
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecd6f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecd6f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dARHh", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $9e584a4ba4de1e17$export$ffb0004e005737fa, (v) => $9e584a4ba4de1e17$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $9e584a4ba4de1e17$export$34b9dba7ce09269b, (v) => $9e584a4ba4de1e17$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $9e584a4ba4de1e17$export$25062201e9e25d76, (v) => $9e584a4ba4de1e17$export$25062201e9e25d76 = v);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9e584a4ba4de1e17$export$ffb0004e005737fa;
var $9e584a4ba4de1e17$export$34b9dba7ce09269b;
var $9e584a4ba4de1e17$export$25062201e9e25d76;
"use strict";
parcelRequire("5imMc");

var $tZqWC = parcelRequire("tZqWC");
var $9e584a4ba4de1e17$var$g = 60103;
$9e584a4ba4de1e17$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $9e584a4ba4de1e17$var$h = Symbol.for;
    $9e584a4ba4de1e17$var$g = $9e584a4ba4de1e17$var$h("react.element");
    $9e584a4ba4de1e17$export$ffb0004e005737fa = $9e584a4ba4de1e17$var$h("react.fragment");
}
var $9e584a4ba4de1e17$var$m = $tZqWC.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $9e584a4ba4de1e17$var$n = Object.prototype.hasOwnProperty, $9e584a4ba4de1e17$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $9e584a4ba4de1e17$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$9e584a4ba4de1e17$var$n.call(a, b) && !$9e584a4ba4de1e17$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $9e584a4ba4de1e17$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $9e584a4ba4de1e17$var$m.current
    };
}
$9e584a4ba4de1e17$export$34b9dba7ce09269b = $9e584a4ba4de1e17$var$q;
$9e584a4ba4de1e17$export$25062201e9e25d76 = $9e584a4ba4de1e17$var$q;

});
parcelRegister("5imMc", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $3db04d20a6aafd46$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3db04d20a6aafd46$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $3db04d20a6aafd46$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $3db04d20a6aafd46$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $3db04d20a6aafd46$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $3db04d20a6aafd46$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $3db04d20a6aafd46$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($3db04d20a6aafd46$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($3db04d20a6aafd46$var$getOwnPropertySymbols) {
            symbols = $3db04d20a6aafd46$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($3db04d20a6aafd46$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("tZqWC", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2D4jB"));

});
parcelRegister("2D4jB", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1ea2922cdc05cc2a$export$ffb0004e005737fa, (v) => $1ea2922cdc05cc2a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $1ea2922cdc05cc2a$export$5f8d39834fd61797, (v) => $1ea2922cdc05cc2a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $1ea2922cdc05cc2a$export$e2c29f18771995cb, (v) => $1ea2922cdc05cc2a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $1ea2922cdc05cc2a$export$74bf444e3cd11ea5, (v) => $1ea2922cdc05cc2a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $1ea2922cdc05cc2a$export$dca3b0875bd9a954, (v) => $1ea2922cdc05cc2a$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1ea2922cdc05cc2a$export$16fa2f45be04daa8, (v) => $1ea2922cdc05cc2a$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $1ea2922cdc05cc2a$export$221d75b3f55bb0bd, (v) => $1ea2922cdc05cc2a$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1ea2922cdc05cc2a$export$ae55be85d98224ed, (v) => $1ea2922cdc05cc2a$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1ea2922cdc05cc2a$export$e530037191fcd5d7, (v) => $1ea2922cdc05cc2a$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1ea2922cdc05cc2a$export$fd42f52fd3ae1109, (v) => $1ea2922cdc05cc2a$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1ea2922cdc05cc2a$export$c8a8987d4410bf2d, (v) => $1ea2922cdc05cc2a$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1ea2922cdc05cc2a$export$d38cd72104c1f0e9, (v) => $1ea2922cdc05cc2a$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1ea2922cdc05cc2a$export$7d1e3a5e95ceca43, (v) => $1ea2922cdc05cc2a$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1ea2922cdc05cc2a$export$257a8862b851cb5b, (v) => $1ea2922cdc05cc2a$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1ea2922cdc05cc2a$export$a8257692ac88316c, (v) => $1ea2922cdc05cc2a$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1ea2922cdc05cc2a$export$488013bae63b21da, (v) => $1ea2922cdc05cc2a$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1ea2922cdc05cc2a$export$7c73462e0d25e514, (v) => $1ea2922cdc05cc2a$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1ea2922cdc05cc2a$export$35808ee640e87ca7, (v) => $1ea2922cdc05cc2a$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1ea2922cdc05cc2a$export$fae74005e78b1a27, (v) => $1ea2922cdc05cc2a$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1ea2922cdc05cc2a$export$dc8fbce3eb94dc1e, (v) => $1ea2922cdc05cc2a$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1ea2922cdc05cc2a$export$6d9c69b0de29b591, (v) => $1ea2922cdc05cc2a$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1ea2922cdc05cc2a$export$d5a552a76deda3c2, (v) => $1ea2922cdc05cc2a$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1ea2922cdc05cc2a$export$e5c5a5f917a5871c, (v) => $1ea2922cdc05cc2a$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1ea2922cdc05cc2a$export$1538c33de8887b59, (v) => $1ea2922cdc05cc2a$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1ea2922cdc05cc2a$export$13e3392192263954, (v) => $1ea2922cdc05cc2a$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1ea2922cdc05cc2a$export$b8f5890fc79d6aca, (v) => $1ea2922cdc05cc2a$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1ea2922cdc05cc2a$export$60241385465d0a34, (v) => $1ea2922cdc05cc2a$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1ea2922cdc05cc2a$export$83d89fbfd8236492, (v) => $1ea2922cdc05cc2a$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1ea2922cdc05cc2a$export$ffb0004e005737fa;
var $1ea2922cdc05cc2a$export$5f8d39834fd61797;
var $1ea2922cdc05cc2a$export$e2c29f18771995cb;
var $1ea2922cdc05cc2a$export$74bf444e3cd11ea5;
var $1ea2922cdc05cc2a$export$dca3b0875bd9a954;
var $1ea2922cdc05cc2a$export$16fa2f45be04daa8;
var $1ea2922cdc05cc2a$export$221d75b3f55bb0bd;
var $1ea2922cdc05cc2a$export$ae55be85d98224ed;
var $1ea2922cdc05cc2a$export$e530037191fcd5d7;
var $1ea2922cdc05cc2a$export$fd42f52fd3ae1109;
var $1ea2922cdc05cc2a$export$c8a8987d4410bf2d;
var $1ea2922cdc05cc2a$export$d38cd72104c1f0e9;
var $1ea2922cdc05cc2a$export$7d1e3a5e95ceca43;
var $1ea2922cdc05cc2a$export$257a8862b851cb5b;
var $1ea2922cdc05cc2a$export$a8257692ac88316c;
var $1ea2922cdc05cc2a$export$488013bae63b21da;
var $1ea2922cdc05cc2a$export$7c73462e0d25e514;
var $1ea2922cdc05cc2a$export$35808ee640e87ca7;
var $1ea2922cdc05cc2a$export$fae74005e78b1a27;
var $1ea2922cdc05cc2a$export$dc8fbce3eb94dc1e;
var $1ea2922cdc05cc2a$export$6d9c69b0de29b591;
var $1ea2922cdc05cc2a$export$d5a552a76deda3c2;
var $1ea2922cdc05cc2a$export$e5c5a5f917a5871c;
var $1ea2922cdc05cc2a$export$1538c33de8887b59;
var $1ea2922cdc05cc2a$export$13e3392192263954;
var $1ea2922cdc05cc2a$export$b8f5890fc79d6aca;
var $1ea2922cdc05cc2a$export$60241385465d0a34;
var $1ea2922cdc05cc2a$export$83d89fbfd8236492;
"use strict";

var $5imMc = parcelRequire("5imMc");
var $1ea2922cdc05cc2a$var$n = 60103, $1ea2922cdc05cc2a$var$p = 60106;
$1ea2922cdc05cc2a$export$ffb0004e005737fa = 60107;
$1ea2922cdc05cc2a$export$5f8d39834fd61797 = 60108;
$1ea2922cdc05cc2a$export$e2c29f18771995cb = 60114;
var $1ea2922cdc05cc2a$var$q = 60109, $1ea2922cdc05cc2a$var$r = 60110, $1ea2922cdc05cc2a$var$t = 60112;
$1ea2922cdc05cc2a$export$74bf444e3cd11ea5 = 60113;
var $1ea2922cdc05cc2a$var$u = 60115, $1ea2922cdc05cc2a$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $1ea2922cdc05cc2a$var$w = Symbol.for;
    $1ea2922cdc05cc2a$var$n = $1ea2922cdc05cc2a$var$w("react.element");
    $1ea2922cdc05cc2a$var$p = $1ea2922cdc05cc2a$var$w("react.portal");
    $1ea2922cdc05cc2a$export$ffb0004e005737fa = $1ea2922cdc05cc2a$var$w("react.fragment");
    $1ea2922cdc05cc2a$export$5f8d39834fd61797 = $1ea2922cdc05cc2a$var$w("react.strict_mode");
    $1ea2922cdc05cc2a$export$e2c29f18771995cb = $1ea2922cdc05cc2a$var$w("react.profiler");
    $1ea2922cdc05cc2a$var$q = $1ea2922cdc05cc2a$var$w("react.provider");
    $1ea2922cdc05cc2a$var$r = $1ea2922cdc05cc2a$var$w("react.context");
    $1ea2922cdc05cc2a$var$t = $1ea2922cdc05cc2a$var$w("react.forward_ref");
    $1ea2922cdc05cc2a$export$74bf444e3cd11ea5 = $1ea2922cdc05cc2a$var$w("react.suspense");
    $1ea2922cdc05cc2a$var$u = $1ea2922cdc05cc2a$var$w("react.memo");
    $1ea2922cdc05cc2a$var$v = $1ea2922cdc05cc2a$var$w("react.lazy");
}
var $1ea2922cdc05cc2a$var$x = "function" === typeof Symbol && Symbol.iterator;
function $1ea2922cdc05cc2a$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1ea2922cdc05cc2a$var$x && a[$1ea2922cdc05cc2a$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $1ea2922cdc05cc2a$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1ea2922cdc05cc2a$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1ea2922cdc05cc2a$var$B = {};
function $1ea2922cdc05cc2a$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1ea2922cdc05cc2a$var$B;
    this.updater = c || $1ea2922cdc05cc2a$var$A;
}
$1ea2922cdc05cc2a$var$C.prototype.isReactComponent = {};
$1ea2922cdc05cc2a$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1ea2922cdc05cc2a$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1ea2922cdc05cc2a$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1ea2922cdc05cc2a$var$D() {}
$1ea2922cdc05cc2a$var$D.prototype = $1ea2922cdc05cc2a$var$C.prototype;
function $1ea2922cdc05cc2a$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1ea2922cdc05cc2a$var$B;
    this.updater = c || $1ea2922cdc05cc2a$var$A;
}
var $1ea2922cdc05cc2a$var$F = $1ea2922cdc05cc2a$var$E.prototype = new $1ea2922cdc05cc2a$var$D;
$1ea2922cdc05cc2a$var$F.constructor = $1ea2922cdc05cc2a$var$E;
$5imMc($1ea2922cdc05cc2a$var$F, $1ea2922cdc05cc2a$var$C.prototype);
$1ea2922cdc05cc2a$var$F.isPureReactComponent = !0;
var $1ea2922cdc05cc2a$var$G = {
    current: null
}, $1ea2922cdc05cc2a$var$H = Object.prototype.hasOwnProperty, $1ea2922cdc05cc2a$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1ea2922cdc05cc2a$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1ea2922cdc05cc2a$var$H.call(b, e) && !$1ea2922cdc05cc2a$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $1ea2922cdc05cc2a$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $1ea2922cdc05cc2a$var$G.current
    };
}
function $1ea2922cdc05cc2a$var$K(a, b) {
    return {
        $$typeof: $1ea2922cdc05cc2a$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1ea2922cdc05cc2a$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1ea2922cdc05cc2a$var$n;
}
function $1ea2922cdc05cc2a$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1ea2922cdc05cc2a$var$M = /\/+/g;
function $1ea2922cdc05cc2a$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1ea2922cdc05cc2a$var$escape("" + a.key) : b.toString(36);
}
function $1ea2922cdc05cc2a$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1ea2922cdc05cc2a$var$n:
                case $1ea2922cdc05cc2a$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $1ea2922cdc05cc2a$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($1ea2922cdc05cc2a$var$M, "$&/") + "/"), $1ea2922cdc05cc2a$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($1ea2922cdc05cc2a$var$L(d) && (d = $1ea2922cdc05cc2a$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($1ea2922cdc05cc2a$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $1ea2922cdc05cc2a$var$N(k, g);
        h += $1ea2922cdc05cc2a$var$O(k, b, c, f, d);
    }
    else if (f = $1ea2922cdc05cc2a$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $1ea2922cdc05cc2a$var$N(k, g++), h += $1ea2922cdc05cc2a$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($1ea2922cdc05cc2a$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $1ea2922cdc05cc2a$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $1ea2922cdc05cc2a$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $1ea2922cdc05cc2a$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $1ea2922cdc05cc2a$var$R = {
    current: null
};
function $1ea2922cdc05cc2a$var$S() {
    var a = $1ea2922cdc05cc2a$var$R.current;
    if (null === a) throw Error($1ea2922cdc05cc2a$var$z(321));
    return a;
}
var $1ea2922cdc05cc2a$var$T = {
    ReactCurrentDispatcher: $1ea2922cdc05cc2a$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $1ea2922cdc05cc2a$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $5imMc
};
$1ea2922cdc05cc2a$export$dca3b0875bd9a954 = {
    map: $1ea2922cdc05cc2a$var$P,
    forEach: function(a, b, c) {
        $1ea2922cdc05cc2a$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $1ea2922cdc05cc2a$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1ea2922cdc05cc2a$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1ea2922cdc05cc2a$var$L(a)) throw Error($1ea2922cdc05cc2a$var$z(143));
        return a;
    }
};
$1ea2922cdc05cc2a$export$16fa2f45be04daa8 = $1ea2922cdc05cc2a$var$C;
$1ea2922cdc05cc2a$export$221d75b3f55bb0bd = $1ea2922cdc05cc2a$var$E;
$1ea2922cdc05cc2a$export$ae55be85d98224ed = $1ea2922cdc05cc2a$var$T;
$1ea2922cdc05cc2a$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1ea2922cdc05cc2a$var$z(267, a));
    var e = $5imMc({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1ea2922cdc05cc2a$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1ea2922cdc05cc2a$var$H.call(b, f) && !$1ea2922cdc05cc2a$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $1ea2922cdc05cc2a$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$1ea2922cdc05cc2a$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1ea2922cdc05cc2a$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1ea2922cdc05cc2a$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$1ea2922cdc05cc2a$export$c8a8987d4410bf2d = $1ea2922cdc05cc2a$var$J;
$1ea2922cdc05cc2a$export$d38cd72104c1f0e9 = function(a) {
    var b = $1ea2922cdc05cc2a$var$J.bind(null, a);
    b.type = a;
    return b;
};
$1ea2922cdc05cc2a$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1ea2922cdc05cc2a$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1ea2922cdc05cc2a$var$t,
        render: a
    };
};
$1ea2922cdc05cc2a$export$a8257692ac88316c = $1ea2922cdc05cc2a$var$L;
$1ea2922cdc05cc2a$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1ea2922cdc05cc2a$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1ea2922cdc05cc2a$var$Q
    };
};
$1ea2922cdc05cc2a$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1ea2922cdc05cc2a$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1ea2922cdc05cc2a$export$35808ee640e87ca7 = function(a, b) {
    return $1ea2922cdc05cc2a$var$S().useCallback(a, b);
};
$1ea2922cdc05cc2a$export$fae74005e78b1a27 = function(a, b) {
    return $1ea2922cdc05cc2a$var$S().useContext(a, b);
};
$1ea2922cdc05cc2a$export$dc8fbce3eb94dc1e = function() {};
$1ea2922cdc05cc2a$export$6d9c69b0de29b591 = function(a, b) {
    return $1ea2922cdc05cc2a$var$S().useEffect(a, b);
};
$1ea2922cdc05cc2a$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1ea2922cdc05cc2a$var$S().useImperativeHandle(a, b, c);
};
$1ea2922cdc05cc2a$export$e5c5a5f917a5871c = function(a, b) {
    return $1ea2922cdc05cc2a$var$S().useLayoutEffect(a, b);
};
$1ea2922cdc05cc2a$export$1538c33de8887b59 = function(a, b) {
    return $1ea2922cdc05cc2a$var$S().useMemo(a, b);
};
$1ea2922cdc05cc2a$export$13e3392192263954 = function(a, b, c) {
    return $1ea2922cdc05cc2a$var$S().useReducer(a, b, c);
};
$1ea2922cdc05cc2a$export$b8f5890fc79d6aca = function(a) {
    return $1ea2922cdc05cc2a$var$S().useRef(a);
};
$1ea2922cdc05cc2a$export$60241385465d0a34 = function(a) {
    return $1ea2922cdc05cc2a$var$S().useState(a);
};
$1ea2922cdc05cc2a$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("bIn0m", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $tZqWC = parcelRequire("tZqWC");

var $5imMc = parcelRequire("5imMc");

var $7bPco = parcelRequire("7bPco");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$tZqWC) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $tZqWC.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $5imMc({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $tZqWC.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $5imMc({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $5imMc({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $5imMc({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $7bPco.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $7bPco.unstable_scheduleCallback($7bPco.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $7bPco.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $7bPco.unstable_UserBlockingPriority, ed = $7bPco.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $5imMc(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $5imMc({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $5imMc({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $5imMc({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $5imMc({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $5imMc({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $5imMc({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $5imMc({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $5imMc({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $5imMc({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $5imMc({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $5imMc({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $5imMc({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $5imMc({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $7bPco.unstable_runWithPriority, Of = $7bPco.unstable_scheduleCallback, Pf = $7bPco.unstable_cancelCallback, Qf = $7bPco.unstable_shouldYield, Rf = $7bPco.unstable_requestPaint, Sf = $7bPco.unstable_now, Tf = $7bPco.unstable_getCurrentPriorityLevel, Uf = $7bPco.unstable_ImmediatePriority, Vf = $7bPco.unstable_UserBlockingPriority, Wf = $7bPco.unstable_NormalPriority, Xf = $7bPco.unstable_LowPriority, Yf = $7bPco.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $5imMc({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $5imMc({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $tZqWC.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $5imMc({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $5imMc({}, e, {
                    value: void 0
                });
                d = $5imMc({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $5imMc({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("7bPco", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bh2AD"));

});
parcelRegister("bh2AD", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $83534a8c3330e8bf$export$c4744153514ff05d, (v) => $83534a8c3330e8bf$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $83534a8c3330e8bf$export$b5836b71941fa3ed, (v) => $83534a8c3330e8bf$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $83534a8c3330e8bf$export$d66a1c1c77bd778b, (v) => $83534a8c3330e8bf$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $83534a8c3330e8bf$export$3e506c1ccc9cc1a7, (v) => $83534a8c3330e8bf$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $83534a8c3330e8bf$export$e26fe2ed2fa76875, (v) => $83534a8c3330e8bf$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $83534a8c3330e8bf$export$502329bbf4b505b1, (v) => $83534a8c3330e8bf$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $83534a8c3330e8bf$export$6e3807111c4874c4, (v) => $83534a8c3330e8bf$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $83534a8c3330e8bf$export$c27134553091fb3a, (v) => $83534a8c3330e8bf$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $83534a8c3330e8bf$export$33ee1acdc04fd2a2, (v) => $83534a8c3330e8bf$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $83534a8c3330e8bf$export$b00a404bbd5edef2, (v) => $83534a8c3330e8bf$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $83534a8c3330e8bf$export$8352ce38b91d0c62, (v) => $83534a8c3330e8bf$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $83534a8c3330e8bf$export$d3dfb8e4810cb555, (v) => $83534a8c3330e8bf$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $83534a8c3330e8bf$export$839f9183b0465a69, (v) => $83534a8c3330e8bf$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $83534a8c3330e8bf$export$72fdf0e06517287b, (v) => $83534a8c3330e8bf$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $83534a8c3330e8bf$export$4b844e58a3e414b4, (v) => $83534a8c3330e8bf$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $83534a8c3330e8bf$export$816d2913ae6b83b1, (v) => $83534a8c3330e8bf$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $83534a8c3330e8bf$export$61bcfe829111a1d0, (v) => $83534a8c3330e8bf$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $83534a8c3330e8bf$export$7ee8c9beb337bc3f, (v) => $83534a8c3330e8bf$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $83534a8c3330e8bf$export$cf845f2c119da08a, (v) => $83534a8c3330e8bf$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $83534a8c3330e8bf$export$c4744153514ff05d;
var $83534a8c3330e8bf$export$b5836b71941fa3ed;
var $83534a8c3330e8bf$export$d66a1c1c77bd778b;
var $83534a8c3330e8bf$export$3e506c1ccc9cc1a7;
var $83534a8c3330e8bf$export$e26fe2ed2fa76875;
var $83534a8c3330e8bf$export$502329bbf4b505b1;
var $83534a8c3330e8bf$export$6e3807111c4874c4;
var $83534a8c3330e8bf$export$c27134553091fb3a;
var $83534a8c3330e8bf$export$33ee1acdc04fd2a2;
var $83534a8c3330e8bf$export$b00a404bbd5edef2;
var $83534a8c3330e8bf$export$8352ce38b91d0c62;
var $83534a8c3330e8bf$export$d3dfb8e4810cb555;
var $83534a8c3330e8bf$export$839f9183b0465a69;
var $83534a8c3330e8bf$export$72fdf0e06517287b;
var $83534a8c3330e8bf$export$4b844e58a3e414b4;
var $83534a8c3330e8bf$export$816d2913ae6b83b1;
var $83534a8c3330e8bf$export$61bcfe829111a1d0;
var $83534a8c3330e8bf$export$7ee8c9beb337bc3f;
var $83534a8c3330e8bf$export$cf845f2c119da08a;
"use strict";
var $83534a8c3330e8bf$var$f, $83534a8c3330e8bf$var$g, $83534a8c3330e8bf$var$h, $83534a8c3330e8bf$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $83534a8c3330e8bf$var$l = performance;
    $83534a8c3330e8bf$export$c4744153514ff05d = function() {
        return $83534a8c3330e8bf$var$l.now();
    };
} else {
    var $83534a8c3330e8bf$var$p = Date, $83534a8c3330e8bf$var$q = $83534a8c3330e8bf$var$p.now();
    $83534a8c3330e8bf$export$c4744153514ff05d = function() {
        return $83534a8c3330e8bf$var$p.now() - $83534a8c3330e8bf$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $83534a8c3330e8bf$var$t = null, $83534a8c3330e8bf$var$u = null, $83534a8c3330e8bf$var$w = function() {
        if (null !== $83534a8c3330e8bf$var$t) try {
            var a = $83534a8c3330e8bf$export$c4744153514ff05d();
            $83534a8c3330e8bf$var$t(!0, a);
            $83534a8c3330e8bf$var$t = null;
        } catch (b) {
            throw setTimeout($83534a8c3330e8bf$var$w, 0), b;
        }
    };
    $83534a8c3330e8bf$var$f = function(a) {
        null !== $83534a8c3330e8bf$var$t ? setTimeout($83534a8c3330e8bf$var$f, 0, a) : ($83534a8c3330e8bf$var$t = a, setTimeout($83534a8c3330e8bf$var$w, 0));
    };
    $83534a8c3330e8bf$var$g = function(a, b) {
        $83534a8c3330e8bf$var$u = setTimeout(a, b);
    };
    $83534a8c3330e8bf$var$h = function() {
        clearTimeout($83534a8c3330e8bf$var$u);
    };
    $83534a8c3330e8bf$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $83534a8c3330e8bf$var$k = $83534a8c3330e8bf$export$d66a1c1c77bd778b = function() {};
} else {
    var $83534a8c3330e8bf$var$x = window.setTimeout, $83534a8c3330e8bf$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $83534a8c3330e8bf$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $83534a8c3330e8bf$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $83534a8c3330e8bf$var$A = !1, $83534a8c3330e8bf$var$B = null, $83534a8c3330e8bf$var$C = -1, $83534a8c3330e8bf$var$D = 5, $83534a8c3330e8bf$var$E = 0;
    $83534a8c3330e8bf$export$b5836b71941fa3ed = function() {
        return $83534a8c3330e8bf$export$c4744153514ff05d() >= $83534a8c3330e8bf$var$E;
    };
    $83534a8c3330e8bf$var$k = function() {};
    $83534a8c3330e8bf$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $83534a8c3330e8bf$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $83534a8c3330e8bf$var$F = new MessageChannel, $83534a8c3330e8bf$var$G = $83534a8c3330e8bf$var$F.port2;
    $83534a8c3330e8bf$var$F.port1.onmessage = function() {
        if (null !== $83534a8c3330e8bf$var$B) {
            var a = $83534a8c3330e8bf$export$c4744153514ff05d();
            $83534a8c3330e8bf$var$E = a + $83534a8c3330e8bf$var$D;
            try {
                $83534a8c3330e8bf$var$B(!0, a) ? $83534a8c3330e8bf$var$G.postMessage(null) : ($83534a8c3330e8bf$var$A = !1, $83534a8c3330e8bf$var$B = null);
            } catch (b) {
                throw $83534a8c3330e8bf$var$G.postMessage(null), b;
            }
        } else $83534a8c3330e8bf$var$A = !1;
    };
    $83534a8c3330e8bf$var$f = function(a) {
        $83534a8c3330e8bf$var$B = a;
        $83534a8c3330e8bf$var$A || ($83534a8c3330e8bf$var$A = !0, $83534a8c3330e8bf$var$G.postMessage(null));
    };
    $83534a8c3330e8bf$var$g = function(a, b) {
        $83534a8c3330e8bf$var$C = $83534a8c3330e8bf$var$x(function() {
            a($83534a8c3330e8bf$export$c4744153514ff05d());
        }, b);
    };
    $83534a8c3330e8bf$var$h = function() {
        $83534a8c3330e8bf$var$y($83534a8c3330e8bf$var$C);
        $83534a8c3330e8bf$var$C = -1;
    };
}
function $83534a8c3330e8bf$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $83534a8c3330e8bf$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $83534a8c3330e8bf$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $83534a8c3330e8bf$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $83534a8c3330e8bf$var$I(n, c)) void 0 !== r && 0 > $83534a8c3330e8bf$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $83534a8c3330e8bf$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $83534a8c3330e8bf$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $83534a8c3330e8bf$var$L = [], $83534a8c3330e8bf$var$M = [], $83534a8c3330e8bf$var$N = 1, $83534a8c3330e8bf$var$O = null, $83534a8c3330e8bf$var$P = 3, $83534a8c3330e8bf$var$Q = !1, $83534a8c3330e8bf$var$R = !1, $83534a8c3330e8bf$var$S = !1;
function $83534a8c3330e8bf$var$T(a) {
    for(var b = $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$M); null !== b;){
        if (null === b.callback) $83534a8c3330e8bf$var$K($83534a8c3330e8bf$var$M);
        else if (b.startTime <= a) $83534a8c3330e8bf$var$K($83534a8c3330e8bf$var$M), b.sortIndex = b.expirationTime, $83534a8c3330e8bf$var$H($83534a8c3330e8bf$var$L, b);
        else break;
        b = $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$M);
    }
}
function $83534a8c3330e8bf$var$U(a) {
    $83534a8c3330e8bf$var$S = !1;
    $83534a8c3330e8bf$var$T(a);
    if (!$83534a8c3330e8bf$var$R) {
        if (null !== $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$L)) $83534a8c3330e8bf$var$R = !0, $83534a8c3330e8bf$var$f($83534a8c3330e8bf$var$V);
        else {
            var b = $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$M);
            null !== b && $83534a8c3330e8bf$var$g($83534a8c3330e8bf$var$U, b.startTime - a);
        }
    }
}
function $83534a8c3330e8bf$var$V(a, b) {
    $83534a8c3330e8bf$var$R = !1;
    $83534a8c3330e8bf$var$S && ($83534a8c3330e8bf$var$S = !1, $83534a8c3330e8bf$var$h());
    $83534a8c3330e8bf$var$Q = !0;
    var c = $83534a8c3330e8bf$var$P;
    try {
        $83534a8c3330e8bf$var$T(b);
        for($83534a8c3330e8bf$var$O = $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$L); null !== $83534a8c3330e8bf$var$O && (!($83534a8c3330e8bf$var$O.expirationTime > b) || a && !$83534a8c3330e8bf$export$b5836b71941fa3ed());){
            var d = $83534a8c3330e8bf$var$O.callback;
            if ("function" === typeof d) {
                $83534a8c3330e8bf$var$O.callback = null;
                $83534a8c3330e8bf$var$P = $83534a8c3330e8bf$var$O.priorityLevel;
                var e = d($83534a8c3330e8bf$var$O.expirationTime <= b);
                b = $83534a8c3330e8bf$export$c4744153514ff05d();
                "function" === typeof e ? $83534a8c3330e8bf$var$O.callback = e : $83534a8c3330e8bf$var$O === $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$L) && $83534a8c3330e8bf$var$K($83534a8c3330e8bf$var$L);
                $83534a8c3330e8bf$var$T(b);
            } else $83534a8c3330e8bf$var$K($83534a8c3330e8bf$var$L);
            $83534a8c3330e8bf$var$O = $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$L);
        }
        if (null !== $83534a8c3330e8bf$var$O) var m = !0;
        else {
            var n = $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$M);
            null !== n && $83534a8c3330e8bf$var$g($83534a8c3330e8bf$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $83534a8c3330e8bf$var$O = null, $83534a8c3330e8bf$var$P = c, $83534a8c3330e8bf$var$Q = !1;
    }
}
var $83534a8c3330e8bf$var$W = $83534a8c3330e8bf$var$k;
$83534a8c3330e8bf$export$3e506c1ccc9cc1a7 = 5;
$83534a8c3330e8bf$export$e26fe2ed2fa76875 = 1;
$83534a8c3330e8bf$export$502329bbf4b505b1 = 4;
$83534a8c3330e8bf$export$6e3807111c4874c4 = 3;
$83534a8c3330e8bf$export$c27134553091fb3a = null;
$83534a8c3330e8bf$export$33ee1acdc04fd2a2 = 2;
$83534a8c3330e8bf$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$83534a8c3330e8bf$export$8352ce38b91d0c62 = function() {
    $83534a8c3330e8bf$var$R || $83534a8c3330e8bf$var$Q || ($83534a8c3330e8bf$var$R = !0, $83534a8c3330e8bf$var$f($83534a8c3330e8bf$var$V));
};
$83534a8c3330e8bf$export$d3dfb8e4810cb555 = function() {
    return $83534a8c3330e8bf$var$P;
};
$83534a8c3330e8bf$export$839f9183b0465a69 = function() {
    return $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$L);
};
$83534a8c3330e8bf$export$72fdf0e06517287b = function(a) {
    switch($83534a8c3330e8bf$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $83534a8c3330e8bf$var$P;
    }
    var c = $83534a8c3330e8bf$var$P;
    $83534a8c3330e8bf$var$P = b;
    try {
        return a();
    } finally{
        $83534a8c3330e8bf$var$P = c;
    }
};
$83534a8c3330e8bf$export$4b844e58a3e414b4 = function() {};
$83534a8c3330e8bf$export$816d2913ae6b83b1 = $83534a8c3330e8bf$var$W;
$83534a8c3330e8bf$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $83534a8c3330e8bf$var$P;
    $83534a8c3330e8bf$var$P = a;
    try {
        return b();
    } finally{
        $83534a8c3330e8bf$var$P = c;
    }
};
$83534a8c3330e8bf$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $83534a8c3330e8bf$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $83534a8c3330e8bf$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $83534a8c3330e8bf$var$H($83534a8c3330e8bf$var$M, a), null === $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$L) && a === $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$M) && ($83534a8c3330e8bf$var$S ? $83534a8c3330e8bf$var$h() : $83534a8c3330e8bf$var$S = !0, $83534a8c3330e8bf$var$g($83534a8c3330e8bf$var$U, c - d))) : (a.sortIndex = e, $83534a8c3330e8bf$var$H($83534a8c3330e8bf$var$L, a), $83534a8c3330e8bf$var$R || $83534a8c3330e8bf$var$Q || ($83534a8c3330e8bf$var$R = !0, $83534a8c3330e8bf$var$f($83534a8c3330e8bf$var$V)));
    return a;
};
$83534a8c3330e8bf$export$cf845f2c119da08a = function(a) {
    var b = $83534a8c3330e8bf$var$P;
    return function() {
        var c = $83534a8c3330e8bf$var$P;
        $83534a8c3330e8bf$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $83534a8c3330e8bf$var$P = c;
        }
    };
};

});



parcelRegister("4L3zM", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $376e535b1f013c40$var$ReactIs, $376e535b1f013c40$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("eEtjc"))();

});
parcelRegister("eEtjc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $hVVq1 = parcelRequire("hVVq1");
function $aaab893b1a76f303$var$emptyFunction() {}
function $aaab893b1a76f303$var$emptyFunctionWithReset() {}
$aaab893b1a76f303$var$emptyFunctionWithReset.resetWarningCache = $aaab893b1a76f303$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $hVVq1) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $aaab893b1a76f303$var$emptyFunctionWithReset,
        resetWarningCache: $aaab893b1a76f303$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("hVVq1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $d0e44caf0df1935f$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $d0e44caf0df1935f$var$ReactPropTypesSecret;

});



parcelRegister("lt0gQ", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $fa0c842a3e4de27a$export$2b8d127b894957b9, (v) => $fa0c842a3e4de27a$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $fa0c842a3e4de27a$export$cea3a54a6425200c, (v) => $fa0c842a3e4de27a$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $fa0c842a3e4de27a$export$a7c73072b1a182ae, (v) => $fa0c842a3e4de27a$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $fa0c842a3e4de27a$export$9f27bc3417b4524d, (v) => $fa0c842a3e4de27a$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $fa0c842a3e4de27a$export$db77ccec0bb4ccac, (v) => $fa0c842a3e4de27a$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $fa0c842a3e4de27a$export$8392c0c9d3dcbd35, (v) => $fa0c842a3e4de27a$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $fa0c842a3e4de27a$export$ffb0004e005737fa, (v) => $fa0c842a3e4de27a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $fa0c842a3e4de27a$export$b624eff549462981, (v) => $fa0c842a3e4de27a$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $fa0c842a3e4de27a$export$7897aa7841a5380c, (v) => $fa0c842a3e4de27a$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $fa0c842a3e4de27a$export$602eac185826482c, (v) => $fa0c842a3e4de27a$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $fa0c842a3e4de27a$export$e2c29f18771995cb, (v) => $fa0c842a3e4de27a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $fa0c842a3e4de27a$export$5f8d39834fd61797, (v) => $fa0c842a3e4de27a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $fa0c842a3e4de27a$export$74bf444e3cd11ea5, (v) => $fa0c842a3e4de27a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $fa0c842a3e4de27a$export$92387174baf9b227, (v) => $fa0c842a3e4de27a$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $fa0c842a3e4de27a$export$ec112efeb987d9c6, (v) => $fa0c842a3e4de27a$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $fa0c842a3e4de27a$export$b706b080d889d2c9, (v) => $fa0c842a3e4de27a$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $fa0c842a3e4de27a$export$5be5a87408f70ddc, (v) => $fa0c842a3e4de27a$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $fa0c842a3e4de27a$export$45a5e7f76e0caa8d, (v) => $fa0c842a3e4de27a$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $fa0c842a3e4de27a$export$455c2e768291efa6, (v) => $fa0c842a3e4de27a$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $fa0c842a3e4de27a$export$9522e17588c12572, (v) => $fa0c842a3e4de27a$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $fa0c842a3e4de27a$export$2110ac352bb060b9, (v) => $fa0c842a3e4de27a$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $fa0c842a3e4de27a$export$56885ab8b9c456ab, (v) => $fa0c842a3e4de27a$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $fa0c842a3e4de27a$export$d927fcb6adf8f9de, (v) => $fa0c842a3e4de27a$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $fa0c842a3e4de27a$export$b82d16f27459e05a, (v) => $fa0c842a3e4de27a$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $fa0c842a3e4de27a$export$522c17b4f5e123e8, (v) => $fa0c842a3e4de27a$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $fa0c842a3e4de27a$export$1aabd8a0274ecfd6, (v) => $fa0c842a3e4de27a$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $fa0c842a3e4de27a$export$9b621391a187a31a, (v) => $fa0c842a3e4de27a$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $fa0c842a3e4de27a$export$f5bbd400c2f4426f, (v) => $fa0c842a3e4de27a$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fa0c842a3e4de27a$export$2b8d127b894957b9;
var $fa0c842a3e4de27a$export$cea3a54a6425200c;
var $fa0c842a3e4de27a$export$a7c73072b1a182ae;
var $fa0c842a3e4de27a$export$9f27bc3417b4524d;
var $fa0c842a3e4de27a$export$db77ccec0bb4ccac;
var $fa0c842a3e4de27a$export$8392c0c9d3dcbd35;
var $fa0c842a3e4de27a$export$ffb0004e005737fa;
var $fa0c842a3e4de27a$export$b624eff549462981;
var $fa0c842a3e4de27a$export$7897aa7841a5380c;
var $fa0c842a3e4de27a$export$602eac185826482c;
var $fa0c842a3e4de27a$export$e2c29f18771995cb;
var $fa0c842a3e4de27a$export$5f8d39834fd61797;
var $fa0c842a3e4de27a$export$74bf444e3cd11ea5;
var $fa0c842a3e4de27a$export$92387174baf9b227;
var $fa0c842a3e4de27a$export$ec112efeb987d9c6;
var $fa0c842a3e4de27a$export$b706b080d889d2c9;
var $fa0c842a3e4de27a$export$5be5a87408f70ddc;
var $fa0c842a3e4de27a$export$45a5e7f76e0caa8d;
var $fa0c842a3e4de27a$export$455c2e768291efa6;
var $fa0c842a3e4de27a$export$9522e17588c12572;
var $fa0c842a3e4de27a$export$2110ac352bb060b9;
var $fa0c842a3e4de27a$export$56885ab8b9c456ab;
var $fa0c842a3e4de27a$export$d927fcb6adf8f9de;
var $fa0c842a3e4de27a$export$b82d16f27459e05a;
var $fa0c842a3e4de27a$export$522c17b4f5e123e8;
var $fa0c842a3e4de27a$export$1aabd8a0274ecfd6;
var $fa0c842a3e4de27a$export$9b621391a187a31a;
var $fa0c842a3e4de27a$export$f5bbd400c2f4426f;
"use strict";
var $fa0c842a3e4de27a$var$b = "function" === typeof Symbol && Symbol.for, $fa0c842a3e4de27a$var$c = $fa0c842a3e4de27a$var$b ? Symbol.for("react.element") : 60103, $fa0c842a3e4de27a$var$d = $fa0c842a3e4de27a$var$b ? Symbol.for("react.portal") : 60106, $fa0c842a3e4de27a$var$e = $fa0c842a3e4de27a$var$b ? Symbol.for("react.fragment") : 60107, $fa0c842a3e4de27a$var$f = $fa0c842a3e4de27a$var$b ? Symbol.for("react.strict_mode") : 60108, $fa0c842a3e4de27a$var$g = $fa0c842a3e4de27a$var$b ? Symbol.for("react.profiler") : 60114, $fa0c842a3e4de27a$var$h = $fa0c842a3e4de27a$var$b ? Symbol.for("react.provider") : 60109, $fa0c842a3e4de27a$var$k = $fa0c842a3e4de27a$var$b ? Symbol.for("react.context") : 60110, $fa0c842a3e4de27a$var$l = $fa0c842a3e4de27a$var$b ? Symbol.for("react.async_mode") : 60111, $fa0c842a3e4de27a$var$m = $fa0c842a3e4de27a$var$b ? Symbol.for("react.concurrent_mode") : 60111, $fa0c842a3e4de27a$var$n = $fa0c842a3e4de27a$var$b ? Symbol.for("react.forward_ref") : 60112, $fa0c842a3e4de27a$var$p = $fa0c842a3e4de27a$var$b ? Symbol.for("react.suspense") : 60113, $fa0c842a3e4de27a$var$q = $fa0c842a3e4de27a$var$b ? Symbol.for("react.suspense_list") : 60120, $fa0c842a3e4de27a$var$r = $fa0c842a3e4de27a$var$b ? Symbol.for("react.memo") : 60115, $fa0c842a3e4de27a$var$t = $fa0c842a3e4de27a$var$b ? Symbol.for("react.lazy") : 60116, $fa0c842a3e4de27a$var$v = $fa0c842a3e4de27a$var$b ? Symbol.for("react.block") : 60121, $fa0c842a3e4de27a$var$w = $fa0c842a3e4de27a$var$b ? Symbol.for("react.fundamental") : 60117, $fa0c842a3e4de27a$var$x = $fa0c842a3e4de27a$var$b ? Symbol.for("react.responder") : 60118, $fa0c842a3e4de27a$var$y = $fa0c842a3e4de27a$var$b ? Symbol.for("react.scope") : 60119;
function $fa0c842a3e4de27a$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $fa0c842a3e4de27a$var$c:
                switch(a = a.type, a){
                    case $fa0c842a3e4de27a$var$l:
                    case $fa0c842a3e4de27a$var$m:
                    case $fa0c842a3e4de27a$var$e:
                    case $fa0c842a3e4de27a$var$g:
                    case $fa0c842a3e4de27a$var$f:
                    case $fa0c842a3e4de27a$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $fa0c842a3e4de27a$var$k:
                            case $fa0c842a3e4de27a$var$n:
                            case $fa0c842a3e4de27a$var$t:
                            case $fa0c842a3e4de27a$var$r:
                            case $fa0c842a3e4de27a$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $fa0c842a3e4de27a$var$d:
                return u;
        }
    }
}
function $fa0c842a3e4de27a$var$A(a) {
    return $fa0c842a3e4de27a$var$z(a) === $fa0c842a3e4de27a$var$m;
}
$fa0c842a3e4de27a$export$2b8d127b894957b9 = $fa0c842a3e4de27a$var$l;
$fa0c842a3e4de27a$export$cea3a54a6425200c = $fa0c842a3e4de27a$var$m;
$fa0c842a3e4de27a$export$a7c73072b1a182ae = $fa0c842a3e4de27a$var$k;
$fa0c842a3e4de27a$export$9f27bc3417b4524d = $fa0c842a3e4de27a$var$h;
$fa0c842a3e4de27a$export$db77ccec0bb4ccac = $fa0c842a3e4de27a$var$c;
$fa0c842a3e4de27a$export$8392c0c9d3dcbd35 = $fa0c842a3e4de27a$var$n;
$fa0c842a3e4de27a$export$ffb0004e005737fa = $fa0c842a3e4de27a$var$e;
$fa0c842a3e4de27a$export$b624eff549462981 = $fa0c842a3e4de27a$var$t;
$fa0c842a3e4de27a$export$7897aa7841a5380c = $fa0c842a3e4de27a$var$r;
$fa0c842a3e4de27a$export$602eac185826482c = $fa0c842a3e4de27a$var$d;
$fa0c842a3e4de27a$export$e2c29f18771995cb = $fa0c842a3e4de27a$var$g;
$fa0c842a3e4de27a$export$5f8d39834fd61797 = $fa0c842a3e4de27a$var$f;
$fa0c842a3e4de27a$export$74bf444e3cd11ea5 = $fa0c842a3e4de27a$var$p;
$fa0c842a3e4de27a$export$92387174baf9b227 = function(a) {
    return $fa0c842a3e4de27a$var$A(a) || $fa0c842a3e4de27a$var$z(a) === $fa0c842a3e4de27a$var$l;
};
$fa0c842a3e4de27a$export$ec112efeb987d9c6 = $fa0c842a3e4de27a$var$A;
$fa0c842a3e4de27a$export$b706b080d889d2c9 = function(a) {
    return $fa0c842a3e4de27a$var$z(a) === $fa0c842a3e4de27a$var$k;
};
$fa0c842a3e4de27a$export$5be5a87408f70ddc = function(a) {
    return $fa0c842a3e4de27a$var$z(a) === $fa0c842a3e4de27a$var$h;
};
$fa0c842a3e4de27a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $fa0c842a3e4de27a$var$c;
};
$fa0c842a3e4de27a$export$455c2e768291efa6 = function(a) {
    return $fa0c842a3e4de27a$var$z(a) === $fa0c842a3e4de27a$var$n;
};
$fa0c842a3e4de27a$export$9522e17588c12572 = function(a) {
    return $fa0c842a3e4de27a$var$z(a) === $fa0c842a3e4de27a$var$e;
};
$fa0c842a3e4de27a$export$2110ac352bb060b9 = function(a) {
    return $fa0c842a3e4de27a$var$z(a) === $fa0c842a3e4de27a$var$t;
};
$fa0c842a3e4de27a$export$56885ab8b9c456ab = function(a) {
    return $fa0c842a3e4de27a$var$z(a) === $fa0c842a3e4de27a$var$r;
};
$fa0c842a3e4de27a$export$d927fcb6adf8f9de = function(a) {
    return $fa0c842a3e4de27a$var$z(a) === $fa0c842a3e4de27a$var$d;
};
$fa0c842a3e4de27a$export$b82d16f27459e05a = function(a) {
    return $fa0c842a3e4de27a$var$z(a) === $fa0c842a3e4de27a$var$g;
};
$fa0c842a3e4de27a$export$522c17b4f5e123e8 = function(a) {
    return $fa0c842a3e4de27a$var$z(a) === $fa0c842a3e4de27a$var$f;
};
$fa0c842a3e4de27a$export$1aabd8a0274ecfd6 = function(a) {
    return $fa0c842a3e4de27a$var$z(a) === $fa0c842a3e4de27a$var$p;
};
$fa0c842a3e4de27a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $fa0c842a3e4de27a$var$e || a === $fa0c842a3e4de27a$var$m || a === $fa0c842a3e4de27a$var$g || a === $fa0c842a3e4de27a$var$f || a === $fa0c842a3e4de27a$var$p || a === $fa0c842a3e4de27a$var$q || "object" === typeof a && null !== a && (a.$$typeof === $fa0c842a3e4de27a$var$t || a.$$typeof === $fa0c842a3e4de27a$var$r || a.$$typeof === $fa0c842a3e4de27a$var$h || a.$$typeof === $fa0c842a3e4de27a$var$k || a.$$typeof === $fa0c842a3e4de27a$var$n || a.$$typeof === $fa0c842a3e4de27a$var$w || a.$$typeof === $fa0c842a3e4de27a$var$x || a.$$typeof === $fa0c842a3e4de27a$var$y || a.$$typeof === $fa0c842a3e4de27a$var$v);
};
$fa0c842a3e4de27a$export$f5bbd400c2f4426f = $fa0c842a3e4de27a$var$z;

});

parcelRegister("bR9Ya", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $8a1c60aeca462d1f$export$a7c73072b1a182ae, (v) => $8a1c60aeca462d1f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $8a1c60aeca462d1f$export$9f27bc3417b4524d, (v) => $8a1c60aeca462d1f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $8a1c60aeca462d1f$export$db77ccec0bb4ccac, (v) => $8a1c60aeca462d1f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $8a1c60aeca462d1f$export$8392c0c9d3dcbd35, (v) => $8a1c60aeca462d1f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $8a1c60aeca462d1f$export$ffb0004e005737fa, (v) => $8a1c60aeca462d1f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $8a1c60aeca462d1f$export$b624eff549462981, (v) => $8a1c60aeca462d1f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $8a1c60aeca462d1f$export$7897aa7841a5380c, (v) => $8a1c60aeca462d1f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $8a1c60aeca462d1f$export$602eac185826482c, (v) => $8a1c60aeca462d1f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $8a1c60aeca462d1f$export$e2c29f18771995cb, (v) => $8a1c60aeca462d1f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $8a1c60aeca462d1f$export$5f8d39834fd61797, (v) => $8a1c60aeca462d1f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8a1c60aeca462d1f$export$74bf444e3cd11ea5, (v) => $8a1c60aeca462d1f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $8a1c60aeca462d1f$export$92387174baf9b227, (v) => $8a1c60aeca462d1f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $8a1c60aeca462d1f$export$ec112efeb987d9c6, (v) => $8a1c60aeca462d1f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $8a1c60aeca462d1f$export$b706b080d889d2c9, (v) => $8a1c60aeca462d1f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $8a1c60aeca462d1f$export$5be5a87408f70ddc, (v) => $8a1c60aeca462d1f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $8a1c60aeca462d1f$export$45a5e7f76e0caa8d, (v) => $8a1c60aeca462d1f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $8a1c60aeca462d1f$export$455c2e768291efa6, (v) => $8a1c60aeca462d1f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $8a1c60aeca462d1f$export$9522e17588c12572, (v) => $8a1c60aeca462d1f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $8a1c60aeca462d1f$export$2110ac352bb060b9, (v) => $8a1c60aeca462d1f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $8a1c60aeca462d1f$export$56885ab8b9c456ab, (v) => $8a1c60aeca462d1f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $8a1c60aeca462d1f$export$d927fcb6adf8f9de, (v) => $8a1c60aeca462d1f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $8a1c60aeca462d1f$export$b82d16f27459e05a, (v) => $8a1c60aeca462d1f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $8a1c60aeca462d1f$export$522c17b4f5e123e8, (v) => $8a1c60aeca462d1f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $8a1c60aeca462d1f$export$1aabd8a0274ecfd6, (v) => $8a1c60aeca462d1f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $8a1c60aeca462d1f$export$9b621391a187a31a, (v) => $8a1c60aeca462d1f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $8a1c60aeca462d1f$export$f5bbd400c2f4426f, (v) => $8a1c60aeca462d1f$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8a1c60aeca462d1f$export$a7c73072b1a182ae;
var $8a1c60aeca462d1f$export$9f27bc3417b4524d;
var $8a1c60aeca462d1f$export$db77ccec0bb4ccac;
var $8a1c60aeca462d1f$export$8392c0c9d3dcbd35;
var $8a1c60aeca462d1f$export$ffb0004e005737fa;
var $8a1c60aeca462d1f$export$b624eff549462981;
var $8a1c60aeca462d1f$export$7897aa7841a5380c;
var $8a1c60aeca462d1f$export$602eac185826482c;
var $8a1c60aeca462d1f$export$e2c29f18771995cb;
var $8a1c60aeca462d1f$export$5f8d39834fd61797;
var $8a1c60aeca462d1f$export$74bf444e3cd11ea5;
var $8a1c60aeca462d1f$export$92387174baf9b227;
var $8a1c60aeca462d1f$export$ec112efeb987d9c6;
var $8a1c60aeca462d1f$export$b706b080d889d2c9;
var $8a1c60aeca462d1f$export$5be5a87408f70ddc;
var $8a1c60aeca462d1f$export$45a5e7f76e0caa8d;
var $8a1c60aeca462d1f$export$455c2e768291efa6;
var $8a1c60aeca462d1f$export$9522e17588c12572;
var $8a1c60aeca462d1f$export$2110ac352bb060b9;
var $8a1c60aeca462d1f$export$56885ab8b9c456ab;
var $8a1c60aeca462d1f$export$d927fcb6adf8f9de;
var $8a1c60aeca462d1f$export$b82d16f27459e05a;
var $8a1c60aeca462d1f$export$522c17b4f5e123e8;
var $8a1c60aeca462d1f$export$1aabd8a0274ecfd6;
var $8a1c60aeca462d1f$export$9b621391a187a31a;
var $8a1c60aeca462d1f$export$f5bbd400c2f4426f;
"use strict";
var $8a1c60aeca462d1f$var$b = 60103, $8a1c60aeca462d1f$var$c = 60106, $8a1c60aeca462d1f$var$d = 60107, $8a1c60aeca462d1f$var$e = 60108, $8a1c60aeca462d1f$var$f = 60114, $8a1c60aeca462d1f$var$g = 60109, $8a1c60aeca462d1f$var$h = 60110, $8a1c60aeca462d1f$var$k = 60112, $8a1c60aeca462d1f$var$l = 60113, $8a1c60aeca462d1f$var$m = 60120, $8a1c60aeca462d1f$var$n = 60115, $8a1c60aeca462d1f$var$p = 60116, $8a1c60aeca462d1f$var$q = 60121, $8a1c60aeca462d1f$var$r = 60122, $8a1c60aeca462d1f$var$u = 60117, $8a1c60aeca462d1f$var$v = 60129, $8a1c60aeca462d1f$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $8a1c60aeca462d1f$var$x = Symbol.for;
    $8a1c60aeca462d1f$var$b = $8a1c60aeca462d1f$var$x("react.element");
    $8a1c60aeca462d1f$var$c = $8a1c60aeca462d1f$var$x("react.portal");
    $8a1c60aeca462d1f$var$d = $8a1c60aeca462d1f$var$x("react.fragment");
    $8a1c60aeca462d1f$var$e = $8a1c60aeca462d1f$var$x("react.strict_mode");
    $8a1c60aeca462d1f$var$f = $8a1c60aeca462d1f$var$x("react.profiler");
    $8a1c60aeca462d1f$var$g = $8a1c60aeca462d1f$var$x("react.provider");
    $8a1c60aeca462d1f$var$h = $8a1c60aeca462d1f$var$x("react.context");
    $8a1c60aeca462d1f$var$k = $8a1c60aeca462d1f$var$x("react.forward_ref");
    $8a1c60aeca462d1f$var$l = $8a1c60aeca462d1f$var$x("react.suspense");
    $8a1c60aeca462d1f$var$m = $8a1c60aeca462d1f$var$x("react.suspense_list");
    $8a1c60aeca462d1f$var$n = $8a1c60aeca462d1f$var$x("react.memo");
    $8a1c60aeca462d1f$var$p = $8a1c60aeca462d1f$var$x("react.lazy");
    $8a1c60aeca462d1f$var$q = $8a1c60aeca462d1f$var$x("react.block");
    $8a1c60aeca462d1f$var$r = $8a1c60aeca462d1f$var$x("react.server.block");
    $8a1c60aeca462d1f$var$u = $8a1c60aeca462d1f$var$x("react.fundamental");
    $8a1c60aeca462d1f$var$v = $8a1c60aeca462d1f$var$x("react.debug_trace_mode");
    $8a1c60aeca462d1f$var$w = $8a1c60aeca462d1f$var$x("react.legacy_hidden");
}
function $8a1c60aeca462d1f$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $8a1c60aeca462d1f$var$b:
                switch(a = a.type, a){
                    case $8a1c60aeca462d1f$var$d:
                    case $8a1c60aeca462d1f$var$f:
                    case $8a1c60aeca462d1f$var$e:
                    case $8a1c60aeca462d1f$var$l:
                    case $8a1c60aeca462d1f$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8a1c60aeca462d1f$var$h:
                            case $8a1c60aeca462d1f$var$k:
                            case $8a1c60aeca462d1f$var$p:
                            case $8a1c60aeca462d1f$var$n:
                            case $8a1c60aeca462d1f$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $8a1c60aeca462d1f$var$c:
                return t;
        }
    }
}
var $8a1c60aeca462d1f$var$z = $8a1c60aeca462d1f$var$g, $8a1c60aeca462d1f$var$A = $8a1c60aeca462d1f$var$b, $8a1c60aeca462d1f$var$B = $8a1c60aeca462d1f$var$k, $8a1c60aeca462d1f$var$C = $8a1c60aeca462d1f$var$d, $8a1c60aeca462d1f$var$D = $8a1c60aeca462d1f$var$p, $8a1c60aeca462d1f$var$E = $8a1c60aeca462d1f$var$n, $8a1c60aeca462d1f$var$F = $8a1c60aeca462d1f$var$c, $8a1c60aeca462d1f$var$G = $8a1c60aeca462d1f$var$f, $8a1c60aeca462d1f$var$H = $8a1c60aeca462d1f$var$e, $8a1c60aeca462d1f$var$I = $8a1c60aeca462d1f$var$l;
$8a1c60aeca462d1f$export$a7c73072b1a182ae = $8a1c60aeca462d1f$var$h;
$8a1c60aeca462d1f$export$9f27bc3417b4524d = $8a1c60aeca462d1f$var$z;
$8a1c60aeca462d1f$export$db77ccec0bb4ccac = $8a1c60aeca462d1f$var$A;
$8a1c60aeca462d1f$export$8392c0c9d3dcbd35 = $8a1c60aeca462d1f$var$B;
$8a1c60aeca462d1f$export$ffb0004e005737fa = $8a1c60aeca462d1f$var$C;
$8a1c60aeca462d1f$export$b624eff549462981 = $8a1c60aeca462d1f$var$D;
$8a1c60aeca462d1f$export$7897aa7841a5380c = $8a1c60aeca462d1f$var$E;
$8a1c60aeca462d1f$export$602eac185826482c = $8a1c60aeca462d1f$var$F;
$8a1c60aeca462d1f$export$e2c29f18771995cb = $8a1c60aeca462d1f$var$G;
$8a1c60aeca462d1f$export$5f8d39834fd61797 = $8a1c60aeca462d1f$var$H;
$8a1c60aeca462d1f$export$74bf444e3cd11ea5 = $8a1c60aeca462d1f$var$I;
$8a1c60aeca462d1f$export$92387174baf9b227 = function() {
    return !1;
};
$8a1c60aeca462d1f$export$ec112efeb987d9c6 = function() {
    return !1;
};
$8a1c60aeca462d1f$export$b706b080d889d2c9 = function(a) {
    return $8a1c60aeca462d1f$var$y(a) === $8a1c60aeca462d1f$var$h;
};
$8a1c60aeca462d1f$export$5be5a87408f70ddc = function(a) {
    return $8a1c60aeca462d1f$var$y(a) === $8a1c60aeca462d1f$var$g;
};
$8a1c60aeca462d1f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8a1c60aeca462d1f$var$b;
};
$8a1c60aeca462d1f$export$455c2e768291efa6 = function(a) {
    return $8a1c60aeca462d1f$var$y(a) === $8a1c60aeca462d1f$var$k;
};
$8a1c60aeca462d1f$export$9522e17588c12572 = function(a) {
    return $8a1c60aeca462d1f$var$y(a) === $8a1c60aeca462d1f$var$d;
};
$8a1c60aeca462d1f$export$2110ac352bb060b9 = function(a) {
    return $8a1c60aeca462d1f$var$y(a) === $8a1c60aeca462d1f$var$p;
};
$8a1c60aeca462d1f$export$56885ab8b9c456ab = function(a) {
    return $8a1c60aeca462d1f$var$y(a) === $8a1c60aeca462d1f$var$n;
};
$8a1c60aeca462d1f$export$d927fcb6adf8f9de = function(a) {
    return $8a1c60aeca462d1f$var$y(a) === $8a1c60aeca462d1f$var$c;
};
$8a1c60aeca462d1f$export$b82d16f27459e05a = function(a) {
    return $8a1c60aeca462d1f$var$y(a) === $8a1c60aeca462d1f$var$f;
};
$8a1c60aeca462d1f$export$522c17b4f5e123e8 = function(a) {
    return $8a1c60aeca462d1f$var$y(a) === $8a1c60aeca462d1f$var$e;
};
$8a1c60aeca462d1f$export$1aabd8a0274ecfd6 = function(a) {
    return $8a1c60aeca462d1f$var$y(a) === $8a1c60aeca462d1f$var$l;
};
$8a1c60aeca462d1f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8a1c60aeca462d1f$var$d || a === $8a1c60aeca462d1f$var$f || a === $8a1c60aeca462d1f$var$v || a === $8a1c60aeca462d1f$var$e || a === $8a1c60aeca462d1f$var$l || a === $8a1c60aeca462d1f$var$m || a === $8a1c60aeca462d1f$var$w || "object" === typeof a && null !== a && (a.$$typeof === $8a1c60aeca462d1f$var$p || a.$$typeof === $8a1c60aeca462d1f$var$n || a.$$typeof === $8a1c60aeca462d1f$var$g || a.$$typeof === $8a1c60aeca462d1f$var$h || a.$$typeof === $8a1c60aeca462d1f$var$k || a.$$typeof === $8a1c60aeca462d1f$var$u || a.$$typeof === $8a1c60aeca462d1f$var$q || a[0] === $8a1c60aeca462d1f$var$r) ? !0 : !1;
};
$8a1c60aeca462d1f$export$f5bbd400c2f4426f = $8a1c60aeca462d1f$var$y;

});

parcelRegister("6bvDC", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => D);
$parcel$export(module.exports, "enableES5", () => N);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $480c4fd31131abbc$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!n.constructor[L] || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? (n.delete(r), n.add(t)) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) ? n : (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0), n);
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function O(n) {
    g(n), n.p.forEach(S), n.p = null;
}
function g(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.O = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.g || b("ES5").S(e, r, o), o ? (i[Q].P && (O(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), O(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o;
        i(3 === e.i ? new Set(o) : o, function(r, i) {
            return A(n, e, o, r, i, t);
        }), x(n, o, !1), t && n.u && b("Patches").R(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s) {
    if (r(c)) {
        var v = M(e, c, s && i && 3 !== i.i && !u(i.D, a) ? s.concat(a) : void 0);
        if (f(o, a, v), !r(v)) return;
        e.m = !1;
    }
    if (t(c) && !y(c)) {
        if (!e.h.F && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), n.h.F && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function R(n, r, t) {
    var e = s(r) ? b("MapSet").N(r, t) : v(r) ? b("MapSet").T(r, t) : n.g ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            D: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function D(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = F(r, c), u.I = !1;
        } else e = F(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function F(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function N() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.O && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                D: {},
                l: r,
                t: n,
                k: i,
                o: null,
                O: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.D, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = "" + i[s];
                    0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        R: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.D, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.D, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.D = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = R(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.O && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                D: void 0,
                t: n,
                k: this,
                C: !1,
                O: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.D.set(n, !0), t.o.set(n, r), t.D.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.D.set(n, !1) : r.D.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.D = new Map, i(n.t, function(r) {
                n.D.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = R(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                O: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        N: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    N(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = R(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.D[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && "number" != typeof t && (void 0 !== t || r in n.o) || (n.o[r] = t, n.D[r] = !0, !0);
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.D[r] = !1, E(n), k(n)) : delete n.D[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.g = B, this.F = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = R(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? O(c) : g(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw O(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.F && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = D(e));
        var i = w(this), o = R(this, e, void 0);
        return o[Q].C = !0, g(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.F = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.g = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $480c4fd31131abbc$export$2e2bcd8739ae039 = fn;

});

parcelRegister("hrvvF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $cb2d6678dab51cb8$export$1e511d4a378977f5, (v) => $cb2d6678dab51cb8$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $cb2d6678dab51cb8$export$2e2bcd8739ae039, (v) => $cb2d6678dab51cb8$export$2e2bcd8739ae039 = v);
var $cb2d6678dab51cb8$export$1e511d4a378977f5;
var $cb2d6678dab51cb8$export$2e2bcd8739ae039;
"use strict";
$cb2d6678dab51cb8$export$1e511d4a378977f5 = true;
$cb2d6678dab51cb8$export$2e2bcd8739ae039 = $cb2d6678dab51cb8$var$createWebStorage;

var $cb2d6678dab51cb8$var$_getStorage = $cb2d6678dab51cb8$var$_interopRequireDefault((parcelRequire("1n0uj")));
function $cb2d6678dab51cb8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cb2d6678dab51cb8$var$createWebStorage(type) {
    var storage = (0, $cb2d6678dab51cb8$var$_getStorage.default)(type);
    return {
        getItem: function getItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.getItem(key));
            });
        },
        setItem: function setItem(key, item) {
            return new Promise(function(resolve, reject) {
                resolve(storage.setItem(key, item));
            });
        },
        removeItem: function removeItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.removeItem(key));
            });
        }
    };
}

});
parcelRegister("1n0uj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $0ff8514bbd8b56f0$export$1e511d4a378977f5, (v) => $0ff8514bbd8b56f0$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $0ff8514bbd8b56f0$export$2e2bcd8739ae039, (v) => $0ff8514bbd8b56f0$export$2e2bcd8739ae039 = v);
var $0ff8514bbd8b56f0$export$1e511d4a378977f5;
var $0ff8514bbd8b56f0$export$2e2bcd8739ae039;
"use strict";
$0ff8514bbd8b56f0$export$1e511d4a378977f5 = true;
$0ff8514bbd8b56f0$export$2e2bcd8739ae039 = $0ff8514bbd8b56f0$var$getStorage;
function $0ff8514bbd8b56f0$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0ff8514bbd8b56f0$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $0ff8514bbd8b56f0$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0ff8514bbd8b56f0$var$_typeof(obj);
}
function $0ff8514bbd8b56f0$var$noop() {}
var $0ff8514bbd8b56f0$var$noopStorage = {
    getItem: $0ff8514bbd8b56f0$var$noop,
    setItem: $0ff8514bbd8b56f0$var$noop,
    removeItem: $0ff8514bbd8b56f0$var$noop
};
function $0ff8514bbd8b56f0$var$hasStorage(storageType) {
    if ((typeof self === "undefined" ? "undefined" : $0ff8514bbd8b56f0$var$_typeof(self)) !== "object" || !(storageType in self)) return false;
    try {
        var storage = self[storageType];
        var testKey = "redux-persist ".concat(storageType, " test");
        storage.setItem(testKey, "test");
        storage.getItem(testKey);
        storage.removeItem(testKey);
    } catch (e) {
        return false;
    }
    return true;
}
function $0ff8514bbd8b56f0$var$getStorage(type) {
    var storageType = "".concat(type, "Storage");
    if ($0ff8514bbd8b56f0$var$hasStorage(storageType)) return self[storageType];
    else return $0ff8514bbd8b56f0$var$noopStorage;
}

});


parcelRegister("kuzpm", function(module, exports) {
// shim for using process in browser
var $eeb21346c238d2e4$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $eeb21346c238d2e4$var$cachedSetTimeout;
var $eeb21346c238d2e4$var$cachedClearTimeout;
function $eeb21346c238d2e4$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $eeb21346c238d2e4$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $eeb21346c238d2e4$var$cachedSetTimeout = setTimeout;
        else $eeb21346c238d2e4$var$cachedSetTimeout = $eeb21346c238d2e4$var$defaultSetTimout;
    } catch (e) {
        $eeb21346c238d2e4$var$cachedSetTimeout = $eeb21346c238d2e4$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $eeb21346c238d2e4$var$cachedClearTimeout = clearTimeout;
        else $eeb21346c238d2e4$var$cachedClearTimeout = $eeb21346c238d2e4$var$defaultClearTimeout;
    } catch (e) {
        $eeb21346c238d2e4$var$cachedClearTimeout = $eeb21346c238d2e4$var$defaultClearTimeout;
    }
})();
function $eeb21346c238d2e4$var$runTimeout(fun) {
    if ($eeb21346c238d2e4$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($eeb21346c238d2e4$var$cachedSetTimeout === $eeb21346c238d2e4$var$defaultSetTimout || !$eeb21346c238d2e4$var$cachedSetTimeout) && setTimeout) {
        $eeb21346c238d2e4$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $eeb21346c238d2e4$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $eeb21346c238d2e4$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $eeb21346c238d2e4$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $eeb21346c238d2e4$var$runClearTimeout(marker) {
    if ($eeb21346c238d2e4$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($eeb21346c238d2e4$var$cachedClearTimeout === $eeb21346c238d2e4$var$defaultClearTimeout || !$eeb21346c238d2e4$var$cachedClearTimeout) && clearTimeout) {
        $eeb21346c238d2e4$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $eeb21346c238d2e4$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $eeb21346c238d2e4$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $eeb21346c238d2e4$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $eeb21346c238d2e4$var$queue = [];
var $eeb21346c238d2e4$var$draining = false;
var $eeb21346c238d2e4$var$currentQueue;
var $eeb21346c238d2e4$var$queueIndex = -1;
function $eeb21346c238d2e4$var$cleanUpNextTick() {
    if (!$eeb21346c238d2e4$var$draining || !$eeb21346c238d2e4$var$currentQueue) return;
    $eeb21346c238d2e4$var$draining = false;
    if ($eeb21346c238d2e4$var$currentQueue.length) $eeb21346c238d2e4$var$queue = $eeb21346c238d2e4$var$currentQueue.concat($eeb21346c238d2e4$var$queue);
    else $eeb21346c238d2e4$var$queueIndex = -1;
    if ($eeb21346c238d2e4$var$queue.length) $eeb21346c238d2e4$var$drainQueue();
}
function $eeb21346c238d2e4$var$drainQueue() {
    if ($eeb21346c238d2e4$var$draining) return;
    var timeout = $eeb21346c238d2e4$var$runTimeout($eeb21346c238d2e4$var$cleanUpNextTick);
    $eeb21346c238d2e4$var$draining = true;
    var len = $eeb21346c238d2e4$var$queue.length;
    while(len){
        $eeb21346c238d2e4$var$currentQueue = $eeb21346c238d2e4$var$queue;
        $eeb21346c238d2e4$var$queue = [];
        while(++$eeb21346c238d2e4$var$queueIndex < len)if ($eeb21346c238d2e4$var$currentQueue) $eeb21346c238d2e4$var$currentQueue[$eeb21346c238d2e4$var$queueIndex].run();
        $eeb21346c238d2e4$var$queueIndex = -1;
        len = $eeb21346c238d2e4$var$queue.length;
    }
    $eeb21346c238d2e4$var$currentQueue = null;
    $eeb21346c238d2e4$var$draining = false;
    $eeb21346c238d2e4$var$runClearTimeout(timeout);
}
$eeb21346c238d2e4$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $eeb21346c238d2e4$var$queue.push(new $eeb21346c238d2e4$var$Item(fun, args));
    if ($eeb21346c238d2e4$var$queue.length === 1 && !$eeb21346c238d2e4$var$draining) $eeb21346c238d2e4$var$runTimeout($eeb21346c238d2e4$var$drainQueue);
};
// v8 likes predictible objects
function $eeb21346c238d2e4$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$eeb21346c238d2e4$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$eeb21346c238d2e4$var$process.title = "browser";
$eeb21346c238d2e4$var$process.browser = true;
$eeb21346c238d2e4$var$process.env = {};
$eeb21346c238d2e4$var$process.argv = [];
$eeb21346c238d2e4$var$process.version = ""; // empty string to avoid regexp issues
$eeb21346c238d2e4$var$process.versions = {};
function $eeb21346c238d2e4$var$noop() {}
$eeb21346c238d2e4$var$process.on = $eeb21346c238d2e4$var$noop;
$eeb21346c238d2e4$var$process.addListener = $eeb21346c238d2e4$var$noop;
$eeb21346c238d2e4$var$process.once = $eeb21346c238d2e4$var$noop;
$eeb21346c238d2e4$var$process.off = $eeb21346c238d2e4$var$noop;
$eeb21346c238d2e4$var$process.removeListener = $eeb21346c238d2e4$var$noop;
$eeb21346c238d2e4$var$process.removeAllListeners = $eeb21346c238d2e4$var$noop;
$eeb21346c238d2e4$var$process.emit = $eeb21346c238d2e4$var$noop;
$eeb21346c238d2e4$var$process.prependListener = $eeb21346c238d2e4$var$noop;
$eeb21346c238d2e4$var$process.prependOnceListener = $eeb21346c238d2e4$var$noop;
$eeb21346c238d2e4$var$process.listeners = function(name) {
    return [];
};
$eeb21346c238d2e4$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$eeb21346c238d2e4$var$process.cwd = function() {
    return "/";
};
$eeb21346c238d2e4$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$eeb21346c238d2e4$var$process.umask = function() {
    return 0;
};

});

parcelRegister("4Z4HE", function(module, exports) {

$parcel$export(module.exports, "createRule", () => createRule);
$parcel$export(module.exports, "toCssValue", () => toCssValue);
$parcel$export(module.exports, "RuleList", () => RuleList);
$parcel$export(module.exports, "create", () => createJss);
$parcel$export(module.exports, "hasCSSTOMSupport", () => hasCSSTOMSupport);
$parcel$export(module.exports, "getDynamicStyles", () => getDynamicStyles);

var $j1NUG = parcelRequire("j1NUG");

var $4dSXJ = parcelRequire("4dSXJ");

var $gRx9P = parcelRequire("gRx9P");

var $avH1z = parcelRequire("avH1z");

var $1gxF5 = parcelRequire("1gxF5");

var $an7Fk = parcelRequire("an7Fk");

var $cGhSa = parcelRequire("cGhSa");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== "object") return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = "unnamed";
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = "";
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === "!important") break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value, ignoreImportant) {
    if (ignoreImportant === void 0) ignoreImportant = false;
    if (!Array.isArray(value)) return value;
    var cssValue = ""; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === "!important") break;
        if (cssValue) cssValue += ", ";
        cssValue += join(value[i], " ");
    }
    else cssValue = join(value, ", "); // Add !important, because it was ignored.
    if (!ignoreImportant && value[value.length - 1] === "!important") cssValue += " !important";
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: "",
        space: ""
    };
    return {
        linebreak: "\n",
        space: " "
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = "";
    for(var index = 0; index < indent; index++)result += "  ";
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = "";
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== "fallbacks") {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr("}", indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== "undefined" && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, "\\$1");
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = "style";
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $1gxF5.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $an7Fk.default)((0, $an7Fk.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== "object") json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $j1NUG.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $avH1z.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === "@" || options.parent && options.parent.type === "keyframes") return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = "conditional";
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : "unknown"; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $j1NUG.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : "";
    };
    return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = "keyframes";
        this.at = "@keyframes";
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = "noname";
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $j1NUG.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $j1NUG.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === "string") return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === "string" && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style" || !sheet) return style;
        if ("animation-name" in style) replaceRef(style, "animation-name", sheet.keyframes);
        if ("animation" in style) replaceRef(style, "animation", sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case "animation":
                return findReferencedKeyframe(val, sheet.keyframes);
            case "animation-name":
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $1gxF5.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $j1NUG.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === "keyframes") return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = "font-face";
        this.at = "@font-face";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = "";
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = "viewport";
        this.at = "@viewport";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === "@viewport" || key === "@-ms-viewport" ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = "simple";
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = "";
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += "\n";
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    "@charset": true,
    "@import": true,
    "@namespace": true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $j1NUG.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */ ;
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $j1NUG.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === "string") {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = "";
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $j1NUG.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Replace a rule in the current stylesheet.
   */ ;
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === "object" ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: "external"
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $cGhSa.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = "";
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $avH1z.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" && window.Math === Math ? window : typeof self !== "undefined" && self.Math === Math ? self : Function("return this")();
var ns = "2f1acc6c3a606b082e5eef5e54414ffb";
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = "";
        var prefix = "";
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || "c") + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : "") + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return "";
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) {
            cssValue = toCssValue(value, true);
            if (value[value.length - 1] === "!important") {
                cssRule.style.setProperty(prop, cssValue, "important");
                return true;
            }
        } // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else cssRule.style.setProperty(prop, cssValue);
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector("head");
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === "string") {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === "number") {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute("content") : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ("insertRule" in container) container.insertRule(rule, index);
        else if ("appendRule" in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement("style"); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = "\n";
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute("data-jss", "");
        if (media) this.element.setAttribute("media", media);
        if (meta) this.element.setAttribute("data-meta", meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute("nonce", nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = "\n";
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === "conditional" || rule.type === "keyframes") {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.9.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $4dSXJ.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: "internal"
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $j1NUG.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ("Renderer" in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== "number") index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $j1NUG.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === "object") return this.createRule(undefined, name, style);
        var ruleOptions = (0, $j1NUG.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $gRx9P.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $gRx9P.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $avH1z.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === "object" && CSS != null && "number" in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === "function") {
            if (!to) to = {};
            to[key] = value;
        } else if (type === "object" && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $3a1081e125299197$export$2e2bcd8739ae039 = index;

});
parcelRegister("j1NUG", function(module, exports) {

$parcel$export(module.exports, "default", () => $dda4d40cf5733033$export$2e2bcd8739ae039);
function $dda4d40cf5733033$export$2e2bcd8739ae039() {
    $dda4d40cf5733033$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dda4d40cf5733033$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("4dSXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $313302b3755e3c2b$export$2e2bcd8739ae039);
var $313302b3755e3c2b$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $313302b3755e3c2b$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $313302b3755e3c2b$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $313302b3755e3c2b$var$_typeof(document)) === "object" && document.nodeType === 9;
var $313302b3755e3c2b$export$2e2bcd8739ae039 = $313302b3755e3c2b$export$4e09c449d6c407f7;

});

parcelRegister("gRx9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $c46b50f7a2993a99$export$2e2bcd8739ae039);
var $c46b50f7a2993a99$var$isProduction = true;
function $c46b50f7a2993a99$var$warning(condition, message) {
    if (!$c46b50f7a2993a99$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $c46b50f7a2993a99$export$2e2bcd8739ae039 = $c46b50f7a2993a99$var$warning;

});

parcelRegister("avH1z", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6e2c5edbf0ab9f$export$2e2bcd8739ae039);
function $7a6e2c5edbf0ab9f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7a6e2c5edbf0ab9f$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $7a6e2c5edbf0ab9f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7a6e2c5edbf0ab9f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});

parcelRegister("1gxF5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ec1659a3a380451$export$2e2bcd8739ae039);

var $l5s0C = parcelRequire("l5s0C");
function $0ec1659a3a380451$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $l5s0C.default)(subClass, superClass);
}

});
parcelRegister("l5s0C", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59fca9f0da9b49e$export$2e2bcd8739ae039);
function $f59fca9f0da9b49e$export$2e2bcd8739ae039(o, p) {
    $f59fca9f0da9b49e$export$2e2bcd8739ae039 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f59fca9f0da9b49e$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("an7Fk", function(module, exports) {

$parcel$export(module.exports, "default", () => $78d1ff95f3f3e89d$export$2e2bcd8739ae039);
function $78d1ff95f3f3e89d$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("cGhSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b7456b56abf607$export$2e2bcd8739ae039);
function $93b7456b56abf607$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("lpmCO", function(module, exports) {

$parcel$export(module.exports, "CoreHelperUtil", () => $f95d7b9c98cdf5f4$export$d8fe68a4208d58ff);

var $b3v9s = parcelRequire("b3v9s");

var $3h0dG = parcelRequire("3h0dG");

var $bc5dy = parcelRequire("bc5dy");
const $f95d7b9c98cdf5f4$export$d8fe68a4208d58ff = {
    isMobile () {
        if (this.isClient()) return Boolean(window?.matchMedia("(pointer:coarse)")?.matches || /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/u.test(navigator.userAgent));
        return false;
    },
    checkCaipNetwork (network, networkName = "") {
        return network?.caipNetworkId.toLocaleLowerCase().includes(networkName.toLowerCase());
    },
    isAndroid () {
        if (!this.isMobile()) return false;
        const ua = window?.navigator.userAgent.toLowerCase();
        return $f95d7b9c98cdf5f4$export$d8fe68a4208d58ff.isMobile() && ua.includes("android");
    },
    isIos () {
        if (!this.isMobile()) return false;
        const ua = window?.navigator.userAgent.toLowerCase();
        return ua.includes("iphone") || ua.includes("ipad");
    },
    isSafari () {
        if (!this.isClient()) return false;
        const ua = window?.navigator.userAgent.toLowerCase();
        return ua.includes("safari");
    },
    isClient () {
        return typeof window !== "undefined";
    },
    isPairingExpired (expiry) {
        return expiry ? expiry - Date.now() <= (0, $3h0dG.ConstantsUtil).TEN_SEC_MS : true;
    },
    isAllowedRetry (lastRetry, differenceMs = (0, $3h0dG.ConstantsUtil).ONE_SEC_MS) {
        return Date.now() - lastRetry >= differenceMs;
    },
    copyToClopboard (text) {
        navigator.clipboard.writeText(text);
    },
    isIframe () {
        try {
            return window?.self !== window?.top;
        } catch (e) {
            return false;
        }
    },
    getPairingExpiry () {
        return Date.now() + (0, $3h0dG.ConstantsUtil).FOUR_MINUTES_MS;
    },
    getNetworkId (caipAddress) {
        return caipAddress?.split(":")[1];
    },
    getPlainAddress (caipAddress) {
        return caipAddress?.split(":")[2];
    },
    async wait (milliseconds) {
        return new Promise((resolve)=>{
            setTimeout(resolve, milliseconds);
        });
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    debounce (func, timeout = 500) {
        let timer = undefined;
        return (...args)=>{
            function next() {
                func(...args);
            }
            if (timer) clearTimeout(timer);
            timer = setTimeout(next, timeout);
        };
    },
    isHttpUrl (url) {
        return url.startsWith("http://") || url.startsWith("https://");
    },
    formatNativeUrl (appUrl, wcUri, universalLink = null) {
        if ($f95d7b9c98cdf5f4$export$d8fe68a4208d58ff.isHttpUrl(appUrl)) return this.formatUniversalUrl(appUrl, wcUri);
        let safeAppUrl = appUrl;
        let safeUniversalLink = universalLink;
        if (!safeAppUrl.includes("://")) {
            safeAppUrl = appUrl.replaceAll("/", "").replaceAll(":", "");
            safeAppUrl = `${safeAppUrl}://`;
        }
        if (!safeAppUrl.endsWith("/")) safeAppUrl = `${safeAppUrl}/`;
        if (safeUniversalLink && !safeUniversalLink?.endsWith("/")) safeUniversalLink = `${safeUniversalLink}/`;
        // Android deeplinks in tg context require the uri to be encoded twice
        if (this.isTelegram() && this.isAndroid()) // eslint-disable-next-line no-param-reassign
        wcUri = encodeURIComponent(wcUri);
        const encodedWcUrl = encodeURIComponent(wcUri);
        return {
            redirect: `${safeAppUrl}wc?uri=${encodedWcUrl}`,
            redirectUniversalLink: safeUniversalLink ? `${safeUniversalLink}wc?uri=${encodedWcUrl}` : undefined,
            href: safeAppUrl
        };
    },
    formatUniversalUrl (appUrl, wcUri) {
        if (!$f95d7b9c98cdf5f4$export$d8fe68a4208d58ff.isHttpUrl(appUrl)) return this.formatNativeUrl(appUrl, wcUri);
        let safeAppUrl = appUrl;
        if (!safeAppUrl.endsWith("/")) safeAppUrl = `${safeAppUrl}/`;
        const encodedWcUrl = encodeURIComponent(wcUri);
        return {
            redirect: `${safeAppUrl}wc?uri=${encodedWcUrl}`,
            href: safeAppUrl
        };
    },
    getOpenTargetForPlatform (target) {
        if (target === "popupWindow") return target;
        // Only '_blank' deeplinks work in Telegram context
        if (this.isTelegram()) {
            // But for social login, we need to load the page in the same context
            if ((0, $bc5dy.StorageUtil).getTelegramSocialProvider()) return "_top";
            return "_blank";
        }
        return target;
    },
    openHref (href, target, features) {
        window?.open(href, this.getOpenTargetForPlatform(target), features || "noreferrer noopener");
    },
    returnOpenHref (href, target, features) {
        return window?.open(href, this.getOpenTargetForPlatform(target), features || "noreferrer noopener");
    },
    isTelegram () {
        return typeof window !== "undefined" && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (Boolean(window.TelegramWebviewProxy) || // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Boolean(window.Telegram) || // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Boolean(window.TelegramWebviewProxyProto));
    },
    isPWA () {
        if (typeof window === "undefined") return false;
        const isStandaloneDisplayMode = window.matchMedia?.("(display-mode: standalone)")?.matches;
        const isIOSStandalone = window?.navigator?.standalone;
        return Boolean(isStandaloneDisplayMode || isIOSStandalone);
    },
    async preloadImage (src) {
        const imagePromise = new Promise((resolve, reject)=>{
            const image = new Image();
            image.onload = resolve;
            image.onerror = reject;
            image.crossOrigin = "anonymous";
            image.src = src;
        });
        return Promise.race([
            imagePromise,
            $f95d7b9c98cdf5f4$export$d8fe68a4208d58ff.wait(2000)
        ]);
    },
    formatBalance (balance, symbol) {
        let formattedBalance = "0.000";
        if (typeof balance === "string") {
            const number = Number(balance);
            if (number) {
                const formattedValue = Math.floor(number * 1000) / 1000;
                if (formattedValue) formattedBalance = formattedValue.toString();
            }
        }
        return `${formattedBalance}${symbol ? ` ${symbol}` : ""}`;
    },
    formatBalance2 (balance, symbol) {
        let formattedBalance = undefined;
        if (balance === "0") formattedBalance = "0";
        else if (typeof balance === "string") {
            const number = Number(balance);
            if (number) formattedBalance = number.toString().match(/^-?\d+(?:\.\d{0,3})?/u)?.[0];
        }
        return {
            value: formattedBalance ?? "0",
            rest: formattedBalance === "0" ? "000" : "",
            symbol: symbol
        };
    },
    getApiUrl () {
        return (0, $b3v9s.ConstantsUtil).W3M_API_URL;
    },
    getBlockchainApiUrl () {
        return (0, $b3v9s.ConstantsUtil).BLOCKCHAIN_API_RPC_URL;
    },
    getAnalyticsUrl () {
        return (0, $b3v9s.ConstantsUtil).PULSE_API_URL;
    },
    getUUID () {
        if (crypto?.randomUUID) return crypto.randomUUID();
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/gu, (c)=>{
            const r = Math.random() * 16 | 0;
            const v = c === "x" ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseError (error) {
        if (typeof error === "string") return error;
        else if (typeof error?.issues?.[0]?.message === "string") return error.issues[0].message;
        else if (error instanceof Error) return error.message;
        return "Unknown error";
    },
    sortRequestedNetworks (approvedIds, requestedNetworks = []) {
        const approvedIndexMap = {};
        if (requestedNetworks && approvedIds) {
            approvedIds.forEach((id, index)=>{
                approvedIndexMap[id] = index;
            });
            requestedNetworks.sort((a, b)=>{
                const indexA = approvedIndexMap[a.id];
                const indexB = approvedIndexMap[b.id];
                if (indexA !== undefined && indexB !== undefined) return indexA - indexB;
                else if (indexA !== undefined) return -1;
                else if (indexB !== undefined) return 1;
                return 0;
            });
        }
        return requestedNetworks;
    },
    calculateBalance (array) {
        let sum = 0;
        for (const item of array)sum += item.value ?? 0;
        return sum;
    },
    formatTokenBalance (number) {
        const roundedNumber = number.toFixed(2);
        const [dollars, pennies] = roundedNumber.split(".");
        return {
            dollars: dollars,
            pennies: pennies
        };
    },
    isAddress (address, chain = "eip155") {
        switch(chain){
            case "eip155":
                if (!/^(?:0x)?[0-9a-f]{40}$/iu.test(address)) return false;
                else if (/^(?:0x)?[0-9a-f]{40}$/iu.test(address) || /^(?:0x)?[0-9A-F]{40}$/iu.test(address)) return true;
                return false;
            case "solana":
                return /[1-9A-HJ-NP-Za-km-z]{32,44}$/iu.test(address);
            default:
                return false;
        }
    },
    uniqueBy (arr, key) {
        const set = new Set();
        return arr.filter((item)=>{
            const keyValue = item[key];
            if (set.has(keyValue)) return false;
            set.add(keyValue);
            return true;
        });
    },
    generateSdkVersion (adapters, platform, version) {
        const hasNoAdapters = adapters.length === 0;
        const adapterNames = hasNoAdapters ? (0, $3h0dG.ConstantsUtil).ADAPTER_TYPES.UNIVERSAL : adapters.map((adapter)=>adapter.adapterType).join(",");
        return `${platform}-${adapterNames}-${version}`;
    },
    // eslint-disable-next-line max-params
    createAccount (namespace, address, type, publicKey, path) {
        return {
            namespace: namespace,
            address: address,
            type: type,
            publicKey: publicKey,
            path: path
        };
    },
    isCaipAddress (address) {
        if (typeof address !== "string") return false;
        const sections = address.split(":");
        const namespace = sections[0];
        return sections.filter(Boolean).length === 3 && namespace in (0, $b3v9s.ConstantsUtil).CHAIN_NAME_MAP;
    },
    isMac () {
        const ua = window?.navigator.userAgent.toLowerCase();
        return ua.includes("macintosh") && !ua.includes("safari");
    },
    formatTelegramSocialLoginUrl (url) {
        const valueToInject = `--${encodeURIComponent(window?.location.href)}`;
        const paramToInject = "state=";
        const parsedUrl = new URL(url);
        if (parsedUrl.host === "auth.magic.link") {
            const providerParam = "provider_authorization_url=";
            const providerUrl = url.substring(url.indexOf(providerParam) + providerParam.length);
            const resultUrl = this.injectIntoUrl(decodeURIComponent(providerUrl), paramToInject, valueToInject);
            return url.replace(providerUrl, encodeURIComponent(resultUrl));
        }
        return this.injectIntoUrl(url, paramToInject, valueToInject);
    },
    injectIntoUrl (url, key, appendString) {
        // Find the position of "key" e.g. "state=" in the URL
        const keyIndex = url.indexOf(key);
        if (keyIndex === -1) throw new Error(`${key} parameter not found in the URL: ${url}`);
        // Find the position of the next "&" after "key"
        const keyEndIndex = url.indexOf("&", keyIndex);
        const keyLength = key.length;
        // If there is no "&" after key, it means "key" is the last parameter
        // eslint-disable-next-line no-negated-condition
        const keyParamEnd = keyEndIndex !== -1 ? keyEndIndex : url.length;
        // Extract the part of the URL before the key value
        const beforeKeyValue = url.substring(0, keyIndex + keyLength);
        // Extract the current key value
        const currentKeyValue = url.substring(keyIndex + keyLength, keyParamEnd);
        // Extract the part of the URL after the key value
        const afterKeyValue = url.substring(keyEndIndex);
        // Append the new string to the key value
        const newKeyValue = currentKeyValue + appendString;
        // Reconstruct the URL with the appended key value
        const newUrl = beforeKeyValue + newKeyValue + afterKeyValue;
        return newUrl;
    }
};

});
parcelRegister("b3v9s", function(module, exports) {

$parcel$export(module.exports, "ConstantsUtil", () => $80c82396fac8ae2b$export$aafe1f751f1bc52a);

var $kuzpm = parcelRequire("kuzpm");
const $80c82396fac8ae2b$export$aafe1f751f1bc52a = {
    WC_NAME_SUFFIX: ".reown.id",
    WC_NAME_SUFFIX_LEGACY: ".wcn.id",
    BLOCKCHAIN_API_RPC_URL: "https://rpc.walletconnect.org",
    PULSE_API_URL: "https://pulse.walletconnect.org",
    W3M_API_URL: "https://api.web3modal.org",
    CONNECTOR_ID: {
        WALLET_CONNECT: "walletConnect",
        INJECTED: "injected",
        WALLET_STANDARD: "announced",
        COINBASE: "coinbaseWallet",
        COINBASE_SDK: "coinbaseWalletSDK",
        SAFE: "safe",
        LEDGER: "ledger",
        OKX: "okx",
        EIP6963: "eip6963",
        AUTH: "ID_AUTH"
    },
    CONNECTOR_NAMES: {
        AUTH: "Auth"
    },
    AUTH_CONNECTOR_SUPPORTED_CHAINS: [
        "eip155",
        "solana"
    ],
    LIMITS: {
        PENDING_TRANSACTIONS: 99
    },
    CHAIN: {
        EVM: "eip155",
        SOLANA: "solana",
        POLKADOT: "polkadot",
        BITCOIN: "bip122"
    },
    CHAIN_NAME_MAP: {
        eip155: "EVM Networks",
        solana: "Solana",
        polkadot: "Polkadot",
        bip122: "Bitcoin",
        cosmos: "Cosmos"
    },
    ADAPTER_TYPES: {
        BITCOIN: "bitcoin",
        SOLANA: "solana",
        WAGMI: "wagmi",
        ETHERS: "ethers",
        ETHERS5: "ethers5"
    },
    USDT_CONTRACT_ADDRESSES: [
        "0xdac17f958d2ee523a2206206994597c13d831ec7",
        "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
        "0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7",
        "0x919C1c267BC06a7039e03fcc2eF738525769109c",
        "0x48065fbBE25f71C9282ddf5e1cD6D6A887483D5e",
        "0x55d398326f99059fF775485246999027B3197955",
        "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9"
    ],
    HTTP_STATUS_CODES: {
        SERVICE_UNAVAILABLE: 503,
        FORBIDDEN: 403
    },
    UNSUPPORTED_NETWORK_NAME: "Unknown Network",
    SECURE_SITE_SDK_ORIGIN: (typeof $kuzpm !== "undefined" && typeof $kuzpm.env !== "undefined" ? undefined : undefined) || "https://secure.walletconnect.org"
};

});

parcelRegister("3h0dG", function(module, exports) {

$parcel$export(module.exports, "ONRAMP_PROVIDERS", () => $2623214435ff1bde$export$e021b4b4649620f6);
$parcel$export(module.exports, "MELD_PUBLIC_KEY", () => $2623214435ff1bde$export$10bde7f41fd14984);
$parcel$export(module.exports, "ConstantsUtil", () => $2623214435ff1bde$export$aafe1f751f1bc52a);


var $kuzpm = parcelRequire("kuzpm");
const $2623214435ff1bde$var$SECURE_SITE = // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
(typeof $kuzpm !== "undefined" && typeof $kuzpm.env !== "undefined" ? undefined : undefined) || "https://secure.walletconnect.org";
const $2623214435ff1bde$export$e021b4b4649620f6 = [
    {
        label: "Coinbase",
        name: "coinbase",
        feeRange: "1-2%",
        url: "",
        supportedChains: [
            "eip155"
        ]
    },
    {
        label: "Meld.io",
        name: "meld",
        feeRange: "1-2%",
        url: "https://meldcrypto.com",
        supportedChains: [
            "eip155",
            "solana"
        ]
    }
];
const $2623214435ff1bde$export$10bde7f41fd14984 = "WXETMuFUQmqqybHuRkSgxv:25B8LJHSfpG6LVjR2ytU5Cwh7Z4Sch2ocoU";
const $2623214435ff1bde$export$aafe1f751f1bc52a = {
    FOUR_MINUTES_MS: 240000,
    TEN_SEC_MS: 10000,
    FIVE_SEC_MS: 5000,
    THREE_SEC_MS: 3000,
    ONE_SEC_MS: 1000,
    SECURE_SITE: $2623214435ff1bde$var$SECURE_SITE,
    SECURE_SITE_DASHBOARD: `${$2623214435ff1bde$var$SECURE_SITE}/dashboard`,
    SECURE_SITE_FAVICON: `${$2623214435ff1bde$var$SECURE_SITE}/images/favicon.png`,
    RESTRICTED_TIMEZONES: [
        "ASIA/SHANGHAI",
        "ASIA/URUMQI",
        "ASIA/CHONGQING",
        "ASIA/HARBIN",
        "ASIA/KASHGAR",
        "ASIA/MACAU",
        "ASIA/HONG_KONG",
        "ASIA/MACAO",
        "ASIA/BEIJING",
        "ASIA/HARBIN"
    ],
    /**
     * Network name to Coinbase Pay SDK chain name map object
     * @see supported chain names on Coinbase for Pay SDK: https://github.com/coinbase/cbpay-js/blob/d4bda2c05c4d5917c8db6a05476b603546046394/src/types/onramp.ts
     */ WC_COINBASE_PAY_SDK_CHAINS: [
        "ethereum",
        "arbitrum",
        "polygon",
        "berachain",
        "avalanche-c-chain",
        "optimism",
        "celo",
        "base"
    ],
    WC_COINBASE_PAY_SDK_FALLBACK_CHAIN: "ethereum",
    WC_COINBASE_PAY_SDK_CHAIN_NAME_MAP: {
        Ethereum: "ethereum",
        "Arbitrum One": "arbitrum",
        Polygon: "polygon",
        Berachain: "berachain",
        Avalanche: "avalanche-c-chain",
        "OP Mainnet": "optimism",
        Celo: "celo",
        Base: "base"
    },
    WC_COINBASE_ONRAMP_APP_ID: "bf18c88d-495a-463b-b249-0b9d3656cf5e",
    SWAP_SUGGESTED_TOKENS: [
        "ETH",
        "UNI",
        "1INCH",
        "AAVE",
        "SOL",
        "ADA",
        "AVAX",
        "DOT",
        "LINK",
        "NITRO",
        "GAIA",
        "MILK",
        "TRX",
        "NEAR",
        "GNO",
        "WBTC",
        "DAI",
        "WETH",
        "USDC",
        "USDT",
        "ARB",
        "BAL",
        "BICO",
        "CRV",
        "ENS",
        "MATIC",
        "OP"
    ],
    SWAP_POPULAR_TOKENS: [
        "ETH",
        "UNI",
        "1INCH",
        "AAVE",
        "SOL",
        "ADA",
        "AVAX",
        "DOT",
        "LINK",
        "NITRO",
        "GAIA",
        "MILK",
        "TRX",
        "NEAR",
        "GNO",
        "WBTC",
        "DAI",
        "WETH",
        "USDC",
        "USDT",
        "ARB",
        "BAL",
        "BICO",
        "CRV",
        "ENS",
        "MATIC",
        "OP",
        "METAL",
        "DAI",
        "CHAMP",
        "WOLF",
        "SALE",
        "BAL",
        "BUSD",
        "MUST",
        "BTCpx",
        "ROUTE",
        "HEX",
        "WELT",
        "amDAI",
        "VSQ",
        "VISION",
        "AURUM",
        "pSP",
        "SNX",
        "VC",
        "LINK",
        "CHP",
        "amUSDT",
        "SPHERE",
        "FOX",
        "GIDDY",
        "GFC",
        "OMEN",
        "OX_OLD",
        "DE",
        "WNT"
    ],
    BALANCE_SUPPORTED_CHAINS: [
        "eip155",
        "solana"
    ],
    SWAP_SUPPORTED_NETWORKS: [
        // Ethereum'
        "eip155:1",
        // Arbitrum One'
        "eip155:42161",
        // Optimism'
        "eip155:10",
        // ZKSync Era'
        "eip155:324",
        // Base'
        "eip155:8453",
        // BNB Smart Chain'
        "eip155:56",
        // Polygon'
        "eip155:137",
        // Gnosis'
        "eip155:100",
        // Avalanche'
        "eip155:43114",
        // Fantom'
        "eip155:250",
        // Klaytn'
        "eip155:8217",
        // Aurora
        "eip155:1313161554"
    ],
    NAMES_SUPPORTED_CHAIN_NAMESPACES: [
        "eip155"
    ],
    ONRAMP_SUPPORTED_CHAIN_NAMESPACES: [
        "eip155",
        "solana"
    ],
    ACTIVITY_ENABLED_CHAIN_NAMESPACES: [
        "eip155"
    ],
    NATIVE_TOKEN_ADDRESS: {
        eip155: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        solana: "So11111111111111111111111111111111111111111",
        polkadot: "0x",
        bip122: "0x",
        cosmos: "0x"
    },
    CONVERT_SLIPPAGE_TOLERANCE: 1,
    CONNECT_LABELS: {
        MOBILE: "Open and continue in the wallet app",
        WEB: "Open and continue in the wallet app"
    },
    SEND_SUPPORTED_NAMESPACES: [
        "eip155",
        "solana"
    ],
    DEFAULT_REMOTE_FEATURES: {
        swaps: [
            "1inch"
        ],
        onramp: [
            "coinbase",
            "meld"
        ],
        email: true,
        socials: [
            "google",
            "x",
            "discord",
            "farcaster",
            "github",
            "apple",
            "facebook"
        ],
        activity: true,
        reownBranding: true
    },
    DEFAULT_REMOTE_FEATURES_DISABLED: {
        email: false,
        socials: false,
        swaps: false,
        onramp: false,
        activity: false,
        reownBranding: false
    },
    DEFAULT_FEATURES: {
        receive: true,
        send: true,
        emailShowWallets: true,
        connectorTypeOrder: [
            "walletConnect",
            "recent",
            "injected",
            "featured",
            "custom",
            "external",
            "recommended"
        ],
        analytics: true,
        allWallets: true,
        legalCheckbox: false,
        smartSessions: false,
        collapseWallets: false,
        walletFeaturesOrder: [
            "onramp",
            "swaps",
            "receive",
            "send"
        ],
        connectMethodsOrder: undefined,
        pay: false
    },
    DEFAULT_SOCIALS: [
        "google",
        "x",
        "farcaster",
        "discord",
        "apple",
        "github",
        "facebook"
    ],
    DEFAULT_ACCOUNT_TYPES: {
        bip122: "payment",
        eip155: "smartAccount",
        polkadot: "eoa",
        solana: "eoa"
    },
    ADAPTER_TYPES: {
        UNIVERSAL: "universal",
        SOLANA: "solana",
        WAGMI: "wagmi",
        ETHERS: "ethers",
        ETHERS5: "ethers5",
        BITCOIN: "bitcoin"
    }
};

});

parcelRegister("bc5dy", function(module, exports) {

$parcel$export(module.exports, "StorageUtil", () => $8264dcd09bfe742c$export$d4382c6359971b24);
/* eslint-disable no-console */ 
var $eaPAz = parcelRequire("eaPAz");
const $8264dcd09bfe742c$export$d4382c6359971b24 = {
    // Cache expiry in milliseconds
    cacheExpiry: {
        portfolio: 30000,
        nativeBalance: 30000,
        ens: 300000,
        identity: 300000
    },
    isCacheExpired (timestamp, cacheExpiry) {
        return Date.now() - timestamp > cacheExpiry;
    },
    getActiveNetworkProps () {
        const namespace = $8264dcd09bfe742c$export$d4382c6359971b24.getActiveNamespace();
        const caipNetworkId = $8264dcd09bfe742c$export$d4382c6359971b24.getActiveCaipNetworkId();
        const stringChainId = caipNetworkId ? caipNetworkId.split(":")[1] : undefined;
        // eslint-disable-next-line no-nested-ternary
        const chainId = stringChainId ? isNaN(Number(stringChainId)) ? stringChainId : Number(stringChainId) : undefined;
        return {
            namespace: namespace,
            caipNetworkId: caipNetworkId,
            chainId: chainId
        };
    },
    setWalletConnectDeepLink ({ name: name, href: href }) {
        try {
            (0, $eaPAz.SafeLocalStorage).setItem((0, $eaPAz.SafeLocalStorageKeys).DEEPLINK_CHOICE, JSON.stringify({
                href: href,
                name: name
            }));
        } catch  {
            console.info("Unable to set WalletConnect deep link");
        }
    },
    getWalletConnectDeepLink () {
        try {
            const deepLink = (0, $eaPAz.SafeLocalStorage).getItem((0, $eaPAz.SafeLocalStorageKeys).DEEPLINK_CHOICE);
            if (deepLink) return JSON.parse(deepLink);
        } catch  {
            console.info("Unable to get WalletConnect deep link");
        }
        return undefined;
    },
    deleteWalletConnectDeepLink () {
        try {
            (0, $eaPAz.SafeLocalStorage).removeItem((0, $eaPAz.SafeLocalStorageKeys).DEEPLINK_CHOICE);
        } catch  {
            console.info("Unable to delete WalletConnect deep link");
        }
    },
    setActiveNamespace (namespace) {
        try {
            (0, $eaPAz.SafeLocalStorage).setItem((0, $eaPAz.SafeLocalStorageKeys).ACTIVE_NAMESPACE, namespace);
        } catch  {
            console.info("Unable to set active namespace");
        }
    },
    setActiveCaipNetworkId (caipNetworkId) {
        try {
            (0, $eaPAz.SafeLocalStorage).setItem((0, $eaPAz.SafeLocalStorageKeys).ACTIVE_CAIP_NETWORK_ID, caipNetworkId);
            $8264dcd09bfe742c$export$d4382c6359971b24.setActiveNamespace(caipNetworkId.split(":")[0]);
        } catch  {
            console.info("Unable to set active caip network id");
        }
    },
    getActiveCaipNetworkId () {
        try {
            return (0, $eaPAz.SafeLocalStorage).getItem((0, $eaPAz.SafeLocalStorageKeys).ACTIVE_CAIP_NETWORK_ID);
        } catch  {
            console.info("Unable to get active caip network id");
            return undefined;
        }
    },
    deleteActiveCaipNetworkId () {
        try {
            (0, $eaPAz.SafeLocalStorage).removeItem((0, $eaPAz.SafeLocalStorageKeys).ACTIVE_CAIP_NETWORK_ID);
        } catch  {
            console.info("Unable to delete active caip network id");
        }
    },
    deleteConnectedConnectorId (namespace) {
        try {
            const key = (0, $eaPAz.getSafeConnectorIdKey)(namespace);
            (0, $eaPAz.SafeLocalStorage).removeItem(key);
        } catch  {
            console.info("Unable to delete connected connector id");
        }
    },
    setAppKitRecent (wallet) {
        try {
            const recentWallets = $8264dcd09bfe742c$export$d4382c6359971b24.getRecentWallets();
            const exists = recentWallets.find((w)=>w.id === wallet.id);
            if (!exists) {
                recentWallets.unshift(wallet);
                if (recentWallets.length > 2) recentWallets.pop();
                (0, $eaPAz.SafeLocalStorage).setItem((0, $eaPAz.SafeLocalStorageKeys).RECENT_WALLETS, JSON.stringify(recentWallets));
            }
        } catch  {
            console.info("Unable to set AppKit recent");
        }
    },
    getRecentWallets () {
        try {
            const recent = (0, $eaPAz.SafeLocalStorage).getItem((0, $eaPAz.SafeLocalStorageKeys).RECENT_WALLETS);
            return recent ? JSON.parse(recent) : [];
        } catch  {
            console.info("Unable to get AppKit recent");
        }
        return [];
    },
    setConnectedConnectorId (namespace, connectorId) {
        try {
            const key = (0, $eaPAz.getSafeConnectorIdKey)(namespace);
            (0, $eaPAz.SafeLocalStorage).setItem(key, connectorId);
        } catch  {
            console.info("Unable to set Connected Connector Id");
        }
    },
    getActiveNamespace () {
        try {
            const activeNamespace = (0, $eaPAz.SafeLocalStorage).getItem((0, $eaPAz.SafeLocalStorageKeys).ACTIVE_NAMESPACE);
            return activeNamespace;
        } catch  {
            console.info("Unable to get active namespace");
        }
        return undefined;
    },
    getConnectedConnectorId (namespace) {
        if (!namespace) return undefined;
        try {
            const key = (0, $eaPAz.getSafeConnectorIdKey)(namespace);
            return (0, $eaPAz.SafeLocalStorage).getItem(key);
        } catch (e) {
            console.info("Unable to get connected connector id in namespace ", namespace);
        }
        return undefined;
    },
    setConnectedSocialProvider (socialProvider) {
        try {
            (0, $eaPAz.SafeLocalStorage).setItem((0, $eaPAz.SafeLocalStorageKeys).CONNECTED_SOCIAL, socialProvider);
        } catch  {
            console.info("Unable to set connected social provider");
        }
    },
    getConnectedSocialProvider () {
        try {
            return (0, $eaPAz.SafeLocalStorage).getItem((0, $eaPAz.SafeLocalStorageKeys).CONNECTED_SOCIAL);
        } catch  {
            console.info("Unable to get connected social provider");
        }
        return undefined;
    },
    deleteConnectedSocialProvider () {
        try {
            (0, $eaPAz.SafeLocalStorage).removeItem((0, $eaPAz.SafeLocalStorageKeys).CONNECTED_SOCIAL);
        } catch  {
            console.info("Unable to delete connected social provider");
        }
    },
    getConnectedSocialUsername () {
        try {
            return (0, $eaPAz.SafeLocalStorage).getItem((0, $eaPAz.SafeLocalStorageKeys).CONNECTED_SOCIAL_USERNAME);
        } catch  {
            console.info("Unable to get connected social username");
        }
        return undefined;
    },
    getStoredActiveCaipNetworkId () {
        const storedCaipNetworkId = (0, $eaPAz.SafeLocalStorage).getItem((0, $eaPAz.SafeLocalStorageKeys).ACTIVE_CAIP_NETWORK_ID);
        const networkId = storedCaipNetworkId?.split(":")?.[1];
        return networkId;
    },
    setConnectionStatus (status) {
        try {
            (0, $eaPAz.SafeLocalStorage).setItem((0, $eaPAz.SafeLocalStorageKeys).CONNECTION_STATUS, status);
        } catch  {
            console.info("Unable to set connection status");
        }
    },
    getConnectionStatus () {
        try {
            return (0, $eaPAz.SafeLocalStorage).getItem((0, $eaPAz.SafeLocalStorageKeys).CONNECTION_STATUS);
        } catch  {
            return undefined;
        }
    },
    getConnectedNamespaces () {
        try {
            const namespaces = (0, $eaPAz.SafeLocalStorage).getItem((0, $eaPAz.SafeLocalStorageKeys).CONNECTED_NAMESPACES);
            if (!namespaces?.length) return [];
            return namespaces.split(",");
        } catch  {
            return [];
        }
    },
    setConnectedNamespaces (namespaces) {
        try {
            const uniqueNamespaces = Array.from(new Set(namespaces));
            (0, $eaPAz.SafeLocalStorage).setItem((0, $eaPAz.SafeLocalStorageKeys).CONNECTED_NAMESPACES, uniqueNamespaces.join(","));
        } catch  {
            console.info("Unable to set namespaces in storage");
        }
    },
    addConnectedNamespace (namespace) {
        try {
            const namespaces = $8264dcd09bfe742c$export$d4382c6359971b24.getConnectedNamespaces();
            if (!namespaces.includes(namespace)) {
                namespaces.push(namespace);
                $8264dcd09bfe742c$export$d4382c6359971b24.setConnectedNamespaces(namespaces);
            }
        } catch  {
            console.info("Unable to add connected namespace");
        }
    },
    removeConnectedNamespace (namespace) {
        try {
            const namespaces = $8264dcd09bfe742c$export$d4382c6359971b24.getConnectedNamespaces();
            const index = namespaces.indexOf(namespace);
            if (index > -1) {
                namespaces.splice(index, 1);
                $8264dcd09bfe742c$export$d4382c6359971b24.setConnectedNamespaces(namespaces);
            }
        } catch  {
            console.info("Unable to remove connected namespace");
        }
    },
    getTelegramSocialProvider () {
        try {
            return (0, $eaPAz.SafeLocalStorage).getItem((0, $eaPAz.SafeLocalStorageKeys).TELEGRAM_SOCIAL_PROVIDER);
        } catch  {
            console.info("Unable to get telegram social provider");
            return null;
        }
    },
    setTelegramSocialProvider (socialProvider) {
        try {
            (0, $eaPAz.SafeLocalStorage).setItem((0, $eaPAz.SafeLocalStorageKeys).TELEGRAM_SOCIAL_PROVIDER, socialProvider);
        } catch  {
            console.info("Unable to set telegram social provider");
        }
    },
    removeTelegramSocialProvider () {
        try {
            (0, $eaPAz.SafeLocalStorage).removeItem((0, $eaPAz.SafeLocalStorageKeys).TELEGRAM_SOCIAL_PROVIDER);
        } catch  {
            console.info("Unable to remove telegram social provider");
        }
    },
    getBalanceCache () {
        let cache = {};
        try {
            const result = (0, $eaPAz.SafeLocalStorage).getItem((0, $eaPAz.SafeLocalStorageKeys).PORTFOLIO_CACHE);
            cache = result ? JSON.parse(result) : {};
        } catch  {
            console.info("Unable to get balance cache");
        }
        return cache;
    },
    removeAddressFromBalanceCache (caipAddress) {
        try {
            const cache = $8264dcd09bfe742c$export$d4382c6359971b24.getBalanceCache();
            (0, $eaPAz.SafeLocalStorage).setItem((0, $eaPAz.SafeLocalStorageKeys).PORTFOLIO_CACHE, JSON.stringify({
                ...cache,
                [caipAddress]: undefined
            }));
        } catch  {
            console.info("Unable to remove address from balance cache", caipAddress);
        }
    },
    getBalanceCacheForCaipAddress (caipAddress) {
        try {
            const cache = $8264dcd09bfe742c$export$d4382c6359971b24.getBalanceCache();
            const balanceCache = cache[caipAddress];
            // We want to discard cache if it's older than the cache expiry
            if (balanceCache && !this.isCacheExpired(balanceCache.timestamp, this.cacheExpiry.portfolio)) return balanceCache.balance;
            $8264dcd09bfe742c$export$d4382c6359971b24.removeAddressFromBalanceCache(caipAddress);
        } catch  {
            console.info("Unable to get balance cache for address", caipAddress);
        }
        return undefined;
    },
    updateBalanceCache (params) {
        try {
            const cache = $8264dcd09bfe742c$export$d4382c6359971b24.getBalanceCache();
            cache[params.caipAddress] = params;
            (0, $eaPAz.SafeLocalStorage).setItem((0, $eaPAz.SafeLocalStorageKeys).PORTFOLIO_CACHE, JSON.stringify(cache));
        } catch  {
            console.info("Unable to update balance cache", params);
        }
    },
    getNativeBalanceCache () {
        let cache = {};
        try {
            const result = (0, $eaPAz.SafeLocalStorage).getItem((0, $eaPAz.SafeLocalStorageKeys).NATIVE_BALANCE_CACHE);
            cache = result ? JSON.parse(result) : {};
        } catch  {
            console.info("Unable to get balance cache");
        }
        return cache;
    },
    removeAddressFromNativeBalanceCache (caipAddress) {
        try {
            const cache = $8264dcd09bfe742c$export$d4382c6359971b24.getBalanceCache();
            (0, $eaPAz.SafeLocalStorage).setItem((0, $eaPAz.SafeLocalStorageKeys).NATIVE_BALANCE_CACHE, JSON.stringify({
                ...cache,
                [caipAddress]: undefined
            }));
        } catch  {
            console.info("Unable to remove address from balance cache", caipAddress);
        }
    },
    getNativeBalanceCacheForCaipAddress (caipAddress) {
        try {
            const cache = $8264dcd09bfe742c$export$d4382c6359971b24.getNativeBalanceCache();
            const nativeBalanceCache = cache[caipAddress];
            // We want to discard cache if it's older than the cache expiry
            if (nativeBalanceCache && !this.isCacheExpired(nativeBalanceCache.timestamp, this.cacheExpiry.nativeBalance)) return nativeBalanceCache;
            console.info("Discarding cache for address", caipAddress);
            $8264dcd09bfe742c$export$d4382c6359971b24.removeAddressFromBalanceCache(caipAddress);
        } catch  {
            console.info("Unable to get balance cache for address", caipAddress);
        }
        return undefined;
    },
    updateNativeBalanceCache (params) {
        try {
            const cache = $8264dcd09bfe742c$export$d4382c6359971b24.getNativeBalanceCache();
            cache[params.caipAddress] = params;
            (0, $eaPAz.SafeLocalStorage).setItem((0, $eaPAz.SafeLocalStorageKeys).NATIVE_BALANCE_CACHE, JSON.stringify(cache));
        } catch  {
            console.info("Unable to update balance cache", params);
        }
    },
    getEnsCache () {
        let cache = {};
        try {
            const result = (0, $eaPAz.SafeLocalStorage).getItem((0, $eaPAz.SafeLocalStorageKeys).ENS_CACHE);
            cache = result ? JSON.parse(result) : {};
        } catch  {
            console.info("Unable to get ens name cache");
        }
        return cache;
    },
    getEnsFromCacheForAddress (address) {
        try {
            const cache = $8264dcd09bfe742c$export$d4382c6359971b24.getEnsCache();
            const ensCache = cache[address];
            // We want to discard cache if it's older than the cache expiry
            if (ensCache && !this.isCacheExpired(ensCache.timestamp, this.cacheExpiry.ens)) return ensCache.ens;
            $8264dcd09bfe742c$export$d4382c6359971b24.removeEnsFromCache(address);
        } catch  {
            console.info("Unable to get ens name from cache", address);
        }
        return undefined;
    },
    updateEnsCache (params) {
        try {
            const cache = $8264dcd09bfe742c$export$d4382c6359971b24.getEnsCache();
            cache[params.address] = params;
            (0, $eaPAz.SafeLocalStorage).setItem((0, $eaPAz.SafeLocalStorageKeys).ENS_CACHE, JSON.stringify(cache));
        } catch  {
            console.info("Unable to update ens name cache", params);
        }
    },
    removeEnsFromCache (address) {
        try {
            const cache = $8264dcd09bfe742c$export$d4382c6359971b24.getEnsCache();
            (0, $eaPAz.SafeLocalStorage).setItem((0, $eaPAz.SafeLocalStorageKeys).ENS_CACHE, JSON.stringify({
                ...cache,
                [address]: undefined
            }));
        } catch  {
            console.info("Unable to remove ens name from cache", address);
        }
    },
    getIdentityCache () {
        let cache = {};
        try {
            const result = (0, $eaPAz.SafeLocalStorage).getItem((0, $eaPAz.SafeLocalStorageKeys).IDENTITY_CACHE);
            cache = result ? JSON.parse(result) : {};
        } catch  {
            console.info("Unable to get identity cache");
        }
        return cache;
    },
    getIdentityFromCacheForAddress (address) {
        try {
            const cache = $8264dcd09bfe742c$export$d4382c6359971b24.getIdentityCache();
            const identityCache = cache[address];
            // We want to discard cache if it's older than the cache expiry
            if (identityCache && !this.isCacheExpired(identityCache.timestamp, this.cacheExpiry.identity)) return identityCache.identity;
            $8264dcd09bfe742c$export$d4382c6359971b24.removeIdentityFromCache(address);
        } catch  {
            console.info("Unable to get identity from cache", address);
        }
        return undefined;
    },
    updateIdentityCache (params) {
        try {
            const cache = $8264dcd09bfe742c$export$d4382c6359971b24.getIdentityCache();
            cache[params.address] = {
                identity: params.identity,
                timestamp: params.timestamp
            };
            (0, $eaPAz.SafeLocalStorage).setItem((0, $eaPAz.SafeLocalStorageKeys).IDENTITY_CACHE, JSON.stringify(cache));
        } catch  {
            console.info("Unable to update identity cache", params);
        }
    },
    removeIdentityFromCache (address) {
        try {
            const cache = $8264dcd09bfe742c$export$d4382c6359971b24.getIdentityCache();
            (0, $eaPAz.SafeLocalStorage).setItem((0, $eaPAz.SafeLocalStorageKeys).IDENTITY_CACHE, JSON.stringify({
                ...cache,
                [address]: undefined
            }));
        } catch  {
            console.info("Unable to remove identity from cache", address);
        }
    },
    clearAddressCache () {
        try {
            (0, $eaPAz.SafeLocalStorage).removeItem((0, $eaPAz.SafeLocalStorageKeys).PORTFOLIO_CACHE);
            (0, $eaPAz.SafeLocalStorage).removeItem((0, $eaPAz.SafeLocalStorageKeys).NATIVE_BALANCE_CACHE);
            (0, $eaPAz.SafeLocalStorage).removeItem((0, $eaPAz.SafeLocalStorageKeys).ENS_CACHE);
            (0, $eaPAz.SafeLocalStorage).removeItem((0, $eaPAz.SafeLocalStorageKeys).IDENTITY_CACHE);
        } catch  {
            console.info("Unable to clear address cache");
        }
    },
    setPreferredAccountTypes (accountTypes) {
        try {
            (0, $eaPAz.SafeLocalStorage).setItem((0, $eaPAz.SafeLocalStorageKeys).PREFERRED_ACCOUNT_TYPES, JSON.stringify(accountTypes));
        } catch  {
            console.info("Unable to set preferred account types", accountTypes);
        }
    },
    getPreferredAccountTypes () {
        try {
            const result = (0, $eaPAz.SafeLocalStorage).getItem((0, $eaPAz.SafeLocalStorageKeys).PREFERRED_ACCOUNT_TYPES);
            if (!result) return {};
            return JSON.parse(result);
        } catch  {
            console.info("Unable to get preferred account types");
        }
        return {};
    },
    setConnections (connections, chainNamespace) {
        try {
            const newConnections = {
                ...$8264dcd09bfe742c$export$d4382c6359971b24.getConnections(),
                [chainNamespace]: connections
            };
            (0, $eaPAz.SafeLocalStorage).setItem((0, $eaPAz.SafeLocalStorageKeys).CONNECTIONS, JSON.stringify(newConnections));
        } catch (error) {
            console.error("Unable to sync connections to storage", error);
        }
    },
    getConnections () {
        try {
            const connectionsStorage = (0, $eaPAz.SafeLocalStorage).getItem((0, $eaPAz.SafeLocalStorageKeys).CONNECTIONS);
            if (!connectionsStorage) return {};
            return JSON.parse(connectionsStorage);
        } catch (error) {
            console.error("Unable to get connections from storage", error);
            return {};
        }
    }
};

});
parcelRegister("eaPAz", function(module, exports) {

$parcel$export(module.exports, "SafeLocalStorageKeys", () => $a51a045262c2b417$export$f45bfaaf0fe93ad2);
$parcel$export(module.exports, "getSafeConnectorIdKey", () => $a51a045262c2b417$export$7865287674725e0f);
$parcel$export(module.exports, "SafeLocalStorage", () => $a51a045262c2b417$export$a229b0e0e51a1f62);
$parcel$export(module.exports, "isSafe", () => $a51a045262c2b417$export$26e0721b40973527);
const $a51a045262c2b417$export$f45bfaaf0fe93ad2 = {
    WALLET_ID: "@appkit/wallet_id",
    WALLET_NAME: "@appkit/wallet_name",
    SOLANA_WALLET: "@appkit/solana_wallet",
    SOLANA_CAIP_CHAIN: "@appkit/solana_caip_chain",
    ACTIVE_CAIP_NETWORK_ID: "@appkit/active_caip_network_id",
    CONNECTED_SOCIAL: "@appkit/connected_social",
    CONNECTED_SOCIAL_USERNAME: "@appkit-wallet/SOCIAL_USERNAME",
    RECENT_WALLETS: "@appkit/recent_wallets",
    DEEPLINK_CHOICE: "WALLETCONNECT_DEEPLINK_CHOICE",
    ACTIVE_NAMESPACE: "@appkit/active_namespace",
    CONNECTED_NAMESPACES: "@appkit/connected_namespaces",
    CONNECTION_STATUS: "@appkit/connection_status",
    SIWX_AUTH_TOKEN: "@appkit/siwx-auth-token",
    SIWX_NONCE_TOKEN: "@appkit/siwx-nonce-token",
    TELEGRAM_SOCIAL_PROVIDER: "@appkit/social_provider",
    NATIVE_BALANCE_CACHE: "@appkit/native_balance_cache",
    PORTFOLIO_CACHE: "@appkit/portfolio_cache",
    ENS_CACHE: "@appkit/ens_cache",
    IDENTITY_CACHE: "@appkit/identity_cache",
    PREFERRED_ACCOUNT_TYPES: "@appkit/preferred_account_types",
    CONNECTIONS: "@appkit/connections"
};
function $a51a045262c2b417$export$7865287674725e0f(namespace) {
    if (!namespace) throw new Error("Namespace is required for CONNECTED_CONNECTOR_ID");
    return `@appkit/${namespace}:connected_connector_id`;
}
const $a51a045262c2b417$export$a229b0e0e51a1f62 = {
    setItem (key, value) {
        if ($a51a045262c2b417$export$26e0721b40973527() && value !== undefined) localStorage.setItem(key, value);
    },
    getItem (key) {
        if ($a51a045262c2b417$export$26e0721b40973527()) return localStorage.getItem(key) || undefined;
        return undefined;
    },
    removeItem (key) {
        if ($a51a045262c2b417$export$26e0721b40973527()) localStorage.removeItem(key);
    },
    clear () {
        if ($a51a045262c2b417$export$26e0721b40973527()) localStorage.clear();
    }
};
function $a51a045262c2b417$export$26e0721b40973527() {
    return typeof window !== "undefined" && typeof localStorage !== "undefined";
}

});



parcelRegister("8hHqr", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $608198ad3de3097e$export$306c0aa65ff9ec16, (v) => $608198ad3de3097e$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $608198ad3de3097e$export$306c0aa65ff9ec16;
"use strict";

var $tZqWC = parcelRequire("tZqWC");
function $608198ad3de3097e$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $608198ad3de3097e$var$k = "function" === typeof Object.is ? Object.is : $608198ad3de3097e$var$h, $608198ad3de3097e$var$l = $tZqWC.useState, $608198ad3de3097e$var$m = $tZqWC.useEffect, $608198ad3de3097e$var$n = $tZqWC.useLayoutEffect, $608198ad3de3097e$var$p = $tZqWC.useDebugValue;
function $608198ad3de3097e$var$q(a, b) {
    var d = b(), f = $608198ad3de3097e$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $608198ad3de3097e$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $608198ad3de3097e$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $608198ad3de3097e$var$m(function() {
        $608198ad3de3097e$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $608198ad3de3097e$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $608198ad3de3097e$var$p(d);
    return d;
}
function $608198ad3de3097e$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$608198ad3de3097e$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $608198ad3de3097e$var$t(a, b) {
    return b();
}
var $608198ad3de3097e$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $608198ad3de3097e$var$t : $608198ad3de3097e$var$q;
$608198ad3de3097e$export$306c0aa65ff9ec16 = void 0 !== $tZqWC.useSyncExternalStore ? $tZqWC.useSyncExternalStore : $608198ad3de3097e$var$u;

});

parcelRegister("7zrdF", function(module, exports) {

$parcel$export(module.exports, "proxy", () => $2d1edcc3592c62fe$export$923f96dd5afa9ce6);
$parcel$export(module.exports, "getVersion", () => $2d1edcc3592c62fe$export$c506eb22e615ba4a);
$parcel$export(module.exports, "subscribe", () => $2d1edcc3592c62fe$export$ec068583843480e7);
$parcel$export(module.exports, "snapshot", () => $2d1edcc3592c62fe$export$b8801ea43165ed7d);
$parcel$export(module.exports, "ref", () => $2d1edcc3592c62fe$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "unstable_buildProxyFunction", () => $2d1edcc3592c62fe$export$e7b04d37d9502758);

var $8VYnW = parcelRequire("8VYnW");
var $2d1edcc3592c62fe$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/valtio/esm/vanilla.mjs"
});
const $2d1edcc3592c62fe$var$isObject = (x)=>typeof x === "object" && x !== null;
const $2d1edcc3592c62fe$var$proxyStateMap = /* @__PURE__ */ new WeakMap();
const $2d1edcc3592c62fe$var$refSet = /* @__PURE__ */ new WeakSet();
const $2d1edcc3592c62fe$var$buildProxyFunction = (objectIs = Object.is, newProxy = (target, handler)=>new Proxy(target, handler), canProxy = (x)=>$2d1edcc3592c62fe$var$isObject(x) && !$2d1edcc3592c62fe$var$refSet.has(x) && (Array.isArray(x) || !(Symbol.iterator in x)) && !(x instanceof WeakMap) && !(x instanceof WeakSet) && !(x instanceof Error) && !(x instanceof Number) && !(x instanceof Date) && !(x instanceof String) && !(x instanceof RegExp) && !(x instanceof ArrayBuffer), defaultHandlePromise = (promise)=>{
    switch(promise.status){
        case "fulfilled":
            return promise.value;
        case "rejected":
            throw promise.reason;
        default:
            throw promise;
    }
}, snapCache = /* @__PURE__ */ new WeakMap(), createSnapshot = (target, version, handlePromise = defaultHandlePromise)=>{
    const cache = snapCache.get(target);
    if ((cache == null ? void 0 : cache[0]) === version) return cache[1];
    const snap = Array.isArray(target) ? [] : Object.create(Object.getPrototypeOf(target));
    (0, $8VYnW.markToTrack)(snap, true);
    snapCache.set(target, [
        version,
        snap
    ]);
    Reflect.ownKeys(target).forEach((key)=>{
        if (Object.getOwnPropertyDescriptor(snap, key)) return;
        const value = Reflect.get(target, key);
        const { enumerable: enumerable } = Reflect.getOwnPropertyDescriptor(target, key);
        const desc = {
            value: value,
            enumerable: enumerable,
            // This is intentional to avoid copying with proxy-compare.
            // It's still non-writable, so it avoids assigning a value.
            configurable: true
        };
        if ($2d1edcc3592c62fe$var$refSet.has(value)) (0, $8VYnW.markToTrack)(value, false);
        else if (value instanceof Promise) {
            delete desc.value;
            desc.get = ()=>handlePromise(value);
        } else if ($2d1edcc3592c62fe$var$proxyStateMap.has(value)) {
            const [target2, ensureVersion] = $2d1edcc3592c62fe$var$proxyStateMap.get(value);
            desc.value = createSnapshot(target2, ensureVersion(), handlePromise);
        }
        Object.defineProperty(snap, key, desc);
    });
    return Object.preventExtensions(snap);
}, proxyCache = /* @__PURE__ */ new WeakMap(), versionHolder = [
    1,
    1
], proxyFunction = (initialObject)=>{
    if (!$2d1edcc3592c62fe$var$isObject(initialObject)) throw new Error("object required");
    const found = proxyCache.get(initialObject);
    if (found) return found;
    let version = versionHolder[0];
    const listeners = /* @__PURE__ */ new Set();
    const notifyUpdate = (op, nextVersion = ++versionHolder[0])=>{
        if (version !== nextVersion) {
            version = nextVersion;
            listeners.forEach((listener)=>listener(op, nextVersion));
        }
    };
    let checkVersion = versionHolder[1];
    const ensureVersion = (nextCheckVersion = ++versionHolder[1])=>{
        if (checkVersion !== nextCheckVersion && !listeners.size) {
            checkVersion = nextCheckVersion;
            propProxyStates.forEach(([propProxyState])=>{
                const propVersion = propProxyState[1](nextCheckVersion);
                if (propVersion > version) version = propVersion;
            });
        }
        return version;
    };
    const createPropListener = (prop)=>(op, nextVersion)=>{
            const newOp = [
                ...op
            ];
            newOp[1] = [
                prop,
                ...newOp[1]
            ];
            notifyUpdate(newOp, nextVersion);
        };
    const propProxyStates = /* @__PURE__ */ new Map();
    const addPropListener = (prop, propProxyState)=>{
        if (($2d1edcc3592c62fe$import_meta.env ? $2d1edcc3592c62fe$import_meta.env.MODE : void 0) !== "production" && propProxyStates.has(prop)) throw new Error("prop listener already exists");
        if (listeners.size) {
            const remove = propProxyState[3](createPropListener(prop));
            propProxyStates.set(prop, [
                propProxyState,
                remove
            ]);
        } else propProxyStates.set(prop, [
            propProxyState
        ]);
    };
    const removePropListener = (prop)=>{
        var _a;
        const entry = propProxyStates.get(prop);
        if (entry) {
            propProxyStates.delete(prop);
            (_a = entry[1]) == null || _a.call(entry);
        }
    };
    const addListener = (listener)=>{
        listeners.add(listener);
        if (listeners.size === 1) propProxyStates.forEach(([propProxyState, prevRemove], prop)=>{
            if (($2d1edcc3592c62fe$import_meta.env ? $2d1edcc3592c62fe$import_meta.env.MODE : void 0) !== "production" && prevRemove) throw new Error("remove already exists");
            const remove = propProxyState[3](createPropListener(prop));
            propProxyStates.set(prop, [
                propProxyState,
                remove
            ]);
        });
        const removeListener = ()=>{
            listeners.delete(listener);
            if (listeners.size === 0) propProxyStates.forEach(([propProxyState, remove], prop)=>{
                if (remove) {
                    remove();
                    propProxyStates.set(prop, [
                        propProxyState
                    ]);
                }
            });
        };
        return removeListener;
    };
    const baseObject = Array.isArray(initialObject) ? [] : Object.create(Object.getPrototypeOf(initialObject));
    const handler = {
        deleteProperty (target, prop) {
            const prevValue = Reflect.get(target, prop);
            removePropListener(prop);
            const deleted = Reflect.deleteProperty(target, prop);
            if (deleted) notifyUpdate([
                "delete",
                [
                    prop
                ],
                prevValue
            ]);
            return deleted;
        },
        set (target, prop, value, receiver) {
            const hasPrevValue = Reflect.has(target, prop);
            const prevValue = Reflect.get(target, prop, receiver);
            if (hasPrevValue && (objectIs(prevValue, value) || proxyCache.has(value) && objectIs(prevValue, proxyCache.get(value)))) return true;
            removePropListener(prop);
            if ($2d1edcc3592c62fe$var$isObject(value)) value = (0, $8VYnW.getUntracked)(value) || value;
            let nextValue = value;
            if (value instanceof Promise) value.then((v)=>{
                value.status = "fulfilled";
                value.value = v;
                notifyUpdate([
                    "resolve",
                    [
                        prop
                    ],
                    v
                ]);
            }).catch((e)=>{
                value.status = "rejected";
                value.reason = e;
                notifyUpdate([
                    "reject",
                    [
                        prop
                    ],
                    e
                ]);
            });
            else {
                if (!$2d1edcc3592c62fe$var$proxyStateMap.has(value) && canProxy(value)) nextValue = proxyFunction(value);
                const childProxyState = !$2d1edcc3592c62fe$var$refSet.has(nextValue) && $2d1edcc3592c62fe$var$proxyStateMap.get(nextValue);
                if (childProxyState) addPropListener(prop, childProxyState);
            }
            Reflect.set(target, prop, nextValue, receiver);
            notifyUpdate([
                "set",
                [
                    prop
                ],
                value,
                prevValue
            ]);
            return true;
        }
    };
    const proxyObject = newProxy(baseObject, handler);
    proxyCache.set(initialObject, proxyObject);
    const proxyState = [
        baseObject,
        ensureVersion,
        createSnapshot,
        addListener
    ];
    $2d1edcc3592c62fe$var$proxyStateMap.set(proxyObject, proxyState);
    Reflect.ownKeys(initialObject).forEach((key)=>{
        const desc = Object.getOwnPropertyDescriptor(initialObject, key);
        if ("value" in desc) {
            proxyObject[key] = initialObject[key];
            delete desc.value;
            delete desc.writable;
        }
        Object.defineProperty(baseObject, key, desc);
    });
    return proxyObject;
})=>[
        // public functions
        proxyFunction,
        // shared state
        $2d1edcc3592c62fe$var$proxyStateMap,
        $2d1edcc3592c62fe$var$refSet,
        // internal things
        objectIs,
        newProxy,
        canProxy,
        defaultHandlePromise,
        snapCache,
        createSnapshot,
        proxyCache,
        versionHolder
    ];
const [$2d1edcc3592c62fe$var$defaultProxyFunction] = $2d1edcc3592c62fe$var$buildProxyFunction();
function $2d1edcc3592c62fe$export$923f96dd5afa9ce6(initialObject = {}) {
    return $2d1edcc3592c62fe$var$defaultProxyFunction(initialObject);
}
function $2d1edcc3592c62fe$export$c506eb22e615ba4a(proxyObject) {
    const proxyState = $2d1edcc3592c62fe$var$proxyStateMap.get(proxyObject);
    return proxyState == null ? void 0 : proxyState[1]();
}
function $2d1edcc3592c62fe$export$ec068583843480e7(proxyObject, callback, notifyInSync) {
    const proxyState = $2d1edcc3592c62fe$var$proxyStateMap.get(proxyObject);
    if (($2d1edcc3592c62fe$import_meta.env ? $2d1edcc3592c62fe$import_meta.env.MODE : void 0) !== "production" && !proxyState) console.warn("Please use proxy object");
    let promise;
    const ops = [];
    const addListener = proxyState[3];
    let isListenerActive = false;
    const listener = (op)=>{
        ops.push(op);
        if (notifyInSync) {
            callback(ops.splice(0));
            return;
        }
        if (!promise) promise = Promise.resolve().then(()=>{
            promise = void 0;
            if (isListenerActive) callback(ops.splice(0));
        });
    };
    const removeListener = addListener(listener);
    isListenerActive = true;
    return ()=>{
        isListenerActive = false;
        removeListener();
    };
}
function $2d1edcc3592c62fe$export$b8801ea43165ed7d(proxyObject, handlePromise) {
    const proxyState = $2d1edcc3592c62fe$var$proxyStateMap.get(proxyObject);
    if (($2d1edcc3592c62fe$import_meta.env ? $2d1edcc3592c62fe$import_meta.env.MODE : void 0) !== "production" && !proxyState) console.warn("Please use proxy object");
    const [target, ensureVersion, createSnapshot] = proxyState;
    return createSnapshot(target, ensureVersion(), handlePromise);
}
function $2d1edcc3592c62fe$export$eff4d24c3ff7876e(obj) {
    $2d1edcc3592c62fe$var$refSet.add(obj);
    return obj;
}
const $2d1edcc3592c62fe$export$e7b04d37d9502758 = $2d1edcc3592c62fe$var$buildProxyFunction;

});
parcelRegister("8VYnW", function(module, exports) {

$parcel$export(module.exports, "createProxy", () => $68127cd540a0a37a$export$7865d0c7f908de6b);
$parcel$export(module.exports, "isChanged", () => $68127cd540a0a37a$export$3a85b3f4caf02b6f);
$parcel$export(module.exports, "getUntracked", () => $68127cd540a0a37a$export$80d2cee7ee556e99);
$parcel$export(module.exports, "markToTrack", () => $68127cd540a0a37a$export$2c8383c890e26a1c);
$parcel$export(module.exports, "affectedToPathList", () => $68127cd540a0a37a$export$10e85fc10e680a16);
const $68127cd540a0a37a$var$e = Symbol(), $68127cd540a0a37a$var$t = Symbol(), $68127cd540a0a37a$var$r = "a", $68127cd540a0a37a$var$n = "w";
let $68127cd540a0a37a$var$o = (e, t)=>new Proxy(e, t);
const $68127cd540a0a37a$var$s = Object.getPrototypeOf, $68127cd540a0a37a$var$c = new WeakMap, $68127cd540a0a37a$var$l = (e)=>e && ($68127cd540a0a37a$var$c.has(e) ? $68127cd540a0a37a$var$c.get(e) : $68127cd540a0a37a$var$s(e) === Object.prototype || $68127cd540a0a37a$var$s(e) === Array.prototype), $68127cd540a0a37a$var$f = (e)=>"object" == typeof e && null !== e, $68127cd540a0a37a$var$i = (e)=>{
    if (Array.isArray(e)) return Array.from(e);
    const t = Object.getOwnPropertyDescriptors(e);
    return Object.values(t).forEach((e)=>{
        e.configurable = !0;
    }), Object.create($68127cd540a0a37a$var$s(e), t);
}, $68127cd540a0a37a$var$u = (e)=>e[$68127cd540a0a37a$var$t] || e, $68127cd540a0a37a$export$7865d0c7f908de6b = (s, c, f, p)=>{
    if (!$68127cd540a0a37a$var$l(s)) return s;
    let g = p && p.get(s);
    if (!g) {
        const e = $68127cd540a0a37a$var$u(s);
        g = ((e)=>Object.values(Object.getOwnPropertyDescriptors(e)).some((e)=>!e.configurable && !e.writable))(e) ? [
            e,
            $68127cd540a0a37a$var$i(e)
        ] : [
            e
        ], null == p || p.set(s, g);
    }
    const [y, h] = g;
    let w = f && f.get(y);
    return w && w[1].f === !!h || (w = ((o, s)=>{
        const c = {
            f: s
        };
        let l = !1;
        const f = (e, t)=>{
            if (!l) {
                let s = c[$68127cd540a0a37a$var$r].get(o);
                if (s || (s = {}, c[$68127cd540a0a37a$var$r].set(o, s)), e === $68127cd540a0a37a$var$n) s[$68127cd540a0a37a$var$n] = !0;
                else {
                    let r = s[e];
                    r || (r = new Set, s[e] = r), r.add(t);
                }
            }
        }, i = {
            get: (e, n)=>n === $68127cd540a0a37a$var$t ? o : (f("k", n), $68127cd540a0a37a$export$7865d0c7f908de6b(Reflect.get(e, n), c[$68127cd540a0a37a$var$r], c.c, c.t)),
            has: (t, n)=>n === $68127cd540a0a37a$var$e ? (l = !0, c[$68127cd540a0a37a$var$r].delete(o), !0) : (f("h", n), Reflect.has(t, n)),
            getOwnPropertyDescriptor: (e, t)=>(f("o", t), Reflect.getOwnPropertyDescriptor(e, t)),
            ownKeys: (e)=>(f($68127cd540a0a37a$var$n), Reflect.ownKeys(e))
        };
        return s && (i.set = i.deleteProperty = ()=>!1), [
            i,
            c
        ];
    })(y, !!h), w[1].p = $68127cd540a0a37a$var$o(h || y, w[0]), f && f.set(y, w)), w[1][$68127cd540a0a37a$var$r] = c, w[1].c = f, w[1].t = p, w[1].p;
}, $68127cd540a0a37a$export$3a85b3f4caf02b6f = (e, t, r, o, s = Object.is)=>{
    if (s(e, t)) return !1;
    if (!$68127cd540a0a37a$var$f(e) || !$68127cd540a0a37a$var$f(t)) return !0;
    const c = r.get($68127cd540a0a37a$var$u(e));
    if (!c) return !0;
    if (o) {
        const r = o.get(e);
        if (r && r.n === t) return r.g;
        o.set(e, {
            n: t,
            g: !1
        });
    }
    let l = null;
    try {
        for (const r of c.h || [])if (l = Reflect.has(e, r) !== Reflect.has(t, r), l) return l;
        if (!0 === c[$68127cd540a0a37a$var$n]) {
            if (l = ((e, t)=>{
                const r = Reflect.ownKeys(e), n = Reflect.ownKeys(t);
                return r.length !== n.length || r.some((e, t)=>e !== n[t]);
            })(e, t), l) return l;
        } else for (const r of c.o || [])if (l = !!Reflect.getOwnPropertyDescriptor(e, r) != !!Reflect.getOwnPropertyDescriptor(t, r), l) return l;
        for (const n of c.k || [])if (l = $68127cd540a0a37a$export$3a85b3f4caf02b6f(e[n], t[n], r, o, s), l) return l;
        return null === l && (l = !0), l;
    } finally{
        o && o.set(e, {
            n: t,
            g: l
        });
    }
}, $68127cd540a0a37a$export$badc26589cf7bb38 = (t)=>!!$68127cd540a0a37a$var$l(t) && $68127cd540a0a37a$var$e in t, $68127cd540a0a37a$export$80d2cee7ee556e99 = (e)=>$68127cd540a0a37a$var$l(e) && e[$68127cd540a0a37a$var$t] || null, $68127cd540a0a37a$export$2c8383c890e26a1c = (e, t = !0)=>{
    $68127cd540a0a37a$var$c.set(e, t);
}, $68127cd540a0a37a$export$10e85fc10e680a16 = (e, t, r)=>{
    const o = [], s = new WeakSet, c = (e, l)=>{
        if (s.has(e)) return;
        $68127cd540a0a37a$var$f(e) && s.add(e);
        const i = $68127cd540a0a37a$var$f(e) && t.get($68127cd540a0a37a$var$u(e));
        if (i) {
            var a, p;
            if (null == (a = i.h) || a.forEach((e)=>{
                const t = `:has(${String(e)})`;
                o.push(l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            }), !0 === i[$68127cd540a0a37a$var$n]) {
                const e = ":ownKeys";
                o.push(l ? [
                    ...l,
                    e
                ] : [
                    e
                ]);
            } else {
                var g;
                null == (g = i.o) || g.forEach((e)=>{
                    const t = `:hasOwn(${String(e)})`;
                    o.push(l ? [
                        ...l,
                        t
                    ] : [
                        t
                    ]);
                });
            }
            null == (p = i.k) || p.forEach((t)=>{
                r && !("value" in (Object.getOwnPropertyDescriptor(e, t) || {})) || c(e[t], l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            });
        } else l && o.push(l);
    };
    return c(e), o;
}, $68127cd540a0a37a$export$9b4d5450dbd8e67e = (e)=>{
    $68127cd540a0a37a$var$o = e;
};

});


parcelRegister("gD0RX", function(module, exports) {

$parcel$export(module.exports, "ChainController", () => $c1b0f67bff3c0936$export$fbf61adcac1da229);

var $7zrdF = parcelRequire("7zrdF");

var $eFS1l = parcelRequire("eFS1l");

var $b3v9s = parcelRequire("b3v9s");
var $dawjb = parcelRequire("dawjb");

var $bzYsu = parcelRequire("bzYsu");

var $3h0dG = parcelRequire("3h0dG");

var $lpmCO = parcelRequire("lpmCO");

var $bc5dy = parcelRequire("bc5dy");

var $lCKEr = parcelRequire("lCKEr");

var $kfwQH = parcelRequire("kfwQH");

var $efZLi = parcelRequire("efZLi");

var $58cAm = parcelRequire("58cAm");

var $5FNhR = parcelRequire("5FNhR");

var $6aBkR = parcelRequire("6aBkR");

var $knC5d = parcelRequire("knC5d");

var $1dM5v = parcelRequire("1dM5v");

var $aZ8hw = parcelRequire("aZ8hw");

var $vRYB3 = parcelRequire("vRYB3");
// -- Constants ----------------------------------------- //
const $c1b0f67bff3c0936$var$accountState = {
    currentTab: 0,
    tokenBalance: [],
    smartAccountDeployed: false,
    addressLabels: new Map(),
    allAccounts: [],
    user: undefined
};
const $c1b0f67bff3c0936$var$networkState = {
    caipNetwork: undefined,
    supportsAllNetworks: true,
    smartAccountEnabledNetworks: []
};
// -- State --------------------------------------------- //
const $c1b0f67bff3c0936$var$state = (0, $7zrdF.proxy)({
    chains: (0, $eFS1l.proxyMap)(),
    activeCaipAddress: undefined,
    activeChain: undefined,
    activeCaipNetwork: undefined,
    noAdapters: false,
    universalAdapter: {
        networkControllerClient: undefined,
        connectionControllerClient: undefined
    },
    isSwitchingNamespace: false
});
// -- Controller ---------------------------------------- //
const $c1b0f67bff3c0936$var$controller = {
    state: $c1b0f67bff3c0936$var$state,
    subscribe (callback) {
        return (0, $7zrdF.subscribe)($c1b0f67bff3c0936$var$state, ()=>{
            callback($c1b0f67bff3c0936$var$state);
        });
    },
    subscribeKey (key, callback) {
        return (0, $eFS1l.subscribeKey)($c1b0f67bff3c0936$var$state, key, callback);
    },
    subscribeChainProp (property, callback, chain) {
        let prev = undefined;
        return (0, $7zrdF.subscribe)($c1b0f67bff3c0936$var$state.chains, ()=>{
            const activeChain = chain || $c1b0f67bff3c0936$var$state.activeChain;
            if (activeChain) {
                const nextValue = $c1b0f67bff3c0936$var$state.chains.get(activeChain)?.[property];
                if (prev !== nextValue) {
                    prev = nextValue;
                    callback(nextValue);
                }
            }
        });
    },
    initialize (adapters, caipNetworks, clients) {
        const { chainId: activeChainId, namespace: activeNamespace } = (0, $bc5dy.StorageUtil).getActiveNetworkProps();
        const activeCaipNetwork = caipNetworks?.find((network)=>network.id.toString() === activeChainId?.toString());
        const defaultAdapter = adapters.find((adapter)=>adapter?.namespace === activeNamespace);
        const adapterToActivate = defaultAdapter || adapters?.[0];
        const namespacesFromAdapters = adapters.map((a)=>a.namespace).filter((n)=>n !== undefined);
        /**
         * If the AppKit is in embedded mode (for Demo app), we should get the available namespaces from the adapters.
         */ const namespaces = (0, $knC5d.OptionsController).state.enableEmbedded ? new Set([
            ...namespacesFromAdapters
        ]) : new Set([
            ...caipNetworks?.map((network)=>network.chainNamespace) ?? []
        ]);
        if (adapters?.length === 0 || !adapterToActivate) $c1b0f67bff3c0936$var$state.noAdapters = true;
        if (!$c1b0f67bff3c0936$var$state.noAdapters) {
            $c1b0f67bff3c0936$var$state.activeChain = adapterToActivate?.namespace;
            $c1b0f67bff3c0936$var$state.activeCaipNetwork = activeCaipNetwork;
            $c1b0f67bff3c0936$export$fbf61adcac1da229.setChainNetworkData(adapterToActivate?.namespace, {
                caipNetwork: activeCaipNetwork
            });
            if ($c1b0f67bff3c0936$var$state.activeChain) (0, $1dM5v.PublicStateController).set({
                activeChain: adapterToActivate?.namespace
            });
        }
        namespaces.forEach((namespace)=>{
            const namespaceNetworks = caipNetworks?.filter((network)=>network.chainNamespace === namespace);
            $c1b0f67bff3c0936$export$fbf61adcac1da229.state.chains.set(namespace, {
                namespace: namespace,
                networkState: (0, $7zrdF.proxy)({
                    ...$c1b0f67bff3c0936$var$networkState,
                    caipNetwork: namespaceNetworks?.[0]
                }),
                accountState: (0, $7zrdF.proxy)($c1b0f67bff3c0936$var$accountState),
                caipNetworks: namespaceNetworks ?? [],
                ...clients
            });
            $c1b0f67bff3c0936$export$fbf61adcac1da229.setRequestedCaipNetworks(namespaceNetworks ?? [], namespace);
        });
    },
    removeAdapter (namespace) {
        if ($c1b0f67bff3c0936$var$state.activeChain === namespace) {
            const nextAdapter = Array.from($c1b0f67bff3c0936$var$state.chains.entries()).find(([chainNamespace])=>chainNamespace !== namespace);
            if (nextAdapter) {
                const caipNetwork = nextAdapter[1]?.caipNetworks?.[0];
                if (caipNetwork) $c1b0f67bff3c0936$export$fbf61adcac1da229.setActiveCaipNetwork(caipNetwork);
            }
        }
        $c1b0f67bff3c0936$var$state.chains.delete(namespace);
    },
    addAdapter (adapter, { networkControllerClient: networkControllerClient, connectionControllerClient: connectionControllerClient }, caipNetworks) {
        $c1b0f67bff3c0936$var$state.chains.set(adapter.namespace, {
            namespace: adapter.namespace,
            networkState: {
                ...$c1b0f67bff3c0936$var$networkState,
                caipNetwork: caipNetworks[0]
            },
            accountState: $c1b0f67bff3c0936$var$accountState,
            caipNetworks: caipNetworks,
            connectionControllerClient: connectionControllerClient,
            networkControllerClient: networkControllerClient
        });
        $c1b0f67bff3c0936$export$fbf61adcac1da229.setRequestedCaipNetworks(caipNetworks?.filter((caipNetwork)=>caipNetwork.chainNamespace === adapter.namespace) ?? [], adapter.namespace);
    },
    addNetwork (network) {
        const chainAdapter = $c1b0f67bff3c0936$var$state.chains.get(network.chainNamespace);
        if (chainAdapter) {
            const newNetworks = [
                ...chainAdapter.caipNetworks || []
            ];
            if (!chainAdapter.caipNetworks?.find((caipNetwork)=>caipNetwork.id === network.id)) newNetworks.push(network);
            $c1b0f67bff3c0936$var$state.chains.set(network.chainNamespace, {
                ...chainAdapter,
                caipNetworks: newNetworks
            });
            $c1b0f67bff3c0936$export$fbf61adcac1da229.setRequestedCaipNetworks(newNetworks, network.chainNamespace);
            (0, $58cAm.ConnectorController).filterByNamespace(network.chainNamespace, true);
        }
    },
    removeNetwork (namespace, networkId) {
        const chainAdapter = $c1b0f67bff3c0936$var$state.chains.get(namespace);
        if (chainAdapter) {
            // Check if network being removed is active network
            const isActiveNetwork = $c1b0f67bff3c0936$var$state.activeCaipNetwork?.id === networkId;
            // Filter out the network being removed
            const newCaipNetworksOfAdapter = [
                ...chainAdapter.caipNetworks?.filter((network)=>network.id !== networkId) || []
            ];
            // If active network was removed and there are other networks available, switch to first one
            if (isActiveNetwork && chainAdapter?.caipNetworks?.[0]) $c1b0f67bff3c0936$export$fbf61adcac1da229.setActiveCaipNetwork(chainAdapter.caipNetworks[0]);
            $c1b0f67bff3c0936$var$state.chains.set(namespace, {
                ...chainAdapter,
                caipNetworks: newCaipNetworksOfAdapter
            });
            $c1b0f67bff3c0936$export$fbf61adcac1da229.setRequestedCaipNetworks(newCaipNetworksOfAdapter || [], namespace);
            if (newCaipNetworksOfAdapter.length === 0) (0, $58cAm.ConnectorController).filterByNamespace(namespace, false);
        }
    },
    setAdapterNetworkState (chain, props) {
        const chainAdapter = $c1b0f67bff3c0936$var$state.chains.get(chain);
        if (chainAdapter) {
            chainAdapter.networkState = {
                ...chainAdapter.networkState || $c1b0f67bff3c0936$var$networkState,
                ...props
            };
            $c1b0f67bff3c0936$var$state.chains.set(chain, chainAdapter);
        }
    },
    setChainAccountData (chain, accountProps, _unknown = true) {
        if (!chain) throw new Error("Chain is required to update chain account data");
        const chainAdapter = $c1b0f67bff3c0936$var$state.chains.get(chain);
        if (chainAdapter) {
            const newAccountState = {
                ...chainAdapter.accountState || $c1b0f67bff3c0936$var$accountState,
                ...accountProps
            };
            $c1b0f67bff3c0936$var$state.chains.set(chain, {
                ...chainAdapter,
                accountState: newAccountState
            });
            if ($c1b0f67bff3c0936$var$state.chains.size === 1 || $c1b0f67bff3c0936$var$state.activeChain === chain) {
                if (accountProps.caipAddress) $c1b0f67bff3c0936$var$state.activeCaipAddress = accountProps.caipAddress;
                (0, $kfwQH.AccountController).replaceState(newAccountState);
            }
        }
    },
    setChainNetworkData (chain, networkProps) {
        if (!chain) return;
        const chainAdapter = $c1b0f67bff3c0936$var$state.chains.get(chain);
        if (chainAdapter) {
            const newNetworkState = {
                ...chainAdapter.networkState || $c1b0f67bff3c0936$var$networkState,
                ...networkProps
            };
            $c1b0f67bff3c0936$var$state.chains.set(chain, {
                ...chainAdapter,
                networkState: newNetworkState
            });
        }
    },
    // eslint-disable-next-line max-params
    setAccountProp (prop, value, chain, replaceState = true) {
        $c1b0f67bff3c0936$export$fbf61adcac1da229.setChainAccountData(chain, {
            [prop]: value
        }, replaceState);
        if (prop === "status" && value === "disconnected" && chain) (0, $58cAm.ConnectorController).removeConnectorId(chain);
    },
    setActiveNamespace (chain) {
        $c1b0f67bff3c0936$var$state.activeChain = chain;
        const newAdapter = chain ? $c1b0f67bff3c0936$var$state.chains.get(chain) : undefined;
        const caipNetwork = newAdapter?.networkState?.caipNetwork;
        if (caipNetwork?.id && chain) {
            $c1b0f67bff3c0936$var$state.activeCaipAddress = newAdapter?.accountState?.caipAddress;
            $c1b0f67bff3c0936$var$state.activeCaipNetwork = caipNetwork;
            $c1b0f67bff3c0936$export$fbf61adcac1da229.setChainNetworkData(chain, {
                caipNetwork: caipNetwork
            });
            (0, $bc5dy.StorageUtil).setActiveCaipNetworkId(caipNetwork?.caipNetworkId);
            (0, $1dM5v.PublicStateController).set({
                activeChain: chain,
                selectedNetworkId: caipNetwork?.caipNetworkId
            });
        }
    },
    setActiveCaipNetwork (caipNetwork) {
        if (!caipNetwork) return;
        if ($c1b0f67bff3c0936$var$state.activeChain !== caipNetwork.chainNamespace) $c1b0f67bff3c0936$export$fbf61adcac1da229.setIsSwitchingNamespace(true);
        const newAdapter = $c1b0f67bff3c0936$var$state.chains.get(caipNetwork.chainNamespace);
        $c1b0f67bff3c0936$var$state.activeChain = caipNetwork.chainNamespace;
        $c1b0f67bff3c0936$var$state.activeCaipNetwork = caipNetwork;
        $c1b0f67bff3c0936$export$fbf61adcac1da229.setChainNetworkData(caipNetwork.chainNamespace, {
            caipNetwork: caipNetwork
        });
        if (newAdapter?.accountState?.address) $c1b0f67bff3c0936$var$state.activeCaipAddress = `${caipNetwork.chainNamespace}:${caipNetwork.id}:${newAdapter?.accountState?.address}`;
        else $c1b0f67bff3c0936$var$state.activeCaipAddress = undefined;
        // Update the chain's account state with the new caip address value
        $c1b0f67bff3c0936$export$fbf61adcac1da229.setAccountProp("caipAddress", $c1b0f67bff3c0936$var$state.activeCaipAddress, caipNetwork.chainNamespace);
        if (newAdapter) (0, $kfwQH.AccountController).replaceState(newAdapter.accountState);
        // Reset send state when switching networks
        (0, $vRYB3.SendController).resetSend();
        (0, $1dM5v.PublicStateController).set({
            activeChain: $c1b0f67bff3c0936$var$state.activeChain,
            selectedNetworkId: $c1b0f67bff3c0936$var$state.activeCaipNetwork?.caipNetworkId
        });
        (0, $bc5dy.StorageUtil).setActiveCaipNetworkId(caipNetwork.caipNetworkId);
        const isSupported = $c1b0f67bff3c0936$export$fbf61adcac1da229.checkIfSupportedNetwork(caipNetwork.chainNamespace);
        if (!isSupported && (0, $knC5d.OptionsController).state.enableNetworkSwitch && !(0, $knC5d.OptionsController).state.allowUnsupportedChain && !(0, $efZLi.ConnectionController).state.wcBasic) $c1b0f67bff3c0936$export$fbf61adcac1da229.showUnsupportedChainUI();
    },
    addCaipNetwork (caipNetwork) {
        if (!caipNetwork) return;
        const chain = $c1b0f67bff3c0936$var$state.chains.get(caipNetwork.chainNamespace);
        if (chain) chain?.caipNetworks?.push(caipNetwork);
    },
    async switchActiveNamespace (namespace) {
        if (!namespace) return;
        const isDifferentChain = namespace !== $c1b0f67bff3c0936$export$fbf61adcac1da229.state.activeChain;
        const caipNetworkOfNamespace = $c1b0f67bff3c0936$export$fbf61adcac1da229.getNetworkData(namespace)?.caipNetwork;
        const firstNetworkWithChain = $c1b0f67bff3c0936$export$fbf61adcac1da229.getCaipNetworkByNamespace(namespace, caipNetworkOfNamespace?.id);
        if (isDifferentChain && firstNetworkWithChain) await $c1b0f67bff3c0936$export$fbf61adcac1da229.switchActiveNetwork(firstNetworkWithChain);
    },
    async switchActiveNetwork (network) {
        const activeAdapter = $c1b0f67bff3c0936$export$fbf61adcac1da229.state.chains.get($c1b0f67bff3c0936$export$fbf61adcac1da229.state.activeChain);
        const unsupportedNetwork = !activeAdapter?.caipNetworks?.some((caipNetwork)=>caipNetwork.id === $c1b0f67bff3c0936$var$state.activeCaipNetwork?.id);
        const networkControllerClient = $c1b0f67bff3c0936$export$fbf61adcac1da229.getNetworkControllerClient(network.chainNamespace);
        if (networkControllerClient) {
            try {
                await networkControllerClient.switchCaipNetwork(network);
                if (unsupportedNetwork) (0, $6aBkR.ModalController).close();
            } catch (error) {
                (0, $aZ8hw.RouterController).goBack();
            }
            (0, $5FNhR.EventsController).sendEvent({
                type: "track",
                event: "SWITCH_NETWORK",
                properties: {
                    network: network.caipNetworkId
                }
            });
        }
    },
    getNetworkControllerClient (chainNamespace) {
        const chain = chainNamespace || $c1b0f67bff3c0936$var$state.activeChain;
        const chainAdapter = $c1b0f67bff3c0936$var$state.chains.get(chain);
        if (!chainAdapter) throw new Error("Chain adapter not found");
        if (!chainAdapter.networkControllerClient) throw new Error("NetworkController client not set");
        return chainAdapter.networkControllerClient;
    },
    getConnectionControllerClient (_chain) {
        const chain = _chain || $c1b0f67bff3c0936$var$state.activeChain;
        if (!chain) throw new Error("Chain is required to get connection controller client");
        const chainAdapter = $c1b0f67bff3c0936$var$state.chains.get(chain);
        if (!chainAdapter?.connectionControllerClient) throw new Error("ConnectionController client not set");
        return chainAdapter.connectionControllerClient;
    },
    getAccountProp (key, _chain) {
        let chain = $c1b0f67bff3c0936$var$state.activeChain;
        if (_chain) chain = _chain;
        if (!chain) return undefined;
        const chainAccountState = $c1b0f67bff3c0936$var$state.chains.get(chain)?.accountState;
        if (!chainAccountState) return undefined;
        return chainAccountState[key];
    },
    getNetworkProp (key, namespace) {
        const chainNetworkState = $c1b0f67bff3c0936$var$state.chains.get(namespace)?.networkState;
        if (!chainNetworkState) return undefined;
        return chainNetworkState[key];
    },
    getRequestedCaipNetworks (chainToFilter) {
        const adapter = $c1b0f67bff3c0936$var$state.chains.get(chainToFilter);
        const { approvedCaipNetworkIds: approvedCaipNetworkIds = [], requestedCaipNetworks: requestedCaipNetworks = [] } = adapter?.networkState || {};
        const sortedNetworks = (0, $lpmCO.CoreHelperUtil).sortRequestedNetworks(approvedCaipNetworkIds, requestedCaipNetworks);
        return sortedNetworks;
    },
    getAllRequestedCaipNetworks () {
        const requestedCaipNetworks = [];
        $c1b0f67bff3c0936$var$state.chains.forEach((chainAdapter)=>{
            const caipNetworks = $c1b0f67bff3c0936$export$fbf61adcac1da229.getRequestedCaipNetworks(chainAdapter.namespace);
            requestedCaipNetworks.push(...caipNetworks);
        });
        return requestedCaipNetworks;
    },
    setRequestedCaipNetworks (caipNetworks, chain) {
        $c1b0f67bff3c0936$export$fbf61adcac1da229.setAdapterNetworkState(chain, {
            requestedCaipNetworks: caipNetworks
        });
        const allRequestedCaipNetworks = $c1b0f67bff3c0936$export$fbf61adcac1da229.getAllRequestedCaipNetworks();
        const namespaces = allRequestedCaipNetworks.map((network)=>network.chainNamespace);
        const uniqueNamespaces = Array.from(new Set(namespaces));
        (0, $58cAm.ConnectorController).filterByNamespaces(uniqueNamespaces);
    },
    getAllApprovedCaipNetworkIds () {
        const approvedCaipNetworkIds = [];
        $c1b0f67bff3c0936$var$state.chains.forEach((chainAdapter)=>{
            const approvedIds = $c1b0f67bff3c0936$export$fbf61adcac1da229.getApprovedCaipNetworkIds(chainAdapter.namespace);
            approvedCaipNetworkIds.push(...approvedIds);
        });
        return approvedCaipNetworkIds;
    },
    getActiveCaipNetwork () {
        return $c1b0f67bff3c0936$var$state.activeCaipNetwork;
    },
    getActiveCaipAddress () {
        return $c1b0f67bff3c0936$var$state.activeCaipAddress;
    },
    getApprovedCaipNetworkIds (namespace) {
        const adapter = $c1b0f67bff3c0936$var$state.chains.get(namespace);
        const approvedCaipNetworkIds = adapter?.networkState?.approvedCaipNetworkIds || [];
        return approvedCaipNetworkIds;
    },
    async setApprovedCaipNetworksData (namespace) {
        const networkControllerClient = $c1b0f67bff3c0936$export$fbf61adcac1da229.getNetworkControllerClient();
        const data = await networkControllerClient?.getApprovedCaipNetworksData();
        $c1b0f67bff3c0936$export$fbf61adcac1da229.setAdapterNetworkState(namespace, {
            approvedCaipNetworkIds: data?.approvedCaipNetworkIds,
            supportsAllNetworks: data?.supportsAllNetworks
        });
    },
    checkIfSupportedNetwork (namespace, caipNetwork) {
        const activeCaipNetwork = caipNetwork || $c1b0f67bff3c0936$var$state.activeCaipNetwork;
        const requestedCaipNetworks = $c1b0f67bff3c0936$export$fbf61adcac1da229.getRequestedCaipNetworks(namespace);
        if (!requestedCaipNetworks.length) return true;
        return requestedCaipNetworks?.some((network)=>network.id === activeCaipNetwork?.id);
    },
    checkIfSupportedChainId (chainId) {
        if (!$c1b0f67bff3c0936$var$state.activeChain) return true;
        const requestedCaipNetworks = $c1b0f67bff3c0936$export$fbf61adcac1da229.getRequestedCaipNetworks($c1b0f67bff3c0936$var$state.activeChain);
        return requestedCaipNetworks?.some((network)=>network.id === chainId);
    },
    // Smart Account Network Handlers
    setSmartAccountEnabledNetworks (smartAccountEnabledNetworks, chain) {
        $c1b0f67bff3c0936$export$fbf61adcac1da229.setAdapterNetworkState(chain, {
            smartAccountEnabledNetworks: smartAccountEnabledNetworks
        });
    },
    checkIfSmartAccountEnabled () {
        const networkId = (0, $dawjb.NetworkUtil).caipNetworkIdToNumber($c1b0f67bff3c0936$var$state.activeCaipNetwork?.caipNetworkId);
        const activeChain = $c1b0f67bff3c0936$var$state.activeChain;
        if (!activeChain || !networkId) return false;
        const smartAccountEnabledNetworks = $c1b0f67bff3c0936$export$fbf61adcac1da229.getNetworkProp("smartAccountEnabledNetworks", activeChain);
        return Boolean(smartAccountEnabledNetworks?.includes(Number(networkId)));
    },
    getActiveNetworkTokenAddress () {
        const namespace = $c1b0f67bff3c0936$var$state.activeCaipNetwork?.chainNamespace || "eip155";
        const chainId = $c1b0f67bff3c0936$var$state.activeCaipNetwork?.id || 1;
        const address = (0, $3h0dG.ConstantsUtil).NATIVE_TOKEN_ADDRESS[namespace];
        return `${namespace}:${chainId}:${address}`;
    },
    showUnsupportedChainUI () {
        (0, $6aBkR.ModalController).open({
            view: "UnsupportedChain"
        });
    },
    checkIfNamesSupported () {
        const activeCaipNetwork = $c1b0f67bff3c0936$var$state.activeCaipNetwork;
        return Boolean(activeCaipNetwork?.chainNamespace && (0, $3h0dG.ConstantsUtil).NAMES_SUPPORTED_CHAIN_NAMESPACES.includes(activeCaipNetwork.chainNamespace));
    },
    resetNetwork (namespace) {
        $c1b0f67bff3c0936$export$fbf61adcac1da229.setAdapterNetworkState(namespace, {
            approvedCaipNetworkIds: undefined,
            supportsAllNetworks: true,
            smartAccountEnabledNetworks: []
        });
    },
    resetAccount (chain) {
        const chainToWrite = chain;
        if (!chainToWrite) throw new Error("Chain is required to set account prop");
        $c1b0f67bff3c0936$var$state.activeCaipAddress = undefined;
        $c1b0f67bff3c0936$export$fbf61adcac1da229.setChainAccountData(chainToWrite, {
            smartAccountDeployed: false,
            currentTab: 0,
            caipAddress: undefined,
            address: undefined,
            balance: undefined,
            balanceSymbol: undefined,
            profileName: undefined,
            profileImage: undefined,
            addressExplorerUrl: undefined,
            tokenBalance: [],
            connectedWalletInfo: undefined,
            preferredAccountTypes: undefined,
            socialProvider: undefined,
            socialWindow: undefined,
            farcasterUrl: undefined,
            allAccounts: [],
            user: undefined,
            status: "disconnected"
        });
        (0, $58cAm.ConnectorController).removeConnectorId(chainToWrite);
    },
    async disconnect (namespace) {
        const chainsToDisconnect = (0, $bzYsu.getChainsToDisconnect)(namespace);
        try {
            // Reset send state when disconnecting
            (0, $vRYB3.SendController).resetSend();
            const disconnectResults = await Promise.allSettled(chainsToDisconnect.map(async ([ns, adapter])=>{
                try {
                    const { caipAddress: caipAddress } = $c1b0f67bff3c0936$export$fbf61adcac1da229.getAccountData(ns) || {};
                    if (caipAddress && adapter.connectionControllerClient?.disconnect) await adapter.connectionControllerClient.disconnect(ns);
                    $c1b0f67bff3c0936$export$fbf61adcac1da229.resetAccount(ns);
                    $c1b0f67bff3c0936$export$fbf61adcac1da229.resetNetwork(ns);
                } catch (error) {
                    throw new Error(`Failed to disconnect chain ${ns}: ${error.message}`);
                }
            }));
            (0, $efZLi.ConnectionController).resetWcConnection();
            const failures = disconnectResults.filter((result)=>result.status === "rejected");
            if (failures.length > 0) throw new Error(failures.map((f)=>f.reason.message).join(", "));
            (0, $bc5dy.StorageUtil).deleteConnectedSocialProvider();
            if (namespace) (0, $58cAm.ConnectorController).removeConnectorId(namespace);
            else (0, $58cAm.ConnectorController).resetConnectorIds();
            (0, $5FNhR.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_SUCCESS",
                properties: {
                    namespace: namespace || "all"
                }
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error.message || "Failed to disconnect chains");
            (0, $5FNhR.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_ERROR",
                properties: {
                    message: error.message || "Failed to disconnect chains"
                }
            });
        }
    },
    setIsSwitchingNamespace (isSwitchingNamespace) {
        $c1b0f67bff3c0936$var$state.isSwitchingNamespace = isSwitchingNamespace;
    },
    getFirstCaipNetworkSupportsAuthConnector () {
        const availableChains = [];
        let firstCaipNetwork = undefined;
        $c1b0f67bff3c0936$var$state.chains.forEach((chain)=>{
            if ((0, $b3v9s.ConstantsUtil).AUTH_CONNECTOR_SUPPORTED_CHAINS.find((ns)=>ns === chain.namespace)) {
                if (chain.namespace) availableChains.push(chain.namespace);
            }
        });
        if (availableChains.length > 0) {
            const firstAvailableChain = availableChains[0];
            firstCaipNetwork = firstAvailableChain ? $c1b0f67bff3c0936$var$state.chains.get(firstAvailableChain)?.caipNetworks?.[0] : undefined;
            return firstCaipNetwork;
        }
        return undefined;
    },
    getAccountData (chainNamespace) {
        if (!chainNamespace) return (0, $kfwQH.AccountController).state;
        return $c1b0f67bff3c0936$export$fbf61adcac1da229.state.chains.get(chainNamespace)?.accountState;
    },
    getNetworkData (chainNamespace) {
        const namespace = chainNamespace || $c1b0f67bff3c0936$var$state.activeChain;
        if (!namespace) return undefined;
        return $c1b0f67bff3c0936$export$fbf61adcac1da229.state.chains.get(namespace)?.networkState;
    },
    getCaipNetworkByNamespace (chainNamespace, chainId) {
        if (!chainNamespace) return undefined;
        const chain = $c1b0f67bff3c0936$export$fbf61adcac1da229.state.chains.get(chainNamespace);
        const byChainId = chain?.caipNetworks?.find((network)=>network.id === chainId);
        if (byChainId) return byChainId;
        return chain?.networkState?.caipNetwork || chain?.caipNetworks?.[0];
    },
    /**
     * Get the requested CaipNetwork IDs for a given namespace. If namespace is not provided, all requested CaipNetwork IDs will be returned
     * @param namespace - The namespace to get the requested CaipNetwork IDs for
     * @returns The requested CaipNetwork IDs
     */ getRequestedCaipNetworkIds () {
        const namespace = (0, $58cAm.ConnectorController).state.filterByNamespace;
        const chains = namespace ? [
            $c1b0f67bff3c0936$var$state.chains.get(namespace)
        ] : Array.from($c1b0f67bff3c0936$var$state.chains.values());
        return chains.flatMap((chain)=>chain?.caipNetworks || []).map((caipNetwork)=>caipNetwork.caipNetworkId);
    },
    getCaipNetworks (namespace) {
        if (namespace) return $c1b0f67bff3c0936$export$fbf61adcac1da229.getRequestedCaipNetworks(namespace);
        return $c1b0f67bff3c0936$export$fbf61adcac1da229.getAllRequestedCaipNetworks();
    }
};
const $c1b0f67bff3c0936$export$fbf61adcac1da229 = (0, $lCKEr.withErrorBoundary)($c1b0f67bff3c0936$var$controller);

});
parcelRegister("eFS1l", function(module, exports) {

$parcel$export(module.exports, "subscribeKey", () => $553fc60ca99745d8$export$7faad7f6b3708314);
$parcel$export(module.exports, "proxyMap", () => $553fc60ca99745d8$export$17aaac2670e0d2b9);

var $7zrdF = parcelRequire("7zrdF");

var $99ZHs = parcelRequire("99ZHs");
var $553fc60ca99745d8$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/valtio/esm/vanilla/utils.mjs"
});
function $553fc60ca99745d8$export$7faad7f6b3708314(proxyObject, key, callback, notifyInSync) {
    let prevValue = proxyObject[key];
    return (0, $7zrdF.subscribe)(proxyObject, ()=>{
        const nextValue = proxyObject[key];
        if (!Object.is(prevValue, nextValue)) callback(prevValue = nextValue);
    }, notifyInSync);
}
let $553fc60ca99745d8$var$currentCleanups;
function $553fc60ca99745d8$export$3db5d71bdb2d5499(callback, options) {
    let alive = true;
    const cleanups = /* @__PURE__ */ new Set();
    const subscriptions = /* @__PURE__ */ new Map();
    const cleanup = ()=>{
        if (alive) {
            alive = false;
            cleanups.forEach((clean)=>clean());
            cleanups.clear();
            subscriptions.forEach((unsubscribe)=>unsubscribe());
            subscriptions.clear();
        }
    };
    const revalidate = async ()=>{
        if (!alive) return;
        cleanups.forEach((clean)=>clean());
        cleanups.clear();
        const proxiesToSubscribe = /* @__PURE__ */ new Set();
        const parent = $553fc60ca99745d8$var$currentCleanups;
        $553fc60ca99745d8$var$currentCleanups = cleanups;
        try {
            const promiseOrPossibleCleanup = callback((proxyObject)=>{
                proxiesToSubscribe.add(proxyObject);
                if (alive && !subscriptions.has(proxyObject)) {
                    const unsubscribe = (0, $7zrdF.subscribe)(proxyObject, revalidate, options == null ? void 0 : options.sync);
                    subscriptions.set(proxyObject, unsubscribe);
                }
                return proxyObject;
            });
            const couldBeCleanup = promiseOrPossibleCleanup && promiseOrPossibleCleanup instanceof Promise ? await promiseOrPossibleCleanup : promiseOrPossibleCleanup;
            if (couldBeCleanup) {
                if (alive) cleanups.add(couldBeCleanup);
                else cleanup();
            }
        } finally{
            $553fc60ca99745d8$var$currentCleanups = parent;
        }
        subscriptions.forEach((unsubscribe, proxyObject)=>{
            if (!proxiesToSubscribe.has(proxyObject)) {
                subscriptions.delete(proxyObject);
                unsubscribe();
            }
        });
    };
    if ($553fc60ca99745d8$var$currentCleanups) $553fc60ca99745d8$var$currentCleanups.add(cleanup);
    revalidate();
    return cleanup;
}
const $553fc60ca99745d8$var$DEVTOOLS = Symbol();
function $553fc60ca99745d8$export$6922d3b3a607469e(proxyObject, options) {
    if (typeof options === "string") {
        console.warn("string name option is deprecated, use { name }. https://github.com/pmndrs/valtio/pull/400");
        options = {
            name: options
        };
    }
    const { enabled: enabled, name: name = "", ...rest } = options || {};
    let extension;
    try {
        extension = (enabled != null ? enabled : ($553fc60ca99745d8$import_meta.env ? $553fc60ca99745d8$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
    } catch (e) {}
    if (!extension) {
        if (($553fc60ca99745d8$import_meta.env ? $553fc60ca99745d8$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[Warning] Please install/enable Redux devtools extension");
        return;
    }
    let isTimeTraveling = false;
    const devtools2 = extension.connect({
        name: name,
        ...rest
    });
    const unsub1 = (0, $7zrdF.subscribe)(proxyObject, (ops)=>{
        const action = ops.filter(([_, path])=>path[0] !== $553fc60ca99745d8$var$DEVTOOLS).map(([op, path])=>`${op}:${path.map(String).join(".")}`).join(", ");
        if (!action) return;
        if (isTimeTraveling) isTimeTraveling = false;
        else {
            const snapWithoutDevtools = Object.assign({}, (0, $7zrdF.snapshot)(proxyObject));
            delete snapWithoutDevtools[$553fc60ca99745d8$var$DEVTOOLS];
            devtools2.send({
                type: action,
                updatedAt: /* @__PURE__ */ new Date().toLocaleString()
            }, snapWithoutDevtools);
        }
    });
    const unsub2 = devtools2.subscribe((message)=>{
        var _a, _b, _c, _d, _e, _f;
        if (message.type === "ACTION" && message.payload) try {
            Object.assign(proxyObject, JSON.parse(message.payload));
        } catch (e) {
            console.error("please dispatch a serializable value that JSON.parse() and proxy() support\n", e);
        }
        if (message.type === "DISPATCH" && message.state) {
            if (((_a = message.payload) == null ? void 0 : _a.type) === "JUMP_TO_ACTION" || ((_b = message.payload) == null ? void 0 : _b.type) === "JUMP_TO_STATE") {
                isTimeTraveling = true;
                const state = JSON.parse(message.state);
                Object.assign(proxyObject, state);
            }
            proxyObject[$553fc60ca99745d8$var$DEVTOOLS] = message;
        } else if (message.type === "DISPATCH" && ((_c = message.payload) == null ? void 0 : _c.type) === "COMMIT") devtools2.init((0, $7zrdF.snapshot)(proxyObject));
        else if (message.type === "DISPATCH" && ((_d = message.payload) == null ? void 0 : _d.type) === "IMPORT_STATE") {
            const actions = (_e = message.payload.nextLiftedState) == null ? void 0 : _e.actionsById;
            const computedStates = ((_f = message.payload.nextLiftedState) == null ? void 0 : _f.computedStates) || [];
            isTimeTraveling = true;
            computedStates.forEach(({ state: state }, index)=>{
                const action = actions[index] || "No action found";
                Object.assign(proxyObject, state);
                if (index === 0) devtools2.init((0, $7zrdF.snapshot)(proxyObject));
                else devtools2.send(action, (0, $7zrdF.snapshot)(proxyObject));
            });
        }
    });
    devtools2.init((0, $7zrdF.snapshot)(proxyObject));
    return ()=>{
        unsub1();
        unsub2 == null || unsub2();
    };
}
function $553fc60ca99745d8$export$b84fff6f79a56fa3(proxyObject, computedFns_FAKE, targetObject = proxyObject) {
    if (($553fc60ca99745d8$import_meta.env ? $553fc60ca99745d8$import_meta.env.MODE : void 0) !== "production") console.warn("addComputed is deprecated. Please consider using `derive`. Falling back to emulation with derive. https://github.com/pmndrs/valtio/pull/201");
    const derivedFns = {};
    Object.keys(computedFns_FAKE).forEach((key)=>{
        derivedFns[key] = (get)=>computedFns_FAKE[key](get(proxyObject));
    });
    return (0, $99ZHs.derive)(derivedFns, {
        proxy: targetObject
    });
}
function $553fc60ca99745d8$export$64a33e9109220e08(initialObject, computedFns) {
    if (($553fc60ca99745d8$import_meta.env ? $553fc60ca99745d8$import_meta.env.MODE : void 0) !== "production") console.warn('proxyWithComputed is deprecated. Please follow "Computed Properties" guide in docs.');
    Object.keys(computedFns).forEach((key)=>{
        if (Object.getOwnPropertyDescriptor(initialObject, key)) throw new Error("object property already defined");
        const computedFn = computedFns[key];
        const { get: get, set: set } = typeof computedFn === "function" ? {
            get: computedFn
        } : computedFn;
        const desc = {};
        desc.get = ()=>get((0, $7zrdF.snapshot)(proxyObject));
        if (set) desc.set = (newValue)=>set(proxyObject, newValue);
        Object.defineProperty(initialObject, key, desc);
    });
    const proxyObject = (0, $7zrdF.proxy)(initialObject);
    return proxyObject;
}
const $553fc60ca99745d8$var$isObject = (x)=>typeof x === "object" && x !== null;
let $553fc60ca99745d8$var$refSet;
const $553fc60ca99745d8$var$deepClone = (obj)=>{
    if (!$553fc60ca99745d8$var$refSet) $553fc60ca99745d8$var$refSet = (0, $7zrdF.unstable_buildProxyFunction)()[2];
    if (!$553fc60ca99745d8$var$isObject(obj) || $553fc60ca99745d8$var$refSet.has(obj)) return obj;
    const baseObject = Array.isArray(obj) ? [] : Object.create(Object.getPrototypeOf(obj));
    Reflect.ownKeys(obj).forEach((key)=>{
        baseObject[key] = $553fc60ca99745d8$var$deepClone(obj[key]);
    });
    return baseObject;
};
function $553fc60ca99745d8$export$32f3091caa3ecf1e(initialValue, skipSubscribe = false) {
    if (($553fc60ca99745d8$import_meta.env ? $553fc60ca99745d8$import_meta.env.MODE : void 0) !== "production") console.warn('proxyWithHistory is deprecated. Please use the "valtio-history" package; refer to the docs');
    const proxyObject = (0, $7zrdF.proxy)({
        value: initialValue,
        history: (0, $7zrdF.ref)({
            wip: void 0,
            // to avoid infinite loop
            snapshots: [],
            index: -1
        }),
        clone: $553fc60ca99745d8$var$deepClone,
        canUndo: ()=>proxyObject.history.index > 0,
        undo: ()=>{
            if (proxyObject.canUndo()) proxyObject.value = proxyObject.history.wip = proxyObject.clone(proxyObject.history.snapshots[--proxyObject.history.index]);
        },
        canRedo: ()=>proxyObject.history.index < proxyObject.history.snapshots.length - 1,
        redo: ()=>{
            if (proxyObject.canRedo()) proxyObject.value = proxyObject.history.wip = proxyObject.clone(proxyObject.history.snapshots[++proxyObject.history.index]);
        },
        saveHistory: ()=>{
            proxyObject.history.snapshots.splice(proxyObject.history.index + 1);
            proxyObject.history.snapshots.push((0, $7zrdF.snapshot)(proxyObject).value);
            ++proxyObject.history.index;
        },
        subscribe: ()=>(0, $7zrdF.subscribe)(proxyObject, (ops)=>{
                if (ops.every((op)=>op[1][0] === "value" && (op[0] !== "set" || op[2] !== proxyObject.history.wip))) proxyObject.saveHistory();
            })
    });
    proxyObject.saveHistory();
    if (!skipSubscribe) proxyObject.subscribe();
    return proxyObject;
}
function $553fc60ca99745d8$export$339ebc24fb22ad80(initialValues) {
    const set = (0, $7zrdF.proxy)({
        data: Array.from(new Set(initialValues)),
        has (value) {
            return this.data.indexOf(value) !== -1;
        },
        add (value) {
            let hasProxy = false;
            if (typeof value === "object" && value !== null) hasProxy = this.data.indexOf((0, $7zrdF.proxy)(value)) !== -1;
            if (this.data.indexOf(value) === -1 && !hasProxy) this.data.push(value);
            return this;
        },
        delete (value) {
            const index = this.data.indexOf(value);
            if (index === -1) return false;
            this.data.splice(index, 1);
            return true;
        },
        clear () {
            this.data.splice(0);
        },
        get size () {
            return this.data.length;
        },
        forEach (cb) {
            this.data.forEach((value)=>{
                cb(value, value, this);
            });
        },
        get [Symbol.toStringTag] () {
            return "Set";
        },
        toJSON () {
            return new Set(this.data);
        },
        [Symbol.iterator] () {
            return this.data[Symbol.iterator]();
        },
        values () {
            return this.data.values();
        },
        keys () {
            return this.data.values();
        },
        entries () {
            return new Set(this.data).entries();
        }
    });
    Object.defineProperties(set, {
        data: {
            enumerable: false
        },
        size: {
            enumerable: false
        },
        toJSON: {
            enumerable: false
        }
    });
    Object.seal(set);
    return set;
}
function $553fc60ca99745d8$export$17aaac2670e0d2b9(entries) {
    const map = (0, $7zrdF.proxy)({
        data: Array.from(entries || []),
        has (key) {
            return this.data.some((p)=>p[0] === key);
        },
        set (key, value) {
            const record = this.data.find((p)=>p[0] === key);
            if (record) record[1] = value;
            else this.data.push([
                key,
                value
            ]);
            return this;
        },
        get (key) {
            var _a;
            return (_a = this.data.find((p)=>p[0] === key)) == null ? void 0 : _a[1];
        },
        delete (key) {
            const index = this.data.findIndex((p)=>p[0] === key);
            if (index === -1) return false;
            this.data.splice(index, 1);
            return true;
        },
        clear () {
            this.data.splice(0);
        },
        get size () {
            return this.data.length;
        },
        toJSON () {
            return new Map(this.data);
        },
        forEach (cb) {
            this.data.forEach((p)=>{
                cb(p[1], p[0], this);
            });
        },
        keys () {
            return this.data.map((p)=>p[0]).values();
        },
        values () {
            return this.data.map((p)=>p[1]).values();
        },
        entries () {
            return new Map(this.data).entries();
        },
        get [Symbol.toStringTag] () {
            return "Map";
        },
        [Symbol.iterator] () {
            return this.entries();
        }
    });
    Object.defineProperties(map, {
        data: {
            enumerable: false
        },
        size: {
            enumerable: false
        },
        toJSON: {
            enumerable: false
        }
    });
    Object.seal(map);
    return map;
}

});
parcelRegister("99ZHs", function(module, exports) {

$parcel$export(module.exports, "derive", () => $6ab4d0a10e39b862$export$78ed5b3305815fc7);

var $7zrdF = parcelRequire("7zrdF");
const $6ab4d0a10e39b862$var$o = new WeakMap, $6ab4d0a10e39b862$var$r = new WeakMap, $6ab4d0a10e39b862$var$s = (e, t)=>{
    const n = $6ab4d0a10e39b862$var$o.get(e);
    n && (n[0].forEach((t)=>{
        const { d: n } = t;
        e !== n && $6ab4d0a10e39b862$var$s(n);
    }), ++n[2], t && n[3].add(t));
}, $6ab4d0a10e39b862$var$l = (e)=>{
    const t = $6ab4d0a10e39b862$var$o.get(e);
    t && (--t[2], t[2] || (t[3].forEach((e)=>e()), t[3].clear()), t[0].forEach((t)=>{
        const { d: n } = t;
        e !== n && $6ab4d0a10e39b862$var$l(n);
    }));
}, $6ab4d0a10e39b862$var$c = (e)=>{
    const { s: n, d: c } = e;
    let a = $6ab4d0a10e39b862$var$r.get(c);
    a || (a = [
        new Set
    ], $6ab4d0a10e39b862$var$r.set(e.d, a)), a[0].add(e);
    let d = $6ab4d0a10e39b862$var$o.get(n);
    if (!d) {
        const e = new Set, r = (0, $7zrdF.subscribe)(n, (t)=>{
            e.forEach((e)=>{
                const { d: o, c: r, n: c, i: a } = e;
                n === o && t.every((e)=>1 === e[1].length && a.includes(e[1][0])) || e.p || ($6ab4d0a10e39b862$var$s(n, r), c ? $6ab4d0a10e39b862$var$l(n) : e.p = Promise.resolve().then(()=>{
                    delete e.p, $6ab4d0a10e39b862$var$l(n);
                }));
            });
        }, !0);
        d = [
            e,
            r,
            0,
            new Set
        ], $6ab4d0a10e39b862$var$o.set(n, d);
    }
    d[0].add(e);
}, $6ab4d0a10e39b862$var$a = (e)=>{
    const { s: t, d: n } = e, s = $6ab4d0a10e39b862$var$r.get(n);
    null == s || s[0].delete(e), 0 === (null == s ? void 0 : s[0].size) && $6ab4d0a10e39b862$var$r.delete(n);
    const l = $6ab4d0a10e39b862$var$o.get(t);
    if (l) {
        const [n, r] = l;
        n.delete(e), n.size || (r(), $6ab4d0a10e39b862$var$o.delete(t));
    }
}, $6ab4d0a10e39b862$var$d = (e)=>{
    const t = $6ab4d0a10e39b862$var$r.get(e);
    return t ? Array.from(t[0]) : [];
}, $6ab4d0a10e39b862$export$5bb85a5dcd872eb9 = {
    add: $6ab4d0a10e39b862$var$c,
    remove: $6ab4d0a10e39b862$var$a,
    list: $6ab4d0a10e39b862$var$d
};
function $6ab4d0a10e39b862$export$78ed5b3305815fc7(t, r) {
    const s = (null == r ? void 0 : r.proxy) || (0, $7zrdF.proxy)({}), l = !(null == r || !r.sync), d = Object.keys(t);
    return d.forEach((e)=>{
        if (Object.getOwnPropertyDescriptor(s, e)) throw new Error("object property already defined");
        const r = t[e];
        let i = null;
        const f = ()=>{
            if (i) {
                if (Array.from(i).map(([e])=>((e, t)=>{
                        const n = $6ab4d0a10e39b862$var$o.get(e);
                        return !(null == n || !n[2] || (n[3].add(t), 0));
                    })(e, f)).some((e)=>e)) return;
                if (Array.from(i).every(([e, t])=>(0, $7zrdF.getVersion)(e) === t.v)) return;
            }
            const t = new Map, u = r((e)=>(t.set(e, {
                    v: (0, $7zrdF.getVersion)(e)
                }), e)), p = ()=>{
                var n;
                t.forEach((t, n)=>{
                    var o;
                    const r = null == (o = i) || null == (o = o.get(n)) ? void 0 : o.s;
                    if (r) t.s = r;
                    else {
                        const o = {
                            s: n,
                            d: s,
                            k: e,
                            c: f,
                            n: l,
                            i: d
                        };
                        $6ab4d0a10e39b862$var$c(o), t.s = o;
                    }
                }), null == (n = i) || n.forEach((e, n)=>{
                    !t.has(n) && e.s && $6ab4d0a10e39b862$var$a(e.s);
                }), i = t;
            };
            u instanceof Promise ? u.finally(p) : p(), s[e] = u;
        };
        f();
    }), s;
}
function $6ab4d0a10e39b862$export$992ed2abb18cb90(e, t) {
    const n = null != t && t.delete ? new Set : null;
    $6ab4d0a10e39b862$var$d(e).forEach((e)=>{
        const { k: o } = e;
        null != t && t.keys && !t.keys.includes(o) || ($6ab4d0a10e39b862$var$a(e), n && n.add(o));
    }), n && n.forEach((t)=>{
        delete e[t];
    });
}

});


parcelRegister("dawjb", function(module, exports) {

$parcel$export(module.exports, "NetworkUtil", () => $996545552b73262e$export$79d00c05833eff69);

var $b3v9s = parcelRequire("b3v9s");
const $996545552b73262e$export$79d00c05833eff69 = {
    caipNetworkIdToNumber (caipnetworkId) {
        return caipnetworkId ? Number(caipnetworkId.split(":")[1]) : undefined;
    },
    parseEvmChainId (chainId) {
        return typeof chainId === "string" ? this.caipNetworkIdToNumber(chainId) : chainId;
    },
    getNetworksByNamespace (networks, namespace) {
        return networks?.filter((network)=>network.chainNamespace === namespace) || [];
    },
    getFirstNetworkByNamespace (networks, namespace) {
        return this.getNetworksByNamespace(networks, namespace)[0];
    },
    getNetworkNameByCaipNetworkId (caipNetworks, caipNetworkId) {
        if (!caipNetworkId) return undefined;
        const caipNetwork = caipNetworks.find((network)=>network.caipNetworkId === caipNetworkId);
        if (caipNetwork) return caipNetwork.name;
        const [namespace] = caipNetworkId.split(":");
        return (0, $b3v9s.ConstantsUtil).CHAIN_NAME_MAP?.[namespace] || undefined;
    }
};

});

parcelRegister("bzYsu", function(module, exports) {

$parcel$export(module.exports, "getChainsToDisconnect", () => $86e1dc65e20ada7e$export$7328d7c531fe82bb);

var $b3v9s = parcelRequire("b3v9s");

var $gD0RX = parcelRequire("gD0RX");

var $34dSO = parcelRequire("34dSO");
function $86e1dc65e20ada7e$export$7328d7c531fe82bb(namespace) {
    const namespaces = Array.from((0, $gD0RX.ChainController).state.chains.keys());
    let chains = [];
    if (namespace) {
        chains.push([
            namespace,
            (0, $gD0RX.ChainController).state.chains.get(namespace)
        ]);
        if ((0, $34dSO.checkNamespaceConnectorId)(namespace, (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.WALLET_CONNECT)) namespaces.forEach((ns)=>{
            if (ns !== namespace && (0, $34dSO.checkNamespaceConnectorId)(ns, (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.WALLET_CONNECT)) chains.push([
                ns,
                (0, $gD0RX.ChainController).state.chains.get(ns)
            ]);
        });
        else if ((0, $34dSO.checkNamespaceConnectorId)(namespace, (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH)) namespaces.forEach((ns)=>{
            if (ns !== namespace && (0, $34dSO.checkNamespaceConnectorId)(ns, (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH)) chains.push([
                ns,
                (0, $gD0RX.ChainController).state.chains.get(ns)
            ]);
        });
    } else chains = Array.from((0, $gD0RX.ChainController).state.chains.entries());
    return chains;
}

});
parcelRegister("34dSO", function(module, exports) {

$parcel$export(module.exports, "checkNamespaceConnectorId", () => $23bc83b1d330673e$export$4043411de1079c57);

var $58cAm = parcelRequire("58cAm");
function $23bc83b1d330673e$export$4043411de1079c57(namespace, connectorId) {
    return (0, $58cAm.ConnectorController).getConnectorId(namespace) === connectorId;
}

});
parcelRegister("58cAm", function(module, exports) {

$parcel$export(module.exports, "ConnectorController", () => $3bc776555737b5e0$export$c83edcb4eee2f517);

var $7zrdF = parcelRequire("7zrdF");

var $eFS1l = parcelRequire("eFS1l");

var $b3v9s = parcelRequire("b3v9s");
var $2Z0OY = parcelRequire("2Z0OY");

var $l4Kxs = parcelRequire("l4Kxs");

var $bc5dy = parcelRequire("bc5dy");

var $lCKEr = parcelRequire("lCKEr");

var $g9yWp = parcelRequire("g9yWp");

var $gD0RX = parcelRequire("gD0RX");

var $knC5d = parcelRequire("knC5d");

var $aZ8hw = parcelRequire("aZ8hw");

var $1VSgi = parcelRequire("1VSgi");
const $3bc776555737b5e0$var$defaultActiveConnectors = {
    eip155: undefined,
    solana: undefined,
    polkadot: undefined,
    bip122: undefined,
    cosmos: undefined
};
// -- State --------------------------------------------- //
const $3bc776555737b5e0$var$state = (0, $7zrdF.proxy)({
    allConnectors: [],
    connectors: [],
    activeConnector: undefined,
    filterByNamespace: undefined,
    activeConnectorIds: {
        ...$3bc776555737b5e0$var$defaultActiveConnectors
    },
    filterByNamespaceMap: {
        eip155: true,
        solana: true,
        polkadot: true,
        bip122: true,
        cosmos: true
    }
});
// -- Controller ---------------------------------------- //
const $3bc776555737b5e0$var$controller = {
    state: $3bc776555737b5e0$var$state,
    subscribe (callback) {
        return (0, $7zrdF.subscribe)($3bc776555737b5e0$var$state, ()=>{
            callback($3bc776555737b5e0$var$state);
        });
    },
    subscribeKey (key, callback) {
        return (0, $eFS1l.subscribeKey)($3bc776555737b5e0$var$state, key, callback);
    },
    initialize (namespaces) {
        namespaces.forEach((namespace)=>{
            const connectorId = (0, $bc5dy.StorageUtil).getConnectedConnectorId(namespace);
            if (connectorId) $3bc776555737b5e0$export$c83edcb4eee2f517.setConnectorId(connectorId, namespace);
        });
    },
    setActiveConnector (connector) {
        if (connector) $3bc776555737b5e0$var$state.activeConnector = (0, $7zrdF.ref)(connector);
    },
    setConnectors (connectors) {
        const newConnectors = connectors.filter((newConnector)=>!$3bc776555737b5e0$var$state.allConnectors.some((existingConnector)=>existingConnector.id === newConnector.id && $3bc776555737b5e0$export$c83edcb4eee2f517.getConnectorName(existingConnector.name) === $3bc776555737b5e0$export$c83edcb4eee2f517.getConnectorName(newConnector.name) && existingConnector.chain === newConnector.chain));
        /**
         * We are reassigning the state of the proxy to a new array of new objects, ConnectorController can cause issues. So it is better to use ref in ConnectorController case.
         * Check more about proxy on https://valtio.dev/docs/api/basic/proxy#Gotchas
         * Check more about ref on https://valtio.dev/docs/api/basic/ref
         */ newConnectors.forEach((connector)=>{
            if (connector.type !== "MULTI_CHAIN") $3bc776555737b5e0$var$state.allConnectors.push((0, $7zrdF.ref)(connector));
        });
        const enabledNamespaces = $3bc776555737b5e0$export$c83edcb4eee2f517.getEnabledNamespaces();
        const connectorsFilteredByNamespaces = $3bc776555737b5e0$export$c83edcb4eee2f517.getEnabledConnectors(enabledNamespaces);
        $3bc776555737b5e0$var$state.connectors = $3bc776555737b5e0$export$c83edcb4eee2f517.mergeMultiChainConnectors(connectorsFilteredByNamespaces);
    },
    filterByNamespaces (enabledNamespaces) {
        Object.keys($3bc776555737b5e0$var$state.filterByNamespaceMap).forEach((namespace)=>{
            $3bc776555737b5e0$var$state.filterByNamespaceMap[namespace] = false;
        });
        enabledNamespaces.forEach((namespace)=>{
            $3bc776555737b5e0$var$state.filterByNamespaceMap[namespace] = true;
        });
        $3bc776555737b5e0$export$c83edcb4eee2f517.updateConnectorsForEnabledNamespaces();
    },
    filterByNamespace (namespace, enabled) {
        $3bc776555737b5e0$var$state.filterByNamespaceMap[namespace] = enabled;
        $3bc776555737b5e0$export$c83edcb4eee2f517.updateConnectorsForEnabledNamespaces();
    },
    updateConnectorsForEnabledNamespaces () {
        const enabledNamespaces = $3bc776555737b5e0$export$c83edcb4eee2f517.getEnabledNamespaces();
        const enabledConnectors = $3bc776555737b5e0$export$c83edcb4eee2f517.getEnabledConnectors(enabledNamespaces);
        const areAllNamespacesEnabled = $3bc776555737b5e0$export$c83edcb4eee2f517.areAllNamespacesEnabled();
        $3bc776555737b5e0$var$state.connectors = $3bc776555737b5e0$export$c83edcb4eee2f517.mergeMultiChainConnectors(enabledConnectors);
        if (areAllNamespacesEnabled) (0, $g9yWp.ApiController).clearFilterByNamespaces();
        else (0, $g9yWp.ApiController).filterByNamespaces(enabledNamespaces);
    },
    getEnabledNamespaces () {
        return Object.entries($3bc776555737b5e0$var$state.filterByNamespaceMap).filter(([_, enabled])=>enabled).map(([namespace])=>namespace);
    },
    getEnabledConnectors (enabledNamespaces) {
        return $3bc776555737b5e0$var$state.allConnectors.filter((connector)=>enabledNamespaces.includes(connector.chain));
    },
    areAllNamespacesEnabled () {
        return Object.values($3bc776555737b5e0$var$state.filterByNamespaceMap).every((enabled)=>enabled);
    },
    mergeMultiChainConnectors (connectors) {
        const connectorsByNameMap = $3bc776555737b5e0$export$c83edcb4eee2f517.generateConnectorMapByName(connectors);
        const mergedConnectors = [];
        connectorsByNameMap.forEach((keyConnectors)=>{
            const firstItem = keyConnectors[0];
            const isAuthConnector = firstItem?.id === (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH;
            if (keyConnectors.length > 1 && firstItem) mergedConnectors.push({
                name: firstItem.name,
                imageUrl: firstItem.imageUrl,
                imageId: firstItem.imageId,
                connectors: [
                    ...keyConnectors
                ],
                type: isAuthConnector ? "AUTH" : "MULTI_CHAIN",
                // These values are just placeholders, we don't use them in multi-chain connector select screen
                chain: "eip155",
                id: firstItem?.id || ""
            });
            else if (firstItem) mergedConnectors.push(firstItem);
        });
        return mergedConnectors;
    },
    generateConnectorMapByName (connectors) {
        const connectorsByNameMap = new Map();
        connectors.forEach((connector)=>{
            const { name: name } = connector;
            const connectorName = $3bc776555737b5e0$export$c83edcb4eee2f517.getConnectorName(name);
            if (!connectorName) return;
            const connectorsByName = connectorsByNameMap.get(connectorName) || [];
            const haveSameConnector = connectorsByName.find((c)=>c.chain === connector.chain);
            if (!haveSameConnector) connectorsByName.push(connector);
            connectorsByNameMap.set(connectorName, connectorsByName);
        });
        return connectorsByNameMap;
    },
    getConnectorName (name) {
        if (!name) return name;
        const nameOverrideMap = {
            "Trust Wallet": "Trust"
        };
        return nameOverrideMap[name] || name;
    },
    getUniqueConnectorsByName (connectors) {
        const uniqueConnectors = [];
        connectors.forEach((c)=>{
            if (!uniqueConnectors.find((uc)=>uc.chain === c.chain)) uniqueConnectors.push(c);
        });
        return uniqueConnectors;
    },
    addConnector (connector) {
        if (connector.id === (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH) {
            const authConnector = connector;
            const optionsState = (0, $7zrdF.snapshot)((0, $knC5d.OptionsController).state);
            const themeMode = (0, $1VSgi.ThemeController).getSnapshot().themeMode;
            const themeVariables = (0, $1VSgi.ThemeController).getSnapshot().themeVariables;
            authConnector?.provider?.syncDappData?.({
                metadata: optionsState.metadata,
                sdkVersion: optionsState.sdkVersion,
                projectId: optionsState.projectId,
                sdkType: optionsState.sdkType
            });
            authConnector?.provider?.syncTheme({
                themeMode: themeMode,
                themeVariables: themeVariables,
                w3mThemeVariables: (0, $2Z0OY.getW3mThemeVariables)(themeVariables, themeMode)
            });
            $3bc776555737b5e0$export$c83edcb4eee2f517.setConnectors([
                connector
            ]);
        } else $3bc776555737b5e0$export$c83edcb4eee2f517.setConnectors([
            connector
        ]);
    },
    getAuthConnector (chainNamespace) {
        const activeNamespace = chainNamespace || (0, $gD0RX.ChainController).state.activeChain;
        const authConnector = $3bc776555737b5e0$var$state.connectors.find((c)=>c.id === (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH);
        if (!authConnector) return undefined;
        if (authConnector?.connectors?.length) {
            const connector = authConnector.connectors.find((c)=>c.chain === activeNamespace);
            return connector;
        }
        return authConnector;
    },
    getAnnouncedConnectorRdns () {
        return $3bc776555737b5e0$var$state.connectors.filter((c)=>c.type === "ANNOUNCED").map((c)=>c.info?.rdns);
    },
    getConnectorById (id) {
        return $3bc776555737b5e0$var$state.allConnectors.find((c)=>c.id === id);
    },
    getConnector (id, rdns) {
        const connectorsByNamespace = $3bc776555737b5e0$var$state.allConnectors.filter((c)=>c.chain === (0, $gD0RX.ChainController).state.activeChain);
        return connectorsByNamespace.find((c)=>c.explorerId === id || c.info?.rdns === rdns);
    },
    syncIfAuthConnector (connector) {
        if (connector.id !== "ID_AUTH") return;
        const authConnector = connector;
        const optionsState = (0, $7zrdF.snapshot)((0, $knC5d.OptionsController).state);
        const themeMode = (0, $1VSgi.ThemeController).getSnapshot().themeMode;
        const themeVariables = (0, $1VSgi.ThemeController).getSnapshot().themeVariables;
        authConnector?.provider?.syncDappData?.({
            metadata: optionsState.metadata,
            sdkVersion: optionsState.sdkVersion,
            sdkType: optionsState.sdkType,
            projectId: optionsState.projectId
        });
        authConnector.provider.syncTheme({
            themeMode: themeMode,
            themeVariables: themeVariables,
            w3mThemeVariables: (0, $2Z0OY.getW3mThemeVariables)(themeVariables, themeMode)
        });
    },
    /**
     * Returns the connectors filtered by namespace.
     * @param namespace - The namespace to filter the connectors by.
     * @returns ConnectorWithProviders[].
     */ getConnectorsByNamespace (namespace) {
        const namespaceConnectors = $3bc776555737b5e0$var$state.allConnectors.filter((connector)=>connector.chain === namespace);
        return $3bc776555737b5e0$export$c83edcb4eee2f517.mergeMultiChainConnectors(namespaceConnectors);
    },
    selectWalletConnector (wallet) {
        const connector = $3bc776555737b5e0$export$c83edcb4eee2f517.getConnector(wallet.id, wallet.rdns);
        (0, $l4Kxs.MobileWalletUtil).handleMobileDeeplinkRedirect(connector?.name || wallet.name || "");
        if (connector) (0, $aZ8hw.RouterController).push("ConnectingExternal", {
            connector: connector
        });
        else (0, $aZ8hw.RouterController).push("ConnectingWalletConnect", {
            wallet: wallet
        });
    },
    /**
     * Returns the connectors. If a namespace is provided, the connectors are filtered by namespace.
     * @param namespace - The namespace to filter the connectors by. If not provided, all connectors are returned.
     * @returns ConnectorWithProviders[].
     */ getConnectors (namespace) {
        if (namespace) return $3bc776555737b5e0$export$c83edcb4eee2f517.getConnectorsByNamespace(namespace);
        return $3bc776555737b5e0$export$c83edcb4eee2f517.mergeMultiChainConnectors($3bc776555737b5e0$var$state.allConnectors);
    },
    /**
     * Sets the filter by namespace and updates the connectors.
     * @param namespace - The namespace to filter the connectors by.
     */ setFilterByNamespace (namespace) {
        $3bc776555737b5e0$var$state.filterByNamespace = namespace;
        $3bc776555737b5e0$var$state.connectors = $3bc776555737b5e0$export$c83edcb4eee2f517.getConnectors(namespace);
        (0, $g9yWp.ApiController).setFilterByNamespace(namespace);
    },
    setConnectorId (connectorId, namespace) {
        if (connectorId) {
            $3bc776555737b5e0$var$state.activeConnectorIds = {
                ...$3bc776555737b5e0$var$state.activeConnectorIds,
                [namespace]: connectorId
            };
            (0, $bc5dy.StorageUtil).setConnectedConnectorId(namespace, connectorId);
        }
    },
    removeConnectorId (namespace) {
        $3bc776555737b5e0$var$state.activeConnectorIds = {
            ...$3bc776555737b5e0$var$state.activeConnectorIds,
            [namespace]: undefined
        };
        (0, $bc5dy.StorageUtil).deleteConnectedConnectorId(namespace);
    },
    getConnectorId (namespace) {
        if (!namespace) return undefined;
        return $3bc776555737b5e0$var$state.activeConnectorIds[namespace];
    },
    isConnected (namespace) {
        if (!namespace) return Object.values($3bc776555737b5e0$var$state.activeConnectorIds).some((id)=>Boolean(id));
        return Boolean($3bc776555737b5e0$var$state.activeConnectorIds[namespace]);
    },
    resetConnectorIds () {
        $3bc776555737b5e0$var$state.activeConnectorIds = {
            ...$3bc776555737b5e0$var$defaultActiveConnectors
        };
    }
};
const $3bc776555737b5e0$export$c83edcb4eee2f517 = (0, $lCKEr.withErrorBoundary)($3bc776555737b5e0$var$controller);

});
parcelRegister("2Z0OY", function(module, exports) {

$parcel$export(module.exports, "getW3mThemeVariables", () => $22c1ea5dba4ba169$export$5ab0d52f4d8873e4);
function $22c1ea5dba4ba169$export$5ab0d52f4d8873e4(themeVariables, themeType) {
    if (themeType === "light") return {
        "--w3m-accent": themeVariables?.["--w3m-accent"] || "hsla(231, 100%, 70%, 1)",
        "--w3m-background": "#fff"
    };
    return {
        "--w3m-accent": themeVariables?.["--w3m-accent"] || "hsla(230, 100%, 67%, 1)",
        "--w3m-background": "#121313"
    };
}

});

parcelRegister("l4Kxs", function(module, exports) {

$parcel$export(module.exports, "MobileWalletUtil", () => $f57e1247d8abbc58$export$427ad77d295e63b7);

var $b3v9s = parcelRequire("b3v9s");

var $gD0RX = parcelRequire("gD0RX");
const $f57e1247d8abbc58$export$427ad77d295e63b7 = {
    /**
     * Handles mobile wallet redirection for wallets that have Universal Links and doesn't support WalletConnect Deep Links.
     *
     * @param {Object} properties - The properties object.
     * @param {string} properties.name - The name of the wallet.
     */ handleMobileDeeplinkRedirect (name) {
        /**
         * Universal Links requires explicit user interaction to open the wallet app.
         * Previously we've been calling this with the life-cycle methods in the Solana clients by listening the SELECT_WALLET event of EventController.
         * But this breaks the UL functionality for some wallets like Phantom.
         */ const href = window.location.href;
        const encodedHref = encodeURIComponent(href);
        if (name === "Phantom" && !("phantom" in window)) {
            const protocol = href.startsWith("https") ? "https" : "http";
            const host = href.split("/")[2];
            const encodedRef = encodeURIComponent(`${protocol}://${host}`);
            window.location.href = `https://phantom.app/ul/browse/${encodedHref}?ref=${encodedRef}`;
        }
        if ((0, $gD0RX.ChainController).state.activeChain === (0, $b3v9s.ConstantsUtil).CHAIN.SOLANA) {
            if (name === "Coinbase Wallet" && !("coinbaseSolana" in window)) window.location.href = `https://go.cb-w.com/dapp?cb_url=${encodedHref}`;
        }
    }
};

});

parcelRegister("lCKEr", function(module, exports) {

$parcel$export(module.exports, "AppKitError", () => $fbe1559200f0e29a$export$70c3fe4248426d1b);
$parcel$export(module.exports, "withErrorBoundary", () => $fbe1559200f0e29a$export$f0c7a449e0cfaec7);

var $kQVGN = parcelRequire("kQVGN");
class $fbe1559200f0e29a$export$70c3fe4248426d1b extends Error {
    constructor(message, category, originalError){
        super(message);
        this.name = "AppKitError";
        this.category = category;
        this.originalError = originalError;
        // Maintain proper stack trace
        if (Error.captureStackTrace) Error.captureStackTrace(this, $fbe1559200f0e29a$export$70c3fe4248426d1b);
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $fbe1559200f0e29a$var$errorHandler(err, defaultCategory) {
    const error = err instanceof $fbe1559200f0e29a$export$70c3fe4248426d1b ? err : new $fbe1559200f0e29a$export$70c3fe4248426d1b(err instanceof Error ? err.message : String(err), defaultCategory, err);
    (0, $kQVGN.TelemetryController).sendError(error, error.category);
    throw error;
}
function $fbe1559200f0e29a$export$f0c7a449e0cfaec7(controller, defaultCategory = "INTERNAL_SDK_ERROR") {
    const newController = {};
    Object.keys(controller).forEach((key)=>{
        const original = controller[key];
        if (typeof original === "function") {
            let wrapped = original;
            if (original.constructor.name === "AsyncFunction") wrapped = async (...args)=>{
                try {
                    return await original(...args);
                } catch (err) {
                    return $fbe1559200f0e29a$var$errorHandler(err, defaultCategory);
                }
            };
            else wrapped = (...args)=>{
                try {
                    return original(...args);
                } catch (err) {
                    return $fbe1559200f0e29a$var$errorHandler(err, defaultCategory);
                }
            };
            newController[key] = wrapped;
        } else newController[key] = original;
    });
    return newController;
}

});
parcelRegister("kQVGN", function(module, exports) {

$parcel$export(module.exports, "TelemetryController", () => $f2e569e320035028$export$d990c2d8e50fc036);

var $7zrdF = parcelRequire("7zrdF");

var $eFS1l = parcelRequire("eFS1l");

var $lpmCO = parcelRequire("lpmCO");

var $6gqz8 = parcelRequire("6gqz8");

var $knC5d = parcelRequire("knC5d");
// -- Constants ----------------------------------------- //
const $f2e569e320035028$var$DEFAULT_STATE = Object.freeze({
    enabled: true,
    events: []
});
const $f2e569e320035028$var$api = new (0, $6gqz8.FetchUtil)({
    baseUrl: (0, $lpmCO.CoreHelperUtil).getAnalyticsUrl(),
    clientId: null
});
// Rate limiting constants
const $f2e569e320035028$var$MAX_ERRORS_PER_MINUTE = 5;
const $f2e569e320035028$var$ONE_MINUTE_MS = 60000;
// -- State --------------------------------------------- //
const $f2e569e320035028$var$state = (0, $7zrdF.proxy)({
    ...$f2e569e320035028$var$DEFAULT_STATE
});
const $f2e569e320035028$export$d990c2d8e50fc036 = {
    state: $f2e569e320035028$var$state,
    subscribeKey (key, callback) {
        return (0, $eFS1l.subscribeKey)($f2e569e320035028$var$state, key, callback);
    },
    async sendError (error, category) {
        if (!$f2e569e320035028$var$state.enabled) return;
        // Check rate limiting using events array
        const now = Date.now();
        const recentErrors = $f2e569e320035028$var$state.events.filter((event)=>{
            const eventTime = new Date(event.properties.timestamp || "").getTime();
            return now - eventTime < $f2e569e320035028$var$ONE_MINUTE_MS;
        });
        if (recentErrors.length >= $f2e569e320035028$var$MAX_ERRORS_PER_MINUTE) // Exit silently
        return;
        const errorEvent = {
            type: "error",
            event: category,
            properties: {
                errorType: error.name,
                errorMessage: error.message,
                stackTrace: error.stack,
                timestamp: new Date().toISOString()
            }
        };
        $f2e569e320035028$var$state.events.push(errorEvent);
        try {
            if (typeof window === "undefined") return;
            const { projectId: projectId, sdkType: sdkType, sdkVersion: sdkVersion } = (0, $knC5d.OptionsController).state;
            await $f2e569e320035028$var$api.post({
                path: "/e",
                params: {
                    projectId: projectId,
                    st: sdkType,
                    sv: sdkVersion || "html-wagmi-4.2.2"
                },
                body: {
                    eventId: (0, $lpmCO.CoreHelperUtil).getUUID(),
                    url: window.location.href,
                    domain: window.location.hostname,
                    timestamp: new Date().toISOString(),
                    props: {
                        type: "error",
                        event: category,
                        errorType: error.name,
                        errorMessage: error.message,
                        stackTrace: error.stack
                    }
                }
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error("Error sending telemetry event:", err);
        }
    },
    enable () {
        $f2e569e320035028$var$state.enabled = true;
    },
    disable () {
        $f2e569e320035028$var$state.enabled = false;
    },
    clearEvents () {
        $f2e569e320035028$var$state.events = [];
    }
};

});
parcelRegister("6gqz8", function(module, exports) {

$parcel$export(module.exports, "FetchUtil", () => $48f8d8146d83d30d$export$ed6eff17d860976a);
async function $48f8d8146d83d30d$var$fetchData(...args) {
    const response = await fetch(...args);
    if (!response.ok) {
        // Create error object and reject if not a 2xx response code
        const err = new Error(`HTTP status code: ${response.status}`, {
            cause: response
        });
        throw err;
    }
    return response;
}
class $48f8d8146d83d30d$export$ed6eff17d860976a {
    constructor({ baseUrl: baseUrl, clientId: clientId }){
        this.baseUrl = baseUrl;
        this.clientId = clientId;
    }
    async get({ headers: headers, signal: signal, cache: cache, ...args }) {
        const url = this.createUrl(args);
        const response = await $48f8d8146d83d30d$var$fetchData(url, {
            method: "GET",
            headers: headers,
            signal: signal,
            cache: cache
        });
        return response.json();
    }
    async getBlob({ headers: headers, signal: signal, ...args }) {
        const url = this.createUrl(args);
        const response = await $48f8d8146d83d30d$var$fetchData(url, {
            method: "GET",
            headers: headers,
            signal: signal
        });
        return response.blob();
    }
    async post({ body: body, headers: headers, signal: signal, ...args }) {
        const url = this.createUrl(args);
        const response = await $48f8d8146d83d30d$var$fetchData(url, {
            method: "POST",
            headers: headers,
            body: body ? JSON.stringify(body) : undefined,
            signal: signal
        });
        return response.json();
    }
    async put({ body: body, headers: headers, signal: signal, ...args }) {
        const url = this.createUrl(args);
        const response = await $48f8d8146d83d30d$var$fetchData(url, {
            method: "PUT",
            headers: headers,
            body: body ? JSON.stringify(body) : undefined,
            signal: signal
        });
        return response.json();
    }
    async delete({ body: body, headers: headers, signal: signal, ...args }) {
        const url = this.createUrl(args);
        const response = await $48f8d8146d83d30d$var$fetchData(url, {
            method: "DELETE",
            headers: headers,
            body: body ? JSON.stringify(body) : undefined,
            signal: signal
        });
        return response.json();
    }
    createUrl({ path: path, params: params }) {
        const url = new URL(path, this.baseUrl);
        if (params) Object.entries(params).forEach(([key, value])=>{
            if (value) url.searchParams.append(key, value);
        });
        if (this.clientId) url.searchParams.append("clientId", this.clientId);
        return url;
    }
}

});

parcelRegister("knC5d", function(module, exports) {

$parcel$export(module.exports, "OptionsController", () => $ed637f20d0fc6e00$export$1f4c428077fc6173);

var $7zrdF = parcelRequire("7zrdF");

var $eFS1l = parcelRequire("eFS1l");

var $3h0dG = parcelRequire("3h0dG");

var $4A1mi = parcelRequire("4A1mi");
// -- State --------------------------------------------- //
const $ed637f20d0fc6e00$var$state = (0, $7zrdF.proxy)({
    features: (0, $3h0dG.ConstantsUtil).DEFAULT_FEATURES,
    projectId: "",
    sdkType: "appkit",
    sdkVersion: "html-wagmi-undefined",
    defaultAccountTypes: (0, $3h0dG.ConstantsUtil).DEFAULT_ACCOUNT_TYPES,
    enableNetworkSwitch: true,
    experimental_preferUniversalLinks: false,
    remoteFeatures: {}
});
const $ed637f20d0fc6e00$export$1f4c428077fc6173 = {
    state: $ed637f20d0fc6e00$var$state,
    subscribeKey (key, callback) {
        return (0, $eFS1l.subscribeKey)($ed637f20d0fc6e00$var$state, key, callback);
    },
    setOptions (options) {
        Object.assign($ed637f20d0fc6e00$var$state, options);
    },
    setRemoteFeatures (remoteFeatures) {
        if (!remoteFeatures) return;
        const newRemoteFeatures = {
            ...$ed637f20d0fc6e00$var$state.remoteFeatures,
            ...remoteFeatures
        };
        $ed637f20d0fc6e00$var$state.remoteFeatures = newRemoteFeatures;
        if ($ed637f20d0fc6e00$var$state.remoteFeatures?.socials) $ed637f20d0fc6e00$var$state.remoteFeatures.socials = (0, $4A1mi.OptionsUtil).filterSocialsByPlatform($ed637f20d0fc6e00$var$state.remoteFeatures.socials);
    },
    setFeatures (features) {
        if (!features) return;
        if (!$ed637f20d0fc6e00$var$state.features) $ed637f20d0fc6e00$var$state.features = (0, $3h0dG.ConstantsUtil).DEFAULT_FEATURES;
        const newFeatures = {
            ...$ed637f20d0fc6e00$var$state.features,
            ...features
        };
        $ed637f20d0fc6e00$var$state.features = newFeatures;
    },
    setProjectId (projectId) {
        $ed637f20d0fc6e00$var$state.projectId = projectId;
    },
    setCustomRpcUrls (customRpcUrls) {
        $ed637f20d0fc6e00$var$state.customRpcUrls = customRpcUrls;
    },
    setAllWallets (allWallets) {
        $ed637f20d0fc6e00$var$state.allWallets = allWallets;
    },
    setIncludeWalletIds (includeWalletIds) {
        $ed637f20d0fc6e00$var$state.includeWalletIds = includeWalletIds;
    },
    setExcludeWalletIds (excludeWalletIds) {
        $ed637f20d0fc6e00$var$state.excludeWalletIds = excludeWalletIds;
    },
    setFeaturedWalletIds (featuredWalletIds) {
        $ed637f20d0fc6e00$var$state.featuredWalletIds = featuredWalletIds;
    },
    setTokens (tokens) {
        $ed637f20d0fc6e00$var$state.tokens = tokens;
    },
    setTermsConditionsUrl (termsConditionsUrl) {
        $ed637f20d0fc6e00$var$state.termsConditionsUrl = termsConditionsUrl;
    },
    setPrivacyPolicyUrl (privacyPolicyUrl) {
        $ed637f20d0fc6e00$var$state.privacyPolicyUrl = privacyPolicyUrl;
    },
    setCustomWallets (customWallets) {
        $ed637f20d0fc6e00$var$state.customWallets = customWallets;
    },
    setIsSiweEnabled (isSiweEnabled) {
        $ed637f20d0fc6e00$var$state.isSiweEnabled = isSiweEnabled;
    },
    setIsUniversalProvider (isUniversalProvider) {
        $ed637f20d0fc6e00$var$state.isUniversalProvider = isUniversalProvider;
    },
    setSdkVersion (sdkVersion) {
        $ed637f20d0fc6e00$var$state.sdkVersion = sdkVersion;
    },
    setMetadata (metadata) {
        $ed637f20d0fc6e00$var$state.metadata = metadata;
    },
    setDisableAppend (disableAppend) {
        $ed637f20d0fc6e00$var$state.disableAppend = disableAppend;
    },
    setEIP6963Enabled (enableEIP6963) {
        $ed637f20d0fc6e00$var$state.enableEIP6963 = enableEIP6963;
    },
    setDebug (debug) {
        $ed637f20d0fc6e00$var$state.debug = debug;
    },
    setEnableWalletConnect (enableWalletConnect) {
        $ed637f20d0fc6e00$var$state.enableWalletConnect = enableWalletConnect;
    },
    setEnableWalletGuide (enableWalletGuide) {
        $ed637f20d0fc6e00$var$state.enableWalletGuide = enableWalletGuide;
    },
    setEnableAuthLogger (enableAuthLogger) {
        $ed637f20d0fc6e00$var$state.enableAuthLogger = enableAuthLogger;
    },
    setEnableWallets (enableWallets) {
        $ed637f20d0fc6e00$var$state.enableWallets = enableWallets;
    },
    setPreferUniversalLinks (preferUniversalLinks) {
        $ed637f20d0fc6e00$var$state.experimental_preferUniversalLinks = preferUniversalLinks;
    },
    setHasMultipleAddresses (hasMultipleAddresses) {
        $ed637f20d0fc6e00$var$state.hasMultipleAddresses = hasMultipleAddresses;
    },
    setSIWX (siwx) {
        $ed637f20d0fc6e00$var$state.siwx = siwx;
    },
    setConnectMethodsOrder (connectMethodsOrder) {
        $ed637f20d0fc6e00$var$state.features = {
            ...$ed637f20d0fc6e00$var$state.features,
            connectMethodsOrder: connectMethodsOrder
        };
    },
    setWalletFeaturesOrder (walletFeaturesOrder) {
        $ed637f20d0fc6e00$var$state.features = {
            ...$ed637f20d0fc6e00$var$state.features,
            walletFeaturesOrder: walletFeaturesOrder
        };
    },
    setSocialsOrder (socialsOrder) {
        $ed637f20d0fc6e00$var$state.remoteFeatures = {
            ...$ed637f20d0fc6e00$var$state.remoteFeatures,
            socials: socialsOrder
        };
    },
    setCollapseWallets (collapseWallets) {
        $ed637f20d0fc6e00$var$state.features = {
            ...$ed637f20d0fc6e00$var$state.features,
            collapseWallets: collapseWallets
        };
    },
    setEnableEmbedded (enableEmbedded) {
        $ed637f20d0fc6e00$var$state.enableEmbedded = enableEmbedded;
    },
    setAllowUnsupportedChain (allowUnsupportedChain) {
        $ed637f20d0fc6e00$var$state.allowUnsupportedChain = allowUnsupportedChain;
    },
    setManualWCControl (manualWCControl) {
        $ed637f20d0fc6e00$var$state.manualWCControl = manualWCControl;
    },
    setEnableNetworkSwitch (enableNetworkSwitch) {
        $ed637f20d0fc6e00$var$state.enableNetworkSwitch = enableNetworkSwitch;
    },
    setDefaultAccountTypes (defaultAccountType = {}) {
        Object.entries(defaultAccountType).forEach(([namespace, accountType])=>{
            if (accountType) // @ts-expect-error - Keys are validated by the param type
            $ed637f20d0fc6e00$var$state.defaultAccountTypes[namespace] = accountType;
        });
    },
    setUniversalProviderConfigOverride (universalProviderConfigOverride) {
        $ed637f20d0fc6e00$var$state.universalProviderConfigOverride = universalProviderConfigOverride;
    },
    getUniversalProviderConfigOverride () {
        return $ed637f20d0fc6e00$var$state.universalProviderConfigOverride;
    },
    getSnapshot () {
        return (0, $7zrdF.snapshot)($ed637f20d0fc6e00$var$state);
    }
};

});
parcelRegister("4A1mi", function(module, exports) {

$parcel$export(module.exports, "OptionsUtil", () => $355b940597bd1a05$export$4e43e6147f798743);

var $3h0dG = parcelRequire("3h0dG");

var $lpmCO = parcelRequire("lpmCO");
const $355b940597bd1a05$export$4e43e6147f798743 = {
    getFeatureValue (key, features) {
        const optionValue = features?.[key];
        if (optionValue === undefined) return (0, $3h0dG.ConstantsUtil).DEFAULT_FEATURES[key];
        return optionValue;
    },
    filterSocialsByPlatform (socials) {
        if (!socials || !socials.length) return socials;
        if ((0, $lpmCO.CoreHelperUtil).isTelegram()) {
            if ((0, $lpmCO.CoreHelperUtil).isIos()) return socials.filter((s)=>s !== "google");
            if ((0, $lpmCO.CoreHelperUtil).isMac()) return socials.filter((s)=>s !== "x");
            if ((0, $lpmCO.CoreHelperUtil).isAndroid()) return socials.filter((s)=>![
                    "facebook",
                    "x"
                ].includes(s));
        }
        return socials;
    }
};

});




parcelRegister("g9yWp", function(module, exports) {

$parcel$export(module.exports, "ApiController", () => $bc289733aa6ea9a1$export$99411f73957952af);

var $7zrdF = parcelRequire("7zrdF");

var $eFS1l = parcelRequire("eFS1l");

var $9PqFe = parcelRequire("9PqFe");

var $lpmCO = parcelRequire("lpmCO");

var $6gqz8 = parcelRequire("6gqz8");

var $bc5dy = parcelRequire("bc5dy");

var $2ccEg = parcelRequire("2ccEg");

var $gD0RX = parcelRequire("gD0RX");

var $58cAm = parcelRequire("58cAm");

var $5FNhR = parcelRequire("5FNhR");

var $knC5d = parcelRequire("knC5d");
const $bc289733aa6ea9a1$export$46fb589ed2c53885 = {
    PHANTOM: "a797aa35c0fadbfc1a53e7f675162ed5226968b44a19ee3d24385c64d1d3c393",
    COINBASE: "fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa"
};
// -- Helpers ------------------------------------------- //
const $bc289733aa6ea9a1$var$baseUrl = (0, $lpmCO.CoreHelperUtil).getApiUrl();
const $bc289733aa6ea9a1$export$644d8ea042df96a6 = new (0, $6gqz8.FetchUtil)({
    baseUrl: $bc289733aa6ea9a1$var$baseUrl,
    clientId: null
});
const $bc289733aa6ea9a1$var$entries = 40;
const $bc289733aa6ea9a1$var$recommendedEntries = 4;
const $bc289733aa6ea9a1$var$imageCountToFetch = 20;
// -- State --------------------------------------------- //
const $bc289733aa6ea9a1$var$state = (0, $7zrdF.proxy)({
    promises: {},
    page: 1,
    count: 0,
    featured: [],
    allFeatured: [],
    recommended: [],
    allRecommended: [],
    wallets: [],
    filteredWallets: [],
    search: [],
    isAnalyticsEnabled: false,
    excludedWallets: [],
    isFetchingRecommendedWallets: false
});
const $bc289733aa6ea9a1$export$99411f73957952af = {
    state: $bc289733aa6ea9a1$var$state,
    subscribeKey (key, callback) {
        return (0, $eFS1l.subscribeKey)($bc289733aa6ea9a1$var$state, key, callback);
    },
    _getSdkProperties () {
        const { projectId: projectId, sdkType: sdkType, sdkVersion: sdkVersion } = (0, $knC5d.OptionsController).state;
        return {
            projectId: projectId,
            st: sdkType || "appkit",
            sv: sdkVersion || "html-wagmi-4.2.2"
        };
    },
    _filterOutExtensions (wallets) {
        if ((0, $knC5d.OptionsController).state.isUniversalProvider) return wallets.filter((w)=>Boolean(w.mobile_link || w.desktop_link || w.webapp_link));
        return wallets;
    },
    async _fetchWalletImage (imageId) {
        const imageUrl = `${$bc289733aa6ea9a1$export$644d8ea042df96a6.baseUrl}/getWalletImage/${imageId}`;
        const blob = await $bc289733aa6ea9a1$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            params: $bc289733aa6ea9a1$export$99411f73957952af._getSdkProperties()
        });
        (0, $2ccEg.AssetController).setWalletImage(imageId, URL.createObjectURL(blob));
    },
    async _fetchNetworkImage (imageId) {
        const imageUrl = `${$bc289733aa6ea9a1$export$644d8ea042df96a6.baseUrl}/public/getAssetImage/${imageId}`;
        const blob = await $bc289733aa6ea9a1$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            params: $bc289733aa6ea9a1$export$99411f73957952af._getSdkProperties()
        });
        (0, $2ccEg.AssetController).setNetworkImage(imageId, URL.createObjectURL(blob));
    },
    async _fetchConnectorImage (imageId) {
        const imageUrl = `${$bc289733aa6ea9a1$export$644d8ea042df96a6.baseUrl}/public/getAssetImage/${imageId}`;
        const blob = await $bc289733aa6ea9a1$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            params: $bc289733aa6ea9a1$export$99411f73957952af._getSdkProperties()
        });
        (0, $2ccEg.AssetController).setConnectorImage(imageId, URL.createObjectURL(blob));
    },
    async _fetchCurrencyImage (countryCode) {
        const imageUrl = `${$bc289733aa6ea9a1$export$644d8ea042df96a6.baseUrl}/public/getCurrencyImage/${countryCode}`;
        const blob = await $bc289733aa6ea9a1$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            params: $bc289733aa6ea9a1$export$99411f73957952af._getSdkProperties()
        });
        (0, $2ccEg.AssetController).setCurrencyImage(countryCode, URL.createObjectURL(blob));
    },
    async _fetchTokenImage (symbol) {
        const imageUrl = `${$bc289733aa6ea9a1$export$644d8ea042df96a6.baseUrl}/public/getTokenImage/${symbol}`;
        const blob = await $bc289733aa6ea9a1$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            params: $bc289733aa6ea9a1$export$99411f73957952af._getSdkProperties()
        });
        (0, $2ccEg.AssetController).setTokenImage(symbol, URL.createObjectURL(blob));
    },
    _filterWalletsByPlatform (wallets) {
        const filteredWallets = (0, $lpmCO.CoreHelperUtil).isMobile() ? wallets?.filter((w)=>w.mobile_link || w.id === $bc289733aa6ea9a1$export$46fb589ed2c53885.COINBASE || w.id === $bc289733aa6ea9a1$export$46fb589ed2c53885.PHANTOM && (0, $gD0RX.ChainController).state.activeChain === "solana") : wallets;
        return filteredWallets;
    },
    async fetchProjectConfig () {
        const response = await $bc289733aa6ea9a1$export$644d8ea042df96a6.get({
            path: "/appkit/v1/config",
            params: $bc289733aa6ea9a1$export$99411f73957952af._getSdkProperties()
        });
        return response.features;
    },
    async fetchAllowedOrigins () {
        try {
            const { allowedOrigins: allowedOrigins } = await $bc289733aa6ea9a1$export$644d8ea042df96a6.get({
                path: "/projects/v1/origins",
                params: $bc289733aa6ea9a1$export$99411f73957952af._getSdkProperties()
            });
            return allowedOrigins;
        } catch (error) {
            return [];
        }
    },
    async fetchNetworkImages () {
        const requestedCaipNetworks = (0, $gD0RX.ChainController).getAllRequestedCaipNetworks();
        const ids = requestedCaipNetworks?.map(({ assets: assets })=>assets?.imageId).filter(Boolean).filter((imageId)=>!(0, $9PqFe.AssetUtil).getNetworkImageById(imageId));
        if (ids) await Promise.allSettled(ids.map((id)=>$bc289733aa6ea9a1$export$99411f73957952af._fetchNetworkImage(id)));
    },
    async fetchConnectorImages () {
        const { connectors: connectors } = (0, $58cAm.ConnectorController).state;
        const ids = connectors.map(({ imageId: imageId })=>imageId).filter(Boolean);
        await Promise.allSettled(ids.map((id)=>$bc289733aa6ea9a1$export$99411f73957952af._fetchConnectorImage(id)));
    },
    async fetchCurrencyImages (currencies = []) {
        await Promise.allSettled(currencies.map((currency)=>$bc289733aa6ea9a1$export$99411f73957952af._fetchCurrencyImage(currency)));
    },
    async fetchTokenImages (tokens = []) {
        await Promise.allSettled(tokens.map((token)=>$bc289733aa6ea9a1$export$99411f73957952af._fetchTokenImage(token)));
    },
    async fetchWallets (params) {
        const exclude = params.exclude ?? [];
        const sdkProperties = $bc289733aa6ea9a1$export$99411f73957952af._getSdkProperties();
        if (sdkProperties.sv.startsWith("html-core-")) exclude.push(...Object.values($bc289733aa6ea9a1$export$46fb589ed2c53885));
        const wallets = await $bc289733aa6ea9a1$export$644d8ea042df96a6.get({
            path: "/getWallets",
            params: {
                ...$bc289733aa6ea9a1$export$99411f73957952af._getSdkProperties(),
                ...params,
                page: String(params.page),
                entries: String(params.entries),
                include: params.include?.join(","),
                exclude: exclude.join(",")
            }
        });
        const filteredWallets = $bc289733aa6ea9a1$export$99411f73957952af._filterWalletsByPlatform(wallets?.data);
        return {
            data: filteredWallets || [],
            // Keep original count for display on main page
            count: wallets?.count
        };
    },
    async fetchFeaturedWallets () {
        const { featuredWalletIds: featuredWalletIds } = (0, $knC5d.OptionsController).state;
        if (featuredWalletIds?.length) {
            const params = {
                ...$bc289733aa6ea9a1$export$99411f73957952af._getSdkProperties(),
                page: 1,
                entries: featuredWalletIds?.length ?? $bc289733aa6ea9a1$var$recommendedEntries,
                include: featuredWalletIds
            };
            const { data: data } = await $bc289733aa6ea9a1$export$99411f73957952af.fetchWallets(params);
            const sortedData = [
                ...data
            ].sort((a, b)=>featuredWalletIds.indexOf(a.id) - featuredWalletIds.indexOf(b.id));
            const images = sortedData.map((d)=>d.image_id).filter(Boolean);
            await Promise.allSettled(images.map((id)=>$bc289733aa6ea9a1$export$99411f73957952af._fetchWalletImage(id)));
            $bc289733aa6ea9a1$var$state.featured = sortedData;
            $bc289733aa6ea9a1$var$state.allFeatured = sortedData;
        }
    },
    async fetchRecommendedWallets () {
        try {
            $bc289733aa6ea9a1$var$state.isFetchingRecommendedWallets = true;
            const { includeWalletIds: includeWalletIds, excludeWalletIds: excludeWalletIds, featuredWalletIds: featuredWalletIds } = (0, $knC5d.OptionsController).state;
            const exclude = [
                ...excludeWalletIds ?? [],
                ...featuredWalletIds ?? []
            ].filter(Boolean);
            const chains = (0, $gD0RX.ChainController).getRequestedCaipNetworkIds().join(",");
            const params = {
                page: 1,
                entries: $bc289733aa6ea9a1$var$recommendedEntries,
                include: includeWalletIds,
                exclude: exclude,
                chains: chains
            };
            const { data: data, count: count } = await $bc289733aa6ea9a1$export$99411f73957952af.fetchWallets(params);
            const recent = (0, $bc5dy.StorageUtil).getRecentWallets();
            const recommendedImages = data.map((d)=>d.image_id).filter(Boolean);
            const recentImages = recent.map((r)=>r.image_id).filter(Boolean);
            await Promise.allSettled([
                ...recommendedImages,
                ...recentImages
            ].map((id)=>$bc289733aa6ea9a1$export$99411f73957952af._fetchWalletImage(id)));
            $bc289733aa6ea9a1$var$state.recommended = data;
            $bc289733aa6ea9a1$var$state.allRecommended = data;
            $bc289733aa6ea9a1$var$state.count = count ?? 0;
        } catch  {
        // Catch silently
        } finally{
            $bc289733aa6ea9a1$var$state.isFetchingRecommendedWallets = false;
        }
    },
    async fetchWalletsByPage ({ page: page }) {
        const { includeWalletIds: includeWalletIds, excludeWalletIds: excludeWalletIds, featuredWalletIds: featuredWalletIds } = (0, $knC5d.OptionsController).state;
        const chains = (0, $gD0RX.ChainController).getRequestedCaipNetworkIds().join(",");
        const exclude = [
            ...$bc289733aa6ea9a1$var$state.recommended.map(({ id: id })=>id),
            ...excludeWalletIds ?? [],
            ...featuredWalletIds ?? []
        ].filter(Boolean);
        const params = {
            page: page,
            entries: $bc289733aa6ea9a1$var$entries,
            include: includeWalletIds,
            exclude: exclude,
            chains: chains
        };
        const { data: data, count: count } = await $bc289733aa6ea9a1$export$99411f73957952af.fetchWallets(params);
        const images = data.slice(0, $bc289733aa6ea9a1$var$imageCountToFetch).map((w)=>w.image_id).filter(Boolean);
        await Promise.allSettled(images.map((id)=>$bc289733aa6ea9a1$export$99411f73957952af._fetchWalletImage(id)));
        $bc289733aa6ea9a1$var$state.wallets = (0, $lpmCO.CoreHelperUtil).uniqueBy([
            ...$bc289733aa6ea9a1$var$state.wallets,
            ...$bc289733aa6ea9a1$export$99411f73957952af._filterOutExtensions(data)
        ], "id").filter((w)=>w.chains?.some((chain)=>chains.includes(chain)));
        $bc289733aa6ea9a1$var$state.count = count > $bc289733aa6ea9a1$var$state.count ? count : $bc289733aa6ea9a1$var$state.count;
        $bc289733aa6ea9a1$var$state.page = page;
    },
    async initializeExcludedWallets ({ ids: ids }) {
        const params = {
            page: 1,
            entries: ids.length,
            include: ids
        };
        const { data: data } = await $bc289733aa6ea9a1$export$99411f73957952af.fetchWallets(params);
        if (data) data.forEach((wallet)=>{
            $bc289733aa6ea9a1$var$state.excludedWallets.push({
                rdns: wallet.rdns,
                name: wallet.name
            });
        });
    },
    async searchWallet ({ search: search, badge: badge }) {
        const { includeWalletIds: includeWalletIds, excludeWalletIds: excludeWalletIds } = (0, $knC5d.OptionsController).state;
        const chains = (0, $gD0RX.ChainController).getRequestedCaipNetworkIds().join(",");
        $bc289733aa6ea9a1$var$state.search = [];
        const params = {
            page: 1,
            entries: 100,
            search: search?.trim(),
            badge_type: badge,
            include: includeWalletIds,
            exclude: excludeWalletIds,
            chains: chains
        };
        const { data: data } = await $bc289733aa6ea9a1$export$99411f73957952af.fetchWallets(params);
        (0, $5FNhR.EventsController).sendEvent({
            type: "track",
            event: "SEARCH_WALLET",
            properties: {
                badge: badge ?? "",
                search: search ?? ""
            }
        });
        const images = data.map((w)=>w.image_id).filter(Boolean);
        await Promise.allSettled([
            ...images.map((id)=>$bc289733aa6ea9a1$export$99411f73957952af._fetchWalletImage(id)),
            (0, $lpmCO.CoreHelperUtil).wait(300)
        ]);
        $bc289733aa6ea9a1$var$state.search = $bc289733aa6ea9a1$export$99411f73957952af._filterOutExtensions(data);
    },
    initPromise (key, fetchFn) {
        const existingPromise = $bc289733aa6ea9a1$var$state.promises[key];
        if (existingPromise) return existingPromise;
        return $bc289733aa6ea9a1$var$state.promises[key] = fetchFn();
    },
    prefetch ({ fetchConnectorImages: fetchConnectorImages = true, fetchFeaturedWallets: fetchFeaturedWallets = true, fetchRecommendedWallets: fetchRecommendedWallets = true, fetchNetworkImages: fetchNetworkImages = true } = {}) {
        const promises = [
            fetchConnectorImages && $bc289733aa6ea9a1$export$99411f73957952af.initPromise("connectorImages", $bc289733aa6ea9a1$export$99411f73957952af.fetchConnectorImages),
            fetchFeaturedWallets && $bc289733aa6ea9a1$export$99411f73957952af.initPromise("featuredWallets", $bc289733aa6ea9a1$export$99411f73957952af.fetchFeaturedWallets),
            fetchRecommendedWallets && $bc289733aa6ea9a1$export$99411f73957952af.initPromise("recommendedWallets", $bc289733aa6ea9a1$export$99411f73957952af.fetchRecommendedWallets),
            fetchNetworkImages && $bc289733aa6ea9a1$export$99411f73957952af.initPromise("networkImages", $bc289733aa6ea9a1$export$99411f73957952af.fetchNetworkImages)
        ].filter(Boolean);
        return Promise.allSettled(promises);
    },
    prefetchAnalyticsConfig () {
        if ((0, $knC5d.OptionsController).state.features?.analytics) $bc289733aa6ea9a1$export$99411f73957952af.fetchAnalyticsConfig();
    },
    async fetchAnalyticsConfig () {
        try {
            const { isAnalyticsEnabled: isAnalyticsEnabled } = await $bc289733aa6ea9a1$export$644d8ea042df96a6.get({
                path: "/getAnalyticsConfig",
                params: $bc289733aa6ea9a1$export$99411f73957952af._getSdkProperties()
            });
            (0, $knC5d.OptionsController).setFeatures({
                analytics: isAnalyticsEnabled
            });
        } catch (error) {
            (0, $knC5d.OptionsController).setFeatures({
                analytics: false
            });
        }
    },
    filterByNamespaces (namespaces) {
        if (!namespaces?.length) {
            $bc289733aa6ea9a1$var$state.featured = $bc289733aa6ea9a1$var$state.allFeatured;
            $bc289733aa6ea9a1$var$state.recommended = $bc289733aa6ea9a1$var$state.allRecommended;
            return;
        }
        const caipNetworkIds = (0, $gD0RX.ChainController).getRequestedCaipNetworkIds().join(",");
        $bc289733aa6ea9a1$var$state.featured = $bc289733aa6ea9a1$var$state.allFeatured.filter((wallet)=>wallet.chains?.some((chain)=>caipNetworkIds.includes(chain)));
        $bc289733aa6ea9a1$var$state.recommended = $bc289733aa6ea9a1$var$state.allRecommended.filter((wallet)=>wallet.chains?.some((chain)=>caipNetworkIds.includes(chain)));
        $bc289733aa6ea9a1$var$state.filteredWallets = $bc289733aa6ea9a1$var$state.wallets.filter((wallet)=>wallet.chains?.some((chain)=>caipNetworkIds.includes(chain)));
    },
    clearFilterByNamespaces () {
        $bc289733aa6ea9a1$var$state.filteredWallets = [];
    },
    setFilterByNamespace (namespace) {
        if (!namespace) {
            $bc289733aa6ea9a1$var$state.featured = $bc289733aa6ea9a1$var$state.allFeatured;
            $bc289733aa6ea9a1$var$state.recommended = $bc289733aa6ea9a1$var$state.allRecommended;
            return;
        }
        const caipNetworkIds = (0, $gD0RX.ChainController).getRequestedCaipNetworkIds().join(",");
        $bc289733aa6ea9a1$var$state.featured = $bc289733aa6ea9a1$var$state.allFeatured.filter((wallet)=>wallet.chains?.some((chain)=>caipNetworkIds.includes(chain)));
        $bc289733aa6ea9a1$var$state.recommended = $bc289733aa6ea9a1$var$state.allRecommended.filter((wallet)=>wallet.chains?.some((chain)=>caipNetworkIds.includes(chain)));
        $bc289733aa6ea9a1$var$state.filteredWallets = $bc289733aa6ea9a1$var$state.wallets.filter((wallet)=>wallet.chains?.some((chain)=>caipNetworkIds.includes(chain)));
    }
};

});
parcelRegister("9PqFe", function(module, exports) {

$parcel$export(module.exports, "AssetUtil", () => $727d8f68c13b7175$export$2a2d471f51b1e9cb);

var $7zrdF = parcelRequire("7zrdF");

var $g9yWp = parcelRequire("g9yWp");

var $2ccEg = parcelRequire("2ccEg");
const $727d8f68c13b7175$var$namespaceImageIds = {
    // Ethereum
    eip155: "ba0ba0cd-17c6-4806-ad93-f9d174f17900",
    // Solana
    solana: "a1b58899-f671-4276-6a5e-56ca5bd59700",
    // Polkadot
    polkadot: "",
    // Bitcoin
    bip122: "0b4838db-0161-4ffe-022d-532bf03dba00",
    // Cosmos
    cosmos: ""
};
// -- State --------------------------------------------- //
const $727d8f68c13b7175$var$state = (0, $7zrdF.proxy)({
    networkImagePromises: {}
});
const $727d8f68c13b7175$export$2a2d471f51b1e9cb = {
    async fetchWalletImage (imageId) {
        if (!imageId) return undefined;
        await (0, $g9yWp.ApiController)._fetchWalletImage(imageId);
        return this.getWalletImageById(imageId);
    },
    async fetchNetworkImage (imageId) {
        if (!imageId) return undefined;
        const existingImage = this.getNetworkImageById(imageId);
        // Check if the image already exists
        if (existingImage) return existingImage;
        // Check if the promise is already created
        if (!$727d8f68c13b7175$var$state.networkImagePromises[imageId]) $727d8f68c13b7175$var$state.networkImagePromises[imageId] = (0, $g9yWp.ApiController)._fetchNetworkImage(imageId);
        await $727d8f68c13b7175$var$state.networkImagePromises[imageId];
        return this.getNetworkImageById(imageId);
    },
    getWalletImageById (imageId) {
        if (!imageId) return undefined;
        return (0, $2ccEg.AssetController).state.walletImages[imageId];
    },
    getWalletImage (wallet) {
        if (wallet?.image_url) return wallet?.image_url;
        if (wallet?.image_id) return (0, $2ccEg.AssetController).state.walletImages[wallet.image_id];
        return undefined;
    },
    getNetworkImage (network) {
        if (network?.assets?.imageUrl) return network?.assets?.imageUrl;
        if (network?.assets?.imageId) return (0, $2ccEg.AssetController).state.networkImages[network.assets.imageId];
        return undefined;
    },
    getNetworkImageById (imageId) {
        if (!imageId) return undefined;
        return (0, $2ccEg.AssetController).state.networkImages[imageId];
    },
    getConnectorImage (connector) {
        if (connector?.imageUrl) return connector.imageUrl;
        if (connector?.imageId) return (0, $2ccEg.AssetController).state.connectorImages[connector.imageId];
        return undefined;
    },
    getChainImage (chain) {
        return (0, $2ccEg.AssetController).state.networkImages[$727d8f68c13b7175$var$namespaceImageIds[chain]];
    }
};

});
parcelRegister("2ccEg", function(module, exports) {

$parcel$export(module.exports, "AssetController", () => $1996837393f5b030$export$4f2a98fee99335);

var $7zrdF = parcelRequire("7zrdF");

var $eFS1l = parcelRequire("eFS1l");

var $lCKEr = parcelRequire("lCKEr");
// -- State --------------------------------------------- //
const $1996837393f5b030$var$state = (0, $7zrdF.proxy)({
    walletImages: {},
    networkImages: {},
    chainImages: {},
    connectorImages: {},
    tokenImages: {},
    currencyImages: {}
});
// -- Controller ---------------------------------------- //
const $1996837393f5b030$var$controller = {
    state: $1996837393f5b030$var$state,
    subscribeNetworkImages (callback) {
        return (0, $7zrdF.subscribe)($1996837393f5b030$var$state.networkImages, ()=>callback($1996837393f5b030$var$state.networkImages));
    },
    subscribeKey (key, callback) {
        return (0, $eFS1l.subscribeKey)($1996837393f5b030$var$state, key, callback);
    },
    subscribe (callback) {
        return (0, $7zrdF.subscribe)($1996837393f5b030$var$state, ()=>callback($1996837393f5b030$var$state));
    },
    setWalletImage (key, value) {
        $1996837393f5b030$var$state.walletImages[key] = value;
    },
    setNetworkImage (key, value) {
        $1996837393f5b030$var$state.networkImages[key] = value;
    },
    setChainImage (key, value) {
        $1996837393f5b030$var$state.chainImages[key] = value;
    },
    setConnectorImage (key, value) {
        $1996837393f5b030$var$state.connectorImages = {
            ...$1996837393f5b030$var$state.connectorImages,
            [key]: value
        };
    },
    setTokenImage (key, value) {
        $1996837393f5b030$var$state.tokenImages[key] = value;
    },
    setCurrencyImage (key, value) {
        $1996837393f5b030$var$state.currencyImages[key] = value;
    }
};
const $1996837393f5b030$export$4f2a98fee99335 = (0, $lCKEr.withErrorBoundary)($1996837393f5b030$var$controller);

});


parcelRegister("5FNhR", function(module, exports) {

$parcel$export(module.exports, "EventsController", () => $0110e32725ff78ea$export$23ca5cb260756952);

var $7zrdF = parcelRequire("7zrdF");

var $b3v9s = parcelRequire("b3v9s");
var $eaPAz = parcelRequire("eaPAz");

var $lpmCO = parcelRequire("lpmCO");

var $6gqz8 = parcelRequire("6gqz8");

var $kfwQH = parcelRequire("kfwQH");

var $5PQZs = parcelRequire("5PQZs");

var $knC5d = parcelRequire("knC5d");
// -- Helpers ------------------------------------------- //
const $0110e32725ff78ea$var$baseUrl = (0, $lpmCO.CoreHelperUtil).getAnalyticsUrl();
const $0110e32725ff78ea$var$api = new (0, $6gqz8.FetchUtil)({
    baseUrl: $0110e32725ff78ea$var$baseUrl,
    clientId: null
});
const $0110e32725ff78ea$var$excluded = [
    "MODAL_CREATED"
];
// -- State --------------------------------------------- //
const $0110e32725ff78ea$var$state = (0, $7zrdF.proxy)({
    timestamp: Date.now(),
    reportedErrors: {},
    data: {
        type: "track",
        event: "MODAL_CREATED"
    }
});
const $0110e32725ff78ea$export$23ca5cb260756952 = {
    state: $0110e32725ff78ea$var$state,
    subscribe (callback) {
        return (0, $7zrdF.subscribe)($0110e32725ff78ea$var$state, ()=>callback($0110e32725ff78ea$var$state));
    },
    getSdkProperties () {
        const { projectId: projectId, sdkType: sdkType, sdkVersion: sdkVersion } = (0, $knC5d.OptionsController).state;
        return {
            projectId: projectId,
            st: sdkType,
            sv: sdkVersion || "html-wagmi-4.2.2"
        };
    },
    async _sendAnalyticsEvent (payload) {
        try {
            const address = (0, $kfwQH.AccountController).state.address;
            if ($0110e32725ff78ea$var$excluded.includes(payload.data.event) || typeof window === "undefined") return;
            await $0110e32725ff78ea$var$api.post({
                path: "/e",
                params: $0110e32725ff78ea$export$23ca5cb260756952.getSdkProperties(),
                body: {
                    eventId: (0, $lpmCO.CoreHelperUtil).getUUID(),
                    url: window.location.href,
                    domain: window.location.hostname,
                    timestamp: payload.timestamp,
                    props: {
                        ...payload.data,
                        address: address
                    }
                }
            });
            $0110e32725ff78ea$var$state.reportedErrors["FORBIDDEN"] = false;
        } catch (err) {
            const isForbiddenError = err instanceof Error && err.cause instanceof Response && err.cause.status === (0, $b3v9s.ConstantsUtil).HTTP_STATUS_CODES.FORBIDDEN && !$0110e32725ff78ea$var$state.reportedErrors["FORBIDDEN"];
            if (isForbiddenError) {
                (0, $5PQZs.AlertController).open({
                    shortMessage: "Invalid App Configuration",
                    longMessage: `Origin ${(0, $eaPAz.isSafe)() ? window.origin : "uknown"} not found on Allowlist - update configuration on cloud.reown.com`
                }, "error");
                $0110e32725ff78ea$var$state.reportedErrors["FORBIDDEN"] = true;
            }
        }
    },
    sendEvent (data) {
        $0110e32725ff78ea$var$state.timestamp = Date.now();
        $0110e32725ff78ea$var$state.data = data;
        if ((0, $knC5d.OptionsController).state.features?.analytics) $0110e32725ff78ea$export$23ca5cb260756952._sendAnalyticsEvent($0110e32725ff78ea$var$state);
    }
};

});
parcelRegister("kfwQH", function(module, exports) {

$parcel$export(module.exports, "AccountController", () => $ebdeb07e279ba4a1$export$3a40b83c1282ee40);

var $7zrdF = parcelRequire("7zrdF");

var $3h0dG = parcelRequire("3h0dG");

var $lpmCO = parcelRequire("lpmCO");

var $lCKEr = parcelRequire("lCKEr");

var $hvrT6 = parcelRequire("hvrT6");

var $gD0RX = parcelRequire("gD0RX");

var $4hCRh = parcelRequire("4hCRh");
// -- State --------------------------------------------- //
const $ebdeb07e279ba4a1$var$state = (0, $7zrdF.proxy)({
    currentTab: 0,
    tokenBalance: [],
    smartAccountDeployed: false,
    addressLabels: new Map(),
    allAccounts: []
});
// -- Controller ---------------------------------------- //
const $ebdeb07e279ba4a1$var$controller = {
    state: $ebdeb07e279ba4a1$var$state,
    replaceState (newState) {
        if (!newState) return;
        Object.assign($ebdeb07e279ba4a1$var$state, (0, $7zrdF.ref)(newState));
    },
    subscribe (callback) {
        return (0, $gD0RX.ChainController).subscribeChainProp("accountState", (accountState)=>{
            if (accountState) return callback(accountState);
            return undefined;
        });
    },
    subscribeKey (property, callback, chain) {
        let prev = undefined;
        return (0, $gD0RX.ChainController).subscribeChainProp("accountState", (accountState)=>{
            if (accountState) {
                const nextValue = accountState[property];
                if (prev !== nextValue) {
                    prev = nextValue;
                    callback(nextValue);
                }
            }
        }, chain);
    },
    setStatus (status, chain) {
        (0, $gD0RX.ChainController).setAccountProp("status", status, chain);
    },
    getCaipAddress (chain) {
        return (0, $gD0RX.ChainController).getAccountProp("caipAddress", chain);
    },
    setCaipAddress (caipAddress, chain) {
        const newAddress = caipAddress ? (0, $lpmCO.CoreHelperUtil).getPlainAddress(caipAddress) : undefined;
        if (chain === (0, $gD0RX.ChainController).state.activeChain) (0, $gD0RX.ChainController).state.activeCaipAddress = caipAddress;
        (0, $gD0RX.ChainController).setAccountProp("caipAddress", caipAddress, chain);
        (0, $gD0RX.ChainController).setAccountProp("address", newAddress, chain);
    },
    setBalance (balance, balanceSymbol, chain) {
        (0, $gD0RX.ChainController).setAccountProp("balance", balance, chain);
        (0, $gD0RX.ChainController).setAccountProp("balanceSymbol", balanceSymbol, chain);
    },
    setProfileName (profileName, chain) {
        (0, $gD0RX.ChainController).setAccountProp("profileName", profileName, chain);
    },
    setProfileImage (profileImage, chain) {
        (0, $gD0RX.ChainController).setAccountProp("profileImage", profileImage, chain);
    },
    setUser (user, chain) {
        (0, $gD0RX.ChainController).setAccountProp("user", user, chain);
    },
    setAddressExplorerUrl (explorerUrl, chain) {
        (0, $gD0RX.ChainController).setAccountProp("addressExplorerUrl", explorerUrl, chain);
    },
    setSmartAccountDeployed (isDeployed, chain) {
        (0, $gD0RX.ChainController).setAccountProp("smartAccountDeployed", isDeployed, chain);
    },
    setCurrentTab (currentTab) {
        (0, $gD0RX.ChainController).setAccountProp("currentTab", currentTab, (0, $gD0RX.ChainController).state.activeChain);
    },
    setTokenBalance (tokenBalance, chain) {
        if (tokenBalance) (0, $gD0RX.ChainController).setAccountProp("tokenBalance", tokenBalance, chain);
    },
    setShouldUpdateToAddress (address, chain) {
        (0, $gD0RX.ChainController).setAccountProp("shouldUpdateToAddress", address, chain);
    },
    setAllAccounts (accounts, namespace) {
        (0, $gD0RX.ChainController).setAccountProp("allAccounts", accounts, namespace);
    },
    addAddressLabel (address, label, chain) {
        const map = (0, $gD0RX.ChainController).getAccountProp("addressLabels", chain) || new Map();
        map.set(address, label);
        (0, $gD0RX.ChainController).setAccountProp("addressLabels", map, chain);
    },
    removeAddressLabel (address, chain) {
        const map = (0, $gD0RX.ChainController).getAccountProp("addressLabels", chain) || new Map();
        map.delete(address);
        (0, $gD0RX.ChainController).setAccountProp("addressLabels", map, chain);
    },
    setConnectedWalletInfo (connectedWalletInfo, chain) {
        (0, $gD0RX.ChainController).setAccountProp("connectedWalletInfo", connectedWalletInfo, chain, false);
    },
    setPreferredAccountType (preferredAccountType, chain) {
        (0, $gD0RX.ChainController).setAccountProp("preferredAccountTypes", {
            ...$ebdeb07e279ba4a1$var$state.preferredAccountTypes,
            [chain]: preferredAccountType
        }, chain);
    },
    setPreferredAccountTypes (preferredAccountTypes) {
        $ebdeb07e279ba4a1$var$state.preferredAccountTypes = preferredAccountTypes;
    },
    setSocialProvider (socialProvider, chain) {
        if (socialProvider) (0, $gD0RX.ChainController).setAccountProp("socialProvider", socialProvider, chain);
    },
    setSocialWindow (socialWindow, chain) {
        (0, $gD0RX.ChainController).setAccountProp("socialWindow", socialWindow ? (0, $7zrdF.ref)(socialWindow) : undefined, chain);
    },
    setFarcasterUrl (farcasterUrl, chain) {
        (0, $gD0RX.ChainController).setAccountProp("farcasterUrl", farcasterUrl, chain);
    },
    async fetchTokenBalance (onError) {
        $ebdeb07e279ba4a1$var$state.balanceLoading = true;
        const chainId = (0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId;
        const chain = (0, $gD0RX.ChainController).state.activeCaipNetwork?.chainNamespace;
        const caipAddress = (0, $gD0RX.ChainController).state.activeCaipAddress;
        const address = caipAddress ? (0, $lpmCO.CoreHelperUtil).getPlainAddress(caipAddress) : undefined;
        if ($ebdeb07e279ba4a1$var$state.lastRetry && !(0, $lpmCO.CoreHelperUtil).isAllowedRetry($ebdeb07e279ba4a1$var$state.lastRetry, 30 * (0, $3h0dG.ConstantsUtil).ONE_SEC_MS)) {
            $ebdeb07e279ba4a1$var$state.balanceLoading = false;
            return [];
        }
        try {
            if (address && chainId && chain) {
                const response = await (0, $hvrT6.BlockchainApiController).getBalance(address, chainId);
                /*
                 * The 1Inch API includes many low-quality tokens in the balance response,
                 * which appear inconsistently. This filter prevents them from being displayed.
                 */ const filteredBalances = response.balances.filter((balance)=>balance.quantity.decimals !== "0");
                $ebdeb07e279ba4a1$export$3a40b83c1282ee40.setTokenBalance(filteredBalances, chain);
                $ebdeb07e279ba4a1$var$state.lastRetry = undefined;
                $ebdeb07e279ba4a1$var$state.balanceLoading = false;
                return filteredBalances;
            }
        } catch (error) {
            $ebdeb07e279ba4a1$var$state.lastRetry = Date.now();
            onError?.(error);
            (0, $4hCRh.SnackController).showError("Token Balance Unavailable");
        } finally{
            $ebdeb07e279ba4a1$var$state.balanceLoading = false;
        }
        return [];
    },
    resetAccount (chain) {
        (0, $gD0RX.ChainController).resetAccount(chain);
    }
};
const $ebdeb07e279ba4a1$export$3a40b83c1282ee40 = (0, $lCKEr.withErrorBoundary)($ebdeb07e279ba4a1$var$controller);

});
parcelRegister("hvrT6", function(module, exports) {

$parcel$export(module.exports, "BlockchainApiController", () => $cbeaf6da86be3d02$export$9c45fcf03cadbfaa);

var $7zrdF = parcelRequire("7zrdF");

var $3h0dG = parcelRequire("3h0dG");

var $lpmCO = parcelRequire("lpmCO");

var $6gqz8 = parcelRequire("6gqz8");

var $bc5dy = parcelRequire("bc5dy");

var $kfwQH = parcelRequire("kfwQH");

var $gD0RX = parcelRequire("gD0RX");

var $knC5d = parcelRequire("knC5d");

var $4hCRh = parcelRequire("4hCRh");
const $cbeaf6da86be3d02$var$DEFAULT_OPTIONS = {
    purchaseCurrencies: [
        {
            id: "2b92315d-eab7-5bef-84fa-089a131333f5",
            name: "USD Coin",
            symbol: "USDC",
            networks: [
                {
                    name: "ethereum-mainnet",
                    display_name: "Ethereum",
                    chain_id: "1",
                    contract_address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
                },
                {
                    name: "polygon-mainnet",
                    display_name: "Polygon",
                    chain_id: "137",
                    contract_address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174"
                }
            ]
        },
        {
            id: "2b92315d-eab7-5bef-84fa-089a131333f5",
            name: "Ether",
            symbol: "ETH",
            networks: [
                {
                    name: "ethereum-mainnet",
                    display_name: "Ethereum",
                    chain_id: "1",
                    contract_address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
                },
                {
                    name: "polygon-mainnet",
                    display_name: "Polygon",
                    chain_id: "137",
                    contract_address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174"
                }
            ]
        }
    ],
    paymentCurrencies: [
        {
            id: "USD",
            payment_method_limits: [
                {
                    id: "card",
                    min: "10.00",
                    max: "7500.00"
                },
                {
                    id: "ach_bank_account",
                    min: "10.00",
                    max: "25000.00"
                }
            ]
        },
        {
            id: "EUR",
            payment_method_limits: [
                {
                    id: "card",
                    min: "10.00",
                    max: "7500.00"
                },
                {
                    id: "ach_bank_account",
                    min: "10.00",
                    max: "25000.00"
                }
            ]
        }
    ]
};
// -- Helpers ------------------------------------------- //
const $cbeaf6da86be3d02$var$baseUrl = (0, $lpmCO.CoreHelperUtil).getBlockchainApiUrl();
// -- State --------------------------------------------- //
const $cbeaf6da86be3d02$var$state = (0, $7zrdF.proxy)({
    clientId: null,
    api: new (0, $6gqz8.FetchUtil)({
        baseUrl: $cbeaf6da86be3d02$var$baseUrl,
        clientId: null
    }),
    supportedChains: {
        http: [],
        ws: []
    }
});
const $cbeaf6da86be3d02$export$9c45fcf03cadbfaa = {
    state: $cbeaf6da86be3d02$var$state,
    async get (request) {
        const { st: st, sv: sv } = $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.getSdkProperties();
        const projectId = (0, $knC5d.OptionsController).state.projectId;
        const params = {
            ...request.params || {},
            st: st,
            sv: sv,
            projectId: projectId
        };
        return $cbeaf6da86be3d02$var$state.api.get({
            ...request,
            params: params
        });
    },
    getSdkProperties () {
        const { sdkType: sdkType, sdkVersion: sdkVersion } = (0, $knC5d.OptionsController).state;
        return {
            st: sdkType || "unknown",
            sv: sdkVersion || "unknown"
        };
    },
    async isNetworkSupported (networkId) {
        if (!networkId) return false;
        try {
            if (!$cbeaf6da86be3d02$var$state.supportedChains.http.length) await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.getSupportedNetworks();
        } catch (e) {
            return false;
        }
        return $cbeaf6da86be3d02$var$state.supportedChains.http.includes(networkId);
    },
    async getSupportedNetworks () {
        try {
            const supportedChains = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.get({
                path: "v1/supported-chains"
            });
            $cbeaf6da86be3d02$var$state.supportedChains = supportedChains;
            return supportedChains;
        } catch  {
            return $cbeaf6da86be3d02$var$state.supportedChains;
        }
    },
    async fetchIdentity ({ address: address, caipNetworkId: caipNetworkId }) {
        const isSupported = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.isNetworkSupported(caipNetworkId);
        if (!isSupported) return {
            avatar: "",
            name: ""
        };
        const identityCache = (0, $bc5dy.StorageUtil).getIdentityFromCacheForAddress(address);
        if (identityCache) return identityCache;
        const result = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.get({
            path: `/v1/identity/${address}`,
            params: {
                sender: (0, $gD0RX.ChainController).state.activeCaipAddress ? (0, $lpmCO.CoreHelperUtil).getPlainAddress((0, $gD0RX.ChainController).state.activeCaipAddress) : undefined
            }
        });
        (0, $bc5dy.StorageUtil).updateIdentityCache({
            address: address,
            identity: result,
            timestamp: Date.now()
        });
        return result;
    },
    async fetchTransactions ({ account: account, cursor: cursor, onramp: onramp, signal: signal, cache: cache, chainId: chainId }) {
        const isSupported = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.isNetworkSupported((0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
        if (!isSupported) return {
            data: [],
            next: undefined
        };
        return $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.get({
            path: `/v1/account/${account}/history`,
            params: {
                cursor: cursor,
                onramp: onramp,
                chainId: chainId
            },
            signal: signal,
            cache: cache
        });
    },
    async fetchSwapQuote ({ amount: amount, userAddress: userAddress, from: from, to: to, gasPrice: gasPrice }) {
        const isSupported = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.isNetworkSupported((0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
        if (!isSupported) return {
            quotes: []
        };
        return $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.get({
            path: `/v1/convert/quotes`,
            headers: {
                "Content-Type": "application/json"
            },
            params: {
                amount: amount,
                userAddress: userAddress,
                from: from,
                to: to,
                gasPrice: gasPrice
            }
        });
    },
    async fetchSwapTokens ({ chainId: chainId }) {
        const isSupported = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.isNetworkSupported((0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
        if (!isSupported) return {
            tokens: []
        };
        return $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.get({
            path: `/v1/convert/tokens`,
            params: {
                chainId: chainId
            }
        });
    },
    async fetchTokenPrice ({ addresses: addresses }) {
        const isSupported = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.isNetworkSupported((0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
        if (!isSupported) return {
            fungibles: []
        };
        return $cbeaf6da86be3d02$var$state.api.post({
            path: "/v1/fungible/price",
            body: {
                currency: "usd",
                addresses: addresses,
                projectId: (0, $knC5d.OptionsController).state.projectId
            },
            headers: {
                "Content-Type": "application/json"
            }
        });
    },
    async fetchSwapAllowance ({ tokenAddress: tokenAddress, userAddress: userAddress }) {
        const isSupported = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.isNetworkSupported((0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
        if (!isSupported) return {
            allowance: "0"
        };
        return $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.get({
            path: `/v1/convert/allowance`,
            params: {
                tokenAddress: tokenAddress,
                userAddress: userAddress
            },
            headers: {
                "Content-Type": "application/json"
            }
        });
    },
    async fetchGasPrice ({ chainId: chainId }) {
        const { st: st, sv: sv } = $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.getSdkProperties();
        const isSupported = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.isNetworkSupported((0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
        if (!isSupported) throw new Error("Network not supported for Gas Price");
        return $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.get({
            path: `/v1/convert/gas-price`,
            headers: {
                "Content-Type": "application/json"
            },
            params: {
                chainId: chainId,
                st: st,
                sv: sv
            }
        });
    },
    async generateSwapCalldata ({ amount: amount, from: from, to: to, userAddress: userAddress, disableEstimate: disableEstimate }) {
        const isSupported = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.isNetworkSupported((0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
        if (!isSupported) throw new Error("Network not supported for Swaps");
        return $cbeaf6da86be3d02$var$state.api.post({
            path: "/v1/convert/build-transaction",
            headers: {
                "Content-Type": "application/json"
            },
            body: {
                amount: amount,
                eip155: {
                    slippage: (0, $3h0dG.ConstantsUtil).CONVERT_SLIPPAGE_TOLERANCE
                },
                projectId: (0, $knC5d.OptionsController).state.projectId,
                from: from,
                to: to,
                userAddress: userAddress,
                disableEstimate: disableEstimate
            }
        });
    },
    async generateApproveCalldata ({ from: from, to: to, userAddress: userAddress }) {
        const { st: st, sv: sv } = $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.getSdkProperties();
        const isSupported = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.isNetworkSupported((0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
        if (!isSupported) throw new Error("Network not supported for Swaps");
        return $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.get({
            path: `/v1/convert/build-approve`,
            headers: {
                "Content-Type": "application/json"
            },
            params: {
                userAddress: userAddress,
                from: from,
                to: to,
                st: st,
                sv: sv
            }
        });
    },
    async getBalance (address, chainId, forceUpdate) {
        const { st: st, sv: sv } = $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.getSdkProperties();
        const isSupported = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.isNetworkSupported((0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
        if (!isSupported) {
            (0, $4hCRh.SnackController).showError("Token Balance Unavailable");
            return {
                balances: []
            };
        }
        const caipAddress = `${chainId}:${address}`;
        const cachedBalance = (0, $bc5dy.StorageUtil).getBalanceCacheForCaipAddress(caipAddress);
        if (cachedBalance) return cachedBalance;
        const balance = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.get({
            path: `/v1/account/${address}/balance`,
            params: {
                currency: "usd",
                chainId: chainId,
                forceUpdate: forceUpdate,
                st: st,
                sv: sv
            }
        });
        (0, $bc5dy.StorageUtil).updateBalanceCache({
            caipAddress: caipAddress,
            balance: balance,
            timestamp: Date.now()
        });
        return balance;
    },
    async lookupEnsName (name) {
        const isSupported = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.isNetworkSupported((0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
        if (!isSupported) return {
            addresses: {},
            attributes: []
        };
        return $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.get({
            path: `/v1/profile/account/${name}`,
            params: {
                apiVersion: "2"
            }
        });
    },
    async reverseLookupEnsName ({ address: address }) {
        const isSupported = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.isNetworkSupported((0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
        if (!isSupported) return [];
        return $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.get({
            path: `/v1/profile/reverse/${address}`,
            params: {
                sender: (0, $kfwQH.AccountController).state.address,
                apiVersion: "2"
            }
        });
    },
    async getEnsNameSuggestions (name) {
        const isSupported = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.isNetworkSupported((0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
        if (!isSupported) return {
            suggestions: []
        };
        return $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.get({
            path: `/v1/profile/suggestions/${name}`,
            params: {
                zone: "reown.id"
            }
        });
    },
    async registerEnsName ({ coinType: coinType, address: address, message: message, signature: signature }) {
        const isSupported = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.isNetworkSupported((0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
        if (!isSupported) return {
            success: false
        };
        return $cbeaf6da86be3d02$var$state.api.post({
            path: `/v1/profile/account`,
            body: {
                coin_type: coinType,
                address: address,
                message: message,
                signature: signature
            },
            headers: {
                "Content-Type": "application/json"
            }
        });
    },
    async generateOnRampURL ({ destinationWallets: destinationWallets, partnerUserId: partnerUserId, defaultNetwork: defaultNetwork, purchaseAmount: purchaseAmount, paymentAmount: paymentAmount }) {
        const isSupported = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.isNetworkSupported((0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
        if (!isSupported) return "";
        const response = await $cbeaf6da86be3d02$var$state.api.post({
            path: `/v1/generators/onrampurl`,
            params: {
                projectId: (0, $knC5d.OptionsController).state.projectId
            },
            body: {
                destinationWallets: destinationWallets,
                defaultNetwork: defaultNetwork,
                partnerUserId: partnerUserId,
                defaultExperience: "buy",
                presetCryptoAmount: purchaseAmount,
                presetFiatAmount: paymentAmount
            }
        });
        return response.url;
    },
    async getOnrampOptions () {
        const isSupported = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.isNetworkSupported((0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
        if (!isSupported) return {
            paymentCurrencies: [],
            purchaseCurrencies: []
        };
        try {
            const response = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.get({
                path: `/v1/onramp/options`
            });
            return response;
        } catch (e) {
            return $cbeaf6da86be3d02$var$DEFAULT_OPTIONS;
        }
    },
    async getOnrampQuote ({ purchaseCurrency: purchaseCurrency, paymentCurrency: paymentCurrency, amount: amount, network: network }) {
        try {
            const isSupported = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.isNetworkSupported((0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
            if (!isSupported) return null;
            const response = await $cbeaf6da86be3d02$var$state.api.post({
                path: `/v1/onramp/quote`,
                params: {
                    projectId: (0, $knC5d.OptionsController).state.projectId
                },
                body: {
                    purchaseCurrency: purchaseCurrency,
                    paymentCurrency: paymentCurrency,
                    amount: amount,
                    network: network
                }
            });
            return response;
        } catch (e) {
            // Mocking response as 1:1 until endpoint is ready
            return {
                coinbaseFee: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                networkFee: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                paymentSubtotal: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                paymentTotal: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                purchaseAmount: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                quoteId: "mocked-quote-id"
            };
        }
    },
    async getSmartSessions (caipAddress) {
        const isSupported = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.isNetworkSupported((0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
        if (!isSupported) return [];
        return $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.get({
            path: `/v1/sessions/${caipAddress}`
        });
    },
    async revokeSmartSession (address, pci, signature) {
        const isSupported = await $cbeaf6da86be3d02$export$9c45fcf03cadbfaa.isNetworkSupported((0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
        if (!isSupported) return {
            success: false
        };
        return $cbeaf6da86be3d02$var$state.api.post({
            path: `/v1/sessions/${address}/revoke`,
            params: {
                projectId: (0, $knC5d.OptionsController).state.projectId
            },
            body: {
                pci: pci,
                signature: signature
            }
        });
    },
    setClientId (clientId) {
        $cbeaf6da86be3d02$var$state.clientId = clientId;
        $cbeaf6da86be3d02$var$state.api = new (0, $6gqz8.FetchUtil)({
            baseUrl: $cbeaf6da86be3d02$var$baseUrl,
            clientId: clientId
        });
    }
};

});
parcelRegister("4hCRh", function(module, exports) {

$parcel$export(module.exports, "SnackController", () => $31e6e4644e603340$export$506cae4b4f746de7);

var $7zrdF = parcelRequire("7zrdF");

var $eFS1l = parcelRequire("eFS1l");

var $lpmCO = parcelRequire("lpmCO");
// -- Constants ----------------------------------------- //
const $31e6e4644e603340$var$DEFAULT_STATE = Object.freeze({
    message: "",
    variant: "success",
    svg: undefined,
    open: false,
    autoClose: true
});
// -- State --------------------------------------------- //
const $31e6e4644e603340$var$state = (0, $7zrdF.proxy)({
    ...$31e6e4644e603340$var$DEFAULT_STATE
});
// -- Controller ---------------------------------------- //
const $31e6e4644e603340$var$controller = {
    state: $31e6e4644e603340$var$state,
    subscribeKey (key, callback) {
        return (0, $eFS1l.subscribeKey)($31e6e4644e603340$var$state, key, callback);
    },
    showLoading (message, options = {}) {
        this._showMessage({
            message: message,
            variant: "loading",
            ...options
        });
    },
    showSuccess (message) {
        this._showMessage({
            message: message,
            variant: "success"
        });
    },
    showSvg (message, svg) {
        this._showMessage({
            message: message,
            svg: svg
        });
    },
    showError (message) {
        const errorMessage = (0, $lpmCO.CoreHelperUtil).parseError(message);
        this._showMessage({
            message: errorMessage,
            variant: "error"
        });
    },
    hide () {
        $31e6e4644e603340$var$state.message = $31e6e4644e603340$var$DEFAULT_STATE.message;
        $31e6e4644e603340$var$state.variant = $31e6e4644e603340$var$DEFAULT_STATE.variant;
        $31e6e4644e603340$var$state.svg = $31e6e4644e603340$var$DEFAULT_STATE.svg;
        $31e6e4644e603340$var$state.open = $31e6e4644e603340$var$DEFAULT_STATE.open;
        $31e6e4644e603340$var$state.autoClose = $31e6e4644e603340$var$DEFAULT_STATE.autoClose;
    },
    _showMessage ({ message: message, svg: svg, variant: variant = "success", autoClose: autoClose = $31e6e4644e603340$var$DEFAULT_STATE.autoClose }) {
        if ($31e6e4644e603340$var$state.open) {
            $31e6e4644e603340$var$state.open = false;
            setTimeout(()=>{
                $31e6e4644e603340$var$state.message = message;
                $31e6e4644e603340$var$state.variant = variant;
                $31e6e4644e603340$var$state.svg = svg;
                $31e6e4644e603340$var$state.open = true;
                $31e6e4644e603340$var$state.autoClose = autoClose;
            }, 150);
        } else {
            $31e6e4644e603340$var$state.message = message;
            $31e6e4644e603340$var$state.variant = variant;
            $31e6e4644e603340$var$state.svg = svg;
            $31e6e4644e603340$var$state.open = true;
            $31e6e4644e603340$var$state.autoClose = autoClose;
        }
    }
};
const $31e6e4644e603340$export$506cae4b4f746de7 = $31e6e4644e603340$var$controller;

});



parcelRegister("5PQZs", function(module, exports) {

$parcel$export(module.exports, "AlertController", () => $43fad1ec610d959c$export$fffc451e938003c6);

var $7zrdF = parcelRequire("7zrdF");

var $eFS1l = parcelRequire("eFS1l");

var $lCKEr = parcelRequire("lCKEr");

var $knC5d = parcelRequire("knC5d");
// -- State --------------------------------------------- //
const $43fad1ec610d959c$var$state = (0, $7zrdF.proxy)({
    message: "",
    variant: "info",
    open: false
});
// -- Controller ---------------------------------------- //
const $43fad1ec610d959c$var$controller = {
    state: $43fad1ec610d959c$var$state,
    subscribeKey (key, callback) {
        return (0, $eFS1l.subscribeKey)($43fad1ec610d959c$var$state, key, callback);
    },
    open (message, variant) {
        const { debug: debug } = (0, $knC5d.OptionsController).state;
        const { shortMessage: shortMessage, longMessage: longMessage } = message;
        if (debug) {
            $43fad1ec610d959c$var$state.message = shortMessage;
            $43fad1ec610d959c$var$state.variant = variant;
            $43fad1ec610d959c$var$state.open = true;
        }
        if (longMessage) // eslint-disable-next-line no-console
        console.error(typeof longMessage === "function" ? longMessage() : longMessage);
    },
    close () {
        $43fad1ec610d959c$var$state.open = false;
        $43fad1ec610d959c$var$state.message = "";
        $43fad1ec610d959c$var$state.variant = "info";
    }
};
const $43fad1ec610d959c$export$fffc451e938003c6 = (0, $lCKEr.withErrorBoundary)($43fad1ec610d959c$var$controller);

});



parcelRegister("aZ8hw", function(module, exports) {

$parcel$export(module.exports, "RouterController", () => $7ff60672725c43e9$export$5ceead2526330ba8);

var $7zrdF = parcelRequire("7zrdF");

var $eFS1l = parcelRequire("eFS1l");

var $lCKEr = parcelRequire("lCKEr");

var $kfwQH = parcelRequire("kfwQH");

var $gD0RX = parcelRequire("gD0RX");

var $58cAm = parcelRequire("58cAm");

var $6aBkR = parcelRequire("6aBkR");

var $knC5d = parcelRequire("knC5d");
// -- State --------------------------------------------- //
const $7ff60672725c43e9$var$state = (0, $7zrdF.proxy)({
    view: "Connect",
    history: [
        "Connect"
    ],
    transactionStack: []
});
// -- Controller ---------------------------------------- //
const $7ff60672725c43e9$var$controller = {
    state: $7ff60672725c43e9$var$state,
    subscribeKey (key, callback) {
        return (0, $eFS1l.subscribeKey)($7ff60672725c43e9$var$state, key, callback);
    },
    pushTransactionStack (action) {
        $7ff60672725c43e9$var$state.transactionStack.push(action);
    },
    popTransactionStack (status) {
        const action = $7ff60672725c43e9$var$state.transactionStack.pop();
        if (!action) return;
        const { onSuccess: onSuccess, onError: onError, onCancel: onCancel } = action;
        switch(status){
            case "success":
                onSuccess?.();
                break;
            case "error":
                onError?.();
                $7ff60672725c43e9$export$5ceead2526330ba8.goBack();
                break;
            case "cancel":
                onCancel?.();
                $7ff60672725c43e9$export$5ceead2526330ba8.goBack();
                break;
            default:
        }
    },
    push (view, data) {
        if (view !== $7ff60672725c43e9$var$state.view) {
            $7ff60672725c43e9$var$state.view = view;
            $7ff60672725c43e9$var$state.history.push(view);
            $7ff60672725c43e9$var$state.data = data;
        }
    },
    reset (view, data) {
        $7ff60672725c43e9$var$state.view = view;
        $7ff60672725c43e9$var$state.history = [
            view
        ];
        $7ff60672725c43e9$var$state.data = data;
    },
    replace (view, data) {
        const lastView = $7ff60672725c43e9$var$state.history.at(-1);
        const isSameView = lastView === view;
        if (!isSameView) {
            $7ff60672725c43e9$var$state.view = view;
            $7ff60672725c43e9$var$state.history[$7ff60672725c43e9$var$state.history.length - 1] = view;
            $7ff60672725c43e9$var$state.data = data;
        }
    },
    goBack () {
        const shouldReload = !(0, $gD0RX.ChainController).state.activeCaipAddress && $7ff60672725c43e9$export$5ceead2526330ba8.state.view === "ConnectingFarcaster";
        if ($7ff60672725c43e9$var$state.history.length > 1) {
            $7ff60672725c43e9$var$state.history.pop();
            const [last] = $7ff60672725c43e9$var$state.history.slice(-1);
            if (last) $7ff60672725c43e9$var$state.view = last;
        } else (0, $6aBkR.ModalController).close();
        if ($7ff60672725c43e9$var$state.data?.wallet) $7ff60672725c43e9$var$state.data.wallet = undefined;
        // Reloading the iframe contentwindow and doing the view animation in the modal causes a small freeze in the transition. Doing these separately fixes that.
        setTimeout(()=>{
            if (shouldReload) {
                (0, $kfwQH.AccountController).setFarcasterUrl(undefined, (0, $gD0RX.ChainController).state.activeChain);
                const authConnector = (0, $58cAm.ConnectorController).getAuthConnector();
                authConnector?.provider?.reload();
                const optionsState = (0, $7zrdF.snapshot)((0, $knC5d.OptionsController).state);
                authConnector?.provider?.syncDappData?.({
                    metadata: optionsState.metadata,
                    sdkVersion: optionsState.sdkVersion,
                    projectId: optionsState.projectId,
                    sdkType: optionsState.sdkType
                });
            }
        }, 100);
    },
    goBackToIndex (historyIndex) {
        if ($7ff60672725c43e9$var$state.history.length > 1) {
            $7ff60672725c43e9$var$state.history = $7ff60672725c43e9$var$state.history.slice(0, historyIndex + 1);
            const [last] = $7ff60672725c43e9$var$state.history.slice(-1);
            if (last) $7ff60672725c43e9$var$state.view = last;
        }
    },
    goBackOrCloseModal () {
        if ($7ff60672725c43e9$export$5ceead2526330ba8.state.history.length > 1) $7ff60672725c43e9$export$5ceead2526330ba8.goBack();
        else (0, $6aBkR.ModalController).close();
    }
};
const $7ff60672725c43e9$export$5ceead2526330ba8 = (0, $lCKEr.withErrorBoundary)($7ff60672725c43e9$var$controller);

});
parcelRegister("6aBkR", function(module, exports) {

$parcel$export(module.exports, "ModalController", () => $47e0a34daf332b92$export$d507f25e63650365);

var $7zrdF = parcelRequire("7zrdF");

var $eFS1l = parcelRequire("eFS1l");

var $lpmCO = parcelRequire("lpmCO");

var $lCKEr = parcelRequire("lCKEr");

var $kfwQH = parcelRequire("kfwQH");

var $g9yWp = parcelRequire("g9yWp");

var $gD0RX = parcelRequire("gD0RX");

var $efZLi = parcelRequire("efZLi");

var $58cAm = parcelRequire("58cAm");

var $5FNhR = parcelRequire("5FNhR");

var $knC5d = parcelRequire("knC5d");

var $1dM5v = parcelRequire("1dM5v");

var $aZ8hw = parcelRequire("aZ8hw");
// -- State --------------------------------------------- //
const $47e0a34daf332b92$var$state = (0, $7zrdF.proxy)({
    loading: false,
    loadingNamespaceMap: new Map(),
    open: false,
    shake: false,
    namespace: undefined
});
// -- Controller ---------------------------------------- //
const $47e0a34daf332b92$var$controller = {
    state: $47e0a34daf332b92$var$state,
    subscribe (callback) {
        return (0, $7zrdF.subscribe)($47e0a34daf332b92$var$state, ()=>callback($47e0a34daf332b92$var$state));
    },
    subscribeKey (key, callback) {
        return (0, $eFS1l.subscribeKey)($47e0a34daf332b92$var$state, key, callback);
    },
    async open (options) {
        const isConnected = (0, $kfwQH.AccountController).state.status === "connected";
        if ((0, $efZLi.ConnectionController).state.wcBasic) // No need to add an await here if we are use basic
        (0, $g9yWp.ApiController).prefetch({
            fetchNetworkImages: false,
            fetchConnectorImages: false
        });
        else await (0, $g9yWp.ApiController).prefetch({
            fetchConnectorImages: !isConnected,
            fetchFeaturedWallets: !isConnected,
            fetchRecommendedWallets: !isConnected
        });
        if (options?.namespace) {
            await (0, $gD0RX.ChainController).switchActiveNamespace(options.namespace);
            $47e0a34daf332b92$export$d507f25e63650365.setLoading(true, options.namespace);
        } else $47e0a34daf332b92$export$d507f25e63650365.setLoading(true);
        (0, $58cAm.ConnectorController).setFilterByNamespace(options?.namespace);
        const caipAddress = (0, $gD0RX.ChainController).getAccountData(options?.namespace)?.caipAddress;
        const hasNoAdapters = (0, $gD0RX.ChainController).state.noAdapters;
        if ((0, $knC5d.OptionsController).state.manualWCControl || hasNoAdapters && !caipAddress) {
            if ((0, $lpmCO.CoreHelperUtil).isMobile()) (0, $aZ8hw.RouterController).reset("AllWallets");
            else (0, $aZ8hw.RouterController).reset("ConnectingWalletConnectBasic");
        } else if (options?.view) (0, $aZ8hw.RouterController).reset(options.view, options.data);
        else if (caipAddress) (0, $aZ8hw.RouterController).reset("Account");
        else (0, $aZ8hw.RouterController).reset("Connect");
        $47e0a34daf332b92$var$state.open = true;
        (0, $1dM5v.PublicStateController).set({
            open: true
        });
        (0, $5FNhR.EventsController).sendEvent({
            type: "track",
            event: "MODAL_OPEN",
            properties: {
                connected: Boolean(caipAddress)
            }
        });
    },
    close () {
        const isEmbeddedEnabled = (0, $knC5d.OptionsController).state.enableEmbedded;
        const isConnected = Boolean((0, $gD0RX.ChainController).state.activeCaipAddress);
        // Only send the event if the modal is open and is about to be closed
        if ($47e0a34daf332b92$var$state.open) (0, $5FNhR.EventsController).sendEvent({
            type: "track",
            event: "MODAL_CLOSE",
            properties: {
                connected: isConnected
            }
        });
        $47e0a34daf332b92$var$state.open = false;
        $47e0a34daf332b92$export$d507f25e63650365.clearLoading();
        if (isEmbeddedEnabled) {
            if (isConnected) (0, $aZ8hw.RouterController).replace("Account");
            else (0, $aZ8hw.RouterController).push("Connect");
        } else (0, $1dM5v.PublicStateController).set({
            open: false
        });
        (0, $efZLi.ConnectionController).resetUri();
    },
    setLoading (loading, namespace) {
        if (namespace) $47e0a34daf332b92$var$state.loadingNamespaceMap.set(namespace, loading);
        $47e0a34daf332b92$var$state.loading = loading;
        (0, $1dM5v.PublicStateController).set({
            loading: loading
        });
    },
    clearLoading () {
        $47e0a34daf332b92$var$state.loadingNamespaceMap.clear();
        $47e0a34daf332b92$var$state.loading = false;
    },
    shake () {
        if ($47e0a34daf332b92$var$state.shake) return;
        $47e0a34daf332b92$var$state.shake = true;
        setTimeout(()=>{
            $47e0a34daf332b92$var$state.shake = false;
        }, 500);
    }
};
const $47e0a34daf332b92$export$d507f25e63650365 = (0, $lCKEr.withErrorBoundary)($47e0a34daf332b92$var$controller);

});
parcelRegister("efZLi", function(module, exports) {

$parcel$export(module.exports, "ConnectionController", () => $a61260002b32c1d3$export$303deccbe6e8c782);

var $7zrdF = parcelRequire("7zrdF");

var $eFS1l = parcelRequire("eFS1l");


var $lpmCO = parcelRequire("lpmCO");

var $ahcWC = parcelRequire("ahcWC");

var $bc5dy = parcelRequire("bc5dy");

var $lCKEr = parcelRequire("lCKEr");

var $kfwQH = parcelRequire("kfwQH");

var $gD0RX = parcelRequire("gD0RX");

var $58cAm = parcelRequire("58cAm");

var $5FNhR = parcelRequire("5FNhR");

var $6aBkR = parcelRequire("6aBkR");

var $aZ8hw = parcelRequire("aZ8hw");

var $9QVQU = parcelRequire("9QVQU");
// -- State --------------------------------------------- //
const $a61260002b32c1d3$var$state = (0, $7zrdF.proxy)({
    connections: new Map(),
    wcError: false,
    buffering: false,
    status: "disconnected"
});
// eslint-disable-next-line init-declarations
let $a61260002b32c1d3$var$wcConnectionPromise;
// -- Controller ---------------------------------------- //
const $a61260002b32c1d3$var$controller = {
    state: $a61260002b32c1d3$var$state,
    subscribeKey (key, callback) {
        return (0, $eFS1l.subscribeKey)($a61260002b32c1d3$var$state, key, callback);
    },
    _getClient () {
        return $a61260002b32c1d3$var$state._client;
    },
    setClient (client) {
        $a61260002b32c1d3$var$state._client = (0, $7zrdF.ref)(client);
    },
    async connectWalletConnect () {
        if ((0, $lpmCO.CoreHelperUtil).isTelegram() || (0, $lpmCO.CoreHelperUtil).isSafari() && (0, $lpmCO.CoreHelperUtil).isIos()) {
            if ($a61260002b32c1d3$var$wcConnectionPromise) {
                await $a61260002b32c1d3$var$wcConnectionPromise;
                $a61260002b32c1d3$var$wcConnectionPromise = undefined;
                return;
            }
            if (!(0, $lpmCO.CoreHelperUtil).isPairingExpired($a61260002b32c1d3$var$state?.wcPairingExpiry)) {
                const link = $a61260002b32c1d3$var$state.wcUri;
                $a61260002b32c1d3$var$state.wcUri = link;
                return;
            }
            $a61260002b32c1d3$var$wcConnectionPromise = $a61260002b32c1d3$export$303deccbe6e8c782._getClient()?.connectWalletConnect?.().catch(()=>undefined);
            $a61260002b32c1d3$export$303deccbe6e8c782.state.status = "connecting";
            await $a61260002b32c1d3$var$wcConnectionPromise;
            $a61260002b32c1d3$var$wcConnectionPromise = undefined;
            $a61260002b32c1d3$var$state.wcPairingExpiry = undefined;
            $a61260002b32c1d3$export$303deccbe6e8c782.state.status = "connected";
        } else await $a61260002b32c1d3$export$303deccbe6e8c782._getClient()?.connectWalletConnect?.();
    },
    async connectExternal (options, chain, setChain = true) {
        await $a61260002b32c1d3$export$303deccbe6e8c782._getClient()?.connectExternal?.(options);
        if (setChain) (0, $gD0RX.ChainController).setActiveNamespace(chain);
    },
    async reconnectExternal (options) {
        await $a61260002b32c1d3$export$303deccbe6e8c782._getClient()?.reconnectExternal?.(options);
        const namespace = options.chain || (0, $gD0RX.ChainController).state.activeChain;
        if (namespace) (0, $58cAm.ConnectorController).setConnectorId(options.id, namespace);
    },
    async setPreferredAccountType (accountType, namespace) {
        (0, $6aBkR.ModalController).setLoading(true, (0, $gD0RX.ChainController).state.activeChain);
        const authConnector = (0, $58cAm.ConnectorController).getAuthConnector();
        if (!authConnector) return;
        (0, $kfwQH.AccountController).setPreferredAccountType(accountType, namespace);
        await authConnector.provider.setPreferredAccount(accountType);
        (0, $bc5dy.StorageUtil).setPreferredAccountTypes((0, $kfwQH.AccountController).state.preferredAccountTypes ?? {
            [namespace]: accountType
        });
        await $a61260002b32c1d3$export$303deccbe6e8c782.reconnectExternal(authConnector);
        (0, $6aBkR.ModalController).setLoading(false, (0, $gD0RX.ChainController).state.activeChain);
        (0, $5FNhR.EventsController).sendEvent({
            type: "track",
            event: "SET_PREFERRED_ACCOUNT_TYPE",
            properties: {
                accountType: accountType,
                network: (0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId || ""
            }
        });
    },
    async signMessage (message) {
        return $a61260002b32c1d3$export$303deccbe6e8c782._getClient()?.signMessage(message);
    },
    parseUnits (value, decimals) {
        return $a61260002b32c1d3$export$303deccbe6e8c782._getClient()?.parseUnits(value, decimals);
    },
    formatUnits (value, decimals) {
        return $a61260002b32c1d3$export$303deccbe6e8c782._getClient()?.formatUnits(value, decimals);
    },
    async sendTransaction (args) {
        return $a61260002b32c1d3$export$303deccbe6e8c782._getClient()?.sendTransaction(args);
    },
    async getCapabilities (params) {
        return $a61260002b32c1d3$export$303deccbe6e8c782._getClient()?.getCapabilities(params);
    },
    async grantPermissions (params) {
        return $a61260002b32c1d3$export$303deccbe6e8c782._getClient()?.grantPermissions(params);
    },
    async walletGetAssets (params) {
        return $a61260002b32c1d3$export$303deccbe6e8c782._getClient()?.walletGetAssets(params) ?? {};
    },
    async estimateGas (args) {
        return $a61260002b32c1d3$export$303deccbe6e8c782._getClient()?.estimateGas(args);
    },
    async writeContract (args) {
        return $a61260002b32c1d3$export$303deccbe6e8c782._getClient()?.writeContract(args);
    },
    async getEnsAddress (value) {
        return $a61260002b32c1d3$export$303deccbe6e8c782._getClient()?.getEnsAddress(value);
    },
    async getEnsAvatar (value) {
        return $a61260002b32c1d3$export$303deccbe6e8c782._getClient()?.getEnsAvatar(value);
    },
    checkInstalled (ids) {
        return $a61260002b32c1d3$export$303deccbe6e8c782._getClient()?.checkInstalled?.(ids) || false;
    },
    resetWcConnection () {
        $a61260002b32c1d3$var$state.wcUri = undefined;
        $a61260002b32c1d3$var$state.wcPairingExpiry = undefined;
        $a61260002b32c1d3$var$state.wcLinking = undefined;
        $a61260002b32c1d3$var$state.recentWallet = undefined;
        $a61260002b32c1d3$var$state.status = "disconnected";
        (0, $9QVQU.TransactionsController).resetTransactions();
        (0, $bc5dy.StorageUtil).deleteWalletConnectDeepLink();
    },
    resetUri () {
        $a61260002b32c1d3$var$state.wcUri = undefined;
        $a61260002b32c1d3$var$state.wcPairingExpiry = undefined;
        $a61260002b32c1d3$var$wcConnectionPromise = undefined;
    },
    finalizeWcConnection () {
        const { wcLinking: wcLinking, recentWallet: recentWallet } = $a61260002b32c1d3$export$303deccbe6e8c782.state;
        if (wcLinking) (0, $bc5dy.StorageUtil).setWalletConnectDeepLink(wcLinking);
        if (recentWallet) (0, $bc5dy.StorageUtil).setAppKitRecent(recentWallet);
        (0, $5FNhR.EventsController).sendEvent({
            type: "track",
            event: "CONNECT_SUCCESS",
            properties: {
                method: wcLinking ? "mobile" : "qrcode",
                name: (0, $aZ8hw.RouterController).state.data?.wallet?.name || "Unknown"
            }
        });
    },
    setWcBasic (wcBasic) {
        $a61260002b32c1d3$var$state.wcBasic = wcBasic;
    },
    setUri (uri) {
        $a61260002b32c1d3$var$state.wcUri = uri;
        $a61260002b32c1d3$var$state.wcPairingExpiry = (0, $lpmCO.CoreHelperUtil).getPairingExpiry();
    },
    setWcLinking (wcLinking) {
        $a61260002b32c1d3$var$state.wcLinking = wcLinking;
    },
    setWcError (wcError) {
        $a61260002b32c1d3$var$state.wcError = wcError;
        $a61260002b32c1d3$var$state.buffering = false;
    },
    setRecentWallet (wallet) {
        $a61260002b32c1d3$var$state.recentWallet = wallet;
    },
    setBuffering (buffering) {
        $a61260002b32c1d3$var$state.buffering = buffering;
    },
    setStatus (status) {
        $a61260002b32c1d3$var$state.status = status;
    },
    async disconnect (namespace) {
        try {
            (0, $6aBkR.ModalController).setLoading(true, namespace);
            await (0, $ahcWC.SIWXUtil).clearSessions();
            await (0, $gD0RX.ChainController).disconnect(namespace);
            (0, $6aBkR.ModalController).setLoading(false, namespace);
            (0, $58cAm.ConnectorController).setFilterByNamespace(undefined);
        } catch (error) {
            throw new (0, $lCKEr.AppKitError)("Failed to disconnect", "INTERNAL_SDK_ERROR", error);
        }
    },
    setConnections (connections, chainNamespace) {
        $a61260002b32c1d3$var$state.connections.set(chainNamespace, connections);
    },
    switchAccount ({ connection: connection, address: address, namespace: namespace }) {
        const connectedConnectorId = (0, $58cAm.ConnectorController).state.activeConnectorIds[namespace];
        const isConnectorConnected = connectedConnectorId === connection.connectorId;
        if (isConnectorConnected) {
            const currentNetwork = (0, $gD0RX.ChainController).state.activeCaipNetwork;
            if (currentNetwork) {
                const caipAddress = `${namespace}:${currentNetwork.id}:${address}`;
                (0, $kfwQH.AccountController).setCaipAddress(caipAddress, namespace);
            } else console.warn(`No current network found for namespace "${namespace}"`);
        } else {
            const connector = (0, $58cAm.ConnectorController).getConnector(connection.connectorId);
            if (connector) $a61260002b32c1d3$export$303deccbe6e8c782.connectExternal(connector, namespace);
            else console.warn(`No connector found for namespace "${namespace}"`);
        }
    }
};
const $a61260002b32c1d3$export$303deccbe6e8c782 = (0, $lCKEr.withErrorBoundary)($a61260002b32c1d3$var$controller);

});
parcelRegister("ahcWC", function(module, exports) {

$parcel$export(module.exports, "SIWXUtil", () => $77b5886f58549800$export$9fa72f7775e955bd);
parcelRequire("5ID99");

var $b3v9s = parcelRequire("b3v9s");

var $034Ac = parcelRequire("034Ac");

var $kfwQH = parcelRequire("kfwQH");

var $gD0RX = parcelRequire("gD0RX");

var $efZLi = parcelRequire("efZLi");

var $58cAm = parcelRequire("58cAm");

var $5FNhR = parcelRequire("5FNhR");

var $6aBkR = parcelRequire("6aBkR");

var $knC5d = parcelRequire("knC5d");

var $aZ8hw = parcelRequire("aZ8hw");

var $4hCRh = parcelRequire("4hCRh");

var $lpmCO = parcelRequire("lpmCO");
const $77b5886f58549800$export$9fa72f7775e955bd = {
    getSIWX () {
        return (0, $knC5d.OptionsController).state.siwx;
    },
    async initializeIfEnabled () {
        const siwx = (0, $knC5d.OptionsController).state.siwx;
        const caipAddress = (0, $gD0RX.ChainController).getActiveCaipAddress();
        if (!(siwx && caipAddress)) return;
        const [namespace, chainId, address] = caipAddress.split(":");
        if (!(0, $gD0RX.ChainController).checkIfSupportedNetwork(namespace)) return;
        try {
            const sessions = await siwx.getSessions(`${namespace}:${chainId}`, address);
            if (sessions.length) return;
            await (0, $6aBkR.ModalController).open({
                view: "SIWXSignMessage"
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error("SIWXUtil:initializeIfEnabled", error);
            (0, $5FNhR.EventsController).sendEvent({
                type: "track",
                event: "SIWX_AUTH_ERROR",
                properties: this.getSIWXEventProperties()
            });
            // eslint-disable-next-line no-console
            await (0, $efZLi.ConnectionController)._getClient()?.disconnect().catch(console.error);
            (0, $aZ8hw.RouterController).reset("Connect");
            (0, $4hCRh.SnackController).showError("A problem occurred while trying initialize authentication");
        }
    },
    async requestSignMessage () {
        const siwx = (0, $knC5d.OptionsController).state.siwx;
        const address = (0, $lpmCO.CoreHelperUtil).getPlainAddress((0, $gD0RX.ChainController).getActiveCaipAddress());
        const network = (0, $gD0RX.ChainController).getActiveCaipNetwork();
        const client = (0, $efZLi.ConnectionController)._getClient();
        if (!siwx) throw new Error("SIWX is not enabled");
        if (!address) throw new Error("No ActiveCaipAddress found");
        if (!network) throw new Error("No ActiveCaipNetwork or client found");
        if (!client) throw new Error("No ConnectionController client found");
        try {
            const siwxMessage = await siwx.createMessage({
                chainId: network.caipNetworkId,
                accountAddress: address
            });
            const message = siwxMessage.toString();
            const connectorId = (0, $58cAm.ConnectorController).getConnectorId(network.chainNamespace);
            if (connectorId === (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH) (0, $aZ8hw.RouterController).pushTransactionStack({});
            const signature = await client.signMessage(message);
            await siwx.addSession({
                data: siwxMessage,
                message: message,
                signature: signature
            });
            (0, $6aBkR.ModalController).close();
            (0, $5FNhR.EventsController).sendEvent({
                type: "track",
                event: "SIWX_AUTH_SUCCESS",
                properties: this.getSIWXEventProperties()
            });
        } catch (error) {
            const properties = this.getSIWXEventProperties();
            if (!(0, $6aBkR.ModalController).state.open || (0, $aZ8hw.RouterController).state.view === "ApproveTransaction") await (0, $6aBkR.ModalController).open({
                view: "SIWXSignMessage"
            });
            if (properties.isSmartAccount) (0, $4hCRh.SnackController).showError("This application might not support Smart Accounts");
            else (0, $4hCRh.SnackController).showError("Signature declined");
            (0, $5FNhR.EventsController).sendEvent({
                type: "track",
                event: "SIWX_AUTH_ERROR",
                properties: properties
            });
            // eslint-disable-next-line no-console
            console.error("SWIXUtil:requestSignMessage", error);
        }
    },
    async cancelSignMessage () {
        try {
            const siwx = this.getSIWX();
            const isRequired = siwx?.getRequired?.();
            if (isRequired) await (0, $efZLi.ConnectionController).disconnect();
            else (0, $6aBkR.ModalController).close();
            (0, $aZ8hw.RouterController).reset("Connect");
            (0, $5FNhR.EventsController).sendEvent({
                event: "CLICK_CANCEL_SIWX",
                type: "track",
                properties: this.getSIWXEventProperties()
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error("SIWXUtil:cancelSignMessage", error);
        }
    },
    async getSessions () {
        const siwx = (0, $knC5d.OptionsController).state.siwx;
        const address = (0, $lpmCO.CoreHelperUtil).getPlainAddress((0, $gD0RX.ChainController).getActiveCaipAddress());
        const network = (0, $gD0RX.ChainController).getActiveCaipNetwork();
        if (!(siwx && address && network)) return [];
        return siwx.getSessions(network.caipNetworkId, address);
    },
    async isSIWXCloseDisabled () {
        const siwx = this.getSIWX();
        if (siwx) {
            const isApproveSignScreen = (0, $aZ8hw.RouterController).state.view === "ApproveTransaction";
            const isSiwxSignMessage = (0, $aZ8hw.RouterController).state.view === "SIWXSignMessage";
            if (isApproveSignScreen || isSiwxSignMessage) return siwx.getRequired?.() && (await this.getSessions()).length === 0;
        }
        return false;
    },
    async universalProviderAuthenticate ({ universalProvider: universalProvider, chains: chains, methods: methods }) {
        const siwx = $77b5886f58549800$export$9fa72f7775e955bd.getSIWX();
        const namespaces = new Set(chains.map((chain)=>chain.split(":")[0]));
        if (!siwx || namespaces.size !== 1 || !namespaces.has("eip155")) return false;
        // Ignores chainId and account address to get other message data
        const siwxMessage = await siwx.createMessage({
            chainId: (0, $gD0RX.ChainController).getActiveCaipNetwork()?.caipNetworkId || "",
            accountAddress: ""
        });
        const result = await universalProvider.authenticate({
            nonce: siwxMessage.nonce,
            domain: siwxMessage.domain,
            uri: siwxMessage.uri,
            exp: siwxMessage.expirationTime,
            iat: siwxMessage.issuedAt,
            nbf: siwxMessage.notBefore,
            requestId: siwxMessage.requestId,
            version: siwxMessage.version,
            resources: siwxMessage.resources,
            statement: siwxMessage.statement,
            chainId: siwxMessage.chainId,
            methods: methods,
            // The first chainId is what is used for universal provider to build the message
            chains: [
                siwxMessage.chainId,
                ...chains.filter((chain)=>chain !== siwxMessage.chainId)
            ]
        });
        (0, $4hCRh.SnackController).showLoading("Authenticating...", {
            autoClose: false
        });
        (0, $kfwQH.AccountController).setConnectedWalletInfo({
            ...result.session.peer.metadata,
            name: result.session.peer.metadata.name,
            icon: result.session.peer.metadata.icons?.[0],
            type: "WALLET_CONNECT"
        }, Array.from(namespaces)[0]);
        if (result?.auths?.length) {
            const sessions = result.auths.map((cacao)=>{
                const message = universalProvider.client.formatAuthMessage({
                    request: cacao.p,
                    iss: cacao.p.iss
                });
                return {
                    data: {
                        ...cacao.p,
                        accountAddress: cacao.p.iss.split(":").slice(-1).join(""),
                        chainId: cacao.p.iss.split(":").slice(2, 4).join(":"),
                        uri: cacao.p.aud,
                        version: cacao.p.version || siwxMessage.version,
                        expirationTime: cacao.p.exp,
                        issuedAt: cacao.p.iat,
                        notBefore: cacao.p.nbf
                    },
                    message: message,
                    signature: cacao.s.s,
                    cacao: cacao
                };
            });
            try {
                await siwx.setSessions(sessions);
                (0, $5FNhR.EventsController).sendEvent({
                    type: "track",
                    event: "SIWX_AUTH_SUCCESS",
                    properties: $77b5886f58549800$export$9fa72f7775e955bd.getSIWXEventProperties()
                });
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error("SIWX:universalProviderAuth - failed to set sessions", error);
                (0, $5FNhR.EventsController).sendEvent({
                    type: "track",
                    event: "SIWX_AUTH_ERROR",
                    properties: $77b5886f58549800$export$9fa72f7775e955bd.getSIWXEventProperties()
                });
                // eslint-disable-next-line no-console
                await universalProvider.disconnect().catch(console.error);
                throw error;
            } finally{
                (0, $4hCRh.SnackController).hide();
            }
        }
        return true;
    },
    getSIWXEventProperties () {
        const activeChainNamespace = (0, $gD0RX.ChainController).state.activeChain;
        return {
            network: (0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId || "",
            isSmartAccount: (0, $kfwQH.AccountController).state.preferredAccountTypes?.[activeChainNamespace] === (0, $034Ac.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
        };
    },
    async clearSessions () {
        const siwx = this.getSIWX();
        if (siwx) await siwx.setSessions([]);
    }
};

});
parcelRegister("5ID99", function(module, exports) {

$parcel$export(module.exports, "default", () => $429f6d87faf9801c$export$2e2bcd8739ae039);

var $kozsa = parcelRequire("kozsa");

var $3qpNA = parcelRequire("3qpNA");

var $6GQzw = parcelRequire("6GQzw");
var $66E6s = parcelRequire("66E6s");

var $eAMDx = parcelRequire("eAMDx");

var $1EAvo = parcelRequire("1EAvo");
parcelRequire("7IWKC");
var $fHodW = parcelRequire("fHodW");

var $5yFVO = parcelRequire("5yFVO");

var $lewJ9 = parcelRequire("lewJ9");
var $429f6d87faf9801c$require$Buffer = $lewJ9.Buffer;
const $429f6d87faf9801c$var$tt = "error", $429f6d87faf9801c$var$St = "wss://relay.walletconnect.org", $429f6d87faf9801c$var$Dt = "wc", $429f6d87faf9801c$var$qt = "universal_provider", $429f6d87faf9801c$var$_ = `${$429f6d87faf9801c$var$Dt}@2:${$429f6d87faf9801c$var$qt}:`, $429f6d87faf9801c$var$et = "https://rpc.walletconnect.org/v1/", $429f6d87faf9801c$var$w = "generic", $429f6d87faf9801c$var$jt = `${$429f6d87faf9801c$var$et}bundler`, $429f6d87faf9801c$var$d = {
    DEFAULT_CHAIN_CHANGED: "default_chain_changed"
};
function $429f6d87faf9801c$var$Rt() {}
function $429f6d87faf9801c$var$G(s) {
    return s == null || typeof s != "object" && typeof s != "function";
}
function $429f6d87faf9801c$var$J(s) {
    return ArrayBuffer.isView(s) && !(s instanceof DataView);
}
function $429f6d87faf9801c$var$_t(s) {
    if ($429f6d87faf9801c$var$G(s)) return s;
    if (Array.isArray(s) || $429f6d87faf9801c$var$J(s) || s instanceof ArrayBuffer || typeof SharedArrayBuffer < "u" && s instanceof SharedArrayBuffer) return s.slice(0);
    const t = Object.getPrototypeOf(s), e = t.constructor;
    if (s instanceof Date || s instanceof Map || s instanceof Set) return new e(s);
    if (s instanceof RegExp) {
        const i = new e(s);
        return i.lastIndex = s.lastIndex, i;
    }
    if (s instanceof DataView) return new e(s.buffer.slice(0));
    if (s instanceof Error) {
        const i = new e(s.message);
        return i.stack = s.stack, i.name = s.name, i.cause = s.cause, i;
    }
    if (typeof File < "u" && s instanceof File) return new e([
        s
    ], s.name, {
        type: s.type,
        lastModified: s.lastModified
    });
    if (typeof s == "object") {
        const i = Object.create(t);
        return Object.assign(i, s);
    }
    return s;
}
function $429f6d87faf9801c$var$st(s) {
    return typeof s == "object" && s !== null;
}
function $429f6d87faf9801c$var$it(s) {
    return Object.getOwnPropertySymbols(s).filter((t)=>Object.prototype.propertyIsEnumerable.call(s, t));
}
function $429f6d87faf9801c$var$rt(s) {
    return s == null ? s === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(s);
}
const $429f6d87faf9801c$var$Ut = "[object RegExp]", $429f6d87faf9801c$var$nt = "[object String]", $429f6d87faf9801c$var$at = "[object Number]", $429f6d87faf9801c$var$ct = "[object Boolean]", $429f6d87faf9801c$var$ot = "[object Arguments]", $429f6d87faf9801c$var$Ft = "[object Symbol]", $429f6d87faf9801c$var$Lt = "[object Date]", $429f6d87faf9801c$var$xt = "[object Map]", $429f6d87faf9801c$var$Mt = "[object Set]", $429f6d87faf9801c$var$Bt = "[object Array]", $429f6d87faf9801c$var$Gt = "[object ArrayBuffer]", $429f6d87faf9801c$var$Jt = "[object Object]", $429f6d87faf9801c$var$zt = "[object DataView]", $429f6d87faf9801c$var$kt = "[object Uint8Array]", $429f6d87faf9801c$var$Wt = "[object Uint8ClampedArray]", $429f6d87faf9801c$var$Kt = "[object Uint16Array]", $429f6d87faf9801c$var$Vt = "[object Uint32Array]", $429f6d87faf9801c$var$Xt = "[object Int8Array]", $429f6d87faf9801c$var$Yt = "[object Int16Array]", $429f6d87faf9801c$var$Qt = "[object Int32Array]", $429f6d87faf9801c$var$Zt = "[object Float32Array]", $429f6d87faf9801c$var$Tt = "[object Float64Array]";
function $429f6d87faf9801c$var$te(s, t) {
    return $429f6d87faf9801c$var$y(s, void 0, s, new Map, t);
}
function $429f6d87faf9801c$var$y(s, t, e, i = new Map, n) {
    const a = n?.(s, t, e, i);
    if (a != null) return a;
    if ($429f6d87faf9801c$var$G(s)) return s;
    if (i.has(s)) return i.get(s);
    if (Array.isArray(s)) {
        const r = new Array(s.length);
        i.set(s, r);
        for(let c = 0; c < s.length; c++)r[c] = $429f6d87faf9801c$var$y(s[c], c, e, i, n);
        return Object.hasOwn(s, "index") && (r.index = s.index), Object.hasOwn(s, "input") && (r.input = s.input), r;
    }
    if (s instanceof Date) return new Date(s.getTime());
    if (s instanceof RegExp) {
        const r = new RegExp(s.source, s.flags);
        return r.lastIndex = s.lastIndex, r;
    }
    if (s instanceof Map) {
        const r = new Map;
        i.set(s, r);
        for (const [c, o] of s)r.set(c, $429f6d87faf9801c$var$y(o, c, e, i, n));
        return r;
    }
    if (s instanceof Set) {
        const r = new Set;
        i.set(s, r);
        for (const c of s)r.add($429f6d87faf9801c$var$y(c, void 0, e, i, n));
        return r;
    }
    if (typeof $429f6d87faf9801c$require$Buffer < "u" && $429f6d87faf9801c$require$Buffer.isBuffer(s)) return s.subarray();
    if ($429f6d87faf9801c$var$J(s)) {
        const r = new (Object.getPrototypeOf(s)).constructor(s.length);
        i.set(s, r);
        for(let c = 0; c < s.length; c++)r[c] = $429f6d87faf9801c$var$y(s[c], c, e, i, n);
        return r;
    }
    if (s instanceof ArrayBuffer || typeof SharedArrayBuffer < "u" && s instanceof SharedArrayBuffer) return s.slice(0);
    if (s instanceof DataView) {
        const r = new DataView(s.buffer.slice(0), s.byteOffset, s.byteLength);
        return i.set(s, r), $429f6d87faf9801c$var$g(r, s, e, i, n), r;
    }
    if (typeof File < "u" && s instanceof File) {
        const r = new File([
            s
        ], s.name, {
            type: s.type
        });
        return i.set(s, r), $429f6d87faf9801c$var$g(r, s, e, i, n), r;
    }
    if (s instanceof Blob) {
        const r = new Blob([
            s
        ], {
            type: s.type
        });
        return i.set(s, r), $429f6d87faf9801c$var$g(r, s, e, i, n), r;
    }
    if (s instanceof Error) {
        const r = new s.constructor;
        return i.set(s, r), r.message = s.message, r.name = s.name, r.stack = s.stack, r.cause = s.cause, $429f6d87faf9801c$var$g(r, s, e, i, n), r;
    }
    if (typeof s == "object" && $429f6d87faf9801c$var$ee(s)) {
        const r = Object.create(Object.getPrototypeOf(s));
        return i.set(s, r), $429f6d87faf9801c$var$g(r, s, e, i, n), r;
    }
    return s;
}
function $429f6d87faf9801c$var$g(s, t, e = s, i, n) {
    const a = [
        ...Object.keys(t),
        ...$429f6d87faf9801c$var$it(t)
    ];
    for(let r = 0; r < a.length; r++){
        const c = a[r], o = Object.getOwnPropertyDescriptor(s, c);
        (o == null || o.writable) && (s[c] = $429f6d87faf9801c$var$y(t[c], c, e, i, n));
    }
}
function $429f6d87faf9801c$var$ee(s) {
    switch($429f6d87faf9801c$var$rt(s)){
        case $429f6d87faf9801c$var$ot:
        case $429f6d87faf9801c$var$Bt:
        case $429f6d87faf9801c$var$Gt:
        case $429f6d87faf9801c$var$zt:
        case $429f6d87faf9801c$var$ct:
        case $429f6d87faf9801c$var$Lt:
        case $429f6d87faf9801c$var$Zt:
        case $429f6d87faf9801c$var$Tt:
        case $429f6d87faf9801c$var$Xt:
        case $429f6d87faf9801c$var$Yt:
        case $429f6d87faf9801c$var$Qt:
        case $429f6d87faf9801c$var$xt:
        case $429f6d87faf9801c$var$at:
        case $429f6d87faf9801c$var$Jt:
        case $429f6d87faf9801c$var$Ut:
        case $429f6d87faf9801c$var$Mt:
        case $429f6d87faf9801c$var$nt:
        case $429f6d87faf9801c$var$Ft:
        case $429f6d87faf9801c$var$kt:
        case $429f6d87faf9801c$var$Wt:
        case $429f6d87faf9801c$var$Kt:
        case $429f6d87faf9801c$var$Vt:
            return !0;
        default:
            return !1;
    }
}
function $429f6d87faf9801c$var$se(s, t) {
    return $429f6d87faf9801c$var$te(s, (e, i, n, a)=>{
        const r = t?.(e, i, n, a);
        if (r != null) return r;
        if (typeof s == "object") switch(Object.prototype.toString.call(s)){
            case $429f6d87faf9801c$var$at:
            case $429f6d87faf9801c$var$nt:
            case $429f6d87faf9801c$var$ct:
                {
                    const c = new s.constructor(s?.valueOf());
                    return $429f6d87faf9801c$var$g(c, s), c;
                }
            case $429f6d87faf9801c$var$ot:
                {
                    const c = {};
                    return $429f6d87faf9801c$var$g(c, s), c.length = s.length, c[Symbol.iterator] = s[Symbol.iterator], c;
                }
            default:
                return;
        }
    });
}
function $429f6d87faf9801c$var$ht(s) {
    return $429f6d87faf9801c$var$se(s);
}
function $429f6d87faf9801c$var$pt(s) {
    return s !== null && typeof s == "object" && $429f6d87faf9801c$var$rt(s) === "[object Arguments]";
}
function $429f6d87faf9801c$var$ie(s) {
    return $429f6d87faf9801c$var$J(s);
}
function $429f6d87faf9801c$var$re(s) {
    if (typeof s != "object" || s == null) return !1;
    if (Object.getPrototypeOf(s) === null) return !0;
    if (Object.prototype.toString.call(s) !== "[object Object]") {
        const e = s[Symbol.toStringTag];
        return e == null || !Object.getOwnPropertyDescriptor(s, Symbol.toStringTag)?.writable ? !1 : s.toString() === `[object ${e}]`;
    }
    let t = s;
    for(; Object.getPrototypeOf(t) !== null;)t = Object.getPrototypeOf(t);
    return Object.getPrototypeOf(s) === t;
}
function $429f6d87faf9801c$var$ne(s, ...t) {
    const e = t.slice(0, -1), i = t[t.length - 1];
    let n = s;
    for(let a = 0; a < e.length; a++){
        const r = e[a];
        n = $429f6d87faf9801c$var$U(n, r, i, new Map);
    }
    return n;
}
function $429f6d87faf9801c$var$U(s, t, e, i) {
    if ($429f6d87faf9801c$var$G(s) && (s = Object(s)), t == null || typeof t != "object") return s;
    if (i.has(t)) return $429f6d87faf9801c$var$_t(i.get(t));
    if (i.set(t, s), Array.isArray(t)) {
        t = t.slice();
        for(let a = 0; a < t.length; a++)t[a] = t[a] ?? void 0;
    }
    const n = [
        ...Object.keys(t),
        ...$429f6d87faf9801c$var$it(t)
    ];
    for(let a = 0; a < n.length; a++){
        const r = n[a];
        let c = t[r], o = s[r];
        if ($429f6d87faf9801c$var$pt(c) && (c = {
            ...c
        }), $429f6d87faf9801c$var$pt(o) && (o = {
            ...o
        }), typeof $429f6d87faf9801c$require$Buffer < "u" && $429f6d87faf9801c$require$Buffer.isBuffer(c) && (c = $429f6d87faf9801c$var$ht(c)), Array.isArray(c)) {
            if (typeof o == "object" && o != null) {
                const j = [], R = Reflect.ownKeys(o);
                for(let f = 0; f < R.length; f++){
                    const Y = R[f];
                    j[Y] = o[Y];
                }
                o = j;
            } else o = [];
        }
        const v = e(o, c, r, s, t, i);
        v != null ? s[r] = v : Array.isArray(c) || $429f6d87faf9801c$var$st(o) && $429f6d87faf9801c$var$st(c) ? s[r] = $429f6d87faf9801c$var$U(o, c, e, i) : o == null && $429f6d87faf9801c$var$re(c) ? s[r] = $429f6d87faf9801c$var$U({}, c, e, i) : o == null && $429f6d87faf9801c$var$ie(c) ? s[r] = $429f6d87faf9801c$var$ht(c) : (o === void 0 || c !== void 0) && (s[r] = c);
    }
    return s;
}
function $429f6d87faf9801c$var$ae(s, ...t) {
    return $429f6d87faf9801c$var$ne(s, ...t, $429f6d87faf9801c$var$Rt);
}
var $429f6d87faf9801c$var$ce = Object.defineProperty, $429f6d87faf9801c$var$oe = Object.defineProperties, $429f6d87faf9801c$var$he = Object.getOwnPropertyDescriptors, $429f6d87faf9801c$var$dt = Object.getOwnPropertySymbols, $429f6d87faf9801c$var$pe = Object.prototype.hasOwnProperty, $429f6d87faf9801c$var$de = Object.prototype.propertyIsEnumerable, $429f6d87faf9801c$var$ut = (s, t, e)=>t in s ? $429f6d87faf9801c$var$ce(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $429f6d87faf9801c$var$F = (s, t)=>{
    for(var e in t || (t = {}))$429f6d87faf9801c$var$pe.call(t, e) && $429f6d87faf9801c$var$ut(s, e, t[e]);
    if ($429f6d87faf9801c$var$dt) for (var e of $429f6d87faf9801c$var$dt(t))$429f6d87faf9801c$var$de.call(t, e) && $429f6d87faf9801c$var$ut(s, e, t[e]);
    return s;
}, $429f6d87faf9801c$var$ue = (s, t)=>$429f6d87faf9801c$var$oe(s, $429f6d87faf9801c$var$he(t));
function $429f6d87faf9801c$var$p(s, t, e) {
    var i;
    const n = (0, $3qpNA.parseChainId)(s);
    return ((i = t.rpcMap) == null ? void 0 : i[n.reference]) || `${$429f6d87faf9801c$var$et}?chainId=${n.namespace}:${n.reference}&projectId=${e}`;
}
function $429f6d87faf9801c$var$P(s) {
    return s.includes(":") ? s.split(":")[1] : s;
}
function $429f6d87faf9801c$var$lt(s) {
    return s.map((t)=>`${t.split(":")[0]}:${t.split(":")[1]}`);
}
function $429f6d87faf9801c$var$le(s, t) {
    const e = Object.keys(t.namespaces).filter((n)=>n.includes(s));
    if (!e.length) return [];
    const i = [];
    return e.forEach((n)=>{
        const a = t.namespaces[n].accounts;
        i.push(...a);
    }), i;
}
function $429f6d87faf9801c$var$z(s = {}, t = {}) {
    const e = $429f6d87faf9801c$var$ft(s), i = $429f6d87faf9801c$var$ft(t);
    return $429f6d87faf9801c$var$ae(e, i);
}
function $429f6d87faf9801c$var$ft(s) {
    var t, e, i, n;
    const a = {};
    if (!(0, $3qpNA.isValidObject)(s)) return a;
    for (const [r, c] of Object.entries(s)){
        const o = (0, $3qpNA.isCaipNamespace)(r) ? [
            r
        ] : c.chains, v = c.methods || [], j = c.events || [], R = c.rpcMap || {}, f = (0, $3qpNA.parseNamespaceKey)(r);
        a[f] = $429f6d87faf9801c$var$ue($429f6d87faf9801c$var$F($429f6d87faf9801c$var$F({}, a[f]), c), {
            chains: (0, $3qpNA.mergeArrays)(o, (t = a[f]) == null ? void 0 : t.chains),
            methods: (0, $3qpNA.mergeArrays)(v, (e = a[f]) == null ? void 0 : e.methods),
            events: (0, $3qpNA.mergeArrays)(j, (i = a[f]) == null ? void 0 : i.events),
            rpcMap: $429f6d87faf9801c$var$F($429f6d87faf9801c$var$F({}, R), (n = a[f]) == null ? void 0 : n.rpcMap)
        });
    }
    return a;
}
function $429f6d87faf9801c$var$mt(s) {
    return s.includes(":") ? s.split(":")[2] : s;
}
function $429f6d87faf9801c$var$vt(s) {
    const t = {};
    for (const [e, i] of Object.entries(s)){
        const n = i.methods || [], a = i.events || [], r = i.accounts || [], c = (0, $3qpNA.isCaipNamespace)(e) ? [
            e
        ] : i.chains ? i.chains : $429f6d87faf9801c$var$lt(i.accounts);
        t[e] = {
            chains: c,
            methods: n,
            events: a,
            accounts: r
        };
    }
    return t;
}
function $429f6d87faf9801c$var$k(s) {
    return typeof s == "number" ? s : s.includes("0x") ? parseInt(s, 16) : (s = s.includes(":") ? s.split(":")[1] : s, isNaN(Number(s)) ? s : Number(s));
}
const $429f6d87faf9801c$var$gt = {}, $429f6d87faf9801c$var$h = (s)=>$429f6d87faf9801c$var$gt[s], $429f6d87faf9801c$var$W = (s, t)=>{
    $429f6d87faf9801c$var$gt[s] = t;
};
var $429f6d87faf9801c$var$fe = Object.defineProperty, $429f6d87faf9801c$var$me = (s, t, e)=>t in s ? $429f6d87faf9801c$var$fe(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $429f6d87faf9801c$var$b = (s, t, e)=>$429f6d87faf9801c$var$me(s, typeof t != "symbol" ? t + "" : t, e);
class $429f6d87faf9801c$var$ve {
    constructor(t){
        $429f6d87faf9801c$var$b(this, "name", "polkadot"), $429f6d87faf9801c$var$b(this, "client"), $429f6d87faf9801c$var$b(this, "httpProviders"), $429f6d87faf9801c$var$b(this, "events"), $429f6d87faf9801c$var$b(this, "namespace"), $429f6d87faf9801c$var$b(this, "chainId"), this.namespace = t.namespace, this.events = $429f6d87faf9801c$var$h("events"), this.client = $429f6d87faf9801c$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    setDefaultChain(t, e) {
        this.httpProviders[t] || this.setHttpProvider(t, e), this.chainId = t, this.events.emit($429f6d87faf9801c$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${t}`);
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]) || [] : [];
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            var i;
            const n = $429f6d87faf9801c$var$P(e);
            t[n] = this.createHttpProvider(n, (i = this.namespace.rpcMap) == null ? void 0 : i[e]);
        }), t;
    }
    getHttpProvider() {
        const t = `${this.name}:${this.chainId}`, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || $429f6d87faf9801c$var$p(t, this.namespace, this.client.core.projectId);
        if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
        return new (0, $1EAvo.JsonRpcProvider)(new (0, $eAMDx.default)(i, $429f6d87faf9801c$var$h("disableProviderPing")));
    }
}
var $429f6d87faf9801c$var$ge = Object.defineProperty, $429f6d87faf9801c$var$Pe = Object.defineProperties, $429f6d87faf9801c$var$we = Object.getOwnPropertyDescriptors, $429f6d87faf9801c$var$Pt = Object.getOwnPropertySymbols, $429f6d87faf9801c$var$ye = Object.prototype.hasOwnProperty, $429f6d87faf9801c$var$be = Object.prototype.propertyIsEnumerable, $429f6d87faf9801c$var$K = (s, t, e)=>t in s ? $429f6d87faf9801c$var$ge(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $429f6d87faf9801c$var$wt = (s, t)=>{
    for(var e in t || (t = {}))$429f6d87faf9801c$var$ye.call(t, e) && $429f6d87faf9801c$var$K(s, e, t[e]);
    if ($429f6d87faf9801c$var$Pt) for (var e of $429f6d87faf9801c$var$Pt(t))$429f6d87faf9801c$var$be.call(t, e) && $429f6d87faf9801c$var$K(s, e, t[e]);
    return s;
}, $429f6d87faf9801c$var$yt = (s, t)=>$429f6d87faf9801c$var$Pe(s, $429f6d87faf9801c$var$we(t)), $429f6d87faf9801c$var$I = (s, t, e)=>$429f6d87faf9801c$var$K(s, typeof t != "symbol" ? t + "" : t, e);
class $429f6d87faf9801c$var$Ie {
    constructor(t){
        $429f6d87faf9801c$var$I(this, "name", "eip155"), $429f6d87faf9801c$var$I(this, "client"), $429f6d87faf9801c$var$I(this, "chainId"), $429f6d87faf9801c$var$I(this, "namespace"), $429f6d87faf9801c$var$I(this, "httpProviders"), $429f6d87faf9801c$var$I(this, "events"), this.namespace = t.namespace, this.events = $429f6d87faf9801c$var$h("events"), this.client = $429f6d87faf9801c$var$h("client"), this.httpProviders = this.createHttpProviders(), this.chainId = parseInt(this.getDefaultChain());
    }
    async request(t) {
        switch(t.request.method){
            case "eth_requestAccounts":
                return this.getAccounts();
            case "eth_accounts":
                return this.getAccounts();
            case "wallet_switchEthereumChain":
                return await this.handleSwitchChain(t);
            case "eth_chainId":
                return parseInt(this.getDefaultChain());
            case "wallet_getCapabilities":
                return await this.getCapabilities(t);
            case "wallet_getCallsStatus":
                return await this.getCallStatus(t);
        }
        return this.namespace.methods.includes(t.request.method) ? await this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    setDefaultChain(t, e) {
        this.httpProviders[t] || this.setHttpProvider(parseInt(t), e), this.chainId = parseInt(t), this.events.emit($429f6d87faf9801c$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${t}`);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId.toString();
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    createHttpProvider(t, e) {
        const i = e || $429f6d87faf9801c$var$p(`${this.name}:${t}`, this.namespace, this.client.core.projectId);
        if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
        return new (0, $1EAvo.JsonRpcProvider)(new (0, $eAMDx.HttpConnection)(i, $429f6d87faf9801c$var$h("disableProviderPing")));
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            var i;
            const n = parseInt($429f6d87faf9801c$var$P(e));
            t[n] = this.createHttpProvider(n, (i = this.namespace.rpcMap) == null ? void 0 : i[e]);
        }), t;
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? [
            ...new Set(t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]))
        ] : [];
    }
    getHttpProvider() {
        const t = this.chainId, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    async handleSwitchChain(t) {
        var e, i;
        let n = t.request.params ? (e = t.request.params[0]) == null ? void 0 : e.chainId : "0x0";
        n = n.startsWith("0x") ? n : `0x${n}`;
        const a = parseInt(n, 16);
        if (this.isChainApproved(a)) this.setDefaultChain(`${a}`);
        else if (this.namespace.methods.includes("wallet_switchEthereumChain")) await this.client.request({
            topic: t.topic,
            request: {
                method: t.request.method,
                params: [
                    {
                        chainId: n
                    }
                ]
            },
            chainId: (i = this.namespace.chains) == null ? void 0 : i[0]
        }), this.setDefaultChain(`${a}`);
        else throw new Error(`Failed to switch to chain 'eip155:${a}'. The chain is not approved or the wallet does not support 'wallet_switchEthereumChain' method.`);
        return null;
    }
    isChainApproved(t) {
        return this.namespace.chains.includes(`${this.name}:${t}`);
    }
    async getCapabilities(t) {
        var e, i, n;
        const a = (i = (e = t.request) == null ? void 0 : e.params) == null ? void 0 : i[0];
        if (!a) throw new Error("Missing address parameter in `wallet_getCapabilities` request");
        const r = this.client.session.get(t.topic), c = ((n = r?.sessionProperties) == null ? void 0 : n.capabilities) || {};
        if (c != null && c[a]) return c?.[a];
        const o = await this.client.request(t);
        try {
            await this.client.session.update(t.topic, {
                sessionProperties: $429f6d87faf9801c$var$yt($429f6d87faf9801c$var$wt({}, r.sessionProperties || {}), {
                    capabilities: $429f6d87faf9801c$var$yt($429f6d87faf9801c$var$wt({}, c || {}), {
                        [a]: o
                    })
                })
            });
        } catch (v) {
            console.warn("Failed to update session with capabilities", v);
        }
        return o;
    }
    async getCallStatus(t) {
        var e, i;
        const n = this.client.session.get(t.topic), a = (e = n.sessionProperties) == null ? void 0 : e.bundler_name;
        if (a) {
            const c = this.getBundlerUrl(t.chainId, a);
            try {
                return await this.getUserOperationReceipt(c, t);
            } catch (o) {
                console.warn("Failed to fetch call status from bundler", o, c);
            }
        }
        const r = (i = n.sessionProperties) == null ? void 0 : i.bundler_url;
        if (r) try {
            return await this.getUserOperationReceipt(r, t);
        } catch (c) {
            console.warn("Failed to fetch call status from custom bundler", c, r);
        }
        if (this.namespace.methods.includes(t.request.method)) return await this.client.request(t);
        throw new Error("Fetching call status not approved by the wallet.");
    }
    async getUserOperationReceipt(t, e) {
        var i;
        const n = new URL(t), a = await fetch(n, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify((0, $fHodW.formatJsonRpcRequest)("eth_getUserOperationReceipt", [
                (i = e.request.params) == null ? void 0 : i[0]
            ]))
        });
        if (!a.ok) throw new Error(`Failed to fetch user operation receipt - ${a.status}`);
        return await a.json();
    }
    getBundlerUrl(t, e) {
        return `${$429f6d87faf9801c$var$jt}?projectId=${this.client.core.projectId}&chainId=${t}&bundler=${e}`;
    }
}
var $429f6d87faf9801c$var$$e = Object.defineProperty, $429f6d87faf9801c$var$Oe = (s, t, e)=>t in s ? $429f6d87faf9801c$var$$e(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $429f6d87faf9801c$var$$ = (s, t, e)=>$429f6d87faf9801c$var$Oe(s, typeof t != "symbol" ? t + "" : t, e);
class $429f6d87faf9801c$var$Ae {
    constructor(t){
        $429f6d87faf9801c$var$$(this, "name", "solana"), $429f6d87faf9801c$var$$(this, "client"), $429f6d87faf9801c$var$$(this, "httpProviders"), $429f6d87faf9801c$var$$(this, "events"), $429f6d87faf9801c$var$$(this, "namespace"), $429f6d87faf9801c$var$$(this, "chainId"), this.namespace = t.namespace, this.events = $429f6d87faf9801c$var$h("events"), this.client = $429f6d87faf9801c$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    setDefaultChain(t, e) {
        this.httpProviders[t] || this.setHttpProvider(t, e), this.chainId = t, this.events.emit($429f6d87faf9801c$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${t}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? [
            ...new Set(t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            var i;
            const n = $429f6d87faf9801c$var$P(e);
            t[n] = this.createHttpProvider(n, (i = this.namespace.rpcMap) == null ? void 0 : i[e]);
        }), t;
    }
    getHttpProvider() {
        const t = `${this.name}:${this.chainId}`, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || $429f6d87faf9801c$var$p(t, this.namespace, this.client.core.projectId);
        if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
        return new (0, $1EAvo.JsonRpcProvider)(new (0, $eAMDx.default)(i, $429f6d87faf9801c$var$h("disableProviderPing")));
    }
}
var $429f6d87faf9801c$var$Ce = Object.defineProperty, $429f6d87faf9801c$var$He = (s, t, e)=>t in s ? $429f6d87faf9801c$var$Ce(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $429f6d87faf9801c$var$O = (s, t, e)=>$429f6d87faf9801c$var$He(s, typeof t != "symbol" ? t + "" : t, e);
class $429f6d87faf9801c$var$Ee {
    constructor(t){
        $429f6d87faf9801c$var$O(this, "name", "cosmos"), $429f6d87faf9801c$var$O(this, "client"), $429f6d87faf9801c$var$O(this, "httpProviders"), $429f6d87faf9801c$var$O(this, "events"), $429f6d87faf9801c$var$O(this, "namespace"), $429f6d87faf9801c$var$O(this, "chainId"), this.namespace = t.namespace, this.events = $429f6d87faf9801c$var$h("events"), this.client = $429f6d87faf9801c$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    setDefaultChain(t, e) {
        this.httpProviders[t] || this.setHttpProvider(t, e), this.chainId = t, this.events.emit($429f6d87faf9801c$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? [
            ...new Set(t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            var i;
            const n = $429f6d87faf9801c$var$P(e);
            t[n] = this.createHttpProvider(n, (i = this.namespace.rpcMap) == null ? void 0 : i[e]);
        }), t;
    }
    getHttpProvider() {
        const t = `${this.name}:${this.chainId}`, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || $429f6d87faf9801c$var$p(t, this.namespace, this.client.core.projectId);
        if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
        return new (0, $1EAvo.JsonRpcProvider)(new (0, $eAMDx.default)(i, $429f6d87faf9801c$var$h("disableProviderPing")));
    }
}
var $429f6d87faf9801c$var$Ne = Object.defineProperty, $429f6d87faf9801c$var$Se = (s, t, e)=>t in s ? $429f6d87faf9801c$var$Ne(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $429f6d87faf9801c$var$A = (s, t, e)=>$429f6d87faf9801c$var$Se(s, typeof t != "symbol" ? t + "" : t, e);
class $429f6d87faf9801c$var$De {
    constructor(t){
        $429f6d87faf9801c$var$A(this, "name", "algorand"), $429f6d87faf9801c$var$A(this, "client"), $429f6d87faf9801c$var$A(this, "httpProviders"), $429f6d87faf9801c$var$A(this, "events"), $429f6d87faf9801c$var$A(this, "namespace"), $429f6d87faf9801c$var$A(this, "chainId"), this.namespace = t.namespace, this.events = $429f6d87faf9801c$var$h("events"), this.client = $429f6d87faf9801c$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    setDefaultChain(t, e) {
        if (!this.httpProviders[t]) {
            const i = e || $429f6d87faf9801c$var$p(`${this.name}:${t}`, this.namespace, this.client.core.projectId);
            if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
            this.setHttpProvider(t, i);
        }
        this.chainId = t, this.events.emit($429f6d87faf9801c$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? [
            ...new Set(t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            var i;
            t[e] = this.createHttpProvider(e, (i = this.namespace.rpcMap) == null ? void 0 : i[e]);
        }), t;
    }
    getHttpProvider() {
        const t = `${this.name}:${this.chainId}`, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || $429f6d87faf9801c$var$p(t, this.namespace, this.client.core.projectId);
        return typeof i > "u" ? void 0 : new (0, $1EAvo.JsonRpcProvider)(new (0, $eAMDx.default)(i, $429f6d87faf9801c$var$h("disableProviderPing")));
    }
}
var $429f6d87faf9801c$var$qe = Object.defineProperty, $429f6d87faf9801c$var$je = (s, t, e)=>t in s ? $429f6d87faf9801c$var$qe(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $429f6d87faf9801c$var$C = (s, t, e)=>$429f6d87faf9801c$var$je(s, typeof t != "symbol" ? t + "" : t, e);
class $429f6d87faf9801c$var$Re {
    constructor(t){
        $429f6d87faf9801c$var$C(this, "name", "cip34"), $429f6d87faf9801c$var$C(this, "client"), $429f6d87faf9801c$var$C(this, "httpProviders"), $429f6d87faf9801c$var$C(this, "events"), $429f6d87faf9801c$var$C(this, "namespace"), $429f6d87faf9801c$var$C(this, "chainId"), this.namespace = t.namespace, this.events = $429f6d87faf9801c$var$h("events"), this.client = $429f6d87faf9801c$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    setDefaultChain(t, e) {
        this.httpProviders[t] || this.setHttpProvider(t, e), this.chainId = t, this.events.emit($429f6d87faf9801c$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? [
            ...new Set(t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            const i = this.getCardanoRPCUrl(e), n = $429f6d87faf9801c$var$P(e);
            t[n] = this.createHttpProvider(n, i);
        }), t;
    }
    getHttpProvider() {
        const t = `${this.name}:${this.chainId}`, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    getCardanoRPCUrl(t) {
        const e = this.namespace.rpcMap;
        if (e) return e[t];
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || this.getCardanoRPCUrl(t);
        if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
        return new (0, $1EAvo.JsonRpcProvider)(new (0, $eAMDx.default)(i, $429f6d87faf9801c$var$h("disableProviderPing")));
    }
}
var $429f6d87faf9801c$var$_e = Object.defineProperty, $429f6d87faf9801c$var$Ue = (s, t, e)=>t in s ? $429f6d87faf9801c$var$_e(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $429f6d87faf9801c$var$H = (s, t, e)=>$429f6d87faf9801c$var$Ue(s, typeof t != "symbol" ? t + "" : t, e);
class $429f6d87faf9801c$var$Fe {
    constructor(t){
        $429f6d87faf9801c$var$H(this, "name", "elrond"), $429f6d87faf9801c$var$H(this, "client"), $429f6d87faf9801c$var$H(this, "httpProviders"), $429f6d87faf9801c$var$H(this, "events"), $429f6d87faf9801c$var$H(this, "namespace"), $429f6d87faf9801c$var$H(this, "chainId"), this.namespace = t.namespace, this.events = $429f6d87faf9801c$var$h("events"), this.client = $429f6d87faf9801c$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    setDefaultChain(t, e) {
        this.httpProviders[t] || this.setHttpProvider(t, e), this.chainId = t, this.events.emit($429f6d87faf9801c$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${t}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? [
            ...new Set(t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            var i;
            const n = $429f6d87faf9801c$var$P(e);
            t[n] = this.createHttpProvider(n, (i = this.namespace.rpcMap) == null ? void 0 : i[e]);
        }), t;
    }
    getHttpProvider() {
        const t = `${this.name}:${this.chainId}`, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || $429f6d87faf9801c$var$p(t, this.namespace, this.client.core.projectId);
        if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
        return new (0, $1EAvo.JsonRpcProvider)(new (0, $eAMDx.default)(i, $429f6d87faf9801c$var$h("disableProviderPing")));
    }
}
var $429f6d87faf9801c$var$Le = Object.defineProperty, $429f6d87faf9801c$var$xe = (s, t, e)=>t in s ? $429f6d87faf9801c$var$Le(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $429f6d87faf9801c$var$E = (s, t, e)=>$429f6d87faf9801c$var$xe(s, typeof t != "symbol" ? t + "" : t, e);
class $429f6d87faf9801c$var$Me {
    constructor(t){
        $429f6d87faf9801c$var$E(this, "name", "multiversx"), $429f6d87faf9801c$var$E(this, "client"), $429f6d87faf9801c$var$E(this, "httpProviders"), $429f6d87faf9801c$var$E(this, "events"), $429f6d87faf9801c$var$E(this, "namespace"), $429f6d87faf9801c$var$E(this, "chainId"), this.namespace = t.namespace, this.events = $429f6d87faf9801c$var$h("events"), this.client = $429f6d87faf9801c$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    setDefaultChain(t, e) {
        this.httpProviders[t] || this.setHttpProvider(t, e), this.chainId = t, this.events.emit($429f6d87faf9801c$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${t}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? [
            ...new Set(t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            var i;
            const n = $429f6d87faf9801c$var$P(e);
            t[n] = this.createHttpProvider(n, (i = this.namespace.rpcMap) == null ? void 0 : i[e]);
        }), t;
    }
    getHttpProvider() {
        const t = `${this.name}:${this.chainId}`, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || $429f6d87faf9801c$var$p(t, this.namespace, this.client.core.projectId);
        if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
        return new (0, $1EAvo.JsonRpcProvider)(new (0, $eAMDx.default)(i, $429f6d87faf9801c$var$h("disableProviderPing")));
    }
}
var $429f6d87faf9801c$var$Be = Object.defineProperty, $429f6d87faf9801c$var$Ge = (s, t, e)=>t in s ? $429f6d87faf9801c$var$Be(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $429f6d87faf9801c$var$N = (s, t, e)=>$429f6d87faf9801c$var$Ge(s, typeof t != "symbol" ? t + "" : t, e);
class $429f6d87faf9801c$var$Je {
    constructor(t){
        $429f6d87faf9801c$var$N(this, "name", "near"), $429f6d87faf9801c$var$N(this, "client"), $429f6d87faf9801c$var$N(this, "httpProviders"), $429f6d87faf9801c$var$N(this, "events"), $429f6d87faf9801c$var$N(this, "namespace"), $429f6d87faf9801c$var$N(this, "chainId"), this.namespace = t.namespace, this.events = $429f6d87faf9801c$var$h("events"), this.client = $429f6d87faf9801c$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    setDefaultChain(t, e) {
        if (this.chainId = t, !this.httpProviders[t]) {
            const i = e || $429f6d87faf9801c$var$p(`${this.name}:${t}`, this.namespace);
            if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
            this.setHttpProvider(t, i);
        }
        this.events.emit($429f6d87faf9801c$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]) || [] : [];
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            var i;
            t[e] = this.createHttpProvider(e, (i = this.namespace.rpcMap) == null ? void 0 : i[e]);
        }), t;
    }
    getHttpProvider() {
        const t = `${this.name}:${this.chainId}`, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || $429f6d87faf9801c$var$p(t, this.namespace);
        return typeof i > "u" ? void 0 : new (0, $1EAvo.JsonRpcProvider)(new (0, $eAMDx.default)(i, $429f6d87faf9801c$var$h("disableProviderPing")));
    }
}
var $429f6d87faf9801c$var$ze = Object.defineProperty, $429f6d87faf9801c$var$ke = (s, t, e)=>t in s ? $429f6d87faf9801c$var$ze(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $429f6d87faf9801c$var$S = (s, t, e)=>$429f6d87faf9801c$var$ke(s, typeof t != "symbol" ? t + "" : t, e);
class $429f6d87faf9801c$var$We {
    constructor(t){
        $429f6d87faf9801c$var$S(this, "name", "tezos"), $429f6d87faf9801c$var$S(this, "client"), $429f6d87faf9801c$var$S(this, "httpProviders"), $429f6d87faf9801c$var$S(this, "events"), $429f6d87faf9801c$var$S(this, "namespace"), $429f6d87faf9801c$var$S(this, "chainId"), this.namespace = t.namespace, this.events = $429f6d87faf9801c$var$h("events"), this.client = $429f6d87faf9801c$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    setDefaultChain(t, e) {
        if (this.chainId = t, !this.httpProviders[t]) {
            const i = e || $429f6d87faf9801c$var$p(`${this.name}:${t}`, this.namespace);
            if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
            this.setHttpProvider(t, i);
        }
        this.events.emit($429f6d87faf9801c$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]) || [] : [];
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            t[e] = this.createHttpProvider(e);
        }), t;
    }
    getHttpProvider() {
        const t = `${this.name}:${this.chainId}`, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || $429f6d87faf9801c$var$p(t, this.namespace);
        return typeof i > "u" ? void 0 : new (0, $1EAvo.JsonRpcProvider)(new (0, $eAMDx.default)(i));
    }
}
var $429f6d87faf9801c$var$Ke = Object.defineProperty, $429f6d87faf9801c$var$Ve = (s, t, e)=>t in s ? $429f6d87faf9801c$var$Ke(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $429f6d87faf9801c$var$D = (s, t, e)=>$429f6d87faf9801c$var$Ve(s, typeof t != "symbol" ? t + "" : t, e);
class $429f6d87faf9801c$var$Xe {
    constructor(t){
        $429f6d87faf9801c$var$D(this, "name", $429f6d87faf9801c$var$w), $429f6d87faf9801c$var$D(this, "client"), $429f6d87faf9801c$var$D(this, "httpProviders"), $429f6d87faf9801c$var$D(this, "events"), $429f6d87faf9801c$var$D(this, "namespace"), $429f6d87faf9801c$var$D(this, "chainId"), this.namespace = t.namespace, this.events = $429f6d87faf9801c$var$h("events"), this.client = $429f6d87faf9801c$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace.chains = [
            ...new Set((this.namespace.chains || []).concat(t.chains || []))
        ], this.namespace.accounts = [
            ...new Set((this.namespace.accounts || []).concat(t.accounts || []))
        ], this.namespace.methods = [
            ...new Set((this.namespace.methods || []).concat(t.methods || []))
        ], this.namespace.events = [
            ...new Set((this.namespace.events || []).concat(t.events || []))
        ], this.httpProviders = this.createHttpProviders();
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider(t.chainId).request(t.request);
    }
    setDefaultChain(t, e) {
        this.httpProviders[t] || this.setHttpProvider(t, e), this.chainId = t, this.events.emit($429f6d87faf9801c$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${t}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? [
            ...new Set(t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        var t, e;
        const i = {};
        return (e = (t = this.namespace) == null ? void 0 : t.accounts) == null || e.forEach((n)=>{
            const a = (0, $3qpNA.parseChainId)(n);
            i[`${a.namespace}:${a.reference}`] = this.createHttpProvider(n);
        }), i;
    }
    getHttpProvider(t) {
        const e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || $429f6d87faf9801c$var$p(t, this.namespace, this.client.core.projectId);
        if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
        return new (0, $1EAvo.JsonRpcProvider)(new (0, $eAMDx.default)(i, $429f6d87faf9801c$var$h("disableProviderPing")));
    }
}
var $429f6d87faf9801c$var$Ye = Object.defineProperty, $429f6d87faf9801c$var$Qe = Object.defineProperties, $429f6d87faf9801c$var$Ze = Object.getOwnPropertyDescriptors, $429f6d87faf9801c$var$bt = Object.getOwnPropertySymbols, $429f6d87faf9801c$var$Te = Object.prototype.hasOwnProperty, $429f6d87faf9801c$var$ts = Object.prototype.propertyIsEnumerable, $429f6d87faf9801c$var$V = (s, t, e)=>t in s ? $429f6d87faf9801c$var$Ye(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $429f6d87faf9801c$var$L = (s, t)=>{
    for(var e in t || (t = {}))$429f6d87faf9801c$var$Te.call(t, e) && $429f6d87faf9801c$var$V(s, e, t[e]);
    if ($429f6d87faf9801c$var$bt) for (var e of $429f6d87faf9801c$var$bt(t))$429f6d87faf9801c$var$ts.call(t, e) && $429f6d87faf9801c$var$V(s, e, t[e]);
    return s;
}, $429f6d87faf9801c$var$X = (s, t)=>$429f6d87faf9801c$var$Qe(s, $429f6d87faf9801c$var$Ze(t)), $429f6d87faf9801c$var$u = (s, t, e)=>$429f6d87faf9801c$var$V(s, typeof t != "symbol" ? t + "" : t, e);
class $429f6d87faf9801c$export$2e2bcd8739ae039 {
    constructor(t){
        $429f6d87faf9801c$var$u(this, "client"), $429f6d87faf9801c$var$u(this, "namespaces"), $429f6d87faf9801c$var$u(this, "optionalNamespaces"), $429f6d87faf9801c$var$u(this, "sessionProperties"), $429f6d87faf9801c$var$u(this, "scopedProperties"), $429f6d87faf9801c$var$u(this, "events", new (0, (/*@__PURE__*/$parcel$interopDefault($5yFVO)))), $429f6d87faf9801c$var$u(this, "rpcProviders", {}), $429f6d87faf9801c$var$u(this, "session"), $429f6d87faf9801c$var$u(this, "providerOpts"), $429f6d87faf9801c$var$u(this, "logger"), $429f6d87faf9801c$var$u(this, "uri"), $429f6d87faf9801c$var$u(this, "disableProviderPing", !1), this.providerOpts = t, this.logger = typeof t?.logger < "u" && typeof t?.logger != "string" ? t.logger : (0, (/*@__PURE__*/$parcel$interopDefault($66E6s)))((0, $6GQzw.getDefaultLoggerOptions)({
            level: t?.logger || $429f6d87faf9801c$var$tt
        })), this.disableProviderPing = t?.disableProviderPing || !1;
    }
    static async init(t) {
        const e = new $429f6d87faf9801c$export$2e2bcd8739ae039(t);
        return await e.initialize(), e;
    }
    async request(t, e, i) {
        const [n, a] = this.validateChain(e);
        if (!this.session) throw new Error("Please call connect() before request()");
        return await this.getProvider(n).request({
            request: $429f6d87faf9801c$var$L({}, t),
            chainId: `${n}:${a}`,
            topic: this.session.topic,
            expiry: i
        });
    }
    sendAsync(t, e, i, n) {
        const a = new Date().getTime();
        this.request(t, i, n).then((r)=>e(null, (0, $fHodW.formatJsonRpcResult)(a, r))).catch((r)=>e(r, void 0));
    }
    async enable() {
        if (!this.client) throw new Error("Sign Client not initialized");
        return this.session || await this.connect({
            namespaces: this.namespaces,
            optionalNamespaces: this.optionalNamespaces,
            sessionProperties: this.sessionProperties,
            scopedProperties: this.scopedProperties
        }), await this.requestAccounts();
    }
    async disconnect() {
        var t;
        if (!this.session) throw new Error("Please call connect() before enable()");
        await this.client.disconnect({
            topic: (t = this.session) == null ? void 0 : t.topic,
            reason: (0, $3qpNA.getSdkError)("USER_DISCONNECTED")
        }), await this.cleanup();
    }
    async connect(t) {
        if (!this.client) throw new Error("Sign Client not initialized");
        if (this.setNamespaces(t), await this.cleanupPendingPairings(), !t.skipPairing) return await this.pair(t.pairingTopic);
    }
    async authenticate(t, e) {
        if (!this.client) throw new Error("Sign Client not initialized");
        this.setNamespaces(t), await this.cleanupPendingPairings();
        const { uri: i, response: n } = await this.client.authenticate(t, e);
        i && (this.uri = i, this.events.emit("display_uri", i));
        const a = await n();
        if (this.session = a.session, this.session) {
            const r = $429f6d87faf9801c$var$vt(this.session.namespaces);
            this.namespaces = $429f6d87faf9801c$var$z(this.namespaces, r), await this.persist("namespaces", this.namespaces), this.onConnect();
        }
        return a;
    }
    on(t, e) {
        this.events.on(t, e);
    }
    once(t, e) {
        this.events.once(t, e);
    }
    removeListener(t, e) {
        this.events.removeListener(t, e);
    }
    off(t, e) {
        this.events.off(t, e);
    }
    get isWalletConnect() {
        return !0;
    }
    async pair(t) {
        const { uri: e, approval: i } = await this.client.connect({
            pairingTopic: t,
            requiredNamespaces: this.namespaces,
            optionalNamespaces: this.optionalNamespaces,
            sessionProperties: this.sessionProperties,
            scopedProperties: this.scopedProperties
        });
        e && (this.uri = e, this.events.emit("display_uri", e));
        const n = await i();
        this.session = n;
        const a = $429f6d87faf9801c$var$vt(n.namespaces);
        return this.namespaces = $429f6d87faf9801c$var$z(this.namespaces, a), await this.persist("namespaces", this.namespaces), await this.persist("optionalNamespaces", this.optionalNamespaces), this.onConnect(), this.session;
    }
    setDefaultChain(t, e) {
        try {
            if (!this.session) return;
            const [i, n] = this.validateChain(t), a = this.getProvider(i);
            a.name === $429f6d87faf9801c$var$w ? a.setDefaultChain(`${i}:${n}`, e) : a.setDefaultChain(n, e);
        } catch (i) {
            if (!/Please call connect/.test(i.message)) throw i;
        }
    }
    async cleanupPendingPairings(t = {}) {
        this.logger.info("Cleaning up inactive pairings...");
        const e = this.client.pairing.getAll();
        if ((0, $3qpNA.isValidArray)(e)) {
            for (const i of e)t.deletePairings ? this.client.core.expirer.set(i.topic, 0) : await this.client.core.relayer.subscriber.unsubscribe(i.topic);
            this.logger.info(`Inactive pairings cleared: ${e.length}`);
        }
    }
    abortPairingAttempt() {
        this.logger.warn("abortPairingAttempt is deprecated. This is now a no-op.");
    }
    async checkStorage() {
        this.namespaces = await this.getFromStore("namespaces") || {}, this.optionalNamespaces = await this.getFromStore("optionalNamespaces") || {}, this.session && this.createProviders();
    }
    async initialize() {
        this.logger.trace("Initialized"), await this.createClient(), await this.checkStorage(), this.registerEventListeners();
    }
    async createClient() {
        var t, e;
        if (this.client = this.providerOpts.client || await (0, $kozsa.default).init({
            core: this.providerOpts.core,
            logger: this.providerOpts.logger || $429f6d87faf9801c$var$tt,
            relayUrl: this.providerOpts.relayUrl || $429f6d87faf9801c$var$St,
            projectId: this.providerOpts.projectId,
            metadata: this.providerOpts.metadata,
            storageOptions: this.providerOpts.storageOptions,
            storage: this.providerOpts.storage,
            name: this.providerOpts.name,
            customStoragePrefix: this.providerOpts.customStoragePrefix,
            telemetryEnabled: this.providerOpts.telemetryEnabled
        }), this.providerOpts.session) try {
            this.session = this.client.session.get(this.providerOpts.session.topic);
        } catch (i) {
            throw this.logger.error("Failed to get session", i), new Error(`The provided session: ${(e = (t = this.providerOpts) == null ? void 0 : t.session) == null ? void 0 : e.topic} doesn't exist in the Sign client`);
        }
        else {
            const i = this.client.session.getAll();
            this.session = i[0];
        }
        this.logger.trace("SignClient Initialized");
    }
    createProviders() {
        if (!this.client) throw new Error("Sign Client not initialized");
        if (!this.session) throw new Error("Session not initialized. Please call connect() before enable()");
        const t = [
            ...new Set(Object.keys(this.session.namespaces).map((e)=>(0, $3qpNA.parseNamespaceKey)(e)))
        ];
        $429f6d87faf9801c$var$W("client", this.client), $429f6d87faf9801c$var$W("events", this.events), $429f6d87faf9801c$var$W("disableProviderPing", this.disableProviderPing), t.forEach((e)=>{
            if (!this.session) return;
            const i = $429f6d87faf9801c$var$le(e, this.session), n = $429f6d87faf9801c$var$lt(i), a = $429f6d87faf9801c$var$z(this.namespaces, this.optionalNamespaces), r = $429f6d87faf9801c$var$X($429f6d87faf9801c$var$L({}, a[e]), {
                accounts: i,
                chains: n
            });
            switch(e){
                case "eip155":
                    this.rpcProviders[e] = new $429f6d87faf9801c$var$Ie({
                        namespace: r
                    });
                    break;
                case "algorand":
                    this.rpcProviders[e] = new $429f6d87faf9801c$var$De({
                        namespace: r
                    });
                    break;
                case "solana":
                    this.rpcProviders[e] = new $429f6d87faf9801c$var$Ae({
                        namespace: r
                    });
                    break;
                case "cosmos":
                    this.rpcProviders[e] = new $429f6d87faf9801c$var$Ee({
                        namespace: r
                    });
                    break;
                case "polkadot":
                    this.rpcProviders[e] = new $429f6d87faf9801c$var$ve({
                        namespace: r
                    });
                    break;
                case "cip34":
                    this.rpcProviders[e] = new $429f6d87faf9801c$var$Re({
                        namespace: r
                    });
                    break;
                case "elrond":
                    this.rpcProviders[e] = new $429f6d87faf9801c$var$Fe({
                        namespace: r
                    });
                    break;
                case "multiversx":
                    this.rpcProviders[e] = new $429f6d87faf9801c$var$Me({
                        namespace: r
                    });
                    break;
                case "near":
                    this.rpcProviders[e] = new $429f6d87faf9801c$var$Je({
                        namespace: r
                    });
                    break;
                case "tezos":
                    this.rpcProviders[e] = new $429f6d87faf9801c$var$We({
                        namespace: r
                    });
                    break;
                default:
                    this.rpcProviders[$429f6d87faf9801c$var$w] ? this.rpcProviders[$429f6d87faf9801c$var$w].updateNamespace(r) : this.rpcProviders[$429f6d87faf9801c$var$w] = new $429f6d87faf9801c$var$Xe({
                        namespace: r
                    });
            }
        });
    }
    registerEventListeners() {
        if (typeof this.client > "u") throw new Error("Sign Client is not initialized");
        this.client.on("session_ping", (t)=>{
            var e;
            const { topic: i } = t;
            i === ((e = this.session) == null ? void 0 : e.topic) && this.events.emit("session_ping", t);
        }), this.client.on("session_event", (t)=>{
            var e;
            const { params: i, topic: n } = t;
            if (n !== ((e = this.session) == null ? void 0 : e.topic)) return;
            const { event: a } = i;
            if (a.name === "accountsChanged") {
                const r = a.data;
                r && (0, $3qpNA.isValidArray)(r) && this.events.emit("accountsChanged", r.map($429f6d87faf9801c$var$mt));
            } else if (a.name === "chainChanged") {
                const r = i.chainId, c = i.event.data, o = (0, $3qpNA.parseNamespaceKey)(r), v = $429f6d87faf9801c$var$k(r) !== $429f6d87faf9801c$var$k(c) ? `${o}:${$429f6d87faf9801c$var$k(c)}` : r;
                this.onChainChanged(v);
            } else this.events.emit(a.name, a.data);
            this.events.emit("session_event", t);
        }), this.client.on("session_update", ({ topic: t, params: e })=>{
            var i, n;
            if (t !== ((i = this.session) == null ? void 0 : i.topic)) return;
            const { namespaces: a } = e, r = (n = this.client) == null ? void 0 : n.session.get(t);
            this.session = $429f6d87faf9801c$var$X($429f6d87faf9801c$var$L({}, r), {
                namespaces: a
            }), this.onSessionUpdate(), this.events.emit("session_update", {
                topic: t,
                params: e
            });
        }), this.client.on("session_delete", async (t)=>{
            var e;
            t.topic === ((e = this.session) == null ? void 0 : e.topic) && (await this.cleanup(), this.events.emit("session_delete", t), this.events.emit("disconnect", $429f6d87faf9801c$var$X($429f6d87faf9801c$var$L({}, (0, $3qpNA.getSdkError)("USER_DISCONNECTED")), {
                data: t.topic
            })));
        }), this.on($429f6d87faf9801c$var$d.DEFAULT_CHAIN_CHANGED, (t)=>{
            this.onChainChanged(t, !0);
        });
    }
    getProvider(t) {
        return this.rpcProviders[t] || this.rpcProviders[$429f6d87faf9801c$var$w];
    }
    onSessionUpdate() {
        Object.keys(this.rpcProviders).forEach((t)=>{
            var e;
            this.getProvider(t).updateNamespace((e = this.session) == null ? void 0 : e.namespaces[t]);
        });
    }
    setNamespaces(t) {
        const { namespaces: e, optionalNamespaces: i, sessionProperties: n, scopedProperties: a } = t;
        e && Object.keys(e).length && (this.namespaces = e), i && Object.keys(i).length && (this.optionalNamespaces = i), this.sessionProperties = n, this.scopedProperties = a;
    }
    validateChain(t) {
        const [e, i] = t?.split(":") || [
            "",
            ""
        ];
        if (!this.namespaces || !Object.keys(this.namespaces).length) return [
            e,
            i
        ];
        if (e && !Object.keys(this.namespaces || {}).map((r)=>(0, $3qpNA.parseNamespaceKey)(r)).includes(e)) throw new Error(`Namespace '${e}' is not configured. Please call connect() first with namespace config.`);
        if (e && i) return [
            e,
            i
        ];
        const n = (0, $3qpNA.parseNamespaceKey)(Object.keys(this.namespaces)[0]), a = this.rpcProviders[n].getDefaultChain();
        return [
            n,
            a
        ];
    }
    async requestAccounts() {
        const [t] = this.validateChain();
        return await this.getProvider(t).requestAccounts();
    }
    async onChainChanged(t, e = !1) {
        if (!this.namespaces) return;
        const [i, n] = this.validateChain(t);
        if (!n) return;
        this.updateNamespaceChain(i, n), this.events.emit("chainChanged", n);
        const a = this.getProvider(i).getDefaultChain();
        e || this.getProvider(i).setDefaultChain(n), this.emitAccountsChangedOnChainChange({
            namespace: i,
            previousChainId: a,
            newChainId: t
        }), await this.persist("namespaces", this.namespaces);
    }
    emitAccountsChangedOnChainChange({ namespace: t, previousChainId: e, newChainId: i }) {
        var n, a;
        try {
            if (e === i) return;
            const r = (a = (n = this.session) == null ? void 0 : n.namespaces[t]) == null ? void 0 : a.accounts;
            if (!r) return;
            const c = r.filter((o)=>o.includes(`${i}:`)).map($429f6d87faf9801c$var$mt);
            if (!(0, $3qpNA.isValidArray)(c)) return;
            this.events.emit("accountsChanged", c);
        } catch (r) {
            this.logger.warn("Failed to emit accountsChanged on chain change", r);
        }
    }
    updateNamespaceChain(t, e) {
        if (!this.namespaces) return;
        const i = this.namespaces[t] ? t : `${t}:${e}`, n = {
            chains: [],
            methods: [],
            events: [],
            defaultChain: e
        };
        this.namespaces[i] ? this.namespaces[i] && (this.namespaces[i].defaultChain = e) : this.namespaces[i] = n;
    }
    onConnect() {
        this.createProviders(), this.events.emit("connect", {
            session: this.session
        });
    }
    async cleanup() {
        this.namespaces = void 0, this.optionalNamespaces = void 0, this.sessionProperties = void 0, await this.deleteFromStore("namespaces"), await this.deleteFromStore("optionalNamespaces"), await this.deleteFromStore("sessionProperties"), this.session = void 0, await this.cleanupPendingPairings({
            deletePairings: !0
        }), await this.cleanupStorage();
    }
    async persist(t, e) {
        var i;
        const n = ((i = this.session) == null ? void 0 : i.topic) || "";
        await this.client.core.storage.setItem(`${$429f6d87faf9801c$var$_}/${t}${n}`, e);
    }
    async getFromStore(t) {
        var e;
        const i = ((e = this.session) == null ? void 0 : e.topic) || "";
        return await this.client.core.storage.getItem(`${$429f6d87faf9801c$var$_}/${t}${i}`);
    }
    async deleteFromStore(t) {
        var e;
        const i = ((e = this.session) == null ? void 0 : e.topic) || "";
        await this.client.core.storage.removeItem(`${$429f6d87faf9801c$var$_}/${t}${i}`);
    }
    async cleanupStorage() {
        var t;
        try {
            if (((t = this.client) == null ? void 0 : t.session.length) > 0) return;
            const e = await this.client.core.storage.getKeys();
            for (const i of e)i.startsWith($429f6d87faf9801c$var$_) && await this.client.core.storage.removeItem(i);
        } catch (e) {
            this.logger.warn("Failed to cleanup storage", e);
        }
    }
}
const $429f6d87faf9801c$export$63bc40680ab52599 = $429f6d87faf9801c$export$2e2bcd8739ae039;

});
parcelRegister("kozsa", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed918cd7853aa237$export$2e2bcd8739ae039);

var $9bAHY = parcelRequire("9bAHY");

var $6GQzw = parcelRequire("6GQzw");
var $66E6s = parcelRequire("66E6s");

var $2B80D = parcelRequire("2B80D");

var $9eyak = parcelRequire("9eyak");

var $3qpNA = parcelRequire("3qpNA");

var $5yFVO = parcelRequire("5yFVO");
parcelRequire("7IWKC");
var $fHodW = parcelRequire("fHodW");
var $fgWWx = parcelRequire("fgWWx");
const $ed918cd7853aa237$export$4fa962fc67384e02 = "wc", $ed918cd7853aa237$export$61085c48796ff049 = 2, $ed918cd7853aa237$export$94715592c220319a = "client", $ed918cd7853aa237$export$7fa6f9ee1e2cab96 = `${$ed918cd7853aa237$export$4fa962fc67384e02}@${$ed918cd7853aa237$export$61085c48796ff049}:${$ed918cd7853aa237$export$94715592c220319a}:`, $ed918cd7853aa237$export$8dffb3242f2c5f72 = {
    name: $ed918cd7853aa237$export$94715592c220319a,
    logger: "error",
    controller: !1,
    relayUrl: "wss://relay.walletconnect.org"
}, $ed918cd7853aa237$export$fb2c3ad2a2bc26e9 = {
    session_proposal: "session_proposal",
    session_update: "session_update",
    session_extend: "session_extend",
    session_ping: "session_ping",
    session_delete: "session_delete",
    session_expire: "session_expire",
    session_request: "session_request",
    session_request_sent: "session_request_sent",
    session_event: "session_event",
    proposal_expire: "proposal_expire",
    session_authenticate: "session_authenticate",
    session_request_expire: "session_request_expire",
    session_connect: "session_connect"
}, $ed918cd7853aa237$export$2e2bb8505f95527b = {
    database: ":memory:"
}, $ed918cd7853aa237$export$a26ccd6441b7d638 = "WALLETCONNECT_DEEPLINK_CHOICE", $ed918cd7853aa237$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $ed918cd7853aa237$export$160142c73cb99dc3 = "history", $ed918cd7853aa237$export$8eba9ce85616c607 = "0.3", $ed918cd7853aa237$export$ae6c7a4f7ed730a1 = "proposal", $ed918cd7853aa237$export$6db28e89b135a53c = (0, $9eyak.THIRTY_DAYS), $ed918cd7853aa237$export$1e6a4dc5172f4830 = "Proposal expired", $ed918cd7853aa237$export$a069e98a8dfeec1e = "session", $ed918cd7853aa237$export$84b1b9dbcdea0475 = (0, $9eyak.SEVEN_DAYS), $ed918cd7853aa237$export$2db42d5151ad6eb8 = "engine", $ed918cd7853aa237$export$4edb1ca37014192d = {
    wc_sessionPropose: {
        req: {
            ttl: (0, $9eyak.FIVE_MINUTES),
            prompt: !0,
            tag: 1100
        },
        res: {
            ttl: (0, $9eyak.FIVE_MINUTES),
            prompt: !1,
            tag: 1101
        },
        reject: {
            ttl: (0, $9eyak.FIVE_MINUTES),
            prompt: !1,
            tag: 1120
        },
        autoReject: {
            ttl: (0, $9eyak.FIVE_MINUTES),
            prompt: !1,
            tag: 1121
        }
    },
    wc_sessionSettle: {
        req: {
            ttl: (0, $9eyak.FIVE_MINUTES),
            prompt: !1,
            tag: 1102
        },
        res: {
            ttl: (0, $9eyak.FIVE_MINUTES),
            prompt: !1,
            tag: 1103
        }
    },
    wc_sessionUpdate: {
        req: {
            ttl: (0, $9eyak.ONE_DAY),
            prompt: !1,
            tag: 1104
        },
        res: {
            ttl: (0, $9eyak.ONE_DAY),
            prompt: !1,
            tag: 1105
        }
    },
    wc_sessionExtend: {
        req: {
            ttl: (0, $9eyak.ONE_DAY),
            prompt: !1,
            tag: 1106
        },
        res: {
            ttl: (0, $9eyak.ONE_DAY),
            prompt: !1,
            tag: 1107
        }
    },
    wc_sessionRequest: {
        req: {
            ttl: (0, $9eyak.FIVE_MINUTES),
            prompt: !0,
            tag: 1108
        },
        res: {
            ttl: (0, $9eyak.FIVE_MINUTES),
            prompt: !1,
            tag: 1109
        }
    },
    wc_sessionEvent: {
        req: {
            ttl: (0, $9eyak.FIVE_MINUTES),
            prompt: !0,
            tag: 1110
        },
        res: {
            ttl: (0, $9eyak.FIVE_MINUTES),
            prompt: !1,
            tag: 1111
        }
    },
    wc_sessionDelete: {
        req: {
            ttl: (0, $9eyak.ONE_DAY),
            prompt: !1,
            tag: 1112
        },
        res: {
            ttl: (0, $9eyak.ONE_DAY),
            prompt: !1,
            tag: 1113
        }
    },
    wc_sessionPing: {
        req: {
            ttl: (0, $9eyak.ONE_DAY),
            prompt: !1,
            tag: 1114
        },
        res: {
            ttl: (0, $9eyak.ONE_DAY),
            prompt: !1,
            tag: 1115
        }
    },
    wc_sessionAuthenticate: {
        req: {
            ttl: (0, $9eyak.ONE_HOUR),
            prompt: !0,
            tag: 1116
        },
        res: {
            ttl: (0, $9eyak.ONE_HOUR),
            prompt: !1,
            tag: 1117
        },
        reject: {
            ttl: (0, $9eyak.FIVE_MINUTES),
            prompt: !1,
            tag: 1118
        },
        autoReject: {
            ttl: (0, $9eyak.FIVE_MINUTES),
            prompt: !1,
            tag: 1119
        }
    }
}, $ed918cd7853aa237$export$409f0c0a13a1b7c6 = {
    min: (0, $9eyak.FIVE_MINUTES),
    max: (0, $9eyak.SEVEN_DAYS)
}, $ed918cd7853aa237$export$8602b201748df21a = {
    idle: "IDLE",
    active: "ACTIVE"
}, $ed918cd7853aa237$export$a06a2a399442c35f = {
    eth_sendTransaction: {
        key: ""
    },
    eth_sendRawTransaction: {
        key: ""
    },
    wallet_sendCalls: {
        key: ""
    },
    solana_signTransaction: {
        key: "signature"
    },
    solana_signAllTransactions: {
        key: "transactions"
    },
    solana_signAndSendTransaction: {
        key: "signature"
    }
}, $ed918cd7853aa237$export$40b296af21bd38a4 = "request", $ed918cd7853aa237$export$63c37d8ae5931ad5 = [
    "wc_sessionPropose",
    "wc_sessionRequest",
    "wc_authRequest",
    "wc_sessionAuthenticate"
], $ed918cd7853aa237$export$e24c518fa7fc04c = "wc", $ed918cd7853aa237$export$af233b4aa2e30834 = 1.5, $ed918cd7853aa237$export$e8b9bbdca3ac0ed = "auth", $ed918cd7853aa237$export$ab815cb37981e7e0 = "authKeys", $ed918cd7853aa237$export$5d9af9e20f678626 = "pairingTopics", $ed918cd7853aa237$export$3643b3579d091159 = "requests", $ed918cd7853aa237$export$323ba3ebb8028ed0 = `${$ed918cd7853aa237$export$e24c518fa7fc04c}@${1.5}:${$ed918cd7853aa237$export$e8b9bbdca3ac0ed}:`, $ed918cd7853aa237$export$efef74cb455ac30f = `${$ed918cd7853aa237$export$323ba3ebb8028ed0}:PUB_KEY`;
var $ed918cd7853aa237$var$Rs = Object.defineProperty, $ed918cd7853aa237$var$vs = Object.defineProperties, $ed918cd7853aa237$var$Is = Object.getOwnPropertyDescriptors, $ed918cd7853aa237$var$ft = Object.getOwnPropertySymbols, $ed918cd7853aa237$var$Ts = Object.prototype.hasOwnProperty, $ed918cd7853aa237$var$qs = Object.prototype.propertyIsEnumerable, $ed918cd7853aa237$var$Ke = (S, n, e)=>n in S ? $ed918cd7853aa237$var$Rs(S, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : S[n] = e, $ed918cd7853aa237$var$v = (S, n)=>{
    for(var e in n || (n = {}))$ed918cd7853aa237$var$Ts.call(n, e) && $ed918cd7853aa237$var$Ke(S, e, n[e]);
    if ($ed918cd7853aa237$var$ft) for (var e of $ed918cd7853aa237$var$ft(n))$ed918cd7853aa237$var$qs.call(n, e) && $ed918cd7853aa237$var$Ke(S, e, n[e]);
    return S;
}, $ed918cd7853aa237$var$b = (S, n)=>$ed918cd7853aa237$var$vs(S, $ed918cd7853aa237$var$Is(n)), $ed918cd7853aa237$var$c = (S, n, e)=>$ed918cd7853aa237$var$Ke(S, typeof n != "symbol" ? n + "" : n, e);
class $ed918cd7853aa237$var$Ps extends (0, $2B80D.IEngine) {
    constructor(n){
        super(n), $ed918cd7853aa237$var$c(this, "name", $ed918cd7853aa237$export$2db42d5151ad6eb8), $ed918cd7853aa237$var$c(this, "events", new (0, (/*@__PURE__*/$parcel$interopDefault($5yFVO)))), $ed918cd7853aa237$var$c(this, "initialized", !1), $ed918cd7853aa237$var$c(this, "requestQueue", {
            state: $ed918cd7853aa237$export$8602b201748df21a.idle,
            queue: []
        }), $ed918cd7853aa237$var$c(this, "sessionRequestQueue", {
            state: $ed918cd7853aa237$export$8602b201748df21a.idle,
            queue: []
        }), $ed918cd7853aa237$var$c(this, "requestQueueDelay", (0, $9eyak.ONE_SECOND)), $ed918cd7853aa237$var$c(this, "expectedPairingMethodMap", new Map), $ed918cd7853aa237$var$c(this, "recentlyDeletedMap", new Map), $ed918cd7853aa237$var$c(this, "recentlyDeletedLimit", 200), $ed918cd7853aa237$var$c(this, "relayMessageCache", []), $ed918cd7853aa237$var$c(this, "pendingSessions", new Map), $ed918cd7853aa237$var$c(this, "init", async ()=>{
            this.initialized || (await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.registerPairingEvents(), await this.registerLinkModeListeners(), this.client.core.pairing.register({
                methods: Object.keys($ed918cd7853aa237$export$4edb1ca37014192d)
            }), this.initialized = !0, setTimeout(async ()=>{
                await this.processPendingMessageEvents(), this.sessionRequestQueue.queue = this.getPendingSessionRequests(), this.processSessionRequestQueue();
            }, (0, $9eyak.toMiliseconds)(this.requestQueueDelay)));
        }), $ed918cd7853aa237$var$c(this, "connect", async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow();
            const t = $ed918cd7853aa237$var$b($ed918cd7853aa237$var$v({}, e), {
                requiredNamespaces: e.requiredNamespaces || {},
                optionalNamespaces: e.optionalNamespaces || {}
            });
            await this.isValidConnect(t);
            const { pairingTopic: s, requiredNamespaces: i, optionalNamespaces: r, sessionProperties: o, scopedProperties: a, relays: l } = t;
            let p = s, h, u = !1;
            try {
                if (p) {
                    const T = this.client.core.pairing.pairings.get(p);
                    this.client.logger.warn("connect() with existing pairing topic is deprecated and will be removed in the next major release."), u = T.active;
                }
            } catch (T) {
                throw this.client.logger.error(`connect() -> pairing.get(${p}) failed`), T;
            }
            if (!p || !u) {
                const { topic: T, uri: U } = await this.client.core.pairing.create();
                p = T, h = U;
            }
            if (!p) {
                const { message: T } = (0, $3qpNA.getInternalError)("NO_MATCHING_KEY", `connect() pairing topic: ${p}`);
                throw new Error(T);
            }
            const d = await this.client.core.crypto.generateKeyPair(), w = $ed918cd7853aa237$export$4edb1ca37014192d.wc_sessionPropose.req.ttl || (0, $9eyak.FIVE_MINUTES), m = (0, $3qpNA.calcExpiry)(w), f = $ed918cd7853aa237$var$b($ed918cd7853aa237$var$v($ed918cd7853aa237$var$v({
                requiredNamespaces: i,
                optionalNamespaces: r,
                relays: l ?? [
                    {
                        protocol: (0, $9bAHY.RELAYER_DEFAULT_PROTOCOL)
                    }
                ],
                proposer: {
                    publicKey: d,
                    metadata: this.client.metadata
                },
                expiryTimestamp: m,
                pairingTopic: p
            }, o && {
                sessionProperties: o
            }), a && {
                scopedProperties: a
            }), {
                id: (0, $fHodW.payloadId)()
            }), _ = (0, $3qpNA.engineEvent)("session_connect", f.id), { reject: g, resolve: A, done: D } = (0, $3qpNA.createDelayedPromise)(w, $ed918cd7853aa237$export$1e6a4dc5172f4830), I = ({ id: T })=>{
                T === f.id && (this.client.events.off("proposal_expire", I), this.pendingSessions.delete(f.id), this.events.emit(_, {
                    error: {
                        message: $ed918cd7853aa237$export$1e6a4dc5172f4830,
                        code: 0
                    }
                }));
            };
            return this.client.events.on("proposal_expire", I), this.events.once(_, ({ error: T, session: U })=>{
                this.client.events.off("proposal_expire", I), T ? g(T) : U && A(U);
            }), await this.sendRequest({
                topic: p,
                method: "wc_sessionPropose",
                params: f,
                throwOnFailedPublish: !0,
                clientRpcId: f.id
            }), await this.setProposal(f.id, f), {
                uri: h,
                approval: D
            };
        }), $ed918cd7853aa237$var$c(this, "pair", async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow();
            try {
                return await this.client.core.pairing.pair(e);
            } catch (t) {
                throw this.client.logger.error("pair() failed"), t;
            }
        }), $ed918cd7853aa237$var$c(this, "approve", async (e)=>{
            var t, s, i;
            const r = this.client.core.eventClient.createEvent({
                properties: {
                    topic: (t = e?.id) == null ? void 0 : t.toString(),
                    trace: [
                        (0, $9bAHY.EVENT_CLIENT_SESSION_TRACES).session_approve_started
                    ]
                }
            });
            try {
                this.isInitialized(), await this.confirmOnlineStateOrThrow();
            } catch (q) {
                throw r.setError((0, $9bAHY.EVENT_CLIENT_SESSION_ERRORS).no_internet_connection), q;
            }
            try {
                await this.isValidProposalId(e?.id);
            } catch (q) {
                throw this.client.logger.error(`approve() -> proposal.get(${e?.id}) failed`), r.setError((0, $9bAHY.EVENT_CLIENT_SESSION_ERRORS).proposal_not_found), q;
            }
            try {
                await this.isValidApprove(e);
            } catch (q) {
                throw this.client.logger.error("approve() -> isValidApprove() failed"), r.setError((0, $9bAHY.EVENT_CLIENT_SESSION_ERRORS).session_approve_namespace_validation_failure), q;
            }
            const { id: o, relayProtocol: a, namespaces: l, sessionProperties: p, scopedProperties: h, sessionConfig: u } = e, d = this.client.proposal.get(o);
            this.client.core.eventClient.deleteEvent({
                eventId: r.eventId
            });
            const { pairingTopic: w, proposer: m, requiredNamespaces: f, optionalNamespaces: _ } = d;
            let g = (s = this.client.core.eventClient) == null ? void 0 : s.getEvent({
                topic: w
            });
            g || (g = (i = this.client.core.eventClient) == null ? void 0 : i.createEvent({
                type: (0, $9bAHY.EVENT_CLIENT_SESSION_TRACES).session_approve_started,
                properties: {
                    topic: w,
                    trace: [
                        (0, $9bAHY.EVENT_CLIENT_SESSION_TRACES).session_approve_started,
                        (0, $9bAHY.EVENT_CLIENT_SESSION_TRACES).session_namespaces_validation_success
                    ]
                }
            }));
            const A = await this.client.core.crypto.generateKeyPair(), D = m.publicKey, I = await this.client.core.crypto.generateSharedKey(A, D), T = $ed918cd7853aa237$var$v($ed918cd7853aa237$var$v($ed918cd7853aa237$var$v({
                relay: {
                    protocol: a ?? "irn"
                },
                namespaces: l,
                controller: {
                    publicKey: A,
                    metadata: this.client.metadata
                },
                expiry: (0, $3qpNA.calcExpiry)($ed918cd7853aa237$export$84b1b9dbcdea0475)
            }, p && {
                sessionProperties: p
            }), h && {
                scopedProperties: h
            }), u && {
                sessionConfig: u
            }), U = (0, $9bAHY.TRANSPORT_TYPES).relay;
            g.addTrace((0, $9bAHY.EVENT_CLIENT_SESSION_TRACES).subscribing_session_topic);
            try {
                await this.client.core.relayer.subscribe(I, {
                    transportType: U
                });
            } catch (q) {
                throw g.setError((0, $9bAHY.EVENT_CLIENT_SESSION_ERRORS).subscribe_session_topic_failure), q;
            }
            g.addTrace((0, $9bAHY.EVENT_CLIENT_SESSION_TRACES).subscribe_session_topic_success);
            const fe = $ed918cd7853aa237$var$b($ed918cd7853aa237$var$v({}, T), {
                topic: I,
                requiredNamespaces: f,
                optionalNamespaces: _,
                pairingTopic: w,
                acknowledged: !1,
                self: T.controller,
                peer: {
                    publicKey: m.publicKey,
                    metadata: m.metadata
                },
                controller: A,
                transportType: (0, $9bAHY.TRANSPORT_TYPES).relay
            });
            await this.client.session.set(I, fe), g.addTrace((0, $9bAHY.EVENT_CLIENT_SESSION_TRACES).store_session);
            try {
                g.addTrace((0, $9bAHY.EVENT_CLIENT_SESSION_TRACES).publishing_session_settle), await this.sendRequest({
                    topic: I,
                    method: "wc_sessionSettle",
                    params: T,
                    throwOnFailedPublish: !0
                }).catch((q)=>{
                    throw g?.setError((0, $9bAHY.EVENT_CLIENT_SESSION_ERRORS).session_settle_publish_failure), q;
                }), g.addTrace((0, $9bAHY.EVENT_CLIENT_SESSION_TRACES).session_settle_publish_success), g.addTrace((0, $9bAHY.EVENT_CLIENT_SESSION_TRACES).publishing_session_approve), await this.sendResult({
                    id: o,
                    topic: w,
                    result: {
                        relay: {
                            protocol: a ?? "irn"
                        },
                        responderPublicKey: A
                    },
                    throwOnFailedPublish: !0
                }).catch((q)=>{
                    throw g?.setError((0, $9bAHY.EVENT_CLIENT_SESSION_ERRORS).session_approve_publish_failure), q;
                }), g.addTrace((0, $9bAHY.EVENT_CLIENT_SESSION_TRACES).session_approve_publish_success);
            } catch (q) {
                throw this.client.logger.error(q), this.client.session.delete(I, (0, $3qpNA.getSdkError)("USER_DISCONNECTED")), await this.client.core.relayer.unsubscribe(I), q;
            }
            return this.client.core.eventClient.deleteEvent({
                eventId: g.eventId
            }), await this.client.core.pairing.updateMetadata({
                topic: w,
                metadata: m.metadata
            }), await this.client.proposal.delete(o, (0, $3qpNA.getSdkError)("USER_DISCONNECTED")), await this.client.core.pairing.activate({
                topic: w
            }), await this.setExpiry(I, (0, $3qpNA.calcExpiry)($ed918cd7853aa237$export$84b1b9dbcdea0475)), {
                topic: I,
                acknowledged: ()=>Promise.resolve(this.client.session.get(I))
            };
        }), $ed918cd7853aa237$var$c(this, "reject", async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow();
            try {
                await this.isValidReject(e);
            } catch (r) {
                throw this.client.logger.error("reject() -> isValidReject() failed"), r;
            }
            const { id: t, reason: s } = e;
            let i;
            try {
                i = this.client.proposal.get(t).pairingTopic;
            } catch (r) {
                throw this.client.logger.error(`reject() -> proposal.get(${t}) failed`), r;
            }
            i && (await this.sendError({
                id: t,
                topic: i,
                error: s,
                rpcOpts: $ed918cd7853aa237$export$4edb1ca37014192d.wc_sessionPropose.reject
            }), await this.client.proposal.delete(t, (0, $3qpNA.getSdkError)("USER_DISCONNECTED")));
        }), $ed918cd7853aa237$var$c(this, "update", async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow();
            try {
                await this.isValidUpdate(e);
            } catch (h) {
                throw this.client.logger.error("update() -> isValidUpdate() failed"), h;
            }
            const { topic: t, namespaces: s } = e, { done: i, resolve: r, reject: o } = (0, $3qpNA.createDelayedPromise)(), a = (0, $fHodW.payloadId)(), l = (0, $fHodW.getBigIntRpcId)().toString(), p = this.client.session.get(t).namespaces;
            return this.events.once((0, $3qpNA.engineEvent)("session_update", a), ({ error: h })=>{
                h ? o(h) : r();
            }), await this.client.session.update(t, {
                namespaces: s
            }), await this.sendRequest({
                topic: t,
                method: "wc_sessionUpdate",
                params: {
                    namespaces: s
                },
                throwOnFailedPublish: !0,
                clientRpcId: a,
                relayRpcId: l
            }).catch((h)=>{
                this.client.logger.error(h), this.client.session.update(t, {
                    namespaces: p
                }), o(h);
            }), {
                acknowledged: i
            };
        }), $ed918cd7853aa237$var$c(this, "extend", async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow();
            try {
                await this.isValidExtend(e);
            } catch (a) {
                throw this.client.logger.error("extend() -> isValidExtend() failed"), a;
            }
            const { topic: t } = e, s = (0, $fHodW.payloadId)(), { done: i, resolve: r, reject: o } = (0, $3qpNA.createDelayedPromise)();
            return this.events.once((0, $3qpNA.engineEvent)("session_extend", s), ({ error: a })=>{
                a ? o(a) : r();
            }), await this.setExpiry(t, (0, $3qpNA.calcExpiry)($ed918cd7853aa237$export$84b1b9dbcdea0475)), this.sendRequest({
                topic: t,
                method: "wc_sessionExtend",
                params: {},
                clientRpcId: s,
                throwOnFailedPublish: !0
            }).catch((a)=>{
                o(a);
            }), {
                acknowledged: i
            };
        }), $ed918cd7853aa237$var$c(this, "request", async (e)=>{
            this.isInitialized();
            try {
                await this.isValidRequest(e);
            } catch (_) {
                throw this.client.logger.error("request() -> isValidRequest() failed"), _;
            }
            const { chainId: t, request: s, topic: i, expiry: r = $ed918cd7853aa237$export$4edb1ca37014192d.wc_sessionRequest.req.ttl } = e, o = this.client.session.get(i);
            o?.transportType === (0, $9bAHY.TRANSPORT_TYPES).relay && await this.confirmOnlineStateOrThrow();
            const a = (0, $fHodW.payloadId)(), l = (0, $fHodW.getBigIntRpcId)().toString(), { done: p, resolve: h, reject: u } = (0, $3qpNA.createDelayedPromise)(r, "Request expired. Please try again.");
            this.events.once((0, $3qpNA.engineEvent)("session_request", a), ({ error: _, result: g })=>{
                _ ? u(_) : h(g);
            });
            const d = "wc_sessionRequest", w = this.getAppLinkIfEnabled(o.peer.metadata, o.transportType);
            if (w) return await this.sendRequest({
                clientRpcId: a,
                relayRpcId: l,
                topic: i,
                method: d,
                params: {
                    request: $ed918cd7853aa237$var$b($ed918cd7853aa237$var$v({}, s), {
                        expiryTimestamp: (0, $3qpNA.calcExpiry)(r)
                    }),
                    chainId: t
                },
                expiry: r,
                throwOnFailedPublish: !0,
                appLink: w
            }).catch((_)=>u(_)), this.client.events.emit("session_request_sent", {
                topic: i,
                request: s,
                chainId: t,
                id: a
            }), await p();
            const m = {
                request: $ed918cd7853aa237$var$b($ed918cd7853aa237$var$v({}, s), {
                    expiryTimestamp: (0, $3qpNA.calcExpiry)(r)
                }),
                chainId: t
            }, f = this.shouldSetTVF(d, m);
            return await Promise.all([
                new Promise(async (_)=>{
                    await this.sendRequest($ed918cd7853aa237$var$v({
                        clientRpcId: a,
                        relayRpcId: l,
                        topic: i,
                        method: d,
                        params: m,
                        expiry: r,
                        throwOnFailedPublish: !0
                    }, f && {
                        tvf: this.getTVFParams(a, m)
                    })).catch((g)=>u(g)), this.client.events.emit("session_request_sent", {
                        topic: i,
                        request: s,
                        chainId: t,
                        id: a
                    }), _();
                }),
                new Promise(async (_)=>{
                    var g;
                    if (!((g = o.sessionConfig) != null && g.disableDeepLink)) {
                        const A = await (0, $3qpNA.getDeepLink)(this.client.core.storage, $ed918cd7853aa237$export$a26ccd6441b7d638);
                        await (0, $3qpNA.handleDeeplinkRedirect)({
                            id: a,
                            topic: i,
                            wcDeepLink: A
                        });
                    }
                    _();
                }),
                p()
            ]).then((_)=>_[2]);
        }), $ed918cd7853aa237$var$c(this, "respond", async (e)=>{
            this.isInitialized(), await this.isValidRespond(e);
            const { topic: t, response: s } = e, { id: i } = s, r = this.client.session.get(t);
            r.transportType === (0, $9bAHY.TRANSPORT_TYPES).relay && await this.confirmOnlineStateOrThrow();
            const o = this.getAppLinkIfEnabled(r.peer.metadata, r.transportType);
            (0, $fgWWx.isJsonRpcResult)(s) ? await this.sendResult({
                id: i,
                topic: t,
                result: s.result,
                throwOnFailedPublish: !0,
                appLink: o
            }) : (0, $fgWWx.isJsonRpcError)(s) && await this.sendError({
                id: i,
                topic: t,
                error: s.error,
                appLink: o
            }), this.cleanupAfterResponse(e);
        }), $ed918cd7853aa237$var$c(this, "ping", async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow();
            try {
                await this.isValidPing(e);
            } catch (s) {
                throw this.client.logger.error("ping() -> isValidPing() failed"), s;
            }
            const { topic: t } = e;
            if (this.client.session.keys.includes(t)) {
                const s = (0, $fHodW.payloadId)(), i = (0, $fHodW.getBigIntRpcId)().toString(), { done: r, resolve: o, reject: a } = (0, $3qpNA.createDelayedPromise)();
                this.events.once((0, $3qpNA.engineEvent)("session_ping", s), ({ error: l })=>{
                    l ? a(l) : o();
                }), await Promise.all([
                    this.sendRequest({
                        topic: t,
                        method: "wc_sessionPing",
                        params: {},
                        throwOnFailedPublish: !0,
                        clientRpcId: s,
                        relayRpcId: i
                    }),
                    r()
                ]);
            } else this.client.core.pairing.pairings.keys.includes(t) && (this.client.logger.warn("ping() on pairing topic is deprecated and will be removed in the next major release."), await this.client.core.pairing.ping({
                topic: t
            }));
        }), $ed918cd7853aa237$var$c(this, "emit", async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow(), await this.isValidEmit(e);
            const { topic: t, event: s, chainId: i } = e, r = (0, $fHodW.getBigIntRpcId)().toString(), o = (0, $fHodW.payloadId)();
            await this.sendRequest({
                topic: t,
                method: "wc_sessionEvent",
                params: {
                    event: s,
                    chainId: i
                },
                throwOnFailedPublish: !0,
                relayRpcId: r,
                clientRpcId: o
            });
        }), $ed918cd7853aa237$var$c(this, "disconnect", async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow(), await this.isValidDisconnect(e);
            const { topic: t } = e;
            if (this.client.session.keys.includes(t)) await this.sendRequest({
                topic: t,
                method: "wc_sessionDelete",
                params: (0, $3qpNA.getSdkError)("USER_DISCONNECTED"),
                throwOnFailedPublish: !0
            }), await this.deleteSession({
                topic: t,
                emitEvent: !1
            });
            else if (this.client.core.pairing.pairings.keys.includes(t)) await this.client.core.pairing.disconnect({
                topic: t
            });
            else {
                const { message: s } = (0, $3qpNA.getInternalError)("MISMATCHED_TOPIC", `Session or pairing topic not found: ${t}`);
                throw new Error(s);
            }
        }), $ed918cd7853aa237$var$c(this, "find", (e)=>(this.isInitialized(), this.client.session.getAll().filter((t)=>(0, $3qpNA.isSessionCompatible)(t, e)))), $ed918cd7853aa237$var$c(this, "getPendingSessionRequests", ()=>this.client.pendingRequest.getAll()), $ed918cd7853aa237$var$c(this, "authenticate", async (e, t)=>{
            var s;
            this.isInitialized(), this.isValidAuthenticate(e);
            const i = t && this.client.core.linkModeSupportedApps.includes(t) && ((s = this.client.metadata.redirect) == null ? void 0 : s.linkMode), r = i ? (0, $9bAHY.TRANSPORT_TYPES).link_mode : (0, $9bAHY.TRANSPORT_TYPES).relay;
            r === (0, $9bAHY.TRANSPORT_TYPES).relay && await this.confirmOnlineStateOrThrow();
            const { chains: o, statement: a = "", uri: l, domain: p, nonce: h, type: u, exp: d, nbf: w, methods: m = [], expiry: f } = e, _ = [
                ...e.resources || []
            ], { topic: g, uri: A } = await this.client.core.pairing.create({
                methods: [
                    "wc_sessionAuthenticate"
                ],
                transportType: r
            });
            this.client.logger.info({
                message: "Generated new pairing",
                pairing: {
                    topic: g,
                    uri: A
                }
            });
            const D = await this.client.core.crypto.generateKeyPair(), I = (0, $3qpNA.hashKey)(D);
            if (await Promise.all([
                this.client.auth.authKeys.set($ed918cd7853aa237$export$efef74cb455ac30f, {
                    responseTopic: I,
                    publicKey: D
                }),
                this.client.auth.pairingTopics.set(I, {
                    topic: I,
                    pairingTopic: g
                })
            ]), await this.client.core.relayer.subscribe(I, {
                transportType: r
            }), this.client.logger.info(`sending request to new pairing topic: ${g}`), m.length > 0) {
                const { namespace: x } = (0, $3qpNA.parseChainId)(o[0]);
                let L = (0, $3qpNA.createEncodedRecap)(x, "request", m);
                (0, $3qpNA.getRecapFromResources)(_) && (L = (0, $3qpNA.mergeEncodedRecaps)(L, _.pop())), _.push(L);
            }
            const T = f && f > $ed918cd7853aa237$export$4edb1ca37014192d.wc_sessionAuthenticate.req.ttl ? f : $ed918cd7853aa237$export$4edb1ca37014192d.wc_sessionAuthenticate.req.ttl, U = {
                authPayload: {
                    type: u ?? "caip122",
                    chains: o,
                    statement: a,
                    aud: l,
                    domain: p,
                    version: "1",
                    nonce: h,
                    iat: new Date().toISOString(),
                    exp: d,
                    nbf: w,
                    resources: _
                },
                requester: {
                    publicKey: D,
                    metadata: this.client.metadata
                },
                expiryTimestamp: (0, $3qpNA.calcExpiry)(T)
            }, fe = {
                eip155: {
                    chains: o,
                    methods: [
                        ...new Set([
                            "personal_sign",
                            ...m
                        ])
                    ],
                    events: [
                        "chainChanged",
                        "accountsChanged"
                    ]
                }
            }, q = {
                requiredNamespaces: {},
                optionalNamespaces: fe,
                relays: [
                    {
                        protocol: "irn"
                    }
                ],
                pairingTopic: g,
                proposer: {
                    publicKey: D,
                    metadata: this.client.metadata
                },
                expiryTimestamp: (0, $3qpNA.calcExpiry)($ed918cd7853aa237$export$4edb1ca37014192d.wc_sessionPropose.req.ttl),
                id: (0, $fHodW.payloadId)()
            }, { done: Rt, resolve: je, reject: Se } = (0, $3qpNA.createDelayedPromise)(T, "Request expired"), te = (0, $fHodW.payloadId)(), le = (0, $3qpNA.engineEvent)("session_connect", q.id), Re = (0, $3qpNA.engineEvent)("session_request", te), pe = async ({ error: x, session: L })=>{
                this.events.off(Re, ve), x ? Se(x) : L && je({
                    session: L
                });
            }, ve = async (x)=>{
                var L, Fe, Qe;
                if (await this.deletePendingAuthRequest(te, {
                    message: "fulfilled",
                    code: 0
                }), x.error) {
                    const ie = (0, $3qpNA.getSdkError)("WC_METHOD_UNSUPPORTED", "wc_sessionAuthenticate");
                    return x.error.code === ie.code ? void 0 : (this.events.off(le, pe), Se(x.error.message));
                }
                await this.deleteProposal(q.id), this.events.off(le, pe);
                const { cacaos: He, responder: Q } = x.result, Te = [], ze = [];
                for (const ie of He){
                    await (0, $3qpNA.validateSignedCacao)({
                        cacao: ie,
                        projectId: this.client.core.projectId
                    }) || (this.client.logger.error(ie, "Signature verification failed"), Se((0, $3qpNA.getSdkError)("SESSION_SETTLEMENT_FAILED", "Signature verification failed")));
                    const { p: qe } = ie, Pe = (0, $3qpNA.getRecapFromResources)(qe.resources), Ye = [
                        (0, $3qpNA.getNamespacedDidChainId)(qe.iss)
                    ], vt = (0, $3qpNA.getDidAddress)(qe.iss);
                    if (Pe) {
                        const Ne = (0, $3qpNA.getMethodsFromRecap)(Pe), It = (0, $3qpNA.getChainsFromRecap)(Pe);
                        Te.push(...Ne), Ye.push(...It);
                    }
                    for (const Ne of Ye)ze.push(`${Ne}:${vt}`);
                }
                const se = await this.client.core.crypto.generateSharedKey(D, Q.publicKey);
                let he;
                Te.length > 0 && (he = {
                    topic: se,
                    acknowledged: !0,
                    self: {
                        publicKey: D,
                        metadata: this.client.metadata
                    },
                    peer: Q,
                    controller: Q.publicKey,
                    expiry: (0, $3qpNA.calcExpiry)($ed918cd7853aa237$export$84b1b9dbcdea0475),
                    requiredNamespaces: {},
                    optionalNamespaces: {},
                    relay: {
                        protocol: "irn"
                    },
                    pairingTopic: g,
                    namespaces: (0, $3qpNA.buildNamespacesFromAuth)([
                        ...new Set(Te)
                    ], [
                        ...new Set(ze)
                    ]),
                    transportType: r
                }, await this.client.core.relayer.subscribe(se, {
                    transportType: r
                }), await this.client.session.set(se, he), g && await this.client.core.pairing.updateMetadata({
                    topic: g,
                    metadata: Q.metadata
                }), he = this.client.session.get(se)), (L = this.client.metadata.redirect) != null && L.linkMode && (Fe = Q.metadata.redirect) != null && Fe.linkMode && (Qe = Q.metadata.redirect) != null && Qe.universal && t && (this.client.core.addLinkModeSupportedApp(Q.metadata.redirect.universal), this.client.session.update(se, {
                    transportType: (0, $9bAHY.TRANSPORT_TYPES).link_mode
                })), je({
                    auths: He,
                    session: he
                });
            };
            this.events.once(le, pe), this.events.once(Re, ve);
            let Ie;
            try {
                if (i) {
                    const x = (0, $fHodW.formatJsonRpcRequest)("wc_sessionAuthenticate", U, te);
                    this.client.core.history.set(g, x);
                    const L = await this.client.core.crypto.encode("", x, {
                        type: (0, $3qpNA.TYPE_2),
                        encoding: (0, $3qpNA.BASE64URL)
                    });
                    Ie = (0, $3qpNA.getLinkModeURL)(t, g, L);
                } else await Promise.all([
                    this.sendRequest({
                        topic: g,
                        method: "wc_sessionAuthenticate",
                        params: U,
                        expiry: e.expiry,
                        throwOnFailedPublish: !0,
                        clientRpcId: te
                    }),
                    this.sendRequest({
                        topic: g,
                        method: "wc_sessionPropose",
                        params: q,
                        expiry: $ed918cd7853aa237$export$4edb1ca37014192d.wc_sessionPropose.req.ttl,
                        throwOnFailedPublish: !0,
                        clientRpcId: q.id
                    })
                ]);
            } catch (x) {
                throw this.events.off(le, pe), this.events.off(Re, ve), x;
            }
            return await this.setProposal(q.id, q), await this.setAuthRequest(te, {
                request: $ed918cd7853aa237$var$b($ed918cd7853aa237$var$v({}, U), {
                    verifyContext: {}
                }),
                pairingTopic: g,
                transportType: r
            }), {
                uri: Ie ?? A,
                response: Rt
            };
        }), $ed918cd7853aa237$var$c(this, "approveSessionAuthenticate", async (e)=>{
            const { id: t, auths: s } = e, i = this.client.core.eventClient.createEvent({
                properties: {
                    topic: t.toString(),
                    trace: [
                        (0, $9bAHY.EVENT_CLIENT_AUTHENTICATE_TRACES).authenticated_session_approve_started
                    ]
                }
            });
            try {
                this.isInitialized();
            } catch (f) {
                throw i.setError((0, $9bAHY.EVENT_CLIENT_AUTHENTICATE_ERRORS).no_internet_connection), f;
            }
            const r = this.getPendingAuthRequest(t);
            if (!r) throw i.setError((0, $9bAHY.EVENT_CLIENT_AUTHENTICATE_ERRORS).authenticated_session_pending_request_not_found), new Error(`Could not find pending auth request with id ${t}`);
            const o = r.transportType || (0, $9bAHY.TRANSPORT_TYPES).relay;
            o === (0, $9bAHY.TRANSPORT_TYPES).relay && await this.confirmOnlineStateOrThrow();
            const a = r.requester.publicKey, l = await this.client.core.crypto.generateKeyPair(), p = (0, $3qpNA.hashKey)(a), h = {
                type: (0, $3qpNA.TYPE_1),
                receiverPublicKey: a,
                senderPublicKey: l
            }, u = [], d = [];
            for (const f of s){
                if (!await (0, $3qpNA.validateSignedCacao)({
                    cacao: f,
                    projectId: this.client.core.projectId
                })) {
                    i.setError((0, $9bAHY.EVENT_CLIENT_AUTHENTICATE_ERRORS).invalid_cacao);
                    const I = (0, $3qpNA.getSdkError)("SESSION_SETTLEMENT_FAILED", "Signature verification failed");
                    throw await this.sendError({
                        id: t,
                        topic: p,
                        error: I,
                        encodeOpts: h
                    }), new Error(I.message);
                }
                i.addTrace((0, $9bAHY.EVENT_CLIENT_AUTHENTICATE_TRACES).cacaos_verified);
                const { p: _ } = f, g = (0, $3qpNA.getRecapFromResources)(_.resources), A = [
                    (0, $3qpNA.getNamespacedDidChainId)(_.iss)
                ], D = (0, $3qpNA.getDidAddress)(_.iss);
                if (g) {
                    const I = (0, $3qpNA.getMethodsFromRecap)(g), T = (0, $3qpNA.getChainsFromRecap)(g);
                    u.push(...I), A.push(...T);
                }
                for (const I of A)d.push(`${I}:${D}`);
            }
            const w = await this.client.core.crypto.generateSharedKey(l, a);
            i.addTrace((0, $9bAHY.EVENT_CLIENT_AUTHENTICATE_TRACES).create_authenticated_session_topic);
            let m;
            if (u?.length > 0) {
                m = {
                    topic: w,
                    acknowledged: !0,
                    self: {
                        publicKey: l,
                        metadata: this.client.metadata
                    },
                    peer: {
                        publicKey: a,
                        metadata: r.requester.metadata
                    },
                    controller: a,
                    expiry: (0, $3qpNA.calcExpiry)($ed918cd7853aa237$export$84b1b9dbcdea0475),
                    authentication: s,
                    requiredNamespaces: {},
                    optionalNamespaces: {},
                    relay: {
                        protocol: "irn"
                    },
                    pairingTopic: r.pairingTopic,
                    namespaces: (0, $3qpNA.buildNamespacesFromAuth)([
                        ...new Set(u)
                    ], [
                        ...new Set(d)
                    ]),
                    transportType: o
                }, i.addTrace((0, $9bAHY.EVENT_CLIENT_AUTHENTICATE_TRACES).subscribing_authenticated_session_topic);
                try {
                    await this.client.core.relayer.subscribe(w, {
                        transportType: o
                    });
                } catch (f) {
                    throw i.setError((0, $9bAHY.EVENT_CLIENT_AUTHENTICATE_ERRORS).subscribe_authenticated_session_topic_failure), f;
                }
                i.addTrace((0, $9bAHY.EVENT_CLIENT_AUTHENTICATE_TRACES).subscribe_authenticated_session_topic_success), await this.client.session.set(w, m), i.addTrace((0, $9bAHY.EVENT_CLIENT_AUTHENTICATE_TRACES).store_authenticated_session), await this.client.core.pairing.updateMetadata({
                    topic: r.pairingTopic,
                    metadata: r.requester.metadata
                });
            }
            i.addTrace((0, $9bAHY.EVENT_CLIENT_AUTHENTICATE_TRACES).publishing_authenticated_session_approve);
            try {
                await this.sendResult({
                    topic: p,
                    id: t,
                    result: {
                        cacaos: s,
                        responder: {
                            publicKey: l,
                            metadata: this.client.metadata
                        }
                    },
                    encodeOpts: h,
                    throwOnFailedPublish: !0,
                    appLink: this.getAppLinkIfEnabled(r.requester.metadata, o)
                });
            } catch (f) {
                throw i.setError((0, $9bAHY.EVENT_CLIENT_AUTHENTICATE_ERRORS).authenticated_session_approve_publish_failure), f;
            }
            return await this.client.auth.requests.delete(t, {
                message: "fulfilled",
                code: 0
            }), await this.client.core.pairing.activate({
                topic: r.pairingTopic
            }), this.client.core.eventClient.deleteEvent({
                eventId: i.eventId
            }), {
                session: m
            };
        }), $ed918cd7853aa237$var$c(this, "rejectSessionAuthenticate", async (e)=>{
            this.isInitialized();
            const { id: t, reason: s } = e, i = this.getPendingAuthRequest(t);
            if (!i) throw new Error(`Could not find pending auth request with id ${t}`);
            i.transportType === (0, $9bAHY.TRANSPORT_TYPES).relay && await this.confirmOnlineStateOrThrow();
            const r = i.requester.publicKey, o = await this.client.core.crypto.generateKeyPair(), a = (0, $3qpNA.hashKey)(r), l = {
                type: (0, $3qpNA.TYPE_1),
                receiverPublicKey: r,
                senderPublicKey: o
            };
            await this.sendError({
                id: t,
                topic: a,
                error: s,
                encodeOpts: l,
                rpcOpts: $ed918cd7853aa237$export$4edb1ca37014192d.wc_sessionAuthenticate.reject,
                appLink: this.getAppLinkIfEnabled(i.requester.metadata, i.transportType)
            }), await this.client.auth.requests.delete(t, {
                message: "rejected",
                code: 0
            }), await this.client.proposal.delete(t, (0, $3qpNA.getSdkError)("USER_DISCONNECTED"));
        }), $ed918cd7853aa237$var$c(this, "formatAuthMessage", (e)=>{
            this.isInitialized();
            const { request: t, iss: s } = e;
            return (0, $3qpNA.formatMessage)(t, s);
        }), $ed918cd7853aa237$var$c(this, "processRelayMessageCache", ()=>{
            setTimeout(async ()=>{
                if (this.relayMessageCache.length !== 0) for(; this.relayMessageCache.length > 0;)try {
                    const e = this.relayMessageCache.shift();
                    e && await this.onRelayMessage(e);
                } catch (e) {
                    this.client.logger.error(e);
                }
            }, 50);
        }), $ed918cd7853aa237$var$c(this, "cleanupDuplicatePairings", async (e)=>{
            if (e.pairingTopic) try {
                const t = this.client.core.pairing.pairings.get(e.pairingTopic), s = this.client.core.pairing.pairings.getAll().filter((i)=>{
                    var r, o;
                    return ((r = i.peerMetadata) == null ? void 0 : r.url) && ((o = i.peerMetadata) == null ? void 0 : o.url) === e.peer.metadata.url && i.topic && i.topic !== t.topic;
                });
                if (s.length === 0) return;
                this.client.logger.info(`Cleaning up ${s.length} duplicate pairing(s)`), await Promise.all(s.map((i)=>this.client.core.pairing.disconnect({
                        topic: i.topic
                    }))), this.client.logger.info("Duplicate pairings clean up finished");
            } catch (t) {
                this.client.logger.error(t);
            }
        }), $ed918cd7853aa237$var$c(this, "deleteSession", async (e)=>{
            var t;
            const { topic: s, expirerHasDeleted: i = !1, emitEvent: r = !0, id: o = 0 } = e, { self: a } = this.client.session.get(s);
            await this.client.core.relayer.unsubscribe(s), await this.client.session.delete(s, (0, $3qpNA.getSdkError)("USER_DISCONNECTED")), this.addToRecentlyDeleted(s, "session"), this.client.core.crypto.keychain.has(a.publicKey) && await this.client.core.crypto.deleteKeyPair(a.publicKey), this.client.core.crypto.keychain.has(s) && await this.client.core.crypto.deleteSymKey(s), i || this.client.core.expirer.del(s), this.client.core.storage.removeItem($ed918cd7853aa237$export$a26ccd6441b7d638).catch((l)=>this.client.logger.warn(l)), this.getPendingSessionRequests().forEach((l)=>{
                l.topic === s && this.deletePendingSessionRequest(l.id, (0, $3qpNA.getSdkError)("USER_DISCONNECTED"));
            }), s === ((t = this.sessionRequestQueue.queue[0]) == null ? void 0 : t.topic) && (this.sessionRequestQueue.state = $ed918cd7853aa237$export$8602b201748df21a.idle), r && this.client.events.emit("session_delete", {
                id: o,
                topic: s
            });
        }), $ed918cd7853aa237$var$c(this, "deleteProposal", async (e, t)=>{
            if (t) try {
                const s = this.client.proposal.get(e), i = this.client.core.eventClient.getEvent({
                    topic: s.pairingTopic
                });
                i?.setError((0, $9bAHY.EVENT_CLIENT_SESSION_ERRORS).proposal_expired);
            } catch  {}
            await Promise.all([
                this.client.proposal.delete(e, (0, $3qpNA.getSdkError)("USER_DISCONNECTED")),
                t ? Promise.resolve() : this.client.core.expirer.del(e)
            ]), this.addToRecentlyDeleted(e, "proposal");
        }), $ed918cd7853aa237$var$c(this, "deletePendingSessionRequest", async (e, t, s = !1)=>{
            await Promise.all([
                this.client.pendingRequest.delete(e, t),
                s ? Promise.resolve() : this.client.core.expirer.del(e)
            ]), this.addToRecentlyDeleted(e, "request"), this.sessionRequestQueue.queue = this.sessionRequestQueue.queue.filter((i)=>i.id !== e), s && (this.sessionRequestQueue.state = $ed918cd7853aa237$export$8602b201748df21a.idle, this.client.events.emit("session_request_expire", {
                id: e
            }));
        }), $ed918cd7853aa237$var$c(this, "deletePendingAuthRequest", async (e, t, s = !1)=>{
            await Promise.all([
                this.client.auth.requests.delete(e, t),
                s ? Promise.resolve() : this.client.core.expirer.del(e)
            ]);
        }), $ed918cd7853aa237$var$c(this, "setExpiry", async (e, t)=>{
            this.client.session.keys.includes(e) && (this.client.core.expirer.set(e, t), await this.client.session.update(e, {
                expiry: t
            }));
        }), $ed918cd7853aa237$var$c(this, "setProposal", async (e, t)=>{
            this.client.core.expirer.set(e, (0, $3qpNA.calcExpiry)($ed918cd7853aa237$export$4edb1ca37014192d.wc_sessionPropose.req.ttl)), await this.client.proposal.set(e, t);
        }), $ed918cd7853aa237$var$c(this, "setAuthRequest", async (e, t)=>{
            const { request: s, pairingTopic: i, transportType: r = (0, $9bAHY.TRANSPORT_TYPES).relay } = t;
            this.client.core.expirer.set(e, s.expiryTimestamp), await this.client.auth.requests.set(e, {
                authPayload: s.authPayload,
                requester: s.requester,
                expiryTimestamp: s.expiryTimestamp,
                id: e,
                pairingTopic: i,
                verifyContext: s.verifyContext,
                transportType: r
            });
        }), $ed918cd7853aa237$var$c(this, "setPendingSessionRequest", async (e)=>{
            const { id: t, topic: s, params: i, verifyContext: r } = e, o = i.request.expiryTimestamp || (0, $3qpNA.calcExpiry)($ed918cd7853aa237$export$4edb1ca37014192d.wc_sessionRequest.req.ttl);
            this.client.core.expirer.set(t, o), await this.client.pendingRequest.set(t, {
                id: t,
                topic: s,
                params: i,
                verifyContext: r
            });
        }), $ed918cd7853aa237$var$c(this, "sendRequest", async (e)=>{
            const { topic: t, method: s, params: i, expiry: r, relayRpcId: o, clientRpcId: a, throwOnFailedPublish: l, appLink: p, tvf: h } = e, u = (0, $fHodW.formatJsonRpcRequest)(s, i, a);
            let d;
            const w = !!p;
            try {
                const _ = w ? (0, $3qpNA.BASE64URL) : (0, $3qpNA.BASE64);
                d = await this.client.core.crypto.encode(t, u, {
                    encoding: _
                });
            } catch (_) {
                throw await this.cleanup(), this.client.logger.error(`sendRequest() -> core.crypto.encode() for topic ${t} failed`), _;
            }
            let m;
            if ($ed918cd7853aa237$export$63c37d8ae5931ad5.includes(s)) {
                const _ = (0, $3qpNA.hashMessage)(JSON.stringify(u)), g = (0, $3qpNA.hashMessage)(d);
                m = await this.client.core.verify.register({
                    id: g,
                    decryptedId: _
                });
            }
            const f = $ed918cd7853aa237$export$4edb1ca37014192d[s].req;
            if (f.attestation = m, r && (f.ttl = r), o && (f.id = o), this.client.core.history.set(t, u), w) {
                const _ = (0, $3qpNA.getLinkModeURL)(p, t, d);
                await $parcel$global.Linking.openURL(_, this.client.name);
            } else {
                const _ = $ed918cd7853aa237$export$4edb1ca37014192d[s].req;
                r && (_.ttl = r), o && (_.id = o), _.tvf = $ed918cd7853aa237$var$b($ed918cd7853aa237$var$v({}, h), {
                    correlationId: u.id
                }), l ? (_.internal = $ed918cd7853aa237$var$b($ed918cd7853aa237$var$v({}, _.internal), {
                    throwOnFailedPublish: !0
                }), await this.client.core.relayer.publish(t, d, _)) : this.client.core.relayer.publish(t, d, _).catch((g)=>this.client.logger.error(g));
            }
            return u.id;
        }), $ed918cd7853aa237$var$c(this, "sendResult", async (e)=>{
            const { id: t, topic: s, result: i, throwOnFailedPublish: r, encodeOpts: o, appLink: a } = e, l = (0, $fHodW.formatJsonRpcResult)(t, i);
            let p;
            const h = a && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u";
            try {
                const w = h ? (0, $3qpNA.BASE64URL) : (0, $3qpNA.BASE64);
                p = await this.client.core.crypto.encode(s, l, $ed918cd7853aa237$var$b($ed918cd7853aa237$var$v({}, o || {}), {
                    encoding: w
                }));
            } catch (w) {
                throw await this.cleanup(), this.client.logger.error(`sendResult() -> core.crypto.encode() for topic ${s} failed`), w;
            }
            let u, d;
            try {
                u = await this.client.core.history.get(s, t);
                const w = u.request;
                try {
                    this.shouldSetTVF(w.method, w.params) && (d = this.getTVFParams(t, w.params, i));
                } catch (m) {
                    this.client.logger.warn("sendResult() -> getTVFParams() failed", m);
                }
            } catch (w) {
                throw this.client.logger.error(`sendResult() -> history.get(${s}, ${t}) failed`), w;
            }
            if (h) {
                const w = (0, $3qpNA.getLinkModeURL)(a, s, p);
                await $parcel$global.Linking.openURL(w, this.client.name);
            } else {
                const w = u.request.method, m = $ed918cd7853aa237$export$4edb1ca37014192d[w].res;
                m.tvf = $ed918cd7853aa237$var$b($ed918cd7853aa237$var$v({}, d), {
                    correlationId: t
                }), r ? (m.internal = $ed918cd7853aa237$var$b($ed918cd7853aa237$var$v({}, m.internal), {
                    throwOnFailedPublish: !0
                }), await this.client.core.relayer.publish(s, p, m)) : this.client.core.relayer.publish(s, p, m).catch((f)=>this.client.logger.error(f));
            }
            await this.client.core.history.resolve(l);
        }), $ed918cd7853aa237$var$c(this, "sendError", async (e)=>{
            const { id: t, topic: s, error: i, encodeOpts: r, rpcOpts: o, appLink: a } = e, l = (0, $fHodW.formatJsonRpcError)(t, i);
            let p;
            const h = a && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u";
            try {
                const d = h ? (0, $3qpNA.BASE64URL) : (0, $3qpNA.BASE64);
                p = await this.client.core.crypto.encode(s, l, $ed918cd7853aa237$var$b($ed918cd7853aa237$var$v({}, r || {}), {
                    encoding: d
                }));
            } catch (d) {
                throw await this.cleanup(), this.client.logger.error(`sendError() -> core.crypto.encode() for topic ${s} failed`), d;
            }
            let u;
            try {
                u = await this.client.core.history.get(s, t);
            } catch (d) {
                throw this.client.logger.error(`sendError() -> history.get(${s}, ${t}) failed`), d;
            }
            if (h) {
                const d = (0, $3qpNA.getLinkModeURL)(a, s, p);
                await $parcel$global.Linking.openURL(d, this.client.name);
            } else {
                const d = u.request.method, w = o || $ed918cd7853aa237$export$4edb1ca37014192d[d].res;
                this.client.core.relayer.publish(s, p, w);
            }
            await this.client.core.history.resolve(l);
        }), $ed918cd7853aa237$var$c(this, "cleanup", async ()=>{
            const e = [], t = [];
            this.client.session.getAll().forEach((s)=>{
                let i = !1;
                (0, $3qpNA.isExpired)(s.expiry) && (i = !0), this.client.core.crypto.keychain.has(s.topic) || (i = !0), i && e.push(s.topic);
            }), this.client.proposal.getAll().forEach((s)=>{
                (0, $3qpNA.isExpired)(s.expiryTimestamp) && t.push(s.id);
            }), await Promise.all([
                ...e.map((s)=>this.deleteSession({
                        topic: s
                    })),
                ...t.map((s)=>this.deleteProposal(s))
            ]);
        }), $ed918cd7853aa237$var$c(this, "onProviderMessageEvent", async (e)=>{
            !this.initialized || this.relayMessageCache.length > 0 ? this.relayMessageCache.push(e) : await this.onRelayMessage(e);
        }), $ed918cd7853aa237$var$c(this, "onRelayEventRequest", async (e)=>{
            this.requestQueue.queue.push(e), await this.processRequestsQueue();
        }), $ed918cd7853aa237$var$c(this, "processRequestsQueue", async ()=>{
            if (this.requestQueue.state === $ed918cd7853aa237$export$8602b201748df21a.active) {
                this.client.logger.info("Request queue already active, skipping...");
                return;
            }
            for(this.client.logger.info(`Request queue starting with ${this.requestQueue.queue.length} requests`); this.requestQueue.queue.length > 0;){
                this.requestQueue.state = $ed918cd7853aa237$export$8602b201748df21a.active;
                const e = this.requestQueue.queue.shift();
                if (e) try {
                    await this.processRequest(e);
                } catch (t) {
                    this.client.logger.warn(t);
                }
            }
            this.requestQueue.state = $ed918cd7853aa237$export$8602b201748df21a.idle;
        }), $ed918cd7853aa237$var$c(this, "processRequest", async (e)=>{
            const { topic: t, payload: s, attestation: i, transportType: r, encryptedId: o } = e, a = s.method;
            if (!this.shouldIgnorePairingRequest({
                topic: t,
                requestMethod: a
            })) switch(a){
                case "wc_sessionPropose":
                    return await this.onSessionProposeRequest({
                        topic: t,
                        payload: s,
                        attestation: i,
                        encryptedId: o
                    });
                case "wc_sessionSettle":
                    return await this.onSessionSettleRequest(t, s);
                case "wc_sessionUpdate":
                    return await this.onSessionUpdateRequest(t, s);
                case "wc_sessionExtend":
                    return await this.onSessionExtendRequest(t, s);
                case "wc_sessionPing":
                    return await this.onSessionPingRequest(t, s);
                case "wc_sessionDelete":
                    return await this.onSessionDeleteRequest(t, s);
                case "wc_sessionRequest":
                    return await this.onSessionRequest({
                        topic: t,
                        payload: s,
                        attestation: i,
                        encryptedId: o,
                        transportType: r
                    });
                case "wc_sessionEvent":
                    return await this.onSessionEventRequest(t, s);
                case "wc_sessionAuthenticate":
                    return await this.onSessionAuthenticateRequest({
                        topic: t,
                        payload: s,
                        attestation: i,
                        encryptedId: o,
                        transportType: r
                    });
                default:
                    return this.client.logger.info(`Unsupported request method ${a}`);
            }
        }), $ed918cd7853aa237$var$c(this, "onRelayEventResponse", async (e)=>{
            const { topic: t, payload: s, transportType: i } = e, r = (await this.client.core.history.get(t, s.id)).request.method;
            switch(r){
                case "wc_sessionPropose":
                    return this.onSessionProposeResponse(t, s, i);
                case "wc_sessionSettle":
                    return this.onSessionSettleResponse(t, s);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateResponse(t, s);
                case "wc_sessionExtend":
                    return this.onSessionExtendResponse(t, s);
                case "wc_sessionPing":
                    return this.onSessionPingResponse(t, s);
                case "wc_sessionRequest":
                    return this.onSessionRequestResponse(t, s);
                case "wc_sessionAuthenticate":
                    return this.onSessionAuthenticateResponse(t, s);
                default:
                    return this.client.logger.info(`Unsupported response method ${r}`);
            }
        }), $ed918cd7853aa237$var$c(this, "onRelayEventUnknownPayload", (e)=>{
            const { topic: t } = e, { message: s } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `Decoded payload on topic ${t} is not identifiable as a JSON-RPC request or a response.`);
            throw new Error(s);
        }), $ed918cd7853aa237$var$c(this, "shouldIgnorePairingRequest", (e)=>{
            const { topic: t, requestMethod: s } = e, i = this.expectedPairingMethodMap.get(t);
            return !i || i.includes(s) ? !1 : !!(i.includes("wc_sessionAuthenticate") && this.client.events.listenerCount("session_authenticate") > 0);
        }), $ed918cd7853aa237$var$c(this, "onSessionProposeRequest", async (e)=>{
            const { topic: t, payload: s, attestation: i, encryptedId: r } = e, { params: o, id: a } = s;
            try {
                const l = this.client.core.eventClient.getEvent({
                    topic: t
                });
                this.client.events.listenerCount("session_proposal") === 0 && (console.warn("No listener for session_proposal event"), l?.setError((0, $9bAHY.EVENT_CLIENT_PAIRING_ERRORS).proposal_listener_not_found)), this.isValidConnect($ed918cd7853aa237$var$v({}, s.params));
                const p = o.expiryTimestamp || (0, $3qpNA.calcExpiry)($ed918cd7853aa237$export$4edb1ca37014192d.wc_sessionPropose.req.ttl), h = $ed918cd7853aa237$var$v({
                    id: a,
                    pairingTopic: t,
                    expiryTimestamp: p
                }, o);
                await this.setProposal(a, h);
                const u = await this.getVerifyContext({
                    attestationId: i,
                    hash: (0, $3qpNA.hashMessage)(JSON.stringify(s)),
                    encryptedId: r,
                    metadata: h.proposer.metadata
                });
                l?.addTrace((0, $9bAHY.EVENT_CLIENT_PAIRING_TRACES).emit_session_proposal), this.client.events.emit("session_proposal", {
                    id: a,
                    params: h,
                    verifyContext: u
                });
            } catch (l) {
                await this.sendError({
                    id: a,
                    topic: t,
                    error: l,
                    rpcOpts: $ed918cd7853aa237$export$4edb1ca37014192d.wc_sessionPropose.autoReject
                }), this.client.logger.error(l);
            }
        }), $ed918cd7853aa237$var$c(this, "onSessionProposeResponse", async (e, t, s)=>{
            const { id: i } = t;
            if ((0, $fgWWx.isJsonRpcResult)(t)) {
                const { result: r } = t;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    result: r
                });
                const o = this.client.proposal.get(i);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    proposal: o
                });
                const a = o.proposer.publicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    selfPublicKey: a
                });
                const l = r.responderPublicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    peerPublicKey: l
                });
                const p = await this.client.core.crypto.generateSharedKey(a, l);
                this.pendingSessions.set(i, {
                    sessionTopic: p,
                    pairingTopic: e,
                    proposalId: i,
                    publicKey: a
                });
                const h = await this.client.core.relayer.subscribe(p, {
                    transportType: s
                });
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    subscriptionId: h
                }), await this.client.core.pairing.activate({
                    topic: e
                });
            } else if ((0, $fgWWx.isJsonRpcError)(t)) {
                await this.client.proposal.delete(i, (0, $3qpNA.getSdkError)("USER_DISCONNECTED"));
                const r = (0, $3qpNA.engineEvent)("session_connect", i);
                if (this.events.listenerCount(r) === 0) throw new Error(`emitting ${r} without any listeners, 954`);
                this.events.emit(r, {
                    error: t.error
                });
            }
        }), $ed918cd7853aa237$var$c(this, "onSessionSettleRequest", async (e, t)=>{
            const { id: s, params: i } = t;
            try {
                this.isValidSessionSettleRequest(i);
                const { relay: r, controller: o, expiry: a, namespaces: l, sessionProperties: p, scopedProperties: h, sessionConfig: u } = t.params, d = [
                    ...this.pendingSessions.values()
                ].find((f)=>f.sessionTopic === e);
                if (!d) return this.client.logger.error(`Pending session not found for topic ${e}`);
                const w = this.client.proposal.get(d.proposalId), m = $ed918cd7853aa237$var$b($ed918cd7853aa237$var$v($ed918cd7853aa237$var$v($ed918cd7853aa237$var$v({
                    topic: e,
                    relay: r,
                    expiry: a,
                    namespaces: l,
                    acknowledged: !0,
                    pairingTopic: d.pairingTopic,
                    requiredNamespaces: w.requiredNamespaces,
                    optionalNamespaces: w.optionalNamespaces,
                    controller: o.publicKey,
                    self: {
                        publicKey: d.publicKey,
                        metadata: this.client.metadata
                    },
                    peer: {
                        publicKey: o.publicKey,
                        metadata: o.metadata
                    }
                }, p && {
                    sessionProperties: p
                }), h && {
                    scopedProperties: h
                }), u && {
                    sessionConfig: u
                }), {
                    transportType: (0, $9bAHY.TRANSPORT_TYPES).relay
                });
                await this.client.session.set(m.topic, m), await this.setExpiry(m.topic, m.expiry), await this.client.core.pairing.updateMetadata({
                    topic: d.pairingTopic,
                    metadata: m.peer.metadata
                }), this.client.events.emit("session_connect", {
                    session: m
                }), this.events.emit((0, $3qpNA.engineEvent)("session_connect", d.proposalId), {
                    session: m
                }), this.pendingSessions.delete(d.proposalId), this.deleteProposal(d.proposalId, !1), this.cleanupDuplicatePairings(m), await this.sendResult({
                    id: t.id,
                    topic: e,
                    result: !0,
                    throwOnFailedPublish: !0
                });
            } catch (r) {
                await this.sendError({
                    id: s,
                    topic: e,
                    error: r
                }), this.client.logger.error(r);
            }
        }), $ed918cd7853aa237$var$c(this, "onSessionSettleResponse", async (e, t)=>{
            const { id: s } = t;
            (0, $fgWWx.isJsonRpcResult)(t) ? (await this.client.session.update(e, {
                acknowledged: !0
            }), this.events.emit((0, $3qpNA.engineEvent)("session_approve", s), {})) : (0, $fgWWx.isJsonRpcError)(t) && (await this.client.session.delete(e, (0, $3qpNA.getSdkError)("USER_DISCONNECTED")), this.events.emit((0, $3qpNA.engineEvent)("session_approve", s), {
                error: t.error
            }));
        }), $ed918cd7853aa237$var$c(this, "onSessionUpdateRequest", async (e, t)=>{
            const { params: s, id: i } = t;
            try {
                const r = `${e}_session_update`, o = (0, $3qpNA.MemoryStore).get(r);
                if (o && this.isRequestOutOfSync(o, i)) {
                    this.client.logger.warn(`Discarding out of sync request - ${i}`), this.sendError({
                        id: i,
                        topic: e,
                        error: (0, $3qpNA.getSdkError)("INVALID_UPDATE_REQUEST")
                    });
                    return;
                }
                this.isValidUpdate($ed918cd7853aa237$var$v({
                    topic: e
                }, s));
                try {
                    (0, $3qpNA.MemoryStore).set(r, i), await this.client.session.update(e, {
                        namespaces: s.namespaces
                    }), await this.sendResult({
                        id: i,
                        topic: e,
                        result: !0,
                        throwOnFailedPublish: !0
                    });
                } catch (a) {
                    throw (0, $3qpNA.MemoryStore).delete(r), a;
                }
                this.client.events.emit("session_update", {
                    id: i,
                    topic: e,
                    params: s
                });
            } catch (r) {
                await this.sendError({
                    id: i,
                    topic: e,
                    error: r
                }), this.client.logger.error(r);
            }
        }), $ed918cd7853aa237$var$c(this, "isRequestOutOfSync", (e, t)=>t.toString().slice(0, -3) < e.toString().slice(0, -3)), $ed918cd7853aa237$var$c(this, "onSessionUpdateResponse", (e, t)=>{
            const { id: s } = t, i = (0, $3qpNA.engineEvent)("session_update", s);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            (0, $fgWWx.isJsonRpcResult)(t) ? this.events.emit((0, $3qpNA.engineEvent)("session_update", s), {}) : (0, $fgWWx.isJsonRpcError)(t) && this.events.emit((0, $3qpNA.engineEvent)("session_update", s), {
                error: t.error
            });
        }), $ed918cd7853aa237$var$c(this, "onSessionExtendRequest", async (e, t)=>{
            const { id: s } = t;
            try {
                this.isValidExtend({
                    topic: e
                }), await this.setExpiry(e, (0, $3qpNA.calcExpiry)($ed918cd7853aa237$export$84b1b9dbcdea0475)), await this.sendResult({
                    id: s,
                    topic: e,
                    result: !0,
                    throwOnFailedPublish: !0
                }), this.client.events.emit("session_extend", {
                    id: s,
                    topic: e
                });
            } catch (i) {
                await this.sendError({
                    id: s,
                    topic: e,
                    error: i
                }), this.client.logger.error(i);
            }
        }), $ed918cd7853aa237$var$c(this, "onSessionExtendResponse", (e, t)=>{
            const { id: s } = t, i = (0, $3qpNA.engineEvent)("session_extend", s);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            (0, $fgWWx.isJsonRpcResult)(t) ? this.events.emit((0, $3qpNA.engineEvent)("session_extend", s), {}) : (0, $fgWWx.isJsonRpcError)(t) && this.events.emit((0, $3qpNA.engineEvent)("session_extend", s), {
                error: t.error
            });
        }), $ed918cd7853aa237$var$c(this, "onSessionPingRequest", async (e, t)=>{
            const { id: s } = t;
            try {
                this.isValidPing({
                    topic: e
                }), await this.sendResult({
                    id: s,
                    topic: e,
                    result: !0,
                    throwOnFailedPublish: !0
                }), this.client.events.emit("session_ping", {
                    id: s,
                    topic: e
                });
            } catch (i) {
                await this.sendError({
                    id: s,
                    topic: e,
                    error: i
                }), this.client.logger.error(i);
            }
        }), $ed918cd7853aa237$var$c(this, "onSessionPingResponse", (e, t)=>{
            const { id: s } = t, i = (0, $3qpNA.engineEvent)("session_ping", s);
            setTimeout(()=>{
                if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners 2176`);
                (0, $fgWWx.isJsonRpcResult)(t) ? this.events.emit((0, $3qpNA.engineEvent)("session_ping", s), {}) : (0, $fgWWx.isJsonRpcError)(t) && this.events.emit((0, $3qpNA.engineEvent)("session_ping", s), {
                    error: t.error
                });
            }, 500);
        }), $ed918cd7853aa237$var$c(this, "onSessionDeleteRequest", async (e, t)=>{
            const { id: s } = t;
            try {
                this.isValidDisconnect({
                    topic: e,
                    reason: t.params
                }), Promise.all([
                    new Promise((i)=>{
                        this.client.core.relayer.once((0, $9bAHY.RELAYER_EVENTS).publish, async ()=>{
                            i(await this.deleteSession({
                                topic: e,
                                id: s
                            }));
                        });
                    }),
                    this.sendResult({
                        id: s,
                        topic: e,
                        result: !0,
                        throwOnFailedPublish: !0
                    }),
                    this.cleanupPendingSentRequestsForTopic({
                        topic: e,
                        error: (0, $3qpNA.getSdkError)("USER_DISCONNECTED")
                    })
                ]).catch((i)=>this.client.logger.error(i));
            } catch (i) {
                this.client.logger.error(i);
            }
        }), $ed918cd7853aa237$var$c(this, "onSessionRequest", async (e)=>{
            var t, s, i;
            const { topic: r, payload: o, attestation: a, encryptedId: l, transportType: p } = e, { id: h, params: u } = o;
            try {
                await this.isValidRequest($ed918cd7853aa237$var$v({
                    topic: r
                }, u));
                const d = this.client.session.get(r), w = await this.getVerifyContext({
                    attestationId: a,
                    hash: (0, $3qpNA.hashMessage)(JSON.stringify((0, $fHodW.formatJsonRpcRequest)("wc_sessionRequest", u, h))),
                    encryptedId: l,
                    metadata: d.peer.metadata,
                    transportType: p
                }), m = {
                    id: h,
                    topic: r,
                    params: u,
                    verifyContext: w
                };
                await this.setPendingSessionRequest(m), p === (0, $9bAHY.TRANSPORT_TYPES).link_mode && (t = d.peer.metadata.redirect) != null && t.universal && this.client.core.addLinkModeSupportedApp((s = d.peer.metadata.redirect) == null ? void 0 : s.universal), (i = this.client.signConfig) != null && i.disableRequestQueue ? this.emitSessionRequest(m) : (this.addSessionRequestToSessionRequestQueue(m), this.processSessionRequestQueue());
            } catch (d) {
                await this.sendError({
                    id: h,
                    topic: r,
                    error: d
                }), this.client.logger.error(d);
            }
        }), $ed918cd7853aa237$var$c(this, "onSessionRequestResponse", (e, t)=>{
            const { id: s } = t, i = (0, $3qpNA.engineEvent)("session_request", s);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            (0, $fgWWx.isJsonRpcResult)(t) ? this.events.emit((0, $3qpNA.engineEvent)("session_request", s), {
                result: t.result
            }) : (0, $fgWWx.isJsonRpcError)(t) && this.events.emit((0, $3qpNA.engineEvent)("session_request", s), {
                error: t.error
            });
        }), $ed918cd7853aa237$var$c(this, "onSessionEventRequest", async (e, t)=>{
            const { id: s, params: i } = t;
            try {
                const r = `${e}_session_event_${i.event.name}`, o = (0, $3qpNA.MemoryStore).get(r);
                if (o && this.isRequestOutOfSync(o, s)) {
                    this.client.logger.info(`Discarding out of sync request - ${s}`);
                    return;
                }
                this.isValidEmit($ed918cd7853aa237$var$v({
                    topic: e
                }, i)), this.client.events.emit("session_event", {
                    id: s,
                    topic: e,
                    params: i
                }), (0, $3qpNA.MemoryStore).set(r, s);
            } catch (r) {
                await this.sendError({
                    id: s,
                    topic: e,
                    error: r
                }), this.client.logger.error(r);
            }
        }), $ed918cd7853aa237$var$c(this, "onSessionAuthenticateResponse", (e, t)=>{
            const { id: s } = t;
            this.client.logger.trace({
                type: "method",
                method: "onSessionAuthenticateResponse",
                topic: e,
                payload: t
            }), (0, $fgWWx.isJsonRpcResult)(t) ? this.events.emit((0, $3qpNA.engineEvent)("session_request", s), {
                result: t.result
            }) : (0, $fgWWx.isJsonRpcError)(t) && this.events.emit((0, $3qpNA.engineEvent)("session_request", s), {
                error: t.error
            });
        }), $ed918cd7853aa237$var$c(this, "onSessionAuthenticateRequest", async (e)=>{
            var t;
            const { topic: s, payload: i, attestation: r, encryptedId: o, transportType: a } = e;
            try {
                const { requester: l, authPayload: p, expiryTimestamp: h } = i.params, u = await this.getVerifyContext({
                    attestationId: r,
                    hash: (0, $3qpNA.hashMessage)(JSON.stringify(i)),
                    encryptedId: o,
                    metadata: l.metadata,
                    transportType: a
                }), d = {
                    requester: l,
                    pairingTopic: s,
                    id: i.id,
                    authPayload: p,
                    verifyContext: u,
                    expiryTimestamp: h
                };
                await this.setAuthRequest(i.id, {
                    request: d,
                    pairingTopic: s,
                    transportType: a
                }), a === (0, $9bAHY.TRANSPORT_TYPES).link_mode && (t = l.metadata.redirect) != null && t.universal && this.client.core.addLinkModeSupportedApp(l.metadata.redirect.universal), this.client.events.emit("session_authenticate", {
                    topic: s,
                    params: i.params,
                    id: i.id,
                    verifyContext: u
                });
            } catch (l) {
                this.client.logger.error(l);
                const p = i.params.requester.publicKey, h = await this.client.core.crypto.generateKeyPair(), u = this.getAppLinkIfEnabled(i.params.requester.metadata, a), d = {
                    type: (0, $3qpNA.TYPE_1),
                    receiverPublicKey: p,
                    senderPublicKey: h
                };
                await this.sendError({
                    id: i.id,
                    topic: s,
                    error: l,
                    encodeOpts: d,
                    rpcOpts: $ed918cd7853aa237$export$4edb1ca37014192d.wc_sessionAuthenticate.autoReject,
                    appLink: u
                });
            }
        }), $ed918cd7853aa237$var$c(this, "addSessionRequestToSessionRequestQueue", (e)=>{
            this.sessionRequestQueue.queue.push(e);
        }), $ed918cd7853aa237$var$c(this, "cleanupAfterResponse", (e)=>{
            this.deletePendingSessionRequest(e.response.id, {
                message: "fulfilled",
                code: 0
            }), setTimeout(()=>{
                this.sessionRequestQueue.state = $ed918cd7853aa237$export$8602b201748df21a.idle, this.processSessionRequestQueue();
            }, (0, $9eyak.toMiliseconds)(this.requestQueueDelay));
        }), $ed918cd7853aa237$var$c(this, "cleanupPendingSentRequestsForTopic", ({ topic: e, error: t })=>{
            const s = this.client.core.history.pending;
            s.length > 0 && s.filter((i)=>i.topic === e && i.request.method === "wc_sessionRequest").forEach((i)=>{
                const r = i.request.id, o = (0, $3qpNA.engineEvent)("session_request", r);
                if (this.events.listenerCount(o) === 0) throw new Error(`emitting ${o} without any listeners`);
                this.events.emit((0, $3qpNA.engineEvent)("session_request", i.request.id), {
                    error: t
                });
            });
        }), $ed918cd7853aa237$var$c(this, "processSessionRequestQueue", ()=>{
            if (this.sessionRequestQueue.state === $ed918cd7853aa237$export$8602b201748df21a.active) {
                this.client.logger.info("session request queue is already active.");
                return;
            }
            const e = this.sessionRequestQueue.queue[0];
            if (!e) {
                this.client.logger.info("session request queue is empty.");
                return;
            }
            try {
                this.sessionRequestQueue.state = $ed918cd7853aa237$export$8602b201748df21a.active, this.emitSessionRequest(e);
            } catch (t) {
                this.client.logger.error(t);
            }
        }), $ed918cd7853aa237$var$c(this, "emitSessionRequest", (e)=>{
            this.client.events.emit("session_request", e);
        }), $ed918cd7853aa237$var$c(this, "onPairingCreated", (e)=>{
            if (e.methods && this.expectedPairingMethodMap.set(e.topic, e.methods), e.active) return;
            const t = this.client.proposal.getAll().find((s)=>s.pairingTopic === e.topic);
            t && this.onSessionProposeRequest({
                topic: e.topic,
                payload: (0, $fHodW.formatJsonRpcRequest)("wc_sessionPropose", $ed918cd7853aa237$var$b($ed918cd7853aa237$var$v({}, t), {
                    requiredNamespaces: t.requiredNamespaces,
                    optionalNamespaces: t.optionalNamespaces,
                    relays: t.relays,
                    proposer: t.proposer,
                    sessionProperties: t.sessionProperties,
                    scopedProperties: t.scopedProperties
                }), t.id)
            });
        }), $ed918cd7853aa237$var$c(this, "isValidConnect", async (e)=>{
            if (!(0, $3qpNA.isValidParams)(e)) {
                const { message: l } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `connect() params: ${JSON.stringify(e)}`);
                throw new Error(l);
            }
            const { pairingTopic: t, requiredNamespaces: s, optionalNamespaces: i, sessionProperties: r, scopedProperties: o, relays: a } = e;
            if ((0, $3qpNA.isUndefined)(t) || await this.isValidPairingTopic(t), !(0, $3qpNA.isValidRelays)(a, !0)) {
                const { message: l } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `connect() relays: ${a}`);
                throw new Error(l);
            }
            if (!(0, $3qpNA.isUndefined)(s) && (0, $3qpNA.isValidObject)(s) !== 0 && this.validateNamespaces(s, "requiredNamespaces"), !(0, $3qpNA.isUndefined)(i) && (0, $3qpNA.isValidObject)(i) !== 0 && this.validateNamespaces(i, "optionalNamespaces"), (0, $3qpNA.isUndefined)(r) || this.validateSessionProps(r, "sessionProperties"), !(0, $3qpNA.isUndefined)(o)) {
                this.validateSessionProps(o, "scopedProperties");
                const l = Object.keys(s || {}).concat(Object.keys(i || {}));
                if (!Object.keys(o).every((p)=>l.includes(p))) throw new Error(`Scoped properties must be a subset of required/optional namespaces, received: ${JSON.stringify(o)}, required/optional namespaces: ${JSON.stringify(l)}`);
            }
        }), $ed918cd7853aa237$var$c(this, "validateNamespaces", (e, t)=>{
            const s = (0, $3qpNA.isValidRequiredNamespaces)(e, "connect()", t);
            if (s) throw new Error(s.message);
        }), $ed918cd7853aa237$var$c(this, "isValidApprove", async (e)=>{
            if (!(0, $3qpNA.isValidParams)(e)) throw new Error((0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `approve() params: ${e}`).message);
            const { id: t, namespaces: s, relayProtocol: i, sessionProperties: r, scopedProperties: o } = e;
            this.checkRecentlyDeleted(t), await this.isValidProposalId(t);
            const a = this.client.proposal.get(t), l = (0, $3qpNA.isValidNamespaces)(s, "approve()");
            if (l) throw new Error(l.message);
            const p = (0, $3qpNA.isConformingNamespaces)(a.requiredNamespaces, s, "approve()");
            if (p) throw new Error(p.message);
            if (!(0, $3qpNA.isValidString)(i, !0)) {
                const { message: h } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `approve() relayProtocol: ${i}`);
                throw new Error(h);
            }
            if ((0, $3qpNA.isUndefined)(r) || this.validateSessionProps(r, "sessionProperties"), !(0, $3qpNA.isUndefined)(o)) {
                this.validateSessionProps(o, "scopedProperties");
                const h = new Set(Object.keys(s));
                if (!Object.keys(o).every((u)=>h.has(u))) throw new Error(`Scoped properties must be a subset of approved namespaces, received: ${JSON.stringify(o)}, approved namespaces: ${Array.from(h).join(", ")}`);
            }
        }), $ed918cd7853aa237$var$c(this, "isValidReject", async (e)=>{
            if (!(0, $3qpNA.isValidParams)(e)) {
                const { message: i } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `reject() params: ${e}`);
                throw new Error(i);
            }
            const { id: t, reason: s } = e;
            if (this.checkRecentlyDeleted(t), await this.isValidProposalId(t), !(0, $3qpNA.isValidErrorReason)(s)) {
                const { message: i } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `reject() reason: ${JSON.stringify(s)}`);
                throw new Error(i);
            }
        }), $ed918cd7853aa237$var$c(this, "isValidSessionSettleRequest", (e)=>{
            if (!(0, $3qpNA.isValidParams)(e)) {
                const { message: l } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `onSessionSettleRequest() params: ${e}`);
                throw new Error(l);
            }
            const { relay: t, controller: s, namespaces: i, expiry: r } = e;
            if (!(0, $3qpNA.isValidRelay)(t)) {
                const { message: l } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string");
                throw new Error(l);
            }
            const o = (0, $3qpNA.isValidController)(s, "onSessionSettleRequest()");
            if (o) throw new Error(o.message);
            const a = (0, $3qpNA.isValidNamespaces)(i, "onSessionSettleRequest()");
            if (a) throw new Error(a.message);
            if ((0, $3qpNA.isExpired)(r)) {
                const { message: l } = (0, $3qpNA.getInternalError)("EXPIRED", "onSessionSettleRequest()");
                throw new Error(l);
            }
        }), $ed918cd7853aa237$var$c(this, "isValidUpdate", async (e)=>{
            if (!(0, $3qpNA.isValidParams)(e)) {
                const { message: a } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `update() params: ${e}`);
                throw new Error(a);
            }
            const { topic: t, namespaces: s } = e;
            this.checkRecentlyDeleted(t), await this.isValidSessionTopic(t);
            const i = this.client.session.get(t), r = (0, $3qpNA.isValidNamespaces)(s, "update()");
            if (r) throw new Error(r.message);
            const o = (0, $3qpNA.isConformingNamespaces)(i.requiredNamespaces, s, "update()");
            if (o) throw new Error(o.message);
        }), $ed918cd7853aa237$var$c(this, "isValidExtend", async (e)=>{
            if (!(0, $3qpNA.isValidParams)(e)) {
                const { message: s } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `extend() params: ${e}`);
                throw new Error(s);
            }
            const { topic: t } = e;
            this.checkRecentlyDeleted(t), await this.isValidSessionTopic(t);
        }), $ed918cd7853aa237$var$c(this, "isValidRequest", async (e)=>{
            if (!(0, $3qpNA.isValidParams)(e)) {
                const { message: a } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `request() params: ${e}`);
                throw new Error(a);
            }
            const { topic: t, request: s, chainId: i, expiry: r } = e;
            this.checkRecentlyDeleted(t), await this.isValidSessionTopic(t);
            const { namespaces: o } = this.client.session.get(t);
            if (!(0, $3qpNA.isValidNamespacesChainId)(o, i)) {
                const { message: a } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `request() chainId: ${i}`);
                throw new Error(a);
            }
            if (!(0, $3qpNA.isValidRequest)(s)) {
                const { message: a } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `request() ${JSON.stringify(s)}`);
                throw new Error(a);
            }
            if (!(0, $3qpNA.isValidNamespacesRequest)(o, i, s.method)) {
                const { message: a } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `request() method: ${s.method}`);
                throw new Error(a);
            }
            if (r && !(0, $3qpNA.isValidRequestExpiry)(r, $ed918cd7853aa237$export$409f0c0a13a1b7c6)) {
                const { message: a } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `request() expiry: ${r}. Expiry must be a number (in seconds) between ${$ed918cd7853aa237$export$409f0c0a13a1b7c6.min} and ${$ed918cd7853aa237$export$409f0c0a13a1b7c6.max}`);
                throw new Error(a);
            }
        }), $ed918cd7853aa237$var$c(this, "isValidRespond", async (e)=>{
            var t;
            if (!(0, $3qpNA.isValidParams)(e)) {
                const { message: r } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `respond() params: ${e}`);
                throw new Error(r);
            }
            const { topic: s, response: i } = e;
            try {
                await this.isValidSessionTopic(s);
            } catch (r) {
                throw (t = e?.response) != null && t.id && this.cleanupAfterResponse(e), r;
            }
            if (!(0, $3qpNA.isValidResponse)(i)) {
                const { message: r } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `respond() response: ${JSON.stringify(i)}`);
                throw new Error(r);
            }
        }), $ed918cd7853aa237$var$c(this, "isValidPing", async (e)=>{
            if (!(0, $3qpNA.isValidParams)(e)) {
                const { message: s } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `ping() params: ${e}`);
                throw new Error(s);
            }
            const { topic: t } = e;
            await this.isValidSessionOrPairingTopic(t);
        }), $ed918cd7853aa237$var$c(this, "isValidEmit", async (e)=>{
            if (!(0, $3qpNA.isValidParams)(e)) {
                const { message: o } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `emit() params: ${e}`);
                throw new Error(o);
            }
            const { topic: t, event: s, chainId: i } = e;
            await this.isValidSessionTopic(t);
            const { namespaces: r } = this.client.session.get(t);
            if (!(0, $3qpNA.isValidNamespacesChainId)(r, i)) {
                const { message: o } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `emit() chainId: ${i}`);
                throw new Error(o);
            }
            if (!(0, $3qpNA.isValidEvent)(s)) {
                const { message: o } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(s)}`);
                throw new Error(o);
            }
            if (!(0, $3qpNA.isValidNamespacesEvent)(r, i, s.name)) {
                const { message: o } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(s)}`);
                throw new Error(o);
            }
        }), $ed918cd7853aa237$var$c(this, "isValidDisconnect", async (e)=>{
            if (!(0, $3qpNA.isValidParams)(e)) {
                const { message: s } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `disconnect() params: ${e}`);
                throw new Error(s);
            }
            const { topic: t } = e;
            await this.isValidSessionOrPairingTopic(t);
        }), $ed918cd7853aa237$var$c(this, "isValidAuthenticate", (e)=>{
            const { chains: t, uri: s, domain: i, nonce: r } = e;
            if (!Array.isArray(t) || t.length === 0) throw new Error("chains is required and must be a non-empty array");
            if (!(0, $3qpNA.isValidString)(s, !1)) throw new Error("uri is required parameter");
            if (!(0, $3qpNA.isValidString)(i, !1)) throw new Error("domain is required parameter");
            if (!(0, $3qpNA.isValidString)(r, !1)) throw new Error("nonce is required parameter");
            if ([
                ...new Set(t.map((a)=>(0, $3qpNA.parseChainId)(a).namespace))
            ].length > 1) throw new Error("Multi-namespace requests are not supported. Please request single namespace only.");
            const { namespace: o } = (0, $3qpNA.parseChainId)(t[0]);
            if (o !== "eip155") throw new Error("Only eip155 namespace is supported for authenticated sessions. Please use .connect() for non-eip155 chains.");
        }), $ed918cd7853aa237$var$c(this, "getVerifyContext", async (e)=>{
            const { attestationId: t, hash: s, encryptedId: i, metadata: r, transportType: o } = e, a = {
                verified: {
                    verifyUrl: r.verifyUrl || (0, $9bAHY.VERIFY_SERVER),
                    validation: "UNKNOWN",
                    origin: r.url || ""
                }
            };
            try {
                if (o === (0, $9bAHY.TRANSPORT_TYPES).link_mode) {
                    const p = this.getAppLinkIfEnabled(r, o);
                    return a.verified.validation = p && new URL(p).origin === new URL(r.url).origin ? "VALID" : "INVALID", a;
                }
                const l = await this.client.core.verify.resolve({
                    attestationId: t,
                    hash: s,
                    encryptedId: i,
                    verifyUrl: r.verifyUrl
                });
                l && (a.verified.origin = l.origin, a.verified.isScam = l.isScam, a.verified.validation = l.origin === new URL(r.url).origin ? "VALID" : "INVALID");
            } catch (l) {
                this.client.logger.warn(l);
            }
            return this.client.logger.debug(`Verify context: ${JSON.stringify(a)}`), a;
        }), $ed918cd7853aa237$var$c(this, "validateSessionProps", (e, t)=>{
            Object.values(e).forEach((s, i)=>{
                if (s == null) {
                    const { message: r } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `${t} must contain an existing value for each key. Received: ${s} for key ${Object.keys(e)[i]}`);
                    throw new Error(r);
                }
            });
        }), $ed918cd7853aa237$var$c(this, "getPendingAuthRequest", (e)=>{
            const t = this.client.auth.requests.get(e);
            return typeof t == "object" ? t : void 0;
        }), $ed918cd7853aa237$var$c(this, "addToRecentlyDeleted", (e, t)=>{
            if (this.recentlyDeletedMap.set(e, t), this.recentlyDeletedMap.size >= this.recentlyDeletedLimit) {
                let s = 0;
                const i = this.recentlyDeletedLimit / 2;
                for (const r of this.recentlyDeletedMap.keys()){
                    if (s++ >= i) break;
                    this.recentlyDeletedMap.delete(r);
                }
            }
        }), $ed918cd7853aa237$var$c(this, "checkRecentlyDeleted", (e)=>{
            const t = this.recentlyDeletedMap.get(e);
            if (t) {
                const { message: s } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `Record was recently deleted - ${t}: ${e}`);
                throw new Error(s);
            }
        }), $ed918cd7853aa237$var$c(this, "isLinkModeEnabled", (e, t)=>{
            var s, i, r, o, a, l, p, h, u;
            return !e || t !== (0, $9bAHY.TRANSPORT_TYPES).link_mode ? !1 : ((i = (s = this.client.metadata) == null ? void 0 : s.redirect) == null ? void 0 : i.linkMode) === !0 && ((o = (r = this.client.metadata) == null ? void 0 : r.redirect) == null ? void 0 : o.universal) !== void 0 && ((l = (a = this.client.metadata) == null ? void 0 : a.redirect) == null ? void 0 : l.universal) !== "" && ((p = e?.redirect) == null ? void 0 : p.universal) !== void 0 && ((h = e?.redirect) == null ? void 0 : h.universal) !== "" && ((u = e?.redirect) == null ? void 0 : u.linkMode) === !0 && this.client.core.linkModeSupportedApps.includes(e.redirect.universal) && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u";
        }), $ed918cd7853aa237$var$c(this, "getAppLinkIfEnabled", (e, t)=>{
            var s;
            return this.isLinkModeEnabled(e, t) ? (s = e?.redirect) == null ? void 0 : s.universal : void 0;
        }), $ed918cd7853aa237$var$c(this, "handleLinkModeMessage", ({ url: e })=>{
            if (!e || !e.includes("wc_ev") || !e.includes("topic")) return;
            const t = (0, $3qpNA.getSearchParamFromURL)(e, "topic") || "", s = decodeURIComponent((0, $3qpNA.getSearchParamFromURL)(e, "wc_ev") || ""), i = this.client.session.keys.includes(t);
            i && this.client.session.update(t, {
                transportType: (0, $9bAHY.TRANSPORT_TYPES).link_mode
            }), this.client.core.dispatchEnvelope({
                topic: t,
                message: s,
                sessionExists: i
            });
        }), $ed918cd7853aa237$var$c(this, "registerLinkModeListeners", async ()=>{
            var e;
            if ((0, $3qpNA.isTestRun)() || (0, $3qpNA.isReactNative)() && (e = this.client.metadata.redirect) != null && e.linkMode) {
                const t = $parcel$global == null ? void 0 : $parcel$global.Linking;
                if (typeof t < "u") {
                    t.addEventListener("url", this.handleLinkModeMessage, this.client.name);
                    const s = await t.getInitialURL();
                    s && setTimeout(()=>{
                        this.handleLinkModeMessage({
                            url: s
                        });
                    }, 50);
                }
            }
        }), $ed918cd7853aa237$var$c(this, "shouldSetTVF", (e, t)=>{
            if (!t || e !== "wc_sessionRequest") return !1;
            const { request: s } = t;
            return Object.keys($ed918cd7853aa237$export$a06a2a399442c35f).includes(s.method);
        }), $ed918cd7853aa237$var$c(this, "getTVFParams", (e, t, s)=>{
            var i, r;
            try {
                const o = t.request.method, a = this.extractTxHashesFromResult(o, s);
                return $ed918cd7853aa237$var$b($ed918cd7853aa237$var$v({
                    correlationId: e,
                    rpcMethods: [
                        o
                    ],
                    chainId: t.chainId
                }, this.isValidContractData(t.request.params) && {
                    contractAddresses: [
                        (r = (i = t.request.params) == null ? void 0 : i[0]) == null ? void 0 : r.to
                    ]
                }), {
                    txHashes: a
                });
            } catch (o) {
                this.client.logger.warn("Error getting TVF params", o);
            }
            return {};
        }), $ed918cd7853aa237$var$c(this, "isValidContractData", (e)=>{
            var t;
            if (!e) return !1;
            try {
                const s = e?.data || ((t = e?.[0]) == null ? void 0 : t.data);
                if (!s.startsWith("0x")) return !1;
                const i = s.slice(2);
                return /^[0-9a-fA-F]*$/.test(i) ? i.length % 2 === 0 : !1;
            } catch  {}
            return !1;
        }), $ed918cd7853aa237$var$c(this, "extractTxHashesFromResult", (e, t)=>{
            try {
                const s = $ed918cd7853aa237$export$a06a2a399442c35f[e];
                if (typeof t == "string") return [
                    t
                ];
                const i = t[s.key];
                if ((0, $3qpNA.isValidArray)(i)) return e === "solana_signAllTransactions" ? i.map((r)=>(0, $3qpNA.extractSolanaTransactionId)(r)) : i;
                if (typeof i == "string") return [
                    i
                ];
            } catch (s) {
                this.client.logger.warn("Error extracting tx hashes from result", s);
            }
            return [];
        });
    }
    async processPendingMessageEvents() {
        try {
            const n = this.client.session.keys, e = this.client.core.relayer.messages.getWithoutAck(n);
            for (const [t, s] of Object.entries(e))for (const i of s)try {
                await this.onProviderMessageEvent({
                    topic: t,
                    message: i,
                    publishedAt: Date.now()
                });
            } catch  {
                this.client.logger.warn(`Error processing pending message event for topic: ${t}, message: ${i}`);
            }
        } catch (n) {
            this.client.logger.warn("processPendingMessageEvents failed", n);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: n } = (0, $3qpNA.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(n);
        }
    }
    async confirmOnlineStateOrThrow() {
        await this.client.core.relayer.confirmOnlineStateOrThrow();
    }
    registerRelayerEvents() {
        this.client.core.relayer.on((0, $9bAHY.RELAYER_EVENTS).message, (n)=>{
            this.onProviderMessageEvent(n);
        });
    }
    async onRelayMessage(n) {
        const { topic: e, message: t, attestation: s, transportType: i } = n, { publicKey: r } = this.client.auth.authKeys.keys.includes($ed918cd7853aa237$export$efef74cb455ac30f) ? this.client.auth.authKeys.get($ed918cd7853aa237$export$efef74cb455ac30f) : {
            responseTopic: void 0,
            publicKey: void 0
        };
        try {
            const o = await this.client.core.crypto.decode(e, t, {
                receiverPublicKey: r,
                encoding: i === (0, $9bAHY.TRANSPORT_TYPES).link_mode ? (0, $3qpNA.BASE64URL) : (0, $3qpNA.BASE64)
            });
            (0, $fgWWx.isJsonRpcRequest)(o) ? (this.client.core.history.set(e, o), await this.onRelayEventRequest({
                topic: e,
                payload: o,
                attestation: s,
                transportType: i,
                encryptedId: (0, $3qpNA.hashMessage)(t)
            })) : (0, $fgWWx.isJsonRpcResponse)(o) ? (await this.client.core.history.resolve(o), await this.onRelayEventResponse({
                topic: e,
                payload: o,
                transportType: i
            }), this.client.core.history.delete(e, o.id)) : await this.onRelayEventUnknownPayload({
                topic: e,
                payload: o,
                transportType: i
            }), await this.client.core.relayer.messages.ack(e, t);
        } catch (o) {
            this.client.logger.error(o);
        }
    }
    registerExpirerEvents() {
        this.client.core.expirer.on((0, $9bAHY.EXPIRER_EVENTS).expired, async (n)=>{
            const { topic: e, id: t } = (0, $3qpNA.parseExpirerTarget)(n.target);
            if (t && this.client.pendingRequest.keys.includes(t)) return await this.deletePendingSessionRequest(t, (0, $3qpNA.getInternalError)("EXPIRED"), !0);
            if (t && this.client.auth.requests.keys.includes(t)) return await this.deletePendingAuthRequest(t, (0, $3qpNA.getInternalError)("EXPIRED"), !0);
            e ? this.client.session.keys.includes(e) && (await this.deleteSession({
                topic: e,
                expirerHasDeleted: !0
            }), this.client.events.emit("session_expire", {
                topic: e
            })) : t && (await this.deleteProposal(t, !0), this.client.events.emit("proposal_expire", {
                id: t
            }));
        });
    }
    registerPairingEvents() {
        this.client.core.pairing.events.on((0, $9bAHY.PAIRING_EVENTS).create, (n)=>this.onPairingCreated(n)), this.client.core.pairing.events.on((0, $9bAHY.PAIRING_EVENTS).delete, (n)=>{
            this.addToRecentlyDeleted(n.topic, "pairing");
        });
    }
    isValidPairingTopic(n) {
        if (!(0, $3qpNA.isValidString)(n, !1)) {
            const { message: e } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `pairing topic should be a string: ${n}`);
            throw new Error(e);
        }
        if (!this.client.core.pairing.pairings.keys.includes(n)) {
            const { message: e } = (0, $3qpNA.getInternalError)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${n}`);
            throw new Error(e);
        }
        if ((0, $3qpNA.isExpired)(this.client.core.pairing.pairings.get(n).expiry)) {
            const { message: e } = (0, $3qpNA.getInternalError)("EXPIRED", `pairing topic: ${n}`);
            throw new Error(e);
        }
    }
    async isValidSessionTopic(n) {
        if (!(0, $3qpNA.isValidString)(n, !1)) {
            const { message: e } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `session topic should be a string: ${n}`);
            throw new Error(e);
        }
        if (this.checkRecentlyDeleted(n), !this.client.session.keys.includes(n)) {
            const { message: e } = (0, $3qpNA.getInternalError)("NO_MATCHING_KEY", `session topic doesn't exist: ${n}`);
            throw new Error(e);
        }
        if ((0, $3qpNA.isExpired)(this.client.session.get(n).expiry)) {
            await this.deleteSession({
                topic: n
            });
            const { message: e } = (0, $3qpNA.getInternalError)("EXPIRED", `session topic: ${n}`);
            throw new Error(e);
        }
        if (!this.client.core.crypto.keychain.has(n)) {
            const { message: e } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `session topic does not exist in keychain: ${n}`);
            throw await this.deleteSession({
                topic: n
            }), new Error(e);
        }
    }
    async isValidSessionOrPairingTopic(n) {
        if (this.checkRecentlyDeleted(n), this.client.session.keys.includes(n)) await this.isValidSessionTopic(n);
        else if (this.client.core.pairing.pairings.keys.includes(n)) this.isValidPairingTopic(n);
        else if ((0, $3qpNA.isValidString)(n, !1)) {
            const { message: e } = (0, $3qpNA.getInternalError)("NO_MATCHING_KEY", `session or pairing topic doesn't exist: ${n}`);
            throw new Error(e);
        } else {
            const { message: e } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `session or pairing topic should be a string: ${n}`);
            throw new Error(e);
        }
    }
    async isValidProposalId(n) {
        if (!(0, $3qpNA.isValidId)(n)) {
            const { message: e } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `proposal id should be a number: ${n}`);
            throw new Error(e);
        }
        if (!this.client.proposal.keys.includes(n)) {
            const { message: e } = (0, $3qpNA.getInternalError)("NO_MATCHING_KEY", `proposal id doesn't exist: ${n}`);
            throw new Error(e);
        }
        if ((0, $3qpNA.isExpired)(this.client.proposal.get(n).expiryTimestamp)) {
            await this.deleteProposal(n);
            const { message: e } = (0, $3qpNA.getInternalError)("EXPIRED", `proposal id: ${n}`);
            throw new Error(e);
        }
    }
}
class $ed918cd7853aa237$var$Ns extends (0, $9bAHY.Store) {
    constructor(n, e){
        super(n, e, $ed918cd7853aa237$export$ae6c7a4f7ed730a1, $ed918cd7853aa237$export$7fa6f9ee1e2cab96), this.core = n, this.logger = e;
    }
}
class $ed918cd7853aa237$var$St extends (0, $9bAHY.Store) {
    constructor(n, e){
        super(n, e, $ed918cd7853aa237$export$a069e98a8dfeec1e, $ed918cd7853aa237$export$7fa6f9ee1e2cab96), this.core = n, this.logger = e;
    }
}
class $ed918cd7853aa237$var$Os extends (0, $9bAHY.Store) {
    constructor(n, e){
        super(n, e, $ed918cd7853aa237$export$40b296af21bd38a4, $ed918cd7853aa237$export$7fa6f9ee1e2cab96, (t)=>t.id), this.core = n, this.logger = e;
    }
}
class $ed918cd7853aa237$var$bs extends (0, $9bAHY.Store) {
    constructor(n, e){
        super(n, e, $ed918cd7853aa237$export$ab815cb37981e7e0, $ed918cd7853aa237$export$323ba3ebb8028ed0, ()=>$ed918cd7853aa237$export$efef74cb455ac30f), this.core = n, this.logger = e;
    }
}
class $ed918cd7853aa237$var$As extends (0, $9bAHY.Store) {
    constructor(n, e){
        super(n, e, $ed918cd7853aa237$export$5d9af9e20f678626, $ed918cd7853aa237$export$323ba3ebb8028ed0), this.core = n, this.logger = e;
    }
}
class $ed918cd7853aa237$var$xs extends (0, $9bAHY.Store) {
    constructor(n, e){
        super(n, e, $ed918cd7853aa237$export$3643b3579d091159, $ed918cd7853aa237$export$323ba3ebb8028ed0, (t)=>t.id), this.core = n, this.logger = e;
    }
}
var $ed918cd7853aa237$var$Cs = Object.defineProperty, $ed918cd7853aa237$var$Vs = (S, n, e)=>n in S ? $ed918cd7853aa237$var$Cs(S, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : S[n] = e, $ed918cd7853aa237$var$Ge = (S, n, e)=>$ed918cd7853aa237$var$Vs(S, typeof n != "symbol" ? n + "" : n, e);
class $ed918cd7853aa237$var$Ds {
    constructor(n, e){
        this.core = n, this.logger = e, $ed918cd7853aa237$var$Ge(this, "authKeys"), $ed918cd7853aa237$var$Ge(this, "pairingTopics"), $ed918cd7853aa237$var$Ge(this, "requests"), this.authKeys = new $ed918cd7853aa237$var$bs(this.core, this.logger), this.pairingTopics = new $ed918cd7853aa237$var$As(this.core, this.logger), this.requests = new $ed918cd7853aa237$var$xs(this.core, this.logger);
    }
    async init() {
        await this.authKeys.init(), await this.pairingTopics.init(), await this.requests.init();
    }
}
var $ed918cd7853aa237$var$Ls = Object.defineProperty, $ed918cd7853aa237$var$ks = (S, n, e)=>n in S ? $ed918cd7853aa237$var$Ls(S, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : S[n] = e, $ed918cd7853aa237$var$E = (S, n, e)=>$ed918cd7853aa237$var$ks(S, typeof n != "symbol" ? n + "" : n, e);
class $ed918cd7853aa237$export$2e2bcd8739ae039 extends (0, $2B80D.ISignClient) {
    constructor(n){
        super(n), $ed918cd7853aa237$var$E(this, "protocol", $ed918cd7853aa237$export$4fa962fc67384e02), $ed918cd7853aa237$var$E(this, "version", $ed918cd7853aa237$export$61085c48796ff049), $ed918cd7853aa237$var$E(this, "name", $ed918cd7853aa237$export$8dffb3242f2c5f72.name), $ed918cd7853aa237$var$E(this, "metadata"), $ed918cd7853aa237$var$E(this, "core"), $ed918cd7853aa237$var$E(this, "logger"), $ed918cd7853aa237$var$E(this, "events", new (0, $5yFVO.EventEmitter)), $ed918cd7853aa237$var$E(this, "engine"), $ed918cd7853aa237$var$E(this, "session"), $ed918cd7853aa237$var$E(this, "proposal"), $ed918cd7853aa237$var$E(this, "pendingRequest"), $ed918cd7853aa237$var$E(this, "auth"), $ed918cd7853aa237$var$E(this, "signConfig"), $ed918cd7853aa237$var$E(this, "on", (t, s)=>this.events.on(t, s)), $ed918cd7853aa237$var$E(this, "once", (t, s)=>this.events.once(t, s)), $ed918cd7853aa237$var$E(this, "off", (t, s)=>this.events.off(t, s)), $ed918cd7853aa237$var$E(this, "removeListener", (t, s)=>this.events.removeListener(t, s)), $ed918cd7853aa237$var$E(this, "removeAllListeners", (t)=>this.events.removeAllListeners(t)), $ed918cd7853aa237$var$E(this, "connect", async (t)=>{
            try {
                return await this.engine.connect(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $ed918cd7853aa237$var$E(this, "pair", async (t)=>{
            try {
                return await this.engine.pair(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $ed918cd7853aa237$var$E(this, "approve", async (t)=>{
            try {
                return await this.engine.approve(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $ed918cd7853aa237$var$E(this, "reject", async (t)=>{
            try {
                return await this.engine.reject(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $ed918cd7853aa237$var$E(this, "update", async (t)=>{
            try {
                return await this.engine.update(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $ed918cd7853aa237$var$E(this, "extend", async (t)=>{
            try {
                return await this.engine.extend(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $ed918cd7853aa237$var$E(this, "request", async (t)=>{
            try {
                return await this.engine.request(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $ed918cd7853aa237$var$E(this, "respond", async (t)=>{
            try {
                return await this.engine.respond(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $ed918cd7853aa237$var$E(this, "ping", async (t)=>{
            try {
                return await this.engine.ping(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $ed918cd7853aa237$var$E(this, "emit", async (t)=>{
            try {
                return await this.engine.emit(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $ed918cd7853aa237$var$E(this, "disconnect", async (t)=>{
            try {
                return await this.engine.disconnect(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $ed918cd7853aa237$var$E(this, "find", (t)=>{
            try {
                return this.engine.find(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $ed918cd7853aa237$var$E(this, "getPendingSessionRequests", ()=>{
            try {
                return this.engine.getPendingSessionRequests();
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }), $ed918cd7853aa237$var$E(this, "authenticate", async (t, s)=>{
            try {
                return await this.engine.authenticate(t, s);
            } catch (i) {
                throw this.logger.error(i.message), i;
            }
        }), $ed918cd7853aa237$var$E(this, "formatAuthMessage", (t)=>{
            try {
                return this.engine.formatAuthMessage(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $ed918cd7853aa237$var$E(this, "approveSessionAuthenticate", async (t)=>{
            try {
                return await this.engine.approveSessionAuthenticate(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $ed918cd7853aa237$var$E(this, "rejectSessionAuthenticate", async (t)=>{
            try {
                return await this.engine.rejectSessionAuthenticate(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), this.name = n?.name || $ed918cd7853aa237$export$8dffb3242f2c5f72.name, this.metadata = (0, $3qpNA.populateAppMetadata)(n?.metadata), this.signConfig = n?.signConfig;
        const e = typeof n?.logger < "u" && typeof n?.logger != "string" ? n.logger : (0, (/*@__PURE__*/$parcel$interopDefault($66E6s)))((0, $6GQzw.getDefaultLoggerOptions)({
            level: n?.logger || $ed918cd7853aa237$export$8dffb3242f2c5f72.logger
        }));
        this.core = n?.core || new (0, $9bAHY.Core)(n), this.logger = (0, $6GQzw.generateChildLogger)(e, this.name), this.session = new $ed918cd7853aa237$var$St(this.core, this.logger), this.proposal = new $ed918cd7853aa237$var$Ns(this.core, this.logger), this.pendingRequest = new $ed918cd7853aa237$var$Os(this.core, this.logger), this.engine = new $ed918cd7853aa237$var$Ps(this), this.auth = new $ed918cd7853aa237$var$Ds(this.core, this.logger);
    }
    static async init(n) {
        const e = new $ed918cd7853aa237$export$2e2bcd8739ae039(n);
        return await e.initialize(), e;
    }
    get context() {
        return (0, $6GQzw.getLoggerContext)(this.logger);
    }
    get pairing() {
        return this.core.pairing.pairings;
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.core.start(), await this.session.init(), await this.proposal.init(), await this.pendingRequest.init(), await this.auth.init(), await this.engine.init(), this.logger.info("SignClient Initialization Success"), setTimeout(()=>{
                this.engine.processRelayMessageCache();
            }, (0, $9eyak.toMiliseconds)((0, $9eyak.ONE_SECOND)));
        } catch (n) {
            throw this.logger.info("SignClient Initialization Failure"), this.logger.error(n.message), n;
        }
    }
}
const $ed918cd7853aa237$export$90b8cff65c105172 = $ed918cd7853aa237$var$St, $ed918cd7853aa237$export$bdf4ba258ec679dc = $ed918cd7853aa237$export$2e2bcd8739ae039;

});
parcelRegister("9bAHY", function(module, exports) {

$parcel$export(module.exports, "RELAYER_DEFAULT_PROTOCOL", () => $6b019d9bd89ed96b$export$822d0bd1635d5360);
$parcel$export(module.exports, "RELAYER_EVENTS", () => $6b019d9bd89ed96b$export$d56245796e2837d);
$parcel$export(module.exports, "TRANSPORT_TYPES", () => $6b019d9bd89ed96b$export$326e296bb8673773);
$parcel$export(module.exports, "PAIRING_EVENTS", () => $6b019d9bd89ed96b$export$ca3c0b962acf7b75);
$parcel$export(module.exports, "EXPIRER_EVENTS", () => $6b019d9bd89ed96b$export$9013719d9206b0c1);
$parcel$export(module.exports, "VERIFY_SERVER", () => $6b019d9bd89ed96b$export$7e3b1a28ddecdbaa);
$parcel$export(module.exports, "EVENT_CLIENT_PAIRING_TRACES", () => $6b019d9bd89ed96b$export$6736f9bb609b5d34);
$parcel$export(module.exports, "EVENT_CLIENT_PAIRING_ERRORS", () => $6b019d9bd89ed96b$export$e1dc85b7b7495247);
$parcel$export(module.exports, "EVENT_CLIENT_SESSION_TRACES", () => $6b019d9bd89ed96b$export$16ed3f27a411eba0);
$parcel$export(module.exports, "EVENT_CLIENT_SESSION_ERRORS", () => $6b019d9bd89ed96b$export$bc50109885e83402);
$parcel$export(module.exports, "EVENT_CLIENT_AUTHENTICATE_TRACES", () => $6b019d9bd89ed96b$export$6540f02663742dde);
$parcel$export(module.exports, "EVENT_CLIENT_AUTHENTICATE_ERRORS", () => $6b019d9bd89ed96b$export$aca4f34441e6cd3a);
$parcel$export(module.exports, "Store", () => $6b019d9bd89ed96b$export$390f32400eaf98c9);
$parcel$export(module.exports, "Core", () => $6b019d9bd89ed96b$export$4143ab5b91744744);

var $5yFVO = parcelRequire("5yFVO");

var $7G2F6 = parcelRequire("7G2F6");

var $2nKgt = parcelRequire("2nKgt");

var $6GQzw = parcelRequire("6GQzw");
var $66E6s = parcelRequire("66E6s");

var $2B80D = parcelRequire("2B80D");

var $9eyak = parcelRequire("9eyak");

var $bREX4 = parcelRequire("bREX4");

var $aKPeb = parcelRequire("aKPeb");

var $3qpNA = parcelRequire("3qpNA");
parcelRequire("68fSN");
var $iH58P = parcelRequire("iH58P");

var $1EAvo = parcelRequire("1EAvo");
parcelRequire("7IWKC");
var $fHodW = parcelRequire("fHodW");
var $fgWWx = parcelRequire("fgWWx");

var $7XH1l = parcelRequire("7XH1l");

var $bfa86 = parcelRequire("bfa86");

var $lewJ9 = parcelRequire("lewJ9");
var $6b019d9bd89ed96b$require$Buffer = $lewJ9.Buffer;

var $kuzpm = parcelRequire("kuzpm");
const $6b019d9bd89ed96b$export$51b1c900ac262bdf = "wc", $6b019d9bd89ed96b$export$f30bd3c8747cdfbe = 2, $6b019d9bd89ed96b$export$d47601f9de5ee22b = "core", $6b019d9bd89ed96b$export$f258d29ae5e3d545 = `${$6b019d9bd89ed96b$export$51b1c900ac262bdf}@2:${$6b019d9bd89ed96b$export$d47601f9de5ee22b}:`, $6b019d9bd89ed96b$export$db0fdb6d486555c2 = {
    name: $6b019d9bd89ed96b$export$d47601f9de5ee22b,
    logger: "error"
}, $6b019d9bd89ed96b$export$ba920abfe854b85d = {
    database: ":memory:"
}, $6b019d9bd89ed96b$export$92a79f21481c803d = "crypto", $6b019d9bd89ed96b$export$3613aa6e652146e4 = "client_ed25519_seed", $6b019d9bd89ed96b$export$c4bc5e31a4d0ec78 = (0, $9eyak.ONE_DAY), $6b019d9bd89ed96b$export$9d7218f72e8dc49b = "keychain", $6b019d9bd89ed96b$export$34f82f4ba0c3d769 = "0.3", $6b019d9bd89ed96b$export$9662bbc7d10cf481 = "messages", $6b019d9bd89ed96b$export$19dfd1896412c038 = "0.3", $6b019d9bd89ed96b$export$8ddbe6611b67d926 = (0, $9eyak.SIX_HOURS), $6b019d9bd89ed96b$export$9d92662178f2abd1 = "publisher", $6b019d9bd89ed96b$export$822d0bd1635d5360 = "irn", $6b019d9bd89ed96b$export$5176ffa6778d6637 = "error", $6b019d9bd89ed96b$export$a68061e6c48f332a = "wss://relay.walletconnect.org", $6b019d9bd89ed96b$export$602d6e27611c3fcb = "relayer", $6b019d9bd89ed96b$export$d56245796e2837d = {
    message: "relayer_message",
    message_ack: "relayer_message_ack",
    connect: "relayer_connect",
    disconnect: "relayer_disconnect",
    error: "relayer_error",
    connection_stalled: "relayer_connection_stalled",
    transport_closed: "relayer_transport_closed",
    publish: "relayer_publish"
}, $6b019d9bd89ed96b$export$119b4645f6b233c8 = "_subscription", $6b019d9bd89ed96b$export$58062acf2f31ddf8 = {
    payload: "payload",
    connect: "connect",
    disconnect: "disconnect",
    error: "error"
}, $6b019d9bd89ed96b$export$11ccd39be2c57d6 = .1, $6b019d9bd89ed96b$export$44b621f74f0f4c93 = {
    database: ":memory:"
}, $6b019d9bd89ed96b$export$5f30917a6f8c9025 = "2.20.2", $6b019d9bd89ed96b$export$fb3eab7adf12329d = 1e4, $6b019d9bd89ed96b$export$326e296bb8673773 = {
    link_mode: "link_mode",
    relay: "relay"
}, $6b019d9bd89ed96b$export$5c65dd72e0f566ab = {
    inbound: "inbound",
    outbound: "outbound"
}, $6b019d9bd89ed96b$export$629a342182ba24b = "0.3", $6b019d9bd89ed96b$export$9e4ca561755938da = "WALLETCONNECT_CLIENT_ID", $6b019d9bd89ed96b$export$1989eec3a412fb97 = "WALLETCONNECT_LINK_MODE_APPS", $6b019d9bd89ed96b$export$24ff3e54e94ef413 = {
    created: "subscription_created",
    deleted: "subscription_deleted",
    expired: "subscription_expired",
    disabled: "subscription_disabled",
    sync: "subscription_sync",
    resubscribed: "subscription_resubscribed"
}, $6b019d9bd89ed96b$export$9d35d0a6a3599be = (0, $9eyak.THIRTY_DAYS), $6b019d9bd89ed96b$export$9c3a96bb670cddb8 = "subscription", $6b019d9bd89ed96b$export$fb57e03bef4c4cea = "0.3", $6b019d9bd89ed96b$export$9a2ddbfe54f8af77 = (0, $9eyak.FIVE_SECONDS) * 1e3, $6b019d9bd89ed96b$export$390360ea476c6145 = "pairing", $6b019d9bd89ed96b$export$5593ec74b27d1b18 = "0.3", $6b019d9bd89ed96b$export$ee4b1978d0aedfad = (0, $9eyak.THIRTY_DAYS), $6b019d9bd89ed96b$export$d94d6986a8185883 = {
    wc_pairingDelete: {
        req: {
            ttl: (0, $9eyak.ONE_DAY),
            prompt: !1,
            tag: 1e3
        },
        res: {
            ttl: (0, $9eyak.ONE_DAY),
            prompt: !1,
            tag: 1001
        }
    },
    wc_pairingPing: {
        req: {
            ttl: (0, $9eyak.THIRTY_SECONDS),
            prompt: !1,
            tag: 1002
        },
        res: {
            ttl: (0, $9eyak.THIRTY_SECONDS),
            prompt: !1,
            tag: 1003
        }
    },
    unregistered_method: {
        req: {
            ttl: (0, $9eyak.ONE_DAY),
            prompt: !1,
            tag: 0
        },
        res: {
            ttl: (0, $9eyak.ONE_DAY),
            prompt: !1,
            tag: 0
        }
    }
}, $6b019d9bd89ed96b$export$ca3c0b962acf7b75 = {
    create: "pairing_create",
    expire: "pairing_expire",
    delete: "pairing_delete",
    ping: "pairing_ping"
}, $6b019d9bd89ed96b$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $6b019d9bd89ed96b$export$160142c73cb99dc3 = "history", $6b019d9bd89ed96b$export$8eba9ce85616c607 = "0.3", $6b019d9bd89ed96b$export$4ddf883392bbc828 = "expirer", $6b019d9bd89ed96b$export$9013719d9206b0c1 = {
    created: "expirer_created",
    deleted: "expirer_deleted",
    expired: "expirer_expired",
    sync: "expirer_sync"
}, $6b019d9bd89ed96b$export$717295846191925d = "0.3", $6b019d9bd89ed96b$export$3cfe73d6765db74 = (0, $9eyak.ONE_DAY), $6b019d9bd89ed96b$export$3b58f2450f2297e3 = "verify-api", $6b019d9bd89ed96b$var$Xs = "https://verify.walletconnect.com", $6b019d9bd89ed96b$var$Ht = "https://verify.walletconnect.org", $6b019d9bd89ed96b$export$7e3b1a28ddecdbaa = $6b019d9bd89ed96b$var$Ht, $6b019d9bd89ed96b$export$412739528655ee2f = `${$6b019d9bd89ed96b$export$7e3b1a28ddecdbaa}/v3`, $6b019d9bd89ed96b$export$be24df03c4baa778 = [
    $6b019d9bd89ed96b$var$Xs,
    $6b019d9bd89ed96b$var$Ht
], $6b019d9bd89ed96b$export$40c022d2cffe0adc = "echo", $6b019d9bd89ed96b$export$3c48c4faab79aab1 = "https://echo.walletconnect.com", $6b019d9bd89ed96b$export$2f94b15ed52f7de9 = "event-client", $6b019d9bd89ed96b$export$6736f9bb609b5d34 = {
    pairing_started: "pairing_started",
    pairing_uri_validation_success: "pairing_uri_validation_success",
    pairing_uri_not_expired: "pairing_uri_not_expired",
    store_new_pairing: "store_new_pairing",
    subscribing_pairing_topic: "subscribing_pairing_topic",
    subscribe_pairing_topic_success: "subscribe_pairing_topic_success",
    existing_pairing: "existing_pairing",
    pairing_not_expired: "pairing_not_expired",
    emit_inactive_pairing: "emit_inactive_pairing",
    emit_session_proposal: "emit_session_proposal",
    subscribing_to_pairing_topic: "subscribing_to_pairing_topic"
}, $6b019d9bd89ed96b$export$e1dc85b7b7495247 = {
    no_wss_connection: "no_wss_connection",
    no_internet_connection: "no_internet_connection",
    malformed_pairing_uri: "malformed_pairing_uri",
    active_pairing_already_exists: "active_pairing_already_exists",
    subscribe_pairing_topic_failure: "subscribe_pairing_topic_failure",
    pairing_expired: "pairing_expired",
    proposal_expired: "proposal_expired",
    proposal_listener_not_found: "proposal_listener_not_found"
}, $6b019d9bd89ed96b$export$16ed3f27a411eba0 = {
    session_approve_started: "session_approve_started",
    proposal_not_expired: "proposal_not_expired",
    session_namespaces_validation_success: "session_namespaces_validation_success",
    create_session_topic: "create_session_topic",
    subscribing_session_topic: "subscribing_session_topic",
    subscribe_session_topic_success: "subscribe_session_topic_success",
    publishing_session_approve: "publishing_session_approve",
    session_approve_publish_success: "session_approve_publish_success",
    store_session: "store_session",
    publishing_session_settle: "publishing_session_settle",
    session_settle_publish_success: "session_settle_publish_success"
}, $6b019d9bd89ed96b$export$bc50109885e83402 = {
    no_internet_connection: "no_internet_connection",
    no_wss_connection: "no_wss_connection",
    proposal_expired: "proposal_expired",
    subscribe_session_topic_failure: "subscribe_session_topic_failure",
    session_approve_publish_failure: "session_approve_publish_failure",
    session_settle_publish_failure: "session_settle_publish_failure",
    session_approve_namespace_validation_failure: "session_approve_namespace_validation_failure",
    proposal_not_found: "proposal_not_found"
}, $6b019d9bd89ed96b$export$6540f02663742dde = {
    authenticated_session_approve_started: "authenticated_session_approve_started",
    authenticated_session_not_expired: "authenticated_session_not_expired",
    chains_caip2_compliant: "chains_caip2_compliant",
    chains_evm_compliant: "chains_evm_compliant",
    create_authenticated_session_topic: "create_authenticated_session_topic",
    cacaos_verified: "cacaos_verified",
    store_authenticated_session: "store_authenticated_session",
    subscribing_authenticated_session_topic: "subscribing_authenticated_session_topic",
    subscribe_authenticated_session_topic_success: "subscribe_authenticated_session_topic_success",
    publishing_authenticated_session_approve: "publishing_authenticated_session_approve",
    authenticated_session_approve_publish_success: "authenticated_session_approve_publish_success"
}, $6b019d9bd89ed96b$export$aca4f34441e6cd3a = {
    no_internet_connection: "no_internet_connection",
    no_wss_connection: "no_wss_connection",
    missing_session_authenticate_request: "missing_session_authenticate_request",
    session_authenticate_request_expired: "session_authenticate_request_expired",
    chains_caip2_compliant_failure: "chains_caip2_compliant_failure",
    chains_evm_compliant_failure: "chains_evm_compliant_failure",
    invalid_cacao: "invalid_cacao",
    subscribe_authenticated_session_topic_failure: "subscribe_authenticated_session_topic_failure",
    authenticated_session_approve_publish_failure: "authenticated_session_approve_publish_failure",
    authenticated_session_pending_request_not_found: "authenticated_session_pending_request_not_found"
}, $6b019d9bd89ed96b$export$c73857c3a3d16b1c = .1, $6b019d9bd89ed96b$export$e020229e09910965 = "event-client", $6b019d9bd89ed96b$export$79348045429687e2 = 86400, $6b019d9bd89ed96b$export$bb6a8925f3cb1ca = "https://pulse.walletconnect.org/batch";
function $6b019d9bd89ed96b$var$sr(r, e) {
    if (r.length >= 255) throw new TypeError("Alphabet too long");
    for(var t = new Uint8Array(256), i = 0; i < t.length; i++)t[i] = 255;
    for(var s = 0; s < r.length; s++){
        var n = r.charAt(s), o = n.charCodeAt(0);
        if (t[o] !== 255) throw new TypeError(n + " is ambiguous");
        t[o] = s;
    }
    var a = r.length, c = r.charAt(0), h = Math.log(a) / Math.log(256), l = Math.log(256) / Math.log(a);
    function d(u) {
        if (u instanceof Uint8Array || (ArrayBuffer.isView(u) ? u = new Uint8Array(u.buffer, u.byteOffset, u.byteLength) : Array.isArray(u) && (u = Uint8Array.from(u))), !(u instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (u.length === 0) return "";
        for(var b = 0, x = 0, I = 0, D = u.length; I !== D && u[I] === 0;)I++, b++;
        for(var j = (D - I) * l + 1 >>> 0, T = new Uint8Array(j); I !== D;){
            for(var q = u[I], J = 0, K = j - 1; (q !== 0 || J < x) && K !== -1; K--, J++)q += 256 * T[K] >>> 0, T[K] = q % a >>> 0, q = q / a >>> 0;
            if (q !== 0) throw new Error("Non-zero carry");
            x = J, I++;
        }
        for(var H = j - x; H !== j && T[H] === 0;)H++;
        for(var me = c.repeat(b); H < j; ++H)me += r.charAt(T[H]);
        return me;
    }
    function g(u) {
        if (typeof u != "string") throw new TypeError("Expected String");
        if (u.length === 0) return new Uint8Array;
        var b = 0;
        if (u[b] !== " ") {
            for(var x = 0, I = 0; u[b] === c;)x++, b++;
            for(var D = (u.length - b) * h + 1 >>> 0, j = new Uint8Array(D); u[b];){
                var T = t[u.charCodeAt(b)];
                if (T === 255) return;
                for(var q = 0, J = D - 1; (T !== 0 || q < I) && J !== -1; J--, q++)T += a * j[J] >>> 0, j[J] = T % 256 >>> 0, T = T / 256 >>> 0;
                if (T !== 0) throw new Error("Non-zero carry");
                I = q, b++;
            }
            if (u[b] !== " ") {
                for(var K = D - I; K !== D && j[K] === 0;)K++;
                for(var H = new Uint8Array(x + (D - K)), me = x; K !== D;)H[me++] = j[K++];
                return H;
            }
        }
    }
    function _(u) {
        var b = g(u);
        if (b) return b;
        throw new Error(`Non-${e} character`);
    }
    return {
        encode: d,
        decodeUnsafe: g,
        decode: _
    };
}
var $6b019d9bd89ed96b$var$rr = $6b019d9bd89ed96b$var$sr, $6b019d9bd89ed96b$var$nr = $6b019d9bd89ed96b$var$rr;
const $6b019d9bd89ed96b$var$si = (r)=>{
    if (r instanceof Uint8Array && r.constructor.name === "Uint8Array") return r;
    if (r instanceof ArrayBuffer) return new Uint8Array(r);
    if (ArrayBuffer.isView(r)) return new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
    throw new Error("Unknown type, must be binary type");
}, $6b019d9bd89ed96b$var$or = (r)=>new TextEncoder().encode(r), $6b019d9bd89ed96b$var$ar = (r)=>new TextDecoder().decode(r);
class $6b019d9bd89ed96b$var$cr {
    constructor(e, t, i){
        this.name = e, this.prefix = t, this.baseEncode = i;
    }
    encode(e) {
        if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
        throw Error("Unknown type, must be binary type");
    }
}
class $6b019d9bd89ed96b$var$hr {
    constructor(e, t, i){
        if (this.name = e, this.prefix = t, t.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
        this.prefixCodePoint = t.codePointAt(0), this.baseDecode = i;
    }
    decode(e) {
        if (typeof e == "string") {
            if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(e.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(e) {
        return $6b019d9bd89ed96b$var$ri(this, e);
    }
}
class $6b019d9bd89ed96b$var$lr {
    constructor(e){
        this.decoders = e;
    }
    or(e) {
        return $6b019d9bd89ed96b$var$ri(this, e);
    }
    decode(e) {
        const t = e[0], i = this.decoders[t];
        if (i) return i.decode(e);
        throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $6b019d9bd89ed96b$var$ri = (r, e)=>new $6b019d9bd89ed96b$var$lr({
        ...r.decoders || {
            [r.prefix]: r
        },
        ...e.decoders || {
            [e.prefix]: e
        }
    });
class $6b019d9bd89ed96b$var$ur {
    constructor(e, t, i, s){
        this.name = e, this.prefix = t, this.baseEncode = i, this.baseDecode = s, this.encoder = new $6b019d9bd89ed96b$var$cr(e, t, i), this.decoder = new $6b019d9bd89ed96b$var$hr(e, t, s);
    }
    encode(e) {
        return this.encoder.encode(e);
    }
    decode(e) {
        return this.decoder.decode(e);
    }
}
const $6b019d9bd89ed96b$var$Ee = ({ name: r, prefix: e, encode: t, decode: i })=>new $6b019d9bd89ed96b$var$ur(r, e, t, i), $6b019d9bd89ed96b$var$de = ({ prefix: r, name: e, alphabet: t })=>{
    const { encode: i, decode: s } = $6b019d9bd89ed96b$var$nr(t, e);
    return $6b019d9bd89ed96b$var$Ee({
        prefix: r,
        name: e,
        encode: i,
        decode: (n)=>$6b019d9bd89ed96b$var$si(s(n))
    });
}, $6b019d9bd89ed96b$var$dr = (r, e, t, i)=>{
    const s = {};
    for(let l = 0; l < e.length; ++l)s[e[l]] = l;
    let n = r.length;
    for(; r[n - 1] === "=";)--n;
    const o = new Uint8Array(n * t / 8 | 0);
    let a = 0, c = 0, h = 0;
    for(let l = 0; l < n; ++l){
        const d = s[r[l]];
        if (d === void 0) throw new SyntaxError(`Non-${i} character`);
        c = c << t | d, a += t, a >= 8 && (a -= 8, o[h++] = 255 & c >> a);
    }
    if (a >= t || 255 & c << 8 - a) throw new SyntaxError("Unexpected end of data");
    return o;
}, $6b019d9bd89ed96b$var$gr = (r, e, t)=>{
    const i = e[e.length - 1] === "=", s = (1 << t) - 1;
    let n = "", o = 0, a = 0;
    for(let c = 0; c < r.length; ++c)for(a = a << 8 | r[c], o += 8; o > t;)o -= t, n += e[s & a >> o];
    if (o && (n += e[s & a << t - o]), i) for(; n.length * t & 7;)n += "=";
    return n;
}, $6b019d9bd89ed96b$var$P = ({ name: r, prefix: e, bitsPerChar: t, alphabet: i })=>$6b019d9bd89ed96b$var$Ee({
        prefix: e,
        name: r,
        encode (s) {
            return $6b019d9bd89ed96b$var$gr(s, i, t);
        },
        decode (s) {
            return $6b019d9bd89ed96b$var$dr(s, i, t, r);
        }
    }), $6b019d9bd89ed96b$var$pr = $6b019d9bd89ed96b$var$Ee({
    prefix: "\x00",
    name: "identity",
    encode: (r)=>$6b019d9bd89ed96b$var$ar(r),
    decode: (r)=>$6b019d9bd89ed96b$var$or(r)
});
var $6b019d9bd89ed96b$var$yr = Object.freeze({
    __proto__: null,
    identity: $6b019d9bd89ed96b$var$pr
});
const $6b019d9bd89ed96b$var$br = $6b019d9bd89ed96b$var$P({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
var $6b019d9bd89ed96b$var$mr = Object.freeze({
    __proto__: null,
    base2: $6b019d9bd89ed96b$var$br
});
const $6b019d9bd89ed96b$var$fr = $6b019d9bd89ed96b$var$P({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
var $6b019d9bd89ed96b$var$Dr = Object.freeze({
    __proto__: null,
    base8: $6b019d9bd89ed96b$var$fr
});
const $6b019d9bd89ed96b$var$vr = $6b019d9bd89ed96b$var$de({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
var $6b019d9bd89ed96b$var$wr = Object.freeze({
    __proto__: null,
    base10: $6b019d9bd89ed96b$var$vr
});
const $6b019d9bd89ed96b$var$_r = $6b019d9bd89ed96b$var$P({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), $6b019d9bd89ed96b$var$Er = $6b019d9bd89ed96b$var$P({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
var $6b019d9bd89ed96b$var$Ir = Object.freeze({
    __proto__: null,
    base16: $6b019d9bd89ed96b$var$_r,
    base16upper: $6b019d9bd89ed96b$var$Er
});
const $6b019d9bd89ed96b$var$Tr = $6b019d9bd89ed96b$var$P({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), $6b019d9bd89ed96b$var$Cr = $6b019d9bd89ed96b$var$P({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), $6b019d9bd89ed96b$var$Pr = $6b019d9bd89ed96b$var$P({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), $6b019d9bd89ed96b$var$Sr = $6b019d9bd89ed96b$var$P({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), $6b019d9bd89ed96b$var$Rr = $6b019d9bd89ed96b$var$P({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), $6b019d9bd89ed96b$var$Or = $6b019d9bd89ed96b$var$P({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), $6b019d9bd89ed96b$var$Ar = $6b019d9bd89ed96b$var$P({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), $6b019d9bd89ed96b$var$xr = $6b019d9bd89ed96b$var$P({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), $6b019d9bd89ed96b$var$Nr = $6b019d9bd89ed96b$var$P({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
var $6b019d9bd89ed96b$var$$r = Object.freeze({
    __proto__: null,
    base32: $6b019d9bd89ed96b$var$Tr,
    base32upper: $6b019d9bd89ed96b$var$Cr,
    base32pad: $6b019d9bd89ed96b$var$Pr,
    base32padupper: $6b019d9bd89ed96b$var$Sr,
    base32hex: $6b019d9bd89ed96b$var$Rr,
    base32hexupper: $6b019d9bd89ed96b$var$Or,
    base32hexpad: $6b019d9bd89ed96b$var$Ar,
    base32hexpadupper: $6b019d9bd89ed96b$var$xr,
    base32z: $6b019d9bd89ed96b$var$Nr
});
const $6b019d9bd89ed96b$var$zr = $6b019d9bd89ed96b$var$de({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $6b019d9bd89ed96b$var$Lr = $6b019d9bd89ed96b$var$de({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
var $6b019d9bd89ed96b$var$kr = Object.freeze({
    __proto__: null,
    base36: $6b019d9bd89ed96b$var$zr,
    base36upper: $6b019d9bd89ed96b$var$Lr
});
const $6b019d9bd89ed96b$var$jr = $6b019d9bd89ed96b$var$de({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), $6b019d9bd89ed96b$var$Ur = $6b019d9bd89ed96b$var$de({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
var $6b019d9bd89ed96b$var$Fr = Object.freeze({
    __proto__: null,
    base58btc: $6b019d9bd89ed96b$var$jr,
    base58flickr: $6b019d9bd89ed96b$var$Ur
});
const $6b019d9bd89ed96b$var$Mr = $6b019d9bd89ed96b$var$P({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), $6b019d9bd89ed96b$var$Kr = $6b019d9bd89ed96b$var$P({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), $6b019d9bd89ed96b$var$Br = $6b019d9bd89ed96b$var$P({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), $6b019d9bd89ed96b$var$Vr = $6b019d9bd89ed96b$var$P({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
var $6b019d9bd89ed96b$var$qr = Object.freeze({
    __proto__: null,
    base64: $6b019d9bd89ed96b$var$Mr,
    base64pad: $6b019d9bd89ed96b$var$Kr,
    base64url: $6b019d9bd89ed96b$var$Br,
    base64urlpad: $6b019d9bd89ed96b$var$Vr
});
const $6b019d9bd89ed96b$var$ni = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), $6b019d9bd89ed96b$var$Gr = $6b019d9bd89ed96b$var$ni.reduce((r, e, t)=>(r[t] = e, r), []), $6b019d9bd89ed96b$var$Wr = $6b019d9bd89ed96b$var$ni.reduce((r, e, t)=>(r[e.codePointAt(0)] = t, r), []);
function $6b019d9bd89ed96b$var$Hr(r) {
    return r.reduce((e, t)=>(e += $6b019d9bd89ed96b$var$Gr[t], e), "");
}
function $6b019d9bd89ed96b$var$Yr(r) {
    const e = [];
    for (const t of r){
        const i = $6b019d9bd89ed96b$var$Wr[t.codePointAt(0)];
        if (i === void 0) throw new Error(`Non-base256emoji character: ${t}`);
        e.push(i);
    }
    return new Uint8Array(e);
}
const $6b019d9bd89ed96b$var$Jr = $6b019d9bd89ed96b$var$Ee({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $6b019d9bd89ed96b$var$Hr,
    decode: $6b019d9bd89ed96b$var$Yr
});
var $6b019d9bd89ed96b$var$Xr = Object.freeze({
    __proto__: null,
    base256emoji: $6b019d9bd89ed96b$var$Jr
}), $6b019d9bd89ed96b$var$Zr = $6b019d9bd89ed96b$var$ai, $6b019d9bd89ed96b$var$oi = 128, $6b019d9bd89ed96b$var$Qr = 127, $6b019d9bd89ed96b$var$en = ~$6b019d9bd89ed96b$var$Qr, $6b019d9bd89ed96b$var$tn = Math.pow(2, 31);
function $6b019d9bd89ed96b$var$ai(r, e, t) {
    e = e || [], t = t || 0;
    for(var i = t; r >= $6b019d9bd89ed96b$var$tn;)e[t++] = r & 255 | $6b019d9bd89ed96b$var$oi, r /= 128;
    for(; r & $6b019d9bd89ed96b$var$en;)e[t++] = r & 255 | $6b019d9bd89ed96b$var$oi, r >>>= 7;
    return e[t] = r | 0, $6b019d9bd89ed96b$var$ai.bytes = t - i + 1, e;
}
var $6b019d9bd89ed96b$var$sn = $6b019d9bd89ed96b$var$Me, $6b019d9bd89ed96b$var$rn = 128, $6b019d9bd89ed96b$var$ci = 127;
function $6b019d9bd89ed96b$var$Me(r, i) {
    var t = 0, i = i || 0, s = 0, n = i, o, a = r.length;
    do {
        if (n >= a) throw $6b019d9bd89ed96b$var$Me.bytes = 0, new RangeError("Could not decode varint");
        o = r[n++], t += s < 28 ? (o & $6b019d9bd89ed96b$var$ci) << s : (o & $6b019d9bd89ed96b$var$ci) * Math.pow(2, s), s += 7;
    }while (o >= $6b019d9bd89ed96b$var$rn);
    return $6b019d9bd89ed96b$var$Me.bytes = n - i, t;
}
var $6b019d9bd89ed96b$var$nn = Math.pow(2, 7), $6b019d9bd89ed96b$var$on = Math.pow(2, 14), $6b019d9bd89ed96b$var$an = Math.pow(2, 21), $6b019d9bd89ed96b$var$cn = Math.pow(2, 28), $6b019d9bd89ed96b$var$hn = Math.pow(2, 35), $6b019d9bd89ed96b$var$ln = Math.pow(2, 42), $6b019d9bd89ed96b$var$un = Math.pow(2, 49), $6b019d9bd89ed96b$var$dn = Math.pow(2, 56), $6b019d9bd89ed96b$var$gn = Math.pow(2, 63), $6b019d9bd89ed96b$var$pn = function(r) {
    return r < $6b019d9bd89ed96b$var$nn ? 1 : r < $6b019d9bd89ed96b$var$on ? 2 : r < $6b019d9bd89ed96b$var$an ? 3 : r < $6b019d9bd89ed96b$var$cn ? 4 : r < $6b019d9bd89ed96b$var$hn ? 5 : r < $6b019d9bd89ed96b$var$ln ? 6 : r < $6b019d9bd89ed96b$var$un ? 7 : r < $6b019d9bd89ed96b$var$dn ? 8 : r < $6b019d9bd89ed96b$var$gn ? 9 : 10;
}, $6b019d9bd89ed96b$var$yn = {
    encode: $6b019d9bd89ed96b$var$Zr,
    decode: $6b019d9bd89ed96b$var$sn,
    encodingLength: $6b019d9bd89ed96b$var$pn
}, $6b019d9bd89ed96b$var$hi = $6b019d9bd89ed96b$var$yn;
const $6b019d9bd89ed96b$var$li = (r, e, t = 0)=>($6b019d9bd89ed96b$var$hi.encode(r, e, t), e), $6b019d9bd89ed96b$var$ui = (r)=>$6b019d9bd89ed96b$var$hi.encodingLength(r), $6b019d9bd89ed96b$var$Ke = (r, e)=>{
    const t = e.byteLength, i = $6b019d9bd89ed96b$var$ui(r), s = i + $6b019d9bd89ed96b$var$ui(t), n = new Uint8Array(s + t);
    return $6b019d9bd89ed96b$var$li(r, n, 0), $6b019d9bd89ed96b$var$li(t, n, i), n.set(e, s), new $6b019d9bd89ed96b$var$bn(r, t, e, n);
};
class $6b019d9bd89ed96b$var$bn {
    constructor(e, t, i, s){
        this.code = e, this.size = t, this.digest = i, this.bytes = s;
    }
}
const $6b019d9bd89ed96b$var$di = ({ name: r, code: e, encode: t })=>new $6b019d9bd89ed96b$var$mn(r, e, t);
class $6b019d9bd89ed96b$var$mn {
    constructor(e, t, i){
        this.name = e, this.code = t, this.encode = i;
    }
    digest(e) {
        if (e instanceof Uint8Array) {
            const t = this.encode(e);
            return t instanceof Uint8Array ? $6b019d9bd89ed96b$var$Ke(this.code, t) : t.then((i)=>$6b019d9bd89ed96b$var$Ke(this.code, i));
        } else throw Error("Unknown type, must be binary type");
    }
}
const $6b019d9bd89ed96b$var$gi = (r)=>async (e)=>new Uint8Array(await crypto.subtle.digest(r, e)), $6b019d9bd89ed96b$var$fn = $6b019d9bd89ed96b$var$di({
    name: "sha2-256",
    code: 18,
    encode: $6b019d9bd89ed96b$var$gi("SHA-256")
}), $6b019d9bd89ed96b$var$Dn = $6b019d9bd89ed96b$var$di({
    name: "sha2-512",
    code: 19,
    encode: $6b019d9bd89ed96b$var$gi("SHA-512")
});
var $6b019d9bd89ed96b$var$vn = Object.freeze({
    __proto__: null,
    sha256: $6b019d9bd89ed96b$var$fn,
    sha512: $6b019d9bd89ed96b$var$Dn
});
const $6b019d9bd89ed96b$var$pi = 0, $6b019d9bd89ed96b$var$wn = "identity", $6b019d9bd89ed96b$var$yi = $6b019d9bd89ed96b$var$si, $6b019d9bd89ed96b$var$_n = (r)=>$6b019d9bd89ed96b$var$Ke($6b019d9bd89ed96b$var$pi, $6b019d9bd89ed96b$var$yi(r)), $6b019d9bd89ed96b$var$En = {
    code: $6b019d9bd89ed96b$var$pi,
    name: $6b019d9bd89ed96b$var$wn,
    encode: $6b019d9bd89ed96b$var$yi,
    digest: $6b019d9bd89ed96b$var$_n
};
var $6b019d9bd89ed96b$var$In = Object.freeze({
    __proto__: null,
    identity: $6b019d9bd89ed96b$var$En
});
new TextEncoder, new TextDecoder;
const $6b019d9bd89ed96b$var$bi = {
    ...$6b019d9bd89ed96b$var$yr,
    ...$6b019d9bd89ed96b$var$mr,
    ...$6b019d9bd89ed96b$var$Dr,
    ...$6b019d9bd89ed96b$var$wr,
    ...$6b019d9bd89ed96b$var$Ir,
    ...$6b019d9bd89ed96b$var$$r,
    ...$6b019d9bd89ed96b$var$kr,
    ...$6b019d9bd89ed96b$var$Fr,
    ...$6b019d9bd89ed96b$var$qr,
    ...$6b019d9bd89ed96b$var$Xr
};
({
    ...$6b019d9bd89ed96b$var$vn,
    ...$6b019d9bd89ed96b$var$In
});
function $6b019d9bd89ed96b$var$Tn(r = 0) {
    return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? globalThis.Buffer.allocUnsafe(r) : new Uint8Array(r);
}
function $6b019d9bd89ed96b$var$mi(r, e, t, i) {
    return {
        name: r,
        prefix: e,
        encoder: {
            name: r,
            prefix: e,
            encode: t
        },
        decoder: {
            decode: i
        }
    };
}
const $6b019d9bd89ed96b$var$fi = $6b019d9bd89ed96b$var$mi("utf8", "u", (r)=>"u" + new TextDecoder("utf8").decode(r), (r)=>new TextEncoder().encode(r.substring(1))), $6b019d9bd89ed96b$var$Be = $6b019d9bd89ed96b$var$mi("ascii", "a", (r)=>{
    let e = "a";
    for(let t = 0; t < r.length; t++)e += String.fromCharCode(r[t]);
    return e;
}, (r)=>{
    r = r.substring(1);
    const e = $6b019d9bd89ed96b$var$Tn(r.length);
    for(let t = 0; t < r.length; t++)e[t] = r.charCodeAt(t);
    return e;
}), $6b019d9bd89ed96b$var$Cn = {
    utf8: $6b019d9bd89ed96b$var$fi,
    "utf-8": $6b019d9bd89ed96b$var$fi,
    hex: $6b019d9bd89ed96b$var$bi.base16,
    latin1: $6b019d9bd89ed96b$var$Be,
    ascii: $6b019d9bd89ed96b$var$Be,
    binary: $6b019d9bd89ed96b$var$Be,
    ...$6b019d9bd89ed96b$var$bi
};
function $6b019d9bd89ed96b$var$Pn(r, e = "utf8") {
    const t = $6b019d9bd89ed96b$var$Cn[e];
    if (!t) throw new Error(`Unsupported encoding "${e}"`);
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? globalThis.Buffer.from(r, "utf8") : t.decoder.decode(`${t.prefix}${r}`);
}
var $6b019d9bd89ed96b$var$Sn = Object.defineProperty, $6b019d9bd89ed96b$var$Rn = (r, e, t)=>e in r ? $6b019d9bd89ed96b$var$Sn(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $6b019d9bd89ed96b$var$W = (r, e, t)=>$6b019d9bd89ed96b$var$Rn(r, typeof e != "symbol" ? e + "" : e, t);
class $6b019d9bd89ed96b$export$dd4508d2540f08d3 {
    constructor(e, t){
        this.core = e, this.logger = t, $6b019d9bd89ed96b$var$W(this, "keychain", new Map), $6b019d9bd89ed96b$var$W(this, "name", $6b019d9bd89ed96b$export$9d7218f72e8dc49b), $6b019d9bd89ed96b$var$W(this, "version", $6b019d9bd89ed96b$export$34f82f4ba0c3d769), $6b019d9bd89ed96b$var$W(this, "initialized", !1), $6b019d9bd89ed96b$var$W(this, "storagePrefix", $6b019d9bd89ed96b$export$f258d29ae5e3d545), $6b019d9bd89ed96b$var$W(this, "init", async ()=>{
            if (!this.initialized) {
                const i = await this.getKeyChain();
                typeof i < "u" && (this.keychain = i), this.initialized = !0;
            }
        }), $6b019d9bd89ed96b$var$W(this, "has", (i)=>(this.isInitialized(), this.keychain.has(i))), $6b019d9bd89ed96b$var$W(this, "set", async (i, s)=>{
            this.isInitialized(), this.keychain.set(i, s), await this.persist();
        }), $6b019d9bd89ed96b$var$W(this, "get", (i)=>{
            this.isInitialized();
            const s = this.keychain.get(i);
            if (typeof s > "u") {
                const { message: n } = (0, $3qpNA.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${i}`);
                throw new Error(n);
            }
            return s;
        }), $6b019d9bd89ed96b$var$W(this, "del", async (i)=>{
            this.isInitialized(), this.keychain.delete(i), await this.persist();
        }), this.core = e, this.logger = (0, $6GQzw.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $6GQzw.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    async setKeyChain(e) {
        await this.core.storage.setItem(this.storageKey, (0, $3qpNA.mapToObj)(e));
    }
    async getKeyChain() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $3qpNA.objToMap)(e) : void 0;
    }
    async persist() {
        await this.setKeyChain(this.keychain);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $3qpNA.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
var $6b019d9bd89ed96b$var$On = Object.defineProperty, $6b019d9bd89ed96b$var$An = (r, e, t)=>e in r ? $6b019d9bd89ed96b$var$On(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $6b019d9bd89ed96b$var$S = (r, e, t)=>$6b019d9bd89ed96b$var$An(r, typeof e != "symbol" ? e + "" : e, t);
class $6b019d9bd89ed96b$export$8ac8b6291b7ccf24 {
    constructor(e, t, i){
        this.core = e, this.logger = t, $6b019d9bd89ed96b$var$S(this, "name", $6b019d9bd89ed96b$export$92a79f21481c803d), $6b019d9bd89ed96b$var$S(this, "keychain"), $6b019d9bd89ed96b$var$S(this, "randomSessionIdentifier", (0, $3qpNA.generateRandomBytes32)()), $6b019d9bd89ed96b$var$S(this, "initialized", !1), $6b019d9bd89ed96b$var$S(this, "init", async ()=>{
            this.initialized || (await this.keychain.init(), this.initialized = !0);
        }), $6b019d9bd89ed96b$var$S(this, "hasKeys", (s)=>(this.isInitialized(), this.keychain.has(s))), $6b019d9bd89ed96b$var$S(this, "getClientId", async ()=>{
            this.isInitialized();
            const s = await this.getClientSeed(), n = $aKPeb.generateKeyPair(s);
            return $aKPeb.encodeIss(n.publicKey);
        }), $6b019d9bd89ed96b$var$S(this, "generateKeyPair", ()=>{
            this.isInitialized();
            const s = (0, $3qpNA.generateKeyPair)();
            return this.setPrivateKey(s.publicKey, s.privateKey);
        }), $6b019d9bd89ed96b$var$S(this, "signJWT", async (s)=>{
            this.isInitialized();
            const n = await this.getClientSeed(), o = $aKPeb.generateKeyPair(n), a = this.randomSessionIdentifier, c = $6b019d9bd89ed96b$export$c4bc5e31a4d0ec78;
            return await $aKPeb.signJWT(a, s, c, o);
        }), $6b019d9bd89ed96b$var$S(this, "generateSharedKey", (s, n, o)=>{
            this.isInitialized();
            const a = this.getPrivateKey(s), c = (0, $3qpNA.deriveSymKey)(a, n);
            return this.setSymKey(c, o);
        }), $6b019d9bd89ed96b$var$S(this, "setSymKey", async (s, n)=>{
            this.isInitialized();
            const o = n || (0, $3qpNA.hashKey)(s);
            return await this.keychain.set(o, s), o;
        }), $6b019d9bd89ed96b$var$S(this, "deleteKeyPair", async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }), $6b019d9bd89ed96b$var$S(this, "deleteSymKey", async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }), $6b019d9bd89ed96b$var$S(this, "encode", async (s, n, o)=>{
            this.isInitialized();
            const a = (0, $3qpNA.validateEncoding)(o), c = (0, $bREX4.safeJsonStringify)(n);
            if ((0, $3qpNA.isTypeTwoEnvelope)(a)) return (0, $3qpNA.encodeTypeTwoEnvelope)(c, o?.encoding);
            if ((0, $3qpNA.isTypeOneEnvelope)(a)) {
                const g = a.senderPublicKey, _ = a.receiverPublicKey;
                s = await this.generateSharedKey(g, _);
            }
            const h = this.getSymKey(s), { type: l, senderPublicKey: d } = a;
            return (0, $3qpNA.encrypt)({
                type: l,
                symKey: h,
                message: c,
                senderPublicKey: d,
                encoding: o?.encoding
            });
        }), $6b019d9bd89ed96b$var$S(this, "decode", async (s, n, o)=>{
            this.isInitialized();
            const a = (0, $3qpNA.validateDecoding)(n, o);
            if ((0, $3qpNA.isTypeTwoEnvelope)(a)) {
                const c = (0, $3qpNA.decodeTypeTwoEnvelope)(n, o?.encoding);
                return (0, $bREX4.safeJsonParse)(c);
            }
            if ((0, $3qpNA.isTypeOneEnvelope)(a)) {
                const c = a.receiverPublicKey, h = a.senderPublicKey;
                s = await this.generateSharedKey(c, h);
            }
            try {
                const c = this.getSymKey(s), h = (0, $3qpNA.decrypt)({
                    symKey: c,
                    encoded: n,
                    encoding: o?.encoding
                });
                return (0, $bREX4.safeJsonParse)(h);
            } catch (c) {
                this.logger.error(`Failed to decode message from topic: '${s}', clientId: '${await this.getClientId()}'`), this.logger.error(c);
            }
        }), $6b019d9bd89ed96b$var$S(this, "getPayloadType", (s, n = (0, $3qpNA.BASE64))=>{
            const o = (0, $3qpNA.deserialize)({
                encoded: s,
                encoding: n
            });
            return (0, $3qpNA.decodeTypeByte)(o.type);
        }), $6b019d9bd89ed96b$var$S(this, "getPayloadSenderPublicKey", (s, n = (0, $3qpNA.BASE64))=>{
            const o = (0, $3qpNA.deserialize)({
                encoded: s,
                encoding: n
            });
            return o.senderPublicKey ? (0, $iH58P.toString)(o.senderPublicKey, (0, $3qpNA.BASE16)) : void 0;
        }), this.core = e, this.logger = (0, $6GQzw.generateChildLogger)(t, this.name), this.keychain = i || new $6b019d9bd89ed96b$export$dd4508d2540f08d3(this.core, this.logger);
    }
    get context() {
        return (0, $6GQzw.getLoggerContext)(this.logger);
    }
    async setPrivateKey(e, t) {
        return await this.keychain.set(e, t), e;
    }
    getPrivateKey(e) {
        return this.keychain.get(e);
    }
    async getClientSeed() {
        let e = "";
        try {
            e = this.keychain.get($6b019d9bd89ed96b$export$3613aa6e652146e4);
        } catch  {
            e = (0, $3qpNA.generateRandomBytes32)(), await this.keychain.set($6b019d9bd89ed96b$export$3613aa6e652146e4, e);
        }
        return $6b019d9bd89ed96b$var$Pn(e, "base16");
    }
    getSymKey(e) {
        return this.keychain.get(e);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $3qpNA.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
var $6b019d9bd89ed96b$var$xn = Object.defineProperty, $6b019d9bd89ed96b$var$Nn = Object.defineProperties, $6b019d9bd89ed96b$var$$n = Object.getOwnPropertyDescriptors, $6b019d9bd89ed96b$var$wi = Object.getOwnPropertySymbols, $6b019d9bd89ed96b$var$zn = Object.prototype.hasOwnProperty, $6b019d9bd89ed96b$var$Ln = Object.prototype.propertyIsEnumerable, $6b019d9bd89ed96b$var$Ve = (r, e, t)=>e in r ? $6b019d9bd89ed96b$var$xn(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $6b019d9bd89ed96b$var$kn = (r, e)=>{
    for(var t in e || (e = {}))$6b019d9bd89ed96b$var$zn.call(e, t) && $6b019d9bd89ed96b$var$Ve(r, t, e[t]);
    if ($6b019d9bd89ed96b$var$wi) for (var t of $6b019d9bd89ed96b$var$wi(e))$6b019d9bd89ed96b$var$Ln.call(e, t) && $6b019d9bd89ed96b$var$Ve(r, t, e[t]);
    return r;
}, $6b019d9bd89ed96b$var$jn = (r, e)=>$6b019d9bd89ed96b$var$Nn(r, $6b019d9bd89ed96b$var$$n(e)), $6b019d9bd89ed96b$var$k = (r, e, t)=>$6b019d9bd89ed96b$var$Ve(r, typeof e != "symbol" ? e + "" : e, t);
class $6b019d9bd89ed96b$export$4a2542d0790ac2fd extends (0, $2B80D.IMessageTracker) {
    constructor(e, t){
        super(e, t), this.logger = e, this.core = t, $6b019d9bd89ed96b$var$k(this, "messages", new Map), $6b019d9bd89ed96b$var$k(this, "messagesWithoutClientAck", new Map), $6b019d9bd89ed96b$var$k(this, "name", $6b019d9bd89ed96b$export$9662bbc7d10cf481), $6b019d9bd89ed96b$var$k(this, "version", $6b019d9bd89ed96b$export$19dfd1896412c038), $6b019d9bd89ed96b$var$k(this, "initialized", !1), $6b019d9bd89ed96b$var$k(this, "storagePrefix", $6b019d9bd89ed96b$export$f258d29ae5e3d545), $6b019d9bd89ed96b$var$k(this, "init", async ()=>{
            if (!this.initialized) {
                this.logger.trace("Initialized");
                try {
                    const i = await this.getRelayerMessages();
                    typeof i < "u" && (this.messages = i);
                    const s = await this.getRelayerMessagesWithoutClientAck();
                    typeof s < "u" && (this.messagesWithoutClientAck = s), this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                        type: "method",
                        method: "restore",
                        size: this.messages.size
                    });
                } catch (i) {
                    this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(i);
                } finally{
                    this.initialized = !0;
                }
            }
        }), $6b019d9bd89ed96b$var$k(this, "set", async (i, s, n)=>{
            this.isInitialized();
            const o = (0, $3qpNA.hashMessage)(s);
            let a = this.messages.get(i);
            if (typeof a > "u" && (a = {}), typeof a[o] < "u") return o;
            if (a[o] = s, this.messages.set(i, a), n === $6b019d9bd89ed96b$export$5c65dd72e0f566ab.inbound) {
                const c = this.messagesWithoutClientAck.get(i) || {};
                this.messagesWithoutClientAck.set(i, $6b019d9bd89ed96b$var$jn($6b019d9bd89ed96b$var$kn({}, c), {
                    [o]: s
                }));
            }
            return await this.persist(), o;
        }), $6b019d9bd89ed96b$var$k(this, "get", (i)=>{
            this.isInitialized();
            let s = this.messages.get(i);
            return typeof s > "u" && (s = {}), s;
        }), $6b019d9bd89ed96b$var$k(this, "getWithoutAck", (i)=>{
            this.isInitialized();
            const s = {};
            for (const n of i){
                const o = this.messagesWithoutClientAck.get(n) || {};
                s[n] = Object.values(o);
            }
            return s;
        }), $6b019d9bd89ed96b$var$k(this, "has", (i, s)=>{
            this.isInitialized();
            const n = this.get(i), o = (0, $3qpNA.hashMessage)(s);
            return typeof n[o] < "u";
        }), $6b019d9bd89ed96b$var$k(this, "ack", async (i, s)=>{
            this.isInitialized();
            const n = this.messagesWithoutClientAck.get(i);
            if (typeof n > "u") return;
            const o = (0, $3qpNA.hashMessage)(s);
            delete n[o], Object.keys(n).length === 0 ? this.messagesWithoutClientAck.delete(i) : this.messagesWithoutClientAck.set(i, n), await this.persist();
        }), $6b019d9bd89ed96b$var$k(this, "del", async (i)=>{
            this.isInitialized(), this.messages.delete(i), this.messagesWithoutClientAck.delete(i), await this.persist();
        }), this.logger = (0, $6GQzw.generateChildLogger)(e, this.name), this.core = t;
    }
    get context() {
        return (0, $6GQzw.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get storageKeyWithoutClientAck() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name + "_withoutClientAck";
    }
    async setRelayerMessages(e) {
        await this.core.storage.setItem(this.storageKey, (0, $3qpNA.mapToObj)(e));
    }
    async setRelayerMessagesWithoutClientAck(e) {
        await this.core.storage.setItem(this.storageKeyWithoutClientAck, (0, $3qpNA.mapToObj)(e));
    }
    async getRelayerMessages() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $3qpNA.objToMap)(e) : void 0;
    }
    async getRelayerMessagesWithoutClientAck() {
        const e = await this.core.storage.getItem(this.storageKeyWithoutClientAck);
        return typeof e < "u" ? (0, $3qpNA.objToMap)(e) : void 0;
    }
    async persist() {
        await this.setRelayerMessages(this.messages), await this.setRelayerMessagesWithoutClientAck(this.messagesWithoutClientAck);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $3qpNA.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
var $6b019d9bd89ed96b$var$Un = Object.defineProperty, $6b019d9bd89ed96b$var$Fn = Object.defineProperties, $6b019d9bd89ed96b$var$Mn = Object.getOwnPropertyDescriptors, $6b019d9bd89ed96b$var$Ei = Object.getOwnPropertySymbols, $6b019d9bd89ed96b$var$Kn = Object.prototype.hasOwnProperty, $6b019d9bd89ed96b$var$Bn = Object.prototype.propertyIsEnumerable, $6b019d9bd89ed96b$var$qe = (r, e, t)=>e in r ? $6b019d9bd89ed96b$var$Un(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $6b019d9bd89ed96b$var$Ie = (r, e)=>{
    for(var t in e || (e = {}))$6b019d9bd89ed96b$var$Kn.call(e, t) && $6b019d9bd89ed96b$var$qe(r, t, e[t]);
    if ($6b019d9bd89ed96b$var$Ei) for (var t of $6b019d9bd89ed96b$var$Ei(e))$6b019d9bd89ed96b$var$Bn.call(e, t) && $6b019d9bd89ed96b$var$qe(r, t, e[t]);
    return r;
}, $6b019d9bd89ed96b$var$Ge = (r, e)=>$6b019d9bd89ed96b$var$Fn(r, $6b019d9bd89ed96b$var$Mn(e)), $6b019d9bd89ed96b$var$V = (r, e, t)=>$6b019d9bd89ed96b$var$qe(r, typeof e != "symbol" ? e + "" : e, t);
class $6b019d9bd89ed96b$var$Vn extends (0, $2B80D.IPublisher) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, $6b019d9bd89ed96b$var$V(this, "events", new (0, $5yFVO.EventEmitter)), $6b019d9bd89ed96b$var$V(this, "name", $6b019d9bd89ed96b$export$9d92662178f2abd1), $6b019d9bd89ed96b$var$V(this, "queue", new Map), $6b019d9bd89ed96b$var$V(this, "publishTimeout", (0, $9eyak.toMiliseconds)((0, $9eyak.ONE_MINUTE))), $6b019d9bd89ed96b$var$V(this, "initialPublishTimeout", (0, $9eyak.toMiliseconds)((0, $9eyak.ONE_SECOND) * 15)), $6b019d9bd89ed96b$var$V(this, "needsTransportRestart", !1), $6b019d9bd89ed96b$var$V(this, "publish", async (i, s, n)=>{
            var o;
            this.logger.debug("Publishing Payload"), this.logger.trace({
                type: "method",
                method: "publish",
                params: {
                    topic: i,
                    message: s,
                    opts: n
                }
            });
            const a = n?.ttl || $6b019d9bd89ed96b$export$8ddbe6611b67d926, c = (0, $3qpNA.getRelayProtocolName)(n), h = n?.prompt || !1, l = n?.tag || 0, d = n?.id || (0, $fHodW.getBigIntRpcId)().toString(), g = {
                topic: i,
                message: s,
                opts: {
                    ttl: a,
                    relay: c,
                    prompt: h,
                    tag: l,
                    id: d,
                    attestation: n?.attestation,
                    tvf: n?.tvf
                }
            }, _ = `Failed to publish payload, please try again. id:${d} tag:${l}`;
            try {
                const u = new Promise(async (b)=>{
                    const x = ({ id: D })=>{
                        g.opts.id === D && (this.removeRequestFromQueue(D), this.relayer.events.removeListener($6b019d9bd89ed96b$export$d56245796e2837d.publish, x), b(g));
                    };
                    this.relayer.events.on($6b019d9bd89ed96b$export$d56245796e2837d.publish, x);
                    const I = (0, $3qpNA.createExpiringPromise)(new Promise((D, j)=>{
                        this.rpcPublish({
                            topic: i,
                            message: s,
                            ttl: a,
                            prompt: h,
                            tag: l,
                            id: d,
                            attestation: n?.attestation,
                            tvf: n?.tvf
                        }).then(D).catch((T)=>{
                            this.logger.warn(T, T?.message), j(T);
                        });
                    }), this.initialPublishTimeout, `Failed initial publish, retrying.... id:${d} tag:${l}`);
                    try {
                        await I, this.events.removeListener($6b019d9bd89ed96b$export$d56245796e2837d.publish, x);
                    } catch (D) {
                        this.queue.set(d, $6b019d9bd89ed96b$var$Ge($6b019d9bd89ed96b$var$Ie({}, g), {
                            attempt: 1
                        })), this.logger.warn(D, D?.message);
                    }
                });
                this.logger.trace({
                    type: "method",
                    method: "publish",
                    params: {
                        id: d,
                        topic: i,
                        message: s,
                        opts: n
                    }
                }), await (0, $3qpNA.createExpiringPromise)(u, this.publishTimeout, _);
            } catch (u) {
                if (this.logger.debug("Failed to Publish Payload"), this.logger.error(u), (o = n?.internal) != null && o.throwOnFailedPublish) throw u;
            } finally{
                this.queue.delete(d);
            }
        }), $6b019d9bd89ed96b$var$V(this, "on", (i, s)=>{
            this.events.on(i, s);
        }), $6b019d9bd89ed96b$var$V(this, "once", (i, s)=>{
            this.events.once(i, s);
        }), $6b019d9bd89ed96b$var$V(this, "off", (i, s)=>{
            this.events.off(i, s);
        }), $6b019d9bd89ed96b$var$V(this, "removeListener", (i, s)=>{
            this.events.removeListener(i, s);
        }), this.relayer = e, this.logger = (0, $6GQzw.generateChildLogger)(t, this.name), this.registerEventListeners();
    }
    get context() {
        return (0, $6GQzw.getLoggerContext)(this.logger);
    }
    async rpcPublish(e) {
        var t, i, s, n;
        const { topic: o, message: a, ttl: c = $6b019d9bd89ed96b$export$8ddbe6611b67d926, prompt: h, tag: l, id: d, attestation: g, tvf: _ } = e, u = {
            method: (0, $3qpNA.getRelayProtocolApi)((0, $3qpNA.getRelayProtocolName)().protocol).publish,
            params: $6b019d9bd89ed96b$var$Ie({
                topic: o,
                message: a,
                ttl: c,
                prompt: h,
                tag: l,
                attestation: g
            }, _),
            id: d
        };
        (0, $3qpNA.isUndefined)((t = u.params) == null ? void 0 : t.prompt) && ((i = u.params) == null || delete i.prompt), (0, $3qpNA.isUndefined)((s = u.params) == null ? void 0 : s.tag) && ((n = u.params) == null || delete n.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "message",
            direction: "outgoing",
            request: u
        });
        const b = await this.relayer.request(u);
        return this.relayer.events.emit($6b019d9bd89ed96b$export$d56245796e2837d.publish, e), this.logger.debug("Successfully Published Payload"), b;
    }
    removeRequestFromQueue(e) {
        this.queue.delete(e);
    }
    checkQueue() {
        this.queue.forEach(async (e, t)=>{
            const i = e.attempt + 1;
            this.queue.set(t, $6b019d9bd89ed96b$var$Ge($6b019d9bd89ed96b$var$Ie({}, e), {
                attempt: i
            }));
            const { topic: s, message: n, opts: o, attestation: a } = e;
            this.logger.warn({}, `Publisher: queue->publishing: ${e.opts.id}, tag: ${e.opts.tag}, attempt: ${i}`), await this.rpcPublish($6b019d9bd89ed96b$var$Ge($6b019d9bd89ed96b$var$Ie({}, e), {
                topic: s,
                message: n,
                ttl: o.ttl,
                prompt: o.prompt,
                tag: o.tag,
                id: o.id,
                attestation: a,
                tvf: o.tvf
            })), this.logger.warn({}, `Publisher: queue->published: ${e.opts.id}`);
        });
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $7G2F6.HEARTBEAT_EVENTS).pulse, ()=>{
            if (this.needsTransportRestart) {
                this.needsTransportRestart = !1, this.relayer.events.emit($6b019d9bd89ed96b$export$d56245796e2837d.connection_stalled);
                return;
            }
            this.checkQueue();
        }), this.relayer.on($6b019d9bd89ed96b$export$d56245796e2837d.message_ack, (e)=>{
            this.removeRequestFromQueue(e.id.toString());
        });
    }
}
var $6b019d9bd89ed96b$var$qn = Object.defineProperty, $6b019d9bd89ed96b$var$Gn = (r, e, t)=>e in r ? $6b019d9bd89ed96b$var$qn(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $6b019d9bd89ed96b$var$re = (r, e, t)=>$6b019d9bd89ed96b$var$Gn(r, typeof e != "symbol" ? e + "" : e, t);
class $6b019d9bd89ed96b$var$Wn {
    constructor(){
        $6b019d9bd89ed96b$var$re(this, "map", new Map), $6b019d9bd89ed96b$var$re(this, "set", (e, t)=>{
            const i = this.get(e);
            this.exists(e, t) || this.map.set(e, [
                ...i,
                t
            ]);
        }), $6b019d9bd89ed96b$var$re(this, "get", (e)=>this.map.get(e) || []), $6b019d9bd89ed96b$var$re(this, "exists", (e, t)=>this.get(e).includes(t)), $6b019d9bd89ed96b$var$re(this, "delete", (e, t)=>{
            if (typeof t > "u") {
                this.map.delete(e);
                return;
            }
            if (!this.map.has(e)) return;
            const i = this.get(e);
            if (!this.exists(e, t)) return;
            const s = i.filter((n)=>n !== t);
            if (!s.length) {
                this.map.delete(e);
                return;
            }
            this.map.set(e, s);
        }), $6b019d9bd89ed96b$var$re(this, "clear", ()=>{
            this.map.clear();
        });
    }
    get topics() {
        return Array.from(this.map.keys());
    }
}
var $6b019d9bd89ed96b$var$Hn = Object.defineProperty, $6b019d9bd89ed96b$var$Yn = Object.defineProperties, $6b019d9bd89ed96b$var$Jn = Object.getOwnPropertyDescriptors, $6b019d9bd89ed96b$var$Ii = Object.getOwnPropertySymbols, $6b019d9bd89ed96b$var$Xn = Object.prototype.hasOwnProperty, $6b019d9bd89ed96b$var$Zn = Object.prototype.propertyIsEnumerable, $6b019d9bd89ed96b$var$We = (r, e, t)=>e in r ? $6b019d9bd89ed96b$var$Hn(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $6b019d9bd89ed96b$var$ge = (r, e)=>{
    for(var t in e || (e = {}))$6b019d9bd89ed96b$var$Xn.call(e, t) && $6b019d9bd89ed96b$var$We(r, t, e[t]);
    if ($6b019d9bd89ed96b$var$Ii) for (var t of $6b019d9bd89ed96b$var$Ii(e))$6b019d9bd89ed96b$var$Zn.call(e, t) && $6b019d9bd89ed96b$var$We(r, t, e[t]);
    return r;
}, $6b019d9bd89ed96b$var$He = (r, e)=>$6b019d9bd89ed96b$var$Yn(r, $6b019d9bd89ed96b$var$Jn(e)), $6b019d9bd89ed96b$var$f = (r, e, t)=>$6b019d9bd89ed96b$var$We(r, typeof e != "symbol" ? e + "" : e, t);
class $6b019d9bd89ed96b$export$60959659b2c22881 extends (0, $2B80D.ISubscriber) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, $6b019d9bd89ed96b$var$f(this, "subscriptions", new Map), $6b019d9bd89ed96b$var$f(this, "topicMap", new $6b019d9bd89ed96b$var$Wn), $6b019d9bd89ed96b$var$f(this, "events", new (0, $5yFVO.EventEmitter)), $6b019d9bd89ed96b$var$f(this, "name", $6b019d9bd89ed96b$export$9c3a96bb670cddb8), $6b019d9bd89ed96b$var$f(this, "version", $6b019d9bd89ed96b$export$fb57e03bef4c4cea), $6b019d9bd89ed96b$var$f(this, "pending", new Map), $6b019d9bd89ed96b$var$f(this, "cached", []), $6b019d9bd89ed96b$var$f(this, "initialized", !1), $6b019d9bd89ed96b$var$f(this, "storagePrefix", $6b019d9bd89ed96b$export$f258d29ae5e3d545), $6b019d9bd89ed96b$var$f(this, "subscribeTimeout", (0, $9eyak.toMiliseconds)((0, $9eyak.ONE_MINUTE))), $6b019d9bd89ed96b$var$f(this, "initialSubscribeTimeout", (0, $9eyak.toMiliseconds)((0, $9eyak.ONE_SECOND) * 15)), $6b019d9bd89ed96b$var$f(this, "clientId"), $6b019d9bd89ed96b$var$f(this, "batchSubscribeTopicsLimit", 500), $6b019d9bd89ed96b$var$f(this, "init", async ()=>{
            this.initialized || (this.logger.trace("Initialized"), this.registerEventListeners(), await this.restore()), this.initialized = !0;
        }), $6b019d9bd89ed96b$var$f(this, "subscribe", async (i, s)=>{
            this.isInitialized(), this.logger.debug("Subscribing Topic"), this.logger.trace({
                type: "method",
                method: "subscribe",
                params: {
                    topic: i,
                    opts: s
                }
            });
            try {
                const n = (0, $3qpNA.getRelayProtocolName)(s), o = {
                    topic: i,
                    relay: n,
                    transportType: s?.transportType
                };
                this.pending.set(i, o);
                const a = await this.rpcSubscribe(i, n, s);
                return typeof a == "string" && (this.onSubscribe(a, o), this.logger.debug("Successfully Subscribed Topic"), this.logger.trace({
                    type: "method",
                    method: "subscribe",
                    params: {
                        topic: i,
                        opts: s
                    }
                })), a;
            } catch (n) {
                throw this.logger.debug("Failed to Subscribe Topic"), this.logger.error(n), n;
            }
        }), $6b019d9bd89ed96b$var$f(this, "unsubscribe", async (i, s)=>{
            this.isInitialized(), typeof s?.id < "u" ? await this.unsubscribeById(i, s.id, s) : await this.unsubscribeByTopic(i, s);
        }), $6b019d9bd89ed96b$var$f(this, "isSubscribed", (i)=>new Promise((s)=>{
                s(this.topicMap.topics.includes(i));
            })), $6b019d9bd89ed96b$var$f(this, "isKnownTopic", (i)=>new Promise((s)=>{
                s(this.topicMap.topics.includes(i) || this.pending.has(i) || this.cached.some((n)=>n.topic === i));
            })), $6b019d9bd89ed96b$var$f(this, "on", (i, s)=>{
            this.events.on(i, s);
        }), $6b019d9bd89ed96b$var$f(this, "once", (i, s)=>{
            this.events.once(i, s);
        }), $6b019d9bd89ed96b$var$f(this, "off", (i, s)=>{
            this.events.off(i, s);
        }), $6b019d9bd89ed96b$var$f(this, "removeListener", (i, s)=>{
            this.events.removeListener(i, s);
        }), $6b019d9bd89ed96b$var$f(this, "start", async ()=>{
            await this.onConnect();
        }), $6b019d9bd89ed96b$var$f(this, "stop", async ()=>{
            await this.onDisconnect();
        }), $6b019d9bd89ed96b$var$f(this, "restart", async ()=>{
            await this.restore(), await this.onRestart();
        }), $6b019d9bd89ed96b$var$f(this, "checkPending", async ()=>{
            if (this.pending.size === 0 && (!this.initialized || !this.relayer.connected)) return;
            const i = [];
            this.pending.forEach((s)=>{
                i.push(s);
            }), await this.batchSubscribe(i);
        }), $6b019d9bd89ed96b$var$f(this, "registerEventListeners", ()=>{
            this.relayer.core.heartbeat.on((0, $7G2F6.HEARTBEAT_EVENTS).pulse, async ()=>{
                await this.checkPending();
            }), this.events.on($6b019d9bd89ed96b$export$24ff3e54e94ef413.created, async (i)=>{
                const s = $6b019d9bd89ed96b$export$24ff3e54e94ef413.created;
                this.logger.info(`Emitting ${s}`), this.logger.debug({
                    type: "event",
                    event: s,
                    data: i
                }), await this.persist();
            }), this.events.on($6b019d9bd89ed96b$export$24ff3e54e94ef413.deleted, async (i)=>{
                const s = $6b019d9bd89ed96b$export$24ff3e54e94ef413.deleted;
                this.logger.info(`Emitting ${s}`), this.logger.debug({
                    type: "event",
                    event: s,
                    data: i
                }), await this.persist();
            });
        }), this.relayer = e, this.logger = (0, $6GQzw.generateChildLogger)(t, this.name), this.clientId = "";
    }
    get context() {
        return (0, $6GQzw.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.relayer.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.subscriptions.size;
    }
    get ids() {
        return Array.from(this.subscriptions.keys());
    }
    get values() {
        return Array.from(this.subscriptions.values());
    }
    get topics() {
        return this.topicMap.topics;
    }
    get hasAnyTopics() {
        return this.topicMap.topics.length > 0 || this.pending.size > 0 || this.cached.length > 0 || this.subscriptions.size > 0;
    }
    hasSubscription(e, t) {
        let i = !1;
        try {
            i = this.getSubscription(e).topic === t;
        } catch  {}
        return i;
    }
    reset() {
        this.cached = [], this.initialized = !0;
    }
    onDisable() {
        this.values.length > 0 && (this.cached = this.values), this.subscriptions.clear(), this.topicMap.clear();
    }
    async unsubscribeByTopic(e, t) {
        const i = this.topicMap.get(e);
        await Promise.all(i.map(async (s)=>await this.unsubscribeById(e, s, t)));
    }
    async unsubscribeById(e, t, i) {
        this.logger.debug("Unsubscribing Topic"), this.logger.trace({
            type: "method",
            method: "unsubscribe",
            params: {
                topic: e,
                id: t,
                opts: i
            }
        });
        try {
            const s = (0, $3qpNA.getRelayProtocolName)(i);
            await this.restartToComplete({
                topic: e,
                id: t,
                relay: s
            }), await this.rpcUnsubscribe(e, t, s);
            const n = (0, $3qpNA.getSdkError)("USER_DISCONNECTED", `${this.name}, ${e}`);
            await this.onUnsubscribe(e, t, n), this.logger.debug("Successfully Unsubscribed Topic"), this.logger.trace({
                type: "method",
                method: "unsubscribe",
                params: {
                    topic: e,
                    id: t,
                    opts: i
                }
            });
        } catch (s) {
            throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(s), s;
        }
    }
    async rpcSubscribe(e, t, i) {
        var s;
        (!i || i?.transportType === $6b019d9bd89ed96b$export$326e296bb8673773.relay) && await this.restartToComplete({
            topic: e,
            id: e,
            relay: t
        });
        const n = {
            method: (0, $3qpNA.getRelayProtocolApi)(t.protocol).subscribe,
            params: {
                topic: e
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: n
        });
        const o = (s = i?.internal) == null ? void 0 : s.throwOnFailedPublish;
        try {
            const a = await this.getSubscriptionId(e);
            if (i?.transportType === $6b019d9bd89ed96b$export$326e296bb8673773.link_mode) return setTimeout(()=>{
                (this.relayer.connected || this.relayer.connecting) && this.relayer.request(n).catch((l)=>this.logger.warn(l));
            }, (0, $9eyak.toMiliseconds)((0, $9eyak.ONE_SECOND))), a;
            const c = new Promise(async (l)=>{
                const d = (g)=>{
                    g.topic === e && (this.events.removeListener($6b019d9bd89ed96b$export$24ff3e54e94ef413.created, d), l(g.id));
                };
                this.events.on($6b019d9bd89ed96b$export$24ff3e54e94ef413.created, d);
                try {
                    const g = await (0, $3qpNA.createExpiringPromise)(new Promise((_, u)=>{
                        this.relayer.request(n).catch((b)=>{
                            this.logger.warn(b, b?.message), u(b);
                        }).then(_);
                    }), this.initialSubscribeTimeout, `Subscribing to ${e} failed, please try again`);
                    this.events.removeListener($6b019d9bd89ed96b$export$24ff3e54e94ef413.created, d), l(g);
                } catch  {}
            }), h = await (0, $3qpNA.createExpiringPromise)(c, this.subscribeTimeout, `Subscribing to ${e} failed, please try again`);
            if (!h && o) throw new Error(`Subscribing to ${e} failed, please try again`);
            return h ? a : null;
        } catch (a) {
            if (this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit($6b019d9bd89ed96b$export$d56245796e2837d.connection_stalled), o) throw a;
        }
        return null;
    }
    async rpcBatchSubscribe(e) {
        if (!e.length) return;
        const t = e[0].relay, i = {
            method: (0, $3qpNA.getRelayProtocolApi)(t.protocol).batchSubscribe,
            params: {
                topics: e.map((s)=>s.topic)
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            await await (0, $3qpNA.createExpiringPromise)(new Promise((s)=>{
                this.relayer.request(i).catch((n)=>this.logger.warn(n)).then(s);
            }), this.subscribeTimeout, "rpcBatchSubscribe failed, please try again");
        } catch  {
            this.relayer.events.emit($6b019d9bd89ed96b$export$d56245796e2837d.connection_stalled);
        }
    }
    async rpcBatchFetchMessages(e) {
        if (!e.length) return;
        const t = e[0].relay, i = {
            method: (0, $3qpNA.getRelayProtocolApi)(t.protocol).batchFetchMessages,
            params: {
                topics: e.map((n)=>n.topic)
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        let s;
        try {
            s = await await (0, $3qpNA.createExpiringPromise)(new Promise((n, o)=>{
                this.relayer.request(i).catch((a)=>{
                    this.logger.warn(a), o(a);
                }).then(n);
            }), this.subscribeTimeout, "rpcBatchFetchMessages failed, please try again");
        } catch  {
            this.relayer.events.emit($6b019d9bd89ed96b$export$d56245796e2837d.connection_stalled);
        }
        return s;
    }
    rpcUnsubscribe(e, t, i) {
        const s = {
            method: (0, $3qpNA.getRelayProtocolApi)(i.protocol).unsubscribe,
            params: {
                topic: e,
                id: t
            }
        };
        return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: s
        }), this.relayer.request(s);
    }
    onSubscribe(e, t) {
        this.setSubscription(e, $6b019d9bd89ed96b$var$He($6b019d9bd89ed96b$var$ge({}, t), {
            id: e
        })), this.pending.delete(t.topic);
    }
    onBatchSubscribe(e) {
        e.length && e.forEach((t)=>{
            this.setSubscription(t.id, $6b019d9bd89ed96b$var$ge({}, t)), this.pending.delete(t.topic);
        });
    }
    async onUnsubscribe(e, t, i) {
        this.events.removeAllListeners(t), this.hasSubscription(t, e) && this.deleteSubscription(t, i), await this.relayer.messages.del(e);
    }
    async setRelayerSubscriptions(e) {
        await this.relayer.core.storage.setItem(this.storageKey, e);
    }
    async getRelayerSubscriptions() {
        return await this.relayer.core.storage.getItem(this.storageKey);
    }
    setSubscription(e, t) {
        this.logger.debug("Setting subscription"), this.logger.trace({
            type: "method",
            method: "setSubscription",
            id: e,
            subscription: t
        }), this.addSubscription(e, t);
    }
    addSubscription(e, t) {
        this.subscriptions.set(e, $6b019d9bd89ed96b$var$ge({}, t)), this.topicMap.set(t.topic, e), this.events.emit($6b019d9bd89ed96b$export$24ff3e54e94ef413.created, t);
    }
    getSubscription(e) {
        this.logger.debug("Getting subscription"), this.logger.trace({
            type: "method",
            method: "getSubscription",
            id: e
        });
        const t = this.subscriptions.get(e);
        if (!t) {
            const { message: i } = (0, $3qpNA.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    deleteSubscription(e, t) {
        this.logger.debug("Deleting subscription"), this.logger.trace({
            type: "method",
            method: "deleteSubscription",
            id: e,
            reason: t
        });
        const i = this.getSubscription(e);
        this.subscriptions.delete(e), this.topicMap.delete(i.topic, e), this.events.emit($6b019d9bd89ed96b$export$24ff3e54e94ef413.deleted, $6b019d9bd89ed96b$var$He($6b019d9bd89ed96b$var$ge({}, i), {
            reason: t
        }));
    }
    async persist() {
        await this.setRelayerSubscriptions(this.values), this.events.emit($6b019d9bd89ed96b$export$24ff3e54e94ef413.sync);
    }
    async onRestart() {
        if (this.cached.length) {
            const e = [
                ...this.cached
            ], t = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
            for(let i = 0; i < t; i++){
                const s = e.splice(0, this.batchSubscribeTopicsLimit);
                await this.batchSubscribe(s);
            }
        }
        this.events.emit($6b019d9bd89ed96b$export$24ff3e54e94ef413.resubscribed);
    }
    async restore() {
        try {
            const e = await this.getRelayerSubscriptions();
            if (typeof e > "u" || !e.length) return;
            if (this.subscriptions.size) {
                const { message: t } = (0, $3qpNA.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored subscriptions for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                subscriptions: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore subscriptions for ${this.name}`), this.logger.error(e);
        }
    }
    async batchSubscribe(e) {
        e.length && (await this.rpcBatchSubscribe(e), this.onBatchSubscribe(await Promise.all(e.map(async (t)=>$6b019d9bd89ed96b$var$He($6b019d9bd89ed96b$var$ge({}, t), {
                id: await this.getSubscriptionId(t.topic)
            })))));
    }
    async batchFetchMessages(e) {
        if (!e.length) return;
        this.logger.trace(`Fetching batch messages for ${e.length} subscriptions`);
        const t = await this.rpcBatchFetchMessages(e);
        t && t.messages && (await (0, $3qpNA.sleep)((0, $9eyak.toMiliseconds)((0, $9eyak.ONE_SECOND))), await this.relayer.handleBatchMessageEvents(t.messages));
    }
    async onConnect() {
        await this.restart(), this.reset();
    }
    onDisconnect() {
        this.onDisable();
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $3qpNA.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async restartToComplete(e) {
        !this.relayer.connected && !this.relayer.connecting && (this.cached.push(e), await this.relayer.transportOpen());
    }
    async getClientId() {
        return this.clientId || (this.clientId = await this.relayer.core.crypto.getClientId()), this.clientId;
    }
    async getSubscriptionId(e) {
        return (0, $3qpNA.hashMessage)(e + await this.getClientId());
    }
}
var $6b019d9bd89ed96b$var$Qn = Object.defineProperty, $6b019d9bd89ed96b$var$Ci = Object.getOwnPropertySymbols, $6b019d9bd89ed96b$var$eo = Object.prototype.hasOwnProperty, $6b019d9bd89ed96b$var$to = Object.prototype.propertyIsEnumerable, $6b019d9bd89ed96b$var$Ye = (r, e, t)=>e in r ? $6b019d9bd89ed96b$var$Qn(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $6b019d9bd89ed96b$var$Pi = (r, e)=>{
    for(var t in e || (e = {}))$6b019d9bd89ed96b$var$eo.call(e, t) && $6b019d9bd89ed96b$var$Ye(r, t, e[t]);
    if ($6b019d9bd89ed96b$var$Ci) for (var t of $6b019d9bd89ed96b$var$Ci(e))$6b019d9bd89ed96b$var$to.call(e, t) && $6b019d9bd89ed96b$var$Ye(r, t, e[t]);
    return r;
}, $6b019d9bd89ed96b$var$y = (r, e, t)=>$6b019d9bd89ed96b$var$Ye(r, typeof e != "symbol" ? e + "" : e, t);
class $6b019d9bd89ed96b$export$70e73aa29a3d4407 extends (0, $2B80D.IRelayer) {
    constructor(e){
        super(e), $6b019d9bd89ed96b$var$y(this, "protocol", "wc"), $6b019d9bd89ed96b$var$y(this, "version", 2), $6b019d9bd89ed96b$var$y(this, "core"), $6b019d9bd89ed96b$var$y(this, "logger"), $6b019d9bd89ed96b$var$y(this, "events", new (0, $5yFVO.EventEmitter)), $6b019d9bd89ed96b$var$y(this, "provider"), $6b019d9bd89ed96b$var$y(this, "messages"), $6b019d9bd89ed96b$var$y(this, "subscriber"), $6b019d9bd89ed96b$var$y(this, "publisher"), $6b019d9bd89ed96b$var$y(this, "name", $6b019d9bd89ed96b$export$602d6e27611c3fcb), $6b019d9bd89ed96b$var$y(this, "transportExplicitlyClosed", !1), $6b019d9bd89ed96b$var$y(this, "initialized", !1), $6b019d9bd89ed96b$var$y(this, "connectionAttemptInProgress", !1), $6b019d9bd89ed96b$var$y(this, "relayUrl"), $6b019d9bd89ed96b$var$y(this, "projectId"), $6b019d9bd89ed96b$var$y(this, "packageName"), $6b019d9bd89ed96b$var$y(this, "bundleId"), $6b019d9bd89ed96b$var$y(this, "hasExperiencedNetworkDisruption", !1), $6b019d9bd89ed96b$var$y(this, "pingTimeout"), $6b019d9bd89ed96b$var$y(this, "heartBeatTimeout", (0, $9eyak.toMiliseconds)((0, $9eyak.THIRTY_SECONDS) + (0, $9eyak.FIVE_SECONDS))), $6b019d9bd89ed96b$var$y(this, "reconnectTimeout"), $6b019d9bd89ed96b$var$y(this, "connectPromise"), $6b019d9bd89ed96b$var$y(this, "reconnectInProgress", !1), $6b019d9bd89ed96b$var$y(this, "requestsInFlight", []), $6b019d9bd89ed96b$var$y(this, "connectTimeout", (0, $9eyak.toMiliseconds)((0, $9eyak.ONE_SECOND) * 15)), $6b019d9bd89ed96b$var$y(this, "request", async (t)=>{
            var i, s;
            this.logger.debug("Publishing Request Payload");
            const n = t.id || (0, $fHodW.getBigIntRpcId)().toString();
            await this.toEstablishConnection();
            try {
                this.logger.trace({
                    id: n,
                    method: t.method,
                    topic: (i = t.params) == null ? void 0 : i.topic
                }, "relayer.request - publishing...");
                const o = `${n}:${((s = t.params) == null ? void 0 : s.tag) || ""}`;
                this.requestsInFlight.push(o);
                const a = await this.provider.request(t);
                return this.requestsInFlight = this.requestsInFlight.filter((c)=>c !== o), a;
            } catch (o) {
                throw this.logger.debug(`Failed to Publish Request: ${n}`), o;
            }
        }), $6b019d9bd89ed96b$var$y(this, "resetPingTimeout", ()=>{
            (0, $3qpNA.isNode)() && (clearTimeout(this.pingTimeout), this.pingTimeout = setTimeout(()=>{
                var t, i, s, n;
                try {
                    this.logger.debug({}, "pingTimeout: Connection stalled, terminating..."), (n = (s = (i = (t = this.provider) == null ? void 0 : t.connection) == null ? void 0 : i.socket) == null ? void 0 : s.terminate) == null || n.call(s);
                } catch (o) {
                    this.logger.warn(o, o?.message);
                }
            }, this.heartBeatTimeout));
        }), $6b019d9bd89ed96b$var$y(this, "onPayloadHandler", (t)=>{
            this.onProviderPayload(t), this.resetPingTimeout();
        }), $6b019d9bd89ed96b$var$y(this, "onConnectHandler", ()=>{
            this.logger.warn({}, "Relayer connected \uD83D\uDEDC"), this.startPingTimeout(), this.events.emit($6b019d9bd89ed96b$export$d56245796e2837d.connect);
        }), $6b019d9bd89ed96b$var$y(this, "onDisconnectHandler", ()=>{
            this.logger.warn({}, "Relayer disconnected \uD83D\uDED1"), this.requestsInFlight = [], this.onProviderDisconnect();
        }), $6b019d9bd89ed96b$var$y(this, "onProviderErrorHandler", (t)=>{
            this.logger.fatal(`Fatal socket error: ${t.message}`), this.events.emit($6b019d9bd89ed96b$export$d56245796e2837d.error, t), this.logger.fatal("Fatal socket error received, closing transport"), this.transportClose();
        }), $6b019d9bd89ed96b$var$y(this, "registerProviderListeners", ()=>{
            this.provider.on($6b019d9bd89ed96b$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.on($6b019d9bd89ed96b$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.on($6b019d9bd89ed96b$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.on($6b019d9bd89ed96b$export$58062acf2f31ddf8.error, this.onProviderErrorHandler);
        }), this.core = e.core, this.logger = typeof e.logger < "u" && typeof e.logger != "string" ? (0, $6GQzw.generateChildLogger)(e.logger, this.name) : (0, (/*@__PURE__*/$parcel$interopDefault($66E6s)))((0, $6GQzw.getDefaultLoggerOptions)({
            level: e.logger || $6b019d9bd89ed96b$export$5176ffa6778d6637
        })), this.messages = new $6b019d9bd89ed96b$export$4a2542d0790ac2fd(this.logger, e.core), this.subscriber = new $6b019d9bd89ed96b$export$60959659b2c22881(this, this.logger), this.publisher = new $6b019d9bd89ed96b$var$Vn(this, this.logger), this.relayUrl = e?.relayUrl || $6b019d9bd89ed96b$export$a68061e6c48f332a, this.projectId = e.projectId, (0, $3qpNA.isAndroid)() ? this.packageName = (0, $3qpNA.getAppId)() : (0, $3qpNA.isIos)() && (this.bundleId = (0, $3qpNA.getAppId)()), this.provider = {};
    }
    async init() {
        if (this.logger.trace("Initialized"), this.registerEventListeners(), await Promise.all([
            this.messages.init(),
            this.subscriber.init()
        ]), this.initialized = !0, this.subscriber.hasAnyTopics) try {
            await this.transportOpen();
        } catch (e) {
            this.logger.warn(e, e?.message);
        }
    }
    get context() {
        return (0, $6GQzw.getLoggerContext)(this.logger);
    }
    get connected() {
        var e, t, i;
        return ((i = (t = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : t.socket) == null ? void 0 : i.readyState) === 1 || !1;
    }
    get connecting() {
        var e, t, i;
        return ((i = (t = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : t.socket) == null ? void 0 : i.readyState) === 0 || this.connectPromise !== void 0 || !1;
    }
    async publish(e, t, i) {
        this.isInitialized(), await this.publisher.publish(e, t, i), await this.recordMessageEvent({
            topic: e,
            message: t,
            publishedAt: Date.now(),
            transportType: $6b019d9bd89ed96b$export$326e296bb8673773.relay
        }, $6b019d9bd89ed96b$export$5c65dd72e0f566ab.outbound);
    }
    async subscribe(e, t) {
        var i, s, n;
        this.isInitialized(), (!(t != null && t.transportType) || t?.transportType === "relay") && await this.toEstablishConnection();
        const o = typeof ((i = t?.internal) == null ? void 0 : i.throwOnFailedPublish) > "u" ? !0 : (s = t?.internal) == null ? void 0 : s.throwOnFailedPublish;
        let a = ((n = this.subscriber.topicMap.get(e)) == null ? void 0 : n[0]) || "", c;
        const h = (l)=>{
            l.topic === e && (this.subscriber.off($6b019d9bd89ed96b$export$24ff3e54e94ef413.created, h), c());
        };
        return await Promise.all([
            new Promise((l)=>{
                c = l, this.subscriber.on($6b019d9bd89ed96b$export$24ff3e54e94ef413.created, h);
            }),
            new Promise(async (l, d)=>{
                a = await this.subscriber.subscribe(e, $6b019d9bd89ed96b$var$Pi({
                    internal: {
                        throwOnFailedPublish: o
                    }
                }, t)).catch((g)=>{
                    o && d(g);
                }) || a, l();
            })
        ]), a;
    }
    async unsubscribe(e, t) {
        this.isInitialized(), await this.subscriber.unsubscribe(e, t);
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async transportDisconnect() {
        this.provider.disconnect && (this.hasExperiencedNetworkDisruption || this.connected) ? await (0, $3qpNA.createExpiringPromise)(this.provider.disconnect(), 2e3, "provider.disconnect()").catch(()=>this.onProviderDisconnect()) : this.onProviderDisconnect();
    }
    async transportClose() {
        this.transportExplicitlyClosed = !0, await this.transportDisconnect();
    }
    async transportOpen(e) {
        if (!this.subscriber.hasAnyTopics) {
            this.logger.warn("Starting WS connection skipped because the client has no topics to work with.");
            return;
        }
        if (this.connectPromise ? (this.logger.debug({}, "Waiting for existing connection attempt to resolve..."), await this.connectPromise, this.logger.debug({}, "Existing connection attempt resolved")) : (this.connectPromise = new Promise(async (t, i)=>{
            await this.connect(e).then(t).catch(i).finally(()=>{
                this.connectPromise = void 0;
            });
        }), await this.connectPromise), !this.connected) throw new Error(`Couldn't establish socket connection to the relay server: ${this.relayUrl}`);
    }
    async restartTransport(e) {
        this.logger.debug({}, "Restarting transport..."), !this.connectionAttemptInProgress && (this.relayUrl = e || this.relayUrl, await this.confirmOnlineStateOrThrow(), await this.transportClose(), await this.transportOpen());
    }
    async confirmOnlineStateOrThrow() {
        if (!await (0, $3qpNA.isOnline)()) throw new Error("No internet connection detected. Please restart your network and try again.");
    }
    async handleBatchMessageEvents(e) {
        if (e?.length === 0) {
            this.logger.trace("Batch message events is empty. Ignoring...");
            return;
        }
        const t = e.sort((i, s)=>i.publishedAt - s.publishedAt);
        this.logger.debug(`Batch of ${t.length} message events sorted`);
        for (const i of t)try {
            await this.onMessageEvent(i);
        } catch (s) {
            this.logger.warn(s, "Error while processing batch message event: " + s?.message);
        }
        this.logger.trace(`Batch of ${t.length} message events processed`);
    }
    async onLinkMessageEvent(e, t) {
        const { topic: i } = e;
        if (!t.sessionExists) {
            const s = (0, $3qpNA.calcExpiry)((0, $9eyak.FIVE_MINUTES)), n = {
                topic: i,
                expiry: s,
                relay: {
                    protocol: "irn"
                },
                active: !1
            };
            await this.core.pairing.pairings.set(i, n);
        }
        this.events.emit($6b019d9bd89ed96b$export$d56245796e2837d.message, e), await this.recordMessageEvent(e, $6b019d9bd89ed96b$export$5c65dd72e0f566ab.inbound);
    }
    async connect(e) {
        await this.confirmOnlineStateOrThrow(), e && e !== this.relayUrl && (this.relayUrl = e, await this.transportDisconnect()), this.connectionAttemptInProgress = !0, this.transportExplicitlyClosed = !1;
        let t = 1;
        for(; t < 6;){
            try {
                if (this.transportExplicitlyClosed) break;
                this.logger.debug({}, `Connecting to ${this.relayUrl}, attempt: ${t}...`), await this.createProvider(), await new Promise(async (i, s)=>{
                    const n = ()=>{
                        s(new Error("Connection interrupted while trying to subscribe"));
                    };
                    this.provider.once($6b019d9bd89ed96b$export$58062acf2f31ddf8.disconnect, n), await (0, $3qpNA.createExpiringPromise)(new Promise((o, a)=>{
                        this.provider.connect().then(o).catch(a);
                    }), this.connectTimeout, `Socket stalled when trying to connect to ${this.relayUrl}`).catch((o)=>{
                        s(o);
                    }).finally(()=>{
                        this.provider.off($6b019d9bd89ed96b$export$58062acf2f31ddf8.disconnect, n), clearTimeout(this.reconnectTimeout);
                    }), await new Promise(async (o, a)=>{
                        const c = ()=>{
                            a(new Error("Connection interrupted while trying to subscribe"));
                        };
                        this.provider.once($6b019d9bd89ed96b$export$58062acf2f31ddf8.disconnect, c), await this.subscriber.start().then(o).catch(a).finally(()=>{
                            this.provider.off($6b019d9bd89ed96b$export$58062acf2f31ddf8.disconnect, c);
                        });
                    }), this.hasExperiencedNetworkDisruption = !1, i();
                });
            } catch (i) {
                await this.subscriber.stop();
                const s = i;
                this.logger.warn({}, s.message), this.hasExperiencedNetworkDisruption = !0;
            } finally{
                this.connectionAttemptInProgress = !1;
            }
            if (this.connected) {
                this.logger.debug({}, `Connected to ${this.relayUrl} successfully on attempt: ${t}`);
                break;
            }
            await new Promise((i)=>setTimeout(i, (0, $9eyak.toMiliseconds)(t * 1))), t++;
        }
    }
    startPingTimeout() {
        var e, t, i, s, n;
        if ((0, $3qpNA.isNode)()) try {
            (t = (e = this.provider) == null ? void 0 : e.connection) != null && t.socket && ((n = (s = (i = this.provider) == null ? void 0 : i.connection) == null ? void 0 : s.socket) == null || n.on("ping", ()=>{
                this.resetPingTimeout();
            })), this.resetPingTimeout();
        } catch (o) {
            this.logger.warn(o, o?.message);
        }
    }
    async createProvider() {
        this.provider.connection && this.unregisterProviderListeners();
        const e = await this.core.crypto.signJWT(this.relayUrl);
        this.provider = new (0, $1EAvo.JsonRpcProvider)(new (0, $7XH1l.default)((0, $3qpNA.formatRelayRpcUrl)({
            sdkVersion: $6b019d9bd89ed96b$export$5f30917a6f8c9025,
            protocol: this.protocol,
            version: this.version,
            relayUrl: this.relayUrl,
            projectId: this.projectId,
            auth: e,
            useOnCloseEvent: !0,
            bundleId: this.bundleId,
            packageName: this.packageName
        }))), this.registerProviderListeners();
    }
    async recordMessageEvent(e, t) {
        const { topic: i, message: s } = e;
        await this.messages.set(i, s, t);
    }
    async shouldIgnoreMessageEvent(e) {
        const { topic: t, message: i } = e;
        if (!i || i.length === 0) return this.logger.warn(`Ignoring invalid/empty message: ${i}`), !0;
        if (!await this.subscriber.isKnownTopic(t)) return this.logger.warn(`Ignoring message for unknown topic ${t}`), !0;
        const s = this.messages.has(t, i);
        return s && this.logger.warn(`Ignoring duplicate message: ${i}`), s;
    }
    async onProviderPayload(e) {
        if (this.logger.debug("Incoming Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "incoming",
            payload: e
        }), (0, $fgWWx.isJsonRpcRequest)(e)) {
            if (!e.method.endsWith($6b019d9bd89ed96b$export$119b4645f6b233c8)) return;
            const t = e.params, { topic: i, message: s, publishedAt: n, attestation: o } = t.data, a = {
                topic: i,
                message: s,
                publishedAt: n,
                transportType: $6b019d9bd89ed96b$export$326e296bb8673773.relay,
                attestation: o
            };
            this.logger.debug("Emitting Relayer Payload"), this.logger.trace($6b019d9bd89ed96b$var$Pi({
                type: "event",
                event: t.id
            }, a)), this.events.emit(t.id, a), await this.acknowledgePayload(e), await this.onMessageEvent(a);
        } else (0, $fgWWx.isJsonRpcResponse)(e) && this.events.emit($6b019d9bd89ed96b$export$d56245796e2837d.message_ack, e);
    }
    async onMessageEvent(e) {
        await this.shouldIgnoreMessageEvent(e) || (await this.recordMessageEvent(e, $6b019d9bd89ed96b$export$5c65dd72e0f566ab.inbound), this.events.emit($6b019d9bd89ed96b$export$d56245796e2837d.message, e));
    }
    async acknowledgePayload(e) {
        const t = (0, $fHodW.formatJsonRpcResult)(e.id, !0);
        await this.provider.connection.send(t);
    }
    unregisterProviderListeners() {
        this.provider.off($6b019d9bd89ed96b$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.off($6b019d9bd89ed96b$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.off($6b019d9bd89ed96b$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.off($6b019d9bd89ed96b$export$58062acf2f31ddf8.error, this.onProviderErrorHandler), clearTimeout(this.pingTimeout);
    }
    async registerEventListeners() {
        let e = await (0, $3qpNA.isOnline)();
        (0, $3qpNA.subscribeToNetworkChange)(async (t)=>{
            e !== t && (e = t, t ? await this.transportOpen().catch((i)=>this.logger.error(i, i?.message)) : (this.hasExperiencedNetworkDisruption = !0, await this.transportDisconnect(), this.transportExplicitlyClosed = !1));
        });
    }
    async onProviderDisconnect() {
        clearTimeout(this.pingTimeout), this.events.emit($6b019d9bd89ed96b$export$d56245796e2837d.disconnect), this.connectionAttemptInProgress = !1, !this.reconnectInProgress && (this.reconnectInProgress = !0, await this.subscriber.stop(), this.subscriber.hasAnyTopics && (this.transportExplicitlyClosed || (this.reconnectTimeout = setTimeout(async ()=>{
            await this.transportOpen().catch((e)=>this.logger.error(e, e?.message)), this.reconnectTimeout = void 0, this.reconnectInProgress = !1;
        }, (0, $9eyak.toMiliseconds)($6b019d9bd89ed96b$export$11ccd39be2c57d6)))));
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $3qpNA.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async toEstablishConnection() {
        if (await this.confirmOnlineStateOrThrow(), !this.connected) {
            if (this.connectPromise) {
                await this.connectPromise;
                return;
            }
            await this.connect();
        }
    }
}
function $6b019d9bd89ed96b$var$io() {}
function $6b019d9bd89ed96b$var$Ri(r) {
    if (!r || typeof r != "object") return !1;
    const e = Object.getPrototypeOf(r);
    return e === null || e === Object.prototype || Object.getPrototypeOf(e) === null ? Object.prototype.toString.call(r) === "[object Object]" : !1;
}
function $6b019d9bd89ed96b$var$Oi(r) {
    return Object.getOwnPropertySymbols(r).filter((e)=>Object.prototype.propertyIsEnumerable.call(r, e));
}
function $6b019d9bd89ed96b$var$Ai(r) {
    return r == null ? r === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(r);
}
const $6b019d9bd89ed96b$var$so = "[object RegExp]", $6b019d9bd89ed96b$var$ro = "[object String]", $6b019d9bd89ed96b$var$no = "[object Number]", $6b019d9bd89ed96b$var$oo = "[object Boolean]", $6b019d9bd89ed96b$var$xi = "[object Arguments]", $6b019d9bd89ed96b$var$ao = "[object Symbol]", $6b019d9bd89ed96b$var$co = "[object Date]", $6b019d9bd89ed96b$var$ho = "[object Map]", $6b019d9bd89ed96b$var$lo = "[object Set]", $6b019d9bd89ed96b$var$uo = "[object Array]", $6b019d9bd89ed96b$var$go = "[object Function]", $6b019d9bd89ed96b$var$po = "[object ArrayBuffer]", $6b019d9bd89ed96b$var$Je = "[object Object]", $6b019d9bd89ed96b$var$yo = "[object Error]", $6b019d9bd89ed96b$var$bo = "[object DataView]", $6b019d9bd89ed96b$var$mo = "[object Uint8Array]", $6b019d9bd89ed96b$var$fo = "[object Uint8ClampedArray]", $6b019d9bd89ed96b$var$Do = "[object Uint16Array]", $6b019d9bd89ed96b$var$vo = "[object Uint32Array]", $6b019d9bd89ed96b$var$wo = "[object BigUint64Array]", $6b019d9bd89ed96b$var$_o = "[object Int8Array]", $6b019d9bd89ed96b$var$Eo = "[object Int16Array]", $6b019d9bd89ed96b$var$Io = "[object Int32Array]", $6b019d9bd89ed96b$var$To = "[object BigInt64Array]", $6b019d9bd89ed96b$var$Co = "[object Float32Array]", $6b019d9bd89ed96b$var$Po = "[object Float64Array]";
function $6b019d9bd89ed96b$var$So(r, e) {
    return r === e || Number.isNaN(r) && Number.isNaN(e);
}
function $6b019d9bd89ed96b$var$Ro(r, e, t) {
    return $6b019d9bd89ed96b$var$pe(r, e, void 0, void 0, void 0, void 0, t);
}
function $6b019d9bd89ed96b$var$pe(r, e, t, i, s, n, o) {
    const a = o(r, e, t, i, s, n);
    if (a !== void 0) return a;
    if (typeof r == typeof e) switch(typeof r){
        case "bigint":
        case "string":
        case "boolean":
        case "symbol":
        case "undefined":
            return r === e;
        case "number":
            return r === e || Object.is(r, e);
        case "function":
            return r === e;
        case "object":
            return $6b019d9bd89ed96b$var$ye(r, e, n, o);
    }
    return $6b019d9bd89ed96b$var$ye(r, e, n, o);
}
function $6b019d9bd89ed96b$var$ye(r, e, t, i) {
    if (Object.is(r, e)) return !0;
    let s = $6b019d9bd89ed96b$var$Ai(r), n = $6b019d9bd89ed96b$var$Ai(e);
    if (s === $6b019d9bd89ed96b$var$xi && (s = $6b019d9bd89ed96b$var$Je), n === $6b019d9bd89ed96b$var$xi && (n = $6b019d9bd89ed96b$var$Je), s !== n) return !1;
    switch(s){
        case $6b019d9bd89ed96b$var$ro:
            return r.toString() === e.toString();
        case $6b019d9bd89ed96b$var$no:
            {
                const c = r.valueOf(), h = e.valueOf();
                return $6b019d9bd89ed96b$var$So(c, h);
            }
        case $6b019d9bd89ed96b$var$oo:
        case $6b019d9bd89ed96b$var$co:
        case $6b019d9bd89ed96b$var$ao:
            return Object.is(r.valueOf(), e.valueOf());
        case $6b019d9bd89ed96b$var$so:
            return r.source === e.source && r.flags === e.flags;
        case $6b019d9bd89ed96b$var$go:
            return r === e;
    }
    t = t ?? new Map;
    const o = t.get(r), a = t.get(e);
    if (o != null && a != null) return o === e;
    t.set(r, e), t.set(e, r);
    try {
        switch(s){
            case $6b019d9bd89ed96b$var$ho:
                if (r.size !== e.size) return !1;
                for (const [c, h] of r.entries())if (!e.has(c) || !$6b019d9bd89ed96b$var$pe(h, e.get(c), c, r, e, t, i)) return !1;
                return !0;
            case $6b019d9bd89ed96b$var$lo:
                {
                    if (r.size !== e.size) return !1;
                    const c = Array.from(r.values()), h = Array.from(e.values());
                    for(let l = 0; l < c.length; l++){
                        const d = c[l], g = h.findIndex((_)=>$6b019d9bd89ed96b$var$pe(d, _, void 0, r, e, t, i));
                        if (g === -1) return !1;
                        h.splice(g, 1);
                    }
                    return !0;
                }
            case $6b019d9bd89ed96b$var$uo:
            case $6b019d9bd89ed96b$var$mo:
            case $6b019d9bd89ed96b$var$fo:
            case $6b019d9bd89ed96b$var$Do:
            case $6b019d9bd89ed96b$var$vo:
            case $6b019d9bd89ed96b$var$wo:
            case $6b019d9bd89ed96b$var$_o:
            case $6b019d9bd89ed96b$var$Eo:
            case $6b019d9bd89ed96b$var$Io:
            case $6b019d9bd89ed96b$var$To:
            case $6b019d9bd89ed96b$var$Co:
            case $6b019d9bd89ed96b$var$Po:
                if (typeof $6b019d9bd89ed96b$require$Buffer < "u" && $6b019d9bd89ed96b$require$Buffer.isBuffer(r) !== $6b019d9bd89ed96b$require$Buffer.isBuffer(e) || r.length !== e.length) return !1;
                for(let c = 0; c < r.length; c++)if (!$6b019d9bd89ed96b$var$pe(r[c], e[c], c, r, e, t, i)) return !1;
                return !0;
            case $6b019d9bd89ed96b$var$po:
                return r.byteLength !== e.byteLength ? !1 : $6b019d9bd89ed96b$var$ye(new Uint8Array(r), new Uint8Array(e), t, i);
            case $6b019d9bd89ed96b$var$bo:
                return r.byteLength !== e.byteLength || r.byteOffset !== e.byteOffset ? !1 : $6b019d9bd89ed96b$var$ye(new Uint8Array(r), new Uint8Array(e), t, i);
            case $6b019d9bd89ed96b$var$yo:
                return r.name === e.name && r.message === e.message;
            case $6b019d9bd89ed96b$var$Je:
                {
                    if (!($6b019d9bd89ed96b$var$ye(r.constructor, e.constructor, t, i) || $6b019d9bd89ed96b$var$Ri(r) && $6b019d9bd89ed96b$var$Ri(e))) return !1;
                    const h = [
                        ...Object.keys(r),
                        ...$6b019d9bd89ed96b$var$Oi(r)
                    ], l = [
                        ...Object.keys(e),
                        ...$6b019d9bd89ed96b$var$Oi(e)
                    ];
                    if (h.length !== l.length) return !1;
                    for(let d = 0; d < h.length; d++){
                        const g = h[d], _ = r[g];
                        if (!Object.hasOwn(e, g)) return !1;
                        const u = e[g];
                        if (!$6b019d9bd89ed96b$var$pe(_, u, g, r, e, t, i)) return !1;
                    }
                    return !0;
                }
            default:
                return !1;
        }
    } finally{
        t.delete(r), t.delete(e);
    }
}
function $6b019d9bd89ed96b$var$Oo(r, e) {
    return $6b019d9bd89ed96b$var$Ro(r, e, $6b019d9bd89ed96b$var$io);
}
var $6b019d9bd89ed96b$var$Ao = Object.defineProperty, $6b019d9bd89ed96b$var$Ni = Object.getOwnPropertySymbols, $6b019d9bd89ed96b$var$xo = Object.prototype.hasOwnProperty, $6b019d9bd89ed96b$var$No = Object.prototype.propertyIsEnumerable, $6b019d9bd89ed96b$var$Xe = (r, e, t)=>e in r ? $6b019d9bd89ed96b$var$Ao(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $6b019d9bd89ed96b$var$$i = (r, e)=>{
    for(var t in e || (e = {}))$6b019d9bd89ed96b$var$xo.call(e, t) && $6b019d9bd89ed96b$var$Xe(r, t, e[t]);
    if ($6b019d9bd89ed96b$var$Ni) for (var t of $6b019d9bd89ed96b$var$Ni(e))$6b019d9bd89ed96b$var$No.call(e, t) && $6b019d9bd89ed96b$var$Xe(r, t, e[t]);
    return r;
}, $6b019d9bd89ed96b$var$z = (r, e, t)=>$6b019d9bd89ed96b$var$Xe(r, typeof e != "symbol" ? e + "" : e, t);
class $6b019d9bd89ed96b$export$390f32400eaf98c9 extends (0, $2B80D.IStore) {
    constructor(e, t, i, s = $6b019d9bd89ed96b$export$f258d29ae5e3d545, n){
        super(e, t, i, s), this.core = e, this.logger = t, this.name = i, $6b019d9bd89ed96b$var$z(this, "map", new Map), $6b019d9bd89ed96b$var$z(this, "version", $6b019d9bd89ed96b$export$629a342182ba24b), $6b019d9bd89ed96b$var$z(this, "cached", []), $6b019d9bd89ed96b$var$z(this, "initialized", !1), $6b019d9bd89ed96b$var$z(this, "getKey"), $6b019d9bd89ed96b$var$z(this, "storagePrefix", $6b019d9bd89ed96b$export$f258d29ae5e3d545), $6b019d9bd89ed96b$var$z(this, "recentlyDeleted", []), $6b019d9bd89ed96b$var$z(this, "recentlyDeletedLimit", 200), $6b019d9bd89ed96b$var$z(this, "init", async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((o)=>{
                this.getKey && o !== null && !(0, $3qpNA.isUndefined)(o) ? this.map.set(this.getKey(o), o) : (0, $3qpNA.isProposalStruct)(o) ? this.map.set(o.id, o) : (0, $3qpNA.isSessionStruct)(o) && this.map.set(o.topic, o);
            }), this.cached = [], this.initialized = !0);
        }), $6b019d9bd89ed96b$var$z(this, "set", async (o, a)=>{
            this.isInitialized(), this.map.has(o) ? await this.update(o, a) : (this.logger.debug("Setting value"), this.logger.trace({
                type: "method",
                method: "set",
                key: o,
                value: a
            }), this.map.set(o, a), await this.persist());
        }), $6b019d9bd89ed96b$var$z(this, "get", (o)=>(this.isInitialized(), this.logger.debug("Getting value"), this.logger.trace({
                type: "method",
                method: "get",
                key: o
            }), this.getData(o))), $6b019d9bd89ed96b$var$z(this, "getAll", (o)=>(this.isInitialized(), o ? this.values.filter((a)=>Object.keys(o).every((c)=>$6b019d9bd89ed96b$var$Oo(a[c], o[c]))) : this.values)), $6b019d9bd89ed96b$var$z(this, "update", async (o, a)=>{
            this.isInitialized(), this.logger.debug("Updating value"), this.logger.trace({
                type: "method",
                method: "update",
                key: o,
                update: a
            });
            const c = $6b019d9bd89ed96b$var$$i($6b019d9bd89ed96b$var$$i({}, this.getData(o)), a);
            this.map.set(o, c), await this.persist();
        }), $6b019d9bd89ed96b$var$z(this, "delete", async (o, a)=>{
            this.isInitialized(), this.map.has(o) && (this.logger.debug("Deleting value"), this.logger.trace({
                type: "method",
                method: "delete",
                key: o,
                reason: a
            }), this.map.delete(o), this.addToRecentlyDeleted(o), await this.persist());
        }), this.logger = (0, $6GQzw.generateChildLogger)(t, this.name), this.storagePrefix = s, this.getKey = n;
    }
    get context() {
        return (0, $6GQzw.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.map.size;
    }
    get keys() {
        return Array.from(this.map.keys());
    }
    get values() {
        return Array.from(this.map.values());
    }
    addToRecentlyDeleted(e) {
        this.recentlyDeleted.push(e), this.recentlyDeleted.length >= this.recentlyDeletedLimit && this.recentlyDeleted.splice(0, this.recentlyDeletedLimit / 2);
    }
    async setDataStore(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getDataStore() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getData(e) {
        const t = this.map.get(e);
        if (!t) {
            if (this.recentlyDeleted.includes(e)) {
                const { message: s } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `Record was recently deleted - ${this.name}: ${e}`);
                throw this.logger.error(s), new Error(s);
            }
            const { message: i } = (0, $3qpNA.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(i), new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setDataStore(this.values);
    }
    async restore() {
        try {
            const e = await this.getDataStore();
            if (typeof e > "u" || !e.length) return;
            if (this.map.size) {
                const { message: t } = (0, $3qpNA.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored value for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                value: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore value for ${this.name}`), this.logger.error(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $3qpNA.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
var $6b019d9bd89ed96b$var$$o = Object.defineProperty, $6b019d9bd89ed96b$var$zo = (r, e, t)=>e in r ? $6b019d9bd89ed96b$var$$o(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $6b019d9bd89ed96b$var$p = (r, e, t)=>$6b019d9bd89ed96b$var$zo(r, typeof e != "symbol" ? e + "" : e, t);
class $6b019d9bd89ed96b$export$3370ee24730992a3 {
    constructor(e, t){
        this.core = e, this.logger = t, $6b019d9bd89ed96b$var$p(this, "name", $6b019d9bd89ed96b$export$390360ea476c6145), $6b019d9bd89ed96b$var$p(this, "version", $6b019d9bd89ed96b$export$5593ec74b27d1b18), $6b019d9bd89ed96b$var$p(this, "events", new (0, (/*@__PURE__*/$parcel$interopDefault($5yFVO)))), $6b019d9bd89ed96b$var$p(this, "pairings"), $6b019d9bd89ed96b$var$p(this, "initialized", !1), $6b019d9bd89ed96b$var$p(this, "storagePrefix", $6b019d9bd89ed96b$export$f258d29ae5e3d545), $6b019d9bd89ed96b$var$p(this, "ignoredPayloadTypes", [
            (0, $3qpNA.TYPE_1)
        ]), $6b019d9bd89ed96b$var$p(this, "registeredMethods", []), $6b019d9bd89ed96b$var$p(this, "init", async ()=>{
            this.initialized || (await this.pairings.init(), await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.initialized = !0, this.logger.trace("Initialized"));
        }), $6b019d9bd89ed96b$var$p(this, "register", ({ methods: i })=>{
            this.isInitialized(), this.registeredMethods = [
                ...new Set([
                    ...this.registeredMethods,
                    ...i
                ])
            ];
        }), $6b019d9bd89ed96b$var$p(this, "create", async (i)=>{
            this.isInitialized();
            const s = (0, $3qpNA.generateRandomBytes32)(), n = await this.core.crypto.setSymKey(s), o = (0, $3qpNA.calcExpiry)((0, $9eyak.FIVE_MINUTES)), a = {
                protocol: $6b019d9bd89ed96b$export$822d0bd1635d5360
            }, c = {
                topic: n,
                expiry: o,
                relay: a,
                active: !1,
                methods: i?.methods
            }, h = (0, $3qpNA.formatUri)({
                protocol: this.core.protocol,
                version: this.core.version,
                topic: n,
                symKey: s,
                relay: a,
                expiryTimestamp: o,
                methods: i?.methods
            });
            return this.events.emit($6b019d9bd89ed96b$export$ca3c0b962acf7b75.create, c), this.core.expirer.set(n, o), await this.pairings.set(n, c), await this.core.relayer.subscribe(n, {
                transportType: i?.transportType
            }), {
                topic: n,
                uri: h
            };
        }), $6b019d9bd89ed96b$var$p(this, "pair", async (i)=>{
            this.isInitialized();
            const s = this.core.eventClient.createEvent({
                properties: {
                    topic: i?.uri,
                    trace: [
                        $6b019d9bd89ed96b$export$6736f9bb609b5d34.pairing_started
                    ]
                }
            });
            this.isValidPair(i, s);
            const { topic: n, symKey: o, relay: a, expiryTimestamp: c, methods: h } = (0, $3qpNA.parseUri)(i.uri);
            s.props.properties.topic = n, s.addTrace($6b019d9bd89ed96b$export$6736f9bb609b5d34.pairing_uri_validation_success), s.addTrace($6b019d9bd89ed96b$export$6736f9bb609b5d34.pairing_uri_not_expired);
            let l;
            if (this.pairings.keys.includes(n)) {
                if (l = this.pairings.get(n), s.addTrace($6b019d9bd89ed96b$export$6736f9bb609b5d34.existing_pairing), l.active) throw s.setError($6b019d9bd89ed96b$export$e1dc85b7b7495247.active_pairing_already_exists), new Error(`Pairing already exists: ${n}. Please try again with a new connection URI.`);
                s.addTrace($6b019d9bd89ed96b$export$6736f9bb609b5d34.pairing_not_expired);
            }
            const d = c || (0, $3qpNA.calcExpiry)((0, $9eyak.FIVE_MINUTES)), g = {
                topic: n,
                relay: a,
                expiry: d,
                active: !1,
                methods: h
            };
            this.core.expirer.set(n, d), await this.pairings.set(n, g), s.addTrace($6b019d9bd89ed96b$export$6736f9bb609b5d34.store_new_pairing), i.activatePairing && await this.activate({
                topic: n
            }), this.events.emit($6b019d9bd89ed96b$export$ca3c0b962acf7b75.create, g), s.addTrace($6b019d9bd89ed96b$export$6736f9bb609b5d34.emit_inactive_pairing), this.core.crypto.keychain.has(n) || await this.core.crypto.setSymKey(o, n), s.addTrace($6b019d9bd89ed96b$export$6736f9bb609b5d34.subscribing_pairing_topic);
            try {
                await this.core.relayer.confirmOnlineStateOrThrow();
            } catch  {
                s.setError($6b019d9bd89ed96b$export$e1dc85b7b7495247.no_internet_connection);
            }
            try {
                await this.core.relayer.subscribe(n, {
                    relay: a
                });
            } catch (_) {
                throw s.setError($6b019d9bd89ed96b$export$e1dc85b7b7495247.subscribe_pairing_topic_failure), _;
            }
            return s.addTrace($6b019d9bd89ed96b$export$6736f9bb609b5d34.subscribe_pairing_topic_success), g;
        }), $6b019d9bd89ed96b$var$p(this, "activate", async ({ topic: i })=>{
            this.isInitialized();
            const s = (0, $3qpNA.calcExpiry)((0, $9eyak.FIVE_MINUTES));
            this.core.expirer.set(i, s), await this.pairings.update(i, {
                active: !0,
                expiry: s
            });
        }), $6b019d9bd89ed96b$var$p(this, "ping", async (i)=>{
            this.isInitialized(), await this.isValidPing(i), this.logger.warn("ping() is deprecated and will be removed in the next major release.");
            const { topic: s } = i;
            if (this.pairings.keys.includes(s)) {
                const n = await this.sendRequest(s, "wc_pairingPing", {}), { done: o, resolve: a, reject: c } = (0, $3qpNA.createDelayedPromise)();
                this.events.once((0, $3qpNA.engineEvent)("pairing_ping", n), ({ error: h })=>{
                    h ? c(h) : a();
                }), await o();
            }
        }), $6b019d9bd89ed96b$var$p(this, "updateExpiry", async ({ topic: i, expiry: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                expiry: s
            });
        }), $6b019d9bd89ed96b$var$p(this, "updateMetadata", async ({ topic: i, metadata: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                peerMetadata: s
            });
        }), $6b019d9bd89ed96b$var$p(this, "getPairings", ()=>(this.isInitialized(), this.pairings.values)), $6b019d9bd89ed96b$var$p(this, "disconnect", async (i)=>{
            this.isInitialized(), await this.isValidDisconnect(i);
            const { topic: s } = i;
            this.pairings.keys.includes(s) && (await this.sendRequest(s, "wc_pairingDelete", (0, $3qpNA.getSdkError)("USER_DISCONNECTED")), await this.deletePairing(s));
        }), $6b019d9bd89ed96b$var$p(this, "formatUriFromPairing", (i)=>{
            this.isInitialized();
            const { topic: s, relay: n, expiry: o, methods: a } = i, c = this.core.crypto.keychain.get(s);
            return (0, $3qpNA.formatUri)({
                protocol: this.core.protocol,
                version: this.core.version,
                topic: s,
                symKey: c,
                relay: n,
                expiryTimestamp: o,
                methods: a
            });
        }), $6b019d9bd89ed96b$var$p(this, "sendRequest", async (i, s, n)=>{
            const o = (0, $fHodW.formatJsonRpcRequest)(s, n), a = await this.core.crypto.encode(i, o), c = $6b019d9bd89ed96b$export$d94d6986a8185883[s].req;
            return this.core.history.set(i, o), this.core.relayer.publish(i, a, c), o.id;
        }), $6b019d9bd89ed96b$var$p(this, "sendResult", async (i, s, n)=>{
            const o = (0, $fHodW.formatJsonRpcResult)(i, n), a = await this.core.crypto.encode(s, o), c = (await this.core.history.get(s, i)).request.method, h = $6b019d9bd89ed96b$export$d94d6986a8185883[c].res;
            await this.core.relayer.publish(s, a, h), await this.core.history.resolve(o);
        }), $6b019d9bd89ed96b$var$p(this, "sendError", async (i, s, n)=>{
            const o = (0, $fHodW.formatJsonRpcError)(i, n), a = await this.core.crypto.encode(s, o), c = (await this.core.history.get(s, i)).request.method, h = $6b019d9bd89ed96b$export$d94d6986a8185883[c] ? $6b019d9bd89ed96b$export$d94d6986a8185883[c].res : $6b019d9bd89ed96b$export$d94d6986a8185883.unregistered_method.res;
            await this.core.relayer.publish(s, a, h), await this.core.history.resolve(o);
        }), $6b019d9bd89ed96b$var$p(this, "deletePairing", async (i, s)=>{
            await this.core.relayer.unsubscribe(i), await Promise.all([
                this.pairings.delete(i, (0, $3qpNA.getSdkError)("USER_DISCONNECTED")),
                this.core.crypto.deleteSymKey(i),
                s ? Promise.resolve() : this.core.expirer.del(i)
            ]);
        }), $6b019d9bd89ed96b$var$p(this, "cleanup", async ()=>{
            const i = this.pairings.getAll().filter((s)=>(0, $3qpNA.isExpired)(s.expiry));
            await Promise.all(i.map((s)=>this.deletePairing(s.topic)));
        }), $6b019d9bd89ed96b$var$p(this, "onRelayEventRequest", async (i)=>{
            const { topic: s, payload: n } = i;
            switch(n.method){
                case "wc_pairingPing":
                    return await this.onPairingPingRequest(s, n);
                case "wc_pairingDelete":
                    return await this.onPairingDeleteRequest(s, n);
                default:
                    return await this.onUnknownRpcMethodRequest(s, n);
            }
        }), $6b019d9bd89ed96b$var$p(this, "onRelayEventResponse", async (i)=>{
            const { topic: s, payload: n } = i, o = (await this.core.history.get(s, n.id)).request.method;
            switch(o){
                case "wc_pairingPing":
                    return this.onPairingPingResponse(s, n);
                default:
                    return this.onUnknownRpcMethodResponse(o);
            }
        }), $6b019d9bd89ed96b$var$p(this, "onPairingPingRequest", async (i, s)=>{
            const { id: n } = s;
            try {
                this.isValidPing({
                    topic: i
                }), await this.sendResult(n, i, !0), this.events.emit($6b019d9bd89ed96b$export$ca3c0b962acf7b75.ping, {
                    id: n,
                    topic: i
                });
            } catch (o) {
                await this.sendError(n, i, o), this.logger.error(o);
            }
        }), $6b019d9bd89ed96b$var$p(this, "onPairingPingResponse", (i, s)=>{
            const { id: n } = s;
            setTimeout(()=>{
                (0, $fgWWx.isJsonRpcResult)(s) ? this.events.emit((0, $3qpNA.engineEvent)("pairing_ping", n), {}) : (0, $fgWWx.isJsonRpcError)(s) && this.events.emit((0, $3qpNA.engineEvent)("pairing_ping", n), {
                    error: s.error
                });
            }, 500);
        }), $6b019d9bd89ed96b$var$p(this, "onPairingDeleteRequest", async (i, s)=>{
            const { id: n } = s;
            try {
                this.isValidDisconnect({
                    topic: i
                }), await this.deletePairing(i), this.events.emit($6b019d9bd89ed96b$export$ca3c0b962acf7b75.delete, {
                    id: n,
                    topic: i
                });
            } catch (o) {
                await this.sendError(n, i, o), this.logger.error(o);
            }
        }), $6b019d9bd89ed96b$var$p(this, "onUnknownRpcMethodRequest", async (i, s)=>{
            const { id: n, method: o } = s;
            try {
                if (this.registeredMethods.includes(o)) return;
                const a = (0, $3qpNA.getSdkError)("WC_METHOD_UNSUPPORTED", o);
                await this.sendError(n, i, a), this.logger.error(a);
            } catch (a) {
                await this.sendError(n, i, a), this.logger.error(a);
            }
        }), $6b019d9bd89ed96b$var$p(this, "onUnknownRpcMethodResponse", (i)=>{
            this.registeredMethods.includes(i) || this.logger.error((0, $3qpNA.getSdkError)("WC_METHOD_UNSUPPORTED", i));
        }), $6b019d9bd89ed96b$var$p(this, "isValidPair", (i, s)=>{
            var n;
            if (!(0, $3qpNA.isValidParams)(i)) {
                const { message: a } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `pair() params: ${i}`);
                throw s.setError($6b019d9bd89ed96b$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a);
            }
            if (!(0, $3qpNA.isValidUrl)(i.uri)) {
                const { message: a } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `pair() uri: ${i.uri}`);
                throw s.setError($6b019d9bd89ed96b$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a);
            }
            const o = (0, $3qpNA.parseUri)(i?.uri);
            if (!((n = o?.relay) != null && n.protocol)) {
                const { message: a } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", "pair() uri#relay-protocol");
                throw s.setError($6b019d9bd89ed96b$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a);
            }
            if (!(o != null && o.symKey)) {
                const { message: a } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", "pair() uri#symKey");
                throw s.setError($6b019d9bd89ed96b$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a);
            }
            if (o != null && o.expiryTimestamp && (0, $9eyak.toMiliseconds)(o?.expiryTimestamp) < Date.now()) {
                s.setError($6b019d9bd89ed96b$export$e1dc85b7b7495247.pairing_expired);
                const { message: a } = (0, $3qpNA.getInternalError)("EXPIRED", "pair() URI has expired. Please try again with a new connection URI.");
                throw new Error(a);
            }
        }), $6b019d9bd89ed96b$var$p(this, "isValidPing", async (i)=>{
            if (!(0, $3qpNA.isValidParams)(i)) {
                const { message: n } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `ping() params: ${i}`);
                throw new Error(n);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }), $6b019d9bd89ed96b$var$p(this, "isValidDisconnect", async (i)=>{
            if (!(0, $3qpNA.isValidParams)(i)) {
                const { message: n } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `disconnect() params: ${i}`);
                throw new Error(n);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }), $6b019d9bd89ed96b$var$p(this, "isValidPairingTopic", async (i)=>{
            if (!(0, $3qpNA.isValidString)(i, !1)) {
                const { message: s } = (0, $3qpNA.getInternalError)("MISSING_OR_INVALID", `pairing topic should be a string: ${i}`);
                throw new Error(s);
            }
            if (!this.pairings.keys.includes(i)) {
                const { message: s } = (0, $3qpNA.getInternalError)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${i}`);
                throw new Error(s);
            }
            if ((0, $3qpNA.isExpired)(this.pairings.get(i).expiry)) {
                await this.deletePairing(i);
                const { message: s } = (0, $3qpNA.getInternalError)("EXPIRED", `pairing topic: ${i}`);
                throw new Error(s);
            }
        }), this.core = e, this.logger = (0, $6GQzw.generateChildLogger)(t, this.name), this.pairings = new $6b019d9bd89ed96b$export$390f32400eaf98c9(this.core, this.logger, this.name, this.storagePrefix);
    }
    get context() {
        return (0, $6GQzw.getLoggerContext)(this.logger);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $3qpNA.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    registerRelayerEvents() {
        this.core.relayer.on($6b019d9bd89ed96b$export$d56245796e2837d.message, async (e)=>{
            const { topic: t, message: i, transportType: s } = e;
            if (this.pairings.keys.includes(t) && s !== $6b019d9bd89ed96b$export$326e296bb8673773.link_mode && !this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(i))) try {
                const n = await this.core.crypto.decode(t, i);
                (0, $fgWWx.isJsonRpcRequest)(n) ? (this.core.history.set(t, n), await this.onRelayEventRequest({
                    topic: t,
                    payload: n
                })) : (0, $fgWWx.isJsonRpcResponse)(n) && (await this.core.history.resolve(n), await this.onRelayEventResponse({
                    topic: t,
                    payload: n
                }), this.core.history.delete(t, n.id)), await this.core.relayer.messages.ack(t, i);
            } catch (n) {
                this.logger.error(n);
            }
        });
    }
    registerExpirerEvents() {
        this.core.expirer.on($6b019d9bd89ed96b$export$9013719d9206b0c1.expired, async (e)=>{
            const { topic: t } = (0, $3qpNA.parseExpirerTarget)(e.target);
            t && this.pairings.keys.includes(t) && (await this.deletePairing(t, !0), this.events.emit($6b019d9bd89ed96b$export$ca3c0b962acf7b75.expire, {
                topic: t
            }));
        });
    }
}
var $6b019d9bd89ed96b$var$Lo = Object.defineProperty, $6b019d9bd89ed96b$var$ko = (r, e, t)=>e in r ? $6b019d9bd89ed96b$var$Lo(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $6b019d9bd89ed96b$var$R = (r, e, t)=>$6b019d9bd89ed96b$var$ko(r, typeof e != "symbol" ? e + "" : e, t);
class $6b019d9bd89ed96b$export$eeb4f10f25d479cb extends (0, $2B80D.IJsonRpcHistory) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, $6b019d9bd89ed96b$var$R(this, "records", new Map), $6b019d9bd89ed96b$var$R(this, "events", new (0, $5yFVO.EventEmitter)), $6b019d9bd89ed96b$var$R(this, "name", $6b019d9bd89ed96b$export$160142c73cb99dc3), $6b019d9bd89ed96b$var$R(this, "version", $6b019d9bd89ed96b$export$8eba9ce85616c607), $6b019d9bd89ed96b$var$R(this, "cached", []), $6b019d9bd89ed96b$var$R(this, "initialized", !1), $6b019d9bd89ed96b$var$R(this, "storagePrefix", $6b019d9bd89ed96b$export$f258d29ae5e3d545), $6b019d9bd89ed96b$var$R(this, "init", async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.records.set(i.id, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }), $6b019d9bd89ed96b$var$R(this, "set", (i, s, n)=>{
            if (this.isInitialized(), this.logger.debug("Setting JSON-RPC request history record"), this.logger.trace({
                type: "method",
                method: "set",
                topic: i,
                request: s,
                chainId: n
            }), this.records.has(s.id)) return;
            const o = {
                id: s.id,
                topic: i,
                request: {
                    method: s.method,
                    params: s.params || null
                },
                chainId: n,
                expiry: (0, $3qpNA.calcExpiry)((0, $9eyak.THIRTY_DAYS))
            };
            this.records.set(o.id, o), this.persist(), this.events.emit($6b019d9bd89ed96b$export$a682338b5ffca937.created, o);
        }), $6b019d9bd89ed96b$var$R(this, "resolve", async (i)=>{
            if (this.isInitialized(), this.logger.debug("Updating JSON-RPC response history record"), this.logger.trace({
                type: "method",
                method: "update",
                response: i
            }), !this.records.has(i.id)) return;
            const s = await this.getRecord(i.id);
            typeof s.response > "u" && (s.response = (0, $fgWWx.isJsonRpcError)(i) ? {
                error: i.error
            } : {
                result: i.result
            }, this.records.set(s.id, s), this.persist(), this.events.emit($6b019d9bd89ed96b$export$a682338b5ffca937.updated, s));
        }), $6b019d9bd89ed96b$var$R(this, "get", async (i, s)=>(this.isInitialized(), this.logger.debug("Getting record"), this.logger.trace({
                type: "method",
                method: "get",
                topic: i,
                id: s
            }), await this.getRecord(s))), $6b019d9bd89ed96b$var$R(this, "delete", (i, s)=>{
            this.isInitialized(), this.logger.debug("Deleting record"), this.logger.trace({
                type: "method",
                method: "delete",
                id: s
            }), this.values.forEach((n)=>{
                if (n.topic === i) {
                    if (typeof s < "u" && n.id !== s) return;
                    this.records.delete(n.id), this.events.emit($6b019d9bd89ed96b$export$a682338b5ffca937.deleted, n);
                }
            }), this.persist();
        }), $6b019d9bd89ed96b$var$R(this, "exists", async (i, s)=>(this.isInitialized(), this.records.has(s) ? (await this.getRecord(s)).topic === i : !1)), $6b019d9bd89ed96b$var$R(this, "on", (i, s)=>{
            this.events.on(i, s);
        }), $6b019d9bd89ed96b$var$R(this, "once", (i, s)=>{
            this.events.once(i, s);
        }), $6b019d9bd89ed96b$var$R(this, "off", (i, s)=>{
            this.events.off(i, s);
        }), $6b019d9bd89ed96b$var$R(this, "removeListener", (i, s)=>{
            this.events.removeListener(i, s);
        }), this.logger = (0, $6GQzw.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $6GQzw.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get size() {
        return this.records.size;
    }
    get keys() {
        return Array.from(this.records.keys());
    }
    get values() {
        return Array.from(this.records.values());
    }
    get pending() {
        const e = [];
        return this.values.forEach((t)=>{
            if (typeof t.response < "u") return;
            const i = {
                topic: t.topic,
                request: (0, $fHodW.formatJsonRpcRequest)(t.request.method, t.request.params, t.id),
                chainId: t.chainId
            };
            return e.push(i);
        }), e;
    }
    async setJsonRpcRecords(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getJsonRpcRecords() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getRecord(e) {
        this.isInitialized();
        const t = this.records.get(e);
        if (!t) {
            const { message: i } = (0, $3qpNA.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setJsonRpcRecords(this.values), this.events.emit($6b019d9bd89ed96b$export$a682338b5ffca937.sync);
    }
    async restore() {
        try {
            const e = await this.getJsonRpcRecords();
            if (typeof e > "u" || !e.length) return;
            if (this.records.size) {
                const { message: t } = (0, $3qpNA.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                records: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(e);
        }
    }
    registerEventListeners() {
        this.events.on($6b019d9bd89ed96b$export$a682338b5ffca937.created, (e)=>{
            const t = $6b019d9bd89ed96b$export$a682338b5ffca937.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            });
        }), this.events.on($6b019d9bd89ed96b$export$a682338b5ffca937.updated, (e)=>{
            const t = $6b019d9bd89ed96b$export$a682338b5ffca937.updated;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            });
        }), this.events.on($6b019d9bd89ed96b$export$a682338b5ffca937.deleted, (e)=>{
            const t = $6b019d9bd89ed96b$export$a682338b5ffca937.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            });
        }), this.core.heartbeat.on((0, $7G2F6.HEARTBEAT_EVENTS).pulse, ()=>{
            this.cleanup();
        });
    }
    cleanup() {
        try {
            this.isInitialized();
            let e = !1;
            this.records.forEach((t)=>{
                (0, $9eyak.toMiliseconds)(t.expiry || 0) - Date.now() <= 0 && (this.logger.info(`Deleting expired history log: ${t.id}`), this.records.delete(t.id), this.events.emit($6b019d9bd89ed96b$export$a682338b5ffca937.deleted, t, !1), e = !0);
            }), e && this.persist();
        } catch (e) {
            this.logger.warn(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $3qpNA.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
var $6b019d9bd89ed96b$var$jo = Object.defineProperty, $6b019d9bd89ed96b$var$Uo = (r, e, t)=>e in r ? $6b019d9bd89ed96b$var$jo(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $6b019d9bd89ed96b$var$A = (r, e, t)=>$6b019d9bd89ed96b$var$Uo(r, typeof e != "symbol" ? e + "" : e, t);
class $6b019d9bd89ed96b$export$e76805ce609031cb extends (0, $2B80D.IExpirer) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, $6b019d9bd89ed96b$var$A(this, "expirations", new Map), $6b019d9bd89ed96b$var$A(this, "events", new (0, $5yFVO.EventEmitter)), $6b019d9bd89ed96b$var$A(this, "name", $6b019d9bd89ed96b$export$4ddf883392bbc828), $6b019d9bd89ed96b$var$A(this, "version", $6b019d9bd89ed96b$export$717295846191925d), $6b019d9bd89ed96b$var$A(this, "cached", []), $6b019d9bd89ed96b$var$A(this, "initialized", !1), $6b019d9bd89ed96b$var$A(this, "storagePrefix", $6b019d9bd89ed96b$export$f258d29ae5e3d545), $6b019d9bd89ed96b$var$A(this, "init", async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.expirations.set(i.target, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }), $6b019d9bd89ed96b$var$A(this, "has", (i)=>{
            try {
                const s = this.formatTarget(i);
                return typeof this.getExpiration(s) < "u";
            } catch  {
                return !1;
            }
        }), $6b019d9bd89ed96b$var$A(this, "set", (i, s)=>{
            this.isInitialized();
            const n = this.formatTarget(i), o = {
                target: n,
                expiry: s
            };
            this.expirations.set(n, o), this.checkExpiry(n, o), this.events.emit($6b019d9bd89ed96b$export$9013719d9206b0c1.created, {
                target: n,
                expiration: o
            });
        }), $6b019d9bd89ed96b$var$A(this, "get", (i)=>{
            this.isInitialized();
            const s = this.formatTarget(i);
            return this.getExpiration(s);
        }), $6b019d9bd89ed96b$var$A(this, "del", (i)=>{
            if (this.isInitialized(), this.has(i)) {
                const s = this.formatTarget(i), n = this.getExpiration(s);
                this.expirations.delete(s), this.events.emit($6b019d9bd89ed96b$export$9013719d9206b0c1.deleted, {
                    target: s,
                    expiration: n
                });
            }
        }), $6b019d9bd89ed96b$var$A(this, "on", (i, s)=>{
            this.events.on(i, s);
        }), $6b019d9bd89ed96b$var$A(this, "once", (i, s)=>{
            this.events.once(i, s);
        }), $6b019d9bd89ed96b$var$A(this, "off", (i, s)=>{
            this.events.off(i, s);
        }), $6b019d9bd89ed96b$var$A(this, "removeListener", (i, s)=>{
            this.events.removeListener(i, s);
        }), this.logger = (0, $6GQzw.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $6GQzw.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.expirations.size;
    }
    get keys() {
        return Array.from(this.expirations.keys());
    }
    get values() {
        return Array.from(this.expirations.values());
    }
    formatTarget(e) {
        if (typeof e == "string") return (0, $3qpNA.formatTopicTarget)(e);
        if (typeof e == "number") return (0, $3qpNA.formatIdTarget)(e);
        const { message: t } = (0, $3qpNA.getInternalError)("UNKNOWN_TYPE", `Target type: ${typeof e}`);
        throw new Error(t);
    }
    async setExpirations(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getExpirations() {
        return await this.core.storage.getItem(this.storageKey);
    }
    async persist() {
        await this.setExpirations(this.values), this.events.emit($6b019d9bd89ed96b$export$9013719d9206b0c1.sync);
    }
    async restore() {
        try {
            const e = await this.getExpirations();
            if (typeof e > "u" || !e.length) return;
            if (this.expirations.size) {
                const { message: t } = (0, $3qpNA.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored expirations for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                expirations: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore expirations for ${this.name}`), this.logger.error(e);
        }
    }
    getExpiration(e) {
        const t = this.expirations.get(e);
        if (!t) {
            const { message: i } = (0, $3qpNA.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.warn(i), new Error(i);
        }
        return t;
    }
    checkExpiry(e, t) {
        const { expiry: i } = t;
        (0, $9eyak.toMiliseconds)(i) - Date.now() <= 0 && this.expire(e, t);
    }
    expire(e, t) {
        this.expirations.delete(e), this.events.emit($6b019d9bd89ed96b$export$9013719d9206b0c1.expired, {
            target: e,
            expiration: t
        });
    }
    checkExpirations() {
        this.core.relayer.connected && this.expirations.forEach((e, t)=>this.checkExpiry(t, e));
    }
    registerEventListeners() {
        this.core.heartbeat.on((0, $7G2F6.HEARTBEAT_EVENTS).pulse, ()=>this.checkExpirations()), this.events.on($6b019d9bd89ed96b$export$9013719d9206b0c1.created, (e)=>{
            const t = $6b019d9bd89ed96b$export$9013719d9206b0c1.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($6b019d9bd89ed96b$export$9013719d9206b0c1.expired, (e)=>{
            const t = $6b019d9bd89ed96b$export$9013719d9206b0c1.expired;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($6b019d9bd89ed96b$export$9013719d9206b0c1.deleted, (e)=>{
            const t = $6b019d9bd89ed96b$export$9013719d9206b0c1.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $3qpNA.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
var $6b019d9bd89ed96b$var$Fo = Object.defineProperty, $6b019d9bd89ed96b$var$Mo = (r, e, t)=>e in r ? $6b019d9bd89ed96b$var$Fo(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $6b019d9bd89ed96b$var$w = (r, e, t)=>$6b019d9bd89ed96b$var$Mo(r, typeof e != "symbol" ? e + "" : e, t);
class $6b019d9bd89ed96b$export$91a8e56769aeb334 extends (0, $2B80D.IVerify) {
    constructor(e, t, i){
        super(e, t, i), this.core = e, this.logger = t, this.store = i, $6b019d9bd89ed96b$var$w(this, "name", $6b019d9bd89ed96b$export$3b58f2450f2297e3), $6b019d9bd89ed96b$var$w(this, "abortController"), $6b019d9bd89ed96b$var$w(this, "isDevEnv"), $6b019d9bd89ed96b$var$w(this, "verifyUrlV3", $6b019d9bd89ed96b$export$412739528655ee2f), $6b019d9bd89ed96b$var$w(this, "storagePrefix", $6b019d9bd89ed96b$export$f258d29ae5e3d545), $6b019d9bd89ed96b$var$w(this, "version", $6b019d9bd89ed96b$export$f30bd3c8747cdfbe), $6b019d9bd89ed96b$var$w(this, "publicKey"), $6b019d9bd89ed96b$var$w(this, "fetchPromise"), $6b019d9bd89ed96b$var$w(this, "init", async ()=>{
            var s;
            this.isDevEnv || (this.publicKey = await this.store.getItem(this.storeKey), this.publicKey && (0, $9eyak.toMiliseconds)((s = this.publicKey) == null ? void 0 : s.expiresAt) < Date.now() && (this.logger.debug("verify v2 public key expired"), await this.removePublicKey()));
        }), $6b019d9bd89ed96b$var$w(this, "register", async (s)=>{
            if (!(0, $3qpNA.isBrowser)() || this.isDevEnv) return;
            const n = window.location.origin, { id: o, decryptedId: a } = s, c = `${this.verifyUrlV3}/attestation?projectId=${this.core.projectId}&origin=${n}&id=${o}&decryptedId=${a}`;
            try {
                const h = (0, $bfa86.getDocument)(), l = this.startAbortTimer((0, $9eyak.ONE_SECOND) * 5), d = await new Promise((g, _)=>{
                    const u = ()=>{
                        window.removeEventListener("message", x), h.body.removeChild(b), _("attestation aborted");
                    };
                    this.abortController.signal.addEventListener("abort", u);
                    const b = h.createElement("iframe");
                    b.src = c, b.style.display = "none", b.addEventListener("error", u, {
                        signal: this.abortController.signal
                    });
                    const x = (I)=>{
                        if (I.data && typeof I.data == "string") try {
                            const D = JSON.parse(I.data);
                            if (D.type === "verify_attestation") {
                                if ((0, $aKPeb.decodeJWT)(D.attestation).payload.id !== o) return;
                                clearInterval(l), h.body.removeChild(b), this.abortController.signal.removeEventListener("abort", u), window.removeEventListener("message", x), g(D.attestation === null ? "" : D.attestation);
                            }
                        } catch (D) {
                            this.logger.warn(D);
                        }
                    };
                    h.body.appendChild(b), window.addEventListener("message", x, {
                        signal: this.abortController.signal
                    });
                });
                return this.logger.debug("jwt attestation", d), d;
            } catch (h) {
                this.logger.warn(h);
            }
            return "";
        }), $6b019d9bd89ed96b$var$w(this, "resolve", async (s)=>{
            if (this.isDevEnv) return "";
            const { attestationId: n, hash: o, encryptedId: a } = s;
            if (n === "") {
                this.logger.debug("resolve: attestationId is empty, skipping");
                return;
            }
            if (n) {
                if ((0, $aKPeb.decodeJWT)(n).payload.id !== a) return;
                const h = await this.isValidJwtAttestation(n);
                if (h) {
                    if (!h.isVerified) {
                        this.logger.warn("resolve: jwt attestation: origin url not verified");
                        return;
                    }
                    return h;
                }
            }
            if (!o) return;
            const c = this.getVerifyUrl(s?.verifyUrl);
            return this.fetchAttestation(o, c);
        }), $6b019d9bd89ed96b$var$w(this, "fetchAttestation", async (s, n)=>{
            this.logger.debug(`resolving attestation: ${s} from url: ${n}`);
            const o = this.startAbortTimer((0, $9eyak.ONE_SECOND) * 5), a = await fetch(`${n}/attestation/${s}?v2Supported=true`, {
                signal: this.abortController.signal
            });
            return clearTimeout(o), a.status === 200 ? await a.json() : void 0;
        }), $6b019d9bd89ed96b$var$w(this, "getVerifyUrl", (s)=>{
            let n = s || $6b019d9bd89ed96b$export$7e3b1a28ddecdbaa;
            return $6b019d9bd89ed96b$export$be24df03c4baa778.includes(n) || (this.logger.info(`verify url: ${n}, not included in trusted list, assigning default: ${$6b019d9bd89ed96b$export$7e3b1a28ddecdbaa}`), n = $6b019d9bd89ed96b$export$7e3b1a28ddecdbaa), n;
        }), $6b019d9bd89ed96b$var$w(this, "fetchPublicKey", async ()=>{
            try {
                this.logger.debug(`fetching public key from: ${this.verifyUrlV3}`);
                const s = this.startAbortTimer((0, $9eyak.FIVE_SECONDS)), n = await fetch(`${this.verifyUrlV3}/public-key`, {
                    signal: this.abortController.signal
                });
                return clearTimeout(s), await n.json();
            } catch (s) {
                this.logger.warn(s);
            }
        }), $6b019d9bd89ed96b$var$w(this, "persistPublicKey", async (s)=>{
            this.logger.debug("persisting public key to local storage", s), await this.store.setItem(this.storeKey, s), this.publicKey = s;
        }), $6b019d9bd89ed96b$var$w(this, "removePublicKey", async ()=>{
            this.logger.debug("removing verify v2 public key from storage"), await this.store.removeItem(this.storeKey), this.publicKey = void 0;
        }), $6b019d9bd89ed96b$var$w(this, "isValidJwtAttestation", async (s)=>{
            const n = await this.getPublicKey();
            try {
                if (n) return this.validateAttestation(s, n);
            } catch (a) {
                this.logger.error(a), this.logger.warn("error validating attestation");
            }
            const o = await this.fetchAndPersistPublicKey();
            try {
                if (o) return this.validateAttestation(s, o);
            } catch (a) {
                this.logger.error(a), this.logger.warn("error validating attestation");
            }
        }), $6b019d9bd89ed96b$var$w(this, "getPublicKey", async ()=>this.publicKey ? this.publicKey : await this.fetchAndPersistPublicKey()), $6b019d9bd89ed96b$var$w(this, "fetchAndPersistPublicKey", async ()=>{
            if (this.fetchPromise) return await this.fetchPromise, this.publicKey;
            this.fetchPromise = new Promise(async (n)=>{
                const o = await this.fetchPublicKey();
                o && (await this.persistPublicKey(o), n(o));
            });
            const s = await this.fetchPromise;
            return this.fetchPromise = void 0, s;
        }), $6b019d9bd89ed96b$var$w(this, "validateAttestation", (s, n)=>{
            const o = (0, $3qpNA.verifyP256Jwt)(s, n.publicKey), a = {
                hasExpired: (0, $9eyak.toMiliseconds)(o.exp) < Date.now(),
                payload: o
            };
            if (a.hasExpired) throw this.logger.warn("resolve: jwt attestation expired"), new Error("JWT attestation expired");
            return {
                origin: a.payload.origin,
                isScam: a.payload.isScam,
                isVerified: a.payload.isVerified
            };
        }), this.logger = (0, $6GQzw.generateChildLogger)(t, this.name), this.abortController = new AbortController, this.isDevEnv = (0, $3qpNA.isTestRun)(), this.init();
    }
    get storeKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//verify:public:key";
    }
    get context() {
        return (0, $6GQzw.getLoggerContext)(this.logger);
    }
    startAbortTimer(e) {
        return this.abortController = new AbortController, setTimeout(()=>this.abortController.abort(), (0, $9eyak.toMiliseconds)(e));
    }
}
var $6b019d9bd89ed96b$var$Ko = Object.defineProperty, $6b019d9bd89ed96b$var$Bo = (r, e, t)=>e in r ? $6b019d9bd89ed96b$var$Ko(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $6b019d9bd89ed96b$var$Fi = (r, e, t)=>$6b019d9bd89ed96b$var$Bo(r, typeof e != "symbol" ? e + "" : e, t);
class $6b019d9bd89ed96b$export$c393c48c5b0cf59a extends (0, $2B80D.IEchoClient) {
    constructor(e, t){
        super(e, t), this.projectId = e, this.logger = t, $6b019d9bd89ed96b$var$Fi(this, "context", $6b019d9bd89ed96b$export$40c022d2cffe0adc), $6b019d9bd89ed96b$var$Fi(this, "registerDeviceToken", async (i)=>{
            const { clientId: s, token: n, notificationType: o, enableEncrypted: a = !1 } = i, c = `${$6b019d9bd89ed96b$export$3c48c4faab79aab1}/${this.projectId}/clients`;
            await fetch(c, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    client_id: s,
                    type: o,
                    token: n,
                    always_raw: a
                })
            });
        }), this.logger = (0, $6GQzw.generateChildLogger)(t, this.context);
    }
}
var $6b019d9bd89ed96b$var$Vo = Object.defineProperty, $6b019d9bd89ed96b$var$Ki = Object.getOwnPropertySymbols, $6b019d9bd89ed96b$var$qo = Object.prototype.hasOwnProperty, $6b019d9bd89ed96b$var$Go = Object.prototype.propertyIsEnumerable, $6b019d9bd89ed96b$var$Ze = (r, e, t)=>e in r ? $6b019d9bd89ed96b$var$Vo(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $6b019d9bd89ed96b$var$be = (r, e)=>{
    for(var t in e || (e = {}))$6b019d9bd89ed96b$var$qo.call(e, t) && $6b019d9bd89ed96b$var$Ze(r, t, e[t]);
    if ($6b019d9bd89ed96b$var$Ki) for (var t of $6b019d9bd89ed96b$var$Ki(e))$6b019d9bd89ed96b$var$Go.call(e, t) && $6b019d9bd89ed96b$var$Ze(r, t, e[t]);
    return r;
}, $6b019d9bd89ed96b$var$E = (r, e, t)=>$6b019d9bd89ed96b$var$Ze(r, typeof e != "symbol" ? e + "" : e, t);
class $6b019d9bd89ed96b$export$f4a30e909fe70796 extends (0, $2B80D.IEventClient) {
    constructor(e, t, i = !0){
        super(e, t, i), this.core = e, this.logger = t, $6b019d9bd89ed96b$var$E(this, "context", $6b019d9bd89ed96b$export$e020229e09910965), $6b019d9bd89ed96b$var$E(this, "storagePrefix", $6b019d9bd89ed96b$export$f258d29ae5e3d545), $6b019d9bd89ed96b$var$E(this, "storageVersion", $6b019d9bd89ed96b$export$c73857c3a3d16b1c), $6b019d9bd89ed96b$var$E(this, "events", new Map), $6b019d9bd89ed96b$var$E(this, "shouldPersist", !1), $6b019d9bd89ed96b$var$E(this, "init", async ()=>{
            if (!(0, $3qpNA.isTestRun)()) try {
                const s = {
                    eventId: (0, $3qpNA.uuidv4)(),
                    timestamp: Date.now(),
                    domain: this.getAppDomain(),
                    props: {
                        event: "INIT",
                        type: "",
                        properties: {
                            client_id: await this.core.crypto.getClientId(),
                            user_agent: (0, $3qpNA.formatUA)(this.core.relayer.protocol, this.core.relayer.version, $6b019d9bd89ed96b$export$5f30917a6f8c9025)
                        }
                    }
                };
                await this.sendEvent([
                    s
                ]);
            } catch (s) {
                this.logger.warn(s);
            }
        }), $6b019d9bd89ed96b$var$E(this, "createEvent", (s)=>{
            const { event: n = "ERROR", type: o = "", properties: { topic: a, trace: c } } = s, h = (0, $3qpNA.uuidv4)(), l = this.core.projectId || "", d = Date.now(), g = $6b019d9bd89ed96b$var$be({
                eventId: h,
                timestamp: d,
                props: {
                    event: n,
                    type: o,
                    properties: {
                        topic: a,
                        trace: c
                    }
                },
                bundleId: l,
                domain: this.getAppDomain()
            }, this.setMethods(h));
            return this.telemetryEnabled && (this.events.set(h, g), this.shouldPersist = !0), g;
        }), $6b019d9bd89ed96b$var$E(this, "getEvent", (s)=>{
            const { eventId: n, topic: o } = s;
            if (n) return this.events.get(n);
            const a = Array.from(this.events.values()).find((c)=>c.props.properties.topic === o);
            if (a) return $6b019d9bd89ed96b$var$be($6b019d9bd89ed96b$var$be({}, a), this.setMethods(a.eventId));
        }), $6b019d9bd89ed96b$var$E(this, "deleteEvent", (s)=>{
            const { eventId: n } = s;
            this.events.delete(n), this.shouldPersist = !0;
        }), $6b019d9bd89ed96b$var$E(this, "setEventListeners", ()=>{
            this.core.heartbeat.on((0, $7G2F6.HEARTBEAT_EVENTS).pulse, async ()=>{
                this.shouldPersist && await this.persist(), this.events.forEach((s)=>{
                    (0, $9eyak.fromMiliseconds)(Date.now()) - (0, $9eyak.fromMiliseconds)(s.timestamp) > $6b019d9bd89ed96b$export$79348045429687e2 && (this.events.delete(s.eventId), this.shouldPersist = !0);
                });
            });
        }), $6b019d9bd89ed96b$var$E(this, "setMethods", (s)=>({
                addTrace: (n)=>this.addTrace(s, n),
                setError: (n)=>this.setError(s, n)
            })), $6b019d9bd89ed96b$var$E(this, "addTrace", (s, n)=>{
            const o = this.events.get(s);
            o && (o.props.properties.trace.push(n), this.events.set(s, o), this.shouldPersist = !0);
        }), $6b019d9bd89ed96b$var$E(this, "setError", (s, n)=>{
            const o = this.events.get(s);
            o && (o.props.type = n, o.timestamp = Date.now(), this.events.set(s, o), this.shouldPersist = !0);
        }), $6b019d9bd89ed96b$var$E(this, "persist", async ()=>{
            await this.core.storage.setItem(this.storageKey, Array.from(this.events.values())), this.shouldPersist = !1;
        }), $6b019d9bd89ed96b$var$E(this, "restore", async ()=>{
            try {
                const s = await this.core.storage.getItem(this.storageKey) || [];
                if (!s.length) return;
                s.forEach((n)=>{
                    this.events.set(n.eventId, $6b019d9bd89ed96b$var$be($6b019d9bd89ed96b$var$be({}, n), this.setMethods(n.eventId)));
                });
            } catch (s) {
                this.logger.warn(s);
            }
        }), $6b019d9bd89ed96b$var$E(this, "submit", async ()=>{
            if (!this.telemetryEnabled || this.events.size === 0) return;
            const s = [];
            for (const [n, o] of this.events)o.props.type && s.push(o);
            if (s.length !== 0) try {
                if ((await this.sendEvent(s)).ok) for (const n of s)this.events.delete(n.eventId), this.shouldPersist = !0;
            } catch (n) {
                this.logger.warn(n);
            }
        }), $6b019d9bd89ed96b$var$E(this, "sendEvent", async (s)=>{
            const n = this.getAppDomain() ? "" : "&sp=desktop";
            return await fetch(`${$6b019d9bd89ed96b$export$bb6a8925f3cb1ca}?projectId=${this.core.projectId}&st=events_sdk&sv=js-${$6b019d9bd89ed96b$export$5f30917a6f8c9025}${n}`, {
                method: "POST",
                body: JSON.stringify(s)
            });
        }), $6b019d9bd89ed96b$var$E(this, "getAppDomain", ()=>(0, $3qpNA.getAppMetadata)().url), this.logger = (0, $6GQzw.generateChildLogger)(t, this.context), this.telemetryEnabled = i, i ? this.restore().then(async ()=>{
            await this.submit(), this.setEventListeners();
        }) : this.persist();
    }
    get storageKey() {
        return this.storagePrefix + this.storageVersion + this.core.customStoragePrefix + "//" + this.context;
    }
}
var $6b019d9bd89ed96b$var$Wo = Object.defineProperty, $6b019d9bd89ed96b$var$Vi = Object.getOwnPropertySymbols, $6b019d9bd89ed96b$var$Ho = Object.prototype.hasOwnProperty, $6b019d9bd89ed96b$var$Yo = Object.prototype.propertyIsEnumerable, $6b019d9bd89ed96b$var$Qe = (r, e, t)=>e in r ? $6b019d9bd89ed96b$var$Wo(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $6b019d9bd89ed96b$var$qi = (r, e)=>{
    for(var t in e || (e = {}))$6b019d9bd89ed96b$var$Ho.call(e, t) && $6b019d9bd89ed96b$var$Qe(r, t, e[t]);
    if ($6b019d9bd89ed96b$var$Vi) for (var t of $6b019d9bd89ed96b$var$Vi(e))$6b019d9bd89ed96b$var$Yo.call(e, t) && $6b019d9bd89ed96b$var$Qe(r, t, e[t]);
    return r;
}, $6b019d9bd89ed96b$var$v = (r, e, t)=>$6b019d9bd89ed96b$var$Qe(r, typeof e != "symbol" ? e + "" : e, t);
class $6b019d9bd89ed96b$export$2e2bcd8739ae039 extends (0, $2B80D.ICore) {
    constructor(e){
        var t;
        super(e), $6b019d9bd89ed96b$var$v(this, "protocol", $6b019d9bd89ed96b$export$51b1c900ac262bdf), $6b019d9bd89ed96b$var$v(this, "version", $6b019d9bd89ed96b$export$f30bd3c8747cdfbe), $6b019d9bd89ed96b$var$v(this, "name", $6b019d9bd89ed96b$export$d47601f9de5ee22b), $6b019d9bd89ed96b$var$v(this, "relayUrl"), $6b019d9bd89ed96b$var$v(this, "projectId"), $6b019d9bd89ed96b$var$v(this, "customStoragePrefix"), $6b019d9bd89ed96b$var$v(this, "events", new (0, $5yFVO.EventEmitter)), $6b019d9bd89ed96b$var$v(this, "logger"), $6b019d9bd89ed96b$var$v(this, "heartbeat"), $6b019d9bd89ed96b$var$v(this, "relayer"), $6b019d9bd89ed96b$var$v(this, "crypto"), $6b019d9bd89ed96b$var$v(this, "storage"), $6b019d9bd89ed96b$var$v(this, "history"), $6b019d9bd89ed96b$var$v(this, "expirer"), $6b019d9bd89ed96b$var$v(this, "pairing"), $6b019d9bd89ed96b$var$v(this, "verify"), $6b019d9bd89ed96b$var$v(this, "echoClient"), $6b019d9bd89ed96b$var$v(this, "linkModeSupportedApps"), $6b019d9bd89ed96b$var$v(this, "eventClient"), $6b019d9bd89ed96b$var$v(this, "initialized", !1), $6b019d9bd89ed96b$var$v(this, "logChunkController"), $6b019d9bd89ed96b$var$v(this, "on", (a, c)=>this.events.on(a, c)), $6b019d9bd89ed96b$var$v(this, "once", (a, c)=>this.events.once(a, c)), $6b019d9bd89ed96b$var$v(this, "off", (a, c)=>this.events.off(a, c)), $6b019d9bd89ed96b$var$v(this, "removeListener", (a, c)=>this.events.removeListener(a, c)), $6b019d9bd89ed96b$var$v(this, "dispatchEnvelope", ({ topic: a, message: c, sessionExists: h })=>{
            if (!a || !c) return;
            const l = {
                topic: a,
                message: c,
                publishedAt: Date.now(),
                transportType: $6b019d9bd89ed96b$export$326e296bb8673773.link_mode
            };
            this.relayer.onLinkMessageEvent(l, {
                sessionExists: h
            });
        });
        const i = this.getGlobalCore(e?.customStoragePrefix);
        if (i) try {
            return this.customStoragePrefix = i.customStoragePrefix, this.logger = i.logger, this.heartbeat = i.heartbeat, this.crypto = i.crypto, this.history = i.history, this.expirer = i.expirer, this.storage = i.storage, this.relayer = i.relayer, this.pairing = i.pairing, this.verify = i.verify, this.echoClient = i.echoClient, this.linkModeSupportedApps = i.linkModeSupportedApps, this.eventClient = i.eventClient, this.initialized = i.initialized, this.logChunkController = i.logChunkController, i;
        } catch (a) {
            console.warn("Failed to copy global core", a);
        }
        this.projectId = e?.projectId, this.relayUrl = e?.relayUrl || $6b019d9bd89ed96b$export$a68061e6c48f332a, this.customStoragePrefix = e != null && e.customStoragePrefix ? `:${e.customStoragePrefix}` : "";
        const s = (0, $6GQzw.getDefaultLoggerOptions)({
            level: typeof e?.logger == "string" && e.logger ? e.logger : $6b019d9bd89ed96b$export$db0fdb6d486555c2.logger,
            name: $6b019d9bd89ed96b$export$d47601f9de5ee22b
        }), { logger: n, chunkLoggerController: o } = (0, $6GQzw.generatePlatformLogger)({
            opts: s,
            maxSizeInBytes: e?.maxLogBlobSizeInBytes,
            loggerOverride: e?.logger
        });
        this.logChunkController = o, (t = this.logChunkController) != null && t.downloadLogsBlobInBrowser && (window.downloadLogsBlobInBrowser = async ()=>{
            var a, c;
            (a = this.logChunkController) != null && a.downloadLogsBlobInBrowser && ((c = this.logChunkController) == null || c.downloadLogsBlobInBrowser({
                clientId: await this.crypto.getClientId()
            }));
        }), this.logger = (0, $6GQzw.generateChildLogger)(n, this.name), this.heartbeat = new (0, $7G2F6.HeartBeat), this.crypto = new $6b019d9bd89ed96b$export$8ac8b6291b7ccf24(this, this.logger, e?.keychain), this.history = new $6b019d9bd89ed96b$export$eeb4f10f25d479cb(this, this.logger), this.expirer = new $6b019d9bd89ed96b$export$e76805ce609031cb(this, this.logger), this.storage = e != null && e.storage ? e.storage : new (0, $2nKgt.default)($6b019d9bd89ed96b$var$qi($6b019d9bd89ed96b$var$qi({}, $6b019d9bd89ed96b$export$ba920abfe854b85d), e?.storageOptions)), this.relayer = new $6b019d9bd89ed96b$export$70e73aa29a3d4407({
            core: this,
            logger: this.logger,
            relayUrl: this.relayUrl,
            projectId: this.projectId
        }), this.pairing = new $6b019d9bd89ed96b$export$3370ee24730992a3(this, this.logger), this.verify = new $6b019d9bd89ed96b$export$91a8e56769aeb334(this, this.logger, this.storage), this.echoClient = new $6b019d9bd89ed96b$export$c393c48c5b0cf59a(this.projectId || "", this.logger), this.linkModeSupportedApps = [], this.eventClient = new $6b019d9bd89ed96b$export$f4a30e909fe70796(this, this.logger, e?.telemetryEnabled), this.setGlobalCore(this);
    }
    static async init(e) {
        const t = new $6b019d9bd89ed96b$export$2e2bcd8739ae039(e);
        await t.initialize();
        const i = await t.crypto.getClientId();
        return await t.storage.setItem($6b019d9bd89ed96b$export$9e4ca561755938da, i), t;
    }
    get context() {
        return (0, $6GQzw.getLoggerContext)(this.logger);
    }
    async start() {
        this.initialized || await this.initialize();
    }
    async getLogsBlob() {
        var e;
        return (e = this.logChunkController) == null ? void 0 : e.logsToBlob({
            clientId: await this.crypto.getClientId()
        });
    }
    async addLinkModeSupportedApp(e) {
        this.linkModeSupportedApps.includes(e) || (this.linkModeSupportedApps.push(e), await this.storage.setItem($6b019d9bd89ed96b$export$1989eec3a412fb97, this.linkModeSupportedApps));
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.crypto.init(), await this.history.init(), await this.expirer.init(), await this.relayer.init(), await this.heartbeat.init(), await this.pairing.init(), this.linkModeSupportedApps = await this.storage.getItem($6b019d9bd89ed96b$export$1989eec3a412fb97) || [], this.initialized = !0, this.logger.info("Core Initialization Success");
        } catch (e) {
            throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`, e), this.logger.error(e.message), e;
        }
    }
    getGlobalCore(e = "") {
        try {
            if (this.isGlobalCoreDisabled()) return;
            const t = `_walletConnectCore_${e}`, i = `${t}_count`;
            return globalThis[i] = (globalThis[i] || 0) + 1, globalThis[i] > 1 && console.warn(`WalletConnect Core is already initialized. This is probably a mistake and can lead to unexpected behavior. Init() was called ${globalThis[i]} times.`), globalThis[t];
        } catch (t) {
            console.warn("Failed to get global WalletConnect core", t);
            return;
        }
    }
    setGlobalCore(e) {
        var t;
        try {
            if (this.isGlobalCoreDisabled()) return;
            const i = `_walletConnectCore_${((t = e.opts) == null ? void 0 : t.customStoragePrefix) || ""}`;
            globalThis[i] = e;
        } catch (i) {
            console.warn("Failed to set global WalletConnect core", i);
        }
    }
    isGlobalCoreDisabled() {
        try {
            return typeof $kuzpm < "u" && false;
        } catch  {
            return !0;
        }
    }
}
const $6b019d9bd89ed96b$export$4143ab5b91744744 = $6b019d9bd89ed96b$export$2e2bcd8739ae039;

});
parcelRegister("5yFVO", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $40c0a773334e9771$var$R = typeof Reflect === "object" ? Reflect : null;
var $40c0a773334e9771$var$ReflectApply = $40c0a773334e9771$var$R && typeof $40c0a773334e9771$var$R.apply === "function" ? $40c0a773334e9771$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $40c0a773334e9771$var$ReflectOwnKeys;
if ($40c0a773334e9771$var$R && typeof $40c0a773334e9771$var$R.ownKeys === "function") $40c0a773334e9771$var$ReflectOwnKeys = $40c0a773334e9771$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $40c0a773334e9771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $40c0a773334e9771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $40c0a773334e9771$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $40c0a773334e9771$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $40c0a773334e9771$var$EventEmitter() {
    $40c0a773334e9771$var$EventEmitter.init.call(this);
}
module.exports = $40c0a773334e9771$var$EventEmitter;
module.exports.once = $40c0a773334e9771$var$once;
// Backwards-compat with node 0.10.x
$40c0a773334e9771$var$EventEmitter.EventEmitter = $40c0a773334e9771$var$EventEmitter;
$40c0a773334e9771$var$EventEmitter.prototype._events = undefined;
$40c0a773334e9771$var$EventEmitter.prototype._eventsCount = 0;
$40c0a773334e9771$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $40c0a773334e9771$var$defaultMaxListeners = 10;
function $40c0a773334e9771$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($40c0a773334e9771$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $40c0a773334e9771$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $40c0a773334e9771$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $40c0a773334e9771$var$defaultMaxListeners = arg;
    }
});
$40c0a773334e9771$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$40c0a773334e9771$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $40c0a773334e9771$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $40c0a773334e9771$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $40c0a773334e9771$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$40c0a773334e9771$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $40c0a773334e9771$var$_getMaxListeners(this);
};
$40c0a773334e9771$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $40c0a773334e9771$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $40c0a773334e9771$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$40c0a773334e9771$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $40c0a773334e9771$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $40c0a773334e9771$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $40c0a773334e9771$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $40c0a773334e9771$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$40c0a773334e9771$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $40c0a773334e9771$var$_addListener(this, type, listener, false);
};
$40c0a773334e9771$var$EventEmitter.prototype.on = $40c0a773334e9771$var$EventEmitter.prototype.addListener;
$40c0a773334e9771$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $40c0a773334e9771$var$_addListener(this, type, listener, true);
};
function $40c0a773334e9771$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $40c0a773334e9771$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $40c0a773334e9771$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$40c0a773334e9771$var$EventEmitter.prototype.once = function once(type, listener) {
    $40c0a773334e9771$var$checkListener(listener);
    this.on(type, $40c0a773334e9771$var$_onceWrap(this, type, listener));
    return this;
};
$40c0a773334e9771$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $40c0a773334e9771$var$checkListener(listener);
    this.prependListener(type, $40c0a773334e9771$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$40c0a773334e9771$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $40c0a773334e9771$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $40c0a773334e9771$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$40c0a773334e9771$var$EventEmitter.prototype.off = $40c0a773334e9771$var$EventEmitter.prototype.removeListener;
$40c0a773334e9771$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $40c0a773334e9771$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $40c0a773334e9771$var$unwrapListeners(evlistener) : $40c0a773334e9771$var$arrayClone(evlistener, evlistener.length);
}
$40c0a773334e9771$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $40c0a773334e9771$var$_listeners(this, type, true);
};
$40c0a773334e9771$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $40c0a773334e9771$var$_listeners(this, type, false);
};
$40c0a773334e9771$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $40c0a773334e9771$var$listenerCount.call(emitter, type);
};
$40c0a773334e9771$var$EventEmitter.prototype.listenerCount = $40c0a773334e9771$var$listenerCount;
function $40c0a773334e9771$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$40c0a773334e9771$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $40c0a773334e9771$var$ReflectOwnKeys(this._events) : [];
};
function $40c0a773334e9771$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $40c0a773334e9771$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $40c0a773334e9771$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $40c0a773334e9771$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $40c0a773334e9771$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $40c0a773334e9771$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $40c0a773334e9771$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $40c0a773334e9771$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $40c0a773334e9771$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("7G2F6", function(module, exports) {

$parcel$export(module.exports, "HEARTBEAT_EVENTS", () => $596e853ab16203e9$export$f3340c1af6bee4b5);
$parcel$export(module.exports, "HeartBeat", () => $596e853ab16203e9$export$996c9b2cd7645b55);

var $5yFVO = parcelRequire("5yFVO");

var $9eyak = parcelRequire("9eyak");
parcelRequire("6nxVc");
var $czCIg = parcelRequire("czCIg");
class $596e853ab16203e9$export$d31d5212998928bd extends (0, $czCIg.IEvents) {
    constructor(e){
        super();
    }
}
const $596e853ab16203e9$export$31c453b5fe09788d = (0, $9eyak.FIVE_SECONDS), $596e853ab16203e9$export$f3340c1af6bee4b5 = {
    pulse: "heartbeat_pulse"
};
class $596e853ab16203e9$export$996c9b2cd7645b55 extends $596e853ab16203e9$export$d31d5212998928bd {
    constructor(e){
        super(e), this.events = new (0, $5yFVO.EventEmitter), this.interval = $596e853ab16203e9$export$31c453b5fe09788d, this.interval = e?.interval || $596e853ab16203e9$export$31c453b5fe09788d;
    }
    static async init(e) {
        const t = new $596e853ab16203e9$export$996c9b2cd7645b55(e);
        return await t.init(), t;
    }
    async init() {
        await this.initialize();
    }
    stop() {
        clearInterval(this.intervalRef);
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async initialize() {
        this.intervalRef = setInterval(()=>this.pulse(), (0, $9eyak.toMiliseconds)(this.interval));
    }
    pulse() {
        this.events.emit($596e853ab16203e9$export$f3340c1af6bee4b5.pulse);
    }
}

});
parcelRegister("9eyak", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kZbRE = parcelRequire("kZbRE");

$kZbRE.__exportStar((parcelRequire("35H3g")), module.exports);

$kZbRE.__exportStar((parcelRequire("2s6hV")), module.exports);

$kZbRE.__exportStar((parcelRequire("ghluR")), module.exports);

$kZbRE.__exportStar((parcelRequire("l1hb1")), module.exports);

});
parcelRegister("kZbRE", function(module, exports) {

$parcel$export(module.exports, "__exportStar", () => $f472b52a6955a172$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $f472b52a6955a172$var$extendStatics = function(d, b) {
    $f472b52a6955a172$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $f472b52a6955a172$var$extendStatics(d, b);
};
function $f472b52a6955a172$export$a8ba968b8961cb8a(d, b) {
    $f472b52a6955a172$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f472b52a6955a172$export$18ce0697a983be9b = function() {
    $f472b52a6955a172$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f472b52a6955a172$export$18ce0697a983be9b.apply(this, arguments);
};
function $f472b52a6955a172$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f472b52a6955a172$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f472b52a6955a172$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f472b52a6955a172$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f472b52a6955a172$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f472b52a6955a172$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $f472b52a6955a172$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $f472b52a6955a172$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $f472b52a6955a172$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f472b52a6955a172$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f472b52a6955a172$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f472b52a6955a172$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f472b52a6955a172$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f472b52a6955a172$export$10c90e4f7922046c(v) {
    return this instanceof $f472b52a6955a172$export$10c90e4f7922046c ? (this.v = v, this) : new $f472b52a6955a172$export$10c90e4f7922046c(v);
}
function $f472b52a6955a172$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f472b52a6955a172$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f472b52a6955a172$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f472b52a6955a172$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $f472b52a6955a172$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f472b52a6955a172$export$19a8beecd37a4c45 === "function" ? $f472b52a6955a172$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f472b52a6955a172$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $f472b52a6955a172$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $f472b52a6955a172$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f472b52a6955a172$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $f472b52a6955a172$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("35H3g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kZbRE = parcelRequire("kZbRE");

$kZbRE.__exportStar((parcelRequire("jeqnh")), module.exports);

$kZbRE.__exportStar((parcelRequire("6ZxDZ")), module.exports);

});
parcelRegister("jeqnh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.delay = void 0;
function $e003c88b940570e6$var$delay(timeout) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(true);
        }, timeout);
    });
}
module.exports.delay = $e003c88b940570e6$var$delay;

});

parcelRegister("6ZxDZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromMiliseconds = module.exports.toMiliseconds = void 0;

var $l1hb1 = parcelRequire("l1hb1");
function $5172899009118afb$var$toMiliseconds(seconds) {
    return seconds * $l1hb1.ONE_THOUSAND;
}
module.exports.toMiliseconds = $5172899009118afb$var$toMiliseconds;
function $5172899009118afb$var$fromMiliseconds(miliseconds) {
    return Math.floor(miliseconds / $l1hb1.ONE_THOUSAND);
}
module.exports.fromMiliseconds = $5172899009118afb$var$fromMiliseconds;

});
parcelRegister("l1hb1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kZbRE = parcelRequire("kZbRE");

$kZbRE.__exportStar((parcelRequire("hDg6A")), module.exports);

$kZbRE.__exportStar((parcelRequire("8J10i")), module.exports);

});
parcelRegister("hDg6A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_THOUSAND = module.exports.ONE_HUNDRED = void 0;
module.exports.ONE_HUNDRED = 100;
module.exports.ONE_THOUSAND = 1000;

});

parcelRegister("8J10i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_YEAR = module.exports.FOUR_WEEKS = module.exports.THREE_WEEKS = module.exports.TWO_WEEKS = module.exports.ONE_WEEK = module.exports.THIRTY_DAYS = module.exports.SEVEN_DAYS = module.exports.FIVE_DAYS = module.exports.THREE_DAYS = module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS = module.exports.TWELVE_HOURS = module.exports.SIX_HOURS = module.exports.THREE_HOURS = module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES = module.exports.THIRTY_MINUTES = module.exports.TEN_MINUTES = module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS = module.exports.THIRTY_SECONDS = module.exports.TEN_SECONDS = module.exports.FIVE_SECONDS = module.exports.ONE_SECOND = void 0;
module.exports.ONE_SECOND = 1;
module.exports.FIVE_SECONDS = 5;
module.exports.TEN_SECONDS = 10;
module.exports.THIRTY_SECONDS = 30;
module.exports.SIXTY_SECONDS = 60;
module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS;
module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE * 5;
module.exports.TEN_MINUTES = module.exports.ONE_MINUTE * 10;
module.exports.THIRTY_MINUTES = module.exports.ONE_MINUTE * 30;
module.exports.SIXTY_MINUTES = module.exports.ONE_MINUTE * 60;
module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES;
module.exports.THREE_HOURS = module.exports.ONE_HOUR * 3;
module.exports.SIX_HOURS = module.exports.ONE_HOUR * 6;
module.exports.TWELVE_HOURS = module.exports.ONE_HOUR * 12;
module.exports.TWENTY_FOUR_HOURS = module.exports.ONE_HOUR * 24;
module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS;
module.exports.THREE_DAYS = module.exports.ONE_DAY * 3;
module.exports.FIVE_DAYS = module.exports.ONE_DAY * 5;
module.exports.SEVEN_DAYS = module.exports.ONE_DAY * 7;
module.exports.THIRTY_DAYS = module.exports.ONE_DAY * 30;
module.exports.ONE_WEEK = module.exports.SEVEN_DAYS;
module.exports.TWO_WEEKS = module.exports.ONE_WEEK * 2;
module.exports.THREE_WEEKS = module.exports.ONE_WEEK * 3;
module.exports.FOUR_WEEKS = module.exports.ONE_WEEK * 4;
module.exports.ONE_YEAR = module.exports.ONE_DAY * 365;

});




parcelRegister("2s6hV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Watch = void 0;
class $1c9312ff2fa33f1b$var$Watch {
    constructor(){
        this.timestamps = new Map();
    }
    start(label) {
        if (this.timestamps.has(label)) throw new Error(`Watch already started for label: ${label}`);
        this.timestamps.set(label, {
            started: Date.now()
        });
    }
    stop(label) {
        const timestamp = this.get(label);
        if (typeof timestamp.elapsed !== "undefined") throw new Error(`Watch already stopped for label: ${label}`);
        const elapsed = Date.now() - timestamp.started;
        this.timestamps.set(label, {
            started: timestamp.started,
            elapsed: elapsed
        });
    }
    get(label) {
        const timestamp = this.timestamps.get(label);
        if (typeof timestamp === "undefined") throw new Error(`No timestamp found for label: ${label}`);
        return timestamp;
    }
    elapsed(label) {
        const timestamp = this.get(label);
        const elapsed = timestamp.elapsed || Date.now() - timestamp.started;
        return elapsed;
    }
}
module.exports.Watch = $1c9312ff2fa33f1b$var$Watch;
module.exports.default = $1c9312ff2fa33f1b$var$Watch;

});

parcelRegister("ghluR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kZbRE = parcelRequire("kZbRE");

$kZbRE.__exportStar((parcelRequire("3KqTf")), module.exports);

});
parcelRegister("3KqTf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IWatch = void 0;
class $2baa86cf81e84ad1$var$IWatch {
}
module.exports.IWatch = $2baa86cf81e84ad1$var$IWatch;

});



parcelRegister("6nxVc", function(module, exports) {
$parcel$export(module.exports, "IEvents", () => (parcelRequire("czCIg")).IEvents);
parcelRequire("czCIg");

});
parcelRegister("czCIg", function(module, exports) {

$parcel$export(module.exports, "IEvents", () => $9276c87bd85edce3$export$ab429ec7e240e546);
class $9276c87bd85edce3$export$ab429ec7e240e546 {
}

});



parcelRegister("2nKgt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bc19df600df56ed$export$8536778e426ddf92);

var $51ZY4 = parcelRequire("51ZY4");

var $hD3IG = parcelRequire("hD3IG");

var $bREX4 = parcelRequire("bREX4");
function $1bc19df600df56ed$var$C(i) {
    return i;
}
const $1bc19df600df56ed$var$x = "idb-keyval";
var $1bc19df600df56ed$var$z = (i = {})=>{
    const t = i.base && i.base.length > 0 ? `${i.base}:` : "", e = (s)=>t + s;
    let n;
    return i.dbName && i.storeName && (n = (0, $hD3IG.createStore)(i.dbName, i.storeName)), {
        name: $1bc19df600df56ed$var$x,
        options: i,
        async hasItem (s) {
            return !(typeof await (0, $hD3IG.get)(e(s), n) > "u");
        },
        async getItem (s) {
            return await (0, $hD3IG.get)(e(s), n) ?? null;
        },
        setItem (s, a) {
            return (0, $hD3IG.set)(e(s), a, n);
        },
        removeItem (s) {
            return (0, $hD3IG.del)(e(s), n);
        },
        getKeys () {
            return (0, $hD3IG.keys)(n);
        },
        clear () {
            return (0, $hD3IG.clear)(n);
        }
    };
};
const $1bc19df600df56ed$var$D = "WALLET_CONNECT_V2_INDEXED_DB", $1bc19df600df56ed$var$E = "keyvaluestorage";
class $1bc19df600df56ed$var$_ {
    constructor(){
        this.indexedDb = (0, $51ZY4.createStorage)({
            driver: $1bc19df600df56ed$var$z({
                dbName: $1bc19df600df56ed$var$D,
                storeName: $1bc19df600df56ed$var$E
            })
        });
    }
    async getKeys() {
        return this.indexedDb.getKeys();
    }
    async getEntries() {
        return (await this.indexedDb.getItems(await this.indexedDb.getKeys())).map((t)=>[
                t.key,
                t.value
            ]);
    }
    async getItem(t) {
        const e = await this.indexedDb.getItem(t);
        if (e !== null) return e;
    }
    async setItem(t, e) {
        await this.indexedDb.setItem(t, (0, $bREX4.safeJsonStringify)(e));
    }
    async removeItem(t) {
        await this.indexedDb.removeItem(t);
    }
}
var $1bc19df600df56ed$var$l = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {}, $1bc19df600df56ed$var$c = {
    exports: {}
};
(function() {
    let i;
    function t() {}
    i = t, i.prototype.getItem = function(e) {
        return this.hasOwnProperty(e) ? String(this[e]) : null;
    }, i.prototype.setItem = function(e, n) {
        this[e] = String(n);
    }, i.prototype.removeItem = function(e) {
        delete this[e];
    }, i.prototype.clear = function() {
        const e = this;
        Object.keys(e).forEach(function(n) {
            e[n] = void 0, delete e[n];
        });
    }, i.prototype.key = function(e) {
        return e = e || 0, Object.keys(this)[e];
    }, i.prototype.__defineGetter__("length", function() {
        return Object.keys(this).length;
    }), typeof $1bc19df600df56ed$var$l < "u" && $1bc19df600df56ed$var$l.localStorage ? $1bc19df600df56ed$var$c.exports = $1bc19df600df56ed$var$l.localStorage : typeof window < "u" && window.localStorage ? $1bc19df600df56ed$var$c.exports = window.localStorage : $1bc19df600df56ed$var$c.exports = new t;
})();
function $1bc19df600df56ed$var$k(i) {
    var t;
    return [
        i[0],
        (0, $bREX4.safeJsonParse)((t = i[1]) != null ? t : "")
    ];
}
class $1bc19df600df56ed$var$K {
    constructor(){
        this.localStorage = $1bc19df600df56ed$var$c.exports;
    }
    async getKeys() {
        return Object.keys(this.localStorage);
    }
    async getEntries() {
        return Object.entries(this.localStorage).map($1bc19df600df56ed$var$k);
    }
    async getItem(t) {
        const e = this.localStorage.getItem(t);
        if (e !== null) return (0, $bREX4.safeJsonParse)(e);
    }
    async setItem(t, e) {
        this.localStorage.setItem(t, (0, $bREX4.safeJsonStringify)(e));
    }
    async removeItem(t) {
        this.localStorage.removeItem(t);
    }
}
const $1bc19df600df56ed$var$N = "wc_storage_version", $1bc19df600df56ed$var$y = 1, $1bc19df600df56ed$var$O = async (i, t, e)=>{
    const n = $1bc19df600df56ed$var$N, s = await t.getItem(n);
    if (s && s >= $1bc19df600df56ed$var$y) {
        e(t);
        return;
    }
    const a = await i.getKeys();
    if (!a.length) {
        e(t);
        return;
    }
    const m = [];
    for(; a.length;){
        const r = a.shift();
        if (!r) continue;
        const o = r.toLowerCase();
        if (o.includes("wc@") || o.includes("walletconnect") || o.includes("wc_") || o.includes("wallet_connect")) {
            const f = await i.getItem(r);
            await t.setItem(r, f), m.push(r);
        }
    }
    await t.setItem(n, $1bc19df600df56ed$var$y), e(t), $1bc19df600df56ed$var$j(i, m);
}, $1bc19df600df56ed$var$j = async (i, t)=>{
    t.length && t.forEach(async (e)=>{
        await i.removeItem(e);
    });
};
class $1bc19df600df56ed$export$8536778e426ddf92 {
    constructor(){
        this.initialized = !1, this.setInitialized = (e)=>{
            this.storage = e, this.initialized = !0;
        };
        const t = new $1bc19df600df56ed$var$K;
        this.storage = t;
        try {
            const e = new $1bc19df600df56ed$var$_;
            $1bc19df600df56ed$var$O(t, e, this.setInitialized);
        } catch  {
            this.initialized = !0;
        }
    }
    async getKeys() {
        return await this.initialize(), this.storage.getKeys();
    }
    async getEntries() {
        return await this.initialize(), this.storage.getEntries();
    }
    async getItem(t) {
        return await this.initialize(), this.storage.getItem(t);
    }
    async setItem(t, e) {
        return await this.initialize(), this.storage.setItem(t, e);
    }
    async removeItem(t) {
        return await this.initialize(), this.storage.removeItem(t);
    }
    async initialize() {
        this.initialized || await new Promise((t)=>{
            const e = setInterval(()=>{
                this.initialized && (clearInterval(e), t());
            }, 20);
        });
    }
}

});
parcelRegister("51ZY4", function(module, exports) {

$parcel$export(module.exports, "createStorage", () => $76905bcaa0f218e5$export$d184a47a971dd4b9);

var $kJEP3 = parcelRequire("kJEP3");

var $fOAQK = parcelRequire("fOAQK");
function $76905bcaa0f218e5$export$b5cf55d52d4cddb(factory) {
    return factory;
}
const $76905bcaa0f218e5$var$DRIVER_NAME = "memory";
const $76905bcaa0f218e5$var$memory = $76905bcaa0f218e5$export$b5cf55d52d4cddb(()=>{
    const data = /* @__PURE__ */ new Map();
    return {
        name: $76905bcaa0f218e5$var$DRIVER_NAME,
        getInstance: ()=>data,
        hasItem (key) {
            return data.has(key);
        },
        getItem (key) {
            return data.get(key) ?? null;
        },
        getItemRaw (key) {
            return data.get(key) ?? null;
        },
        setItem (key, value) {
            data.set(key, value);
        },
        setItemRaw (key, value) {
            data.set(key, value);
        },
        removeItem (key) {
            data.delete(key);
        },
        getKeys () {
            return [
                ...data.keys()
            ];
        },
        clear () {
            data.clear();
        },
        dispose () {
            data.clear();
        }
    };
});
function $76905bcaa0f218e5$export$d184a47a971dd4b9(options = {}) {
    const context = {
        mounts: {
            "": options.driver || $76905bcaa0f218e5$var$memory()
        },
        mountpoints: [
            ""
        ],
        watching: false,
        watchListeners: [],
        unwatch: {}
    };
    const getMount = (key)=>{
        for (const base of context.mountpoints){
            if (key.startsWith(base)) return {
                base: base,
                relativeKey: key.slice(base.length),
                driver: context.mounts[base]
            };
        }
        return {
            base: "",
            relativeKey: key,
            driver: context.mounts[""]
        };
    };
    const getMounts = (base, includeParent)=>{
        return context.mountpoints.filter((mountpoint)=>mountpoint.startsWith(base) || includeParent && base.startsWith(mountpoint)).map((mountpoint)=>({
                relativeBase: base.length > mountpoint.length ? base.slice(mountpoint.length) : void 0,
                mountpoint: mountpoint,
                driver: context.mounts[mountpoint]
            }));
    };
    const onChange = (event, key)=>{
        if (!context.watching) return;
        key = (0, $fOAQK.a)(key);
        for (const listener of context.watchListeners)listener(event, key);
    };
    const startWatch = async ()=>{
        if (context.watching) return;
        context.watching = true;
        for(const mountpoint in context.mounts)context.unwatch[mountpoint] = await $76905bcaa0f218e5$var$watch(context.mounts[mountpoint], onChange, mountpoint);
    };
    const stopWatch = async ()=>{
        if (!context.watching) return;
        for(const mountpoint in context.unwatch)await context.unwatch[mountpoint]();
        context.unwatch = {};
        context.watching = false;
    };
    const runBatch = (items, commonOptions, cb)=>{
        const batches = /* @__PURE__ */ new Map();
        const getBatch = (mount)=>{
            let batch = batches.get(mount.base);
            if (!batch) {
                batch = {
                    driver: mount.driver,
                    base: mount.base,
                    items: []
                };
                batches.set(mount.base, batch);
            }
            return batch;
        };
        for (const item of items){
            const isStringItem = typeof item === "string";
            const key = (0, $fOAQK.a)(isStringItem ? item : item.key);
            const value = isStringItem ? void 0 : item.value;
            const options2 = isStringItem || !item.options ? commonOptions : {
                ...commonOptions,
                ...item.options
            };
            const mount = getMount(key);
            getBatch(mount).items.push({
                key: key,
                value: value,
                relativeKey: mount.relativeKey,
                options: options2
            });
        }
        return Promise.all([
            ...batches.values()
        ].map((batch)=>cb(batch))).then((r)=>r.flat());
    };
    const storage = {
        // Item
        hasItem (key, opts = {}) {
            key = (0, $fOAQK.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            return (0, $fOAQK.b)(driver.hasItem, relativeKey, opts);
        },
        getItem (key, opts = {}) {
            key = (0, $fOAQK.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            return (0, $fOAQK.b)(driver.getItem, relativeKey, opts).then((value)=>(0, $kJEP3.default)(value));
        },
        getItems (items, commonOptions = {}) {
            return runBatch(items, commonOptions, (batch)=>{
                if (batch.driver.getItems) return (0, $fOAQK.b)(batch.driver.getItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        options: item.options
                    })), commonOptions).then((r)=>r.map((item)=>({
                            key: (0, $fOAQK.j)(batch.base, item.key),
                            value: (0, $kJEP3.default)(item.value)
                        })));
                return Promise.all(batch.items.map((item)=>{
                    return (0, $fOAQK.b)(batch.driver.getItem, item.relativeKey, item.options).then((value)=>({
                            key: item.key,
                            value: (0, $kJEP3.default)(value)
                        }));
                }));
            });
        },
        getItemRaw (key, opts = {}) {
            key = (0, $fOAQK.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (driver.getItemRaw) return (0, $fOAQK.b)(driver.getItemRaw, relativeKey, opts);
            return (0, $fOAQK.b)(driver.getItem, relativeKey, opts).then((value)=>(0, $fOAQK.e)(value));
        },
        async setItem (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key);
            key = (0, $fOAQK.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (!driver.setItem) return;
            await (0, $fOAQK.b)(driver.setItem, relativeKey, (0, $fOAQK.d)(value), opts);
            if (!driver.watch) onChange("update", key);
        },
        async setItems (items, commonOptions) {
            await runBatch(items, commonOptions, async (batch)=>{
                if (batch.driver.setItems) return (0, $fOAQK.b)(batch.driver.setItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        value: (0, $fOAQK.d)(item.value),
                        options: item.options
                    })), commonOptions);
                if (!batch.driver.setItem) return;
                await Promise.all(batch.items.map((item)=>{
                    return (0, $fOAQK.b)(batch.driver.setItem, item.relativeKey, (0, $fOAQK.d)(item.value), item.options);
                }));
            });
        },
        async setItemRaw (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key, opts);
            key = (0, $fOAQK.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (driver.setItemRaw) await (0, $fOAQK.b)(driver.setItemRaw, relativeKey, value, opts);
            else if (driver.setItem) await (0, $fOAQK.b)(driver.setItem, relativeKey, (0, $fOAQK.s)(value), opts);
            else return;
            if (!driver.watch) onChange("update", key);
        },
        async removeItem (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                removeMeta: opts
            };
            key = (0, $fOAQK.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (!driver.removeItem) return;
            await (0, $fOAQK.b)(driver.removeItem, relativeKey, opts);
            if (opts.removeMeta || opts.removeMata) await (0, $fOAQK.b)(driver.removeItem, relativeKey + "$", opts);
            if (!driver.watch) onChange("remove", key);
        },
        // Meta
        async getMeta (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                nativeOnly: opts
            };
            key = (0, $fOAQK.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            const meta = /* @__PURE__ */ Object.create(null);
            if (driver.getMeta) Object.assign(meta, await (0, $fOAQK.b)(driver.getMeta, relativeKey, opts));
            if (!opts.nativeOnly) {
                const value = await (0, $fOAQK.b)(driver.getItem, relativeKey + "$", opts).then((value_)=>(0, $kJEP3.default)(value_));
                if (value && typeof value === "object") {
                    if (typeof value.atime === "string") value.atime = new Date(value.atime);
                    if (typeof value.mtime === "string") value.mtime = new Date(value.mtime);
                    Object.assign(meta, value);
                }
            }
            return meta;
        },
        setMeta (key, value, opts = {}) {
            return this.setItem(key + "$", value, opts);
        },
        removeMeta (key, opts = {}) {
            return this.removeItem(key + "$", opts);
        },
        // Keys
        async getKeys (base, opts = {}) {
            base = (0, $fOAQK.n)(base);
            const mounts = getMounts(base, true);
            let maskedMounts = [];
            const allKeys = [];
            let allMountsSupportMaxDepth = true;
            for (const mount of mounts){
                if (!mount.driver.flags?.maxDepth) allMountsSupportMaxDepth = false;
                const rawKeys = await (0, $fOAQK.b)(mount.driver.getKeys, mount.relativeBase, opts);
                for (const key of rawKeys){
                    const fullKey = mount.mountpoint + (0, $fOAQK.a)(key);
                    if (!maskedMounts.some((p)=>fullKey.startsWith(p))) allKeys.push(fullKey);
                }
                maskedMounts = [
                    mount.mountpoint,
                    ...maskedMounts.filter((p)=>!p.startsWith(mount.mountpoint))
                ];
            }
            const shouldFilterByDepth = opts.maxDepth !== void 0 && !allMountsSupportMaxDepth;
            return allKeys.filter((key)=>(!shouldFilterByDepth || (0, $fOAQK.f)(key, opts.maxDepth)) && (0, $fOAQK.c)(key, base));
        },
        // Utils
        async clear (base, opts = {}) {
            base = (0, $fOAQK.n)(base);
            await Promise.all(getMounts(base, false).map(async (m)=>{
                if (m.driver.clear) return (0, $fOAQK.b)(m.driver.clear, m.relativeBase, opts);
                if (m.driver.removeItem) {
                    const keys = await m.driver.getKeys(m.relativeBase || "", opts);
                    return Promise.all(keys.map((key)=>m.driver.removeItem(key, opts)));
                }
            }));
        },
        async dispose () {
            await Promise.all(Object.values(context.mounts).map((driver)=>$76905bcaa0f218e5$var$dispose(driver)));
        },
        async watch (callback) {
            await startWatch();
            context.watchListeners.push(callback);
            return async ()=>{
                context.watchListeners = context.watchListeners.filter((listener)=>listener !== callback);
                if (context.watchListeners.length === 0) await stopWatch();
            };
        },
        async unwatch () {
            context.watchListeners = [];
            await stopWatch();
        },
        // Mount
        mount (base, driver) {
            base = (0, $fOAQK.n)(base);
            if (base && context.mounts[base]) throw new Error(`already mounted at ${base}`);
            if (base) {
                context.mountpoints.push(base);
                context.mountpoints.sort((a, b)=>b.length - a.length);
            }
            context.mounts[base] = driver;
            if (context.watching) Promise.resolve($76905bcaa0f218e5$var$watch(driver, onChange, base)).then((unwatcher)=>{
                context.unwatch[base] = unwatcher;
            }).catch(console.error);
            return storage;
        },
        async unmount (base, _dispose = true) {
            base = (0, $fOAQK.n)(base);
            if (!base || !context.mounts[base]) return;
            if (context.watching && base in context.unwatch) {
                context.unwatch[base]?.();
                delete context.unwatch[base];
            }
            if (_dispose) await $76905bcaa0f218e5$var$dispose(context.mounts[base]);
            context.mountpoints = context.mountpoints.filter((key)=>key !== base);
            delete context.mounts[base];
        },
        getMount (key = "") {
            key = (0, $fOAQK.a)(key) + ":";
            const m = getMount(key);
            return {
                driver: m.driver,
                base: m.base
            };
        },
        getMounts (base = "", opts = {}) {
            base = (0, $fOAQK.a)(base);
            const mounts = getMounts(base, opts.parents);
            return mounts.map((m)=>({
                    driver: m.driver,
                    base: m.mountpoint
                }));
        },
        // Aliases
        keys: (base, opts = {})=>storage.getKeys(base, opts),
        get: (key, opts = {})=>storage.getItem(key, opts),
        set: (key, value, opts = {})=>storage.setItem(key, value, opts),
        has: (key, opts = {})=>storage.hasItem(key, opts),
        del: (key, opts = {})=>storage.removeItem(key, opts),
        remove: (key, opts = {})=>storage.removeItem(key, opts)
    };
    return storage;
}
async function $76905bcaa0f218e5$export$b8801ea43165ed7d(storage, base) {
    base = (0, $fOAQK.n)(base);
    const keys = await storage.getKeys(base);
    const snapshot2 = {};
    await Promise.all(keys.map(async (key)=>{
        snapshot2[key.slice(base.length)] = await storage.getItem(key);
    }));
    return snapshot2;
}
async function $76905bcaa0f218e5$export$11e5d4541284dd1e(driver, snapshot2, base = "") {
    base = (0, $fOAQK.n)(base);
    await Promise.all(Object.entries(snapshot2).map((e)=>driver.setItem(base + e[0], e[1])));
}
function $76905bcaa0f218e5$var$watch(driver, onChange, base) {
    return driver.watch ? driver.watch((event, key)=>onChange(event, base + key)) : ()=>{};
}
async function $76905bcaa0f218e5$var$dispose(driver) {
    if (typeof driver.dispose === "function") await (0, $fOAQK.b)(driver.dispose);
}
const $76905bcaa0f218e5$export$108bed33247a8bd7 = {
    "azure-app-configuration": "unstorage/drivers/azure-app-configuration",
    "azureAppConfiguration": "unstorage/drivers/azure-app-configuration",
    "azure-cosmos": "unstorage/drivers/azure-cosmos",
    "azureCosmos": "unstorage/drivers/azure-cosmos",
    "azure-key-vault": "unstorage/drivers/azure-key-vault",
    "azureKeyVault": "unstorage/drivers/azure-key-vault",
    "azure-storage-blob": "unstorage/drivers/azure-storage-blob",
    "azureStorageBlob": "unstorage/drivers/azure-storage-blob",
    "azure-storage-table": "unstorage/drivers/azure-storage-table",
    "azureStorageTable": "unstorage/drivers/azure-storage-table",
    "capacitor-preferences": "unstorage/drivers/capacitor-preferences",
    "capacitorPreferences": "unstorage/drivers/capacitor-preferences",
    "cloudflare-kv-binding": "unstorage/drivers/cloudflare-kv-binding",
    "cloudflareKVBinding": "unstorage/drivers/cloudflare-kv-binding",
    "cloudflare-kv-http": "unstorage/drivers/cloudflare-kv-http",
    "cloudflareKVHttp": "unstorage/drivers/cloudflare-kv-http",
    "cloudflare-r2-binding": "unstorage/drivers/cloudflare-r2-binding",
    "cloudflareR2Binding": "unstorage/drivers/cloudflare-r2-binding",
    "db0": "unstorage/drivers/db0",
    "deno-kv-node": "unstorage/drivers/deno-kv-node",
    "denoKVNode": "unstorage/drivers/deno-kv-node",
    "deno-kv": "unstorage/drivers/deno-kv",
    "denoKV": "unstorage/drivers/deno-kv",
    "fs-lite": "unstorage/drivers/fs-lite",
    "fsLite": "unstorage/drivers/fs-lite",
    "fs": "unstorage/drivers/fs",
    "github": "unstorage/drivers/github",
    "http": "unstorage/drivers/http",
    "indexedb": "unstorage/drivers/indexedb",
    "localstorage": "unstorage/drivers/localstorage",
    "lru-cache": "unstorage/drivers/lru-cache",
    "lruCache": "unstorage/drivers/lru-cache",
    "memory": "unstorage/drivers/memory",
    "mongodb": "unstorage/drivers/mongodb",
    "netlify-blobs": "unstorage/drivers/netlify-blobs",
    "netlifyBlobs": "unstorage/drivers/netlify-blobs",
    "null": "unstorage/drivers/null",
    "overlay": "unstorage/drivers/overlay",
    "planetscale": "unstorage/drivers/planetscale",
    "redis": "unstorage/drivers/redis",
    "s3": "unstorage/drivers/s3",
    "session-storage": "unstorage/drivers/session-storage",
    "sessionStorage": "unstorage/drivers/session-storage",
    "uploadthing": "unstorage/drivers/uploadthing",
    "upstash": "unstorage/drivers/upstash",
    "vercel-blob": "unstorage/drivers/vercel-blob",
    "vercelBlob": "unstorage/drivers/vercel-blob",
    "vercel-kv": "unstorage/drivers/vercel-kv",
    "vercelKV": "unstorage/drivers/vercel-kv"
};

});
parcelRegister("kJEP3", function(module, exports) {

$parcel$export(module.exports, "default", () => $703f701287205c36$export$2e2bcd8739ae039);
const $703f701287205c36$var$suspectProtoRx = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/;
const $703f701287205c36$var$suspectConstructorRx = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
const $703f701287205c36$var$JsonSigRx = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function $703f701287205c36$var$jsonParseTransform(key, value) {
    if (key === "__proto__" || key === "constructor" && value && typeof value === "object" && "prototype" in value) {
        $703f701287205c36$var$warnKeyDropped(key);
        return;
    }
    return value;
}
function $703f701287205c36$var$warnKeyDropped(key) {
    console.warn(`[destr] Dropping "${key}" key to prevent prototype pollution.`);
}
function $703f701287205c36$export$2e2bcd8739ae039(value, options = {}) {
    if (typeof value !== "string") return value;
    if (value[0] === '"' && value[value.length - 1] === '"' && value.indexOf("\\") === -1) return value.slice(1, -1);
    const _value = value.trim();
    if (_value.length <= 9) switch(_value.toLowerCase()){
        case "true":
            return true;
        case "false":
            return false;
        case "undefined":
            return void 0;
        case "null":
            return null;
        case "nan":
            return Number.NaN;
        case "infinity":
            return Number.POSITIVE_INFINITY;
        case "-infinity":
            return Number.NEGATIVE_INFINITY;
    }
    if (!$703f701287205c36$var$JsonSigRx.test(value)) {
        if (options.strict) throw new SyntaxError("[destr] Invalid JSON");
        return value;
    }
    try {
        if ($703f701287205c36$var$suspectProtoRx.test(value) || $703f701287205c36$var$suspectConstructorRx.test(value)) {
            if (options.strict) throw new Error("[destr] Possible prototype pollution");
            return JSON.parse(value, $703f701287205c36$var$jsonParseTransform);
        }
        return JSON.parse(value);
    } catch (error) {
        if (options.strict) throw error;
        return value;
    }
}
function $703f701287205c36$export$4b2a7c187ff4b28c(value, options = {}) {
    return $703f701287205c36$export$2e2bcd8739ae039(value, {
        ...options,
        strict: true
    });
}

});

parcelRegister("fOAQK", function(module, exports) {

$parcel$export(module.exports, "b", () => $b3303e2d205f7c57$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "d", () => $b3303e2d205f7c57$export$4368d992c4eafac0);
$parcel$export(module.exports, "s", () => $b3303e2d205f7c57$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "e", () => $b3303e2d205f7c57$export$f1e1789686576879);
$parcel$export(module.exports, "n", () => $b3303e2d205f7c57$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "a", () => $b3303e2d205f7c57$export$407448d2b89b1813);
$parcel$export(module.exports, "j", () => $b3303e2d205f7c57$export$35e795649ee09318);
$parcel$export(module.exports, "f", () => $b3303e2d205f7c57$export$2d1720544b23b823);
$parcel$export(module.exports, "c", () => $b3303e2d205f7c57$export$db3b6bfb95261072);

var $lewJ9 = parcelRequire("lewJ9");
var $b3303e2d205f7c57$require$Buffer = $lewJ9.Buffer;
function $b3303e2d205f7c57$var$wrapToPromise(value) {
    if (!value || typeof value.then !== "function") return Promise.resolve(value);
    return value;
}
function $b3303e2d205f7c57$export$8b22cf2602fb60ce(function_, ...arguments_) {
    try {
        return $b3303e2d205f7c57$var$wrapToPromise(function_(...arguments_));
    } catch (error) {
        return Promise.reject(error);
    }
}
function $b3303e2d205f7c57$var$isPrimitive(value) {
    const type = typeof value;
    return value === null || type !== "object" && type !== "function";
}
function $b3303e2d205f7c57$var$isPureObject(value) {
    const proto = Object.getPrototypeOf(value);
    return !proto || proto.isPrototypeOf(Object);
}
function $b3303e2d205f7c57$export$4368d992c4eafac0(value) {
    if ($b3303e2d205f7c57$var$isPrimitive(value)) return String(value);
    if ($b3303e2d205f7c57$var$isPureObject(value) || Array.isArray(value)) return JSON.stringify(value);
    if (typeof value.toJSON === "function") return $b3303e2d205f7c57$export$4368d992c4eafac0(value.toJSON());
    throw new Error("[unstorage] Cannot stringify value!");
}
const $b3303e2d205f7c57$var$BASE64_PREFIX = "base64:";
function $b3303e2d205f7c57$export$2408f22a0fab9ae5(value) {
    if (typeof value === "string") return value;
    return $b3303e2d205f7c57$var$BASE64_PREFIX + $b3303e2d205f7c57$var$base64Encode(value);
}
function $b3303e2d205f7c57$export$f1e1789686576879(value) {
    if (typeof value !== "string") return value;
    if (!value.startsWith($b3303e2d205f7c57$var$BASE64_PREFIX)) return value;
    return $b3303e2d205f7c57$var$base64Decode(value.slice($b3303e2d205f7c57$var$BASE64_PREFIX.length));
}
function $b3303e2d205f7c57$var$base64Decode(input) {
    if (globalThis.Buffer) return $b3303e2d205f7c57$require$Buffer.from(input, "base64");
    return Uint8Array.from(globalThis.atob(input), (c)=>c.codePointAt(0));
}
function $b3303e2d205f7c57$var$base64Encode(input) {
    if (globalThis.Buffer) return $b3303e2d205f7c57$require$Buffer.from(input).toString("base64");
    return globalThis.btoa(String.fromCodePoint(...input));
}
const $b3303e2d205f7c57$var$storageKeyProperties = [
    "has",
    "hasItem",
    "get",
    "getItem",
    "getItemRaw",
    "set",
    "setItem",
    "setItemRaw",
    "del",
    "remove",
    "removeItem",
    "getMeta",
    "setMeta",
    "removeMeta",
    "getKeys",
    "clear",
    "mount",
    "unmount"
];
function $b3303e2d205f7c57$export$ffb5f4729a158638(storage, base) {
    base = $b3303e2d205f7c57$export$7ccc53e8f1e7dfc5(base);
    if (!base) return storage;
    const nsStorage = {
        ...storage
    };
    for (const property of $b3303e2d205f7c57$var$storageKeyProperties)nsStorage[property] = (key = "", ...args)=>// @ts-ignore
        storage[property](base + key, ...args);
    nsStorage.getKeys = (key = "", ...arguments_)=>storage.getKeys(base + key, ...arguments_).then((keys)=>keys.map((key2)=>key2.slice(base.length)));
    nsStorage.getItems = async (items, commonOptions)=>{
        const prefixedItems = items.map((item)=>typeof item === "string" ? base + item : {
                ...item,
                key: base + item.key
            });
        const results = await storage.getItems(prefixedItems, commonOptions);
        return results.map((entry)=>({
                key: entry.key.slice(base.length),
                value: entry.value
            }));
    };
    nsStorage.setItems = async (items, commonOptions)=>{
        const prefixedItems = items.map((item)=>({
                key: base + item.key,
                value: item.value,
                options: item.options
            }));
        return storage.setItems(prefixedItems, commonOptions);
    };
    return nsStorage;
}
function $b3303e2d205f7c57$export$407448d2b89b1813(key) {
    if (!key) return "";
    return key.split("?")[0]?.replace(/[/\\]/g, ":").replace(/:+/g, ":").replace(/^:|:$/g, "") || "";
}
function $b3303e2d205f7c57$export$35e795649ee09318(...keys) {
    return $b3303e2d205f7c57$export$407448d2b89b1813(keys.join(":"));
}
function $b3303e2d205f7c57$export$7ccc53e8f1e7dfc5(base) {
    base = $b3303e2d205f7c57$export$407448d2b89b1813(base);
    return base ? base + ":" : "";
}
function $b3303e2d205f7c57$export$2d1720544b23b823(key, depth) {
    if (depth === void 0) return true;
    let substrCount = 0;
    let index = key.indexOf(":");
    while(index > -1){
        substrCount++;
        index = key.indexOf(":", index + 1);
    }
    return substrCount <= depth;
}
function $b3303e2d205f7c57$export$db3b6bfb95261072(key, base) {
    if (base) return key.startsWith(base) && key[key.length - 1] !== "$";
    return key[key.length - 1] !== "$";
}

});
parcelRegister("lewJ9", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $f7544abf2b86eba7$export$a143d493d941bafc, (v) => $f7544abf2b86eba7$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $f7544abf2b86eba7$export$e4cf37d7f6fb9e0a, (v) => $f7544abf2b86eba7$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $f7544abf2b86eba7$export$f99ded8fe4b79145, (v) => $f7544abf2b86eba7$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $f7544abf2b86eba7$export$599f31c3813fae4d, (v) => $f7544abf2b86eba7$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $f7544abf2b86eba7$export$a143d493d941bafc;
var $f7544abf2b86eba7$export$e4cf37d7f6fb9e0a;
var $f7544abf2b86eba7$export$f99ded8fe4b79145;
var $f7544abf2b86eba7$export$599f31c3813fae4d;
"use strict";

var $gKBU6 = parcelRequire("gKBU6");

var $OUdei = parcelRequire("OUdei");
const $f7544abf2b86eba7$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$f7544abf2b86eba7$export$a143d493d941bafc = $f7544abf2b86eba7$var$Buffer;
$f7544abf2b86eba7$export$e4cf37d7f6fb9e0a = $f7544abf2b86eba7$var$SlowBuffer;
$f7544abf2b86eba7$export$f99ded8fe4b79145 = 50;
const $f7544abf2b86eba7$var$K_MAX_LENGTH = 0x7fffffff;
$f7544abf2b86eba7$export$599f31c3813fae4d = $f7544abf2b86eba7$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $f7544abf2b86eba7$var$Buffer.TYPED_ARRAY_SUPPORT = $f7544abf2b86eba7$var$typedArraySupport();
if (!$f7544abf2b86eba7$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $f7544abf2b86eba7$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($f7544abf2b86eba7$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$f7544abf2b86eba7$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($f7544abf2b86eba7$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$f7544abf2b86eba7$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $f7544abf2b86eba7$var$createBuffer(length) {
    if (length > $f7544abf2b86eba7$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $f7544abf2b86eba7$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $f7544abf2b86eba7$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $f7544abf2b86eba7$var$allocUnsafe(arg);
    }
    return $f7544abf2b86eba7$var$from(arg, encodingOrOffset, length);
}
$f7544abf2b86eba7$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $f7544abf2b86eba7$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $f7544abf2b86eba7$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $f7544abf2b86eba7$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($f7544abf2b86eba7$var$isInstance(value, ArrayBuffer) || value && $f7544abf2b86eba7$var$isInstance(value.buffer, ArrayBuffer)) return $f7544abf2b86eba7$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($f7544abf2b86eba7$var$isInstance(value, SharedArrayBuffer) || value && $f7544abf2b86eba7$var$isInstance(value.buffer, SharedArrayBuffer))) return $f7544abf2b86eba7$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $f7544abf2b86eba7$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $f7544abf2b86eba7$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $f7544abf2b86eba7$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $f7544abf2b86eba7$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $f7544abf2b86eba7$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($f7544abf2b86eba7$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($f7544abf2b86eba7$var$Buffer, Uint8Array);
function $f7544abf2b86eba7$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $f7544abf2b86eba7$var$alloc(size, fill, encoding) {
    $f7544abf2b86eba7$var$assertSize(size);
    if (size <= 0) return $f7544abf2b86eba7$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $f7544abf2b86eba7$var$createBuffer(size).fill(fill, encoding) : $f7544abf2b86eba7$var$createBuffer(size).fill(fill);
    return $f7544abf2b86eba7$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $f7544abf2b86eba7$var$Buffer.alloc = function(size, fill, encoding) {
    return $f7544abf2b86eba7$var$alloc(size, fill, encoding);
};
function $f7544abf2b86eba7$var$allocUnsafe(size) {
    $f7544abf2b86eba7$var$assertSize(size);
    return $f7544abf2b86eba7$var$createBuffer(size < 0 ? 0 : $f7544abf2b86eba7$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $f7544abf2b86eba7$var$Buffer.allocUnsafe = function(size) {
    return $f7544abf2b86eba7$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $f7544abf2b86eba7$var$Buffer.allocUnsafeSlow = function(size) {
    return $f7544abf2b86eba7$var$allocUnsafe(size);
};
function $f7544abf2b86eba7$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$f7544abf2b86eba7$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $f7544abf2b86eba7$var$byteLength(string, encoding) | 0;
    let buf = $f7544abf2b86eba7$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $f7544abf2b86eba7$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $f7544abf2b86eba7$var$checked(array.length) | 0;
    const buf = $f7544abf2b86eba7$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $f7544abf2b86eba7$var$fromArrayView(arrayView) {
    if ($f7544abf2b86eba7$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $f7544abf2b86eba7$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $f7544abf2b86eba7$var$fromArrayLike(arrayView);
}
function $f7544abf2b86eba7$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $f7544abf2b86eba7$var$Buffer.prototype);
    return buf;
}
function $f7544abf2b86eba7$var$fromObject(obj) {
    if ($f7544abf2b86eba7$var$Buffer.isBuffer(obj)) {
        const len = $f7544abf2b86eba7$var$checked(obj.length) | 0;
        const buf = $f7544abf2b86eba7$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $f7544abf2b86eba7$var$numberIsNaN(obj.length)) return $f7544abf2b86eba7$var$createBuffer(0);
        return $f7544abf2b86eba7$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $f7544abf2b86eba7$var$fromArrayLike(obj.data);
}
function $f7544abf2b86eba7$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $f7544abf2b86eba7$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $f7544abf2b86eba7$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $f7544abf2b86eba7$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $f7544abf2b86eba7$var$Buffer.alloc(+length);
}
$f7544abf2b86eba7$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $f7544abf2b86eba7$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$f7544abf2b86eba7$var$Buffer.compare = function compare(a, b) {
    if ($f7544abf2b86eba7$var$isInstance(a, Uint8Array)) a = $f7544abf2b86eba7$var$Buffer.from(a, a.offset, a.byteLength);
    if ($f7544abf2b86eba7$var$isInstance(b, Uint8Array)) b = $f7544abf2b86eba7$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$f7544abf2b86eba7$var$Buffer.isBuffer(a) || !$f7544abf2b86eba7$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$f7544abf2b86eba7$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$f7544abf2b86eba7$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $f7544abf2b86eba7$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $f7544abf2b86eba7$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($f7544abf2b86eba7$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$f7544abf2b86eba7$var$Buffer.isBuffer(buf)) buf = $f7544abf2b86eba7$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$f7544abf2b86eba7$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $f7544abf2b86eba7$var$byteLength(string, encoding) {
    if ($f7544abf2b86eba7$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $f7544abf2b86eba7$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $f7544abf2b86eba7$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $f7544abf2b86eba7$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $f7544abf2b86eba7$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$f7544abf2b86eba7$var$Buffer.byteLength = $f7544abf2b86eba7$var$byteLength;
function $f7544abf2b86eba7$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $f7544abf2b86eba7$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $f7544abf2b86eba7$var$utf8Slice(this, start, end);
        case "ascii":
            return $f7544abf2b86eba7$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $f7544abf2b86eba7$var$latin1Slice(this, start, end);
        case "base64":
            return $f7544abf2b86eba7$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $f7544abf2b86eba7$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$f7544abf2b86eba7$var$Buffer.prototype._isBuffer = true;
function $f7544abf2b86eba7$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$f7544abf2b86eba7$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$f7544abf2b86eba7$var$swap(this, i, i + 1);
    return this;
};
$f7544abf2b86eba7$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $f7544abf2b86eba7$var$swap(this, i, i + 3);
        $f7544abf2b86eba7$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$f7544abf2b86eba7$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $f7544abf2b86eba7$var$swap(this, i, i + 7);
        $f7544abf2b86eba7$var$swap(this, i + 1, i + 6);
        $f7544abf2b86eba7$var$swap(this, i + 2, i + 5);
        $f7544abf2b86eba7$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$f7544abf2b86eba7$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $f7544abf2b86eba7$var$utf8Slice(this, 0, length);
    return $f7544abf2b86eba7$var$slowToString.apply(this, arguments);
};
$f7544abf2b86eba7$var$Buffer.prototype.toLocaleString = $f7544abf2b86eba7$var$Buffer.prototype.toString;
$f7544abf2b86eba7$var$Buffer.prototype.equals = function equals(b) {
    if (!$f7544abf2b86eba7$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $f7544abf2b86eba7$var$Buffer.compare(this, b) === 0;
};
$f7544abf2b86eba7$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $f7544abf2b86eba7$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($f7544abf2b86eba7$var$customInspectSymbol) $f7544abf2b86eba7$var$Buffer.prototype[$f7544abf2b86eba7$var$customInspectSymbol] = $f7544abf2b86eba7$var$Buffer.prototype.inspect;
$f7544abf2b86eba7$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($f7544abf2b86eba7$var$isInstance(target, Uint8Array)) target = $f7544abf2b86eba7$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$f7544abf2b86eba7$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $f7544abf2b86eba7$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($f7544abf2b86eba7$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $f7544abf2b86eba7$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($f7544abf2b86eba7$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $f7544abf2b86eba7$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $f7544abf2b86eba7$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $f7544abf2b86eba7$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$f7544abf2b86eba7$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$f7544abf2b86eba7$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $f7544abf2b86eba7$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$f7544abf2b86eba7$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $f7544abf2b86eba7$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $f7544abf2b86eba7$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($f7544abf2b86eba7$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $f7544abf2b86eba7$var$utf8Write(buf, string, offset, length) {
    return $f7544abf2b86eba7$var$blitBuffer($f7544abf2b86eba7$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $f7544abf2b86eba7$var$asciiWrite(buf, string, offset, length) {
    return $f7544abf2b86eba7$var$blitBuffer($f7544abf2b86eba7$var$asciiToBytes(string), buf, offset, length);
}
function $f7544abf2b86eba7$var$base64Write(buf, string, offset, length) {
    return $f7544abf2b86eba7$var$blitBuffer($f7544abf2b86eba7$var$base64ToBytes(string), buf, offset, length);
}
function $f7544abf2b86eba7$var$ucs2Write(buf, string, offset, length) {
    return $f7544abf2b86eba7$var$blitBuffer($f7544abf2b86eba7$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$f7544abf2b86eba7$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $f7544abf2b86eba7$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $f7544abf2b86eba7$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $f7544abf2b86eba7$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $f7544abf2b86eba7$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $f7544abf2b86eba7$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$f7544abf2b86eba7$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $f7544abf2b86eba7$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gKBU6.fromByteArray(buf);
    else return $gKBU6.fromByteArray(buf.slice(start, end));
}
function $f7544abf2b86eba7$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $f7544abf2b86eba7$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $f7544abf2b86eba7$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $f7544abf2b86eba7$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $f7544abf2b86eba7$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $f7544abf2b86eba7$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $f7544abf2b86eba7$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $f7544abf2b86eba7$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $f7544abf2b86eba7$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $f7544abf2b86eba7$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $f7544abf2b86eba7$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$f7544abf2b86eba7$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $f7544abf2b86eba7$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $f7544abf2b86eba7$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$f7544abf2b86eba7$var$Buffer.prototype.readUintLE = $f7544abf2b86eba7$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$f7544abf2b86eba7$var$Buffer.prototype.readUintBE = $f7544abf2b86eba7$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$f7544abf2b86eba7$var$Buffer.prototype.readUint8 = $f7544abf2b86eba7$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$f7544abf2b86eba7$var$Buffer.prototype.readUint16LE = $f7544abf2b86eba7$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$f7544abf2b86eba7$var$Buffer.prototype.readUint16BE = $f7544abf2b86eba7$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$f7544abf2b86eba7$var$Buffer.prototype.readUint32LE = $f7544abf2b86eba7$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$f7544abf2b86eba7$var$Buffer.prototype.readUint32BE = $f7544abf2b86eba7$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$f7544abf2b86eba7$var$Buffer.prototype.readBigUInt64LE = $f7544abf2b86eba7$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $f7544abf2b86eba7$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f7544abf2b86eba7$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$f7544abf2b86eba7$var$Buffer.prototype.readBigUInt64BE = $f7544abf2b86eba7$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $f7544abf2b86eba7$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f7544abf2b86eba7$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$f7544abf2b86eba7$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f7544abf2b86eba7$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f7544abf2b86eba7$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$f7544abf2b86eba7$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f7544abf2b86eba7$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f7544abf2b86eba7$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$f7544abf2b86eba7$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$f7544abf2b86eba7$var$Buffer.prototype.readBigInt64LE = $f7544abf2b86eba7$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $f7544abf2b86eba7$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f7544abf2b86eba7$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$f7544abf2b86eba7$var$Buffer.prototype.readBigInt64BE = $f7544abf2b86eba7$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $f7544abf2b86eba7$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f7544abf2b86eba7$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$f7544abf2b86eba7$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkOffset(offset, 4, this.length);
    return $OUdei.read(this, offset, true, 23, 4);
};
$f7544abf2b86eba7$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkOffset(offset, 4, this.length);
    return $OUdei.read(this, offset, false, 23, 4);
};
$f7544abf2b86eba7$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkOffset(offset, 8, this.length);
    return $OUdei.read(this, offset, true, 52, 8);
};
$f7544abf2b86eba7$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkOffset(offset, 8, this.length);
    return $OUdei.read(this, offset, false, 52, 8);
};
function $f7544abf2b86eba7$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$f7544abf2b86eba7$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$f7544abf2b86eba7$var$Buffer.prototype.writeUintLE = $f7544abf2b86eba7$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f7544abf2b86eba7$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f7544abf2b86eba7$var$Buffer.prototype.writeUintBE = $f7544abf2b86eba7$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f7544abf2b86eba7$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f7544abf2b86eba7$var$Buffer.prototype.writeUint8 = $f7544abf2b86eba7$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$f7544abf2b86eba7$var$Buffer.prototype.writeUint16LE = $f7544abf2b86eba7$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f7544abf2b86eba7$var$Buffer.prototype.writeUint16BE = $f7544abf2b86eba7$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f7544abf2b86eba7$var$Buffer.prototype.writeUint32LE = $f7544abf2b86eba7$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$f7544abf2b86eba7$var$Buffer.prototype.writeUint32BE = $f7544abf2b86eba7$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $f7544abf2b86eba7$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $f7544abf2b86eba7$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $f7544abf2b86eba7$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $f7544abf2b86eba7$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$f7544abf2b86eba7$var$Buffer.prototype.writeBigUInt64LE = $f7544abf2b86eba7$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $f7544abf2b86eba7$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$f7544abf2b86eba7$var$Buffer.prototype.writeBigUInt64BE = $f7544abf2b86eba7$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $f7544abf2b86eba7$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$f7544abf2b86eba7$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $f7544abf2b86eba7$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f7544abf2b86eba7$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $f7544abf2b86eba7$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f7544abf2b86eba7$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$f7544abf2b86eba7$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f7544abf2b86eba7$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f7544abf2b86eba7$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$f7544abf2b86eba7$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$f7544abf2b86eba7$var$Buffer.prototype.writeBigInt64LE = $f7544abf2b86eba7$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $f7544abf2b86eba7$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$f7544abf2b86eba7$var$Buffer.prototype.writeBigInt64BE = $f7544abf2b86eba7$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $f7544abf2b86eba7$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $f7544abf2b86eba7$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $f7544abf2b86eba7$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $OUdei.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$f7544abf2b86eba7$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $f7544abf2b86eba7$var$writeFloat(this, value, offset, true, noAssert);
};
$f7544abf2b86eba7$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $f7544abf2b86eba7$var$writeFloat(this, value, offset, false, noAssert);
};
function $f7544abf2b86eba7$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7544abf2b86eba7$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $OUdei.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$f7544abf2b86eba7$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $f7544abf2b86eba7$var$writeDouble(this, value, offset, true, noAssert);
};
$f7544abf2b86eba7$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $f7544abf2b86eba7$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$f7544abf2b86eba7$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$f7544abf2b86eba7$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$f7544abf2b86eba7$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$f7544abf2b86eba7$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $f7544abf2b86eba7$var$Buffer.isBuffer(val) ? val : $f7544abf2b86eba7$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $f7544abf2b86eba7$var$errors = {};
function $f7544abf2b86eba7$var$E(sym, getMessage, Base) {
    $f7544abf2b86eba7$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$f7544abf2b86eba7$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$f7544abf2b86eba7$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$f7544abf2b86eba7$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $f7544abf2b86eba7$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $f7544abf2b86eba7$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $f7544abf2b86eba7$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $f7544abf2b86eba7$var$checkBounds(buf, offset, byteLength) {
    $f7544abf2b86eba7$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $f7544abf2b86eba7$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $f7544abf2b86eba7$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $f7544abf2b86eba7$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $f7544abf2b86eba7$var$checkBounds(buf, offset, byteLength);
}
function $f7544abf2b86eba7$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $f7544abf2b86eba7$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $f7544abf2b86eba7$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $f7544abf2b86eba7$var$validateNumber(value, type);
        throw new $f7544abf2b86eba7$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $f7544abf2b86eba7$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $f7544abf2b86eba7$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $f7544abf2b86eba7$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $f7544abf2b86eba7$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($f7544abf2b86eba7$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $f7544abf2b86eba7$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $f7544abf2b86eba7$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $f7544abf2b86eba7$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $f7544abf2b86eba7$var$base64ToBytes(str) {
    return $gKBU6.toByteArray($f7544abf2b86eba7$var$base64clean(str));
}
function $f7544abf2b86eba7$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $f7544abf2b86eba7$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $f7544abf2b86eba7$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $f7544abf2b86eba7$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $f7544abf2b86eba7$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $f7544abf2b86eba7$var$BufferBigIntNotDefined : fn;
}
function $f7544abf2b86eba7$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("gKBU6", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $c31e581ecac6fdce$export$d622b2ad8d90c771, (v) => $c31e581ecac6fdce$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $c31e581ecac6fdce$export$6100ba28696e12de, (v) => $c31e581ecac6fdce$export$6100ba28696e12de = v);
var $c31e581ecac6fdce$export$a48f0734ac7c2329;
var $c31e581ecac6fdce$export$d622b2ad8d90c771;
var $c31e581ecac6fdce$export$6100ba28696e12de;
"use strict";
$c31e581ecac6fdce$export$a48f0734ac7c2329 = $c31e581ecac6fdce$var$byteLength;
$c31e581ecac6fdce$export$d622b2ad8d90c771 = $c31e581ecac6fdce$var$toByteArray;
$c31e581ecac6fdce$export$6100ba28696e12de = $c31e581ecac6fdce$var$fromByteArray;
var $c31e581ecac6fdce$var$lookup = [];
var $c31e581ecac6fdce$var$revLookup = [];
var $c31e581ecac6fdce$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $c31e581ecac6fdce$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $c31e581ecac6fdce$var$i = 0, $c31e581ecac6fdce$var$len = $c31e581ecac6fdce$var$code.length; $c31e581ecac6fdce$var$i < $c31e581ecac6fdce$var$len; ++$c31e581ecac6fdce$var$i){
    $c31e581ecac6fdce$var$lookup[$c31e581ecac6fdce$var$i] = $c31e581ecac6fdce$var$code[$c31e581ecac6fdce$var$i];
    $c31e581ecac6fdce$var$revLookup[$c31e581ecac6fdce$var$code.charCodeAt($c31e581ecac6fdce$var$i)] = $c31e581ecac6fdce$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$c31e581ecac6fdce$var$revLookup["-".charCodeAt(0)] = 62;
$c31e581ecac6fdce$var$revLookup["_".charCodeAt(0)] = 63;
function $c31e581ecac6fdce$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $c31e581ecac6fdce$var$byteLength(b64) {
    var lens = $c31e581ecac6fdce$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c31e581ecac6fdce$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c31e581ecac6fdce$var$toByteArray(b64) {
    var tmp;
    var lens = $c31e581ecac6fdce$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $c31e581ecac6fdce$var$Arr($c31e581ecac6fdce$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $c31e581ecac6fdce$var$revLookup[b64.charCodeAt(i)] << 18 | $c31e581ecac6fdce$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $c31e581ecac6fdce$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $c31e581ecac6fdce$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $c31e581ecac6fdce$var$revLookup[b64.charCodeAt(i)] << 2 | $c31e581ecac6fdce$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $c31e581ecac6fdce$var$revLookup[b64.charCodeAt(i)] << 10 | $c31e581ecac6fdce$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $c31e581ecac6fdce$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $c31e581ecac6fdce$var$tripletToBase64(num) {
    return $c31e581ecac6fdce$var$lookup[num >> 18 & 0x3F] + $c31e581ecac6fdce$var$lookup[num >> 12 & 0x3F] + $c31e581ecac6fdce$var$lookup[num >> 6 & 0x3F] + $c31e581ecac6fdce$var$lookup[num & 0x3F];
}
function $c31e581ecac6fdce$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($c31e581ecac6fdce$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $c31e581ecac6fdce$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($c31e581ecac6fdce$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($c31e581ecac6fdce$var$lookup[tmp >> 2] + $c31e581ecac6fdce$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($c31e581ecac6fdce$var$lookup[tmp >> 10] + $c31e581ecac6fdce$var$lookup[tmp >> 4 & 0x3F] + $c31e581ecac6fdce$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("OUdei", function(module, exports) {

$parcel$export(module.exports, "read", () => $0990463bea6be092$export$aafa59e2e03f2942, (v) => $0990463bea6be092$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $0990463bea6be092$export$68d8715fc104d294, (v) => $0990463bea6be092$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $0990463bea6be092$export$aafa59e2e03f2942;
var $0990463bea6be092$export$68d8715fc104d294;
$0990463bea6be092$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$0990463bea6be092$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("hD3IG", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $cd58f6d28b6e82da$export$f51a9068ac82ea43);
$parcel$export(module.exports, "get", () => $cd58f6d28b6e82da$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $cd58f6d28b6e82da$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "del", () => $cd58f6d28b6e82da$export$1d2f21e549771e67);
$parcel$export(module.exports, "clear", () => $cd58f6d28b6e82da$export$42ffd38884aecdac);
$parcel$export(module.exports, "keys", () => $cd58f6d28b6e82da$export$ed97f33186d4b816);
function $cd58f6d28b6e82da$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $cd58f6d28b6e82da$export$f51a9068ac82ea43(dbName, storeName) {
    let dbp;
    const getDB = ()=>{
        if (dbp) return dbp;
        const request = indexedDB.open(dbName);
        request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
        dbp = $cd58f6d28b6e82da$export$b327150396135fe7(request);
        dbp.then((db)=>{
            // It seems like Safari sometimes likes to just close the connection.
            // It's supposed to fire this event when that happens. Let's hope it does!
            db.onclose = ()=>dbp = undefined;
        }, ()=>{});
        return dbp;
    };
    return (txMode, callback)=>getDB().then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $cd58f6d28b6e82da$var$defaultGetStoreFunc;
function $cd58f6d28b6e82da$var$defaultGetStore() {
    if (!$cd58f6d28b6e82da$var$defaultGetStoreFunc) $cd58f6d28b6e82da$var$defaultGetStoreFunc = $cd58f6d28b6e82da$export$f51a9068ac82ea43("keyval-store", "keyval");
    return $cd58f6d28b6e82da$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $cd58f6d28b6e82da$export$3988ae62b71be9a3(key, customStore = $cd58f6d28b6e82da$var$defaultGetStore()) {
    return customStore("readonly", (store)=>$cd58f6d28b6e82da$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $cd58f6d28b6e82da$export$adaa4cf7ef1b65be(key, value, customStore = $cd58f6d28b6e82da$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        store.put(value, key);
        return $cd58f6d28b6e82da$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $cd58f6d28b6e82da$export$daa0a5170277c7a8(entries, customStore = $cd58f6d28b6e82da$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $cd58f6d28b6e82da$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $cd58f6d28b6e82da$export$5df405cccea42673(keys, customStore = $cd58f6d28b6e82da$var$defaultGetStore()) {
    return customStore("readonly", (store)=>Promise.all(keys.map((key)=>$cd58f6d28b6e82da$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $cd58f6d28b6e82da$export$722fbec263ad908a(key, updater, customStore = $cd58f6d28b6e82da$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($cd58f6d28b6e82da$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $cd58f6d28b6e82da$export$1d2f21e549771e67(key, customStore = $cd58f6d28b6e82da$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        store.delete(key);
        return $cd58f6d28b6e82da$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $cd58f6d28b6e82da$export$c8aa84257229cac8(keys, customStore = $cd58f6d28b6e82da$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $cd58f6d28b6e82da$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $cd58f6d28b6e82da$export$42ffd38884aecdac(customStore = $cd58f6d28b6e82da$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        store.clear();
        return $cd58f6d28b6e82da$export$b327150396135fe7(store.transaction);
    });
}
function $cd58f6d28b6e82da$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $cd58f6d28b6e82da$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $cd58f6d28b6e82da$export$ed97f33186d4b816(customStore = $cd58f6d28b6e82da$var$defaultGetStore()) {
    return customStore("readonly", (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $cd58f6d28b6e82da$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $cd58f6d28b6e82da$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $cd58f6d28b6e82da$export$68c286be0e7e55b7(customStore = $cd58f6d28b6e82da$var$defaultGetStore()) {
    return customStore("readonly", (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $cd58f6d28b6e82da$export$b327150396135fe7(store.getAll());
        const items = [];
        return $cd58f6d28b6e82da$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $cd58f6d28b6e82da$export$3e9f948b41964866(customStore = $cd58f6d28b6e82da$var$defaultGetStore()) {
    return customStore("readonly", (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $cd58f6d28b6e82da$export$b327150396135fe7(store.getAllKeys()),
            $cd58f6d28b6e82da$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore("readonly", (store)=>$cd58f6d28b6e82da$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}

});

parcelRegister("bREX4", function(module, exports) {

$parcel$export(module.exports, "safeJsonParse", () => $8a346922e1712d14$export$84137bb44359aed5);
$parcel$export(module.exports, "safeJsonStringify", () => $8a346922e1712d14$export$abc3f407e87918a4);
const $8a346922e1712d14$var$JSONStringify = (data)=>JSON.stringify(data, (_, value)=>typeof value === "bigint" ? value.toString() + "n" : value);
const $8a346922e1712d14$var$JSONParse = (json)=>{
    const numbersBiggerThanMaxInt = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g;
    const serializedData = json.replace(numbersBiggerThanMaxInt, '$1"$2n"$3');
    return JSON.parse(serializedData, (_, value)=>{
        const isCustomFormatBigInt = typeof value === "string" && value.match(/^\d+n$/);
        if (isCustomFormatBigInt) return BigInt(value.substring(0, value.length - 1));
        return value;
    });
};
function $8a346922e1712d14$export$84137bb44359aed5(value) {
    if (typeof value !== "string") throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    try {
        return $8a346922e1712d14$var$JSONParse(value);
    } catch (_a) {
        return value;
    }
}
function $8a346922e1712d14$export$abc3f407e87918a4(value) {
    return typeof value === "string" ? value : $8a346922e1712d14$var$JSONStringify(value) || "";
}

});


parcelRegister("6GQzw", function(module, exports) {

$parcel$export(module.exports, "getDefaultLoggerOptions", () => $4def7204e79d7023$export$bad2475df51c8ecc);
$parcel$export(module.exports, "getLoggerContext", () => $4def7204e79d7023$export$a283a9a0054a3c25);
$parcel$export(module.exports, "generateChildLogger", () => $4def7204e79d7023$export$4929e0372308a636);
$parcel$export(module.exports, "generatePlatformLogger", () => $4def7204e79d7023$export$15eba7fb5aaf9303);
$parcel$export(module.exports, "pino", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("66E6s")))));

var $66E6s = parcelRequire("66E6s");

var $bREX4 = parcelRequire("bREX4");
const $4def7204e79d7023$export$341ee22b43fe3f8e = {
    level: "info"
}, $4def7204e79d7023$export$fdd446d41f74bf3a = "custom_context", $4def7204e79d7023$export$64bef9d49cc9288f = 1024000;
class $4def7204e79d7023$var$O {
    constructor(e){
        this.nodeValue = e, this.sizeInBytes = new TextEncoder().encode(this.nodeValue).length, this.next = null;
    }
    get value() {
        return this.nodeValue;
    }
    get size() {
        return this.sizeInBytes;
    }
}
class $4def7204e79d7023$var$d {
    constructor(e){
        this.head = null, this.tail = null, this.lengthInNodes = 0, this.maxSizeInBytes = e, this.sizeInBytes = 0;
    }
    append(e) {
        const t = new $4def7204e79d7023$var$O(e);
        if (t.size > this.maxSizeInBytes) throw new Error(`[LinkedList] Value too big to insert into list: ${e} with size ${t.size}`);
        for(; this.size + t.size > this.maxSizeInBytes;)this.shift();
        this.head ? (this.tail && (this.tail.next = t), this.tail = t) : (this.head = t, this.tail = t), this.lengthInNodes++, this.sizeInBytes += t.size;
    }
    shift() {
        if (!this.head) return;
        const e = this.head;
        this.head = this.head.next, this.head || (this.tail = null), this.lengthInNodes--, this.sizeInBytes -= e.size;
    }
    toArray() {
        const e = [];
        let t = this.head;
        for(; t !== null;)e.push(t.value), t = t.next;
        return e;
    }
    get length() {
        return this.lengthInNodes;
    }
    get size() {
        return this.sizeInBytes;
    }
    toOrderedArray() {
        return Array.from(this);
    }
    [Symbol.iterator]() {
        let e = this.head;
        return {
            next: ()=>{
                if (!e) return {
                    done: !0,
                    value: null
                };
                const t = e.value;
                return e = e.next, {
                    done: !1,
                    value: t
                };
            }
        };
    }
}
class $4def7204e79d7023$var$L {
    constructor(e, t = $4def7204e79d7023$export$64bef9d49cc9288f){
        this.level = e ?? "error", this.levelValue = (0, $66E6s.levels).values[this.level], this.MAX_LOG_SIZE_IN_BYTES = t, this.logs = new $4def7204e79d7023$var$d(this.MAX_LOG_SIZE_IN_BYTES);
    }
    forwardToConsole(e, t) {
        t === (0, $66E6s.levels).values.error ? console.error(e) : t === (0, $66E6s.levels).values.warn ? console.warn(e) : t === (0, $66E6s.levels).values.debug ? console.debug(e) : t === (0, $66E6s.levels).values.trace ? console.trace(e) : console.log(e);
    }
    appendToLogs(e) {
        this.logs.append((0, $bREX4.safeJsonStringify)({
            timestamp: new Date().toISOString(),
            log: e
        }));
        const t = typeof e == "string" ? JSON.parse(e).level : e.level;
        t >= this.levelValue && this.forwardToConsole(e, t);
    }
    getLogs() {
        return this.logs;
    }
    clearLogs() {
        this.logs = new $4def7204e79d7023$var$d(this.MAX_LOG_SIZE_IN_BYTES);
    }
    getLogArray() {
        return Array.from(this.logs);
    }
    logsToBlob(e) {
        const t = this.getLogArray();
        return t.push((0, $bREX4.safeJsonStringify)({
            extraMetadata: e
        })), new Blob(t, {
            type: "application/json"
        });
    }
}
class $4def7204e79d7023$var$m {
    constructor(e, t = $4def7204e79d7023$export$64bef9d49cc9288f){
        this.baseChunkLogger = new $4def7204e79d7023$var$L(e, t);
    }
    write(e) {
        this.baseChunkLogger.appendToLogs(e);
    }
    getLogs() {
        return this.baseChunkLogger.getLogs();
    }
    clearLogs() {
        this.baseChunkLogger.clearLogs();
    }
    getLogArray() {
        return this.baseChunkLogger.getLogArray();
    }
    logsToBlob(e) {
        return this.baseChunkLogger.logsToBlob(e);
    }
    downloadLogsBlobInBrowser(e) {
        const t = URL.createObjectURL(this.logsToBlob(e)), o = document.createElement("a");
        o.href = t, o.download = `walletconnect-logs-${new Date().toISOString()}.txt`, document.body.appendChild(o), o.click(), document.body.removeChild(o), URL.revokeObjectURL(t);
    }
}
class $4def7204e79d7023$var$B {
    constructor(e, t = $4def7204e79d7023$export$64bef9d49cc9288f){
        this.baseChunkLogger = new $4def7204e79d7023$var$L(e, t);
    }
    write(e) {
        this.baseChunkLogger.appendToLogs(e);
    }
    getLogs() {
        return this.baseChunkLogger.getLogs();
    }
    clearLogs() {
        this.baseChunkLogger.clearLogs();
    }
    getLogArray() {
        return this.baseChunkLogger.getLogArray();
    }
    logsToBlob(e) {
        return this.baseChunkLogger.logsToBlob(e);
    }
}
var $4def7204e79d7023$var$x = Object.defineProperty, $4def7204e79d7023$var$S = Object.defineProperties, $4def7204e79d7023$var$_ = Object.getOwnPropertyDescriptors, $4def7204e79d7023$var$p = Object.getOwnPropertySymbols, $4def7204e79d7023$var$T = Object.prototype.hasOwnProperty, $4def7204e79d7023$var$z = Object.prototype.propertyIsEnumerable, $4def7204e79d7023$var$f = (r, e, t)=>e in r ? $4def7204e79d7023$var$x(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $4def7204e79d7023$var$i = (r, e)=>{
    for(var t in e || (e = {}))$4def7204e79d7023$var$T.call(e, t) && $4def7204e79d7023$var$f(r, t, e[t]);
    if ($4def7204e79d7023$var$p) for (var t of $4def7204e79d7023$var$p(e))$4def7204e79d7023$var$z.call(e, t) && $4def7204e79d7023$var$f(r, t, e[t]);
    return r;
}, $4def7204e79d7023$var$g = (r, e)=>$4def7204e79d7023$var$S(r, $4def7204e79d7023$var$_(e));
function $4def7204e79d7023$export$bad2475df51c8ecc(r) {
    return $4def7204e79d7023$var$g($4def7204e79d7023$var$i({}, r), {
        level: r?.level || $4def7204e79d7023$export$341ee22b43fe3f8e.level
    });
}
function $4def7204e79d7023$export$e8faae0482d84e9e(r, e = $4def7204e79d7023$export$fdd446d41f74bf3a) {
    return r[e] || "";
}
function $4def7204e79d7023$export$758f352b7265b00e(r, e, t = $4def7204e79d7023$export$fdd446d41f74bf3a) {
    return r[t] = e, r;
}
function $4def7204e79d7023$export$a283a9a0054a3c25(r, e = $4def7204e79d7023$export$fdd446d41f74bf3a) {
    let t = "";
    return typeof r.bindings > "u" ? t = $4def7204e79d7023$export$e8faae0482d84e9e(r, e) : t = r.bindings().context || "", t;
}
function $4def7204e79d7023$export$307261146df20465(r, e, t = $4def7204e79d7023$export$fdd446d41f74bf3a) {
    const o = $4def7204e79d7023$export$a283a9a0054a3c25(r, t);
    return o.trim() ? `${o}/${e}` : e;
}
function $4def7204e79d7023$export$4929e0372308a636(r, e, t = $4def7204e79d7023$export$fdd446d41f74bf3a) {
    const o = $4def7204e79d7023$export$307261146df20465(r, e, t), a = r.child({
        context: o
    });
    return $4def7204e79d7023$export$758f352b7265b00e(a, o, t);
}
function $4def7204e79d7023$export$2ca1453636a43a7(r) {
    var e, t;
    const o = new $4def7204e79d7023$var$m((e = r.opts) == null ? void 0 : e.level, r.maxSizeInBytes);
    return {
        logger: (0, (/*@__PURE__*/$parcel$interopDefault($66E6s)))($4def7204e79d7023$var$g($4def7204e79d7023$var$i({}, r.opts), {
            level: "trace",
            browser: $4def7204e79d7023$var$g($4def7204e79d7023$var$i({}, (t = r.opts) == null ? void 0 : t.browser), {
                write: (a)=>o.write(a)
            })
        })),
        chunkLoggerController: o
    };
}
function $4def7204e79d7023$export$495ac2973e46cb97(r) {
    var e;
    const t = new $4def7204e79d7023$var$B((e = r.opts) == null ? void 0 : e.level, r.maxSizeInBytes);
    return {
        logger: (0, (/*@__PURE__*/$parcel$interopDefault($66E6s)))($4def7204e79d7023$var$g($4def7204e79d7023$var$i({}, r.opts), {
            level: "trace"
        }), t),
        chunkLoggerController: t
    };
}
function $4def7204e79d7023$export$15eba7fb5aaf9303(r) {
    return typeof r.loggerOverride < "u" && typeof r.loggerOverride != "string" ? {
        logger: r.loggerOverride,
        chunkLoggerController: null
    } : typeof window < "u" ? $4def7204e79d7023$export$2ca1453636a43a7(r) : $4def7204e79d7023$export$495ac2973e46cb97(r);
}

});
parcelRegister("66E6s", function(module, exports) {
"use strict";

var $059lV = parcelRequire("059lV");
module.exports = $4722694221b637ff$var$pino;
const $4722694221b637ff$var$_console = $4722694221b637ff$var$pfGlobalThisOrFallback().console || {};
const $4722694221b637ff$var$stdSerializers = {
    mapHttpRequest: $4722694221b637ff$var$mock,
    mapHttpResponse: $4722694221b637ff$var$mock,
    wrapRequestSerializer: $4722694221b637ff$var$passthrough,
    wrapResponseSerializer: $4722694221b637ff$var$passthrough,
    wrapErrorSerializer: $4722694221b637ff$var$passthrough,
    req: $4722694221b637ff$var$mock,
    res: $4722694221b637ff$var$mock,
    err: $4722694221b637ff$var$asErrValue
};
function $4722694221b637ff$var$shouldSerialize(serialize, serializers) {
    if (Array.isArray(serialize)) {
        const hasToFilter = serialize.filter(function(k) {
            return k !== "!stdSerializers.err";
        });
        return hasToFilter;
    } else if (serialize === true) return Object.keys(serializers);
    return false;
}
function $4722694221b637ff$var$pino(opts) {
    opts = opts || {};
    opts.browser = opts.browser || {};
    const transmit = opts.browser.transmit;
    if (transmit && typeof transmit.send !== "function") throw Error("pino: transmit option must have a send function");
    const proto = opts.browser.write || $4722694221b637ff$var$_console;
    if (opts.browser.write) opts.browser.asObject = true;
    const serializers = opts.serializers || {};
    const serialize = $4722694221b637ff$var$shouldSerialize(opts.browser.serialize, serializers);
    let stdErrSerialize = opts.browser.serialize;
    if (Array.isArray(opts.browser.serialize) && opts.browser.serialize.indexOf("!stdSerializers.err") > -1) stdErrSerialize = false;
    const levels = [
        "error",
        "fatal",
        "warn",
        "info",
        "debug",
        "trace"
    ];
    if (typeof proto === "function") proto.error = proto.fatal = proto.warn = proto.info = proto.debug = proto.trace = proto;
    if (opts.enabled === false) opts.level = "silent";
    const level = opts.level || "info";
    const logger = Object.create(proto);
    if (!logger.log) logger.log = $4722694221b637ff$var$noop;
    Object.defineProperty(logger, "levelVal", {
        get: getLevelVal
    });
    Object.defineProperty(logger, "level", {
        get: getLevel,
        set: setLevel
    });
    const setOpts = {
        transmit: transmit,
        serialize: serialize,
        asObject: opts.browser.asObject,
        levels: levels,
        timestamp: $4722694221b637ff$var$getTimeFunction(opts)
    };
    logger.levels = $4722694221b637ff$var$pino.levels;
    logger.level = level;
    logger.setMaxListeners = logger.getMaxListeners = logger.emit = logger.addListener = logger.on = logger.prependListener = logger.once = logger.prependOnceListener = logger.removeListener = logger.removeAllListeners = logger.listeners = logger.listenerCount = logger.eventNames = logger.write = logger.flush = $4722694221b637ff$var$noop;
    logger.serializers = serializers;
    logger._serialize = serialize;
    logger._stdErrSerialize = stdErrSerialize;
    logger.child = child;
    if (transmit) logger._logEvent = $4722694221b637ff$var$createLogEventShape();
    function getLevelVal() {
        return this.level === "silent" ? Infinity : this.levels.values[this.level];
    }
    function getLevel() {
        return this._level;
    }
    function setLevel(level) {
        if (level !== "silent" && !this.levels.values[level]) throw Error("unknown level " + level);
        this._level = level;
        $4722694221b637ff$var$set(setOpts, logger, "error", "log") // <-- must stay first
        ;
        $4722694221b637ff$var$set(setOpts, logger, "fatal", "error");
        $4722694221b637ff$var$set(setOpts, logger, "warn", "error");
        $4722694221b637ff$var$set(setOpts, logger, "info", "log");
        $4722694221b637ff$var$set(setOpts, logger, "debug", "log");
        $4722694221b637ff$var$set(setOpts, logger, "trace", "log");
    }
    function child(bindings, childOptions) {
        if (!bindings) throw new Error("missing bindings for child Pino");
        childOptions = childOptions || {};
        if (serialize && bindings.serializers) childOptions.serializers = bindings.serializers;
        const childOptionsSerializers = childOptions.serializers;
        if (serialize && childOptionsSerializers) {
            var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
            var childSerialize = opts.browser.serialize === true ? Object.keys(childSerializers) : serialize;
            delete bindings.serializers;
            $4722694221b637ff$var$applySerializers([
                bindings
            ], childSerialize, childSerializers, this._stdErrSerialize);
        }
        function Child(parent) {
            this._childLevel = (parent._childLevel | 0) + 1;
            this.error = $4722694221b637ff$var$bind(parent, bindings, "error");
            this.fatal = $4722694221b637ff$var$bind(parent, bindings, "fatal");
            this.warn = $4722694221b637ff$var$bind(parent, bindings, "warn");
            this.info = $4722694221b637ff$var$bind(parent, bindings, "info");
            this.debug = $4722694221b637ff$var$bind(parent, bindings, "debug");
            this.trace = $4722694221b637ff$var$bind(parent, bindings, "trace");
            if (childSerializers) {
                this.serializers = childSerializers;
                this._serialize = childSerialize;
            }
            if (transmit) this._logEvent = $4722694221b637ff$var$createLogEventShape([].concat(parent._logEvent.bindings, bindings));
        }
        Child.prototype = this;
        return new Child(this);
    }
    return logger;
}
$4722694221b637ff$var$pino.levels = {
    values: {
        fatal: 60,
        error: 50,
        warn: 40,
        info: 30,
        debug: 20,
        trace: 10
    },
    labels: {
        10: "trace",
        20: "debug",
        30: "info",
        40: "warn",
        50: "error",
        60: "fatal"
    }
};
$4722694221b637ff$var$pino.stdSerializers = $4722694221b637ff$var$stdSerializers;
$4722694221b637ff$var$pino.stdTimeFunctions = Object.assign({}, {
    nullTime: $4722694221b637ff$var$nullTime,
    epochTime: $4722694221b637ff$var$epochTime,
    unixTime: $4722694221b637ff$var$unixTime,
    isoTime: $4722694221b637ff$var$isoTime
});
function $4722694221b637ff$var$set(opts, logger, level, fallback) {
    const proto = Object.getPrototypeOf(logger);
    logger[level] = logger.levelVal > logger.levels.values[level] ? $4722694221b637ff$var$noop : proto[level] ? proto[level] : $4722694221b637ff$var$_console[level] || $4722694221b637ff$var$_console[fallback] || $4722694221b637ff$var$noop;
    $4722694221b637ff$var$wrap(opts, logger, level);
}
function $4722694221b637ff$var$wrap(opts, logger, level) {
    if (!opts.transmit && logger[level] === $4722694221b637ff$var$noop) return;
    logger[level] = function(write) {
        return function LOG() {
            const ts = opts.timestamp();
            const args = new Array(arguments.length);
            const proto = Object.getPrototypeOf && Object.getPrototypeOf(this) === $4722694221b637ff$var$_console ? $4722694221b637ff$var$_console : this;
            for(var i = 0; i < args.length; i++)args[i] = arguments[i];
            if (opts.serialize && !opts.asObject) $4722694221b637ff$var$applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
            if (opts.asObject) write.call(proto, $4722694221b637ff$var$asObject(this, level, args, ts));
            else write.apply(proto, args);
            if (opts.transmit) {
                const transmitLevel = opts.transmit.level || logger.level;
                const transmitValue = $4722694221b637ff$var$pino.levels.values[transmitLevel];
                const methodValue = $4722694221b637ff$var$pino.levels.values[level];
                if (methodValue < transmitValue) return;
                $4722694221b637ff$var$transmit(this, {
                    ts: ts,
                    methodLevel: level,
                    methodValue: methodValue,
                    transmitLevel: transmitLevel,
                    transmitValue: $4722694221b637ff$var$pino.levels.values[opts.transmit.level || logger.level],
                    send: opts.transmit.send,
                    val: logger.levelVal
                }, args);
            }
        };
    }(logger[level]);
}
function $4722694221b637ff$var$asObject(logger, level, args, ts) {
    if (logger._serialize) $4722694221b637ff$var$applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize);
    const argsCloned = args.slice();
    let msg = argsCloned[0];
    const o = {};
    if (ts) o.time = ts;
    o.level = $4722694221b637ff$var$pino.levels.values[level];
    let lvl = (logger._childLevel | 0) + 1;
    if (lvl < 1) lvl = 1;
    // deliberate, catching objects, arrays
    if (msg !== null && typeof msg === "object") {
        while(lvl-- && typeof argsCloned[0] === "object")Object.assign(o, argsCloned.shift());
        msg = argsCloned.length ? $059lV(argsCloned.shift(), argsCloned) : undefined;
    } else if (typeof msg === "string") msg = $059lV(argsCloned.shift(), argsCloned);
    if (msg !== undefined) o.msg = msg;
    return o;
}
function $4722694221b637ff$var$applySerializers(args, serialize, serializers, stdErrSerialize) {
    for(const i in args){
        if (stdErrSerialize && args[i] instanceof Error) args[i] = $4722694221b637ff$var$pino.stdSerializers.err(args[i]);
        else if (typeof args[i] === "object" && !Array.isArray(args[i])) {
            for(const k in args[i])if (serialize && serialize.indexOf(k) > -1 && k in serializers) args[i][k] = serializers[k](args[i][k]);
        }
    }
}
function $4722694221b637ff$var$bind(parent, bindings, level) {
    return function() {
        const args = new Array(1 + arguments.length);
        args[0] = bindings;
        for(var i = 1; i < args.length; i++)args[i] = arguments[i - 1];
        return parent[level].apply(this, args);
    };
}
function $4722694221b637ff$var$transmit(logger, opts, args) {
    const send = opts.send;
    const ts = opts.ts;
    const methodLevel = opts.methodLevel;
    const methodValue = opts.methodValue;
    const val = opts.val;
    const bindings = logger._logEvent.bindings;
    $4722694221b637ff$var$applySerializers(args, logger._serialize || Object.keys(logger.serializers), logger.serializers, logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize);
    logger._logEvent.ts = ts;
    logger._logEvent.messages = args.filter(function(arg) {
        // bindings can only be objects, so reference equality check via indexOf is fine
        return bindings.indexOf(arg) === -1;
    });
    logger._logEvent.level.label = methodLevel;
    logger._logEvent.level.value = methodValue;
    send(methodLevel, logger._logEvent, val);
    logger._logEvent = $4722694221b637ff$var$createLogEventShape(bindings);
}
function $4722694221b637ff$var$createLogEventShape(bindings) {
    return {
        ts: 0,
        messages: [],
        bindings: bindings || [],
        level: {
            label: "",
            value: 0
        }
    };
}
function $4722694221b637ff$var$asErrValue(err) {
    const obj = {
        type: err.constructor.name,
        msg: err.message,
        stack: err.stack
    };
    for(const key in err)if (obj[key] === undefined) obj[key] = err[key];
    return obj;
}
function $4722694221b637ff$var$getTimeFunction(opts) {
    if (typeof opts.timestamp === "function") return opts.timestamp;
    if (opts.timestamp === false) return $4722694221b637ff$var$nullTime;
    return $4722694221b637ff$var$epochTime;
}
function $4722694221b637ff$var$mock() {
    return {};
}
function $4722694221b637ff$var$passthrough(a) {
    return a;
}
function $4722694221b637ff$var$noop() {}
function $4722694221b637ff$var$nullTime() {
    return false;
}
function $4722694221b637ff$var$epochTime() {
    return Date.now();
}
function $4722694221b637ff$var$unixTime() {
    return Math.round(Date.now() / 1000.0);
}
function $4722694221b637ff$var$isoTime() {
    return new Date(Date.now()).toISOString();
} // using Date.now() for testability
/* eslint-disable */ /* istanbul ignore next */ function $4722694221b637ff$var$pfGlobalThisOrFallback() {
    function defd(o) {
        return typeof o !== "undefined" && o;
    }
    try {
        if (typeof globalThis !== "undefined") return globalThis;
        Object.defineProperty(Object.prototype, "globalThis", {
            get: function() {
                delete Object.prototype.globalThis;
                return this.globalThis = this;
            },
            configurable: true
        });
        return globalThis;
    } catch (e) {
        return defd(self) || defd(window) || defd(this) || {};
    }
} /* eslint-enable */ 

});
parcelRegister("059lV", function(module, exports) {
"use strict";
function $00f7b8fb75690504$var$tryStringify(o) {
    try {
        return JSON.stringify(o);
    } catch (e) {
        return '"[Circular]"';
    }
}
module.exports = $00f7b8fb75690504$var$format;
function $00f7b8fb75690504$var$format(f, args, opts) {
    var ss = opts && opts.stringify || $00f7b8fb75690504$var$tryStringify;
    var offset = 1;
    if (typeof f === "object" && f !== null) {
        var len = args.length + offset;
        if (len === 1) return f;
        var objects = new Array(len);
        objects[0] = ss(f);
        for(var index = 1; index < len; index++)objects[index] = ss(args[index]);
        return objects.join(" ");
    }
    if (typeof f !== "string") return f;
    var argLen = args.length;
    if (argLen === 0) return f;
    var str = "";
    var a = 1 - offset;
    var lastPos = -1;
    var flen = f && f.length || 0;
    for(var i = 0; i < flen;){
        if (f.charCodeAt(i) === 37 && i + 1 < flen) {
            lastPos = lastPos > -1 ? lastPos : 0;
            switch(f.charCodeAt(i + 1)){
                case 100:
                case 102:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Number(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 105:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Math.floor(Number(args[a]));
                    lastPos = i + 2;
                    i++;
                    break;
                case 79:
                case 111:
                case 106:
                    if (a >= argLen) break;
                    if (args[a] === undefined) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    var type = typeof args[a];
                    if (type === "string") {
                        str += "'" + args[a] + "'";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    if (type === "function") {
                        str += args[a].name || "<anonymous>";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    str += ss(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 115:
                    if (a >= argLen) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += String(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 37:
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += "%";
                    lastPos = i + 2;
                    i++;
                    a--;
                    break;
            }
            ++a;
        }
        ++i;
    }
    if (lastPos === -1) return f;
    else if (lastPos < flen) str += f.slice(lastPos);
    return str;
}

});



parcelRegister("2B80D", function(module, exports) {

$parcel$export(module.exports, "ICore", () => $1e453ff5c74ce096$export$ed533416df113881);
$parcel$export(module.exports, "IJsonRpcHistory", () => $1e453ff5c74ce096$export$45b2c2643615b67);
$parcel$export(module.exports, "IMessageTracker", () => $1e453ff5c74ce096$export$e67570fe0a885c47);
$parcel$export(module.exports, "IPublisher", () => $1e453ff5c74ce096$export$3b0872bbd7e675a2);
$parcel$export(module.exports, "IRelayer", () => $1e453ff5c74ce096$export$9a0f755fd4f79434);
$parcel$export(module.exports, "IStore", () => $1e453ff5c74ce096$export$a7f17ba6c54777e7);
$parcel$export(module.exports, "ISubscriber", () => $1e453ff5c74ce096$export$300eed987e764b57);
$parcel$export(module.exports, "IExpirer", () => $1e453ff5c74ce096$export$41aaa3c39f6f2861);
$parcel$export(module.exports, "IVerify", () => $1e453ff5c74ce096$export$873b0b865d85ddb6);
$parcel$export(module.exports, "IEchoClient", () => $1e453ff5c74ce096$export$7db533fb638f979d);
$parcel$export(module.exports, "IEventClient", () => $1e453ff5c74ce096$export$4264a8ec567679e5);
$parcel$export(module.exports, "ISignClient", () => $1e453ff5c74ce096$export$2ebcf6eeacedad44);
$parcel$export(module.exports, "IEngine", () => $1e453ff5c74ce096$export$87df43c730effa30);
parcelRequire("6nxVc");
var $czCIg = parcelRequire("czCIg");

var $5yFVO = parcelRequire("5yFVO");
var $1e453ff5c74ce096$var$a = Object.defineProperty, $1e453ff5c74ce096$var$u = (e, s, r)=>s in e ? $1e453ff5c74ce096$var$a(e, s, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[s] = r, $1e453ff5c74ce096$var$c = (e, s, r)=>$1e453ff5c74ce096$var$u(e, typeof s != "symbol" ? s + "" : s, r);
class $1e453ff5c74ce096$export$ed533416df113881 extends (0, $czCIg.IEvents) {
    constructor(s){
        super(), this.opts = s, $1e453ff5c74ce096$var$c(this, "protocol", "wc"), $1e453ff5c74ce096$var$c(this, "version", 2);
    }
}
class $1e453ff5c74ce096$export$a4e7e56f03915894 {
    constructor(s, r, t){
        this.core = s, this.logger = r;
    }
}
var $1e453ff5c74ce096$var$p = Object.defineProperty, $1e453ff5c74ce096$var$b = (e, s, r)=>s in e ? $1e453ff5c74ce096$var$p(e, s, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[s] = r, $1e453ff5c74ce096$var$v = (e, s, r)=>$1e453ff5c74ce096$var$b(e, typeof s != "symbol" ? s + "" : s, r);
class $1e453ff5c74ce096$export$45b2c2643615b67 extends (0, $czCIg.IEvents) {
    constructor(s, r){
        super(), this.core = s, this.logger = r, $1e453ff5c74ce096$var$v(this, "records", new Map);
    }
}
class $1e453ff5c74ce096$export$e67570fe0a885c47 {
    constructor(s, r){
        this.logger = s, this.core = r;
    }
}
class $1e453ff5c74ce096$export$3b0872bbd7e675a2 extends (0, $czCIg.IEvents) {
    constructor(s, r){
        super(), this.relayer = s, this.logger = r;
    }
}
class $1e453ff5c74ce096$export$9a0f755fd4f79434 extends (0, $czCIg.IEvents) {
    constructor(s){
        super();
    }
}
class $1e453ff5c74ce096$export$a7f17ba6c54777e7 {
    constructor(s, r, t, q){
        this.core = s, this.logger = r, this.name = t;
    }
}
var $1e453ff5c74ce096$var$E = Object.defineProperty, $1e453ff5c74ce096$var$x = (e, s, r)=>s in e ? $1e453ff5c74ce096$var$E(e, s, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[s] = r, $1e453ff5c74ce096$var$w = (e, s, r)=>$1e453ff5c74ce096$var$x(e, typeof s != "symbol" ? s + "" : s, r);
class $1e453ff5c74ce096$export$5746ea6dad01660a {
    constructor(){
        $1e453ff5c74ce096$var$w(this, "map", new Map);
    }
}
class $1e453ff5c74ce096$export$300eed987e764b57 extends (0, $czCIg.IEvents) {
    constructor(s, r){
        super(), this.relayer = s, this.logger = r;
    }
}
class $1e453ff5c74ce096$export$be56d986c75c3691 {
    constructor(s, r){
        this.core = s, this.logger = r;
    }
}
class $1e453ff5c74ce096$export$41aaa3c39f6f2861 extends (0, $czCIg.IEvents) {
    constructor(s, r){
        super(), this.core = s, this.logger = r;
    }
}
class $1e453ff5c74ce096$export$d6c2d698ffb743f1 {
    constructor(s, r){
        this.logger = s, this.core = r;
    }
}
class $1e453ff5c74ce096$export$873b0b865d85ddb6 {
    constructor(s, r, t){
        this.core = s, this.logger = r, this.store = t;
    }
}
class $1e453ff5c74ce096$export$7db533fb638f979d {
    constructor(s, r){
        this.projectId = s, this.logger = r;
    }
}
class $1e453ff5c74ce096$export$4264a8ec567679e5 {
    constructor(s, r, t){
        this.core = s, this.logger = r, this.telemetryEnabled = t;
    }
}
var $1e453ff5c74ce096$var$T = Object.defineProperty, $1e453ff5c74ce096$var$k = (e, s, r)=>s in e ? $1e453ff5c74ce096$var$T(e, s, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[s] = r, $1e453ff5c74ce096$var$i = (e, s, r)=>$1e453ff5c74ce096$var$k(e, typeof s != "symbol" ? s + "" : s, r);
class $1e453ff5c74ce096$export$235ef727e8a26483 extends (0, (/*@__PURE__*/$parcel$interopDefault($5yFVO))) {
    constructor(){
        super();
    }
}
class $1e453ff5c74ce096$export$2ebcf6eeacedad44 {
    constructor(s){
        this.opts = s, $1e453ff5c74ce096$var$i(this, "protocol", "wc"), $1e453ff5c74ce096$var$i(this, "version", 2);
    }
}
class $1e453ff5c74ce096$export$623dd0f793f15643 extends (0, $5yFVO.EventEmitter) {
    constructor(){
        super();
    }
}
class $1e453ff5c74ce096$export$87df43c730effa30 {
    constructor(s){
        this.client = s;
    }
}

});

parcelRegister("aKPeb", function(module, exports) {

$parcel$export(module.exports, "encodeIss", () => $7d45f003e5c7496e$export$1b29ef9371459e10);
$parcel$export(module.exports, "decodeJWT", () => $7d45f003e5c7496e$export$9a62e6c0a30e00bc);
$parcel$export(module.exports, "generateKeyPair", () => $7d45f003e5c7496e$export$a949d36eab55b41f);
$parcel$export(module.exports, "signJWT", () => $7d45f003e5c7496e$export$a8dda30659d36d45);

var $9eyak = parcelRequire("9eyak");

var $bREX4 = parcelRequire("bREX4");
function $7d45f003e5c7496e$var$En(t) {
    return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function $7d45f003e5c7496e$var$fe(t, ...e) {
    if (!$7d45f003e5c7496e$var$En(t)) throw new Error("Uint8Array expected");
    if (e.length > 0 && !e.includes(t.length)) throw new Error("Uint8Array expected of length " + e + ", got length=" + t.length);
}
function $7d45f003e5c7496e$var$De(t, e = !0) {
    if (t.destroyed) throw new Error("Hash instance has been destroyed");
    if (e && t.finished) throw new Error("Hash#digest() has already been called");
}
function $7d45f003e5c7496e$var$gn(t, e) {
    $7d45f003e5c7496e$var$fe(t);
    const n = e.outputLen;
    if (t.length < n) throw new Error("digestInto() expects output buffer of length at least " + n);
}
const $7d45f003e5c7496e$var$it = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0; /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
const $7d45f003e5c7496e$var$_t = (t)=>new DataView(t.buffer, t.byteOffset, t.byteLength);
function $7d45f003e5c7496e$var$yn(t) {
    if (typeof t != "string") throw new Error("utf8ToBytes expected string, got " + typeof t);
    return new Uint8Array(new TextEncoder().encode(t));
}
function $7d45f003e5c7496e$var$de(t) {
    return typeof t == "string" && (t = $7d45f003e5c7496e$var$yn(t)), $7d45f003e5c7496e$var$fe(t), t;
}
class $7d45f003e5c7496e$var$xn {
    clone() {
        return this._cloneInto();
    }
}
function $7d45f003e5c7496e$var$Bn(t) {
    const e = (r)=>t().update($7d45f003e5c7496e$var$de(r)).digest(), n = t();
    return e.outputLen = n.outputLen, e.blockLen = n.blockLen, e.create = ()=>t(), e;
}
function $7d45f003e5c7496e$var$he(t = 32) {
    if ($7d45f003e5c7496e$var$it && typeof $7d45f003e5c7496e$var$it.getRandomValues == "function") return $7d45f003e5c7496e$var$it.getRandomValues(new Uint8Array(t));
    if ($7d45f003e5c7496e$var$it && typeof $7d45f003e5c7496e$var$it.randomBytes == "function") return $7d45f003e5c7496e$var$it.randomBytes(t);
    throw new Error("crypto.getRandomValues must be defined");
}
function $7d45f003e5c7496e$var$Cn(t, e, n, r) {
    if (typeof t.setBigUint64 == "function") return t.setBigUint64(e, n, r);
    const o = BigInt(32), s = BigInt(4294967295), a = Number(n >> o & s), u = Number(n & s), i = r ? 4 : 0, D = r ? 0 : 4;
    t.setUint32(e + i, a, r), t.setUint32(e + D, u, r);
}
class $7d45f003e5c7496e$var$An extends $7d45f003e5c7496e$var$xn {
    constructor(e, n, r, o){
        super(), this.blockLen = e, this.outputLen = n, this.padOffset = r, this.isLE = o, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = $7d45f003e5c7496e$var$_t(this.buffer);
    }
    update(e) {
        $7d45f003e5c7496e$var$De(this);
        const { view: n, buffer: r, blockLen: o } = this;
        e = $7d45f003e5c7496e$var$de(e);
        const s = e.length;
        for(let a = 0; a < s;){
            const u = Math.min(o - this.pos, s - a);
            if (u === o) {
                const i = $7d45f003e5c7496e$var$_t(e);
                for(; o <= s - a; a += o)this.process(i, a);
                continue;
            }
            r.set(e.subarray(a, a + u), this.pos), this.pos += u, a += u, this.pos === o && (this.process(n, 0), this.pos = 0);
        }
        return this.length += e.length, this.roundClean(), this;
    }
    digestInto(e) {
        $7d45f003e5c7496e$var$De(this), $7d45f003e5c7496e$var$gn(e, this), this.finished = !0;
        const { buffer: n, view: r, blockLen: o, isLE: s } = this;
        let { pos: a } = this;
        n[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > o - a && (this.process(r, 0), a = 0);
        for(let l = a; l < o; l++)n[l] = 0;
        $7d45f003e5c7496e$var$Cn(r, o - 8, BigInt(this.length * 8), s), this.process(r, 0);
        const u = $7d45f003e5c7496e$var$_t(e), i = this.outputLen;
        if (i % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const D = i / 4, c = this.get();
        if (D > c.length) throw new Error("_sha2: outputLen bigger than state");
        for(let l = 0; l < D; l++)u.setUint32(4 * l, c[l], s);
    }
    digest() {
        const { buffer: e, outputLen: n } = this;
        this.digestInto(e);
        const r = e.slice(0, n);
        return this.destroy(), r;
    }
    _cloneInto(e) {
        e || (e = new this.constructor), e.set(...this.get());
        const { blockLen: n, buffer: r, length: o, finished: s, destroyed: a, pos: u } = this;
        return e.length = o, e.pos = u, e.finished = s, e.destroyed = a, o % n && e.buffer.set(r), e;
    }
}
const $7d45f003e5c7496e$var$wt = BigInt(2 ** 32 - 1), $7d45f003e5c7496e$var$St = BigInt(32);
function $7d45f003e5c7496e$var$le(t, e = !1) {
    return e ? {
        h: Number(t & $7d45f003e5c7496e$var$wt),
        l: Number(t >> $7d45f003e5c7496e$var$St & $7d45f003e5c7496e$var$wt)
    } : {
        h: Number(t >> $7d45f003e5c7496e$var$St & $7d45f003e5c7496e$var$wt) | 0,
        l: Number(t & $7d45f003e5c7496e$var$wt) | 0
    };
}
function $7d45f003e5c7496e$var$mn(t, e = !1) {
    let n = new Uint32Array(t.length), r = new Uint32Array(t.length);
    for(let o = 0; o < t.length; o++){
        const { h: s, l: a } = $7d45f003e5c7496e$var$le(t[o], e);
        [n[o], r[o]] = [
            s,
            a
        ];
    }
    return [
        n,
        r
    ];
}
const $7d45f003e5c7496e$var$_n = (t, e)=>BigInt(t >>> 0) << $7d45f003e5c7496e$var$St | BigInt(e >>> 0), $7d45f003e5c7496e$var$Sn = (t, e, n)=>t >>> n, $7d45f003e5c7496e$var$vn = (t, e, n)=>t << 32 - n | e >>> n, $7d45f003e5c7496e$var$In = (t, e, n)=>t >>> n | e << 32 - n, $7d45f003e5c7496e$var$Un = (t, e, n)=>t << 32 - n | e >>> n, $7d45f003e5c7496e$var$Tn = (t, e, n)=>t << 64 - n | e >>> n - 32, $7d45f003e5c7496e$var$Fn = (t, e, n)=>t >>> n - 32 | e << 64 - n, $7d45f003e5c7496e$var$Nn = (t, e)=>e, $7d45f003e5c7496e$var$Ln = (t, e)=>t, $7d45f003e5c7496e$var$On = (t, e, n)=>t << n | e >>> 32 - n, $7d45f003e5c7496e$var$Hn = (t, e, n)=>e << n | t >>> 32 - n, $7d45f003e5c7496e$var$zn = (t, e, n)=>e << n - 32 | t >>> 64 - n, $7d45f003e5c7496e$var$Mn = (t, e, n)=>t << n - 32 | e >>> 64 - n;
function $7d45f003e5c7496e$var$qn(t, e, n, r) {
    const o = (e >>> 0) + (r >>> 0);
    return {
        h: t + n + (o / 2 ** 32 | 0) | 0,
        l: o | 0
    };
}
const $7d45f003e5c7496e$var$$n = (t, e, n)=>(t >>> 0) + (e >>> 0) + (n >>> 0), $7d45f003e5c7496e$var$kn = (t, e, n, r)=>e + n + r + (t / 2 ** 32 | 0) | 0, $7d45f003e5c7496e$var$Rn = (t, e, n, r)=>(t >>> 0) + (e >>> 0) + (n >>> 0) + (r >>> 0), $7d45f003e5c7496e$var$jn = (t, e, n, r, o)=>e + n + r + o + (t / 2 ** 32 | 0) | 0, $7d45f003e5c7496e$var$Zn = (t, e, n, r, o)=>(t >>> 0) + (e >>> 0) + (n >>> 0) + (r >>> 0) + (o >>> 0), $7d45f003e5c7496e$var$Gn = (t, e, n, r, o, s)=>e + n + r + o + s + (t / 2 ** 32 | 0) | 0, $7d45f003e5c7496e$var$x = {
    fromBig: $7d45f003e5c7496e$var$le,
    split: $7d45f003e5c7496e$var$mn,
    toBig: $7d45f003e5c7496e$var$_n,
    shrSH: $7d45f003e5c7496e$var$Sn,
    shrSL: $7d45f003e5c7496e$var$vn,
    rotrSH: $7d45f003e5c7496e$var$In,
    rotrSL: $7d45f003e5c7496e$var$Un,
    rotrBH: $7d45f003e5c7496e$var$Tn,
    rotrBL: $7d45f003e5c7496e$var$Fn,
    rotr32H: $7d45f003e5c7496e$var$Nn,
    rotr32L: $7d45f003e5c7496e$var$Ln,
    rotlSH: $7d45f003e5c7496e$var$On,
    rotlSL: $7d45f003e5c7496e$var$Hn,
    rotlBH: $7d45f003e5c7496e$var$zn,
    rotlBL: $7d45f003e5c7496e$var$Mn,
    add: $7d45f003e5c7496e$var$qn,
    add3L: $7d45f003e5c7496e$var$$n,
    add3H: $7d45f003e5c7496e$var$kn,
    add4L: $7d45f003e5c7496e$var$Rn,
    add4H: $7d45f003e5c7496e$var$jn,
    add5H: $7d45f003e5c7496e$var$Gn,
    add5L: $7d45f003e5c7496e$var$Zn
}, [$7d45f003e5c7496e$var$Vn, $7d45f003e5c7496e$var$Yn] = (()=>$7d45f003e5c7496e$var$x.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((t)=>BigInt(t))))(), $7d45f003e5c7496e$var$P = new Uint32Array(80), $7d45f003e5c7496e$var$Q = new Uint32Array(80);
class $7d45f003e5c7496e$var$Jn extends $7d45f003e5c7496e$var$An {
    constructor(){
        super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
    }
    get() {
        const { Ah: e, Al: n, Bh: r, Bl: o, Ch: s, Cl: a, Dh: u, Dl: i, Eh: D, El: c, Fh: l, Fl: p, Gh: w, Gl: h, Hh: g, Hl: S } = this;
        return [
            e,
            n,
            r,
            o,
            s,
            a,
            u,
            i,
            D,
            c,
            l,
            p,
            w,
            h,
            g,
            S
        ];
    }
    set(e, n, r, o, s, a, u, i, D, c, l, p, w, h, g, S) {
        this.Ah = e | 0, this.Al = n | 0, this.Bh = r | 0, this.Bl = o | 0, this.Ch = s | 0, this.Cl = a | 0, this.Dh = u | 0, this.Dl = i | 0, this.Eh = D | 0, this.El = c | 0, this.Fh = l | 0, this.Fl = p | 0, this.Gh = w | 0, this.Gl = h | 0, this.Hh = g | 0, this.Hl = S | 0;
    }
    process(e, n) {
        for(let d = 0; d < 16; d++, n += 4)$7d45f003e5c7496e$var$P[d] = e.getUint32(n), $7d45f003e5c7496e$var$Q[d] = e.getUint32(n += 4);
        for(let d = 16; d < 80; d++){
            const m = $7d45f003e5c7496e$var$P[d - 15] | 0, F = $7d45f003e5c7496e$var$Q[d - 15] | 0, q = $7d45f003e5c7496e$var$x.rotrSH(m, F, 1) ^ $7d45f003e5c7496e$var$x.rotrSH(m, F, 8) ^ $7d45f003e5c7496e$var$x.shrSH(m, F, 7), z = $7d45f003e5c7496e$var$x.rotrSL(m, F, 1) ^ $7d45f003e5c7496e$var$x.rotrSL(m, F, 8) ^ $7d45f003e5c7496e$var$x.shrSL(m, F, 7), I = $7d45f003e5c7496e$var$P[d - 2] | 0, O = $7d45f003e5c7496e$var$Q[d - 2] | 0, ot = $7d45f003e5c7496e$var$x.rotrSH(I, O, 19) ^ $7d45f003e5c7496e$var$x.rotrBH(I, O, 61) ^ $7d45f003e5c7496e$var$x.shrSH(I, O, 6), tt = $7d45f003e5c7496e$var$x.rotrSL(I, O, 19) ^ $7d45f003e5c7496e$var$x.rotrBL(I, O, 61) ^ $7d45f003e5c7496e$var$x.shrSL(I, O, 6), st = $7d45f003e5c7496e$var$x.add4L(z, tt, $7d45f003e5c7496e$var$Q[d - 7], $7d45f003e5c7496e$var$Q[d - 16]), at = $7d45f003e5c7496e$var$x.add4H(st, q, ot, $7d45f003e5c7496e$var$P[d - 7], $7d45f003e5c7496e$var$P[d - 16]);
            $7d45f003e5c7496e$var$P[d] = at | 0, $7d45f003e5c7496e$var$Q[d] = st | 0;
        }
        let { Ah: r, Al: o, Bh: s, Bl: a, Ch: u, Cl: i, Dh: D, Dl: c, Eh: l, El: p, Fh: w, Fl: h, Gh: g, Gl: S, Hh: v, Hl: L } = this;
        for(let d = 0; d < 80; d++){
            const m = $7d45f003e5c7496e$var$x.rotrSH(l, p, 14) ^ $7d45f003e5c7496e$var$x.rotrSH(l, p, 18) ^ $7d45f003e5c7496e$var$x.rotrBH(l, p, 41), F = $7d45f003e5c7496e$var$x.rotrSL(l, p, 14) ^ $7d45f003e5c7496e$var$x.rotrSL(l, p, 18) ^ $7d45f003e5c7496e$var$x.rotrBL(l, p, 41), q = l & w ^ ~l & g, z = p & h ^ ~p & S, I = $7d45f003e5c7496e$var$x.add5L(L, F, z, $7d45f003e5c7496e$var$Yn[d], $7d45f003e5c7496e$var$Q[d]), O = $7d45f003e5c7496e$var$x.add5H(I, v, m, q, $7d45f003e5c7496e$var$Vn[d], $7d45f003e5c7496e$var$P[d]), ot = I | 0, tt = $7d45f003e5c7496e$var$x.rotrSH(r, o, 28) ^ $7d45f003e5c7496e$var$x.rotrBH(r, o, 34) ^ $7d45f003e5c7496e$var$x.rotrBH(r, o, 39), st = $7d45f003e5c7496e$var$x.rotrSL(r, o, 28) ^ $7d45f003e5c7496e$var$x.rotrBL(r, o, 34) ^ $7d45f003e5c7496e$var$x.rotrBL(r, o, 39), at = r & s ^ r & u ^ s & u, Ct = o & a ^ o & i ^ a & i;
            v = g | 0, L = S | 0, g = w | 0, S = h | 0, w = l | 0, h = p | 0, ({ h: l, l: p } = $7d45f003e5c7496e$var$x.add(D | 0, c | 0, O | 0, ot | 0)), D = u | 0, c = i | 0, u = s | 0, i = a | 0, s = r | 0, a = o | 0;
            const At = $7d45f003e5c7496e$var$x.add3L(ot, st, Ct);
            r = $7d45f003e5c7496e$var$x.add3H(At, O, tt, at), o = At | 0;
        }
        ({ h: r, l: o } = $7d45f003e5c7496e$var$x.add(this.Ah | 0, this.Al | 0, r | 0, o | 0)), ({ h: s, l: a } = $7d45f003e5c7496e$var$x.add(this.Bh | 0, this.Bl | 0, s | 0, a | 0)), ({ h: u, l: i } = $7d45f003e5c7496e$var$x.add(this.Ch | 0, this.Cl | 0, u | 0, i | 0)), ({ h: D, l: c } = $7d45f003e5c7496e$var$x.add(this.Dh | 0, this.Dl | 0, D | 0, c | 0)), ({ h: l, l: p } = $7d45f003e5c7496e$var$x.add(this.Eh | 0, this.El | 0, l | 0, p | 0)), ({ h: w, l: h } = $7d45f003e5c7496e$var$x.add(this.Fh | 0, this.Fl | 0, w | 0, h | 0)), ({ h: g, l: S } = $7d45f003e5c7496e$var$x.add(this.Gh | 0, this.Gl | 0, g | 0, S | 0)), ({ h: v, l: L } = $7d45f003e5c7496e$var$x.add(this.Hh | 0, this.Hl | 0, v | 0, L | 0)), this.set(r, o, s, a, u, i, D, c, l, p, w, h, g, S, v, L);
    }
    roundClean() {
        $7d45f003e5c7496e$var$P.fill(0), $7d45f003e5c7496e$var$Q.fill(0);
    }
    destroy() {
        this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
const $7d45f003e5c7496e$var$Kn = $7d45f003e5c7496e$var$Bn(()=>new $7d45f003e5c7496e$var$Jn); /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
const $7d45f003e5c7496e$var$vt = BigInt(0), $7d45f003e5c7496e$var$be = BigInt(1), $7d45f003e5c7496e$var$Wn = BigInt(2);
function $7d45f003e5c7496e$var$It(t) {
    return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function $7d45f003e5c7496e$var$Ut(t) {
    if (!$7d45f003e5c7496e$var$It(t)) throw new Error("Uint8Array expected");
}
function $7d45f003e5c7496e$var$Tt(t, e) {
    if (typeof e != "boolean") throw new Error(t + " boolean expected, got " + e);
}
const $7d45f003e5c7496e$var$Xn = Array.from({
    length: 256
}, (t, e)=>e.toString(16).padStart(2, "0"));
function $7d45f003e5c7496e$var$Ft(t) {
    $7d45f003e5c7496e$var$Ut(t);
    let e = "";
    for(let n = 0; n < t.length; n++)e += $7d45f003e5c7496e$var$Xn[t[n]];
    return e;
}
function $7d45f003e5c7496e$var$pe(t) {
    if (typeof t != "string") throw new Error("hex string expected, got " + typeof t);
    return t === "" ? $7d45f003e5c7496e$var$vt : BigInt("0x" + t);
}
const $7d45f003e5c7496e$var$K = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $7d45f003e5c7496e$var$we(t) {
    if (t >= $7d45f003e5c7496e$var$K._0 && t <= $7d45f003e5c7496e$var$K._9) return t - $7d45f003e5c7496e$var$K._0;
    if (t >= $7d45f003e5c7496e$var$K.A && t <= $7d45f003e5c7496e$var$K.F) return t - ($7d45f003e5c7496e$var$K.A - 10);
    if (t >= $7d45f003e5c7496e$var$K.a && t <= $7d45f003e5c7496e$var$K.f) return t - ($7d45f003e5c7496e$var$K.a - 10);
}
function $7d45f003e5c7496e$var$Ee(t) {
    if (typeof t != "string") throw new Error("hex string expected, got " + typeof t);
    const e = t.length, n = e / 2;
    if (e % 2) throw new Error("hex string expected, got unpadded hex of length " + e);
    const r = new Uint8Array(n);
    for(let o = 0, s = 0; o < n; o++, s += 2){
        const a = $7d45f003e5c7496e$var$we(t.charCodeAt(s)), u = $7d45f003e5c7496e$var$we(t.charCodeAt(s + 1));
        if (a === void 0 || u === void 0) {
            const i = t[s] + t[s + 1];
            throw new Error('hex string expected, got non-hex character "' + i + '" at index ' + s);
        }
        r[o] = a * 16 + u;
    }
    return r;
}
function $7d45f003e5c7496e$var$Pn(t) {
    return $7d45f003e5c7496e$var$pe($7d45f003e5c7496e$var$Ft(t));
}
function $7d45f003e5c7496e$var$Et(t) {
    return $7d45f003e5c7496e$var$Ut(t), $7d45f003e5c7496e$var$pe($7d45f003e5c7496e$var$Ft(Uint8Array.from(t).reverse()));
}
function $7d45f003e5c7496e$var$ge(t, e) {
    return $7d45f003e5c7496e$var$Ee(t.toString(16).padStart(e * 2, "0"));
}
function $7d45f003e5c7496e$var$Nt(t, e) {
    return $7d45f003e5c7496e$var$ge(t, e).reverse();
}
function $7d45f003e5c7496e$var$W(t, e, n) {
    let r;
    if (typeof e == "string") try {
        r = $7d45f003e5c7496e$var$Ee(e);
    } catch (s) {
        throw new Error(t + " must be hex string or Uint8Array, cause: " + s);
    }
    else if ($7d45f003e5c7496e$var$It(e)) r = Uint8Array.from(e);
    else throw new Error(t + " must be hex string or Uint8Array");
    const o = r.length;
    if (typeof n == "number" && o !== n) throw new Error(t + " of length " + n + " expected, got " + o);
    return r;
}
function $7d45f003e5c7496e$var$ye(...t) {
    let e = 0;
    for(let r = 0; r < t.length; r++){
        const o = t[r];
        $7d45f003e5c7496e$var$Ut(o), e += o.length;
    }
    const n = new Uint8Array(e);
    for(let r = 0, o = 0; r < t.length; r++){
        const s = t[r];
        n.set(s, o), o += s.length;
    }
    return n;
}
const $7d45f003e5c7496e$var$Lt = (t)=>typeof t == "bigint" && $7d45f003e5c7496e$var$vt <= t;
function $7d45f003e5c7496e$var$Qn(t, e, n) {
    return $7d45f003e5c7496e$var$Lt(t) && $7d45f003e5c7496e$var$Lt(e) && $7d45f003e5c7496e$var$Lt(n) && e <= t && t < n;
}
function $7d45f003e5c7496e$var$ft(t, e, n, r) {
    if (!$7d45f003e5c7496e$var$Qn(e, n, r)) throw new Error("expected valid " + t + ": " + n + " <= n < " + r + ", got " + e);
}
function $7d45f003e5c7496e$var$tr(t) {
    let e;
    for(e = 0; t > $7d45f003e5c7496e$var$vt; t >>= $7d45f003e5c7496e$var$be, e += 1);
    return e;
}
const $7d45f003e5c7496e$var$er = (t)=>($7d45f003e5c7496e$var$Wn << BigInt(t - 1)) - $7d45f003e5c7496e$var$be, $7d45f003e5c7496e$var$nr = {
    bigint: (t)=>typeof t == "bigint",
    function: (t)=>typeof t == "function",
    boolean: (t)=>typeof t == "boolean",
    string: (t)=>typeof t == "string",
    stringOrUint8Array: (t)=>typeof t == "string" || $7d45f003e5c7496e$var$It(t),
    isSafeInteger: (t)=>Number.isSafeInteger(t),
    array: (t)=>Array.isArray(t),
    field: (t, e)=>e.Fp.isValid(t),
    hash: (t)=>typeof t == "function" && Number.isSafeInteger(t.outputLen)
};
function $7d45f003e5c7496e$var$Ot(t, e, n = {}) {
    const r = (o, s, a)=>{
        const u = $7d45f003e5c7496e$var$nr[s];
        if (typeof u != "function") throw new Error("invalid validator function");
        const i = t[o];
        if (!(a && i === void 0) && !u(i, t)) throw new Error("param " + String(o) + " is invalid. Expected " + s + ", got " + i);
    };
    for (const [o, s] of Object.entries(e))r(o, s, !1);
    for (const [o, s] of Object.entries(n))r(o, s, !0);
    return t;
}
function $7d45f003e5c7496e$var$xe(t) {
    const e = new WeakMap;
    return (n, ...r)=>{
        const o = e.get(n);
        if (o !== void 0) return o;
        const s = t(n, ...r);
        return e.set(n, s), s;
    };
}
const $7d45f003e5c7496e$var$M = BigInt(0), $7d45f003e5c7496e$var$N = BigInt(1), $7d45f003e5c7496e$var$nt = BigInt(2), $7d45f003e5c7496e$var$rr = BigInt(3), $7d45f003e5c7496e$var$Ht = BigInt(4), $7d45f003e5c7496e$var$Be = BigInt(5), $7d45f003e5c7496e$var$Ce = BigInt(8);
function $7d45f003e5c7496e$var$H(t, e) {
    const n = t % e;
    return n >= $7d45f003e5c7496e$var$M ? n : e + n;
}
function $7d45f003e5c7496e$var$or(t, e, n) {
    if (e < $7d45f003e5c7496e$var$M) throw new Error("invalid exponent, negatives unsupported");
    if (n <= $7d45f003e5c7496e$var$M) throw new Error("invalid modulus");
    if (n === $7d45f003e5c7496e$var$N) return $7d45f003e5c7496e$var$M;
    let r = $7d45f003e5c7496e$var$N;
    for(; e > $7d45f003e5c7496e$var$M;)e & $7d45f003e5c7496e$var$N && (r = r * t % n), t = t * t % n, e >>= $7d45f003e5c7496e$var$N;
    return r;
}
function $7d45f003e5c7496e$var$J(t, e, n) {
    let r = t;
    for(; e-- > $7d45f003e5c7496e$var$M;)r *= r, r %= n;
    return r;
}
function $7d45f003e5c7496e$var$Ae(t, e) {
    if (t === $7d45f003e5c7496e$var$M) throw new Error("invert: expected non-zero number");
    if (e <= $7d45f003e5c7496e$var$M) throw new Error("invert: expected positive modulus, got " + e);
    let n = $7d45f003e5c7496e$var$H(t, e), r = e, o = $7d45f003e5c7496e$var$M, s = $7d45f003e5c7496e$var$N;
    for(; n !== $7d45f003e5c7496e$var$M;){
        const u = r / n, i = r % n, D = o - s * u;
        r = n, n = i, o = s, s = D;
    }
    if (r !== $7d45f003e5c7496e$var$N) throw new Error("invert: does not exist");
    return $7d45f003e5c7496e$var$H(o, e);
}
function $7d45f003e5c7496e$var$sr(t) {
    const e = (t - $7d45f003e5c7496e$var$N) / $7d45f003e5c7496e$var$nt;
    let n, r, o;
    for(n = t - $7d45f003e5c7496e$var$N, r = 0; n % $7d45f003e5c7496e$var$nt === $7d45f003e5c7496e$var$M; n /= $7d45f003e5c7496e$var$nt, r++);
    for(o = $7d45f003e5c7496e$var$nt; o < t && $7d45f003e5c7496e$var$or(o, e, t) !== t - $7d45f003e5c7496e$var$N; o++)if (o > 1e3) throw new Error("Cannot find square root: likely non-prime P");
    if (r === 1) {
        const a = (t + $7d45f003e5c7496e$var$N) / $7d45f003e5c7496e$var$Ht;
        return function(i, D) {
            const c = i.pow(D, a);
            if (!i.eql(i.sqr(c), D)) throw new Error("Cannot find square root");
            return c;
        };
    }
    const s = (n + $7d45f003e5c7496e$var$N) / $7d45f003e5c7496e$var$nt;
    return function(u, i) {
        if (u.pow(i, e) === u.neg(u.ONE)) throw new Error("Cannot find square root");
        let D = r, c = u.pow(u.mul(u.ONE, o), n), l = u.pow(i, s), p = u.pow(i, n);
        for(; !u.eql(p, u.ONE);){
            if (u.eql(p, u.ZERO)) return u.ZERO;
            let w = 1;
            for(let g = u.sqr(p); w < D && !u.eql(g, u.ONE); w++)g = u.sqr(g);
            const h = u.pow(c, $7d45f003e5c7496e$var$N << BigInt(D - w - 1));
            c = u.sqr(h), l = u.mul(l, h), p = u.mul(p, c), D = w;
        }
        return l;
    };
}
function $7d45f003e5c7496e$var$ir(t) {
    if (t % $7d45f003e5c7496e$var$Ht === $7d45f003e5c7496e$var$rr) {
        const e = (t + $7d45f003e5c7496e$var$N) / $7d45f003e5c7496e$var$Ht;
        return function(r, o) {
            const s = r.pow(o, e);
            if (!r.eql(r.sqr(s), o)) throw new Error("Cannot find square root");
            return s;
        };
    }
    if (t % $7d45f003e5c7496e$var$Ce === $7d45f003e5c7496e$var$Be) {
        const e = (t - $7d45f003e5c7496e$var$Be) / $7d45f003e5c7496e$var$Ce;
        return function(r, o) {
            const s = r.mul(o, $7d45f003e5c7496e$var$nt), a = r.pow(s, e), u = r.mul(o, a), i = r.mul(r.mul(u, $7d45f003e5c7496e$var$nt), a), D = r.mul(u, r.sub(i, r.ONE));
            if (!r.eql(r.sqr(D), o)) throw new Error("Cannot find square root");
            return D;
        };
    }
    return $7d45f003e5c7496e$var$sr(t);
}
const $7d45f003e5c7496e$var$ur = (t, e)=>($7d45f003e5c7496e$var$H(t, e) & $7d45f003e5c7496e$var$N) === $7d45f003e5c7496e$var$N, $7d45f003e5c7496e$var$cr = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $7d45f003e5c7496e$var$ar(t) {
    const e = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    }, n = $7d45f003e5c7496e$var$cr.reduce((r, o)=>(r[o] = "function", r), e);
    return $7d45f003e5c7496e$var$Ot(t, n);
}
function $7d45f003e5c7496e$var$fr(t, e, n) {
    if (n < $7d45f003e5c7496e$var$M) throw new Error("invalid exponent, negatives unsupported");
    if (n === $7d45f003e5c7496e$var$M) return t.ONE;
    if (n === $7d45f003e5c7496e$var$N) return e;
    let r = t.ONE, o = e;
    for(; n > $7d45f003e5c7496e$var$M;)n & $7d45f003e5c7496e$var$N && (r = t.mul(r, o)), o = t.sqr(o), n >>= $7d45f003e5c7496e$var$N;
    return r;
}
function $7d45f003e5c7496e$var$Dr(t, e) {
    const n = new Array(e.length), r = e.reduce((s, a, u)=>t.is0(a) ? s : (n[u] = s, t.mul(s, a)), t.ONE), o = t.inv(r);
    return e.reduceRight((s, a, u)=>t.is0(a) ? s : (n[u] = t.mul(s, n[u]), t.mul(s, a)), o), n;
}
function $7d45f003e5c7496e$var$me(t, e) {
    const n = e !== void 0 ? e : t.toString(2).length, r = Math.ceil(n / 8);
    return {
        nBitLength: n,
        nByteLength: r
    };
}
function $7d45f003e5c7496e$var$_e(t, e, n = !1, r = {}) {
    if (t <= $7d45f003e5c7496e$var$M) throw new Error("invalid field: expected ORDER > 0, got " + t);
    const { nBitLength: o, nByteLength: s } = $7d45f003e5c7496e$var$me(t, e);
    if (s > 2048) throw new Error("invalid field: expected ORDER of <= 2048 bytes");
    let a;
    const u = Object.freeze({
        ORDER: t,
        isLE: n,
        BITS: o,
        BYTES: s,
        MASK: $7d45f003e5c7496e$var$er(o),
        ZERO: $7d45f003e5c7496e$var$M,
        ONE: $7d45f003e5c7496e$var$N,
        create: (i)=>$7d45f003e5c7496e$var$H(i, t),
        isValid: (i)=>{
            if (typeof i != "bigint") throw new Error("invalid field element: expected bigint, got " + typeof i);
            return $7d45f003e5c7496e$var$M <= i && i < t;
        },
        is0: (i)=>i === $7d45f003e5c7496e$var$M,
        isOdd: (i)=>(i & $7d45f003e5c7496e$var$N) === $7d45f003e5c7496e$var$N,
        neg: (i)=>$7d45f003e5c7496e$var$H(-i, t),
        eql: (i, D)=>i === D,
        sqr: (i)=>$7d45f003e5c7496e$var$H(i * i, t),
        add: (i, D)=>$7d45f003e5c7496e$var$H(i + D, t),
        sub: (i, D)=>$7d45f003e5c7496e$var$H(i - D, t),
        mul: (i, D)=>$7d45f003e5c7496e$var$H(i * D, t),
        pow: (i, D)=>$7d45f003e5c7496e$var$fr(u, i, D),
        div: (i, D)=>$7d45f003e5c7496e$var$H(i * $7d45f003e5c7496e$var$Ae(D, t), t),
        sqrN: (i)=>i * i,
        addN: (i, D)=>i + D,
        subN: (i, D)=>i - D,
        mulN: (i, D)=>i * D,
        inv: (i)=>$7d45f003e5c7496e$var$Ae(i, t),
        sqrt: r.sqrt || ((i)=>(a || (a = $7d45f003e5c7496e$var$ir(t)), a(u, i))),
        invertBatch: (i)=>$7d45f003e5c7496e$var$Dr(u, i),
        cmov: (i, D, c)=>c ? D : i,
        toBytes: (i)=>n ? $7d45f003e5c7496e$var$Nt(i, s) : $7d45f003e5c7496e$var$ge(i, s),
        fromBytes: (i)=>{
            if (i.length !== s) throw new Error("Field.fromBytes: expected " + s + " bytes, got " + i.length);
            return n ? $7d45f003e5c7496e$var$Et(i) : $7d45f003e5c7496e$var$Pn(i);
        }
    });
    return Object.freeze(u);
}
const $7d45f003e5c7496e$var$Se = BigInt(0), $7d45f003e5c7496e$var$gt = BigInt(1);
function $7d45f003e5c7496e$var$zt(t, e) {
    const n = e.negate();
    return t ? n : e;
}
function $7d45f003e5c7496e$var$ve(t, e) {
    if (!Number.isSafeInteger(t) || t <= 0 || t > e) throw new Error("invalid window size, expected [1.." + e + "], got W=" + t);
}
function $7d45f003e5c7496e$var$Mt(t, e) {
    $7d45f003e5c7496e$var$ve(t, e);
    const n = Math.ceil(e / t) + 1, r = 2 ** (t - 1);
    return {
        windows: n,
        windowSize: r
    };
}
function $7d45f003e5c7496e$var$dr(t, e) {
    if (!Array.isArray(t)) throw new Error("array expected");
    t.forEach((n, r)=>{
        if (!(n instanceof e)) throw new Error("invalid point at index " + r);
    });
}
function $7d45f003e5c7496e$var$hr(t, e) {
    if (!Array.isArray(t)) throw new Error("array of scalars expected");
    t.forEach((n, r)=>{
        if (!e.isValid(n)) throw new Error("invalid scalar at index " + r);
    });
}
const $7d45f003e5c7496e$var$qt = new WeakMap, $7d45f003e5c7496e$var$Ie = new WeakMap;
function $7d45f003e5c7496e$var$$t(t) {
    return $7d45f003e5c7496e$var$Ie.get(t) || 1;
}
function $7d45f003e5c7496e$var$lr(t, e) {
    return {
        constTimeNegate: $7d45f003e5c7496e$var$zt,
        hasPrecomputes (n) {
            return $7d45f003e5c7496e$var$$t(n) !== 1;
        },
        unsafeLadder (n, r, o = t.ZERO) {
            let s = n;
            for(; r > $7d45f003e5c7496e$var$Se;)r & $7d45f003e5c7496e$var$gt && (o = o.add(s)), s = s.double(), r >>= $7d45f003e5c7496e$var$gt;
            return o;
        },
        precomputeWindow (n, r) {
            const { windows: o, windowSize: s } = $7d45f003e5c7496e$var$Mt(r, e), a = [];
            let u = n, i = u;
            for(let D = 0; D < o; D++){
                i = u, a.push(i);
                for(let c = 1; c < s; c++)i = i.add(u), a.push(i);
                u = i.double();
            }
            return a;
        },
        wNAF (n, r, o) {
            const { windows: s, windowSize: a } = $7d45f003e5c7496e$var$Mt(n, e);
            let u = t.ZERO, i = t.BASE;
            const D = BigInt(2 ** n - 1), c = 2 ** n, l = BigInt(n);
            for(let p = 0; p < s; p++){
                const w = p * a;
                let h = Number(o & D);
                o >>= l, h > a && (h -= c, o += $7d45f003e5c7496e$var$gt);
                const g = w, S = w + Math.abs(h) - 1, v = p % 2 !== 0, L = h < 0;
                h === 0 ? i = i.add($7d45f003e5c7496e$var$zt(v, r[g])) : u = u.add($7d45f003e5c7496e$var$zt(L, r[S]));
            }
            return {
                p: u,
                f: i
            };
        },
        wNAFUnsafe (n, r, o, s = t.ZERO) {
            const { windows: a, windowSize: u } = $7d45f003e5c7496e$var$Mt(n, e), i = BigInt(2 ** n - 1), D = 2 ** n, c = BigInt(n);
            for(let l = 0; l < a; l++){
                const p = l * u;
                if (o === $7d45f003e5c7496e$var$Se) break;
                let w = Number(o & i);
                if (o >>= c, w > u && (w -= D, o += $7d45f003e5c7496e$var$gt), w === 0) continue;
                let h = r[p + Math.abs(w) - 1];
                w < 0 && (h = h.negate()), s = s.add(h);
            }
            return s;
        },
        getPrecomputes (n, r, o) {
            let s = $7d45f003e5c7496e$var$qt.get(r);
            return s || (s = this.precomputeWindow(r, n), n !== 1 && $7d45f003e5c7496e$var$qt.set(r, o(s))), s;
        },
        wNAFCached (n, r, o) {
            const s = $7d45f003e5c7496e$var$$t(n);
            return this.wNAF(s, this.getPrecomputes(s, n, o), r);
        },
        wNAFCachedUnsafe (n, r, o, s) {
            const a = $7d45f003e5c7496e$var$$t(n);
            return a === 1 ? this.unsafeLadder(n, r, s) : this.wNAFUnsafe(a, this.getPrecomputes(a, n, o), r, s);
        },
        setWindowSize (n, r) {
            $7d45f003e5c7496e$var$ve(r, e), $7d45f003e5c7496e$var$Ie.set(n, r), $7d45f003e5c7496e$var$qt.delete(n);
        }
    };
}
function $7d45f003e5c7496e$var$br(t, e, n, r) {
    if ($7d45f003e5c7496e$var$dr(n, t), $7d45f003e5c7496e$var$hr(r, e), n.length !== r.length) throw new Error("arrays of points and scalars must have equal length");
    const o = t.ZERO, s = $7d45f003e5c7496e$var$tr(BigInt(n.length)), a = s > 12 ? s - 3 : s > 4 ? s - 2 : s ? 2 : 1, u = (1 << a) - 1, i = new Array(u + 1).fill(o), D = Math.floor((e.BITS - 1) / a) * a;
    let c = o;
    for(let l = D; l >= 0; l -= a){
        i.fill(o);
        for(let w = 0; w < r.length; w++){
            const h = r[w], g = Number(h >> BigInt(l) & BigInt(u));
            i[g] = i[g].add(n[w]);
        }
        let p = o;
        for(let w = i.length - 1, h = o; w > 0; w--)h = h.add(i[w]), p = p.add(h);
        if (c = c.add(p), l !== 0) for(let w = 0; w < a; w++)c = c.double();
    }
    return c;
}
function $7d45f003e5c7496e$var$pr(t) {
    return $7d45f003e5c7496e$var$ar(t.Fp), $7d45f003e5c7496e$var$Ot(t, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    }), Object.freeze({
        ...$7d45f003e5c7496e$var$me(t.n, t.nBitLength),
        ...t,
        p: t.Fp.ORDER
    });
}
const $7d45f003e5c7496e$var$G = BigInt(0), $7d45f003e5c7496e$var$j = BigInt(1), $7d45f003e5c7496e$var$yt = BigInt(2), $7d45f003e5c7496e$var$wr = BigInt(8), $7d45f003e5c7496e$var$Er = {
    zip215: !0
};
function $7d45f003e5c7496e$var$gr(t) {
    const e = $7d45f003e5c7496e$var$pr(t);
    return $7d45f003e5c7496e$var$Ot(t, {
        hash: "function",
        a: "bigint",
        d: "bigint",
        randomBytes: "function"
    }, {
        adjustScalarBytes: "function",
        domain: "function",
        uvRatio: "function",
        mapToCurve: "function"
    }), Object.freeze({
        ...e
    });
}
function $7d45f003e5c7496e$var$yr(t) {
    const e = $7d45f003e5c7496e$var$gr(t), { Fp: n, n: r, prehash: o, hash: s, randomBytes: a, nByteLength: u, h: i } = e, D = $7d45f003e5c7496e$var$yt << BigInt(u * 8) - $7d45f003e5c7496e$var$j, c = n.create, l = $7d45f003e5c7496e$var$_e(e.n, e.nBitLength), p = e.uvRatio || ((y, f)=>{
        try {
            return {
                isValid: !0,
                value: n.sqrt(y * n.inv(f))
            };
        } catch  {
            return {
                isValid: !1,
                value: $7d45f003e5c7496e$var$G
            };
        }
    }), w = e.adjustScalarBytes || ((y)=>y), h = e.domain || ((y, f, b)=>{
        if ($7d45f003e5c7496e$var$Tt("phflag", b), f.length || b) throw new Error("Contexts/pre-hash are not supported");
        return y;
    });
    function g(y, f) {
        $7d45f003e5c7496e$var$ft("coordinate " + y, f, $7d45f003e5c7496e$var$G, D);
    }
    function S(y) {
        if (!(y instanceof d)) throw new Error("ExtendedPoint expected");
    }
    const v = $7d45f003e5c7496e$var$xe((y, f)=>{
        const { ex: b, ey: E, ez: B } = y, C = y.is0();
        f == null && (f = C ? $7d45f003e5c7496e$var$wr : n.inv(B));
        const A = c(b * f), U = c(E * f), _ = c(B * f);
        if (C) return {
            x: $7d45f003e5c7496e$var$G,
            y: $7d45f003e5c7496e$var$j
        };
        if (_ !== $7d45f003e5c7496e$var$j) throw new Error("invZ was invalid");
        return {
            x: A,
            y: U
        };
    }), L = $7d45f003e5c7496e$var$xe((y)=>{
        const { a: f, d: b } = e;
        if (y.is0()) throw new Error("bad point: ZERO");
        const { ex: E, ey: B, ez: C, et: A } = y, U = c(E * E), _ = c(B * B), T = c(C * C), $ = c(T * T), R = c(U * f), V = c(T * c(R + _)), Y = c($ + c(b * c(U * _)));
        if (V !== Y) throw new Error("bad point: equation left != right (1)");
        const Z = c(E * B), X = c(C * A);
        if (Z !== X) throw new Error("bad point: equation left != right (2)");
        return !0;
    });
    class d {
        constructor(f, b, E, B){
            this.ex = f, this.ey = b, this.ez = E, this.et = B, g("x", f), g("y", b), g("z", E), g("t", B), Object.freeze(this);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static fromAffine(f) {
            if (f instanceof d) throw new Error("extended point not allowed");
            const { x: b, y: E } = f || {};
            return g("x", b), g("y", E), new d(b, E, $7d45f003e5c7496e$var$j, c(b * E));
        }
        static normalizeZ(f) {
            const b = n.invertBatch(f.map((E)=>E.ez));
            return f.map((E, B)=>E.toAffine(b[B])).map(d.fromAffine);
        }
        static msm(f, b) {
            return $7d45f003e5c7496e$var$br(d, l, f, b);
        }
        _setWindowSize(f) {
            q.setWindowSize(this, f);
        }
        assertValidity() {
            L(this);
        }
        equals(f) {
            S(f);
            const { ex: b, ey: E, ez: B } = this, { ex: C, ey: A, ez: U } = f, _ = c(b * U), T = c(C * B), $ = c(E * U), R = c(A * B);
            return _ === T && $ === R;
        }
        is0() {
            return this.equals(d.ZERO);
        }
        negate() {
            return new d(c(-this.ex), this.ey, this.ez, c(-this.et));
        }
        double() {
            const { a: f } = e, { ex: b, ey: E, ez: B } = this, C = c(b * b), A = c(E * E), U = c($7d45f003e5c7496e$var$yt * c(B * B)), _ = c(f * C), T = b + E, $ = c(c(T * T) - C - A), R = _ + A, V = R - U, Y = _ - A, Z = c($ * V), X = c(R * Y), et = c($ * Y), pt = c(V * R);
            return new d(Z, X, pt, et);
        }
        add(f) {
            S(f);
            const { a: b, d: E } = e, { ex: B, ey: C, ez: A, et: U } = this, { ex: _, ey: T, ez: $, et: R } = f;
            if (b === BigInt(-1)) {
                const re = c((C - B) * (T + _)), oe = c((C + B) * (T - _)), mt = c(oe - re);
                if (mt === $7d45f003e5c7496e$var$G) return this.double();
                const se = c(A * $7d45f003e5c7496e$var$yt * R), ie = c(U * $7d45f003e5c7496e$var$yt * $), ue = ie + se, ce = oe + re, ae = ie - se, Dn = c(ue * mt), dn = c(ce * ae), hn = c(ue * ae), ln = c(mt * ce);
                return new d(Dn, dn, ln, hn);
            }
            const V = c(B * _), Y = c(C * T), Z = c(U * E * R), X = c(A * $), et = c((B + C) * (_ + T) - V - Y), pt = X - Z, ee = X + Z, ne = c(Y - b * V), un = c(et * pt), cn = c(ee * ne), an = c(et * ne), fn = c(pt * ee);
            return new d(un, cn, fn, an);
        }
        subtract(f) {
            return this.add(f.negate());
        }
        wNAF(f) {
            return q.wNAFCached(this, f, d.normalizeZ);
        }
        multiply(f) {
            const b = f;
            $7d45f003e5c7496e$var$ft("scalar", b, $7d45f003e5c7496e$var$j, r);
            const { p: E, f: B } = this.wNAF(b);
            return d.normalizeZ([
                E,
                B
            ])[0];
        }
        multiplyUnsafe(f, b = d.ZERO) {
            const E = f;
            return $7d45f003e5c7496e$var$ft("scalar", E, $7d45f003e5c7496e$var$G, r), E === $7d45f003e5c7496e$var$G ? F : this.is0() || E === $7d45f003e5c7496e$var$j ? this : q.wNAFCachedUnsafe(this, E, d.normalizeZ, b);
        }
        isSmallOrder() {
            return this.multiplyUnsafe(i).is0();
        }
        isTorsionFree() {
            return q.unsafeLadder(this, r).is0();
        }
        toAffine(f) {
            return v(this, f);
        }
        clearCofactor() {
            const { h: f } = e;
            return f === $7d45f003e5c7496e$var$j ? this : this.multiplyUnsafe(f);
        }
        static fromHex(f, b = !1) {
            const { d: E, a: B } = e, C = n.BYTES;
            f = $7d45f003e5c7496e$var$W("pointHex", f, C), $7d45f003e5c7496e$var$Tt("zip215", b);
            const A = f.slice(), U = f[C - 1];
            A[C - 1] = U & -129;
            const _ = $7d45f003e5c7496e$var$Et(A), T = b ? D : n.ORDER;
            $7d45f003e5c7496e$var$ft("pointHex.y", _, $7d45f003e5c7496e$var$G, T);
            const $ = c(_ * _), R = c($ - $7d45f003e5c7496e$var$j), V = c(E * $ - B);
            let { isValid: Y, value: Z } = p(R, V);
            if (!Y) throw new Error("Point.fromHex: invalid y coordinate");
            const X = (Z & $7d45f003e5c7496e$var$j) === $7d45f003e5c7496e$var$j, et = (U & 128) !== 0;
            if (!b && Z === $7d45f003e5c7496e$var$G && et) throw new Error("Point.fromHex: x=0 and x_0=1");
            return et !== X && (Z = c(-Z)), d.fromAffine({
                x: Z,
                y: _
            });
        }
        static fromPrivateKey(f) {
            return O(f).point;
        }
        toRawBytes() {
            const { x: f, y: b } = this.toAffine(), E = $7d45f003e5c7496e$var$Nt(b, n.BYTES);
            return E[E.length - 1] |= f & $7d45f003e5c7496e$var$j ? 128 : 0, E;
        }
        toHex() {
            return $7d45f003e5c7496e$var$Ft(this.toRawBytes());
        }
    }
    d.BASE = new d(e.Gx, e.Gy, $7d45f003e5c7496e$var$j, c(e.Gx * e.Gy)), d.ZERO = new d($7d45f003e5c7496e$var$G, $7d45f003e5c7496e$var$j, $7d45f003e5c7496e$var$j, $7d45f003e5c7496e$var$G);
    const { BASE: m, ZERO: F } = d, q = $7d45f003e5c7496e$var$lr(d, u * 8);
    function z(y) {
        return $7d45f003e5c7496e$var$H(y, r);
    }
    function I(y) {
        return z($7d45f003e5c7496e$var$Et(y));
    }
    function O(y) {
        const f = n.BYTES;
        y = $7d45f003e5c7496e$var$W("private key", y, f);
        const b = $7d45f003e5c7496e$var$W("hashed private key", s(y), 2 * f), E = w(b.slice(0, f)), B = b.slice(f, 2 * f), C = I(E), A = m.multiply(C), U = A.toRawBytes();
        return {
            head: E,
            prefix: B,
            scalar: C,
            point: A,
            pointBytes: U
        };
    }
    function ot(y) {
        return O(y).pointBytes;
    }
    function tt(y = new Uint8Array, ...f) {
        const b = $7d45f003e5c7496e$var$ye(...f);
        return I(s(h(b, $7d45f003e5c7496e$var$W("context", y), !!o)));
    }
    function st(y, f, b = {}) {
        y = $7d45f003e5c7496e$var$W("message", y), o && (y = o(y));
        const { prefix: E, scalar: B, pointBytes: C } = O(f), A = tt(b.context, E, y), U = m.multiply(A).toRawBytes(), _ = tt(b.context, U, C, y), T = z(A + _ * B);
        $7d45f003e5c7496e$var$ft("signature.s", T, $7d45f003e5c7496e$var$G, r);
        const $ = $7d45f003e5c7496e$var$ye(U, $7d45f003e5c7496e$var$Nt(T, n.BYTES));
        return $7d45f003e5c7496e$var$W("result", $, n.BYTES * 2);
    }
    const at = $7d45f003e5c7496e$var$Er;
    function Ct(y, f, b, E = at) {
        const { context: B, zip215: C } = E, A = n.BYTES;
        y = $7d45f003e5c7496e$var$W("signature", y, 2 * A), f = $7d45f003e5c7496e$var$W("message", f), b = $7d45f003e5c7496e$var$W("publicKey", b, A), C !== void 0 && $7d45f003e5c7496e$var$Tt("zip215", C), o && (f = o(f));
        const U = $7d45f003e5c7496e$var$Et(y.slice(A, 2 * A));
        let _, T, $;
        try {
            _ = d.fromHex(b, C), T = d.fromHex(y.slice(0, A), C), $ = m.multiplyUnsafe(U);
        } catch  {
            return !1;
        }
        if (!C && _.isSmallOrder()) return !1;
        const R = tt(B, T.toRawBytes(), _.toRawBytes(), f);
        return T.add(_.multiplyUnsafe(R)).subtract($).clearCofactor().equals(d.ZERO);
    }
    return m._setWindowSize(8), {
        CURVE: e,
        getPublicKey: ot,
        sign: st,
        verify: Ct,
        ExtendedPoint: d,
        utils: {
            getExtendedPublicKey: O,
            randomPrivateKey: ()=>a(n.BYTES),
            precompute (y = 8, f = d.BASE) {
                return f._setWindowSize(y), f.multiply(BigInt(3)), f;
            }
        }
    };
}
BigInt(0), BigInt(1);
const $7d45f003e5c7496e$var$kt = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949"), $7d45f003e5c7496e$var$Ue = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
BigInt(0);
const $7d45f003e5c7496e$var$xr = BigInt(1), $7d45f003e5c7496e$var$Te = BigInt(2);
BigInt(3);
const $7d45f003e5c7496e$var$Br = BigInt(5), $7d45f003e5c7496e$var$Cr = BigInt(8);
function $7d45f003e5c7496e$var$Ar(t) {
    const e = BigInt(10), n = BigInt(20), r = BigInt(40), o = BigInt(80), s = $7d45f003e5c7496e$var$kt, u = t * t % s * t % s, i = $7d45f003e5c7496e$var$J(u, $7d45f003e5c7496e$var$Te, s) * u % s, D = $7d45f003e5c7496e$var$J(i, $7d45f003e5c7496e$var$xr, s) * t % s, c = $7d45f003e5c7496e$var$J(D, $7d45f003e5c7496e$var$Br, s) * D % s, l = $7d45f003e5c7496e$var$J(c, e, s) * c % s, p = $7d45f003e5c7496e$var$J(l, n, s) * l % s, w = $7d45f003e5c7496e$var$J(p, r, s) * p % s, h = $7d45f003e5c7496e$var$J(w, o, s) * w % s, g = $7d45f003e5c7496e$var$J(h, o, s) * w % s, S = $7d45f003e5c7496e$var$J(g, e, s) * c % s;
    return {
        pow_p_5_8: $7d45f003e5c7496e$var$J(S, $7d45f003e5c7496e$var$Te, s) * t % s,
        b2: u
    };
}
function $7d45f003e5c7496e$var$mr(t) {
    return t[0] &= 248, t[31] &= 127, t[31] |= 64, t;
}
function $7d45f003e5c7496e$var$_r(t, e) {
    const n = $7d45f003e5c7496e$var$kt, r = $7d45f003e5c7496e$var$H(e * e * e, n), o = $7d45f003e5c7496e$var$H(r * r * e, n), s = $7d45f003e5c7496e$var$Ar(t * o).pow_p_5_8;
    let a = $7d45f003e5c7496e$var$H(t * r * s, n);
    const u = $7d45f003e5c7496e$var$H(e * a * a, n), i = a, D = $7d45f003e5c7496e$var$H(a * $7d45f003e5c7496e$var$Ue, n), c = u === t, l = u === $7d45f003e5c7496e$var$H(-t, n), p = u === $7d45f003e5c7496e$var$H(-t * $7d45f003e5c7496e$var$Ue, n);
    return c && (a = i), (l || p) && (a = D), $7d45f003e5c7496e$var$ur(a, n) && (a = $7d45f003e5c7496e$var$H(-a, n)), {
        isValid: c || l,
        value: a
    };
}
const $7d45f003e5c7496e$var$Sr = (()=>$7d45f003e5c7496e$var$_e($7d45f003e5c7496e$var$kt, void 0, !0))(), $7d45f003e5c7496e$var$vr = (()=>({
        a: BigInt(-1),
        d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
        Fp: $7d45f003e5c7496e$var$Sr,
        n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
        h: $7d45f003e5c7496e$var$Cr,
        Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
        Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
        hash: $7d45f003e5c7496e$var$Kn,
        randomBytes: $7d45f003e5c7496e$var$he,
        adjustScalarBytes: $7d45f003e5c7496e$var$mr,
        uvRatio: $7d45f003e5c7496e$var$_r
    }))(), $7d45f003e5c7496e$var$Rt = (()=>$7d45f003e5c7496e$var$yr($7d45f003e5c7496e$var$vr))(), $7d45f003e5c7496e$export$51745f7832485c34 = "EdDSA", $7d45f003e5c7496e$export$f51b45e220f2ba98 = "JWT", $7d45f003e5c7496e$export$a3e35a0f952eb3ef = ".", $7d45f003e5c7496e$export$d2e6fe38c55f8e23 = "base64url", $7d45f003e5c7496e$export$c09c2801e10a2b95 = "utf8", $7d45f003e5c7496e$export$1e9219c0b91a4257 = "utf8", $7d45f003e5c7496e$export$d4057275de9d060b = ":", $7d45f003e5c7496e$export$acf13c61a1a0ccf3 = "did", $7d45f003e5c7496e$export$b908fe81ccf30934 = "key", $7d45f003e5c7496e$export$7bd18b7a7a4d0471 = "base58btc", $7d45f003e5c7496e$export$6d6d3d2e39be8d68 = "z", $7d45f003e5c7496e$export$9902a33a5776d1fc = "K36", $7d45f003e5c7496e$export$ca477e91394a742a = 32, $7d45f003e5c7496e$export$f09ad228919f26fb = 32;
function $7d45f003e5c7496e$var$Xt(t) {
    return globalThis.Buffer != null ? new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : t;
}
function $7d45f003e5c7496e$var$Le(t = 0) {
    return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? $7d45f003e5c7496e$var$Xt(globalThis.Buffer.allocUnsafe(t)) : new Uint8Array(t);
}
function $7d45f003e5c7496e$var$Oe(t, e) {
    e || (e = t.reduce((o, s)=>o + s.length, 0));
    const n = $7d45f003e5c7496e$var$Le(e);
    let r = 0;
    for (const o of t)n.set(o, r), r += o.length;
    return $7d45f003e5c7496e$var$Xt(n);
}
function $7d45f003e5c7496e$var$Ir(t, e) {
    if (t.length >= 255) throw new TypeError("Alphabet too long");
    for(var n = new Uint8Array(256), r = 0; r < n.length; r++)n[r] = 255;
    for(var o = 0; o < t.length; o++){
        var s = t.charAt(o), a = s.charCodeAt(0);
        if (n[a] !== 255) throw new TypeError(s + " is ambiguous");
        n[a] = o;
    }
    var u = t.length, i = t.charAt(0), D = Math.log(u) / Math.log(256), c = Math.log(256) / Math.log(u);
    function l(h) {
        if (h instanceof Uint8Array || (ArrayBuffer.isView(h) ? h = new Uint8Array(h.buffer, h.byteOffset, h.byteLength) : Array.isArray(h) && (h = Uint8Array.from(h))), !(h instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (h.length === 0) return "";
        for(var g = 0, S = 0, v = 0, L = h.length; v !== L && h[v] === 0;)v++, g++;
        for(var d = (L - v) * c + 1 >>> 0, m = new Uint8Array(d); v !== L;){
            for(var F = h[v], q = 0, z = d - 1; (F !== 0 || q < S) && z !== -1; z--, q++)F += 256 * m[z] >>> 0, m[z] = F % u >>> 0, F = F / u >>> 0;
            if (F !== 0) throw new Error("Non-zero carry");
            S = q, v++;
        }
        for(var I = d - S; I !== d && m[I] === 0;)I++;
        for(var O = i.repeat(g); I < d; ++I)O += t.charAt(m[I]);
        return O;
    }
    function p(h) {
        if (typeof h != "string") throw new TypeError("Expected String");
        if (h.length === 0) return new Uint8Array;
        var g = 0;
        if (h[g] !== " ") {
            for(var S = 0, v = 0; h[g] === i;)S++, g++;
            for(var L = (h.length - g) * D + 1 >>> 0, d = new Uint8Array(L); h[g];){
                var m = n[h.charCodeAt(g)];
                if (m === 255) return;
                for(var F = 0, q = L - 1; (m !== 0 || F < v) && q !== -1; q--, F++)m += u * d[q] >>> 0, d[q] = m % 256 >>> 0, m = m / 256 >>> 0;
                if (m !== 0) throw new Error("Non-zero carry");
                v = F, g++;
            }
            if (h[g] !== " ") {
                for(var z = L - v; z !== L && d[z] === 0;)z++;
                for(var I = new Uint8Array(S + (L - z)), O = S; z !== L;)I[O++] = d[z++];
                return I;
            }
        }
    }
    function w(h) {
        var g = p(h);
        if (g) return g;
        throw new Error(`Non-${e} character`);
    }
    return {
        encode: l,
        decodeUnsafe: p,
        decode: w
    };
}
var $7d45f003e5c7496e$var$Ur = $7d45f003e5c7496e$var$Ir, $7d45f003e5c7496e$var$Tr = $7d45f003e5c7496e$var$Ur;
const $7d45f003e5c7496e$var$He = (t)=>{
    if (t instanceof Uint8Array && t.constructor.name === "Uint8Array") return t;
    if (t instanceof ArrayBuffer) return new Uint8Array(t);
    if (ArrayBuffer.isView(t)) return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
    throw new Error("Unknown type, must be binary type");
}, $7d45f003e5c7496e$var$Fr = (t)=>new TextEncoder().encode(t), $7d45f003e5c7496e$var$Nr = (t)=>new TextDecoder().decode(t);
class $7d45f003e5c7496e$var$Lr {
    constructor(e, n, r){
        this.name = e, this.prefix = n, this.baseEncode = r;
    }
    encode(e) {
        if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
        throw Error("Unknown type, must be binary type");
    }
}
class $7d45f003e5c7496e$var$Or {
    constructor(e, n, r){
        if (this.name = e, this.prefix = n, n.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
        this.prefixCodePoint = n.codePointAt(0), this.baseDecode = r;
    }
    decode(e) {
        if (typeof e == "string") {
            if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(e.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(e) {
        return $7d45f003e5c7496e$var$ze(this, e);
    }
}
class $7d45f003e5c7496e$var$Hr {
    constructor(e){
        this.decoders = e;
    }
    or(e) {
        return $7d45f003e5c7496e$var$ze(this, e);
    }
    decode(e) {
        const n = e[0], r = this.decoders[n];
        if (r) return r.decode(e);
        throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $7d45f003e5c7496e$var$ze = (t, e)=>new $7d45f003e5c7496e$var$Hr({
        ...t.decoders || {
            [t.prefix]: t
        },
        ...e.decoders || {
            [e.prefix]: e
        }
    });
class $7d45f003e5c7496e$var$zr {
    constructor(e, n, r, o){
        this.name = e, this.prefix = n, this.baseEncode = r, this.baseDecode = o, this.encoder = new $7d45f003e5c7496e$var$Lr(e, n, r), this.decoder = new $7d45f003e5c7496e$var$Or(e, n, o);
    }
    encode(e) {
        return this.encoder.encode(e);
    }
    decode(e) {
        return this.decoder.decode(e);
    }
}
const $7d45f003e5c7496e$var$Bt = ({ name: t, prefix: e, encode: n, decode: r })=>new $7d45f003e5c7496e$var$zr(t, e, n, r), $7d45f003e5c7496e$var$ht = ({ prefix: t, name: e, alphabet: n })=>{
    const { encode: r, decode: o } = $7d45f003e5c7496e$var$Tr(n, e);
    return $7d45f003e5c7496e$var$Bt({
        prefix: t,
        name: e,
        encode: r,
        decode: (s)=>$7d45f003e5c7496e$var$He(o(s))
    });
}, $7d45f003e5c7496e$var$Mr = (t, e, n, r)=>{
    const o = {};
    for(let c = 0; c < e.length; ++c)o[e[c]] = c;
    let s = t.length;
    for(; t[s - 1] === "=";)--s;
    const a = new Uint8Array(s * n / 8 | 0);
    let u = 0, i = 0, D = 0;
    for(let c = 0; c < s; ++c){
        const l = o[t[c]];
        if (l === void 0) throw new SyntaxError(`Non-${r} character`);
        i = i << n | l, u += n, u >= 8 && (u -= 8, a[D++] = 255 & i >> u);
    }
    if (u >= n || 255 & i << 8 - u) throw new SyntaxError("Unexpected end of data");
    return a;
}, $7d45f003e5c7496e$var$qr = (t, e, n)=>{
    const r = e[e.length - 1] === "=", o = (1 << n) - 1;
    let s = "", a = 0, u = 0;
    for(let i = 0; i < t.length; ++i)for(u = u << 8 | t[i], a += 8; a > n;)a -= n, s += e[o & u >> a];
    if (a && (s += e[o & u << n - a]), r) for(; s.length * n & 7;)s += "=";
    return s;
}, $7d45f003e5c7496e$var$k = ({ name: t, prefix: e, bitsPerChar: n, alphabet: r })=>$7d45f003e5c7496e$var$Bt({
        prefix: e,
        name: t,
        encode (o) {
            return $7d45f003e5c7496e$var$qr(o, r, n);
        },
        decode (o) {
            return $7d45f003e5c7496e$var$Mr(o, r, n, t);
        }
    }), $7d45f003e5c7496e$var$$r = $7d45f003e5c7496e$var$Bt({
    prefix: "\x00",
    name: "identity",
    encode: (t)=>$7d45f003e5c7496e$var$Nr(t),
    decode: (t)=>$7d45f003e5c7496e$var$Fr(t)
});
var $7d45f003e5c7496e$var$kr = Object.freeze({
    __proto__: null,
    identity: $7d45f003e5c7496e$var$$r
});
const $7d45f003e5c7496e$var$Rr = $7d45f003e5c7496e$var$k({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
var $7d45f003e5c7496e$var$jr = Object.freeze({
    __proto__: null,
    base2: $7d45f003e5c7496e$var$Rr
});
const $7d45f003e5c7496e$var$Zr = $7d45f003e5c7496e$var$k({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
var $7d45f003e5c7496e$var$Gr = Object.freeze({
    __proto__: null,
    base8: $7d45f003e5c7496e$var$Zr
});
const $7d45f003e5c7496e$var$Vr = $7d45f003e5c7496e$var$ht({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
var $7d45f003e5c7496e$var$Yr = Object.freeze({
    __proto__: null,
    base10: $7d45f003e5c7496e$var$Vr
});
const $7d45f003e5c7496e$var$Jr = $7d45f003e5c7496e$var$k({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), $7d45f003e5c7496e$var$Kr = $7d45f003e5c7496e$var$k({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
var $7d45f003e5c7496e$var$Wr = Object.freeze({
    __proto__: null,
    base16: $7d45f003e5c7496e$var$Jr,
    base16upper: $7d45f003e5c7496e$var$Kr
});
const $7d45f003e5c7496e$var$Xr = $7d45f003e5c7496e$var$k({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), $7d45f003e5c7496e$var$Pr = $7d45f003e5c7496e$var$k({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), $7d45f003e5c7496e$var$Qr = $7d45f003e5c7496e$var$k({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), $7d45f003e5c7496e$var$to = $7d45f003e5c7496e$var$k({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), $7d45f003e5c7496e$var$eo = $7d45f003e5c7496e$var$k({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), $7d45f003e5c7496e$var$no = $7d45f003e5c7496e$var$k({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), $7d45f003e5c7496e$var$ro = $7d45f003e5c7496e$var$k({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), $7d45f003e5c7496e$var$oo = $7d45f003e5c7496e$var$k({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), $7d45f003e5c7496e$var$so = $7d45f003e5c7496e$var$k({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
var $7d45f003e5c7496e$var$io = Object.freeze({
    __proto__: null,
    base32: $7d45f003e5c7496e$var$Xr,
    base32upper: $7d45f003e5c7496e$var$Pr,
    base32pad: $7d45f003e5c7496e$var$Qr,
    base32padupper: $7d45f003e5c7496e$var$to,
    base32hex: $7d45f003e5c7496e$var$eo,
    base32hexupper: $7d45f003e5c7496e$var$no,
    base32hexpad: $7d45f003e5c7496e$var$ro,
    base32hexpadupper: $7d45f003e5c7496e$var$oo,
    base32z: $7d45f003e5c7496e$var$so
});
const $7d45f003e5c7496e$var$uo = $7d45f003e5c7496e$var$ht({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $7d45f003e5c7496e$var$co = $7d45f003e5c7496e$var$ht({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
var $7d45f003e5c7496e$var$ao = Object.freeze({
    __proto__: null,
    base36: $7d45f003e5c7496e$var$uo,
    base36upper: $7d45f003e5c7496e$var$co
});
const $7d45f003e5c7496e$var$fo = $7d45f003e5c7496e$var$ht({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), $7d45f003e5c7496e$var$Do = $7d45f003e5c7496e$var$ht({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
var $7d45f003e5c7496e$var$ho = Object.freeze({
    __proto__: null,
    base58btc: $7d45f003e5c7496e$var$fo,
    base58flickr: $7d45f003e5c7496e$var$Do
});
const $7d45f003e5c7496e$var$lo = $7d45f003e5c7496e$var$k({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), $7d45f003e5c7496e$var$bo = $7d45f003e5c7496e$var$k({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), $7d45f003e5c7496e$var$po = $7d45f003e5c7496e$var$k({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), $7d45f003e5c7496e$var$wo = $7d45f003e5c7496e$var$k({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
var $7d45f003e5c7496e$var$Eo = Object.freeze({
    __proto__: null,
    base64: $7d45f003e5c7496e$var$lo,
    base64pad: $7d45f003e5c7496e$var$bo,
    base64url: $7d45f003e5c7496e$var$po,
    base64urlpad: $7d45f003e5c7496e$var$wo
});
const $7d45f003e5c7496e$var$Me = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), $7d45f003e5c7496e$var$go = $7d45f003e5c7496e$var$Me.reduce((t, e, n)=>(t[n] = e, t), []), $7d45f003e5c7496e$var$yo = $7d45f003e5c7496e$var$Me.reduce((t, e, n)=>(t[e.codePointAt(0)] = n, t), []);
function $7d45f003e5c7496e$var$xo(t) {
    return t.reduce((e, n)=>(e += $7d45f003e5c7496e$var$go[n], e), "");
}
function $7d45f003e5c7496e$var$Bo(t) {
    const e = [];
    for (const n of t){
        const r = $7d45f003e5c7496e$var$yo[n.codePointAt(0)];
        if (r === void 0) throw new Error(`Non-base256emoji character: ${n}`);
        e.push(r);
    }
    return new Uint8Array(e);
}
const $7d45f003e5c7496e$var$Co = $7d45f003e5c7496e$var$Bt({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $7d45f003e5c7496e$var$xo,
    decode: $7d45f003e5c7496e$var$Bo
});
var $7d45f003e5c7496e$var$Ao = Object.freeze({
    __proto__: null,
    base256emoji: $7d45f003e5c7496e$var$Co
}), $7d45f003e5c7496e$var$mo = $7d45f003e5c7496e$var$$e, $7d45f003e5c7496e$var$qe = 128, $7d45f003e5c7496e$var$_o = 127, $7d45f003e5c7496e$var$So = ~$7d45f003e5c7496e$var$_o, $7d45f003e5c7496e$var$vo = Math.pow(2, 31);
function $7d45f003e5c7496e$var$$e(t, e, n) {
    e = e || [], n = n || 0;
    for(var r = n; t >= $7d45f003e5c7496e$var$vo;)e[n++] = t & 255 | $7d45f003e5c7496e$var$qe, t /= 128;
    for(; t & $7d45f003e5c7496e$var$So;)e[n++] = t & 255 | $7d45f003e5c7496e$var$qe, t >>>= 7;
    return e[n] = t | 0, $7d45f003e5c7496e$var$$e.bytes = n - r + 1, e;
}
var $7d45f003e5c7496e$var$Io = $7d45f003e5c7496e$var$Pt, $7d45f003e5c7496e$var$Uo = 128, $7d45f003e5c7496e$var$ke = 127;
function $7d45f003e5c7496e$var$Pt(t, r) {
    var n = 0, r = r || 0, o = 0, s = r, a, u = t.length;
    do {
        if (s >= u) throw $7d45f003e5c7496e$var$Pt.bytes = 0, new RangeError("Could not decode varint");
        a = t[s++], n += o < 28 ? (a & $7d45f003e5c7496e$var$ke) << o : (a & $7d45f003e5c7496e$var$ke) * Math.pow(2, o), o += 7;
    }while (a >= $7d45f003e5c7496e$var$Uo);
    return $7d45f003e5c7496e$var$Pt.bytes = s - r, n;
}
var $7d45f003e5c7496e$var$To = Math.pow(2, 7), $7d45f003e5c7496e$var$Fo = Math.pow(2, 14), $7d45f003e5c7496e$var$No = Math.pow(2, 21), $7d45f003e5c7496e$var$Lo = Math.pow(2, 28), $7d45f003e5c7496e$var$Oo = Math.pow(2, 35), $7d45f003e5c7496e$var$Ho = Math.pow(2, 42), $7d45f003e5c7496e$var$zo = Math.pow(2, 49), $7d45f003e5c7496e$var$Mo = Math.pow(2, 56), $7d45f003e5c7496e$var$qo = Math.pow(2, 63), $7d45f003e5c7496e$var$$o = function(t) {
    return t < $7d45f003e5c7496e$var$To ? 1 : t < $7d45f003e5c7496e$var$Fo ? 2 : t < $7d45f003e5c7496e$var$No ? 3 : t < $7d45f003e5c7496e$var$Lo ? 4 : t < $7d45f003e5c7496e$var$Oo ? 5 : t < $7d45f003e5c7496e$var$Ho ? 6 : t < $7d45f003e5c7496e$var$zo ? 7 : t < $7d45f003e5c7496e$var$Mo ? 8 : t < $7d45f003e5c7496e$var$qo ? 9 : 10;
}, $7d45f003e5c7496e$var$ko = {
    encode: $7d45f003e5c7496e$var$mo,
    decode: $7d45f003e5c7496e$var$Io,
    encodingLength: $7d45f003e5c7496e$var$$o
}, $7d45f003e5c7496e$var$Re = $7d45f003e5c7496e$var$ko;
const $7d45f003e5c7496e$var$je = (t, e, n = 0)=>($7d45f003e5c7496e$var$Re.encode(t, e, n), e), $7d45f003e5c7496e$var$Ze = (t)=>$7d45f003e5c7496e$var$Re.encodingLength(t), $7d45f003e5c7496e$var$Qt = (t, e)=>{
    const n = e.byteLength, r = $7d45f003e5c7496e$var$Ze(t), o = r + $7d45f003e5c7496e$var$Ze(n), s = new Uint8Array(o + n);
    return $7d45f003e5c7496e$var$je(t, s, 0), $7d45f003e5c7496e$var$je(n, s, r), s.set(e, o), new $7d45f003e5c7496e$var$Ro(t, n, e, s);
};
class $7d45f003e5c7496e$var$Ro {
    constructor(e, n, r, o){
        this.code = e, this.size = n, this.digest = r, this.bytes = o;
    }
}
const $7d45f003e5c7496e$var$Ge = ({ name: t, code: e, encode: n })=>new $7d45f003e5c7496e$var$jo(t, e, n);
class $7d45f003e5c7496e$var$jo {
    constructor(e, n, r){
        this.name = e, this.code = n, this.encode = r;
    }
    digest(e) {
        if (e instanceof Uint8Array) {
            const n = this.encode(e);
            return n instanceof Uint8Array ? $7d45f003e5c7496e$var$Qt(this.code, n) : n.then((r)=>$7d45f003e5c7496e$var$Qt(this.code, r));
        } else throw Error("Unknown type, must be binary type");
    }
}
const $7d45f003e5c7496e$var$Ve = (t)=>async (e)=>new Uint8Array(await crypto.subtle.digest(t, e)), $7d45f003e5c7496e$var$Zo = $7d45f003e5c7496e$var$Ge({
    name: "sha2-256",
    code: 18,
    encode: $7d45f003e5c7496e$var$Ve("SHA-256")
}), $7d45f003e5c7496e$var$Go = $7d45f003e5c7496e$var$Ge({
    name: "sha2-512",
    code: 19,
    encode: $7d45f003e5c7496e$var$Ve("SHA-512")
});
var $7d45f003e5c7496e$var$Vo = Object.freeze({
    __proto__: null,
    sha256: $7d45f003e5c7496e$var$Zo,
    sha512: $7d45f003e5c7496e$var$Go
});
const $7d45f003e5c7496e$var$Ye = 0, $7d45f003e5c7496e$var$Yo = "identity", $7d45f003e5c7496e$var$Je = $7d45f003e5c7496e$var$He, $7d45f003e5c7496e$var$Jo = (t)=>$7d45f003e5c7496e$var$Qt($7d45f003e5c7496e$var$Ye, $7d45f003e5c7496e$var$Je(t)), $7d45f003e5c7496e$var$Ko = {
    code: $7d45f003e5c7496e$var$Ye,
    name: $7d45f003e5c7496e$var$Yo,
    encode: $7d45f003e5c7496e$var$Je,
    digest: $7d45f003e5c7496e$var$Jo
};
var $7d45f003e5c7496e$var$Wo = Object.freeze({
    __proto__: null,
    identity: $7d45f003e5c7496e$var$Ko
});
new TextEncoder, new TextDecoder;
const $7d45f003e5c7496e$var$Ke = {
    ...$7d45f003e5c7496e$var$kr,
    ...$7d45f003e5c7496e$var$jr,
    ...$7d45f003e5c7496e$var$Gr,
    ...$7d45f003e5c7496e$var$Yr,
    ...$7d45f003e5c7496e$var$Wr,
    ...$7d45f003e5c7496e$var$io,
    ...$7d45f003e5c7496e$var$ao,
    ...$7d45f003e5c7496e$var$ho,
    ...$7d45f003e5c7496e$var$Eo,
    ...$7d45f003e5c7496e$var$Ao
};
({
    ...$7d45f003e5c7496e$var$Vo,
    ...$7d45f003e5c7496e$var$Wo
});
function $7d45f003e5c7496e$var$We(t, e, n, r) {
    return {
        name: t,
        prefix: e,
        encoder: {
            name: t,
            prefix: e,
            encode: n
        },
        decoder: {
            decode: r
        }
    };
}
const $7d45f003e5c7496e$var$Xe = $7d45f003e5c7496e$var$We("utf8", "u", (t)=>"u" + new TextDecoder("utf8").decode(t), (t)=>new TextEncoder().encode(t.substring(1))), $7d45f003e5c7496e$var$te = $7d45f003e5c7496e$var$We("ascii", "a", (t)=>{
    let e = "a";
    for(let n = 0; n < t.length; n++)e += String.fromCharCode(t[n]);
    return e;
}, (t)=>{
    t = t.substring(1);
    const e = $7d45f003e5c7496e$var$Le(t.length);
    for(let n = 0; n < t.length; n++)e[n] = t.charCodeAt(n);
    return e;
}), $7d45f003e5c7496e$var$Pe = {
    utf8: $7d45f003e5c7496e$var$Xe,
    "utf-8": $7d45f003e5c7496e$var$Xe,
    hex: $7d45f003e5c7496e$var$Ke.base16,
    latin1: $7d45f003e5c7496e$var$te,
    ascii: $7d45f003e5c7496e$var$te,
    binary: $7d45f003e5c7496e$var$te,
    ...$7d45f003e5c7496e$var$Ke
};
function $7d45f003e5c7496e$var$ct(t, e = "utf8") {
    const n = $7d45f003e5c7496e$var$Pe[e];
    if (!n) throw new Error(`Unsupported encoding "${e}"`);
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? globalThis.Buffer.from(t.buffer, t.byteOffset, t.byteLength).toString("utf8") : n.encoder.encode(t).substring(1);
}
function $7d45f003e5c7496e$var$rt(t, e = "utf8") {
    const n = $7d45f003e5c7496e$var$Pe[e];
    if (!n) throw new Error(`Unsupported encoding "${e}"`);
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? $7d45f003e5c7496e$var$Xt(globalThis.Buffer.from(t, "utf-8")) : n.decoder.decode(`${n.prefix}${t}`);
}
function $7d45f003e5c7496e$export$2030d1af6cd0ef93(t) {
    return (0, $bREX4.safeJsonParse)($7d45f003e5c7496e$var$ct($7d45f003e5c7496e$var$rt(t, $7d45f003e5c7496e$export$d2e6fe38c55f8e23), $7d45f003e5c7496e$export$c09c2801e10a2b95));
}
function $7d45f003e5c7496e$export$84046f8082657cdf(t) {
    return $7d45f003e5c7496e$var$ct($7d45f003e5c7496e$var$rt((0, $bREX4.safeJsonStringify)(t), $7d45f003e5c7496e$export$c09c2801e10a2b95), $7d45f003e5c7496e$export$d2e6fe38c55f8e23);
}
function $7d45f003e5c7496e$export$1b29ef9371459e10(t) {
    const e = $7d45f003e5c7496e$var$rt($7d45f003e5c7496e$export$9902a33a5776d1fc, $7d45f003e5c7496e$export$7bd18b7a7a4d0471), n = $7d45f003e5c7496e$export$6d6d3d2e39be8d68 + $7d45f003e5c7496e$var$ct($7d45f003e5c7496e$var$Oe([
        e,
        t
    ]), $7d45f003e5c7496e$export$7bd18b7a7a4d0471);
    return [
        $7d45f003e5c7496e$export$acf13c61a1a0ccf3,
        $7d45f003e5c7496e$export$b908fe81ccf30934,
        n
    ].join($7d45f003e5c7496e$export$d4057275de9d060b);
}
function $7d45f003e5c7496e$export$86ac046d72244356(t) {
    const [e, n, r] = t.split($7d45f003e5c7496e$export$d4057275de9d060b);
    if (e !== $7d45f003e5c7496e$export$acf13c61a1a0ccf3 || n !== $7d45f003e5c7496e$export$b908fe81ccf30934) throw new Error('Issuer must be a DID with method "key"');
    if (r.slice(0, 1) !== $7d45f003e5c7496e$export$6d6d3d2e39be8d68) throw new Error("Issuer must be a key in mulicodec format");
    const o = $7d45f003e5c7496e$var$rt(r.slice(1), $7d45f003e5c7496e$export$7bd18b7a7a4d0471);
    if ($7d45f003e5c7496e$var$ct(o.slice(0, 2), $7d45f003e5c7496e$export$7bd18b7a7a4d0471) !== $7d45f003e5c7496e$export$9902a33a5776d1fc) throw new Error('Issuer must be a public key with type "Ed25519"');
    const s = o.slice(2);
    if (s.length !== $7d45f003e5c7496e$export$ca477e91394a742a) throw new Error("Issuer must be a public key with length 32 bytes");
    return s;
}
function $7d45f003e5c7496e$export$d9746ef301b2089b(t) {
    return $7d45f003e5c7496e$var$ct(t, $7d45f003e5c7496e$export$d2e6fe38c55f8e23);
}
function $7d45f003e5c7496e$export$c37aeb372ac07c0e(t) {
    return $7d45f003e5c7496e$var$rt(t, $7d45f003e5c7496e$export$d2e6fe38c55f8e23);
}
function $7d45f003e5c7496e$export$cfdd1f2478131e3d(t) {
    return $7d45f003e5c7496e$var$rt([
        $7d45f003e5c7496e$export$84046f8082657cdf(t.header),
        $7d45f003e5c7496e$export$84046f8082657cdf(t.payload)
    ].join($7d45f003e5c7496e$export$a3e35a0f952eb3ef), $7d45f003e5c7496e$export$1e9219c0b91a4257);
}
function $7d45f003e5c7496e$export$13923bea59211b58(t) {
    const e = $7d45f003e5c7496e$var$ct(t, $7d45f003e5c7496e$export$1e9219c0b91a4257).split($7d45f003e5c7496e$export$a3e35a0f952eb3ef), n = $7d45f003e5c7496e$export$2030d1af6cd0ef93(e[0]), r = $7d45f003e5c7496e$export$2030d1af6cd0ef93(e[1]);
    return {
        header: n,
        payload: r
    };
}
function $7d45f003e5c7496e$export$1b70f4551c751d68(t) {
    return [
        $7d45f003e5c7496e$export$84046f8082657cdf(t.header),
        $7d45f003e5c7496e$export$84046f8082657cdf(t.payload),
        $7d45f003e5c7496e$export$d9746ef301b2089b(t.signature)
    ].join($7d45f003e5c7496e$export$a3e35a0f952eb3ef);
}
function $7d45f003e5c7496e$export$9a62e6c0a30e00bc(t) {
    const e = t.split($7d45f003e5c7496e$export$a3e35a0f952eb3ef), n = $7d45f003e5c7496e$export$2030d1af6cd0ef93(e[0]), r = $7d45f003e5c7496e$export$2030d1af6cd0ef93(e[1]), o = $7d45f003e5c7496e$export$c37aeb372ac07c0e(e[2]), s = $7d45f003e5c7496e$var$rt(e.slice(0, 2).join($7d45f003e5c7496e$export$a3e35a0f952eb3ef), $7d45f003e5c7496e$export$1e9219c0b91a4257);
    return {
        header: n,
        payload: r,
        signature: o,
        data: s
    };
}
function $7d45f003e5c7496e$export$a949d36eab55b41f(t = $7d45f003e5c7496e$var$he($7d45f003e5c7496e$export$f09ad228919f26fb)) {
    const e = $7d45f003e5c7496e$var$Rt.getPublicKey(t);
    return {
        secretKey: $7d45f003e5c7496e$var$Oe([
            t,
            e
        ]),
        publicKey: e
    };
}
async function $7d45f003e5c7496e$export$a8dda30659d36d45(t, e, n, r, o = (0, $9eyak.fromMiliseconds)(Date.now())) {
    const s = {
        alg: $7d45f003e5c7496e$export$51745f7832485c34,
        typ: $7d45f003e5c7496e$export$f51b45e220f2ba98
    }, a = $7d45f003e5c7496e$export$1b29ef9371459e10(r.publicKey), u = o + n, i = {
        iss: a,
        sub: t,
        aud: e,
        iat: o,
        exp: u
    }, D = $7d45f003e5c7496e$export$cfdd1f2478131e3d({
        header: s,
        payload: i
    }), c = $7d45f003e5c7496e$var$Rt.sign(D, r.secretKey.slice(0, 32));
    return $7d45f003e5c7496e$export$1b70f4551c751d68({
        header: s,
        payload: i,
        signature: c
    });
}
async function $7d45f003e5c7496e$export$7b6fc79aa8c5b79c(t) {
    const { header: e, payload: n, data: r, signature: o } = $7d45f003e5c7496e$export$9a62e6c0a30e00bc(t);
    if (e.alg !== $7d45f003e5c7496e$export$51745f7832485c34 || e.typ !== $7d45f003e5c7496e$export$f51b45e220f2ba98) throw new Error("JWT must use EdDSA algorithm");
    const s = $7d45f003e5c7496e$export$86ac046d72244356(n.iss);
    return $7d45f003e5c7496e$var$Rt.verify(o, r, s);
}

});

parcelRegister("3qpNA", function(module, exports) {

$parcel$export(module.exports, "parseChainId", () => $27e7cfe6b0bd856f$export$4764229d78de4437);
$parcel$export(module.exports, "isNode", () => $27e7cfe6b0bd856f$export$8ee0fc9ee280b4ee);
$parcel$export(module.exports, "isReactNative", () => $27e7cfe6b0bd856f$export$f7a1e23e542d38e3);
$parcel$export(module.exports, "isAndroid", () => $27e7cfe6b0bd856f$export$a11b0059900ceec8);
$parcel$export(module.exports, "isIos", () => $27e7cfe6b0bd856f$export$41a665f744414057);
$parcel$export(module.exports, "isBrowser", () => $27e7cfe6b0bd856f$export$4e09c449d6c407f7);
$parcel$export(module.exports, "getAppId", () => $27e7cfe6b0bd856f$export$fb2283f4a44fb53);
$parcel$export(module.exports, "populateAppMetadata", () => $27e7cfe6b0bd856f$export$40393344880c2ca3);
$parcel$export(module.exports, "getAppMetadata", () => $27e7cfe6b0bd856f$export$ba31e015127122bb);
$parcel$export(module.exports, "formatUA", () => $27e7cfe6b0bd856f$export$b55a4c6e272b719f);
$parcel$export(module.exports, "formatRelayRpcUrl", () => $27e7cfe6b0bd856f$export$d875b3963ef774f5);
$parcel$export(module.exports, "mapToObj", () => $27e7cfe6b0bd856f$export$c4b8dfeb6e237eb9);
$parcel$export(module.exports, "objToMap", () => $27e7cfe6b0bd856f$export$ac31b37c726bc3ba);
$parcel$export(module.exports, "createDelayedPromise", () => $27e7cfe6b0bd856f$export$cbf9e3cc9ffc85cb);
$parcel$export(module.exports, "createExpiringPromise", () => $27e7cfe6b0bd856f$export$3da2293b007ed708);
$parcel$export(module.exports, "formatTopicTarget", () => $27e7cfe6b0bd856f$export$43ab92477f8713b9);
$parcel$export(module.exports, "formatIdTarget", () => $27e7cfe6b0bd856f$export$bd13103c2e5cc0c3);
$parcel$export(module.exports, "parseExpirerTarget", () => $27e7cfe6b0bd856f$export$93adeb0f16e8e51d);
$parcel$export(module.exports, "calcExpiry", () => $27e7cfe6b0bd856f$export$b136d03015bfc12);
$parcel$export(module.exports, "isExpired", () => $27e7cfe6b0bd856f$export$57947cfd429801a2);
$parcel$export(module.exports, "engineEvent", () => $27e7cfe6b0bd856f$export$e3eb27ce66c0f6d9);
$parcel$export(module.exports, "mergeArrays", () => $27e7cfe6b0bd856f$export$9826fe7ad3921016);
$parcel$export(module.exports, "handleDeeplinkRedirect", () => $27e7cfe6b0bd856f$export$694a208c8abca99a);
$parcel$export(module.exports, "getDeepLink", () => $27e7cfe6b0bd856f$export$e55bfdac47149a32);
$parcel$export(module.exports, "getSearchParamFromURL", () => $27e7cfe6b0bd856f$export$e35f0b82969c30c3);
$parcel$export(module.exports, "uuidv4", () => $27e7cfe6b0bd856f$export$abe4376e1bf796d6);
$parcel$export(module.exports, "isTestRun", () => $27e7cfe6b0bd856f$export$b4bb0f87d8376dd4);
$parcel$export(module.exports, "sleep", () => $27e7cfe6b0bd856f$export$e772c8ff12451969);
$parcel$export(module.exports, "extractSolanaTransactionId", () => $27e7cfe6b0bd856f$export$22c18daeebb76cc2);
$parcel$export(module.exports, "getNamespacedDidChainId", () => $27e7cfe6b0bd856f$export$a8b149927aef7051);
$parcel$export(module.exports, "getDidAddress", () => $27e7cfe6b0bd856f$export$bf43cfbb4bd95de9);
$parcel$export(module.exports, "validateSignedCacao", () => $27e7cfe6b0bd856f$export$b7d566fce8e2b970);
$parcel$export(module.exports, "formatMessage", () => $27e7cfe6b0bd856f$export$25868d1e8e76735f);
$parcel$export(module.exports, "getRecapFromResources", () => $27e7cfe6b0bd856f$export$3bb18ae0fb9a9fa9);
$parcel$export(module.exports, "createEncodedRecap", () => $27e7cfe6b0bd856f$export$2bc35d2a08a09ad5);
$parcel$export(module.exports, "mergeEncodedRecaps", () => $27e7cfe6b0bd856f$export$c7a40c552af428b5);
$parcel$export(module.exports, "getMethodsFromRecap", () => $27e7cfe6b0bd856f$export$d6c6a43d36418efe);
$parcel$export(module.exports, "getChainsFromRecap", () => $27e7cfe6b0bd856f$export$372f88051a611988);
$parcel$export(module.exports, "BASE16", () => $27e7cfe6b0bd856f$export$49eb910ab2518105);
$parcel$export(module.exports, "BASE64", () => $27e7cfe6b0bd856f$export$9bff723d552e6bcf);
$parcel$export(module.exports, "BASE64URL", () => $27e7cfe6b0bd856f$export$e9cf21fb8029e645);
$parcel$export(module.exports, "TYPE_1", () => $27e7cfe6b0bd856f$export$406e97c329f0f3d4);
$parcel$export(module.exports, "TYPE_2", () => $27e7cfe6b0bd856f$export$d79eac6ee921504f);
$parcel$export(module.exports, "generateKeyPair", () => $27e7cfe6b0bd856f$export$a949d36eab55b41f);
$parcel$export(module.exports, "generateRandomBytes32", () => $27e7cfe6b0bd856f$export$d15a28e4f1821243);
$parcel$export(module.exports, "deriveSymKey", () => $27e7cfe6b0bd856f$export$f8378f68e053f5c6);
$parcel$export(module.exports, "hashKey", () => $27e7cfe6b0bd856f$export$1e87d19d4aab5805);
$parcel$export(module.exports, "hashMessage", () => $27e7cfe6b0bd856f$export$d4c241cec96564c1);
$parcel$export(module.exports, "decodeTypeByte", () => $27e7cfe6b0bd856f$export$7547a514ee29b9d4);
$parcel$export(module.exports, "encrypt", () => $27e7cfe6b0bd856f$export$5b0f6292f11d1d18);
$parcel$export(module.exports, "decrypt", () => $27e7cfe6b0bd856f$export$e85a0c9a1067c5d3);
$parcel$export(module.exports, "deserialize", () => $27e7cfe6b0bd856f$export$efcd34ab6248d3cd);
$parcel$export(module.exports, "encodeTypeTwoEnvelope", () => $27e7cfe6b0bd856f$export$99abb28d1c4baa95);
$parcel$export(module.exports, "decodeTypeTwoEnvelope", () => $27e7cfe6b0bd856f$export$6b54347426d28ee3);
$parcel$export(module.exports, "validateDecoding", () => $27e7cfe6b0bd856f$export$177f3e316562333d);
$parcel$export(module.exports, "validateEncoding", () => $27e7cfe6b0bd856f$export$7949f60f2444aef2);
$parcel$export(module.exports, "isTypeOneEnvelope", () => $27e7cfe6b0bd856f$export$8c165704db2d5c15);
$parcel$export(module.exports, "isTypeTwoEnvelope", () => $27e7cfe6b0bd856f$export$599538f59a4a14c3);
$parcel$export(module.exports, "verifyP256Jwt", () => $27e7cfe6b0bd856f$export$f65520390041ee33);
$parcel$export(module.exports, "getRelayProtocolName", () => $27e7cfe6b0bd856f$export$cf77af25151525db);
$parcel$export(module.exports, "getRelayProtocolApi", () => $27e7cfe6b0bd856f$export$604e3deb95e1b734);
$parcel$export(module.exports, "parseUri", () => $27e7cfe6b0bd856f$export$59f58847421cfb28);
$parcel$export(module.exports, "formatUri", () => $27e7cfe6b0bd856f$export$b2786ede34fb2350);
$parcel$export(module.exports, "getLinkModeURL", () => $27e7cfe6b0bd856f$export$556cb6cc912028c2);
$parcel$export(module.exports, "isValidNamespaces", () => $27e7cfe6b0bd856f$export$93f7b81dc815a714);
$parcel$export(module.exports, "isConformingNamespaces", () => $27e7cfe6b0bd856f$export$ba5b0a4b585cd1b4);
$parcel$export(module.exports, "isCaipNamespace", () => $27e7cfe6b0bd856f$export$e03e993df4723bde);
$parcel$export(module.exports, "parseNamespaceKey", () => $27e7cfe6b0bd856f$export$dd404c96fbbb1ff8);
$parcel$export(module.exports, "isValidObject", () => $27e7cfe6b0bd856f$export$16a0268bc22b47b0);
$parcel$export(module.exports, "buildNamespacesFromAuth", () => $27e7cfe6b0bd856f$export$b5744b1c39447540);
$parcel$export(module.exports, "getInternalError", () => $27e7cfe6b0bd856f$export$500d4c4a8fafe35);
$parcel$export(module.exports, "getSdkError", () => $27e7cfe6b0bd856f$export$8203ef1531c8b5b5);
$parcel$export(module.exports, "isValidArray", () => $27e7cfe6b0bd856f$export$41dd3d480aac4a71);
$parcel$export(module.exports, "isUndefined", () => $27e7cfe6b0bd856f$export$fce6876652108ab);
$parcel$export(module.exports, "isValidString", () => $27e7cfe6b0bd856f$export$ee898ca48ab56c74);
$parcel$export(module.exports, "isSessionCompatible", () => $27e7cfe6b0bd856f$export$6fc4971bf8f326a);
$parcel$export(module.exports, "isValidUrl", () => $27e7cfe6b0bd856f$export$bef94a5618bf18bf);
$parcel$export(module.exports, "isProposalStruct", () => $27e7cfe6b0bd856f$export$f657f7976bb2769d);
$parcel$export(module.exports, "isSessionStruct", () => $27e7cfe6b0bd856f$export$c96d5113768aaf5e);
$parcel$export(module.exports, "isValidController", () => $27e7cfe6b0bd856f$export$5e1c5c89613c213f);
$parcel$export(module.exports, "isValidRequiredNamespaces", () => $27e7cfe6b0bd856f$export$9e2b2cae22c6a8b3);
$parcel$export(module.exports, "isValidRelay", () => $27e7cfe6b0bd856f$export$1b3fc298be8c9a7b);
$parcel$export(module.exports, "isValidRelays", () => $27e7cfe6b0bd856f$export$6294c30b976bd21e);
$parcel$export(module.exports, "isValidId", () => $27e7cfe6b0bd856f$export$53551be28ad5e34d);
$parcel$export(module.exports, "isValidParams", () => $27e7cfe6b0bd856f$export$b3f5fcca1d210454);
$parcel$export(module.exports, "isValidErrorReason", () => $27e7cfe6b0bd856f$export$766fe78377d96f2a);
$parcel$export(module.exports, "isValidRequest", () => $27e7cfe6b0bd856f$export$1a2af3c017fb6d42);
$parcel$export(module.exports, "isValidResponse", () => $27e7cfe6b0bd856f$export$1ae38cf0a848f651);
$parcel$export(module.exports, "isValidEvent", () => $27e7cfe6b0bd856f$export$cbe4cdc5960cfa11);
$parcel$export(module.exports, "isValidNamespacesChainId", () => $27e7cfe6b0bd856f$export$144fc36610eb6522);
$parcel$export(module.exports, "isValidNamespacesRequest", () => $27e7cfe6b0bd856f$export$8db4804e3a6de711);
$parcel$export(module.exports, "isValidNamespacesEvent", () => $27e7cfe6b0bd856f$export$df2c67ef8baad16b);
$parcel$export(module.exports, "isValidRequestExpiry", () => $27e7cfe6b0bd856f$export$59fba2af1ac782b);
$parcel$export(module.exports, "isOnline", () => $27e7cfe6b0bd856f$export$53c2fd0173ad2b80);
$parcel$export(module.exports, "subscribeToNetworkChange", () => $27e7cfe6b0bd856f$export$600a1ee4bc680996);
$parcel$export(module.exports, "MemoryStore", () => $27e7cfe6b0bd856f$export$b72d712fed4d036d);

var $dd6tE = parcelRequire("dd6tE");

var $9eyak = parcelRequire("9eyak");

var $bfa86 = parcelRequire("bfa86");

var $5giLd = parcelRequire("5giLd");

var $1DO4H = parcelRequire("1DO4H");

var $4zT52 = parcelRequire("4zT52");

var $aKPeb = parcelRequire("aKPeb");
parcelRequire("68fSN");
var $g976M = parcelRequire("g976M");
var $eREyP = parcelRequire("eREyP");
var $iH58P = parcelRequire("iH58P");

var $lfcmX = parcelRequire("lfcmX");

var $kuzpm = parcelRequire("kuzpm");

var $lewJ9 = parcelRequire("lewJ9");
var $27e7cfe6b0bd856f$require$Buffer = $lewJ9.Buffer;
const $27e7cfe6b0bd856f$var$se = ":";
function $27e7cfe6b0bd856f$export$4764229d78de4437(t) {
    const [e, n] = t.split($27e7cfe6b0bd856f$var$se);
    return {
        namespace: e,
        reference: n
    };
}
function $27e7cfe6b0bd856f$export$a5999672e4930644(t) {
    const { namespace: e, reference: n } = t;
    return [
        e,
        n
    ].join($27e7cfe6b0bd856f$var$se);
}
function $27e7cfe6b0bd856f$export$276ab0158c66e3d(t) {
    const [e, n, r] = t.split($27e7cfe6b0bd856f$var$se);
    return {
        namespace: e,
        reference: n,
        address: r
    };
}
function $27e7cfe6b0bd856f$export$566a25328fb93a18(t) {
    const { namespace: e, reference: n, address: r } = t;
    return [
        e,
        n,
        r
    ].join($27e7cfe6b0bd856f$var$se);
}
function $27e7cfe6b0bd856f$export$d579bc26e95946b5(t, e) {
    const n = [];
    return t.forEach((r)=>{
        const o = e(r);
        n.includes(o) || n.push(o);
    }), n;
}
function $27e7cfe6b0bd856f$export$2806d446053abd1d(t) {
    const { address: e } = $27e7cfe6b0bd856f$export$276ab0158c66e3d(t);
    return e;
}
function $27e7cfe6b0bd856f$export$93512919ec2ab555(t) {
    const { namespace: e, reference: n } = $27e7cfe6b0bd856f$export$276ab0158c66e3d(t);
    return $27e7cfe6b0bd856f$export$a5999672e4930644({
        namespace: e,
        reference: n
    });
}
function $27e7cfe6b0bd856f$export$40283ddc77f27f6e(t, e) {
    const { namespace: n, reference: r } = $27e7cfe6b0bd856f$export$4764229d78de4437(e);
    return $27e7cfe6b0bd856f$export$566a25328fb93a18({
        namespace: n,
        reference: r,
        address: t
    });
}
function $27e7cfe6b0bd856f$export$aa4a6b630dfcfa83(t) {
    return $27e7cfe6b0bd856f$export$d579bc26e95946b5(t, $27e7cfe6b0bd856f$export$2806d446053abd1d);
}
function $27e7cfe6b0bd856f$export$d5ee58c6b13696e9(t) {
    return $27e7cfe6b0bd856f$export$d579bc26e95946b5(t, $27e7cfe6b0bd856f$export$93512919ec2ab555);
}
function $27e7cfe6b0bd856f$export$23329703ad972840(t, e = []) {
    const n = [];
    return Object.keys(t).forEach((r)=>{
        if (e.length && !e.includes(r)) return;
        const o = t[r];
        n.push(...o.accounts);
    }), n;
}
function $27e7cfe6b0bd856f$export$6281ff29da5f85fe(t, e = []) {
    const n = [];
    return Object.keys(t).forEach((r)=>{
        if (e.length && !e.includes(r)) return;
        const o = t[r];
        n.push(...$27e7cfe6b0bd856f$export$d5ee58c6b13696e9(o.accounts));
    }), n;
}
function $27e7cfe6b0bd856f$export$d1109eeb751412cf(t, e = []) {
    const n = [];
    return Object.keys(t).forEach((r)=>{
        if (e.length && !e.includes(r)) return;
        const o = t[r];
        n.push(...$27e7cfe6b0bd856f$export$376384387cd15b27(r, o));
    }), n;
}
function $27e7cfe6b0bd856f$export$376384387cd15b27(t, e) {
    return t.includes(":") ? [
        t
    ] : e.chains || [];
}
var $27e7cfe6b0bd856f$var$Zo = Object.defineProperty, $27e7cfe6b0bd856f$var$Yo = Object.defineProperties, $27e7cfe6b0bd856f$var$Go = Object.getOwnPropertyDescriptors, $27e7cfe6b0bd856f$var$Tn = Object.getOwnPropertySymbols, $27e7cfe6b0bd856f$var$Wo = Object.prototype.hasOwnProperty, $27e7cfe6b0bd856f$var$Xo = Object.prototype.propertyIsEnumerable, $27e7cfe6b0bd856f$var$Rn = (t, e, n)=>e in t ? $27e7cfe6b0bd856f$var$Zo(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n, $27e7cfe6b0bd856f$var$_n = (t, e)=>{
    for(var n in e || (e = {}))$27e7cfe6b0bd856f$var$Wo.call(e, n) && $27e7cfe6b0bd856f$var$Rn(t, n, e[n]);
    if ($27e7cfe6b0bd856f$var$Tn) for (var n of $27e7cfe6b0bd856f$var$Tn(e))$27e7cfe6b0bd856f$var$Xo.call(e, n) && $27e7cfe6b0bd856f$var$Rn(t, n, e[n]);
    return t;
}, $27e7cfe6b0bd856f$var$Jo = (t, e)=>$27e7cfe6b0bd856f$var$Yo(t, $27e7cfe6b0bd856f$var$Go(e));
const $27e7cfe6b0bd856f$export$f12873d77424d47b = "ReactNative", $27e7cfe6b0bd856f$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $27e7cfe6b0bd856f$export$657dee6d5648750a = " ", $27e7cfe6b0bd856f$export$96c3628b3b9d2079 = ":", $27e7cfe6b0bd856f$export$98238152dfccf046 = "/", $27e7cfe6b0bd856f$export$7f882bb969de14a3 = 2, $27e7cfe6b0bd856f$export$77baccb4c6bd5852 = 1e3, $27e7cfe6b0bd856f$export$e08b61c98317d88c = "js";
function $27e7cfe6b0bd856f$export$8ee0fc9ee280b4ee() {
    return typeof $kuzpm < "u" && typeof $kuzpm.versions < "u" && typeof $kuzpm.versions.node < "u";
}
function $27e7cfe6b0bd856f$export$f7a1e23e542d38e3() {
    return !(0, $bfa86.getDocument)() && !!(0, $bfa86.getNavigator)() && navigator.product === $27e7cfe6b0bd856f$export$f12873d77424d47b;
}
function $27e7cfe6b0bd856f$export$a11b0059900ceec8() {
    return $27e7cfe6b0bd856f$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u" && ($parcel$global == null ? void 0 : $parcel$global.Platform.OS) === "android";
}
function $27e7cfe6b0bd856f$export$41a665f744414057() {
    return $27e7cfe6b0bd856f$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u" && ($parcel$global == null ? void 0 : $parcel$global.Platform.OS) === "ios";
}
function $27e7cfe6b0bd856f$export$4e09c449d6c407f7() {
    return !$27e7cfe6b0bd856f$export$8ee0fc9ee280b4ee() && !!(0, $bfa86.getNavigator)() && !!(0, $bfa86.getDocument)();
}
function $27e7cfe6b0bd856f$export$57570b1603cf6adb() {
    return $27e7cfe6b0bd856f$export$f7a1e23e542d38e3() ? $27e7cfe6b0bd856f$export$86b1301a63b15dd9.reactNative : $27e7cfe6b0bd856f$export$8ee0fc9ee280b4ee() ? $27e7cfe6b0bd856f$export$86b1301a63b15dd9.node : $27e7cfe6b0bd856f$export$4e09c449d6c407f7() ? $27e7cfe6b0bd856f$export$86b1301a63b15dd9.browser : $27e7cfe6b0bd856f$export$86b1301a63b15dd9.unknown;
}
function $27e7cfe6b0bd856f$export$fb2283f4a44fb53() {
    var t;
    try {
        return $27e7cfe6b0bd856f$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Application) < "u" ? (t = $parcel$global.Application) == null ? void 0 : t.applicationId : void 0;
    } catch  {
        return;
    }
}
function $27e7cfe6b0bd856f$export$c4147c69f6845da(t, e) {
    const n = new URLSearchParams(t);
    for (const r of Object.keys(e).sort())if (e.hasOwnProperty(r)) {
        const o = e[r];
        o !== void 0 && n.set(r, o);
    }
    return n.toString();
}
function $27e7cfe6b0bd856f$export$40393344880c2ca3(t) {
    var e, n;
    const r = $27e7cfe6b0bd856f$export$ba31e015127122bb();
    try {
        return t != null && t.url && r.url && t.url !== r.url && (console.warn(`The configured WalletConnect 'metadata.url':${t.url} differs from the actual page url:${r.url}. This is probably unintended and can lead to issues.`), t.url = r.url), (e = t?.icons) != null && e.length && t.icons.length > 0 && (t.icons = t.icons.filter((o)=>o !== "")), $27e7cfe6b0bd856f$var$Jo($27e7cfe6b0bd856f$var$_n($27e7cfe6b0bd856f$var$_n({}, r), t), {
            url: t?.url || r.url,
            name: t?.name || r.name,
            description: t?.description || r.description,
            icons: (n = t?.icons) != null && n.length && t.icons.length > 0 ? t.icons : r.icons
        });
    } catch (o) {
        return console.warn("Error populating app metadata", o), t || r;
    }
}
function $27e7cfe6b0bd856f$export$ba31e015127122bb() {
    return (0, $5giLd.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $27e7cfe6b0bd856f$export$6b05aa0115b6fc2d(t, e) {
    var n;
    const r = $27e7cfe6b0bd856f$export$57570b1603cf6adb(), o = {
        protocol: t,
        version: e,
        env: r
    };
    return r === "browser" && (o.host = ((n = (0, $bfa86.getLocation)()) == null ? void 0 : n.host) || "unknown"), o;
}
function $27e7cfe6b0bd856f$export$20d4a3cb5829b8b6() {
    if ($27e7cfe6b0bd856f$export$57570b1603cf6adb() === $27e7cfe6b0bd856f$export$86b1301a63b15dd9.reactNative && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        const { OS: n, Version: r } = $parcel$global.Platform;
        return [
            n,
            r
        ].join("-");
    }
    const t = (0, $dd6tE.detect)();
    if (t === null) return "unknown";
    const e = t.os ? t.os.replace(" ", "").toLowerCase() : "unknown";
    return t.type === "browser" ? [
        e,
        t.name,
        t.version
    ].join("-") : [
        e,
        t.version
    ].join("-");
}
function $27e7cfe6b0bd856f$export$4389b0987726d52d() {
    var t;
    const e = $27e7cfe6b0bd856f$export$57570b1603cf6adb();
    return e === $27e7cfe6b0bd856f$export$86b1301a63b15dd9.browser ? [
        e,
        ((t = (0, $bfa86.getLocation)()) == null ? void 0 : t.host) || "unknown"
    ].join(":") : e;
}
function $27e7cfe6b0bd856f$export$b55a4c6e272b719f(t, e, n) {
    const r = $27e7cfe6b0bd856f$export$20d4a3cb5829b8b6(), o = $27e7cfe6b0bd856f$export$4389b0987726d52d();
    return [
        [
            t,
            e
        ].join("-"),
        [
            $27e7cfe6b0bd856f$export$e08b61c98317d88c,
            n
        ].join("-"),
        r,
        o
    ].join("/");
}
function $27e7cfe6b0bd856f$export$d875b3963ef774f5({ protocol: t, version: e, relayUrl: n, sdkVersion: r, auth: o, projectId: i, useOnCloseEvent: s, bundleId: c, packageName: a }) {
    const u = n.split("?"), l = $27e7cfe6b0bd856f$export$b55a4c6e272b719f(t, e, r), f = {
        auth: o,
        ua: l,
        projectId: i,
        useOnCloseEvent: s || void 0,
        packageName: a || void 0,
        bundleId: c || void 0
    }, h = $27e7cfe6b0bd856f$export$c4147c69f6845da(u[1] || "", f);
    return u[0] + "?" + h;
}
function $27e7cfe6b0bd856f$export$ed08891a8a54eb(t) {
    let e = (t.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const n = typeof e < "u" ? t.split("://")[1] : t;
    return e = e === "wss" ? "https" : "http", [
        e,
        n
    ].join("://");
}
function $27e7cfe6b0bd856f$export$804de46662e4ac95(t, e, n) {
    if (!t[e] || typeof t[e] !== n) throw new Error(`Missing or invalid "${e}" param`);
}
function $27e7cfe6b0bd856f$export$1e21530e896c0b0b(t, e = $27e7cfe6b0bd856f$export$7f882bb969de14a3) {
    return $27e7cfe6b0bd856f$export$7f00885504704576(t.split($27e7cfe6b0bd856f$export$98238152dfccf046), e);
}
function $27e7cfe6b0bd856f$export$80bffd46c37a96f6(t) {
    return $27e7cfe6b0bd856f$export$1e21530e896c0b0b(t).join($27e7cfe6b0bd856f$export$657dee6d5648750a);
}
function $27e7cfe6b0bd856f$export$1468a49de573f7f9(t, e) {
    return t.filter((n)=>e.includes(n)).length === t.length;
}
function $27e7cfe6b0bd856f$export$7f00885504704576(t, e = $27e7cfe6b0bd856f$export$7f882bb969de14a3) {
    return t.slice(Math.max(t.length - e, 0));
}
function $27e7cfe6b0bd856f$export$c4b8dfeb6e237eb9(t) {
    return Object.fromEntries(t.entries());
}
function $27e7cfe6b0bd856f$export$ac31b37c726bc3ba(t) {
    return new Map(Object.entries(t));
}
function $27e7cfe6b0bd856f$export$592ef47eabb05614(t, e) {
    const n = {};
    return Object.keys(t).forEach((r)=>{
        n[r] = e(t[r]);
    }), n;
}
const $27e7cfe6b0bd856f$export$85c927578394b28b = (t)=>t;
function $27e7cfe6b0bd856f$export$e9f8fcacef3bca4b(t) {
    return t.trim().replace(/^\w/, (e)=>e.toUpperCase());
}
function $27e7cfe6b0bd856f$export$9a00dee1beb8f576(t) {
    return t.split($27e7cfe6b0bd856f$export$657dee6d5648750a).map((e)=>$27e7cfe6b0bd856f$export$e9f8fcacef3bca4b(e)).join($27e7cfe6b0bd856f$export$657dee6d5648750a);
}
function $27e7cfe6b0bd856f$export$cbf9e3cc9ffc85cb(t = (0, $9eyak.FIVE_MINUTES), e) {
    const n = (0, $9eyak.toMiliseconds)(t || (0, $9eyak.FIVE_MINUTES));
    let r, o, i, s;
    return {
        resolve: (c)=>{
            i && r && (clearTimeout(i), r(c), s = Promise.resolve(c));
        },
        reject: (c)=>{
            i && o && (clearTimeout(i), o(c));
        },
        done: ()=>new Promise((c, a)=>{
                if (s) return c(s);
                i = setTimeout(()=>{
                    const u = new Error(e);
                    s = Promise.reject(u), a(u);
                }, n), r = c, o = a;
            })
    };
}
function $27e7cfe6b0bd856f$export$3da2293b007ed708(t, e, n) {
    return new Promise(async (r, o)=>{
        const i = setTimeout(()=>o(new Error(n)), e);
        try {
            const s = await t;
            r(s);
        } catch (s) {
            o(s);
        }
        clearTimeout(i);
    });
}
function $27e7cfe6b0bd856f$export$187ab6574b2ae23f(t, e) {
    if (typeof e == "string" && e.startsWith(`${t}:`)) return e;
    if (t.toLowerCase() === "topic") {
        if (typeof e != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${e}`;
    } else if (t.toLowerCase() === "id") {
        if (typeof e != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${e}`;
    }
    throw new Error(`Unknown expirer target type: ${t}`);
}
function $27e7cfe6b0bd856f$export$43ab92477f8713b9(t) {
    return $27e7cfe6b0bd856f$export$187ab6574b2ae23f("topic", t);
}
function $27e7cfe6b0bd856f$export$bd13103c2e5cc0c3(t) {
    return $27e7cfe6b0bd856f$export$187ab6574b2ae23f("id", t);
}
function $27e7cfe6b0bd856f$export$93adeb0f16e8e51d(t) {
    const [e, n] = t.split(":"), r = {
        id: void 0,
        topic: void 0
    };
    if (e === "topic" && typeof n == "string") r.topic = n;
    else if (e === "id" && Number.isInteger(Number(n))) r.id = Number(n);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${e}:${n}`);
    return r;
}
function $27e7cfe6b0bd856f$export$b136d03015bfc12(t, e) {
    return (0, $9eyak.fromMiliseconds)((e || Date.now()) + (0, $9eyak.toMiliseconds)(t));
}
function $27e7cfe6b0bd856f$export$57947cfd429801a2(t) {
    return Date.now() >= (0, $9eyak.toMiliseconds)(t);
}
function $27e7cfe6b0bd856f$export$e3eb27ce66c0f6d9(t, e) {
    return `${t}${e ? `:${e}` : ""}`;
}
function $27e7cfe6b0bd856f$export$9826fe7ad3921016(t = [], e = []) {
    return [
        ...new Set([
            ...t,
            ...e
        ])
    ];
}
async function $27e7cfe6b0bd856f$export$694a208c8abca99a({ id: t, topic: e, wcDeepLink: n }) {
    var r;
    try {
        if (!n) return;
        const o = typeof n == "string" ? JSON.parse(n) : n, i = o?.href;
        if (typeof i != "string") return;
        const s = $27e7cfe6b0bd856f$export$50b95b57215c848b(i, t, e), c = $27e7cfe6b0bd856f$export$57570b1603cf6adb();
        if (c === $27e7cfe6b0bd856f$export$86b1301a63b15dd9.browser) {
            if (!((r = (0, $bfa86.getDocument)()) != null && r.hasFocus())) {
                console.warn("Document does not have focus, skipping deeplink.");
                return;
            }
            $27e7cfe6b0bd856f$export$435b055258496866(s);
        } else c === $27e7cfe6b0bd856f$export$86b1301a63b15dd9.reactNative && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u" && await $parcel$global.Linking.openURL(s);
    } catch (o) {
        console.error(o);
    }
}
function $27e7cfe6b0bd856f$export$50b95b57215c848b(t, e, n) {
    const r = `requestId=${e}&sessionTopic=${n}`;
    t.endsWith("/") && (t = t.slice(0, -1));
    let o = `${t}`;
    if (t.startsWith("https://t.me")) {
        const i = t.includes("?") ? "&startapp=" : "?startapp=";
        o = `${o}${i}${$27e7cfe6b0bd856f$export$37cc283d8fbd3462(r, !0)}`;
    } else o = `${o}/wc?${r}`;
    return o;
}
function $27e7cfe6b0bd856f$export$435b055258496866(t) {
    let e = "_self";
    $27e7cfe6b0bd856f$export$e6c5ffa684aac4d7() ? e = "_top" : ($27e7cfe6b0bd856f$export$859b6b071fc07ffd() || t.startsWith("https://") || t.startsWith("http://")) && (e = "_blank"), window.open(t, e, "noreferrer noopener");
}
async function $27e7cfe6b0bd856f$export$e55bfdac47149a32(t, e) {
    let n = "";
    try {
        if ($27e7cfe6b0bd856f$export$4e09c449d6c407f7() && (n = localStorage.getItem(e), n)) return n;
        n = await t.getItem(e);
    } catch (r) {
        console.error(r);
    }
    return n;
}
function $27e7cfe6b0bd856f$export$f8aaf09178dd8b96(t, e) {
    return t.filter((n)=>e.includes(n));
}
function $27e7cfe6b0bd856f$export$e35f0b82969c30c3(t, e) {
    if (!t.includes(e)) return null;
    const n = t.split(/([&,?,=])/), r = n.indexOf(e);
    return n[r + 2];
}
function $27e7cfe6b0bd856f$export$abe4376e1bf796d6() {
    return typeof crypto < "u" && crypto != null && crypto.randomUUID ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/gu, (t)=>{
        const e = Math.random() * 16 | 0;
        return (t === "x" ? e : e & 3 | 8).toString(16);
    });
}
function $27e7cfe6b0bd856f$export$b4bb0f87d8376dd4() {
    return typeof $kuzpm < "u" && false;
}
function $27e7cfe6b0bd856f$export$859b6b071fc07ffd() {
    return typeof window < "u" && (!!window.TelegramWebviewProxy || !!window.Telegram || !!window.TelegramWebviewProxyProto);
}
function $27e7cfe6b0bd856f$export$e6c5ffa684aac4d7() {
    try {
        return window.self !== window.top;
    } catch  {
        return !1;
    }
}
function $27e7cfe6b0bd856f$export$37cc283d8fbd3462(t, e = !1) {
    const n = $27e7cfe6b0bd856f$require$Buffer.from(t).toString("base64");
    return e ? n.replace(/[=]/g, "") : n;
}
function $27e7cfe6b0bd856f$export$c537b38001c583b7(t) {
    return $27e7cfe6b0bd856f$require$Buffer.from(t, "base64").toString("utf-8");
}
function $27e7cfe6b0bd856f$export$e772c8ff12451969(t) {
    return new Promise((e)=>setTimeout(e, t));
}
function $27e7cfe6b0bd856f$var$Gt(t) {
    if (!Number.isSafeInteger(t) || t < 0) throw new Error("positive integer expected, got " + t);
}
function $27e7cfe6b0bd856f$var$Ui(t) {
    return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function $27e7cfe6b0bd856f$var$Wt(t, ...e) {
    if (!$27e7cfe6b0bd856f$var$Ui(t)) throw new Error("Uint8Array expected");
    if (e.length > 0 && !e.includes(t.length)) throw new Error("Uint8Array expected of length " + e + ", got length=" + t.length);
}
function $27e7cfe6b0bd856f$var$je(t) {
    if (typeof t != "function" || typeof t.create != "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $27e7cfe6b0bd856f$var$Gt(t.outputLen), $27e7cfe6b0bd856f$var$Gt(t.blockLen);
}
function $27e7cfe6b0bd856f$var$Tt(t, e = !0) {
    if (t.destroyed) throw new Error("Hash instance has been destroyed");
    if (e && t.finished) throw new Error("Hash#digest() has already been called");
}
function $27e7cfe6b0bd856f$var$Gn(t, e) {
    $27e7cfe6b0bd856f$var$Wt(t);
    const n = e.outputLen;
    if (t.length < n) throw new Error("digestInto() expects output buffer of length at least " + n);
}
const $27e7cfe6b0bd856f$var$ue = BigInt(2 ** 32 - 1), $27e7cfe6b0bd856f$var$Wn = BigInt(32);
function $27e7cfe6b0bd856f$var$Ti(t, e = !1) {
    return e ? {
        h: Number(t & $27e7cfe6b0bd856f$var$ue),
        l: Number(t >> $27e7cfe6b0bd856f$var$Wn & $27e7cfe6b0bd856f$var$ue)
    } : {
        h: Number(t >> $27e7cfe6b0bd856f$var$Wn & $27e7cfe6b0bd856f$var$ue) | 0,
        l: Number(t & $27e7cfe6b0bd856f$var$ue) | 0
    };
}
function $27e7cfe6b0bd856f$var$Ri(t, e = !1) {
    let n = new Uint32Array(t.length), r = new Uint32Array(t.length);
    for(let o = 0; o < t.length; o++){
        const { h: i, l: s } = $27e7cfe6b0bd856f$var$Ti(t[o], e);
        [n[o], r[o]] = [
            i,
            s
        ];
    }
    return [
        n,
        r
    ];
}
const $27e7cfe6b0bd856f$var$_i = (t, e, n)=>t << n | e >>> 32 - n, $27e7cfe6b0bd856f$var$$i = (t, e, n)=>e << n | t >>> 32 - n, $27e7cfe6b0bd856f$var$Li = (t, e, n)=>e << n - 32 | t >>> 64 - n, $27e7cfe6b0bd856f$var$ji = (t, e, n)=>t << n - 32 | e >>> 64 - n, $27e7cfe6b0bd856f$var$Rt = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
function $27e7cfe6b0bd856f$var$Ci(t) {
    return new Uint32Array(t.buffer, t.byteOffset, Math.floor(t.byteLength / 4));
}
function $27e7cfe6b0bd856f$var$Ce(t) {
    return new DataView(t.buffer, t.byteOffset, t.byteLength);
}
function $27e7cfe6b0bd856f$var$st(t, e) {
    return t << 32 - e | t >>> e;
}
const $27e7cfe6b0bd856f$var$Xn = new Uint8Array(new Uint32Array([
    287454020
]).buffer)[0] === 68;
function $27e7cfe6b0bd856f$var$Pi(t) {
    return t << 24 & 4278190080 | t << 8 & 16711680 | t >>> 8 & 65280 | t >>> 24 & 255;
}
function $27e7cfe6b0bd856f$var$Jn(t) {
    for(let e = 0; e < t.length; e++)t[e] = $27e7cfe6b0bd856f$var$Pi(t[e]);
}
function $27e7cfe6b0bd856f$var$ki(t) {
    if (typeof t != "string") throw new Error("utf8ToBytes expected string, got " + typeof t);
    return new Uint8Array(new TextEncoder().encode(t));
}
function $27e7cfe6b0bd856f$var$_t(t) {
    return typeof t == "string" && (t = $27e7cfe6b0bd856f$var$ki(t)), $27e7cfe6b0bd856f$var$Wt(t), t;
}
function $27e7cfe6b0bd856f$var$Vi(...t) {
    let e = 0;
    for(let r = 0; r < t.length; r++){
        const o = t[r];
        $27e7cfe6b0bd856f$var$Wt(o), e += o.length;
    }
    const n = new Uint8Array(e);
    for(let r = 0, o = 0; r < t.length; r++){
        const i = t[r];
        n.set(i, o), o += i.length;
    }
    return n;
}
class $27e7cfe6b0bd856f$var$Pe {
    clone() {
        return this._cloneInto();
    }
}
function $27e7cfe6b0bd856f$var$Qn(t) {
    const e = (r)=>t().update($27e7cfe6b0bd856f$var$_t(r)).digest(), n = t();
    return e.outputLen = n.outputLen, e.blockLen = n.blockLen, e.create = ()=>t(), e;
}
function $27e7cfe6b0bd856f$var$$t(t = 32) {
    if ($27e7cfe6b0bd856f$var$Rt && typeof $27e7cfe6b0bd856f$var$Rt.getRandomValues == "function") return $27e7cfe6b0bd856f$var$Rt.getRandomValues(new Uint8Array(t));
    if ($27e7cfe6b0bd856f$var$Rt && typeof $27e7cfe6b0bd856f$var$Rt.randomBytes == "function") return $27e7cfe6b0bd856f$var$Rt.randomBytes(t);
    throw new Error("crypto.getRandomValues must be defined");
}
const $27e7cfe6b0bd856f$var$tr = [], $27e7cfe6b0bd856f$var$er = [], $27e7cfe6b0bd856f$var$nr = [], $27e7cfe6b0bd856f$var$Mi = BigInt(0), $27e7cfe6b0bd856f$var$Xt = BigInt(1), $27e7cfe6b0bd856f$var$Di = BigInt(2), $27e7cfe6b0bd856f$var$Hi = BigInt(7), $27e7cfe6b0bd856f$var$qi = BigInt(256), $27e7cfe6b0bd856f$var$Ki = BigInt(113);
for(let t = 0, e = $27e7cfe6b0bd856f$var$Xt, n = 1, r = 0; t < 24; t++){
    [n, r] = [
        r,
        (2 * n + 3 * r) % 5
    ], $27e7cfe6b0bd856f$var$tr.push(2 * (5 * r + n)), $27e7cfe6b0bd856f$var$er.push((t + 1) * (t + 2) / 2 % 64);
    let o = $27e7cfe6b0bd856f$var$Mi;
    for(let i = 0; i < 7; i++)e = (e << $27e7cfe6b0bd856f$var$Xt ^ (e >> $27e7cfe6b0bd856f$var$Hi) * $27e7cfe6b0bd856f$var$Ki) % $27e7cfe6b0bd856f$var$qi, e & $27e7cfe6b0bd856f$var$Di && (o ^= $27e7cfe6b0bd856f$var$Xt << ($27e7cfe6b0bd856f$var$Xt << BigInt(i)) - $27e7cfe6b0bd856f$var$Xt);
    $27e7cfe6b0bd856f$var$nr.push(o);
}
const [$27e7cfe6b0bd856f$var$Fi, $27e7cfe6b0bd856f$var$zi] = $27e7cfe6b0bd856f$var$Ri($27e7cfe6b0bd856f$var$nr, !0), $27e7cfe6b0bd856f$var$rr = (t, e, n)=>n > 32 ? $27e7cfe6b0bd856f$var$Li(t, e, n) : $27e7cfe6b0bd856f$var$_i(t, e, n), $27e7cfe6b0bd856f$var$or = (t, e, n)=>n > 32 ? $27e7cfe6b0bd856f$var$ji(t, e, n) : $27e7cfe6b0bd856f$var$$i(t, e, n);
function $27e7cfe6b0bd856f$var$Zi(t, e = 24) {
    const n = new Uint32Array(10);
    for(let r = 24 - e; r < 24; r++){
        for(let s = 0; s < 10; s++)n[s] = t[s] ^ t[s + 10] ^ t[s + 20] ^ t[s + 30] ^ t[s + 40];
        for(let s = 0; s < 10; s += 2){
            const c = (s + 8) % 10, a = (s + 2) % 10, u = n[a], l = n[a + 1], f = $27e7cfe6b0bd856f$var$rr(u, l, 1) ^ n[c], h = $27e7cfe6b0bd856f$var$or(u, l, 1) ^ n[c + 1];
            for(let y = 0; y < 50; y += 10)t[s + y] ^= f, t[s + y + 1] ^= h;
        }
        let o = t[2], i = t[3];
        for(let s = 0; s < 24; s++){
            const c = $27e7cfe6b0bd856f$var$er[s], a = $27e7cfe6b0bd856f$var$rr(o, i, c), u = $27e7cfe6b0bd856f$var$or(o, i, c), l = $27e7cfe6b0bd856f$var$tr[s];
            o = t[l], i = t[l + 1], t[l] = a, t[l + 1] = u;
        }
        for(let s = 0; s < 50; s += 10){
            for(let c = 0; c < 10; c++)n[c] = t[s + c];
            for(let c = 0; c < 10; c++)t[s + c] ^= ~n[(c + 2) % 10] & n[(c + 4) % 10];
        }
        t[0] ^= $27e7cfe6b0bd856f$var$Fi[r], t[1] ^= $27e7cfe6b0bd856f$var$zi[r];
    }
    n.fill(0);
}
class $27e7cfe6b0bd856f$var$En extends $27e7cfe6b0bd856f$var$Pe {
    constructor(e, n, r, o = !1, i = 24){
        if (super(), this.blockLen = e, this.suffix = n, this.outputLen = r, this.enableXOF = o, this.rounds = i, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, $27e7cfe6b0bd856f$var$Gt(r), 0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200), this.state32 = $27e7cfe6b0bd856f$var$Ci(this.state);
    }
    keccak() {
        $27e7cfe6b0bd856f$var$Xn || $27e7cfe6b0bd856f$var$Jn(this.state32), $27e7cfe6b0bd856f$var$Zi(this.state32, this.rounds), $27e7cfe6b0bd856f$var$Xn || $27e7cfe6b0bd856f$var$Jn(this.state32), this.posOut = 0, this.pos = 0;
    }
    update(e) {
        $27e7cfe6b0bd856f$var$Tt(this);
        const { blockLen: n, state: r } = this;
        e = $27e7cfe6b0bd856f$var$_t(e);
        const o = e.length;
        for(let i = 0; i < o;){
            const s = Math.min(n - this.pos, o - i);
            for(let c = 0; c < s; c++)r[this.pos++] ^= e[i++];
            this.pos === n && this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = !0;
        const { state: e, suffix: n, pos: r, blockLen: o } = this;
        e[r] ^= n, (n & 128) !== 0 && r === o - 1 && this.keccak(), e[o - 1] ^= 128, this.keccak();
    }
    writeInto(e) {
        $27e7cfe6b0bd856f$var$Tt(this, !1), $27e7cfe6b0bd856f$var$Wt(e), this.finish();
        const n = this.state, { blockLen: r } = this;
        for(let o = 0, i = e.length; o < i;){
            this.posOut >= r && this.keccak();
            const s = Math.min(r - this.posOut, i - o);
            e.set(n.subarray(this.posOut, this.posOut + s), o), this.posOut += s, o += s;
        }
        return e;
    }
    xofInto(e) {
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(e);
    }
    xof(e) {
        return $27e7cfe6b0bd856f$var$Gt(e), this.xofInto(new Uint8Array(e));
    }
    digestInto(e) {
        if ($27e7cfe6b0bd856f$var$Gn(e, this), this.finished) throw new Error("digest() was already called");
        return this.writeInto(e), this.destroy(), e;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = !0, this.state.fill(0);
    }
    _cloneInto(e) {
        const { blockLen: n, suffix: r, outputLen: o, rounds: i, enableXOF: s } = this;
        return e || (e = new $27e7cfe6b0bd856f$var$En(n, r, o, s, i)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = i, e.suffix = r, e.outputLen = o, e.enableXOF = s, e.destroyed = this.destroyed, e;
    }
}
const $27e7cfe6b0bd856f$var$Yi = (t, e, n)=>$27e7cfe6b0bd856f$var$Qn(()=>new $27e7cfe6b0bd856f$var$En(e, t, n)), $27e7cfe6b0bd856f$var$Gi = $27e7cfe6b0bd856f$var$Yi(1, 136, 32), $27e7cfe6b0bd856f$var$Wi = "https://rpc.walletconnect.org/v1";
function $27e7cfe6b0bd856f$export$13666321730419b4(t) {
    const e = `Ethereum Signed Message:
${t.length}`, n = new TextEncoder().encode(e + t);
    return "0x" + $27e7cfe6b0bd856f$require$Buffer.from($27e7cfe6b0bd856f$var$Gi(n)).toString("hex");
}
async function $27e7cfe6b0bd856f$export$ab54e47fdf2903bb(t, e, n, r, o, i) {
    switch(n.t){
        case "eip191":
            return await $27e7cfe6b0bd856f$export$b5da105d64914e5a(t, e, n.s);
        case "eip1271":
            return await $27e7cfe6b0bd856f$export$9bffe3330373b76b(t, e, n.s, r, o, i);
        default:
            throw new Error(`verifySignature failed: Attempted to verify CacaoSignature with unknown type: ${n.t}`);
    }
}
async function $27e7cfe6b0bd856f$export$b5da105d64914e5a(t, e, n) {
    return (await (0, $1DO4H.recoverAddress)({
        hash: $27e7cfe6b0bd856f$export$13666321730419b4(e),
        signature: n
    })).toLowerCase() === t.toLowerCase();
}
async function $27e7cfe6b0bd856f$export$9bffe3330373b76b(t, e, n, r, o, i) {
    const s = $27e7cfe6b0bd856f$export$4764229d78de4437(r);
    if (!s.namespace || !s.reference) throw new Error(`isValidEip1271Signature failed: chainId must be in CAIP-2 format, received: ${r}`);
    try {
        const c = "0x1626ba7e", a = "0000000000000000000000000000000000000000000000000000000000000040", u = "0000000000000000000000000000000000000000000000000000000000000041", l = n.substring(2), f = $27e7cfe6b0bd856f$export$13666321730419b4(e).substring(2), h = c + f + a + u + l, y = await fetch(`${i || $27e7cfe6b0bd856f$var$Wi}/?chainId=${r}&projectId=${o}`, {
            method: "POST",
            body: JSON.stringify({
                id: $27e7cfe6b0bd856f$var$Xi(),
                jsonrpc: "2.0",
                method: "eth_call",
                params: [
                    {
                        to: t,
                        data: h
                    },
                    "latest"
                ]
            })
        }), { result: E } = await y.json();
        return E ? E.slice(0, c.length).toLowerCase() === c.toLowerCase() : !1;
    } catch (c) {
        return console.error("isValidEip1271Signature: ", c), !1;
    }
}
function $27e7cfe6b0bd856f$var$Xi() {
    return Date.now() + Math.floor(Math.random() * 1e3);
}
function $27e7cfe6b0bd856f$export$22c18daeebb76cc2(t) {
    const e = atob(t), n = new Uint8Array(e.length);
    for(let s = 0; s < e.length; s++)n[s] = e.charCodeAt(s);
    const r = n[0];
    if (r === 0) throw new Error("No signatures found");
    const o = 1 + r * 64;
    if (n.length < o) throw new Error("Transaction data too short for claimed signature count");
    if (n.length < 100) throw new Error("Transaction too short");
    const i = $27e7cfe6b0bd856f$require$Buffer.from(t, "base64").slice(1, 65);
    return (0, $4zT52.default).encode(i);
}
var $27e7cfe6b0bd856f$var$Qi = Object.defineProperty, $27e7cfe6b0bd856f$var$ts = Object.defineProperties, $27e7cfe6b0bd856f$var$es = Object.getOwnPropertyDescriptors, $27e7cfe6b0bd856f$var$ar = Object.getOwnPropertySymbols, $27e7cfe6b0bd856f$var$ns = Object.prototype.hasOwnProperty, $27e7cfe6b0bd856f$var$rs = Object.prototype.propertyIsEnumerable, $27e7cfe6b0bd856f$var$ur = (t, e, n)=>e in t ? $27e7cfe6b0bd856f$var$Qi(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n, $27e7cfe6b0bd856f$var$Ve = (t, e)=>{
    for(var n in e || (e = {}))$27e7cfe6b0bd856f$var$ns.call(e, n) && $27e7cfe6b0bd856f$var$ur(t, n, e[n]);
    if ($27e7cfe6b0bd856f$var$ar) for (var n of $27e7cfe6b0bd856f$var$ar(e))$27e7cfe6b0bd856f$var$rs.call(e, n) && $27e7cfe6b0bd856f$var$ur(t, n, e[n]);
    return t;
}, $27e7cfe6b0bd856f$var$fr = (t, e)=>$27e7cfe6b0bd856f$var$ts(t, $27e7cfe6b0bd856f$var$es(e));
const $27e7cfe6b0bd856f$var$os = "did:pkh:", $27e7cfe6b0bd856f$export$a524ae552db7912 = (t)=>t?.split(":"), $27e7cfe6b0bd856f$export$85f23c05c80b194 = (t)=>{
    const e = t && $27e7cfe6b0bd856f$export$a524ae552db7912(t);
    if (e) return t.includes($27e7cfe6b0bd856f$var$os) ? e[3] : e[1];
}, $27e7cfe6b0bd856f$export$a8b149927aef7051 = (t)=>{
    const e = t && $27e7cfe6b0bd856f$export$a524ae552db7912(t);
    if (e) return e[2] + ":" + e[3];
}, $27e7cfe6b0bd856f$export$bf43cfbb4bd95de9 = (t)=>{
    const e = t && $27e7cfe6b0bd856f$export$a524ae552db7912(t);
    if (e) return e.pop();
};
async function $27e7cfe6b0bd856f$export$b7d566fce8e2b970(t) {
    const { cacao: e, projectId: n } = t, { s: r, p: o } = e, i = $27e7cfe6b0bd856f$export$25868d1e8e76735f(o, o.iss), s = $27e7cfe6b0bd856f$export$bf43cfbb4bd95de9(o.iss);
    return await $27e7cfe6b0bd856f$export$ab54e47fdf2903bb(s, i, r, $27e7cfe6b0bd856f$export$a8b149927aef7051(o.iss), n);
}
const $27e7cfe6b0bd856f$export$25868d1e8e76735f = (t, e)=>{
    const n = `${t.domain} wants you to sign in with your Ethereum account:`, r = $27e7cfe6b0bd856f$export$bf43cfbb4bd95de9(e);
    if (!t.aud && !t.uri) throw new Error("Either `aud` or `uri` is required to construct the message");
    let o = t.statement || void 0;
    const i = `URI: ${t.aud || t.uri}`, s = `Version: ${t.version}`, c = `Chain ID: ${$27e7cfe6b0bd856f$export$85f23c05c80b194(e)}`, a = `Nonce: ${t.nonce}`, u = `Issued At: ${t.iat}`, l = t.exp ? `Expiration Time: ${t.exp}` : void 0, f = t.nbf ? `Not Before: ${t.nbf}` : void 0, h = t.requestId ? `Request ID: ${t.requestId}` : void 0, y = t.resources ? `Resources:${t.resources.map((p)=>`
- ${p}`).join("")}` : void 0, E = $27e7cfe6b0bd856f$export$3bb18ae0fb9a9fa9(t.resources);
    if (E) {
        const p = $27e7cfe6b0bd856f$export$d34522c9e5a1aed1(E);
        o = $27e7cfe6b0bd856f$export$51673931d3a8308d(o, p);
    }
    return [
        n,
        r,
        "",
        o,
        "",
        i,
        s,
        c,
        a,
        u,
        l,
        f,
        h,
        y
    ].filter((p)=>p != null).join(`
`);
};
function $27e7cfe6b0bd856f$export$905974078a05d5f9(t, e, n) {
    return n.includes("did:pkh:") || (n = `did:pkh:${n}`), {
        h: {
            t: "caip122"
        },
        p: {
            iss: n,
            domain: t.domain,
            aud: t.aud,
            version: t.version,
            nonce: t.nonce,
            iat: t.iat,
            statement: t.statement,
            requestId: t.requestId,
            resources: t.resources,
            nbf: t.nbf,
            exp: t.exp
        },
        s: e
    };
}
function $27e7cfe6b0bd856f$export$2bfa2ac7d9bc193c(t) {
    var e;
    const { authPayload: n, chains: r, methods: o } = t, i = n.statement || "";
    if (!(r != null && r.length)) return n;
    const s = n.chains, c = $27e7cfe6b0bd856f$export$f8aaf09178dd8b96(s, r);
    if (!(c != null && c.length)) throw new Error("No supported chains");
    const a = $27e7cfe6b0bd856f$export$8db308c294c84efd(n.resources);
    if (!a) return n;
    $27e7cfe6b0bd856f$export$ae8075c482503f32(a);
    const u = $27e7cfe6b0bd856f$export$9595a56724061288(a, "eip155");
    let l = n?.resources || [];
    if (u != null && u.length) {
        const f = $27e7cfe6b0bd856f$export$e1a9af3d61db3b68(u), h = $27e7cfe6b0bd856f$export$f8aaf09178dd8b96(f, o);
        if (!(h != null && h.length)) throw new Error(`Supported methods don't satisfy the requested: ${JSON.stringify(f)}, supported: ${JSON.stringify(o)}`);
        const y = $27e7cfe6b0bd856f$export$987cafd76db78dd1("request", h, {
            chains: c
        }), E = $27e7cfe6b0bd856f$export$317cb0007b0867c1(a, "eip155", y);
        l = ((e = n?.resources) == null ? void 0 : e.slice(0, -1)) || [], l.push($27e7cfe6b0bd856f$export$79a538532b4f11f7(E));
    }
    return $27e7cfe6b0bd856f$var$fr($27e7cfe6b0bd856f$var$Ve({}, n), {
        statement: $27e7cfe6b0bd856f$export$fb351782bc6f001e(i, $27e7cfe6b0bd856f$export$3bb18ae0fb9a9fa9(l)),
        chains: c,
        resources: n != null && n.resources || l.length > 0 ? l : void 0
    });
}
function $27e7cfe6b0bd856f$export$8db308c294c84efd(t) {
    const e = $27e7cfe6b0bd856f$export$3bb18ae0fb9a9fa9(t);
    if (e && $27e7cfe6b0bd856f$export$d9f11bd9fec5a64(e)) return $27e7cfe6b0bd856f$export$d34522c9e5a1aed1(e);
}
function $27e7cfe6b0bd856f$export$771534f1eaa353c(t, e) {
    var n;
    return (n = t?.att) == null ? void 0 : n.hasOwnProperty(e);
}
function $27e7cfe6b0bd856f$export$9595a56724061288(t, e) {
    var n, r;
    return (n = t?.att) != null && n[e] ? Object.keys((r = t?.att) == null ? void 0 : r[e]) : [];
}
function $27e7cfe6b0bd856f$export$d4548b739f9dafe(t) {
    return t?.map((e)=>Object.keys(e)) || [];
}
function $27e7cfe6b0bd856f$export$e1a9af3d61db3b68(t) {
    return t?.map((e)=>{
        var n;
        return (n = e.split("/")) == null ? void 0 : n[1];
    }) || [];
}
function $27e7cfe6b0bd856f$export$e510a73ee562749(t) {
    return $27e7cfe6b0bd856f$require$Buffer.from(JSON.stringify(t)).toString("base64");
}
function $27e7cfe6b0bd856f$export$c62426fdd000a97e(t) {
    return JSON.parse($27e7cfe6b0bd856f$require$Buffer.from(t, "base64").toString("utf-8"));
}
function $27e7cfe6b0bd856f$export$ae8075c482503f32(t) {
    if (!t) throw new Error("No recap provided, value is undefined");
    if (!t.att) throw new Error("No `att` property found");
    const e = Object.keys(t.att);
    if (!(e != null && e.length)) throw new Error("No resources found in `att` property");
    e.forEach((n)=>{
        const r = t.att[n];
        if (Array.isArray(r)) throw new Error(`Resource must be an object: ${n}`);
        if (typeof r != "object") throw new Error(`Resource must be an object: ${n}`);
        if (!Object.keys(r).length) throw new Error(`Resource object is empty: ${n}`);
        Object.keys(r).forEach((o)=>{
            const i = r[o];
            if (!Array.isArray(i)) throw new Error(`Ability limits ${o} must be an array of objects, found: ${i}`);
            if (!i.length) throw new Error(`Value of ${o} is empty array, must be an array with objects`);
            i.forEach((s)=>{
                if (typeof s != "object") throw new Error(`Ability limits (${o}) must be an array of objects, found: ${s}`);
            });
        });
    });
}
function $27e7cfe6b0bd856f$export$eea18a04b33506ed(t, e, n, r = {}) {
    return n?.sort((o, i)=>o.localeCompare(i)), {
        att: {
            [t]: $27e7cfe6b0bd856f$export$987cafd76db78dd1(e, n, r)
        }
    };
}
function $27e7cfe6b0bd856f$export$317cb0007b0867c1(t, e, n) {
    var r;
    t.att[e] = $27e7cfe6b0bd856f$var$Ve({}, n);
    const o = (r = Object.keys(t.att)) == null ? void 0 : r.sort((s, c)=>s.localeCompare(c)), i = {
        att: {}
    };
    return o.reduce((s, c)=>(s.att[c] = t.att[c], s), i);
}
function $27e7cfe6b0bd856f$export$987cafd76db78dd1(t, e, n = {}) {
    e = e?.sort((o, i)=>o.localeCompare(i));
    const r = e.map((o)=>({
            [`${t}/${o}`]: [
                n
            ]
        }));
    return Object.assign({}, ...r);
}
function $27e7cfe6b0bd856f$export$79a538532b4f11f7(t) {
    return $27e7cfe6b0bd856f$export$ae8075c482503f32(t), `urn:recap:${$27e7cfe6b0bd856f$export$e510a73ee562749(t).replace(/=/g, "")}`;
}
function $27e7cfe6b0bd856f$export$d34522c9e5a1aed1(t) {
    const e = $27e7cfe6b0bd856f$export$c62426fdd000a97e(t.replace("urn:recap:", ""));
    return $27e7cfe6b0bd856f$export$ae8075c482503f32(e), e;
}
function $27e7cfe6b0bd856f$export$2bc35d2a08a09ad5(t, e, n) {
    const r = $27e7cfe6b0bd856f$export$eea18a04b33506ed(t, e, n);
    return $27e7cfe6b0bd856f$export$79a538532b4f11f7(r);
}
function $27e7cfe6b0bd856f$export$d9f11bd9fec5a64(t) {
    return t && t.includes("urn:recap:");
}
function $27e7cfe6b0bd856f$export$c7a40c552af428b5(t, e) {
    const n = $27e7cfe6b0bd856f$export$d34522c9e5a1aed1(t), r = $27e7cfe6b0bd856f$export$d34522c9e5a1aed1(e), o = $27e7cfe6b0bd856f$export$2445df2492ef2cbd(n, r);
    return $27e7cfe6b0bd856f$export$79a538532b4f11f7(o);
}
function $27e7cfe6b0bd856f$export$2445df2492ef2cbd(t, e) {
    $27e7cfe6b0bd856f$export$ae8075c482503f32(t), $27e7cfe6b0bd856f$export$ae8075c482503f32(e);
    const n = Object.keys(t.att).concat(Object.keys(e.att)).sort((o, i)=>o.localeCompare(i)), r = {
        att: {}
    };
    return n.forEach((o)=>{
        var i, s;
        Object.keys(((i = t.att) == null ? void 0 : i[o]) || {}).concat(Object.keys(((s = e.att) == null ? void 0 : s[o]) || {})).sort((c, a)=>c.localeCompare(a)).forEach((c)=>{
            var a, u;
            r.att[o] = $27e7cfe6b0bd856f$var$fr($27e7cfe6b0bd856f$var$Ve({}, r.att[o]), {
                [c]: ((a = t.att[o]) == null ? void 0 : a[c]) || ((u = e.att[o]) == null ? void 0 : u[c])
            });
        });
    }), r;
}
function $27e7cfe6b0bd856f$export$51673931d3a8308d(t = "", e) {
    $27e7cfe6b0bd856f$export$ae8075c482503f32(e);
    const n = "I further authorize the stated URI to perform the following actions on my behalf: ";
    if (t.includes(n)) return t;
    const r = [];
    let o = 0;
    Object.keys(e.att).forEach((c)=>{
        const a = Object.keys(e.att[c]).map((f)=>({
                ability: f.split("/")[0],
                action: f.split("/")[1]
            }));
        a.sort((f, h)=>f.action.localeCompare(h.action));
        const u = {};
        a.forEach((f)=>{
            u[f.ability] || (u[f.ability] = []), u[f.ability].push(f.action);
        });
        const l = Object.keys(u).map((f)=>(o++, `(${o}) '${f}': '${u[f].join("', '")}' for '${c}'.`));
        r.push(l.join(", ").replace(".,", "."));
    });
    const i = r.join(" "), s = `${n}${i}`;
    return `${t ? t + " " : ""}${s}`;
}
function $27e7cfe6b0bd856f$export$d6c6a43d36418efe(t) {
    var e;
    const n = $27e7cfe6b0bd856f$export$d34522c9e5a1aed1(t);
    $27e7cfe6b0bd856f$export$ae8075c482503f32(n);
    const r = (e = n.att) == null ? void 0 : e.eip155;
    return r ? Object.keys(r).map((o)=>o.split("/")[1]) : [];
}
function $27e7cfe6b0bd856f$export$372f88051a611988(t) {
    const e = $27e7cfe6b0bd856f$export$d34522c9e5a1aed1(t);
    $27e7cfe6b0bd856f$export$ae8075c482503f32(e);
    const n = [];
    return Object.values(e.att).forEach((r)=>{
        Object.values(r).forEach((o)=>{
            var i;
            (i = o?.[0]) != null && i.chains && n.push(o[0].chains);
        });
    }), [
        ...new Set(n.flat())
    ];
}
function $27e7cfe6b0bd856f$export$fb351782bc6f001e(t, e) {
    if (!e) return t;
    const n = $27e7cfe6b0bd856f$export$d34522c9e5a1aed1(e);
    return $27e7cfe6b0bd856f$export$ae8075c482503f32(n), $27e7cfe6b0bd856f$export$51673931d3a8308d(t, n);
}
function $27e7cfe6b0bd856f$export$3bb18ae0fb9a9fa9(t) {
    if (!t) return;
    const e = t?.[t.length - 1];
    return $27e7cfe6b0bd856f$export$d9f11bd9fec5a64(e) ? e : void 0;
}
function $27e7cfe6b0bd856f$var$Ke(t) {
    if (!Number.isSafeInteger(t) || t < 0) throw new Error("positive integer expected, got " + t);
}
function $27e7cfe6b0bd856f$var$Sr(t) {
    return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function $27e7cfe6b0bd856f$var$tt(t, ...e) {
    if (!$27e7cfe6b0bd856f$var$Sr(t)) throw new Error("Uint8Array expected");
    if (e.length > 0 && !e.includes(t.length)) throw new Error("Uint8Array expected of length " + e + ", got length=" + t.length);
}
function $27e7cfe6b0bd856f$var$Or(t, e = !0) {
    if (t.destroyed) throw new Error("Hash instance has been destroyed");
    if (e && t.finished) throw new Error("Hash#digest() has already been called");
}
function $27e7cfe6b0bd856f$var$ps(t, e) {
    $27e7cfe6b0bd856f$var$tt(t);
    const n = e.outputLen;
    if (t.length < n) throw new Error("digestInto() expects output buffer of length at least " + n);
}
function $27e7cfe6b0bd856f$var$Ar(t) {
    if (typeof t != "boolean") throw new Error(`boolean expected, not ${t}`);
}
const $27e7cfe6b0bd856f$var$mt = (t)=>new Uint32Array(t.buffer, t.byteOffset, Math.floor(t.byteLength / 4)), $27e7cfe6b0bd856f$var$gs = (t)=>new DataView(t.buffer, t.byteOffset, t.byteLength), $27e7cfe6b0bd856f$var$ys = new Uint8Array(new Uint32Array([
    287454020
]).buffer)[0] === 68;
if (!$27e7cfe6b0bd856f$var$ys) throw new Error("Non little-endian hardware is not supported");
function $27e7cfe6b0bd856f$var$ms(t) {
    if (typeof t != "string") throw new Error("string expected");
    return new Uint8Array(new TextEncoder().encode(t));
}
function $27e7cfe6b0bd856f$var$Fe(t) {
    if (typeof t == "string") t = $27e7cfe6b0bd856f$var$ms(t);
    else if ($27e7cfe6b0bd856f$var$Sr(t)) t = $27e7cfe6b0bd856f$var$ze(t);
    else throw new Error("Uint8Array expected, got " + typeof t);
    return t;
}
function $27e7cfe6b0bd856f$var$ws(t, e) {
    if (e == null || typeof e != "object") throw new Error("options must be defined");
    return Object.assign(t, e);
}
function $27e7cfe6b0bd856f$var$bs(t, e) {
    if (t.length !== e.length) return !1;
    let n = 0;
    for(let r = 0; r < t.length; r++)n |= t[r] ^ e[r];
    return n === 0;
}
const $27e7cfe6b0bd856f$var$Es = (t, e)=>{
    function n(r, ...o) {
        if ($27e7cfe6b0bd856f$var$tt(r), t.nonceLength !== void 0) {
            const l = o[0];
            if (!l) throw new Error("nonce / iv required");
            t.varSizeNonce ? $27e7cfe6b0bd856f$var$tt(l) : $27e7cfe6b0bd856f$var$tt(l, t.nonceLength);
        }
        const i = t.tagLength;
        i && o[1] !== void 0 && $27e7cfe6b0bd856f$var$tt(o[1]);
        const s = e(r, ...o), c = (l, f)=>{
            if (f !== void 0) {
                if (l !== 2) throw new Error("cipher output not supported");
                $27e7cfe6b0bd856f$var$tt(f);
            }
        };
        let a = !1;
        return {
            encrypt (l, f) {
                if (a) throw new Error("cannot encrypt() twice with same key + nonce");
                return a = !0, $27e7cfe6b0bd856f$var$tt(l), c(s.encrypt.length, f), s.encrypt(l, f);
            },
            decrypt (l, f) {
                if ($27e7cfe6b0bd856f$var$tt(l), i && l.length < i) throw new Error("invalid ciphertext length: smaller than tagLength=" + i);
                return c(s.decrypt.length, f), s.decrypt(l, f);
            }
        };
    }
    return Object.assign(n, t), n;
};
function $27e7cfe6b0bd856f$var$Br(t, e, n = !0) {
    if (e === void 0) return new Uint8Array(t);
    if (e.length !== t) throw new Error("invalid output length, expected " + t + ", got: " + e.length);
    if (n && !$27e7cfe6b0bd856f$var$vs(e)) throw new Error("invalid output, must be aligned");
    return e;
}
function $27e7cfe6b0bd856f$var$Ir(t, e, n, r) {
    if (typeof t.setBigUint64 == "function") return t.setBigUint64(e, n, r);
    const o = BigInt(32), i = BigInt(4294967295), s = Number(n >> o & i), c = Number(n & i), a = r ? 4 : 0, u = r ? 0 : 4;
    t.setUint32(e + a, s, r), t.setUint32(e + u, c, r);
}
function $27e7cfe6b0bd856f$var$vs(t) {
    return t.byteOffset % 4 === 0;
}
function $27e7cfe6b0bd856f$var$ze(t) {
    return Uint8Array.from(t);
}
function $27e7cfe6b0bd856f$var$Lt(...t) {
    for(let e = 0; e < t.length; e++)t[e].fill(0);
}
const $27e7cfe6b0bd856f$var$Nr = (t)=>Uint8Array.from(t.split("").map((e)=>e.charCodeAt(0))), $27e7cfe6b0bd856f$var$xs = $27e7cfe6b0bd856f$var$Nr("expand 16-byte k"), $27e7cfe6b0bd856f$var$Ss = $27e7cfe6b0bd856f$var$Nr("expand 32-byte k"), $27e7cfe6b0bd856f$var$Os = $27e7cfe6b0bd856f$var$mt($27e7cfe6b0bd856f$var$xs), $27e7cfe6b0bd856f$var$As = $27e7cfe6b0bd856f$var$mt($27e7cfe6b0bd856f$var$Ss);
function $27e7cfe6b0bd856f$var$V(t, e) {
    return t << e | t >>> 32 - e;
}
function $27e7cfe6b0bd856f$var$Ze(t) {
    return t.byteOffset % 4 === 0;
}
const $27e7cfe6b0bd856f$var$he = 64, $27e7cfe6b0bd856f$var$Bs = 16, $27e7cfe6b0bd856f$var$Ur = 2 ** 32 - 1, $27e7cfe6b0bd856f$var$Tr = new Uint32Array;
function $27e7cfe6b0bd856f$var$Is(t, e, n, r, o, i, s, c) {
    const a = o.length, u = new Uint8Array($27e7cfe6b0bd856f$var$he), l = $27e7cfe6b0bd856f$var$mt(u), f = $27e7cfe6b0bd856f$var$Ze(o) && $27e7cfe6b0bd856f$var$Ze(i), h = f ? $27e7cfe6b0bd856f$var$mt(o) : $27e7cfe6b0bd856f$var$Tr, y = f ? $27e7cfe6b0bd856f$var$mt(i) : $27e7cfe6b0bd856f$var$Tr;
    for(let E = 0; E < a; s++){
        if (t(e, n, r, l, s, c), s >= $27e7cfe6b0bd856f$var$Ur) throw new Error("arx: counter overflow");
        const p = Math.min($27e7cfe6b0bd856f$var$he, a - E);
        if (f && p === $27e7cfe6b0bd856f$var$he) {
            const d = E / 4;
            if (E % 4 !== 0) throw new Error("arx: invalid block position");
            for(let v = 0, m; v < $27e7cfe6b0bd856f$var$Bs; v++)m = d + v, y[m] = h[m] ^ l[v];
            E += $27e7cfe6b0bd856f$var$he;
            continue;
        }
        for(let d = 0, v; d < p; d++)v = E + d, i[v] = o[v] ^ u[d];
        E += p;
    }
}
function $27e7cfe6b0bd856f$var$Ns(t, e) {
    const { allowShortKeys: n, extendNonceFn: r, counterLength: o, counterRight: i, rounds: s } = $27e7cfe6b0bd856f$var$ws({
        allowShortKeys: !1,
        counterLength: 8,
        counterRight: !1,
        rounds: 20
    }, e);
    if (typeof t != "function") throw new Error("core must be a function");
    return $27e7cfe6b0bd856f$var$Ke(o), $27e7cfe6b0bd856f$var$Ke(s), $27e7cfe6b0bd856f$var$Ar(i), $27e7cfe6b0bd856f$var$Ar(n), (c, a, u, l, f = 0)=>{
        $27e7cfe6b0bd856f$var$tt(c), $27e7cfe6b0bd856f$var$tt(a), $27e7cfe6b0bd856f$var$tt(u);
        const h = u.length;
        if (l === void 0 && (l = new Uint8Array(h)), $27e7cfe6b0bd856f$var$tt(l), $27e7cfe6b0bd856f$var$Ke(f), f < 0 || f >= $27e7cfe6b0bd856f$var$Ur) throw new Error("arx: counter overflow");
        if (l.length < h) throw new Error(`arx: output (${l.length}) is shorter than data (${h})`);
        const y = [];
        let E = c.length, p, d;
        if (E === 32) y.push(p = $27e7cfe6b0bd856f$var$ze(c)), d = $27e7cfe6b0bd856f$var$As;
        else if (E === 16 && n) p = new Uint8Array(32), p.set(c), p.set(c, 16), d = $27e7cfe6b0bd856f$var$Os, y.push(p);
        else throw new Error(`arx: invalid 32-byte key, got length=${E}`);
        $27e7cfe6b0bd856f$var$Ze(a) || y.push(a = $27e7cfe6b0bd856f$var$ze(a));
        const v = $27e7cfe6b0bd856f$var$mt(p);
        if (r) {
            if (a.length !== 24) throw new Error("arx: extended nonce must be 24 bytes");
            r(d, v, $27e7cfe6b0bd856f$var$mt(a.subarray(0, 16)), v), a = a.subarray(16);
        }
        const m = 16 - o;
        if (m !== a.length) throw new Error(`arx: nonce must be ${m} or 16 bytes`);
        if (m !== 12) {
            const N = new Uint8Array(12);
            N.set(a, i ? 0 : 12 - a.length), a = N, y.push(a);
        }
        const O = $27e7cfe6b0bd856f$var$mt(a);
        return $27e7cfe6b0bd856f$var$Is(t, d, v, O, u, l, f, s), $27e7cfe6b0bd856f$var$Lt(...y), l;
    };
}
const $27e7cfe6b0bd856f$var$F = (t, e)=>t[e++] & 255 | (t[e++] & 255) << 8;
class $27e7cfe6b0bd856f$var$Us {
    constructor(e){
        this.blockLen = 16, this.outputLen = 16, this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.pos = 0, this.finished = !1, e = $27e7cfe6b0bd856f$var$Fe(e), $27e7cfe6b0bd856f$var$tt(e, 32);
        const n = $27e7cfe6b0bd856f$var$F(e, 0), r = $27e7cfe6b0bd856f$var$F(e, 2), o = $27e7cfe6b0bd856f$var$F(e, 4), i = $27e7cfe6b0bd856f$var$F(e, 6), s = $27e7cfe6b0bd856f$var$F(e, 8), c = $27e7cfe6b0bd856f$var$F(e, 10), a = $27e7cfe6b0bd856f$var$F(e, 12), u = $27e7cfe6b0bd856f$var$F(e, 14);
        this.r[0] = n & 8191, this.r[1] = (n >>> 13 | r << 3) & 8191, this.r[2] = (r >>> 10 | o << 6) & 7939, this.r[3] = (o >>> 7 | i << 9) & 8191, this.r[4] = (i >>> 4 | s << 12) & 255, this.r[5] = s >>> 1 & 8190, this.r[6] = (s >>> 14 | c << 2) & 8191, this.r[7] = (c >>> 11 | a << 5) & 8065, this.r[8] = (a >>> 8 | u << 8) & 8191, this.r[9] = u >>> 5 & 127;
        for(let l = 0; l < 8; l++)this.pad[l] = $27e7cfe6b0bd856f$var$F(e, 16 + 2 * l);
    }
    process(e, n, r = !1) {
        const o = r ? 0 : 2048, { h: i, r: s } = this, c = s[0], a = s[1], u = s[2], l = s[3], f = s[4], h = s[5], y = s[6], E = s[7], p = s[8], d = s[9], v = $27e7cfe6b0bd856f$var$F(e, n + 0), m = $27e7cfe6b0bd856f$var$F(e, n + 2), O = $27e7cfe6b0bd856f$var$F(e, n + 4), N = $27e7cfe6b0bd856f$var$F(e, n + 6), $ = $27e7cfe6b0bd856f$var$F(e, n + 8), B = $27e7cfe6b0bd856f$var$F(e, n + 10), A = $27e7cfe6b0bd856f$var$F(e, n + 12), T = $27e7cfe6b0bd856f$var$F(e, n + 14);
        let S = i[0] + (v & 8191), L = i[1] + ((v >>> 13 | m << 3) & 8191), U = i[2] + ((m >>> 10 | O << 6) & 8191), _ = i[3] + ((O >>> 7 | N << 9) & 8191), j = i[4] + ((N >>> 4 | $ << 12) & 8191), g = i[5] + ($ >>> 1 & 8191), w = i[6] + (($ >>> 14 | B << 2) & 8191), b = i[7] + ((B >>> 11 | A << 5) & 8191), I = i[8] + ((A >>> 8 | T << 8) & 8191), R = i[9] + (T >>> 5 | o), x = 0, C = x + S * c + L * (5 * d) + U * (5 * p) + _ * (5 * E) + j * (5 * y);
        x = C >>> 13, C &= 8191, C += g * (5 * h) + w * (5 * f) + b * (5 * l) + I * (5 * u) + R * (5 * a), x += C >>> 13, C &= 8191;
        let P = x + S * a + L * c + U * (5 * d) + _ * (5 * p) + j * (5 * E);
        x = P >>> 13, P &= 8191, P += g * (5 * y) + w * (5 * h) + b * (5 * f) + I * (5 * l) + R * (5 * u), x += P >>> 13, P &= 8191;
        let k = x + S * u + L * a + U * c + _ * (5 * d) + j * (5 * p);
        x = k >>> 13, k &= 8191, k += g * (5 * E) + w * (5 * y) + b * (5 * h) + I * (5 * f) + R * (5 * l), x += k >>> 13, k &= 8191;
        let M = x + S * l + L * u + U * a + _ * c + j * (5 * d);
        x = M >>> 13, M &= 8191, M += g * (5 * p) + w * (5 * E) + b * (5 * y) + I * (5 * h) + R * (5 * f), x += M >>> 13, M &= 8191;
        let D = x + S * f + L * l + U * u + _ * a + j * c;
        x = D >>> 13, D &= 8191, D += g * (5 * d) + w * (5 * p) + b * (5 * E) + I * (5 * y) + R * (5 * h), x += D >>> 13, D &= 8191;
        let z = x + S * h + L * f + U * l + _ * u + j * a;
        x = z >>> 13, z &= 8191, z += g * c + w * (5 * d) + b * (5 * p) + I * (5 * E) + R * (5 * y), x += z >>> 13, z &= 8191;
        let Z = x + S * y + L * h + U * f + _ * l + j * u;
        x = Z >>> 13, Z &= 8191, Z += g * a + w * c + b * (5 * d) + I * (5 * p) + R * (5 * E), x += Z >>> 13, Z &= 8191;
        let it = x + S * E + L * y + U * h + _ * f + j * l;
        x = it >>> 13, it &= 8191, it += g * u + w * a + b * c + I * (5 * d) + R * (5 * p), x += it >>> 13, it &= 8191;
        let W = x + S * p + L * E + U * y + _ * h + j * f;
        x = W >>> 13, W &= 8191, W += g * l + w * u + b * a + I * c + R * (5 * d), x += W >>> 13, W &= 8191;
        let J = x + S * d + L * p + U * E + _ * y + j * h;
        x = J >>> 13, J &= 8191, J += g * f + w * l + b * u + I * a + R * c, x += J >>> 13, J &= 8191, x = (x << 2) + x | 0, x = x + C | 0, C = x & 8191, x = x >>> 13, P += x, i[0] = C, i[1] = P, i[2] = k, i[3] = M, i[4] = D, i[5] = z, i[6] = Z, i[7] = it, i[8] = W, i[9] = J;
    }
    finalize() {
        const { h: e, pad: n } = this, r = new Uint16Array(10);
        let o = e[1] >>> 13;
        e[1] &= 8191;
        for(let c = 2; c < 10; c++)e[c] += o, o = e[c] >>> 13, e[c] &= 8191;
        e[0] += o * 5, o = e[0] >>> 13, e[0] &= 8191, e[1] += o, o = e[1] >>> 13, e[1] &= 8191, e[2] += o, r[0] = e[0] + 5, o = r[0] >>> 13, r[0] &= 8191;
        for(let c = 1; c < 10; c++)r[c] = e[c] + o, o = r[c] >>> 13, r[c] &= 8191;
        r[9] -= 8192;
        let i = (o ^ 1) - 1;
        for(let c = 0; c < 10; c++)r[c] &= i;
        i = ~i;
        for(let c = 0; c < 10; c++)e[c] = e[c] & i | r[c];
        e[0] = (e[0] | e[1] << 13) & 65535, e[1] = (e[1] >>> 3 | e[2] << 10) & 65535, e[2] = (e[2] >>> 6 | e[3] << 7) & 65535, e[3] = (e[3] >>> 9 | e[4] << 4) & 65535, e[4] = (e[4] >>> 12 | e[5] << 1 | e[6] << 14) & 65535, e[5] = (e[6] >>> 2 | e[7] << 11) & 65535, e[6] = (e[7] >>> 5 | e[8] << 8) & 65535, e[7] = (e[8] >>> 8 | e[9] << 5) & 65535;
        let s = e[0] + n[0];
        e[0] = s & 65535;
        for(let c = 1; c < 8; c++)s = (e[c] + n[c] | 0) + (s >>> 16) | 0, e[c] = s & 65535;
        $27e7cfe6b0bd856f$var$Lt(r);
    }
    update(e) {
        $27e7cfe6b0bd856f$var$Or(this);
        const { buffer: n, blockLen: r } = this;
        e = $27e7cfe6b0bd856f$var$Fe(e);
        const o = e.length;
        for(let i = 0; i < o;){
            const s = Math.min(r - this.pos, o - i);
            if (s === r) {
                for(; r <= o - i; i += r)this.process(e, i);
                continue;
            }
            n.set(e.subarray(i, i + s), this.pos), this.pos += s, i += s, this.pos === r && (this.process(n, 0, !1), this.pos = 0);
        }
        return this;
    }
    destroy() {
        $27e7cfe6b0bd856f$var$Lt(this.h, this.r, this.buffer, this.pad);
    }
    digestInto(e) {
        $27e7cfe6b0bd856f$var$Or(this), $27e7cfe6b0bd856f$var$ps(e, this), this.finished = !0;
        const { buffer: n, h: r } = this;
        let { pos: o } = this;
        if (o) {
            for(n[o++] = 1; o < 16; o++)n[o] = 0;
            this.process(n, 0, !0);
        }
        this.finalize();
        let i = 0;
        for(let s = 0; s < 8; s++)e[i++] = r[s] >>> 0, e[i++] = r[s] >>> 8;
        return e;
    }
    digest() {
        const { buffer: e, outputLen: n } = this;
        this.digestInto(e);
        const r = e.slice(0, n);
        return this.destroy(), r;
    }
}
function $27e7cfe6b0bd856f$var$Ts(t) {
    const e = (r, o)=>t(o).update($27e7cfe6b0bd856f$var$Fe(r)).digest(), n = t(new Uint8Array(32));
    return e.outputLen = n.outputLen, e.blockLen = n.blockLen, e.create = (r)=>t(r), e;
}
const $27e7cfe6b0bd856f$var$Rs = $27e7cfe6b0bd856f$var$Ts((t)=>new $27e7cfe6b0bd856f$var$Us(t));
function $27e7cfe6b0bd856f$var$_s(t, e, n, r, o, i = 20) {
    let s = t[0], c = t[1], a = t[2], u = t[3], l = e[0], f = e[1], h = e[2], y = e[3], E = e[4], p = e[5], d = e[6], v = e[7], m = o, O = n[0], N = n[1], $ = n[2], B = s, A = c, T = a, S = u, L = l, U = f, _ = h, j = y, g = E, w = p, b = d, I = v, R = m, x = O, C = N, P = $;
    for(let M = 0; M < i; M += 2)B = B + L | 0, R = $27e7cfe6b0bd856f$var$V(R ^ B, 16), g = g + R | 0, L = $27e7cfe6b0bd856f$var$V(L ^ g, 12), B = B + L | 0, R = $27e7cfe6b0bd856f$var$V(R ^ B, 8), g = g + R | 0, L = $27e7cfe6b0bd856f$var$V(L ^ g, 7), A = A + U | 0, x = $27e7cfe6b0bd856f$var$V(x ^ A, 16), w = w + x | 0, U = $27e7cfe6b0bd856f$var$V(U ^ w, 12), A = A + U | 0, x = $27e7cfe6b0bd856f$var$V(x ^ A, 8), w = w + x | 0, U = $27e7cfe6b0bd856f$var$V(U ^ w, 7), T = T + _ | 0, C = $27e7cfe6b0bd856f$var$V(C ^ T, 16), b = b + C | 0, _ = $27e7cfe6b0bd856f$var$V(_ ^ b, 12), T = T + _ | 0, C = $27e7cfe6b0bd856f$var$V(C ^ T, 8), b = b + C | 0, _ = $27e7cfe6b0bd856f$var$V(_ ^ b, 7), S = S + j | 0, P = $27e7cfe6b0bd856f$var$V(P ^ S, 16), I = I + P | 0, j = $27e7cfe6b0bd856f$var$V(j ^ I, 12), S = S + j | 0, P = $27e7cfe6b0bd856f$var$V(P ^ S, 8), I = I + P | 0, j = $27e7cfe6b0bd856f$var$V(j ^ I, 7), B = B + U | 0, P = $27e7cfe6b0bd856f$var$V(P ^ B, 16), b = b + P | 0, U = $27e7cfe6b0bd856f$var$V(U ^ b, 12), B = B + U | 0, P = $27e7cfe6b0bd856f$var$V(P ^ B, 8), b = b + P | 0, U = $27e7cfe6b0bd856f$var$V(U ^ b, 7), A = A + _ | 0, R = $27e7cfe6b0bd856f$var$V(R ^ A, 16), I = I + R | 0, _ = $27e7cfe6b0bd856f$var$V(_ ^ I, 12), A = A + _ | 0, R = $27e7cfe6b0bd856f$var$V(R ^ A, 8), I = I + R | 0, _ = $27e7cfe6b0bd856f$var$V(_ ^ I, 7), T = T + j | 0, x = $27e7cfe6b0bd856f$var$V(x ^ T, 16), g = g + x | 0, j = $27e7cfe6b0bd856f$var$V(j ^ g, 12), T = T + j | 0, x = $27e7cfe6b0bd856f$var$V(x ^ T, 8), g = g + x | 0, j = $27e7cfe6b0bd856f$var$V(j ^ g, 7), S = S + L | 0, C = $27e7cfe6b0bd856f$var$V(C ^ S, 16), w = w + C | 0, L = $27e7cfe6b0bd856f$var$V(L ^ w, 12), S = S + L | 0, C = $27e7cfe6b0bd856f$var$V(C ^ S, 8), w = w + C | 0, L = $27e7cfe6b0bd856f$var$V(L ^ w, 7);
    let k = 0;
    r[k++] = s + B | 0, r[k++] = c + A | 0, r[k++] = a + T | 0, r[k++] = u + S | 0, r[k++] = l + L | 0, r[k++] = f + U | 0, r[k++] = h + _ | 0, r[k++] = y + j | 0, r[k++] = E + g | 0, r[k++] = p + w | 0, r[k++] = d + b | 0, r[k++] = v + I | 0, r[k++] = m + R | 0, r[k++] = O + x | 0, r[k++] = N + C | 0, r[k++] = $ + P | 0;
}
const $27e7cfe6b0bd856f$var$$s = $27e7cfe6b0bd856f$var$Ns($27e7cfe6b0bd856f$var$_s, {
    counterRight: !1,
    counterLength: 4,
    allowShortKeys: !1
}), $27e7cfe6b0bd856f$var$Ls = new Uint8Array(16), $27e7cfe6b0bd856f$var$Rr = (t, e)=>{
    t.update(e);
    const n = e.length % 16;
    n && t.update($27e7cfe6b0bd856f$var$Ls.subarray(n));
}, $27e7cfe6b0bd856f$var$js = new Uint8Array(32);
function $27e7cfe6b0bd856f$var$_r(t, e, n, r, o) {
    const i = t(e, n, $27e7cfe6b0bd856f$var$js), s = $27e7cfe6b0bd856f$var$Rs.create(i);
    o && $27e7cfe6b0bd856f$var$Rr(s, o), $27e7cfe6b0bd856f$var$Rr(s, r);
    const c = new Uint8Array(16), a = $27e7cfe6b0bd856f$var$gs(c);
    $27e7cfe6b0bd856f$var$Ir(a, 0, BigInt(o ? o.length : 0), !0), $27e7cfe6b0bd856f$var$Ir(a, 8, BigInt(r.length), !0), s.update(c);
    const u = s.digest();
    return $27e7cfe6b0bd856f$var$Lt(i, c), u;
}
const $27e7cfe6b0bd856f$var$Cs = (t)=>(e, n, r)=>({
            encrypt (i, s) {
                const c = i.length;
                s = $27e7cfe6b0bd856f$var$Br(c + 16, s, !1), s.set(i);
                const a = s.subarray(0, -16);
                t(e, n, a, a, 1);
                const u = $27e7cfe6b0bd856f$var$_r(t, e, n, a, r);
                return s.set(u, c), $27e7cfe6b0bd856f$var$Lt(u), s;
            },
            decrypt (i, s) {
                s = $27e7cfe6b0bd856f$var$Br(i.length - 16, s, !1);
                const c = i.subarray(0, -16), a = i.subarray(-16), u = $27e7cfe6b0bd856f$var$_r(t, e, n, c, r);
                if (!$27e7cfe6b0bd856f$var$bs(a, u)) throw new Error("invalid tag");
                return s.set(i.subarray(0, -16)), t(e, n, s, s, 1), $27e7cfe6b0bd856f$var$Lt(u), s;
            }
        }), $27e7cfe6b0bd856f$var$$r = $27e7cfe6b0bd856f$var$Es({
    blockSize: 64,
    nonceLength: 12,
    tagLength: 16
}, $27e7cfe6b0bd856f$var$Cs($27e7cfe6b0bd856f$var$$s));
class $27e7cfe6b0bd856f$var$Lr extends $27e7cfe6b0bd856f$var$Pe {
    constructor(e, n){
        super(), this.finished = !1, this.destroyed = !1, $27e7cfe6b0bd856f$var$je(e);
        const r = $27e7cfe6b0bd856f$var$_t(n);
        if (this.iHash = e.create(), typeof this.iHash.update != "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
        const o = this.blockLen, i = new Uint8Array(o);
        i.set(r.length > o ? e.create().update(r).digest() : r);
        for(let s = 0; s < i.length; s++)i[s] ^= 54;
        this.iHash.update(i), this.oHash = e.create();
        for(let s = 0; s < i.length; s++)i[s] ^= 106;
        this.oHash.update(i), i.fill(0);
    }
    update(e) {
        return $27e7cfe6b0bd856f$var$Tt(this), this.iHash.update(e), this;
    }
    digestInto(e) {
        $27e7cfe6b0bd856f$var$Tt(this), $27e7cfe6b0bd856f$var$Wt(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
    }
    digest() {
        const e = new Uint8Array(this.oHash.outputLen);
        return this.digestInto(e), e;
    }
    _cloneInto(e) {
        e || (e = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: n, iHash: r, finished: o, destroyed: i, blockLen: s, outputLen: c } = this;
        return e, e.finished = o, e.destroyed = i, e.blockLen = s, e.outputLen = c, e.oHash = n._cloneInto(e.oHash), e.iHash = r._cloneInto(e.iHash), e;
    }
    destroy() {
        this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
    }
}
const $27e7cfe6b0bd856f$var$pe = (t, e, n)=>new $27e7cfe6b0bd856f$var$Lr(t, e).update(n).digest();
$27e7cfe6b0bd856f$var$pe.create = (t, e)=>new $27e7cfe6b0bd856f$var$Lr(t, e);
function $27e7cfe6b0bd856f$var$Ps(t, e, n) {
    return $27e7cfe6b0bd856f$var$je(t), n === void 0 && (n = new Uint8Array(t.outputLen)), $27e7cfe6b0bd856f$var$pe(t, $27e7cfe6b0bd856f$var$_t(n), $27e7cfe6b0bd856f$var$_t(e));
}
const $27e7cfe6b0bd856f$var$Ye = new Uint8Array([
    0
]), $27e7cfe6b0bd856f$var$jr = new Uint8Array;
function $27e7cfe6b0bd856f$var$ks(t, e, n, r = 32) {
    if ($27e7cfe6b0bd856f$var$je(t), $27e7cfe6b0bd856f$var$Gt(r), r > 255 * t.outputLen) throw new Error("Length should be <= 255*HashLen");
    const o = Math.ceil(r / t.outputLen);
    n === void 0 && (n = $27e7cfe6b0bd856f$var$jr);
    const i = new Uint8Array(o * t.outputLen), s = $27e7cfe6b0bd856f$var$pe.create(t, e), c = s._cloneInto(), a = new Uint8Array(s.outputLen);
    for(let u = 0; u < o; u++)$27e7cfe6b0bd856f$var$Ye[0] = u + 1, c.update(u === 0 ? $27e7cfe6b0bd856f$var$jr : a).update(n).update($27e7cfe6b0bd856f$var$Ye).digestInto(a), i.set(a, t.outputLen * u), s._cloneInto(c);
    return s.destroy(), c.destroy(), a.fill(0), $27e7cfe6b0bd856f$var$Ye.fill(0), i.slice(0, r);
}
const $27e7cfe6b0bd856f$var$Vs = (t, e, n, r, o)=>$27e7cfe6b0bd856f$var$ks(t, $27e7cfe6b0bd856f$var$Ps(t, e, n), r, o);
function $27e7cfe6b0bd856f$var$Ms(t, e, n, r) {
    if (typeof t.setBigUint64 == "function") return t.setBigUint64(e, n, r);
    const o = BigInt(32), i = BigInt(4294967295), s = Number(n >> o & i), c = Number(n & i), a = r ? 4 : 0, u = r ? 0 : 4;
    t.setUint32(e + a, s, r), t.setUint32(e + u, c, r);
}
function $27e7cfe6b0bd856f$var$Ds(t, e, n) {
    return t & e ^ ~t & n;
}
function $27e7cfe6b0bd856f$var$Hs(t, e, n) {
    return t & e ^ t & n ^ e & n;
}
class $27e7cfe6b0bd856f$var$qs extends $27e7cfe6b0bd856f$var$Pe {
    constructor(e, n, r, o){
        super(), this.blockLen = e, this.outputLen = n, this.padOffset = r, this.isLE = o, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = $27e7cfe6b0bd856f$var$Ce(this.buffer);
    }
    update(e) {
        $27e7cfe6b0bd856f$var$Tt(this);
        const { view: n, buffer: r, blockLen: o } = this;
        e = $27e7cfe6b0bd856f$var$_t(e);
        const i = e.length;
        for(let s = 0; s < i;){
            const c = Math.min(o - this.pos, i - s);
            if (c === o) {
                const a = $27e7cfe6b0bd856f$var$Ce(e);
                for(; o <= i - s; s += o)this.process(a, s);
                continue;
            }
            r.set(e.subarray(s, s + c), this.pos), this.pos += c, s += c, this.pos === o && (this.process(n, 0), this.pos = 0);
        }
        return this.length += e.length, this.roundClean(), this;
    }
    digestInto(e) {
        $27e7cfe6b0bd856f$var$Tt(this), $27e7cfe6b0bd856f$var$Gn(e, this), this.finished = !0;
        const { buffer: n, view: r, blockLen: o, isLE: i } = this;
        let { pos: s } = this;
        n[s++] = 128, this.buffer.subarray(s).fill(0), this.padOffset > o - s && (this.process(r, 0), s = 0);
        for(let f = s; f < o; f++)n[f] = 0;
        $27e7cfe6b0bd856f$var$Ms(r, o - 8, BigInt(this.length * 8), i), this.process(r, 0);
        const c = $27e7cfe6b0bd856f$var$Ce(e), a = this.outputLen;
        if (a % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const u = a / 4, l = this.get();
        if (u > l.length) throw new Error("_sha2: outputLen bigger than state");
        for(let f = 0; f < u; f++)c.setUint32(4 * f, l[f], i);
    }
    digest() {
        const { buffer: e, outputLen: n } = this;
        this.digestInto(e);
        const r = e.slice(0, n);
        return this.destroy(), r;
    }
    _cloneInto(e) {
        e || (e = new this.constructor), e.set(...this.get());
        const { blockLen: n, buffer: r, length: o, finished: i, destroyed: s, pos: c } = this;
        return e.length = o, e.pos = c, e.finished = i, e.destroyed = s, o % n && e.buffer.set(r), e;
    }
}
const $27e7cfe6b0bd856f$var$Ks = new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
]), $27e7cfe6b0bd856f$var$wt = new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
]), $27e7cfe6b0bd856f$var$bt = new Uint32Array(64);
class $27e7cfe6b0bd856f$var$Fs extends $27e7cfe6b0bd856f$var$qs {
    constructor(){
        super(64, 32, 8, !1), this.A = $27e7cfe6b0bd856f$var$wt[0] | 0, this.B = $27e7cfe6b0bd856f$var$wt[1] | 0, this.C = $27e7cfe6b0bd856f$var$wt[2] | 0, this.D = $27e7cfe6b0bd856f$var$wt[3] | 0, this.E = $27e7cfe6b0bd856f$var$wt[4] | 0, this.F = $27e7cfe6b0bd856f$var$wt[5] | 0, this.G = $27e7cfe6b0bd856f$var$wt[6] | 0, this.H = $27e7cfe6b0bd856f$var$wt[7] | 0;
    }
    get() {
        const { A: e, B: n, C: r, D: o, E: i, F: s, G: c, H: a } = this;
        return [
            e,
            n,
            r,
            o,
            i,
            s,
            c,
            a
        ];
    }
    set(e, n, r, o, i, s, c, a) {
        this.A = e | 0, this.B = n | 0, this.C = r | 0, this.D = o | 0, this.E = i | 0, this.F = s | 0, this.G = c | 0, this.H = a | 0;
    }
    process(e, n) {
        for(let f = 0; f < 16; f++, n += 4)$27e7cfe6b0bd856f$var$bt[f] = e.getUint32(n, !1);
        for(let f = 16; f < 64; f++){
            const h = $27e7cfe6b0bd856f$var$bt[f - 15], y = $27e7cfe6b0bd856f$var$bt[f - 2], E = $27e7cfe6b0bd856f$var$st(h, 7) ^ $27e7cfe6b0bd856f$var$st(h, 18) ^ h >>> 3, p = $27e7cfe6b0bd856f$var$st(y, 17) ^ $27e7cfe6b0bd856f$var$st(y, 19) ^ y >>> 10;
            $27e7cfe6b0bd856f$var$bt[f] = p + $27e7cfe6b0bd856f$var$bt[f - 7] + E + $27e7cfe6b0bd856f$var$bt[f - 16] | 0;
        }
        let { A: r, B: o, C: i, D: s, E: c, F: a, G: u, H: l } = this;
        for(let f = 0; f < 64; f++){
            const h = $27e7cfe6b0bd856f$var$st(c, 6) ^ $27e7cfe6b0bd856f$var$st(c, 11) ^ $27e7cfe6b0bd856f$var$st(c, 25), y = l + h + $27e7cfe6b0bd856f$var$Ds(c, a, u) + $27e7cfe6b0bd856f$var$Ks[f] + $27e7cfe6b0bd856f$var$bt[f] | 0, p = ($27e7cfe6b0bd856f$var$st(r, 2) ^ $27e7cfe6b0bd856f$var$st(r, 13) ^ $27e7cfe6b0bd856f$var$st(r, 22)) + $27e7cfe6b0bd856f$var$Hs(r, o, i) | 0;
            l = u, u = a, a = c, c = s + y | 0, s = i, i = o, o = r, r = y + p | 0;
        }
        r = r + this.A | 0, o = o + this.B | 0, i = i + this.C | 0, s = s + this.D | 0, c = c + this.E | 0, a = a + this.F | 0, u = u + this.G | 0, l = l + this.H | 0, this.set(r, o, i, s, c, a, u, l);
    }
    roundClean() {
        $27e7cfe6b0bd856f$var$bt.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
}
const $27e7cfe6b0bd856f$var$Jt = $27e7cfe6b0bd856f$var$Qn(()=>new $27e7cfe6b0bd856f$var$Fs); /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
const $27e7cfe6b0bd856f$var$ge = BigInt(0), $27e7cfe6b0bd856f$var$ye = BigInt(1), $27e7cfe6b0bd856f$var$zs = BigInt(2);
function $27e7cfe6b0bd856f$var$St(t) {
    return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function $27e7cfe6b0bd856f$var$Qt(t) {
    if (!$27e7cfe6b0bd856f$var$St(t)) throw new Error("Uint8Array expected");
}
function $27e7cfe6b0bd856f$var$jt(t, e) {
    if (typeof e != "boolean") throw new Error(t + " boolean expected, got " + e);
}
const $27e7cfe6b0bd856f$var$Zs = Array.from({
    length: 256
}, (t, e)=>e.toString(16).padStart(2, "0"));
function $27e7cfe6b0bd856f$var$Ct(t) {
    $27e7cfe6b0bd856f$var$Qt(t);
    let e = "";
    for(let n = 0; n < t.length; n++)e += $27e7cfe6b0bd856f$var$Zs[t[n]];
    return e;
}
function $27e7cfe6b0bd856f$var$Pt(t) {
    const e = t.toString(16);
    return e.length & 1 ? "0" + e : e;
}
function $27e7cfe6b0bd856f$var$Ge(t) {
    if (typeof t != "string") throw new Error("hex string expected, got " + typeof t);
    return t === "" ? $27e7cfe6b0bd856f$var$ge : BigInt("0x" + t);
}
const $27e7cfe6b0bd856f$var$ut = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $27e7cfe6b0bd856f$var$Cr(t) {
    if (t >= $27e7cfe6b0bd856f$var$ut._0 && t <= $27e7cfe6b0bd856f$var$ut._9) return t - $27e7cfe6b0bd856f$var$ut._0;
    if (t >= $27e7cfe6b0bd856f$var$ut.A && t <= $27e7cfe6b0bd856f$var$ut.F) return t - ($27e7cfe6b0bd856f$var$ut.A - 10);
    if (t >= $27e7cfe6b0bd856f$var$ut.a && t <= $27e7cfe6b0bd856f$var$ut.f) return t - ($27e7cfe6b0bd856f$var$ut.a - 10);
}
function $27e7cfe6b0bd856f$var$kt(t) {
    if (typeof t != "string") throw new Error("hex string expected, got " + typeof t);
    const e = t.length, n = e / 2;
    if (e % 2) throw new Error("hex string expected, got unpadded hex of length " + e);
    const r = new Uint8Array(n);
    for(let o = 0, i = 0; o < n; o++, i += 2){
        const s = $27e7cfe6b0bd856f$var$Cr(t.charCodeAt(i)), c = $27e7cfe6b0bd856f$var$Cr(t.charCodeAt(i + 1));
        if (s === void 0 || c === void 0) {
            const a = t[i] + t[i + 1];
            throw new Error('hex string expected, got non-hex character "' + a + '" at index ' + i);
        }
        r[o] = s * 16 + c;
    }
    return r;
}
function $27e7cfe6b0bd856f$var$Ot(t) {
    return $27e7cfe6b0bd856f$var$Ge($27e7cfe6b0bd856f$var$Ct(t));
}
function $27e7cfe6b0bd856f$var$te(t) {
    return $27e7cfe6b0bd856f$var$Qt(t), $27e7cfe6b0bd856f$var$Ge($27e7cfe6b0bd856f$var$Ct(Uint8Array.from(t).reverse()));
}
function $27e7cfe6b0bd856f$var$Vt(t, e) {
    return $27e7cfe6b0bd856f$var$kt(t.toString(16).padStart(e * 2, "0"));
}
function $27e7cfe6b0bd856f$var$me(t, e) {
    return $27e7cfe6b0bd856f$var$Vt(t, e).reverse();
}
function $27e7cfe6b0bd856f$var$Ys(t) {
    return $27e7cfe6b0bd856f$var$kt($27e7cfe6b0bd856f$var$Pt(t));
}
function $27e7cfe6b0bd856f$var$et(t, e, n) {
    let r;
    if (typeof e == "string") try {
        r = $27e7cfe6b0bd856f$var$kt(e);
    } catch (i) {
        throw new Error(t + " must be hex string or Uint8Array, cause: " + i);
    }
    else if ($27e7cfe6b0bd856f$var$St(e)) r = Uint8Array.from(e);
    else throw new Error(t + " must be hex string or Uint8Array");
    const o = r.length;
    if (typeof n == "number" && o !== n) throw new Error(t + " of length " + n + " expected, got " + o);
    return r;
}
function $27e7cfe6b0bd856f$var$ee(...t) {
    let e = 0;
    for(let r = 0; r < t.length; r++){
        const o = t[r];
        $27e7cfe6b0bd856f$var$Qt(o), e += o.length;
    }
    const n = new Uint8Array(e);
    for(let r = 0, o = 0; r < t.length; r++){
        const i = t[r];
        n.set(i, o), o += i.length;
    }
    return n;
}
function $27e7cfe6b0bd856f$var$Gs(t, e) {
    if (t.length !== e.length) return !1;
    let n = 0;
    for(let r = 0; r < t.length; r++)n |= t[r] ^ e[r];
    return n === 0;
}
function $27e7cfe6b0bd856f$var$Ws(t) {
    if (typeof t != "string") throw new Error("string expected");
    return new Uint8Array(new TextEncoder().encode(t));
}
const $27e7cfe6b0bd856f$var$We = (t)=>typeof t == "bigint" && $27e7cfe6b0bd856f$var$ge <= t;
function $27e7cfe6b0bd856f$var$we(t, e, n) {
    return $27e7cfe6b0bd856f$var$We(t) && $27e7cfe6b0bd856f$var$We(e) && $27e7cfe6b0bd856f$var$We(n) && e <= t && t < n;
}
function $27e7cfe6b0bd856f$var$ft(t, e, n, r) {
    if (!$27e7cfe6b0bd856f$var$we(e, n, r)) throw new Error("expected valid " + t + ": " + n + " <= n < " + r + ", got " + e);
}
function $27e7cfe6b0bd856f$var$Pr(t) {
    let e;
    for(e = 0; t > $27e7cfe6b0bd856f$var$ge; t >>= $27e7cfe6b0bd856f$var$ye, e += 1);
    return e;
}
function $27e7cfe6b0bd856f$var$Xs(t, e) {
    return t >> BigInt(e) & $27e7cfe6b0bd856f$var$ye;
}
function $27e7cfe6b0bd856f$var$Js(t, e, n) {
    return t | (n ? $27e7cfe6b0bd856f$var$ye : $27e7cfe6b0bd856f$var$ge) << BigInt(e);
}
const $27e7cfe6b0bd856f$var$Xe = (t)=>($27e7cfe6b0bd856f$var$zs << BigInt(t - 1)) - $27e7cfe6b0bd856f$var$ye, $27e7cfe6b0bd856f$var$Je = (t)=>new Uint8Array(t), $27e7cfe6b0bd856f$var$kr = (t)=>Uint8Array.from(t);
function $27e7cfe6b0bd856f$var$Vr(t, e, n) {
    if (typeof t != "number" || t < 2) throw new Error("hashLen must be a number");
    if (typeof e != "number" || e < 2) throw new Error("qByteLen must be a number");
    if (typeof n != "function") throw new Error("hmacFn must be a function");
    let r = $27e7cfe6b0bd856f$var$Je(t), o = $27e7cfe6b0bd856f$var$Je(t), i = 0;
    const s = ()=>{
        r.fill(1), o.fill(0), i = 0;
    }, c = (...f)=>n(o, r, ...f), a = (f = $27e7cfe6b0bd856f$var$Je())=>{
        o = c($27e7cfe6b0bd856f$var$kr([
            0
        ]), f), r = c(), f.length !== 0 && (o = c($27e7cfe6b0bd856f$var$kr([
            1
        ]), f), r = c());
    }, u = ()=>{
        if (i++ >= 1e3) throw new Error("drbg: tried 1000 values");
        let f = 0;
        const h = [];
        for(; f < e;){
            r = c();
            const y = r.slice();
            h.push(y), f += r.length;
        }
        return $27e7cfe6b0bd856f$var$ee(...h);
    };
    return (f, h)=>{
        s(), a(f);
        let y;
        for(; !(y = h(u()));)a();
        return s(), y;
    };
}
const $27e7cfe6b0bd856f$var$Qs = {
    bigint: (t)=>typeof t == "bigint",
    function: (t)=>typeof t == "function",
    boolean: (t)=>typeof t == "boolean",
    string: (t)=>typeof t == "string",
    stringOrUint8Array: (t)=>typeof t == "string" || $27e7cfe6b0bd856f$var$St(t),
    isSafeInteger: (t)=>Number.isSafeInteger(t),
    array: (t)=>Array.isArray(t),
    field: (t, e)=>e.Fp.isValid(t),
    hash: (t)=>typeof t == "function" && Number.isSafeInteger(t.outputLen)
};
function $27e7cfe6b0bd856f$var$Mt(t, e, n = {}) {
    const r = (o, i, s)=>{
        const c = $27e7cfe6b0bd856f$var$Qs[i];
        if (typeof c != "function") throw new Error("invalid validator function");
        const a = t[o];
        if (!(s && a === void 0) && !c(a, t)) throw new Error("param " + String(o) + " is invalid. Expected " + i + ", got " + a);
    };
    for (const [o, i] of Object.entries(e))r(o, i, !1);
    for (const [o, i] of Object.entries(n))r(o, i, !0);
    return t;
}
const $27e7cfe6b0bd856f$var$tc = ()=>{
    throw new Error("not implemented");
};
function $27e7cfe6b0bd856f$var$Qe(t) {
    const e = new WeakMap;
    return (n, ...r)=>{
        const o = e.get(n);
        if (o !== void 0) return o;
        const i = t(n, ...r);
        return e.set(n, i), i;
    };
}
var $27e7cfe6b0bd856f$var$ec = Object.freeze({
    __proto__: null,
    isBytes: $27e7cfe6b0bd856f$var$St,
    abytes: $27e7cfe6b0bd856f$var$Qt,
    abool: $27e7cfe6b0bd856f$var$jt,
    bytesToHex: $27e7cfe6b0bd856f$var$Ct,
    numberToHexUnpadded: $27e7cfe6b0bd856f$var$Pt,
    hexToNumber: $27e7cfe6b0bd856f$var$Ge,
    hexToBytes: $27e7cfe6b0bd856f$var$kt,
    bytesToNumberBE: $27e7cfe6b0bd856f$var$Ot,
    bytesToNumberLE: $27e7cfe6b0bd856f$var$te,
    numberToBytesBE: $27e7cfe6b0bd856f$var$Vt,
    numberToBytesLE: $27e7cfe6b0bd856f$var$me,
    numberToVarBytesBE: $27e7cfe6b0bd856f$var$Ys,
    ensureBytes: $27e7cfe6b0bd856f$var$et,
    concatBytes: $27e7cfe6b0bd856f$var$ee,
    equalBytes: $27e7cfe6b0bd856f$var$Gs,
    utf8ToBytes: $27e7cfe6b0bd856f$var$Ws,
    inRange: $27e7cfe6b0bd856f$var$we,
    aInRange: $27e7cfe6b0bd856f$var$ft,
    bitLen: $27e7cfe6b0bd856f$var$Pr,
    bitGet: $27e7cfe6b0bd856f$var$Xs,
    bitSet: $27e7cfe6b0bd856f$var$Js,
    bitMask: $27e7cfe6b0bd856f$var$Xe,
    createHmacDrbg: $27e7cfe6b0bd856f$var$Vr,
    validateObject: $27e7cfe6b0bd856f$var$Mt,
    notImplemented: $27e7cfe6b0bd856f$var$tc,
    memoized: $27e7cfe6b0bd856f$var$Qe
});
const $27e7cfe6b0bd856f$var$q = BigInt(0), $27e7cfe6b0bd856f$var$H = BigInt(1), $27e7cfe6b0bd856f$var$At = BigInt(2), $27e7cfe6b0bd856f$var$nc = BigInt(3), $27e7cfe6b0bd856f$var$tn = BigInt(4), $27e7cfe6b0bd856f$var$Mr = BigInt(5), $27e7cfe6b0bd856f$var$Dr = BigInt(8);
function $27e7cfe6b0bd856f$var$X(t, e) {
    const n = t % e;
    return n >= $27e7cfe6b0bd856f$var$q ? n : e + n;
}
function $27e7cfe6b0bd856f$var$Hr(t, e, n) {
    if (e < $27e7cfe6b0bd856f$var$q) throw new Error("invalid exponent, negatives unsupported");
    if (n <= $27e7cfe6b0bd856f$var$q) throw new Error("invalid modulus");
    if (n === $27e7cfe6b0bd856f$var$H) return $27e7cfe6b0bd856f$var$q;
    let r = $27e7cfe6b0bd856f$var$H;
    for(; e > $27e7cfe6b0bd856f$var$q;)e & $27e7cfe6b0bd856f$var$H && (r = r * t % n), t = t * t % n, e >>= $27e7cfe6b0bd856f$var$H;
    return r;
}
function $27e7cfe6b0bd856f$var$ot(t, e, n) {
    let r = t;
    for(; e-- > $27e7cfe6b0bd856f$var$q;)r *= r, r %= n;
    return r;
}
function $27e7cfe6b0bd856f$var$en(t, e) {
    if (t === $27e7cfe6b0bd856f$var$q) throw new Error("invert: expected non-zero number");
    if (e <= $27e7cfe6b0bd856f$var$q) throw new Error("invert: expected positive modulus, got " + e);
    let n = $27e7cfe6b0bd856f$var$X(t, e), r = e, o = $27e7cfe6b0bd856f$var$q, i = $27e7cfe6b0bd856f$var$H;
    for(; n !== $27e7cfe6b0bd856f$var$q;){
        const c = r / n, a = r % n, u = o - i * c;
        r = n, n = a, o = i, i = u;
    }
    if (r !== $27e7cfe6b0bd856f$var$H) throw new Error("invert: does not exist");
    return $27e7cfe6b0bd856f$var$X(o, e);
}
function $27e7cfe6b0bd856f$var$rc(t) {
    const e = (t - $27e7cfe6b0bd856f$var$H) / $27e7cfe6b0bd856f$var$At;
    let n, r, o;
    for(n = t - $27e7cfe6b0bd856f$var$H, r = 0; n % $27e7cfe6b0bd856f$var$At === $27e7cfe6b0bd856f$var$q; n /= $27e7cfe6b0bd856f$var$At, r++);
    for(o = $27e7cfe6b0bd856f$var$At; o < t && $27e7cfe6b0bd856f$var$Hr(o, e, t) !== t - $27e7cfe6b0bd856f$var$H; o++)if (o > 1e3) throw new Error("Cannot find square root: likely non-prime P");
    if (r === 1) {
        const s = (t + $27e7cfe6b0bd856f$var$H) / $27e7cfe6b0bd856f$var$tn;
        return function(a, u) {
            const l = a.pow(u, s);
            if (!a.eql(a.sqr(l), u)) throw new Error("Cannot find square root");
            return l;
        };
    }
    const i = (n + $27e7cfe6b0bd856f$var$H) / $27e7cfe6b0bd856f$var$At;
    return function(c, a) {
        if (c.pow(a, e) === c.neg(c.ONE)) throw new Error("Cannot find square root");
        let u = r, l = c.pow(c.mul(c.ONE, o), n), f = c.pow(a, i), h = c.pow(a, n);
        for(; !c.eql(h, c.ONE);){
            if (c.eql(h, c.ZERO)) return c.ZERO;
            let y = 1;
            for(let p = c.sqr(h); y < u && !c.eql(p, c.ONE); y++)p = c.sqr(p);
            const E = c.pow(l, $27e7cfe6b0bd856f$var$H << BigInt(u - y - 1));
            l = c.sqr(E), f = c.mul(f, E), h = c.mul(h, l), u = y;
        }
        return f;
    };
}
function $27e7cfe6b0bd856f$var$oc(t) {
    if (t % $27e7cfe6b0bd856f$var$tn === $27e7cfe6b0bd856f$var$nc) {
        const e = (t + $27e7cfe6b0bd856f$var$H) / $27e7cfe6b0bd856f$var$tn;
        return function(r, o) {
            const i = r.pow(o, e);
            if (!r.eql(r.sqr(i), o)) throw new Error("Cannot find square root");
            return i;
        };
    }
    if (t % $27e7cfe6b0bd856f$var$Dr === $27e7cfe6b0bd856f$var$Mr) {
        const e = (t - $27e7cfe6b0bd856f$var$Mr) / $27e7cfe6b0bd856f$var$Dr;
        return function(r, o) {
            const i = r.mul(o, $27e7cfe6b0bd856f$var$At), s = r.pow(i, e), c = r.mul(o, s), a = r.mul(r.mul(c, $27e7cfe6b0bd856f$var$At), s), u = r.mul(c, r.sub(a, r.ONE));
            if (!r.eql(r.sqr(u), o)) throw new Error("Cannot find square root");
            return u;
        };
    }
    return $27e7cfe6b0bd856f$var$rc(t);
}
const $27e7cfe6b0bd856f$var$ic = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $27e7cfe6b0bd856f$var$sc(t) {
    const e = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    }, n = $27e7cfe6b0bd856f$var$ic.reduce((r, o)=>(r[o] = "function", r), e);
    return $27e7cfe6b0bd856f$var$Mt(t, n);
}
function $27e7cfe6b0bd856f$var$cc(t, e, n) {
    if (n < $27e7cfe6b0bd856f$var$q) throw new Error("invalid exponent, negatives unsupported");
    if (n === $27e7cfe6b0bd856f$var$q) return t.ONE;
    if (n === $27e7cfe6b0bd856f$var$H) return e;
    let r = t.ONE, o = e;
    for(; n > $27e7cfe6b0bd856f$var$q;)n & $27e7cfe6b0bd856f$var$H && (r = t.mul(r, o)), o = t.sqr(o), n >>= $27e7cfe6b0bd856f$var$H;
    return r;
}
function $27e7cfe6b0bd856f$var$ac(t, e) {
    const n = new Array(e.length), r = e.reduce((i, s, c)=>t.is0(s) ? i : (n[c] = i, t.mul(i, s)), t.ONE), o = t.inv(r);
    return e.reduceRight((i, s, c)=>t.is0(s) ? i : (n[c] = t.mul(i, n[c]), t.mul(i, s)), o), n;
}
function $27e7cfe6b0bd856f$var$qr(t, e) {
    const n = e !== void 0 ? e : t.toString(2).length, r = Math.ceil(n / 8);
    return {
        nBitLength: n,
        nByteLength: r
    };
}
function $27e7cfe6b0bd856f$var$Kr(t, e, n = !1, r = {}) {
    if (t <= $27e7cfe6b0bd856f$var$q) throw new Error("invalid field: expected ORDER > 0, got " + t);
    const { nBitLength: o, nByteLength: i } = $27e7cfe6b0bd856f$var$qr(t, e);
    if (i > 2048) throw new Error("invalid field: expected ORDER of <= 2048 bytes");
    let s;
    const c = Object.freeze({
        ORDER: t,
        isLE: n,
        BITS: o,
        BYTES: i,
        MASK: $27e7cfe6b0bd856f$var$Xe(o),
        ZERO: $27e7cfe6b0bd856f$var$q,
        ONE: $27e7cfe6b0bd856f$var$H,
        create: (a)=>$27e7cfe6b0bd856f$var$X(a, t),
        isValid: (a)=>{
            if (typeof a != "bigint") throw new Error("invalid field element: expected bigint, got " + typeof a);
            return $27e7cfe6b0bd856f$var$q <= a && a < t;
        },
        is0: (a)=>a === $27e7cfe6b0bd856f$var$q,
        isOdd: (a)=>(a & $27e7cfe6b0bd856f$var$H) === $27e7cfe6b0bd856f$var$H,
        neg: (a)=>$27e7cfe6b0bd856f$var$X(-a, t),
        eql: (a, u)=>a === u,
        sqr: (a)=>$27e7cfe6b0bd856f$var$X(a * a, t),
        add: (a, u)=>$27e7cfe6b0bd856f$var$X(a + u, t),
        sub: (a, u)=>$27e7cfe6b0bd856f$var$X(a - u, t),
        mul: (a, u)=>$27e7cfe6b0bd856f$var$X(a * u, t),
        pow: (a, u)=>$27e7cfe6b0bd856f$var$cc(c, a, u),
        div: (a, u)=>$27e7cfe6b0bd856f$var$X(a * $27e7cfe6b0bd856f$var$en(u, t), t),
        sqrN: (a)=>a * a,
        addN: (a, u)=>a + u,
        subN: (a, u)=>a - u,
        mulN: (a, u)=>a * u,
        inv: (a)=>$27e7cfe6b0bd856f$var$en(a, t),
        sqrt: r.sqrt || ((a)=>(s || (s = $27e7cfe6b0bd856f$var$oc(t)), s(c, a))),
        invertBatch: (a)=>$27e7cfe6b0bd856f$var$ac(c, a),
        cmov: (a, u, l)=>l ? u : a,
        toBytes: (a)=>n ? $27e7cfe6b0bd856f$var$me(a, i) : $27e7cfe6b0bd856f$var$Vt(a, i),
        fromBytes: (a)=>{
            if (a.length !== i) throw new Error("Field.fromBytes: expected " + i + " bytes, got " + a.length);
            return n ? $27e7cfe6b0bd856f$var$te(a) : $27e7cfe6b0bd856f$var$Ot(a);
        }
    });
    return Object.freeze(c);
}
function $27e7cfe6b0bd856f$var$Fr(t) {
    if (typeof t != "bigint") throw new Error("field order must be bigint");
    const e = t.toString(2).length;
    return Math.ceil(e / 8);
}
function $27e7cfe6b0bd856f$var$zr(t) {
    const e = $27e7cfe6b0bd856f$var$Fr(t);
    return e + Math.ceil(e / 2);
}
function $27e7cfe6b0bd856f$var$uc(t, e, n = !1) {
    const r = t.length, o = $27e7cfe6b0bd856f$var$Fr(e), i = $27e7cfe6b0bd856f$var$zr(e);
    if (r < 16 || r < i || r > 1024) throw new Error("expected " + i + "-1024 bytes of input, got " + r);
    const s = n ? $27e7cfe6b0bd856f$var$te(t) : $27e7cfe6b0bd856f$var$Ot(t), c = $27e7cfe6b0bd856f$var$X(s, e - $27e7cfe6b0bd856f$var$H) + $27e7cfe6b0bd856f$var$H;
    return n ? $27e7cfe6b0bd856f$var$me(c, o) : $27e7cfe6b0bd856f$var$Vt(c, o);
}
const $27e7cfe6b0bd856f$var$Zr = BigInt(0), $27e7cfe6b0bd856f$var$be = BigInt(1);
function $27e7cfe6b0bd856f$var$nn(t, e) {
    const n = e.negate();
    return t ? n : e;
}
function $27e7cfe6b0bd856f$var$Yr(t, e) {
    if (!Number.isSafeInteger(t) || t <= 0 || t > e) throw new Error("invalid window size, expected [1.." + e + "], got W=" + t);
}
function $27e7cfe6b0bd856f$var$rn(t, e) {
    $27e7cfe6b0bd856f$var$Yr(t, e);
    const n = Math.ceil(e / t) + 1, r = 2 ** (t - 1);
    return {
        windows: n,
        windowSize: r
    };
}
function $27e7cfe6b0bd856f$var$fc(t, e) {
    if (!Array.isArray(t)) throw new Error("array expected");
    t.forEach((n, r)=>{
        if (!(n instanceof e)) throw new Error("invalid point at index " + r);
    });
}
function $27e7cfe6b0bd856f$var$lc(t, e) {
    if (!Array.isArray(t)) throw new Error("array of scalars expected");
    t.forEach((n, r)=>{
        if (!e.isValid(n)) throw new Error("invalid scalar at index " + r);
    });
}
const $27e7cfe6b0bd856f$var$on = new WeakMap, $27e7cfe6b0bd856f$var$Gr = new WeakMap;
function $27e7cfe6b0bd856f$var$sn(t) {
    return $27e7cfe6b0bd856f$var$Gr.get(t) || 1;
}
function $27e7cfe6b0bd856f$var$dc(t, e) {
    return {
        constTimeNegate: $27e7cfe6b0bd856f$var$nn,
        hasPrecomputes (n) {
            return $27e7cfe6b0bd856f$var$sn(n) !== 1;
        },
        unsafeLadder (n, r, o = t.ZERO) {
            let i = n;
            for(; r > $27e7cfe6b0bd856f$var$Zr;)r & $27e7cfe6b0bd856f$var$be && (o = o.add(i)), i = i.double(), r >>= $27e7cfe6b0bd856f$var$be;
            return o;
        },
        precomputeWindow (n, r) {
            const { windows: o, windowSize: i } = $27e7cfe6b0bd856f$var$rn(r, e), s = [];
            let c = n, a = c;
            for(let u = 0; u < o; u++){
                a = c, s.push(a);
                for(let l = 1; l < i; l++)a = a.add(c), s.push(a);
                c = a.double();
            }
            return s;
        },
        wNAF (n, r, o) {
            const { windows: i, windowSize: s } = $27e7cfe6b0bd856f$var$rn(n, e);
            let c = t.ZERO, a = t.BASE;
            const u = BigInt(2 ** n - 1), l = 2 ** n, f = BigInt(n);
            for(let h = 0; h < i; h++){
                const y = h * s;
                let E = Number(o & u);
                o >>= f, E > s && (E -= l, o += $27e7cfe6b0bd856f$var$be);
                const p = y, d = y + Math.abs(E) - 1, v = h % 2 !== 0, m = E < 0;
                E === 0 ? a = a.add($27e7cfe6b0bd856f$var$nn(v, r[p])) : c = c.add($27e7cfe6b0bd856f$var$nn(m, r[d]));
            }
            return {
                p: c,
                f: a
            };
        },
        wNAFUnsafe (n, r, o, i = t.ZERO) {
            const { windows: s, windowSize: c } = $27e7cfe6b0bd856f$var$rn(n, e), a = BigInt(2 ** n - 1), u = 2 ** n, l = BigInt(n);
            for(let f = 0; f < s; f++){
                const h = f * c;
                if (o === $27e7cfe6b0bd856f$var$Zr) break;
                let y = Number(o & a);
                if (o >>= l, y > c && (y -= u, o += $27e7cfe6b0bd856f$var$be), y === 0) continue;
                let E = r[h + Math.abs(y) - 1];
                y < 0 && (E = E.negate()), i = i.add(E);
            }
            return i;
        },
        getPrecomputes (n, r, o) {
            let i = $27e7cfe6b0bd856f$var$on.get(r);
            return i || (i = this.precomputeWindow(r, n), n !== 1 && $27e7cfe6b0bd856f$var$on.set(r, o(i))), i;
        },
        wNAFCached (n, r, o) {
            const i = $27e7cfe6b0bd856f$var$sn(n);
            return this.wNAF(i, this.getPrecomputes(i, n, o), r);
        },
        wNAFCachedUnsafe (n, r, o, i) {
            const s = $27e7cfe6b0bd856f$var$sn(n);
            return s === 1 ? this.unsafeLadder(n, r, i) : this.wNAFUnsafe(s, this.getPrecomputes(s, n, o), r, i);
        },
        setWindowSize (n, r) {
            $27e7cfe6b0bd856f$var$Yr(r, e), $27e7cfe6b0bd856f$var$Gr.set(n, r), $27e7cfe6b0bd856f$var$on.delete(n);
        }
    };
}
function $27e7cfe6b0bd856f$var$hc(t, e, n, r) {
    if ($27e7cfe6b0bd856f$var$fc(n, t), $27e7cfe6b0bd856f$var$lc(r, e), n.length !== r.length) throw new Error("arrays of points and scalars must have equal length");
    const o = t.ZERO, i = $27e7cfe6b0bd856f$var$Pr(BigInt(n.length)), s = i > 12 ? i - 3 : i > 4 ? i - 2 : i ? 2 : 1, c = (1 << s) - 1, a = new Array(c + 1).fill(o), u = Math.floor((e.BITS - 1) / s) * s;
    let l = o;
    for(let f = u; f >= 0; f -= s){
        a.fill(o);
        for(let y = 0; y < r.length; y++){
            const E = r[y], p = Number(E >> BigInt(f) & BigInt(c));
            a[p] = a[p].add(n[y]);
        }
        let h = o;
        for(let y = a.length - 1, E = o; y > 0; y--)E = E.add(a[y]), h = h.add(E);
        if (l = l.add(h), f !== 0) for(let y = 0; y < s; y++)l = l.double();
    }
    return l;
}
function $27e7cfe6b0bd856f$var$Wr(t) {
    return $27e7cfe6b0bd856f$var$sc(t.Fp), $27e7cfe6b0bd856f$var$Mt(t, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    }), Object.freeze({
        ...$27e7cfe6b0bd856f$var$qr(t.n, t.nBitLength),
        ...t,
        p: t.Fp.ORDER
    });
}
BigInt(0), BigInt(1), BigInt(2), BigInt(8);
const $27e7cfe6b0bd856f$var$Dt = BigInt(0), $27e7cfe6b0bd856f$var$cn = BigInt(1);
function $27e7cfe6b0bd856f$var$pc(t) {
    return $27e7cfe6b0bd856f$var$Mt(t, {
        a: "bigint"
    }, {
        montgomeryBits: "isSafeInteger",
        nByteLength: "isSafeInteger",
        adjustScalarBytes: "function",
        domain: "function",
        powPminus2: "function",
        Gu: "bigint"
    }), Object.freeze({
        ...t
    });
}
function $27e7cfe6b0bd856f$var$gc(t) {
    const e = $27e7cfe6b0bd856f$var$pc(t), { P: n } = e, r = (m)=>$27e7cfe6b0bd856f$var$X(m, n), o = e.montgomeryBits, i = Math.ceil(o / 8), s = e.nByteLength, c = e.adjustScalarBytes || ((m)=>m), a = e.powPminus2 || ((m)=>$27e7cfe6b0bd856f$var$Hr(m, n - BigInt(2), n));
    function u(m, O, N) {
        const $ = r(m * (O - N));
        return O = r(O - $), N = r(N + $), [
            O,
            N
        ];
    }
    const l = (e.a - BigInt(2)) / BigInt(4);
    function f(m, O) {
        $27e7cfe6b0bd856f$var$ft("u", m, $27e7cfe6b0bd856f$var$Dt, n), $27e7cfe6b0bd856f$var$ft("scalar", O, $27e7cfe6b0bd856f$var$Dt, n);
        const N = O, $ = m;
        let B = $27e7cfe6b0bd856f$var$cn, A = $27e7cfe6b0bd856f$var$Dt, T = m, S = $27e7cfe6b0bd856f$var$cn, L = $27e7cfe6b0bd856f$var$Dt, U;
        for(let j = BigInt(o - 1); j >= $27e7cfe6b0bd856f$var$Dt; j--){
            const g = N >> j & $27e7cfe6b0bd856f$var$cn;
            L ^= g, U = u(L, B, T), B = U[0], T = U[1], U = u(L, A, S), A = U[0], S = U[1], L = g;
            const w = B + A, b = r(w * w), I = B - A, R = r(I * I), x = b - R, C = T + S, P = T - S, k = r(P * w), M = r(C * I), D = k + M, z = k - M;
            T = r(D * D), S = r($ * r(z * z)), B = r(b * R), A = r(x * (b + r(l * x)));
        }
        U = u(L, B, T), B = U[0], T = U[1], U = u(L, A, S), A = U[0], S = U[1];
        const _ = a(A);
        return r(B * _);
    }
    function h(m) {
        return $27e7cfe6b0bd856f$var$me(r(m), i);
    }
    function y(m) {
        const O = $27e7cfe6b0bd856f$var$et("u coordinate", m, i);
        return s === 32 && (O[31] &= 127), $27e7cfe6b0bd856f$var$te(O);
    }
    function E(m) {
        const O = $27e7cfe6b0bd856f$var$et("scalar", m), N = O.length;
        if (N !== i && N !== s) {
            let $ = "" + i + " or " + s;
            throw new Error("invalid scalar, expected " + $ + " bytes, got " + N);
        }
        return $27e7cfe6b0bd856f$var$te(c(O));
    }
    function p(m, O) {
        const N = y(O), $ = E(m), B = f(N, $);
        if (B === $27e7cfe6b0bd856f$var$Dt) throw new Error("invalid private or public key received");
        return h(B);
    }
    const d = h(e.Gu);
    function v(m) {
        return p(m, d);
    }
    return {
        scalarMult: p,
        scalarMultBase: v,
        getSharedSecret: (m, O)=>p(m, O),
        getPublicKey: (m)=>v(m),
        utils: {
            randomPrivateKey: ()=>e.randomBytes(e.nByteLength)
        },
        GuBytes: d
    };
}
const $27e7cfe6b0bd856f$var$an = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949");
BigInt(0);
const $27e7cfe6b0bd856f$var$yc = BigInt(1), $27e7cfe6b0bd856f$var$Xr = BigInt(2), $27e7cfe6b0bd856f$var$mc = BigInt(3), $27e7cfe6b0bd856f$var$wc = BigInt(5);
BigInt(8);
function $27e7cfe6b0bd856f$var$bc(t) {
    const e = BigInt(10), n = BigInt(20), r = BigInt(40), o = BigInt(80), i = $27e7cfe6b0bd856f$var$an, c = t * t % i * t % i, a = $27e7cfe6b0bd856f$var$ot(c, $27e7cfe6b0bd856f$var$Xr, i) * c % i, u = $27e7cfe6b0bd856f$var$ot(a, $27e7cfe6b0bd856f$var$yc, i) * t % i, l = $27e7cfe6b0bd856f$var$ot(u, $27e7cfe6b0bd856f$var$wc, i) * u % i, f = $27e7cfe6b0bd856f$var$ot(l, e, i) * l % i, h = $27e7cfe6b0bd856f$var$ot(f, n, i) * f % i, y = $27e7cfe6b0bd856f$var$ot(h, r, i) * h % i, E = $27e7cfe6b0bd856f$var$ot(y, o, i) * y % i, p = $27e7cfe6b0bd856f$var$ot(E, o, i) * y % i, d = $27e7cfe6b0bd856f$var$ot(p, e, i) * l % i;
    return {
        pow_p_5_8: $27e7cfe6b0bd856f$var$ot(d, $27e7cfe6b0bd856f$var$Xr, i) * t % i,
        b2: c
    };
}
function $27e7cfe6b0bd856f$var$Ec(t) {
    return t[0] &= 248, t[31] &= 127, t[31] |= 64, t;
}
const $27e7cfe6b0bd856f$var$un = $27e7cfe6b0bd856f$var$gc({
    P: $27e7cfe6b0bd856f$var$an,
    a: BigInt(486662),
    montgomeryBits: 255,
    nByteLength: 32,
    Gu: BigInt(9),
    powPminus2: (t)=>{
        const e = $27e7cfe6b0bd856f$var$an, { pow_p_5_8: n, b2: r } = $27e7cfe6b0bd856f$var$bc(t);
        return $27e7cfe6b0bd856f$var$X($27e7cfe6b0bd856f$var$ot(n, $27e7cfe6b0bd856f$var$mc, e) * r, e);
    },
    adjustScalarBytes: $27e7cfe6b0bd856f$var$Ec,
    randomBytes: $27e7cfe6b0bd856f$var$$t
});
function $27e7cfe6b0bd856f$var$Jr(t) {
    t.lowS !== void 0 && $27e7cfe6b0bd856f$var$jt("lowS", t.lowS), t.prehash !== void 0 && $27e7cfe6b0bd856f$var$jt("prehash", t.prehash);
}
function $27e7cfe6b0bd856f$var$vc(t) {
    const e = $27e7cfe6b0bd856f$var$Wr(t);
    $27e7cfe6b0bd856f$var$Mt(e, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: n, Fp: r, a: o } = e;
    if (n) {
        if (!r.eql(o, r.ZERO)) throw new Error("invalid endomorphism, can only be defined for Koblitz curves that have a=0");
        if (typeof n != "object" || typeof n.beta != "bigint" || typeof n.splitScalar != "function") throw new Error("invalid endomorphism, expected beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...e
    });
}
const { bytesToNumberBE: $27e7cfe6b0bd856f$var$xc, hexToBytes: $27e7cfe6b0bd856f$var$Sc } = $27e7cfe6b0bd856f$var$ec;
class $27e7cfe6b0bd856f$var$Oc extends Error {
    constructor(e = ""){
        super(e);
    }
}
const $27e7cfe6b0bd856f$var$lt = {
    Err: $27e7cfe6b0bd856f$var$Oc,
    _tlv: {
        encode: (t, e)=>{
            const { Err: n } = $27e7cfe6b0bd856f$var$lt;
            if (t < 0 || t > 256) throw new n("tlv.encode: wrong tag");
            if (e.length & 1) throw new n("tlv.encode: unpadded data");
            const r = e.length / 2, o = $27e7cfe6b0bd856f$var$Pt(r);
            if (o.length / 2 & 128) throw new n("tlv.encode: long form length too big");
            const i = r > 127 ? $27e7cfe6b0bd856f$var$Pt(o.length / 2 | 128) : "";
            return $27e7cfe6b0bd856f$var$Pt(t) + i + o + e;
        },
        decode (t, e) {
            const { Err: n } = $27e7cfe6b0bd856f$var$lt;
            let r = 0;
            if (t < 0 || t > 256) throw new n("tlv.encode: wrong tag");
            if (e.length < 2 || e[r++] !== t) throw new n("tlv.decode: wrong tlv");
            const o = e[r++], i = !!(o & 128);
            let s = 0;
            if (!i) s = o;
            else {
                const a = o & 127;
                if (!a) throw new n("tlv.decode(long): indefinite length not supported");
                if (a > 4) throw new n("tlv.decode(long): byte length is too big");
                const u = e.subarray(r, r + a);
                if (u.length !== a) throw new n("tlv.decode: length bytes not complete");
                if (u[0] === 0) throw new n("tlv.decode(long): zero leftmost byte");
                for (const l of u)s = s << 8 | l;
                if (r += a, s < 128) throw new n("tlv.decode(long): not minimal encoding");
            }
            const c = e.subarray(r, r + s);
            if (c.length !== s) throw new n("tlv.decode: wrong value length");
            return {
                v: c,
                l: e.subarray(r + s)
            };
        }
    },
    _int: {
        encode (t) {
            const { Err: e } = $27e7cfe6b0bd856f$var$lt;
            if (t < $27e7cfe6b0bd856f$var$dt) throw new e("integer: negative integers are not allowed");
            let n = $27e7cfe6b0bd856f$var$Pt(t);
            if (Number.parseInt(n[0], 16) & 8 && (n = "00" + n), n.length & 1) throw new e("unexpected DER parsing assertion: unpadded hex");
            return n;
        },
        decode (t) {
            const { Err: e } = $27e7cfe6b0bd856f$var$lt;
            if (t[0] & 128) throw new e("invalid signature integer: negative");
            if (t[0] === 0 && !(t[1] & 128)) throw new e("invalid signature integer: unnecessary leading zero");
            return $27e7cfe6b0bd856f$var$xc(t);
        }
    },
    toSig (t) {
        const { Err: e, _int: n, _tlv: r } = $27e7cfe6b0bd856f$var$lt, o = typeof t == "string" ? $27e7cfe6b0bd856f$var$Sc(t) : t;
        $27e7cfe6b0bd856f$var$Qt(o);
        const { v: i, l: s } = r.decode(48, o);
        if (s.length) throw new e("invalid signature: left bytes after parsing");
        const { v: c, l: a } = r.decode(2, i), { v: u, l: l } = r.decode(2, a);
        if (l.length) throw new e("invalid signature: left bytes after parsing");
        return {
            r: n.decode(c),
            s: n.decode(u)
        };
    },
    hexFromSig (t) {
        const { _tlv: e, _int: n } = $27e7cfe6b0bd856f$var$lt, r = e.encode(2, n.encode(t.r)), o = e.encode(2, n.encode(t.s)), i = r + o;
        return e.encode(48, i);
    }
}, $27e7cfe6b0bd856f$var$dt = BigInt(0), $27e7cfe6b0bd856f$var$K = BigInt(1);
BigInt(2);
const $27e7cfe6b0bd856f$var$Qr = BigInt(3);
BigInt(4);
function $27e7cfe6b0bd856f$var$Ac(t) {
    const e = $27e7cfe6b0bd856f$var$vc(t), { Fp: n } = e, r = $27e7cfe6b0bd856f$var$Kr(e.n, e.nBitLength), o = e.toBytes || ((p, d, v)=>{
        const m = d.toAffine();
        return $27e7cfe6b0bd856f$var$ee(Uint8Array.from([
            4
        ]), n.toBytes(m.x), n.toBytes(m.y));
    }), i = e.fromBytes || ((p)=>{
        const d = p.subarray(1), v = n.fromBytes(d.subarray(0, n.BYTES)), m = n.fromBytes(d.subarray(n.BYTES, 2 * n.BYTES));
        return {
            x: v,
            y: m
        };
    });
    function s(p) {
        const { a: d, b: v } = e, m = n.sqr(p), O = n.mul(m, p);
        return n.add(n.add(O, n.mul(p, d)), v);
    }
    if (!n.eql(n.sqr(e.Gy), s(e.Gx))) throw new Error("bad generator point: equation left != right");
    function c(p) {
        return $27e7cfe6b0bd856f$var$we(p, $27e7cfe6b0bd856f$var$K, e.n);
    }
    function a(p) {
        const { allowedPrivateKeyLengths: d, nByteLength: v, wrapPrivateKey: m, n: O } = e;
        if (d && typeof p != "bigint") {
            if ($27e7cfe6b0bd856f$var$St(p) && (p = $27e7cfe6b0bd856f$var$Ct(p)), typeof p != "string" || !d.includes(p.length)) throw new Error("invalid private key");
            p = p.padStart(v * 2, "0");
        }
        let N;
        try {
            N = typeof p == "bigint" ? p : $27e7cfe6b0bd856f$var$Ot($27e7cfe6b0bd856f$var$et("private key", p, v));
        } catch  {
            throw new Error("invalid private key, expected hex or " + v + " bytes, got " + typeof p);
        }
        return m && (N = $27e7cfe6b0bd856f$var$X(N, O)), $27e7cfe6b0bd856f$var$ft("private key", N, $27e7cfe6b0bd856f$var$K, O), N;
    }
    function u(p) {
        if (!(p instanceof h)) throw new Error("ProjectivePoint expected");
    }
    const l = $27e7cfe6b0bd856f$var$Qe((p, d)=>{
        const { px: v, py: m, pz: O } = p;
        if (n.eql(O, n.ONE)) return {
            x: v,
            y: m
        };
        const N = p.is0();
        d == null && (d = N ? n.ONE : n.inv(O));
        const $ = n.mul(v, d), B = n.mul(m, d), A = n.mul(O, d);
        if (N) return {
            x: n.ZERO,
            y: n.ZERO
        };
        if (!n.eql(A, n.ONE)) throw new Error("invZ was invalid");
        return {
            x: $,
            y: B
        };
    }), f = $27e7cfe6b0bd856f$var$Qe((p)=>{
        if (p.is0()) {
            if (e.allowInfinityPoint && !n.is0(p.py)) return;
            throw new Error("bad point: ZERO");
        }
        const { x: d, y: v } = p.toAffine();
        if (!n.isValid(d) || !n.isValid(v)) throw new Error("bad point: x or y not FE");
        const m = n.sqr(v), O = s(d);
        if (!n.eql(m, O)) throw new Error("bad point: equation left != right");
        if (!p.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        return !0;
    });
    class h {
        constructor(d, v, m){
            if (this.px = d, this.py = v, this.pz = m, d == null || !n.isValid(d)) throw new Error("x required");
            if (v == null || !n.isValid(v)) throw new Error("y required");
            if (m == null || !n.isValid(m)) throw new Error("z required");
            Object.freeze(this);
        }
        static fromAffine(d) {
            const { x: v, y: m } = d || {};
            if (!d || !n.isValid(v) || !n.isValid(m)) throw new Error("invalid affine point");
            if (d instanceof h) throw new Error("projective point not allowed");
            const O = (N)=>n.eql(N, n.ZERO);
            return O(v) && O(m) ? h.ZERO : new h(v, m, n.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static normalizeZ(d) {
            const v = n.invertBatch(d.map((m)=>m.pz));
            return d.map((m, O)=>m.toAffine(v[O])).map(h.fromAffine);
        }
        static fromHex(d) {
            const v = h.fromAffine(i($27e7cfe6b0bd856f$var$et("pointHex", d)));
            return v.assertValidity(), v;
        }
        static fromPrivateKey(d) {
            return h.BASE.multiply(a(d));
        }
        static msm(d, v) {
            return $27e7cfe6b0bd856f$var$hc(h, r, d, v);
        }
        _setWindowSize(d) {
            E.setWindowSize(this, d);
        }
        assertValidity() {
            f(this);
        }
        hasEvenY() {
            const { y: d } = this.toAffine();
            if (n.isOdd) return !n.isOdd(d);
            throw new Error("Field doesn't support isOdd");
        }
        equals(d) {
            u(d);
            const { px: v, py: m, pz: O } = this, { px: N, py: $, pz: B } = d, A = n.eql(n.mul(v, B), n.mul(N, O)), T = n.eql(n.mul(m, B), n.mul($, O));
            return A && T;
        }
        negate() {
            return new h(this.px, n.neg(this.py), this.pz);
        }
        double() {
            const { a: d, b: v } = e, m = n.mul(v, $27e7cfe6b0bd856f$var$Qr), { px: O, py: N, pz: $ } = this;
            let B = n.ZERO, A = n.ZERO, T = n.ZERO, S = n.mul(O, O), L = n.mul(N, N), U = n.mul($, $), _ = n.mul(O, N);
            return _ = n.add(_, _), T = n.mul(O, $), T = n.add(T, T), B = n.mul(d, T), A = n.mul(m, U), A = n.add(B, A), B = n.sub(L, A), A = n.add(L, A), A = n.mul(B, A), B = n.mul(_, B), T = n.mul(m, T), U = n.mul(d, U), _ = n.sub(S, U), _ = n.mul(d, _), _ = n.add(_, T), T = n.add(S, S), S = n.add(T, S), S = n.add(S, U), S = n.mul(S, _), A = n.add(A, S), U = n.mul(N, $), U = n.add(U, U), S = n.mul(U, _), B = n.sub(B, S), T = n.mul(U, L), T = n.add(T, T), T = n.add(T, T), new h(B, A, T);
        }
        add(d) {
            u(d);
            const { px: v, py: m, pz: O } = this, { px: N, py: $, pz: B } = d;
            let A = n.ZERO, T = n.ZERO, S = n.ZERO;
            const L = e.a, U = n.mul(e.b, $27e7cfe6b0bd856f$var$Qr);
            let _ = n.mul(v, N), j = n.mul(m, $), g = n.mul(O, B), w = n.add(v, m), b = n.add(N, $);
            w = n.mul(w, b), b = n.add(_, j), w = n.sub(w, b), b = n.add(v, O);
            let I = n.add(N, B);
            return b = n.mul(b, I), I = n.add(_, g), b = n.sub(b, I), I = n.add(m, O), A = n.add($, B), I = n.mul(I, A), A = n.add(j, g), I = n.sub(I, A), S = n.mul(L, b), A = n.mul(U, g), S = n.add(A, S), A = n.sub(j, S), S = n.add(j, S), T = n.mul(A, S), j = n.add(_, _), j = n.add(j, _), g = n.mul(L, g), b = n.mul(U, b), j = n.add(j, g), g = n.sub(_, g), g = n.mul(L, g), b = n.add(b, g), _ = n.mul(j, b), T = n.add(T, _), _ = n.mul(I, b), A = n.mul(w, A), A = n.sub(A, _), _ = n.mul(w, j), S = n.mul(I, S), S = n.add(S, _), new h(A, T, S);
        }
        subtract(d) {
            return this.add(d.negate());
        }
        is0() {
            return this.equals(h.ZERO);
        }
        wNAF(d) {
            return E.wNAFCached(this, d, h.normalizeZ);
        }
        multiplyUnsafe(d) {
            const { endo: v, n: m } = e;
            $27e7cfe6b0bd856f$var$ft("scalar", d, $27e7cfe6b0bd856f$var$dt, m);
            const O = h.ZERO;
            if (d === $27e7cfe6b0bd856f$var$dt) return O;
            if (this.is0() || d === $27e7cfe6b0bd856f$var$K) return this;
            if (!v || E.hasPrecomputes(this)) return E.wNAFCachedUnsafe(this, d, h.normalizeZ);
            let { k1neg: N, k1: $, k2neg: B, k2: A } = v.splitScalar(d), T = O, S = O, L = this;
            for(; $ > $27e7cfe6b0bd856f$var$dt || A > $27e7cfe6b0bd856f$var$dt;)$ & $27e7cfe6b0bd856f$var$K && (T = T.add(L)), A & $27e7cfe6b0bd856f$var$K && (S = S.add(L)), L = L.double(), $ >>= $27e7cfe6b0bd856f$var$K, A >>= $27e7cfe6b0bd856f$var$K;
            return N && (T = T.negate()), B && (S = S.negate()), S = new h(n.mul(S.px, v.beta), S.py, S.pz), T.add(S);
        }
        multiply(d) {
            const { endo: v, n: m } = e;
            $27e7cfe6b0bd856f$var$ft("scalar", d, $27e7cfe6b0bd856f$var$K, m);
            let O, N;
            if (v) {
                const { k1neg: $, k1: B, k2neg: A, k2: T } = v.splitScalar(d);
                let { p: S, f: L } = this.wNAF(B), { p: U, f: _ } = this.wNAF(T);
                S = E.constTimeNegate($, S), U = E.constTimeNegate(A, U), U = new h(n.mul(U.px, v.beta), U.py, U.pz), O = S.add(U), N = L.add(_);
            } else {
                const { p: $, f: B } = this.wNAF(d);
                O = $, N = B;
            }
            return h.normalizeZ([
                O,
                N
            ])[0];
        }
        multiplyAndAddUnsafe(d, v, m) {
            const O = h.BASE, N = (B, A)=>A === $27e7cfe6b0bd856f$var$dt || A === $27e7cfe6b0bd856f$var$K || !B.equals(O) ? B.multiplyUnsafe(A) : B.multiply(A), $ = N(this, v).add(N(d, m));
            return $.is0() ? void 0 : $;
        }
        toAffine(d) {
            return l(this, d);
        }
        isTorsionFree() {
            const { h: d, isTorsionFree: v } = e;
            if (d === $27e7cfe6b0bd856f$var$K) return !0;
            if (v) return v(h, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: d, clearCofactor: v } = e;
            return d === $27e7cfe6b0bd856f$var$K ? this : v ? v(h, this) : this.multiplyUnsafe(e.h);
        }
        toRawBytes(d = !0) {
            return $27e7cfe6b0bd856f$var$jt("isCompressed", d), this.assertValidity(), o(h, this, d);
        }
        toHex(d = !0) {
            return $27e7cfe6b0bd856f$var$jt("isCompressed", d), $27e7cfe6b0bd856f$var$Ct(this.toRawBytes(d));
        }
    }
    h.BASE = new h(e.Gx, e.Gy, n.ONE), h.ZERO = new h(n.ZERO, n.ONE, n.ZERO);
    const y = e.nBitLength, E = $27e7cfe6b0bd856f$var$dc(h, e.endo ? Math.ceil(y / 2) : y);
    return {
        CURVE: e,
        ProjectivePoint: h,
        normPrivateKeyToScalar: a,
        weierstrassEquation: s,
        isWithinCurveOrder: c
    };
}
function $27e7cfe6b0bd856f$var$Bc(t) {
    const e = $27e7cfe6b0bd856f$var$Wr(t);
    return $27e7cfe6b0bd856f$var$Mt(e, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    }), Object.freeze({
        lowS: !0,
        ...e
    });
}
function $27e7cfe6b0bd856f$var$Ic(t) {
    const e = $27e7cfe6b0bd856f$var$Bc(t), { Fp: n, n: r } = e, o = n.BYTES + 1, i = 2 * n.BYTES + 1;
    function s(g) {
        return $27e7cfe6b0bd856f$var$X(g, r);
    }
    function c(g) {
        return $27e7cfe6b0bd856f$var$en(g, r);
    }
    const { ProjectivePoint: a, normPrivateKeyToScalar: u, weierstrassEquation: l, isWithinCurveOrder: f } = $27e7cfe6b0bd856f$var$Ac({
        ...e,
        toBytes (g, w, b) {
            const I = w.toAffine(), R = n.toBytes(I.x), x = $27e7cfe6b0bd856f$var$ee;
            return $27e7cfe6b0bd856f$var$jt("isCompressed", b), b ? x(Uint8Array.from([
                w.hasEvenY() ? 2 : 3
            ]), R) : x(Uint8Array.from([
                4
            ]), R, n.toBytes(I.y));
        },
        fromBytes (g) {
            const w = g.length, b = g[0], I = g.subarray(1);
            if (w === o && (b === 2 || b === 3)) {
                const R = $27e7cfe6b0bd856f$var$Ot(I);
                if (!$27e7cfe6b0bd856f$var$we(R, $27e7cfe6b0bd856f$var$K, n.ORDER)) throw new Error("Point is not on curve");
                const x = l(R);
                let C;
                try {
                    C = n.sqrt(x);
                } catch (M) {
                    const D = M instanceof Error ? ": " + M.message : "";
                    throw new Error("Point is not on curve" + D);
                }
                const P = (C & $27e7cfe6b0bd856f$var$K) === $27e7cfe6b0bd856f$var$K;
                return (b & 1) === 1 !== P && (C = n.neg(C)), {
                    x: R,
                    y: C
                };
            } else if (w === i && b === 4) {
                const R = n.fromBytes(I.subarray(0, n.BYTES)), x = n.fromBytes(I.subarray(n.BYTES, 2 * n.BYTES));
                return {
                    x: R,
                    y: x
                };
            } else {
                const R = o, x = i;
                throw new Error("invalid Point, expected length of " + R + ", or uncompressed " + x + ", got " + w);
            }
        }
    }), h = (g)=>$27e7cfe6b0bd856f$var$Ct($27e7cfe6b0bd856f$var$Vt(g, e.nByteLength));
    function y(g) {
        const w = r >> $27e7cfe6b0bd856f$var$K;
        return g > w;
    }
    function E(g) {
        return y(g) ? s(-g) : g;
    }
    const p = (g, w, b)=>$27e7cfe6b0bd856f$var$Ot(g.slice(w, b));
    class d {
        constructor(w, b, I){
            this.r = w, this.s = b, this.recovery = I, this.assertValidity();
        }
        static fromCompact(w) {
            const b = e.nByteLength;
            return w = $27e7cfe6b0bd856f$var$et("compactSignature", w, b * 2), new d(p(w, 0, b), p(w, b, 2 * b));
        }
        static fromDER(w) {
            const { r: b, s: I } = $27e7cfe6b0bd856f$var$lt.toSig($27e7cfe6b0bd856f$var$et("DER", w));
            return new d(b, I);
        }
        assertValidity() {
            $27e7cfe6b0bd856f$var$ft("r", this.r, $27e7cfe6b0bd856f$var$K, r), $27e7cfe6b0bd856f$var$ft("s", this.s, $27e7cfe6b0bd856f$var$K, r);
        }
        addRecoveryBit(w) {
            return new d(this.r, this.s, w);
        }
        recoverPublicKey(w) {
            const { r: b, s: I, recovery: R } = this, x = B($27e7cfe6b0bd856f$var$et("msgHash", w));
            if (R == null || ![
                0,
                1,
                2,
                3
            ].includes(R)) throw new Error("recovery id invalid");
            const C = R === 2 || R === 3 ? b + e.n : b;
            if (C >= n.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const P = (R & 1) === 0 ? "02" : "03", k = a.fromHex(P + h(C)), M = c(C), D = s(-x * M), z = s(I * M), Z = a.BASE.multiplyAndAddUnsafe(k, D, z);
            if (!Z) throw new Error("point at infinify");
            return Z.assertValidity(), Z;
        }
        hasHighS() {
            return y(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new d(this.r, s(-this.s), this.recovery) : this;
        }
        toDERRawBytes() {
            return $27e7cfe6b0bd856f$var$kt(this.toDERHex());
        }
        toDERHex() {
            return $27e7cfe6b0bd856f$var$lt.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        toCompactRawBytes() {
            return $27e7cfe6b0bd856f$var$kt(this.toCompactHex());
        }
        toCompactHex() {
            return h(this.r) + h(this.s);
        }
    }
    const v = {
        isValidPrivateKey (g) {
            try {
                return u(g), !0;
            } catch  {
                return !1;
            }
        },
        normPrivateKeyToScalar: u,
        randomPrivateKey: ()=>{
            const g = $27e7cfe6b0bd856f$var$zr(e.n);
            return $27e7cfe6b0bd856f$var$uc(e.randomBytes(g), e.n);
        },
        precompute (g = 8, w = a.BASE) {
            return w._setWindowSize(g), w.multiply(BigInt(3)), w;
        }
    };
    function m(g, w = !0) {
        return a.fromPrivateKey(g).toRawBytes(w);
    }
    function O(g) {
        const w = $27e7cfe6b0bd856f$var$St(g), b = typeof g == "string", I = (w || b) && g.length;
        return w ? I === o || I === i : b ? I === 2 * o || I === 2 * i : g instanceof a;
    }
    function N(g, w, b = !0) {
        if (O(g)) throw new Error("first arg must be private key");
        if (!O(w)) throw new Error("second arg must be public key");
        return a.fromHex(w).multiply(u(g)).toRawBytes(b);
    }
    const $ = e.bits2int || function(g) {
        if (g.length > 8192) throw new Error("input is too large");
        const w = $27e7cfe6b0bd856f$var$Ot(g), b = g.length * 8 - e.nBitLength;
        return b > 0 ? w >> BigInt(b) : w;
    }, B = e.bits2int_modN || function(g) {
        return s($(g));
    }, A = $27e7cfe6b0bd856f$var$Xe(e.nBitLength);
    function T(g) {
        return $27e7cfe6b0bd856f$var$ft("num < 2^" + e.nBitLength, g, $27e7cfe6b0bd856f$var$dt, A), $27e7cfe6b0bd856f$var$Vt(g, e.nByteLength);
    }
    function S(g, w, b = L) {
        if ([
            "recovered",
            "canonical"
        ].some((W)=>W in b)) throw new Error("sign() legacy options not supported");
        const { hash: I, randomBytes: R } = e;
        let { lowS: x, prehash: C, extraEntropy: P } = b;
        x == null && (x = !0), g = $27e7cfe6b0bd856f$var$et("msgHash", g), $27e7cfe6b0bd856f$var$Jr(b), C && (g = $27e7cfe6b0bd856f$var$et("prehashed msgHash", I(g)));
        const k = B(g), M = u(w), D = [
            T(M),
            T(k)
        ];
        if (P != null && P !== !1) {
            const W = P === !0 ? R(n.BYTES) : P;
            D.push($27e7cfe6b0bd856f$var$et("extraEntropy", W));
        }
        const z = $27e7cfe6b0bd856f$var$ee(...D), Z = k;
        function it(W) {
            const J = $(W);
            if (!f(J)) return;
            const Oe = c(J), Ft = a.BASE.multiply(J).toAffine(), vt = s(Ft.x);
            if (vt === $27e7cfe6b0bd856f$var$dt) return;
            const zt = s(Oe * s(Z + vt * M));
            if (zt === $27e7cfe6b0bd856f$var$dt) return;
            let Ut = (Ft.x === vt ? 0 : 2) | Number(Ft.y & $27e7cfe6b0bd856f$var$K), vn = zt;
            return x && y(zt) && (vn = E(zt), Ut ^= 1), new d(vt, vn, Ut);
        }
        return {
            seed: z,
            k2sig: it
        };
    }
    const L = {
        lowS: e.lowS,
        prehash: !1
    }, U = {
        lowS: e.lowS,
        prehash: !1
    };
    function _(g, w, b = L) {
        const { seed: I, k2sig: R } = S(g, w, b), x = e;
        return $27e7cfe6b0bd856f$var$Vr(x.hash.outputLen, x.nByteLength, x.hmac)(I, R);
    }
    a.BASE._setWindowSize(8);
    function j(g, w, b, I = U) {
        const R = g;
        w = $27e7cfe6b0bd856f$var$et("msgHash", w), b = $27e7cfe6b0bd856f$var$et("publicKey", b);
        const { lowS: x, prehash: C, format: P } = I;
        if ($27e7cfe6b0bd856f$var$Jr(I), "strict" in I) throw new Error("options.strict was renamed to lowS");
        if (P !== void 0 && P !== "compact" && P !== "der") throw new Error("format must be compact or der");
        const k = typeof R == "string" || $27e7cfe6b0bd856f$var$St(R), M = !k && !P && typeof R == "object" && R !== null && typeof R.r == "bigint" && typeof R.s == "bigint";
        if (!k && !M) throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
        let D, z;
        try {
            if (M && (D = new d(R.r, R.s)), k) {
                try {
                    P !== "compact" && (D = d.fromDER(R));
                } catch (Ut) {
                    if (!(Ut instanceof $27e7cfe6b0bd856f$var$lt.Err)) throw Ut;
                }
                !D && P !== "der" && (D = d.fromCompact(R));
            }
            z = a.fromHex(b);
        } catch  {
            return !1;
        }
        if (!D || x && D.hasHighS()) return !1;
        C && (w = e.hash(w));
        const { r: Z, s: it } = D, W = B(w), J = c(it), Oe = s(W * J), Ft = s(Z * J), vt = a.BASE.multiplyAndAddUnsafe(z, Oe, Ft)?.toAffine();
        return vt ? s(vt.x) === Z : !1;
    }
    return {
        CURVE: e,
        getPublicKey: m,
        getSharedSecret: N,
        sign: _,
        verify: j,
        ProjectivePoint: a,
        Signature: d,
        utils: v
    };
}
function $27e7cfe6b0bd856f$var$Nc(t) {
    return {
        hash: t,
        hmac: (e, ...n)=>$27e7cfe6b0bd856f$var$pe(t, e, $27e7cfe6b0bd856f$var$Vi(...n)),
        randomBytes: $27e7cfe6b0bd856f$var$$t
    };
}
function $27e7cfe6b0bd856f$var$Uc(t, e) {
    const n = (r)=>$27e7cfe6b0bd856f$var$Ic({
            ...t,
            ...$27e7cfe6b0bd856f$var$Nc(r)
        });
    return {
        ...n(e),
        create: n
    };
}
const $27e7cfe6b0bd856f$var$to = $27e7cfe6b0bd856f$var$Kr(BigInt("0xffffffff00000001000000000000000000000000ffffffffffffffffffffffff")), $27e7cfe6b0bd856f$var$Tc = $27e7cfe6b0bd856f$var$to.create(BigInt("-3")), $27e7cfe6b0bd856f$var$Rc = BigInt("0x5ac635d8aa3a93e7b3ebbd55769886bc651d06b0cc53b0f63bce3c3e27d2604b"), $27e7cfe6b0bd856f$var$_c = $27e7cfe6b0bd856f$var$Uc({
    a: $27e7cfe6b0bd856f$var$Tc,
    b: $27e7cfe6b0bd856f$var$Rc,
    Fp: $27e7cfe6b0bd856f$var$to,
    n: BigInt("0xffffffff00000000ffffffffffffffffbce6faada7179e84f3b9cac2fc632551"),
    Gx: BigInt("0x6b17d1f2e12c4247f8bce6e563a440f277037d812deb33a0f4a13945d898c296"),
    Gy: BigInt("0x4fe342e2fe1a7f9b8ee7eb4a7c0f9e162bce33576b315ececbb6406837bf51f5"),
    h: BigInt(1),
    lowS: !1
}, $27e7cfe6b0bd856f$var$Jt), $27e7cfe6b0bd856f$export$f7403969428298bd = "base10", $27e7cfe6b0bd856f$export$49eb910ab2518105 = "base16", $27e7cfe6b0bd856f$export$9bff723d552e6bcf = "base64pad", $27e7cfe6b0bd856f$export$e9cf21fb8029e645 = "base64url", $27e7cfe6b0bd856f$export$9560dad2a83e4f04 = "utf8", $27e7cfe6b0bd856f$export$3425bd336a9673d8 = 0, $27e7cfe6b0bd856f$export$406e97c329f0f3d4 = 1, $27e7cfe6b0bd856f$export$d79eac6ee921504f = 2, $27e7cfe6b0bd856f$var$$c = 0, $27e7cfe6b0bd856f$var$eo = 1, $27e7cfe6b0bd856f$var$re = 12, $27e7cfe6b0bd856f$var$dn = 32;
function $27e7cfe6b0bd856f$export$a949d36eab55b41f() {
    const t = $27e7cfe6b0bd856f$var$un.utils.randomPrivateKey(), e = $27e7cfe6b0bd856f$var$un.getPublicKey(t);
    return {
        privateKey: (0, $iH58P.toString)(t, $27e7cfe6b0bd856f$export$49eb910ab2518105),
        publicKey: (0, $iH58P.toString)(e, $27e7cfe6b0bd856f$export$49eb910ab2518105)
    };
}
function $27e7cfe6b0bd856f$export$d15a28e4f1821243() {
    const t = $27e7cfe6b0bd856f$var$$t($27e7cfe6b0bd856f$var$dn);
    return (0, $iH58P.toString)(t, $27e7cfe6b0bd856f$export$49eb910ab2518105);
}
function $27e7cfe6b0bd856f$export$f8378f68e053f5c6(t, e) {
    const n = $27e7cfe6b0bd856f$var$un.getSharedSecret((0, $eREyP.fromString)(t, $27e7cfe6b0bd856f$export$49eb910ab2518105), (0, $eREyP.fromString)(e, $27e7cfe6b0bd856f$export$49eb910ab2518105)), r = $27e7cfe6b0bd856f$var$Vs($27e7cfe6b0bd856f$var$Jt, n, void 0, void 0, $27e7cfe6b0bd856f$var$dn);
    return (0, $iH58P.toString)(r, $27e7cfe6b0bd856f$export$49eb910ab2518105);
}
function $27e7cfe6b0bd856f$export$1e87d19d4aab5805(t) {
    const e = $27e7cfe6b0bd856f$var$Jt((0, $eREyP.fromString)(t, $27e7cfe6b0bd856f$export$49eb910ab2518105));
    return (0, $iH58P.toString)(e, $27e7cfe6b0bd856f$export$49eb910ab2518105);
}
function $27e7cfe6b0bd856f$export$d4c241cec96564c1(t) {
    const e = $27e7cfe6b0bd856f$var$Jt((0, $eREyP.fromString)(t, $27e7cfe6b0bd856f$export$9560dad2a83e4f04));
    return (0, $iH58P.toString)(e, $27e7cfe6b0bd856f$export$49eb910ab2518105);
}
function $27e7cfe6b0bd856f$export$e9d2f9ba70428fb6(t) {
    return (0, $eREyP.fromString)(`${t}`, $27e7cfe6b0bd856f$export$f7403969428298bd);
}
function $27e7cfe6b0bd856f$export$7547a514ee29b9d4(t) {
    return Number((0, $iH58P.toString)(t, $27e7cfe6b0bd856f$export$f7403969428298bd));
}
function $27e7cfe6b0bd856f$var$no(t) {
    return t.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function $27e7cfe6b0bd856f$var$ro(t) {
    const e = t.replace(/-/g, "+").replace(/_/g, "/"), n = (4 - e.length % 4) % 4;
    return e + "=".repeat(n);
}
function $27e7cfe6b0bd856f$export$5b0f6292f11d1d18(t) {
    const e = $27e7cfe6b0bd856f$export$e9d2f9ba70428fb6(typeof t.type < "u" ? t.type : $27e7cfe6b0bd856f$export$3425bd336a9673d8);
    if ($27e7cfe6b0bd856f$export$7547a514ee29b9d4(e) === $27e7cfe6b0bd856f$export$406e97c329f0f3d4 && typeof t.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const n = typeof t.senderPublicKey < "u" ? (0, $eREyP.fromString)(t.senderPublicKey, $27e7cfe6b0bd856f$export$49eb910ab2518105) : void 0, r = typeof t.iv < "u" ? (0, $eREyP.fromString)(t.iv, $27e7cfe6b0bd856f$export$49eb910ab2518105) : $27e7cfe6b0bd856f$var$$t($27e7cfe6b0bd856f$var$re), o = (0, $eREyP.fromString)(t.symKey, $27e7cfe6b0bd856f$export$49eb910ab2518105), i = $27e7cfe6b0bd856f$var$$r(o, r).encrypt((0, $eREyP.fromString)(t.message, $27e7cfe6b0bd856f$export$9560dad2a83e4f04)), s = $27e7cfe6b0bd856f$export$dfdc1655ccc5b9cb({
        type: e,
        sealed: i,
        iv: r,
        senderPublicKey: n
    });
    return t.encoding === $27e7cfe6b0bd856f$export$e9cf21fb8029e645 ? $27e7cfe6b0bd856f$var$no(s) : s;
}
function $27e7cfe6b0bd856f$export$e85a0c9a1067c5d3(t) {
    const e = (0, $eREyP.fromString)(t.symKey, $27e7cfe6b0bd856f$export$49eb910ab2518105), { sealed: n, iv: r } = $27e7cfe6b0bd856f$export$efcd34ab6248d3cd({
        encoded: t.encoded,
        encoding: t.encoding
    }), o = $27e7cfe6b0bd856f$var$$r(e, r).decrypt(n);
    if (o === null) throw new Error("Failed to decrypt");
    return (0, $iH58P.toString)(o, $27e7cfe6b0bd856f$export$9560dad2a83e4f04);
}
function $27e7cfe6b0bd856f$export$99abb28d1c4baa95(t, e) {
    const n = $27e7cfe6b0bd856f$export$e9d2f9ba70428fb6($27e7cfe6b0bd856f$export$d79eac6ee921504f), r = $27e7cfe6b0bd856f$var$$t($27e7cfe6b0bd856f$var$re), o = (0, $eREyP.fromString)(t, $27e7cfe6b0bd856f$export$9560dad2a83e4f04), i = $27e7cfe6b0bd856f$export$dfdc1655ccc5b9cb({
        type: n,
        sealed: o,
        iv: r
    });
    return e === $27e7cfe6b0bd856f$export$e9cf21fb8029e645 ? $27e7cfe6b0bd856f$var$no(i) : i;
}
function $27e7cfe6b0bd856f$export$6b54347426d28ee3(t, e) {
    const { sealed: n } = $27e7cfe6b0bd856f$export$efcd34ab6248d3cd({
        encoded: t,
        encoding: e
    });
    return (0, $iH58P.toString)(n, $27e7cfe6b0bd856f$export$9560dad2a83e4f04);
}
function $27e7cfe6b0bd856f$export$dfdc1655ccc5b9cb(t) {
    if ($27e7cfe6b0bd856f$export$7547a514ee29b9d4(t.type) === $27e7cfe6b0bd856f$export$d79eac6ee921504f) return (0, $iH58P.toString)((0, $g976M.concat)([
        t.type,
        t.sealed
    ]), $27e7cfe6b0bd856f$export$9bff723d552e6bcf);
    if ($27e7cfe6b0bd856f$export$7547a514ee29b9d4(t.type) === $27e7cfe6b0bd856f$export$406e97c329f0f3d4) {
        if (typeof t.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $iH58P.toString)((0, $g976M.concat)([
            t.type,
            t.senderPublicKey,
            t.iv,
            t.sealed
        ]), $27e7cfe6b0bd856f$export$9bff723d552e6bcf);
    }
    return (0, $iH58P.toString)((0, $g976M.concat)([
        t.type,
        t.iv,
        t.sealed
    ]), $27e7cfe6b0bd856f$export$9bff723d552e6bcf);
}
function $27e7cfe6b0bd856f$export$efcd34ab6248d3cd(t) {
    const e = (t.encoding || $27e7cfe6b0bd856f$export$9bff723d552e6bcf) === $27e7cfe6b0bd856f$export$e9cf21fb8029e645 ? $27e7cfe6b0bd856f$var$ro(t.encoded) : t.encoded, n = (0, $eREyP.fromString)(e, $27e7cfe6b0bd856f$export$9bff723d552e6bcf), r = n.slice($27e7cfe6b0bd856f$var$$c, $27e7cfe6b0bd856f$var$eo), o = $27e7cfe6b0bd856f$var$eo;
    if ($27e7cfe6b0bd856f$export$7547a514ee29b9d4(r) === $27e7cfe6b0bd856f$export$406e97c329f0f3d4) {
        const a = o + $27e7cfe6b0bd856f$var$dn, u = a + $27e7cfe6b0bd856f$var$re, l = n.slice(o, a), f = n.slice(a, u), h = n.slice(u);
        return {
            type: r,
            sealed: h,
            iv: f,
            senderPublicKey: l
        };
    }
    if ($27e7cfe6b0bd856f$export$7547a514ee29b9d4(r) === $27e7cfe6b0bd856f$export$d79eac6ee921504f) {
        const a = n.slice(o), u = $27e7cfe6b0bd856f$var$$t($27e7cfe6b0bd856f$var$re);
        return {
            type: r,
            sealed: a,
            iv: u
        };
    }
    const i = o + $27e7cfe6b0bd856f$var$re, s = n.slice(o, i), c = n.slice(i);
    return {
        type: r,
        sealed: c,
        iv: s
    };
}
function $27e7cfe6b0bd856f$export$177f3e316562333d(t, e) {
    const n = $27e7cfe6b0bd856f$export$efcd34ab6248d3cd({
        encoded: t,
        encoding: e?.encoding
    });
    return $27e7cfe6b0bd856f$export$7949f60f2444aef2({
        type: $27e7cfe6b0bd856f$export$7547a514ee29b9d4(n.type),
        senderPublicKey: typeof n.senderPublicKey < "u" ? (0, $iH58P.toString)(n.senderPublicKey, $27e7cfe6b0bd856f$export$49eb910ab2518105) : void 0,
        receiverPublicKey: e?.receiverPublicKey
    });
}
function $27e7cfe6b0bd856f$export$7949f60f2444aef2(t) {
    const e = t?.type || $27e7cfe6b0bd856f$export$3425bd336a9673d8;
    if (e === $27e7cfe6b0bd856f$export$406e97c329f0f3d4) {
        if (typeof t?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof t?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: e,
        senderPublicKey: t?.senderPublicKey,
        receiverPublicKey: t?.receiverPublicKey
    };
}
function $27e7cfe6b0bd856f$export$8c165704db2d5c15(t) {
    return t.type === $27e7cfe6b0bd856f$export$406e97c329f0f3d4 && typeof t.senderPublicKey == "string" && typeof t.receiverPublicKey == "string";
}
function $27e7cfe6b0bd856f$export$599538f59a4a14c3(t) {
    return t.type === $27e7cfe6b0bd856f$export$d79eac6ee921504f;
}
function $27e7cfe6b0bd856f$export$63aed4db4cd72ee8(t) {
    const e = $27e7cfe6b0bd856f$require$Buffer.from(t.x, "base64"), n = $27e7cfe6b0bd856f$require$Buffer.from(t.y, "base64");
    return (0, $g976M.concat)([
        new Uint8Array([
            4
        ]),
        e,
        n
    ]);
}
function $27e7cfe6b0bd856f$export$f65520390041ee33(t, e) {
    const [n, r, o] = t.split("."), i = $27e7cfe6b0bd856f$require$Buffer.from($27e7cfe6b0bd856f$var$ro(o), "base64");
    if (i.length !== 64) throw new Error("Invalid signature length");
    const s = i.slice(0, 32), c = i.slice(32, 64), a = `${n}.${r}`, u = $27e7cfe6b0bd856f$var$Jt(a), l = $27e7cfe6b0bd856f$export$63aed4db4cd72ee8(e);
    if (!$27e7cfe6b0bd856f$var$_c.verify((0, $g976M.concat)([
        s,
        c
    ]), u, l)) throw new Error("Invalid signature");
    return (0, $aKPeb.decodeJWT)(t).payload;
}
const $27e7cfe6b0bd856f$export$822d0bd1635d5360 = "irn";
function $27e7cfe6b0bd856f$export$cf77af25151525db(t) {
    return t?.relay || {
        protocol: $27e7cfe6b0bd856f$export$822d0bd1635d5360
    };
}
function $27e7cfe6b0bd856f$export$604e3deb95e1b734(t) {
    const e = (0, $lfcmX.RELAY_JSONRPC)[t];
    if (typeof e > "u") throw new Error(`Relay Protocol not supported: ${t}`);
    return e;
}
function $27e7cfe6b0bd856f$export$3d24f408c2ac468a(t, e = "-") {
    const n = {}, r = "relay" + e;
    return Object.keys(t).forEach((o)=>{
        if (o.startsWith(r)) {
            const i = o.replace(r, ""), s = t[o];
            n[i] = s;
        }
    }), n;
}
function $27e7cfe6b0bd856f$export$59f58847421cfb28(t) {
    if (!t.includes("wc:")) {
        const u = $27e7cfe6b0bd856f$export$c537b38001c583b7(t);
        u != null && u.includes("wc:") && (t = u);
    }
    t = t.includes("wc://") ? t.replace("wc://", "") : t, t = t.includes("wc:") ? t.replace("wc:", "") : t;
    const e = t.indexOf(":"), n = t.indexOf("?") !== -1 ? t.indexOf("?") : void 0, r = t.substring(0, e), o = t.substring(e + 1, n).split("@"), i = typeof n < "u" ? t.substring(n) : "", s = new URLSearchParams(i), c = {};
    s.forEach((u, l)=>{
        c[l] = u;
    });
    const a = typeof c.methods == "string" ? c.methods.split(",") : void 0;
    return {
        protocol: r,
        topic: $27e7cfe6b0bd856f$export$5ddc9ebef1d00f28(o[0]),
        version: parseInt(o[1], 10),
        symKey: c.symKey,
        relay: $27e7cfe6b0bd856f$export$3d24f408c2ac468a(c),
        methods: a,
        expiryTimestamp: c.expiryTimestamp ? parseInt(c.expiryTimestamp, 10) : void 0
    };
}
function $27e7cfe6b0bd856f$export$5ddc9ebef1d00f28(t) {
    return t.startsWith("//") ? t.substring(2) : t;
}
function $27e7cfe6b0bd856f$export$65c55c7ccd19bb8f(t, e = "-") {
    const n = "relay", r = {};
    return Object.keys(t).forEach((o)=>{
        const i = o, s = n + e + i;
        t[i] && (r[s] = t[i]);
    }), r;
}
function $27e7cfe6b0bd856f$export$b2786ede34fb2350(t) {
    const e = new URLSearchParams, n = $27e7cfe6b0bd856f$export$65c55c7ccd19bb8f(t.relay);
    Object.keys(n).sort().forEach((o)=>{
        e.set(o, n[o]);
    }), e.set("symKey", t.symKey), t.expiryTimestamp && e.set("expiryTimestamp", t.expiryTimestamp.toString()), t.methods && e.set("methods", t.methods.join(","));
    const r = e.toString();
    return `${t.protocol}:${t.topic}@${t.version}?${r}`;
}
function $27e7cfe6b0bd856f$export$556cb6cc912028c2(t, e, n) {
    return `${t}?wc_ev=${n}&topic=${e}`;
}
var $27e7cfe6b0bd856f$var$Jc = Object.defineProperty, $27e7cfe6b0bd856f$var$Qc = Object.defineProperties, $27e7cfe6b0bd856f$var$ta = Object.getOwnPropertyDescriptors, $27e7cfe6b0bd856f$var$fo = Object.getOwnPropertySymbols, $27e7cfe6b0bd856f$var$ea = Object.prototype.hasOwnProperty, $27e7cfe6b0bd856f$var$na = Object.prototype.propertyIsEnumerable, $27e7cfe6b0bd856f$var$lo = (t, e, n)=>e in t ? $27e7cfe6b0bd856f$var$Jc(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n, $27e7cfe6b0bd856f$var$ra = (t, e)=>{
    for(var n in e || (e = {}))$27e7cfe6b0bd856f$var$ea.call(e, n) && $27e7cfe6b0bd856f$var$lo(t, n, e[n]);
    if ($27e7cfe6b0bd856f$var$fo) for (var n of $27e7cfe6b0bd856f$var$fo(e))$27e7cfe6b0bd856f$var$na.call(e, n) && $27e7cfe6b0bd856f$var$lo(t, n, e[n]);
    return t;
}, $27e7cfe6b0bd856f$var$oa = (t, e)=>$27e7cfe6b0bd856f$var$Qc(t, $27e7cfe6b0bd856f$var$ta(e));
function $27e7cfe6b0bd856f$export$d46695d9c3664fe9(t) {
    const e = [];
    return t.forEach((n)=>{
        const [r, o] = n.split(":");
        e.push(`${r}:${o}`);
    }), e;
}
function $27e7cfe6b0bd856f$export$fb6db6038e742b14(t) {
    const e = [];
    return Object.values(t).forEach((n)=>{
        e.push(...$27e7cfe6b0bd856f$export$d46695d9c3664fe9(n.accounts));
    }), e;
}
function $27e7cfe6b0bd856f$export$7dcf4808e17b15ac(t, e) {
    const n = [];
    return Object.values(t).forEach((r)=>{
        $27e7cfe6b0bd856f$export$d46695d9c3664fe9(r.accounts).includes(e) && n.push(...r.methods);
    }), n;
}
function $27e7cfe6b0bd856f$export$94ee6d00e384a22(t, e) {
    const n = [];
    return Object.values(t).forEach((r)=>{
        $27e7cfe6b0bd856f$export$d46695d9c3664fe9(r.accounts).includes(e) && n.push(...r.events);
    }), n;
}
function $27e7cfe6b0bd856f$export$a8daa26a7c60ef90(t, e) {
    const n = $27e7cfe6b0bd856f$export$93f7b81dc815a714(t, e);
    if (n) throw new Error(n.message);
    const r = {};
    for (const [o, i] of Object.entries(t))r[o] = {
        methods: i.methods,
        events: i.events,
        chains: i.accounts.map((s)=>`${s.split(":")[0]}:${s.split(":")[1]}`)
    };
    return r;
}
function $27e7cfe6b0bd856f$export$c0b86bc9b7d9f338(t) {
    const { proposal: { requiredNamespaces: e, optionalNamespaces: n = {} }, supportedNamespaces: r } = t, o = $27e7cfe6b0bd856f$export$2994550cda701c96(e), i = $27e7cfe6b0bd856f$export$2994550cda701c96(n), s = {};
    Object.keys(r).forEach((u)=>{
        const l = r[u].chains, f = r[u].methods, h = r[u].events, y = r[u].accounts;
        l.forEach((E)=>{
            if (!y.some((p)=>p.includes(E))) throw new Error(`No accounts provided for chain ${E} in namespace ${u}`);
        }), s[u] = {
            chains: l,
            methods: f,
            events: h,
            accounts: y
        };
    });
    const c = $27e7cfe6b0bd856f$export$ba5b0a4b585cd1b4(e, s, "approve()");
    if (c) throw new Error(c.message);
    const a = {};
    return !Object.keys(e).length && !Object.keys(n).length ? s : (Object.keys(o).forEach((u)=>{
        const l = r[u].chains.filter((E)=>{
            var p, d;
            return (d = (p = o[u]) == null ? void 0 : p.chains) == null ? void 0 : d.includes(E);
        }), f = r[u].methods.filter((E)=>{
            var p, d;
            return (d = (p = o[u]) == null ? void 0 : p.methods) == null ? void 0 : d.includes(E);
        }), h = r[u].events.filter((E)=>{
            var p, d;
            return (d = (p = o[u]) == null ? void 0 : p.events) == null ? void 0 : d.includes(E);
        }), y = l.map((E)=>r[u].accounts.filter((p)=>p.includes(`${E}:`))).flat();
        a[u] = {
            chains: l,
            methods: f,
            events: h,
            accounts: y
        };
    }), Object.keys(i).forEach((u)=>{
        var l, f, h, y, E, p;
        if (!r[u]) return;
        const d = (f = (l = i[u]) == null ? void 0 : l.chains) == null ? void 0 : f.filter((N)=>r[u].chains.includes(N)), v = r[u].methods.filter((N)=>{
            var $, B;
            return (B = ($ = i[u]) == null ? void 0 : $.methods) == null ? void 0 : B.includes(N);
        }), m = r[u].events.filter((N)=>{
            var $, B;
            return (B = ($ = i[u]) == null ? void 0 : $.events) == null ? void 0 : B.includes(N);
        }), O = d?.map((N)=>r[u].accounts.filter(($)=>$.includes(`${N}:`))).flat();
        a[u] = {
            chains: $27e7cfe6b0bd856f$export$9826fe7ad3921016((h = a[u]) == null ? void 0 : h.chains, d),
            methods: $27e7cfe6b0bd856f$export$9826fe7ad3921016((y = a[u]) == null ? void 0 : y.methods, v),
            events: $27e7cfe6b0bd856f$export$9826fe7ad3921016((E = a[u]) == null ? void 0 : E.events, m),
            accounts: $27e7cfe6b0bd856f$export$9826fe7ad3921016((p = a[u]) == null ? void 0 : p.accounts, O)
        };
    }), a);
}
function $27e7cfe6b0bd856f$export$e03e993df4723bde(t) {
    return t.includes(":");
}
function $27e7cfe6b0bd856f$export$dd404c96fbbb1ff8(t) {
    return $27e7cfe6b0bd856f$export$e03e993df4723bde(t) ? t.split(":")[0] : t;
}
function $27e7cfe6b0bd856f$export$2994550cda701c96(t) {
    var e, n, r;
    const o = {};
    if (!$27e7cfe6b0bd856f$export$16a0268bc22b47b0(t)) return o;
    for (const [i, s] of Object.entries(t)){
        const c = $27e7cfe6b0bd856f$export$e03e993df4723bde(i) ? [
            i
        ] : s.chains, a = s.methods || [], u = s.events || [], l = $27e7cfe6b0bd856f$export$dd404c96fbbb1ff8(i);
        o[l] = $27e7cfe6b0bd856f$var$oa($27e7cfe6b0bd856f$var$ra({}, o[l]), {
            chains: $27e7cfe6b0bd856f$export$9826fe7ad3921016(c, (e = o[l]) == null ? void 0 : e.chains),
            methods: $27e7cfe6b0bd856f$export$9826fe7ad3921016(a, (n = o[l]) == null ? void 0 : n.methods),
            events: $27e7cfe6b0bd856f$export$9826fe7ad3921016(u, (r = o[l]) == null ? void 0 : r.events)
        });
    }
    return o;
}
function $27e7cfe6b0bd856f$export$293459f1cc8d700(t) {
    const e = {};
    return t?.forEach((n)=>{
        var r;
        const [o, i] = n.split(":");
        e[o] || (e[o] = {
            accounts: [],
            chains: [],
            events: [],
            methods: []
        }), e[o].accounts.push(n), (r = e[o].chains) == null || r.push(`${o}:${i}`);
    }), e;
}
function $27e7cfe6b0bd856f$export$b5744b1c39447540(t, e) {
    e = e.map((r)=>r.replace("did:pkh:", ""));
    const n = $27e7cfe6b0bd856f$export$293459f1cc8d700(e);
    for (const [r, o] of Object.entries(n))o.methods ? o.methods = $27e7cfe6b0bd856f$export$9826fe7ad3921016(o.methods, t) : o.methods = t, o.events = [
        "chainChanged",
        "accountsChanged"
    ];
    return n;
}
const $27e7cfe6b0bd856f$export$990de0b632caca05 = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $27e7cfe6b0bd856f$export$77b3faa414a0ce61 = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $27e7cfe6b0bd856f$export$500d4c4a8fafe35(t, e) {
    const { message: n, code: r } = $27e7cfe6b0bd856f$export$77b3faa414a0ce61[t];
    return {
        message: e ? `${n} ${e}` : n,
        code: r
    };
}
function $27e7cfe6b0bd856f$export$8203ef1531c8b5b5(t, e) {
    const { message: n, code: r } = $27e7cfe6b0bd856f$export$990de0b632caca05[t];
    return {
        message: e ? `${n} ${e}` : n,
        code: r
    };
}
function $27e7cfe6b0bd856f$export$41dd3d480aac4a71(t, e) {
    return Array.isArray(t) ? typeof e < "u" && t.length ? t.every(e) : !0 : !1;
}
function $27e7cfe6b0bd856f$export$16a0268bc22b47b0(t) {
    return Object.getPrototypeOf(t) === Object.prototype && Object.keys(t).length;
}
function $27e7cfe6b0bd856f$export$fce6876652108ab(t) {
    return typeof t > "u";
}
function $27e7cfe6b0bd856f$export$ee898ca48ab56c74(t, e) {
    return e && $27e7cfe6b0bd856f$export$fce6876652108ab(t) ? !0 : typeof t == "string" && !!t.trim().length;
}
function $27e7cfe6b0bd856f$export$d6781b696a0576d1(t, e) {
    return e && $27e7cfe6b0bd856f$export$fce6876652108ab(t) ? !0 : typeof t == "number" && !isNaN(t);
}
function $27e7cfe6b0bd856f$export$6fc4971bf8f326a(t, e) {
    const { requiredNamespaces: n } = e, r = Object.keys(t.namespaces), o = Object.keys(n);
    let i = !0;
    return $27e7cfe6b0bd856f$export$1468a49de573f7f9(o, r) ? (r.forEach((s)=>{
        const { accounts: c, methods: a, events: u } = t.namespaces[s], l = $27e7cfe6b0bd856f$export$d46695d9c3664fe9(c), f = n[s];
        (!$27e7cfe6b0bd856f$export$1468a49de573f7f9($27e7cfe6b0bd856f$export$376384387cd15b27(s, f), l) || !$27e7cfe6b0bd856f$export$1468a49de573f7f9(f.methods, a) || !$27e7cfe6b0bd856f$export$1468a49de573f7f9(f.events, u)) && (i = !1);
    }), i) : !1;
}
function $27e7cfe6b0bd856f$export$e544b39f0a22e47a(t) {
    return $27e7cfe6b0bd856f$export$ee898ca48ab56c74(t, !1) && t.includes(":") ? t.split(":").length === 2 : !1;
}
function $27e7cfe6b0bd856f$export$49e4a5b6862e3c71(t) {
    if ($27e7cfe6b0bd856f$export$ee898ca48ab56c74(t, !1) && t.includes(":")) {
        const e = t.split(":");
        if (e.length === 3) {
            const n = e[0] + ":" + e[1];
            return !!e[2] && $27e7cfe6b0bd856f$export$e544b39f0a22e47a(n);
        }
    }
    return !1;
}
function $27e7cfe6b0bd856f$export$bef94a5618bf18bf(t) {
    function e(n) {
        try {
            return typeof new URL(n) < "u";
        } catch  {
            return !1;
        }
    }
    try {
        if ($27e7cfe6b0bd856f$export$ee898ca48ab56c74(t, !1)) {
            if (e(t)) return !0;
            const n = $27e7cfe6b0bd856f$export$c537b38001c583b7(t);
            return e(n);
        }
    } catch  {}
    return !1;
}
function $27e7cfe6b0bd856f$export$f657f7976bb2769d(t) {
    var e;
    return (e = t?.proposer) == null ? void 0 : e.publicKey;
}
function $27e7cfe6b0bd856f$export$c96d5113768aaf5e(t) {
    return t?.topic;
}
function $27e7cfe6b0bd856f$export$5e1c5c89613c213f(t, e) {
    let n = null;
    return $27e7cfe6b0bd856f$export$ee898ca48ab56c74(t?.publicKey, !1) || (n = $27e7cfe6b0bd856f$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${e} controller public key should be a string`)), n;
}
function $27e7cfe6b0bd856f$export$c12fced8176774f3(t) {
    let e = !0;
    return $27e7cfe6b0bd856f$export$41dd3d480aac4a71(t) ? t.length && (e = t.every((n)=>$27e7cfe6b0bd856f$export$ee898ca48ab56c74(n, !1))) : e = !1, e;
}
function $27e7cfe6b0bd856f$export$df46c123d7e298ce(t, e, n) {
    let r = null;
    return $27e7cfe6b0bd856f$export$41dd3d480aac4a71(e) && e.length ? e.forEach((o)=>{
        r || $27e7cfe6b0bd856f$export$e544b39f0a22e47a(o) || (r = $27e7cfe6b0bd856f$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${n}, chain ${o} should be a string and conform to "namespace:chainId" format`));
    }) : $27e7cfe6b0bd856f$export$e544b39f0a22e47a(t) || (r = $27e7cfe6b0bd856f$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${n}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), r;
}
function $27e7cfe6b0bd856f$export$94ae96fb66f29e08(t, e, n) {
    let r = null;
    return Object.entries(t).forEach(([o, i])=>{
        if (r) return;
        const s = $27e7cfe6b0bd856f$export$df46c123d7e298ce(o, $27e7cfe6b0bd856f$export$376384387cd15b27(o, i), `${e} ${n}`);
        s && (r = s);
    }), r;
}
function $27e7cfe6b0bd856f$export$d5644026aaffb9e7(t, e) {
    let n = null;
    return $27e7cfe6b0bd856f$export$41dd3d480aac4a71(t) ? t.forEach((r)=>{
        n || $27e7cfe6b0bd856f$export$49e4a5b6862e3c71(r) || (n = $27e7cfe6b0bd856f$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${e}, account ${r} should be a string and conform to "namespace:chainId:address" format`));
    }) : n = $27e7cfe6b0bd856f$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${e}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), n;
}
function $27e7cfe6b0bd856f$export$2a2012e7bfa1cfb4(t, e) {
    let n = null;
    return Object.values(t).forEach((r)=>{
        if (n) return;
        const o = $27e7cfe6b0bd856f$export$d5644026aaffb9e7(r?.accounts, `${e} namespace`);
        o && (n = o);
    }), n;
}
function $27e7cfe6b0bd856f$export$b32541d63753af56(t, e) {
    let n = null;
    return $27e7cfe6b0bd856f$export$c12fced8176774f3(t?.methods) ? $27e7cfe6b0bd856f$export$c12fced8176774f3(t?.events) || (n = $27e7cfe6b0bd856f$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", `${e}, events should be an array of strings or empty array for no events`)) : n = $27e7cfe6b0bd856f$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", `${e}, methods should be an array of strings or empty array for no methods`), n;
}
function $27e7cfe6b0bd856f$export$27682c78deeca9d7(t, e) {
    let n = null;
    return Object.values(t).forEach((r)=>{
        if (n) return;
        const o = $27e7cfe6b0bd856f$export$b32541d63753af56(r, `${e}, namespace`);
        o && (n = o);
    }), n;
}
function $27e7cfe6b0bd856f$export$9e2b2cae22c6a8b3(t, e, n) {
    let r = null;
    if (t && $27e7cfe6b0bd856f$export$16a0268bc22b47b0(t)) {
        const o = $27e7cfe6b0bd856f$export$27682c78deeca9d7(t, e);
        o && (r = o);
        const i = $27e7cfe6b0bd856f$export$94ae96fb66f29e08(t, e, n);
        i && (r = i);
    } else r = $27e7cfe6b0bd856f$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${e}, ${n} should be an object with data`);
    return r;
}
function $27e7cfe6b0bd856f$export$93f7b81dc815a714(t, e) {
    let n = null;
    if (t && $27e7cfe6b0bd856f$export$16a0268bc22b47b0(t)) {
        const r = $27e7cfe6b0bd856f$export$27682c78deeca9d7(t, e);
        r && (n = r);
        const o = $27e7cfe6b0bd856f$export$2a2012e7bfa1cfb4(t, e);
        o && (n = o);
    } else n = $27e7cfe6b0bd856f$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${e}, namespaces should be an object with data`);
    return n;
}
function $27e7cfe6b0bd856f$export$1b3fc298be8c9a7b(t) {
    return $27e7cfe6b0bd856f$export$ee898ca48ab56c74(t.protocol, !0);
}
function $27e7cfe6b0bd856f$export$6294c30b976bd21e(t, e) {
    let n = !1;
    return e && !t ? n = !0 : t && $27e7cfe6b0bd856f$export$41dd3d480aac4a71(t) && t.length && t.forEach((r)=>{
        n = $27e7cfe6b0bd856f$export$1b3fc298be8c9a7b(r);
    }), n;
}
function $27e7cfe6b0bd856f$export$53551be28ad5e34d(t) {
    return typeof t == "number";
}
function $27e7cfe6b0bd856f$export$b3f5fcca1d210454(t) {
    return typeof t < "u" && true;
}
function $27e7cfe6b0bd856f$export$766fe78377d96f2a(t) {
    return !(!t || typeof t != "object" || !t.code || !$27e7cfe6b0bd856f$export$d6781b696a0576d1(t.code, !1) || !t.message || !$27e7cfe6b0bd856f$export$ee898ca48ab56c74(t.message, !1));
}
function $27e7cfe6b0bd856f$export$1a2af3c017fb6d42(t) {
    return !($27e7cfe6b0bd856f$export$fce6876652108ab(t) || !$27e7cfe6b0bd856f$export$ee898ca48ab56c74(t.method, !1));
}
function $27e7cfe6b0bd856f$export$1ae38cf0a848f651(t) {
    return !($27e7cfe6b0bd856f$export$fce6876652108ab(t) || $27e7cfe6b0bd856f$export$fce6876652108ab(t.result) && $27e7cfe6b0bd856f$export$fce6876652108ab(t.error) || !$27e7cfe6b0bd856f$export$d6781b696a0576d1(t.id, !1) || !$27e7cfe6b0bd856f$export$ee898ca48ab56c74(t.jsonrpc, !1));
}
function $27e7cfe6b0bd856f$export$cbe4cdc5960cfa11(t) {
    return !($27e7cfe6b0bd856f$export$fce6876652108ab(t) || !$27e7cfe6b0bd856f$export$ee898ca48ab56c74(t.name, !1));
}
function $27e7cfe6b0bd856f$export$144fc36610eb6522(t, e) {
    return !(!$27e7cfe6b0bd856f$export$e544b39f0a22e47a(e) || !$27e7cfe6b0bd856f$export$fb6db6038e742b14(t).includes(e));
}
function $27e7cfe6b0bd856f$export$8db4804e3a6de711(t, e, n) {
    return $27e7cfe6b0bd856f$export$ee898ca48ab56c74(n, !1) ? $27e7cfe6b0bd856f$export$7dcf4808e17b15ac(t, e).includes(n) : !1;
}
function $27e7cfe6b0bd856f$export$df2c67ef8baad16b(t, e, n) {
    return $27e7cfe6b0bd856f$export$ee898ca48ab56c74(n, !1) ? $27e7cfe6b0bd856f$export$94ee6d00e384a22(t, e).includes(n) : !1;
}
function $27e7cfe6b0bd856f$export$ba5b0a4b585cd1b4(t, e, n) {
    let r = null;
    const o = $27e7cfe6b0bd856f$var$Oa(t), i = $27e7cfe6b0bd856f$var$Aa(e), s = Object.keys(o), c = Object.keys(i), a = $27e7cfe6b0bd856f$var$Uo(Object.keys(t)), u = $27e7cfe6b0bd856f$var$Uo(Object.keys(e)), l = a.filter((f)=>!u.includes(f));
    return l.length && (r = $27e7cfe6b0bd856f$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${n} namespaces keys don't satisfy requiredNamespaces.
      Required: ${l.toString()}
      Received: ${Object.keys(e).toString()}`)), $27e7cfe6b0bd856f$export$1468a49de573f7f9(s, c) || (r = $27e7cfe6b0bd856f$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${n} namespaces chains don't satisfy required namespaces.
      Required: ${s.toString()}
      Approved: ${c.toString()}`)), Object.keys(e).forEach((f)=>{
        if (!f.includes(":") || r) return;
        const h = $27e7cfe6b0bd856f$export$d46695d9c3664fe9(e[f].accounts);
        h.includes(f) || (r = $27e7cfe6b0bd856f$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${n} namespaces accounts don't satisfy namespace accounts for ${f}
        Required: ${f}
        Approved: ${h.toString()}`));
    }), s.forEach((f)=>{
        r || ($27e7cfe6b0bd856f$export$1468a49de573f7f9(o[f].methods, i[f].methods) ? $27e7cfe6b0bd856f$export$1468a49de573f7f9(o[f].events, i[f].events) || (r = $27e7cfe6b0bd856f$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${n} namespaces events don't satisfy namespace events for ${f}`)) : r = $27e7cfe6b0bd856f$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${n} namespaces methods don't satisfy namespace methods for ${f}`));
    }), r;
}
function $27e7cfe6b0bd856f$var$Oa(t) {
    const e = {};
    return Object.keys(t).forEach((n)=>{
        var r;
        n.includes(":") ? e[n] = t[n] : (r = t[n].chains) == null || r.forEach((o)=>{
            e[o] = {
                methods: t[n].methods,
                events: t[n].events
            };
        });
    }), e;
}
function $27e7cfe6b0bd856f$var$Uo(t) {
    return [
        ...new Set(t.map((e)=>e.includes(":") ? e.split(":")[0] : e))
    ];
}
function $27e7cfe6b0bd856f$var$Aa(t) {
    const e = {};
    return Object.keys(t).forEach((n)=>{
        if (n.includes(":")) e[n] = t[n];
        else {
            const r = $27e7cfe6b0bd856f$export$d46695d9c3664fe9(t[n].accounts);
            r?.forEach((o)=>{
                e[o] = {
                    accounts: t[n].accounts.filter((i)=>i.includes(`${o}:`)),
                    methods: t[n].methods,
                    events: t[n].events
                };
            });
        }
    }), e;
}
function $27e7cfe6b0bd856f$export$59fba2af1ac782b(t, e) {
    return $27e7cfe6b0bd856f$export$d6781b696a0576d1(t, !1) && t <= e.max && t >= e.min;
}
function $27e7cfe6b0bd856f$export$53c2fd0173ad2b80() {
    const t = $27e7cfe6b0bd856f$export$57570b1603cf6adb();
    return new Promise((e)=>{
        switch(t){
            case $27e7cfe6b0bd856f$export$86b1301a63b15dd9.browser:
                e($27e7cfe6b0bd856f$export$2f147c609a999e49());
                break;
            case $27e7cfe6b0bd856f$export$86b1301a63b15dd9.reactNative:
                e($27e7cfe6b0bd856f$export$1444c95b1570bd12());
                break;
            case $27e7cfe6b0bd856f$export$86b1301a63b15dd9.node:
                e($27e7cfe6b0bd856f$export$aec5b2d627eec500());
                break;
            default:
                e(!0);
        }
    });
}
function $27e7cfe6b0bd856f$export$2f147c609a999e49() {
    return $27e7cfe6b0bd856f$export$4e09c449d6c407f7() && navigator?.onLine;
}
async function $27e7cfe6b0bd856f$export$1444c95b1570bd12() {
    if ($27e7cfe6b0bd856f$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo) {
        const t = await ($parcel$global == null ? void 0 : $parcel$global.NetInfo.fetch());
        return t?.isConnected;
    }
    return !0;
}
function $27e7cfe6b0bd856f$export$aec5b2d627eec500() {
    return !0;
}
function $27e7cfe6b0bd856f$export$600a1ee4bc680996(t) {
    switch($27e7cfe6b0bd856f$export$57570b1603cf6adb()){
        case $27e7cfe6b0bd856f$export$86b1301a63b15dd9.browser:
            $27e7cfe6b0bd856f$export$d32b24f18d96c5f2(t);
            break;
        case $27e7cfe6b0bd856f$export$86b1301a63b15dd9.reactNative:
            $27e7cfe6b0bd856f$export$904edb1c18ec91c7(t);
            break;
        case $27e7cfe6b0bd856f$export$86b1301a63b15dd9.node:
            break;
    }
}
function $27e7cfe6b0bd856f$export$d32b24f18d96c5f2(t) {
    !$27e7cfe6b0bd856f$export$f7a1e23e542d38e3() && $27e7cfe6b0bd856f$export$4e09c449d6c407f7() && (window.addEventListener("online", ()=>t(!0)), window.addEventListener("offline", ()=>t(!1)));
}
function $27e7cfe6b0bd856f$export$904edb1c18ec91c7(t) {
    $27e7cfe6b0bd856f$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo && $parcel$global?.NetInfo.addEventListener((e)=>t(e?.isConnected));
}
const $27e7cfe6b0bd856f$var$bn = {};
class $27e7cfe6b0bd856f$export$b72d712fed4d036d {
    static get(e) {
        return $27e7cfe6b0bd856f$var$bn[e];
    }
    static set(e, n) {
        $27e7cfe6b0bd856f$var$bn[e] = n;
    }
    static delete(e) {
        delete $27e7cfe6b0bd856f$var$bn[e];
    }
}

});
parcelRegister("dd6tE", function(module, exports) {

$parcel$export(module.exports, "detect", () => $99e1837ddcfb2a50$export$17b446b869dad473);

var $kuzpm = parcelRequire("kuzpm");
var $99e1837ddcfb2a50$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $99e1837ddcfb2a50$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var $99e1837ddcfb2a50$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = $kuzpm.platform;
    }
    return NodeInfo;
}();
var $99e1837ddcfb2a50$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var $99e1837ddcfb2a50$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $99e1837ddcfb2a50$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $99e1837ddcfb2a50$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $99e1837ddcfb2a50$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $99e1837ddcfb2a50$var$REQUIRED_VERSION_PARTS = 3;
var $99e1837ddcfb2a50$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $99e1837ddcfb2a50$var$SEARCHBOX_UA_REGEX
    ]
];
var $99e1837ddcfb2a50$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Windows CE",
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function $99e1837ddcfb2a50$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $99e1837ddcfb2a50$export$1184956100eddc3c(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new $99e1837ddcfb2a50$export$7c78fe95a9d9b03e();
    if (typeof navigator !== "undefined") return $99e1837ddcfb2a50$export$1184956100eddc3c(navigator.userAgent);
    return $99e1837ddcfb2a50$export$bf2c6630ab904918();
}
function $99e1837ddcfb2a50$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && $99e1837ddcfb2a50$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $99e1837ddcfb2a50$export$89ca9f8ca1a50fd5(ua) {
    var data = $99e1837ddcfb2a50$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $99e1837ddcfb2a50$export$1184956100eddc3c(ua) {
    var matchedRule = $99e1837ddcfb2a50$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $99e1837ddcfb2a50$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split(".").join("_").split("_").slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $99e1837ddcfb2a50$var$REQUIRED_VERSION_PARTS) versionParts = $99e1837ddcfb2a50$var$__spreadArray($99e1837ddcfb2a50$var$__spreadArray([], versionParts, true), $99e1837ddcfb2a50$var$createVersionParts($99e1837ddcfb2a50$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = $99e1837ddcfb2a50$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $99e1837ddcfb2a50$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $99e1837ddcfb2a50$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $99e1837ddcfb2a50$export$8fa985da04a86f0(name, version, os);
}
function $99e1837ddcfb2a50$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $99e1837ddcfb2a50$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $99e1837ddcfb2a50$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $99e1837ddcfb2a50$export$bf2c6630ab904918() {
    var isNode = typeof $kuzpm !== "undefined" && $kuzpm.version;
    return isNode ? new $99e1837ddcfb2a50$export$62457c674e0167c0($kuzpm.version.slice(1)) : null;
}
function $99e1837ddcfb2a50$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}

});

parcelRegister("bfa86", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLocalStorage = module.exports.getLocalStorageOrThrow = module.exports.getCrypto = module.exports.getCryptoOrThrow = module.exports.getLocation = module.exports.getLocationOrThrow = module.exports.getNavigator = module.exports.getNavigatorOrThrow = module.exports.getDocument = module.exports.getDocumentOrThrow = module.exports.getFromWindowOrThrow = module.exports.getFromWindow = void 0;
function $82f8f3fae86c63c4$var$getFromWindow(name) {
    let res = undefined;
    if (typeof window !== "undefined" && typeof window[name] !== "undefined") res = window[name];
    return res;
}
module.exports.getFromWindow = $82f8f3fae86c63c4$var$getFromWindow;
function $82f8f3fae86c63c4$var$getFromWindowOrThrow(name) {
    const res = $82f8f3fae86c63c4$var$getFromWindow(name);
    if (!res) throw new Error(`${name} is not defined in Window`);
    return res;
}
module.exports.getFromWindowOrThrow = $82f8f3fae86c63c4$var$getFromWindowOrThrow;
function $82f8f3fae86c63c4$var$getDocumentOrThrow() {
    return $82f8f3fae86c63c4$var$getFromWindowOrThrow("document");
}
module.exports.getDocumentOrThrow = $82f8f3fae86c63c4$var$getDocumentOrThrow;
function $82f8f3fae86c63c4$var$getDocument() {
    return $82f8f3fae86c63c4$var$getFromWindow("document");
}
module.exports.getDocument = $82f8f3fae86c63c4$var$getDocument;
function $82f8f3fae86c63c4$var$getNavigatorOrThrow() {
    return $82f8f3fae86c63c4$var$getFromWindowOrThrow("navigator");
}
module.exports.getNavigatorOrThrow = $82f8f3fae86c63c4$var$getNavigatorOrThrow;
function $82f8f3fae86c63c4$var$getNavigator() {
    return $82f8f3fae86c63c4$var$getFromWindow("navigator");
}
module.exports.getNavigator = $82f8f3fae86c63c4$var$getNavigator;
function $82f8f3fae86c63c4$var$getLocationOrThrow() {
    return $82f8f3fae86c63c4$var$getFromWindowOrThrow("location");
}
module.exports.getLocationOrThrow = $82f8f3fae86c63c4$var$getLocationOrThrow;
function $82f8f3fae86c63c4$var$getLocation() {
    return $82f8f3fae86c63c4$var$getFromWindow("location");
}
module.exports.getLocation = $82f8f3fae86c63c4$var$getLocation;
function $82f8f3fae86c63c4$var$getCryptoOrThrow() {
    return $82f8f3fae86c63c4$var$getFromWindowOrThrow("crypto");
}
module.exports.getCryptoOrThrow = $82f8f3fae86c63c4$var$getCryptoOrThrow;
function $82f8f3fae86c63c4$var$getCrypto() {
    return $82f8f3fae86c63c4$var$getFromWindow("crypto");
}
module.exports.getCrypto = $82f8f3fae86c63c4$var$getCrypto;
function $82f8f3fae86c63c4$var$getLocalStorageOrThrow() {
    return $82f8f3fae86c63c4$var$getFromWindowOrThrow("localStorage");
}
module.exports.getLocalStorageOrThrow = $82f8f3fae86c63c4$var$getLocalStorageOrThrow;
function $82f8f3fae86c63c4$var$getLocalStorage() {
    return $82f8f3fae86c63c4$var$getFromWindow("localStorage");
}
module.exports.getLocalStorage = $82f8f3fae86c63c4$var$getLocalStorage;

});

parcelRegister("5giLd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getWindowMetadata = void 0;

var $bfa86 = parcelRequire("bfa86");
function $3d4cffd383ede128$var$getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = $bfa86.getDocumentOrThrow();
        loc = $bfa86.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
module.exports.getWindowMetadata = $3d4cffd383ede128$var$getWindowMetadata;

});

parcelRegister("1DO4H", function(module, exports) {

$parcel$export(module.exports, "recoverAddress", () => $132046c59382e253$export$23cc18f96d8510e2);

var $3Pn5I = parcelRequire("3Pn5I");

var $bqq1O = parcelRequire("bqq1O");
async function $132046c59382e253$export$23cc18f96d8510e2({ hash: hash, signature: signature }) {
    return (0, $3Pn5I.publicKeyToAddress)(await (0, $bqq1O.recoverPublicKey)({
        hash: hash,
        signature: signature
    }));
}

});
parcelRegister("3Pn5I", function(module, exports) {

$parcel$export(module.exports, "publicKeyToAddress", () => $2c980bedd36a193d$export$462669520a9d12d1);

var $aNqkJ = parcelRequire("aNqkJ");

var $6vND0 = parcelRequire("6vND0");
function $2c980bedd36a193d$export$462669520a9d12d1(publicKey) {
    const address = (0, $6vND0.keccak256)(`0x${publicKey.substring(4)}`).substring(26);
    return (0, $aNqkJ.checksumAddress)(`0x${address}`);
}

});
parcelRegister("aNqkJ", function(module, exports) {

$parcel$export(module.exports, "checksumAddress", () => $7dc2e83e1a403ada$export$9ff46e8f6df13548);

var $3I1WV = parcelRequire("3I1WV");

var $9Zghv = parcelRequire("9Zghv");

var $6vND0 = parcelRequire("6vND0");

var $cGVhd = parcelRequire("cGVhd");

var $5aIaC = parcelRequire("5aIaC");
const $7dc2e83e1a403ada$var$checksumAddressCache = /*#__PURE__*/ new (0, $cGVhd.LruMap)(8192);
function $7dc2e83e1a403ada$export$9ff46e8f6df13548(address_, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if ($7dc2e83e1a403ada$var$checksumAddressCache.has(`${address_}.${chainId}`)) return $7dc2e83e1a403ada$var$checksumAddressCache.get(`${address_}.${chainId}`);
    const hexAddress = chainId ? `${chainId}${address_.toLowerCase()}` : address_.substring(2).toLowerCase();
    const hash = (0, $6vND0.keccak256)((0, $9Zghv.stringToBytes)(hexAddress), "bytes");
    const address = (chainId ? hexAddress.substring(`${chainId}0x`.length) : hexAddress).split("");
    for(let i = 0; i < 40; i += 2){
        if (hash[i >> 1] >> 4 >= 8 && address[i]) address[i] = address[i].toUpperCase();
        if ((hash[i >> 1] & 0x0f) >= 8 && address[i + 1]) address[i + 1] = address[i + 1].toUpperCase();
    }
    const result = `0x${address.join("")}`;
    $7dc2e83e1a403ada$var$checksumAddressCache.set(`${address_}.${chainId}`, result);
    return result;
}
function $7dc2e83e1a403ada$export$88411125f012957a(address, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if (!(0, $5aIaC.isAddress)(address, {
        strict: false
    })) throw new (0, $3I1WV.InvalidAddressError)({
        address: address
    });
    return $7dc2e83e1a403ada$export$9ff46e8f6df13548(address, chainId);
}

});
parcelRegister("3I1WV", function(module, exports) {

$parcel$export(module.exports, "InvalidAddressError", () => $2b36fe4a216d2ce0$export$66c44d927ffead98);

var $6Q4jv = parcelRequire("6Q4jv");
class $2b36fe4a216d2ce0$export$66c44d927ffead98 extends (0, $6Q4jv.BaseError) {
    constructor({ address: address }){
        super(`Address "${address}" is invalid.`, {
            metaMessages: [
                "- Address must be a hex value of 20 bytes (40 hex characters).",
                "- Address must match its checksum counterpart."
            ],
            name: "InvalidAddressError"
        });
    }
}

});
parcelRegister("6Q4jv", function(module, exports) {

$parcel$export(module.exports, "BaseError", () => $4faaf2036ff21322$export$a490eb03cb7a0a5e);

var $95Hak = parcelRequire("95Hak");
let $4faaf2036ff21322$var$errorConfig = {
    getDocsUrl: ({ docsBaseUrl: docsBaseUrl, docsPath: docsPath = "", docsSlug: docsSlug })=>docsPath ? `${docsBaseUrl ?? "https://viem.sh"}${docsPath}${docsSlug ? `#${docsSlug}` : ""}` : undefined,
    version: `viem@${(0, $95Hak.version)}`
};
function $4faaf2036ff21322$export$4ac109df0c5244e9(config) {
    $4faaf2036ff21322$var$errorConfig = config;
}
class $4faaf2036ff21322$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        const details = (()=>{
            if (args.cause instanceof $4faaf2036ff21322$export$a490eb03cb7a0a5e) return args.cause.details;
            if (args.cause?.message) return args.cause.message;
            return args.details;
        })();
        const docsPath = (()=>{
            if (args.cause instanceof $4faaf2036ff21322$export$a490eb03cb7a0a5e) return args.cause.docsPath || args.docsPath;
            return args.docsPath;
        })();
        const docsUrl = $4faaf2036ff21322$var$errorConfig.getDocsUrl?.({
            ...args,
            docsPath: docsPath
        });
        const message = [
            shortMessage || "An error occurred.",
            "",
            ...args.metaMessages ? [
                ...args.metaMessages,
                ""
            ] : [],
            ...docsUrl ? [
                `Docs: ${docsUrl}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            ...$4faaf2036ff21322$var$errorConfig.version ? [
                `Version: ${$4faaf2036ff21322$var$errorConfig.version}`
            ] : []
        ].join("\n");
        super(message, args.cause ? {
            cause: args.cause
        } : undefined);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BaseError"
        });
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.name = args.name ?? this.name;
        this.shortMessage = shortMessage;
        this.version = (0, $95Hak.version);
    }
    walk(fn) {
        return $4faaf2036ff21322$var$walk(this, fn);
    }
}
function $4faaf2036ff21322$var$walk(err, fn) {
    if (fn?.(err)) return err;
    if (err && typeof err === "object" && "cause" in err && err.cause !== undefined) return $4faaf2036ff21322$var$walk(err.cause, fn);
    return fn ? null : err;
}

});
parcelRegister("95Hak", function(module, exports) {

$parcel$export(module.exports, "version", () => $69e6107c966cb799$export$83d89fbfd8236492);
const $69e6107c966cb799$export$83d89fbfd8236492 = "2.23.2";

});



parcelRegister("9Zghv", function(module, exports) {

$parcel$export(module.exports, "toBytes", () => $745670af2cee689b$export$30a71edf0753ed6b);
$parcel$export(module.exports, "hexToBytes", () => $745670af2cee689b$export$31c96b9df38bc8d4);
$parcel$export(module.exports, "stringToBytes", () => $745670af2cee689b$export$c8dd6bc66a63753c);

var $6Q4jv = parcelRequire("6Q4jv");

var $iWj0F = parcelRequire("iWj0F");

var $96ksv = parcelRequire("96ksv");

var $lmQAI = parcelRequire("lmQAI");

var $i5PVa = parcelRequire("i5PVa");
const $745670af2cee689b$var$encoder = /*#__PURE__*/ new TextEncoder();
function $745670af2cee689b$export$30a71edf0753ed6b(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $745670af2cee689b$export$49ad9be85c347998(value, opts);
    if (typeof value === "boolean") return $745670af2cee689b$export$771517697a68241(value, opts);
    if ((0, $iWj0F.isHex)(value)) return $745670af2cee689b$export$31c96b9df38bc8d4(value, opts);
    return $745670af2cee689b$export$c8dd6bc66a63753c(value, opts);
}
function $745670af2cee689b$export$771517697a68241(value, opts = {}) {
    const bytes = new Uint8Array(1);
    bytes[0] = Number(value);
    if (typeof opts.size === "number") {
        (0, $lmQAI.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $96ksv.pad)(bytes, {
            size: opts.size
        });
    }
    return bytes;
}
// We use very optimized technique to convert hex string to byte array
const $745670af2cee689b$var$charCodeMap = {
    zero: 48,
    nine: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $745670af2cee689b$var$charCodeToBase16(char) {
    if (char >= $745670af2cee689b$var$charCodeMap.zero && char <= $745670af2cee689b$var$charCodeMap.nine) return char - $745670af2cee689b$var$charCodeMap.zero;
    if (char >= $745670af2cee689b$var$charCodeMap.A && char <= $745670af2cee689b$var$charCodeMap.F) return char - ($745670af2cee689b$var$charCodeMap.A - 10);
    if (char >= $745670af2cee689b$var$charCodeMap.a && char <= $745670af2cee689b$var$charCodeMap.f) return char - ($745670af2cee689b$var$charCodeMap.a - 10);
    return undefined;
}
function $745670af2cee689b$export$31c96b9df38bc8d4(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        (0, $lmQAI.assertSize)(hex, {
            size: opts.size
        });
        hex = (0, $96ksv.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    let hexString = hex.slice(2);
    if (hexString.length % 2) hexString = `0${hexString}`;
    const length = hexString.length / 2;
    const bytes = new Uint8Array(length);
    for(let index = 0, j = 0; index < length; index++){
        const nibbleLeft = $745670af2cee689b$var$charCodeToBase16(hexString.charCodeAt(j++));
        const nibbleRight = $745670af2cee689b$var$charCodeToBase16(hexString.charCodeAt(j++));
        if (nibbleLeft === undefined || nibbleRight === undefined) throw new (0, $6Q4jv.BaseError)(`Invalid byte sequence ("${hexString[j - 2]}${hexString[j - 1]}" in "${hexString}").`);
        bytes[index] = nibbleLeft * 16 + nibbleRight;
    }
    return bytes;
}
function $745670af2cee689b$export$49ad9be85c347998(value, opts) {
    const hex = (0, $i5PVa.numberToHex)(value, opts);
    return $745670af2cee689b$export$31c96b9df38bc8d4(hex);
}
function $745670af2cee689b$export$c8dd6bc66a63753c(value, opts = {}) {
    const bytes = $745670af2cee689b$var$encoder.encode(value);
    if (typeof opts.size === "number") {
        (0, $lmQAI.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $96ksv.pad)(bytes, {
            dir: "right",
            size: opts.size
        });
    }
    return bytes;
}

});
parcelRegister("iWj0F", function(module, exports) {

$parcel$export(module.exports, "isHex", () => $dc9c63b51b92de34$export$8a9b6341a7c96bc);
function $dc9c63b51b92de34$export$8a9b6341a7c96bc(value, { strict: strict = true } = {}) {
    if (!value) return false;
    if (typeof value !== "string") return false;
    return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith("0x");
}

});

parcelRegister("96ksv", function(module, exports) {

$parcel$export(module.exports, "pad", () => $6a048b468500dfb7$export$5d04458e2a6c373e);

var $5MJkg = parcelRequire("5MJkg");
function $6a048b468500dfb7$export$5d04458e2a6c373e(hexOrBytes, { dir: dir, size: size = 32 } = {}) {
    if (typeof hexOrBytes === "string") return $6a048b468500dfb7$export$1bcd51c0fce8ee55(hexOrBytes, {
        dir: dir,
        size: size
    });
    return $6a048b468500dfb7$export$4c6b868113605df3(hexOrBytes, {
        dir: dir,
        size: size
    });
}
function $6a048b468500dfb7$export$1bcd51c0fce8ee55(hex_, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return hex_;
    const hex = hex_.replace("0x", "");
    if (hex.length > size * 2) throw new (0, $5MJkg.SizeExceedsPaddingSizeError)({
        size: Math.ceil(hex.length / 2),
        targetSize: size,
        type: "hex"
    });
    return `0x${hex[dir === "right" ? "padEnd" : "padStart"](size * 2, "0")}`;
}
function $6a048b468500dfb7$export$4c6b868113605df3(bytes, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return bytes;
    if (bytes.length > size) throw new (0, $5MJkg.SizeExceedsPaddingSizeError)({
        size: bytes.length,
        targetSize: size,
        type: "bytes"
    });
    const paddedBytes = new Uint8Array(size);
    for(let i = 0; i < size; i++){
        const padEnd = dir === "right";
        paddedBytes[padEnd ? i : size - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
    }
    return paddedBytes;
}

});
parcelRegister("5MJkg", function(module, exports) {

$parcel$export(module.exports, "SizeExceedsPaddingSizeError", () => $4364983995a6f114$export$70445dc308a7f3d5);

var $6Q4jv = parcelRequire("6Q4jv");
class $4364983995a6f114$export$cfcd41bba8b36dbd extends (0, $6Q4jv.BaseError) {
    constructor({ offset: offset, position: position, size: size }){
        super(`Slice ${position === "start" ? "starting" : "ending"} at offset "${offset}" is out-of-bounds (size: ${size}).`, {
            name: "SliceOffsetOutOfBoundsError"
        });
    }
}
class $4364983995a6f114$export$70445dc308a7f3d5 extends (0, $6Q4jv.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (${size}) exceeds padding size (${targetSize}).`, {
            name: "SizeExceedsPaddingSizeError"
        });
    }
}
class $4364983995a6f114$export$8a5469becf223114 extends (0, $6Q4jv.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} is expected to be ${targetSize} ${type} long, but is ${size} ${type} long.`, {
            name: "InvalidBytesLengthError"
        });
    }
}

});


parcelRegister("lmQAI", function(module, exports) {

$parcel$export(module.exports, "assertSize", () => $f8e4729606a3b35f$export$2af489edb7fa35fe);
$parcel$export(module.exports, "hexToNumber", () => $f8e4729606a3b35f$export$d57f2bacc26b4249);
$parcel$export(module.exports, "hexToBigInt", () => $f8e4729606a3b35f$export$92a44656ec81b584);

var $95QDg = parcelRequire("95QDg");

var $54SKZ = parcelRequire("54SKZ");

var $aN7Sp = parcelRequire("aN7Sp");

var $9Zghv = parcelRequire("9Zghv");
function $f8e4729606a3b35f$export$2af489edb7fa35fe(hexOrBytes, { size: size }) {
    if ((0, $54SKZ.size)(hexOrBytes) > size) throw new (0, $95QDg.SizeOverflowError)({
        givenSize: (0, $54SKZ.size)(hexOrBytes),
        maxSize: size
    });
}
function $f8e4729606a3b35f$export$1a8ceedbd5845648(hex, toOrOpts) {
    const opts = typeof toOrOpts === "string" ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === "number") return $f8e4729606a3b35f$export$d57f2bacc26b4249(hex, opts);
    if (to === "bigint") return $f8e4729606a3b35f$export$92a44656ec81b584(hex, opts);
    if (to === "string") return $f8e4729606a3b35f$export$f4bc7e46f3eb3ac3(hex, opts);
    if (to === "boolean") return $f8e4729606a3b35f$export$bde1d77e6fe6c41e(hex, opts);
    return (0, $9Zghv.hexToBytes)(hex, opts);
}
function $f8e4729606a3b35f$export$92a44656ec81b584(hex, opts = {}) {
    const { signed: signed } = opts;
    if (opts.size) $f8e4729606a3b35f$export$2af489edb7fa35fe(hex, {
        size: opts.size
    });
    const value = BigInt(hex);
    if (!signed) return value;
    const size = (hex.length - 2) / 2;
    const max = (1n << BigInt(size) * 8n - 1n) - 1n;
    if (value <= max) return value;
    return value - BigInt(`0x${"f".padStart(size * 2, "f")}`) - 1n;
}
function $f8e4729606a3b35f$export$bde1d77e6fe6c41e(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        $f8e4729606a3b35f$export$2af489edb7fa35fe(hex, {
            size: opts.size
        });
        hex = (0, $aN7Sp.trim)(hex);
    }
    if ((0, $aN7Sp.trim)(hex) === "0x00") return false;
    if ((0, $aN7Sp.trim)(hex) === "0x01") return true;
    throw new (0, $95QDg.InvalidHexBooleanError)(hex);
}
function $f8e4729606a3b35f$export$d57f2bacc26b4249(hex, opts = {}) {
    return Number($f8e4729606a3b35f$export$92a44656ec81b584(hex, opts));
}
function $f8e4729606a3b35f$export$f4bc7e46f3eb3ac3(hex, opts = {}) {
    let bytes = (0, $9Zghv.hexToBytes)(hex);
    if (opts.size) {
        $f8e4729606a3b35f$export$2af489edb7fa35fe(bytes, {
            size: opts.size
        });
        bytes = (0, $aN7Sp.trim)(bytes, {
            dir: "right"
        });
    }
    return new TextDecoder().decode(bytes);
}

});
parcelRegister("95QDg", function(module, exports) {

$parcel$export(module.exports, "IntegerOutOfRangeError", () => $69ed6857c5a2aff3$export$47d164a8071229a9);
$parcel$export(module.exports, "InvalidHexBooleanError", () => $69ed6857c5a2aff3$export$f574ac54e35514c);
$parcel$export(module.exports, "SizeOverflowError", () => $69ed6857c5a2aff3$export$beb44ed4f8747d0e);

var $6Q4jv = parcelRequire("6Q4jv");
class $69ed6857c5a2aff3$export$47d164a8071229a9 extends (0, $6Q4jv.BaseError) {
    constructor({ max: max, min: min, signed: signed, size: size, value: value }){
        super(`Number "${value}" is not in safe ${size ? `${size * 8}-bit ${signed ? "signed" : "unsigned"} ` : ""}integer range ${max ? `(${min} to ${max})` : `(above ${min})`}`, {
            name: "IntegerOutOfRangeError"
        });
    }
}
class $69ed6857c5a2aff3$export$52fc62e5266c8838 extends (0, $6Q4jv.BaseError) {
    constructor(bytes){
        super(`Bytes value "${bytes}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`, {
            name: "InvalidBytesBooleanError"
        });
    }
}
class $69ed6857c5a2aff3$export$f574ac54e35514c extends (0, $6Q4jv.BaseError) {
    constructor(hex){
        super(`Hex value "${hex}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`, {
            name: "InvalidHexBooleanError"
        });
    }
}
class $69ed6857c5a2aff3$export$ef05eafd11dd4a83 extends (0, $6Q4jv.BaseError) {
    constructor(value){
        super(`Hex value "${value}" is an odd length (${value.length}). It must be an even length.`, {
            name: "InvalidHexValueError"
        });
    }
}
class $69ed6857c5a2aff3$export$beb44ed4f8747d0e extends (0, $6Q4jv.BaseError) {
    constructor({ givenSize: givenSize, maxSize: maxSize }){
        super(`Size cannot exceed ${maxSize} bytes. Given size: ${givenSize} bytes.`, {
            name: "SizeOverflowError"
        });
    }
}

});

parcelRegister("54SKZ", function(module, exports) {

$parcel$export(module.exports, "size", () => $3b27cd12ea625930$export$346677f925de839c);

var $iWj0F = parcelRequire("iWj0F");
function $3b27cd12ea625930$export$346677f925de839c(value) {
    if ((0, $iWj0F.isHex)(value, {
        strict: false
    })) return Math.ceil((value.length - 2) / 2);
    return value.length;
}

});

parcelRegister("aN7Sp", function(module, exports) {

$parcel$export(module.exports, "trim", () => $7db497224e6604e0$export$87c2784dc9fc4ab);
function $7db497224e6604e0$export$87c2784dc9fc4ab(hexOrBytes, { dir: dir = "left" } = {}) {
    let data = typeof hexOrBytes === "string" ? hexOrBytes.replace("0x", "") : hexOrBytes;
    let sliceLength = 0;
    for(let i = 0; i < data.length - 1; i++){
        if (data[dir === "left" ? i : data.length - i - 1].toString() === "0") sliceLength++;
        else break;
    }
    data = dir === "left" ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    if (typeof hexOrBytes === "string") {
        if (data.length === 1 && dir === "right") data = `${data}0`;
        return `0x${data.length % 2 === 1 ? `0${data}` : data}`;
    }
    return data;
}

});


parcelRegister("i5PVa", function(module, exports) {

$parcel$export(module.exports, "toHex", () => $d2c0f8155bcaf47c$export$7ea66e3774a60b67);
$parcel$export(module.exports, "numberToHex", () => $d2c0f8155bcaf47c$export$4e87185b7ecfeec4);

var $95QDg = parcelRequire("95QDg");

var $96ksv = parcelRequire("96ksv");

var $lmQAI = parcelRequire("lmQAI");
const $d2c0f8155bcaf47c$var$hexes = /*#__PURE__*/ Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, "0"));
function $d2c0f8155bcaf47c$export$7ea66e3774a60b67(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $d2c0f8155bcaf47c$export$4e87185b7ecfeec4(value, opts);
    if (typeof value === "string") return $d2c0f8155bcaf47c$export$551c48dea6f88e6d(value, opts);
    if (typeof value === "boolean") return $d2c0f8155bcaf47c$export$b5c95dec4f62ef7a(value, opts);
    return $d2c0f8155bcaf47c$export$58b867e287a802c8(value, opts);
}
function $d2c0f8155bcaf47c$export$b5c95dec4f62ef7a(value, opts = {}) {
    const hex = `0x${Number(value)}`;
    if (typeof opts.size === "number") {
        (0, $lmQAI.assertSize)(hex, {
            size: opts.size
        });
        return (0, $96ksv.pad)(hex, {
            size: opts.size
        });
    }
    return hex;
}
function $d2c0f8155bcaf47c$export$58b867e287a802c8(value, opts = {}) {
    let string = "";
    for(let i = 0; i < value.length; i++)string += $d2c0f8155bcaf47c$var$hexes[value[i]];
    const hex = `0x${string}`;
    if (typeof opts.size === "number") {
        (0, $lmQAI.assertSize)(hex, {
            size: opts.size
        });
        return (0, $96ksv.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    return hex;
}
function $d2c0f8155bcaf47c$export$4e87185b7ecfeec4(value_, opts = {}) {
    const { signed: signed, size: size } = opts;
    const value = BigInt(value_);
    let maxValue;
    if (size) {
        if (signed) maxValue = (1n << BigInt(size) * 8n - 1n) - 1n;
        else maxValue = 2n ** (BigInt(size) * 8n) - 1n;
    } else if (typeof value_ === "number") maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    const minValue = typeof maxValue === "bigint" && signed ? -maxValue - 1n : 0;
    if (maxValue && value > maxValue || value < minValue) {
        const suffix = typeof value_ === "bigint" ? "n" : "";
        throw new (0, $95QDg.IntegerOutOfRangeError)({
            max: maxValue ? `${maxValue}${suffix}` : undefined,
            min: `${minValue}${suffix}`,
            signed: signed,
            size: size,
            value: `${value_}${suffix}`
        });
    }
    const hex = `0x${(signed && value < 0 ? (1n << BigInt(size * 8)) + BigInt(value) : value).toString(16)}`;
    if (size) return (0, $96ksv.pad)(hex, {
        size: size
    });
    return hex;
}
const $d2c0f8155bcaf47c$var$encoder = /*#__PURE__*/ new TextEncoder();
function $d2c0f8155bcaf47c$export$551c48dea6f88e6d(value_, opts = {}) {
    const value = $d2c0f8155bcaf47c$var$encoder.encode(value_);
    return $d2c0f8155bcaf47c$export$58b867e287a802c8(value, opts);
}

});


parcelRegister("6vND0", function(module, exports) {

$parcel$export(module.exports, "keccak256", () => $4bdc227495f78581$export$f8151fce47ad1c35);

var $d6pZi = parcelRequire("d6pZi");

var $iWj0F = parcelRequire("iWj0F");

var $9Zghv = parcelRequire("9Zghv");

var $i5PVa = parcelRequire("i5PVa");
function $4bdc227495f78581$export$f8151fce47ad1c35(value, to_) {
    const to = to_ || "hex";
    const bytes = (0, $d6pZi.keccak_256)((0, $iWj0F.isHex)(value, {
        strict: false
    }) ? (0, $9Zghv.toBytes)(value) : value);
    if (to === "bytes") return bytes;
    return (0, $i5PVa.toHex)(bytes);
}

});
parcelRegister("d6pZi", function(module, exports) {

$parcel$export(module.exports, "keccak_256", () => $989ffe8062308e09$export$860ddaa9ca84a66d);
/**
 * SHA3 (keccak) hash function, based on a new "Sponge function" design.
 * Different from older hashes, the internal state is bigger than output size.
 *
 * Check out [FIPS-202](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.202.pdf),
 * [Website](https://keccak.team/keccak.html),
 * [the differences between SHA-3 and Keccak](https://crypto.stackexchange.com/questions/15727/what-are-the-key-differences-between-the-draft-sha-3-standard-and-the-keccak-sub).
 *
 * Check out `sha3-addons` module for cSHAKE, k12, and others.
 * @module
 */ 
var $fjVeb = parcelRequire("fjVeb");

var $dFsF5 = parcelRequire("dFsF5");

var $2W4uX = parcelRequire("2W4uX");
// Various per round constants calculations
const $989ffe8062308e09$var$SHA3_PI = [];
const $989ffe8062308e09$var$SHA3_ROTL = [];
const $989ffe8062308e09$var$_SHA3_IOTA = [];
const $989ffe8062308e09$var$_0n = /* @__PURE__ */ BigInt(0);
const $989ffe8062308e09$var$_1n = /* @__PURE__ */ BigInt(1);
const $989ffe8062308e09$var$_2n = /* @__PURE__ */ BigInt(2);
const $989ffe8062308e09$var$_7n = /* @__PURE__ */ BigInt(7);
const $989ffe8062308e09$var$_256n = /* @__PURE__ */ BigInt(256);
const $989ffe8062308e09$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $989ffe8062308e09$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $989ffe8062308e09$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $989ffe8062308e09$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $989ffe8062308e09$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $989ffe8062308e09$var$_1n ^ (R >> $989ffe8062308e09$var$_7n) * $989ffe8062308e09$var$_0x71n) % $989ffe8062308e09$var$_256n;
        if (R & $989ffe8062308e09$var$_2n) t ^= $989ffe8062308e09$var$_1n << ($989ffe8062308e09$var$_1n << /* @__PURE__ */ BigInt(j)) - $989ffe8062308e09$var$_1n;
    }
    $989ffe8062308e09$var$_SHA3_IOTA.push(t);
}
const [$989ffe8062308e09$var$SHA3_IOTA_H, $989ffe8062308e09$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $dFsF5.split)($989ffe8062308e09$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $989ffe8062308e09$var$rotlH = (h, l, s)=>s > 32 ? (0, $dFsF5.rotlBH)(h, l, s) : (0, $dFsF5.rotlSH)(h, l, s);
const $989ffe8062308e09$var$rotlL = (h, l, s)=>s > 32 ? (0, $dFsF5.rotlBL)(h, l, s) : (0, $dFsF5.rotlSL)(h, l, s);
function $989ffe8062308e09$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $989ffe8062308e09$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $989ffe8062308e09$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $989ffe8062308e09$var$SHA3_ROTL[t];
            const Th = $989ffe8062308e09$var$rotlH(curH, curL, shift);
            const Tl = $989ffe8062308e09$var$rotlL(curH, curL, shift);
            const PI = $989ffe8062308e09$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $989ffe8062308e09$var$SHA3_IOTA_H[round];
        s[1] ^= $989ffe8062308e09$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
class $989ffe8062308e09$export$f7374b8b4498bc2e extends (0, $2W4uX.Hash) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $fjVeb.anumber)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        // 0 < blockLen < 200
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $2W4uX.u32)(this.state);
    }
    keccak() {
        if (!(0, $2W4uX.isLE)) (0, $2W4uX.byteSwap32)(this.state32);
        $989ffe8062308e09$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        if (!(0, $2W4uX.isLE)) (0, $2W4uX.byteSwap32)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $fjVeb.aexists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $2W4uX.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $fjVeb.aexists)(this, false);
        (0, $fjVeb.abytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $fjVeb.anumber)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $fjVeb.aoutput)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $989ffe8062308e09$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $989ffe8062308e09$var$gen = (suffix, blockLen, outputLen)=>(0, $2W4uX.wrapConstructor)(()=>new $989ffe8062308e09$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $989ffe8062308e09$export$fe6c2b96a79338e9 = /* @__PURE__ */ $989ffe8062308e09$var$gen(0x06, 144, 28);
const $989ffe8062308e09$export$76e19b6966813b14 = /* @__PURE__ */ $989ffe8062308e09$var$gen(0x06, 136, 32);
const $989ffe8062308e09$export$a58509fa80f30d15 = /* @__PURE__ */ $989ffe8062308e09$var$gen(0x06, 104, 48);
const $989ffe8062308e09$export$20ed324dbdf09b7c = /* @__PURE__ */ $989ffe8062308e09$var$gen(0x06, 72, 64);
const $989ffe8062308e09$export$2f7fb3c6fac246bc = /* @__PURE__ */ $989ffe8062308e09$var$gen(0x01, 144, 28);
const $989ffe8062308e09$export$860ddaa9ca84a66d = /* @__PURE__ */ $989ffe8062308e09$var$gen(0x01, 136, 32);
const $989ffe8062308e09$export$46fcdeb4c5686552 = /* @__PURE__ */ $989ffe8062308e09$var$gen(0x01, 104, 48);
const $989ffe8062308e09$export$aec1ddaf6c1ba495 = /* @__PURE__ */ $989ffe8062308e09$var$gen(0x01, 72, 64);
const $989ffe8062308e09$var$genShake = (suffix, blockLen, outputLen)=>(0, $2W4uX.wrapXOFConstructorWithOpts)((opts = {})=>new $989ffe8062308e09$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $989ffe8062308e09$export$f43dc3bb86efbba2 = /* @__PURE__ */ $989ffe8062308e09$var$genShake(0x1f, 168, 16);
const $989ffe8062308e09$export$c240d011f1520440 = /* @__PURE__ */ $989ffe8062308e09$var$genShake(0x1f, 136, 32);

});
parcelRegister("fjVeb", function(module, exports) {

$parcel$export(module.exports, "anumber", () => $b2750595f018a74f$export$75364c6cb16d43b6);
$parcel$export(module.exports, "abytes", () => $b2750595f018a74f$export$e8a750b9efad93f5);
$parcel$export(module.exports, "ahash", () => $b2750595f018a74f$export$3ff5a4f04de7e52e);
$parcel$export(module.exports, "aexists", () => $b2750595f018a74f$export$20871f6b1d047d77);
$parcel$export(module.exports, "aoutput", () => $b2750595f018a74f$export$e8e53abee12b995e);
/**
 * Internal assertion helpers.
 * @module
 */ /** Asserts something is positive integer. */ function $b2750595f018a74f$export$75364c6cb16d43b6(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error("positive integer expected, got " + n);
}
/** Is number an Uint8Array? Copied from utils for perf. */ function $b2750595f018a74f$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
/** Asserts something is Uint8Array. */ function $b2750595f018a74f$export$e8a750b9efad93f5(b, ...lengths) {
    if (!$b2750595f018a74f$var$isBytes(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error("Uint8Array expected of length " + lengths + ", got length=" + b.length);
}
/** Asserts something is hash */ function $b2750595f018a74f$export$3ff5a4f04de7e52e(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $b2750595f018a74f$export$75364c6cb16d43b6(h.outputLen);
    $b2750595f018a74f$export$75364c6cb16d43b6(h.blockLen);
}
/** Asserts a hash instance has not been destroyed / finished */ function $b2750595f018a74f$export$20871f6b1d047d77(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
/** Asserts output is properly-sized byte array */ function $b2750595f018a74f$export$e8e53abee12b995e(out, instance) {
    $b2750595f018a74f$export$e8a750b9efad93f5(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error("digestInto() expects output buffer of length at least " + min);
}

});

parcelRegister("dFsF5", function(module, exports) {

$parcel$export(module.exports, "split", () => $9f35564f872af264$export$65980d18b75784e2);
$parcel$export(module.exports, "rotlSH", () => $9f35564f872af264$export$4b80a2917447870e);
$parcel$export(module.exports, "rotlSL", () => $9f35564f872af264$export$20652918a7b63b3);
$parcel$export(module.exports, "rotlBH", () => $9f35564f872af264$export$a52f14bf902f9977);
$parcel$export(module.exports, "rotlBL", () => $9f35564f872af264$export$5d12cc1da441323f);
/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const $9f35564f872af264$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $9f35564f872af264$var$_32n = /* @__PURE__ */ BigInt(32);
function $9f35564f872af264$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $9f35564f872af264$var$U32_MASK64),
        l: Number(n >> $9f35564f872af264$var$_32n & $9f35564f872af264$var$U32_MASK64)
    };
    return {
        h: Number(n >> $9f35564f872af264$var$_32n & $9f35564f872af264$var$U32_MASK64) | 0,
        l: Number(n & $9f35564f872af264$var$U32_MASK64) | 0
    };
}
function $9f35564f872af264$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $9f35564f872af264$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $9f35564f872af264$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $9f35564f872af264$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $9f35564f872af264$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $9f35564f872af264$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $9f35564f872af264$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $9f35564f872af264$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $9f35564f872af264$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $9f35564f872af264$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $9f35564f872af264$export$a088d44bd387d2a3 = (_h, l)=>l;
const $9f35564f872af264$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $9f35564f872af264$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $9f35564f872af264$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $9f35564f872af264$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $9f35564f872af264$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $9f35564f872af264$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $9f35564f872af264$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $9f35564f872af264$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $9f35564f872af264$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $9f35564f872af264$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $9f35564f872af264$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $9f35564f872af264$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $9f35564f872af264$var$u64 = {
    fromBig: $9f35564f872af264$export$9625d4333cb56c3f,
    split: $9f35564f872af264$export$65980d18b75784e2,
    toBig: $9f35564f872af264$export$30f78adcaaa2eb7,
    shrSH: $9f35564f872af264$export$75aa78dc5bd52853,
    shrSL: $9f35564f872af264$export$a0225ff0aee14e25,
    rotrSH: $9f35564f872af264$export$97f812dfd830ca87,
    rotrSL: $9f35564f872af264$export$60987e30e2c9d9d,
    rotrBH: $9f35564f872af264$export$af9c7fbac44dcb76,
    rotrBL: $9f35564f872af264$export$f619171d6d5ac414,
    rotr32H: $9f35564f872af264$export$a088d44bd387d2a3,
    rotr32L: $9f35564f872af264$export$8415aae4d1f69577,
    rotlSH: $9f35564f872af264$export$4b80a2917447870e,
    rotlSL: $9f35564f872af264$export$20652918a7b63b3,
    rotlBH: $9f35564f872af264$export$a52f14bf902f9977,
    rotlBL: $9f35564f872af264$export$5d12cc1da441323f,
    add: $9f35564f872af264$export$e16d8520af44a096,
    add3L: $9f35564f872af264$export$c0c22b91f08911f,
    add3H: $9f35564f872af264$export$ef7b26044977a8ec,
    add4L: $9f35564f872af264$export$2f4e199c560f545d,
    add4H: $9f35564f872af264$export$e909220d675a7741,
    add5H: $9f35564f872af264$export$b45ee8d78c965098,
    add5L: $9f35564f872af264$export$d732b061fe9c9ae4
};
var $9f35564f872af264$export$2e2bcd8739ae039 = $9f35564f872af264$var$u64;

});

parcelRegister("2W4uX", function(module, exports) {

$parcel$export(module.exports, "u32", () => $22347cd3563b852f$export$8bacf4ad828c7fe7);
$parcel$export(module.exports, "createView", () => $22347cd3563b852f$export$d7febe7b891e79f0);
$parcel$export(module.exports, "rotr", () => $22347cd3563b852f$export$466993d7d0d272aa);
$parcel$export(module.exports, "isLE", () => $22347cd3563b852f$export$a0f88e38d4cf9577);
$parcel$export(module.exports, "byteSwap32", () => $22347cd3563b852f$export$97b40fc37f25d711);
$parcel$export(module.exports, "toBytes", () => $22347cd3563b852f$export$30a71edf0753ed6b);
$parcel$export(module.exports, "concatBytes", () => $22347cd3563b852f$export$287dd7971339c972);
$parcel$export(module.exports, "Hash", () => $22347cd3563b852f$export$ab85ecd77ce6a5cd);
$parcel$export(module.exports, "wrapConstructor", () => $22347cd3563b852f$export$f081816339df1972);
$parcel$export(module.exports, "wrapXOFConstructorWithOpts", () => $22347cd3563b852f$export$e18964dbd6e083c1);
$parcel$export(module.exports, "randomBytes", () => $22347cd3563b852f$export$5f828d93ff035aa8);
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.

var $R5Td2 = parcelRequire("R5Td2");

var $fjVeb = parcelRequire("fjVeb");
function $22347cd3563b852f$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
function $22347cd3563b852f$export$9813fca58c0b9f71(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $22347cd3563b852f$export$8bacf4ad828c7fe7(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
function $22347cd3563b852f$export$d7febe7b891e79f0(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $22347cd3563b852f$export$466993d7d0d272aa(word, shift) {
    return word << 32 - shift | word >>> shift;
}
function $22347cd3563b852f$export$ac5e39599698b562(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
const $22347cd3563b852f$export$a0f88e38d4cf9577 = /* @__PURE__ */ (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
function $22347cd3563b852f$export$a4170f7f8be47425(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
const $22347cd3563b852f$export$4a0a88cc2d284e7f = $22347cd3563b852f$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$22347cd3563b852f$export$a4170f7f8be47425(n);
function $22347cd3563b852f$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $22347cd3563b852f$export$a4170f7f8be47425(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $22347cd3563b852f$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $22347cd3563b852f$export$58b867e287a802c8(bytes) {
    (0, $fjVeb.abytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $22347cd3563b852f$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $22347cd3563b852f$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $22347cd3563b852f$var$asciiToBase16(ch) {
    if (ch >= $22347cd3563b852f$var$asciis._0 && ch <= $22347cd3563b852f$var$asciis._9) return ch - $22347cd3563b852f$var$asciis._0; // '2' => 50-48
    if (ch >= $22347cd3563b852f$var$asciis.A && ch <= $22347cd3563b852f$var$asciis.F) return ch - ($22347cd3563b852f$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $22347cd3563b852f$var$asciis.a && ch <= $22347cd3563b852f$var$asciis.f) return ch - ($22347cd3563b852f$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
function $22347cd3563b852f$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $22347cd3563b852f$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $22347cd3563b852f$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
const $22347cd3563b852f$export$bdd553fddd433dcb = async ()=>{};
async function $22347cd3563b852f$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $22347cd3563b852f$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $22347cd3563b852f$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error("utf8ToBytes expected string, got " + typeof str);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $22347cd3563b852f$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $22347cd3563b852f$export$3df70a15530b5e81(data);
    (0, $fjVeb.abytes)(data);
    return data;
}
function $22347cd3563b852f$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $fjVeb.abytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
class $22347cd3563b852f$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
function $22347cd3563b852f$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $22347cd3563b852f$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($22347cd3563b852f$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $22347cd3563b852f$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($22347cd3563b852f$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $22347cd3563b852f$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($22347cd3563b852f$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $22347cd3563b852f$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $R5Td2.crypto) && typeof (0, $R5Td2.crypto).getRandomValues === "function") return (0, $R5Td2.crypto).getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ((0, $R5Td2.crypto) && typeof (0, $R5Td2.crypto).randomBytes === "function") return (0, $R5Td2.crypto).randomBytes(bytesLength);
    throw new Error("crypto.getRandomValues must be defined");
}

});
parcelRegister("R5Td2", function(module, exports) {

$parcel$export(module.exports, "crypto", () => $09f984e0f6aeaf8a$export$7effb53edfc7fa2d);
const $09f984e0f6aeaf8a$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("cGVhd", function(module, exports) {

$parcel$export(module.exports, "LruMap", () => $93d5d64102ccce0a$export$fcb3b6cad79d7e3a);
/**
 * Map with a LRU (Least recently used) policy.
 *
 * @link https://en.wikipedia.org/wiki/Cache_replacement_policies#LRU
 */ class $93d5d64102ccce0a$export$fcb3b6cad79d7e3a extends Map {
    constructor(size){
        super();
        Object.defineProperty(this, "maxSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.maxSize = size;
    }
    get(key) {
        const value = super.get(key);
        if (super.has(key) && value !== undefined) {
            this.delete(key);
            super.set(key, value);
        }
        return value;
    }
    set(key, value) {
        super.set(key, value);
        if (this.maxSize && this.size > this.maxSize) {
            const firstKey = this.keys().next().value;
            if (firstKey) this.delete(firstKey);
        }
        return this;
    }
}

});

parcelRegister("5aIaC", function(module, exports) {

$parcel$export(module.exports, "isAddress", () => $3c4026321674dd19$export$977e255126d763d6);

var $cGVhd = parcelRequire("cGVhd");

var $aNqkJ = parcelRequire("aNqkJ");
const $3c4026321674dd19$var$addressRegex = /^0x[a-fA-F0-9]{40}$/;
const $3c4026321674dd19$export$ef83598cc5072ce = /*#__PURE__*/ new (0, $cGVhd.LruMap)(8192);
function $3c4026321674dd19$export$977e255126d763d6(address, options) {
    const { strict: strict = true } = options ?? {};
    const cacheKey = `${address}.${strict}`;
    if ($3c4026321674dd19$export$ef83598cc5072ce.has(cacheKey)) return $3c4026321674dd19$export$ef83598cc5072ce.get(cacheKey);
    const result = (()=>{
        if (!$3c4026321674dd19$var$addressRegex.test(address)) return false;
        if (address.toLowerCase() === address) return true;
        if (strict) return (0, $aNqkJ.checksumAddress)(address) === address;
        return true;
    })();
    $3c4026321674dd19$export$ef83598cc5072ce.set(cacheKey, result);
    return result;
}

});



parcelRegister("bqq1O", function(module, exports) {

$parcel$export(module.exports, "recoverPublicKey", () => $851650157b286e5e$export$952dd09fbe0232b7);

var $iWj0F = parcelRequire("iWj0F");

var $lmQAI = parcelRequire("lmQAI");

var $i5PVa = parcelRequire("i5PVa");

async function $851650157b286e5e$export$952dd09fbe0232b7({ hash: hash, signature: signature }) {
    const hashHex = (0, $iWj0F.isHex)(hash) ? hash : (0, $i5PVa.toHex)(hash);
    const { secp256k1: secp256k1 } = await (parcelRequire("93YCX"));
    const signature_ = (()=>{
        // typeof signature: `Signature`
        if (typeof signature === "object" && "r" in signature && "s" in signature) {
            const { r: r, s: s, v: v, yParity: yParity } = signature;
            const yParityOrV = Number(yParity ?? v);
            const recoveryBit = $851650157b286e5e$var$toRecoveryBit(yParityOrV);
            return new secp256k1.Signature((0, $lmQAI.hexToBigInt)(r), (0, $lmQAI.hexToBigInt)(s)).addRecoveryBit(recoveryBit);
        }
        // typeof signature: `Hex | ByteArray`
        const signatureHex = (0, $iWj0F.isHex)(signature) ? signature : (0, $i5PVa.toHex)(signature);
        const yParityOrV = (0, $lmQAI.hexToNumber)(`0x${signatureHex.slice(130)}`);
        const recoveryBit = $851650157b286e5e$var$toRecoveryBit(yParityOrV);
        return secp256k1.Signature.fromCompact(signatureHex.substring(2, 130)).addRecoveryBit(recoveryBit);
    })();
    const publicKey = signature_.recoverPublicKey(hashHex.substring(2)).toHex(false);
    return `0x${publicKey}`;
}
function $851650157b286e5e$var$toRecoveryBit(yParityOrV) {
    if (yParityOrV === 0 || yParityOrV === 1) return yParityOrV;
    if (yParityOrV === 27) return 0;
    if (yParityOrV === 28) return 1;
    throw new Error("Invalid yParityOrV value");
}

});
parcelRegister("93YCX", function(module, exports) {

var $04X1W = parcelRequire("04X1W");
module.exports = $04X1W("854zs").then(()=>parcelRequire("bTAvj"));

});
parcelRegister("04X1W", function(module, exports) {
"use strict";

function $0003d76326f98b52$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("bK96A")).resolve(id));
}
module.exports = $0003d76326f98b52$var$load;

});




parcelRegister("4zT52", function(module, exports) {

$parcel$export(module.exports, "default", () => $35552818783521f0$export$2e2bcd8739ae039);

var $1BvoP = parcelRequire("1BvoP");
var $35552818783521f0$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var $35552818783521f0$export$2e2bcd8739ae039 = (0, $1BvoP.default)($35552818783521f0$var$ALPHABET);

});
parcelRegister("1BvoP", function(module, exports) {

$parcel$export(module.exports, "default", () => $12b19a72fb6f788a$export$2e2bcd8739ae039);
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $12b19a72fb6f788a$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    const BASE_MAP = new Uint8Array(256);
    for(let j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(let i = 0; i < ALPHABET.length; i++){
        const x = ALPHABET.charAt(i);
        const xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    const BASE = ALPHABET.length;
    const LEADER = ALPHABET.charAt(0);
    const FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    const iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        // eslint-disable-next-line no-empty
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        let zeroes = 0;
        let length = 0;
        let pbegin = 0;
        const pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        const size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        const b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            let carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            let i = 0;
            for(let it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        let it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        let str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        let psz = 0;
        // Skip and count leading '1's.
        let zeroes = 0;
        let length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        const size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        const b256 = new Uint8Array(size);
        // Process the characters.
        while(psz < source.length){
            // Find code of next character
            const charCode = source.charCodeAt(psz);
            // Base map can not be indexed using char code
            if (charCode > 255) return;
            // Decode character
            let carry = BASE_MAP[charCode];
            // Invalid character
            if (carry === 255) return;
            let i = 0;
            for(let it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        let it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        const vch = new Uint8Array(zeroes + (size - it4));
        let j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        const buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $12b19a72fb6f788a$export$2e2bcd8739ae039 = $12b19a72fb6f788a$var$base;

});


parcelRegister("68fSN", function(module, exports) {

$parcel$export(module.exports, "concat", () => (parcelRequire("g976M")).concat);
$parcel$export(module.exports, "fromString", () => (parcelRequire("eREyP")).fromString);
$parcel$export(module.exports, "toString", () => (parcelRequire("iH58P")).toString);

var $672Lm = parcelRequire("672Lm");

var $g976M = parcelRequire("g976M");

var $lzG9t = parcelRequire("lzG9t");

var $eREyP = parcelRequire("eREyP");

var $iH58P = parcelRequire("iH58P");

var $amriN = parcelRequire("amriN");

});
parcelRegister("672Lm", function(module, exports) {
function $47358a30bc5cdb68$export$398604a469f7de9a(a, b) {
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}

});

parcelRegister("g976M", function(module, exports) {

$parcel$export(module.exports, "concat", () => $bc1300310fdfe568$export$ee1b3e54f0441b22);

var $zPrTJ = parcelRequire("zPrTJ");
function $bc1300310fdfe568$export$ee1b3e54f0441b22(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = (0, $zPrTJ.allocUnsafe)(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return output;
}

});
parcelRegister("zPrTJ", function(module, exports) {

$parcel$export(module.exports, "allocUnsafe", () => $06bb2db11740afc1$export$19833a56117fe205);
function $06bb2db11740afc1$export$2de70f21292aac9e(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.alloc != null) return globalThis.Buffer.alloc(size);
    return new Uint8Array(size);
}
function $06bb2db11740afc1$export$19833a56117fe205(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) return globalThis.Buffer.allocUnsafe(size);
    return new Uint8Array(size);
}

});


parcelRegister("lzG9t", function(module, exports) {
function $fb4d9057bd3fb92a$export$e9bab7fafb253603(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}

});

parcelRegister("eREyP", function(module, exports) {

$parcel$export(module.exports, "fromString", () => $ad257a787ced7429$export$3004f64547af360e);

var $8XAda = parcelRequire("8XAda");
function $ad257a787ced7429$export$3004f64547af360e(string, encoding = "utf8") {
    const base = (0, $8XAda.default)[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(string, "utf8");
    return base.decoder.decode(`${base.prefix}${string}`);
}

});
parcelRegister("8XAda", function(module, exports) {

$parcel$export(module.exports, "default", () => $685fec3c1fecbb83$export$2e2bcd8739ae039);

var $5Ygtb = parcelRequire("5Ygtb");

var $zPrTJ = parcelRequire("zPrTJ");
function $685fec3c1fecbb83$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
const $685fec3c1fecbb83$var$string = $685fec3c1fecbb83$var$createCodec("utf8", "u", (buf)=>{
    const decoder = new TextDecoder("utf8");
    return "u" + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const $685fec3c1fecbb83$var$ascii = $685fec3c1fecbb83$var$createCodec("ascii", "a", (buf)=>{
    let string = "a";
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = (0, $zPrTJ.allocUnsafe)(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
const $685fec3c1fecbb83$var$BASES = {
    utf8: $685fec3c1fecbb83$var$string,
    "utf-8": $685fec3c1fecbb83$var$string,
    hex: (0, $5Ygtb.bases).base16,
    latin1: $685fec3c1fecbb83$var$ascii,
    ascii: $685fec3c1fecbb83$var$ascii,
    binary: $685fec3c1fecbb83$var$ascii,
    ...(0, $5Ygtb.bases)
};
var $685fec3c1fecbb83$export$2e2bcd8739ae039 = $685fec3c1fecbb83$var$BASES;

});
parcelRegister("5Ygtb", function(module, exports) {

$parcel$export(module.exports, "bases", () => $458f54df47c5f816$export$196f613671eb7dd9);

var $73c6z = parcelRequire("73c6z");

var $d0Owj = parcelRequire("d0Owj");

var $1EZ61 = parcelRequire("1EZ61");

var $2NZyz = parcelRequire("2NZyz");

var $eDeKa = parcelRequire("eDeKa");

var $bTjm8 = parcelRequire("bTjm8");

var $k9GJy = parcelRequire("k9GJy");

var $e5IcK = parcelRequire("e5IcK");

var $4tqp3 = parcelRequire("4tqp3");

var $jKtpF = parcelRequire("jKtpF");

var $9aB9z = parcelRequire("9aB9z");

var $mg9h6 = parcelRequire("mg9h6");

var $8CkJF = parcelRequire("8CkJF");

var $dkzpD = parcelRequire("dkzpD");
parcelRequire("g6EkA");
var $cDo3E = parcelRequire("cDo3E");
var $blxcT = parcelRequire("blxcT");
var $knGCq = parcelRequire("knGCq");
var $4WpY9 = parcelRequire("4WpY9");
var $v3LQn = parcelRequire("v3LQn");
const $458f54df47c5f816$export$196f613671eb7dd9 = {
    ...$73c6z,
    ...$d0Owj,
    ...$1EZ61,
    ...$2NZyz,
    ...$eDeKa,
    ...$bTjm8,
    ...$k9GJy,
    ...$e5IcK,
    ...$4tqp3,
    ...$jKtpF
};
const $458f54df47c5f816$export$cff071c6f82b8944 = {
    ...$9aB9z,
    ...$mg9h6
};
const $458f54df47c5f816$export$b2c6ab3b27d60531 = {
    raw: $8CkJF,
    json: $dkzpD
};

});
parcelRegister("73c6z", function(module, exports) {

$parcel$export(module.exports, "identity", () => $5222340681d998c4$export$f0954fd7d5368655);

var $fBffy = parcelRequire("fBffy");

var $v3LQn = parcelRequire("v3LQn");
const $5222340681d998c4$export$f0954fd7d5368655 = (0, $fBffy.from)({
    prefix: "\x00",
    name: "identity",
    encode: (buf)=>(0, $v3LQn.toString)(buf),
    decode: (str)=>(0, $v3LQn.fromString)(str)
});

});
parcelRegister("fBffy", function(module, exports) {

$parcel$export(module.exports, "from", () => $b5b62402041109e1$export$6788812c4e6611e6);
$parcel$export(module.exports, "baseX", () => $b5b62402041109e1$export$180c73aedea7f385);
$parcel$export(module.exports, "rfc4648", () => $b5b62402041109e1$export$fa9dde04c7d2f31a);

var $1fqH0 = parcelRequire("1fqH0");

var $v3LQn = parcelRequire("v3LQn");
class $b5b62402041109e1$var$Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error("Unknown type, must be binary type");
    }
}
class $b5b62402041109e1$var$Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error("Invalid prefix character");
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === "string") {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(decoder) {
        return $b5b62402041109e1$export$252bb8b3bbdf6749(this, decoder);
    }
}
class $b5b62402041109e1$var$ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return $b5b62402041109e1$export$252bb8b3bbdf6749(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $b5b62402041109e1$export$252bb8b3bbdf6749 = (left, right)=>new $b5b62402041109e1$var$ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class $b5b62402041109e1$export$a111e9ced3f1d2d0 {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new $b5b62402041109e1$var$Encoder(name, prefix, baseEncode);
        this.decoder = new $b5b62402041109e1$var$Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const $b5b62402041109e1$export$6788812c4e6611e6 = ({ name: name, prefix: prefix, encode: encode, decode: decode })=>new $b5b62402041109e1$export$a111e9ced3f1d2d0(name, prefix, encode, decode);
const $b5b62402041109e1$export$180c73aedea7f385 = ({ prefix: prefix, name: name, alphabet: alphabet })=>{
    const { encode: encode, decode: decode } = (0, $1fqH0.default)(alphabet, name);
    return $b5b62402041109e1$export$6788812c4e6611e6({
        prefix: prefix,
        name: name,
        encode: encode,
        decode: (text)=>(0, $v3LQn.coerce)(decode(text))
    });
};
const $b5b62402041109e1$var$decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === "=")--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError("Unexpected end of data");
    return out;
};
const $b5b62402041109e1$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === "=";
    const mask = (1 << bitsPerChar) - 1;
    let out = "";
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += "=";
    return out;
};
const $b5b62402041109e1$export$fa9dde04c7d2f31a = ({ name: name, prefix: prefix, bitsPerChar: bitsPerChar, alphabet: alphabet })=>{
    return $b5b62402041109e1$export$6788812c4e6611e6({
        prefix: prefix,
        name: name,
        encode (input) {
            return $b5b62402041109e1$var$encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return $b5b62402041109e1$var$decode(input, alphabet, bitsPerChar, name);
        }
    });
};

});
parcelRegister("1fqH0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e8be5beb6964d45$export$2e2bcd8739ae039);
function $0e8be5beb6964d45$var$base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === " ") return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        if (source[psz] === " ") return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $0e8be5beb6964d45$var$src = $0e8be5beb6964d45$var$base;
var $0e8be5beb6964d45$var$_brrp__multiformats_scope_baseX = $0e8be5beb6964d45$var$src;
var $0e8be5beb6964d45$export$2e2bcd8739ae039 = $0e8be5beb6964d45$var$_brrp__multiformats_scope_baseX;

});

parcelRegister("v3LQn", function(module, exports) {

$parcel$export(module.exports, "equals", () => $05d5d2245e4ad208$export$e9bab7fafb253603);
$parcel$export(module.exports, "coerce", () => $05d5d2245e4ad208$export$8c14e57e778d3873);
$parcel$export(module.exports, "fromString", () => $05d5d2245e4ad208$export$3004f64547af360e);
$parcel$export(module.exports, "toString", () => $05d5d2245e4ad208$export$f84e8e69fd4488a5);
const $05d5d2245e4ad208$export$6e22c362a0406a2c = new Uint8Array(0);
const $05d5d2245e4ad208$export$7ea66e3774a60b67 = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, "0"), "");
const $05d5d2245e4ad208$export$1a8ceedbd5845648 = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : $05d5d2245e4ad208$export$6e22c362a0406a2c;
};
const $05d5d2245e4ad208$export$e9bab7fafb253603 = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const $05d5d2245e4ad208$export$8c14e57e778d3873 = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
};
const $05d5d2245e4ad208$export$37488ff1135b1696 = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const $05d5d2245e4ad208$export$3004f64547af360e = (str)=>new TextEncoder().encode(str);
const $05d5d2245e4ad208$export$f84e8e69fd4488a5 = (b)=>new TextDecoder().decode(b);

});



parcelRegister("d0Owj", function(module, exports) {

$parcel$export(module.exports, "base2", () => $979276b32010d120$export$ed5f7917e37e31aa);

var $fBffy = parcelRequire("fBffy");
const $979276b32010d120$export$ed5f7917e37e31aa = (0, $fBffy.rfc4648)({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});

});

parcelRegister("1EZ61", function(module, exports) {

$parcel$export(module.exports, "base8", () => $1358eb48d134a0dd$export$43b580ac9deb5b96);

var $fBffy = parcelRequire("fBffy");
const $1358eb48d134a0dd$export$43b580ac9deb5b96 = (0, $fBffy.rfc4648)({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});

});

parcelRegister("2NZyz", function(module, exports) {

$parcel$export(module.exports, "base10", () => $20afe840719bc83b$export$63d6a7de0ff813cc);

var $fBffy = parcelRequire("fBffy");
const $20afe840719bc83b$export$63d6a7de0ff813cc = (0, $fBffy.baseX)({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});

});

parcelRegister("eDeKa", function(module, exports) {

$parcel$export(module.exports, "base16", () => $aa702501b08cb21b$export$586f61c71cb02fe4);
$parcel$export(module.exports, "base16upper", () => $aa702501b08cb21b$export$2d835b8dd4032b62);

var $fBffy = parcelRequire("fBffy");
const $aa702501b08cb21b$export$586f61c71cb02fe4 = (0, $fBffy.rfc4648)({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
});
const $aa702501b08cb21b$export$2d835b8dd4032b62 = (0, $fBffy.rfc4648)({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});

});

parcelRegister("bTjm8", function(module, exports) {

$parcel$export(module.exports, "base32", () => $8a83d878a1b6d637$export$4a4d5965e2738b2a);
$parcel$export(module.exports, "base32upper", () => $8a83d878a1b6d637$export$fbaa3bbbd754def4);
$parcel$export(module.exports, "base32pad", () => $8a83d878a1b6d637$export$e194fa100d329365);
$parcel$export(module.exports, "base32padupper", () => $8a83d878a1b6d637$export$3a9fc48d294dce32);
$parcel$export(module.exports, "base32hex", () => $8a83d878a1b6d637$export$c57d6760d519c8ac);
$parcel$export(module.exports, "base32hexupper", () => $8a83d878a1b6d637$export$8cf4640df3165d29);
$parcel$export(module.exports, "base32hexpad", () => $8a83d878a1b6d637$export$8c6a05c08ec7d456);
$parcel$export(module.exports, "base32hexpadupper", () => $8a83d878a1b6d637$export$29f73c6a744e639f);
$parcel$export(module.exports, "base32z", () => $8a83d878a1b6d637$export$fdad9af4bdc05e3);

var $fBffy = parcelRequire("fBffy");
const $8a83d878a1b6d637$export$4a4d5965e2738b2a = (0, $fBffy.rfc4648)({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
});
const $8a83d878a1b6d637$export$fbaa3bbbd754def4 = (0, $fBffy.rfc4648)({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
});
const $8a83d878a1b6d637$export$e194fa100d329365 = (0, $fBffy.rfc4648)({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
});
const $8a83d878a1b6d637$export$3a9fc48d294dce32 = (0, $fBffy.rfc4648)({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
});
const $8a83d878a1b6d637$export$c57d6760d519c8ac = (0, $fBffy.rfc4648)({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
});
const $8a83d878a1b6d637$export$8cf4640df3165d29 = (0, $fBffy.rfc4648)({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
});
const $8a83d878a1b6d637$export$8c6a05c08ec7d456 = (0, $fBffy.rfc4648)({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
});
const $8a83d878a1b6d637$export$29f73c6a744e639f = (0, $fBffy.rfc4648)({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
});
const $8a83d878a1b6d637$export$fdad9af4bdc05e3 = (0, $fBffy.rfc4648)({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});

});

parcelRegister("k9GJy", function(module, exports) {

$parcel$export(module.exports, "base36", () => $eac5cbf51a228295$export$95b61e7c39ae893a);
$parcel$export(module.exports, "base36upper", () => $eac5cbf51a228295$export$bab7c9bdb963afd);

var $fBffy = parcelRequire("fBffy");
const $eac5cbf51a228295$export$95b61e7c39ae893a = (0, $fBffy.baseX)({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
});
const $eac5cbf51a228295$export$bab7c9bdb963afd = (0, $fBffy.baseX)({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});

});

parcelRegister("e5IcK", function(module, exports) {

$parcel$export(module.exports, "base58btc", () => $a423d26f14936a88$export$65c61748a9b98a2c);
$parcel$export(module.exports, "base58flickr", () => $a423d26f14936a88$export$c6a7baed2941aad2);

var $fBffy = parcelRequire("fBffy");
const $a423d26f14936a88$export$65c61748a9b98a2c = (0, $fBffy.baseX)({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
});
const $a423d26f14936a88$export$c6a7baed2941aad2 = (0, $fBffy.baseX)({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});

});

parcelRegister("4tqp3", function(module, exports) {

$parcel$export(module.exports, "base64", () => $341e59f6de305d30$export$b3b2de96497acc47);
$parcel$export(module.exports, "base64pad", () => $341e59f6de305d30$export$a9c086fc40b4563c);
$parcel$export(module.exports, "base64url", () => $341e59f6de305d30$export$7d21597c7bc64465);
$parcel$export(module.exports, "base64urlpad", () => $341e59f6de305d30$export$e87ddc9183aa53c9);

var $fBffy = parcelRequire("fBffy");
const $341e59f6de305d30$export$b3b2de96497acc47 = (0, $fBffy.rfc4648)({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
});
const $341e59f6de305d30$export$a9c086fc40b4563c = (0, $fBffy.rfc4648)({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
});
const $341e59f6de305d30$export$7d21597c7bc64465 = (0, $fBffy.rfc4648)({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
});
const $341e59f6de305d30$export$e87ddc9183aa53c9 = (0, $fBffy.rfc4648)({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});

});

parcelRegister("jKtpF", function(module, exports) {

$parcel$export(module.exports, "base256emoji", () => $e60920fc00825de8$export$6a5d4ab6075d2779);

var $fBffy = parcelRequire("fBffy");
const $e60920fc00825de8$var$alphabet = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42");
const $e60920fc00825de8$var$alphabetBytesToChars = $e60920fc00825de8$var$alphabet.reduce((p, c, i)=>{
    p[i] = c;
    return p;
}, []);
const $e60920fc00825de8$var$alphabetCharsToBytes = $e60920fc00825de8$var$alphabet.reduce((p, c, i)=>{
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function $e60920fc00825de8$var$encode(data) {
    return data.reduce((p, c)=>{
        p += $e60920fc00825de8$var$alphabetBytesToChars[c];
        return p;
    }, "");
}
function $e60920fc00825de8$var$decode(str) {
    const byts = [];
    for (const char of str){
        const byt = $e60920fc00825de8$var$alphabetCharsToBytes[char.codePointAt(0)];
        if (byt === undefined) throw new Error(`Non-base256emoji character: ${char}`);
        byts.push(byt);
    }
    return new Uint8Array(byts);
}
const $e60920fc00825de8$export$6a5d4ab6075d2779 = (0, $fBffy.from)({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $e60920fc00825de8$var$encode,
    decode: $e60920fc00825de8$var$decode
});

});

parcelRegister("9aB9z", function(module, exports) {

$parcel$export(module.exports, "sha256", () => $6ad1de204d7f71cf$export$bced8d2aada2d1c9);
$parcel$export(module.exports, "sha512", () => $6ad1de204d7f71cf$export$a888d2532e6dc7bb);

var $blxcT = parcelRequire("blxcT");
const $6ad1de204d7f71cf$var$sha = (name)=>async (data)=>new Uint8Array(await crypto.subtle.digest(name, data));
const $6ad1de204d7f71cf$export$bced8d2aada2d1c9 = (0, $blxcT.from)({
    name: "sha2-256",
    code: 18,
    encode: $6ad1de204d7f71cf$var$sha("SHA-256")
});
const $6ad1de204d7f71cf$export$a888d2532e6dc7bb = (0, $blxcT.from)({
    name: "sha2-512",
    code: 19,
    encode: $6ad1de204d7f71cf$var$sha("SHA-512")
});

});
parcelRegister("blxcT", function(module, exports) {

$parcel$export(module.exports, "from", () => $842b6a19d7e57921$export$6788812c4e6611e6);

var $knGCq = parcelRequire("knGCq");
const $842b6a19d7e57921$export$6788812c4e6611e6 = ({ name: name, code: code, encode: encode })=>new $842b6a19d7e57921$export$df06eed23808f4d0(name, code, encode);
class $842b6a19d7e57921$export$df06eed23808f4d0 {
    constructor(name, code, encode){
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    digest(input) {
        if (input instanceof Uint8Array) {
            const result = this.encode(input);
            return result instanceof Uint8Array ? $knGCq.create(this.code, result) : result.then((digest)=>$knGCq.create(this.code, digest));
        } else throw Error("Unknown type, must be binary type");
    }
}

});
parcelRegister("knGCq", function(module, exports) {

$parcel$export(module.exports, "create", () => $ed6703d2dddd937f$export$185802fd694ee1f5);
$parcel$export(module.exports, "Digest", () => $ed6703d2dddd937f$export$d67a82ff561eff43);
$parcel$export(module.exports, "decode", () => $ed6703d2dddd937f$export$2f872c0f2117be69);
$parcel$export(module.exports, "equals", () => $ed6703d2dddd937f$export$e9bab7fafb253603);

var $v3LQn = parcelRequire("v3LQn");

var $4WpY9 = parcelRequire("4WpY9");
const $ed6703d2dddd937f$export$185802fd694ee1f5 = (code, digest)=>{
    const size = digest.byteLength;
    const sizeOffset = $4WpY9.encodingLength(code);
    const digestOffset = sizeOffset + $4WpY9.encodingLength(size);
    const bytes = new Uint8Array(digestOffset + size);
    $4WpY9.encodeTo(code, bytes, 0);
    $4WpY9.encodeTo(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new $ed6703d2dddd937f$export$d67a82ff561eff43(code, size, digest, bytes);
};
const $ed6703d2dddd937f$export$2f872c0f2117be69 = (multihash)=>{
    const bytes = (0, $v3LQn.coerce)(multihash);
    const [code, sizeOffset] = $4WpY9.decode(bytes);
    const [size, digestOffset] = $4WpY9.decode(bytes.subarray(sizeOffset));
    const digest = bytes.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error("Incorrect length");
    return new $ed6703d2dddd937f$export$d67a82ff561eff43(code, size, digest, bytes);
};
const $ed6703d2dddd937f$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && (0, $v3LQn.equals)(a.bytes, b.bytes);
};
class $ed6703d2dddd937f$export$d67a82ff561eff43 {
    constructor(code, size, digest, bytes){
        this.code = code;
        this.size = size;
        this.digest = digest;
        this.bytes = bytes;
    }
}

});
parcelRegister("4WpY9", function(module, exports) {

$parcel$export(module.exports, "decode", () => $3990b929f021abb6$export$2f872c0f2117be69);
$parcel$export(module.exports, "encodeTo", () => $3990b929f021abb6$export$8512cbe4228de3b3);
$parcel$export(module.exports, "encodingLength", () => $3990b929f021abb6$export$cbee51f25f0626d7);

var $hJ7FB = parcelRequire("hJ7FB");
const $3990b929f021abb6$export$2f872c0f2117be69 = (data, offset = 0)=>{
    const code = (0, $hJ7FB.default).decode(data, offset);
    return [
        code,
        (0, $hJ7FB.default).decode.bytes
    ];
};
const $3990b929f021abb6$export$8512cbe4228de3b3 = (int, target, offset = 0)=>{
    (0, $hJ7FB.default).encode(int, target, offset);
    return target;
};
const $3990b929f021abb6$export$cbee51f25f0626d7 = (int)=>{
    return (0, $hJ7FB.default).encodingLength(int);
};

});
parcelRegister("hJ7FB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce7c96bd030a041e$export$2e2bcd8739ae039);
var $ce7c96bd030a041e$var$encode_1 = $ce7c96bd030a041e$var$encode;
var $ce7c96bd030a041e$var$MSB = 128, $ce7c96bd030a041e$var$REST = 127, $ce7c96bd030a041e$var$MSBALL = ~$ce7c96bd030a041e$var$REST, $ce7c96bd030a041e$var$INT = Math.pow(2, 31);
function $ce7c96bd030a041e$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $ce7c96bd030a041e$var$INT){
        out[offset++] = num & 255 | $ce7c96bd030a041e$var$MSB;
        num /= 128;
    }
    while(num & $ce7c96bd030a041e$var$MSBALL){
        out[offset++] = num & 255 | $ce7c96bd030a041e$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $ce7c96bd030a041e$var$encode.bytes = offset - oldOffset + 1;
    return out;
}
var $ce7c96bd030a041e$var$decode = $ce7c96bd030a041e$var$read;
var $ce7c96bd030a041e$var$MSB$1 = 128, $ce7c96bd030a041e$var$REST$1 = 127;
function $ce7c96bd030a041e$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $ce7c96bd030a041e$var$read.bytes = 0;
            throw new RangeError("Could not decode varint");
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $ce7c96bd030a041e$var$REST$1) << shift : (b & $ce7c96bd030a041e$var$REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $ce7c96bd030a041e$var$MSB$1);
    $ce7c96bd030a041e$var$read.bytes = counter - offset;
    return res;
}
var $ce7c96bd030a041e$var$N1 = Math.pow(2, 7);
var $ce7c96bd030a041e$var$N2 = Math.pow(2, 14);
var $ce7c96bd030a041e$var$N3 = Math.pow(2, 21);
var $ce7c96bd030a041e$var$N4 = Math.pow(2, 28);
var $ce7c96bd030a041e$var$N5 = Math.pow(2, 35);
var $ce7c96bd030a041e$var$N6 = Math.pow(2, 42);
var $ce7c96bd030a041e$var$N7 = Math.pow(2, 49);
var $ce7c96bd030a041e$var$N8 = Math.pow(2, 56);
var $ce7c96bd030a041e$var$N9 = Math.pow(2, 63);
var $ce7c96bd030a041e$var$length = function(value) {
    return value < $ce7c96bd030a041e$var$N1 ? 1 : value < $ce7c96bd030a041e$var$N2 ? 2 : value < $ce7c96bd030a041e$var$N3 ? 3 : value < $ce7c96bd030a041e$var$N4 ? 4 : value < $ce7c96bd030a041e$var$N5 ? 5 : value < $ce7c96bd030a041e$var$N6 ? 6 : value < $ce7c96bd030a041e$var$N7 ? 7 : value < $ce7c96bd030a041e$var$N8 ? 8 : value < $ce7c96bd030a041e$var$N9 ? 9 : 10;
};
var $ce7c96bd030a041e$var$varint = {
    encode: $ce7c96bd030a041e$var$encode_1,
    decode: $ce7c96bd030a041e$var$decode,
    encodingLength: $ce7c96bd030a041e$var$length
};
var $ce7c96bd030a041e$var$_brrp_varint = $ce7c96bd030a041e$var$varint;
var $ce7c96bd030a041e$export$2e2bcd8739ae039 = $ce7c96bd030a041e$var$_brrp_varint;

});





parcelRegister("mg9h6", function(module, exports) {

$parcel$export(module.exports, "identity", () => $042e94f6aacca8e0$export$f0954fd7d5368655);

var $v3LQn = parcelRequire("v3LQn");

var $knGCq = parcelRequire("knGCq");
const $042e94f6aacca8e0$var$code = 0;
const $042e94f6aacca8e0$var$name = "identity";
const $042e94f6aacca8e0$var$encode = (0, $v3LQn.coerce);
const $042e94f6aacca8e0$var$digest = (input)=>$knGCq.create($042e94f6aacca8e0$var$code, $042e94f6aacca8e0$var$encode(input));
const $042e94f6aacca8e0$export$f0954fd7d5368655 = {
    code: $042e94f6aacca8e0$var$code,
    name: $042e94f6aacca8e0$var$name,
    encode: $042e94f6aacca8e0$var$encode,
    digest: $042e94f6aacca8e0$var$digest
};

});

parcelRegister("8CkJF", function(module, exports) {

$parcel$export(module.exports, "name", () => $6461f500a7e0c07c$export$a8ff84c12d48cfa6);
$parcel$export(module.exports, "code", () => $6461f500a7e0c07c$export$6565f9f03506010b);
$parcel$export(module.exports, "encode", () => $6461f500a7e0c07c$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $6461f500a7e0c07c$export$2f872c0f2117be69);

var $v3LQn = parcelRequire("v3LQn");
const $6461f500a7e0c07c$export$a8ff84c12d48cfa6 = "raw";
const $6461f500a7e0c07c$export$6565f9f03506010b = 85;
const $6461f500a7e0c07c$export$c564cdbbe6da493 = (node)=>(0, $v3LQn.coerce)(node);
const $6461f500a7e0c07c$export$2f872c0f2117be69 = (data)=>(0, $v3LQn.coerce)(data);

});

parcelRegister("dkzpD", function(module, exports) {

$parcel$export(module.exports, "name", () => $9b489cd0e48ef132$export$a8ff84c12d48cfa6);
$parcel$export(module.exports, "code", () => $9b489cd0e48ef132$export$6565f9f03506010b);
$parcel$export(module.exports, "encode", () => $9b489cd0e48ef132$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $9b489cd0e48ef132$export$2f872c0f2117be69);
const $9b489cd0e48ef132$var$textEncoder = new TextEncoder();
const $9b489cd0e48ef132$var$textDecoder = new TextDecoder();
const $9b489cd0e48ef132$export$a8ff84c12d48cfa6 = "json";
const $9b489cd0e48ef132$export$6565f9f03506010b = 512;
const $9b489cd0e48ef132$export$c564cdbbe6da493 = (node)=>$9b489cd0e48ef132$var$textEncoder.encode(JSON.stringify(node));
const $9b489cd0e48ef132$export$2f872c0f2117be69 = (data)=>JSON.parse($9b489cd0e48ef132$var$textDecoder.decode(data));

});

parcelRegister("g6EkA", function(module, exports) {

var $cDo3E = parcelRequire("cDo3E");

var $4WpY9 = parcelRequire("4WpY9");

var $v3LQn = parcelRequire("v3LQn");

var $blxcT = parcelRequire("blxcT");

var $knGCq = parcelRequire("knGCq");

});
parcelRegister("cDo3E", function(module, exports) {

var $4WpY9 = parcelRequire("4WpY9");

var $knGCq = parcelRequire("knGCq");

var $e5IcK = parcelRequire("e5IcK");

var $bTjm8 = parcelRequire("bTjm8");

var $v3LQn = parcelRequire("v3LQn");
class $932bc9f93c164e2c$export$12d863fcef3f6aa {
    constructor(version, code, multihash, bytes){
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: $932bc9f93c164e2c$var$hidden,
            byteLength: $932bc9f93c164e2c$var$hidden,
            code: $932bc9f93c164e2c$var$readonly,
            version: $932bc9f93c164e2c$var$readonly,
            multihash: $932bc9f93c164e2c$var$readonly,
            bytes: $932bc9f93c164e2c$var$readonly,
            _baseCache: $932bc9f93c164e2c$var$hidden,
            asCID: $932bc9f93c164e2c$var$hidden
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code: code, multihash: multihash } = this;
                    if (code !== $932bc9f93c164e2c$var$DAG_PB_CODE) throw new Error("Cannot convert a non dag-pb CID to CIDv0");
                    if (multihash.code !== $932bc9f93c164e2c$var$SHA_256_CODE) throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
                    return $932bc9f93c164e2c$export$12d863fcef3f6aa.createV0(multihash);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code: code, digest: digest } = this.multihash;
                    const multihash = $knGCq.create(code, digest);
                    return $932bc9f93c164e2c$export$12d863fcef3f6aa.createV1(this.code, multihash);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(other) {
        return other && this.code === other.code && this.version === other.version && $knGCq.equals(this.multihash, other.multihash);
    }
    toString(base) {
        const { bytes: bytes, version: version, _baseCache: _baseCache } = this;
        switch(version){
            case 0:
                return $932bc9f93c164e2c$var$toStringV0(bytes, _baseCache, base || (0, $e5IcK.base58btc).encoder);
            default:
                return $932bc9f93c164e2c$var$toStringV1(bytes, _baseCache, base || (0, $bTjm8.base32).encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return "CID";
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return "CID(" + this.toString() + ")";
    }
    static isCID(value) {
        $932bc9f93c164e2c$var$deprecate(/^0\.0/, $932bc9f93c164e2c$var$IS_CID_DEPRECATION);
        return !!(value && (value[$932bc9f93c164e2c$var$cidSymbol] || value.asCID === value));
    }
    get toBaseEncodedString() {
        throw new Error("Deprecated, use .toString()");
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error("Deprecated .buffer property, use .bytes to get Uint8Array instead");
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(value) {
        if (value instanceof $932bc9f93c164e2c$export$12d863fcef3f6aa) return value;
        else if (value != null && value.asCID === value) {
            const { version: version, code: code, multihash: multihash, bytes: bytes } = value;
            return new $932bc9f93c164e2c$export$12d863fcef3f6aa(version, code, multihash, bytes || $932bc9f93c164e2c$var$encodeCID(version, code, multihash.bytes));
        } else if (value != null && value[$932bc9f93c164e2c$var$cidSymbol] === true) {
            const { version: version, multihash: multihash, code: code } = value;
            const digest = $knGCq.decode(multihash);
            return $932bc9f93c164e2c$export$12d863fcef3f6aa.create(version, code, digest);
        } else return null;
    }
    static create(version, code, digest) {
        if (typeof code !== "number") throw new Error("String codecs are no longer supported");
        switch(version){
            case 0:
                if (code !== $932bc9f93c164e2c$var$DAG_PB_CODE) throw new Error(`Version 0 CID must use dag-pb (code: ${$932bc9f93c164e2c$var$DAG_PB_CODE}) block encoding`);
                else return new $932bc9f93c164e2c$export$12d863fcef3f6aa(version, code, digest, digest.bytes);
            case 1:
                {
                    const bytes = $932bc9f93c164e2c$var$encodeCID(version, code, digest.bytes);
                    return new $932bc9f93c164e2c$export$12d863fcef3f6aa(version, code, digest, bytes);
                }
            default:
                throw new Error("Invalid version");
        }
    }
    static createV0(digest) {
        return $932bc9f93c164e2c$export$12d863fcef3f6aa.create(0, $932bc9f93c164e2c$var$DAG_PB_CODE, digest);
    }
    static createV1(code, digest) {
        return $932bc9f93c164e2c$export$12d863fcef3f6aa.create(1, code, digest);
    }
    static decode(bytes) {
        const [cid, remainder] = $932bc9f93c164e2c$export$12d863fcef3f6aa.decodeFirst(bytes);
        if (remainder.length) throw new Error("Incorrect length");
        return cid;
    }
    static decodeFirst(bytes) {
        const specs = $932bc9f93c164e2c$export$12d863fcef3f6aa.inspectBytes(bytes);
        const prefixSize = specs.size - specs.multihashSize;
        const multihashBytes = (0, $v3LQn.coerce)(bytes.subarray(prefixSize, prefixSize + specs.multihashSize));
        if (multihashBytes.byteLength !== specs.multihashSize) throw new Error("Incorrect length");
        const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
        const digest = new $knGCq.Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
        const cid = specs.version === 0 ? $932bc9f93c164e2c$export$12d863fcef3f6aa.createV0(digest) : $932bc9f93c164e2c$export$12d863fcef3f6aa.createV1(specs.codec, digest);
        return [
            cid,
            bytes.subarray(specs.size)
        ];
    }
    static inspectBytes(initialBytes) {
        let offset = 0;
        const next = ()=>{
            const [i, length] = $4WpY9.decode(initialBytes.subarray(offset));
            offset += length;
            return i;
        };
        let version = next();
        let codec = $932bc9f93c164e2c$var$DAG_PB_CODE;
        if (version === 18) {
            version = 0;
            offset = 0;
        } else if (version === 1) codec = next();
        if (version !== 0 && version !== 1) throw new RangeError(`Invalid CID version ${version}`);
        const prefixSize = offset;
        const multihashCode = next();
        const digestSize = next();
        const size = offset + digestSize;
        const multihashSize = size - prefixSize;
        return {
            version: version,
            codec: codec,
            multihashCode: multihashCode,
            digestSize: digestSize,
            multihashSize: multihashSize,
            size: size
        };
    }
    static parse(source, base) {
        const [prefix, bytes] = $932bc9f93c164e2c$var$parseCIDtoBytes(source, base);
        const cid = $932bc9f93c164e2c$export$12d863fcef3f6aa.decode(bytes);
        cid._baseCache.set(prefix, source);
        return cid;
    }
}
const $932bc9f93c164e2c$var$parseCIDtoBytes = (source, base)=>{
    switch(source[0]){
        case "Q":
            {
                const decoder = base || (0, $e5IcK.base58btc);
                return [
                    (0, $e5IcK.base58btc).prefix,
                    decoder.decode(`${(0, $e5IcK.base58btc).prefix}${source}`)
                ];
            }
        case (0, $e5IcK.base58btc).prefix:
            {
                const decoder = base || (0, $e5IcK.base58btc);
                return [
                    (0, $e5IcK.base58btc).prefix,
                    decoder.decode(source)
                ];
            }
        case (0, $bTjm8.base32).prefix:
            {
                const decoder = base || (0, $bTjm8.base32);
                return [
                    (0, $bTjm8.base32).prefix,
                    decoder.decode(source)
                ];
            }
        default:
            if (base == null) throw Error("To parse non base32 or base58btc encoded CID multibase decoder must be provided");
            return [
                source[0],
                base.decode(source)
            ];
    }
};
const $932bc9f93c164e2c$var$toStringV0 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    if (prefix !== (0, $e5IcK.base58btc).prefix) throw Error(`Cannot string encode V0 in ${base.name} encoding`);
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes).slice(1);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $932bc9f93c164e2c$var$toStringV1 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $932bc9f93c164e2c$var$DAG_PB_CODE = 112;
const $932bc9f93c164e2c$var$SHA_256_CODE = 18;
const $932bc9f93c164e2c$var$encodeCID = (version, code, multihash)=>{
    const codeOffset = $4WpY9.encodingLength(version);
    const hashOffset = codeOffset + $4WpY9.encodingLength(code);
    const bytes = new Uint8Array(hashOffset + multihash.byteLength);
    $4WpY9.encodeTo(version, bytes, 0);
    $4WpY9.encodeTo(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
const $932bc9f93c164e2c$var$cidSymbol = Symbol.for("@ipld/js-cid/CID");
const $932bc9f93c164e2c$var$readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
const $932bc9f93c164e2c$var$hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
const $932bc9f93c164e2c$var$version = "0.0.0-dev";
const $932bc9f93c164e2c$var$deprecate = (range, message)=>{
    if (range.test($932bc9f93c164e2c$var$version)) console.warn(message);
    else throw new Error(message);
};
const $932bc9f93c164e2c$var$IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;

});





parcelRegister("iH58P", function(module, exports) {

$parcel$export(module.exports, "toString", () => $d9c03b20d4fb63a0$export$f84e8e69fd4488a5);

var $8XAda = parcelRequire("8XAda");
function $d9c03b20d4fb63a0$export$f84e8e69fd4488a5(array, encoding = "utf8") {
    const base = (0, $8XAda.default)[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString("utf8");
    return base.encoder.encode(array).substring(1);
}

});

parcelRegister("amriN", function(module, exports) {

var $zPrTJ = parcelRequire("zPrTJ");
function $78b12313874807f5$export$6444ef5cd411280c(a, b) {
    if (a.length !== b.length) throw new Error("Inputs should have the same length");
    const result = (0, $zPrTJ.allocUnsafe)(a.length);
    for(let i = 0; i < a.length; i++)result[i] = a[i] ^ b[i];
    return result;
}

});


parcelRegister("lfcmX", function(module, exports) {

$parcel$export(module.exports, "RELAY_JSONRPC", () => $f77497fb5ba33799$export$af490b3b9a6de00f);
function $f77497fb5ba33799$var$e(s, r, i = "string") {
    if (!s[r] || typeof s[r] !== i) throw new Error(`Missing or invalid "${r}" param`);
}
function $f77497fb5ba33799$var$l(s, r) {
    let i = !0;
    return r.forEach((t)=>{
        t in s || (i = !1);
    }), i;
}
function $f77497fb5ba33799$var$f(s, r) {
    return Array.isArray(s) ? s.length === r : Object.keys(s).length === r;
}
function $f77497fb5ba33799$var$w(s, r) {
    return Array.isArray(s) ? s.length >= r : Object.keys(s).length >= r;
}
function $f77497fb5ba33799$var$u(s, r, i) {
    return (i.length ? $f77497fb5ba33799$var$w(s, r.length) : $f77497fb5ba33799$var$f(s, r.length)) ? $f77497fb5ba33799$var$l(s, r) : !1;
}
function $f77497fb5ba33799$var$n(s, r, i = "_") {
    const t = s.split(i);
    return t[t.length - 1].trim().toLowerCase() === r.trim().toLowerCase();
}
function $f77497fb5ba33799$export$c75580565fa025bd(s) {
    return $f77497fb5ba33799$export$f576347163de0984(s.method) && $f77497fb5ba33799$export$dae2311546d43680(s.params);
}
function $f77497fb5ba33799$export$f576347163de0984(s) {
    return $f77497fb5ba33799$var$n(s, "subscribe");
}
function $f77497fb5ba33799$export$dae2311546d43680(s) {
    return $f77497fb5ba33799$var$u(s, [
        "topic"
    ], []);
}
function $f77497fb5ba33799$export$8fa7cf76b41caee0(s) {
    return $f77497fb5ba33799$export$71d4d33ac7f7a269(s.method) && $f77497fb5ba33799$export$71e8d1aa48c3e86f(s.params);
}
function $f77497fb5ba33799$export$71d4d33ac7f7a269(s) {
    return $f77497fb5ba33799$var$n(s, "publish");
}
function $f77497fb5ba33799$export$71e8d1aa48c3e86f(s) {
    return $f77497fb5ba33799$var$u(s, [
        "message",
        "topic",
        "ttl"
    ], [
        "prompt",
        "tag"
    ]);
}
function $f77497fb5ba33799$export$83e292763180b41b(s) {
    return $f77497fb5ba33799$export$568d956f39536025(s.method) && $f77497fb5ba33799$export$cbc597c53c3b4f80(s.params);
}
function $f77497fb5ba33799$export$568d956f39536025(s) {
    return $f77497fb5ba33799$var$n(s, "unsubscribe");
}
function $f77497fb5ba33799$export$cbc597c53c3b4f80(s) {
    return $f77497fb5ba33799$var$u(s, [
        "id",
        "topic"
    ], []);
}
function $f77497fb5ba33799$export$43cf4100d6287b8e(s) {
    return $f77497fb5ba33799$export$3cb4ad320e3a46a4(s.method) && $f77497fb5ba33799$export$6366ff9a39f2da4c(s.params);
}
function $f77497fb5ba33799$export$3cb4ad320e3a46a4(s) {
    return $f77497fb5ba33799$var$n(s, "subscription");
}
function $f77497fb5ba33799$export$6366ff9a39f2da4c(s) {
    return $f77497fb5ba33799$var$u(s, [
        "id",
        "data"
    ], []);
}
function $f77497fb5ba33799$export$abdf96c288cb375(s) {
    if (!$f77497fb5ba33799$export$f576347163de0984(s.method)) throw new Error("JSON-RPC Request has invalid subscribe method");
    if (!$f77497fb5ba33799$export$dae2311546d43680(s.params)) throw new Error("JSON-RPC Request has invalid subscribe params");
    const r = s.params;
    return $f77497fb5ba33799$var$e(r, "topic"), r;
}
function $f77497fb5ba33799$export$eac3e45ac5c5c9fa(s) {
    if (!$f77497fb5ba33799$export$71d4d33ac7f7a269(s.method)) throw new Error("JSON-RPC Request has invalid publish method");
    if (!$f77497fb5ba33799$export$71e8d1aa48c3e86f(s.params)) throw new Error("JSON-RPC Request has invalid publish params");
    const r = s.params;
    return $f77497fb5ba33799$var$e(r, "topic"), $f77497fb5ba33799$var$e(r, "message"), $f77497fb5ba33799$var$e(r, "ttl", "number"), r;
}
function $f77497fb5ba33799$export$78baa72f78156594(s) {
    if (!$f77497fb5ba33799$export$568d956f39536025(s.method)) throw new Error("JSON-RPC Request has invalid unsubscribe method");
    if (!$f77497fb5ba33799$export$cbc597c53c3b4f80(s.params)) throw new Error("JSON-RPC Request has invalid unsubscribe params");
    const r = s.params;
    return $f77497fb5ba33799$var$e(r, "id"), r;
}
function $f77497fb5ba33799$export$4d5822edd41f3b48(s) {
    if (!$f77497fb5ba33799$export$3cb4ad320e3a46a4(s.method)) throw new Error("JSON-RPC Request has invalid subscription method");
    if (!$f77497fb5ba33799$export$6366ff9a39f2da4c(s.params)) throw new Error("JSON-RPC Request has invalid subscription params");
    const r = s.params;
    return $f77497fb5ba33799$var$e(r, "id"), $f77497fb5ba33799$var$e(r, "data"), r;
}
const $f77497fb5ba33799$export$af490b3b9a6de00f = {
    waku: {
        publish: "waku_publish",
        batchPublish: "waku_batchPublish",
        subscribe: "waku_subscribe",
        batchSubscribe: "waku_batchSubscribe",
        subscription: "waku_subscription",
        unsubscribe: "waku_unsubscribe",
        batchUnsubscribe: "waku_batchUnsubscribe",
        batchFetchMessages: "waku_batchFetchMessages"
    },
    irn: {
        publish: "irn_publish",
        batchPublish: "irn_batchPublish",
        subscribe: "irn_subscribe",
        batchSubscribe: "irn_batchSubscribe",
        subscription: "irn_subscription",
        unsubscribe: "irn_unsubscribe",
        batchUnsubscribe: "irn_batchUnsubscribe",
        batchFetchMessages: "irn_batchFetchMessages"
    },
    iridium: {
        publish: "iridium_publish",
        batchPublish: "iridium_batchPublish",
        subscribe: "iridium_subscribe",
        batchSubscribe: "iridium_batchSubscribe",
        subscription: "iridium_subscription",
        unsubscribe: "iridium_unsubscribe",
        batchUnsubscribe: "iridium_batchUnsubscribe",
        batchFetchMessages: "iridium_batchFetchMessages"
    }
};

});


parcelRegister("1EAvo", function(module, exports) {

$parcel$export(module.exports, "JsonRpcProvider", () => $1345d816cc1fcc39$export$da28308012bf6748);

var $5yFVO = parcelRequire("5yFVO");
parcelRequire("7IWKC");
var $fHodW = parcelRequire("fHodW");
var $fYdYk = parcelRequire("fYdYk");
var $fgWWx = parcelRequire("fgWWx");
class $1345d816cc1fcc39$export$da28308012bf6748 extends (0, $fYdYk.IJsonRpcProvider) {
    constructor(t){
        super(t), this.events = new (0, $5yFVO.EventEmitter), this.hasRegisteredEventListeners = !1, this.connection = this.setConnection(t), this.connection.connected && this.registerEventListeners();
    }
    async connect(t = this.connection) {
        await this.open(t);
    }
    async disconnect() {
        await this.close();
    }
    on(t, e) {
        this.events.on(t, e);
    }
    once(t, e) {
        this.events.once(t, e);
    }
    off(t, e) {
        this.events.off(t, e);
    }
    removeListener(t, e) {
        this.events.removeListener(t, e);
    }
    async request(t, e) {
        return this.requestStrict((0, $fHodW.formatJsonRpcRequest)(t.method, t.params || [], t.id || (0, $fHodW.getBigIntRpcId)().toString()), e);
    }
    async requestStrict(t, e) {
        return new Promise(async (i, s)=>{
            if (!this.connection.connected) try {
                await this.open();
            } catch (n) {
                s(n);
            }
            this.events.on(`${t.id}`, (n)=>{
                (0, $fgWWx.isJsonRpcError)(n) ? s(n.error) : i(n.result);
            });
            try {
                await this.connection.send(t, e);
            } catch (n) {
                s(n);
            }
        });
    }
    setConnection(t = this.connection) {
        return t;
    }
    onPayload(t) {
        this.events.emit("payload", t), (0, $fgWWx.isJsonRpcResponse)(t) ? this.events.emit(`${t.id}`, t) : this.events.emit("message", {
            type: t.method,
            data: t.params
        });
    }
    onClose(t) {
        t && t.code === 3e3 && this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${t.code} ${t.reason ? `(${t.reason})` : ""}`)), this.events.emit("disconnect");
    }
    async open(t = this.connection) {
        this.connection === t && this.connection.connected || (this.connection.connected && this.close(), typeof t == "string" && (await this.connection.open(t), t = this.connection), this.connection = this.setConnection(t), await this.connection.open(), this.registerEventListeners(), this.events.emit("connect"));
    }
    async close() {
        await this.connection.close();
    }
    registerEventListeners() {
        this.hasRegisteredEventListeners || (this.connection.on("payload", (t)=>this.onPayload(t)), this.connection.on("close", (t)=>this.onClose(t)), this.connection.on("error", (t)=>this.events.emit("error", t)), this.connection.on("register_error", (t)=>this.onClose()), this.hasRegisteredEventListeners = !0);
    }
}

});
parcelRegister("7IWKC", function(module, exports) {
$parcel$export(module.exports, "parseConnectionError", () => (parcelRequire("64EFX")).parseConnectionError);
$parcel$export(module.exports, "formatJsonRpcError", () => (parcelRequire("hj3eH")).formatJsonRpcError);
$parcel$export(module.exports, "formatJsonRpcRequest", () => (parcelRequire("hj3eH")).formatJsonRpcRequest);
$parcel$export(module.exports, "formatJsonRpcResult", () => (parcelRequire("hj3eH")).formatJsonRpcResult);
$parcel$export(module.exports, "getBigIntRpcId", () => (parcelRequire("hj3eH")).getBigIntRpcId);
$parcel$export(module.exports, "IJsonRpcProvider", () => (parcelRequire("hj3eH")).IJsonRpcProvider);
$parcel$export(module.exports, "isHttpUrl", () => (parcelRequire("hj3eH")).isHttpUrl);
$parcel$export(module.exports, "isJsonRpcError", () => (parcelRequire("hj3eH")).isJsonRpcError);
$parcel$export(module.exports, "isJsonRpcRequest", () => (parcelRequire("hj3eH")).isJsonRpcRequest);
$parcel$export(module.exports, "isJsonRpcResponse", () => (parcelRequire("hj3eH")).isJsonRpcResponse);
$parcel$export(module.exports, "isJsonRpcResult", () => (parcelRequire("hj3eH")).isJsonRpcResult);
$parcel$export(module.exports, "isLocalhostUrl", () => (parcelRequire("hj3eH")).isLocalhostUrl);
$parcel$export(module.exports, "isReactNative", () => (parcelRequire("hj3eH")).isReactNative);
$parcel$export(module.exports, "isWsUrl", () => (parcelRequire("hj3eH")).isWsUrl);
$parcel$export(module.exports, "parseConnectionError", () => (parcelRequire("hj3eH")).parseConnectionError);
$parcel$export(module.exports, "payloadId", () => (parcelRequire("hj3eH")).payloadId);
$parcel$export(module.exports, "formatJsonRpcError", () => (parcelRequire("fHodW")).formatJsonRpcError);
$parcel$export(module.exports, "formatJsonRpcRequest", () => (parcelRequire("fHodW")).formatJsonRpcRequest);
$parcel$export(module.exports, "formatJsonRpcResult", () => (parcelRequire("fHodW")).formatJsonRpcResult);
$parcel$export(module.exports, "getBigIntRpcId", () => (parcelRequire("fHodW")).getBigIntRpcId);
$parcel$export(module.exports, "payloadId", () => (parcelRequire("fHodW")).payloadId);
$parcel$export(module.exports, "IJsonRpcProvider", () => (parcelRequire("fYdYk")).IJsonRpcProvider);
$parcel$export(module.exports, "isHttpUrl", () => (parcelRequire("bb82n")).isHttpUrl);
$parcel$export(module.exports, "isLocalhostUrl", () => (parcelRequire("bb82n")).isLocalhostUrl);
$parcel$export(module.exports, "isWsUrl", () => (parcelRequire("bb82n")).isWsUrl);
$parcel$export(module.exports, "isJsonRpcError", () => (parcelRequire("fgWWx")).isJsonRpcError);
$parcel$export(module.exports, "isJsonRpcRequest", () => (parcelRequire("fgWWx")).isJsonRpcRequest);
$parcel$export(module.exports, "isJsonRpcResponse", () => (parcelRequire("fgWWx")).isJsonRpcResponse);
$parcel$export(module.exports, "isJsonRpcResult", () => (parcelRequire("fgWWx")).isJsonRpcResult);
parcelRequire("1IAVq");
parcelRequire("64EFX");
parcelRequire("84V9C");
parcelRequire("fHodW");
parcelRequire("6TkXv");
parcelRequire("gSWz8");
parcelRequire("bb82n");
parcelRequire("fgWWx");

});
parcelRegister("1IAVq", function(module, exports) {

$parcel$export(module.exports, "INTERNAL_ERROR", () => $14068b1671432bb8$export$f6e3abf3038d348f);
$parcel$export(module.exports, "SERVER_ERROR", () => $14068b1671432bb8$export$125ebd30471ac25c);
$parcel$export(module.exports, "RESERVED_ERROR_CODES", () => $14068b1671432bb8$export$af84821b5448ca78);
$parcel$export(module.exports, "SERVER_ERROR_CODE_RANGE", () => $14068b1671432bb8$export$fff5b44b15c75f69);
$parcel$export(module.exports, "STANDARD_ERROR_MAP", () => $14068b1671432bb8$export$cca5387ab287e1ae);
$parcel$export(module.exports, "DEFAULT_ERROR", () => $14068b1671432bb8$export$d166979eca925bce);
const $14068b1671432bb8$export$2ecaad7eb5cc1f25 = "PARSE_ERROR";
const $14068b1671432bb8$export$c77b2f9ece3946ce = "INVALID_REQUEST";
const $14068b1671432bb8$export$e8d537b30db778d6 = "METHOD_NOT_FOUND";
const $14068b1671432bb8$export$13aae195c7978fb1 = "INVALID_PARAMS";
const $14068b1671432bb8$export$f6e3abf3038d348f = "INTERNAL_ERROR";
const $14068b1671432bb8$export$125ebd30471ac25c = "SERVER_ERROR";
const $14068b1671432bb8$export$af84821b5448ca78 = [
    -32700,
    -32600,
    -32601,
    -32602,
    -32603
];
const $14068b1671432bb8$export$fff5b44b15c75f69 = [
    -32000,
    -32099
];
const $14068b1671432bb8$export$cca5387ab287e1ae = {
    [$14068b1671432bb8$export$2ecaad7eb5cc1f25]: {
        code: -32700,
        message: "Parse error"
    },
    [$14068b1671432bb8$export$c77b2f9ece3946ce]: {
        code: -32600,
        message: "Invalid Request"
    },
    [$14068b1671432bb8$export$e8d537b30db778d6]: {
        code: -32601,
        message: "Method not found"
    },
    [$14068b1671432bb8$export$13aae195c7978fb1]: {
        code: -32602,
        message: "Invalid params"
    },
    [$14068b1671432bb8$export$f6e3abf3038d348f]: {
        code: -32603,
        message: "Internal error"
    },
    [$14068b1671432bb8$export$125ebd30471ac25c]: {
        code: -32000,
        message: "Server error"
    }
};
const $14068b1671432bb8$export$d166979eca925bce = $14068b1671432bb8$export$125ebd30471ac25c;

});

parcelRegister("64EFX", function(module, exports) {

$parcel$export(module.exports, "isReservedErrorCode", () => $46c2ab2498d52013$export$2ae0ec6393ab16c3);
$parcel$export(module.exports, "getError", () => $46c2ab2498d52013$export$e1599abf47b5b568);
$parcel$export(module.exports, "getErrorByCode", () => $46c2ab2498d52013$export$60a3bac005957e12);
$parcel$export(module.exports, "parseConnectionError", () => $46c2ab2498d52013$export$f555d7d8f922e407);

var $1IAVq = parcelRequire("1IAVq");
function $46c2ab2498d52013$export$e463129eb4bc487f(code) {
    return code <= (0, $1IAVq.SERVER_ERROR_CODE_RANGE)[0] && code >= (0, $1IAVq.SERVER_ERROR_CODE_RANGE)[1];
}
function $46c2ab2498d52013$export$2ae0ec6393ab16c3(code) {
    return (0, $1IAVq.RESERVED_ERROR_CODES).includes(code);
}
function $46c2ab2498d52013$export$7543109e66e1748d(code) {
    return typeof code === "number";
}
function $46c2ab2498d52013$export$e1599abf47b5b568(type) {
    if (!Object.keys((0, $1IAVq.STANDARD_ERROR_MAP)).includes(type)) return (0, $1IAVq.STANDARD_ERROR_MAP)[0, $1IAVq.DEFAULT_ERROR];
    return (0, $1IAVq.STANDARD_ERROR_MAP)[type];
}
function $46c2ab2498d52013$export$60a3bac005957e12(code) {
    const match = Object.values((0, $1IAVq.STANDARD_ERROR_MAP)).find((e)=>e.code === code);
    if (!match) return (0, $1IAVq.STANDARD_ERROR_MAP)[0, $1IAVq.DEFAULT_ERROR];
    return match;
}
function $46c2ab2498d52013$export$6be064b82176dd99(response) {
    if (typeof response.error.code === "undefined") return {
        valid: false,
        error: "Missing code for JSON-RPC error"
    };
    if (typeof response.error.message === "undefined") return {
        valid: false,
        error: "Missing message for JSON-RPC error"
    };
    if (!$46c2ab2498d52013$export$7543109e66e1748d(response.error.code)) return {
        valid: false,
        error: `Invalid error code type for JSON-RPC: ${response.error.code}`
    };
    if ($46c2ab2498d52013$export$2ae0ec6393ab16c3(response.error.code)) {
        const error = $46c2ab2498d52013$export$60a3bac005957e12(response.error.code);
        if (error.message !== (0, $1IAVq.STANDARD_ERROR_MAP)[0, $1IAVq.DEFAULT_ERROR].message && response.error.message === error.message) return {
            valid: false,
            error: `Invalid error code message for JSON-RPC: ${response.error.code}`
        };
    }
    return {
        valid: true
    };
}
function $46c2ab2498d52013$export$f555d7d8f922e407(e, url, type) {
    return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${type} RPC url at ${url}`) : e;
}

});

parcelRegister("84V9C", function(module, exports) {

var $hj3eH = parcelRequire("hj3eH");
const $5e1b08107a558550$export$d1694901a048d7c8 = (0, $hj3eH.isNode);
$parcel$exportWildcard(module.exports, $hj3eH);

});
parcelRegister("hj3eH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kZbRE = parcelRequire("kZbRE");

$kZbRE.__exportStar((parcelRequire("iRMgy")), module.exports);

$kZbRE.__exportStar((parcelRequire("aCu77")), module.exports);

});
parcelRegister("iRMgy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowserCryptoAvailable = module.exports.getSubtleCrypto = module.exports.getBrowerCrypto = void 0;
function $038b65a4a3acc71e$var$getBrowerCrypto() {
    return ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.crypto) || ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.msCrypto) || {};
}
module.exports.getBrowerCrypto = $038b65a4a3acc71e$var$getBrowerCrypto;
function $038b65a4a3acc71e$var$getSubtleCrypto() {
    const browserCrypto = $038b65a4a3acc71e$var$getBrowerCrypto();
    return browserCrypto.subtle || browserCrypto.webkitSubtle;
}
module.exports.getSubtleCrypto = $038b65a4a3acc71e$var$getSubtleCrypto;
function $038b65a4a3acc71e$var$isBrowserCryptoAvailable() {
    return !!$038b65a4a3acc71e$var$getBrowerCrypto() && !!$038b65a4a3acc71e$var$getSubtleCrypto();
}
module.exports.isBrowserCryptoAvailable = $038b65a4a3acc71e$var$isBrowserCryptoAvailable;

});

parcelRegister("aCu77", function(module, exports) {

var $kuzpm = parcelRequire("kuzpm");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowser = module.exports.isNode = module.exports.isReactNative = void 0;
function $7bb4cff3e4393658$var$isReactNative() {
    return typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative";
}
module.exports.isReactNative = $7bb4cff3e4393658$var$isReactNative;
function $7bb4cff3e4393658$var$isNode() {
    return typeof $kuzpm !== "undefined" && typeof $kuzpm.versions !== "undefined" && typeof $kuzpm.versions.node !== "undefined";
}
module.exports.isNode = $7bb4cff3e4393658$var$isNode;
function $7bb4cff3e4393658$var$isBrowser() {
    return !$7bb4cff3e4393658$var$isReactNative() && !$7bb4cff3e4393658$var$isNode();
}
module.exports.isBrowser = $7bb4cff3e4393658$var$isBrowser;

});



parcelRegister("fHodW", function(module, exports) {

$parcel$export(module.exports, "payloadId", () => $b6dda98ab6c1477f$export$2f5364a5d4b80251);
$parcel$export(module.exports, "getBigIntRpcId", () => $b6dda98ab6c1477f$export$799a3db5df197877);
$parcel$export(module.exports, "formatJsonRpcRequest", () => $b6dda98ab6c1477f$export$11d081ebb32d4398);
$parcel$export(module.exports, "formatJsonRpcResult", () => $b6dda98ab6c1477f$export$478fdea01c2a3198);
$parcel$export(module.exports, "formatJsonRpcError", () => $b6dda98ab6c1477f$export$9f7302ae26c3f77);

var $64EFX = parcelRequire("64EFX");

var $1IAVq = parcelRequire("1IAVq");
function $b6dda98ab6c1477f$export$2f5364a5d4b80251(entropy = 3) {
    const date = Date.now() * Math.pow(10, entropy);
    const extra = Math.floor(Math.random() * Math.pow(10, entropy));
    return date + extra;
}
function $b6dda98ab6c1477f$export$799a3db5df197877(entropy = 6) {
    return BigInt($b6dda98ab6c1477f$export$2f5364a5d4b80251(entropy));
}
function $b6dda98ab6c1477f$export$11d081ebb32d4398(method, params, id) {
    return {
        id: id || $b6dda98ab6c1477f$export$2f5364a5d4b80251(),
        jsonrpc: "2.0",
        method: method,
        params: params
    };
}
function $b6dda98ab6c1477f$export$478fdea01c2a3198(id, result) {
    return {
        id: id,
        jsonrpc: "2.0",
        result: result
    };
}
function $b6dda98ab6c1477f$export$9f7302ae26c3f77(id, error, data) {
    return {
        id: id,
        jsonrpc: "2.0",
        error: $b6dda98ab6c1477f$export$5201d50a34753d71(error, data)
    };
}
function $b6dda98ab6c1477f$export$5201d50a34753d71(error, data) {
    if (typeof error === "undefined") return (0, $64EFX.getError)((0, $1IAVq.INTERNAL_ERROR));
    if (typeof error === "string") error = Object.assign(Object.assign({}, (0, $64EFX.getError)((0, $1IAVq.SERVER_ERROR))), {
        message: error
    });
    if (typeof data !== "undefined") error.data = data;
    if ((0, $64EFX.isReservedErrorCode)(error.code)) error = (0, $64EFX.getErrorByCode)(error.code);
    return error;
}

});

parcelRegister("6TkXv", function(module, exports) {
function $50482315e7536821$export$9f3e656a7f6a3adc(route) {
    if (route.includes("*")) return $50482315e7536821$export$8e8b9bea55b56df2(route);
    if (/\W/g.test(route)) return false;
    return true;
}
function $50482315e7536821$export$c7e2040809cad2c4(route) {
    return route === "*";
}
function $50482315e7536821$export$8e8b9bea55b56df2(route) {
    if ($50482315e7536821$export$c7e2040809cad2c4(route)) return true;
    if (!route.includes("*")) return false;
    if (route.split("*").length !== 2) return false;
    if (route.split("*").filter((x)=>x.trim() === "").length !== 1) return false;
    return true;
}
function $50482315e7536821$export$2d48faaafcc8fbdc(route) {
    return !$50482315e7536821$export$c7e2040809cad2c4(route) && $50482315e7536821$export$8e8b9bea55b56df2(route) && !route.split("*")[0].trim();
}
function $50482315e7536821$export$be298a4710fab756(route) {
    return !$50482315e7536821$export$c7e2040809cad2c4(route) && $50482315e7536821$export$8e8b9bea55b56df2(route) && !route.split("*")[1].trim();
}

});

parcelRegister("gSWz8", function(module, exports) {
$parcel$export(module.exports, "IJsonRpcProvider", () => (parcelRequire("fYdYk")).IJsonRpcProvider);
parcelRequire("fYdYk");

});
parcelRegister("fYdYk", function(module, exports) {

$parcel$export(module.exports, "IJsonRpcProvider", () => $ba074c2839d54c9b$export$46957420a688a16d);
class $ba074c2839d54c9b$export$ab429ec7e240e546 {
}
class $ba074c2839d54c9b$export$77d426dd89724fbe extends $ba074c2839d54c9b$export$ab429ec7e240e546 {
    constructor(c){
        super();
    }
}
class $ba074c2839d54c9b$export$cb916a2eed49af33 extends $ba074c2839d54c9b$export$ab429ec7e240e546 {
    constructor(){
        super();
    }
}
class $ba074c2839d54c9b$export$46957420a688a16d extends $ba074c2839d54c9b$export$cb916a2eed49af33 {
    constructor(c){
        super();
    }
}

});


parcelRegister("bb82n", function(module, exports) {

$parcel$export(module.exports, "isHttpUrl", () => $8236f4d273baf4c5$export$206c3129b8bb1b4f);
$parcel$export(module.exports, "isWsUrl", () => $8236f4d273baf4c5$export$4e4463e75eccf20c);
$parcel$export(module.exports, "isLocalhostUrl", () => $8236f4d273baf4c5$export$8eb4a0a481601f29);
const $8236f4d273baf4c5$var$HTTP_REGEX = "^https?:";
const $8236f4d273baf4c5$var$WS_REGEX = "^wss?:";
function $8236f4d273baf4c5$var$getUrlProtocol(url) {
    const matches = url.match(new RegExp(/^\w+:/, "gi"));
    if (!matches || !matches.length) return;
    return matches[0];
}
function $8236f4d273baf4c5$var$matchRegexProtocol(url, regex) {
    const protocol = $8236f4d273baf4c5$var$getUrlProtocol(url);
    if (typeof protocol === "undefined") return false;
    return new RegExp(regex).test(protocol);
}
function $8236f4d273baf4c5$export$206c3129b8bb1b4f(url) {
    return $8236f4d273baf4c5$var$matchRegexProtocol(url, $8236f4d273baf4c5$var$HTTP_REGEX);
}
function $8236f4d273baf4c5$export$4e4463e75eccf20c(url) {
    return $8236f4d273baf4c5$var$matchRegexProtocol(url, $8236f4d273baf4c5$var$WS_REGEX);
}
function $8236f4d273baf4c5$export$8eb4a0a481601f29(url) {
    return new RegExp("wss?://localhost(:d{2,5})?").test(url);
}

});

parcelRegister("fgWWx", function(module, exports) {

$parcel$export(module.exports, "isJsonRpcRequest", () => $b1e612823b60c367$export$f6e4034abe07d2a5);
$parcel$export(module.exports, "isJsonRpcResponse", () => $b1e612823b60c367$export$308ba927de2bcbe8);
$parcel$export(module.exports, "isJsonRpcResult", () => $b1e612823b60c367$export$cb3d3b20e3223d77);
$parcel$export(module.exports, "isJsonRpcError", () => $b1e612823b60c367$export$5662a1047b4d1d15);
function $b1e612823b60c367$export$bf3617e9fafa893f(payload) {
    return typeof payload === "object" && "id" in payload && "jsonrpc" in payload && payload.jsonrpc === "2.0";
}
function $b1e612823b60c367$export$f6e4034abe07d2a5(payload) {
    return $b1e612823b60c367$export$bf3617e9fafa893f(payload) && "method" in payload;
}
function $b1e612823b60c367$export$308ba927de2bcbe8(payload) {
    return $b1e612823b60c367$export$bf3617e9fafa893f(payload) && ($b1e612823b60c367$export$cb3d3b20e3223d77(payload) || $b1e612823b60c367$export$5662a1047b4d1d15(payload));
}
function $b1e612823b60c367$export$cb3d3b20e3223d77(payload) {
    return "result" in payload;
}
function $b1e612823b60c367$export$5662a1047b4d1d15(payload) {
    return "error" in payload;
}
function $b1e612823b60c367$export$ae97720cc2d120d4(validation) {
    return "error" in validation && validation.valid === false;
}

});



parcelRegister("7XH1l", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cbf6a1455c03acf$export$ea0df116fa892998);

var $5yFVO = parcelRequire("5yFVO");

var $bREX4 = parcelRequire("bREX4");
parcelRequire("7IWKC");
var $fHodW = parcelRequire("fHodW");
var $bb82n = parcelRequire("bb82n");
var $hj3eH = parcelRequire("hj3eH");
var $64EFX = parcelRequire("64EFX");

const $5cbf6a1455c03acf$var$v = ()=>typeof WebSocket < "u" ? WebSocket : typeof $parcel$global < "u" && typeof $parcel$global.WebSocket < "u" ? $parcel$global.WebSocket : typeof window < "u" && typeof window.WebSocket < "u" ? window.WebSocket : typeof self < "u" && typeof self.WebSocket < "u" ? self.WebSocket : (parcelRequire("8QwLo")), $5cbf6a1455c03acf$var$w = ()=>typeof WebSocket < "u" || typeof $parcel$global < "u" && typeof $parcel$global.WebSocket < "u" || typeof window < "u" && typeof window.WebSocket < "u" || typeof self < "u" && typeof self.WebSocket < "u", $5cbf6a1455c03acf$var$d = (r)=>r.split("?")[0], $5cbf6a1455c03acf$var$h = 10, $5cbf6a1455c03acf$var$b = $5cbf6a1455c03acf$var$v();
class $5cbf6a1455c03acf$export$ea0df116fa892998 {
    constructor(e){
        if (this.url = e, this.events = new (0, $5yFVO.EventEmitter), this.registering = !1, !(0, $bb82n.isWsUrl)(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
        this.url = e;
    }
    get connected() {
        return typeof this.socket < "u";
    }
    get connecting() {
        return this.registering;
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async open(e = this.url) {
        await this.register(e);
    }
    async close() {
        return new Promise((e, t)=>{
            if (typeof this.socket > "u") {
                t(new Error("Connection already closed"));
                return;
            }
            this.socket.onclose = (n)=>{
                this.onClose(n), e();
            }, this.socket.close();
        });
    }
    async send(e) {
        typeof this.socket > "u" && (this.socket = await this.register());
        try {
            this.socket.send((0, $bREX4.safeJsonStringify)(e));
        } catch (t) {
            this.onError(e.id, t);
        }
    }
    register(e = this.url) {
        if (!(0, $bb82n.isWsUrl)(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
        if (this.registering) {
            const t = this.events.getMaxListeners();
            return (this.events.listenerCount("register_error") >= t || this.events.listenerCount("open") >= t) && this.events.setMaxListeners(t + 1), new Promise((n, s)=>{
                this.events.once("register_error", (o)=>{
                    this.resetMaxListeners(), s(o);
                }), this.events.once("open", ()=>{
                    if (this.resetMaxListeners(), typeof this.socket > "u") return s(new Error("WebSocket connection is missing or invalid"));
                    n(this.socket);
                });
            });
        }
        return this.url = e, this.registering = !0, new Promise((t, n)=>{
            const s = (0, $hj3eH.isReactNative)() ? void 0 : {
                rejectUnauthorized: !(0, $bb82n.isLocalhostUrl)(e)
            }, o = new $5cbf6a1455c03acf$var$b(e, [], s);
            $5cbf6a1455c03acf$var$w() ? o.onerror = (i)=>{
                const a = i;
                n(this.emitError(a.error));
            } : o.on("error", (i)=>{
                n(this.emitError(i));
            }), o.onopen = ()=>{
                this.onOpen(o), t(o);
            };
        });
    }
    onOpen(e) {
        e.onmessage = (t)=>this.onPayload(t), e.onclose = (t)=>this.onClose(t), this.socket = e, this.registering = !1, this.events.emit("open");
    }
    onClose(e) {
        this.socket = void 0, this.registering = !1, this.events.emit("close", e);
    }
    onPayload(e) {
        if (typeof e.data > "u") return;
        const t = typeof e.data == "string" ? (0, $bREX4.safeJsonParse)(e.data) : e.data;
        this.events.emit("payload", t);
    }
    onError(e, t) {
        const n = this.parseError(t), s = n.message || n.toString(), o = (0, $fHodW.formatJsonRpcError)(e, s);
        this.events.emit("payload", o);
    }
    parseError(e, t = this.url) {
        return (0, $64EFX.parseConnectionError)(e, $5cbf6a1455c03acf$var$d(t), "WS");
    }
    resetMaxListeners() {
        this.events.getMaxListeners() > $5cbf6a1455c03acf$var$h && this.events.setMaxListeners($5cbf6a1455c03acf$var$h);
    }
    emitError(e) {
        const t = this.parseError(new Error(e?.message || `WebSocket connection failed for host: ${$5cbf6a1455c03acf$var$d(this.url)}`));
        return this.events.emit("register_error", t), t;
    }
}

});
parcelRegister("8QwLo", function(module, exports) {
"use strict";
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

});




parcelRegister("eAMDx", function(module, exports) {

$parcel$export(module.exports, "HttpConnection", () => $a9fa27b9c109c5b0$export$13c1f9cf8a283575);
$parcel$export(module.exports, "default", () => $a9fa27b9c109c5b0$export$13c1f9cf8a283575);

var $5yFVO = parcelRequire("5yFVO");

var $byIIQ = parcelRequire("byIIQ");

var $bREX4 = parcelRequire("bREX4");
parcelRequire("7IWKC");
var $fHodW = parcelRequire("fHodW");
var $bb82n = parcelRequire("bb82n");
var $64EFX = parcelRequire("64EFX");
var $a9fa27b9c109c5b0$var$P = Object.defineProperty, $a9fa27b9c109c5b0$var$w = Object.defineProperties, $a9fa27b9c109c5b0$var$E = Object.getOwnPropertyDescriptors, $a9fa27b9c109c5b0$var$c = Object.getOwnPropertySymbols, $a9fa27b9c109c5b0$var$L = Object.prototype.hasOwnProperty, $a9fa27b9c109c5b0$var$O = Object.prototype.propertyIsEnumerable, $a9fa27b9c109c5b0$var$l = (r, t, e)=>t in r ? $a9fa27b9c109c5b0$var$P(r, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : r[t] = e, $a9fa27b9c109c5b0$var$p = (r, t)=>{
    for(var e in t || (t = {}))$a9fa27b9c109c5b0$var$L.call(t, e) && $a9fa27b9c109c5b0$var$l(r, e, t[e]);
    if ($a9fa27b9c109c5b0$var$c) for (var e of $a9fa27b9c109c5b0$var$c(t))$a9fa27b9c109c5b0$var$O.call(t, e) && $a9fa27b9c109c5b0$var$l(r, e, t[e]);
    return r;
}, $a9fa27b9c109c5b0$var$v = (r, t)=>$a9fa27b9c109c5b0$var$w(r, $a9fa27b9c109c5b0$var$E(t));
const $a9fa27b9c109c5b0$var$j = {
    Accept: "application/json",
    "Content-Type": "application/json"
}, $a9fa27b9c109c5b0$var$T = "POST", $a9fa27b9c109c5b0$var$d = {
    headers: $a9fa27b9c109c5b0$var$j,
    method: $a9fa27b9c109c5b0$var$T
}, $a9fa27b9c109c5b0$var$g = 10;
class $a9fa27b9c109c5b0$export$13c1f9cf8a283575 {
    constructor(t, e = !1){
        if (this.url = t, this.disableProviderPing = e, this.events = new (0, $5yFVO.EventEmitter), this.isAvailable = !1, this.registering = !1, !(0, $bb82n.isHttpUrl)(t)) throw new Error(`Provided URL is not compatible with HTTP connection: ${t}`);
        this.url = t, this.disableProviderPing = e;
    }
    get connected() {
        return this.isAvailable;
    }
    get connecting() {
        return this.registering;
    }
    on(t, e) {
        this.events.on(t, e);
    }
    once(t, e) {
        this.events.once(t, e);
    }
    off(t, e) {
        this.events.off(t, e);
    }
    removeListener(t, e) {
        this.events.removeListener(t, e);
    }
    async open(t = this.url) {
        await this.register(t);
    }
    async close() {
        if (!this.isAvailable) throw new Error("Connection already closed");
        this.onClose();
    }
    async send(t) {
        this.isAvailable || await this.register();
        try {
            const e = (0, $bREX4.safeJsonStringify)(t), s = await (await (0, (/*@__PURE__*/$parcel$interopDefault($byIIQ)))(this.url, $a9fa27b9c109c5b0$var$v($a9fa27b9c109c5b0$var$p({}, $a9fa27b9c109c5b0$var$d), {
                body: e
            }))).json();
            this.onPayload({
                data: s
            });
        } catch (e) {
            this.onError(t.id, e);
        }
    }
    async register(t = this.url) {
        if (!(0, $bb82n.isHttpUrl)(t)) throw new Error(`Provided URL is not compatible with HTTP connection: ${t}`);
        if (this.registering) {
            const e = this.events.getMaxListeners();
            return (this.events.listenerCount("register_error") >= e || this.events.listenerCount("open") >= e) && this.events.setMaxListeners(e + 1), new Promise((s, i)=>{
                this.events.once("register_error", (n)=>{
                    this.resetMaxListeners(), i(n);
                }), this.events.once("open", ()=>{
                    if (this.resetMaxListeners(), typeof this.isAvailable > "u") return i(new Error("HTTP connection is missing or invalid"));
                    s();
                });
            });
        }
        this.url = t, this.registering = !0;
        try {
            if (!this.disableProviderPing) {
                const e = (0, $bREX4.safeJsonStringify)({
                    id: 1,
                    jsonrpc: "2.0",
                    method: "test",
                    params: []
                });
                await (0, (/*@__PURE__*/$parcel$interopDefault($byIIQ)))(t, $a9fa27b9c109c5b0$var$v($a9fa27b9c109c5b0$var$p({}, $a9fa27b9c109c5b0$var$d), {
                    body: e
                }));
            }
            this.onOpen();
        } catch (e) {
            const s = this.parseError(e);
            throw this.events.emit("register_error", s), this.onClose(), s;
        }
    }
    onOpen() {
        this.isAvailable = !0, this.registering = !1, this.events.emit("open");
    }
    onClose() {
        this.isAvailable = !1, this.registering = !1, this.events.emit("close");
    }
    onPayload(t) {
        if (typeof t.data > "u") return;
        const e = typeof t.data == "string" ? (0, $bREX4.safeJsonParse)(t.data) : t.data;
        this.events.emit("payload", e);
    }
    onError(t, e) {
        const s = this.parseError(e), i = s.message || s.toString(), n = (0, $fHodW.formatJsonRpcError)(t, i);
        this.events.emit("payload", n);
    }
    parseError(t, e = this.url) {
        return (0, $64EFX.parseConnectionError)(t, e, "HTTP");
    }
    resetMaxListeners() {
        this.events.getMaxListeners() > $a9fa27b9c109c5b0$var$g && this.events.setMaxListeners($a9fa27b9c109c5b0$var$g);
    }
}

});
parcelRegister("byIIQ", function(module, exports) {
// Save global object in a variable
var __global__ = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || typeof $parcel$global !== "undefined" && $parcel$global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        /* eslint-disable no-prototype-builtins */ var g = typeof globalThis1 !== "undefined" && globalThis1 || typeof self !== "undefined" && self || // eslint-disable-next-line no-undef
        typeof $parcel$global !== "undefined" && $parcel$global || {};
        var support = {
            searchParams: "URLSearchParams" in g,
            iterable: "Symbol" in g && "iterator" in Symbol,
            blob: "FileReader" in g && "Blob" in g && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in g,
            arrayBuffer: "ArrayBuffer" in g
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                if (header.length != 2) throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + header.length);
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body._noBody) return;
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
            var encoding = match ? match[1] : "utf-8";
            reader.readAsText(blob, encoding);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ // eslint-disable-next-line no-self-assign
                this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) {
                    this._noBody = true;
                    this._bodyText = "";
                } else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) this.blob = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                    this._bodyArrayBuffer
                ]));
                else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                else return Promise.resolve(new Blob([
                    this._bodyText
                ]));
            };
            this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) {
                    var isConsumed = consumed(this);
                    if (isConsumed) return isConsumed;
                    else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                    else return Promise.resolve(this._bodyArrayBuffer);
                } else if (support.blob) return this.blob().then(readBlobAsArrayBuffer);
                else throw new Error("could not read as ArrayBuffer");
            };
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "CONNECT",
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "PATCH",
            "POST",
            "PUT",
            "TRACE"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal || function() {
                if ("AbortController" in g) {
                    var ctrl = new AbortController();
                    return ctrl.signal;
                }
            }();
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
            if (this.method === "GET" || this.method === "HEAD") {
                if (options.cache === "no-store" || options.cache === "no-cache") {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, "$1_=" + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split("\r").map(function(header) {
                return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    try {
                        headers.append(key, value);
                    } catch (error) {
                        console.warn("Response " + error.message);
                    }
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? "" : "" + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 200,
                statusText: ""
            });
            response.ok = false;
            response.status = 0;
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = g.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    // This check if specifically for when a user fetches a file locally from the file system
                    // Only if the status is out of a normal range
                    if (request.url.indexOf("file://") === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                    else options.status = xhr.status;
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError("Network request failed"));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError("Network request timed out"));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException("Aborted", "AbortError"));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === "" && g.location.href ? g.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr) {
                    if (support.blob) xhr.responseType = "blob";
                    else if (support.arrayBuffer) xhr.responseType = "arraybuffer";
                }
                if (init && typeof init.headers === "object" && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
                    var names = [];
                    Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                        names.push(normalizeName(name));
                        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                    });
                    request.headers.forEach(function(value, name) {
                        if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                    });
                } else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!g.fetch) {
            g.fetch = fetch;
            g.Headers = Headers;
            g.Request = Request;
            g.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});



parcelRegister("034Ac", function(module, exports) {

$parcel$export(module.exports, "SECURE_SITE_SDK", () => $0093d60230395316$export$b36058160289df06);
$parcel$export(module.exports, "DEFAULT_LOG_LEVEL", () => $0093d60230395316$export$97d4c6871900dcac);
$parcel$export(module.exports, "SECURE_SITE_SDK_VERSION", () => $0093d60230395316$export$f75405ca60a6f444);
$parcel$export(module.exports, "W3mFrameConstants", () => $0093d60230395316$export$3ff97a7390ed49be);
$parcel$export(module.exports, "W3mFrameRpcConstants", () => $0093d60230395316$export$9975694bfb286db);

var $kuzpm = parcelRequire("kuzpm");
const $0093d60230395316$var$DEFAULT_SDK_URL = "https://secure.walletconnect.org/sdk";
const $0093d60230395316$export$b36058160289df06 = (typeof $kuzpm !== "undefined" && typeof $kuzpm.env !== "undefined" ? undefined : undefined) || $0093d60230395316$var$DEFAULT_SDK_URL;
const $0093d60230395316$export$97d4c6871900dcac = (typeof $kuzpm !== "undefined" && typeof $kuzpm.env !== "undefined" ? undefined : undefined) || "error";
const $0093d60230395316$export$f75405ca60a6f444 = (typeof $kuzpm !== "undefined" && typeof $kuzpm.env !== "undefined" ? undefined : undefined) || "4";
const $0093d60230395316$export$3ff97a7390ed49be = {
    APP_EVENT_KEY: "@w3m-app/",
    FRAME_EVENT_KEY: "@w3m-frame/",
    RPC_METHOD_KEY: "RPC_",
    STORAGE_KEY: "@appkit-wallet/",
    SESSION_TOKEN_KEY: "SESSION_TOKEN_KEY",
    EMAIL_LOGIN_USED_KEY: "EMAIL_LOGIN_USED_KEY",
    LAST_USED_CHAIN_KEY: "LAST_USED_CHAIN_KEY",
    LAST_EMAIL_LOGIN_TIME: "LAST_EMAIL_LOGIN_TIME",
    EMAIL: "EMAIL",
    PREFERRED_ACCOUNT_TYPE: "PREFERRED_ACCOUNT_TYPE",
    SMART_ACCOUNT_ENABLED: "SMART_ACCOUNT_ENABLED",
    SMART_ACCOUNT_ENABLED_NETWORKS: "SMART_ACCOUNT_ENABLED_NETWORKS",
    SOCIAL_USERNAME: "SOCIAL_USERNAME",
    APP_SWITCH_NETWORK: "@w3m-app/SWITCH_NETWORK",
    APP_CONNECT_EMAIL: "@w3m-app/CONNECT_EMAIL",
    APP_CONNECT_DEVICE: "@w3m-app/CONNECT_DEVICE",
    APP_CONNECT_OTP: "@w3m-app/CONNECT_OTP",
    APP_CONNECT_SOCIAL: "@w3m-app/CONNECT_SOCIAL",
    APP_GET_SOCIAL_REDIRECT_URI: "@w3m-app/GET_SOCIAL_REDIRECT_URI",
    APP_GET_USER: "@w3m-app/GET_USER",
    APP_SIGN_OUT: "@w3m-app/SIGN_OUT",
    APP_IS_CONNECTED: "@w3m-app/IS_CONNECTED",
    APP_GET_CHAIN_ID: "@w3m-app/GET_CHAIN_ID",
    APP_RPC_REQUEST: "@w3m-app/RPC_REQUEST",
    APP_UPDATE_EMAIL: "@w3m-app/UPDATE_EMAIL",
    APP_UPDATE_EMAIL_PRIMARY_OTP: "@w3m-app/UPDATE_EMAIL_PRIMARY_OTP",
    APP_UPDATE_EMAIL_SECONDARY_OTP: "@w3m-app/UPDATE_EMAIL_SECONDARY_OTP",
    APP_AWAIT_UPDATE_EMAIL: "@w3m-app/AWAIT_UPDATE_EMAIL",
    APP_SYNC_THEME: "@w3m-app/SYNC_THEME",
    APP_SYNC_DAPP_DATA: "@w3m-app/SYNC_DAPP_DATA",
    APP_GET_SMART_ACCOUNT_ENABLED_NETWORKS: "@w3m-app/GET_SMART_ACCOUNT_ENABLED_NETWORKS",
    APP_INIT_SMART_ACCOUNT: "@w3m-app/INIT_SMART_ACCOUNT",
    APP_SET_PREFERRED_ACCOUNT: "@w3m-app/SET_PREFERRED_ACCOUNT",
    APP_CONNECT_FARCASTER: "@w3m-app/CONNECT_FARCASTER",
    APP_GET_FARCASTER_URI: "@w3m-app/GET_FARCASTER_URI",
    APP_RELOAD: "@w3m-app/RELOAD",
    FRAME_SWITCH_NETWORK_ERROR: "@w3m-frame/SWITCH_NETWORK_ERROR",
    FRAME_SWITCH_NETWORK_SUCCESS: "@w3m-frame/SWITCH_NETWORK_SUCCESS",
    FRAME_CONNECT_EMAIL_ERROR: "@w3m-frame/CONNECT_EMAIL_ERROR",
    FRAME_CONNECT_EMAIL_SUCCESS: "@w3m-frame/CONNECT_EMAIL_SUCCESS",
    FRAME_CONNECT_DEVICE_ERROR: "@w3m-frame/CONNECT_DEVICE_ERROR",
    FRAME_CONNECT_DEVICE_SUCCESS: "@w3m-frame/CONNECT_DEVICE_SUCCESS",
    FRAME_CONNECT_OTP_SUCCESS: "@w3m-frame/CONNECT_OTP_SUCCESS",
    FRAME_CONNECT_OTP_ERROR: "@w3m-frame/CONNECT_OTP_ERROR",
    FRAME_CONNECT_SOCIAL_SUCCESS: "@w3m-frame/CONNECT_SOCIAL_SUCCESS",
    FRAME_CONNECT_SOCIAL_ERROR: "@w3m-frame/CONNECT_SOCIAL_ERROR",
    FRAME_CONNECT_FARCASTER_SUCCESS: "@w3m-frame/CONNECT_FARCASTER_SUCCESS",
    FRAME_CONNECT_FARCASTER_ERROR: "@w3m-frame/CONNECT_FARCASTER_ERROR",
    FRAME_GET_FARCASTER_URI_SUCCESS: "@w3m-frame/GET_FARCASTER_URI_SUCCESS",
    FRAME_GET_FARCASTER_URI_ERROR: "@w3m-frame/GET_FARCASTER_URI_ERROR",
    FRAME_GET_SOCIAL_REDIRECT_URI_SUCCESS: "@w3m-frame/GET_SOCIAL_REDIRECT_URI_SUCCESS",
    FRAME_GET_SOCIAL_REDIRECT_URI_ERROR: "@w3m-frame/GET_SOCIAL_REDIRECT_URI_ERROR",
    FRAME_GET_USER_SUCCESS: "@w3m-frame/GET_USER_SUCCESS",
    FRAME_GET_USER_ERROR: "@w3m-frame/GET_USER_ERROR",
    FRAME_SIGN_OUT_SUCCESS: "@w3m-frame/SIGN_OUT_SUCCESS",
    FRAME_SIGN_OUT_ERROR: "@w3m-frame/SIGN_OUT_ERROR",
    FRAME_IS_CONNECTED_SUCCESS: "@w3m-frame/IS_CONNECTED_SUCCESS",
    FRAME_IS_CONNECTED_ERROR: "@w3m-frame/IS_CONNECTED_ERROR",
    FRAME_GET_CHAIN_ID_SUCCESS: "@w3m-frame/GET_CHAIN_ID_SUCCESS",
    FRAME_GET_CHAIN_ID_ERROR: "@w3m-frame/GET_CHAIN_ID_ERROR",
    FRAME_RPC_REQUEST_SUCCESS: "@w3m-frame/RPC_REQUEST_SUCCESS",
    FRAME_RPC_REQUEST_ERROR: "@w3m-frame/RPC_REQUEST_ERROR",
    FRAME_SESSION_UPDATE: "@w3m-frame/SESSION_UPDATE",
    FRAME_UPDATE_EMAIL_SUCCESS: "@w3m-frame/UPDATE_EMAIL_SUCCESS",
    FRAME_UPDATE_EMAIL_ERROR: "@w3m-frame/UPDATE_EMAIL_ERROR",
    FRAME_UPDATE_EMAIL_PRIMARY_OTP_SUCCESS: "@w3m-frame/UPDATE_EMAIL_PRIMARY_OTP_SUCCESS",
    FRAME_UPDATE_EMAIL_PRIMARY_OTP_ERROR: "@w3m-frame/UPDATE_EMAIL_PRIMARY_OTP_ERROR",
    FRAME_UPDATE_EMAIL_SECONDARY_OTP_SUCCESS: "@w3m-frame/UPDATE_EMAIL_SECONDARY_OTP_SUCCESS",
    FRAME_UPDATE_EMAIL_SECONDARY_OTP_ERROR: "@w3m-frame/UPDATE_EMAIL_SECONDARY_OTP_ERROR",
    FRAME_SYNC_THEME_SUCCESS: "@w3m-frame/SYNC_THEME_SUCCESS",
    FRAME_SYNC_THEME_ERROR: "@w3m-frame/SYNC_THEME_ERROR",
    FRAME_SYNC_DAPP_DATA_SUCCESS: "@w3m-frame/SYNC_DAPP_DATA_SUCCESS",
    FRAME_SYNC_DAPP_DATA_ERROR: "@w3m-frame/SYNC_DAPP_DATA_ERROR",
    FRAME_GET_SMART_ACCOUNT_ENABLED_NETWORKS_SUCCESS: "@w3m-frame/GET_SMART_ACCOUNT_ENABLED_NETWORKS_SUCCESS",
    FRAME_GET_SMART_ACCOUNT_ENABLED_NETWORKS_ERROR: "@w3m-frame/GET_SMART_ACCOUNT_ENABLED_NETWORKS_ERROR",
    FRAME_INIT_SMART_ACCOUNT_SUCCESS: "@w3m-frame/INIT_SMART_ACCOUNT_SUCCESS",
    FRAME_INIT_SMART_ACCOUNT_ERROR: "@w3m-frame/INIT_SMART_ACCOUNT_ERROR",
    FRAME_SET_PREFERRED_ACCOUNT_SUCCESS: "@w3m-frame/SET_PREFERRED_ACCOUNT_SUCCESS",
    FRAME_SET_PREFERRED_ACCOUNT_ERROR: "@w3m-frame/SET_PREFERRED_ACCOUNT_ERROR",
    FRAME_READY: "@w3m-frame/READY",
    FRAME_RELOAD_SUCCESS: "@w3m-frame/RELOAD_SUCCESS",
    FRAME_RELOAD_ERROR: "@w3m-frame/RELOAD_ERROR",
    RPC_RESPONSE_TYPE_ERROR: "RPC_RESPONSE_ERROR",
    RPC_RESPONSE_TYPE_TX: "RPC_RESPONSE_TRANSACTION_HASH",
    RPC_RESPONSE_TYPE_OBJECT: "RPC_RESPONSE_OBJECT"
};
const $0093d60230395316$export$9975694bfb286db = {
    SAFE_RPC_METHODS: [
        "eth_accounts",
        "eth_blockNumber",
        "eth_call",
        "eth_chainId",
        "eth_estimateGas",
        "eth_feeHistory",
        "eth_gasPrice",
        "eth_getAccount",
        "eth_getBalance",
        "eth_getBlockByHash",
        "eth_getBlockByNumber",
        "eth_getBlockReceipts",
        "eth_getBlockTransactionCountByHash",
        "eth_getBlockTransactionCountByNumber",
        "eth_getCode",
        "eth_getFilterChanges",
        "eth_getFilterLogs",
        "eth_getLogs",
        "eth_getProof",
        "eth_getStorageAt",
        "eth_getTransactionByBlockHashAndIndex",
        "eth_getTransactionByBlockNumberAndIndex",
        "eth_getTransactionByHash",
        "eth_getTransactionCount",
        "eth_getTransactionReceipt",
        "eth_getUncleCountByBlockHash",
        "eth_getUncleCountByBlockNumber",
        "eth_maxPriorityFeePerGas",
        "eth_newBlockFilter",
        "eth_newFilter",
        "eth_newPendingTransactionFilter",
        "eth_sendRawTransaction",
        "eth_syncing",
        "eth_uninstallFilter",
        "wallet_getCapabilities",
        "wallet_getCallsStatus",
        "eth_getUserOperationReceipt",
        "eth_estimateUserOperationGas",
        "eth_getUserOperationByHash",
        "eth_supportedEntryPoints",
        "wallet_getAssets"
    ],
    NOT_SAFE_RPC_METHODS: [
        "personal_sign",
        "eth_signTypedData_v4",
        "eth_sendTransaction",
        "solana_signMessage",
        "solana_signTransaction",
        "solana_signAllTransactions",
        "solana_signAndSendTransaction",
        "wallet_sendCalls",
        "wallet_grantPermissions",
        "wallet_revokePermissions",
        "eth_sendUserOperation"
    ],
    GET_CHAIN_ID: "eth_chainId",
    RPC_METHOD_NOT_ALLOWED_MESSAGE: "Requested RPC call is not allowed",
    RPC_METHOD_NOT_ALLOWED_UI_MESSAGE: "Action not allowed",
    ACCOUNT_TYPES: {
        EOA: "eoa",
        SMART_ACCOUNT: "smartAccount"
    }
};

});


parcelRegister("9QVQU", function(module, exports) {

$parcel$export(module.exports, "TransactionsController", () => $72c5d8aa891f7449$export$da1e018e28e23fb0);

var $7zrdF = parcelRequire("7zrdF");

var $034Ac = parcelRequire("034Ac");

var $lCKEr = parcelRequire("lCKEr");

var $kfwQH = parcelRequire("kfwQH");

var $hvrT6 = parcelRequire("hvrT6");

var $gD0RX = parcelRequire("gD0RX");

var $5FNhR = parcelRequire("5FNhR");

var $knC5d = parcelRequire("knC5d");

var $4hCRh = parcelRequire("4hCRh");
// -- State --------------------------------------------- //
const $72c5d8aa891f7449$var$state = (0, $7zrdF.proxy)({
    transactions: [],
    coinbaseTransactions: {},
    transactionsByYear: {},
    lastNetworkInView: undefined,
    loading: false,
    empty: false,
    next: undefined
});
// -- Controller ---------------------------------------- //
const $72c5d8aa891f7449$var$controller = {
    state: $72c5d8aa891f7449$var$state,
    subscribe (callback) {
        return (0, $7zrdF.subscribe)($72c5d8aa891f7449$var$state, ()=>callback($72c5d8aa891f7449$var$state));
    },
    setLastNetworkInView (lastNetworkInView) {
        $72c5d8aa891f7449$var$state.lastNetworkInView = lastNetworkInView;
    },
    async fetchTransactions (accountAddress, onramp) {
        if (!accountAddress) throw new Error("Transactions can't be fetched without an accountAddress");
        $72c5d8aa891f7449$var$state.loading = true;
        try {
            const response = await (0, $hvrT6.BlockchainApiController).fetchTransactions({
                account: accountAddress,
                cursor: $72c5d8aa891f7449$var$state.next,
                onramp: onramp,
                // Coinbase transaction history state updates require the latest data
                cache: onramp === "coinbase" ? "no-cache" : undefined,
                chainId: (0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId
            });
            const nonSpamTransactions = $72c5d8aa891f7449$export$da1e018e28e23fb0.filterSpamTransactions(response.data);
            const sameChainTransactions = $72c5d8aa891f7449$export$da1e018e28e23fb0.filterByConnectedChain(nonSpamTransactions);
            const filteredTransactions = [
                ...$72c5d8aa891f7449$var$state.transactions,
                ...sameChainTransactions
            ];
            $72c5d8aa891f7449$var$state.loading = false;
            if (onramp === "coinbase") $72c5d8aa891f7449$var$state.coinbaseTransactions = $72c5d8aa891f7449$export$da1e018e28e23fb0.groupTransactionsByYearAndMonth($72c5d8aa891f7449$var$state.coinbaseTransactions, response.data);
            else {
                $72c5d8aa891f7449$var$state.transactions = filteredTransactions;
                $72c5d8aa891f7449$var$state.transactionsByYear = $72c5d8aa891f7449$export$da1e018e28e23fb0.groupTransactionsByYearAndMonth($72c5d8aa891f7449$var$state.transactionsByYear, sameChainTransactions);
            }
            $72c5d8aa891f7449$var$state.empty = filteredTransactions.length === 0;
            $72c5d8aa891f7449$var$state.next = response.next ? response.next : undefined;
        } catch (error) {
            const activeChainNamespace = (0, $gD0RX.ChainController).state.activeChain;
            (0, $5FNhR.EventsController).sendEvent({
                type: "track",
                event: "ERROR_FETCH_TRANSACTIONS",
                properties: {
                    address: accountAddress,
                    projectId: (0, $knC5d.OptionsController).state.projectId,
                    cursor: $72c5d8aa891f7449$var$state.next,
                    isSmartAccount: (0, $kfwQH.AccountController).state.preferredAccountTypes?.[activeChainNamespace] === (0, $034Ac.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
                }
            });
            (0, $4hCRh.SnackController).showError("Failed to fetch transactions");
            $72c5d8aa891f7449$var$state.loading = false;
            $72c5d8aa891f7449$var$state.empty = true;
            $72c5d8aa891f7449$var$state.next = undefined;
        }
    },
    groupTransactionsByYearAndMonth (transactionsMap = {}, transactions = []) {
        const grouped = transactionsMap;
        transactions.forEach((transaction)=>{
            const year = new Date(transaction.metadata.minedAt).getFullYear();
            const month = new Date(transaction.metadata.minedAt).getMonth();
            const yearTransactions = grouped[year] ?? {};
            const monthTransactions = yearTransactions[month] ?? [];
            // If there's a transaction with the same id, remove the old one
            const newMonthTransactions = monthTransactions.filter((tx)=>tx.id !== transaction.id);
            grouped[year] = {
                ...yearTransactions,
                [month]: [
                    ...newMonthTransactions,
                    transaction
                ].sort((a, b)=>new Date(b.metadata.minedAt).getTime() - new Date(a.metadata.minedAt).getTime())
            };
        });
        return grouped;
    },
    filterSpamTransactions (transactions) {
        return transactions.filter((transaction)=>{
            const isAllSpam = transaction.transfers.every((transfer)=>transfer.nft_info?.flags.is_spam === true);
            return !isAllSpam;
        });
    },
    filterByConnectedChain (transactions) {
        const chainId = (0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId;
        const filteredTransactions = transactions.filter((transaction)=>transaction.metadata.chain === chainId);
        return filteredTransactions;
    },
    clearCursor () {
        $72c5d8aa891f7449$var$state.next = undefined;
    },
    resetTransactions () {
        $72c5d8aa891f7449$var$state.transactions = [];
        $72c5d8aa891f7449$var$state.transactionsByYear = {};
        $72c5d8aa891f7449$var$state.lastNetworkInView = undefined;
        $72c5d8aa891f7449$var$state.loading = false;
        $72c5d8aa891f7449$var$state.empty = false;
        $72c5d8aa891f7449$var$state.next = undefined;
    }
};
const $72c5d8aa891f7449$export$da1e018e28e23fb0 = (0, $lCKEr.withErrorBoundary)($72c5d8aa891f7449$var$controller, "API_ERROR");

});


parcelRegister("1dM5v", function(module, exports) {

$parcel$export(module.exports, "PublicStateController", () => $0e3c4e8e729fd14e$export$24bc8c77cb7c530);

var $7zrdF = parcelRequire("7zrdF");

var $eFS1l = parcelRequire("eFS1l");
// -- State --------------------------------------------- //
const $0e3c4e8e729fd14e$var$state = (0, $7zrdF.proxy)({
    loading: false,
    open: false,
    selectedNetworkId: undefined,
    activeChain: undefined,
    initialized: false
});
const $0e3c4e8e729fd14e$export$24bc8c77cb7c530 = {
    state: $0e3c4e8e729fd14e$var$state,
    subscribe (callback) {
        return (0, $7zrdF.subscribe)($0e3c4e8e729fd14e$var$state, ()=>callback($0e3c4e8e729fd14e$var$state));
    },
    subscribeOpen (callback) {
        return (0, $eFS1l.subscribeKey)($0e3c4e8e729fd14e$var$state, "open", callback);
    },
    set (newState) {
        Object.assign($0e3c4e8e729fd14e$var$state, {
            ...$0e3c4e8e729fd14e$var$state,
            ...newState
        });
    }
};

});



parcelRegister("1VSgi", function(module, exports) {

$parcel$export(module.exports, "ThemeController", () => $16853491c2b3a8dc$export$e18d4112326e72bf);

var $7zrdF = parcelRequire("7zrdF");

var $2Z0OY = parcelRequire("2Z0OY");

var $lCKEr = parcelRequire("lCKEr");

var $58cAm = parcelRequire("58cAm");
// -- State --------------------------------------------- //
const $16853491c2b3a8dc$var$state = (0, $7zrdF.proxy)({
    themeMode: "dark",
    themeVariables: {},
    w3mThemeVariables: undefined
});
// -- Controller ---------------------------------------- //
const $16853491c2b3a8dc$var$controller = {
    state: $16853491c2b3a8dc$var$state,
    subscribe (callback) {
        return (0, $7zrdF.subscribe)($16853491c2b3a8dc$var$state, ()=>callback($16853491c2b3a8dc$var$state));
    },
    setThemeMode (themeMode) {
        $16853491c2b3a8dc$var$state.themeMode = themeMode;
        try {
            const authConnector = (0, $58cAm.ConnectorController).getAuthConnector();
            if (authConnector) {
                const themeVariables = $16853491c2b3a8dc$var$controller.getSnapshot().themeVariables;
                authConnector.provider.syncTheme({
                    themeMode: themeMode,
                    themeVariables: themeVariables,
                    w3mThemeVariables: (0, $2Z0OY.getW3mThemeVariables)(themeVariables, themeMode)
                });
            }
        } catch  {
            // eslint-disable-next-line no-console
            console.info("Unable to sync theme to auth connector");
        }
    },
    setThemeVariables (themeVariables) {
        $16853491c2b3a8dc$var$state.themeVariables = {
            ...$16853491c2b3a8dc$var$state.themeVariables,
            ...themeVariables
        };
        try {
            const authConnector = (0, $58cAm.ConnectorController).getAuthConnector();
            if (authConnector) {
                const themeVariablesSnapshot = $16853491c2b3a8dc$var$controller.getSnapshot().themeVariables;
                authConnector.provider.syncTheme({
                    themeVariables: themeVariablesSnapshot,
                    w3mThemeVariables: (0, $2Z0OY.getW3mThemeVariables)($16853491c2b3a8dc$var$state.themeVariables, $16853491c2b3a8dc$var$state.themeMode)
                });
            }
        } catch  {
            // eslint-disable-next-line no-console
            console.info("Unable to sync theme to auth connector");
        }
    },
    getSnapshot () {
        return (0, $7zrdF.snapshot)($16853491c2b3a8dc$var$state);
    }
};
const $16853491c2b3a8dc$export$e18d4112326e72bf = (0, $lCKEr.withErrorBoundary)($16853491c2b3a8dc$var$controller);

});




parcelRegister("vRYB3", function(module, exports) {

$parcel$export(module.exports, "SendController", () => $05fcc3f25975fe87$export$e3bfd79582777e03);

var $7zrdF = parcelRequire("7zrdF");

var $eFS1l = parcelRequire("eFS1l");

var $4qB4v = parcelRequire("4qB4v");
var $eUrJG = parcelRequire("eUrJG");

var $034Ac = parcelRequire("034Ac");

var $3h0dG = parcelRequire("3h0dG");

var $lpmCO = parcelRequire("lpmCO");

var $jQ5aJ = parcelRequire("jQ5aJ");

var $lCKEr = parcelRequire("lCKEr");

var $kfwQH = parcelRequire("kfwQH");

var $gD0RX = parcelRequire("gD0RX");

var $efZLi = parcelRequire("efZLi");

var $5FNhR = parcelRequire("5FNhR");

var $aZ8hw = parcelRequire("aZ8hw");

var $4hCRh = parcelRequire("4hCRh");
// -- State --------------------------------------------- //
const $05fcc3f25975fe87$var$state = (0, $7zrdF.proxy)({
    tokenBalances: [],
    loading: false
});
// -- Controller ---------------------------------------- //
const $05fcc3f25975fe87$var$controller = {
    state: $05fcc3f25975fe87$var$state,
    subscribe (callback) {
        return (0, $7zrdF.subscribe)($05fcc3f25975fe87$var$state, ()=>callback($05fcc3f25975fe87$var$state));
    },
    subscribeKey (key, callback) {
        return (0, $eFS1l.subscribeKey)($05fcc3f25975fe87$var$state, key, callback);
    },
    setToken (token) {
        if (token) $05fcc3f25975fe87$var$state.token = (0, $7zrdF.ref)(token);
    },
    setTokenAmount (sendTokenAmount) {
        $05fcc3f25975fe87$var$state.sendTokenAmount = sendTokenAmount;
    },
    setReceiverAddress (receiverAddress) {
        $05fcc3f25975fe87$var$state.receiverAddress = receiverAddress;
    },
    setReceiverProfileImageUrl (receiverProfileImageUrl) {
        $05fcc3f25975fe87$var$state.receiverProfileImageUrl = receiverProfileImageUrl;
    },
    setReceiverProfileName (receiverProfileName) {
        $05fcc3f25975fe87$var$state.receiverProfileName = receiverProfileName;
    },
    setNetworkBalanceInUsd (networkBalanceInUSD) {
        $05fcc3f25975fe87$var$state.networkBalanceInUSD = networkBalanceInUSD;
    },
    setLoading (loading) {
        $05fcc3f25975fe87$var$state.loading = loading;
    },
    async sendToken () {
        try {
            $05fcc3f25975fe87$export$e3bfd79582777e03.setLoading(true);
            switch((0, $gD0RX.ChainController).state.activeCaipNetwork?.chainNamespace){
                case "eip155":
                    await $05fcc3f25975fe87$export$e3bfd79582777e03.sendEvmToken();
                    return;
                case "solana":
                    await $05fcc3f25975fe87$export$e3bfd79582777e03.sendSolanaToken();
                    return;
                default:
                    throw new Error("Unsupported chain");
            }
        } finally{
            $05fcc3f25975fe87$export$e3bfd79582777e03.setLoading(false);
        }
    },
    async sendEvmToken () {
        const activeChainNamespace = (0, $gD0RX.ChainController).state.activeChain;
        const activeAccountType = (0, $kfwQH.AccountController).state.preferredAccountTypes?.[activeChainNamespace];
        if (!$05fcc3f25975fe87$export$e3bfd79582777e03.state.sendTokenAmount || !$05fcc3f25975fe87$export$e3bfd79582777e03.state.receiverAddress) throw new Error("An amount and receiver address are required");
        if (!$05fcc3f25975fe87$export$e3bfd79582777e03.state.token) throw new Error("A token is required");
        if ($05fcc3f25975fe87$export$e3bfd79582777e03.state.token?.address) {
            (0, $5FNhR.EventsController).sendEvent({
                type: "track",
                event: "SEND_INITIATED",
                properties: {
                    isSmartAccount: activeAccountType === (0, $034Ac.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT,
                    token: $05fcc3f25975fe87$export$e3bfd79582777e03.state.token.address,
                    amount: $05fcc3f25975fe87$export$e3bfd79582777e03.state.sendTokenAmount,
                    network: (0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId || ""
                }
            });
            await $05fcc3f25975fe87$export$e3bfd79582777e03.sendERC20Token({
                receiverAddress: $05fcc3f25975fe87$export$e3bfd79582777e03.state.receiverAddress,
                tokenAddress: $05fcc3f25975fe87$export$e3bfd79582777e03.state.token.address,
                sendTokenAmount: $05fcc3f25975fe87$export$e3bfd79582777e03.state.sendTokenAmount,
                decimals: $05fcc3f25975fe87$export$e3bfd79582777e03.state.token.quantity.decimals
            });
        } else {
            (0, $5FNhR.EventsController).sendEvent({
                type: "track",
                event: "SEND_INITIATED",
                properties: {
                    isSmartAccount: activeAccountType === (0, $034Ac.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT,
                    token: $05fcc3f25975fe87$export$e3bfd79582777e03.state.token.symbol || "",
                    amount: $05fcc3f25975fe87$export$e3bfd79582777e03.state.sendTokenAmount,
                    network: (0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId || ""
                }
            });
            await $05fcc3f25975fe87$export$e3bfd79582777e03.sendNativeToken({
                receiverAddress: $05fcc3f25975fe87$export$e3bfd79582777e03.state.receiverAddress,
                sendTokenAmount: $05fcc3f25975fe87$export$e3bfd79582777e03.state.sendTokenAmount,
                decimals: $05fcc3f25975fe87$export$e3bfd79582777e03.state.token.quantity.decimals
            });
        }
    },
    async fetchTokenBalance (onError) {
        $05fcc3f25975fe87$var$state.loading = true;
        const chainId = (0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId;
        const chain = (0, $gD0RX.ChainController).state.activeCaipNetwork?.chainNamespace;
        const caipAddress = (0, $gD0RX.ChainController).state.activeCaipAddress;
        const address = caipAddress ? (0, $lpmCO.CoreHelperUtil).getPlainAddress(caipAddress) : undefined;
        if ($05fcc3f25975fe87$var$state.lastRetry && !(0, $lpmCO.CoreHelperUtil).isAllowedRetry($05fcc3f25975fe87$var$state.lastRetry, 30 * (0, $3h0dG.ConstantsUtil).ONE_SEC_MS)) {
            $05fcc3f25975fe87$var$state.loading = false;
            return [];
        }
        try {
            if (address && chainId && chain) {
                const balances = await (0, $jQ5aJ.SendApiUtil).getMyTokensWithBalance();
                $05fcc3f25975fe87$var$state.tokenBalances = balances;
                $05fcc3f25975fe87$var$state.lastRetry = undefined;
                return balances;
            }
        } catch (error) {
            $05fcc3f25975fe87$var$state.lastRetry = Date.now();
            onError?.(error);
            (0, $4hCRh.SnackController).showError("Token Balance Unavailable");
        } finally{
            $05fcc3f25975fe87$var$state.loading = false;
        }
        return [];
    },
    fetchNetworkBalance () {
        if ($05fcc3f25975fe87$var$state.tokenBalances.length === 0) return;
        const networkTokenBalances = (0, $jQ5aJ.SendApiUtil).mapBalancesToSwapTokens($05fcc3f25975fe87$var$state.tokenBalances);
        if (!networkTokenBalances) return;
        const networkToken = networkTokenBalances.find((token)=>token.address === (0, $gD0RX.ChainController).getActiveNetworkTokenAddress());
        if (!networkToken) return;
        $05fcc3f25975fe87$var$state.networkBalanceInUSD = networkToken ? (0, $eUrJG.NumberUtil).multiply(networkToken.quantity.numeric, networkToken.price).toString() : "0";
    },
    async sendNativeToken (params) {
        (0, $aZ8hw.RouterController).pushTransactionStack({});
        const to = params.receiverAddress;
        const address = (0, $kfwQH.AccountController).state.address;
        const value = (0, $efZLi.ConnectionController).parseUnits(params.sendTokenAmount.toString(), Number(params.decimals));
        const data = "0x";
        await (0, $efZLi.ConnectionController).sendTransaction({
            chainNamespace: "eip155",
            to: to,
            address: address,
            data: data,
            value: value ?? BigInt(0)
        });
        (0, $5FNhR.EventsController).sendEvent({
            type: "track",
            event: "SEND_SUCCESS",
            properties: {
                isSmartAccount: (0, $kfwQH.AccountController).state.preferredAccountTypes?.["eip155"] === (0, $034Ac.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT,
                token: $05fcc3f25975fe87$export$e3bfd79582777e03.state.token?.symbol || "",
                amount: params.sendTokenAmount,
                network: (0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId || ""
            }
        });
        (0, $efZLi.ConnectionController)._getClient()?.updateBalance("eip155");
        $05fcc3f25975fe87$export$e3bfd79582777e03.resetSend();
    },
    async sendERC20Token (params) {
        (0, $aZ8hw.RouterController).pushTransactionStack({
            onSuccess () {
                (0, $aZ8hw.RouterController).replace("Account");
            }
        });
        const amount = (0, $efZLi.ConnectionController).parseUnits(params.sendTokenAmount.toString(), Number(params.decimals));
        if ((0, $kfwQH.AccountController).state.address && params.sendTokenAmount && params.receiverAddress && params.tokenAddress) {
            const tokenAddress = (0, $lpmCO.CoreHelperUtil).getPlainAddress(params.tokenAddress);
            await (0, $efZLi.ConnectionController).writeContract({
                fromAddress: (0, $kfwQH.AccountController).state.address,
                tokenAddress: tokenAddress,
                args: [
                    params.receiverAddress,
                    amount ?? BigInt(0)
                ],
                method: "transfer",
                abi: (0, $4qB4v.ContractUtil).getERC20Abi(tokenAddress),
                chainNamespace: "eip155"
            });
            $05fcc3f25975fe87$export$e3bfd79582777e03.resetSend();
        }
    },
    async sendSolanaToken () {
        if (!$05fcc3f25975fe87$export$e3bfd79582777e03.state.sendTokenAmount || !$05fcc3f25975fe87$export$e3bfd79582777e03.state.receiverAddress) throw new Error("An amount and receiver address are required");
        (0, $aZ8hw.RouterController).pushTransactionStack({
            onSuccess () {
                (0, $aZ8hw.RouterController).replace("Account");
            }
        });
        await (0, $efZLi.ConnectionController).sendTransaction({
            chainNamespace: "solana",
            to: $05fcc3f25975fe87$export$e3bfd79582777e03.state.receiverAddress,
            value: $05fcc3f25975fe87$export$e3bfd79582777e03.state.sendTokenAmount
        });
        (0, $efZLi.ConnectionController)._getClient()?.updateBalance("solana");
        $05fcc3f25975fe87$export$e3bfd79582777e03.resetSend();
    },
    resetSend () {
        $05fcc3f25975fe87$var$state.token = undefined;
        $05fcc3f25975fe87$var$state.sendTokenAmount = undefined;
        $05fcc3f25975fe87$var$state.receiverAddress = undefined;
        $05fcc3f25975fe87$var$state.receiverProfileImageUrl = undefined;
        $05fcc3f25975fe87$var$state.receiverProfileName = undefined;
        $05fcc3f25975fe87$var$state.loading = false;
        $05fcc3f25975fe87$var$state.tokenBalances = [];
    }
};
const $05fcc3f25975fe87$export$e3bfd79582777e03 = (0, $lCKEr.withErrorBoundary)($05fcc3f25975fe87$var$controller);

});
parcelRegister("4qB4v", function(module, exports) {

$parcel$export(module.exports, "ContractUtil", () => $339658cec187dda9$export$b0501f439c0227a);

var $2BTsb = parcelRequire("2BTsb");

var $c0vo8 = parcelRequire("c0vo8");

var $9GQmO = parcelRequire("9GQmO");

var $b3v9s = parcelRequire("b3v9s");
const $339658cec187dda9$export$b0501f439c0227a = {
    getERC20Abi: (tokenAddress)=>{
        if ((0, $b3v9s.ConstantsUtil).USDT_CONTRACT_ADDRESSES.includes(tokenAddress)) return 0, $9GQmO.usdtABI;
        return 0, $2BTsb.erc20ABI;
    },
    getSwapAbi: ()=>(0, $c0vo8.swapABI)
};

});
parcelRegister("2BTsb", function(module, exports) {

$parcel$export(module.exports, "erc20ABI", () => $1e6a0d67f3ebd54f$export$e125cdc2a458cf13);
const $1e6a0d67f3ebd54f$export$e125cdc2a458cf13 = [
    {
        type: "function",
        name: "transfer",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "_to",
                type: "address"
            },
            {
                name: "_value",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "_from",
                type: "address"
            },
            {
                name: "_to",
                type: "address"
            },
            {
                name: "_value",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    }
];

});

parcelRegister("c0vo8", function(module, exports) {

$parcel$export(module.exports, "swapABI", () => $8bddd53158d8908c$export$7694ccd0d73b0da0);
const $8bddd53158d8908c$export$7694ccd0d73b0da0 = [
    {
        type: "function",
        name: "approve",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    }
];

});

parcelRegister("9GQmO", function(module, exports) {

$parcel$export(module.exports, "usdtABI", () => $70e0a84a22085d93$export$a776a2ebde38fde7);
const $70e0a84a22085d93$export$a776a2ebde38fde7 = [
    {
        type: "function",
        name: "transfer",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    }
];

});


parcelRegister("eUrJG", function(module, exports) {

$parcel$export(module.exports, "NumberUtil", () => $adabcf65c1b193c4$export$be098d443162b0ca);

var $cVfe4 = parcelRequire("cVfe4");
const $adabcf65c1b193c4$export$be098d443162b0ca = {
    bigNumber (value) {
        if (!value) return new (0, $cVfe4.default)(0);
        return new (0, $cVfe4.default)(value);
    },
    multiply (a, b) {
        if (a === undefined || b === undefined) return new (0, $cVfe4.default)(0);
        const aBigNumber = new (0, $cVfe4.default)(a);
        const bBigNumber = new (0, $cVfe4.default)(b);
        return aBigNumber.times(bBigNumber);
    },
    formatNumberToLocalString (value, decimals = 2) {
        if (value === undefined) return "0.00";
        if (typeof value === "number") return value.toLocaleString("en-US", {
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals
        });
        return parseFloat(value).toLocaleString("en-US", {
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals
        });
    },
    parseLocalStringToNumber (value) {
        if (value === undefined) return 0;
        return parseFloat(value.replace(/,/gu, ""));
    }
};

});
parcelRegister("cVfe4", function(module, exports) {

$parcel$export(module.exports, "default", () => $99a76b50c1814e85$export$2e2bcd8739ae039);
/*
 *  big.js v6.2.2
 *  A small, fast, easy-to-use library for arbitrary-precision decimal arithmetic.
 *  Copyright (c) 2024 Michael Mclaughlin
 *  https://github.com/MikeMcl/big.js/LICENCE.md
 */ /************************************** EDITABLE DEFAULTS *****************************************/ // The default values below must be integers within the stated ranges.
/*
   * The maximum number of decimal places (DP) of the results of operations involving division:
   * div and sqrt, and pow with negative exponents.
   */ var $99a76b50c1814e85$var$DP = 20, /*
   * The rounding mode (RM) used when rounding to the above decimal places.
   *
   *  0  Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
   *  1  To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
   *  2  To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
   *  3  Away from zero.                                  (ROUND_UP)
   */ $99a76b50c1814e85$var$RM = 1, // The maximum value of DP and Big.DP.
$99a76b50c1814e85$var$MAX_DP = 1E6, // The maximum magnitude of the exponent argument to the pow method.
$99a76b50c1814e85$var$MAX_POWER = 1E6, /*
   * The negative exponent (NE) at and beneath which toString returns exponential notation.
   * (JavaScript numbers: -7)
   * -1000000 is the minimum recommended exponent value of a Big.
   */ $99a76b50c1814e85$var$NE = -7, /*
   * The positive exponent (PE) at and above which toString returns exponential notation.
   * (JavaScript numbers: 21)
   * 1000000 is the maximum recommended exponent value of a Big, but this limit is not enforced.
   */ $99a76b50c1814e85$var$PE = 21, /*
   * When true, an error will be thrown if a primitive number is passed to the Big constructor,
   * or if valueOf is called, or if toNumber is called on a Big which cannot be converted to a
   * primitive number without a loss of precision.
   */ $99a76b50c1814e85$var$STRICT = false, /**************************************************************************************************/ // Error messages.
$99a76b50c1814e85$var$NAME = "[big.js] ", $99a76b50c1814e85$var$INVALID = $99a76b50c1814e85$var$NAME + "Invalid ", $99a76b50c1814e85$var$INVALID_DP = $99a76b50c1814e85$var$INVALID + "decimal places", $99a76b50c1814e85$var$INVALID_RM = $99a76b50c1814e85$var$INVALID + "rounding mode", $99a76b50c1814e85$var$DIV_BY_ZERO = $99a76b50c1814e85$var$NAME + "Division by zero", // The shared prototype object.
$99a76b50c1814e85$var$P = {}, $99a76b50c1814e85$var$UNDEFINED = void 0, $99a76b50c1814e85$var$NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
/*
 * Create and return a Big constructor.
 */ function $99a76b50c1814e85$var$_Big_() {
    /*
   * The Big constructor and exported function.
   * Create and return a new instance of a Big number object.
   *
   * n {number|string|Big} A numeric value.
   */ function Big(n) {
        var x = this;
        // Enable constructor usage without new.
        if (!(x instanceof Big)) return n === $99a76b50c1814e85$var$UNDEFINED ? $99a76b50c1814e85$var$_Big_() : new Big(n);
        // Duplicate.
        if (n instanceof Big) {
            x.s = n.s;
            x.e = n.e;
            x.c = n.c.slice();
        } else {
            if (typeof n !== "string") {
                if (Big.strict === true && typeof n !== "bigint") throw TypeError($99a76b50c1814e85$var$INVALID + "value");
                // Minus zero?
                n = n === 0 && 1 / n < 0 ? "-0" : String(n);
            }
            $99a76b50c1814e85$var$parse(x, n);
        }
        // Retain a reference to this Big constructor.
        // Shadow Big.prototype.constructor which points to Object.
        x.constructor = Big;
    }
    Big.prototype = $99a76b50c1814e85$var$P;
    Big.DP = $99a76b50c1814e85$var$DP;
    Big.RM = $99a76b50c1814e85$var$RM;
    Big.NE = $99a76b50c1814e85$var$NE;
    Big.PE = $99a76b50c1814e85$var$PE;
    Big.strict = $99a76b50c1814e85$var$STRICT;
    Big.roundDown = 0;
    Big.roundHalfUp = 1;
    Big.roundHalfEven = 2;
    Big.roundUp = 3;
    return Big;
}
/*
 * Parse the number or string value passed to a Big constructor.
 *
 * x {Big} A Big number instance.
 * n {number|string} A numeric value.
 */ function $99a76b50c1814e85$var$parse(x, n) {
    var e, i, nl;
    if (!$99a76b50c1814e85$var$NUMERIC.test(n)) throw Error($99a76b50c1814e85$var$INVALID + "number");
    // Determine sign.
    x.s = n.charAt(0) == "-" ? (n = n.slice(1), -1) : 1;
    // Decimal point?
    if ((e = n.indexOf(".")) > -1) n = n.replace(".", "");
    // Exponential form?
    if ((i = n.search(/e/i)) > 0) {
        // Determine exponent.
        if (e < 0) e = i;
        e += +n.slice(i + 1);
        n = n.substring(0, i);
    } else if (e < 0) // Integer.
    e = n.length;
    nl = n.length;
    // Determine leading zeros.
    for(i = 0; i < nl && n.charAt(i) == "0";)++i;
    if (i == nl) // Zero.
    x.c = [
        x.e = 0
    ];
    else {
        // Determine trailing zeros.
        for(; nl > 0 && n.charAt(--nl) == "0";);
        x.e = e - i - 1;
        x.c = [];
        // Convert string to array of digits without leading/trailing zeros.
        for(e = 0; i <= nl;)x.c[e++] = +n.charAt(i++);
    }
    return x;
}
/*
 * Round Big x to a maximum of sd significant digits using rounding mode rm.
 *
 * x {Big} The Big to round.
 * sd {number} Significant digits: integer, 0 to MAX_DP inclusive.
 * rm {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 * [more] {boolean} Whether the result of division was truncated.
 */ function $99a76b50c1814e85$var$round(x, sd, rm, more) {
    var xc = x.c;
    if (rm === $99a76b50c1814e85$var$UNDEFINED) rm = x.constructor.RM;
    if (rm !== 0 && rm !== 1 && rm !== 2 && rm !== 3) throw Error($99a76b50c1814e85$var$INVALID_RM);
    if (sd < 1) {
        more = rm === 3 && (more || !!xc[0]) || sd === 0 && (rm === 1 && xc[0] >= 5 || rm === 2 && (xc[0] > 5 || xc[0] === 5 && (more || xc[1] !== $99a76b50c1814e85$var$UNDEFINED)));
        xc.length = 1;
        if (more) {
            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
            x.e = x.e - sd + 1;
            xc[0] = 1;
        } else // Zero.
        xc[0] = x.e = 0;
    } else if (sd < xc.length) {
        // xc[sd] is the digit after the digit that may be rounded up.
        more = rm === 1 && xc[sd] >= 5 || rm === 2 && (xc[sd] > 5 || xc[sd] === 5 && (more || xc[sd + 1] !== $99a76b50c1814e85$var$UNDEFINED || xc[sd - 1] & 1)) || rm === 3 && (more || !!xc[0]);
        // Remove any digits after the required precision.
        xc.length = sd;
        // Round up?
        if (more) // Rounding up may mean the previous digit has to be rounded up.
        for(; ++xc[--sd] > 9;){
            xc[sd] = 0;
            if (sd === 0) {
                ++x.e;
                xc.unshift(1);
                break;
            }
        }
        // Remove trailing zeros.
        for(sd = xc.length; !xc[--sd];)xc.pop();
    }
    return x;
}
/*
 * Return a string representing the value of Big x in normal or exponential notation.
 * Handles P.toExponential, P.toFixed, P.toJSON, P.toPrecision, P.toString and P.valueOf.
 */ function $99a76b50c1814e85$var$stringify(x, doExponential, isNonzero) {
    var e = x.e, s = x.c.join(""), n = s.length;
    // Exponential notation?
    if (doExponential) s = s.charAt(0) + (n > 1 ? "." + s.slice(1) : "") + (e < 0 ? "e" : "e+") + e;
    else if (e < 0) {
        for(; ++e;)s = "0" + s;
        s = "0." + s;
    } else if (e > 0) {
        if (++e > n) for(e -= n; e--;)s += "0";
        else if (e < n) s = s.slice(0, e) + "." + s.slice(e);
    } else if (n > 1) s = s.charAt(0) + "." + s.slice(1);
    return x.s < 0 && isNonzero ? "-" + s : s;
}
// Prototype/instance methods
/*
 * Return a new Big whose value is the absolute value of this Big.
 */ $99a76b50c1814e85$var$P.abs = function() {
    var x = new this.constructor(this);
    x.s = 1;
    return x;
};
/*
 * Return 1 if the value of this Big is greater than the value of Big y,
 *       -1 if the value of this Big is less than the value of Big y, or
 *        0 if they have the same value.
 */ $99a76b50c1814e85$var$P.cmp = function(y) {
    var isneg, x = this, xc = x.c, yc = (y = new x.constructor(y)).c, i = x.s, j = y.s, k = x.e, l = y.e;
    // Either zero?
    if (!xc[0] || !yc[0]) return !xc[0] ? !yc[0] ? 0 : -j : i;
    // Signs differ?
    if (i != j) return i;
    isneg = i < 0;
    // Compare exponents.
    if (k != l) return k > l ^ isneg ? 1 : -1;
    j = (k = xc.length) < (l = yc.length) ? k : l;
    // Compare digit by digit.
    for(i = -1; ++i < j;){
        if (xc[i] != yc[i]) return xc[i] > yc[i] ^ isneg ? 1 : -1;
    }
    // Compare lengths.
    return k == l ? 0 : k > l ^ isneg ? 1 : -1;
};
/*
 * Return a new Big whose value is the value of this Big divided by the value of Big y, rounded,
 * if necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
 */ $99a76b50c1814e85$var$P.div = function(y) {
    var x = this, Big = x.constructor, a = x.c, b = (y = new Big(y)).c, k = x.s == y.s ? 1 : -1, dp = Big.DP;
    if (dp !== ~~dp || dp < 0 || dp > $99a76b50c1814e85$var$MAX_DP) throw Error($99a76b50c1814e85$var$INVALID_DP);
    // Divisor is zero?
    if (!b[0]) throw Error($99a76b50c1814e85$var$DIV_BY_ZERO);
    // Dividend is 0? Return +-0.
    if (!a[0]) {
        y.s = k;
        y.c = [
            y.e = 0
        ];
        return y;
    }
    var bl, bt, n, cmp, ri, bz = b.slice(), ai = bl = b.length, al = a.length, r = a.slice(0, bl), rl = r.length, q = y, qc = q.c = [], qi = 0, p = dp + (q.e = x.e - y.e) + 1; // precision of the result
    q.s = k;
    k = p < 0 ? 0 : p;
    // Create version of divisor with leading zero.
    bz.unshift(0);
    // Add zeros to make remainder as long as divisor.
    for(; rl++ < bl;)r.push(0);
    do {
        // n is how many times the divisor goes into current remainder.
        for(n = 0; n < 10; n++){
            // Compare divisor and remainder.
            if (bl != (rl = r.length)) cmp = bl > rl ? 1 : -1;
            else {
                for(ri = -1, cmp = 0; ++ri < bl;)if (b[ri] != r[ri]) {
                    cmp = b[ri] > r[ri] ? 1 : -1;
                    break;
                }
            }
            // If divisor < remainder, subtract divisor from remainder.
            if (cmp < 0) {
                // Remainder can't be more than 1 digit longer than divisor.
                // Equalise lengths using divisor with extra leading zero?
                for(bt = rl == bl ? b : bz; rl;){
                    if (r[--rl] < bt[rl]) {
                        ri = rl;
                        for(; ri && !r[--ri];)r[ri] = 9;
                        --r[ri];
                        r[rl] += 10;
                    }
                    r[rl] -= bt[rl];
                }
                for(; !r[0];)r.shift();
            } else break;
        }
        // Add the digit n to the result array.
        qc[qi++] = cmp ? n : ++n;
        // Update the remainder.
        if (r[0] && cmp) r[rl] = a[ai] || 0;
        else r = [
            a[ai]
        ];
    }while ((ai++ < al || r[0] !== $99a76b50c1814e85$var$UNDEFINED) && k--);
    // Leading zero? Do not remove if result is simply zero (qi == 1).
    if (!qc[0] && qi != 1) {
        // There can't be more than one zero.
        qc.shift();
        q.e--;
        p--;
    }
    // Round?
    if (qi > p) $99a76b50c1814e85$var$round(q, p, Big.RM, r[0] !== $99a76b50c1814e85$var$UNDEFINED);
    return q;
};
/*
 * Return true if the value of this Big is equal to the value of Big y, otherwise return false.
 */ $99a76b50c1814e85$var$P.eq = function(y) {
    return this.cmp(y) === 0;
};
/*
 * Return true if the value of this Big is greater than the value of Big y, otherwise return
 * false.
 */ $99a76b50c1814e85$var$P.gt = function(y) {
    return this.cmp(y) > 0;
};
/*
 * Return true if the value of this Big is greater than or equal to the value of Big y, otherwise
 * return false.
 */ $99a76b50c1814e85$var$P.gte = function(y) {
    return this.cmp(y) > -1;
};
/*
 * Return true if the value of this Big is less than the value of Big y, otherwise return false.
 */ $99a76b50c1814e85$var$P.lt = function(y) {
    return this.cmp(y) < 0;
};
/*
 * Return true if the value of this Big is less than or equal to the value of Big y, otherwise
 * return false.
 */ $99a76b50c1814e85$var$P.lte = function(y) {
    return this.cmp(y) < 1;
};
/*
 * Return a new Big whose value is the value of this Big minus the value of Big y.
 */ $99a76b50c1814e85$var$P.minus = $99a76b50c1814e85$var$P.sub = function(y) {
    var i, j, t, xlty, x = this, Big = x.constructor, a = x.s, b = (y = new Big(y)).s;
    // Signs differ?
    if (a != b) {
        y.s = -b;
        return x.plus(y);
    }
    var xc = x.c.slice(), xe = x.e, yc = y.c, ye = y.e;
    // Either zero?
    if (!xc[0] || !yc[0]) {
        if (yc[0]) y.s = -b;
        else if (xc[0]) y = new Big(x);
        else y.s = 1;
        return y;
    }
    // Determine which is the bigger number. Prepend zeros to equalise exponents.
    if (a = xe - ye) {
        if (xlty = a < 0) {
            a = -a;
            t = xc;
        } else {
            ye = xe;
            t = yc;
        }
        t.reverse();
        for(b = a; b--;)t.push(0);
        t.reverse();
    } else {
        // Exponents equal. Check digit by digit.
        j = ((xlty = xc.length < yc.length) ? xc : yc).length;
        for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
            xlty = xc[b] < yc[b];
            break;
        }
    }
    // x < y? Point xc to the array of the bigger number.
    if (xlty) {
        t = xc;
        xc = yc;
        yc = t;
        y.s = -y.s;
    }
    /*
   * Append zeros to xc if shorter. No need to add zeros to yc if shorter as subtraction only
   * needs to start at yc.length.
   */ if ((b = (j = yc.length) - (i = xc.length)) > 0) for(; b--;)xc[i++] = 0;
    // Subtract yc from xc.
    for(b = i; j > a;){
        if (xc[--j] < yc[j]) {
            for(i = j; i && !xc[--i];)xc[i] = 9;
            --xc[i];
            xc[j] += 10;
        }
        xc[j] -= yc[j];
    }
    // Remove trailing zeros.
    for(; xc[--b] === 0;)xc.pop();
    // Remove leading zeros and adjust exponent accordingly.
    for(; xc[0] === 0;){
        xc.shift();
        --ye;
    }
    if (!xc[0]) {
        // n - n = +0
        y.s = 1;
        // Result must be zero.
        xc = [
            ye = 0
        ];
    }
    y.c = xc;
    y.e = ye;
    return y;
};
/*
 * Return a new Big whose value is the value of this Big modulo the value of Big y.
 */ $99a76b50c1814e85$var$P.mod = function(y) {
    var ygtx, x = this, Big = x.constructor, a = x.s, b = (y = new Big(y)).s;
    if (!y.c[0]) throw Error($99a76b50c1814e85$var$DIV_BY_ZERO);
    x.s = y.s = 1;
    ygtx = y.cmp(x) == 1;
    x.s = a;
    y.s = b;
    if (ygtx) return new Big(x);
    a = Big.DP;
    b = Big.RM;
    Big.DP = Big.RM = 0;
    x = x.div(y);
    Big.DP = a;
    Big.RM = b;
    return this.minus(x.times(y));
};
/*
 * Return a new Big whose value is the value of this Big negated.
 */ $99a76b50c1814e85$var$P.neg = function() {
    var x = new this.constructor(this);
    x.s = -x.s;
    return x;
};
/*
 * Return a new Big whose value is the value of this Big plus the value of Big y.
 */ $99a76b50c1814e85$var$P.plus = $99a76b50c1814e85$var$P.add = function(y) {
    var e, k, t, x = this, Big = x.constructor;
    y = new Big(y);
    // Signs differ?
    if (x.s != y.s) {
        y.s = -y.s;
        return x.minus(y);
    }
    var xe = x.e, xc = x.c, ye = y.e, yc = y.c;
    // Either zero?
    if (!xc[0] || !yc[0]) {
        if (!yc[0]) {
            if (xc[0]) y = new Big(x);
            else y.s = x.s;
        }
        return y;
    }
    xc = xc.slice();
    // Prepend zeros to equalise exponents.
    // Note: reverse faster than unshifts.
    if (e = xe - ye) {
        if (e > 0) {
            ye = xe;
            t = yc;
        } else {
            e = -e;
            t = xc;
        }
        t.reverse();
        for(; e--;)t.push(0);
        t.reverse();
    }
    // Point xc to the longer array.
    if (xc.length - yc.length < 0) {
        t = yc;
        yc = xc;
        xc = t;
    }
    e = yc.length;
    // Only start adding at yc.length - 1 as the further digits of xc can be left as they are.
    for(k = 0; e; xc[e] %= 10)k = (xc[--e] = xc[e] + yc[e] + k) / 10 | 0;
    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
    if (k) {
        xc.unshift(k);
        ++ye;
    }
    // Remove trailing zeros.
    for(e = xc.length; xc[--e] === 0;)xc.pop();
    y.c = xc;
    y.e = ye;
    return y;
};
/*
 * Return a Big whose value is the value of this Big raised to the power n.
 * If n is negative, round to a maximum of Big.DP decimal places using rounding
 * mode Big.RM.
 *
 * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
 */ $99a76b50c1814e85$var$P.pow = function(n) {
    var x = this, one = new x.constructor("1"), y = one, isneg = n < 0;
    if (n !== ~~n || n < -$99a76b50c1814e85$var$MAX_POWER || n > $99a76b50c1814e85$var$MAX_POWER) throw Error($99a76b50c1814e85$var$INVALID + "exponent");
    if (isneg) n = -n;
    for(;;){
        if (n & 1) y = y.times(x);
        n >>= 1;
        if (!n) break;
        x = x.times(x);
    }
    return isneg ? one.div(y) : y;
};
/*
 * Return a new Big whose value is the value of this Big rounded to a maximum precision of sd
 * significant digits using rounding mode rm, or Big.RM if rm is not specified.
 *
 * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 */ $99a76b50c1814e85$var$P.prec = function(sd, rm) {
    if (sd !== ~~sd || sd < 1 || sd > $99a76b50c1814e85$var$MAX_DP) throw Error($99a76b50c1814e85$var$INVALID + "precision");
    return $99a76b50c1814e85$var$round(new this.constructor(this), sd, rm);
};
/*
 * Return a new Big whose value is the value of this Big rounded to a maximum of dp decimal places
 * using rounding mode rm, or Big.RM if rm is not specified.
 * If dp is negative, round to an integer which is a multiple of 10**-dp.
 * If dp is not specified, round to 0 decimal places.
 *
 * dp? {number} Integer, -MAX_DP to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 */ $99a76b50c1814e85$var$P.round = function(dp, rm) {
    if (dp === $99a76b50c1814e85$var$UNDEFINED) dp = 0;
    else if (dp !== ~~dp || dp < -$99a76b50c1814e85$var$MAX_DP || dp > $99a76b50c1814e85$var$MAX_DP) throw Error($99a76b50c1814e85$var$INVALID_DP);
    return $99a76b50c1814e85$var$round(new this.constructor(this), dp + this.e + 1, rm);
};
/*
 * Return a new Big whose value is the square root of the value of this Big, rounded, if
 * necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
 */ $99a76b50c1814e85$var$P.sqrt = function() {
    var r, c, t, x = this, Big = x.constructor, s = x.s, e = x.e, half = new Big("0.5");
    // Zero?
    if (!x.c[0]) return new Big(x);
    // Negative?
    if (s < 0) throw Error($99a76b50c1814e85$var$NAME + "No square root");
    // Estimate.
    s = Math.sqrt(+$99a76b50c1814e85$var$stringify(x, true, true));
    // Math.sqrt underflow/overflow?
    // Re-estimate: pass x coefficient to Math.sqrt as integer, then adjust the result exponent.
    if (s === 0 || s === 1 / 0) {
        c = x.c.join("");
        if (!(c.length + e & 1)) c += "0";
        s = Math.sqrt(c);
        e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
        r = new Big((s == 1 / 0 ? "5e" : (s = s.toExponential()).slice(0, s.indexOf("e") + 1)) + e);
    } else r = new Big(s + "");
    e = r.e + (Big.DP += 4);
    // Newton-Raphson iteration.
    do {
        t = r;
        r = half.times(t.plus(x.div(t)));
    }while (t.c.slice(0, e).join("") !== r.c.slice(0, e).join(""));
    return $99a76b50c1814e85$var$round(r, (Big.DP -= 4) + r.e + 1, Big.RM);
};
/*
 * Return a new Big whose value is the value of this Big times the value of Big y.
 */ $99a76b50c1814e85$var$P.times = $99a76b50c1814e85$var$P.mul = function(y) {
    var c, x = this, Big = x.constructor, xc = x.c, yc = (y = new Big(y)).c, a = xc.length, b = yc.length, i = x.e, j = y.e;
    // Determine sign of result.
    y.s = x.s == y.s ? 1 : -1;
    // Return signed 0 if either 0.
    if (!xc[0] || !yc[0]) {
        y.c = [
            y.e = 0
        ];
        return y;
    }
    // Initialise exponent of result as x.e + y.e.
    y.e = i + j;
    // If array xc has fewer digits than yc, swap xc and yc, and lengths.
    if (a < b) {
        c = xc;
        xc = yc;
        yc = c;
        j = a;
        a = b;
        b = j;
    }
    // Initialise coefficient array of result with zeros.
    for(c = new Array(j = a + b); j--;)c[j] = 0;
    // Multiply.
    // i is initially xc.length.
    for(i = b; i--;){
        b = 0;
        // a is yc.length.
        for(j = a + i; j > i;){
            // Current sum of products at this digit position, plus carry.
            b = c[j] + yc[i] * xc[j - i - 1] + b;
            c[j--] = b % 10;
            // carry
            b = b / 10 | 0;
        }
        c[j] = b;
    }
    // Increment result exponent if there is a final carry, otherwise remove leading zero.
    if (b) ++y.e;
    else c.shift();
    // Remove trailing zeros.
    for(i = c.length; !c[--i];)c.pop();
    y.c = c;
    return y;
};
/*
 * Return a string representing the value of this Big in exponential notation rounded to dp fixed
 * decimal places using rounding mode rm, or Big.RM if rm is not specified.
 *
 * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 */ $99a76b50c1814e85$var$P.toExponential = function(dp, rm) {
    var x = this, n = x.c[0];
    if (dp !== $99a76b50c1814e85$var$UNDEFINED) {
        if (dp !== ~~dp || dp < 0 || dp > $99a76b50c1814e85$var$MAX_DP) throw Error($99a76b50c1814e85$var$INVALID_DP);
        x = $99a76b50c1814e85$var$round(new x.constructor(x), ++dp, rm);
        for(; x.c.length < dp;)x.c.push(0);
    }
    return $99a76b50c1814e85$var$stringify(x, true, !!n);
};
/*
 * Return a string representing the value of this Big in normal notation rounded to dp fixed
 * decimal places using rounding mode rm, or Big.RM if rm is not specified.
 *
 * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 *
 * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
 * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
 */ $99a76b50c1814e85$var$P.toFixed = function(dp, rm) {
    var x = this, n = x.c[0];
    if (dp !== $99a76b50c1814e85$var$UNDEFINED) {
        if (dp !== ~~dp || dp < 0 || dp > $99a76b50c1814e85$var$MAX_DP) throw Error($99a76b50c1814e85$var$INVALID_DP);
        x = $99a76b50c1814e85$var$round(new x.constructor(x), dp + x.e + 1, rm);
        // x.e may have changed if the value is rounded up.
        for(dp = dp + x.e + 1; x.c.length < dp;)x.c.push(0);
    }
    return $99a76b50c1814e85$var$stringify(x, false, !!n);
};
/*
 * Return a string representing the value of this Big.
 * Return exponential notation if this Big has a positive exponent equal to or greater than
 * Big.PE, or a negative exponent equal to or less than Big.NE.
 * Omit the sign for negative zero.
 */ $99a76b50c1814e85$var$P[Symbol.for("nodejs.util.inspect.custom")] = $99a76b50c1814e85$var$P.toJSON = $99a76b50c1814e85$var$P.toString = function() {
    var x = this, Big = x.constructor;
    return $99a76b50c1814e85$var$stringify(x, x.e <= Big.NE || x.e >= Big.PE, !!x.c[0]);
};
/*
 * Return the value of this Big as a primitve number.
 */ $99a76b50c1814e85$var$P.toNumber = function() {
    var n = +$99a76b50c1814e85$var$stringify(this, true, true);
    if (this.constructor.strict === true && !this.eq(n.toString())) throw Error($99a76b50c1814e85$var$NAME + "Imprecise conversion");
    return n;
};
/*
 * Return a string representing the value of this Big rounded to sd significant digits using
 * rounding mode rm, or Big.RM if rm is not specified.
 * Use exponential notation if sd is less than the number of digits necessary to represent
 * the integer part of the value in normal notation.
 *
 * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 */ $99a76b50c1814e85$var$P.toPrecision = function(sd, rm) {
    var x = this, Big = x.constructor, n = x.c[0];
    if (sd !== $99a76b50c1814e85$var$UNDEFINED) {
        if (sd !== ~~sd || sd < 1 || sd > $99a76b50c1814e85$var$MAX_DP) throw Error($99a76b50c1814e85$var$INVALID + "precision");
        x = $99a76b50c1814e85$var$round(new Big(x), sd, rm);
        for(; x.c.length < sd;)x.c.push(0);
    }
    return $99a76b50c1814e85$var$stringify(x, sd <= x.e || x.e <= Big.NE || x.e >= Big.PE, !!n);
};
/*
 * Return a string representing the value of this Big.
 * Return exponential notation if this Big has a positive exponent equal to or greater than
 * Big.PE, or a negative exponent equal to or less than Big.NE.
 * Include the sign for negative zero.
 */ $99a76b50c1814e85$var$P.valueOf = function() {
    var x = this, Big = x.constructor;
    if (Big.strict === true) throw Error($99a76b50c1814e85$var$NAME + "valueOf disallowed");
    return $99a76b50c1814e85$var$stringify(x, x.e <= Big.NE || x.e >= Big.PE, true);
};
var $99a76b50c1814e85$export$721faf8597f6f672 = $99a76b50c1814e85$var$_Big_();
var /// <reference types="https://raw.githubusercontent.com/DefinitelyTyped/DefinitelyTyped/master/types/big.js/index.d.ts" />
$99a76b50c1814e85$export$2e2bcd8739ae039 = $99a76b50c1814e85$export$721faf8597f6f672;

});


parcelRegister("jQ5aJ", function(module, exports) {

$parcel$export(module.exports, "SendApiUtil", () => $e716e2b51ee39ca0$export$a6a5161de524b194);

var $kfwQH = parcelRequire("kfwQH");

var $hvrT6 = parcelRequire("hvrT6");

var $gD0RX = parcelRequire("gD0RX");

var $efZLi = parcelRequire("efZLi");

var $dFj3W = parcelRequire("dFj3W");
const $e716e2b51ee39ca0$export$a6a5161de524b194 = {
    async getMyTokensWithBalance (forceUpdate) {
        const address = (0, $kfwQH.AccountController).state.address;
        const caipNetwork = (0, $gD0RX.ChainController).state.activeCaipNetwork;
        if (!address || !caipNetwork) return [];
        // Extract EIP-155 specific logic
        if (caipNetwork.chainNamespace === "eip155") {
            const eip155Balances = await this.getEIP155Balances(address, caipNetwork);
            if (eip155Balances) return this.filterLowQualityTokens(eip155Balances);
        }
        // Fallback to 1Inch API
        const response = await (0, $hvrT6.BlockchainApiController).getBalance(address, caipNetwork.caipNetworkId, forceUpdate);
        return this.filterLowQualityTokens(response.balances);
    },
    async getEIP155Balances (address, caipNetwork) {
        try {
            const chainIdHex = (0, $dFj3W.ERC7811Utils).getChainIdHexFromCAIP2ChainId(caipNetwork.caipNetworkId);
            const walletCapabilities = await (0, $efZLi.ConnectionController).getCapabilities(address);
            if (!walletCapabilities?.[chainIdHex]?.["assetDiscovery"]?.supported) return null;
            const walletGetAssetsResponse = await (0, $efZLi.ConnectionController).walletGetAssets({
                account: address,
                chainFilter: [
                    chainIdHex
                ]
            });
            if (!(0, $dFj3W.ERC7811Utils).isWalletGetAssetsResponse(walletGetAssetsResponse)) return null;
            const assets = walletGetAssetsResponse[chainIdHex] || [];
            return assets.map((asset)=>(0, $dFj3W.ERC7811Utils).createBalance(asset, caipNetwork.caipNetworkId));
        } catch (error) {
            return null;
        }
    },
    /**
     * The 1Inch API includes many low-quality tokens in the balance response,
     * which appear inconsistently. This filter prevents them from being displayed.
     */ filterLowQualityTokens (balances) {
        return balances.filter((balance)=>balance.quantity.decimals !== "0");
    },
    mapBalancesToSwapTokens (balances) {
        return balances?.map((token)=>({
                ...token,
                address: token?.address ? token.address : (0, $gD0RX.ChainController).getActiveNetworkTokenAddress(),
                decimals: parseInt(token.quantity.decimals, 10),
                logoUri: token.iconUrl,
                eip2612: false
            })) || [];
    }
};

});
parcelRegister("dFj3W", function(module, exports) {

$parcel$export(module.exports, "ERC7811Utils", () => $9f2de41f043b2dc9$export$62206186fe95b12);

var $lUvCu = parcelRequire("lUvCu");
const $9f2de41f043b2dc9$export$62206186fe95b12 = {
    /**
     * Creates a Balance object from an ERC7811 Asset object
     * @param asset - Asset object to convert
     * @param chainId - Chain ID in CAIP-2 format
     * @returns Balance object
     */ createBalance (asset, chainId) {
        const metadata = {
            name: asset.metadata["name"] || "",
            symbol: asset.metadata["symbol"] || "",
            decimals: asset.metadata["decimals"] || 0,
            value: asset.metadata["value"] || 0,
            price: asset.metadata["price"] || 0,
            iconUrl: asset.metadata["iconUrl"] || ""
        };
        return {
            name: metadata.name,
            symbol: metadata.symbol,
            chainId: chainId,
            address: asset.address === "native" ? undefined : this.convertAddressToCAIP10Address(asset.address, chainId),
            value: metadata.value,
            price: metadata.price,
            quantity: {
                decimals: metadata.decimals.toString(),
                numeric: this.convertHexToBalance({
                    hex: asset.balance,
                    decimals: metadata.decimals
                })
            },
            iconUrl: metadata.iconUrl
        };
    },
    /**
     * Converts a hex string to a Balance object
     * @param hex - Hex string to convert
     * @param decimals - Number of decimals to use
     * @returns Balance object
     */ convertHexToBalance ({ hex: hex, decimals: decimals }) {
        return (0, $lUvCu.formatUnits)(BigInt(hex), decimals);
    },
    /**
     * Converts an address to a CAIP-10 address
     * @param address - Address to convert
     * @param chainId - Chain ID in CAIP-2 format
     * @returns CAIP-10 address
     */ convertAddressToCAIP10Address (address, chainId) {
        return `${chainId}:${address}`;
    },
    /**
     *  Creates a CAIP-2 Chain ID from a chain ID and namespace
     * @param chainId  - Chain ID in hex format
     * @param namespace  - Chain namespace
     * @returns
     */ createCAIP2ChainId (chainId, namespace) {
        return `${namespace}:${parseInt(chainId, 16)}`;
    },
    /**
     * Gets the chain ID in hex format from a CAIP-2 Chain ID
     * @param caip2ChainId - CAIP-2 Chain ID
     * @returns Chain ID in hex format
     */ getChainIdHexFromCAIP2ChainId (caip2ChainId) {
        const parts = caip2ChainId.split(":");
        if (parts.length < 2 || !parts[1]) return "0x0";
        const chainPart = parts[1];
        const parsed = parseInt(chainPart, 10);
        return isNaN(parsed) ? "0x0" : `0x${parsed.toString(16)}`;
    },
    /**
     * Checks if a response is a valid WalletGetAssetsResponse
     * @param response - The response to check
     * @returns True if the response is a valid WalletGetAssetsResponse, false otherwise
     */ isWalletGetAssetsResponse (response) {
        // Check if response is an object and has the expected structure
        if (typeof response !== "object" || response === null) return false;
        // Check if all values are arrays and conform to the expected asset structure
        return Object.values(response).every((value)=>Array.isArray(value) && value.every((asset)=>this.isValidAsset(asset)));
    },
    /**
     * Checks if an asset object is valid.
     * @param asset - The asset object to check.
     * @returns True if the asset is valid, false otherwise.
     */ isValidAsset (asset) {
        return typeof asset === "object" && asset !== null && typeof asset.address === "string" && typeof asset.balance === "string" && (asset.type === "ERC20" || asset.type === "NATIVE") && typeof asset.metadata === "object" && asset.metadata !== null && typeof asset.metadata["name"] === "string" && typeof asset.metadata["symbol"] === "string" && typeof asset.metadata["decimals"] === "number" && typeof asset.metadata["price"] === "number" && typeof asset.metadata["iconUrl"] === "string";
    }
};

});
parcelRegister("lUvCu", function(module, exports) {

$parcel$export(module.exports, "formatUnits", () => $ff375af910281d47$export$bd39b96f71da1885);
/**
 *  Divides a number by a given exponent of base 10 (10exponent), and formats it into a string representation of the number..
 *
 * - Docs: https://viem.sh/docs/utilities/formatUnits
 *
 * @example
 * import { formatUnits } from 'viem'
 *
 * formatUnits(420000000000n, 9)
 * // '420'
 */ function $ff375af910281d47$export$bd39b96f71da1885(value, decimals) {
    let display = value.toString();
    const negative = display.startsWith("-");
    if (negative) display = display.slice(1);
    display = display.padStart(decimals, "0");
    let [integer, fraction] = [
        display.slice(0, display.length - decimals),
        display.slice(display.length - decimals)
    ];
    fraction = fraction.replace(/(0+)$/, "");
    return `${negative ? "-" : ""}${integer || "0"}${fraction ? `.${fraction}` : ""}`;
}

});





parcelRegister("5SSdQ", function(module, exports) {

$parcel$export(module.exports, "ConstantsUtil", () => $448c0e4bb1ff1254$export$aafe1f751f1bc52a);
const $448c0e4bb1ff1254$export$aafe1f751f1bc52a = {
    METMASK_CONNECTOR_NAME: "MetaMask",
    TRUST_CONNECTOR_NAME: "Trust Wallet",
    SOLFLARE_CONNECTOR_NAME: "Solflare",
    PHANTOM_CONNECTOR_NAME: "Phantom",
    COIN98_CONNECTOR_NAME: "Coin98",
    MAGIC_EDEN_CONNECTOR_NAME: "Magic Eden",
    BACKPACK_CONNECTOR_NAME: "Backpack",
    BITGET_CONNECTOR_NAME: "Bitget Wallet",
    FRONTIER_CONNECTOR_NAME: "Frontier",
    XVERSE_CONNECTOR_NAME: "Xverse Wallet",
    LEATHER_CONNECTOR_NAME: "Leather",
    EIP155: "eip155",
    ADD_CHAIN_METHOD: "wallet_addEthereumChain",
    EIP6963_ANNOUNCE_EVENT: "eip6963:announceProvider",
    EIP6963_REQUEST_EVENT: "eip6963:requestProvider",
    CONNECTOR_RDNS_MAP: {
        coinbaseWallet: "com.coinbase.wallet",
        coinbaseWalletSDK: "com.coinbase.wallet"
    },
    CONNECTOR_TYPE_EXTERNAL: "EXTERNAL",
    CONNECTOR_TYPE_WALLET_CONNECT: "WALLET_CONNECT",
    CONNECTOR_TYPE_INJECTED: "INJECTED",
    CONNECTOR_TYPE_ANNOUNCED: "ANNOUNCED",
    CONNECTOR_TYPE_AUTH: "AUTH",
    CONNECTOR_TYPE_MULTI_CHAIN: "MULTI_CHAIN",
    CONNECTOR_TYPE_W3M_AUTH: "ID_AUTH"
};

});

parcelRegister("6rTj5", function(module, exports) {

$parcel$export(module.exports, "ErrorUtil", () => $4b202a7b56c76283$export$fbf30fa5992be4f5);
const $4b202a7b56c76283$var$abortController = new AbortController();
const $4b202a7b56c76283$export$fbf30fa5992be4f5 = {
    EmbeddedWalletAbortController: $4b202a7b56c76283$var$abortController,
    UniversalProviderErrors: {
        UNAUTHORIZED_DOMAIN_NOT_ALLOWED: {
            message: "Unauthorized: origin not allowed",
            alertErrorKey: "INVALID_APP_CONFIGURATION"
        },
        JWT_VALIDATION_ERROR: {
            message: "JWT validation error: JWT Token is not yet valid",
            alertErrorKey: "JWT_TOKEN_NOT_VALID"
        },
        INVALID_KEY: {
            message: "Unauthorized: invalid key",
            alertErrorKey: "INVALID_PROJECT_ID"
        }
    },
    ALERT_ERRORS: {
        SWITCH_NETWORK_NOT_FOUND: {
            shortMessage: "Network Not Found",
            longMessage: "Network not found - please make sure it is included in 'networks' array in createAppKit function"
        },
        INVALID_APP_CONFIGURATION: {
            shortMessage: "Invalid App Configuration",
            longMessage: ()=>`Origin ${$4b202a7b56c76283$var$isSafe() ? window.origin : "unknown"} not found on Allowlist - update configuration on cloud.reown.com`
        },
        IFRAME_LOAD_FAILED: {
            shortMessage: "Network Error - Could not load embedded wallet",
            longMessage: ()=>"There was an issue loading the embedded wallet. Please try again later."
        },
        IFRAME_REQUEST_TIMEOUT: {
            shortMessage: "Embedded Wallet Request Timed Out",
            longMessage: ()=>"There was an issue doing the request to the embedded wallet. Please try again later."
        },
        UNVERIFIED_DOMAIN: {
            shortMessage: "Invalid App Configuration",
            longMessage: ()=>"There was an issue loading the embedded wallet. Please verify that your domain is allowed at cloud.reown.com"
        },
        JWT_TOKEN_NOT_VALID: {
            shortMessage: "Session Expired",
            longMessage: "Invalid session found on UniversalProvider - please check your time settings and connect again"
        },
        INVALID_PROJECT_ID: {
            shortMessage: "Invalid App Configuration",
            longMessage: "Invalid Project ID - update configuration"
        },
        PROJECT_ID_NOT_CONFIGURED: {
            shortMessage: "Project ID Not Configured",
            longMessage: "Project ID Not Configured - update configuration on cloud.reown.com"
        }
    }
};
function $4b202a7b56c76283$var$isSafe() {
    return typeof window !== "undefined";
}

});

parcelRegister("bCoR3", function(module, exports) {

$parcel$export(module.exports, "ProviderUtil", () => $875685ec4e1660fd$export$5e77bfd2f7a1eb35);

var $7zrdF = parcelRequire("7zrdF");

var $eFS1l = parcelRequire("eFS1l");
const $875685ec4e1660fd$var$CLEAN_PROVIDERS_STATE = {
    eip155: undefined,
    solana: undefined,
    polkadot: undefined,
    bip122: undefined,
    cosmos: undefined
};
const $875685ec4e1660fd$var$state = (0, $7zrdF.proxy)({
    providers: {
        ...$875685ec4e1660fd$var$CLEAN_PROVIDERS_STATE
    },
    providerIds: {
        ...$875685ec4e1660fd$var$CLEAN_PROVIDERS_STATE
    }
});
const $875685ec4e1660fd$export$5e77bfd2f7a1eb35 = {
    state: $875685ec4e1660fd$var$state,
    subscribeKey (key, callback) {
        return (0, $eFS1l.subscribeKey)($875685ec4e1660fd$var$state, key, callback);
    },
    subscribe (callback) {
        return (0, $7zrdF.subscribe)($875685ec4e1660fd$var$state, ()=>{
            callback($875685ec4e1660fd$var$state);
        });
    },
    subscribeProviders (callback) {
        return (0, $7zrdF.subscribe)($875685ec4e1660fd$var$state.providers, ()=>callback($875685ec4e1660fd$var$state.providers));
    },
    setProvider (chainNamespace, provider) {
        if (provider) $875685ec4e1660fd$var$state.providers[chainNamespace] = (0, $7zrdF.ref)(provider);
    },
    getProvider (chainNamespace) {
        return $875685ec4e1660fd$var$state.providers[chainNamespace];
    },
    setProviderId (chainNamespace, providerId) {
        if (providerId) $875685ec4e1660fd$var$state.providerIds[chainNamespace] = providerId;
    },
    getProviderId (chainNamespace) {
        if (!chainNamespace) return undefined;
        return $875685ec4e1660fd$var$state.providerIds[chainNamespace];
    },
    reset () {
        $875685ec4e1660fd$var$state.providers = {
            ...$875685ec4e1660fd$var$CLEAN_PROVIDERS_STATE
        };
        $875685ec4e1660fd$var$state.providerIds = {
            ...$875685ec4e1660fd$var$CLEAN_PROVIDERS_STATE
        };
    },
    resetChain (chainNamespace) {
        $875685ec4e1660fd$var$state.providers[chainNamespace] = undefined;
        $875685ec4e1660fd$var$state.providerIds[chainNamespace] = undefined;
    }
};

});

parcelRegister("5nPZz", function(module, exports) {

$parcel$export(module.exports, "W3mFrameHelpers", () => $3eb76e461cd0d61d$export$794efc40d8765bc4);

var $h5AQd = parcelRequire("h5AQd");

var $034Ac = parcelRequire("034Ac");

var $iM16n = parcelRequire("iM16n");
const $3eb76e461cd0d61d$var$EMAIL_MINIMUM_TIMEOUT = 30000;
const $3eb76e461cd0d61d$export$794efc40d8765bc4 = {
    checkIfAllowedToTriggerEmail () {
        const lastEmailLoginTime = (0, $iM16n.W3mFrameStorage).get((0, $034Ac.W3mFrameConstants).LAST_EMAIL_LOGIN_TIME);
        if (lastEmailLoginTime) {
            const difference = Date.now() - Number(lastEmailLoginTime);
            if (difference < $3eb76e461cd0d61d$var$EMAIL_MINIMUM_TIMEOUT) {
                const cooldownSec = Math.ceil(($3eb76e461cd0d61d$var$EMAIL_MINIMUM_TIMEOUT - difference) / 1000);
                throw new Error(`Please try again after ${cooldownSec} seconds`);
            }
        }
    },
    getTimeToNextEmailLogin () {
        const lastEmailLoginTime = (0, $iM16n.W3mFrameStorage).get((0, $034Ac.W3mFrameConstants).LAST_EMAIL_LOGIN_TIME);
        if (lastEmailLoginTime) {
            const difference = Date.now() - Number(lastEmailLoginTime);
            if (difference < $3eb76e461cd0d61d$var$EMAIL_MINIMUM_TIMEOUT) return Math.ceil(($3eb76e461cd0d61d$var$EMAIL_MINIMUM_TIMEOUT - difference) / 1000);
        }
        return 0;
    },
    checkIfRequestExists (request) {
        return (0, $034Ac.W3mFrameRpcConstants).NOT_SAFE_RPC_METHODS.includes(request.method) || (0, $034Ac.W3mFrameRpcConstants).SAFE_RPC_METHODS.includes(request.method);
    },
    getResponseType (response) {
        const isPayloadString = typeof response === "string";
        const isTransactionHash = isPayloadString && (response?.match((0, $h5AQd.RegexUtil).transactionHash) || response?.match((0, $h5AQd.RegexUtil).signedMessage));
        if (isTransactionHash) return (0, $034Ac.W3mFrameConstants).RPC_RESPONSE_TYPE_TX;
        return (0, $034Ac.W3mFrameConstants).RPC_RESPONSE_TYPE_OBJECT;
    },
    checkIfRequestIsSafe (request) {
        return (0, $034Ac.W3mFrameRpcConstants).SAFE_RPC_METHODS.includes(request.method);
    },
    isClient: typeof window !== "undefined"
};

});
parcelRegister("h5AQd", function(module, exports) {

$parcel$export(module.exports, "RegexUtil", () => $c70f7b3032e1105c$export$e5d4f8e67553e137);
const $c70f7b3032e1105c$export$e5d4f8e67553e137 = {
    address: /^0x(?:[A-Fa-f0-9]{40})$/u,
    transactionHash: /^0x(?:[A-Fa-f0-9]{64})$/u,
    signedMessage: /^0x(?:[a-fA-F0-9]{62,})$/u
};

});

parcelRegister("iM16n", function(module, exports) {

$parcel$export(module.exports, "W3mFrameStorage", () => $daad907ef4cfa7e9$export$500c415dce2853c3);

var $034Ac = parcelRequire("034Ac");

var $5nPZz = parcelRequire("5nPZz");
const $daad907ef4cfa7e9$export$500c415dce2853c3 = {
    set (key, value) {
        if ((0, $5nPZz.W3mFrameHelpers).isClient) localStorage.setItem(`${(0, $034Ac.W3mFrameConstants).STORAGE_KEY}${key}`, value);
    },
    get (key) {
        if ((0, $5nPZz.W3mFrameHelpers).isClient) return localStorage.getItem(`${(0, $034Ac.W3mFrameConstants).STORAGE_KEY}${key}`);
        return null;
    },
    delete (key, social) {
        if ((0, $5nPZz.W3mFrameHelpers).isClient) {
            if (social) localStorage.removeItem(key);
            else localStorage.removeItem(`${(0, $034Ac.W3mFrameConstants).STORAGE_KEY}${key}`);
        }
    }
};

});


parcelRegister("7vbDh", function(module, exports) {

$parcel$export(module.exports, "W3mFrameProvider", () => $576473a067ef6a3c$export$112ca4a9acf9f612);

var $b56LK = parcelRequire("b56LK");

var $034Ac = parcelRequire("034Ac");

var $5nPZz = parcelRequire("5nPZz");

var $5BRQ2 = parcelRequire("5BRQ2");

var $iM16n = parcelRequire("iM16n");
class $576473a067ef6a3c$export$112ca4a9acf9f612 {
    constructor({ projectId: projectId, chainId: chainId, enableLogger: enableLogger = true, onTimeout: onTimeout, abortController: abortController }){
        this.openRpcRequests = [];
        this.isInitialized = false;
        if (enableLogger) this.w3mLogger = new (0, $5BRQ2.W3mFrameLogger)(projectId);
        this.abortController = abortController;
        this.w3mFrame = new (0, $b56LK.W3mFrame)({
            projectId: projectId,
            isAppClient: true,
            chainId: chainId,
            enableLogger: enableLogger
        });
        this.onTimeout = onTimeout;
        if (this.getLoginEmailUsed()) this.createFrame();
    }
    async createFrame() {
        this.w3mFrame.initFrame();
        this.initPromise = new Promise((resolve)=>{
            this.w3mFrame.events.onFrameEvent((event)=>{
                if (event.type === (0, $034Ac.W3mFrameConstants).FRAME_READY) setTimeout(()=>{
                    resolve();
                }, 500);
            });
        });
        await this.initPromise;
        this.isInitialized = true;
        this.initPromise = undefined;
    }
    async init() {
        if (this.isInitialized) return;
        if (this.initPromise) {
            await this.initPromise;
            return;
        }
        await this.createFrame();
    }
    getLoginEmailUsed() {
        return Boolean((0, $iM16n.W3mFrameStorage).get((0, $034Ac.W3mFrameConstants).EMAIL_LOGIN_USED_KEY));
    }
    getEmail() {
        return (0, $iM16n.W3mFrameStorage).get((0, $034Ac.W3mFrameConstants).EMAIL);
    }
    getUsername() {
        return (0, $iM16n.W3mFrameStorage).get((0, $034Ac.W3mFrameConstants).SOCIAL_USERNAME);
    }
    async reload() {
        try {
            await this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_RELOAD
            });
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error reloading iframe");
            throw error;
        }
    }
    async connectEmail(payload) {
        try {
            (0, $5nPZz.W3mFrameHelpers).checkIfAllowedToTriggerEmail();
            await this.init();
            const response = await this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_CONNECT_EMAIL,
                payload: payload
            });
            this.setNewLastEmailLoginTime();
            return response;
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error connecting email");
            throw error;
        }
    }
    async connectDevice() {
        try {
            return this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_CONNECT_DEVICE
            });
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error connecting device");
            throw error;
        }
    }
    async connectOtp(payload) {
        try {
            return this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_CONNECT_OTP,
                payload: payload
            });
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error connecting otp");
            throw error;
        }
    }
    async isConnected() {
        try {
            if (!this.getLoginEmailUsed()) return {
                isConnected: false
            };
            const response = await this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_IS_CONNECTED
            });
            if (!response?.isConnected) this.deleteAuthLoginCache();
            return response;
        } catch (error) {
            this.deleteAuthLoginCache();
            this.w3mLogger?.logger.error({
                error: error
            }, "Error checking connection");
            throw error;
        }
    }
    async getChainId() {
        try {
            const response = await this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_GET_CHAIN_ID
            });
            this.setLastUsedChainId(response.chainId);
            return response;
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error getting chain id");
            throw error;
        }
    }
    async getSocialRedirectUri(payload) {
        try {
            await this.init();
            return this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_GET_SOCIAL_REDIRECT_URI,
                payload: payload
            });
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error getting social redirect uri");
            throw error;
        }
    }
    async updateEmail(payload) {
        try {
            const response = await this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_UPDATE_EMAIL,
                payload: payload
            });
            this.setNewLastEmailLoginTime();
            return response;
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error updating email");
            throw error;
        }
    }
    async updateEmailPrimaryOtp(payload) {
        try {
            return this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_UPDATE_EMAIL_PRIMARY_OTP,
                payload: payload
            });
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error updating email primary otp");
            throw error;
        }
    }
    async updateEmailSecondaryOtp(payload) {
        try {
            const response = await this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_UPDATE_EMAIL_SECONDARY_OTP,
                payload: payload
            });
            this.setLoginSuccess(response.newEmail);
            return response;
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error updating email secondary otp");
            throw error;
        }
    }
    async syncTheme(payload) {
        try {
            return this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_SYNC_THEME,
                payload: payload
            });
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error syncing theme");
            throw error;
        }
    }
    async syncDappData(payload) {
        try {
            return this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_SYNC_DAPP_DATA,
                payload: payload
            });
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error syncing dapp data");
            throw error;
        }
    }
    async getSmartAccountEnabledNetworks() {
        try {
            const response = await this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_GET_SMART_ACCOUNT_ENABLED_NETWORKS
            });
            this.persistSmartAccountEnabledNetworks(response.smartAccountEnabledNetworks);
            return response;
        } catch (error) {
            this.persistSmartAccountEnabledNetworks([]);
            this.w3mLogger?.logger.error({
                error: error
            }, "Error getting smart account enabled networks");
            throw error;
        }
    }
    async setPreferredAccount(type) {
        try {
            return this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_SET_PREFERRED_ACCOUNT,
                payload: {
                    type: type
                }
            });
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error setting preferred account");
            throw error;
        }
    }
    async connect(payload) {
        if (payload?.socialUri) try {
            await this.init();
            const response = await this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_CONNECT_SOCIAL,
                payload: {
                    uri: payload.socialUri,
                    preferredAccountType: payload.preferredAccountType,
                    chainId: payload.chainId
                }
            });
            if (response.userName) this.setSocialLoginSuccess(response.userName);
            this.setLoginSuccess(response.email);
            this.setLastUsedChainId(response.chainId);
            this.user = response;
            return response;
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error connecting social");
            throw error;
        }
        else try {
            const chainId = payload?.chainId || this.getLastUsedChainId() || 1;
            const response = await this.getUser({
                chainId: chainId,
                preferredAccountType: payload?.preferredAccountType
            });
            this.setLoginSuccess(response.email);
            this.setLastUsedChainId(response.chainId);
            this.user = response;
            return response;
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error connecting");
            throw error;
        }
    }
    async getUser(payload) {
        try {
            await this.init();
            const chainId = payload?.chainId || this.getLastUsedChainId() || 1;
            const response = await this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_GET_USER,
                payload: {
                    ...payload,
                    chainId: chainId
                }
            });
            this.user = response;
            return response;
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error connecting");
            throw error;
        }
    }
    async connectSocial(uri) {
        try {
            await this.init();
            const response = await this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_CONNECT_SOCIAL,
                payload: {
                    uri: uri
                }
            });
            if (response.userName) this.setSocialLoginSuccess(response.userName);
            return response;
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error connecting social");
            throw error;
        }
    }
    async getFarcasterUri() {
        try {
            await this.init();
            const response = await this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_GET_FARCASTER_URI
            });
            return response;
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error getting farcaster uri");
            throw error;
        }
    }
    async connectFarcaster() {
        try {
            const response = await this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_CONNECT_FARCASTER
            });
            if (response.userName) this.setSocialLoginSuccess(response.userName);
            return response;
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error connecting farcaster");
            throw error;
        }
    }
    async switchNetwork(chainId) {
        try {
            const response = await this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_SWITCH_NETWORK,
                payload: {
                    chainId: chainId
                }
            });
            this.setLastUsedChainId(response.chainId);
            return response;
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error switching network");
            throw error;
        }
    }
    async disconnect() {
        try {
            this.deleteAuthLoginCache();
            const response = await new Promise(async (resolve)=>{
                const timeout = setTimeout(()=>{
                    resolve();
                }, 3000);
                await this.appEvent({
                    type: (0, $034Ac.W3mFrameConstants).APP_SIGN_OUT
                });
                clearTimeout(timeout);
                resolve();
            });
            return response;
        } catch (error) {
            this.w3mLogger?.logger.error({
                error: error
            }, "Error disconnecting");
            throw error;
        }
    }
    async request(req) {
        try {
            if ((0, $034Ac.W3mFrameRpcConstants).GET_CHAIN_ID === req.method) return this.getLastUsedChainId();
            this.rpcRequestHandler?.(req);
            const response = await this.appEvent({
                type: (0, $034Ac.W3mFrameConstants).APP_RPC_REQUEST,
                payload: req
            });
            this.rpcSuccessHandler?.(response, req);
            return response;
        } catch (error) {
            this.rpcErrorHandler?.(error, req);
            this.w3mLogger?.logger.error({
                error: error
            }, "Error requesting");
            throw error;
        }
    }
    onRpcRequest(callback) {
        this.rpcRequestHandler = callback;
    }
    onRpcSuccess(callback) {
        this.rpcSuccessHandler = callback;
    }
    onRpcError(callback) {
        this.rpcErrorHandler = callback;
    }
    onIsConnected(callback) {
        this.w3mFrame.events.onFrameEvent((event)=>{
            if (event.type === (0, $034Ac.W3mFrameConstants).FRAME_IS_CONNECTED_SUCCESS && event.payload.isConnected) callback();
        });
    }
    onNotConnected(callback) {
        this.w3mFrame.events.onFrameEvent((event)=>{
            if (event.type === (0, $034Ac.W3mFrameConstants).FRAME_IS_CONNECTED_ERROR) callback();
            if (event.type === (0, $034Ac.W3mFrameConstants).FRAME_IS_CONNECTED_SUCCESS && !event.payload.isConnected) callback();
        });
    }
    onConnect(callback) {
        this.w3mFrame.events.onFrameEvent((event)=>{
            if (event.type === (0, $034Ac.W3mFrameConstants).FRAME_GET_USER_SUCCESS) callback(event.payload);
        });
    }
    onSocialConnected(callback) {
        this.w3mFrame.events.onFrameEvent((event)=>{
            if (event.type === (0, $034Ac.W3mFrameConstants).FRAME_CONNECT_SOCIAL_SUCCESS) callback(event.payload);
        });
    }
    async getCapabilities() {
        try {
            const capabilities = await this.request({
                method: "wallet_getCapabilities"
            });
            return capabilities || {};
        } catch  {
            return {};
        }
    }
    onSetPreferredAccount(callback) {
        this.w3mFrame.events.onFrameEvent((event)=>{
            if (event.type === (0, $034Ac.W3mFrameConstants).FRAME_SET_PREFERRED_ACCOUNT_SUCCESS) callback(event.payload);
            else if (event.type === (0, $034Ac.W3mFrameConstants).FRAME_SET_PREFERRED_ACCOUNT_ERROR) callback({
                type: (0, $034Ac.W3mFrameRpcConstants).ACCOUNT_TYPES.EOA
            });
        });
    }
    onGetSmartAccountEnabledNetworks(callback) {
        this.w3mFrame.events.onFrameEvent((event)=>{
            if (event.type === (0, $034Ac.W3mFrameConstants).FRAME_GET_SMART_ACCOUNT_ENABLED_NETWORKS_SUCCESS) callback(event.payload.smartAccountEnabledNetworks);
            else if (event.type === (0, $034Ac.W3mFrameConstants).FRAME_GET_SMART_ACCOUNT_ENABLED_NETWORKS_ERROR) callback([]);
        });
    }
    getAvailableChainIds() {
        return Object.keys(this.w3mFrame.networks);
    }
    rejectRpcRequests() {
        try {
            this.openRpcRequests.forEach(({ abortController: abortController, method: method })=>{
                if (!(0, $034Ac.W3mFrameRpcConstants).SAFE_RPC_METHODS.includes(method)) abortController.abort();
            });
            this.openRpcRequests = [];
        } catch (e) {
            this.w3mLogger?.logger.error({
                error: e
            }, "Error aborting RPC request");
        }
    }
    async appEvent(event) {
        let requestTimeout = undefined;
        let iframeReadyTimeout = undefined;
        function replaceEventType(type) {
            return type.replace("@w3m-app/", "");
        }
        const safeEventTypes = [
            (0, $034Ac.W3mFrameConstants).APP_SYNC_DAPP_DATA,
            (0, $034Ac.W3mFrameConstants).APP_SYNC_THEME,
            (0, $034Ac.W3mFrameConstants).APP_SET_PREFERRED_ACCOUNT
        ];
        const type = replaceEventType(event.type);
        if (!this.w3mFrame.iframeIsReady && !safeEventTypes.includes(event.type)) iframeReadyTimeout = setTimeout(()=>{
            this.onTimeout?.("iframe_load_failed");
            this.abortController.abort();
        }, 20000);
        await this.w3mFrame.frameLoadPromise;
        clearTimeout(iframeReadyTimeout);
        const shouldCheckForTimeout = [
            (0, $034Ac.W3mFrameConstants).APP_CONNECT_EMAIL,
            (0, $034Ac.W3mFrameConstants).APP_CONNECT_DEVICE,
            (0, $034Ac.W3mFrameConstants).APP_CONNECT_OTP,
            (0, $034Ac.W3mFrameConstants).APP_CONNECT_SOCIAL,
            (0, $034Ac.W3mFrameConstants).APP_GET_SOCIAL_REDIRECT_URI
        ].map(replaceEventType).includes(type);
        if (shouldCheckForTimeout) requestTimeout = setTimeout(()=>{
            this.onTimeout?.("iframe_request_timeout");
            this.abortController.abort();
        }, 30000);
        return new Promise((resolve, reject)=>{
            const id = Math.random().toString(36).substring(7);
            this.w3mLogger?.logger.info?.({
                event: event,
                id: id
            }, "Sending app event");
            this.w3mFrame.events.postAppEvent({
                ...event,
                id: id
            });
            const abortController = new AbortController();
            if (type === "RPC_REQUEST") {
                const rpcEvent = event;
                this.openRpcRequests = [
                    ...this.openRpcRequests,
                    {
                        ...rpcEvent.payload,
                        abortController: abortController
                    }
                ];
            }
            abortController.signal.addEventListener("abort", ()=>{
                if (type === "RPC_REQUEST") reject(new Error("Request was aborted"));
                else if (type !== "GET_FARCASTER_URI") reject(new Error("Something went wrong"));
            });
            function handler(framEvent, logger) {
                if (framEvent.id !== id) return;
                logger?.logger.info?.({
                    framEvent: framEvent,
                    id: id
                }, "Received frame response");
                if (framEvent.type === `@w3m-frame/${type}_SUCCESS`) {
                    if (requestTimeout) clearTimeout(requestTimeout);
                    if (iframeReadyTimeout) clearTimeout(iframeReadyTimeout);
                    if ("payload" in framEvent) resolve(framEvent.payload);
                    resolve(undefined);
                } else if (framEvent.type === `@w3m-frame/${type}_ERROR`) {
                    if (requestTimeout) clearTimeout(requestTimeout);
                    if (iframeReadyTimeout) clearTimeout(iframeReadyTimeout);
                    if ("payload" in framEvent) reject(new Error(framEvent.payload?.message || "An error occurred"));
                    reject(new Error("An error occurred"));
                }
            }
            this.w3mFrame.events.registerFrameEventHandler(id, (frameEvent)=>handler(frameEvent, this.w3mLogger), this.abortController.signal);
        });
    }
    setNewLastEmailLoginTime() {
        (0, $iM16n.W3mFrameStorage).set((0, $034Ac.W3mFrameConstants).LAST_EMAIL_LOGIN_TIME, Date.now().toString());
    }
    setSocialLoginSuccess(username) {
        (0, $iM16n.W3mFrameStorage).set((0, $034Ac.W3mFrameConstants).SOCIAL_USERNAME, username);
    }
    setLoginSuccess(email) {
        if (email) (0, $iM16n.W3mFrameStorage).set((0, $034Ac.W3mFrameConstants).EMAIL, email);
        (0, $iM16n.W3mFrameStorage).set((0, $034Ac.W3mFrameConstants).EMAIL_LOGIN_USED_KEY, "true");
        (0, $iM16n.W3mFrameStorage).delete((0, $034Ac.W3mFrameConstants).LAST_EMAIL_LOGIN_TIME);
    }
    deleteAuthLoginCache() {
        (0, $iM16n.W3mFrameStorage).delete((0, $034Ac.W3mFrameConstants).EMAIL_LOGIN_USED_KEY);
        (0, $iM16n.W3mFrameStorage).delete((0, $034Ac.W3mFrameConstants).EMAIL);
        (0, $iM16n.W3mFrameStorage).delete((0, $034Ac.W3mFrameConstants).LAST_USED_CHAIN_KEY);
        (0, $iM16n.W3mFrameStorage).delete((0, $034Ac.W3mFrameConstants).SOCIAL_USERNAME);
    }
    setLastUsedChainId(chainId) {
        if (chainId) (0, $iM16n.W3mFrameStorage).set((0, $034Ac.W3mFrameConstants).LAST_USED_CHAIN_KEY, String(chainId));
    }
    getLastUsedChainId() {
        const chainId = (0, $iM16n.W3mFrameStorage).get((0, $034Ac.W3mFrameConstants).LAST_USED_CHAIN_KEY) ?? undefined;
        const numberChainId = Number(chainId);
        return isNaN(numberChainId) ? chainId : numberChainId;
    }
    persistSmartAccountEnabledNetworks(networks) {
        (0, $iM16n.W3mFrameStorage).set((0, $034Ac.W3mFrameConstants).SMART_ACCOUNT_ENABLED_NETWORKS, networks.join(","));
    }
}

});
parcelRegister("b56LK", function(module, exports) {

$parcel$export(module.exports, "W3mFrame", () => $811569920e90597c$export$668e35d4f1b0aa08);

var $b3v9s = parcelRequire("b3v9s");

var $034Ac = parcelRequire("034Ac");

var $5nPZz = parcelRequire("5nPZz");

var $7ZO7l = parcelRequire("7ZO7l");
function $811569920e90597c$var$shouldHandleEvent(eventKey, data = {}) {
    return typeof data?.type === "string" && data?.type?.includes(eventKey);
}
class $811569920e90597c$export$668e35d4f1b0aa08 {
    constructor({ projectId: projectId, isAppClient: isAppClient = false, chainId: chainId = "eip155:1", enableLogger: enableLogger = true }){
        this.iframe = null;
        this.iframeIsReady = false;
        this.rpcUrl = (0, $b3v9s.ConstantsUtil).BLOCKCHAIN_API_RPC_URL;
        this.initFrame = ()=>{
            const isFrameInitialized = document.getElementById("w3m-iframe");
            if (this.iframe && !isFrameInitialized) document.body.appendChild(this.iframe);
        };
        this.events = {
            registerFrameEventHandler: (id, callback, signal)=>{
                function eventHandler({ data: data }) {
                    if (!$811569920e90597c$var$shouldHandleEvent((0, $034Ac.W3mFrameConstants).FRAME_EVENT_KEY, data)) return;
                    const frameEvent = (0, $7ZO7l.W3mFrameSchema).frameEvent.parse(data);
                    if (frameEvent.id === id) {
                        callback(frameEvent);
                        window.removeEventListener("message", eventHandler);
                    }
                }
                if ((0, $5nPZz.W3mFrameHelpers).isClient) {
                    window.addEventListener("message", eventHandler);
                    signal.addEventListener("abort", ()=>{
                        window.removeEventListener("message", eventHandler);
                    });
                }
            },
            onFrameEvent: (callback)=>{
                if ((0, $5nPZz.W3mFrameHelpers).isClient) window.addEventListener("message", ({ data: data })=>{
                    if (!$811569920e90597c$var$shouldHandleEvent((0, $034Ac.W3mFrameConstants).FRAME_EVENT_KEY, data)) return;
                    const frameEvent = (0, $7ZO7l.W3mFrameSchema).frameEvent.parse(data);
                    callback(frameEvent);
                });
            },
            onAppEvent: (callback)=>{
                if ((0, $5nPZz.W3mFrameHelpers).isClient) window.addEventListener("message", ({ data: data })=>{
                    if (!$811569920e90597c$var$shouldHandleEvent((0, $034Ac.W3mFrameConstants).APP_EVENT_KEY, data)) return;
                    const appEvent = (0, $7ZO7l.W3mFrameSchema).appEvent.parse(data);
                    callback(appEvent);
                });
            },
            postAppEvent: (event)=>{
                if ((0, $5nPZz.W3mFrameHelpers).isClient) {
                    if (!this.iframe?.contentWindow) throw new Error("W3mFrame: iframe is not set");
                    (0, $7ZO7l.W3mFrameSchema).appEvent.parse(event);
                    this.iframe.contentWindow.postMessage(event, "*");
                }
            },
            postFrameEvent: (event)=>{
                if ((0, $5nPZz.W3mFrameHelpers).isClient) {
                    if (!parent) throw new Error("W3mFrame: parent is not set");
                    (0, $7ZO7l.W3mFrameSchema).frameEvent.parse(event);
                    parent.postMessage(event, "*");
                }
            }
        };
        this.projectId = projectId;
        this.frameLoadPromise = new Promise((resolve, reject)=>{
            this.frameLoadPromiseResolver = {
                resolve: resolve,
                reject: reject
            };
        });
        if (isAppClient) {
            this.frameLoadPromise = new Promise((resolve, reject)=>{
                this.frameLoadPromiseResolver = {
                    resolve: resolve,
                    reject: reject
                };
            });
            if ((0, $5nPZz.W3mFrameHelpers).isClient) {
                const iframe = document.createElement("iframe");
                iframe.id = "w3m-iframe";
                iframe.src = `${0, $034Ac.SECURE_SITE_SDK}?projectId=${projectId}&chainId=${chainId}&version=${0, $034Ac.SECURE_SITE_SDK_VERSION}&enableLogger=${enableLogger}`;
                iframe.name = "w3m-secure-iframe";
                iframe.style.position = "fixed";
                iframe.style.zIndex = "999999";
                iframe.style.display = "none";
                iframe.style.border = "none";
                iframe.style.animationDelay = "0s, 50ms";
                iframe.style.borderBottomLeftRadius = `clamp(0px, var(--wui-border-radius-l), 44px)`;
                iframe.style.borderBottomRightRadius = `clamp(0px, var(--wui-border-radius-l), 44px)`;
                this.iframe = iframe;
                this.iframe.onerror = ()=>{
                    this.frameLoadPromiseResolver?.reject("Unable to load email login dependency");
                };
                this.events.onFrameEvent((event)=>{
                    if (event.type === "@w3m-frame/READY") {
                        this.iframeIsReady = true;
                        this.frameLoadPromiseResolver?.resolve(undefined);
                    }
                });
            }
        }
    }
    get networks() {
        const data = [
            "eip155:1",
            "eip155:5",
            "eip155:11155111",
            "eip155:10",
            "eip155:420",
            "eip155:42161",
            "eip155:421613",
            "eip155:137",
            "eip155:80001",
            "eip155:42220",
            "eip155:1313161554",
            "eip155:1313161555",
            "eip155:56",
            "eip155:97",
            "eip155:43114",
            "eip155:43113",
            "eip155:324",
            "eip155:280",
            "eip155:100",
            "eip155:8453",
            "eip155:84531",
            "eip155:84532",
            "eip155:7777777",
            "eip155:999",
            "solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp",
            "solana:4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z",
            "solana:EtWTRABZaYq6iMfeYKouRu166VU2xqa1"
        ].map((id)=>({
                [id]: {
                    rpcUrl: `${this.rpcUrl}/v1/?chainId=${id}&projectId=${this.projectId}`,
                    chainId: id
                }
            }));
        return Object.assign({}, ...data);
    }
}

});
parcelRegister("7ZO7l", function(module, exports) {

$parcel$export(module.exports, "W3mFrameSchema", () => $5d251b2b36ad3cb7$export$238f9986c2bb1b9a);

var $lBSq3 = parcelRequire("lBSq3");

var $034Ac = parcelRequire("034Ac");
const $5d251b2b36ad3cb7$var$zError = (0, $lBSq3.z).object({
    message: (0, $lBSq3.z).string()
});
function $5d251b2b36ad3cb7$var$zType(key) {
    return (0, $lBSq3.z).literal((0, $034Ac.W3mFrameConstants)[key]);
}
const $5d251b2b36ad3cb7$export$89415e8e09b5a4e0 = (0, $lBSq3.z).object({
    accessList: (0, $lBSq3.z).array((0, $lBSq3.z).string()),
    blockHash: (0, $lBSq3.z).string().nullable(),
    blockNumber: (0, $lBSq3.z).string().nullable(),
    chainId: (0, $lBSq3.z).string().or((0, $lBSq3.z).number()),
    from: (0, $lBSq3.z).string(),
    gas: (0, $lBSq3.z).string(),
    hash: (0, $lBSq3.z).string(),
    input: (0, $lBSq3.z).string().nullable(),
    maxFeePerGas: (0, $lBSq3.z).string(),
    maxPriorityFeePerGas: (0, $lBSq3.z).string(),
    nonce: (0, $lBSq3.z).string(),
    r: (0, $lBSq3.z).string(),
    s: (0, $lBSq3.z).string(),
    to: (0, $lBSq3.z).string(),
    transactionIndex: (0, $lBSq3.z).string().nullable(),
    type: (0, $lBSq3.z).string(),
    v: (0, $lBSq3.z).string(),
    value: (0, $lBSq3.z).string()
});
const $5d251b2b36ad3cb7$export$6f296c19518f2ab2 = (0, $lBSq3.z).object({
    chainId: (0, $lBSq3.z).string().or((0, $lBSq3.z).number())
});
const $5d251b2b36ad3cb7$export$976f191ce42ce5be = (0, $lBSq3.z).object({
    email: (0, $lBSq3.z).string().email()
});
const $5d251b2b36ad3cb7$export$3c60c26d0e7c7485 = (0, $lBSq3.z).object({
    otp: (0, $lBSq3.z).string()
});
const $5d251b2b36ad3cb7$export$b4cf8f9e803c0857 = (0, $lBSq3.z).object({
    uri: (0, $lBSq3.z).string(),
    preferredAccountType: (0, $lBSq3.z).optional((0, $lBSq3.z).string()),
    chainId: (0, $lBSq3.z).optional((0, $lBSq3.z).string().or((0, $lBSq3.z).number()))
});
const $5d251b2b36ad3cb7$export$2b55edadc32e688a = (0, $lBSq3.z).object({
    chainId: (0, $lBSq3.z).optional((0, $lBSq3.z).string().or((0, $lBSq3.z).number())),
    preferredAccountType: (0, $lBSq3.z).optional((0, $lBSq3.z).string()),
    socialUri: (0, $lBSq3.z).optional((0, $lBSq3.z).string())
});
const $5d251b2b36ad3cb7$export$9d16112af534cfa2 = (0, $lBSq3.z).object({
    provider: (0, $lBSq3.z).enum([
        "google",
        "github",
        "apple",
        "facebook",
        "x",
        "discord"
    ])
});
const $5d251b2b36ad3cb7$export$65e6e56482b6df27 = (0, $lBSq3.z).object({
    email: (0, $lBSq3.z).string().email()
});
const $5d251b2b36ad3cb7$export$63ec130352b88085 = (0, $lBSq3.z).object({
    otp: (0, $lBSq3.z).string()
});
const $5d251b2b36ad3cb7$export$cbb50d2392bf53e2 = (0, $lBSq3.z).object({
    otp: (0, $lBSq3.z).string()
});
const $5d251b2b36ad3cb7$export$c523bb85fd166f04 = (0, $lBSq3.z).object({
    themeMode: (0, $lBSq3.z).optional((0, $lBSq3.z).enum([
        "light",
        "dark"
    ])),
    themeVariables: (0, $lBSq3.z).optional((0, $lBSq3.z).record((0, $lBSq3.z).string(), (0, $lBSq3.z).string().or((0, $lBSq3.z).number()))),
    w3mThemeVariables: (0, $lBSq3.z).optional((0, $lBSq3.z).record((0, $lBSq3.z).string(), (0, $lBSq3.z).string()))
});
const $5d251b2b36ad3cb7$export$4ca9ea890e921270 = (0, $lBSq3.z).object({
    metadata: (0, $lBSq3.z).object({
        name: (0, $lBSq3.z).string(),
        description: (0, $lBSq3.z).string(),
        url: (0, $lBSq3.z).string(),
        icons: (0, $lBSq3.z).array((0, $lBSq3.z).string())
    }).optional(),
    sdkVersion: (0, $lBSq3.z).string().optional(),
    sdkType: (0, $lBSq3.z).string().optional(),
    projectId: (0, $lBSq3.z).string()
});
const $5d251b2b36ad3cb7$export$9cebfb60f9fcc35b = (0, $lBSq3.z).object({
    type: (0, $lBSq3.z).string()
});
const $5d251b2b36ad3cb7$export$333a7bf9d10b914 = (0, $lBSq3.z).object({
    action: (0, $lBSq3.z).enum([
        "VERIFY_DEVICE",
        "VERIFY_OTP",
        "CONNECT"
    ])
});
const $5d251b2b36ad3cb7$export$da46d112c20de897 = (0, $lBSq3.z).object({
    url: (0, $lBSq3.z).string()
});
const $5d251b2b36ad3cb7$export$e3d16386f65b39d3 = (0, $lBSq3.z).object({
    userName: (0, $lBSq3.z).string()
});
const $5d251b2b36ad3cb7$export$9f099747f910622d = (0, $lBSq3.z).object({
    email: (0, $lBSq3.z).string().optional().nullable(),
    address: (0, $lBSq3.z).string(),
    chainId: (0, $lBSq3.z).string().or((0, $lBSq3.z).number()),
    accounts: (0, $lBSq3.z).array((0, $lBSq3.z).object({
        address: (0, $lBSq3.z).string(),
        type: (0, $lBSq3.z).enum([
            (0, $034Ac.W3mFrameRpcConstants).ACCOUNT_TYPES.EOA,
            (0, $034Ac.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
        ])
    })).optional(),
    userName: (0, $lBSq3.z).string().optional().nullable(),
    preferredAccountType: (0, $lBSq3.z).optional((0, $lBSq3.z).string())
});
const $5d251b2b36ad3cb7$export$14285ffeae37d072 = (0, $lBSq3.z).object({
    action: (0, $lBSq3.z).enum([
        "VERIFY_PRIMARY_OTP",
        "VERIFY_SECONDARY_OTP"
    ])
});
const $5d251b2b36ad3cb7$export$2d6662dda0084b61 = (0, $lBSq3.z).object({
    email: (0, $lBSq3.z).string().email().optional().nullable(),
    address: (0, $lBSq3.z).string(),
    chainId: (0, $lBSq3.z).string().or((0, $lBSq3.z).number()),
    smartAccountDeployed: (0, $lBSq3.z).optional((0, $lBSq3.z).boolean()),
    accounts: (0, $lBSq3.z).array((0, $lBSq3.z).object({
        address: (0, $lBSq3.z).string(),
        type: (0, $lBSq3.z).enum([
            (0, $034Ac.W3mFrameRpcConstants).ACCOUNT_TYPES.EOA,
            (0, $034Ac.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
        ])
    })).optional(),
    preferredAccountType: (0, $lBSq3.z).optional((0, $lBSq3.z).string())
});
const $5d251b2b36ad3cb7$export$37bc618e26a3f46 = (0, $lBSq3.z).object({
    uri: (0, $lBSq3.z).string()
});
const $5d251b2b36ad3cb7$export$775a450ce21f8fdf = (0, $lBSq3.z).object({
    isConnected: (0, $lBSq3.z).boolean()
});
const $5d251b2b36ad3cb7$export$245abc04f43df573 = (0, $lBSq3.z).object({
    chainId: (0, $lBSq3.z).string().or((0, $lBSq3.z).number())
});
const $5d251b2b36ad3cb7$export$178941fe9bfa6200 = (0, $lBSq3.z).object({
    chainId: (0, $lBSq3.z).string().or((0, $lBSq3.z).number())
});
const $5d251b2b36ad3cb7$export$d31a2d4d5f5aa2cd = (0, $lBSq3.z).object({
    newEmail: (0, $lBSq3.z).string().email()
});
const $5d251b2b36ad3cb7$export$31b27be58286b84c = (0, $lBSq3.z).object({
    smartAccountEnabledNetworks: (0, $lBSq3.z).array((0, $lBSq3.z).number())
});
const $5d251b2b36ad3cb7$export$b8e958c03766c98e = (0, $lBSq3.z).object({
    address: (0, $lBSq3.z).string(),
    isDeployed: (0, $lBSq3.z).boolean()
});
const $5d251b2b36ad3cb7$export$cf84e75f220f5121 = (0, $lBSq3.z).object({
    version: (0, $lBSq3.z).string().optional()
});
const $5d251b2b36ad3cb7$export$258085d3b41c15d5 = (0, $lBSq3.z).object({
    type: (0, $lBSq3.z).string(),
    address: (0, $lBSq3.z).string()
});
const $5d251b2b36ad3cb7$export$d4ce1c0118069cf6 = (0, $lBSq3.z).any();
const $5d251b2b36ad3cb7$export$333c606c26a06359 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_accounts")
});
const $5d251b2b36ad3cb7$export$ed481a6ef87fb1a4 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_blockNumber")
});
const $5d251b2b36ad3cb7$export$3746f30d5256aebc = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_call"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$ced6b8fef5e3a1ae = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_chainId")
});
const $5d251b2b36ad3cb7$export$272161a7d614a7de = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_estimateGas"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$601d25f8f10fb73e = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_feeHistory"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$375f72aea2abe32f = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_gasPrice")
});
const $5d251b2b36ad3cb7$export$5781e194c9800107 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getAccount"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$e8c54d0244516318 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getBalance"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$ed296586d8ca73e5 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getBlockByHash"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$5930d1a65f85cd1c = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getBlockByNumber"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$728754e9b5ce598 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getBlockReceipts"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$4ddab575d344fe47 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getBlockTransactionCountByHash"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$3a9707a1a95b758c = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getBlockTransactionCountByNumber"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$32d3decd99b4e77c = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getCode"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$70385be35bb1c094 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getFilterChanges"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$67adfcd98750c2a4 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getFilterLogs"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$ec85b0f99f3b0860 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getLogs"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$aad1bb370c749036 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getProof"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$de118eb57c7e99ee = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getStorageAt"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$925a4185b30091ca = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getTransactionByBlockHashAndIndex"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$132e327b9ac8100f = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getTransactionByBlockNumberAndIndex"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$b498be03499c3270 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getTransactionByHash"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$8e3ae636de98a13f = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getTransactionCount"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$ebf4091cc6dfa2ef = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getTransactionReceipt"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$a9e565a5951dbda1 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getUncleCountByBlockHash"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$3e72b948c8cdb33b = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_getUncleCountByBlockNumber"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$35da6e194885ea4f = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_maxPriorityFeePerGas")
});
const $5d251b2b36ad3cb7$export$f2d7c90f3596d13e = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_newBlockFilter")
});
const $5d251b2b36ad3cb7$export$f6ccc436669a288e = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_newFilter"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$299d889501e7632c = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_newPendingTransactionFilter")
});
const $5d251b2b36ad3cb7$export$2f01b91caa317491 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_sendRawTransaction"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$688f7a1e4924e71b = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_syncing"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$1cc394e8ef03e09a = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_uninstallFilter"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$57dc995d18380851 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("personal_sign"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$98d6e3ae5e5869d0 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_signTypedData_v4"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$fc4f4bb7f991c8e0 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("eth_sendTransaction"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$d91e2474cd16d70d = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("solana_signMessage"),
    params: (0, $lBSq3.z).object({
        message: (0, $lBSq3.z).string(),
        pubkey: (0, $lBSq3.z).string()
    })
});
const $5d251b2b36ad3cb7$export$11543edd53c7f4cb = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("solana_signTransaction"),
    params: (0, $lBSq3.z).object({
        transaction: (0, $lBSq3.z).string()
    })
});
const $5d251b2b36ad3cb7$export$6befabb65fdc5cc7 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("solana_signAllTransactions"),
    params: (0, $lBSq3.z).object({
        transactions: (0, $lBSq3.z).array((0, $lBSq3.z).string())
    })
});
const $5d251b2b36ad3cb7$export$655852added10635 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("solana_signAndSendTransaction"),
    params: (0, $lBSq3.z).object({
        transaction: (0, $lBSq3.z).string(),
        options: (0, $lBSq3.z).object({
            skipPreflight: (0, $lBSq3.z).boolean().optional(),
            preflightCommitment: (0, $lBSq3.z).enum([
                "processed",
                "confirmed",
                "finalized",
                "recent",
                "single",
                "singleGossip",
                "root",
                "max"
            ]).optional(),
            maxRetries: (0, $lBSq3.z).number().optional(),
            minContextSlot: (0, $lBSq3.z).number().optional()
        }).optional()
    })
});
const $5d251b2b36ad3cb7$export$22abffcfa04dcf81 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("wallet_sendCalls"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).object({
        chainId: (0, $lBSq3.z).string().or((0, $lBSq3.z).number()).optional(),
        from: (0, $lBSq3.z).string().optional(),
        version: (0, $lBSq3.z).string().optional(),
        capabilities: (0, $lBSq3.z).any().optional(),
        calls: (0, $lBSq3.z).array((0, $lBSq3.z).object({
            to: (0, $lBSq3.z).string().startsWith("0x"),
            data: (0, $lBSq3.z).string().startsWith("0x").optional(),
            value: (0, $lBSq3.z).string().optional()
        }))
    }))
});
const $5d251b2b36ad3cb7$export$81a313f8ca8f6f80 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("wallet_getCallsStatus"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).string())
});
const $5d251b2b36ad3cb7$export$193ba0334adb9ab5 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("wallet_getCapabilities")
});
const $5d251b2b36ad3cb7$export$b5e7f5679b9a54bb = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("wallet_grantPermissions"),
    params: (0, $lBSq3.z).array((0, $lBSq3.z).any())
});
const $5d251b2b36ad3cb7$export$43d628d068c00aa2 = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("wallet_revokePermissions"),
    params: (0, $lBSq3.z).any()
});
const $5d251b2b36ad3cb7$export$13218108412fb51c = (0, $lBSq3.z).object({
    method: (0, $lBSq3.z).literal("wallet_getAssets"),
    params: (0, $lBSq3.z).any()
});
const $5d251b2b36ad3cb7$export$583fad842749c757 = (0, $lBSq3.z).object({
    token: (0, $lBSq3.z).string()
});
const $5d251b2b36ad3cb7$export$769a4ec051ed522c = (0, $lBSq3.z).object({
    id: (0, $lBSq3.z).string().optional()
});
const $5d251b2b36ad3cb7$export$238f9986c2bb1b9a = {
    appEvent: $5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_SWITCH_NETWORK"),
        payload: $5d251b2b36ad3cb7$export$6f296c19518f2ab2
    }).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_CONNECT_EMAIL"),
        payload: $5d251b2b36ad3cb7$export$976f191ce42ce5be
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_CONNECT_DEVICE")
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_CONNECT_OTP"),
        payload: $5d251b2b36ad3cb7$export$3c60c26d0e7c7485
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_CONNECT_SOCIAL"),
        payload: $5d251b2b36ad3cb7$export$b4cf8f9e803c0857
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_GET_FARCASTER_URI")
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_CONNECT_FARCASTER")
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_GET_USER"),
        payload: (0, $lBSq3.z).optional($5d251b2b36ad3cb7$export$2b55edadc32e688a)
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_GET_SOCIAL_REDIRECT_URI"),
        payload: $5d251b2b36ad3cb7$export$9d16112af534cfa2
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_SIGN_OUT")
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_IS_CONNECTED"),
        payload: (0, $lBSq3.z).optional($5d251b2b36ad3cb7$export$583fad842749c757)
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_GET_CHAIN_ID")
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_GET_SMART_ACCOUNT_ENABLED_NETWORKS")
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_INIT_SMART_ACCOUNT")
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_SET_PREFERRED_ACCOUNT"),
        payload: $5d251b2b36ad3cb7$export$9cebfb60f9fcc35b
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_RPC_REQUEST"),
        payload: $5d251b2b36ad3cb7$export$57dc995d18380851.or($5d251b2b36ad3cb7$export$13218108412fb51c).or($5d251b2b36ad3cb7$export$333c606c26a06359).or($5d251b2b36ad3cb7$export$ed481a6ef87fb1a4).or($5d251b2b36ad3cb7$export$3746f30d5256aebc).or($5d251b2b36ad3cb7$export$ced6b8fef5e3a1ae).or($5d251b2b36ad3cb7$export$272161a7d614a7de).or($5d251b2b36ad3cb7$export$601d25f8f10fb73e).or($5d251b2b36ad3cb7$export$375f72aea2abe32f).or($5d251b2b36ad3cb7$export$5781e194c9800107).or($5d251b2b36ad3cb7$export$e8c54d0244516318).or($5d251b2b36ad3cb7$export$ed296586d8ca73e5).or($5d251b2b36ad3cb7$export$5930d1a65f85cd1c).or($5d251b2b36ad3cb7$export$728754e9b5ce598).or($5d251b2b36ad3cb7$export$4ddab575d344fe47).or($5d251b2b36ad3cb7$export$3a9707a1a95b758c).or($5d251b2b36ad3cb7$export$32d3decd99b4e77c).or($5d251b2b36ad3cb7$export$70385be35bb1c094).or($5d251b2b36ad3cb7$export$67adfcd98750c2a4).or($5d251b2b36ad3cb7$export$ec85b0f99f3b0860).or($5d251b2b36ad3cb7$export$aad1bb370c749036).or($5d251b2b36ad3cb7$export$de118eb57c7e99ee).or($5d251b2b36ad3cb7$export$925a4185b30091ca).or($5d251b2b36ad3cb7$export$132e327b9ac8100f).or($5d251b2b36ad3cb7$export$b498be03499c3270).or($5d251b2b36ad3cb7$export$8e3ae636de98a13f).or($5d251b2b36ad3cb7$export$ebf4091cc6dfa2ef).or($5d251b2b36ad3cb7$export$a9e565a5951dbda1).or($5d251b2b36ad3cb7$export$3e72b948c8cdb33b).or($5d251b2b36ad3cb7$export$35da6e194885ea4f).or($5d251b2b36ad3cb7$export$f2d7c90f3596d13e).or($5d251b2b36ad3cb7$export$f6ccc436669a288e).or($5d251b2b36ad3cb7$export$299d889501e7632c).or($5d251b2b36ad3cb7$export$2f01b91caa317491).or($5d251b2b36ad3cb7$export$688f7a1e4924e71b).or($5d251b2b36ad3cb7$export$1cc394e8ef03e09a).or($5d251b2b36ad3cb7$export$57dc995d18380851).or($5d251b2b36ad3cb7$export$98d6e3ae5e5869d0).or($5d251b2b36ad3cb7$export$fc4f4bb7f991c8e0).or($5d251b2b36ad3cb7$export$d91e2474cd16d70d).or($5d251b2b36ad3cb7$export$11543edd53c7f4cb).or($5d251b2b36ad3cb7$export$6befabb65fdc5cc7).or($5d251b2b36ad3cb7$export$655852added10635).or($5d251b2b36ad3cb7$export$81a313f8ca8f6f80).or($5d251b2b36ad3cb7$export$22abffcfa04dcf81).or($5d251b2b36ad3cb7$export$193ba0334adb9ab5).or($5d251b2b36ad3cb7$export$b5e7f5679b9a54bb).or($5d251b2b36ad3cb7$export$43d628d068c00aa2)
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_UPDATE_EMAIL"),
        payload: $5d251b2b36ad3cb7$export$65e6e56482b6df27
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_UPDATE_EMAIL_PRIMARY_OTP"),
        payload: $5d251b2b36ad3cb7$export$63ec130352b88085
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_UPDATE_EMAIL_SECONDARY_OTP"),
        payload: $5d251b2b36ad3cb7$export$cbb50d2392bf53e2
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_SYNC_THEME"),
        payload: $5d251b2b36ad3cb7$export$c523bb85fd166f04
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_SYNC_DAPP_DATA"),
        payload: $5d251b2b36ad3cb7$export$4ca9ea890e921270
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("APP_RELOAD")
    })),
    frameEvent: $5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_SWITCH_NETWORK_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    }).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_SWITCH_NETWORK_SUCCESS"),
        payload: $5d251b2b36ad3cb7$export$178941fe9bfa6200
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_CONNECT_EMAIL_SUCCESS"),
        payload: $5d251b2b36ad3cb7$export$333a7bf9d10b914
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_CONNECT_EMAIL_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_GET_FARCASTER_URI_SUCCESS"),
        payload: $5d251b2b36ad3cb7$export$da46d112c20de897
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_GET_FARCASTER_URI_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_CONNECT_FARCASTER_SUCCESS"),
        payload: $5d251b2b36ad3cb7$export$e3d16386f65b39d3
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_CONNECT_FARCASTER_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_CONNECT_OTP_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_CONNECT_OTP_SUCCESS")
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_CONNECT_DEVICE_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_CONNECT_DEVICE_SUCCESS")
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_CONNECT_SOCIAL_SUCCESS"),
        payload: $5d251b2b36ad3cb7$export$9f099747f910622d
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_CONNECT_SOCIAL_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_GET_USER_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_GET_USER_SUCCESS"),
        payload: $5d251b2b36ad3cb7$export$2d6662dda0084b61
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_GET_SOCIAL_REDIRECT_URI_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_GET_SOCIAL_REDIRECT_URI_SUCCESS"),
        payload: $5d251b2b36ad3cb7$export$37bc618e26a3f46
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_SIGN_OUT_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_SIGN_OUT_SUCCESS")
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_IS_CONNECTED_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_IS_CONNECTED_SUCCESS"),
        payload: $5d251b2b36ad3cb7$export$775a450ce21f8fdf
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_GET_CHAIN_ID_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_GET_CHAIN_ID_SUCCESS"),
        payload: $5d251b2b36ad3cb7$export$245abc04f43df573
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_RPC_REQUEST_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_RPC_REQUEST_SUCCESS"),
        payload: $5d251b2b36ad3cb7$export$d4ce1c0118069cf6
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_SESSION_UPDATE"),
        payload: $5d251b2b36ad3cb7$export$583fad842749c757
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_UPDATE_EMAIL_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_UPDATE_EMAIL_SUCCESS"),
        payload: $5d251b2b36ad3cb7$export$14285ffeae37d072
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_UPDATE_EMAIL_PRIMARY_OTP_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_UPDATE_EMAIL_PRIMARY_OTP_SUCCESS")
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_UPDATE_EMAIL_SECONDARY_OTP_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_UPDATE_EMAIL_SECONDARY_OTP_SUCCESS"),
        payload: $5d251b2b36ad3cb7$export$d31a2d4d5f5aa2cd
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_SYNC_THEME_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_SYNC_THEME_SUCCESS")
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_SYNC_DAPP_DATA_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_SYNC_DAPP_DATA_SUCCESS")
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_GET_SMART_ACCOUNT_ENABLED_NETWORKS_SUCCESS"),
        payload: $5d251b2b36ad3cb7$export$31b27be58286b84c
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_GET_SMART_ACCOUNT_ENABLED_NETWORKS_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_INIT_SMART_ACCOUNT_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_SET_PREFERRED_ACCOUNT_SUCCESS"),
        payload: $5d251b2b36ad3cb7$export$258085d3b41c15d5
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_SET_PREFERRED_ACCOUNT_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_READY"),
        payload: $5d251b2b36ad3cb7$export$cf84e75f220f5121
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_RELOAD_ERROR"),
        payload: $5d251b2b36ad3cb7$var$zError
    })).or($5d251b2b36ad3cb7$export$769a4ec051ed522c.extend({
        type: $5d251b2b36ad3cb7$var$zType("FRAME_RELOAD_SUCCESS")
    }))
};

});
parcelRegister("lBSq3", function(module, exports) {

$parcel$export(module.exports, "z", () => $47a411931cd9b30c$export$2e2bcd8739ae039);
var $47a411931cd9b30c$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($47a411931cd9b30c$export$7debb50ef11d5e0b || ($47a411931cd9b30c$export$7debb50ef11d5e0b = {}));
var $47a411931cd9b30c$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($47a411931cd9b30c$export$4aa2142c225fd5c7 || ($47a411931cd9b30c$export$4aa2142c225fd5c7 = {}));
const $47a411931cd9b30c$export$5716da67bfaa244d = $47a411931cd9b30c$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $47a411931cd9b30c$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $47a411931cd9b30c$export$5716da67bfaa244d.undefined;
        case "string":
            return $47a411931cd9b30c$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $47a411931cd9b30c$export$5716da67bfaa244d.nan : $47a411931cd9b30c$export$5716da67bfaa244d.number;
        case "boolean":
            return $47a411931cd9b30c$export$5716da67bfaa244d.boolean;
        case "function":
            return $47a411931cd9b30c$export$5716da67bfaa244d.function;
        case "bigint":
            return $47a411931cd9b30c$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $47a411931cd9b30c$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $47a411931cd9b30c$export$5716da67bfaa244d.array;
            if (data === null) return $47a411931cd9b30c$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $47a411931cd9b30c$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $47a411931cd9b30c$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $47a411931cd9b30c$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $47a411931cd9b30c$export$5716da67bfaa244d.date;
            return $47a411931cd9b30c$export$5716da67bfaa244d.object;
        default:
            return $47a411931cd9b30c$export$5716da67bfaa244d.unknown;
    }
};
const $47a411931cd9b30c$export$5ba560653e4a1035 = $47a411931cd9b30c$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $47a411931cd9b30c$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $47a411931cd9b30c$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $47a411931cd9b30c$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$47a411931cd9b30c$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $47a411931cd9b30c$export$f98dac4b251ab333(issues);
    return error;
};
const $47a411931cd9b30c$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $47a411931cd9b30c$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $47a411931cd9b30c$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $47a411931cd9b30c$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $47a411931cd9b30c$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$47a411931cd9b30c$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $47a411931cd9b30c$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $47a411931cd9b30c$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$47a411931cd9b30c$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $47a411931cd9b30c$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$47a411931cd9b30c$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $47a411931cd9b30c$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $47a411931cd9b30c$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $47a411931cd9b30c$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $47a411931cd9b30c$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $47a411931cd9b30c$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $47a411931cd9b30c$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $47a411931cd9b30c$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $47a411931cd9b30c$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $47a411931cd9b30c$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $47a411931cd9b30c$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $47a411931cd9b30c$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $47a411931cd9b30c$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $47a411931cd9b30c$var$overrideErrorMap = $47a411931cd9b30c$export$341b0b6e0a6f5099;
function $47a411931cd9b30c$export$1097a8289cfd22d7(map) {
    $47a411931cd9b30c$var$overrideErrorMap = map;
}
function $47a411931cd9b30c$export$32f27c719778d4c4() {
    return $47a411931cd9b30c$var$overrideErrorMap;
}
const $47a411931cd9b30c$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage
    };
};
const $47a411931cd9b30c$export$1526d2e05f74572 = [];
function $47a411931cd9b30c$export$db7caee60e5d514d(ctx, issueData) {
    const issue = $47a411931cd9b30c$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            $47a411931cd9b30c$export$32f27c719778d4c4(),
            $47a411931cd9b30c$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $47a411931cd9b30c$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $47a411931cd9b30c$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs)syncPairs.push({
            key: await pair.key,
            value: await pair.value
        });
        return $47a411931cd9b30c$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $47a411931cd9b30c$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $47a411931cd9b30c$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $47a411931cd9b30c$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $47a411931cd9b30c$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $47a411931cd9b30c$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $47a411931cd9b30c$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $47a411931cd9b30c$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $47a411931cd9b30c$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $47a411931cd9b30c$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
var $47a411931cd9b30c$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($47a411931cd9b30c$var$errorUtil || ($47a411931cd9b30c$var$errorUtil = {}));
class $47a411931cd9b30c$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $47a411931cd9b30c$var$handleResult = (ctx, result)=>{
    if ($47a411931cd9b30c$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $47a411931cd9b30c$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $47a411931cd9b30c$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $47a411931cd9b30c$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $47a411931cd9b30c$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $47a411931cd9b30c$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $47a411931cd9b30c$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $47a411931cd9b30c$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($47a411931cd9b30c$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $47a411931cd9b30c$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $47a411931cd9b30c$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $47a411931cd9b30c$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($47a411931cd9b30c$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $47a411931cd9b30c$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $47a411931cd9b30c$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $47a411931cd9b30c$export$a60af00cc0ce2582({
            schema: this,
            typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $47a411931cd9b30c$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $47a411931cd9b30c$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $47a411931cd9b30c$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $47a411931cd9b30c$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $47a411931cd9b30c$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $47a411931cd9b30c$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $47a411931cd9b30c$export$a60af00cc0ce2582({
            ...$47a411931cd9b30c$var$processCreateParams(this._def),
            schema: this,
            typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $47a411931cd9b30c$export$bb19b37874861e7e({
            ...$47a411931cd9b30c$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $47a411931cd9b30c$export$66b0c798a395271f({
            typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$47a411931cd9b30c$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $47a411931cd9b30c$export$75a44ec6249ac76b({
            ...$47a411931cd9b30c$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $47a411931cd9b30c$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $47a411931cd9b30c$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $47a411931cd9b30c$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $47a411931cd9b30c$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
const $47a411931cd9b30c$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $47a411931cd9b30c$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $47a411931cd9b30c$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $47a411931cd9b30c$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $47a411931cd9b30c$var$emojiRegex;
const $47a411931cd9b30c$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const $47a411931cd9b30c$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const $47a411931cd9b30c$var$datetimeRegex = (args)=>{
    if (args.precision) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    } else {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
};
function $47a411931cd9b30c$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $47a411931cd9b30c$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $47a411931cd9b30c$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $47a411931cd9b30c$export$1230eb29b8d3b502 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                expected: $47a411931cd9b30c$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        const status = new $47a411931cd9b30c$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$47a411931cd9b30c$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$47a411931cd9b30c$var$emojiRegex) $47a411931cd9b30c$var$emojiRegex = new RegExp($47a411931cd9b30c$var$_emojiRegex, "u");
                if (!$47a411931cd9b30c$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$47a411931cd9b30c$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$47a411931cd9b30c$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$47a411931cd9b30c$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$47a411931cd9b30c$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $47a411931cd9b30c$var$datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$47a411931cd9b30c$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $47a411931cd9b30c$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_string,
            ...$47a411931cd9b30c$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $47a411931cd9b30c$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$47a411931cd9b30c$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$47a411931cd9b30c$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$47a411931cd9b30c$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$47a411931cd9b30c$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$47a411931cd9b30c$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$47a411931cd9b30c$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$47a411931cd9b30c$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$47a411931cd9b30c$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...$47a411931cd9b30c$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$47a411931cd9b30c$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$47a411931cd9b30c$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$47a411931cd9b30c$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$47a411931cd9b30c$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$47a411931cd9b30c$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$47a411931cd9b30c$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$47a411931cd9b30c$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $47a411931cd9b30c$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $47a411931cd9b30c$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $47a411931cd9b30c$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $47a411931cd9b30c$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$47a411931cd9b30c$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $47a411931cd9b30c$export$1230eb29b8d3b502({
        checks: [],
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $47a411931cd9b30c$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $47a411931cd9b30c$export$5b070a55c0c43e09 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                expected: $47a411931cd9b30c$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $47a411931cd9b30c$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$47a411931cd9b30c$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($47a411931cd9b30c$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $47a411931cd9b30c$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $47a411931cd9b30c$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $47a411931cd9b30c$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $47a411931cd9b30c$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $47a411931cd9b30c$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $47a411931cd9b30c$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $47a411931cd9b30c$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $47a411931cd9b30c$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $47a411931cd9b30c$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $47a411931cd9b30c$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $47a411931cd9b30c$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $47a411931cd9b30c$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $47a411931cd9b30c$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $47a411931cd9b30c$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $47a411931cd9b30c$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $47a411931cd9b30c$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $47a411931cd9b30c$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $47a411931cd9b30c$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$47a411931cd9b30c$export$5b070a55c0c43e09.create = (params)=>{
    return new $47a411931cd9b30c$export$5b070a55c0c43e09({
        checks: [],
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$67d741fd70ff98f4 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                expected: $47a411931cd9b30c$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $47a411931cd9b30c$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $47a411931cd9b30c$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $47a411931cd9b30c$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $47a411931cd9b30c$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $47a411931cd9b30c$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $47a411931cd9b30c$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $47a411931cd9b30c$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $47a411931cd9b30c$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $47a411931cd9b30c$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $47a411931cd9b30c$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $47a411931cd9b30c$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $47a411931cd9b30c$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $47a411931cd9b30c$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $47a411931cd9b30c$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$47a411931cd9b30c$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $47a411931cd9b30c$export$67d741fd70ff98f4({
        checks: [],
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$723d146f80596191 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                expected: $47a411931cd9b30c$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        return $47a411931cd9b30c$export$c6813a8d51f77eaf(input.data);
    }
}
$47a411931cd9b30c$export$723d146f80596191.create = (params)=>{
    return new $47a411931cd9b30c$export$723d146f80596191({
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$e974be33bdc55521 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                expected: $47a411931cd9b30c$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_date
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        const status = new $47a411931cd9b30c$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $47a411931cd9b30c$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $47a411931cd9b30c$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $47a411931cd9b30c$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $47a411931cd9b30c$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$47a411931cd9b30c$export$e974be33bdc55521.create = (params)=>{
    return new $47a411931cd9b30c$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodDate,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$bcc3b40f6b638044 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                expected: $47a411931cd9b30c$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        return $47a411931cd9b30c$export$c6813a8d51f77eaf(input.data);
    }
}
$47a411931cd9b30c$export$bcc3b40f6b638044.create = (params)=>{
    return new $47a411931cd9b30c$export$bcc3b40f6b638044({
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodSymbol,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$4e780e961c30340d extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                expected: $47a411931cd9b30c$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        return $47a411931cd9b30c$export$c6813a8d51f77eaf(input.data);
    }
}
$47a411931cd9b30c$export$4e780e961c30340d.create = (params)=>{
    return new $47a411931cd9b30c$export$4e780e961c30340d({
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodUndefined,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$a96281f914484f2d extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                expected: $47a411931cd9b30c$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        return $47a411931cd9b30c$export$c6813a8d51f77eaf(input.data);
    }
}
$47a411931cd9b30c$export$a96281f914484f2d.create = (params)=>{
    return new $47a411931cd9b30c$export$a96281f914484f2d({
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodNull,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$b9d1edb536b4e4eb extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $47a411931cd9b30c$export$c6813a8d51f77eaf(input.data);
    }
}
$47a411931cd9b30c$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $47a411931cd9b30c$export$b9d1edb536b4e4eb({
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodAny,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$ef3b1bb1630977ae extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $47a411931cd9b30c$export$c6813a8d51f77eaf(input.data);
    }
}
$47a411931cd9b30c$export$ef3b1bb1630977ae.create = (params)=>{
    return new $47a411931cd9b30c$export$ef3b1bb1630977ae({
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodUnknown,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$1e576a20c3ce9fb5 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
            code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
            expected: $47a411931cd9b30c$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $47a411931cd9b30c$export$9a105a556e65c2c0;
    }
}
$47a411931cd9b30c$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $47a411931cd9b30c$export$1e576a20c3ce9fb5({
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodNever,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$7d39f5df85f21031 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                expected: $47a411931cd9b30c$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        return $47a411931cd9b30c$export$c6813a8d51f77eaf(input.data);
    }
}
$47a411931cd9b30c$export$7d39f5df85f21031.create = (params)=>{
    return new $47a411931cd9b30c$export$7d39f5df85f21031({
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodVoid,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$7acfc3e64785411 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.array) {
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                expected: $47a411931cd9b30c$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $47a411931cd9b30c$export$5ba560653e4a1035.too_big : $47a411931cd9b30c$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                    code: $47a411931cd9b30c$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                    code: $47a411931cd9b30c$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $47a411931cd9b30c$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $47a411931cd9b30c$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $47a411931cd9b30c$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $47a411931cd9b30c$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $47a411931cd9b30c$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $47a411931cd9b30c$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $47a411931cd9b30c$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $47a411931cd9b30c$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $47a411931cd9b30c$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $47a411931cd9b30c$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$47a411931cd9b30c$export$7acfc3e64785411.create = (schema, params)=>{
    return new $47a411931cd9b30c$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodArray,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
function $47a411931cd9b30c$var$deepPartialify(schema) {
    if (schema instanceof $47a411931cd9b30c$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $47a411931cd9b30c$export$aa56fec1e9d629b8.create($47a411931cd9b30c$var$deepPartialify(fieldSchema));
        }
        return new $47a411931cd9b30c$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $47a411931cd9b30c$export$7acfc3e64785411) return new $47a411931cd9b30c$export$7acfc3e64785411({
        ...schema._def,
        type: $47a411931cd9b30c$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $47a411931cd9b30c$export$aa56fec1e9d629b8) return $47a411931cd9b30c$export$aa56fec1e9d629b8.create($47a411931cd9b30c$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $47a411931cd9b30c$export$aaac0b8b429cef5) return $47a411931cd9b30c$export$aaac0b8b429cef5.create($47a411931cd9b30c$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $47a411931cd9b30c$export$e2a18bb771d8e6a3) return $47a411931cd9b30c$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$47a411931cd9b30c$var$deepPartialify(item)));
    else return schema;
}
class $47a411931cd9b30c$export$736315c5b55efbad extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $47a411931cd9b30c$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                expected: $47a411931cd9b30c$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $47a411931cd9b30c$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $47a411931cd9b30c$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $47a411931cd9b30c$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                        code: $47a411931cd9b30c$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $47a411931cd9b30c$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                syncPairs.push({
                    key: key,
                    value: await pair.value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $47a411931cd9b30c$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $47a411931cd9b30c$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $47a411931cd9b30c$var$errorUtil.errToObj;
        return new $47a411931cd9b30c$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $47a411931cd9b30c$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $47a411931cd9b30c$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $47a411931cd9b30c$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $47a411931cd9b30c$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $47a411931cd9b30c$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $47a411931cd9b30c$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $47a411931cd9b30c$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $47a411931cd9b30c$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $47a411931cd9b30c$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $47a411931cd9b30c$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $47a411931cd9b30c$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $47a411931cd9b30c$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $47a411931cd9b30c$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $47a411931cd9b30c$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $47a411931cd9b30c$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $47a411931cd9b30c$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $47a411931cd9b30c$var$createZodEnum($47a411931cd9b30c$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$47a411931cd9b30c$export$736315c5b55efbad.create = (shape, params)=>{
    return new $47a411931cd9b30c$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $47a411931cd9b30c$export$1e576a20c3ce9fb5.create(),
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodObject,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
$47a411931cd9b30c$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $47a411931cd9b30c$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $47a411931cd9b30c$export$1e576a20c3ce9fb5.create(),
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodObject,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
$47a411931cd9b30c$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $47a411931cd9b30c$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $47a411931cd9b30c$export$1e576a20c3ce9fb5.create(),
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodObject,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$a8b236cb5070a311 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $47a411931cd9b30c$export$f98dac4b251ab333(result.ctx.common.issues));
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $47a411931cd9b30c$export$f98dac4b251ab333(issues));
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$47a411931cd9b30c$export$a8b236cb5070a311.create = (types, params)=>{
    return new $47a411931cd9b30c$export$a8b236cb5070a311({
        options: types,
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodUnion,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $47a411931cd9b30c$var$getDiscriminator = (type)=>{
    if (type instanceof $47a411931cd9b30c$export$378d0cfce37406e6) return $47a411931cd9b30c$var$getDiscriminator(type.schema);
    else if (type instanceof $47a411931cd9b30c$export$a60af00cc0ce2582) return $47a411931cd9b30c$var$getDiscriminator(type.innerType());
    else if (type instanceof $47a411931cd9b30c$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $47a411931cd9b30c$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $47a411931cd9b30c$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $47a411931cd9b30c$export$bb19b37874861e7e) return $47a411931cd9b30c$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $47a411931cd9b30c$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $47a411931cd9b30c$export$a96281f914484f2d) return [
        null
    ];
    else return null;
};
class $47a411931cd9b30c$export$5ef2424805ac76a3 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.object) {
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                expected: $47a411931cd9b30c$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $47a411931cd9b30c$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $47a411931cd9b30c$export$5ef2424805ac76a3({
            typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$47a411931cd9b30c$var$processCreateParams(params)
        });
    }
}
function $47a411931cd9b30c$var$mergeValues(a, b) {
    const aType = $47a411931cd9b30c$export$3e9057828ebd5c7a(a);
    const bType = $47a411931cd9b30c$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $47a411931cd9b30c$export$5716da67bfaa244d.object && bType === $47a411931cd9b30c$export$5716da67bfaa244d.object) {
        const bKeys = $47a411931cd9b30c$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $47a411931cd9b30c$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $47a411931cd9b30c$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $47a411931cd9b30c$export$5716da67bfaa244d.array && bType === $47a411931cd9b30c$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $47a411931cd9b30c$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $47a411931cd9b30c$export$5716da67bfaa244d.date && bType === $47a411931cd9b30c$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $47a411931cd9b30c$export$c02deaf0bb5203d4 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($47a411931cd9b30c$export$afa861e3c5730743(parsedLeft) || $47a411931cd9b30c$export$afa861e3c5730743(parsedRight)) return $47a411931cd9b30c$export$9a105a556e65c2c0;
            const merged = $47a411931cd9b30c$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                    code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $47a411931cd9b30c$export$9a105a556e65c2c0;
            }
            if ($47a411931cd9b30c$export$910b6cdd390341b3(parsedLeft) || $47a411931cd9b30c$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$47a411931cd9b30c$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $47a411931cd9b30c$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodIntersection,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$e2a18bb771d8e6a3 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.array) {
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                expected: $47a411931cd9b30c$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $47a411931cd9b30c$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $47a411931cd9b30c$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $47a411931cd9b30c$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $47a411931cd9b30c$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$47a411931cd9b30c$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $47a411931cd9b30c$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$a2acc09968cb4b7f extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.object) {
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                expected: $47a411931cd9b30c$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $47a411931cd9b30c$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $47a411931cd9b30c$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
        if (ctx.common.async) return $47a411931cd9b30c$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $47a411931cd9b30c$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $47a411931cd9b30c$export$19342e026b58ebb7) return new $47a411931cd9b30c$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodRecord,
            ...$47a411931cd9b30c$var$processCreateParams(third)
        });
        return new $47a411931cd9b30c$export$a2acc09968cb4b7f({
            keyType: $47a411931cd9b30c$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodRecord,
            ...$47a411931cd9b30c$var$processCreateParams(second)
        });
    }
}
class $47a411931cd9b30c$export$163b6a2b712d9542 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.map) {
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                expected: $47a411931cd9b30c$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $47a411931cd9b30c$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $47a411931cd9b30c$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $47a411931cd9b30c$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $47a411931cd9b30c$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$47a411931cd9b30c$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $47a411931cd9b30c$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodMap,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$977057706f816712 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.set) {
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                expected: $47a411931cd9b30c$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                    code: $47a411931cd9b30c$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                    code: $47a411931cd9b30c$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $47a411931cd9b30c$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $47a411931cd9b30c$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $47a411931cd9b30c$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $47a411931cd9b30c$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $47a411931cd9b30c$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $47a411931cd9b30c$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$47a411931cd9b30c$export$977057706f816712.create = (valueType, params)=>{
    return new $47a411931cd9b30c$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodSet,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$d4602ba55673f53c extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.function) {
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                expected: $47a411931cd9b30c$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $47a411931cd9b30c$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $47a411931cd9b30c$export$32f27c719778d4c4(),
                    $47a411931cd9b30c$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $47a411931cd9b30c$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $47a411931cd9b30c$export$32f27c719778d4c4(),
                    $47a411931cd9b30c$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $47a411931cd9b30c$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $47a411931cd9b30c$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $47a411931cd9b30c$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $47a411931cd9b30c$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $47a411931cd9b30c$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $47a411931cd9b30c$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $47a411931cd9b30c$export$d4602ba55673f53c({
            ...this._def,
            args: $47a411931cd9b30c$export$e2a18bb771d8e6a3.create(items).rest($47a411931cd9b30c$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $47a411931cd9b30c$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $47a411931cd9b30c$export$d4602ba55673f53c({
            args: args ? args : $47a411931cd9b30c$export$e2a18bb771d8e6a3.create([]).rest($47a411931cd9b30c$export$ef3b1bb1630977ae.create()),
            returns: returns || $47a411931cd9b30c$export$ef3b1bb1630977ae.create(),
            typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodFunction,
            ...$47a411931cd9b30c$var$processCreateParams(params)
        });
    }
}
class $47a411931cd9b30c$export$378d0cfce37406e6 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$47a411931cd9b30c$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $47a411931cd9b30c$export$378d0cfce37406e6({
        getter: getter,
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodLazy,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$7e44096782a165d3 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$47a411931cd9b30c$export$7e44096782a165d3.create = (value, params)=>{
    return new $47a411931cd9b30c$export$7e44096782a165d3({
        value: value,
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodLiteral,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
function $47a411931cd9b30c$var$createZodEnum(values, params) {
    return new $47a411931cd9b30c$export$d325d1f0e1c20179({
        values: values,
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodEnum,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
}
class $47a411931cd9b30c$export$d325d1f0e1c20179 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                expected: $47a411931cd9b30c$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        return $47a411931cd9b30c$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values) {
        return $47a411931cd9b30c$export$d325d1f0e1c20179.create(values);
    }
    exclude(values) {
        return $47a411931cd9b30c$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)));
    }
}
$47a411931cd9b30c$export$d325d1f0e1c20179.create = $47a411931cd9b30c$var$createZodEnum;
class $47a411931cd9b30c$export$370b2e8d6d6f5c56 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $47a411931cd9b30c$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.string && ctx.parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.number) {
            const expectedValues = $47a411931cd9b30c$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                expected: $47a411931cd9b30c$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = $47a411931cd9b30c$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        return $47a411931cd9b30c$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$47a411931cd9b30c$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $47a411931cd9b30c$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodNativeEnum,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$3f196b0127d6e50a extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                expected: $47a411931cd9b30c$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $47a411931cd9b30c$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $47a411931cd9b30c$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$47a411931cd9b30c$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $47a411931cd9b30c$export$3f196b0127d6e50a({
        type: schema,
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodPromise,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$a60af00cc0ce2582 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $47a411931cd9b30c$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $47a411931cd9b30c$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) return {
                status: "dirty",
                value: ctx.data
            };
            if (ctx.common.async) return Promise.resolve(processed).then((processed)=>{
                return this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
            });
            else return this._def.schema._parseSync({
                data: processed,
                path: ctx.path,
                parent: ctx
            });
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $47a411931cd9b30c$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $47a411931cd9b30c$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$47a411931cd9b30c$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$47a411931cd9b30c$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $47a411931cd9b30c$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$47a411931cd9b30c$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $47a411931cd9b30c$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
$47a411931cd9b30c$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $47a411931cd9b30c$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodEffects,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$aa56fec1e9d629b8 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $47a411931cd9b30c$export$5716da67bfaa244d.undefined) return $47a411931cd9b30c$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$47a411931cd9b30c$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $47a411931cd9b30c$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodOptional,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$aaac0b8b429cef5 extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $47a411931cd9b30c$export$5716da67bfaa244d.null) return $47a411931cd9b30c$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$47a411931cd9b30c$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $47a411931cd9b30c$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodNullable,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$bb19b37874861e7e extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $47a411931cd9b30c$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$47a411931cd9b30c$export$bb19b37874861e7e.create = (type, params)=>{
    return new $47a411931cd9b30c$export$bb19b37874861e7e({
        innerType: type,
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$75a44ec6249ac76b extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($47a411931cd9b30c$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $47a411931cd9b30c$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $47a411931cd9b30c$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$47a411931cd9b30c$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $47a411931cd9b30c$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
class $47a411931cd9b30c$export$26ccfa0145e8511f extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $47a411931cd9b30c$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $47a411931cd9b30c$export$db7caee60e5d514d(ctx, {
                code: $47a411931cd9b30c$export$5ba560653e4a1035.invalid_type,
                expected: $47a411931cd9b30c$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $47a411931cd9b30c$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$47a411931cd9b30c$export$26ccfa0145e8511f.create = (params)=>{
    return new $47a411931cd9b30c$export$26ccfa0145e8511f({
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodNaN,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
const $47a411931cd9b30c$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $47a411931cd9b30c$export$66b0c798a395271f extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $47a411931cd9b30c$export$a3c3ef8a0e95c6da extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $47a411931cd9b30c$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $47a411931cd9b30c$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $47a411931cd9b30c$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $47a411931cd9b30c$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $47a411931cd9b30c$export$5d1f7ef05c4e493a extends $47a411931cd9b30c$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if ($47a411931cd9b30c$export$1ea939691cdc45b8(result)) result.value = Object.freeze(result.value);
        return result;
    }
}
$47a411931cd9b30c$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $47a411931cd9b30c$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $47a411931cd9b30c$export$558106ce543bd011.ZodReadonly,
        ...$47a411931cd9b30c$var$processCreateParams(params)
    });
};
const $47a411931cd9b30c$export$4c00f665f0d4b443 = (check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal)=>{
    if (check) return $47a411931cd9b30c$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $47a411931cd9b30c$export$b9d1edb536b4e4eb.create();
};
const $47a411931cd9b30c$export$1ee8ee30835eab8b = {
    object: $47a411931cd9b30c$export$736315c5b55efbad.lazycreate
};
var $47a411931cd9b30c$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($47a411931cd9b30c$export$558106ce543bd011 || ($47a411931cd9b30c$export$558106ce543bd011 = {}));
const $47a411931cd9b30c$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$47a411931cd9b30c$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $47a411931cd9b30c$export$22b082955e083ec3 = $47a411931cd9b30c$export$1230eb29b8d3b502.create;
const $47a411931cd9b30c$export$98e628dec113755e = $47a411931cd9b30c$export$5b070a55c0c43e09.create;
const $47a411931cd9b30c$export$9e06de0973666692 = $47a411931cd9b30c$export$26ccfa0145e8511f.create;
const $47a411931cd9b30c$export$a0f65b52274bcc00 = $47a411931cd9b30c$export$67d741fd70ff98f4.create;
const $47a411931cd9b30c$export$4a21f16c33752377 = $47a411931cd9b30c$export$723d146f80596191.create;
const $47a411931cd9b30c$export$324d90190a8b822a = $47a411931cd9b30c$export$e974be33bdc55521.create;
const $47a411931cd9b30c$export$8f701197936bc2a6 = $47a411931cd9b30c$export$bcc3b40f6b638044.create;
const $47a411931cd9b30c$export$1db45310990710a5 = $47a411931cd9b30c$export$4e780e961c30340d.create;
const $47a411931cd9b30c$export$7b1b591b262c240 = $47a411931cd9b30c$export$a96281f914484f2d.create;
const $47a411931cd9b30c$export$4154a199d7d90455 = $47a411931cd9b30c$export$b9d1edb536b4e4eb.create;
const $47a411931cd9b30c$export$19282c40b967aec6 = $47a411931cd9b30c$export$ef3b1bb1630977ae.create;
const $47a411931cd9b30c$export$b3e22bcfd64c1022 = $47a411931cd9b30c$export$1e576a20c3ce9fb5.create;
const $47a411931cd9b30c$export$490e536ee7389aeb = $47a411931cd9b30c$export$7d39f5df85f21031.create;
const $47a411931cd9b30c$export$2f23118c22fb2630 = $47a411931cd9b30c$export$7acfc3e64785411.create;
const $47a411931cd9b30c$export$be5493f9613cbbe = $47a411931cd9b30c$export$736315c5b55efbad.create;
const $47a411931cd9b30c$export$8fb0df5f40d0b477 = $47a411931cd9b30c$export$736315c5b55efbad.strictCreate;
const $47a411931cd9b30c$export$971dd5b0dfd021b6 = $47a411931cd9b30c$export$a8b236cb5070a311.create;
const $47a411931cd9b30c$export$4b888e40c4ee26dd = $47a411931cd9b30c$export$5ef2424805ac76a3.create;
const $47a411931cd9b30c$export$bc86dfbf7795668c = $47a411931cd9b30c$export$c02deaf0bb5203d4.create;
const $47a411931cd9b30c$export$65e3907585753458 = $47a411931cd9b30c$export$e2a18bb771d8e6a3.create;
const $47a411931cd9b30c$export$e5185e241753e543 = $47a411931cd9b30c$export$a2acc09968cb4b7f.create;
const $47a411931cd9b30c$export$871de8747c9eaa88 = $47a411931cd9b30c$export$163b6a2b712d9542.create;
const $47a411931cd9b30c$export$adaa4cf7ef1b65be = $47a411931cd9b30c$export$977057706f816712.create;
const $47a411931cd9b30c$export$44e51c8aac7c2deb = $47a411931cd9b30c$export$d4602ba55673f53c.create;
const $47a411931cd9b30c$export$488013bae63b21da = $47a411931cd9b30c$export$378d0cfce37406e6.create;
const $47a411931cd9b30c$export$c8ec6e1ec9fefcb0 = $47a411931cd9b30c$export$7e44096782a165d3.create;
const $47a411931cd9b30c$export$78a99c8d44d72635 = $47a411931cd9b30c$export$d325d1f0e1c20179.create;
const $47a411931cd9b30c$export$6fe7eca19ebe5199 = $47a411931cd9b30c$export$370b2e8d6d6f5c56.create;
const $47a411931cd9b30c$export$c957ef27a0ebfd4 = $47a411931cd9b30c$export$3f196b0127d6e50a.create;
const $47a411931cd9b30c$export$dc573d8a6576cdb3 = $47a411931cd9b30c$export$a60af00cc0ce2582.create;
const $47a411931cd9b30c$export$516e28dec6a4b6d4 = $47a411931cd9b30c$export$aa56fec1e9d629b8.create;
const $47a411931cd9b30c$export$133fc36489ac9add = $47a411931cd9b30c$export$aaac0b8b429cef5.create;
const $47a411931cd9b30c$export$fc37fe19dfda43ee = $47a411931cd9b30c$export$a60af00cc0ce2582.createWithPreprocess;
const $47a411931cd9b30c$export$43f28b24e1eb8181 = $47a411931cd9b30c$export$a3c3ef8a0e95c6da.create;
const $47a411931cd9b30c$export$3b3d07727c5b702c = ()=>$47a411931cd9b30c$export$22b082955e083ec3().optional();
const $47a411931cd9b30c$export$eb150471a61fced6 = ()=>$47a411931cd9b30c$export$98e628dec113755e().optional();
const $47a411931cd9b30c$export$269251733cdcbbf1 = ()=>$47a411931cd9b30c$export$4a21f16c33752377().optional();
const $47a411931cd9b30c$export$8c14e57e778d3873 = {
    string: (arg)=>$47a411931cd9b30c$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$47a411931cd9b30c$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$47a411931cd9b30c$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$47a411931cd9b30c$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$47a411931cd9b30c$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $47a411931cd9b30c$export$96c94437c95d7862 = $47a411931cd9b30c$export$9a105a556e65c2c0;
var $47a411931cd9b30c$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $47a411931cd9b30c$export$341b0b6e0a6f5099,
    setErrorMap: $47a411931cd9b30c$export$1097a8289cfd22d7,
    getErrorMap: $47a411931cd9b30c$export$32f27c719778d4c4,
    makeIssue: $47a411931cd9b30c$export$244a85fde9c419ed,
    EMPTY_PATH: $47a411931cd9b30c$export$1526d2e05f74572,
    addIssueToContext: $47a411931cd9b30c$export$db7caee60e5d514d,
    ParseStatus: $47a411931cd9b30c$export$5b20a5c3d05c1f6f,
    INVALID: $47a411931cd9b30c$export$9a105a556e65c2c0,
    DIRTY: $47a411931cd9b30c$export$325a211da9693fcf,
    OK: $47a411931cd9b30c$export$c6813a8d51f77eaf,
    isAborted: $47a411931cd9b30c$export$afa861e3c5730743,
    isDirty: $47a411931cd9b30c$export$910b6cdd390341b3,
    isValid: $47a411931cd9b30c$export$1ea939691cdc45b8,
    isAsync: $47a411931cd9b30c$export$aefee5ebe1dcfd9e,
    get util () {
        return $47a411931cd9b30c$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $47a411931cd9b30c$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $47a411931cd9b30c$export$5716da67bfaa244d,
    getParsedType: $47a411931cd9b30c$export$3e9057828ebd5c7a,
    ZodType: $47a411931cd9b30c$export$19342e026b58ebb7,
    ZodString: $47a411931cd9b30c$export$1230eb29b8d3b502,
    ZodNumber: $47a411931cd9b30c$export$5b070a55c0c43e09,
    ZodBigInt: $47a411931cd9b30c$export$67d741fd70ff98f4,
    ZodBoolean: $47a411931cd9b30c$export$723d146f80596191,
    ZodDate: $47a411931cd9b30c$export$e974be33bdc55521,
    ZodSymbol: $47a411931cd9b30c$export$bcc3b40f6b638044,
    ZodUndefined: $47a411931cd9b30c$export$4e780e961c30340d,
    ZodNull: $47a411931cd9b30c$export$a96281f914484f2d,
    ZodAny: $47a411931cd9b30c$export$b9d1edb536b4e4eb,
    ZodUnknown: $47a411931cd9b30c$export$ef3b1bb1630977ae,
    ZodNever: $47a411931cd9b30c$export$1e576a20c3ce9fb5,
    ZodVoid: $47a411931cd9b30c$export$7d39f5df85f21031,
    ZodArray: $47a411931cd9b30c$export$7acfc3e64785411,
    ZodObject: $47a411931cd9b30c$export$736315c5b55efbad,
    ZodUnion: $47a411931cd9b30c$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $47a411931cd9b30c$export$5ef2424805ac76a3,
    ZodIntersection: $47a411931cd9b30c$export$c02deaf0bb5203d4,
    ZodTuple: $47a411931cd9b30c$export$e2a18bb771d8e6a3,
    ZodRecord: $47a411931cd9b30c$export$a2acc09968cb4b7f,
    ZodMap: $47a411931cd9b30c$export$163b6a2b712d9542,
    ZodSet: $47a411931cd9b30c$export$977057706f816712,
    ZodFunction: $47a411931cd9b30c$export$d4602ba55673f53c,
    ZodLazy: $47a411931cd9b30c$export$378d0cfce37406e6,
    ZodLiteral: $47a411931cd9b30c$export$7e44096782a165d3,
    ZodEnum: $47a411931cd9b30c$export$d325d1f0e1c20179,
    ZodNativeEnum: $47a411931cd9b30c$export$370b2e8d6d6f5c56,
    ZodPromise: $47a411931cd9b30c$export$3f196b0127d6e50a,
    ZodEffects: $47a411931cd9b30c$export$a60af00cc0ce2582,
    ZodTransformer: $47a411931cd9b30c$export$a60af00cc0ce2582,
    ZodOptional: $47a411931cd9b30c$export$aa56fec1e9d629b8,
    ZodNullable: $47a411931cd9b30c$export$aaac0b8b429cef5,
    ZodDefault: $47a411931cd9b30c$export$bb19b37874861e7e,
    ZodCatch: $47a411931cd9b30c$export$75a44ec6249ac76b,
    ZodNaN: $47a411931cd9b30c$export$26ccfa0145e8511f,
    BRAND: $47a411931cd9b30c$export$cf2deea74cde46b4,
    ZodBranded: $47a411931cd9b30c$export$66b0c798a395271f,
    ZodPipeline: $47a411931cd9b30c$export$a3c3ef8a0e95c6da,
    ZodReadonly: $47a411931cd9b30c$export$5d1f7ef05c4e493a,
    custom: $47a411931cd9b30c$export$4c00f665f0d4b443,
    Schema: $47a411931cd9b30c$export$19342e026b58ebb7,
    ZodSchema: $47a411931cd9b30c$export$19342e026b58ebb7,
    late: $47a411931cd9b30c$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $47a411931cd9b30c$export$558106ce543bd011;
    },
    coerce: $47a411931cd9b30c$export$8c14e57e778d3873,
    any: $47a411931cd9b30c$export$4154a199d7d90455,
    array: $47a411931cd9b30c$export$2f23118c22fb2630,
    bigint: $47a411931cd9b30c$export$a0f65b52274bcc00,
    boolean: $47a411931cd9b30c$export$4a21f16c33752377,
    date: $47a411931cd9b30c$export$324d90190a8b822a,
    discriminatedUnion: $47a411931cd9b30c$export$4b888e40c4ee26dd,
    effect: $47a411931cd9b30c$export$dc573d8a6576cdb3,
    "enum": $47a411931cd9b30c$export$78a99c8d44d72635,
    "function": $47a411931cd9b30c$export$44e51c8aac7c2deb,
    "instanceof": $47a411931cd9b30c$export$3d916e7c22dbd8b5,
    intersection: $47a411931cd9b30c$export$bc86dfbf7795668c,
    lazy: $47a411931cd9b30c$export$488013bae63b21da,
    literal: $47a411931cd9b30c$export$c8ec6e1ec9fefcb0,
    map: $47a411931cd9b30c$export$871de8747c9eaa88,
    nan: $47a411931cd9b30c$export$9e06de0973666692,
    nativeEnum: $47a411931cd9b30c$export$6fe7eca19ebe5199,
    never: $47a411931cd9b30c$export$b3e22bcfd64c1022,
    "null": $47a411931cd9b30c$export$7b1b591b262c240,
    nullable: $47a411931cd9b30c$export$133fc36489ac9add,
    number: $47a411931cd9b30c$export$98e628dec113755e,
    object: $47a411931cd9b30c$export$be5493f9613cbbe,
    oboolean: $47a411931cd9b30c$export$269251733cdcbbf1,
    onumber: $47a411931cd9b30c$export$eb150471a61fced6,
    optional: $47a411931cd9b30c$export$516e28dec6a4b6d4,
    ostring: $47a411931cd9b30c$export$3b3d07727c5b702c,
    pipeline: $47a411931cd9b30c$export$43f28b24e1eb8181,
    preprocess: $47a411931cd9b30c$export$fc37fe19dfda43ee,
    promise: $47a411931cd9b30c$export$c957ef27a0ebfd4,
    record: $47a411931cd9b30c$export$e5185e241753e543,
    set: $47a411931cd9b30c$export$adaa4cf7ef1b65be,
    strictObject: $47a411931cd9b30c$export$8fb0df5f40d0b477,
    string: $47a411931cd9b30c$export$22b082955e083ec3,
    symbol: $47a411931cd9b30c$export$8f701197936bc2a6,
    transformer: $47a411931cd9b30c$export$dc573d8a6576cdb3,
    tuple: $47a411931cd9b30c$export$65e3907585753458,
    "undefined": $47a411931cd9b30c$export$1db45310990710a5,
    union: $47a411931cd9b30c$export$971dd5b0dfd021b6,
    unknown: $47a411931cd9b30c$export$19282c40b967aec6,
    "void": $47a411931cd9b30c$export$490e536ee7389aeb,
    NEVER: $47a411931cd9b30c$export$96c94437c95d7862,
    ZodIssueCode: $47a411931cd9b30c$export$5ba560653e4a1035,
    quotelessJson: $47a411931cd9b30c$export$913eddeaf297cfea,
    ZodError: $47a411931cd9b30c$export$f98dac4b251ab333
});

});



parcelRegister("5BRQ2", function(module, exports) {

$parcel$export(module.exports, "W3mFrameLogger", () => $415a2b9ac4107719$export$d95526ab53dea907);

var $6GQzw = parcelRequire("6GQzw");

var $034Ac = parcelRequire("034Ac");
class $415a2b9ac4107719$export$d95526ab53dea907 {
    constructor(projectId){
        const loggerOptions = (0, $6GQzw.getDefaultLoggerOptions)({
            level: (0, $034Ac.DEFAULT_LOG_LEVEL)
        });
        const { logger: logger, chunkLoggerController: chunkLoggerController } = (0, $6GQzw.generatePlatformLogger)({
            opts: loggerOptions
        });
        this.logger = (0, $6GQzw.generateChildLogger)(logger, this.constructor.name);
        this.chunkLoggerController = chunkLoggerController;
        if (typeof window !== "undefined" && this.chunkLoggerController?.downloadLogsBlobInBrowser) {
            if (!window.downloadAppKitLogsBlob) window.downloadAppKitLogsBlob = {};
            window.downloadAppKitLogsBlob["sdk"] = ()=>{
                if (this.chunkLoggerController?.downloadLogsBlobInBrowser) this.chunkLoggerController.downloadLogsBlobInBrowser({
                    projectId: projectId
                });
            };
        }
    }
}

});


parcelRegister("6WAiR", function(module, exports) {

$parcel$export(module.exports, "ParseUtil", () => $50e451ecbdbd8e54$export$b9e15791779cd947);
const $50e451ecbdbd8e54$export$b9e15791779cd947 = {
    validateCaipAddress (address) {
        if (address.split(":")?.length !== 3) throw new Error("Invalid CAIP Address");
        return address;
    },
    parseCaipAddress (caipAddress) {
        const parts = caipAddress.split(":");
        if (parts.length !== 3) throw new Error(`Invalid CAIP-10 address: ${caipAddress}`);
        const [chainNamespace, chainId, address] = parts;
        if (!chainNamespace || !chainId || !address) throw new Error(`Invalid CAIP-10 address: ${caipAddress}`);
        return {
            chainNamespace: chainNamespace,
            chainId: chainId,
            address: address
        };
    },
    parseCaipNetworkId (caipNetworkId) {
        const parts = caipNetworkId.split(":");
        if (parts.length !== 2) throw new Error(`Invalid CAIP-2 network id: ${caipNetworkId}`);
        const [chainNamespace, chainId] = parts;
        if (!chainNamespace || !chainId) throw new Error(`Invalid CAIP-2 network id: ${caipNetworkId}`);
        return {
            chainNamespace: chainNamespace,
            chainId: chainId
        };
    }
};

});

parcelRegister("lIOIM", function(module, exports) {

$parcel$export(module.exports, "EnsController", () => $fd050d36625fcf10$export$d0d981286ee4cb7);

var $7zrdF = parcelRequire("7zrdF");

var $eFS1l = parcelRequire("eFS1l");

var $7JKO5 = parcelRequire("7JKO5");

var $bc5dy = parcelRequire("bc5dy");

var $lCKEr = parcelRequire("lCKEr");

var $kfwQH = parcelRequire("kfwQH");

var $hvrT6 = parcelRequire("hvrT6");

var $gD0RX = parcelRequire("gD0RX");

var $efZLi = parcelRequire("efZLi");

var $58cAm = parcelRequire("58cAm");

var $aZ8hw = parcelRequire("aZ8hw");
// -- State --------------------------------------------- //
const $fd050d36625fcf10$var$state = (0, $7zrdF.proxy)({
    suggestions: [],
    loading: false
});
// -- Controller ---------------------------------------- //
const $fd050d36625fcf10$var$controller = {
    state: $fd050d36625fcf10$var$state,
    subscribe (callback) {
        return (0, $7zrdF.subscribe)($fd050d36625fcf10$var$state, ()=>callback($fd050d36625fcf10$var$state));
    },
    subscribeKey (key, callback) {
        return (0, $eFS1l.subscribeKey)($fd050d36625fcf10$var$state, key, callback);
    },
    async resolveName (name) {
        try {
            return await (0, $hvrT6.BlockchainApiController).lookupEnsName(name);
        } catch (e) {
            const error = e;
            throw new Error(error?.reasons?.[0]?.description || "Error resolving name");
        }
    },
    async isNameRegistered (name) {
        try {
            await (0, $hvrT6.BlockchainApiController).lookupEnsName(name);
            return true;
        } catch  {
            return false;
        }
    },
    async getSuggestions (value) {
        try {
            $fd050d36625fcf10$var$state.loading = true;
            $fd050d36625fcf10$var$state.suggestions = [];
            const response = await (0, $hvrT6.BlockchainApiController).getEnsNameSuggestions(value);
            $fd050d36625fcf10$var$state.suggestions = response.suggestions.map((suggestion)=>({
                    ...suggestion,
                    name: suggestion.name
                })) || [];
            return $fd050d36625fcf10$var$state.suggestions;
        } catch (e) {
            const errorMessage = $fd050d36625fcf10$export$d0d981286ee4cb7.parseEnsApiError(e, "Error fetching name suggestions");
            throw new Error(errorMessage);
        } finally{
            $fd050d36625fcf10$var$state.loading = false;
        }
    },
    async getNamesForAddress (address) {
        try {
            const network = (0, $gD0RX.ChainController).state.activeCaipNetwork;
            if (!network) return [];
            const cachedEns = (0, $bc5dy.StorageUtil).getEnsFromCacheForAddress(address);
            if (cachedEns) return cachedEns;
            const response = await (0, $hvrT6.BlockchainApiController).reverseLookupEnsName({
                address: address
            });
            (0, $bc5dy.StorageUtil).updateEnsCache({
                address: address,
                ens: response,
                timestamp: Date.now()
            });
            return response;
        } catch (e) {
            const errorMessage = $fd050d36625fcf10$export$d0d981286ee4cb7.parseEnsApiError(e, "Error fetching names for address");
            throw new Error(errorMessage);
        }
    },
    async registerName (name) {
        const network = (0, $gD0RX.ChainController).state.activeCaipNetwork;
        if (!network) throw new Error("Network not found");
        const address = (0, $kfwQH.AccountController).state.address;
        const emailConnector = (0, $58cAm.ConnectorController).getAuthConnector();
        if (!address || !emailConnector) throw new Error("Address or auth connector not found");
        $fd050d36625fcf10$var$state.loading = true;
        try {
            const message = JSON.stringify({
                name: name,
                attributes: {},
                // Unix timestamp
                timestamp: Math.floor(Date.now() / 1000)
            });
            (0, $aZ8hw.RouterController).pushTransactionStack({
                onCancel () {
                    (0, $aZ8hw.RouterController).replace("RegisterAccountName");
                }
            });
            const signature = await (0, $efZLi.ConnectionController).signMessage(message);
            $fd050d36625fcf10$var$state.loading = false;
            const networkId = network.id;
            if (!networkId) throw new Error("Network not found");
            const coinType = (0, $7JKO5.EnsUtil).convertEVMChainIdToCoinType(Number(networkId));
            await (0, $hvrT6.BlockchainApiController).registerEnsName({
                coinType: coinType,
                address: address,
                signature: signature,
                message: message
            });
            (0, $kfwQH.AccountController).setProfileName(name, network.chainNamespace);
            (0, $aZ8hw.RouterController).replace("RegisterAccountNameSuccess");
        } catch (e) {
            const errorMessage = $fd050d36625fcf10$export$d0d981286ee4cb7.parseEnsApiError(e, `Error registering name ${name}`);
            (0, $aZ8hw.RouterController).replace("RegisterAccountName");
            throw new Error(errorMessage);
        } finally{
            $fd050d36625fcf10$var$state.loading = false;
        }
    },
    validateName (name) {
        return /^[a-zA-Z0-9-]{4,}$/u.test(name);
    },
    parseEnsApiError (error, defaultError) {
        const ensError = error;
        return ensError?.reasons?.[0]?.description || defaultError;
    }
};
const $fd050d36625fcf10$export$d0d981286ee4cb7 = (0, $lCKEr.withErrorBoundary)($fd050d36625fcf10$var$controller);

});
parcelRegister("7JKO5", function(module, exports) {

$parcel$export(module.exports, "EnsUtil", () => $5a210b3c2cc02ebf$export$88d8d1feba0d56ec);
const $5a210b3c2cc02ebf$var$SLIP44_MSB = 0x80000000;
const $5a210b3c2cc02ebf$export$88d8d1feba0d56ec = {
    convertEVMChainIdToCoinType (chainId) {
        if (chainId >= $5a210b3c2cc02ebf$var$SLIP44_MSB) throw new Error("Invalid chainId");
        return ($5a210b3c2cc02ebf$var$SLIP44_MSB | chainId) >>> 0;
    }
};

});


parcelRegister("jHvAI", function(module, exports) {

$parcel$export(module.exports, "OnRampController", () => $e57a89d37e345cfd$export$8cdcd0d64858bea7);

var $7zrdF = parcelRequire("7zrdF");

var $eFS1l = parcelRequire("eFS1l");

var $b3v9s = parcelRequire("b3v9s");

var $3h0dG = parcelRequire("3h0dG");

var $lCKEr = parcelRequire("lCKEr");

var $kfwQH = parcelRequire("kfwQH");

var $g9yWp = parcelRequire("g9yWp");

var $hvrT6 = parcelRequire("hvrT6");

var $gD0RX = parcelRequire("gD0RX");

var $knC5d = parcelRequire("knC5d");
const $e57a89d37e345cfd$export$fed6f7f3caffd3f0 = {
    id: "2b92315d-eab7-5bef-84fa-089a131333f5",
    name: "USD Coin",
    symbol: "USDC",
    networks: [
        {
            name: "ethereum-mainnet",
            display_name: "Ethereum",
            chain_id: "1",
            contract_address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
        },
        {
            name: "polygon-mainnet",
            display_name: "Polygon",
            chain_id: "137",
            contract_address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174"
        }
    ]
};
const $e57a89d37e345cfd$export$213201b848d8007c = {
    id: "USD",
    payment_method_limits: [
        {
            id: "card",
            min: "10.00",
            max: "7500.00"
        },
        {
            id: "ach_bank_account",
            min: "10.00",
            max: "25000.00"
        }
    ]
};
const $e57a89d37e345cfd$var$defaultState = {
    providers: (0, $3h0dG.ONRAMP_PROVIDERS),
    selectedProvider: null,
    error: null,
    purchaseCurrency: $e57a89d37e345cfd$export$fed6f7f3caffd3f0,
    paymentCurrency: $e57a89d37e345cfd$export$213201b848d8007c,
    purchaseCurrencies: [
        $e57a89d37e345cfd$export$fed6f7f3caffd3f0
    ],
    paymentCurrencies: [],
    quotesLoading: false
};
// -- State --------------------------------------------- //
const $e57a89d37e345cfd$var$state = (0, $7zrdF.proxy)($e57a89d37e345cfd$var$defaultState);
// -- Controller ---------------------------------------- //
const $e57a89d37e345cfd$var$controller = {
    state: $e57a89d37e345cfd$var$state,
    subscribe (callback) {
        return (0, $7zrdF.subscribe)($e57a89d37e345cfd$var$state, ()=>callback($e57a89d37e345cfd$var$state));
    },
    subscribeKey (key, callback) {
        return (0, $eFS1l.subscribeKey)($e57a89d37e345cfd$var$state, key, callback);
    },
    setSelectedProvider (provider) {
        if (provider && provider.name === "meld") {
            const currency = (0, $gD0RX.ChainController).state.activeChain === (0, $b3v9s.ConstantsUtil).CHAIN.SOLANA ? "SOL" : "USDC";
            const address = (0, $kfwQH.AccountController).state.address ?? "";
            const url = new URL(provider.url);
            url.searchParams.append("publicKey", (0, $3h0dG.MELD_PUBLIC_KEY));
            url.searchParams.append("destinationCurrencyCode", currency);
            url.searchParams.append("walletAddress", address);
            url.searchParams.append("externalCustomerId", (0, $knC5d.OptionsController).state.projectId);
            $e57a89d37e345cfd$var$state.selectedProvider = {
                ...provider,
                url: url.toString()
            };
        } else $e57a89d37e345cfd$var$state.selectedProvider = provider;
    },
    setOnrampProviders (providers) {
        if (Array.isArray(providers) && providers.every((item)=>typeof item === "string")) {
            const validOnramp = providers;
            const newProviders = (0, $3h0dG.ONRAMP_PROVIDERS).filter((provider)=>validOnramp.includes(provider.name));
            $e57a89d37e345cfd$var$state.providers = newProviders;
        } else $e57a89d37e345cfd$var$state.providers = [];
    },
    setPurchaseCurrency (currency) {
        $e57a89d37e345cfd$var$state.purchaseCurrency = currency;
    },
    setPaymentCurrency (currency) {
        $e57a89d37e345cfd$var$state.paymentCurrency = currency;
    },
    setPurchaseAmount (amount) {
        $e57a89d37e345cfd$export$8cdcd0d64858bea7.state.purchaseAmount = amount;
    },
    setPaymentAmount (amount) {
        $e57a89d37e345cfd$export$8cdcd0d64858bea7.state.paymentAmount = amount;
    },
    async getAvailableCurrencies () {
        const options = await (0, $hvrT6.BlockchainApiController).getOnrampOptions();
        $e57a89d37e345cfd$var$state.purchaseCurrencies = options.purchaseCurrencies;
        $e57a89d37e345cfd$var$state.paymentCurrencies = options.paymentCurrencies;
        $e57a89d37e345cfd$var$state.paymentCurrency = options.paymentCurrencies[0] || $e57a89d37e345cfd$export$213201b848d8007c;
        $e57a89d37e345cfd$var$state.purchaseCurrency = options.purchaseCurrencies[0] || $e57a89d37e345cfd$export$fed6f7f3caffd3f0;
        await (0, $g9yWp.ApiController).fetchCurrencyImages(options.paymentCurrencies.map((currency)=>currency.id));
        await (0, $g9yWp.ApiController).fetchTokenImages(options.purchaseCurrencies.map((currency)=>currency.symbol));
    },
    async getQuote () {
        $e57a89d37e345cfd$var$state.quotesLoading = true;
        try {
            const quote = await (0, $hvrT6.BlockchainApiController).getOnrampQuote({
                purchaseCurrency: $e57a89d37e345cfd$var$state.purchaseCurrency,
                paymentCurrency: $e57a89d37e345cfd$var$state.paymentCurrency,
                amount: $e57a89d37e345cfd$var$state.paymentAmount?.toString() || "0",
                network: $e57a89d37e345cfd$var$state.purchaseCurrency?.symbol
            });
            $e57a89d37e345cfd$var$state.quotesLoading = false;
            $e57a89d37e345cfd$var$state.purchaseAmount = Number(quote?.purchaseAmount.amount);
            return quote;
        } catch (error) {
            $e57a89d37e345cfd$var$state.error = error.message;
            $e57a89d37e345cfd$var$state.quotesLoading = false;
            return null;
        } finally{
            $e57a89d37e345cfd$var$state.quotesLoading = false;
        }
    },
    resetState () {
        $e57a89d37e345cfd$var$state.selectedProvider = null;
        $e57a89d37e345cfd$var$state.error = null;
        $e57a89d37e345cfd$var$state.purchaseCurrency = $e57a89d37e345cfd$export$fed6f7f3caffd3f0;
        $e57a89d37e345cfd$var$state.paymentCurrency = $e57a89d37e345cfd$export$213201b848d8007c;
        $e57a89d37e345cfd$var$state.purchaseCurrencies = [
            $e57a89d37e345cfd$export$fed6f7f3caffd3f0
        ];
        $e57a89d37e345cfd$var$state.paymentCurrencies = [];
        $e57a89d37e345cfd$var$state.paymentAmount = undefined;
        $e57a89d37e345cfd$var$state.purchaseAmount = undefined;
        $e57a89d37e345cfd$var$state.quotesLoading = false;
    }
};
const $e57a89d37e345cfd$export$8cdcd0d64858bea7 = (0, $lCKEr.withErrorBoundary)($e57a89d37e345cfd$var$controller);

});

parcelRegister("kHrzX", function(module, exports) {

$parcel$export(module.exports, "ConnectorUtil", () => $f11d3765d5299194$export$da399465fdb11b85);

var $b3v9s = parcelRequire("b3v9s");

var $g9yWp = parcelRequire("g9yWp");
var $gD0RX = parcelRequire("gD0RX");
var $efZLi = parcelRequire("efZLi");
var $58cAm = parcelRequire("58cAm");
var $lpmCO = parcelRequire("lpmCO");
var $knC5d = parcelRequire("knC5d");
var $bc5dy = parcelRequire("bc5dy");

var $ePwaB = parcelRequire("ePwaB");

var $lDgVc = parcelRequire("lDgVc");
const $f11d3765d5299194$export$da399465fdb11b85 = {
    getConnectorsByType (connectors, recommended, featured) {
        const { customWallets: customWallets } = (0, $knC5d.OptionsController).state;
        const recent = (0, $bc5dy.StorageUtil).getRecentWallets();
        const filteredRecommended = (0, $lDgVc.WalletUtil).filterOutDuplicateWallets(recommended);
        const filteredFeatured = (0, $lDgVc.WalletUtil).filterOutDuplicateWallets(featured);
        const multiChain = connectors.filter((connector)=>connector.type === "MULTI_CHAIN");
        const announced = connectors.filter((connector)=>connector.type === "ANNOUNCED");
        const injected = connectors.filter((connector)=>connector.type === "INJECTED");
        const external = connectors.filter((connector)=>connector.type === "EXTERNAL");
        return {
            custom: customWallets,
            recent: recent,
            external: external,
            multiChain: multiChain,
            announced: announced,
            injected: injected,
            recommended: filteredRecommended,
            featured: filteredFeatured
        };
    },
    showConnector (connector) {
        const rdns = connector.info?.rdns;
        const isRDNSExcluded = Boolean(rdns) && (0, $g9yWp.ApiController).state.excludedWallets.some((wallet)=>Boolean(wallet.rdns) && wallet.rdns === rdns);
        const isNameExcluded = Boolean(connector.name) && (0, $g9yWp.ApiController).state.excludedWallets.some((wallet)=>(0, $ePwaB.HelpersUtil).isLowerCaseMatch(wallet.name, connector.name));
        if (connector.type === "INJECTED") {
            const isBrowserWallet = connector.name === "Browser Wallet";
            if (isBrowserWallet) {
                if (!(0, $lpmCO.CoreHelperUtil).isMobile()) return false;
                if ((0, $lpmCO.CoreHelperUtil).isMobile() && !rdns && !(0, $efZLi.ConnectionController).checkInstalled()) return false;
            }
            if (isRDNSExcluded || isNameExcluded) return false;
        }
        if ((connector.type === "ANNOUNCED" || connector.type === "EXTERNAL") && (isRDNSExcluded || isNameExcluded)) return false;
        return true;
    },
    getIsConnectedWithWC () {
        const chains = Array.from((0, $gD0RX.ChainController).state.chains.values());
        const isConnectedWithWC = chains.some((chain)=>{
            const connectorId = (0, $58cAm.ConnectorController).getConnectorId(chain.namespace);
            return connectorId === (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.WALLET_CONNECT;
        });
        return isConnectedWithWC;
    },
    getConnectorTypeOrder ({ recommended: recommended, featured: featured, custom: custom, recent: recent, announced: announced, injected: injected, multiChain: multiChain, external: external, overriddenConnectors: overriddenConnectors = (0, $knC5d.OptionsController).state.features?.connectorTypeOrder ?? [] }) {
        const isConnectedWithWC = $f11d3765d5299194$export$da399465fdb11b85.getIsConnectedWithWC();
        const isWCEnabled = (0, $knC5d.OptionsController).state.enableWalletConnect;
        const allConnectors = [
            {
                type: "walletConnect",
                isEnabled: isWCEnabled && !isConnectedWithWC
            },
            {
                type: "recent",
                isEnabled: recent.length > 0
            },
            {
                type: "injected",
                isEnabled: [
                    ...injected,
                    ...announced,
                    ...multiChain
                ].length > 0
            },
            {
                type: "featured",
                isEnabled: featured.length > 0
            },
            {
                type: "custom",
                isEnabled: custom && custom.length > 0
            },
            {
                type: "external",
                isEnabled: external.length > 0
            },
            {
                type: "recommended",
                isEnabled: recommended.length > 0
            }
        ];
        const enabledConnectors = allConnectors.filter((option)=>option.isEnabled);
        const enabledConnectorTypes = new Set(enabledConnectors.map((option)=>option.type));
        const prioritizedConnectors = overriddenConnectors.filter((type)=>enabledConnectorTypes.has(type)).map((type)=>({
                type: type,
                isEnabled: true
            }));
        const remainingConnectors = enabledConnectors.filter(({ type: enabledConnectorType })=>{
            const hasPrioritizedConnector = prioritizedConnectors.some(({ type: prioritizedConnectorType })=>prioritizedConnectorType === enabledConnectorType);
            return !hasPrioritizedConnector;
        });
        return Array.from(new Set([
            ...prioritizedConnectors,
            ...remainingConnectors
        ].map(({ type: type })=>type)));
    }
};

});
parcelRegister("ePwaB", function(module, exports) {

$parcel$export(module.exports, "HelpersUtil", () => $acbec8669f2235b4$export$518f198897991e39);

var $5SSdQ = parcelRequire("5SSdQ");
const $acbec8669f2235b4$export$518f198897991e39 = {
    getCaipTokens (tokens) {
        if (!tokens) return undefined;
        const caipTokens = {};
        Object.entries(tokens).forEach(([id, token])=>{
            caipTokens[`${(0, $5SSdQ.ConstantsUtil).EIP155}:${id}`] = token;
        });
        return caipTokens;
    },
    isLowerCaseMatch (str1, str2) {
        return str1?.toLowerCase() === str2?.toLowerCase();
    }
};

});

parcelRegister("lDgVc", function(module, exports) {

$parcel$export(module.exports, "WalletUtil", () => $fbfa5dbffcf31267$export$74541ed5542a8fa7);

var $g9yWp = parcelRequire("g9yWp");
var $58cAm = parcelRequire("58cAm");
var $lpmCO = parcelRequire("lpmCO");
var $knC5d = parcelRequire("knC5d");
var $bc5dy = parcelRequire("bc5dy");

var $ePwaB = parcelRequire("ePwaB");

var $kHrzX = parcelRequire("kHrzX");

var $6weBs = parcelRequire("6weBs");
const $fbfa5dbffcf31267$export$74541ed5542a8fa7 = {
    filterOutDuplicatesByRDNS (wallets) {
        const connectors = (0, $knC5d.OptionsController).state.enableEIP6963 ? (0, $58cAm.ConnectorController).state.connectors : [];
        const recent = (0, $bc5dy.StorageUtil).getRecentWallets();
        const connectorRDNSs = connectors.map((connector)=>connector.info?.rdns).filter(Boolean);
        const recentRDNSs = recent.map((wallet)=>wallet.rdns).filter(Boolean);
        const allRDNSs = connectorRDNSs.concat(recentRDNSs);
        if (allRDNSs.includes("io.metamask.mobile") && (0, $lpmCO.CoreHelperUtil).isMobile()) {
            const index = allRDNSs.indexOf("io.metamask.mobile");
            allRDNSs[index] = "io.metamask";
        }
        const filtered = wallets.filter((wallet)=>!allRDNSs.includes(String(wallet?.rdns)));
        return filtered;
    },
    filterOutDuplicatesByIds (wallets) {
        const connectors = (0, $58cAm.ConnectorController).state.connectors.filter((connector)=>connector.type === "ANNOUNCED" || connector.type === "INJECTED");
        const recent = (0, $bc5dy.StorageUtil).getRecentWallets();
        const connectorIds = connectors.map((connector)=>connector.explorerId);
        const recentIds = recent.map((wallet)=>wallet.id);
        const allIds = connectorIds.concat(recentIds);
        const filtered = wallets.filter((wallet)=>!allIds.includes(wallet?.id));
        return filtered;
    },
    filterOutDuplicateWallets (wallets) {
        const uniqueByRDNS = this.filterOutDuplicatesByRDNS(wallets);
        const uniqueWallets = this.filterOutDuplicatesByIds(uniqueByRDNS);
        return uniqueWallets;
    },
    markWalletsAsInstalled (wallets) {
        const { connectors: connectors } = (0, $58cAm.ConnectorController).state;
        const { featuredWalletIds: featuredWalletIds } = (0, $knC5d.OptionsController).state;
        const installedWalletRdnsMap = connectors.filter((connector)=>connector.type === "ANNOUNCED").reduce((rdnsMap, connector)=>{
            if (!connector.info?.rdns) return rdnsMap;
            rdnsMap[connector.info.rdns] = true;
            return rdnsMap;
        }, {});
        const walletsWithInstallationStatus = wallets.map((wallet)=>({
                ...wallet,
                installed: Boolean(wallet.rdns) && Boolean(installedWalletRdnsMap[wallet.rdns ?? ""])
            }));
        const sortedWallets = walletsWithInstallationStatus.sort((walletA, walletB)=>{
            const installationComparison = Number(walletB.installed) - Number(walletA.installed);
            if (installationComparison !== 0) return installationComparison;
            if (featuredWalletIds?.length) {
                const walletAFeaturedIndex = featuredWalletIds.indexOf(walletA.id);
                const walletBFeaturedIndex = featuredWalletIds.indexOf(walletB.id);
                if (walletAFeaturedIndex !== -1 && walletBFeaturedIndex !== -1) return walletAFeaturedIndex - walletBFeaturedIndex;
                if (walletAFeaturedIndex !== -1) return -1;
                if (walletBFeaturedIndex !== -1) return 1;
            }
            return 0;
        });
        return sortedWallets;
    },
    getConnectOrderMethod (_features, _connectors) {
        const connectMethodOrder = _features?.connectMethodsOrder || (0, $knC5d.OptionsController).state.features?.connectMethodsOrder;
        const connectors = _connectors || (0, $58cAm.ConnectorController).state.connectors;
        if (connectMethodOrder) return connectMethodOrder;
        const { injected: injected, announced: announced } = (0, $kHrzX.ConnectorUtil).getConnectorsByType(connectors, (0, $g9yWp.ApiController).state.recommended, (0, $g9yWp.ApiController).state.featured);
        const shownInjected = injected.filter((0, $kHrzX.ConnectorUtil).showConnector);
        const shownAnnounced = announced.filter((0, $kHrzX.ConnectorUtil).showConnector);
        if (shownInjected.length || shownAnnounced.length) return [
            "wallet",
            "email",
            "social"
        ];
        return (0, $6weBs.ConstantsUtil).DEFAULT_CONNECT_METHOD_ORDER;
    },
    isExcluded (wallet) {
        const isRDNSExcluded = Boolean(wallet.rdns) && (0, $g9yWp.ApiController).state.excludedWallets.some((w)=>w.rdns === wallet.rdns);
        const isNameExcluded = Boolean(wallet.name) && (0, $g9yWp.ApiController).state.excludedWallets.some((w)=>(0, $ePwaB.HelpersUtil).isLowerCaseMatch(w.name, wallet.name));
        return isRDNSExcluded || isNameExcluded;
    }
};

});
parcelRegister("6weBs", function(module, exports) {

$parcel$export(module.exports, "ConstantsUtil", () => $4bf10f2162d8645f$export$aafe1f751f1bc52a);

var $kuzpm = parcelRequire("kuzpm");
const $4bf10f2162d8645f$export$aafe1f751f1bc52a = {
    ACCOUNT_TABS: [
        {
            label: "Tokens"
        },
        {
            label: "NFTs"
        },
        {
            label: "Activity"
        }
    ],
    SECURE_SITE_ORIGIN: (typeof $kuzpm !== "undefined" && typeof $kuzpm.env !== "undefined" ? undefined : undefined) || "https://secure.walletconnect.org",
    VIEW_DIRECTION: {
        Next: "next",
        Prev: "prev"
    },
    DEFAULT_CONNECT_METHOD_ORDER: [
        "email",
        "social",
        "wallet"
    ],
    ANIMATION_DURATIONS: {
        HeaderText: 120,
        ModalHeight: 150,
        ViewTransition: 150
    }
};

});



parcelRegister("giNUc", function(module, exports) {

$parcel$export(module.exports, "MathUtil", () => (parcelRequire("7OpeC")).MathUtil);
$parcel$export(module.exports, "initializeTheming", () => (parcelRequire("gqttf")).initializeTheming);
$parcel$export(module.exports, "setColorTheme", () => (parcelRequire("gqttf")).setColorTheme);
$parcel$export(module.exports, "setThemeVariables", () => (parcelRequire("gqttf")).setThemeVariables);
$parcel$export(module.exports, "UiHelperUtil", () => (parcelRequire("8f1DU")).UiHelperUtil);
$parcel$export(module.exports, "TransactionUtil", () => (parcelRequire("cj4sB")).TransactionUtil);
$parcel$export(module.exports, "customElement", () => (parcelRequire("iOo4s")).customElement);

var $7OpeC = parcelRequire("7OpeC");

var $gqttf = parcelRequire("gqttf");

var $8f1DU = parcelRequire("8f1DU");

var $cj4sB = parcelRequire("cj4sB");

var $iOo4s = parcelRequire("iOo4s");

});
parcelRegister("7OpeC", function(module, exports) {

$parcel$export(module.exports, "MathUtil", () => $5b00c708682875de$export$cdbe365d8c7d477d);
const $5b00c708682875de$export$cdbe365d8c7d477d = {
    interpolate (inputRange, outputRange, value) {
        if (inputRange.length !== 2 || outputRange.length !== 2) throw new Error("inputRange and outputRange must be an array of length 2");
        const originalRangeMin = inputRange[0] || 0;
        const originalRangeMax = inputRange[1] || 0;
        const newRangeMin = outputRange[0] || 0;
        const newRangeMax = outputRange[1] || 0;
        if (value < originalRangeMin) return newRangeMin;
        if (value > originalRangeMax) return newRangeMax;
        return (newRangeMax - newRangeMin) / (originalRangeMax - originalRangeMin) * (value - originalRangeMin) + newRangeMin;
    }
};

});

parcelRegister("gqttf", function(module, exports) {

$parcel$export(module.exports, "initializeTheming", () => $bf55ef56e9436a28$export$8ee9916a43f985de);
$parcel$export(module.exports, "setColorTheme", () => $bf55ef56e9436a28$export$718db041b82c5d23);
$parcel$export(module.exports, "setThemeVariables", () => $bf55ef56e9436a28$export$b6ed091aa8078e9b);
$parcel$export(module.exports, "resetStyles", () => $bf55ef56e9436a28$export$6b6f359a824920a4);
$parcel$export(module.exports, "elementStyles", () => $bf55ef56e9436a28$export$e7ba49a1dbca65c7);
$parcel$export(module.exports, "colorStyles", () => $bf55ef56e9436a28$export$ab44001f5690ee9c);
parcelRequire("lD8FA");
var $4QRxi = parcelRequire("4QRxi");

var $2Z0OY = parcelRequire("2Z0OY");
let $bf55ef56e9436a28$var$themeTag = undefined;
let $bf55ef56e9436a28$var$darkModeTag = undefined;
let $bf55ef56e9436a28$var$lightModeTag = undefined;
function $bf55ef56e9436a28$export$8ee9916a43f985de(themeVariables, themeMode) {
    $bf55ef56e9436a28$var$themeTag = document.createElement("style");
    $bf55ef56e9436a28$var$darkModeTag = document.createElement("style");
    $bf55ef56e9436a28$var$lightModeTag = document.createElement("style");
    $bf55ef56e9436a28$var$themeTag.textContent = $bf55ef56e9436a28$var$createRootStyles(themeVariables).core.cssText;
    $bf55ef56e9436a28$var$darkModeTag.textContent = $bf55ef56e9436a28$var$createRootStyles(themeVariables).dark.cssText;
    $bf55ef56e9436a28$var$lightModeTag.textContent = $bf55ef56e9436a28$var$createRootStyles(themeVariables).light.cssText;
    document.head.appendChild($bf55ef56e9436a28$var$themeTag);
    document.head.appendChild($bf55ef56e9436a28$var$darkModeTag);
    document.head.appendChild($bf55ef56e9436a28$var$lightModeTag);
    $bf55ef56e9436a28$export$718db041b82c5d23(themeMode);
}
function $bf55ef56e9436a28$export$718db041b82c5d23(themeMode) {
    if ($bf55ef56e9436a28$var$darkModeTag && $bf55ef56e9436a28$var$lightModeTag) {
        if (themeMode === "light") {
            $bf55ef56e9436a28$var$darkModeTag.removeAttribute("media");
            $bf55ef56e9436a28$var$lightModeTag.media = "enabled";
        } else {
            $bf55ef56e9436a28$var$lightModeTag.removeAttribute("media");
            $bf55ef56e9436a28$var$darkModeTag.media = "enabled";
        }
    }
}
function $bf55ef56e9436a28$export$b6ed091aa8078e9b(themeVariables) {
    if ($bf55ef56e9436a28$var$themeTag && $bf55ef56e9436a28$var$darkModeTag && $bf55ef56e9436a28$var$lightModeTag) {
        $bf55ef56e9436a28$var$themeTag.textContent = $bf55ef56e9436a28$var$createRootStyles(themeVariables).core.cssText;
        $bf55ef56e9436a28$var$darkModeTag.textContent = $bf55ef56e9436a28$var$createRootStyles(themeVariables).dark.cssText;
        $bf55ef56e9436a28$var$lightModeTag.textContent = $bf55ef56e9436a28$var$createRootStyles(themeVariables).light.cssText;
    }
}
function $bf55ef56e9436a28$var$createRootStyles(themeVariables) {
    return {
        core: (0, $4QRxi.css)`
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
      @keyframes w3m-shake {
        0% {
          transform: scale(1) rotate(0deg);
        }
        20% {
          transform: scale(1) rotate(-1deg);
        }
        40% {
          transform: scale(1) rotate(1.5deg);
        }
        60% {
          transform: scale(1) rotate(-1.5deg);
        }
        80% {
          transform: scale(1) rotate(1deg);
        }
        100% {
          transform: scale(1) rotate(0deg);
        }
      }
      @keyframes w3m-iframe-fade-out {
        0% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }
      @keyframes w3m-iframe-zoom-in {
        0% {
          transform: translateY(50px);
          opacity: 0;
        }
        100% {
          transform: translateY(0px);
          opacity: 1;
        }
      }
      @keyframes w3m-iframe-zoom-in-mobile {
        0% {
          transform: scale(0.95);
          opacity: 0;
        }
        100% {
          transform: scale(1);
          opacity: 1;
        }
      }
      :root {
        --w3m-modal-width: 360px;
        --w3m-color-mix-strength: ${(0, $4QRxi.unsafeCSS)(themeVariables?.["--w3m-color-mix-strength"] ? `${themeVariables["--w3m-color-mix-strength"]}%` : "0%")};
        --w3m-font-family: ${(0, $4QRxi.unsafeCSS)(themeVariables?.["--w3m-font-family"] || "Inter, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;")};
        --w3m-font-size-master: ${(0, $4QRxi.unsafeCSS)(themeVariables?.["--w3m-font-size-master"] || "10px")};
        --w3m-border-radius-master: ${(0, $4QRxi.unsafeCSS)(themeVariables?.["--w3m-border-radius-master"] || "4px")};
        --w3m-z-index: ${(0, $4QRxi.unsafeCSS)(themeVariables?.["--w3m-z-index"] || 999)};

        --wui-font-family: var(--w3m-font-family);

        --wui-font-size-mini: calc(var(--w3m-font-size-master) * 0.8);
        --wui-font-size-micro: var(--w3m-font-size-master);
        --wui-font-size-tiny: calc(var(--w3m-font-size-master) * 1.2);
        --wui-font-size-small: calc(var(--w3m-font-size-master) * 1.4);
        --wui-font-size-paragraph: calc(var(--w3m-font-size-master) * 1.6);
        --wui-font-size-medium: calc(var(--w3m-font-size-master) * 1.8);
        --wui-font-size-large: calc(var(--w3m-font-size-master) * 2);
        --wui-font-size-title-6: calc(var(--w3m-font-size-master) * 2.2);
        --wui-font-size-medium-title: calc(var(--w3m-font-size-master) * 2.4);
        --wui-font-size-2xl: calc(var(--w3m-font-size-master) * 4);

        --wui-border-radius-5xs: var(--w3m-border-radius-master);
        --wui-border-radius-4xs: calc(var(--w3m-border-radius-master) * 1.5);
        --wui-border-radius-3xs: calc(var(--w3m-border-radius-master) * 2);
        --wui-border-radius-xxs: calc(var(--w3m-border-radius-master) * 3);
        --wui-border-radius-xs: calc(var(--w3m-border-radius-master) * 4);
        --wui-border-radius-s: calc(var(--w3m-border-radius-master) * 5);
        --wui-border-radius-m: calc(var(--w3m-border-radius-master) * 7);
        --wui-border-radius-l: calc(var(--w3m-border-radius-master) * 9);
        --wui-border-radius-3xl: calc(var(--w3m-border-radius-master) * 20);

        --wui-font-weight-light: 400;
        --wui-font-weight-regular: 500;
        --wui-font-weight-medium: 600;
        --wui-font-weight-bold: 700;

        --wui-letter-spacing-2xl: -1.6px;
        --wui-letter-spacing-medium-title: -0.96px;
        --wui-letter-spacing-title-6: -0.88px;
        --wui-letter-spacing-large: -0.8px;
        --wui-letter-spacing-medium: -0.72px;
        --wui-letter-spacing-paragraph: -0.64px;
        --wui-letter-spacing-small: -0.56px;
        --wui-letter-spacing-tiny: -0.48px;
        --wui-letter-spacing-micro: -0.2px;
        --wui-letter-spacing-mini: -0.16px;

        --wui-spacing-0: 0px;
        --wui-spacing-4xs: 2px;
        --wui-spacing-3xs: 4px;
        --wui-spacing-xxs: 6px;
        --wui-spacing-2xs: 7px;
        --wui-spacing-xs: 8px;
        --wui-spacing-1xs: 10px;
        --wui-spacing-s: 12px;
        --wui-spacing-m: 14px;
        --wui-spacing-l: 16px;
        --wui-spacing-2l: 18px;
        --wui-spacing-xl: 20px;
        --wui-spacing-xxl: 24px;
        --wui-spacing-2xl: 32px;
        --wui-spacing-3xl: 40px;
        --wui-spacing-4xl: 90px;
        --wui-spacing-5xl: 95px;

        --wui-icon-box-size-xxs: 14px;
        --wui-icon-box-size-xs: 20px;
        --wui-icon-box-size-sm: 24px;
        --wui-icon-box-size-md: 32px;
        --wui-icon-box-size-mdl: 36px;
        --wui-icon-box-size-lg: 40px;
        --wui-icon-box-size-2lg: 48px;
        --wui-icon-box-size-xl: 64px;

        --wui-icon-size-inherit: inherit;
        --wui-icon-size-xxs: 10px;
        --wui-icon-size-xs: 12px;
        --wui-icon-size-sm: 14px;
        --wui-icon-size-md: 16px;
        --wui-icon-size-mdl: 18px;
        --wui-icon-size-lg: 20px;
        --wui-icon-size-xl: 24px;
        --wui-icon-size-xxl: 28px;

        --wui-wallet-image-size-inherit: inherit;
        --wui-wallet-image-size-sm: 40px;
        --wui-wallet-image-size-md: 56px;
        --wui-wallet-image-size-lg: 80px;

        --wui-visual-size-size-inherit: inherit;
        --wui-visual-size-sm: 40px;
        --wui-visual-size-md: 55px;
        --wui-visual-size-lg: 80px;

        --wui-box-size-md: 100px;
        --wui-box-size-lg: 120px;

        --wui-ease-out-power-2: cubic-bezier(0, 0, 0.22, 1);
        --wui-ease-out-power-1: cubic-bezier(0, 0, 0.55, 1);

        --wui-ease-in-power-3: cubic-bezier(0.66, 0, 1, 1);
        --wui-ease-in-power-2: cubic-bezier(0.45, 0, 1, 1);
        --wui-ease-in-power-1: cubic-bezier(0.3, 0, 1, 1);

        --wui-ease-inout-power-1: cubic-bezier(0.45, 0, 0.55, 1);

        --wui-duration-lg: 200ms;
        --wui-duration-md: 125ms;
        --wui-duration-sm: 75ms;

        --wui-path-network-sm: path(
          'M15.4 2.1a5.21 5.21 0 0 1 5.2 0l11.61 6.7a5.21 5.21 0 0 1 2.61 4.52v13.4c0 1.87-1 3.59-2.6 4.52l-11.61 6.7c-1.62.93-3.6.93-5.22 0l-11.6-6.7a5.21 5.21 0 0 1-2.61-4.51v-13.4c0-1.87 1-3.6 2.6-4.52L15.4 2.1Z'
        );

        --wui-path-network-md: path(
          'M43.4605 10.7248L28.0485 1.61089C25.5438 0.129705 22.4562 0.129705 19.9515 1.61088L4.53951 10.7248C2.03626 12.2051 0.5 14.9365 0.5 17.886V36.1139C0.5 39.0635 2.03626 41.7949 4.53951 43.2752L19.9515 52.3891C22.4562 53.8703 25.5438 53.8703 28.0485 52.3891L43.4605 43.2752C45.9637 41.7949 47.5 39.0635 47.5 36.114V17.8861C47.5 14.9365 45.9637 12.2051 43.4605 10.7248Z'
        );

        --wui-path-network-lg: path(
          'M78.3244 18.926L50.1808 2.45078C45.7376 -0.150261 40.2624 -0.150262 35.8192 2.45078L7.6756 18.926C3.23322 21.5266 0.5 26.3301 0.5 31.5248V64.4752C0.5 69.6699 3.23322 74.4734 7.6756 77.074L35.8192 93.5492C40.2624 96.1503 45.7376 96.1503 50.1808 93.5492L78.3244 77.074C82.7668 74.4734 85.5 69.6699 85.5 64.4752V31.5248C85.5 26.3301 82.7668 21.5266 78.3244 18.926Z'
        );

        --wui-width-network-sm: 36px;
        --wui-width-network-md: 48px;
        --wui-width-network-lg: 86px;

        --wui-height-network-sm: 40px;
        --wui-height-network-md: 54px;
        --wui-height-network-lg: 96px;

        --wui-icon-size-network-xs: 12px;
        --wui-icon-size-network-sm: 16px;
        --wui-icon-size-network-md: 24px;
        --wui-icon-size-network-lg: 42px;

        --wui-color-inherit: inherit;

        --wui-color-inverse-100: #fff;
        --wui-color-inverse-000: #000;

        --wui-cover: rgba(20, 20, 20, 0.8);

        --wui-color-modal-bg: var(--wui-color-modal-bg-base);

        --wui-color-accent-100: var(--wui-color-accent-base-100);
        --wui-color-accent-090: var(--wui-color-accent-base-090);
        --wui-color-accent-080: var(--wui-color-accent-base-080);

        --wui-color-success-100: var(--wui-color-success-base-100);
        --wui-color-success-125: var(--wui-color-success-base-125);

        --wui-color-warning-100: var(--wui-color-warning-base-100);

        --wui-color-error-100: var(--wui-color-error-base-100);
        --wui-color-error-125: var(--wui-color-error-base-125);

        --wui-color-blue-100: var(--wui-color-blue-base-100);
        --wui-color-blue-90: var(--wui-color-blue-base-90);

        --wui-icon-box-bg-error-100: var(--wui-icon-box-bg-error-base-100);
        --wui-icon-box-bg-blue-100: var(--wui-icon-box-bg-blue-base-100);
        --wui-icon-box-bg-success-100: var(--wui-icon-box-bg-success-base-100);
        --wui-icon-box-bg-inverse-100: var(--wui-icon-box-bg-inverse-base-100);

        --wui-all-wallets-bg-100: var(--wui-all-wallets-bg-100);

        --wui-avatar-border: var(--wui-avatar-border-base);

        --wui-thumbnail-border: var(--wui-thumbnail-border-base);

        --wui-wallet-button-bg: var(--wui-wallet-button-bg-base);

        --wui-box-shadow-blue: var(--wui-color-accent-glass-020);
      }

      @supports (background: color-mix(in srgb, white 50%, black)) {
        :root {
          --wui-color-modal-bg: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-modal-bg-base)
          );

          --wui-box-shadow-blue: color-mix(in srgb, var(--wui-color-accent-100) 20%, transparent);

          --wui-color-accent-100: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 100%,
            transparent
          );
          --wui-color-accent-090: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 90%,
            transparent
          );
          --wui-color-accent-080: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 80%,
            transparent
          );
          --wui-color-accent-glass-090: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 90%,
            transparent
          );
          --wui-color-accent-glass-080: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 80%,
            transparent
          );
          --wui-color-accent-glass-020: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 20%,
            transparent
          );
          --wui-color-accent-glass-015: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 15%,
            transparent
          );
          --wui-color-accent-glass-010: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 10%,
            transparent
          );
          --wui-color-accent-glass-005: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 5%,
            transparent
          );
          --wui-color-accent-002: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 2%,
            transparent
          );

          --wui-color-fg-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-100)
          );
          --wui-color-fg-125: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-125)
          );
          --wui-color-fg-150: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-150)
          );
          --wui-color-fg-175: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-175)
          );
          --wui-color-fg-200: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-200)
          );
          --wui-color-fg-225: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-225)
          );
          --wui-color-fg-250: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-250)
          );
          --wui-color-fg-275: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-275)
          );
          --wui-color-fg-300: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-300)
          );
          --wui-color-fg-325: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-325)
          );
          --wui-color-fg-350: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-350)
          );

          --wui-color-bg-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-100)
          );
          --wui-color-bg-125: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-125)
          );
          --wui-color-bg-150: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-150)
          );
          --wui-color-bg-175: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-175)
          );
          --wui-color-bg-200: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-200)
          );
          --wui-color-bg-225: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-225)
          );
          --wui-color-bg-250: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-250)
          );
          --wui-color-bg-275: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-275)
          );
          --wui-color-bg-300: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-300)
          );
          --wui-color-bg-325: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-325)
          );
          --wui-color-bg-350: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-350)
          );

          --wui-color-success-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-success-base-100)
          );
          --wui-color-success-125: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-success-base-125)
          );

          --wui-color-warning-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-warning-base-100)
          );

          --wui-color-error-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-error-base-100)
          );
          --wui-color-blue-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-blue-base-100)
          );
          --wui-color-blue-90: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-blue-base-90)
          );
          --wui-color-error-125: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-error-base-125)
          );

          --wui-icon-box-bg-error-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-error-base-100)
          );
          --wui-icon-box-bg-accent-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-blue-base-100)
          );
          --wui-icon-box-bg-success-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-success-base-100)
          );
          --wui-icon-box-bg-inverse-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-inverse-base-100)
          );

          --wui-all-wallets-bg-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-all-wallets-bg-100)
          );

          --wui-avatar-border: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-avatar-border-base)
          );

          --wui-thumbnail-border: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-thumbnail-border-base)
          );

          --wui-wallet-button-bg: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-wallet-button-bg-base)
          );
        }
      }
    `,
        light: (0, $4QRxi.css)`
      :root {
        --w3m-color-mix: ${(0, $4QRxi.unsafeCSS)(themeVariables?.["--w3m-color-mix"] || "#fff")};
        --w3m-accent: ${(0, $4QRxi.unsafeCSS)((0, $2Z0OY.getW3mThemeVariables)(themeVariables, "dark")["--w3m-accent"])};
        --w3m-default: #fff;

        --wui-color-modal-bg-base: ${(0, $4QRxi.unsafeCSS)((0, $2Z0OY.getW3mThemeVariables)(themeVariables, "dark")["--w3m-background"])};
        --wui-color-accent-base-100: var(--w3m-accent);

        --wui-color-blueberry-100: hsla(230, 100%, 67%, 1);
        --wui-color-blueberry-090: hsla(231, 76%, 61%, 1);
        --wui-color-blueberry-080: hsla(230, 59%, 55%, 1);
        --wui-color-blueberry-050: hsla(231, 100%, 70%, 0.1);

        --wui-color-fg-100: #e4e7e7;
        --wui-color-fg-125: #d0d5d5;
        --wui-color-fg-150: #a8b1b1;
        --wui-color-fg-175: #a8b0b0;
        --wui-color-fg-200: #949e9e;
        --wui-color-fg-225: #868f8f;
        --wui-color-fg-250: #788080;
        --wui-color-fg-275: #788181;
        --wui-color-fg-300: #6e7777;
        --wui-color-fg-325: #9a9a9a;
        --wui-color-fg-350: #363636;

        --wui-color-bg-100: #141414;
        --wui-color-bg-125: #191a1a;
        --wui-color-bg-150: #1e1f1f;
        --wui-color-bg-175: #222525;
        --wui-color-bg-200: #272a2a;
        --wui-color-bg-225: #2c3030;
        --wui-color-bg-250: #313535;
        --wui-color-bg-275: #363b3b;
        --wui-color-bg-300: #3b4040;
        --wui-color-bg-325: #252525;
        --wui-color-bg-350: #ffffff;

        --wui-color-success-base-100: #26d962;
        --wui-color-success-base-125: #30a46b;

        --wui-color-warning-base-100: #f3a13f;

        --wui-color-error-base-100: #f25a67;
        --wui-color-error-base-125: #df4a34;

        --wui-color-blue-base-100: rgba(102, 125, 255, 1);
        --wui-color-blue-base-90: rgba(102, 125, 255, 0.9);

        --wui-color-success-glass-001: rgba(38, 217, 98, 0.01);
        --wui-color-success-glass-002: rgba(38, 217, 98, 0.02);
        --wui-color-success-glass-005: rgba(38, 217, 98, 0.05);
        --wui-color-success-glass-010: rgba(38, 217, 98, 0.1);
        --wui-color-success-glass-015: rgba(38, 217, 98, 0.15);
        --wui-color-success-glass-020: rgba(38, 217, 98, 0.2);
        --wui-color-success-glass-025: rgba(38, 217, 98, 0.25);
        --wui-color-success-glass-030: rgba(38, 217, 98, 0.3);
        --wui-color-success-glass-060: rgba(38, 217, 98, 0.6);
        --wui-color-success-glass-080: rgba(38, 217, 98, 0.8);

        --wui-color-success-glass-reown-020: rgba(48, 164, 107, 0.2);

        --wui-color-warning-glass-reown-020: rgba(243, 161, 63, 0.2);

        --wui-color-error-glass-001: rgba(242, 90, 103, 0.01);
        --wui-color-error-glass-002: rgba(242, 90, 103, 0.02);
        --wui-color-error-glass-005: rgba(242, 90, 103, 0.05);
        --wui-color-error-glass-010: rgba(242, 90, 103, 0.1);
        --wui-color-error-glass-015: rgba(242, 90, 103, 0.15);
        --wui-color-error-glass-020: rgba(242, 90, 103, 0.2);
        --wui-color-error-glass-025: rgba(242, 90, 103, 0.25);
        --wui-color-error-glass-030: rgba(242, 90, 103, 0.3);
        --wui-color-error-glass-060: rgba(242, 90, 103, 0.6);
        --wui-color-error-glass-080: rgba(242, 90, 103, 0.8);

        --wui-color-error-glass-reown-020: rgba(223, 74, 52, 0.2);

        --wui-color-gray-glass-001: rgba(255, 255, 255, 0.01);
        --wui-color-gray-glass-002: rgba(255, 255, 255, 0.02);
        --wui-color-gray-glass-005: rgba(255, 255, 255, 0.05);
        --wui-color-gray-glass-010: rgba(255, 255, 255, 0.1);
        --wui-color-gray-glass-015: rgba(255, 255, 255, 0.15);
        --wui-color-gray-glass-020: rgba(255, 255, 255, 0.2);
        --wui-color-gray-glass-025: rgba(255, 255, 255, 0.25);
        --wui-color-gray-glass-030: rgba(255, 255, 255, 0.3);
        --wui-color-gray-glass-060: rgba(255, 255, 255, 0.6);
        --wui-color-gray-glass-080: rgba(255, 255, 255, 0.8);
        --wui-color-gray-glass-090: rgba(255, 255, 255, 0.9);

        --wui-color-dark-glass-100: rgba(42, 42, 42, 1);

        --wui-icon-box-bg-error-base-100: #3c2426;
        --wui-icon-box-bg-blue-base-100: #20303f;
        --wui-icon-box-bg-success-base-100: #1f3a28;
        --wui-icon-box-bg-inverse-base-100: #243240;

        --wui-all-wallets-bg-100: #222b35;

        --wui-avatar-border-base: #252525;

        --wui-thumbnail-border-base: #252525;

        --wui-wallet-button-bg-base: var(--wui-color-bg-125);

        --w3m-card-embedded-shadow-color: rgb(17 17 18 / 25%);
      }
    `,
        dark: (0, $4QRxi.css)`
      :root {
        --w3m-color-mix: ${(0, $4QRxi.unsafeCSS)(themeVariables?.["--w3m-color-mix"] || "#000")};
        --w3m-accent: ${(0, $4QRxi.unsafeCSS)((0, $2Z0OY.getW3mThemeVariables)(themeVariables, "light")["--w3m-accent"])};
        --w3m-default: #000;

        --wui-color-modal-bg-base: ${(0, $4QRxi.unsafeCSS)((0, $2Z0OY.getW3mThemeVariables)(themeVariables, "light")["--w3m-background"])};
        --wui-color-accent-base-100: var(--w3m-accent);

        --wui-color-blueberry-100: hsla(231, 100%, 70%, 1);
        --wui-color-blueberry-090: hsla(231, 97%, 72%, 1);
        --wui-color-blueberry-080: hsla(231, 92%, 74%, 1);

        --wui-color-fg-100: #141414;
        --wui-color-fg-125: #2d3131;
        --wui-color-fg-150: #474d4d;
        --wui-color-fg-175: #636d6d;
        --wui-color-fg-200: #798686;
        --wui-color-fg-225: #828f8f;
        --wui-color-fg-250: #8b9797;
        --wui-color-fg-275: #95a0a0;
        --wui-color-fg-300: #9ea9a9;
        --wui-color-fg-325: #9a9a9a;
        --wui-color-fg-350: #d0d0d0;

        --wui-color-bg-100: #ffffff;
        --wui-color-bg-125: #f5fafa;
        --wui-color-bg-150: #f3f8f8;
        --wui-color-bg-175: #eef4f4;
        --wui-color-bg-200: #eaf1f1;
        --wui-color-bg-225: #e5eded;
        --wui-color-bg-250: #e1e9e9;
        --wui-color-bg-275: #dce7e7;
        --wui-color-bg-300: #d8e3e3;
        --wui-color-bg-325: #f3f3f3;
        --wui-color-bg-350: #202020;

        --wui-color-success-base-100: #26b562;
        --wui-color-success-base-125: #30a46b;

        --wui-color-warning-base-100: #f3a13f;

        --wui-color-error-base-100: #f05142;
        --wui-color-error-base-125: #df4a34;

        --wui-color-blue-base-100: rgba(102, 125, 255, 1);
        --wui-color-blue-base-90: rgba(102, 125, 255, 0.9);

        --wui-color-success-glass-001: rgba(38, 181, 98, 0.01);
        --wui-color-success-glass-002: rgba(38, 181, 98, 0.02);
        --wui-color-success-glass-005: rgba(38, 181, 98, 0.05);
        --wui-color-success-glass-010: rgba(38, 181, 98, 0.1);
        --wui-color-success-glass-015: rgba(38, 181, 98, 0.15);
        --wui-color-success-glass-020: rgba(38, 181, 98, 0.2);
        --wui-color-success-glass-025: rgba(38, 181, 98, 0.25);
        --wui-color-success-glass-030: rgba(38, 181, 98, 0.3);
        --wui-color-success-glass-060: rgba(38, 181, 98, 0.6);
        --wui-color-success-glass-080: rgba(38, 181, 98, 0.8);

        --wui-color-success-glass-reown-020: rgba(48, 164, 107, 0.2);

        --wui-color-warning-glass-reown-020: rgba(243, 161, 63, 0.2);

        --wui-color-error-glass-001: rgba(240, 81, 66, 0.01);
        --wui-color-error-glass-002: rgba(240, 81, 66, 0.02);
        --wui-color-error-glass-005: rgba(240, 81, 66, 0.05);
        --wui-color-error-glass-010: rgba(240, 81, 66, 0.1);
        --wui-color-error-glass-015: rgba(240, 81, 66, 0.15);
        --wui-color-error-glass-020: rgba(240, 81, 66, 0.2);
        --wui-color-error-glass-025: rgba(240, 81, 66, 0.25);
        --wui-color-error-glass-030: rgba(240, 81, 66, 0.3);
        --wui-color-error-glass-060: rgba(240, 81, 66, 0.6);
        --wui-color-error-glass-080: rgba(240, 81, 66, 0.8);

        --wui-color-error-glass-reown-020: rgba(223, 74, 52, 0.2);

        --wui-icon-box-bg-error-base-100: #f4dfdd;
        --wui-icon-box-bg-blue-base-100: #d9ecfb;
        --wui-icon-box-bg-success-base-100: #daf0e4;
        --wui-icon-box-bg-inverse-base-100: #dcecfc;

        --wui-all-wallets-bg-100: #e8f1fa;

        --wui-avatar-border-base: #f3f4f4;

        --wui-thumbnail-border-base: #eaefef;

        --wui-wallet-button-bg-base: var(--wui-color-bg-125);

        --wui-color-gray-glass-001: rgba(0, 0, 0, 0.01);
        --wui-color-gray-glass-002: rgba(0, 0, 0, 0.02);
        --wui-color-gray-glass-005: rgba(0, 0, 0, 0.05);
        --wui-color-gray-glass-010: rgba(0, 0, 0, 0.1);
        --wui-color-gray-glass-015: rgba(0, 0, 0, 0.15);
        --wui-color-gray-glass-020: rgba(0, 0, 0, 0.2);
        --wui-color-gray-glass-025: rgba(0, 0, 0, 0.25);
        --wui-color-gray-glass-030: rgba(0, 0, 0, 0.3);
        --wui-color-gray-glass-060: rgba(0, 0, 0, 0.6);
        --wui-color-gray-glass-080: rgba(0, 0, 0, 0.8);
        --wui-color-gray-glass-090: rgba(0, 0, 0, 0.9);

        --wui-color-dark-glass-100: rgba(233, 233, 233, 1);

        --w3m-card-embedded-shadow-color: rgb(224 225 233 / 25%);
      }
    `
    };
}
const $bf55ef56e9436a28$export$6b6f359a824920a4 = (0, $4QRxi.css)`
  *,
  *::after,
  *::before,
  :host {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-style: normal;
    text-rendering: optimizeSpeed;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: transparent;
    font-family: var(--wui-font-family);
    backface-visibility: hidden;
  }
`;
const $bf55ef56e9436a28$export$e7ba49a1dbca65c7 = (0, $4QRxi.css)`
  button,
  a {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    transition:
      color var(--wui-duration-lg) var(--wui-ease-out-power-1),
      background-color var(--wui-duration-lg) var(--wui-ease-out-power-1),
      border var(--wui-duration-lg) var(--wui-ease-out-power-1),
      border-radius var(--wui-duration-lg) var(--wui-ease-out-power-1),
      box-shadow var(--wui-duration-lg) var(--wui-ease-out-power-1);
    will-change: background-color, color, border, box-shadow, border-radius;
    outline: none;
    border: none;
    column-gap: var(--wui-spacing-3xs);
    background-color: transparent;
    text-decoration: none;
  }

  wui-flex {
    transition: border-radius var(--wui-duration-lg) var(--wui-ease-out-power-1);
    will-change: border-radius;
  }

  button:disabled > wui-wallet-image,
  button:disabled > wui-all-wallets-image,
  button:disabled > wui-network-image,
  button:disabled > wui-image,
  button:disabled > wui-transaction-visual,
  button:disabled > wui-logo {
    filter: grayscale(1);
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-color-gray-glass-005);
    }

    button:active:enabled {
      background-color: var(--wui-color-gray-glass-010);
    }
  }

  button:disabled > wui-icon-box {
    opacity: 0.5;
  }

  input {
    border: none;
    outline: none;
    appearance: none;
  }
`;
const $bf55ef56e9436a28$export$ab44001f5690ee9c = (0, $4QRxi.css)`
  .wui-color-inherit {
    color: var(--wui-color-inherit);
  }

  .wui-color-accent-100 {
    color: var(--wui-color-accent-100);
  }

  .wui-color-error-100 {
    color: var(--wui-color-error-100);
  }

  .wui-color-blue-100 {
    color: var(--wui-color-blue-100);
  }

  .wui-color-blue-90 {
    color: var(--wui-color-blue-90);
  }

  .wui-color-error-125 {
    color: var(--wui-color-error-125);
  }

  .wui-color-success-100 {
    color: var(--wui-color-success-100);
  }

  .wui-color-success-125 {
    color: var(--wui-color-success-125);
  }

  .wui-color-inverse-100 {
    color: var(--wui-color-inverse-100);
  }

  .wui-color-inverse-000 {
    color: var(--wui-color-inverse-000);
  }

  .wui-color-fg-100 {
    color: var(--wui-color-fg-100);
  }

  .wui-color-fg-200 {
    color: var(--wui-color-fg-200);
  }

  .wui-color-fg-300 {
    color: var(--wui-color-fg-300);
  }

  .wui-color-fg-325 {
    color: var(--wui-color-fg-325);
  }

  .wui-color-fg-350 {
    color: var(--wui-color-fg-350);
  }

  .wui-bg-color-inherit {
    background-color: var(--wui-color-inherit);
  }

  .wui-bg-color-blue-100 {
    background-color: var(--wui-color-accent-100);
  }

  .wui-bg-color-error-100 {
    background-color: var(--wui-color-error-100);
  }

  .wui-bg-color-error-125 {
    background-color: var(--wui-color-error-125);
  }

  .wui-bg-color-success-100 {
    background-color: var(--wui-color-success-100);
  }

  .wui-bg-color-success-125 {
    background-color: var(--wui-color-success-100);
  }

  .wui-bg-color-inverse-100 {
    background-color: var(--wui-color-inverse-100);
  }

  .wui-bg-color-inverse-000 {
    background-color: var(--wui-color-inverse-000);
  }

  .wui-bg-color-fg-100 {
    background-color: var(--wui-color-fg-100);
  }

  .wui-bg-color-fg-200 {
    background-color: var(--wui-color-fg-200);
  }

  .wui-bg-color-fg-300 {
    background-color: var(--wui-color-fg-300);
  }

  .wui-color-fg-325 {
    background-color: var(--wui-color-fg-325);
  }

  .wui-color-fg-350 {
    background-color: var(--wui-color-fg-350);
  }
`;

});
parcelRegister("lD8FA", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("4QRxi")).css);
$parcel$export(module.exports, "html", () => (parcelRequire("1DiKN")).html);
$parcel$export(module.exports, "LitElement", () => (parcelRequire("heFbZ")).LitElement);
$parcel$export(module.exports, "svg", () => (parcelRequire("1DiKN")).svg);
$parcel$export(module.exports, "unsafeCSS", () => (parcelRequire("4QRxi")).unsafeCSS);
parcelRequire("8Rylu");
parcelRequire("1DiKN");
parcelRequire("heFbZ");
parcelRequire("5aLBB");

});
parcelRegister("8Rylu", function(module, exports) {

$parcel$export(module.exports, "defaultConverter", () => $673dea490bdcda04$export$7312b35fbf521afb);
$parcel$export(module.exports, "notEqual", () => $673dea490bdcda04$export$53a6892c50694894);
$parcel$export(module.exports, "ReactiveElement", () => $673dea490bdcda04$export$c7c07a37856565d);
$parcel$export(module.exports, "css", () => (parcelRequire("4QRxi")).css);
$parcel$export(module.exports, "unsafeCSS", () => (parcelRequire("4QRxi")).unsafeCSS);

var $4QRxi = parcelRequire("4QRxi");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $673dea490bdcda04$var$i, defineProperty: $673dea490bdcda04$var$e, getOwnPropertyDescriptor: $673dea490bdcda04$var$h, getOwnPropertyNames: $673dea490bdcda04$var$r, getOwnPropertySymbols: $673dea490bdcda04$var$o, getPrototypeOf: $673dea490bdcda04$var$n } = Object, $673dea490bdcda04$var$a = globalThis, $673dea490bdcda04$var$c = $673dea490bdcda04$var$a.trustedTypes, $673dea490bdcda04$var$l = $673dea490bdcda04$var$c ? $673dea490bdcda04$var$c.emptyScript : "", $673dea490bdcda04$var$p = $673dea490bdcda04$var$a.reactiveElementPolyfillSupport, $673dea490bdcda04$var$d = (t, s)=>t, $673dea490bdcda04$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $673dea490bdcda04$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $673dea490bdcda04$export$53a6892c50694894 = (t, s)=>!$673dea490bdcda04$var$i(t, s), $673dea490bdcda04$var$b = {
    attribute: !0,
    type: String,
    converter: $673dea490bdcda04$export$7312b35fbf521afb,
    reflect: !1,
    useDefault: !1,
    hasChanged: $673dea490bdcda04$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $673dea490bdcda04$var$a.litPropertyMetadata ??= new WeakMap;
class $673dea490bdcda04$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $673dea490bdcda04$var$b) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((s = Object.create(s)).wrapped = !0), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), h = this.getPropertyDescriptor(t, i, s);
            void 0 !== h && $673dea490bdcda04$var$e(this.prototype, t, h);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: r } = $673dea490bdcda04$var$h(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get: e,
            set (s) {
                const h = e?.call(this);
                r?.call(this, s), this.requestUpdate(t, h, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $673dea490bdcda04$var$b;
    }
    static _$Ei() {
        if (this.hasOwnProperty($673dea490bdcda04$var$d("elementProperties"))) return;
        const t = $673dea490bdcda04$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($673dea490bdcda04$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($673dea490bdcda04$var$d("properties"))) {
            const t = this.properties, s = [
                ...$673dea490bdcda04$var$r(t),
                ...$673dea490bdcda04$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $4QRxi.getCompatibleStyle)(s));
        } else void 0 !== s && i.push((0, $4QRxi.getCompatibleStyle)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $4QRxi.adoptStyles)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$ET(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const h = (void 0 !== i.converter?.toAttribute ? i.converter : $673dea490bdcda04$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == h ? this.removeAttribute(e) : this.setAttribute(e, h), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $673dea490bdcda04$export$7312b35fbf521afb;
            this._$Em = e, this[e] = h.fromAttribute(s, t.type) ?? this._$Ej?.get(e) ?? null, this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            const e = this.constructor, h = this[t];
            if (i ??= e.getPropertyOptions(t), !((i.hasChanged ?? $673dea490bdcda04$export$53a6892c50694894)(h, s) || i.useDefault && i.reflect && h === this._$Ej?.get(t) && !this.hasAttribute(e._$Eu(t, i)))) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(t, s, { useDefault: i, reflect: e, wrapped: h }, r) {
        i && !(this._$Ej ??= new Map).has(t) && (this._$Ej.set(t, r ?? s ?? this[t]), !0 !== h || void 0 !== r) || (this._$AL.has(t) || (this.hasUpdated || i || (s = void 0), this._$AL.set(t, s)), !0 === e && this._$Em !== t && (this._$Eq ??= new Set).add(t));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t){
                const { wrapped: t } = i, e = this[s];
                !0 !== t || this._$AL.has(s) || void 0 === e || this.C(s, void 0, i, e);
            }
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EM();
        } catch (s) {
            throw t = !1, this._$EM(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Eq &&= this._$Eq.forEach((t)=>this._$ET(t, this[t])), this._$EM();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$673dea490bdcda04$export$c7c07a37856565d.elementStyles = [], $673dea490bdcda04$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $673dea490bdcda04$export$c7c07a37856565d[$673dea490bdcda04$var$d("elementProperties")] = new Map, $673dea490bdcda04$export$c7c07a37856565d[$673dea490bdcda04$var$d("finalized")] = new Map, $673dea490bdcda04$var$p?.({
    ReactiveElement: $673dea490bdcda04$export$c7c07a37856565d
}), ($673dea490bdcda04$var$a.reactiveElementVersions ??= []).push("2.1.0");

});
parcelRegister("4QRxi", function(module, exports) {

$parcel$export(module.exports, "unsafeCSS", () => $38858be757a8a56a$export$8d80f9cac07cdb3);
$parcel$export(module.exports, "css", () => $38858be757a8a56a$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $38858be757a8a56a$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $38858be757a8a56a$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $38858be757a8a56a$var$t = globalThis, $38858be757a8a56a$export$b4d10f6001c083c2 = $38858be757a8a56a$var$t.ShadowRoot && (void 0 === $38858be757a8a56a$var$t.ShadyCSS || $38858be757a8a56a$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $38858be757a8a56a$var$s = Symbol(), $38858be757a8a56a$var$o = new WeakMap;
class $38858be757a8a56a$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $38858be757a8a56a$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($38858be757a8a56a$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $38858be757a8a56a$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $38858be757a8a56a$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $38858be757a8a56a$export$8d80f9cac07cdb3 = (t)=>new $38858be757a8a56a$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $38858be757a8a56a$var$s), $38858be757a8a56a$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $38858be757a8a56a$export$505d1e8739bad805(o, t, $38858be757a8a56a$var$s);
}, $38858be757a8a56a$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($38858be757a8a56a$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $38858be757a8a56a$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $38858be757a8a56a$export$ee69dfd951e24778 = $38858be757a8a56a$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $38858be757a8a56a$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("1DiKN", function(module, exports) {

$parcel$export(module.exports, "html", () => $1307fb0f027f8f54$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "svg", () => $1307fb0f027f8f54$export$7ed1367e7fa1ad68);
$parcel$export(module.exports, "noChange", () => $1307fb0f027f8f54$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "nothing", () => $1307fb0f027f8f54$export$45b790e32b2810ee);
$parcel$export(module.exports, "_$LH", () => $1307fb0f027f8f54$export$8613d1ca9052b22e);
$parcel$export(module.exports, "render", () => $1307fb0f027f8f54$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $1307fb0f027f8f54$var$t = globalThis, $1307fb0f027f8f54$var$i = $1307fb0f027f8f54$var$t.trustedTypes, $1307fb0f027f8f54$var$s = $1307fb0f027f8f54$var$i ? $1307fb0f027f8f54$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $1307fb0f027f8f54$var$e = "$lit$", $1307fb0f027f8f54$var$h = `lit$${Math.random().toFixed(9).slice(2)}$`, $1307fb0f027f8f54$var$o = "?" + $1307fb0f027f8f54$var$h, $1307fb0f027f8f54$var$n = `<${$1307fb0f027f8f54$var$o}>`, $1307fb0f027f8f54$var$r = document, $1307fb0f027f8f54$var$l = ()=>$1307fb0f027f8f54$var$r.createComment(""), $1307fb0f027f8f54$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $1307fb0f027f8f54$var$a = Array.isArray, $1307fb0f027f8f54$var$u = (t)=>$1307fb0f027f8f54$var$a(t) || "function" == typeof t?.[Symbol.iterator], $1307fb0f027f8f54$var$d = "[ 	\n\f\r]", $1307fb0f027f8f54$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $1307fb0f027f8f54$var$v = /-->/g, $1307fb0f027f8f54$var$_ = />/g, $1307fb0f027f8f54$var$m = RegExp(`>|${$1307fb0f027f8f54$var$d}(?:([^\\s"'>=/]+)(${$1307fb0f027f8f54$var$d}*=${$1307fb0f027f8f54$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $1307fb0f027f8f54$var$p = /'/g, $1307fb0f027f8f54$var$g = /"/g, $1307fb0f027f8f54$var$$ = /^(?:script|style|textarea|title)$/i, $1307fb0f027f8f54$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $1307fb0f027f8f54$export$c0bb0b647f701bb5 = $1307fb0f027f8f54$var$y(1), $1307fb0f027f8f54$export$7ed1367e7fa1ad68 = $1307fb0f027f8f54$var$y(2), $1307fb0f027f8f54$export$47d5b44d225be5b4 = $1307fb0f027f8f54$var$y(3), $1307fb0f027f8f54$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $1307fb0f027f8f54$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $1307fb0f027f8f54$var$A = new WeakMap, $1307fb0f027f8f54$var$C = $1307fb0f027f8f54$var$r.createTreeWalker($1307fb0f027f8f54$var$r, 129);
function $1307fb0f027f8f54$var$P(t, i) {
    if (!$1307fb0f027f8f54$var$a(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $1307fb0f027f8f54$var$s ? $1307fb0f027f8f54$var$s.createHTML(i) : i;
}
const $1307fb0f027f8f54$var$V = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $1307fb0f027f8f54$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $1307fb0f027f8f54$var$f ? "!--" === u[1] ? c = $1307fb0f027f8f54$var$v : void 0 !== u[1] ? c = $1307fb0f027f8f54$var$_ : void 0 !== u[2] ? ($1307fb0f027f8f54$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $1307fb0f027f8f54$var$m) : void 0 !== u[3] && (c = $1307fb0f027f8f54$var$m) : c === $1307fb0f027f8f54$var$m ? ">" === u[0] ? (c = r ?? $1307fb0f027f8f54$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $1307fb0f027f8f54$var$m : '"' === u[3] ? $1307fb0f027f8f54$var$g : $1307fb0f027f8f54$var$p) : c === $1307fb0f027f8f54$var$g || c === $1307fb0f027f8f54$var$p ? c = $1307fb0f027f8f54$var$m : c === $1307fb0f027f8f54$var$v || c === $1307fb0f027f8f54$var$_ ? c = $1307fb0f027f8f54$var$f : (c = $1307fb0f027f8f54$var$m, r = void 0);
        const x = c === $1307fb0f027f8f54$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $1307fb0f027f8f54$var$f ? s + $1307fb0f027f8f54$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $1307fb0f027f8f54$var$e + s.slice(d) + $1307fb0f027f8f54$var$h + x) : s + $1307fb0f027f8f54$var$h + (-2 === d ? i : x);
    }
    return [
        $1307fb0f027f8f54$var$P(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        o
    ];
};
class $1307fb0f027f8f54$var$N {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $1307fb0f027f8f54$var$V(t, s);
        if (this.el = $1307fb0f027f8f54$var$N.createElement(f, n), $1307fb0f027f8f54$var$C.currentNode = this.el.content, 2 === s || 3 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $1307fb0f027f8f54$var$C.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($1307fb0f027f8f54$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($1307fb0f027f8f54$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $1307fb0f027f8f54$var$H : "?" === e[1] ? $1307fb0f027f8f54$var$I : "@" === e[1] ? $1307fb0f027f8f54$var$L : $1307fb0f027f8f54$var$k
                    }), r.removeAttribute(t);
                } else t.startsWith($1307fb0f027f8f54$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($1307fb0f027f8f54$var$$.test(r.tagName)) {
                    const t = r.textContent.split($1307fb0f027f8f54$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $1307fb0f027f8f54$var$i ? $1307fb0f027f8f54$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $1307fb0f027f8f54$var$l()), $1307fb0f027f8f54$var$C.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $1307fb0f027f8f54$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $1307fb0f027f8f54$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($1307fb0f027f8f54$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $1307fb0f027f8f54$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $1307fb0f027f8f54$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $1307fb0f027f8f54$var$S(t, i, s = t, e) {
    if (i === $1307fb0f027f8f54$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $1307fb0f027f8f54$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $1307fb0f027f8f54$var$S(t, h._$AS(t, i.values), h, e)), i;
}
class $1307fb0f027f8f54$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $1307fb0f027f8f54$var$r).importNode(i, !0);
        $1307fb0f027f8f54$var$C.currentNode = e;
        let h = $1307fb0f027f8f54$var$C.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $1307fb0f027f8f54$var$R(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $1307fb0f027f8f54$var$z(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $1307fb0f027f8f54$var$C.nextNode(), o++);
        }
        return $1307fb0f027f8f54$var$C.currentNode = $1307fb0f027f8f54$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $1307fb0f027f8f54$var$R {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $1307fb0f027f8f54$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $1307fb0f027f8f54$var$S(this, t, i), $1307fb0f027f8f54$var$c(t) ? t === $1307fb0f027f8f54$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $1307fb0f027f8f54$export$45b790e32b2810ee && this._$AR(), this._$AH = $1307fb0f027f8f54$export$45b790e32b2810ee) : t !== this._$AH && t !== $1307fb0f027f8f54$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $1307fb0f027f8f54$var$u(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $1307fb0f027f8f54$export$45b790e32b2810ee && $1307fb0f027f8f54$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($1307fb0f027f8f54$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $1307fb0f027f8f54$var$N.createElement($1307fb0f027f8f54$var$P(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $1307fb0f027f8f54$var$M(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $1307fb0f027f8f54$var$A.get(t.strings);
        return void 0 === i && $1307fb0f027f8f54$var$A.set(t.strings, i = new $1307fb0f027f8f54$var$N(t)), i;
    }
    k(t) {
        $1307fb0f027f8f54$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $1307fb0f027f8f54$var$R(this.O($1307fb0f027f8f54$var$l()), this.O($1307fb0f027f8f54$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $1307fb0f027f8f54$var$k {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $1307fb0f027f8f54$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $1307fb0f027f8f54$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $1307fb0f027f8f54$var$S(this, t, i, 0), o = !$1307fb0f027f8f54$var$c(t) || t !== this._$AH && t !== $1307fb0f027f8f54$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $1307fb0f027f8f54$var$S(this, e[s + n], i, n), r === $1307fb0f027f8f54$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$1307fb0f027f8f54$var$c(r) || r !== this._$AH[n], r === $1307fb0f027f8f54$export$45b790e32b2810ee ? t = $1307fb0f027f8f54$export$45b790e32b2810ee : t !== $1307fb0f027f8f54$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $1307fb0f027f8f54$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $1307fb0f027f8f54$var$H extends $1307fb0f027f8f54$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $1307fb0f027f8f54$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $1307fb0f027f8f54$var$I extends $1307fb0f027f8f54$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $1307fb0f027f8f54$export$45b790e32b2810ee);
    }
}
class $1307fb0f027f8f54$var$L extends $1307fb0f027f8f54$var$k {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $1307fb0f027f8f54$var$S(this, t, i, 0) ?? $1307fb0f027f8f54$export$45b790e32b2810ee) === $1307fb0f027f8f54$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $1307fb0f027f8f54$export$45b790e32b2810ee && s !== $1307fb0f027f8f54$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $1307fb0f027f8f54$export$45b790e32b2810ee && (s === $1307fb0f027f8f54$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $1307fb0f027f8f54$var$z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $1307fb0f027f8f54$var$S(this, t);
    }
}
const $1307fb0f027f8f54$export$8613d1ca9052b22e = {
    M: $1307fb0f027f8f54$var$e,
    P: $1307fb0f027f8f54$var$h,
    A: $1307fb0f027f8f54$var$o,
    C: 1,
    L: $1307fb0f027f8f54$var$V,
    R: $1307fb0f027f8f54$var$M,
    D: $1307fb0f027f8f54$var$u,
    V: $1307fb0f027f8f54$var$S,
    I: $1307fb0f027f8f54$var$R,
    H: $1307fb0f027f8f54$var$k,
    N: $1307fb0f027f8f54$var$I,
    U: $1307fb0f027f8f54$var$L,
    B: $1307fb0f027f8f54$var$H,
    F: $1307fb0f027f8f54$var$z
}, $1307fb0f027f8f54$var$j = $1307fb0f027f8f54$var$t.litHtmlPolyfillSupport;
$1307fb0f027f8f54$var$j?.($1307fb0f027f8f54$var$N, $1307fb0f027f8f54$var$R), ($1307fb0f027f8f54$var$t.litHtmlVersions ??= []).push("3.3.0");
const $1307fb0f027f8f54$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $1307fb0f027f8f54$var$R(i.insertBefore($1307fb0f027f8f54$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

});

parcelRegister("heFbZ", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("4QRxi")).css);
$parcel$export(module.exports, "ReactiveElement", () => (parcelRequire("8Rylu")).ReactiveElement);
$parcel$export(module.exports, "unsafeCSS", () => (parcelRequire("4QRxi")).unsafeCSS);
$parcel$export(module.exports, "html", () => (parcelRequire("1DiKN")).html);
$parcel$export(module.exports, "noChange", () => (parcelRequire("1DiKN")).noChange);
$parcel$export(module.exports, "render", () => (parcelRequire("1DiKN")).render);
$parcel$export(module.exports, "svg", () => (parcelRequire("1DiKN")).svg);

$parcel$export(module.exports, "LitElement", () => $c8c3b2705326b895$export$3f2f9f5909897157);

var $8Rylu = parcelRequire("8Rylu");

var $1DiKN = parcelRequire("1DiKN");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $c8c3b2705326b895$var$s = globalThis;
class $c8c3b2705326b895$export$3f2f9f5909897157 extends (0, $8Rylu.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const r = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $1DiKN.render)(r, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $1DiKN.noChange;
    }
}
$c8c3b2705326b895$export$3f2f9f5909897157._$litElement$ = !0, $c8c3b2705326b895$export$3f2f9f5909897157["finalized"] = !0, $c8c3b2705326b895$var$s.litElementHydrateSupport?.({
    LitElement: $c8c3b2705326b895$export$3f2f9f5909897157
});
const $c8c3b2705326b895$var$o = $c8c3b2705326b895$var$s.litElementPolyfillSupport;
$c8c3b2705326b895$var$o?.({
    LitElement: $c8c3b2705326b895$export$3f2f9f5909897157
});
const $c8c3b2705326b895$export$f5c524615a7708d6 = {
    _$AK: (t, e, r)=>{
        t._$AK(e, r);
    },
    _$AL: (t)=>t._$AL
};
($c8c3b2705326b895$var$s.litElementVersions ??= []).push("4.2.0");

});

parcelRegister("5aLBB", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3c42d05ff88fe888$export$6acf61af03e62db = !1;

});



parcelRegister("8f1DU", function(module, exports) {

$parcel$export(module.exports, "UiHelperUtil", () => $6000ffa3a9ec431d$export$be769b74c01bc1bc);
const $6000ffa3a9ec431d$export$be769b74c01bc1bc = {
    getSpacingStyles (spacing, index) {
        if (Array.isArray(spacing)) return spacing[index] ? `var(--wui-spacing-${spacing[index]})` : undefined;
        else if (typeof spacing === "string") return `var(--wui-spacing-${spacing})`;
        return undefined;
    },
    getFormattedDate (date) {
        return new Intl.DateTimeFormat("en-US", {
            month: "short",
            day: "numeric"
        }).format(date);
    },
    getHostName (url) {
        try {
            const newUrl = new URL(url);
            return newUrl.hostname;
        } catch (error) {
            return "";
        }
    },
    getTruncateString ({ string: string, charsStart: charsStart, charsEnd: charsEnd, truncate: truncate }) {
        if (string.length <= charsStart + charsEnd) return string;
        if (truncate === "end") return `${string.substring(0, charsStart)}...`;
        else if (truncate === "start") return `...${string.substring(string.length - charsEnd)}`;
        return `${string.substring(0, Math.floor(charsStart))}...${string.substring(string.length - Math.floor(charsEnd))}`;
    },
    generateAvatarColors (address) {
        const hash = address.toLowerCase().replace(/^0x/iu, "").replace(/[^a-f0-9]/gu, "");
        const baseColor = hash.substring(0, 6).padEnd(6, "0");
        const rgbColor = this.hexToRgb(baseColor);
        const masterBorderRadius = getComputedStyle(document.documentElement).getPropertyValue("--w3m-border-radius-master");
        const radius = Number(masterBorderRadius?.replace("px", ""));
        const edge = 100 - 3 * radius;
        const gradientCircle = `${edge}% ${edge}% at 65% 40%`;
        const colors = [];
        for(let i = 0; i < 5; i += 1){
            const tintedColor = this.tintColor(rgbColor, 0.15 * i);
            colors.push(`rgb(${tintedColor[0]}, ${tintedColor[1]}, ${tintedColor[2]})`);
        }
        return `
    --local-color-1: ${colors[0]};
    --local-color-2: ${colors[1]};
    --local-color-3: ${colors[2]};
    --local-color-4: ${colors[3]};
    --local-color-5: ${colors[4]};
    --local-radial-circle: ${gradientCircle}
   `;
    },
    hexToRgb (hex) {
        const bigint = parseInt(hex, 16);
        const r = bigint >> 16 & 255;
        const g = bigint >> 8 & 255;
        const b = bigint & 255;
        return [
            r,
            g,
            b
        ];
    },
    tintColor (rgb, tint) {
        const [r, g, b] = rgb;
        const tintedR = Math.round(r + (255 - r) * tint);
        const tintedG = Math.round(g + (255 - g) * tint);
        const tintedB = Math.round(b + (255 - b) * tint);
        return [
            tintedR,
            tintedG,
            tintedB
        ];
    },
    isNumber (character) {
        const regex = {
            number: /^[0-9]+$/u
        };
        return regex.number.test(character);
    },
    getColorTheme (theme) {
        if (theme) return theme;
        else if (typeof window !== "undefined" && window.matchMedia) {
            if (window.matchMedia("(prefers-color-scheme: dark)")?.matches) return "dark";
            return "light";
        }
        return "dark";
    },
    splitBalance (input) {
        const parts = input.split(".");
        if (parts.length === 2) return [
            parts[0],
            parts[1]
        ];
        return [
            "0",
            "00"
        ];
    },
    roundNumber (number, threshold, fixed) {
        const roundedNumber = number.toString().length >= threshold ? Number(number).toFixed(fixed) : number;
        return roundedNumber;
    },
    formatNumberToLocalString (value, decimals = 2) {
        if (value === undefined) return "0.00";
        if (typeof value === "number") return value.toLocaleString("en-US", {
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals
        });
        return parseFloat(value).toLocaleString("en-US", {
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals
        });
    }
};

});

parcelRegister("cj4sB", function(module, exports) {

$parcel$export(module.exports, "TransactionUtil", () => $8f5ab81c8a766fa5$export$445ed8d5992cc5e0);

var $l75MI = parcelRequire("l75MI");

var $8f1DU = parcelRequire("8f1DU");
const $8f5ab81c8a766fa5$var$FLOAT_FIXED_VALUE = 3;
const $8f5ab81c8a766fa5$var$plusTypes = [
    "receive",
    "deposit",
    "borrow",
    "claim"
];
const $8f5ab81c8a766fa5$var$minusTypes = [
    "withdraw",
    "repay",
    "burn"
];
const $8f5ab81c8a766fa5$export$445ed8d5992cc5e0 = {
    getTransactionGroupTitle (year, month) {
        const currentYear = (0, $l75MI.DateUtil).getYear();
        const monthName = (0, $l75MI.DateUtil).getMonthNameByIndex(month);
        const isCurrentYear = year === currentYear;
        const groupTitle = isCurrentYear ? monthName : `${monthName} ${year}`;
        return groupTitle;
    },
    getTransactionImages (transfers) {
        const [transfer, secondTransfer] = transfers;
        const isAllNFT = Boolean(transfer) && transfers?.every((item)=>Boolean(item.nft_info));
        const haveMultipleTransfers = transfers?.length > 1;
        const haveTwoTransfers = transfers?.length === 2;
        if (haveTwoTransfers && !isAllNFT) return [
            this.getTransactionImage(transfer),
            this.getTransactionImage(secondTransfer)
        ];
        if (haveMultipleTransfers) return transfers.map((item)=>this.getTransactionImage(item));
        return [
            this.getTransactionImage(transfer)
        ];
    },
    getTransactionImage (transfer) {
        return {
            type: $8f5ab81c8a766fa5$export$445ed8d5992cc5e0.getTransactionTransferTokenType(transfer),
            url: $8f5ab81c8a766fa5$export$445ed8d5992cc5e0.getTransactionImageURL(transfer)
        };
    },
    getTransactionImageURL (transfer) {
        let imageURL = undefined;
        const isNFT = Boolean(transfer?.nft_info);
        const isFungible = Boolean(transfer?.fungible_info);
        if (transfer && isNFT) imageURL = transfer?.nft_info?.content?.preview?.url;
        else if (transfer && isFungible) imageURL = transfer?.fungible_info?.icon?.url;
        return imageURL;
    },
    getTransactionTransferTokenType (transfer) {
        if (transfer?.fungible_info) return "FUNGIBLE";
        else if (transfer?.nft_info) return "NFT";
        return undefined;
    },
    getTransactionDescriptions (transaction) {
        const type = transaction?.metadata?.operationType;
        const transfers = transaction?.transfers;
        const haveTransfer = transaction?.transfers?.length > 0;
        const haveMultipleTransfers = transaction?.transfers?.length > 1;
        const isFungible = haveTransfer && transfers?.every((transfer)=>Boolean(transfer?.fungible_info));
        const [firstTransfer, secondTransfer] = transfers;
        let firstDescription = this.getTransferDescription(firstTransfer);
        let secondDescription = this.getTransferDescription(secondTransfer);
        if (!haveTransfer) {
            const isSendOrReceive = type === "send" || type === "receive";
            if (isSendOrReceive && isFungible) {
                firstDescription = (0, $8f1DU.UiHelperUtil).getTruncateString({
                    string: transaction?.metadata.sentFrom,
                    charsStart: 4,
                    charsEnd: 6,
                    truncate: "middle"
                });
                secondDescription = (0, $8f1DU.UiHelperUtil).getTruncateString({
                    string: transaction?.metadata.sentTo,
                    charsStart: 4,
                    charsEnd: 6,
                    truncate: "middle"
                });
                return [
                    firstDescription,
                    secondDescription
                ];
            }
            return [
                transaction.metadata.status
            ];
        }
        if (haveMultipleTransfers) return transfers.map((item)=>this.getTransferDescription(item));
        let prefix = "";
        if ($8f5ab81c8a766fa5$var$plusTypes.includes(type)) prefix = "+";
        else if ($8f5ab81c8a766fa5$var$minusTypes.includes(type)) prefix = "-";
        firstDescription = prefix.concat(firstDescription);
        return [
            firstDescription
        ];
    },
    getTransferDescription (transfer) {
        let description = "";
        if (!transfer) return description;
        if (transfer?.nft_info) description = transfer?.nft_info?.name || "-";
        else if (transfer?.fungible_info) description = this.getFungibleTransferDescription(transfer) || "-";
        return description;
    },
    getFungibleTransferDescription (transfer) {
        if (!transfer) return null;
        const quantity = this.getQuantityFixedValue(transfer?.quantity.numeric);
        const description = [
            quantity,
            transfer?.fungible_info?.symbol
        ].join(" ").trim();
        return description;
    },
    getQuantityFixedValue (value) {
        if (!value) return null;
        const parsedValue = parseFloat(value);
        return parsedValue.toFixed($8f5ab81c8a766fa5$var$FLOAT_FIXED_VALUE);
    }
};

});
parcelRegister("l75MI", function(module, exports) {

$parcel$export(module.exports, "DateUtil", () => $f5eebd27e01871d6$export$9b575f14aa5e09a1);

var $jDavk = parcelRequire("jDavk");

var $5U086 = parcelRequire("5U086");

var $gNqjc = parcelRequire("gNqjc");

var $iERD9 = parcelRequire("iERD9");
(0, (/*@__PURE__*/$parcel$interopDefault($jDavk))).extend((0, (/*@__PURE__*/$parcel$interopDefault($gNqjc))));
(0, (/*@__PURE__*/$parcel$interopDefault($jDavk))).extend((0, (/*@__PURE__*/$parcel$interopDefault($iERD9))));
const $f5eebd27e01871d6$var$localeObject = {
    ...(0, (/*@__PURE__*/$parcel$interopDefault($5U086))),
    name: "en-web3-modal",
    relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "%d sec",
        m: "1 min",
        mm: "%d min",
        h: "1 hr",
        hh: "%d hrs",
        d: "1 d",
        dd: "%d d",
        M: "1 mo",
        MM: "%d mo",
        y: "1 yr",
        yy: "%d yr"
    }
};
const $f5eebd27e01871d6$var$MONTH_NAMES = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
(0, (/*@__PURE__*/$parcel$interopDefault($jDavk))).locale("en-web3-modal", $f5eebd27e01871d6$var$localeObject);
const $f5eebd27e01871d6$export$9b575f14aa5e09a1 = {
    getMonthNameByIndex (monthIndex) {
        return $f5eebd27e01871d6$var$MONTH_NAMES[monthIndex];
    },
    getYear (date = new Date().toISOString()) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jDavk)))(date).year();
    },
    getRelativeDateFromNow (date) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jDavk)))(date).locale("en-web3-modal").fromNow(true);
    },
    formatDate (date, format = "DD MMM") {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jDavk)))(date).format(format);
    }
};

});
parcelRegister("jDavk", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("5U086", function(module, exports) {
!function(e, n) {
    module.exports = n();
}(module.exports, function() {
    "use strict";
    return {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(e) {
            var n = [
                "th",
                "st",
                "nd",
                "rd"
            ], t = e % 100;
            return "[" + e + (n[(t - 20) % 10] || n[t] || n[0]) + "]";
        }
    };
});

});

parcelRegister("gNqjc", function(module, exports) {
!function(r, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    return function(r, e, t) {
        r = r || {};
        var n = e.prototype, o = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        };
        function i(r, e, t, o) {
            return n.fromToBase(r, e, t, o);
        }
        t.en.relativeTime = o, n.fromToBase = function(e, n, i, d, u) {
            for(var f, a, s, l = i.$locale().relativeTime || o, h = r.thresholds || [
                {
                    l: "s",
                    r: 44,
                    d: "second"
                },
                {
                    l: "m",
                    r: 89
                },
                {
                    l: "mm",
                    r: 44,
                    d: "minute"
                },
                {
                    l: "h",
                    r: 89
                },
                {
                    l: "hh",
                    r: 21,
                    d: "hour"
                },
                {
                    l: "d",
                    r: 35
                },
                {
                    l: "dd",
                    r: 25,
                    d: "day"
                },
                {
                    l: "M",
                    r: 45
                },
                {
                    l: "MM",
                    r: 10,
                    d: "month"
                },
                {
                    l: "y",
                    r: 17
                },
                {
                    l: "yy",
                    d: "year"
                }
            ], m = h.length, c = 0; c < m; c += 1){
                var y = h[c];
                y.d && (f = d ? t(e).diff(i, y.d, !0) : i.diff(e, y.d, !0));
                var p = (r.rounding || Math.round)(Math.abs(f));
                if (s = f > 0, p <= y.r || !y.r) {
                    p <= 1 && c > 0 && (y = h[c - 1]);
                    var v = l[y.l];
                    u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n, y.l, s);
                    break;
                }
            }
            if (n) return a;
            var M = s ? l.future : l.past;
            return "function" == typeof M ? M(a) : M.replace("%s", a);
        }, n.to = function(r, e) {
            return i(r, e, this, !0);
        }, n.from = function(r, e) {
            return i(r, e, this);
        };
        var d = function(r) {
            return r.$u ? t.utc() : t();
        };
        n.toNow = function(r) {
            return this.to(d(this), r);
        }, n.fromNow = function(r) {
            return this.from(d(this), r);
        };
    };
});

});

parcelRegister("iERD9", function(module, exports) {
!function(e, n) {
    module.exports = n();
}(module.exports, function() {
    "use strict";
    return function(e, n, t) {
        t.updateLocale = function(e, n) {
            var o = t.Ls[e];
            if (o) return (n ? Object.keys(n) : []).forEach(function(e) {
                o[e] = n[e];
            }), o;
        };
    };
});

});



parcelRegister("iOo4s", function(module, exports) {

$parcel$export(module.exports, "customElement", () => $db1f9176f4a24996$export$da64fc29f17f9d0e);
function $db1f9176f4a24996$var$standardCustomElement(tagName, descriptor) {
    const { kind: kind, elements: elements } = descriptor;
    return {
        kind: kind,
        elements: elements,
        finisher (clazz) {
            if (!customElements.get(tagName)) customElements.define(tagName, clazz);
        }
    };
}
function $db1f9176f4a24996$var$legacyCustomElement(tagName, clazz) {
    if (!customElements.get(tagName)) customElements.define(tagName, clazz);
    return clazz;
}
function $db1f9176f4a24996$export$da64fc29f17f9d0e(tagName) {
    return function create(classOrDescriptor) {
        return typeof classOrDescriptor === "function" ? $db1f9176f4a24996$var$legacyCustomElement(tagName, classOrDescriptor) : $db1f9176f4a24996$var$standardCustomElement(tagName, classOrDescriptor);
    };
}

});


parcelRegister("3cVvs", function(module, exports) {

$parcel$export(module.exports, "BaseError", () => $255f19a844293bd5$export$a490eb03cb7a0a5e);

var $7WSOe = parcelRequire("7WSOe");
let $255f19a844293bd5$var$errorConfig = {
    getDocsUrl: ({ docsBaseUrl: docsBaseUrl, docsPath: docsPath = "", docsSlug: docsSlug })=>docsPath ? `${docsBaseUrl ?? "https://viem.sh"}${docsPath}${docsSlug ? `#${docsSlug}` : ""}` : undefined,
    version: `viem@${(0, $7WSOe.version)}`
};
function $255f19a844293bd5$export$4ac109df0c5244e9(config) {
    $255f19a844293bd5$var$errorConfig = config;
}
class $255f19a844293bd5$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        const details = (()=>{
            if (args.cause instanceof $255f19a844293bd5$export$a490eb03cb7a0a5e) return args.cause.details;
            if (args.cause?.message) return args.cause.message;
            return args.details;
        })();
        const docsPath = (()=>{
            if (args.cause instanceof $255f19a844293bd5$export$a490eb03cb7a0a5e) return args.cause.docsPath || args.docsPath;
            return args.docsPath;
        })();
        const docsUrl = $255f19a844293bd5$var$errorConfig.getDocsUrl?.({
            ...args,
            docsPath: docsPath
        });
        const message = [
            shortMessage || "An error occurred.",
            "",
            ...args.metaMessages ? [
                ...args.metaMessages,
                ""
            ] : [],
            ...docsUrl ? [
                `Docs: ${docsUrl}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            ...$255f19a844293bd5$var$errorConfig.version ? [
                `Version: ${$255f19a844293bd5$var$errorConfig.version}`
            ] : []
        ].join("\n");
        super(message, args.cause ? {
            cause: args.cause
        } : undefined);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BaseError"
        });
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.name = args.name ?? this.name;
        this.shortMessage = shortMessage;
        this.version = (0, $7WSOe.version);
    }
    walk(fn) {
        return $255f19a844293bd5$var$walk(this, fn);
    }
}
function $255f19a844293bd5$var$walk(err, fn) {
    if (fn?.(err)) return err;
    if (err && typeof err === "object" && "cause" in err && err.cause !== undefined) return $255f19a844293bd5$var$walk(err.cause, fn);
    return fn ? null : err;
}

});
parcelRegister("7WSOe", function(module, exports) {

$parcel$export(module.exports, "version", () => $5c98772330ecf117$export$83d89fbfd8236492);
const $5c98772330ecf117$export$83d89fbfd8236492 = "2.30.1";

});


parcelRegister("16W4z", function(module, exports) {

$parcel$export(module.exports, "ParseRpcError", () => $0cf36608486b1a39$export$aa31e6432f136746);
$parcel$export(module.exports, "InvalidRequestRpcError", () => $0cf36608486b1a39$export$ff7b9f15f3eb8d4d);
$parcel$export(module.exports, "MethodNotFoundRpcError", () => $0cf36608486b1a39$export$4c4044ac99c8d2d3);
$parcel$export(module.exports, "InvalidParamsRpcError", () => $0cf36608486b1a39$export$c600faffd3cbd390);
$parcel$export(module.exports, "InternalRpcError", () => $0cf36608486b1a39$export$4e62fafb20e19fd7);
$parcel$export(module.exports, "InvalidInputRpcError", () => $0cf36608486b1a39$export$3ba2994324ab015e);
$parcel$export(module.exports, "ResourceNotFoundRpcError", () => $0cf36608486b1a39$export$466772c50c6d6751);
$parcel$export(module.exports, "ResourceUnavailableRpcError", () => $0cf36608486b1a39$export$270451347568a637);
$parcel$export(module.exports, "TransactionRejectedRpcError", () => $0cf36608486b1a39$export$f714565c9176e28);
$parcel$export(module.exports, "MethodNotSupportedRpcError", () => $0cf36608486b1a39$export$b106fe05a02d89c5);
$parcel$export(module.exports, "LimitExceededRpcError", () => $0cf36608486b1a39$export$2c6f5ab73129d9d7);
$parcel$export(module.exports, "JsonRpcVersionUnsupportedError", () => $0cf36608486b1a39$export$662f3764fa426a13);
$parcel$export(module.exports, "UserRejectedRequestError", () => $0cf36608486b1a39$export$4af5b080d9e9e1a6);
$parcel$export(module.exports, "UnauthorizedProviderError", () => $0cf36608486b1a39$export$cc1057a5779c7ffa);
$parcel$export(module.exports, "UnsupportedProviderMethodError", () => $0cf36608486b1a39$export$6a557500ae315a49);
$parcel$export(module.exports, "ProviderDisconnectedError", () => $0cf36608486b1a39$export$abb104bf1dd9c38b);
$parcel$export(module.exports, "ChainDisconnectedError", () => $0cf36608486b1a39$export$ef186cf1cda0444);
$parcel$export(module.exports, "SwitchChainError", () => $0cf36608486b1a39$export$d4ddb31968a9d366);
$parcel$export(module.exports, "UnsupportedNonOptionalCapabilityError", () => $0cf36608486b1a39$export$2e2034789e203e09);
$parcel$export(module.exports, "UnsupportedChainIdError", () => $0cf36608486b1a39$export$fc97cac2ba066ec7);
$parcel$export(module.exports, "DuplicateIdError", () => $0cf36608486b1a39$export$5037bf500375aebd);
$parcel$export(module.exports, "UnknownBundleIdError", () => $0cf36608486b1a39$export$dafa4532fa5beea2);
$parcel$export(module.exports, "BundleTooLargeError", () => $0cf36608486b1a39$export$9e5f099cd963515a);
$parcel$export(module.exports, "AtomicReadyWalletRejectedUpgradeError", () => $0cf36608486b1a39$export$ec7a64b1ed968f39);
$parcel$export(module.exports, "AtomicityNotSupportedError", () => $0cf36608486b1a39$export$7aa24bfbf721a0aa);
$parcel$export(module.exports, "UnknownRpcError", () => $0cf36608486b1a39$export$bfc830e1ec76e31b);

var $3cVvs = parcelRequire("3cVvs");

var $kbqwz = parcelRequire("kbqwz");
const $0cf36608486b1a39$var$unknownErrorCode = -1;
class $0cf36608486b1a39$export$5460eff990f31920 extends (0, $3cVvs.BaseError) {
    constructor(cause, { code: code, docsPath: docsPath, metaMessages: metaMessages, name: name, shortMessage: shortMessage }){
        super(shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: metaMessages || cause?.metaMessages,
            name: name || "RpcError"
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = name || cause.name;
        this.code = cause instanceof (0, $kbqwz.RpcRequestError) ? cause.code : code ?? $0cf36608486b1a39$var$unknownErrorCode;
    }
}
class $0cf36608486b1a39$export$417589b978208a8f extends $0cf36608486b1a39$export$5460eff990f31920 {
    constructor(cause, options){
        super(cause, options);
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = options.data;
    }
}
class $0cf36608486b1a39$export$aa31e6432f136746 extends $0cf36608486b1a39$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$aa31e6432f136746.code,
            name: "ParseRpcError",
            shortMessage: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$aa31e6432f136746, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32700
});
class $0cf36608486b1a39$export$ff7b9f15f3eb8d4d extends $0cf36608486b1a39$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$ff7b9f15f3eb8d4d.code,
            name: "InvalidRequestRpcError",
            shortMessage: "JSON is not a valid request object."
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$ff7b9f15f3eb8d4d, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32600
});
class $0cf36608486b1a39$export$4c4044ac99c8d2d3 extends $0cf36608486b1a39$export$5460eff990f31920 {
    constructor(cause, { method: method } = {}){
        super(cause, {
            code: $0cf36608486b1a39$export$4c4044ac99c8d2d3.code,
            name: "MethodNotFoundRpcError",
            shortMessage: `The method${method ? ` "${method}"` : ""} does not exist / is not available.`
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$4c4044ac99c8d2d3, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32601
});
class $0cf36608486b1a39$export$c600faffd3cbd390 extends $0cf36608486b1a39$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$c600faffd3cbd390.code,
            name: "InvalidParamsRpcError",
            shortMessage: [
                "Invalid parameters were provided to the RPC method.",
                "Double check you have provided the correct parameters."
            ].join("\n")
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$c600faffd3cbd390, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32602
});
class $0cf36608486b1a39$export$4e62fafb20e19fd7 extends $0cf36608486b1a39$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$4e62fafb20e19fd7.code,
            name: "InternalRpcError",
            shortMessage: "An internal error was received."
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$4e62fafb20e19fd7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32603
});
class $0cf36608486b1a39$export$3ba2994324ab015e extends $0cf36608486b1a39$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$3ba2994324ab015e.code,
            name: "InvalidInputRpcError",
            shortMessage: [
                "Missing or invalid parameters.",
                "Double check you have provided the correct parameters."
            ].join("\n")
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$3ba2994324ab015e, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32000
});
class $0cf36608486b1a39$export$466772c50c6d6751 extends $0cf36608486b1a39$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$466772c50c6d6751.code,
            name: "ResourceNotFoundRpcError",
            shortMessage: "Requested resource not found."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ResourceNotFoundRpcError"
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$466772c50c6d6751, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32001
});
class $0cf36608486b1a39$export$270451347568a637 extends $0cf36608486b1a39$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$270451347568a637.code,
            name: "ResourceUnavailableRpcError",
            shortMessage: "Requested resource not available."
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$270451347568a637, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32002
});
class $0cf36608486b1a39$export$f714565c9176e28 extends $0cf36608486b1a39$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$f714565c9176e28.code,
            name: "TransactionRejectedRpcError",
            shortMessage: "Transaction creation failed."
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$f714565c9176e28, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32003
});
class $0cf36608486b1a39$export$b106fe05a02d89c5 extends $0cf36608486b1a39$export$5460eff990f31920 {
    constructor(cause, { method: method } = {}){
        super(cause, {
            code: $0cf36608486b1a39$export$b106fe05a02d89c5.code,
            name: "MethodNotSupportedRpcError",
            shortMessage: `Method${method ? ` "${method}"` : ""} is not supported.`
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$b106fe05a02d89c5, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32004
});
class $0cf36608486b1a39$export$2c6f5ab73129d9d7 extends $0cf36608486b1a39$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$2c6f5ab73129d9d7.code,
            name: "LimitExceededRpcError",
            shortMessage: "Request exceeds defined limit."
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$2c6f5ab73129d9d7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32005
});
class $0cf36608486b1a39$export$662f3764fa426a13 extends $0cf36608486b1a39$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$662f3764fa426a13.code,
            name: "JsonRpcVersionUnsupportedError",
            shortMessage: "Version of JSON-RPC protocol is not supported."
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$662f3764fa426a13, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32006
});
class $0cf36608486b1a39$export$4af5b080d9e9e1a6 extends $0cf36608486b1a39$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$4af5b080d9e9e1a6.code,
            name: "UserRejectedRequestError",
            shortMessage: "User rejected the request."
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$4af5b080d9e9e1a6, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4001
});
class $0cf36608486b1a39$export$cc1057a5779c7ffa extends $0cf36608486b1a39$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$cc1057a5779c7ffa.code,
            name: "UnauthorizedProviderError",
            shortMessage: "The requested method and/or account has not been authorized by the user."
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$cc1057a5779c7ffa, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4100
});
class $0cf36608486b1a39$export$6a557500ae315a49 extends $0cf36608486b1a39$export$417589b978208a8f {
    constructor(cause, { method: method } = {}){
        super(cause, {
            code: $0cf36608486b1a39$export$6a557500ae315a49.code,
            name: "UnsupportedProviderMethodError",
            shortMessage: `The Provider does not support the requested method${method ? ` " ${method}"` : ""}.`
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$6a557500ae315a49, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4200
});
class $0cf36608486b1a39$export$abb104bf1dd9c38b extends $0cf36608486b1a39$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$abb104bf1dd9c38b.code,
            name: "ProviderDisconnectedError",
            shortMessage: "The Provider is disconnected from all chains."
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$abb104bf1dd9c38b, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4900
});
class $0cf36608486b1a39$export$ef186cf1cda0444 extends $0cf36608486b1a39$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$ef186cf1cda0444.code,
            name: "ChainDisconnectedError",
            shortMessage: "The Provider is not connected to the requested chain."
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$ef186cf1cda0444, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4901
});
class $0cf36608486b1a39$export$d4ddb31968a9d366 extends $0cf36608486b1a39$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$d4ddb31968a9d366.code,
            name: "SwitchChainError",
            shortMessage: "An error occurred when attempting to switch chain."
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$d4ddb31968a9d366, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4902
});
class $0cf36608486b1a39$export$2e2034789e203e09 extends $0cf36608486b1a39$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$2e2034789e203e09.code,
            name: "UnsupportedNonOptionalCapabilityError",
            shortMessage: "This Wallet does not support a capability that was not marked as optional."
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$2e2034789e203e09, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 5700
});
class $0cf36608486b1a39$export$fc97cac2ba066ec7 extends $0cf36608486b1a39$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$fc97cac2ba066ec7.code,
            name: "UnsupportedChainIdError",
            shortMessage: "This Wallet does not support the requested chain ID."
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$fc97cac2ba066ec7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 5710
});
class $0cf36608486b1a39$export$5037bf500375aebd extends $0cf36608486b1a39$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$5037bf500375aebd.code,
            name: "DuplicateIdError",
            shortMessage: "There is already a bundle submitted with this ID."
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$5037bf500375aebd, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 5720
});
class $0cf36608486b1a39$export$dafa4532fa5beea2 extends $0cf36608486b1a39$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$dafa4532fa5beea2.code,
            name: "UnknownBundleIdError",
            shortMessage: "This bundle id is unknown / has not been submitted"
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$dafa4532fa5beea2, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 5730
});
class $0cf36608486b1a39$export$9e5f099cd963515a extends $0cf36608486b1a39$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$9e5f099cd963515a.code,
            name: "BundleTooLargeError",
            shortMessage: "The call bundle is too large for the Wallet to process."
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$9e5f099cd963515a, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 5740
});
class $0cf36608486b1a39$export$ec7a64b1ed968f39 extends $0cf36608486b1a39$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$ec7a64b1ed968f39.code,
            name: "AtomicReadyWalletRejectedUpgradeError",
            shortMessage: "The Wallet can support atomicity after an upgrade, but the user rejected the upgrade."
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$ec7a64b1ed968f39, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 5750
});
class $0cf36608486b1a39$export$7aa24bfbf721a0aa extends $0cf36608486b1a39$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $0cf36608486b1a39$export$7aa24bfbf721a0aa.code,
            name: "AtomicityNotSupportedError",
            shortMessage: "The wallet does not support atomic execution but the request requires it."
        });
    }
}
Object.defineProperty($0cf36608486b1a39$export$7aa24bfbf721a0aa, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 5760
});
class $0cf36608486b1a39$export$bfc830e1ec76e31b extends $0cf36608486b1a39$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            name: "UnknownRpcError",
            shortMessage: "An unknown RPC error occurred."
        });
    }
}

});
parcelRegister("kbqwz", function(module, exports) {

$parcel$export(module.exports, "HttpRequestError", () => $eb1968ee29ce218a$export$715ba3385e9f2cf0);
$parcel$export(module.exports, "RpcRequestError", () => $eb1968ee29ce218a$export$a823590631c47261);
$parcel$export(module.exports, "TimeoutError", () => $eb1968ee29ce218a$export$66d311bf29d5c89c);

var $c0R7l = parcelRequire("c0R7l");

var $3cVvs = parcelRequire("3cVvs");

var $dovow = parcelRequire("dovow");
class $eb1968ee29ce218a$export$715ba3385e9f2cf0 extends (0, $3cVvs.BaseError) {
    constructor({ body: body, cause: cause, details: details, headers: headers, status: status, url: url }){
        super("HTTP request failed.", {
            cause: cause,
            details: details,
            metaMessages: [
                status && `Status: ${status}`,
                `URL: ${(0, $dovow.getUrl)(url)}`,
                body && `Request body: ${(0, $c0R7l.stringify)(body)}`
            ].filter(Boolean),
            name: "HttpRequestError"
        });
        Object.defineProperty(this, "body", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "url", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.body = body;
        this.headers = headers;
        this.status = status;
        this.url = url;
    }
}
class $eb1968ee29ce218a$export$e1d72a3a26ed1bc extends (0, $3cVvs.BaseError) {
    constructor({ body: body, cause: cause, details: details, url: url }){
        super("WebSocket request failed.", {
            cause: cause,
            details: details,
            metaMessages: [
                `URL: ${(0, $dovow.getUrl)(url)}`,
                body && `Request body: ${(0, $c0R7l.stringify)(body)}`
            ].filter(Boolean),
            name: "WebSocketRequestError"
        });
    }
}
class $eb1968ee29ce218a$export$a823590631c47261 extends (0, $3cVvs.BaseError) {
    constructor({ body: body, error: error, url: url }){
        super("RPC Request failed.", {
            cause: error,
            details: error.message,
            metaMessages: [
                `URL: ${(0, $dovow.getUrl)(url)}`,
                `Request body: ${(0, $c0R7l.stringify)(body)}`
            ],
            name: "RpcRequestError"
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.code = error.code;
        this.data = error.data;
    }
}
class $eb1968ee29ce218a$export$a52f6cfb6f69ff4d extends (0, $3cVvs.BaseError) {
    constructor({ url: url } = {}){
        super("The socket has been closed.", {
            metaMessages: [
                url && `URL: ${(0, $dovow.getUrl)(url)}`
            ].filter(Boolean),
            name: "SocketClosedError"
        });
    }
}
class $eb1968ee29ce218a$export$66d311bf29d5c89c extends (0, $3cVvs.BaseError) {
    constructor({ body: body, url: url }){
        super("The request took too long to respond.", {
            details: "The request timed out.",
            metaMessages: [
                `URL: ${(0, $dovow.getUrl)(url)}`,
                `Request body: ${(0, $c0R7l.stringify)(body)}`
            ],
            name: "TimeoutError"
        });
    }
}

});
parcelRegister("c0R7l", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $8beeb02289d682ed$export$fac44ee5b035f737);
const $8beeb02289d682ed$export$fac44ee5b035f737 = (value, replacer, space)=>JSON.stringify(value, (key, value_)=>{
        const value = typeof value_ === "bigint" ? value_.toString() : value_;
        return typeof replacer === "function" ? replacer(key, value) : value;
    }, space);

});

parcelRegister("dovow", function(module, exports) {

$parcel$export(module.exports, "getContractAddress", () => $9c05de8ec46c5226$export$b7fbffef12272e40);
$parcel$export(module.exports, "getUrl", () => $9c05de8ec46c5226$export$94df0e59ebebf4a7);
const $9c05de8ec46c5226$export$b7fbffef12272e40 = (address)=>address;
const $9c05de8ec46c5226$export$94df0e59ebebf4a7 = (url)=>url;

});



parcelRegister("nDot9", function(module, exports) {

$parcel$export(module.exports, "toHex", () => $0470b4dbbbb668fc$export$7ea66e3774a60b67);
$parcel$export(module.exports, "numberToHex", () => $0470b4dbbbb668fc$export$4e87185b7ecfeec4);
$parcel$export(module.exports, "stringToHex", () => $0470b4dbbbb668fc$export$551c48dea6f88e6d);
$parcel$export(module.exports, "boolToHex", () => $0470b4dbbbb668fc$export$b5c95dec4f62ef7a);
$parcel$export(module.exports, "bytesToHex", () => $0470b4dbbbb668fc$export$58b867e287a802c8);

var $k04Zp = parcelRequire("k04Zp");

var $aS9j8 = parcelRequire("aS9j8");

var $9Hxnd = parcelRequire("9Hxnd");
const $0470b4dbbbb668fc$var$hexes = /*#__PURE__*/ Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, "0"));
function $0470b4dbbbb668fc$export$7ea66e3774a60b67(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $0470b4dbbbb668fc$export$4e87185b7ecfeec4(value, opts);
    if (typeof value === "string") return $0470b4dbbbb668fc$export$551c48dea6f88e6d(value, opts);
    if (typeof value === "boolean") return $0470b4dbbbb668fc$export$b5c95dec4f62ef7a(value, opts);
    return $0470b4dbbbb668fc$export$58b867e287a802c8(value, opts);
}
function $0470b4dbbbb668fc$export$b5c95dec4f62ef7a(value, opts = {}) {
    const hex = `0x${Number(value)}`;
    if (typeof opts.size === "number") {
        (0, $9Hxnd.assertSize)(hex, {
            size: opts.size
        });
        return (0, $aS9j8.pad)(hex, {
            size: opts.size
        });
    }
    return hex;
}
function $0470b4dbbbb668fc$export$58b867e287a802c8(value, opts = {}) {
    let string = "";
    for(let i = 0; i < value.length; i++)string += $0470b4dbbbb668fc$var$hexes[value[i]];
    const hex = `0x${string}`;
    if (typeof opts.size === "number") {
        (0, $9Hxnd.assertSize)(hex, {
            size: opts.size
        });
        return (0, $aS9j8.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    return hex;
}
function $0470b4dbbbb668fc$export$4e87185b7ecfeec4(value_, opts = {}) {
    const { signed: signed, size: size } = opts;
    const value = BigInt(value_);
    let maxValue;
    if (size) {
        if (signed) maxValue = (1n << BigInt(size) * 8n - 1n) - 1n;
        else maxValue = 2n ** (BigInt(size) * 8n) - 1n;
    } else if (typeof value_ === "number") maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    const minValue = typeof maxValue === "bigint" && signed ? -maxValue - 1n : 0;
    if (maxValue && value > maxValue || value < minValue) {
        const suffix = typeof value_ === "bigint" ? "n" : "";
        throw new (0, $k04Zp.IntegerOutOfRangeError)({
            max: maxValue ? `${maxValue}${suffix}` : undefined,
            min: `${minValue}${suffix}`,
            signed: signed,
            size: size,
            value: `${value_}${suffix}`
        });
    }
    const hex = `0x${(signed && value < 0 ? (1n << BigInt(size * 8)) + BigInt(value) : value).toString(16)}`;
    if (size) return (0, $aS9j8.pad)(hex, {
        size: size
    });
    return hex;
}
const $0470b4dbbbb668fc$var$encoder = /*#__PURE__*/ new TextEncoder();
function $0470b4dbbbb668fc$export$551c48dea6f88e6d(value_, opts = {}) {
    const value = $0470b4dbbbb668fc$var$encoder.encode(value_);
    return $0470b4dbbbb668fc$export$58b867e287a802c8(value, opts);
}

});
parcelRegister("k04Zp", function(module, exports) {

$parcel$export(module.exports, "IntegerOutOfRangeError", () => $e8f7ad8cf9c5ec6a$export$47d164a8071229a9);
$parcel$export(module.exports, "InvalidBytesBooleanError", () => $e8f7ad8cf9c5ec6a$export$52fc62e5266c8838);
$parcel$export(module.exports, "InvalidHexBooleanError", () => $e8f7ad8cf9c5ec6a$export$f574ac54e35514c);
$parcel$export(module.exports, "SizeOverflowError", () => $e8f7ad8cf9c5ec6a$export$beb44ed4f8747d0e);

var $3cVvs = parcelRequire("3cVvs");
class $e8f7ad8cf9c5ec6a$export$47d164a8071229a9 extends (0, $3cVvs.BaseError) {
    constructor({ max: max, min: min, signed: signed, size: size, value: value }){
        super(`Number "${value}" is not in safe ${size ? `${size * 8}-bit ${signed ? "signed" : "unsigned"} ` : ""}integer range ${max ? `(${min} to ${max})` : `(above ${min})`}`, {
            name: "IntegerOutOfRangeError"
        });
    }
}
class $e8f7ad8cf9c5ec6a$export$52fc62e5266c8838 extends (0, $3cVvs.BaseError) {
    constructor(bytes){
        super(`Bytes value "${bytes}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`, {
            name: "InvalidBytesBooleanError"
        });
    }
}
class $e8f7ad8cf9c5ec6a$export$f574ac54e35514c extends (0, $3cVvs.BaseError) {
    constructor(hex){
        super(`Hex value "${hex}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`, {
            name: "InvalidHexBooleanError"
        });
    }
}
class $e8f7ad8cf9c5ec6a$export$ef05eafd11dd4a83 extends (0, $3cVvs.BaseError) {
    constructor(value){
        super(`Hex value "${value}" is an odd length (${value.length}). It must be an even length.`, {
            name: "InvalidHexValueError"
        });
    }
}
class $e8f7ad8cf9c5ec6a$export$beb44ed4f8747d0e extends (0, $3cVvs.BaseError) {
    constructor({ givenSize: givenSize, maxSize: maxSize }){
        super(`Size cannot exceed ${maxSize} bytes. Given size: ${givenSize} bytes.`, {
            name: "SizeOverflowError"
        });
    }
}

});

parcelRegister("aS9j8", function(module, exports) {

$parcel$export(module.exports, "pad", () => $7ea62ace1053d1f3$export$5d04458e2a6c373e);
$parcel$export(module.exports, "padHex", () => $7ea62ace1053d1f3$export$1bcd51c0fce8ee55);

var $9et7x = parcelRequire("9et7x");
function $7ea62ace1053d1f3$export$5d04458e2a6c373e(hexOrBytes, { dir: dir, size: size = 32 } = {}) {
    if (typeof hexOrBytes === "string") return $7ea62ace1053d1f3$export$1bcd51c0fce8ee55(hexOrBytes, {
        dir: dir,
        size: size
    });
    return $7ea62ace1053d1f3$export$4c6b868113605df3(hexOrBytes, {
        dir: dir,
        size: size
    });
}
function $7ea62ace1053d1f3$export$1bcd51c0fce8ee55(hex_, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return hex_;
    const hex = hex_.replace("0x", "");
    if (hex.length > size * 2) throw new (0, $9et7x.SizeExceedsPaddingSizeError)({
        size: Math.ceil(hex.length / 2),
        targetSize: size,
        type: "hex"
    });
    return `0x${hex[dir === "right" ? "padEnd" : "padStart"](size * 2, "0")}`;
}
function $7ea62ace1053d1f3$export$4c6b868113605df3(bytes, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return bytes;
    if (bytes.length > size) throw new (0, $9et7x.SizeExceedsPaddingSizeError)({
        size: bytes.length,
        targetSize: size,
        type: "bytes"
    });
    const paddedBytes = new Uint8Array(size);
    for(let i = 0; i < size; i++){
        const padEnd = dir === "right";
        paddedBytes[padEnd ? i : size - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
    }
    return paddedBytes;
}

});
parcelRegister("9et7x", function(module, exports) {

$parcel$export(module.exports, "SliceOffsetOutOfBoundsError", () => $6b8c02976a9a6f00$export$cfcd41bba8b36dbd);
$parcel$export(module.exports, "SizeExceedsPaddingSizeError", () => $6b8c02976a9a6f00$export$70445dc308a7f3d5);
$parcel$export(module.exports, "InvalidBytesLengthError", () => $6b8c02976a9a6f00$export$8a5469becf223114);

var $3cVvs = parcelRequire("3cVvs");
class $6b8c02976a9a6f00$export$cfcd41bba8b36dbd extends (0, $3cVvs.BaseError) {
    constructor({ offset: offset, position: position, size: size }){
        super(`Slice ${position === "start" ? "starting" : "ending"} at offset "${offset}" is out-of-bounds (size: ${size}).`, {
            name: "SliceOffsetOutOfBoundsError"
        });
    }
}
class $6b8c02976a9a6f00$export$70445dc308a7f3d5 extends (0, $3cVvs.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (${size}) exceeds padding size (${targetSize}).`, {
            name: "SizeExceedsPaddingSizeError"
        });
    }
}
class $6b8c02976a9a6f00$export$8a5469becf223114 extends (0, $3cVvs.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} is expected to be ${targetSize} ${type} long, but is ${size} ${type} long.`, {
            name: "InvalidBytesLengthError"
        });
    }
}

});


parcelRegister("9Hxnd", function(module, exports) {

$parcel$export(module.exports, "assertSize", () => $7102047afb52ea28$export$2af489edb7fa35fe);
$parcel$export(module.exports, "hexToNumber", () => $7102047afb52ea28$export$d57f2bacc26b4249);
$parcel$export(module.exports, "hexToBigInt", () => $7102047afb52ea28$export$92a44656ec81b584);
$parcel$export(module.exports, "hexToString", () => $7102047afb52ea28$export$f4bc7e46f3eb3ac3);

var $k04Zp = parcelRequire("k04Zp");

var $loik3 = parcelRequire("loik3");

var $4Khm8 = parcelRequire("4Khm8");

var $lbhq0 = parcelRequire("lbhq0");
function $7102047afb52ea28$export$2af489edb7fa35fe(hexOrBytes, { size: size }) {
    if ((0, $loik3.size)(hexOrBytes) > size) throw new (0, $k04Zp.SizeOverflowError)({
        givenSize: (0, $loik3.size)(hexOrBytes),
        maxSize: size
    });
}
function $7102047afb52ea28$export$1a8ceedbd5845648(hex, toOrOpts) {
    const opts = typeof toOrOpts === "string" ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === "number") return $7102047afb52ea28$export$d57f2bacc26b4249(hex, opts);
    if (to === "bigint") return $7102047afb52ea28$export$92a44656ec81b584(hex, opts);
    if (to === "string") return $7102047afb52ea28$export$f4bc7e46f3eb3ac3(hex, opts);
    if (to === "boolean") return $7102047afb52ea28$export$bde1d77e6fe6c41e(hex, opts);
    return (0, $lbhq0.hexToBytes)(hex, opts);
}
function $7102047afb52ea28$export$92a44656ec81b584(hex, opts = {}) {
    const { signed: signed } = opts;
    if (opts.size) $7102047afb52ea28$export$2af489edb7fa35fe(hex, {
        size: opts.size
    });
    const value = BigInt(hex);
    if (!signed) return value;
    const size = (hex.length - 2) / 2;
    const max = (1n << BigInt(size) * 8n - 1n) - 1n;
    if (value <= max) return value;
    return value - BigInt(`0x${"f".padStart(size * 2, "f")}`) - 1n;
}
function $7102047afb52ea28$export$bde1d77e6fe6c41e(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        $7102047afb52ea28$export$2af489edb7fa35fe(hex, {
            size: opts.size
        });
        hex = (0, $4Khm8.trim)(hex);
    }
    if ((0, $4Khm8.trim)(hex) === "0x00") return false;
    if ((0, $4Khm8.trim)(hex) === "0x01") return true;
    throw new (0, $k04Zp.InvalidHexBooleanError)(hex);
}
function $7102047afb52ea28$export$d57f2bacc26b4249(hex, opts = {}) {
    return Number($7102047afb52ea28$export$92a44656ec81b584(hex, opts));
}
function $7102047afb52ea28$export$f4bc7e46f3eb3ac3(hex, opts = {}) {
    let bytes = (0, $lbhq0.hexToBytes)(hex);
    if (opts.size) {
        $7102047afb52ea28$export$2af489edb7fa35fe(bytes, {
            size: opts.size
        });
        bytes = (0, $4Khm8.trim)(bytes, {
            dir: "right"
        });
    }
    return new TextDecoder().decode(bytes);
}

});
parcelRegister("loik3", function(module, exports) {

$parcel$export(module.exports, "size", () => $f92a0d5787cfcd29$export$346677f925de839c);

var $ifibB = parcelRequire("ifibB");
function $f92a0d5787cfcd29$export$346677f925de839c(value) {
    if ((0, $ifibB.isHex)(value, {
        strict: false
    })) return Math.ceil((value.length - 2) / 2);
    return value.length;
}

});
parcelRegister("ifibB", function(module, exports) {

$parcel$export(module.exports, "isHex", () => $d487bc17d2a67b91$export$8a9b6341a7c96bc);
function $d487bc17d2a67b91$export$8a9b6341a7c96bc(value, { strict: strict = true } = {}) {
    if (!value) return false;
    if (typeof value !== "string") return false;
    return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith("0x");
}

});


parcelRegister("4Khm8", function(module, exports) {

$parcel$export(module.exports, "trim", () => $3748ebd1cf9b586b$export$87c2784dc9fc4ab);
function $3748ebd1cf9b586b$export$87c2784dc9fc4ab(hexOrBytes, { dir: dir = "left" } = {}) {
    let data = typeof hexOrBytes === "string" ? hexOrBytes.replace("0x", "") : hexOrBytes;
    let sliceLength = 0;
    for(let i = 0; i < data.length - 1; i++){
        if (data[dir === "left" ? i : data.length - i - 1].toString() === "0") sliceLength++;
        else break;
    }
    data = dir === "left" ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    if (typeof hexOrBytes === "string") {
        if (data.length === 1 && dir === "right") data = `${data}0`;
        return `0x${data.length % 2 === 1 ? `0${data}` : data}`;
    }
    return data;
}

});

parcelRegister("lbhq0", function(module, exports) {

$parcel$export(module.exports, "toBytes", () => $f6b822fa838e53c2$export$30a71edf0753ed6b);
$parcel$export(module.exports, "hexToBytes", () => $f6b822fa838e53c2$export$31c96b9df38bc8d4);
$parcel$export(module.exports, "stringToBytes", () => $f6b822fa838e53c2$export$c8dd6bc66a63753c);

var $3cVvs = parcelRequire("3cVvs");

var $ifibB = parcelRequire("ifibB");

var $aS9j8 = parcelRequire("aS9j8");

var $9Hxnd = parcelRequire("9Hxnd");

var $nDot9 = parcelRequire("nDot9");
const $f6b822fa838e53c2$var$encoder = /*#__PURE__*/ new TextEncoder();
function $f6b822fa838e53c2$export$30a71edf0753ed6b(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $f6b822fa838e53c2$export$49ad9be85c347998(value, opts);
    if (typeof value === "boolean") return $f6b822fa838e53c2$export$771517697a68241(value, opts);
    if ((0, $ifibB.isHex)(value)) return $f6b822fa838e53c2$export$31c96b9df38bc8d4(value, opts);
    return $f6b822fa838e53c2$export$c8dd6bc66a63753c(value, opts);
}
function $f6b822fa838e53c2$export$771517697a68241(value, opts = {}) {
    const bytes = new Uint8Array(1);
    bytes[0] = Number(value);
    if (typeof opts.size === "number") {
        (0, $9Hxnd.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $aS9j8.pad)(bytes, {
            size: opts.size
        });
    }
    return bytes;
}
// We use very optimized technique to convert hex string to byte array
const $f6b822fa838e53c2$var$charCodeMap = {
    zero: 48,
    nine: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $f6b822fa838e53c2$var$charCodeToBase16(char) {
    if (char >= $f6b822fa838e53c2$var$charCodeMap.zero && char <= $f6b822fa838e53c2$var$charCodeMap.nine) return char - $f6b822fa838e53c2$var$charCodeMap.zero;
    if (char >= $f6b822fa838e53c2$var$charCodeMap.A && char <= $f6b822fa838e53c2$var$charCodeMap.F) return char - ($f6b822fa838e53c2$var$charCodeMap.A - 10);
    if (char >= $f6b822fa838e53c2$var$charCodeMap.a && char <= $f6b822fa838e53c2$var$charCodeMap.f) return char - ($f6b822fa838e53c2$var$charCodeMap.a - 10);
    return undefined;
}
function $f6b822fa838e53c2$export$31c96b9df38bc8d4(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        (0, $9Hxnd.assertSize)(hex, {
            size: opts.size
        });
        hex = (0, $aS9j8.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    let hexString = hex.slice(2);
    if (hexString.length % 2) hexString = `0${hexString}`;
    const length = hexString.length / 2;
    const bytes = new Uint8Array(length);
    for(let index = 0, j = 0; index < length; index++){
        const nibbleLeft = $f6b822fa838e53c2$var$charCodeToBase16(hexString.charCodeAt(j++));
        const nibbleRight = $f6b822fa838e53c2$var$charCodeToBase16(hexString.charCodeAt(j++));
        if (nibbleLeft === undefined || nibbleRight === undefined) throw new (0, $3cVvs.BaseError)(`Invalid byte sequence ("${hexString[j - 2]}${hexString[j - 1]}" in "${hexString}").`);
        bytes[index] = nibbleLeft * 16 + nibbleRight;
    }
    return bytes;
}
function $f6b822fa838e53c2$export$49ad9be85c347998(value, opts) {
    const hex = (0, $nDot9.numberToHex)(value, opts);
    return $f6b822fa838e53c2$export$31c96b9df38bc8d4(hex);
}
function $f6b822fa838e53c2$export$c8dd6bc66a63753c(value, opts = {}) {
    const bytes = $f6b822fa838e53c2$var$encoder.encode(value);
    if (typeof opts.size === "number") {
        (0, $9Hxnd.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $aS9j8.pad)(bytes, {
            dir: "right",
            size: opts.size
        });
    }
    return bytes;
}

});



parcelRegister("6LDR0", function(module, exports) {

var $04X1W = parcelRequire("04X1W");
module.exports = Promise.all([
    $04X1W("8mFAr"),
    $04X1W("507Wj")
]).then(()=>parcelRequire("7EodA"));

});

parcelRegister("5AOtn", function(module, exports) {

var $04X1W = parcelRequire("04X1W");
module.exports = Promise.all([
    $04X1W("8mFAr"),
    $04X1W("5cTjs")
]).then(()=>parcelRequire("cx54q"));

});

parcelRegister("bBR0C", function(module, exports) {

var $04X1W = parcelRequire("04X1W");
module.exports = Promise.all([
    $04X1W("bf2aJ"),
    $04X1W("8mFAr"),
    $04X1W("3neYn")
]).then(()=>parcelRequire("lQExd"));

});

parcelRegister("5pl4x", function(module, exports) {

var $04X1W = parcelRequire("04X1W");
module.exports = Promise.all([
    $04X1W("cJlat"),
    $04X1W("8mFAr"),
    $04X1W("3p3Xo")
]).then(()=>parcelRequire("fRwDw"));

});

parcelRegister("3cUZu", function(module, exports) {

var $04X1W = parcelRequire("04X1W");
module.exports = Promise.all([
    $04X1W("cJlat"),
    $04X1W("8mFAr"),
    $04X1W("kvIvj")
]).then(()=>parcelRequire("8BaCy"));

});

parcelRegister("03SUl", function(module, exports) {

var $04X1W = parcelRequire("04X1W");
module.exports = Promise.all([
    $04X1W("bf2aJ"),
    $04X1W("8mFAr"),
    $04X1W("9HBUC")
]).then(()=>parcelRequire("f7Whi"));

});

parcelRegister("2Oo5D", function(module, exports) {

var $04X1W = parcelRequire("04X1W");
module.exports = Promise.all([
    $04X1W("fkRTX"),
    $04X1W("8mFAr"),
    $04X1W("aIxaa")
]).then(()=>parcelRequire("9DN5H"));

});

parcelRegister("kdAAl", function(module, exports) {

var $04X1W = parcelRequire("04X1W");
module.exports = Promise.all([
    $04X1W("7tbm5"),
    $04X1W("8mFAr"),
    $04X1W("26Hyw")
]).then(()=>parcelRequire("3vEho"));

});

parcelRegister("cANvU", function(module, exports) {

var $04X1W = parcelRequire("04X1W");
module.exports = Promise.all([
    $04X1W("8mFAr"),
    $04X1W("5kvzT")
]).then(()=>parcelRequire("jh84f"));

});

parcelRegister("5jIRQ", function(module, exports) {

var $04X1W = parcelRequire("04X1W");
module.exports = Promise.all([
    $04X1W("7tbm5"),
    $04X1W("fkRTX"),
    $04X1W("bf2aJ"),
    $04X1W("8mFAr"),
    $04X1W("j3wq0")
]).then(()=>parcelRequire("bnxah"));

});

parcelRegister("aL8PV", function(module, exports) {

var $04X1W = parcelRequire("04X1W");
module.exports = Promise.all([
    $04X1W("8mFAr"),
    $04X1W("7Oy9l")
]).then(()=>parcelRequire("7faqJ"));

});

parcelRegister("9yvAP", function(module, exports) {

$parcel$export(module.exports, "ChainNotConfiguredError", () => $6f4fcbbe694d91e6$export$688e5fda4b4631ed);
$parcel$export(module.exports, "ConnectorAlreadyConnectedError", () => $6f4fcbbe694d91e6$export$ee7f4e50316bc4b2);
$parcel$export(module.exports, "ConnectorNotConnectedError", () => $6f4fcbbe694d91e6$export$d9a3828eace037a6);
$parcel$export(module.exports, "ConnectorAccountNotFoundError", () => $6f4fcbbe694d91e6$export$65c369a969e2c62e);
$parcel$export(module.exports, "ConnectorChainMismatchError", () => $6f4fcbbe694d91e6$export$6f9c2f3137249d9c);
$parcel$export(module.exports, "ConnectorUnavailableReconnectingError", () => $6f4fcbbe694d91e6$export$58faffcf27ce6845);

var $jWASA = parcelRequire("jWASA");
class $6f4fcbbe694d91e6$export$688e5fda4b4631ed extends (0, $jWASA.BaseError) {
    constructor(){
        super("Chain not configured.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ChainNotConfiguredError"
        });
    }
}
class $6f4fcbbe694d91e6$export$ee7f4e50316bc4b2 extends (0, $jWASA.BaseError) {
    constructor(){
        super("Connector already connected.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorAlreadyConnectedError"
        });
    }
}
class $6f4fcbbe694d91e6$export$d9a3828eace037a6 extends (0, $jWASA.BaseError) {
    constructor(){
        super("Connector not connected.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorNotConnectedError"
        });
    }
}
class $6f4fcbbe694d91e6$export$9f8a797207d6544e extends (0, $jWASA.BaseError) {
    constructor(){
        super("Connector not found.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorNotFoundError"
        });
    }
}
class $6f4fcbbe694d91e6$export$65c369a969e2c62e extends (0, $jWASA.BaseError) {
    constructor({ address: address, connector: connector }){
        super(`Account "${address}" not found for connector "${connector.name}".`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorAccountNotFoundError"
        });
    }
}
class $6f4fcbbe694d91e6$export$6f9c2f3137249d9c extends (0, $jWASA.BaseError) {
    constructor({ connectionChainId: connectionChainId, connectorChainId: connectorChainId }){
        super(`The current chain of the connector (id: ${connectorChainId}) does not match the connection's chain (id: ${connectionChainId}).`, {
            metaMessages: [
                `Current Chain ID:  ${connectorChainId}`,
                `Expected Chain ID: ${connectionChainId}`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorChainMismatchError"
        });
    }
}
class $6f4fcbbe694d91e6$export$58faffcf27ce6845 extends (0, $jWASA.BaseError) {
    constructor({ connector: connector }){
        super(`Connector "${connector.name}" unavailable while reconnecting.`, {
            details: [
                "During the reconnection step, the only connector methods guaranteed to be available are: `id`, `name`, `type`, `uid`.",
                "All other methods are not guaranteed to be available until reconnection completes and connectors are fully restored.",
                "This error commonly occurs for connectors that asynchronously inject after reconnection has already started."
            ].join(" ")
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorUnavailableReconnectingError"
        });
    }
}

});
parcelRegister("jWASA", function(module, exports) {

$parcel$export(module.exports, "BaseError", () => $e8500a994d0b4c74$export$a490eb03cb7a0a5e);

var $knWPY = parcelRequire("knWPY");
var $e8500a994d0b4c74$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $e8500a994d0b4c74$var$_BaseError_instances, $e8500a994d0b4c74$var$_BaseError_walk;
class $e8500a994d0b4c74$export$a490eb03cb7a0a5e extends Error {
    get docsBaseUrl() {
        return "https://wagmi.sh/core";
    }
    get version() {
        return (0, $knWPY.getVersion)();
    }
    constructor(shortMessage, options = {}){
        super();
        $e8500a994d0b4c74$var$_BaseError_instances.add(this);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "WagmiCoreError"
        });
        const details = options.cause instanceof $e8500a994d0b4c74$export$a490eb03cb7a0a5e ? options.cause.details : options.cause?.message ? options.cause.message : options.details;
        const docsPath = options.cause instanceof $e8500a994d0b4c74$export$a490eb03cb7a0a5e ? options.cause.docsPath || options.docsPath : options.docsPath;
        this.message = [
            shortMessage || "An error occurred.",
            "",
            ...options.metaMessages ? [
                ...options.metaMessages,
                ""
            ] : [],
            ...docsPath ? [
                `Docs: ${this.docsBaseUrl}${docsPath}.html${options.docsSlug ? `#${options.docsSlug}` : ""}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            `Version: ${this.version}`
        ].join("\n");
        if (options.cause) this.cause = options.cause;
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = options.metaMessages;
        this.shortMessage = shortMessage;
    }
    walk(fn) {
        return $e8500a994d0b4c74$var$__classPrivateFieldGet(this, $e8500a994d0b4c74$var$_BaseError_instances, "m", $e8500a994d0b4c74$var$_BaseError_walk).call(this, this, fn);
    }
}
$e8500a994d0b4c74$var$_BaseError_instances = new WeakSet(), $e8500a994d0b4c74$var$_BaseError_walk = function _BaseError_walk(err, fn) {
    if (fn?.(err)) return err;
    if (err.cause) return $e8500a994d0b4c74$var$__classPrivateFieldGet(this, $e8500a994d0b4c74$var$_BaseError_instances, "m", _BaseError_walk).call(this, err.cause, fn);
    return err;
};

});
parcelRegister("knWPY", function(module, exports) {

$parcel$export(module.exports, "getVersion", () => $ed73987b0aba2786$export$c506eb22e615ba4a);

var $4wZB6 = parcelRequire("4wZB6");
const $ed73987b0aba2786$export$c506eb22e615ba4a = ()=>`@wagmi/core@${0, $4wZB6.version}`;

});
parcelRegister("4wZB6", function(module, exports) {

$parcel$export(module.exports, "version", () => $34c9ee8711a62066$export$83d89fbfd8236492);
const $34c9ee8711a62066$export$83d89fbfd8236492 = "2.17.2";

});




parcelRegister("bOQZu", function(module, exports) {

$parcel$export(module.exports, "checksumAddress", () => $89ad7812c535e09e$export$9ff46e8f6df13548);
$parcel$export(module.exports, "getAddress", () => $89ad7812c535e09e$export$88411125f012957a);

var $cegbN = parcelRequire("cegbN");

var $lbhq0 = parcelRequire("lbhq0");

var $bHm1a = parcelRequire("bHm1a");

var $2MUIq = parcelRequire("2MUIq");

var $lmNDj = parcelRequire("lmNDj");
const $89ad7812c535e09e$var$checksumAddressCache = /*#__PURE__*/ new (0, $2MUIq.LruMap)(8192);
function $89ad7812c535e09e$export$9ff46e8f6df13548(address_, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if ($89ad7812c535e09e$var$checksumAddressCache.has(`${address_}.${chainId}`)) return $89ad7812c535e09e$var$checksumAddressCache.get(`${address_}.${chainId}`);
    const hexAddress = chainId ? `${chainId}${address_.toLowerCase()}` : address_.substring(2).toLowerCase();
    const hash = (0, $bHm1a.keccak256)((0, $lbhq0.stringToBytes)(hexAddress), "bytes");
    const address = (chainId ? hexAddress.substring(`${chainId}0x`.length) : hexAddress).split("");
    for(let i = 0; i < 40; i += 2){
        if (hash[i >> 1] >> 4 >= 8 && address[i]) address[i] = address[i].toUpperCase();
        if ((hash[i >> 1] & 0x0f) >= 8 && address[i + 1]) address[i + 1] = address[i + 1].toUpperCase();
    }
    const result = `0x${address.join("")}`;
    $89ad7812c535e09e$var$checksumAddressCache.set(`${address_}.${chainId}`, result);
    return result;
}
function $89ad7812c535e09e$export$88411125f012957a(address, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if (!(0, $lmNDj.isAddress)(address, {
        strict: false
    })) throw new (0, $cegbN.InvalidAddressError)({
        address: address
    });
    return $89ad7812c535e09e$export$9ff46e8f6df13548(address, chainId);
}

});
parcelRegister("cegbN", function(module, exports) {

$parcel$export(module.exports, "InvalidAddressError", () => $8e7359abf6cb2e48$export$66c44d927ffead98);

var $3cVvs = parcelRequire("3cVvs");
class $8e7359abf6cb2e48$export$66c44d927ffead98 extends (0, $3cVvs.BaseError) {
    constructor({ address: address }){
        super(`Address "${address}" is invalid.`, {
            metaMessages: [
                "- Address must be a hex value of 20 bytes (40 hex characters).",
                "- Address must match its checksum counterpart."
            ],
            name: "InvalidAddressError"
        });
    }
}

});

parcelRegister("bHm1a", function(module, exports) {

$parcel$export(module.exports, "keccak256", () => $8844ca24cb3c73b6$export$f8151fce47ad1c35);

var $j0one = parcelRequire("j0one");

var $ifibB = parcelRequire("ifibB");

var $lbhq0 = parcelRequire("lbhq0");

var $nDot9 = parcelRequire("nDot9");
function $8844ca24cb3c73b6$export$f8151fce47ad1c35(value, to_) {
    const to = to_ || "hex";
    const bytes = (0, $j0one.keccak_256)((0, $ifibB.isHex)(value, {
        strict: false
    }) ? (0, $lbhq0.toBytes)(value) : value);
    if (to === "bytes") return bytes;
    return (0, $nDot9.toHex)(bytes);
}

});
parcelRegister("j0one", function(module, exports) {

$parcel$export(module.exports, "keccak_256", () => $dd60ec80e236c758$export$860ddaa9ca84a66d);
/**
 * SHA3 (keccak) hash function, based on a new "Sponge function" design.
 * Different from older hashes, the internal state is bigger than output size.
 *
 * Check out [FIPS-202](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.202.pdf),
 * [Website](https://keccak.team/keccak.html),
 * [the differences between SHA-3 and Keccak](https://crypto.stackexchange.com/questions/15727/what-are-the-key-differences-between-the-draft-sha-3-standard-and-the-keccak-sub).
 *
 * Check out `sha3-addons` module for cSHAKE, k12, and others.
 * @module
 */ 
var $hIfB5 = parcelRequire("hIfB5");

var $7MXpH = parcelRequire("7MXpH");
// No __PURE__ annotations in sha3 header:
// EVERYTHING is in fact used on every export.
// Various per round constants calculations
const $dd60ec80e236c758$var$_0n = BigInt(0);
const $dd60ec80e236c758$var$_1n = BigInt(1);
const $dd60ec80e236c758$var$_2n = BigInt(2);
const $dd60ec80e236c758$var$_7n = BigInt(7);
const $dd60ec80e236c758$var$_256n = BigInt(256);
const $dd60ec80e236c758$var$_0x71n = BigInt(0x71);
const $dd60ec80e236c758$var$SHA3_PI = [];
const $dd60ec80e236c758$var$SHA3_ROTL = [];
const $dd60ec80e236c758$var$_SHA3_IOTA = [];
for(let round = 0, R = $dd60ec80e236c758$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $dd60ec80e236c758$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $dd60ec80e236c758$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $dd60ec80e236c758$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $dd60ec80e236c758$var$_1n ^ (R >> $dd60ec80e236c758$var$_7n) * $dd60ec80e236c758$var$_0x71n) % $dd60ec80e236c758$var$_256n;
        if (R & $dd60ec80e236c758$var$_2n) t ^= $dd60ec80e236c758$var$_1n << ($dd60ec80e236c758$var$_1n << /* @__PURE__ */ BigInt(j)) - $dd60ec80e236c758$var$_1n;
    }
    $dd60ec80e236c758$var$_SHA3_IOTA.push(t);
}
const $dd60ec80e236c758$var$IOTAS = (0, $hIfB5.split)($dd60ec80e236c758$var$_SHA3_IOTA, true);
const $dd60ec80e236c758$var$SHA3_IOTA_H = $dd60ec80e236c758$var$IOTAS[0];
const $dd60ec80e236c758$var$SHA3_IOTA_L = $dd60ec80e236c758$var$IOTAS[1];
// Left rotation (without 0, 32, 64)
const $dd60ec80e236c758$var$rotlH = (h, l, s)=>s > 32 ? (0, $hIfB5.rotlBH)(h, l, s) : (0, $hIfB5.rotlSH)(h, l, s);
const $dd60ec80e236c758$var$rotlL = (h, l, s)=>s > 32 ? (0, $hIfB5.rotlBL)(h, l, s) : (0, $hIfB5.rotlSL)(h, l, s);
function $dd60ec80e236c758$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $dd60ec80e236c758$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $dd60ec80e236c758$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $dd60ec80e236c758$var$SHA3_ROTL[t];
            const Th = $dd60ec80e236c758$var$rotlH(curH, curL, shift);
            const Tl = $dd60ec80e236c758$var$rotlL(curH, curL, shift);
            const PI = $dd60ec80e236c758$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $dd60ec80e236c758$var$SHA3_IOTA_H[round];
        s[1] ^= $dd60ec80e236c758$var$SHA3_IOTA_L[round];
    }
    (0, $7MXpH.clean)(B);
}
class $dd60ec80e236c758$export$f7374b8b4498bc2e extends (0, $7MXpH.Hash) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        this.enableXOF = false;
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        // Can be passed from user as dkLen
        (0, $7MXpH.anumber)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        // 0 < blockLen < 200
        if (!(0 < blockLen && blockLen < 200)) throw new Error("only keccak-f1600 function is supported");
        this.state = new Uint8Array(200);
        this.state32 = (0, $7MXpH.u32)(this.state);
    }
    clone() {
        return this._cloneInto();
    }
    keccak() {
        (0, $7MXpH.swap32IfBE)(this.state32);
        $dd60ec80e236c758$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        (0, $7MXpH.swap32IfBE)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $7MXpH.aexists)(this);
        data = (0, $7MXpH.toBytes)(data);
        (0, $7MXpH.abytes)(data);
        const { blockLen: blockLen, state: state } = this;
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $7MXpH.aexists)(this, false);
        (0, $7MXpH.abytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $7MXpH.anumber)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $7MXpH.aoutput)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        (0, $7MXpH.clean)(this.state);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $dd60ec80e236c758$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $dd60ec80e236c758$var$gen = (suffix, blockLen, outputLen)=>(0, $7MXpH.createHasher)(()=>new $dd60ec80e236c758$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $dd60ec80e236c758$export$fe6c2b96a79338e9 = /* @__PURE__ */ (()=>$dd60ec80e236c758$var$gen(0x06, 144, 28))();
const $dd60ec80e236c758$export$76e19b6966813b14 = /* @__PURE__ */ (()=>$dd60ec80e236c758$var$gen(0x06, 136, 32))();
const $dd60ec80e236c758$export$a58509fa80f30d15 = /* @__PURE__ */ (()=>$dd60ec80e236c758$var$gen(0x06, 104, 48))();
const $dd60ec80e236c758$export$20ed324dbdf09b7c = /* @__PURE__ */ (()=>$dd60ec80e236c758$var$gen(0x06, 72, 64))();
const $dd60ec80e236c758$export$2f7fb3c6fac246bc = /* @__PURE__ */ (()=>$dd60ec80e236c758$var$gen(0x01, 144, 28))();
const $dd60ec80e236c758$export$860ddaa9ca84a66d = /* @__PURE__ */ (()=>$dd60ec80e236c758$var$gen(0x01, 136, 32))();
const $dd60ec80e236c758$export$46fcdeb4c5686552 = /* @__PURE__ */ (()=>$dd60ec80e236c758$var$gen(0x01, 104, 48))();
const $dd60ec80e236c758$export$aec1ddaf6c1ba495 = /* @__PURE__ */ (()=>$dd60ec80e236c758$var$gen(0x01, 72, 64))();
const $dd60ec80e236c758$var$genShake = (suffix, blockLen, outputLen)=>(0, $7MXpH.createXOFer)((opts = {})=>new $dd60ec80e236c758$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $dd60ec80e236c758$export$f43dc3bb86efbba2 = /* @__PURE__ */ (()=>$dd60ec80e236c758$var$genShake(0x1f, 168, 16))();
const $dd60ec80e236c758$export$c240d011f1520440 = /* @__PURE__ */ (()=>$dd60ec80e236c758$var$genShake(0x1f, 136, 32))();

});
parcelRegister("hIfB5", function(module, exports) {

$parcel$export(module.exports, "split", () => $ce52a50127d2f5e0$export$65980d18b75784e2);
$parcel$export(module.exports, "shrSH", () => $ce52a50127d2f5e0$export$75aa78dc5bd52853);
$parcel$export(module.exports, "shrSL", () => $ce52a50127d2f5e0$export$a0225ff0aee14e25);
$parcel$export(module.exports, "rotrSH", () => $ce52a50127d2f5e0$export$97f812dfd830ca87);
$parcel$export(module.exports, "rotrSL", () => $ce52a50127d2f5e0$export$60987e30e2c9d9d);
$parcel$export(module.exports, "rotrBH", () => $ce52a50127d2f5e0$export$af9c7fbac44dcb76);
$parcel$export(module.exports, "rotrBL", () => $ce52a50127d2f5e0$export$f619171d6d5ac414);
$parcel$export(module.exports, "rotlSH", () => $ce52a50127d2f5e0$export$4b80a2917447870e);
$parcel$export(module.exports, "rotlSL", () => $ce52a50127d2f5e0$export$20652918a7b63b3);
$parcel$export(module.exports, "rotlBH", () => $ce52a50127d2f5e0$export$a52f14bf902f9977);
$parcel$export(module.exports, "rotlBL", () => $ce52a50127d2f5e0$export$5d12cc1da441323f);
$parcel$export(module.exports, "add", () => $ce52a50127d2f5e0$export$e16d8520af44a096);
$parcel$export(module.exports, "add3L", () => $ce52a50127d2f5e0$export$c0c22b91f08911f);
$parcel$export(module.exports, "add3H", () => $ce52a50127d2f5e0$export$ef7b26044977a8ec);
$parcel$export(module.exports, "add4L", () => $ce52a50127d2f5e0$export$2f4e199c560f545d);
$parcel$export(module.exports, "add4H", () => $ce52a50127d2f5e0$export$e909220d675a7741);
$parcel$export(module.exports, "add5L", () => $ce52a50127d2f5e0$export$d732b061fe9c9ae4);
$parcel$export(module.exports, "add5H", () => $ce52a50127d2f5e0$export$b45ee8d78c965098);
/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const $ce52a50127d2f5e0$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $ce52a50127d2f5e0$var$_32n = /* @__PURE__ */ BigInt(32);
function $ce52a50127d2f5e0$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $ce52a50127d2f5e0$var$U32_MASK64),
        l: Number(n >> $ce52a50127d2f5e0$var$_32n & $ce52a50127d2f5e0$var$U32_MASK64)
    };
    return {
        h: Number(n >> $ce52a50127d2f5e0$var$_32n & $ce52a50127d2f5e0$var$U32_MASK64) | 0,
        l: Number(n & $ce52a50127d2f5e0$var$U32_MASK64) | 0
    };
}
function $ce52a50127d2f5e0$export$65980d18b75784e2(lst, le = false) {
    const len = lst.length;
    let Ah = new Uint32Array(len);
    let Al = new Uint32Array(len);
    for(let i = 0; i < len; i++){
        const { h: h, l: l } = $ce52a50127d2f5e0$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $ce52a50127d2f5e0$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $ce52a50127d2f5e0$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $ce52a50127d2f5e0$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $ce52a50127d2f5e0$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $ce52a50127d2f5e0$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $ce52a50127d2f5e0$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $ce52a50127d2f5e0$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $ce52a50127d2f5e0$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $ce52a50127d2f5e0$export$a088d44bd387d2a3 = (_h, l)=>l;
const $ce52a50127d2f5e0$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $ce52a50127d2f5e0$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $ce52a50127d2f5e0$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $ce52a50127d2f5e0$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $ce52a50127d2f5e0$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $ce52a50127d2f5e0$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $ce52a50127d2f5e0$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $ce52a50127d2f5e0$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $ce52a50127d2f5e0$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $ce52a50127d2f5e0$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $ce52a50127d2f5e0$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $ce52a50127d2f5e0$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $ce52a50127d2f5e0$var$u64 = {
    fromBig: $ce52a50127d2f5e0$export$9625d4333cb56c3f,
    split: $ce52a50127d2f5e0$export$65980d18b75784e2,
    toBig: $ce52a50127d2f5e0$export$30f78adcaaa2eb7,
    shrSH: $ce52a50127d2f5e0$export$75aa78dc5bd52853,
    shrSL: $ce52a50127d2f5e0$export$a0225ff0aee14e25,
    rotrSH: $ce52a50127d2f5e0$export$97f812dfd830ca87,
    rotrSL: $ce52a50127d2f5e0$export$60987e30e2c9d9d,
    rotrBH: $ce52a50127d2f5e0$export$af9c7fbac44dcb76,
    rotrBL: $ce52a50127d2f5e0$export$f619171d6d5ac414,
    rotr32H: $ce52a50127d2f5e0$export$a088d44bd387d2a3,
    rotr32L: $ce52a50127d2f5e0$export$8415aae4d1f69577,
    rotlSH: $ce52a50127d2f5e0$export$4b80a2917447870e,
    rotlSL: $ce52a50127d2f5e0$export$20652918a7b63b3,
    rotlBH: $ce52a50127d2f5e0$export$a52f14bf902f9977,
    rotlBL: $ce52a50127d2f5e0$export$5d12cc1da441323f,
    add: $ce52a50127d2f5e0$export$e16d8520af44a096,
    add3L: $ce52a50127d2f5e0$export$c0c22b91f08911f,
    add3H: $ce52a50127d2f5e0$export$ef7b26044977a8ec,
    add4L: $ce52a50127d2f5e0$export$2f4e199c560f545d,
    add4H: $ce52a50127d2f5e0$export$e909220d675a7741,
    add5H: $ce52a50127d2f5e0$export$b45ee8d78c965098,
    add5L: $ce52a50127d2f5e0$export$d732b061fe9c9ae4
};
var $ce52a50127d2f5e0$export$2e2bcd8739ae039 = $ce52a50127d2f5e0$var$u64;

});

parcelRegister("7MXpH", function(module, exports) {

$parcel$export(module.exports, "anumber", () => $5abb1a6391d8968d$export$75364c6cb16d43b6);
$parcel$export(module.exports, "abytes", () => $5abb1a6391d8968d$export$e8a750b9efad93f5);
$parcel$export(module.exports, "ahash", () => $5abb1a6391d8968d$export$3ff5a4f04de7e52e);
$parcel$export(module.exports, "aexists", () => $5abb1a6391d8968d$export$20871f6b1d047d77);
$parcel$export(module.exports, "aoutput", () => $5abb1a6391d8968d$export$e8e53abee12b995e);
$parcel$export(module.exports, "u32", () => $5abb1a6391d8968d$export$8bacf4ad828c7fe7);
$parcel$export(module.exports, "clean", () => $5abb1a6391d8968d$export$cf0b2a6c63f9e656);
$parcel$export(module.exports, "createView", () => $5abb1a6391d8968d$export$d7febe7b891e79f0);
$parcel$export(module.exports, "rotr", () => $5abb1a6391d8968d$export$466993d7d0d272aa);
$parcel$export(module.exports, "swap32IfBE", () => $5abb1a6391d8968d$export$f3e5ccb1e5f96d20);
$parcel$export(module.exports, "bytesToHex", () => $5abb1a6391d8968d$export$58b867e287a802c8);
$parcel$export(module.exports, "utf8ToBytes", () => $5abb1a6391d8968d$export$3df70a15530b5e81);
$parcel$export(module.exports, "toBytes", () => $5abb1a6391d8968d$export$30a71edf0753ed6b);
$parcel$export(module.exports, "concatBytes", () => $5abb1a6391d8968d$export$287dd7971339c972);
$parcel$export(module.exports, "Hash", () => $5abb1a6391d8968d$export$ab85ecd77ce6a5cd);
$parcel$export(module.exports, "createHasher", () => $5abb1a6391d8968d$export$14b114effbc08b6b);
$parcel$export(module.exports, "createXOFer", () => $5abb1a6391d8968d$export$741ac6dc04ed5295);
$parcel$export(module.exports, "randomBytes", () => $5abb1a6391d8968d$export$5f828d93ff035aa8);
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.

var $9qEFX = parcelRequire("9qEFX");
function $5abb1a6391d8968d$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
function $5abb1a6391d8968d$export$75364c6cb16d43b6(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error("positive integer expected, got " + n);
}
function $5abb1a6391d8968d$export$e8a750b9efad93f5(b, ...lengths) {
    if (!$5abb1a6391d8968d$export$c6fabfbfd097fc30(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error("Uint8Array expected of length " + lengths + ", got length=" + b.length);
}
function $5abb1a6391d8968d$export$3ff5a4f04de7e52e(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.createHasher");
    $5abb1a6391d8968d$export$75364c6cb16d43b6(h.outputLen);
    $5abb1a6391d8968d$export$75364c6cb16d43b6(h.blockLen);
}
function $5abb1a6391d8968d$export$20871f6b1d047d77(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $5abb1a6391d8968d$export$e8e53abee12b995e(out, instance) {
    $5abb1a6391d8968d$export$e8a750b9efad93f5(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error("digestInto() expects output buffer of length at least " + min);
}
function $5abb1a6391d8968d$export$9813fca58c0b9f71(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $5abb1a6391d8968d$export$8bacf4ad828c7fe7(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
function $5abb1a6391d8968d$export$cf0b2a6c63f9e656(...arrays) {
    for(let i = 0; i < arrays.length; i++)arrays[i].fill(0);
}
function $5abb1a6391d8968d$export$d7febe7b891e79f0(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $5abb1a6391d8968d$export$466993d7d0d272aa(word, shift) {
    return word << 32 - shift | word >>> shift;
}
function $5abb1a6391d8968d$export$ac5e39599698b562(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
const $5abb1a6391d8968d$export$a0f88e38d4cf9577 = /* @__PURE__ */ (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
function $5abb1a6391d8968d$export$a4170f7f8be47425(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
const $5abb1a6391d8968d$export$e108944b32ae0e38 = $5abb1a6391d8968d$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$5abb1a6391d8968d$export$a4170f7f8be47425(n);
const $5abb1a6391d8968d$export$4a0a88cc2d284e7f = $5abb1a6391d8968d$export$e108944b32ae0e38;
function $5abb1a6391d8968d$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $5abb1a6391d8968d$export$a4170f7f8be47425(arr[i]);
    return arr;
}
const $5abb1a6391d8968d$export$f3e5ccb1e5f96d20 = $5abb1a6391d8968d$export$a0f88e38d4cf9577 ? (u)=>u : $5abb1a6391d8968d$export$97b40fc37f25d711;
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const $5abb1a6391d8968d$var$hasHexBuiltin = /* @__PURE__ */ (()=>// @ts-ignore
    typeof Uint8Array.from([]).toHex === "function" && typeof Uint8Array.fromHex === "function")();
// Array where index 0xf0 (240) is mapped to string 'f0'
const $5abb1a6391d8968d$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $5abb1a6391d8968d$export$58b867e287a802c8(bytes) {
    $5abb1a6391d8968d$export$e8a750b9efad93f5(bytes);
    // @ts-ignore
    if ($5abb1a6391d8968d$var$hasHexBuiltin) return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $5abb1a6391d8968d$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $5abb1a6391d8968d$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $5abb1a6391d8968d$var$asciiToBase16(ch) {
    if (ch >= $5abb1a6391d8968d$var$asciis._0 && ch <= $5abb1a6391d8968d$var$asciis._9) return ch - $5abb1a6391d8968d$var$asciis._0; // '2' => 50-48
    if (ch >= $5abb1a6391d8968d$var$asciis.A && ch <= $5abb1a6391d8968d$var$asciis.F) return ch - ($5abb1a6391d8968d$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $5abb1a6391d8968d$var$asciis.a && ch <= $5abb1a6391d8968d$var$asciis.f) return ch - ($5abb1a6391d8968d$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
function $5abb1a6391d8968d$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // @ts-ignore
    if ($5abb1a6391d8968d$var$hasHexBuiltin) return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $5abb1a6391d8968d$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $5abb1a6391d8968d$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
const $5abb1a6391d8968d$export$bdd553fddd433dcb = async ()=>{};
async function $5abb1a6391d8968d$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $5abb1a6391d8968d$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $5abb1a6391d8968d$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error("string expected");
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $5abb1a6391d8968d$export$5f46301b4a1d43db(bytes) {
    return new TextDecoder().decode(bytes);
}
function $5abb1a6391d8968d$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $5abb1a6391d8968d$export$3df70a15530b5e81(data);
    $5abb1a6391d8968d$export$e8a750b9efad93f5(data);
    return data;
}
function $5abb1a6391d8968d$export$e01ba4a527b8942d(data) {
    if (typeof data === "string") data = $5abb1a6391d8968d$export$3df70a15530b5e81(data);
    $5abb1a6391d8968d$export$e8a750b9efad93f5(data);
    return data;
}
function $5abb1a6391d8968d$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $5abb1a6391d8968d$export$e8a750b9efad93f5(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $5abb1a6391d8968d$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== "[object Object]") throw new Error("options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
class $5abb1a6391d8968d$export$ab85ecd77ce6a5cd {
}
function $5abb1a6391d8968d$export$14b114effbc08b6b(hashCons) {
    const hashC = (msg)=>hashCons().update($5abb1a6391d8968d$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $5abb1a6391d8968d$export$aaa6b3684f701ca2(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($5abb1a6391d8968d$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $5abb1a6391d8968d$export$741ac6dc04ed5295(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($5abb1a6391d8968d$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
const $5abb1a6391d8968d$export$f081816339df1972 = $5abb1a6391d8968d$export$14b114effbc08b6b;
const $5abb1a6391d8968d$export$b465638d1569a3ae = $5abb1a6391d8968d$export$aaa6b3684f701ca2;
const $5abb1a6391d8968d$export$e18964dbd6e083c1 = $5abb1a6391d8968d$export$741ac6dc04ed5295;
function $5abb1a6391d8968d$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $9qEFX.crypto) && typeof (0, $9qEFX.crypto).getRandomValues === "function") return (0, $9qEFX.crypto).getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ((0, $9qEFX.crypto) && typeof (0, $9qEFX.crypto).randomBytes === "function") return Uint8Array.from((0, $9qEFX.crypto).randomBytes(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}

});
parcelRegister("9qEFX", function(module, exports) {

$parcel$export(module.exports, "crypto", () => $6dd6181f75fdcc9c$export$7effb53edfc7fa2d);
const $6dd6181f75fdcc9c$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("2MUIq", function(module, exports) {

$parcel$export(module.exports, "LruMap", () => $207c0f01af787256$export$fcb3b6cad79d7e3a);
/**
 * Map with a LRU (Least recently used) policy.
 *
 * @link https://en.wikipedia.org/wiki/Cache_replacement_policies#LRU
 */ class $207c0f01af787256$export$fcb3b6cad79d7e3a extends Map {
    constructor(size){
        super();
        Object.defineProperty(this, "maxSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.maxSize = size;
    }
    get(key) {
        const value = super.get(key);
        if (super.has(key) && value !== undefined) {
            this.delete(key);
            super.set(key, value);
        }
        return value;
    }
    set(key, value) {
        super.set(key, value);
        if (this.maxSize && this.size > this.maxSize) {
            const firstKey = this.keys().next().value;
            if (firstKey) this.delete(firstKey);
        }
        return this;
    }
}

});

parcelRegister("lmNDj", function(module, exports) {

$parcel$export(module.exports, "isAddress", () => $f8e2271ded061469$export$977e255126d763d6);

var $2MUIq = parcelRequire("2MUIq");

var $bOQZu = parcelRequire("bOQZu");
const $f8e2271ded061469$var$addressRegex = /^0x[a-fA-F0-9]{40}$/;
const $f8e2271ded061469$export$ef83598cc5072ce = /*#__PURE__*/ new (0, $2MUIq.LruMap)(8192);
function $f8e2271ded061469$export$977e255126d763d6(address, options) {
    const { strict: strict = true } = options ?? {};
    const cacheKey = `${address}.${strict}`;
    if ($f8e2271ded061469$export$ef83598cc5072ce.has(cacheKey)) return $f8e2271ded061469$export$ef83598cc5072ce.get(cacheKey);
    const result = (()=>{
        if (!$f8e2271ded061469$var$addressRegex.test(address)) return false;
        if (address.toLowerCase() === address) return true;
        if (strict) return (0, $bOQZu.checksumAddress)(address) === address;
        return true;
    })();
    $f8e2271ded061469$export$ef83598cc5072ce.set(cacheKey, result);
    return result;
}

});


parcelRegister("jb2AH", function(module, exports) {

$parcel$export(module.exports, "createConnector", () => $df610dec2b821d2d$export$36e7227504c841ea);
function $df610dec2b821d2d$export$36e7227504c841ea(createConnectorFn) {
    return createConnectorFn;
}

});

parcelRegister("e7UPq", function(module, exports) {

$parcel$export(module.exports, "EventEmitter", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("1P3yO")))));

var $1P3yO = parcelRequire("1P3yO");
var $202d49447b79ee6b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($1P3yO)));

});
parcelRegister("1P3yO", function(module, exports) {
"use strict";
var $153d50e76ac8722a$var$has = Object.prototype.hasOwnProperty, $153d50e76ac8722a$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $153d50e76ac8722a$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $153d50e76ac8722a$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $153d50e76ac8722a$var$Events().__proto__) $153d50e76ac8722a$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $153d50e76ac8722a$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $153d50e76ac8722a$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $153d50e76ac8722a$var$EE(fn, context || emitter, once), evt = $153d50e76ac8722a$var$prefix ? $153d50e76ac8722a$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $153d50e76ac8722a$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $153d50e76ac8722a$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $153d50e76ac8722a$var$EventEmitter() {
    this._events = new $153d50e76ac8722a$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $153d50e76ac8722a$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($153d50e76ac8722a$var$has.call(events, name)) names.push($153d50e76ac8722a$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $153d50e76ac8722a$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $153d50e76ac8722a$var$prefix ? $153d50e76ac8722a$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $153d50e76ac8722a$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $153d50e76ac8722a$var$prefix ? $153d50e76ac8722a$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $153d50e76ac8722a$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $153d50e76ac8722a$var$prefix ? $153d50e76ac8722a$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $153d50e76ac8722a$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $153d50e76ac8722a$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $153d50e76ac8722a$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $153d50e76ac8722a$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $153d50e76ac8722a$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $153d50e76ac8722a$var$prefix ? $153d50e76ac8722a$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $153d50e76ac8722a$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $153d50e76ac8722a$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $153d50e76ac8722a$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $153d50e76ac8722a$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $153d50e76ac8722a$var$prefix ? $153d50e76ac8722a$var$prefix + event : event;
        if (this._events[evt]) $153d50e76ac8722a$var$clearEvent(this, evt);
    } else {
        this._events = new $153d50e76ac8722a$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$153d50e76ac8722a$var$EventEmitter.prototype.off = $153d50e76ac8722a$var$EventEmitter.prototype.removeListener;
$153d50e76ac8722a$var$EventEmitter.prototype.addListener = $153d50e76ac8722a$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$153d50e76ac8722a$var$EventEmitter.prefixed = $153d50e76ac8722a$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$153d50e76ac8722a$var$EventEmitter.EventEmitter = $153d50e76ac8722a$var$EventEmitter;
module.exports = $153d50e76ac8722a$var$EventEmitter;

});


parcelRegister("04Jxx", function(module, exports) {

$parcel$export(module.exports, "concat", () => $00e3b323c1539a91$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "concatHex", () => $00e3b323c1539a91$export$f6cc0b64b5a999af);
function $00e3b323c1539a91$export$ee1b3e54f0441b22(values) {
    if (typeof values[0] === "string") return $00e3b323c1539a91$export$f6cc0b64b5a999af(values);
    return $00e3b323c1539a91$export$287dd7971339c972(values);
}
function $00e3b323c1539a91$export$287dd7971339c972(values) {
    let length = 0;
    for (const arr of values)length += arr.length;
    const result = new Uint8Array(length);
    let offset = 0;
    for (const arr of values){
        result.set(arr, offset);
        offset += arr.length;
    }
    return result;
}
function $00e3b323c1539a91$export$f6cc0b64b5a999af(values) {
    return `0x${values.reduce((acc, x)=>acc + x.replace("0x", ""), "")}`;
}

});

parcelRegister("6kbuD", function(module, exports) {

$parcel$export(module.exports, "sha256", () => $49ad86a1720db57c$export$bced8d2aada2d1c9);
/**
 * SHA2-256 a.k.a. sha256. In JS, it is the fastest hash, even faster than Blake3.
 *
 * To break sha256 using birthday attack, attackers need to try 2^128 hashes.
 * BTC network is doing 2^70 hashes/sec (2^95 hashes/year) as per 2025.
 *
 * Check out [FIPS 180-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf).
 * @module
 * @deprecated
 */ 
var $2UD1v = parcelRequire("2UD1v");
const $49ad86a1720db57c$export$397b834fceb5b168 = (0, $2UD1v.SHA256);
const $49ad86a1720db57c$export$bced8d2aada2d1c9 = (0, $2UD1v.sha256);
const $49ad86a1720db57c$export$d90fcf4a65424421 = (0, $2UD1v.SHA224);
const $49ad86a1720db57c$export$97b70509d4e397ea = (0, $2UD1v.sha224);

});
parcelRegister("2UD1v", function(module, exports) {

$parcel$export(module.exports, "SHA256", () => $21ef14eeb56ca594$export$397b834fceb5b168);
$parcel$export(module.exports, "SHA224", () => $21ef14eeb56ca594$export$d90fcf4a65424421);
$parcel$export(module.exports, "sha256", () => $21ef14eeb56ca594$export$bced8d2aada2d1c9);
$parcel$export(module.exports, "sha224", () => $21ef14eeb56ca594$export$97b70509d4e397ea);
$parcel$export(module.exports, "sha512", () => $21ef14eeb56ca594$export$a888d2532e6dc7bb);
/**
 * SHA2 hash function. A.k.a. sha256, sha384, sha512, sha512_224, sha512_256.
 * SHA256 is the fastest hash implementable in JS, even faster than Blake3.
 * Check out [RFC 4634](https://datatracker.ietf.org/doc/html/rfc4634) and
 * [FIPS 180-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf).
 * @module
 */ 
var $bZKId = parcelRequire("bZKId");

var $hIfB5 = parcelRequire("hIfB5");

var $7MXpH = parcelRequire("7MXpH");
/**
 * Round constants:
 * First 32 bits of fractional parts of the cube roots of the first 64 primes 2..311)
 */ // prettier-ignore
const $21ef14eeb56ca594$var$SHA256_K = /* @__PURE__ */ Uint32Array.from([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Reusable temporary buffer. "W" comes straight from spec. */ const $21ef14eeb56ca594$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $21ef14eeb56ca594$export$397b834fceb5b168 extends (0, $bZKId.HashMD) {
    constructor(outputLen = 32){
        super(64, outputLen, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = (0, $bZKId.SHA256_IV)[0] | 0;
        this.B = (0, $bZKId.SHA256_IV)[1] | 0;
        this.C = (0, $bZKId.SHA256_IV)[2] | 0;
        this.D = (0, $bZKId.SHA256_IV)[3] | 0;
        this.E = (0, $bZKId.SHA256_IV)[4] | 0;
        this.F = (0, $bZKId.SHA256_IV)[5] | 0;
        this.G = (0, $bZKId.SHA256_IV)[6] | 0;
        this.H = (0, $bZKId.SHA256_IV)[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$21ef14eeb56ca594$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $21ef14eeb56ca594$var$SHA256_W[i - 15];
            const W2 = $21ef14eeb56ca594$var$SHA256_W[i - 2];
            const s0 = (0, $7MXpH.rotr)(W15, 7) ^ (0, $7MXpH.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $7MXpH.rotr)(W2, 17) ^ (0, $7MXpH.rotr)(W2, 19) ^ W2 >>> 10;
            $21ef14eeb56ca594$var$SHA256_W[i] = s1 + $21ef14eeb56ca594$var$SHA256_W[i - 7] + s0 + $21ef14eeb56ca594$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $7MXpH.rotr)(E, 6) ^ (0, $7MXpH.rotr)(E, 11) ^ (0, $7MXpH.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $bZKId.Chi)(E, F, G) + $21ef14eeb56ca594$var$SHA256_K[i] + $21ef14eeb56ca594$var$SHA256_W[i] | 0;
            const sigma0 = (0, $7MXpH.rotr)(A, 2) ^ (0, $7MXpH.rotr)(A, 13) ^ (0, $7MXpH.rotr)(A, 22);
            const T2 = sigma0 + (0, $bZKId.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        (0, $7MXpH.clean)($21ef14eeb56ca594$var$SHA256_W);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        (0, $7MXpH.clean)(this.buffer);
    }
}
class $21ef14eeb56ca594$export$d90fcf4a65424421 extends $21ef14eeb56ca594$export$397b834fceb5b168 {
    constructor(){
        super(28);
        this.A = (0, $bZKId.SHA224_IV)[0] | 0;
        this.B = (0, $bZKId.SHA224_IV)[1] | 0;
        this.C = (0, $bZKId.SHA224_IV)[2] | 0;
        this.D = (0, $bZKId.SHA224_IV)[3] | 0;
        this.E = (0, $bZKId.SHA224_IV)[4] | 0;
        this.F = (0, $bZKId.SHA224_IV)[5] | 0;
        this.G = (0, $bZKId.SHA224_IV)[6] | 0;
        this.H = (0, $bZKId.SHA224_IV)[7] | 0;
    }
}
// SHA2-512 is slower than sha256 in js because u64 operations are slow.
// Round contants
// First 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409
// prettier-ignore
const $21ef14eeb56ca594$var$K512 = /* @__PURE__ */ (()=>$hIfB5.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
const $21ef14eeb56ca594$var$SHA512_Kh = /* @__PURE__ */ (()=>$21ef14eeb56ca594$var$K512[0])();
const $21ef14eeb56ca594$var$SHA512_Kl = /* @__PURE__ */ (()=>$21ef14eeb56ca594$var$K512[1])();
// Reusable temporary buffers
const $21ef14eeb56ca594$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $21ef14eeb56ca594$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $21ef14eeb56ca594$export$d655fdb8a1cad5df extends (0, $bZKId.HashMD) {
    constructor(outputLen = 64){
        super(128, outputLen, 16, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = (0, $bZKId.SHA512_IV)[0] | 0;
        this.Al = (0, $bZKId.SHA512_IV)[1] | 0;
        this.Bh = (0, $bZKId.SHA512_IV)[2] | 0;
        this.Bl = (0, $bZKId.SHA512_IV)[3] | 0;
        this.Ch = (0, $bZKId.SHA512_IV)[4] | 0;
        this.Cl = (0, $bZKId.SHA512_IV)[5] | 0;
        this.Dh = (0, $bZKId.SHA512_IV)[6] | 0;
        this.Dl = (0, $bZKId.SHA512_IV)[7] | 0;
        this.Eh = (0, $bZKId.SHA512_IV)[8] | 0;
        this.El = (0, $bZKId.SHA512_IV)[9] | 0;
        this.Fh = (0, $bZKId.SHA512_IV)[10] | 0;
        this.Fl = (0, $bZKId.SHA512_IV)[11] | 0;
        this.Gh = (0, $bZKId.SHA512_IV)[12] | 0;
        this.Gl = (0, $bZKId.SHA512_IV)[13] | 0;
        this.Hh = (0, $bZKId.SHA512_IV)[14] | 0;
        this.Hl = (0, $bZKId.SHA512_IV)[15] | 0;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $21ef14eeb56ca594$var$SHA512_W_H[i] = view.getUint32(offset);
            $21ef14eeb56ca594$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $21ef14eeb56ca594$var$SHA512_W_H[i - 15] | 0;
            const W15l = $21ef14eeb56ca594$var$SHA512_W_L[i - 15] | 0;
            const s0h = $hIfB5.rotrSH(W15h, W15l, 1) ^ $hIfB5.rotrSH(W15h, W15l, 8) ^ $hIfB5.shrSH(W15h, W15l, 7);
            const s0l = $hIfB5.rotrSL(W15h, W15l, 1) ^ $hIfB5.rotrSL(W15h, W15l, 8) ^ $hIfB5.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $21ef14eeb56ca594$var$SHA512_W_H[i - 2] | 0;
            const W2l = $21ef14eeb56ca594$var$SHA512_W_L[i - 2] | 0;
            const s1h = $hIfB5.rotrSH(W2h, W2l, 19) ^ $hIfB5.rotrBH(W2h, W2l, 61) ^ $hIfB5.shrSH(W2h, W2l, 6);
            const s1l = $hIfB5.rotrSL(W2h, W2l, 19) ^ $hIfB5.rotrBL(W2h, W2l, 61) ^ $hIfB5.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $hIfB5.add4L(s0l, s1l, $21ef14eeb56ca594$var$SHA512_W_L[i - 7], $21ef14eeb56ca594$var$SHA512_W_L[i - 16]);
            const SUMh = $hIfB5.add4H(SUMl, s0h, s1h, $21ef14eeb56ca594$var$SHA512_W_H[i - 7], $21ef14eeb56ca594$var$SHA512_W_H[i - 16]);
            $21ef14eeb56ca594$var$SHA512_W_H[i] = SUMh | 0;
            $21ef14eeb56ca594$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $hIfB5.rotrSH(Eh, El, 14) ^ $hIfB5.rotrSH(Eh, El, 18) ^ $hIfB5.rotrBH(Eh, El, 41);
            const sigma1l = $hIfB5.rotrSL(Eh, El, 14) ^ $hIfB5.rotrSL(Eh, El, 18) ^ $hIfB5.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $hIfB5.add5L(Hl, sigma1l, CHIl, $21ef14eeb56ca594$var$SHA512_Kl[i], $21ef14eeb56ca594$var$SHA512_W_L[i]);
            const T1h = $hIfB5.add5H(T1ll, Hh, sigma1h, CHIh, $21ef14eeb56ca594$var$SHA512_Kh[i], $21ef14eeb56ca594$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $hIfB5.rotrSH(Ah, Al, 28) ^ $hIfB5.rotrBH(Ah, Al, 34) ^ $hIfB5.rotrBH(Ah, Al, 39);
            const sigma0l = $hIfB5.rotrSL(Ah, Al, 28) ^ $hIfB5.rotrBL(Ah, Al, 34) ^ $hIfB5.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $hIfB5.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $hIfB5.add3L(T1l, sigma0l, MAJl);
            Ah = $hIfB5.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $hIfB5.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $hIfB5.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $hIfB5.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $hIfB5.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $hIfB5.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $hIfB5.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $hIfB5.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $hIfB5.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        (0, $7MXpH.clean)($21ef14eeb56ca594$var$SHA512_W_H, $21ef14eeb56ca594$var$SHA512_W_L);
    }
    destroy() {
        (0, $7MXpH.clean)(this.buffer);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
class $21ef14eeb56ca594$export$b4bd5cd48f62bcf0 extends $21ef14eeb56ca594$export$d655fdb8a1cad5df {
    constructor(){
        super(48);
        this.Ah = (0, $bZKId.SHA384_IV)[0] | 0;
        this.Al = (0, $bZKId.SHA384_IV)[1] | 0;
        this.Bh = (0, $bZKId.SHA384_IV)[2] | 0;
        this.Bl = (0, $bZKId.SHA384_IV)[3] | 0;
        this.Ch = (0, $bZKId.SHA384_IV)[4] | 0;
        this.Cl = (0, $bZKId.SHA384_IV)[5] | 0;
        this.Dh = (0, $bZKId.SHA384_IV)[6] | 0;
        this.Dl = (0, $bZKId.SHA384_IV)[7] | 0;
        this.Eh = (0, $bZKId.SHA384_IV)[8] | 0;
        this.El = (0, $bZKId.SHA384_IV)[9] | 0;
        this.Fh = (0, $bZKId.SHA384_IV)[10] | 0;
        this.Fl = (0, $bZKId.SHA384_IV)[11] | 0;
        this.Gh = (0, $bZKId.SHA384_IV)[12] | 0;
        this.Gl = (0, $bZKId.SHA384_IV)[13] | 0;
        this.Hh = (0, $bZKId.SHA384_IV)[14] | 0;
        this.Hl = (0, $bZKId.SHA384_IV)[15] | 0;
    }
}
/**
 * Truncated SHA512/256 and SHA512/224.
 * SHA512_IV is XORed with 0xa5a5a5a5a5a5a5a5, then used as "intermediary" IV of SHA512/t.
 * Then t hashes string to produce result IV.
 * See `test/misc/sha2-gen-iv.js`.
 */ /** SHA512/224 IV */ const $21ef14eeb56ca594$var$T224_IV = /* @__PURE__ */ Uint32Array.from([
    0x8c3d37c8,
    0x19544da2,
    0x73e19966,
    0x89dcd4d6,
    0x1dfab7ae,
    0x32ff9c82,
    0x679dd514,
    0x582f9fcf,
    0x0f6d2b69,
    0x7bd44da8,
    0x77e36f73,
    0x04c48942,
    0x3f9d85a8,
    0x6a1d36c8,
    0x1112e6ad,
    0x91d692a1
]);
/** SHA512/256 IV */ const $21ef14eeb56ca594$var$T256_IV = /* @__PURE__ */ Uint32Array.from([
    0x22312194,
    0xfc2bf72c,
    0x9f555fa3,
    0xc84c64c2,
    0x2393b86b,
    0x6f53b151,
    0x96387719,
    0x5940eabd,
    0x96283ee2,
    0xa88effe3,
    0xbe5e1e25,
    0x53863992,
    0x2b0199fc,
    0x2c85b8aa,
    0x0eb72ddc,
    0x81c52ca2
]);
class $21ef14eeb56ca594$export$9269e18873efb8a1 extends $21ef14eeb56ca594$export$d655fdb8a1cad5df {
    constructor(){
        super(28);
        this.Ah = $21ef14eeb56ca594$var$T224_IV[0] | 0;
        this.Al = $21ef14eeb56ca594$var$T224_IV[1] | 0;
        this.Bh = $21ef14eeb56ca594$var$T224_IV[2] | 0;
        this.Bl = $21ef14eeb56ca594$var$T224_IV[3] | 0;
        this.Ch = $21ef14eeb56ca594$var$T224_IV[4] | 0;
        this.Cl = $21ef14eeb56ca594$var$T224_IV[5] | 0;
        this.Dh = $21ef14eeb56ca594$var$T224_IV[6] | 0;
        this.Dl = $21ef14eeb56ca594$var$T224_IV[7] | 0;
        this.Eh = $21ef14eeb56ca594$var$T224_IV[8] | 0;
        this.El = $21ef14eeb56ca594$var$T224_IV[9] | 0;
        this.Fh = $21ef14eeb56ca594$var$T224_IV[10] | 0;
        this.Fl = $21ef14eeb56ca594$var$T224_IV[11] | 0;
        this.Gh = $21ef14eeb56ca594$var$T224_IV[12] | 0;
        this.Gl = $21ef14eeb56ca594$var$T224_IV[13] | 0;
        this.Hh = $21ef14eeb56ca594$var$T224_IV[14] | 0;
        this.Hl = $21ef14eeb56ca594$var$T224_IV[15] | 0;
    }
}
class $21ef14eeb56ca594$export$70b84015054354f1 extends $21ef14eeb56ca594$export$d655fdb8a1cad5df {
    constructor(){
        super(32);
        this.Ah = $21ef14eeb56ca594$var$T256_IV[0] | 0;
        this.Al = $21ef14eeb56ca594$var$T256_IV[1] | 0;
        this.Bh = $21ef14eeb56ca594$var$T256_IV[2] | 0;
        this.Bl = $21ef14eeb56ca594$var$T256_IV[3] | 0;
        this.Ch = $21ef14eeb56ca594$var$T256_IV[4] | 0;
        this.Cl = $21ef14eeb56ca594$var$T256_IV[5] | 0;
        this.Dh = $21ef14eeb56ca594$var$T256_IV[6] | 0;
        this.Dl = $21ef14eeb56ca594$var$T256_IV[7] | 0;
        this.Eh = $21ef14eeb56ca594$var$T256_IV[8] | 0;
        this.El = $21ef14eeb56ca594$var$T256_IV[9] | 0;
        this.Fh = $21ef14eeb56ca594$var$T256_IV[10] | 0;
        this.Fl = $21ef14eeb56ca594$var$T256_IV[11] | 0;
        this.Gh = $21ef14eeb56ca594$var$T256_IV[12] | 0;
        this.Gl = $21ef14eeb56ca594$var$T256_IV[13] | 0;
        this.Hh = $21ef14eeb56ca594$var$T256_IV[14] | 0;
        this.Hl = $21ef14eeb56ca594$var$T256_IV[15] | 0;
    }
}
const $21ef14eeb56ca594$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $7MXpH.createHasher)(()=>new $21ef14eeb56ca594$export$397b834fceb5b168());
const $21ef14eeb56ca594$export$97b70509d4e397ea = /* @__PURE__ */ (0, $7MXpH.createHasher)(()=>new $21ef14eeb56ca594$export$d90fcf4a65424421());
const $21ef14eeb56ca594$export$a888d2532e6dc7bb = /* @__PURE__ */ (0, $7MXpH.createHasher)(()=>new $21ef14eeb56ca594$export$d655fdb8a1cad5df());
const $21ef14eeb56ca594$export$612d47d55dedde45 = /* @__PURE__ */ (0, $7MXpH.createHasher)(()=>new $21ef14eeb56ca594$export$b4bd5cd48f62bcf0());
const $21ef14eeb56ca594$export$c78786b6da86db2a = /* @__PURE__ */ (0, $7MXpH.createHasher)(()=>new $21ef14eeb56ca594$export$70b84015054354f1());
const $21ef14eeb56ca594$export$a090a04f72f0a320 = /* @__PURE__ */ (0, $7MXpH.createHasher)(()=>new $21ef14eeb56ca594$export$9269e18873efb8a1());

});
parcelRegister("bZKId", function(module, exports) {

$parcel$export(module.exports, "Chi", () => $8bb9a0444ce49488$export$d0d97f016526eaf0);
$parcel$export(module.exports, "Maj", () => $8bb9a0444ce49488$export$8b1d810b1bd30adf);
$parcel$export(module.exports, "HashMD", () => $8bb9a0444ce49488$export$f9f830659f932cb2);
$parcel$export(module.exports, "SHA256_IV", () => $8bb9a0444ce49488$export$a986fdf7a5bdfdf8);
$parcel$export(module.exports, "SHA224_IV", () => $8bb9a0444ce49488$export$104dc246f4c65f21);
$parcel$export(module.exports, "SHA384_IV", () => $8bb9a0444ce49488$export$b5217b4b948279ee);
$parcel$export(module.exports, "SHA512_IV", () => $8bb9a0444ce49488$export$f2cbb88a1784d2d1);
/**
 * Internal Merkle-Damgard hash utils.
 * @module
 */ 
var $7MXpH = parcelRequire("7MXpH");
function $8bb9a0444ce49488$export$b13f930c762582ab(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
function $8bb9a0444ce49488$export$d0d97f016526eaf0(a, b, c) {
    return a & b ^ ~a & c;
}
function $8bb9a0444ce49488$export$8b1d810b1bd30adf(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
class $8bb9a0444ce49488$export$f9f830659f932cb2 extends (0, $7MXpH.Hash) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $7MXpH.createView)(this.buffer);
    }
    update(data) {
        (0, $7MXpH.aexists)(this);
        data = (0, $7MXpH.toBytes)(data);
        (0, $7MXpH.abytes)(data);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $7MXpH.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $7MXpH.aexists)(this);
        (0, $7MXpH.aoutput)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        (0, $7MXpH.clean)(this.buffer.subarray(pos));
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $8bb9a0444ce49488$export$b13f930c762582ab(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $7MXpH.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.destroyed = destroyed;
        to.finished = finished;
        to.length = length;
        to.pos = pos;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
}
const $8bb9a0444ce49488$export$a986fdf7a5bdfdf8 = /* @__PURE__ */ Uint32Array.from([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
const $8bb9a0444ce49488$export$104dc246f4c65f21 = /* @__PURE__ */ Uint32Array.from([
    0xc1059ed8,
    0x367cd507,
    0x3070dd17,
    0xf70e5939,
    0xffc00b31,
    0x68581511,
    0x64f98fa7,
    0xbefa4fa4
]);
const $8bb9a0444ce49488$export$b5217b4b948279ee = /* @__PURE__ */ Uint32Array.from([
    0xcbbb9d5d,
    0xc1059ed8,
    0x629a292a,
    0x367cd507,
    0x9159015a,
    0x3070dd17,
    0x152fecd8,
    0xf70e5939,
    0x67332667,
    0xffc00b31,
    0x8eb44a87,
    0x68581511,
    0xdb0c2e0d,
    0x64f98fa7,
    0x47b5481d,
    0xbefa4fa4
]);
const $8bb9a0444ce49488$export$f2cbb88a1784d2d1 = /* @__PURE__ */ Uint32Array.from([
    0x6a09e667,
    0xf3bcc908,
    0xbb67ae85,
    0x84caa73b,
    0x3c6ef372,
    0xfe94f82b,
    0xa54ff53a,
    0x5f1d36f1,
    0x510e527f,
    0xade682d1,
    0x9b05688c,
    0x2b3e6c1f,
    0x1f83d9ab,
    0xfb41bd6b,
    0x5be0cd19,
    0x137e2179
]);

});



parcelRegister("7hOjg", function(module, exports) {

$parcel$export(module.exports, "panicReasons", () => $54e125645cea626d$export$a618024566d3d221);
$parcel$export(module.exports, "solidityError", () => $54e125645cea626d$export$730e9cc7aaa8ca20);
$parcel$export(module.exports, "solidityPanic", () => $54e125645cea626d$export$e45b3aea1c5b33e6);
// https://docs.soliditylang.org/en/v0.8.16/control-structures.html#panic-via-assert-and-error-via-require
const $54e125645cea626d$export$a618024566d3d221 = {
    1: "An `assert` condition failed.",
    17: "Arithmetic operation resulted in underflow or overflow.",
    18: "Division or modulo by zero (e.g. `5 / 0` or `23 % 0`).",
    33: "Attempted to convert to an invalid type.",
    34: "Attempted to access a storage byte array that is incorrectly encoded.",
    49: "Performed `.pop()` on an empty array",
    50: "Array index is out of bounds.",
    65: "Allocated too much memory or created an array which is too large.",
    81: "Attempted to call a zero-initialized variable of internal function type."
};
const $54e125645cea626d$export$730e9cc7aaa8ca20 = {
    inputs: [
        {
            name: "message",
            type: "string"
        }
    ],
    name: "Error",
    type: "error"
};
const $54e125645cea626d$export$e45b3aea1c5b33e6 = {
    inputs: [
        {
            name: "reason",
            type: "uint256"
        }
    ],
    name: "Panic",
    type: "error"
};

});

parcelRegister("cvXjB", function(module, exports) {

$parcel$export(module.exports, "decodeErrorResult", () => $91c6640f313cbef5$export$8f7898b7bcae6080);

var $7hOjg = parcelRequire("7hOjg");

var $ie3rb = parcelRequire("ie3rb");

var $g4WYS = parcelRequire("g4WYS");

var $dUPAH = parcelRequire("dUPAH");

var $dY2s0 = parcelRequire("dY2s0");

var $gDCe1 = parcelRequire("gDCe1");
function $91c6640f313cbef5$export$8f7898b7bcae6080(parameters) {
    const { abi: abi, data: data } = parameters;
    const signature = (0, $g4WYS.slice)(data, 0, 4);
    if (signature === "0x") throw new (0, $ie3rb.AbiDecodingZeroDataError)();
    const abi_ = [
        ...abi || [],
        (0, $7hOjg.solidityError),
        (0, $7hOjg.solidityPanic)
    ];
    const abiItem = abi_.find((x)=>x.type === "error" && signature === (0, $dUPAH.toFunctionSelector)((0, $gDCe1.formatAbiItem)(x)));
    if (!abiItem) throw new (0, $ie3rb.AbiErrorSignatureNotFoundError)(signature, {
        docsPath: "/docs/contract/decodeErrorResult"
    });
    return {
        abiItem: abiItem,
        args: "inputs" in abiItem && abiItem.inputs && abiItem.inputs.length > 0 ? (0, $dY2s0.decodeAbiParameters)(abiItem.inputs, (0, $g4WYS.slice)(data, 4)) : undefined,
        errorName: abiItem.name
    };
}

});
parcelRegister("ie3rb", function(module, exports) {

$parcel$export(module.exports, "AbiConstructorNotFoundError", () => $d44c336850f2a894$export$efa723f306cf6168);
$parcel$export(module.exports, "AbiConstructorParamsNotFoundError", () => $d44c336850f2a894$export$4faec14323ef9c47);
$parcel$export(module.exports, "AbiDecodingDataSizeTooSmallError", () => $d44c336850f2a894$export$7a409e433c5f3a8c);
$parcel$export(module.exports, "AbiDecodingZeroDataError", () => $d44c336850f2a894$export$a063cde4013f1935);
$parcel$export(module.exports, "AbiEncodingArrayLengthMismatchError", () => $d44c336850f2a894$export$a851da9bf50b557);
$parcel$export(module.exports, "AbiEncodingBytesSizeMismatchError", () => $d44c336850f2a894$export$19c281dc8e23a2ea);
$parcel$export(module.exports, "AbiEncodingLengthMismatchError", () => $d44c336850f2a894$export$20737d495bb13c2d);
$parcel$export(module.exports, "AbiErrorInputsNotFoundError", () => $d44c336850f2a894$export$d47cf5ef47eda817);
$parcel$export(module.exports, "AbiErrorNotFoundError", () => $d44c336850f2a894$export$86b719574b683f04);
$parcel$export(module.exports, "AbiErrorSignatureNotFoundError", () => $d44c336850f2a894$export$8959cb729fefe1ea);
$parcel$export(module.exports, "AbiEventSignatureEmptyTopicsError", () => $d44c336850f2a894$export$f83210ce5f9b901f);
$parcel$export(module.exports, "AbiEventSignatureNotFoundError", () => $d44c336850f2a894$export$3b44baeac92e4d3a);
$parcel$export(module.exports, "AbiFunctionNotFoundError", () => $d44c336850f2a894$export$c4faa308ea7f9b2);
$parcel$export(module.exports, "AbiFunctionOutputsNotFoundError", () => $d44c336850f2a894$export$26f2edb605108b34);
$parcel$export(module.exports, "AbiFunctionSignatureNotFoundError", () => $d44c336850f2a894$export$14373147a0e60810);
$parcel$export(module.exports, "AbiItemAmbiguityError", () => $d44c336850f2a894$export$fdbba54ba15f2c2d);
$parcel$export(module.exports, "DecodeLogDataMismatch", () => $d44c336850f2a894$export$3978f86c08fc8c25);
$parcel$export(module.exports, "DecodeLogTopicsMismatch", () => $d44c336850f2a894$export$6d7c6f419cf52377);
$parcel$export(module.exports, "InvalidAbiEncodingTypeError", () => $d44c336850f2a894$export$53ed98b886965f49);
$parcel$export(module.exports, "InvalidAbiDecodingTypeError", () => $d44c336850f2a894$export$cf94ccff0ff97c65);
$parcel$export(module.exports, "InvalidArrayError", () => $d44c336850f2a894$export$710dd6d4f78cc47e);
$parcel$export(module.exports, "InvalidDefinitionTypeError", () => $d44c336850f2a894$export$81781a0fcfb9ed95);

var $gDCe1 = parcelRequire("gDCe1");

var $loik3 = parcelRequire("loik3");

var $3cVvs = parcelRequire("3cVvs");
class $d44c336850f2a894$export$efa723f306cf6168 extends (0, $3cVvs.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            "A constructor was not found on the ABI.",
            "Make sure you are using the correct ABI and that the constructor exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiConstructorNotFoundError"
        });
    }
}
class $d44c336850f2a894$export$4faec14323ef9c47 extends (0, $3cVvs.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            "Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.",
            "Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiConstructorParamsNotFoundError"
        });
    }
}
class $d44c336850f2a894$export$68a7b570091cba69 extends (0, $3cVvs.BaseError) {
    constructor({ data: data, size: size }){
        super([
            `Data size of ${size} bytes is invalid.`,
            "Size must be in increments of 32 bytes (size % 32 === 0)."
        ].join("\n"), {
            metaMessages: [
                `Data: ${data} (${size} bytes)`
            ],
            name: "AbiDecodingDataSizeInvalidError"
        });
    }
}
class $d44c336850f2a894$export$7a409e433c5f3a8c extends (0, $3cVvs.BaseError) {
    constructor({ data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for given parameters.`
        ].join("\n"), {
            metaMessages: [
                `Params: (${(0, $gDCe1.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ],
            name: "AbiDecodingDataSizeTooSmallError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $d44c336850f2a894$export$a063cde4013f1935 extends (0, $3cVvs.BaseError) {
    constructor(){
        super('Cannot decode zero data ("0x") with ABI parameters.', {
            name: "AbiDecodingZeroDataError"
        });
    }
}
class $d44c336850f2a894$export$a851da9bf50b557 extends (0, $3cVvs.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength, type: type }){
        super([
            `ABI encoding array length mismatch for type ${type}.`,
            `Expected length: ${expectedLength}`,
            `Given length: ${givenLength}`
        ].join("\n"), {
            name: "AbiEncodingArrayLengthMismatchError"
        });
    }
}
class $d44c336850f2a894$export$19c281dc8e23a2ea extends (0, $3cVvs.BaseError) {
    constructor({ expectedSize: expectedSize, value: value }){
        super(`Size of bytes "${value}" (bytes${(0, $loik3.size)(value)}) does not match expected size (bytes${expectedSize}).`, {
            name: "AbiEncodingBytesSizeMismatchError"
        });
    }
}
class $d44c336850f2a894$export$20737d495bb13c2d extends (0, $3cVvs.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength }){
        super([
            "ABI encoding params/values length mismatch.",
            `Expected length (params): ${expectedLength}`,
            `Given length (values): ${givenLength}`
        ].join("\n"), {
            name: "AbiEncodingLengthMismatchError"
        });
    }
}
class $d44c336850f2a894$export$d47cf5ef47eda817 extends (0, $3cVvs.BaseError) {
    constructor(errorName, { docsPath: docsPath }){
        super([
            `Arguments (\`args\`) were provided to "${errorName}", but "${errorName}" on the ABI does not contain any parameters (\`inputs\`).`,
            "Cannot encode error result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the inputs exist on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorInputsNotFoundError"
        });
    }
}
class $d44c336850f2a894$export$86b719574b683f04 extends (0, $3cVvs.BaseError) {
    constructor(errorName, { docsPath: docsPath } = {}){
        super([
            `Error ${errorName ? `"${errorName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the error exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorNotFoundError"
        });
    }
}
class $d44c336850f2a894$export$8959cb729fefe1ea extends (0, $3cVvs.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded error signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the error exists on it.",
            `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorSignatureNotFoundError"
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.signature = signature;
    }
}
class $d44c336850f2a894$export$f83210ce5f9b901f extends (0, $3cVvs.BaseError) {
    constructor({ docsPath: docsPath }){
        super("Cannot extract event signature from empty topics.", {
            docsPath: docsPath,
            name: "AbiEventSignatureEmptyTopicsError"
        });
    }
}
class $d44c336850f2a894$export$3b44baeac92e4d3a extends (0, $3cVvs.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded event signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the event exists on it.",
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiEventSignatureNotFoundError"
        });
    }
}
class $d44c336850f2a894$export$c7be62baad13b157 extends (0, $3cVvs.BaseError) {
    constructor(eventName, { docsPath: docsPath } = {}){
        super([
            `Event ${eventName ? `"${eventName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the event exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiEventNotFoundError"
        });
    }
}
class $d44c336850f2a894$export$c4faa308ea7f9b2 extends (0, $3cVvs.BaseError) {
    constructor(functionName, { docsPath: docsPath } = {}){
        super([
            `Function ${functionName ? `"${functionName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionNotFoundError"
        });
    }
}
class $d44c336850f2a894$export$26f2edb605108b34 extends (0, $3cVvs.BaseError) {
    constructor(functionName, { docsPath: docsPath }){
        super([
            `Function "${functionName}" does not contain any \`outputs\` on ABI.`,
            "Cannot decode function result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionOutputsNotFoundError"
        });
    }
}
class $d44c336850f2a894$export$14373147a0e60810 extends (0, $3cVvs.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded function signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the function exists on it.",
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionSignatureNotFoundError"
        });
    }
}
class $d44c336850f2a894$export$fdbba54ba15f2c2d extends (0, $3cVvs.BaseError) {
    constructor(x, y){
        super("Found ambiguous types in overloaded ABI items.", {
            metaMessages: [
                `\`${x.type}\` in \`${(0, $gDCe1.formatAbiItem)(x.abiItem)}\`, and`,
                `\`${y.type}\` in \`${(0, $gDCe1.formatAbiItem)(y.abiItem)}\``,
                "",
                "These types encode differently and cannot be distinguished at runtime.",
                "Remove one of the ambiguous items in the ABI."
            ],
            name: "AbiItemAmbiguityError"
        });
    }
}
class $d44c336850f2a894$export$a0eb884ede5c87eb extends (0, $3cVvs.BaseError) {
    constructor({ expectedSize: expectedSize, givenSize: givenSize }){
        super(`Expected bytes${expectedSize}, got bytes${givenSize}.`, {
            name: "BytesSizeMismatchError"
        });
    }
}
class $d44c336850f2a894$export$3978f86c08fc8c25 extends (0, $3cVvs.BaseError) {
    constructor({ abiItem: abiItem, data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for non-indexed event parameters.`
        ].join("\n"), {
            metaMessages: [
                `Params: (${(0, $gDCe1.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ],
            name: "DecodeLogDataMismatch"
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $d44c336850f2a894$export$6d7c6f419cf52377 extends (0, $3cVvs.BaseError) {
    constructor({ abiItem: abiItem, param: param }){
        super([
            `Expected a topic for indexed event parameter${param.name ? ` "${param.name}"` : ""} on event "${(0, $gDCe1.formatAbiItem)(abiItem, {
                includeName: true
            })}".`
        ].join("\n"), {
            name: "DecodeLogTopicsMismatch"
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
    }
}
class $d44c336850f2a894$export$53ed98b886965f49 extends (0, $3cVvs.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid encoding type.`,
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath,
            name: "InvalidAbiEncodingType"
        });
    }
}
class $d44c336850f2a894$export$cf94ccff0ff97c65 extends (0, $3cVvs.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid decoding type.`,
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath,
            name: "InvalidAbiDecodingType"
        });
    }
}
class $d44c336850f2a894$export$710dd6d4f78cc47e extends (0, $3cVvs.BaseError) {
    constructor(value){
        super([
            `Value "${value}" is not a valid array.`
        ].join("\n"), {
            name: "InvalidArrayError"
        });
    }
}
class $d44c336850f2a894$export$81781a0fcfb9ed95 extends (0, $3cVvs.BaseError) {
    constructor(type){
        super([
            `"${type}" is not a valid definition type.`,
            'Valid types: "function", "event", "error"'
        ].join("\n"), {
            name: "InvalidDefinitionTypeError"
        });
    }
}
class $d44c336850f2a894$export$a16541e2fe420ef1 extends (0, $3cVvs.BaseError) {
    constructor(type){
        super(`Type "${type}" is not supported for packed encoding.`, {
            name: "UnsupportedPackedAbiType"
        });
    }
}

});
parcelRegister("gDCe1", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", () => $c1cdf0986d7eda12$export$dc5d0ff4fc2fdee1);
$parcel$export(module.exports, "formatAbiParams", () => $c1cdf0986d7eda12$export$849e499971de75b3);

var $ie3rb = parcelRequire("ie3rb");
function $c1cdf0986d7eda12$export$dc5d0ff4fc2fdee1(abiItem, { includeName: includeName = false } = {}) {
    if (abiItem.type !== "function" && abiItem.type !== "event" && abiItem.type !== "error") throw new (0, $ie3rb.InvalidDefinitionTypeError)(abiItem.type);
    return `${abiItem.name}(${$c1cdf0986d7eda12$export$849e499971de75b3(abiItem.inputs, {
        includeName: includeName
    })})`;
}
function $c1cdf0986d7eda12$export$849e499971de75b3(params, { includeName: includeName = false } = {}) {
    if (!params) return "";
    return params.map((param)=>$c1cdf0986d7eda12$var$formatAbiParam(param, {
            includeName: includeName
        })).join(includeName ? ", " : ",");
}
function $c1cdf0986d7eda12$var$formatAbiParam(param, { includeName: includeName }) {
    if (param.type.startsWith("tuple")) return `(${$c1cdf0986d7eda12$export$849e499971de75b3(param.components, {
        includeName: includeName
    })})${param.type.slice(5)}`;
    return param.type + (includeName && param.name ? ` ${param.name}` : "");
}

});


parcelRegister("g4WYS", function(module, exports) {

$parcel$export(module.exports, "slice", () => $bb4ac5719e0c9044$export$58adb3bec8346d0f);
$parcel$export(module.exports, "sliceBytes", () => $bb4ac5719e0c9044$export$8bac03c8c1da551);

var $9et7x = parcelRequire("9et7x");

var $ifibB = parcelRequire("ifibB");

var $loik3 = parcelRequire("loik3");
function $bb4ac5719e0c9044$export$58adb3bec8346d0f(value, start, end, { strict: strict } = {}) {
    if ((0, $ifibB.isHex)(value, {
        strict: false
    })) return $bb4ac5719e0c9044$export$728fe14c970402fe(value, start, end, {
        strict: strict
    });
    return $bb4ac5719e0c9044$export$8bac03c8c1da551(value, start, end, {
        strict: strict
    });
}
function $bb4ac5719e0c9044$var$assertStartOffset(value, start) {
    if (typeof start === "number" && start > 0 && start > (0, $loik3.size)(value) - 1) throw new (0, $9et7x.SliceOffsetOutOfBoundsError)({
        offset: start,
        position: "start",
        size: (0, $loik3.size)(value)
    });
}
function $bb4ac5719e0c9044$var$assertEndOffset(value, start, end) {
    if (typeof start === "number" && typeof end === "number" && (0, $loik3.size)(value) !== end - start) throw new (0, $9et7x.SliceOffsetOutOfBoundsError)({
        offset: end,
        position: "end",
        size: (0, $loik3.size)(value)
    });
}
function $bb4ac5719e0c9044$export$8bac03c8c1da551(value_, start, end, { strict: strict } = {}) {
    $bb4ac5719e0c9044$var$assertStartOffset(value_, start);
    const value = value_.slice(start, end);
    if (strict) $bb4ac5719e0c9044$var$assertEndOffset(value, start, end);
    return value;
}
function $bb4ac5719e0c9044$export$728fe14c970402fe(value_, start, end, { strict: strict } = {}) {
    $bb4ac5719e0c9044$var$assertStartOffset(value_, start);
    const value = `0x${value_.replace("0x", "").slice((start ?? 0) * 2, (end ?? value_.length) * 2)}`;
    if (strict) $bb4ac5719e0c9044$var$assertEndOffset(value, start, end);
    return value;
}

});

parcelRegister("dUPAH", function(module, exports) {

$parcel$export(module.exports, "toFunctionSelector", () => $a21886339e33ea34$export$e2442488533809cb);

var $g4WYS = parcelRequire("g4WYS");

var $4knKV = parcelRequire("4knKV");
const $a21886339e33ea34$export$e2442488533809cb = (fn)=>(0, $g4WYS.slice)((0, $4knKV.toSignatureHash)(fn), 0, 4);

});
parcelRegister("4knKV", function(module, exports) {

$parcel$export(module.exports, "toSignatureHash", () => $326b751fcf55c341$export$d809beebc9c913db);

var $eBHoY = parcelRequire("eBHoY");

var $e008v = parcelRequire("e008v");
function $326b751fcf55c341$export$d809beebc9c913db(fn) {
    return (0, $eBHoY.hashSignature)((0, $e008v.toSignature)(fn));
}

});
parcelRegister("eBHoY", function(module, exports) {

$parcel$export(module.exports, "hashSignature", () => $aa263016b621dd05$export$77bbcd7aaec17976);

var $lbhq0 = parcelRequire("lbhq0");

var $bHm1a = parcelRequire("bHm1a");
const $aa263016b621dd05$var$hash = (value)=>(0, $bHm1a.keccak256)((0, $lbhq0.toBytes)(value));
function $aa263016b621dd05$export$77bbcd7aaec17976(sig) {
    return $aa263016b621dd05$var$hash(sig);
}

});

parcelRegister("e008v", function(module, exports) {

$parcel$export(module.exports, "toSignature", () => $a3112bd60cf5a121$export$d075a2fd83e0ecb);

var $2kDuZ = parcelRequire("2kDuZ");

var $e7QuX = parcelRequire("e7QuX");
const $a3112bd60cf5a121$export$d075a2fd83e0ecb = (def)=>{
    const def_ = (()=>{
        if (typeof def === "string") return def;
        return (0, $2kDuZ.formatAbiItem)(def);
    })();
    return (0, $e7QuX.normalizeSignature)(def_);
};

});
parcelRegister("2kDuZ", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", () => $1b2c16ab2f850693$export$dc5d0ff4fc2fdee1);

var $2H3SC = parcelRequire("2H3SC");
function $1b2c16ab2f850693$export$dc5d0ff4fc2fdee1(abiItem) {
    if (abiItem.type === "function") return `function ${abiItem.name}(${(0, $2H3SC.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability && abiItem.stateMutability !== "nonpayable" ? ` ${abiItem.stateMutability}` : ""}${abiItem.outputs?.length ? ` returns (${(0, $2H3SC.formatAbiParameters)(abiItem.outputs)})` : ""}`;
    if (abiItem.type === "event") return `event ${abiItem.name}(${(0, $2H3SC.formatAbiParameters)(abiItem.inputs)})`;
    if (abiItem.type === "error") return `error ${abiItem.name}(${(0, $2H3SC.formatAbiParameters)(abiItem.inputs)})`;
    if (abiItem.type === "constructor") return `constructor(${(0, $2H3SC.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability === "payable" ? " payable" : ""}`;
    if (abiItem.type === "fallback") return `fallback() external${abiItem.stateMutability === "payable" ? " payable" : ""}`;
    return "receive() external payable";
}

});
parcelRegister("2H3SC", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameters", () => $1f629b68d6b04469$export$c55dbda1a081631e);

var $9FWvf = parcelRequire("9FWvf");
function $1f629b68d6b04469$export$c55dbda1a081631e(abiParameters) {
    let params = "";
    const length = abiParameters.length;
    for(let i = 0; i < length; i++){
        const abiParameter = abiParameters[i];
        params += (0, $9FWvf.formatAbiParameter)(abiParameter);
        if (i !== length - 1) params += ", ";
    }
    return params;
}

});
parcelRegister("9FWvf", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameter", () => $70b552e016e006af$export$c75e01ebc733dc6b);

var $71OGG = parcelRequire("71OGG");
// https://regexr.com/7f7rv
const $70b552e016e006af$var$tupleRegex = /^tuple(?<array>(\[(\d*)\])*)$/;
function $70b552e016e006af$export$c75e01ebc733dc6b(abiParameter) {
    let type = abiParameter.type;
    if ($70b552e016e006af$var$tupleRegex.test(abiParameter.type) && "components" in abiParameter) {
        type = "(";
        const length = abiParameter.components.length;
        for(let i = 0; i < length; i++){
            const component = abiParameter.components[i];
            type += $70b552e016e006af$export$c75e01ebc733dc6b(component);
            if (i < length - 1) type += ", ";
        }
        const result = (0, $71OGG.execTyped)($70b552e016e006af$var$tupleRegex, abiParameter.type);
        type += `)${result?.array ?? ""}`;
        return $70b552e016e006af$export$c75e01ebc733dc6b({
            ...abiParameter,
            type: type
        });
    }
    // Add `indexed` to type if in `abiParameter`
    if ("indexed" in abiParameter && abiParameter.indexed) type = `${type} indexed`;
    // Return human-readable ABI parameter
    if (abiParameter.name) return `${type} ${abiParameter.name}`;
    return type;
}

});
parcelRegister("71OGG", function(module, exports) {

$parcel$export(module.exports, "execTyped", () => $51dff1db04d4487f$export$1cca4755fb17f5bd);
$parcel$export(module.exports, "bytesRegex", () => $51dff1db04d4487f$export$94d7303c0d9f263a);
$parcel$export(module.exports, "integerRegex", () => $51dff1db04d4487f$export$45902cc189596eef);
$parcel$export(module.exports, "isTupleRegex", () => $51dff1db04d4487f$export$5c1628af1434aed0);
// TODO: This looks cool. Need to check the performance of `new RegExp` versus defined inline though.
// https://twitter.com/GabrielVergnaud/status/1622906834343366657
function $51dff1db04d4487f$export$1cca4755fb17f5bd(regex, string) {
    const match = regex.exec(string);
    return match?.groups;
}
const $51dff1db04d4487f$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $51dff1db04d4487f$export$45902cc189596eef = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
const $51dff1db04d4487f$export$5c1628af1434aed0 = /^\(.+?\).*?$/;

});




parcelRegister("e7QuX", function(module, exports) {

$parcel$export(module.exports, "normalizeSignature", () => $a48a71351339de14$export$5cba87ebe4d0307a);

var $3cVvs = parcelRequire("3cVvs");
function $a48a71351339de14$export$5cba87ebe4d0307a(signature) {
    let active = true;
    let current = "";
    let level = 0;
    let result = "";
    let valid = false;
    for(let i = 0; i < signature.length; i++){
        const char = signature[i];
        // If the character is a separator, we want to reactivate.
        if ([
            "(",
            ")",
            ","
        ].includes(char)) active = true;
        // If the character is a "level" token, we want to increment/decrement.
        if (char === "(") level++;
        if (char === ")") level--;
        // If we aren't active, we don't want to mutate the result.
        if (!active) continue;
        // If level === 0, we are at the definition level.
        if (level === 0) {
            if (char === " " && [
                "event",
                "function",
                ""
            ].includes(result)) result = "";
            else {
                result += char;
                // If we are at the end of the definition, we must be finished.
                if (char === ")") {
                    valid = true;
                    break;
                }
            }
            continue;
        }
        // Ignore spaces
        if (char === " ") {
            // If the previous character is a separator, and the current section isn't empty, we want to deactivate.
            if (signature[i - 1] !== "," && current !== "," && current !== ",(") {
                current = "";
                active = false;
            }
            continue;
        }
        result += char;
        current += char;
    }
    if (!valid) throw new (0, $3cVvs.BaseError)("Unable to normalize signature.");
    return result;
}

});




parcelRegister("dY2s0", function(module, exports) {

$parcel$export(module.exports, "decodeAbiParameters", () => $a2b2c79e33333da6$export$84d51ac2fffabd56);

var $ie3rb = parcelRequire("ie3rb");

var $bOQZu = parcelRequire("bOQZu");

var $7gKPm = parcelRequire("7gKPm");

var $loik3 = parcelRequire("loik3");

var $g4WYS = parcelRequire("g4WYS");

var $4Khm8 = parcelRequire("4Khm8");

var $6gETe = parcelRequire("6gETe");

var $lbhq0 = parcelRequire("lbhq0");

var $nDot9 = parcelRequire("nDot9");

var $fMLNX = parcelRequire("fMLNX");
function $a2b2c79e33333da6$export$84d51ac2fffabd56(params, data) {
    const bytes = typeof data === "string" ? (0, $lbhq0.hexToBytes)(data) : data;
    const cursor = (0, $7gKPm.createCursor)(bytes);
    if ((0, $loik3.size)(bytes) === 0 && params.length > 0) throw new (0, $ie3rb.AbiDecodingZeroDataError)();
    if ((0, $loik3.size)(data) && (0, $loik3.size)(data) < 32) throw new (0, $ie3rb.AbiDecodingDataSizeTooSmallError)({
        data: typeof data === "string" ? data : (0, $nDot9.bytesToHex)(data),
        params: params,
        size: (0, $loik3.size)(data)
    });
    let consumed = 0;
    const values = [];
    for(let i = 0; i < params.length; ++i){
        const param = params[i];
        cursor.setPosition(consumed);
        const [data, consumed_] = $a2b2c79e33333da6$var$decodeParameter(cursor, param, {
            staticPosition: 0
        });
        consumed += consumed_;
        values.push(data);
    }
    return values;
}
function $a2b2c79e33333da6$var$decodeParameter(cursor, param, { staticPosition: staticPosition }) {
    const arrayComponents = (0, $fMLNX.getArrayComponents)(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $a2b2c79e33333da6$var$decodeArray(cursor, {
            ...param,
            type: type
        }, {
            length: length,
            staticPosition: staticPosition
        });
    }
    if (param.type === "tuple") return $a2b2c79e33333da6$var$decodeTuple(cursor, param, {
        staticPosition: staticPosition
    });
    if (param.type === "address") return $a2b2c79e33333da6$var$decodeAddress(cursor);
    if (param.type === "bool") return $a2b2c79e33333da6$var$decodeBool(cursor);
    if (param.type.startsWith("bytes")) return $a2b2c79e33333da6$var$decodeBytes(cursor, param, {
        staticPosition: staticPosition
    });
    if (param.type.startsWith("uint") || param.type.startsWith("int")) return $a2b2c79e33333da6$var$decodeNumber(cursor, param);
    if (param.type === "string") return $a2b2c79e33333da6$var$decodeString(cursor, {
        staticPosition: staticPosition
    });
    throw new (0, $ie3rb.InvalidAbiDecodingTypeError)(param.type, {
        docsPath: "/docs/contract/decodeAbiParameters"
    });
}
////////////////////////////////////////////////////////////////////
// Type Decoders
const $a2b2c79e33333da6$var$sizeOfLength = 32;
const $a2b2c79e33333da6$var$sizeOfOffset = 32;
function $a2b2c79e33333da6$var$decodeAddress(cursor) {
    const value = cursor.readBytes(32);
    return [
        (0, $bOQZu.checksumAddress)((0, $nDot9.bytesToHex)((0, $g4WYS.sliceBytes)(value, -20))),
        32
    ];
}
function $a2b2c79e33333da6$var$decodeArray(cursor, param, { length: length, staticPosition: staticPosition }) {
    // If the length of the array is not known in advance (dynamic array),
    // this means we will need to wonder off to the pointer and decode.
    if (!length) {
        // Dealing with a dynamic type, so get the offset of the array data.
        const offset = (0, $6gETe.bytesToNumber)(cursor.readBytes($a2b2c79e33333da6$var$sizeOfOffset));
        // Start is the static position of current slot + offset.
        const start = staticPosition + offset;
        const startOfData = start + $a2b2c79e33333da6$var$sizeOfLength;
        // Get the length of the array from the offset.
        cursor.setPosition(start);
        const length = (0, $6gETe.bytesToNumber)(cursor.readBytes($a2b2c79e33333da6$var$sizeOfLength));
        // Check if the array has any dynamic children.
        const dynamicChild = $a2b2c79e33333da6$var$hasDynamicChild(param);
        let consumed = 0;
        const value = [];
        for(let i = 0; i < length; ++i){
            // If any of the children is dynamic, then all elements will be offset pointer, thus size of one slot (32 bytes).
            // Otherwise, elements will be the size of their encoding (consumed bytes).
            cursor.setPosition(startOfData + (dynamicChild ? i * 32 : consumed));
            const [data, consumed_] = $a2b2c79e33333da6$var$decodeParameter(cursor, param, {
                staticPosition: startOfData
            });
            consumed += consumed_;
            value.push(data);
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the length of the array is known in advance,
    // and the length of an element deeply nested in the array is not known,
    // we need to decode the offset of the array data.
    if ($a2b2c79e33333da6$var$hasDynamicChild(param)) {
        // Dealing with dynamic types, so get the offset of the array data.
        const offset = (0, $6gETe.bytesToNumber)(cursor.readBytes($a2b2c79e33333da6$var$sizeOfOffset));
        // Start is the static position of current slot + offset.
        const start = staticPosition + offset;
        const value = [];
        for(let i = 0; i < length; ++i){
            // Move cursor along to the next slot (next offset pointer).
            cursor.setPosition(start + i * 32);
            const [data] = $a2b2c79e33333da6$var$decodeParameter(cursor, param, {
                staticPosition: start
            });
            value.push(data);
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the length of the array is known in advance and the array is deeply static,
    // then we can just decode each element in sequence.
    let consumed = 0;
    const value = [];
    for(let i = 0; i < length; ++i){
        const [data, consumed_] = $a2b2c79e33333da6$var$decodeParameter(cursor, param, {
            staticPosition: staticPosition + consumed
        });
        consumed += consumed_;
        value.push(data);
    }
    return [
        value,
        consumed
    ];
}
function $a2b2c79e33333da6$var$decodeBool(cursor) {
    return [
        (0, $6gETe.bytesToBool)(cursor.readBytes(32), {
            size: 32
        }),
        32
    ];
}
function $a2b2c79e33333da6$var$decodeBytes(cursor, param, { staticPosition: staticPosition }) {
    const [_, size] = param.type.split("bytes");
    if (!size) {
        // Dealing with dynamic types, so get the offset of the bytes data.
        const offset = (0, $6gETe.bytesToNumber)(cursor.readBytes(32));
        // Set position of the cursor to start of bytes data.
        cursor.setPosition(staticPosition + offset);
        const length = (0, $6gETe.bytesToNumber)(cursor.readBytes(32));
        // If there is no length, we have zero data.
        if (length === 0) {
            // As we have gone wondering, restore to the original position + next slot.
            cursor.setPosition(staticPosition + 32);
            return [
                "0x",
                32
            ];
        }
        const data = cursor.readBytes(length);
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            (0, $nDot9.bytesToHex)(data),
            32
        ];
    }
    const value = (0, $nDot9.bytesToHex)(cursor.readBytes(Number.parseInt(size), 32));
    return [
        value,
        32
    ];
}
function $a2b2c79e33333da6$var$decodeNumber(cursor, param) {
    const signed = param.type.startsWith("int");
    const size = Number.parseInt(param.type.split("int")[1] || "256");
    const value = cursor.readBytes(32);
    return [
        size > 48 ? (0, $6gETe.bytesToBigInt)(value, {
            signed: signed
        }) : (0, $6gETe.bytesToNumber)(value, {
            signed: signed
        }),
        32
    ];
}
function $a2b2c79e33333da6$var$decodeTuple(cursor, param, { staticPosition: staticPosition }) {
    // Tuples can have unnamed components (i.e. they are arrays), so we must
    // determine whether the tuple is named or unnamed. In the case of a named
    // tuple, the value will be an object where each property is the name of the
    // component. In the case of an unnamed tuple, the value will be an array.
    const hasUnnamedChild = param.components.length === 0 || param.components.some(({ name: name })=>!name);
    // Initialize the value to an object or an array, depending on whether the
    // tuple is named or unnamed.
    const value = hasUnnamedChild ? [] : {};
    let consumed = 0;
    // If the tuple has a dynamic child, we must first decode the offset to the
    // tuple data.
    if ($a2b2c79e33333da6$var$hasDynamicChild(param)) {
        // Dealing with dynamic types, so get the offset of the tuple data.
        const offset = (0, $6gETe.bytesToNumber)(cursor.readBytes($a2b2c79e33333da6$var$sizeOfOffset));
        // Start is the static position of referencing slot + offset.
        const start = staticPosition + offset;
        for(let i = 0; i < param.components.length; ++i){
            const component = param.components[i];
            cursor.setPosition(start + consumed);
            const [data, consumed_] = $a2b2c79e33333da6$var$decodeParameter(cursor, component, {
                staticPosition: start
            });
            consumed += consumed_;
            value[hasUnnamedChild ? i : component?.name] = data;
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the tuple has static children, we can just decode each component
    // in sequence.
    for(let i = 0; i < param.components.length; ++i){
        const component = param.components[i];
        const [data, consumed_] = $a2b2c79e33333da6$var$decodeParameter(cursor, component, {
            staticPosition: staticPosition
        });
        value[hasUnnamedChild ? i : component?.name] = data;
        consumed += consumed_;
    }
    return [
        value,
        consumed
    ];
}
function $a2b2c79e33333da6$var$decodeString(cursor, { staticPosition: staticPosition }) {
    // Get offset to start of string data.
    const offset = (0, $6gETe.bytesToNumber)(cursor.readBytes(32));
    // Start is the static position of current slot + offset.
    const start = staticPosition + offset;
    cursor.setPosition(start);
    const length = (0, $6gETe.bytesToNumber)(cursor.readBytes(32));
    // If there is no length, we have zero data (empty string).
    if (length === 0) {
        cursor.setPosition(staticPosition + 32);
        return [
            "",
            32
        ];
    }
    const data = cursor.readBytes(length, 32);
    const value = (0, $6gETe.bytesToString)((0, $4Khm8.trim)(data));
    // As we have gone wondering, restore to the original position + next slot.
    cursor.setPosition(staticPosition + 32);
    return [
        value,
        32
    ];
}
function $a2b2c79e33333da6$var$hasDynamicChild(param) {
    const { type: type } = param;
    if (type === "string") return true;
    if (type === "bytes") return true;
    if (type.endsWith("[]")) return true;
    if (type === "tuple") return param.components?.some($a2b2c79e33333da6$var$hasDynamicChild);
    const arrayComponents = (0, $fMLNX.getArrayComponents)(param.type);
    if (arrayComponents && $a2b2c79e33333da6$var$hasDynamicChild({
        ...param,
        type: arrayComponents[1]
    })) return true;
    return false;
}

});
parcelRegister("7gKPm", function(module, exports) {

$parcel$export(module.exports, "createCursor", () => $54ae59f9be0cce65$export$fb542681b7c0dc55);

var $h6fPA = parcelRequire("h6fPA");
const $54ae59f9be0cce65$var$staticCursor = {
    bytes: new Uint8Array(),
    dataView: new DataView(new ArrayBuffer(0)),
    position: 0,
    positionReadCount: new Map(),
    recursiveReadCount: 0,
    recursiveReadLimit: Number.POSITIVE_INFINITY,
    assertReadLimit () {
        if (this.recursiveReadCount >= this.recursiveReadLimit) throw new (0, $h6fPA.RecursiveReadLimitExceededError)({
            count: this.recursiveReadCount + 1,
            limit: this.recursiveReadLimit
        });
    },
    assertPosition (position) {
        if (position < 0 || position > this.bytes.length - 1) throw new (0, $h6fPA.PositionOutOfBoundsError)({
            length: this.bytes.length,
            position: position
        });
    },
    decrementPosition (offset) {
        if (offset < 0) throw new (0, $h6fPA.NegativeOffsetError)({
            offset: offset
        });
        const position = this.position - offset;
        this.assertPosition(position);
        this.position = position;
    },
    getReadCount (position) {
        return this.positionReadCount.get(position || this.position) || 0;
    },
    incrementPosition (offset) {
        if (offset < 0) throw new (0, $h6fPA.NegativeOffsetError)({
            offset: offset
        });
        const position = this.position + offset;
        this.assertPosition(position);
        this.position = position;
    },
    inspectByte (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectBytes (length, position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + length - 1);
        return this.bytes.subarray(position, position + length);
    },
    inspectUint8 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectUint16 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 1);
        return this.dataView.getUint16(position);
    },
    inspectUint24 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 2);
        return (this.dataView.getUint16(position) << 8) + this.dataView.getUint8(position + 2);
    },
    inspectUint32 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 3);
        return this.dataView.getUint32(position);
    },
    pushByte (byte) {
        this.assertPosition(this.position);
        this.bytes[this.position] = byte;
        this.position++;
    },
    pushBytes (bytes) {
        this.assertPosition(this.position + bytes.length - 1);
        this.bytes.set(bytes, this.position);
        this.position += bytes.length;
    },
    pushUint8 (value) {
        this.assertPosition(this.position);
        this.bytes[this.position] = value;
        this.position++;
    },
    pushUint16 (value) {
        this.assertPosition(this.position + 1);
        this.dataView.setUint16(this.position, value);
        this.position += 2;
    },
    pushUint24 (value) {
        this.assertPosition(this.position + 2);
        this.dataView.setUint16(this.position, value >> 8);
        this.dataView.setUint8(this.position + 2, value & 255);
        this.position += 3;
    },
    pushUint32 (value) {
        this.assertPosition(this.position + 3);
        this.dataView.setUint32(this.position, value);
        this.position += 4;
    },
    readByte () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectByte();
        this.position++;
        return value;
    },
    readBytes (length, size) {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectBytes(length);
        this.position += size ?? length;
        return value;
    },
    readUint8 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint8();
        this.position += 1;
        return value;
    },
    readUint16 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint16();
        this.position += 2;
        return value;
    },
    readUint24 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint24();
        this.position += 3;
        return value;
    },
    readUint32 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint32();
        this.position += 4;
        return value;
    },
    get remaining () {
        return this.bytes.length - this.position;
    },
    setPosition (position) {
        const oldPosition = this.position;
        this.assertPosition(position);
        this.position = position;
        return ()=>this.position = oldPosition;
    },
    _touch () {
        if (this.recursiveReadLimit === Number.POSITIVE_INFINITY) return;
        const count = this.getReadCount();
        this.positionReadCount.set(this.position, count + 1);
        if (count > 0) this.recursiveReadCount++;
    }
};
function $54ae59f9be0cce65$export$fb542681b7c0dc55(bytes, { recursiveReadLimit: recursiveReadLimit = 8192 } = {}) {
    const cursor = Object.create($54ae59f9be0cce65$var$staticCursor);
    cursor.bytes = bytes;
    cursor.dataView = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    cursor.positionReadCount = new Map();
    cursor.recursiveReadLimit = recursiveReadLimit;
    return cursor;
}

});
parcelRegister("h6fPA", function(module, exports) {

$parcel$export(module.exports, "NegativeOffsetError", () => $033670a0a82fed75$export$4741ff085e62ac19);
$parcel$export(module.exports, "PositionOutOfBoundsError", () => $033670a0a82fed75$export$72dcc4230cbf50ba);
$parcel$export(module.exports, "RecursiveReadLimitExceededError", () => $033670a0a82fed75$export$4952f5c6336a7cc7);

var $3cVvs = parcelRequire("3cVvs");
class $033670a0a82fed75$export$4741ff085e62ac19 extends (0, $3cVvs.BaseError) {
    constructor({ offset: offset }){
        super(`Offset \`${offset}\` cannot be negative.`, {
            name: "NegativeOffsetError"
        });
    }
}
class $033670a0a82fed75$export$72dcc4230cbf50ba extends (0, $3cVvs.BaseError) {
    constructor({ length: length, position: position }){
        super(`Position \`${position}\` is out of bounds (\`0 < position < ${length}\`).`, {
            name: "PositionOutOfBoundsError"
        });
    }
}
class $033670a0a82fed75$export$4952f5c6336a7cc7 extends (0, $3cVvs.BaseError) {
    constructor({ count: count, limit: limit }){
        super(`Recursive read limit of \`${limit}\` exceeded (recursive read count: \`${count}\`).`, {
            name: "RecursiveReadLimitExceededError"
        });
    }
}

});


parcelRegister("6gETe", function(module, exports) {

$parcel$export(module.exports, "bytesToNumber", () => $4903f497739c1573$export$c0cca17bcf674749);
$parcel$export(module.exports, "bytesToBigInt", () => $4903f497739c1573$export$2a52511e4f35930a);
$parcel$export(module.exports, "bytesToBool", () => $4903f497739c1573$export$aa06fda122958d5d);
$parcel$export(module.exports, "bytesToString", () => $4903f497739c1573$export$7c746b75f47c9c7d);

var $k04Zp = parcelRequire("k04Zp");

var $4Khm8 = parcelRequire("4Khm8");

var $9Hxnd = parcelRequire("9Hxnd");

var $nDot9 = parcelRequire("nDot9");
function $4903f497739c1573$export$de2da3025c30316c(bytes, toOrOpts) {
    const opts = typeof toOrOpts === "string" ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === "number") return $4903f497739c1573$export$c0cca17bcf674749(bytes, opts);
    if (to === "bigint") return $4903f497739c1573$export$2a52511e4f35930a(bytes, opts);
    if (to === "boolean") return $4903f497739c1573$export$aa06fda122958d5d(bytes, opts);
    if (to === "string") return $4903f497739c1573$export$7c746b75f47c9c7d(bytes, opts);
    return (0, $nDot9.bytesToHex)(bytes, opts);
}
function $4903f497739c1573$export$2a52511e4f35930a(bytes, opts = {}) {
    if (typeof opts.size !== "undefined") (0, $9Hxnd.assertSize)(bytes, {
        size: opts.size
    });
    const hex = (0, $nDot9.bytesToHex)(bytes, opts);
    return (0, $9Hxnd.hexToBigInt)(hex, opts);
}
function $4903f497739c1573$export$aa06fda122958d5d(bytes_, opts = {}) {
    let bytes = bytes_;
    if (typeof opts.size !== "undefined") {
        (0, $9Hxnd.assertSize)(bytes, {
            size: opts.size
        });
        bytes = (0, $4Khm8.trim)(bytes);
    }
    if (bytes.length > 1 || bytes[0] > 1) throw new (0, $k04Zp.InvalidBytesBooleanError)(bytes);
    return Boolean(bytes[0]);
}
function $4903f497739c1573$export$c0cca17bcf674749(bytes, opts = {}) {
    if (typeof opts.size !== "undefined") (0, $9Hxnd.assertSize)(bytes, {
        size: opts.size
    });
    const hex = (0, $nDot9.bytesToHex)(bytes, opts);
    return (0, $9Hxnd.hexToNumber)(hex, opts);
}
function $4903f497739c1573$export$7c746b75f47c9c7d(bytes_, opts = {}) {
    let bytes = bytes_;
    if (typeof opts.size !== "undefined") {
        (0, $9Hxnd.assertSize)(bytes, {
            size: opts.size
        });
        bytes = (0, $4Khm8.trim)(bytes, {
            dir: "right"
        });
    }
    return new TextDecoder().decode(bytes);
}

});

parcelRegister("fMLNX", function(module, exports) {

$parcel$export(module.exports, "encodeAbiParameters", () => $b7e06bc4048d0723$export$448ea0950d6dd7d7);
$parcel$export(module.exports, "getArrayComponents", () => $b7e06bc4048d0723$export$ab502cfdbb1a0d07);

var $ie3rb = parcelRequire("ie3rb");

var $cegbN = parcelRequire("cegbN");

var $3cVvs = parcelRequire("3cVvs");

var $k04Zp = parcelRequire("k04Zp");

var $lmNDj = parcelRequire("lmNDj");

var $04Jxx = parcelRequire("04Jxx");

var $aS9j8 = parcelRequire("aS9j8");

var $loik3 = parcelRequire("loik3");

var $g4WYS = parcelRequire("g4WYS");

var $nDot9 = parcelRequire("nDot9");

var $4kdiC = parcelRequire("4kdiC");
function $b7e06bc4048d0723$export$448ea0950d6dd7d7(params, values) {
    if (params.length !== values.length) throw new (0, $ie3rb.AbiEncodingLengthMismatchError)({
        expectedLength: params.length,
        givenLength: values.length
    });
    // Prepare the parameters to determine dynamic types to encode.
    const preparedParams = $b7e06bc4048d0723$var$prepareParams({
        params: params,
        values: values
    });
    const data = $b7e06bc4048d0723$var$encodeParams(preparedParams);
    if (data.length === 0) return "0x";
    return data;
}
function $b7e06bc4048d0723$var$prepareParams({ params: params, values: values }) {
    const preparedParams = [];
    for(let i = 0; i < params.length; i++)preparedParams.push($b7e06bc4048d0723$var$prepareParam({
        param: params[i],
        value: values[i]
    }));
    return preparedParams;
}
function $b7e06bc4048d0723$var$prepareParam({ param: param, value: value }) {
    const arrayComponents = $b7e06bc4048d0723$export$ab502cfdbb1a0d07(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $b7e06bc4048d0723$var$encodeArray(value, {
            length: length,
            param: {
                ...param,
                type: type
            }
        });
    }
    if (param.type === "tuple") return $b7e06bc4048d0723$var$encodeTuple(value, {
        param: param
    });
    if (param.type === "address") return $b7e06bc4048d0723$var$encodeAddress(value);
    if (param.type === "bool") return $b7e06bc4048d0723$var$encodeBool(value);
    if (param.type.startsWith("uint") || param.type.startsWith("int")) {
        const signed = param.type.startsWith("int");
        const [, , size = "256"] = (0, $4kdiC.integerRegex).exec(param.type) ?? [];
        return $b7e06bc4048d0723$var$encodeNumber(value, {
            signed: signed,
            size: Number(size)
        });
    }
    if (param.type.startsWith("bytes")) return $b7e06bc4048d0723$var$encodeBytes(value, {
        param: param
    });
    if (param.type === "string") return $b7e06bc4048d0723$var$encodeString(value);
    throw new (0, $ie3rb.InvalidAbiEncodingTypeError)(param.type, {
        docsPath: "/docs/contract/encodeAbiParameters"
    });
}
function $b7e06bc4048d0723$var$encodeParams(preparedParams) {
    // 1. Compute the size of the static part of the parameters.
    let staticSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) staticSize += 32;
        else staticSize += (0, $loik3.size)(encoded);
    }
    // 2. Split the parameters into static and dynamic parts.
    const staticParams = [];
    const dynamicParams = [];
    let dynamicSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) {
            staticParams.push((0, $nDot9.numberToHex)(staticSize + dynamicSize, {
                size: 32
            }));
            dynamicParams.push(encoded);
            dynamicSize += (0, $loik3.size)(encoded);
        } else staticParams.push(encoded);
    }
    // 3. Concatenate static and dynamic parts.
    return (0, $04Jxx.concat)([
        ...staticParams,
        ...dynamicParams
    ]);
}
function $b7e06bc4048d0723$var$encodeAddress(value) {
    if (!(0, $lmNDj.isAddress)(value)) throw new (0, $cegbN.InvalidAddressError)({
        address: value
    });
    return {
        dynamic: false,
        encoded: (0, $aS9j8.padHex)(value.toLowerCase())
    };
}
function $b7e06bc4048d0723$var$encodeArray(value, { length: length, param: param }) {
    const dynamic = length === null;
    if (!Array.isArray(value)) throw new (0, $ie3rb.InvalidArrayError)(value);
    if (!dynamic && value.length !== length) throw new (0, $ie3rb.AbiEncodingArrayLengthMismatchError)({
        expectedLength: length,
        givenLength: value.length,
        type: `${param.type}[${length}]`
    });
    let dynamicChild = false;
    const preparedParams = [];
    for(let i = 0; i < value.length; i++){
        const preparedParam = $b7e06bc4048d0723$var$prepareParam({
            param: param,
            value: value[i]
        });
        if (preparedParam.dynamic) dynamicChild = true;
        preparedParams.push(preparedParam);
    }
    if (dynamic || dynamicChild) {
        const data = $b7e06bc4048d0723$var$encodeParams(preparedParams);
        if (dynamic) {
            const length = (0, $nDot9.numberToHex)(preparedParams.length, {
                size: 32
            });
            return {
                dynamic: true,
                encoded: preparedParams.length > 0 ? (0, $04Jxx.concat)([
                    length,
                    data
                ]) : length
            };
        }
        if (dynamicChild) return {
            dynamic: true,
            encoded: data
        };
    }
    return {
        dynamic: false,
        encoded: (0, $04Jxx.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $b7e06bc4048d0723$var$encodeBytes(value, { param: param }) {
    const [, paramSize] = param.type.split("bytes");
    const bytesSize = (0, $loik3.size)(value);
    if (!paramSize) {
        let value_ = value;
        // If the size is not divisible by 32 bytes, pad the end
        // with empty bytes to the ceiling 32 bytes.
        if (bytesSize % 32 !== 0) value_ = (0, $aS9j8.padHex)(value_, {
            dir: "right",
            size: Math.ceil((value.length - 2) / 2 / 32) * 32
        });
        return {
            dynamic: true,
            encoded: (0, $04Jxx.concat)([
                (0, $aS9j8.padHex)((0, $nDot9.numberToHex)(bytesSize, {
                    size: 32
                })),
                value_
            ])
        };
    }
    if (bytesSize !== Number.parseInt(paramSize)) throw new (0, $ie3rb.AbiEncodingBytesSizeMismatchError)({
        expectedSize: Number.parseInt(paramSize),
        value: value
    });
    return {
        dynamic: false,
        encoded: (0, $aS9j8.padHex)(value, {
            dir: "right"
        })
    };
}
function $b7e06bc4048d0723$var$encodeBool(value) {
    if (typeof value !== "boolean") throw new (0, $3cVvs.BaseError)(`Invalid boolean value: "${value}" (type: ${typeof value}). Expected: \`true\` or \`false\`.`);
    return {
        dynamic: false,
        encoded: (0, $aS9j8.padHex)((0, $nDot9.boolToHex)(value))
    };
}
function $b7e06bc4048d0723$var$encodeNumber(value, { signed: signed, size: size = 256 }) {
    if (typeof size === "number") {
        const max = 2n ** (BigInt(size) - (signed ? 1n : 0n)) - 1n;
        const min = signed ? -max - 1n : 0n;
        if (value > max || value < min) throw new (0, $k04Zp.IntegerOutOfRangeError)({
            max: max.toString(),
            min: min.toString(),
            signed: signed,
            size: size / 8,
            value: value.toString()
        });
    }
    return {
        dynamic: false,
        encoded: (0, $nDot9.numberToHex)(value, {
            size: 32,
            signed: signed
        })
    };
}
function $b7e06bc4048d0723$var$encodeString(value) {
    const hexValue = (0, $nDot9.stringToHex)(value);
    const partsLength = Math.ceil((0, $loik3.size)(hexValue) / 32);
    const parts = [];
    for(let i = 0; i < partsLength; i++)parts.push((0, $aS9j8.padHex)((0, $g4WYS.slice)(hexValue, i * 32, (i + 1) * 32), {
        dir: "right"
    }));
    return {
        dynamic: true,
        encoded: (0, $04Jxx.concat)([
            (0, $aS9j8.padHex)((0, $nDot9.numberToHex)((0, $loik3.size)(hexValue), {
                size: 32
            })),
            ...parts
        ])
    };
}
function $b7e06bc4048d0723$var$encodeTuple(value, { param: param }) {
    let dynamic = false;
    const preparedParams = [];
    for(let i = 0; i < param.components.length; i++){
        const param_ = param.components[i];
        const index = Array.isArray(value) ? i : param_.name;
        const preparedParam = $b7e06bc4048d0723$var$prepareParam({
            param: param_,
            value: value[index]
        });
        preparedParams.push(preparedParam);
        if (preparedParam.dynamic) dynamic = true;
    }
    return {
        dynamic: dynamic,
        encoded: dynamic ? $b7e06bc4048d0723$var$encodeParams(preparedParams) : (0, $04Jxx.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $b7e06bc4048d0723$export$ab502cfdbb1a0d07(type) {
    const matches = type.match(/^(.*)\[(\d+)?\]$/);
    return matches ? [
        matches[2] ? Number(matches[2]) : null,
        matches[1]
    ] : undefined;
}

});
parcelRegister("4kdiC", function(module, exports) {

$parcel$export(module.exports, "integerRegex", () => $3263589f699f568f$export$45902cc189596eef);
const $3263589f699f568f$export$6cd562aaf6380f0e = /^(.*)\[([0-9]*)\]$/;
const $3263589f699f568f$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $3263589f699f568f$export$45902cc189596eef = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;

});




parcelRegister("3jfUm", function(module, exports) {

$parcel$export(module.exports, "getAbiItem", () => $268f7c7366c37c04$export$99b134cd177e9574);

var $ie3rb = parcelRequire("ie3rb");

var $ifibB = parcelRequire("ifibB");

var $lmNDj = parcelRequire("lmNDj");

var $h5q9B = parcelRequire("h5q9B");

var $dUPAH = parcelRequire("dUPAH");
function $268f7c7366c37c04$export$99b134cd177e9574(parameters) {
    const { abi: abi, args: args = [], name: name } = parameters;
    const isSelector = (0, $ifibB.isHex)(name, {
        strict: false
    });
    const abiItems = abi.filter((abiItem)=>{
        if (isSelector) {
            if (abiItem.type === "function") return (0, $dUPAH.toFunctionSelector)(abiItem) === name;
            if (abiItem.type === "event") return (0, $h5q9B.toEventSelector)(abiItem) === name;
            return false;
        }
        return "name" in abiItem && abiItem.name === name;
    });
    if (abiItems.length === 0) return undefined;
    if (abiItems.length === 1) return abiItems[0];
    let matchedAbiItem = undefined;
    for (const abiItem of abiItems){
        if (!("inputs" in abiItem)) continue;
        if (!args || args.length === 0) {
            if (!abiItem.inputs || abiItem.inputs.length === 0) return abiItem;
            continue;
        }
        if (!abiItem.inputs) continue;
        if (abiItem.inputs.length === 0) continue;
        if (abiItem.inputs.length !== args.length) continue;
        const matched = args.every((arg, index)=>{
            const abiParameter = "inputs" in abiItem && abiItem.inputs[index];
            if (!abiParameter) return false;
            return $268f7c7366c37c04$export$697eff86d182a8c1(arg, abiParameter);
        });
        if (matched) {
            // Check for ambiguity against already matched parameters (e.g. `address` vs `bytes20`).
            if (matchedAbiItem && "inputs" in matchedAbiItem && matchedAbiItem.inputs) {
                const ambiguousTypes = $268f7c7366c37c04$export$79fd08820d2778aa(abiItem.inputs, matchedAbiItem.inputs, args);
                if (ambiguousTypes) throw new (0, $ie3rb.AbiItemAmbiguityError)({
                    abiItem: abiItem,
                    type: ambiguousTypes[0]
                }, {
                    abiItem: matchedAbiItem,
                    type: ambiguousTypes[1]
                });
            }
            matchedAbiItem = abiItem;
        }
    }
    if (matchedAbiItem) return matchedAbiItem;
    return abiItems[0];
}
function $268f7c7366c37c04$export$697eff86d182a8c1(arg, abiParameter) {
    const argType = typeof arg;
    const abiParameterType = abiParameter.type;
    switch(abiParameterType){
        case "address":
            return (0, $lmNDj.isAddress)(arg, {
                strict: false
            });
        case "bool":
            return argType === "boolean";
        case "function":
            return argType === "string";
        case "string":
            return argType === "string";
        default:
            if (abiParameterType === "tuple" && "components" in abiParameter) return Object.values(abiParameter.components).every((component, index)=>{
                return $268f7c7366c37c04$export$697eff86d182a8c1(Object.values(arg)[index], component);
            });
            // `(u)int<M>`: (un)signed integer type of `M` bits, `0 < M <= 256`, `M % 8 == 0`
            // https://regexr.com/6v8hp
            if (/^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(abiParameterType)) return argType === "number" || argType === "bigint";
            // `bytes<M>`: binary type of `M` bytes, `0 < M <= 32`
            // https://regexr.com/6va55
            if (/^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(abiParameterType)) return argType === "string" || arg instanceof Uint8Array;
            // fixed-length (`<type>[M]`) and dynamic (`<type>[]`) arrays
            // https://regexr.com/6va6i
            if (/[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(abiParameterType)) return Array.isArray(arg) && arg.every((x)=>$268f7c7366c37c04$export$697eff86d182a8c1(x, {
                    ...abiParameter,
                    // Pop off `[]` or `[M]` from end of type
                    type: abiParameterType.replace(/(\[[0-9]{0,}\])$/, "")
                }));
            return false;
    }
}
function $268f7c7366c37c04$export$79fd08820d2778aa(sourceParameters, targetParameters, args) {
    for(const parameterIndex in sourceParameters){
        const sourceParameter = sourceParameters[parameterIndex];
        const targetParameter = targetParameters[parameterIndex];
        if (sourceParameter.type === "tuple" && targetParameter.type === "tuple" && "components" in sourceParameter && "components" in targetParameter) return $268f7c7366c37c04$export$79fd08820d2778aa(sourceParameter.components, targetParameter.components, args[parameterIndex]);
        const types = [
            sourceParameter.type,
            targetParameter.type
        ];
        const ambiguous = (()=>{
            if (types.includes("address") && types.includes("bytes20")) return true;
            if (types.includes("address") && types.includes("string")) return (0, $lmNDj.isAddress)(args[parameterIndex], {
                strict: false
            });
            if (types.includes("address") && types.includes("bytes")) return (0, $lmNDj.isAddress)(args[parameterIndex], {
                strict: false
            });
            return false;
        })();
        if (ambiguous) return types;
    }
    return;
}

});
parcelRegister("h5q9B", function(module, exports) {

$parcel$export(module.exports, "toEventSelector", () => $c70730e393c05834$export$351f40ec61b2972);

var $4knKV = parcelRequire("4knKV");
const $c70730e393c05834$export$351f40ec61b2972 = (0, $4knKV.toSignatureHash);

});


parcelRegister("2znys", function(module, exports) {

$parcel$export(module.exports, "multicall3Abi", () => $1df11f2280d56cf4$export$4e233219477ffb48);
$parcel$export(module.exports, "batchGatewayAbi", () => $1df11f2280d56cf4$export$8344c934d721cf41);
/* [Multicall3](https://github.com/mds1/multicall) */ const $1df11f2280d56cf4$export$4e233219477ffb48 = [
    {
        inputs: [
            {
                components: [
                    {
                        name: "target",
                        type: "address"
                    },
                    {
                        name: "allowFailure",
                        type: "bool"
                    },
                    {
                        name: "callData",
                        type: "bytes"
                    }
                ],
                name: "calls",
                type: "tuple[]"
            }
        ],
        name: "aggregate3",
        outputs: [
            {
                components: [
                    {
                        name: "success",
                        type: "bool"
                    },
                    {
                        name: "returnData",
                        type: "bytes"
                    }
                ],
                name: "returnData",
                type: "tuple[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $1df11f2280d56cf4$export$8344c934d721cf41 = [
    {
        name: "query",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                type: "tuple[]",
                name: "queries",
                components: [
                    {
                        type: "address",
                        name: "sender"
                    },
                    {
                        type: "string[]",
                        name: "urls"
                    },
                    {
                        type: "bytes",
                        name: "data"
                    }
                ]
            }
        ],
        outputs: [
            {
                type: "bool[]",
                name: "failures"
            },
            {
                type: "bytes[]",
                name: "responses"
            }
        ]
    },
    {
        name: "HttpError",
        type: "error",
        inputs: [
            {
                type: "uint16",
                name: "status"
            },
            {
                type: "string",
                name: "message"
            }
        ]
    }
];
const $1df11f2280d56cf4$var$universalResolverErrors = [
    {
        inputs: [],
        name: "ResolverNotFound",
        type: "error"
    },
    {
        inputs: [],
        name: "ResolverWildcardNotSupported",
        type: "error"
    },
    {
        inputs: [],
        name: "ResolverNotContract",
        type: "error"
    },
    {
        inputs: [
            {
                name: "returnData",
                type: "bytes"
            }
        ],
        name: "ResolverError",
        type: "error"
    },
    {
        inputs: [
            {
                components: [
                    {
                        name: "status",
                        type: "uint16"
                    },
                    {
                        name: "message",
                        type: "string"
                    }
                ],
                name: "errors",
                type: "tuple[]"
            }
        ],
        name: "HttpError",
        type: "error"
    }
];
const $1df11f2280d56cf4$export$400f1d40cf4f98fe = [
    ...$1df11f2280d56cf4$var$universalResolverErrors,
    {
        name: "resolve",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes"
            },
            {
                name: "data",
                type: "bytes"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            },
            {
                name: "address",
                type: "address"
            }
        ]
    },
    {
        name: "resolve",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes"
            },
            {
                name: "data",
                type: "bytes"
            },
            {
                name: "gateways",
                type: "string[]"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            },
            {
                name: "address",
                type: "address"
            }
        ]
    }
];
const $1df11f2280d56cf4$export$fd0db820daeebac9 = [
    ...$1df11f2280d56cf4$var$universalResolverErrors,
    {
        name: "reverse",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                type: "bytes",
                name: "reverseName"
            }
        ],
        outputs: [
            {
                type: "string",
                name: "resolvedName"
            },
            {
                type: "address",
                name: "resolvedAddress"
            },
            {
                type: "address",
                name: "reverseResolver"
            },
            {
                type: "address",
                name: "resolver"
            }
        ]
    },
    {
        name: "reverse",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                type: "bytes",
                name: "reverseName"
            },
            {
                type: "string[]",
                name: "gateways"
            }
        ],
        outputs: [
            {
                type: "string",
                name: "resolvedName"
            },
            {
                type: "address",
                name: "resolvedAddress"
            },
            {
                type: "address",
                name: "reverseResolver"
            },
            {
                type: "address",
                name: "resolver"
            }
        ]
    }
];
const $1df11f2280d56cf4$export$4e6990b9fd834e88 = [
    {
        name: "text",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            },
            {
                name: "key",
                type: "string"
            }
        ],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    }
];
const $1df11f2280d56cf4$export$4c61cc2994c5d90b = [
    {
        name: "addr",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            }
        ],
        outputs: [
            {
                name: "",
                type: "address"
            }
        ]
    },
    {
        name: "addr",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            },
            {
                name: "coinType",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            }
        ]
    }
];
const $1df11f2280d56cf4$export$429a705aa5b352c0 = [
    {
        name: "isValidSignature",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "hash",
                type: "bytes32"
            },
            {
                name: "signature",
                type: "bytes"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes4"
            }
        ]
    }
];
const $1df11f2280d56cf4$export$b10682c3fa53fbd1 = [
    {
        inputs: [
            {
                name: "_signer",
                type: "address"
            },
            {
                name: "_hash",
                type: "bytes32"
            },
            {
                name: "_signature",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                name: "_signer",
                type: "address"
            },
            {
                name: "_hash",
                type: "bytes32"
            },
            {
                name: "_signature",
                type: "bytes"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function",
        name: "isValidSig"
    }
];
const $1df11f2280d56cf4$export$891152826cc2370a = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "allowance",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint8"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transfer",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    }
];
const $1df11f2280d56cf4$export$1c8d119bf9c799eb = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "allowance",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint8"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "bytes32"
            }
        ]
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "bytes32"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transfer",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    }
];
const $1df11f2280d56cf4$export$963b27f63f08e0bf = [
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ERC1155InsufficientBalance",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "approver",
                type: "address"
            }
        ],
        name: "ERC1155InvalidApprover",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "idsLength",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "valuesLength",
                type: "uint256"
            }
        ],
        name: "ERC1155InvalidArrayLength",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "ERC1155InvalidOperator",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "ERC1155InvalidReceiver",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            }
        ],
        name: "ERC1155InvalidSender",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "ERC1155MissingApprovalForAll",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]"
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]"
            }
        ],
        name: "TransferBatch",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "TransferSingle",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "value",
                type: "string"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "id",
                type: "uint256"
            }
        ],
        name: "URI",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "accounts",
                type: "address[]"
            },
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]"
            }
        ],
        name: "balanceOfBatch",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]"
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeBatchTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        name: "uri",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $1df11f2280d56cf4$export$da6511eb7df6e9f8 = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: true,
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "ApprovalForAll",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                name: "approved",
                type: "bool"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "payable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "getApproved",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "address"
            }
        ]
    },
    {
        type: "function",
        name: "isApprovedForAll",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "operator",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "ownerOf",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "owner",
                type: "address"
            }
        ]
    },
    {
        type: "function",
        name: "safeTransferFrom",
        stateMutability: "payable",
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "safeTransferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "id",
                type: "uint256"
            },
            {
                name: "data",
                type: "bytes"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "setApprovalForAll",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "operator",
                type: "address"
            },
            {
                name: "approved",
                type: "bool"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "tokenByIndex",
        stateMutability: "view",
        inputs: [
            {
                name: "index",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "tokenByIndex",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "index",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "tokenURI",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "payable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "tokeId",
                type: "uint256"
            }
        ],
        outputs: []
    }
];
const $1df11f2280d56cf4$export$82934a3bb3a99370 = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                name: "receiver",
                type: "address"
            },
            {
                indexed: false,
                name: "assets",
                type: "uint256"
            },
            {
                indexed: false,
                name: "shares",
                type: "uint256"
            }
        ],
        name: "Deposit",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                name: "receiver",
                type: "address"
            },
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: false,
                name: "assets",
                type: "uint256"
            },
            {
                indexed: false,
                name: "shares",
                type: "uint256"
            }
        ],
        name: "Withdraw",
        type: "event"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "asset",
        outputs: [
            {
                name: "assetTokenAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "convertToAssets",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "convertToShares",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            }
        ],
        name: "deposit",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "caller",
                type: "address"
            }
        ],
        name: "maxDeposit",
        outputs: [
            {
                name: "maxAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "caller",
                type: "address"
            }
        ],
        name: "maxMint",
        outputs: [
            {
                name: "maxShares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "maxRedeem",
        outputs: [
            {
                name: "maxShares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "maxWithdraw",
        outputs: [
            {
                name: "maxAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            }
        ],
        name: "mint",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "previewDeposit",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "previewMint",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "previewRedeem",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "previewWithdraw",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            },
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "redeem",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "totalAssets",
        outputs: [
            {
                name: "totalManagedAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "to",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            },
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "withdraw",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];

});

parcelRegister("eNB0a", function(module, exports) {

$parcel$export(module.exports, "call", () => $ac62581294064d22$export$848feb93d8f32b9b);

var $1v1ze = parcelRequire("1v1ze");

var $6wJhs = parcelRequire("6wJhs");

var $fbsYZ = parcelRequire("fbsYZ");

var $2znys = parcelRequire("2znys");

var $2aU8i = parcelRequire("2aU8i");

var $hQPTC = parcelRequire("hQPTC");

var $3cVvs = parcelRequire("3cVvs");

var $4TNV6 = parcelRequire("4TNV6");

var $9juKK = parcelRequire("9juKK");

var $9Nj5J = parcelRequire("9Nj5J");

var $3aOPa = parcelRequire("3aOPa");

var $83bOE = parcelRequire("83bOE");

var $ejxc0 = parcelRequire("ejxc0");

var $nDot9 = parcelRequire("nDot9");

var $7zU3k = parcelRequire("7zU3k");

var $6ztP3 = parcelRequire("6ztP3");

var $csK11 = parcelRequire("csK11");

var $5UW0B = parcelRequire("5UW0B");

var $6Pzc8 = parcelRequire("6Pzc8");

var $hQGp6 = parcelRequire("hQGp6");

async function $ac62581294064d22$export$848feb93d8f32b9b(client, args) {
    const { account: account_ = client.account, batch: batch = Boolean(client.batch?.multicall), blockNumber: blockNumber, blockTag: blockTag = "latest", accessList: accessList, blobs: blobs, blockOverrides: blockOverrides, code: code, data: data_, factory: factory, factoryData: factoryData, gas: gas, gasPrice: gasPrice, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, stateOverride: stateOverride, ...rest } = args;
    const account = account_ ? (0, $fbsYZ.parseAccount)(account_) : undefined;
    if (code && (factory || factoryData)) throw new (0, $3cVvs.BaseError)("Cannot provide both `code` & `factory`/`factoryData` as parameters.");
    if (code && to) throw new (0, $3cVvs.BaseError)("Cannot provide both `code` & `to` as parameters.");
    // Check if the call is deployless via bytecode.
    const deploylessCallViaBytecode = code && data_;
    // Check if the call is deployless via a factory.
    const deploylessCallViaFactory = factory && factoryData && to && data_;
    const deploylessCall = deploylessCallViaBytecode || deploylessCallViaFactory;
    const data = (()=>{
        if (deploylessCallViaBytecode) return $ac62581294064d22$var$toDeploylessCallViaBytecodeData({
            code: code,
            data: data_
        });
        if (deploylessCallViaFactory) return $ac62581294064d22$var$toDeploylessCallViaFactoryData({
            data: data_,
            factory: factory,
            factoryData: factoryData,
            to: to
        });
        return data_;
    })();
    try {
        (0, $hQGp6.assertRequest)(args);
        const blockNumberHex = typeof blockNumber === "bigint" ? (0, $nDot9.numberToHex)(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        const rpcBlockOverrides = blockOverrides ? $6wJhs.toRpc(blockOverrides) : undefined;
        const rpcStateOverride = (0, $6Pzc8.serializeStateOverride)(stateOverride);
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || (0, $csK11.formatTransactionRequest);
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...(0, $6ztP3.extract)(rest, {
                format: chainFormat
            }),
            from: account?.address,
            accessList: accessList,
            blobs: blobs,
            data: data,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerBlobGas: maxFeePerBlobGas,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: deploylessCall ? undefined : to,
            value: value
        });
        if (batch && $ac62581294064d22$var$shouldPerformMulticall({
            request: request
        }) && !rpcStateOverride && !rpcBlockOverrides) try {
            return await $ac62581294064d22$var$scheduleMulticall(client, {
                ...request,
                blockNumber: blockNumber,
                blockTag: blockTag
            });
        } catch (err) {
            if (!(err instanceof (0, $4TNV6.ClientChainNotConfiguredError)) && !(err instanceof (0, $4TNV6.ChainDoesNotSupportContract))) throw err;
        }
        const params = (()=>{
            const base = [
                request,
                block
            ];
            if (rpcStateOverride && rpcBlockOverrides) return [
                ...base,
                rpcStateOverride,
                rpcBlockOverrides
            ];
            if (rpcStateOverride) return [
                ...base,
                rpcStateOverride
            ];
            if (rpcBlockOverrides) return [
                ...base,
                {},
                rpcBlockOverrides
            ];
            return base;
        })();
        const response = await client.request({
            method: "eth_call",
            params: params
        });
        if (response === "0x") return {
            data: undefined
        };
        return {
            data: response
        };
    } catch (err) {
        const data = $ac62581294064d22$export$6ef1a527f868ca75(err);
        // Check for CCIP-Read offchain lookup signature.
        const { offchainLookup: offchainLookup, offchainLookupSignature: offchainLookupSignature } = await (parcelRequire("2PSXI"));
        if (client.ccipRead !== false && data?.slice(0, 10) === offchainLookupSignature && to) return {
            data: await offchainLookup(client, {
                data: data,
                to: to
            })
        };
        // Check for counterfactual deployment error.
        if (deploylessCall && data?.slice(0, 10) === "0x101bb98d") throw new (0, $9juKK.CounterfactualDeploymentFailedError)({
            factory: factory
        });
        throw (0, $7zU3k.getCallError)(err, {
            ...args,
            account: account,
            chain: client.chain
        });
    }
}
// We only want to perform a scheduled multicall if:
// - The request has calldata,
// - The request has a target address,
// - The target address is not already the aggregate3 signature,
// - The request has no other properties (`nonce`, `gas`, etc cannot be sent with a multicall).
function $ac62581294064d22$var$shouldPerformMulticall({ request: request }) {
    const { data: data, to: to, ...request_ } = request;
    if (!data) return false;
    if (data.startsWith((0, $2aU8i.aggregate3Signature))) return false;
    if (!to) return false;
    if (Object.values(request_).filter((x)=>typeof x !== "undefined").length > 0) return false;
    return true;
}
async function $ac62581294064d22$var$scheduleMulticall(client, args) {
    const { batchSize: batchSize = 1024, wait: wait = 0 } = typeof client.batch?.multicall === "object" ? client.batch.multicall : {};
    const { blockNumber: blockNumber, blockTag: blockTag = "latest", data: data, multicallAddress: multicallAddress_, to: to } = args;
    let multicallAddress = multicallAddress_;
    if (!multicallAddress) {
        if (!client.chain) throw new (0, $4TNV6.ClientChainNotConfiguredError)();
        multicallAddress = (0, $ejxc0.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "multicall3"
        });
    }
    const blockNumberHex = typeof blockNumber === "bigint" ? (0, $nDot9.numberToHex)(blockNumber) : undefined;
    const block = blockNumberHex || blockTag;
    const { schedule: schedule } = (0, $5UW0B.createBatchScheduler)({
        id: `${client.uid}.${block}`,
        wait: wait,
        shouldSplitBatch (args) {
            const size = args.reduce((size, { data: data })=>size + (data.length - 2), 0);
            return size > batchSize * 2;
        },
        fn: async (requests)=>{
            const calls = requests.map((request)=>({
                    allowFailure: true,
                    callData: request.data,
                    target: request.to
                }));
            const calldata = (0, $83bOE.encodeFunctionData)({
                abi: (0, $2znys.multicall3Abi),
                args: [
                    calls
                ],
                functionName: "aggregate3"
            });
            const data = await client.request({
                method: "eth_call",
                params: [
                    {
                        data: calldata,
                        to: multicallAddress
                    },
                    block
                ]
            });
            return (0, $9Nj5J.decodeFunctionResult)({
                abi: (0, $2znys.multicall3Abi),
                args: [
                    calls
                ],
                functionName: "aggregate3",
                data: data || "0x"
            });
        }
    });
    const [{ returnData: returnData, success: success }] = await schedule({
        data: data,
        to: to
    });
    if (!success) throw new (0, $9juKK.RawContractError)({
        data: returnData
    });
    if (returnData === "0x") return {
        data: undefined
    };
    return {
        data: returnData
    };
}
function $ac62581294064d22$var$toDeploylessCallViaBytecodeData(parameters) {
    const { code: code, data: data } = parameters;
    return (0, $3aOPa.encodeDeployData)({
        abi: (0, $1v1ze.parseAbi)([
            "constructor(bytes, bytes)"
        ]),
        bytecode: (0, $hQPTC.deploylessCallViaBytecodeBytecode),
        args: [
            code,
            data
        ]
    });
}
function $ac62581294064d22$var$toDeploylessCallViaFactoryData(parameters) {
    const { data: data, factory: factory, factoryData: factoryData, to: to } = parameters;
    return (0, $3aOPa.encodeDeployData)({
        abi: (0, $1v1ze.parseAbi)([
            "constructor(address, bytes, address, bytes)"
        ]),
        bytecode: (0, $hQPTC.deploylessCallViaFactoryBytecode),
        args: [
            to,
            data,
            factory,
            factoryData
        ]
    });
}
function $ac62581294064d22$export$6ef1a527f868ca75(err) {
    if (!(err instanceof (0, $3cVvs.BaseError))) return undefined;
    const error = err.walk();
    return typeof error?.data === "object" ? error.data?.data : error.data;
}

});
parcelRegister("1v1ze", function(module, exports) {

$parcel$export(module.exports, "parseAbi", () => $1179e6f007df9535$export$4ab3f466fb8f069);

var $X3o77 = parcelRequire("X3o77");

var $lP9In = parcelRequire("lP9In");

var $ge5MJ = parcelRequire("ge5MJ");
function $1179e6f007df9535$export$4ab3f466fb8f069(signatures) {
    const structs = (0, $lP9In.parseStructs)(signatures);
    const abi = [];
    const length = signatures.length;
    for(let i = 0; i < length; i++){
        const signature = signatures[i];
        if ((0, $X3o77.isStructSignature)(signature)) continue;
        abi.push((0, $ge5MJ.parseSignature)(signature, structs));
    }
    return abi;
}

});
parcelRegister("X3o77", function(module, exports) {

$parcel$export(module.exports, "isErrorSignature", () => $0b1823934ec8740b$export$33be303020ecaff5);
$parcel$export(module.exports, "execErrorSignature", () => $0b1823934ec8740b$export$a8b67e842e5c116d);
$parcel$export(module.exports, "isEventSignature", () => $0b1823934ec8740b$export$7912f33b3b4526ca);
$parcel$export(module.exports, "execEventSignature", () => $0b1823934ec8740b$export$87d5ec49338ff6f);
$parcel$export(module.exports, "isFunctionSignature", () => $0b1823934ec8740b$export$fa8ae1a8bca33200);
$parcel$export(module.exports, "execFunctionSignature", () => $0b1823934ec8740b$export$8a14253893829398);
$parcel$export(module.exports, "isStructSignature", () => $0b1823934ec8740b$export$130f77ea18c25fb8);
$parcel$export(module.exports, "execStructSignature", () => $0b1823934ec8740b$export$432f3b6c467d7b70);
$parcel$export(module.exports, "isConstructorSignature", () => $0b1823934ec8740b$export$7ec9623fe58e8638);
$parcel$export(module.exports, "execConstructorSignature", () => $0b1823934ec8740b$export$4713f9c79c855460);
$parcel$export(module.exports, "isFallbackSignature", () => $0b1823934ec8740b$export$f99ebae7027f9f2f);
$parcel$export(module.exports, "execFallbackSignature", () => $0b1823934ec8740b$export$3a925f26585db196);
$parcel$export(module.exports, "isReceiveSignature", () => $0b1823934ec8740b$export$555d9bfe0f07ab3d);
$parcel$export(module.exports, "eventModifiers", () => $0b1823934ec8740b$export$e4045f69b6b17e16);
$parcel$export(module.exports, "functionModifiers", () => $0b1823934ec8740b$export$d304f1652f422b6b);

var $71OGG = parcelRequire("71OGG");
// https://regexr.com/7gmok
const $0b1823934ec8740b$var$errorSignatureRegex = /^error (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function $0b1823934ec8740b$export$33be303020ecaff5(signature) {
    return $0b1823934ec8740b$var$errorSignatureRegex.test(signature);
}
function $0b1823934ec8740b$export$a8b67e842e5c116d(signature) {
    return (0, $71OGG.execTyped)($0b1823934ec8740b$var$errorSignatureRegex, signature);
}
// https://regexr.com/7gmoq
const $0b1823934ec8740b$var$eventSignatureRegex = /^event (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function $0b1823934ec8740b$export$7912f33b3b4526ca(signature) {
    return $0b1823934ec8740b$var$eventSignatureRegex.test(signature);
}
function $0b1823934ec8740b$export$87d5ec49338ff6f(signature) {
    return (0, $71OGG.execTyped)($0b1823934ec8740b$var$eventSignatureRegex, signature);
}
// https://regexr.com/7gmot
const $0b1823934ec8740b$var$functionSignatureRegex = /^function (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)(?: (?<scope>external|public{1}))?(?: (?<stateMutability>pure|view|nonpayable|payable{1}))?(?: returns\s?\((?<returns>.*?)\))?$/;
function $0b1823934ec8740b$export$fa8ae1a8bca33200(signature) {
    return $0b1823934ec8740b$var$functionSignatureRegex.test(signature);
}
function $0b1823934ec8740b$export$8a14253893829398(signature) {
    return (0, $71OGG.execTyped)($0b1823934ec8740b$var$functionSignatureRegex, signature);
}
// https://regexr.com/7gmp3
const $0b1823934ec8740b$var$structSignatureRegex = /^struct (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*) \{(?<properties>.*?)\}$/;
function $0b1823934ec8740b$export$130f77ea18c25fb8(signature) {
    return $0b1823934ec8740b$var$structSignatureRegex.test(signature);
}
function $0b1823934ec8740b$export$432f3b6c467d7b70(signature) {
    return (0, $71OGG.execTyped)($0b1823934ec8740b$var$structSignatureRegex, signature);
}
// https://regexr.com/78u01
const $0b1823934ec8740b$var$constructorSignatureRegex = /^constructor\((?<parameters>.*?)\)(?:\s(?<stateMutability>payable{1}))?$/;
function $0b1823934ec8740b$export$7ec9623fe58e8638(signature) {
    return $0b1823934ec8740b$var$constructorSignatureRegex.test(signature);
}
function $0b1823934ec8740b$export$4713f9c79c855460(signature) {
    return (0, $71OGG.execTyped)($0b1823934ec8740b$var$constructorSignatureRegex, signature);
}
// https://regexr.com/7srtn
const $0b1823934ec8740b$var$fallbackSignatureRegex = /^fallback\(\) external(?:\s(?<stateMutability>payable{1}))?$/;
function $0b1823934ec8740b$export$f99ebae7027f9f2f(signature) {
    return $0b1823934ec8740b$var$fallbackSignatureRegex.test(signature);
}
function $0b1823934ec8740b$export$3a925f26585db196(signature) {
    return (0, $71OGG.execTyped)($0b1823934ec8740b$var$fallbackSignatureRegex, signature);
}
// https://regexr.com/78u1k
const $0b1823934ec8740b$var$receiveSignatureRegex = /^receive\(\) external payable$/;
function $0b1823934ec8740b$export$555d9bfe0f07ab3d(signature) {
    return $0b1823934ec8740b$var$receiveSignatureRegex.test(signature);
}
const $0b1823934ec8740b$export$c2f15f629432a51d = new Set([
    "memory",
    "indexed",
    "storage",
    "calldata"
]);
const $0b1823934ec8740b$export$e4045f69b6b17e16 = new Set([
    "indexed"
]);
const $0b1823934ec8740b$export$d304f1652f422b6b = new Set([
    "calldata",
    "memory",
    "storage"
]);

});

parcelRegister("lP9In", function(module, exports) {

$parcel$export(module.exports, "parseStructs", () => $fe35e58497ac57f1$export$6e5e6f927c48b857);

var $71OGG = parcelRequire("71OGG");

var $dctyo = parcelRequire("dctyo");

var $l8RId = parcelRequire("l8RId");

var $i3t4X = parcelRequire("i3t4X");

var $ljgvk = parcelRequire("ljgvk");

var $X3o77 = parcelRequire("X3o77");

var $ge5MJ = parcelRequire("ge5MJ");
function $fe35e58497ac57f1$export$6e5e6f927c48b857(signatures) {
    // Create "shallow" version of each struct (and filter out non-structs or invalid structs)
    const shallowStructs = {};
    const signaturesLength = signatures.length;
    for(let i = 0; i < signaturesLength; i++){
        const signature = signatures[i];
        if (!(0, $X3o77.isStructSignature)(signature)) continue;
        const match = (0, $X3o77.execStructSignature)(signature);
        if (!match) throw new (0, $i3t4X.InvalidSignatureError)({
            signature: signature,
            type: "struct"
        });
        const properties = match.properties.split(";");
        const components = [];
        const propertiesLength = properties.length;
        for(let k = 0; k < propertiesLength; k++){
            const property = properties[k];
            const trimmed = property.trim();
            if (!trimmed) continue;
            const abiParameter = (0, $ge5MJ.parseAbiParameter)(trimmed, {
                type: "struct"
            });
            components.push(abiParameter);
        }
        if (!components.length) throw new (0, $i3t4X.InvalidStructSignatureError)({
            signature: signature
        });
        shallowStructs[match.name] = components;
    }
    // Resolve nested structs inside each parameter
    const resolvedStructs = {};
    const entries = Object.entries(shallowStructs);
    const entriesLength = entries.length;
    for(let i = 0; i < entriesLength; i++){
        const [name, parameters] = entries[i];
        resolvedStructs[name] = $fe35e58497ac57f1$var$resolveStructs(parameters, shallowStructs);
    }
    return resolvedStructs;
}
const $fe35e58497ac57f1$var$typeWithoutTupleRegex = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?$/;
function $fe35e58497ac57f1$var$resolveStructs(abiParameters, structs, ancestors = new Set()) {
    const components = [];
    const length = abiParameters.length;
    for(let i = 0; i < length; i++){
        const abiParameter = abiParameters[i];
        const isTuple = (0, $71OGG.isTupleRegex).test(abiParameter.type);
        if (isTuple) components.push(abiParameter);
        else {
            const match = (0, $71OGG.execTyped)($fe35e58497ac57f1$var$typeWithoutTupleRegex, abiParameter.type);
            if (!match?.type) throw new (0, $l8RId.InvalidAbiTypeParameterError)({
                abiParameter: abiParameter
            });
            const { array: array, type: type } = match;
            if (type in structs) {
                if (ancestors.has(type)) throw new (0, $ljgvk.CircularReferenceError)({
                    type: type
                });
                components.push({
                    ...abiParameter,
                    type: `tuple${array ?? ""}`,
                    components: $fe35e58497ac57f1$var$resolveStructs(structs[type] ?? [], structs, new Set([
                        ...ancestors,
                        type
                    ]))
                });
            } else {
                if ((0, $ge5MJ.isSolidityType)(type)) components.push(abiParameter);
                else throw new (0, $dctyo.UnknownTypeError)({
                    type: type
                });
            }
        }
    }
    return components;
}

});
parcelRegister("dctyo", function(module, exports) {

$parcel$export(module.exports, "UnknownTypeError", () => $99c3521b3a0412e7$export$9e77a92da3bcd5ca);
$parcel$export(module.exports, "UnknownSolidityTypeError", () => $99c3521b3a0412e7$export$5a36348a2ac471a3);

var $1hh7U = parcelRequire("1hh7U");
class $99c3521b3a0412e7$export$a4e0854b60f599b6 extends (0, $1hh7U.BaseError) {
    constructor({ signature: signature }){
        super("Failed to parse ABI item.", {
            details: `parseAbiItem(${JSON.stringify(signature, null, 2)})`,
            docsPath: "/api/human#parseabiitem-1"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiItemError"
        });
    }
}
class $99c3521b3a0412e7$export$9e77a92da3bcd5ca extends (0, $1hh7U.BaseError) {
    constructor({ type: type }){
        super("Unknown type.", {
            metaMessages: [
                `Type "${type}" is not a valid ABI type. Perhaps you forgot to include a struct signature?`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownTypeError"
        });
    }
}
class $99c3521b3a0412e7$export$5a36348a2ac471a3 extends (0, $1hh7U.BaseError) {
    constructor({ type: type }){
        super("Unknown type.", {
            metaMessages: [
                `Type "${type}" is not a valid ABI type.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownSolidityTypeError"
        });
    }
}

});
parcelRegister("1hh7U", function(module, exports) {

$parcel$export(module.exports, "BaseError", () => $0ee4a9f7ac43e790$export$a490eb03cb7a0a5e);

var $3Fsvy = parcelRequire("3Fsvy");
class $0ee4a9f7ac43e790$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        const details = args.cause instanceof $0ee4a9f7ac43e790$export$a490eb03cb7a0a5e ? args.cause.details : args.cause?.message ? args.cause.message : args.details;
        const docsPath = args.cause instanceof $0ee4a9f7ac43e790$export$a490eb03cb7a0a5e ? args.cause.docsPath || args.docsPath : args.docsPath;
        const message = [
            shortMessage || "An error occurred.",
            "",
            ...args.metaMessages ? [
                ...args.metaMessages,
                ""
            ] : [],
            ...docsPath ? [
                `Docs: https://abitype.dev${docsPath}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            `Version: abitype@${(0, $3Fsvy.version)}`
        ].join("\n");
        super(message);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiTypeError"
        });
        if (args.cause) this.cause = args.cause;
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.shortMessage = shortMessage;
    }
}

});
parcelRegister("3Fsvy", function(module, exports) {

$parcel$export(module.exports, "version", () => $2abb508a2aecc445$export$83d89fbfd8236492);
const $2abb508a2aecc445$export$83d89fbfd8236492 = "1.0.8";

});



parcelRegister("l8RId", function(module, exports) {

$parcel$export(module.exports, "InvalidParameterError", () => $f644026f24d9f0e4$export$e569b97a5d46005c);
$parcel$export(module.exports, "SolidityProtectedKeywordError", () => $f644026f24d9f0e4$export$58697cc8f790f211);
$parcel$export(module.exports, "InvalidModifierError", () => $f644026f24d9f0e4$export$f837e6b0dee0e468);
$parcel$export(module.exports, "InvalidFunctionModifierError", () => $f644026f24d9f0e4$export$7afd0f25b8fdbbd8);
$parcel$export(module.exports, "InvalidAbiTypeParameterError", () => $f644026f24d9f0e4$export$b5451545b6c52dc8);

var $1hh7U = parcelRequire("1hh7U");
class $f644026f24d9f0e4$export$bdcd4054531f5b35 extends (0, $1hh7U.BaseError) {
    constructor({ param: param }){
        super("Failed to parse ABI parameter.", {
            details: `parseAbiParameter(${JSON.stringify(param, null, 2)})`,
            docsPath: "/api/human#parseabiparameter-1"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiParameterError"
        });
    }
}
class $f644026f24d9f0e4$export$f35df31806e96ff extends (0, $1hh7U.BaseError) {
    constructor({ params: params }){
        super("Failed to parse ABI parameters.", {
            details: `parseAbiParameters(${JSON.stringify(params, null, 2)})`,
            docsPath: "/api/human#parseabiparameters-1"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiParametersError"
        });
    }
}
class $f644026f24d9f0e4$export$e569b97a5d46005c extends (0, $1hh7U.BaseError) {
    constructor({ param: param }){
        super("Invalid ABI parameter.", {
            details: param
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidParameterError"
        });
    }
}
class $f644026f24d9f0e4$export$58697cc8f790f211 extends (0, $1hh7U.BaseError) {
    constructor({ param: param, name: name }){
        super("Invalid ABI parameter.", {
            details: param,
            metaMessages: [
                `"${name}" is a protected Solidity keyword. More info: https://docs.soliditylang.org/en/latest/cheatsheet.html`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SolidityProtectedKeywordError"
        });
    }
}
class $f644026f24d9f0e4$export$f837e6b0dee0e468 extends (0, $1hh7U.BaseError) {
    constructor({ param: param, type: type, modifier: modifier }){
        super("Invalid ABI parameter.", {
            details: param,
            metaMessages: [
                `Modifier "${modifier}" not allowed${type ? ` in "${type}" type` : ""}.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidModifierError"
        });
    }
}
class $f644026f24d9f0e4$export$7afd0f25b8fdbbd8 extends (0, $1hh7U.BaseError) {
    constructor({ param: param, type: type, modifier: modifier }){
        super("Invalid ABI parameter.", {
            details: param,
            metaMessages: [
                `Modifier "${modifier}" not allowed${type ? ` in "${type}" type` : ""}.`,
                `Data location can only be specified for array, struct, or mapping types, but "${modifier}" was given.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidFunctionModifierError"
        });
    }
}
class $f644026f24d9f0e4$export$b5451545b6c52dc8 extends (0, $1hh7U.BaseError) {
    constructor({ abiParameter: abiParameter }){
        super("Invalid ABI parameter.", {
            details: JSON.stringify(abiParameter, null, 2),
            metaMessages: [
                "ABI parameter type is invalid."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiTypeParameterError"
        });
    }
}

});

parcelRegister("i3t4X", function(module, exports) {

$parcel$export(module.exports, "InvalidSignatureError", () => $d24f104f0537fd16$export$ccc2f68ef106615a);
$parcel$export(module.exports, "UnknownSignatureError", () => $d24f104f0537fd16$export$3727c00c40963d37);
$parcel$export(module.exports, "InvalidStructSignatureError", () => $d24f104f0537fd16$export$769955518e5ea753);

var $1hh7U = parcelRequire("1hh7U");
class $d24f104f0537fd16$export$ccc2f68ef106615a extends (0, $1hh7U.BaseError) {
    constructor({ signature: signature, type: type }){
        super(`Invalid ${type} signature.`, {
            details: signature
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidSignatureError"
        });
    }
}
class $d24f104f0537fd16$export$3727c00c40963d37 extends (0, $1hh7U.BaseError) {
    constructor({ signature: signature }){
        super("Unknown signature.", {
            details: signature
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownSignatureError"
        });
    }
}
class $d24f104f0537fd16$export$769955518e5ea753 extends (0, $1hh7U.BaseError) {
    constructor({ signature: signature }){
        super("Invalid struct signature.", {
            details: signature,
            metaMessages: [
                "No properties exist."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidStructSignatureError"
        });
    }
}

});

parcelRegister("ljgvk", function(module, exports) {

$parcel$export(module.exports, "CircularReferenceError", () => $f8382cc1c392c4e2$export$3b7cb2315fb6b103);

var $1hh7U = parcelRequire("1hh7U");
class $f8382cc1c392c4e2$export$3b7cb2315fb6b103 extends (0, $1hh7U.BaseError) {
    constructor({ type: type }){
        super("Circular reference detected.", {
            metaMessages: [
                `Struct "${type}" is a circular reference.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "CircularReferenceError"
        });
    }
}

});

parcelRegister("ge5MJ", function(module, exports) {

$parcel$export(module.exports, "parseSignature", () => $bd0270f0b2dccaba$export$dc1dc22ccf24efef);
$parcel$export(module.exports, "parseAbiParameter", () => $bd0270f0b2dccaba$export$357229f9e2d85552);
$parcel$export(module.exports, "isSolidityType", () => $bd0270f0b2dccaba$export$640ecc6f40db6417);

var $71OGG = parcelRequire("71OGG");

var $dctyo = parcelRequire("dctyo");

var $l8RId = parcelRequire("l8RId");

var $i3t4X = parcelRequire("i3t4X");

var $71MYR = parcelRequire("71MYR");

var $1lzUm = parcelRequire("1lzUm");

var $X3o77 = parcelRequire("X3o77");
function $bd0270f0b2dccaba$export$dc1dc22ccf24efef(signature, structs = {}) {
    if ((0, $X3o77.isFunctionSignature)(signature)) return $bd0270f0b2dccaba$export$d79eb8ab55e2a331(signature, structs);
    if ((0, $X3o77.isEventSignature)(signature)) return $bd0270f0b2dccaba$export$25d6467a8776aab1(signature, structs);
    if ((0, $X3o77.isErrorSignature)(signature)) return $bd0270f0b2dccaba$export$c1ace8fbd46164f1(signature, structs);
    if ((0, $X3o77.isConstructorSignature)(signature)) return $bd0270f0b2dccaba$export$57fb927a1bb13269(signature, structs);
    if ((0, $X3o77.isFallbackSignature)(signature)) return $bd0270f0b2dccaba$export$59f3352106efd66(signature);
    if ((0, $X3o77.isReceiveSignature)(signature)) return {
        type: "receive",
        stateMutability: "payable"
    };
    throw new (0, $i3t4X.UnknownSignatureError)({
        signature: signature
    });
}
function $bd0270f0b2dccaba$export$d79eb8ab55e2a331(signature, structs = {}) {
    const match = (0, $X3o77.execFunctionSignature)(signature);
    if (!match) throw new (0, $i3t4X.InvalidSignatureError)({
        signature: signature,
        type: "function"
    });
    const inputParams = $bd0270f0b2dccaba$export$8350908b11ff5aef(match.parameters);
    const inputs = [];
    const inputLength = inputParams.length;
    for(let i = 0; i < inputLength; i++)inputs.push($bd0270f0b2dccaba$export$357229f9e2d85552(inputParams[i], {
        modifiers: (0, $X3o77.functionModifiers),
        structs: structs,
        type: "function"
    }));
    const outputs = [];
    if (match.returns) {
        const outputParams = $bd0270f0b2dccaba$export$8350908b11ff5aef(match.returns);
        const outputLength = outputParams.length;
        for(let i = 0; i < outputLength; i++)outputs.push($bd0270f0b2dccaba$export$357229f9e2d85552(outputParams[i], {
            modifiers: (0, $X3o77.functionModifiers),
            structs: structs,
            type: "function"
        }));
    }
    return {
        name: match.name,
        type: "function",
        stateMutability: match.stateMutability ?? "nonpayable",
        inputs: inputs,
        outputs: outputs
    };
}
function $bd0270f0b2dccaba$export$25d6467a8776aab1(signature, structs = {}) {
    const match = (0, $X3o77.execEventSignature)(signature);
    if (!match) throw new (0, $i3t4X.InvalidSignatureError)({
        signature: signature,
        type: "event"
    });
    const params = $bd0270f0b2dccaba$export$8350908b11ff5aef(match.parameters);
    const abiParameters = [];
    const length = params.length;
    for(let i = 0; i < length; i++)abiParameters.push($bd0270f0b2dccaba$export$357229f9e2d85552(params[i], {
        modifiers: (0, $X3o77.eventModifiers),
        structs: structs,
        type: "event"
    }));
    return {
        name: match.name,
        type: "event",
        inputs: abiParameters
    };
}
function $bd0270f0b2dccaba$export$c1ace8fbd46164f1(signature, structs = {}) {
    const match = (0, $X3o77.execErrorSignature)(signature);
    if (!match) throw new (0, $i3t4X.InvalidSignatureError)({
        signature: signature,
        type: "error"
    });
    const params = $bd0270f0b2dccaba$export$8350908b11ff5aef(match.parameters);
    const abiParameters = [];
    const length = params.length;
    for(let i = 0; i < length; i++)abiParameters.push($bd0270f0b2dccaba$export$357229f9e2d85552(params[i], {
        structs: structs,
        type: "error"
    }));
    return {
        name: match.name,
        type: "error",
        inputs: abiParameters
    };
}
function $bd0270f0b2dccaba$export$57fb927a1bb13269(signature, structs = {}) {
    const match = (0, $X3o77.execConstructorSignature)(signature);
    if (!match) throw new (0, $i3t4X.InvalidSignatureError)({
        signature: signature,
        type: "constructor"
    });
    const params = $bd0270f0b2dccaba$export$8350908b11ff5aef(match.parameters);
    const abiParameters = [];
    const length = params.length;
    for(let i = 0; i < length; i++)abiParameters.push($bd0270f0b2dccaba$export$357229f9e2d85552(params[i], {
        structs: structs,
        type: "constructor"
    }));
    return {
        type: "constructor",
        stateMutability: match.stateMutability ?? "nonpayable",
        inputs: abiParameters
    };
}
function $bd0270f0b2dccaba$export$59f3352106efd66(signature) {
    const match = (0, $X3o77.execFallbackSignature)(signature);
    if (!match) throw new (0, $i3t4X.InvalidSignatureError)({
        signature: signature,
        type: "fallback"
    });
    return {
        type: "fallback",
        stateMutability: match.stateMutability ?? "nonpayable"
    };
}
const $bd0270f0b2dccaba$var$abiParameterWithoutTupleRegex = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/;
const $bd0270f0b2dccaba$var$abiParameterWithTupleRegex = /^\((?<type>.+?)\)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/;
const $bd0270f0b2dccaba$var$dynamicIntegerRegex = /^u?int$/;
function $bd0270f0b2dccaba$export$357229f9e2d85552(param, options) {
    // optional namespace cache by `type`
    const parameterCacheKey = (0, $1lzUm.getParameterCacheKey)(param, options?.type, options?.structs);
    if ((0, $1lzUm.parameterCache).has(parameterCacheKey)) return (0, $1lzUm.parameterCache).get(parameterCacheKey);
    const isTuple = (0, $71OGG.isTupleRegex).test(param);
    const match = (0, $71OGG.execTyped)(isTuple ? $bd0270f0b2dccaba$var$abiParameterWithTupleRegex : $bd0270f0b2dccaba$var$abiParameterWithoutTupleRegex, param);
    if (!match) throw new (0, $l8RId.InvalidParameterError)({
        param: param
    });
    if (match.name && $bd0270f0b2dccaba$export$d83e1b8970d84409(match.name)) throw new (0, $l8RId.SolidityProtectedKeywordError)({
        param: param,
        name: match.name
    });
    const name = match.name ? {
        name: match.name
    } : {};
    const indexed = match.modifier === "indexed" ? {
        indexed: true
    } : {};
    const structs = options?.structs ?? {};
    let type;
    let components = {};
    if (isTuple) {
        type = "tuple";
        const params = $bd0270f0b2dccaba$export$8350908b11ff5aef(match.type);
        const components_ = [];
        const length = params.length;
        for(let i = 0; i < length; i++)// remove `modifiers` from `options` to prevent from being added to tuple components
        components_.push($bd0270f0b2dccaba$export$357229f9e2d85552(params[i], {
            structs: structs
        }));
        components = {
            components: components_
        };
    } else if (match.type in structs) {
        type = "tuple";
        components = {
            components: structs[match.type]
        };
    } else if ($bd0270f0b2dccaba$var$dynamicIntegerRegex.test(match.type)) type = `${match.type}256`;
    else {
        type = match.type;
        if (!(options?.type === "struct") && !$bd0270f0b2dccaba$export$640ecc6f40db6417(type)) throw new (0, $dctyo.UnknownSolidityTypeError)({
            type: type
        });
    }
    if (match.modifier) {
        // Check if modifier exists, but is not allowed (e.g. `indexed` in `functionModifiers`)
        if (!options?.modifiers?.has?.(match.modifier)) throw new (0, $l8RId.InvalidModifierError)({
            param: param,
            type: options?.type,
            modifier: match.modifier
        });
        // Check if resolved `type` is valid if there is a function modifier
        if ((0, $X3o77.functionModifiers).has(match.modifier) && !$bd0270f0b2dccaba$export$7265528696368a9(type, !!match.array)) throw new (0, $l8RId.InvalidFunctionModifierError)({
            param: param,
            type: options?.type,
            modifier: match.modifier
        });
    }
    const abiParameter = {
        type: `${type}${match.array ?? ""}`,
        ...name,
        ...indexed,
        ...components
    };
    (0, $1lzUm.parameterCache).set(parameterCacheKey, abiParameter);
    return abiParameter;
}
function $bd0270f0b2dccaba$export$8350908b11ff5aef(params, result = [], current = "", depth = 0) {
    const length = params.trim().length;
    // biome-ignore lint/correctness/noUnreachable: recursive
    for(let i = 0; i < length; i++){
        const char = params[i];
        const tail = params.slice(i + 1);
        switch(char){
            case ",":
                return depth === 0 ? $bd0270f0b2dccaba$export$8350908b11ff5aef(tail, [
                    ...result,
                    current.trim()
                ]) : $bd0270f0b2dccaba$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth);
            case "(":
                return $bd0270f0b2dccaba$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth + 1);
            case ")":
                return $bd0270f0b2dccaba$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth - 1);
            default:
                return $bd0270f0b2dccaba$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth);
        }
    }
    if (current === "") return result;
    if (depth !== 0) throw new (0, $71MYR.InvalidParenthesisError)({
        current: current,
        depth: depth
    });
    result.push(current.trim());
    return result;
}
function $bd0270f0b2dccaba$export$640ecc6f40db6417(type) {
    return type === "address" || type === "bool" || type === "function" || type === "string" || (0, $71OGG.bytesRegex).test(type) || (0, $71OGG.integerRegex).test(type);
}
const $bd0270f0b2dccaba$var$protectedKeywordsRegex = /^(?:after|alias|anonymous|apply|auto|byte|calldata|case|catch|constant|copyof|default|defined|error|event|external|false|final|function|immutable|implements|in|indexed|inline|internal|let|mapping|match|memory|mutable|null|of|override|partial|private|promise|public|pure|reference|relocatable|return|returns|sizeof|static|storage|struct|super|supports|switch|this|true|try|typedef|typeof|var|view|virtual)$/;
function $bd0270f0b2dccaba$export$d83e1b8970d84409(name) {
    return name === "address" || name === "bool" || name === "function" || name === "string" || name === "tuple" || (0, $71OGG.bytesRegex).test(name) || (0, $71OGG.integerRegex).test(name) || $bd0270f0b2dccaba$var$protectedKeywordsRegex.test(name);
}
function $bd0270f0b2dccaba$export$7265528696368a9(type, isArray) {
    return isArray || type === "bytes" || type === "string" || type === "tuple";
}

});
parcelRegister("71MYR", function(module, exports) {

$parcel$export(module.exports, "InvalidParenthesisError", () => $51de9eecabcf5760$export$a13d6673dbe1ad6e);

var $1hh7U = parcelRequire("1hh7U");
class $51de9eecabcf5760$export$a13d6673dbe1ad6e extends (0, $1hh7U.BaseError) {
    constructor({ current: current, depth: depth }){
        super("Unbalanced parentheses.", {
            metaMessages: [
                `"${current.trim()}" has too many ${depth > 0 ? "opening" : "closing"} parentheses.`
            ],
            details: `Depth "${depth}"`
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidParenthesisError"
        });
    }
}

});

parcelRegister("1lzUm", function(module, exports) {

$parcel$export(module.exports, "getParameterCacheKey", () => $0fb39b359960a5a7$export$516f1eedf0355404);
$parcel$export(module.exports, "parameterCache", () => $0fb39b359960a5a7$export$da1654d628010643);
/**
 * Gets {@link parameterCache} cache key namespaced by {@link type}. This prevents parameters from being accessible to types that don't allow them (e.g. `string indexed foo` not allowed outside of `type: 'event'`).
 * @param param ABI parameter string
 * @param type ABI parameter type
 * @returns Cache key for {@link parameterCache}
 */ function $0fb39b359960a5a7$export$516f1eedf0355404(param, type, structs) {
    let structKey = "";
    if (structs) for (const struct of Object.entries(structs)){
        if (!struct) continue;
        let propertyKey = "";
        for (const property of struct[1])propertyKey += `[${property.type}${property.name ? `:${property.name}` : ""}]`;
        structKey += `(${struct[0]}{${propertyKey}})`;
    }
    if (type) return `${type}:${param}${structKey}`;
    return param;
}
const $0fb39b359960a5a7$export$da1654d628010643 = new Map([
    // Unnamed
    [
        "address",
        {
            type: "address"
        }
    ],
    [
        "bool",
        {
            type: "bool"
        }
    ],
    [
        "bytes",
        {
            type: "bytes"
        }
    ],
    [
        "bytes32",
        {
            type: "bytes32"
        }
    ],
    [
        "int",
        {
            type: "int256"
        }
    ],
    [
        "int256",
        {
            type: "int256"
        }
    ],
    [
        "string",
        {
            type: "string"
        }
    ],
    [
        "uint",
        {
            type: "uint256"
        }
    ],
    [
        "uint8",
        {
            type: "uint8"
        }
    ],
    [
        "uint16",
        {
            type: "uint16"
        }
    ],
    [
        "uint24",
        {
            type: "uint24"
        }
    ],
    [
        "uint32",
        {
            type: "uint32"
        }
    ],
    [
        "uint64",
        {
            type: "uint64"
        }
    ],
    [
        "uint96",
        {
            type: "uint96"
        }
    ],
    [
        "uint112",
        {
            type: "uint112"
        }
    ],
    [
        "uint160",
        {
            type: "uint160"
        }
    ],
    [
        "uint192",
        {
            type: "uint192"
        }
    ],
    [
        "uint256",
        {
            type: "uint256"
        }
    ],
    // Named
    [
        "address owner",
        {
            type: "address",
            name: "owner"
        }
    ],
    [
        "address to",
        {
            type: "address",
            name: "to"
        }
    ],
    [
        "bool approved",
        {
            type: "bool",
            name: "approved"
        }
    ],
    [
        "bytes _data",
        {
            type: "bytes",
            name: "_data"
        }
    ],
    [
        "bytes data",
        {
            type: "bytes",
            name: "data"
        }
    ],
    [
        "bytes signature",
        {
            type: "bytes",
            name: "signature"
        }
    ],
    [
        "bytes32 hash",
        {
            type: "bytes32",
            name: "hash"
        }
    ],
    [
        "bytes32 r",
        {
            type: "bytes32",
            name: "r"
        }
    ],
    [
        "bytes32 root",
        {
            type: "bytes32",
            name: "root"
        }
    ],
    [
        "bytes32 s",
        {
            type: "bytes32",
            name: "s"
        }
    ],
    [
        "string name",
        {
            type: "string",
            name: "name"
        }
    ],
    [
        "string symbol",
        {
            type: "string",
            name: "symbol"
        }
    ],
    [
        "string tokenURI",
        {
            type: "string",
            name: "tokenURI"
        }
    ],
    [
        "uint tokenId",
        {
            type: "uint256",
            name: "tokenId"
        }
    ],
    [
        "uint8 v",
        {
            type: "uint8",
            name: "v"
        }
    ],
    [
        "uint256 balance",
        {
            type: "uint256",
            name: "balance"
        }
    ],
    [
        "uint256 tokenId",
        {
            type: "uint256",
            name: "tokenId"
        }
    ],
    [
        "uint256 value",
        {
            type: "uint256",
            name: "value"
        }
    ],
    // Indexed
    [
        "event:address indexed from",
        {
            type: "address",
            name: "from",
            indexed: true
        }
    ],
    [
        "event:address indexed to",
        {
            type: "address",
            name: "to",
            indexed: true
        }
    ],
    [
        "event:uint indexed tokenId",
        {
            type: "uint256",
            name: "tokenId",
            indexed: true
        }
    ],
    [
        "event:uint256 indexed tokenId",
        {
            type: "uint256",
            name: "tokenId",
            indexed: true
        }
    ]
]);

});




parcelRegister("6wJhs", function(module, exports) {

$parcel$export(module.exports, "toRpc", () => $4c08db044dbaa1d0$export$28304b15c69ed8d2);

var $brTYz = parcelRequire("brTYz");

var $frW1O = parcelRequire("frW1O");
function $4c08db044dbaa1d0$export$6720e65aed65316f(rpcBlockOverrides) {
    return {
        ...rpcBlockOverrides.baseFeePerGas && {
            baseFeePerGas: BigInt(rpcBlockOverrides.baseFeePerGas)
        },
        ...rpcBlockOverrides.blobBaseFee && {
            blobBaseFee: BigInt(rpcBlockOverrides.blobBaseFee)
        },
        ...rpcBlockOverrides.feeRecipient && {
            feeRecipient: rpcBlockOverrides.feeRecipient
        },
        ...rpcBlockOverrides.gasLimit && {
            gasLimit: BigInt(rpcBlockOverrides.gasLimit)
        },
        ...rpcBlockOverrides.number && {
            number: BigInt(rpcBlockOverrides.number)
        },
        ...rpcBlockOverrides.prevRandao && {
            prevRandao: BigInt(rpcBlockOverrides.prevRandao)
        },
        ...rpcBlockOverrides.time && {
            time: BigInt(rpcBlockOverrides.time)
        },
        ...rpcBlockOverrides.withdrawals && {
            withdrawals: rpcBlockOverrides.withdrawals.map($frW1O.fromRpc)
        }
    };
}
function $4c08db044dbaa1d0$export$28304b15c69ed8d2(blockOverrides) {
    return {
        ...typeof blockOverrides.baseFeePerGas === "bigint" && {
            baseFeePerGas: $brTYz.fromNumber(blockOverrides.baseFeePerGas)
        },
        ...typeof blockOverrides.blobBaseFee === "bigint" && {
            blobBaseFee: $brTYz.fromNumber(blockOverrides.blobBaseFee)
        },
        ...typeof blockOverrides.feeRecipient === "string" && {
            feeRecipient: blockOverrides.feeRecipient
        },
        ...typeof blockOverrides.gasLimit === "bigint" && {
            gasLimit: $brTYz.fromNumber(blockOverrides.gasLimit)
        },
        ...typeof blockOverrides.number === "bigint" && {
            number: $brTYz.fromNumber(blockOverrides.number)
        },
        ...typeof blockOverrides.prevRandao === "bigint" && {
            prevRandao: $brTYz.fromNumber(blockOverrides.prevRandao)
        },
        ...typeof blockOverrides.time === "bigint" && {
            time: $brTYz.fromNumber(blockOverrides.time)
        },
        ...blockOverrides.withdrawals && {
            withdrawals: blockOverrides.withdrawals.map($frW1O.toRpc)
        }
    };
}

});
parcelRegister("brTYz", function(module, exports) {

$parcel$export(module.exports, "fromBytes", () => $855da2feca95a412$export$de2da3025c30316c);
$parcel$export(module.exports, "padRight", () => $855da2feca95a412$export$7e24a29324041c48);
$parcel$export(module.exports, "fromNumber", () => $855da2feca95a412$export$7bbb4164c9a77bc2);
$parcel$export(module.exports, "size", () => $855da2feca95a412$export$346677f925de839c);
$parcel$export(module.exports, "toBigInt", () => $855da2feca95a412$export$c221a145703ab783);
$parcel$export(module.exports, "toNumber", () => $855da2feca95a412$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "SizeOverflowError", () => $855da2feca95a412$export$beb44ed4f8747d0e);
$parcel$export(module.exports, "SliceOffsetOutOfBoundsError", () => $855da2feca95a412$export$cfcd41bba8b36dbd);
$parcel$export(module.exports, "SizeExceedsPaddingSizeError", () => $855da2feca95a412$export$70445dc308a7f3d5);

var $igT8E = parcelRequire("igT8E");

var $3MQf5 = parcelRequire("3MQf5");

var $1o9Xr = parcelRequire("1o9Xr");

var $bZDi8 = parcelRequire("bZDi8");

var $by0e0 = parcelRequire("by0e0");

var $4RUZM = parcelRequire("4RUZM");
const $855da2feca95a412$var$encoder = /*#__PURE__*/ new TextEncoder();
const $855da2feca95a412$var$hexes = /*#__PURE__*/ Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, "0"));
function $855da2feca95a412$export$a7a9523472993e97(value, options = {}) {
    const { strict: strict = false } = options;
    if (!value) throw new $855da2feca95a412$export$28b84176f40096b3(value);
    if (typeof value !== "string") throw new $855da2feca95a412$export$28b84176f40096b3(value);
    if (strict) {
        if (!/^0x[0-9a-fA-F]*$/.test(value)) throw new $855da2feca95a412$export$ef05eafd11dd4a83(value);
    }
    if (!value.startsWith("0x")) throw new $855da2feca95a412$export$ef05eafd11dd4a83(value);
}
function $855da2feca95a412$export$ee1b3e54f0441b22(...values) {
    return `0x${values.reduce((acc, x)=>acc + x.replace("0x", ""), "")}`;
}
function $855da2feca95a412$export$6788812c4e6611e6(value) {
    if (value instanceof Uint8Array) return $855da2feca95a412$export$de2da3025c30316c(value);
    if (Array.isArray(value)) return $855da2feca95a412$export$de2da3025c30316c(new Uint8Array(value));
    return value;
}
function $855da2feca95a412$export$dbafa4424a806c15(value, options = {}) {
    const hex = `0x${Number(value)}`;
    if (typeof options.size === "number") {
        $4RUZM.assertSize(hex, options.size);
        return $855da2feca95a412$export$bc3bea8325045070(hex, options.size);
    }
    return hex;
}
function $855da2feca95a412$export$de2da3025c30316c(value, options = {}) {
    let string = "";
    for(let i = 0; i < value.length; i++)string += $855da2feca95a412$var$hexes[value[i]];
    const hex = `0x${string}`;
    if (typeof options.size === "number") {
        $4RUZM.assertSize(hex, options.size);
        return $855da2feca95a412$export$7e24a29324041c48(hex, options.size);
    }
    return hex;
}
function $855da2feca95a412$export$7bbb4164c9a77bc2(value, options = {}) {
    const { signed: signed, size: size } = options;
    const value_ = BigInt(value);
    let maxValue;
    if (size) {
        if (signed) maxValue = (1n << BigInt(size) * 8n - 1n) - 1n;
        else maxValue = 2n ** (BigInt(size) * 8n) - 1n;
    } else if (typeof value === "number") maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    const minValue = typeof maxValue === "bigint" && signed ? -maxValue - 1n : 0;
    if (maxValue && value_ > maxValue || value_ < minValue) {
        const suffix = typeof value === "bigint" ? "n" : "";
        throw new $855da2feca95a412$export$47d164a8071229a9({
            max: maxValue ? `${maxValue}${suffix}` : undefined,
            min: `${minValue}${suffix}`,
            signed: signed,
            size: size,
            value: `${value}${suffix}`
        });
    }
    const stringValue = (signed && value_ < 0 ? (1n << BigInt(size * 8)) + BigInt(value_) : value_).toString(16);
    const hex = `0x${stringValue}`;
    if (size) return $855da2feca95a412$export$bc3bea8325045070(hex, size);
    return hex;
}
function $855da2feca95a412$export$3004f64547af360e(value, options = {}) {
    return $855da2feca95a412$export$de2da3025c30316c($855da2feca95a412$var$encoder.encode(value), options);
}
function $855da2feca95a412$export$248d38f6296296c5(hexA, hexB) {
    return (0, $igT8E.equalBytes)($3MQf5.fromHex(hexA), $3MQf5.fromHex(hexB));
}
function $855da2feca95a412$export$bc3bea8325045070(value, size) {
    return $4RUZM.pad(value, {
        dir: "left",
        size: size
    });
}
function $855da2feca95a412$export$7e24a29324041c48(value, size) {
    return $4RUZM.pad(value, {
        dir: "right",
        size: size
    });
}
function $855da2feca95a412$export$4385e60b38654f68(length) {
    return $855da2feca95a412$export$de2da3025c30316c($3MQf5.random(length));
}
function $855da2feca95a412$export$58adb3bec8346d0f(value, start, end, options = {}) {
    const { strict: strict } = options;
    $4RUZM.assertStartOffset(value, start);
    const value_ = `0x${value.replace("0x", "").slice((start ?? 0) * 2, (end ?? value.length) * 2)}`;
    if (strict) $4RUZM.assertEndOffset(value_, start, end);
    return value_;
}
function $855da2feca95a412$export$346677f925de839c(value) {
    return Math.ceil((value.length - 2) / 2);
}
function $855da2feca95a412$export$c5557f40488c48ec(value) {
    return $4RUZM.trim(value, {
        dir: "left"
    });
}
function $855da2feca95a412$export$da8e5da96e287379(value) {
    return $4RUZM.trim(value, {
        dir: "right"
    });
}
function $855da2feca95a412$export$c221a145703ab783(hex, options = {}) {
    const { signed: signed } = options;
    if (options.size) $4RUZM.assertSize(hex, options.size);
    const value = BigInt(hex);
    if (!signed) return value;
    const size = (hex.length - 2) / 2;
    const max_unsigned = (1n << BigInt(size) * 8n) - 1n;
    const max_signed = max_unsigned >> 1n;
    if (value <= max_signed) return value;
    return value - max_unsigned - 1n;
}
function $855da2feca95a412$export$3c2e6d1b7583eee6(hex, options = {}) {
    if (options.size) $4RUZM.assertSize(hex, options.size);
    const hex_ = $855da2feca95a412$export$c5557f40488c48ec(hex);
    if (hex_ === "0x") return false;
    if (hex_ === "0x1") return true;
    throw new $855da2feca95a412$export$f574ac54e35514c(hex);
}
function $855da2feca95a412$export$30a71edf0753ed6b(hex, options = {}) {
    return $3MQf5.fromHex(hex, options);
}
function $855da2feca95a412$export$a0a81dc3380ce7d3(hex, options = {}) {
    const { signed: signed, size: size } = options;
    if (!signed && !size) return Number(hex);
    return Number($855da2feca95a412$export$c221a145703ab783(hex, options));
}
function $855da2feca95a412$export$f84e8e69fd4488a5(hex, options = {}) {
    const { size: size } = options;
    let bytes = $3MQf5.fromHex(hex);
    if (size) {
        $by0e0.assertSize(bytes, size);
        bytes = $3MQf5.trimRight(bytes);
    }
    return new TextDecoder().decode(bytes);
}
function $855da2feca95a412$export$a22775fa5e2eebd9(value, options = {}) {
    const { strict: strict = false } = options;
    try {
        $855da2feca95a412$export$a7a9523472993e97(value, {
            strict: strict
        });
        return true;
    } catch  {
        return false;
    }
}
class $855da2feca95a412$export$47d164a8071229a9 extends $1o9Xr.BaseError {
    constructor({ max: max, min: min, signed: signed, size: size, value: value }){
        super(`Number \`${value}\` is not in safe${size ? ` ${size * 8}-bit` : ""}${signed ? " signed" : " unsigned"} integer range ${max ? `(\`${min}\` to \`${max}\`)` : `(above \`${min}\`)`}`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Hex.IntegerOutOfRangeError"
        });
    }
}
class $855da2feca95a412$export$f574ac54e35514c extends $1o9Xr.BaseError {
    constructor(hex){
        super(`Hex value \`"${hex}"\` is not a valid boolean.`, {
            metaMessages: [
                'The hex value must be `"0x0"` (false) or `"0x1"` (true).'
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Hex.InvalidHexBooleanError"
        });
    }
}
class $855da2feca95a412$export$28b84176f40096b3 extends $1o9Xr.BaseError {
    constructor(value){
        super(`Value \`${typeof value === "object" ? $bZDi8.stringify(value) : value}\` of type \`${typeof value}\` is an invalid hex type.`, {
            metaMessages: [
                'Hex types must be represented as `"0x${string}"`.'
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Hex.InvalidHexTypeError"
        });
    }
}
class $855da2feca95a412$export$ef05eafd11dd4a83 extends $1o9Xr.BaseError {
    constructor(value){
        super(`Value \`${value}\` is an invalid hex value.`, {
            metaMessages: [
                'Hex values must start with `"0x"` and contain only hexadecimal characters (0-9, a-f, A-F).'
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Hex.InvalidHexValueError"
        });
    }
}
class $855da2feca95a412$export$a8e02cec4b9cc2a0 extends $1o9Xr.BaseError {
    constructor(value){
        super(`Hex value \`"${value}"\` is an odd length (${value.length - 2} nibbles).`, {
            metaMessages: [
                "It must be an even length."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Hex.InvalidLengthError"
        });
    }
}
class $855da2feca95a412$export$beb44ed4f8747d0e extends $1o9Xr.BaseError {
    constructor({ givenSize: givenSize, maxSize: maxSize }){
        super(`Size cannot exceed \`${maxSize}\` bytes. Given size: \`${givenSize}\` bytes.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Hex.SizeOverflowError"
        });
    }
}
class $855da2feca95a412$export$cfcd41bba8b36dbd extends $1o9Xr.BaseError {
    constructor({ offset: offset, position: position, size: size }){
        super(`Slice ${position === "start" ? "starting" : "ending"} at offset \`${offset}\` is out-of-bounds (size: \`${size}\`).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Hex.SliceOffsetOutOfBoundsError"
        });
    }
}
class $855da2feca95a412$export$70445dc308a7f3d5 extends $1o9Xr.BaseError {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (\`${size}\`) exceeds padding size (\`${targetSize}\`).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Hex.SizeExceedsPaddingSizeError"
        });
    }
}

});
parcelRegister("igT8E", function(module, exports) {

$parcel$export(module.exports, "isBytes", () => $d4d47dfc47a75ec5$export$c6fabfbfd097fc30);
$parcel$export(module.exports, "abytes", () => $d4d47dfc47a75ec5$export$e8a750b9efad93f5);
$parcel$export(module.exports, "abool", () => $d4d47dfc47a75ec5$export$809304d28d77d92d);
$parcel$export(module.exports, "numberToHexUnpadded", () => $d4d47dfc47a75ec5$export$4ed2545b622827c1);
$parcel$export(module.exports, "bytesToHex", () => $d4d47dfc47a75ec5$export$58b867e287a802c8);
$parcel$export(module.exports, "hexToBytes", () => $d4d47dfc47a75ec5$export$31c96b9df38bc8d4);
$parcel$export(module.exports, "bytesToNumberBE", () => $d4d47dfc47a75ec5$export$d609354794974f8);
$parcel$export(module.exports, "bytesToNumberLE", () => $d4d47dfc47a75ec5$export$d67b1d03392107e7);
$parcel$export(module.exports, "numberToBytesBE", () => $d4d47dfc47a75ec5$export$1459dafd057611cb);
$parcel$export(module.exports, "numberToBytesLE", () => $d4d47dfc47a75ec5$export$ba2172e58d139f6d);
$parcel$export(module.exports, "ensureBytes", () => $d4d47dfc47a75ec5$export$3cb5d50a3a30e837);
$parcel$export(module.exports, "concatBytes", () => $d4d47dfc47a75ec5$export$287dd7971339c972);
$parcel$export(module.exports, "equalBytes", () => $d4d47dfc47a75ec5$export$2aa59cef064b0333);
$parcel$export(module.exports, "utf8ToBytes", () => $d4d47dfc47a75ec5$export$3df70a15530b5e81);
$parcel$export(module.exports, "inRange", () => $d4d47dfc47a75ec5$export$ddf89a9c5af38f94);
$parcel$export(module.exports, "aInRange", () => $d4d47dfc47a75ec5$export$86cc12b5dde3c1e4);
$parcel$export(module.exports, "bitLen", () => $d4d47dfc47a75ec5$export$e93ef600c41761a9);
$parcel$export(module.exports, "bitMask", () => $d4d47dfc47a75ec5$export$803efa2fa1c7279);
$parcel$export(module.exports, "createHmacDrbg", () => $d4d47dfc47a75ec5$export$d459d139192e4fba);
$parcel$export(module.exports, "validateObject", () => $d4d47dfc47a75ec5$export$381bae2d0f08004f);
$parcel$export(module.exports, "memoized", () => $d4d47dfc47a75ec5$export$9756366f7cb6f62b);
/**
 * Hex, bytes and number utilities.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $d4d47dfc47a75ec5$var$_0n = /* @__PURE__ */ BigInt(0);
const $d4d47dfc47a75ec5$var$_1n = /* @__PURE__ */ BigInt(1);
function $d4d47dfc47a75ec5$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
function $d4d47dfc47a75ec5$export$e8a750b9efad93f5(item) {
    if (!$d4d47dfc47a75ec5$export$c6fabfbfd097fc30(item)) throw new Error("Uint8Array expected");
}
function $d4d47dfc47a75ec5$export$809304d28d77d92d(title, value) {
    if (typeof value !== "boolean") throw new Error(title + " boolean expected, got " + value);
}
function $d4d47dfc47a75ec5$export$4ed2545b622827c1(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? "0" + hex : hex;
}
function $d4d47dfc47a75ec5$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    return hex === "" ? $d4d47dfc47a75ec5$var$_0n : BigInt("0x" + hex); // Big Endian
}
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const $d4d47dfc47a75ec5$var$hasHexBuiltin = // @ts-ignore
typeof Uint8Array.from([]).toHex === "function" && typeof Uint8Array.fromHex === "function";
// Array where index 0xf0 (240) is mapped to string 'f0'
const $d4d47dfc47a75ec5$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $d4d47dfc47a75ec5$export$58b867e287a802c8(bytes) {
    $d4d47dfc47a75ec5$export$e8a750b9efad93f5(bytes);
    // @ts-ignore
    if ($d4d47dfc47a75ec5$var$hasHexBuiltin) return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $d4d47dfc47a75ec5$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $d4d47dfc47a75ec5$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $d4d47dfc47a75ec5$var$asciiToBase16(ch) {
    if (ch >= $d4d47dfc47a75ec5$var$asciis._0 && ch <= $d4d47dfc47a75ec5$var$asciis._9) return ch - $d4d47dfc47a75ec5$var$asciis._0; // '2' => 50-48
    if (ch >= $d4d47dfc47a75ec5$var$asciis.A && ch <= $d4d47dfc47a75ec5$var$asciis.F) return ch - ($d4d47dfc47a75ec5$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $d4d47dfc47a75ec5$var$asciis.a && ch <= $d4d47dfc47a75ec5$var$asciis.f) return ch - ($d4d47dfc47a75ec5$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
function $d4d47dfc47a75ec5$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // @ts-ignore
    if ($d4d47dfc47a75ec5$var$hasHexBuiltin) return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $d4d47dfc47a75ec5$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $d4d47dfc47a75ec5$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
function $d4d47dfc47a75ec5$export$d609354794974f8(bytes) {
    return $d4d47dfc47a75ec5$export$d57f2bacc26b4249($d4d47dfc47a75ec5$export$58b867e287a802c8(bytes));
}
function $d4d47dfc47a75ec5$export$d67b1d03392107e7(bytes) {
    $d4d47dfc47a75ec5$export$e8a750b9efad93f5(bytes);
    return $d4d47dfc47a75ec5$export$d57f2bacc26b4249($d4d47dfc47a75ec5$export$58b867e287a802c8(Uint8Array.from(bytes).reverse()));
}
function $d4d47dfc47a75ec5$export$1459dafd057611cb(n, len) {
    return $d4d47dfc47a75ec5$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, "0"));
}
function $d4d47dfc47a75ec5$export$ba2172e58d139f6d(n, len) {
    return $d4d47dfc47a75ec5$export$1459dafd057611cb(n, len).reverse();
}
function $d4d47dfc47a75ec5$export$80ee8c1914de6dde(n) {
    return $d4d47dfc47a75ec5$export$31c96b9df38bc8d4($d4d47dfc47a75ec5$export$4ed2545b622827c1(n));
}
function $d4d47dfc47a75ec5$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $d4d47dfc47a75ec5$export$31c96b9df38bc8d4(hex);
    } catch (e) {
        throw new Error(title + " must be hex string or Uint8Array, cause: " + e);
    }
    else if ($d4d47dfc47a75ec5$export$c6fabfbfd097fc30(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(title + " must be hex string or Uint8Array");
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(title + " of length " + expectedLength + " expected, got " + len);
    return res;
}
function $d4d47dfc47a75ec5$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $d4d47dfc47a75ec5$export$e8a750b9efad93f5(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $d4d47dfc47a75ec5$export$2aa59cef064b0333(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
function $d4d47dfc47a75ec5$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error("string expected");
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
// Is positive bigint
const $d4d47dfc47a75ec5$var$isPosBig = (n)=>typeof n === "bigint" && $d4d47dfc47a75ec5$var$_0n <= n;
function $d4d47dfc47a75ec5$export$ddf89a9c5af38f94(n, min, max) {
    return $d4d47dfc47a75ec5$var$isPosBig(n) && $d4d47dfc47a75ec5$var$isPosBig(min) && $d4d47dfc47a75ec5$var$isPosBig(max) && min <= n && n < max;
}
function $d4d47dfc47a75ec5$export$86cc12b5dde3c1e4(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!$d4d47dfc47a75ec5$export$ddf89a9c5af38f94(n, min, max)) throw new Error("expected valid " + title + ": " + min + " <= n < " + max + ", got " + n);
}
function $d4d47dfc47a75ec5$export$e93ef600c41761a9(n) {
    let len;
    for(len = 0; n > $d4d47dfc47a75ec5$var$_0n; n >>= $d4d47dfc47a75ec5$var$_1n, len += 1);
    return len;
}
function $d4d47dfc47a75ec5$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $d4d47dfc47a75ec5$var$_1n;
}
function $d4d47dfc47a75ec5$export$967bb2b9787441cb(n, pos, value) {
    return n | (value ? $d4d47dfc47a75ec5$var$_1n : $d4d47dfc47a75ec5$var$_0n) << BigInt(pos);
}
const $d4d47dfc47a75ec5$export$803efa2fa1c7279 = (n)=>($d4d47dfc47a75ec5$var$_1n << BigInt(n)) - $d4d47dfc47a75ec5$var$_1n;
// DRBG
const $d4d47dfc47a75ec5$var$u8n = (len)=>new Uint8Array(len); // creates Uint8Array
const $d4d47dfc47a75ec5$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
function $d4d47dfc47a75ec5$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $d4d47dfc47a75ec5$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $d4d47dfc47a75ec5$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $d4d47dfc47a75ec5$var$u8n(0))=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($d4d47dfc47a75ec5$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($d4d47dfc47a75ec5$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $d4d47dfc47a75ec5$export$287dd7971339c972(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $d4d47dfc47a75ec5$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || $d4d47dfc47a75ec5$export$c6fabfbfd097fc30(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
function $d4d47dfc47a75ec5$export$381bae2d0f08004f(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $d4d47dfc47a75ec5$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error("invalid validator function");
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error("param " + String(fieldName) + " is invalid. Expected " + type + ", got " + val);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
const $d4d47dfc47a75ec5$export$94a5f06e658f87e2 = ()=>{
    throw new Error("not implemented");
};
function $d4d47dfc47a75ec5$export$9756366f7cb6f62b(fn) {
    const map = new WeakMap();
    return (arg, ...args)=>{
        const val = map.get(arg);
        if (val !== undefined) return val;
        const computed = fn(arg, ...args);
        map.set(arg, computed);
        return computed;
    };
}

});

parcelRegister("3MQf5", function(module, exports) {

$parcel$export(module.exports, "fromHex", () => $2c1e6102db510eab$export$1a8ceedbd5845648);
$parcel$export(module.exports, "random", () => $2c1e6102db510eab$export$4385e60b38654f68);
$parcel$export(module.exports, "size", () => $2c1e6102db510eab$export$346677f925de839c);
$parcel$export(module.exports, "trimRight", () => $2c1e6102db510eab$export$da8e5da96e287379);
$parcel$export(module.exports, "SizeOverflowError", () => $2c1e6102db510eab$export$beb44ed4f8747d0e);
$parcel$export(module.exports, "SliceOffsetOutOfBoundsError", () => $2c1e6102db510eab$export$cfcd41bba8b36dbd);
$parcel$export(module.exports, "SizeExceedsPaddingSizeError", () => $2c1e6102db510eab$export$70445dc308a7f3d5);

var $igT8E = parcelRequire("igT8E");

var $1o9Xr = parcelRequire("1o9Xr");

var $brTYz = parcelRequire("brTYz");

var $bZDi8 = parcelRequire("bZDi8");

var $by0e0 = parcelRequire("by0e0");

var $4RUZM = parcelRequire("4RUZM");
const $2c1e6102db510eab$var$decoder = /*#__PURE__*/ new TextDecoder();
const $2c1e6102db510eab$var$encoder = /*#__PURE__*/ new TextEncoder();
function $2c1e6102db510eab$export$a7a9523472993e97(value) {
    if (value instanceof Uint8Array) return;
    if (!value) throw new $2c1e6102db510eab$export$eda7c289dac6c5ce(value);
    if (typeof value !== "object") throw new $2c1e6102db510eab$export$eda7c289dac6c5ce(value);
    if (!("BYTES_PER_ELEMENT" in value)) throw new $2c1e6102db510eab$export$eda7c289dac6c5ce(value);
    if (value.BYTES_PER_ELEMENT !== 1 || value.constructor.name !== "Uint8Array") throw new $2c1e6102db510eab$export$eda7c289dac6c5ce(value);
}
function $2c1e6102db510eab$export$ee1b3e54f0441b22(...values) {
    let length = 0;
    for (const arr of values)length += arr.length;
    const result = new Uint8Array(length);
    for(let i = 0, index = 0; i < values.length; i++){
        const arr = values[i];
        result.set(arr, index);
        index += arr.length;
    }
    return result;
}
function $2c1e6102db510eab$export$6788812c4e6611e6(value) {
    if (value instanceof Uint8Array) return value;
    if (typeof value === "string") return $2c1e6102db510eab$export$1a8ceedbd5845648(value);
    return $2c1e6102db510eab$export$571d59b505e6bb4e(value);
}
function $2c1e6102db510eab$export$571d59b505e6bb4e(value) {
    return value instanceof Uint8Array ? value : new Uint8Array(value);
}
function $2c1e6102db510eab$export$dbafa4424a806c15(value, options = {}) {
    const { size: size } = options;
    const bytes = new Uint8Array(1);
    bytes[0] = Number(value);
    if (typeof size === "number") {
        $by0e0.assertSize(bytes, size);
        return $2c1e6102db510eab$export$bc3bea8325045070(bytes, size);
    }
    return bytes;
}
function $2c1e6102db510eab$export$1a8ceedbd5845648(value, options = {}) {
    const { size: size } = options;
    let hex = value;
    if (size) {
        $4RUZM.assertSize(value, size);
        hex = $brTYz.padRight(value, size);
    }
    let hexString = hex.slice(2);
    if (hexString.length % 2) hexString = `0${hexString}`;
    const length = hexString.length / 2;
    const bytes = new Uint8Array(length);
    for(let index = 0, j = 0; index < length; index++){
        const nibbleLeft = $by0e0.charCodeToBase16(hexString.charCodeAt(j++));
        const nibbleRight = $by0e0.charCodeToBase16(hexString.charCodeAt(j++));
        if (nibbleLeft === undefined || nibbleRight === undefined) throw new $1o9Xr.BaseError(`Invalid byte sequence ("${hexString[j - 2]}${hexString[j - 1]}" in "${hexString}").`);
        bytes[index] = nibbleLeft * 16 + nibbleRight;
    }
    return bytes;
}
function $2c1e6102db510eab$export$7bbb4164c9a77bc2(value, options) {
    const hex = $brTYz.fromNumber(value, options);
    return $2c1e6102db510eab$export$1a8ceedbd5845648(hex);
}
function $2c1e6102db510eab$export$3004f64547af360e(value, options = {}) {
    const { size: size } = options;
    const bytes = $2c1e6102db510eab$var$encoder.encode(value);
    if (typeof size === "number") {
        $by0e0.assertSize(bytes, size);
        return $2c1e6102db510eab$export$7e24a29324041c48(bytes, size);
    }
    return bytes;
}
function $2c1e6102db510eab$export$248d38f6296296c5(bytesA, bytesB) {
    return (0, $igT8E.equalBytes)(bytesA, bytesB);
}
function $2c1e6102db510eab$export$bc3bea8325045070(value, size) {
    return $by0e0.pad(value, {
        dir: "left",
        size: size
    });
}
function $2c1e6102db510eab$export$7e24a29324041c48(value, size) {
    return $by0e0.pad(value, {
        dir: "right",
        size: size
    });
}
function $2c1e6102db510eab$export$4385e60b38654f68(length) {
    return crypto.getRandomValues(new Uint8Array(length));
}
function $2c1e6102db510eab$export$346677f925de839c(value) {
    return value.length;
}
function $2c1e6102db510eab$export$58adb3bec8346d0f(value, start, end, options = {}) {
    const { strict: strict } = options;
    $by0e0.assertStartOffset(value, start);
    const value_ = value.slice(start, end);
    if (strict) $by0e0.assertEndOffset(value_, start, end);
    return value_;
}
function $2c1e6102db510eab$export$c221a145703ab783(bytes, options = {}) {
    const { size: size } = options;
    if (typeof size !== "undefined") $by0e0.assertSize(bytes, size);
    const hex = $brTYz.fromBytes(bytes, options);
    return $brTYz.toBigInt(hex, options);
}
function $2c1e6102db510eab$export$3c2e6d1b7583eee6(bytes, options = {}) {
    const { size: size } = options;
    let bytes_ = bytes;
    if (typeof size !== "undefined") {
        $by0e0.assertSize(bytes_, size);
        bytes_ = $2c1e6102db510eab$export$c5557f40488c48ec(bytes_);
    }
    if (bytes_.length > 1 || bytes_[0] > 1) throw new $2c1e6102db510eab$export$52fc62e5266c8838(bytes_);
    return Boolean(bytes_[0]);
}
function $2c1e6102db510eab$export$7ea66e3774a60b67(value, options = {}) {
    return $brTYz.fromBytes(value, options);
}
function $2c1e6102db510eab$export$a0a81dc3380ce7d3(bytes, options = {}) {
    const { size: size } = options;
    if (typeof size !== "undefined") $by0e0.assertSize(bytes, size);
    const hex = $brTYz.fromBytes(bytes, options);
    return $brTYz.toNumber(hex, options);
}
function $2c1e6102db510eab$export$f84e8e69fd4488a5(bytes, options = {}) {
    const { size: size } = options;
    let bytes_ = bytes;
    if (typeof size !== "undefined") {
        $by0e0.assertSize(bytes_, size);
        bytes_ = $2c1e6102db510eab$export$da8e5da96e287379(bytes_);
    }
    return $2c1e6102db510eab$var$decoder.decode(bytes_);
}
function $2c1e6102db510eab$export$c5557f40488c48ec(value) {
    return $by0e0.trim(value, {
        dir: "left"
    });
}
function $2c1e6102db510eab$export$da8e5da96e287379(value) {
    return $by0e0.trim(value, {
        dir: "right"
    });
}
function $2c1e6102db510eab$export$a22775fa5e2eebd9(value) {
    try {
        $2c1e6102db510eab$export$a7a9523472993e97(value);
        return true;
    } catch  {
        return false;
    }
}
class $2c1e6102db510eab$export$52fc62e5266c8838 extends $1o9Xr.BaseError {
    constructor(bytes){
        super(`Bytes value \`${bytes}\` is not a valid boolean.`, {
            metaMessages: [
                "The bytes array must contain a single byte of either a `0` or `1` value."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Bytes.InvalidBytesBooleanError"
        });
    }
}
class $2c1e6102db510eab$export$eda7c289dac6c5ce extends $1o9Xr.BaseError {
    constructor(value){
        super(`Value \`${typeof value === "object" ? $bZDi8.stringify(value) : value}\` of type \`${typeof value}\` is an invalid Bytes value.`, {
            metaMessages: [
                "Bytes values must be of type `Bytes`."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Bytes.InvalidBytesTypeError"
        });
    }
}
class $2c1e6102db510eab$export$beb44ed4f8747d0e extends $1o9Xr.BaseError {
    constructor({ givenSize: givenSize, maxSize: maxSize }){
        super(`Size cannot exceed \`${maxSize}\` bytes. Given size: \`${givenSize}\` bytes.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Bytes.SizeOverflowError"
        });
    }
}
class $2c1e6102db510eab$export$cfcd41bba8b36dbd extends $1o9Xr.BaseError {
    constructor({ offset: offset, position: position, size: size }){
        super(`Slice ${position === "start" ? "starting" : "ending"} at offset \`${offset}\` is out-of-bounds (size: \`${size}\`).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Bytes.SliceOffsetOutOfBoundsError"
        });
    }
}
class $2c1e6102db510eab$export$70445dc308a7f3d5 extends $1o9Xr.BaseError {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (\`${size}\`) exceeds padding size (\`${targetSize}\`).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Bytes.SizeExceedsPaddingSizeError"
        });
    }
}

});
parcelRegister("1o9Xr", function(module, exports) {

$parcel$export(module.exports, "BaseError", () => $102fc1bae9aced6c$export$a490eb03cb7a0a5e);

var $aSmDC = parcelRequire("aSmDC");
class $102fc1bae9aced6c$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, options = {}){
        const details = (()=>{
            if (options.cause instanceof $102fc1bae9aced6c$export$a490eb03cb7a0a5e) {
                if (options.cause.details) return options.cause.details;
                if (options.cause.shortMessage) return options.cause.shortMessage;
            }
            if (options.cause && "details" in options.cause && typeof options.cause.details === "string") return options.cause.details;
            if (options.cause?.message) return options.cause.message;
            return options.details;
        })();
        const docsPath = (()=>{
            if (options.cause instanceof $102fc1bae9aced6c$export$a490eb03cb7a0a5e) return options.cause.docsPath || options.docsPath;
            return options.docsPath;
        })();
        const docsBaseUrl = "https://oxlib.sh";
        const docs = `${docsBaseUrl}${docsPath ?? ""}`;
        const message = [
            shortMessage || "An error occurred.",
            ...options.metaMessages ? [
                "",
                ...options.metaMessages
            ] : [],
            ...details || docsPath ? [
                "",
                details ? `Details: ${details}` : undefined,
                docsPath ? `See: ${docs}` : undefined
            ] : []
        ].filter((x)=>typeof x === "string").join("\n");
        super(message, options.cause ? {
            cause: options.cause
        } : undefined);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BaseError"
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: `ox@${(0, $aSmDC.getVersion)()}`
        });
        this.cause = options.cause;
        this.details = details;
        this.docs = docs;
        this.docsPath = docsPath;
        this.shortMessage = shortMessage;
    }
    walk(fn) {
        return $102fc1bae9aced6c$var$walk(this, fn);
    }
}
/** @internal */ function $102fc1bae9aced6c$var$walk(err, fn) {
    if (fn?.(err)) return err;
    if (err && typeof err === "object" && "cause" in err && err.cause) return $102fc1bae9aced6c$var$walk(err.cause, fn);
    return fn ? null : err;
}

});
parcelRegister("aSmDC", function(module, exports) {

$parcel$export(module.exports, "getVersion", () => $7eb081f7abbae2de$export$c506eb22e615ba4a);

var $laGSu = parcelRequire("laGSu");
function $7eb081f7abbae2de$export$94df0e59ebebf4a7(url) {
    return url;
}
function $7eb081f7abbae2de$export$c506eb22e615ba4a() {
    return 0, $laGSu.version;
}
function $7eb081f7abbae2de$export$cde3d1388a9feac3(args) {
    if (!args) return "";
    const entries = Object.entries(args).map(([key, value])=>{
        if (value === undefined || value === false) return null;
        return [
            key,
            value
        ];
    }).filter(Boolean);
    const maxLength = entries.reduce((acc, [key])=>Math.max(acc, key.length), 0);
    return entries.map(([key, value])=>`  ${`${key}:`.padEnd(maxLength + 1)}  ${value}`).join("\n");
}

});
parcelRegister("laGSu", function(module, exports) {

$parcel$export(module.exports, "version", () => $f69bcac8ee81aace$export$83d89fbfd8236492);
/** @internal */ const $f69bcac8ee81aace$export$83d89fbfd8236492 = "0.1.1";

});



parcelRegister("bZDi8", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $8bb3dead78cd187f$export$fac44ee5b035f737);
const $8bb3dead78cd187f$var$bigIntSuffix = "#__bigint";
function $8bb3dead78cd187f$export$98e6a39c04603d36(string, reviver) {
    return JSON.parse(string, (key, value_)=>{
        const value = value_;
        if (typeof value === "string" && value.endsWith($8bb3dead78cd187f$var$bigIntSuffix)) return BigInt(value.slice(0, -$8bb3dead78cd187f$var$bigIntSuffix.length));
        return typeof reviver === "function" ? reviver(key, value) : value;
    });
}
function $8bb3dead78cd187f$export$fac44ee5b035f737(value, replacer, space) {
    return JSON.stringify(value, (key, value)=>{
        if (typeof replacer === "function") return replacer(key, value);
        if (typeof value === "bigint") return value.toString() + $8bb3dead78cd187f$var$bigIntSuffix;
        return value;
    }, space);
}

});

parcelRegister("by0e0", function(module, exports) {

$parcel$export(module.exports, "assertSize", () => $86830b5296bd79af$export$2af489edb7fa35fe);
$parcel$export(module.exports, "assertStartOffset", () => $86830b5296bd79af$export$98489c993c29af1d);
$parcel$export(module.exports, "assertEndOffset", () => $86830b5296bd79af$export$37e4b9f33692ba2b);
$parcel$export(module.exports, "charCodeToBase16", () => $86830b5296bd79af$export$d2f423b5f9925871);
$parcel$export(module.exports, "pad", () => $86830b5296bd79af$export$5d04458e2a6c373e);
$parcel$export(module.exports, "trim", () => $86830b5296bd79af$export$87c2784dc9fc4ab);

var $3MQf5 = parcelRequire("3MQf5");
function $86830b5296bd79af$export$2af489edb7fa35fe(bytes, size_) {
    if ($3MQf5.size(bytes) > size_) throw new $3MQf5.SizeOverflowError({
        givenSize: $3MQf5.size(bytes),
        maxSize: size_
    });
}
function $86830b5296bd79af$export$98489c993c29af1d(value, start) {
    if (typeof start === "number" && start > 0 && start > $3MQf5.size(value) - 1) throw new $3MQf5.SliceOffsetOutOfBoundsError({
        offset: start,
        position: "start",
        size: $3MQf5.size(value)
    });
}
function $86830b5296bd79af$export$37e4b9f33692ba2b(value, start, end) {
    if (typeof start === "number" && typeof end === "number" && $3MQf5.size(value) !== end - start) throw new $3MQf5.SliceOffsetOutOfBoundsError({
        offset: end,
        position: "end",
        size: $3MQf5.size(value)
    });
}
const $86830b5296bd79af$export$1abeefa007f24ab4 = {
    zero: 48,
    nine: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $86830b5296bd79af$export$d2f423b5f9925871(char) {
    if (char >= $86830b5296bd79af$export$1abeefa007f24ab4.zero && char <= $86830b5296bd79af$export$1abeefa007f24ab4.nine) return char - $86830b5296bd79af$export$1abeefa007f24ab4.zero;
    if (char >= $86830b5296bd79af$export$1abeefa007f24ab4.A && char <= $86830b5296bd79af$export$1abeefa007f24ab4.F) return char - ($86830b5296bd79af$export$1abeefa007f24ab4.A - 10);
    if (char >= $86830b5296bd79af$export$1abeefa007f24ab4.a && char <= $86830b5296bd79af$export$1abeefa007f24ab4.f) return char - ($86830b5296bd79af$export$1abeefa007f24ab4.a - 10);
    return undefined;
}
function $86830b5296bd79af$export$5d04458e2a6c373e(bytes, options = {}) {
    const { dir: dir, size: size = 32 } = options;
    if (size === 0) return bytes;
    if (bytes.length > size) throw new $3MQf5.SizeExceedsPaddingSizeError({
        size: bytes.length,
        targetSize: size,
        type: "Bytes"
    });
    const paddedBytes = new Uint8Array(size);
    for(let i = 0; i < size; i++){
        const padEnd = dir === "right";
        paddedBytes[padEnd ? i : size - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
    }
    return paddedBytes;
}
function $86830b5296bd79af$export$87c2784dc9fc4ab(value, options = {}) {
    const { dir: dir = "left" } = options;
    let data = value;
    let sliceLength = 0;
    for(let i = 0; i < data.length - 1; i++){
        if (data[dir === "left" ? i : data.length - i - 1].toString() === "0") sliceLength++;
        else break;
    }
    data = dir === "left" ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    return data;
}

});

parcelRegister("4RUZM", function(module, exports) {

$parcel$export(module.exports, "assertSize", () => $38b852c2d28a2669$export$2af489edb7fa35fe);
$parcel$export(module.exports, "assertStartOffset", () => $38b852c2d28a2669$export$98489c993c29af1d);
$parcel$export(module.exports, "assertEndOffset", () => $38b852c2d28a2669$export$37e4b9f33692ba2b);
$parcel$export(module.exports, "pad", () => $38b852c2d28a2669$export$5d04458e2a6c373e);
$parcel$export(module.exports, "trim", () => $38b852c2d28a2669$export$87c2784dc9fc4ab);

var $brTYz = parcelRequire("brTYz");
function $38b852c2d28a2669$export$2af489edb7fa35fe(hex, size_) {
    if ($brTYz.size(hex) > size_) throw new $brTYz.SizeOverflowError({
        givenSize: $brTYz.size(hex),
        maxSize: size_
    });
}
function $38b852c2d28a2669$export$98489c993c29af1d(value, start) {
    if (typeof start === "number" && start > 0 && start > $brTYz.size(value) - 1) throw new $brTYz.SliceOffsetOutOfBoundsError({
        offset: start,
        position: "start",
        size: $brTYz.size(value)
    });
}
function $38b852c2d28a2669$export$37e4b9f33692ba2b(value, start, end) {
    if (typeof start === "number" && typeof end === "number" && $brTYz.size(value) !== end - start) throw new $brTYz.SliceOffsetOutOfBoundsError({
        offset: end,
        position: "end",
        size: $brTYz.size(value)
    });
}
function $38b852c2d28a2669$export$5d04458e2a6c373e(hex_, options = {}) {
    const { dir: dir, size: size = 32 } = options;
    if (size === 0) return hex_;
    const hex = hex_.replace("0x", "");
    if (hex.length > size * 2) throw new $brTYz.SizeExceedsPaddingSizeError({
        size: Math.ceil(hex.length / 2),
        targetSize: size,
        type: "Hex"
    });
    return `0x${hex[dir === "right" ? "padEnd" : "padStart"](size * 2, "0")}`;
}
function $38b852c2d28a2669$export$87c2784dc9fc4ab(value, options = {}) {
    const { dir: dir = "left" } = options;
    let data = value.replace("0x", "");
    let sliceLength = 0;
    for(let i = 0; i < data.length - 1; i++){
        if (data[dir === "left" ? i : data.length - i - 1].toString() === "0") sliceLength++;
        else break;
    }
    data = dir === "left" ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    if (data === "0") return "0x";
    if (dir === "right" && data.length % 2 === 1) return `0x${data}0`;
    return `0x${data}`;
}

});



parcelRegister("frW1O", function(module, exports) {

$parcel$export(module.exports, "fromRpc", () => $b3f663d1a975364e$export$6720e65aed65316f);
$parcel$export(module.exports, "toRpc", () => $b3f663d1a975364e$export$28304b15c69ed8d2);

var $brTYz = parcelRequire("brTYz");
function $b3f663d1a975364e$export$6720e65aed65316f(withdrawal) {
    return {
        ...withdrawal,
        amount: BigInt(withdrawal.amount),
        index: Number(withdrawal.index),
        validatorIndex: Number(withdrawal.validatorIndex)
    };
}
function $b3f663d1a975364e$export$28304b15c69ed8d2(withdrawal) {
    return {
        address: withdrawal.address,
        amount: $brTYz.fromNumber(withdrawal.amount),
        index: $brTYz.fromNumber(withdrawal.index),
        validatorIndex: $brTYz.fromNumber(withdrawal.validatorIndex)
    };
}

});


parcelRegister("fbsYZ", function(module, exports) {

$parcel$export(module.exports, "parseAccount", () => $b0de5d7a7263fabe$export$11027cbf6cf15da2);
function $b0de5d7a7263fabe$export$11027cbf6cf15da2(account) {
    if (typeof account === "string") return {
        address: account,
        type: "json-rpc"
    };
    return account;
}

});

parcelRegister("2aU8i", function(module, exports) {

$parcel$export(module.exports, "aggregate3Signature", () => $19580eba3017c680$export$25fd9a7ba13a8409);
const $19580eba3017c680$export$25fd9a7ba13a8409 = "0x82ad56cb";

});

parcelRegister("hQPTC", function(module, exports) {

$parcel$export(module.exports, "deploylessCallViaBytecodeBytecode", () => $cfef8c7df60db7f9$export$b8650f6504de1536);
$parcel$export(module.exports, "deploylessCallViaFactoryBytecode", () => $cfef8c7df60db7f9$export$b03493bdbcb80605);
const $cfef8c7df60db7f9$export$b8650f6504de1536 = "0x608060405234801561001057600080fd5b5060405161018e38038061018e83398101604081905261002f91610124565b6000808351602085016000f59050803b61004857600080fd5b6000808351602085016000855af16040513d6000823e81610067573d81fd5b3d81f35b634e487b7160e01b600052604160045260246000fd5b600082601f83011261009257600080fd5b81516001600160401b038111156100ab576100ab61006b565b604051601f8201601f19908116603f011681016001600160401b03811182821017156100d9576100d961006b565b6040528181528382016020018510156100f157600080fd5b60005b82811015610110576020818601810151838301820152016100f4565b506000918101602001919091529392505050565b6000806040838503121561013757600080fd5b82516001600160401b0381111561014d57600080fd5b61015985828601610081565b602085015190935090506001600160401b0381111561017757600080fd5b61018385828601610081565b915050925092905056fe";
const $cfef8c7df60db7f9$export$b03493bdbcb80605 = "0x608060405234801561001057600080fd5b506040516102c03803806102c083398101604081905261002f916101e6565b836001600160a01b03163b6000036100e457600080836001600160a01b03168360405161005c9190610270565b6000604051808303816000865af19150503d8060008114610099576040519150601f19603f3d011682016040523d82523d6000602084013e61009e565b606091505b50915091508115806100b857506001600160a01b0386163b155b156100e1578060405163101bb98d60e01b81526004016100d8919061028c565b60405180910390fd5b50505b6000808451602086016000885af16040513d6000823e81610103573d81fd5b3d81f35b80516001600160a01b038116811461011e57600080fd5b919050565b634e487b7160e01b600052604160045260246000fd5b60005b8381101561015457818101518382015260200161013c565b50506000910152565b600082601f83011261016e57600080fd5b81516001600160401b0381111561018757610187610123565b604051601f8201601f19908116603f011681016001600160401b03811182821017156101b5576101b5610123565b6040528181528382016020018510156101cd57600080fd5b6101de826020830160208701610139565b949350505050565b600080600080608085870312156101fc57600080fd5b61020585610107565b60208601519094506001600160401b0381111561022157600080fd5b61022d8782880161015d565b93505061023c60408601610107565b60608601519092506001600160401b0381111561025857600080fd5b6102648782880161015d565b91505092959194509250565b60008251610282818460208701610139565b9190910192915050565b60208152600082518060208401526102ab816040850160208701610139565b601f01601f1916919091016040019291505056fe";
const $cfef8c7df60db7f9$export$76c7202cd92b9dbb = "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";

});

parcelRegister("4TNV6", function(module, exports) {

$parcel$export(module.exports, "ChainDoesNotSupportContract", () => $3913058a7a57a4e1$export$f2b2bfa70417796b);
$parcel$export(module.exports, "ChainMismatchError", () => $3913058a7a57a4e1$export$535d82255cc17992);
$parcel$export(module.exports, "ChainNotFoundError", () => $3913058a7a57a4e1$export$b7f33b26fea1ae0b);
$parcel$export(module.exports, "ClientChainNotConfiguredError", () => $3913058a7a57a4e1$export$64807f0e18658482);

var $3cVvs = parcelRequire("3cVvs");
class $3913058a7a57a4e1$export$f2b2bfa70417796b extends (0, $3cVvs.BaseError) {
    constructor({ blockNumber: blockNumber, chain: chain, contract: contract }){
        super(`Chain "${chain.name}" does not support contract "${contract.name}".`, {
            metaMessages: [
                "This could be due to any of the following:",
                ...blockNumber && contract.blockCreated && contract.blockCreated > blockNumber ? [
                    `- The contract "${contract.name}" was not deployed until block ${contract.blockCreated} (current block ${blockNumber}).`
                ] : [
                    `- The chain does not have the contract "${contract.name}" configured.`
                ]
            ],
            name: "ChainDoesNotSupportContract"
        });
    }
}
class $3913058a7a57a4e1$export$535d82255cc17992 extends (0, $3cVvs.BaseError) {
    constructor({ chain: chain, currentChainId: currentChainId }){
        super(`The current chain of the wallet (id: ${currentChainId}) does not match the target chain for the transaction (id: ${chain.id} \u{2013} ${chain.name}).`, {
            metaMessages: [
                `Current Chain ID:  ${currentChainId}`,
                `Expected Chain ID: ${chain.id} \u{2013} ${chain.name}`
            ],
            name: "ChainMismatchError"
        });
    }
}
class $3913058a7a57a4e1$export$b7f33b26fea1ae0b extends (0, $3cVvs.BaseError) {
    constructor(){
        super([
            "No chain was provided to the request.",
            "Please provide a chain with the `chain` argument on the Action, or by supplying a `chain` to WalletClient."
        ].join("\n"), {
            name: "ChainNotFoundError"
        });
    }
}
class $3913058a7a57a4e1$export$64807f0e18658482 extends (0, $3cVvs.BaseError) {
    constructor(){
        super("No chain was provided to the Client.", {
            name: "ClientChainNotConfiguredError"
        });
    }
}
class $3913058a7a57a4e1$export$4836eb835ffca5b2 extends (0, $3cVvs.BaseError) {
    constructor({ chainId: chainId }){
        super(typeof chainId === "number" ? `Chain ID "${chainId}" is invalid.` : "Chain ID is invalid.", {
            name: "InvalidChainIdError"
        });
    }
}

});

parcelRegister("9juKK", function(module, exports) {

$parcel$export(module.exports, "CallExecutionError", () => $6c7dbe4c15a094dc$export$e67b04e2cd29b7d);
$parcel$export(module.exports, "ContractFunctionExecutionError", () => $6c7dbe4c15a094dc$export$399e62fddbe24423);
$parcel$export(module.exports, "ContractFunctionRevertedError", () => $6c7dbe4c15a094dc$export$b3a6b9663001535f);
$parcel$export(module.exports, "ContractFunctionZeroDataError", () => $6c7dbe4c15a094dc$export$46f5208cdcd5a621);
$parcel$export(module.exports, "CounterfactualDeploymentFailedError", () => $6c7dbe4c15a094dc$export$4fec38f081e68d02);
$parcel$export(module.exports, "RawContractError", () => $6c7dbe4c15a094dc$export$5b877bc4d7d9d460);

var $fbsYZ = parcelRequire("fbsYZ");

var $7hOjg = parcelRequire("7hOjg");

var $cvXjB = parcelRequire("cvXjB");

var $gDCe1 = parcelRequire("gDCe1");

var $5zP6R = parcelRequire("5zP6R");

var $3jfUm = parcelRequire("3jfUm");

var $huI8N = parcelRequire("huI8N");

var $iQ1Hl = parcelRequire("iQ1Hl");

var $ie3rb = parcelRequire("ie3rb");

var $3cVvs = parcelRequire("3cVvs");

var $fVCN3 = parcelRequire("fVCN3");

var $lfct8 = parcelRequire("lfct8");

var $dovow = parcelRequire("dovow");
class $6c7dbe4c15a094dc$export$e67b04e2cd29b7d extends (0, $3cVvs.BaseError) {
    constructor(cause, { account: account_, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, stateOverride: stateOverride }){
        const account = account_ ? (0, $fbsYZ.parseAccount)(account_) : undefined;
        let prettyArgs = (0, $lfct8.prettyPrint)({
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $huI8N.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $iQ1Hl.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $iQ1Hl.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $iQ1Hl.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        if (stateOverride) prettyArgs += `\n${(0, $fVCN3.prettyStateOverride)(stateOverride)}`;
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Raw Call Arguments:",
                prettyArgs
            ].filter(Boolean),
            name: "CallExecutionError"
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cause = cause;
    }
}
class $6c7dbe4c15a094dc$export$399e62fddbe24423 extends (0, $3cVvs.BaseError) {
    constructor(cause, { abi: abi, args: args, contractAddress: contractAddress, docsPath: docsPath, functionName: functionName, sender: sender }){
        const abiItem = (0, $3jfUm.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        const formattedArgs = abiItem ? (0, $5zP6R.formatAbiItemWithArgs)({
            abiItem: abiItem,
            args: args,
            includeFunctionName: false,
            includeName: false
        }) : undefined;
        const functionWithParams = abiItem ? (0, $gDCe1.formatAbiItem)(abiItem, {
            includeName: true
        }) : undefined;
        const prettyArgs = (0, $lfct8.prettyPrint)({
            address: contractAddress && (0, $dovow.getContractAddress)(contractAddress),
            function: functionWithParams,
            args: formattedArgs && formattedArgs !== "()" && `${[
                ...Array(functionName?.length ?? 0).keys()
            ].map(()=>" ").join("")}${formattedArgs}`,
            sender: sender
        });
        super(cause.shortMessage || `An unknown error occurred while executing the contract function "${functionName}".`, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                prettyArgs && "Contract Call:",
                prettyArgs
            ].filter(Boolean),
            name: "ContractFunctionExecutionError"
        });
        Object.defineProperty(this, "abi", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "args", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contractAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "formattedArgs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "functionName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sender", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abi = abi;
        this.args = args;
        this.cause = cause;
        this.contractAddress = contractAddress;
        this.functionName = functionName;
        this.sender = sender;
    }
}
class $6c7dbe4c15a094dc$export$b3a6b9663001535f extends (0, $3cVvs.BaseError) {
    constructor({ abi: abi, data: data, functionName: functionName, message: message }){
        let cause;
        let decodedData = undefined;
        let metaMessages;
        let reason;
        if (data && data !== "0x") try {
            decodedData = (0, $cvXjB.decodeErrorResult)({
                abi: abi,
                data: data
            });
            const { abiItem: abiItem, errorName: errorName, args: errorArgs } = decodedData;
            if (errorName === "Error") reason = errorArgs[0];
            else if (errorName === "Panic") {
                const [firstArg] = errorArgs;
                reason = (0, $7hOjg.panicReasons)[firstArg];
            } else {
                const errorWithParams = abiItem ? (0, $gDCe1.formatAbiItem)(abiItem, {
                    includeName: true
                }) : undefined;
                const formattedArgs = abiItem && errorArgs ? (0, $5zP6R.formatAbiItemWithArgs)({
                    abiItem: abiItem,
                    args: errorArgs,
                    includeFunctionName: false,
                    includeName: false
                }) : undefined;
                metaMessages = [
                    errorWithParams ? `Error: ${errorWithParams}` : "",
                    formattedArgs && formattedArgs !== "()" ? `       ${[
                        ...Array(errorName?.length ?? 0).keys()
                    ].map(()=>" ").join("")}${formattedArgs}` : ""
                ];
            }
        } catch (err) {
            cause = err;
        }
        else if (message) reason = message;
        let signature;
        if (cause instanceof (0, $ie3rb.AbiErrorSignatureNotFoundError)) {
            signature = cause.signature;
            metaMessages = [
                `Unable to decode signature "${signature}" as it was not found on the provided ABI.`,
                "Make sure you are using the correct ABI and that the error exists on it.",
                `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`
            ];
        }
        super(reason && reason !== "execution reverted" || signature ? [
            `The contract function "${functionName}" reverted with the following ${signature ? "signature" : "reason"}:`,
            reason || signature
        ].join("\n") : `The contract function "${functionName}" reverted.`, {
            cause: cause,
            metaMessages: metaMessages,
            name: "ContractFunctionRevertedError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "raw", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reason", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = decodedData;
        this.raw = data;
        this.reason = reason;
        this.signature = signature;
    }
}
class $6c7dbe4c15a094dc$export$46f5208cdcd5a621 extends (0, $3cVvs.BaseError) {
    constructor({ functionName: functionName }){
        super(`The contract function "${functionName}" returned no data ("0x").`, {
            metaMessages: [
                "This could be due to any of the following:",
                `  - The contract does not have the function "${functionName}",`,
                "  - The parameters passed to the contract function may be invalid, or",
                "  - The address is not a contract."
            ],
            name: "ContractFunctionZeroDataError"
        });
    }
}
class $6c7dbe4c15a094dc$export$4fec38f081e68d02 extends (0, $3cVvs.BaseError) {
    constructor({ factory: factory }){
        super(`Deployment for counterfactual contract call failed${factory ? ` for factory "${factory}".` : ""}`, {
            metaMessages: [
                "Please ensure:",
                "- The `factory` is a valid contract deployment factory (ie. Create2 Factory, ERC-4337 Factory, etc).",
                "- The `factoryData` is a valid encoded function call for contract deployment function on the factory."
            ],
            name: "CounterfactualDeploymentFailedError"
        });
    }
}
class $6c7dbe4c15a094dc$export$5b877bc4d7d9d460 extends (0, $3cVvs.BaseError) {
    constructor({ data: data, message: message }){
        super(message || "", {
            name: "RawContractError"
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 3
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
    }
}

});
parcelRegister("5zP6R", function(module, exports) {

$parcel$export(module.exports, "formatAbiItemWithArgs", () => $40f7ddf576e5ddc2$export$5266ec2b0e3e9205);

var $c0R7l = parcelRequire("c0R7l");
function $40f7ddf576e5ddc2$export$5266ec2b0e3e9205({ abiItem: abiItem, args: args, includeFunctionName: includeFunctionName = true, includeName: includeName = false }) {
    if (!("name" in abiItem)) return;
    if (!("inputs" in abiItem)) return;
    if (!abiItem.inputs) return;
    return `${includeFunctionName ? abiItem.name : ""}(${abiItem.inputs.map((input, i)=>`${includeName && input.name ? `${input.name}: ` : ""}${typeof args[i] === "object" ? (0, $c0R7l.stringify)(args[i]) : args[i]}`).join(", ")})`;
}

});

parcelRegister("huI8N", function(module, exports) {

$parcel$export(module.exports, "formatEther", () => $cbc77a7a022a8f2f$export$11bc63b4c03ea518);

var $9e4ts = parcelRequire("9e4ts");

var $lUvCu = parcelRequire("lUvCu");
function $cbc77a7a022a8f2f$export$11bc63b4c03ea518(wei, unit = "wei") {
    return (0, $lUvCu.formatUnits)(wei, (0, $9e4ts.etherUnits)[unit]);
}

});
parcelRegister("9e4ts", function(module, exports) {

$parcel$export(module.exports, "etherUnits", () => $6b78e4575a94595d$export$5bbd813111ed9646);
$parcel$export(module.exports, "gweiUnits", () => $6b78e4575a94595d$export$a26120bf8be88528);
$parcel$export(module.exports, "weiUnits", () => $6b78e4575a94595d$export$b959b3594ea07183);
const $6b78e4575a94595d$export$5bbd813111ed9646 = {
    gwei: 9,
    wei: 18
};
const $6b78e4575a94595d$export$a26120bf8be88528 = {
    ether: -9,
    wei: 9
};
const $6b78e4575a94595d$export$b959b3594ea07183 = {
    ether: -18,
    gwei: -9
};

});


parcelRegister("iQ1Hl", function(module, exports) {

$parcel$export(module.exports, "formatGwei", () => $db6e668bb6a82b73$export$a716d64a7f646b61);

var $9e4ts = parcelRequire("9e4ts");

var $lUvCu = parcelRequire("lUvCu");
function $db6e668bb6a82b73$export$a716d64a7f646b61(wei, unit = "wei") {
    return (0, $lUvCu.formatUnits)(wei, (0, $9e4ts.gweiUnits)[unit]);
}

});

parcelRegister("fVCN3", function(module, exports) {

$parcel$export(module.exports, "AccountStateConflictError", () => $b98a44ceb9621572$export$eb92af66de2d34c1);
$parcel$export(module.exports, "StateAssignmentConflictError", () => $b98a44ceb9621572$export$3f829f5a43fdcc2e);
$parcel$export(module.exports, "prettyStateOverride", () => $b98a44ceb9621572$export$d08c47f9c4a87c67);

var $3cVvs = parcelRequire("3cVvs");
class $b98a44ceb9621572$export$eb92af66de2d34c1 extends (0, $3cVvs.BaseError) {
    constructor({ address: address }){
        super(`State for account "${address}" is set multiple times.`, {
            name: "AccountStateConflictError"
        });
    }
}
class $b98a44ceb9621572$export$3f829f5a43fdcc2e extends (0, $3cVvs.BaseError) {
    constructor(){
        super("state and stateDiff are set on the same account.", {
            name: "StateAssignmentConflictError"
        });
    }
}
function $b98a44ceb9621572$export$4afb15becff191ad(stateMapping) {
    return stateMapping.reduce((pretty, { slot: slot, value: value })=>{
        return `${pretty}        ${slot}: ${value}\n`;
    }, "");
}
function $b98a44ceb9621572$export$d08c47f9c4a87c67(stateOverride) {
    return stateOverride.reduce((pretty, { address: address, ...state })=>{
        let val = `${pretty}    ${address}:\n`;
        if (state.nonce) val += `      nonce: ${state.nonce}\n`;
        if (state.balance) val += `      balance: ${state.balance}\n`;
        if (state.code) val += `      code: ${state.code}\n`;
        if (state.state) {
            val += "      state:\n";
            val += $b98a44ceb9621572$export$4afb15becff191ad(state.state);
        }
        if (state.stateDiff) {
            val += "      stateDiff:\n";
            val += $b98a44ceb9621572$export$4afb15becff191ad(state.stateDiff);
        }
        return val;
    }, "  State Override:\n").slice(0, -1);
}

});

parcelRegister("lfct8", function(module, exports) {

$parcel$export(module.exports, "prettyPrint", () => $f774abc3a8cf2d54$export$cde3d1388a9feac3);
$parcel$export(module.exports, "FeeConflictError", () => $f774abc3a8cf2d54$export$4e13f9693b10724d);
$parcel$export(module.exports, "InvalidSerializableTransactionError", () => $f774abc3a8cf2d54$export$f2282ba9c8899971);
$parcel$export(module.exports, "TransactionExecutionError", () => $f774abc3a8cf2d54$export$17fc407b5aeb1e96);
$parcel$export(module.exports, "TransactionNotFoundError", () => $f774abc3a8cf2d54$export$23c42bc218867b7c);
$parcel$export(module.exports, "TransactionReceiptNotFoundError", () => $f774abc3a8cf2d54$export$df65591684d92652);
$parcel$export(module.exports, "WaitForTransactionReceiptTimeoutError", () => $f774abc3a8cf2d54$export$69578a09754f4b33);

var $huI8N = parcelRequire("huI8N");

var $iQ1Hl = parcelRequire("iQ1Hl");

var $3cVvs = parcelRequire("3cVvs");
function $f774abc3a8cf2d54$export$cde3d1388a9feac3(args) {
    const entries = Object.entries(args).map(([key, value])=>{
        if (value === undefined || value === false) return null;
        return [
            key,
            value
        ];
    }).filter(Boolean);
    const maxLength = entries.reduce((acc, [key])=>Math.max(acc, key.length), 0);
    return entries.map(([key, value])=>`  ${`${key}:`.padEnd(maxLength + 1)}  ${value}`).join("\n");
}
class $f774abc3a8cf2d54$export$4e13f9693b10724d extends (0, $3cVvs.BaseError) {
    constructor(){
        super([
            "Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.",
            "Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others."
        ].join("\n"), {
            name: "FeeConflictError"
        });
    }
}
class $f774abc3a8cf2d54$export$8ffce3f13fa2ade4 extends (0, $3cVvs.BaseError) {
    constructor({ v: v }){
        super(`Invalid \`v\` value "${v}". Expected 27 or 28.`, {
            name: "InvalidLegacyVError"
        });
    }
}
class $f774abc3a8cf2d54$export$f2282ba9c8899971 extends (0, $3cVvs.BaseError) {
    constructor({ transaction: transaction }){
        super("Cannot infer a transaction type from provided transaction.", {
            metaMessages: [
                "Provided Transaction:",
                "{",
                $f774abc3a8cf2d54$export$cde3d1388a9feac3(transaction),
                "}",
                "",
                "To infer the type, either provide:",
                "- a `type` to the Transaction, or",
                "- an EIP-1559 Transaction with `maxFeePerGas`, or",
                "- an EIP-2930 Transaction with `gasPrice` & `accessList`, or",
                "- an EIP-4844 Transaction with `blobs`, `blobVersionedHashes`, `sidecars`, or",
                "- an EIP-7702 Transaction with `authorizationList`, or",
                "- a Legacy Transaction with `gasPrice`"
            ],
            name: "InvalidSerializableTransactionError"
        });
    }
}
class $f774abc3a8cf2d54$export$e410925d6bb07863 extends (0, $3cVvs.BaseError) {
    constructor({ serializedType: serializedType }){
        super(`Serialized transaction type "${serializedType}" is invalid.`, {
            name: "InvalidSerializedTransactionType"
        });
        Object.defineProperty(this, "serializedType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.serializedType = serializedType;
    }
}
class $f774abc3a8cf2d54$export$75fa267d8b74b3b9 extends (0, $3cVvs.BaseError) {
    constructor({ attributes: attributes, serializedTransaction: serializedTransaction, type: type }){
        const missing = Object.entries(attributes).map(([key, value])=>typeof value === "undefined" ? key : undefined).filter(Boolean);
        super(`Invalid serialized transaction of type "${type}" was provided.`, {
            metaMessages: [
                `Serialized Transaction: "${serializedTransaction}"`,
                missing.length > 0 ? `Missing Attributes: ${missing.join(", ")}` : ""
            ].filter(Boolean),
            name: "InvalidSerializedTransactionError"
        });
        Object.defineProperty(this, "serializedTransaction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.serializedTransaction = serializedTransaction;
        this.type = type;
    }
}
class $f774abc3a8cf2d54$export$f5e370fd7cd91580 extends (0, $3cVvs.BaseError) {
    constructor({ storageKey: storageKey }){
        super(`Size for storage key "${storageKey}" is invalid. Expected 32 bytes. Got ${Math.floor((storageKey.length - 2) / 2)} bytes.`, {
            name: "InvalidStorageKeySizeError"
        });
    }
}
class $f774abc3a8cf2d54$export$17fc407b5aeb1e96 extends (0, $3cVvs.BaseError) {
    constructor(cause, { account: account, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }){
        const prettyArgs = $f774abc3a8cf2d54$export$cde3d1388a9feac3({
            chain: chain && `${chain?.name} (id: ${chain?.id})`,
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $huI8N.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $iQ1Hl.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $iQ1Hl.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $iQ1Hl.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Request Arguments:",
                prettyArgs
            ].filter(Boolean),
            name: "TransactionExecutionError"
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cause = cause;
    }
}
class $f774abc3a8cf2d54$export$23c42bc218867b7c extends (0, $3cVvs.BaseError) {
    constructor({ blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag, hash: hash, index: index }){
        let identifier = "Transaction";
        if (blockTag && index !== undefined) identifier = `Transaction at block time "${blockTag}" at index "${index}"`;
        if (blockHash && index !== undefined) identifier = `Transaction at block hash "${blockHash}" at index "${index}"`;
        if (blockNumber && index !== undefined) identifier = `Transaction at block number "${blockNumber}" at index "${index}"`;
        if (hash) identifier = `Transaction with hash "${hash}"`;
        super(`${identifier} could not be found.`, {
            name: "TransactionNotFoundError"
        });
    }
}
class $f774abc3a8cf2d54$export$df65591684d92652 extends (0, $3cVvs.BaseError) {
    constructor({ hash: hash }){
        super(`Transaction receipt with hash "${hash}" could not be found. The Transaction may not be processed on a block yet.`, {
            name: "TransactionReceiptNotFoundError"
        });
    }
}
class $f774abc3a8cf2d54$export$69578a09754f4b33 extends (0, $3cVvs.BaseError) {
    constructor({ hash: hash }){
        super(`Timed out while waiting for transaction with hash "${hash}" to be confirmed.`, {
            name: "WaitForTransactionReceiptTimeoutError"
        });
    }
}

});


parcelRegister("9Nj5J", function(module, exports) {

$parcel$export(module.exports, "decodeFunctionResult", () => $72177fd2897579f0$export$3a05a90c230f925);

var $ie3rb = parcelRequire("ie3rb");

var $dY2s0 = parcelRequire("dY2s0");

var $3jfUm = parcelRequire("3jfUm");
const $72177fd2897579f0$var$docsPath = "/docs/contract/decodeFunctionResult";
function $72177fd2897579f0$export$3a05a90c230f925(parameters) {
    const { abi: abi, args: args, functionName: functionName, data: data } = parameters;
    let abiItem = abi[0];
    if (functionName) {
        const item = (0, $3jfUm.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!item) throw new (0, $ie3rb.AbiFunctionNotFoundError)(functionName, {
            docsPath: $72177fd2897579f0$var$docsPath
        });
        abiItem = item;
    }
    if (abiItem.type !== "function") throw new (0, $ie3rb.AbiFunctionNotFoundError)(undefined, {
        docsPath: $72177fd2897579f0$var$docsPath
    });
    if (!abiItem.outputs) throw new (0, $ie3rb.AbiFunctionOutputsNotFoundError)(abiItem.name, {
        docsPath: $72177fd2897579f0$var$docsPath
    });
    const values = (0, $dY2s0.decodeAbiParameters)(abiItem.outputs, data);
    if (values && values.length > 1) return values;
    if (values && values.length === 1) return values[0];
    return undefined;
}

});

parcelRegister("3aOPa", function(module, exports) {

$parcel$export(module.exports, "encodeDeployData", () => $24f9bae45b61d2a0$export$d7a7276006273fbd);

var $ie3rb = parcelRequire("ie3rb");

var $04Jxx = parcelRequire("04Jxx");

var $fMLNX = parcelRequire("fMLNX");
const $24f9bae45b61d2a0$var$docsPath = "/docs/contract/encodeDeployData";
function $24f9bae45b61d2a0$export$d7a7276006273fbd(parameters) {
    const { abi: abi, args: args, bytecode: bytecode } = parameters;
    if (!args || args.length === 0) return bytecode;
    const description = abi.find((x)=>"type" in x && x.type === "constructor");
    if (!description) throw new (0, $ie3rb.AbiConstructorNotFoundError)({
        docsPath: $24f9bae45b61d2a0$var$docsPath
    });
    if (!("inputs" in description)) throw new (0, $ie3rb.AbiConstructorParamsNotFoundError)({
        docsPath: $24f9bae45b61d2a0$var$docsPath
    });
    if (!description.inputs || description.inputs.length === 0) throw new (0, $ie3rb.AbiConstructorParamsNotFoundError)({
        docsPath: $24f9bae45b61d2a0$var$docsPath
    });
    const data = (0, $fMLNX.encodeAbiParameters)(description.inputs, args);
    return (0, $04Jxx.concatHex)([
        bytecode,
        data
    ]);
}

});

parcelRegister("83bOE", function(module, exports) {

$parcel$export(module.exports, "encodeFunctionData", () => $5dc7c4eb9b5ebfa1$export$f4ee15df45da9f03);

var $04Jxx = parcelRequire("04Jxx");

var $fMLNX = parcelRequire("fMLNX");

var $4h3zC = parcelRequire("4h3zC");
function $5dc7c4eb9b5ebfa1$export$f4ee15df45da9f03(parameters) {
    const { args: args } = parameters;
    const { abi: abi, functionName: functionName } = (()=>{
        if (parameters.abi.length === 1 && parameters.functionName?.startsWith("0x")) return parameters;
        return (0, $4h3zC.prepareEncodeFunctionData)(parameters);
    })();
    const abiItem = abi[0];
    const signature = functionName;
    const data = "inputs" in abiItem && abiItem.inputs ? (0, $fMLNX.encodeAbiParameters)(abiItem.inputs, args ?? []) : undefined;
    return (0, $04Jxx.concatHex)([
        signature,
        data ?? "0x"
    ]);
}

});
parcelRegister("4h3zC", function(module, exports) {

$parcel$export(module.exports, "prepareEncodeFunctionData", () => $31cb859087720546$export$bb3e0a434581ff8);

var $ie3rb = parcelRequire("ie3rb");

var $dUPAH = parcelRequire("dUPAH");

var $gDCe1 = parcelRequire("gDCe1");

var $3jfUm = parcelRequire("3jfUm");
const $31cb859087720546$var$docsPath = "/docs/contract/encodeFunctionData";
function $31cb859087720546$export$bb3e0a434581ff8(parameters) {
    const { abi: abi, args: args, functionName: functionName } = parameters;
    let abiItem = abi[0];
    if (functionName) {
        const item = (0, $3jfUm.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!item) throw new (0, $ie3rb.AbiFunctionNotFoundError)(functionName, {
            docsPath: $31cb859087720546$var$docsPath
        });
        abiItem = item;
    }
    if (abiItem.type !== "function") throw new (0, $ie3rb.AbiFunctionNotFoundError)(undefined, {
        docsPath: $31cb859087720546$var$docsPath
    });
    return {
        abi: [
            abiItem
        ],
        functionName: (0, $dUPAH.toFunctionSelector)((0, $gDCe1.formatAbiItem)(abiItem))
    };
}

});


parcelRegister("ejxc0", function(module, exports) {

$parcel$export(module.exports, "getChainContractAddress", () => $a6bc9662a9bc196f$export$cf4414608a078996);

var $4TNV6 = parcelRequire("4TNV6");
function $a6bc9662a9bc196f$export$cf4414608a078996({ blockNumber: blockNumber, chain: chain, contract: name }) {
    const contract = chain?.contracts?.[name];
    if (!contract) throw new (0, $4TNV6.ChainDoesNotSupportContract)({
        chain: chain,
        contract: {
            name: name
        }
    });
    if (blockNumber && contract.blockCreated && contract.blockCreated > blockNumber) throw new (0, $4TNV6.ChainDoesNotSupportContract)({
        blockNumber: blockNumber,
        chain: chain,
        contract: {
            name: name,
            blockCreated: contract.blockCreated
        }
    });
    return contract.address;
}

});

parcelRegister("7zU3k", function(module, exports) {

$parcel$export(module.exports, "getCallError", () => $58474830475ea8a8$export$7a3a4dfb724485e1);

var $9juKK = parcelRequire("9juKK");

var $hOdyB = parcelRequire("hOdyB");

var $b0rjl = parcelRequire("b0rjl");
function $58474830475ea8a8$export$7a3a4dfb724485e1(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $b0rjl.getNodeError)(err, args);
        if (cause instanceof (0, $hOdyB.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $9juKK.CallExecutionError)(cause, {
        docsPath: docsPath,
        ...args
    });
}

});
parcelRegister("hOdyB", function(module, exports) {

$parcel$export(module.exports, "ExecutionRevertedError", () => $cf719f5c87d94cdc$export$a558573a20f90d54);
$parcel$export(module.exports, "FeeCapTooHighError", () => $cf719f5c87d94cdc$export$63c545de2a2ec844);
$parcel$export(module.exports, "FeeCapTooLowError", () => $cf719f5c87d94cdc$export$dbd5936ae1758966);
$parcel$export(module.exports, "NonceTooHighError", () => $cf719f5c87d94cdc$export$6147426561fdc965);
$parcel$export(module.exports, "NonceTooLowError", () => $cf719f5c87d94cdc$export$2bb6d6395b589b3b);
$parcel$export(module.exports, "NonceMaxValueError", () => $cf719f5c87d94cdc$export$71cf1d500f9be262);
$parcel$export(module.exports, "InsufficientFundsError", () => $cf719f5c87d94cdc$export$b276096bbba16879);
$parcel$export(module.exports, "IntrinsicGasTooHighError", () => $cf719f5c87d94cdc$export$7ad883b4998b9615);
$parcel$export(module.exports, "IntrinsicGasTooLowError", () => $cf719f5c87d94cdc$export$813ccdcce0428bcf);
$parcel$export(module.exports, "TransactionTypeNotSupportedError", () => $cf719f5c87d94cdc$export$a20c52a8beca5c20);
$parcel$export(module.exports, "TipAboveFeeCapError", () => $cf719f5c87d94cdc$export$6ef9dd5e2f836046);
$parcel$export(module.exports, "UnknownNodeError", () => $cf719f5c87d94cdc$export$d6085363229de344);

var $iQ1Hl = parcelRequire("iQ1Hl");

var $3cVvs = parcelRequire("3cVvs");
class $cf719f5c87d94cdc$export$a558573a20f90d54 extends (0, $3cVvs.BaseError) {
    constructor({ cause: cause, message: message } = {}){
        const reason = message?.replace("execution reverted: ", "")?.replace("execution reverted", "");
        super(`Execution reverted ${reason ? `with reason: ${reason}` : "for an unknown reason"}.`, {
            cause: cause,
            name: "ExecutionRevertedError"
        });
    }
}
Object.defineProperty($cf719f5c87d94cdc$export$a558573a20f90d54, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 3
});
Object.defineProperty($cf719f5c87d94cdc$export$a558573a20f90d54, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /execution reverted/
});
class $cf719f5c87d94cdc$export$63c545de2a2ec844 extends (0, $3cVvs.BaseError) {
    constructor({ cause: cause, maxFeePerGas: maxFeePerGas } = {}){
        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $iQ1Hl.formatGwei)(maxFeePerGas)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
            cause: cause,
            name: "FeeCapTooHighError"
        });
    }
}
Object.defineProperty($cf719f5c87d94cdc$export$63c545de2a2ec844, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class $cf719f5c87d94cdc$export$dbd5936ae1758966 extends (0, $3cVvs.BaseError) {
    constructor({ cause: cause, maxFeePerGas: maxFeePerGas } = {}){
        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $iQ1Hl.formatGwei)(maxFeePerGas)}` : ""} gwei) cannot be lower than the block base fee.`, {
            cause: cause,
            name: "FeeCapTooLowError"
        });
    }
}
Object.defineProperty($cf719f5c87d94cdc$export$dbd5936ae1758966, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
class $cf719f5c87d94cdc$export$6147426561fdc965 extends (0, $3cVvs.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}is higher than the next one expected.`, {
            cause: cause,
            name: "NonceTooHighError"
        });
    }
}
Object.defineProperty($cf719f5c87d94cdc$export$6147426561fdc965, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too high/
});
class $cf719f5c87d94cdc$export$2bb6d6395b589b3b extends (0, $3cVvs.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super([
            `Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}is lower than the current nonce of the account.`,
            "Try increasing the nonce or find the latest nonce with `getTransactionCount`."
        ].join("\n"), {
            cause: cause,
            name: "NonceTooLowError"
        });
    }
}
Object.defineProperty($cf719f5c87d94cdc$export$2bb6d6395b589b3b, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too low|transaction already imported|already known/
});
class $cf719f5c87d94cdc$export$71cf1d500f9be262 extends (0, $3cVvs.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}exceeds the maximum allowed nonce.`, {
            cause: cause,
            name: "NonceMaxValueError"
        });
    }
}
Object.defineProperty($cf719f5c87d94cdc$export$71cf1d500f9be262, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce has max value/
});
class $cf719f5c87d94cdc$export$b276096bbba16879 extends (0, $3cVvs.BaseError) {
    constructor({ cause: cause } = {}){
        super([
            "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account."
        ].join("\n"), {
            cause: cause,
            metaMessages: [
                "This error could arise when the account does not have enough funds to:",
                " - pay for the total gas fee,",
                " - pay for the value to send.",
                " ",
                "The cost of the transaction is calculated as `gas * gas fee + value`, where:",
                " - `gas` is the amount of gas needed for transaction to execute,",
                " - `gas fee` is the gas fee,",
                " - `value` is the amount of ether to send to the recipient."
            ],
            name: "InsufficientFundsError"
        });
    }
}
Object.defineProperty($cf719f5c87d94cdc$export$b276096bbba16879, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /insufficient funds|exceeds transaction sender account balance/
});
class $cf719f5c87d94cdc$export$7ad883b4998b9615 extends (0, $3cVvs.BaseError) {
    constructor({ cause: cause, gas: gas } = {}){
        super(`The amount of gas ${gas ? `(${gas}) ` : ""}provided for the transaction exceeds the limit allowed for the block.`, {
            cause: cause,
            name: "IntrinsicGasTooHighError"
        });
    }
}
Object.defineProperty($cf719f5c87d94cdc$export$7ad883b4998b9615, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too high|gas limit reached/
});
class $cf719f5c87d94cdc$export$813ccdcce0428bcf extends (0, $3cVvs.BaseError) {
    constructor({ cause: cause, gas: gas } = {}){
        super(`The amount of gas ${gas ? `(${gas}) ` : ""}provided for the transaction is too low.`, {
            cause: cause,
            name: "IntrinsicGasTooLowError"
        });
    }
}
Object.defineProperty($cf719f5c87d94cdc$export$813ccdcce0428bcf, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too low/
});
class $cf719f5c87d94cdc$export$a20c52a8beca5c20 extends (0, $3cVvs.BaseError) {
    constructor({ cause: cause }){
        super("The transaction type is not supported for this chain.", {
            cause: cause,
            name: "TransactionTypeNotSupportedError"
        });
    }
}
Object.defineProperty($cf719f5c87d94cdc$export$a20c52a8beca5c20, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /transaction type not valid/
});
class $cf719f5c87d94cdc$export$6ef9dd5e2f836046 extends (0, $3cVvs.BaseError) {
    constructor({ cause: cause, maxPriorityFeePerGas: maxPriorityFeePerGas, maxFeePerGas: maxFeePerGas } = {}){
        super([
            `The provided tip (\`maxPriorityFeePerGas\`${maxPriorityFeePerGas ? ` = ${(0, $iQ1Hl.formatGwei)(maxPriorityFeePerGas)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $iQ1Hl.formatGwei)(maxFeePerGas)} gwei` : ""}).`
        ].join("\n"), {
            cause: cause,
            name: "TipAboveFeeCapError"
        });
    }
}
Object.defineProperty($cf719f5c87d94cdc$export$6ef9dd5e2f836046, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
class $cf719f5c87d94cdc$export$d6085363229de344 extends (0, $3cVvs.BaseError) {
    constructor({ cause: cause }){
        super(`An error occurred while executing: ${cause?.shortMessage}`, {
            cause: cause,
            name: "UnknownNodeError"
        });
    }
}

});

parcelRegister("b0rjl", function(module, exports) {

$parcel$export(module.exports, "getNodeError", () => $8034e12e14c2005d$export$218ee3a1c831c34e);

var $3cVvs = parcelRequire("3cVvs");

var $hOdyB = parcelRequire("hOdyB");

var $kbqwz = parcelRequire("kbqwz");

var $16W4z = parcelRequire("16W4z");
function $8034e12e14c2005d$export$620efda101db5601(err) {
    return err instanceof (0, $16W4z.TransactionRejectedRpcError) || err instanceof (0, $16W4z.InvalidInputRpcError) || err instanceof (0, $kbqwz.RpcRequestError) && err.code === (0, $hOdyB.ExecutionRevertedError).code;
}
function $8034e12e14c2005d$export$218ee3a1c831c34e(err, args) {
    const message = (err.details || "").toLowerCase();
    const executionRevertedError = err instanceof (0, $3cVvs.BaseError) ? err.walk((e)=>e?.code === (0, $hOdyB.ExecutionRevertedError).code) : err;
    if (executionRevertedError instanceof (0, $3cVvs.BaseError)) return new (0, $hOdyB.ExecutionRevertedError)({
        cause: err,
        message: executionRevertedError.details
    });
    if ((0, $hOdyB.ExecutionRevertedError).nodeMessage.test(message)) return new (0, $hOdyB.ExecutionRevertedError)({
        cause: err,
        message: err.details
    });
    if ((0, $hOdyB.FeeCapTooHighError).nodeMessage.test(message)) return new (0, $hOdyB.FeeCapTooHighError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas
    });
    if ((0, $hOdyB.FeeCapTooLowError).nodeMessage.test(message)) return new (0, $hOdyB.FeeCapTooLowError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas
    });
    if ((0, $hOdyB.NonceTooHighError).nodeMessage.test(message)) return new (0, $hOdyB.NonceTooHighError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $hOdyB.NonceTooLowError).nodeMessage.test(message)) return new (0, $hOdyB.NonceTooLowError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $hOdyB.NonceMaxValueError).nodeMessage.test(message)) return new (0, $hOdyB.NonceMaxValueError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $hOdyB.InsufficientFundsError).nodeMessage.test(message)) return new (0, $hOdyB.InsufficientFundsError)({
        cause: err
    });
    if ((0, $hOdyB.IntrinsicGasTooHighError).nodeMessage.test(message)) return new (0, $hOdyB.IntrinsicGasTooHighError)({
        cause: err,
        gas: args?.gas
    });
    if ((0, $hOdyB.IntrinsicGasTooLowError).nodeMessage.test(message)) return new (0, $hOdyB.IntrinsicGasTooLowError)({
        cause: err,
        gas: args?.gas
    });
    if ((0, $hOdyB.TransactionTypeNotSupportedError).nodeMessage.test(message)) return new (0, $hOdyB.TransactionTypeNotSupportedError)({
        cause: err
    });
    if ((0, $hOdyB.TipAboveFeeCapError).nodeMessage.test(message)) return new (0, $hOdyB.TipAboveFeeCapError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas,
        maxPriorityFeePerGas: args?.maxPriorityFeePerGas
    });
    return new (0, $hOdyB.UnknownNodeError)({
        cause: err
    });
}

});


parcelRegister("6ztP3", function(module, exports) {

$parcel$export(module.exports, "extract", () => $4c8d2511e1ee4889$export$f9380c9a627682d3);
/**
 * @description Picks out the keys from `value` that exist in the formatter..
 */ function $4c8d2511e1ee4889$export$f9380c9a627682d3(value_, { format: format }) {
    if (!format) return {};
    const value = {};
    function extract_(formatted) {
        const keys = Object.keys(formatted);
        for (const key of keys){
            if (key in value_) value[key] = value_[key];
            if (formatted[key] && typeof formatted[key] === "object" && !Array.isArray(formatted[key])) extract_(formatted[key]);
        }
    }
    const formatted = format(value_ || {});
    extract_(formatted);
    return value;
}

});

parcelRegister("csK11", function(module, exports) {

$parcel$export(module.exports, "formatTransactionRequest", () => $912bcb4c0477d448$export$d23fcba447c86a8e);

var $nDot9 = parcelRequire("nDot9");

var $4jLjg = parcelRequire("4jLjg");
const $912bcb4c0477d448$export$b2a848539dcbb25f = {
    legacy: "0x0",
    eip2930: "0x1",
    eip1559: "0x2",
    eip4844: "0x3",
    eip7702: "0x4"
};
function $912bcb4c0477d448$export$d23fcba447c86a8e(request) {
    const rpcRequest = {};
    if (typeof request.authorizationList !== "undefined") rpcRequest.authorizationList = $912bcb4c0477d448$var$formatAuthorizationList(request.authorizationList);
    if (typeof request.accessList !== "undefined") rpcRequest.accessList = request.accessList;
    if (typeof request.blobVersionedHashes !== "undefined") rpcRequest.blobVersionedHashes = request.blobVersionedHashes;
    if (typeof request.blobs !== "undefined") {
        if (typeof request.blobs[0] !== "string") rpcRequest.blobs = request.blobs.map((x)=>(0, $nDot9.bytesToHex)(x));
        else rpcRequest.blobs = request.blobs;
    }
    if (typeof request.data !== "undefined") rpcRequest.data = request.data;
    if (typeof request.from !== "undefined") rpcRequest.from = request.from;
    if (typeof request.gas !== "undefined") rpcRequest.gas = (0, $nDot9.numberToHex)(request.gas);
    if (typeof request.gasPrice !== "undefined") rpcRequest.gasPrice = (0, $nDot9.numberToHex)(request.gasPrice);
    if (typeof request.maxFeePerBlobGas !== "undefined") rpcRequest.maxFeePerBlobGas = (0, $nDot9.numberToHex)(request.maxFeePerBlobGas);
    if (typeof request.maxFeePerGas !== "undefined") rpcRequest.maxFeePerGas = (0, $nDot9.numberToHex)(request.maxFeePerGas);
    if (typeof request.maxPriorityFeePerGas !== "undefined") rpcRequest.maxPriorityFeePerGas = (0, $nDot9.numberToHex)(request.maxPriorityFeePerGas);
    if (typeof request.nonce !== "undefined") rpcRequest.nonce = (0, $nDot9.numberToHex)(request.nonce);
    if (typeof request.to !== "undefined") rpcRequest.to = request.to;
    if (typeof request.type !== "undefined") rpcRequest.type = $912bcb4c0477d448$export$b2a848539dcbb25f[request.type];
    if (typeof request.value !== "undefined") rpcRequest.value = (0, $nDot9.numberToHex)(request.value);
    return rpcRequest;
}
const $912bcb4c0477d448$export$aba208618cee26e3 = /*#__PURE__*/ (0, $4jLjg.defineFormatter)("transactionRequest", $912bcb4c0477d448$export$d23fcba447c86a8e);
//////////////////////////////////////////////////////////////////////////////
function $912bcb4c0477d448$var$formatAuthorizationList(authorizationList) {
    return authorizationList.map((authorization)=>({
            address: authorization.address,
            r: authorization.r ? (0, $nDot9.numberToHex)(BigInt(authorization.r)) : authorization.r,
            s: authorization.s ? (0, $nDot9.numberToHex)(BigInt(authorization.s)) : authorization.s,
            chainId: (0, $nDot9.numberToHex)(authorization.chainId),
            nonce: (0, $nDot9.numberToHex)(authorization.nonce),
            ...typeof authorization.yParity !== "undefined" ? {
                yParity: (0, $nDot9.numberToHex)(authorization.yParity)
            } : {},
            ...typeof authorization.v !== "undefined" && typeof authorization.yParity === "undefined" ? {
                v: (0, $nDot9.numberToHex)(authorization.v)
            } : {}
        }));
}

});
parcelRegister("4jLjg", function(module, exports) {

$parcel$export(module.exports, "defineFormatter", () => $324da2795d47b252$export$5d08535cc975931a);
function $324da2795d47b252$export$5d08535cc975931a(type, format) {
    return ({ exclude: exclude, format: overrides })=>{
        return {
            exclude: exclude,
            format: (args)=>{
                const formatted = format(args);
                if (exclude) for (const key of exclude)delete formatted[key];
                return {
                    ...formatted,
                    ...overrides(args)
                };
            },
            type: type
        };
    };
}

});


parcelRegister("5UW0B", function(module, exports) {

$parcel$export(module.exports, "createBatchScheduler", () => $44ef2e0367109a15$export$24d3fde68b7c4167);

var $4BHVN = parcelRequire("4BHVN");
const $44ef2e0367109a15$var$schedulerCache = /*#__PURE__*/ new Map();
function $44ef2e0367109a15$export$24d3fde68b7c4167({ fn: fn, id: id, shouldSplitBatch: shouldSplitBatch, wait: wait = 0, sort: sort }) {
    const exec = async ()=>{
        const scheduler = getScheduler();
        flush();
        const args = scheduler.map(({ args: args })=>args);
        if (args.length === 0) return;
        fn(args).then((data)=>{
            if (sort && Array.isArray(data)) data.sort(sort);
            for(let i = 0; i < scheduler.length; i++){
                const { resolve: resolve } = scheduler[i];
                resolve?.([
                    data[i],
                    data
                ]);
            }
        }).catch((err)=>{
            for(let i = 0; i < scheduler.length; i++){
                const { reject: reject } = scheduler[i];
                reject?.(err);
            }
        });
    };
    const flush = ()=>$44ef2e0367109a15$var$schedulerCache.delete(id);
    const getBatchedArgs = ()=>getScheduler().map(({ args: args })=>args);
    const getScheduler = ()=>$44ef2e0367109a15$var$schedulerCache.get(id) || [];
    const setScheduler = (item)=>$44ef2e0367109a15$var$schedulerCache.set(id, [
            ...getScheduler(),
            item
        ]);
    return {
        flush: flush,
        async schedule (args) {
            const { promise: promise, resolve: resolve, reject: reject } = (0, $4BHVN.withResolvers)();
            const split = shouldSplitBatch?.([
                ...getBatchedArgs(),
                args
            ]);
            if (split) exec();
            const hasActiveScheduler = getScheduler().length > 0;
            if (hasActiveScheduler) {
                setScheduler({
                    args: args,
                    resolve: resolve,
                    reject: reject
                });
                return promise;
            }
            setScheduler({
                args: args,
                resolve: resolve,
                reject: reject
            });
            setTimeout(exec, wait);
            return promise;
        }
    };
}

});
parcelRegister("4BHVN", function(module, exports) {

$parcel$export(module.exports, "withResolvers", () => $35acb1f122ba7c2e$export$88ce28fd4287e6ef);
/** @internal */ function $35acb1f122ba7c2e$export$88ce28fd4287e6ef() {
    let resolve = ()=>undefined;
    let reject = ()=>undefined;
    const promise = new Promise((resolve_, reject_)=>{
        resolve = resolve_;
        reject = reject_;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}

});


parcelRegister("6Pzc8", function(module, exports) {

$parcel$export(module.exports, "serializeStateOverride", () => $4f92ce70beb5aaa9$export$f6da3c954eb711d6);

var $cegbN = parcelRequire("cegbN");

var $9et7x = parcelRequire("9et7x");

var $fVCN3 = parcelRequire("fVCN3");

var $lmNDj = parcelRequire("lmNDj");

var $nDot9 = parcelRequire("nDot9");
function $4f92ce70beb5aaa9$export$29e73cd11b306a76(stateMapping) {
    if (!stateMapping || stateMapping.length === 0) return undefined;
    return stateMapping.reduce((acc, { slot: slot, value: value })=>{
        if (slot.length !== 66) throw new (0, $9et7x.InvalidBytesLengthError)({
            size: slot.length,
            targetSize: 66,
            type: "hex"
        });
        if (value.length !== 66) throw new (0, $9et7x.InvalidBytesLengthError)({
            size: value.length,
            targetSize: 66,
            type: "hex"
        });
        acc[slot] = value;
        return acc;
    }, {});
}
function $4f92ce70beb5aaa9$export$ff6c86decd3de345(parameters) {
    const { balance: balance, nonce: nonce, state: state, stateDiff: stateDiff, code: code } = parameters;
    const rpcAccountStateOverride = {};
    if (code !== undefined) rpcAccountStateOverride.code = code;
    if (balance !== undefined) rpcAccountStateOverride.balance = (0, $nDot9.numberToHex)(balance);
    if (nonce !== undefined) rpcAccountStateOverride.nonce = (0, $nDot9.numberToHex)(nonce);
    if (state !== undefined) rpcAccountStateOverride.state = $4f92ce70beb5aaa9$export$29e73cd11b306a76(state);
    if (stateDiff !== undefined) {
        if (rpcAccountStateOverride.state) throw new (0, $fVCN3.StateAssignmentConflictError)();
        rpcAccountStateOverride.stateDiff = $4f92ce70beb5aaa9$export$29e73cd11b306a76(stateDiff);
    }
    return rpcAccountStateOverride;
}
function $4f92ce70beb5aaa9$export$f6da3c954eb711d6(parameters) {
    if (!parameters) return undefined;
    const rpcStateOverride = {};
    for (const { address: address, ...accountState } of parameters){
        if (!(0, $lmNDj.isAddress)(address, {
            strict: false
        })) throw new (0, $cegbN.InvalidAddressError)({
            address: address
        });
        if (rpcStateOverride[address]) throw new (0, $fVCN3.AccountStateConflictError)({
            address: address
        });
        rpcStateOverride[address] = $4f92ce70beb5aaa9$export$ff6c86decd3de345(accountState);
    }
    return rpcStateOverride;
}

});

parcelRegister("hQGp6", function(module, exports) {

$parcel$export(module.exports, "assertRequest", () => $cfe82f8b6b722590$export$5378021d985ceaf8);

var $fbsYZ = parcelRequire("fbsYZ");

var $5ZQBu = parcelRequire("5ZQBu");

var $cegbN = parcelRequire("cegbN");

var $hOdyB = parcelRequire("hOdyB");

var $lfct8 = parcelRequire("lfct8");

var $lmNDj = parcelRequire("lmNDj");
function $cfe82f8b6b722590$export$5378021d985ceaf8(args) {
    const { account: account_, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, to: to } = args;
    const account = account_ ? (0, $fbsYZ.parseAccount)(account_) : undefined;
    if (account && !(0, $lmNDj.isAddress)(account.address)) throw new (0, $cegbN.InvalidAddressError)({
        address: account.address
    });
    if (to && !(0, $lmNDj.isAddress)(to)) throw new (0, $cegbN.InvalidAddressError)({
        address: to
    });
    if (typeof gasPrice !== "undefined" && (typeof maxFeePerGas !== "undefined" || typeof maxPriorityFeePerGas !== "undefined")) throw new (0, $lfct8.FeeConflictError)();
    if (maxFeePerGas && maxFeePerGas > (0, $5ZQBu.maxUint256)) throw new (0, $hOdyB.FeeCapTooHighError)({
        maxFeePerGas: maxFeePerGas
    });
    if (maxPriorityFeePerGas && maxFeePerGas && maxPriorityFeePerGas > maxFeePerGas) throw new (0, $hOdyB.TipAboveFeeCapError)({
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas
    });
}

});
parcelRegister("5ZQBu", function(module, exports) {

$parcel$export(module.exports, "maxUint256", () => $45db7445f1ce6d6b$export$48de485e50a67ffa);
const $45db7445f1ce6d6b$export$bdd7109439799cdf = 2n ** (8n - 1n) - 1n;
const $45db7445f1ce6d6b$export$eee94935c9b963a1 = 2n ** (16n - 1n) - 1n;
const $45db7445f1ce6d6b$export$e91fe5d90cd4a2f6 = 2n ** (24n - 1n) - 1n;
const $45db7445f1ce6d6b$export$25c0796c740353c4 = 2n ** (32n - 1n) - 1n;
const $45db7445f1ce6d6b$export$ac2072b1e721a92d = 2n ** (40n - 1n) - 1n;
const $45db7445f1ce6d6b$export$7b7c71fa48943f3 = 2n ** (48n - 1n) - 1n;
const $45db7445f1ce6d6b$export$e27ce19a567c9842 = 2n ** (56n - 1n) - 1n;
const $45db7445f1ce6d6b$export$a51b0cf29ddb8e40 = 2n ** (64n - 1n) - 1n;
const $45db7445f1ce6d6b$export$347f40d3f7572e5a = 2n ** (72n - 1n) - 1n;
const $45db7445f1ce6d6b$export$940f45cde4f61aed = 2n ** (80n - 1n) - 1n;
const $45db7445f1ce6d6b$export$13cad54caf92841d = 2n ** (88n - 1n) - 1n;
const $45db7445f1ce6d6b$export$872296ce91d7dabe = 2n ** (96n - 1n) - 1n;
const $45db7445f1ce6d6b$export$404112bd52c31da4 = 2n ** (104n - 1n) - 1n;
const $45db7445f1ce6d6b$export$1d4284abecdbf56d = 2n ** (112n - 1n) - 1n;
const $45db7445f1ce6d6b$export$35201a0fd5d34f18 = 2n ** (120n - 1n) - 1n;
const $45db7445f1ce6d6b$export$92415df5352289c7 = 2n ** (128n - 1n) - 1n;
const $45db7445f1ce6d6b$export$ccb03f6a03d6e182 = 2n ** (136n - 1n) - 1n;
const $45db7445f1ce6d6b$export$cbf030aa46ccd63 = 2n ** (144n - 1n) - 1n;
const $45db7445f1ce6d6b$export$33ad14852d23a660 = 2n ** (152n - 1n) - 1n;
const $45db7445f1ce6d6b$export$6429af277dbaae06 = 2n ** (160n - 1n) - 1n;
const $45db7445f1ce6d6b$export$2b154fcf8b3c7a42 = 2n ** (168n - 1n) - 1n;
const $45db7445f1ce6d6b$export$6ba90f949100477a = 2n ** (176n - 1n) - 1n;
const $45db7445f1ce6d6b$export$a353fb8a621e38fd = 2n ** (184n - 1n) - 1n;
const $45db7445f1ce6d6b$export$ad4f6360abea4fa4 = 2n ** (192n - 1n) - 1n;
const $45db7445f1ce6d6b$export$381549e0b0f272ab = 2n ** (200n - 1n) - 1n;
const $45db7445f1ce6d6b$export$a083a4afa1a2c00c = 2n ** (208n - 1n) - 1n;
const $45db7445f1ce6d6b$export$ee8f6a880c431cd3 = 2n ** (216n - 1n) - 1n;
const $45db7445f1ce6d6b$export$a8672844e0af1027 = 2n ** (224n - 1n) - 1n;
const $45db7445f1ce6d6b$export$57c45c845403e7a5 = 2n ** (232n - 1n) - 1n;
const $45db7445f1ce6d6b$export$e8e88f55ae4a3354 = 2n ** (240n - 1n) - 1n;
const $45db7445f1ce6d6b$export$ebbd894fe518c064 = 2n ** (248n - 1n) - 1n;
const $45db7445f1ce6d6b$export$e4d673aa7367981c = 2n ** (256n - 1n) - 1n;
const $45db7445f1ce6d6b$export$ef9b9e1988c51720 = -(2n ** (8n - 1n));
const $45db7445f1ce6d6b$export$b923fba4a82cad48 = -(2n ** (16n - 1n));
const $45db7445f1ce6d6b$export$7b0286602251a7c7 = -(2n ** (24n - 1n));
const $45db7445f1ce6d6b$export$5f0d0d25b56bbb4f = -(2n ** (32n - 1n));
const $45db7445f1ce6d6b$export$4c07a8deea2258b1 = -(2n ** (40n - 1n));
const $45db7445f1ce6d6b$export$6a6c2e4f279545ff = -(2n ** (48n - 1n));
const $45db7445f1ce6d6b$export$1739c13d967d68b1 = -(2n ** (56n - 1n));
const $45db7445f1ce6d6b$export$14e6fedf9fb9d75c = -(2n ** (64n - 1n));
const $45db7445f1ce6d6b$export$bc3defde0bfb8bd = -(2n ** (72n - 1n));
const $45db7445f1ce6d6b$export$8efa66e0d946dfd2 = -(2n ** (80n - 1n));
const $45db7445f1ce6d6b$export$80ab8bed90b29bfe = -(2n ** (88n - 1n));
const $45db7445f1ce6d6b$export$39c4444aac2d0d86 = -(2n ** (96n - 1n));
const $45db7445f1ce6d6b$export$28fd4a9e64dafe7b = -(2n ** (104n - 1n));
const $45db7445f1ce6d6b$export$38cae674fedc8f74 = -(2n ** (112n - 1n));
const $45db7445f1ce6d6b$export$6779113dfecc5d69 = -(2n ** (120n - 1n));
const $45db7445f1ce6d6b$export$93cc92d28d07644b = -(2n ** (128n - 1n));
const $45db7445f1ce6d6b$export$4acf8238e6d61d3e = -(2n ** (136n - 1n));
const $45db7445f1ce6d6b$export$ac974246b2ca90ec = -(2n ** (144n - 1n));
const $45db7445f1ce6d6b$export$77d4dfc3aa958440 = -(2n ** (152n - 1n));
const $45db7445f1ce6d6b$export$a9a1ab546428ca6f = -(2n ** (160n - 1n));
const $45db7445f1ce6d6b$export$aca1dbffc71a377a = -(2n ** (168n - 1n));
const $45db7445f1ce6d6b$export$1ca77ffa68208066 = -(2n ** (176n - 1n));
const $45db7445f1ce6d6b$export$e74092b0e35f2385 = -(2n ** (184n - 1n));
const $45db7445f1ce6d6b$export$5f53c97c87f852f4 = -(2n ** (192n - 1n));
const $45db7445f1ce6d6b$export$df01e80cffe255dc = -(2n ** (200n - 1n));
const $45db7445f1ce6d6b$export$155f043c7b06e008 = -(2n ** (208n - 1n));
const $45db7445f1ce6d6b$export$195a5ffec9c679b8 = -(2n ** (216n - 1n));
const $45db7445f1ce6d6b$export$b1ee6eacfb96c50c = -(2n ** (224n - 1n));
const $45db7445f1ce6d6b$export$16bdbfee8230ad51 = -(2n ** (232n - 1n));
const $45db7445f1ce6d6b$export$5715ad8f9991a9a2 = -(2n ** (240n - 1n));
const $45db7445f1ce6d6b$export$9146117a246b63ab = -(2n ** (248n - 1n));
const $45db7445f1ce6d6b$export$5d31694d80b27ae5 = -(2n ** (256n - 1n));
const $45db7445f1ce6d6b$export$7db2ab1a72670716 = 2n ** 8n - 1n;
const $45db7445f1ce6d6b$export$e4e112958a94d87f = 2n ** 16n - 1n;
const $45db7445f1ce6d6b$export$1bea6075c2df6828 = 2n ** 24n - 1n;
const $45db7445f1ce6d6b$export$48716e5eecd83bf7 = 2n ** 32n - 1n;
const $45db7445f1ce6d6b$export$dc2184b5c9263ac7 = 2n ** 40n - 1n;
const $45db7445f1ce6d6b$export$e639b3656891925b = 2n ** 48n - 1n;
const $45db7445f1ce6d6b$export$bea470c1abdb1310 = 2n ** 56n - 1n;
const $45db7445f1ce6d6b$export$3f17b1570950699c = 2n ** 64n - 1n;
const $45db7445f1ce6d6b$export$8135da85ae9b595b = 2n ** 72n - 1n;
const $45db7445f1ce6d6b$export$caa80683240e3b73 = 2n ** 80n - 1n;
const $45db7445f1ce6d6b$export$8e50c223f761a8cf = 2n ** 88n - 1n;
const $45db7445f1ce6d6b$export$621d3d87b73138e5 = 2n ** 96n - 1n;
const $45db7445f1ce6d6b$export$4e5098f4748a9a4d = 2n ** 104n - 1n;
const $45db7445f1ce6d6b$export$1435b580b943ede2 = 2n ** 112n - 1n;
const $45db7445f1ce6d6b$export$4362e740aadf7dab = 2n ** 120n - 1n;
const $45db7445f1ce6d6b$export$380ebe6b2fc5caa9 = 2n ** 128n - 1n;
const $45db7445f1ce6d6b$export$6c13d06e0cefb9aa = 2n ** 136n - 1n;
const $45db7445f1ce6d6b$export$fe2d415b41e5f433 = 2n ** 144n - 1n;
const $45db7445f1ce6d6b$export$c2f2754e23c5488a = 2n ** 152n - 1n;
const $45db7445f1ce6d6b$export$34fcca92c372a91b = 2n ** 160n - 1n;
const $45db7445f1ce6d6b$export$32e3523cb82cc8a0 = 2n ** 168n - 1n;
const $45db7445f1ce6d6b$export$d36711d6637bde95 = 2n ** 176n - 1n;
const $45db7445f1ce6d6b$export$9211611648dd09a2 = 2n ** 184n - 1n;
const $45db7445f1ce6d6b$export$4e61cbaa2231cfdd = 2n ** 192n - 1n;
const $45db7445f1ce6d6b$export$9187c63f331d335b = 2n ** 200n - 1n;
const $45db7445f1ce6d6b$export$7f910799edc7ae97 = 2n ** 208n - 1n;
const $45db7445f1ce6d6b$export$64506e5a2676ecb0 = 2n ** 216n - 1n;
const $45db7445f1ce6d6b$export$a060896418206521 = 2n ** 224n - 1n;
const $45db7445f1ce6d6b$export$18b000c2bc5e114 = 2n ** 232n - 1n;
const $45db7445f1ce6d6b$export$253bb52e7f7a3909 = 2n ** 240n - 1n;
const $45db7445f1ce6d6b$export$d5a8ad83a637081c = 2n ** 248n - 1n;
const $45db7445f1ce6d6b$export$48de485e50a67ffa = 2n ** 256n - 1n;

});


parcelRegister("2PSXI", function(module, exports) {

var $04X1W = parcelRequire("04X1W");
module.exports = $04X1W("hAmMs").then(()=>parcelRequire("gYCy5"));

});


parcelRegister("hKzxL", function(module, exports) {

$parcel$export(module.exports, "isAddressEqual", () => $0355b6ee769b5bce$export$34ca016df7f376b8);

var $cegbN = parcelRequire("cegbN");

var $lmNDj = parcelRequire("lmNDj");
function $0355b6ee769b5bce$export$34ca016df7f376b8(a, b) {
    if (!(0, $lmNDj.isAddress)(a, {
        strict: false
    })) throw new (0, $cegbN.InvalidAddressError)({
        address: a
    });
    if (!(0, $lmNDj.isAddress)(b, {
        strict: false
    })) throw new (0, $cegbN.InvalidAddressError)({
        address: b
    });
    return a.toLowerCase() === b.toLowerCase();
}

});

parcelRegister("ammkE", function(module, exports) {

var $04X1W = parcelRequire("04X1W");
module.exports = $04X1W("djPKv").then(()=>parcelRequire("d1uRk"));

});

parcelRegister("3hdCU", function(module, exports) {

$parcel$export(module.exports, "wNAF", () => wNAF);
$parcel$export(module.exports, "pippenger", () => pippenger);
$parcel$export(module.exports, "validateBasic", () => validateBasic);
/**
 * Methods for elliptic curve multiplication by scalars.
 * Contains wNAF, pippenger
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $eyPLr = parcelRequire("eyPLr");

var $igT8E = parcelRequire("igT8E");
const _0n = BigInt(0);
const _1n = BigInt(1);
function constTimeNegate(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
function validateW(W, bits) {
    if (!Number.isSafeInteger(W) || W <= 0 || W > bits) throw new Error("invalid window size, expected [1.." + bits + "], got W=" + W);
}
function calcWOpts(W, scalarBits) {
    validateW(W, scalarBits);
    const windows = Math.ceil(scalarBits / W) + 1; // W=8 33. Not 32, because we skip zero
    const windowSize = 2 ** (W - 1); // W=8 128. Not 256, because we skip zero
    const maxNumber = 2 ** W; // W=8 256
    const mask = (0, $igT8E.bitMask)(W); // W=8 255 == mask 0b11111111
    const shiftBy = BigInt(W); // W=8 8
    return {
        windows: windows,
        windowSize: windowSize,
        mask: mask,
        maxNumber: maxNumber,
        shiftBy: shiftBy
    };
}
function calcOffsets(n, window, wOpts) {
    const { windowSize, mask, maxNumber, shiftBy } = wOpts;
    let wbits = Number(n & mask); // extract W bits.
    let nextN = n >> shiftBy; // shift number by W bits.
    // What actually happens here:
    // const highestBit = Number(mask ^ (mask >> 1n));
    // let wbits2 = wbits - 1; // skip zero
    // if (wbits2 & highestBit) { wbits2 ^= Number(mask); // (~);
    // split if bits > max: +224 => 256-32
    if (wbits > windowSize) {
        // we skip zero, which means instead of `>= size-1`, we do `> size`
        wbits -= maxNumber; // -32, can be maxNumber - wbits, but then we need to set isNeg here.
        nextN += _1n; // +256 (carry)
    }
    const offsetStart = window * windowSize;
    const offset = offsetStart + Math.abs(wbits) - 1; // -1 because we skip zero
    const isZero = wbits === 0; // is current window slice a 0?
    const isNeg = wbits < 0; // is current window slice negative?
    const isNegF = window % 2 !== 0; // fake random statement for noise
    const offsetF = offsetStart; // fake offset for noise
    return {
        nextN: nextN,
        offset: offset,
        isZero: isZero,
        isNeg: isNeg,
        isNegF: isNegF,
        offsetF: offsetF
    };
}
function validateMSMPoints(points, c) {
    if (!Array.isArray(points)) throw new Error("array expected");
    points.forEach((p, i)=>{
        if (!(p instanceof c)) throw new Error("invalid point at index " + i);
    });
}
function validateMSMScalars(scalars, field) {
    if (!Array.isArray(scalars)) throw new Error("array of scalars expected");
    scalars.forEach((s, i)=>{
        if (!field.isValid(s)) throw new Error("invalid scalar at index " + i);
    });
}
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes.
// Allows to make points frozen / immutable.
const pointPrecomputes = new WeakMap();
const pointWindowSizes = new WeakMap();
function getW(P) {
    return pointWindowSizes.get(P) || 1;
}
function wNAF(c, bits) {
    return {
        constTimeNegate: constTimeNegate,
        hasPrecomputes (elm) {
            return getW(elm) !== 1;
        },
        // non-const time multiplication ladder
        unsafeLadder (elm, n, p = c.ZERO) {
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @param elm Point instance
         * @param W window size
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = calcWOpts(W, bits);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // i=1, bc we skip 0
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // Smaller version:
            // https://github.com/paulmillr/noble-secp256k1/blob/47cb1669b6e506ad66b35fe7d76132ae97465da2/index.ts#L502-L541
            // TODO: check the scalar is less than group order?
            // wNAF behavior is undefined otherwise. But have to carefully remove
            // other checks before wNAF. ORDER == bits here.
            // Accumulators
            let p = c.ZERO;
            let f = c.BASE;
            // This code was first written with assumption that 'f' and 'p' will never be infinity point:
            // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
            // there is negate now: it is possible that negated element from low value
            // would be the same as high element, which will create carry into next window.
            // It's not obvious how this can fail, but still worth investigating later.
            const wo = calcWOpts(W, bits);
            for(let window = 0; window < wo.windows; window++){
                // (n === _0n) is handled and not early-exited. isEven and offsetF are used for noise
                const { nextN, offset, isZero, isNeg, isNegF, offsetF } = calcOffsets(n, window, wo);
                n = nextN;
                if (isZero) // bits are 0: add garbage to fake point
                // Important part for const-time getPublicKey: add random "noise" point to f.
                f = f.add(constTimeNegate(isNegF, precomputes[offsetF]));
                else // bits are 1: add to result point
                p = p.add(constTimeNegate(isNeg, precomputes[offset]));
            }
            // Return both real and fake points: JIT won't eliminate f.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        /**
         * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @param acc accumulator point to add result of multiplication
         * @returns point
         */ wNAFUnsafe (W, precomputes, n, acc = c.ZERO) {
            const wo = calcWOpts(W, bits);
            for(let window = 0; window < wo.windows; window++){
                if (n === _0n) break; // Early-exit, skip 0 value
                const { nextN, offset, isZero, isNeg } = calcOffsets(n, window, wo);
                n = nextN;
                if (isZero) continue;
                else {
                    const item = precomputes[offset];
                    acc = acc.add(isNeg ? item.negate() : item); // Re-using acc allows to save adds in MSM
                }
            }
            return acc;
        },
        getPrecomputes (W, P, transform) {
            // Calculate precomputes on a first run, reuse them after
            let comp = pointPrecomputes.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) pointPrecomputes.set(P, transform(comp));
            }
            return comp;
        },
        wNAFCached (P, n, transform) {
            const W = getW(P);
            return this.wNAF(W, this.getPrecomputes(W, P, transform), n);
        },
        wNAFCachedUnsafe (P, n, transform, prev) {
            const W = getW(P);
            if (W === 1) return this.unsafeLadder(P, n, prev); // For W=1 ladder is ~x2 faster
            return this.wNAFUnsafe(W, this.getPrecomputes(W, P, transform), n, prev);
        },
        // We calculate precomputes for elliptic curve point multiplication
        // using windowed method. This specifies window size and
        // stores precomputed values. Usually only base point would be precomputed.
        setWindowSize (P, W) {
            validateW(W, bits);
            pointWindowSizes.set(P, W);
            pointPrecomputes.delete(P);
        }
    };
}
function pippenger(c, fieldN, points, scalars) {
    // If we split scalars by some window (let's say 8 bits), every chunk will only
    // take 256 buckets even if there are 4096 scalars, also re-uses double.
    // TODO:
    // - https://eprint.iacr.org/2024/750.pdf
    // - https://tches.iacr.org/index.php/TCHES/article/view/10287
    // 0 is accepted in scalars
    validateMSMPoints(points, c);
    validateMSMScalars(scalars, fieldN);
    const plength = points.length;
    const slength = scalars.length;
    if (plength !== slength) throw new Error("arrays of points and scalars must have equal length");
    // if (plength === 0) throw new Error('array must be of length >= 2');
    const zero = c.ZERO;
    const wbits = (0, $igT8E.bitLen)(BigInt(plength));
    let windowSize = 1; // bits
    if (wbits > 12) windowSize = wbits - 3;
    else if (wbits > 4) windowSize = wbits - 2;
    else if (wbits > 0) windowSize = 2;
    const MASK = (0, $igT8E.bitMask)(windowSize);
    const buckets = new Array(Number(MASK) + 1).fill(zero); // +1 for zero array
    const lastBits = Math.floor((fieldN.BITS - 1) / windowSize) * windowSize;
    let sum = zero;
    for(let i = lastBits; i >= 0; i -= windowSize){
        buckets.fill(zero);
        for(let j = 0; j < slength; j++){
            const scalar = scalars[j];
            const wbits = Number(scalar >> BigInt(i) & MASK);
            buckets[wbits] = buckets[wbits].add(points[j]);
        }
        let resI = zero; // not using this will do small speed-up, but will lose ct
        // Skip first bucket, because it is zero
        for(let j = buckets.length - 1, sumI = zero; j > 0; j--){
            sumI = sumI.add(buckets[j]);
            resI = resI.add(sumI);
        }
        sum = sum.add(resI);
        if (i !== 0) for(let j = 0; j < windowSize; j++)sum = sum.double();
    }
    return sum;
}
function precomputeMSMUnsafe(c, fieldN, points, windowSize) {
    /**
     * Performance Analysis of Window-based Precomputation
     *
     * Base Case (256-bit scalar, 8-bit window):
     * - Standard precomputation requires:
     *   - 31 additions per scalar × 256 scalars = 7,936 ops
     *   - Plus 255 summary additions = 8,191 total ops
     *   Note: Summary additions can be optimized via accumulator
     *
     * Chunked Precomputation Analysis:
     * - Using 32 chunks requires:
     *   - 255 additions per chunk
     *   - 256 doublings
     *   - Total: (255 × 32) + 256 = 8,416 ops
     *
     * Memory Usage Comparison:
     * Window Size | Standard Points | Chunked Points
     * ------------|-----------------|---------------
     *     4-bit   |     520         |      15
     *     8-bit   |    4,224        |     255
     *    10-bit   |   13,824        |   1,023
     *    16-bit   |  557,056        |  65,535
     *
     * Key Advantages:
     * 1. Enables larger window sizes due to reduced memory overhead
     * 2. More efficient for smaller scalar counts:
     *    - 16 chunks: (16 × 255) + 256 = 4,336 ops
     *    - ~2x faster than standard 8,191 ops
     *
     * Limitations:
     * - Not suitable for plain precomputes (requires 256 constant doublings)
     * - Performance degrades with larger scalar counts:
     *   - Optimal for ~256 scalars
     *   - Less efficient for 4096+ scalars (Pippenger preferred)
     */ validateW(windowSize, fieldN.BITS);
    validateMSMPoints(points, c);
    const zero = c.ZERO;
    const tableSize = 2 ** windowSize - 1; // table size (without zero)
    const chunks = Math.ceil(fieldN.BITS / windowSize); // chunks of item
    const MASK = (0, $igT8E.bitMask)(windowSize);
    const tables = points.map((p)=>{
        const res = [];
        for(let i = 0, acc = p; i < tableSize; i++){
            res.push(acc);
            acc = acc.add(p);
        }
        return res;
    });
    return (scalars)=>{
        validateMSMScalars(scalars, fieldN);
        if (scalars.length > points.length) throw new Error("array of scalars must be smaller than array of points");
        let res = zero;
        for(let i = 0; i < chunks; i++){
            // No need to double if accumulator is still zero.
            if (res !== zero) for(let j = 0; j < windowSize; j++)res = res.double();
            const shiftBy = BigInt(chunks * windowSize - (i + 1) * windowSize);
            for(let j = 0; j < scalars.length; j++){
                const n = scalars[j];
                const curr = Number(n >> shiftBy & MASK);
                if (!curr) continue; // skip zero scalars chunks
                res = res.add(tables[j][curr - 1]);
            }
        }
        return res;
    };
}
function validateBasic(curve) {
    (0, $eyPLr.validateField)(curve.Fp);
    (0, $igT8E.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $eyPLr.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

});
parcelRegister("eyPLr", function(module, exports) {

$parcel$export(module.exports, "mod", () => $a99c64f3938da64a$export$842a2cf37af977e1);
$parcel$export(module.exports, "Field", () => $a99c64f3938da64a$export$a455218a85c89869);
$parcel$export(module.exports, "pow2", () => $a99c64f3938da64a$export$fa569bd808b67eef);
$parcel$export(module.exports, "invert", () => $a99c64f3938da64a$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "isNegativeLE", () => $a99c64f3938da64a$export$7806f13ad5078b2f);
$parcel$export(module.exports, "validateField", () => $a99c64f3938da64a$export$bd454f0cef11418d);
$parcel$export(module.exports, "FpInvertBatch", () => $a99c64f3938da64a$export$a492e3387142c0e9);
$parcel$export(module.exports, "nLength", () => $a99c64f3938da64a$export$c79df43ecd7e66c2);
$parcel$export(module.exports, "FpSqrtEven", () => $a99c64f3938da64a$export$1d7b691df0888e02);
$parcel$export(module.exports, "getMinHashLength", () => $a99c64f3938da64a$export$d058763b563056af);
$parcel$export(module.exports, "mapHashToField", () => $a99c64f3938da64a$export$20cb21dbfa61dac3);
/**
 * Utils for modular division and finite fields.
 * A finite field over 11 is integer number operations `mod 11`.
 * There is no division: it is replaced by modular multiplicative inverse.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $7MXpH = parcelRequire("7MXpH");

var $igT8E = parcelRequire("igT8E");
// prettier-ignore
const $a99c64f3938da64a$var$_0n = BigInt(0), $a99c64f3938da64a$var$_1n = BigInt(1), $a99c64f3938da64a$var$_2n = /* @__PURE__ */ BigInt(2), $a99c64f3938da64a$var$_3n = /* @__PURE__ */ BigInt(3);
// prettier-ignore
const $a99c64f3938da64a$var$_4n = /* @__PURE__ */ BigInt(4), $a99c64f3938da64a$var$_5n = /* @__PURE__ */ BigInt(5), $a99c64f3938da64a$var$_8n = /* @__PURE__ */ BigInt(8);
function $a99c64f3938da64a$export$842a2cf37af977e1(a, b) {
    const result = a % b;
    return result >= $a99c64f3938da64a$var$_0n ? result : b + result;
}
function $a99c64f3938da64a$export$9c297f60e22e3389(num, power, modulo) {
    return $a99c64f3938da64a$export$5d8ce3717733a987($a99c64f3938da64a$export$a455218a85c89869(modulo), num, power);
}
function $a99c64f3938da64a$export$fa569bd808b67eef(x, power, modulo) {
    let res = x;
    while(power-- > $a99c64f3938da64a$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $a99c64f3938da64a$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $a99c64f3938da64a$var$_0n) throw new Error("invert: expected non-zero number");
    if (modulo <= $a99c64f3938da64a$var$_0n) throw new Error("invert: expected positive modulus, got " + modulo);
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $a99c64f3938da64a$export$842a2cf37af977e1(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $a99c64f3938da64a$var$_0n, y = $a99c64f3938da64a$var$_1n, u = $a99c64f3938da64a$var$_1n, v = $a99c64f3938da64a$var$_0n;
    while(a !== $a99c64f3938da64a$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $a99c64f3938da64a$var$_1n) throw new Error("invert: does not exist");
    return $a99c64f3938da64a$export$842a2cf37af977e1(x, modulo);
}
// Not all roots are possible! Example which will throw:
// const NUM =
// n = 72057594037927816n;
// Fp = Field(BigInt('0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaab'));
function $a99c64f3938da64a$var$sqrt3mod4(Fp, n) {
    const p1div4 = (Fp.ORDER + $a99c64f3938da64a$var$_1n) / $a99c64f3938da64a$var$_4n;
    const root = Fp.pow(n, p1div4);
    // Throw if root^2 != n
    if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
    return root;
}
function $a99c64f3938da64a$var$sqrt5mod8(Fp, n) {
    const p5div8 = (Fp.ORDER - $a99c64f3938da64a$var$_5n) / $a99c64f3938da64a$var$_8n;
    const n2 = Fp.mul(n, $a99c64f3938da64a$var$_2n);
    const v = Fp.pow(n2, p5div8);
    const nv = Fp.mul(n, v);
    const i = Fp.mul(Fp.mul(nv, $a99c64f3938da64a$var$_2n), v);
    const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
    if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
    return root;
}
function $a99c64f3938da64a$export$69f29ab1f3e9a234(P) {
    // Initialization (precomputation).
    if (P < BigInt(3)) throw new Error("sqrt is not defined for small field");
    // Factor P - 1 = Q * 2^S, where Q is odd
    let Q = P - $a99c64f3938da64a$var$_1n;
    let S = 0;
    while(Q % $a99c64f3938da64a$var$_2n === $a99c64f3938da64a$var$_0n){
        Q /= $a99c64f3938da64a$var$_2n;
        S++;
    }
    // Find the first quadratic non-residue Z >= 2
    let Z = $a99c64f3938da64a$var$_2n;
    const _Fp = $a99c64f3938da64a$export$a455218a85c89869(P);
    while($a99c64f3938da64a$export$77ed22730026dd0d(_Fp, Z) === 1){
        // Basic primality test for P. After x iterations, chance of
        // not finding quadratic non-residue is 2^x, so 2^1000.
        if (Z++ > 1000) throw new Error("Cannot find square root: probably non-prime P");
    }
    // Fast-path; usually done before Z, but we do "primality test".
    if (S === 1) return $a99c64f3938da64a$var$sqrt3mod4;
    // Slow-path
    // TODO: test on Fp2 and others
    let cc = _Fp.pow(Z, Q); // c = z^Q
    const Q1div2 = (Q + $a99c64f3938da64a$var$_1n) / $a99c64f3938da64a$var$_2n;
    return function tonelliSlow(Fp, n) {
        if (Fp.is0(n)) return n;
        // Check if n is a quadratic residue using Legendre symbol
        if ($a99c64f3938da64a$export$77ed22730026dd0d(Fp, n) !== 1) throw new Error("Cannot find square root");
        // Initialize variables for the main loop
        let M = S;
        let c = Fp.mul(Fp.ONE, cc); // c = z^Q, move cc from field _Fp into field Fp
        let t = Fp.pow(n, Q); // t = n^Q, first guess at the fudge factor
        let R = Fp.pow(n, Q1div2); // R = n^((Q+1)/2), first guess at the square root
        // Main loop
        // while t != 1
        while(!Fp.eql(t, Fp.ONE)){
            if (Fp.is0(t)) return Fp.ZERO; // if t=0 return R=0
            let i = 1;
            // Find the smallest i >= 1 such that t^(2^i) ≡ 1 (mod P)
            let t_tmp = Fp.sqr(t); // t^(2^1)
            while(!Fp.eql(t_tmp, Fp.ONE)){
                i++;
                t_tmp = Fp.sqr(t_tmp); // t^(2^2)...
                if (i === M) throw new Error("Cannot find square root");
            }
            // Calculate the exponent for b: 2^(M - i - 1)
            const exponent = $a99c64f3938da64a$var$_1n << BigInt(M - i - 1); // bigint is important
            const b = Fp.pow(c, exponent); // b = 2^(M - i - 1)
            // Update variables
            M = i;
            c = Fp.sqr(b); // c = b^2
            t = Fp.mul(t, c); // t = (t * b^2)
            R = Fp.mul(R, b); // R = R*b
        }
        return R;
    };
}
function $a99c64f3938da64a$export$33bda048c6b8ea7d(P) {
    // P ≡ 3 (mod 4) => √n = n^((P+1)/4)
    if (P % $a99c64f3938da64a$var$_4n === $a99c64f3938da64a$var$_3n) return $a99c64f3938da64a$var$sqrt3mod4;
    // P ≡ 5 (mod 8) => Atkin algorithm, page 10 of https://eprint.iacr.org/2012/685.pdf
    if (P % $a99c64f3938da64a$var$_8n === $a99c64f3938da64a$var$_5n) return $a99c64f3938da64a$var$sqrt5mod8;
    // P ≡ 9 (mod 16) not implemented, see above
    // Tonelli-Shanks algorithm
    return $a99c64f3938da64a$export$69f29ab1f3e9a234(P);
}
const $a99c64f3938da64a$export$7806f13ad5078b2f = (num, modulo)=>($a99c64f3938da64a$export$842a2cf37af977e1(num, modulo) & $a99c64f3938da64a$var$_1n) === $a99c64f3938da64a$var$_1n;
// prettier-ignore
const $a99c64f3938da64a$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $a99c64f3938da64a$export$bd454f0cef11418d(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $a99c64f3938da64a$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $igT8E.validateObject)(field, opts);
}
function $a99c64f3938da64a$export$5d8ce3717733a987(Fp, num, power) {
    if (power < $a99c64f3938da64a$var$_0n) throw new Error("invalid exponent, negatives unsupported");
    if (power === $a99c64f3938da64a$var$_0n) return Fp.ONE;
    if (power === $a99c64f3938da64a$var$_1n) return num;
    let p = Fp.ONE;
    let d = num;
    while(power > $a99c64f3938da64a$var$_0n){
        if (power & $a99c64f3938da64a$var$_1n) p = Fp.mul(p, d);
        d = Fp.sqr(d);
        power >>= $a99c64f3938da64a$var$_1n;
    }
    return p;
}
function $a99c64f3938da64a$export$a492e3387142c0e9(Fp, nums, passZero = false) {
    const inverted = new Array(nums.length).fill(passZero ? Fp.ZERO : undefined);
    // Walk from first to last, multiply them by each other MOD p
    const multipliedAcc = nums.reduce((acc, num, i)=>{
        if (Fp.is0(num)) return acc;
        inverted[i] = acc;
        return Fp.mul(acc, num);
    }, Fp.ONE);
    // Invert last element
    const invertedAcc = Fp.inv(multipliedAcc);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (Fp.is0(num)) return acc;
        inverted[i] = Fp.mul(acc, inverted[i]);
        return Fp.mul(acc, num);
    }, invertedAcc);
    return inverted;
}
function $a99c64f3938da64a$export$e74c665040343df6(Fp, lhs, rhs) {
    return Fp.mul(lhs, typeof rhs === "bigint" ? $a99c64f3938da64a$export$6897c284b6f9f4dc(rhs, Fp.ORDER) : Fp.inv(rhs));
}
function $a99c64f3938da64a$export$77ed22730026dd0d(Fp, n) {
    // We can use 3rd argument as optional cache of this value
    // but seems unneeded for now. The operation is very fast.
    const p1mod2 = (Fp.ORDER - $a99c64f3938da64a$var$_1n) / $a99c64f3938da64a$var$_2n;
    const powered = Fp.pow(n, p1mod2);
    const yes = Fp.eql(powered, Fp.ONE);
    const zero = Fp.eql(powered, Fp.ZERO);
    const no = Fp.eql(powered, Fp.neg(Fp.ONE));
    if (!yes && !zero && !no) throw new Error("invalid Legendre symbol result");
    return yes ? 1 : zero ? 0 : -1;
}
function $a99c64f3938da64a$export$5e2b6e87f2891ea7(Fp, n) {
    const l = $a99c64f3938da64a$export$77ed22730026dd0d(Fp, n);
    return l === 1;
}
function $a99c64f3938da64a$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    if (nBitLength !== undefined) (0, $7MXpH.anumber)(nBitLength);
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
function $a99c64f3938da64a$export$a455218a85c89869(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $a99c64f3938da64a$var$_0n) throw new Error("invalid field: expected ORDER > 0, got " + ORDER);
    const { nBitLength: BITS, nByteLength: BYTES } = $a99c64f3938da64a$export$c79df43ecd7e66c2(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("invalid field: expected ORDER of <= 2048 bytes");
    let sqrtP; // cached sqrtP
    const f = Object.freeze({
        ORDER: ORDER,
        isLE: isLE,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $igT8E.bitMask)(BITS),
        ZERO: $a99c64f3938da64a$var$_0n,
        ONE: $a99c64f3938da64a$var$_1n,
        create: (num)=>$a99c64f3938da64a$export$842a2cf37af977e1(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error("invalid field element: expected bigint, got " + typeof num);
            return $a99c64f3938da64a$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $a99c64f3938da64a$var$_0n,
        isOdd: (num)=>(num & $a99c64f3938da64a$var$_1n) === $a99c64f3938da64a$var$_1n,
        neg: (num)=>$a99c64f3938da64a$export$842a2cf37af977e1(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$a99c64f3938da64a$export$842a2cf37af977e1(num * num, ORDER),
        add: (lhs, rhs)=>$a99c64f3938da64a$export$842a2cf37af977e1(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$a99c64f3938da64a$export$842a2cf37af977e1(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$a99c64f3938da64a$export$842a2cf37af977e1(lhs * rhs, ORDER),
        pow: (num, power)=>$a99c64f3938da64a$export$5d8ce3717733a987(f, num, power),
        div: (lhs, rhs)=>$a99c64f3938da64a$export$842a2cf37af977e1(lhs * $a99c64f3938da64a$export$6897c284b6f9f4dc(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$a99c64f3938da64a$export$6897c284b6f9f4dc(num, ORDER),
        sqrt: redef.sqrt || ((n)=>{
            if (!sqrtP) sqrtP = $a99c64f3938da64a$export$33bda048c6b8ea7d(ORDER);
            return sqrtP(f, n);
        }),
        toBytes: (num)=>isLE ? (0, $igT8E.numberToBytesLE)(num, BYTES) : (0, $igT8E.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error("Field.fromBytes: expected " + BYTES + " bytes, got " + bytes.length);
            return isLE ? (0, $igT8E.bytesToNumberLE)(bytes) : (0, $igT8E.bytesToNumberBE)(bytes);
        },
        // TODO: we don't need it here, move out to separate fn
        invertBatch: (lst)=>$a99c64f3938da64a$export$a492e3387142c0e9(f, lst),
        // We can't move this out because Fp6, Fp12 implement it
        // and it's unclear what to return in there.
        cmov: (a, b, c)=>c ? b : a
    });
    return Object.freeze(f);
}
function $a99c64f3938da64a$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $a99c64f3938da64a$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $a99c64f3938da64a$export$d3b0e8260d5dbad4(hash, groupOrder, isLE = false) {
    hash = (0, $igT8E.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $a99c64f3938da64a$export$c79df43ecd7e66c2(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error("hashToPrivateScalar: expected " + minLen + "-1024 bytes of input, got " + hashLen);
    const num = isLE ? (0, $igT8E.bytesToNumberLE)(hash) : (0, $igT8E.bytesToNumberBE)(hash);
    return $a99c64f3938da64a$export$842a2cf37af977e1(num, groupOrder - $a99c64f3938da64a$var$_1n) + $a99c64f3938da64a$var$_1n;
}
function $a99c64f3938da64a$export$9cf21a9392b0fcfc(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $a99c64f3938da64a$export$d058763b563056af(fieldOrder) {
    const length = $a99c64f3938da64a$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $a99c64f3938da64a$export$20cb21dbfa61dac3(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $a99c64f3938da64a$export$9cf21a9392b0fcfc(fieldOrder);
    const minLen = $a99c64f3938da64a$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error("expected " + minLen + "-1024 bytes of input, got " + len);
    const num = isLE ? (0, $igT8E.bytesToNumberLE)(key) : (0, $igT8E.bytesToNumberBE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $a99c64f3938da64a$export$842a2cf37af977e1(num, fieldOrder - $a99c64f3938da64a$var$_1n) + $a99c64f3938da64a$var$_1n;
    return isLE ? (0, $igT8E.numberToBytesLE)(reduced, fieldLen) : (0, $igT8E.numberToBytesBE)(reduced, fieldLen);
}

});


parcelRegister("lCikh", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("ct9Rv")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});
parcelRegister("ct9Rv", function(module, exports) {
"use strict";

});


parcelRegister("dqH3B", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $lewJ9 = parcelRequire("lewJ9");
var $9c6f1a50fdcd86f1$var$Buffer = $lewJ9.Buffer;
// alternative to using Object.keys for old browsers
function $9c6f1a50fdcd86f1$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($9c6f1a50fdcd86f1$var$Buffer.from && $9c6f1a50fdcd86f1$var$Buffer.alloc && $9c6f1a50fdcd86f1$var$Buffer.allocUnsafe && $9c6f1a50fdcd86f1$var$Buffer.allocUnsafeSlow) module.exports = $lewJ9;
else {
    // Copy properties from require('buffer')
    $9c6f1a50fdcd86f1$var$copyProps($lewJ9, module.exports);
    module.exports.Buffer = $9c6f1a50fdcd86f1$var$SafeBuffer;
}
function $9c6f1a50fdcd86f1$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $9c6f1a50fdcd86f1$var$Buffer(arg, encodingOrOffset, length);
}
$9c6f1a50fdcd86f1$var$SafeBuffer.prototype = Object.create($9c6f1a50fdcd86f1$var$Buffer.prototype);
// Copy static methods from Buffer
$9c6f1a50fdcd86f1$var$copyProps($9c6f1a50fdcd86f1$var$Buffer, $9c6f1a50fdcd86f1$var$SafeBuffer);
$9c6f1a50fdcd86f1$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $9c6f1a50fdcd86f1$var$Buffer(arg, encodingOrOffset, length);
};
$9c6f1a50fdcd86f1$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $9c6f1a50fdcd86f1$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$9c6f1a50fdcd86f1$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $9c6f1a50fdcd86f1$var$Buffer(size);
};
$9c6f1a50fdcd86f1$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $lewJ9.SlowBuffer(size);
};

});

parcelRegister("lQSzJ", function(module, exports) {

var $cVN2N = parcelRequire("cVN2N");
var $fe88c9d19ef39b7f$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $cVN2N($fe88c9d19ef39b7f$var$ALPHABET);

});
parcelRegister("cVN2N", function(module, exports) {
"use strict";

var $dqH3B = parcelRequire("dqH3B");
var $96a0da11719d7741$require$_Buffer = $dqH3B.Buffer;
function $96a0da11719d7741$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $96a0da11719d7741$require$_Buffer.from(source);
        if (!$96a0da11719d7741$require$_Buffer.isBuffer(source)) throw new TypeError("Expected Buffer");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return $96a0da11719d7741$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(psz < source.length){
            // Find code of next character
            var charCode = source.charCodeAt(psz);
            // Base map can not be indexed using char code
            if (charCode > 255) return;
            // Decode character
            var carry = BASE_MAP[charCode];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $96a0da11719d7741$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $96a0da11719d7741$var$base;

});


parcelRegister("1ukto", function(module, exports) {

$parcel$export(module.exports, "TextEncoder", () => $1158794a2a74dfa9$export$88fb0cfd153261a7, (v) => $1158794a2a74dfa9$export$88fb0cfd153261a7 = v);
$parcel$export(module.exports, "TextDecoder", () => $1158794a2a74dfa9$export$9c6b53e35bc51b5c, (v) => $1158794a2a74dfa9$export$9c6b53e35bc51b5c = v);
var $1158794a2a74dfa9$export$88fb0cfd153261a7;
var $1158794a2a74dfa9$export$9c6b53e35bc51b5c;
"use strict";
// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.
//
// Utilities
//
/**
 * @param {number} a The number to test.
 * @param {number} min The minimum value in the range, inclusive.
 * @param {number} max The maximum value in the range, inclusive.
 * @return {boolean} True if a >= min and a <= max.
 */ function $1158794a2a74dfa9$var$inRange(a, min, max) {
    return min <= a && a <= max;
}
/**
 * @param {*} o
 * @return {Object}
 */ function $1158794a2a74dfa9$var$ToDictionary(o) {
    if (o === undefined) return {};
    if (o === Object(o)) return o;
    throw TypeError("Could not convert argument to dictionary");
}
/**
 * @param {string} string Input string of UTF-16 code units.
 * @return {!Array.<number>} Code points.
 */ function $1158794a2a74dfa9$var$stringToCodePoints(string) {
    // https://heycam.github.io/webidl/#dfn-obtain-unicode
    // 1. Let S be the DOMString value.
    var s = String(string);
    // 2. Let n be the length of S.
    var n = s.length;
    // 3. Initialize i to 0.
    var i = 0;
    // 4. Initialize U to be an empty sequence of Unicode characters.
    var u = [];
    // 5. While i < n:
    while(i < n){
        // 1. Let c be the code unit in S at index i.
        var c = s.charCodeAt(i);
        // 2. Depending on the value of c:
        // c < 0xD800 or c > 0xDFFF
        if (c < 0xD800 || c > 0xDFFF) // Append to U the Unicode character with code point c.
        u.push(c);
        else if (0xDC00 <= c && c <= 0xDFFF) // Append to U a U+FFFD REPLACEMENT CHARACTER.
        u.push(0xFFFD);
        else if (0xD800 <= c && c <= 0xDBFF) {
            // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
            // CHARACTER.
            if (i === n - 1) u.push(0xFFFD);
            else {
                // 1. Let d be the code unit in S at index i+1.
                var d = string.charCodeAt(i + 1);
                // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
                if (0xDC00 <= d && d <= 0xDFFF) {
                    // 1. Let a be c & 0x3FF.
                    var a = c & 0x3FF;
                    // 2. Let b be d & 0x3FF.
                    var b = d & 0x3FF;
                    // 3. Append to U the Unicode character with code point
                    // 2^16+2^10*a+b.
                    u.push(0x10000 + (a << 10) + b);
                    // 4. Set i to i+1.
                    i += 1;
                } else u.push(0xFFFD);
            }
        }
        // 3. Set i to i+1.
        i += 1;
    }
    // 6. Return U.
    return u;
}
/**
 * @param {!Array.<number>} code_points Array of code points.
 * @return {string} string String of UTF-16 code units.
 */ function $1158794a2a74dfa9$var$codePointsToString(code_points) {
    var s = "";
    for(var i = 0; i < code_points.length; ++i){
        var cp = code_points[i];
        if (cp <= 0xFFFF) s += String.fromCharCode(cp);
        else {
            cp -= 0x10000;
            s += String.fromCharCode((cp >> 10) + 0xD800, (cp & 0x3FF) + 0xDC00);
        }
    }
    return s;
}
//
// Implementation of Encoding specification
// https://encoding.spec.whatwg.org/
//
//
// 3. Terminology
//
/**
 * End-of-stream is a special token that signifies no more tokens
 * are in the stream.
 * @const
 */ var $1158794a2a74dfa9$var$end_of_stream = -1;
/**
 * A stream represents an ordered sequence of tokens.
 *
 * @constructor
 * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide the
 * stream.
 */ function $1158794a2a74dfa9$var$Stream(tokens) {
    /** @type {!Array.<number>} */ this.tokens = [].slice.call(tokens);
}
$1158794a2a74dfa9$var$Stream.prototype = {
    /**
   * @return {boolean} True if end-of-stream has been hit.
   */ endOfStream: function() {
        return !this.tokens.length;
    },
    /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */ read: function() {
        if (!this.tokens.length) return $1158794a2a74dfa9$var$end_of_stream;
        return this.tokens.shift();
    },
    /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */ prepend: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.unshift(tokens.pop());
        } else this.tokens.unshift(token);
    },
    /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */ push: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.push(tokens.shift());
        } else this.tokens.push(token);
    }
};
//
// 4. Encodings
//
// 4.1 Encoders and decoders
/** @const */ var $1158794a2a74dfa9$var$finished = -1;
/**
 * @param {boolean} fatal If true, decoding errors raise an exception.
 * @param {number=} opt_code_point Override the standard fallback code point.
 * @return {number} The code point to insert on a decoding error.
 */ function $1158794a2a74dfa9$var$decoderError(fatal, opt_code_point) {
    if (fatal) throw TypeError("Decoder error");
    return opt_code_point || 0xFFFD;
}
//
// 7. API
//
/** @const */ var $1158794a2a74dfa9$var$DEFAULT_ENCODING = "utf-8";
// 7.1 Interface TextDecoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $1158794a2a74dfa9$var$TextDecoder(encoding, options) {
    if (!(this instanceof $1158794a2a74dfa9$var$TextDecoder)) return new $1158794a2a74dfa9$var$TextDecoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $1158794a2a74dfa9$var$DEFAULT_ENCODING;
    if (encoding !== $1158794a2a74dfa9$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $1158794a2a74dfa9$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {boolean} */ this._BOMseen = false;
    /** @private @type {?Decoder} */ this._decoder = null;
    /** @private @type {boolean} */ this._fatal = Boolean(options["fatal"]);
    /** @private @type {boolean} */ this._ignoreBOM = Boolean(options["ignoreBOM"]);
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
    Object.defineProperty(this, "fatal", {
        value: this._fatal
    });
    Object.defineProperty(this, "ignoreBOM", {
        value: this._ignoreBOM
    });
}
$1158794a2a74dfa9$var$TextDecoder.prototype = {
    /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */ decode: function decode(input, options) {
        var bytes;
        if (typeof input === "object" && input instanceof ArrayBuffer) bytes = new Uint8Array(input);
        else if (typeof input === "object" && "buffer" in input && input.buffer instanceof ArrayBuffer) bytes = new Uint8Array(input.buffer, input.byteOffset, input.byteLength);
        else bytes = new Uint8Array(0);
        options = $1158794a2a74dfa9$var$ToDictionary(options);
        if (!this._streaming) {
            this._decoder = new $1158794a2a74dfa9$var$UTF8Decoder({
                fatal: this._fatal
            });
            this._BOMseen = false;
        }
        this._streaming = Boolean(options["stream"]);
        var input_stream = new $1158794a2a74dfa9$var$Stream(bytes);
        var code_points = [];
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._decoder.handler(input_stream, input_stream.read());
            if (result === $1158794a2a74dfa9$var$finished) break;
            if (result === null) continue;
            if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
            else code_points.push(result);
        }
        if (!this._streaming) {
            do {
                result = this._decoder.handler(input_stream, input_stream.read());
                if (result === $1158794a2a74dfa9$var$finished) break;
                if (result === null) continue;
                if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
                else code_points.push(result);
            }while (!input_stream.endOfStream());
            this._decoder = null;
        }
        if (code_points.length) // If encoding is one of utf-8, utf-16be, and utf-16le, and
        // ignore BOM flag and BOM seen flag are unset, run these
        // subsubsteps:
        {
            if ([
                "utf-8"
            ].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen) {
                // If token is U+FEFF, set BOM seen flag.
                if (code_points[0] === 0xFEFF) {
                    this._BOMseen = true;
                    code_points.shift();
                } else // Otherwise, if token is not end-of-stream, set BOM seen
                // flag and append token to output.
                this._BOMseen = true;
            }
        }
        return $1158794a2a74dfa9$var$codePointsToString(code_points);
    }
};
// 7.2 Interface TextEncoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $1158794a2a74dfa9$var$TextEncoder(encoding, options) {
    if (!(this instanceof $1158794a2a74dfa9$var$TextEncoder)) return new $1158794a2a74dfa9$var$TextEncoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $1158794a2a74dfa9$var$DEFAULT_ENCODING;
    if (encoding !== $1158794a2a74dfa9$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $1158794a2a74dfa9$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {?Encoder} */ this._encoder = null;
    /** @private @type {{fatal: boolean}} */ this._options = {
        fatal: Boolean(options["fatal"])
    };
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
}
$1158794a2a74dfa9$var$TextEncoder.prototype = {
    /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */ encode: function encode(opt_string, options) {
        opt_string = opt_string ? String(opt_string) : "";
        options = $1158794a2a74dfa9$var$ToDictionary(options);
        // NOTE: This option is nonstandard. None of the encodings
        // permitted for encoding (i.e. UTF-8, UTF-16) are stateful,
        // so streaming is not necessary.
        if (!this._streaming) this._encoder = new $1158794a2a74dfa9$var$UTF8Encoder(this._options);
        this._streaming = Boolean(options["stream"]);
        var bytes = [];
        var input_stream = new $1158794a2a74dfa9$var$Stream($1158794a2a74dfa9$var$stringToCodePoints(opt_string));
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._encoder.handler(input_stream, input_stream.read());
            if (result === $1158794a2a74dfa9$var$finished) break;
            if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
            else bytes.push(result);
        }
        if (!this._streaming) {
            while(true){
                result = this._encoder.handler(input_stream, input_stream.read());
                if (result === $1158794a2a74dfa9$var$finished) break;
                if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
                else bytes.push(result);
            }
            this._encoder = null;
        }
        return new Uint8Array(bytes);
    }
};
//
// 8. The encoding
//
// 8.1 utf-8
/**
 * @constructor
 * @implements {Decoder}
 * @param {{fatal: boolean}} options
 */ function $1158794a2a74dfa9$var$UTF8Decoder(options) {
    var fatal = options.fatal;
    // utf-8's decoder's has an associated utf-8 code point, utf-8
    // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
    // lower boundary (initially 0x80), and a utf-8 upper boundary
    // (initially 0xBF).
    var /** @type {number} */ utf8_code_point = 0, /** @type {number} */ utf8_bytes_seen = 0, /** @type {number} */ utf8_bytes_needed = 0, /** @type {number} */ utf8_lower_boundary = 0x80, /** @type {number} */ utf8_upper_boundary = 0xBF;
    /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point.
   */ this.handler = function(stream, bite) {
        // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
        // set utf-8 bytes needed to 0 and return error.
        if (bite === $1158794a2a74dfa9$var$end_of_stream && utf8_bytes_needed !== 0) {
            utf8_bytes_needed = 0;
            return $1158794a2a74dfa9$var$decoderError(fatal);
        }
        // 2. If byte is end-of-stream, return finished.
        if (bite === $1158794a2a74dfa9$var$end_of_stream) return $1158794a2a74dfa9$var$finished;
        // 3. If utf-8 bytes needed is 0, based on byte:
        if (utf8_bytes_needed === 0) {
            // 0x00 to 0x7F
            if ($1158794a2a74dfa9$var$inRange(bite, 0x00, 0x7F)) // Return a code point whose value is byte.
            return bite;
            // 0xC2 to 0xDF
            if ($1158794a2a74dfa9$var$inRange(bite, 0xC2, 0xDF)) {
                // Set utf-8 bytes needed to 1 and utf-8 code point to byte
                // − 0xC0.
                utf8_bytes_needed = 1;
                utf8_code_point = bite - 0xC0;
            } else if ($1158794a2a74dfa9$var$inRange(bite, 0xE0, 0xEF)) {
                // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
                if (bite === 0xE0) utf8_lower_boundary = 0xA0;
                // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
                if (bite === 0xED) utf8_upper_boundary = 0x9F;
                // 3. Set utf-8 bytes needed to 2 and utf-8 code point to
                // byte − 0xE0.
                utf8_bytes_needed = 2;
                utf8_code_point = bite - 0xE0;
            } else if ($1158794a2a74dfa9$var$inRange(bite, 0xF0, 0xF4)) {
                // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
                if (bite === 0xF0) utf8_lower_boundary = 0x90;
                // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
                if (bite === 0xF4) utf8_upper_boundary = 0x8F;
                // 3. Set utf-8 bytes needed to 3 and utf-8 code point to
                // byte − 0xF0.
                utf8_bytes_needed = 3;
                utf8_code_point = bite - 0xF0;
            } else // Return error.
            return $1158794a2a74dfa9$var$decoderError(fatal);
            // Then (byte is in the range 0xC2 to 0xF4) set utf-8 code
            // point to utf-8 code point << (6 × utf-8 bytes needed) and
            // return continue.
            utf8_code_point = utf8_code_point << 6 * utf8_bytes_needed;
            return null;
        }
        // 4. If byte is not in the range utf-8 lower boundary to utf-8
        // upper boundary, run these substeps:
        if (!$1158794a2a74dfa9$var$inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {
            // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
            // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
            // utf-8 upper boundary to 0xBF.
            utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
            utf8_lower_boundary = 0x80;
            utf8_upper_boundary = 0xBF;
            // 2. Prepend byte to stream.
            stream.prepend(bite);
            // 3. Return error.
            return $1158794a2a74dfa9$var$decoderError(fatal);
        }
        // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
        // to 0xBF.
        utf8_lower_boundary = 0x80;
        utf8_upper_boundary = 0xBF;
        // 6. Increase utf-8 bytes seen by one and set utf-8 code point
        // to utf-8 code point + (byte − 0x80) << (6 × (utf-8 bytes
        // needed − utf-8 bytes seen)).
        utf8_bytes_seen += 1;
        utf8_code_point += bite - 0x80 << 6 * (utf8_bytes_needed - utf8_bytes_seen);
        // 7. If utf-8 bytes seen is not equal to utf-8 bytes needed,
        // continue.
        if (utf8_bytes_seen !== utf8_bytes_needed) return null;
        // 8. Let code point be utf-8 code point.
        var code_point = utf8_code_point;
        // 9. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
        // seen to 0.
        utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
        // 10. Return a code point whose value is code point.
        return code_point;
    };
}
/**
 * @constructor
 * @implements {Encoder}
 * @param {{fatal: boolean}} options
 */ function $1158794a2a74dfa9$var$UTF8Encoder(options) {
    var fatal = options.fatal;
    /**
   * @param {Stream} stream Input stream.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit.
   */ this.handler = function(stream, code_point) {
        // 1. If code point is end-of-stream, return finished.
        if (code_point === $1158794a2a74dfa9$var$end_of_stream) return $1158794a2a74dfa9$var$finished;
        // 2. If code point is in the range U+0000 to U+007F, return a
        // byte whose value is code point.
        if ($1158794a2a74dfa9$var$inRange(code_point, 0x0000, 0x007f)) return code_point;
        // 3. Set count and offset based on the range code point is in:
        var count, offset;
        // U+0080 to U+07FF:    1 and 0xC0
        if ($1158794a2a74dfa9$var$inRange(code_point, 0x0080, 0x07FF)) {
            count = 1;
            offset = 0xC0;
        } else if ($1158794a2a74dfa9$var$inRange(code_point, 0x0800, 0xFFFF)) {
            count = 2;
            offset = 0xE0;
        } else if ($1158794a2a74dfa9$var$inRange(code_point, 0x10000, 0x10FFFF)) {
            count = 3;
            offset = 0xF0;
        }
        // 4.Let bytes be a byte sequence whose first byte is (code
        // point >> (6 × count)) + offset.
        var bytes = [
            (code_point >> 6 * count) + offset
        ];
        // 5. Run these substeps while count is greater than 0:
        while(count > 0){
            // 1. Set temp to code point >> (6 × (count − 1)).
            var temp = code_point >> 6 * (count - 1);
            // 2. Append to bytes 0x80 | (temp & 0x3F).
            bytes.push(0x80 | temp & 0x3F);
            // 3. Decrease count by one.
            count -= 1;
        }
        // 6. Return bytes bytes, in order.
        return bytes;
    };
}
$1158794a2a74dfa9$export$88fb0cfd153261a7 = $1158794a2a74dfa9$var$TextEncoder;
$1158794a2a74dfa9$export$9c6b53e35bc51b5c = $1158794a2a74dfa9$var$TextDecoder;

});

parcelRegister("7pdKa", function(module, exports) {

$parcel$export(module.exports, "secp256k1", () => $564587610d04a137$export$529e6123e9353a90);
/**
 * NIST secp256k1. See [pdf](https://www.secg.org/sec2-v2.pdf).
 *
 * Seems to be rigid (not backdoored)
 * [as per discussion](https://bitcointalk.org/index.php?topic=289795.msg3183975#msg3183975).
 *
 * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
 * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
 * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
 * [See explanation](https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066).
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $2UD1v = parcelRequire("2UD1v");

var $7MXpH = parcelRequire("7MXpH");

var $2Dyck = parcelRequire("2Dyck");

var $fNnAT = parcelRequire("fNnAT");

var $eyPLr = parcelRequire("eyPLr");

var $igT8E = parcelRequire("igT8E");

var $3fu0P = parcelRequire("3fu0P");
const $564587610d04a137$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $564587610d04a137$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $564587610d04a137$var$_0n = BigInt(0);
const $564587610d04a137$var$_1n = BigInt(1);
const $564587610d04a137$var$_2n = BigInt(2);
const $564587610d04a137$var$divNearest = (a, b)=>(a + b / $564587610d04a137$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $564587610d04a137$var$sqrtMod(y) {
    const P = $564587610d04a137$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $eyPLr.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $eyPLr.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $eyPLr.pow2)(b9, $564587610d04a137$var$_2n, P) * b2 % P;
    const b22 = (0, $eyPLr.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $eyPLr.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $eyPLr.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $eyPLr.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $eyPLr.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $eyPLr.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $eyPLr.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $eyPLr.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $eyPLr.pow2)(t2, $564587610d04a137$var$_2n, P);
    if (!$564587610d04a137$var$Fpk1.eql($564587610d04a137$var$Fpk1.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $564587610d04a137$var$Fpk1 = (0, $eyPLr.Field)($564587610d04a137$var$secp256k1P, undefined, undefined, {
    sqrt: $564587610d04a137$var$sqrtMod
});
const $564587610d04a137$export$529e6123e9353a90 = (0, $2Dyck.createCurve)({
    a: $564587610d04a137$var$_0n,
    b: BigInt(7),
    Fp: $564587610d04a137$var$Fpk1,
    n: $564587610d04a137$var$secp256k1N,
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    endo: {
        // Endomorphism, see above
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $564587610d04a137$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$564587610d04a137$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $564587610d04a137$var$divNearest(b2 * k, n);
            const c2 = $564587610d04a137$var$divNearest(-b1 * k, n);
            let k1 = (0, $eyPLr.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $eyPLr.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, (0, $2UD1v.sha256));
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $564587610d04a137$var$TAGGED_HASH_PREFIXES = {};
function $564587610d04a137$var$taggedHash(tag, ...messages) {
    let tagP = $564587610d04a137$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $2UD1v.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $igT8E.concatBytes)(tagH, tagH);
        $564587610d04a137$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $2UD1v.sha256)((0, $igT8E.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $564587610d04a137$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $564587610d04a137$var$numTo32b = (n)=>(0, $igT8E.numberToBytesBE)(n, 32);
const $564587610d04a137$var$modP = (x)=>(0, $eyPLr.mod)(x, $564587610d04a137$var$secp256k1P);
const $564587610d04a137$var$modN = (x)=>(0, $eyPLr.mod)(x, $564587610d04a137$var$secp256k1N);
const $564587610d04a137$var$Point = /* @__PURE__ */ (()=>$564587610d04a137$export$529e6123e9353a90.ProjectivePoint)();
const $564587610d04a137$var$GmulAdd = (Q, a, b)=>$564587610d04a137$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $564587610d04a137$var$schnorrGetExtPubKey(priv) {
    let d_ = $564587610d04a137$export$529e6123e9353a90.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $564587610d04a137$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $564587610d04a137$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $564587610d04a137$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $564587610d04a137$var$lift_x(x) {
    (0, $igT8E.aInRange)("x", x, $564587610d04a137$var$_1n, $564587610d04a137$var$secp256k1P); // Fail if x ≥ p.
    const xx = $564587610d04a137$var$modP(x * x);
    const c = $564587610d04a137$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $564587610d04a137$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $564587610d04a137$var$_2n !== $564587610d04a137$var$_0n) y = $564587610d04a137$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $564587610d04a137$var$Point(x, y, $564587610d04a137$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
const $564587610d04a137$var$num = (0, $igT8E.bytesToNumberBE);
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $564587610d04a137$var$challenge(...args) {
    return $564587610d04a137$var$modN($564587610d04a137$var$num($564587610d04a137$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $564587610d04a137$var$schnorrGetPublicKey(privateKey) {
    return $564587610d04a137$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $564587610d04a137$var$schnorrSign(message, privateKey, auxRand = (0, $7MXpH.randomBytes)(32)) {
    const m = (0, $igT8E.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $564587610d04a137$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $igT8E.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $564587610d04a137$var$numTo32b(d ^ $564587610d04a137$var$num($564587610d04a137$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $564587610d04a137$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $564587610d04a137$var$modN($564587610d04a137$var$num(rand)); // Let k' = int(rand) mod n
    if (k_ === $564587610d04a137$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $564587610d04a137$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $564587610d04a137$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($564587610d04a137$var$numTo32b($564587610d04a137$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$564587610d04a137$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $564587610d04a137$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $igT8E.ensureBytes)("signature", signature, 64);
    const m = (0, $igT8E.ensureBytes)("message", message);
    const pub = (0, $igT8E.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $564587610d04a137$var$lift_x($564587610d04a137$var$num(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = $564587610d04a137$var$num(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!(0, $igT8E.inRange)(r, $564587610d04a137$var$_1n, $564587610d04a137$var$secp256k1P)) return false;
        const s = $564587610d04a137$var$num(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!(0, $igT8E.inRange)(s, $564587610d04a137$var$_1n, $564587610d04a137$var$secp256k1N)) return false;
        const e = $564587610d04a137$var$challenge($564587610d04a137$var$numTo32b(r), $564587610d04a137$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $564587610d04a137$var$GmulAdd(P, s, $564587610d04a137$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
const $564587610d04a137$export$1f2401df071be9f = /* @__PURE__ */ (()=>({
        getPublicKey: $564587610d04a137$var$schnorrGetPublicKey,
        sign: $564587610d04a137$var$schnorrSign,
        verify: $564587610d04a137$var$schnorrVerify,
        utils: {
            randomPrivateKey: $564587610d04a137$export$529e6123e9353a90.utils.randomPrivateKey,
            lift_x: $564587610d04a137$var$lift_x,
            pointToBytes: $564587610d04a137$var$pointToBytes,
            numberToBytesBE: $igT8E.numberToBytesBE,
            bytesToNumberBE: $igT8E.bytesToNumberBE,
            taggedHash: $564587610d04a137$var$taggedHash,
            mod: $eyPLr.mod
        }
    }))();
const $564587610d04a137$var$isoMap = /* @__PURE__ */ (()=>(0, $fNnAT.isogenyMap)($564587610d04a137$var$Fpk1, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $564587610d04a137$var$mapSWU = /* @__PURE__ */ (()=>(0, $3fu0P.mapToCurveSimpleSWU)($564587610d04a137$var$Fpk1, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $564587610d04a137$var$Fpk1.create(BigInt("-11"))
    }))();
const $564587610d04a137$export$e7a33585c78e532a = /* @__PURE__ */ (()=>(0, $fNnAT.createHasher)($564587610d04a137$export$529e6123e9353a90.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $564587610d04a137$var$mapSWU($564587610d04a137$var$Fpk1.create(scalars[0]));
        return $564587610d04a137$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $564587610d04a137$var$Fpk1.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $2UD1v.sha256)
    }))();
const $564587610d04a137$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$564587610d04a137$export$e7a33585c78e532a.hashToCurve)();
const $564587610d04a137$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$564587610d04a137$export$e7a33585c78e532a.encodeToCurve)();

});
parcelRegister("2Dyck", function(module, exports) {

$parcel$export(module.exports, "createCurve", () => $1eb9c04277b23cc1$export$3f2f6721dd02558a);
/**
 * Utilities for short weierstrass curves, combined with noble-hashes.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $iU0BM = parcelRequire("iU0BM");

var $7MXpH = parcelRequire("7MXpH");

var $3fu0P = parcelRequire("3fu0P");
function $1eb9c04277b23cc1$export$adaba664e531641c(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $iU0BM.hmac)(hash, key, (0, $7MXpH.concatBytes)(...msgs)),
        randomBytes: $7MXpH.randomBytes
    };
}
function $1eb9c04277b23cc1$export$3f2f6721dd02558a(curveDef, defHash) {
    const create = (hash)=>(0, $3fu0P.weierstrass)({
            ...curveDef,
            ...$1eb9c04277b23cc1$export$adaba664e531641c(hash)
        });
    return {
        ...create(defHash),
        create: create
    };
}

});
parcelRegister("iU0BM", function(module, exports) {

$parcel$export(module.exports, "hmac", () => $dc2dedc47c8d07bf$export$355af40f8ab02f34);
/**
 * HMAC: RFC2104 message authentication code.
 * @module
 */ 
var $7MXpH = parcelRequire("7MXpH");
class $dc2dedc47c8d07bf$export$7b9cf41ebec74f45 extends (0, $7MXpH.Hash) {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $7MXpH.ahash)(hash);
        const key = (0, $7MXpH.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        (0, $7MXpH.clean)(pad);
    }
    update(buf) {
        (0, $7MXpH.aexists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $7MXpH.aexists)(this);
        (0, $7MXpH.abytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
const $dc2dedc47c8d07bf$export$355af40f8ab02f34 = (hash, key, message)=>new $dc2dedc47c8d07bf$export$7b9cf41ebec74f45(hash, key).update(message).digest();
$dc2dedc47c8d07bf$export$355af40f8ab02f34.create = (hash, key)=>new $dc2dedc47c8d07bf$export$7b9cf41ebec74f45(hash, key);

});

parcelRegister("3fu0P", function(module, exports) {

$parcel$export(module.exports, "weierstrass", () => $25da0da8ee998e43$export$350b8ea6f1c27fae);
$parcel$export(module.exports, "mapToCurveSimpleSWU", () => $25da0da8ee998e43$export$cc7fea9756a17416);
/**
 * Short Weierstrass curve methods. The formula is: y² = x³ + ax + b.
 *
 * ### Parameters
 *
 * To initialize a weierstrass curve, one needs to pass following params:
 *
 * * a: formula param
 * * b: formula param
 * * Fp: finite field of prime characteristic P; may be complex (Fp2). Arithmetics is done in field
 * * n: order of prime subgroup a.k.a total amount of valid curve points
 * * Gx: Base point (x, y) aka generator point. Gx = x coordinate
 * * Gy: ...y coordinate
 * * h: cofactor, usually 1. h*n = curve group order (n is only subgroup order)
 * * lowS: whether to enable (default) or disable "low-s" non-malleable signatures
 *
 * ### Design rationale for types
 *
 * * Interaction between classes from different curves should fail:
 *   `k256.Point.BASE.add(p256.Point.BASE)`
 * * For this purpose we want to use `instanceof` operator, which is fast and works during runtime
 * * Different calls of `curve()` would return different classes -
 *   `curve(params) !== curve(params)`: if somebody decided to monkey-patch their curve,
 *   it won't affect others
 *
 * TypeScript can't infer types for classes created inside a function. Classes is one instance
 * of nominative types in TypeScript and interfaces only check for shape, so it's hard to create
 * unique type for every function call.
 *
 * We can use generic types via some param, like curve opts, but that would:
 *     1. Enable interaction between `curve(params)` and `curve(params)` (curves of same params)
 *     which is hard to debug.
 *     2. Params can be generic and we can't enforce them to be constant value:
 *     if somebody creates curve from non-constant params,
 *     it would be allowed to interact with other curves with non-constant params
 *
 * @todo https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-7.html#unique-symbol
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // prettier-ignore

var $3hdCU = parcelRequire("3hdCU");

var $eyPLr = parcelRequire("eyPLr");

var $igT8E = parcelRequire("igT8E");
function $25da0da8ee998e43$var$validateSigVerOpts(opts) {
    if (opts.lowS !== undefined) (0, $igT8E.abool)("lowS", opts.lowS);
    if (opts.prehash !== undefined) (0, $igT8E.abool)("prehash", opts.prehash);
}
function $25da0da8ee998e43$var$validatePointOpts(curve) {
    const opts = (0, $3hdCU.validateBasic)(curve);
    (0, $igT8E.validateObject)(opts, {
        a: "field",
        b: "field"
    }, {
        allowInfinityPoint: "boolean",
        allowedPrivateKeyLengths: "array",
        clearCofactor: "function",
        fromBytes: "function",
        isTorsionFree: "function",
        toBytes: "function",
        wrapPrivateKey: "boolean"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("invalid endo: CURVE.a must be 0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error('invalid endo: expected "beta": bigint and "splitScalar": function');
    }
    return Object.freeze({
        ...opts
    });
}
class $25da0da8ee998e43$export$523a36accd0afb37 extends Error {
    constructor(m = ""){
        super(m);
    }
}
const $25da0da8ee998e43$export$56ac33195d7076db = {
    // asn.1 DER encoding utils
    Err: $25da0da8ee998e43$export$523a36accd0afb37,
    // Basic building block is TLV (Tag-Length-Value)
    _tlv: {
        encode: (tag, data)=>{
            const { Err: E } = $25da0da8ee998e43$export$56ac33195d7076db;
            if (tag < 0 || tag > 256) throw new E("tlv.encode: wrong tag");
            if (data.length & 1) throw new E("tlv.encode: unpadded data");
            const dataLen = data.length / 2;
            const len = (0, $igT8E.numberToHexUnpadded)(dataLen);
            if (len.length / 2 & 128) throw new E("tlv.encode: long form length too big");
            // length of length with long form flag
            const lenLen = dataLen > 127 ? (0, $igT8E.numberToHexUnpadded)(len.length / 2 | 128) : "";
            const t = (0, $igT8E.numberToHexUnpadded)(tag);
            return t + lenLen + len + data;
        },
        // v - value, l - left bytes (unparsed)
        decode (tag, data) {
            const { Err: E } = $25da0da8ee998e43$export$56ac33195d7076db;
            let pos = 0;
            if (tag < 0 || tag > 256) throw new E("tlv.encode: wrong tag");
            if (data.length < 2 || data[pos++] !== tag) throw new E("tlv.decode: wrong tlv");
            const first = data[pos++];
            const isLong = !!(first & 128); // First bit of first length byte is flag for short/long form
            let length = 0;
            if (!isLong) length = first;
            else {
                // Long form: [longFlag(1bit), lengthLength(7bit), length (BE)]
                const lenLen = first & 127;
                if (!lenLen) throw new E("tlv.decode(long): indefinite length not supported");
                if (lenLen > 4) throw new E("tlv.decode(long): byte length is too big"); // this will overflow u32 in js
                const lengthBytes = data.subarray(pos, pos + lenLen);
                if (lengthBytes.length !== lenLen) throw new E("tlv.decode: length bytes not complete");
                if (lengthBytes[0] === 0) throw new E("tlv.decode(long): zero leftmost byte");
                for (const b of lengthBytes)length = length << 8 | b;
                pos += lenLen;
                if (length < 128) throw new E("tlv.decode(long): not minimal encoding");
            }
            const v = data.subarray(pos, pos + length);
            if (v.length !== length) throw new E("tlv.decode: wrong value length");
            return {
                v: v,
                l: data.subarray(pos + length)
            };
        }
    },
    // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
    // since we always use positive integers here. It must always be empty:
    // - add zero byte if exists
    // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
    _int: {
        encode (num) {
            const { Err: E } = $25da0da8ee998e43$export$56ac33195d7076db;
            if (num < $25da0da8ee998e43$var$_0n) throw new E("integer: negative integers are not allowed");
            let hex = (0, $igT8E.numberToHexUnpadded)(num);
            // Pad with zero byte if negative flag is present
            if (Number.parseInt(hex[0], 16) & 8) hex = "00" + hex;
            if (hex.length & 1) throw new E("unexpected DER parsing assertion: unpadded hex");
            return hex;
        },
        decode (data) {
            const { Err: E } = $25da0da8ee998e43$export$56ac33195d7076db;
            if (data[0] & 128) throw new E("invalid signature integer: negative");
            if (data[0] === 0x00 && !(data[1] & 128)) throw new E("invalid signature integer: unnecessary leading zero");
            return (0, $igT8E.bytesToNumberBE)(data);
        }
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E, _int: int, _tlv: tlv } = $25da0da8ee998e43$export$56ac33195d7076db;
        const data = (0, $igT8E.ensureBytes)("signature", hex);
        const { v: seqBytes, l: seqLeftBytes } = tlv.decode(0x30, data);
        if (seqLeftBytes.length) throw new E("invalid signature: left bytes after parsing");
        const { v: rBytes, l: rLeftBytes } = tlv.decode(0x02, seqBytes);
        const { v: sBytes, l: sLeftBytes } = tlv.decode(0x02, rLeftBytes);
        if (sLeftBytes.length) throw new E("invalid signature: left bytes after parsing");
        return {
            r: int.decode(rBytes),
            s: int.decode(sBytes)
        };
    },
    hexFromSig (sig) {
        const { _tlv: tlv, _int: int } = $25da0da8ee998e43$export$56ac33195d7076db;
        const rs = tlv.encode(0x02, int.encode(sig.r));
        const ss = tlv.encode(0x02, int.encode(sig.s));
        const seq = rs + ss;
        return tlv.encode(0x30, seq);
    }
};
function $25da0da8ee998e43$var$numToSizedHex(num, size) {
    return (0, $igT8E.bytesToHex)((0, $igT8E.numberToBytesBE)(num, size));
}
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $25da0da8ee998e43$var$_0n = BigInt(0), $25da0da8ee998e43$var$_1n = BigInt(1), $25da0da8ee998e43$var$_2n = BigInt(2), $25da0da8ee998e43$var$_3n = BigInt(3), $25da0da8ee998e43$var$_4n = BigInt(4);
function $25da0da8ee998e43$export$fa783af82e4fe0fc(opts) {
    const CURVE = $25da0da8ee998e43$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const Fn = (0, $eyPLr.Field)(CURVE.n, CURVE.nBitLength);
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return (0, $igT8E.concatBytes)(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula. Takes x, returns y².
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x² * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x³ + a * x + b
    }
    function isValidXY(x, y) {
        const left = Fp.sqr(y); // y²
        const right = weierstrassEquation(x); // x³ + ax + b
        return Fp.eql(left, right);
    }
    // Validate whether the passed curve params are valid.
    // Test 1: equation y² = x³ + ax + b should work for generator point.
    if (!isValidXY(CURVE.Gx, CURVE.Gy)) throw new Error("bad curve params: generator point");
    // Test 2: discriminant Δ part should be non-zero: 4a³ + 27b² != 0.
    // Guarantees curve is genus-1, smooth (non-singular).
    const _4a3 = Fp.mul(Fp.pow(CURVE.a, $25da0da8ee998e43$var$_3n), $25da0da8ee998e43$var$_4n);
    const _27b2 = Fp.mul(Fp.sqr(CURVE.b), BigInt(27));
    if (Fp.is0(Fp.add(_4a3, _27b2))) throw new Error("bad curve params: a or b");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return (0, $igT8E.inRange)(num, $25da0da8ee998e43$var$_1n, CURVE.n);
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: N } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if ((0, $igT8E.isBytes)(key)) key = (0, $igT8E.bytesToHex)(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("invalid private key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : (0, $igT8E.bytesToNumberBE)((0, $igT8E.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error("invalid private key, expected hex or " + nByteLength + " bytes, got " + typeof key);
        }
        if (wrapPrivateKey) num = (0, $eyPLr.mod)(num, N); // disabled by default, enabled for BLS
        (0, $igT8E.aInRange)("private key", num, $25da0da8ee998e43$var$_1n, N); // num in range [1..N-1]
        return num;
    }
    function aprjpoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    // Memoized toAffine / validity check. They are heavy. Points are immutable.
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (X, Y, Z) ∋ (x=X/Z, y=Y/Z)
    const toAffineMemo = (0, $igT8E.memoized)((p, iz)=>{
        const { px: x, py: y, pz: z } = p;
        // Fast-path for normalized points
        if (Fp.eql(z, Fp.ONE)) return {
            x: x,
            y: y
        };
        const is0 = p.is0();
        // If invZ was 0, we return zero point. However we still want to execute
        // all operations, so we replace invZ with a random number, 1.
        if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
        const ax = Fp.mul(x, iz);
        const ay = Fp.mul(y, iz);
        const zz = Fp.mul(z, iz);
        if (is0) return {
            x: Fp.ZERO,
            y: Fp.ZERO
        };
        if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
        return {
            x: ax,
            y: ay
        };
    });
    // NOTE: on exception this will crash 'cached' and no value will be set.
    // Otherwise true will be return
    const assertValidMemo = (0, $igT8E.memoized)((p)=>{
        if (p.is0()) {
            // (0, 1, 0) aka ZERO is invalid in most contexts.
            // In BLS, ZERO can be serialized, so we allow it.
            // (0, 0, 0) is invalid representation of ZERO.
            if (CURVE.allowInfinityPoint && !Fp.is0(p.py)) return;
            throw new Error("bad point: ZERO");
        }
        // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
        const { x: x, y: y } = p.toAffine();
        // Check if x, y are valid field elements
        if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
        if (!isValidXY(x, y)) throw new Error("bad point: equation left != right");
        if (!p.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        return true;
    });
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (X, Y, Z) ∋ (x=X/Z, y=Y/Z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py) || Fp.is0(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
            this.px = px;
            this.py = py;
            this.pz = pz;
            Object.freeze(this);
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = (0, $eyPLr.FpInvertBatch)(Fp, points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $igT8E.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // Multiscalar Multiplication
        static msm(points, scalars) {
            return (0, $3hdCU.pippenger)(Point, Fn, points, scalars);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            wnaf.setWindowSize(this, windowSize);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            assertValidMemo(this);
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            aprjpoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $25da0da8ee998e43$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            aprjpoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $25da0da8ee998e43$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, n, Point.normalizeZ);
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(sc) {
            const { endo: endo, n: N } = CURVE;
            (0, $igT8E.aInRange)("scalar", sc, $25da0da8ee998e43$var$_0n, N);
            const I = Point.ZERO;
            if (sc === $25da0da8ee998e43$var$_0n) return I;
            if (this.is0() || sc === $25da0da8ee998e43$var$_1n) return this;
            // Case a: no endomorphism. Case b: has precomputes.
            if (!endo || wnaf.hasPrecomputes(this)) return wnaf.wNAFCachedUnsafe(this, sc, Point.normalizeZ);
            // Case c: endomorphism
            /** See docs for {@link EndomorphismOpts} */ let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(sc);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $25da0da8ee998e43$var$_0n || k2 > $25da0da8ee998e43$var$_0n){
                if (k1 & $25da0da8ee998e43$var$_1n) k1p = k1p.add(d);
                if (k2 & $25da0da8ee998e43$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $25da0da8ee998e43$var$_1n;
                k2 >>= $25da0da8ee998e43$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            const { endo: endo, n: N } = CURVE;
            (0, $igT8E.aInRange)("scalar", scalar, $25da0da8ee998e43$var$_1n, N);
            let point, fake; // Fake point is used to const-time mult
            /** See docs for {@link EndomorphismOpts} */ if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(scalar);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(scalar);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $25da0da8ee998e43$var$_0n || a === $25da0da8ee998e43$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            return toAffineMemo(this, iz);
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $25da0da8ee998e43$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $25da0da8ee998e43$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            (0, $igT8E.abool)("isCompressed", isCompressed);
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            (0, $igT8E.abool)("isCompressed", isCompressed);
            return (0, $igT8E.bytesToHex)(this.toRawBytes(isCompressed));
        }
    }
    // base / generator point
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    // zero / infinity / identity point
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO); // 0, 1, 0
    const { endo: endo, nBitLength: nBitLength } = CURVE;
    const wnaf = (0, $3hdCU.wNAF)(Point, endo ? Math.ceil(nBitLength / 2) : nBitLength);
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
function $25da0da8ee998e43$var$validateOpts(curve) {
    const opts = (0, $3hdCU.validateBasic)(curve);
    (0, $igT8E.validateObject)(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $25da0da8ee998e43$export$350b8ea6f1c27fae(curveDef) {
    const CURVE = $25da0da8ee998e43$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER, nByteLength: nByteLength, nBitLength: nBitLength } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function modN(a) {
        return (0, $eyPLr.mod)(a, CURVE_ORDER);
    }
    function invN(a) {
        return (0, $eyPLr.invert)(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $25da0da8ee998e43$export$fa783af82e4fe0fc({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = (0, $igT8E.concatBytes);
            (0, $igT8E.abool)("isCompressed", isCompressed);
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = (0, $igT8E.bytesToNumberBE)(tail);
                if (!(0, $igT8E.inRange)(x, $25da0da8ee998e43$var$_1n, Fp.ORDER)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y;
                try {
                    y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                } catch (sqrtError) {
                    const suffix = sqrtError instanceof Error ? ": " + sqrtError.message : "";
                    throw new Error("Point is not on curve" + suffix);
                }
                const isYOdd = (y & $25da0da8ee998e43$var$_1n) === $25da0da8ee998e43$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else {
                const cl = compressedLen;
                const ul = uncompressedLen;
                throw new Error("invalid Point, expected length of " + cl + ", or uncompressed " + ul + ", got " + len);
            }
        }
    });
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $25da0da8ee998e43$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>(0, $igT8E.bytesToNumberBE)(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            (0, $igT8E.aInRange)("r", r, $25da0da8ee998e43$var$_1n, CURVE_ORDER); // r in [1..N]
            (0, $igT8E.aInRange)("s", s, $25da0da8ee998e43$var$_1n, CURVE_ORDER); // s in [1..N]
            this.r = r;
            this.s = s;
            if (recovery != null) this.recovery = recovery;
            Object.freeze(this);
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = nByteLength;
            hex = (0, $igT8E.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $25da0da8ee998e43$export$56ac33195d7076db.toSig((0, $igT8E.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        /**
         * @todo remove
         * @deprecated
         */ assertValidity() {}
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $igT8E.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + $25da0da8ee998e43$var$numToSizedHex(radj, Fp.BYTES));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return (0, $igT8E.hexToBytes)(this.toDERHex());
        }
        toDERHex() {
            return $25da0da8ee998e43$export$56ac33195d7076db.hexFromSig(this);
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return (0, $igT8E.hexToBytes)(this.toCompactHex());
        }
        toCompactHex() {
            const l = nByteLength;
            return $25da0da8ee998e43$var$numToSizedHex(this.r, l) + $25da0da8ee998e43$var$numToSizedHex(this.s, l);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = (0, $eyPLr.getMinHashLength)(CURVE.n);
            return (0, $eyPLr.mapHashToField)(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        if (typeof item === "bigint") return false;
        if (item instanceof Point) return true;
        const arr = (0, $igT8E.ensureBytes)("key", item);
        const len = arr.length;
        const fpl = Fp.BYTES;
        const compLen = fpl + 1; // e.g. 33 for 32
        const uncompLen = 2 * fpl + 1; // e.g. 65 for 32
        if (CURVE.allowedPrivateKeyLengths || nByteLength === compLen) return undefined;
        else return len === compLen || len === uncompLen;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA) === true) throw new Error("first arg must be private key");
        if (isProbPub(publicB) === false) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // Our custom check "just in case", for protection against DoS
        if (bytes.length > 8192) throw new Error("input is too large");
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = (0, $igT8E.bytesToNumberBE)(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = (0, $igT8E.bitMask)(nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        (0, $igT8E.aInRange)("num < 2^" + nBitLength, num, $25da0da8ee998e43$var$_0n, ORDER_MASK);
        // works with order, can have different size than numToField!
        return (0, $igT8E.numberToBytesBE)(num, nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order,
    // this will be invalid at least for P521. Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $igT8E.ensureBytes)("msgHash", msgHash);
        $25da0da8ee998e43$var$validateSigVerOpts(opts);
        if (prehash) msgHash = (0, $igT8E.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null && ent !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $igT8E.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = (0, $igT8E.concatBytes)(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $25da0da8ee998e43$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $25da0da8ee998e43$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $25da0da8ee998e43$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = (0, $igT8E.createHmacDrbg)(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $igT8E.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $igT8E.ensureBytes)("publicKey", publicKey);
        const { lowS: lowS, prehash: prehash, format: format } = opts;
        // Verify opts, deduce signature format
        $25da0da8ee998e43$var$validateSigVerOpts(opts);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        if (format !== undefined && format !== "compact" && format !== "der") throw new Error("format must be compact or der");
        const isHex = typeof sg === "string" || (0, $igT8E.isBytes)(sg);
        const isObj = !isHex && !format && typeof sg === "object" && sg !== null && typeof sg.r === "bigint" && typeof sg.s === "bigint";
        if (!isHex && !isObj) throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
        let _sig = undefined;
        let P;
        try {
            if (isObj) _sig = new Signature(sg.r, sg.s);
            if (isHex) {
                // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
                // Since DER can also be 2*nByteLength bytes, we check for it first.
                try {
                    if (format !== "compact") _sig = Signature.fromDER(sg);
                } catch (derError) {
                    if (!(derError instanceof $25da0da8ee998e43$export$56ac33195d7076db.Err)) throw derError;
                }
                if (!_sig && format !== "der") _sig = Signature.fromCompact(sg);
            }
            P = Point.fromHex(publicKey);
        } catch (error) {
            return false;
        }
        if (!_sig) return false;
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
function $25da0da8ee998e43$export$8324ae9483e33241(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $25da0da8ee998e43$var$_0n;
    for(let o = q - $25da0da8ee998e43$var$_1n; o % $25da0da8ee998e43$var$_2n === $25da0da8ee998e43$var$_0n; o /= $25da0da8ee998e43$var$_2n)l += $25da0da8ee998e43$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $25da0da8ee998e43$var$_2n << c1 - $25da0da8ee998e43$var$_1n - $25da0da8ee998e43$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $25da0da8ee998e43$var$_2n;
    const c2 = (q - $25da0da8ee998e43$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $25da0da8ee998e43$var$_1n) / $25da0da8ee998e43$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $25da0da8ee998e43$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $25da0da8ee998e43$var$_1n) / $25da0da8ee998e43$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $25da0da8ee998e43$var$_1n; i--){
            let tv5 = i - $25da0da8ee998e43$var$_2n; // 18.    tv5 = i - 2
            tv5 = $25da0da8ee998e43$var$_2n << tv5 - $25da0da8ee998e43$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $25da0da8ee998e43$var$_4n === $25da0da8ee998e43$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $25da0da8ee998e43$var$_3n) / $25da0da8ee998e43$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
function $25da0da8ee998e43$export$cc7fea9756a17416(Fp, opts) {
    (0, $eyPLr.validateField)(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $25da0da8ee998e43$export$8324ae9483e33241(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        const tv4_inv = (0, $eyPLr.FpInvertBatch)(Fp, [
            tv4
        ], true)[0];
        x = Fp.mul(x, tv4_inv); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}

});


parcelRegister("fNnAT", function(module, exports) {

$parcel$export(module.exports, "expand_message_xmd", () => $02f7b4944da05780$export$3df78c69af9fc85d);
$parcel$export(module.exports, "isogenyMap", () => $02f7b4944da05780$export$9393380cf1075f28);
$parcel$export(module.exports, "createHasher", () => $02f7b4944da05780$export$14b114effbc08b6b);

var $eyPLr = parcelRequire("eyPLr");

var $igT8E = parcelRequire("igT8E");
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $02f7b4944da05780$var$os2ip = (0, $igT8E.bytesToNumberBE);
// Integer to Octet Stream (numberToBytesBE)
function $02f7b4944da05780$var$i2osp(value, length) {
    $02f7b4944da05780$var$anum(value);
    $02f7b4944da05780$var$anum(length);
    if (value < 0 || value >= 1 << 8 * length) throw new Error("invalid I2OSP input: " + value);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $02f7b4944da05780$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $02f7b4944da05780$var$anum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
function $02f7b4944da05780$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    (0, $igT8E.abytes)(msg);
    (0, $igT8E.abytes)(DST);
    $02f7b4944da05780$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $igT8E.concatBytes)((0, $igT8E.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (lenInBytes > 65535 || ell > 255) throw new Error("expand_message_xmd: invalid lenInBytes");
    const DST_prime = (0, $igT8E.concatBytes)(DST, $02f7b4944da05780$var$i2osp(DST.length, 1));
    const Z_pad = $02f7b4944da05780$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $02f7b4944da05780$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $igT8E.concatBytes)(Z_pad, msg, l_i_b_str, $02f7b4944da05780$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $igT8E.concatBytes)(b_0, $02f7b4944da05780$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $02f7b4944da05780$var$strxor(b_0, b[i - 1]),
            $02f7b4944da05780$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $igT8E.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $igT8E.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $02f7b4944da05780$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    (0, $igT8E.abytes)(msg);
    (0, $igT8E.abytes)(DST);
    $02f7b4944da05780$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $igT8E.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($02f7b4944da05780$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($02f7b4944da05780$var$i2osp(DST.length, 1)).digest();
}
function $02f7b4944da05780$export$97cdd5ee18de8172(msg, count, options) {
    (0, $igT8E.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    (0, $igT8E.abytes)(msg);
    $02f7b4944da05780$var$anum(count);
    const DST = typeof _DST === "string" ? (0, $igT8E.utf8ToBytes)(_DST) : _DST;
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $02f7b4944da05780$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $02f7b4944da05780$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $eyPLr.mod)($02f7b4944da05780$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $02f7b4944da05780$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    const coeff = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xn, xd, yn, yd] = coeff.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        // 6.6.3
        // Exceptional cases of iso_map are inputs that cause the denominator of
        // either rational function to evaluate to zero; such cases MUST return
        // the identity point on E.
        const [xd_inv, yd_inv] = (0, $eyPLr.FpInvertBatch)(field, [
            xd,
            yd
        ], true);
        x = field.mul(xn, xd_inv); // xNum / xDen
        y = field.mul(y, field.mul(yn, yd_inv)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
function $02f7b4944da05780$export$14b114effbc08b6b(Point, mapToCurve, defaults) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    function map(num) {
        return Point.fromAffine(mapToCurve(num));
    }
    function clear(initial) {
        const P = initial.clearCofactor();
        if (P.equals(Point.ZERO)) return Point.ZERO; // zero will throw in assert
        P.assertValidity();
        return P;
    }
    return {
        defaults: defaults,
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $02f7b4944da05780$export$97cdd5ee18de8172(msg, 2, {
                ...defaults,
                DST: defaults.DST,
                ...options
            });
            const u0 = map(u[0]);
            const u1 = map(u[1]);
            return clear(u0.add(u1));
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $02f7b4944da05780$export$97cdd5ee18de8172(msg, 1, {
                ...defaults,
                DST: defaults.encodeDST,
                ...options
            });
            return clear(map(u[0]));
        },
        // Same as encodeToCurve, but without hash
        mapToCurve (scalars) {
            if (!Array.isArray(scalars)) throw new Error("expected array of bigints");
            for (const i of scalars)if (typeof i !== "bigint") throw new Error("expected array of bigints");
            return clear(map(scalars));
        }
    };
}

});


parcelRegister("02Twl", function(module, exports) {
"use strict";
var $008b4143525e723b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenSigner = module.exports.createUnsecuredToken = void 0;

var $aT9GC = parcelRequire("aT9GC");

var $ccACr = parcelRequire("ccACr");

var $kDPfV = parcelRequire("kDPfV");

var $kRrbd = parcelRequire("kRrbd");
function $008b4143525e723b$var$createSigningInput(payload, header) {
    const tokenParts = [];
    // add in the header
    const encodedHeader = $aT9GC.encode(JSON.stringify(header));
    tokenParts.push(encodedHeader);
    // add in the payload
    const encodedPayload = $aT9GC.encode(JSON.stringify(payload));
    tokenParts.push(encodedPayload);
    // prepare the message
    const signingInput = tokenParts.join(".");
    // return the signing input
    return signingInput;
}
function $008b4143525e723b$var$createUnsecuredToken(payload) {
    const header = {
        typ: "JWT",
        alg: "none"
    };
    return $008b4143525e723b$var$createSigningInput(payload, header) + ".";
}
module.exports.createUnsecuredToken = $008b4143525e723b$var$createUnsecuredToken;
class $008b4143525e723b$var$TokenSigner {
    constructor(signingAlgorithm, rawPrivateKey){
        if (!(signingAlgorithm && rawPrivateKey)) throw new $kDPfV.MissingParametersError("a signing algorithm and private key are required");
        if (typeof signingAlgorithm !== "string") throw new Error("signing algorithm parameter must be a string");
        signingAlgorithm = signingAlgorithm.toUpperCase();
        if (!$ccACr.cryptoClients.hasOwnProperty(signingAlgorithm)) throw new Error("invalid signing algorithm");
        this.tokenType = "JWT";
        this.cryptoClient = $ccACr.cryptoClients[signingAlgorithm];
        this.rawPrivateKey = rawPrivateKey;
    }
    header(header = {}) {
        const defaultHeader = {
            typ: this.tokenType,
            alg: this.cryptoClient.algorithmName
        };
        return Object.assign({}, defaultHeader, header);
    }
    sign(payload, expanded = false, customHeader = {}) {
        // generate the token header
        const header = this.header(customHeader);
        // prepare the message to be signed
        const signingInput = $008b4143525e723b$var$createSigningInput(payload, header);
        const signingInputHash = (0, $kRrbd.hashSha256)(signingInput);
        return this.createWithSignedHash(payload, expanded, header, signingInput, signingInputHash);
    }
    signAsync(payload, expanded = false, customHeader = {}) {
        return $008b4143525e723b$var$__awaiter(this, void 0, void 0, function*() {
            // generate the token header
            const header = this.header(customHeader);
            // prepare the message to be signed
            const signingInput = $008b4143525e723b$var$createSigningInput(payload, header);
            const signingInputHash = yield (0, $kRrbd.hashSha256Async)(signingInput);
            return this.createWithSignedHash(payload, expanded, header, signingInput, signingInputHash);
        });
    }
    createWithSignedHash(payload, expanded, header, signingInput, signingInputHash) {
        // sign the message and add in the signature
        const signature = this.cryptoClient.signHash(signingInputHash, this.rawPrivateKey);
        if (expanded) {
            const signedToken = {
                header: [
                    $aT9GC.encode(JSON.stringify(header))
                ],
                payload: JSON.stringify(payload),
                signature: [
                    signature
                ]
            };
            return signedToken;
        } else return [
            signingInput,
            signature
        ].join(".");
    }
}
module.exports.TokenSigner = $008b4143525e723b$var$TokenSigner;

});
parcelRegister("aT9GC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decode = module.exports.encode = module.exports.unescape = module.exports.escape = module.exports.pad = void 0;

var $gKBU6 = parcelRequire("gKBU6");
function $7ed68df340ff9bc3$var$pad(base64) {
    return `${base64}${"=".repeat(4 - (base64.length % 4 || 4))}`;
}
module.exports.pad = $7ed68df340ff9bc3$var$pad;
function $7ed68df340ff9bc3$var$escape(base64) {
    return base64.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
module.exports.escape = $7ed68df340ff9bc3$var$escape;
function $7ed68df340ff9bc3$var$unescape(base64Url) {
    return $7ed68df340ff9bc3$var$pad(base64Url).replace(/-/g, "+").replace(/_/g, "/");
}
module.exports.unescape = $7ed68df340ff9bc3$var$unescape;
function $7ed68df340ff9bc3$var$encode(base64) {
    return $7ed68df340ff9bc3$var$escape((0, $gKBU6.fromByteArray)(new TextEncoder().encode(base64)));
}
module.exports.encode = $7ed68df340ff9bc3$var$encode;
function $7ed68df340ff9bc3$var$decode(base64Url) {
    return new TextDecoder().decode((0, $gKBU6.toByteArray)($7ed68df340ff9bc3$var$pad($7ed68df340ff9bc3$var$unescape(base64Url))));
}
module.exports.decode = $7ed68df340ff9bc3$var$decode;

});

parcelRegister("ccACr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cryptoClients = module.exports.SECP256K1Client = void 0;

var $Xidbc = parcelRequire("Xidbc");
Object.defineProperty(module.exports, "SECP256K1Client", {
    enumerable: true,
    get: function() {
        return $Xidbc.SECP256K1Client;
    }
});
const $8e2302c886d7d25d$var$cryptoClients = {
    ES256K: $Xidbc.SECP256K1Client
};
module.exports.cryptoClients = $8e2302c886d7d25d$var$cryptoClients;

});
parcelRegister("Xidbc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SECP256K1Client = void 0;

var $1Sm9I = parcelRequire("1Sm9I");

var $hX4ZG = parcelRequire("hX4ZG");

var $7xCMk = parcelRequire("7xCMk");

var $6or2c = parcelRequire("6or2c");

var $kDPfV = parcelRequire("kDPfV");

var $frEr5 = parcelRequire("frEr5");
// required to use noble secp https://github.com/paulmillr/noble-secp256k1
$7xCMk.utils.hmacSha256Sync = (key, ...msgs)=>{
    const h = $1Sm9I.hmac.create($hX4ZG.sha256, key);
    msgs.forEach((msg)=>h.update(msg));
    return h.digest();
};
class $0b23a33deeba53da$var$SECP256K1Client {
    static derivePublicKey(privateKey, compressed = true) {
        if (privateKey.length === 66) privateKey = privateKey.slice(0, 64);
        if (privateKey.length < 64) // backward compatibly accept too short private keys
        privateKey = privateKey.padStart(64, "0");
        return (0, $frEr5.bytesToHex)($7xCMk.getPublicKey(privateKey, compressed));
    }
    static signHash(signingInputHash, privateKey, format = "jose") {
        // make sure the required parameters are provided
        if (!signingInputHash || !privateKey) throw new $kDPfV.MissingParametersError("a signing input hash and private key are all required");
        const derSignature = $7xCMk.signSync(signingInputHash, privateKey.slice(0, 64), {
            der: true,
            canonical: false
        });
        if (format === "der") return (0, $frEr5.bytesToHex)(derSignature);
        if (format === "jose") return (0, $6or2c.derToJose)(derSignature, "ES256");
        throw Error("Invalid signature format");
    }
    static loadSignature(joseSignature) {
        // create and return the DER-formatted signature bytes
        return (0, $6or2c.joseToDer)(joseSignature, "ES256");
    }
    static verifyHash(signingInputHash, derSignatureBytes, publicKey) {
        // make sure the required parameters are provided
        if (!signingInputHash || !derSignatureBytes || !publicKey) throw new $kDPfV.MissingParametersError("a signing input hash, der signature, and public key are all required");
        return $7xCMk.verify(derSignatureBytes, signingInputHash, publicKey, {
            strict: false
        });
    }
}
module.exports.SECP256K1Client = $0b23a33deeba53da$var$SECP256K1Client;
$0b23a33deeba53da$var$SECP256K1Client.algorithmName = "ES256K";

});
parcelRegister("1Sm9I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hmac = module.exports.HMAC = void 0;

var $frEr5 = parcelRequire("frEr5");
class $15dc0545267fe85b$var$HMAC extends $frEr5.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $frEr5.ahash)(hash);
        const key = (0, $frEr5.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        (0, $frEr5.clean)(pad);
    }
    update(buf) {
        (0, $frEr5.aexists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $frEr5.aexists)(this);
        (0, $frEr5.abytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
module.exports.HMAC = $15dc0545267fe85b$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 * @example
 * import { hmac } from '@noble/hashes/hmac';
 * import { sha256 } from '@noble/hashes/sha2';
 * const mac1 = hmac(sha256, 'key', 'message');
 */ const $15dc0545267fe85b$var$hmac = (hash, key, message)=>new $15dc0545267fe85b$var$HMAC(hash, key).update(message).digest();
module.exports.hmac = $15dc0545267fe85b$var$hmac;
module.exports.hmac.create = (hash, key)=>new $15dc0545267fe85b$var$HMAC(hash, key);

});
parcelRegister("frEr5", function(module, exports) {
"use strict";
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.Hash = module.exports.nextTick = module.exports.swap32IfBE = module.exports.byteSwapIfBE = module.exports.swap8IfBE = module.exports.isLE = void 0;
module.exports.isBytes = $b3e8be57daaa948d$var$isBytes;
module.exports.anumber = $b3e8be57daaa948d$var$anumber;
module.exports.abytes = $b3e8be57daaa948d$var$abytes;
module.exports.ahash = $b3e8be57daaa948d$var$ahash;
module.exports.aexists = $b3e8be57daaa948d$var$aexists;
module.exports.aoutput = $b3e8be57daaa948d$var$aoutput;
module.exports.u8 = $b3e8be57daaa948d$var$u8;
module.exports.u32 = $b3e8be57daaa948d$var$u32;
module.exports.clean = $b3e8be57daaa948d$var$clean;
module.exports.createView = $b3e8be57daaa948d$var$createView;
module.exports.rotr = $b3e8be57daaa948d$var$rotr;
module.exports.rotl = $b3e8be57daaa948d$var$rotl;
module.exports.byteSwap = $b3e8be57daaa948d$var$byteSwap;
module.exports.byteSwap32 = $b3e8be57daaa948d$var$byteSwap32;
module.exports.bytesToHex = $b3e8be57daaa948d$var$bytesToHex;
module.exports.hexToBytes = $b3e8be57daaa948d$var$hexToBytes;
module.exports.asyncLoop = $b3e8be57daaa948d$var$asyncLoop;
module.exports.utf8ToBytes = $b3e8be57daaa948d$var$utf8ToBytes;
module.exports.bytesToUtf8 = $b3e8be57daaa948d$var$bytesToUtf8;
module.exports.toBytes = $b3e8be57daaa948d$var$toBytes;
module.exports.kdfInputToBytes = $b3e8be57daaa948d$var$kdfInputToBytes;
module.exports.concatBytes = $b3e8be57daaa948d$var$concatBytes;
module.exports.checkOpts = $b3e8be57daaa948d$var$checkOpts;
module.exports.createHasher = $b3e8be57daaa948d$var$createHasher;
module.exports.createOptHasher = $b3e8be57daaa948d$var$createOptHasher;
module.exports.createXOFer = $b3e8be57daaa948d$var$createXOFer;
module.exports.randomBytes = $b3e8be57daaa948d$var$randomBytes;

var $lvlW2 = parcelRequire("lvlW2");
/** Checks if something is Uint8Array. Be careful: nodejs Buffer will return true. */ function $b3e8be57daaa948d$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
/** Asserts something is positive integer. */ function $b3e8be57daaa948d$var$anumber(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error("positive integer expected, got " + n);
}
/** Asserts something is Uint8Array. */ function $b3e8be57daaa948d$var$abytes(b, ...lengths) {
    if (!$b3e8be57daaa948d$var$isBytes(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error("Uint8Array expected of length " + lengths + ", got length=" + b.length);
}
/** Asserts something is hash */ function $b3e8be57daaa948d$var$ahash(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.createHasher");
    $b3e8be57daaa948d$var$anumber(h.outputLen);
    $b3e8be57daaa948d$var$anumber(h.blockLen);
}
/** Asserts a hash instance has not been destroyed / finished */ function $b3e8be57daaa948d$var$aexists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
/** Asserts output is properly-sized byte array */ function $b3e8be57daaa948d$var$aoutput(out, instance) {
    $b3e8be57daaa948d$var$abytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error("digestInto() expects output buffer of length at least " + min);
}
/** Cast u8 / u16 / u32 to u8. */ function $b3e8be57daaa948d$var$u8(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** Cast u8 / u16 / u32 to u32. */ function $b3e8be57daaa948d$var$u32(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
/** Zeroize a byte array. Warning: JS provides no guarantees. */ function $b3e8be57daaa948d$var$clean(...arrays) {
    for(let i = 0; i < arrays.length; i++)arrays[i].fill(0);
}
/** Create DataView of an array for easy byte-level manipulation. */ function $b3e8be57daaa948d$var$createView(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** The rotate right (circular right shift) operation for uint32 */ function $b3e8be57daaa948d$var$rotr(word, shift) {
    return word << 32 - shift | word >>> shift;
}
/** The rotate left (circular left shift) operation for uint32 */ function $b3e8be57daaa948d$var$rotl(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
/** Is current platform little-endian? Most are. Big-Endian platform: IBM */ module.exports.isLE = (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
/** The byte swap operation for uint32 */ function $b3e8be57daaa948d$var$byteSwap(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
/** Conditionally byte swap if on a big-endian platform */ module.exports.swap8IfBE = module.exports.isLE ? (n)=>n : (n)=>$b3e8be57daaa948d$var$byteSwap(n);
/** @deprecated */ module.exports.byteSwapIfBE = module.exports.swap8IfBE;
/** In place byte swap for Uint32Array */ function $b3e8be57daaa948d$var$byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $b3e8be57daaa948d$var$byteSwap(arr[i]);
    return arr;
}
module.exports.swap32IfBE = module.exports.isLE ? (u)=>u : $b3e8be57daaa948d$var$byteSwap32;
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const $b3e8be57daaa948d$var$hasHexBuiltin = /* @__PURE__ */ (()=>// @ts-ignore
    typeof Uint8Array.from([]).toHex === "function" && typeof Uint8Array.fromHex === "function")();
// Array where index 0xf0 (240) is mapped to string 'f0'
const $b3e8be57daaa948d$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * Convert byte array to hex string. Uses built-in function, when available.
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $b3e8be57daaa948d$var$bytesToHex(bytes) {
    $b3e8be57daaa948d$var$abytes(bytes);
    // @ts-ignore
    if ($b3e8be57daaa948d$var$hasHexBuiltin) return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $b3e8be57daaa948d$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $b3e8be57daaa948d$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $b3e8be57daaa948d$var$asciiToBase16(ch) {
    if (ch >= $b3e8be57daaa948d$var$asciis._0 && ch <= $b3e8be57daaa948d$var$asciis._9) return ch - $b3e8be57daaa948d$var$asciis._0; // '2' => 50-48
    if (ch >= $b3e8be57daaa948d$var$asciis.A && ch <= $b3e8be57daaa948d$var$asciis.F) return ch - ($b3e8be57daaa948d$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $b3e8be57daaa948d$var$asciis.a && ch <= $b3e8be57daaa948d$var$asciis.f) return ch - ($b3e8be57daaa948d$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * Convert hex string to byte array. Uses built-in function, when available.
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $b3e8be57daaa948d$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // @ts-ignore
    if ($b3e8be57daaa948d$var$hasHexBuiltin) return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $b3e8be57daaa948d$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $b3e8be57daaa948d$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
/**
 * There is no setImmediate in browser and setTimeout is slow.
 * Call of async fn will return Promise, which will be fullfiled only on
 * next scheduler queue processing step and this is exactly what we need.
 */ const $b3e8be57daaa948d$var$nextTick = async ()=>{};
module.exports.nextTick = $b3e8be57daaa948d$var$nextTick;
/** Returns control to thread each 'tick' ms to avoid blocking. */ async function $b3e8be57daaa948d$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
/**
 * Converts string to bytes using UTF8 encoding.
 * @example utf8ToBytes('abc') // Uint8Array.from([97, 98, 99])
 */ function $b3e8be57daaa948d$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error("string expected");
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Converts bytes to string using UTF8 encoding.
 * @example bytesToUtf8(Uint8Array.from([97, 98, 99])) // 'abc'
 */ function $b3e8be57daaa948d$var$bytesToUtf8(bytes) {
    return new TextDecoder().decode(bytes);
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $b3e8be57daaa948d$var$toBytes(data) {
    if (typeof data === "string") data = $b3e8be57daaa948d$var$utf8ToBytes(data);
    $b3e8be57daaa948d$var$abytes(data);
    return data;
}
/**
 * Helper for KDFs: consumes uint8array or string.
 * When string is passed, does utf8 decoding, using TextDecoder.
 */ function $b3e8be57daaa948d$var$kdfInputToBytes(data) {
    if (typeof data === "string") data = $b3e8be57daaa948d$var$utf8ToBytes(data);
    $b3e8be57daaa948d$var$abytes(data);
    return data;
}
/** Copies several Uint8Arrays into one. */ function $b3e8be57daaa948d$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $b3e8be57daaa948d$var$abytes(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $b3e8be57daaa948d$var$checkOpts(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== "[object Object]") throw new Error("options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
/** For runtime check if class implements interface */ class $b3e8be57daaa948d$var$Hash {
}
module.exports.Hash = $b3e8be57daaa948d$var$Hash;
/** Wraps hash function, creating an interface on top of it */ function $b3e8be57daaa948d$var$createHasher(hashCons) {
    const hashC = (msg)=>hashCons().update($b3e8be57daaa948d$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $b3e8be57daaa948d$var$createOptHasher(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($b3e8be57daaa948d$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $b3e8be57daaa948d$var$createXOFer(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($b3e8be57daaa948d$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructor = $b3e8be57daaa948d$var$createHasher;
module.exports.wrapConstructorWithOpts = $b3e8be57daaa948d$var$createOptHasher;
module.exports.wrapXOFConstructorWithOpts = $b3e8be57daaa948d$var$createXOFer;
/** Cryptographically secure PRNG. Uses internal OS-level `crypto.getRandomValues`. */ function $b3e8be57daaa948d$var$randomBytes(bytesLength = 32) {
    if ($lvlW2.crypto && typeof $lvlW2.crypto.getRandomValues === "function") return $lvlW2.crypto.getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ($lvlW2.crypto && typeof $lvlW2.crypto.randomBytes === "function") return Uint8Array.from($lvlW2.crypto.randomBytes(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}

});
parcelRegister("lvlW2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});



parcelRegister("hX4ZG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha224 = module.exports.SHA224 = module.exports.sha256 = module.exports.SHA256 = void 0;

var $bl0h7 = parcelRequire("bl0h7");
/** @deprecated Use import from `noble/hashes/sha2` module */ module.exports.SHA256 = $bl0h7.SHA256;
/** @deprecated Use import from `noble/hashes/sha2` module */ module.exports.sha256 = $bl0h7.sha256;
/** @deprecated Use import from `noble/hashes/sha2` module */ module.exports.SHA224 = $bl0h7.SHA224;
/** @deprecated Use import from `noble/hashes/sha2` module */ module.exports.sha224 = $bl0h7.sha224;

});
parcelRegister("bl0h7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha512_224 = module.exports.sha512_256 = module.exports.sha384 = module.exports.sha512 = module.exports.sha224 = module.exports.sha256 = module.exports.SHA512_256 = module.exports.SHA512_224 = module.exports.SHA384 = module.exports.SHA512 = module.exports.SHA224 = module.exports.SHA256 = void 0;

var $eGicV = parcelRequire("eGicV");

var $f0wHT = parcelRequire("f0wHT");

var $frEr5 = parcelRequire("frEr5");
/**
 * Round constants:
 * First 32 bits of fractional parts of the cube roots of the first 64 primes 2..311)
 */ // prettier-ignore
const $8411de87c6cd0305$var$SHA256_K = /* @__PURE__ */ Uint32Array.from([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Reusable temporary buffer. "W" comes straight from spec. */ const $8411de87c6cd0305$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $8411de87c6cd0305$var$SHA256 extends $eGicV.HashMD {
    constructor(outputLen = 32){
        super(64, outputLen, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $eGicV.SHA256_IV[0] | 0;
        this.B = $eGicV.SHA256_IV[1] | 0;
        this.C = $eGicV.SHA256_IV[2] | 0;
        this.D = $eGicV.SHA256_IV[3] | 0;
        this.E = $eGicV.SHA256_IV[4] | 0;
        this.F = $eGicV.SHA256_IV[5] | 0;
        this.G = $eGicV.SHA256_IV[6] | 0;
        this.H = $eGicV.SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$8411de87c6cd0305$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $8411de87c6cd0305$var$SHA256_W[i - 15];
            const W2 = $8411de87c6cd0305$var$SHA256_W[i - 2];
            const s0 = (0, $frEr5.rotr)(W15, 7) ^ (0, $frEr5.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $frEr5.rotr)(W2, 17) ^ (0, $frEr5.rotr)(W2, 19) ^ W2 >>> 10;
            $8411de87c6cd0305$var$SHA256_W[i] = s1 + $8411de87c6cd0305$var$SHA256_W[i - 7] + s0 + $8411de87c6cd0305$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $frEr5.rotr)(E, 6) ^ (0, $frEr5.rotr)(E, 11) ^ (0, $frEr5.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $eGicV.Chi)(E, F, G) + $8411de87c6cd0305$var$SHA256_K[i] + $8411de87c6cd0305$var$SHA256_W[i] | 0;
            const sigma0 = (0, $frEr5.rotr)(A, 2) ^ (0, $frEr5.rotr)(A, 13) ^ (0, $frEr5.rotr)(A, 22);
            const T2 = sigma0 + (0, $eGicV.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        (0, $frEr5.clean)($8411de87c6cd0305$var$SHA256_W);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        (0, $frEr5.clean)(this.buffer);
    }
}
module.exports.SHA256 = $8411de87c6cd0305$var$SHA256;
class $8411de87c6cd0305$var$SHA224 extends $8411de87c6cd0305$var$SHA256 {
    constructor(){
        super(28);
        this.A = $eGicV.SHA224_IV[0] | 0;
        this.B = $eGicV.SHA224_IV[1] | 0;
        this.C = $eGicV.SHA224_IV[2] | 0;
        this.D = $eGicV.SHA224_IV[3] | 0;
        this.E = $eGicV.SHA224_IV[4] | 0;
        this.F = $eGicV.SHA224_IV[5] | 0;
        this.G = $eGicV.SHA224_IV[6] | 0;
        this.H = $eGicV.SHA224_IV[7] | 0;
    }
}
module.exports.SHA224 = $8411de87c6cd0305$var$SHA224;
// SHA2-512 is slower than sha256 in js because u64 operations are slow.
// Round contants
// First 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409
// prettier-ignore
const $8411de87c6cd0305$var$K512 = /* @__PURE__ */ (()=>$f0wHT.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
const $8411de87c6cd0305$var$SHA512_Kh = /* @__PURE__ */ (()=>$8411de87c6cd0305$var$K512[0])();
const $8411de87c6cd0305$var$SHA512_Kl = /* @__PURE__ */ (()=>$8411de87c6cd0305$var$K512[1])();
// Reusable temporary buffers
const $8411de87c6cd0305$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $8411de87c6cd0305$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $8411de87c6cd0305$var$SHA512 extends $eGicV.HashMD {
    constructor(outputLen = 64){
        super(128, outputLen, 16, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = $eGicV.SHA512_IV[0] | 0;
        this.Al = $eGicV.SHA512_IV[1] | 0;
        this.Bh = $eGicV.SHA512_IV[2] | 0;
        this.Bl = $eGicV.SHA512_IV[3] | 0;
        this.Ch = $eGicV.SHA512_IV[4] | 0;
        this.Cl = $eGicV.SHA512_IV[5] | 0;
        this.Dh = $eGicV.SHA512_IV[6] | 0;
        this.Dl = $eGicV.SHA512_IV[7] | 0;
        this.Eh = $eGicV.SHA512_IV[8] | 0;
        this.El = $eGicV.SHA512_IV[9] | 0;
        this.Fh = $eGicV.SHA512_IV[10] | 0;
        this.Fl = $eGicV.SHA512_IV[11] | 0;
        this.Gh = $eGicV.SHA512_IV[12] | 0;
        this.Gl = $eGicV.SHA512_IV[13] | 0;
        this.Hh = $eGicV.SHA512_IV[14] | 0;
        this.Hl = $eGicV.SHA512_IV[15] | 0;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $8411de87c6cd0305$var$SHA512_W_H[i] = view.getUint32(offset);
            $8411de87c6cd0305$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $8411de87c6cd0305$var$SHA512_W_H[i - 15] | 0;
            const W15l = $8411de87c6cd0305$var$SHA512_W_L[i - 15] | 0;
            const s0h = $f0wHT.rotrSH(W15h, W15l, 1) ^ $f0wHT.rotrSH(W15h, W15l, 8) ^ $f0wHT.shrSH(W15h, W15l, 7);
            const s0l = $f0wHT.rotrSL(W15h, W15l, 1) ^ $f0wHT.rotrSL(W15h, W15l, 8) ^ $f0wHT.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $8411de87c6cd0305$var$SHA512_W_H[i - 2] | 0;
            const W2l = $8411de87c6cd0305$var$SHA512_W_L[i - 2] | 0;
            const s1h = $f0wHT.rotrSH(W2h, W2l, 19) ^ $f0wHT.rotrBH(W2h, W2l, 61) ^ $f0wHT.shrSH(W2h, W2l, 6);
            const s1l = $f0wHT.rotrSL(W2h, W2l, 19) ^ $f0wHT.rotrBL(W2h, W2l, 61) ^ $f0wHT.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $f0wHT.add4L(s0l, s1l, $8411de87c6cd0305$var$SHA512_W_L[i - 7], $8411de87c6cd0305$var$SHA512_W_L[i - 16]);
            const SUMh = $f0wHT.add4H(SUMl, s0h, s1h, $8411de87c6cd0305$var$SHA512_W_H[i - 7], $8411de87c6cd0305$var$SHA512_W_H[i - 16]);
            $8411de87c6cd0305$var$SHA512_W_H[i] = SUMh | 0;
            $8411de87c6cd0305$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $f0wHT.rotrSH(Eh, El, 14) ^ $f0wHT.rotrSH(Eh, El, 18) ^ $f0wHT.rotrBH(Eh, El, 41);
            const sigma1l = $f0wHT.rotrSL(Eh, El, 14) ^ $f0wHT.rotrSL(Eh, El, 18) ^ $f0wHT.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $f0wHT.add5L(Hl, sigma1l, CHIl, $8411de87c6cd0305$var$SHA512_Kl[i], $8411de87c6cd0305$var$SHA512_W_L[i]);
            const T1h = $f0wHT.add5H(T1ll, Hh, sigma1h, CHIh, $8411de87c6cd0305$var$SHA512_Kh[i], $8411de87c6cd0305$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $f0wHT.rotrSH(Ah, Al, 28) ^ $f0wHT.rotrBH(Ah, Al, 34) ^ $f0wHT.rotrBH(Ah, Al, 39);
            const sigma0l = $f0wHT.rotrSL(Ah, Al, 28) ^ $f0wHT.rotrBL(Ah, Al, 34) ^ $f0wHT.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $f0wHT.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $f0wHT.add3L(T1l, sigma0l, MAJl);
            Ah = $f0wHT.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $f0wHT.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $f0wHT.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $f0wHT.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $f0wHT.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $f0wHT.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $f0wHT.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $f0wHT.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $f0wHT.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        (0, $frEr5.clean)($8411de87c6cd0305$var$SHA512_W_H, $8411de87c6cd0305$var$SHA512_W_L);
    }
    destroy() {
        (0, $frEr5.clean)(this.buffer);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
module.exports.SHA512 = $8411de87c6cd0305$var$SHA512;
class $8411de87c6cd0305$var$SHA384 extends $8411de87c6cd0305$var$SHA512 {
    constructor(){
        super(48);
        this.Ah = $eGicV.SHA384_IV[0] | 0;
        this.Al = $eGicV.SHA384_IV[1] | 0;
        this.Bh = $eGicV.SHA384_IV[2] | 0;
        this.Bl = $eGicV.SHA384_IV[3] | 0;
        this.Ch = $eGicV.SHA384_IV[4] | 0;
        this.Cl = $eGicV.SHA384_IV[5] | 0;
        this.Dh = $eGicV.SHA384_IV[6] | 0;
        this.Dl = $eGicV.SHA384_IV[7] | 0;
        this.Eh = $eGicV.SHA384_IV[8] | 0;
        this.El = $eGicV.SHA384_IV[9] | 0;
        this.Fh = $eGicV.SHA384_IV[10] | 0;
        this.Fl = $eGicV.SHA384_IV[11] | 0;
        this.Gh = $eGicV.SHA384_IV[12] | 0;
        this.Gl = $eGicV.SHA384_IV[13] | 0;
        this.Hh = $eGicV.SHA384_IV[14] | 0;
        this.Hl = $eGicV.SHA384_IV[15] | 0;
    }
}
module.exports.SHA384 = $8411de87c6cd0305$var$SHA384;
/**
 * Truncated SHA512/256 and SHA512/224.
 * SHA512_IV is XORed with 0xa5a5a5a5a5a5a5a5, then used as "intermediary" IV of SHA512/t.
 * Then t hashes string to produce result IV.
 * See `test/misc/sha2-gen-iv.js`.
 */ /** SHA512/224 IV */ const $8411de87c6cd0305$var$T224_IV = /* @__PURE__ */ Uint32Array.from([
    0x8c3d37c8,
    0x19544da2,
    0x73e19966,
    0x89dcd4d6,
    0x1dfab7ae,
    0x32ff9c82,
    0x679dd514,
    0x582f9fcf,
    0x0f6d2b69,
    0x7bd44da8,
    0x77e36f73,
    0x04c48942,
    0x3f9d85a8,
    0x6a1d36c8,
    0x1112e6ad,
    0x91d692a1
]);
/** SHA512/256 IV */ const $8411de87c6cd0305$var$T256_IV = /* @__PURE__ */ Uint32Array.from([
    0x22312194,
    0xfc2bf72c,
    0x9f555fa3,
    0xc84c64c2,
    0x2393b86b,
    0x6f53b151,
    0x96387719,
    0x5940eabd,
    0x96283ee2,
    0xa88effe3,
    0xbe5e1e25,
    0x53863992,
    0x2b0199fc,
    0x2c85b8aa,
    0x0eb72ddc,
    0x81c52ca2
]);
class $8411de87c6cd0305$var$SHA512_224 extends $8411de87c6cd0305$var$SHA512 {
    constructor(){
        super(28);
        this.Ah = $8411de87c6cd0305$var$T224_IV[0] | 0;
        this.Al = $8411de87c6cd0305$var$T224_IV[1] | 0;
        this.Bh = $8411de87c6cd0305$var$T224_IV[2] | 0;
        this.Bl = $8411de87c6cd0305$var$T224_IV[3] | 0;
        this.Ch = $8411de87c6cd0305$var$T224_IV[4] | 0;
        this.Cl = $8411de87c6cd0305$var$T224_IV[5] | 0;
        this.Dh = $8411de87c6cd0305$var$T224_IV[6] | 0;
        this.Dl = $8411de87c6cd0305$var$T224_IV[7] | 0;
        this.Eh = $8411de87c6cd0305$var$T224_IV[8] | 0;
        this.El = $8411de87c6cd0305$var$T224_IV[9] | 0;
        this.Fh = $8411de87c6cd0305$var$T224_IV[10] | 0;
        this.Fl = $8411de87c6cd0305$var$T224_IV[11] | 0;
        this.Gh = $8411de87c6cd0305$var$T224_IV[12] | 0;
        this.Gl = $8411de87c6cd0305$var$T224_IV[13] | 0;
        this.Hh = $8411de87c6cd0305$var$T224_IV[14] | 0;
        this.Hl = $8411de87c6cd0305$var$T224_IV[15] | 0;
    }
}
module.exports.SHA512_224 = $8411de87c6cd0305$var$SHA512_224;
class $8411de87c6cd0305$var$SHA512_256 extends $8411de87c6cd0305$var$SHA512 {
    constructor(){
        super(32);
        this.Ah = $8411de87c6cd0305$var$T256_IV[0] | 0;
        this.Al = $8411de87c6cd0305$var$T256_IV[1] | 0;
        this.Bh = $8411de87c6cd0305$var$T256_IV[2] | 0;
        this.Bl = $8411de87c6cd0305$var$T256_IV[3] | 0;
        this.Ch = $8411de87c6cd0305$var$T256_IV[4] | 0;
        this.Cl = $8411de87c6cd0305$var$T256_IV[5] | 0;
        this.Dh = $8411de87c6cd0305$var$T256_IV[6] | 0;
        this.Dl = $8411de87c6cd0305$var$T256_IV[7] | 0;
        this.Eh = $8411de87c6cd0305$var$T256_IV[8] | 0;
        this.El = $8411de87c6cd0305$var$T256_IV[9] | 0;
        this.Fh = $8411de87c6cd0305$var$T256_IV[10] | 0;
        this.Fl = $8411de87c6cd0305$var$T256_IV[11] | 0;
        this.Gh = $8411de87c6cd0305$var$T256_IV[12] | 0;
        this.Gl = $8411de87c6cd0305$var$T256_IV[13] | 0;
        this.Hh = $8411de87c6cd0305$var$T256_IV[14] | 0;
        this.Hl = $8411de87c6cd0305$var$T256_IV[15] | 0;
    }
}
module.exports.SHA512_256 = $8411de87c6cd0305$var$SHA512_256;
/**
 * SHA2-256 hash function from RFC 4634.
 *
 * It is the fastest JS hash, even faster than Blake3.
 * To break sha256 using birthday attack, attackers need to try 2^128 hashes.
 * BTC network is doing 2^70 hashes/sec (2^95 hashes/year) as per 2025.
 */ module.exports.sha256 = (0, $frEr5.createHasher)(()=>new $8411de87c6cd0305$var$SHA256());
/** SHA2-224 hash function from RFC 4634 */ module.exports.sha224 = (0, $frEr5.createHasher)(()=>new $8411de87c6cd0305$var$SHA224());
/** SHA2-512 hash function from RFC 4634. */ module.exports.sha512 = (0, $frEr5.createHasher)(()=>new $8411de87c6cd0305$var$SHA512());
/** SHA2-384 hash function from RFC 4634. */ module.exports.sha384 = (0, $frEr5.createHasher)(()=>new $8411de87c6cd0305$var$SHA384());
/**
 * SHA2-512/256 "truncated" hash function, with improved resistance to length extension attacks.
 * See the paper on [truncated SHA512](https://eprint.iacr.org/2010/548.pdf).
 */ module.exports.sha512_256 = (0, $frEr5.createHasher)(()=>new $8411de87c6cd0305$var$SHA512_256());
/**
 * SHA2-512/224 "truncated" hash function, with improved resistance to length extension attacks.
 * See the paper on [truncated SHA512](https://eprint.iacr.org/2010/548.pdf).
 */ module.exports.sha512_224 = (0, $frEr5.createHasher)(()=>new $8411de87c6cd0305$var$SHA512_224());

});
parcelRegister("eGicV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SHA512_IV = module.exports.SHA384_IV = module.exports.SHA224_IV = module.exports.SHA256_IV = module.exports.HashMD = void 0;
module.exports.setBigUint64 = $ab031c8cf19e5d89$var$setBigUint64;
module.exports.Chi = $ab031c8cf19e5d89$var$Chi;
module.exports.Maj = $ab031c8cf19e5d89$var$Maj;

var $frEr5 = parcelRequire("frEr5");
/** Polyfill for Safari 14. https://caniuse.com/mdn-javascript_builtins_dataview_setbiguint64 */ function $ab031c8cf19e5d89$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
/** Choice: a ? b : c */ function $ab031c8cf19e5d89$var$Chi(a, b, c) {
    return a & b ^ ~a & c;
}
/** Majority function, true if any two inputs is true. */ function $ab031c8cf19e5d89$var$Maj(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */ class $ab031c8cf19e5d89$var$HashMD extends $frEr5.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $frEr5.createView)(this.buffer);
    }
    update(data) {
        (0, $frEr5.aexists)(this);
        data = (0, $frEr5.toBytes)(data);
        (0, $frEr5.abytes)(data);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $frEr5.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $frEr5.aexists)(this);
        (0, $frEr5.aoutput)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        (0, $frEr5.clean)(this.buffer.subarray(pos));
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $ab031c8cf19e5d89$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $frEr5.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.destroyed = destroyed;
        to.finished = finished;
        to.length = length;
        to.pos = pos;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
}
module.exports.HashMD = $ab031c8cf19e5d89$var$HashMD;
/**
 * Initial SHA-2 state: fractional parts of square roots of first 16 primes 2..53.
 * Check out `test/misc/sha2-gen-iv.js` for recomputation guide.
 */ /** Initial SHA256 state. Bits 0..32 of frac part of sqrt of primes 2..19 */ module.exports.SHA256_IV = Uint32Array.from([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
/** Initial SHA224 state. Bits 32..64 of frac part of sqrt of primes 23..53 */ module.exports.SHA224_IV = Uint32Array.from([
    0xc1059ed8,
    0x367cd507,
    0x3070dd17,
    0xf70e5939,
    0xffc00b31,
    0x68581511,
    0x64f98fa7,
    0xbefa4fa4
]);
/** Initial SHA384 state. Bits 0..64 of frac part of sqrt of primes 23..53 */ module.exports.SHA384_IV = Uint32Array.from([
    0xcbbb9d5d,
    0xc1059ed8,
    0x629a292a,
    0x367cd507,
    0x9159015a,
    0x3070dd17,
    0x152fecd8,
    0xf70e5939,
    0x67332667,
    0xffc00b31,
    0x8eb44a87,
    0x68581511,
    0xdb0c2e0d,
    0x64f98fa7,
    0x47b5481d,
    0xbefa4fa4
]);
/** Initial SHA512 state. Bits 0..64 of frac part of sqrt of primes 2..19 */ module.exports.SHA512_IV = Uint32Array.from([
    0x6a09e667,
    0xf3bcc908,
    0xbb67ae85,
    0x84caa73b,
    0x3c6ef372,
    0xfe94f82b,
    0xa54ff53a,
    0x5f1d36f1,
    0x510e527f,
    0xade682d1,
    0x9b05688c,
    0x2b3e6c1f,
    0x1f83d9ab,
    0xfb41bd6b,
    0x5be0cd19,
    0x137e2179
]);

});

parcelRegister("f0wHT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toBig = module.exports.shrSL = module.exports.shrSH = module.exports.rotrSL = module.exports.rotrSH = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotlBL = module.exports.rotlBH = module.exports.add5L = module.exports.add5H = module.exports.add4L = module.exports.add4H = module.exports.add3L = module.exports.add3H = void 0;
module.exports.add = $aed03a0420bd0f82$var$add;
module.exports.fromBig = $aed03a0420bd0f82$var$fromBig;
module.exports.split = $aed03a0420bd0f82$var$split;
/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const $aed03a0420bd0f82$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $aed03a0420bd0f82$var$_32n = /* @__PURE__ */ BigInt(32);
function $aed03a0420bd0f82$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $aed03a0420bd0f82$var$U32_MASK64),
        l: Number(n >> $aed03a0420bd0f82$var$_32n & $aed03a0420bd0f82$var$U32_MASK64)
    };
    return {
        h: Number(n >> $aed03a0420bd0f82$var$_32n & $aed03a0420bd0f82$var$U32_MASK64) | 0,
        l: Number(n & $aed03a0420bd0f82$var$U32_MASK64) | 0
    };
}
function $aed03a0420bd0f82$var$split(lst, le = false) {
    const len = lst.length;
    let Ah = new Uint32Array(len);
    let Al = new Uint32Array(len);
    for(let i = 0; i < len; i++){
        const { h: h, l: l } = $aed03a0420bd0f82$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $aed03a0420bd0f82$var$toBig = (h, l)=>BigInt(h >>> 0) << $aed03a0420bd0f82$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $aed03a0420bd0f82$var$toBig;
// for Shift in [0, 32)
const $aed03a0420bd0f82$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $aed03a0420bd0f82$var$shrSH;
const $aed03a0420bd0f82$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $aed03a0420bd0f82$var$shrSL;
// Right rotate for Shift in [1, 32)
const $aed03a0420bd0f82$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $aed03a0420bd0f82$var$rotrSH;
const $aed03a0420bd0f82$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $aed03a0420bd0f82$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aed03a0420bd0f82$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $aed03a0420bd0f82$var$rotrBH;
const $aed03a0420bd0f82$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $aed03a0420bd0f82$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $aed03a0420bd0f82$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $aed03a0420bd0f82$var$rotr32H;
const $aed03a0420bd0f82$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $aed03a0420bd0f82$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $aed03a0420bd0f82$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $aed03a0420bd0f82$var$rotlSH;
const $aed03a0420bd0f82$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $aed03a0420bd0f82$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aed03a0420bd0f82$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $aed03a0420bd0f82$var$rotlBH;
const $aed03a0420bd0f82$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $aed03a0420bd0f82$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $aed03a0420bd0f82$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $aed03a0420bd0f82$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $aed03a0420bd0f82$var$add3L;
const $aed03a0420bd0f82$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $aed03a0420bd0f82$var$add3H;
const $aed03a0420bd0f82$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $aed03a0420bd0f82$var$add4L;
const $aed03a0420bd0f82$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $aed03a0420bd0f82$var$add4H;
const $aed03a0420bd0f82$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $aed03a0420bd0f82$var$add5L;
const $aed03a0420bd0f82$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $aed03a0420bd0f82$var$add5H;
// prettier-ignore
const $aed03a0420bd0f82$var$u64 = {
    fromBig: $aed03a0420bd0f82$var$fromBig,
    split: $aed03a0420bd0f82$var$split,
    toBig: $aed03a0420bd0f82$var$toBig,
    shrSH: $aed03a0420bd0f82$var$shrSH,
    shrSL: $aed03a0420bd0f82$var$shrSL,
    rotrSH: $aed03a0420bd0f82$var$rotrSH,
    rotrSL: $aed03a0420bd0f82$var$rotrSL,
    rotrBH: $aed03a0420bd0f82$var$rotrBH,
    rotrBL: $aed03a0420bd0f82$var$rotrBL,
    rotr32H: $aed03a0420bd0f82$var$rotr32H,
    rotr32L: $aed03a0420bd0f82$var$rotr32L,
    rotlSH: $aed03a0420bd0f82$var$rotlSH,
    rotlSL: $aed03a0420bd0f82$var$rotlSL,
    rotlBH: $aed03a0420bd0f82$var$rotlBH,
    rotlBL: $aed03a0420bd0f82$var$rotlBL,
    add: $aed03a0420bd0f82$var$add,
    add3L: $aed03a0420bd0f82$var$add3L,
    add3H: $aed03a0420bd0f82$var$add3H,
    add4L: $aed03a0420bd0f82$var$add4L,
    add4H: $aed03a0420bd0f82$var$add4H,
    add5H: $aed03a0420bd0f82$var$add5H,
    add5L: $aed03a0420bd0f82$var$add5L
};
module.exports.default = $aed03a0420bd0f82$var$u64;

});



parcelRegister("7xCMk", function(module, exports) {
"use strict";
/*! noble-secp256k1 - MIT License (c) 2019 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utils = module.exports.schnorr = module.exports.verify = module.exports.signSync = module.exports.sign = module.exports.getSharedSecret = module.exports.recoverPublicKey = module.exports.getPublicKey = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.Signature = module.exports.Point = module.exports.CURVE = void 0;

var $ct9Rv = parcelRequire("ct9Rv");
const $57d9b21523188de5$var$_0n = BigInt(0);
const $57d9b21523188de5$var$_1n = BigInt(1);
const $57d9b21523188de5$var$_2n = BigInt(2);
const $57d9b21523188de5$var$_3n = BigInt(3);
const $57d9b21523188de5$var$_8n = BigInt(8);
const $57d9b21523188de5$var$CURVE = Object.freeze({
    a: $57d9b21523188de5$var$_0n,
    b: BigInt(7),
    P: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"),
    n: BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"),
    h: $57d9b21523188de5$var$_1n,
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee")
});
module.exports.CURVE = $57d9b21523188de5$var$CURVE;
const $57d9b21523188de5$var$divNearest = (a, b)=>(a + b / $57d9b21523188de5$var$_2n) / b;
const $57d9b21523188de5$var$endo = {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar (k) {
        const { n: n } = $57d9b21523188de5$var$CURVE;
        const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
        const b1 = -$57d9b21523188de5$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
        const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
        const b2 = a1;
        const POW_2_128 = BigInt("0x100000000000000000000000000000000");
        const c1 = $57d9b21523188de5$var$divNearest(b2 * k, n);
        const c2 = $57d9b21523188de5$var$divNearest(-b1 * k, n);
        let k1 = $57d9b21523188de5$var$mod(k - c1 * a1 - c2 * a2, n);
        let k2 = $57d9b21523188de5$var$mod(-c1 * b1 - c2 * b2, n);
        const k1neg = k1 > POW_2_128;
        const k2neg = k2 > POW_2_128;
        if (k1neg) k1 = n - k1;
        if (k2neg) k2 = n - k2;
        if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalarEndo: Endomorphism failed, k=" + k);
        return {
            k1neg: k1neg,
            k1: k1,
            k2neg: k2neg,
            k2: k2
        };
    }
};
const $57d9b21523188de5$var$fieldLen = 32;
const $57d9b21523188de5$var$groupLen = 32;
const $57d9b21523188de5$var$hashLen = 32;
const $57d9b21523188de5$var$compressedLen = $57d9b21523188de5$var$fieldLen + 1;
const $57d9b21523188de5$var$uncompressedLen = 2 * $57d9b21523188de5$var$fieldLen + 1;
function $57d9b21523188de5$var$weierstrass(x) {
    const { a: a, b: b } = $57d9b21523188de5$var$CURVE;
    const x2 = $57d9b21523188de5$var$mod(x * x);
    const x3 = $57d9b21523188de5$var$mod(x2 * x);
    return $57d9b21523188de5$var$mod(x3 + a * x + b);
}
const $57d9b21523188de5$var$USE_ENDOMORPHISM = $57d9b21523188de5$var$CURVE.a === $57d9b21523188de5$var$_0n;
class $57d9b21523188de5$var$ShaError extends Error {
    constructor(message){
        super(message);
    }
}
function $57d9b21523188de5$var$assertJacPoint(other) {
    if (!(other instanceof $57d9b21523188de5$var$JacobianPoint)) throw new TypeError("JacobianPoint expected");
}
class $57d9b21523188de5$var$JacobianPoint {
    constructor(x, y, z){
        this.x = x;
        this.y = y;
        this.z = z;
    }
    static fromAffine(p) {
        if (!(p instanceof $57d9b21523188de5$var$Point)) throw new TypeError("JacobianPoint#fromAffine: expected Point");
        if (p.equals($57d9b21523188de5$var$Point.ZERO)) return $57d9b21523188de5$var$JacobianPoint.ZERO;
        return new $57d9b21523188de5$var$JacobianPoint(p.x, p.y, $57d9b21523188de5$var$_1n);
    }
    static toAffineBatch(points) {
        const toInv = $57d9b21523188de5$var$invertBatch(points.map((p)=>p.z));
        return points.map((p, i)=>p.toAffine(toInv[i]));
    }
    static normalizeZ(points) {
        return $57d9b21523188de5$var$JacobianPoint.toAffineBatch(points).map($57d9b21523188de5$var$JacobianPoint.fromAffine);
    }
    equals(other) {
        $57d9b21523188de5$var$assertJacPoint(other);
        const { x: X1, y: Y1, z: Z1 } = this;
        const { x: X2, y: Y2, z: Z2 } = other;
        const Z1Z1 = $57d9b21523188de5$var$mod(Z1 * Z1);
        const Z2Z2 = $57d9b21523188de5$var$mod(Z2 * Z2);
        const U1 = $57d9b21523188de5$var$mod(X1 * Z2Z2);
        const U2 = $57d9b21523188de5$var$mod(X2 * Z1Z1);
        const S1 = $57d9b21523188de5$var$mod($57d9b21523188de5$var$mod(Y1 * Z2) * Z2Z2);
        const S2 = $57d9b21523188de5$var$mod($57d9b21523188de5$var$mod(Y2 * Z1) * Z1Z1);
        return U1 === U2 && S1 === S2;
    }
    negate() {
        return new $57d9b21523188de5$var$JacobianPoint(this.x, $57d9b21523188de5$var$mod(-this.y), this.z);
    }
    double() {
        const { x: X1, y: Y1, z: Z1 } = this;
        const A = $57d9b21523188de5$var$mod(X1 * X1);
        const B = $57d9b21523188de5$var$mod(Y1 * Y1);
        const C = $57d9b21523188de5$var$mod(B * B);
        const x1b = X1 + B;
        const D = $57d9b21523188de5$var$mod($57d9b21523188de5$var$_2n * ($57d9b21523188de5$var$mod(x1b * x1b) - A - C));
        const E = $57d9b21523188de5$var$mod($57d9b21523188de5$var$_3n * A);
        const F = $57d9b21523188de5$var$mod(E * E);
        const X3 = $57d9b21523188de5$var$mod(F - $57d9b21523188de5$var$_2n * D);
        const Y3 = $57d9b21523188de5$var$mod(E * (D - X3) - $57d9b21523188de5$var$_8n * C);
        const Z3 = $57d9b21523188de5$var$mod($57d9b21523188de5$var$_2n * Y1 * Z1);
        return new $57d9b21523188de5$var$JacobianPoint(X3, Y3, Z3);
    }
    add(other) {
        $57d9b21523188de5$var$assertJacPoint(other);
        const { x: X1, y: Y1, z: Z1 } = this;
        const { x: X2, y: Y2, z: Z2 } = other;
        if (X2 === $57d9b21523188de5$var$_0n || Y2 === $57d9b21523188de5$var$_0n) return this;
        if (X1 === $57d9b21523188de5$var$_0n || Y1 === $57d9b21523188de5$var$_0n) return other;
        const Z1Z1 = $57d9b21523188de5$var$mod(Z1 * Z1);
        const Z2Z2 = $57d9b21523188de5$var$mod(Z2 * Z2);
        const U1 = $57d9b21523188de5$var$mod(X1 * Z2Z2);
        const U2 = $57d9b21523188de5$var$mod(X2 * Z1Z1);
        const S1 = $57d9b21523188de5$var$mod($57d9b21523188de5$var$mod(Y1 * Z2) * Z2Z2);
        const S2 = $57d9b21523188de5$var$mod($57d9b21523188de5$var$mod(Y2 * Z1) * Z1Z1);
        const H = $57d9b21523188de5$var$mod(U2 - U1);
        const r = $57d9b21523188de5$var$mod(S2 - S1);
        if (H === $57d9b21523188de5$var$_0n) {
            if (r === $57d9b21523188de5$var$_0n) return this.double();
            else return $57d9b21523188de5$var$JacobianPoint.ZERO;
        }
        const HH = $57d9b21523188de5$var$mod(H * H);
        const HHH = $57d9b21523188de5$var$mod(H * HH);
        const V = $57d9b21523188de5$var$mod(U1 * HH);
        const X3 = $57d9b21523188de5$var$mod(r * r - HHH - $57d9b21523188de5$var$_2n * V);
        const Y3 = $57d9b21523188de5$var$mod(r * (V - X3) - S1 * HHH);
        const Z3 = $57d9b21523188de5$var$mod(Z1 * Z2 * H);
        return new $57d9b21523188de5$var$JacobianPoint(X3, Y3, Z3);
    }
    subtract(other) {
        return this.add(other.negate());
    }
    multiplyUnsafe(scalar) {
        const P0 = $57d9b21523188de5$var$JacobianPoint.ZERO;
        if (typeof scalar === "bigint" && scalar === $57d9b21523188de5$var$_0n) return P0;
        let n = $57d9b21523188de5$var$normalizeScalar(scalar);
        if (n === $57d9b21523188de5$var$_1n) return this;
        if (!$57d9b21523188de5$var$USE_ENDOMORPHISM) {
            let p = P0;
            let d = this;
            while(n > $57d9b21523188de5$var$_0n){
                if (n & $57d9b21523188de5$var$_1n) p = p.add(d);
                d = d.double();
                n >>= $57d9b21523188de5$var$_1n;
            }
            return p;
        }
        let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = $57d9b21523188de5$var$endo.splitScalar(n);
        let k1p = P0;
        let k2p = P0;
        let d = this;
        while(k1 > $57d9b21523188de5$var$_0n || k2 > $57d9b21523188de5$var$_0n){
            if (k1 & $57d9b21523188de5$var$_1n) k1p = k1p.add(d);
            if (k2 & $57d9b21523188de5$var$_1n) k2p = k2p.add(d);
            d = d.double();
            k1 >>= $57d9b21523188de5$var$_1n;
            k2 >>= $57d9b21523188de5$var$_1n;
        }
        if (k1neg) k1p = k1p.negate();
        if (k2neg) k2p = k2p.negate();
        k2p = new $57d9b21523188de5$var$JacobianPoint($57d9b21523188de5$var$mod(k2p.x * $57d9b21523188de5$var$endo.beta), k2p.y, k2p.z);
        return k1p.add(k2p);
    }
    precomputeWindow(W) {
        const windows = $57d9b21523188de5$var$USE_ENDOMORPHISM ? 128 / W + 1 : 256 / W + 1;
        const points = [];
        let p = this;
        let base = p;
        for(let window = 0; window < windows; window++){
            base = p;
            points.push(base);
            for(let i = 1; i < 2 ** (W - 1); i++){
                base = base.add(p);
                points.push(base);
            }
            p = base.double();
        }
        return points;
    }
    wNAF(n, affinePoint) {
        if (!affinePoint && this.equals($57d9b21523188de5$var$JacobianPoint.BASE)) affinePoint = $57d9b21523188de5$var$Point.BASE;
        const W = affinePoint && affinePoint._WINDOW_SIZE || 1;
        if (256 % W) throw new Error("Point#wNAF: Invalid precomputation window, must be power of 2");
        let precomputes = affinePoint && $57d9b21523188de5$var$pointPrecomputes.get(affinePoint);
        if (!precomputes) {
            precomputes = this.precomputeWindow(W);
            if (affinePoint && W !== 1) {
                precomputes = $57d9b21523188de5$var$JacobianPoint.normalizeZ(precomputes);
                $57d9b21523188de5$var$pointPrecomputes.set(affinePoint, precomputes);
            }
        }
        let p = $57d9b21523188de5$var$JacobianPoint.ZERO;
        let f = $57d9b21523188de5$var$JacobianPoint.BASE;
        const windows = 1 + ($57d9b21523188de5$var$USE_ENDOMORPHISM ? 128 / W : 256 / W);
        const windowSize = 2 ** (W - 1);
        const mask = BigInt(2 ** W - 1);
        const maxNumber = 2 ** W;
        const shiftBy = BigInt(W);
        for(let window = 0; window < windows; window++){
            const offset = window * windowSize;
            let wbits = Number(n & mask);
            n >>= shiftBy;
            if (wbits > windowSize) {
                wbits -= maxNumber;
                n += $57d9b21523188de5$var$_1n;
            }
            const offset1 = offset;
            const offset2 = offset + Math.abs(wbits) - 1;
            const cond1 = window % 2 !== 0;
            const cond2 = wbits < 0;
            if (wbits === 0) f = f.add($57d9b21523188de5$var$constTimeNegate(cond1, precomputes[offset1]));
            else p = p.add($57d9b21523188de5$var$constTimeNegate(cond2, precomputes[offset2]));
        }
        return {
            p: p,
            f: f
        };
    }
    multiply(scalar, affinePoint) {
        let n = $57d9b21523188de5$var$normalizeScalar(scalar);
        let point;
        let fake;
        if ($57d9b21523188de5$var$USE_ENDOMORPHISM) {
            const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = $57d9b21523188de5$var$endo.splitScalar(n);
            let { p: k1p, f: f1p } = this.wNAF(k1, affinePoint);
            let { p: k2p, f: f2p } = this.wNAF(k2, affinePoint);
            k1p = $57d9b21523188de5$var$constTimeNegate(k1neg, k1p);
            k2p = $57d9b21523188de5$var$constTimeNegate(k2neg, k2p);
            k2p = new $57d9b21523188de5$var$JacobianPoint($57d9b21523188de5$var$mod(k2p.x * $57d9b21523188de5$var$endo.beta), k2p.y, k2p.z);
            point = k1p.add(k2p);
            fake = f1p.add(f2p);
        } else {
            const { p: p, f: f } = this.wNAF(n, affinePoint);
            point = p;
            fake = f;
        }
        return $57d9b21523188de5$var$JacobianPoint.normalizeZ([
            point,
            fake
        ])[0];
    }
    toAffine(invZ) {
        const { x: x, y: y, z: z } = this;
        const is0 = this.equals($57d9b21523188de5$var$JacobianPoint.ZERO);
        if (invZ == null) invZ = is0 ? $57d9b21523188de5$var$_8n : $57d9b21523188de5$var$invert(z);
        const iz1 = invZ;
        const iz2 = $57d9b21523188de5$var$mod(iz1 * iz1);
        const iz3 = $57d9b21523188de5$var$mod(iz2 * iz1);
        const ax = $57d9b21523188de5$var$mod(x * iz2);
        const ay = $57d9b21523188de5$var$mod(y * iz3);
        const zz = $57d9b21523188de5$var$mod(z * iz1);
        if (is0) return $57d9b21523188de5$var$Point.ZERO;
        if (zz !== $57d9b21523188de5$var$_1n) throw new Error("invZ was invalid");
        return new $57d9b21523188de5$var$Point(ax, ay);
    }
}
$57d9b21523188de5$var$JacobianPoint.BASE = new $57d9b21523188de5$var$JacobianPoint($57d9b21523188de5$var$CURVE.Gx, $57d9b21523188de5$var$CURVE.Gy, $57d9b21523188de5$var$_1n);
$57d9b21523188de5$var$JacobianPoint.ZERO = new $57d9b21523188de5$var$JacobianPoint($57d9b21523188de5$var$_0n, $57d9b21523188de5$var$_1n, $57d9b21523188de5$var$_0n);
function $57d9b21523188de5$var$constTimeNegate(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
const $57d9b21523188de5$var$pointPrecomputes = new WeakMap();
class $57d9b21523188de5$var$Point {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    _setWindowSize(windowSize) {
        this._WINDOW_SIZE = windowSize;
        $57d9b21523188de5$var$pointPrecomputes.delete(this);
    }
    hasEvenY() {
        return this.y % $57d9b21523188de5$var$_2n === $57d9b21523188de5$var$_0n;
    }
    static fromCompressedHex(bytes) {
        const isShort = bytes.length === 32;
        const x = $57d9b21523188de5$var$bytesToNumber(isShort ? bytes : bytes.subarray(1));
        if (!$57d9b21523188de5$var$isValidFieldElement(x)) throw new Error("Point is not on curve");
        const y2 = $57d9b21523188de5$var$weierstrass(x);
        let y = $57d9b21523188de5$var$sqrtMod(y2);
        const isYOdd = (y & $57d9b21523188de5$var$_1n) === $57d9b21523188de5$var$_1n;
        if (isShort) {
            if (isYOdd) y = $57d9b21523188de5$var$mod(-y);
        } else {
            const isFirstByteOdd = (bytes[0] & 1) === 1;
            if (isFirstByteOdd !== isYOdd) y = $57d9b21523188de5$var$mod(-y);
        }
        const point = new $57d9b21523188de5$var$Point(x, y);
        point.assertValidity();
        return point;
    }
    static fromUncompressedHex(bytes) {
        const x = $57d9b21523188de5$var$bytesToNumber(bytes.subarray(1, $57d9b21523188de5$var$fieldLen + 1));
        const y = $57d9b21523188de5$var$bytesToNumber(bytes.subarray($57d9b21523188de5$var$fieldLen + 1, $57d9b21523188de5$var$fieldLen * 2 + 1));
        const point = new $57d9b21523188de5$var$Point(x, y);
        point.assertValidity();
        return point;
    }
    static fromHex(hex) {
        const bytes = $57d9b21523188de5$var$ensureBytes(hex);
        const len = bytes.length;
        const header = bytes[0];
        if (len === $57d9b21523188de5$var$fieldLen) return this.fromCompressedHex(bytes);
        if (len === $57d9b21523188de5$var$compressedLen && (header === 0x02 || header === 0x03)) return this.fromCompressedHex(bytes);
        if (len === $57d9b21523188de5$var$uncompressedLen && header === 0x04) return this.fromUncompressedHex(bytes);
        throw new Error(`Point.fromHex: received invalid point. Expected 32-${$57d9b21523188de5$var$compressedLen} compressed bytes or ${$57d9b21523188de5$var$uncompressedLen} uncompressed bytes, not ${len}`);
    }
    static fromPrivateKey(privateKey) {
        return $57d9b21523188de5$var$Point.BASE.multiply($57d9b21523188de5$var$normalizePrivateKey(privateKey));
    }
    static fromSignature(msgHash, signature, recovery) {
        const { r: r, s: s } = $57d9b21523188de5$var$normalizeSignature(signature);
        if (![
            0,
            1,
            2,
            3
        ].includes(recovery)) throw new Error("Cannot recover: invalid recovery bit");
        const h = $57d9b21523188de5$var$truncateHash($57d9b21523188de5$var$ensureBytes(msgHash));
        const { n: n } = $57d9b21523188de5$var$CURVE;
        const radj = recovery === 2 || recovery === 3 ? r + n : r;
        const rinv = $57d9b21523188de5$var$invert(radj, n);
        const u1 = $57d9b21523188de5$var$mod(-h * rinv, n);
        const u2 = $57d9b21523188de5$var$mod(s * rinv, n);
        const prefix = recovery & 1 ? "03" : "02";
        const R = $57d9b21523188de5$var$Point.fromHex(prefix + $57d9b21523188de5$var$numTo32bStr(radj));
        const Q = $57d9b21523188de5$var$Point.BASE.multiplyAndAddUnsafe(R, u1, u2);
        if (!Q) throw new Error("Cannot recover signature: point at infinify");
        Q.assertValidity();
        return Q;
    }
    toRawBytes(isCompressed = false) {
        return $57d9b21523188de5$var$hexToBytes(this.toHex(isCompressed));
    }
    toHex(isCompressed = false) {
        const x = $57d9b21523188de5$var$numTo32bStr(this.x);
        if (isCompressed) {
            const prefix = this.hasEvenY() ? "02" : "03";
            return `${prefix}${x}`;
        } else return `04${x}${$57d9b21523188de5$var$numTo32bStr(this.y)}`;
    }
    toHexX() {
        return this.toHex(true).slice(2);
    }
    toRawX() {
        return this.toRawBytes(true).slice(1);
    }
    assertValidity() {
        const msg = "Point is not on elliptic curve";
        const { x: x, y: y } = this;
        if (!$57d9b21523188de5$var$isValidFieldElement(x) || !$57d9b21523188de5$var$isValidFieldElement(y)) throw new Error(msg);
        const left = $57d9b21523188de5$var$mod(y * y);
        const right = $57d9b21523188de5$var$weierstrass(x);
        if ($57d9b21523188de5$var$mod(left - right) !== $57d9b21523188de5$var$_0n) throw new Error(msg);
    }
    equals(other) {
        return this.x === other.x && this.y === other.y;
    }
    negate() {
        return new $57d9b21523188de5$var$Point(this.x, $57d9b21523188de5$var$mod(-this.y));
    }
    double() {
        return $57d9b21523188de5$var$JacobianPoint.fromAffine(this).double().toAffine();
    }
    add(other) {
        return $57d9b21523188de5$var$JacobianPoint.fromAffine(this).add($57d9b21523188de5$var$JacobianPoint.fromAffine(other)).toAffine();
    }
    subtract(other) {
        return this.add(other.negate());
    }
    multiply(scalar) {
        return $57d9b21523188de5$var$JacobianPoint.fromAffine(this).multiply(scalar, this).toAffine();
    }
    multiplyAndAddUnsafe(Q, a, b) {
        const P = $57d9b21523188de5$var$JacobianPoint.fromAffine(this);
        const aP = a === $57d9b21523188de5$var$_0n || a === $57d9b21523188de5$var$_1n || this !== $57d9b21523188de5$var$Point.BASE ? P.multiplyUnsafe(a) : P.multiply(a);
        const bQ = $57d9b21523188de5$var$JacobianPoint.fromAffine(Q).multiplyUnsafe(b);
        const sum = aP.add(bQ);
        return sum.equals($57d9b21523188de5$var$JacobianPoint.ZERO) ? undefined : sum.toAffine();
    }
}
module.exports.Point = $57d9b21523188de5$var$Point;
$57d9b21523188de5$var$Point.BASE = new $57d9b21523188de5$var$Point($57d9b21523188de5$var$CURVE.Gx, $57d9b21523188de5$var$CURVE.Gy);
$57d9b21523188de5$var$Point.ZERO = new $57d9b21523188de5$var$Point($57d9b21523188de5$var$_0n, $57d9b21523188de5$var$_0n);
function $57d9b21523188de5$var$sliceDER(s) {
    return Number.parseInt(s[0], 16) >= 8 ? "00" + s : s;
}
function $57d9b21523188de5$var$parseDERInt(data) {
    if (data.length < 2 || data[0] !== 0x02) throw new Error(`Invalid signature integer tag: ${$57d9b21523188de5$var$bytesToHex(data)}`);
    const len = data[1];
    const res = data.subarray(2, len + 2);
    if (!len || res.length !== len) throw new Error(`Invalid signature integer: wrong length`);
    if (res[0] === 0x00 && res[1] <= 0x7f) throw new Error("Invalid signature integer: trailing length");
    return {
        data: $57d9b21523188de5$var$bytesToNumber(res),
        left: data.subarray(len + 2)
    };
}
function $57d9b21523188de5$var$parseDERSignature(data) {
    if (data.length < 2 || data[0] != 0x30) throw new Error(`Invalid signature tag: ${$57d9b21523188de5$var$bytesToHex(data)}`);
    if (data[1] !== data.length - 2) throw new Error("Invalid signature: incorrect length");
    const { data: r, left: sBytes } = $57d9b21523188de5$var$parseDERInt(data.subarray(2));
    const { data: s, left: rBytesLeft } = $57d9b21523188de5$var$parseDERInt(sBytes);
    if (rBytesLeft.length) throw new Error(`Invalid signature: left bytes after parsing: ${$57d9b21523188de5$var$bytesToHex(rBytesLeft)}`);
    return {
        r: r,
        s: s
    };
}
class $57d9b21523188de5$var$Signature {
    constructor(r, s){
        this.r = r;
        this.s = s;
        this.assertValidity();
    }
    static fromCompact(hex) {
        const arr = $57d9b21523188de5$var$isBytes(hex);
        const name = "Signature.fromCompact";
        if (typeof hex !== "string" && !arr) throw new TypeError(`${name}: Expected string or Uint8Array`);
        const str = arr ? $57d9b21523188de5$var$bytesToHex(hex) : hex;
        if (str.length !== 128) throw new Error(`${name}: Expected 64-byte hex`);
        return new $57d9b21523188de5$var$Signature($57d9b21523188de5$var$hexToNumber(str.slice(0, 64)), $57d9b21523188de5$var$hexToNumber(str.slice(64, 128)));
    }
    static fromDER(hex) {
        const arr = $57d9b21523188de5$var$isBytes(hex);
        if (typeof hex !== "string" && !arr) throw new TypeError(`Signature.fromDER: Expected string or Uint8Array`);
        const { r: r, s: s } = $57d9b21523188de5$var$parseDERSignature(arr ? hex : $57d9b21523188de5$var$hexToBytes(hex));
        return new $57d9b21523188de5$var$Signature(r, s);
    }
    static fromHex(hex) {
        return this.fromDER(hex);
    }
    assertValidity() {
        const { r: r, s: s } = this;
        if (!$57d9b21523188de5$var$isWithinCurveOrder(r)) throw new Error("Invalid Signature: r must be 0 < r < n");
        if (!$57d9b21523188de5$var$isWithinCurveOrder(s)) throw new Error("Invalid Signature: s must be 0 < s < n");
    }
    hasHighS() {
        const HALF = $57d9b21523188de5$var$CURVE.n >> $57d9b21523188de5$var$_1n;
        return this.s > HALF;
    }
    normalizeS() {
        return this.hasHighS() ? new $57d9b21523188de5$var$Signature(this.r, $57d9b21523188de5$var$mod(-this.s, $57d9b21523188de5$var$CURVE.n)) : this;
    }
    toDERRawBytes() {
        return $57d9b21523188de5$var$hexToBytes(this.toDERHex());
    }
    toDERHex() {
        const sHex = $57d9b21523188de5$var$sliceDER($57d9b21523188de5$var$numberToHexUnpadded(this.s));
        const rHex = $57d9b21523188de5$var$sliceDER($57d9b21523188de5$var$numberToHexUnpadded(this.r));
        const sHexL = sHex.length / 2;
        const rHexL = rHex.length / 2;
        const sLen = $57d9b21523188de5$var$numberToHexUnpadded(sHexL);
        const rLen = $57d9b21523188de5$var$numberToHexUnpadded(rHexL);
        const length = $57d9b21523188de5$var$numberToHexUnpadded(rHexL + sHexL + 4);
        return `30${length}02${rLen}${rHex}02${sLen}${sHex}`;
    }
    toRawBytes() {
        return this.toDERRawBytes();
    }
    toHex() {
        return this.toDERHex();
    }
    toCompactRawBytes() {
        return $57d9b21523188de5$var$hexToBytes(this.toCompactHex());
    }
    toCompactHex() {
        return $57d9b21523188de5$var$numTo32bStr(this.r) + $57d9b21523188de5$var$numTo32bStr(this.s);
    }
}
module.exports.Signature = $57d9b21523188de5$var$Signature;
function $57d9b21523188de5$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
function $57d9b21523188de5$var$abytes(item) {
    if (!$57d9b21523188de5$var$isBytes(item)) throw new Error("Uint8Array expected");
}
function $57d9b21523188de5$var$concatBytes(...arrays) {
    arrays.every($57d9b21523188de5$var$abytes);
    if (arrays.length === 1) return arrays[0];
    const length = arrays.reduce((a, arr)=>a + arr.length, 0);
    const result = new Uint8Array(length);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const arr = arrays[i];
        result.set(arr, pad);
        pad += arr.length;
    }
    return result;
}
const $57d9b21523188de5$var$hexes = Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $57d9b21523188de5$var$bytesToHex(bytes) {
    $57d9b21523188de5$var$abytes(bytes);
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $57d9b21523188de5$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $57d9b21523188de5$var$bytesToHex;
const $57d9b21523188de5$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $57d9b21523188de5$var$asciiToBase16(ch) {
    if (ch >= $57d9b21523188de5$var$asciis._0 && ch <= $57d9b21523188de5$var$asciis._9) return ch - $57d9b21523188de5$var$asciis._0;
    if (ch >= $57d9b21523188de5$var$asciis.A && ch <= $57d9b21523188de5$var$asciis.F) return ch - ($57d9b21523188de5$var$asciis.A - 10);
    if (ch >= $57d9b21523188de5$var$asciis.a && ch <= $57d9b21523188de5$var$asciis.f) return ch - ($57d9b21523188de5$var$asciis.a - 10);
    return;
}
function $57d9b21523188de5$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $57d9b21523188de5$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $57d9b21523188de5$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
module.exports.hexToBytes = $57d9b21523188de5$var$hexToBytes;
const $57d9b21523188de5$var$POW_2_256 = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000");
function $57d9b21523188de5$var$numTo32bStr(num) {
    if (typeof num !== "bigint") throw new Error("Expected bigint");
    if (!($57d9b21523188de5$var$_0n <= num && num < $57d9b21523188de5$var$POW_2_256)) throw new Error("Expected number 0 <= n < 2^256");
    return num.toString(16).padStart(64, "0");
}
function $57d9b21523188de5$var$numTo32b(num) {
    const b = $57d9b21523188de5$var$hexToBytes($57d9b21523188de5$var$numTo32bStr(num));
    if (b.length !== 32) throw new Error("Error: expected 32 bytes");
    return b;
}
function $57d9b21523188de5$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function $57d9b21523188de5$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new TypeError("hexToNumber: expected string, got " + typeof hex);
    return BigInt(`0x${hex}`);
}
function $57d9b21523188de5$var$bytesToNumber(bytes) {
    return $57d9b21523188de5$var$hexToNumber($57d9b21523188de5$var$bytesToHex(bytes));
}
function $57d9b21523188de5$var$ensureBytes(hex) {
    return $57d9b21523188de5$var$isBytes(hex) ? Uint8Array.from(hex) : $57d9b21523188de5$var$hexToBytes(hex);
}
function $57d9b21523188de5$var$normalizeScalar(num) {
    if (typeof num === "number" && Number.isSafeInteger(num) && num > 0) return BigInt(num);
    if (typeof num === "bigint" && $57d9b21523188de5$var$isWithinCurveOrder(num)) return num;
    throw new TypeError("Expected valid private scalar: 0 < scalar < curve.n");
}
function $57d9b21523188de5$var$mod(a, b = $57d9b21523188de5$var$CURVE.P) {
    const result = a % b;
    return result >= $57d9b21523188de5$var$_0n ? result : b + result;
}
function $57d9b21523188de5$var$pow2(x, power) {
    const { P: P } = $57d9b21523188de5$var$CURVE;
    let res = x;
    while(power-- > $57d9b21523188de5$var$_0n){
        res *= res;
        res %= P;
    }
    return res;
}
function $57d9b21523188de5$var$sqrtMod(x) {
    const { P: P } = $57d9b21523188de5$var$CURVE;
    const _6n = BigInt(6);
    const _11n = BigInt(11);
    const _22n = BigInt(22);
    const _23n = BigInt(23);
    const _44n = BigInt(44);
    const _88n = BigInt(88);
    const b2 = x * x * x % P;
    const b3 = b2 * b2 * x % P;
    const b6 = $57d9b21523188de5$var$pow2(b3, $57d9b21523188de5$var$_3n) * b3 % P;
    const b9 = $57d9b21523188de5$var$pow2(b6, $57d9b21523188de5$var$_3n) * b3 % P;
    const b11 = $57d9b21523188de5$var$pow2(b9, $57d9b21523188de5$var$_2n) * b2 % P;
    const b22 = $57d9b21523188de5$var$pow2(b11, _11n) * b11 % P;
    const b44 = $57d9b21523188de5$var$pow2(b22, _22n) * b22 % P;
    const b88 = $57d9b21523188de5$var$pow2(b44, _44n) * b44 % P;
    const b176 = $57d9b21523188de5$var$pow2(b88, _88n) * b88 % P;
    const b220 = $57d9b21523188de5$var$pow2(b176, _44n) * b44 % P;
    const b223 = $57d9b21523188de5$var$pow2(b220, $57d9b21523188de5$var$_3n) * b3 % P;
    const t1 = $57d9b21523188de5$var$pow2(b223, _23n) * b22 % P;
    const t2 = $57d9b21523188de5$var$pow2(t1, _6n) * b2 % P;
    const rt = $57d9b21523188de5$var$pow2(t2, $57d9b21523188de5$var$_2n);
    const xc = rt * rt % P;
    if (xc !== x) throw new Error("Cannot find square root");
    return rt;
}
function $57d9b21523188de5$var$invert(number, modulo = $57d9b21523188de5$var$CURVE.P) {
    if (number === $57d9b21523188de5$var$_0n || modulo <= $57d9b21523188de5$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    let a = $57d9b21523188de5$var$mod(number, modulo);
    let b = modulo;
    let x = $57d9b21523188de5$var$_0n, y = $57d9b21523188de5$var$_1n, u = $57d9b21523188de5$var$_1n, v = $57d9b21523188de5$var$_0n;
    while(a !== $57d9b21523188de5$var$_0n){
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $57d9b21523188de5$var$_1n) throw new Error("invert: does not exist");
    return $57d9b21523188de5$var$mod(x, modulo);
}
function $57d9b21523188de5$var$invertBatch(nums, p = $57d9b21523188de5$var$CURVE.P) {
    const scratch = new Array(nums.length);
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (num === $57d9b21523188de5$var$_0n) return acc;
        scratch[i] = acc;
        return $57d9b21523188de5$var$mod(acc * num, p);
    }, $57d9b21523188de5$var$_1n);
    const inverted = $57d9b21523188de5$var$invert(lastMultiplied, p);
    nums.reduceRight((acc, num, i)=>{
        if (num === $57d9b21523188de5$var$_0n) return acc;
        scratch[i] = $57d9b21523188de5$var$mod(acc * scratch[i], p);
        return $57d9b21523188de5$var$mod(acc * num, p);
    }, inverted);
    return scratch;
}
function $57d9b21523188de5$var$bits2int_2(bytes) {
    const delta = bytes.length * 8 - $57d9b21523188de5$var$groupLen * 8;
    const num = $57d9b21523188de5$var$bytesToNumber(bytes);
    return delta > 0 ? num >> BigInt(delta) : num;
}
function $57d9b21523188de5$var$truncateHash(hash, truncateOnly = false) {
    const h = $57d9b21523188de5$var$bits2int_2(hash);
    if (truncateOnly) return h;
    const { n: n } = $57d9b21523188de5$var$CURVE;
    return h >= n ? h - n : h;
}
let $57d9b21523188de5$var$_sha256Sync;
let $57d9b21523188de5$var$_hmacSha256Sync;
class $57d9b21523188de5$var$HmacDrbg {
    constructor(hashLen, qByteLen){
        this.hashLen = hashLen;
        this.qByteLen = qByteLen;
        if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
        if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
        this.v = new Uint8Array(hashLen).fill(1);
        this.k = new Uint8Array(hashLen).fill(0);
        this.counter = 0;
    }
    hmac(...values) {
        return module.exports.utils.hmacSha256(this.k, ...values);
    }
    hmacSync(...values) {
        return $57d9b21523188de5$var$_hmacSha256Sync(this.k, ...values);
    }
    checkSync() {
        if (typeof $57d9b21523188de5$var$_hmacSha256Sync !== "function") throw new $57d9b21523188de5$var$ShaError("hmacSha256Sync needs to be set");
    }
    incr() {
        if (this.counter >= 1000) throw new Error("Tried 1,000 k values for sign(), all were invalid");
        this.counter += 1;
    }
    async reseed(seed = new Uint8Array()) {
        this.k = await this.hmac(this.v, Uint8Array.from([
            0x00
        ]), seed);
        this.v = await this.hmac(this.v);
        if (seed.length === 0) return;
        this.k = await this.hmac(this.v, Uint8Array.from([
            0x01
        ]), seed);
        this.v = await this.hmac(this.v);
    }
    reseedSync(seed = new Uint8Array()) {
        this.checkSync();
        this.k = this.hmacSync(this.v, Uint8Array.from([
            0x00
        ]), seed);
        this.v = this.hmacSync(this.v);
        if (seed.length === 0) return;
        this.k = this.hmacSync(this.v, Uint8Array.from([
            0x01
        ]), seed);
        this.v = this.hmacSync(this.v);
    }
    async generate() {
        this.incr();
        let len = 0;
        const out = [];
        while(len < this.qByteLen){
            this.v = await this.hmac(this.v);
            const sl = this.v.slice();
            out.push(sl);
            len += this.v.length;
        }
        return $57d9b21523188de5$var$concatBytes(...out);
    }
    generateSync() {
        this.checkSync();
        this.incr();
        let len = 0;
        const out = [];
        while(len < this.qByteLen){
            this.v = this.hmacSync(this.v);
            const sl = this.v.slice();
            out.push(sl);
            len += this.v.length;
        }
        return $57d9b21523188de5$var$concatBytes(...out);
    }
}
function $57d9b21523188de5$var$isWithinCurveOrder(num) {
    return $57d9b21523188de5$var$_0n < num && num < $57d9b21523188de5$var$CURVE.n;
}
function $57d9b21523188de5$var$isValidFieldElement(num) {
    return $57d9b21523188de5$var$_0n < num && num < $57d9b21523188de5$var$CURVE.P;
}
function $57d9b21523188de5$var$kmdToSig(kBytes, m, d, lowS = true) {
    const { n: n } = $57d9b21523188de5$var$CURVE;
    const k = $57d9b21523188de5$var$truncateHash(kBytes, true);
    if (!$57d9b21523188de5$var$isWithinCurveOrder(k)) return;
    const kinv = $57d9b21523188de5$var$invert(k, n);
    const q = $57d9b21523188de5$var$Point.BASE.multiply(k);
    const r = $57d9b21523188de5$var$mod(q.x, n);
    if (r === $57d9b21523188de5$var$_0n) return;
    const s = $57d9b21523188de5$var$mod(kinv * $57d9b21523188de5$var$mod(m + d * r, n), n);
    if (s === $57d9b21523188de5$var$_0n) return;
    let sig = new $57d9b21523188de5$var$Signature(r, s);
    let recovery = (q.x === sig.r ? 0 : 2) | Number(q.y & $57d9b21523188de5$var$_1n);
    if (lowS && sig.hasHighS()) {
        sig = sig.normalizeS();
        recovery ^= 1;
    }
    return {
        sig: sig,
        recovery: recovery
    };
}
function $57d9b21523188de5$var$normalizePrivateKey(key) {
    let num;
    if (typeof key === "bigint") num = key;
    else if (typeof key === "number" && Number.isSafeInteger(key) && key > 0) num = BigInt(key);
    else if (typeof key === "string") {
        if (key.length !== 2 * $57d9b21523188de5$var$groupLen) throw new Error("Expected 32 bytes of private key");
        num = $57d9b21523188de5$var$hexToNumber(key);
    } else if ($57d9b21523188de5$var$isBytes(key)) {
        if (key.length !== $57d9b21523188de5$var$groupLen) throw new Error("Expected 32 bytes of private key");
        num = $57d9b21523188de5$var$bytesToNumber(key);
    } else throw new TypeError("Expected valid private key");
    if (!$57d9b21523188de5$var$isWithinCurveOrder(num)) throw new Error("Expected private key: 0 < key < n");
    return num;
}
function $57d9b21523188de5$var$normalizePublicKey(publicKey) {
    if (publicKey instanceof $57d9b21523188de5$var$Point) {
        publicKey.assertValidity();
        return publicKey;
    } else return $57d9b21523188de5$var$Point.fromHex(publicKey);
}
function $57d9b21523188de5$var$normalizeSignature(signature) {
    if (signature instanceof $57d9b21523188de5$var$Signature) {
        signature.assertValidity();
        return signature;
    }
    try {
        return $57d9b21523188de5$var$Signature.fromDER(signature);
    } catch (error) {
        return $57d9b21523188de5$var$Signature.fromCompact(signature);
    }
}
function $57d9b21523188de5$var$getPublicKey(privateKey, isCompressed = false) {
    return $57d9b21523188de5$var$Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
}
module.exports.getPublicKey = $57d9b21523188de5$var$getPublicKey;
function $57d9b21523188de5$var$recoverPublicKey(msgHash, signature, recovery, isCompressed = false) {
    return $57d9b21523188de5$var$Point.fromSignature(msgHash, signature, recovery).toRawBytes(isCompressed);
}
module.exports.recoverPublicKey = $57d9b21523188de5$var$recoverPublicKey;
function $57d9b21523188de5$var$isProbPub(item) {
    const arr = $57d9b21523188de5$var$isBytes(item);
    const str = typeof item === "string";
    const len = (arr || str) && item.length;
    if (arr) return len === $57d9b21523188de5$var$compressedLen || len === $57d9b21523188de5$var$uncompressedLen;
    if (str) return len === $57d9b21523188de5$var$compressedLen * 2 || len === $57d9b21523188de5$var$uncompressedLen * 2;
    if (item instanceof $57d9b21523188de5$var$Point) return true;
    return false;
}
function $57d9b21523188de5$var$getSharedSecret(privateA, publicB, isCompressed = false) {
    if ($57d9b21523188de5$var$isProbPub(privateA)) throw new TypeError("getSharedSecret: first arg must be private key");
    if (!$57d9b21523188de5$var$isProbPub(publicB)) throw new TypeError("getSharedSecret: second arg must be public key");
    const b = $57d9b21523188de5$var$normalizePublicKey(publicB);
    b.assertValidity();
    return b.multiply($57d9b21523188de5$var$normalizePrivateKey(privateA)).toRawBytes(isCompressed);
}
module.exports.getSharedSecret = $57d9b21523188de5$var$getSharedSecret;
function $57d9b21523188de5$var$bits2int(bytes) {
    const slice = bytes.length > $57d9b21523188de5$var$fieldLen ? bytes.slice(0, $57d9b21523188de5$var$fieldLen) : bytes;
    return $57d9b21523188de5$var$bytesToNumber(slice);
}
function $57d9b21523188de5$var$bits2octets(bytes) {
    const z1 = $57d9b21523188de5$var$bits2int(bytes);
    const z2 = $57d9b21523188de5$var$mod(z1, $57d9b21523188de5$var$CURVE.n);
    return $57d9b21523188de5$var$int2octets(z2 < $57d9b21523188de5$var$_0n ? z1 : z2);
}
function $57d9b21523188de5$var$int2octets(num) {
    return $57d9b21523188de5$var$numTo32b(num);
}
function $57d9b21523188de5$var$initSigArgs(msgHash, privateKey, extraEntropy) {
    if (msgHash == null) throw new Error(`sign: expected valid message hash, not "${msgHash}"`);
    const h1 = $57d9b21523188de5$var$ensureBytes(msgHash);
    const d = $57d9b21523188de5$var$normalizePrivateKey(privateKey);
    const seedArgs = [
        $57d9b21523188de5$var$int2octets(d),
        $57d9b21523188de5$var$bits2octets(h1)
    ];
    if (extraEntropy != null) {
        if (extraEntropy === true) extraEntropy = module.exports.utils.randomBytes($57d9b21523188de5$var$fieldLen);
        const e = $57d9b21523188de5$var$ensureBytes(extraEntropy);
        if (e.length !== $57d9b21523188de5$var$fieldLen) throw new Error(`sign: Expected ${$57d9b21523188de5$var$fieldLen} bytes of extra data`);
        seedArgs.push(e);
    }
    const seed = $57d9b21523188de5$var$concatBytes(...seedArgs);
    const m = $57d9b21523188de5$var$bits2int(h1);
    return {
        seed: seed,
        m: m,
        d: d
    };
}
function $57d9b21523188de5$var$finalizeSig(recSig, opts) {
    const { sig: sig, recovery: recovery } = recSig;
    const { der: der, recovered: recovered } = Object.assign({
        canonical: true,
        der: true
    }, opts);
    const hashed = der ? sig.toDERRawBytes() : sig.toCompactRawBytes();
    return recovered ? [
        hashed,
        recovery
    ] : hashed;
}
async function $57d9b21523188de5$var$sign(msgHash, privKey, opts = {}) {
    const { seed: seed, m: m, d: d } = $57d9b21523188de5$var$initSigArgs(msgHash, privKey, opts.extraEntropy);
    const drbg = new $57d9b21523188de5$var$HmacDrbg($57d9b21523188de5$var$hashLen, $57d9b21523188de5$var$groupLen);
    await drbg.reseed(seed);
    let sig;
    while(!(sig = $57d9b21523188de5$var$kmdToSig(await drbg.generate(), m, d, opts.canonical)))await drbg.reseed();
    return $57d9b21523188de5$var$finalizeSig(sig, opts);
}
module.exports.sign = $57d9b21523188de5$var$sign;
function $57d9b21523188de5$var$signSync(msgHash, privKey, opts = {}) {
    const { seed: seed, m: m, d: d } = $57d9b21523188de5$var$initSigArgs(msgHash, privKey, opts.extraEntropy);
    const drbg = new $57d9b21523188de5$var$HmacDrbg($57d9b21523188de5$var$hashLen, $57d9b21523188de5$var$groupLen);
    drbg.reseedSync(seed);
    let sig;
    while(!(sig = $57d9b21523188de5$var$kmdToSig(drbg.generateSync(), m, d, opts.canonical)))drbg.reseedSync();
    return $57d9b21523188de5$var$finalizeSig(sig, opts);
}
module.exports.signSync = $57d9b21523188de5$var$signSync;
const $57d9b21523188de5$var$vopts = {
    strict: true
};
function $57d9b21523188de5$var$verify(signature, msgHash, publicKey, opts = $57d9b21523188de5$var$vopts) {
    let sig;
    try {
        sig = $57d9b21523188de5$var$normalizeSignature(signature);
        msgHash = $57d9b21523188de5$var$ensureBytes(msgHash);
    } catch (error) {
        return false;
    }
    const { r: r, s: s } = sig;
    if (opts.strict && sig.hasHighS()) return false;
    const h = $57d9b21523188de5$var$truncateHash(msgHash);
    let P;
    try {
        P = $57d9b21523188de5$var$normalizePublicKey(publicKey);
    } catch (error) {
        return false;
    }
    const { n: n } = $57d9b21523188de5$var$CURVE;
    const sinv = $57d9b21523188de5$var$invert(s, n);
    const u1 = $57d9b21523188de5$var$mod(h * sinv, n);
    const u2 = $57d9b21523188de5$var$mod(r * sinv, n);
    const R = $57d9b21523188de5$var$Point.BASE.multiplyAndAddUnsafe(P, u1, u2);
    if (!R) return false;
    const v = $57d9b21523188de5$var$mod(R.x, n);
    return v === r;
}
module.exports.verify = $57d9b21523188de5$var$verify;
function $57d9b21523188de5$var$schnorrChallengeFinalize(ch) {
    return $57d9b21523188de5$var$mod($57d9b21523188de5$var$bytesToNumber(ch), $57d9b21523188de5$var$CURVE.n);
}
class $57d9b21523188de5$var$SchnorrSignature {
    constructor(r, s){
        this.r = r;
        this.s = s;
        this.assertValidity();
    }
    static fromHex(hex) {
        const bytes = $57d9b21523188de5$var$ensureBytes(hex);
        if (bytes.length !== 64) throw new TypeError(`SchnorrSignature.fromHex: expected 64 bytes, not ${bytes.length}`);
        const r = $57d9b21523188de5$var$bytesToNumber(bytes.subarray(0, 32));
        const s = $57d9b21523188de5$var$bytesToNumber(bytes.subarray(32, 64));
        return new $57d9b21523188de5$var$SchnorrSignature(r, s);
    }
    assertValidity() {
        const { r: r, s: s } = this;
        if (!$57d9b21523188de5$var$isValidFieldElement(r) || !$57d9b21523188de5$var$isWithinCurveOrder(s)) throw new Error("Invalid signature");
    }
    toHex() {
        return $57d9b21523188de5$var$numTo32bStr(this.r) + $57d9b21523188de5$var$numTo32bStr(this.s);
    }
    toRawBytes() {
        return $57d9b21523188de5$var$hexToBytes(this.toHex());
    }
}
function $57d9b21523188de5$var$schnorrGetPublicKey(privateKey) {
    return $57d9b21523188de5$var$Point.fromPrivateKey(privateKey).toRawX();
}
class $57d9b21523188de5$var$InternalSchnorrSignature {
    constructor(message, privateKey, auxRand = module.exports.utils.randomBytes()){
        if (message == null) throw new TypeError(`sign: Expected valid message, not "${message}"`);
        this.m = $57d9b21523188de5$var$ensureBytes(message);
        const { x: x, scalar: scalar } = this.getScalar($57d9b21523188de5$var$normalizePrivateKey(privateKey));
        this.px = x;
        this.d = scalar;
        this.rand = $57d9b21523188de5$var$ensureBytes(auxRand);
        if (this.rand.length !== 32) throw new TypeError("sign: Expected 32 bytes of aux randomness");
    }
    getScalar(priv) {
        const point = $57d9b21523188de5$var$Point.fromPrivateKey(priv);
        const scalar = point.hasEvenY() ? priv : $57d9b21523188de5$var$CURVE.n - priv;
        return {
            point: point,
            scalar: scalar,
            x: point.toRawX()
        };
    }
    initNonce(d, t0h) {
        return $57d9b21523188de5$var$numTo32b(d ^ $57d9b21523188de5$var$bytesToNumber(t0h));
    }
    finalizeNonce(k0h) {
        const k0 = $57d9b21523188de5$var$mod($57d9b21523188de5$var$bytesToNumber(k0h), $57d9b21523188de5$var$CURVE.n);
        if (k0 === $57d9b21523188de5$var$_0n) throw new Error("sign: Creation of signature failed. k is zero");
        const { point: R, x: rx, scalar: k } = this.getScalar(k0);
        return {
            R: R,
            rx: rx,
            k: k
        };
    }
    finalizeSig(R, k, e, d) {
        return new $57d9b21523188de5$var$SchnorrSignature(R.x, $57d9b21523188de5$var$mod(k + e * d, $57d9b21523188de5$var$CURVE.n)).toRawBytes();
    }
    error() {
        throw new Error("sign: Invalid signature produced");
    }
    async calc() {
        const { m: m, d: d, px: px, rand: rand } = this;
        const tag = module.exports.utils.taggedHash;
        const t = this.initNonce(d, await tag($57d9b21523188de5$var$TAGS.aux, rand));
        const { R: R, rx: rx, k: k } = this.finalizeNonce(await tag($57d9b21523188de5$var$TAGS.nonce, t, px, m));
        const e = $57d9b21523188de5$var$schnorrChallengeFinalize(await tag($57d9b21523188de5$var$TAGS.challenge, rx, px, m));
        const sig = this.finalizeSig(R, k, e, d);
        if (!await $57d9b21523188de5$var$schnorrVerify(sig, m, px)) this.error();
        return sig;
    }
    calcSync() {
        const { m: m, d: d, px: px, rand: rand } = this;
        const tag = module.exports.utils.taggedHashSync;
        const t = this.initNonce(d, tag($57d9b21523188de5$var$TAGS.aux, rand));
        const { R: R, rx: rx, k: k } = this.finalizeNonce(tag($57d9b21523188de5$var$TAGS.nonce, t, px, m));
        const e = $57d9b21523188de5$var$schnorrChallengeFinalize(tag($57d9b21523188de5$var$TAGS.challenge, rx, px, m));
        const sig = this.finalizeSig(R, k, e, d);
        if (!$57d9b21523188de5$var$schnorrVerifySync(sig, m, px)) this.error();
        return sig;
    }
}
async function $57d9b21523188de5$var$schnorrSign(msg, privKey, auxRand) {
    return new $57d9b21523188de5$var$InternalSchnorrSignature(msg, privKey, auxRand).calc();
}
function $57d9b21523188de5$var$schnorrSignSync(msg, privKey, auxRand) {
    return new $57d9b21523188de5$var$InternalSchnorrSignature(msg, privKey, auxRand).calcSync();
}
function $57d9b21523188de5$var$initSchnorrVerify(signature, message, publicKey) {
    const raw = signature instanceof $57d9b21523188de5$var$SchnorrSignature;
    const sig = raw ? signature : $57d9b21523188de5$var$SchnorrSignature.fromHex(signature);
    if (raw) sig.assertValidity();
    return {
        ...sig,
        m: $57d9b21523188de5$var$ensureBytes(message),
        P: $57d9b21523188de5$var$normalizePublicKey(publicKey)
    };
}
function $57d9b21523188de5$var$finalizeSchnorrVerify(r, P, s, e) {
    const R = $57d9b21523188de5$var$Point.BASE.multiplyAndAddUnsafe(P, $57d9b21523188de5$var$normalizePrivateKey(s), $57d9b21523188de5$var$mod(-e, $57d9b21523188de5$var$CURVE.n));
    if (!R || !R.hasEvenY() || R.x !== r) return false;
    return true;
}
async function $57d9b21523188de5$var$schnorrVerify(signature, message, publicKey) {
    try {
        const { r: r, s: s, m: m, P: P } = $57d9b21523188de5$var$initSchnorrVerify(signature, message, publicKey);
        const e = $57d9b21523188de5$var$schnorrChallengeFinalize(await module.exports.utils.taggedHash($57d9b21523188de5$var$TAGS.challenge, $57d9b21523188de5$var$numTo32b(r), P.toRawX(), m));
        return $57d9b21523188de5$var$finalizeSchnorrVerify(r, P, s, e);
    } catch (error) {
        return false;
    }
}
function $57d9b21523188de5$var$schnorrVerifySync(signature, message, publicKey) {
    try {
        const { r: r, s: s, m: m, P: P } = $57d9b21523188de5$var$initSchnorrVerify(signature, message, publicKey);
        const e = $57d9b21523188de5$var$schnorrChallengeFinalize(module.exports.utils.taggedHashSync($57d9b21523188de5$var$TAGS.challenge, $57d9b21523188de5$var$numTo32b(r), P.toRawX(), m));
        return $57d9b21523188de5$var$finalizeSchnorrVerify(r, P, s, e);
    } catch (error) {
        if (error instanceof $57d9b21523188de5$var$ShaError) throw error;
        return false;
    }
}
module.exports.schnorr = {
    Signature: $57d9b21523188de5$var$SchnorrSignature,
    getPublicKey: $57d9b21523188de5$var$schnorrGetPublicKey,
    sign: $57d9b21523188de5$var$schnorrSign,
    verify: $57d9b21523188de5$var$schnorrVerify,
    signSync: $57d9b21523188de5$var$schnorrSignSync,
    verifySync: $57d9b21523188de5$var$schnorrVerifySync
};
$57d9b21523188de5$var$Point.BASE._setWindowSize(8);
const $57d9b21523188de5$var$crypto = {
    node: $ct9Rv,
    web: typeof self === "object" && "crypto" in self ? self.crypto : undefined
};
const $57d9b21523188de5$var$TAGS = {
    challenge: "BIP0340/challenge",
    aux: "BIP0340/aux",
    nonce: "BIP0340/nonce"
};
const $57d9b21523188de5$var$TAGGED_HASH_PREFIXES = {};
module.exports.utils = {
    bytesToHex: $57d9b21523188de5$var$bytesToHex,
    hexToBytes: $57d9b21523188de5$var$hexToBytes,
    concatBytes: $57d9b21523188de5$var$concatBytes,
    mod: $57d9b21523188de5$var$mod,
    invert: $57d9b21523188de5$var$invert,
    isValidPrivateKey (privateKey) {
        try {
            $57d9b21523188de5$var$normalizePrivateKey(privateKey);
            return true;
        } catch (error) {
            return false;
        }
    },
    _bigintTo32Bytes: $57d9b21523188de5$var$numTo32b,
    _normalizePrivateKey: $57d9b21523188de5$var$normalizePrivateKey,
    hashToPrivateKey: (hash)=>{
        hash = $57d9b21523188de5$var$ensureBytes(hash);
        const minLen = $57d9b21523188de5$var$groupLen + 8;
        if (hash.length < minLen || hash.length > 1024) throw new Error(`Expected valid bytes of private key as per FIPS 186`);
        const num = $57d9b21523188de5$var$mod($57d9b21523188de5$var$bytesToNumber(hash), $57d9b21523188de5$var$CURVE.n - $57d9b21523188de5$var$_1n) + $57d9b21523188de5$var$_1n;
        return $57d9b21523188de5$var$numTo32b(num);
    },
    randomBytes: (bytesLength = 32)=>{
        if ($57d9b21523188de5$var$crypto.web) return $57d9b21523188de5$var$crypto.web.getRandomValues(new Uint8Array(bytesLength));
        else if ($57d9b21523188de5$var$crypto.node) {
            const { randomBytes: randomBytes } = $57d9b21523188de5$var$crypto.node;
            return Uint8Array.from(randomBytes(bytesLength));
        } else throw new Error("The environment doesn't have randomBytes function");
    },
    randomPrivateKey: ()=>module.exports.utils.hashToPrivateKey(module.exports.utils.randomBytes($57d9b21523188de5$var$groupLen + 8)),
    precompute (windowSize = 8, point = $57d9b21523188de5$var$Point.BASE) {
        const cached = point === $57d9b21523188de5$var$Point.BASE ? point : new $57d9b21523188de5$var$Point(point.x, point.y);
        cached._setWindowSize(windowSize);
        cached.multiply($57d9b21523188de5$var$_3n);
        return cached;
    },
    sha256: async (...messages)=>{
        if ($57d9b21523188de5$var$crypto.web) {
            const buffer = await $57d9b21523188de5$var$crypto.web.subtle.digest("SHA-256", $57d9b21523188de5$var$concatBytes(...messages));
            return new Uint8Array(buffer);
        } else if ($57d9b21523188de5$var$crypto.node) {
            const { createHash: createHash } = $57d9b21523188de5$var$crypto.node;
            const hash = createHash("sha256");
            messages.forEach((m)=>hash.update(m));
            return Uint8Array.from(hash.digest());
        } else throw new Error("The environment doesn't have sha256 function");
    },
    hmacSha256: async (key, ...messages)=>{
        if ($57d9b21523188de5$var$crypto.web) {
            const ckey = await $57d9b21523188de5$var$crypto.web.subtle.importKey("raw", key, {
                name: "HMAC",
                hash: {
                    name: "SHA-256"
                }
            }, false, [
                "sign"
            ]);
            const message = $57d9b21523188de5$var$concatBytes(...messages);
            const buffer = await $57d9b21523188de5$var$crypto.web.subtle.sign("HMAC", ckey, message);
            return new Uint8Array(buffer);
        } else if ($57d9b21523188de5$var$crypto.node) {
            const { createHmac: createHmac } = $57d9b21523188de5$var$crypto.node;
            const hash = createHmac("sha256", key);
            messages.forEach((m)=>hash.update(m));
            return Uint8Array.from(hash.digest());
        } else throw new Error("The environment doesn't have hmac-sha256 function");
    },
    sha256Sync: undefined,
    hmacSha256Sync: undefined,
    taggedHash: async (tag, ...messages)=>{
        let tagP = $57d9b21523188de5$var$TAGGED_HASH_PREFIXES[tag];
        if (tagP === undefined) {
            const tagH = await module.exports.utils.sha256(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
            tagP = $57d9b21523188de5$var$concatBytes(tagH, tagH);
            $57d9b21523188de5$var$TAGGED_HASH_PREFIXES[tag] = tagP;
        }
        return module.exports.utils.sha256(tagP, ...messages);
    },
    taggedHashSync: (tag, ...messages)=>{
        if (typeof $57d9b21523188de5$var$_sha256Sync !== "function") throw new $57d9b21523188de5$var$ShaError("sha256Sync is undefined, you need to set it");
        let tagP = $57d9b21523188de5$var$TAGGED_HASH_PREFIXES[tag];
        if (tagP === undefined) {
            const tagH = $57d9b21523188de5$var$_sha256Sync(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
            tagP = $57d9b21523188de5$var$concatBytes(tagH, tagH);
            $57d9b21523188de5$var$TAGGED_HASH_PREFIXES[tag] = tagP;
        }
        return $57d9b21523188de5$var$_sha256Sync(tagP, ...messages);
    },
    _JacobianPoint: $57d9b21523188de5$var$JacobianPoint
};
Object.defineProperties(module.exports.utils, {
    sha256Sync: {
        configurable: false,
        get () {
            return $57d9b21523188de5$var$_sha256Sync;
        },
        set (val) {
            if (!$57d9b21523188de5$var$_sha256Sync) $57d9b21523188de5$var$_sha256Sync = val;
        }
    },
    hmacSha256Sync: {
        configurable: false,
        get () {
            return $57d9b21523188de5$var$_hmacSha256Sync;
        },
        set (val) {
            if (!$57d9b21523188de5$var$_hmacSha256Sync) $57d9b21523188de5$var$_hmacSha256Sync = val;
        }
    }
});

});

parcelRegister("6or2c", function(module, exports) {
"use strict";
//  NOTICE
//  Copyright 2015 D2L Corporation
//
//  Licensed under the Apache License, Version 2.0 (the "License");
//  you may not use this file except in compliance with the License.
//  You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
//  Unless required by applicable law or agreed to in writing, software
//  distributed under the License is distributed on an "AS IS" BASIS,
//  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//  See the License for the specific language governing permissions and
//  limitations under the License.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.joseToDer = module.exports.derToJose = void 0;

var $gKBU6 = parcelRequire("gKBU6");

var $aT9GC = parcelRequire("aT9GC");
function $4a79f47042aa6cdc$var$getParamSize(keySize) {
    return (keySize / 8 | 0) + (keySize % 8 === 0 ? 0 : 1);
}
const $4a79f47042aa6cdc$var$paramBytesForAlg = {
    ES256: $4a79f47042aa6cdc$var$getParamSize(256),
    ES384: $4a79f47042aa6cdc$var$getParamSize(384),
    ES512: $4a79f47042aa6cdc$var$getParamSize(521)
};
function $4a79f47042aa6cdc$var$getParamBytesForAlg(alg) {
    const paramBytes = $4a79f47042aa6cdc$var$paramBytesForAlg[alg];
    if (paramBytes) return paramBytes;
    throw new Error(`Unknown algorithm "${alg}"`);
}
const $4a79f47042aa6cdc$var$MAX_OCTET = 0x80;
const $4a79f47042aa6cdc$var$CLASS_UNIVERSAL = 0;
const $4a79f47042aa6cdc$var$PRIMITIVE_BIT = 0x20;
const $4a79f47042aa6cdc$var$TAG_SEQ = 0x10;
const $4a79f47042aa6cdc$var$TAG_INT = 0x02;
const $4a79f47042aa6cdc$var$ENCODED_TAG_SEQ = $4a79f47042aa6cdc$var$TAG_SEQ | $4a79f47042aa6cdc$var$PRIMITIVE_BIT | $4a79f47042aa6cdc$var$CLASS_UNIVERSAL << 6;
const $4a79f47042aa6cdc$var$ENCODED_TAG_INT = $4a79f47042aa6cdc$var$TAG_INT | $4a79f47042aa6cdc$var$CLASS_UNIVERSAL << 6;
function $4a79f47042aa6cdc$var$signatureAsBytes(signature) {
    if (signature instanceof Uint8Array) return signature;
    else if ("string" === typeof signature) return (0, $gKBU6.toByteArray)((0, $aT9GC.pad)(signature));
    throw new TypeError("ECDSA signature must be a Base64 string or a Uint8Array");
}
function $4a79f47042aa6cdc$var$derToJose(signature, alg) {
    const signatureBytes = $4a79f47042aa6cdc$var$signatureAsBytes(signature);
    const paramBytes = $4a79f47042aa6cdc$var$getParamBytesForAlg(alg);
    // the DER encoded param should at most be the param size, plus a padding
    // zero, since due to being a signed integer
    const maxEncodedParamLength = paramBytes + 1;
    const inputLength = signatureBytes.length;
    let offset = 0;
    if (signatureBytes[offset++] !== $4a79f47042aa6cdc$var$ENCODED_TAG_SEQ) throw new Error('Could not find expected "seq"');
    let seqLength = signatureBytes[offset++];
    if (seqLength === ($4a79f47042aa6cdc$var$MAX_OCTET | 1)) seqLength = signatureBytes[offset++];
    if (inputLength - offset < seqLength) throw new Error(`"seq" specified length of "${seqLength}", only "${inputLength - offset}" remaining`);
    if (signatureBytes[offset++] !== $4a79f47042aa6cdc$var$ENCODED_TAG_INT) throw new Error('Could not find expected "int" for "r"');
    const rLength = signatureBytes[offset++];
    if (inputLength - offset - 2 < rLength) throw new Error(`"r" specified length of "${rLength}", only "${inputLength - offset - 2}" available`);
    if (maxEncodedParamLength < rLength) throw new Error(`"r" specified length of "${rLength}", max of "${maxEncodedParamLength}" is acceptable`);
    const rOffset = offset;
    offset += rLength;
    if (signatureBytes[offset++] !== $4a79f47042aa6cdc$var$ENCODED_TAG_INT) throw new Error('Could not find expected "int" for "s"');
    const sLength = signatureBytes[offset++];
    if (inputLength - offset !== sLength) throw new Error(`"s" specified length of "${sLength}", expected "${inputLength - offset}"`);
    if (maxEncodedParamLength < sLength) throw new Error(`"s" specified length of "${sLength}", max of "${maxEncodedParamLength}" is acceptable`);
    const sOffset = offset;
    offset += sLength;
    if (offset !== inputLength) throw new Error(`Expected to consume entire array, but "${inputLength - offset}" bytes remain`);
    const rPadding = paramBytes - rLength;
    const sPadding = paramBytes - sLength;
    const dst = new Uint8Array(rPadding + rLength + sPadding + sLength);
    for(offset = 0; offset < rPadding; ++offset)dst[offset] = 0;
    dst.set(signatureBytes.subarray(rOffset + Math.max(-rPadding, 0), rOffset + rLength), offset);
    offset = paramBytes;
    for(const o = offset; offset < o + sPadding; ++offset)dst[offset] = 0;
    dst.set(signatureBytes.subarray(sOffset + Math.max(-sPadding, 0), sOffset + sLength), offset);
    return (0, $aT9GC.escape)((0, $gKBU6.fromByteArray)(dst));
}
module.exports.derToJose = $4a79f47042aa6cdc$var$derToJose;
function $4a79f47042aa6cdc$var$countPadding(buf, start, stop) {
    let padding = 0;
    while(start + padding < stop && buf[start + padding] === 0)++padding;
    const needsSign = buf[start + padding] >= $4a79f47042aa6cdc$var$MAX_OCTET;
    if (needsSign) --padding;
    return padding;
}
function $4a79f47042aa6cdc$var$joseToDer(signature, alg) {
    signature = $4a79f47042aa6cdc$var$signatureAsBytes(signature);
    const paramBytes = $4a79f47042aa6cdc$var$getParamBytesForAlg(alg);
    const signatureBytes = signature.length;
    if (signatureBytes !== paramBytes * 2) throw new TypeError(`"${alg}" signatures must be "${paramBytes * 2}" bytes, saw "${signatureBytes}"`);
    const rPadding = $4a79f47042aa6cdc$var$countPadding(signature, 0, paramBytes);
    const sPadding = $4a79f47042aa6cdc$var$countPadding(signature, paramBytes, signature.length);
    const rLength = paramBytes - rPadding;
    const sLength = paramBytes - sPadding;
    const rsBytes = 2 + rLength + 1 + 1 + sLength;
    const shortLength = rsBytes < $4a79f47042aa6cdc$var$MAX_OCTET;
    const dst = new Uint8Array((shortLength ? 2 : 3) + rsBytes);
    let offset = 0;
    dst[offset++] = $4a79f47042aa6cdc$var$ENCODED_TAG_SEQ;
    if (shortLength) // Bit 8 has value "0"
    // bits 7-1 give the length.
    dst[offset++] = rsBytes;
    else {
        // Bit 8 of first octet has value "1"
        // bits 7-1 give the number of additional length octets.
        dst[offset++] = $4a79f47042aa6cdc$var$MAX_OCTET | 1;
        // length, base 256
        dst[offset++] = rsBytes & 0xff;
    }
    dst[offset++] = $4a79f47042aa6cdc$var$ENCODED_TAG_INT;
    dst[offset++] = rLength;
    if (rPadding < 0) {
        dst[offset++] = 0;
        dst.set(signature.subarray(0, paramBytes), offset);
        offset += paramBytes;
    } else {
        dst.set(signature.subarray(rPadding, paramBytes), offset);
        offset += paramBytes - rPadding;
    }
    dst[offset++] = $4a79f47042aa6cdc$var$ENCODED_TAG_INT;
    dst[offset++] = sLength;
    if (sPadding < 0) {
        dst[offset++] = 0;
        dst.set(signature.subarray(paramBytes), offset);
    } else dst.set(signature.subarray(paramBytes + sPadding), offset);
    return dst;
}
module.exports.joseToDer = $4a79f47042aa6cdc$var$joseToDer;

});

parcelRegister("kDPfV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidTokenError = module.exports.MissingParametersError = void 0;
class $f06f3588dbc17c04$var$MissingParametersError extends Error {
    constructor(message){
        super();
        this.name = "MissingParametersError";
        this.message = message || "";
    }
}
module.exports.MissingParametersError = $f06f3588dbc17c04$var$MissingParametersError;
class $f06f3588dbc17c04$var$InvalidTokenError extends Error {
    constructor(message){
        super();
        this.name = "InvalidTokenError";
        this.message = message || "";
    }
}
module.exports.InvalidTokenError = $f06f3588dbc17c04$var$InvalidTokenError;

});



parcelRegister("kRrbd", function(module, exports) {
"use strict";
var $f2fdd743bb346f1e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashSha256Async = module.exports.hashSha256 = void 0;

var $hX4ZG = parcelRequire("hX4ZG");
function $f2fdd743bb346f1e$var$hashSha256(input) {
    return (0, $hX4ZG.sha256)(input);
}
module.exports.hashSha256 = $f2fdd743bb346f1e$var$hashSha256;

function $f2fdd743bb346f1e$var$hashSha256Async(input) {
    return $f2fdd743bb346f1e$var$__awaiter(this, void 0, void 0, function*() {
        try {
            const isSubtleCryptoAvailable = typeof crypto !== "undefined" && typeof crypto.subtle !== "undefined";
            if (isSubtleCryptoAvailable) {
                // Use the W3C Web Crypto API if available (running in a web browser).
                const bytes = typeof input === "string" ? new TextEncoder().encode(input) : input;
                const hash = yield crypto.subtle.digest("SHA-256", bytes);
                return new Uint8Array(hash);
            } else {
                // Otherwise try loading the Node.js `crypto` module (running in Node.js, or an older browser with a polyfill).
                const nodeCrypto = (parcelRequire("ct9Rv"));
                if (!nodeCrypto.createHash) throw new Error("`crypto` module does not contain `createHash`");
                return Promise.resolve(nodeCrypto.createHash("sha256").update(input).digest());
            }
        } catch (error) {
            console.log(error);
            console.log('Crypto lib not found. Neither the global `crypto.subtle` Web Crypto API, nor the or the Node.js `require("crypto").createHash` module is available. Falling back to JS implementation.');
            return Promise.resolve($f2fdd743bb346f1e$var$hashSha256(input));
        }
    });
}
module.exports.hashSha256Async = $f2fdd743bb346f1e$var$hashSha256Async;

});


parcelRegister("gEccP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenVerifier = void 0;

var $aT9GC = parcelRequire("aT9GC");

var $ccACr = parcelRequire("ccACr");

var $kDPfV = parcelRequire("kDPfV");

var $kRrbd = parcelRequire("kRrbd");
class $c1e9d99efd945629$var$TokenVerifier {
    constructor(signingAlgorithm, rawPublicKey){
        if (!(signingAlgorithm && rawPublicKey)) throw new $kDPfV.MissingParametersError("a signing algorithm and public key are required");
        if (typeof signingAlgorithm !== "string") throw "signing algorithm parameter must be a string";
        signingAlgorithm = signingAlgorithm.toUpperCase();
        if (!$ccACr.cryptoClients.hasOwnProperty(signingAlgorithm)) throw "invalid signing algorithm";
        this.tokenType = "JWT";
        this.cryptoClient = $ccACr.cryptoClients[signingAlgorithm];
        this.rawPublicKey = rawPublicKey;
    }
    verify(token) {
        if (typeof token === "string") return this.verifyCompact(token, false);
        else if (typeof token === "object") return this.verifyExpanded(token, false);
        else return false;
    }
    verifyAsync(token) {
        if (typeof token === "string") return this.verifyCompact(token, true);
        else if (typeof token === "object") return this.verifyExpanded(token, true);
        else return Promise.resolve(false);
    }
    verifyCompact(token, async) {
        // decompose the token into parts
        const tokenParts = token.split(".");
        // calculate the signing input hash
        const signingInput = tokenParts[0] + "." + tokenParts[1];
        const performVerify = (signingInputHash)=>{
            // extract the signature as a DER array
            const derSignatureBytes = this.cryptoClient.loadSignature(tokenParts[2]);
            // verify the signed hash
            return this.cryptoClient.verifyHash(signingInputHash, derSignatureBytes, this.rawPublicKey);
        };
        if (async) return (0, $kRrbd.hashSha256Async)(signingInput).then((signingInputHash)=>performVerify(signingInputHash));
        else {
            const signingInputHash = (0, $kRrbd.hashSha256)(signingInput);
            return performVerify(signingInputHash);
        }
    }
    verifyExpanded(token, async) {
        const signingInput = [
            token["header"].join("."),
            $aT9GC.encode(token["payload"])
        ].join(".");
        let verified = true;
        const performVerify = (signingInputHash)=>{
            token["signature"].map((signature)=>{
                const derSignatureBytes = this.cryptoClient.loadSignature(signature);
                const signatureVerified = this.cryptoClient.verifyHash(signingInputHash, derSignatureBytes, this.rawPublicKey);
                if (!signatureVerified) verified = false;
            });
            return verified;
        };
        if (async) return (0, $kRrbd.hashSha256Async)(signingInput).then((signingInputHash)=>performVerify(signingInputHash));
        else {
            const signingInputHash = (0, $kRrbd.hashSha256)(signingInput);
            return performVerify(signingInputHash);
        }
    }
}
module.exports.TokenVerifier = $c1e9d99efd945629$var$TokenVerifier;

});

parcelRegister("j8owO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeToken = void 0;

var $aT9GC = parcelRequire("aT9GC");
function $dee1ca761ee53a1b$var$decodeToken(token) {
    if (typeof token === "string") {
        // decompose the token into parts
        const tokenParts = token.split(".");
        const header = JSON.parse($aT9GC.decode(tokenParts[0]));
        const payload = JSON.parse($aT9GC.decode(tokenParts[1]));
        const signature = tokenParts[2];
        // return the token object
        return {
            header: header,
            payload: payload,
            signature: signature
        };
    } else if (typeof token === "object") {
        if (typeof token.payload !== "string") throw new Error("Expected token payload to be a base64 or json string");
        let payload = token.payload;
        if (token.payload[0] !== "{") payload = $aT9GC.decode(payload);
        const allHeaders = [];
        token.header.map((headerValue)=>{
            const header = JSON.parse($aT9GC.decode(headerValue));
            allHeaders.push(header);
        });
        return {
            header: allHeaders,
            payload: JSON.parse(payload),
            signature: token.signature
        };
    }
}
module.exports.decodeToken = $dee1ca761ee53a1b$var$decodeToken;

});

parcelRegister("asgrE", function(module, exports) {

$parcel$export(module.exports, "check", () => check);
$parcel$export(module.exports, "maxLength", () => maxLength);
$parcel$export(module.exports, "minLength", () => minLength);
$parcel$export(module.exports, "is", () => is);
$parcel$export(module.exports, "array", () => array);
$parcel$export(module.exports, "boolean", () => boolean);
$parcel$export(module.exports, "enum", () => enum_);
$parcel$export(module.exports, "literal", () => literal);
$parcel$export(module.exports, "looseObject", () => looseObject);
$parcel$export(module.exports, "nonOptional", () => nonOptional);
$parcel$export(module.exports, "null", () => null_);
$parcel$export(module.exports, "nullish", () => nullish);
$parcel$export(module.exports, "number", () => number);
$parcel$export(module.exports, "object", () => object);
$parcel$export(module.exports, "optional", () => optional);
$parcel$export(module.exports, "picklist", () => picklist);
$parcel$export(module.exports, "record", () => record);
$parcel$export(module.exports, "string", () => string);
$parcel$export(module.exports, "union", () => union);
$parcel$export(module.exports, "unknown", () => unknown);
$parcel$export(module.exports, "variant", () => variant);
$parcel$export(module.exports, "omit", () => omit);
$parcel$export(module.exports, "pipe", () => pipe);
$parcel$export(module.exports, "unwrap", () => unwrap);
// src/actions/await/awaitAsync.ts
function awaitAsync() {
    return {
        kind: "transformation",
        type: "await",
        reference: awaitAsync,
        async: true,
        async _run (dataset) {
            dataset.value = await dataset.value;
            return dataset;
        }
    };
}
// src/regex.ts
var BASE64_REGEX = /^(?:[\da-z+/]{4})*(?:[\da-z+/]{2}==|[\da-z+/]{3}=)?$/iu;
var BIC_REGEX = /^[A-Z]{6}(?!00)[\dA-Z]{2}(?:[\dA-Z]{3})?$/u;
var CUID2_REGEX = /^[a-z][\da-z]*$/u;
var DECIMAL_REGEX = /^[+-]?\d+(?:\.\d+)?$/u;
var DIGITS_REGEX = /^\d+$/u;
var EMAIL_REGEX = /^[\w+-]+(?:\.[\w+-]+)*@[\da-z]+(?:[.-][\da-z]+)*\.[a-z]{2,}$/iu;
var EMOJI_REGEX = // eslint-disable-next-line redos-detector/no-unsafe-regex, regexp/no-dupe-disjunctions -- false positives
/^(?:[\u{1F1E6}-\u{1F1FF}]{2}|\u{1F3F4}[\u{E0061}-\u{E007A}]{2}[\u{E0030}-\u{E0039}\u{E0061}-\u{E007A}]{1,3}\u{E007F}|(?:\p{Emoji}\uFE0F\u20E3?|\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Presentation})(?:\u200D(?:\p{Emoji}\uFE0F\u20E3?|\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Presentation}))*)+$/u;
var HEXADECIMAL_REGEX = /^(?:0[hx])?[\da-f]+$/iu;
var HEX_COLOR_REGEX = /^#(?:[\da-f]{3,4}|[\da-f]{6}|[\da-f]{8})$/iu;
var IMEI_REGEX = /^\d{15}$|^\d{2}-\d{6}-\d{6}-\d$/u;
var IPV4_REGEX = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive
/^(?:(?:[1-9]|1\d|2[0-4])?\d|25[0-5])(?:\.(?:(?:[1-9]|1\d|2[0-4])?\d|25[0-5])){3}$/u;
var IPV6_REGEX = /^(?:(?:[\da-f]{1,4}:){7}[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,7}:|(?:[\da-f]{1,4}:){1,6}:[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,5}(?::[\da-f]{1,4}){1,2}|(?:[\da-f]{1,4}:){1,4}(?::[\da-f]{1,4}){1,3}|(?:[\da-f]{1,4}:){1,3}(?::[\da-f]{1,4}){1,4}|(?:[\da-f]{1,4}:){1,2}(?::[\da-f]{1,4}){1,5}|[\da-f]{1,4}:(?::[\da-f]{1,4}){1,6}|:(?:(?::[\da-f]{1,4}){1,7}|:)|fe80:(?::[\da-f]{0,4}){0,4}%[\da-z]+|::(?:f{4}(?::0{1,4})?:)?(?:(?:25[0-5]|(?:2[0-4]|1?\d)?\d)\.){3}(?:25[0-5]|(?:2[0-4]|1?\d)?\d)|(?:[\da-f]{1,4}:){1,4}:(?:(?:25[0-5]|(?:2[0-4]|1?\d)?\d)\.){3}(?:25[0-5]|(?:2[0-4]|1?\d)?\d))$/iu;
var IP_REGEX = /^(?:(?:[1-9]|1\d|2[0-4])?\d|25[0-5])(?:\.(?:(?:[1-9]|1\d|2[0-4])?\d|25[0-5])){3}$|^(?:(?:[\da-f]{1,4}:){7}[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,7}:|(?:[\da-f]{1,4}:){1,6}:[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,5}(?::[\da-f]{1,4}){1,2}|(?:[\da-f]{1,4}:){1,4}(?::[\da-f]{1,4}){1,3}|(?:[\da-f]{1,4}:){1,3}(?::[\da-f]{1,4}){1,4}|(?:[\da-f]{1,4}:){1,2}(?::[\da-f]{1,4}){1,5}|[\da-f]{1,4}:(?::[\da-f]{1,4}){1,6}|:(?:(?::[\da-f]{1,4}){1,7}|:)|fe80:(?::[\da-f]{0,4}){0,4}%[\da-z]+|::(?:f{4}(?::0{1,4})?:)?(?:(?:25[0-5]|(?:2[0-4]|1?\d)?\d)\.){3}(?:25[0-5]|(?:2[0-4]|1?\d)?\d)|(?:[\da-f]{1,4}:){1,4}:(?:(?:25[0-5]|(?:2[0-4]|1?\d)?\d)\.){3}(?:25[0-5]|(?:2[0-4]|1?\d)?\d))$/iu;
var ISO_DATE_REGEX = /^\d{4}-(?:0[1-9]|1[0-2])-(?:[12]\d|0[1-9]|3[01])$/u;
var ISO_DATE_TIME_REGEX = /^\d{4}-(?:0[1-9]|1[0-2])-(?:[12]\d|0[1-9]|3[01])T(?:0\d|1\d|2[0-3]):[0-5]\d$/u;
var ISO_TIME_REGEX = /^(?:0\d|1\d|2[0-3]):[0-5]\d$/u;
var ISO_TIME_SECOND_REGEX = /^(?:0\d|1\d|2[0-3])(?::[0-5]\d){2}$/u;
var ISO_TIMESTAMP_REGEX = /^\d{4}-(?:0[1-9]|1[0-2])-(?:[12]\d|0[1-9]|3[01])T(?:0\d|1\d|2[0-3])(?::[0-5]\d){2}(?:\.\d{1,9})?(?:Z|[+-](?:0\d|1\d|2[0-3])(?::?[0-5]\d)?)$/u;
var ISO_WEEK_REGEX = /^\d{4}-W(?:0[1-9]|[1-4]\d|5[0-3])$/u;
var MAC48_REGEX = /^(?:[\da-f]{2}:){5}[\da-f]{2}$|^(?:[\da-f]{2}-){5}[\da-f]{2}$|^(?:[\da-f]{4}\.){2}[\da-f]{4}$/iu;
var MAC64_REGEX = /^(?:[\da-f]{2}:){7}[\da-f]{2}$|^(?:[\da-f]{2}-){7}[\da-f]{2}$|^(?:[\da-f]{4}\.){3}[\da-f]{4}$|^(?:[\da-f]{4}:){3}[\da-f]{4}$/iu;
var MAC_REGEX = /^(?:[\da-f]{2}:){5}[\da-f]{2}$|^(?:[\da-f]{2}-){5}[\da-f]{2}$|^(?:[\da-f]{4}\.){2}[\da-f]{4}$|^(?:[\da-f]{2}:){7}[\da-f]{2}$|^(?:[\da-f]{2}-){7}[\da-f]{2}$|^(?:[\da-f]{4}\.){3}[\da-f]{4}$|^(?:[\da-f]{4}:){3}[\da-f]{4}$/iu;
var NANO_ID_REGEX = /^[\w-]+$/u;
var OCTAL_REGEX = /^(?:0o)?[0-7]+$/iu;
var ULID_REGEX = /^[\da-hjkmnp-tv-z]{26}$/iu;
var UUID_REGEX = /^[\da-f]{8}(?:-[\da-f]{4}){3}-[\da-f]{12}$/iu;
// src/storages/globalConfig/globalConfig.ts
var store;
function setGlobalConfig(config2) {
    store = {
        ...store,
        ...config2
    };
}
function getGlobalConfig(config2) {
    return {
        lang: config2?.lang ?? store?.lang,
        message: config2?.message,
        abortEarly: config2?.abortEarly ?? store?.abortEarly,
        abortPipeEarly: config2?.abortPipeEarly ?? store?.abortPipeEarly
    };
}
function deleteGlobalConfig() {
    store = void 0;
}
// src/storages/globalMessage/globalMessage.ts
var store2;
function setGlobalMessage(message, lang) {
    if (!store2) store2 = /* @__PURE__ */ new Map();
    store2.set(lang, message);
}
function getGlobalMessage(lang) {
    return store2?.get(lang);
}
function deleteGlobalMessage(lang) {
    store2?.delete(lang);
}
// src/storages/schemaMessage/schemaMessage.ts
var store3;
function setSchemaMessage(message, lang) {
    if (!store3) store3 = /* @__PURE__ */ new Map();
    store3.set(lang, message);
}
function getSchemaMessage(lang) {
    return store3?.get(lang);
}
function deleteSchemaMessage(lang) {
    store3?.delete(lang);
}
// src/storages/specificMessage/specificMessage.ts
var store4;
function setSpecificMessage(reference, message, lang) {
    if (!store4) store4 = /* @__PURE__ */ new Map();
    if (!store4.get(reference)) store4.set(reference, /* @__PURE__ */ new Map());
    store4.get(reference).set(lang, message);
}
function getSpecificMessage(reference, lang) {
    return store4?.get(reference)?.get(lang);
}
function deleteSpecificMessage(reference, lang) {
    store4?.get(reference)?.delete(lang);
}
// src/utils/_stringify/_stringify.ts
function _stringify(input) {
    const type = typeof input;
    if (type === "string") return `"${input}"`;
    if (type === "number" || type === "bigint" || type === "boolean") return `${input}`;
    if (type === "object" || type === "function") return (input && Object.getPrototypeOf(input)?.constructor?.name) ?? "null";
    return type;
}
// src/utils/_addIssue/_addIssue.ts
function _addIssue(context, label, dataset, config2, other) {
    const input = other && "input" in other ? other.input : dataset.value;
    const expected = other?.expected ?? context.expects ?? null;
    const received = other?.received ?? _stringify(input);
    const issue = {
        kind: context.kind,
        type: context.type,
        input: input,
        expected: expected,
        received: received,
        message: `Invalid ${label}: ${expected ? `Expected ${expected} but r` : "R"}eceived ${received}`,
        requirement: context.requirement,
        path: other?.path,
        issues: other?.issues,
        lang: config2.lang,
        abortEarly: config2.abortEarly,
        abortPipeEarly: config2.abortPipeEarly
    };
    const isSchema = context.kind === "schema";
    const message = other?.message ?? context.message ?? getSpecificMessage(context.reference, issue.lang) ?? (isSchema ? getSchemaMessage(issue.lang) : null) ?? config2.message ?? getGlobalMessage(issue.lang);
    if (message) issue.message = typeof message === "function" ? // @ts-expect-error
    message(issue) : message;
    if (isSchema) dataset.typed = false;
    if (dataset.issues) dataset.issues.push(issue);
    else dataset.issues = [
        issue
    ];
}
// src/utils/_isLuhnAlgo/_isLuhnAlgo.ts
var NON_DIGIT_REGEX = /\D/gu;
function _isLuhnAlgo(input) {
    const number2 = input.replace(NON_DIGIT_REGEX, "");
    let length2 = number2.length;
    let bit = 1;
    let sum = 0;
    while(length2){
        const value2 = +number2[--length2];
        bit ^= 1;
        sum += bit ? [
            0,
            2,
            4,
            6,
            8,
            1,
            3,
            5,
            7,
            9
        ][value2] : value2;
    }
    return sum % 10 === 0;
}
// src/utils/_isValidObjectKey/_isValidObjectKey.ts
function _isValidObjectKey(object2, key) {
    return Object.hasOwn(object2, key) && key !== "__proto__" && key !== "prototype" && key !== "constructor";
}
// src/utils/_joinExpects/_joinExpects.ts
function _joinExpects(values, separator) {
    const list = [
        ...new Set(values)
    ];
    if (list.length > 1) return `(${list.join(` ${separator} `)})`;
    return list[0] ?? "never";
}
// src/utils/entriesFromList/entriesFromList.ts
function entriesFromList(list, schema) {
    const entries = {};
    for (const key of list)entries[key] = schema;
    return entries;
}
// src/utils/getDotPath/getDotPath.ts
function getDotPath(issue) {
    if (issue.path) {
        let key = "";
        for (const item of issue.path){
            if (typeof item.key === "string" || typeof item.key === "number") {
                if (key) key += `.${item.key}`;
                else key += item.key;
            } else return null;
        }
        return key;
    }
    return null;
}
// src/utils/isOfKind/isOfKind.ts
function isOfKind(kind, object2) {
    return object2.kind === kind;
}
// src/utils/isOfType/isOfType.ts
function isOfType(type, object2) {
    return object2.type === type;
}
// src/utils/isValiError/isValiError.ts
function isValiError(error) {
    return error instanceof ValiError;
}
// src/utils/ValiError/ValiError.ts
var ValiError = class extends Error {
    /**
   * The error issues.
   */ issues;
    /**
   * Creates a Valibot error with useful information.
   *
   * @param issues The error issues.
   */ constructor(issues){
        super(issues[0].message);
        this.name = "ValiError";
        this.issues = issues;
    }
};
// src/actions/base64/base64.ts
function base64(message) {
    return {
        kind: "validation",
        type: "base64",
        reference: base64,
        async: false,
        expects: null,
        requirement: BASE64_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "Base64", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/bic/bic.ts
function bic(message) {
    return {
        kind: "validation",
        type: "bic",
        reference: bic,
        async: false,
        expects: null,
        requirement: BIC_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "BIC", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/brand/brand.ts
function brand(name) {
    return {
        kind: "transformation",
        type: "brand",
        reference: brand,
        async: false,
        name: name,
        _run (dataset) {
            return dataset;
        }
    };
}
// src/actions/bytes/bytes.ts
function bytes(requirement, message) {
    return {
        kind: "validation",
        type: "bytes",
        reference: bytes,
        async: false,
        expects: `${requirement}`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed) {
                const length2 = new TextEncoder().encode(dataset.value).length;
                if (length2 !== this.requirement) _addIssue(this, "bytes", dataset, config2, {
                    received: `${length2}`
                });
            }
            return dataset;
        }
    };
}
// src/actions/check/check.ts
function check(requirement, message) {
    return {
        kind: "validation",
        type: "check",
        reference: check,
        async: false,
        expects: null,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement(dataset.value)) _addIssue(this, "input", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/check/checkAsync.ts
function checkAsync(requirement, message) {
    return {
        kind: "validation",
        type: "check",
        reference: checkAsync,
        async: true,
        expects: null,
        requirement: requirement,
        message: message,
        async _run (dataset, config2) {
            if (dataset.typed && !await this.requirement(dataset.value)) _addIssue(this, "input", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/checkItems/checkItems.ts
function checkItems(requirement, message) {
    return {
        kind: "validation",
        type: "check_items",
        reference: checkItems,
        async: false,
        expects: null,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed) for(let index = 0; index < dataset.value.length; index++){
                const item = dataset.value[index];
                if (!this.requirement(item, index, dataset.value)) _addIssue(this, "item", dataset, config2, {
                    input: item,
                    path: [
                        {
                            type: "array",
                            origin: "value",
                            input: dataset.value,
                            key: index,
                            value: item
                        }
                    ]
                });
            }
            return dataset;
        }
    };
}
// src/actions/creditCard/creditCard.ts
var CREDIT_CARD_REGEX = /^(?:\d{14,19}|\d{4}(?: \d{3,6}){2,4}|\d{4}(?:-\d{3,6}){2,4})$/u;
var SANITIZE_REGEX = /[- ]/gu;
var PROVIDER_REGEX_LIST = [
    // American Express
    /^3[47]\d{13}$/u,
    // Diners Club
    /^3(?:0[0-5]|[68]\d)\d{11,13}$/u,
    // Discover
    /^6(?:011|5\d{2})\d{12,15}$/u,
    // JCB
    /^(?:2131|1800|35\d{3})\d{11}$/u,
    // Mastercard
    /^5[1-5]\d{2}|(?:222\d|22[3-9]\d|2[3-6]\d{2}|27[01]\d|2720)\d{12}$/u,
    // UnionPay
    /^(?:6[27]\d{14,17}|81\d{14,17})$/u,
    // Visa
    /^4\d{12}(?:\d{3,6})?$/u
];
function creditCard(message) {
    return {
        kind: "validation",
        type: "credit_card",
        reference: creditCard,
        async: false,
        expects: null,
        requirement (input) {
            let sanitized;
            return CREDIT_CARD_REGEX.test(input) && // Remove any hyphens and blanks
            (sanitized = input.replace(SANITIZE_REGEX, "")) && // Check if it matches a provider
            PROVIDER_REGEX_LIST.some((regex2)=>regex2.test(sanitized)) && // Check if passes luhn algorithm
            _isLuhnAlgo(sanitized);
        },
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement(dataset.value)) _addIssue(this, "credit card", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/cuid2/cuid2.ts
function cuid2(message) {
    return {
        kind: "validation",
        type: "cuid2",
        reference: cuid2,
        async: false,
        expects: null,
        requirement: CUID2_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "Cuid2", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/decimal/decimal.ts
function decimal(message) {
    return {
        kind: "validation",
        type: "decimal",
        reference: decimal,
        async: false,
        expects: null,
        requirement: DECIMAL_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "decimal", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/description/description.ts
function description(description_) {
    return {
        kind: "metadata",
        type: "description",
        reference: description,
        description: description_
    };
}
// src/actions/digits/digits.ts
function digits(message) {
    return {
        kind: "validation",
        type: "digits",
        reference: digits,
        async: false,
        expects: null,
        requirement: DIGITS_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "digits", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/email/email.ts
function email(message) {
    return {
        kind: "validation",
        type: "email",
        reference: email,
        expects: null,
        async: false,
        requirement: EMAIL_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "email", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/emoji/emoji.ts
function emoji(message) {
    return {
        kind: "validation",
        type: "emoji",
        reference: emoji,
        async: false,
        expects: null,
        requirement: EMOJI_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "emoji", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/empty/empty.ts
function empty(message) {
    return {
        kind: "validation",
        type: "empty",
        reference: empty,
        async: false,
        expects: "0",
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && dataset.value.length > 0) _addIssue(this, "length", dataset, config2, {
                received: `${dataset.value.length}`
            });
            return dataset;
        }
    };
}
// src/actions/endsWith/endsWith.ts
function endsWith(requirement, message) {
    return {
        kind: "validation",
        type: "ends_with",
        reference: endsWith,
        async: false,
        expects: `"${requirement}"`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !dataset.value.endsWith(this.requirement)) _addIssue(this, "end", dataset, config2, {
                received: `"${dataset.value.slice(-this.requirement.length)}"`
            });
            return dataset;
        }
    };
}
// src/actions/everyItem/everyItem.ts
function everyItem(requirement, message) {
    return {
        kind: "validation",
        type: "every_item",
        reference: everyItem,
        async: false,
        expects: null,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !dataset.value.every(this.requirement)) _addIssue(this, "item", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/excludes/excludes.ts
function excludes(requirement, message) {
    const received = _stringify(requirement);
    return {
        kind: "validation",
        type: "excludes",
        reference: excludes,
        async: false,
        expects: `!${received}`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && dataset.value.includes(this.requirement)) _addIssue(this, "content", dataset, config2, {
                received: received
            });
            return dataset;
        }
    };
}
// src/actions/filterItems/filterItems.ts
function filterItems(operation) {
    return {
        kind: "transformation",
        type: "filter_items",
        reference: filterItems,
        async: false,
        operation: operation,
        _run (dataset) {
            dataset.value = dataset.value.filter(this.operation);
            return dataset;
        }
    };
}
// src/actions/findItem/findItem.ts
function findItem(operation) {
    return {
        kind: "transformation",
        type: "find_item",
        reference: findItem,
        async: false,
        operation: operation,
        _run (dataset) {
            dataset.value = dataset.value.find(this.operation);
            return dataset;
        }
    };
}
// src/actions/finite/finite.ts
function finite(message) {
    return {
        kind: "validation",
        type: "finite",
        reference: finite,
        async: false,
        expects: null,
        requirement: Number.isFinite,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement(dataset.value)) _addIssue(this, "finite", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/hash/hash.ts
var HASH_LENGTHS = {
    md4: 32,
    md5: 32,
    sha1: 40,
    sha256: 64,
    sha384: 96,
    sha512: 128,
    ripemd128: 32,
    ripemd160: 40,
    tiger128: 32,
    tiger160: 40,
    tiger192: 48,
    crc32: 8,
    crc32b: 8,
    adler32: 8
};
function hash(types, message) {
    return {
        kind: "validation",
        type: "hash",
        reference: hash,
        expects: null,
        async: false,
        requirement: RegExp(types.map((type)=>`^[a-f0-9]{${HASH_LENGTHS[type]}}$`).join("|"), "iu"),
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "hash", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/hexadecimal/hexadecimal.ts
function hexadecimal(message) {
    return {
        kind: "validation",
        type: "hexadecimal",
        reference: hexadecimal,
        async: false,
        expects: null,
        requirement: HEXADECIMAL_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "hexadecimal", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/hexColor/hexColor.ts
function hexColor(message) {
    return {
        kind: "validation",
        type: "hex_color",
        reference: hexColor,
        async: false,
        expects: null,
        requirement: HEX_COLOR_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "hex color", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/imei/imei.ts
function imei(message) {
    return {
        kind: "validation",
        type: "imei",
        reference: imei,
        async: false,
        expects: null,
        requirement (input) {
            return IMEI_REGEX.test(input) && _isLuhnAlgo(input);
        },
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement(dataset.value)) _addIssue(this, "IMEI", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/includes/includes.ts
function includes(requirement, message) {
    const expects = _stringify(requirement);
    return {
        kind: "validation",
        type: "includes",
        reference: includes,
        async: false,
        expects: expects,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !dataset.value.includes(this.requirement)) _addIssue(this, "content", dataset, config2, {
                received: `!${expects}`
            });
            return dataset;
        }
    };
}
// src/actions/integer/integer.ts
function integer(message) {
    return {
        kind: "validation",
        type: "integer",
        reference: integer,
        async: false,
        expects: null,
        requirement: Number.isInteger,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement(dataset.value)) _addIssue(this, "integer", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/ip/ip.ts
function ip(message) {
    return {
        kind: "validation",
        type: "ip",
        reference: ip,
        async: false,
        expects: null,
        requirement: IP_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "IP", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/ipv4/ipv4.ts
function ipv4(message) {
    return {
        kind: "validation",
        type: "ipv4",
        reference: ipv4,
        async: false,
        expects: null,
        requirement: IPV4_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "IPv4", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/ipv6/ipv6.ts
function ipv6(message) {
    return {
        kind: "validation",
        type: "ipv6",
        reference: ipv6,
        async: false,
        expects: null,
        requirement: IPV6_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "IPv6", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/isoDate/isoDate.ts
function isoDate(message) {
    return {
        kind: "validation",
        type: "iso_date",
        reference: isoDate,
        async: false,
        expects: null,
        requirement: ISO_DATE_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "date", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/isoDateTime/isoDateTime.ts
function isoDateTime(message) {
    return {
        kind: "validation",
        type: "iso_date_time",
        reference: isoDateTime,
        async: false,
        expects: null,
        requirement: ISO_DATE_TIME_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "date-time", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/isoTime/isoTime.ts
function isoTime(message) {
    return {
        kind: "validation",
        type: "iso_time",
        reference: isoTime,
        async: false,
        expects: null,
        requirement: ISO_TIME_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "time", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/isoTimeSecond/isoTimeSecond.ts
function isoTimeSecond(message) {
    return {
        kind: "validation",
        type: "iso_time_second",
        reference: isoTimeSecond,
        async: false,
        expects: null,
        requirement: ISO_TIME_SECOND_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "time-second", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/isoTimestamp/isoTimestamp.ts
function isoTimestamp(message) {
    return {
        kind: "validation",
        type: "iso_timestamp",
        reference: isoTimestamp,
        async: false,
        expects: null,
        requirement: ISO_TIMESTAMP_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "timestamp", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/isoWeek/isoWeek.ts
function isoWeek(message) {
    return {
        kind: "validation",
        type: "iso_week",
        reference: isoWeek,
        async: false,
        expects: null,
        requirement: ISO_WEEK_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "week", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/length/length.ts
function length(requirement, message) {
    return {
        kind: "validation",
        type: "length",
        reference: length,
        async: false,
        expects: `${requirement}`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && dataset.value.length !== this.requirement) _addIssue(this, "length", dataset, config2, {
                received: `${dataset.value.length}`
            });
            return dataset;
        }
    };
}
// src/actions/mac/mac.ts
function mac(message) {
    return {
        kind: "validation",
        type: "mac",
        reference: mac,
        async: false,
        expects: null,
        requirement: MAC_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "MAC", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/mac48/mac48.ts
function mac48(message) {
    return {
        kind: "validation",
        type: "mac48",
        reference: mac48,
        async: false,
        expects: null,
        requirement: MAC48_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "48-bit MAC", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/mac64/mac64.ts
function mac64(message) {
    return {
        kind: "validation",
        type: "mac64",
        reference: mac64,
        async: false,
        expects: null,
        requirement: MAC64_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "64-bit MAC", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/mapItems/mapItems.ts
function mapItems(operation) {
    return {
        kind: "transformation",
        type: "map_items",
        reference: mapItems,
        async: false,
        operation: operation,
        _run (dataset) {
            dataset.value = dataset.value.map(this.operation);
            return dataset;
        }
    };
}
// src/actions/maxBytes/maxBytes.ts
function maxBytes(requirement, message) {
    return {
        kind: "validation",
        type: "max_bytes",
        reference: maxBytes,
        async: false,
        expects: `<=${requirement}`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed) {
                const length2 = new TextEncoder().encode(dataset.value).length;
                if (length2 > this.requirement) _addIssue(this, "bytes", dataset, config2, {
                    received: `${length2}`
                });
            }
            return dataset;
        }
    };
}
// src/actions/maxLength/maxLength.ts
function maxLength(requirement, message) {
    return {
        kind: "validation",
        type: "max_length",
        reference: maxLength,
        async: false,
        expects: `<=${requirement}`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && dataset.value.length > this.requirement) _addIssue(this, "length", dataset, config2, {
                received: `${dataset.value.length}`
            });
            return dataset;
        }
    };
}
// src/actions/maxSize/maxSize.ts
function maxSize(requirement, message) {
    return {
        kind: "validation",
        type: "max_size",
        reference: maxSize,
        async: false,
        expects: `<=${requirement}`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && dataset.value.size > this.requirement) _addIssue(this, "size", dataset, config2, {
                received: `${dataset.value.size}`
            });
            return dataset;
        }
    };
}
// src/actions/maxValue/maxValue.ts
function maxValue(requirement, message) {
    return {
        kind: "validation",
        type: "max_value",
        reference: maxValue,
        async: false,
        expects: `<=${requirement instanceof Date ? requirement.toJSON() : _stringify(requirement)}`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && dataset.value > this.requirement) _addIssue(this, "value", dataset, config2, {
                received: dataset.value instanceof Date ? dataset.value.toJSON() : _stringify(dataset.value)
            });
            return dataset;
        }
    };
}
// src/actions/metadata/metadata.ts
function metadata(metadata_) {
    return {
        kind: "metadata",
        type: "metadata",
        reference: metadata,
        metadata: metadata_
    };
}
// src/actions/mimeType/mimeType.ts
function mimeType(requirement, message) {
    return {
        kind: "validation",
        type: "mime_type",
        reference: mimeType,
        async: false,
        expects: _joinExpects(requirement.map((option)=>`"${option}"`), "|"),
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.includes(dataset.value.type)) _addIssue(this, "MIME type", dataset, config2, {
                received: `"${dataset.value.type}"`
            });
            return dataset;
        }
    };
}
// src/actions/minBytes/minBytes.ts
function minBytes(requirement, message) {
    return {
        kind: "validation",
        type: "min_bytes",
        reference: minBytes,
        async: false,
        expects: `>=${requirement}`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed) {
                const length2 = new TextEncoder().encode(dataset.value).length;
                if (length2 < this.requirement) _addIssue(this, "bytes", dataset, config2, {
                    received: `${length2}`
                });
            }
            return dataset;
        }
    };
}
// src/actions/minLength/minLength.ts
function minLength(requirement, message) {
    return {
        kind: "validation",
        type: "min_length",
        reference: minLength,
        async: false,
        expects: `>=${requirement}`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && dataset.value.length < this.requirement) _addIssue(this, "length", dataset, config2, {
                received: `${dataset.value.length}`
            });
            return dataset;
        }
    };
}
// src/actions/minSize/minSize.ts
function minSize(requirement, message) {
    return {
        kind: "validation",
        type: "min_size",
        reference: minSize,
        async: false,
        expects: `>=${requirement}`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && dataset.value.size < this.requirement) _addIssue(this, "size", dataset, config2, {
                received: `${dataset.value.size}`
            });
            return dataset;
        }
    };
}
// src/actions/minValue/minValue.ts
function minValue(requirement, message) {
    return {
        kind: "validation",
        type: "min_value",
        reference: minValue,
        async: false,
        expects: `>=${requirement instanceof Date ? requirement.toJSON() : _stringify(requirement)}`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && dataset.value < this.requirement) _addIssue(this, "value", dataset, config2, {
                received: dataset.value instanceof Date ? dataset.value.toJSON() : _stringify(dataset.value)
            });
            return dataset;
        }
    };
}
// src/actions/multipleOf/multipleOf.ts
function multipleOf(requirement, message) {
    return {
        kind: "validation",
        type: "multiple_of",
        reference: multipleOf,
        async: false,
        expects: `%${requirement}`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && dataset.value % this.requirement !== 0) _addIssue(this, "multiple", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/nanoid/nanoid.ts
function nanoid(message) {
    return {
        kind: "validation",
        type: "nanoid",
        reference: nanoid,
        async: false,
        expects: null,
        requirement: NANO_ID_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "Nano ID", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/nonEmpty/nonEmpty.ts
function nonEmpty(message) {
    return {
        kind: "validation",
        type: "non_empty",
        reference: nonEmpty,
        async: false,
        expects: "!0",
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && dataset.value.length === 0) _addIssue(this, "length", dataset, config2, {
                received: "0"
            });
            return dataset;
        }
    };
}
// src/actions/normalize/normalize.ts
function normalize(form) {
    return {
        kind: "transformation",
        type: "normalize",
        reference: normalize,
        async: false,
        form: form,
        _run (dataset) {
            dataset.value = dataset.value.normalize(this.form);
            return dataset;
        }
    };
}
// src/actions/notBytes/notBytes.ts
function notBytes(requirement, message) {
    return {
        kind: "validation",
        type: "not_bytes",
        reference: notBytes,
        async: false,
        expects: `!${requirement}`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed) {
                const length2 = new TextEncoder().encode(dataset.value).length;
                if (length2 === this.requirement) _addIssue(this, "bytes", dataset, config2, {
                    received: `${length2}`
                });
            }
            return dataset;
        }
    };
}
// src/actions/notLength/notLength.ts
function notLength(requirement, message) {
    return {
        kind: "validation",
        type: "not_length",
        reference: notLength,
        async: false,
        expects: `!${requirement}`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && dataset.value.length === this.requirement) _addIssue(this, "length", dataset, config2, {
                received: `${dataset.value.length}`
            });
            return dataset;
        }
    };
}
// src/actions/notSize/notSize.ts
function notSize(requirement, message) {
    return {
        kind: "validation",
        type: "not_size",
        reference: notSize,
        async: false,
        expects: `!${requirement}`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && dataset.value.size === this.requirement) _addIssue(this, "size", dataset, config2, {
                received: `${dataset.value.size}`
            });
            return dataset;
        }
    };
}
// src/actions/notValue/notValue.ts
function notValue(requirement, message) {
    return {
        kind: "validation",
        type: "not_value",
        reference: notValue,
        async: false,
        expects: requirement instanceof Date ? `!${requirement.toJSON()}` : `!${_stringify(requirement)}`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && this.requirement <= dataset.value && this.requirement >= dataset.value) _addIssue(this, "value", dataset, config2, {
                received: dataset.value instanceof Date ? dataset.value.toJSON() : _stringify(dataset.value)
            });
            return dataset;
        }
    };
}
// src/actions/octal/octal.ts
function octal(message) {
    return {
        kind: "validation",
        type: "octal",
        reference: octal,
        async: false,
        expects: null,
        requirement: OCTAL_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "octal", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/partialCheck/utils/_isPartiallyTyped/_isPartiallyTyped.ts
function _isPartiallyTyped(dataset, pathList) {
    if (dataset.issues) {
        for (const path of pathList)for (const issue of dataset.issues){
            let typed = false;
            const bound = Math.min(path.length, issue.path?.length ?? 0);
            for(let index = 0; index < bound; index++)if (path[index] !== issue.path[index].key) {
                typed = true;
                break;
            }
            if (!typed) return false;
        }
    }
    return true;
}
// src/actions/partialCheck/partialCheck.ts
function partialCheck(pathList, requirement, message) {
    return {
        kind: "validation",
        type: "partial_check",
        reference: partialCheck,
        async: false,
        expects: null,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (_isPartiallyTyped(dataset, pathList) && // @ts-expect-error
            !this.requirement(dataset.value)) _addIssue(this, "input", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/partialCheck/partialCheckAsync.ts
function partialCheckAsync(pathList, requirement, message) {
    return {
        kind: "validation",
        type: "partial_check",
        reference: partialCheckAsync,
        async: true,
        expects: null,
        requirement: requirement,
        message: message,
        async _run (dataset, config2) {
            if (_isPartiallyTyped(dataset, pathList) && // @ts-expect-error
            !await this.requirement(dataset.value)) _addIssue(this, "input", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/rawCheck/rawCheck.ts
function rawCheck(action) {
    return {
        kind: "validation",
        type: "raw_check",
        reference: rawCheck,
        async: false,
        expects: null,
        _run (dataset, config2) {
            action({
                dataset: dataset,
                config: config2,
                addIssue: (info)=>_addIssue(this, info?.label ?? "input", dataset, config2, info)
            });
            return dataset;
        }
    };
}
// src/actions/rawCheck/rawCheckAsync.ts
function rawCheckAsync(action) {
    return {
        kind: "validation",
        type: "raw_check",
        reference: rawCheckAsync,
        async: true,
        expects: null,
        async _run (dataset, config2) {
            await action({
                dataset: dataset,
                config: config2,
                addIssue: (info)=>_addIssue(this, info?.label ?? "input", dataset, config2, info)
            });
            return dataset;
        }
    };
}
// src/actions/rawTransform/rawTransform.ts
function rawTransform(action) {
    return {
        kind: "transformation",
        type: "raw_transform",
        reference: rawTransform,
        async: false,
        _run (dataset, config2) {
            const output = action({
                dataset: dataset,
                config: config2,
                addIssue: (info)=>_addIssue(this, info?.label ?? "input", dataset, config2, info),
                NEVER: null
            });
            if (dataset.issues) dataset.typed = false;
            else dataset.value = output;
            return dataset;
        }
    };
}
// src/actions/rawTransform/rawTransformAsync.ts
function rawTransformAsync(action) {
    return {
        kind: "transformation",
        type: "raw_transform",
        reference: rawTransformAsync,
        async: true,
        async _run (dataset, config2) {
            const output = await action({
                dataset: dataset,
                config: config2,
                addIssue: (info)=>_addIssue(this, info?.label ?? "input", dataset, config2, info),
                NEVER: null
            });
            if (dataset.issues) dataset.typed = false;
            else dataset.value = output;
            return dataset;
        }
    };
}
// src/actions/readonly/readonly.ts
function readonly() {
    return {
        kind: "transformation",
        type: "readonly",
        reference: readonly,
        async: false,
        _run (dataset) {
            return dataset;
        }
    };
}
// src/actions/reduceItems/reduceItems.ts
function reduceItems(operation, initial) {
    return {
        kind: "transformation",
        type: "reduce_items",
        reference: reduceItems,
        async: false,
        operation: operation,
        initial: initial,
        _run (dataset) {
            dataset.value = dataset.value.reduce(this.operation, this.initial);
            return dataset;
        }
    };
}
// src/actions/regex/regex.ts
function regex(requirement, message) {
    return {
        kind: "validation",
        type: "regex",
        reference: regex,
        async: false,
        expects: `${requirement}`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "format", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/safeInteger/safeInteger.ts
function safeInteger(message) {
    return {
        kind: "validation",
        type: "safe_integer",
        reference: safeInteger,
        async: false,
        expects: null,
        requirement: Number.isSafeInteger,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement(dataset.value)) _addIssue(this, "safe integer", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/size/size.ts
function size(requirement, message) {
    return {
        kind: "validation",
        type: "size",
        reference: size,
        async: false,
        expects: `${requirement}`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && dataset.value.size !== this.requirement) _addIssue(this, "size", dataset, config2, {
                received: `${dataset.value.size}`
            });
            return dataset;
        }
    };
}
// src/actions/someItem/someItem.ts
function someItem(requirement, message) {
    return {
        kind: "validation",
        type: "some_item",
        reference: someItem,
        async: false,
        expects: null,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !dataset.value.some(this.requirement)) _addIssue(this, "item", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/sortItems/sortItems.ts
function sortItems(operation) {
    return {
        kind: "transformation",
        type: "sort_items",
        reference: sortItems,
        async: false,
        operation: operation,
        _run (dataset) {
            dataset.value = dataset.value.sort(this.operation);
            return dataset;
        }
    };
}
// src/actions/startsWith/startsWith.ts
function startsWith(requirement, message) {
    return {
        kind: "validation",
        type: "starts_with",
        reference: startsWith,
        async: false,
        expects: `"${requirement}"`,
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !dataset.value.startsWith(this.requirement)) _addIssue(this, "start", dataset, config2, {
                received: `"${dataset.value.slice(0, this.requirement.length)}"`
            });
            return dataset;
        }
    };
}
// src/actions/title/title.ts
function title(title_) {
    return {
        kind: "metadata",
        type: "title",
        reference: title,
        title: title_
    };
}
// src/actions/toLowerCase/toLowerCase.ts
function toLowerCase() {
    return {
        kind: "transformation",
        type: "to_lower_case",
        reference: toLowerCase,
        async: false,
        _run (dataset) {
            dataset.value = dataset.value.toLowerCase();
            return dataset;
        }
    };
}
// src/actions/toMaxValue/toMaxValue.ts
function toMaxValue(requirement) {
    return {
        kind: "transformation",
        type: "to_max_value",
        reference: toMaxValue,
        async: false,
        requirement: requirement,
        _run (dataset) {
            dataset.value = dataset.value > this.requirement ? this.requirement : dataset.value;
            return dataset;
        }
    };
}
// src/actions/toMinValue/toMinValue.ts
function toMinValue(requirement) {
    return {
        kind: "transformation",
        type: "to_min_value",
        reference: toMinValue,
        async: false,
        requirement: requirement,
        _run (dataset) {
            dataset.value = dataset.value < this.requirement ? this.requirement : dataset.value;
            return dataset;
        }
    };
}
// src/actions/toUpperCase/toUpperCase.ts
function toUpperCase() {
    return {
        kind: "transformation",
        type: "to_upper_case",
        reference: toUpperCase,
        async: false,
        _run (dataset) {
            dataset.value = dataset.value.toUpperCase();
            return dataset;
        }
    };
}
// src/actions/transform/transform.ts
function transform(operation) {
    return {
        kind: "transformation",
        type: "transform",
        reference: transform,
        async: false,
        operation: operation,
        _run (dataset) {
            dataset.value = this.operation(dataset.value);
            return dataset;
        }
    };
}
// src/actions/transform/transformAsync.ts
function transformAsync(operation) {
    return {
        kind: "transformation",
        type: "transform",
        reference: transformAsync,
        async: true,
        operation: operation,
        async _run (dataset) {
            dataset.value = await this.operation(dataset.value);
            return dataset;
        }
    };
}
// src/actions/trim/trim.ts
function trim() {
    return {
        kind: "transformation",
        type: "trim",
        reference: trim,
        async: false,
        _run (dataset) {
            dataset.value = dataset.value.trim();
            return dataset;
        }
    };
}
// src/actions/trimEnd/trimEnd.ts
function trimEnd() {
    return {
        kind: "transformation",
        type: "trim_end",
        reference: trimEnd,
        async: false,
        _run (dataset) {
            dataset.value = dataset.value.trimEnd();
            return dataset;
        }
    };
}
// src/actions/trimStart/trimStart.ts
function trimStart() {
    return {
        kind: "transformation",
        type: "trim_start",
        reference: trimStart,
        async: false,
        _run (dataset) {
            dataset.value = dataset.value.trimStart();
            return dataset;
        }
    };
}
// src/actions/ulid/ulid.ts
function ulid(message) {
    return {
        kind: "validation",
        type: "ulid",
        reference: ulid,
        async: false,
        expects: null,
        requirement: ULID_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "ULID", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/url/url.ts
function url(message) {
    return {
        kind: "validation",
        type: "url",
        reference: url,
        async: false,
        expects: null,
        requirement (input) {
            try {
                new URL(input);
                return true;
            } catch  {
                return false;
            }
        },
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement(dataset.value)) _addIssue(this, "URL", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/uuid/uuid.ts
function uuid(message) {
    return {
        kind: "validation",
        type: "uuid",
        reference: uuid,
        async: false,
        expects: null,
        requirement: UUID_REGEX,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !this.requirement.test(dataset.value)) _addIssue(this, "UUID", dataset, config2);
            return dataset;
        }
    };
}
// src/actions/value/value.ts
function value(requirement, message) {
    return {
        kind: "validation",
        type: "value",
        reference: value,
        async: false,
        expects: requirement instanceof Date ? requirement.toJSON() : _stringify(requirement),
        requirement: requirement,
        message: message,
        _run (dataset, config2) {
            if (dataset.typed && !(this.requirement <= dataset.value && this.requirement >= dataset.value)) _addIssue(this, "value", dataset, config2, {
                received: dataset.value instanceof Date ? dataset.value.toJSON() : _stringify(dataset.value)
            });
            return dataset;
        }
    };
}
// src/methods/config/config.ts
function config(schema, config2) {
    return {
        ...schema,
        _run (dataset, config_) {
            return schema._run(dataset, {
                ...config_,
                ...config2
            });
        }
    };
}
// src/methods/getFallback/getFallback.ts
function getFallback(schema, dataset, config2) {
    return typeof schema.fallback === "function" ? // @ts-expect-error
    schema.fallback(dataset, config2) : // @ts-expect-error
    schema.fallback;
}
// src/methods/fallback/fallback.ts
function fallback(schema, fallback2) {
    return {
        ...schema,
        fallback: fallback2,
        _run (dataset, config2) {
            const outputDataset = schema._run(dataset, config2);
            return outputDataset.issues ? {
                typed: true,
                value: getFallback(this, outputDataset, config2)
            } : outputDataset;
        }
    };
}
// src/methods/fallback/fallbackAsync.ts
function fallbackAsync(schema, fallback2) {
    return {
        ...schema,
        fallback: fallback2,
        async: true,
        async _run (dataset, config2) {
            const outputDataset = await schema._run(dataset, config2);
            return outputDataset.issues ? // @ts-expect-error
            {
                typed: true,
                value: await getFallback(this, outputDataset, config2)
            } : outputDataset;
        }
    };
}
// src/methods/flatten/flatten.ts
function flatten(issues) {
    const flatErrors = {};
    for (const issue of issues){
        if (issue.path) {
            const dotPath = getDotPath(issue);
            if (dotPath) {
                if (!flatErrors.nested) flatErrors.nested = {};
                if (flatErrors.nested[dotPath]) flatErrors.nested[dotPath].push(issue.message);
                else flatErrors.nested[dotPath] = [
                    issue.message
                ];
            } else if (flatErrors.other) flatErrors.other.push(issue.message);
            else flatErrors.other = [
                issue.message
            ];
        } else if (flatErrors.root) flatErrors.root.push(issue.message);
        else flatErrors.root = [
            issue.message
        ];
    }
    return flatErrors;
}
// src/methods/forward/forward.ts
function forward(action, pathKeys) {
    return {
        ...action,
        _run (dataset, config2) {
            const prevIssues = dataset.issues && [
                ...dataset.issues
            ];
            action._run(dataset, config2);
            if (dataset.issues) {
                for (const issue of dataset.issues)if (!prevIssues?.includes(issue)) {
                    let pathInput = dataset.value;
                    for (const key of pathKeys){
                        const pathValue = pathInput[key];
                        const pathItem = {
                            type: "unknown",
                            origin: "value",
                            input: pathInput,
                            key: key,
                            value: pathValue
                        };
                        if (issue.path) issue.path.push(pathItem);
                        else issue.path = [
                            pathItem
                        ];
                        if (!pathValue) break;
                        pathInput = pathValue;
                    }
                }
            }
            return dataset;
        }
    };
}
// src/methods/forward/forwardAsync.ts
function forwardAsync(action, pathKeys) {
    return {
        ...action,
        async: true,
        async _run (dataset, config2) {
            const prevIssues = dataset.issues && [
                ...dataset.issues
            ];
            await action._run(dataset, config2);
            if (dataset.issues) {
                for (const issue of dataset.issues)if (!prevIssues?.includes(issue)) {
                    let pathInput = dataset.value;
                    for (const key of pathKeys){
                        const pathValue = pathInput[key];
                        const pathItem = {
                            type: "unknown",
                            origin: "value",
                            input: pathInput,
                            key: key,
                            value: pathValue
                        };
                        if (issue.path) issue.path.push(pathItem);
                        else issue.path = [
                            pathItem
                        ];
                        if (!pathValue) break;
                        pathInput = pathValue;
                    }
                }
            }
            return dataset;
        }
    };
}
// src/methods/getDefault/getDefault.ts
function getDefault(schema, dataset, config2) {
    return typeof schema.default === "function" ? // @ts-expect-error
    schema.default(dataset, config2) : // @ts-expect-error
    schema.default;
}
// src/methods/getDefaults/getDefaults.ts
function getDefaults(schema) {
    if ("entries" in schema) {
        const object2 = {};
        for(const key in schema.entries)object2[key] = getDefaults(schema.entries[key]);
        return object2;
    }
    if ("items" in schema) return schema.items.map(getDefaults);
    return getDefault(schema);
}
// src/methods/getDefaults/getDefaultsAsync.ts
async function getDefaultsAsync(schema) {
    if ("entries" in schema) return Object.fromEntries(await Promise.all(Object.entries(schema.entries).map(async ([key, value2])=>[
            key,
            await getDefaultsAsync(value2)
        ])));
    if ("items" in schema) return Promise.all(schema.items.map(getDefaultsAsync));
    return getDefault(schema);
}
// src/methods/getFallbacks/getFallbacks.ts
function getFallbacks(schema) {
    if ("entries" in schema) {
        const object2 = {};
        for(const key in schema.entries)object2[key] = getFallbacks(schema.entries[key]);
        return object2;
    }
    if ("items" in schema) return schema.items.map(getFallbacks);
    return getFallback(schema);
}
// src/methods/getFallbacks/getFallbacksAsync.ts
async function getFallbacksAsync(schema) {
    if ("entries" in schema) return Object.fromEntries(await Promise.all(Object.entries(schema.entries).map(async ([key, value2])=>[
            key,
            await getFallbacksAsync(value2)
        ])));
    if ("items" in schema) return Promise.all(schema.items.map(getFallbacksAsync));
    return getFallback(schema);
}
// src/methods/is/is.ts
function is(schema, input) {
    return !schema._run({
        typed: false,
        value: input
    }, {
        abortEarly: true
    }).issues;
}
// src/schemas/any/any.ts
function any() {
    return {
        kind: "schema",
        type: "any",
        reference: any,
        expects: "any",
        async: false,
        _run (dataset) {
            dataset.typed = true;
            return dataset;
        }
    };
}
// src/schemas/array/array.ts
function array(item, message) {
    return {
        kind: "schema",
        type: "array",
        reference: array,
        expects: "Array",
        async: false,
        item: item,
        message: message,
        _run (dataset, config2) {
            const input = dataset.value;
            if (Array.isArray(input)) {
                dataset.typed = true;
                dataset.value = [];
                for(let key = 0; key < input.length; key++){
                    const value2 = input[key];
                    const itemDataset = this.item._run({
                        typed: false,
                        value: value2
                    }, config2);
                    if (itemDataset.issues) {
                        const pathItem = {
                            type: "array",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of itemDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = itemDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!itemDataset.typed) dataset.typed = false;
                    dataset.value.push(itemDataset.value);
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/array/arrayAsync.ts
function arrayAsync(item, message) {
    return {
        kind: "schema",
        type: "array",
        reference: arrayAsync,
        expects: "Array",
        async: true,
        item: item,
        message: message,
        async _run (dataset, config2) {
            const input = dataset.value;
            if (Array.isArray(input)) {
                dataset.typed = true;
                dataset.value = [];
                const itemDatasets = await Promise.all(input.map((value2)=>this.item._run({
                        typed: false,
                        value: value2
                    }, config2)));
                for(let key = 0; key < itemDatasets.length; key++){
                    const itemDataset = itemDatasets[key];
                    if (itemDataset.issues) {
                        const pathItem = {
                            type: "array",
                            origin: "value",
                            input: input,
                            key: key,
                            value: input[key]
                        };
                        for (const issue of itemDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = itemDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!itemDataset.typed) dataset.typed = false;
                    dataset.value.push(itemDataset.value);
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/bigint/bigint.ts
function bigint(message) {
    return {
        kind: "schema",
        type: "bigint",
        reference: bigint,
        expects: "bigint",
        async: false,
        message: message,
        _run (dataset, config2) {
            if (typeof dataset.value === "bigint") dataset.typed = true;
            else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/blob/blob.ts
function blob(message) {
    return {
        kind: "schema",
        type: "blob",
        reference: blob,
        expects: "Blob",
        async: false,
        message: message,
        _run (dataset, config2) {
            if (dataset.value instanceof Blob) dataset.typed = true;
            else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/boolean/boolean.ts
function boolean(message) {
    return {
        kind: "schema",
        type: "boolean",
        reference: boolean,
        expects: "boolean",
        async: false,
        message: message,
        _run (dataset, config2) {
            if (typeof dataset.value === "boolean") dataset.typed = true;
            else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/custom/custom.ts
function custom(check2, message) {
    return {
        kind: "schema",
        type: "custom",
        reference: custom,
        expects: "unknown",
        async: false,
        check: check2,
        message: message,
        _run (dataset, config2) {
            if (this.check(dataset.value)) dataset.typed = true;
            else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/custom/customAsync.ts
function customAsync(check2, message) {
    return {
        kind: "schema",
        type: "custom",
        reference: customAsync,
        expects: "unknown",
        async: true,
        check: check2,
        message: message,
        async _run (dataset, config2) {
            if (await this.check(dataset.value)) dataset.typed = true;
            else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/date/date.ts
function date(message) {
    return {
        kind: "schema",
        type: "date",
        reference: date,
        expects: "Date",
        async: false,
        message: message,
        _run (dataset, config2) {
            if (dataset.value instanceof Date) {
                if (!isNaN(dataset.value)) dataset.typed = true;
                else _addIssue(this, "type", dataset, config2, {
                    received: '"Invalid Date"'
                });
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/enum/enum.ts
function enum_(enum__, message) {
    const options = Object.entries(enum__).filter(([key])=>isNaN(+key)).map(([, value2])=>value2);
    return {
        kind: "schema",
        type: "enum",
        reference: enum_,
        expects: _joinExpects(options.map(_stringify), "|"),
        async: false,
        enum: enum__,
        options: options,
        message: message,
        _run (dataset, config2) {
            if (this.options.includes(dataset.value)) dataset.typed = true;
            else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/file/file.ts
function file(message) {
    return {
        kind: "schema",
        type: "file",
        reference: file,
        expects: "File",
        async: false,
        message: message,
        _run (dataset, config2) {
            if (dataset.value instanceof File) dataset.typed = true;
            else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/function/function.ts
function function_(message) {
    return {
        kind: "schema",
        type: "function",
        reference: function_,
        expects: "Function",
        async: false,
        message: message,
        _run (dataset, config2) {
            if (typeof dataset.value === "function") dataset.typed = true;
            else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/instance/instance.ts
function instance(class_, message) {
    return {
        kind: "schema",
        type: "instance",
        reference: instance,
        expects: class_.name,
        async: false,
        class: class_,
        message: message,
        _run (dataset, config2) {
            if (dataset.value instanceof this.class) dataset.typed = true;
            else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/intersect/utils/_merge/_merge.ts
function _merge(value1, value2) {
    if (typeof value1 === typeof value2) {
        if (value1 === value2 || value1 instanceof Date && value2 instanceof Date && +value1 === +value2) return {
            value: value1
        };
        if (value1 && value2 && value1.constructor === Object && value2.constructor === Object) {
            for(const key in value2)if (key in value1) {
                const dataset = _merge(value1[key], value2[key]);
                if (dataset.issue) return dataset;
                value1[key] = dataset.value;
            } else value1[key] = value2[key];
            return {
                value: value1
            };
        }
        if (Array.isArray(value1) && Array.isArray(value2)) {
            if (value1.length === value2.length) {
                for(let index = 0; index < value1.length; index++){
                    const dataset = _merge(value1[index], value2[index]);
                    if (dataset.issue) return dataset;
                    value1[index] = dataset.value;
                }
                return {
                    value: value1
                };
            }
        }
    }
    return {
        issue: true
    };
}
// src/schemas/intersect/intersect.ts
function intersect(options, message) {
    return {
        kind: "schema",
        type: "intersect",
        reference: intersect,
        expects: _joinExpects(options.map((option)=>option.expects), "&"),
        async: false,
        options: options,
        message: message,
        _run (dataset, config2) {
            if (this.options.length) {
                const input = dataset.value;
                let outputs;
                dataset.typed = true;
                for (const schema of this.options){
                    const optionDataset = schema._run({
                        typed: false,
                        value: input
                    }, config2);
                    if (optionDataset.issues) {
                        if (dataset.issues) dataset.issues.push(...optionDataset.issues);
                        else dataset.issues = optionDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!optionDataset.typed) dataset.typed = false;
                    if (dataset.typed) {
                        if (outputs) outputs.push(optionDataset.value);
                        else outputs = [
                            optionDataset.value
                        ];
                    }
                }
                if (dataset.typed) {
                    dataset.value = outputs[0];
                    for(let index = 1; index < outputs.length; index++){
                        const mergeDataset = _merge(dataset.value, outputs[index]);
                        if (mergeDataset.issue) {
                            _addIssue(this, "type", dataset, config2, {
                                received: "unknown"
                            });
                            break;
                        }
                        dataset.value = mergeDataset.value;
                    }
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/intersect/intersectAsync.ts
function intersectAsync(options, message) {
    return {
        kind: "schema",
        type: "intersect",
        reference: intersectAsync,
        expects: _joinExpects(options.map((option)=>option.expects), "&"),
        async: true,
        options: options,
        message: message,
        async _run (dataset, config2) {
            if (this.options.length) {
                const input = dataset.value;
                let outputs;
                dataset.typed = true;
                const optionDatasets = await Promise.all(this.options.map((schema)=>schema._run({
                        typed: false,
                        value: input
                    }, config2)));
                for (const optionDataset of optionDatasets){
                    if (optionDataset.issues) {
                        if (dataset.issues) dataset.issues.push(...optionDataset.issues);
                        else dataset.issues = optionDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!optionDataset.typed) dataset.typed = false;
                    if (dataset.typed) {
                        if (outputs) outputs.push(optionDataset.value);
                        else outputs = [
                            optionDataset.value
                        ];
                    }
                }
                if (dataset.typed) {
                    dataset.value = outputs[0];
                    for(let index = 1; index < outputs.length; index++){
                        const mergeDataset = _merge(dataset.value, outputs[index]);
                        if (mergeDataset.issue) {
                            _addIssue(this, "type", dataset, config2, {
                                received: "unknown"
                            });
                            break;
                        }
                        dataset.value = mergeDataset.value;
                    }
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/lazy/lazy.ts
function lazy(getter) {
    return {
        kind: "schema",
        type: "lazy",
        reference: lazy,
        expects: "unknown",
        async: false,
        getter: getter,
        _run (dataset, config2) {
            return this.getter(dataset.value)._run(dataset, config2);
        }
    };
}
// src/schemas/lazy/lazyAsync.ts
function lazyAsync(getter) {
    return {
        kind: "schema",
        type: "lazy",
        reference: lazyAsync,
        expects: "unknown",
        async: true,
        getter: getter,
        async _run (dataset, config2) {
            return (await this.getter(dataset.value))._run(dataset, config2);
        }
    };
}
// src/schemas/literal/literal.ts
function literal(literal_, message) {
    return {
        kind: "schema",
        type: "literal",
        reference: literal,
        expects: _stringify(literal_),
        async: false,
        literal: literal_,
        message: message,
        _run (dataset, config2) {
            if (dataset.value === this.literal) dataset.typed = true;
            else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/looseObject/looseObject.ts
function looseObject(entries, message) {
    return {
        kind: "schema",
        type: "loose_object",
        reference: looseObject,
        expects: "Object",
        async: false,
        entries: entries,
        message: message,
        _run (dataset, config2) {
            const input = dataset.value;
            if (input && typeof input === "object") {
                dataset.typed = true;
                dataset.value = {};
                for(const key in this.entries){
                    const value2 = input[key];
                    const valueDataset = this.entries[key]._run({
                        typed: false,
                        value: value2
                    }, config2);
                    if (valueDataset.issues) {
                        const pathItem = {
                            type: "object",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of valueDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = valueDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!valueDataset.typed) dataset.typed = false;
                    if (valueDataset.value !== void 0 || key in input) dataset.value[key] = valueDataset.value;
                }
                if (!dataset.issues || !config2.abortEarly) {
                    for(const key in input)if (_isValidObjectKey(input, key) && !(key in this.entries)) dataset.value[key] = input[key];
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/looseObject/looseObjectAsync.ts
function looseObjectAsync(entries, message) {
    return {
        kind: "schema",
        type: "loose_object",
        reference: looseObjectAsync,
        expects: "Object",
        async: true,
        entries: entries,
        message: message,
        async _run (dataset, config2) {
            const input = dataset.value;
            if (input && typeof input === "object") {
                dataset.typed = true;
                dataset.value = {};
                const valueDatasets = await Promise.all(Object.entries(this.entries).map(async ([key, schema])=>{
                    const value2 = input[key];
                    return [
                        key,
                        value2,
                        await schema._run({
                            typed: false,
                            value: value2
                        }, config2)
                    ];
                }));
                for (const [key, value2, valueDataset] of valueDatasets){
                    if (valueDataset.issues) {
                        const pathItem = {
                            type: "object",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of valueDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = valueDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!valueDataset.typed) dataset.typed = false;
                    if (valueDataset.value !== void 0 || key in input) dataset.value[key] = valueDataset.value;
                }
                if (!dataset.issues || !config2.abortEarly) {
                    for(const key in input)if (_isValidObjectKey(input, key) && !(key in this.entries)) dataset.value[key] = input[key];
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/looseTuple/looseTuple.ts
function looseTuple(items, message) {
    return {
        kind: "schema",
        type: "loose_tuple",
        reference: looseTuple,
        expects: "Array",
        async: false,
        items: items,
        message: message,
        _run (dataset, config2) {
            const input = dataset.value;
            if (Array.isArray(input)) {
                dataset.typed = true;
                dataset.value = [];
                for(let key = 0; key < this.items.length; key++){
                    const value2 = input[key];
                    const itemDataset = this.items[key]._run({
                        typed: false,
                        value: value2
                    }, config2);
                    if (itemDataset.issues) {
                        const pathItem = {
                            type: "array",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of itemDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = itemDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!itemDataset.typed) dataset.typed = false;
                    dataset.value.push(itemDataset.value);
                }
                if (!dataset.issues || !config2.abortEarly) for(let key = this.items.length; key < input.length; key++)dataset.value.push(input[key]);
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/looseTuple/looseTupleAsync.ts
function looseTupleAsync(items, message) {
    return {
        kind: "schema",
        type: "loose_tuple",
        reference: looseTupleAsync,
        expects: "Array",
        async: true,
        items: items,
        message: message,
        async _run (dataset, config2) {
            const input = dataset.value;
            if (Array.isArray(input)) {
                dataset.typed = true;
                dataset.value = [];
                const itemDatasets = await Promise.all(this.items.map(async (item, key)=>{
                    const value2 = input[key];
                    return [
                        key,
                        value2,
                        await item._run({
                            typed: false,
                            value: value2
                        }, config2)
                    ];
                }));
                for (const [key, value2, itemDataset] of itemDatasets){
                    if (itemDataset.issues) {
                        const pathItem = {
                            type: "array",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of itemDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = itemDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!itemDataset.typed) dataset.typed = false;
                    dataset.value.push(itemDataset.value);
                }
                if (!dataset.issues || !config2.abortEarly) for(let key = this.items.length; key < input.length; key++)dataset.value.push(input[key]);
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/map/map.ts
function map(key, value2, message) {
    return {
        kind: "schema",
        type: "map",
        reference: map,
        expects: "Map",
        async: false,
        key: key,
        value: value2,
        message: message,
        _run (dataset, config2) {
            const input = dataset.value;
            if (input instanceof Map) {
                dataset.typed = true;
                dataset.value = /* @__PURE__ */ new Map();
                for (const [inputKey, inputValue] of input){
                    const keyDataset = this.key._run({
                        typed: false,
                        value: inputKey
                    }, config2);
                    if (keyDataset.issues) {
                        const pathItem = {
                            type: "map",
                            origin: "key",
                            input: input,
                            key: inputKey,
                            value: inputValue
                        };
                        for (const issue of keyDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = keyDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    const valueDataset = this.value._run({
                        typed: false,
                        value: inputValue
                    }, config2);
                    if (valueDataset.issues) {
                        const pathItem = {
                            type: "map",
                            origin: "value",
                            input: input,
                            key: inputKey,
                            value: inputValue
                        };
                        for (const issue of valueDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = valueDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!keyDataset.typed || !valueDataset.typed) dataset.typed = false;
                    dataset.value.set(keyDataset.value, valueDataset.value);
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/map/mapAsync.ts
function mapAsync(key, value2, message) {
    return {
        kind: "schema",
        type: "map",
        reference: mapAsync,
        expects: "Map",
        async: true,
        key: key,
        value: value2,
        message: message,
        async _run (dataset, config2) {
            const input = dataset.value;
            if (input instanceof Map) {
                dataset.typed = true;
                dataset.value = /* @__PURE__ */ new Map();
                const datasets = await Promise.all([
                    ...input
                ].map(([inputKey, inputValue])=>Promise.all([
                        inputKey,
                        inputValue,
                        this.key._run({
                            typed: false,
                            value: inputKey
                        }, config2),
                        this.value._run({
                            typed: false,
                            value: inputValue
                        }, config2)
                    ])));
                for (const [inputKey, inputValue, keyDataset, valueDataset] of datasets){
                    if (keyDataset.issues) {
                        const pathItem = {
                            type: "map",
                            origin: "key",
                            input: input,
                            key: inputKey,
                            value: inputValue
                        };
                        for (const issue of keyDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = keyDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (valueDataset.issues) {
                        const pathItem = {
                            type: "map",
                            origin: "value",
                            input: input,
                            key: inputKey,
                            value: inputValue
                        };
                        for (const issue of valueDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = valueDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!keyDataset.typed || !valueDataset.typed) dataset.typed = false;
                    dataset.value.set(keyDataset.value, valueDataset.value);
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/nan/nan.ts
function nan(message) {
    return {
        kind: "schema",
        type: "nan",
        reference: nan,
        expects: "NaN",
        async: false,
        message: message,
        _run (dataset, config2) {
            if (Number.isNaN(dataset.value)) dataset.typed = true;
            else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/never/never.ts
function never(message) {
    return {
        kind: "schema",
        type: "never",
        reference: never,
        expects: "never",
        async: false,
        message: message,
        _run (dataset, config2) {
            _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/nonNullable/nonNullable.ts
function nonNullable(wrapped, message) {
    return {
        kind: "schema",
        type: "non_nullable",
        reference: nonNullable,
        expects: "!null",
        async: false,
        wrapped: wrapped,
        message: message,
        _run (dataset, config2) {
            if (dataset.value === null) {
                _addIssue(this, "type", dataset, config2);
                return dataset;
            }
            return this.wrapped._run(dataset, config2);
        }
    };
}
// src/schemas/nonNullable/nonNullableAsync.ts
function nonNullableAsync(wrapped, message) {
    return {
        kind: "schema",
        type: "non_nullable",
        reference: nonNullableAsync,
        expects: "!null",
        async: true,
        wrapped: wrapped,
        message: message,
        async _run (dataset, config2) {
            if (dataset.value === null) {
                _addIssue(this, "type", dataset, config2);
                return dataset;
            }
            return this.wrapped._run(dataset, config2);
        }
    };
}
// src/schemas/nonNullish/nonNullish.ts
function nonNullish(wrapped, message) {
    return {
        kind: "schema",
        type: "non_nullish",
        reference: nonNullish,
        expects: "(!null & !undefined)",
        async: false,
        wrapped: wrapped,
        message: message,
        _run (dataset, config2) {
            if (dataset.value === null || dataset.value === void 0) {
                _addIssue(this, "type", dataset, config2);
                return dataset;
            }
            return this.wrapped._run(dataset, config2);
        }
    };
}
// src/schemas/nonNullish/nonNullishAsync.ts
function nonNullishAsync(wrapped, message) {
    return {
        kind: "schema",
        type: "non_nullish",
        reference: nonNullishAsync,
        expects: "(!null & !undefined)",
        async: true,
        wrapped: wrapped,
        message: message,
        async _run (dataset, config2) {
            if (dataset.value === null || dataset.value === void 0) {
                _addIssue(this, "type", dataset, config2);
                return dataset;
            }
            return this.wrapped._run(dataset, config2);
        }
    };
}
// src/schemas/nonOptional/nonOptional.ts
function nonOptional(wrapped, message) {
    return {
        kind: "schema",
        type: "non_optional",
        reference: nonOptional,
        expects: "!undefined",
        async: false,
        wrapped: wrapped,
        message: message,
        _run (dataset, config2) {
            if (dataset.value === void 0) {
                _addIssue(this, "type", dataset, config2);
                return dataset;
            }
            return this.wrapped._run(dataset, config2);
        }
    };
}
// src/schemas/nonOptional/nonOptionalAsync.ts
function nonOptionalAsync(wrapped, message) {
    return {
        kind: "schema",
        type: "non_optional",
        reference: nonOptionalAsync,
        expects: "!undefined",
        async: true,
        wrapped: wrapped,
        message: message,
        async _run (dataset, config2) {
            if (dataset.value === void 0) {
                _addIssue(this, "type", dataset, config2);
                return dataset;
            }
            return this.wrapped._run(dataset, config2);
        }
    };
}
// src/schemas/null/null.ts
function null_(message) {
    return {
        kind: "schema",
        type: "null",
        reference: null_,
        expects: "null",
        async: false,
        message: message,
        _run (dataset, config2) {
            if (dataset.value === null) dataset.typed = true;
            else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/nullable/nullable.ts
function nullable(wrapped, ...args) {
    const schema = {
        kind: "schema",
        type: "nullable",
        reference: nullable,
        expects: `(${wrapped.expects} | null)`,
        async: false,
        wrapped: wrapped,
        _run (dataset, config2) {
            if (dataset.value === null) {
                if ("default" in this) dataset.value = getDefault(this, dataset, config2);
                if (dataset.value === null) {
                    dataset.typed = true;
                    return dataset;
                }
            }
            return this.wrapped._run(dataset, config2);
        }
    };
    if (0 in args) schema.default = args[0];
    return schema;
}
// src/schemas/nullable/nullableAsync.ts
function nullableAsync(wrapped, ...args) {
    const schema = {
        kind: "schema",
        type: "nullable",
        reference: nullableAsync,
        expects: `(${wrapped.expects} | null)`,
        async: true,
        wrapped: wrapped,
        async _run (dataset, config2) {
            if (dataset.value === null) {
                if ("default" in this) dataset.value = await getDefault(this, dataset, config2);
                if (dataset.value === null) {
                    dataset.typed = true;
                    return dataset;
                }
            }
            return this.wrapped._run(dataset, config2);
        }
    };
    if (0 in args) schema.default = args[0];
    return schema;
}
// src/schemas/nullish/nullish.ts
function nullish(wrapped, ...args) {
    const schema = {
        kind: "schema",
        type: "nullish",
        reference: nullish,
        expects: `(${wrapped.expects} | null | undefined)`,
        async: false,
        wrapped: wrapped,
        _run (dataset, config2) {
            if (dataset.value === null || dataset.value === void 0) {
                if ("default" in this) dataset.value = getDefault(this, dataset, config2);
                if (dataset.value === null || dataset.value === void 0) {
                    dataset.typed = true;
                    return dataset;
                }
            }
            return this.wrapped._run(dataset, config2);
        }
    };
    if (0 in args) schema.default = args[0];
    return schema;
}
// src/schemas/nullish/nullishAsync.ts
function nullishAsync(wrapped, ...args) {
    const schema = {
        kind: "schema",
        type: "nullish",
        reference: nullishAsync,
        expects: `(${wrapped.expects} | null | undefined)`,
        async: true,
        wrapped: wrapped,
        async _run (dataset, config2) {
            if (dataset.value === null || dataset.value === void 0) {
                if ("default" in this) dataset.value = await getDefault(this, dataset, config2);
                if (dataset.value === null || dataset.value === void 0) {
                    dataset.typed = true;
                    return dataset;
                }
            }
            return this.wrapped._run(dataset, config2);
        }
    };
    if (0 in args) schema.default = args[0];
    return schema;
}
// src/schemas/number/number.ts
function number(message) {
    return {
        kind: "schema",
        type: "number",
        reference: number,
        expects: "number",
        async: false,
        message: message,
        _run (dataset, config2) {
            if (typeof dataset.value === "number" && !isNaN(dataset.value)) dataset.typed = true;
            else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/object/object.ts
function object(entries, message) {
    return {
        kind: "schema",
        type: "object",
        reference: object,
        expects: "Object",
        async: false,
        entries: entries,
        message: message,
        _run (dataset, config2) {
            const input = dataset.value;
            if (input && typeof input === "object") {
                dataset.typed = true;
                dataset.value = {};
                for(const key in this.entries){
                    const value2 = input[key];
                    const valueDataset = this.entries[key]._run({
                        typed: false,
                        value: value2
                    }, config2);
                    if (valueDataset.issues) {
                        const pathItem = {
                            type: "object",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of valueDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = valueDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!valueDataset.typed) dataset.typed = false;
                    if (valueDataset.value !== void 0 || key in input) dataset.value[key] = valueDataset.value;
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/object/objectAsync.ts
function objectAsync(entries, message) {
    return {
        kind: "schema",
        type: "object",
        reference: objectAsync,
        expects: "Object",
        async: true,
        entries: entries,
        message: message,
        async _run (dataset, config2) {
            const input = dataset.value;
            if (input && typeof input === "object") {
                dataset.typed = true;
                dataset.value = {};
                const valueDatasets = await Promise.all(Object.entries(this.entries).map(async ([key, schema])=>{
                    const value2 = input[key];
                    return [
                        key,
                        value2,
                        await schema._run({
                            typed: false,
                            value: value2
                        }, config2)
                    ];
                }));
                for (const [key, value2, valueDataset] of valueDatasets){
                    if (valueDataset.issues) {
                        const pathItem = {
                            type: "object",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of valueDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = valueDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!valueDataset.typed) dataset.typed = false;
                    if (valueDataset.value !== void 0 || key in input) dataset.value[key] = valueDataset.value;
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/objectWithRest/objectWithRest.ts
function objectWithRest(entries, rest, message) {
    return {
        kind: "schema",
        type: "object_with_rest",
        reference: objectWithRest,
        expects: "Object",
        async: false,
        entries: entries,
        rest: rest,
        message: message,
        _run (dataset, config2) {
            const input = dataset.value;
            if (input && typeof input === "object") {
                dataset.typed = true;
                dataset.value = {};
                for(const key in this.entries){
                    const value2 = input[key];
                    const valueDataset = this.entries[key]._run({
                        typed: false,
                        value: value2
                    }, config2);
                    if (valueDataset.issues) {
                        const pathItem = {
                            type: "object",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of valueDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = valueDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!valueDataset.typed) dataset.typed = false;
                    if (valueDataset.value !== void 0 || key in input) dataset.value[key] = valueDataset.value;
                }
                if (!dataset.issues || !config2.abortEarly) {
                    for(const key in input)if (_isValidObjectKey(input, key) && !(key in this.entries)) {
                        const value2 = input[key];
                        const valueDataset = this.rest._run({
                            typed: false,
                            value: value2
                        }, config2);
                        if (valueDataset.issues) {
                            const pathItem = {
                                type: "object",
                                origin: "value",
                                input: input,
                                key: key,
                                value: value2
                            };
                            for (const issue of valueDataset.issues){
                                if (issue.path) issue.path.unshift(pathItem);
                                else issue.path = [
                                    pathItem
                                ];
                                dataset.issues?.push(issue);
                            }
                            if (!dataset.issues) dataset.issues = valueDataset.issues;
                            if (config2.abortEarly) {
                                dataset.typed = false;
                                break;
                            }
                        }
                        if (!valueDataset.typed) dataset.typed = false;
                        dataset.value[key] = valueDataset.value;
                    }
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/objectWithRest/objectWithRestAsync.ts
function objectWithRestAsync(entries, rest, message) {
    return {
        kind: "schema",
        type: "object_with_rest",
        reference: objectWithRestAsync,
        expects: "Object",
        async: true,
        entries: entries,
        rest: rest,
        message: message,
        async _run (dataset, config2) {
            const input = dataset.value;
            if (input && typeof input === "object") {
                dataset.typed = true;
                dataset.value = {};
                const [normalDatasets, restDatasets] = await Promise.all([
                    // Parse schema of each normal entry
                    // Hint: We do not distinguish between missing and `undefined` entries.
                    // The reason for this decision is that it reduces the bundle size, and
                    // we also expect that most users will expect this behavior.
                    Promise.all(Object.entries(this.entries).map(async ([key, schema])=>{
                        const value2 = input[key];
                        return [
                            key,
                            value2,
                            await schema._run({
                                typed: false,
                                value: value2
                            }, config2)
                        ];
                    })),
                    // Parse other entries with rest schema
                    // Hint: We exclude specific keys for security reasons
                    Promise.all(Object.entries(input).filter(([key])=>_isValidObjectKey(input, key) && !(key in this.entries)).map(async ([key, value2])=>[
                            key,
                            value2,
                            await this.rest._run({
                                typed: false,
                                value: value2
                            }, config2)
                        ]))
                ]);
                for (const [key, value2, valueDataset] of normalDatasets){
                    if (valueDataset.issues) {
                        const pathItem = {
                            type: "object",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of valueDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = valueDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!valueDataset.typed) dataset.typed = false;
                    if (valueDataset.value !== void 0 || key in input) dataset.value[key] = valueDataset.value;
                }
                if (!dataset.issues || !config2.abortEarly) for (const [key, value2, valueDataset] of restDatasets){
                    if (valueDataset.issues) {
                        const pathItem = {
                            type: "object",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of valueDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = valueDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!valueDataset.typed) dataset.typed = false;
                    dataset.value[key] = valueDataset.value;
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/optional/optional.ts
function optional(wrapped, ...args) {
    const schema = {
        kind: "schema",
        type: "optional",
        reference: optional,
        expects: `(${wrapped.expects} | undefined)`,
        async: false,
        wrapped: wrapped,
        _run (dataset, config2) {
            if (dataset.value === void 0) {
                if ("default" in this) dataset.value = getDefault(this, dataset, config2);
                if (dataset.value === void 0) {
                    dataset.typed = true;
                    return dataset;
                }
            }
            return this.wrapped._run(dataset, config2);
        }
    };
    if (0 in args) schema.default = args[0];
    return schema;
}
// src/schemas/optional/optionalAsync.ts
function optionalAsync(wrapped, ...args) {
    const schema = {
        kind: "schema",
        type: "optional",
        reference: optionalAsync,
        expects: `(${wrapped.expects} | undefined)`,
        async: true,
        wrapped: wrapped,
        async _run (dataset, config2) {
            if (dataset.value === void 0) {
                if ("default" in this) dataset.value = await getDefault(this, dataset, config2);
                if (dataset.value === void 0) {
                    dataset.typed = true;
                    return dataset;
                }
            }
            return this.wrapped._run(dataset, config2);
        }
    };
    if (0 in args) schema.default = args[0];
    return schema;
}
// src/schemas/picklist/picklist.ts
function picklist(options, message) {
    return {
        kind: "schema",
        type: "picklist",
        reference: picklist,
        expects: _joinExpects(options.map(_stringify), "|"),
        async: false,
        options: options,
        message: message,
        _run (dataset, config2) {
            if (this.options.includes(dataset.value)) dataset.typed = true;
            else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/promise/promise.ts
function promise(message) {
    return {
        kind: "schema",
        type: "promise",
        reference: promise,
        expects: "Promise",
        async: false,
        message: message,
        _run (dataset, config2) {
            if (dataset.value instanceof Promise) dataset.typed = true;
            else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/record/record.ts
function record(key, value2, message) {
    return {
        kind: "schema",
        type: "record",
        reference: record,
        expects: "Object",
        async: false,
        key: key,
        value: value2,
        message: message,
        _run (dataset, config2) {
            const input = dataset.value;
            if (input && typeof input === "object") {
                dataset.typed = true;
                dataset.value = {};
                for(const entryKey in input)if (_isValidObjectKey(input, entryKey)) {
                    const entryValue = input[entryKey];
                    const keyDataset = this.key._run({
                        typed: false,
                        value: entryKey
                    }, config2);
                    if (keyDataset.issues) {
                        const pathItem = {
                            type: "object",
                            origin: "key",
                            input: input,
                            key: entryKey,
                            value: entryValue
                        };
                        for (const issue of keyDataset.issues){
                            issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = keyDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    const valueDataset = this.value._run({
                        typed: false,
                        value: entryValue
                    }, config2);
                    if (valueDataset.issues) {
                        const pathItem = {
                            type: "object",
                            origin: "value",
                            input: input,
                            key: entryKey,
                            value: entryValue
                        };
                        for (const issue of valueDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = valueDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!keyDataset.typed || !valueDataset.typed) dataset.typed = false;
                    if (keyDataset.typed) dataset.value[keyDataset.value] = valueDataset.value;
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/record/recordAsync.ts
function recordAsync(key, value2, message) {
    return {
        kind: "schema",
        type: "record",
        reference: recordAsync,
        expects: "Object",
        async: true,
        key: key,
        value: value2,
        message: message,
        async _run (dataset, config2) {
            const input = dataset.value;
            if (input && typeof input === "object") {
                dataset.typed = true;
                dataset.value = {};
                const datasets = await Promise.all(Object.entries(input).filter(([key2])=>_isValidObjectKey(input, key2)).map(([entryKey, entryValue])=>Promise.all([
                        entryKey,
                        entryValue,
                        this.key._run({
                            typed: false,
                            value: entryKey
                        }, config2),
                        this.value._run({
                            typed: false,
                            value: entryValue
                        }, config2)
                    ])));
                for (const [entryKey, entryValue, keyDataset, valueDataset] of datasets){
                    if (keyDataset.issues) {
                        const pathItem = {
                            type: "object",
                            origin: "key",
                            input: input,
                            key: entryKey,
                            value: entryValue
                        };
                        for (const issue of keyDataset.issues){
                            issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = keyDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (valueDataset.issues) {
                        const pathItem = {
                            type: "object",
                            origin: "value",
                            input: input,
                            key: entryKey,
                            value: entryValue
                        };
                        for (const issue of valueDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = valueDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!keyDataset.typed || !valueDataset.typed) dataset.typed = false;
                    if (keyDataset.typed) dataset.value[keyDataset.value] = valueDataset.value;
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/set/set.ts
function set(value2, message) {
    return {
        kind: "schema",
        type: "set",
        reference: set,
        expects: "Set",
        async: false,
        value: value2,
        message: message,
        _run (dataset, config2) {
            const input = dataset.value;
            if (input instanceof Set) {
                dataset.typed = true;
                dataset.value = /* @__PURE__ */ new Set();
                for (const inputValue of input){
                    const valueDataset = this.value._run({
                        typed: false,
                        value: inputValue
                    }, config2);
                    if (valueDataset.issues) {
                        const pathItem = {
                            type: "set",
                            origin: "value",
                            input: input,
                            key: null,
                            value: inputValue
                        };
                        for (const issue of valueDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = valueDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!valueDataset.typed) dataset.typed = false;
                    dataset.value.add(valueDataset.value);
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/set/setAsync.ts
function setAsync(value2, message) {
    return {
        kind: "schema",
        type: "set",
        reference: setAsync,
        expects: "Set",
        async: true,
        value: value2,
        message: message,
        async _run (dataset, config2) {
            const input = dataset.value;
            if (input instanceof Set) {
                dataset.typed = true;
                dataset.value = /* @__PURE__ */ new Set();
                const valueDatasets = await Promise.all([
                    ...input
                ].map(async (inputValue)=>[
                        inputValue,
                        await this.value._run({
                            typed: false,
                            value: inputValue
                        }, config2)
                    ]));
                for (const [inputValue, valueDataset] of valueDatasets){
                    if (valueDataset.issues) {
                        const pathItem = {
                            type: "set",
                            origin: "value",
                            input: input,
                            key: null,
                            value: inputValue
                        };
                        for (const issue of valueDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = valueDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!valueDataset.typed) dataset.typed = false;
                    dataset.value.add(valueDataset.value);
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/strictObject/strictObject.ts
function strictObject(entries, message) {
    return {
        kind: "schema",
        type: "strict_object",
        reference: strictObject,
        expects: "Object",
        async: false,
        entries: entries,
        message: message,
        _run (dataset, config2) {
            const input = dataset.value;
            if (input && typeof input === "object") {
                dataset.typed = true;
                dataset.value = {};
                for(const key in this.entries){
                    const value2 = input[key];
                    const valueDataset = this.entries[key]._run({
                        typed: false,
                        value: value2
                    }, config2);
                    if (valueDataset.issues) {
                        const pathItem = {
                            type: "object",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of valueDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = valueDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!valueDataset.typed) dataset.typed = false;
                    if (valueDataset.value !== void 0 || key in input) dataset.value[key] = valueDataset.value;
                }
                if (!dataset.issues || !config2.abortEarly) {
                    for(const key in input)if (!(key in this.entries)) {
                        const value2 = input[key];
                        _addIssue(this, "type", dataset, config2, {
                            input: value2,
                            expected: "never",
                            path: [
                                {
                                    type: "object",
                                    origin: "value",
                                    input: input,
                                    key: key,
                                    value: value2
                                }
                            ]
                        });
                        break;
                    }
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/strictObject/strictObjectAsync.ts
function strictObjectAsync(entries, message) {
    return {
        kind: "schema",
        type: "strict_object",
        reference: strictObjectAsync,
        expects: "Object",
        async: true,
        entries: entries,
        message: message,
        async _run (dataset, config2) {
            const input = dataset.value;
            if (input && typeof input === "object") {
                dataset.typed = true;
                dataset.value = {};
                const valueDatasets = await Promise.all(Object.entries(this.entries).map(async ([key, schema])=>{
                    const value2 = input[key];
                    return [
                        key,
                        value2,
                        await schema._run({
                            typed: false,
                            value: value2
                        }, config2)
                    ];
                }));
                for (const [key, value2, valueDataset] of valueDatasets){
                    if (valueDataset.issues) {
                        const pathItem = {
                            type: "object",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of valueDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = valueDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!valueDataset.typed) dataset.typed = false;
                    if (valueDataset.value !== void 0 || key in input) dataset.value[key] = valueDataset.value;
                }
                if (!dataset.issues || !config2.abortEarly) {
                    for(const key in input)if (!(key in this.entries)) {
                        const value2 = input[key];
                        _addIssue(this, "type", dataset, config2, {
                            input: value2,
                            expected: "never",
                            path: [
                                {
                                    type: "object",
                                    origin: "value",
                                    input: input,
                                    key: key,
                                    value: value2
                                }
                            ]
                        });
                        break;
                    }
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/strictTuple/strictTuple.ts
function strictTuple(items, message) {
    return {
        kind: "schema",
        type: "strict_tuple",
        reference: strictTuple,
        expects: "Array",
        async: false,
        items: items,
        message: message,
        _run (dataset, config2) {
            const input = dataset.value;
            if (Array.isArray(input)) {
                dataset.typed = true;
                dataset.value = [];
                for(let key = 0; key < this.items.length; key++){
                    const value2 = input[key];
                    const itemDataset = this.items[key]._run({
                        typed: false,
                        value: value2
                    }, config2);
                    if (itemDataset.issues) {
                        const pathItem = {
                            type: "array",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of itemDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = itemDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!itemDataset.typed) dataset.typed = false;
                    dataset.value.push(itemDataset.value);
                }
                if (!(dataset.issues && config2.abortEarly) && this.items.length < input.length) {
                    const value2 = input[items.length];
                    _addIssue(this, "type", dataset, config2, {
                        input: value2,
                        expected: "never",
                        path: [
                            {
                                type: "array",
                                origin: "value",
                                input: input,
                                key: this.items.length,
                                value: value2
                            }
                        ]
                    });
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/strictTuple/strictTupleAsync.ts
function strictTupleAsync(items, message) {
    return {
        kind: "schema",
        type: "strict_tuple",
        reference: strictTupleAsync,
        expects: "Array",
        async: true,
        items: items,
        message: message,
        async _run (dataset, config2) {
            const input = dataset.value;
            if (Array.isArray(input)) {
                dataset.typed = true;
                dataset.value = [];
                const itemDatasets = await Promise.all(this.items.map(async (item, key)=>{
                    const value2 = input[key];
                    return [
                        key,
                        value2,
                        await item._run({
                            typed: false,
                            value: value2
                        }, config2)
                    ];
                }));
                for (const [key, value2, itemDataset] of itemDatasets){
                    if (itemDataset.issues) {
                        const pathItem = {
                            type: "array",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of itemDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = itemDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!itemDataset.typed) dataset.typed = false;
                    dataset.value.push(itemDataset.value);
                }
                if (!(dataset.issues && config2.abortEarly) && this.items.length < input.length) {
                    const value2 = input[items.length];
                    _addIssue(this, "type", dataset, config2, {
                        input: value2,
                        expected: "never",
                        path: [
                            {
                                type: "array",
                                origin: "value",
                                input: input,
                                key: this.items.length,
                                value: value2
                            }
                        ]
                    });
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/string/string.ts
function string(message) {
    return {
        kind: "schema",
        type: "string",
        reference: string,
        expects: "string",
        async: false,
        message: message,
        _run (dataset, config2) {
            if (typeof dataset.value === "string") dataset.typed = true;
            else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/symbol/symbol.ts
function symbol(message) {
    return {
        kind: "schema",
        type: "symbol",
        reference: symbol,
        expects: "symbol",
        async: false,
        message: message,
        _run (dataset, config2) {
            if (typeof dataset.value === "symbol") dataset.typed = true;
            else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/tuple/tuple.ts
function tuple(items, message) {
    return {
        kind: "schema",
        type: "tuple",
        reference: tuple,
        expects: "Array",
        async: false,
        items: items,
        message: message,
        _run (dataset, config2) {
            const input = dataset.value;
            if (Array.isArray(input)) {
                dataset.typed = true;
                dataset.value = [];
                for(let key = 0; key < this.items.length; key++){
                    const value2 = input[key];
                    const itemDataset = this.items[key]._run({
                        typed: false,
                        value: value2
                    }, config2);
                    if (itemDataset.issues) {
                        const pathItem = {
                            type: "array",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of itemDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = itemDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!itemDataset.typed) dataset.typed = false;
                    dataset.value.push(itemDataset.value);
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/tuple/tupleAsync.ts
function tupleAsync(items, message) {
    return {
        kind: "schema",
        type: "tuple",
        reference: tupleAsync,
        expects: "Array",
        async: true,
        items: items,
        message: message,
        async _run (dataset, config2) {
            const input = dataset.value;
            if (Array.isArray(input)) {
                dataset.typed = true;
                dataset.value = [];
                const itemDatasets = await Promise.all(this.items.map(async (item, key)=>{
                    const value2 = input[key];
                    return [
                        key,
                        value2,
                        await item._run({
                            typed: false,
                            value: value2
                        }, config2)
                    ];
                }));
                for (const [key, value2, itemDataset] of itemDatasets){
                    if (itemDataset.issues) {
                        const pathItem = {
                            type: "array",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of itemDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = itemDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!itemDataset.typed) dataset.typed = false;
                    dataset.value.push(itemDataset.value);
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/tupleWithRest/tupleWithRest.ts
function tupleWithRest(items, rest, message) {
    return {
        kind: "schema",
        type: "tuple_with_rest",
        reference: tupleWithRest,
        expects: "Array",
        async: false,
        items: items,
        rest: rest,
        message: message,
        _run (dataset, config2) {
            const input = dataset.value;
            if (Array.isArray(input)) {
                dataset.typed = true;
                dataset.value = [];
                for(let key = 0; key < this.items.length; key++){
                    const value2 = input[key];
                    const itemDataset = this.items[key]._run({
                        typed: false,
                        value: value2
                    }, config2);
                    if (itemDataset.issues) {
                        const pathItem = {
                            type: "array",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of itemDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = itemDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!itemDataset.typed) dataset.typed = false;
                    dataset.value.push(itemDataset.value);
                }
                if (!dataset.issues || !config2.abortEarly) for(let key = this.items.length; key < input.length; key++){
                    const value2 = input[key];
                    const itemDataset = this.rest._run({
                        typed: false,
                        value: value2
                    }, config2);
                    if (itemDataset.issues) {
                        const pathItem = {
                            type: "array",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of itemDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = itemDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!itemDataset.typed) dataset.typed = false;
                    dataset.value.push(itemDataset.value);
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/tupleWithRest/tupleWithRestAsync.ts
function tupleWithRestAsync(items, rest, message) {
    return {
        kind: "schema",
        type: "tuple_with_rest",
        reference: tupleWithRestAsync,
        expects: "Array",
        async: true,
        items: items,
        rest: rest,
        message: message,
        async _run (dataset, config2) {
            const input = dataset.value;
            if (Array.isArray(input)) {
                dataset.typed = true;
                dataset.value = [];
                const [normalDatasets, restDatasets] = await Promise.all([
                    // Parse schema of each normal item
                    Promise.all(this.items.map(async (item, key)=>{
                        const value2 = input[key];
                        return [
                            key,
                            value2,
                            await item._run({
                                typed: false,
                                value: value2
                            }, config2)
                        ];
                    })),
                    // Parse other items with rest schema
                    Promise.all(input.slice(this.items.length).map(async (value2, key)=>{
                        return [
                            key + this.items.length,
                            value2,
                            await this.rest._run({
                                typed: false,
                                value: value2
                            }, config2)
                        ];
                    }))
                ]);
                for (const [key, value2, itemDataset] of normalDatasets){
                    if (itemDataset.issues) {
                        const pathItem = {
                            type: "array",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of itemDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = itemDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!itemDataset.typed) dataset.typed = false;
                    dataset.value.push(itemDataset.value);
                }
                if (!dataset.issues || !config2.abortEarly) for (const [key, value2, itemDataset] of restDatasets){
                    if (itemDataset.issues) {
                        const pathItem = {
                            type: "array",
                            origin: "value",
                            input: input,
                            key: key,
                            value: value2
                        };
                        for (const issue of itemDataset.issues){
                            if (issue.path) issue.path.unshift(pathItem);
                            else issue.path = [
                                pathItem
                            ];
                            dataset.issues?.push(issue);
                        }
                        if (!dataset.issues) dataset.issues = itemDataset.issues;
                        if (config2.abortEarly) {
                            dataset.typed = false;
                            break;
                        }
                    }
                    if (!itemDataset.typed) dataset.typed = false;
                    dataset.value.push(itemDataset.value);
                }
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/undefined/undefined.ts
function undefined_(message) {
    return {
        kind: "schema",
        type: "undefined",
        reference: undefined_,
        expects: "undefined",
        async: false,
        message: message,
        _run (dataset, config2) {
            if (dataset.value === void 0) dataset.typed = true;
            else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/undefinedable/undefinedable.ts
function undefinedable(wrapped, ...args) {
    const schema = {
        kind: "schema",
        type: "undefinedable",
        reference: undefinedable,
        expects: `(${wrapped.expects} | undefined)`,
        async: false,
        wrapped: wrapped,
        _run (dataset, config2) {
            if (dataset.value === void 0) {
                if ("default" in this) dataset.value = getDefault(this, dataset, config2);
                if (dataset.value === void 0) {
                    dataset.typed = true;
                    return dataset;
                }
            }
            return this.wrapped._run(dataset, config2);
        }
    };
    if (0 in args) schema.default = args[0];
    return schema;
}
// src/schemas/undefinedable/undefinedableAsync.ts
function undefinedableAsync(wrapped, ...args) {
    const schema = {
        kind: "schema",
        type: "undefinedable",
        reference: undefinedableAsync,
        expects: `(${wrapped.expects} | undefined)`,
        async: true,
        wrapped: wrapped,
        async _run (dataset, config2) {
            if (dataset.value === void 0) {
                if ("default" in this) dataset.value = await getDefault(this, dataset, config2);
                if (dataset.value === void 0) {
                    dataset.typed = true;
                    return dataset;
                }
            }
            return this.wrapped._run(dataset, config2);
        }
    };
    if (0 in args) schema.default = args[0];
    return schema;
}
// src/schemas/union/utils/_subIssues/_subIssues.ts
function _subIssues(datasets) {
    let issues;
    if (datasets) {
        for (const dataset of datasets)if (issues) issues.push(...dataset.issues);
        else issues = dataset.issues;
    }
    return issues;
}
// src/schemas/union/union.ts
function union(options, message) {
    return {
        kind: "schema",
        type: "union",
        reference: union,
        expects: _joinExpects(options.map((option)=>option.expects), "|"),
        async: false,
        options: options,
        message: message,
        _run (dataset, config2) {
            let validDataset;
            let typedDatasets;
            let untypedDatasets;
            for (const schema of this.options){
                const optionDataset = schema._run({
                    typed: false,
                    value: dataset.value
                }, config2);
                if (optionDataset.typed) {
                    if (optionDataset.issues) {
                        if (typedDatasets) typedDatasets.push(optionDataset);
                        else typedDatasets = [
                            optionDataset
                        ];
                    } else {
                        validDataset = optionDataset;
                        break;
                    }
                } else if (untypedDatasets) untypedDatasets.push(optionDataset);
                else untypedDatasets = [
                    optionDataset
                ];
            }
            if (validDataset) return validDataset;
            if (typedDatasets) {
                if (typedDatasets.length === 1) return typedDatasets[0];
                _addIssue(this, "type", dataset, config2, {
                    issues: _subIssues(typedDatasets)
                });
                dataset.typed = true;
            } else if (untypedDatasets?.length === 1) return untypedDatasets[0];
            else _addIssue(this, "type", dataset, config2, {
                issues: _subIssues(untypedDatasets)
            });
            return dataset;
        }
    };
}
// src/schemas/union/unionAsync.ts
function unionAsync(options, message) {
    return {
        kind: "schema",
        type: "union",
        reference: unionAsync,
        expects: _joinExpects(options.map((option)=>option.expects), "|"),
        async: true,
        options: options,
        message: message,
        async _run (dataset, config2) {
            let validDataset;
            let typedDatasets;
            let untypedDatasets;
            for (const schema of this.options){
                const optionDataset = await schema._run({
                    typed: false,
                    value: dataset.value
                }, config2);
                if (optionDataset.typed) {
                    if (optionDataset.issues) {
                        if (typedDatasets) typedDatasets.push(optionDataset);
                        else typedDatasets = [
                            optionDataset
                        ];
                    } else {
                        validDataset = optionDataset;
                        break;
                    }
                } else if (untypedDatasets) untypedDatasets.push(optionDataset);
                else untypedDatasets = [
                    optionDataset
                ];
            }
            if (validDataset) return validDataset;
            if (typedDatasets) {
                if (typedDatasets.length === 1) return typedDatasets[0];
                _addIssue(this, "type", dataset, config2, {
                    issues: _subIssues(typedDatasets)
                });
                dataset.typed = true;
            } else if (untypedDatasets?.length === 1) return untypedDatasets[0];
            else _addIssue(this, "type", dataset, config2, {
                issues: _subIssues(untypedDatasets)
            });
            return dataset;
        }
    };
}
// src/schemas/unknown/unknown.ts
function unknown() {
    return {
        kind: "schema",
        type: "unknown",
        reference: unknown,
        expects: "unknown",
        async: false,
        _run (dataset) {
            dataset.typed = true;
            return dataset;
        }
    };
}
// src/schemas/variant/variant.ts
function variant(key, options, message) {
    return {
        kind: "schema",
        type: "variant",
        reference: variant,
        expects: "Object",
        async: false,
        key: key,
        options: options,
        message: message,
        _run (dataset, config2) {
            const input = dataset.value;
            if (input && typeof input === "object") {
                let outputDataset;
                let maxDiscriminatorPriority = 0;
                let invalidDiscriminatorKey = this.key;
                let expectedDiscriminators = [];
                const parseOptions = (variant2, allKeys)=>{
                    for (const schema of variant2.options){
                        if (schema.type === "variant") parseOptions(schema, new Set(allKeys).add(schema.key));
                        else {
                            let keysAreValid = true;
                            let currentPriority = 0;
                            for (const currentKey of allKeys){
                                if (schema.entries[currentKey]._run(// @ts-expect-error
                                {
                                    typed: false,
                                    value: input[currentKey]
                                }, config2).issues) {
                                    keysAreValid = false;
                                    if (invalidDiscriminatorKey !== currentKey && (maxDiscriminatorPriority < currentPriority || maxDiscriminatorPriority === currentPriority && currentKey in input && !(invalidDiscriminatorKey in input))) {
                                        maxDiscriminatorPriority = currentPriority;
                                        invalidDiscriminatorKey = currentKey;
                                        expectedDiscriminators = [];
                                    }
                                    if (invalidDiscriminatorKey === currentKey) expectedDiscriminators.push(schema.entries[currentKey].expects);
                                    break;
                                }
                                currentPriority++;
                            }
                            if (keysAreValid) {
                                const optionDataset = schema._run({
                                    typed: false,
                                    value: input
                                }, config2);
                                if (!outputDataset || !outputDataset.typed && optionDataset.typed) outputDataset = optionDataset;
                            }
                        }
                        if (outputDataset && !outputDataset.issues) break;
                    }
                };
                parseOptions(this, /* @__PURE__ */ new Set([
                    this.key
                ]));
                if (outputDataset) return outputDataset;
                _addIssue(this, "type", dataset, config2, {
                    // @ts-expect-error
                    input: input[invalidDiscriminatorKey],
                    expected: _joinExpects(expectedDiscriminators, "|"),
                    path: [
                        {
                            type: "object",
                            origin: "value",
                            input: input,
                            key: invalidDiscriminatorKey,
                            // @ts-expect-error
                            value: input[invalidDiscriminatorKey]
                        }
                    ]
                });
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/variant/variantAsync.ts
function variantAsync(key, options, message) {
    return {
        kind: "schema",
        type: "variant",
        reference: variantAsync,
        expects: "Object",
        async: true,
        key: key,
        options: options,
        message: message,
        async _run (dataset, config2) {
            const input = dataset.value;
            if (input && typeof input === "object") {
                let outputDataset;
                let maxDiscriminatorPriority = 0;
                let invalidDiscriminatorKey = this.key;
                let expectedDiscriminators = [];
                const parseOptions = async (variant2, allKeys)=>{
                    for (const schema of variant2.options){
                        if (schema.type === "variant") await parseOptions(schema, new Set(allKeys).add(schema.key));
                        else {
                            let keysAreValid = true;
                            let currentPriority = 0;
                            for (const currentKey of allKeys){
                                if ((await schema.entries[currentKey]._run(// @ts-expect-error
                                {
                                    typed: false,
                                    value: input[currentKey]
                                }, config2)).issues) {
                                    keysAreValid = false;
                                    if (invalidDiscriminatorKey !== currentKey && (maxDiscriminatorPriority < currentPriority || maxDiscriminatorPriority === currentPriority && currentKey in input && !(invalidDiscriminatorKey in input))) {
                                        maxDiscriminatorPriority = currentPriority;
                                        invalidDiscriminatorKey = currentKey;
                                        expectedDiscriminators = [];
                                    }
                                    if (invalidDiscriminatorKey === currentKey) expectedDiscriminators.push(schema.entries[currentKey].expects);
                                    break;
                                }
                                currentPriority++;
                            }
                            if (keysAreValid) {
                                const optionDataset = await schema._run({
                                    typed: false,
                                    value: input
                                }, config2);
                                if (!outputDataset || !outputDataset.typed && optionDataset.typed) outputDataset = optionDataset;
                            }
                        }
                        if (outputDataset && !outputDataset.issues) break;
                    }
                };
                await parseOptions(this, /* @__PURE__ */ new Set([
                    this.key
                ]));
                if (outputDataset) return outputDataset;
                _addIssue(this, "type", dataset, config2, {
                    // @ts-expect-error
                    input: input[invalidDiscriminatorKey],
                    expected: _joinExpects(expectedDiscriminators, "|"),
                    path: [
                        {
                            type: "object",
                            origin: "value",
                            input: input,
                            key: invalidDiscriminatorKey,
                            // @ts-expect-error
                            value: input[invalidDiscriminatorKey]
                        }
                    ]
                });
            } else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/schemas/void/void.ts
function void_(message) {
    return {
        kind: "schema",
        type: "void",
        reference: void_,
        expects: "void",
        async: false,
        message: message,
        _run (dataset, config2) {
            if (dataset.value === void 0) dataset.typed = true;
            else _addIssue(this, "type", dataset, config2);
            return dataset;
        }
    };
}
// src/methods/keyof/keyof.ts
function keyof(schema, message) {
    return picklist(Object.keys(schema.entries), message);
}
// src/methods/omit/omit.ts
function omit(schema, keys) {
    const entries = {
        ...schema.entries
    };
    for (const key of keys)delete entries[key];
    return {
        ...schema,
        entries: entries
    };
}
// src/methods/parse/parse.ts
function parse(schema, input, config2) {
    const dataset = schema._run({
        typed: false,
        value: input
    }, getGlobalConfig(config2));
    if (dataset.issues) throw new ValiError(dataset.issues);
    return dataset.value;
}
// src/methods/parse/parseAsync.ts
async function parseAsync(schema, input, config2) {
    const dataset = await schema._run({
        typed: false,
        value: input
    }, getGlobalConfig(config2));
    if (dataset.issues) throw new ValiError(dataset.issues);
    return dataset.value;
}
// src/methods/parser/parser.ts
function parser(schema, config2) {
    const func = (input)=>parse(schema, input, config2);
    func.schema = schema;
    func.config = config2;
    return func;
}
// src/methods/parser/parserAsync.ts
function parserAsync(schema, config2) {
    const func = (input)=>parseAsync(schema, input, config2);
    func.schema = schema;
    func.config = config2;
    return func;
}
// src/methods/partial/partial.ts
function partial(schema, keys) {
    const entries = {};
    for(const key in schema.entries)entries[key] = !keys || keys.includes(key) ? optional(schema.entries[key]) : schema.entries[key];
    return {
        ...schema,
        entries: entries
    };
}
// src/methods/partial/partialAsync.ts
function partialAsync(schema, keys) {
    const entries = {};
    for(const key in schema.entries)entries[key] = !keys || keys.includes(key) ? optionalAsync(schema.entries[key]) : schema.entries[key];
    return {
        ...schema,
        entries: entries
    };
}
// src/methods/pick/pick.ts
function pick(schema, keys) {
    const entries = {};
    for (const key of keys)entries[key] = schema.entries[key];
    return {
        ...schema,
        entries: entries
    };
}
// src/methods/pipe/pipe.ts
function pipe(...pipe2) {
    return {
        ...pipe2[0],
        pipe: pipe2,
        _run (dataset, config2) {
            for (const item of pipe2)if (item.kind !== "metadata") {
                if (dataset.issues && (item.kind === "schema" || item.kind === "transformation")) {
                    dataset.typed = false;
                    break;
                }
                if (!dataset.issues || !config2.abortEarly && !config2.abortPipeEarly) dataset = item._run(dataset, config2);
            }
            return dataset;
        }
    };
}
// src/methods/pipe/pipeAsync.ts
function pipeAsync(...pipe2) {
    return {
        ...pipe2[0],
        pipe: pipe2,
        async: true,
        async _run (dataset, config2) {
            for (const item of pipe2)if (item.kind !== "metadata") {
                if (dataset.issues && (item.kind === "schema" || item.kind === "transformation")) {
                    dataset.typed = false;
                    break;
                }
                if (!dataset.issues || !config2.abortEarly && !config2.abortPipeEarly) dataset = await item._run(dataset, config2);
            }
            return dataset;
        }
    };
}
// src/methods/required/required.ts
function required(schema, arg2, arg3) {
    const keys = Array.isArray(arg2) ? arg2 : void 0;
    const message = Array.isArray(arg2) ? arg3 : arg2;
    const entries = {};
    for(const key in schema.entries)entries[key] = !keys || keys.includes(key) ? nonOptional(schema.entries[key], message) : schema.entries[key];
    return {
        ...schema,
        entries: entries
    };
}
// src/methods/required/requiredAsync.ts
function requiredAsync(schema, arg2, arg3) {
    const keys = Array.isArray(arg2) ? arg2 : void 0;
    const message = Array.isArray(arg2) ? arg3 : arg2;
    const entries = {};
    for(const key in schema.entries)entries[key] = !keys || keys.includes(key) ? nonOptionalAsync(schema.entries[key], message) : schema.entries[key];
    return {
        ...schema,
        entries: entries
    };
}
// src/methods/safeParse/safeParse.ts
function safeParse(schema, input, config2) {
    const dataset = schema._run({
        typed: false,
        value: input
    }, getGlobalConfig(config2));
    return {
        typed: dataset.typed,
        success: !dataset.issues,
        output: dataset.value,
        issues: dataset.issues
    };
}
// src/methods/safeParse/safeParseAsync.ts
async function safeParseAsync(schema, input, config2) {
    const dataset = await schema._run({
        typed: false,
        value: input
    }, getGlobalConfig(config2));
    return {
        typed: dataset.typed,
        success: !dataset.issues,
        output: dataset.value,
        issues: dataset.issues
    };
}
// src/methods/safeParser/safeParser.ts
function safeParser(schema, config2) {
    const func = (input)=>safeParse(schema, input, config2);
    func.schema = schema;
    func.config = config2;
    return func;
}
// src/methods/safeParser/safeParserAsync.ts
function safeParserAsync(schema, config2) {
    const func = (input)=>safeParseAsync(schema, input, config2);
    func.schema = schema;
    func.config = config2;
    return func;
}
// src/methods/unwrap/unwrap.ts
function unwrap(schema) {
    return schema.wrapped;
}

});

parcelRegister("nNv0y", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $04788b97afea9e85$export$2b8d127b894957b9, (v) => $04788b97afea9e85$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $04788b97afea9e85$export$cea3a54a6425200c, (v) => $04788b97afea9e85$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $04788b97afea9e85$export$a7c73072b1a182ae, (v) => $04788b97afea9e85$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $04788b97afea9e85$export$9f27bc3417b4524d, (v) => $04788b97afea9e85$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $04788b97afea9e85$export$db77ccec0bb4ccac, (v) => $04788b97afea9e85$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $04788b97afea9e85$export$8392c0c9d3dcbd35, (v) => $04788b97afea9e85$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $04788b97afea9e85$export$ffb0004e005737fa, (v) => $04788b97afea9e85$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $04788b97afea9e85$export$b624eff549462981, (v) => $04788b97afea9e85$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $04788b97afea9e85$export$7897aa7841a5380c, (v) => $04788b97afea9e85$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $04788b97afea9e85$export$602eac185826482c, (v) => $04788b97afea9e85$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $04788b97afea9e85$export$e2c29f18771995cb, (v) => $04788b97afea9e85$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $04788b97afea9e85$export$5f8d39834fd61797, (v) => $04788b97afea9e85$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $04788b97afea9e85$export$74bf444e3cd11ea5, (v) => $04788b97afea9e85$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $04788b97afea9e85$export$92387174baf9b227, (v) => $04788b97afea9e85$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $04788b97afea9e85$export$ec112efeb987d9c6, (v) => $04788b97afea9e85$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $04788b97afea9e85$export$b706b080d889d2c9, (v) => $04788b97afea9e85$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $04788b97afea9e85$export$5be5a87408f70ddc, (v) => $04788b97afea9e85$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $04788b97afea9e85$export$45a5e7f76e0caa8d, (v) => $04788b97afea9e85$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $04788b97afea9e85$export$455c2e768291efa6, (v) => $04788b97afea9e85$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $04788b97afea9e85$export$9522e17588c12572, (v) => $04788b97afea9e85$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $04788b97afea9e85$export$2110ac352bb060b9, (v) => $04788b97afea9e85$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $04788b97afea9e85$export$56885ab8b9c456ab, (v) => $04788b97afea9e85$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $04788b97afea9e85$export$d927fcb6adf8f9de, (v) => $04788b97afea9e85$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $04788b97afea9e85$export$b82d16f27459e05a, (v) => $04788b97afea9e85$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $04788b97afea9e85$export$522c17b4f5e123e8, (v) => $04788b97afea9e85$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $04788b97afea9e85$export$1aabd8a0274ecfd6, (v) => $04788b97afea9e85$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $04788b97afea9e85$export$9b621391a187a31a, (v) => $04788b97afea9e85$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $04788b97afea9e85$export$f5bbd400c2f4426f, (v) => $04788b97afea9e85$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $04788b97afea9e85$export$2b8d127b894957b9;
var $04788b97afea9e85$export$cea3a54a6425200c;
var $04788b97afea9e85$export$a7c73072b1a182ae;
var $04788b97afea9e85$export$9f27bc3417b4524d;
var $04788b97afea9e85$export$db77ccec0bb4ccac;
var $04788b97afea9e85$export$8392c0c9d3dcbd35;
var $04788b97afea9e85$export$ffb0004e005737fa;
var $04788b97afea9e85$export$b624eff549462981;
var $04788b97afea9e85$export$7897aa7841a5380c;
var $04788b97afea9e85$export$602eac185826482c;
var $04788b97afea9e85$export$e2c29f18771995cb;
var $04788b97afea9e85$export$5f8d39834fd61797;
var $04788b97afea9e85$export$74bf444e3cd11ea5;
var $04788b97afea9e85$export$92387174baf9b227;
var $04788b97afea9e85$export$ec112efeb987d9c6;
var $04788b97afea9e85$export$b706b080d889d2c9;
var $04788b97afea9e85$export$5be5a87408f70ddc;
var $04788b97afea9e85$export$45a5e7f76e0caa8d;
var $04788b97afea9e85$export$455c2e768291efa6;
var $04788b97afea9e85$export$9522e17588c12572;
var $04788b97afea9e85$export$2110ac352bb060b9;
var $04788b97afea9e85$export$56885ab8b9c456ab;
var $04788b97afea9e85$export$d927fcb6adf8f9de;
var $04788b97afea9e85$export$b82d16f27459e05a;
var $04788b97afea9e85$export$522c17b4f5e123e8;
var $04788b97afea9e85$export$1aabd8a0274ecfd6;
var $04788b97afea9e85$export$9b621391a187a31a;
var $04788b97afea9e85$export$f5bbd400c2f4426f;
"use strict";
var $04788b97afea9e85$var$b = "function" === typeof Symbol && Symbol.for, $04788b97afea9e85$var$c = $04788b97afea9e85$var$b ? Symbol.for("react.element") : 60103, $04788b97afea9e85$var$d = $04788b97afea9e85$var$b ? Symbol.for("react.portal") : 60106, $04788b97afea9e85$var$e = $04788b97afea9e85$var$b ? Symbol.for("react.fragment") : 60107, $04788b97afea9e85$var$f = $04788b97afea9e85$var$b ? Symbol.for("react.strict_mode") : 60108, $04788b97afea9e85$var$g = $04788b97afea9e85$var$b ? Symbol.for("react.profiler") : 60114, $04788b97afea9e85$var$h = $04788b97afea9e85$var$b ? Symbol.for("react.provider") : 60109, $04788b97afea9e85$var$k = $04788b97afea9e85$var$b ? Symbol.for("react.context") : 60110, $04788b97afea9e85$var$l = $04788b97afea9e85$var$b ? Symbol.for("react.async_mode") : 60111, $04788b97afea9e85$var$m = $04788b97afea9e85$var$b ? Symbol.for("react.concurrent_mode") : 60111, $04788b97afea9e85$var$n = $04788b97afea9e85$var$b ? Symbol.for("react.forward_ref") : 60112, $04788b97afea9e85$var$p = $04788b97afea9e85$var$b ? Symbol.for("react.suspense") : 60113, $04788b97afea9e85$var$q = $04788b97afea9e85$var$b ? Symbol.for("react.suspense_list") : 60120, $04788b97afea9e85$var$r = $04788b97afea9e85$var$b ? Symbol.for("react.memo") : 60115, $04788b97afea9e85$var$t = $04788b97afea9e85$var$b ? Symbol.for("react.lazy") : 60116, $04788b97afea9e85$var$v = $04788b97afea9e85$var$b ? Symbol.for("react.block") : 60121, $04788b97afea9e85$var$w = $04788b97afea9e85$var$b ? Symbol.for("react.fundamental") : 60117, $04788b97afea9e85$var$x = $04788b97afea9e85$var$b ? Symbol.for("react.responder") : 60118, $04788b97afea9e85$var$y = $04788b97afea9e85$var$b ? Symbol.for("react.scope") : 60119;
function $04788b97afea9e85$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $04788b97afea9e85$var$c:
                switch(a = a.type, a){
                    case $04788b97afea9e85$var$l:
                    case $04788b97afea9e85$var$m:
                    case $04788b97afea9e85$var$e:
                    case $04788b97afea9e85$var$g:
                    case $04788b97afea9e85$var$f:
                    case $04788b97afea9e85$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $04788b97afea9e85$var$k:
                            case $04788b97afea9e85$var$n:
                            case $04788b97afea9e85$var$t:
                            case $04788b97afea9e85$var$r:
                            case $04788b97afea9e85$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $04788b97afea9e85$var$d:
                return u;
        }
    }
}
function $04788b97afea9e85$var$A(a) {
    return $04788b97afea9e85$var$z(a) === $04788b97afea9e85$var$m;
}
$04788b97afea9e85$export$2b8d127b894957b9 = $04788b97afea9e85$var$l;
$04788b97afea9e85$export$cea3a54a6425200c = $04788b97afea9e85$var$m;
$04788b97afea9e85$export$a7c73072b1a182ae = $04788b97afea9e85$var$k;
$04788b97afea9e85$export$9f27bc3417b4524d = $04788b97afea9e85$var$h;
$04788b97afea9e85$export$db77ccec0bb4ccac = $04788b97afea9e85$var$c;
$04788b97afea9e85$export$8392c0c9d3dcbd35 = $04788b97afea9e85$var$n;
$04788b97afea9e85$export$ffb0004e005737fa = $04788b97afea9e85$var$e;
$04788b97afea9e85$export$b624eff549462981 = $04788b97afea9e85$var$t;
$04788b97afea9e85$export$7897aa7841a5380c = $04788b97afea9e85$var$r;
$04788b97afea9e85$export$602eac185826482c = $04788b97afea9e85$var$d;
$04788b97afea9e85$export$e2c29f18771995cb = $04788b97afea9e85$var$g;
$04788b97afea9e85$export$5f8d39834fd61797 = $04788b97afea9e85$var$f;
$04788b97afea9e85$export$74bf444e3cd11ea5 = $04788b97afea9e85$var$p;
$04788b97afea9e85$export$92387174baf9b227 = function(a) {
    return $04788b97afea9e85$var$A(a) || $04788b97afea9e85$var$z(a) === $04788b97afea9e85$var$l;
};
$04788b97afea9e85$export$ec112efeb987d9c6 = $04788b97afea9e85$var$A;
$04788b97afea9e85$export$b706b080d889d2c9 = function(a) {
    return $04788b97afea9e85$var$z(a) === $04788b97afea9e85$var$k;
};
$04788b97afea9e85$export$5be5a87408f70ddc = function(a) {
    return $04788b97afea9e85$var$z(a) === $04788b97afea9e85$var$h;
};
$04788b97afea9e85$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $04788b97afea9e85$var$c;
};
$04788b97afea9e85$export$455c2e768291efa6 = function(a) {
    return $04788b97afea9e85$var$z(a) === $04788b97afea9e85$var$n;
};
$04788b97afea9e85$export$9522e17588c12572 = function(a) {
    return $04788b97afea9e85$var$z(a) === $04788b97afea9e85$var$e;
};
$04788b97afea9e85$export$2110ac352bb060b9 = function(a) {
    return $04788b97afea9e85$var$z(a) === $04788b97afea9e85$var$t;
};
$04788b97afea9e85$export$56885ab8b9c456ab = function(a) {
    return $04788b97afea9e85$var$z(a) === $04788b97afea9e85$var$r;
};
$04788b97afea9e85$export$d927fcb6adf8f9de = function(a) {
    return $04788b97afea9e85$var$z(a) === $04788b97afea9e85$var$d;
};
$04788b97afea9e85$export$b82d16f27459e05a = function(a) {
    return $04788b97afea9e85$var$z(a) === $04788b97afea9e85$var$g;
};
$04788b97afea9e85$export$522c17b4f5e123e8 = function(a) {
    return $04788b97afea9e85$var$z(a) === $04788b97afea9e85$var$f;
};
$04788b97afea9e85$export$1aabd8a0274ecfd6 = function(a) {
    return $04788b97afea9e85$var$z(a) === $04788b97afea9e85$var$p;
};
$04788b97afea9e85$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $04788b97afea9e85$var$e || a === $04788b97afea9e85$var$m || a === $04788b97afea9e85$var$g || a === $04788b97afea9e85$var$f || a === $04788b97afea9e85$var$p || a === $04788b97afea9e85$var$q || "object" === typeof a && null !== a && (a.$$typeof === $04788b97afea9e85$var$t || a.$$typeof === $04788b97afea9e85$var$r || a.$$typeof === $04788b97afea9e85$var$h || a.$$typeof === $04788b97afea9e85$var$k || a.$$typeof === $04788b97afea9e85$var$n || a.$$typeof === $04788b97afea9e85$var$w || a.$$typeof === $04788b97afea9e85$var$x || a.$$typeof === $04788b97afea9e85$var$y || a.$$typeof === $04788b97afea9e85$var$v);
};
$04788b97afea9e85$export$f5bbd400c2f4426f = $04788b97afea9e85$var$z;

});

parcelRegister("9A5xi", function(module, exports) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("krg3S", function(module, exports) {

$parcel$export(module.exports, "Formik", () => Formik);
$parcel$export(module.exports, "useField", () => useField);
$parcel$export(module.exports, "Form", () => Form);
$parcel$export(module.exports, "ErrorMessage", () => ErrorMessage);

var $tZqWC = parcelRequire("tZqWC");

var $gtGaO = parcelRequire("gtGaO");

var $jz9i0 = parcelRequire("jz9i0");

var $k6JLi = parcelRequire("k6JLi");

var $1jWfM = parcelRequire("1jWfM");

var $gEK22 = parcelRequire("gEK22");

var $gRx9P = parcelRequire("gRx9P");

var $7g5pF = parcelRequire("7g5pF");

var $e3GSY = parcelRequire("e3GSY");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === "function";
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === "object";
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === "[object String]";
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $tZqWC.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== "undefined" ? document : undefined);
    if (typeof doc === "undefined") return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $gEK22.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $1jWfM.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $gEK22.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $1jWfM.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
var FormikContext = /*#__PURE__*/ (0, $tZqWC.createContext)(undefined);
FormikContext.displayName = "FormikContext";
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $tZqWC.useContext)(FormikContext);
    !!!formik && (0, $gRx9P.default)(false);
    return formik;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case "SET_VALUES":
            return _extends({}, state, {
                values: msg.payload
            });
        case "SET_TOUCHED":
            return _extends({}, state, {
                touched: msg.payload
            });
        case "SET_ERRORS":
            if ((0, (/*@__PURE__*/$parcel$interopDefault($gtGaO)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case "SET_STATUS":
            return _extends({}, state, {
                status: msg.payload
            });
        case "SET_ISSUBMITTING":
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case "SET_ISVALIDATING":
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case "SET_FIELD_VALUE":
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_TOUCHED":
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_ERROR":
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case "RESET_FORM":
            return _extends({}, state, msg.payload);
        case "SET_FORMIK_STATE":
            return msg.payload(state);
        case "SUBMIT_ATTEMPT":
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case "SUBMIT_FAILURE":
            return _extends({}, state, {
                isSubmitting: false
            });
        case "SUBMIT_SUCCESS":
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $tZqWC.useRef)(props.initialValues);
    var initialErrors = (0, $tZqWC.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $tZqWC.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $tZqWC.useRef)(props.initialStatus);
    var isMounted = (0, $tZqWC.useRef)(false);
    var fieldRegistry = (0, $tZqWC.useRef)({});
    (0, $tZqWC.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useReducer = (0, $tZqWC.useReducer)(formikReducer, {
        values: props.initialValues,
        errors: props.initialErrors || emptyErrors,
        touched: props.initialTouched || emptyTouched,
        status: props.initialStatus,
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    }), state = _React$useReducer[0], dispatch = _React$useReducer[1];
    var runValidateHandler = (0, $tZqWC.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $tZqWC.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === "ValidationError") resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $tZqWC.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $tZqWC.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === "DO_NOT_DELETE_YOU_WILL_BE_FIRED") return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $tZqWC.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $jz9i0.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: "SET_ISVALIDATING",
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
                dispatch({
                    type: "SET_ERRORS",
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $tZqWC.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($gtGaO)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $tZqWC.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: "RESET_FORM",
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === "number" ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched
    ]);
    (0, $tZqWC.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($gtGaO)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
            }
            if (validateOnMount) validateFormWithHighPriority(initialValues.current);
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $tZqWC.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($gtGaO)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: "SET_ERRORS",
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $tZqWC.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($gtGaO)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: "SET_TOUCHED",
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $tZqWC.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($gtGaO)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: "SET_STATUS",
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: "SET_FIELD_ERROR",
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: "SET_ISVALIDATING",
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: "SET_ISVALIDATING",
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: error[name]
                    }
                });
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $tZqWC.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $tZqWC.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: "SET_TOUCHED",
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $tZqWC.useCallback)(function(errors) {
        dispatch({
            type: "SET_ERRORS",
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: "SET_VALUES",
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $tZqWC.useCallback)(function(field, value) {
        dispatch({
            type: "SET_FIELD_ERROR",
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: "SET_FIELD_VALUE",
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, $tZqWC.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? "" : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: "SET_FIELD_TOUCHED",
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $tZqWC.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $tZqWC.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: "SET_FORMIK_STATE",
            payload: stateOrCb
        });
        else dispatch({
            type: "SET_FORMIK_STATE",
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $tZqWC.useCallback)(function(status) {
        dispatch({
            type: "SET_STATUS",
            payload: status
        });
    }, []);
    var setSubmitting = (0, $tZqWC.useCallback)(function(isSubmitting) {
        dispatch({
            type: "SET_ISSUBMITTING",
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: "SUBMIT_ATTEMPT"
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: "SUBMIT_SUCCESS"
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: "SUBMIT_FAILURE"
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: "SUBMIT_FAILURE"
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $tZqWC.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $tZqWC.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $tZqWC.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === "checkbox") {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === "radio") {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === "select" && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $tZqWC.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($gtGaO)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $tZqWC.useMemo)(function() {
        return typeof isInitialValid !== "undefined" ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $tZqWC.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $tZqWC.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $tZqWC.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $tZqWC.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    if (context === void 0) context = {};
    var validateData = prepareDataForValidation(values);
    return schema[sync ? "validateSync" : "validate"](validateData, {
        abortEarly: false,
        context: context
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $k6JLi.default)(value)) return prepareDataForValidation(value);
            else return value !== "" ? value : undefined;
        });
        else if ((0, $k6JLi.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== "" ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === "undefined") {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $jz9i0.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $jz9i0.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === "boolean") return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == "true" || valueProp == "false") return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $tZqWC.useLayoutEffect) : (0, $tZqWC.useEffect);
function useEventCallback(fn) {
    var ref = (0, $tZqWC.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $tZqWC.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $tZqWC.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $gRx9P.default)(false);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        getFieldHelpers(fieldName)
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $tZqWC.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === "string") {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $tZqWC.createElement)(component, _extends({
                ref: innerRef
            }, field, rest), children);
        } // We don't pass `meta` for backwards compat
        return (0, $tZqWC.createElement)(component, _extends({
            field: field,
            form: formik
        }, props), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || "input";
    if (typeof asElement === "string") {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $tZqWC.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest), children);
    }
    return (0, $tZqWC.createElement)(asElement, _extends({}, field, props), children);
}
var Form = /*#__PURE__*/ (0, $tZqWC.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : "#";
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $tZqWC.createElement)("form", Object.assign({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = "Form";
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== "function") // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || "Component";
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                _this = _React$Component.apply(this, arguments) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                /**
         * Just avoiding a render callback for perf here
         */ _this.renderFormComponent = function(formikProps) {
                    return (0, $tZqWC.createElement)(Component$1, Object.assign({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $tZqWC.createElement)(Formik, Object.assign({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $tZqWC.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($7g5pF)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $tZqWC.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $gRx9P.default)(false);
            return (0, $tZqWC.createElement)(Comp, Object.assign({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || "Component"; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($7g5pF)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = typeof alterErrors === "function" ? alterErrors : fn;
                var updateTouched = typeof alterTouched === "function" ? alterTouched : fn; // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $e3GSY.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                if (length < 0) length = arr.length;
                return arr;
            }, function(array) {
                var arr = array ? [
                    null
                ].concat(array) : [
                    null
                ];
                if (length < 0) length = arr.length;
                return arr;
            }, function(array) {
                var arr = array ? [
                    null
                ].concat(array) : [
                    null
                ];
                if (length < 0) length = arr.length;
                return arr;
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        }; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($gtGaO)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
            return copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array;
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $tZqWC.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === "function" ? children(props) : !isEmptyChildren(children) ? (0, $tZqWC.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $tZqWC.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $tZqWC.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $tZqWC.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $gRx9P.default)(false);
        !!(component && render) && (0, $gRx9P.default)(false);
        !!(is && children && isFunction(children)) && (0, $gRx9P.default)(false);
        !!(component && children && isFunction(children)) && (0, $gRx9P.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $gRx9P.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === "string") {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $tZqWC.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $tZqWC.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || "input";
        if (typeof asElement === "string") {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $tZqWC.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $tZqWC.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $tZqWC.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("gtGaO", function(module, exports) {
"use strict";
var $bff0118810130a42$var$isArray = Array.isArray;
var $bff0118810130a42$var$keyList = Object.keys;
var $bff0118810130a42$var$hasProp = Object.prototype.hasOwnProperty;
var $bff0118810130a42$var$hasElementType = typeof Element !== "undefined";
function $bff0118810130a42$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        var arrA = $bff0118810130a42$var$isArray(a), arrB = $bff0118810130a42$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$bff0118810130a42$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $bff0118810130a42$var$keyList(a);
        length = keys.length;
        if (length !== $bff0118810130a42$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$bff0118810130a42$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($bff0118810130a42$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$bff0118810130a42$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $bff0118810130a42$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("jz9i0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3e87dde0214ec6c$export$2e2bcd8739ae039);
var $e3e87dde0214ec6c$var$isMergeableObject = function isMergeableObject(value) {
    return $e3e87dde0214ec6c$var$isNonNullObject(value) && !$e3e87dde0214ec6c$var$isSpecial(value);
};
function $e3e87dde0214ec6c$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $e3e87dde0214ec6c$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $e3e87dde0214ec6c$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $e3e87dde0214ec6c$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $e3e87dde0214ec6c$var$REACT_ELEMENT_TYPE = $e3e87dde0214ec6c$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $e3e87dde0214ec6c$var$isReactElement(value) {
    return value.$$typeof === $e3e87dde0214ec6c$var$REACT_ELEMENT_TYPE;
}
function $e3e87dde0214ec6c$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $e3e87dde0214ec6c$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $e3e87dde0214ec6c$var$deepmerge($e3e87dde0214ec6c$var$emptyTarget(value), value, options) : value;
}
function $e3e87dde0214ec6c$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $e3e87dde0214ec6c$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $e3e87dde0214ec6c$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $e3e87dde0214ec6c$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $e3e87dde0214ec6c$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $e3e87dde0214ec6c$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $e3e87dde0214ec6c$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $e3e87dde0214ec6c$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $e3e87dde0214ec6c$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $e3e87dde0214ec6c$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $e3e87dde0214ec6c$var$mergeObject(target, source, options);
}
$e3e87dde0214ec6c$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $e3e87dde0214ec6c$var$deepmerge(prev, next, options);
    }, {});
};
var $e3e87dde0214ec6c$var$deepmerge_1 = $e3e87dde0214ec6c$var$deepmerge;
var $e3e87dde0214ec6c$export$2e2bcd8739ae039 = $e3e87dde0214ec6c$var$deepmerge_1;

});

parcelRegister("k6JLi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea37dd85c0ab7fe5$export$2e2bcd8739ae039);

var $8X3vt = parcelRequire("8X3vt");

var $dkTWv = parcelRequire("dkTWv");

var $da1Ti = parcelRequire("da1Ti");
/** `Object#toString` result references. */ var $ea37dd85c0ab7fe5$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $ea37dd85c0ab7fe5$var$funcProto = Function.prototype, $ea37dd85c0ab7fe5$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $ea37dd85c0ab7fe5$var$funcToString = $ea37dd85c0ab7fe5$var$funcProto.toString;
/** Used to check objects for own properties. */ var $ea37dd85c0ab7fe5$var$hasOwnProperty = $ea37dd85c0ab7fe5$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $ea37dd85c0ab7fe5$var$objectCtorString = $ea37dd85c0ab7fe5$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $ea37dd85c0ab7fe5$var$isPlainObject(value) {
    if (!(0, $da1Ti.default)(value) || (0, $8X3vt.default)(value) != $ea37dd85c0ab7fe5$var$objectTag) return false;
    var proto = (0, $dkTWv.default)(value);
    if (proto === null) return true;
    var Ctor = $ea37dd85c0ab7fe5$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $ea37dd85c0ab7fe5$var$funcToString.call(Ctor) == $ea37dd85c0ab7fe5$var$objectCtorString;
}
var $ea37dd85c0ab7fe5$export$2e2bcd8739ae039 = $ea37dd85c0ab7fe5$var$isPlainObject;

});
parcelRegister("8X3vt", function(module, exports) {

$parcel$export(module.exports, "default", () => $68468dc8d9512fd3$export$2e2bcd8739ae039);

var $aYS7m = parcelRequire("aYS7m");

var $gmfoF = parcelRequire("gmfoF");

var $cok5v = parcelRequire("cok5v");
/** `Object#toString` result references. */ var $68468dc8d9512fd3$var$nullTag = "[object Null]", $68468dc8d9512fd3$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $68468dc8d9512fd3$var$symToStringTag = (0, $aYS7m.default) ? (0, $aYS7m.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $68468dc8d9512fd3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $68468dc8d9512fd3$var$undefinedTag : $68468dc8d9512fd3$var$nullTag;
    return $68468dc8d9512fd3$var$symToStringTag && $68468dc8d9512fd3$var$symToStringTag in Object(value) ? (0, $gmfoF.default)(value) : (0, $cok5v.default)(value);
}
var $68468dc8d9512fd3$export$2e2bcd8739ae039 = $68468dc8d9512fd3$var$baseGetTag;

});
parcelRegister("aYS7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $0210272bf8e1daa8$export$2e2bcd8739ae039);

var $fRXcK = parcelRequire("fRXcK");
/** Built-in value references. */ var $0210272bf8e1daa8$var$Symbol = (0, $fRXcK.default).Symbol;
var $0210272bf8e1daa8$export$2e2bcd8739ae039 = $0210272bf8e1daa8$var$Symbol;

});
parcelRegister("fRXcK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8d9bb12be31d9ad$export$2e2bcd8739ae039);

var $1kslA = parcelRequire("1kslA");
/** Detect free variable `self`. */ var $b8d9bb12be31d9ad$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $b8d9bb12be31d9ad$var$root = (0, $1kslA.default) || $b8d9bb12be31d9ad$var$freeSelf || Function("return this")();
var $b8d9bb12be31d9ad$export$2e2bcd8739ae039 = $b8d9bb12be31d9ad$var$root;

});
parcelRegister("1kslA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f7da5e1cb69594e$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $0f7da5e1cb69594e$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $0f7da5e1cb69594e$export$2e2bcd8739ae039 = $0f7da5e1cb69594e$var$freeGlobal;

});



parcelRegister("gmfoF", function(module, exports) {

$parcel$export(module.exports, "default", () => $be8aa4ebf35d483b$export$2e2bcd8739ae039);

var $aYS7m = parcelRequire("aYS7m");
/** Used for built-in method references. */ var $be8aa4ebf35d483b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $be8aa4ebf35d483b$var$hasOwnProperty = $be8aa4ebf35d483b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $be8aa4ebf35d483b$var$nativeObjectToString = $be8aa4ebf35d483b$var$objectProto.toString;
/** Built-in value references. */ var $be8aa4ebf35d483b$var$symToStringTag = (0, $aYS7m.default) ? (0, $aYS7m.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $be8aa4ebf35d483b$var$getRawTag(value) {
    var isOwn = $be8aa4ebf35d483b$var$hasOwnProperty.call(value, $be8aa4ebf35d483b$var$symToStringTag), tag = value[$be8aa4ebf35d483b$var$symToStringTag];
    try {
        value[$be8aa4ebf35d483b$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $be8aa4ebf35d483b$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$be8aa4ebf35d483b$var$symToStringTag] = tag;
        else delete value[$be8aa4ebf35d483b$var$symToStringTag];
    }
    return result;
}
var $be8aa4ebf35d483b$export$2e2bcd8739ae039 = $be8aa4ebf35d483b$var$getRawTag;

});

parcelRegister("cok5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $90574ef76cd32410$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $90574ef76cd32410$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $90574ef76cd32410$var$nativeObjectToString = $90574ef76cd32410$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $90574ef76cd32410$var$objectToString(value) {
    return $90574ef76cd32410$var$nativeObjectToString.call(value);
}
var $90574ef76cd32410$export$2e2bcd8739ae039 = $90574ef76cd32410$var$objectToString;

});


parcelRegister("dkTWv", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b5889a70ae02920$export$2e2bcd8739ae039);

var $kX7Ds = parcelRequire("kX7Ds");
/** Built-in value references. */ var $9b5889a70ae02920$var$getPrototype = (0, $kX7Ds.default)(Object.getPrototypeOf, Object);
var $9b5889a70ae02920$export$2e2bcd8739ae039 = $9b5889a70ae02920$var$getPrototype;

});
parcelRegister("kX7Ds", function(module, exports) {

$parcel$export(module.exports, "default", () => $f40f3d8f9bab6dbb$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $f40f3d8f9bab6dbb$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $f40f3d8f9bab6dbb$export$2e2bcd8739ae039 = $f40f3d8f9bab6dbb$var$overArg;

});


parcelRegister("da1Ti", function(module, exports) {

$parcel$export(module.exports, "default", () => $994dad09dbe65596$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $994dad09dbe65596$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $994dad09dbe65596$export$2e2bcd8739ae039 = $994dad09dbe65596$var$isObjectLike;

});


parcelRegister("1jWfM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f64c0bf81a62130$export$2e2bcd8739ae039);

var $k0qEi = parcelRequire("k0qEi");
/** Used to compose bitmasks for cloning. */ var $0f64c0bf81a62130$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $0f64c0bf81a62130$var$clone(value) {
    return (0, $k0qEi.default)(value, $0f64c0bf81a62130$var$CLONE_SYMBOLS_FLAG);
}
var $0f64c0bf81a62130$export$2e2bcd8739ae039 = $0f64c0bf81a62130$var$clone;

});
parcelRegister("k0qEi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9087aa2c458803d$export$2e2bcd8739ae039);

var $29wyc = parcelRequire("29wyc");

var $6tC51 = parcelRequire("6tC51");

var $5YV7T = parcelRequire("5YV7T");

var $f9u12 = parcelRequire("f9u12");

var $5h2DV = parcelRequire("5h2DV");

var $c4zsg = parcelRequire("c4zsg");

var $h3wcn = parcelRequire("h3wcn");

var $fbIah = parcelRequire("fbIah");

var $170nJ = parcelRequire("170nJ");

var $3tk8b = parcelRequire("3tk8b");

var $8b64V = parcelRequire("8b64V");

var $gbHlz = parcelRequire("gbHlz");

var $izuBR = parcelRequire("izuBR");

var $lBsJH = parcelRequire("lBsJH");

var $kraA4 = parcelRequire("kraA4");

var $5yaQN = parcelRequire("5yaQN");

var $dsiS5 = parcelRequire("dsiS5");

var $9pyJg = parcelRequire("9pyJg");

var $frrTq = parcelRequire("frrTq");

var $19too = parcelRequire("19too");

var $2jh9k = parcelRequire("2jh9k");

var $2W5yf = parcelRequire("2W5yf");
/** Used to compose bitmasks for cloning. */ var $e9087aa2c458803d$var$CLONE_DEEP_FLAG = 1, $e9087aa2c458803d$var$CLONE_FLAT_FLAG = 2, $e9087aa2c458803d$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $e9087aa2c458803d$var$argsTag = "[object Arguments]", $e9087aa2c458803d$var$arrayTag = "[object Array]", $e9087aa2c458803d$var$boolTag = "[object Boolean]", $e9087aa2c458803d$var$dateTag = "[object Date]", $e9087aa2c458803d$var$errorTag = "[object Error]", $e9087aa2c458803d$var$funcTag = "[object Function]", $e9087aa2c458803d$var$genTag = "[object GeneratorFunction]", $e9087aa2c458803d$var$mapTag = "[object Map]", $e9087aa2c458803d$var$numberTag = "[object Number]", $e9087aa2c458803d$var$objectTag = "[object Object]", $e9087aa2c458803d$var$regexpTag = "[object RegExp]", $e9087aa2c458803d$var$setTag = "[object Set]", $e9087aa2c458803d$var$stringTag = "[object String]", $e9087aa2c458803d$var$symbolTag = "[object Symbol]", $e9087aa2c458803d$var$weakMapTag = "[object WeakMap]";
var $e9087aa2c458803d$var$arrayBufferTag = "[object ArrayBuffer]", $e9087aa2c458803d$var$dataViewTag = "[object DataView]", $e9087aa2c458803d$var$float32Tag = "[object Float32Array]", $e9087aa2c458803d$var$float64Tag = "[object Float64Array]", $e9087aa2c458803d$var$int8Tag = "[object Int8Array]", $e9087aa2c458803d$var$int16Tag = "[object Int16Array]", $e9087aa2c458803d$var$int32Tag = "[object Int32Array]", $e9087aa2c458803d$var$uint8Tag = "[object Uint8Array]", $e9087aa2c458803d$var$uint8ClampedTag = "[object Uint8ClampedArray]", $e9087aa2c458803d$var$uint16Tag = "[object Uint16Array]", $e9087aa2c458803d$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $e9087aa2c458803d$var$cloneableTags = {};
$e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$argsTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$arrayTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$arrayBufferTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$dataViewTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$boolTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$dateTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$float32Tag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$float64Tag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$int8Tag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$int16Tag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$int32Tag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$mapTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$numberTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$objectTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$regexpTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$setTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$stringTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$symbolTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$uint8Tag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$uint8ClampedTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$uint16Tag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$uint32Tag] = true;
$e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$errorTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$funcTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $e9087aa2c458803d$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $e9087aa2c458803d$var$CLONE_DEEP_FLAG, isFlat = bitmask & $e9087aa2c458803d$var$CLONE_FLAT_FLAG, isFull = bitmask & $e9087aa2c458803d$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $frrTq.default)(value)) return value;
    var isArr = (0, $5yaQN.default)(value);
    if (isArr) {
        result = (0, $izuBR.default)(value);
        if (!isDeep) return (0, $h3wcn.default)(value, result);
    } else {
        var tag = (0, $gbHlz.default)(value), isFunc = tag == $e9087aa2c458803d$var$funcTag || tag == $e9087aa2c458803d$var$genTag;
        if ((0, $dsiS5.default)(value)) return (0, $c4zsg.default)(value, isDeep);
        if (tag == $e9087aa2c458803d$var$objectTag || tag == $e9087aa2c458803d$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $kraA4.default)(value);
            if (!isDeep) return isFlat ? (0, $170nJ.default)(value, (0, $5h2DV.default)(result, value)) : (0, $fbIah.default)(value, (0, $f9u12.default)(result, value));
        } else {
            if (!$e9087aa2c458803d$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $lBsJH.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $29wyc.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $19too.default)(value)) value.forEach(function(subValue) {
        result.add($e9087aa2c458803d$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $9pyJg.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $e9087aa2c458803d$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $8b64V.default) : (0, $3tk8b.default) : isFlat ? (0, $2W5yf.default) : (0, $2jh9k.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $6tC51.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $5YV7T.default)(result, key, $e9087aa2c458803d$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $e9087aa2c458803d$export$2e2bcd8739ae039 = $e9087aa2c458803d$var$baseClone;

});
parcelRegister("29wyc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1915abe93de7f94a$export$2e2bcd8739ae039);

var $bKxs2 = parcelRequire("bKxs2");

var $54bhV = parcelRequire("54bhV");

var $8TShp = parcelRequire("8TShp");

var $22Xy2 = parcelRequire("22Xy2");

var $79WLC = parcelRequire("79WLC");

var $3BXfQ = parcelRequire("3BXfQ");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1915abe93de7f94a$var$Stack(entries) {
    var data = this.__data__ = new (0, $bKxs2.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$1915abe93de7f94a$var$Stack.prototype.clear = (0, $54bhV.default);
$1915abe93de7f94a$var$Stack.prototype["delete"] = (0, $8TShp.default);
$1915abe93de7f94a$var$Stack.prototype.get = (0, $22Xy2.default);
$1915abe93de7f94a$var$Stack.prototype.has = (0, $79WLC.default);
$1915abe93de7f94a$var$Stack.prototype.set = (0, $3BXfQ.default);
var $1915abe93de7f94a$export$2e2bcd8739ae039 = $1915abe93de7f94a$var$Stack;

});
parcelRegister("bKxs2", function(module, exports) {

$parcel$export(module.exports, "default", () => $88ddf04ee0a9db3a$export$2e2bcd8739ae039);

var $cBY1p = parcelRequire("cBY1p");

var $hkApn = parcelRequire("hkApn");

var $fzjrg = parcelRequire("fzjrg");

var $8b3Ad = parcelRequire("8b3Ad");

var $hYsIA = parcelRequire("hYsIA");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $88ddf04ee0a9db3a$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$88ddf04ee0a9db3a$var$ListCache.prototype.clear = (0, $cBY1p.default);
$88ddf04ee0a9db3a$var$ListCache.prototype["delete"] = (0, $hkApn.default);
$88ddf04ee0a9db3a$var$ListCache.prototype.get = (0, $fzjrg.default);
$88ddf04ee0a9db3a$var$ListCache.prototype.has = (0, $8b3Ad.default);
$88ddf04ee0a9db3a$var$ListCache.prototype.set = (0, $hYsIA.default);
var $88ddf04ee0a9db3a$export$2e2bcd8739ae039 = $88ddf04ee0a9db3a$var$ListCache;

});
parcelRegister("cBY1p", function(module, exports) {

$parcel$export(module.exports, "default", () => $92e77fd092ca6d4c$export$2e2bcd8739ae039);
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $92e77fd092ca6d4c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $92e77fd092ca6d4c$export$2e2bcd8739ae039 = $92e77fd092ca6d4c$var$listCacheClear;

});

parcelRegister("hkApn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9e08bd5fb3e5d48$export$2e2bcd8739ae039);

var $5ibcC = parcelRequire("5ibcC");
/** Used for built-in method references. */ var $c9e08bd5fb3e5d48$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $c9e08bd5fb3e5d48$var$splice = $c9e08bd5fb3e5d48$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c9e08bd5fb3e5d48$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $5ibcC.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $c9e08bd5fb3e5d48$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $c9e08bd5fb3e5d48$export$2e2bcd8739ae039 = $c9e08bd5fb3e5d48$var$listCacheDelete;

});
parcelRegister("5ibcC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da752c761c01e17$export$2e2bcd8739ae039);

var $7pwr8 = parcelRequire("7pwr8");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $3da752c761c01e17$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $7pwr8.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $3da752c761c01e17$export$2e2bcd8739ae039 = $3da752c761c01e17$var$assocIndexOf;

});
parcelRegister("7pwr8", function(module, exports) {

$parcel$export(module.exports, "default", () => $56540772ee4efdb4$export$2e2bcd8739ae039);
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $56540772ee4efdb4$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $56540772ee4efdb4$export$2e2bcd8739ae039 = $56540772ee4efdb4$var$eq;

});



parcelRegister("fzjrg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b559340aec939663$export$2e2bcd8739ae039);

var $5ibcC = parcelRequire("5ibcC");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b559340aec939663$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $5ibcC.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $b559340aec939663$export$2e2bcd8739ae039 = $b559340aec939663$var$listCacheGet;

});

parcelRegister("8b3Ad", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f42215892c41178$export$2e2bcd8739ae039);

var $5ibcC = parcelRequire("5ibcC");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5f42215892c41178$var$listCacheHas(key) {
    return (0, $5ibcC.default)(this.__data__, key) > -1;
}
var $5f42215892c41178$export$2e2bcd8739ae039 = $5f42215892c41178$var$listCacheHas;

});

parcelRegister("hYsIA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d15e511bd8969362$export$2e2bcd8739ae039);

var $5ibcC = parcelRequire("5ibcC");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $d15e511bd8969362$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $5ibcC.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $d15e511bd8969362$export$2e2bcd8739ae039 = $d15e511bd8969362$var$listCacheSet;

});


parcelRegister("54bhV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b061514bde24cc2$export$2e2bcd8739ae039);

var $bKxs2 = parcelRequire("bKxs2");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $3b061514bde24cc2$var$stackClear() {
    this.__data__ = new (0, $bKxs2.default);
    this.size = 0;
}
var $3b061514bde24cc2$export$2e2bcd8739ae039 = $3b061514bde24cc2$var$stackClear;

});

parcelRegister("8TShp", function(module, exports) {

$parcel$export(module.exports, "default", () => $67ad909b39561276$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $67ad909b39561276$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $67ad909b39561276$export$2e2bcd8739ae039 = $67ad909b39561276$var$stackDelete;

});

parcelRegister("22Xy2", function(module, exports) {

$parcel$export(module.exports, "default", () => $17d9f5aeb45870ea$export$2e2bcd8739ae039);
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $17d9f5aeb45870ea$var$stackGet(key) {
    return this.__data__.get(key);
}
var $17d9f5aeb45870ea$export$2e2bcd8739ae039 = $17d9f5aeb45870ea$var$stackGet;

});

parcelRegister("79WLC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5366f5922c08e123$export$2e2bcd8739ae039);
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5366f5922c08e123$var$stackHas(key) {
    return this.__data__.has(key);
}
var $5366f5922c08e123$export$2e2bcd8739ae039 = $5366f5922c08e123$var$stackHas;

});

parcelRegister("3BXfQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a12ca83aa150521$export$2e2bcd8739ae039);

var $bKxs2 = parcelRequire("bKxs2");

var $5atPJ = parcelRequire("5atPJ");

var $cPIJw = parcelRequire("cPIJw");
/** Used as the size to enable large array optimizations. */ var $2a12ca83aa150521$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $2a12ca83aa150521$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $bKxs2.default)) {
        var pairs = data.__data__;
        if (!(0, $5atPJ.default) || pairs.length < $2a12ca83aa150521$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $cPIJw.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $2a12ca83aa150521$export$2e2bcd8739ae039 = $2a12ca83aa150521$var$stackSet;

});
parcelRegister("5atPJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c3507300ac7ffd8$export$2e2bcd8739ae039);

var $2h6lm = parcelRequire("2h6lm");

var $fRXcK = parcelRequire("fRXcK");
/* Built-in method references that are verified to be native. */ var $3c3507300ac7ffd8$var$Map = (0, $2h6lm.default)((0, $fRXcK.default), "Map");
var $3c3507300ac7ffd8$export$2e2bcd8739ae039 = $3c3507300ac7ffd8$var$Map;

});
parcelRegister("2h6lm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a8216fe5bdd61cc$export$2e2bcd8739ae039);

var $6HoRA = parcelRequire("6HoRA");

var $gRR8o = parcelRequire("gRR8o");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $1a8216fe5bdd61cc$var$getNative(object, key) {
    var value = (0, $gRR8o.default)(object, key);
    return (0, $6HoRA.default)(value) ? value : undefined;
}
var $1a8216fe5bdd61cc$export$2e2bcd8739ae039 = $1a8216fe5bdd61cc$var$getNative;

});
parcelRegister("6HoRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e0a0b8dae2c5158$export$2e2bcd8739ae039);

var $i2d2G = parcelRequire("i2d2G");

var $gUCSj = parcelRequire("gUCSj");

var $frrTq = parcelRequire("frrTq");

var $8Si7B = parcelRequire("8Si7B");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $4e0a0b8dae2c5158$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $4e0a0b8dae2c5158$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $4e0a0b8dae2c5158$var$funcProto = Function.prototype, $4e0a0b8dae2c5158$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $4e0a0b8dae2c5158$var$funcToString = $4e0a0b8dae2c5158$var$funcProto.toString;
/** Used to check objects for own properties. */ var $4e0a0b8dae2c5158$var$hasOwnProperty = $4e0a0b8dae2c5158$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $4e0a0b8dae2c5158$var$reIsNative = RegExp("^" + $4e0a0b8dae2c5158$var$funcToString.call($4e0a0b8dae2c5158$var$hasOwnProperty).replace($4e0a0b8dae2c5158$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $4e0a0b8dae2c5158$var$baseIsNative(value) {
    if (!(0, $frrTq.default)(value) || (0, $gUCSj.default)(value)) return false;
    var pattern = (0, $i2d2G.default)(value) ? $4e0a0b8dae2c5158$var$reIsNative : $4e0a0b8dae2c5158$var$reIsHostCtor;
    return pattern.test((0, $8Si7B.default)(value));
}
var $4e0a0b8dae2c5158$export$2e2bcd8739ae039 = $4e0a0b8dae2c5158$var$baseIsNative;

});
parcelRegister("i2d2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21287d0c0d10911$export$2e2bcd8739ae039);

var $8X3vt = parcelRequire("8X3vt");

var $frrTq = parcelRequire("frrTq");
/** `Object#toString` result references. */ var $d21287d0c0d10911$var$asyncTag = "[object AsyncFunction]", $d21287d0c0d10911$var$funcTag = "[object Function]", $d21287d0c0d10911$var$genTag = "[object GeneratorFunction]", $d21287d0c0d10911$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $d21287d0c0d10911$var$isFunction(value) {
    if (!(0, $frrTq.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $8X3vt.default)(value);
    return tag == $d21287d0c0d10911$var$funcTag || tag == $d21287d0c0d10911$var$genTag || tag == $d21287d0c0d10911$var$asyncTag || tag == $d21287d0c0d10911$var$proxyTag;
}
var $d21287d0c0d10911$export$2e2bcd8739ae039 = $d21287d0c0d10911$var$isFunction;

});
parcelRegister("frrTq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3df039c0fe6a2f0$export$2e2bcd8739ae039);
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $b3df039c0fe6a2f0$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $b3df039c0fe6a2f0$export$2e2bcd8739ae039 = $b3df039c0fe6a2f0$var$isObject;

});


parcelRegister("gUCSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5000813d021dbca$export$2e2bcd8739ae039);

var $4qK3P = parcelRequire("4qK3P");
/** Used to detect methods masquerading as native. */ var $c5000813d021dbca$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $4qK3P.default) && (0, $4qK3P.default).keys && (0, $4qK3P.default).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $c5000813d021dbca$var$isMasked(func) {
    return !!$c5000813d021dbca$var$maskSrcKey && $c5000813d021dbca$var$maskSrcKey in func;
}
var $c5000813d021dbca$export$2e2bcd8739ae039 = $c5000813d021dbca$var$isMasked;

});
parcelRegister("4qK3P", function(module, exports) {

$parcel$export(module.exports, "default", () => $339d51d2beb33f96$export$2e2bcd8739ae039);

var $fRXcK = parcelRequire("fRXcK");
/** Used to detect overreaching core-js shims. */ var $339d51d2beb33f96$var$coreJsData = (0, $fRXcK.default)["__core-js_shared__"];
var $339d51d2beb33f96$export$2e2bcd8739ae039 = $339d51d2beb33f96$var$coreJsData;

});


parcelRegister("8Si7B", function(module, exports) {

$parcel$export(module.exports, "default", () => $67616c73ae0ab3b8$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $67616c73ae0ab3b8$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $67616c73ae0ab3b8$var$funcToString = $67616c73ae0ab3b8$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $67616c73ae0ab3b8$var$toSource(func) {
    if (func != null) {
        try {
            return $67616c73ae0ab3b8$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $67616c73ae0ab3b8$export$2e2bcd8739ae039 = $67616c73ae0ab3b8$var$toSource;

});


parcelRegister("gRR8o", function(module, exports) {

$parcel$export(module.exports, "default", () => $c47acff25e8ff3d7$export$2e2bcd8739ae039);
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $c47acff25e8ff3d7$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $c47acff25e8ff3d7$export$2e2bcd8739ae039 = $c47acff25e8ff3d7$var$getValue;

});



parcelRegister("cPIJw", function(module, exports) {

$parcel$export(module.exports, "default", () => $957cf28a58e20ec6$export$2e2bcd8739ae039);

var $XI5RO = parcelRequire("XI5RO");

var $hGGf4 = parcelRequire("hGGf4");

var $eUEZc = parcelRequire("eUEZc");

var $dGkb8 = parcelRequire("dGkb8");

var $hnStB = parcelRequire("hnStB");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $957cf28a58e20ec6$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$957cf28a58e20ec6$var$MapCache.prototype.clear = (0, $XI5RO.default);
$957cf28a58e20ec6$var$MapCache.prototype["delete"] = (0, $hGGf4.default);
$957cf28a58e20ec6$var$MapCache.prototype.get = (0, $eUEZc.default);
$957cf28a58e20ec6$var$MapCache.prototype.has = (0, $dGkb8.default);
$957cf28a58e20ec6$var$MapCache.prototype.set = (0, $hnStB.default);
var $957cf28a58e20ec6$export$2e2bcd8739ae039 = $957cf28a58e20ec6$var$MapCache;

});
parcelRegister("XI5RO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b37b6e11865570f$export$2e2bcd8739ae039);

var $ctpRT = parcelRequire("ctpRT");

var $bKxs2 = parcelRequire("bKxs2");

var $5atPJ = parcelRequire("5atPJ");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $0b37b6e11865570f$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $ctpRT.default),
        "map": new ((0, $5atPJ.default) || (0, $bKxs2.default)),
        "string": new (0, $ctpRT.default)
    };
}
var $0b37b6e11865570f$export$2e2bcd8739ae039 = $0b37b6e11865570f$var$mapCacheClear;

});
parcelRegister("ctpRT", function(module, exports) {

$parcel$export(module.exports, "default", () => $914c4256658f912b$export$2e2bcd8739ae039);

var $38Emf = parcelRequire("38Emf");

var $2oals = parcelRequire("2oals");

var $hrree = parcelRequire("hrree");

var $5EeJZ = parcelRequire("5EeJZ");

var $1J3oB = parcelRequire("1J3oB");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $914c4256658f912b$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$914c4256658f912b$var$Hash.prototype.clear = (0, $38Emf.default);
$914c4256658f912b$var$Hash.prototype["delete"] = (0, $2oals.default);
$914c4256658f912b$var$Hash.prototype.get = (0, $hrree.default);
$914c4256658f912b$var$Hash.prototype.has = (0, $5EeJZ.default);
$914c4256658f912b$var$Hash.prototype.set = (0, $1J3oB.default);
var $914c4256658f912b$export$2e2bcd8739ae039 = $914c4256658f912b$var$Hash;

});
parcelRegister("38Emf", function(module, exports) {

$parcel$export(module.exports, "default", () => $24916cb0a1f5cb14$export$2e2bcd8739ae039);

var $dVQXg = parcelRequire("dVQXg");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $24916cb0a1f5cb14$var$hashClear() {
    this.__data__ = (0, $dVQXg.default) ? (0, $dVQXg.default)(null) : {};
    this.size = 0;
}
var $24916cb0a1f5cb14$export$2e2bcd8739ae039 = $24916cb0a1f5cb14$var$hashClear;

});
parcelRegister("dVQXg", function(module, exports) {

$parcel$export(module.exports, "default", () => $a249acf5c6bc3639$export$2e2bcd8739ae039);

var $2h6lm = parcelRequire("2h6lm");
/* Built-in method references that are verified to be native. */ var $a249acf5c6bc3639$var$nativeCreate = (0, $2h6lm.default)(Object, "create");
var $a249acf5c6bc3639$export$2e2bcd8739ae039 = $a249acf5c6bc3639$var$nativeCreate;

});


parcelRegister("2oals", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bd5d8fbefb6aa42$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $1bd5d8fbefb6aa42$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $1bd5d8fbefb6aa42$export$2e2bcd8739ae039 = $1bd5d8fbefb6aa42$var$hashDelete;

});

parcelRegister("hrree", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2a144d0aa9deec$export$2e2bcd8739ae039);

var $dVQXg = parcelRequire("dVQXg");
/** Used to stand-in for `undefined` hash values. */ var $cb2a144d0aa9deec$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $cb2a144d0aa9deec$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cb2a144d0aa9deec$var$hasOwnProperty = $cb2a144d0aa9deec$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $cb2a144d0aa9deec$var$hashGet(key) {
    var data = this.__data__;
    if (0, $dVQXg.default) {
        var result = data[key];
        return result === $cb2a144d0aa9deec$var$HASH_UNDEFINED ? undefined : result;
    }
    return $cb2a144d0aa9deec$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $cb2a144d0aa9deec$export$2e2bcd8739ae039 = $cb2a144d0aa9deec$var$hashGet;

});

parcelRegister("5EeJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $41cc1f5e5801ce38$export$2e2bcd8739ae039);

var $dVQXg = parcelRequire("dVQXg");
/** Used for built-in method references. */ var $41cc1f5e5801ce38$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $41cc1f5e5801ce38$var$hasOwnProperty = $41cc1f5e5801ce38$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $41cc1f5e5801ce38$var$hashHas(key) {
    var data = this.__data__;
    return (0, $dVQXg.default) ? data[key] !== undefined : $41cc1f5e5801ce38$var$hasOwnProperty.call(data, key);
}
var $41cc1f5e5801ce38$export$2e2bcd8739ae039 = $41cc1f5e5801ce38$var$hashHas;

});

parcelRegister("1J3oB", function(module, exports) {

$parcel$export(module.exports, "default", () => $141ca0bf5928a85a$export$2e2bcd8739ae039);

var $dVQXg = parcelRequire("dVQXg");
/** Used to stand-in for `undefined` hash values. */ var $141ca0bf5928a85a$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $141ca0bf5928a85a$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $dVQXg.default) && value === undefined ? $141ca0bf5928a85a$var$HASH_UNDEFINED : value;
    return this;
}
var $141ca0bf5928a85a$export$2e2bcd8739ae039 = $141ca0bf5928a85a$var$hashSet;

});



parcelRegister("hGGf4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce07204ae5cd6e47$export$2e2bcd8739ae039);

var $CBtAG = parcelRequire("CBtAG");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ce07204ae5cd6e47$var$mapCacheDelete(key) {
    var result = (0, $CBtAG.default)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $ce07204ae5cd6e47$export$2e2bcd8739ae039 = $ce07204ae5cd6e47$var$mapCacheDelete;

});
parcelRegister("CBtAG", function(module, exports) {

$parcel$export(module.exports, "default", () => $07409ebb26c77be4$export$2e2bcd8739ae039);

var $cpTBK = parcelRequire("cpTBK");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $07409ebb26c77be4$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $cpTBK.default)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $07409ebb26c77be4$export$2e2bcd8739ae039 = $07409ebb26c77be4$var$getMapData;

});
parcelRegister("cpTBK", function(module, exports) {

$parcel$export(module.exports, "default", () => $90a2f4695e9c08f6$export$2e2bcd8739ae039);
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $90a2f4695e9c08f6$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $90a2f4695e9c08f6$export$2e2bcd8739ae039 = $90a2f4695e9c08f6$var$isKeyable;

});



parcelRegister("eUEZc", function(module, exports) {

$parcel$export(module.exports, "default", () => $adb616a8824a08aa$export$2e2bcd8739ae039);

var $CBtAG = parcelRequire("CBtAG");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $adb616a8824a08aa$var$mapCacheGet(key) {
    return (0, $CBtAG.default)(this, key).get(key);
}
var $adb616a8824a08aa$export$2e2bcd8739ae039 = $adb616a8824a08aa$var$mapCacheGet;

});

parcelRegister("dGkb8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f5ed9abb3555b68$export$2e2bcd8739ae039);

var $CBtAG = parcelRequire("CBtAG");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9f5ed9abb3555b68$var$mapCacheHas(key) {
    return (0, $CBtAG.default)(this, key).has(key);
}
var $9f5ed9abb3555b68$export$2e2bcd8739ae039 = $9f5ed9abb3555b68$var$mapCacheHas;

});

parcelRegister("hnStB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca7ed787c492dedd$export$2e2bcd8739ae039);

var $CBtAG = parcelRequire("CBtAG");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $ca7ed787c492dedd$var$mapCacheSet(key, value) {
    var data = (0, $CBtAG.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $ca7ed787c492dedd$export$2e2bcd8739ae039 = $ca7ed787c492dedd$var$mapCacheSet;

});




parcelRegister("6tC51", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b72fd670e0457f1$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $4b72fd670e0457f1$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $4b72fd670e0457f1$export$2e2bcd8739ae039 = $4b72fd670e0457f1$var$arrayEach;

});

parcelRegister("5YV7T", function(module, exports) {

$parcel$export(module.exports, "default", () => $45aede6cc1401fb2$export$2e2bcd8739ae039);

var $enhc0 = parcelRequire("enhc0");

var $7pwr8 = parcelRequire("7pwr8");
/** Used for built-in method references. */ var $45aede6cc1401fb2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $45aede6cc1401fb2$var$hasOwnProperty = $45aede6cc1401fb2$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $45aede6cc1401fb2$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($45aede6cc1401fb2$var$hasOwnProperty.call(object, key) && (0, $7pwr8.default)(objValue, value)) || value === undefined && !(key in object)) (0, $enhc0.default)(object, key, value);
}
var $45aede6cc1401fb2$export$2e2bcd8739ae039 = $45aede6cc1401fb2$var$assignValue;

});
parcelRegister("enhc0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7708cc41bff3746$export$2e2bcd8739ae039);

var $dolVq = parcelRequire("dolVq");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a7708cc41bff3746$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $dolVq.default)) (0, $dolVq.default)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $a7708cc41bff3746$export$2e2bcd8739ae039 = $a7708cc41bff3746$var$baseAssignValue;

});
parcelRegister("dolVq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bfe8620f76c21fc$export$2e2bcd8739ae039);

var $2h6lm = parcelRequire("2h6lm");
var $9bfe8620f76c21fc$var$defineProperty = function() {
    try {
        var func = (0, $2h6lm.default)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $9bfe8620f76c21fc$export$2e2bcd8739ae039 = $9bfe8620f76c21fc$var$defineProperty;

});



parcelRegister("f9u12", function(module, exports) {

$parcel$export(module.exports, "default", () => $b07efac6142b839d$export$2e2bcd8739ae039);

var $9SYAA = parcelRequire("9SYAA");

var $2jh9k = parcelRequire("2jh9k");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $b07efac6142b839d$var$baseAssign(object, source) {
    return object && (0, $9SYAA.default)(source, (0, $2jh9k.default)(source), object);
}
var $b07efac6142b839d$export$2e2bcd8739ae039 = $b07efac6142b839d$var$baseAssign;

});
parcelRegister("9SYAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $732827ed53a9fd5e$export$2e2bcd8739ae039);

var $5YV7T = parcelRequire("5YV7T");

var $enhc0 = parcelRequire("enhc0");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $732827ed53a9fd5e$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $enhc0.default)(object, key, newValue);
        else (0, $5YV7T.default)(object, key, newValue);
    }
    return object;
}
var $732827ed53a9fd5e$export$2e2bcd8739ae039 = $732827ed53a9fd5e$var$copyObject;

});

parcelRegister("2jh9k", function(module, exports) {

$parcel$export(module.exports, "default", () => $1aeaa8a4b0d3a6c5$export$2e2bcd8739ae039);

var $2Ey4s = parcelRequire("2Ey4s");

var $5OieK = parcelRequire("5OieK");

var $10Tbb = parcelRequire("10Tbb");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $1aeaa8a4b0d3a6c5$var$keys(object) {
    return (0, $10Tbb.default)(object) ? (0, $2Ey4s.default)(object) : (0, $5OieK.default)(object);
}
var $1aeaa8a4b0d3a6c5$export$2e2bcd8739ae039 = $1aeaa8a4b0d3a6c5$var$keys;

});
parcelRegister("2Ey4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ee9befbb41fe2a6$export$2e2bcd8739ae039);

var $b1EaJ = parcelRequire("b1EaJ");

var $80EAH = parcelRequire("80EAH");

var $5yaQN = parcelRequire("5yaQN");

var $dsiS5 = parcelRequire("dsiS5");

var $jeldA = parcelRequire("jeldA");

var $j9cN5 = parcelRequire("j9cN5");
/** Used for built-in method references. */ var $1ee9befbb41fe2a6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1ee9befbb41fe2a6$var$hasOwnProperty = $1ee9befbb41fe2a6$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $1ee9befbb41fe2a6$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $5yaQN.default)(value), isArg = !isArr && (0, $80EAH.default)(value), isBuff = !isArr && !isArg && (0, $dsiS5.default)(value), isType = !isArr && !isArg && !isBuff && (0, $j9cN5.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $b1EaJ.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $1ee9befbb41fe2a6$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $jeldA.default)(key, length)))) result.push(key);
    return result;
}
var $1ee9befbb41fe2a6$export$2e2bcd8739ae039 = $1ee9befbb41fe2a6$var$arrayLikeKeys;

});
parcelRegister("b1EaJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $806ef30d5f86a86d$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $806ef30d5f86a86d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $806ef30d5f86a86d$export$2e2bcd8739ae039 = $806ef30d5f86a86d$var$baseTimes;

});

parcelRegister("80EAH", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d4dcf59a89cd3a5$export$2e2bcd8739ae039);

var $9uUli = parcelRequire("9uUli");

var $da1Ti = parcelRequire("da1Ti");
/** Used for built-in method references. */ var $5d4dcf59a89cd3a5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5d4dcf59a89cd3a5$var$hasOwnProperty = $5d4dcf59a89cd3a5$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $5d4dcf59a89cd3a5$var$propertyIsEnumerable = $5d4dcf59a89cd3a5$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $5d4dcf59a89cd3a5$var$isArguments = (0, $9uUli.default)(function() {
    return arguments;
}()) ? (0, $9uUli.default) : function(value) {
    return (0, $da1Ti.default)(value) && $5d4dcf59a89cd3a5$var$hasOwnProperty.call(value, "callee") && !$5d4dcf59a89cd3a5$var$propertyIsEnumerable.call(value, "callee");
};
var $5d4dcf59a89cd3a5$export$2e2bcd8739ae039 = $5d4dcf59a89cd3a5$var$isArguments;

});
parcelRegister("9uUli", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ea29edca0a9135c$export$2e2bcd8739ae039);

var $8X3vt = parcelRequire("8X3vt");

var $da1Ti = parcelRequire("da1Ti");
/** `Object#toString` result references. */ var $6ea29edca0a9135c$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $6ea29edca0a9135c$var$baseIsArguments(value) {
    return (0, $da1Ti.default)(value) && (0, $8X3vt.default)(value) == $6ea29edca0a9135c$var$argsTag;
}
var $6ea29edca0a9135c$export$2e2bcd8739ae039 = $6ea29edca0a9135c$var$baseIsArguments;

});


parcelRegister("5yaQN", function(module, exports) {

$parcel$export(module.exports, "default", () => $40a88b6b7b19c283$export$2e2bcd8739ae039);
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $40a88b6b7b19c283$var$isArray = Array.isArray;
var $40a88b6b7b19c283$export$2e2bcd8739ae039 = $40a88b6b7b19c283$var$isArray;

});

parcelRegister("dsiS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cbc87528db2a3ee$export$2e2bcd8739ae039);

var $fRXcK = parcelRequire("fRXcK");

var $4f1Ll = parcelRequire("4f1Ll");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $fRXcK.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $4f1Ll.default);
var $9cbc87528db2a3ee$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("4f1Ll", function(module, exports) {

$parcel$export(module.exports, "default", () => $3169ee2e9259e190$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $3169ee2e9259e190$var$stubFalse() {
    return false;
}
var $3169ee2e9259e190$export$2e2bcd8739ae039 = $3169ee2e9259e190$var$stubFalse;

});


parcelRegister("jeldA", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfffc89eb4ba3bf4$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $dfffc89eb4ba3bf4$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $dfffc89eb4ba3bf4$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $dfffc89eb4ba3bf4$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $dfffc89eb4ba3bf4$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $dfffc89eb4ba3bf4$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $dfffc89eb4ba3bf4$export$2e2bcd8739ae039 = $dfffc89eb4ba3bf4$var$isIndex;

});

parcelRegister("j9cN5", function(module, exports) {

$parcel$export(module.exports, "default", () => $df08c787f8f9f81d$export$2e2bcd8739ae039);

var $38v8p = parcelRequire("38v8p");

var $a1upq = parcelRequire("a1upq");

var $1wE0y = parcelRequire("1wE0y");
/* Node.js helper references. */ var $df08c787f8f9f81d$var$nodeIsTypedArray = (0, $1wE0y.default) && (0, $1wE0y.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $df08c787f8f9f81d$var$isTypedArray = $df08c787f8f9f81d$var$nodeIsTypedArray ? (0, $a1upq.default)($df08c787f8f9f81d$var$nodeIsTypedArray) : (0, $38v8p.default);
var $df08c787f8f9f81d$export$2e2bcd8739ae039 = $df08c787f8f9f81d$var$isTypedArray;

});
parcelRegister("38v8p", function(module, exports) {

$parcel$export(module.exports, "default", () => $248a4521821d915d$export$2e2bcd8739ae039);

var $8X3vt = parcelRequire("8X3vt");

var $3ntEU = parcelRequire("3ntEU");

var $da1Ti = parcelRequire("da1Ti");
/** `Object#toString` result references. */ var $248a4521821d915d$var$argsTag = "[object Arguments]", $248a4521821d915d$var$arrayTag = "[object Array]", $248a4521821d915d$var$boolTag = "[object Boolean]", $248a4521821d915d$var$dateTag = "[object Date]", $248a4521821d915d$var$errorTag = "[object Error]", $248a4521821d915d$var$funcTag = "[object Function]", $248a4521821d915d$var$mapTag = "[object Map]", $248a4521821d915d$var$numberTag = "[object Number]", $248a4521821d915d$var$objectTag = "[object Object]", $248a4521821d915d$var$regexpTag = "[object RegExp]", $248a4521821d915d$var$setTag = "[object Set]", $248a4521821d915d$var$stringTag = "[object String]", $248a4521821d915d$var$weakMapTag = "[object WeakMap]";
var $248a4521821d915d$var$arrayBufferTag = "[object ArrayBuffer]", $248a4521821d915d$var$dataViewTag = "[object DataView]", $248a4521821d915d$var$float32Tag = "[object Float32Array]", $248a4521821d915d$var$float64Tag = "[object Float64Array]", $248a4521821d915d$var$int8Tag = "[object Int8Array]", $248a4521821d915d$var$int16Tag = "[object Int16Array]", $248a4521821d915d$var$int32Tag = "[object Int32Array]", $248a4521821d915d$var$uint8Tag = "[object Uint8Array]", $248a4521821d915d$var$uint8ClampedTag = "[object Uint8ClampedArray]", $248a4521821d915d$var$uint16Tag = "[object Uint16Array]", $248a4521821d915d$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $248a4521821d915d$var$typedArrayTags = {};
$248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$float32Tag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$float64Tag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$int8Tag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$int16Tag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$int32Tag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$uint8Tag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$uint8ClampedTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$uint16Tag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$uint32Tag] = true;
$248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$argsTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$arrayTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$arrayBufferTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$boolTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$dataViewTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$dateTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$errorTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$funcTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$mapTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$numberTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$objectTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$regexpTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$setTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$stringTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $248a4521821d915d$var$baseIsTypedArray(value) {
    return (0, $da1Ti.default)(value) && (0, $3ntEU.default)(value.length) && !!$248a4521821d915d$var$typedArrayTags[(0, $8X3vt.default)(value)];
}
var $248a4521821d915d$export$2e2bcd8739ae039 = $248a4521821d915d$var$baseIsTypedArray;

});
parcelRegister("3ntEU", function(module, exports) {

$parcel$export(module.exports, "default", () => $275a86b612593d31$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $275a86b612593d31$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $275a86b612593d31$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $275a86b612593d31$var$MAX_SAFE_INTEGER;
}
var $275a86b612593d31$export$2e2bcd8739ae039 = $275a86b612593d31$var$isLength;

});


parcelRegister("a1upq", function(module, exports) {

$parcel$export(module.exports, "default", () => $74c19602feaa3066$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $74c19602feaa3066$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $74c19602feaa3066$export$2e2bcd8739ae039 = $74c19602feaa3066$var$baseUnary;

});

parcelRegister("1wE0y", function(module, exports) {

$parcel$export(module.exports, "default", () => $11c7d05c3117e39d$export$2e2bcd8739ae039);

var $1kslA = parcelRequire("1kslA");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $1kslA.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $11c7d05c3117e39d$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("5OieK", function(module, exports) {

$parcel$export(module.exports, "default", () => $43afc4bb8d89a7bd$export$2e2bcd8739ae039);

var $dU0PL = parcelRequire("dU0PL");

var $aPlCK = parcelRequire("aPlCK");
/** Used for built-in method references. */ var $43afc4bb8d89a7bd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $43afc4bb8d89a7bd$var$hasOwnProperty = $43afc4bb8d89a7bd$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $43afc4bb8d89a7bd$var$baseKeys(object) {
    if (!(0, $dU0PL.default)(object)) return (0, $aPlCK.default)(object);
    var result = [];
    for(var key in Object(object))if ($43afc4bb8d89a7bd$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $43afc4bb8d89a7bd$export$2e2bcd8739ae039 = $43afc4bb8d89a7bd$var$baseKeys;

});
parcelRegister("dU0PL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1f126e8eddaa8ab$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $a1f126e8eddaa8ab$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $a1f126e8eddaa8ab$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $a1f126e8eddaa8ab$var$objectProto;
    return value === proto;
}
var $a1f126e8eddaa8ab$export$2e2bcd8739ae039 = $a1f126e8eddaa8ab$var$isPrototype;

});

parcelRegister("aPlCK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1f70e42ac81693$export$2e2bcd8739ae039);

var $kX7Ds = parcelRequire("kX7Ds");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7e1f70e42ac81693$var$nativeKeys = (0, $kX7Ds.default)(Object.keys, Object);
var $7e1f70e42ac81693$export$2e2bcd8739ae039 = $7e1f70e42ac81693$var$nativeKeys;

});


parcelRegister("10Tbb", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bd097fe0adacb0c$export$2e2bcd8739ae039);

var $i2d2G = parcelRequire("i2d2G");

var $3ntEU = parcelRequire("3ntEU");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $0bd097fe0adacb0c$var$isArrayLike(value) {
    return value != null && (0, $3ntEU.default)(value.length) && !(0, $i2d2G.default)(value);
}
var $0bd097fe0adacb0c$export$2e2bcd8739ae039 = $0bd097fe0adacb0c$var$isArrayLike;

});



parcelRegister("5h2DV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d709718d4f710f2$export$2e2bcd8739ae039);

var $9SYAA = parcelRequire("9SYAA");

var $2W5yf = parcelRequire("2W5yf");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $3d709718d4f710f2$var$baseAssignIn(object, source) {
    return object && (0, $9SYAA.default)(source, (0, $2W5yf.default)(source), object);
}
var $3d709718d4f710f2$export$2e2bcd8739ae039 = $3d709718d4f710f2$var$baseAssignIn;

});
parcelRegister("2W5yf", function(module, exports) {

$parcel$export(module.exports, "default", () => $22354deb72ac72e5$export$2e2bcd8739ae039);

var $2Ey4s = parcelRequire("2Ey4s");

var $6A5i5 = parcelRequire("6A5i5");

var $10Tbb = parcelRequire("10Tbb");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $22354deb72ac72e5$var$keysIn(object) {
    return (0, $10Tbb.default)(object) ? (0, $2Ey4s.default)(object, true) : (0, $6A5i5.default)(object);
}
var $22354deb72ac72e5$export$2e2bcd8739ae039 = $22354deb72ac72e5$var$keysIn;

});
parcelRegister("6A5i5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4caa3583e2a58f16$export$2e2bcd8739ae039);

var $frrTq = parcelRequire("frrTq");

var $dU0PL = parcelRequire("dU0PL");

var $bK1FG = parcelRequire("bK1FG");
/** Used for built-in method references. */ var $4caa3583e2a58f16$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4caa3583e2a58f16$var$hasOwnProperty = $4caa3583e2a58f16$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $4caa3583e2a58f16$var$baseKeysIn(object) {
    if (!(0, $frrTq.default)(object)) return (0, $bK1FG.default)(object);
    var isProto = (0, $dU0PL.default)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$4caa3583e2a58f16$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $4caa3583e2a58f16$export$2e2bcd8739ae039 = $4caa3583e2a58f16$var$baseKeysIn;

});
parcelRegister("bK1FG", function(module, exports) {

$parcel$export(module.exports, "default", () => $88c5497c4daf1d09$export$2e2bcd8739ae039);
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $88c5497c4daf1d09$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $88c5497c4daf1d09$export$2e2bcd8739ae039 = $88c5497c4daf1d09$var$nativeKeysIn;

});




parcelRegister("c4zsg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ca15c60c7d72159$export$2e2bcd8739ae039);

var $fRXcK = parcelRequire("fRXcK");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $fRXcK.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $8ca15c60c7d72159$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("h3wcn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6abb176712716ec$export$2e2bcd8739ae039);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $c6abb176712716ec$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $c6abb176712716ec$export$2e2bcd8739ae039 = $c6abb176712716ec$var$copyArray;

});

parcelRegister("fbIah", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ea24505f79aadc$export$2e2bcd8739ae039);

var $9SYAA = parcelRequire("9SYAA");

var $kALHS = parcelRequire("kALHS");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $b0ea24505f79aadc$var$copySymbols(source, object) {
    return (0, $9SYAA.default)(source, (0, $kALHS.default)(source), object);
}
var $b0ea24505f79aadc$export$2e2bcd8739ae039 = $b0ea24505f79aadc$var$copySymbols;

});
parcelRegister("kALHS", function(module, exports) {

$parcel$export(module.exports, "default", () => $efdc2cfa145e1b28$export$2e2bcd8739ae039);

var $ayFD8 = parcelRequire("ayFD8");

var $9RGsf = parcelRequire("9RGsf");
/** Used for built-in method references. */ var $efdc2cfa145e1b28$var$objectProto = Object.prototype;
/** Built-in value references. */ var $efdc2cfa145e1b28$var$propertyIsEnumerable = $efdc2cfa145e1b28$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $efdc2cfa145e1b28$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $efdc2cfa145e1b28$var$getSymbols = !$efdc2cfa145e1b28$var$nativeGetSymbols ? (0, $9RGsf.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $ayFD8.default)($efdc2cfa145e1b28$var$nativeGetSymbols(object), function(symbol) {
        return $efdc2cfa145e1b28$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $efdc2cfa145e1b28$export$2e2bcd8739ae039 = $efdc2cfa145e1b28$var$getSymbols;

});
parcelRegister("ayFD8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7afd5f3f4d5b8e56$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $7afd5f3f4d5b8e56$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $7afd5f3f4d5b8e56$export$2e2bcd8739ae039 = $7afd5f3f4d5b8e56$var$arrayFilter;

});

parcelRegister("9RGsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $72e9fee4b7156309$export$2e2bcd8739ae039);
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $72e9fee4b7156309$var$stubArray() {
    return [];
}
var $72e9fee4b7156309$export$2e2bcd8739ae039 = $72e9fee4b7156309$var$stubArray;

});



parcelRegister("170nJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cf6bdb3007a3257$export$2e2bcd8739ae039);

var $9SYAA = parcelRequire("9SYAA");

var $c3zSs = parcelRequire("c3zSs");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $0cf6bdb3007a3257$var$copySymbolsIn(source, object) {
    return (0, $9SYAA.default)(source, (0, $c3zSs.default)(source), object);
}
var $0cf6bdb3007a3257$export$2e2bcd8739ae039 = $0cf6bdb3007a3257$var$copySymbolsIn;

});
parcelRegister("c3zSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c7198582d5f5065$export$2e2bcd8739ae039);

var $3NJ3g = parcelRequire("3NJ3g");

var $dkTWv = parcelRequire("dkTWv");

var $kALHS = parcelRequire("kALHS");

var $9RGsf = parcelRequire("9RGsf");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8c7198582d5f5065$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $8c7198582d5f5065$var$getSymbolsIn = !$8c7198582d5f5065$var$nativeGetSymbols ? (0, $9RGsf.default) : function(object) {
    var result = [];
    while(object){
        (0, $3NJ3g.default)(result, (0, $kALHS.default)(object));
        object = (0, $dkTWv.default)(object);
    }
    return result;
};
var $8c7198582d5f5065$export$2e2bcd8739ae039 = $8c7198582d5f5065$var$getSymbolsIn;

});
parcelRegister("3NJ3g", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c48e50495c683b7$export$2e2bcd8739ae039);
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $2c48e50495c683b7$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $2c48e50495c683b7$export$2e2bcd8739ae039 = $2c48e50495c683b7$var$arrayPush;

});



parcelRegister("3tk8b", function(module, exports) {

$parcel$export(module.exports, "default", () => $2873b21a5e0737cb$export$2e2bcd8739ae039);

var $2QHMP = parcelRequire("2QHMP");

var $kALHS = parcelRequire("kALHS");

var $2jh9k = parcelRequire("2jh9k");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $2873b21a5e0737cb$var$getAllKeys(object) {
    return (0, $2QHMP.default)(object, (0, $2jh9k.default), (0, $kALHS.default));
}
var $2873b21a5e0737cb$export$2e2bcd8739ae039 = $2873b21a5e0737cb$var$getAllKeys;

});
parcelRegister("2QHMP", function(module, exports) {

$parcel$export(module.exports, "default", () => $2132672da0b0c39a$export$2e2bcd8739ae039);

var $3NJ3g = parcelRequire("3NJ3g");

var $5yaQN = parcelRequire("5yaQN");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $2132672da0b0c39a$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $5yaQN.default)(object) ? result : (0, $3NJ3g.default)(result, symbolsFunc(object));
}
var $2132672da0b0c39a$export$2e2bcd8739ae039 = $2132672da0b0c39a$var$baseGetAllKeys;

});


parcelRegister("8b64V", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f4410d750b52ee3$export$2e2bcd8739ae039);

var $2QHMP = parcelRequire("2QHMP");

var $c3zSs = parcelRequire("c3zSs");

var $2W5yf = parcelRequire("2W5yf");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $5f4410d750b52ee3$var$getAllKeysIn(object) {
    return (0, $2QHMP.default)(object, (0, $2W5yf.default), (0, $c3zSs.default));
}
var $5f4410d750b52ee3$export$2e2bcd8739ae039 = $5f4410d750b52ee3$var$getAllKeysIn;

});

parcelRegister("gbHlz", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc8f4c39200cff94$export$2e2bcd8739ae039);

var $78fz0 = parcelRequire("78fz0");

var $5atPJ = parcelRequire("5atPJ");

var $dB6DU = parcelRequire("dB6DU");

var $cHnJV = parcelRequire("cHnJV");

var $4aHBz = parcelRequire("4aHBz");

var $8X3vt = parcelRequire("8X3vt");

var $8Si7B = parcelRequire("8Si7B");
/** `Object#toString` result references. */ var $bc8f4c39200cff94$var$mapTag = "[object Map]", $bc8f4c39200cff94$var$objectTag = "[object Object]", $bc8f4c39200cff94$var$promiseTag = "[object Promise]", $bc8f4c39200cff94$var$setTag = "[object Set]", $bc8f4c39200cff94$var$weakMapTag = "[object WeakMap]";
var $bc8f4c39200cff94$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $bc8f4c39200cff94$var$dataViewCtorString = (0, $8Si7B.default)((0, $78fz0.default)), $bc8f4c39200cff94$var$mapCtorString = (0, $8Si7B.default)((0, $5atPJ.default)), $bc8f4c39200cff94$var$promiseCtorString = (0, $8Si7B.default)((0, $dB6DU.default)), $bc8f4c39200cff94$var$setCtorString = (0, $8Si7B.default)((0, $cHnJV.default)), $bc8f4c39200cff94$var$weakMapCtorString = (0, $8Si7B.default)((0, $4aHBz.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $bc8f4c39200cff94$var$getTag = (0, $8X3vt.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $78fz0.default) && $bc8f4c39200cff94$var$getTag(new (0, $78fz0.default)(new ArrayBuffer(1))) != $bc8f4c39200cff94$var$dataViewTag || (0, $5atPJ.default) && $bc8f4c39200cff94$var$getTag(new (0, $5atPJ.default)) != $bc8f4c39200cff94$var$mapTag || (0, $dB6DU.default) && $bc8f4c39200cff94$var$getTag((0, $dB6DU.default).resolve()) != $bc8f4c39200cff94$var$promiseTag || (0, $cHnJV.default) && $bc8f4c39200cff94$var$getTag(new (0, $cHnJV.default)) != $bc8f4c39200cff94$var$setTag || (0, $4aHBz.default) && $bc8f4c39200cff94$var$getTag(new (0, $4aHBz.default)) != $bc8f4c39200cff94$var$weakMapTag) $bc8f4c39200cff94$var$getTag = function(value) {
    var result = (0, $8X3vt.default)(value), Ctor = result == $bc8f4c39200cff94$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $8Si7B.default)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $bc8f4c39200cff94$var$dataViewCtorString:
            return $bc8f4c39200cff94$var$dataViewTag;
        case $bc8f4c39200cff94$var$mapCtorString:
            return $bc8f4c39200cff94$var$mapTag;
        case $bc8f4c39200cff94$var$promiseCtorString:
            return $bc8f4c39200cff94$var$promiseTag;
        case $bc8f4c39200cff94$var$setCtorString:
            return $bc8f4c39200cff94$var$setTag;
        case $bc8f4c39200cff94$var$weakMapCtorString:
            return $bc8f4c39200cff94$var$weakMapTag;
    }
    return result;
};
var $bc8f4c39200cff94$export$2e2bcd8739ae039 = $bc8f4c39200cff94$var$getTag;

});
parcelRegister("78fz0", function(module, exports) {

$parcel$export(module.exports, "default", () => $53155a5b51f6f1ea$export$2e2bcd8739ae039);

var $2h6lm = parcelRequire("2h6lm");

var $fRXcK = parcelRequire("fRXcK");
/* Built-in method references that are verified to be native. */ var $53155a5b51f6f1ea$var$DataView = (0, $2h6lm.default)((0, $fRXcK.default), "DataView");
var $53155a5b51f6f1ea$export$2e2bcd8739ae039 = $53155a5b51f6f1ea$var$DataView;

});

parcelRegister("dB6DU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e63e23025cefe66$export$2e2bcd8739ae039);

var $2h6lm = parcelRequire("2h6lm");

var $fRXcK = parcelRequire("fRXcK");
/* Built-in method references that are verified to be native. */ var $9e63e23025cefe66$var$Promise = (0, $2h6lm.default)((0, $fRXcK.default), "Promise");
var $9e63e23025cefe66$export$2e2bcd8739ae039 = $9e63e23025cefe66$var$Promise;

});

parcelRegister("cHnJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $93ebea6538da6b4a$export$2e2bcd8739ae039);

var $2h6lm = parcelRequire("2h6lm");

var $fRXcK = parcelRequire("fRXcK");
/* Built-in method references that are verified to be native. */ var $93ebea6538da6b4a$var$Set = (0, $2h6lm.default)((0, $fRXcK.default), "Set");
var $93ebea6538da6b4a$export$2e2bcd8739ae039 = $93ebea6538da6b4a$var$Set;

});

parcelRegister("4aHBz", function(module, exports) {

$parcel$export(module.exports, "default", () => $3099eb9c8a2dad9e$export$2e2bcd8739ae039);

var $2h6lm = parcelRequire("2h6lm");

var $fRXcK = parcelRequire("fRXcK");
/* Built-in method references that are verified to be native. */ var $3099eb9c8a2dad9e$var$WeakMap = (0, $2h6lm.default)((0, $fRXcK.default), "WeakMap");
var $3099eb9c8a2dad9e$export$2e2bcd8739ae039 = $3099eb9c8a2dad9e$var$WeakMap;

});


parcelRegister("izuBR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8533d5198bb6125$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $d8533d5198bb6125$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d8533d5198bb6125$var$hasOwnProperty = $d8533d5198bb6125$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $d8533d5198bb6125$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $d8533d5198bb6125$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $d8533d5198bb6125$export$2e2bcd8739ae039 = $d8533d5198bb6125$var$initCloneArray;

});

parcelRegister("lBsJH", function(module, exports) {

$parcel$export(module.exports, "default", () => $fba35811d6335abb$export$2e2bcd8739ae039);

var $dHNs8 = parcelRequire("dHNs8");

var $3cCc2 = parcelRequire("3cCc2");

var $d9E6g = parcelRequire("d9E6g");

var $lfP7M = parcelRequire("lfP7M");

var $ji7F8 = parcelRequire("ji7F8");
/** `Object#toString` result references. */ var $fba35811d6335abb$var$boolTag = "[object Boolean]", $fba35811d6335abb$var$dateTag = "[object Date]", $fba35811d6335abb$var$mapTag = "[object Map]", $fba35811d6335abb$var$numberTag = "[object Number]", $fba35811d6335abb$var$regexpTag = "[object RegExp]", $fba35811d6335abb$var$setTag = "[object Set]", $fba35811d6335abb$var$stringTag = "[object String]", $fba35811d6335abb$var$symbolTag = "[object Symbol]";
var $fba35811d6335abb$var$arrayBufferTag = "[object ArrayBuffer]", $fba35811d6335abb$var$dataViewTag = "[object DataView]", $fba35811d6335abb$var$float32Tag = "[object Float32Array]", $fba35811d6335abb$var$float64Tag = "[object Float64Array]", $fba35811d6335abb$var$int8Tag = "[object Int8Array]", $fba35811d6335abb$var$int16Tag = "[object Int16Array]", $fba35811d6335abb$var$int32Tag = "[object Int32Array]", $fba35811d6335abb$var$uint8Tag = "[object Uint8Array]", $fba35811d6335abb$var$uint8ClampedTag = "[object Uint8ClampedArray]", $fba35811d6335abb$var$uint16Tag = "[object Uint16Array]", $fba35811d6335abb$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $fba35811d6335abb$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $fba35811d6335abb$var$arrayBufferTag:
            return (0, $dHNs8.default)(object);
        case $fba35811d6335abb$var$boolTag:
        case $fba35811d6335abb$var$dateTag:
            return new Ctor(+object);
        case $fba35811d6335abb$var$dataViewTag:
            return (0, $3cCc2.default)(object, isDeep);
        case $fba35811d6335abb$var$float32Tag:
        case $fba35811d6335abb$var$float64Tag:
        case $fba35811d6335abb$var$int8Tag:
        case $fba35811d6335abb$var$int16Tag:
        case $fba35811d6335abb$var$int32Tag:
        case $fba35811d6335abb$var$uint8Tag:
        case $fba35811d6335abb$var$uint8ClampedTag:
        case $fba35811d6335abb$var$uint16Tag:
        case $fba35811d6335abb$var$uint32Tag:
            return (0, $ji7F8.default)(object, isDeep);
        case $fba35811d6335abb$var$mapTag:
            return new Ctor;
        case $fba35811d6335abb$var$numberTag:
        case $fba35811d6335abb$var$stringTag:
            return new Ctor(object);
        case $fba35811d6335abb$var$regexpTag:
            return (0, $d9E6g.default)(object);
        case $fba35811d6335abb$var$setTag:
            return new Ctor;
        case $fba35811d6335abb$var$symbolTag:
            return (0, $lfP7M.default)(object);
    }
}
var $fba35811d6335abb$export$2e2bcd8739ae039 = $fba35811d6335abb$var$initCloneByTag;

});
parcelRegister("dHNs8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fa5a6ce6bedeb19$export$2e2bcd8739ae039);

var $iwkKj = parcelRequire("iwkKj");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $9fa5a6ce6bedeb19$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $iwkKj.default)(result).set(new (0, $iwkKj.default)(arrayBuffer));
    return result;
}
var $9fa5a6ce6bedeb19$export$2e2bcd8739ae039 = $9fa5a6ce6bedeb19$var$cloneArrayBuffer;

});
parcelRegister("iwkKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7bb4edf6850e70d$export$2e2bcd8739ae039);

var $fRXcK = parcelRequire("fRXcK");
/** Built-in value references. */ var $d7bb4edf6850e70d$var$Uint8Array = (0, $fRXcK.default).Uint8Array;
var $d7bb4edf6850e70d$export$2e2bcd8739ae039 = $d7bb4edf6850e70d$var$Uint8Array;

});


parcelRegister("3cCc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $25501e6e6f11ca9a$export$2e2bcd8739ae039);

var $dHNs8 = parcelRequire("dHNs8");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $25501e6e6f11ca9a$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $dHNs8.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $25501e6e6f11ca9a$export$2e2bcd8739ae039 = $25501e6e6f11ca9a$var$cloneDataView;

});

parcelRegister("d9E6g", function(module, exports) {

$parcel$export(module.exports, "default", () => $993b38ade2f79fde$export$2e2bcd8739ae039);
/** Used to match `RegExp` flags from their coerced string values. */ var $993b38ade2f79fde$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $993b38ade2f79fde$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $993b38ade2f79fde$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $993b38ade2f79fde$export$2e2bcd8739ae039 = $993b38ade2f79fde$var$cloneRegExp;

});

parcelRegister("lfP7M", function(module, exports) {

$parcel$export(module.exports, "default", () => $f792a7f29df71491$export$2e2bcd8739ae039);

var $aYS7m = parcelRequire("aYS7m");
/** Used to convert symbols to primitives and strings. */ var $f792a7f29df71491$var$symbolProto = (0, $aYS7m.default) ? (0, $aYS7m.default).prototype : undefined, $f792a7f29df71491$var$symbolValueOf = $f792a7f29df71491$var$symbolProto ? $f792a7f29df71491$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $f792a7f29df71491$var$cloneSymbol(symbol) {
    return $f792a7f29df71491$var$symbolValueOf ? Object($f792a7f29df71491$var$symbolValueOf.call(symbol)) : {};
}
var $f792a7f29df71491$export$2e2bcd8739ae039 = $f792a7f29df71491$var$cloneSymbol;

});

parcelRegister("ji7F8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0b5a45c50fd41c2$export$2e2bcd8739ae039);

var $dHNs8 = parcelRequire("dHNs8");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $e0b5a45c50fd41c2$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $dHNs8.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $e0b5a45c50fd41c2$export$2e2bcd8739ae039 = $e0b5a45c50fd41c2$var$cloneTypedArray;

});


parcelRegister("kraA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee0e895e26f45914$export$2e2bcd8739ae039);

var $6PSm0 = parcelRequire("6PSm0");

var $dkTWv = parcelRequire("dkTWv");

var $dU0PL = parcelRequire("dU0PL");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $ee0e895e26f45914$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $dU0PL.default)(object) ? (0, $6PSm0.default)((0, $dkTWv.default)(object)) : {};
}
var $ee0e895e26f45914$export$2e2bcd8739ae039 = $ee0e895e26f45914$var$initCloneObject;

});
parcelRegister("6PSm0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fa1ab0ddeec3062$export$2e2bcd8739ae039);

var $frrTq = parcelRequire("frrTq");
/** Built-in value references. */ var $4fa1ab0ddeec3062$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $4fa1ab0ddeec3062$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $frrTq.default)(proto)) return {};
        if ($4fa1ab0ddeec3062$var$objectCreate) return $4fa1ab0ddeec3062$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $4fa1ab0ddeec3062$export$2e2bcd8739ae039 = $4fa1ab0ddeec3062$var$baseCreate;

});


parcelRegister("9pyJg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6da16355e5b791d2$export$2e2bcd8739ae039);

var $262q8 = parcelRequire("262q8");

var $a1upq = parcelRequire("a1upq");

var $1wE0y = parcelRequire("1wE0y");
/* Node.js helper references. */ var $6da16355e5b791d2$var$nodeIsMap = (0, $1wE0y.default) && (0, $1wE0y.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $6da16355e5b791d2$var$isMap = $6da16355e5b791d2$var$nodeIsMap ? (0, $a1upq.default)($6da16355e5b791d2$var$nodeIsMap) : (0, $262q8.default);
var $6da16355e5b791d2$export$2e2bcd8739ae039 = $6da16355e5b791d2$var$isMap;

});
parcelRegister("262q8", function(module, exports) {

$parcel$export(module.exports, "default", () => $186e04f8c1c2a2ec$export$2e2bcd8739ae039);

var $gbHlz = parcelRequire("gbHlz");

var $da1Ti = parcelRequire("da1Ti");
/** `Object#toString` result references. */ var $186e04f8c1c2a2ec$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $186e04f8c1c2a2ec$var$baseIsMap(value) {
    return (0, $da1Ti.default)(value) && (0, $gbHlz.default)(value) == $186e04f8c1c2a2ec$var$mapTag;
}
var $186e04f8c1c2a2ec$export$2e2bcd8739ae039 = $186e04f8c1c2a2ec$var$baseIsMap;

});


parcelRegister("19too", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d6d6e6fca5822f7$export$2e2bcd8739ae039);

var $lqe6R = parcelRequire("lqe6R");

var $a1upq = parcelRequire("a1upq");

var $1wE0y = parcelRequire("1wE0y");
/* Node.js helper references. */ var $0d6d6e6fca5822f7$var$nodeIsSet = (0, $1wE0y.default) && (0, $1wE0y.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $0d6d6e6fca5822f7$var$isSet = $0d6d6e6fca5822f7$var$nodeIsSet ? (0, $a1upq.default)($0d6d6e6fca5822f7$var$nodeIsSet) : (0, $lqe6R.default);
var $0d6d6e6fca5822f7$export$2e2bcd8739ae039 = $0d6d6e6fca5822f7$var$isSet;

});
parcelRegister("lqe6R", function(module, exports) {

$parcel$export(module.exports, "default", () => $f986f8946c013d91$export$2e2bcd8739ae039);

var $gbHlz = parcelRequire("gbHlz");

var $da1Ti = parcelRequire("da1Ti");
/** `Object#toString` result references. */ var $f986f8946c013d91$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $f986f8946c013d91$var$baseIsSet(value) {
    return (0, $da1Ti.default)(value) && (0, $gbHlz.default)(value) == $f986f8946c013d91$var$setTag;
}
var $f986f8946c013d91$export$2e2bcd8739ae039 = $f986f8946c013d91$var$baseIsSet;

});




parcelRegister("gEK22", function(module, exports) {

$parcel$export(module.exports, "default", () => $0321192409cd131f$export$2e2bcd8739ae039);

var $2t6z1 = parcelRequire("2t6z1");

var $h3wcn = parcelRequire("h3wcn");

var $5yaQN = parcelRequire("5yaQN");

var $ezQL1 = parcelRequire("ezQL1");

var $43jPC = parcelRequire("43jPC");

var $4MtJK = parcelRequire("4MtJK");

var $cJCTt = parcelRequire("cJCTt");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $0321192409cd131f$var$toPath(value) {
    if ((0, $5yaQN.default)(value)) return (0, $2t6z1.default)(value, (0, $4MtJK.default));
    return (0, $ezQL1.default)(value) ? [
        value
    ] : (0, $h3wcn.default)((0, $43jPC.default)((0, $cJCTt.default)(value)));
}
var $0321192409cd131f$export$2e2bcd8739ae039 = $0321192409cd131f$var$toPath;

});
parcelRegister("2t6z1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cc361a78917bf93$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $1cc361a78917bf93$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $1cc361a78917bf93$export$2e2bcd8739ae039 = $1cc361a78917bf93$var$arrayMap;

});

parcelRegister("ezQL1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9cd42161855db0d$export$2e2bcd8739ae039);

var $8X3vt = parcelRequire("8X3vt");

var $da1Ti = parcelRequire("da1Ti");
/** `Object#toString` result references. */ var $a9cd42161855db0d$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $a9cd42161855db0d$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $da1Ti.default)(value) && (0, $8X3vt.default)(value) == $a9cd42161855db0d$var$symbolTag;
}
var $a9cd42161855db0d$export$2e2bcd8739ae039 = $a9cd42161855db0d$var$isSymbol;

});

parcelRegister("43jPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f36d35e51d6821a$export$2e2bcd8739ae039);

var $adSRj = parcelRequire("adSRj");
/** Used to match property names within property paths. */ var $2f36d35e51d6821a$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $2f36d35e51d6821a$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2f36d35e51d6821a$var$stringToPath = (0, $adSRj.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($2f36d35e51d6821a$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($2f36d35e51d6821a$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
var $2f36d35e51d6821a$export$2e2bcd8739ae039 = $2f36d35e51d6821a$var$stringToPath;

});
parcelRegister("adSRj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7715ac1b7b976a71$export$2e2bcd8739ae039);

var $fIPbB = parcelRequire("fIPbB");
/** Used as the maximum memoize cache size. */ var $7715ac1b7b976a71$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $7715ac1b7b976a71$var$memoizeCapped(func) {
    var result = (0, $fIPbB.default)(func, function(key) {
        if (cache.size === $7715ac1b7b976a71$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $7715ac1b7b976a71$export$2e2bcd8739ae039 = $7715ac1b7b976a71$var$memoizeCapped;

});
parcelRegister("fIPbB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b722ab918bf9f4f5$export$2e2bcd8739ae039);

var $cPIJw = parcelRequire("cPIJw");
/** Error message constants. */ var $b722ab918bf9f4f5$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $b722ab918bf9f4f5$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($b722ab918bf9f4f5$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($b722ab918bf9f4f5$var$memoize.Cache || (0, $cPIJw.default));
    return memoized;
}
// Expose `MapCache`.
$b722ab918bf9f4f5$var$memoize.Cache = (0, $cPIJw.default);
var $b722ab918bf9f4f5$export$2e2bcd8739ae039 = $b722ab918bf9f4f5$var$memoize;

});



parcelRegister("4MtJK", function(module, exports) {

$parcel$export(module.exports, "default", () => $37b2b63aca8e513d$export$2e2bcd8739ae039);

var $ezQL1 = parcelRequire("ezQL1");
/** Used as references for various `Number` constants. */ var $37b2b63aca8e513d$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $37b2b63aca8e513d$var$toKey(value) {
    if (typeof value == "string" || (0, $ezQL1.default)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$37b2b63aca8e513d$var$INFINITY ? "-0" : result;
}
var $37b2b63aca8e513d$export$2e2bcd8739ae039 = $37b2b63aca8e513d$var$toKey;

});

parcelRegister("cJCTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $9457db7e2e078153$export$2e2bcd8739ae039);

var $lmBhJ = parcelRequire("lmBhJ");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $9457db7e2e078153$var$toString(value) {
    return value == null ? "" : (0, $lmBhJ.default)(value);
}
var $9457db7e2e078153$export$2e2bcd8739ae039 = $9457db7e2e078153$var$toString;

});
parcelRegister("lmBhJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8d893110632a9ac$export$2e2bcd8739ae039);

var $aYS7m = parcelRequire("aYS7m");

var $2t6z1 = parcelRequire("2t6z1");

var $5yaQN = parcelRequire("5yaQN");

var $ezQL1 = parcelRequire("ezQL1");
/** Used as references for various `Number` constants. */ var $f8d893110632a9ac$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f8d893110632a9ac$var$symbolProto = (0, $aYS7m.default) ? (0, $aYS7m.default).prototype : undefined, $f8d893110632a9ac$var$symbolToString = $f8d893110632a9ac$var$symbolProto ? $f8d893110632a9ac$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f8d893110632a9ac$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, $5yaQN.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $2t6z1.default)(value, $f8d893110632a9ac$var$baseToString) + "";
    if ((0, $ezQL1.default)(value)) return $f8d893110632a9ac$var$symbolToString ? $f8d893110632a9ac$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$f8d893110632a9ac$var$INFINITY ? "-0" : result;
}
var $f8d893110632a9ac$export$2e2bcd8739ae039 = $f8d893110632a9ac$var$baseToString;

});



parcelRegister("7g5pF", function(module, exports) {
"use strict";

var $41Tfm = parcelRequire("41Tfm");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $548e39f24abb922b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $548e39f24abb922b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $548e39f24abb922b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $548e39f24abb922b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $548e39f24abb922b$var$TYPE_STATICS = {};
$548e39f24abb922b$var$TYPE_STATICS[$41Tfm.ForwardRef] = $548e39f24abb922b$var$FORWARD_REF_STATICS;
$548e39f24abb922b$var$TYPE_STATICS[$41Tfm.Memo] = $548e39f24abb922b$var$MEMO_STATICS;
function $548e39f24abb922b$var$getStatics(component) {
    // React v16.11 and below
    if ($41Tfm.isMemo(component)) return $548e39f24abb922b$var$MEMO_STATICS;
     // React v16.12 and above
    return $548e39f24abb922b$var$TYPE_STATICS[component["$$typeof"]] || $548e39f24abb922b$var$REACT_STATICS;
}
var $548e39f24abb922b$var$defineProperty = Object.defineProperty;
var $548e39f24abb922b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $548e39f24abb922b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $548e39f24abb922b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $548e39f24abb922b$var$getPrototypeOf = Object.getPrototypeOf;
var $548e39f24abb922b$var$objectPrototype = Object.prototype;
function $548e39f24abb922b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($548e39f24abb922b$var$objectPrototype) {
            var inheritedComponent = $548e39f24abb922b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $548e39f24abb922b$var$objectPrototype) $548e39f24abb922b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $548e39f24abb922b$var$getOwnPropertyNames(sourceComponent);
        if ($548e39f24abb922b$var$getOwnPropertySymbols) keys = keys.concat($548e39f24abb922b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $548e39f24abb922b$var$getStatics(targetComponent);
        var sourceStatics = $548e39f24abb922b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$548e39f24abb922b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $548e39f24abb922b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $548e39f24abb922b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $548e39f24abb922b$var$hoistNonReactStatics;

});
parcelRegister("41Tfm", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lt0gQ"));

});


parcelRegister("e3GSY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3c29cb39a40953b$export$2e2bcd8739ae039);

var $k0qEi = parcelRequire("k0qEi");
/** Used to compose bitmasks for cloning. */ var $a3c29cb39a40953b$var$CLONE_DEEP_FLAG = 1, $a3c29cb39a40953b$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $a3c29cb39a40953b$var$cloneDeep(value) {
    return (0, $k0qEi.default)(value, $a3c29cb39a40953b$var$CLONE_DEEP_FLAG | $a3c29cb39a40953b$var$CLONE_SYMBOLS_FLAG);
}
var $a3c29cb39a40953b$export$2e2bcd8739ae039 = $a3c29cb39a40953b$var$cloneDeep;

});


parcelRegister("h8F4l", function(module, exports) {
/*
 A JavaScript implementation of the SHA family of hashes, as
 defined in FIPS PUB 180-4 and FIPS PUB 202, as well as the corresponding
 HMAC implementation as defined in FIPS PUB 198a

 Copyright 2008-2020 Brian Turek, 1998-2009 Paul Johnston & Contributors
 Distributed under the BSD License
 See http://caligatio.github.com/jsSHA/ for more information
*/ "use strict";
(function(aa) {
    function C(d, b, a) {
        var h = 0, k = [], m = 0, g, l, c, f, n, q, u, r, I = !1, v = [], x = [], t, y = !1, z = !1, w = -1;
        a = a || {};
        g = a.encoding || "UTF8";
        t = a.numRounds || 1;
        if (t !== parseInt(t, 10) || 1 > t) throw Error("numRounds must a integer >= 1");
        if ("SHA-1" === d) n = 512, q = K, u = ba, f = 160, r = function(b) {
            return b.slice();
        };
        else if (0 === d.lastIndexOf("SHA-", 0)) {
            if (q = function(b, h) {
                return L(b, h, d);
            }, u = function(b, h, k, a) {
                var e, f;
                if ("SHA-224" === d || "SHA-256" === d) e = (h + 65 >>> 9 << 4) + 15, f = 16;
                else if ("SHA-384" === d || "SHA-512" === d) e = (h + 129 >>> 10 << 5) + 31, f = 32;
                else throw Error("Unexpected error in SHA-2 implementation");
                for(; b.length <= e;)b.push(0);
                b[h >>> 5] |= 128 << 24 - h % 32;
                h = h + k;
                b[e] = h & 4294967295;
                b[e - 1] = h / 4294967296 | 0;
                k = b.length;
                for(h = 0; h < k; h += f)a = L(b.slice(h, h + f), a, d);
                if ("SHA-224" === d) b = [
                    a[0],
                    a[1],
                    a[2],
                    a[3],
                    a[4],
                    a[5],
                    a[6]
                ];
                else if ("SHA-256" === d) b = a;
                else if ("SHA-384" === d) b = [
                    a[0].a,
                    a[0].b,
                    a[1].a,
                    a[1].b,
                    a[2].a,
                    a[2].b,
                    a[3].a,
                    a[3].b,
                    a[4].a,
                    a[4].b,
                    a[5].a,
                    a[5].b
                ];
                else if ("SHA-512" === d) b = [
                    a[0].a,
                    a[0].b,
                    a[1].a,
                    a[1].b,
                    a[2].a,
                    a[2].b,
                    a[3].a,
                    a[3].b,
                    a[4].a,
                    a[4].b,
                    a[5].a,
                    a[5].b,
                    a[6].a,
                    a[6].b,
                    a[7].a,
                    a[7].b
                ];
                else throw Error("Unexpected error in SHA-2 implementation");
                return b;
            }, r = function(b) {
                return b.slice();
            }, "SHA-224" === d) n = 512, f = 224;
            else if ("SHA-256" === d) n = 512, f = 256;
            else if ("SHA-384" === d) n = 1024, f = 384;
            else if ("SHA-512" === d) n = 1024, f = 512;
            else throw Error("Chosen SHA variant is not supported");
        } else if (0 === d.lastIndexOf("SHA3-", 0) || 0 === d.lastIndexOf("SHAKE", 0)) {
            var F = 6;
            q = D;
            r = function(b) {
                var d = [], a;
                for(a = 0; 5 > a; a += 1)d[a] = b[a].slice();
                return d;
            };
            w = 1;
            if ("SHA3-224" === d) n = 1152, f = 224;
            else if ("SHA3-256" === d) n = 1088, f = 256;
            else if ("SHA3-384" === d) n = 832, f = 384;
            else if ("SHA3-512" === d) n = 576, f = 512;
            else if ("SHAKE128" === d) n = 1344, f = -1, F = 31, z = !0;
            else if ("SHAKE256" === d) n = 1088, f = -1, F = 31, z = !0;
            else throw Error("Chosen SHA variant is not supported");
            u = function(b, d, a, h, k) {
                a = n;
                var e = F, f, g = [], m = a >>> 5, l = 0, c = d >>> 5;
                for(f = 0; f < c && d >= a; f += m)h = D(b.slice(f, f + m), h), d -= a;
                b = b.slice(f);
                for(d %= a; b.length < m;)b.push(0);
                f = d >>> 3;
                b[f >> 2] ^= e << f % 4 * 8;
                b[m - 1] ^= 2147483648;
                for(h = D(b, h); 32 * g.length < k;){
                    b = h[l % 5][l / 5 | 0];
                    g.push(b.b);
                    if (32 * g.length >= k) break;
                    g.push(b.a);
                    l += 1;
                    0 === 64 * l % a && (D(null, h), l = 0);
                }
                return g;
            };
        } else throw Error("Chosen SHA variant is not supported");
        c = M(b, g, w);
        l = A(d);
        this.setHMACKey = function(b, a, k) {
            var e;
            if (!0 === I) throw Error("HMAC key already set");
            if (!0 === y) throw Error("Cannot set HMAC key after calling update");
            if (!0 === z) throw Error("SHAKE is not supported for HMAC");
            g = (k || {}).encoding || "UTF8";
            a = M(a, g, w)(b);
            b = a.binLen;
            a = a.value;
            e = n >>> 3;
            k = e / 4 - 1;
            for(e < b / 8 && (a = u(a, b, 0, A(d), f)); a.length <= k;)a.push(0);
            for(b = 0; b <= k; b += 1)v[b] = a[b] ^ 909522486, x[b] = a[b] ^ 1549556828;
            l = q(v, l);
            h = n;
            I = !0;
        };
        this.update = function(b) {
            var d, a, e, f = 0, g = n >>> 5;
            d = c(b, k, m);
            b = d.binLen;
            a = d.value;
            d = b >>> 5;
            for(e = 0; e < d; e += g)f + n <= b && (l = q(a.slice(e, e + g), l), f += n);
            h += f;
            k = a.slice(f >>> 5);
            m = b % n;
            y = !0;
        };
        this.getHash = function(b, a) {
            var e, g, c, n;
            if (!0 === I) throw Error("Cannot call getHash after setting HMAC key");
            c = N(a);
            if (!0 === z) {
                if (-1 === c.shakeLen) throw Error("shakeLen must be specified in options");
                f = c.shakeLen;
            }
            switch(b){
                case "HEX":
                    e = function(b) {
                        return O(b, f, w, c);
                    };
                    break;
                case "B64":
                    e = function(b) {
                        return P(b, f, w, c);
                    };
                    break;
                case "BYTES":
                    e = function(b) {
                        return Q(b, f, w);
                    };
                    break;
                case "ARRAYBUFFER":
                    try {
                        g = new ArrayBuffer(0);
                    } catch (p) {
                        throw Error("ARRAYBUFFER not supported by this environment");
                    }
                    e = function(b) {
                        return R(b, f, w);
                    };
                    break;
                case "UINT8ARRAY":
                    try {
                        g = new Uint8Array(0);
                    } catch (p) {
                        throw Error("UINT8ARRAY not supported by this environment");
                    }
                    e = function(b) {
                        return S(b, f, w);
                    };
                    break;
                default:
                    throw Error("format must be HEX, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");
            }
            n = u(k.slice(), m, h, r(l), f);
            for(g = 1; g < t; g += 1)!0 === z && 0 !== f % 32 && (n[n.length - 1] &= 16777215 >>> 24 - f % 32), n = u(n, f, 0, A(d), f);
            return e(n);
        };
        this.getHMAC = function(b, a) {
            var e, g, c, p;
            if (!1 === I) throw Error("Cannot call getHMAC without first setting HMAC key");
            c = N(a);
            switch(b){
                case "HEX":
                    e = function(b) {
                        return O(b, f, w, c);
                    };
                    break;
                case "B64":
                    e = function(b) {
                        return P(b, f, w, c);
                    };
                    break;
                case "BYTES":
                    e = function(b) {
                        return Q(b, f, w);
                    };
                    break;
                case "ARRAYBUFFER":
                    try {
                        e = new ArrayBuffer(0);
                    } catch (v) {
                        throw Error("ARRAYBUFFER not supported by this environment");
                    }
                    e = function(b) {
                        return R(b, f, w);
                    };
                    break;
                case "UINT8ARRAY":
                    try {
                        e = new Uint8Array(0);
                    } catch (v) {
                        throw Error("UINT8ARRAY not supported by this environment");
                    }
                    e = function(b) {
                        return S(b, f, w);
                    };
                    break;
                default:
                    throw Error("outputFormat must be HEX, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");
            }
            g = u(k.slice(), m, h, r(l), f);
            p = q(x, A(d));
            p = u(g, f, n, p, f);
            return e(p);
        };
    }
    function a(d, b) {
        this.a = d;
        this.b = b;
    }
    function T(d, b, a, h) {
        var k, m, g, l, c;
        b = b || [
            0
        ];
        a = a || 0;
        m = a >>> 3;
        c = -1 === h ? 3 : 0;
        for(k = 0; k < d.length; k += 1)l = k + m, g = l >>> 2, b.length <= g && b.push(0), b[g] |= d[k] << 8 * (c + l % 4 * h);
        return {
            value: b,
            binLen: 8 * d.length + a
        };
    }
    function O(a, b, e, h) {
        var k = "";
        b /= 8;
        var m, g, c;
        c = -1 === e ? 3 : 0;
        for(m = 0; m < b; m += 1)g = a[m >>> 2] >>> 8 * (c + m % 4 * e), k += "0123456789abcdef".charAt(g >>> 4 & 15) + "0123456789abcdef".charAt(g & 15);
        return h.outputUpper ? k.toUpperCase() : k;
    }
    function P(a, b, e, h) {
        var k = "", m = b / 8, g, c, p, f;
        f = -1 === e ? 3 : 0;
        for(g = 0; g < m; g += 3)for(c = g + 1 < m ? a[g + 1 >>> 2] : 0, p = g + 2 < m ? a[g + 2 >>> 2] : 0, p = (a[g >>> 2] >>> 8 * (f + g % 4 * e) & 255) << 16 | (c >>> 8 * (f + (g + 1) % 4 * e) & 255) << 8 | p >>> 8 * (f + (g + 2) % 4 * e) & 255, c = 0; 4 > c; c += 1)8 * g + 6 * c <= b ? k += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(p >>> 6 * (3 - c) & 63) : k += h.b64Pad;
        return k;
    }
    function Q(a, b, e) {
        var h = "";
        b /= 8;
        var k, c, g;
        g = -1 === e ? 3 : 0;
        for(k = 0; k < b; k += 1)c = a[k >>> 2] >>> 8 * (g + k % 4 * e) & 255, h += String.fromCharCode(c);
        return h;
    }
    function R(a, b, e) {
        b /= 8;
        var h, k = new ArrayBuffer(b), c, g;
        g = new Uint8Array(k);
        c = -1 === e ? 3 : 0;
        for(h = 0; h < b; h += 1)g[h] = a[h >>> 2] >>> 8 * (c + h % 4 * e) & 255;
        return k;
    }
    function S(a, b, e) {
        b /= 8;
        var h, k = new Uint8Array(b), c;
        c = -1 === e ? 3 : 0;
        for(h = 0; h < b; h += 1)k[h] = a[h >>> 2] >>> 8 * (c + h % 4 * e) & 255;
        return k;
    }
    function N(a) {
        var b = {
            outputUpper: !1,
            b64Pad: "=",
            shakeLen: -1
        };
        a = a || {};
        b.outputUpper = a.outputUpper || !1;
        !0 === a.hasOwnProperty("b64Pad") && (b.b64Pad = a.b64Pad);
        if (!0 === a.hasOwnProperty("shakeLen")) {
            if (0 !== a.shakeLen % 8) throw Error("shakeLen must be a multiple of 8");
            b.shakeLen = a.shakeLen;
        }
        if ("boolean" !== typeof b.outputUpper) throw Error("Invalid outputUpper formatting option");
        if ("string" !== typeof b.b64Pad) throw Error("Invalid b64Pad formatting option");
        return b;
    }
    function M(a, b, e) {
        switch(b){
            case "UTF8":
            case "UTF16BE":
            case "UTF16LE":
                break;
            default:
                throw Error("encoding must be UTF8, UTF16BE, or UTF16LE");
        }
        switch(a){
            case "HEX":
                a = function(b, a, d) {
                    var g = b.length, c, p, f, n, q, u;
                    if (0 !== g % 2) throw Error("String of HEX type must be in byte increments");
                    a = a || [
                        0
                    ];
                    d = d || 0;
                    q = d >>> 3;
                    u = -1 === e ? 3 : 0;
                    for(c = 0; c < g; c += 2){
                        p = parseInt(b.substr(c, 2), 16);
                        if (isNaN(p)) throw Error("String of HEX type contains invalid characters");
                        n = (c >>> 1) + q;
                        for(f = n >>> 2; a.length <= f;)a.push(0);
                        a[f] |= p << 8 * (u + n % 4 * e);
                    }
                    return {
                        value: a,
                        binLen: 4 * g + d
                    };
                };
                break;
            case "TEXT":
                a = function(a, d, c) {
                    var g, l, p = 0, f, n, q, u, r, t;
                    d = d || [
                        0
                    ];
                    c = c || 0;
                    q = c >>> 3;
                    if ("UTF8" === b) for(t = -1 === e ? 3 : 0, f = 0; f < a.length; f += 1)for(g = a.charCodeAt(f), l = [], 128 > g ? l.push(g) : 2048 > g ? (l.push(192 | g >>> 6), l.push(128 | g & 63)) : 55296 > g || 57344 <= g ? l.push(224 | g >>> 12, 128 | g >>> 6 & 63, 128 | g & 63) : (f += 1, g = 65536 + ((g & 1023) << 10 | a.charCodeAt(f) & 1023), l.push(240 | g >>> 18, 128 | g >>> 12 & 63, 128 | g >>> 6 & 63, 128 | g & 63)), n = 0; n < l.length; n += 1){
                        r = p + q;
                        for(u = r >>> 2; d.length <= u;)d.push(0);
                        d[u] |= l[n] << 8 * (t + r % 4 * e);
                        p += 1;
                    }
                    else if ("UTF16BE" === b || "UTF16LE" === b) for(t = -1 === e ? 2 : 0, l = "UTF16LE" === b && 1 !== e || "UTF16LE" !== b && 1 === e, f = 0; f < a.length; f += 1){
                        g = a.charCodeAt(f);
                        !0 === l && (n = g & 255, g = n << 8 | g >>> 8);
                        r = p + q;
                        for(u = r >>> 2; d.length <= u;)d.push(0);
                        d[u] |= g << 8 * (t + r % 4 * e);
                        p += 2;
                    }
                    return {
                        value: d,
                        binLen: 8 * p + c
                    };
                };
                break;
            case "B64":
                a = function(b, a, d) {
                    var c = 0, l, p, f, n, q, u, r, t;
                    if (-1 === b.search(/^[a-zA-Z0-9=+\/]+$/)) throw Error("Invalid character in base-64 string");
                    p = b.indexOf("=");
                    b = b.replace(/\=/g, "");
                    if (-1 !== p && p < b.length) throw Error("Invalid '=' found in base-64 string");
                    a = a || [
                        0
                    ];
                    d = d || 0;
                    u = d >>> 3;
                    t = -1 === e ? 3 : 0;
                    for(p = 0; p < b.length; p += 4){
                        q = b.substr(p, 4);
                        for(f = n = 0; f < q.length; f += 1)l = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(q.charAt(f)), n |= l << 18 - 6 * f;
                        for(f = 0; f < q.length - 1; f += 1){
                            r = c + u;
                            for(l = r >>> 2; a.length <= l;)a.push(0);
                            a[l] |= (n >>> 16 - 8 * f & 255) << 8 * (t + r % 4 * e);
                            c += 1;
                        }
                    }
                    return {
                        value: a,
                        binLen: 8 * c + d
                    };
                };
                break;
            case "BYTES":
                a = function(b, a, d) {
                    var c, l, p, f, n, q;
                    a = a || [
                        0
                    ];
                    d = d || 0;
                    p = d >>> 3;
                    q = -1 === e ? 3 : 0;
                    for(l = 0; l < b.length; l += 1)c = b.charCodeAt(l), n = l + p, f = n >>> 2, a.length <= f && a.push(0), a[f] |= c << 8 * (q + n % 4 * e);
                    return {
                        value: a,
                        binLen: 8 * b.length + d
                    };
                };
                break;
            case "ARRAYBUFFER":
                try {
                    a = new ArrayBuffer(0);
                } catch (h) {
                    throw Error("ARRAYBUFFER not supported by this environment");
                }
                a = function(b, a, d) {
                    return T(new Uint8Array(b), a, d, e);
                };
                break;
            case "UINT8ARRAY":
                try {
                    a = new Uint8Array(0);
                } catch (h) {
                    throw Error("UINT8ARRAY not supported by this environment");
                }
                a = function(b, a, d) {
                    return T(b, a, d, e);
                };
                break;
            default:
                throw Error("format must be HEX, TEXT, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");
        }
        return a;
    }
    function y(a, b) {
        return a << b | a >>> 32 - b;
    }
    function U(d, b) {
        return 32 < b ? (b -= 32, new a(d.b << b | d.a >>> 32 - b, d.a << b | d.b >>> 32 - b)) : 0 !== b ? new a(d.a << b | d.b >>> 32 - b, d.b << b | d.a >>> 32 - b) : d;
    }
    function x(a, b) {
        return a >>> b | a << 32 - b;
    }
    function t(d, b) {
        var e = null, e = new a(d.a, d.b);
        return e = 32 >= b ? new a(e.a >>> b | e.b << 32 - b & 4294967295, e.b >>> b | e.a << 32 - b & 4294967295) : new a(e.b >>> b - 32 | e.a << 64 - b & 4294967295, e.a >>> b - 32 | e.b << 64 - b & 4294967295);
    }
    function V(d, b) {
        var e = null;
        return e = 32 >= b ? new a(d.a >>> b, d.b >>> b | d.a << 32 - b & 4294967295) : new a(0, d.a >>> b - 32);
    }
    function ca(a, b, e) {
        return a & b ^ ~a & e;
    }
    function da(d, b, e) {
        return new a(d.a & b.a ^ ~d.a & e.a, d.b & b.b ^ ~d.b & e.b);
    }
    function W(a, b, e) {
        return a & b ^ a & e ^ b & e;
    }
    function ea(d, b, e) {
        return new a(d.a & b.a ^ d.a & e.a ^ b.a & e.a, d.b & b.b ^ d.b & e.b ^ b.b & e.b);
    }
    function fa(a) {
        return x(a, 2) ^ x(a, 13) ^ x(a, 22);
    }
    function ga(d) {
        var b = t(d, 28), e = t(d, 34);
        d = t(d, 39);
        return new a(b.a ^ e.a ^ d.a, b.b ^ e.b ^ d.b);
    }
    function ha(a) {
        return x(a, 6) ^ x(a, 11) ^ x(a, 25);
    }
    function ia(d) {
        var b = t(d, 14), e = t(d, 18);
        d = t(d, 41);
        return new a(b.a ^ e.a ^ d.a, b.b ^ e.b ^ d.b);
    }
    function ja(a) {
        return x(a, 7) ^ x(a, 18) ^ a >>> 3;
    }
    function ka(d) {
        var b = t(d, 1), e = t(d, 8);
        d = V(d, 7);
        return new a(b.a ^ e.a ^ d.a, b.b ^ e.b ^ d.b);
    }
    function la(a) {
        return x(a, 17) ^ x(a, 19) ^ a >>> 10;
    }
    function ma(d) {
        var b = t(d, 19), e = t(d, 61);
        d = V(d, 6);
        return new a(b.a ^ e.a ^ d.a, b.b ^ e.b ^ d.b);
    }
    function G(a, b) {
        var e = (a & 65535) + (b & 65535);
        return ((a >>> 16) + (b >>> 16) + (e >>> 16) & 65535) << 16 | e & 65535;
    }
    function na(a, b, e, h) {
        var c = (a & 65535) + (b & 65535) + (e & 65535) + (h & 65535);
        return ((a >>> 16) + (b >>> 16) + (e >>> 16) + (h >>> 16) + (c >>> 16) & 65535) << 16 | c & 65535;
    }
    function H(a, b, e, h, c) {
        var m = (a & 65535) + (b & 65535) + (e & 65535) + (h & 65535) + (c & 65535);
        return ((a >>> 16) + (b >>> 16) + (e >>> 16) + (h >>> 16) + (c >>> 16) + (m >>> 16) & 65535) << 16 | m & 65535;
    }
    function oa(d, b) {
        var e, h, c;
        e = (d.b & 65535) + (b.b & 65535);
        h = (d.b >>> 16) + (b.b >>> 16) + (e >>> 16);
        c = (h & 65535) << 16 | e & 65535;
        e = (d.a & 65535) + (b.a & 65535) + (h >>> 16);
        h = (d.a >>> 16) + (b.a >>> 16) + (e >>> 16);
        return new a((h & 65535) << 16 | e & 65535, c);
    }
    function pa(d, b, e, h) {
        var c, m, g;
        c = (d.b & 65535) + (b.b & 65535) + (e.b & 65535) + (h.b & 65535);
        m = (d.b >>> 16) + (b.b >>> 16) + (e.b >>> 16) + (h.b >>> 16) + (c >>> 16);
        g = (m & 65535) << 16 | c & 65535;
        c = (d.a & 65535) + (b.a & 65535) + (e.a & 65535) + (h.a & 65535) + (m >>> 16);
        m = (d.a >>> 16) + (b.a >>> 16) + (e.a >>> 16) + (h.a >>> 16) + (c >>> 16);
        return new a((m & 65535) << 16 | c & 65535, g);
    }
    function qa(d, b, e, h, c) {
        var m, g, l;
        m = (d.b & 65535) + (b.b & 65535) + (e.b & 65535) + (h.b & 65535) + (c.b & 65535);
        g = (d.b >>> 16) + (b.b >>> 16) + (e.b >>> 16) + (h.b >>> 16) + (c.b >>> 16) + (m >>> 16);
        l = (g & 65535) << 16 | m & 65535;
        m = (d.a & 65535) + (b.a & 65535) + (e.a & 65535) + (h.a & 65535) + (c.a & 65535) + (g >>> 16);
        g = (d.a >>> 16) + (b.a >>> 16) + (e.a >>> 16) + (h.a >>> 16) + (c.a >>> 16) + (m >>> 16);
        return new a((g & 65535) << 16 | m & 65535, l);
    }
    function B(d, b) {
        return new a(d.a ^ b.a, d.b ^ b.b);
    }
    function A(d) {
        var b = [], e;
        if ("SHA-1" === d) b = [
            1732584193,
            4023233417,
            2562383102,
            271733878,
            3285377520
        ];
        else if (0 === d.lastIndexOf("SHA-", 0)) switch(b = [
            3238371032,
            914150663,
            812702999,
            4144912697,
            4290775857,
            1750603025,
            1694076839,
            3204075428
        ], e = [
            1779033703,
            3144134277,
            1013904242,
            2773480762,
            1359893119,
            2600822924,
            528734635,
            1541459225
        ], d){
            case "SHA-224":
                break;
            case "SHA-256":
                b = e;
                break;
            case "SHA-384":
                b = [
                    new a(3418070365, b[0]),
                    new a(1654270250, b[1]),
                    new a(2438529370, b[2]),
                    new a(355462360, b[3]),
                    new a(1731405415, b[4]),
                    new a(41048885895, b[5]),
                    new a(3675008525, b[6]),
                    new a(1203062813, b[7])
                ];
                break;
            case "SHA-512":
                b = [
                    new a(e[0], 4089235720),
                    new a(e[1], 2227873595),
                    new a(e[2], 4271175723),
                    new a(e[3], 1595750129),
                    new a(e[4], 2917565137),
                    new a(e[5], 725511199),
                    new a(e[6], 4215389547),
                    new a(e[7], 327033209)
                ];
                break;
            default:
                throw Error("Unknown SHA variant");
        }
        else if (0 === d.lastIndexOf("SHA3-", 0) || 0 === d.lastIndexOf("SHAKE", 0)) for(d = 0; 5 > d; d += 1)b[d] = [
            new a(0, 0),
            new a(0, 0),
            new a(0, 0),
            new a(0, 0),
            new a(0, 0)
        ];
        else throw Error("No SHA variants supported");
        return b;
    }
    function K(a, b) {
        var e = [], h, c, m, g, l, p, f;
        h = b[0];
        c = b[1];
        m = b[2];
        g = b[3];
        l = b[4];
        for(f = 0; 80 > f; f += 1)e[f] = 16 > f ? a[f] : y(e[f - 3] ^ e[f - 8] ^ e[f - 14] ^ e[f - 16], 1), p = 20 > f ? H(y(h, 5), c & m ^ ~c & g, l, 1518500249, e[f]) : 40 > f ? H(y(h, 5), c ^ m ^ g, l, 1859775393, e[f]) : 60 > f ? H(y(h, 5), W(c, m, g), l, 2400959708, e[f]) : H(y(h, 5), c ^ m ^ g, l, 3395469782, e[f]), l = g, g = m, m = y(c, 30), c = h, h = p;
        b[0] = G(h, b[0]);
        b[1] = G(c, b[1]);
        b[2] = G(m, b[2]);
        b[3] = G(g, b[3]);
        b[4] = G(l, b[4]);
        return b;
    }
    function ba(a, b, e, c) {
        var k;
        for(k = (b + 65 >>> 9 << 4) + 15; a.length <= k;)a.push(0);
        a[b >>> 5] |= 128 << 24 - b % 32;
        b += e;
        a[k] = b & 4294967295;
        a[k - 1] = b / 4294967296 | 0;
        b = a.length;
        for(k = 0; k < b; k += 16)c = K(a.slice(k, k + 16), c);
        return c;
    }
    function L(d, b, e) {
        var h, k, m, g, l, p, f, n, q, u, r, t, v, x, y, A, z, w, F, B, C, D, E = [], J;
        if ("SHA-224" === e || "SHA-256" === e) u = 64, t = 1, D = Number, v = G, x = na, y = H, A = ja, z = la, w = fa, F = ha, C = W, B = ca, J = c;
        else if ("SHA-384" === e || "SHA-512" === e) u = 80, t = 2, D = a, v = oa, x = pa, y = qa, A = ka, z = ma, w = ga, F = ia, C = ea, B = da, J = X;
        else throw Error("Unexpected error in SHA-2 implementation");
        e = b[0];
        h = b[1];
        k = b[2];
        m = b[3];
        g = b[4];
        l = b[5];
        p = b[6];
        f = b[7];
        for(r = 0; r < u; r += 1)16 > r ? (q = r * t, n = d.length <= q ? 0 : d[q], q = d.length <= q + 1 ? 0 : d[q + 1], E[r] = new D(n, q)) : E[r] = x(z(E[r - 2]), E[r - 7], A(E[r - 15]), E[r - 16]), n = y(f, F(g), B(g, l, p), J[r], E[r]), q = v(w(e), C(e, h, k)), f = p, p = l, l = g, g = v(m, n), m = k, k = h, h = e, e = v(n, q);
        b[0] = v(e, b[0]);
        b[1] = v(h, b[1]);
        b[2] = v(k, b[2]);
        b[3] = v(m, b[3]);
        b[4] = v(g, b[4]);
        b[5] = v(l, b[5]);
        b[6] = v(p, b[6]);
        b[7] = v(f, b[7]);
        return b;
    }
    function D(d, b) {
        var e, c, k, m, g = [], l = [];
        if (null !== d) for(c = 0; c < d.length; c += 2)b[(c >>> 1) % 5][(c >>> 1) / 5 | 0] = B(b[(c >>> 1) % 5][(c >>> 1) / 5 | 0], new a(d[c + 1], d[c]));
        for(e = 0; 24 > e; e += 1){
            m = A("SHA3-");
            for(c = 0; 5 > c; c += 1){
                k = b[c][0];
                var p = b[c][1], f = b[c][2], n = b[c][3], q = b[c][4];
                g[c] = new a(k.a ^ p.a ^ f.a ^ n.a ^ q.a, k.b ^ p.b ^ f.b ^ n.b ^ q.b);
            }
            for(c = 0; 5 > c; c += 1)l[c] = B(g[(c + 4) % 5], U(g[(c + 1) % 5], 1));
            for(c = 0; 5 > c; c += 1)for(k = 0; 5 > k; k += 1)b[c][k] = B(b[c][k], l[c]);
            for(c = 0; 5 > c; c += 1)for(k = 0; 5 > k; k += 1)m[k][(2 * c + 3 * k) % 5] = U(b[c][k], Y[c][k]);
            for(c = 0; 5 > c; c += 1)for(k = 0; 5 > k; k += 1)b[c][k] = B(m[c][k], new a(~m[(c + 1) % 5][k].a & m[(c + 2) % 5][k].a, ~m[(c + 1) % 5][k].b & m[(c + 2) % 5][k].b));
            b[0][0] = B(b[0][0], Z[e]);
        }
        return b;
    }
    var c, X, Y, Z;
    c = [
        1116352408,
        1899447441,
        3049323471,
        3921009573,
        961987163,
        1508970993,
        2453635748,
        2870763221,
        3624381080,
        310598401,
        607225278,
        1426881987,
        1925078388,
        2162078206,
        2614888103,
        3248222580,
        3835390401,
        4022224774,
        264347078,
        604807628,
        770255983,
        1249150122,
        1555081692,
        1996064986,
        2554220882,
        2821834349,
        2952996808,
        3210313671,
        3336571891,
        3584528711,
        113926993,
        338241895,
        666307205,
        773529912,
        1294757372,
        1396182291,
        1695183700,
        1986661051,
        2177026350,
        2456956037,
        2730485921,
        2820302411,
        3259730800,
        3345764771,
        3516065817,
        3600352804,
        4094571909,
        275423344,
        430227734,
        506948616,
        659060556,
        883997877,
        958139571,
        1322822218,
        1537002063,
        1747873779,
        1955562222,
        2024104815,
        2227730452,
        2361852424,
        2428436474,
        2756734187,
        3204031479,
        3329325298
    ];
    X = [
        new a(c[0], 3609767458),
        new a(c[1], 602891725),
        new a(c[2], 3964484399),
        new a(c[3], 2173295548),
        new a(c[4], 4081628472),
        new a(c[5], 3053834265),
        new a(c[6], 2937671579),
        new a(c[7], 3664609560),
        new a(c[8], 2734883394),
        new a(c[9], 1164996542),
        new a(c[10], 1323610764),
        new a(c[11], 3590304994),
        new a(c[12], 4068182383),
        new a(c[13], 991336113),
        new a(c[14], 633803317),
        new a(c[15], 3479774868),
        new a(c[16], 2666613458),
        new a(c[17], 944711139),
        new a(c[18], 2341262773),
        new a(c[19], 2007800933),
        new a(c[20], 1495990901),
        new a(c[21], 1856431235),
        new a(c[22], 3175218132),
        new a(c[23], 2198950837),
        new a(c[24], 3999719339),
        new a(c[25], 766784016),
        new a(c[26], 2566594879),
        new a(c[27], 3203337956),
        new a(c[28], 1034457026),
        new a(c[29], 2466948901),
        new a(c[30], 3758326383),
        new a(c[31], 168717936),
        new a(c[32], 1188179964),
        new a(c[33], 1546045734),
        new a(c[34], 1522805485),
        new a(c[35], 2643833823),
        new a(c[36], 2343527390),
        new a(c[37], 1014477480),
        new a(c[38], 1206759142),
        new a(c[39], 344077627),
        new a(c[40], 1290863460),
        new a(c[41], 3158454273),
        new a(c[42], 3505952657),
        new a(c[43], 106217008),
        new a(c[44], 3606008344),
        new a(c[45], 1432725776),
        new a(c[46], 1467031594),
        new a(c[47], 851169720),
        new a(c[48], 3100823752),
        new a(c[49], 1363258195),
        new a(c[50], 3750685593),
        new a(c[51], 3785050280),
        new a(c[52], 3318307427),
        new a(c[53], 3812723403),
        new a(c[54], 2003034995),
        new a(c[55], 3602036899),
        new a(c[56], 1575990012),
        new a(c[57], 1125592928),
        new a(c[58], 2716904306),
        new a(c[59], 442776044),
        new a(c[60], 593698344),
        new a(c[61], 3733110249),
        new a(c[62], 2999351573),
        new a(c[63], 3815920427),
        new a(3391569614, 3928383900),
        new a(3515267271, 566280711),
        new a(3940187606, 3454069534),
        new a(4118630271, 4000239992),
        new a(116418474, 1914138554),
        new a(174292421, 2731055270),
        new a(289380356, 3203993006),
        new a(460393269, 320620315),
        new a(685471733, 587496836),
        new a(852142971, 1086792851),
        new a(1017036298, 365543100),
        new a(1126000580, 2618297676),
        new a(1288033470, 3409855158),
        new a(1501505948, 4234509866),
        new a(1607167915, 987167468),
        new a(1816402316, 1246189591)
    ];
    Z = [
        new a(0, 1),
        new a(0, 32898),
        new a(2147483648, 32906),
        new a(2147483648, 2147516416),
        new a(0, 32907),
        new a(0, 2147483649),
        new a(2147483648, 2147516545),
        new a(2147483648, 32777),
        new a(0, 138),
        new a(0, 136),
        new a(0, 2147516425),
        new a(0, 2147483658),
        new a(0, 2147516555),
        new a(2147483648, 139),
        new a(2147483648, 32905),
        new a(2147483648, 32771),
        new a(2147483648, 32770),
        new a(2147483648, 128),
        new a(0, 32778),
        new a(2147483648, 2147483658),
        new a(2147483648, 2147516545),
        new a(2147483648, 32896),
        new a(0, 2147483649),
        new a(2147483648, 2147516424)
    ];
    Y = [
        [
            0,
            36,
            3,
            41,
            18
        ],
        [
            1,
            44,
            10,
            45,
            2
        ],
        [
            62,
            6,
            43,
            15,
            61
        ],
        [
            28,
            55,
            25,
            21,
            56
        ],
        [
            27,
            20,
            39,
            8,
            14
        ]
    ];
    "function" === typeof define && define.amd ? define(function() {
        return C;
    }) : ((0, module.exports) && (module.exports = C), exports = C);
})(this);

});

parcelRegister("4Dyi7", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("92ABP", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.6.0
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-03-02T17:08Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket #14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.6.0", // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    var Sizzle = /*!
 * Sizzle CSS Selector Engine v2.3.6
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2021-02-16
 */ function(window1) {
        var i, support, Expr, getText, isXML, tokenize, compile, select, outermostContext, sortInput, hasDuplicate, // Local document vars
        setDocument, document, docElem, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains, // Instance-specific data
        expando = "sizzle" + 1 * new Date(), preferredDoc = window1.document, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, // Instance methods
        hasOwn = {}.hasOwnProperty, arr = [], pop = arr.pop, pushNative = arr.push, push = arr.push, slice = arr.slice, // Use a stripped-down indexOf as it's faster than native
        // https://jsperf.com/thor-indexof-vs-for/5
        indexOf = function(list, elem) {
            var i = 0, len = list.length;
            for(; i < len; i++){
                if (list[i] === elem) return i;
            }
            return -1;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // http://www.w3.org/TR/css3-selectors/#whitespace
        whitespace = "[\\x20\\t\\r\\n\\f]", // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\x00-\\x7f])+", // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5]
        // or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            "ID": new RegExp("^#(" + identifier + ")"),
            "CLASS": new RegExp("^\\.(" + identifier + ")"),
            "TAG": new RegExp("^(" + identifier + "|[*])"),
            "ATTR": new RegExp("^" + attributes),
            "PSEUDO": new RegExp("^" + pseudos),
            "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            "bool": new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rhtml = /HTML$/i, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rnative = /^[^{]+\{\s*\[native \w/, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            return nonHex ? // Strip the backslash prefix from a non-hex escape sequence
            nonHex : // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // CSS string/identifier serialization
        // https://drafts.csswg.org/cssom/#common-serializing-idioms
        rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, fcssescape = function(ch, asCodePoint) {
            if (asCodePoint) {
                // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                if (ch === "\x00") return "\uFFFD";
                // Control characters and (dependent upon position) numbers get escaped as code points
                return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
            }
            // Other potentially-special ASCII characters get backslash-escaped
            return "\\" + ch;
        }, // Used for iframes
        // See setDocument()
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android<4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: arr.length ? // Leverage slice if possible
                function(target, els) {
                    pushNative.apply(target, slice.call(els));
                } : // Support: IE<9
                // Otherwise append directly
                function(target, els) {
                    var j = target.length, i = 0;
                    // Can't trust NodeList.length
                    while(target[j++] = els[i++]);
                    target.length = j - 1;
                }
            };
        }
        function Sizzle(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE, Opera, Webkit
                                // TODO: identify versions
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        results.push(elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE, Opera, Webkit
                            // TODO: identify versions
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {
                                results.push(elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (support.qsa && !nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector)) && // Support: IE 8 only
                    // Exclude object elements
                    (nodeType !== 1 || context.nodeName.toLowerCase() !== "object")) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rcombinators.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            if (newContext !== context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = nid.replace(rcssescape, fcssescape);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrim, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */ function addHandle(attrs, handler) {
            var arr = attrs.split("|"), i = arr.length;
            while(i--)Expr.attrHandle[arr[i]] = handler;
        }
        /**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */ function siblingCheck(a, b) {
            var cur = b && a, diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex;
            // Use IE sourceIndex if available on both nodes
            if (diff) return diff;
            // Check if b follows a
            if (cur) while(cur = cur.nextSibling){
                if (cur === b) return -1;
            }
            return a ? 1 : -1;
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return name === "input" && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return (name === "input" || name === "button") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        /* jshint -W018 */ elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        // Expose support vars for convenience
        support = Sizzle.support = {};
        /**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */ isXML = Sizzle.isXML = function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Support: IE <=8
            // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
            // https://bugs.jquery.com/ticket/4833
            return !rhtml.test(namespace || docElem && docElem.nodeName || "HTML");
        };
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ setDocument = Sizzle.setDocument = function(node) {
            var hasCompare, subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            docElem = document.documentElement;
            documentIsHTML = !isXML(document);
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {
                // Support: IE 11, Edge
                if (subWindow.addEventListener) subWindow.addEventListener("unload", unloadHandler, false);
                else if (subWindow.attachEvent) subWindow.attachEvent("onunload", unloadHandler);
            }
            // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
            // Safari 4 - 5 only, Opera <=11.6 - 12.x only
            // IE/Edge & older browsers don't support the :scope pseudo-class.
            // Support: Safari 6.0 only
            // Safari 6.0 supports :scope but it's an alias of :root there.
            support.scope = assert(function(el) {
                docElem.appendChild(el).appendChild(document.createElement("div"));
                return typeof el.querySelectorAll !== "undefined" && !el.querySelectorAll(":scope fieldset div").length;
            });
            /* Attributes
	---------------------------------------------------------------------- */ // Support: IE<8
            // Verify that getAttribute really returns attributes and not properties
            // (excepting IE8 booleans)
            support.attributes = assert(function(el) {
                el.className = "i";
                return !el.getAttribute("className");
            });
            /* getElement(s)By*
	---------------------------------------------------------------------- */ // Check if getElementsByTagName("*") returns only elements
            support.getElementsByTagName = assert(function(el) {
                el.appendChild(document.createComment(""));
                return !el.getElementsByTagName("*").length;
            });
            // Support: IE<9
            support.getElementsByClassName = rnative.test(document.getElementsByClassName);
            // Support: IE<10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                docElem.appendChild(el).id = expando;
                return !document.getElementsByName || !document.getElementsByName(expando).length;
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find["ID"] = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find["ID"] = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find["TAG"] = support.getElementsByTagName ? function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else if (support.qsa) return context.querySelectorAll(tag);
            } : function(tag, context) {
                var elem, tmp = [], i = 0, // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                results = context.getElementsByTagName(tag);
                // Filter out possible comments
                if (tag === "*") {
                    while(elem = results[i++])if (elem.nodeType === 1) tmp.push(elem);
                    return tmp;
                }
                return results;
            };
            // Class
            Expr.find["CLASS"] = support.getElementsByClassName && function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
            rbuggyMatches = [];
            // qSa(:focus) reports false when true (Chrome 21)
            // We allow this because of a bug in IE8/9 that throws an error
            // whenever `document.activeElement` is accessed on an iframe
            // So, we allow :focus to pass through QSA all the time to avoid the IE error
            // See https://bugs.jquery.com/ticket/13378
            rbuggyQSA = [];
            if (support.qsa = rnative.test(document.querySelectorAll)) {
                // Build QSA regex
                // Regex strategy adopted from Diego Perini
                assert(function(el) {
                    var input;
                    // Select is set to empty string on purpose
                    // This is to test IE's treatment of not explicitly
                    // setting a boolean content attribute,
                    // since its presence should be enough
                    // https://bugs.jquery.com/ticket/12359
                    docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";
                    // Support: IE8, Opera 11-12.16
                    // Nothing should be selected when empty strings follow ^= or $= or *=
                    // The test attribute must be unknown in Opera but "safe" for WinRT
                    // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                    if (el.querySelectorAll("[msallowcapture^='']").length) rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
                    // Support: IE8
                    // Boolean attributes and "value" are not treated correctly
                    if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                    // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                    if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                    // Support: IE 11+, Edge 15 - 18+
                    // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                    // Adding a temporary attribute to the document before the selection works
                    // around the issue.
                    // Interestingly, IE 10 & older don't seem to have the issue.
                    input = document.createElement("input");
                    input.setAttribute("name", "");
                    el.appendChild(input);
                    if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
                    // Webkit/Opera - :checked should return selected option elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    // IE8 throws error here and will not see later tests
                    if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                    // Support: Safari 8+, iOS 8+
                    // https://bugs.webkit.org/show_bug.cgi?id=136851
                    // In-page `selector#id sibling-combinator selector` fails
                    if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                    // Support: Firefox <=3.6 - 5 only
                    // Old Firefox doesn't throw on a badly-escaped identifier.
                    el.querySelectorAll("\\\f");
                    rbuggyQSA.push("[\\r\\n\\f]");
                });
                assert(function(el) {
                    el.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                    // Support: Windows 8 Native Apps
                    // The type and name attributes are restricted during .innerHTML assignment
                    var input = document.createElement("input");
                    input.setAttribute("type", "hidden");
                    el.appendChild(input).setAttribute("name", "D");
                    // Support: IE8
                    // Enforce case-sensitivity of name attribute
                    if (el.querySelectorAll("[name=d]").length) rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
                    // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                    // IE8 throws error here and will not see later tests
                    if (el.querySelectorAll(":enabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                    // Support: IE9-11+
                    // IE's :disabled selector does not pick up the children of disabled fieldsets
                    docElem.appendChild(el).disabled = true;
                    if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                    // Support: Opera 10 - 11 only
                    // Opera 10-11 does not throw on post-comma invalid pseudos
                    el.querySelectorAll("*,:x");
                    rbuggyQSA.push(",.*:");
                });
            }
            if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) assert(function(el) {
                // Check to see if it's possible to do matchesSelector
                // on a disconnected node (IE 9)
                support.disconnectedMatch = matches.call(el, "*");
                // This should fail with an exception
                // Gecko does not error, returns false instead
                matches.call(el, "[s!='']:x");
                rbuggyMatches.push("!=", pseudos);
            });
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
            /* Contains
	---------------------------------------------------------------------- */ hasCompare = rnative.test(docElem.compareDocumentPosition);
            // Element contains another
            // Purposefully self-exclusive
            // As in, an element does not contain itself
            contains = hasCompare || rnative.test(docElem.contains) ? function(a, b) {
                var adown = a.nodeType === 9 ? a.documentElement : a, bup = b && b.parentNode;
                return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
            } : function(a, b) {
                if (b) while(b = b.parentNode){
                    if (b === a) return true;
                }
                return false;
            };
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = hasCompare ? function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a == document || a.ownerDocument == preferredDoc && contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b == document || b.ownerDocument == preferredDoc && contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            } : function(a, b) {
                // Exit early if the nodes are identical
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                var cur, i = 0, aup = a.parentNode, bup = b.parentNode, ap = [
                    a
                ], bp = [
                    b
                ];
                // Parentless nodes are either documents or disconnected
                if (!aup || !bup) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                /* eslint-disable eqeqeq */ return a == document ? -1 : b == document ? 1 : /* eslint-enable eqeqeq */ aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                else if (aup === bup) return siblingCheck(a, b);
                // Otherwise we need full lists of their ancestors for comparison
                cur = a;
                while(cur = cur.parentNode)ap.unshift(cur);
                cur = b;
                while(cur = cur.parentNode)bp.unshift(cur);
                // Walk down the tree looking for a discrepancy
                while(ap[i] === bp[i])i++;
                return i ? // Do a sibling check if the nodes have a common ancestor
                siblingCheck(ap[i], bp[i]) : // Otherwise nodes in our document sort first
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                /* eslint-disable eqeqeq */ ap[i] == preferredDoc ? -1 : bp[i] == preferredDoc ? 1 : /* eslint-enable eqeqeq */ 0;
            };
            return document;
        };
        Sizzle.matches = function(expr, elements) {
            return Sizzle(expr, null, null, elements);
        };
        Sizzle.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (support.matchesSelector && documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return Sizzle(expr, document, null, [
                elem
            ]).length > 0;
        };
        Sizzle.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return contains(context, elem);
        };
        Sizzle.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (jQuery #13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        };
        Sizzle.escape = function(sel) {
            return (sel + "").replace(rcssescape, fcssescape);
        };
        Sizzle.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ Sizzle.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            hasDuplicate = !support.detectDuplicates;
            sortInput = !support.sortStable && results.slice(0);
            results.sort(sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)results.splice(duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        /**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */ getText = Sizzle.getText = function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += getText(node);
            else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                // Use textContent for elements
                // innerText usage removed for consistency of new lines (jQuery #11153)
                if (typeof elem.textContent === "string") return elem.textContent;
                else // Traverse its children
                for(elem = elem.firstChild; elem; elem = elem.nextSibling)ret += getText(elem);
            } else if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        };
        Expr = Sizzle.selectors = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                "ATTR": function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                "CHILD": function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) Sizzle.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) Sizzle.error(match[0]);
                    return match;
                },
                "PSEUDO": function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr["CHILD"].test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                "TAG": function(nodeNameSelector) {
                    var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                    };
                },
                "CLASS": function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                "ATTR": function(name, operator, check) {
                    return function(elem) {
                        var result = Sizzle.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        /* eslint-disable max-len */ return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
                    /* eslint-enable max-len */ };
                },
                "CHILD": function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, uniqueCache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                // ...in a gzip-friendly way
                                node = parent;
                                outerCache = node[expando] || (node[expando] = {});
                                // Support: IE <9 only
                                // Defend against cloned attroperties (jQuery gh-1709)
                                uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                cache = uniqueCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    uniqueCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    // ...in a gzip-friendly way
                                    node = elem;
                                    outerCache = node[expando] || (node[expando] = {});
                                    // Support: IE <9 only
                                    // Defend against cloned attroperties (jQuery gh-1709)
                                    uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                    cache = uniqueCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            // Support: IE <9 only
                                            // Defend against cloned attroperties (jQuery gh-1709)
                                            uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                            uniqueCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                "PSEUDO": function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // http://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as Sizzle does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                "not": markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrim, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element (issue #299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                "has": markFunction(function(selector) {
                    return function(elem) {
                        return Sizzle(selector, elem).length > 0;
                    };
                }),
                "contains": markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || getText(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // http://www.w3.org/TR/selectors/#lang-pseudo
                "lang": markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) Sizzle.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                "target": function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                "root": function(elem) {
                    return elem === docElem;
                },
                "focus": function(elem) {
                    return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                "enabled": createDisabledPseudo(false),
                "disabled": createDisabledPseudo(true),
                "checked": function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    var nodeName = elem.nodeName.toLowerCase();
                    return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
                },
                "selected": function(elem) {
                    // Accessing this property makes selected-by-default
                    // options in Safari work properly
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                "empty": function(elem) {
                    // http://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                "parent": function(elem) {
                    return !Expr.pseudos["empty"](elem);
                },
                // Element/input types
                "header": function(elem) {
                    return rheader.test(elem.nodeName);
                },
                "input": function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                "button": function(elem) {
                    var name = elem.nodeName.toLowerCase();
                    return name === "input" && elem.type === "button" || name === "button";
                },
                "text": function(elem) {
                    var attr;
                    return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && // Support: IE<8
                    // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                "first": createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                "last": createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                "eq": createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                "even": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "odd": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "lt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument > length ? length : argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "gt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos["nth"] = Expr.pseudos["eq"];
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        tokenize = Sizzle.tokenize = function(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rcombinators.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrim, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        };
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, uniqueCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        // Support: IE <9 only
                        // Defend against cloned attroperties (jQuery gh-1709)
                        uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});
                        if (skip && skip === elem.nodeName.toLowerCase()) elem = elem[dir] || elem;
                        else if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            uniqueCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)Sizzle(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems, matcherOut = matcher ? // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                [] : // ...otherwise use results directly
                results : matcherIn;
                // Find primary matches
                if (matcher) matcher(matcherIn, matcherOut, context, xml);
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element (issue #299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find["TAG"]("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: IE<9, Safari
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            results.push(elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) Sizzle.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        compile = Sizzle.compile = function(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        };
        /**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ select = Sizzle.select = function(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        };
        // One-time assignments
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Support: Chrome 14-35+
        // Always assume duplicates if they aren't passed to the comparison function
        support.detectDuplicates = !!hasDuplicate;
        // Initialize against the default document
        setDocument();
        // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        // Support: IE<8
        // Prevent attribute/property "interpolation"
        // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
        if (!assert(function(el) {
            el.innerHTML = "<a href='#'></a>";
            return el.firstChild.getAttribute("href") === "#";
        })) addHandle("type|href|height|width", function(elem, name, isXML) {
            if (!isXML) return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
        });
        // Support: IE<9
        // Use defaultValue in place of getAttribute("value")
        if (!support.attributes || !assert(function(el) {
            el.innerHTML = "<input/>";
            el.firstChild.setAttribute("value", "");
            return el.firstChild.getAttribute("value") === "";
        })) addHandle("value", function(elem, _name, isXML) {
            if (!isXML && elem.nodeName.toLowerCase() === "input") return elem.defaultValue;
        });
        // Support: IE<9
        // Use getAttributeNode to fetch booleans when getAttribute lies
        if (!assert(function(el) {
            return el.getAttribute("disabled") == null;
        })) addHandle(booleans, function(elem, name, isXML) {
            var val;
            if (!isXML) return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        });
        return Sizzle;
    }(window1);
    jQuery.find = Sizzle;
    jQuery.expr = Sizzle.selectors;
    // Deprecated
    jQuery.expr[":"] = jQuery.expr.pseudos;
    jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
    jQuery.text = Sizzle.getText;
    jQuery.isXMLDoc = Sizzle.isXML;
    jQuery.contains = Sizzle.contains;
    jQuery.escapeSelector = Sizzle.escape;
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
    // Strict HTML recognition (#11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to Sizzle
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.stackTrace);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the stack, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getStackHook) process.stackTrace = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    jQuery.Deferred.exceptionHook = function(error, stack) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See #6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (#9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see #8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (#14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (#11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (#14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (#13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (#15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (#12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    // Support: IE <=9 - 11+
    // focus() and blur() are asynchronous, except when they are no-op.
    // So expect focus to be synchronous when the element is already active,
    // and blur to be synchronous when the element is not already active.
    // (focus and blur are always synchronous in other supported browsers,
    // this just defines when we can count on it).
    function expectSync(elem, type) {
        return elem === safeActiveElement() === (type === "focus");
    }
    // Support: IE <=9 only
    // Accessing document.activeElement can throw unexpectedly
    // https://bugs.jquery.com/ticket/13393
    function safeActiveElement() {
        try {
            return document.activeElement;
        } catch (err) {}
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (#13208)
                // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (#13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", returnTrue);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, expectSync) {
        // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
        if (!expectSync) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var notAsync, result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    // Saved data should be false in such cases, but might be a leftover capture object
                    // from an async native handler (gh-4350)
                    if (!saved.length) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        // Support: IE <=9 - 11+
                        // focus() and blur() are asynchronous
                        notAsync = expectSync(this, type);
                        this[type]();
                        result = dataPriv.get(this, type);
                        if (saved !== result || notAsync) dataPriv.set(this, type, false);
                        else result = {};
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            // Support: Chrome 86+
                            // In Chrome, if an element having a focusout handler is blurred by
                            // clicking outside of it, it invokes the handler synchronously. If
                            // that handler calls `.remove()` on the element, the data is cleared,
                            // leaving `result` undefined. We need to guard against this.
                            return result && result.value;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering the
                    // native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved.length) {
                    // ...and capture the result
                    dataPriv.set(this, type, {
                        value: jQuery.event.trigger(// Support: IE <=9 - 11+
                        // Extend with the prototype to reset the above stopImmediatePropagation()
                        jQuery.extend(saved[0], jQuery.Event.prototype), saved.slice(1), this)
                    });
                    // Abort handling of the native event
                    event.stopImmediatePropagation();
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (#504, #13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, expectSync);
                // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            // Suppress native focus or blur as it's already being fired
            // in leverageNative.
            _default: function() {
                return true;
            },
            delegateType: delegateType
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (#8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Reenable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (#8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is display: block
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, #12537)
        //   .css('--customProperty) (#3144)
        if (computed) {
            ret = computed.getPropertyValue(name) || computed[name];
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, rcustomProp = /^--/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            if (box === "margin") delta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            "animationIterationCount": true,
            "columnCount": true,
            "fillOpacity": true,
            "flexGrow": true,
            "flexShrink": true,
            "fontWeight": true,
            "gridArea": true,
            "gridColumn": true,
            "gridColumnEnd": true,
            "gridColumnStart": true,
            "gridRow": true,
            "gridRowEnd": true,
            "gridRowStart": true,
            "lineHeight": true,
            "opacity": true,
            "order": true,
            "orphans": true,
            "widows": true,
            "zIndex": true,
            "zoom": true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (#7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug #9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (#7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    // https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
                    // Use proper attribute retrieval(#12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classes, elem, cur, curValue, clazz, j, finalValue, i = 0;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classes = classesToArray(value);
            if (classes.length) while(elem = this[i++]){
                curValue = getClass(elem);
                cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    j = 0;
                    while(clazz = classes[j++])if (cur.indexOf(" " + clazz + " ") < 0) cur += clazz + " ";
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) elem.setAttribute("class", finalValue);
                }
            }
            return this;
        },
        removeClass: function(value) {
            var classes, elem, cur, curValue, clazz, j, finalValue, i = 0;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classes = classesToArray(value);
            if (classes.length) while(elem = this[i++]){
                curValue = getClass(elem);
                // This expression is here for better compressibility (see addClass)
                cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    j = 0;
                    while(clazz = classes[j++])// Remove *all* instances
                    while(cur.indexOf(" " + clazz + " ") > -1)cur = cur.replace(" " + clazz + " ", " ");
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) elem.setAttribute("class", finalValue);
                }
            }
            return this;
        },
        toggleClass: function(value, stateVal) {
            var type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            return this.each(function() {
                var className, i, self, classNames;
                if (isValidValue) {
                    // Toggle individual class names
                    i = 0;
                    self = jQuery(this);
                    classNames = classesToArray(value);
                    while(className = classNames[i++])// Check each className given, space separated list
                    if (self.hasClass(className)) self.removeClass(className);
                    else self.addClass(className);
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (#14686, #14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (#2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    support.focusin = "onfocusin" in window1;
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (#9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (#6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    // Support: Firefox <=44
    // Firefox doesn't have focus(in | out) events
    // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
    //
    // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
    // focus(in | out) events fire after focus & blur events,
    // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
    // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
    if (!support.focusin) jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(orig, fix) {
        // Attach a single capturing handler on the document while someone wants focusin/focusout
        var handler = function(event) {
            jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
        };
        jQuery.event.special[fix] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, attaches = dataPriv.access(doc, fix);
                if (!attaches) doc.addEventListener(orig, handler, true);
                dataPriv.access(doc, fix, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, attaches = dataPriv.access(doc, fix) - 1;
                if (!attaches) {
                    doc.removeEventListener(orig, handler, true);
                    dataPriv.remove(doc, fix);
                } else dataPriv.access(doc, fix, attaches);
            }
        };
    });
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // #7653, #8125, #8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes #9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (#10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket #12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // #9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (#11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // #1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see #8605, #14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // #14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (#13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("ejSM7", function(module, exports) {
//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i;
        for(i = 0; i < arr.length; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentProperties.length > 0) for(i = 0; i < momentProperties.length; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key;
                for(i = 0; i < arguments.length; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i;
            for(i = 0; i < prioritized.length; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        for(i = 0; i < token.length; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias("month", "M");
    // PRIORITY
    addUnitPriority("month", 8);
    // PARSING
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ""));
            longPieces.push(this.months(mom, ""));
            mixedPieces.push(this.months(mom, ""));
            mixedPieces.push(this.monthsShort(mom, ""));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // ALIASES
    addUnitAlias("year", "y");
    // PRIORITIES
    addUnitPriority("year", 1);
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // ALIASES
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    // PRIORITIES
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    // PARSING
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // ALIASES
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    // PRIORITY
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // ALIASES
    addUnitAlias("hour", "h");
    // PRIORITY
    addUnitPriority("hour", 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDates.length; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimes.length; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false;
        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < config._f.length; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < ordering.length; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    // PRIORITY
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // ALIASES
    addUnitAlias("quarter", "Q");
    // PRIORITY
    addUnitPriority("quarter", 7);
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // ALIASES
    addUnitAlias("date", "D");
    // PRIORITY
    addUnitPriority("date", 9);
    // PARSING
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // ALIASES
    addUnitAlias("dayOfYear", "DDD");
    // PRIORITY
    addUnitPriority("dayOfYear", 4);
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // ALIASES
    addUnitAlias("minute", "m");
    // PRIORITY
    addUnitPriority("minute", 14);
    // PARSING
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // ALIASES
    addUnitAlias("second", "s");
    // PRIORITY
    addUnitPriority("second", 15);
    // PARSING
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias("millisecond", "ms");
    // PRIORITY
    addUnitPriority("millisecond", 16);
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.29.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("jt1nG", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bdkFk"));

});
parcelRegister("bdkFk", function(module, exports) {

$parcel$export(module.exports, "Children", () => $82a0f06228d8c641$export$dca3b0875bd9a954, (v) => $82a0f06228d8c641$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $82a0f06228d8c641$export$16fa2f45be04daa8, (v) => $82a0f06228d8c641$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $82a0f06228d8c641$export$ffb0004e005737fa, (v) => $82a0f06228d8c641$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $82a0f06228d8c641$export$e2c29f18771995cb, (v) => $82a0f06228d8c641$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $82a0f06228d8c641$export$221d75b3f55bb0bd, (v) => $82a0f06228d8c641$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $82a0f06228d8c641$export$5f8d39834fd61797, (v) => $82a0f06228d8c641$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $82a0f06228d8c641$export$74bf444e3cd11ea5, (v) => $82a0f06228d8c641$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $82a0f06228d8c641$export$ae55be85d98224ed, (v) => $82a0f06228d8c641$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $82a0f06228d8c641$export$e530037191fcd5d7, (v) => $82a0f06228d8c641$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $82a0f06228d8c641$export$fd42f52fd3ae1109, (v) => $82a0f06228d8c641$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $82a0f06228d8c641$export$c8a8987d4410bf2d, (v) => $82a0f06228d8c641$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $82a0f06228d8c641$export$d38cd72104c1f0e9, (v) => $82a0f06228d8c641$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $82a0f06228d8c641$export$7d1e3a5e95ceca43, (v) => $82a0f06228d8c641$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $82a0f06228d8c641$export$257a8862b851cb5b, (v) => $82a0f06228d8c641$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $82a0f06228d8c641$export$a8257692ac88316c, (v) => $82a0f06228d8c641$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $82a0f06228d8c641$export$488013bae63b21da, (v) => $82a0f06228d8c641$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $82a0f06228d8c641$export$7c73462e0d25e514, (v) => $82a0f06228d8c641$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $82a0f06228d8c641$export$35808ee640e87ca7, (v) => $82a0f06228d8c641$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $82a0f06228d8c641$export$fae74005e78b1a27, (v) => $82a0f06228d8c641$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $82a0f06228d8c641$export$dc8fbce3eb94dc1e, (v) => $82a0f06228d8c641$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $82a0f06228d8c641$export$6d9c69b0de29b591, (v) => $82a0f06228d8c641$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $82a0f06228d8c641$export$d5a552a76deda3c2, (v) => $82a0f06228d8c641$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $82a0f06228d8c641$export$e5c5a5f917a5871c, (v) => $82a0f06228d8c641$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $82a0f06228d8c641$export$1538c33de8887b59, (v) => $82a0f06228d8c641$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $82a0f06228d8c641$export$13e3392192263954, (v) => $82a0f06228d8c641$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $82a0f06228d8c641$export$b8f5890fc79d6aca, (v) => $82a0f06228d8c641$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $82a0f06228d8c641$export$60241385465d0a34, (v) => $82a0f06228d8c641$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $82a0f06228d8c641$export$83d89fbfd8236492, (v) => $82a0f06228d8c641$export$83d89fbfd8236492 = v);
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $82a0f06228d8c641$export$dca3b0875bd9a954;
var $82a0f06228d8c641$export$16fa2f45be04daa8;
var $82a0f06228d8c641$export$ffb0004e005737fa;
var $82a0f06228d8c641$export$e2c29f18771995cb;
var $82a0f06228d8c641$export$221d75b3f55bb0bd;
var $82a0f06228d8c641$export$5f8d39834fd61797;
var $82a0f06228d8c641$export$74bf444e3cd11ea5;
var $82a0f06228d8c641$export$ae55be85d98224ed;
var $82a0f06228d8c641$export$e530037191fcd5d7;
var $82a0f06228d8c641$export$fd42f52fd3ae1109;
var $82a0f06228d8c641$export$c8a8987d4410bf2d;
var $82a0f06228d8c641$export$d38cd72104c1f0e9;
var $82a0f06228d8c641$export$7d1e3a5e95ceca43;
var $82a0f06228d8c641$export$257a8862b851cb5b;
var $82a0f06228d8c641$export$a8257692ac88316c;
var $82a0f06228d8c641$export$488013bae63b21da;
var $82a0f06228d8c641$export$7c73462e0d25e514;
var $82a0f06228d8c641$export$35808ee640e87ca7;
var $82a0f06228d8c641$export$fae74005e78b1a27;
var $82a0f06228d8c641$export$dc8fbce3eb94dc1e;
var $82a0f06228d8c641$export$6d9c69b0de29b591;
var $82a0f06228d8c641$export$d5a552a76deda3c2;
var $82a0f06228d8c641$export$e5c5a5f917a5871c;
var $82a0f06228d8c641$export$1538c33de8887b59;
var $82a0f06228d8c641$export$13e3392192263954;
var $82a0f06228d8c641$export$b8f5890fc79d6aca;
var $82a0f06228d8c641$export$60241385465d0a34;
var $82a0f06228d8c641$export$83d89fbfd8236492;
"use strict";

var $5imMc = parcelRequire("5imMc");
var $82a0f06228d8c641$var$n = "function" === typeof Symbol && Symbol.for, $82a0f06228d8c641$var$p = $82a0f06228d8c641$var$n ? Symbol.for("react.element") : 60103, $82a0f06228d8c641$var$q = $82a0f06228d8c641$var$n ? Symbol.for("react.portal") : 60106, $82a0f06228d8c641$var$r = $82a0f06228d8c641$var$n ? Symbol.for("react.fragment") : 60107, $82a0f06228d8c641$var$t = $82a0f06228d8c641$var$n ? Symbol.for("react.strict_mode") : 60108, $82a0f06228d8c641$var$u = $82a0f06228d8c641$var$n ? Symbol.for("react.profiler") : 60114, $82a0f06228d8c641$var$v = $82a0f06228d8c641$var$n ? Symbol.for("react.provider") : 60109, $82a0f06228d8c641$var$w = $82a0f06228d8c641$var$n ? Symbol.for("react.context") : 60110, $82a0f06228d8c641$var$x = $82a0f06228d8c641$var$n ? Symbol.for("react.forward_ref") : 60112, $82a0f06228d8c641$var$y = $82a0f06228d8c641$var$n ? Symbol.for("react.suspense") : 60113, $82a0f06228d8c641$var$z = $82a0f06228d8c641$var$n ? Symbol.for("react.memo") : 60115, $82a0f06228d8c641$var$A = $82a0f06228d8c641$var$n ? Symbol.for("react.lazy") : 60116, $82a0f06228d8c641$var$B = "function" === typeof Symbol && Symbol.iterator;
function $82a0f06228d8c641$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $82a0f06228d8c641$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $82a0f06228d8c641$var$E = {};
function $82a0f06228d8c641$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $82a0f06228d8c641$var$E;
    this.updater = c || $82a0f06228d8c641$var$D;
}
$82a0f06228d8c641$var$F.prototype.isReactComponent = {};
$82a0f06228d8c641$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($82a0f06228d8c641$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$82a0f06228d8c641$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $82a0f06228d8c641$var$G() {}
$82a0f06228d8c641$var$G.prototype = $82a0f06228d8c641$var$F.prototype;
function $82a0f06228d8c641$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $82a0f06228d8c641$var$E;
    this.updater = c || $82a0f06228d8c641$var$D;
}
var $82a0f06228d8c641$var$I = $82a0f06228d8c641$var$H.prototype = new $82a0f06228d8c641$var$G;
$82a0f06228d8c641$var$I.constructor = $82a0f06228d8c641$var$H;
$5imMc($82a0f06228d8c641$var$I, $82a0f06228d8c641$var$F.prototype);
$82a0f06228d8c641$var$I.isPureReactComponent = !0;
var $82a0f06228d8c641$var$J = {
    current: null
}, $82a0f06228d8c641$var$K = Object.prototype.hasOwnProperty, $82a0f06228d8c641$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $82a0f06228d8c641$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$82a0f06228d8c641$var$K.call(b, e) && !$82a0f06228d8c641$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $82a0f06228d8c641$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $82a0f06228d8c641$var$J.current
    };
}
function $82a0f06228d8c641$var$N(a, b) {
    return {
        $$typeof: $82a0f06228d8c641$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $82a0f06228d8c641$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $82a0f06228d8c641$var$p;
}
function $82a0f06228d8c641$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $82a0f06228d8c641$var$P = /\/+/g, $82a0f06228d8c641$var$Q = [];
function $82a0f06228d8c641$var$R(a, b, c, e) {
    if ($82a0f06228d8c641$var$Q.length) {
        var d = $82a0f06228d8c641$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $82a0f06228d8c641$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $82a0f06228d8c641$var$Q.length && $82a0f06228d8c641$var$Q.push(a);
}
function $82a0f06228d8c641$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $82a0f06228d8c641$var$p:
                case $82a0f06228d8c641$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $82a0f06228d8c641$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $82a0f06228d8c641$var$U(d, k);
        g += $82a0f06228d8c641$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $82a0f06228d8c641$var$B && a[$82a0f06228d8c641$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $82a0f06228d8c641$var$U(d, k++), g += $82a0f06228d8c641$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($82a0f06228d8c641$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $82a0f06228d8c641$var$V(a, b, c) {
    return null == a ? 0 : $82a0f06228d8c641$var$T(a, "", b, c);
}
function $82a0f06228d8c641$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $82a0f06228d8c641$var$escape(a.key) : b.toString(36);
}
function $82a0f06228d8c641$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $82a0f06228d8c641$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $82a0f06228d8c641$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($82a0f06228d8c641$var$O(a) && (a = $82a0f06228d8c641$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($82a0f06228d8c641$var$P, "$&/") + "/") + c)), e.push(a));
}
function $82a0f06228d8c641$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($82a0f06228d8c641$var$P, "$&/") + "/");
    b = $82a0f06228d8c641$var$R(b, g, e, d);
    $82a0f06228d8c641$var$V(a, $82a0f06228d8c641$var$aa, b);
    $82a0f06228d8c641$var$S(b);
}
var $82a0f06228d8c641$var$Y = {
    current: null
};
function $82a0f06228d8c641$var$Z() {
    var a = $82a0f06228d8c641$var$Y.current;
    if (null === a) throw Error($82a0f06228d8c641$var$C(321));
    return a;
}
var $82a0f06228d8c641$var$ba = {
    ReactCurrentDispatcher: $82a0f06228d8c641$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $82a0f06228d8c641$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $5imMc
};
$82a0f06228d8c641$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $82a0f06228d8c641$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $82a0f06228d8c641$var$R(null, null, b, c);
        $82a0f06228d8c641$var$V(a, $82a0f06228d8c641$var$W, b);
        $82a0f06228d8c641$var$S(b);
    },
    count: function(a) {
        return $82a0f06228d8c641$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $82a0f06228d8c641$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$82a0f06228d8c641$var$O(a)) throw Error($82a0f06228d8c641$var$C(143));
        return a;
    }
};
$82a0f06228d8c641$export$16fa2f45be04daa8 = $82a0f06228d8c641$var$F;
$82a0f06228d8c641$export$ffb0004e005737fa = $82a0f06228d8c641$var$r;
$82a0f06228d8c641$export$e2c29f18771995cb = $82a0f06228d8c641$var$u;
$82a0f06228d8c641$export$221d75b3f55bb0bd = $82a0f06228d8c641$var$H;
$82a0f06228d8c641$export$5f8d39834fd61797 = $82a0f06228d8c641$var$t;
$82a0f06228d8c641$export$74bf444e3cd11ea5 = $82a0f06228d8c641$var$y;
$82a0f06228d8c641$export$ae55be85d98224ed = $82a0f06228d8c641$var$ba;
$82a0f06228d8c641$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($82a0f06228d8c641$var$C(267, a));
    var e = $5imMc({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $82a0f06228d8c641$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$82a0f06228d8c641$var$K.call(b, h) && !$82a0f06228d8c641$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $82a0f06228d8c641$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$82a0f06228d8c641$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $82a0f06228d8c641$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $82a0f06228d8c641$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$82a0f06228d8c641$export$c8a8987d4410bf2d = $82a0f06228d8c641$var$M;
$82a0f06228d8c641$export$d38cd72104c1f0e9 = function(a) {
    var b = $82a0f06228d8c641$var$M.bind(null, a);
    b.type = a;
    return b;
};
$82a0f06228d8c641$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$82a0f06228d8c641$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $82a0f06228d8c641$var$x,
        render: a
    };
};
$82a0f06228d8c641$export$a8257692ac88316c = $82a0f06228d8c641$var$O;
$82a0f06228d8c641$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $82a0f06228d8c641$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$82a0f06228d8c641$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $82a0f06228d8c641$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$82a0f06228d8c641$export$35808ee640e87ca7 = function(a, b) {
    return $82a0f06228d8c641$var$Z().useCallback(a, b);
};
$82a0f06228d8c641$export$fae74005e78b1a27 = function(a, b) {
    return $82a0f06228d8c641$var$Z().useContext(a, b);
};
$82a0f06228d8c641$export$dc8fbce3eb94dc1e = function() {};
$82a0f06228d8c641$export$6d9c69b0de29b591 = function(a, b) {
    return $82a0f06228d8c641$var$Z().useEffect(a, b);
};
$82a0f06228d8c641$export$d5a552a76deda3c2 = function(a, b, c) {
    return $82a0f06228d8c641$var$Z().useImperativeHandle(a, b, c);
};
$82a0f06228d8c641$export$e5c5a5f917a5871c = function(a, b) {
    return $82a0f06228d8c641$var$Z().useLayoutEffect(a, b);
};
$82a0f06228d8c641$export$1538c33de8887b59 = function(a, b) {
    return $82a0f06228d8c641$var$Z().useMemo(a, b);
};
$82a0f06228d8c641$export$13e3392192263954 = function(a, b, c) {
    return $82a0f06228d8c641$var$Z().useReducer(a, b, c);
};
$82a0f06228d8c641$export$b8f5890fc79d6aca = function(a) {
    return $82a0f06228d8c641$var$Z().useRef(a);
};
$82a0f06228d8c641$export$60241385465d0a34 = function(a) {
    return $82a0f06228d8c641$var$Z().useState(a);
};
$82a0f06228d8c641$export$83d89fbfd8236492 = "16.14.0";

});


parcelRegister("4ndnV", function(module, exports) {
module.exports = $32f3b15cfd80ad23$var$Paginator;
// Paginator constructor
//
// `per_page` is the number of results per page, `length` is the number of
// pages to display. They default to `25` and `10` respectively.
function $32f3b15cfd80ad23$var$Paginator(per_page, length) {
    // You really should be calling this with `new Paginator`, but WHATEVER.
    if (!(this instanceof $32f3b15cfd80ad23$var$Paginator)) return new $32f3b15cfd80ad23$var$Paginator(per_page, length);
    // Woo, defaults!
    this.per_page = per_page || 25;
    this.length = length || 10;
}
// Build an object with all the necessary information for outputting pagination
// controls.
//
// (new Paginator(paginator.build(100, 2)
$32f3b15cfd80ad23$var$Paginator.prototype.build = function(total_results, current_page) {
    // We want the number of pages, rounded up to the nearest page.
    var total_pages = Math.ceil(total_results / this.per_page);
    // Ensure both total_results and current_page are treated as Numbers
    total_results = parseInt(total_results, 10);
    current_page = parseInt(current_page, 10) || 1;
    // Obviously we can't be on a negative or 0 page.
    if (current_page < 1) current_page = 1;
    // If the user has done something like /page/99999 we want to clamp that back
    // down.
    if (current_page > total_pages) current_page = total_pages;
    // This is the first page to be displayed as a numbered link.
    var first_page = Math.max(1, current_page - Math.floor(this.length / 2));
    // And here's the last page to be displayed specifically.
    var last_page = Math.min(total_pages, current_page + Math.floor(this.length / 2));
    // This is triggered if we're at or near one of the extremes; we won't have
    // enough page links. We need to adjust our bounds accordingly.
    if (last_page - first_page + 1 < this.length) {
        if (current_page < total_pages / 2) last_page = Math.min(total_pages, last_page + (this.length - (last_page - first_page)));
        else first_page = Math.max(1, first_page - (this.length - (last_page - first_page)));
    }
    // This can be triggered if the user wants an odd number of pages.
    if (last_page - first_page + 1 > this.length) {
        // We want to move towards whatever extreme we're closest to at the time.
        if (current_page > total_pages / 2) first_page++;
        else last_page--;
    }
    // First result on the page. This, along with the field below, can be used to
    // do "showing x to y of z results" style things.
    var first_result = this.per_page * (current_page - 1);
    if (first_result < 0) first_result = 0;
    // Last result on the page.
    var last_result = this.per_page * current_page - 1;
    if (last_result < 0) last_result = 0;
    if (last_result > Math.max(total_results - 1, 0)) last_result = Math.max(total_results - 1, 0);
    // GIMME THAT OBJECT
    return {
        total_pages: total_pages,
        pages: Math.min(last_page - first_page + 1, total_pages),
        current_page: current_page,
        first_page: first_page,
        last_page: last_page,
        previous_page: current_page - 1,
        next_page: current_page + 1,
        has_previous_page: current_page > 1,
        has_next_page: current_page < total_pages,
        total_results: total_results,
        results: Math.min(last_result - first_result + 1, total_results),
        first_result: first_result,
        last_result: last_result
    };
};

});

parcelRegister("61x14", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $462c726dd24a4899$var$_react = $462c726dd24a4899$var$_interopRequireWildcard((parcelRequire("jt1nG")));

var $462c726dd24a4899$var$_propTypes = $462c726dd24a4899$var$_interopRequireDefault((parcelRequire("4L3zM")));

var $462c726dd24a4899$var$_classnames = $462c726dd24a4899$var$_interopRequireDefault((parcelRequire("9A5xi")));
function $462c726dd24a4899$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $462c726dd24a4899$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $462c726dd24a4899$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $462c726dd24a4899$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $462c726dd24a4899$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $462c726dd24a4899$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $462c726dd24a4899$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $462c726dd24a4899$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $462c726dd24a4899$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $462c726dd24a4899$var$_typeof(obj);
}
function $462c726dd24a4899$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $462c726dd24a4899$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $462c726dd24a4899$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $462c726dd24a4899$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $462c726dd24a4899$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $462c726dd24a4899$var$_possibleConstructorReturn(self, call) {
    if (call && ($462c726dd24a4899$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $462c726dd24a4899$var$_assertThisInitialized(self);
}
function $462c726dd24a4899$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $462c726dd24a4899$var$_getPrototypeOf(o) {
    $462c726dd24a4899$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $462c726dd24a4899$var$_getPrototypeOf(o);
}
function $462c726dd24a4899$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $462c726dd24a4899$var$_setPrototypeOf(subClass, superClass);
}
function $462c726dd24a4899$var$_setPrototypeOf(o, p) {
    $462c726dd24a4899$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $462c726dd24a4899$var$_setPrototypeOf(o, p);
}
function $462c726dd24a4899$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $462c726dd24a4899$var$Page = /*#__PURE__*/ function(_Component) {
    $462c726dd24a4899$var$_inherits(Page, _Component);
    function Page() {
        $462c726dd24a4899$var$_classCallCheck(this, Page);
        return $462c726dd24a4899$var$_possibleConstructorReturn(this, $462c726dd24a4899$var$_getPrototypeOf(Page).apply(this, arguments));
    }
    $462c726dd24a4899$var$_createClass(Page, [
        {
            key: "handleClick",
            value: function handleClick(e) {
                var _this$props = this.props, isDisabled = _this$props.isDisabled, pageNumber = _this$props.pageNumber;
                e.preventDefault();
                if (isDisabled) return;
                this.props.onClick(pageNumber);
            }
        },
        {
            key: "render",
            value: function render() {
                var _cx;
                var _this$props2 = this.props, pageText = _this$props2.pageText, pageNumber = _this$props2.pageNumber, activeClass = _this$props2.activeClass, itemClass = _this$props2.itemClass, linkClass = _this$props2.linkClass, activeLinkClass = _this$props2.activeLinkClass, disabledClass = _this$props2.disabledClass, isActive = _this$props2.isActive, isDisabled = _this$props2.isDisabled, href = _this$props2.href, ariaLabel = _this$props2.ariaLabel;
                var css = (0, $462c726dd24a4899$var$_classnames["default"])(itemClass, (_cx = {}, $462c726dd24a4899$var$_defineProperty(_cx, activeClass, isActive), $462c726dd24a4899$var$_defineProperty(_cx, disabledClass, isDisabled), _cx));
                var linkCss = (0, $462c726dd24a4899$var$_classnames["default"])(linkClass, $462c726dd24a4899$var$_defineProperty({}, activeLinkClass, isActive));
                return $462c726dd24a4899$var$_react["default"].createElement("li", {
                    className: css,
                    onClick: this.handleClick.bind(this)
                }, $462c726dd24a4899$var$_react["default"].createElement("a", {
                    className: linkCss,
                    href: href,
                    "aria-label": ariaLabel
                }, pageText));
            }
        }
    ]);
    return Page;
}($462c726dd24a4899$var$_react.Component);
module.exports["default"] = $462c726dd24a4899$var$Page;
$462c726dd24a4899$var$_defineProperty($462c726dd24a4899$var$Page, "propTypes", {
    pageText: $462c726dd24a4899$var$_propTypes["default"].oneOfType([
        $462c726dd24a4899$var$_propTypes["default"].string,
        $462c726dd24a4899$var$_propTypes["default"].element
    ]),
    pageNumber: $462c726dd24a4899$var$_propTypes["default"].number.isRequired,
    onClick: $462c726dd24a4899$var$_propTypes["default"].func.isRequired,
    isActive: $462c726dd24a4899$var$_propTypes["default"].bool.isRequired,
    isDisabled: $462c726dd24a4899$var$_propTypes["default"].bool,
    activeClass: $462c726dd24a4899$var$_propTypes["default"].string,
    activeLinkClass: $462c726dd24a4899$var$_propTypes["default"].string,
    itemClass: $462c726dd24a4899$var$_propTypes["default"].string,
    linkClass: $462c726dd24a4899$var$_propTypes["default"].string,
    disabledClass: $462c726dd24a4899$var$_propTypes["default"].string,
    href: $462c726dd24a4899$var$_propTypes["default"].string
});
$462c726dd24a4899$var$_defineProperty($462c726dd24a4899$var$Page, "defaultProps", {
    activeClass: "active",
    disabledClass: "disabled",
    itemClass: undefined,
    linkClass: undefined,
    activeLinkCLass: undefined,
    isActive: false,
    isDisabled: false,
    href: "#"
});

});

parcelRegister("lb2du", function(module, exports) {

/*!
 * Chart.js v2.9.4
 * https://www.chartjs.org
 * (c) 2020 Chart.js Contributors
 * Released under the MIT License
 */ (function(global, factory) {
    module.exports = factory(function() {
        try {
            return (parcelRequire("ejSM7"));
        } catch (e) {}
    }());
})(module.exports, function(moment) {
    "use strict";
    moment = moment && moment.hasOwnProperty("default") ? moment["default"] : moment;
    function createCommonjsModule(fn, module1) {
        return module1 = {
            exports: {}
        }, fn(module1, module1.exports), module1.exports;
    }
    function getCjsExportFromNamespace(n) {
        return n && n["default"] || n;
    }
    var colorName = {
        "aliceblue": [
            240,
            248,
            255
        ],
        "antiquewhite": [
            250,
            235,
            215
        ],
        "aqua": [
            0,
            255,
            255
        ],
        "aquamarine": [
            127,
            255,
            212
        ],
        "azure": [
            240,
            255,
            255
        ],
        "beige": [
            245,
            245,
            220
        ],
        "bisque": [
            255,
            228,
            196
        ],
        "black": [
            0,
            0,
            0
        ],
        "blanchedalmond": [
            255,
            235,
            205
        ],
        "blue": [
            0,
            0,
            255
        ],
        "blueviolet": [
            138,
            43,
            226
        ],
        "brown": [
            165,
            42,
            42
        ],
        "burlywood": [
            222,
            184,
            135
        ],
        "cadetblue": [
            95,
            158,
            160
        ],
        "chartreuse": [
            127,
            255,
            0
        ],
        "chocolate": [
            210,
            105,
            30
        ],
        "coral": [
            255,
            127,
            80
        ],
        "cornflowerblue": [
            100,
            149,
            237
        ],
        "cornsilk": [
            255,
            248,
            220
        ],
        "crimson": [
            220,
            20,
            60
        ],
        "cyan": [
            0,
            255,
            255
        ],
        "darkblue": [
            0,
            0,
            139
        ],
        "darkcyan": [
            0,
            139,
            139
        ],
        "darkgoldenrod": [
            184,
            134,
            11
        ],
        "darkgray": [
            169,
            169,
            169
        ],
        "darkgreen": [
            0,
            100,
            0
        ],
        "darkgrey": [
            169,
            169,
            169
        ],
        "darkkhaki": [
            189,
            183,
            107
        ],
        "darkmagenta": [
            139,
            0,
            139
        ],
        "darkolivegreen": [
            85,
            107,
            47
        ],
        "darkorange": [
            255,
            140,
            0
        ],
        "darkorchid": [
            153,
            50,
            204
        ],
        "darkred": [
            139,
            0,
            0
        ],
        "darksalmon": [
            233,
            150,
            122
        ],
        "darkseagreen": [
            143,
            188,
            143
        ],
        "darkslateblue": [
            72,
            61,
            139
        ],
        "darkslategray": [
            47,
            79,
            79
        ],
        "darkslategrey": [
            47,
            79,
            79
        ],
        "darkturquoise": [
            0,
            206,
            209
        ],
        "darkviolet": [
            148,
            0,
            211
        ],
        "deeppink": [
            255,
            20,
            147
        ],
        "deepskyblue": [
            0,
            191,
            255
        ],
        "dimgray": [
            105,
            105,
            105
        ],
        "dimgrey": [
            105,
            105,
            105
        ],
        "dodgerblue": [
            30,
            144,
            255
        ],
        "firebrick": [
            178,
            34,
            34
        ],
        "floralwhite": [
            255,
            250,
            240
        ],
        "forestgreen": [
            34,
            139,
            34
        ],
        "fuchsia": [
            255,
            0,
            255
        ],
        "gainsboro": [
            220,
            220,
            220
        ],
        "ghostwhite": [
            248,
            248,
            255
        ],
        "gold": [
            255,
            215,
            0
        ],
        "goldenrod": [
            218,
            165,
            32
        ],
        "gray": [
            128,
            128,
            128
        ],
        "green": [
            0,
            128,
            0
        ],
        "greenyellow": [
            173,
            255,
            47
        ],
        "grey": [
            128,
            128,
            128
        ],
        "honeydew": [
            240,
            255,
            240
        ],
        "hotpink": [
            255,
            105,
            180
        ],
        "indianred": [
            205,
            92,
            92
        ],
        "indigo": [
            75,
            0,
            130
        ],
        "ivory": [
            255,
            255,
            240
        ],
        "khaki": [
            240,
            230,
            140
        ],
        "lavender": [
            230,
            230,
            250
        ],
        "lavenderblush": [
            255,
            240,
            245
        ],
        "lawngreen": [
            124,
            252,
            0
        ],
        "lemonchiffon": [
            255,
            250,
            205
        ],
        "lightblue": [
            173,
            216,
            230
        ],
        "lightcoral": [
            240,
            128,
            128
        ],
        "lightcyan": [
            224,
            255,
            255
        ],
        "lightgoldenrodyellow": [
            250,
            250,
            210
        ],
        "lightgray": [
            211,
            211,
            211
        ],
        "lightgreen": [
            144,
            238,
            144
        ],
        "lightgrey": [
            211,
            211,
            211
        ],
        "lightpink": [
            255,
            182,
            193
        ],
        "lightsalmon": [
            255,
            160,
            122
        ],
        "lightseagreen": [
            32,
            178,
            170
        ],
        "lightskyblue": [
            135,
            206,
            250
        ],
        "lightslategray": [
            119,
            136,
            153
        ],
        "lightslategrey": [
            119,
            136,
            153
        ],
        "lightsteelblue": [
            176,
            196,
            222
        ],
        "lightyellow": [
            255,
            255,
            224
        ],
        "lime": [
            0,
            255,
            0
        ],
        "limegreen": [
            50,
            205,
            50
        ],
        "linen": [
            250,
            240,
            230
        ],
        "magenta": [
            255,
            0,
            255
        ],
        "maroon": [
            128,
            0,
            0
        ],
        "mediumaquamarine": [
            102,
            205,
            170
        ],
        "mediumblue": [
            0,
            0,
            205
        ],
        "mediumorchid": [
            186,
            85,
            211
        ],
        "mediumpurple": [
            147,
            112,
            219
        ],
        "mediumseagreen": [
            60,
            179,
            113
        ],
        "mediumslateblue": [
            123,
            104,
            238
        ],
        "mediumspringgreen": [
            0,
            250,
            154
        ],
        "mediumturquoise": [
            72,
            209,
            204
        ],
        "mediumvioletred": [
            199,
            21,
            133
        ],
        "midnightblue": [
            25,
            25,
            112
        ],
        "mintcream": [
            245,
            255,
            250
        ],
        "mistyrose": [
            255,
            228,
            225
        ],
        "moccasin": [
            255,
            228,
            181
        ],
        "navajowhite": [
            255,
            222,
            173
        ],
        "navy": [
            0,
            0,
            128
        ],
        "oldlace": [
            253,
            245,
            230
        ],
        "olive": [
            128,
            128,
            0
        ],
        "olivedrab": [
            107,
            142,
            35
        ],
        "orange": [
            255,
            165,
            0
        ],
        "orangered": [
            255,
            69,
            0
        ],
        "orchid": [
            218,
            112,
            214
        ],
        "palegoldenrod": [
            238,
            232,
            170
        ],
        "palegreen": [
            152,
            251,
            152
        ],
        "paleturquoise": [
            175,
            238,
            238
        ],
        "palevioletred": [
            219,
            112,
            147
        ],
        "papayawhip": [
            255,
            239,
            213
        ],
        "peachpuff": [
            255,
            218,
            185
        ],
        "peru": [
            205,
            133,
            63
        ],
        "pink": [
            255,
            192,
            203
        ],
        "plum": [
            221,
            160,
            221
        ],
        "powderblue": [
            176,
            224,
            230
        ],
        "purple": [
            128,
            0,
            128
        ],
        "rebeccapurple": [
            102,
            51,
            153
        ],
        "red": [
            255,
            0,
            0
        ],
        "rosybrown": [
            188,
            143,
            143
        ],
        "royalblue": [
            65,
            105,
            225
        ],
        "saddlebrown": [
            139,
            69,
            19
        ],
        "salmon": [
            250,
            128,
            114
        ],
        "sandybrown": [
            244,
            164,
            96
        ],
        "seagreen": [
            46,
            139,
            87
        ],
        "seashell": [
            255,
            245,
            238
        ],
        "sienna": [
            160,
            82,
            45
        ],
        "silver": [
            192,
            192,
            192
        ],
        "skyblue": [
            135,
            206,
            235
        ],
        "slateblue": [
            106,
            90,
            205
        ],
        "slategray": [
            112,
            128,
            144
        ],
        "slategrey": [
            112,
            128,
            144
        ],
        "snow": [
            255,
            250,
            250
        ],
        "springgreen": [
            0,
            255,
            127
        ],
        "steelblue": [
            70,
            130,
            180
        ],
        "tan": [
            210,
            180,
            140
        ],
        "teal": [
            0,
            128,
            128
        ],
        "thistle": [
            216,
            191,
            216
        ],
        "tomato": [
            255,
            99,
            71
        ],
        "turquoise": [
            64,
            224,
            208
        ],
        "violet": [
            238,
            130,
            238
        ],
        "wheat": [
            245,
            222,
            179
        ],
        "white": [
            255,
            255,
            255
        ],
        "whitesmoke": [
            245,
            245,
            245
        ],
        "yellow": [
            255,
            255,
            0
        ],
        "yellowgreen": [
            154,
            205,
            50
        ]
    };
    var conversions = createCommonjsModule(function(module1) {
        /* MIT license */ // NOTE: conversions should only return primitive values (i.e. arrays, or
        //       values that give correct `typeof` results).
        //       do not use box values types (i.e. Number(), String(), etc.)
        var reverseKeywords = {};
        for(var key in colorName)if (colorName.hasOwnProperty(key)) reverseKeywords[colorName[key]] = key;
        var convert = module1.exports = {
            rgb: {
                channels: 3,
                labels: "rgb"
            },
            hsl: {
                channels: 3,
                labels: "hsl"
            },
            hsv: {
                channels: 3,
                labels: "hsv"
            },
            hwb: {
                channels: 3,
                labels: "hwb"
            },
            cmyk: {
                channels: 4,
                labels: "cmyk"
            },
            xyz: {
                channels: 3,
                labels: "xyz"
            },
            lab: {
                channels: 3,
                labels: "lab"
            },
            lch: {
                channels: 3,
                labels: "lch"
            },
            hex: {
                channels: 1,
                labels: [
                    "hex"
                ]
            },
            keyword: {
                channels: 1,
                labels: [
                    "keyword"
                ]
            },
            ansi16: {
                channels: 1,
                labels: [
                    "ansi16"
                ]
            },
            ansi256: {
                channels: 1,
                labels: [
                    "ansi256"
                ]
            },
            hcg: {
                channels: 3,
                labels: [
                    "h",
                    "c",
                    "g"
                ]
            },
            apple: {
                channels: 3,
                labels: [
                    "r16",
                    "g16",
                    "b16"
                ]
            },
            gray: {
                channels: 1,
                labels: [
                    "gray"
                ]
            }
        };
        // hide .channels and .labels properties
        for(var model in convert)if (convert.hasOwnProperty(model)) {
            if (!("channels" in convert[model])) throw new Error("missing channels property: " + model);
            if (!("labels" in convert[model])) throw new Error("missing channel labels property: " + model);
            if (convert[model].labels.length !== convert[model].channels) throw new Error("channel and label counts mismatch: " + model);
            var channels = convert[model].channels;
            var labels = convert[model].labels;
            delete convert[model].channels;
            delete convert[model].labels;
            Object.defineProperty(convert[model], "channels", {
                value: channels
            });
            Object.defineProperty(convert[model], "labels", {
                value: labels
            });
        }
        convert.rgb.hsl = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var min = Math.min(r, g, b);
            var max = Math.max(r, g, b);
            var delta = max - min;
            var h;
            var s;
            var l;
            if (max === min) h = 0;
            else if (r === max) h = (g - b) / delta;
            else if (g === max) h = 2 + (b - r) / delta;
            else if (b === max) h = 4 + (r - g) / delta;
            h = Math.min(h * 60, 360);
            if (h < 0) h += 360;
            l = (min + max) / 2;
            if (max === min) s = 0;
            else if (l <= 0.5) s = delta / (max + min);
            else s = delta / (2 - max - min);
            return [
                h,
                s * 100,
                l * 100
            ];
        };
        convert.rgb.hsv = function(rgb) {
            var rdif;
            var gdif;
            var bdif;
            var h;
            var s;
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var v = Math.max(r, g, b);
            var diff = v - Math.min(r, g, b);
            var diffc = function(c) {
                return (v - c) / 6 / diff + 0.5;
            };
            if (diff === 0) h = s = 0;
            else {
                s = diff / v;
                rdif = diffc(r);
                gdif = diffc(g);
                bdif = diffc(b);
                if (r === v) h = bdif - gdif;
                else if (g === v) h = 1 / 3 + rdif - bdif;
                else if (b === v) h = 2 / 3 + gdif - rdif;
                if (h < 0) h += 1;
                else if (h > 1) h -= 1;
            }
            return [
                h * 360,
                s * 100,
                v * 100
            ];
        };
        convert.rgb.hwb = function(rgb) {
            var r = rgb[0];
            var g = rgb[1];
            var b = rgb[2];
            var h = convert.rgb.hsl(rgb)[0];
            var w = 1 / 255 * Math.min(r, Math.min(g, b));
            b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
            return [
                h,
                w * 100,
                b * 100
            ];
        };
        convert.rgb.cmyk = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var c;
            var m;
            var y;
            var k;
            k = Math.min(1 - r, 1 - g, 1 - b);
            c = (1 - r - k) / (1 - k) || 0;
            m = (1 - g - k) / (1 - k) || 0;
            y = (1 - b - k) / (1 - k) || 0;
            return [
                c * 100,
                m * 100,
                y * 100,
                k * 100
            ];
        };
        /**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */ function comparativeDistance(x, y) {
            return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
        }
        convert.rgb.keyword = function(rgb) {
            var reversed = reverseKeywords[rgb];
            if (reversed) return reversed;
            var currentClosestDistance = Infinity;
            var currentClosestKeyword;
            for(var keyword in colorName)if (colorName.hasOwnProperty(keyword)) {
                var value = colorName[keyword];
                // Compute comparative distance
                var distance = comparativeDistance(rgb, value);
                // Check if its less, if so set as closest
                if (distance < currentClosestDistance) {
                    currentClosestDistance = distance;
                    currentClosestKeyword = keyword;
                }
            }
            return currentClosestKeyword;
        };
        convert.keyword.rgb = function(keyword) {
            return colorName[keyword];
        };
        convert.rgb.xyz = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            // assume sRGB
            r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
            g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
            b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
            var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
            var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
            var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
            return [
                x * 100,
                y * 100,
                z * 100
            ];
        };
        convert.rgb.lab = function(rgb) {
            var xyz = convert.rgb.xyz(rgb);
            var x = xyz[0];
            var y = xyz[1];
            var z = xyz[2];
            var l;
            var a;
            var b;
            x /= 95.047;
            y /= 100;
            z /= 108.883;
            x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
            y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
            z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
            l = 116 * y - 16;
            a = 500 * (x - y);
            b = 200 * (y - z);
            return [
                l,
                a,
                b
            ];
        };
        convert.hsl.rgb = function(hsl) {
            var h = hsl[0] / 360;
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var t1;
            var t2;
            var t3;
            var rgb;
            var val;
            if (s === 0) {
                val = l * 255;
                return [
                    val,
                    val,
                    val
                ];
            }
            if (l < 0.5) t2 = l * (1 + s);
            else t2 = l + s - l * s;
            t1 = 2 * l - t2;
            rgb = [
                0,
                0,
                0
            ];
            for(var i = 0; i < 3; i++){
                t3 = h + 1 / 3 * -(i - 1);
                if (t3 < 0) t3++;
                if (t3 > 1) t3--;
                if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
                else if (2 * t3 < 1) val = t2;
                else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                else val = t1;
                rgb[i] = val * 255;
            }
            return rgb;
        };
        convert.hsl.hsv = function(hsl) {
            var h = hsl[0];
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var smin = s;
            var lmin = Math.max(l, 0.01);
            var sv;
            var v;
            l *= 2;
            s *= l <= 1 ? l : 2 - l;
            smin *= lmin <= 1 ? lmin : 2 - lmin;
            v = (l + s) / 2;
            sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
            return [
                h,
                sv * 100,
                v * 100
            ];
        };
        convert.hsv.rgb = function(hsv) {
            var h = hsv[0] / 60;
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var hi = Math.floor(h) % 6;
            var f = h - Math.floor(h);
            var p = 255 * v * (1 - s);
            var q = 255 * v * (1 - s * f);
            var t = 255 * v * (1 - s * (1 - f));
            v *= 255;
            switch(hi){
                case 0:
                    return [
                        v,
                        t,
                        p
                    ];
                case 1:
                    return [
                        q,
                        v,
                        p
                    ];
                case 2:
                    return [
                        p,
                        v,
                        t
                    ];
                case 3:
                    return [
                        p,
                        q,
                        v
                    ];
                case 4:
                    return [
                        t,
                        p,
                        v
                    ];
                case 5:
                    return [
                        v,
                        p,
                        q
                    ];
            }
        };
        convert.hsv.hsl = function(hsv) {
            var h = hsv[0];
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var vmin = Math.max(v, 0.01);
            var lmin;
            var sl;
            var l;
            l = (2 - s) * v;
            lmin = (2 - s) * vmin;
            sl = s * vmin;
            sl /= lmin <= 1 ? lmin : 2 - lmin;
            sl = sl || 0;
            l /= 2;
            return [
                h,
                sl * 100,
                l * 100
            ];
        };
        // http://dev.w3.org/csswg/css-color/#hwb-to-rgb
        convert.hwb.rgb = function(hwb) {
            var h = hwb[0] / 360;
            var wh = hwb[1] / 100;
            var bl = hwb[2] / 100;
            var ratio = wh + bl;
            var i;
            var v;
            var f;
            var n;
            // wh + bl cant be > 1
            if (ratio > 1) {
                wh /= ratio;
                bl /= ratio;
            }
            i = Math.floor(6 * h);
            v = 1 - bl;
            f = 6 * h - i;
            if ((i & 0x01) !== 0) f = 1 - f;
            n = wh + f * (v - wh); // linear interpolation
            var r;
            var g;
            var b;
            switch(i){
                default:
                case 6:
                case 0:
                    r = v;
                    g = n;
                    b = wh;
                    break;
                case 1:
                    r = n;
                    g = v;
                    b = wh;
                    break;
                case 2:
                    r = wh;
                    g = v;
                    b = n;
                    break;
                case 3:
                    r = wh;
                    g = n;
                    b = v;
                    break;
                case 4:
                    r = n;
                    g = wh;
                    b = v;
                    break;
                case 5:
                    r = v;
                    g = wh;
                    b = n;
                    break;
            }
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.cmyk.rgb = function(cmyk) {
            var c = cmyk[0] / 100;
            var m = cmyk[1] / 100;
            var y = cmyk[2] / 100;
            var k = cmyk[3] / 100;
            var r;
            var g;
            var b;
            r = 1 - Math.min(1, c * (1 - k) + k);
            g = 1 - Math.min(1, m * (1 - k) + k);
            b = 1 - Math.min(1, y * (1 - k) + k);
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.xyz.rgb = function(xyz) {
            var x = xyz[0] / 100;
            var y = xyz[1] / 100;
            var z = xyz[2] / 100;
            var r;
            var g;
            var b;
            r = x * 3.2406 + y * -1.5372 + z * -0.4986;
            g = x * -0.9689 + y * 1.8758 + z * 0.0415;
            b = x * 0.0557 + y * -0.204 + z * 1.0570;
            // assume sRGB
            r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
            g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
            b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
            r = Math.min(Math.max(0, r), 1);
            g = Math.min(Math.max(0, g), 1);
            b = Math.min(Math.max(0, b), 1);
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.xyz.lab = function(xyz) {
            var x = xyz[0];
            var y = xyz[1];
            var z = xyz[2];
            var l;
            var a;
            var b;
            x /= 95.047;
            y /= 100;
            z /= 108.883;
            x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
            y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
            z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
            l = 116 * y - 16;
            a = 500 * (x - y);
            b = 200 * (y - z);
            return [
                l,
                a,
                b
            ];
        };
        convert.lab.xyz = function(lab) {
            var l = lab[0];
            var a = lab[1];
            var b = lab[2];
            var x;
            var y;
            var z;
            y = (l + 16) / 116;
            x = a / 500 + y;
            z = y - b / 200;
            var y2 = Math.pow(y, 3);
            var x2 = Math.pow(x, 3);
            var z2 = Math.pow(z, 3);
            y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
            x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
            z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
            x *= 95.047;
            y *= 100;
            z *= 108.883;
            return [
                x,
                y,
                z
            ];
        };
        convert.lab.lch = function(lab) {
            var l = lab[0];
            var a = lab[1];
            var b = lab[2];
            var hr;
            var h;
            var c;
            hr = Math.atan2(b, a);
            h = hr * 360 / 2 / Math.PI;
            if (h < 0) h += 360;
            c = Math.sqrt(a * a + b * b);
            return [
                l,
                c,
                h
            ];
        };
        convert.lch.lab = function(lch) {
            var l = lch[0];
            var c = lch[1];
            var h = lch[2];
            var a;
            var b;
            var hr;
            hr = h / 360 * 2 * Math.PI;
            a = c * Math.cos(hr);
            b = c * Math.sin(hr);
            return [
                l,
                a,
                b
            ];
        };
        convert.rgb.ansi16 = function(args) {
            var r = args[0];
            var g = args[1];
            var b = args[2];
            var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
            value = Math.round(value / 50);
            if (value === 0) return 30;
            var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
            if (value === 2) ansi += 60;
            return ansi;
        };
        convert.hsv.ansi16 = function(args) {
            // optimization here; we already know the value and don't need to get
            // it converted for us.
            return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
        };
        convert.rgb.ansi256 = function(args) {
            var r = args[0];
            var g = args[1];
            var b = args[2];
            // we use the extended greyscale palette here, with the exception of
            // black and white. normal palette only has 4 greyscale shades.
            if (r === g && g === b) {
                if (r < 8) return 16;
                if (r > 248) return 231;
                return Math.round((r - 8) / 247 * 24) + 232;
            }
            var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
            return ansi;
        };
        convert.ansi16.rgb = function(args) {
            var color = args % 10;
            // handle greyscale
            if (color === 0 || color === 7) {
                if (args > 50) color += 3.5;
                color = color / 10.5 * 255;
                return [
                    color,
                    color,
                    color
                ];
            }
            var mult = (~~(args > 50) + 1) * 0.5;
            var r = (color & 1) * mult * 255;
            var g = (color >> 1 & 1) * mult * 255;
            var b = (color >> 2 & 1) * mult * 255;
            return [
                r,
                g,
                b
            ];
        };
        convert.ansi256.rgb = function(args) {
            // handle greyscale
            if (args >= 232) {
                var c = (args - 232) * 10 + 8;
                return [
                    c,
                    c,
                    c
                ];
            }
            args -= 16;
            var rem;
            var r = Math.floor(args / 36) / 5 * 255;
            var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
            var b = rem % 6 / 5 * 255;
            return [
                r,
                g,
                b
            ];
        };
        convert.rgb.hex = function(args) {
            var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
            var string = integer.toString(16).toUpperCase();
            return "000000".substring(string.length) + string;
        };
        convert.hex.rgb = function(args) {
            var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
            if (!match) return [
                0,
                0,
                0
            ];
            var colorString = match[0];
            if (match[0].length === 3) colorString = colorString.split("").map(function(char) {
                return char + char;
            }).join("");
            var integer = parseInt(colorString, 16);
            var r = integer >> 16 & 0xFF;
            var g = integer >> 8 & 0xFF;
            var b = integer & 0xFF;
            return [
                r,
                g,
                b
            ];
        };
        convert.rgb.hcg = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var max = Math.max(Math.max(r, g), b);
            var min = Math.min(Math.min(r, g), b);
            var chroma = max - min;
            var grayscale;
            var hue;
            if (chroma < 1) grayscale = min / (1 - chroma);
            else grayscale = 0;
            if (chroma <= 0) hue = 0;
            else if (max === r) hue = (g - b) / chroma % 6;
            else if (max === g) hue = 2 + (b - r) / chroma;
            else hue = 4 + (r - g) / chroma + 4;
            hue /= 6;
            hue %= 1;
            return [
                hue * 360,
                chroma * 100,
                grayscale * 100
            ];
        };
        convert.hsl.hcg = function(hsl) {
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var c = 1;
            var f = 0;
            if (l < 0.5) c = 2.0 * s * l;
            else c = 2.0 * s * (1.0 - l);
            if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
            return [
                hsl[0],
                c * 100,
                f * 100
            ];
        };
        convert.hsv.hcg = function(hsv) {
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var c = s * v;
            var f = 0;
            if (c < 1.0) f = (v - c) / (1 - c);
            return [
                hsv[0],
                c * 100,
                f * 100
            ];
        };
        convert.hcg.rgb = function(hcg) {
            var h = hcg[0] / 360;
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            if (c === 0.0) return [
                g * 255,
                g * 255,
                g * 255
            ];
            var pure = [
                0,
                0,
                0
            ];
            var hi = h % 1 * 6;
            var v = hi % 1;
            var w = 1 - v;
            var mg = 0;
            switch(Math.floor(hi)){
                case 0:
                    pure[0] = 1;
                    pure[1] = v;
                    pure[2] = 0;
                    break;
                case 1:
                    pure[0] = w;
                    pure[1] = 1;
                    pure[2] = 0;
                    break;
                case 2:
                    pure[0] = 0;
                    pure[1] = 1;
                    pure[2] = v;
                    break;
                case 3:
                    pure[0] = 0;
                    pure[1] = w;
                    pure[2] = 1;
                    break;
                case 4:
                    pure[0] = v;
                    pure[1] = 0;
                    pure[2] = 1;
                    break;
                default:
                    pure[0] = 1;
                    pure[1] = 0;
                    pure[2] = w;
            }
            mg = (1.0 - c) * g;
            return [
                (c * pure[0] + mg) * 255,
                (c * pure[1] + mg) * 255,
                (c * pure[2] + mg) * 255
            ];
        };
        convert.hcg.hsv = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var v = c + g * (1.0 - c);
            var f = 0;
            if (v > 0.0) f = c / v;
            return [
                hcg[0],
                f * 100,
                v * 100
            ];
        };
        convert.hcg.hsl = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var l = g * (1.0 - c) + 0.5 * c;
            var s = 0;
            if (l > 0.0 && l < 0.5) s = c / (2 * l);
            else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
            return [
                hcg[0],
                s * 100,
                l * 100
            ];
        };
        convert.hcg.hwb = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var v = c + g * (1.0 - c);
            return [
                hcg[0],
                (v - c) * 100,
                (1 - v) * 100
            ];
        };
        convert.hwb.hcg = function(hwb) {
            var w = hwb[1] / 100;
            var b = hwb[2] / 100;
            var v = 1 - b;
            var c = v - w;
            var g = 0;
            if (c < 1) g = (v - c) / (1 - c);
            return [
                hwb[0],
                c * 100,
                g * 100
            ];
        };
        convert.apple.rgb = function(apple) {
            return [
                apple[0] / 65535 * 255,
                apple[1] / 65535 * 255,
                apple[2] / 65535 * 255
            ];
        };
        convert.rgb.apple = function(rgb) {
            return [
                rgb[0] / 255 * 65535,
                rgb[1] / 255 * 65535,
                rgb[2] / 255 * 65535
            ];
        };
        convert.gray.rgb = function(args) {
            return [
                args[0] / 100 * 255,
                args[0] / 100 * 255,
                args[0] / 100 * 255
            ];
        };
        convert.gray.hsl = convert.gray.hsv = function(args) {
            return [
                0,
                0,
                args[0]
            ];
        };
        convert.gray.hwb = function(gray) {
            return [
                0,
                100,
                gray[0]
            ];
        };
        convert.gray.cmyk = function(gray) {
            return [
                0,
                0,
                0,
                gray[0]
            ];
        };
        convert.gray.lab = function(gray) {
            return [
                gray[0],
                0,
                0
            ];
        };
        convert.gray.hex = function(gray) {
            var val = Math.round(gray[0] / 100 * 255) & 0xFF;
            var integer = (val << 16) + (val << 8) + val;
            var string = integer.toString(16).toUpperCase();
            return "000000".substring(string.length) + string;
        };
        convert.rgb.gray = function(rgb) {
            var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
            return [
                val / 255 * 100
            ];
        };
    });
    var conversions_1 = conversions.rgb;
    var conversions_2 = conversions.hsl;
    var conversions_3 = conversions.hsv;
    var conversions_4 = conversions.hwb;
    var conversions_5 = conversions.cmyk;
    var conversions_6 = conversions.xyz;
    var conversions_7 = conversions.lab;
    var conversions_8 = conversions.lch;
    var conversions_9 = conversions.hex;
    var conversions_10 = conversions.keyword;
    var conversions_11 = conversions.ansi16;
    var conversions_12 = conversions.ansi256;
    var conversions_13 = conversions.hcg;
    var conversions_14 = conversions.apple;
    var conversions_15 = conversions.gray;
    /*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function buildGraph() {
        var graph = {};
        // https://jsperf.com/object-keys-vs-for-in-with-closure/3
        var models = Object.keys(conversions);
        for(var len = models.length, i = 0; i < len; i++)graph[models[i]] = {
            // http://jsperf.com/1-vs-infinity
            // micro-opt, but this is simple.
            distance: -1,
            parent: null
        };
        return graph;
    }
    // https://en.wikipedia.org/wiki/Breadth-first_search
    function deriveBFS(fromModel) {
        var graph = buildGraph();
        var queue = [
            fromModel
        ]; // unshift -> queue -> pop
        graph[fromModel].distance = 0;
        while(queue.length){
            var current = queue.pop();
            var adjacents = Object.keys(conversions[current]);
            for(var len = adjacents.length, i = 0; i < len; i++){
                var adjacent = adjacents[i];
                var node = graph[adjacent];
                if (node.distance === -1) {
                    node.distance = graph[current].distance + 1;
                    node.parent = current;
                    queue.unshift(adjacent);
                }
            }
        }
        return graph;
    }
    function link(from, to) {
        return function(args) {
            return to(from(args));
        };
    }
    function wrapConversion(toModel, graph) {
        var path = [
            graph[toModel].parent,
            toModel
        ];
        var fn = conversions[graph[toModel].parent][toModel];
        var cur = graph[toModel].parent;
        while(graph[cur].parent){
            path.unshift(graph[cur].parent);
            fn = link(conversions[graph[cur].parent][cur], fn);
            cur = graph[cur].parent;
        }
        fn.conversion = path;
        return fn;
    }
    var route = function(fromModel) {
        var graph = deriveBFS(fromModel);
        var conversion = {};
        var models = Object.keys(graph);
        for(var len = models.length, i = 0; i < len; i++){
            var toModel = models[i];
            var node = graph[toModel];
            if (node.parent === null) continue;
            conversion[toModel] = wrapConversion(toModel, graph);
        }
        return conversion;
    };
    var convert = {};
    var models = Object.keys(conversions);
    function wrapRaw(fn) {
        var wrappedFn = function(args) {
            if (args === undefined || args === null) return args;
            if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
            return fn(args);
        };
        // preserve .conversion property if there is one
        if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
        return wrappedFn;
    }
    function wrapRounded(fn) {
        var wrappedFn = function(args) {
            if (args === undefined || args === null) return args;
            if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
            var result = fn(args);
            // we're assuming the result is an array here.
            // see notice in conversions.js; don't use box types
            // in conversion functions.
            if (typeof result === "object") for(var len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
            return result;
        };
        // preserve .conversion property if there is one
        if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
        return wrappedFn;
    }
    models.forEach(function(fromModel) {
        convert[fromModel] = {};
        Object.defineProperty(convert[fromModel], "channels", {
            value: conversions[fromModel].channels
        });
        Object.defineProperty(convert[fromModel], "labels", {
            value: conversions[fromModel].labels
        });
        var routes = route(fromModel);
        var routeModels = Object.keys(routes);
        routeModels.forEach(function(toModel) {
            var fn = routes[toModel];
            convert[fromModel][toModel] = wrapRounded(fn);
            convert[fromModel][toModel].raw = wrapRaw(fn);
        });
    });
    var colorConvert = convert;
    var colorName$1 = {
        "aliceblue": [
            240,
            248,
            255
        ],
        "antiquewhite": [
            250,
            235,
            215
        ],
        "aqua": [
            0,
            255,
            255
        ],
        "aquamarine": [
            127,
            255,
            212
        ],
        "azure": [
            240,
            255,
            255
        ],
        "beige": [
            245,
            245,
            220
        ],
        "bisque": [
            255,
            228,
            196
        ],
        "black": [
            0,
            0,
            0
        ],
        "blanchedalmond": [
            255,
            235,
            205
        ],
        "blue": [
            0,
            0,
            255
        ],
        "blueviolet": [
            138,
            43,
            226
        ],
        "brown": [
            165,
            42,
            42
        ],
        "burlywood": [
            222,
            184,
            135
        ],
        "cadetblue": [
            95,
            158,
            160
        ],
        "chartreuse": [
            127,
            255,
            0
        ],
        "chocolate": [
            210,
            105,
            30
        ],
        "coral": [
            255,
            127,
            80
        ],
        "cornflowerblue": [
            100,
            149,
            237
        ],
        "cornsilk": [
            255,
            248,
            220
        ],
        "crimson": [
            220,
            20,
            60
        ],
        "cyan": [
            0,
            255,
            255
        ],
        "darkblue": [
            0,
            0,
            139
        ],
        "darkcyan": [
            0,
            139,
            139
        ],
        "darkgoldenrod": [
            184,
            134,
            11
        ],
        "darkgray": [
            169,
            169,
            169
        ],
        "darkgreen": [
            0,
            100,
            0
        ],
        "darkgrey": [
            169,
            169,
            169
        ],
        "darkkhaki": [
            189,
            183,
            107
        ],
        "darkmagenta": [
            139,
            0,
            139
        ],
        "darkolivegreen": [
            85,
            107,
            47
        ],
        "darkorange": [
            255,
            140,
            0
        ],
        "darkorchid": [
            153,
            50,
            204
        ],
        "darkred": [
            139,
            0,
            0
        ],
        "darksalmon": [
            233,
            150,
            122
        ],
        "darkseagreen": [
            143,
            188,
            143
        ],
        "darkslateblue": [
            72,
            61,
            139
        ],
        "darkslategray": [
            47,
            79,
            79
        ],
        "darkslategrey": [
            47,
            79,
            79
        ],
        "darkturquoise": [
            0,
            206,
            209
        ],
        "darkviolet": [
            148,
            0,
            211
        ],
        "deeppink": [
            255,
            20,
            147
        ],
        "deepskyblue": [
            0,
            191,
            255
        ],
        "dimgray": [
            105,
            105,
            105
        ],
        "dimgrey": [
            105,
            105,
            105
        ],
        "dodgerblue": [
            30,
            144,
            255
        ],
        "firebrick": [
            178,
            34,
            34
        ],
        "floralwhite": [
            255,
            250,
            240
        ],
        "forestgreen": [
            34,
            139,
            34
        ],
        "fuchsia": [
            255,
            0,
            255
        ],
        "gainsboro": [
            220,
            220,
            220
        ],
        "ghostwhite": [
            248,
            248,
            255
        ],
        "gold": [
            255,
            215,
            0
        ],
        "goldenrod": [
            218,
            165,
            32
        ],
        "gray": [
            128,
            128,
            128
        ],
        "green": [
            0,
            128,
            0
        ],
        "greenyellow": [
            173,
            255,
            47
        ],
        "grey": [
            128,
            128,
            128
        ],
        "honeydew": [
            240,
            255,
            240
        ],
        "hotpink": [
            255,
            105,
            180
        ],
        "indianred": [
            205,
            92,
            92
        ],
        "indigo": [
            75,
            0,
            130
        ],
        "ivory": [
            255,
            255,
            240
        ],
        "khaki": [
            240,
            230,
            140
        ],
        "lavender": [
            230,
            230,
            250
        ],
        "lavenderblush": [
            255,
            240,
            245
        ],
        "lawngreen": [
            124,
            252,
            0
        ],
        "lemonchiffon": [
            255,
            250,
            205
        ],
        "lightblue": [
            173,
            216,
            230
        ],
        "lightcoral": [
            240,
            128,
            128
        ],
        "lightcyan": [
            224,
            255,
            255
        ],
        "lightgoldenrodyellow": [
            250,
            250,
            210
        ],
        "lightgray": [
            211,
            211,
            211
        ],
        "lightgreen": [
            144,
            238,
            144
        ],
        "lightgrey": [
            211,
            211,
            211
        ],
        "lightpink": [
            255,
            182,
            193
        ],
        "lightsalmon": [
            255,
            160,
            122
        ],
        "lightseagreen": [
            32,
            178,
            170
        ],
        "lightskyblue": [
            135,
            206,
            250
        ],
        "lightslategray": [
            119,
            136,
            153
        ],
        "lightslategrey": [
            119,
            136,
            153
        ],
        "lightsteelblue": [
            176,
            196,
            222
        ],
        "lightyellow": [
            255,
            255,
            224
        ],
        "lime": [
            0,
            255,
            0
        ],
        "limegreen": [
            50,
            205,
            50
        ],
        "linen": [
            250,
            240,
            230
        ],
        "magenta": [
            255,
            0,
            255
        ],
        "maroon": [
            128,
            0,
            0
        ],
        "mediumaquamarine": [
            102,
            205,
            170
        ],
        "mediumblue": [
            0,
            0,
            205
        ],
        "mediumorchid": [
            186,
            85,
            211
        ],
        "mediumpurple": [
            147,
            112,
            219
        ],
        "mediumseagreen": [
            60,
            179,
            113
        ],
        "mediumslateblue": [
            123,
            104,
            238
        ],
        "mediumspringgreen": [
            0,
            250,
            154
        ],
        "mediumturquoise": [
            72,
            209,
            204
        ],
        "mediumvioletred": [
            199,
            21,
            133
        ],
        "midnightblue": [
            25,
            25,
            112
        ],
        "mintcream": [
            245,
            255,
            250
        ],
        "mistyrose": [
            255,
            228,
            225
        ],
        "moccasin": [
            255,
            228,
            181
        ],
        "navajowhite": [
            255,
            222,
            173
        ],
        "navy": [
            0,
            0,
            128
        ],
        "oldlace": [
            253,
            245,
            230
        ],
        "olive": [
            128,
            128,
            0
        ],
        "olivedrab": [
            107,
            142,
            35
        ],
        "orange": [
            255,
            165,
            0
        ],
        "orangered": [
            255,
            69,
            0
        ],
        "orchid": [
            218,
            112,
            214
        ],
        "palegoldenrod": [
            238,
            232,
            170
        ],
        "palegreen": [
            152,
            251,
            152
        ],
        "paleturquoise": [
            175,
            238,
            238
        ],
        "palevioletred": [
            219,
            112,
            147
        ],
        "papayawhip": [
            255,
            239,
            213
        ],
        "peachpuff": [
            255,
            218,
            185
        ],
        "peru": [
            205,
            133,
            63
        ],
        "pink": [
            255,
            192,
            203
        ],
        "plum": [
            221,
            160,
            221
        ],
        "powderblue": [
            176,
            224,
            230
        ],
        "purple": [
            128,
            0,
            128
        ],
        "rebeccapurple": [
            102,
            51,
            153
        ],
        "red": [
            255,
            0,
            0
        ],
        "rosybrown": [
            188,
            143,
            143
        ],
        "royalblue": [
            65,
            105,
            225
        ],
        "saddlebrown": [
            139,
            69,
            19
        ],
        "salmon": [
            250,
            128,
            114
        ],
        "sandybrown": [
            244,
            164,
            96
        ],
        "seagreen": [
            46,
            139,
            87
        ],
        "seashell": [
            255,
            245,
            238
        ],
        "sienna": [
            160,
            82,
            45
        ],
        "silver": [
            192,
            192,
            192
        ],
        "skyblue": [
            135,
            206,
            235
        ],
        "slateblue": [
            106,
            90,
            205
        ],
        "slategray": [
            112,
            128,
            144
        ],
        "slategrey": [
            112,
            128,
            144
        ],
        "snow": [
            255,
            250,
            250
        ],
        "springgreen": [
            0,
            255,
            127
        ],
        "steelblue": [
            70,
            130,
            180
        ],
        "tan": [
            210,
            180,
            140
        ],
        "teal": [
            0,
            128,
            128
        ],
        "thistle": [
            216,
            191,
            216
        ],
        "tomato": [
            255,
            99,
            71
        ],
        "turquoise": [
            64,
            224,
            208
        ],
        "violet": [
            238,
            130,
            238
        ],
        "wheat": [
            245,
            222,
            179
        ],
        "white": [
            255,
            255,
            255
        ],
        "whitesmoke": [
            245,
            245,
            245
        ],
        "yellow": [
            255,
            255,
            0
        ],
        "yellowgreen": [
            154,
            205,
            50
        ]
    };
    /* MIT license */ var colorString = {
        getRgba: getRgba,
        getHsla: getHsla,
        getRgb: getRgb,
        getHsl: getHsl,
        getHwb: getHwb,
        getAlpha: getAlpha,
        hexString: hexString,
        rgbString: rgbString,
        rgbaString: rgbaString,
        percentString: percentString,
        percentaString: percentaString,
        hslString: hslString,
        hslaString: hslaString,
        hwbString: hwbString,
        keyword: keyword
    };
    function getRgba(string) {
        if (!string) return;
        var abbr = /^#([a-fA-F0-9]{3,4})$/i, hex = /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i, rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i, per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i, keyword = /(\w+)/;
        var rgb = [
            0,
            0,
            0
        ], a = 1, match = string.match(abbr), hexAlpha = "";
        if (match) {
            match = match[1];
            hexAlpha = match[3];
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i] + match[i], 16);
            if (hexAlpha) a = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
        } else if (match = string.match(hex)) {
            hexAlpha = match[2];
            match = match[1];
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
            if (hexAlpha) a = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
        } else if (match = string.match(rgba)) {
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i + 1]);
            a = parseFloat(match[4]);
        } else if (match = string.match(per)) {
            for(var i = 0; i < rgb.length; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
            a = parseFloat(match[4]);
        } else if (match = string.match(keyword)) {
            if (match[1] == "transparent") return [
                0,
                0,
                0,
                0
            ];
            rgb = colorName$1[match[1]];
            if (!rgb) return;
        }
        for(var i = 0; i < rgb.length; i++)rgb[i] = scale(rgb[i], 0, 255);
        if (!a && a != 0) a = 1;
        else a = scale(a, 0, 1);
        rgb[3] = a;
        return rgb;
    }
    function getHsla(string) {
        if (!string) return;
        var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
        var match = string.match(hsl);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = scale(parseInt(match[1]), 0, 360), s = scale(parseFloat(match[2]), 0, 100), l = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [
                h,
                s,
                l,
                a
            ];
        }
    }
    function getHwb(string) {
        if (!string) return;
        var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
        var match = string.match(hwb);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = scale(parseInt(match[1]), 0, 360), w = scale(parseFloat(match[2]), 0, 100), b = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [
                h,
                w,
                b,
                a
            ];
        }
    }
    function getRgb(string) {
        var rgba = getRgba(string);
        return rgba && rgba.slice(0, 3);
    }
    function getHsl(string) {
        var hsla = getHsla(string);
        return hsla && hsla.slice(0, 3);
    }
    function getAlpha(string) {
        var vals = getRgba(string);
        if (vals) return vals[3];
        else if (vals = getHsla(string)) return vals[3];
        else if (vals = getHwb(string)) return vals[3];
    }
    // generators
    function hexString(rgba, a) {
        var a = a !== undefined && rgba.length === 3 ? a : rgba[3];
        return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (a >= 0 && a < 1 ? hexDouble(Math.round(a * 255)) : "");
    }
    function rgbString(rgba, alpha) {
        if (alpha < 1 || rgba[3] && rgba[3] < 1) return rgbaString(rgba, alpha);
        return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
    }
    function rgbaString(rgba, alpha) {
        if (alpha === undefined) alpha = rgba[3] !== undefined ? rgba[3] : 1;
        return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ", " + alpha + ")";
    }
    function percentString(rgba, alpha) {
        if (alpha < 1 || rgba[3] && rgba[3] < 1) return percentaString(rgba, alpha);
        var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
        return "rgb(" + r + "%, " + g + "%, " + b + "%)";
    }
    function percentaString(rgba, alpha) {
        var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
        return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
    }
    function hslString(hsla, alpha) {
        if (alpha < 1 || hsla[3] && hsla[3] < 1) return hslaString(hsla, alpha);
        return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
    }
    function hslaString(hsla, alpha) {
        if (alpha === undefined) alpha = hsla[3] !== undefined ? hsla[3] : 1;
        return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + alpha + ")";
    }
    // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
    // (hwb have alpha optional & 1 is default value)
    function hwbString(hwb, alpha) {
        if (alpha === undefined) alpha = hwb[3] !== undefined ? hwb[3] : 1;
        return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%" + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
    }
    function keyword(rgb) {
        return reverseNames[rgb.slice(0, 3)];
    }
    // helpers
    function scale(num, min, max) {
        return Math.min(Math.max(min, num), max);
    }
    function hexDouble(num) {
        var str = num.toString(16).toUpperCase();
        return str.length < 2 ? "0" + str : str;
    }
    //create a list of reverse color names
    var reverseNames = {};
    for(var name in colorName$1)reverseNames[colorName$1[name]] = name;
    /* MIT license */ var Color = function(obj) {
        if (obj instanceof Color) return obj;
        if (!(this instanceof Color)) return new Color(obj);
        this.valid = false;
        this.values = {
            rgb: [
                0,
                0,
                0
            ],
            hsl: [
                0,
                0,
                0
            ],
            hsv: [
                0,
                0,
                0
            ],
            hwb: [
                0,
                0,
                0
            ],
            cmyk: [
                0,
                0,
                0,
                0
            ],
            alpha: 1
        };
        // parse Color() argument
        var vals;
        if (typeof obj === "string") {
            vals = colorString.getRgba(obj);
            if (vals) this.setValues("rgb", vals);
            else if (vals = colorString.getHsla(obj)) this.setValues("hsl", vals);
            else if (vals = colorString.getHwb(obj)) this.setValues("hwb", vals);
        } else if (typeof obj === "object") {
            vals = obj;
            if (vals.r !== undefined || vals.red !== undefined) this.setValues("rgb", vals);
            else if (vals.l !== undefined || vals.lightness !== undefined) this.setValues("hsl", vals);
            else if (vals.v !== undefined || vals.value !== undefined) this.setValues("hsv", vals);
            else if (vals.w !== undefined || vals.whiteness !== undefined) this.setValues("hwb", vals);
            else if (vals.c !== undefined || vals.cyan !== undefined) this.setValues("cmyk", vals);
        }
    };
    Color.prototype = {
        isValid: function() {
            return this.valid;
        },
        rgb: function() {
            return this.setSpace("rgb", arguments);
        },
        hsl: function() {
            return this.setSpace("hsl", arguments);
        },
        hsv: function() {
            return this.setSpace("hsv", arguments);
        },
        hwb: function() {
            return this.setSpace("hwb", arguments);
        },
        cmyk: function() {
            return this.setSpace("cmyk", arguments);
        },
        rgbArray: function() {
            return this.values.rgb;
        },
        hslArray: function() {
            return this.values.hsl;
        },
        hsvArray: function() {
            return this.values.hsv;
        },
        hwbArray: function() {
            var values = this.values;
            if (values.alpha !== 1) return values.hwb.concat([
                values.alpha
            ]);
            return values.hwb;
        },
        cmykArray: function() {
            return this.values.cmyk;
        },
        rgbaArray: function() {
            var values = this.values;
            return values.rgb.concat([
                values.alpha
            ]);
        },
        hslaArray: function() {
            var values = this.values;
            return values.hsl.concat([
                values.alpha
            ]);
        },
        alpha: function(val) {
            if (val === undefined) return this.values.alpha;
            this.setValues("alpha", val);
            return this;
        },
        red: function(val) {
            return this.setChannel("rgb", 0, val);
        },
        green: function(val) {
            return this.setChannel("rgb", 1, val);
        },
        blue: function(val) {
            return this.setChannel("rgb", 2, val);
        },
        hue: function(val) {
            if (val) {
                val %= 360;
                val = val < 0 ? 360 + val : val;
            }
            return this.setChannel("hsl", 0, val);
        },
        saturation: function(val) {
            return this.setChannel("hsl", 1, val);
        },
        lightness: function(val) {
            return this.setChannel("hsl", 2, val);
        },
        saturationv: function(val) {
            return this.setChannel("hsv", 1, val);
        },
        whiteness: function(val) {
            return this.setChannel("hwb", 1, val);
        },
        blackness: function(val) {
            return this.setChannel("hwb", 2, val);
        },
        value: function(val) {
            return this.setChannel("hsv", 2, val);
        },
        cyan: function(val) {
            return this.setChannel("cmyk", 0, val);
        },
        magenta: function(val) {
            return this.setChannel("cmyk", 1, val);
        },
        yellow: function(val) {
            return this.setChannel("cmyk", 2, val);
        },
        black: function(val) {
            return this.setChannel("cmyk", 3, val);
        },
        hexString: function() {
            return colorString.hexString(this.values.rgb);
        },
        rgbString: function() {
            return colorString.rgbString(this.values.rgb, this.values.alpha);
        },
        rgbaString: function() {
            return colorString.rgbaString(this.values.rgb, this.values.alpha);
        },
        percentString: function() {
            return colorString.percentString(this.values.rgb, this.values.alpha);
        },
        hslString: function() {
            return colorString.hslString(this.values.hsl, this.values.alpha);
        },
        hslaString: function() {
            return colorString.hslaString(this.values.hsl, this.values.alpha);
        },
        hwbString: function() {
            return colorString.hwbString(this.values.hwb, this.values.alpha);
        },
        keyword: function() {
            return colorString.keyword(this.values.rgb, this.values.alpha);
        },
        rgbNumber: function() {
            var rgb = this.values.rgb;
            return rgb[0] << 16 | rgb[1] << 8 | rgb[2];
        },
        luminosity: function() {
            // http://www.w3.org/TR/WCAG20/#relativeluminancedef
            var rgb = this.values.rgb;
            var lum = [];
            for(var i = 0; i < rgb.length; i++){
                var chan = rgb[i] / 255;
                lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
            }
            return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
        },
        contrast: function(color2) {
            // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
            var lum1 = this.luminosity();
            var lum2 = color2.luminosity();
            if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
            return (lum2 + 0.05) / (lum1 + 0.05);
        },
        level: function(color2) {
            var contrastRatio = this.contrast(color2);
            if (contrastRatio >= 7.1) return "AAA";
            return contrastRatio >= 4.5 ? "AA" : "";
        },
        dark: function() {
            // YIQ equation from http://24ways.org/2010/calculating-color-contrast
            var rgb = this.values.rgb;
            var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
            return yiq < 128;
        },
        light: function() {
            return !this.dark();
        },
        negate: function() {
            var rgb = [];
            for(var i = 0; i < 3; i++)rgb[i] = 255 - this.values.rgb[i];
            this.setValues("rgb", rgb);
            return this;
        },
        lighten: function(ratio) {
            var hsl = this.values.hsl;
            hsl[2] += hsl[2] * ratio;
            this.setValues("hsl", hsl);
            return this;
        },
        darken: function(ratio) {
            var hsl = this.values.hsl;
            hsl[2] -= hsl[2] * ratio;
            this.setValues("hsl", hsl);
            return this;
        },
        saturate: function(ratio) {
            var hsl = this.values.hsl;
            hsl[1] += hsl[1] * ratio;
            this.setValues("hsl", hsl);
            return this;
        },
        desaturate: function(ratio) {
            var hsl = this.values.hsl;
            hsl[1] -= hsl[1] * ratio;
            this.setValues("hsl", hsl);
            return this;
        },
        whiten: function(ratio) {
            var hwb = this.values.hwb;
            hwb[1] += hwb[1] * ratio;
            this.setValues("hwb", hwb);
            return this;
        },
        blacken: function(ratio) {
            var hwb = this.values.hwb;
            hwb[2] += hwb[2] * ratio;
            this.setValues("hwb", hwb);
            return this;
        },
        greyscale: function() {
            var rgb = this.values.rgb;
            // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
            var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
            this.setValues("rgb", [
                val,
                val,
                val
            ]);
            return this;
        },
        clearer: function(ratio) {
            var alpha = this.values.alpha;
            this.setValues("alpha", alpha - alpha * ratio);
            return this;
        },
        opaquer: function(ratio) {
            var alpha = this.values.alpha;
            this.setValues("alpha", alpha + alpha * ratio);
            return this;
        },
        rotate: function(degrees) {
            var hsl = this.values.hsl;
            var hue = (hsl[0] + degrees) % 360;
            hsl[0] = hue < 0 ? 360 + hue : hue;
            this.setValues("hsl", hsl);
            return this;
        },
        /**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */ mix: function(mixinColor, weight) {
            var color1 = this;
            var color2 = mixinColor;
            var p = weight === undefined ? 0.5 : weight;
            var w = 2 * p - 1;
            var a = color1.alpha() - color2.alpha();
            var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            var w2 = 1 - w1;
            return this.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue()).alpha(color1.alpha() * p + color2.alpha() * (1 - p));
        },
        toJSON: function() {
            return this.rgb();
        },
        clone: function() {
            // NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
            // making the final build way to big to embed in Chart.js. So let's do it manually,
            // assuming that values to clone are 1 dimension arrays containing only numbers,
            // except 'alpha' which is a number.
            var result = new Color();
            var source = this.values;
            var target = result.values;
            var value, type;
            for(var prop in source)if (source.hasOwnProperty(prop)) {
                value = source[prop];
                type = ({}).toString.call(value);
                if (type === "[object Array]") target[prop] = value.slice(0);
                else if (type === "[object Number]") target[prop] = value;
                else console.error("unexpected color value:", value);
            }
            return result;
        }
    };
    Color.prototype.spaces = {
        rgb: [
            "red",
            "green",
            "blue"
        ],
        hsl: [
            "hue",
            "saturation",
            "lightness"
        ],
        hsv: [
            "hue",
            "saturation",
            "value"
        ],
        hwb: [
            "hue",
            "whiteness",
            "blackness"
        ],
        cmyk: [
            "cyan",
            "magenta",
            "yellow",
            "black"
        ]
    };
    Color.prototype.maxes = {
        rgb: [
            255,
            255,
            255
        ],
        hsl: [
            360,
            100,
            100
        ],
        hsv: [
            360,
            100,
            100
        ],
        hwb: [
            360,
            100,
            100
        ],
        cmyk: [
            100,
            100,
            100,
            100
        ]
    };
    Color.prototype.getValues = function(space) {
        var values = this.values;
        var vals = {};
        for(var i = 0; i < space.length; i++)vals[space.charAt(i)] = values[space][i];
        if (values.alpha !== 1) vals.a = values.alpha;
        // {r: 255, g: 255, b: 255, a: 0.4}
        return vals;
    };
    Color.prototype.setValues = function(space, vals) {
        var values = this.values;
        var spaces = this.spaces;
        var maxes = this.maxes;
        var alpha = 1;
        var i;
        this.valid = true;
        if (space === "alpha") alpha = vals;
        else if (vals.length) {
            // [10, 10, 10]
            values[space] = vals.slice(0, space.length);
            alpha = vals[space.length];
        } else if (vals[space.charAt(0)] !== undefined) {
            // {r: 10, g: 10, b: 10}
            for(i = 0; i < space.length; i++)values[space][i] = vals[space.charAt(i)];
            alpha = vals.a;
        } else if (vals[spaces[space][0]] !== undefined) {
            // {red: 10, green: 10, blue: 10}
            var chans = spaces[space];
            for(i = 0; i < space.length; i++)values[space][i] = vals[chans[i]];
            alpha = vals.alpha;
        }
        values.alpha = Math.max(0, Math.min(1, alpha === undefined ? values.alpha : alpha));
        if (space === "alpha") return false;
        var capped;
        // cap values of the space prior converting all values
        for(i = 0; i < space.length; i++){
            capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
            values[space][i] = Math.round(capped);
        }
        // convert to all the other color spaces
        for(var sname in spaces)if (sname !== space) values[sname] = colorConvert[space][sname](values[space]);
        return true;
    };
    Color.prototype.setSpace = function(space, args) {
        var vals = args[0];
        if (vals === undefined) // color.rgb()
        return this.getValues(space);
        // color.rgb(10, 10, 10)
        if (typeof vals === "number") vals = Array.prototype.slice.call(args);
        this.setValues(space, vals);
        return this;
    };
    Color.prototype.setChannel = function(space, index, val) {
        var svalues = this.values[space];
        if (val === undefined) // color.red()
        return svalues[index];
        else if (val === svalues[index]) // color.red(color.red())
        return this;
        // color.red(100)
        svalues[index] = val;
        this.setValues(space, svalues);
        return this;
    };
    if (typeof window !== "undefined") window.Color = Color;
    var chartjsColor = Color;
    function isValidKey(key) {
        return [
            "__proto__",
            "prototype",
            "constructor"
        ].indexOf(key) === -1;
    }
    /**
 * @namespace Chart.helpers
 */ var helpers = {
        /**
	 * An empty function that can be used, for example, for optional callback.
	 */ noop: function() {},
        /**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */ uid: function() {
            var id = 0;
            return function() {
                return id++;
            };
        }(),
        /**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */ isNullOrUndef: function(value) {
            return value === null || typeof value === "undefined";
        },
        /**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */ isArray: function(value) {
            if (Array.isArray && Array.isArray(value)) return true;
            var type = Object.prototype.toString.call(value);
            if (type.substr(0, 7) === "[object" && type.substr(-6) === "Array]") return true;
            return false;
        },
        /**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */ isObject: function(value) {
            return value !== null && Object.prototype.toString.call(value) === "[object Object]";
        },
        /**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */ isFinite: function(value) {
            return (typeof value === "number" || value instanceof Number) && isFinite(value);
        },
        /**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */ valueOrDefault: function(value, defaultValue) {
            return typeof value === "undefined" ? defaultValue : value;
        },
        /**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */ valueAtIndexOrDefault: function(value, index, defaultValue) {
            return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
        },
        /**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */ callback: function(fn, args, thisArg) {
            if (fn && typeof fn.call === "function") return fn.apply(thisArg, args);
        },
        /**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */ each: function(loopable, fn, thisArg, reverse) {
            var i, len, keys;
            if (helpers.isArray(loopable)) {
                len = loopable.length;
                if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
                else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
            } else if (helpers.isObject(loopable)) {
                keys = Object.keys(loopable);
                len = keys.length;
                for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
            }
        },
        /**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */ arrayEquals: function(a0, a1) {
            var i, ilen, v0, v1;
            if (!a0 || !a1 || a0.length !== a1.length) return false;
            for(i = 0, ilen = a0.length; i < ilen; ++i){
                v0 = a0[i];
                v1 = a1[i];
                if (v0 instanceof Array && v1 instanceof Array) {
                    if (!helpers.arrayEquals(v0, v1)) return false;
                } else if (v0 !== v1) // NOTE: two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
            return true;
        },
        /**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */ clone: function(source) {
            if (helpers.isArray(source)) return source.map(helpers.clone);
            if (helpers.isObject(source)) {
                var target = Object.create(source);
                var keys = Object.keys(source);
                var klen = keys.length;
                var k = 0;
                for(; k < klen; ++k)target[keys[k]] = helpers.clone(source[keys[k]]);
                return target;
            }
            return source;
        },
        /**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */ _merger: function(key, target, source, options) {
            if (!isValidKey(key)) // We want to ensure we do not copy prototypes over
            // as this can pollute global namespaces
            return;
            var tval = target[key];
            var sval = source[key];
            if (helpers.isObject(tval) && helpers.isObject(sval)) helpers.merge(tval, sval, options);
            else target[key] = helpers.clone(sval);
        },
        /**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */ _mergerIf: function(key, target, source) {
            if (!isValidKey(key)) // We want to ensure we do not copy prototypes over
            // as this can pollute global namespaces
            return;
            var tval = target[key];
            var sval = source[key];
            if (helpers.isObject(tval) && helpers.isObject(sval)) helpers.mergeIf(tval, sval);
            else if (!target.hasOwnProperty(key)) target[key] = helpers.clone(sval);
        },
        /**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */ merge: function(target, source, options) {
            var sources = helpers.isArray(source) ? source : [
                source
            ];
            var ilen = sources.length;
            var merge, i, keys, klen, k;
            if (!helpers.isObject(target)) return target;
            options = options || {};
            merge = options.merger || helpers._merger;
            for(i = 0; i < ilen; ++i){
                source = sources[i];
                if (!helpers.isObject(source)) continue;
                keys = Object.keys(source);
                for(k = 0, klen = keys.length; k < klen; ++k)merge(keys[k], target, source, options);
            }
            return target;
        },
        /**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */ mergeIf: function(target, source) {
            return helpers.merge(target, source, {
                merger: helpers._mergerIf
            });
        },
        /**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */ extend: Object.assign || function(target) {
            return helpers.merge(target, [].slice.call(arguments, 1), {
                merger: function(key, dst, src) {
                    dst[key] = src[key];
                }
            });
        },
        /**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */ inherits: function(extensions) {
            var me = this;
            var ChartElement = extensions && extensions.hasOwnProperty("constructor") ? extensions.constructor : function() {
                return me.apply(this, arguments);
            };
            var Surrogate = function() {
                this.constructor = ChartElement;
            };
            Surrogate.prototype = me.prototype;
            ChartElement.prototype = new Surrogate();
            ChartElement.extend = helpers.inherits;
            if (extensions) helpers.extend(ChartElement.prototype, extensions);
            ChartElement.__super__ = me.prototype;
            return ChartElement;
        },
        _deprecated: function(scope, value, previous, current) {
            if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
        }
    };
    var helpers_core = helpers;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */ helpers.callCallback = helpers.callback;
    /**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.indexOf = function(array, item, fromIndex) {
        return Array.prototype.indexOf.call(array, item, fromIndex);
    };
    /**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.getValueOrDefault = helpers.valueOrDefault;
    /**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
    /**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */ var effects = {
        linear: function(t) {
            return t;
        },
        easeInQuad: function(t) {
            return t * t;
        },
        easeOutQuad: function(t) {
            return -t * (t - 2);
        },
        easeInOutQuad: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t;
            return -0.5 * (--t * (t - 2) - 1);
        },
        easeInCubic: function(t) {
            return t * t * t;
        },
        easeOutCubic: function(t) {
            return (t = t - 1) * t * t + 1;
        },
        easeInOutCubic: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t;
            return 0.5 * ((t -= 2) * t * t + 2);
        },
        easeInQuart: function(t) {
            return t * t * t * t;
        },
        easeOutQuart: function(t) {
            return -((t = t - 1) * t * t * t - 1);
        },
        easeInOutQuart: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t * t;
            return -0.5 * ((t -= 2) * t * t * t - 2);
        },
        easeInQuint: function(t) {
            return t * t * t * t * t;
        },
        easeOutQuint: function(t) {
            return (t = t - 1) * t * t * t * t + 1;
        },
        easeInOutQuint: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t * t * t;
            return 0.5 * ((t -= 2) * t * t * t * t + 2);
        },
        easeInSine: function(t) {
            return -Math.cos(t * (Math.PI / 2)) + 1;
        },
        easeOutSine: function(t) {
            return Math.sin(t * (Math.PI / 2));
        },
        easeInOutSine: function(t) {
            return -0.5 * (Math.cos(Math.PI * t) - 1);
        },
        easeInExpo: function(t) {
            return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
        },
        easeOutExpo: function(t) {
            return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
        },
        easeInOutExpo: function(t) {
            if (t === 0) return 0;
            if (t === 1) return 1;
            if ((t /= 0.5) < 1) return 0.5 * Math.pow(2, 10 * (t - 1));
            return 0.5 * (-Math.pow(2, -10 * --t) + 2);
        },
        easeInCirc: function(t) {
            if (t >= 1) return t;
            return -(Math.sqrt(1 - t * t) - 1);
        },
        easeOutCirc: function(t) {
            return Math.sqrt(1 - (t = t - 1) * t);
        },
        easeInOutCirc: function(t) {
            if ((t /= 0.5) < 1) return -0.5 * (Math.sqrt(1 - t * t) - 1);
            return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
        },
        easeInElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if (t === 1) return 1;
            if (!p) p = 0.3;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
        },
        easeOutElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if (t === 1) return 1;
            if (!p) p = 0.3;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
        },
        easeInOutElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if ((t /= 0.5) === 2) return 1;
            if (!p) p = 0.45;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
            return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
        },
        easeInBack: function(t) {
            var s = 1.70158;
            return t * t * ((s + 1) * t - s);
        },
        easeOutBack: function(t) {
            var s = 1.70158;
            return (t = t - 1) * t * ((s + 1) * t + s) + 1;
        },
        easeInOutBack: function(t) {
            var s = 1.70158;
            if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
            return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
        },
        easeInBounce: function(t) {
            return 1 - effects.easeOutBounce(1 - t);
        },
        easeOutBounce: function(t) {
            if (t < 1 / 2.75) return 7.5625 * t * t;
            if (t < 2 / 2.75) return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
            if (t < 2.5 / 2.75) return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
            return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
        },
        easeInOutBounce: function(t) {
            if (t < 0.5) return effects.easeInBounce(t * 2) * 0.5;
            return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
        }
    };
    var helpers_easing = {
        effects: effects
    };
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.easingEffects = effects;
    var PI = Math.PI;
    var RAD_PER_DEG = PI / 180;
    var DOUBLE_PI = PI * 2;
    var HALF_PI = PI / 2;
    var QUARTER_PI = PI / 4;
    var TWO_THIRDS_PI = PI * 2 / 3;
    /**
 * @namespace Chart.helpers.canvas
 */ var exports$1 = {
        /**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */ clear: function(chart) {
            chart.ctx.clearRect(0, 0, chart.width, chart.height);
        },
        /**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */ roundedRect: function(ctx, x, y, width, height, radius) {
            if (radius) {
                var r = Math.min(radius, height / 2, width / 2);
                var left = x + r;
                var top = y + r;
                var right = x + width - r;
                var bottom = y + height - r;
                ctx.moveTo(x, top);
                if (left < right && top < bottom) {
                    ctx.arc(left, top, r, -PI, -HALF_PI);
                    ctx.arc(right, top, r, -HALF_PI, 0);
                    ctx.arc(right, bottom, r, 0, HALF_PI);
                    ctx.arc(left, bottom, r, HALF_PI, PI);
                } else if (left < right) {
                    ctx.moveTo(left, y);
                    ctx.arc(right, top, r, -HALF_PI, HALF_PI);
                    ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
                } else if (top < bottom) {
                    ctx.arc(left, top, r, -PI, 0);
                    ctx.arc(left, bottom, r, 0, PI);
                } else ctx.arc(left, top, r, -PI, PI);
                ctx.closePath();
                ctx.moveTo(x, y);
            } else ctx.rect(x, y, width, height);
        },
        drawPoint: function(ctx, style, radius, x, y, rotation) {
            var type, xOffset, yOffset, size, cornerRadius;
            var rad = (rotation || 0) * RAD_PER_DEG;
            if (style && typeof style === "object") {
                type = style.toString();
                if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
                    ctx.save();
                    ctx.translate(x, y);
                    ctx.rotate(rad);
                    ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
                    ctx.restore();
                    return;
                }
            }
            if (isNaN(radius) || radius <= 0) return;
            ctx.beginPath();
            switch(style){
                // Default includes circle
                default:
                    ctx.arc(x, y, radius, 0, DOUBLE_PI);
                    ctx.closePath();
                    break;
                case "triangle":
                    ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    rad += TWO_THIRDS_PI;
                    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    rad += TWO_THIRDS_PI;
                    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    ctx.closePath();
                    break;
                case "rectRounded":
                    // NOTE: the rounded rect implementation changed to use `arc` instead of
                    // `quadraticCurveTo` since it generates better results when rect is
                    // almost a circle. 0.516 (instead of 0.5) produces results with visually
                    // closer proportion to the previous impl and it is inscribed in the
                    // circle with `radius`. For more details, see the following PRs:
                    // https://github.com/chartjs/Chart.js/issues/5597
                    // https://github.com/chartjs/Chart.js/issues/5858
                    cornerRadius = radius * 0.516;
                    size = radius - cornerRadius;
                    xOffset = Math.cos(rad + QUARTER_PI) * size;
                    yOffset = Math.sin(rad + QUARTER_PI) * size;
                    ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
                    ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
                    ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
                    ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
                    ctx.closePath();
                    break;
                case "rect":
                    if (!rotation) {
                        size = Math.SQRT1_2 * radius;
                        ctx.rect(x - size, y - size, 2 * size, 2 * size);
                        break;
                    }
                    rad += QUARTER_PI;
                /* falls through */ case "rectRot":
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    ctx.closePath();
                    break;
                case "crossRot":
                    rad += QUARTER_PI;
                /* falls through */ case "cross":
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    break;
                case "star":
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    rad += QUARTER_PI;
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    break;
                case "line":
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    break;
                case "dash":
                    ctx.moveTo(x, y);
                    ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
                    break;
            }
            ctx.fill();
            ctx.stroke();
        },
        /**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */ _isPointInArea: function(point, area) {
            var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
            return point.x > area.left - epsilon && point.x < area.right + epsilon && point.y > area.top - epsilon && point.y < area.bottom + epsilon;
        },
        clipArea: function(ctx, area) {
            ctx.save();
            ctx.beginPath();
            ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
            ctx.clip();
        },
        unclipArea: function(ctx) {
            ctx.restore();
        },
        lineTo: function(ctx, previous, target, flip) {
            var stepped = target.steppedLine;
            if (stepped) {
                if (stepped === "middle") {
                    var midpoint = (previous.x + target.x) / 2.0;
                    ctx.lineTo(midpoint, flip ? target.y : previous.y);
                    ctx.lineTo(midpoint, flip ? previous.y : target.y);
                } else if (stepped === "after" && !flip || stepped !== "after" && flip) ctx.lineTo(previous.x, target.y);
                else ctx.lineTo(target.x, previous.y);
                ctx.lineTo(target.x, target.y);
                return;
            }
            if (!target.tension) {
                ctx.lineTo(target.x, target.y);
                return;
            }
            ctx.bezierCurveTo(flip ? previous.controlPointPreviousX : previous.controlPointNextX, flip ? previous.controlPointPreviousY : previous.controlPointNextY, flip ? target.controlPointNextX : target.controlPointPreviousX, flip ? target.controlPointNextY : target.controlPointPreviousY, target.x, target.y);
        }
    };
    var helpers_canvas = exports$1;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.clear = exports$1.clear;
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.drawRoundedRectangle = function(ctx) {
        ctx.beginPath();
        exports$1.roundedRect.apply(exports$1, arguments);
    };
    var defaults = {
        /**
	 * @private
	 */ _set: function(scope, values) {
            return helpers_core.merge(this[scope] || (this[scope] = {}), values);
        }
    };
    // TODO(v3): remove 'global' from namespace.  all default are global and
    // there's inconsistency around which options are under 'global'
    defaults._set("global", {
        defaultColor: "rgba(0,0,0,0.1)",
        defaultFontColor: "#666",
        defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        defaultFontSize: 12,
        defaultFontStyle: "normal",
        defaultLineHeight: 1.2,
        showLines: true
    });
    var core_defaults = defaults;
    var valueOrDefault = helpers_core.valueOrDefault;
    /**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function toFontString(font) {
        if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) return null;
        return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
    }
    /**
 * @alias Chart.helpers.options
 * @namespace
 */ var helpers_options = {
        /**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */ toLineHeight: function(value, size) {
            var matches = ("" + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
            if (!matches || matches[1] === "normal") return size * 1.2;
            value = +matches[2];
            switch(matches[3]){
                case "px":
                    return value;
                case "%":
                    value /= 100;
                    break;
            }
            return size * value;
        },
        /**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */ toPadding: function(value) {
            var t, r, b, l;
            if (helpers_core.isObject(value)) {
                t = +value.top || 0;
                r = +value.right || 0;
                b = +value.bottom || 0;
                l = +value.left || 0;
            } else t = r = b = l = +value || 0;
            return {
                top: t,
                right: r,
                bottom: b,
                left: l,
                height: t + b,
                width: l + r
            };
        },
        /**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */ _parseFont: function(options) {
            var globalDefaults = core_defaults.global;
            var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
            var font = {
                family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
                lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
                size: size,
                style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
                weight: null,
                string: ""
            };
            font.string = toFontString(font);
            return font;
        },
        /**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @param {object} [info] - object to return information about resolution in
	 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
	 * @since 2.7.0
	 */ resolve: function(inputs, context, index, info) {
            var cacheable = true;
            var i, ilen, value;
            for(i = 0, ilen = inputs.length; i < ilen; ++i){
                value = inputs[i];
                if (value === undefined) continue;
                if (context !== undefined && typeof value === "function") {
                    value = value(context);
                    cacheable = false;
                }
                if (index !== undefined && helpers_core.isArray(value)) {
                    value = value[index];
                    cacheable = false;
                }
                if (value !== undefined) {
                    if (info && !cacheable) info.cacheable = false;
                    return value;
                }
            }
        }
    };
    /**
 * @alias Chart.helpers.math
 * @namespace
 */ var exports$2 = {
        /**
	 * Returns an array of factors sorted from 1 to sqrt(value)
	 * @private
	 */ _factorize: function(value) {
            var result = [];
            var sqrt = Math.sqrt(value);
            var i;
            for(i = 1; i < sqrt; i++)if (value % i === 0) {
                result.push(i);
                result.push(value / i);
            }
            if (sqrt === (sqrt | 0)) result.push(sqrt);
            result.sort(function(a, b) {
                return a - b;
            }).pop();
            return result;
        },
        log10: Math.log10 || function(x) {
            var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
            // Check for whole powers of 10,
            // which due to floating point rounding error should be corrected.
            var powerOf10 = Math.round(exponent);
            var isPowerOf10 = x === Math.pow(10, powerOf10);
            return isPowerOf10 ? powerOf10 : exponent;
        }
    };
    var helpers_math = exports$2;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
 * @namespace Chart.helpers.log10
 * @deprecated since version 2.9.0
 * @todo remove at version 3
 * @private
 */ helpers_core.log10 = exports$2.log10;
    var getRtlAdapter = function(rectX, width) {
        return {
            x: function(x) {
                return rectX + rectX + width - x;
            },
            setWidth: function(w) {
                width = w;
            },
            textAlign: function(align) {
                if (align === "center") return align;
                return align === "right" ? "left" : "right";
            },
            xPlus: function(x, value) {
                return x - value;
            },
            leftForLtr: function(x, itemWidth) {
                return x - itemWidth;
            }
        };
    };
    var getLtrAdapter = function() {
        return {
            x: function(x) {
                return x;
            },
            setWidth: function(w) {},
            textAlign: function(align) {
                return align;
            },
            xPlus: function(x, value) {
                return x + value;
            },
            leftForLtr: function(x, _itemWidth) {
                return x;
            }
        };
    };
    var getAdapter = function(rtl, rectX, width) {
        return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
    };
    var overrideTextDirection = function(ctx, direction) {
        var style, original;
        if (direction === "ltr" || direction === "rtl") {
            style = ctx.canvas.style;
            original = [
                style.getPropertyValue("direction"),
                style.getPropertyPriority("direction")
            ];
            style.setProperty("direction", direction, "important");
            ctx.prevTextDirection = original;
        }
    };
    var restoreTextDirection = function(ctx) {
        var original = ctx.prevTextDirection;
        if (original !== undefined) {
            delete ctx.prevTextDirection;
            ctx.canvas.style.setProperty("direction", original[0], original[1]);
        }
    };
    var helpers_rtl = {
        getRtlAdapter: getAdapter,
        overrideTextDirection: overrideTextDirection,
        restoreTextDirection: restoreTextDirection
    };
    var helpers$1 = helpers_core;
    var easing = helpers_easing;
    var canvas = helpers_canvas;
    var options = helpers_options;
    var math = helpers_math;
    var rtl = helpers_rtl;
    helpers$1.easing = easing;
    helpers$1.canvas = canvas;
    helpers$1.options = options;
    helpers$1.math = math;
    helpers$1.rtl = rtl;
    function interpolate(start, view, model, ease) {
        var keys = Object.keys(model);
        var i, ilen, key, actual, origin, target, type, c0, c1;
        for(i = 0, ilen = keys.length; i < ilen; ++i){
            key = keys[i];
            target = model[key];
            // if a value is added to the model after pivot() has been called, the view
            // doesn't contain it, so let's initialize the view to the target value.
            if (!view.hasOwnProperty(key)) view[key] = target;
            actual = view[key];
            if (actual === target || key[0] === "_") continue;
            if (!start.hasOwnProperty(key)) start[key] = actual;
            origin = start[key];
            type = typeof target;
            if (type === typeof origin) {
                if (type === "string") {
                    c0 = chartjsColor(origin);
                    if (c0.valid) {
                        c1 = chartjsColor(target);
                        if (c1.valid) {
                            view[key] = c1.mix(c0, ease).rgbString();
                            continue;
                        }
                    }
                } else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
                    view[key] = origin + (target - origin) * ease;
                    continue;
                }
            }
            view[key] = target;
        }
    }
    var Element = function(configuration) {
        helpers$1.extend(this, configuration);
        this.initialize.apply(this, arguments);
    };
    helpers$1.extend(Element.prototype, {
        _type: undefined,
        initialize: function() {
            this.hidden = false;
        },
        pivot: function() {
            var me = this;
            if (!me._view) me._view = helpers$1.extend({}, me._model);
            me._start = {};
            return me;
        },
        transition: function(ease) {
            var me = this;
            var model = me._model;
            var start = me._start;
            var view = me._view;
            // No animation -> No Transition
            if (!model || ease === 1) {
                me._view = helpers$1.extend({}, model);
                me._start = null;
                return me;
            }
            if (!view) view = me._view = {};
            if (!start) start = me._start = {};
            interpolate(start, view, model, ease);
            return me;
        },
        tooltipPosition: function() {
            return {
                x: this._model.x,
                y: this._model.y
            };
        },
        hasValue: function() {
            return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
        }
    });
    Element.extend = helpers$1.inherits;
    var core_element = Element;
    var exports$3 = core_element.extend({
        chart: null,
        currentStep: 0,
        numSteps: 60,
        easing: "",
        render: null,
        onAnimationProgress: null,
        onAnimationComplete: null
    });
    var core_animation = exports$3;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */ Object.defineProperty(exports$3.prototype, "animationObject", {
        get: function() {
            return this;
        }
    });
    /**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */ Object.defineProperty(exports$3.prototype, "chartInstance", {
        get: function() {
            return this.chart;
        },
        set: function(value) {
            this.chart = value;
        }
    });
    core_defaults._set("global", {
        animation: {
            duration: 1000,
            easing: "easeOutQuart",
            onProgress: helpers$1.noop,
            onComplete: helpers$1.noop
        }
    });
    var core_animations = {
        animations: [],
        request: null,
        /**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */ addAnimation: function(chart, animation, duration, lazy) {
            var animations = this.animations;
            var i, ilen;
            animation.chart = chart;
            animation.startTime = Date.now();
            animation.duration = duration;
            if (!lazy) chart.animating = true;
            for(i = 0, ilen = animations.length; i < ilen; ++i)if (animations[i].chart === chart) {
                animations[i] = animation;
                return;
            }
            animations.push(animation);
            // If there are no animations queued, manually kickstart a digest, for lack of a better word
            if (animations.length === 1) this.requestAnimationFrame();
        },
        cancelAnimation: function(chart) {
            var index = helpers$1.findIndex(this.animations, function(animation) {
                return animation.chart === chart;
            });
            if (index !== -1) {
                this.animations.splice(index, 1);
                chart.animating = false;
            }
        },
        requestAnimationFrame: function() {
            var me = this;
            if (me.request === null) // Skip animation frame requests until the active one is executed.
            // This can happen when processing mouse events, e.g. 'mousemove'
            // and 'mouseout' events will trigger multiple renders.
            me.request = helpers$1.requestAnimFrame.call(window, function() {
                me.request = null;
                me.startDigest();
            });
        },
        /**
	 * @private
	 */ startDigest: function() {
            var me = this;
            me.advance();
            // Do we have more stuff to animate?
            if (me.animations.length > 0) me.requestAnimationFrame();
        },
        /**
	 * @private
	 */ advance: function() {
            var animations = this.animations;
            var animation, chart, numSteps, nextStep;
            var i = 0;
            // 1 animation per chart, so we are looping charts here
            while(i < animations.length){
                animation = animations[i];
                chart = animation.chart;
                numSteps = animation.numSteps;
                // Make sure that currentStep starts at 1
                // https://github.com/chartjs/Chart.js/issues/6104
                nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
                animation.currentStep = Math.min(nextStep, numSteps);
                helpers$1.callback(animation.render, [
                    chart,
                    animation
                ], chart);
                helpers$1.callback(animation.onAnimationProgress, [
                    animation
                ], chart);
                if (animation.currentStep >= numSteps) {
                    helpers$1.callback(animation.onAnimationComplete, [
                        animation
                    ], chart);
                    chart.animating = false;
                    animations.splice(i, 1);
                } else ++i;
            }
        }
    };
    var resolve = helpers$1.options.resolve;
    var arrayEvents = [
        "push",
        "pop",
        "shift",
        "splice",
        "unshift"
    ];
    /**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */ function listenArrayEvents(array, listener) {
        if (array._chartjs) {
            array._chartjs.listeners.push(listener);
            return;
        }
        Object.defineProperty(array, "_chartjs", {
            configurable: true,
            enumerable: false,
            value: {
                listeners: [
                    listener
                ]
            }
        });
        arrayEvents.forEach(function(key) {
            var method = "onData" + key.charAt(0).toUpperCase() + key.slice(1);
            var base = array[key];
            Object.defineProperty(array, key, {
                configurable: true,
                enumerable: false,
                value: function() {
                    var args = Array.prototype.slice.call(arguments);
                    var res = base.apply(this, args);
                    helpers$1.each(array._chartjs.listeners, function(object) {
                        if (typeof object[method] === "function") object[method].apply(object, args);
                    });
                    return res;
                }
            });
        });
    }
    /**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */ function unlistenArrayEvents(array, listener) {
        var stub = array._chartjs;
        if (!stub) return;
        var listeners = stub.listeners;
        var index = listeners.indexOf(listener);
        if (index !== -1) listeners.splice(index, 1);
        if (listeners.length > 0) return;
        arrayEvents.forEach(function(key) {
            delete array[key];
        });
        delete array._chartjs;
    }
    // Base class for all dataset controllers (line, bar, etc)
    var DatasetController = function(chart, datasetIndex) {
        this.initialize(chart, datasetIndex);
    };
    helpers$1.extend(DatasetController.prototype, {
        /**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */ datasetElementType: null,
        /**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */ dataElementType: null,
        /**
	 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */ _datasetElementOptions: [
            "backgroundColor",
            "borderCapStyle",
            "borderColor",
            "borderDash",
            "borderDashOffset",
            "borderJoinStyle",
            "borderWidth"
        ],
        /**
	 * Data element option keys to be resolved in _resolveDataElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderWidth",
            "pointStyle"
        ],
        initialize: function(chart, datasetIndex) {
            var me = this;
            me.chart = chart;
            me.index = datasetIndex;
            me.linkScales();
            me.addElements();
            me._type = me.getMeta().type;
        },
        updateIndex: function(datasetIndex) {
            this.index = datasetIndex;
        },
        linkScales: function() {
            var me = this;
            var meta = me.getMeta();
            var chart = me.chart;
            var scales = chart.scales;
            var dataset = me.getDataset();
            var scalesOpts = chart.options.scales;
            if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
            if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
        },
        getDataset: function() {
            return this.chart.data.datasets[this.index];
        },
        getMeta: function() {
            return this.chart.getDatasetMeta(this.index);
        },
        getScaleForId: function(scaleID) {
            return this.chart.scales[scaleID];
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.getMeta().yAxisID;
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.getMeta().xAxisID;
        },
        /**
	 * @private
	 */ _getValueScale: function() {
            return this.getScaleForId(this._getValueScaleId());
        },
        /**
	 * @private
	 */ _getIndexScale: function() {
            return this.getScaleForId(this._getIndexScaleId());
        },
        reset: function() {
            this._update(true);
        },
        /**
	 * @private
	 */ destroy: function() {
            if (this._data) unlistenArrayEvents(this._data, this);
        },
        createMetaDataset: function() {
            var me = this;
            var type = me.datasetElementType;
            return type && new type({
                _chart: me.chart,
                _datasetIndex: me.index
            });
        },
        createMetaData: function(index) {
            var me = this;
            var type = me.dataElementType;
            return type && new type({
                _chart: me.chart,
                _datasetIndex: me.index,
                _index: index
            });
        },
        addElements: function() {
            var me = this;
            var meta = me.getMeta();
            var data = me.getDataset().data || [];
            var metaData = meta.data;
            var i, ilen;
            for(i = 0, ilen = data.length; i < ilen; ++i)metaData[i] = metaData[i] || me.createMetaData(i);
            meta.dataset = meta.dataset || me.createMetaDataset();
        },
        addElementAndReset: function(index) {
            var element = this.createMetaData(index);
            this.getMeta().data.splice(index, 0, element);
            this.updateElement(element, index, true);
        },
        buildOrUpdateElements: function() {
            var me = this;
            var dataset = me.getDataset();
            var data = dataset.data || (dataset.data = []);
            // In order to correctly handle data addition/deletion animation (an thus simulate
            // real-time charts), we need to monitor these data modifications and synchronize
            // the internal meta data accordingly.
            if (me._data !== data) {
                if (me._data) // This case happens when the user replaced the data array instance.
                unlistenArrayEvents(me._data, me);
                if (data && Object.isExtensible(data)) listenArrayEvents(data, me);
                me._data = data;
            }
            // Re-sync meta data in case the user replaced the data array or if we missed
            // any updates and so make sure that we handle number of datapoints changing.
            me.resyncElements();
        },
        /**
	 * Returns the merged user-supplied and default dataset-level options
	 * @private
	 */ _configure: function() {
            var me = this;
            me._config = helpers$1.merge(Object.create(null), [
                me.chart.options.datasets[me._type],
                me.getDataset()
            ], {
                merger: function(key, target, source) {
                    if (key !== "_meta" && key !== "data") helpers$1._merger(key, target, source);
                }
            });
        },
        _update: function(reset) {
            var me = this;
            me._configure();
            me._cachedDataOpts = null;
            me.update(reset);
        },
        update: helpers$1.noop,
        transition: function(easingValue) {
            var meta = this.getMeta();
            var elements = meta.data || [];
            var ilen = elements.length;
            var i = 0;
            for(; i < ilen; ++i)elements[i].transition(easingValue);
            if (meta.dataset) meta.dataset.transition(easingValue);
        },
        draw: function() {
            var meta = this.getMeta();
            var elements = meta.data || [];
            var ilen = elements.length;
            var i = 0;
            if (meta.dataset) meta.dataset.draw();
            for(; i < ilen; ++i)elements[i].draw();
        },
        /**
	 * Returns a set of predefined style properties that should be used to represent the dataset
	 * or the data if the index is specified
	 * @param {number} index - data index
	 * @return {IStyleInterface} style object
	 */ getStyle: function(index) {
            var me = this;
            var meta = me.getMeta();
            var dataset = meta.dataset;
            var style;
            me._configure();
            if (dataset && index === undefined) style = me._resolveDatasetElementOptions(dataset || {});
            else {
                index = index || 0;
                style = me._resolveDataElementOptions(meta.data[index] || {}, index);
            }
            if (style.fill === false || style.fill === null) style.backgroundColor = style.borderColor;
            return style;
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function(element, hover) {
            var me = this;
            var chart = me.chart;
            var datasetOpts = me._config;
            var custom = element.custom || {};
            var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
            var elementOptions = me._datasetElementOptions;
            var values = {};
            var i, ilen, key, readKey;
            // Scriptable options
            var context = {
                chart: chart,
                dataset: me.getDataset(),
                datasetIndex: me.index,
                hover: hover
            };
            for(i = 0, ilen = elementOptions.length; i < ilen; ++i){
                key = elementOptions[i];
                readKey = hover ? "hover" + key.charAt(0).toUpperCase() + key.slice(1) : key;
                values[key] = resolve([
                    custom[readKey],
                    datasetOpts[readKey],
                    options[readKey]
                ], context);
            }
            return values;
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function(element, index) {
            var me = this;
            var custom = element && element.custom;
            var cached = me._cachedDataOpts;
            if (cached && !custom) return cached;
            var chart = me.chart;
            var datasetOpts = me._config;
            var options = chart.options.elements[me.dataElementType.prototype._type] || {};
            var elementOptions = me._dataElementOptions;
            var values = {};
            // Scriptable options
            var context = {
                chart: chart,
                dataIndex: index,
                dataset: me.getDataset(),
                datasetIndex: me.index
            };
            // `resolve` sets cacheable to `false` if any option is indexed or scripted
            var info = {
                cacheable: !custom
            };
            var keys, i, ilen, key;
            custom = custom || {};
            if (helpers$1.isArray(elementOptions)) for(i = 0, ilen = elementOptions.length; i < ilen; ++i){
                key = elementOptions[i];
                values[key] = resolve([
                    custom[key],
                    datasetOpts[key],
                    options[key]
                ], context, index, info);
            }
            else {
                keys = Object.keys(elementOptions);
                for(i = 0, ilen = keys.length; i < ilen; ++i){
                    key = keys[i];
                    values[key] = resolve([
                        custom[key],
                        datasetOpts[elementOptions[key]],
                        datasetOpts[key],
                        options[key]
                    ], context, index, info);
                }
            }
            if (info.cacheable) me._cachedDataOpts = Object.freeze(values);
            return values;
        },
        removeHoverStyle: function(element) {
            helpers$1.merge(element._model, element.$previousStyle || {});
            delete element.$previousStyle;
        },
        setHoverStyle: function(element) {
            var dataset = this.chart.data.datasets[element._datasetIndex];
            var index = element._index;
            var custom = element.custom || {};
            var model = element._model;
            var getHoverColor = helpers$1.getHoverColor;
            element.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = resolve([
                custom.hoverBackgroundColor,
                dataset.hoverBackgroundColor,
                getHoverColor(model.backgroundColor)
            ], undefined, index);
            model.borderColor = resolve([
                custom.hoverBorderColor,
                dataset.hoverBorderColor,
                getHoverColor(model.borderColor)
            ], undefined, index);
            model.borderWidth = resolve([
                custom.hoverBorderWidth,
                dataset.hoverBorderWidth,
                model.borderWidth
            ], undefined, index);
        },
        /**
	 * @private
	 */ _removeDatasetHoverStyle: function() {
            var element = this.getMeta().dataset;
            if (element) this.removeHoverStyle(element);
        },
        /**
	 * @private
	 */ _setDatasetHoverStyle: function() {
            var element = this.getMeta().dataset;
            var prev = {};
            var i, ilen, key, keys, hoverOptions, model;
            if (!element) return;
            model = element._model;
            hoverOptions = this._resolveDatasetElementOptions(element, true);
            keys = Object.keys(hoverOptions);
            for(i = 0, ilen = keys.length; i < ilen; ++i){
                key = keys[i];
                prev[key] = model[key];
                model[key] = hoverOptions[key];
            }
            element.$previousStyle = prev;
        },
        /**
	 * @private
	 */ resyncElements: function() {
            var me = this;
            var meta = me.getMeta();
            var data = me.getDataset().data;
            var numMeta = meta.data.length;
            var numData = data.length;
            if (numData < numMeta) meta.data.splice(numData, numMeta - numData);
            else if (numData > numMeta) me.insertElements(numMeta, numData - numMeta);
        },
        /**
	 * @private
	 */ insertElements: function(start, count) {
            for(var i = 0; i < count; ++i)this.addElementAndReset(start + i);
        },
        /**
	 * @private
	 */ onDataPush: function() {
            var count = arguments.length;
            this.insertElements(this.getDataset().data.length - count, count);
        },
        /**
	 * @private
	 */ onDataPop: function() {
            this.getMeta().data.pop();
        },
        /**
	 * @private
	 */ onDataShift: function() {
            this.getMeta().data.shift();
        },
        /**
	 * @private
	 */ onDataSplice: function(start, count) {
            this.getMeta().data.splice(start, count);
            this.insertElements(start, arguments.length - 2);
        },
        /**
	 * @private
	 */ onDataUnshift: function() {
            this.insertElements(0, arguments.length);
        }
    });
    DatasetController.extend = helpers$1.inherits;
    var core_datasetController = DatasetController;
    var TAU = Math.PI * 2;
    core_defaults._set("global", {
        elements: {
            arc: {
                backgroundColor: core_defaults.global.defaultColor,
                borderColor: "#fff",
                borderWidth: 2,
                borderAlign: "center"
            }
        }
    });
    function clipArc(ctx, arc) {
        var startAngle = arc.startAngle;
        var endAngle = arc.endAngle;
        var pixelMargin = arc.pixelMargin;
        var angleMargin = pixelMargin / arc.outerRadius;
        var x = arc.x;
        var y = arc.y;
        // Draw an inner border by cliping the arc and drawing a double-width border
        // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
        ctx.beginPath();
        ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
        if (arc.innerRadius > pixelMargin) {
            angleMargin = pixelMargin / arc.innerRadius;
            ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
        } else ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
        ctx.closePath();
        ctx.clip();
    }
    function drawFullCircleBorders(ctx, vm, arc, inner) {
        var endAngle = arc.endAngle;
        var i;
        if (inner) {
            arc.endAngle = arc.startAngle + TAU;
            clipArc(ctx, arc);
            arc.endAngle = endAngle;
            if (arc.endAngle === arc.startAngle && arc.fullCircles) {
                arc.endAngle += TAU;
                arc.fullCircles--;
            }
        }
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
        for(i = 0; i < arc.fullCircles; ++i)ctx.stroke();
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
        for(i = 0; i < arc.fullCircles; ++i)ctx.stroke();
    }
    function drawBorder(ctx, vm, arc) {
        var inner = vm.borderAlign === "inner";
        if (inner) {
            ctx.lineWidth = vm.borderWidth * 2;
            ctx.lineJoin = "round";
        } else {
            ctx.lineWidth = vm.borderWidth;
            ctx.lineJoin = "bevel";
        }
        if (arc.fullCircles) drawFullCircleBorders(ctx, vm, arc, inner);
        if (inner) clipArc(ctx, arc);
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
        ctx.closePath();
        ctx.stroke();
    }
    var element_arc = core_element.extend({
        _type: "arc",
        inLabelRange: function(mouseX) {
            var vm = this._view;
            if (vm) return Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2);
            return false;
        },
        inRange: function(chartX, chartY) {
            var vm = this._view;
            if (vm) {
                var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {
                    x: chartX,
                    y: chartY
                });
                var angle = pointRelativePosition.angle;
                var distance = pointRelativePosition.distance;
                // Sanitise angle range
                var startAngle = vm.startAngle;
                var endAngle = vm.endAngle;
                while(endAngle < startAngle)endAngle += TAU;
                while(angle > endAngle)angle -= TAU;
                while(angle < startAngle)angle += TAU;
                // Check if within the range of the open/close angle
                var betweenAngles = angle >= startAngle && angle <= endAngle;
                var withinRadius = distance >= vm.innerRadius && distance <= vm.outerRadius;
                return betweenAngles && withinRadius;
            }
            return false;
        },
        getCenterPoint: function() {
            var vm = this._view;
            var halfAngle = (vm.startAngle + vm.endAngle) / 2;
            var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
            return {
                x: vm.x + Math.cos(halfAngle) * halfRadius,
                y: vm.y + Math.sin(halfAngle) * halfRadius
            };
        },
        getArea: function() {
            var vm = this._view;
            return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
        },
        tooltipPosition: function() {
            var vm = this._view;
            var centreAngle = vm.startAngle + (vm.endAngle - vm.startAngle) / 2;
            var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
            return {
                x: vm.x + Math.cos(centreAngle) * rangeFromCentre,
                y: vm.y + Math.sin(centreAngle) * rangeFromCentre
            };
        },
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var pixelMargin = vm.borderAlign === "inner" ? 0.33 : 0;
            var arc = {
                x: vm.x,
                y: vm.y,
                innerRadius: vm.innerRadius,
                outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
                pixelMargin: pixelMargin,
                startAngle: vm.startAngle,
                endAngle: vm.endAngle,
                fullCircles: Math.floor(vm.circumference / TAU)
            };
            var i;
            ctx.save();
            ctx.fillStyle = vm.backgroundColor;
            ctx.strokeStyle = vm.borderColor;
            if (arc.fullCircles) {
                arc.endAngle = arc.startAngle + TAU;
                ctx.beginPath();
                ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
                ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
                ctx.closePath();
                for(i = 0; i < arc.fullCircles; ++i)ctx.fill();
                arc.endAngle = arc.startAngle + vm.circumference % TAU;
            }
            ctx.beginPath();
            ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
            ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
            ctx.closePath();
            ctx.fill();
            if (vm.borderWidth) drawBorder(ctx, vm, arc);
            ctx.restore();
        }
    });
    var valueOrDefault$1 = helpers$1.valueOrDefault;
    var defaultColor = core_defaults.global.defaultColor;
    core_defaults._set("global", {
        elements: {
            line: {
                tension: 0.4,
                backgroundColor: defaultColor,
                borderWidth: 3,
                borderColor: defaultColor,
                borderCapStyle: "butt",
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: "miter",
                capBezierPoints: true,
                fill: true
            }
        }
    });
    var element_line = core_element.extend({
        _type: "line",
        draw: function() {
            var me = this;
            var vm = me._view;
            var ctx = me._chart.ctx;
            var spanGaps = vm.spanGaps;
            var points = me._children.slice(); // clone array
            var globalDefaults = core_defaults.global;
            var globalOptionLineElements = globalDefaults.elements.line;
            var lastDrawnIndex = -1;
            var closePath = me._loop;
            var index, previous, currentVM;
            if (!points.length) return;
            if (me._loop) {
                for(index = 0; index < points.length; ++index){
                    previous = helpers$1.previousItem(points, index);
                    // If the line has an open path, shift the point array
                    if (!points[index]._view.skip && previous._view.skip) {
                        points = points.slice(index).concat(points.slice(0, index));
                        closePath = spanGaps;
                        break;
                    }
                }
                // If the line has a close path, add the first point again
                if (closePath) points.push(points[0]);
            }
            ctx.save();
            // Stroke Line Options
            ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
            // IE 9 and 10 do not support line dash
            if (ctx.setLineDash) ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
            ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
            ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
            ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
            ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
            // Stroke Line
            ctx.beginPath();
            // First point moves to it's starting position no matter what
            currentVM = points[0]._view;
            if (!currentVM.skip) {
                ctx.moveTo(currentVM.x, currentVM.y);
                lastDrawnIndex = 0;
            }
            for(index = 1; index < points.length; ++index){
                currentVM = points[index]._view;
                previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
                if (!currentVM.skip) {
                    if (lastDrawnIndex !== index - 1 && !spanGaps || lastDrawnIndex === -1) // There was a gap and this is the first point after the gap
                    ctx.moveTo(currentVM.x, currentVM.y);
                    else // Line to next point
                    helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
                    lastDrawnIndex = index;
                }
            }
            if (closePath) ctx.closePath();
            ctx.stroke();
            ctx.restore();
        }
    });
    var valueOrDefault$2 = helpers$1.valueOrDefault;
    var defaultColor$1 = core_defaults.global.defaultColor;
    core_defaults._set("global", {
        elements: {
            point: {
                radius: 3,
                pointStyle: "circle",
                backgroundColor: defaultColor$1,
                borderColor: defaultColor$1,
                borderWidth: 1,
                // Hover
                hitRadius: 1,
                hoverRadius: 4,
                hoverBorderWidth: 1
            }
        }
    });
    function xRange(mouseX) {
        var vm = this._view;
        return vm ? Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius : false;
    }
    function yRange(mouseY) {
        var vm = this._view;
        return vm ? Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius : false;
    }
    var element_point = core_element.extend({
        _type: "point",
        inRange: function(mouseX, mouseY) {
            var vm = this._view;
            return vm ? Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2) < Math.pow(vm.hitRadius + vm.radius, 2) : false;
        },
        inLabelRange: xRange,
        inXRange: xRange,
        inYRange: yRange,
        getCenterPoint: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y
            };
        },
        getArea: function() {
            return Math.PI * Math.pow(this._view.radius, 2);
        },
        tooltipPosition: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y,
                padding: vm.radius + vm.borderWidth
            };
        },
        draw: function(chartArea) {
            var vm = this._view;
            var ctx = this._chart.ctx;
            var pointStyle = vm.pointStyle;
            var rotation = vm.rotation;
            var radius = vm.radius;
            var x = vm.x;
            var y = vm.y;
            var globalDefaults = core_defaults.global;
            var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow
            if (vm.skip) return;
            // Clipping for Points.
            if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
                ctx.strokeStyle = vm.borderColor || defaultColor;
                ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
                ctx.fillStyle = vm.backgroundColor || defaultColor;
                helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
            }
        }
    });
    var defaultColor$2 = core_defaults.global.defaultColor;
    core_defaults._set("global", {
        elements: {
            rectangle: {
                backgroundColor: defaultColor$2,
                borderColor: defaultColor$2,
                borderSkipped: "bottom",
                borderWidth: 0
            }
        }
    });
    function isVertical(vm) {
        return vm && vm.width !== undefined;
    }
    /**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */ function getBarBounds(vm) {
        var x1, x2, y1, y2, half;
        if (isVertical(vm)) {
            half = vm.width / 2;
            x1 = vm.x - half;
            x2 = vm.x + half;
            y1 = Math.min(vm.y, vm.base);
            y2 = Math.max(vm.y, vm.base);
        } else {
            half = vm.height / 2;
            x1 = Math.min(vm.x, vm.base);
            x2 = Math.max(vm.x, vm.base);
            y1 = vm.y - half;
            y2 = vm.y + half;
        }
        return {
            left: x1,
            top: y1,
            right: x2,
            bottom: y2
        };
    }
    function swap(orig, v1, v2) {
        return orig === v1 ? v2 : orig === v2 ? v1 : orig;
    }
    function parseBorderSkipped(vm) {
        var edge = vm.borderSkipped;
        var res = {};
        if (!edge) return res;
        if (vm.horizontal) {
            if (vm.base > vm.x) edge = swap(edge, "left", "right");
        } else if (vm.base < vm.y) edge = swap(edge, "bottom", "top");
        res[edge] = true;
        return res;
    }
    function parseBorderWidth(vm, maxW, maxH) {
        var value = vm.borderWidth;
        var skip = parseBorderSkipped(vm);
        var t, r, b, l;
        if (helpers$1.isObject(value)) {
            t = +value.top || 0;
            r = +value.right || 0;
            b = +value.bottom || 0;
            l = +value.left || 0;
        } else t = r = b = l = +value || 0;
        return {
            t: skip.top || t < 0 ? 0 : t > maxH ? maxH : t,
            r: skip.right || r < 0 ? 0 : r > maxW ? maxW : r,
            b: skip.bottom || b < 0 ? 0 : b > maxH ? maxH : b,
            l: skip.left || l < 0 ? 0 : l > maxW ? maxW : l
        };
    }
    function boundingRects(vm) {
        var bounds = getBarBounds(vm);
        var width = bounds.right - bounds.left;
        var height = bounds.bottom - bounds.top;
        var border = parseBorderWidth(vm, width / 2, height / 2);
        return {
            outer: {
                x: bounds.left,
                y: bounds.top,
                w: width,
                h: height
            },
            inner: {
                x: bounds.left + border.l,
                y: bounds.top + border.t,
                w: width - border.l - border.r,
                h: height - border.t - border.b
            }
        };
    }
    function inRange(vm, x, y) {
        var skipX = x === null;
        var skipY = y === null;
        var bounds = !vm || skipX && skipY ? false : getBarBounds(vm);
        return bounds && (skipX || x >= bounds.left && x <= bounds.right) && (skipY || y >= bounds.top && y <= bounds.bottom);
    }
    var element_rectangle = core_element.extend({
        _type: "rectangle",
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var rects = boundingRects(vm);
            var outer = rects.outer;
            var inner = rects.inner;
            ctx.fillStyle = vm.backgroundColor;
            ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
            if (outer.w === inner.w && outer.h === inner.h) return;
            ctx.save();
            ctx.beginPath();
            ctx.rect(outer.x, outer.y, outer.w, outer.h);
            ctx.clip();
            ctx.fillStyle = vm.borderColor;
            ctx.rect(inner.x, inner.y, inner.w, inner.h);
            ctx.fill("evenodd");
            ctx.restore();
        },
        height: function() {
            var vm = this._view;
            return vm.base - vm.y;
        },
        inRange: function(mouseX, mouseY) {
            return inRange(this._view, mouseX, mouseY);
        },
        inLabelRange: function(mouseX, mouseY) {
            var vm = this._view;
            return isVertical(vm) ? inRange(vm, mouseX, null) : inRange(vm, null, mouseY);
        },
        inXRange: function(mouseX) {
            return inRange(this._view, mouseX, null);
        },
        inYRange: function(mouseY) {
            return inRange(this._view, null, mouseY);
        },
        getCenterPoint: function() {
            var vm = this._view;
            var x, y;
            if (isVertical(vm)) {
                x = vm.x;
                y = (vm.y + vm.base) / 2;
            } else {
                x = (vm.x + vm.base) / 2;
                y = vm.y;
            }
            return {
                x: x,
                y: y
            };
        },
        getArea: function() {
            var vm = this._view;
            return isVertical(vm) ? vm.width * Math.abs(vm.y - vm.base) : vm.height * Math.abs(vm.x - vm.base);
        },
        tooltipPosition: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y
            };
        }
    });
    var elements = {};
    var Arc = element_arc;
    var Line = element_line;
    var Point = element_point;
    var Rectangle = element_rectangle;
    elements.Arc = Arc;
    elements.Line = Line;
    elements.Point = Point;
    elements.Rectangle = Rectangle;
    var deprecated = helpers$1._deprecated;
    var valueOrDefault$3 = helpers$1.valueOrDefault;
    core_defaults._set("bar", {
        hover: {
            mode: "label"
        },
        scales: {
            xAxes: [
                {
                    type: "category",
                    offset: true,
                    gridLines: {
                        offsetGridLines: true
                    }
                }
            ],
            yAxes: [
                {
                    type: "linear"
                }
            ]
        }
    });
    core_defaults._set("global", {
        datasets: {
            bar: {
                categoryPercentage: 0.8,
                barPercentage: 0.9
            }
        }
    });
    /**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */ function computeMinSampleSize(scale, pixels) {
        var min = scale._length;
        var prev, curr, i, ilen;
        for(i = 1, ilen = pixels.length; i < ilen; ++i)min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
        for(i = 0, ilen = scale.getTicks().length; i < ilen; ++i){
            curr = scale.getPixelForTick(i);
            min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
            prev = curr;
        }
        return min;
    }
    /**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */ function computeFitCategoryTraits(index, ruler, options) {
        var thickness = options.barThickness;
        var count = ruler.stackCount;
        var curr = ruler.pixels[index];
        var min = helpers$1.isNullOrUndef(thickness) ? computeMinSampleSize(ruler.scale, ruler.pixels) : -1;
        var size, ratio;
        if (helpers$1.isNullOrUndef(thickness)) {
            size = min * options.categoryPercentage;
            ratio = options.barPercentage;
        } else {
            // When bar thickness is enforced, category and bar percentages are ignored.
            // Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
            // and deprecate barPercentage since this value is ignored when thickness is absolute.
            size = thickness * count;
            ratio = 1;
        }
        return {
            chunk: size / count,
            ratio: ratio,
            start: curr - size / 2
        };
    }
    /**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */ function computeFlexCategoryTraits(index, ruler, options) {
        var pixels = ruler.pixels;
        var curr = pixels[index];
        var prev = index > 0 ? pixels[index - 1] : null;
        var next = index < pixels.length - 1 ? pixels[index + 1] : null;
        var percent = options.categoryPercentage;
        var start, size;
        if (prev === null) // first data: its size is double based on the next point or,
        // if it's also the last data, we use the scale size.
        prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
        if (next === null) // last data: its size is also double based on the previous point.
        next = curr + curr - prev;
        start = curr - (curr - Math.min(prev, next)) / 2 * percent;
        size = Math.abs(next - prev) / 2 * percent;
        return {
            chunk: size / ruler.stackCount,
            ratio: options.barPercentage,
            start: start
        };
    }
    var controller_bar = core_datasetController.extend({
        dataElementType: elements.Rectangle,
        /**
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderSkipped",
            "borderWidth",
            "barPercentage",
            "barThickness",
            "categoryPercentage",
            "maxBarThickness",
            "minBarLength"
        ],
        initialize: function() {
            var me = this;
            var meta, scaleOpts;
            core_datasetController.prototype.initialize.apply(me, arguments);
            meta = me.getMeta();
            meta.stack = me.getDataset().stack;
            meta.bar = true;
            scaleOpts = me._getIndexScale().options;
            deprecated("bar chart", scaleOpts.barPercentage, "scales.[x/y]Axes.barPercentage", "dataset.barPercentage");
            deprecated("bar chart", scaleOpts.barThickness, "scales.[x/y]Axes.barThickness", "dataset.barThickness");
            deprecated("bar chart", scaleOpts.categoryPercentage, "scales.[x/y]Axes.categoryPercentage", "dataset.categoryPercentage");
            deprecated("bar chart", me._getValueScale().options.minBarLength, "scales.[x/y]Axes.minBarLength", "dataset.minBarLength");
            deprecated("bar chart", scaleOpts.maxBarThickness, "scales.[x/y]Axes.maxBarThickness", "dataset.maxBarThickness");
        },
        update: function(reset) {
            var me = this;
            var rects = me.getMeta().data;
            var i, ilen;
            me._ruler = me.getRuler();
            for(i = 0, ilen = rects.length; i < ilen; ++i)me.updateElement(rects[i], i, reset);
        },
        updateElement: function(rectangle, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var dataset = me.getDataset();
            var options = me._resolveDataElementOptions(rectangle, index);
            rectangle._xScale = me.getScaleForId(meta.xAxisID);
            rectangle._yScale = me.getScaleForId(meta.yAxisID);
            rectangle._datasetIndex = me.index;
            rectangle._index = index;
            rectangle._model = {
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderSkipped: options.borderSkipped,
                borderWidth: options.borderWidth,
                datasetLabel: dataset.label,
                label: me.chart.data.labels[index]
            };
            if (helpers$1.isArray(dataset.data[index])) rectangle._model.borderSkipped = null;
            me._updateElementGeometry(rectangle, index, reset, options);
            rectangle.pivot();
        },
        /**
	 * @private
	 */ _updateElementGeometry: function(rectangle, index, reset, options) {
            var me = this;
            var model = rectangle._model;
            var vscale = me._getValueScale();
            var base = vscale.getBasePixel();
            var horizontal = vscale.isHorizontal();
            var ruler = me._ruler || me.getRuler();
            var vpixels = me.calculateBarValuePixels(me.index, index, options);
            var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
            model.horizontal = horizontal;
            model.base = reset ? base : vpixels.base;
            model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
            model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
            model.height = horizontal ? ipixels.size : undefined;
            model.width = horizontal ? undefined : ipixels.size;
        },
        /**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */ _getStacks: function(last) {
            var me = this;
            var scale = me._getIndexScale();
            var metasets = scale._getMatchingVisibleMetas(me._type);
            var stacked = scale.options.stacked;
            var ilen = metasets.length;
            var stacks = [];
            var i, meta;
            for(i = 0; i < ilen; ++i){
                meta = metasets[i];
                // stacked   | meta.stack
                //           | found | not found | undefined
                // false     |   x   |     x     |     x
                // true      |       |     x     |
                // undefined |       |     x     |     x
                if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
                if (meta.index === last) break;
            }
            return stacks;
        },
        /**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */ getStackCount: function() {
            return this._getStacks().length;
        },
        /**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */ getStackIndex: function(datasetIndex, name) {
            var stacks = this._getStacks(datasetIndex);
            var index = name !== undefined ? stacks.indexOf(name) : -1; // indexOf returns -1 if element is not present
            return index === -1 ? stacks.length - 1 : index;
        },
        /**
	 * @private
	 */ getRuler: function() {
            var me = this;
            var scale = me._getIndexScale();
            var pixels = [];
            var i, ilen;
            for(i = 0, ilen = me.getMeta().data.length; i < ilen; ++i)pixels.push(scale.getPixelForValue(null, i, me.index));
            return {
                pixels: pixels,
                start: scale._startPixel,
                end: scale._endPixel,
                stackCount: me.getStackCount(),
                scale: scale
            };
        },
        /**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */ calculateBarValuePixels: function(datasetIndex, index, options) {
            var me = this;
            var chart = me.chart;
            var scale = me._getValueScale();
            var isHorizontal = scale.isHorizontal();
            var datasets = chart.data.datasets;
            var metasets = scale._getMatchingVisibleMetas(me._type);
            var value = scale._parseValue(datasets[datasetIndex].data[index]);
            var minBarLength = options.minBarLength;
            var stacked = scale.options.stacked;
            var stack = me.getMeta().stack;
            var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
            var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
            var ilen = metasets.length;
            var i, imeta, ivalue, base, head, size, stackLength;
            if (stacked || stacked === undefined && stack !== undefined) for(i = 0; i < ilen; ++i){
                imeta = metasets[i];
                if (imeta.index === datasetIndex) break;
                if (imeta.stack === stack) {
                    stackLength = scale._parseValue(datasets[imeta.index].data[index]);
                    ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
                    if (value.min < 0 && ivalue < 0 || value.max >= 0 && ivalue > 0) start += ivalue;
                }
            }
            base = scale.getPixelForValue(start);
            head = scale.getPixelForValue(start + length);
            size = head - base;
            if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
                size = minBarLength;
                if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) head = base - minBarLength;
                else head = base + minBarLength;
            }
            return {
                size: size,
                base: base,
                head: head,
                center: head + size / 2
            };
        },
        /**
	 * @private
	 */ calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
            var me = this;
            var range = options.barThickness === "flex" ? computeFlexCategoryTraits(index, ruler, options) : computeFitCategoryTraits(index, ruler, options);
            var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
            var center = range.start + range.chunk * stackIndex + range.chunk / 2;
            var size = Math.min(valueOrDefault$3(options.maxBarThickness, Infinity), range.chunk * range.ratio);
            return {
                base: center - size / 2,
                head: center + size / 2,
                center: center,
                size: size
            };
        },
        draw: function() {
            var me = this;
            var chart = me.chart;
            var scale = me._getValueScale();
            var rects = me.getMeta().data;
            var dataset = me.getDataset();
            var ilen = rects.length;
            var i = 0;
            helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
            for(; i < ilen; ++i){
                var val = scale._parseValue(dataset.data[i]);
                if (!isNaN(val.min) && !isNaN(val.max)) rects[i].draw();
            }
            helpers$1.canvas.unclipArea(chart.ctx);
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function() {
            var me = this;
            var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
            var indexOpts = me._getIndexScale().options;
            var valueOpts = me._getValueScale().options;
            values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
            values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
            values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
            values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
            values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
            return values;
        }
    });
    var valueOrDefault$4 = helpers$1.valueOrDefault;
    var resolve$1 = helpers$1.options.resolve;
    core_defaults._set("bubble", {
        hover: {
            mode: "single"
        },
        scales: {
            xAxes: [
                {
                    type: "linear",
                    position: "bottom",
                    id: "x-axis-0" // need an ID so datasets can reference the scale
                }
            ],
            yAxes: [
                {
                    type: "linear",
                    position: "left",
                    id: "y-axis-0"
                }
            ]
        },
        tooltips: {
            callbacks: {
                title: function() {
                    // Title doesn't make sense for scatter since we format the data as a point
                    return "";
                },
                label: function(item, data) {
                    var datasetLabel = data.datasets[item.datasetIndex].label || "";
                    var dataPoint = data.datasets[item.datasetIndex].data[item.index];
                    return datasetLabel + ": (" + item.xLabel + ", " + item.yLabel + ", " + dataPoint.r + ")";
                }
            }
        }
    });
    var controller_bubble = core_datasetController.extend({
        /**
	 * @protected
	 */ dataElementType: elements.Point,
        /**
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderWidth",
            "hoverBackgroundColor",
            "hoverBorderColor",
            "hoverBorderWidth",
            "hoverRadius",
            "hitRadius",
            "pointStyle",
            "rotation"
        ],
        /**
	 * @protected
	 */ update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var points = meta.data;
            // Update Points
            helpers$1.each(points, function(point, index) {
                me.updateElement(point, index, reset);
            });
        },
        /**
	 * @protected
	 */ updateElement: function(point, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var custom = point.custom || {};
            var xScale = me.getScaleForId(meta.xAxisID);
            var yScale = me.getScaleForId(meta.yAxisID);
            var options = me._resolveDataElementOptions(point, index);
            var data = me.getDataset().data[index];
            var dsIndex = me.index;
            var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === "object" ? data : NaN, index, dsIndex);
            var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
            point._xScale = xScale;
            point._yScale = yScale;
            point._options = options;
            point._datasetIndex = dsIndex;
            point._index = index;
            point._model = {
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                hitRadius: options.hitRadius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                radius: reset ? 0 : options.radius,
                skip: custom.skip || isNaN(x) || isNaN(y),
                x: x,
                y: y
            };
            point.pivot();
        },
        /**
	 * @protected
	 */ setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
            model.radius = options.radius + options.hoverRadius;
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function(point, index) {
            var me = this;
            var chart = me.chart;
            var dataset = me.getDataset();
            var custom = point.custom || {};
            var data = dataset.data[index] || {};
            var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
            // Scriptable options
            var context = {
                chart: chart,
                dataIndex: index,
                dataset: dataset,
                datasetIndex: me.index
            };
            // In case values were cached (and thus frozen), we need to clone the values
            if (me._cachedDataOpts === values) values = helpers$1.extend({}, values);
            // Custom radius resolution
            values.radius = resolve$1([
                custom.radius,
                data.r,
                me._config.radius,
                chart.options.elements.point.radius
            ], context, index);
            return values;
        }
    });
    var valueOrDefault$5 = helpers$1.valueOrDefault;
    var PI$1 = Math.PI;
    var DOUBLE_PI$1 = PI$1 * 2;
    var HALF_PI$1 = PI$1 / 2;
    core_defaults._set("doughnut", {
        animation: {
            // Boolean - Whether we animate the rotation of the Doughnut
            animateRotate: true,
            // Boolean - Whether we animate scaling the Doughnut from the centre
            animateScale: false
        },
        hover: {
            mode: "single"
        },
        legendCallback: function(chart) {
            var list = document.createElement("ul");
            var data = chart.data;
            var datasets = data.datasets;
            var labels = data.labels;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute("class", chart.id + "-legend");
            if (datasets.length) for(i = 0, ilen = datasets[0].data.length; i < ilen; ++i){
                listItem = list.appendChild(document.createElement("li"));
                listItemSpan = listItem.appendChild(document.createElement("span"));
                listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
                if (labels[i]) listItem.appendChild(document.createTextNode(labels[i]));
            }
            return list.outerHTML;
        },
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            strokeStyle: style.borderColor,
                            lineWidth: style.borderWidth,
                            hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                            // Extra data used for toggling the correct item
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function(e, legendItem) {
                var index = legendItem.index;
                var chart = this.chart;
                var i, ilen, meta;
                for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i){
                    meta = chart.getDatasetMeta(i);
                    // toggle visibility of index if exists
                    if (meta.data[index]) meta.data[index].hidden = !meta.data[index].hidden;
                }
                chart.update();
            }
        },
        // The percentage of the chart that we cut out of the middle.
        cutoutPercentage: 50,
        // The rotation of the chart, where the first data arc begins.
        rotation: -HALF_PI$1,
        // The total circumference of the chart.
        circumference: DOUBLE_PI$1,
        // Need to override these to give a nice default
        tooltips: {
            callbacks: {
                title: function() {
                    return "";
                },
                label: function(tooltipItem, data) {
                    var dataLabel = data.labels[tooltipItem.index];
                    var value = ": " + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    if (helpers$1.isArray(dataLabel)) {
                        // show value on first line of multiline label
                        // need to clone because we are changing the value
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else dataLabel += value;
                    return dataLabel;
                }
            }
        }
    });
    var controller_doughnut = core_datasetController.extend({
        dataElementType: elements.Arc,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderWidth",
            "borderAlign",
            "hoverBackgroundColor",
            "hoverBorderColor",
            "hoverBorderWidth"
        ],
        // Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
        getRingIndex: function(datasetIndex) {
            var ringIndex = 0;
            for(var j = 0; j < datasetIndex; ++j)if (this.chart.isDatasetVisible(j)) ++ringIndex;
            return ringIndex;
        },
        update: function(reset) {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var ratioX = 1;
            var ratioY = 1;
            var offsetX = 0;
            var offsetY = 0;
            var meta = me.getMeta();
            var arcs = meta.data;
            var cutout = opts.cutoutPercentage / 100 || 0;
            var circumference = opts.circumference;
            var chartWeight = me._getRingWeight(me.index);
            var maxWidth, maxHeight, i, ilen;
            // If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
            if (circumference < DOUBLE_PI$1) {
                var startAngle = opts.rotation % DOUBLE_PI$1;
                startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
                var endAngle = startAngle + circumference;
                var startX = Math.cos(startAngle);
                var startY = Math.sin(startAngle);
                var endX = Math.cos(endAngle);
                var endY = Math.sin(endAngle);
                var contains0 = startAngle <= 0 && endAngle >= 0 || endAngle >= DOUBLE_PI$1;
                var contains90 = startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1 || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
                var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
                var contains270 = startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1 || endAngle >= PI$1 + HALF_PI$1;
                var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
                var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
                var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
                var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
                ratioX = (maxX - minX) / 2;
                ratioY = (maxY - minY) / 2;
                offsetX = -(maxX + minX) / 2;
                offsetY = -(maxY + minY) / 2;
            }
            for(i = 0, ilen = arcs.length; i < ilen; ++i)arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
            chart.borderWidth = me.getMaxBorderWidth();
            maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
            maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
            chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
            chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
            chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
            chart.offsetX = offsetX * chart.outerRadius;
            chart.offsetY = offsetY * chart.outerRadius;
            meta.total = me.calculateTotal();
            me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
            me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
            for(i = 0, ilen = arcs.length; i < ilen; ++i)me.updateElement(arcs[i], i, reset);
        },
        updateElement: function(arc, index, reset) {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var animationOpts = opts.animation;
            var centerX = (chartArea.left + chartArea.right) / 2;
            var centerY = (chartArea.top + chartArea.bottom) / 2;
            var startAngle = opts.rotation; // non reset case handled later
            var endAngle = opts.rotation; // non reset case handled later
            var dataset = me.getDataset();
            var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
            var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
            var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
            var options = arc._options || {};
            helpers$1.extend(arc, {
                // Utility
                _datasetIndex: me.index,
                _index: index,
                // Desired view properties
                _model: {
                    backgroundColor: options.backgroundColor,
                    borderColor: options.borderColor,
                    borderWidth: options.borderWidth,
                    borderAlign: options.borderAlign,
                    x: centerX + chart.offsetX,
                    y: centerY + chart.offsetY,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    circumference: circumference,
                    outerRadius: outerRadius,
                    innerRadius: innerRadius,
                    label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
                }
            });
            var model = arc._model;
            // Set correct angles if not resetting
            if (!reset || !animationOpts.animateRotate) {
                if (index === 0) model.startAngle = opts.rotation;
                else model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
                model.endAngle = model.startAngle + model.circumference;
            }
            arc.pivot();
        },
        calculateTotal: function() {
            var dataset = this.getDataset();
            var meta = this.getMeta();
            var total = 0;
            var value;
            helpers$1.each(meta.data, function(element, index) {
                value = dataset.data[index];
                if (!isNaN(value) && !element.hidden) total += Math.abs(value);
            });
            /* if (total === 0) {
			total = NaN;
		}*/ return total;
        },
        calculateCircumference: function(value) {
            var total = this.getMeta().total;
            if (total > 0 && !isNaN(value)) return DOUBLE_PI$1 * (Math.abs(value) / total);
            return 0;
        },
        // gets the max border or hover width to properly scale pie charts
        getMaxBorderWidth: function(arcs) {
            var me = this;
            var max = 0;
            var chart = me.chart;
            var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
            if (!arcs) {
                // Find the outmost visible dataset
                for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                    meta = chart.getDatasetMeta(i);
                    arcs = meta.data;
                    if (i !== me.index) controller = meta.controller;
                    break;
                }
            }
            if (!arcs) return 0;
            for(i = 0, ilen = arcs.length; i < ilen; ++i){
                arc = arcs[i];
                if (controller) {
                    controller._configure();
                    options = controller._resolveDataElementOptions(arc, i);
                } else options = arc._options;
                if (options.borderAlign !== "inner") {
                    borderWidth = options.borderWidth;
                    hoverWidth = options.hoverBorderWidth;
                    max = borderWidth > max ? borderWidth : max;
                    max = hoverWidth > max ? hoverWidth : max;
                }
            }
            return max;
        },
        /**
	 * @protected
	 */ setHoverStyle: function(arc) {
            var model = arc._model;
            var options = arc._options;
            var getHoverColor = helpers$1.getHoverColor;
            arc.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
        },
        /**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */ _getRingWeightOffset: function(datasetIndex) {
            var ringWeightOffset = 0;
            for(var i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
            return ringWeightOffset;
        },
        /**
	 * @private
	 */ _getRingWeight: function(dataSetIndex) {
            return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
        },
        /**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */ _getVisibleDatasetWeightTotal: function() {
            return this._getRingWeightOffset(this.chart.data.datasets.length);
        }
    });
    core_defaults._set("horizontalBar", {
        hover: {
            mode: "index",
            axis: "y"
        },
        scales: {
            xAxes: [
                {
                    type: "linear",
                    position: "bottom"
                }
            ],
            yAxes: [
                {
                    type: "category",
                    position: "left",
                    offset: true,
                    gridLines: {
                        offsetGridLines: true
                    }
                }
            ]
        },
        elements: {
            rectangle: {
                borderSkipped: "left"
            }
        },
        tooltips: {
            mode: "index",
            axis: "y"
        }
    });
    core_defaults._set("global", {
        datasets: {
            horizontalBar: {
                categoryPercentage: 0.8,
                barPercentage: 0.9
            }
        }
    });
    var controller_horizontalBar = controller_bar.extend({
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.getMeta().xAxisID;
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.getMeta().yAxisID;
        }
    });
    var valueOrDefault$6 = helpers$1.valueOrDefault;
    var resolve$2 = helpers$1.options.resolve;
    var isPointInArea = helpers$1.canvas._isPointInArea;
    core_defaults._set("line", {
        showLines: true,
        spanGaps: false,
        hover: {
            mode: "label"
        },
        scales: {
            xAxes: [
                {
                    type: "category",
                    id: "x-axis-0"
                }
            ],
            yAxes: [
                {
                    type: "linear",
                    id: "y-axis-0"
                }
            ]
        }
    });
    function scaleClip(scale, halfBorderWidth) {
        var tickOpts = scale && scale.options.ticks || {};
        var reverse = tickOpts.reverse;
        var min = tickOpts.min === undefined ? halfBorderWidth : 0;
        var max = tickOpts.max === undefined ? halfBorderWidth : 0;
        return {
            start: reverse ? max : min,
            end: reverse ? min : max
        };
    }
    function defaultClip(xScale, yScale, borderWidth) {
        var halfBorderWidth = borderWidth / 2;
        var x = scaleClip(xScale, halfBorderWidth);
        var y = scaleClip(yScale, halfBorderWidth);
        return {
            top: y.end,
            right: x.end,
            bottom: y.start,
            left: x.start
        };
    }
    function toClip(value) {
        var t, r, b, l;
        if (helpers$1.isObject(value)) {
            t = value.top;
            r = value.right;
            b = value.bottom;
            l = value.left;
        } else t = r = b = l = value;
        return {
            top: t,
            right: r,
            bottom: b,
            left: l
        };
    }
    var controller_line = core_datasetController.extend({
        datasetElementType: elements.Line,
        dataElementType: elements.Point,
        /**
	 * @private
	 */ _datasetElementOptions: [
            "backgroundColor",
            "borderCapStyle",
            "borderColor",
            "borderDash",
            "borderDashOffset",
            "borderJoinStyle",
            "borderWidth",
            "cubicInterpolationMode",
            "fill"
        ],
        /**
	 * @private
	 */ _dataElementOptions: {
            backgroundColor: "pointBackgroundColor",
            borderColor: "pointBorderColor",
            borderWidth: "pointBorderWidth",
            hitRadius: "pointHitRadius",
            hoverBackgroundColor: "pointHoverBackgroundColor",
            hoverBorderColor: "pointHoverBorderColor",
            hoverBorderWidth: "pointHoverBorderWidth",
            hoverRadius: "pointHoverRadius",
            pointStyle: "pointStyle",
            radius: "pointRadius",
            rotation: "pointRotation"
        },
        update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var line = meta.dataset;
            var points = meta.data || [];
            var options = me.chart.options;
            var config = me._config;
            var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
            var i, ilen;
            me._xScale = me.getScaleForId(meta.xAxisID);
            me._yScale = me.getScaleForId(meta.yAxisID);
            // Update Line
            if (showLine) {
                // Compatibility: If the properties are defined with only the old name, use those values
                if (config.tension !== undefined && config.lineTension === undefined) config.lineTension = config.tension;
                // Utility
                line._scale = me._yScale;
                line._datasetIndex = me.index;
                // Data
                line._children = points;
                // Model
                line._model = me._resolveDatasetElementOptions(line);
                line.pivot();
            }
            // Update Points
            for(i = 0, ilen = points.length; i < ilen; ++i)me.updateElement(points[i], i, reset);
            if (showLine && line._model.tension !== 0) me.updateBezierControlPoints();
            // Now pivot the point for animation
            for(i = 0, ilen = points.length; i < ilen; ++i)points[i].pivot();
        },
        updateElement: function(point, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var custom = point.custom || {};
            var dataset = me.getDataset();
            var datasetIndex = me.index;
            var value = dataset.data[index];
            var xScale = me._xScale;
            var yScale = me._yScale;
            var lineModel = meta.dataset._model;
            var x, y;
            var options = me._resolveDataElementOptions(point, index);
            x = xScale.getPixelForValue(typeof value === "object" ? value : NaN, index, datasetIndex);
            y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
            // Utility
            point._xScale = xScale;
            point._yScale = yScale;
            point._options = options;
            point._datasetIndex = datasetIndex;
            point._index = index;
            // Desired view properties
            point._model = {
                x: x,
                y: y,
                skip: custom.skip || isNaN(x) || isNaN(y),
                // Appearance
                radius: options.radius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
                steppedLine: lineModel ? lineModel.steppedLine : false,
                // Tooltip
                hitRadius: options.hitRadius
            };
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function(element) {
            var me = this;
            var config = me._config;
            var custom = element.custom || {};
            var options = me.chart.options;
            var lineOptions = options.elements.line;
            var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
            // The default behavior of lines is to break at null values, according
            // to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
            // This option gives lines the ability to span gaps
            values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
            values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
            values.steppedLine = resolve$2([
                custom.steppedLine,
                config.steppedLine,
                lineOptions.stepped
            ]);
            values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
            return values;
        },
        calculatePointY: function(value, index, datasetIndex) {
            var me = this;
            var chart = me.chart;
            var yScale = me._yScale;
            var sumPos = 0;
            var sumNeg = 0;
            var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
            if (yScale.options.stacked) {
                rightValue = +yScale.getRightValue(value);
                metasets = chart._getSortedVisibleDatasetMetas();
                ilen = metasets.length;
                for(i = 0; i < ilen; ++i){
                    dsMeta = metasets[i];
                    if (dsMeta.index === datasetIndex) break;
                    ds = chart.data.datasets[dsMeta.index];
                    if (dsMeta.type === "line" && dsMeta.yAxisID === yScale.id) {
                        stackedRightValue = +yScale.getRightValue(ds.data[index]);
                        if (stackedRightValue < 0) sumNeg += stackedRightValue || 0;
                        else sumPos += stackedRightValue || 0;
                    }
                }
                if (rightValue < 0) return yScale.getPixelForValue(sumNeg + rightValue);
                return yScale.getPixelForValue(sumPos + rightValue);
            }
            return yScale.getPixelForValue(value);
        },
        updateBezierControlPoints: function() {
            var me = this;
            var chart = me.chart;
            var meta = me.getMeta();
            var lineModel = meta.dataset._model;
            var area = chart.chartArea;
            var points = meta.data || [];
            var i, ilen, model, controlPoints;
            // Only consider points that are drawn in case the spanGaps option is used
            if (lineModel.spanGaps) points = points.filter(function(pt) {
                return !pt._model.skip;
            });
            function capControlPoint(pt, min, max) {
                return Math.max(Math.min(pt, max), min);
            }
            if (lineModel.cubicInterpolationMode === "monotone") helpers$1.splineCurveMonotone(points);
            else for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i)._model, model, helpers$1.nextItem(points, i)._model, lineModel.tension);
                model.controlPointPreviousX = controlPoints.previous.x;
                model.controlPointPreviousY = controlPoints.previous.y;
                model.controlPointNextX = controlPoints.next.x;
                model.controlPointNextY = controlPoints.next.y;
            }
            if (chart.options.elements.line.capBezierPoints) for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                if (isPointInArea(model, area)) {
                    if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
                        model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
                        model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
                    }
                    if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
                        model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
                        model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
                    }
                }
            }
        },
        draw: function() {
            var me = this;
            var chart = me.chart;
            var meta = me.getMeta();
            var points = meta.data || [];
            var area = chart.chartArea;
            var canvas = chart.canvas;
            var i = 0;
            var ilen = points.length;
            var clip;
            if (me._showLine) {
                clip = meta.dataset._model.clip;
                helpers$1.canvas.clipArea(chart.ctx, {
                    left: clip.left === false ? 0 : area.left - clip.left,
                    right: clip.right === false ? canvas.width : area.right + clip.right,
                    top: clip.top === false ? 0 : area.top - clip.top,
                    bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
                });
                meta.dataset.draw();
                helpers$1.canvas.unclipArea(chart.ctx);
            }
            // Draw the points
            for(; i < ilen; ++i)points[i].draw(area);
        },
        /**
	 * @protected
	 */ setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
            model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
        }
    });
    var resolve$3 = helpers$1.options.resolve;
    core_defaults._set("polarArea", {
        scale: {
            type: "radialLinear",
            angleLines: {
                display: false
            },
            gridLines: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            ticks: {
                beginAtZero: true
            }
        },
        // Boolean - Whether to animate the rotation of the chart
        animation: {
            animateRotate: true,
            animateScale: true
        },
        startAngle: -0.5 * Math.PI,
        legendCallback: function(chart) {
            var list = document.createElement("ul");
            var data = chart.data;
            var datasets = data.datasets;
            var labels = data.labels;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute("class", chart.id + "-legend");
            if (datasets.length) for(i = 0, ilen = datasets[0].data.length; i < ilen; ++i){
                listItem = list.appendChild(document.createElement("li"));
                listItemSpan = listItem.appendChild(document.createElement("span"));
                listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
                if (labels[i]) listItem.appendChild(document.createTextNode(labels[i]));
            }
            return list.outerHTML;
        },
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            strokeStyle: style.borderColor,
                            lineWidth: style.borderWidth,
                            hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                            // Extra data used for toggling the correct item
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function(e, legendItem) {
                var index = legendItem.index;
                var chart = this.chart;
                var i, ilen, meta;
                for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i){
                    meta = chart.getDatasetMeta(i);
                    meta.data[index].hidden = !meta.data[index].hidden;
                }
                chart.update();
            }
        },
        // Need to override these to give a nice default
        tooltips: {
            callbacks: {
                title: function() {
                    return "";
                },
                label: function(item, data) {
                    return data.labels[item.index] + ": " + item.yLabel;
                }
            }
        }
    });
    var controller_polarArea = core_datasetController.extend({
        dataElementType: elements.Arc,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderWidth",
            "borderAlign",
            "hoverBackgroundColor",
            "hoverBorderColor",
            "hoverBorderWidth"
        ],
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.chart.scale.id;
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.chart.scale.id;
        },
        update: function(reset) {
            var me = this;
            var dataset = me.getDataset();
            var meta = me.getMeta();
            var start = me.chart.options.startAngle || 0;
            var starts = me._starts = [];
            var angles = me._angles = [];
            var arcs = meta.data;
            var i, ilen, angle;
            me._updateRadius();
            meta.count = me.countVisibleElements();
            for(i = 0, ilen = dataset.data.length; i < ilen; i++){
                starts[i] = start;
                angle = me._computeAngle(i);
                angles[i] = angle;
                start += angle;
            }
            for(i = 0, ilen = arcs.length; i < ilen; ++i){
                arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
                me.updateElement(arcs[i], i, reset);
            }
        },
        /**
	 * @private
	 */ _updateRadius: function() {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
            chart.outerRadius = Math.max(minSize / 2, 0);
            chart.innerRadius = Math.max(opts.cutoutPercentage ? chart.outerRadius / 100 * opts.cutoutPercentage : 1, 0);
            chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
            me.outerRadius = chart.outerRadius - chart.radiusLength * me.index;
            me.innerRadius = me.outerRadius - chart.radiusLength;
        },
        updateElement: function(arc, index, reset) {
            var me = this;
            var chart = me.chart;
            var dataset = me.getDataset();
            var opts = chart.options;
            var animationOpts = opts.animation;
            var scale = chart.scale;
            var labels = chart.data.labels;
            var centerX = scale.xCenter;
            var centerY = scale.yCenter;
            // var negHalfPI = -0.5 * Math.PI;
            var datasetStartAngle = opts.startAngle;
            var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
            var startAngle = me._starts[index];
            var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
            var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
            var options = arc._options || {};
            helpers$1.extend(arc, {
                // Utility
                _datasetIndex: me.index,
                _index: index,
                _scale: scale,
                // Desired view properties
                _model: {
                    backgroundColor: options.backgroundColor,
                    borderColor: options.borderColor,
                    borderWidth: options.borderWidth,
                    borderAlign: options.borderAlign,
                    x: centerX,
                    y: centerY,
                    innerRadius: 0,
                    outerRadius: reset ? resetRadius : distance,
                    startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
                    endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
                    label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
                }
            });
            arc.pivot();
        },
        countVisibleElements: function() {
            var dataset = this.getDataset();
            var meta = this.getMeta();
            var count = 0;
            helpers$1.each(meta.data, function(element, index) {
                if (!isNaN(dataset.data[index]) && !element.hidden) count++;
            });
            return count;
        },
        /**
	 * @protected
	 */ setHoverStyle: function(arc) {
            var model = arc._model;
            var options = arc._options;
            var getHoverColor = helpers$1.getHoverColor;
            var valueOrDefault = helpers$1.valueOrDefault;
            arc.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
        },
        /**
	 * @private
	 */ _computeAngle: function(index) {
            var me = this;
            var count = this.getMeta().count;
            var dataset = me.getDataset();
            var meta = me.getMeta();
            if (isNaN(dataset.data[index]) || meta.data[index].hidden) return 0;
            // Scriptable options
            var context = {
                chart: me.chart,
                dataIndex: index,
                dataset: dataset,
                datasetIndex: me.index
            };
            return resolve$3([
                me.chart.options.elements.arc.angle,
                2 * Math.PI / count
            ], context, index);
        }
    });
    core_defaults._set("pie", helpers$1.clone(core_defaults.doughnut));
    core_defaults._set("pie", {
        cutoutPercentage: 0
    });
    // Pie charts are Doughnut chart with different defaults
    var controller_pie = controller_doughnut;
    var valueOrDefault$7 = helpers$1.valueOrDefault;
    core_defaults._set("radar", {
        spanGaps: false,
        scale: {
            type: "radialLinear"
        },
        elements: {
            line: {
                fill: "start",
                tension: 0 // no bezier in radar
            }
        }
    });
    var controller_radar = core_datasetController.extend({
        datasetElementType: elements.Line,
        dataElementType: elements.Point,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _datasetElementOptions: [
            "backgroundColor",
            "borderWidth",
            "borderColor",
            "borderCapStyle",
            "borderDash",
            "borderDashOffset",
            "borderJoinStyle",
            "fill"
        ],
        /**
	 * @private
	 */ _dataElementOptions: {
            backgroundColor: "pointBackgroundColor",
            borderColor: "pointBorderColor",
            borderWidth: "pointBorderWidth",
            hitRadius: "pointHitRadius",
            hoverBackgroundColor: "pointHoverBackgroundColor",
            hoverBorderColor: "pointHoverBorderColor",
            hoverBorderWidth: "pointHoverBorderWidth",
            hoverRadius: "pointHoverRadius",
            pointStyle: "pointStyle",
            radius: "pointRadius",
            rotation: "pointRotation"
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.chart.scale.id;
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.chart.scale.id;
        },
        update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var line = meta.dataset;
            var points = meta.data || [];
            var scale = me.chart.scale;
            var config = me._config;
            var i, ilen;
            // Compatibility: If the properties are defined with only the old name, use those values
            if (config.tension !== undefined && config.lineTension === undefined) config.lineTension = config.tension;
            // Utility
            line._scale = scale;
            line._datasetIndex = me.index;
            // Data
            line._children = points;
            line._loop = true;
            // Model
            line._model = me._resolveDatasetElementOptions(line);
            line.pivot();
            // Update Points
            for(i = 0, ilen = points.length; i < ilen; ++i)me.updateElement(points[i], i, reset);
            // Update bezier control points
            me.updateBezierControlPoints();
            // Now pivot the point for animation
            for(i = 0, ilen = points.length; i < ilen; ++i)points[i].pivot();
        },
        updateElement: function(point, index, reset) {
            var me = this;
            var custom = point.custom || {};
            var dataset = me.getDataset();
            var scale = me.chart.scale;
            var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
            var options = me._resolveDataElementOptions(point, index);
            var lineModel = me.getMeta().dataset._model;
            var x = reset ? scale.xCenter : pointPosition.x;
            var y = reset ? scale.yCenter : pointPosition.y;
            // Utility
            point._scale = scale;
            point._options = options;
            point._datasetIndex = me.index;
            point._index = index;
            // Desired view properties
            point._model = {
                x: x,
                y: y,
                skip: custom.skip || isNaN(x) || isNaN(y),
                // Appearance
                radius: options.radius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
                // Tooltip
                hitRadius: options.hitRadius
            };
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function() {
            var me = this;
            var config = me._config;
            var options = me.chart.options;
            var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
            values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
            values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
            return values;
        },
        updateBezierControlPoints: function() {
            var me = this;
            var meta = me.getMeta();
            var area = me.chart.chartArea;
            var points = meta.data || [];
            var i, ilen, model, controlPoints;
            // Only consider points that are drawn in case the spanGaps option is used
            if (meta.dataset._model.spanGaps) points = points.filter(function(pt) {
                return !pt._model.skip;
            });
            function capControlPoint(pt, min, max) {
                return Math.max(Math.min(pt, max), min);
            }
            for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i, true)._model, model, helpers$1.nextItem(points, i, true)._model, model.tension);
                // Prevent the bezier going outside of the bounds of the graph
                model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
                model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
                model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
                model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
            }
        },
        setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
            model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
        }
    });
    core_defaults._set("scatter", {
        hover: {
            mode: "single"
        },
        scales: {
            xAxes: [
                {
                    id: "x-axis-1",
                    type: "linear",
                    position: "bottom"
                }
            ],
            yAxes: [
                {
                    id: "y-axis-1",
                    type: "linear",
                    position: "left"
                }
            ]
        },
        tooltips: {
            callbacks: {
                title: function() {
                    return ""; // doesn't make sense for scatter since data are formatted as a point
                },
                label: function(item) {
                    return "(" + item.xLabel + ", " + item.yLabel + ")";
                }
            }
        }
    });
    core_defaults._set("global", {
        datasets: {
            scatter: {
                showLine: false
            }
        }
    });
    // Scatter charts use line controllers
    var controller_scatter = controller_line;
    // NOTE export a map in which the key represents the controller type, not
    // the class, and so must be CamelCase in order to be correctly retrieved
    // by the controller in core.controller.js (`controllers[meta.type]`).
    var controllers = {
        bar: controller_bar,
        bubble: controller_bubble,
        doughnut: controller_doughnut,
        horizontalBar: controller_horizontalBar,
        line: controller_line,
        polarArea: controller_polarArea,
        pie: controller_pie,
        radar: controller_radar,
        scatter: controller_scatter
    };
    /**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */ function getRelativePosition(e, chart) {
        if (e.native) return {
            x: e.x,
            y: e.y
        };
        return helpers$1.getRelativePosition(e, chart);
    }
    /**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */ function parseVisibleItems(chart, handler) {
        var metasets = chart._getSortedVisibleDatasetMetas();
        var metadata, i, j, ilen, jlen, element;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            metadata = metasets[i].data;
            for(j = 0, jlen = metadata.length; j < jlen; ++j){
                element = metadata[j];
                if (!element._view.skip) handler(element);
            }
        }
    }
    /**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */ function getIntersectItems(chart, position) {
        var elements = [];
        parseVisibleItems(chart, function(element) {
            if (element.inRange(position.x, position.y)) elements.push(element);
        });
        return elements;
    }
    /**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */ function getNearestItems(chart, position, intersect, distanceMetric) {
        var minDistance = Number.POSITIVE_INFINITY;
        var nearestItems = [];
        parseVisibleItems(chart, function(element) {
            if (intersect && !element.inRange(position.x, position.y)) return;
            var center = element.getCenterPoint();
            var distance = distanceMetric(position, center);
            if (distance < minDistance) {
                nearestItems = [
                    element
                ];
                minDistance = distance;
            } else if (distance === minDistance) // Can have multiple items at the same distance in which case we sort by size
            nearestItems.push(element);
        });
        return nearestItems;
    }
    /**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */ function getDistanceMetricForAxis(axis) {
        var useX = axis.indexOf("x") !== -1;
        var useY = axis.indexOf("y") !== -1;
        return function(pt1, pt2) {
            var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
            var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
            return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
        };
    }
    function indexMode(chart, e, options) {
        var position = getRelativePosition(e, chart);
        // Default axis for index mode is 'x' to match old behaviour
        options.axis = options.axis || "x";
        var distanceMetric = getDistanceMetricForAxis(options.axis);
        var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
        var elements = [];
        if (!items.length) return [];
        chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
            var element = meta.data[items[0]._index];
            // don't count items that are skipped (null data)
            if (element && !element._view.skip) elements.push(element);
        });
        return elements;
    }
    /**
 * @interface IInteractionOptions
 */ /**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */ /**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */ var core_interaction = {
        // Helper function for different modes
        modes: {
            single: function(chart, e) {
                var position = getRelativePosition(e, chart);
                var elements = [];
                parseVisibleItems(chart, function(element) {
                    if (element.inRange(position.x, position.y)) {
                        elements.push(element);
                        return elements;
                    }
                });
                return elements.slice(0, 1);
            },
            /**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */ label: indexMode,
            /**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ index: indexMode,
            /**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ dataset: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                options.axis = options.axis || "xy";
                var distanceMetric = getDistanceMetricForAxis(options.axis);
                var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
                if (items.length > 0) items = chart.getDatasetMeta(items[0]._datasetIndex).data;
                return items;
            },
            /**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */ "x-axis": function(chart, e) {
                return indexMode(chart, e, {
                    intersect: false
                });
            },
            /**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ point: function(chart, e) {
                var position = getRelativePosition(e, chart);
                return getIntersectItems(chart, position);
            },
            /**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ nearest: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                options.axis = options.axis || "xy";
                var distanceMetric = getDistanceMetricForAxis(options.axis);
                return getNearestItems(chart, position, options.intersect, distanceMetric);
            },
            /**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ x: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                var items = [];
                var intersectsItem = false;
                parseVisibleItems(chart, function(element) {
                    if (element.inXRange(position.x)) items.push(element);
                    if (element.inRange(position.x, position.y)) intersectsItem = true;
                });
                // If we want to trigger on an intersect and we don't have any items
                // that intersect the position, return nothing
                if (options.intersect && !intersectsItem) items = [];
                return items;
            },
            /**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ y: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                var items = [];
                var intersectsItem = false;
                parseVisibleItems(chart, function(element) {
                    if (element.inYRange(position.y)) items.push(element);
                    if (element.inRange(position.x, position.y)) intersectsItem = true;
                });
                // If we want to trigger on an intersect and we don't have any items
                // that intersect the position, return nothing
                if (options.intersect && !intersectsItem) items = [];
                return items;
            }
        }
    };
    var extend = helpers$1.extend;
    function filterByPosition(array, position) {
        return helpers$1.where(array, function(v) {
            return v.pos === position;
        });
    }
    function sortByWeight(array, reverse) {
        return array.sort(function(a, b) {
            var v0 = reverse ? b : a;
            var v1 = reverse ? a : b;
            return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
        });
    }
    function wrapBoxes(boxes) {
        var layoutBoxes = [];
        var i, ilen, box;
        for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
            box = boxes[i];
            layoutBoxes.push({
                index: i,
                box: box,
                pos: box.position,
                horizontal: box.isHorizontal(),
                weight: box.weight
            });
        }
        return layoutBoxes;
    }
    function setLayoutDims(layouts, params) {
        var i, ilen, layout;
        for(i = 0, ilen = layouts.length; i < ilen; ++i){
            layout = layouts[i];
            // store width used instead of chartArea.w in fitBoxes
            layout.width = layout.horizontal ? layout.box.fullWidth && params.availableWidth : params.vBoxMaxWidth;
            // store height used instead of chartArea.h in fitBoxes
            layout.height = layout.horizontal && params.hBoxMaxHeight;
        }
    }
    function buildLayoutBoxes(boxes) {
        var layoutBoxes = wrapBoxes(boxes);
        var left = sortByWeight(filterByPosition(layoutBoxes, "left"), true);
        var right = sortByWeight(filterByPosition(layoutBoxes, "right"));
        var top = sortByWeight(filterByPosition(layoutBoxes, "top"), true);
        var bottom = sortByWeight(filterByPosition(layoutBoxes, "bottom"));
        return {
            leftAndTop: left.concat(top),
            rightAndBottom: right.concat(bottom),
            chartArea: filterByPosition(layoutBoxes, "chartArea"),
            vertical: left.concat(right),
            horizontal: top.concat(bottom)
        };
    }
    function getCombinedMax(maxPadding, chartArea, a, b) {
        return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
    }
    function updateDims(chartArea, params, layout) {
        var box = layout.box;
        var maxPadding = chartArea.maxPadding;
        var newWidth, newHeight;
        if (layout.size) // this layout was already counted for, lets first reduce old size
        chartArea[layout.pos] -= layout.size;
        layout.size = layout.horizontal ? box.height : box.width;
        chartArea[layout.pos] += layout.size;
        if (box.getPadding) {
            var boxPadding = box.getPadding();
            maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
            maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
            maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
            maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
        }
        newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, "left", "right");
        newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, "top", "bottom");
        if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
            chartArea.w = newWidth;
            chartArea.h = newHeight;
            // return true if chart area changed in layout's direction
            var sizes = layout.horizontal ? [
                newWidth,
                chartArea.w
            ] : [
                newHeight,
                chartArea.h
            ];
            return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
        }
    }
    function handleMaxPadding(chartArea) {
        var maxPadding = chartArea.maxPadding;
        function updatePos(pos) {
            var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
            chartArea[pos] += change;
            return change;
        }
        chartArea.y += updatePos("top");
        chartArea.x += updatePos("left");
        updatePos("right");
        updatePos("bottom");
    }
    function getMargins(horizontal, chartArea) {
        var maxPadding = chartArea.maxPadding;
        function marginForPositions(positions) {
            var margin = {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            };
            positions.forEach(function(pos) {
                margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
            });
            return margin;
        }
        return horizontal ? marginForPositions([
            "left",
            "right"
        ]) : marginForPositions([
            "top",
            "bottom"
        ]);
    }
    function fitBoxes(boxes, chartArea, params) {
        var refitBoxes = [];
        var i, ilen, layout, box, refit, changed;
        for(i = 0, ilen = boxes.length; i < ilen; ++i){
            layout = boxes[i];
            box = layout.box;
            box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
            if (updateDims(chartArea, params, layout)) {
                changed = true;
                if (refitBoxes.length) // Dimensions changed and there were non full width boxes before this
                // -> we have to refit those
                refit = true;
            }
            if (!box.fullWidth) refitBoxes.push(layout);
        }
        return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
    }
    function placeBoxes(boxes, chartArea, params) {
        var userPadding = params.padding;
        var x = chartArea.x;
        var y = chartArea.y;
        var i, ilen, layout, box;
        for(i = 0, ilen = boxes.length; i < ilen; ++i){
            layout = boxes[i];
            box = layout.box;
            if (layout.horizontal) {
                box.left = box.fullWidth ? userPadding.left : chartArea.left;
                box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
                box.top = y;
                box.bottom = y + box.height;
                box.width = box.right - box.left;
                y = box.bottom;
            } else {
                box.left = x;
                box.right = x + box.width;
                box.top = chartArea.top;
                box.bottom = chartArea.top + chartArea.h;
                box.height = box.bottom - box.top;
                x = box.right;
            }
        }
        chartArea.x = x;
        chartArea.y = y;
    }
    core_defaults._set("global", {
        layout: {
            padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }
        }
    });
    /**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */ // The layout service is very self explanatory.  It's responsible for the layout within a chart.
    // Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
    // It is this service's responsibility of carrying out that layout.
    var core_layouts = {
        defaults: {},
        /**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */ addBox: function(chart, item) {
            if (!chart.boxes) chart.boxes = [];
            // initialize item with default values
            item.fullWidth = item.fullWidth || false;
            item.position = item.position || "top";
            item.weight = item.weight || 0;
            item._layers = item._layers || function() {
                return [
                    {
                        z: 0,
                        draw: function() {
                            item.draw.apply(item, arguments);
                        }
                    }
                ];
            };
            chart.boxes.push(item);
        },
        /**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */ removeBox: function(chart, layoutItem) {
            var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
            if (index !== -1) chart.boxes.splice(index, 1);
        },
        /**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */ configure: function(chart, item, options) {
            var props = [
                "fullWidth",
                "position",
                "weight"
            ];
            var ilen = props.length;
            var i = 0;
            var prop;
            for(; i < ilen; ++i){
                prop = props[i];
                if (options.hasOwnProperty(prop)) item[prop] = options[prop];
            }
        },
        /**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */ update: function(chart, width, height) {
            if (!chart) return;
            var layoutOptions = chart.options.layout || {};
            var padding = helpers$1.options.toPadding(layoutOptions.padding);
            var availableWidth = width - padding.width;
            var availableHeight = height - padding.height;
            var boxes = buildLayoutBoxes(chart.boxes);
            var verticalBoxes = boxes.vertical;
            var horizontalBoxes = boxes.horizontal;
            // Essentially we now have any number of boxes on each of the 4 sides.
            // Our canvas looks like the following.
            // The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
            // B1 is the bottom axis
            // There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
            // These locations are single-box locations only, when trying to register a chartArea location that is already taken,
            // an error will be thrown.
            //
            // |----------------------------------------------------|
            // |                  T1 (Full Width)                   |
            // |----------------------------------------------------|
            // |    |    |                 T2                  |    |
            // |    |----|-------------------------------------|----|
            // |    |    | C1 |                           | C2 |    |
            // |    |    |----|                           |----|    |
            // |    |    |                                     |    |
            // | L1 | L2 |           ChartArea (C0)            | R1 |
            // |    |    |                                     |    |
            // |    |    |----|                           |----|    |
            // |    |    | C3 |                           | C4 |    |
            // |    |----|-------------------------------------|----|
            // |    |    |                 B1                  |    |
            // |----------------------------------------------------|
            // |                  B2 (Full Width)                   |
            // |----------------------------------------------------|
            //
            var params = Object.freeze({
                outerWidth: width,
                outerHeight: height,
                padding: padding,
                availableWidth: availableWidth,
                vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
                hBoxMaxHeight: availableHeight / 2
            });
            var chartArea = extend({
                maxPadding: extend({}, padding),
                w: availableWidth,
                h: availableHeight,
                x: padding.left,
                y: padding.top
            }, padding);
            setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
            // First fit vertical boxes
            fitBoxes(verticalBoxes, chartArea, params);
            // Then fit horizontal boxes
            if (fitBoxes(horizontalBoxes, chartArea, params)) // if the area changed, re-fit vertical boxes
            fitBoxes(verticalBoxes, chartArea, params);
            handleMaxPadding(chartArea);
            // Finally place the boxes to correct coordinates
            placeBoxes(boxes.leftAndTop, chartArea, params);
            // Move to opposite side of chart
            chartArea.x += chartArea.w;
            chartArea.y += chartArea.h;
            placeBoxes(boxes.rightAndBottom, chartArea, params);
            chart.chartArea = {
                left: chartArea.left,
                top: chartArea.top,
                right: chartArea.left + chartArea.w,
                bottom: chartArea.top + chartArea.h
            };
            // Finally update boxes in chartArea (radial scale for example)
            helpers$1.each(boxes.chartArea, function(layout) {
                var box = layout.box;
                extend(box, chart.chartArea);
                box.update(chartArea.w, chartArea.h);
            });
        }
    };
    /**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */ var platform_basic = {
        acquireContext: function(item) {
            if (item && item.canvas) // Support for any object associated to a canvas (including a context2d)
            item = item.canvas;
            return item && item.getContext("2d") || null;
        }
    };
    var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n	from { opacity: 0.99; }\r\n	to { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n	animation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n	position: absolute;\r\n	direction: ltr;\r\n	left: 0;\r\n	top: 0;\r\n	right: 0;\r\n	bottom: 0;\r\n	overflow: hidden;\r\n	pointer-events: none;\r\n	visibility: hidden;\r\n	z-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n	position: absolute;\r\n	width: 1000000px;\r\n	height: 1000000px;\r\n	left: 0;\r\n	top: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n	position: absolute;\r\n	width: 200%;\r\n	height: 200%;\r\n	left: 0;\r\n	top: 0;\r\n}\r\n";
    var platform_dom$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        "default": platform_dom
    });
    var stylesheet = getCjsExportFromNamespace(platform_dom$1);
    var EXPANDO_KEY = "$chartjs";
    var CSS_PREFIX = "chartjs-";
    var CSS_SIZE_MONITOR = CSS_PREFIX + "size-monitor";
    var CSS_RENDER_MONITOR = CSS_PREFIX + "render-monitor";
    var CSS_RENDER_ANIMATION = CSS_PREFIX + "render-animation";
    var ANIMATION_START_EVENTS = [
        "animationstart",
        "webkitAnimationStart"
    ];
    /**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */ var EVENT_TYPES = {
        touchstart: "mousedown",
        touchmove: "mousemove",
        touchend: "mouseup",
        pointerenter: "mouseenter",
        pointerdown: "mousedown",
        pointermove: "mousemove",
        pointerup: "mouseup",
        pointerleave: "mouseout",
        pointerout: "mouseout"
    };
    /**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */ function readUsedSize(element, property) {
        var value = helpers$1.getStyle(element, property);
        var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
        return matches ? Number(matches[1]) : undefined;
    }
    /**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */ function initCanvas(canvas, config) {
        var style = canvas.style;
        // NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
        // returns null or '' if no explicit value has been set to the canvas attribute.
        var renderHeight = canvas.getAttribute("height");
        var renderWidth = canvas.getAttribute("width");
        // Chart.js modifies some canvas values that we want to restore on destroy
        canvas[EXPANDO_KEY] = {
            initial: {
                height: renderHeight,
                width: renderWidth,
                style: {
                    display: style.display,
                    height: style.height,
                    width: style.width
                }
            }
        };
        // Force canvas to display as block to avoid extra space caused by inline
        // elements, which would interfere with the responsive resize process.
        // https://github.com/chartjs/Chart.js/issues/2538
        style.display = style.display || "block";
        if (renderWidth === null || renderWidth === "") {
            var displayWidth = readUsedSize(canvas, "width");
            if (displayWidth !== undefined) canvas.width = displayWidth;
        }
        if (renderHeight === null || renderHeight === "") {
            if (canvas.style.height === "") // If no explicit render height and style height, let's apply the aspect ratio,
            // which one can be specified by the user but also by charts as default option
            // (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
            canvas.height = canvas.width / (config.options.aspectRatio || 2);
            else {
                var displayHeight = readUsedSize(canvas, "height");
                if (displayWidth !== undefined) canvas.height = displayHeight;
            }
        }
        return canvas;
    }
    /**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ var supportsEventListenerOptions = function() {
        var supports = false;
        try {
            var options = Object.defineProperty({}, "passive", {
                // eslint-disable-next-line getter-return
                get: function() {
                    supports = true;
                }
            });
            window.addEventListener("e", null, options);
        } catch (e) {
        // continue regardless of error
        }
        return supports;
    }();
    // Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
    // https://github.com/chartjs/Chart.js/issues/4287
    var eventListenerOptions = supportsEventListenerOptions ? {
        passive: true
    } : false;
    function addListener(node, type, listener) {
        node.addEventListener(type, listener, eventListenerOptions);
    }
    function removeListener(node, type, listener) {
        node.removeEventListener(type, listener, eventListenerOptions);
    }
    function createEvent(type, chart, x, y, nativeEvent) {
        return {
            type: type,
            chart: chart,
            native: nativeEvent || null,
            x: x !== undefined ? x : null,
            y: y !== undefined ? y : null
        };
    }
    function fromNativeEvent(event, chart) {
        var type = EVENT_TYPES[event.type] || event.type;
        var pos = helpers$1.getRelativePosition(event, chart);
        return createEvent(type, chart, pos.x, pos.y, event);
    }
    function throttled(fn, thisArg) {
        var ticking = false;
        var args = [];
        return function() {
            args = Array.prototype.slice.call(arguments);
            thisArg = thisArg || this;
            if (!ticking) {
                ticking = true;
                helpers$1.requestAnimFrame.call(window, function() {
                    ticking = false;
                    fn.apply(thisArg, args);
                });
            }
        };
    }
    function createDiv(cls) {
        var el = document.createElement("div");
        el.className = cls || "";
        return el;
    }
    // Implementation based on https://github.com/marcj/css-element-queries
    function createResizer(handler) {
        var maxSize = 1000000;
        // NOTE(SB) Don't use innerHTML because it could be considered unsafe.
        // https://github.com/chartjs/Chart.js/issues/5902
        var resizer = createDiv(CSS_SIZE_MONITOR);
        var expand = createDiv(CSS_SIZE_MONITOR + "-expand");
        var shrink = createDiv(CSS_SIZE_MONITOR + "-shrink");
        expand.appendChild(createDiv());
        shrink.appendChild(createDiv());
        resizer.appendChild(expand);
        resizer.appendChild(shrink);
        resizer._reset = function() {
            expand.scrollLeft = maxSize;
            expand.scrollTop = maxSize;
            shrink.scrollLeft = maxSize;
            shrink.scrollTop = maxSize;
        };
        var onScroll = function() {
            resizer._reset();
            handler();
        };
        addListener(expand, "scroll", onScroll.bind(expand, "expand"));
        addListener(shrink, "scroll", onScroll.bind(shrink, "shrink"));
        return resizer;
    }
    // https://davidwalsh.name/detect-node-insertion
    function watchForRender(node, handler) {
        var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
        var proxy = expando.renderProxy = function(e) {
            if (e.animationName === CSS_RENDER_ANIMATION) handler();
        };
        helpers$1.each(ANIMATION_START_EVENTS, function(type) {
            addListener(node, type, proxy);
        });
        // #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
        // is removed then added back immediately (same animation frame?). Accessing the
        // `offsetParent` property will force a reflow and re-evaluate the CSS animation.
        // https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
        // https://github.com/chartjs/Chart.js/issues/4737
        expando.reflow = !!node.offsetParent;
        node.classList.add(CSS_RENDER_MONITOR);
    }
    function unwatchForRender(node) {
        var expando = node[EXPANDO_KEY] || {};
        var proxy = expando.renderProxy;
        if (proxy) {
            helpers$1.each(ANIMATION_START_EVENTS, function(type) {
                removeListener(node, type, proxy);
            });
            delete expando.renderProxy;
        }
        node.classList.remove(CSS_RENDER_MONITOR);
    }
    function addResizeListener(node, listener, chart) {
        var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
        // Let's keep track of this added resizer and thus avoid DOM query when removing it.
        var resizer = expando.resizer = createResizer(throttled(function() {
            if (expando.resizer) {
                var container = chart.options.maintainAspectRatio && node.parentNode;
                var w = container ? container.clientWidth : 0;
                listener(createEvent("resize", chart));
                if (container && container.clientWidth < w && chart.canvas) // If the container size shrank during chart resize, let's assume
                // scrollbar appeared. So we resize again with the scrollbar visible -
                // effectively making chart smaller and the scrollbar hidden again.
                // Because we are inside `throttled`, and currently `ticking`, scroll
                // events are ignored during this whole 2 resize process.
                // If we assumed wrong and something else happened, we are resizing
                // twice in a frame (potential performance issue)
                listener(createEvent("resize", chart));
            }
        }));
        // The resizer needs to be attached to the node parent, so we first need to be
        // sure that `node` is attached to the DOM before injecting the resizer element.
        watchForRender(node, function() {
            if (expando.resizer) {
                var container = node.parentNode;
                if (container && container !== resizer.parentNode) container.insertBefore(resizer, container.firstChild);
                // The container size might have changed, let's reset the resizer state.
                resizer._reset();
            }
        });
    }
    function removeResizeListener(node) {
        var expando = node[EXPANDO_KEY] || {};
        var resizer = expando.resizer;
        delete expando.resizer;
        unwatchForRender(node);
        if (resizer && resizer.parentNode) resizer.parentNode.removeChild(resizer);
    }
    /**
 * Injects CSS styles inline if the styles are not already present.
 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
 * @param {string} css - the CSS to be injected.
 */ function injectCSS(rootNode, css) {
        // https://stackoverflow.com/q/3922139
        var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
        if (!expando.containsStyles) {
            expando.containsStyles = true;
            css = "/* Chart.js */\n" + css;
            var style = document.createElement("style");
            style.setAttribute("type", "text/css");
            style.appendChild(document.createTextNode(css));
            rootNode.appendChild(style);
        }
    }
    var platform_dom$2 = {
        /**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */ disableCSSInjection: false,
        /**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */ _enabled: typeof window !== "undefined" && typeof document !== "undefined",
        /**
	 * Initializes resources that depend on platform options.
	 * @param {HTMLCanvasElement} canvas - The Canvas element.
	 * @private
	 */ _ensureLoaded: function(canvas) {
            if (!this.disableCSSInjection) {
                // If the canvas is in a shadow DOM, then the styles must also be inserted
                // into the same shadow DOM.
                // https://github.com/chartjs/Chart.js/issues/5763
                var root = canvas.getRootNode ? canvas.getRootNode() : document;
                var targetNode = root.host ? root : document.head;
                injectCSS(targetNode, stylesheet);
            }
        },
        acquireContext: function(item, config) {
            if (typeof item === "string") item = document.getElementById(item);
            else if (item.length) // Support for array based queries (such as jQuery)
            item = item[0];
            if (item && item.canvas) // Support for any object associated to a canvas (including a context2d)
            item = item.canvas;
            // To prevent canvas fingerprinting, some add-ons undefine the getContext
            // method, for example: https://github.com/kkapsner/CanvasBlocker
            // https://github.com/chartjs/Chart.js/issues/2807
            var context = item && item.getContext && item.getContext("2d");
            // `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
            // inside an iframe or when running in a protected environment. We could guess the
            // types from their toString() value but let's keep things flexible and assume it's
            // a sufficient condition if the item has a context2D which has item as `canvas`.
            // https://github.com/chartjs/Chart.js/issues/3887
            // https://github.com/chartjs/Chart.js/issues/4102
            // https://github.com/chartjs/Chart.js/issues/4152
            if (context && context.canvas === item) {
                // Load platform resources on first chart creation, to make it possible to
                // import the library before setting platform options.
                this._ensureLoaded(item);
                initCanvas(item, config);
                return context;
            }
            return null;
        },
        releaseContext: function(context) {
            var canvas = context.canvas;
            if (!canvas[EXPANDO_KEY]) return;
            var initial = canvas[EXPANDO_KEY].initial;
            [
                "height",
                "width"
            ].forEach(function(prop) {
                var value = initial[prop];
                if (helpers$1.isNullOrUndef(value)) canvas.removeAttribute(prop);
                else canvas.setAttribute(prop, value);
            });
            helpers$1.each(initial.style || {}, function(value, key) {
                canvas.style[key] = value;
            });
            // The canvas render size might have been changed (and thus the state stack discarded),
            // we can't use save() and restore() to restore the initial state. So make sure that at
            // least the canvas context is reset to the default state by setting the canvas width.
            // https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
            // eslint-disable-next-line no-self-assign
            canvas.width = canvas.width;
            delete canvas[EXPANDO_KEY];
        },
        addEventListener: function(chart, type, listener) {
            var canvas = chart.canvas;
            if (type === "resize") {
                // Note: the resize event is not supported on all browsers.
                addResizeListener(canvas, listener, chart);
                return;
            }
            var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
            var proxies = expando.proxies || (expando.proxies = {});
            var proxy = proxies[chart.id + "_" + type] = function(event) {
                listener(fromNativeEvent(event, chart));
            };
            addListener(canvas, type, proxy);
        },
        removeEventListener: function(chart, type, listener) {
            var canvas = chart.canvas;
            if (type === "resize") {
                // Note: the resize event is not supported on all browsers.
                removeResizeListener(canvas);
                return;
            }
            var expando = listener[EXPANDO_KEY] || {};
            var proxies = expando.proxies || {};
            var proxy = proxies[chart.id + "_" + type];
            if (!proxy) return;
            removeListener(canvas, type, proxy);
        }
    };
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers$1.addEvent = addListener;
    /**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers$1.removeEvent = removeListener;
    // @TODO Make possible to select another platform at build time.
    var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
    /**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */ var platform = helpers$1.extend({
        /**
	 * @since 2.7.0
	 */ initialize: function() {},
        /**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */ acquireContext: function() {},
        /**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */ releaseContext: function() {},
        /**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */ addEventListener: function() {},
        /**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */ removeEventListener: function() {}
    }, implementation);
    core_defaults._set("global", {
        plugins: {}
    });
    /**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */ var core_plugins = {
        /**
	 * Globally registered plugins.
	 * @private
	 */ _plugins: [],
        /**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */ _cacheId: 0,
        /**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */ register: function(plugins) {
            var p = this._plugins;
            [].concat(plugins).forEach(function(plugin) {
                if (p.indexOf(plugin) === -1) p.push(plugin);
            });
            this._cacheId++;
        },
        /**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */ unregister: function(plugins) {
            var p = this._plugins;
            [].concat(plugins).forEach(function(plugin) {
                var idx = p.indexOf(plugin);
                if (idx !== -1) p.splice(idx, 1);
            });
            this._cacheId++;
        },
        /**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */ clear: function() {
            this._plugins = [];
            this._cacheId++;
        },
        /**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */ count: function() {
            return this._plugins.length;
        },
        /**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */ getAll: function() {
            return this._plugins;
        },
        /**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */ notify: function(chart, hook, args) {
            var descriptors = this.descriptors(chart);
            var ilen = descriptors.length;
            var i, descriptor, plugin, params, method;
            for(i = 0; i < ilen; ++i){
                descriptor = descriptors[i];
                plugin = descriptor.plugin;
                method = plugin[hook];
                if (typeof method === "function") {
                    params = [
                        chart
                    ].concat(args || []);
                    params.push(descriptor.options);
                    if (method.apply(plugin, params) === false) return false;
                }
            }
            return true;
        },
        /**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */ descriptors: function(chart) {
            var cache = chart.$plugins || (chart.$plugins = {});
            if (cache.id === this._cacheId) return cache.descriptors;
            var plugins = [];
            var descriptors = [];
            var config = chart && chart.config || {};
            var options = config.options && config.options.plugins || {};
            this._plugins.concat(config.plugins || []).forEach(function(plugin) {
                var idx = plugins.indexOf(plugin);
                if (idx !== -1) return;
                var id = plugin.id;
                var opts = options[id];
                if (opts === false) return;
                if (opts === true) opts = helpers$1.clone(core_defaults.global.plugins[id]);
                plugins.push(plugin);
                descriptors.push({
                    plugin: plugin,
                    options: opts || {}
                });
            });
            cache.descriptors = descriptors;
            cache.id = this._cacheId;
            return descriptors;
        },
        /**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */ _invalidate: function(chart) {
            delete chart.$plugins;
        }
    };
    var core_scaleService = {
        // Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
        // use the new chart options to grab the correct scale
        constructors: {},
        // Use a registration function so that we can move to an ES6 map when we no longer need to support
        // old browsers
        // Scale config defaults
        defaults: {},
        registerScaleType: function(type, scaleConstructor, scaleDefaults) {
            this.constructors[type] = scaleConstructor;
            this.defaults[type] = helpers$1.clone(scaleDefaults);
        },
        getScaleConstructor: function(type) {
            return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
        },
        getScaleDefaults: function(type) {
            // Return the scale defaults merged with the global settings so that we always use the latest ones
            return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [
                core_defaults.scale,
                this.defaults[type]
            ]) : {};
        },
        updateScaleDefaults: function(type, additions) {
            var me = this;
            if (me.defaults.hasOwnProperty(type)) me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
        },
        addScalesToLayout: function(chart) {
            // Adds each scale to the chart.boxes array to be sized accordingly
            helpers$1.each(chart.scales, function(scale) {
                // Set ILayoutItem parameters for backwards compatibility
                scale.fullWidth = scale.options.fullWidth;
                scale.position = scale.options.position;
                scale.weight = scale.options.weight;
                core_layouts.addBox(chart, scale);
            });
        }
    };
    var valueOrDefault$8 = helpers$1.valueOrDefault;
    var getRtlHelper = helpers$1.rtl.getRtlAdapter;
    core_defaults._set("global", {
        tooltips: {
            enabled: true,
            custom: null,
            mode: "nearest",
            position: "average",
            intersect: true,
            backgroundColor: "rgba(0,0,0,0.8)",
            titleFontStyle: "bold",
            titleSpacing: 2,
            titleMarginBottom: 6,
            titleFontColor: "#fff",
            titleAlign: "left",
            bodySpacing: 2,
            bodyFontColor: "#fff",
            bodyAlign: "left",
            footerFontStyle: "bold",
            footerSpacing: 2,
            footerMarginTop: 6,
            footerFontColor: "#fff",
            footerAlign: "left",
            yPadding: 6,
            xPadding: 6,
            caretPadding: 2,
            caretSize: 5,
            cornerRadius: 6,
            multiKeyBackground: "#fff",
            displayColors: true,
            borderColor: "rgba(0,0,0,0)",
            borderWidth: 0,
            callbacks: {
                // Args are: (tooltipItems, data)
                beforeTitle: helpers$1.noop,
                title: function(tooltipItems, data) {
                    var title = "";
                    var labels = data.labels;
                    var labelCount = labels ? labels.length : 0;
                    if (tooltipItems.length > 0) {
                        var item = tooltipItems[0];
                        if (item.label) title = item.label;
                        else if (item.xLabel) title = item.xLabel;
                        else if (labelCount > 0 && item.index < labelCount) title = labels[item.index];
                    }
                    return title;
                },
                afterTitle: helpers$1.noop,
                // Args are: (tooltipItems, data)
                beforeBody: helpers$1.noop,
                // Args are: (tooltipItem, data)
                beforeLabel: helpers$1.noop,
                label: function(tooltipItem, data) {
                    var label = data.datasets[tooltipItem.datasetIndex].label || "";
                    if (label) label += ": ";
                    if (!helpers$1.isNullOrUndef(tooltipItem.value)) label += tooltipItem.value;
                    else label += tooltipItem.yLabel;
                    return label;
                },
                labelColor: function(tooltipItem, chart) {
                    var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
                    var activeElement = meta.data[tooltipItem.index];
                    var view = activeElement._view;
                    return {
                        borderColor: view.borderColor,
                        backgroundColor: view.backgroundColor
                    };
                },
                labelTextColor: function() {
                    return this._options.bodyFontColor;
                },
                afterLabel: helpers$1.noop,
                // Args are: (tooltipItems, data)
                afterBody: helpers$1.noop,
                // Args are: (tooltipItems, data)
                beforeFooter: helpers$1.noop,
                footer: helpers$1.noop,
                afterFooter: helpers$1.noop
            }
        }
    });
    var positioners = {
        /**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */ average: function(elements) {
            if (!elements.length) return false;
            var i, len;
            var x = 0;
            var y = 0;
            var count = 0;
            for(i = 0, len = elements.length; i < len; ++i){
                var el = elements[i];
                if (el && el.hasValue()) {
                    var pos = el.tooltipPosition();
                    x += pos.x;
                    y += pos.y;
                    ++count;
                }
            }
            return {
                x: x / count,
                y: y / count
            };
        },
        /**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */ nearest: function(elements, eventPosition) {
            var x = eventPosition.x;
            var y = eventPosition.y;
            var minDistance = Number.POSITIVE_INFINITY;
            var i, len, nearestElement;
            for(i = 0, len = elements.length; i < len; ++i){
                var el = elements[i];
                if (el && el.hasValue()) {
                    var center = el.getCenterPoint();
                    var d = helpers$1.distanceBetweenPoints(eventPosition, center);
                    if (d < minDistance) {
                        minDistance = d;
                        nearestElement = el;
                    }
                }
            }
            if (nearestElement) {
                var tp = nearestElement.tooltipPosition();
                x = tp.x;
                y = tp.y;
            }
            return {
                x: x,
                y: y
            };
        }
    };
    // Helper to push or concat based on if the 2nd parameter is an array or not
    function pushOrConcat(base, toPush) {
        if (toPush) {
            if (helpers$1.isArray(toPush)) // base = base.concat(toPush);
            Array.prototype.push.apply(base, toPush);
            else base.push(toPush);
        }
        return base;
    }
    /**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */ function splitNewlines(str) {
        if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) return str.split("\n");
        return str;
    }
    /**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */ function createTooltipItem(element) {
        var xScale = element._xScale;
        var yScale = element._yScale || element._scale; // handle radar || polarArea charts
        var index = element._index;
        var datasetIndex = element._datasetIndex;
        var controller = element._chart.getDatasetMeta(datasetIndex).controller;
        var indexScale = controller._getIndexScale();
        var valueScale = controller._getValueScale();
        return {
            xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : "",
            yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : "",
            label: indexScale ? "" + indexScale.getLabelForIndex(index, datasetIndex) : "",
            value: valueScale ? "" + valueScale.getLabelForIndex(index, datasetIndex) : "",
            index: index,
            datasetIndex: datasetIndex,
            x: element._model.x,
            y: element._model.y
        };
    }
    /**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */ function getBaseModel(tooltipOpts) {
        var globalDefaults = core_defaults.global;
        return {
            // Positioning
            xPadding: tooltipOpts.xPadding,
            yPadding: tooltipOpts.yPadding,
            xAlign: tooltipOpts.xAlign,
            yAlign: tooltipOpts.yAlign,
            // Drawing direction and text direction
            rtl: tooltipOpts.rtl,
            textDirection: tooltipOpts.textDirection,
            // Body
            bodyFontColor: tooltipOpts.bodyFontColor,
            _bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
            _bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
            _bodyAlign: tooltipOpts.bodyAlign,
            bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
            bodySpacing: tooltipOpts.bodySpacing,
            // Title
            titleFontColor: tooltipOpts.titleFontColor,
            _titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
            _titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
            titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
            _titleAlign: tooltipOpts.titleAlign,
            titleSpacing: tooltipOpts.titleSpacing,
            titleMarginBottom: tooltipOpts.titleMarginBottom,
            // Footer
            footerFontColor: tooltipOpts.footerFontColor,
            _footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
            _footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
            footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
            _footerAlign: tooltipOpts.footerAlign,
            footerSpacing: tooltipOpts.footerSpacing,
            footerMarginTop: tooltipOpts.footerMarginTop,
            // Appearance
            caretSize: tooltipOpts.caretSize,
            cornerRadius: tooltipOpts.cornerRadius,
            backgroundColor: tooltipOpts.backgroundColor,
            opacity: 0,
            legendColorBackground: tooltipOpts.multiKeyBackground,
            displayColors: tooltipOpts.displayColors,
            borderColor: tooltipOpts.borderColor,
            borderWidth: tooltipOpts.borderWidth
        };
    }
    /**
 * Get the size of the tooltip
 */ function getTooltipSize(tooltip, model) {
        var ctx = tooltip._chart.ctx;
        var height = model.yPadding * 2; // Tooltip Padding
        var width = 0;
        // Count of all lines in the body
        var body = model.body;
        var combinedBodyLength = body.reduce(function(count, bodyItem) {
            return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
        }, 0);
        combinedBodyLength += model.beforeBody.length + model.afterBody.length;
        var titleLineCount = model.title.length;
        var footerLineCount = model.footer.length;
        var titleFontSize = model.titleFontSize;
        var bodyFontSize = model.bodyFontSize;
        var footerFontSize = model.footerFontSize;
        height += titleLineCount * titleFontSize; // Title Lines
        height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
        height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
        height += combinedBodyLength * bodyFontSize; // Body Lines
        height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
        height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
        height += footerLineCount * footerFontSize; // Footer Lines
        height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
        // Title width
        var widthPadding = 0;
        var maxLineWidth = function(line) {
            width = Math.max(width, ctx.measureText(line).width + widthPadding);
        };
        ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
        helpers$1.each(model.title, maxLineWidth);
        // Body width
        ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
        helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
        // Body lines may include some extra width due to the color box
        widthPadding = model.displayColors ? bodyFontSize + 2 : 0;
        helpers$1.each(body, function(bodyItem) {
            helpers$1.each(bodyItem.before, maxLineWidth);
            helpers$1.each(bodyItem.lines, maxLineWidth);
            helpers$1.each(bodyItem.after, maxLineWidth);
        });
        // Reset back to 0
        widthPadding = 0;
        // Footer width
        ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
        helpers$1.each(model.footer, maxLineWidth);
        // Add padding
        width += 2 * model.xPadding;
        return {
            width: width,
            height: height
        };
    }
    /**
 * Helper to get the alignment of a tooltip given the size
 */ function determineAlignment(tooltip, size) {
        var model = tooltip._model;
        var chart = tooltip._chart;
        var chartArea = tooltip._chart.chartArea;
        var xAlign = "center";
        var yAlign = "center";
        if (model.y < size.height) yAlign = "top";
        else if (model.y > chart.height - size.height) yAlign = "bottom";
        var lf, rf; // functions to determine left, right alignment
        var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
        var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
        var midX = (chartArea.left + chartArea.right) / 2;
        var midY = (chartArea.top + chartArea.bottom) / 2;
        if (yAlign === "center") {
            lf = function(x) {
                return x <= midX;
            };
            rf = function(x) {
                return x > midX;
            };
        } else {
            lf = function(x) {
                return x <= size.width / 2;
            };
            rf = function(x) {
                return x >= chart.width - size.width / 2;
            };
        }
        olf = function(x) {
            return x + size.width + model.caretSize + model.caretPadding > chart.width;
        };
        orf = function(x) {
            return x - size.width - model.caretSize - model.caretPadding < 0;
        };
        yf = function(y) {
            return y <= midY ? "top" : "bottom";
        };
        if (lf(model.x)) {
            xAlign = "left";
            // Is tooltip too wide and goes over the right side of the chart.?
            if (olf(model.x)) {
                xAlign = "center";
                yAlign = yf(model.y);
            }
        } else if (rf(model.x)) {
            xAlign = "right";
            // Is tooltip too wide and goes outside left edge of canvas?
            if (orf(model.x)) {
                xAlign = "center";
                yAlign = yf(model.y);
            }
        }
        var opts = tooltip._options;
        return {
            xAlign: opts.xAlign ? opts.xAlign : xAlign,
            yAlign: opts.yAlign ? opts.yAlign : yAlign
        };
    }
    /**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */ function getBackgroundPoint(vm, size, alignment, chart) {
        // Background Position
        var x = vm.x;
        var y = vm.y;
        var caretSize = vm.caretSize;
        var caretPadding = vm.caretPadding;
        var cornerRadius = vm.cornerRadius;
        var xAlign = alignment.xAlign;
        var yAlign = alignment.yAlign;
        var paddingAndSize = caretSize + caretPadding;
        var radiusAndPadding = cornerRadius + caretPadding;
        if (xAlign === "right") x -= size.width;
        else if (xAlign === "center") {
            x -= size.width / 2;
            if (x + size.width > chart.width) x = chart.width - size.width;
            if (x < 0) x = 0;
        }
        if (yAlign === "top") y += paddingAndSize;
        else if (yAlign === "bottom") y -= size.height + paddingAndSize;
        else y -= size.height / 2;
        if (yAlign === "center") {
            if (xAlign === "left") x += paddingAndSize;
            else if (xAlign === "right") x -= paddingAndSize;
        } else if (xAlign === "left") x -= radiusAndPadding;
        else if (xAlign === "right") x += radiusAndPadding;
        return {
            x: x,
            y: y
        };
    }
    function getAlignedX(vm, align) {
        return align === "center" ? vm.x + vm.width / 2 : align === "right" ? vm.x + vm.width - vm.xPadding : vm.x + vm.xPadding;
    }
    /**
 * Helper to build before and after body lines
 */ function getBeforeAfterBodyLines(callback) {
        return pushOrConcat([], splitNewlines(callback));
    }
    var exports$4 = core_element.extend({
        initialize: function() {
            this._model = getBaseModel(this._options);
            this._lastActive = [];
        },
        // Get the title
        // Args are: (tooltipItem, data)
        getTitle: function() {
            var me = this;
            var opts = me._options;
            var callbacks = opts.callbacks;
            var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
            var title = callbacks.title.apply(me, arguments);
            var afterTitle = callbacks.afterTitle.apply(me, arguments);
            var lines = [];
            lines = pushOrConcat(lines, splitNewlines(beforeTitle));
            lines = pushOrConcat(lines, splitNewlines(title));
            lines = pushOrConcat(lines, splitNewlines(afterTitle));
            return lines;
        },
        // Args are: (tooltipItem, data)
        getBeforeBody: function() {
            return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
        },
        // Args are: (tooltipItem, data)
        getBody: function(tooltipItems, data) {
            var me = this;
            var callbacks = me._options.callbacks;
            var bodyItems = [];
            helpers$1.each(tooltipItems, function(tooltipItem) {
                var bodyItem = {
                    before: [],
                    lines: [],
                    after: []
                };
                pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
                pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
                pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
                bodyItems.push(bodyItem);
            });
            return bodyItems;
        },
        // Args are: (tooltipItem, data)
        getAfterBody: function() {
            return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
        },
        // Get the footer and beforeFooter and afterFooter lines
        // Args are: (tooltipItem, data)
        getFooter: function() {
            var me = this;
            var callbacks = me._options.callbacks;
            var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
            var footer = callbacks.footer.apply(me, arguments);
            var afterFooter = callbacks.afterFooter.apply(me, arguments);
            var lines = [];
            lines = pushOrConcat(lines, splitNewlines(beforeFooter));
            lines = pushOrConcat(lines, splitNewlines(footer));
            lines = pushOrConcat(lines, splitNewlines(afterFooter));
            return lines;
        },
        update: function(changed) {
            var me = this;
            var opts = me._options;
            // Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
            // that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
            // which breaks any animations.
            var existingModel = me._model;
            var model = me._model = getBaseModel(opts);
            var active = me._active;
            var data = me._data;
            // In the case where active.length === 0 we need to keep these at existing values for good animations
            var alignment = {
                xAlign: existingModel.xAlign,
                yAlign: existingModel.yAlign
            };
            var backgroundPoint = {
                x: existingModel.x,
                y: existingModel.y
            };
            var tooltipSize = {
                width: existingModel.width,
                height: existingModel.height
            };
            var tooltipPosition = {
                x: existingModel.caretX,
                y: existingModel.caretY
            };
            var i, len;
            if (active.length) {
                model.opacity = 1;
                var labelColors = [];
                var labelTextColors = [];
                tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
                var tooltipItems = [];
                for(i = 0, len = active.length; i < len; ++i)tooltipItems.push(createTooltipItem(active[i]));
                // If the user provided a filter function, use it to modify the tooltip items
                if (opts.filter) tooltipItems = tooltipItems.filter(function(a) {
                    return opts.filter(a, data);
                });
                // If the user provided a sorting function, use it to modify the tooltip items
                if (opts.itemSort) tooltipItems = tooltipItems.sort(function(a, b) {
                    return opts.itemSort(a, b, data);
                });
                // Determine colors for boxes
                helpers$1.each(tooltipItems, function(tooltipItem) {
                    labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
                    labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
                });
                // Build the Text Lines
                model.title = me.getTitle(tooltipItems, data);
                model.beforeBody = me.getBeforeBody(tooltipItems, data);
                model.body = me.getBody(tooltipItems, data);
                model.afterBody = me.getAfterBody(tooltipItems, data);
                model.footer = me.getFooter(tooltipItems, data);
                // Initial positioning and colors
                model.x = tooltipPosition.x;
                model.y = tooltipPosition.y;
                model.caretPadding = opts.caretPadding;
                model.labelColors = labelColors;
                model.labelTextColors = labelTextColors;
                // data points
                model.dataPoints = tooltipItems;
                // We need to determine alignment of the tooltip
                tooltipSize = getTooltipSize(this, model);
                alignment = determineAlignment(this, tooltipSize);
                // Final Size and Position
                backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
            } else model.opacity = 0;
            model.xAlign = alignment.xAlign;
            model.yAlign = alignment.yAlign;
            model.x = backgroundPoint.x;
            model.y = backgroundPoint.y;
            model.width = tooltipSize.width;
            model.height = tooltipSize.height;
            // Point where the caret on the tooltip points to
            model.caretX = tooltipPosition.x;
            model.caretY = tooltipPosition.y;
            me._model = model;
            if (changed && opts.custom) opts.custom.call(me, model);
            return me;
        },
        drawCaret: function(tooltipPoint, size) {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
            ctx.lineTo(caretPosition.x1, caretPosition.y1);
            ctx.lineTo(caretPosition.x2, caretPosition.y2);
            ctx.lineTo(caretPosition.x3, caretPosition.y3);
        },
        getCaretPosition: function(tooltipPoint, size, vm) {
            var x1, x2, x3, y1, y2, y3;
            var caretSize = vm.caretSize;
            var cornerRadius = vm.cornerRadius;
            var xAlign = vm.xAlign;
            var yAlign = vm.yAlign;
            var ptX = tooltipPoint.x;
            var ptY = tooltipPoint.y;
            var width = size.width;
            var height = size.height;
            if (yAlign === "center") {
                y2 = ptY + height / 2;
                if (xAlign === "left") {
                    x1 = ptX;
                    x2 = x1 - caretSize;
                    x3 = x1;
                    y1 = y2 + caretSize;
                    y3 = y2 - caretSize;
                } else {
                    x1 = ptX + width;
                    x2 = x1 + caretSize;
                    x3 = x1;
                    y1 = y2 - caretSize;
                    y3 = y2 + caretSize;
                }
            } else {
                if (xAlign === "left") {
                    x2 = ptX + cornerRadius + caretSize;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                } else if (xAlign === "right") {
                    x2 = ptX + width - cornerRadius - caretSize;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                } else {
                    x2 = vm.caretX;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                }
                if (yAlign === "top") {
                    y1 = ptY;
                    y2 = y1 - caretSize;
                    y3 = y1;
                } else {
                    y1 = ptY + height;
                    y2 = y1 + caretSize;
                    y3 = y1;
                    // invert drawing order
                    var tmp = x3;
                    x3 = x1;
                    x1 = tmp;
                }
            }
            return {
                x1: x1,
                x2: x2,
                x3: x3,
                y1: y1,
                y2: y2,
                y3: y3
            };
        },
        drawTitle: function(pt, vm, ctx) {
            var title = vm.title;
            var length = title.length;
            var titleFontSize, titleSpacing, i;
            if (length) {
                var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
                pt.x = getAlignedX(vm, vm._titleAlign);
                ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
                ctx.textBaseline = "middle";
                titleFontSize = vm.titleFontSize;
                titleSpacing = vm.titleSpacing;
                ctx.fillStyle = vm.titleFontColor;
                ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
                for(i = 0; i < length; ++i){
                    ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
                    pt.y += titleFontSize + titleSpacing; // Line Height and spacing
                    if (i + 1 === length) pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
                }
            }
        },
        drawBody: function(pt, vm, ctx) {
            var bodyFontSize = vm.bodyFontSize;
            var bodySpacing = vm.bodySpacing;
            var bodyAlign = vm._bodyAlign;
            var body = vm.body;
            var drawColorBoxes = vm.displayColors;
            var xLinePadding = 0;
            var colorX = drawColorBoxes ? getAlignedX(vm, "left") : 0;
            var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
            var fillLineOfText = function(line) {
                ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
                pt.y += bodyFontSize + bodySpacing;
            };
            var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
            var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
            ctx.textAlign = bodyAlign;
            ctx.textBaseline = "middle";
            ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
            pt.x = getAlignedX(vm, bodyAlignForCalculation);
            // Before body lines
            ctx.fillStyle = vm.bodyFontColor;
            helpers$1.each(vm.beforeBody, fillLineOfText);
            xLinePadding = drawColorBoxes && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? bodyFontSize / 2 + 1 : bodyFontSize + 2 : 0;
            // Draw body lines now
            for(i = 0, ilen = body.length; i < ilen; ++i){
                bodyItem = body[i];
                textColor = vm.labelTextColors[i];
                labelColors = vm.labelColors[i];
                ctx.fillStyle = textColor;
                helpers$1.each(bodyItem.before, fillLineOfText);
                lines = bodyItem.lines;
                for(j = 0, jlen = lines.length; j < jlen; ++j){
                    // Draw Legend-like boxes if needed
                    if (drawColorBoxes) {
                        var rtlColorX = rtlHelper.x(colorX);
                        // Fill a white rect so that colours merge nicely if the opacity is < 1
                        ctx.fillStyle = vm.legendColorBackground;
                        ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
                        // Border
                        ctx.lineWidth = 1;
                        ctx.strokeStyle = labelColors.borderColor;
                        ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
                        // Inner square
                        ctx.fillStyle = labelColors.backgroundColor;
                        ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
                        ctx.fillStyle = textColor;
                    }
                    fillLineOfText(lines[j]);
                }
                helpers$1.each(bodyItem.after, fillLineOfText);
            }
            // Reset back to 0 for after body
            xLinePadding = 0;
            // After body lines
            helpers$1.each(vm.afterBody, fillLineOfText);
            pt.y -= bodySpacing; // Remove last body spacing
        },
        drawFooter: function(pt, vm, ctx) {
            var footer = vm.footer;
            var length = footer.length;
            var footerFontSize, i;
            if (length) {
                var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
                pt.x = getAlignedX(vm, vm._footerAlign);
                pt.y += vm.footerMarginTop;
                ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
                ctx.textBaseline = "middle";
                footerFontSize = vm.footerFontSize;
                ctx.fillStyle = vm.footerFontColor;
                ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
                for(i = 0; i < length; ++i){
                    ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
                    pt.y += footerFontSize + vm.footerSpacing;
                }
            }
        },
        drawBackground: function(pt, vm, ctx, tooltipSize) {
            ctx.fillStyle = vm.backgroundColor;
            ctx.strokeStyle = vm.borderColor;
            ctx.lineWidth = vm.borderWidth;
            var xAlign = vm.xAlign;
            var yAlign = vm.yAlign;
            var x = pt.x;
            var y = pt.y;
            var width = tooltipSize.width;
            var height = tooltipSize.height;
            var radius = vm.cornerRadius;
            ctx.beginPath();
            ctx.moveTo(x + radius, y);
            if (yAlign === "top") this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + width - radius, y);
            ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
            if (yAlign === "center" && xAlign === "right") this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + width, y + height - radius);
            ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
            if (yAlign === "bottom") this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + radius, y + height);
            ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
            if (yAlign === "center" && xAlign === "left") this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x, y + radius);
            ctx.quadraticCurveTo(x, y, x + radius, y);
            ctx.closePath();
            ctx.fill();
            if (vm.borderWidth > 0) ctx.stroke();
        },
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            if (vm.opacity === 0) return;
            var tooltipSize = {
                width: vm.width,
                height: vm.height
            };
            var pt = {
                x: vm.x,
                y: vm.y
            };
            // IE11/Edge does not like very small opacities, so snap to 0
            var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
            // Truthy/falsey value for empty tooltip
            var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
            if (this._options.enabled && hasTooltipContent) {
                ctx.save();
                ctx.globalAlpha = opacity;
                // Draw Background
                this.drawBackground(pt, vm, ctx, tooltipSize);
                // Draw Title, Body, and Footer
                pt.y += vm.yPadding;
                helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
                // Titles
                this.drawTitle(pt, vm, ctx);
                // Body
                this.drawBody(pt, vm, ctx);
                // Footer
                this.drawFooter(pt, vm, ctx);
                helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
                ctx.restore();
            }
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */ handleEvent: function(e) {
            var me = this;
            var options = me._options;
            var changed = false;
            me._lastActive = me._lastActive || [];
            // Find Active Elements for tooltips
            if (e.type === "mouseout") me._active = [];
            else {
                me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
                if (options.reverse) me._active.reverse();
            }
            // Remember Last Actives
            changed = !helpers$1.arrayEquals(me._active, me._lastActive);
            // Only handle target event on tooltip change
            if (changed) {
                me._lastActive = me._active;
                if (options.enabled || options.custom) {
                    me._eventPosition = {
                        x: e.x,
                        y: e.y
                    };
                    me.update(true);
                    me.pivot();
                }
            }
            return changed;
        }
    });
    /**
 * @namespace Chart.Tooltip.positioners
 */ var positioners_1 = positioners;
    var core_tooltip = exports$4;
    core_tooltip.positioners = positioners_1;
    var valueOrDefault$9 = helpers$1.valueOrDefault;
    core_defaults._set("global", {
        elements: {},
        events: [
            "mousemove",
            "mouseout",
            "click",
            "touchstart",
            "touchmove"
        ],
        hover: {
            onHover: null,
            mode: "nearest",
            intersect: true,
            animationDuration: 400
        },
        onClick: null,
        maintainAspectRatio: true,
        responsive: true,
        responsiveAnimationDuration: 0
    });
    /**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */ function mergeScaleConfig() {
        return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
            merger: function(key, target, source, options) {
                if (key === "xAxes" || key === "yAxes") {
                    var slen = source[key].length;
                    var i, type, scale;
                    if (!target[key]) target[key] = [];
                    for(i = 0; i < slen; ++i){
                        scale = source[key][i];
                        type = valueOrDefault$9(scale.type, key === "xAxes" ? "category" : "linear");
                        if (i >= target[key].length) target[key].push({});
                        if (!target[key][i].type || scale.type && scale.type !== target[key][i].type) // new/untyped scale or type changed: let's apply the new defaults
                        // then merge source scale to correctly overwrite the defaults.
                        helpers$1.merge(target[key][i], [
                            core_scaleService.getScaleDefaults(type),
                            scale
                        ]);
                        else // scales type are the same
                        helpers$1.merge(target[key][i], scale);
                    }
                } else helpers$1._merger(key, target, source, options);
            }
        });
    }
    /**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */ function mergeConfig() {
        return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
            merger: function(key, target, source, options) {
                var tval = target[key] || Object.create(null);
                var sval = source[key];
                if (key === "scales") // scale config merging is complex. Add our own function here for that
                target[key] = mergeScaleConfig(tval, sval);
                else if (key === "scale") // used in polar area & radar charts since there is only one scale
                target[key] = helpers$1.merge(tval, [
                    core_scaleService.getScaleDefaults(sval.type),
                    sval
                ]);
                else helpers$1._merger(key, target, source, options);
            }
        });
    }
    function initConfig(config) {
        config = config || Object.create(null);
        // Do NOT use mergeConfig for the data object because this method merges arrays
        // and so would change references to labels and datasets, preventing data updates.
        var data = config.data = config.data || {};
        data.datasets = data.datasets || [];
        data.labels = data.labels || [];
        config.options = mergeConfig(core_defaults.global, core_defaults[config.type], config.options || {});
        return config;
    }
    function updateConfig(chart) {
        var newOptions = chart.options;
        helpers$1.each(chart.scales, function(scale) {
            core_layouts.removeBox(chart, scale);
        });
        newOptions = mergeConfig(core_defaults.global, core_defaults[chart.config.type], newOptions);
        chart.options = chart.config.options = newOptions;
        chart.ensureScalesHaveIDs();
        chart.buildOrUpdateScales();
        // Tooltip
        chart.tooltip._options = newOptions.tooltips;
        chart.tooltip.initialize();
    }
    function nextAvailableScaleId(axesOpts, prefix, index) {
        var id;
        var hasId = function(obj) {
            return obj.id === id;
        };
        do id = prefix + index++;
        while (helpers$1.findIndex(axesOpts, hasId) >= 0);
        return id;
    }
    function positionIsHorizontal(position) {
        return position === "top" || position === "bottom";
    }
    function compare2Level(l1, l2) {
        return function(a, b) {
            return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
        };
    }
    var Chart = function(item, config) {
        this.construct(item, config);
        return this;
    };
    helpers$1.extend(Chart.prototype, /** @lends Chart */ {
        /**
	 * @private
	 */ construct: function(item, config) {
            var me = this;
            config = initConfig(config);
            var context = platform.acquireContext(item, config);
            var canvas = context && context.canvas;
            var height = canvas && canvas.height;
            var width = canvas && canvas.width;
            me.id = helpers$1.uid();
            me.ctx = context;
            me.canvas = canvas;
            me.config = config;
            me.width = width;
            me.height = height;
            me.aspectRatio = height ? width / height : null;
            me.options = config.options;
            me._bufferedRender = false;
            me._layers = [];
            /**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */ me.chart = me;
            me.controller = me; // chart.chart.controller #inception
            // Add the chart instance to the global namespace
            Chart.instances[me.id] = me;
            // Define alias to the config data: `chart.data === chart.config.data`
            Object.defineProperty(me, "data", {
                get: function() {
                    return me.config.data;
                },
                set: function(value) {
                    me.config.data = value;
                }
            });
            if (!context || !canvas) {
                // The given item is not a compatible context2d element, let's return before finalizing
                // the chart initialization but after setting basic chart / controller properties that
                // can help to figure out that the chart is not valid (e.g chart.canvas !== null);
                // https://github.com/chartjs/Chart.js/issues/2807
                console.error("Failed to create chart: can't acquire context from the given item");
                return;
            }
            me.initialize();
            me.update();
        },
        /**
	 * @private
	 */ initialize: function() {
            var me = this;
            // Before init plugin notification
            core_plugins.notify(me, "beforeInit");
            helpers$1.retinaScale(me, me.options.devicePixelRatio);
            me.bindEvents();
            if (me.options.responsive) // Initial resize before chart draws (must be silent to preserve initial animations).
            me.resize(true);
            me.initToolTip();
            // After init plugin notification
            core_plugins.notify(me, "afterInit");
            return me;
        },
        clear: function() {
            helpers$1.canvas.clear(this);
            return this;
        },
        stop: function() {
            // Stops any current animation loop occurring
            core_animations.cancelAnimation(this);
            return this;
        },
        resize: function(silent) {
            var me = this;
            var options = me.options;
            var canvas = me.canvas;
            var aspectRatio = options.maintainAspectRatio && me.aspectRatio || null;
            // the canvas render width and height will be casted to integers so make sure that
            // the canvas display style uses the same integer values to avoid blurring effect.
            // Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
            var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
            var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
            if (me.width === newWidth && me.height === newHeight) return;
            canvas.width = me.width = newWidth;
            canvas.height = me.height = newHeight;
            canvas.style.width = newWidth + "px";
            canvas.style.height = newHeight + "px";
            helpers$1.retinaScale(me, options.devicePixelRatio);
            if (!silent) {
                // Notify any plugins about the resize
                var newSize = {
                    width: newWidth,
                    height: newHeight
                };
                core_plugins.notify(me, "resize", [
                    newSize
                ]);
                // Notify of resize
                if (options.onResize) options.onResize(me, newSize);
                me.stop();
                me.update({
                    duration: options.responsiveAnimationDuration
                });
            }
        },
        ensureScalesHaveIDs: function() {
            var options = this.options;
            var scalesOptions = options.scales || {};
            var scaleOptions = options.scale;
            helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
                if (!xAxisOptions.id) xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, "x-axis-", index);
            });
            helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
                if (!yAxisOptions.id) yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, "y-axis-", index);
            });
            if (scaleOptions) scaleOptions.id = scaleOptions.id || "scale";
        },
        /**
	 * Builds a map of scale ID to scale object for future lookup.
	 */ buildOrUpdateScales: function() {
            var me = this;
            var options = me.options;
            var scales = me.scales || {};
            var items = [];
            var updated = Object.keys(scales).reduce(function(obj, id) {
                obj[id] = false;
                return obj;
            }, {});
            if (options.scales) items = items.concat((options.scales.xAxes || []).map(function(xAxisOptions) {
                return {
                    options: xAxisOptions,
                    dtype: "category",
                    dposition: "bottom"
                };
            }), (options.scales.yAxes || []).map(function(yAxisOptions) {
                return {
                    options: yAxisOptions,
                    dtype: "linear",
                    dposition: "left"
                };
            }));
            if (options.scale) items.push({
                options: options.scale,
                dtype: "radialLinear",
                isDefault: true,
                dposition: "chartArea"
            });
            helpers$1.each(items, function(item) {
                var scaleOptions = item.options;
                var id = scaleOptions.id;
                var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
                if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
                updated[id] = true;
                var scale = null;
                if (id in scales && scales[id].type === scaleType) {
                    scale = scales[id];
                    scale.options = scaleOptions;
                    scale.ctx = me.ctx;
                    scale.chart = me;
                } else {
                    var scaleClass = core_scaleService.getScaleConstructor(scaleType);
                    if (!scaleClass) return;
                    scale = new scaleClass({
                        id: id,
                        type: scaleType,
                        options: scaleOptions,
                        ctx: me.ctx,
                        chart: me
                    });
                    scales[scale.id] = scale;
                }
                scale.mergeTicksOptions();
                // TODO(SB): I think we should be able to remove this custom case (options.scale)
                // and consider it as a regular scale part of the "scales"" map only! This would
                // make the logic easier and remove some useless? custom code.
                if (item.isDefault) me.scale = scale;
            });
            // clear up discarded scales
            helpers$1.each(updated, function(hasUpdated, id) {
                if (!hasUpdated) delete scales[id];
            });
            me.scales = scales;
            core_scaleService.addScalesToLayout(this);
        },
        buildOrUpdateControllers: function() {
            var me = this;
            var newControllers = [];
            var datasets = me.data.datasets;
            var i, ilen;
            for(i = 0, ilen = datasets.length; i < ilen; i++){
                var dataset = datasets[i];
                var meta = me.getDatasetMeta(i);
                var type = dataset.type || me.config.type;
                if (meta.type && meta.type !== type) {
                    me.destroyDatasetMeta(i);
                    meta = me.getDatasetMeta(i);
                }
                meta.type = type;
                meta.order = dataset.order || 0;
                meta.index = i;
                if (meta.controller) {
                    meta.controller.updateIndex(i);
                    meta.controller.linkScales();
                } else {
                    var ControllerClass = controllers[meta.type];
                    if (ControllerClass === undefined) throw new Error('"' + meta.type + '" is not a chart type.');
                    meta.controller = new ControllerClass(me, i);
                    newControllers.push(meta.controller);
                }
            }
            return newControllers;
        },
        /**
	 * Reset the elements of all datasets
	 * @private
	 */ resetElements: function() {
            var me = this;
            helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
                me.getDatasetMeta(datasetIndex).controller.reset();
            }, me);
        },
        /**
	* Resets the chart back to it's state before the initial animation
	*/ reset: function() {
            this.resetElements();
            this.tooltip.initialize();
        },
        update: function(config) {
            var me = this;
            var i, ilen;
            if (!config || typeof config !== "object") // backwards compatibility
            config = {
                duration: config,
                lazy: arguments[1]
            };
            updateConfig(me);
            // plugins options references might have change, let's invalidate the cache
            // https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
            core_plugins._invalidate(me);
            if (core_plugins.notify(me, "beforeUpdate") === false) return;
            // In case the entire data object changed
            me.tooltip._data = me.data;
            // Make sure dataset controllers are updated and new controllers are reset
            var newControllers = me.buildOrUpdateControllers();
            // Make sure all dataset controllers have correct meta data counts
            for(i = 0, ilen = me.data.datasets.length; i < ilen; i++)me.getDatasetMeta(i).controller.buildOrUpdateElements();
            me.updateLayout();
            // Can only reset the new controllers after the scales have been updated
            if (me.options.animation && me.options.animation.duration) helpers$1.each(newControllers, function(controller) {
                controller.reset();
            });
            me.updateDatasets();
            // Need to reset tooltip in case it is displayed with elements that are removed
            // after update.
            me.tooltip.initialize();
            // Last active contains items that were previously in the tooltip.
            // When we reset the tooltip, we need to clear it
            me.lastActive = [];
            // Do this before render so that any plugins that need final scale updates can use it
            core_plugins.notify(me, "afterUpdate");
            me._layers.sort(compare2Level("z", "_idx"));
            if (me._bufferedRender) me._bufferedRequest = {
                duration: config.duration,
                easing: config.easing,
                lazy: config.lazy
            };
            else me.render(config);
        },
        /**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */ updateLayout: function() {
            var me = this;
            if (core_plugins.notify(me, "beforeLayout") === false) return;
            core_layouts.update(this, this.width, this.height);
            me._layers = [];
            helpers$1.each(me.boxes, function(box) {
                // _configure is called twice, once in core.scale.update and once here.
                // Here the boxes are fully updated and at their final positions.
                if (box._configure) box._configure();
                me._layers.push.apply(me._layers, box._layers());
            }, me);
            me._layers.forEach(function(item, index) {
                item._idx = index;
            });
            /**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */ core_plugins.notify(me, "afterScaleUpdate");
            core_plugins.notify(me, "afterLayout");
        },
        /**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */ updateDatasets: function() {
            var me = this;
            if (core_plugins.notify(me, "beforeDatasetsUpdate") === false) return;
            for(var i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me.updateDataset(i);
            core_plugins.notify(me, "afterDatasetsUpdate");
        },
        /**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */ updateDataset: function(index) {
            var me = this;
            var meta = me.getDatasetMeta(index);
            var args = {
                meta: meta,
                index: index
            };
            if (core_plugins.notify(me, "beforeDatasetUpdate", [
                args
            ]) === false) return;
            meta.controller._update();
            core_plugins.notify(me, "afterDatasetUpdate", [
                args
            ]);
        },
        render: function(config) {
            var me = this;
            if (!config || typeof config !== "object") // backwards compatibility
            config = {
                duration: config,
                lazy: arguments[1]
            };
            var animationOptions = me.options.animation;
            var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
            var lazy = config.lazy;
            if (core_plugins.notify(me, "beforeRender") === false) return;
            var onComplete = function(animation) {
                core_plugins.notify(me, "afterRender");
                helpers$1.callback(animationOptions && animationOptions.onComplete, [
                    animation
                ], me);
            };
            if (animationOptions && duration) {
                var animation = new core_animation({
                    numSteps: duration / 16.66,
                    easing: config.easing || animationOptions.easing,
                    render: function(chart, animationObject) {
                        var easingFunction = helpers$1.easing.effects[animationObject.easing];
                        var currentStep = animationObject.currentStep;
                        var stepDecimal = currentStep / animationObject.numSteps;
                        chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
                    },
                    onAnimationProgress: animationOptions.onProgress,
                    onAnimationComplete: onComplete
                });
                core_animations.addAnimation(me, animation, duration, lazy);
            } else {
                me.draw();
                // See https://github.com/chartjs/Chart.js/issues/3781
                onComplete(new core_animation({
                    numSteps: 0,
                    chart: me
                }));
            }
            return me;
        },
        draw: function(easingValue) {
            var me = this;
            var i, layers;
            me.clear();
            if (helpers$1.isNullOrUndef(easingValue)) easingValue = 1;
            me.transition(easingValue);
            if (me.width <= 0 || me.height <= 0) return;
            if (core_plugins.notify(me, "beforeDraw", [
                easingValue
            ]) === false) return;
            // Because of plugin hooks (before/afterDatasetsDraw), datasets can't
            // currently be part of layers. Instead, we draw
            // layers <= 0 before(default, backward compat), and the rest after
            layers = me._layers;
            for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(me.chartArea);
            me.drawDatasets(easingValue);
            // Rest of layers
            for(; i < layers.length; ++i)layers[i].draw(me.chartArea);
            me._drawTooltip(easingValue);
            core_plugins.notify(me, "afterDraw", [
                easingValue
            ]);
        },
        /**
	 * @private
	 */ transition: function(easingValue) {
            var me = this;
            for(var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i)if (me.isDatasetVisible(i)) me.getDatasetMeta(i).controller.transition(easingValue);
            me.tooltip.transition(easingValue);
        },
        /**
	 * @private
	 */ _getSortedDatasetMetas: function(filterVisible) {
            var me = this;
            var datasets = me.data.datasets || [];
            var result = [];
            var i, ilen;
            for(i = 0, ilen = datasets.length; i < ilen; ++i)if (!filterVisible || me.isDatasetVisible(i)) result.push(me.getDatasetMeta(i));
            result.sort(compare2Level("order", "index"));
            return result;
        },
        /**
	 * @private
	 */ _getSortedVisibleDatasetMetas: function() {
            return this._getSortedDatasetMetas(true);
        },
        /**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */ drawDatasets: function(easingValue) {
            var me = this;
            var metasets, i;
            if (core_plugins.notify(me, "beforeDatasetsDraw", [
                easingValue
            ]) === false) return;
            metasets = me._getSortedVisibleDatasetMetas();
            for(i = metasets.length - 1; i >= 0; --i)me.drawDataset(metasets[i], easingValue);
            core_plugins.notify(me, "afterDatasetsDraw", [
                easingValue
            ]);
        },
        /**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */ drawDataset: function(meta, easingValue) {
            var me = this;
            var args = {
                meta: meta,
                index: meta.index,
                easingValue: easingValue
            };
            if (core_plugins.notify(me, "beforeDatasetDraw", [
                args
            ]) === false) return;
            meta.controller.draw(easingValue);
            core_plugins.notify(me, "afterDatasetDraw", [
                args
            ]);
        },
        /**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */ _drawTooltip: function(easingValue) {
            var me = this;
            var tooltip = me.tooltip;
            var args = {
                tooltip: tooltip,
                easingValue: easingValue
            };
            if (core_plugins.notify(me, "beforeTooltipDraw", [
                args
            ]) === false) return;
            tooltip.draw();
            core_plugins.notify(me, "afterTooltipDraw", [
                args
            ]);
        },
        /**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */ getElementAtEvent: function(e) {
            return core_interaction.modes.single(this, e);
        },
        getElementsAtEvent: function(e) {
            return core_interaction.modes.label(this, e, {
                intersect: true
            });
        },
        getElementsAtXAxis: function(e) {
            return core_interaction.modes["x-axis"](this, e, {
                intersect: true
            });
        },
        getElementsAtEventForMode: function(e, mode, options) {
            var method = core_interaction.modes[mode];
            if (typeof method === "function") return method(this, e, options);
            return [];
        },
        getDatasetAtEvent: function(e) {
            return core_interaction.modes.dataset(this, e, {
                intersect: true
            });
        },
        getDatasetMeta: function(datasetIndex) {
            var me = this;
            var dataset = me.data.datasets[datasetIndex];
            if (!dataset._meta) dataset._meta = {};
            var meta = dataset._meta[me.id];
            if (!meta) meta = dataset._meta[me.id] = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset.order || 0,
                index: datasetIndex
            };
            return meta;
        },
        getVisibleDatasetCount: function() {
            var count = 0;
            for(var i = 0, ilen = this.data.datasets.length; i < ilen; ++i)if (this.isDatasetVisible(i)) count++;
            return count;
        },
        isDatasetVisible: function(datasetIndex) {
            var meta = this.getDatasetMeta(datasetIndex);
            // meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
            // the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
            return typeof meta.hidden === "boolean" ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
        },
        generateLegend: function() {
            return this.options.legendCallback(this);
        },
        /**
	 * @private
	 */ destroyDatasetMeta: function(datasetIndex) {
            var id = this.id;
            var dataset = this.data.datasets[datasetIndex];
            var meta = dataset._meta && dataset._meta[id];
            if (meta) {
                meta.controller.destroy();
                delete dataset._meta[id];
            }
        },
        destroy: function() {
            var me = this;
            var canvas = me.canvas;
            var i, ilen;
            me.stop();
            // dataset controllers need to cleanup associated data
            for(i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me.destroyDatasetMeta(i);
            if (canvas) {
                me.unbindEvents();
                helpers$1.canvas.clear(me);
                platform.releaseContext(me.ctx);
                me.canvas = null;
                me.ctx = null;
            }
            core_plugins.notify(me, "destroy");
            delete Chart.instances[me.id];
        },
        toBase64Image: function() {
            return this.canvas.toDataURL.apply(this.canvas, arguments);
        },
        initToolTip: function() {
            var me = this;
            me.tooltip = new core_tooltip({
                _chart: me,
                _chartInstance: me,
                _data: me.data,
                _options: me.options.tooltips
            }, me);
        },
        /**
	 * @private
	 */ bindEvents: function() {
            var me = this;
            var listeners = me._listeners = {};
            var listener = function() {
                me.eventHandler.apply(me, arguments);
            };
            helpers$1.each(me.options.events, function(type) {
                platform.addEventListener(me, type, listener);
                listeners[type] = listener;
            });
            // Elements used to detect size change should not be injected for non responsive charts.
            // See https://github.com/chartjs/Chart.js/issues/2210
            if (me.options.responsive) {
                listener = function() {
                    me.resize();
                };
                platform.addEventListener(me, "resize", listener);
                listeners.resize = listener;
            }
        },
        /**
	 * @private
	 */ unbindEvents: function() {
            var me = this;
            var listeners = me._listeners;
            if (!listeners) return;
            delete me._listeners;
            helpers$1.each(listeners, function(listener, type) {
                platform.removeEventListener(me, type, listener);
            });
        },
        updateHoverStyle: function(elements, mode, enabled) {
            var prefix = enabled ? "set" : "remove";
            var element, i, ilen;
            for(i = 0, ilen = elements.length; i < ilen; ++i){
                element = elements[i];
                if (element) this.getDatasetMeta(element._datasetIndex).controller[prefix + "HoverStyle"](element);
            }
            if (mode === "dataset") this.getDatasetMeta(elements[0]._datasetIndex).controller["_" + prefix + "DatasetHoverStyle"]();
        },
        /**
	 * @private
	 */ eventHandler: function(e) {
            var me = this;
            var tooltip = me.tooltip;
            if (core_plugins.notify(me, "beforeEvent", [
                e
            ]) === false) return;
            // Buffer any update calls so that renders do not occur
            me._bufferedRender = true;
            me._bufferedRequest = null;
            var changed = me.handleEvent(e);
            // for smooth tooltip animations issue #4989
            // the tooltip should be the source of change
            // Animation check workaround:
            // tooltip._start will be null when tooltip isn't animating
            if (tooltip) changed = tooltip._start ? tooltip.handleEvent(e) : changed | tooltip.handleEvent(e);
            core_plugins.notify(me, "afterEvent", [
                e
            ]);
            var bufferedRequest = me._bufferedRequest;
            if (bufferedRequest) // If we have an update that was triggered, we need to do a normal render
            me.render(bufferedRequest);
            else if (changed && !me.animating) {
                // If entering, leaving, or changing elements, animate the change via pivot
                me.stop();
                // We only need to render at this point. Updating will cause scales to be
                // recomputed generating flicker & using more memory than necessary.
                me.render({
                    duration: me.options.hover.animationDuration,
                    lazy: true
                });
            }
            me._bufferedRender = false;
            me._bufferedRequest = null;
            return me;
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */ handleEvent: function(e) {
            var me = this;
            var options = me.options || {};
            var hoverOptions = options.hover;
            var changed = false;
            me.lastActive = me.lastActive || [];
            // Find Active Elements for hover and tooltips
            if (e.type === "mouseout") me.active = [];
            else me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
            // Invoke onHover hook
            // Need to call with native event here to not break backwards compatibility
            helpers$1.callback(options.onHover || options.hover.onHover, [
                e.native,
                me.active
            ], me);
            if (e.type === "mouseup" || e.type === "click") {
                if (options.onClick) // Use e.native here for backwards compatibility
                options.onClick.call(me, e.native, me.active);
            }
            // Remove styling for last active (even if it may still be active)
            if (me.lastActive.length) me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
            // Built in hover styling
            if (me.active.length && hoverOptions.mode) me.updateHoverStyle(me.active, hoverOptions.mode, true);
            changed = !helpers$1.arrayEquals(me.active, me.lastActive);
            // Remember Last Actives
            me.lastActive = me.active;
            return changed;
        }
    });
    /**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */ Chart.instances = {};
    var core_controller = Chart;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */ Chart.Controller = Chart;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */ Chart.types = {};
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ helpers$1.configMerge = mergeConfig;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ helpers$1.scaleMerge = mergeScaleConfig;
    var core_helpers = function() {
        // -- Basic js utility methods
        helpers$1.where = function(collection, filterCallback) {
            if (helpers$1.isArray(collection) && Array.prototype.filter) return collection.filter(filterCallback);
            var filtered = [];
            helpers$1.each(collection, function(item) {
                if (filterCallback(item)) filtered.push(item);
            });
            return filtered;
        };
        helpers$1.findIndex = Array.prototype.findIndex ? function(array, callback, scope) {
            return array.findIndex(callback, scope);
        } : function(array, callback, scope) {
            scope = scope === undefined ? array : scope;
            for(var i = 0, ilen = array.length; i < ilen; ++i){
                if (callback.call(scope, array[i], i, array)) return i;
            }
            return -1;
        };
        helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
            // Default to start of the array
            if (helpers$1.isNullOrUndef(startIndex)) startIndex = -1;
            for(var i = startIndex + 1; i < arrayToSearch.length; i++){
                var currentItem = arrayToSearch[i];
                if (filterCallback(currentItem)) return currentItem;
            }
        };
        helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
            // Default to end of the array
            if (helpers$1.isNullOrUndef(startIndex)) startIndex = arrayToSearch.length;
            for(var i = startIndex - 1; i >= 0; i--){
                var currentItem = arrayToSearch[i];
                if (filterCallback(currentItem)) return currentItem;
            }
        };
        // -- Math methods
        helpers$1.isNumber = function(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        };
        helpers$1.almostEquals = function(x, y, epsilon) {
            return Math.abs(x - y) < epsilon;
        };
        helpers$1.almostWhole = function(x, epsilon) {
            var rounded = Math.round(x);
            return rounded - epsilon <= x && rounded + epsilon >= x;
        };
        helpers$1.max = function(array) {
            return array.reduce(function(max, value) {
                if (!isNaN(value)) return Math.max(max, value);
                return max;
            }, Number.NEGATIVE_INFINITY);
        };
        helpers$1.min = function(array) {
            return array.reduce(function(min, value) {
                if (!isNaN(value)) return Math.min(min, value);
                return min;
            }, Number.POSITIVE_INFINITY);
        };
        helpers$1.sign = Math.sign ? function(x) {
            return Math.sign(x);
        } : function(x) {
            x = +x; // convert to a number
            if (x === 0 || isNaN(x)) return x;
            return x > 0 ? 1 : -1;
        };
        helpers$1.toRadians = function(degrees) {
            return degrees * (Math.PI / 180);
        };
        helpers$1.toDegrees = function(radians) {
            return radians * (180 / Math.PI);
        };
        /**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */ helpers$1._decimalPlaces = function(x) {
            if (!helpers$1.isFinite(x)) return;
            var e = 1;
            var p = 0;
            while(Math.round(x * e) / e !== x){
                e *= 10;
                p++;
            }
            return p;
        };
        // Gets the angle from vertical upright to the point about a centre.
        helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
            var distanceFromXCenter = anglePoint.x - centrePoint.x;
            var distanceFromYCenter = anglePoint.y - centrePoint.y;
            var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
            var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
            if (angle < -0.5 * Math.PI) angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
            return {
                angle: angle,
                distance: radialDistanceFromCenter
            };
        };
        helpers$1.distanceBetweenPoints = function(pt1, pt2) {
            return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
        };
        /**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */ helpers$1.aliasPixel = function(pixelWidth) {
            return pixelWidth % 2 === 0 ? 0 : 0.5;
        };
        /**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */ helpers$1._alignPixel = function(chart, pixel, width) {
            var devicePixelRatio = chart.currentDevicePixelRatio;
            var halfWidth = width / 2;
            return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
        };
        helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
            // Props to Rob Spencer at scaled innovation for his post on splining between points
            // http://scaledinnovation.com/analytics/splines/aboutSplines.html
            // This function must also respect "skipped" points
            var previous = firstPoint.skip ? middlePoint : firstPoint;
            var current = middlePoint;
            var next = afterPoint.skip ? middlePoint : afterPoint;
            var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
            var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
            var s01 = d01 / (d01 + d12);
            var s12 = d12 / (d01 + d12);
            // If all points are the same, s01 & s02 will be inf
            s01 = isNaN(s01) ? 0 : s01;
            s12 = isNaN(s12) ? 0 : s12;
            var fa = t * s01; // scaling factor for triangle Ta
            var fb = t * s12;
            return {
                previous: {
                    x: current.x - fa * (next.x - previous.x),
                    y: current.y - fa * (next.y - previous.y)
                },
                next: {
                    x: current.x + fb * (next.x - previous.x),
                    y: current.y + fb * (next.y - previous.y)
                }
            };
        };
        helpers$1.EPSILON = Number.EPSILON || 1e-14;
        helpers$1.splineCurveMonotone = function(points) {
            // This function calculates Bézier control points in a similar way than |splineCurve|,
            // but preserves monotonicity of the provided data and ensures no local extremums are added
            // between the dataset discrete points due to the interpolation.
            // See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
            var pointsWithTangents = (points || []).map(function(point) {
                return {
                    model: point._model,
                    deltaK: 0,
                    mK: 0
                };
            });
            // Calculate slopes (deltaK) and initialize tangents (mK)
            var pointsLen = pointsWithTangents.length;
            var i, pointBefore, pointCurrent, pointAfter;
            for(i = 0; i < pointsLen; ++i){
                pointCurrent = pointsWithTangents[i];
                if (pointCurrent.model.skip) continue;
                pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
                pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
                if (pointAfter && !pointAfter.model.skip) {
                    var slopeDeltaX = pointAfter.model.x - pointCurrent.model.x;
                    // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
                    pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
                }
                if (!pointBefore || pointBefore.model.skip) pointCurrent.mK = pointCurrent.deltaK;
                else if (!pointAfter || pointAfter.model.skip) pointCurrent.mK = pointBefore.deltaK;
                else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) pointCurrent.mK = 0;
                else pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
            }
            // Adjust tangents to ensure monotonic properties
            var alphaK, betaK, tauK, squaredMagnitude;
            for(i = 0; i < pointsLen - 1; ++i){
                pointCurrent = pointsWithTangents[i];
                pointAfter = pointsWithTangents[i + 1];
                if (pointCurrent.model.skip || pointAfter.model.skip) continue;
                if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
                    pointCurrent.mK = pointAfter.mK = 0;
                    continue;
                }
                alphaK = pointCurrent.mK / pointCurrent.deltaK;
                betaK = pointAfter.mK / pointCurrent.deltaK;
                squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
                if (squaredMagnitude <= 9) continue;
                tauK = 3 / Math.sqrt(squaredMagnitude);
                pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
                pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
            }
            // Compute control points
            var deltaX;
            for(i = 0; i < pointsLen; ++i){
                pointCurrent = pointsWithTangents[i];
                if (pointCurrent.model.skip) continue;
                pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
                pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
                if (pointBefore && !pointBefore.model.skip) {
                    deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
                    pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
                    pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
                }
                if (pointAfter && !pointAfter.model.skip) {
                    deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
                    pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
                    pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
                }
            }
        };
        helpers$1.nextItem = function(collection, index, loop) {
            if (loop) return index >= collection.length - 1 ? collection[0] : collection[index + 1];
            return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
        };
        helpers$1.previousItem = function(collection, index, loop) {
            if (loop) return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
            return index <= 0 ? collection[0] : collection[index - 1];
        };
        // Implementation of the nice number algorithm used in determining where axis labels will go
        helpers$1.niceNum = function(range, round) {
            var exponent = Math.floor(helpers$1.log10(range));
            var fraction = range / Math.pow(10, exponent);
            var niceFraction;
            if (round) {
                if (fraction < 1.5) niceFraction = 1;
                else if (fraction < 3) niceFraction = 2;
                else if (fraction < 7) niceFraction = 5;
                else niceFraction = 10;
            } else if (fraction <= 1.0) niceFraction = 1;
            else if (fraction <= 2) niceFraction = 2;
            else if (fraction <= 5) niceFraction = 5;
            else niceFraction = 10;
            return niceFraction * Math.pow(10, exponent);
        };
        // Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
        helpers$1.requestAnimFrame = function() {
            if (typeof window === "undefined") return function(callback) {
                callback();
            };
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) {
                return window.setTimeout(callback, 1000 / 60);
            };
        }();
        // -- DOM methods
        helpers$1.getRelativePosition = function(evt, chart) {
            var mouseX, mouseY;
            var e = evt.originalEvent || evt;
            var canvas = evt.target || evt.srcElement;
            var boundingRect = canvas.getBoundingClientRect();
            var touches = e.touches;
            if (touches && touches.length > 0) {
                mouseX = touches[0].clientX;
                mouseY = touches[0].clientY;
            } else {
                mouseX = e.clientX;
                mouseY = e.clientY;
            }
            // Scale mouse coordinates into canvas coordinates
            // by following the pattern laid out by 'jerryj' in the comments of
            // https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
            var paddingLeft = parseFloat(helpers$1.getStyle(canvas, "padding-left"));
            var paddingTop = parseFloat(helpers$1.getStyle(canvas, "padding-top"));
            var paddingRight = parseFloat(helpers$1.getStyle(canvas, "padding-right"));
            var paddingBottom = parseFloat(helpers$1.getStyle(canvas, "padding-bottom"));
            var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
            var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
            // We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
            // the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
            mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / width * canvas.width / chart.currentDevicePixelRatio);
            mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / height * canvas.height / chart.currentDevicePixelRatio);
            return {
                x: mouseX,
                y: mouseY
            };
        };
        // Private helper function to convert max-width/max-height values that may be percentages into a number
        function parseMaxStyle(styleValue, node, parentProperty) {
            var valueInPixels;
            if (typeof styleValue === "string") {
                valueInPixels = parseInt(styleValue, 10);
                if (styleValue.indexOf("%") !== -1) // percentage * size in dimension
                valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
            } else valueInPixels = styleValue;
            return valueInPixels;
        }
        /**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */ function isConstrainedValue(value) {
            return value !== undefined && value !== null && value !== "none";
        }
        /**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */ function getConstraintDimension(domNode, maxStyle, percentageProperty) {
            var view = document.defaultView;
            var parentNode = helpers$1._getParentNode(domNode);
            var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
            var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
            var hasCNode = isConstrainedValue(constrainedNode);
            var hasCContainer = isConstrainedValue(constrainedContainer);
            var infinity = Number.POSITIVE_INFINITY;
            if (hasCNode || hasCContainer) return Math.min(hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity, hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
            return "none";
        }
        // returns Number or undefined if no constraint
        helpers$1.getConstraintWidth = function(domNode) {
            return getConstraintDimension(domNode, "max-width", "clientWidth");
        };
        // returns Number or undefined if no constraint
        helpers$1.getConstraintHeight = function(domNode) {
            return getConstraintDimension(domNode, "max-height", "clientHeight");
        };
        /**
	 * @private
 	 */ helpers$1._calculatePadding = function(container, padding, parentDimension) {
            padding = helpers$1.getStyle(container, padding);
            return padding.indexOf("%") > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
        };
        /**
	 * @private
	 */ helpers$1._getParentNode = function(domNode) {
            var parent = domNode.parentNode;
            if (parent && parent.toString() === "[object ShadowRoot]") parent = parent.host;
            return parent;
        };
        helpers$1.getMaximumWidth = function(domNode) {
            var container = helpers$1._getParentNode(domNode);
            if (!container) return domNode.clientWidth;
            var clientWidth = container.clientWidth;
            var paddingLeft = helpers$1._calculatePadding(container, "padding-left", clientWidth);
            var paddingRight = helpers$1._calculatePadding(container, "padding-right", clientWidth);
            var w = clientWidth - paddingLeft - paddingRight;
            var cw = helpers$1.getConstraintWidth(domNode);
            return isNaN(cw) ? w : Math.min(w, cw);
        };
        helpers$1.getMaximumHeight = function(domNode) {
            var container = helpers$1._getParentNode(domNode);
            if (!container) return domNode.clientHeight;
            var clientHeight = container.clientHeight;
            var paddingTop = helpers$1._calculatePadding(container, "padding-top", clientHeight);
            var paddingBottom = helpers$1._calculatePadding(container, "padding-bottom", clientHeight);
            var h = clientHeight - paddingTop - paddingBottom;
            var ch = helpers$1.getConstraintHeight(domNode);
            return isNaN(ch) ? h : Math.min(h, ch);
        };
        helpers$1.getStyle = function(el, property) {
            return el.currentStyle ? el.currentStyle[property] : document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
        };
        helpers$1.retinaScale = function(chart, forceRatio) {
            var pixelRatio = chart.currentDevicePixelRatio = forceRatio || typeof window !== "undefined" && window.devicePixelRatio || 1;
            if (pixelRatio === 1) return;
            var canvas = chart.canvas;
            var height = chart.height;
            var width = chart.width;
            canvas.height = height * pixelRatio;
            canvas.width = width * pixelRatio;
            chart.ctx.scale(pixelRatio, pixelRatio);
            // If no style has been set on the canvas, the render size is used as display size,
            // making the chart visually bigger, so let's enforce it to the "correct" values.
            // See https://github.com/chartjs/Chart.js/issues/3575
            if (!canvas.style.height && !canvas.style.width) {
                canvas.style.height = height + "px";
                canvas.style.width = width + "px";
            }
        };
        // -- Canvas methods
        helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
            return fontStyle + " " + pixelSize + "px " + fontFamily;
        };
        helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
            cache = cache || {};
            var data = cache.data = cache.data || {};
            var gc = cache.garbageCollect = cache.garbageCollect || [];
            if (cache.font !== font) {
                data = cache.data = {};
                gc = cache.garbageCollect = [];
                cache.font = font;
            }
            ctx.font = font;
            var longest = 0;
            var ilen = arrayOfThings.length;
            var i, j, jlen, thing, nestedThing;
            for(i = 0; i < ilen; i++){
                thing = arrayOfThings[i];
                // Undefined strings and arrays should not be measured
                if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) longest = helpers$1.measureText(ctx, data, gc, longest, thing);
                else if (helpers$1.isArray(thing)) // if it is an array lets measure each element
                // to do maybe simplify this function a bit so we can do this more recursively?
                for(j = 0, jlen = thing.length; j < jlen; j++){
                    nestedThing = thing[j];
                    // Undefined strings and arrays should not be measured
                    if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
                }
            }
            var gcLen = gc.length / 2;
            if (gcLen > arrayOfThings.length) {
                for(i = 0; i < gcLen; i++)delete data[gc[i]];
                gc.splice(0, gcLen);
            }
            return longest;
        };
        helpers$1.measureText = function(ctx, data, gc, longest, string) {
            var textWidth = data[string];
            if (!textWidth) {
                textWidth = data[string] = ctx.measureText(string).width;
                gc.push(string);
            }
            if (textWidth > longest) longest = textWidth;
            return longest;
        };
        /**
	 * @deprecated
	 */ helpers$1.numberOfLabelLines = function(arrayOfThings) {
            var numberOfLines = 1;
            helpers$1.each(arrayOfThings, function(thing) {
                if (helpers$1.isArray(thing)) {
                    if (thing.length > numberOfLines) numberOfLines = thing.length;
                }
            });
            return numberOfLines;
        };
        helpers$1.color = !chartjsColor ? function(value) {
            console.error("Color.js not found!");
            return value;
        } : function(value) {
            /* global CanvasGradient */ if (value instanceof CanvasGradient) value = core_defaults.global.defaultColor;
            return chartjsColor(value);
        };
        helpers$1.getHoverColor = function(colorValue) {
            /* global CanvasPattern */ return colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient ? colorValue : helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
        };
    };
    function abstract() {
        throw new Error("This method is not implemented: either no adapter can be found or an incomplete integration was provided.");
    }
    /**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ /**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */ /**
 * @class
 */ function DateAdapter(options) {
        this.options = options || {};
    }
    helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
        /**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */ formats: abstract,
        /**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */ parse: abstract,
        /**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */ format: abstract,
        /**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */ add: abstract,
        /**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */ diff: abstract,
        /**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */ startOf: abstract,
        /**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */ endOf: abstract,
        // DEPRECATIONS
        /**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */ _create: function(value) {
            return value;
        }
    });
    DateAdapter.override = function(members) {
        helpers$1.extend(DateAdapter.prototype, members);
    };
    var _date = DateAdapter;
    var core_adapters = {
        _date: _date
    };
    /**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */ var core_ticks = {
        /**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */ formatters: {
            /**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */ values: function(value) {
                return helpers$1.isArray(value) ? value : "" + value;
            },
            /**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */ linear: function(tickValue, index, ticks) {
                // If we have lots of ticks, don't use the ones
                var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
                // If we have a number like 2.5 as the delta, figure out how many decimal places we need
                if (Math.abs(delta) > 1) {
                    if (tickValue !== Math.floor(tickValue)) // not an integer
                    delta = tickValue - Math.floor(tickValue);
                }
                var logDelta = helpers$1.log10(Math.abs(delta));
                var tickString = "";
                if (tickValue !== 0) {
                    var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
                    if (maxTick < 1e-4) {
                        var logTick = helpers$1.log10(Math.abs(tickValue));
                        var numExponential = Math.floor(logTick) - Math.floor(logDelta);
                        numExponential = Math.max(Math.min(numExponential, 20), 0);
                        tickString = tickValue.toExponential(numExponential);
                    } else {
                        var numDecimal = -1 * Math.floor(logDelta);
                        numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
                        tickString = tickValue.toFixed(numDecimal);
                    }
                } else tickString = "0"; // never show decimal places for 0
                return tickString;
            },
            logarithmic: function(tickValue, index, ticks) {
                var remain = tickValue / Math.pow(10, Math.floor(helpers$1.log10(tickValue)));
                if (tickValue === 0) return "0";
                else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) return tickValue.toExponential();
                return "";
            }
        }
    };
    var isArray = helpers$1.isArray;
    var isNullOrUndef = helpers$1.isNullOrUndef;
    var valueOrDefault$a = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
    core_defaults._set("scale", {
        display: true,
        position: "left",
        offset: false,
        // grid line settings
        gridLines: {
            display: true,
            color: "rgba(0,0,0,0.1)",
            lineWidth: 1,
            drawBorder: true,
            drawOnChartArea: true,
            drawTicks: true,
            tickMarkLength: 10,
            zeroLineWidth: 1,
            zeroLineColor: "rgba(0,0,0,0.25)",
            zeroLineBorderDash: [],
            zeroLineBorderDashOffset: 0.0,
            offsetGridLines: false,
            borderDash: [],
            borderDashOffset: 0.0
        },
        // scale label
        scaleLabel: {
            // display property
            display: false,
            // actual label
            labelString: "",
            // top/bottom padding
            padding: {
                top: 4,
                bottom: 4
            }
        },
        // label settings
        ticks: {
            beginAtZero: false,
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            padding: 0,
            reverse: false,
            display: true,
            autoSkip: true,
            autoSkipPadding: 0,
            labelOffset: 0,
            // We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
            callback: core_ticks.formatters.values,
            minor: {},
            major: {}
        }
    });
    /** Returns a new array containing numItems from arr */ function sample(arr, numItems) {
        var result = [];
        var increment = arr.length / numItems;
        var i = 0;
        var len = arr.length;
        for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
        return result;
    }
    function getPixelForGridLine(scale, index, offsetGridLines) {
        var length = scale.getTicks().length;
        var validIndex = Math.min(index, length - 1);
        var lineValue = scale.getPixelForTick(validIndex);
        var start = scale._startPixel;
        var end = scale._endPixel;
        var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
        var offset;
        if (offsetGridLines) {
            if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
            else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
            else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
            lineValue += validIndex < index ? offset : -offset;
            // Return undefined if the pixel is out of the range
            if (lineValue < start - epsilon || lineValue > end + epsilon) return;
        }
        return lineValue;
    }
    function garbageCollect(caches, length) {
        helpers$1.each(caches, function(cache) {
            var gc = cache.gc;
            var gcLen = gc.length / 2;
            var i;
            if (gcLen > length) {
                for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
                gc.splice(0, gcLen);
            }
        });
    }
    /**
 * Returns {width, height, offset} objects for the first, last, widest, highest tick
 * labels where offset indicates the anchor point offset from the top in pixels.
 */ function computeLabelSizes(ctx, tickFonts, ticks, caches) {
        var length = ticks.length;
        var widths = [];
        var heights = [];
        var offsets = [];
        var widestLabelSize = 0;
        var highestLabelSize = 0;
        var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
        for(i = 0; i < length; ++i){
            label = ticks[i].label;
            tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            // Undefined labels and arrays should not be measured
            if (!isNullOrUndef(label) && !isArray(label)) {
                width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if (isArray(label)) // if it is an array let's measure each element
            for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                // Undefined labels and arrays should not be measured
                if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
                    width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            offsets.push(lineHeight / 2);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        garbageCollect(caches, length);
        widest = widths.indexOf(widestLabelSize);
        highest = heights.indexOf(highestLabelSize);
        function valueAt(idx) {
            return {
                width: widths[idx] || 0,
                height: heights[idx] || 0,
                offset: offsets[idx] || 0
            };
        }
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest)
        };
    }
    function getTickMarkLength(options) {
        return options.drawTicks ? options.tickMarkLength : 0;
    }
    function getScaleLabelHeight(options) {
        var font, padding;
        if (!options.display) return 0;
        font = helpers$1.options._parseFont(options);
        padding = helpers$1.options.toPadding(options.padding);
        return font.lineHeight + padding.height;
    }
    function parseFontOptions(options, nestedOpts) {
        return helpers$1.extend(helpers$1.options._parseFont({
            fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
            fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
            fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
            lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
        }), {
            color: helpers$1.options.resolve([
                nestedOpts.fontColor,
                options.fontColor,
                core_defaults.global.defaultFontColor
            ])
        });
    }
    function parseTickFontOptions(options) {
        var minor = parseFontOptions(options, options.minor);
        var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
        return {
            minor: minor,
            major: major
        };
    }
    function nonSkipped(ticksToFilter) {
        var filtered = [];
        var item, index, len;
        for(index = 0, len = ticksToFilter.length; index < len; ++index){
            item = ticksToFilter[index];
            if (typeof item._index !== "undefined") filtered.push(item);
        }
        return filtered;
    }
    function getEvenSpacing(arr) {
        var len = arr.length;
        var i, diff;
        if (len < 2) return false;
        for(diff = arr[0], i = 1; i < len; ++i){
            if (arr[i] - arr[i - 1] !== diff) return false;
        }
        return diff;
    }
    function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
        var evenMajorSpacing = getEvenSpacing(majorIndices);
        var spacing = (ticks.length - 1) / ticksLimit;
        var factors, factor, i, ilen;
        // If the major ticks are evenly spaced apart, place the minor ticks
        // so that they divide the major ticks into even chunks
        if (!evenMajorSpacing) return Math.max(spacing, 1);
        factors = helpers$1.math._factorize(evenMajorSpacing);
        for(i = 0, ilen = factors.length - 1; i < ilen; i++){
            factor = factors[i];
            if (factor > spacing) return factor;
        }
        return Math.max(spacing, 1);
    }
    function getMajorIndices(ticks) {
        var result = [];
        var i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
        return result;
    }
    function skipMajors(ticks, majorIndices, spacing) {
        var count = 0;
        var next = majorIndices[0];
        var i, tick;
        spacing = Math.ceil(spacing);
        for(i = 0; i < ticks.length; i++){
            tick = ticks[i];
            if (i === next) {
                tick._index = i;
                count++;
                next = majorIndices[count * spacing];
            } else delete tick.label;
        }
    }
    function skip(ticks, spacing, majorStart, majorEnd) {
        var start = valueOrDefault$a(majorStart, 0);
        var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
        var count = 0;
        var length, i, tick, next;
        spacing = Math.ceil(spacing);
        if (majorEnd) {
            length = majorEnd - majorStart;
            spacing = length / Math.floor(length / spacing);
        }
        next = start;
        while(next < 0){
            count++;
            next = Math.round(start + count * spacing);
        }
        for(i = Math.max(start, 0); i < end; i++){
            tick = ticks[i];
            if (i === next) {
                tick._index = i;
                count++;
                next = Math.round(start + count * spacing);
            } else delete tick.label;
        }
    }
    var Scale = core_element.extend({
        zeroLineIndex: 0,
        /**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */ getPadding: function() {
            var me = this;
            return {
                left: me.paddingLeft || 0,
                top: me.paddingTop || 0,
                right: me.paddingRight || 0,
                bottom: me.paddingBottom || 0
            };
        },
        /**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */ getTicks: function() {
            return this._ticks;
        },
        /**
	* @private
	*/ _getLabels: function() {
            var data = this.chart.data;
            return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
        },
        // These methods are ordered by lifecyle. Utilities then follow.
        // Any function defined here is inherited by all scale types.
        // Any function can be extended by the scale type
        /**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.Scale.mergeTicksOptions
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */ mergeTicksOptions: function() {
        // noop
        },
        beforeUpdate: function() {
            helpers$1.callback(this.options.beforeUpdate, [
                this
            ]);
        },
        /**
	 * @param {number} maxWidth - the max width in pixels
	 * @param {number} maxHeight - the max height in pixels
	 * @param {object} margins - the space between the edge of the other scales and edge of the chart
	 *   This space comes from two sources:
	 *     - padding - space that's required to show the labels at the edges of the scale
	 *     - thickness of scales or legends in another orientation
	 */ update: function(maxWidth, maxHeight, margins) {
            var me = this;
            var tickOpts = me.options.ticks;
            var sampleSize = tickOpts.sampleSize;
            var i, ilen, labels, ticks, samplingEnabled;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = helpers$1.extend({
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }, margins);
            me._ticks = null;
            me.ticks = null;
            me._labelSizes = null;
            me._maxLabelLines = 0;
            me.longestLabelWidth = 0;
            me.longestTextCache = me.longestTextCache || {};
            me._gridLineItems = null;
            me._labelItems = null;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Data min/max
            me.beforeDataLimits();
            me.determineDataLimits();
            me.afterDataLimits();
            // Ticks - `this.ticks` is now DEPRECATED!
            // Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
            // and must not be accessed directly from outside this class. `this.ticks` being
            // around for long time and not marked as private, we can't change its structure
            // without unexpected breaking changes. If you need to access the scale ticks,
            // use scale.getTicks() instead.
            me.beforeBuildTicks();
            // New implementations should return an array of objects but for BACKWARD COMPAT,
            // we still support no return (`this.ticks` internally set by calling this method).
            ticks = me.buildTicks() || [];
            // Allow modification of ticks in callback.
            ticks = me.afterBuildTicks(ticks) || ticks;
            // Ensure ticks contains ticks in new tick format
            if ((!ticks || !ticks.length) && me.ticks) {
                ticks = [];
                for(i = 0, ilen = me.ticks.length; i < ilen; ++i)ticks.push({
                    value: me.ticks[i],
                    major: false
                });
            }
            me._ticks = ticks;
            // Compute tick rotation and fit using a sampled subset of labels
            // We generally don't need to compute the size of every single label for determining scale size
            samplingEnabled = sampleSize < ticks.length;
            labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
            // _configure is called twice, once here, once from core.controller.updateLayout.
            // Here we haven't been positioned yet, but dimensions are correct.
            // Variables set in _configure are needed for calculateTickRotation, and
            // it's ok that coordinates are not correct there, only dimensions matter.
            me._configure();
            // Tick Rotation
            me.beforeCalculateTickRotation();
            me.calculateTickRotation();
            me.afterCalculateTickRotation();
            me.beforeFit();
            me.fit();
            me.afterFit();
            // Auto-skip
            me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto") ? me._autoSkip(ticks) : ticks;
            if (samplingEnabled) // Generate labels using all non-skipped ticks
            labels = me._convertTicksToLabels(me._ticksToDraw);
            me.ticks = labels; // BACKWARD COMPATIBILITY
            // IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!
            me.afterUpdate();
            // TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
            // make maxWidth and maxHeight private
            return me.minSize;
        },
        /**
	 * @private
	 */ _configure: function() {
            var me = this;
            var reversePixels = me.options.ticks.reverse;
            var startPixel, endPixel;
            if (me.isHorizontal()) {
                startPixel = me.left;
                endPixel = me.right;
            } else {
                startPixel = me.top;
                endPixel = me.bottom;
                // by default vertical scales are from bottom to top, so pixels are reversed
                reversePixels = !reversePixels;
            }
            me._startPixel = startPixel;
            me._endPixel = endPixel;
            me._reversePixels = reversePixels;
            me._length = endPixel - startPixel;
        },
        afterUpdate: function() {
            helpers$1.callback(this.options.afterUpdate, [
                this
            ]);
        },
        //
        beforeSetDimensions: function() {
            helpers$1.callback(this.options.beforeSetDimensions, [
                this
            ]);
        },
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
        },
        afterSetDimensions: function() {
            helpers$1.callback(this.options.afterSetDimensions, [
                this
            ]);
        },
        // Data limits
        beforeDataLimits: function() {
            helpers$1.callback(this.options.beforeDataLimits, [
                this
            ]);
        },
        determineDataLimits: helpers$1.noop,
        afterDataLimits: function() {
            helpers$1.callback(this.options.afterDataLimits, [
                this
            ]);
        },
        //
        beforeBuildTicks: function() {
            helpers$1.callback(this.options.beforeBuildTicks, [
                this
            ]);
        },
        buildTicks: helpers$1.noop,
        afterBuildTicks: function(ticks) {
            var me = this;
            // ticks is empty for old axis implementations here
            if (isArray(ticks) && ticks.length) return helpers$1.callback(me.options.afterBuildTicks, [
                me,
                ticks
            ]);
            // Support old implementations (that modified `this.ticks` directly in buildTicks)
            me.ticks = helpers$1.callback(me.options.afterBuildTicks, [
                me,
                me.ticks
            ]) || me.ticks;
            return ticks;
        },
        beforeTickToLabelConversion: function() {
            helpers$1.callback(this.options.beforeTickToLabelConversion, [
                this
            ]);
        },
        convertTicksToLabels: function() {
            var me = this;
            // Convert ticks to strings
            var tickOpts = me.options.ticks;
            me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
        },
        afterTickToLabelConversion: function() {
            helpers$1.callback(this.options.afterTickToLabelConversion, [
                this
            ]);
        },
        //
        beforeCalculateTickRotation: function() {
            helpers$1.callback(this.options.beforeCalculateTickRotation, [
                this
            ]);
        },
        calculateTickRotation: function() {
            var me = this;
            var options = me.options;
            var tickOpts = options.ticks;
            var numTicks = me.getTicks().length;
            var minRotation = tickOpts.minRotation || 0;
            var maxRotation = tickOpts.maxRotation;
            var labelRotation = minRotation;
            var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
            if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
                me.labelRotation = minRotation;
                return;
            }
            labelSizes = me._getLabelSizes();
            maxLabelWidth = labelSizes.widest.width;
            maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
            // Estimate the width of each grid based on the canvas width, the maximum
            // label width and the number of tick intervals
            maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
            tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
            // Allow 3 pixels x2 padding either side for label readability
            if (maxLabelWidth + 6 > tickWidth) {
                tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
                maxHeight = me.maxHeight - getTickMarkLength(options.gridLines) - tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
                maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
                labelRotation = helpers$1.toDegrees(Math.min(Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)), Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)));
                labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
            }
            me.labelRotation = labelRotation;
        },
        afterCalculateTickRotation: function() {
            helpers$1.callback(this.options.afterCalculateTickRotation, [
                this
            ]);
        },
        //
        beforeFit: function() {
            helpers$1.callback(this.options.beforeFit, [
                this
            ]);
        },
        fit: function() {
            var me = this;
            // Reset
            var minSize = me.minSize = {
                width: 0,
                height: 0
            };
            var chart = me.chart;
            var opts = me.options;
            var tickOpts = opts.ticks;
            var scaleLabelOpts = opts.scaleLabel;
            var gridLineOpts = opts.gridLines;
            var display = me._isVisible();
            var isBottom = opts.position === "bottom";
            var isHorizontal = me.isHorizontal();
            // Width
            if (isHorizontal) minSize.width = me.maxWidth;
            else if (display) minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
            // height
            if (!isHorizontal) minSize.height = me.maxHeight; // fill all the height
            else if (display) minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
            // Don't bother fitting the ticks if we are not showing the labels
            if (tickOpts.display && display) {
                var tickFonts = parseTickFontOptions(tickOpts);
                var labelSizes = me._getLabelSizes();
                var firstLabelSize = labelSizes.first;
                var lastLabelSize = labelSizes.last;
                var widestLabelSize = labelSizes.widest;
                var highestLabelSize = labelSizes.highest;
                var lineSpace = tickFonts.minor.lineHeight * 0.4;
                var tickPadding = tickOpts.padding;
                if (isHorizontal) {
                    // A horizontal axis is more constrained by the height.
                    var isRotated = me.labelRotation !== 0;
                    var angleRadians = helpers$1.toRadians(me.labelRotation);
                    var cosRotation = Math.cos(angleRadians);
                    var sinRotation = Math.sin(angleRadians);
                    var labelHeight = sinRotation * widestLabelSize.width + cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0)) + (isRotated ? 0 : lineSpace); // padding
                    minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
                    var offsetLeft = me.getPixelForTick(0) - me.left;
                    var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
                    var paddingLeft, paddingRight;
                    // Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
                    // which means that the right padding is dominated by the font height
                    if (isRotated) {
                        paddingLeft = isBottom ? cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset : sinRotation * (firstLabelSize.height - firstLabelSize.offset);
                        paddingRight = isBottom ? sinRotation * (lastLabelSize.height - lastLabelSize.offset) : cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
                    } else {
                        paddingLeft = firstLabelSize.width / 2;
                        paddingRight = lastLabelSize.width / 2;
                    }
                    // Adjust padding taking into account changes in offsets
                    // and add 3 px to move away from canvas edges
                    me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
                    me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
                } else {
                    // A vertical axis is more constrained by the width. Labels are the
                    // dominant factor here, so get that length first and account for padding
                    var labelWidth = tickOpts.mirror ? 0 : // use lineSpace for consistency with horizontal axis
                    // tickPadding is not implemented for horizontal
                    widestLabelSize.width + tickPadding + lineSpace;
                    minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
                    me.paddingTop = firstLabelSize.height / 2;
                    me.paddingBottom = lastLabelSize.height / 2;
                }
            }
            me.handleMargins();
            if (isHorizontal) {
                me.width = me._length = chart.width - me.margins.left - me.margins.right;
                me.height = minSize.height;
            } else {
                me.width = minSize.width;
                me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
            }
        },
        /**
	 * Handle margins and padding interactions
	 * @private
	 */ handleMargins: function() {
            var me = this;
            if (me.margins) {
                me.margins.left = Math.max(me.paddingLeft, me.margins.left);
                me.margins.top = Math.max(me.paddingTop, me.margins.top);
                me.margins.right = Math.max(me.paddingRight, me.margins.right);
                me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
            }
        },
        afterFit: function() {
            helpers$1.callback(this.options.afterFit, [
                this
            ]);
        },
        // Shared Methods
        isHorizontal: function() {
            var pos = this.options.position;
            return pos === "top" || pos === "bottom";
        },
        isFullWidth: function() {
            return this.options.fullWidth;
        },
        // Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
        getRightValue: function(rawValue) {
            // Null and undefined values first
            if (isNullOrUndef(rawValue)) return NaN;
            // isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
            if ((typeof rawValue === "number" || rawValue instanceof Number) && !isFinite(rawValue)) return NaN;
            // If it is in fact an object, dive in one more level
            if (rawValue) {
                if (this.isHorizontal()) {
                    if (rawValue.x !== undefined) return this.getRightValue(rawValue.x);
                } else if (rawValue.y !== undefined) return this.getRightValue(rawValue.y);
            }
            // Value is good, return it
            return rawValue;
        },
        _convertTicksToLabels: function(ticks) {
            var me = this;
            var labels, i, ilen;
            me.ticks = ticks.map(function(tick) {
                return tick.value;
            });
            me.beforeTickToLabelConversion();
            // New implementations should return the formatted tick labels but for BACKWARD
            // COMPAT, we still support no return (`this.ticks` internally changed by calling
            // this method and supposed to contain only string values).
            labels = me.convertTicksToLabels(ticks) || me.ticks;
            me.afterTickToLabelConversion();
            // BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
            for(i = 0, ilen = ticks.length; i < ilen; ++i)ticks[i].label = labels[i];
            return labels;
        },
        /**
	 * @private
	 */ _getLabelSizes: function() {
            var me = this;
            var labelSizes = me._labelSizes;
            if (!labelSizes) {
                me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
                me.longestLabelWidth = labelSizes.widest.width;
            }
            return labelSizes;
        },
        /**
	 * @private
	 */ _parseValue: function(value) {
            var start, end, min, max;
            if (isArray(value)) {
                start = +this.getRightValue(value[0]);
                end = +this.getRightValue(value[1]);
                min = Math.min(start, end);
                max = Math.max(start, end);
            } else {
                value = +this.getRightValue(value);
                start = undefined;
                end = value;
                min = value;
                max = value;
            }
            return {
                min: min,
                max: max,
                start: start,
                end: end
            };
        },
        /**
	* @private
	*/ _getScaleLabel: function(rawValue) {
            var v = this._parseValue(rawValue);
            if (v.start !== undefined) return "[" + v.start + ", " + v.end + "]";
            return +this.getRightValue(rawValue);
        },
        /**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */ getLabelForIndex: helpers$1.noop,
        /**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */ getPixelForValue: helpers$1.noop,
        /**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */ getValueForPixel: helpers$1.noop,
        /**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getPixelForTick: function(index) {
            var me = this;
            var offset = me.options.offset;
            var numTicks = me._ticks.length;
            var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
            return index < 0 || index > numTicks - 1 ? null : me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
        },
        /**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getPixelForDecimal: function(decimal) {
            var me = this;
            if (me._reversePixels) decimal = 1 - decimal;
            return me._startPixel + decimal * me._length;
        },
        getDecimalForPixel: function(pixel) {
            var decimal = (pixel - this._startPixel) / this._length;
            return this._reversePixels ? 1 - decimal : decimal;
        },
        /**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getBasePixel: function() {
            return this.getPixelForValue(this.getBaseValue());
        },
        getBaseValue: function() {
            var me = this;
            var min = me.min;
            var max = me.max;
            return me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
        },
        /**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */ _autoSkip: function(ticks) {
            var me = this;
            var tickOpts = me.options.ticks;
            var axisLength = me._length;
            var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
            var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
            var numMajorIndices = majorIndices.length;
            var first = majorIndices[0];
            var last = majorIndices[numMajorIndices - 1];
            var i, ilen, spacing, avgMajorSpacing;
            // If there are too many major ticks to display them all
            if (numMajorIndices > ticksLimit) {
                skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
                return nonSkipped(ticks);
            }
            spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
            if (numMajorIndices > 0) {
                for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
                avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
                skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
                skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
                return nonSkipped(ticks);
            }
            skip(ticks, spacing);
            return nonSkipped(ticks);
        },
        /**
	 * @private
	 */ _tickSize: function() {
            var me = this;
            var optionTicks = me.options.ticks;
            // Calculate space needed by label in axis direction.
            var rot = helpers$1.toRadians(me.labelRotation);
            var cos = Math.abs(Math.cos(rot));
            var sin = Math.abs(Math.sin(rot));
            var labelSizes = me._getLabelSizes();
            var padding = optionTicks.autoSkipPadding || 0;
            var w = labelSizes ? labelSizes.widest.width + padding : 0;
            var h = labelSizes ? labelSizes.highest.height + padding : 0;
            // Calculate space needed for 1 tick in axis direction.
            return me.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
        },
        /**
	 * @private
	 */ _isVisible: function() {
            var me = this;
            var chart = me.chart;
            var display = me.options.display;
            var i, ilen, meta;
            if (display !== "auto") return !!display;
            // When 'auto', the scale is visible if at least one associated dataset is visible.
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                if (meta.xAxisID === me.id || meta.yAxisID === me.id) return true;
            }
            return false;
        },
        /**
	 * @private
	 */ _computeGridLineItems: function(chartArea) {
            var me = this;
            var chart = me.chart;
            var options = me.options;
            var gridLines = options.gridLines;
            var position = options.position;
            var offsetGridLines = gridLines.offsetGridLines;
            var isHorizontal = me.isHorizontal();
            var ticks = me._ticksToDraw;
            var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
            var tl = getTickMarkLength(gridLines);
            var items = [];
            var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
            var axisHalfWidth = axisWidth / 2;
            var alignPixel = helpers$1._alignPixel;
            var alignBorderValue = function(pixel) {
                return alignPixel(chart, pixel, axisWidth);
            };
            var borderValue, i, tick, lineValue, alignedLineValue;
            var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
            if (position === "top") {
                borderValue = alignBorderValue(me.bottom);
                ty1 = me.bottom - tl;
                ty2 = borderValue - axisHalfWidth;
                y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
                y2 = chartArea.bottom;
            } else if (position === "bottom") {
                borderValue = alignBorderValue(me.top);
                y1 = chartArea.top;
                y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
                ty1 = borderValue + axisHalfWidth;
                ty2 = me.top + tl;
            } else if (position === "left") {
                borderValue = alignBorderValue(me.right);
                tx1 = me.right - tl;
                tx2 = borderValue - axisHalfWidth;
                x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
                x2 = chartArea.right;
            } else {
                borderValue = alignBorderValue(me.left);
                x1 = chartArea.left;
                x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
                tx1 = borderValue + axisHalfWidth;
                tx2 = me.left + tl;
            }
            for(i = 0; i < ticksLength; ++i){
                tick = ticks[i] || {};
                // autoskipper skipped this tick (#4635)
                if (isNullOrUndef(tick.label) && i < ticks.length) continue;
                if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
                    // Draw the first index specially
                    lineWidth = gridLines.zeroLineWidth;
                    lineColor = gridLines.zeroLineColor;
                    borderDash = gridLines.zeroLineBorderDash || [];
                    borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
                } else {
                    lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
                    lineColor = valueAtIndexOrDefault(gridLines.color, i, "rgba(0,0,0,0.1)");
                    borderDash = gridLines.borderDash || [];
                    borderDashOffset = gridLines.borderDashOffset || 0.0;
                }
                lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
                // Skip if the pixel is out of the range
                if (lineValue === undefined) continue;
                alignedLineValue = alignPixel(chart, lineValue, lineWidth);
                if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
                else ty1 = ty2 = y1 = y2 = alignedLineValue;
                items.push({
                    tx1: tx1,
                    ty1: ty1,
                    tx2: tx2,
                    ty2: ty2,
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2,
                    width: lineWidth,
                    color: lineColor,
                    borderDash: borderDash,
                    borderDashOffset: borderDashOffset
                });
            }
            items.ticksLength = ticksLength;
            items.borderValue = borderValue;
            return items;
        },
        /**
	 * @private
	 */ _computeLabelItems: function() {
            var me = this;
            var options = me.options;
            var optionTicks = options.ticks;
            var position = options.position;
            var isMirrored = optionTicks.mirror;
            var isHorizontal = me.isHorizontal();
            var ticks = me._ticksToDraw;
            var fonts = parseTickFontOptions(optionTicks);
            var tickPadding = optionTicks.padding;
            var tl = getTickMarkLength(options.gridLines);
            var rotation = -helpers$1.toRadians(me.labelRotation);
            var items = [];
            var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
            if (position === "top") {
                y = me.bottom - tl - tickPadding;
                textAlign = !rotation ? "center" : "left";
            } else if (position === "bottom") {
                y = me.top + tl + tickPadding;
                textAlign = !rotation ? "center" : "right";
            } else if (position === "left") {
                x = me.right - (isMirrored ? 0 : tl) - tickPadding;
                textAlign = isMirrored ? "left" : "right";
            } else {
                x = me.left + (isMirrored ? 0 : tl) + tickPadding;
                textAlign = isMirrored ? "right" : "left";
            }
            for(i = 0, ilen = ticks.length; i < ilen; ++i){
                tick = ticks[i];
                label = tick.label;
                // autoskipper skipped this tick (#4635)
                if (isNullOrUndef(label)) continue;
                pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
                font = tick.major ? fonts.major : fonts.minor;
                lineHeight = font.lineHeight;
                lineCount = isArray(label) ? label.length : 1;
                if (isHorizontal) {
                    x = pixel;
                    textOffset = position === "top" ? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight : (!rotation ? 0.5 : 0) * lineHeight;
                } else {
                    y = pixel;
                    textOffset = (1 - lineCount) * lineHeight / 2;
                }
                items.push({
                    x: x,
                    y: y,
                    rotation: rotation,
                    label: label,
                    font: font,
                    textOffset: textOffset,
                    textAlign: textAlign
                });
            }
            return items;
        },
        /**
	 * @private
	 */ _drawGrid: function(chartArea) {
            var me = this;
            var gridLines = me.options.gridLines;
            if (!gridLines.display) return;
            var ctx = me.ctx;
            var chart = me.chart;
            var alignPixel = helpers$1._alignPixel;
            var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
            var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
            var width, color, i, ilen, item;
            for(i = 0, ilen = items.length; i < ilen; ++i){
                item = items[i];
                width = item.width;
                color = item.color;
                if (width && color) {
                    ctx.save();
                    ctx.lineWidth = width;
                    ctx.strokeStyle = color;
                    if (ctx.setLineDash) {
                        ctx.setLineDash(item.borderDash);
                        ctx.lineDashOffset = item.borderDashOffset;
                    }
                    ctx.beginPath();
                    if (gridLines.drawTicks) {
                        ctx.moveTo(item.tx1, item.ty1);
                        ctx.lineTo(item.tx2, item.ty2);
                    }
                    if (gridLines.drawOnChartArea) {
                        ctx.moveTo(item.x1, item.y1);
                        ctx.lineTo(item.x2, item.y2);
                    }
                    ctx.stroke();
                    ctx.restore();
                }
            }
            if (axisWidth) {
                // Draw the line at the edge of the axis
                var firstLineWidth = axisWidth;
                var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
                var borderValue = items.borderValue;
                var x1, x2, y1, y2;
                if (me.isHorizontal()) {
                    x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
                    x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
                    y1 = y2 = borderValue;
                } else {
                    y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
                    y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
                    x1 = x2 = borderValue;
                }
                ctx.lineWidth = axisWidth;
                ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
                ctx.beginPath();
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.stroke();
            }
        },
        /**
	 * @private
	 */ _drawLabels: function() {
            var me = this;
            var optionTicks = me.options.ticks;
            if (!optionTicks.display) return;
            var ctx = me.ctx;
            var items = me._labelItems || (me._labelItems = me._computeLabelItems());
            var i, j, ilen, jlen, item, tickFont, label, y;
            for(i = 0, ilen = items.length; i < ilen; ++i){
                item = items[i];
                tickFont = item.font;
                // Make sure we draw text in the correct color and font
                ctx.save();
                ctx.translate(item.x, item.y);
                ctx.rotate(item.rotation);
                ctx.font = tickFont.string;
                ctx.fillStyle = tickFont.color;
                ctx.textBaseline = "middle";
                ctx.textAlign = item.textAlign;
                label = item.label;
                y = item.textOffset;
                if (isArray(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                    // We just make sure the multiline element is a string here..
                    ctx.fillText("" + label[j], 0, y);
                    y += tickFont.lineHeight;
                }
                else ctx.fillText(label, 0, y);
                ctx.restore();
            }
        },
        /**
	 * @private
	 */ _drawTitle: function() {
            var me = this;
            var ctx = me.ctx;
            var options = me.options;
            var scaleLabel = options.scaleLabel;
            if (!scaleLabel.display) return;
            var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
            var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
            var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
            var halfLineHeight = scaleLabelFont.lineHeight / 2;
            var position = options.position;
            var rotation = 0;
            var scaleLabelX, scaleLabelY;
            if (me.isHorizontal()) {
                scaleLabelX = me.left + me.width / 2; // midpoint of the width
                scaleLabelY = position === "bottom" ? me.bottom - halfLineHeight - scaleLabelPadding.bottom : me.top + halfLineHeight + scaleLabelPadding.top;
            } else {
                var isLeft = position === "left";
                scaleLabelX = isLeft ? me.left + halfLineHeight + scaleLabelPadding.top : me.right - halfLineHeight - scaleLabelPadding.top;
                scaleLabelY = me.top + me.height / 2;
                rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
            }
            ctx.save();
            ctx.translate(scaleLabelX, scaleLabelY);
            ctx.rotate(rotation);
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillStyle = scaleLabelFontColor; // render in correct colour
            ctx.font = scaleLabelFont.string;
            ctx.fillText(scaleLabel.labelString, 0, 0);
            ctx.restore();
        },
        draw: function(chartArea) {
            var me = this;
            if (!me._isVisible()) return;
            me._drawGrid(chartArea);
            me._drawTitle();
            me._drawLabels();
        },
        /**
	 * @private
	 */ _layers: function() {
            var me = this;
            var opts = me.options;
            var tz = opts.ticks && opts.ticks.z || 0;
            var gz = opts.gridLines && opts.gridLines.z || 0;
            if (!me._isVisible() || tz === gz || me.draw !== me._draw) // backward compatibility: draw has been overridden by custom scale
            return [
                {
                    z: tz,
                    draw: function() {
                        me.draw.apply(me, arguments);
                    }
                }
            ];
            return [
                {
                    z: gz,
                    draw: function() {
                        me._drawGrid.apply(me, arguments);
                        me._drawTitle.apply(me, arguments);
                    }
                },
                {
                    z: tz,
                    draw: function() {
                        me._drawLabels.apply(me, arguments);
                    }
                }
            ];
        },
        /**
	 * @private
	 */ _getMatchingVisibleMetas: function(type) {
            var me = this;
            var isHorizontal = me.isHorizontal();
            return me.chart._getSortedVisibleDatasetMetas().filter(function(meta) {
                return (!type || meta.type === type) && (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
            });
        }
    });
    Scale.prototype._draw = Scale.prototype.draw;
    var core_scale = Scale;
    var isNullOrUndef$1 = helpers$1.isNullOrUndef;
    var defaultConfig = {
        position: "bottom"
    };
    var scale_category = core_scale.extend({
        determineDataLimits: function() {
            var me = this;
            var labels = me._getLabels();
            var ticksOpts = me.options.ticks;
            var min = ticksOpts.min;
            var max = ticksOpts.max;
            var minIndex = 0;
            var maxIndex = labels.length - 1;
            var findIndex;
            if (min !== undefined) {
                // user specified min value
                findIndex = labels.indexOf(min);
                if (findIndex >= 0) minIndex = findIndex;
            }
            if (max !== undefined) {
                // user specified max value
                findIndex = labels.indexOf(max);
                if (findIndex >= 0) maxIndex = findIndex;
            }
            me.minIndex = minIndex;
            me.maxIndex = maxIndex;
            me.min = labels[minIndex];
            me.max = labels[maxIndex];
        },
        buildTicks: function() {
            var me = this;
            var labels = me._getLabels();
            var minIndex = me.minIndex;
            var maxIndex = me.maxIndex;
            // If we are viewing some subset of labels, slice the original array
            me.ticks = minIndex === 0 && maxIndex === labels.length - 1 ? labels : labels.slice(minIndex, maxIndex + 1);
        },
        getLabelForIndex: function(index, datasetIndex) {
            var me = this;
            var chart = me.chart;
            if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
            return me._getLabels()[index];
        },
        _configure: function() {
            var me = this;
            var offset = me.options.offset;
            var ticks = me.ticks;
            core_scale.prototype._configure.call(me);
            if (!me.isHorizontal()) // For backward compatibility, vertical category scale reverse is inverted.
            me._reversePixels = !me._reversePixels;
            if (!ticks) return;
            me._startValue = me.minIndex - (offset ? 0.5 : 0);
            me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
        },
        // Used to get data value locations.  Value can either be an index or a numerical value
        getPixelForValue: function(value, index, datasetIndex) {
            var me = this;
            var valueCategory, labels, idx;
            if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) value = me.chart.data.datasets[datasetIndex].data[index];
            // If value is a data object, then index is the index in the data array,
            // not the index of the scale. We need to change that.
            if (!isNullOrUndef$1(value)) valueCategory = me.isHorizontal() ? value.x : value.y;
            if (valueCategory !== undefined || value !== undefined && isNaN(index)) {
                labels = me._getLabels();
                value = helpers$1.valueOrDefault(valueCategory, value);
                idx = labels.indexOf(value);
                index = idx !== -1 ? idx : index;
                if (isNaN(index)) index = value;
            }
            return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
        },
        getPixelForTick: function(index) {
            var ticks = this.ticks;
            return index < 0 || index > ticks.length - 1 ? null : this.getPixelForValue(ticks[index], index + this.minIndex);
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
            return Math.min(Math.max(value, 0), me.ticks.length - 1);
        },
        getBasePixel: function() {
            return this.bottom;
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults = defaultConfig;
    scale_category._defaults = _defaults;
    var noop = helpers$1.noop;
    var isNullOrUndef$2 = helpers$1.isNullOrUndef;
    /**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */ function generateTicks(generationOptions, dataRange) {
        var ticks = [];
        // To get a "nice" value for the tick spacing, we will use the appropriately named
        // "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
        // for details.
        var MIN_SPACING = 1e-14;
        var stepSize = generationOptions.stepSize;
        var unit = stepSize || 1;
        var maxNumSpaces = generationOptions.maxTicks - 1;
        var min = generationOptions.min;
        var max = generationOptions.max;
        var precision = generationOptions.precision;
        var rmin = dataRange.min;
        var rmax = dataRange.max;
        var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
        var factor, niceMin, niceMax, numSpaces;
        // Beyond MIN_SPACING floating point numbers being to lose precision
        // such that we can't do the math necessary to generate ticks
        if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) return [
            rmin,
            rmax
        ];
        numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
        if (numSpaces > maxNumSpaces) // If the calculated num of spaces exceeds maxNumSpaces, recalculate it
        spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
        if (stepSize || isNullOrUndef$2(precision)) // If a precision is not specified, calculate factor based on spacing
        factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
        else {
            // If the user specified a precision, round to that number of decimal places
            factor = Math.pow(10, precision);
            spacing = Math.ceil(spacing * factor) / factor;
        }
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
        // If min, max and stepSize is set and they make an evenly spaced scale use it.
        if (stepSize) {
            // If very close to our whole number, use it.
            if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) niceMin = min;
            if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) niceMax = max;
        }
        numSpaces = (niceMax - niceMin) / spacing;
        // If very close to our rounded value, use it.
        if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
        niceMin = Math.round(niceMin * factor) / factor;
        niceMax = Math.round(niceMax * factor) / factor;
        ticks.push(isNullOrUndef$2(min) ? niceMin : min);
        for(var j = 1; j < numSpaces; ++j)ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
        ticks.push(isNullOrUndef$2(max) ? niceMax : max);
        return ticks;
    }
    var scale_linearbase = core_scale.extend({
        getRightValue: function(value) {
            if (typeof value === "string") return +value;
            return core_scale.prototype.getRightValue.call(this, value);
        },
        handleTickRangeOptions: function() {
            var me = this;
            var opts = me.options;
            var tickOpts = opts.ticks;
            // If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
            // do nothing since that would make the chart weird. If the user really wants a weird chart
            // axis, they can manually override it
            if (tickOpts.beginAtZero) {
                var minSign = helpers$1.sign(me.min);
                var maxSign = helpers$1.sign(me.max);
                if (minSign < 0 && maxSign < 0) // move the top up to 0
                me.max = 0;
                else if (minSign > 0 && maxSign > 0) // move the bottom down to 0
                me.min = 0;
            }
            var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
            var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
            if (tickOpts.min !== undefined) me.min = tickOpts.min;
            else if (tickOpts.suggestedMin !== undefined) {
                if (me.min === null) me.min = tickOpts.suggestedMin;
                else me.min = Math.min(me.min, tickOpts.suggestedMin);
            }
            if (tickOpts.max !== undefined) me.max = tickOpts.max;
            else if (tickOpts.suggestedMax !== undefined) {
                if (me.max === null) me.max = tickOpts.suggestedMax;
                else me.max = Math.max(me.max, tickOpts.suggestedMax);
            }
            if (setMin !== setMax) // We set the min or the max but not both.
            // So ensure that our range is good
            // Inverted or 0 length range can happen when
            // ticks.min is set, and no datasets are visible
            {
                if (me.min >= me.max) {
                    if (setMin) me.max = me.min + 1;
                    else me.min = me.max - 1;
                }
            }
            if (me.min === me.max) {
                me.max++;
                if (!tickOpts.beginAtZero) me.min--;
            }
        },
        getTickLimit: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var stepSize = tickOpts.stepSize;
            var maxTicksLimit = tickOpts.maxTicksLimit;
            var maxTicks;
            if (stepSize) maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
            else {
                maxTicks = me._computeTickLimit();
                maxTicksLimit = maxTicksLimit || 11;
            }
            if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
            return maxTicks;
        },
        _computeTickLimit: function() {
            return Number.POSITIVE_INFINITY;
        },
        handleDirectionalChanges: noop,
        buildTicks: function() {
            var me = this;
            var opts = me.options;
            var tickOpts = opts.ticks;
            // Figure out what the max number of ticks we can support it is based on the size of
            // the axis area. For now, we say that the minimum tick spacing in pixels must be 40
            // We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
            // the graph. Make sure we always have at least 2 ticks
            var maxTicks = me.getTickLimit();
            maxTicks = Math.max(2, maxTicks);
            var numericGeneratorOptions = {
                maxTicks: maxTicks,
                min: tickOpts.min,
                max: tickOpts.max,
                precision: tickOpts.precision,
                stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
            };
            var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
            me.handleDirectionalChanges();
            // At this point, we need to update our max and min given the tick values since we have expanded the
            // range of the scale
            me.max = helpers$1.max(ticks);
            me.min = helpers$1.min(ticks);
            if (tickOpts.reverse) {
                ticks.reverse();
                me.start = me.max;
                me.end = me.min;
            } else {
                me.start = me.min;
                me.end = me.max;
            }
        },
        convertTicksToLabels: function() {
            var me = this;
            me.ticksAsNumbers = me.ticks.slice();
            me.zeroLineIndex = me.ticks.indexOf(0);
            core_scale.prototype.convertTicksToLabels.call(me);
        },
        _configure: function() {
            var me = this;
            var ticks = me.getTicks();
            var start = me.min;
            var end = me.max;
            var offset;
            core_scale.prototype._configure.call(me);
            if (me.options.offset && ticks.length) {
                offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
                start -= offset;
                end += offset;
            }
            me._startValue = start;
            me._endValue = end;
            me._valueRange = end - start;
        }
    });
    var defaultConfig$1 = {
        position: "left",
        ticks: {
            callback: core_ticks.formatters.linear
        }
    };
    var DEFAULT_MIN = 0;
    var DEFAULT_MAX = 1;
    function getOrCreateStack(stacks, stacked, meta) {
        var key = [
            meta.type,
            // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
            stacked === undefined && meta.stack === undefined ? meta.index : "",
            meta.stack
        ].join(".");
        if (stacks[key] === undefined) stacks[key] = {
            pos: [],
            neg: []
        };
        return stacks[key];
    }
    function stackData(scale, stacks, meta, data) {
        var opts = scale.options;
        var stacked = opts.stacked;
        var stack = getOrCreateStack(stacks, stacked, meta);
        var pos = stack.pos;
        var neg = stack.neg;
        var ilen = data.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = scale._parseValue(data[i]);
            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) continue;
            pos[i] = pos[i] || 0;
            neg[i] = neg[i] || 0;
            if (opts.relativePoints) pos[i] = 100;
            else if (value.min < 0 || value.max < 0) neg[i] += value.min;
            else pos[i] += value.max;
        }
    }
    function updateMinMax(scale, meta, data) {
        var ilen = data.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = scale._parseValue(data[i]);
            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) continue;
            scale.min = Math.min(scale.min, value.min);
            scale.max = Math.max(scale.max, value.max);
        }
    }
    var scale_linear = scale_linearbase.extend({
        determineDataLimits: function() {
            var me = this;
            var opts = me.options;
            var chart = me.chart;
            var datasets = chart.data.datasets;
            var metasets = me._getMatchingVisibleMetas();
            var hasStacks = opts.stacked;
            var stacks = {};
            var ilen = metasets.length;
            var i, meta, data, values;
            me.min = Number.POSITIVE_INFINITY;
            me.max = Number.NEGATIVE_INFINITY;
            if (hasStacks === undefined) for(i = 0; !hasStacks && i < ilen; ++i){
                meta = metasets[i];
                hasStacks = meta.stack !== undefined;
            }
            for(i = 0; i < ilen; ++i){
                meta = metasets[i];
                data = datasets[meta.index].data;
                if (hasStacks) stackData(me, stacks, meta, data);
                else updateMinMax(me, meta, data);
            }
            helpers$1.each(stacks, function(stackValues) {
                values = stackValues.pos.concat(stackValues.neg);
                me.min = Math.min(me.min, helpers$1.min(values));
                me.max = Math.max(me.max, helpers$1.max(values));
            });
            me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
            me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
            // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
            me.handleTickRangeOptions();
        },
        // Returns the maximum number of ticks based on the scale dimension
        _computeTickLimit: function() {
            var me = this;
            var tickFont;
            if (me.isHorizontal()) return Math.ceil(me.width / 40);
            tickFont = helpers$1.options._parseFont(me.options.ticks);
            return Math.ceil(me.height / tickFont.lineHeight);
        },
        // Called after the ticks are built. We need
        handleDirectionalChanges: function() {
            if (!this.isHorizontal()) // We are in a vertical orientation. The top value is the highest. So reverse the array
            this.ticks.reverse();
        },
        getLabelForIndex: function(index, datasetIndex) {
            return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
        },
        // Utils
        getPixelForValue: function(value) {
            var me = this;
            return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
        },
        getValueForPixel: function(pixel) {
            return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
        },
        getPixelForTick: function(index) {
            var ticks = this.ticksAsNumbers;
            if (index < 0 || index > ticks.length - 1) return null;
            return this.getPixelForValue(ticks[index]);
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$1 = defaultConfig$1;
    scale_linear._defaults = _defaults$1;
    var valueOrDefault$b = helpers$1.valueOrDefault;
    var log10 = helpers$1.math.log10;
    /**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */ function generateTicks$1(generationOptions, dataRange) {
        var ticks = [];
        var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
        var endExp = Math.floor(log10(dataRange.max));
        var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
        var exp, significand;
        if (tickVal === 0) {
            exp = Math.floor(log10(dataRange.minNotZero));
            significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
            ticks.push(tickVal);
            tickVal = significand * Math.pow(10, exp);
        } else {
            exp = Math.floor(log10(tickVal));
            significand = Math.floor(tickVal / Math.pow(10, exp));
        }
        var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
        do {
            ticks.push(tickVal);
            ++significand;
            if (significand === 10) {
                significand = 1;
                ++exp;
                precision = exp >= 0 ? 1 : precision;
            }
            tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
        }while (exp < endExp || exp === endExp && significand < endSignificand);
        var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
        ticks.push(lastTick);
        return ticks;
    }
    var defaultConfig$2 = {
        position: "left",
        // label settings
        ticks: {
            callback: core_ticks.formatters.logarithmic
        }
    };
    // TODO(v3): change this to positiveOrDefault
    function nonNegativeOrDefault(value, defaultValue) {
        return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
    }
    var scale_logarithmic = core_scale.extend({
        determineDataLimits: function() {
            var me = this;
            var opts = me.options;
            var chart = me.chart;
            var datasets = chart.data.datasets;
            var isHorizontal = me.isHorizontal();
            function IDMatches(meta) {
                return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
            }
            var datasetIndex, meta, value, data, i, ilen;
            // Calculate Range
            me.min = Number.POSITIVE_INFINITY;
            me.max = Number.NEGATIVE_INFINITY;
            me.minNotZero = Number.POSITIVE_INFINITY;
            var hasStacks = opts.stacked;
            if (hasStacks === undefined) for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                meta = chart.getDatasetMeta(datasetIndex);
                if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) && meta.stack !== undefined) {
                    hasStacks = true;
                    break;
                }
            }
            if (opts.stacked || hasStacks) {
                var valuesPerStack = {};
                for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                    meta = chart.getDatasetMeta(datasetIndex);
                    var key = [
                        meta.type,
                        // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
                        opts.stacked === undefined && meta.stack === undefined ? datasetIndex : "",
                        meta.stack
                    ].join(".");
                    if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
                        if (valuesPerStack[key] === undefined) valuesPerStack[key] = [];
                        data = datasets[datasetIndex].data;
                        for(i = 0, ilen = data.length; i < ilen; i++){
                            var values = valuesPerStack[key];
                            value = me._parseValue(data[i]);
                            // invalid, hidden and negative values are ignored
                            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) continue;
                            values[i] = values[i] || 0;
                            values[i] += value.max;
                        }
                    }
                }
                helpers$1.each(valuesPerStack, function(valuesForType) {
                    if (valuesForType.length > 0) {
                        var minVal = helpers$1.min(valuesForType);
                        var maxVal = helpers$1.max(valuesForType);
                        me.min = Math.min(me.min, minVal);
                        me.max = Math.max(me.max, maxVal);
                    }
                });
            } else for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                meta = chart.getDatasetMeta(datasetIndex);
                if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
                    data = datasets[datasetIndex].data;
                    for(i = 0, ilen = data.length; i < ilen; i++){
                        value = me._parseValue(data[i]);
                        // invalid, hidden and negative values are ignored
                        if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) continue;
                        me.min = Math.min(value.min, me.min);
                        me.max = Math.max(value.max, me.max);
                        if (value.min !== 0) me.minNotZero = Math.min(value.min, me.minNotZero);
                    }
                }
            }
            me.min = helpers$1.isFinite(me.min) ? me.min : null;
            me.max = helpers$1.isFinite(me.max) ? me.max : null;
            me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
            // Common base implementation to handle ticks.min, ticks.max
            this.handleTickRangeOptions();
        },
        handleTickRangeOptions: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var DEFAULT_MIN = 1;
            var DEFAULT_MAX = 10;
            me.min = nonNegativeOrDefault(tickOpts.min, me.min);
            me.max = nonNegativeOrDefault(tickOpts.max, me.max);
            if (me.min === me.max) {
                if (me.min !== 0 && me.min !== null) {
                    me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
                    me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
                } else {
                    me.min = DEFAULT_MIN;
                    me.max = DEFAULT_MAX;
                }
            }
            if (me.min === null) me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
            if (me.max === null) me.max = me.min !== 0 ? Math.pow(10, Math.floor(log10(me.min)) + 1) : DEFAULT_MAX;
            if (me.minNotZero === null) {
                if (me.min > 0) me.minNotZero = me.min;
                else if (me.max < 1) me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
                else me.minNotZero = DEFAULT_MIN;
            }
        },
        buildTicks: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var reverse = !me.isHorizontal();
            var generationOptions = {
                min: nonNegativeOrDefault(tickOpts.min),
                max: nonNegativeOrDefault(tickOpts.max)
            };
            var ticks = me.ticks = generateTicks$1(generationOptions, me);
            // At this point, we need to update our max and min given the tick values since we have expanded the
            // range of the scale
            me.max = helpers$1.max(ticks);
            me.min = helpers$1.min(ticks);
            if (tickOpts.reverse) {
                reverse = !reverse;
                me.start = me.max;
                me.end = me.min;
            } else {
                me.start = me.min;
                me.end = me.max;
            }
            if (reverse) ticks.reverse();
        },
        convertTicksToLabels: function() {
            this.tickValues = this.ticks.slice();
            core_scale.prototype.convertTicksToLabels.call(this);
        },
        // Get the correct tooltip label
        getLabelForIndex: function(index, datasetIndex) {
            return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
        },
        getPixelForTick: function(index) {
            var ticks = this.tickValues;
            if (index < 0 || index > ticks.length - 1) return null;
            return this.getPixelForValue(ticks[index]);
        },
        /**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */ _getFirstTickValue: function(value) {
            var exp = Math.floor(log10(value));
            var significand = Math.floor(value / Math.pow(10, exp));
            return significand * Math.pow(10, exp);
        },
        _configure: function() {
            var me = this;
            var start = me.min;
            var offset = 0;
            core_scale.prototype._configure.call(me);
            if (start === 0) {
                start = me._getFirstTickValue(me.minNotZero);
                offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
            }
            me._startValue = log10(start);
            me._valueOffset = offset;
            me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
        },
        getPixelForValue: function(value) {
            var me = this;
            var decimal = 0;
            value = +me.getRightValue(value);
            if (value > me.min && value > 0) decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
            return me.getPixelForDecimal(decimal);
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var decimal = me.getDecimalForPixel(pixel);
            return decimal === 0 && me.min === 0 ? 0 : Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$2 = defaultConfig$2;
    scale_logarithmic._defaults = _defaults$2;
    var valueOrDefault$c = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
    var resolve$4 = helpers$1.options.resolve;
    var defaultConfig$3 = {
        display: true,
        // Boolean - Whether to animate scaling the chart from the centre
        animate: true,
        position: "chartArea",
        angleLines: {
            display: true,
            color: "rgba(0,0,0,0.1)",
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        gridLines: {
            circular: false
        },
        // label settings
        ticks: {
            // Boolean - Show a backdrop to the scale label
            showLabelBackdrop: true,
            // String - The colour of the label backdrop
            backdropColor: "rgba(255,255,255,0.75)",
            // Number - The backdrop padding above & below the label in pixels
            backdropPaddingY: 2,
            // Number - The backdrop padding to the side of the label in pixels
            backdropPaddingX: 2,
            callback: core_ticks.formatters.linear
        },
        pointLabels: {
            // Boolean - if true, show point labels
            display: true,
            // Number - Point label font size in pixels
            fontSize: 10,
            // Function - Used to convert point labels
            callback: function(label) {
                return label;
            }
        }
    };
    function getTickBackdropHeight(opts) {
        var tickOpts = opts.ticks;
        if (tickOpts.display && opts.display) return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
        return 0;
    }
    function measureLabelSize(ctx, lineHeight, label) {
        if (helpers$1.isArray(label)) return {
            w: helpers$1.longestText(ctx, ctx.font, label),
            h: label.length * lineHeight
        };
        return {
            w: ctx.measureText(label).width,
            h: lineHeight
        };
    }
    function determineLimits(angle, pos, size, min, max) {
        if (angle === min || angle === max) return {
            start: pos - size / 2,
            end: pos + size / 2
        };
        else if (angle < min || angle > max) return {
            start: pos - size,
            end: pos
        };
        return {
            start: pos,
            end: pos + size
        };
    }
    /**
 * Helper function to fit a radial linear scale with point labels
 */ function fitWithPointLabels(scale) {
        // Right, this is really confusing and there is a lot of maths going on here
        // The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
        //
        // Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
        //
        // Solution:
        //
        // We assume the radius of the polygon is half the size of the canvas at first
        // at each index we check if the text overlaps.
        //
        // Where it does, we store that angle and that index.
        //
        // After finding the largest index and angle we calculate how much we need to remove
        // from the shape radius to move the point inwards by that x.
        //
        // We average the left and right distances to get the maximum shape radius that can fit in the box
        // along with labels.
        //
        // Once we have that, we can find the centre point for the chart, by taking the x text protrusion
        // on each side, removing that from the size, halving it and adding the left x protrusion width.
        //
        // This will mean we have a shape fitted to the canvas, as large as it can be with the labels
        // and position it in the most space efficient manner
        //
        // https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
        var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
        // Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
        // Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
        var furthestLimits = {
            l: 0,
            r: scale.width,
            t: 0,
            b: scale.height - scale.paddingTop
        };
        var furthestAngles = {};
        var i, textSize, pointPosition;
        scale.ctx.font = plFont.string;
        scale._pointLabelSizes = [];
        var valueCount = scale.chart.data.labels.length;
        for(i = 0; i < valueCount; i++){
            pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
            textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
            scale._pointLabelSizes[i] = textSize;
            // Add quarter circle to make degree 0 mean top of circle
            var angleRadians = scale.getIndexAngle(i);
            var angle = helpers$1.toDegrees(angleRadians) % 360;
            var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
            var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
            if (hLimits.start < furthestLimits.l) {
                furthestLimits.l = hLimits.start;
                furthestAngles.l = angleRadians;
            }
            if (hLimits.end > furthestLimits.r) {
                furthestLimits.r = hLimits.end;
                furthestAngles.r = angleRadians;
            }
            if (vLimits.start < furthestLimits.t) {
                furthestLimits.t = vLimits.start;
                furthestAngles.t = angleRadians;
            }
            if (vLimits.end > furthestLimits.b) {
                furthestLimits.b = vLimits.end;
                furthestAngles.b = angleRadians;
            }
        }
        scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
    }
    function getTextAlignForAngle(angle) {
        if (angle === 0 || angle === 180) return "center";
        else if (angle < 180) return "left";
        return "right";
    }
    function fillText(ctx, text, position, lineHeight) {
        var y = position.y + lineHeight / 2;
        var i, ilen;
        if (helpers$1.isArray(text)) for(i = 0, ilen = text.length; i < ilen; ++i){
            ctx.fillText(text[i], position.x, y);
            y += lineHeight;
        }
        else ctx.fillText(text, position.x, y);
    }
    function adjustPointPositionForLabelHeight(angle, textSize, position) {
        if (angle === 90 || angle === 270) position.y -= textSize.h / 2;
        else if (angle > 270 || angle < 90) position.y -= textSize.h;
    }
    function drawPointLabels(scale) {
        var ctx = scale.ctx;
        var opts = scale.options;
        var pointLabelOpts = opts.pointLabels;
        var tickBackdropHeight = getTickBackdropHeight(opts);
        var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
        var plFont = helpers$1.options._parseFont(pointLabelOpts);
        ctx.save();
        ctx.font = plFont.string;
        ctx.textBaseline = "middle";
        for(var i = scale.chart.data.labels.length - 1; i >= 0; i--){
            // Extra pixels out for some label spacing
            var extra = i === 0 ? tickBackdropHeight / 2 : 0;
            var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
            // Keep this in loop since we may support array properties here
            var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
            ctx.fillStyle = pointLabelFontColor;
            var angleRadians = scale.getIndexAngle(i);
            var angle = helpers$1.toDegrees(angleRadians);
            ctx.textAlign = getTextAlignForAngle(angle);
            adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
            fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
        }
        ctx.restore();
    }
    function drawRadiusLine(scale, gridLineOpts, radius, index) {
        var ctx = scale.ctx;
        var circular = gridLineOpts.circular;
        var valueCount = scale.chart.data.labels.length;
        var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
        var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
        var pointPosition;
        if (!circular && !valueCount || !lineColor || !lineWidth) return;
        ctx.save();
        ctx.strokeStyle = lineColor;
        ctx.lineWidth = lineWidth;
        if (ctx.setLineDash) {
            ctx.setLineDash(gridLineOpts.borderDash || []);
            ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
        }
        ctx.beginPath();
        if (circular) // Draw circular arcs between the points
        ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
        else {
            // Draw straight lines connecting each index
            pointPosition = scale.getPointPosition(0, radius);
            ctx.moveTo(pointPosition.x, pointPosition.y);
            for(var i = 1; i < valueCount; i++){
                pointPosition = scale.getPointPosition(i, radius);
                ctx.lineTo(pointPosition.x, pointPosition.y);
            }
        }
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
    }
    function numberOrZero(param) {
        return helpers$1.isNumber(param) ? param : 0;
    }
    var scale_radialLinear = scale_linearbase.extend({
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            me.width = me.maxWidth;
            me.height = me.maxHeight;
            me.paddingTop = getTickBackdropHeight(me.options) / 2;
            me.xCenter = Math.floor(me.width / 2);
            me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
            me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
        },
        determineDataLimits: function() {
            var me = this;
            var chart = me.chart;
            var min = Number.POSITIVE_INFINITY;
            var max = Number.NEGATIVE_INFINITY;
            helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
                if (chart.isDatasetVisible(datasetIndex)) {
                    var meta = chart.getDatasetMeta(datasetIndex);
                    helpers$1.each(dataset.data, function(rawValue, index) {
                        var value = +me.getRightValue(rawValue);
                        if (isNaN(value) || meta.data[index].hidden) return;
                        min = Math.min(value, min);
                        max = Math.max(value, max);
                    });
                }
            });
            me.min = min === Number.POSITIVE_INFINITY ? 0 : min;
            me.max = max === Number.NEGATIVE_INFINITY ? 0 : max;
            // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
            me.handleTickRangeOptions();
        },
        // Returns the maximum number of ticks based on the scale dimension
        _computeTickLimit: function() {
            return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
        },
        convertTicksToLabels: function() {
            var me = this;
            scale_linearbase.prototype.convertTicksToLabels.call(me);
            // Point labels
            me.pointLabels = me.chart.data.labels.map(function() {
                var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
                return label || label === 0 ? label : "";
            });
        },
        getLabelForIndex: function(index, datasetIndex) {
            return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
        },
        fit: function() {
            var me = this;
            var opts = me.options;
            if (opts.display && opts.pointLabels.display) fitWithPointLabels(me);
            else me.setCenterPoint(0, 0, 0, 0);
        },
        /**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */ setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
            var me = this;
            var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
            var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
            var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
            var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
            radiusReductionLeft = numberOrZero(radiusReductionLeft);
            radiusReductionRight = numberOrZero(radiusReductionRight);
            radiusReductionTop = numberOrZero(radiusReductionTop);
            radiusReductionBottom = numberOrZero(radiusReductionBottom);
            me.drawingArea = Math.min(Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2), Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
            me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
        },
        setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
            var me = this;
            var maxRight = me.width - rightMovement - me.drawingArea;
            var maxLeft = leftMovement + me.drawingArea;
            var maxTop = topMovement + me.drawingArea;
            var maxBottom = me.height - me.paddingTop - bottomMovement - me.drawingArea;
            me.xCenter = Math.floor((maxLeft + maxRight) / 2 + me.left);
            me.yCenter = Math.floor((maxTop + maxBottom) / 2 + me.top + me.paddingTop);
        },
        getIndexAngle: function(index) {
            var chart = this.chart;
            var angleMultiplier = 360 / chart.data.labels.length;
            var options = chart.options || {};
            var startAngle = options.startAngle || 0;
            // Start from the top instead of right, so remove a quarter of the circle
            var angle = (index * angleMultiplier + startAngle) % 360;
            return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
        },
        getDistanceFromCenterForValue: function(value) {
            var me = this;
            if (helpers$1.isNullOrUndef(value)) return NaN;
            // Take into account half font size + the yPadding of the top value
            var scalingFactor = me.drawingArea / (me.max - me.min);
            if (me.options.ticks.reverse) return (me.max - value) * scalingFactor;
            return (value - me.min) * scalingFactor;
        },
        getPointPosition: function(index, distanceFromCenter) {
            var me = this;
            var thisAngle = me.getIndexAngle(index) - Math.PI / 2;
            return {
                x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
                y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
            };
        },
        getPointPositionForValue: function(index, value) {
            return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
        },
        getBasePosition: function(index) {
            var me = this;
            var min = me.min;
            var max = me.max;
            return me.getPointPositionForValue(index || 0, me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0);
        },
        /**
	 * @private
	 */ _drawGrid: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            var gridLineOpts = opts.gridLines;
            var angleLineOpts = opts.angleLines;
            var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
            var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
            var i, offset, position;
            if (opts.pointLabels.display) drawPointLabels(me);
            if (gridLineOpts.display) helpers$1.each(me.ticks, function(label, index) {
                if (index !== 0) {
                    offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
                    drawRadiusLine(me, gridLineOpts, offset, index);
                }
            });
            if (angleLineOpts.display && lineWidth && lineColor) {
                ctx.save();
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = lineColor;
                if (ctx.setLineDash) {
                    ctx.setLineDash(resolve$4([
                        angleLineOpts.borderDash,
                        gridLineOpts.borderDash,
                        []
                    ]));
                    ctx.lineDashOffset = resolve$4([
                        angleLineOpts.borderDashOffset,
                        gridLineOpts.borderDashOffset,
                        0.0
                    ]);
                }
                for(i = me.chart.data.labels.length - 1; i >= 0; i--){
                    offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
                    position = me.getPointPosition(i, offset);
                    ctx.beginPath();
                    ctx.moveTo(me.xCenter, me.yCenter);
                    ctx.lineTo(position.x, position.y);
                    ctx.stroke();
                }
                ctx.restore();
            }
        },
        /**
	 * @private
	 */ _drawLabels: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            var tickOpts = opts.ticks;
            if (!tickOpts.display) return;
            var startAngle = me.getIndexAngle(0);
            var tickFont = helpers$1.options._parseFont(tickOpts);
            var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
            var offset, width;
            ctx.save();
            ctx.font = tickFont.string;
            ctx.translate(me.xCenter, me.yCenter);
            ctx.rotate(startAngle);
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            helpers$1.each(me.ticks, function(label, index) {
                if (index === 0 && !tickOpts.reverse) return;
                offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
                if (tickOpts.showLabelBackdrop) {
                    width = ctx.measureText(label).width;
                    ctx.fillStyle = tickOpts.backdropColor;
                    ctx.fillRect(-width / 2 - tickOpts.backdropPaddingX, -offset - tickFont.size / 2 - tickOpts.backdropPaddingY, width + tickOpts.backdropPaddingX * 2, tickFont.size + tickOpts.backdropPaddingY * 2);
                }
                ctx.fillStyle = tickFontColor;
                ctx.fillText(label, 0, -offset);
            });
            ctx.restore();
        },
        /**
	 * @private
	 */ _drawTitle: helpers$1.noop
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$3 = defaultConfig$3;
    scale_radialLinear._defaults = _defaults$3;
    var deprecated$1 = helpers$1._deprecated;
    var resolve$5 = helpers$1.options.resolve;
    var valueOrDefault$d = helpers$1.valueOrDefault;
    // Integer constants are from the ES6 spec.
    var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
    var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
    var INTERVALS = {
        millisecond: {
            common: true,
            size: 1,
            steps: 1000
        },
        second: {
            common: true,
            size: 1000,
            steps: 60
        },
        minute: {
            common: true,
            size: 60000,
            steps: 60
        },
        hour: {
            common: true,
            size: 3600000,
            steps: 24
        },
        day: {
            common: true,
            size: 86400000,
            steps: 30
        },
        week: {
            common: false,
            size: 604800000,
            steps: 4
        },
        month: {
            common: true,
            size: 2.628e9,
            steps: 12
        },
        quarter: {
            common: false,
            size: 7.884e9,
            steps: 4
        },
        year: {
            common: true,
            size: 3.154e10
        }
    };
    var UNITS = Object.keys(INTERVALS);
    function sorter(a, b) {
        return a - b;
    }
    function arrayUnique(items) {
        var hash = {};
        var out = [];
        var i, ilen, item;
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            if (!hash[item]) {
                hash[item] = true;
                out.push(item);
            }
        }
        return out;
    }
    function getMin(options) {
        return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
    }
    function getMax(options) {
        return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
    }
    /**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */ function buildLookupTable(timestamps, min, max, distribution) {
        if (distribution === "linear" || !timestamps.length) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        var table = [];
        var items = [
            min
        ];
        var i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr > min && curr < max) items.push(curr);
        }
        items.push(max);
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            // only add points that breaks the scale linearity
            if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    // @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
    function lookup(table, key, value) {
        var lo = 0;
        var hi = table.length - 1;
        var mid, i0, i1;
        while(lo >= 0 && lo <= hi){
            mid = lo + hi >> 1;
            i0 = table[mid - 1] || null;
            i1 = table[mid];
            if (!i0) // given value is outside table (before first item)
            return {
                lo: null,
                hi: i1
            };
            else if (i1[key] < value) lo = mid + 1;
            else if (i0[key] > value) hi = mid - 1;
            else return {
                lo: i0,
                hi: i1
            };
        }
        // given value is outside table (after last item)
        return {
            lo: i1,
            hi: null
        };
    }
    /**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */ function interpolate$1(table, skey, sval, tkey) {
        var range = lookup(table, skey, sval);
        // Note: the lookup table ALWAYS contains at least 2 items (min and max)
        var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
        var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
        var span = next[skey] - prev[skey];
        var ratio = span ? (sval - prev[skey]) / span : 0;
        var offset = (next[tkey] - prev[tkey]) * ratio;
        return prev[tkey] + offset;
    }
    function toTimestamp(scale, input) {
        var adapter = scale._adapter;
        var options = scale.options.time;
        var parser = options.parser;
        var format = parser || options.format;
        var value = input;
        if (typeof parser === "function") value = parser(value);
        // Only parse if its not a timestamp already
        if (!helpers$1.isFinite(value)) value = typeof format === "string" ? adapter.parse(value, format) : adapter.parse(value);
        if (value !== null) return +value;
        // Labels are in an incompatible format and no `parser` has been provided.
        // The user might still use the deprecated `format` option for parsing.
        if (!parser && typeof format === "function") {
            value = format(input);
            // `format` could return something else than a timestamp, if so, parse it
            if (!helpers$1.isFinite(value)) value = adapter.parse(value);
        }
        return value;
    }
    function parse(scale, input) {
        if (helpers$1.isNullOrUndef(input)) return null;
        var options = scale.options.time;
        var value = toTimestamp(scale, scale.getRightValue(input));
        if (value === null) return value;
        if (options.round) value = +scale._adapter.startOf(value, options.round);
        return value;
    }
    /**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */ function determineUnitForAutoTicks(minUnit, min, max, capacity) {
        var ilen = UNITS.length;
        var i, interval, factor;
        for(i = UNITS.indexOf(minUnit); i < ilen - 1; ++i){
            interval = INTERVALS[UNITS[i]];
            factor = interval.steps ? interval.steps : MAX_INTEGER;
            if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return UNITS[i];
        }
        return UNITS[ilen - 1];
    }
    /**
 * Figures out what unit to format a set of ticks with
 */ function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
        var i, unit;
        for(i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--){
            unit = UNITS[i];
            if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
        }
        return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
    }
    function determineMajorUnit(unit) {
        for(var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i){
            if (INTERVALS[UNITS[i]].common) return UNITS[i];
        }
    }
    /**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */ function generate(scale, min, max, capacity) {
        var adapter = scale._adapter;
        var options = scale.options;
        var timeOpts = options.time;
        var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
        var stepSize = resolve$5([
            timeOpts.stepSize,
            timeOpts.unitStepSize,
            1
        ]);
        var weekday = minor === "week" ? timeOpts.isoWeekday : false;
        var first = min;
        var ticks = [];
        var time;
        // For 'week' unit, handle the first day of week option
        if (weekday) first = +adapter.startOf(first, "isoWeek", weekday);
        // Align first ticks on unit
        first = +adapter.startOf(first, weekday ? "day" : minor);
        // Prevent browser from freezing in case user options request millions of milliseconds
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor;
        for(time = first; time < max; time = +adapter.add(time, stepSize, minor))ticks.push(time);
        if (time === max || options.bounds === "ticks") ticks.push(time);
        return ticks;
    }
    /**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */ function computeOffsets(table, ticks, min, max, options) {
        var start = 0;
        var end = 0;
        var first, last;
        if (options.offset && ticks.length) {
            first = interpolate$1(table, "time", ticks[0], "pos");
            if (ticks.length === 1) start = 1 - first;
            else start = (interpolate$1(table, "time", ticks[1], "pos") - first) / 2;
            last = interpolate$1(table, "time", ticks[ticks.length - 1], "pos");
            if (ticks.length === 1) end = last;
            else end = (last - interpolate$1(table, "time", ticks[ticks.length - 2], "pos")) / 2;
        }
        return {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    function setMajorTicks(scale, ticks, map, majorUnit) {
        var adapter = scale._adapter;
        var first = +adapter.startOf(ticks[0].value, majorUnit);
        var last = ticks[ticks.length - 1].value;
        var major, index;
        for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
            index = map[major];
            if (index >= 0) ticks[index].major = true;
        }
        return ticks;
    }
    function ticksFromTimestamps(scale, values, majorUnit) {
        var ticks = [];
        var map = {};
        var ilen = values.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = values[i];
            map[value] = i;
            ticks.push({
                value: value,
                major: false
            });
        }
        // We set the major ticks separately from the above loop because calling startOf for every tick
        // is expensive when there is a large number of ticks
        return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
    }
    var defaultConfig$4 = {
        position: "bottom",
        /**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */ distribution: "linear",
        /**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */ bounds: "data",
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            displayFormat: false,
            isoWeekday: false,
            minUnit: "millisecond",
            displayFormats: {}
        },
        ticks: {
            autoSkip: false,
            /**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */ source: "auto",
            major: {
                enabled: false
            }
        }
    };
    var scale_time = core_scale.extend({
        initialize: function() {
            this.mergeTicksOptions();
            core_scale.prototype.initialize.call(this);
        },
        update: function() {
            var me = this;
            var options = me.options;
            var time = options.time || (options.time = {});
            var adapter = me._adapter = new core_adapters._date(options.adapters.date);
            // DEPRECATIONS: output a message only one time per update
            deprecated$1("time scale", time.format, "time.format", "time.parser");
            deprecated$1("time scale", time.min, "time.min", "ticks.min");
            deprecated$1("time scale", time.max, "time.max", "ticks.max");
            // Backward compatibility: before introducing adapter, `displayFormats` was
            // supposed to contain *all* unit/string pairs but this can't be resolved
            // when loading the scale (adapters are loaded afterward), so let's populate
            // missing formats on update
            helpers$1.mergeIf(time.displayFormats, adapter.formats());
            return core_scale.prototype.update.apply(me, arguments);
        },
        /**
	 * Allows data to be referenced via 't' attribute
	 */ getRightValue: function(rawValue) {
            if (rawValue && rawValue.t !== undefined) rawValue = rawValue.t;
            return core_scale.prototype.getRightValue.call(this, rawValue);
        },
        determineDataLimits: function() {
            var me = this;
            var chart = me.chart;
            var adapter = me._adapter;
            var options = me.options;
            var unit = options.time.unit || "day";
            var min = MAX_INTEGER;
            var max = MIN_INTEGER;
            var timestamps = [];
            var datasets = [];
            var labels = [];
            var i, j, ilen, jlen, data, timestamp, labelsAdded;
            var dataLabels = me._getLabels();
            for(i = 0, ilen = dataLabels.length; i < ilen; ++i)labels.push(parse(me, dataLabels[i]));
            for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                data = chart.data.datasets[i].data;
                // Let's consider that all data have the same format.
                if (helpers$1.isObject(data[0])) {
                    datasets[i] = [];
                    for(j = 0, jlen = data.length; j < jlen; ++j){
                        timestamp = parse(me, data[j]);
                        timestamps.push(timestamp);
                        datasets[i][j] = timestamp;
                    }
                } else {
                    datasets[i] = labels.slice(0);
                    if (!labelsAdded) {
                        timestamps = timestamps.concat(labels);
                        labelsAdded = true;
                    }
                }
            } else datasets[i] = [];
            if (labels.length) {
                min = Math.min(min, labels[0]);
                max = Math.max(max, labels[labels.length - 1]);
            }
            if (timestamps.length) {
                timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
                min = Math.min(min, timestamps[0]);
                max = Math.max(max, timestamps[timestamps.length - 1]);
            }
            min = parse(me, getMin(options)) || min;
            max = parse(me, getMax(options)) || max;
            // In case there is no valid min/max, set limits based on unit time option
            min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
            max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
            // Make sure that max is strictly higher than min (required by the lookup table)
            me.min = Math.min(min, max);
            me.max = Math.max(min + 1, max);
            // PRIVATE
            me._table = [];
            me._timestamps = {
                data: timestamps,
                datasets: datasets,
                labels: labels
            };
        },
        buildTicks: function() {
            var me = this;
            var min = me.min;
            var max = me.max;
            var options = me.options;
            var tickOpts = options.ticks;
            var timeOpts = options.time;
            var timestamps = me._timestamps;
            var ticks = [];
            var capacity = me.getLabelCapacity(min);
            var source = tickOpts.source;
            var distribution = options.distribution;
            var i, ilen, timestamp;
            if (source === "data" || source === "auto" && distribution === "series") timestamps = timestamps.data;
            else if (source === "labels") timestamps = timestamps.labels;
            else timestamps = generate(me, min, max, capacity);
            if (options.bounds === "ticks" && timestamps.length) {
                min = timestamps[0];
                max = timestamps[timestamps.length - 1];
            }
            // Enforce limits with user min/max options
            min = parse(me, getMin(options)) || min;
            max = parse(me, getMax(options)) || max;
            // Remove ticks outside the min/max range
            for(i = 0, ilen = timestamps.length; i < ilen; ++i){
                timestamp = timestamps[i];
                if (timestamp >= min && timestamp <= max) ticks.push(timestamp);
            }
            me.min = min;
            me.max = max;
            // PRIVATE
            // determineUnitForFormatting relies on the number of ticks so we don't use it when
            // autoSkip is enabled because we don't yet know what the final number of ticks will be
            me._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity) : determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
            me._majorUnit = !tickOpts.major.enabled || me._unit === "year" ? undefined : determineMajorUnit(me._unit);
            me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
            me._offsets = computeOffsets(me._table, ticks, min, max, options);
            if (tickOpts.reverse) ticks.reverse();
            return ticksFromTimestamps(me, ticks, me._majorUnit);
        },
        getLabelForIndex: function(index, datasetIndex) {
            var me = this;
            var adapter = me._adapter;
            var data = me.chart.data;
            var timeOpts = me.options.time;
            var label = data.labels && index < data.labels.length ? data.labels[index] : "";
            var value = data.datasets[datasetIndex].data[index];
            if (helpers$1.isObject(value)) label = me.getRightValue(value);
            if (timeOpts.tooltipFormat) return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
            if (typeof label === "string") return label;
            return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
        },
        /**
	 * Function to format an individual tick mark
	 * @private
	 */ tickFormatFunction: function(time, index, ticks, format) {
            var me = this;
            var adapter = me._adapter;
            var options = me.options;
            var formats = options.time.displayFormats;
            var minorFormat = formats[me._unit];
            var majorUnit = me._majorUnit;
            var majorFormat = formats[majorUnit];
            var tick = ticks[index];
            var tickOpts = options.ticks;
            var major = majorUnit && majorFormat && tick && tick.major;
            var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
            var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
            var formatter = resolve$5([
                nestedTickOpts.callback,
                nestedTickOpts.userCallback,
                tickOpts.callback,
                tickOpts.userCallback
            ]);
            return formatter ? formatter(label, index, ticks) : label;
        },
        convertTicksToLabels: function(ticks) {
            var labels = [];
            var i, ilen;
            for(i = 0, ilen = ticks.length; i < ilen; ++i)labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
            return labels;
        },
        /**
	 * @private
	 */ getPixelForOffset: function(time) {
            var me = this;
            var offsets = me._offsets;
            var pos = interpolate$1(me._table, "time", time, "pos");
            return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
        },
        getPixelForValue: function(value, index, datasetIndex) {
            var me = this;
            var time = null;
            if (index !== undefined && datasetIndex !== undefined) time = me._timestamps.datasets[datasetIndex][index];
            if (time === null) time = parse(me, value);
            if (time !== null) return me.getPixelForOffset(time);
        },
        getPixelForTick: function(index) {
            var ticks = this.getTicks();
            return index >= 0 && index < ticks.length ? this.getPixelForOffset(ticks[index].value) : null;
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var offsets = me._offsets;
            var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
            var time = interpolate$1(me._table, "pos", pos, "time");
            // DEPRECATION, we should return time directly
            return me._adapter._create(time);
        },
        /**
	 * @private
	 */ _getLabelSize: function(label) {
            var me = this;
            var ticksOpts = me.options.ticks;
            var tickLabelWidth = me.ctx.measureText(label).width;
            var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
            var cosRotation = Math.cos(angle);
            var sinRotation = Math.sin(angle);
            var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
            return {
                w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
                h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
            };
        },
        /**
	 * Crude approximation of what the label width might be
	 * @private
	 */ getLabelWidth: function(label) {
            return this._getLabelSize(label).w;
        },
        /**
	 * @private
	 */ getLabelCapacity: function(exampleTime) {
            var me = this;
            var timeOpts = me.options.time;
            var displayFormats = timeOpts.displayFormats;
            // pick the longest format (milliseconds) for guestimation
            var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
            var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [
                exampleTime
            ], me._majorUnit), format);
            var size = me._getLabelSize(exampleLabel);
            var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
            if (me.options.offset) capacity--;
            return capacity > 0 ? capacity : 1;
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$4 = defaultConfig$4;
    scale_time._defaults = _defaults$4;
    var scales = {
        category: scale_category,
        linear: scale_linear,
        logarithmic: scale_logarithmic,
        radialLinear: scale_radialLinear,
        time: scale_time
    };
    var FORMATS = {
        datetime: "MMM D, YYYY, h:mm:ss a",
        millisecond: "h:mm:ss.SSS a",
        second: "h:mm:ss a",
        minute: "h:mm a",
        hour: "hA",
        day: "MMM D",
        week: "ll",
        month: "MMM YYYY",
        quarter: "[Q]Q - YYYY",
        year: "YYYY"
    };
    core_adapters._date.override(typeof moment === "function" ? {
        _id: "moment",
        formats: function() {
            return FORMATS;
        },
        parse: function(value, format) {
            if (typeof value === "string" && typeof format === "string") value = moment(value, format);
            else if (!(value instanceof moment)) value = moment(value);
            return value.isValid() ? value.valueOf() : null;
        },
        format: function(time, format) {
            return moment(time).format(format);
        },
        add: function(time, amount, unit) {
            return moment(time).add(amount, unit).valueOf();
        },
        diff: function(max, min, unit) {
            return moment(max).diff(moment(min), unit);
        },
        startOf: function(time, unit, weekday) {
            time = moment(time);
            if (unit === "isoWeek") return time.isoWeekday(weekday).valueOf();
            return time.startOf(unit).valueOf();
        },
        endOf: function(time, unit) {
            return moment(time).endOf(unit).valueOf();
        },
        // DEPRECATIONS
        /**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */ _create: function(time) {
            return moment(time);
        }
    } : {});
    core_defaults._set("global", {
        plugins: {
            filler: {
                propagate: true
            }
        }
    });
    var mappers = {
        dataset: function(source) {
            var index = source.fill;
            var chart = source.chart;
            var meta = chart.getDatasetMeta(index);
            var visible = meta && chart.isDatasetVisible(index);
            var points = visible && meta.dataset._children || [];
            var length = points.length || 0;
            return !length ? null : function(point, i) {
                return i < length && points[i]._view || null;
            };
        },
        boundary: function(source) {
            var boundary = source.boundary;
            var x = boundary ? boundary.x : null;
            var y = boundary ? boundary.y : null;
            if (helpers$1.isArray(boundary)) return function(point, i) {
                return boundary[i];
            };
            return function(point) {
                return {
                    x: x === null ? point.x : x,
                    y: y === null ? point.y : y
                };
            };
        }
    };
    // @todo if (fill[0] === '#')
    function decodeFill(el, index, count) {
        var model = el._model || {};
        var fill = model.fill;
        var target;
        if (fill === undefined) fill = !!model.backgroundColor;
        if (fill === false || fill === null) return false;
        if (fill === true) return "origin";
        target = parseFloat(fill, 10);
        if (isFinite(target) && Math.floor(target) === target) {
            if (fill[0] === "-" || fill[0] === "+") target = index + target;
            if (target === index || target < 0 || target >= count) return false;
            return target;
        }
        switch(fill){
            // compatibility
            case "bottom":
                return "start";
            case "top":
                return "end";
            case "zero":
                return "origin";
            // supported boundaries
            case "origin":
            case "start":
            case "end":
                return fill;
            // invalid fill values
            default:
                return false;
        }
    }
    function computeLinearBoundary(source) {
        var model = source.el._model || {};
        var scale = source.el._scale || {};
        var fill = source.fill;
        var target = null;
        var horizontal;
        if (isFinite(fill)) return null;
        // Backward compatibility: until v3, we still need to support boundary values set on
        // the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
        // controllers might still use it (e.g. the Smith chart).
        if (fill === "start") target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
        else if (fill === "end") target = model.scaleTop === undefined ? scale.top : model.scaleTop;
        else if (model.scaleZero !== undefined) target = model.scaleZero;
        else if (scale.getBasePixel) target = scale.getBasePixel();
        if (target !== undefined && target !== null) {
            if (target.x !== undefined && target.y !== undefined) return target;
            if (helpers$1.isFinite(target)) {
                horizontal = scale.isHorizontal();
                return {
                    x: horizontal ? target : null,
                    y: horizontal ? null : target
                };
            }
        }
        return null;
    }
    function computeCircularBoundary(source) {
        var scale = source.el._scale;
        var options = scale.options;
        var length = scale.chart.data.labels.length;
        var fill = source.fill;
        var target = [];
        var start, end, center, i, point;
        if (!length) return null;
        start = options.ticks.reverse ? scale.max : scale.min;
        end = options.ticks.reverse ? scale.min : scale.max;
        center = scale.getPointPositionForValue(0, start);
        for(i = 0; i < length; ++i){
            point = fill === "start" || fill === "end" ? scale.getPointPositionForValue(i, fill === "start" ? start : end) : scale.getBasePosition(i);
            if (options.gridLines.circular) {
                point.cx = center.x;
                point.cy = center.y;
                point.angle = scale.getIndexAngle(i) - Math.PI / 2;
            }
            target.push(point);
        }
        return target;
    }
    function computeBoundary(source) {
        var scale = source.el._scale || {};
        if (scale.getPointPositionForValue) return computeCircularBoundary(source);
        return computeLinearBoundary(source);
    }
    function resolveTarget(sources, index, propagate) {
        var source = sources[index];
        var fill = source.fill;
        var visited = [
            index
        ];
        var target;
        if (!propagate) return fill;
        while(fill !== false && visited.indexOf(fill) === -1){
            if (!isFinite(fill)) return fill;
            target = sources[fill];
            if (!target) return false;
            if (target.visible) return fill;
            visited.push(fill);
            fill = target.fill;
        }
        return false;
    }
    function createMapper(source) {
        var fill = source.fill;
        var type = "dataset";
        if (fill === false) return null;
        if (!isFinite(fill)) type = "boundary";
        return mappers[type](source);
    }
    function isDrawable(point) {
        return point && !point.skip;
    }
    function drawArea(ctx, curve0, curve1, len0, len1) {
        var i, cx, cy, r;
        if (!len0 || !len1) return;
        // building first area curve (normal)
        ctx.moveTo(curve0[0].x, curve0[0].y);
        for(i = 1; i < len0; ++i)helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
        if (curve1[0].angle !== undefined) {
            cx = curve1[0].cx;
            cy = curve1[0].cy;
            r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
            for(i = len1 - 1; i > 0; --i)ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
            return;
        }
        // joining the two area curves
        ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
        // building opposite area curve (reverse)
        for(i = len1 - 1; i > 0; --i)helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
    }
    function doFill(ctx, points, mapper, view, color, loop) {
        var count = points.length;
        var span = view.spanGaps;
        var curve0 = [];
        var curve1 = [];
        var len0 = 0;
        var len1 = 0;
        var i, ilen, index, p0, p1, d0, d1, loopOffset;
        ctx.beginPath();
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i % count;
            p0 = points[index]._view;
            p1 = mapper(p0, index, view);
            d0 = isDrawable(p0);
            d1 = isDrawable(p1);
            if (loop && loopOffset === undefined && d0) {
                loopOffset = i + 1;
                ilen = count + loopOffset;
            }
            if (d0 && d1) {
                len0 = curve0.push(p0);
                len1 = curve1.push(p1);
            } else if (len0 && len1) {
                if (!span) {
                    drawArea(ctx, curve0, curve1, len0, len1);
                    len0 = len1 = 0;
                    curve0 = [];
                    curve1 = [];
                } else {
                    if (d0) curve0.push(p0);
                    if (d1) curve1.push(p1);
                }
            }
        }
        drawArea(ctx, curve0, curve1, len0, len1);
        ctx.closePath();
        ctx.fillStyle = color;
        ctx.fill();
    }
    var plugin_filler = {
        id: "filler",
        afterDatasetsUpdate: function(chart, options) {
            var count = (chart.data.datasets || []).length;
            var propagate = options.propagate;
            var sources = [];
            var meta, i, el, source;
            for(i = 0; i < count; ++i){
                meta = chart.getDatasetMeta(i);
                el = meta.dataset;
                source = null;
                if (el && el._model && el instanceof elements.Line) source = {
                    visible: chart.isDatasetVisible(i),
                    fill: decodeFill(el, i, count),
                    chart: chart,
                    el: el
                };
                meta.$filler = source;
                sources.push(source);
            }
            for(i = 0; i < count; ++i){
                source = sources[i];
                if (!source) continue;
                source.fill = resolveTarget(sources, i, propagate);
                source.boundary = computeBoundary(source);
                source.mapper = createMapper(source);
            }
        },
        beforeDatasetsDraw: function(chart) {
            var metasets = chart._getSortedVisibleDatasetMetas();
            var ctx = chart.ctx;
            var meta, i, el, view, points, mapper, color;
            for(i = metasets.length - 1; i >= 0; --i){
                meta = metasets[i].$filler;
                if (!meta || !meta.visible) continue;
                el = meta.el;
                view = el._view;
                points = el._children || [];
                mapper = meta.mapper;
                color = view.backgroundColor || core_defaults.global.defaultColor;
                if (mapper && color && points.length) {
                    helpers$1.canvas.clipArea(ctx, chart.chartArea);
                    doFill(ctx, points, mapper, view, color, el._loop);
                    helpers$1.canvas.unclipArea(ctx);
                }
            }
        }
    };
    var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
    var noop$1 = helpers$1.noop;
    var valueOrDefault$e = helpers$1.valueOrDefault;
    core_defaults._set("global", {
        legend: {
            display: true,
            position: "top",
            align: "center",
            fullWidth: true,
            reverse: false,
            weight: 1000,
            // a callback that will handle
            onClick: function(e, legendItem) {
                var index = legendItem.datasetIndex;
                var ci = this.chart;
                var meta = ci.getDatasetMeta(index);
                // See controller.isDatasetVisible comment
                meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
                // We hid a dataset ... rerender the chart
                ci.update();
            },
            onHover: null,
            onLeave: null,
            labels: {
                boxWidth: 40,
                padding: 10,
                // Generates labels shown in the legend
                // Valid properties to return:
                // text : text to display
                // fillStyle : fill of coloured box
                // strokeStyle: stroke of coloured box
                // hidden : if this legend item refers to a hidden item
                // lineCap : cap style for line
                // lineDash
                // lineDashOffset :
                // lineJoin :
                // lineWidth :
                generateLabels: function(chart) {
                    var datasets = chart.data.datasets;
                    var options = chart.options.legend || {};
                    var usePointStyle = options.labels && options.labels.usePointStyle;
                    return chart._getSortedDatasetMetas().map(function(meta) {
                        var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                        return {
                            text: datasets[meta.index].label,
                            fillStyle: style.backgroundColor,
                            hidden: !chart.isDatasetVisible(meta.index),
                            lineCap: style.borderCapStyle,
                            lineDash: style.borderDash,
                            lineDashOffset: style.borderDashOffset,
                            lineJoin: style.borderJoinStyle,
                            lineWidth: style.borderWidth,
                            strokeStyle: style.borderColor,
                            pointStyle: style.pointStyle,
                            rotation: style.rotation,
                            // Below is extra data used for toggling the datasets
                            datasetIndex: meta.index
                        };
                    }, this);
                }
            }
        },
        legendCallback: function(chart) {
            var list = document.createElement("ul");
            var datasets = chart.data.datasets;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute("class", chart.id + "-legend");
            for(i = 0, ilen = datasets.length; i < ilen; i++){
                listItem = list.appendChild(document.createElement("li"));
                listItemSpan = listItem.appendChild(document.createElement("span"));
                listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
                if (datasets[i].label) listItem.appendChild(document.createTextNode(datasets[i].label));
            }
            return list.outerHTML;
        }
    });
    /**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */ function getBoxWidth(labelOpts, fontSize) {
        return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ? fontSize : labelOpts.boxWidth;
    }
    /**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */ var Legend = core_element.extend({
        initialize: function(config) {
            var me = this;
            helpers$1.extend(me, config);
            // Contains hit boxes for each dataset (in dataset order)
            me.legendHitBoxes = [];
            /**
 		 * @private
 		 */ me._hoveredItem = null;
            // Are we in doughnut mode which has a different data type
            me.doughnutMode = false;
        },
        // These methods are ordered by lifecycle. Utilities then follow.
        // Any function defined here is inherited by all legend types.
        // Any function can be extended by the legend type
        beforeUpdate: noop$1,
        update: function(maxWidth, maxHeight, margins) {
            var me = this;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = margins;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Labels
            me.beforeBuildLabels();
            me.buildLabels();
            me.afterBuildLabels();
            // Fit
            me.beforeFit();
            me.fit();
            me.afterFit();
            //
            me.afterUpdate();
            return me.minSize;
        },
        afterUpdate: noop$1,
        //
        beforeSetDimensions: noop$1,
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
            // Reset minSize
            me.minSize = {
                width: 0,
                height: 0
            };
        },
        afterSetDimensions: noop$1,
        //
        beforeBuildLabels: noop$1,
        buildLabels: function() {
            var me = this;
            var labelOpts = me.options.labels || {};
            var legendItems = helpers$1.callback(labelOpts.generateLabels, [
                me.chart
            ], me) || [];
            if (labelOpts.filter) legendItems = legendItems.filter(function(item) {
                return labelOpts.filter(item, me.chart.data);
            });
            if (me.options.reverse) legendItems.reverse();
            me.legendItems = legendItems;
        },
        afterBuildLabels: noop$1,
        //
        beforeFit: noop$1,
        fit: function() {
            var me = this;
            var opts = me.options;
            var labelOpts = opts.labels;
            var display = opts.display;
            var ctx = me.ctx;
            var labelFont = helpers$1.options._parseFont(labelOpts);
            var fontSize = labelFont.size;
            // Reset hit boxes
            var hitboxes = me.legendHitBoxes = [];
            var minSize = me.minSize;
            var isHorizontal = me.isHorizontal();
            if (isHorizontal) {
                minSize.width = me.maxWidth; // fill all the width
                minSize.height = display ? 10 : 0;
            } else {
                minSize.width = display ? 10 : 0;
                minSize.height = me.maxHeight; // fill all the height
            }
            // Increase sizes here
            if (!display) {
                me.width = minSize.width = me.height = minSize.height = 0;
                return;
            }
            ctx.font = labelFont.string;
            if (isHorizontal) {
                // Labels
                // Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
                var lineWidths = me.lineWidths = [
                    0
                ];
                var totalHeight = 0;
                ctx.textAlign = "left";
                ctx.textBaseline = "middle";
                helpers$1.each(me.legendItems, function(legendItem, i) {
                    var boxWidth = getBoxWidth(labelOpts, fontSize);
                    var width = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
                        totalHeight += fontSize + labelOpts.padding;
                        lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                    }
                    // Store the hitbox width and height here. Final position will be updated in `draw`
                    hitboxes[i] = {
                        left: 0,
                        top: 0,
                        width: width,
                        height: fontSize
                    };
                    lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
                });
                minSize.height += totalHeight;
            } else {
                var vPadding = labelOpts.padding;
                var columnWidths = me.columnWidths = [];
                var columnHeights = me.columnHeights = [];
                var totalWidth = labelOpts.padding;
                var currentColWidth = 0;
                var currentColHeight = 0;
                helpers$1.each(me.legendItems, function(legendItem, i) {
                    var boxWidth = getBoxWidth(labelOpts, fontSize);
                    var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    // If too tall, go to new column
                    if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
                        totalWidth += currentColWidth + labelOpts.padding;
                        columnWidths.push(currentColWidth); // previous column width
                        columnHeights.push(currentColHeight);
                        currentColWidth = 0;
                        currentColHeight = 0;
                    }
                    // Get max width
                    currentColWidth = Math.max(currentColWidth, itemWidth);
                    currentColHeight += fontSize + vPadding;
                    // Store the hitbox width and height here. Final position will be updated in `draw`
                    hitboxes[i] = {
                        left: 0,
                        top: 0,
                        width: itemWidth,
                        height: fontSize
                    };
                });
                totalWidth += currentColWidth;
                columnWidths.push(currentColWidth);
                columnHeights.push(currentColHeight);
                minSize.width += totalWidth;
            }
            me.width = minSize.width;
            me.height = minSize.height;
        },
        afterFit: noop$1,
        // Shared Methods
        isHorizontal: function() {
            return this.options.position === "top" || this.options.position === "bottom";
        },
        // Actually draw the legend on the canvas
        draw: function() {
            var me = this;
            var opts = me.options;
            var labelOpts = opts.labels;
            var globalDefaults = core_defaults.global;
            var defaultColor = globalDefaults.defaultColor;
            var lineDefault = globalDefaults.elements.line;
            var legendHeight = me.height;
            var columnHeights = me.columnHeights;
            var legendWidth = me.width;
            var lineWidths = me.lineWidths;
            if (!opts.display) return;
            var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
            var ctx = me.ctx;
            var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
            var labelFont = helpers$1.options._parseFont(labelOpts);
            var fontSize = labelFont.size;
            var cursor;
            // Canvas setup
            ctx.textAlign = rtlHelper.textAlign("left");
            ctx.textBaseline = "middle";
            ctx.lineWidth = 0.5;
            ctx.strokeStyle = fontColor; // for strikethrough effect
            ctx.fillStyle = fontColor; // render in correct colour
            ctx.font = labelFont.string;
            var boxWidth = getBoxWidth(labelOpts, fontSize);
            var hitboxes = me.legendHitBoxes;
            // current position
            var drawLegendBox = function(x, y, legendItem) {
                if (isNaN(boxWidth) || boxWidth <= 0) return;
                // Set the ctx for the box
                ctx.save();
                var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
                ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
                ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
                ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
                ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
                if (ctx.setLineDash) // IE 9 and 10 do not support line dash
                ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
                if (labelOpts && labelOpts.usePointStyle) {
                    // Recalculate x and y for drawPoint() because its expecting
                    // x and y to be center of figure (instead of top left)
                    var radius = boxWidth * Math.SQRT2 / 2;
                    var centerX = rtlHelper.xPlus(x, boxWidth / 2);
                    var centerY = y + fontSize / 2;
                    // Draw pointStyle as legend symbol
                    helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
                } else {
                    // Draw box as legend symbol
                    ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
                    if (lineWidth !== 0) ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
                }
                ctx.restore();
            };
            var fillText = function(x, y, legendItem, textWidth) {
                var halfFontSize = fontSize / 2;
                var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
                var yMiddle = y + halfFontSize;
                ctx.fillText(legendItem.text, xLeft, yMiddle);
                if (legendItem.hidden) {
                    // Strikethrough the text if hidden
                    ctx.beginPath();
                    ctx.lineWidth = 2;
                    ctx.moveTo(xLeft, yMiddle);
                    ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
                    ctx.stroke();
                }
            };
            var alignmentOffset = function(dimension, blockSize) {
                switch(opts.align){
                    case "start":
                        return labelOpts.padding;
                    case "end":
                        return dimension - blockSize;
                    default:
                        return (dimension - blockSize + labelOpts.padding) / 2;
                }
            };
            // Horizontal
            var isHorizontal = me.isHorizontal();
            if (isHorizontal) cursor = {
                x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
                y: me.top + labelOpts.padding,
                line: 0
            };
            else cursor = {
                x: me.left + labelOpts.padding,
                y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
                line: 0
            };
            helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
            var itemHeight = fontSize + labelOpts.padding;
            helpers$1.each(me.legendItems, function(legendItem, i) {
                var textWidth = ctx.measureText(legendItem.text).width;
                var width = boxWidth + fontSize / 2 + textWidth;
                var x = cursor.x;
                var y = cursor.y;
                rtlHelper.setWidth(me.minSize.width);
                // Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
                // instead of me.right and me.bottom because me.width and me.height
                // may have been changed since me.minSize was calculated
                if (isHorizontal) {
                    if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
                        y = cursor.y += itemHeight;
                        cursor.line++;
                        x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
                    }
                } else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
                    x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
                    cursor.line++;
                    y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
                }
                var realX = rtlHelper.x(x);
                drawLegendBox(realX, y, legendItem);
                hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
                hitboxes[i].top = y;
                // Fill the actual label
                fillText(realX, y, legendItem, textWidth);
                if (isHorizontal) cursor.x += width + labelOpts.padding;
                else cursor.y += itemHeight;
            });
            helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
        },
        /**
	 * @private
	 */ _getLegendItemAt: function(x, y) {
            var me = this;
            var i, hitBox, lh;
            if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
                // See if we are touching one of the dataset boxes
                lh = me.legendHitBoxes;
                for(i = 0; i < lh.length; ++i){
                    hitBox = lh[i];
                    if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) // Touching an element
                    return me.legendItems[i];
                }
            }
            return null;
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */ handleEvent: function(e) {
            var me = this;
            var opts = me.options;
            var type = e.type === "mouseup" ? "click" : e.type;
            var hoveredItem;
            if (type === "mousemove") {
                if (!opts.onHover && !opts.onLeave) return;
            } else if (type === "click") {
                if (!opts.onClick) return;
            } else return;
            // Chart event already has relative position in it
            hoveredItem = me._getLegendItemAt(e.x, e.y);
            if (type === "click") {
                if (hoveredItem && opts.onClick) // use e.native for backwards compatibility
                opts.onClick.call(me, e.native, hoveredItem);
            } else {
                if (opts.onLeave && hoveredItem !== me._hoveredItem) {
                    if (me._hoveredItem) opts.onLeave.call(me, e.native, me._hoveredItem);
                    me._hoveredItem = hoveredItem;
                }
                if (opts.onHover && hoveredItem) // use e.native for backwards compatibility
                opts.onHover.call(me, e.native, hoveredItem);
            }
        }
    });
    function createNewLegendAndAttach(chart, legendOpts) {
        var legend = new Legend({
            ctx: chart.ctx,
            options: legendOpts,
            chart: chart
        });
        core_layouts.configure(chart, legend, legendOpts);
        core_layouts.addBox(chart, legend);
        chart.legend = legend;
    }
    var plugin_legend = {
        id: "legend",
        /**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */ _element: Legend,
        beforeInit: function(chart) {
            var legendOpts = chart.options.legend;
            if (legendOpts) createNewLegendAndAttach(chart, legendOpts);
        },
        beforeUpdate: function(chart) {
            var legendOpts = chart.options.legend;
            var legend = chart.legend;
            if (legendOpts) {
                helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
                if (legend) {
                    core_layouts.configure(chart, legend, legendOpts);
                    legend.options = legendOpts;
                } else createNewLegendAndAttach(chart, legendOpts);
            } else if (legend) {
                core_layouts.removeBox(chart, legend);
                delete chart.legend;
            }
        },
        afterEvent: function(chart, e) {
            var legend = chart.legend;
            if (legend) legend.handleEvent(e);
        }
    };
    var noop$2 = helpers$1.noop;
    core_defaults._set("global", {
        title: {
            display: false,
            fontStyle: "bold",
            fullWidth: true,
            padding: 10,
            position: "top",
            text: "",
            weight: 2000 // by default greater than legend (1000) to be above
        }
    });
    /**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */ var Title = core_element.extend({
        initialize: function(config) {
            var me = this;
            helpers$1.extend(me, config);
            // Contains hit boxes for each dataset (in dataset order)
            me.legendHitBoxes = [];
        },
        // These methods are ordered by lifecycle. Utilities then follow.
        beforeUpdate: noop$2,
        update: function(maxWidth, maxHeight, margins) {
            var me = this;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = margins;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Labels
            me.beforeBuildLabels();
            me.buildLabels();
            me.afterBuildLabels();
            // Fit
            me.beforeFit();
            me.fit();
            me.afterFit();
            //
            me.afterUpdate();
            return me.minSize;
        },
        afterUpdate: noop$2,
        //
        beforeSetDimensions: noop$2,
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
            // Reset minSize
            me.minSize = {
                width: 0,
                height: 0
            };
        },
        afterSetDimensions: noop$2,
        //
        beforeBuildLabels: noop$2,
        buildLabels: noop$2,
        afterBuildLabels: noop$2,
        //
        beforeFit: noop$2,
        fit: function() {
            var me = this;
            var opts = me.options;
            var minSize = me.minSize = {};
            var isHorizontal = me.isHorizontal();
            var lineCount, textSize;
            if (!opts.display) {
                me.width = minSize.width = me.height = minSize.height = 0;
                return;
            }
            lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
            textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
            me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
            me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
        },
        afterFit: noop$2,
        // Shared Methods
        isHorizontal: function() {
            var pos = this.options.position;
            return pos === "top" || pos === "bottom";
        },
        // Actually draw the title block on the canvas
        draw: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            if (!opts.display) return;
            var fontOpts = helpers$1.options._parseFont(opts);
            var lineHeight = fontOpts.lineHeight;
            var offset = lineHeight / 2 + opts.padding;
            var rotation = 0;
            var top = me.top;
            var left = me.left;
            var bottom = me.bottom;
            var right = me.right;
            var maxWidth, titleX, titleY;
            ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
            ctx.font = fontOpts.string;
            // Horizontal
            if (me.isHorizontal()) {
                titleX = left + (right - left) / 2; // midpoint of the width
                titleY = top + offset;
                maxWidth = right - left;
            } else {
                titleX = opts.position === "left" ? left + offset : right - offset;
                titleY = top + (bottom - top) / 2;
                maxWidth = bottom - top;
                rotation = Math.PI * (opts.position === "left" ? -0.5 : 0.5);
            }
            ctx.save();
            ctx.translate(titleX, titleY);
            ctx.rotate(rotation);
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            var text = opts.text;
            if (helpers$1.isArray(text)) {
                var y = 0;
                for(var i = 0; i < text.length; ++i){
                    ctx.fillText(text[i], 0, y, maxWidth);
                    y += lineHeight;
                }
            } else ctx.fillText(text, 0, 0, maxWidth);
            ctx.restore();
        }
    });
    function createNewTitleBlockAndAttach(chart, titleOpts) {
        var title = new Title({
            ctx: chart.ctx,
            options: titleOpts,
            chart: chart
        });
        core_layouts.configure(chart, title, titleOpts);
        core_layouts.addBox(chart, title);
        chart.titleBlock = title;
    }
    var plugin_title = {
        id: "title",
        /**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */ _element: Title,
        beforeInit: function(chart) {
            var titleOpts = chart.options.title;
            if (titleOpts) createNewTitleBlockAndAttach(chart, titleOpts);
        },
        beforeUpdate: function(chart) {
            var titleOpts = chart.options.title;
            var titleBlock = chart.titleBlock;
            if (titleOpts) {
                helpers$1.mergeIf(titleOpts, core_defaults.global.title);
                if (titleBlock) {
                    core_layouts.configure(chart, titleBlock, titleOpts);
                    titleBlock.options = titleOpts;
                } else createNewTitleBlockAndAttach(chart, titleOpts);
            } else if (titleBlock) {
                core_layouts.removeBox(chart, titleBlock);
                delete chart.titleBlock;
            }
        }
    };
    var plugins = {};
    var filler = plugin_filler;
    var legend = plugin_legend;
    var title = plugin_title;
    plugins.filler = filler;
    plugins.legend = legend;
    plugins.title = title;
    /**
 * @namespace Chart
 */ core_controller.helpers = helpers$1;
    // @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
    core_helpers();
    core_controller._adapters = core_adapters;
    core_controller.Animation = core_animation;
    core_controller.animationService = core_animations;
    core_controller.controllers = controllers;
    core_controller.DatasetController = core_datasetController;
    core_controller.defaults = core_defaults;
    core_controller.Element = core_element;
    core_controller.elements = elements;
    core_controller.Interaction = core_interaction;
    core_controller.layouts = core_layouts;
    core_controller.platform = platform;
    core_controller.plugins = core_plugins;
    core_controller.Scale = core_scale;
    core_controller.scaleService = core_scaleService;
    core_controller.Ticks = core_ticks;
    core_controller.Tooltip = core_tooltip;
    // Register built-in scales
    core_controller.helpers.each(scales, function(scale, type) {
        core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
    });
    // Load to register built-in adapters (as side effects)
    // Loading built-in plugins
    for(var k in plugins)if (plugins.hasOwnProperty(k)) core_controller.plugins.register(plugins[k]);
    core_controller.platform.initialize();
    var src = core_controller;
    if (typeof window !== "undefined") window.Chart = core_controller;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ core_controller.Chart = core_controller;
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.Legend = plugins.legend._element;
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.Title = plugins.title._element;
    /**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.pluginService = core_controller.plugins;
    /**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */ core_controller.PluginBase = core_controller.Element.extend({});
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */ core_controller.canvasHelpers = core_controller.helpers.canvas;
    /**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */ core_controller.layoutService = core_controller.layouts;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */ core_controller.LinearScaleBase = scale_linearbase;
    /**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */ core_controller.helpers.each([
        "Bar",
        "Bubble",
        "Doughnut",
        "Line",
        "PolarArea",
        "Radar",
        "Scatter"
    ], function(klass) {
        core_controller[klass] = function(ctx, cfg) {
            return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
                type: klass.charAt(0).toLowerCase() + klass.slice(1)
            }));
        };
    });
    return src;
});

});

parcelRegister("a39iZ", function(module, exports) {

var $17m4Y = parcelRequire("17m4Y");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $7511670e20115b97$var$isEqual(value, other) {
    return $17m4Y(value, other);
}
module.exports = $7511670e20115b97$var$isEqual;

});
parcelRegister("17m4Y", function(module, exports) {

var $45AKr = parcelRequire("45AKr");

var $3MU3q = parcelRequire("3MU3q");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $0d07925df627adcb$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$3MU3q(value) && !$3MU3q(other)) return value !== value && other !== other;
    return $45AKr(value, other, bitmask, customizer, $0d07925df627adcb$var$baseIsEqual, stack);
}
module.exports = $0d07925df627adcb$var$baseIsEqual;

});
parcelRegister("45AKr", function(module, exports) {

var $h0DYD = parcelRequire("h0DYD");

var $fUeeu = parcelRequire("fUeeu");

var $6uYaw = parcelRequire("6uYaw");

var $8MeZI = parcelRequire("8MeZI");

var $aUeNP = parcelRequire("aUeNP");

var $hVwEW = parcelRequire("hVwEW");

var $iIOJg = parcelRequire("iIOJg");

var $3fKiX = parcelRequire("3fKiX");
/** Used to compose bitmasks for value comparisons. */ var $2fa42274ee5e481c$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $2fa42274ee5e481c$var$argsTag = "[object Arguments]", $2fa42274ee5e481c$var$arrayTag = "[object Array]", $2fa42274ee5e481c$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $2fa42274ee5e481c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2fa42274ee5e481c$var$hasOwnProperty = $2fa42274ee5e481c$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $2fa42274ee5e481c$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $hVwEW(object), othIsArr = $hVwEW(other), objTag = objIsArr ? $2fa42274ee5e481c$var$arrayTag : $aUeNP(object), othTag = othIsArr ? $2fa42274ee5e481c$var$arrayTag : $aUeNP(other);
    objTag = objTag == $2fa42274ee5e481c$var$argsTag ? $2fa42274ee5e481c$var$objectTag : objTag;
    othTag = othTag == $2fa42274ee5e481c$var$argsTag ? $2fa42274ee5e481c$var$objectTag : othTag;
    var objIsObj = objTag == $2fa42274ee5e481c$var$objectTag, othIsObj = othTag == $2fa42274ee5e481c$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $iIOJg(object)) {
        if (!$iIOJg(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $h0DYD);
        return objIsArr || $3fKiX(object) ? $fUeeu(object, other, bitmask, customizer, equalFunc, stack) : $6uYaw(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $2fa42274ee5e481c$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $2fa42274ee5e481c$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $2fa42274ee5e481c$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $h0DYD);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $h0DYD);
    return $8MeZI(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $2fa42274ee5e481c$var$baseIsEqualDeep;

});
parcelRegister("h0DYD", function(module, exports) {

var $5bwrM = parcelRequire("5bwrM");

var $iN2Kf = parcelRequire("iN2Kf");

var $hdJY7 = parcelRequire("hdJY7");

var $aNBeD = parcelRequire("aNBeD");

var $4lO4C = parcelRequire("4lO4C");

var $buL7N = parcelRequire("buL7N");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c6217260871fb595$var$Stack(entries) {
    var data = this.__data__ = new $5bwrM(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$c6217260871fb595$var$Stack.prototype.clear = $iN2Kf;
$c6217260871fb595$var$Stack.prototype["delete"] = $hdJY7;
$c6217260871fb595$var$Stack.prototype.get = $aNBeD;
$c6217260871fb595$var$Stack.prototype.has = $4lO4C;
$c6217260871fb595$var$Stack.prototype.set = $buL7N;
module.exports = $c6217260871fb595$var$Stack;

});
parcelRegister("5bwrM", function(module, exports) {

var $8oWQV = parcelRequire("8oWQV");

var $4JTG5 = parcelRequire("4JTG5");

var $lNRTV = parcelRequire("lNRTV");

var $GfzjQ = parcelRequire("GfzjQ");

var $azYRm = parcelRequire("azYRm");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3c67262323ad5308$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$3c67262323ad5308$var$ListCache.prototype.clear = $8oWQV;
$3c67262323ad5308$var$ListCache.prototype["delete"] = $4JTG5;
$3c67262323ad5308$var$ListCache.prototype.get = $lNRTV;
$3c67262323ad5308$var$ListCache.prototype.has = $GfzjQ;
$3c67262323ad5308$var$ListCache.prototype.set = $azYRm;
module.exports = $3c67262323ad5308$var$ListCache;

});
parcelRegister("8oWQV", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $61de37874291156c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $61de37874291156c$var$listCacheClear;

});

parcelRegister("4JTG5", function(module, exports) {

var $byLNd = parcelRequire("byLNd");
/** Used for built-in method references. */ var $37368dded2099760$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $37368dded2099760$var$splice = $37368dded2099760$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $37368dded2099760$var$listCacheDelete(key) {
    var data = this.__data__, index = $byLNd(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $37368dded2099760$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $37368dded2099760$var$listCacheDelete;

});
parcelRegister("byLNd", function(module, exports) {

var $kYVBW = parcelRequire("kYVBW");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $86a7f1531b2dfed9$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($kYVBW(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $86a7f1531b2dfed9$var$assocIndexOf;

});
parcelRegister("kYVBW", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $f4661991ceca792b$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $f4661991ceca792b$var$eq;

});



parcelRegister("lNRTV", function(module, exports) {

var $byLNd = parcelRequire("byLNd");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fdf7fc38d2bf7e2c$var$listCacheGet(key) {
    var data = this.__data__, index = $byLNd(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $fdf7fc38d2bf7e2c$var$listCacheGet;

});

parcelRegister("GfzjQ", function(module, exports) {

var $byLNd = parcelRequire("byLNd");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $07effff88ed5dbb8$var$listCacheHas(key) {
    return $byLNd(this.__data__, key) > -1;
}
module.exports = $07effff88ed5dbb8$var$listCacheHas;

});

parcelRegister("azYRm", function(module, exports) {

var $byLNd = parcelRequire("byLNd");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $7b3c61b68b2283a4$var$listCacheSet(key, value) {
    var data = this.__data__, index = $byLNd(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $7b3c61b68b2283a4$var$listCacheSet;

});


parcelRegister("iN2Kf", function(module, exports) {

var $5bwrM = parcelRequire("5bwrM");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $dadeeeafa135390a$var$stackClear() {
    this.__data__ = new $5bwrM;
    this.size = 0;
}
module.exports = $dadeeeafa135390a$var$stackClear;

});

parcelRegister("hdJY7", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c8974f01c5dae82a$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $c8974f01c5dae82a$var$stackDelete;

});

parcelRegister("aNBeD", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7dcb5d14561891ea$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $7dcb5d14561891ea$var$stackGet;

});

parcelRegister("4lO4C", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $32aff720036108c9$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $32aff720036108c9$var$stackHas;

});

parcelRegister("buL7N", function(module, exports) {

var $5bwrM = parcelRequire("5bwrM");

var $kpFsf = parcelRequire("kpFsf");

var $kekVz = parcelRequire("kekVz");
/** Used as the size to enable large array optimizations. */ var $85e70d0d67f0e9f7$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $85e70d0d67f0e9f7$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $5bwrM) {
        var pairs = data.__data__;
        if (!$kpFsf || pairs.length < $85e70d0d67f0e9f7$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $kekVz(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $85e70d0d67f0e9f7$var$stackSet;

});
parcelRegister("kpFsf", function(module, exports) {

var $9O1f3 = parcelRequire("9O1f3");

var $cJGSv = parcelRequire("cJGSv");
/* Built-in method references that are verified to be native. */ var $03d5c76d5ec8a109$var$Map = $9O1f3($cJGSv, "Map");
module.exports = $03d5c76d5ec8a109$var$Map;

});
parcelRegister("9O1f3", function(module, exports) {

var $2fRet = parcelRequire("2fRet");

var $4aEXc = parcelRequire("4aEXc");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $7239bf2cb5317263$var$getNative(object, key) {
    var value = $4aEXc(object, key);
    return $2fRet(value) ? value : undefined;
}
module.exports = $7239bf2cb5317263$var$getNative;

});
parcelRegister("2fRet", function(module, exports) {

var $2ObcV = parcelRequire("2ObcV");

var $cKa91 = parcelRequire("cKa91");

var $e4HlO = parcelRequire("e4HlO");

var $5oXjd = parcelRequire("5oXjd");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $1a464651bd16844e$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $1a464651bd16844e$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $1a464651bd16844e$var$funcProto = Function.prototype, $1a464651bd16844e$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $1a464651bd16844e$var$funcToString = $1a464651bd16844e$var$funcProto.toString;
/** Used to check objects for own properties. */ var $1a464651bd16844e$var$hasOwnProperty = $1a464651bd16844e$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $1a464651bd16844e$var$reIsNative = RegExp("^" + $1a464651bd16844e$var$funcToString.call($1a464651bd16844e$var$hasOwnProperty).replace($1a464651bd16844e$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $1a464651bd16844e$var$baseIsNative(value) {
    if (!$e4HlO(value) || $cKa91(value)) return false;
    var pattern = $2ObcV(value) ? $1a464651bd16844e$var$reIsNative : $1a464651bd16844e$var$reIsHostCtor;
    return pattern.test($5oXjd(value));
}
module.exports = $1a464651bd16844e$var$baseIsNative;

});
parcelRegister("2ObcV", function(module, exports) {

var $cOq2v = parcelRequire("cOq2v");

var $e4HlO = parcelRequire("e4HlO");
/** `Object#toString` result references. */ var $20b8f1dd381cbe87$var$asyncTag = "[object AsyncFunction]", $20b8f1dd381cbe87$var$funcTag = "[object Function]", $20b8f1dd381cbe87$var$genTag = "[object GeneratorFunction]", $20b8f1dd381cbe87$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $20b8f1dd381cbe87$var$isFunction(value) {
    if (!$e4HlO(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $cOq2v(value);
    return tag == $20b8f1dd381cbe87$var$funcTag || tag == $20b8f1dd381cbe87$var$genTag || tag == $20b8f1dd381cbe87$var$asyncTag || tag == $20b8f1dd381cbe87$var$proxyTag;
}
module.exports = $20b8f1dd381cbe87$var$isFunction;

});
parcelRegister("cOq2v", function(module, exports) {

var $4btfk = parcelRequire("4btfk");

var $fbw34 = parcelRequire("fbw34");

var $amC45 = parcelRequire("amC45");
/** `Object#toString` result references. */ var $953e5a69274a8f6d$var$nullTag = "[object Null]", $953e5a69274a8f6d$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $953e5a69274a8f6d$var$symToStringTag = $4btfk ? $4btfk.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $953e5a69274a8f6d$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $953e5a69274a8f6d$var$undefinedTag : $953e5a69274a8f6d$var$nullTag;
    return $953e5a69274a8f6d$var$symToStringTag && $953e5a69274a8f6d$var$symToStringTag in Object(value) ? $fbw34(value) : $amC45(value);
}
module.exports = $953e5a69274a8f6d$var$baseGetTag;

});
parcelRegister("4btfk", function(module, exports) {

var $cJGSv = parcelRequire("cJGSv");
/** Built-in value references. */ var $30bee03643085e94$var$Symbol = $cJGSv.Symbol;
module.exports = $30bee03643085e94$var$Symbol;

});
parcelRegister("cJGSv", function(module, exports) {

var $i5Mh4 = parcelRequire("i5Mh4");
/** Detect free variable `self`. */ var $945af2ba7076875b$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $945af2ba7076875b$var$root = $i5Mh4 || $945af2ba7076875b$var$freeSelf || Function("return this")();
module.exports = $945af2ba7076875b$var$root;

});
parcelRegister("i5Mh4", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $d2be23e5a2fdb3be$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $d2be23e5a2fdb3be$var$freeGlobal;

});



parcelRegister("fbw34", function(module, exports) {

var $4btfk = parcelRequire("4btfk");
/** Used for built-in method references. */ var $b0e0be3d4847e3a0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b0e0be3d4847e3a0$var$hasOwnProperty = $b0e0be3d4847e3a0$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b0e0be3d4847e3a0$var$nativeObjectToString = $b0e0be3d4847e3a0$var$objectProto.toString;
/** Built-in value references. */ var $b0e0be3d4847e3a0$var$symToStringTag = $4btfk ? $4btfk.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $b0e0be3d4847e3a0$var$getRawTag(value) {
    var isOwn = $b0e0be3d4847e3a0$var$hasOwnProperty.call(value, $b0e0be3d4847e3a0$var$symToStringTag), tag = value[$b0e0be3d4847e3a0$var$symToStringTag];
    try {
        value[$b0e0be3d4847e3a0$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $b0e0be3d4847e3a0$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$b0e0be3d4847e3a0$var$symToStringTag] = tag;
        else delete value[$b0e0be3d4847e3a0$var$symToStringTag];
    }
    return result;
}
module.exports = $b0e0be3d4847e3a0$var$getRawTag;

});

parcelRegister("amC45", function(module, exports) {
/** Used for built-in method references. */ var $78b97c56aff342cc$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $78b97c56aff342cc$var$nativeObjectToString = $78b97c56aff342cc$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $78b97c56aff342cc$var$objectToString(value) {
    return $78b97c56aff342cc$var$nativeObjectToString.call(value);
}
module.exports = $78b97c56aff342cc$var$objectToString;

});


parcelRegister("e4HlO", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $a3f310f54c06274b$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $a3f310f54c06274b$var$isObject;

});


parcelRegister("cKa91", function(module, exports) {

var $7ZykF = parcelRequire("7ZykF");
/** Used to detect methods masquerading as native. */ var $9471a66d256c10c8$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($7ZykF && $7ZykF.keys && $7ZykF.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $9471a66d256c10c8$var$isMasked(func) {
    return !!$9471a66d256c10c8$var$maskSrcKey && $9471a66d256c10c8$var$maskSrcKey in func;
}
module.exports = $9471a66d256c10c8$var$isMasked;

});
parcelRegister("7ZykF", function(module, exports) {

var $cJGSv = parcelRequire("cJGSv");
/** Used to detect overreaching core-js shims. */ var $5d18dc9e241077d3$var$coreJsData = $cJGSv["__core-js_shared__"];
module.exports = $5d18dc9e241077d3$var$coreJsData;

});


parcelRegister("5oXjd", function(module, exports) {
/** Used for built-in method references. */ var $3eed332edb5460ab$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $3eed332edb5460ab$var$funcToString = $3eed332edb5460ab$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $3eed332edb5460ab$var$toSource(func) {
    if (func != null) {
        try {
            return $3eed332edb5460ab$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $3eed332edb5460ab$var$toSource;

});


parcelRegister("4aEXc", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $3097dd2947b68257$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $3097dd2947b68257$var$getValue;

});



parcelRegister("kekVz", function(module, exports) {

var $f3oMr = parcelRequire("f3oMr");

var $9w52i = parcelRequire("9w52i");

var $7nCA5 = parcelRequire("7nCA5");

var $8MYRl = parcelRequire("8MYRl");

var $elbT0 = parcelRequire("elbT0");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $eba55936bdfe2d60$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$eba55936bdfe2d60$var$MapCache.prototype.clear = $f3oMr;
$eba55936bdfe2d60$var$MapCache.prototype["delete"] = $9w52i;
$eba55936bdfe2d60$var$MapCache.prototype.get = $7nCA5;
$eba55936bdfe2d60$var$MapCache.prototype.has = $8MYRl;
$eba55936bdfe2d60$var$MapCache.prototype.set = $elbT0;
module.exports = $eba55936bdfe2d60$var$MapCache;

});
parcelRegister("f3oMr", function(module, exports) {

var $4N0LH = parcelRequire("4N0LH");

var $5bwrM = parcelRequire("5bwrM");

var $kpFsf = parcelRequire("kpFsf");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $af5a5ba9bf70e002$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $4N0LH,
        "map": new ($kpFsf || $5bwrM),
        "string": new $4N0LH
    };
}
module.exports = $af5a5ba9bf70e002$var$mapCacheClear;

});
parcelRegister("4N0LH", function(module, exports) {

var $2K4AI = parcelRequire("2K4AI");

var $fMxt9 = parcelRequire("fMxt9");

var $jtbab = parcelRequire("jtbab");

var $bQMGX = parcelRequire("bQMGX");

var $3CFVH = parcelRequire("3CFVH");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $37cc5594a50bda04$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$37cc5594a50bda04$var$Hash.prototype.clear = $2K4AI;
$37cc5594a50bda04$var$Hash.prototype["delete"] = $fMxt9;
$37cc5594a50bda04$var$Hash.prototype.get = $jtbab;
$37cc5594a50bda04$var$Hash.prototype.has = $bQMGX;
$37cc5594a50bda04$var$Hash.prototype.set = $3CFVH;
module.exports = $37cc5594a50bda04$var$Hash;

});
parcelRegister("2K4AI", function(module, exports) {

var $guCrh = parcelRequire("guCrh");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $1ff3705be098df48$var$hashClear() {
    this.__data__ = $guCrh ? $guCrh(null) : {};
    this.size = 0;
}
module.exports = $1ff3705be098df48$var$hashClear;

});
parcelRegister("guCrh", function(module, exports) {

var $9O1f3 = parcelRequire("9O1f3");
/* Built-in method references that are verified to be native. */ var $c01d43dbf53f94c2$var$nativeCreate = $9O1f3(Object, "create");
module.exports = $c01d43dbf53f94c2$var$nativeCreate;

});


parcelRegister("fMxt9", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b7d54d008044c2ae$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $b7d54d008044c2ae$var$hashDelete;

});

parcelRegister("jtbab", function(module, exports) {

var $guCrh = parcelRequire("guCrh");
/** Used to stand-in for `undefined` hash values. */ var $e2c9628955b5d187$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $e2c9628955b5d187$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e2c9628955b5d187$var$hasOwnProperty = $e2c9628955b5d187$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e2c9628955b5d187$var$hashGet(key) {
    var data = this.__data__;
    if ($guCrh) {
        var result = data[key];
        return result === $e2c9628955b5d187$var$HASH_UNDEFINED ? undefined : result;
    }
    return $e2c9628955b5d187$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $e2c9628955b5d187$var$hashGet;

});

parcelRegister("bQMGX", function(module, exports) {

var $guCrh = parcelRequire("guCrh");
/** Used for built-in method references. */ var $8a0a52402ec8bf0d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8a0a52402ec8bf0d$var$hasOwnProperty = $8a0a52402ec8bf0d$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8a0a52402ec8bf0d$var$hashHas(key) {
    var data = this.__data__;
    return $guCrh ? data[key] !== undefined : $8a0a52402ec8bf0d$var$hasOwnProperty.call(data, key);
}
module.exports = $8a0a52402ec8bf0d$var$hashHas;

});

parcelRegister("3CFVH", function(module, exports) {

var $guCrh = parcelRequire("guCrh");
/** Used to stand-in for `undefined` hash values. */ var $2a357215896f3611$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $2a357215896f3611$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $guCrh && value === undefined ? $2a357215896f3611$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $2a357215896f3611$var$hashSet;

});



parcelRegister("9w52i", function(module, exports) {

var $66oZ2 = parcelRequire("66oZ2");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6edb0243d1d00ccf$var$mapCacheDelete(key) {
    var result = $66oZ2(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $6edb0243d1d00ccf$var$mapCacheDelete;

});
parcelRegister("66oZ2", function(module, exports) {

var $jdf0Y = parcelRequire("jdf0Y");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $4716aed6aa7162ba$var$getMapData(map, key) {
    var data = map.__data__;
    return $jdf0Y(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $4716aed6aa7162ba$var$getMapData;

});
parcelRegister("jdf0Y", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $dfcae0cf3fc90456$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $dfcae0cf3fc90456$var$isKeyable;

});



parcelRegister("7nCA5", function(module, exports) {

var $66oZ2 = parcelRequire("66oZ2");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $55f89bc7d5b79c06$var$mapCacheGet(key) {
    return $66oZ2(this, key).get(key);
}
module.exports = $55f89bc7d5b79c06$var$mapCacheGet;

});

parcelRegister("8MYRl", function(module, exports) {

var $66oZ2 = parcelRequire("66oZ2");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $666203d15d4c6154$var$mapCacheHas(key) {
    return $66oZ2(this, key).has(key);
}
module.exports = $666203d15d4c6154$var$mapCacheHas;

});

parcelRegister("elbT0", function(module, exports) {

var $66oZ2 = parcelRequire("66oZ2");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $a70c3f32a76d9cd1$var$mapCacheSet(key, value) {
    var data = $66oZ2(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $a70c3f32a76d9cd1$var$mapCacheSet;

});




parcelRegister("fUeeu", function(module, exports) {

var $Bkh6K = parcelRequire("Bkh6K");

var $k3K0i = parcelRequire("k3K0i");

var $erszz = parcelRequire("erszz");
/** Used to compose bitmasks for value comparisons. */ var $b9472047e72d053a$var$COMPARE_PARTIAL_FLAG = 1, $b9472047e72d053a$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $b9472047e72d053a$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $b9472047e72d053a$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $b9472047e72d053a$var$COMPARE_UNORDERED_FLAG ? new $Bkh6K : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$k3K0i(other, function(othValue, othIndex) {
                if (!$erszz(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $b9472047e72d053a$var$equalArrays;

});
parcelRegister("Bkh6K", function(module, exports) {

var $kekVz = parcelRequire("kekVz");

var $6eBJe = parcelRequire("6eBJe");

var $kxRUG = parcelRequire("kxRUG");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $07032efee1b42a30$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $kekVz;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$07032efee1b42a30$var$SetCache.prototype.add = $07032efee1b42a30$var$SetCache.prototype.push = $6eBJe;
$07032efee1b42a30$var$SetCache.prototype.has = $kxRUG;
module.exports = $07032efee1b42a30$var$SetCache;

});
parcelRegister("6eBJe", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $48a150fa0b493574$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $48a150fa0b493574$var$setCacheAdd(value) {
    this.__data__.set(value, $48a150fa0b493574$var$HASH_UNDEFINED);
    return this;
}
module.exports = $48a150fa0b493574$var$setCacheAdd;

});

parcelRegister("kxRUG", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $ef50b5be366180eb$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $ef50b5be366180eb$var$setCacheHas;

});


parcelRegister("k3K0i", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $e9a7c5da92886705$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $e9a7c5da92886705$var$arraySome;

});

parcelRegister("erszz", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a839c03d71f897b2$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $a839c03d71f897b2$var$cacheHas;

});


parcelRegister("6uYaw", function(module, exports) {

var $4btfk = parcelRequire("4btfk");

var $7jtyp = parcelRequire("7jtyp");

var $kYVBW = parcelRequire("kYVBW");

var $fUeeu = parcelRequire("fUeeu");

var $6WQbY = parcelRequire("6WQbY");

var $gsNp6 = parcelRequire("gsNp6");
/** Used to compose bitmasks for value comparisons. */ var $4bb437acfd6df7d3$var$COMPARE_PARTIAL_FLAG = 1, $4bb437acfd6df7d3$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $4bb437acfd6df7d3$var$boolTag = "[object Boolean]", $4bb437acfd6df7d3$var$dateTag = "[object Date]", $4bb437acfd6df7d3$var$errorTag = "[object Error]", $4bb437acfd6df7d3$var$mapTag = "[object Map]", $4bb437acfd6df7d3$var$numberTag = "[object Number]", $4bb437acfd6df7d3$var$regexpTag = "[object RegExp]", $4bb437acfd6df7d3$var$setTag = "[object Set]", $4bb437acfd6df7d3$var$stringTag = "[object String]", $4bb437acfd6df7d3$var$symbolTag = "[object Symbol]";
var $4bb437acfd6df7d3$var$arrayBufferTag = "[object ArrayBuffer]", $4bb437acfd6df7d3$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $4bb437acfd6df7d3$var$symbolProto = $4btfk ? $4btfk.prototype : undefined, $4bb437acfd6df7d3$var$symbolValueOf = $4bb437acfd6df7d3$var$symbolProto ? $4bb437acfd6df7d3$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $4bb437acfd6df7d3$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $4bb437acfd6df7d3$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $4bb437acfd6df7d3$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $7jtyp(object), new $7jtyp(other))) return false;
            return true;
        case $4bb437acfd6df7d3$var$boolTag:
        case $4bb437acfd6df7d3$var$dateTag:
        case $4bb437acfd6df7d3$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $kYVBW(+object, +other);
        case $4bb437acfd6df7d3$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $4bb437acfd6df7d3$var$regexpTag:
        case $4bb437acfd6df7d3$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $4bb437acfd6df7d3$var$mapTag:
            var convert = $6WQbY;
        case $4bb437acfd6df7d3$var$setTag:
            var isPartial = bitmask & $4bb437acfd6df7d3$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $gsNp6);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $4bb437acfd6df7d3$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $fUeeu(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $4bb437acfd6df7d3$var$symbolTag:
            if ($4bb437acfd6df7d3$var$symbolValueOf) return $4bb437acfd6df7d3$var$symbolValueOf.call(object) == $4bb437acfd6df7d3$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $4bb437acfd6df7d3$var$equalByTag;

});
parcelRegister("7jtyp", function(module, exports) {

var $cJGSv = parcelRequire("cJGSv");
/** Built-in value references. */ var $55313b957061afbf$var$Uint8Array = $cJGSv.Uint8Array;
module.exports = $55313b957061afbf$var$Uint8Array;

});

parcelRegister("6WQbY", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $50f0a51ba99a7598$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $50f0a51ba99a7598$var$mapToArray;

});

parcelRegister("gsNp6", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $bfc595733a461cbc$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $bfc595733a461cbc$var$setToArray;

});


parcelRegister("8MeZI", function(module, exports) {

var $HVyr8 = parcelRequire("HVyr8");
/** Used to compose bitmasks for value comparisons. */ var $663e70008af42a9c$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $663e70008af42a9c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $663e70008af42a9c$var$hasOwnProperty = $663e70008af42a9c$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $663e70008af42a9c$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $663e70008af42a9c$var$COMPARE_PARTIAL_FLAG, objProps = $HVyr8(object), objLength = objProps.length, othProps = $HVyr8(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $663e70008af42a9c$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $663e70008af42a9c$var$equalObjects;

});
parcelRegister("HVyr8", function(module, exports) {

var $lJBCD = parcelRequire("lJBCD");

var $aTaNu = parcelRequire("aTaNu");

var $8Tm1R = parcelRequire("8Tm1R");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $0840a960b8bb6e24$var$getAllKeys(object) {
    return $lJBCD(object, $8Tm1R, $aTaNu);
}
module.exports = $0840a960b8bb6e24$var$getAllKeys;

});
parcelRegister("lJBCD", function(module, exports) {

var $4jeh9 = parcelRequire("4jeh9");

var $hVwEW = parcelRequire("hVwEW");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $fd2afbec467b26ac$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $hVwEW(object) ? result : $4jeh9(result, symbolsFunc(object));
}
module.exports = $fd2afbec467b26ac$var$baseGetAllKeys;

});
parcelRegister("4jeh9", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $323402976abbf43c$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $323402976abbf43c$var$arrayPush;

});

parcelRegister("hVwEW", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $d0d117fd96cd52bf$var$isArray = Array.isArray;
module.exports = $d0d117fd96cd52bf$var$isArray;

});


parcelRegister("aTaNu", function(module, exports) {

var $9pnJu = parcelRequire("9pnJu");

var $erjea = parcelRequire("erjea");
/** Used for built-in method references. */ var $7ed76a88e56e36eb$var$objectProto = Object.prototype;
/** Built-in value references. */ var $7ed76a88e56e36eb$var$propertyIsEnumerable = $7ed76a88e56e36eb$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7ed76a88e56e36eb$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $7ed76a88e56e36eb$var$getSymbols = !$7ed76a88e56e36eb$var$nativeGetSymbols ? $erjea : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $9pnJu($7ed76a88e56e36eb$var$nativeGetSymbols(object), function(symbol) {
        return $7ed76a88e56e36eb$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $7ed76a88e56e36eb$var$getSymbols;

});
parcelRegister("9pnJu", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6d98dbae82f68add$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $6d98dbae82f68add$var$arrayFilter;

});

parcelRegister("erjea", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $a83280780c41b306$var$stubArray() {
    return [];
}
module.exports = $a83280780c41b306$var$stubArray;

});


parcelRegister("8Tm1R", function(module, exports) {

var $gGS2i = parcelRequire("gGS2i");

var $hQdh7 = parcelRequire("hQdh7");

var $94r8E = parcelRequire("94r8E");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $67948c43049f1868$var$keys(object) {
    return $94r8E(object) ? $gGS2i(object) : $hQdh7(object);
}
module.exports = $67948c43049f1868$var$keys;

});
parcelRegister("gGS2i", function(module, exports) {

var $lwjOg = parcelRequire("lwjOg");

var $hnI0l = parcelRequire("hnI0l");

var $hVwEW = parcelRequire("hVwEW");

var $iIOJg = parcelRequire("iIOJg");

var $hlO9Y = parcelRequire("hlO9Y");

var $3fKiX = parcelRequire("3fKiX");
/** Used for built-in method references. */ var $c26a7c0414b0a058$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c26a7c0414b0a058$var$hasOwnProperty = $c26a7c0414b0a058$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $c26a7c0414b0a058$var$arrayLikeKeys(value, inherited) {
    var isArr = $hVwEW(value), isArg = !isArr && $hnI0l(value), isBuff = !isArr && !isArg && $iIOJg(value), isType = !isArr && !isArg && !isBuff && $3fKiX(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $lwjOg(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $c26a7c0414b0a058$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $hlO9Y(key, length)))) result.push(key);
    return result;
}
module.exports = $c26a7c0414b0a058$var$arrayLikeKeys;

});
parcelRegister("lwjOg", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $faabf3e7e7c994c0$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $faabf3e7e7c994c0$var$baseTimes;

});

parcelRegister("hnI0l", function(module, exports) {

var $bB5NH = parcelRequire("bB5NH");

var $3MU3q = parcelRequire("3MU3q");
/** Used for built-in method references. */ var $ca76b80bfaff4ee8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ca76b80bfaff4ee8$var$hasOwnProperty = $ca76b80bfaff4ee8$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $ca76b80bfaff4ee8$var$propertyIsEnumerable = $ca76b80bfaff4ee8$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $ca76b80bfaff4ee8$var$isArguments = $bB5NH(function() {
    return arguments;
}()) ? $bB5NH : function(value) {
    return $3MU3q(value) && $ca76b80bfaff4ee8$var$hasOwnProperty.call(value, "callee") && !$ca76b80bfaff4ee8$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $ca76b80bfaff4ee8$var$isArguments;

});
parcelRegister("bB5NH", function(module, exports) {

var $cOq2v = parcelRequire("cOq2v");

var $3MU3q = parcelRequire("3MU3q");
/** `Object#toString` result references. */ var $8717a64e0495ffa0$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $8717a64e0495ffa0$var$baseIsArguments(value) {
    return $3MU3q(value) && $cOq2v(value) == $8717a64e0495ffa0$var$argsTag;
}
module.exports = $8717a64e0495ffa0$var$baseIsArguments;

});
parcelRegister("3MU3q", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $2c215601c244dbd0$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $2c215601c244dbd0$var$isObjectLike;

});



parcelRegister("iIOJg", function(module, exports) {

var $cJGSv = parcelRequire("cJGSv");

var $hxmPr = parcelRequire("hxmPr");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $cJGSv.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $hxmPr;
module.exports = isBuffer;

});
parcelRegister("hxmPr", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $cc473a0b8ba7add5$var$stubFalse() {
    return false;
}
module.exports = $cc473a0b8ba7add5$var$stubFalse;

});


parcelRegister("hlO9Y", function(module, exports) {
/** Used as references for various `Number` constants. */ var $ca1b4e8367836290$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $ca1b4e8367836290$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $ca1b4e8367836290$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $ca1b4e8367836290$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $ca1b4e8367836290$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $ca1b4e8367836290$var$isIndex;

});

parcelRegister("3fKiX", function(module, exports) {

var $j0ISX = parcelRequire("j0ISX");

var $2kbTI = parcelRequire("2kbTI");

var $aTlV2 = parcelRequire("aTlV2");
/* Node.js helper references. */ var $25e6b0fa2bac88eb$var$nodeIsTypedArray = $aTlV2 && $aTlV2.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $25e6b0fa2bac88eb$var$isTypedArray = $25e6b0fa2bac88eb$var$nodeIsTypedArray ? $2kbTI($25e6b0fa2bac88eb$var$nodeIsTypedArray) : $j0ISX;
module.exports = $25e6b0fa2bac88eb$var$isTypedArray;

});
parcelRegister("j0ISX", function(module, exports) {

var $cOq2v = parcelRequire("cOq2v");

var $5XGjw = parcelRequire("5XGjw");

var $3MU3q = parcelRequire("3MU3q");
/** `Object#toString` result references. */ var $dd70d5b791e30f2d$var$argsTag = "[object Arguments]", $dd70d5b791e30f2d$var$arrayTag = "[object Array]", $dd70d5b791e30f2d$var$boolTag = "[object Boolean]", $dd70d5b791e30f2d$var$dateTag = "[object Date]", $dd70d5b791e30f2d$var$errorTag = "[object Error]", $dd70d5b791e30f2d$var$funcTag = "[object Function]", $dd70d5b791e30f2d$var$mapTag = "[object Map]", $dd70d5b791e30f2d$var$numberTag = "[object Number]", $dd70d5b791e30f2d$var$objectTag = "[object Object]", $dd70d5b791e30f2d$var$regexpTag = "[object RegExp]", $dd70d5b791e30f2d$var$setTag = "[object Set]", $dd70d5b791e30f2d$var$stringTag = "[object String]", $dd70d5b791e30f2d$var$weakMapTag = "[object WeakMap]";
var $dd70d5b791e30f2d$var$arrayBufferTag = "[object ArrayBuffer]", $dd70d5b791e30f2d$var$dataViewTag = "[object DataView]", $dd70d5b791e30f2d$var$float32Tag = "[object Float32Array]", $dd70d5b791e30f2d$var$float64Tag = "[object Float64Array]", $dd70d5b791e30f2d$var$int8Tag = "[object Int8Array]", $dd70d5b791e30f2d$var$int16Tag = "[object Int16Array]", $dd70d5b791e30f2d$var$int32Tag = "[object Int32Array]", $dd70d5b791e30f2d$var$uint8Tag = "[object Uint8Array]", $dd70d5b791e30f2d$var$uint8ClampedTag = "[object Uint8ClampedArray]", $dd70d5b791e30f2d$var$uint16Tag = "[object Uint16Array]", $dd70d5b791e30f2d$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $dd70d5b791e30f2d$var$typedArrayTags = {};
$dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$float32Tag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$float64Tag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$int8Tag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$int16Tag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$int32Tag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$uint8Tag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$uint8ClampedTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$uint16Tag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$uint32Tag] = true;
$dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$argsTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$arrayTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$arrayBufferTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$boolTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$dataViewTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$dateTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$errorTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$funcTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$mapTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$numberTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$objectTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$regexpTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$setTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$stringTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $dd70d5b791e30f2d$var$baseIsTypedArray(value) {
    return $3MU3q(value) && $5XGjw(value.length) && !!$dd70d5b791e30f2d$var$typedArrayTags[$cOq2v(value)];
}
module.exports = $dd70d5b791e30f2d$var$baseIsTypedArray;

});
parcelRegister("5XGjw", function(module, exports) {
/** Used as references for various `Number` constants. */ var $4573491ae9d8c150$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $4573491ae9d8c150$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $4573491ae9d8c150$var$MAX_SAFE_INTEGER;
}
module.exports = $4573491ae9d8c150$var$isLength;

});


parcelRegister("2kbTI", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $1b16ada699dbe19d$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $1b16ada699dbe19d$var$baseUnary;

});

parcelRegister("aTlV2", function(module, exports) {

var $i5Mh4 = parcelRequire("i5Mh4");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $i5Mh4.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("hQdh7", function(module, exports) {

var $8dku9 = parcelRequire("8dku9");

var $cmIyZ = parcelRequire("cmIyZ");
/** Used for built-in method references. */ var $cfd19722e2a15c84$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cfd19722e2a15c84$var$hasOwnProperty = $cfd19722e2a15c84$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $cfd19722e2a15c84$var$baseKeys(object) {
    if (!$8dku9(object)) return $cmIyZ(object);
    var result = [];
    for(var key in Object(object))if ($cfd19722e2a15c84$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $cfd19722e2a15c84$var$baseKeys;

});
parcelRegister("8dku9", function(module, exports) {
/** Used for built-in method references. */ var $5faf6d9199a41458$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $5faf6d9199a41458$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $5faf6d9199a41458$var$objectProto;
    return value === proto;
}
module.exports = $5faf6d9199a41458$var$isPrototype;

});

parcelRegister("cmIyZ", function(module, exports) {

var $goDPq = parcelRequire("goDPq");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $900a1b744e832046$var$nativeKeys = $goDPq(Object.keys, Object);
module.exports = $900a1b744e832046$var$nativeKeys;

});
parcelRegister("goDPq", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $befdc85895490d54$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $befdc85895490d54$var$overArg;

});



parcelRegister("94r8E", function(module, exports) {

var $2ObcV = parcelRequire("2ObcV");

var $5XGjw = parcelRequire("5XGjw");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $69a989ec6219b3aa$var$isArrayLike(value) {
    return value != null && $5XGjw(value.length) && !$2ObcV(value);
}
module.exports = $69a989ec6219b3aa$var$isArrayLike;

});




parcelRegister("aUeNP", function(module, exports) {

var $9omvv = parcelRequire("9omvv");

var $kpFsf = parcelRequire("kpFsf");

var $femYG = parcelRequire("femYG");

var $49Hpk = parcelRequire("49Hpk");

var $dR5iQ = parcelRequire("dR5iQ");

var $cOq2v = parcelRequire("cOq2v");

var $5oXjd = parcelRequire("5oXjd");
/** `Object#toString` result references. */ var $7f0a9dd6e661847d$var$mapTag = "[object Map]", $7f0a9dd6e661847d$var$objectTag = "[object Object]", $7f0a9dd6e661847d$var$promiseTag = "[object Promise]", $7f0a9dd6e661847d$var$setTag = "[object Set]", $7f0a9dd6e661847d$var$weakMapTag = "[object WeakMap]";
var $7f0a9dd6e661847d$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $7f0a9dd6e661847d$var$dataViewCtorString = $5oXjd($9omvv), $7f0a9dd6e661847d$var$mapCtorString = $5oXjd($kpFsf), $7f0a9dd6e661847d$var$promiseCtorString = $5oXjd($femYG), $7f0a9dd6e661847d$var$setCtorString = $5oXjd($49Hpk), $7f0a9dd6e661847d$var$weakMapCtorString = $5oXjd($dR5iQ);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $7f0a9dd6e661847d$var$getTag = $cOq2v;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($9omvv && $7f0a9dd6e661847d$var$getTag(new $9omvv(new ArrayBuffer(1))) != $7f0a9dd6e661847d$var$dataViewTag || $kpFsf && $7f0a9dd6e661847d$var$getTag(new $kpFsf) != $7f0a9dd6e661847d$var$mapTag || $femYG && $7f0a9dd6e661847d$var$getTag($femYG.resolve()) != $7f0a9dd6e661847d$var$promiseTag || $49Hpk && $7f0a9dd6e661847d$var$getTag(new $49Hpk) != $7f0a9dd6e661847d$var$setTag || $dR5iQ && $7f0a9dd6e661847d$var$getTag(new $dR5iQ) != $7f0a9dd6e661847d$var$weakMapTag) $7f0a9dd6e661847d$var$getTag = function(value) {
    var result = $cOq2v(value), Ctor = result == $7f0a9dd6e661847d$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $5oXjd(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $7f0a9dd6e661847d$var$dataViewCtorString:
            return $7f0a9dd6e661847d$var$dataViewTag;
        case $7f0a9dd6e661847d$var$mapCtorString:
            return $7f0a9dd6e661847d$var$mapTag;
        case $7f0a9dd6e661847d$var$promiseCtorString:
            return $7f0a9dd6e661847d$var$promiseTag;
        case $7f0a9dd6e661847d$var$setCtorString:
            return $7f0a9dd6e661847d$var$setTag;
        case $7f0a9dd6e661847d$var$weakMapCtorString:
            return $7f0a9dd6e661847d$var$weakMapTag;
    }
    return result;
};
module.exports = $7f0a9dd6e661847d$var$getTag;

});
parcelRegister("9omvv", function(module, exports) {

var $9O1f3 = parcelRequire("9O1f3");

var $cJGSv = parcelRequire("cJGSv");
/* Built-in method references that are verified to be native. */ var $6d67d069615522ef$var$DataView = $9O1f3($cJGSv, "DataView");
module.exports = $6d67d069615522ef$var$DataView;

});

parcelRegister("femYG", function(module, exports) {

var $9O1f3 = parcelRequire("9O1f3");

var $cJGSv = parcelRequire("cJGSv");
/* Built-in method references that are verified to be native. */ var $b169fcba1df6e015$var$Promise = $9O1f3($cJGSv, "Promise");
module.exports = $b169fcba1df6e015$var$Promise;

});

parcelRegister("49Hpk", function(module, exports) {

var $9O1f3 = parcelRequire("9O1f3");

var $cJGSv = parcelRequire("cJGSv");
/* Built-in method references that are verified to be native. */ var $3069ac7e0d04a756$var$Set = $9O1f3($cJGSv, "Set");
module.exports = $3069ac7e0d04a756$var$Set;

});

parcelRegister("dR5iQ", function(module, exports) {

var $9O1f3 = parcelRequire("9O1f3");

var $cJGSv = parcelRequire("cJGSv");
/* Built-in method references that are verified to be native. */ var $a16456a49992e222$var$WeakMap = $9O1f3($cJGSv, "WeakMap");
module.exports = $a16456a49992e222$var$WeakMap;

});





parcelRegister("eKkfN", function(module, exports) {

var $1SQen = parcelRequire("1SQen");

var $83lTV = parcelRequire("83lTV");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $abc5128b165396e3$var$keyBy = $83lTV(function(result, value, key) {
    $1SQen(result, key, value);
});
module.exports = $abc5128b165396e3$var$keyBy;

});
parcelRegister("1SQen", function(module, exports) {

var $5gcad = parcelRequire("5gcad");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $15f35991481f19c4$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $5gcad) $5gcad(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = $15f35991481f19c4$var$baseAssignValue;

});
parcelRegister("5gcad", function(module, exports) {

var $9O1f3 = parcelRequire("9O1f3");
var $3d47e1d21a965796$var$defineProperty = function() {
    try {
        var func = $9O1f3(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $3d47e1d21a965796$var$defineProperty;

});


parcelRegister("83lTV", function(module, exports) {

var $85COX = parcelRequire("85COX");

var $gqGWB = parcelRequire("gqGWB");

var $kTyAU = parcelRequire("kTyAU");

var $hVwEW = parcelRequire("hVwEW");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $5dcf979e5a639cea$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $hVwEW(collection) ? $85COX : $gqGWB, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $kTyAU(iteratee, 2), accumulator);
    };
}
module.exports = $5dcf979e5a639cea$var$createAggregator;

});
parcelRegister("85COX", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $5e3ce75e288faa12$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $5e3ce75e288faa12$var$arrayAggregator;

});

parcelRegister("gqGWB", function(module, exports) {

var $NPR53 = parcelRequire("NPR53");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $bf6062e3813b1911$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $NPR53(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $bf6062e3813b1911$var$baseAggregator;

});
parcelRegister("NPR53", function(module, exports) {

var $aHH9J = parcelRequire("aHH9J");

var $i5HG0 = parcelRequire("i5HG0");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $095ccd115503a6f3$var$baseEach = $i5HG0($aHH9J);
module.exports = $095ccd115503a6f3$var$baseEach;

});
parcelRegister("aHH9J", function(module, exports) {

var $lC9tT = parcelRequire("lC9tT");

var $8Tm1R = parcelRequire("8Tm1R");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $7caf656595371b57$var$baseForOwn(object, iteratee) {
    return object && $lC9tT(object, iteratee, $8Tm1R);
}
module.exports = $7caf656595371b57$var$baseForOwn;

});
parcelRegister("lC9tT", function(module, exports) {

var $6EM9o = parcelRequire("6EM9o");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $fbc4805485bb447f$var$baseFor = $6EM9o();
module.exports = $fbc4805485bb447f$var$baseFor;

});
parcelRegister("6EM9o", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $4d8bd42a602d7b47$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $4d8bd42a602d7b47$var$createBaseFor;

});



parcelRegister("i5HG0", function(module, exports) {

var $94r8E = parcelRequire("94r8E");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $d2ba92de5f6d794f$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$94r8E(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $d2ba92de5f6d794f$var$createBaseEach;

});



parcelRegister("kTyAU", function(module, exports) {

var $8z59r = parcelRequire("8z59r");

var $excbA = parcelRequire("excbA");

var $19t6w = parcelRequire("19t6w");

var $hVwEW = parcelRequire("hVwEW");

var $ihasg = parcelRequire("ihasg");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $f363c76e5dadb889$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $19t6w;
    if (typeof value == "object") return $hVwEW(value) ? $excbA(value[0], value[1]) : $8z59r(value);
    return $ihasg(value);
}
module.exports = $f363c76e5dadb889$var$baseIteratee;

});
parcelRegister("8z59r", function(module, exports) {

var $cQAfb = parcelRequire("cQAfb");

var $2QN7m = parcelRequire("2QN7m");

var $lHAUi = parcelRequire("lHAUi");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $63c596881b4a931b$var$baseMatches(source) {
    var matchData = $2QN7m(source);
    if (matchData.length == 1 && matchData[0][2]) return $lHAUi(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $cQAfb(object, source, matchData);
    };
}
module.exports = $63c596881b4a931b$var$baseMatches;

});
parcelRegister("cQAfb", function(module, exports) {

var $h0DYD = parcelRequire("h0DYD");

var $17m4Y = parcelRequire("17m4Y");
/** Used to compose bitmasks for value comparisons. */ var $95a674ab41e00922$var$COMPARE_PARTIAL_FLAG = 1, $95a674ab41e00922$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $95a674ab41e00922$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $h0DYD;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $17m4Y(srcValue, objValue, $95a674ab41e00922$var$COMPARE_PARTIAL_FLAG | $95a674ab41e00922$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $95a674ab41e00922$var$baseIsMatch;

});

parcelRegister("2QN7m", function(module, exports) {

var $bsRMf = parcelRequire("bsRMf");

var $8Tm1R = parcelRequire("8Tm1R");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $213689da4e1ee288$var$getMatchData(object) {
    var result = $8Tm1R(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $bsRMf(value)
        ];
    }
    return result;
}
module.exports = $213689da4e1ee288$var$getMatchData;

});
parcelRegister("bsRMf", function(module, exports) {

var $e4HlO = parcelRequire("e4HlO");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $858c06417b460a11$var$isStrictComparable(value) {
    return value === value && !$e4HlO(value);
}
module.exports = $858c06417b460a11$var$isStrictComparable;

});


parcelRegister("lHAUi", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $fcca3e1b08cf515c$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $fcca3e1b08cf515c$var$matchesStrictComparable;

});


parcelRegister("excbA", function(module, exports) {

var $17m4Y = parcelRequire("17m4Y");

var $PC5QH = parcelRequire("PC5QH");

var $h1LbN = parcelRequire("h1LbN");

var $5guOp = parcelRequire("5guOp");

var $bsRMf = parcelRequire("bsRMf");

var $lHAUi = parcelRequire("lHAUi");

var $bT5XG = parcelRequire("bT5XG");
/** Used to compose bitmasks for value comparisons. */ var $a94d999cadf3ccaa$var$COMPARE_PARTIAL_FLAG = 1, $a94d999cadf3ccaa$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $a94d999cadf3ccaa$var$baseMatchesProperty(path, srcValue) {
    if ($5guOp(path) && $bsRMf(srcValue)) return $lHAUi($bT5XG(path), srcValue);
    return function(object) {
        var objValue = $PC5QH(object, path);
        return objValue === undefined && objValue === srcValue ? $h1LbN(object, path) : $17m4Y(srcValue, objValue, $a94d999cadf3ccaa$var$COMPARE_PARTIAL_FLAG | $a94d999cadf3ccaa$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $a94d999cadf3ccaa$var$baseMatchesProperty;

});
parcelRegister("PC5QH", function(module, exports) {

var $krRFz = parcelRequire("krRFz");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $09b25013fd512c15$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $krRFz(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $09b25013fd512c15$var$get;

});
parcelRegister("krRFz", function(module, exports) {

var $6hGcP = parcelRequire("6hGcP");

var $bT5XG = parcelRequire("bT5XG");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $ee2ff5e4f203d45b$var$baseGet(object, path) {
    path = $6hGcP(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$bT5XG(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $ee2ff5e4f203d45b$var$baseGet;

});
parcelRegister("6hGcP", function(module, exports) {

var $hVwEW = parcelRequire("hVwEW");

var $5guOp = parcelRequire("5guOp");

var $4fM1S = parcelRequire("4fM1S");

var $62oCn = parcelRequire("62oCn");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $493511d2cb512e68$var$castPath(value, object) {
    if ($hVwEW(value)) return value;
    return $5guOp(value, object) ? [
        value
    ] : $4fM1S($62oCn(value));
}
module.exports = $493511d2cb512e68$var$castPath;

});
parcelRegister("5guOp", function(module, exports) {

var $hVwEW = parcelRequire("hVwEW");

var $6eEhe = parcelRequire("6eEhe");
/** Used to match property names within property paths. */ var $3d565903f56e0b5d$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $3d565903f56e0b5d$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $3d565903f56e0b5d$var$isKey(value, object) {
    if ($hVwEW(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $6eEhe(value)) return true;
    return $3d565903f56e0b5d$var$reIsPlainProp.test(value) || !$3d565903f56e0b5d$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $3d565903f56e0b5d$var$isKey;

});
parcelRegister("6eEhe", function(module, exports) {

var $cOq2v = parcelRequire("cOq2v");

var $3MU3q = parcelRequire("3MU3q");
/** `Object#toString` result references. */ var $48a34b0e52848244$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $48a34b0e52848244$var$isSymbol(value) {
    return typeof value == "symbol" || $3MU3q(value) && $cOq2v(value) == $48a34b0e52848244$var$symbolTag;
}
module.exports = $48a34b0e52848244$var$isSymbol;

});


parcelRegister("4fM1S", function(module, exports) {

var $gcb0x = parcelRequire("gcb0x");
/** Used to match property names within property paths. */ var $318dd1c33e26f88f$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $318dd1c33e26f88f$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $318dd1c33e26f88f$var$stringToPath = $gcb0x(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($318dd1c33e26f88f$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($318dd1c33e26f88f$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $318dd1c33e26f88f$var$stringToPath;

});
parcelRegister("gcb0x", function(module, exports) {

var $1cBPh = parcelRequire("1cBPh");
/** Used as the maximum memoize cache size. */ var $bca64e3c57a777c2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $bca64e3c57a777c2$var$memoizeCapped(func) {
    var result = $1cBPh(func, function(key) {
        if (cache.size === $bca64e3c57a777c2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $bca64e3c57a777c2$var$memoizeCapped;

});
parcelRegister("1cBPh", function(module, exports) {

var $kekVz = parcelRequire("kekVz");
/** Error message constants. */ var $0e0440e81aa01ca2$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $0e0440e81aa01ca2$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($0e0440e81aa01ca2$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($0e0440e81aa01ca2$var$memoize.Cache || $kekVz);
    return memoized;
}
// Expose `MapCache`.
$0e0440e81aa01ca2$var$memoize.Cache = $kekVz;
module.exports = $0e0440e81aa01ca2$var$memoize;

});



parcelRegister("62oCn", function(module, exports) {

var $jkIZf = parcelRequire("jkIZf");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $4656069d2962907d$var$toString(value) {
    return value == null ? "" : $jkIZf(value);
}
module.exports = $4656069d2962907d$var$toString;

});
parcelRegister("jkIZf", function(module, exports) {

var $4btfk = parcelRequire("4btfk");

var $cRGCI = parcelRequire("cRGCI");

var $hVwEW = parcelRequire("hVwEW");

var $6eEhe = parcelRequire("6eEhe");
/** Used as references for various `Number` constants. */ var $e132c809fad01544$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $e132c809fad01544$var$symbolProto = $4btfk ? $4btfk.prototype : undefined, $e132c809fad01544$var$symbolToString = $e132c809fad01544$var$symbolProto ? $e132c809fad01544$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $e132c809fad01544$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($hVwEW(value)) // Recursively convert values (susceptible to call stack limits).
    return $cRGCI(value, $e132c809fad01544$var$baseToString) + "";
    if ($6eEhe(value)) return $e132c809fad01544$var$symbolToString ? $e132c809fad01544$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$e132c809fad01544$var$INFINITY ? "-0" : result;
}
module.exports = $e132c809fad01544$var$baseToString;

});
parcelRegister("cRGCI", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $95db7f6b1a689d75$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $95db7f6b1a689d75$var$arrayMap;

});




parcelRegister("bT5XG", function(module, exports) {

var $6eEhe = parcelRequire("6eEhe");
/** Used as references for various `Number` constants. */ var $8a79749b18a12424$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $8a79749b18a12424$var$toKey(value) {
    if (typeof value == "string" || $6eEhe(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$8a79749b18a12424$var$INFINITY ? "-0" : result;
}
module.exports = $8a79749b18a12424$var$toKey;

});



parcelRegister("h1LbN", function(module, exports) {

var $cnjfS = parcelRequire("cnjfS");

var $jDUbG = parcelRequire("jDUbG");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $c6572275fbec34e3$var$hasIn(object, path) {
    return object != null && $jDUbG(object, path, $cnjfS);
}
module.exports = $c6572275fbec34e3$var$hasIn;

});
parcelRegister("cnjfS", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $902691a9b85b7191$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $902691a9b85b7191$var$baseHasIn;

});

parcelRegister("jDUbG", function(module, exports) {

var $6hGcP = parcelRequire("6hGcP");

var $hnI0l = parcelRequire("hnI0l");

var $hVwEW = parcelRequire("hVwEW");

var $hlO9Y = parcelRequire("hlO9Y");

var $5XGjw = parcelRequire("5XGjw");

var $bT5XG = parcelRequire("bT5XG");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $e4cd3e8514b20db6$var$hasPath(object, path, hasFunc) {
    path = $6hGcP(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $bT5XG(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $5XGjw(length) && $hlO9Y(key, length) && ($hVwEW(object) || $hnI0l(object));
}
module.exports = $e4cd3e8514b20db6$var$hasPath;

});



parcelRegister("19t6w", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $0d6d35347db5b88b$var$identity(value) {
    return value;
}
module.exports = $0d6d35347db5b88b$var$identity;

});

parcelRegister("ihasg", function(module, exports) {

var $8nfve = parcelRequire("8nfve");

var $2YCT4 = parcelRequire("2YCT4");

var $5guOp = parcelRequire("5guOp");

var $bT5XG = parcelRequire("bT5XG");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $d4e1ecabb389b95b$var$property(path) {
    return $5guOp(path) ? $8nfve($bT5XG(path)) : $2YCT4(path);
}
module.exports = $d4e1ecabb389b95b$var$property;

});
parcelRegister("8nfve", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $618c7f3d7c1649bd$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $618c7f3d7c1649bd$var$baseProperty;

});

parcelRegister("2YCT4", function(module, exports) {

var $krRFz = parcelRequire("krRFz");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $22af598ae7b95cce$var$basePropertyDeep(path) {
    return function(object) {
        return $krRFz(object, path);
    };
}
module.exports = $22af598ae7b95cce$var$basePropertyDeep;

});





parcelRegister("lJJrC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $fd310d3f1cf00b48$var$id = 1;
/**
 * generate unique id in application
 * @return {string}
 */ var $fd310d3f1cf00b48$var$_default = function _default() {
    return "".concat($fd310d3f1cf00b48$var$id++);
};
module.exports["default"] = $fd310d3f1cf00b48$var$_default;

});

parcelRegister("b0nUT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $80323f28fabf674a$var$_default = function _default(fn) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
    var timer = null;
    return function() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        clearTimeout(timer);
        timer = setTimeout(function() {
            fn.apply(_this, args);
        }, delay);
    };
};
module.exports["default"] = $80323f28fabf674a$var$_default;

});

parcelRegister("aBwLi", function(module, exports) {
"use strict";

var $1CXFK = parcelRequire("1CXFK");

var $1ATYy = parcelRequire("1ATYy");

var $kyx4g = parcelRequire("kyx4g");

var $4oqry = parcelRequire("4oqry");

var $azOvE = parcelRequire("azOvE");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $7b86c5e8875e8014$var$createInstance(defaultConfig) {
    var context = new $kyx4g(defaultConfig);
    var instance = $1ATYy($kyx4g.prototype.request, context);
    // Copy axios.prototype to instance
    $1CXFK.extend(instance, $kyx4g.prototype, context);
    // Copy context to instance
    $1CXFK.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $7b86c5e8875e8014$var$createInstance($4oqry(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $7b86c5e8875e8014$var$axios = $7b86c5e8875e8014$var$createInstance($azOvE);
// Expose Axios class to allow class inheritance
$7b86c5e8875e8014$var$axios.Axios = $kyx4g;

// Expose Cancel & CancelToken
$7b86c5e8875e8014$var$axios.Cancel = (parcelRequire("dTUuc"));

$7b86c5e8875e8014$var$axios.CancelToken = (parcelRequire("5Kp50"));

$7b86c5e8875e8014$var$axios.isCancel = (parcelRequire("jTdk4"));

$7b86c5e8875e8014$var$axios.VERSION = (parcelRequire("hVO2C")).version;
// Expose all/spread
$7b86c5e8875e8014$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$7b86c5e8875e8014$var$axios.spread = (parcelRequire("id2qT"));

// Expose isAxiosError
$7b86c5e8875e8014$var$axios.isAxiosError = (parcelRequire("dhck8"));
module.exports = $7b86c5e8875e8014$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $7b86c5e8875e8014$var$axios;

});
parcelRegister("1CXFK", function(module, exports) {
"use strict";

var $1ATYy = parcelRequire("1ATYy");
// utils is a library of generic helper functions non-specific to axios
var $12f7a0b72a2c1357$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $12f7a0b72a2c1357$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $12f7a0b72a2c1357$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $12f7a0b72a2c1357$var$isBuffer(val) {
    return val !== null && !$12f7a0b72a2c1357$var$isUndefined(val) && val.constructor !== null && !$12f7a0b72a2c1357$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $12f7a0b72a2c1357$var$isArrayBuffer(val) {
    return $12f7a0b72a2c1357$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $12f7a0b72a2c1357$var$isFormData(val) {
    return $12f7a0b72a2c1357$var$toString.call(val) === "[object FormData]";
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $12f7a0b72a2c1357$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $12f7a0b72a2c1357$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $12f7a0b72a2c1357$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $12f7a0b72a2c1357$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $12f7a0b72a2c1357$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $12f7a0b72a2c1357$var$isPlainObject(val) {
    if ($12f7a0b72a2c1357$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $12f7a0b72a2c1357$var$isDate(val) {
    return $12f7a0b72a2c1357$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $12f7a0b72a2c1357$var$isFile(val) {
    return $12f7a0b72a2c1357$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $12f7a0b72a2c1357$var$isBlob(val) {
    return $12f7a0b72a2c1357$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $12f7a0b72a2c1357$var$isFunction(val) {
    return $12f7a0b72a2c1357$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $12f7a0b72a2c1357$var$isStream(val) {
    return $12f7a0b72a2c1357$var$isObject(val) && $12f7a0b72a2c1357$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $12f7a0b72a2c1357$var$isURLSearchParams(val) {
    return $12f7a0b72a2c1357$var$toString.call(val) === "[object URLSearchParams]";
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $12f7a0b72a2c1357$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $12f7a0b72a2c1357$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $12f7a0b72a2c1357$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($12f7a0b72a2c1357$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $12f7a0b72a2c1357$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($12f7a0b72a2c1357$var$isPlainObject(result[key]) && $12f7a0b72a2c1357$var$isPlainObject(val)) result[key] = $12f7a0b72a2c1357$var$merge(result[key], val);
        else if ($12f7a0b72a2c1357$var$isPlainObject(val)) result[key] = $12f7a0b72a2c1357$var$merge({}, val);
        else if ($12f7a0b72a2c1357$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$12f7a0b72a2c1357$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $12f7a0b72a2c1357$var$extend(a, b, thisArg) {
    $12f7a0b72a2c1357$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $1ATYy(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $12f7a0b72a2c1357$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $12f7a0b72a2c1357$var$isArray,
    isArrayBuffer: $12f7a0b72a2c1357$var$isArrayBuffer,
    isBuffer: $12f7a0b72a2c1357$var$isBuffer,
    isFormData: $12f7a0b72a2c1357$var$isFormData,
    isArrayBufferView: $12f7a0b72a2c1357$var$isArrayBufferView,
    isString: $12f7a0b72a2c1357$var$isString,
    isNumber: $12f7a0b72a2c1357$var$isNumber,
    isObject: $12f7a0b72a2c1357$var$isObject,
    isPlainObject: $12f7a0b72a2c1357$var$isPlainObject,
    isUndefined: $12f7a0b72a2c1357$var$isUndefined,
    isDate: $12f7a0b72a2c1357$var$isDate,
    isFile: $12f7a0b72a2c1357$var$isFile,
    isBlob: $12f7a0b72a2c1357$var$isBlob,
    isFunction: $12f7a0b72a2c1357$var$isFunction,
    isStream: $12f7a0b72a2c1357$var$isStream,
    isURLSearchParams: $12f7a0b72a2c1357$var$isURLSearchParams,
    isStandardBrowserEnv: $12f7a0b72a2c1357$var$isStandardBrowserEnv,
    forEach: $12f7a0b72a2c1357$var$forEach,
    merge: $12f7a0b72a2c1357$var$merge,
    extend: $12f7a0b72a2c1357$var$extend,
    trim: $12f7a0b72a2c1357$var$trim,
    stripBOM: $12f7a0b72a2c1357$var$stripBOM
};

});
parcelRegister("1ATYy", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("kyx4g", function(module, exports) {
"use strict";

var $1CXFK = parcelRequire("1CXFK");

var $jjMyd = parcelRequire("jjMyd");

var $gSNBF = parcelRequire("gSNBF");

var $6Qs0m = parcelRequire("6Qs0m");

var $4oqry = parcelRequire("4oqry");

var $frybV = parcelRequire("frybV");
var $ef70a23721bc3e0c$var$validators = $frybV.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $ef70a23721bc3e0c$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $gSNBF(),
        response: new $gSNBF()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $ef70a23721bc3e0c$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    if (!config.url) throw new Error("Provided config url is not valid");
    config = $4oqry(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $frybV.assertOptions(transitional, {
        silentJSONParsing: $ef70a23721bc3e0c$var$validators.transitional($ef70a23721bc3e0c$var$validators.boolean),
        forcedJSONParsing: $ef70a23721bc3e0c$var$validators.transitional($ef70a23721bc3e0c$var$validators.boolean),
        clarifyTimeoutError: $ef70a23721bc3e0c$var$validators.transitional($ef70a23721bc3e0c$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $6Qs0m,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $6Qs0m(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$ef70a23721bc3e0c$var$Axios.prototype.getUri = function getUri(config) {
    if (!config.url) throw new Error("Provided config url is not valid");
    config = $4oqry(this.defaults, config);
    return $jjMyd(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$1CXFK.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $ef70a23721bc3e0c$var$Axios.prototype[method] = function(url, config) {
        return this.request($4oqry(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$1CXFK.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $ef70a23721bc3e0c$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($4oqry(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $ef70a23721bc3e0c$var$Axios;

});
parcelRegister("jjMyd", function(module, exports) {
"use strict";

var $1CXFK = parcelRequire("1CXFK");
function $e10573da251b51e8$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($1CXFK.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $1CXFK.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($1CXFK.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $1CXFK.forEach(val, function parseValue(v) {
                if ($1CXFK.isDate(v)) v = v.toISOString();
                else if ($1CXFK.isObject(v)) v = JSON.stringify(v);
                parts.push($e10573da251b51e8$var$encode(key) + "=" + $e10573da251b51e8$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("gSNBF", function(module, exports) {
"use strict";

var $1CXFK = parcelRequire("1CXFK");
function $c4a82b4f9efbda3e$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $c4a82b4f9efbda3e$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $c4a82b4f9efbda3e$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $c4a82b4f9efbda3e$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $1CXFK.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $c4a82b4f9efbda3e$var$InterceptorManager;

});

parcelRegister("6Qs0m", function(module, exports) {
"use strict";

var $1CXFK = parcelRequire("1CXFK");

var $gQYaB = parcelRequire("gQYaB");

var $jTdk4 = parcelRequire("jTdk4");

var $azOvE = parcelRequire("azOvE");

var $dTUuc = parcelRequire("dTUuc");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $4fbd52988827b1fd$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $dTUuc("canceled");
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $4fbd52988827b1fd$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $gQYaB.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $1CXFK.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $1CXFK.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $azOvE.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $4fbd52988827b1fd$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $gQYaB.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$jTdk4(reason)) {
            $4fbd52988827b1fd$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $gQYaB.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("gQYaB", function(module, exports) {
"use strict";

var $1CXFK = parcelRequire("1CXFK");

var $azOvE = parcelRequire("azOvE");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $azOvE;
    /*eslint no-param-reassign:0*/ $1CXFK.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("azOvE", function(module, exports) {

var $kuzpm = parcelRequire("kuzpm");
"use strict";

var $1CXFK = parcelRequire("1CXFK");

var $kj4t5 = parcelRequire("kj4t5");

var $2G1oX = parcelRequire("2G1oX");
var $7b345a63e52f4594$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $7b345a63e52f4594$var$setContentTypeIfUnset(headers, value) {
    if (!$1CXFK.isUndefined(headers) && $1CXFK.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $7b345a63e52f4594$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("1DRzM"));
    else if (typeof $kuzpm !== "undefined" && Object.prototype.toString.call($kuzpm) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("1DRzM"));
    return adapter;
}
function $7b345a63e52f4594$var$stringifySafely(rawValue, parser, encoder) {
    if ($1CXFK.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $1CXFK.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $7b345a63e52f4594$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $7b345a63e52f4594$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $kj4t5(headers, "Accept");
            $kj4t5(headers, "Content-Type");
            if ($1CXFK.isFormData(data) || $1CXFK.isArrayBuffer(data) || $1CXFK.isBuffer(data) || $1CXFK.isStream(data) || $1CXFK.isFile(data) || $1CXFK.isBlob(data)) return data;
            if ($1CXFK.isArrayBufferView(data)) return data.buffer;
            if ($1CXFK.isURLSearchParams(data)) {
                $7b345a63e52f4594$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($1CXFK.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $7b345a63e52f4594$var$setContentTypeIfUnset(headers, "application/json");
                return $7b345a63e52f4594$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $7b345a63e52f4594$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $1CXFK.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $2G1oX(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$1CXFK.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $7b345a63e52f4594$var$defaults.headers[method] = {};
});
$1CXFK.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $7b345a63e52f4594$var$defaults.headers[method] = $1CXFK.merge($7b345a63e52f4594$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $7b345a63e52f4594$var$defaults;

});
parcelRegister("kj4t5", function(module, exports) {
"use strict";

var $1CXFK = parcelRequire("1CXFK");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $1CXFK.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("2G1oX", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRegister("1DRzM", function(module, exports) {
"use strict";

var $1CXFK = parcelRequire("1CXFK");

var $hiqk5 = parcelRequire("hiqk5");

var $aK3HT = parcelRequire("aK3HT");

var $jjMyd = parcelRequire("jjMyd");

var $7TMUb = parcelRequire("7TMUb");

var $pMlbu = parcelRequire("pMlbu");

var $8XL79 = parcelRequire("8XL79");

var $1yUnH = parcelRequire("1yUnH");

var $azOvE = parcelRequire("azOvE");

var $dTUuc = parcelRequire("dTUuc");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ($1CXFK.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $7TMUb(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $jjMyd(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $pMlbu(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $hiqk5(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($1yUnH("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($1yUnH("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $azOvE.transitional;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($1yUnH(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($1CXFK.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $8XL79(fullPath)) && config.xsrfCookieName ? $aK3HT.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $1CXFK.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$1CXFK.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $dTUuc("canceled") : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("hiqk5", function(module, exports) {
"use strict";

var $1yUnH = parcelRequire("1yUnH");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($1yUnH("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("1yUnH", function(module, exports) {
"use strict";

var $2G1oX = parcelRequire("2G1oX");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $2G1oX(error, config, code, request, response);
};

});


parcelRegister("aK3HT", function(module, exports) {
"use strict";

var $1CXFK = parcelRequire("1CXFK");
module.exports = $1CXFK.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($1CXFK.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($1CXFK.isString(path)) cookie.push("path=" + path);
            if ($1CXFK.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("7TMUb", function(module, exports) {
"use strict";

var $g1o2z = parcelRequire("g1o2z");

var $12P60 = parcelRequire("12P60");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$g1o2z(requestedURL)) return $12P60(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("g1o2z", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("12P60", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("pMlbu", function(module, exports) {
"use strict";

var $1CXFK = parcelRequire("1CXFK");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $04d7d55dce07a0b9$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $1CXFK.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $1CXFK.trim(line.substr(0, i)).toLowerCase();
        val = $1CXFK.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $04d7d55dce07a0b9$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("8XL79", function(module, exports) {
"use strict";

var $1CXFK = parcelRequire("1CXFK");
module.exports = $1CXFK.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $1CXFK.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("dTUuc", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $a1ec3a669a3ca6c1$var$Cancel(message) {
    this.message = message;
}
$a1ec3a669a3ca6c1$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$a1ec3a669a3ca6c1$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $a1ec3a669a3ca6c1$var$Cancel;

});




parcelRegister("jTdk4", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("4oqry", function(module, exports) {
"use strict";

var $1CXFK = parcelRequire("1CXFK");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($1CXFK.isPlainObject(target) && $1CXFK.isPlainObject(source)) return $1CXFK.merge(target, source);
        else if ($1CXFK.isPlainObject(source)) return $1CXFK.merge({}, source);
        else if ($1CXFK.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$1CXFK.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$1CXFK.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$1CXFK.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$1CXFK.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$1CXFK.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $1CXFK.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $1CXFK.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("frybV", function(module, exports) {
"use strict";

var $hVO2C = parcelRequire("hVO2C");
var $b3e3e64f053008a2$require$VERSION = $hVO2C.version;
var $b3e3e64f053008a2$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $b3e3e64f053008a2$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $b3e3e64f053008a2$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $b3e3e64f053008a2$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + $b3e3e64f053008a2$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
        if (version && !$b3e3e64f053008a2$var$deprecatedWarnings[opt]) {
            $b3e3e64f053008a2$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $b3e3e64f053008a2$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    assertOptions: $b3e3e64f053008a2$var$assertOptions,
    validators: $b3e3e64f053008a2$var$validators
};

});
parcelRegister("hVO2C", function(module, exports) {
module.exports = {
    "version": "0.25.0"
};

});



parcelRegister("5Kp50", function(module, exports) {
"use strict";

var $dTUuc = parcelRequire("dTUuc");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $42f4b3f3b90cbf78$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $dTUuc(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $42f4b3f3b90cbf78$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $42f4b3f3b90cbf78$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $42f4b3f3b90cbf78$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $42f4b3f3b90cbf78$var$CancelToken.source = function source() {
    var cancel;
    var token = new $42f4b3f3b90cbf78$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $42f4b3f3b90cbf78$var$CancelToken;

});

parcelRegister("id2qT", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("dhck8", function(module, exports) {
"use strict";

var $1CXFK = parcelRequire("1CXFK");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $1CXFK.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("ywMPS", function(module, exports) {

$parcel$export(module.exports, "wNAF", () => wNAF);
$parcel$export(module.exports, "validateBasic", () => validateBasic);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Abelian group utilities

var $fPpMu = parcelRequire("fPpMu");

var $39n9f = parcelRequire("39n9f");
const _0n = BigInt(0);
const _1n = BigInt(1);
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
function validateBasic(curve) {
    (0, $fPpMu.validateField)(curve.Fp);
    (0, $39n9f.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $fPpMu.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

});
parcelRegister("fPpMu", function(module, exports) {

$parcel$export(module.exports, "mod", () => $b85f9e00ba56e724$export$842a2cf37af977e1);
$parcel$export(module.exports, "pow2", () => $b85f9e00ba56e724$export$fa569bd808b67eef);
$parcel$export(module.exports, "invert", () => $b85f9e00ba56e724$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "validateField", () => $b85f9e00ba56e724$export$bd454f0cef11418d);
$parcel$export(module.exports, "nLength", () => $b85f9e00ba56e724$export$c79df43ecd7e66c2);
$parcel$export(module.exports, "Field", () => $b85f9e00ba56e724$export$a455218a85c89869);
$parcel$export(module.exports, "getMinHashLength", () => $b85f9e00ba56e724$export$d058763b563056af);
$parcel$export(module.exports, "mapHashToField", () => $b85f9e00ba56e724$export$20cb21dbfa61dac3);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities for modular arithmetics and finite fields

var $39n9f = parcelRequire("39n9f");
// prettier-ignore
const $b85f9e00ba56e724$var$_0n = BigInt(0), $b85f9e00ba56e724$var$_1n = BigInt(1), $b85f9e00ba56e724$var$_2n = BigInt(2), $b85f9e00ba56e724$var$_3n = BigInt(3);
// prettier-ignore
const $b85f9e00ba56e724$var$_4n = BigInt(4), $b85f9e00ba56e724$var$_5n = BigInt(5), $b85f9e00ba56e724$var$_8n = BigInt(8);
// prettier-ignore
const $b85f9e00ba56e724$var$_9n = BigInt(9), $b85f9e00ba56e724$var$_16n = BigInt(16);
function $b85f9e00ba56e724$export$842a2cf37af977e1(a, b) {
    const result = a % b;
    return result >= $b85f9e00ba56e724$var$_0n ? result : b + result;
}
function $b85f9e00ba56e724$export$9c297f60e22e3389(num, power, modulo) {
    if (modulo <= $b85f9e00ba56e724$var$_0n || power < $b85f9e00ba56e724$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $b85f9e00ba56e724$var$_1n) return $b85f9e00ba56e724$var$_0n;
    let res = $b85f9e00ba56e724$var$_1n;
    while(power > $b85f9e00ba56e724$var$_0n){
        if (power & $b85f9e00ba56e724$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $b85f9e00ba56e724$var$_1n;
    }
    return res;
}
function $b85f9e00ba56e724$export$fa569bd808b67eef(x, power, modulo) {
    let res = x;
    while(power-- > $b85f9e00ba56e724$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $b85f9e00ba56e724$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $b85f9e00ba56e724$var$_0n || modulo <= $b85f9e00ba56e724$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $b85f9e00ba56e724$export$842a2cf37af977e1(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $b85f9e00ba56e724$var$_0n, y = $b85f9e00ba56e724$var$_1n, u = $b85f9e00ba56e724$var$_1n, v = $b85f9e00ba56e724$var$_0n;
    while(a !== $b85f9e00ba56e724$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $b85f9e00ba56e724$var$_1n) throw new Error("invert: does not exist");
    return $b85f9e00ba56e724$export$842a2cf37af977e1(x, modulo);
}
function $b85f9e00ba56e724$export$69f29ab1f3e9a234(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $b85f9e00ba56e724$var$_1n) / $b85f9e00ba56e724$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $b85f9e00ba56e724$var$_1n, S = 0; Q % $b85f9e00ba56e724$var$_2n === $b85f9e00ba56e724$var$_0n; Q /= $b85f9e00ba56e724$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $b85f9e00ba56e724$var$_2n; Z < P && $b85f9e00ba56e724$export$9c297f60e22e3389(Z, legendreC, P) !== P - $b85f9e00ba56e724$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $b85f9e00ba56e724$var$_1n) / $b85f9e00ba56e724$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $b85f9e00ba56e724$var$_1n) / $b85f9e00ba56e724$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $b85f9e00ba56e724$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
function $b85f9e00ba56e724$export$33bda048c6b8ea7d(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $b85f9e00ba56e724$var$_4n === $b85f9e00ba56e724$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $b85f9e00ba56e724$var$_1n) / $b85f9e00ba56e724$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $b85f9e00ba56e724$var$_8n === $b85f9e00ba56e724$var$_5n) {
        const c1 = (P - $b85f9e00ba56e724$var$_5n) / $b85f9e00ba56e724$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $b85f9e00ba56e724$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $b85f9e00ba56e724$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $b85f9e00ba56e724$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $b85f9e00ba56e724$export$69f29ab1f3e9a234(P);
}
const $b85f9e00ba56e724$export$7806f13ad5078b2f = (num, modulo)=>($b85f9e00ba56e724$export$842a2cf37af977e1(num, modulo) & $b85f9e00ba56e724$var$_1n) === $b85f9e00ba56e724$var$_1n;
// prettier-ignore
const $b85f9e00ba56e724$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $b85f9e00ba56e724$export$bd454f0cef11418d(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $b85f9e00ba56e724$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $39n9f.validateObject)(field, opts);
}
function $b85f9e00ba56e724$export$5d8ce3717733a987(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $b85f9e00ba56e724$var$_0n) throw new Error("Expected power > 0");
    if (power === $b85f9e00ba56e724$var$_0n) return f.ONE;
    if (power === $b85f9e00ba56e724$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $b85f9e00ba56e724$var$_0n){
        if (power & $b85f9e00ba56e724$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $b85f9e00ba56e724$var$_1n;
    }
    return p;
}
function $b85f9e00ba56e724$export$a492e3387142c0e9(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $b85f9e00ba56e724$export$e74c665040343df6(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $b85f9e00ba56e724$export$6897c284b6f9f4dc(rhs, f.ORDER) : f.inv(rhs));
}
function $b85f9e00ba56e724$export$5e2b6e87f2891ea7(f) {
    const legendreConst = (f.ORDER - $b85f9e00ba56e724$var$_1n) / $b85f9e00ba56e724$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
function $b85f9e00ba56e724$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
function $b85f9e00ba56e724$export$a455218a85c89869(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $b85f9e00ba56e724$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $b85f9e00ba56e724$export$c79df43ecd7e66c2(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $b85f9e00ba56e724$export$33bda048c6b8ea7d(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $39n9f.bitMask)(BITS),
        ZERO: $b85f9e00ba56e724$var$_0n,
        ONE: $b85f9e00ba56e724$var$_1n,
        create: (num)=>$b85f9e00ba56e724$export$842a2cf37af977e1(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $b85f9e00ba56e724$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $b85f9e00ba56e724$var$_0n,
        isOdd: (num)=>(num & $b85f9e00ba56e724$var$_1n) === $b85f9e00ba56e724$var$_1n,
        neg: (num)=>$b85f9e00ba56e724$export$842a2cf37af977e1(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$b85f9e00ba56e724$export$842a2cf37af977e1(num * num, ORDER),
        add: (lhs, rhs)=>$b85f9e00ba56e724$export$842a2cf37af977e1(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$b85f9e00ba56e724$export$842a2cf37af977e1(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$b85f9e00ba56e724$export$842a2cf37af977e1(lhs * rhs, ORDER),
        pow: (num, power)=>$b85f9e00ba56e724$export$5d8ce3717733a987(f, num, power),
        div: (lhs, rhs)=>$b85f9e00ba56e724$export$842a2cf37af977e1(lhs * $b85f9e00ba56e724$export$6897c284b6f9f4dc(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$b85f9e00ba56e724$export$6897c284b6f9f4dc(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$b85f9e00ba56e724$export$a492e3387142c0e9(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $39n9f.numberToBytesLE)(num, BYTES) : (0, $39n9f.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $39n9f.bytesToNumberLE)(bytes) : (0, $39n9f.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $b85f9e00ba56e724$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $b85f9e00ba56e724$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $b85f9e00ba56e724$export$d3b0e8260d5dbad4(hash, groupOrder, isLE = false) {
    hash = (0, $39n9f.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $b85f9e00ba56e724$export$c79df43ecd7e66c2(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $39n9f.bytesToNumberLE)(hash) : (0, $39n9f.bytesToNumberBE)(hash);
    return $b85f9e00ba56e724$export$842a2cf37af977e1(num, groupOrder - $b85f9e00ba56e724$var$_1n) + $b85f9e00ba56e724$var$_1n;
}
function $b85f9e00ba56e724$export$9cf21a9392b0fcfc(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $b85f9e00ba56e724$export$d058763b563056af(fieldOrder) {
    const length = $b85f9e00ba56e724$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $b85f9e00ba56e724$export$20cb21dbfa61dac3(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $b85f9e00ba56e724$export$9cf21a9392b0fcfc(fieldOrder);
    const minLen = $b85f9e00ba56e724$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $39n9f.bytesToNumberBE)(key) : (0, $39n9f.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $b85f9e00ba56e724$export$842a2cf37af977e1(num, fieldOrder - $b85f9e00ba56e724$var$_1n) + $b85f9e00ba56e724$var$_1n;
    return isLE ? (0, $39n9f.numberToBytesLE)(reduced, fieldLen) : (0, $39n9f.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("39n9f", function(module, exports) {

$parcel$export(module.exports, "bytesToHex", () => $24b42b1aae4ba333$export$58b867e287a802c8);
$parcel$export(module.exports, "numberToHexUnpadded", () => $24b42b1aae4ba333$export$4ed2545b622827c1);
$parcel$export(module.exports, "hexToNumber", () => $24b42b1aae4ba333$export$d57f2bacc26b4249);
$parcel$export(module.exports, "hexToBytes", () => $24b42b1aae4ba333$export$31c96b9df38bc8d4);
$parcel$export(module.exports, "bytesToNumberBE", () => $24b42b1aae4ba333$export$d609354794974f8);
$parcel$export(module.exports, "bytesToNumberLE", () => $24b42b1aae4ba333$export$d67b1d03392107e7);
$parcel$export(module.exports, "numberToBytesBE", () => $24b42b1aae4ba333$export$1459dafd057611cb);
$parcel$export(module.exports, "numberToBytesLE", () => $24b42b1aae4ba333$export$ba2172e58d139f6d);
$parcel$export(module.exports, "numberToVarBytesBE", () => $24b42b1aae4ba333$export$80ee8c1914de6dde);
$parcel$export(module.exports, "ensureBytes", () => $24b42b1aae4ba333$export$3cb5d50a3a30e837);
$parcel$export(module.exports, "concatBytes", () => $24b42b1aae4ba333$export$287dd7971339c972);
$parcel$export(module.exports, "equalBytes", () => $24b42b1aae4ba333$export$2aa59cef064b0333);
$parcel$export(module.exports, "utf8ToBytes", () => $24b42b1aae4ba333$export$3df70a15530b5e81);
$parcel$export(module.exports, "bitLen", () => $24b42b1aae4ba333$export$e93ef600c41761a9);
$parcel$export(module.exports, "bitGet", () => $24b42b1aae4ba333$export$9577d112d1fd46ad);
$parcel$export(module.exports, "bitSet", () => $24b42b1aae4ba333$export$967bb2b9787441cb);
$parcel$export(module.exports, "bitMask", () => $24b42b1aae4ba333$export$803efa2fa1c7279);
$parcel$export(module.exports, "createHmacDrbg", () => $24b42b1aae4ba333$export$d459d139192e4fba);
$parcel$export(module.exports, "validateObject", () => $24b42b1aae4ba333$export$381bae2d0f08004f);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $24b42b1aae4ba333$var$_0n = BigInt(0);
const $24b42b1aae4ba333$var$_1n = BigInt(1);
const $24b42b1aae4ba333$var$_2n = BigInt(2);
const $24b42b1aae4ba333$var$u8a = (a)=>a instanceof Uint8Array;
const $24b42b1aae4ba333$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $24b42b1aae4ba333$export$58b867e287a802c8(bytes) {
    if (!$24b42b1aae4ba333$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $24b42b1aae4ba333$var$hexes[bytes[i]];
    return hex;
}
function $24b42b1aae4ba333$export$4ed2545b622827c1(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function $24b42b1aae4ba333$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
function $24b42b1aae4ba333$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
function $24b42b1aae4ba333$export$d609354794974f8(bytes) {
    return $24b42b1aae4ba333$export$d57f2bacc26b4249($24b42b1aae4ba333$export$58b867e287a802c8(bytes));
}
function $24b42b1aae4ba333$export$d67b1d03392107e7(bytes) {
    if (!$24b42b1aae4ba333$var$u8a(bytes)) throw new Error("Uint8Array expected");
    return $24b42b1aae4ba333$export$d57f2bacc26b4249($24b42b1aae4ba333$export$58b867e287a802c8(Uint8Array.from(bytes).reverse()));
}
function $24b42b1aae4ba333$export$1459dafd057611cb(n, len) {
    return $24b42b1aae4ba333$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, "0"));
}
function $24b42b1aae4ba333$export$ba2172e58d139f6d(n, len) {
    return $24b42b1aae4ba333$export$1459dafd057611cb(n, len).reverse();
}
function $24b42b1aae4ba333$export$80ee8c1914de6dde(n) {
    return $24b42b1aae4ba333$export$31c96b9df38bc8d4($24b42b1aae4ba333$export$4ed2545b622827c1(n));
}
function $24b42b1aae4ba333$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $24b42b1aae4ba333$export$31c96b9df38bc8d4(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($24b42b1aae4ba333$var$u8a(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
function $24b42b1aae4ba333$export$287dd7971339c972(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$24b42b1aae4ba333$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
function $24b42b1aae4ba333$export$2aa59cef064b0333(b1, b2) {
    // We don't care about timing attacks here
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
function $24b42b1aae4ba333$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $24b42b1aae4ba333$export$e93ef600c41761a9(n) {
    let len;
    for(len = 0; n > $24b42b1aae4ba333$var$_0n; n >>= $24b42b1aae4ba333$var$_1n, len += 1);
    return len;
}
function $24b42b1aae4ba333$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $24b42b1aae4ba333$var$_1n;
}
const $24b42b1aae4ba333$export$967bb2b9787441cb = (n, pos, value)=>{
    return n | (value ? $24b42b1aae4ba333$var$_1n : $24b42b1aae4ba333$var$_0n) << BigInt(pos);
};
const $24b42b1aae4ba333$export$803efa2fa1c7279 = (n)=>($24b42b1aae4ba333$var$_2n << BigInt(n - 1)) - $24b42b1aae4ba333$var$_1n;
// DRBG
const $24b42b1aae4ba333$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $24b42b1aae4ba333$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
function $24b42b1aae4ba333$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $24b42b1aae4ba333$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $24b42b1aae4ba333$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $24b42b1aae4ba333$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($24b42b1aae4ba333$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($24b42b1aae4ba333$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $24b42b1aae4ba333$export$287dd7971339c972(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $24b42b1aae4ba333$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || val instanceof Uint8Array,
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
function $24b42b1aae4ba333$export$381bae2d0f08004f(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $24b42b1aae4ba333$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
} // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});



var $8bbd0dc1ab5297af$exports = {};
"use strict";

$8bbd0dc1ab5297af$exports = (parcelRequire("dARHh"));


parcelRequire("tZqWC");
var $f419cfc3d92fe631$exports = {};
"use strict";
function $f419cfc3d92fe631$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($f419cfc3d92fe631$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$f419cfc3d92fe631$var$checkDCE();

$f419cfc3d92fe631$exports = (parcelRequire("bIn0m"));



parcelRequire("tZqWC");

parcelRequire("tZqWC");

var $tZqWC = parcelRequire("tZqWC");


var $tZqWC = parcelRequire("tZqWC");
var $c800aa184e4b129d$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext(null);
var $c800aa184e4b129d$export$2e2bcd8739ae039 = $c800aa184e4b129d$export$cc80c08dc91f1c00;


// Default to a dummy "batch" implementation that just runs the callback
function $6d06c8b9e571b6e5$var$defaultNoopBatch(callback) {
    callback();
}
var $6d06c8b9e571b6e5$var$batch = $6d06c8b9e571b6e5$var$defaultNoopBatch; // Allow injecting another batching function later
var $6d06c8b9e571b6e5$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $6d06c8b9e571b6e5$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $6d06c8b9e571b6e5$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $6d06c8b9e571b6e5$var$batch;
};


// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $86ee9a46dd49bc62$var$createListenerCollection() {
    var batch = (0, $6d06c8b9e571b6e5$export$fc47d4c0ba3bd2c6)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $86ee9a46dd49bc62$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $86ee9a46dd49bc62$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $86ee9a46dd49bc62$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $86ee9a46dd49bc62$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $86ee9a46dd49bc62$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}



var $tZqWC = parcelRequire("tZqWC");
var $ca9cd1747ebc2fbf$export$700979bc83e7db82 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $tZqWC.useLayoutEffect) : (0, $tZqWC.useEffect);


function $44a4de761c3016e3$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $tZqWC.useMemo)(function() {
        var subscription = (0, $86ee9a46dd49bc62$export$d567d2b9af322f8f)(store);
        subscription.onStateChange = subscription.notifyNestedSubs;
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $tZqWC.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $ca9cd1747ebc2fbf$export$700979bc83e7db82)(function() {
        var subscription = contextValue.subscription;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $c800aa184e4b129d$export$cc80c08dc91f1c00);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $44a4de761c3016e3$export$2e2bcd8739ae039 = $44a4de761c3016e3$var$Provider;



var $j1NUG = parcelRequire("j1NUG");

var $cGhSa = parcelRequire("cGhSa");

var $7g5pF = parcelRequire("7g5pF");

var $tZqWC = parcelRequire("tZqWC");
var $4344e5410d380169$exports = {};
"use strict";

$4344e5410d380169$exports = (parcelRequire("bR9Ya"));





var $16725376249d14af$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $16725376249d14af$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $16725376249d14af$var$EMPTY_ARRAY = [];
var $16725376249d14af$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $16725376249d14af$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $16725376249d14af$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $16725376249d14af$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $ca9cd1747ebc2fbf$export$700979bc83e7db82)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $16725376249d14af$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $16725376249d14af$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: "STORE_UPDATED",
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $16725376249d14af$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $16725376249d14af$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $c800aa184e4b129d$export$cc80c08dc91f1c00) : _ref2$context, connectOptions = (0, $cGhSa.default)(_ref2, $16725376249d14af$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $j1NUG.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $tZqWC.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $tZqWC.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $cGhSa.default)(props, $16725376249d14af$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $tZqWC.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $4344e5410d380169$exports.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $tZqWC.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $tZqWC.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $tZqWC.useMemo)(function() {
                if (!shouldHandleStateChanges) return $16725376249d14af$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $86ee9a46dd49bc62$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $tZqWC.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $j1NUG.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $tZqWC.useReducer)($16725376249d14af$var$storeStateUpdatesReducer, $16725376249d14af$var$EMPTY_ARRAY, $16725376249d14af$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $tZqWC.useRef)();
            var lastWrapperProps = (0, $tZqWC.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $tZqWC.useRef)();
            var renderIsScheduled = (0, $tZqWC.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $16725376249d14af$var$useIsomorphicLayoutEffectWithArgs($16725376249d14af$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $16725376249d14af$var$useIsomorphicLayoutEffectWithArgs($16725376249d14af$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $tZqWC.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(WrappedComponent, (0, $j1NUG.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $tZqWC.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Connect, (0, $j1NUG.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7g5pF)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($7g5pF)))(Connect, WrappedComponent);
    };
}




var $j1NUG = parcelRequire("j1NUG");

var $cGhSa = parcelRequire("cGhSa");

function $1a47d131d4cd13dc$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $1a47d131d4cd13dc$export$2e2bcd8739ae039(objA, objB) {
    if ($1a47d131d4cd13dc$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$1a47d131d4cd13dc$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $01b1486285ebb912$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $abf642e35390d4b4$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $b2e34002d416f828$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $87041fbcd492919e$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $abf642e35390d4b4$export$2e2bcd8739ae039)(value)) (0, $b2e34002d416f828$export$2e2bcd8739ae039)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}


function $ab176739fdd158e6$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $ab176739fdd158e6$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $ab176739fdd158e6$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $ab176739fdd158e6$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $ab176739fdd158e6$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $46ebfbaa36287ccd$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, $ab176739fdd158e6$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function $46ebfbaa36287ccd$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $ab176739fdd158e6$export$710f7c60f68acd3e)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $46ebfbaa36287ccd$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $ab176739fdd158e6$export$710f7c60f68acd3e)(function(dispatch) {
        return (0, $01b1486285ebb912$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $46ebfbaa36287ccd$export$2e2bcd8739ae039 = [
    $46ebfbaa36287ccd$export$a9f27b4b187c1166,
    $46ebfbaa36287ccd$export$ba20d1a7aa0c4a90,
    $46ebfbaa36287ccd$export$94a6e55709d4d961
];



function $dcd801f855fc8e99$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, $ab176739fdd158e6$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : undefined;
}
function $dcd801f855fc8e99$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $ab176739fdd158e6$export$710f7c60f68acd3e)(function() {
        return {};
    }) : undefined;
}
var $dcd801f855fc8e99$export$2e2bcd8739ae039 = [
    $dcd801f855fc8e99$export$23fc470827b14aa,
    $dcd801f855fc8e99$export$514bc8c1a53c1d66
];



var $j1NUG = parcelRequire("j1NUG");

function $7c36ffa4fae85c0c$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $j1NUG.default)({}, ownProps, stateProps, dispatchProps);
}
function $7c36ffa4fae85c0c$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $7c36ffa4fae85c0c$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === "function" ? $7c36ffa4fae85c0c$export$5b105939c84b5234(mergeProps) : undefined;
}
function $7c36ffa4fae85c0c$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $7c36ffa4fae85c0c$export$691c327fc30bc857;
    } : undefined;
}
var $7c36ffa4fae85c0c$export$2e2bcd8739ae039 = [
    $7c36ffa4fae85c0c$export$d61b680184bc3f00,
    $7c36ffa4fae85c0c$export$a13ba70ef50dda6d
];



var $cGhSa = parcelRequire("cGhSa");

function $755b1351dba08002$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $b2e34002d416f828$export$2e2bcd8739ae039)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $755b1351dba08002$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $755b1351dba08002$var$verify(mapStateToProps, "mapStateToProps", displayName);
    $755b1351dba08002$var$verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    $755b1351dba08002$var$verify(mergeProps, "mergeProps", displayName);
}


var $e647c11232dc41f2$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $e647c11232dc41f2$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $e647c11232dc41f2$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $e647c11232dc41f2$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $cGhSa.default)(_ref2, $e647c11232dc41f2$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $e647c11232dc41f2$export$d20c0c2ca6eb2b6f : $e647c11232dc41f2$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


var $9a02dcf7eea7138a$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $9a02dcf7eea7138a$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $9a02dcf7eea7138a$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $9a02dcf7eea7138a$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $16725376249d14af$export$2e2bcd8739ae039) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $dcd801f855fc8e99$export$2e2bcd8739ae039) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $46ebfbaa36287ccd$export$2e2bcd8739ae039) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $7c36ffa4fae85c0c$export$2e2bcd8739ae039) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $e647c11232dc41f2$export$2e2bcd8739ae039) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $9a02dcf7eea7138a$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $1a47d131d4cd13dc$export$2e2bcd8739ae039) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $1a47d131d4cd13dc$export$2e2bcd8739ae039) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $1a47d131d4cd13dc$export$2e2bcd8739ae039) : _ref3$areMergedPropsE, extraOptions = (0, $cGhSa.default)(_ref3, $9a02dcf7eea7138a$var$_excluded);
        var initMapStateToProps = $9a02dcf7eea7138a$var$match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = $9a02dcf7eea7138a$var$match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = $9a02dcf7eea7138a$var$match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, $j1NUG.default)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $9a02dcf7eea7138a$export$2e2bcd8739ae039 = /*#__PURE__*/ $9a02dcf7eea7138a$export$9f9feb656dec1fc4();




var $tZqWC = parcelRequire("tZqWC");


var $tZqWC = parcelRequire("tZqWC");

function $ce8742bf036ecb86$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $tZqWC.useContext)((0, $c800aa184e4b129d$export$cc80c08dc91f1c00));
    return contextValue;
}


function $36fea69f56ae8106$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $c800aa184e4b129d$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $c800aa184e4b129d$export$cc80c08dc91f1c00) ? (0, $ce8742bf036ecb86$export$c1275ca9a6fd3ec5) : function() {
        return (0, $tZqWC.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $36fea69f56ae8106$export$6ccbb43953eebf8 = /*#__PURE__*/ $36fea69f56ae8106$export$671dba69185d0304();


function $a748bab419689843$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $c800aa184e4b129d$export$cc80c08dc91f1c00);
    var useStore = context === (0, $c800aa184e4b129d$export$cc80c08dc91f1c00) ? (0, $36fea69f56ae8106$export$6ccbb43953eebf8) : (0, $36fea69f56ae8106$export$671dba69185d0304)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $a748bab419689843$export$8ad76b76a4c905f8 = /*#__PURE__*/ $a748bab419689843$export$bc9b55530897c558();



var $tZqWC = parcelRequire("tZqWC");




var $d8c95896af7851e3$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $d8c95896af7851e3$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $tZqWC.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $tZqWC.useMemo)(function() {
        return (0, $86ee9a46dd49bc62$export$d567d2b9af322f8f)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $tZqWC.useRef)();
    var latestSelector = (0, $tZqWC.useRef)();
    var latestStoreState = (0, $tZqWC.useRef)();
    var latestSelectedState = (0, $tZqWC.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $ca9cd1747ebc2fbf$export$700979bc83e7db82)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $ca9cd1747ebc2fbf$export$700979bc83e7db82)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $d8c95896af7851e3$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $c800aa184e4b129d$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $c800aa184e4b129d$export$cc80c08dc91f1c00) ? (0, $ce8742bf036ecb86$export$c1275ca9a6fd3ec5) : function() {
        return (0, $tZqWC.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $d8c95896af7851e3$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $d8c95896af7851e3$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $tZqWC.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $d8c95896af7851e3$export$2105062e25df4afe = /*#__PURE__*/ $d8c95896af7851e3$export$2b53f90d2bd1cbfb();






/* eslint-disable import/no-unresolved */ 



// with standard React renderers (ReactDOM, React Native)
(0, $6d06c8b9e571b6e5$export$4b9874722d0da7bc)((0, $f419cfc3d92fe631$exports.unstable_batchedUpdates));



var $6bvDC = parcelRequire("6bvDC");
function $271d31b42c64d81e$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $bfc31086a22cafcf$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bfc31086a22cafcf$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bfc31086a22cafcf$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $271d31b42c64d81e$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bfc31086a22cafcf$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $5c178e598efca549$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $5c178e598efca549$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $5c178e598efca549$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $5c178e598efca549$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $5c178e598efca549$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $5c178e598efca549$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $5c178e598efca549$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $5c178e598efca549$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $5c178e598efca549$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($5c178e598efca549$var$isDate(val)) return "date";
    if ($5c178e598efca549$var$isError(val)) return "error";
    var constructorName = $5c178e598efca549$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $5c178e598efca549$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $5c178e598efca549$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $5c178e598efca549$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $5c178e598efca549$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ function $5c178e598efca549$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($5c178e598efca549$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($5c178e598efca549$var$formatProdErrorMessage(1));
        return enhancer($5c178e598efca549$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($5c178e598efca549$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($5c178e598efca549$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($5c178e598efca549$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($5c178e598efca549$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($5c178e598efca549$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$5c178e598efca549$var$isPlainObject(action)) throw new Error($5c178e598efca549$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($5c178e598efca549$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($5c178e598efca549$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($5c178e598efca549$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $5c178e598efca549$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($5c178e598efca549$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$5c178e598efca549$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $5c178e598efca549$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$5c178e598efca549$var$$$observable] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $5c178e598efca549$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $5c178e598efca549$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $5c178e598efca549$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$5c178e598efca549$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $5c178e598efca549$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $5c178e598efca549$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $5c178e598efca549$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $5c178e598efca549$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($5c178e598efca549$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $5c178e598efca549$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($5c178e598efca549$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $5c178e598efca549$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $5c178e598efca549$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($5c178e598efca549$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $5c178e598efca549$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $5c178e598efca549$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $5c178e598efca549$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($5c178e598efca549$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $5c178e598efca549$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $5c178e598efca549$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $5c178e598efca549$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($5c178e598efca549$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $5c178e598efca549$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $bfc31086a22cafcf$export$2e2bcd8739ae039)((0, $bfc31086a22cafcf$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function $5c178e598efca549$var$isCrushed() {}


// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $f17c24e54e60b024$var$NOT_FOUND = "NOT_FOUND";
function $f17c24e54e60b024$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $f17c24e54e60b024$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $f17c24e54e60b024$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $f17c24e54e60b024$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $f17c24e54e60b024$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $f17c24e54e60b024$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $f17c24e54e60b024$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $f17c24e54e60b024$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $f17c24e54e60b024$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $f17c24e54e60b024$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $f17c24e54e60b024$var$createSingletonCache(comparator) : $f17c24e54e60b024$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $f17c24e54e60b024$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}


function $6730822c14f67805$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $6730822c14f67805$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $6730822c14f67805$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $6730822c14f67805$export$595d22ed68ca2841 = /* #__PURE__ */ $6730822c14f67805$export$5943f4447f6ef248((0, $f17c24e54e60b024$export$281bff7f05488aa2));
var $6730822c14f67805$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $6730822c14f67805$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $ccc44c8907518eb1$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $ccc44c8907518eb1$var$thunk = $ccc44c8907518eb1$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$ccc44c8907518eb1$var$thunk.withExtraArgument = $ccc44c8907518eb1$var$createThunkMiddleware;
var $ccc44c8907518eb1$export$2e2bcd8739ae039 = $ccc44c8907518eb1$var$thunk;


var $def02af5c61b0dea$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $def02af5c61b0dea$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $def02af5c61b0dea$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $def02af5c61b0dea$var$__defProp = Object.defineProperty;
var $def02af5c61b0dea$var$__defProps = Object.defineProperties;
var $def02af5c61b0dea$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $def02af5c61b0dea$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $def02af5c61b0dea$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $def02af5c61b0dea$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $def02af5c61b0dea$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $def02af5c61b0dea$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $def02af5c61b0dea$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($def02af5c61b0dea$var$__hasOwnProp.call(b, prop)) $def02af5c61b0dea$var$__defNormalProp(a, prop, b[prop]);
    if ($def02af5c61b0dea$var$__getOwnPropSymbols) for(var _i = 0, _c = $def02af5c61b0dea$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($def02af5c61b0dea$var$__propIsEnum.call(b, prop)) $def02af5c61b0dea$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $def02af5c61b0dea$var$__spreadProps = function(a, b) {
    return $def02af5c61b0dea$var$__defProps(a, $def02af5c61b0dea$var$__getOwnPropDescs(b));
};
var $def02af5c61b0dea$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $def02af5c61b0dea$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $6730822c14f67805$export$595d22ed68ca2841).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $def02af5c61b0dea$var$__spreadArray([
            (0, $6bvDC.isDraft)(value) ? (0, $6bvDC.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $def02af5c61b0dea$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $5c178e598efca549$export$f672e0b6f7222cd7;
    return (0, $5c178e598efca549$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $def02af5c61b0dea$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop) {
        return noop;
    };
};
// src/isPlainObject.ts
function $def02af5c61b0dea$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils.ts
function $def02af5c61b0dea$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $def02af5c61b0dea$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $def02af5c61b0dea$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $def02af5c61b0dea$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $def02af5c61b0dea$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
// src/immutableStateInvariantMiddleware.ts
var $def02af5c61b0dea$var$isProduction = true;
var $def02af5c61b0dea$var$prefix = "Invariant failed";
function $def02af5c61b0dea$var$invariant(condition, message) {
    if (condition) return;
    if ($def02af5c61b0dea$var$isProduction) throw new Error($def02af5c61b0dea$var$prefix);
    throw new Error($def02af5c61b0dea$var$prefix + ": " + (message || ""));
}
function $def02af5c61b0dea$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $def02af5c61b0dea$var$getSerialize(serializer, decycler), indent);
}
function $def02af5c61b0dea$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $def02af5c61b0dea$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value === null || typeof value === "undefined" || Object.isFrozen(value);
}
function $def02af5c61b0dea$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $def02af5c61b0dea$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $def02af5c61b0dea$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $def02af5c61b0dea$var$trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $def02af5c61b0dea$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $def02af5c61b0dea$var$detectMutations(isImmutable, ignorePaths, trackedProperty, obj, sameParentRef, path) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    for(var key in keysToDetect){
        var childPath = path ? path + "." + key : key;
        if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
        var result = $def02af5c61b0dea$var$detectMutations(isImmutable, ignorePaths, trackedProperty.children[key], obj[key], sameRef, childPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $def02af5c61b0dea$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $def02af5c61b0dea$export$77670485918dab4e(val) {
    var type = typeof val;
    return type === "undefined" || val === null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $def02af5c61b0dea$export$53b83ca8eaab0383(val);
}
function $def02af5c61b0dea$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $def02af5c61b0dea$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths && ignoredPaths.indexOf(nestedPath) >= 0) continue;
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $def02af5c61b0dea$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    return false;
}
function $def02af5c61b0dea$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $def02af5c61b0dea$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $def02af5c61b0dea$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $def02af5c61b0dea$export$36c1185aeee5b0a6(options);
    };
}
function $def02af5c61b0dea$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new $def02af5c61b0dea$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($def02af5c61b0dea$var$isBoolean(thunk)) middlewareArray.push((0, $ccc44c8907518eb1$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $ccc44c8907518eb1$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $def02af5c61b0dea$var$IS_PRODUCTION = true;
function $def02af5c61b0dea$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $def02af5c61b0dea$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($def02af5c61b0dea$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $5c178e598efca549$export$66e4520cdb265d18)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$def02af5c61b0dea$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$def02af5c61b0dea$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $5c178e598efca549$export$9ff26e0402cc7b7).apply(void 0, finalMiddleware);
    var finalCompose = (0, $5c178e598efca549$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $def02af5c61b0dea$var$composeWithDevTools($def02af5c61b0dea$var$__spreadValues({
        trace: !$def02af5c61b0dea$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var storeEnhancers = [
        middlewareEnhancer
    ];
    if (Array.isArray(enhancers)) storeEnhancers = $def02af5c61b0dea$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(storeEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $5c178e598efca549$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function $def02af5c61b0dea$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $def02af5c61b0dea$var$__spreadValues($def02af5c61b0dea$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $def02af5c61b0dea$var$isFSA(action) {
    return $def02af5c61b0dea$export$53b83ca8eaab0383(action) && typeof action.type === "string" && Object.keys(action).every($def02af5c61b0dea$var$isValidKey);
}
function $def02af5c61b0dea$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $def02af5c61b0dea$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/mapBuilders.ts
function $def02af5c61b0dea$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) throw new Error("addCase cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $def02af5c61b0dea$var$isStateFunction(x) {
    return typeof x === "function";
}
function $def02af5c61b0dea$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $def02af5c61b0dea$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($def02af5c61b0dea$var$isStateFunction(initialState)) getInitialState = function() {
        return (0, $6bvDC.default)(initialState(), function() {});
    };
    else {
        var frozenInitialState_1 = (0, $6bvDC.default)(initialState, function() {});
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $def02af5c61b0dea$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $6bvDC.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (typeof result === "undefined") return previousState;
                    return result;
                } else if (!(0, $6bvDC.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (typeof result === "undefined") {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $6bvDC.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
function $def02af5c61b0dea$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $def02af5c61b0dea$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    var initialState = typeof options.initialState == "function" ? options.initialState : (0, $6bvDC.default)(options.initialState, function() {});
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $def02af5c61b0dea$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $def02af5c61b0dea$export$309c7a02b0b0bc62(type, prepareCallback) : $def02af5c61b0dea$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $def02af5c61b0dea$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $def02af5c61b0dea$var$__spreadValues($def02af5c61b0dea$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $def02af5c61b0dea$export$473eb76d322d0290(initialState, finalCaseReducers, actionMatchers, defaultCaseReducer);
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $def02af5c61b0dea$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $def02af5c61b0dea$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($def02af5c61b0dea$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $def02af5c61b0dea$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $def02af5c61b0dea$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $def02af5c61b0dea$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $def02af5c61b0dea$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $def02af5c61b0dea$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $def02af5c61b0dea$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $def02af5c61b0dea$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $def02af5c61b0dea$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $def02af5c61b0dea$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $def02af5c61b0dea$var$createSingleArgumentStateOperator(mutator) {
    var operator = $def02af5c61b0dea$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $def02af5c61b0dea$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $def02af5c61b0dea$var$isFSA(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $6bvDC.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $6bvDC.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $def02af5c61b0dea$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $def02af5c61b0dea$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $def02af5c61b0dea$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $def02af5c61b0dea$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $def02af5c61b0dea$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $def02af5c61b0dea$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $def02af5c61b0dea$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $def02af5c61b0dea$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $def02af5c61b0dea$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $def02af5c61b0dea$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $def02af5c61b0dea$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $def02af5c61b0dea$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $def02af5c61b0dea$var$__spreadValues($def02af5c61b0dea$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = state.ids.map(function(id) {
                return newKeys[id] || id;
            });
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $def02af5c61b0dea$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $def02af5c61b0dea$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $def02af5c61b0dea$var$createStateOperator(addOneMutably),
        addMany: $def02af5c61b0dea$var$createStateOperator(addManyMutably),
        setOne: $def02af5c61b0dea$var$createStateOperator(setOneMutably),
        setMany: $def02af5c61b0dea$var$createStateOperator(setManyMutably),
        setAll: $def02af5c61b0dea$var$createStateOperator(setAllMutably),
        updateOne: $def02af5c61b0dea$var$createStateOperator(updateOneMutably),
        updateMany: $def02af5c61b0dea$var$createStateOperator(updateManyMutably),
        upsertOne: $def02af5c61b0dea$var$createStateOperator(upsertOneMutably),
        upsertMany: $def02af5c61b0dea$var$createStateOperator(upsertManyMutably),
        removeOne: $def02af5c61b0dea$var$createStateOperator(removeOneMutably),
        removeMany: $def02af5c61b0dea$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $def02af5c61b0dea$var$createSortedStateAdapter(selectId, sort) {
    var _c = $def02af5c61b0dea$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $def02af5c61b0dea$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($def02af5c61b0dea$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $def02af5c61b0dea$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $def02af5c61b0dea$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function takeUpdatedModel(models, update, state) {
        if (!(update.id in state.entities)) return false;
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $def02af5c61b0dea$var$selectIdValue(updated, selectId);
        delete state.entities[update.id];
        models.push(updated);
        return newKey !== update.id;
    }
    function updateManyMutably(updates, state) {
        var models = [];
        updates.forEach(function(update) {
            return takeUpdatedModel(models, update, state);
        });
        if (models.length !== 0) merge(models, state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $def02af5c61b0dea$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $def02af5c61b0dea$var$createStateOperator(addOneMutably),
        updateOne: $def02af5c61b0dea$var$createStateOperator(updateOneMutably),
        upsertOne: $def02af5c61b0dea$var$createStateOperator(upsertOneMutably),
        setOne: $def02af5c61b0dea$var$createStateOperator(setOneMutably),
        setMany: $def02af5c61b0dea$var$createStateOperator(setManyMutably),
        setAll: $def02af5c61b0dea$var$createStateOperator(setAllMutably),
        addMany: $def02af5c61b0dea$var$createStateOperator(addManyMutably),
        updateMany: $def02af5c61b0dea$var$createStateOperator(updateManyMutably),
        upsertMany: $def02af5c61b0dea$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $def02af5c61b0dea$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $def02af5c61b0dea$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $def02af5c61b0dea$var$createInitialStateFactory();
    var selectorsFactory = $def02af5c61b0dea$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $def02af5c61b0dea$var$createSortedStateAdapter(selectId, sortComparer) : $def02af5c61b0dea$var$createUnsortedStateAdapter(selectId);
    return $def02af5c61b0dea$var$__spreadValues($def02af5c61b0dea$var$__spreadValues($def02af5c61b0dea$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $def02af5c61b0dea$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $def02af5c61b0dea$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $def02af5c61b0dea$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $def02af5c61b0dea$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $def02af5c61b0dea$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $def02af5c61b0dea$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $def02af5c61b0dea$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $def02af5c61b0dea$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
function $def02af5c61b0dea$export$6abd22dc03e5063f(typePrefix, payloadCreator, options) {
    var fulfilled = $def02af5c61b0dea$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
        return {
            payload: payload,
            meta: $def02af5c61b0dea$var$__spreadProps($def02af5c61b0dea$var$__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                requestStatus: "fulfilled"
            })
        };
    });
    var pending = $def02af5c61b0dea$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
        return {
            payload: void 0,
            meta: $def02af5c61b0dea$var$__spreadProps($def02af5c61b0dea$var$__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                requestStatus: "pending"
            })
        };
    });
    var rejected = $def02af5c61b0dea$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
        return {
            payload: payload,
            error: (options && options.serializeError || $def02af5c61b0dea$export$c97c53d0b2d5d81e)(error || "Rejected"),
            meta: $def02af5c61b0dea$var$__spreadProps($def02af5c61b0dea$var$__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                rejectedWithValue: !!payload,
                requestStatus: "rejected",
                aborted: (error == null ? void 0 : error.name) === "AbortError",
                condition: (error == null ? void 0 : error.name) === "ConditionError"
            })
        };
    });
    var displayedWarning = false;
    var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
        function class_1() {
            this.signal = {
                aborted: false,
                addEventListener: function() {},
                dispatchEvent: function() {
                    return false;
                },
                onabort: function() {},
                removeEventListener: function() {}
            };
        }
        class_1.prototype.abort = function() {};
        return class_1;
    }();
    function actionCreator(arg) {
        return function(dispatch, getState, extra) {
            var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $def02af5c61b0dea$export$ac4959f4f1338dfc();
            var abortController = new AC();
            var abortReason;
            var abortedPromise = new Promise(function(_, reject) {
                return abortController.signal.addEventListener("abort", function() {
                    return reject({
                        name: "AbortError",
                        message: abortReason || "Aborted"
                    });
                });
            });
            var started = false;
            function abort(reason) {
                if (started) {
                    abortReason = reason;
                    abortController.abort();
                }
            }
            var promise = function() {
                return $def02af5c61b0dea$var$__async(this, null, function() {
                    var _a, _b, finalAction, conditionResult, err_1, skipDispatch;
                    return $def02af5c61b0dea$var$__generator(this, function(_c) {
                        switch(_c.label){
                            case 0:
                                _c.trys.push([
                                    0,
                                    4,
                                    ,
                                    5
                                ]);
                                conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                    getState: getState,
                                    extra: extra
                                });
                                if (!$def02af5c61b0dea$var$isThenable(conditionResult)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    conditionResult
                                ];
                            case 1:
                                conditionResult = _c.sent();
                                _c.label = 2;
                            case 2:
                                if (conditionResult === false) throw {
                                    name: "ConditionError",
                                    message: "Aborted due to condition callback returning false."
                                };
                                started = true;
                                dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                    requestId: requestId,
                                    arg: arg
                                }, {
                                    getState: getState,
                                    extra: extra
                                })));
                                return [
                                    4 /*yield*/ ,
                                    Promise.race([
                                        abortedPromise,
                                        Promise.resolve(payloadCreator(arg, {
                                            dispatch: dispatch,
                                            getState: getState,
                                            extra: extra,
                                            requestId: requestId,
                                            signal: abortController.signal,
                                            rejectWithValue: function(value, meta) {
                                                return new $def02af5c61b0dea$var$RejectWithValue(value, meta);
                                            },
                                            fulfillWithValue: function(value, meta) {
                                                return new $def02af5c61b0dea$var$FulfillWithMeta(value, meta);
                                            }
                                        })).then(function(result) {
                                            if (result instanceof $def02af5c61b0dea$var$RejectWithValue) throw result;
                                            if (result instanceof $def02af5c61b0dea$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                            return fulfilled(result, requestId, arg);
                                        })
                                    ])
                                ];
                            case 3:
                                finalAction = _c.sent();
                                return [
                                    3 /*break*/ ,
                                    5
                                ];
                            case 4:
                                err_1 = _c.sent();
                                finalAction = err_1 instanceof $def02af5c61b0dea$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                return [
                                    3 /*break*/ ,
                                    5
                                ];
                            case 5:
                                skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                if (!skipDispatch) dispatch(finalAction);
                                return [
                                    2 /*return*/ ,
                                    finalAction
                                ];
                        }
                    });
                });
            }();
            return Object.assign(promise, {
                abort: abort,
                requestId: requestId,
                arg: arg,
                unwrap: function() {
                    return promise.then($def02af5c61b0dea$export$5b28227b4c5dc983);
                }
            });
        };
    }
    return Object.assign(actionCreator, {
        pending: pending,
        rejected: rejected,
        fulfilled: fulfilled,
        typePrefix: typePrefix
    });
}
function $def02af5c61b0dea$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $def02af5c61b0dea$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var $def02af5c61b0dea$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var $def02af5c61b0dea$var$matches = function(matcher, action) {
    if ($def02af5c61b0dea$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $def02af5c61b0dea$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $def02af5c61b0dea$var$matches(matcher, action);
        });
    };
}
function $def02af5c61b0dea$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $def02af5c61b0dea$var$matches(matcher, action);
        });
    };
}
function $def02af5c61b0dea$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $def02af5c61b0dea$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $def02af5c61b0dea$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $def02af5c61b0dea$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$def02af5c61b0dea$var$isAsyncThunkArray(asyncThunks)) return $def02af5c61b0dea$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $def02af5c61b0dea$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $def02af5c61b0dea$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $def02af5c61b0dea$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$def02af5c61b0dea$var$isAsyncThunkArray(asyncThunks)) return $def02af5c61b0dea$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $def02af5c61b0dea$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $def02af5c61b0dea$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $def02af5c61b0dea$export$9dd1fb32974da385($def02af5c61b0dea$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$def02af5c61b0dea$var$isAsyncThunkArray(asyncThunks)) return $def02af5c61b0dea$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $def02af5c61b0dea$export$9dd1fb32974da385($def02af5c61b0dea$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $def02af5c61b0dea$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $def02af5c61b0dea$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$def02af5c61b0dea$var$isAsyncThunkArray(asyncThunks)) return $def02af5c61b0dea$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $def02af5c61b0dea$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $def02af5c61b0dea$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $def02af5c61b0dea$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$def02af5c61b0dea$var$isAsyncThunkArray(asyncThunks)) return $def02af5c61b0dea$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $def02af5c61b0dea$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/index.ts
(0, $6bvDC.enableES5)();


var $3e9167b9503b8931$export$711117ad6ad27992 = "persist:";
var $3e9167b9503b8931$export$2aaee4793dd13a52 = "persist/FLUSH";
var $3e9167b9503b8931$export$1647ef958242c4e2 = "persist/REHYDRATE";
var $3e9167b9503b8931$export$dd1033c27a16bbd3 = "persist/PAUSE";
var $3e9167b9503b8931$export$913fe0e161ed92a2 = "persist/PERSIST";
var $3e9167b9503b8931$export$5514fc3b4067675f = "persist/PURGE";
var $3e9167b9503b8931$export$51e82cdd7353a0e1 = "persist/REGISTER";
var $3e9167b9503b8931$export$363ebe89e6e7aeef = -1;


function $cb7f7e5c31054b73$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $cb7f7e5c31054b73$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $cb7f7e5c31054b73$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $cb7f7e5c31054b73$var$_typeof(obj);
}
function $cb7f7e5c31054b73$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cb7f7e5c31054b73$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $cb7f7e5c31054b73$var$ownKeys(source, true).forEach(function(key) {
            $cb7f7e5c31054b73$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $cb7f7e5c31054b73$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cb7f7e5c31054b73$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cb7f7e5c31054b73$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $cb7f7e5c31054b73$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $cb7f7e5c31054b73$var$_typeof(inboundState) === "object") Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === "_persist") return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
         // otherwise hard set the new value
        newState[key] = inboundState[key];
    });
    return newState;
}



function $28ee1925742e823a$export$2e2bcd8739ae039(config) {
    // defaults
    var blacklist = config.blacklist || null;
    var whitelist = config.whitelist || null;
    var transforms = config.transforms || [];
    var throttle = config.throttle || 0;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $3e9167b9503b8931$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var serialize;
    if (config.serialize === false) serialize = function serialize(x) {
        return x;
    };
    else if (typeof config.serialize === "function") serialize = config.serialize;
    else serialize = $28ee1925742e823a$var$defaultSerialize;
    var writeFailHandler = config.writeFailHandler || null; // initialize stateful values
    var lastState = {};
    var stagedState = {};
    var keysToProcess = [];
    var timeIterator = null;
    var writePromise = null;
    var update = function update(state) {
        // add any changed keys to the queue
        Object.keys(state).forEach(function(key) {
            if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
            if (lastState[key] === state[key]) return; // value unchanged? noop
            if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
            keysToProcess.push(key); // add key to queue
        }); //if any key is missing in the new state which was present in the lastState,
        //add it for processing too
        Object.keys(lastState).forEach(function(key) {
            if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) keysToProcess.push(key);
        }); // start the time iterator if not running (read: throttle)
        if (timeIterator === null) timeIterator = setInterval(processNextKey, throttle);
        lastState = state;
    };
    function processNextKey() {
        if (keysToProcess.length === 0) {
            if (timeIterator) clearInterval(timeIterator);
            timeIterator = null;
            return;
        }
        var key = keysToProcess.shift();
        var endState = transforms.reduce(function(subState, transformer) {
            return transformer.in(subState, key, lastState);
        }, lastState[key]);
        if (endState !== undefined) try {
            stagedState[key] = serialize(endState);
        } catch (err) {
            console.error("redux-persist/createPersistoid: error serializing state", err);
        }
        else //if the endState is undefined, no need to persist the existing serialized content
        delete stagedState[key];
        if (keysToProcess.length === 0) writeStagedState();
    }
    function writeStagedState() {
        // cleanup any removed keys just before write.
        Object.keys(stagedState).forEach(function(key) {
            if (lastState[key] === undefined) delete stagedState[key];
        });
        writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    }
    function passWhitelistBlacklist(key) {
        if (whitelist && whitelist.indexOf(key) === -1 && key !== "_persist") return false;
        if (blacklist && blacklist.indexOf(key) !== -1) return false;
        return true;
    }
    function onWriteFail(err) {
        // @TODO add fail handlers (typically storage full)
        if (writeFailHandler) writeFailHandler(err);
    }
    var flush = function flush() {
        while(keysToProcess.length !== 0)processNextKey();
        return writePromise || Promise.resolve();
    }; // return `persistoid`
    return {
        update: update,
        flush: flush
    };
} // @NOTE in the future this may be exposed via config
function $28ee1925742e823a$var$defaultSerialize(data) {
    return JSON.stringify(data);
}



function $57b27d8f7859db32$export$2e2bcd8739ae039(config) {
    var transforms = config.transforms || [];
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $3e9167b9503b8931$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var debug = config.debug;
    var deserialize;
    if (config.deserialize === false) deserialize = function deserialize(x) {
        return x;
    };
    else if (typeof config.deserialize === "function") deserialize = config.deserialize;
    else deserialize = $57b27d8f7859db32$var$defaultDeserialize;
    return storage.getItem(storageKey).then(function(serialized) {
        if (!serialized) return undefined;
        else try {
            var state = {};
            var rawState = deserialize(serialized);
            Object.keys(rawState).forEach(function(key) {
                state[key] = transforms.reduceRight(function(subState, transformer) {
                    return transformer.out(subState, key, rawState);
                }, deserialize(rawState[key]));
            });
            return state;
        } catch (err) {
            throw err;
        }
    });
}
function $57b27d8f7859db32$var$defaultDeserialize(serial) {
    return JSON.parse(serial);
}



function $b70b1670a07cb2cb$export$2e2bcd8739ae039(config) {
    var storage = config.storage;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $3e9167b9503b8931$export$711117ad6ad27992)).concat(config.key);
    return storage.removeItem(storageKey, $b70b1670a07cb2cb$var$warnIfRemoveError);
}
function $b70b1670a07cb2cb$var$warnIfRemoveError(err) {}


function $a48ed584738bab49$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a48ed584738bab49$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a48ed584738bab49$var$ownKeys(source, true).forEach(function(key) {
            $a48ed584738bab49$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a48ed584738bab49$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a48ed584738bab49$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a48ed584738bab49$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a48ed584738bab49$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a48ed584738bab49$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a48ed584738bab49$var$DEFAULT_TIMEOUT = 5000;
function $a48ed584738bab49$export$2e2bcd8739ae039(config, baseReducer) {
    var version = config.version !== undefined ? config.version : (0, $3e9167b9503b8931$export$363ebe89e6e7aeef);
    var debug = config.debug || false;
    var stateReconciler = config.stateReconciler === undefined ? (0, $cb7f7e5c31054b73$export$2e2bcd8739ae039) : config.stateReconciler;
    var getStoredState = config.getStoredState || (0, $57b27d8f7859db32$export$2e2bcd8739ae039);
    var timeout = config.timeout !== undefined ? config.timeout : $a48ed584738bab49$var$DEFAULT_TIMEOUT;
    var _persistoid = null;
    var _purge = false;
    var _paused = true;
    var conditionalUpdate = function conditionalUpdate(state) {
        // update the persistoid only if we are rehydrated and not paused
        state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
        return state;
    };
    return function(state, action) {
        var _ref = state || {}, _persist = _ref._persist, rest = $a48ed584738bab49$var$_objectWithoutProperties(_ref, [
            "_persist"
        ]); // $FlowIgnore need to update State type
        var restState = rest;
        if (action.type === (0, $3e9167b9503b8931$export$913fe0e161ed92a2)) {
            var _sealed = false;
            var _rehydrate = function _rehydrate(payload, err) {
                if (!_sealed) {
                    action.rehydrate(config.key, payload, err);
                    _sealed = true;
                }
            };
            timeout && setTimeout(function() {
                !_sealed && _rehydrate(undefined, new Error('redux-persist: persist timed out for persist key "'.concat(config.key, '"')));
            }, timeout); // @NOTE PERSIST resumes if paused.
            _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
            if (!_persistoid) _persistoid = (0, $28ee1925742e823a$export$2e2bcd8739ae039)(config); // @NOTE PERSIST can be called multiple times, noop after the first
            if (_persist) // We still need to call the base reducer because there might be nested
            // uses of persistReducer which need to be aware of the PERSIST action
            return $a48ed584738bab49$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
            if (typeof action.rehydrate !== "function" || typeof action.register !== "function") throw new Error("redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.");
            action.register(config.key);
            getStoredState(config).then(function(restoredState) {
                var migrate = config.migrate || function(s, v) {
                    return Promise.resolve(s);
                };
                migrate(restoredState, version).then(function(migratedState) {
                    _rehydrate(migratedState);
                }, function(migrateErr) {
                    _rehydrate(undefined, migrateErr);
                });
            }, function(err) {
                _rehydrate(undefined, err);
            });
            return $a48ed584738bab49$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: {
                    version: version,
                    rehydrated: false
                }
            });
        } else if (action.type === (0, $3e9167b9503b8931$export$5514fc3b4067675f)) {
            _purge = true;
            action.result((0, $b70b1670a07cb2cb$export$2e2bcd8739ae039)(config));
            return $a48ed584738bab49$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $3e9167b9503b8931$export$2aaee4793dd13a52)) {
            action.result(_persistoid && _persistoid.flush());
            return $a48ed584738bab49$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $3e9167b9503b8931$export$dd1033c27a16bbd3)) _paused = true;
        else if (action.type === (0, $3e9167b9503b8931$export$1647ef958242c4e2)) {
            // noop on restState if purging
            if (_purge) return $a48ed584738bab49$var$_objectSpread({}, restState, {
                _persist: $a48ed584738bab49$var$_objectSpread({}, _persist, {
                    rehydrated: true
                }) // @NOTE if key does not match, will continue to default else below
            });
            if (action.key === config.key) {
                var reducedState = baseReducer(restState, action);
                var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined
                var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;
                var _newState = $a48ed584738bab49$var$_objectSpread({}, reconciledRest, {
                    _persist: $a48ed584738bab49$var$_objectSpread({}, _persist, {
                        rehydrated: true
                    })
                });
                return conditionalUpdate(_newState);
            }
        } // if we have not already handled PERSIST, straight passthrough
        if (!_persist) return baseReducer(state, action); // run base reducer:
        // is state modified ? return original : return updated
        var newState = baseReducer(restState, action);
        if (newState === restState) return state;
        return conditionalUpdate($a48ed584738bab49$var$_objectSpread({}, newState, {
            _persist: _persist
        }));
    };
}




function $d3a3251829fe7871$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d3a3251829fe7871$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d3a3251829fe7871$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d3a3251829fe7871$var$_typeof(obj);
}
function $d3a3251829fe7871$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d3a3251829fe7871$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d3a3251829fe7871$var$ownKeys(source, true).forEach(function(key) {
            $d3a3251829fe7871$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d3a3251829fe7871$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d3a3251829fe7871$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d3a3251829fe7871$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $d3a3251829fe7871$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $d3a3251829fe7871$var$_typeof(inboundState) === "object") Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === "_persist") return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
        if ($d3a3251829fe7871$var$isPlainEnoughObject(reducedState[key])) {
            // if object is plain enough shallow merge the new values (hence "Level2")
            newState[key] = $d3a3251829fe7871$var$_objectSpread({}, newState[key], {}, inboundState[key]);
            return;
        } // otherwise hard set
        newState[key] = inboundState[key];
    });
    return newState;
}
function $d3a3251829fe7871$var$isPlainEnoughObject(o) {
    return o !== null && !Array.isArray(o) && $d3a3251829fe7871$var$_typeof(o) === "object";
}


function $228d6bb06fb0e924$export$2e2bcd8739ae039(config, reducers) {
    config.stateReconciler = config.stateReconciler === undefined ? (0, $d3a3251829fe7871$export$2e2bcd8739ae039) : config.stateReconciler;
    return (0, $a48ed584738bab49$export$2e2bcd8739ae039)(config, (0, $5c178e598efca549$export$66e4520cdb265d18)(reducers));
}




function $b0e8dc2b8938c053$var$_toConsumableArray(arr) {
    return $b0e8dc2b8938c053$var$_arrayWithoutHoles(arr) || $b0e8dc2b8938c053$var$_iterableToArray(arr) || $b0e8dc2b8938c053$var$_nonIterableSpread();
}
function $b0e8dc2b8938c053$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $b0e8dc2b8938c053$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $b0e8dc2b8938c053$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $b0e8dc2b8938c053$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b0e8dc2b8938c053$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b0e8dc2b8938c053$var$ownKeys(source, true).forEach(function(key) {
            $b0e8dc2b8938c053$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b0e8dc2b8938c053$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b0e8dc2b8938c053$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $b0e8dc2b8938c053$var$initialState = {
    registry: [],
    bootstrapped: false
};
var $b0e8dc2b8938c053$var$persistorReducer = function persistorReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $b0e8dc2b8938c053$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $3e9167b9503b8931$export$51e82cdd7353a0e1:
            return $b0e8dc2b8938c053$var$_objectSpread({}, state, {
                registry: [].concat($b0e8dc2b8938c053$var$_toConsumableArray(state.registry), [
                    action.key
                ])
            });
        case 0, $3e9167b9503b8931$export$1647ef958242c4e2:
            var firstIndex = state.registry.indexOf(action.key);
            var registry = $b0e8dc2b8938c053$var$_toConsumableArray(state.registry);
            registry.splice(firstIndex, 1);
            return $b0e8dc2b8938c053$var$_objectSpread({}, state, {
                registry: registry,
                bootstrapped: registry.length === 0
            });
        default:
            return state;
    }
};
function $b0e8dc2b8938c053$export$2e2bcd8739ae039(store, options, cb) {
    var optionsToTest, bannedKeys;
    var boostrappedCb = cb || false;
    var _pStore = (0, $5c178e598efca549$export$f51a9068ac82ea43)($b0e8dc2b8938c053$var$persistorReducer, $b0e8dc2b8938c053$var$initialState, options && options.enhancer ? options.enhancer : undefined);
    var register = function register(key) {
        _pStore.dispatch({
            type: (0, $3e9167b9503b8931$export$51e82cdd7353a0e1),
            key: key
        });
    };
    var rehydrate = function rehydrate(key, payload, err) {
        var rehydrateAction = {
            type: (0, $3e9167b9503b8931$export$1647ef958242c4e2),
            payload: payload,
            err: err,
            key: key // dispatch to `store` to rehydrate and `persistor` to track result
        };
        store.dispatch(rehydrateAction);
        _pStore.dispatch(rehydrateAction);
        if (boostrappedCb && persistor.getState().bootstrapped) {
            boostrappedCb();
            boostrappedCb = false;
        }
    };
    var persistor = $b0e8dc2b8938c053$var$_objectSpread({}, _pStore, {
        purge: function purge() {
            var results = [];
            store.dispatch({
                type: (0, $3e9167b9503b8931$export$5514fc3b4067675f),
                result: function result(purgeResult) {
                    results.push(purgeResult);
                }
            });
            return Promise.all(results);
        },
        flush: function flush() {
            var results = [];
            store.dispatch({
                type: (0, $3e9167b9503b8931$export$2aaee4793dd13a52),
                result: function result(flushResult) {
                    results.push(flushResult);
                }
            });
            return Promise.all(results);
        },
        pause: function pause() {
            store.dispatch({
                type: (0, $3e9167b9503b8931$export$dd1033c27a16bbd3)
            });
        },
        persist: function persist() {
            store.dispatch({
                type: (0, $3e9167b9503b8931$export$913fe0e161ed92a2),
                register: register,
                rehydrate: rehydrate
            });
        }
    });
    if (!(options && options.manualPersist)) persistor.persist();
    return persistor;
}



function $4efebc71d7ca038f$export$2e2bcd8739ae039(migrations, config) {
    var _ref = config || {}, debug = _ref.debug;
    return function(state, currentVersion) {
        if (!state) return Promise.resolve(undefined);
        var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : (0, $3e9167b9503b8931$export$363ebe89e6e7aeef);
        if (inboundVersion === currentVersion) return Promise.resolve(state);
        if (inboundVersion > currentVersion) return Promise.resolve(state);
        var migrationKeys = Object.keys(migrations).map(function(ver) {
            return parseInt(ver);
        }).filter(function(key) {
            return currentVersion >= key && key > inboundVersion;
        }).sort(function(a, b) {
            return a - b;
        });
        try {
            var migratedState = migrationKeys.reduce(function(state, versionKey) {
                return migrations[versionKey](state);
            }, state);
            return Promise.resolve(migratedState);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}


function $247c4c3fa6d98096$export$2e2bcd8739ae039(inbound, outbound) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var whitelist = config.whitelist || null;
    var blacklist = config.blacklist || null;
    function whitelistBlacklistCheck(key) {
        if (whitelist && whitelist.indexOf(key) === -1) return true;
        if (blacklist && blacklist.indexOf(key) !== -1) return true;
        return false;
    }
    return {
        in: function _in(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
        },
        out: function out(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
        }
    };
}









var $tZqWC = parcelRequire("tZqWC");
function $13ecfebde8ebdf60$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $13ecfebde8ebdf60$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $13ecfebde8ebdf60$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $13ecfebde8ebdf60$var$_typeof(obj);
}
function $13ecfebde8ebdf60$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $13ecfebde8ebdf60$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $13ecfebde8ebdf60$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $13ecfebde8ebdf60$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $13ecfebde8ebdf60$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $13ecfebde8ebdf60$var$_possibleConstructorReturn(self, call) {
    if (call && ($13ecfebde8ebdf60$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $13ecfebde8ebdf60$var$_assertThisInitialized(self);
}
function $13ecfebde8ebdf60$var$_getPrototypeOf(o) {
    $13ecfebde8ebdf60$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $13ecfebde8ebdf60$var$_getPrototypeOf(o);
}
function $13ecfebde8ebdf60$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $13ecfebde8ebdf60$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $13ecfebde8ebdf60$var$_setPrototypeOf(subClass, superClass);
}
function $13ecfebde8ebdf60$var$_setPrototypeOf(o, p) {
    $13ecfebde8ebdf60$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $13ecfebde8ebdf60$var$_setPrototypeOf(o, p);
}
function $13ecfebde8ebdf60$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $13ecfebde8ebdf60$export$311ca220e7478cda = /*#__PURE__*/ function(_PureComponent) {
    $13ecfebde8ebdf60$var$_inherits(PersistGate, _PureComponent);
    function PersistGate() {
        var _getPrototypeOf2;
        var _this;
        $13ecfebde8ebdf60$var$_classCallCheck(this, PersistGate);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $13ecfebde8ebdf60$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $13ecfebde8ebdf60$var$_getPrototypeOf(PersistGate)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $13ecfebde8ebdf60$var$_defineProperty($13ecfebde8ebdf60$var$_assertThisInitialized(_this), "state", {
            bootstrapped: false
        });
        $13ecfebde8ebdf60$var$_defineProperty($13ecfebde8ebdf60$var$_assertThisInitialized(_this), "_unsubscribe", void 0);
        $13ecfebde8ebdf60$var$_defineProperty($13ecfebde8ebdf60$var$_assertThisInitialized(_this), "handlePersistorState", function() {
            var persistor = _this.props.persistor;
            var _persistor$getState = persistor.getState(), bootstrapped = _persistor$getState.bootstrapped;
            if (bootstrapped) {
                if (_this.props.onBeforeLift) Promise.resolve(_this.props.onBeforeLift()).finally(function() {
                    return _this.setState({
                        bootstrapped: true
                    });
                });
                else _this.setState({
                    bootstrapped: true
                });
                _this._unsubscribe && _this._unsubscribe();
            }
        });
        return _this;
    }
    $13ecfebde8ebdf60$var$_createClass(PersistGate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
                this.handlePersistorState();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._unsubscribe && this._unsubscribe();
            }
        },
        {
            key: "render",
            value: function render() {
                if (typeof this.props.children === "function") return this.props.children(this.state.bootstrapped);
                return this.state.bootstrapped ? this.props.children : this.props.loading;
            }
        }
    ]);
    return PersistGate;
}((0, $tZqWC.PureComponent));
$13ecfebde8ebdf60$var$_defineProperty($13ecfebde8ebdf60$export$311ca220e7478cda, "defaultProps", {
    children: null,
    loading: null
});


var $fb9370d62a468f4f$export$1e511d4a378977f5;
var $fb9370d62a468f4f$export$2e2bcd8739ae039;
"use strict";
$fb9370d62a468f4f$export$1e511d4a378977f5 = true;
$fb9370d62a468f4f$export$2e2bcd8739ae039 = void 0;

var $fb9370d62a468f4f$var$_createWebStorage = $fb9370d62a468f4f$var$_interopRequireDefault((parcelRequire("hrvvF")));
function $fb9370d62a468f4f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fb9370d62a468f4f$var$_default = (0, $fb9370d62a468f4f$var$_createWebStorage.default)("local");
$fb9370d62a468f4f$export$2e2bcd8739ae039 = $fb9370d62a468f4f$var$_default;



var $4L3zM = parcelRequire("4L3zM");


const $92860901d8aca1fe$var$initialState = {
    isLoggedIn: true,
    hasAccessToFeatures: true,
    userToDeact: {}
};
const $92860901d8aca1fe$var$store = (0, $def02af5c61b0dea$export$4d8d9bd83c24ae8b)({
    name: "auth",
    initialState: $92860901d8aca1fe$var$initialState,
    reducers: {
        updateRole: (state)=>{
            state.role = "dev";
        },
        updateAccessToFeatures: (state, { payload: payload })=>{
            if (payload) state.hasAccessToFeatures = payload;
            else state.hasAccessToFeatures = true;
        },
        setUserToDeact: (state, { payload: payload })=>{
            if (payload) state.userToDeact = payload;
            else state.userToDeact = null;
        }
    }
});
var $92860901d8aca1fe$export$2e2bcd8739ae039 = $92860901d8aca1fe$var$store;


const $2154a4c08d887b32$var$actionList = {
    ...(0, $92860901d8aca1fe$export$2e2bcd8739ae039).actions
};
const $2154a4c08d887b32$var$reducerList = {
    auth: (0, $92860901d8aca1fe$export$2e2bcd8739ae039).reducer
};
const $2154a4c08d887b32$export$76bc82b2dd65d969 = (0, $5c178e598efca549$export$66e4520cdb265d18)($2154a4c08d887b32$var$reducerList);
const $2154a4c08d887b32$export$e324594224ef24da = (dispatch)=>({
        actions: (0, $5c178e598efca549$export$aea084d96e84da92)($2154a4c08d887b32$var$actionList, dispatch)
    });


function $ea5d2799a316b2c2$var$AppStoreProvider(props) {
    // Destructure
    const { children: children } = props;
    // Variables
    const persistConfig = {
        key: "root",
        blacklist: [
            "alert",
            "ui",
            "filters",
            "address",
            "transaction"
        ],
        storage: $fb9370d62a468f4f$export$2e2bcd8739ae039
    };
    const persistedReducer = (0, $a48ed584738bab49$export$2e2bcd8739ae039)(persistConfig, (0, $2154a4c08d887b32$export$76bc82b2dd65d969));
    const store = (0, $def02af5c61b0dea$export$7d8a5b498da695ac)({
        reducer: persistedReducer,
        middleware: (0, $def02af5c61b0dea$export$36c1185aeee5b0a6)({
            serializableCheck: false
        })
    });
    const persistor = (0, $b0e8dc2b8938c053$export$2e2bcd8739ae039)(store);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $44a4de761c3016e3$export$2e2bcd8739ae039), {
        store: store,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13ecfebde8ebdf60$export$311ca220e7478cda), {
            loading: null,
            persistor: persistor,
            children: children
        })
    });
}
var $ea5d2799a316b2c2$export$2e2bcd8739ae039 = $ea5d2799a316b2c2$var$AppStoreProvider;
// Proptypes Validation
$ea5d2799a316b2c2$var$AppStoreProvider.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]).isRequired
};



parcelRequire("tZqWC");

var $j1NUG = parcelRequire("j1NUG");

var $j1NUG = parcelRequire("j1NUG");
var $3ff4724ea894d7ab$export$6acf61af03e62db = typeof window === "undefined";
function $3ff4724ea894d7ab$export$8793edee2d425525() {
    return undefined;
}
function $3ff4724ea894d7ab$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $3ff4724ea894d7ab$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $3ff4724ea894d7ab$export$4d32d63f64b825b9(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $3ff4724ea894d7ab$export$acaf96a27438246b(array1, array2) {
    return array1.filter(function(x) {
        return array2.indexOf(x) === -1;
    });
}
function $3ff4724ea894d7ab$export$224e3b7078227b8a(array, index, value) {
    var copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $3ff4724ea894d7ab$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $3ff4724ea894d7ab$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$3ff4724ea894d7ab$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === "function") return (0, $j1NUG.default)({}, arg3, {
        queryKey: arg1,
        queryFn: arg2
    });
    return (0, $j1NUG.default)({}, arg2, {
        queryKey: arg1
    });
}
function $3ff4724ea894d7ab$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($3ff4724ea894d7ab$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === "function") return (0, $j1NUG.default)({}, arg3, {
            mutationKey: arg1,
            mutationFn: arg2
        });
        return (0, $j1NUG.default)({}, arg2, {
            mutationKey: arg1
        });
    }
    if (typeof arg1 === "function") return (0, $j1NUG.default)({}, arg2, {
        mutationFn: arg1
    });
    return (0, $j1NUG.default)({}, arg1);
}
function $3ff4724ea894d7ab$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $3ff4724ea894d7ab$export$aaae5295ec3351c9(arg1) ? [
        (0, $j1NUG.default)({}, arg2, {
            queryKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $3ff4724ea894d7ab$export$42387eeaac09cf54(arg1, arg2) {
    return $3ff4724ea894d7ab$export$aaae5295ec3351c9(arg1) ? (0, $j1NUG.default)({}, arg2, {
        mutationKey: arg1
    }) : arg1;
}
function $3ff4724ea894d7ab$export$eafbe052e989494f(active, inactive) {
    if (active === true && inactive === true || active == null && inactive == null) return "all";
    else if (active === false && inactive === false) return "none";
    else {
        // At this point, active|inactive can only be true|false or false|true
        // so, when only one value is provided, the missing one has to be the negated value
        var isActive = active != null ? active : !inactive;
        return isActive ? "active" : "inactive";
    }
}
function $3ff4724ea894d7ab$export$c5d1efe363797780(filters, query) {
    var active = filters.active, exact = filters.exact, fetching = filters.fetching, inactive = filters.inactive, predicate = filters.predicate, queryKey = filters.queryKey, stale = filters.stale;
    if ($3ff4724ea894d7ab$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $3ff4724ea894d7ab$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$3ff4724ea894d7ab$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    var queryStatusFilter = $3ff4724ea894d7ab$export$eafbe052e989494f(active, inactive);
    if (queryStatusFilter === "none") return false;
    else if (queryStatusFilter !== "all") {
        var isActive = query.isActive();
        if (queryStatusFilter === "active" && !isActive) return false;
        if (queryStatusFilter === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetching === "boolean" && query.isFetching() !== fetching) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $3ff4724ea894d7ab$export$a1ea5fb559f63ae3(filters, mutation) {
    var exact = filters.exact, fetching = filters.fetching, predicate = filters.predicate, mutationKey = filters.mutationKey;
    if ($3ff4724ea894d7ab$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($3ff4724ea894d7ab$export$5fcb678681417b54(mutation.options.mutationKey) !== $3ff4724ea894d7ab$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$3ff4724ea894d7ab$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $3ff4724ea894d7ab$export$cc90ca97bc0d73fd(queryKey, options) {
    var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $3ff4724ea894d7ab$export$5fcb678681417b54;
    return hashFn(queryKey);
}
function $3ff4724ea894d7ab$export$5fcb678681417b54(queryKey) {
    var asArray = $3ff4724ea894d7ab$export$4d32d63f64b825b9(queryKey);
    return $3ff4724ea894d7ab$export$e7f2f041280beb00(asArray);
}
function $3ff4724ea894d7ab$export$e7f2f041280beb00(value) {
    return JSON.stringify(value, function(_, val) {
        return $3ff4724ea894d7ab$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce(function(result, key) {
            result[key] = val[key];
            return result;
        }, {}) : val;
    });
}
function $3ff4724ea894d7ab$export$2f07189bb9fa26a7(a, b) {
    return $3ff4724ea894d7ab$export$3bc9138b70293839($3ff4724ea894d7ab$export$4d32d63f64b825b9(a), $3ff4724ea894d7ab$export$4d32d63f64b825b9(b));
}
function $3ff4724ea894d7ab$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some(function(key) {
        return !$3ff4724ea894d7ab$export$3bc9138b70293839(a[key], b[key]);
    });
    return false;
}
function $3ff4724ea894d7ab$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    var array = Array.isArray(a) && Array.isArray(b);
    if (array || $3ff4724ea894d7ab$export$53b83ca8eaab0383(a) && $3ff4724ea894d7ab$export$53b83ca8eaab0383(b)) {
        var aSize = array ? a.length : Object.keys(a).length;
        var bItems = array ? b : Object.keys(b);
        var bSize = bItems.length;
        var copy = array ? [] : {};
        var equalItems = 0;
        for(var i = 0; i < bSize; i++){
            var key = array ? i : bItems[i];
            copy[key] = $3ff4724ea894d7ab$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $3ff4724ea894d7ab$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(var key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $3ff4724ea894d7ab$export$53b83ca8eaab0383(o) {
    if (!$3ff4724ea894d7ab$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    var ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    var prot = ctor.prototype;
    if (!$3ff4724ea894d7ab$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function $3ff4724ea894d7ab$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $3ff4724ea894d7ab$export$aaae5295ec3351c9(value) {
    return typeof value === "string" || Array.isArray(value);
}
function $3ff4724ea894d7ab$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $3ff4724ea894d7ab$export$e772c8ff12451969(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $3ff4724ea894d7ab$export$4304cb76768ca134(callback) {
    Promise.resolve().then(callback).catch(function(error) {
        return setTimeout(function() {
            throw error;
        });
    });
}
function $3ff4724ea894d7ab$export$382ca5d13a8f252c() {
    if (typeof AbortController === "function") return new AbortController();
}



var $1gxF5 = parcelRequire("1gxF5");


var $j1NUG = parcelRequire("j1NUG");


var $290db3e0ce227fd3$export$c3ab47f7c70c8aa4 = /*#__PURE__*/ function() {
    function NotifyManager() {
        this.queue = [];
        this.transactions = 0;
        this.notifyFn = function(callback) {
            callback();
        };
        this.batchNotifyFn = function(callback) {
            callback();
        };
    }
    var _proto = NotifyManager.prototype;
    _proto.batch = function batch(callback) {
        var result;
        this.transactions++;
        try {
            result = callback();
        } finally{
            this.transactions--;
            if (!this.transactions) this.flush();
        }
        return result;
    };
    _proto.schedule = function schedule(callback) {
        var _this = this;
        if (this.transactions) this.queue.push(callback);
        else (0, $3ff4724ea894d7ab$export$4304cb76768ca134)(function() {
            _this.notifyFn(callback);
        });
    } /**
   * All calls to the wrapped function will be batched.
   */ ;
    _proto.batchCalls = function batchCalls(callback) {
        var _this2 = this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this2.schedule(function() {
                callback.apply(void 0, args);
            });
        };
    };
    _proto.flush = function flush() {
        var _this3 = this;
        var queue = this.queue;
        this.queue = [];
        if (queue.length) (0, $3ff4724ea894d7ab$export$4304cb76768ca134)(function() {
            _this3.batchNotifyFn(function() {
                queue.forEach(function(callback) {
                    _this3.notifyFn(callback);
                });
            });
        });
    } /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ ;
    _proto.setNotifyFunction = function setNotifyFunction(fn) {
        this.notifyFn = fn;
    } /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ ;
    _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
        this.batchNotifyFn = fn;
    };
    return NotifyManager;
}(); // SINGLETON
var $290db3e0ce227fd3$export$520687f44db6e1ab = new $290db3e0ce227fd3$export$c3ab47f7c70c8aa4();


// TYPES
// FUNCTIONS
var $9489c5e76e62cc56$var$logger = console;
function $9489c5e76e62cc56$export$2b1d391cd05230fd() {
    return $9489c5e76e62cc56$var$logger;
}
function $9489c5e76e62cc56$export$3abbd92f765bee58(newLogger) {
    $9489c5e76e62cc56$var$logger = newLogger;
}



var $1gxF5 = parcelRequire("1gxF5");
var $8d9dbc58b3471196$export$d26086b469ecdbcc = /*#__PURE__*/ function() {
    function Subscribable() {
        this.listeners = [];
    }
    var _proto = Subscribable.prototype;
    _proto.subscribe = function subscribe(listener) {
        var _this = this;
        var callback = listener || function() {
            return undefined;
        };
        this.listeners.push(callback);
        this.onSubscribe();
        return function() {
            _this.listeners = _this.listeners.filter(function(x) {
                return x !== callback;
            });
            _this.onUnsubscribe();
        };
    };
    _proto.hasListeners = function hasListeners() {
        return this.listeners.length > 0;
    };
    _proto.onSubscribe = function onSubscribe() {};
    _proto.onUnsubscribe = function onUnsubscribe() {};
    return Subscribable;
}();



var $3fbc886baa2b733b$export$86f1af424b2ca4de = /*#__PURE__*/ function(_Subscribable) {
    (0, $1gxF5.default)(FocusManager, _Subscribable);
    function FocusManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onFocus) {
            var _window;
            if (!(0, $3ff4724ea894d7ab$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onFocus();
                }; // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
        };
        return _this;
    }
    var _proto = FocusManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(focused) {
            if (typeof focused === "boolean") _this2.setFocused(focused);
            else _this2.onFocus();
        });
    };
    _proto.setFocused = function setFocused(focused) {
        this.focused = focused;
        if (focused) this.onFocus();
    };
    _proto.onFocus = function onFocus() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isFocused = function isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    };
    return FocusManager;
}((0, $8d9dbc58b3471196$export$d26086b469ecdbcc));
var $3fbc886baa2b733b$export$6bf54661be5b02cf = new $3fbc886baa2b733b$export$86f1af424b2ca4de();



var $1gxF5 = parcelRequire("1gxF5");


var $e9ce68e672abc0c9$export$58774fb55d5ff7fc = /*#__PURE__*/ function(_Subscribable) {
    (0, $1gxF5.default)(OnlineManager, _Subscribable);
    function OnlineManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onOnline) {
            var _window;
            if (!(0, $3ff4724ea894d7ab$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onOnline();
                }; // Listen to online
                window.addEventListener("online", listener, false);
                window.addEventListener("offline", listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("online", listener);
                    window.removeEventListener("offline", listener);
                };
            }
        };
        return _this;
    }
    var _proto = OnlineManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(online) {
            if (typeof online === "boolean") _this2.setOnline(online);
            else _this2.onOnline();
        });
    };
    _proto.setOnline = function setOnline(online) {
        this.online = online;
        if (online) this.onOnline();
    };
    _proto.onOnline = function onOnline() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isOnline = function isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    };
    return OnlineManager;
}((0, $8d9dbc58b3471196$export$d26086b469ecdbcc));
var $e9ce68e672abc0c9$export$b113e788b2dd3fdc = new $e9ce68e672abc0c9$export$58774fb55d5ff7fc();



function $23ca15fd0fb4402b$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * Math.pow(2, failureCount), 30000);
}
function $23ca15fd0fb4402b$export$22e08d49843051be(value) {
    return typeof (value == null ? void 0 : value.cancel) === "function";
}
var $23ca15fd0fb4402b$export$a8430ed4188f35a9 = function CancelledError(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
};
function $23ca15fd0fb4402b$export$986cc6445c1d323(value) {
    return value instanceof $23ca15fd0fb4402b$export$a8430ed4188f35a9;
} // CLASS
var $23ca15fd0fb4402b$export$586a619a4618a582 = function Retryer(config) {
    var _this = this;
    var cancelRetry = false;
    var cancelFn;
    var continueFn;
    var promiseResolve;
    var promiseReject;
    this.abort = config.abort;
    this.cancel = function(cancelOptions) {
        return cancelFn == null ? void 0 : cancelFn(cancelOptions);
    };
    this.cancelRetry = function() {
        cancelRetry = true;
    };
    this.continueRetry = function() {
        cancelRetry = false;
    };
    this.continue = function() {
        return continueFn == null ? void 0 : continueFn();
    };
    this.failureCount = 0;
    this.isPaused = false;
    this.isResolved = false;
    this.isTransportCancelable = false;
    this.promise = new Promise(function(outerResolve, outerReject) {
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    var resolve = function resolve(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    var reject = function reject(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    var pause = function pause() {
        return new Promise(function(continueResolve) {
            continueFn = continueResolve;
            _this.isPaused = true;
            config.onPause == null || config.onPause();
        }).then(function() {
            continueFn = undefined;
            _this.isPaused = false;
            config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    var run = function run() {
        // Do nothing if already resolved
        if (_this.isResolved) return;
        var promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        } // Create callback to cancel this fetch
        cancelFn = function cancelFn(cancelOptions) {
            if (!_this.isResolved) {
                reject(new $23ca15fd0fb4402b$export$a8430ed4188f35a9(cancelOptions));
                _this.abort == null || _this.abort(); // Cancel transport if supported
                if ($23ca15fd0fb4402b$export$22e08d49843051be(promiseOrValue)) try {
                    promiseOrValue.cancel();
                } catch (_unused) {}
            }
        }; // Check if the transport layer support cancellation
        _this.isTransportCancelable = $23ca15fd0fb4402b$export$22e08d49843051be(promiseOrValue);
        Promise.resolve(promiseOrValue).then(resolve).catch(function(error) {
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (_this.isResolved) return;
             // Do we need to retry the request?
            var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $23ca15fd0fb4402b$var$defaultRetryDelay;
            var delay = typeof retryDelay === "function" ? retryDelay(_this.failureCount, error) : retryDelay;
            var shouldRetry = retry === true || typeof retry === "number" && _this.failureCount < retry || typeof retry === "function" && retry(_this.failureCount, error);
            if (cancelRetry || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            _this.failureCount++; // Notify on fail
            config.onFail == null || config.onFail(_this.failureCount, error); // Delay
            (0, $3ff4724ea894d7ab$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(function() {
                if (!(0, $3fbc886baa2b733b$export$6bf54661be5b02cf).isFocused() || !(0, $e9ce68e672abc0c9$export$b113e788b2dd3fdc).isOnline()) return pause();
            }).then(function() {
                if (cancelRetry) reject(error);
                else run();
            });
        });
    }; // Start loop
    run();
};


var $165e83600d2914fb$export$62297b13309008b2 = /*#__PURE__*/ function() {
    function Query(config) {
        this.abortSignalConsumed = false;
        this.hadObservers = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || this.getDefaultState(this.options);
        this.state = this.initialState;
        this.meta = config.meta;
        this.scheduleGc();
    }
    var _proto = Query.prototype;
    _proto.setOptions = function setOptions(options) {
        var _this$options$cacheTi;
        this.options = (0, $j1NUG.default)({}, this.defaultOptions, options);
        this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 300000);
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.scheduleGc = function scheduleGc() {
        var _this = this;
        this.clearGcTimeout();
        if ((0, $3ff4724ea894d7ab$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(function() {
            _this.optionalRemove();
        }, this.cacheTime);
    };
    _proto.clearGcTimeout = function clearGcTimeout() {
        clearTimeout(this.gcTimeout);
        this.gcTimeout = undefined;
    };
    _proto.optionalRemove = function optionalRemove() {
        if (!this.observers.length) {
            if (this.state.isFetching) {
                if (this.hadObservers) this.scheduleGc();
            } else this.cache.remove(this);
        }
    };
    _proto.setData = function setData(updater, options) {
        var _this$options$isDataE, _this$options;
        var prevData = this.state.data; // Get the new data
        var data = (0, $3ff4724ea894d7ab$export$7f095f455ad5af3f)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`
        if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) data = prevData;
        else if (this.options.structuralSharing !== false) // Structurally share data between prev and new data if needed
        data = (0, $3ff4724ea894d7ab$export$77a71fc411098696)(prevData, data);
         // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt
        });
        return data;
    };
    _proto.setState = function setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    };
    _proto.cancel = function cancel(options) {
        var _this$retryer;
        var promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $3ff4724ea894d7ab$export$8793edee2d425525)).catch((0, $3ff4724ea894d7ab$export$8793edee2d425525)) : Promise.resolve();
    };
    _proto.destroy = function destroy() {
        this.clearGcTimeout();
        this.cancel({
            silent: true
        });
    };
    _proto.reset = function reset() {
        this.destroy();
        this.setState(this.initialState);
    };
    _proto.isActive = function isActive() {
        return this.observers.some(function(observer) {
            return observer.options.enabled !== false;
        });
    };
    _proto.isFetching = function isFetching() {
        return this.state.isFetching;
    };
    _proto.isStale = function isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function(observer) {
            return observer.getCurrentResult().isStale;
        });
    };
    _proto.isStaleByTime = function isStaleByTime(staleTime) {
        if (staleTime === void 0) staleTime = 0;
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $3ff4724ea894d7ab$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    };
    _proto.onFocus = function onFocus() {
        var _this$retryer2;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnWindowFocus();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    };
    _proto.onOnline = function onOnline() {
        var _this$retryer3;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnReconnect();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer);
            this.hadObservers = true; // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    };
    _proto.removeObserver = function removeObserver(observer) {
        if (this.observers.indexOf(observer) !== -1) {
            this.observers = this.observers.filter(function(x) {
                return x !== observer;
            });
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.retryer.isTransportCancelable || this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                if (this.cacheTime) this.scheduleGc();
                else this.cache.remove(this);
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    };
    _proto.getObserversCount = function getObserversCount() {
        return this.observers.length;
    };
    _proto.invalidate = function invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    };
    _proto.fetch = function fetch(options, fetchOptions) {
        var _this2 = this, _this$options$behavio, _context$fetchOptions, _abortController$abor;
        if (this.state.isFetching) {
            if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            var observer = this.observers.find(function(x) {
                return x.options.queryFn;
            });
            if (observer) this.setOptions(observer.options);
        }
        var queryKey = (0, $3ff4724ea894d7ab$export$4d32d63f64b825b9)(this.queryKey);
        var abortController = (0, $3ff4724ea894d7ab$export$382ca5d13a8f252c)(); // Create query function context
        var queryFnContext = {
            queryKey: queryKey,
            pageParam: undefined,
            meta: this.meta
        };
        Object.defineProperty(queryFnContext, "signal", {
            enumerable: true,
            get: function get() {
                if (abortController) {
                    _this2.abortSignalConsumed = true;
                    return abortController.signal;
                }
                return undefined;
            }
        }); // Create fetch function
        var fetchFn = function fetchFn() {
            if (!_this2.options.queryFn) return Promise.reject("Missing queryFn");
            _this2.abortSignalConsumed = false;
            return _this2.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        var context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: queryKey,
            state: this.state,
            fetchFn: fetchFn,
            meta: this.meta
        };
        if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
            var _this$options$behavio2;
            (_this$options$behavio2 = this.options.behavior) == null || _this$options$behavio2.onFetch(context);
        } // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        } // Try to fetch the data
        this.retryer = new (0, $23ca15fd0fb4402b$export$586a619a4618a582)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
            onSuccess: function onSuccess(data) {
                _this2.setData(data); // Notify cache callback
                _this2.cache.config.onSuccess == null || _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onError: function onError(error) {
                // Optimistically update state if needed
                if (!((0, $23ca15fd0fb4402b$export$986cc6445c1d323)(error) && error.silent)) _this2.dispatch({
                    type: "error",
                    error: error
                });
                if (!(0, $23ca15fd0fb4402b$export$986cc6445c1d323)(error)) {
                    // Notify cache callback
                    _this2.cache.config.onError == null || _this2.cache.config.onError(error, _this2); // Log error
                    (0, $9489c5e76e62cc56$export$2b1d391cd05230fd)().error(error);
                } // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: "failed"
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: "pause"
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay
        });
        this.promise = this.retryer.promise;
        return this.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = this.reducer(this.state, action);
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onQueryUpdate(action);
            });
            _this3.cache.notify({
                query: _this3,
                type: "queryUpdated",
                action: action
            });
        });
    };
    _proto.getDefaultState = function getDefaultState(options) {
        var data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
        var hasInitialData = typeof options.initialData !== "undefined";
        var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
        var hasData = typeof data !== "undefined";
        return {
            data: data,
            dataUpdateCount: 0,
            dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
            error: null,
            errorUpdateCount: 0,
            errorUpdatedAt: 0,
            fetchFailureCount: 0,
            fetchMeta: null,
            isFetching: false,
            isInvalidated: false,
            isPaused: false,
            status: hasData ? "success" : "idle"
        };
    };
    _proto.reducer = function reducer(state, action) {
        var _action$meta, _action$dataUpdatedAt;
        switch(action.type){
            case "failed":
                return (0, $j1NUG.default)({}, state, {
                    fetchFailureCount: state.fetchFailureCount + 1
                });
            case "pause":
                return (0, $j1NUG.default)({}, state, {
                    isPaused: true
                });
            case "continue":
                return (0, $j1NUG.default)({}, state, {
                    isPaused: false
                });
            case "fetch":
                return (0, $j1NUG.default)({}, state, {
                    fetchFailureCount: 0,
                    fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                    isFetching: true,
                    isPaused: false
                }, !state.dataUpdatedAt && {
                    error: null,
                    status: "loading"
                });
            case "success":
                return (0, $j1NUG.default)({}, state, {
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                    error: null,
                    fetchFailureCount: 0,
                    isFetching: false,
                    isInvalidated: false,
                    isPaused: false,
                    status: "success"
                });
            case "error":
                var error = action.error;
                if ((0, $23ca15fd0fb4402b$export$986cc6445c1d323)(error) && error.revert && this.revertState) return (0, $j1NUG.default)({}, this.revertState);
                return (0, $j1NUG.default)({}, state, {
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    isFetching: false,
                    isPaused: false,
                    status: "error"
                });
            case "invalidate":
                return (0, $j1NUG.default)({}, state, {
                    isInvalidated: true
                });
            case "setState":
                return (0, $j1NUG.default)({}, state, action.state);
            default:
                return state;
        }
    };
    return Query;
}();




var $bd39afbd0bca7de1$export$5dde0cd941da8468 = /*#__PURE__*/ function(_Subscribable) {
    (0, $1gxF5.default)(QueryCache, _Subscribable);
    function QueryCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.queries = [];
        _this.queriesMap = {};
        return _this;
    }
    var _proto = QueryCache.prototype;
    _proto.build = function build(client, options, state) {
        var _options$queryHash;
        var queryKey = options.queryKey;
        var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $3ff4724ea894d7ab$export$cc90ca97bc0d73fd)(queryKey, options);
        var query = this.get(queryHash);
        if (!query) {
            query = new (0, $165e83600d2914fb$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey),
                meta: options.meta
            });
            this.add(query);
        }
        return query;
    };
    _proto.add = function add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "queryAdded",
                query: query
            });
        }
    };
    _proto.remove = function remove(query) {
        var queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter(function(x) {
                return x !== query;
            });
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "queryRemoved",
                query: query
            });
        }
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            _this2.queries.forEach(function(query) {
                _this2.remove(query);
            });
        });
    };
    _proto.get = function get(queryHash) {
        return this.queriesMap[queryHash];
    };
    _proto.getAll = function getAll() {
        return this.queries;
    };
    _proto.find = function find(arg1, arg2) {
        var _parseFilterArgs = (0, $3ff4724ea894d7ab$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find(function(query) {
            return (0, $3ff4724ea894d7ab$export$c5d1efe363797780)(filters, query);
        });
    };
    _proto.findAll = function findAll(arg1, arg2) {
        var _parseFilterArgs2 = (0, $3ff4724ea894d7ab$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        return Object.keys(filters).length > 0 ? this.queries.filter(function(query) {
            return (0, $3ff4724ea894d7ab$export$c5d1efe363797780)(filters, query);
        }) : this.queries;
    };
    _proto.notify = function notify(event) {
        var _this3 = this;
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(event);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        var _this4 = this;
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            _this4.queries.forEach(function(query) {
                query.onFocus();
            });
        });
    };
    _proto.onOnline = function onOnline() {
        var _this5 = this;
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            _this5.queries.forEach(function(query) {
                query.onOnline();
            });
        });
    };
    return QueryCache;
}((0, $8d9dbc58b3471196$export$d26086b469ecdbcc));



var $1gxF5 = parcelRequire("1gxF5");


var $j1NUG = parcelRequire("j1NUG");




var $74a5e2e6477d55b9$export$17b8b19c814bcf56 = /*#__PURE__*/ function() {
    function Mutation(config) {
        this.options = (0, $j1NUG.default)({}, config.defaultOptions, config.options);
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.observers = [];
        this.state = config.state || $74a5e2e6477d55b9$export$a1659b54bac3252a();
        this.meta = config.meta;
    }
    var _proto = Mutation.prototype;
    _proto.setState = function setState(state) {
        this.dispatch({
            type: "setState",
            state: state
        });
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) this.observers.push(observer);
    };
    _proto.removeObserver = function removeObserver(observer) {
        this.observers = this.observers.filter(function(x) {
            return x !== observer;
        });
    };
    _proto.cancel = function cancel() {
        if (this.retryer) {
            this.retryer.cancel();
            return this.retryer.promise.then((0, $3ff4724ea894d7ab$export$8793edee2d425525)).catch((0, $3ff4724ea894d7ab$export$8793edee2d425525));
        }
        return Promise.resolve();
    };
    _proto.continue = function _continue() {
        if (this.retryer) {
            this.retryer.continue();
            return this.retryer.promise;
        }
        return this.execute();
    };
    _proto.execute = function execute() {
        var _this = this;
        var data;
        var restored = this.state.status === "loading";
        var promise = Promise.resolve();
        if (!restored) {
            this.dispatch({
                type: "loading",
                variables: this.options.variables
            });
            promise = promise.then(function() {
                // Notify cache callback
                _this.mutationCache.config.onMutate == null || _this.mutationCache.config.onMutate(_this.state.variables, _this);
            }).then(function() {
                return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
            }).then(function(context) {
                if (context !== _this.state.context) _this.dispatch({
                    type: "loading",
                    context: context,
                    variables: _this.state.variables
                });
            });
        }
        return promise.then(function() {
            return _this.executeMutation();
        }).then(function(result) {
            data = result; // Notify cache callback
            _this.mutationCache.config.onSuccess == null || _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
        }).then(function() {
            return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
        }).then(function() {
            return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
        }).then(function() {
            _this.dispatch({
                type: "success",
                data: data
            });
            return data;
        }).catch(function(error) {
            // Notify cache callback
            _this.mutationCache.config.onError == null || _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error
            (0, $9489c5e76e62cc56$export$2b1d391cd05230fd)().error(error);
            return Promise.resolve().then(function() {
                return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
            }).then(function() {
                return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
            }).then(function() {
                _this.dispatch({
                    type: "error",
                    error: error
                });
                throw error;
            });
        });
    };
    _proto.executeMutation = function executeMutation() {
        var _this2 = this, _this$options$retry;
        this.retryer = new (0, $23ca15fd0fb4402b$export$586a619a4618a582)({
            fn: function fn() {
                if (!_this2.options.mutationFn) return Promise.reject("No mutationFn found");
                return _this2.options.mutationFn(_this2.state.variables);
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: "failed"
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: "pause"
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: "continue"
                });
            },
            retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
            retryDelay: this.options.retryDelay
        });
        return this.retryer.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = $74a5e2e6477d55b9$var$reducer(this.state, action);
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onMutationUpdate(action);
            });
            _this3.mutationCache.notify(_this3);
        });
    };
    return Mutation;
}();
function $74a5e2e6477d55b9$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}
function $74a5e2e6477d55b9$var$reducer(state, action) {
    switch(action.type){
        case "failed":
            return (0, $j1NUG.default)({}, state, {
                failureCount: state.failureCount + 1
            });
        case "pause":
            return (0, $j1NUG.default)({}, state, {
                isPaused: true
            });
        case "continue":
            return (0, $j1NUG.default)({}, state, {
                isPaused: false
            });
        case "loading":
            return (0, $j1NUG.default)({}, state, {
                context: action.context,
                data: undefined,
                error: null,
                isPaused: false,
                status: "loading",
                variables: action.variables
            });
        case "success":
            return (0, $j1NUG.default)({}, state, {
                data: action.data,
                error: null,
                status: "success",
                isPaused: false
            });
        case "error":
            return (0, $j1NUG.default)({}, state, {
                data: undefined,
                error: action.error,
                failureCount: state.failureCount + 1,
                isPaused: false,
                status: "error"
            });
        case "setState":
            return (0, $j1NUG.default)({}, state, action.state);
        default:
            return state;
    }
}




var $a6932dd7526bd65a$export$1fcfd9a244434844 = /*#__PURE__*/ function(_Subscribable) {
    (0, $1gxF5.default)(MutationCache, _Subscribable);
    function MutationCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.mutations = [];
        _this.mutationId = 0;
        return _this;
    }
    var _proto = MutationCache.prototype;
    _proto.build = function build(client, options, state) {
        var mutation = new (0, $74a5e2e6477d55b9$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
            meta: options.meta
        });
        this.add(mutation);
        return mutation;
    };
    _proto.add = function add(mutation) {
        this.mutations.push(mutation);
        this.notify(mutation);
    };
    _proto.remove = function remove(mutation) {
        this.mutations = this.mutations.filter(function(x) {
            return x !== mutation;
        });
        mutation.cancel();
        this.notify(mutation);
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            _this2.mutations.forEach(function(mutation) {
                _this2.remove(mutation);
            });
        });
    };
    _proto.getAll = function getAll() {
        return this.mutations;
    };
    _proto.find = function find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find(function(mutation) {
            return (0, $3ff4724ea894d7ab$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.findAll = function findAll(filters) {
        return this.mutations.filter(function(mutation) {
            return (0, $3ff4724ea894d7ab$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.notify = function notify(mutation) {
        var _this3 = this;
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(mutation);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        this.resumePausedMutations();
    };
    _proto.onOnline = function onOnline() {
        this.resumePausedMutations();
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        var pausedMutations = this.mutations.filter(function(x) {
            return x.state.isPaused;
        });
        return (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            return pausedMutations.reduce(function(promise, mutation) {
                return promise.then(function() {
                    return mutation.continue().catch((0, $3ff4724ea894d7ab$export$8793edee2d425525));
                });
            }, Promise.resolve());
        });
    };
    return MutationCache;
}((0, $8d9dbc58b3471196$export$d26086b469ecdbcc));







function $615235d24e9a8762$export$84470d1367601e8d() {
    return {
        onFetch: function onFetch(context) {
            context.fetchFn = function() {
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                var abortController = (0, $3ff4724ea894d7ab$export$382ca5d13a8f252c)();
                var abortSignal = abortController == null ? void 0 : abortController.signal;
                var newPageParams = oldPageParams;
                var cancelled = false; // Get query function
                var queryFn = context.options.queryFn || function() {
                    return Promise.reject("Missing queryFn");
                };
                var buildNewPages = function buildNewPages(pages, param, page, previous) {
                    newPageParams = previous ? [
                        param
                    ].concat(newPageParams) : [].concat(newPageParams, [
                        param
                    ]);
                    return previous ? [
                        page
                    ].concat(pages) : [].concat(pages, [
                        page
                    ]);
                }; // Create function to fetch a page
                var fetchPage = function fetchPage(pages, manual, param, previous) {
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    var queryFnContext = {
                        queryKey: context.queryKey,
                        signal: abortSignal,
                        pageParam: param,
                        meta: context.meta
                    };
                    var queryFnResult = queryFn(queryFnContext);
                    var promise = Promise.resolve(queryFnResult).then(function(page) {
                        return buildNewPages(pages, param, page, previous);
                    });
                    if ((0, $23ca15fd0fb4402b$export$22e08d49843051be)(queryFnResult)) {
                        var promiseAsAny = promise;
                        promiseAsAny.cancel = queryFnResult.cancel;
                    }
                    return promise;
                };
                var promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    var manual = typeof pageParam !== "undefined";
                    var param = manual ? pageParam : $615235d24e9a8762$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    var _manual = typeof pageParam !== "undefined";
                    var _param = _manual ? pageParam : $615235d24e9a8762$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, _manual, _param, true);
                } else (function() {
                    newPageParams = [];
                    var manual = typeof context.options.getNextPageParam === "undefined";
                    var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    var _loop = function _loop(i) {
                        promise = promise.then(function(pages) {
                            var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                            if (shouldFetchNextPage) {
                                var _param2 = manual ? oldPageParams[i] : $615235d24e9a8762$export$1186159d57de7255(context.options, pages);
                                return fetchPage(pages, manual, _param2);
                            }
                            return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                        });
                    };
                    for(var i = 1; i < oldPages.length; i++)_loop(i);
                })();
                var finalPromise = promise.then(function(pages) {
                    return {
                        pages: pages,
                        pageParams: newPageParams
                    };
                });
                var finalPromiseAsAny = finalPromise;
                finalPromiseAsAny.cancel = function() {
                    cancelled = true;
                    abortController == null || abortController.abort();
                    if ((0, $23ca15fd0fb4402b$export$22e08d49843051be)(promise)) promise.cancel();
                };
                return finalPromise;
            };
        }
    };
}
function $615235d24e9a8762$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $615235d24e9a8762$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
function $615235d24e9a8762$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        var nextPageParam = $615235d24e9a8762$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
}
function $615235d24e9a8762$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        var previousPageParam = $615235d24e9a8762$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
}


var $97b75e8fb286a5f4$export$405d0624ed55a03f = /*#__PURE__*/ function() {
    function QueryClient(config) {
        if (config === void 0) config = {};
        this.queryCache = config.queryCache || new (0, $bd39afbd0bca7de1$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $a6932dd7526bd65a$export$1fcfd9a244434844)();
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
    }
    var _proto = QueryClient.prototype;
    _proto.mount = function mount() {
        var _this = this;
        this.unsubscribeFocus = (0, $3fbc886baa2b733b$export$6bf54661be5b02cf).subscribe(function() {
            if ((0, $3fbc886baa2b733b$export$6bf54661be5b02cf).isFocused() && (0, $e9ce68e672abc0c9$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onFocus();
                _this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $e9ce68e672abc0c9$export$b113e788b2dd3fdc).subscribe(function() {
            if ((0, $3fbc886baa2b733b$export$6bf54661be5b02cf).isFocused() && (0, $e9ce68e672abc0c9$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onOnline();
                _this.queryCache.onOnline();
            }
        });
    };
    _proto.unmount = function unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
    };
    _proto.isFetching = function isFetching(arg1, arg2) {
        var _parseFilterArgs = (0, $3ff4724ea894d7ab$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        filters.fetching = true;
        return this.queryCache.findAll(filters).length;
    };
    _proto.isMutating = function isMutating(filters) {
        return this.mutationCache.findAll((0, $j1NUG.default)({}, filters, {
            fetching: true
        })).length;
    };
    _proto.getQueryData = function getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    };
    _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref) {
            var queryKey = _ref.queryKey, state = _ref.state;
            var data = state.data;
            return [
                queryKey,
                data
            ];
        });
    };
    _proto.setQueryData = function setQueryData(queryKey, updater, options) {
        var parsedOptions = (0, $3ff4724ea894d7ab$export$8a11fbc2c8ea08fd)(queryKey);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(updater, options);
    };
    _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
        var _this2 = this;
        return (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref2) {
                var queryKey = _ref2.queryKey;
                return [
                    queryKey,
                    _this2.setQueryData(queryKey, updater, options)
                ];
            });
        });
    };
    _proto.getQueryState = function getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    };
    _proto.removeQueries = function removeQueries(arg1, arg2) {
        var _parseFilterArgs2 = (0, $3ff4724ea894d7ab$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        var queryCache = this.queryCache;
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                queryCache.remove(query);
            });
        });
    };
    _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
        var _this3 = this;
        var _parseFilterArgs3 = (0, $3ff4724ea894d7ab$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs3[0], options = _parseFilterArgs3[1];
        var queryCache = this.queryCache;
        var refetchFilters = (0, $j1NUG.default)({}, filters, {
            active: true
        });
        return (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                query.reset();
            });
            return _this3.refetchQueries(refetchFilters, options);
        });
    };
    _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
        var _this4 = this;
        var _parseFilterArgs4 = (0, $3ff4724ea894d7ab$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs4[0], _parseFilterArgs4$ = _parseFilterArgs4[1], cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        var promises = (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            return _this4.queryCache.findAll(filters).map(function(query) {
                return query.cancel(cancelOptions);
            });
        });
        return Promise.all(promises).then((0, $3ff4724ea894d7ab$export$8793edee2d425525)).catch((0, $3ff4724ea894d7ab$export$8793edee2d425525));
    };
    _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
        var _ref3, _filters$refetchActiv, _filters$refetchInact, _this5 = this;
        var _parseFilterArgs5 = (0, $3ff4724ea894d7ab$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs5[0], options = _parseFilterArgs5[1];
        var refetchFilters = (0, $j1NUG.default)({}, filters, {
            // if filters.refetchActive is not provided and filters.active is explicitly false,
            // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
            active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
            inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
        });
        return (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            _this5.queryCache.findAll(filters).forEach(function(query) {
                query.invalidate();
            });
            return _this5.refetchQueries(refetchFilters, options);
        });
    };
    _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
        var _this6 = this;
        var _parseFilterArgs6 = (0, $3ff4724ea894d7ab$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs6[0], options = _parseFilterArgs6[1];
        var promises = (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            return _this6.queryCache.findAll(filters).map(function(query) {
                return query.fetch(undefined, (0, $j1NUG.default)({}, options, {
                    meta: {
                        refetchPage: filters == null ? void 0 : filters.refetchPage
                    }
                }));
            });
        });
        var promise = Promise.all(promises).then((0, $3ff4724ea894d7ab$export$8793edee2d425525));
        if (!(options == null ? void 0 : options.throwOnError)) promise = promise.catch((0, $3ff4724ea894d7ab$export$8793edee2d425525));
        return promise;
    };
    _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $3ff4724ea894d7ab$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        var query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    };
    _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $3ff4724ea894d7ab$export$8793edee2d425525)).catch((0, $3ff4724ea894d7ab$export$8793edee2d425525));
    };
    _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $3ff4724ea894d7ab$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $615235d24e9a8762$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    };
    _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $3ff4724ea894d7ab$export$8793edee2d425525)).catch((0, $3ff4724ea894d7ab$export$8793edee2d425525));
    };
    _proto.cancelMutations = function cancelMutations() {
        var _this7 = this;
        var promises = (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            return _this7.mutationCache.getAll().map(function(mutation) {
                return mutation.cancel();
            });
        });
        return Promise.all(promises).then((0, $3ff4724ea894d7ab$export$8793edee2d425525)).catch((0, $3ff4724ea894d7ab$export$8793edee2d425525));
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        return this.getMutationCache().resumePausedMutations();
    };
    _proto.executeMutation = function executeMutation(options) {
        return this.mutationCache.build(this, options).execute();
    };
    _proto.getQueryCache = function getQueryCache() {
        return this.queryCache;
    };
    _proto.getMutationCache = function getMutationCache() {
        return this.mutationCache;
    };
    _proto.getDefaultOptions = function getDefaultOptions() {
        return this.defaultOptions;
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
        var result = this.queryDefaults.find(function(x) {
            return (0, $3ff4724ea894d7ab$export$5fcb678681417b54)(queryKey) === (0, $3ff4724ea894d7ab$export$5fcb678681417b54)(x.queryKey);
        });
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    };
    _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
        var _this$queryDefaults$f;
        return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function(x) {
            return (0, $3ff4724ea894d7ab$export$2f07189bb9fa26a7)(queryKey, x.queryKey);
        })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
    };
    _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
        var result = this.mutationDefaults.find(function(x) {
            return (0, $3ff4724ea894d7ab$export$5fcb678681417b54)(mutationKey) === (0, $3ff4724ea894d7ab$export$5fcb678681417b54)(x.mutationKey);
        });
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    };
    _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
        var _this$mutationDefault;
        return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function(x) {
            return (0, $3ff4724ea894d7ab$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey);
        })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
    };
    _proto.defaultQueryOptions = function defaultQueryOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        var defaultedOptions = (0, $j1NUG.default)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
            _defaulted: true
        });
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $3ff4724ea894d7ab$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        return defaultedOptions;
    };
    _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
        return this.defaultQueryOptions(options);
    };
    _proto.defaultMutationOptions = function defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return (0, $j1NUG.default)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
            _defaulted: true
        });
    };
    _proto.clear = function clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    };
    return QueryClient;
}();


// Side effects


var $bb92ec142e53873a$export$c78a37762a8d58e1 = (0, (/*@__PURE__*/$parcel$interopDefault($f419cfc3d92fe631$exports))).unstable_batchedUpdates;


(0, $290db3e0ce227fd3$export$520687f44db6e1ab).setBatchNotifyFunction((0, $bb92ec142e53873a$export$c78a37762a8d58e1));



var $cb0a650327a3197a$export$af88d00dbe7f521 = console;


(0, $9489c5e76e62cc56$export$3abbd92f765bee58)((0, $cb0a650327a3197a$export$af88d00dbe7f521));



var $tZqWC = parcelRequire("tZqWC");
var $9d2791931b06a49b$var$defaultContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext(undefined);
var $9d2791931b06a49b$var$QueryClientSharingContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $9d2791931b06a49b$var$getQueryClientContext(contextSharing) {
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $9d2791931b06a49b$var$defaultContext;
        return window.ReactQueryClientContext;
    }
    return $9d2791931b06a49b$var$defaultContext;
}
var $9d2791931b06a49b$export$22e77b9572c4fded = function useQueryClient() {
    var queryClient = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useContext($9d2791931b06a49b$var$getQueryClientContext((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useContext($9d2791931b06a49b$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
var $9d2791931b06a49b$export$45604f0cc8ae667b = function QueryClientProvider(_ref) {
    var client = _ref.client, _ref$contextSharing = _ref.contextSharing, contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing, children = _ref.children;
    (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useEffect(function() {
        client.mount();
        return function() {
            client.unmount();
        };
    }, [
        client
    ]);
    var Context = $9d2791931b06a49b$var$getQueryClientContext(contextSharing);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($9d2791931b06a49b$var$QueryClientSharingContext.Provider, {
        value: contextSharing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Context.Provider, {
        value: client
    }, children));
};






var $j1NUG = parcelRequire("j1NUG");

var $tZqWC = parcelRequire("tZqWC");



var $j1NUG = parcelRequire("j1NUG");

var $1gxF5 = parcelRequire("1gxF5");



var $9d7be58e553793c5$export$d3c1860ee66f291a = /*#__PURE__*/ function(_Subscribable) {
    (0, $1gxF5.default)(MutationObserver, _Subscribable);
    function MutationObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.setOptions(options);
        _this.bindMethods();
        _this.updateResult();
        return _this;
    }
    var _proto = MutationObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    };
    _proto.setOptions = function setOptions(options) {
        this.options = this.client.defaultMutationOptions(options);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) {
            var _this$currentMutation;
            (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.removeObserver(this);
        }
    };
    _proto.onMutationUpdate = function onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        var notifyOptions = {
            listeners: true
        };
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error") notifyOptions.onError = true;
        this.notify(notifyOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.reset = function reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    };
    _proto.mutate = function mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, (0, $j1NUG.default)({}, this.options, {
            variables: typeof variables !== "undefined" ? variables : this.options.variables
        }));
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    };
    _proto.updateResult = function updateResult() {
        var state = this.currentMutation ? this.currentMutation.state : (0, $74a5e2e6477d55b9$export$a1659b54bac3252a)();
        var result = (0, $j1NUG.default)({}, state, {
            isLoading: state.status === "loading",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        });
        this.currentResult = result;
    };
    _proto.notify = function notify(options) {
        var _this2 = this;
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            // First trigger the mutate callbacks
            if (_this2.mutateOptions) {
                if (options.onSuccess) {
                    _this2.mutateOptions.onSuccess == null || _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
                } else if (options.onError) {
                    _this2.mutateOptions.onError == null || _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) _this2.listeners.forEach(function(listener) {
                listener(_this2.currentResult);
            });
        });
    };
    return MutationObserver;
}((0, $8d9dbc58b3471196$export$d26086b469ecdbcc));



function $645ff6dc65a1374e$export$2072f68e6c3507cf(suspense, _useErrorBoundary, error) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary(error);
     // Allow useErrorBoundary to override suspense's throwing behavior
    if (typeof _useErrorBoundary === "boolean") return _useErrorBoundary; // If suspense is enabled default to throwing errors
    return !!suspense;
}


function $38e130c204b159d1$export$609860bf8b0084c(arg1, arg2, arg3) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useState(0), forceUpdate = _React$useState[1];
    var options = (0, $3ff4724ea894d7ab$export$b646c531ea475334)(arg1, arg2, arg3);
    var queryClient = (0, $9d2791931b06a49b$export$22e77b9572c4fded)();
    var obsRef = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useRef();
    if (!obsRef.current) obsRef.current = new (0, $9d7be58e553793c5$export$d3c1860ee66f291a)(queryClient, options);
    else obsRef.current.setOptions(options);
    var currentResult = obsRef.current.getCurrentResult();
    (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = obsRef.current.subscribe((0, $290db3e0ce227fd3$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, []);
    var mutate = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useCallback(function(variables, mutateOptions) {
        obsRef.current.mutate(variables, mutateOptions).catch((0, $3ff4724ea894d7ab$export$8793edee2d425525));
    }, []);
    if (currentResult.error && (0, $645ff6dc65a1374e$export$2072f68e6c3507cf)(undefined, obsRef.current.options.useErrorBoundary, currentResult.error)) throw currentResult.error;
    return (0, $j1NUG.default)({}, currentResult, {
        mutate: mutate,
        mutateAsync: currentResult.mutate
    });
}












var $4L3zM = parcelRequire("4L3zM");
function $6829791a091ca67a$var$AppReactQueryProvider(props) {
    // Destructure
    const { children: children } = props;
    // Variables
    const queryClient = new (0, $97b75e8fb286a5f4$export$405d0624ed55a03f)();
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d2791931b06a49b$export$45604f0cc8ae667b), {
        client: queryClient,
        children: children
    });
}
var $6829791a091ca67a$export$2e2bcd8739ae039 = $6829791a091ca67a$var$AppReactQueryProvider;
// Proptypes Validation
$6829791a091ca67a$var$AppReactQueryProvider.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]).isRequired
};



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $tZqWC = parcelRequire("tZqWC");
var $c5a0bc5372e756ee$exports = {};
//
$c5a0bc5372e756ee$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $68d249255e56b2cd$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\x00\x00"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\x00");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $68d249255e56b2cd$export$2e2bcd8739ae039 = $68d249255e56b2cd$var$stylis_min;


var $87b1d4e5408c6cd9$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $87b1d4e5408c6cd9$export$2e2bcd8739ae039 = $87b1d4e5408c6cd9$var$unitlessKeys;


function $af50efb89e5f7a0e$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $af50efb89e5f7a0e$export$2e2bcd8739ae039 = $af50efb89e5f7a0e$var$memoize;


var $f9508aba4ae9c164$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $f9508aba4ae9c164$var$index = (0, $af50efb89e5f7a0e$export$2e2bcd8739ae039)(function(prop) {
    return $f9508aba4ae9c164$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $f9508aba4ae9c164$export$2e2bcd8739ae039 = $f9508aba4ae9c164$var$index;



var $7g5pF = parcelRequire("7g5pF");

var $kuzpm = parcelRequire("kuzpm");
function $a778141486c79bc3$var$v() {
    return ($a778141486c79bc3$var$v = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $a778141486c79bc3$var$g = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $a778141486c79bc3$var$S = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $4344e5410d380169$exports.typeOf)(t);
}, $a778141486c79bc3$var$w = Object.freeze([]), $a778141486c79bc3$var$E = Object.freeze({});
function $a778141486c79bc3$var$b(e) {
    return "function" == typeof e;
}
function $a778141486c79bc3$var$_(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $a778141486c79bc3$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $a778141486c79bc3$var$A = ("undefined" != typeof $kuzpm && undefined, "data-styled"), $a778141486c79bc3$export$83d89fbfd8236492 = "5.3.3", $a778141486c79bc3$var$I = "undefined" != typeof window && "HTMLElement" in window, $a778141486c79bc3$var$P = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : (typeof $kuzpm, typeof $kuzpm, false)), $a778141486c79bc3$var$O = {}, $a778141486c79bc3$var$R = {};
function $a778141486c79bc3$var$D() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $a778141486c79bc3$var$j(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $a778141486c79bc3$var$T = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $a778141486c79bc3$var$j(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $a778141486c79bc3$var$x = new Map, $a778141486c79bc3$var$k = new Map, $a778141486c79bc3$var$V = 1, $a778141486c79bc3$var$B = function(e) {
    if ($a778141486c79bc3$var$x.has(e)) return $a778141486c79bc3$var$x.get(e);
    for(; $a778141486c79bc3$var$k.has($a778141486c79bc3$var$V);)$a778141486c79bc3$var$V++;
    var t = $a778141486c79bc3$var$V++;
    return $a778141486c79bc3$var$x.set(e, t), $a778141486c79bc3$var$k.set(t, e), t;
}, $a778141486c79bc3$var$z = function(e) {
    return $a778141486c79bc3$var$k.get(e);
}, $a778141486c79bc3$var$M = function(e, t) {
    t >= $a778141486c79bc3$var$V && ($a778141486c79bc3$var$V = t + 1), $a778141486c79bc3$var$x.set(e, t), $a778141486c79bc3$var$k.set(t, e);
}, $a778141486c79bc3$var$G = "style[" + $a778141486c79bc3$var$A + '][data-styled-version="5.3.3"]', $a778141486c79bc3$var$L = new RegExp("^" + $a778141486c79bc3$var$A + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $a778141486c79bc3$var$F = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $a778141486c79bc3$var$Y = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($a778141486c79bc3$var$L);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($a778141486c79bc3$var$M(u, c), $a778141486c79bc3$var$F(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $a778141486c79bc3$var$q = function() {
    return "undefined" != typeof window && void 0 !== window.__webpack_nonce__ ? window.__webpack_nonce__ : null;
}, $a778141486c79bc3$var$H = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($a778141486c79bc3$var$A)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($a778141486c79bc3$var$A, "active"), r.setAttribute("data-styled-version", "5.3.3");
    var i = $a778141486c79bc3$var$q();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $a778141486c79bc3$var$$ = function() {
    function e(e) {
        var t = this.element = $a778141486c79bc3$var$H(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $a778141486c79bc3$var$j(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $a778141486c79bc3$var$W = function() {
    function e(e) {
        var t = this.element = $a778141486c79bc3$var$H(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $a778141486c79bc3$var$U = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $a778141486c79bc3$var$J = $a778141486c79bc3$var$I, $a778141486c79bc3$var$X = {
    isServer: !$a778141486c79bc3$var$I,
    useCSSOMInjection: !$a778141486c79bc3$var$P
}, $a778141486c79bc3$var$Z = function() {
    function e(e, t, n) {
        void 0 === e && (e = $a778141486c79bc3$var$E), void 0 === t && (t = {}), this.options = $a778141486c79bc3$var$v({}, $a778141486c79bc3$var$X, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $a778141486c79bc3$var$I && $a778141486c79bc3$var$J && ($a778141486c79bc3$var$J = !1, function(e) {
            for(var t = document.querySelectorAll($a778141486c79bc3$var$G), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($a778141486c79bc3$var$A) && ($a778141486c79bc3$var$Y(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $a778141486c79bc3$var$B(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($a778141486c79bc3$var$v({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $a778141486c79bc3$var$U(o) : r ? new $a778141486c79bc3$var$$(o) : new $a778141486c79bc3$var$W(o), new $a778141486c79bc3$var$T(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($a778141486c79bc3$var$B(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($a778141486c79bc3$var$B(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($a778141486c79bc3$var$B(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $a778141486c79bc3$var$z(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $a778141486c79bc3$var$A + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $a778141486c79bc3$var$K = /(a)(d)/gi, $a778141486c79bc3$var$Q = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $a778141486c79bc3$var$ee(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $a778141486c79bc3$var$Q(t % 52) + n;
    return ($a778141486c79bc3$var$Q(t % 52) + n).replace($a778141486c79bc3$var$K, "$1-$2");
}
var $a778141486c79bc3$var$te = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $a778141486c79bc3$var$ne = function(e) {
    return $a778141486c79bc3$var$te(5381, e);
};
function $a778141486c79bc3$var$re(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($a778141486c79bc3$var$b(n) && !$a778141486c79bc3$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $a778141486c79bc3$var$oe = $a778141486c79bc3$var$ne("5.3.3"), $a778141486c79bc3$var$se = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $a778141486c79bc3$var$re(e), this.componentId = t, this.baseHash = $a778141486c79bc3$var$te($a778141486c79bc3$var$oe, t), this.baseStyle = n, $a778141486c79bc3$var$Z.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $a778141486c79bc3$var$Ne(this.rules, e, t, n).join(""), i = $a778141486c79bc3$var$ee($a778141486c79bc3$var$te(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $a778141486c79bc3$var$te(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $a778141486c79bc3$var$Ne(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $a778141486c79bc3$var$te(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $a778141486c79bc3$var$ee(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $a778141486c79bc3$var$ie = /^\s*\/\/.*$/gm, $a778141486c79bc3$var$ae = [
    ":",
    "[",
    ".",
    "#"
];
function $a778141486c79bc3$var$ce(e) {
    var t, n, r, o, s = void 0 === e ? $a778141486c79bc3$var$E : e, i = s.options, a = void 0 === i ? $a778141486c79bc3$var$E : i, c = s.plugins, u = void 0 === c ? $a778141486c79bc3$var$w : c, l = new (0, $68d249255e56b2cd$export$2e2bcd8739ae039)(a), d = [], h = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $a778141486c79bc3$var$ae.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($a778141486c79bc3$var$ie, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        h,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $a778141486c79bc3$var$j(15), $a778141486c79bc3$var$te(e, t.name);
    }, 5381).toString() : "", m;
}
var $a778141486c79bc3$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext(), $a778141486c79bc3$export$91317688fc694efa = $a778141486c79bc3$export$8c190ef828af4c86.Consumer, $a778141486c79bc3$var$de = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext(), $a778141486c79bc3$var$he = ($a778141486c79bc3$var$de.Consumer, new $a778141486c79bc3$var$Z), $a778141486c79bc3$var$pe = $a778141486c79bc3$var$ce();
function $a778141486c79bc3$var$fe() {
    return (0, $tZqWC.useContext)($a778141486c79bc3$export$8c190ef828af4c86) || $a778141486c79bc3$var$he;
}
function $a778141486c79bc3$var$me() {
    return (0, $tZqWC.useContext)($a778141486c79bc3$var$de) || $a778141486c79bc3$var$pe;
}
function $a778141486c79bc3$export$a473771da2f0ff7c(e) {
    var t = (0, $tZqWC.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $a778141486c79bc3$var$fe(), u = (0, $tZqWC.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $tZqWC.useMemo)(function() {
        return $a778141486c79bc3$var$ce({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $tZqWC.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($c5a0bc5372e756ee$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a778141486c79bc3$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a778141486c79bc3$var$de.Provider, {
        value: l
    }, (0, e.children)));
}
var $a778141486c79bc3$var$ve = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $a778141486c79bc3$var$pe);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $a778141486c79bc3$var$j(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $a778141486c79bc3$var$pe), this.name + e.hash;
    }, e;
}(), $a778141486c79bc3$var$ge = /([A-Z])/, $a778141486c79bc3$var$Se = /([A-Z])/g, $a778141486c79bc3$var$we = /^ms-/, $a778141486c79bc3$var$Ee = function(e) {
    return "-" + e.toLowerCase();
};
function $a778141486c79bc3$var$be(e) {
    return $a778141486c79bc3$var$ge.test(e) ? e.replace($a778141486c79bc3$var$Se, $a778141486c79bc3$var$Ee).replace($a778141486c79bc3$var$we, "-ms-") : e;
}
var $a778141486c79bc3$var$_e = function(e) {
    return null == e || !1 === e || "" === e;
};
function $a778141486c79bc3$var$Ne(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $a778141486c79bc3$var$Ne(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($a778141486c79bc3$var$_e(e)) return "";
    if ($a778141486c79bc3$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($a778141486c79bc3$var$b(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $a778141486c79bc3$var$Ne(u, n, r, o);
    }
    var l;
    return e instanceof $a778141486c79bc3$var$ve ? r ? (e.inject(r, o), e.getName(o)) : e : $a778141486c79bc3$var$S(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$a778141486c79bc3$var$_e(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $a778141486c79bc3$var$b(t[i]) ? s.push($a778141486c79bc3$var$be(i) + ":", t[i], ";") : $a778141486c79bc3$var$S(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($a778141486c79bc3$var$be(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $87b1d4e5408c6cd9$export$2e2bcd8739ae039) ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $a778141486c79bc3$var$Ae = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $a778141486c79bc3$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $a778141486c79bc3$var$b(e) || $a778141486c79bc3$var$S(e) ? $a778141486c79bc3$var$Ae($a778141486c79bc3$var$Ne($a778141486c79bc3$var$g($a778141486c79bc3$var$w, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $a778141486c79bc3$var$Ae($a778141486c79bc3$var$Ne($a778141486c79bc3$var$g(e, n)));
}
var $a778141486c79bc3$var$Ie = /invalid hook call/i, $a778141486c79bc3$var$Pe = new Set, $a778141486c79bc3$var$Oe = function(e, t) {
    var n, r, o, e1;
}, $a778141486c79bc3$var$Re = function(e, t, n) {
    return void 0 === n && (n = $a778141486c79bc3$var$E), e.theme !== n.theme && e.theme || t || n.theme;
}, $a778141486c79bc3$var$De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $a778141486c79bc3$var$je = /(^-|-$)/g;
function $a778141486c79bc3$var$Te(e) {
    return e.replace($a778141486c79bc3$var$De, "-").replace($a778141486c79bc3$var$je, "");
}
var $a778141486c79bc3$var$xe = function(e) {
    return $a778141486c79bc3$var$ee($a778141486c79bc3$var$ne(e) >>> 0);
};
function $a778141486c79bc3$var$ke(e) {
    return "string" == typeof e && true;
}
var $a778141486c79bc3$var$Ve = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $a778141486c79bc3$var$Be = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $a778141486c79bc3$var$ze(e, t, n) {
    var r = e[n];
    $a778141486c79bc3$var$Ve(t) && $a778141486c79bc3$var$Ve(r) ? $a778141486c79bc3$var$Me(r, t) : e[n] = t;
}
function $a778141486c79bc3$var$Me(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($a778141486c79bc3$var$Ve(i)) for(var a in i)$a778141486c79bc3$var$Be(a) && $a778141486c79bc3$var$ze(e, i[a], a);
    }
    return e;
}
var $a778141486c79bc3$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext(), $a778141486c79bc3$export$b631efc24e9d5e2f = $a778141486c79bc3$export$2c657da244d00bd6.Consumer;
function $a778141486c79bc3$export$d8964aec282183a3(e) {
    var t = (0, $tZqWC.useContext)($a778141486c79bc3$export$2c657da244d00bd6), n = (0, $tZqWC.useMemo)(function() {
        return function(e, t) {
            if (!e) return $a778141486c79bc3$var$j(14);
            if ($a778141486c79bc3$var$b(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $a778141486c79bc3$var$j(8) : t ? $a778141486c79bc3$var$v({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a778141486c79bc3$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $a778141486c79bc3$var$Ye = {};
function $a778141486c79bc3$var$qe(e, t, n) {
    var o = $a778141486c79bc3$export$7ba318d8d2f06c76(e), i = !$a778141486c79bc3$var$ke(e), a = t.attrs, c = void 0 === a ? $a778141486c79bc3$var$w : a, d = t.componentId, h = void 0 === d ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $a778141486c79bc3$var$Te(e);
        $a778141486c79bc3$var$Ye[n] = ($a778141486c79bc3$var$Ye[n] || 0) + 1;
        var r = n + "-" + $a778141486c79bc3$var$xe("5.3.3" + n + $a778141486c79bc3$var$Ye[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : d, p = t.displayName, f = void 0 === p ? function(e) {
        return $a778141486c79bc3$var$ke(e) ? "styled." + e : "Styled(" + $a778141486c79bc3$var$_(e) + ")";
    }(e) : p, g = t.displayName && t.componentId ? $a778141486c79bc3$var$Te(t.displayName) + "-" + t.componentId : t.componentId || h, S = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, A = t.shouldForwardProp;
    o && e.shouldForwardProp && (A = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var C, I = new $a778141486c79bc3$var$se(n, g, o ? e.componentStyle : void 0), P = I.isStatic && 0 === c.length, O = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, d = e.shouldForwardProp, h = e.styledComponentId, p = e.target;
            var f = function(e, t, n) {
                void 0 === e && (e = $a778141486c79bc3$var$E);
                var r = $a778141486c79bc3$var$v({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $a778141486c79bc3$var$b(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($a778141486c79bc3$var$Re(t, (0, $tZqWC.useContext)($a778141486c79bc3$export$2c657da244d00bd6), a) || $a778141486c79bc3$var$E, t, o), y = f[0], g = f[1], S = function(e, t, n, r) {
                var o = $a778141486c79bc3$var$fe(), s = $a778141486c79bc3$var$me(), i = t ? e.generateAndInjectStyles($a778141486c79bc3$var$E, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, y, void 0), w = n, _ = g.$as || t.$as || g.as || t.as || p, N = $a778141486c79bc3$var$ke(_), A = g !== t ? $a778141486c79bc3$var$v({}, t, {}, g) : t, C = {};
            for(var I in A)"$" !== I[0] && "as" !== I && ("forwardedAs" === I ? C.as = A[I] : (d ? d(I, (0, $f9508aba4ae9c164$export$2e2bcd8739ae039), _) : !N || (0, $f9508aba4ae9c164$export$2e2bcd8739ae039)(I)) && (C[I] = A[I]));
            return t.style && g.style !== t.style && (C.style = $a778141486c79bc3$var$v({}, t.style, {}, g.style)), C.className = Array.prototype.concat(c, h, S !== h ? S : null, t.className, g.className).filter(Boolean).join(" "), C.ref = w, (0, $tZqWC.createElement)(_, C);
        }(C, e, t, P);
    };
    return O.displayName = f, (C = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).forwardRef(O)).attrs = S, C.componentStyle = I, C.displayName = f, C.shouldForwardProp = A, C.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $a778141486c79bc3$var$w, C.styledComponentId = g, C.target = o ? e.target : e, C.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($a778141486c79bc3$var$ke(e) ? e : $a778141486c79bc3$var$Te($a778141486c79bc3$var$_(e)));
        return $a778141486c79bc3$var$qe(e, $a778141486c79bc3$var$v({}, o, {
            attrs: S,
            componentId: s
        }), n);
    }, Object.defineProperty(C, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $a778141486c79bc3$var$Me({}, e.defaultProps, t) : t;
        }
    }), C.toString = function() {
        return "." + C.styledComponentId;
    }, i && (0, (/*@__PURE__*/$parcel$interopDefault($7g5pF)))(C, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), C;
}
var $a778141486c79bc3$var$He = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $a778141486c79bc3$var$E), !(0, $4344e5410d380169$exports.isValidElementType)(r)) return $a778141486c79bc3$var$j(1, String(r));
        var s = function() {
            return t(r, o, $a778141486c79bc3$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $a778141486c79bc3$var$v({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $a778141486c79bc3$var$v({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($a778141486c79bc3$var$qe, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $a778141486c79bc3$var$He[e] = $a778141486c79bc3$var$He(e);
});
var $a778141486c79bc3$var$$e = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $a778141486c79bc3$var$re(e), $a778141486c79bc3$var$Z.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($a778141486c79bc3$var$Ne(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $a778141486c79bc3$var$Z.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $a778141486c79bc3$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $a778141486c79bc3$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $a778141486c79bc3$var$xe(JSON.stringify(i)), u = new $a778141486c79bc3$var$$e(i, a);
    function l(e) {
        var t = $a778141486c79bc3$var$fe(), n = $a778141486c79bc3$var$me(), o = (0, $tZqWC.useContext)($a778141486c79bc3$export$2c657da244d00bd6), l = (0, $tZqWC.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(l, e, t, o, n), (0, $tZqWC.useLayoutEffect)(function() {
            if (!t.server) return h(l, e, t, o, n), function() {
                return u.removeStyles(l, t);
            };
        }, [
            l,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $a778141486c79bc3$var$O, n, o);
        else {
            var s = $a778141486c79bc3$var$v({}, t, {
                theme: $a778141486c79bc3$var$Re(t, r, l.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).memo(l);
}
function $a778141486c79bc3$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $a778141486c79bc3$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $a778141486c79bc3$var$xe(o);
    return new $a778141486c79bc3$var$ve(s, o);
}
var $a778141486c79bc3$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $a778141486c79bc3$var$q();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $a778141486c79bc3$var$A + '="true"',
                'data-styled-version="5.3.3"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $a778141486c79bc3$var$j(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $a778141486c79bc3$var$j(2);
            var n = ((t = {})[$a778141486c79bc3$var$A] = "", t["data-styled-version"] = "5.3.3", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $a778141486c79bc3$var$q();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("style", $a778141486c79bc3$var$v({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $a778141486c79bc3$var$Z({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $a778141486c79bc3$var$j(2) : (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a778141486c79bc3$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $a778141486c79bc3$var$j(3);
    }, e;
}(), $a778141486c79bc3$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).forwardRef(function(t, n) {
        var o = (0, $tZqWC.useContext)($a778141486c79bc3$export$2c657da244d00bd6), i = e.defaultProps, a = $a778141486c79bc3$var$Re(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(e, $a778141486c79bc3$var$v({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($7g5pF)))(t, e), t.displayName = "WithTheme(" + $a778141486c79bc3$var$_(e) + ")", t;
}, $a778141486c79bc3$export$93d4e7f90805808f = function() {
    return (0, $tZqWC.useContext)($a778141486c79bc3$export$2c657da244d00bd6);
}, $a778141486c79bc3$export$5c87cfe6c475f500 = {
    StyleSheet: $a778141486c79bc3$var$Z,
    masterSheet: $a778141486c79bc3$var$he
};
var $a778141486c79bc3$export$2e2bcd8739ae039 = $a778141486c79bc3$var$He;


var $30e2084c8ceb2f43$exports = {};

$parcel$export($30e2084c8ceb2f43$exports, "colors", () => $30e2084c8ceb2f43$export$8f45430ccf837300);
$parcel$export($30e2084c8ceb2f43$exports, "fonts", () => $30e2084c8ceb2f43$export$f45fbea8fe20ca8a);
$parcel$export($30e2084c8ceb2f43$exports, "functions", () => $30e2084c8ceb2f43$export$18af1f934c132a41);
$parcel$export($30e2084c8ceb2f43$exports, "layout", () => $30e2084c8ceb2f43$export$b3219800bda33a1f);
const $06b9a6a3a837f924$var$mobileFirst = true;
// List of Breakpoints
const $06b9a6a3a837f924$var$breakpoints = {
    verySmall: "320px",
    mobileSmall: "430px",
    mobileMedium: "500px",
    mobile: "600px",
    tabletPortraitUp: "768px",
    tabletLandscapeUp: "920px",
    laptop: "1024px",
    laptopMedium: "1200px",
    laptopLarge: "1320px",
    bigDesktop: "1600px",
    bigDesktopUp: "1800px",
    wideScreen: "4000px"
};
/**
 * Returns media query rule per property breakpoint
 *
 * @param  {} width Max width of media query rule
 * @param  {} content Property : values; for an element
 */ const $06b9a6a3a837f924$var$mediaQuery = (width, content)=>{
    const breakpointWidth = width;
    return `@media screen and (max-width: ${breakpointWidth}) {
    ${content}
  }`;
};
/**
 * Fills property values for unassigned breakpoint
 *
 * @param  {} values Assigned values per property breakpoint
 */ const $06b9a6a3a837f924$var$fillValues = (values)=>{
    const argsMissingValueLength = Object.keys($06b9a6a3a837f924$var$breakpoints).length - values.length;
    const lastArgsValue = values[values.length - 1];
    const updatedValues = values;
    for(let index = 0; index < argsMissingValueLength; index++)updatedValues.push(lastArgsValue);
    return updatedValues;
};
/**
 * Generates media query breakpoint rules for a property
 *
 * @param  {} property Css property
 * @param  {} values Set of values for a property per breakpoint
 */ const $06b9a6a3a837f924$var$generateMediaQuery = (property, values)=>{
    const breakpointWidths = Object.values($06b9a6a3a837f924$var$breakpoints);
    const breakpointLength = breakpointWidths.length;
    const propertyValues = $06b9a6a3a837f924$var$fillValues(values);
    let generatedMediaQueryRule = "";
    if ($06b9a6a3a837f924$var$mobileFirst) {
        // Generates media query breakpoint rules for mobile first approach
        let count = breakpointLength - 1;
        while(count >= 0){
            generatedMediaQueryRule += $06b9a6a3a837f924$var$mediaQuery(breakpointWidths[count], `${property}: ${propertyValues[count]};`);
            count--;
        }
    } else {
        // Generates media query breakpoint rules for desktop first approach
        let count = 0;
        while(count < breakpointLength){
            generatedMediaQueryRule += $06b9a6a3a837f924$var$mediaQuery(breakpointWidths[breakpointLength - count - 1], `${property}: ${propertyValues[count]};`);
            count++;
        }
    }
    return generatedMediaQueryRule;
};
var $06b9a6a3a837f924$export$2e2bcd8739ae039 = $06b9a6a3a837f924$var$generateMediaQuery;


var $b0f150cd91be6a72$exports = {};

$parcel$export($b0f150cd91be6a72$exports, "onEvent", () => $b0f150cd91be6a72$export$4d067148c1e8c84d);
$parcel$export($b0f150cd91be6a72$exports, "transition", () => $b0f150cd91be6a72$export$66bb15e2994e6a26);
$parcel$export($b0f150cd91be6a72$exports, "transform", () => $b0f150cd91be6a72$export$51186ad6e864892a);
$parcel$export($b0f150cd91be6a72$exports, "animation", () => $b0f150cd91be6a72$export$ecad260a8a5fef4f);
$parcel$export($b0f150cd91be6a72$exports, "boxShadow", () => $b0f150cd91be6a72$export$16e1fc8de5cd9687);
$parcel$export($b0f150cd91be6a72$exports, "textShadow", () => $b0f150cd91be6a72$export$2c6941d40bcfb11a);
const $b0f150cd91be6a72$export$4d067148c1e8c84d = (content)=>`
    &:active,
    &:focus,
    &:hover {
     ${content}
    }`;
const $b0f150cd91be6a72$export$66bb15e2994e6a26 = (value)=>`
    -webkit-transition: ${value};
    -moz-transition: ${value};
    -ms-transition: ${value};
    -o-transform: ${value};
    transition: ${value};`;
const $b0f150cd91be6a72$export$51186ad6e864892a = (value)=>`
    -webkit-transform: ${value};
    -moz-transform: ${value};
    -ms-transform: ${value};
    -o-transform: ${value};
    transform: ${value};`;
const $b0f150cd91be6a72$export$ecad260a8a5fef4f = (value)=>`
    -webkit-animation: ${value};
    -moz-animation: ${value};
    -ms-animation: ${value};
    -o-transform: ${value};
    animation: ${value};`;
const $b0f150cd91be6a72$export$16e1fc8de5cd9687 = (value)=>`
    -webkit-box-shadow: ${value};
    -moz-box-shadow: ${value};
    -ms-box-shadow: ${value};
    -o-box-shadow: ${value};
    box-shadow: ${value};`;
const $b0f150cd91be6a72$export$2c6941d40bcfb11a = (value)=>`
    -webkit-text-shadow: ${value};
    -moz-text-shadow: ${value};
    -ms-text-shadow: ${value};
    -o-text-shadow: ${value};
    text-shadow: ${value};`;


const $30e2084c8ceb2f43$export$8f45430ccf837300 = {
    blue: "#26A3F5",
    lightBlue: "#e6fafa",
    darkBlue: "#405264",
    brightBlue: "#2e4ad4",
    blueGray: "#727F97",
    navyBlue: "#0b037a",
    royalBlue: "#4436eb",
    aliceBlue: "#f3f5f7",
    paleNavy: "#eef9fe",
    warning: "#FFB347",
    success: "#3cb371",
    info: "#0275d8",
    lightYellow: "#f8ffdd",
    mediumPurple: "#7068df",
    lightPurple: "#b7b3ee",
    red: "#F45C65",
    brightRed: "#fd4a71",
    yellowGreen: "#CAFF0A",
    green: "#89CF82",
    orange: "#ffa800",
    lightGray: "#F3F4F7",
    darkGray: "#727F97",
    sandGray: "#525252",
    gray: "#d2d2d2",
    ash: "#f7f7f7",
    black: "#000000",
    lightBlack: "#282828",
    darkGrayishNavy: "#31353e",
    darkishWhite: "#F9F9FB",
    white: "#ffffff",
    pureWhite: "#ffffff"
};
const $30e2084c8ceb2f43$export$f45fbea8fe20ca8a = {
    code: "'Courier New', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Monaco', monospace !default",
    text: "'Open Sans', 'Helvetica Neue Light', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif !default"
};
const $30e2084c8ceb2f43$export$18af1f934c132a41 = {
    mediaQuery: $06b9a6a3a837f924$export$2e2bcd8739ae039,
    mixins: $b0f150cd91be6a72$exports
};
const $30e2084c8ceb2f43$export$b3219800bda33a1f = {
    sidebar: false
};


var $699e4332635b25bd$export$2e2bcd8739ae039 = $30e2084c8ceb2f43$exports;


var $c9613c5a00d57ada$exports = {};

$parcel$export($c9613c5a00d57ada$exports, "colors", () => $c9613c5a00d57ada$export$8f45430ccf837300);
$parcel$export($c9613c5a00d57ada$exports, "fonts", () => $c9613c5a00d57ada$export$f45fbea8fe20ca8a);
$parcel$export($c9613c5a00d57ada$exports, "functions", () => $c9613c5a00d57ada$export$18af1f934c132a41);
$parcel$export($c9613c5a00d57ada$exports, "layout", () => $c9613c5a00d57ada$export$b3219800bda33a1f);


const $c9613c5a00d57ada$export$8f45430ccf837300 = {
    blue: "#00CACD",
    lightBlue: "#e6fafa",
    darkBlue: "#405264",
    brightBlue: "#2e4ad4",
    blueGray: "#727F97",
    navyBlue: "#0b037a",
    royalBlue: "#4436eb",
    aliceBlue: "#f3f5f7",
    paleNavy: "#eef9fe",
    warning: "#fd4a71",
    success: "#3cb371",
    info: "#0275d8",
    lightYellow: "#f8ffdd",
    mediumPurple: "#7068df",
    lightPurple: "#b7b3ee",
    red: "#F45C65",
    brightRed: "#fd4a71",
    yellowGreen: "#CAFF0A",
    green: "#89CF82",
    orange: "#ffa800",
    lightGray: "#393D46",
    darkGray: "#e9e9e9",
    sandGray: "#525252",
    gray: "#727F97",
    ash: "#474f5f",
    black: "#000000",
    lightBlack: "#282828",
    darkGrayishNavy: "#31353e",
    darkishWhite: "#F9F9FB",
    white: "#3c4351",
    pureWhite: "#ffffff"
};
const $c9613c5a00d57ada$export$f45fbea8fe20ca8a = {
    code: "'Courier New', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Monaco', monospace !default",
    text: "'Open Sans', 'Helvetica Neue Light', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif !default"
};
const $c9613c5a00d57ada$export$18af1f934c132a41 = {
    mediaQuery: $06b9a6a3a837f924$export$2e2bcd8739ae039,
    mixins: $b0f150cd91be6a72$exports
};
const $c9613c5a00d57ada$export$b3219800bda33a1f = {
    sidebar: false
};


var $ecad517a7fda3a3e$export$2e2bcd8739ae039 = $c9613c5a00d57ada$exports;



var $tZqWC = parcelRequire("tZqWC");
const $a9c50ebe96619b20$var$getValue = (key, initialValue)=>{
    const value = JSON.parse(localStorage.getItem(key));
    if (value) return value;
    if (initialValue instanceof Function) return initialValue();
    if (initialValue !== undefined) return initialValue;
};
const $a9c50ebe96619b20$var$useLocalStorage = (key, initialValue)=>{
    const [localStorageValue, setLocalStorageValue] = (0, $tZqWC.useState)(()=>$a9c50ebe96619b20$var$getValue(key, initialValue));
    (0, $tZqWC.useEffect)(()=>{
        if (localStorageValue !== undefined) localStorage.setItem(key, JSON.stringify(localStorageValue));
    }, [
        localStorageValue
    ]);
    return [
        localStorageValue,
        setLocalStorageValue
    ];
};
var $a9c50ebe96619b20$export$2e2bcd8739ae039 = $a9c50ebe96619b20$var$useLocalStorage;




function $114cb5fd5cac8cce$var$AppThemeProvider(props) {
    // Destructure
    const { children: children } = props;
    const [theme] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)("theme", "dark");
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a778141486c79bc3$export$d8964aec282183a3), {
        theme: theme === "light" ? (0, $699e4332635b25bd$export$2e2bcd8739ae039) : (0, $ecad517a7fda3a3e$export$2e2bcd8739ae039),
        children: children
    });
}
var $114cb5fd5cac8cce$export$2e2bcd8739ae039 = $114cb5fd5cac8cce$var$AppThemeProvider;
// Proptypes Validation
$114cb5fd5cac8cce$var$AppThemeProvider.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]).isRequired
};



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $j1NUG = parcelRequire("j1NUG");

var $tZqWC = parcelRequire("tZqWC");



var $tZqWC = parcelRequire("tZqWC");
var $98af74eaf5eefbeb$var$ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext(null);
var $98af74eaf5eefbeb$export$2e2bcd8739ae039 = $98af74eaf5eefbeb$var$ThemeContext;



var $tZqWC = parcelRequire("tZqWC");

function $8610d05fa52a0f79$export$2e2bcd8739ae039() {
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useContext((0, $98af74eaf5eefbeb$export$2e2bcd8739ae039));
    return theme;
}


var $1dbfa92f9ce00e36$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $1dbfa92f9ce00e36$export$2e2bcd8739ae039 = $1dbfa92f9ce00e36$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";


function $cda1d15932e56755$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        var mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $j1NUG.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $cda1d15932e56755$var$ThemeProvider(props) {
    var children = props.children, localTheme = props.theme;
    var outerTheme = (0, $8610d05fa52a0f79$export$2e2bcd8739ae039)();
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useMemo(function() {
        var output = outerTheme === null ? localTheme : $cda1d15932e56755$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $1dbfa92f9ce00e36$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement((0, $98af74eaf5eefbeb$export$2e2bcd8739ae039).Provider, {
        value: theme
    }, children);
}
var $cda1d15932e56755$export$2e2bcd8739ae039 = $cda1d15932e56755$var$ThemeProvider;



var $j1NUG = parcelRequire("j1NUG");

var $cGhSa = parcelRequire("cGhSa");
function $636333a0deecc159$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $cGhSa.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $tZqWC = parcelRequire("tZqWC");



/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */ var $13e96a4a0f403cd0$var$pseudoClasses = [
    "checked",
    "disabled",
    "error",
    "focused",
    "focusVisible",
    "required",
    "expanded",
    "selected"
]; // Returns a function which generates unique class names based on counters.
function $13e96a4a0f403cd0$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? "jss" : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? "" : _options$seed;
    var seedPrefix = seed === "" ? "" : "".concat(seed, "-");
    var ruleCounter = 0;
    var getNextCounterId = function getNextCounterId() {
        ruleCounter += 1;
        return ruleCounter;
    };
    return function(rule, styleSheet) {
        var name = styleSheet.options.name; // Is a global static MUI style?
        if (name && name.indexOf("Mui") === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($13e96a4a0f403cd0$var$pseudoClasses.indexOf(rule.key) !== -1) return "Mui-".concat(rule.key);
            var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
            if (!styleSheet.options.theme[0, $1dbfa92f9ce00e36$export$2e2bcd8739ae039] || seed !== "") return prefix;
            return "".concat(prefix, "-").concat(getNextCounterId());
        }
        var suffix;
        return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    };
}



var $4Z4HE = parcelRequire("4Z4HE");


var $4Z4HE = parcelRequire("4Z4HE");
var $4da7cddbd1f2bfab$var$now = Date.now();
var $4da7cddbd1f2bfab$var$fnValuesNs = "fnValues" + $4da7cddbd1f2bfab$var$now;
var $4da7cddbd1f2bfab$var$fnRuleNs = "fnStyle" + ++$4da7cddbd1f2bfab$var$now;
var $4da7cddbd1f2bfab$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== "function") return null;
            var rule = (0, $4Z4HE.createRule)(name, {}, options);
            rule[$4da7cddbd1f2bfab$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($4da7cddbd1f2bfab$var$fnValuesNs in rule || $4da7cddbd1f2bfab$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== "function") continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$4da7cddbd1f2bfab$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$4da7cddbd1f2bfab$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$4da7cddbd1f2bfab$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $4da7cddbd1f2bfab$export$2e2bcd8739ae039 = $4da7cddbd1f2bfab$var$functionPlugin;



var $j1NUG = parcelRequire("j1NUG");

var $4Z4HE = parcelRequire("4Z4HE");
var $d03cb5a025812fe7$var$at = "@global";
var $d03cb5a025812fe7$var$atPrefix = "@global ";
var $d03cb5a025812fe7$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = "global";
        this.at = $d03cb5a025812fe7$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $4Z4HE.RuleList)((0, $j1NUG.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $d03cb5a025812fe7$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = "global";
        this.at = $d03cb5a025812fe7$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($d03cb5a025812fe7$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $j1NUG.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : "";
    };
    return GlobalPrefixedRule;
}();
var $d03cb5a025812fe7$var$separatorRegExp = /\s*,\s*/g;
function $d03cb5a025812fe7$var$addScope(selector, scope) {
    var parts = selector.split($d03cb5a025812fe7$var$separatorRegExp);
    var scoped = "";
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ", ";
    }
    return scoped;
}
function $d03cb5a025812fe7$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$d03cb5a025812fe7$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $j1NUG.default)({}, options, {
        selector: $d03cb5a025812fe7$var$addScope(name, rule.selector)
    }));
    delete style[$d03cb5a025812fe7$var$at];
}
function $d03cb5a025812fe7$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== "@" || prop.substr(0, $d03cb5a025812fe7$var$at.length) !== $d03cb5a025812fe7$var$at) continue;
        var selector = $d03cb5a025812fe7$var$addScope(prop.substr($d03cb5a025812fe7$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $j1NUG.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $d03cb5a025812fe7$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $d03cb5a025812fe7$var$at) return new $d03cb5a025812fe7$var$GlobalContainerRule(name, styles, options);
        if (name[0] === "@" && name.substr(0, $d03cb5a025812fe7$var$atPrefix.length) === $d03cb5a025812fe7$var$atPrefix) return new $d03cb5a025812fe7$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === "global" || parent.options.parent && parent.options.parent.type === "global") options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== "style" || !sheet) return;
        $d03cb5a025812fe7$var$handleNestedGlobalContainerRule(rule, sheet);
        $d03cb5a025812fe7$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $d03cb5a025812fe7$export$2e2bcd8739ae039 = $d03cb5a025812fe7$var$jssGlobal;



var $j1NUG = parcelRequire("j1NUG");

var $87ae6c43024cc9b2$var$separatorRegExp = /\s*,\s*/g;
var $87ae6c43024cc9b2$var$parentRegExp = /&/g;
var $87ae6c43024cc9b2$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $87ae6c43024cc9b2$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($87ae6c43024cc9b2$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($87ae6c43024cc9b2$var$separatorRegExp);
        var result = "";
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ", "; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf("&") !== -1 ? nested.replace($87ae6c43024cc9b2$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $j1NUG.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $j1NUG.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style") return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf("&") !== -1;
            var isNestedConditional = prop[0] === "@";
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($87ae6c43024cc9b2$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ("replaceRule" in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $j1NUG.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $j1NUG.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $87ae6c43024cc9b2$export$2e2bcd8739ae039 = $87ae6c43024cc9b2$var$jssNested;


/* eslint-disable no-var, prefer-template */ var $05e5fe2c2b2bdf47$var$uppercasePattern = /[A-Z]/g;
var $05e5fe2c2b2bdf47$var$msPattern = /^ms-/;
var $05e5fe2c2b2bdf47$var$cache = {};
function $05e5fe2c2b2bdf47$var$toHyphenLower(match) {
    return "-" + match.toLowerCase();
}
function $05e5fe2c2b2bdf47$var$hyphenateStyleName(name) {
    if ($05e5fe2c2b2bdf47$var$cache.hasOwnProperty(name)) return $05e5fe2c2b2bdf47$var$cache[name];
    var hName = name.replace($05e5fe2c2b2bdf47$var$uppercasePattern, $05e5fe2c2b2bdf47$var$toHyphenLower);
    return $05e5fe2c2b2bdf47$var$cache[name] = $05e5fe2c2b2bdf47$var$msPattern.test(hName) ? "-" + hName : hName;
}
var $05e5fe2c2b2bdf47$export$2e2bcd8739ae039 = $05e5fe2c2b2bdf47$var$hyphenateStyleName;


/**
 * Convert camel cased property names to dash separated.
 */ function $5ef47dee1f2b9715$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf("--") === 0 ? prop : (0, $05e5fe2c2b2bdf47$export$2e2bcd8739ae039)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($5ef47dee1f2b9715$var$convertCase);
        else converted.fallbacks = $5ef47dee1f2b9715$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $5ef47dee1f2b9715$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $5ef47dee1f2b9715$var$convertCase(style[index]);
            return style;
        }
        return $5ef47dee1f2b9715$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf("--") === 0) return value;
        var hyphenatedProp = (0, $05e5fe2c2b2bdf47$export$2e2bcd8739ae039)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $5ef47dee1f2b9715$export$2e2bcd8739ae039 = $5ef47dee1f2b9715$var$camelCase;



var $4Z4HE = parcelRequire("4Z4HE");
var $105d4b9eaecab6e3$var$px = (0, $4Z4HE.hasCSSTOMSupport) && CSS ? CSS.px : "px";
var $105d4b9eaecab6e3$var$ms = (0, $4Z4HE.hasCSSTOMSupport) && CSS ? CSS.ms : "ms";
var $105d4b9eaecab6e3$var$percent = (0, $4Z4HE.hasCSSTOMSupport) && CSS ? CSS.percent : "%";
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $105d4b9eaecab6e3$var$defaultUnits = {
    // Animation properties
    "animation-delay": $105d4b9eaecab6e3$var$ms,
    "animation-duration": $105d4b9eaecab6e3$var$ms,
    // Background properties
    "background-position": $105d4b9eaecab6e3$var$px,
    "background-position-x": $105d4b9eaecab6e3$var$px,
    "background-position-y": $105d4b9eaecab6e3$var$px,
    "background-size": $105d4b9eaecab6e3$var$px,
    // Border Properties
    border: $105d4b9eaecab6e3$var$px,
    "border-bottom": $105d4b9eaecab6e3$var$px,
    "border-bottom-left-radius": $105d4b9eaecab6e3$var$px,
    "border-bottom-right-radius": $105d4b9eaecab6e3$var$px,
    "border-bottom-width": $105d4b9eaecab6e3$var$px,
    "border-left": $105d4b9eaecab6e3$var$px,
    "border-left-width": $105d4b9eaecab6e3$var$px,
    "border-radius": $105d4b9eaecab6e3$var$px,
    "border-right": $105d4b9eaecab6e3$var$px,
    "border-right-width": $105d4b9eaecab6e3$var$px,
    "border-top": $105d4b9eaecab6e3$var$px,
    "border-top-left-radius": $105d4b9eaecab6e3$var$px,
    "border-top-right-radius": $105d4b9eaecab6e3$var$px,
    "border-top-width": $105d4b9eaecab6e3$var$px,
    "border-width": $105d4b9eaecab6e3$var$px,
    "border-block": $105d4b9eaecab6e3$var$px,
    "border-block-end": $105d4b9eaecab6e3$var$px,
    "border-block-end-width": $105d4b9eaecab6e3$var$px,
    "border-block-start": $105d4b9eaecab6e3$var$px,
    "border-block-start-width": $105d4b9eaecab6e3$var$px,
    "border-block-width": $105d4b9eaecab6e3$var$px,
    "border-inline": $105d4b9eaecab6e3$var$px,
    "border-inline-end": $105d4b9eaecab6e3$var$px,
    "border-inline-end-width": $105d4b9eaecab6e3$var$px,
    "border-inline-start": $105d4b9eaecab6e3$var$px,
    "border-inline-start-width": $105d4b9eaecab6e3$var$px,
    "border-inline-width": $105d4b9eaecab6e3$var$px,
    "border-start-start-radius": $105d4b9eaecab6e3$var$px,
    "border-start-end-radius": $105d4b9eaecab6e3$var$px,
    "border-end-start-radius": $105d4b9eaecab6e3$var$px,
    "border-end-end-radius": $105d4b9eaecab6e3$var$px,
    // Margin properties
    margin: $105d4b9eaecab6e3$var$px,
    "margin-bottom": $105d4b9eaecab6e3$var$px,
    "margin-left": $105d4b9eaecab6e3$var$px,
    "margin-right": $105d4b9eaecab6e3$var$px,
    "margin-top": $105d4b9eaecab6e3$var$px,
    "margin-block": $105d4b9eaecab6e3$var$px,
    "margin-block-end": $105d4b9eaecab6e3$var$px,
    "margin-block-start": $105d4b9eaecab6e3$var$px,
    "margin-inline": $105d4b9eaecab6e3$var$px,
    "margin-inline-end": $105d4b9eaecab6e3$var$px,
    "margin-inline-start": $105d4b9eaecab6e3$var$px,
    // Padding properties
    padding: $105d4b9eaecab6e3$var$px,
    "padding-bottom": $105d4b9eaecab6e3$var$px,
    "padding-left": $105d4b9eaecab6e3$var$px,
    "padding-right": $105d4b9eaecab6e3$var$px,
    "padding-top": $105d4b9eaecab6e3$var$px,
    "padding-block": $105d4b9eaecab6e3$var$px,
    "padding-block-end": $105d4b9eaecab6e3$var$px,
    "padding-block-start": $105d4b9eaecab6e3$var$px,
    "padding-inline": $105d4b9eaecab6e3$var$px,
    "padding-inline-end": $105d4b9eaecab6e3$var$px,
    "padding-inline-start": $105d4b9eaecab6e3$var$px,
    // Mask properties
    "mask-position-x": $105d4b9eaecab6e3$var$px,
    "mask-position-y": $105d4b9eaecab6e3$var$px,
    "mask-size": $105d4b9eaecab6e3$var$px,
    // Width and height properties
    height: $105d4b9eaecab6e3$var$px,
    width: $105d4b9eaecab6e3$var$px,
    "min-height": $105d4b9eaecab6e3$var$px,
    "max-height": $105d4b9eaecab6e3$var$px,
    "min-width": $105d4b9eaecab6e3$var$px,
    "max-width": $105d4b9eaecab6e3$var$px,
    // Position properties
    bottom: $105d4b9eaecab6e3$var$px,
    left: $105d4b9eaecab6e3$var$px,
    top: $105d4b9eaecab6e3$var$px,
    right: $105d4b9eaecab6e3$var$px,
    inset: $105d4b9eaecab6e3$var$px,
    "inset-block": $105d4b9eaecab6e3$var$px,
    "inset-block-end": $105d4b9eaecab6e3$var$px,
    "inset-block-start": $105d4b9eaecab6e3$var$px,
    "inset-inline": $105d4b9eaecab6e3$var$px,
    "inset-inline-end": $105d4b9eaecab6e3$var$px,
    "inset-inline-start": $105d4b9eaecab6e3$var$px,
    // Shadow properties
    "box-shadow": $105d4b9eaecab6e3$var$px,
    "text-shadow": $105d4b9eaecab6e3$var$px,
    // Column properties
    "column-gap": $105d4b9eaecab6e3$var$px,
    "column-rule": $105d4b9eaecab6e3$var$px,
    "column-rule-width": $105d4b9eaecab6e3$var$px,
    "column-width": $105d4b9eaecab6e3$var$px,
    // Font and text properties
    "font-size": $105d4b9eaecab6e3$var$px,
    "font-size-delta": $105d4b9eaecab6e3$var$px,
    "letter-spacing": $105d4b9eaecab6e3$var$px,
    "text-decoration-thickness": $105d4b9eaecab6e3$var$px,
    "text-indent": $105d4b9eaecab6e3$var$px,
    "text-stroke": $105d4b9eaecab6e3$var$px,
    "text-stroke-width": $105d4b9eaecab6e3$var$px,
    "word-spacing": $105d4b9eaecab6e3$var$px,
    // Motion properties
    motion: $105d4b9eaecab6e3$var$px,
    "motion-offset": $105d4b9eaecab6e3$var$px,
    // Outline properties
    outline: $105d4b9eaecab6e3$var$px,
    "outline-offset": $105d4b9eaecab6e3$var$px,
    "outline-width": $105d4b9eaecab6e3$var$px,
    // Perspective properties
    perspective: $105d4b9eaecab6e3$var$px,
    "perspective-origin-x": $105d4b9eaecab6e3$var$percent,
    "perspective-origin-y": $105d4b9eaecab6e3$var$percent,
    // Transform properties
    "transform-origin": $105d4b9eaecab6e3$var$percent,
    "transform-origin-x": $105d4b9eaecab6e3$var$percent,
    "transform-origin-y": $105d4b9eaecab6e3$var$percent,
    "transform-origin-z": $105d4b9eaecab6e3$var$percent,
    // Transition properties
    "transition-delay": $105d4b9eaecab6e3$var$ms,
    "transition-duration": $105d4b9eaecab6e3$var$ms,
    // Alignment properties
    "vertical-align": $105d4b9eaecab6e3$var$px,
    "flex-basis": $105d4b9eaecab6e3$var$px,
    // Some random properties
    "shape-margin": $105d4b9eaecab6e3$var$px,
    size: $105d4b9eaecab6e3$var$px,
    gap: $105d4b9eaecab6e3$var$px,
    // Grid properties
    grid: $105d4b9eaecab6e3$var$px,
    "grid-gap": $105d4b9eaecab6e3$var$px,
    "row-gap": $105d4b9eaecab6e3$var$px,
    "grid-row-gap": $105d4b9eaecab6e3$var$px,
    "grid-column-gap": $105d4b9eaecab6e3$var$px,
    "grid-template-rows": $105d4b9eaecab6e3$var$px,
    "grid-template-columns": $105d4b9eaecab6e3$var$px,
    "grid-auto-rows": $105d4b9eaecab6e3$var$px,
    "grid-auto-columns": $105d4b9eaecab6e3$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    "box-shadow-x": $105d4b9eaecab6e3$var$px,
    "box-shadow-y": $105d4b9eaecab6e3$var$px,
    "box-shadow-blur": $105d4b9eaecab6e3$var$px,
    "box-shadow-spread": $105d4b9eaecab6e3$var$px,
    "font-line-height": $105d4b9eaecab6e3$var$px,
    "text-shadow-x": $105d4b9eaecab6e3$var$px,
    "text-shadow-y": $105d4b9eaecab6e3$var$px,
    "text-shadow-blur": $105d4b9eaecab6e3$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $105d4b9eaecab6e3$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $105d4b9eaecab6e3$var$units = $105d4b9eaecab6e3$var$addCamelCasedVersion($105d4b9eaecab6e3$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $105d4b9eaecab6e3$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $105d4b9eaecab6e3$var$iterate(prop, value[i], options);
    else if (typeof value === "object") {
        if (prop === "fallbacks") for(var innerProp in value)value[innerProp] = $105d4b9eaecab6e3$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $105d4b9eaecab6e3$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === "number" && isNaN(value) === false) {
        var unit = options[prop] || $105d4b9eaecab6e3$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $105d4b9eaecab6e3$var$px)) return typeof unit === "function" ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $105d4b9eaecab6e3$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $105d4b9eaecab6e3$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        for(var prop in style)style[prop] = $105d4b9eaecab6e3$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $105d4b9eaecab6e3$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $105d4b9eaecab6e3$export$2e2bcd8739ae039 = $105d4b9eaecab6e3$var$defaultUnit;



var $4dSXJ = parcelRequire("4dSXJ");
function $59979e7ee80633dd$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $00ab898a0c3426b2$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $59979e7ee80633dd$export$2e2bcd8739ae039)(arr);
}


function $6b138a13403392be$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $a39e8ae1c743274c$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $59979e7ee80633dd$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $59979e7ee80633dd$export$2e2bcd8739ae039)(o, minLen);
}


function $e87ba2ac9b8f5cf2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $cc85964c3bb5b33f$export$2e2bcd8739ae039(arr) {
    return (0, $00ab898a0c3426b2$export$2e2bcd8739ae039)(arr) || (0, $6b138a13403392be$export$2e2bcd8739ae039)(arr) || (0, $a39e8ae1c743274c$export$2e2bcd8739ae039)(arr) || (0, $e87ba2ac9b8f5cf2$export$2e2bcd8739ae039)();
}


// Export javascript style and css style vendor prefixes.
var $79804faf0bc4586e$var$js = "";
var $79804faf0bc4586e$var$css = "";
var $79804faf0bc4586e$var$vendor = "";
var $79804faf0bc4586e$var$browser = "";
var $79804faf0bc4586e$var$isTouch = (0, $4dSXJ.default) && "ontouchstart" in document.documentElement; // We should not do anything if required serverside.
if (0, $4dSXJ.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $79804faf0bc4586e$var$jsCssMap = {
        Moz: "-moz-",
        ms: "-ms-",
        O: "-o-",
        Webkit: "-webkit-"
    };
    var $79804faf0bc4586e$var$_document$createEleme = document.createElement("p"), $79804faf0bc4586e$var$style = $79804faf0bc4586e$var$_document$createEleme.style;
    var $79804faf0bc4586e$var$testProp = "Transform";
    for(var $79804faf0bc4586e$var$key in $79804faf0bc4586e$var$jsCssMap)if ($79804faf0bc4586e$var$key + $79804faf0bc4586e$var$testProp in $79804faf0bc4586e$var$style) {
        $79804faf0bc4586e$var$js = $79804faf0bc4586e$var$key;
        $79804faf0bc4586e$var$css = $79804faf0bc4586e$var$jsCssMap[$79804faf0bc4586e$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($79804faf0bc4586e$var$js === "Webkit" && "msHyphens" in $79804faf0bc4586e$var$style) {
        $79804faf0bc4586e$var$js = "ms";
        $79804faf0bc4586e$var$css = $79804faf0bc4586e$var$jsCssMap.ms;
        $79804faf0bc4586e$var$browser = "edge";
    } // Correctly detect the Safari browser.
    if ($79804faf0bc4586e$var$js === "Webkit" && "-apple-trailing-word" in $79804faf0bc4586e$var$style) $79804faf0bc4586e$var$vendor = "apple";
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $79804faf0bc4586e$export$82e9f45cca5ba907 = {
    js: $79804faf0bc4586e$var$js,
    css: $79804faf0bc4586e$var$css,
    vendor: $79804faf0bc4586e$var$vendor,
    browser: $79804faf0bc4586e$var$browser,
    isTouch: $79804faf0bc4586e$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $79804faf0bc4586e$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === "-") return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($79804faf0bc4586e$export$82e9f45cca5ba907.js === "ms") return key;
    return "@" + $79804faf0bc4586e$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $79804faf0bc4586e$var$appearence = {
    noPrefill: [
        "appearance"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "appearance") return false;
        if ($79804faf0bc4586e$export$82e9f45cca5ba907.js === "ms") return "-webkit-" + prop;
        return $79804faf0bc4586e$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $79804faf0bc4586e$var$colorAdjust = {
    noPrefill: [
        "color-adjust"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "color-adjust") return false;
        if ($79804faf0bc4586e$export$82e9f45cca5ba907.js === "Webkit") return $79804faf0bc4586e$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $79804faf0bc4586e$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $79804faf0bc4586e$var$toUpper(match, c) {
    return c ? c.toUpperCase() : "";
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $79804faf0bc4586e$var$camelize(str) {
    return str.replace($79804faf0bc4586e$var$regExp, $79804faf0bc4586e$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $79804faf0bc4586e$var$pascalize(str) {
    return $79804faf0bc4586e$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $79804faf0bc4586e$var$mask = {
    noPrefill: [
        "mask"
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($79804faf0bc4586e$export$82e9f45cca5ba907.js === "Webkit") {
            var longhand = "mask-image";
            if ($79804faf0bc4586e$var$camelize(longhand) in style) return prop;
            if ($79804faf0bc4586e$export$82e9f45cca5ba907.js + $79804faf0bc4586e$var$pascalize(longhand) in style) return $79804faf0bc4586e$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $79804faf0bc4586e$var$textOrientation = {
    noPrefill: [
        "text-orientation"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "text-orientation") return false;
        if ($79804faf0bc4586e$export$82e9f45cca5ba907.vendor === "apple" && !$79804faf0bc4586e$export$82e9f45cca5ba907.isTouch) return $79804faf0bc4586e$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $79804faf0bc4586e$var$transform = {
    noPrefill: [
        "transform"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transform") return false;
        if (options.transform) return prop;
        return $79804faf0bc4586e$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $79804faf0bc4586e$var$transition = {
    noPrefill: [
        "transition"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transition") return false;
        if (options.transition) return prop;
        return $79804faf0bc4586e$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $79804faf0bc4586e$var$writingMode = {
    noPrefill: [
        "writing-mode"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "writing-mode") return false;
        if ($79804faf0bc4586e$export$82e9f45cca5ba907.js === "Webkit" || $79804faf0bc4586e$export$82e9f45cca5ba907.js === "ms" && $79804faf0bc4586e$export$82e9f45cca5ba907.browser !== "edge") return $79804faf0bc4586e$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $79804faf0bc4586e$var$userSelect = {
    noPrefill: [
        "user-select"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "user-select") return false;
        if ($79804faf0bc4586e$export$82e9f45cca5ba907.js === "Moz" || $79804faf0bc4586e$export$82e9f45cca5ba907.js === "ms" || $79804faf0bc4586e$export$82e9f45cca5ba907.vendor === "apple") return $79804faf0bc4586e$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $79804faf0bc4586e$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($79804faf0bc4586e$export$82e9f45cca5ba907.js === "Webkit") {
            var jsProp = "WebkitColumn" + $79804faf0bc4586e$var$pascalize(prop);
            return jsProp in style ? $79804faf0bc4586e$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($79804faf0bc4586e$export$82e9f45cca5ba907.js === "Moz") {
            var _jsProp = "page" + $79804faf0bc4586e$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $79804faf0bc4586e$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($79804faf0bc4586e$export$82e9f45cca5ba907.js === "Moz") return prop;
        var newProp = prop.replace("-inline", "");
        return $79804faf0bc4586e$export$82e9f45cca5ba907.js + $79804faf0bc4586e$var$pascalize(newProp) in style ? $79804faf0bc4586e$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $79804faf0bc4586e$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $79804faf0bc4586e$var$camelize(prop) in style ? prop : false;
    }
};
var $79804faf0bc4586e$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $79804faf0bc4586e$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === "-") return prop; // Return already prefixed value without prefixing.
        if (prop[0] === "-" && prop[1] === "-") return prop;
        if ($79804faf0bc4586e$export$82e9f45cca5ba907.js + pascalized in style) return $79804faf0bc4586e$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($79804faf0bc4586e$export$82e9f45cca5ba907.js !== "Webkit" && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $79804faf0bc4586e$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== "scroll-snap") return false;
        if ($79804faf0bc4586e$export$82e9f45cca5ba907.js === "ms") return "" + $79804faf0bc4586e$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $79804faf0bc4586e$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "overscroll-behavior") return false;
        if ($79804faf0bc4586e$export$82e9f45cca5ba907.js === "ms") return $79804faf0bc4586e$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $79804faf0bc4586e$var$propMap = {
    "flex-grow": "flex-positive",
    "flex-shrink": "flex-negative",
    "flex-basis": "flex-preferred-size",
    "justify-content": "flex-pack",
    order: "flex-order",
    "align-items": "flex-align",
    "align-content": "flex-line-pack" // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $79804faf0bc4586e$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $79804faf0bc4586e$var$propMap[prop];
        if (!newProp) return false;
        return $79804faf0bc4586e$export$82e9f45cca5ba907.js + $79804faf0bc4586e$var$pascalize(newProp) in style ? $79804faf0bc4586e$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $79804faf0bc4586e$var$propMap$1 = {
    flex: "box-flex",
    "flex-grow": "box-flex",
    "flex-direction": [
        "box-orient",
        "box-direction"
    ],
    order: "box-ordinal-group",
    "align-items": "box-align",
    "flex-flow": [
        "box-orient",
        "box-direction"
    ],
    "justify-content": "box-pack"
};
var $79804faf0bc4586e$var$propKeys = Object.keys($79804faf0bc4586e$var$propMap$1);
var $79804faf0bc4586e$var$prefixCss = function prefixCss(p) {
    return $79804faf0bc4586e$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $79804faf0bc4586e$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($79804faf0bc4586e$var$propKeys.indexOf(prop) > -1) {
            var newProp = $79804faf0bc4586e$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $79804faf0bc4586e$export$82e9f45cca5ba907.js + $79804faf0bc4586e$var$pascalize(newProp) in style ? $79804faf0bc4586e$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($79804faf0bc4586e$export$82e9f45cca5ba907.js + $79804faf0bc4586e$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($79804faf0bc4586e$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $79804faf0bc4586e$var$plugins = [
    $79804faf0bc4586e$var$appearence,
    $79804faf0bc4586e$var$colorAdjust,
    $79804faf0bc4586e$var$mask,
    $79804faf0bc4586e$var$textOrientation,
    $79804faf0bc4586e$var$transform,
    $79804faf0bc4586e$var$transition,
    $79804faf0bc4586e$var$writingMode,
    $79804faf0bc4586e$var$userSelect,
    $79804faf0bc4586e$var$breakPropsOld,
    $79804faf0bc4586e$var$inlineLogicalOld,
    $79804faf0bc4586e$var$unprefixed,
    $79804faf0bc4586e$var$prefixed,
    $79804faf0bc4586e$var$scrollSnap,
    $79804faf0bc4586e$var$overscrollBehavior,
    $79804faf0bc4586e$var$flex2012,
    $79804faf0bc4586e$var$flex2009
];
var $79804faf0bc4586e$var$propertyDetectors = $79804faf0bc4586e$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $79804faf0bc4586e$var$noPrefill = $79804faf0bc4586e$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $cc85964c3bb5b33f$export$2e2bcd8739ae039)(p.noPrefill));
    return a;
}, []);
var $79804faf0bc4586e$var$el;
var $79804faf0bc4586e$var$cache = {};
if (0, $4dSXJ.default) {
    $79804faf0bc4586e$var$el = document.createElement("p"); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $79804faf0bc4586e$var$computed = window.getComputedStyle(document.documentElement, "");
    for(var $79804faf0bc4586e$var$key$1 in $79804faf0bc4586e$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($79804faf0bc4586e$var$key$1)) $79804faf0bc4586e$var$cache[$79804faf0bc4586e$var$computed[$79804faf0bc4586e$var$key$1]] = $79804faf0bc4586e$var$computed[$79804faf0bc4586e$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $79804faf0bc4586e$var$noPrefill.forEach(function(x) {
        return delete $79804faf0bc4586e$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $79804faf0bc4586e$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$79804faf0bc4586e$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($79804faf0bc4586e$var$cache[prop] != null) return $79804faf0bc4586e$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === "transition" || prop === "transform") options[prop] = prop in $79804faf0bc4586e$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $79804faf0bc4586e$var$propertyDetectors.length; i++){
        $79804faf0bc4586e$var$cache[prop] = $79804faf0bc4586e$var$propertyDetectors[i](prop, $79804faf0bc4586e$var$el.style, options); // Break loop, if value found.
        if ($79804faf0bc4586e$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $79804faf0bc4586e$var$el.style[prop] = "";
    } catch (err) {
        return false;
    }
    return $79804faf0bc4586e$var$cache[prop];
}
var $79804faf0bc4586e$var$cache$1 = {};
var $79804faf0bc4586e$var$transitionProperties = {
    transition: 1,
    "transition-property": 1,
    "-webkit-transition": 1,
    "-webkit-transition-property": 1
};
var $79804faf0bc4586e$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $79804faf0bc4586e$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $79804faf0bc4586e$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === "var") return "var";
    if (p1 === "all") return "all";
    if (p2 === "all") return ", all";
    var prefixedValue = p1 ? $79804faf0bc4586e$export$ce097f82c2e4551a(p1) : ", " + $79804faf0bc4586e$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $4dSXJ.default) $79804faf0bc4586e$var$el$1 = document.createElement("p");
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $79804faf0bc4586e$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$79804faf0bc4586e$var$el$1 || property === "content") return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== "string" || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($79804faf0bc4586e$var$cache$1[cacheKey] != null) return $79804faf0bc4586e$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $79804faf0bc4586e$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $79804faf0bc4586e$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($79804faf0bc4586e$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($79804faf0bc4586e$var$transPropsRegExp, $79804faf0bc4586e$var$prefixTransitionCallback);
    else if ($79804faf0bc4586e$var$el$1.style[property] === "") {
        // Value with a vendor prefix.
        prefixedValue = $79804faf0bc4586e$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === "-ms-flex") $79804faf0bc4586e$var$el$1.style[property] = "-ms-flexbox"; // Test prefixed value.
        $79804faf0bc4586e$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($79804faf0bc4586e$var$el$1.style[property] === "") {
            $79804faf0bc4586e$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $79804faf0bc4586e$var$el$1.style[property] = ""; // Write current value to cache.
    $79804faf0bc4586e$var$cache$1[cacheKey] = prefixedValue;
    return $79804faf0bc4586e$var$cache$1[cacheKey];
}



var $4Z4HE = parcelRequire("4Z4HE");
/**
 * Add vendor prefix to a property name when needed.
 */ function $c1fcefa9c74dafe4$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === "keyframes") {
            var atRule = rule;
            atRule.at = (0, $79804faf0bc4586e$export$b6aa0648d950180a)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === "fallbacks" && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $79804faf0bc4586e$export$ce097f82c2e4551a)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $79804faf0bc4586e$export$511766124059c277)(supportedProp, (0, $4Z4HE.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $79804faf0bc4586e$export$511766124059c277)(prop, (0, $4Z4HE.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $c1fcefa9c74dafe4$export$2e2bcd8739ae039 = $c1fcefa9c74dafe4$var$jssVendorPrefixer;


/**
 * Sort props by length.
 */ function $4157d3663b6287b6$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== "style") return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $4157d3663b6287b6$export$2e2bcd8739ae039 = $4157d3663b6287b6$var$jssPropsSort;


function $84f17663b06d60b6$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $4da7cddbd1f2bfab$export$2e2bcd8739ae039)(),
            (0, $d03cb5a025812fe7$export$2e2bcd8739ae039)(),
            (0, $87ae6c43024cc9b2$export$2e2bcd8739ae039)(),
            (0, $5ef47dee1f2b9715$export$2e2bcd8739ae039)(),
            (0, $105d4b9eaecab6e3$export$2e2bcd8739ae039)(),
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === "undefined" ? null : (0, $c1fcefa9c74dafe4$export$2e2bcd8739ae039)(),
            (0, $4157d3663b6287b6$export$2e2bcd8739ae039)()
        ]
    };
}


var $e19cddf4a31c4c83$var$jss = (0, $4Z4HE.create)((0, $84f17663b06d60b6$export$2e2bcd8739ae039)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
var $e19cddf4a31c4c83$var$generateClassName = (0, $13e96a4a0f403cd0$export$2e2bcd8739ae039)(); // Exported for test purposes
var $e19cddf4a31c4c83$export$70a8aea9ff58d1cd = new Map();
var $e19cddf4a31c4c83$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $e19cddf4a31c4c83$var$generateClassName,
    jss: $e19cddf4a31c4c83$var$jss,
    sheetsCache: null,
    sheetsManager: $e19cddf4a31c4c83$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
var $e19cddf4a31c4c83$export$f4de434b269fe487 = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext($e19cddf4a31c4c83$var$defaultOptions);
var $e19cddf4a31c4c83$var$injectFirstNode;
function $e19cddf4a31c4c83$export$2e2bcd8739ae039(props) {
    var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = (0, $636333a0deecc159$export$2e2bcd8739ae039)(props, [
        "children",
        "injectFirst",
        "disableGeneration"
    ]);
    var outerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useContext($e19cddf4a31c4c83$export$f4de434b269fe487);
    var context = (0, $j1NUG.default)({}, outerOptions, {
        disableGeneration: disableGeneration
    }, localOptions);
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== "undefined") {
        if (!$e19cddf4a31c4c83$var$injectFirstNode) {
            var head = document.head;
            $e19cddf4a31c4c83$var$injectFirstNode = document.createComment("mui-inject-first");
            head.insertBefore($e19cddf4a31c4c83$var$injectFirstNode, head.firstChild);
        }
        context.jss = (0, $4Z4HE.create)({
            plugins: (0, $84f17663b06d60b6$export$2e2bcd8739ae039)().plugins,
            insertionPoint: $e19cddf4a31c4c83$var$injectFirstNode
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($e19cddf4a31c4c83$export$f4de434b269fe487.Provider, {
        value: context
    }, children);
}





var $j1NUG = parcelRequire("j1NUG");
function $5a91684feabc84d2$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $5a91684feabc84d2$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5a91684feabc84d2$export$2e2bcd8739ae039(obj);
}


function $04bac6f1fa6ae0d7$export$53b83ca8eaab0383(item) {
    return item && (0, $5a91684feabc84d2$export$2e2bcd8739ae039)(item) === "object" && item.constructor === Object;
}
function $04bac6f1fa6ae0d7$export$2e2bcd8739ae039(target, source) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        clone: true
    };
    var output = options.clone ? (0, $j1NUG.default)({}, target) : target;
    if ($04bac6f1fa6ae0d7$export$53b83ca8eaab0383(target) && $04bac6f1fa6ae0d7$export$53b83ca8eaab0383(source)) Object.keys(source).forEach(function(key) {
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($04bac6f1fa6ae0d7$export$53b83ca8eaab0383(source[key]) && key in target) output[key] = $04bac6f1fa6ae0d7$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}



var $j1NUG = parcelRequire("j1NUG");

var $adc24562274b285e$export$ed97f33186d4b816 = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
]; // Keep in mind that @media is inclusive by the CSS specification.
function $adc24562274b285e$export$2e2bcd8739ae039(breakpoints) {
    var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? "px" : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0, $636333a0deecc159$export$2e2bcd8739ae039)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    function up(key) {
        var value = typeof values[key] === "number" ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = $adc24562274b285e$export$ed97f33186d4b816.indexOf(key) + 1;
        var upperbound = values[$adc24562274b285e$export$ed97f33186d4b816[endIndex]];
        if (endIndex === $adc24562274b285e$export$ed97f33186d4b816.length) // xl down applies to all sizes
        return up("xs");
        var value = typeof upperbound === "number" && endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = $adc24562274b285e$export$ed97f33186d4b816.indexOf(end);
        if (endIndex === $adc24562274b285e$export$ed97f33186d4b816.length - 1) return up(start);
        return "@media (min-width:".concat(typeof values[start] === "number" ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[$adc24562274b285e$export$ed97f33186d4b816[endIndex + 1]] === "number" ? values[$adc24562274b285e$export$ed97f33186d4b816[endIndex + 1]] : end) - step / 100).concat(unit, ")");
    }
    function only(key) {
        return between(key, key);
    }
    var warnedOnce = false;
    function width(key) {
        return values[key];
    }
    return (0, $j1NUG.default)({
        keys: $adc24562274b285e$export$ed97f33186d4b816,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    }, other);
}




var $j1NUG = parcelRequire("j1NUG");
function $cf748c46dff8c82f$export$2e2bcd8739ae039(breakpoints, spacing, mixins) {
    var _toolbar;
    return (0, $j1NUG.default)({
        gutters: function gutters() {
            var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            console.warn([
                "Material-UI: theme.mixins.gutters() is deprecated.",
                "You can use the source of the mixin directly:",
                "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "
            ].join("\n"));
            return (0, $j1NUG.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, (0, $271d31b42c64d81e$export$2e2bcd8739ae039)({}, breakpoints.up("sm"), (0, $j1NUG.default)({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up("sm")])));
        },
        toolbar: (_toolbar = {
            minHeight: 56
        }, (0, $271d31b42c64d81e$export$2e2bcd8739ae039)(_toolbar, "".concat(breakpoints.up("xs"), " and (orientation: landscape)"), {
            minHeight: 48
        }), (0, $271d31b42c64d81e$export$2e2bcd8739ae039)(_toolbar, breakpoints.up("sm"), {
            minHeight: 64
        }), _toolbar)
    }, mixins);
}



var $j1NUG = parcelRequire("j1NUG");

/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $6e0d87268766b68e$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ var url = "https://material-ui.com/production-error/?code=" + code;
    for(var i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified Material-UI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }


var $f0277656017206c7$var$common = {
    black: "#000",
    white: "#fff"
};
var $f0277656017206c7$export$2e2bcd8739ae039 = $f0277656017206c7$var$common;


var $87664339ae2d15e1$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#d5d5d5",
    A200: "#aaaaaa",
    A400: "#303030",
    A700: "#616161"
};
var $87664339ae2d15e1$export$2e2bcd8739ae039 = $87664339ae2d15e1$var$grey;


var $8de1c2a7ee4eb1b8$var$indigo = {
    50: "#e8eaf6",
    100: "#c5cae9",
    200: "#9fa8da",
    300: "#7986cb",
    400: "#5c6bc0",
    500: "#3f51b5",
    600: "#3949ab",
    700: "#303f9f",
    800: "#283593",
    900: "#1a237e",
    A100: "#8c9eff",
    A200: "#536dfe",
    A400: "#3d5afe",
    A700: "#304ffe"
};
var $8de1c2a7ee4eb1b8$export$2e2bcd8739ae039 = $8de1c2a7ee4eb1b8$var$indigo;


var $f064cd3f9c5553d0$var$pink = {
    50: "#fce4ec",
    100: "#f8bbd0",
    200: "#f48fb1",
    300: "#f06292",
    400: "#ec407a",
    500: "#e91e63",
    600: "#d81b60",
    700: "#c2185b",
    800: "#ad1457",
    900: "#880e4f",
    A100: "#ff80ab",
    A200: "#ff4081",
    A400: "#f50057",
    A700: "#c51162"
};
var $f064cd3f9c5553d0$export$2e2bcd8739ae039 = $f064cd3f9c5553d0$var$pink;


var $f97921d8a54538f2$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $f97921d8a54538f2$export$2e2bcd8739ae039 = $f97921d8a54538f2$var$red;


var $2c92826ebf2aa9c7$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $2c92826ebf2aa9c7$export$2e2bcd8739ae039 = $2c92826ebf2aa9c7$var$orange;


var $959f8762776031fe$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $959f8762776031fe$export$2e2bcd8739ae039 = $959f8762776031fe$var$blue;


var $a056b02aec1addbb$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $a056b02aec1addbb$export$2e2bcd8739ae039 = $a056b02aec1addbb$var$green;



/* eslint-disable no-use-before-define */ /**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $355c8a6a53929a53$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.min(Math.max(min, value), max);
}
function $355c8a6a53929a53$export$5a544e13ad4e1fa5(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), "g");
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? "a" : "", "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", "), ")") : "";
}
function $355c8a6a53929a53$var$intToHex(int) {
    var hex = int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
function $355c8a6a53929a53$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    var _decomposeColor = $355c8a6a53929a53$export$677b39864803984e(color), values = _decomposeColor.values;
    return "#".concat(values.map(function(n) {
        return $355c8a6a53929a53$var$intToHex(n);
    }).join(""));
}
function $355c8a6a53929a53$export$29fb7152bd3f781a(color) {
    color = $355c8a6a53929a53$export$677b39864803984e(color);
    var _color = color, values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = "rgb";
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $355c8a6a53929a53$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $355c8a6a53929a53$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $355c8a6a53929a53$export$677b39864803984e($355c8a6a53929a53$export$5a544e13ad4e1fa5(color));
    var marker = color.indexOf("(");
    var type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla"
    ].indexOf(type) === -1) throw new Error((0, $6e0d87268766b68e$export$2e2bcd8739ae039)(3, color));
    var values = color.substring(marker + 1, color.length - 1).split(",");
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values
    };
}
function $355c8a6a53929a53$export$211a73f2b8c10ce4(color) {
    var type = color.type;
    var values = color.values;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf("hsl") !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    return "".concat(type, "(").concat(values.join(", "), ")");
}
function $355c8a6a53929a53$export$d061e26956a60b0a(foreground, background) {
    var lumA = $355c8a6a53929a53$export$c852d90bf7403b62(foreground);
    var lumB = $355c8a6a53929a53$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $355c8a6a53929a53$export$c852d90bf7403b62(color) {
    color = $355c8a6a53929a53$export$677b39864803984e(color);
    var rgb = color.type === "hsl" ? $355c8a6a53929a53$export$677b39864803984e($355c8a6a53929a53$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map(function(val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $355c8a6a53929a53$export$e665714f76e581fd(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return $355c8a6a53929a53$export$c852d90bf7403b62(color) > 0.5 ? $355c8a6a53929a53$export$4b073707ff63303(color, coefficient) : $355c8a6a53929a53$export$c0816ed86df316af(color, coefficient);
}
var $355c8a6a53929a53$var$warnedOnce = false;
function $355c8a6a53929a53$export$cbea29d068a2e18f(color, value) {
    return $355c8a6a53929a53$export$58f0f39f63f3cf42(color, value);
}
function $355c8a6a53929a53$export$58f0f39f63f3cf42(color, value) {
    color = $355c8a6a53929a53$export$677b39864803984e(color);
    value = $355c8a6a53929a53$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    color.values[3] = value;
    return $355c8a6a53929a53$export$211a73f2b8c10ce4(color);
}
function $355c8a6a53929a53$export$4b073707ff63303(color, coefficient) {
    color = $355c8a6a53929a53$export$677b39864803984e(color);
    coefficient = $355c8a6a53929a53$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $355c8a6a53929a53$export$211a73f2b8c10ce4(color);
}
function $355c8a6a53929a53$export$c0816ed86df316af(color, coefficient) {
    color = $355c8a6a53929a53$export$677b39864803984e(color);
    coefficient = $355c8a6a53929a53$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    return $355c8a6a53929a53$export$211a73f2b8c10ce4(color);
}


var $b867ebd94f0c80e5$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.54)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)",
        // Text hints.
        hint: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $f0277656017206c7$export$2e2bcd8739ae039).white,
        default: (0, $87664339ae2d15e1$export$2e2bcd8739ae039)[50]
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
var $b867ebd94f0c80e5$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $f0277656017206c7$export$2e2bcd8739ae039).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        hint: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: (0, $87664339ae2d15e1$export$2e2bcd8739ae039)[800],
        default: "#303030"
    },
    action: {
        active: (0, $f0277656017206c7$export$2e2bcd8739ae039).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $b867ebd94f0c80e5$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $355c8a6a53929a53$export$c0816ed86df316af)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $355c8a6a53929a53$export$4b073707ff63303)(intent.main, tonalOffsetDark);
    }
}
function $b867ebd94f0c80e5$export$2e2bcd8739ae039(palette) {
    var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
        light: (0, $8de1c2a7ee4eb1b8$export$2e2bcd8739ae039)[300],
        main: (0, $8de1c2a7ee4eb1b8$export$2e2bcd8739ae039)[500],
        dark: (0, $8de1c2a7ee4eb1b8$export$2e2bcd8739ae039)[700]
    } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
        light: (0, $f064cd3f9c5553d0$export$2e2bcd8739ae039).A200,
        main: (0, $f064cd3f9c5553d0$export$2e2bcd8739ae039).A400,
        dark: (0, $f064cd3f9c5553d0$export$2e2bcd8739ae039).A700
    } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
        light: (0, $f97921d8a54538f2$export$2e2bcd8739ae039)[300],
        main: (0, $f97921d8a54538f2$export$2e2bcd8739ae039)[500],
        dark: (0, $f97921d8a54538f2$export$2e2bcd8739ae039)[700]
    } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
        light: (0, $2c92826ebf2aa9c7$export$2e2bcd8739ae039)[300],
        main: (0, $2c92826ebf2aa9c7$export$2e2bcd8739ae039)[500],
        dark: (0, $2c92826ebf2aa9c7$export$2e2bcd8739ae039)[700]
    } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
        light: (0, $959f8762776031fe$export$2e2bcd8739ae039)[300],
        main: (0, $959f8762776031fe$export$2e2bcd8739ae039)[500],
        dark: (0, $959f8762776031fe$export$2e2bcd8739ae039)[700]
    } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
        light: (0, $a056b02aec1addbb$export$2e2bcd8739ae039)[300],
        main: (0, $a056b02aec1addbb$export$2e2bcd8739ae039)[500],
        dark: (0, $a056b02aec1addbb$export$2e2bcd8739ae039)[700]
    } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? "light" : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0, $636333a0deecc159$export$2e2bcd8739ae039)(palette, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset"
    ]); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $355c8a6a53929a53$export$d061e26956a60b0a)(background, $b867ebd94f0c80e5$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $b867ebd94f0c80e5$export$55ce6f3a06c59543.text.primary : $b867ebd94f0c80e5$export$a43af521ac8c3202.text.primary;
        var contrast;
        return contrastText;
    }
    var augmentColor = function augmentColor(color) {
        var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
        var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
        color = (0, $j1NUG.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.main) throw new Error((0, $6e0d87268766b68e$export$2e2bcd8739ae039)(4, mainShade));
        if (typeof color.main !== "string") throw new Error((0, $6e0d87268766b68e$export$2e2bcd8739ae039)(5, JSON.stringify(color.main)));
        $b867ebd94f0c80e5$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $b867ebd94f0c80e5$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var types = {
        dark: $b867ebd94f0c80e5$export$55ce6f3a06c59543,
        light: $b867ebd94f0c80e5$export$a43af521ac8c3202
    };
    var paletteOutput = (0, $04bac6f1fa6ae0d7$export$2e2bcd8739ae039)((0, $j1NUG.default)({
        // A collection of common colors.
        common: (0, $f0277656017206c7$export$2e2bcd8739ae039),
        // The palette type, can be light or dark.
        type: type,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor(primary),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor(secondary, "A400", "A200", "A700"),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor(error),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor(warning),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor(info),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor(success),
        // The grey colors.
        grey: (0, $87664339ae2d15e1$export$2e2bcd8739ae039),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, types[type]), other);
    return paletteOutput;
}



var $j1NUG = parcelRequire("j1NUG");


function $5ff4b818c5575e3a$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $5ff4b818c5575e3a$var$warnedOnce = false;
function $5ff4b818c5575e3a$var$roundWithDeprecationWarning(value) {
    return $5ff4b818c5575e3a$var$round(value);
}
var $5ff4b818c5575e3a$var$caseAllCaps = {
    textTransform: "uppercase"
};
var $5ff4b818c5575e3a$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $5ff4b818c5575e3a$export$2e2bcd8739ae039(palette, typography) {
    var _ref = typeof typography === "function" ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? $5ff4b818c5575e3a$var$defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $636333a0deecc159$export$2e2bcd8739ae039)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $j1NUG.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $5ff4b818c5575e3a$var$defaultFontFamily ? {
            letterSpacing: "".concat($5ff4b818c5575e3a$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $5ff4b818c5575e3a$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $5ff4b818c5575e3a$var$caseAllCaps)
    };
    return (0, $04bac6f1fa6ae0d7$export$2e2bcd8739ae039)((0, $j1NUG.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        round: $5ff4b818c5575e3a$var$roundWithDeprecationWarning,
        // TODO v5: remove
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}


var $3b990bec7052f19e$var$shadowKeyUmbraOpacity = 0.2;
var $3b990bec7052f19e$var$shadowKeyPenumbraOpacity = 0.14;
var $3b990bec7052f19e$var$shadowAmbientShadowOpacity = 0.12;
function $3b990bec7052f19e$var$createShadow() {
    return [
        "".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat($3b990bec7052f19e$var$shadowKeyUmbraOpacity, ")"),
        "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat($3b990bec7052f19e$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat($3b990bec7052f19e$var$shadowAmbientShadowOpacity, ")")
    ].join(",");
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $3b990bec7052f19e$var$shadows = [
    "none",
    $3b990bec7052f19e$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $3b990bec7052f19e$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $3b990bec7052f19e$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $3b990bec7052f19e$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $3b990bec7052f19e$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $3b990bec7052f19e$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $3b990bec7052f19e$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $3b990bec7052f19e$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $3b990bec7052f19e$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $3b990bec7052f19e$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $3b990bec7052f19e$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $3b990bec7052f19e$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $3b990bec7052f19e$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $3b990bec7052f19e$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $3b990bec7052f19e$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $3b990bec7052f19e$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $3b990bec7052f19e$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $3b990bec7052f19e$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $3b990bec7052f19e$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $3b990bec7052f19e$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $3b990bec7052f19e$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $3b990bec7052f19e$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $3b990bec7052f19e$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $3b990bec7052f19e$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $3b990bec7052f19e$export$2e2bcd8739ae039 = $3b990bec7052f19e$var$shadows;


var $64352a3996f35822$var$shape = {
    borderRadius: 4
};
var $64352a3996f35822$export$2e2bcd8739ae039 = $64352a3996f35822$var$shape;


function $6f8616f1fbf6e15f$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $fa39fafdc1cff7cd$export$2e2bcd8739ae039(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}



function $627f1d59e2e3d308$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $e6b4a46368942149$export$2e2bcd8739ae039(arr, i) {
    return (0, $6f8616f1fbf6e15f$export$2e2bcd8739ae039)(arr) || (0, $fa39fafdc1cff7cd$export$2e2bcd8739ae039)(arr, i) || (0, $a39e8ae1c743274c$export$2e2bcd8739ae039)(arr, i) || (0, $627f1d59e2e3d308$export$2e2bcd8739ae039)();
}





var $j1NUG = parcelRequire("j1NUG");



function $ed593d4483d53def$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $04bac6f1fa6ae0d7$export$2e2bcd8739ae039)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $ed593d4483d53def$export$2e2bcd8739ae039 = $ed593d4483d53def$var$merge;


// For instance with the first breakpoint xs: [xs, sm[.
var $92fe51a5d0f53e35$var$values = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
};
var $92fe51a5d0f53e35$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: function up(key) {
        return "@media (min-width:".concat($92fe51a5d0f53e35$var$values[key], "px)");
    }
};
function $92fe51a5d0f53e35$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    if (Array.isArray(propValue)) {
        var themeBreakpoints = props.theme.breakpoints || $92fe51a5d0f53e35$var$defaultBreakpoints;
        return propValue.reduce(function(acc, item, index) {
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if ((0, $5a91684feabc84d2$export$2e2bcd8739ae039)(propValue) === "object") {
        var _themeBreakpoints = props.theme.breakpoints || $92fe51a5d0f53e35$var$defaultBreakpoints;
        return Object.keys(propValue).reduce(function(acc, breakpoint) {
            acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
            return acc;
        }, {});
    }
    var output = styleFromPropValue(propValue);
    return output;
}
function $92fe51a5d0f53e35$var$breakpoints(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var base = styleFunction(props);
        var themeBreakpoints = props.theme.breakpoints || $92fe51a5d0f53e35$var$defaultBreakpoints;
        var extended = themeBreakpoints.keys.reduce(function(acc, key) {
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $j1NUG.default)({
                    theme: props.theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $ed593d4483d53def$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ].concat((0, $cc85964c3bb5b33f$export$2e2bcd8739ae039)(styleFunction.filterProps));
    return newStyleFunction;
}
var $92fe51a5d0f53e35$export$2e2bcd8739ae039 = $92fe51a5d0f53e35$var$breakpoints;



function $a796e9ce3f898412$export$2e2bcd8739ae039(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $486b243a89a48a23$var$properties = {
    m: "margin",
    p: "padding"
};
var $486b243a89a48a23$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
var $486b243a89a48a23$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
var $486b243a89a48a23$var$getCssProperties = (0, $a796e9ce3f898412$export$2e2bcd8739ae039)(function(prop) {
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($486b243a89a48a23$var$aliases[prop]) prop = $486b243a89a48a23$var$aliases[prop];
        else return [
            prop
        ];
    }
    var _prop$split = prop.split(""), _prop$split2 = (0, $e6b4a46368942149$export$2e2bcd8739ae039)(_prop$split, 2), a = _prop$split2[0], b = _prop$split2[1];
    var property = $486b243a89a48a23$var$properties[a];
    var direction = $486b243a89a48a23$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map(function(dir) {
        return property + dir;
    }) : [
        property + direction
    ];
});
var $486b243a89a48a23$var$spacingKeys = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY"
];
function $486b243a89a48a23$export$1def6f833384e3d1(theme) {
    var themeSpacing = theme.spacing || 8;
    if (typeof themeSpacing === "number") return function(abs) {
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return function(abs) {
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return function() {
        return undefined;
    };
}
function $486b243a89a48a23$var$getValue(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    var abs = Math.abs(propValue);
    var transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return "-".concat(transformed);
}
function $486b243a89a48a23$var$getStyleFromPropValue(cssProperties, transformer) {
    return function(propValue) {
        return cssProperties.reduce(function(acc, cssProperty) {
            acc[cssProperty] = $486b243a89a48a23$var$getValue(transformer, propValue);
            return acc;
        }, {});
    };
}
function $486b243a89a48a23$var$spacing(props) {
    var theme = props.theme;
    var transformer = $486b243a89a48a23$export$1def6f833384e3d1(theme);
    return Object.keys(props).map(function(prop) {
        // Using a hash computation over an array iteration could be faster, but with only 28 items,
        // it's doesn't worth the bundle size.
        if ($486b243a89a48a23$var$spacingKeys.indexOf(prop) === -1) return null;
        var cssProperties = $486b243a89a48a23$var$getCssProperties(prop);
        var styleFromPropValue = $486b243a89a48a23$var$getStyleFromPropValue(cssProperties, transformer);
        var propValue = props[prop];
        return (0, $92fe51a5d0f53e35$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    }).reduce((0, $ed593d4483d53def$export$2e2bcd8739ae039), {});
}
$486b243a89a48a23$var$spacing.propTypes = {};
$486b243a89a48a23$var$spacing.filterProps = $486b243a89a48a23$var$spacingKeys;
var $486b243a89a48a23$export$2e2bcd8739ae039 = $486b243a89a48a23$var$spacing;


var $c4343a2d7b12e872$var$warnOnce;
function $c4343a2d7b12e872$export$2e2bcd8739ae039() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
    // Smaller components, such as icons and type, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    var transform = (0, $486b243a89a48a23$export$1def6f833384e3d1)({
        spacing: spacingInput
    });
    var spacing = function spacing() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 0) return transform(1);
        if (args.length === 1) return transform(args[0]);
        return args.map(function(argument) {
            if (typeof argument === "string") return argument;
            var output = transform(argument);
            return typeof output === "number" ? "".concat(output, "px") : output;
        }).join(" ");
    }; // Backward compatibility, to remove in v5.
    Object.defineProperty(spacing, "unit", {
        get: function get() {
            return spacingInput;
        }
    });
    spacing.mui = true;
    return spacing;
}



var $79cf0b50b6f9ce39$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
var $79cf0b50b6f9ce39$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $79cf0b50b6f9ce39$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
var /**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */ $79cf0b50b6f9ce39$export$2e2bcd8739ae039 = {
    easing: $79cf0b50b6f9ce39$export$24c5ac7c37452e7d,
    duration: $79cf0b50b6f9ce39$export$1f34108aa9eb96ab,
    create: function create() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            "all"
        ];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$duration = options.duration, durationOption = _options$duration === void 0 ? $79cf0b50b6f9ce39$export$1f34108aa9eb96ab.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? $79cf0b50b6f9ce39$export$24c5ac7c37452e7d.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0, $636333a0deecc159$export$2e2bcd8739ae039)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        var isString, isNumber;
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === "string" ? durationOption : $79cf0b50b6f9ce39$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === "string" ? delay : $79cf0b50b6f9ce39$var$formatMs(delay));
        }).join(",");
    },
    getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) return 0;
        var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    }
};


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $33b246dad8c4b06b$var$zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $33b246dad8c4b06b$export$2e2bcd8739ae039 = $33b246dad8c4b06b$var$zIndex;


function $e0ad99f052315c23$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0, $636333a0deecc159$export$2e2bcd8739ae039)(options, [
        "breakpoints",
        "mixins",
        "palette",
        "spacing",
        "typography"
    ]);
    var palette = (0, $b867ebd94f0c80e5$export$2e2bcd8739ae039)(paletteInput);
    var breakpoints = (0, $adc24562274b285e$export$2e2bcd8739ae039)(breakpointsInput);
    var spacing = (0, $c4343a2d7b12e872$export$2e2bcd8739ae039)(spacingInput);
    var muiTheme = (0, $04bac6f1fa6ae0d7$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: "ltr",
        mixins: (0, $cf748c46dff8c82f$export$2e2bcd8739ae039)(breakpoints, spacing, mixinsInput),
        overrides: {},
        // Inject custom styles
        palette: palette,
        props: {},
        // Provide default props
        shadows: (0, $3b990bec7052f19e$export$2e2bcd8739ae039),
        typography: (0, $5ff4b818c5575e3a$export$2e2bcd8739ae039)(palette, typographyInput),
        spacing: spacing,
        shape: (0, $64352a3996f35822$export$2e2bcd8739ae039),
        transitions: (0, $79cf0b50b6f9ce39$export$2e2bcd8739ae039),
        zIndex: (0, $33b246dad8c4b06b$export$2e2bcd8739ae039)
    }, other);
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $04bac6f1fa6ae0d7$export$2e2bcd8739ae039)(acc, argument);
    }, muiTheme);
    var pseudoClasses, traverse;
    return muiTheme;
}
var $e0ad99f052315c23$var$warnedOnce = false;
function $e0ad99f052315c23$export$c469355549431d9b() {
    return $e0ad99f052315c23$var$createTheme.apply(void 0, arguments);
}
var $e0ad99f052315c23$export$2e2bcd8739ae039 = $e0ad99f052315c23$var$createTheme;


const $e5b1f872cc7ad8d2$var$theme = (0, $e0ad99f052315c23$export$2e2bcd8739ae039)({});
// Theme Overrides
$e5b1f872cc7ad8d2$var$theme.overrides = {
    MuiButton: {
        root: {
            backgroundColor: "green",
            textTransform: "none",
            minWidth: 120,
            borderRadius: 5
        },
        label: {
            fontSize: "16px",
            fontWeight: "inherit"
        }
    },
    MuiOutlinedInput: {
        root: {
            "&&& $input": {
                padding: 0
            }
        }
    },
    MuiAutocomplete: {
        root: {
            backgroundColor: "#fff",
            "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #ced4da"
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #ced4da"
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #ced4da"
            }
        },
        popper: {
            padding: "0px !important",
            boxShadow: "none !important"
        },
        listbox: {
            padding: 0
        },
        option: {
            paddingTop: 12,
            paddingLeft: 16,
            paddingRight: 16,
            paddingBottom: 12
        },
        inputRoot: {
            '&&[class*="MuiOutlinedInput-root"] $input': {
                padding: 0,
                "&:first-child": {
                    padding: "6px 4px",
                    height: "100%"
                }
            }
        }
    },
    MuiPaper: {
        elevation1: {
            boxShadow: "none",
            border: "1px solid #ced4da"
        }
    }
};
// Default Component Props
$e5b1f872cc7ad8d2$var$theme.props = {
    MuiButton: {
        disableElevation: true,
        disableRipple: true,
        disableFocusRipple: true
    },
    MuiTextField: {
        InputLabelProps: {
            shrink: false
        }
    }
};
var $e5b1f872cc7ad8d2$export$2e2bcd8739ae039 = $e5b1f872cc7ad8d2$var$theme;


function $9d7ddad68135e136$var$AppMaterialUIThemeProvider(props) {
    // Destructure
    const { children: children } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cda1d15932e56755$export$2e2bcd8739ae039), {
        theme: (0, $e5b1f872cc7ad8d2$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e19cddf4a31c4c83$export$2e2bcd8739ae039), {
            injectFirst: true,
            children: children
        })
    });
}
var $9d7ddad68135e136$export$2e2bcd8739ae039 = $9d7ddad68135e136$var$AppMaterialUIThemeProvider;
// Proptypes Validation
$9d7ddad68135e136$var$AppMaterialUIThemeProvider.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node),
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]).isRequired
};


/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");

var $lpmCO = parcelRequire("lpmCO");

var $tZqWC = parcelRequire("tZqWC");

var $8VYnW = parcelRequire("8VYnW");
var $62abe5e5578e40c4$exports = {};
"use strict";

$62abe5e5578e40c4$exports = (parcelRequire("8hHqr"));



var $7zrdF = parcelRequire("7zrdF");
var $a47f529d25029b45$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/valtio/esm/react.mjs"
});
const { use: $a47f529d25029b45$var$use } = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC)));
const { useSyncExternalStore: $a47f529d25029b45$var$useSyncExternalStore } = (0, (/*@__PURE__*/$parcel$interopDefault($62abe5e5578e40c4$exports)));
const $a47f529d25029b45$var$useAffectedDebugValue = (state, affected)=>{
    const pathList = (0, $tZqWC.useRef)();
    (0, $tZqWC.useEffect)(()=>{
        pathList.current = (0, $8VYnW.affectedToPathList)(state, affected, true);
    });
    (0, $tZqWC.useDebugValue)(pathList.current);
};
const $a47f529d25029b45$var$targetCache = /* @__PURE__ */ new WeakMap();
function $a47f529d25029b45$export$12201ede76c4c5e1(proxyObject, options) {
    const notifyInSync = options == null ? void 0 : options.sync;
    const lastSnapshot = (0, $tZqWC.useRef)();
    const lastAffected = (0, $tZqWC.useRef)();
    let inRender = true;
    const currSnapshot = $a47f529d25029b45$var$useSyncExternalStore((0, $tZqWC.useCallback)((callback)=>{
        const unsub = (0, $7zrdF.subscribe)(proxyObject, callback, notifyInSync);
        callback();
        return unsub;
    }, [
        proxyObject,
        notifyInSync
    ]), ()=>{
        const nextSnapshot = (0, $7zrdF.snapshot)(proxyObject, $a47f529d25029b45$var$use);
        try {
            if (!inRender && lastSnapshot.current && lastAffected.current && !(0, $8VYnW.isChanged)(lastSnapshot.current, nextSnapshot, lastAffected.current, /* @__PURE__ */ new WeakMap())) return lastSnapshot.current;
        } catch (e) {}
        return nextSnapshot;
    }, ()=>(0, $7zrdF.snapshot)(proxyObject, $a47f529d25029b45$var$use));
    inRender = false;
    const currAffected = /* @__PURE__ */ new WeakMap();
    (0, $tZqWC.useEffect)(()=>{
        lastSnapshot.current = currSnapshot;
        lastAffected.current = currAffected;
    });
    if (($a47f529d25029b45$import_meta.env ? $a47f529d25029b45$import_meta.env.MODE : void 0) !== "production") $a47f529d25029b45$var$useAffectedDebugValue(currSnapshot, currAffected);
    const proxyCache = (0, $tZqWC.useMemo)(()=>/* @__PURE__ */ new WeakMap(), []);
    return (0, $8VYnW.createProxy)(currSnapshot, currAffected, proxyCache, $a47f529d25029b45$var$targetCache);
}



var $b3v9s = parcelRequire("b3v9s");

var $gD0RX = parcelRequire("gD0RX");

var $efZLi = parcelRequire("efZLi");

var $58cAm = parcelRequire("58cAm");

var $lpmCO = parcelRequire("lpmCO");

var $bc5dy = parcelRequire("bc5dy");
function $2b5a8e9ff96f5bfb$export$5c775cffc88d83ea() {
    const { activeCaipNetwork: activeCaipNetwork } = (0, $a47f529d25029b45$export$12201ede76c4c5e1)((0, $gD0RX.ChainController).state);
    return {
        caipNetwork: activeCaipNetwork,
        chainId: activeCaipNetwork?.id,
        caipNetworkId: activeCaipNetwork?.caipNetworkId
    };
}
function $2b5a8e9ff96f5bfb$export$bc49ae41288a26c3(options) {
    const state = (0, $a47f529d25029b45$export$12201ede76c4c5e1)((0, $gD0RX.ChainController).state);
    const chainNamespace = options?.namespace || state.activeChain;
    if (!chainNamespace) return {
        allAccounts: [],
        address: undefined,
        caipAddress: undefined,
        status: undefined,
        isConnected: false,
        embeddedWalletInfo: undefined
    };
    const chainAccountState = state.chains.get(chainNamespace)?.accountState;
    const authConnector = (0, $58cAm.ConnectorController).getAuthConnector(chainNamespace);
    const activeConnectorId = (0, $bc5dy.StorageUtil).getConnectedConnectorId(chainNamespace);
    return {
        allAccounts: chainAccountState?.allAccounts || [],
        caipAddress: chainAccountState?.caipAddress,
        address: (0, $lpmCO.CoreHelperUtil).getPlainAddress(chainAccountState?.caipAddress),
        isConnected: Boolean(chainAccountState?.caipAddress),
        status: chainAccountState?.status,
        embeddedWalletInfo: authConnector && activeConnectorId === (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH ? {
            user: chainAccountState?.user ? {
                ...chainAccountState.user,
                /*
                         * Getting the username from the chain controller works well for social logins,
                         * but Farcaster uses a different connection flow and doesn’t emit the username via events.
                         * Since the username is stored in local storage before the chain controller updates,
                         * it’s safe to use the local storage value here.
                         */ username: (0, $bc5dy.StorageUtil).getConnectedSocialUsername()
            } : undefined,
            authProvider: chainAccountState?.socialProvider || "email",
            accountType: chainAccountState?.preferredAccountTypes?.[chainNamespace],
            isSmartAccountDeployed: Boolean(chainAccountState?.smartAccountDeployed)
        } : undefined
    };
}
function $2b5a8e9ff96f5bfb$export$83bebf2fe7fead4e() {
    async function disconnect(props) {
        await (0, $efZLi.ConnectionController).disconnect(props?.namespace);
    }
    return {
        disconnect: disconnect
    };
}


/* eslint-disable max-depth */ 
var $b3v9s = parcelRequire("b3v9s");
var $2Z0OY = parcelRequire("2Z0OY");

var $kfwQH = parcelRequire("kfwQH");
var $5PQZs = parcelRequire("5PQZs");
var $g9yWp = parcelRequire("g9yWp");
var $gD0RX = parcelRequire("gD0RX");
var $efZLi = parcelRequire("efZLi");
var $58cAm = parcelRequire("58cAm");
var $3h0dG = parcelRequire("3h0dG");
var $lpmCO = parcelRequire("lpmCO");
var $5FNhR = parcelRequire("5FNhR");
var $knC5d = parcelRequire("knC5d");
var $1dM5v = parcelRequire("1dM5v");
var $bc5dy = parcelRequire("bc5dy");
var $1VSgi = parcelRequire("1VSgi");

var $5SSdQ = parcelRequire("5SSdQ");
var $6rTj5 = parcelRequire("6rTj5");
var $ePwaB = parcelRequire("ePwaB");
var $bCoR3 = parcelRequire("bCoR3");

var $5nPZz = parcelRequire("5nPZz");

var $034Ac = parcelRequire("034Ac");

var $7vbDh = parcelRequire("7vbDh");
class $52cf67d5bf1c16df$export$a0344615582d8da3 {
    // eslint-disable-next-line @typescript-eslint/no-empty-function -- This is a singleton
    constructor(){}
    static getInstance({ projectId: projectId, chainId: chainId, enableLogger: enableLogger, onTimeout: onTimeout, abortController: abortController }) {
        if (!$52cf67d5bf1c16df$export$a0344615582d8da3.instance) $52cf67d5bf1c16df$export$a0344615582d8da3.instance = new (0, $7vbDh.W3mFrameProvider)({
            projectId: projectId,
            chainId: chainId,
            enableLogger: enableLogger,
            onTimeout: onTimeout,
            abortController: abortController
        });
        return $52cf67d5bf1c16df$export$a0344615582d8da3.instance;
    }
}



var $5ID99 = parcelRequire("5ID99");

var $b3v9s = parcelRequire("b3v9s");
var $dawjb = parcelRequire("dawjb");
var $6WAiR = parcelRequire("6WAiR");

var $kfwQH = parcelRequire("kfwQH");
var $5PQZs = parcelRequire("5PQZs");
var $g9yWp = parcelRequire("g9yWp");
var $9PqFe = parcelRequire("9PqFe");
var $hvrT6 = parcelRequire("hvrT6");
var $gD0RX = parcelRequire("gD0RX");
var $efZLi = parcelRequire("efZLi");
var $58cAm = parcelRequire("58cAm");
var $3h0dG = parcelRequire("3h0dG");
var $lpmCO = parcelRequire("lpmCO");
var $lIOIM = parcelRequire("lIOIM");
var $5FNhR = parcelRequire("5FNhR");
var $6aBkR = parcelRequire("6aBkR");
var $jHvAI = parcelRequire("jHvAI");
var $knC5d = parcelRequire("knC5d");
var $1dM5v = parcelRequire("1dM5v");
var $aZ8hw = parcelRequire("aZ8hw");
var $4hCRh = parcelRequire("4hCRh");
var $bc5dy = parcelRequire("bc5dy");
var $1VSgi = parcelRequire("1VSgi");
parcelRequire("kHrzX");
parcelRequire("6weBs");
parcelRequire("lDgVc");


var $lDgVc = parcelRequire("lDgVc");
parcelRequire("giNUc");
var $gqttf = parcelRequire("gqttf");

var $hOdyB = parcelRequire("hOdyB");

var $16W4z = parcelRequire("16W4z");
async function $1feed7ec9525f20d$export$5c069c93d2b7493f(time) {
    return new Promise((res)=>setTimeout(res, time));
}



var $3cVvs = parcelRequire("3cVvs");

var $kbqwz = parcelRequire("kbqwz");

var $16W4z = parcelRequire("16W4z");

var $nDot9 = parcelRequire("nDot9");

var $2MUIq = parcelRequire("2MUIq");
const $b4bafd682c0b108c$export$e89e805418f4d2c = /*#__PURE__*/ new (0, $2MUIq.LruMap)(8192);
function $b4bafd682c0b108c$export$387c3b0c09132fc3(fn, { enabled: enabled = true, id: id }) {
    if (!enabled || !id) return fn();
    if ($b4bafd682c0b108c$export$e89e805418f4d2c.get(id)) return $b4bafd682c0b108c$export$e89e805418f4d2c.get(id);
    const promise = fn().finally(()=>$b4bafd682c0b108c$export$e89e805418f4d2c.delete(id));
    $b4bafd682c0b108c$export$e89e805418f4d2c.set(id, promise);
    return promise;
}



function $4aecf79c34be183e$export$188df5ecf8e7961a(fn, { delay: delay_ = 100, retryCount: retryCount = 2, shouldRetry: shouldRetry = ()=>true } = {}) {
    return new Promise((resolve, reject)=>{
        const attemptRetry = async ({ count: count = 0 } = {})=>{
            const retry = async ({ error: error })=>{
                const delay = typeof delay_ === "function" ? delay_({
                    count: count,
                    error: error
                }) : delay_;
                if (delay) await (0, $1feed7ec9525f20d$export$5c069c93d2b7493f)(delay);
                attemptRetry({
                    count: count + 1
                });
            };
            try {
                const data = await fn();
                resolve(data);
            } catch (err) {
                if (count < retryCount && await shouldRetry({
                    count: count,
                    error: err
                })) return retry({
                    error: err
                });
                reject(err);
            }
        };
        attemptRetry();
    });
}



var $c0R7l = parcelRequire("c0R7l");
function $b2a50bb287c573b7$export$6c5295ef7e82f2b2(request, options = {}) {
    return async (args, overrideOptions = {})=>{
        const { dedupe: dedupe = false, methods: methods, retryDelay: retryDelay = 150, retryCount: retryCount = 3, uid: uid } = {
            ...options,
            ...overrideOptions
        };
        const { method: method } = args;
        if (methods?.exclude?.includes(method)) throw new (0, $16W4z.MethodNotSupportedRpcError)(new Error("method not supported"), {
            method: method
        });
        if (methods?.include && !methods.include.includes(method)) throw new (0, $16W4z.MethodNotSupportedRpcError)(new Error("method not supported"), {
            method: method
        });
        const requestId = dedupe ? (0, $nDot9.stringToHex)(`${uid}.${(0, $c0R7l.stringify)(args)}`) : undefined;
        return (0, $b4bafd682c0b108c$export$387c3b0c09132fc3)(()=>(0, $4aecf79c34be183e$export$188df5ecf8e7961a)(async ()=>{
                try {
                    return await request(args);
                } catch (err_) {
                    const err = err_;
                    switch(err.code){
                        // -32700
                        case (0, $16W4z.ParseRpcError).code:
                            throw new (0, $16W4z.ParseRpcError)(err);
                        // -32600
                        case (0, $16W4z.InvalidRequestRpcError).code:
                            throw new (0, $16W4z.InvalidRequestRpcError)(err);
                        // -32601
                        case (0, $16W4z.MethodNotFoundRpcError).code:
                            throw new (0, $16W4z.MethodNotFoundRpcError)(err, {
                                method: args.method
                            });
                        // -32602
                        case (0, $16W4z.InvalidParamsRpcError).code:
                            throw new (0, $16W4z.InvalidParamsRpcError)(err);
                        // -32603
                        case (0, $16W4z.InternalRpcError).code:
                            throw new (0, $16W4z.InternalRpcError)(err);
                        // -32000
                        case (0, $16W4z.InvalidInputRpcError).code:
                            throw new (0, $16W4z.InvalidInputRpcError)(err);
                        // -32001
                        case (0, $16W4z.ResourceNotFoundRpcError).code:
                            throw new (0, $16W4z.ResourceNotFoundRpcError)(err);
                        // -32002
                        case (0, $16W4z.ResourceUnavailableRpcError).code:
                            throw new (0, $16W4z.ResourceUnavailableRpcError)(err);
                        // -32003
                        case (0, $16W4z.TransactionRejectedRpcError).code:
                            throw new (0, $16W4z.TransactionRejectedRpcError)(err);
                        // -32004
                        case (0, $16W4z.MethodNotSupportedRpcError).code:
                            throw new (0, $16W4z.MethodNotSupportedRpcError)(err, {
                                method: args.method
                            });
                        // -32005
                        case (0, $16W4z.LimitExceededRpcError).code:
                            throw new (0, $16W4z.LimitExceededRpcError)(err);
                        // -32006
                        case (0, $16W4z.JsonRpcVersionUnsupportedError).code:
                            throw new (0, $16W4z.JsonRpcVersionUnsupportedError)(err);
                        // 4001
                        case (0, $16W4z.UserRejectedRequestError).code:
                            throw new (0, $16W4z.UserRejectedRequestError)(err);
                        // 4100
                        case (0, $16W4z.UnauthorizedProviderError).code:
                            throw new (0, $16W4z.UnauthorizedProviderError)(err);
                        // 4200
                        case (0, $16W4z.UnsupportedProviderMethodError).code:
                            throw new (0, $16W4z.UnsupportedProviderMethodError)(err);
                        // 4900
                        case (0, $16W4z.ProviderDisconnectedError).code:
                            throw new (0, $16W4z.ProviderDisconnectedError)(err);
                        // 4901
                        case (0, $16W4z.ChainDisconnectedError).code:
                            throw new (0, $16W4z.ChainDisconnectedError)(err);
                        // 4902
                        case (0, $16W4z.SwitchChainError).code:
                            throw new (0, $16W4z.SwitchChainError)(err);
                        // 5700
                        case (0, $16W4z.UnsupportedNonOptionalCapabilityError).code:
                            throw new (0, $16W4z.UnsupportedNonOptionalCapabilityError)(err);
                        // 5710
                        case (0, $16W4z.UnsupportedChainIdError).code:
                            throw new (0, $16W4z.UnsupportedChainIdError)(err);
                        // 5720
                        case (0, $16W4z.DuplicateIdError).code:
                            throw new (0, $16W4z.DuplicateIdError)(err);
                        // 5730
                        case (0, $16W4z.UnknownBundleIdError).code:
                            throw new (0, $16W4z.UnknownBundleIdError)(err);
                        // 5740
                        case (0, $16W4z.BundleTooLargeError).code:
                            throw new (0, $16W4z.BundleTooLargeError)(err);
                        // 5750
                        case (0, $16W4z.AtomicReadyWalletRejectedUpgradeError).code:
                            throw new (0, $16W4z.AtomicReadyWalletRejectedUpgradeError)(err);
                        // 5760
                        case (0, $16W4z.AtomicityNotSupportedError).code:
                            throw new (0, $16W4z.AtomicityNotSupportedError)(err);
                        // CAIP-25: User Rejected Error
                        // https://docs.walletconnect.com/2.0/specs/clients/sign/error-codes#rejected-caip-25
                        case 5000:
                            throw new (0, $16W4z.UserRejectedRequestError)(err);
                        default:
                            if (err_ instanceof (0, $3cVvs.BaseError)) throw err_;
                            throw new (0, $16W4z.UnknownRpcError)(err);
                    }
                }
            }, {
                delay: ({ count: count, error: error })=>{
                    // If we find a Retry-After header, let's retry after the given time.
                    if (error && error instanceof (0, $kbqwz.HttpRequestError)) {
                        const retryAfter = error?.headers?.get("Retry-After");
                        if (retryAfter?.match(/\d/)) return Number.parseInt(retryAfter) * 1000;
                    }
                    // Otherwise, let's retry with an exponential backoff.
                    return ~~(1 << count) * retryDelay;
                },
                retryCount: retryCount,
                shouldRetry: ({ error: error })=>$b2a50bb287c573b7$export$7bfea3c3d460ecd8(error)
            }), {
            enabled: dedupe,
            id: requestId
        });
    };
}
function $b2a50bb287c573b7$export$7bfea3c3d460ecd8(error) {
    if ("code" in error && typeof error.code === "number") {
        if (error.code === -1) return true; // Unknown error
        if (error.code === (0, $16W4z.LimitExceededRpcError).code) return true;
        if (error.code === (0, $16W4z.InternalRpcError).code) return true;
        return false;
    }
    if (error instanceof (0, $kbqwz.HttpRequestError) && error.status) {
        // Forbidden
        if (error.status === 403) return true;
        // Request Timeout
        if (error.status === 408) return true;
        // Request Entity Too Large
        if (error.status === 413) return true;
        // Too Many Requests
        if (error.status === 429) return true;
        // Internal Server Error
        if (error.status === 500) return true;
        // Bad Gateway
        if (error.status === 502) return true;
        // Service Unavailable
        if (error.status === 503) return true;
        // Gateway Timeout
        if (error.status === 504) return true;
        return false;
    }
    return true;
}


const $93931935b93b2e48$var$size = 256;
let $93931935b93b2e48$var$index = $93931935b93b2e48$var$size;
let $93931935b93b2e48$var$buffer;
function $93931935b93b2e48$export$e2a22331486dcca0(length = 11) {
    if (!$93931935b93b2e48$var$buffer || $93931935b93b2e48$var$index + length > $93931935b93b2e48$var$size * 2) {
        $93931935b93b2e48$var$buffer = "";
        $93931935b93b2e48$var$index = 0;
        for(let i = 0; i < $93931935b93b2e48$var$size; i++)$93931935b93b2e48$var$buffer += (256 + Math.random() * 256 | 0).toString(16).substring(1);
    }
    return $93931935b93b2e48$var$buffer.substring($93931935b93b2e48$var$index, $93931935b93b2e48$var$index++ + length);
}


function $4275087a240c0d34$export$d09f50d9ab7f7b69({ key: key, methods: methods, name: name, request: request, retryCount: retryCount = 3, retryDelay: retryDelay = 150, timeout: timeout, type: type }, value) {
    const uid = (0, $93931935b93b2e48$export$e2a22331486dcca0)();
    return {
        config: {
            key: key,
            methods: methods,
            name: name,
            request: request,
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: type
        },
        request: (0, $b2a50bb287c573b7$export$6c5295ef7e82f2b2)(request, {
            methods: methods,
            retryCount: retryCount,
            retryDelay: retryDelay,
            uid: uid
        }),
        value: value
    };
}


function $c29d18ef638d3bea$export$bcd1dd1f397bba12(transports_, config = {}) {
    const { key: key = "fallback", name: name = "Fallback", rank: rank = false, shouldThrow: shouldThrow_ = $c29d18ef638d3bea$export$3b83cb0542ac35f7, retryCount: retryCount, retryDelay: retryDelay } = config;
    return ({ chain: chain, pollingInterval: pollingInterval = 4000, timeout: timeout, ...rest })=>{
        let transports = transports_;
        let onResponse = ()=>{};
        const transport = (0, $4275087a240c0d34$export$d09f50d9ab7f7b69)({
            key: key,
            name: name,
            async request ({ method: method, params: params }) {
                let includes;
                const fetch = async (i = 0)=>{
                    const transport = transports[i]({
                        ...rest,
                        chain: chain,
                        retryCount: 0,
                        timeout: timeout
                    });
                    try {
                        const response = await transport.request({
                            method: method,
                            params: params
                        });
                        onResponse({
                            method: method,
                            params: params,
                            response: response,
                            transport: transport,
                            status: "success"
                        });
                        return response;
                    } catch (err) {
                        onResponse({
                            error: err,
                            method: method,
                            params: params,
                            transport: transport,
                            status: "error"
                        });
                        if (shouldThrow_(err)) throw err;
                        // If we've reached the end of the fallbacks, throw the error.
                        if (i === transports.length - 1) throw err;
                        // Check if at least one other transport includes the method
                        includes ??= transports.slice(i + 1).some((transport)=>{
                            const { include: include, exclude: exclude } = transport({
                                chain: chain
                            }).config.methods || {};
                            if (include) return include.includes(method);
                            if (exclude) return !exclude.includes(method);
                            return true;
                        });
                        if (!includes) throw err;
                        // Otherwise, try the next fallback.
                        return fetch(i + 1);
                    }
                };
                return fetch();
            },
            retryCount: retryCount,
            retryDelay: retryDelay,
            type: "fallback"
        }, {
            onResponse: (fn)=>onResponse = fn,
            transports: transports.map((fn)=>fn({
                    chain: chain,
                    retryCount: 0
                }))
        });
        if (rank) {
            const rankOptions = typeof rank === "object" ? rank : {};
            $c29d18ef638d3bea$export$f2bce5ae3fda4e76({
                chain: chain,
                interval: rankOptions.interval ?? pollingInterval,
                onTransports: (transports_)=>transports = transports_,
                ping: rankOptions.ping,
                sampleCount: rankOptions.sampleCount,
                timeout: rankOptions.timeout,
                transports: transports,
                weights: rankOptions.weights
            });
        }
        return transport;
    };
}
function $c29d18ef638d3bea$export$3b83cb0542ac35f7(error) {
    if ("code" in error && typeof error.code === "number") {
        if (error.code === (0, $16W4z.TransactionRejectedRpcError).code || error.code === (0, $16W4z.UserRejectedRequestError).code || (0, $hOdyB.ExecutionRevertedError).nodeMessage.test(error.message) || error.code === 5000 // CAIP UserRejectedRequestError
        ) return true;
    }
    return false;
}
function $c29d18ef638d3bea$export$f2bce5ae3fda4e76({ chain: chain, interval: interval = 4000, onTransports: onTransports, ping: ping, sampleCount: sampleCount = 10, timeout: timeout = 1000, transports: transports, weights: weights = {} }) {
    const { stability: stabilityWeight = 0.7, latency: latencyWeight = 0.3 } = weights;
    const samples = [];
    const rankTransports_ = async ()=>{
        // 1. Take a sample from each Transport.
        const sample = await Promise.all(transports.map(async (transport)=>{
            const transport_ = transport({
                chain: chain,
                retryCount: 0,
                timeout: timeout
            });
            const start = Date.now();
            let end;
            let success;
            try {
                await (ping ? ping({
                    transport: transport_
                }) : transport_.request({
                    method: "net_listening"
                }));
                success = 1;
            } catch  {
                success = 0;
            } finally{
                end = Date.now();
            }
            const latency = end - start;
            return {
                latency: latency,
                success: success
            };
        }));
        // 2. Store the sample. If we have more than `sampleCount` samples, remove
        // the oldest sample.
        samples.push(sample);
        if (samples.length > sampleCount) samples.shift();
        // 3. Calculate the max latency from samples.
        const maxLatency = Math.max(...samples.map((sample)=>Math.max(...sample.map(({ latency: latency })=>latency))));
        // 4. Calculate the score for each Transport.
        const scores = transports.map((_, i)=>{
            const latencies = samples.map((sample)=>sample[i].latency);
            const meanLatency = latencies.reduce((acc, latency)=>acc + latency, 0) / latencies.length;
            const latencyScore = 1 - meanLatency / maxLatency;
            const successes = samples.map((sample)=>sample[i].success);
            const stabilityScore = successes.reduce((acc, success)=>acc + success, 0) / successes.length;
            if (stabilityScore === 0) return [
                0,
                i
            ];
            return [
                latencyWeight * latencyScore + stabilityWeight * stabilityScore,
                i
            ];
        }).sort((a, b)=>b[0] - a[0]);
        // 5. Sort the Transports by score.
        onTransports(scores.map(([, i])=>transports[i]));
        // 6. Wait, and then rank again.
        await (0, $1feed7ec9525f20d$export$5c069c93d2b7493f)(interval);
        rankTransports_();
    };
    rankTransports_();
}


var $kbqwz = parcelRequire("kbqwz");

var $3cVvs = parcelRequire("3cVvs");
class $f5231d7ebe38f74a$export$d0a48bf953f3c239 extends (0, $3cVvs.BaseError) {
    constructor(){
        super("No URL was provided to the Transport. Please provide a valid RPC URL to the Transport.", {
            docsPath: "/docs/clients/intro",
            name: "UrlRequiredError"
        });
    }
}



var $5UW0B = parcelRequire("5UW0B");

var $kbqwz = parcelRequire("kbqwz");
function $9ca27c1b24cc14cb$export$e86e19342bc4850e(fn, { errorInstance: errorInstance = new Error("timed out"), timeout: timeout, signal: signal }) {
    return new Promise((resolve, reject)=>{
        (async ()=>{
            let timeoutId;
            try {
                const controller = new AbortController();
                if (timeout > 0) timeoutId = setTimeout(()=>{
                    if (signal) controller.abort();
                    else reject(errorInstance);
                }, timeout); // need to cast because bun globals.d.ts overrides @types/node
                resolve(await fn({
                    signal: controller?.signal || null
                }));
            } catch (err) {
                if (err?.name === "AbortError") reject(errorInstance);
                reject(err);
            } finally{
                clearTimeout(timeoutId);
            }
        })();
    });
}



var $c0R7l = parcelRequire("c0R7l");
function $676c04ada2c73138$var$createIdStore() {
    return {
        current: 0,
        take () {
            return this.current++;
        },
        reset () {
            this.current = 0;
        }
    };
}
const $676c04ada2c73138$export$94f79fd1fae0679e = /*#__PURE__*/ $676c04ada2c73138$var$createIdStore();


function $97cb1aae82109390$export$290dc69d3612792(url, options = {}) {
    return {
        async request (params) {
            const { body: body, onRequest: onRequest = options.onRequest, onResponse: onResponse = options.onResponse, timeout: timeout = options.timeout ?? 10000 } = params;
            const fetchOptions = {
                ...options.fetchOptions ?? {},
                ...params.fetchOptions ?? {}
            };
            const { headers: headers, method: method, signal: signal_ } = fetchOptions;
            try {
                const response = await (0, $9ca27c1b24cc14cb$export$e86e19342bc4850e)(async ({ signal: signal })=>{
                    const init = {
                        ...fetchOptions,
                        body: Array.isArray(body) ? (0, $c0R7l.stringify)(body.map((body)=>({
                                jsonrpc: "2.0",
                                id: body.id ?? (0, $676c04ada2c73138$export$94f79fd1fae0679e).take(),
                                ...body
                            }))) : (0, $c0R7l.stringify)({
                            jsonrpc: "2.0",
                            id: body.id ?? (0, $676c04ada2c73138$export$94f79fd1fae0679e).take(),
                            ...body
                        }),
                        headers: {
                            "Content-Type": "application/json",
                            ...headers
                        },
                        method: method || "POST",
                        signal: signal_ || (timeout > 0 ? signal : null)
                    };
                    const request = new Request(url, init);
                    const args = await onRequest?.(request, init) ?? {
                        ...init,
                        url: url
                    };
                    const response = await fetch(args.url ?? url, args);
                    return response;
                }, {
                    errorInstance: new (0, $kbqwz.TimeoutError)({
                        body: body,
                        url: url
                    }),
                    timeout: timeout,
                    signal: true
                });
                if (onResponse) await onResponse(response);
                let data;
                if (response.headers.get("Content-Type")?.startsWith("application/json")) data = await response.json();
                else {
                    data = await response.text();
                    try {
                        data = JSON.parse(data || "{}");
                    } catch (err) {
                        if (response.ok) throw err;
                        data = {
                            error: data
                        };
                    }
                }
                if (!response.ok) throw new (0, $kbqwz.HttpRequestError)({
                    body: body,
                    details: (0, $c0R7l.stringify)(data.error) || response.statusText,
                    headers: response.headers,
                    status: response.status,
                    url: url
                });
                return data;
            } catch (err) {
                if (err instanceof (0, $kbqwz.HttpRequestError)) throw err;
                if (err instanceof (0, $kbqwz.TimeoutError)) throw err;
                throw new (0, $kbqwz.HttpRequestError)({
                    body: body,
                    cause: err,
                    url: url
                });
            }
        }
    };
}



function $ef4c066ea4eb5138$export$7d6f1c8842f9f527(/** URL of the JSON-RPC API. Defaults to the chain's public RPC URL. */ url, config = {}) {
    const { batch: batch, fetchOptions: fetchOptions, key: key = "http", methods: methods, name: name = "HTTP JSON-RPC", onFetchRequest: onFetchRequest, onFetchResponse: onFetchResponse, retryDelay: retryDelay, raw: raw } = config;
    return ({ chain: chain, retryCount: retryCount_, timeout: timeout_ })=>{
        const { batchSize: batchSize = 1000, wait: wait = 0 } = typeof batch === "object" ? batch : {};
        const retryCount = config.retryCount ?? retryCount_;
        const timeout = timeout_ ?? config.timeout ?? 10000;
        const url_ = url || chain?.rpcUrls.default.http[0];
        if (!url_) throw new (0, $f5231d7ebe38f74a$export$d0a48bf953f3c239)();
        const rpcClient = (0, $97cb1aae82109390$export$290dc69d3612792)(url_, {
            fetchOptions: fetchOptions,
            onRequest: onFetchRequest,
            onResponse: onFetchResponse,
            timeout: timeout
        });
        return (0, $4275087a240c0d34$export$d09f50d9ab7f7b69)({
            key: key,
            methods: methods,
            name: name,
            async request ({ method: method, params: params }) {
                const body = {
                    method: method,
                    params: params
                };
                const { schedule: schedule } = (0, $5UW0B.createBatchScheduler)({
                    id: url_,
                    wait: wait,
                    shouldSplitBatch (requests) {
                        return requests.length > batchSize;
                    },
                    fn: (body)=>rpcClient.request({
                            body: body
                        }),
                    sort: (a, b)=>a.id - b.id
                });
                const fn = async (body)=>batch ? schedule(body) : [
                        await rpcClient.request({
                            body: body
                        })
                    ];
                const [{ error: error, result: result }] = await fn(body);
                if (raw) return {
                    error: error,
                    result: result
                };
                if (error) throw new (0, $kbqwz.RpcRequestError)({
                    body: body,
                    error: error,
                    url: url_
                });
                return result;
            },
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: "http"
        }, {
            fetchOptions: fetchOptions,
            url: url_
        });
    };
}



var $b3v9s = parcelRequire("b3v9s");

var $gD0RX = parcelRequire("gD0RX");
var $bc5dy = parcelRequire("bc5dy");

var $b3v9s = parcelRequire("b3v9s");

var $5SSdQ = parcelRequire("5SSdQ");
const $8a4fed4bf263e097$export$fd35d6514357600 = {
    ConnectorExplorerIds: {
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.COINBASE]: "fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa",
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.COINBASE_SDK]: "fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa",
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.SAFE]: "225affb176778569276e484e1b92637ad061b01e13a048b35a9d280c3b58970f",
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.LEDGER]: "19177a98252e07ddfc9af2083ba8e07ef627cb6103467ffebb3f8f4205fd7927",
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.OKX]: "971e689d0a5be527bac79629b4ee9b925e82208e5168b733496a09c0faed0709",
        [(0, $5SSdQ.ConstantsUtil).METMASK_CONNECTOR_NAME]: "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96",
        [(0, $5SSdQ.ConstantsUtil).TRUST_CONNECTOR_NAME]: "4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0",
        [(0, $5SSdQ.ConstantsUtil).SOLFLARE_CONNECTOR_NAME]: "1ca0bdd4747578705b1939af023d120677c64fe6ca76add81fda36e350605e79",
        [(0, $5SSdQ.ConstantsUtil).PHANTOM_CONNECTOR_NAME]: "a797aa35c0fadbfc1a53e7f675162ed5226968b44a19ee3d24385c64d1d3c393",
        [(0, $5SSdQ.ConstantsUtil).COIN98_CONNECTOR_NAME]: "2a3c89040ac3b723a1972a33a125b1db11e258a6975d3a61252cd64e6ea5ea01",
        [(0, $5SSdQ.ConstantsUtil).MAGIC_EDEN_CONNECTOR_NAME]: "8b830a2b724a9c3fbab63af6f55ed29c9dfa8a55e732dc88c80a196a2ba136c6",
        [(0, $5SSdQ.ConstantsUtil).BACKPACK_CONNECTOR_NAME]: "2bd8c14e035c2d48f184aaa168559e86b0e3433228d3c4075900a221785019b0",
        [(0, $5SSdQ.ConstantsUtil).BITGET_CONNECTOR_NAME]: "38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662",
        [(0, $5SSdQ.ConstantsUtil).FRONTIER_CONNECTOR_NAME]: "85db431492aa2e8672e93f4ea7acf10c88b97b867b0d373107af63dc4880f041",
        [(0, $5SSdQ.ConstantsUtil).XVERSE_CONNECTOR_NAME]: "2a87d74ae02e10bdd1f51f7ce6c4e1cc53cd5f2c0b6b5ad0d7b3007d2b13de7b",
        [(0, $5SSdQ.ConstantsUtil).LEATHER_CONNECTOR_NAME]: "483afe1df1df63daf313109971ff3ef8356ddf1cc4e45877d205eee0b7893a13"
    },
    NetworkImageIds: {
        1: "ba0ba0cd-17c6-4806-ad93-f9d174f17900",
        42161: "3bff954d-5cb0-47a0-9a23-d20192e74600",
        43114: "30c46e53-e989-45fb-4549-be3bd4eb3b00",
        56: "93564157-2e8e-4ce7-81df-b264dbee9b00",
        250: "06b26297-fe0c-4733-5d6b-ffa5498aac00",
        10: "ab9c186a-c52f-464b-2906-ca59d760a400",
        137: "41d04d42-da3b-4453-8506-668cc0727900",
        5000: "e86fae9b-b770-4eea-e520-150e12c81100",
        295: "6a97d510-cac8-4e58-c7ce-e8681b044c00",
        11155111: "e909ea0a-f92a-4512-c8fc-748044ea6800",
        84532: "a18a7ecd-e307-4360-4746-283182228e00",
        1301: "4eeea7ef-0014-4649-5d1d-07271a80f600",
        130: "2257980a-3463-48c6-cbac-a42d2a956e00",
        10143: "0a728e83-bacb-46db-7844-948f05434900",
        100: "02b53f6a-e3d4-479e-1cb4-21178987d100",
        9001: "f926ff41-260d-4028-635e-91913fc28e00",
        324: "b310f07f-4ef7-49f3-7073-2a0a39685800",
        314: "5a73b3dd-af74-424e-cae0-0de859ee9400",
        4689: "34e68754-e536-40da-c153-6ef2e7188a00",
        1088: "3897a66d-40b9-4833-162f-a2c90531c900",
        1284: "161038da-44ae-4ec7-1208-0ea569454b00",
        1285: "f1d73bb6-5450-4e18-38f7-fb6484264a00",
        7777777: "845c60df-d429-4991-e687-91ae45791600",
        42220: "ab781bbc-ccc6-418d-d32d-789b15da1f00",
        8453: "7289c336-3981-4081-c5f4-efc26ac64a00",
        1313161554: "3ff73439-a619-4894-9262-4470c773a100",
        2020: "b8101fc0-9c19-4b6f-ec65-f6dfff106e00",
        2021: "b8101fc0-9c19-4b6f-ec65-f6dfff106e00",
        80094: "e329c2c9-59b0-4a02-83e4-212ff3779900",
        2741: "fc2427d1-5af9-4a9c-8da5-6f94627cd900",
        "5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp": "a1b58899-f671-4276-6a5e-56ca5bd59700",
        "4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z": "a1b58899-f671-4276-6a5e-56ca5bd59700",
        EtWTRABZaYq6iMfeYKouRu166VU2xqa1: "a1b58899-f671-4276-6a5e-56ca5bd59700",
        "000000000019d6689c085ae165831e93": "0b4838db-0161-4ffe-022d-532bf03dba00",
        "000000000933ea01ad0ee984209779ba": "39354064-d79b-420b-065d-f980c4b78200"
    },
    ConnectorImageIds: {
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.COINBASE]: "0c2840c3-5b04-4c44-9661-fbd4b49e1800",
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.COINBASE_SDK]: "0c2840c3-5b04-4c44-9661-fbd4b49e1800",
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.SAFE]: "461db637-8616-43ce-035a-d89b8a1d5800",
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.LEDGER]: "54a1aa77-d202-4f8d-0fb2-5d2bb6db0300",
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.WALLET_CONNECT]: "ef1a1fcf-7fe8-4d69-bd6d-fda1345b4400",
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.INJECTED]: "07ba87ed-43aa-4adf-4540-9e6a2b9cae00"
    },
    ConnectorNamesMap: {
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.INJECTED]: "Browser Wallet",
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.WALLET_CONNECT]: "WalletConnect",
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.COINBASE]: "Coinbase",
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.COINBASE_SDK]: "Coinbase",
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.LEDGER]: "Ledger",
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.SAFE]: "Safe"
    },
    ConnectorTypesMap: {
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.INJECTED]: "INJECTED",
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.WALLET_CONNECT]: "WALLET_CONNECT",
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.EIP6963]: "ANNOUNCED",
        [(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH]: "AUTH"
    },
    WalletConnectRpcChainIds: [
        1,
        5,
        11155111,
        10,
        420,
        42161,
        421613,
        137,
        80001,
        42220,
        1313161554,
        1313161555,
        56,
        97,
        43114,
        43113,
        100,
        8453,
        84531,
        7777777,
        999,
        324,
        280
    ]
};


const $3a7f156758201cdc$var$RPC_URL_HOST = "rpc.walletconnect.org";
function $3a7f156758201cdc$export$a52cb070e3651fb9(caipNetworkId, projectId) {
    const url = new URL("https://rpc.walletconnect.org/v1/");
    url.searchParams.set("chainId", caipNetworkId);
    url.searchParams.set("projectId", projectId);
    return url.toString();
}
const $3a7f156758201cdc$var$WC_HTTP_RPC_SUPPORTED_CHAINS = [
    "near:mainnet",
    "solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp",
    "eip155:1101",
    "eip155:56",
    "eip155:42161",
    "eip155:7777777",
    "eip155:59144",
    "eip155:324",
    "solana:EtWTRABZaYq6iMfeYKouRu166VU2xqa1",
    "eip155:5000",
    "solana:4sgjmw1sunhzsxgspuhpqldx6wiyjntz",
    "eip155:80084",
    "eip155:5003",
    "eip155:100",
    "eip155:8453",
    "eip155:42220",
    "eip155:1313161555",
    "eip155:17000",
    "eip155:1",
    "eip155:300",
    "eip155:1313161554",
    "eip155:1329",
    "eip155:84532",
    "eip155:421614",
    "eip155:11155111",
    "eip155:8217",
    "eip155:43114",
    "solana:4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z",
    "eip155:999999999",
    "eip155:11155420",
    "eip155:80002",
    "eip155:97",
    "eip155:43113",
    "eip155:137",
    "eip155:10",
    "eip155:1301",
    "bip122:000000000019d6689c085ae165831e93",
    "bip122:000000000933ea01ad0ee984209779ba"
];
const $3a7f156758201cdc$export$c2b0ef8ebe2589ea = {
    extendRpcUrlWithProjectId (rpcUrl, projectId) {
        let isReownUrl = false;
        try {
            const url = new URL(rpcUrl);
            isReownUrl = url.host === $3a7f156758201cdc$var$RPC_URL_HOST;
        } catch (e) {
            isReownUrl = false;
        }
        if (isReownUrl) {
            const url = new URL(rpcUrl);
            if (!url.searchParams.has("projectId")) url.searchParams.set("projectId", projectId);
            return url.toString();
        }
        return rpcUrl;
    },
    isCaipNetwork (network) {
        return "chainNamespace" in network && "caipNetworkId" in network;
    },
    getChainNamespace (network) {
        if (this.isCaipNetwork(network)) return network.chainNamespace;
        return (0, $b3v9s.ConstantsUtil).CHAIN.EVM;
    },
    getCaipNetworkId (network) {
        if (this.isCaipNetwork(network)) return network.caipNetworkId;
        return `${(0, $b3v9s.ConstantsUtil).CHAIN.EVM}:${network.id}`;
    },
    getDefaultRpcUrl (caipNetwork, caipNetworkId, projectId) {
        const defaultRpcUrl = caipNetwork.rpcUrls?.default?.http?.[0];
        if ($3a7f156758201cdc$var$WC_HTTP_RPC_SUPPORTED_CHAINS.includes(caipNetworkId)) return $3a7f156758201cdc$export$a52cb070e3651fb9(caipNetworkId, projectId);
        return defaultRpcUrl || "";
    },
    extendCaipNetwork (caipNetwork, { customNetworkImageUrls: customNetworkImageUrls, projectId: projectId, customRpcUrls: customRpcUrls }) {
        const chainNamespace = this.getChainNamespace(caipNetwork);
        const caipNetworkId = this.getCaipNetworkId(caipNetwork);
        const networkDefaultRpcUrl = caipNetwork.rpcUrls.default.http?.[0];
        const reownRpcUrl = this.getDefaultRpcUrl(caipNetwork, caipNetworkId, projectId);
        const chainDefaultRpcUrl = caipNetwork?.rpcUrls?.["chainDefault"]?.http?.[0] || networkDefaultRpcUrl;
        const customRpcUrlsOfNetwork = customRpcUrls?.[caipNetworkId]?.map((i)=>i.url) || [];
        const rpcUrls = [
            ...customRpcUrlsOfNetwork,
            reownRpcUrl
        ];
        const rpcUrlsWithoutReown = [
            ...customRpcUrlsOfNetwork
        ];
        if (chainDefaultRpcUrl && !rpcUrlsWithoutReown.includes(chainDefaultRpcUrl)) rpcUrlsWithoutReown.push(chainDefaultRpcUrl);
        return {
            ...caipNetwork,
            chainNamespace: chainNamespace,
            caipNetworkId: caipNetworkId,
            assets: {
                imageId: (0, $8a4fed4bf263e097$export$fd35d6514357600).NetworkImageIds[caipNetwork.id],
                imageUrl: customNetworkImageUrls?.[caipNetwork.id]
            },
            rpcUrls: {
                ...caipNetwork.rpcUrls,
                default: {
                    http: rpcUrls
                },
                chainDefault: {
                    http: rpcUrlsWithoutReown
                }
            }
        };
    },
    extendCaipNetworks (caipNetworks, { customNetworkImageUrls: customNetworkImageUrls, projectId: projectId, customRpcUrls: customRpcUrls }) {
        return caipNetworks.map((caipNetwork)=>$3a7f156758201cdc$export$c2b0ef8ebe2589ea.extendCaipNetwork(caipNetwork, {
                customNetworkImageUrls: customNetworkImageUrls,
                customRpcUrls: customRpcUrls,
                projectId: projectId
            }));
    },
    getViemTransport (caipNetwork, projectId, customRpcUrls) {
        const transports = [];
        customRpcUrls?.forEach((rpcUrl)=>{
            transports.push((0, $ef4c066ea4eb5138$export$7d6f1c8842f9f527)(rpcUrl.url, rpcUrl.config));
        });
        if ($3a7f156758201cdc$var$WC_HTTP_RPC_SUPPORTED_CHAINS.includes(caipNetwork.caipNetworkId)) transports.push((0, $ef4c066ea4eb5138$export$7d6f1c8842f9f527)($3a7f156758201cdc$export$a52cb070e3651fb9(caipNetwork.caipNetworkId, projectId), {
            fetchOptions: {
                headers: {
                    "Content-Type": "text/plain"
                }
            }
        }));
        caipNetwork?.rpcUrls?.default?.http?.forEach((rpcUrl)=>{
            transports.push((0, $ef4c066ea4eb5138$export$7d6f1c8842f9f527)(rpcUrl));
        });
        return (0, $c29d18ef638d3bea$export$bcd1dd1f397bba12)(transports);
    },
    extendWagmiTransports (caipNetwork, projectId, transport) {
        if ($3a7f156758201cdc$var$WC_HTTP_RPC_SUPPORTED_CHAINS.includes(caipNetwork.caipNetworkId)) {
            const reownRpcUrl = this.getDefaultRpcUrl(caipNetwork, caipNetwork.caipNetworkId, projectId);
            return (0, $c29d18ef638d3bea$export$bcd1dd1f397bba12)([
                transport,
                (0, $ef4c066ea4eb5138$export$7d6f1c8842f9f527)(reownRpcUrl)
            ]);
        }
        return transport;
    },
    getUnsupportedNetwork (caipNetworkId) {
        return {
            id: caipNetworkId.split(":")[1],
            caipNetworkId: caipNetworkId,
            name: (0, $b3v9s.ConstantsUtil).UNSUPPORTED_NETWORK_NAME,
            chainNamespace: caipNetworkId.split(":")[0],
            nativeCurrency: {
                name: "",
                decimals: 0,
                symbol: ""
            },
            rpcUrls: {
                default: {
                    http: []
                }
            }
        };
    },
    getCaipNetworkFromStorage (defaultCaipNetwork) {
        const caipNetworkIdFromStorage = (0, $bc5dy.StorageUtil).getActiveCaipNetworkId();
        const caipNetworks = (0, $gD0RX.ChainController).getAllRequestedCaipNetworks();
        const availableNamespaces = Array.from((0, $gD0RX.ChainController).state.chains?.keys() || []);
        const namespace = caipNetworkIdFromStorage?.split(":")[0];
        const isNamespaceAvailable = namespace ? availableNamespaces.includes(namespace) : false;
        const caipNetwork = caipNetworks?.find((cn)=>cn.caipNetworkId === caipNetworkIdFromStorage);
        const isUnsupportedNetwork = isNamespaceAvailable && !caipNetwork && caipNetworkIdFromStorage;
        if (isUnsupportedNetwork) return this.getUnsupportedNetwork(caipNetworkIdFromStorage);
        if (caipNetwork) return caipNetwork;
        if (defaultCaipNetwork) return defaultCaipNetwork;
        return caipNetworks?.[0];
    }
};


var $5SSdQ = parcelRequire("5SSdQ");
var $6rTj5 = parcelRequire("6rTj5");
var $ePwaB = parcelRequire("ePwaB");
var $6GQzw = parcelRequire("6GQzw");
const $877ffcea83859f3f$export$1605cc4fc0ce8504 = {
    createLogger (onError, level = "error") {
        const loggerOptions = (0, $6GQzw.getDefaultLoggerOptions)({
            level: level
        });
        const { logger: logger } = (0, $6GQzw.generatePlatformLogger)({
            opts: loggerOptions
        });
        logger.error = (...args)=>{
            for (const arg of args)if (arg instanceof Error) {
                onError(arg, ...args);
                return;
            }
            onError(undefined, ...args);
        };
        return logger;
    }
};


var $bCoR3 = parcelRequire("bCoR3");

var $4zT52 = parcelRequire("4zT52");

var $nDot9 = parcelRequire("nDot9");

var $b3v9s = parcelRequire("b3v9s");

var $kfwQH = parcelRequire("kfwQH");
var $gD0RX = parcelRequire("gD0RX");
var $3h0dG = parcelRequire("3h0dG");
var $lpmCO = parcelRequire("lpmCO");
parcelRequire("5ID99");

var $b3v9s = parcelRequire("b3v9s");

var $kfwQH = parcelRequire("kfwQH");
var $gD0RX = parcelRequire("gD0RX");

parcelRequire("5ID99");

var $b3v9s = parcelRequire("b3v9s");

var $gD0RX = parcelRequire("gD0RX");
var $knC5d = parcelRequire("knC5d");
var $ahcWC = parcelRequire("ahcWC");

const $30dbf5c41b1ba86e$export$fd679d2deaa3513 = {
    ERROR_CODE_UNRECOGNIZED_CHAIN_ID: 4902,
    ERROR_CODE_DEFAULT: 5000,
    ERROR_INVALID_CHAIN_ID: 32603,
    DEFAULT_ALLOWED_ANCESTORS: [
        "http://localhost:*",
        "https://*.pages.dev",
        "https://*.vercel.app",
        "https://*.ngrok-free.app",
        "https://secure-mobile.walletconnect.com",
        "https://secure-mobile.walletconnect.org"
    ]
};



var $lIOIM = parcelRequire("lIOIM");
// -- Networks ---------------------------------------------------------------
function $558f8120b005e3b4$export$b6380ff64616a4fb(chain) {
    return {
        formatters: undefined,
        fees: undefined,
        serializers: undefined,
        ...chain
    };
}


const $17af278e83b94a22$export$625cf84d855940d4 = /*#__PURE__*/ (0, $558f8120b005e3b4$export$b6380ff64616a4fb)({
    id: 42161,
    name: "Arbitrum One",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://arb1.arbitrum.io/rpc"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Arbiscan",
            url: "https://arbiscan.io",
            apiUrl: "https://api.arbiscan.io/api"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 7654707
        }
    }
});


const $4e7083cdb1b68451$export$536d3e0d2c7baf54 = /*#__PURE__*/ (0, $558f8120b005e3b4$export$b6380ff64616a4fb)({
    id: 1,
    name: "Ethereum",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://eth.merkle.io"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Etherscan",
            url: "https://etherscan.io",
            apiUrl: "https://api.etherscan.io/api"
        }
    },
    contracts: {
        ensRegistry: {
            address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
        },
        ensUniversalResolver: {
            address: "0xce01f8eee7E479C928F8919abD53E553a36CeF67",
            blockCreated: 19258213
        },
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 14353601
        }
    }
});


function $ade00fe43ae620e8$export$b6380ff64616a4fb(chain) {
    return {
        formatters: undefined,
        fees: undefined,
        serializers: undefined,
        ...chain
    };
}


const $f1509a8399dc02d3$export$ee6400bf8f8c2a0d = (0, $ade00fe43ae620e8$export$b6380ff64616a4fb)({
    id: "5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp",
    name: "Solana",
    network: "solana-mainnet",
    nativeCurrency: {
        name: "Solana",
        symbol: "SOL",
        decimals: 9
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.walletconnect.org/v1"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Solscan",
            url: "https://solscan.io"
        }
    },
    testnet: false,
    chainNamespace: "solana",
    caipNetworkId: "solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp",
    deprecatedCaipNetworkId: "solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
});



const $1ffbd897ba4d115b$export$7e6894daae5bd681 = (0, $ade00fe43ae620e8$export$b6380ff64616a4fb)({
    id: "EtWTRABZaYq6iMfeYKouRu166VU2xqa1",
    name: "Solana Devnet",
    network: "solana-devnet",
    nativeCurrency: {
        name: "Solana",
        symbol: "SOL",
        decimals: 9
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.walletconnect.org/v1"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Solscan",
            url: "https://solscan.io"
        }
    },
    testnet: true,
    chainNamespace: "solana",
    caipNetworkId: "solana:EtWTRABZaYq6iMfeYKouRu166VU2xqa1",
    deprecatedCaipNetworkId: "solana:8E9rvCKLFQia2Y35HXjjpWzj8weVo44K"
});



const $2b1a7288ee6d92fd$export$df5e497f95906b2a = (0, $ade00fe43ae620e8$export$b6380ff64616a4fb)({
    id: "4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z",
    name: "Solana Testnet",
    network: "solana-testnet",
    nativeCurrency: {
        name: "Solana",
        symbol: "SOL",
        decimals: 9
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.walletconnect.org/v1"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Solscan",
            url: "https://solscan.io"
        }
    },
    testnet: true,
    chainNamespace: "solana",
    caipNetworkId: "solana:4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z"
});





const $bb01571ccd77b52d$export$794b04b0756618df = (0, $ade00fe43ae620e8$export$b6380ff64616a4fb)({
    id: "000000000019d6689c085ae165831e93",
    caipNetworkId: "bip122:000000000019d6689c085ae165831e93",
    chainNamespace: "bip122",
    name: "Bitcoin",
    nativeCurrency: {
        name: "Bitcoin",
        symbol: "BTC",
        decimals: 8
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.walletconnect.org/v1"
            ]
        }
    }
});
const $bb01571ccd77b52d$export$866db670255e931d = (0, $ade00fe43ae620e8$export$b6380ff64616a4fb)({
    id: "000000000933ea01ad0ee984209779ba",
    caipNetworkId: "bip122:000000000933ea01ad0ee984209779ba",
    chainNamespace: "bip122",
    name: "Bitcoin Testnet",
    nativeCurrency: {
        name: "Bitcoin",
        symbol: "BTC",
        decimals: 8
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.walletconnect.org/v1"
            ]
        }
    },
    testnet: true
});





const $6c592072e95901b7$export$5c3eb765ea0f1dc2 = {
    solana: [
        "solana_signMessage",
        "solana_signTransaction",
        "solana_requestAccounts",
        "solana_getAccounts",
        "solana_signAllTransactions",
        "solana_signAndSendTransaction"
    ],
    eip155: [
        "eth_accounts",
        "eth_requestAccounts",
        "eth_sendRawTransaction",
        "eth_sign",
        "eth_signTransaction",
        "eth_signTypedData",
        "eth_signTypedData_v3",
        "eth_signTypedData_v4",
        "eth_sendTransaction",
        "personal_sign",
        "wallet_switchEthereumChain",
        "wallet_addEthereumChain",
        "wallet_getPermissions",
        "wallet_requestPermissions",
        "wallet_registerOnboarding",
        "wallet_watchAsset",
        "wallet_scanQRCode",
        // EIP-5792
        "wallet_getCallsStatus",
        "wallet_showCallsStatus",
        "wallet_sendCalls",
        "wallet_getCapabilities",
        // EIP-7715
        "wallet_grantPermissions",
        "wallet_revokePermissions",
        //EIP-7811
        "wallet_getAssets"
    ],
    bip122: [
        "sendTransfer",
        "signMessage",
        "signPsbt",
        "getAccountAddresses"
    ]
};
const $6c592072e95901b7$export$4267940df2f33c5a = {
    getMethodsByChainNamespace (chainNamespace) {
        return $6c592072e95901b7$export$5c3eb765ea0f1dc2[chainNamespace] || [];
    },
    createDefaultNamespace (chainNamespace) {
        return {
            methods: this.getMethodsByChainNamespace(chainNamespace),
            events: [
                "accountsChanged",
                "chainChanged"
            ],
            chains: [],
            rpcMap: {}
        };
    },
    applyNamespaceOverrides (baseNamespaces, overrides) {
        if (!overrides) return {
            ...baseNamespaces
        };
        const result = {
            ...baseNamespaces
        };
        const namespacesToOverride = new Set();
        if (overrides.methods) Object.keys(overrides.methods).forEach((ns)=>namespacesToOverride.add(ns));
        if (overrides.chains) Object.keys(overrides.chains).forEach((ns)=>namespacesToOverride.add(ns));
        if (overrides.events) Object.keys(overrides.events).forEach((ns)=>namespacesToOverride.add(ns));
        if (overrides.rpcMap) Object.keys(overrides.rpcMap).forEach((chainId)=>{
            const [ns] = chainId.split(":");
            if (ns) namespacesToOverride.add(ns);
        });
        namespacesToOverride.forEach((ns)=>{
            if (!result[ns]) result[ns] = this.createDefaultNamespace(ns);
        });
        if (overrides.methods) Object.entries(overrides.methods).forEach(([ns, methods])=>{
            if (result[ns]) result[ns].methods = methods;
        });
        if (overrides.chains) Object.entries(overrides.chains).forEach(([ns, chains])=>{
            if (result[ns]) result[ns].chains = chains;
        });
        if (overrides.events) Object.entries(overrides.events).forEach(([ns, events])=>{
            if (result[ns]) result[ns].events = events;
        });
        if (overrides.rpcMap) {
            const processedNamespaces = new Set();
            Object.entries(overrides.rpcMap).forEach(([chainId, rpcUrl])=>{
                const [ns, id] = chainId.split(":");
                if (!ns || !id || !result[ns]) return;
                if (!result[ns].rpcMap) result[ns].rpcMap = {};
                if (!processedNamespaces.has(ns)) {
                    result[ns].rpcMap = {};
                    processedNamespaces.add(ns);
                }
                result[ns].rpcMap[id] = rpcUrl;
            });
        }
        return result;
    },
    createNamespaces (caipNetworks, configOverride) {
        const defaultNamespaces = caipNetworks.reduce((acc, chain)=>{
            const { id: id, chainNamespace: chainNamespace, rpcUrls: rpcUrls } = chain;
            const rpcUrl = rpcUrls.default.http[0];
            if (!acc[chainNamespace]) acc[chainNamespace] = this.createDefaultNamespace(chainNamespace);
            const caipNetworkId = `${chainNamespace}:${id}`;
            // eslint-disable-next-line @typescript-eslint/non-nullable-type-assertion-style
            const namespace = acc[chainNamespace];
            namespace.chains.push(caipNetworkId);
            // Workaround for wallets that only support deprecated Solana network ID
            switch(caipNetworkId){
                case (0, $f1509a8399dc02d3$export$ee6400bf8f8c2a0d).caipNetworkId:
                    namespace.chains.push((0, $f1509a8399dc02d3$export$ee6400bf8f8c2a0d).deprecatedCaipNetworkId);
                    break;
                case (0, $1ffbd897ba4d115b$export$7e6894daae5bd681).caipNetworkId:
                    namespace.chains.push((0, $1ffbd897ba4d115b$export$7e6894daae5bd681).deprecatedCaipNetworkId);
                    break;
                default:
            }
            if (namespace?.rpcMap && rpcUrl) namespace.rpcMap[id] = rpcUrl;
            return acc;
        }, {});
        return this.applyNamespaceOverrides(defaultNamespaces, configOverride);
    },
    resolveReownName: async (name)=>{
        const wcNameAddress = await (0, $lIOIM.EnsController).resolveName(name);
        const networkNameAddresses = Object.values(wcNameAddress?.addresses) || [];
        return networkNameAddresses[0]?.address || false;
    },
    getChainsFromNamespaces (namespaces = {}) {
        return Object.values(namespaces).flatMap((namespace)=>{
            const chains = namespace.chains || [];
            const accountsChains = namespace.accounts.map((account)=>{
                const [chainNamespace, chainId] = account.split(":");
                return `${chainNamespace}:${chainId}`;
            });
            return Array.from(new Set([
                ...chains,
                ...accountsChains
            ]));
        });
    },
    isSessionEventData (data) {
        return typeof data === "object" && data !== null && "id" in data && "topic" in data && "params" in data && typeof data.params === "object" && data.params !== null && "chainId" in data.params && "event" in data.params && typeof data.params.event === "object" && data.params.event !== null;
    },
    isOriginAllowed (currentOrigin, allowedPatterns, defaultAllowedOrigins) {
        for (const pattern of [
            ...allowedPatterns,
            ...defaultAllowedOrigins
        ]){
            if (pattern.includes("*")) {
                // Convert wildcard pattern to regex, escape special chars, replace *, match whole string
                const escapedPattern = pattern.replace(/[.*+?^${}()|[\]\\]/gu, "\\$&");
                const regexString = `^${escapedPattern.replace(/\\\*/gu, ".*")}$`;
                const regex = new RegExp(regexString, "u");
                if (regex.test(currentOrigin)) return true;
            } else if (pattern === currentOrigin) return true;
        }
        // No match found
        return false;
    }
};






class $ffb539405861dea3$export$c456b2d327ac201f {
    constructor({ provider: provider, namespace: namespace }){
        this.id = (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.WALLET_CONNECT;
        this.name = (0, $8a4fed4bf263e097$export$fd35d6514357600).ConnectorNamesMap[(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.WALLET_CONNECT];
        this.type = "WALLET_CONNECT";
        this.imageId = (0, $8a4fed4bf263e097$export$fd35d6514357600).ConnectorImageIds[(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.WALLET_CONNECT];
        this.getCaipNetworks = (0, $gD0RX.ChainController).getCaipNetworks.bind((0, $gD0RX.ChainController));
        this.caipNetworks = this.getCaipNetworks();
        this.provider = provider;
        this.chain = namespace;
    }
    get chains() {
        return this.getCaipNetworks();
    }
    async connectWalletConnect() {
        const isAuthenticated = await this.authenticate();
        if (!isAuthenticated) {
            const caipNetworks = this.getCaipNetworks();
            const universalProviderConfigOverride = (0, $knC5d.OptionsController).state.universalProviderConfigOverride;
            const namespaces = (0, $6c592072e95901b7$export$4267940df2f33c5a).createNamespaces(caipNetworks, universalProviderConfigOverride);
            await this.provider.connect({
                optionalNamespaces: namespaces
            });
        }
        return {
            clientId: await this.provider.client.core.crypto.getClientId(),
            session: this.provider.session
        };
    }
    async disconnect() {
        await this.provider.disconnect();
    }
    async authenticate() {
        const chains = this.chains.map((network)=>network.caipNetworkId);
        return (0, $ahcWC.SIWXUtil).universalProviderAuthenticate({
            universalProvider: this.provider,
            chains: chains,
            methods: $ffb539405861dea3$var$OPTIONAL_METHODS
        });
    }
}
const $ffb539405861dea3$var$OPTIONAL_METHODS = [
    "eth_accounts",
    "eth_requestAccounts",
    "eth_sendRawTransaction",
    "eth_sign",
    "eth_signTransaction",
    "eth_signTypedData",
    "eth_signTypedData_v3",
    "eth_signTypedData_v4",
    "eth_sendTransaction",
    "personal_sign",
    "wallet_switchEthereumChain",
    "wallet_addEthereumChain",
    "wallet_getPermissions",
    "wallet_requestPermissions",
    "wallet_registerOnboarding",
    "wallet_watchAsset",
    "wallet_scanQRCode",
    // EIP-5792
    "wallet_getCallsStatus",
    "wallet_sendCalls",
    "wallet_getCapabilities",
    // EIP-7715
    "wallet_grantPermissions",
    "wallet_revokePermissions",
    //EIP-7811
    "wallet_getAssets"
];


class $047ef4420d4ccb1d$export$993f0e61ab122f72 {
    /**
     * Creates an instance of AdapterBlueprint.
     * @param {AdapterBlueprint.Params} params - The parameters for initializing the adapter
     */ constructor(params){
        this.availableConnectors = [];
        this.eventListeners = new Map();
        this.getCaipNetworks = (namespace)=>(0, $gD0RX.ChainController).getCaipNetworks(namespace);
        if (params) this.construct(params);
    }
    /**
     * Initializes the adapter with the given parameters.
     * @param {AdapterBlueprint.Params} params - The parameters for initializing the adapter
     */ construct(params) {
        this.projectId = params.projectId;
        this.namespace = params.namespace;
        this.adapterType = params.adapterType;
    }
    /**
     * Gets the available connectors.
     * @returns {Connector[]} An array of available connectors
     */ get connectors() {
        return this.availableConnectors;
    }
    /**
     * Gets the supported networks.
     * @returns {CaipNetwork[]} An array of supported networks
     */ get networks() {
        return this.getCaipNetworks(this.namespace);
    }
    /**
     * Sets the auth provider.
     * @param {W3mFrameProvider} authProvider - The auth provider instance
     */ setAuthProvider(authProvider) {
        this.addConnector({
            id: (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH,
            type: "AUTH",
            name: (0, $b3v9s.ConstantsUtil).CONNECTOR_NAMES.AUTH,
            provider: authProvider,
            imageId: (0, $8a4fed4bf263e097$export$fd35d6514357600).ConnectorImageIds[(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH],
            chain: this.namespace,
            chains: []
        });
    }
    /**
     * Adds one or more connectors to the available connectors list.
     * @param {...Connector} connectors - The connectors to add
     */ addConnector(...connectors) {
        const connectorsAdded = new Set();
        this.availableConnectors = [
            ...connectors,
            ...this.availableConnectors
        ].filter((connector)=>{
            if (connectorsAdded.has(connector.id)) return false;
            connectorsAdded.add(connector.id);
            return true;
        });
        this.emit("connectors", this.availableConnectors);
    }
    setStatus(status, chainNamespace) {
        (0, $kfwQH.AccountController).setStatus(status, chainNamespace);
    }
    /**
     * Adds an event listener for a specific event.
     * @template T
     * @param {T} eventName - The name of the event
     * @param {EventCallback<T>} callback - The callback function to be called when the event is emitted
     */ on(eventName, callback) {
        if (!this.eventListeners.has(eventName)) this.eventListeners.set(eventName, new Set());
        this.eventListeners.get(eventName)?.add(callback);
    }
    /**
     * Removes an event listener for a specific event.
     * @template T
     * @param {T} eventName - The name of the event
     * @param {EventCallback<T>} callback - The callback function to be removed
     */ off(eventName, callback) {
        const listeners = this.eventListeners.get(eventName);
        if (listeners) listeners.delete(callback);
    }
    /**
     * Removes all event listeners.
     */ removeAllEventListeners() {
        this.eventListeners.forEach((listeners)=>{
            listeners.clear();
        });
    }
    /**
     * Emits an event with the given name and optional data.
     * @template T
     * @param {T} eventName - The name of the event to emit
     * @param {EventData[T]} [data] - The optional data to be passed to the event listeners
     */ emit(eventName, data) {
        const listeners = this.eventListeners.get(eventName);
        if (listeners) listeners.forEach((callback)=>callback(data));
    }
    /**
     * Connects to WalletConnect.
     * @param {number | string} [_chainId] - Optional chain ID to connect to
     */ async connectWalletConnect(_chainId) {
        const connector = this.getWalletConnectConnector();
        const result = await connector.connectWalletConnect();
        return {
            clientId: result.clientId
        };
    }
    /**
     * Switches the network.
     * @param {AdapterBlueprint.SwitchNetworkParams} params - Network switching parameters
     */ async switchNetwork(params) {
        const { caipNetwork: caipNetwork, providerType: providerType } = params;
        if (!params.provider) return;
        const provider = "provider" in params.provider ? params.provider.provider : params.provider;
        if (providerType === "WALLET_CONNECT") {
            provider.setDefaultChain(caipNetwork.caipNetworkId);
            return;
        }
        if (provider && providerType === "AUTH") {
            const authProvider = provider;
            const preferredAccountType = (0, $kfwQH.AccountController).state.preferredAccountTypes?.[caipNetwork.chainNamespace];
            await authProvider.switchNetwork(caipNetwork.caipNetworkId);
            const user = await authProvider.getUser({
                chainId: caipNetwork.caipNetworkId,
                preferredAccountType: preferredAccountType
            });
            this.emit("switchNetwork", user);
        }
    }
    getWalletConnectConnector() {
        const connector = this.connectors.find((c)=>c instanceof (0, $ffb539405861dea3$export$c456b2d327ac201f));
        if (!connector) throw new Error("WalletConnectConnector not found");
        return connector;
    }
}




class $e006d0b3ae4c2ce3$export$10ed1c0736be619c extends (0, $047ef4420d4ccb1d$export$993f0e61ab122f72) {
    setUniversalProvider(universalProvider) {
        this.addConnector(new (0, $ffb539405861dea3$export$c456b2d327ac201f)({
            provider: universalProvider,
            caipNetworks: this.getCaipNetworks(),
            namespace: this.namespace
        }));
    }
    async connect(params) {
        return Promise.resolve({
            id: "WALLET_CONNECT",
            type: "WALLET_CONNECT",
            chainId: Number(params.chainId),
            provider: this.provider,
            address: ""
        });
    }
    async disconnect() {
        try {
            const connector = this.getWalletConnectConnector();
            await connector.disconnect();
        } catch (error) {
            console.warn("UniversalAdapter:disconnect - error", error);
        }
    }
    async getAccounts({ namespace: namespace }) {
        const provider = this.provider;
        const addresses = provider?.session?.namespaces?.[namespace]?.accounts?.map((account)=>{
            const [, , address] = account.split(":");
            return address;
        }).filter((address, index, self)=>self.indexOf(address) === index) || [];
        return Promise.resolve({
            accounts: addresses.map((address)=>(0, $lpmCO.CoreHelperUtil).createAccount(namespace, address, namespace === "bip122" ? "payment" : "eoa"))
        });
    }
    async syncConnectors() {
        return Promise.resolve();
    }
    async getBalance(params) {
        const isBalanceSupported = params.caipNetwork && (0, $3h0dG.ConstantsUtil).BALANCE_SUPPORTED_CHAINS.includes(params.caipNetwork?.chainNamespace);
        if (!isBalanceSupported || params.caipNetwork?.testnet) return {
            balance: "0.00",
            symbol: params.caipNetwork?.nativeCurrency.symbol || ""
        };
        if ((0, $kfwQH.AccountController).state.balanceLoading && params.chainId === (0, $gD0RX.ChainController).state.activeCaipNetwork?.id) return {
            balance: (0, $kfwQH.AccountController).state.balance || "0.00",
            symbol: (0, $kfwQH.AccountController).state.balanceSymbol || ""
        };
        const balances = await (0, $kfwQH.AccountController).fetchTokenBalance();
        const balance = balances.find((b)=>b.chainId === `${params.caipNetwork?.chainNamespace}:${params.chainId}` && b.symbol === params.caipNetwork?.nativeCurrency.symbol);
        return {
            balance: balance?.quantity.numeric || "0.00",
            symbol: balance?.symbol || params.caipNetwork?.nativeCurrency.symbol || ""
        };
    }
    async signMessage(params) {
        const { provider: provider, message: message, address: address } = params;
        if (!provider) throw new Error("UniversalAdapter:signMessage - provider is undefined");
        let signature = "";
        if ((0, $gD0RX.ChainController).state.activeCaipNetwork?.chainNamespace === (0, $b3v9s.ConstantsUtil).CHAIN.SOLANA) {
            const response = await provider.request({
                method: "solana_signMessage",
                params: {
                    message: (0, $4zT52.default).encode(new TextEncoder().encode(message)),
                    pubkey: address
                }
            }, (0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
            signature = response.signature;
        } else signature = await provider.request({
            method: "personal_sign",
            params: [
                message,
                address
            ]
        }, (0, $gD0RX.ChainController).state.activeCaipNetwork?.caipNetworkId);
        return {
            signature: signature
        };
    }
    // -- Transaction methods ---------------------------------------------------
    /**
     *
     * These methods are supported only on `wagmi` and `ethers` since the Solana SDK does not support them in the same way.
     * These function definition is to have a type parity between the clients. Currently not in use.
     */ async estimateGas() {
        return Promise.resolve({
            gas: BigInt(0)
        });
    }
    async sendTransaction() {
        return Promise.resolve({
            hash: ""
        });
    }
    walletGetAssets(_params) {
        return Promise.resolve({});
    }
    async writeContract() {
        return Promise.resolve({
            hash: ""
        });
    }
    parseUnits() {
        return 0n;
    }
    formatUnits() {
        return "0";
    }
    async getCapabilities() {
        return Promise.resolve({});
    }
    async grantPermissions() {
        return Promise.resolve({});
    }
    async revokePermissions() {
        return Promise.resolve("0x");
    }
    async syncConnection() {
        return Promise.resolve({
            id: "WALLET_CONNECT",
            type: "WALLET_CONNECT",
            chainId: 1,
            provider: this.provider,
            address: ""
        });
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    async switchNetwork(params) {
        const { caipNetwork: caipNetwork } = params;
        const connector = this.getWalletConnectConnector();
        if (caipNetwork.chainNamespace === (0, $b3v9s.ConstantsUtil).CHAIN.EVM) try {
            await connector.provider?.request({
                method: "wallet_switchEthereumChain",
                params: [
                    {
                        chainId: (0, $nDot9.toHex)(caipNetwork.id)
                    }
                ]
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (switchError) {
            if (switchError.code === (0, $30dbf5c41b1ba86e$export$fd679d2deaa3513).ERROR_CODE_UNRECOGNIZED_CHAIN_ID || switchError.code === (0, $30dbf5c41b1ba86e$export$fd679d2deaa3513).ERROR_INVALID_CHAIN_ID || switchError.code === (0, $30dbf5c41b1ba86e$export$fd679d2deaa3513).ERROR_CODE_DEFAULT || switchError?.data?.originalError?.code === (0, $30dbf5c41b1ba86e$export$fd679d2deaa3513).ERROR_CODE_UNRECOGNIZED_CHAIN_ID) try {
                await connector.provider?.request({
                    method: "wallet_addEthereumChain",
                    params: [
                        {
                            chainId: (0, $nDot9.toHex)(caipNetwork.id),
                            rpcUrls: [
                                caipNetwork?.rpcUrls["chainDefault"]?.http
                            ],
                            chainName: caipNetwork.name,
                            nativeCurrency: caipNetwork.nativeCurrency,
                            blockExplorerUrls: [
                                caipNetwork.blockExplorers?.default.url
                            ]
                        }
                    ]
                });
            } catch (error) {
                throw new Error("Chain is not supported");
            }
        }
        connector.provider.setDefaultChain(caipNetwork.caipNetworkId);
    }
    getWalletConnectProvider() {
        const connector = this.connectors.find((c)=>c.type === "WALLET_CONNECT");
        const provider = connector?.provider;
        return provider;
    }
}



var $5PQZs = parcelRequire("5PQZs");
var $g9yWp = parcelRequire("g9yWp");
var $3h0dG = parcelRequire("3h0dG");
const $6d2e340843b2fb5c$var$featureKeys = [
    "email",
    "socials",
    "swaps",
    "onramp",
    "activity",
    "reownBranding"
];
const $6d2e340843b2fb5c$var$featureConfig = {
    email: {
        apiFeatureName: "social_login",
        localFeatureName: "email",
        returnType: false,
        isLegacy: false,
        processApi: (apiConfig)=>{
            if (!apiConfig?.config) return false;
            const config = apiConfig.config;
            return Boolean(apiConfig.isEnabled) && config.includes("email");
        },
        processFallback: (localValue)=>{
            if (localValue === undefined) return (0, $3h0dG.ConstantsUtil).DEFAULT_REMOTE_FEATURES.email;
            return Boolean(localValue);
        }
    },
    socials: {
        apiFeatureName: "social_login",
        localFeatureName: "socials",
        returnType: false,
        isLegacy: false,
        processApi: (apiConfig)=>{
            if (!apiConfig?.config) return false;
            const config = apiConfig.config;
            return Boolean(apiConfig.isEnabled) && config.length > 0 ? config.filter((s)=>s !== "email") : false;
        },
        processFallback: (localValue)=>{
            if (localValue === undefined) return (0, $3h0dG.ConstantsUtil).DEFAULT_REMOTE_FEATURES.socials;
            if (typeof localValue === "boolean") return localValue ? (0, $3h0dG.ConstantsUtil).DEFAULT_REMOTE_FEATURES.socials : false;
            return localValue;
        }
    },
    swaps: {
        apiFeatureName: "swap",
        localFeatureName: "swaps",
        returnType: false,
        isLegacy: false,
        processApi: (apiConfig)=>{
            if (!apiConfig?.config) return false;
            const config = apiConfig.config;
            return Boolean(apiConfig.isEnabled) && config.length > 0 ? config : false;
        },
        processFallback: (localValue)=>{
            if (localValue === undefined) return (0, $3h0dG.ConstantsUtil).DEFAULT_REMOTE_FEATURES.swaps;
            if (typeof localValue === "boolean") return localValue ? (0, $3h0dG.ConstantsUtil).DEFAULT_REMOTE_FEATURES.swaps : false;
            return localValue;
        }
    },
    onramp: {
        apiFeatureName: "onramp",
        localFeatureName: "onramp",
        returnType: false,
        isLegacy: false,
        processApi: (apiConfig)=>{
            if (!apiConfig?.config) return false;
            const config = apiConfig.config;
            return Boolean(apiConfig.isEnabled) && config.length > 0 ? config : false;
        },
        processFallback: (localValue)=>{
            if (localValue === undefined) return (0, $3h0dG.ConstantsUtil).DEFAULT_REMOTE_FEATURES.onramp;
            if (typeof localValue === "boolean") return localValue ? (0, $3h0dG.ConstantsUtil).DEFAULT_REMOTE_FEATURES.onramp : false;
            return localValue;
        }
    },
    activity: {
        apiFeatureName: "activity",
        localFeatureName: "history",
        returnType: false,
        isLegacy: true,
        processApi: (apiConfig)=>Boolean(apiConfig.isEnabled),
        processFallback: (localValue)=>{
            if (localValue === undefined) return (0, $3h0dG.ConstantsUtil).DEFAULT_REMOTE_FEATURES.activity;
            return Boolean(localValue);
        }
    },
    reownBranding: {
        apiFeatureName: "reown_branding",
        localFeatureName: "reownBranding",
        returnType: false,
        isLegacy: false,
        processApi: (apiConfig)=>Boolean(apiConfig.isEnabled),
        processFallback: (localValue)=>{
            if (localValue === undefined) return (0, $3h0dG.ConstantsUtil).DEFAULT_REMOTE_FEATURES.reownBranding;
            return Boolean(localValue);
        }
    }
};
const $6d2e340843b2fb5c$export$97e74942205117b = {
    localSettingsOverridden: new Set(),
    getApiConfig (id, apiProjectConfig) {
        return apiProjectConfig?.find((f)=>f.id === id);
    },
    addWarning (localFeatureValue, featureKey) {
        if (localFeatureValue !== undefined) {
            const config = $6d2e340843b2fb5c$var$featureConfig[featureKey];
            const warningName = config.isLegacy ? `"features.${config.localFeatureName}" (now "${featureKey}")` : `"features.${featureKey}"`;
            this.localSettingsOverridden.add(warningName);
        }
    },
    processFeature (featureKey, localFeatures, apiProjectConfig, useApi) {
        const config = $6d2e340843b2fb5c$var$featureConfig[featureKey];
        const localValue = localFeatures[config.localFeatureName];
        if (useApi) {
            const apiConfig = this.getApiConfig(config.apiFeatureName, apiProjectConfig);
            if (apiConfig?.config === null) return this.processFallbackFeature(featureKey, localValue);
            if (!apiConfig?.config) return false;
            if (localValue !== undefined) this.addWarning(localValue, featureKey);
            return this.processApiFeature(featureKey, apiConfig);
        }
        return this.processFallbackFeature(featureKey, localValue);
    },
    processApiFeature (featureKey, apiConfig) {
        return $6d2e340843b2fb5c$var$featureConfig[featureKey].processApi(apiConfig);
    },
    processFallbackFeature (featureKey, localValue) {
        return $6d2e340843b2fb5c$var$featureConfig[featureKey].processFallback(localValue);
    },
    async fetchRemoteFeatures (config) {
        const localFeatures = config.features || {};
        this.localSettingsOverridden.clear();
        let apiProjectConfig = null;
        let useApiConfig = false;
        try {
            apiProjectConfig = await (0, $g9yWp.ApiController).fetchProjectConfig();
            useApiConfig = apiProjectConfig !== null && apiProjectConfig !== undefined;
        } catch (e) {
            console.warn("[Reown Config] Failed to fetch remote project configuration. Using local/default values.", e);
        }
        const remoteFeaturesConfig = useApiConfig ? (0, $3h0dG.ConstantsUtil).DEFAULT_REMOTE_FEATURES : (0, $3h0dG.ConstantsUtil).DEFAULT_REMOTE_FEATURES_DISABLED;
        try {
            for (const featureKey of $6d2e340843b2fb5c$var$featureKeys){
                const result = this.processFeature(featureKey, localFeatures, apiProjectConfig, useApiConfig);
                Object.assign(remoteFeaturesConfig, {
                    [featureKey]: result
                });
            }
        } catch (e) {
            console.warn("[Reown Config] Failed to process the configuration from Cloud. Using default values.", e);
            return (0, $3h0dG.ConstantsUtil).DEFAULT_REMOTE_FEATURES;
        }
        if (useApiConfig && this.localSettingsOverridden.size > 0) {
            const warningMessage = `Your local configuration for ${Array.from(this.localSettingsOverridden).join(", ")} was ignored because a remote configuration was successfully fetched. Please manage these features via your project dashboard on dashboard.reown.com.`;
            (0, $5PQZs.AlertController).open({
                shortMessage: "Local configuration ignored",
                longMessage: `[Reown Config Notice] ${warningMessage}`
            }, "warning");
        }
        return remoteFeaturesConfig;
    }
};



class $481119b7501ec63c$export$4586931bc94dcec5 {
    constructor(options){
        this.chainNamespaces = [];
        this.remoteFeatures = {};
        this.reportedAlertErrors = {};
        // -- Public Internal ---------------------------------------------------
        this.getCaipNetwork = (chainNamespace, id)=>{
            if (chainNamespace) {
                const caipNetworkWithId = (0, $gD0RX.ChainController).getNetworkData(chainNamespace)?.requestedCaipNetworks?.find((c)=>c.id === id);
                if (caipNetworkWithId) return caipNetworkWithId;
                const namespaceCaipNetwork = (0, $gD0RX.ChainController).getNetworkData(chainNamespace)?.caipNetwork;
                if (namespaceCaipNetwork) return namespaceCaipNetwork;
                const requestedCaipNetworks = (0, $gD0RX.ChainController).getRequestedCaipNetworks(chainNamespace);
                return requestedCaipNetworks.filter((c)=>c.chainNamespace === chainNamespace)?.[0];
            }
            return (0, $gD0RX.ChainController).state.activeCaipNetwork || this.defaultCaipNetwork;
        };
        this.getCaipNetworkId = ()=>{
            const network = this.getCaipNetwork();
            if (network) return network.id;
            return undefined;
        };
        this.getCaipNetworks = (namespace)=>(0, $gD0RX.ChainController).getCaipNetworks(namespace);
        this.getActiveChainNamespace = ()=>(0, $gD0RX.ChainController).state.activeChain;
        this.setRequestedCaipNetworks = (requestedCaipNetworks, chain)=>{
            (0, $gD0RX.ChainController).setRequestedCaipNetworks(requestedCaipNetworks, chain);
        };
        this.getApprovedCaipNetworkIds = ()=>(0, $gD0RX.ChainController).getAllApprovedCaipNetworkIds();
        this.getCaipAddress = (chainNamespace)=>{
            if ((0, $gD0RX.ChainController).state.activeChain === chainNamespace || !chainNamespace) return (0, $gD0RX.ChainController).state.activeCaipAddress;
            return (0, $gD0RX.ChainController).getAccountProp("caipAddress", chainNamespace);
        };
        this.setClientId = (clientId)=>{
            (0, $hvrT6.BlockchainApiController).setClientId(clientId);
        };
        this.getProvider = (namespace)=>(0, $bCoR3.ProviderUtil).getProvider(namespace);
        this.getProviderType = (namespace)=>(0, $bCoR3.ProviderUtil).getProviderId(namespace);
        this.getPreferredAccountType = (namespace)=>(0, $kfwQH.AccountController).state.preferredAccountTypes?.[namespace];
        this.setCaipAddress = (caipAddress, chain)=>{
            (0, $kfwQH.AccountController).setCaipAddress(caipAddress, chain);
            /**
             * For the embedded use cases (Demo app), we should call close() when the user is connected to redirect them to Account View.
             */ if (caipAddress && (0, $knC5d.OptionsController).state.enableEmbedded) this.close();
        };
        this.setBalance = (balance, balanceSymbol, chain)=>{
            (0, $kfwQH.AccountController).setBalance(balance, balanceSymbol, chain);
        };
        this.setProfileName = (profileName, chain)=>{
            (0, $kfwQH.AccountController).setProfileName(profileName, chain);
        };
        this.setProfileImage = (profileImage, chain)=>{
            (0, $kfwQH.AccountController).setProfileImage(profileImage, chain);
        };
        this.setUser = (user, chain)=>{
            (0, $kfwQH.AccountController).setUser(user, chain);
        };
        this.resetAccount = (chain)=>{
            (0, $kfwQH.AccountController).resetAccount(chain);
        };
        this.setCaipNetwork = (caipNetwork)=>{
            (0, $gD0RX.ChainController).setActiveCaipNetwork(caipNetwork);
        };
        this.setCaipNetworkOfNamespace = (caipNetwork, chainNamespace)=>{
            (0, $gD0RX.ChainController).setChainNetworkData(chainNamespace, {
                caipNetwork: caipNetwork
            });
        };
        this.setAllAccounts = (addresses, chain)=>{
            (0, $kfwQH.AccountController).setAllAccounts(addresses, chain);
            (0, $knC5d.OptionsController).setHasMultipleAddresses(addresses?.length > 1);
        };
        this.setStatus = (status, chain)=>{
            (0, $kfwQH.AccountController).setStatus(status, chain);
            // If at least one namespace is connected, set the connection status
            if ((0, $58cAm.ConnectorController).isConnected()) (0, $bc5dy.StorageUtil).setConnectionStatus("connected");
            else (0, $bc5dy.StorageUtil).setConnectionStatus("disconnected");
        };
        this.getAddressByChainNamespace = (chainNamespace)=>(0, $gD0RX.ChainController).getAccountProp("address", chainNamespace);
        this.setConnectors = (connectors)=>{
            const allConnectors = [
                ...(0, $58cAm.ConnectorController).state.allConnectors,
                ...connectors
            ];
            (0, $58cAm.ConnectorController).setConnectors(allConnectors);
        };
        this.setConnections = (connections, chainNamespace)=>{
            (0, $efZLi.ConnectionController).setConnections(connections, chainNamespace);
        };
        this.fetchIdentity = (request)=>(0, $hvrT6.BlockchainApiController).fetchIdentity(request);
        this.getReownName = (address)=>(0, $lIOIM.EnsController).getNamesForAddress(address);
        this.getConnectors = ()=>(0, $58cAm.ConnectorController).getConnectors();
        this.getConnectorImage = (connector)=>(0, $9PqFe.AssetUtil).getConnectorImage(connector);
        this.setConnectedWalletInfo = (connectedWalletInfo, chain)=>{
            const type = (0, $bCoR3.ProviderUtil).getProviderId(chain);
            const walletInfo = connectedWalletInfo ? {
                ...connectedWalletInfo,
                type: type
            } : undefined;
            (0, $kfwQH.AccountController).setConnectedWalletInfo(walletInfo, chain);
        };
        this.getIsConnectedState = ()=>Boolean((0, $gD0RX.ChainController).state.activeCaipAddress);
        this.addAddressLabel = (address, label, chain)=>{
            (0, $kfwQH.AccountController).addAddressLabel(address, label, chain);
        };
        this.removeAddressLabel = (address, chain)=>{
            (0, $kfwQH.AccountController).removeAddressLabel(address, chain);
        };
        this.getAddress = (chainNamespace)=>{
            if ((0, $gD0RX.ChainController).state.activeChain === chainNamespace || !chainNamespace) return (0, $kfwQH.AccountController).state.address;
            return (0, $gD0RX.ChainController).getAccountProp("address", chainNamespace);
        };
        this.setApprovedCaipNetworksData = (namespace)=>(0, $gD0RX.ChainController).setApprovedCaipNetworksData(namespace);
        this.resetNetwork = (namespace)=>{
            (0, $gD0RX.ChainController).resetNetwork(namespace);
        };
        this.addConnector = (connector)=>{
            (0, $58cAm.ConnectorController).addConnector(connector);
        };
        this.resetWcConnection = ()=>{
            (0, $efZLi.ConnectionController).resetWcConnection();
        };
        this.setAddressExplorerUrl = (addressExplorerUrl, chain)=>{
            (0, $kfwQH.AccountController).setAddressExplorerUrl(addressExplorerUrl, chain);
        };
        this.setSmartAccountDeployed = (isDeployed, chain)=>{
            (0, $kfwQH.AccountController).setSmartAccountDeployed(isDeployed, chain);
        };
        this.setSmartAccountEnabledNetworks = (smartAccountEnabledNetworks, chain)=>{
            (0, $gD0RX.ChainController).setSmartAccountEnabledNetworks(smartAccountEnabledNetworks, chain);
        };
        this.setPreferredAccountType = (preferredAccountType, chain)=>{
            (0, $kfwQH.AccountController).setPreferredAccountType(preferredAccountType, chain);
        };
        this.setEIP6963Enabled = (enabled)=>{
            (0, $knC5d.OptionsController).setEIP6963Enabled(enabled);
        };
        this.handleUnsafeRPCRequest = ()=>{
            if (this.isOpen()) {
                // If we are on the modal but there is no transaction stack, close the modal
                if (this.isTransactionStackEmpty()) return;
                // Check if we need to replace or redirect
                this.redirect("ApproveTransaction");
            } else // If called from outside the modal, open ApproveTransaction
            this.open({
                view: "ApproveTransaction"
            });
        };
        this.options = options;
        this.version = options.sdkVersion;
        this.caipNetworks = this.extendCaipNetworks(options);
        this.chainNamespaces = this.getChainNamespacesSet(options.adapters, this.caipNetworks);
        this.defaultCaipNetwork = this.extendDefaultCaipNetwork(options);
        this.chainAdapters = this.createAdapters(options.adapters);
        this.readyPromise = this.initialize(options);
    }
    getChainNamespacesSet(adapters, caipNetworks) {
        const adapterNamespaces = adapters?.map((adapter)=>adapter.namespace).filter((namespace)=>Boolean(namespace));
        if (adapterNamespaces?.length) return [
            ...new Set(adapterNamespaces)
        ];
        const networkNamespaces = caipNetworks?.map((network)=>network.chainNamespace);
        return [
            ...new Set(networkNamespaces)
        ];
    }
    async initialize(options) {
        this.initializeProjectSettings(options);
        this.initControllers(options);
        await this.initChainAdapters();
        this.sendInitializeEvent(options);
        await this.syncExistingConnection();
        this.remoteFeatures = await (0, $6d2e340843b2fb5c$export$97e74942205117b).fetchRemoteFeatures(options);
        (0, $knC5d.OptionsController).setRemoteFeatures(this.remoteFeatures);
        if (this.remoteFeatures.onramp) (0, $jHvAI.OnRampController).setOnrampProviders(this.remoteFeatures.onramp);
        // Check allowed origins only if email or social features are enabled
        if ((0, $knC5d.OptionsController).state.remoteFeatures?.email || Array.isArray((0, $knC5d.OptionsController).state.remoteFeatures?.socials) && (0, $knC5d.OptionsController).state.remoteFeatures?.socials.length > 0) await this.checkAllowedOrigins();
    }
    async checkAllowedOrigins() {
        const allowedOrigins = await (0, $g9yWp.ApiController).fetchAllowedOrigins();
        if (allowedOrigins && (0, $lpmCO.CoreHelperUtil).isClient()) {
            const currentOrigin = window.location.origin;
            const isOriginAllowed = (0, $6c592072e95901b7$export$4267940df2f33c5a).isOriginAllowed(currentOrigin, allowedOrigins, (0, $30dbf5c41b1ba86e$export$fd679d2deaa3513).DEFAULT_ALLOWED_ANCESTORS);
            if (!isOriginAllowed) (0, $5PQZs.AlertController).open((0, $6rTj5.ErrorUtil).ALERT_ERRORS.INVALID_APP_CONFIGURATION, "error");
        } else (0, $5PQZs.AlertController).open((0, $6rTj5.ErrorUtil).ALERT_ERRORS.PROJECT_ID_NOT_CONFIGURED, "error");
    }
    sendInitializeEvent(options) {
        const { ...optionsCopy } = options;
        delete optionsCopy.adapters;
        delete optionsCopy.universalProvider;
        (0, $5FNhR.EventsController).sendEvent({
            type: "track",
            event: "INITIALIZE",
            properties: {
                ...optionsCopy,
                networks: options.networks.map((n)=>n.id),
                siweConfig: {
                    options: options.siweConfig?.options || {}
                }
            }
        });
    }
    // -- Controllers initialization ---------------------------------------------------
    initControllers(options) {
        this.initializeOptionsController(options);
        this.initializeChainController(options);
        this.initializeThemeController(options);
        this.initializeConnectionController(options);
        this.initializeConnectorController();
    }
    initializeThemeController(options) {
        if (options.themeMode) (0, $1VSgi.ThemeController).setThemeMode(options.themeMode);
        if (options.themeVariables) (0, $1VSgi.ThemeController).setThemeVariables(options.themeVariables);
    }
    initializeChainController(options) {
        if (!this.connectionControllerClient || !this.networkControllerClient) throw new Error("ConnectionControllerClient and NetworkControllerClient must be set");
        (0, $gD0RX.ChainController).initialize(options.adapters ?? [], this.caipNetworks, {
            connectionControllerClient: this.connectionControllerClient,
            networkControllerClient: this.networkControllerClient
        });
        const network = this.getDefaultNetwork();
        if (network) (0, $gD0RX.ChainController).setActiveCaipNetwork(network);
    }
    initializeConnectionController(options) {
        (0, $efZLi.ConnectionController).setWcBasic(options.basic ?? false);
    }
    initializeConnectorController() {
        (0, $58cAm.ConnectorController).initialize(this.chainNamespaces);
    }
    initializeProjectSettings(options) {
        (0, $knC5d.OptionsController).setProjectId(options.projectId);
        (0, $knC5d.OptionsController).setSdkVersion(options.sdkVersion);
    }
    initializeOptionsController(options) {
        (0, $knC5d.OptionsController).setDebug(options.debug !== false);
        // On by default
        (0, $knC5d.OptionsController).setEnableWalletConnect(options.enableWalletConnect !== false);
        (0, $knC5d.OptionsController).setEnableWalletGuide(options.enableWalletGuide !== false);
        (0, $knC5d.OptionsController).setEnableWallets(options.enableWallets !== false);
        (0, $knC5d.OptionsController).setEIP6963Enabled(options.enableEIP6963 !== false);
        (0, $knC5d.OptionsController).setEnableNetworkSwitch(options.enableNetworkSwitch !== false);
        (0, $knC5d.OptionsController).setEnableAuthLogger(options.enableAuthLogger !== false);
        (0, $knC5d.OptionsController).setCustomRpcUrls(options.customRpcUrls);
        (0, $knC5d.OptionsController).setEnableEmbedded(options.enableEmbedded);
        (0, $knC5d.OptionsController).setAllWallets(options.allWallets);
        (0, $knC5d.OptionsController).setIncludeWalletIds(options.includeWalletIds);
        (0, $knC5d.OptionsController).setExcludeWalletIds(options.excludeWalletIds);
        (0, $knC5d.OptionsController).setFeaturedWalletIds(options.featuredWalletIds);
        (0, $knC5d.OptionsController).setTokens(options.tokens);
        (0, $knC5d.OptionsController).setTermsConditionsUrl(options.termsConditionsUrl);
        (0, $knC5d.OptionsController).setPrivacyPolicyUrl(options.privacyPolicyUrl);
        (0, $knC5d.OptionsController).setCustomWallets(options.customWallets);
        (0, $knC5d.OptionsController).setFeatures(options.features);
        (0, $knC5d.OptionsController).setAllowUnsupportedChain(options.allowUnsupportedChain);
        (0, $knC5d.OptionsController).setUniversalProviderConfigOverride(options.universalProviderConfigOverride);
        (0, $knC5d.OptionsController).setPreferUniversalLinks(options.experimental_preferUniversalLinks);
        // Save option in controller
        (0, $knC5d.OptionsController).setDefaultAccountTypes(options.defaultAccountTypes);
        // Get stored account types
        const storedAccountTypes = (0, $bc5dy.StorageUtil).getPreferredAccountTypes() || {};
        const defaultTypes = {
            ...(0, $knC5d.OptionsController).state.defaultAccountTypes,
            ...storedAccountTypes
        };
        (0, $kfwQH.AccountController).setPreferredAccountTypes(defaultTypes);
        const defaultMetaData = this.getDefaultMetaData();
        if (!options.metadata && defaultMetaData) options.metadata = defaultMetaData;
        (0, $knC5d.OptionsController).setMetadata(options.metadata);
        (0, $knC5d.OptionsController).setDisableAppend(options.disableAppend);
        (0, $knC5d.OptionsController).setEnableEmbedded(options.enableEmbedded);
        (0, $knC5d.OptionsController).setSIWX(options.siwx);
        if (!options.projectId) {
            (0, $5PQZs.AlertController).open((0, $6rTj5.ErrorUtil).ALERT_ERRORS.PROJECT_ID_NOT_CONFIGURED, "error");
            return;
        }
        const evmAdapter = options.adapters?.find((adapter)=>adapter.namespace === (0, $b3v9s.ConstantsUtil).CHAIN.EVM);
        // Set the SIWE client for EVM chains
        if (evmAdapter) {
            if (options.siweConfig) {
                if (options.siwx) throw new Error("Cannot set both `siweConfig` and `siwx` options");
                (0, $knC5d.OptionsController).setSIWX(options.siweConfig.mapToSIWX());
            }
        }
    }
    getDefaultMetaData() {
        if ((0, $lpmCO.CoreHelperUtil).isClient()) return {
            name: document.getElementsByTagName("title")?.[0]?.textContent || "",
            description: document.querySelector('meta[property="og:description"]')?.content || "",
            url: window.location.origin,
            icons: [
                document.querySelector('link[rel~="icon"]')?.href || ""
            ]
        };
        return null;
    }
    // -- Network Initialization ---------------------------------------------------
    setUnsupportedNetwork(chainId) {
        const namespace = this.getActiveChainNamespace();
        if (namespace) {
            const unsupportedNetwork = (0, $3a7f156758201cdc$export$c2b0ef8ebe2589ea).getUnsupportedNetwork(`${namespace}:${chainId}`);
            (0, $gD0RX.ChainController).setActiveCaipNetwork(unsupportedNetwork);
        }
    }
    getDefaultNetwork() {
        return (0, $3a7f156758201cdc$export$c2b0ef8ebe2589ea).getCaipNetworkFromStorage(this.defaultCaipNetwork);
    }
    extendCaipNetwork(network, options) {
        const extendedNetwork = (0, $3a7f156758201cdc$export$c2b0ef8ebe2589ea).extendCaipNetwork(network, {
            customNetworkImageUrls: options.chainImages,
            projectId: options.projectId
        });
        return extendedNetwork;
    }
    extendCaipNetworks(options) {
        const extendedNetworks = (0, $3a7f156758201cdc$export$c2b0ef8ebe2589ea).extendCaipNetworks(options.networks, {
            customNetworkImageUrls: options.chainImages,
            customRpcUrls: options.customRpcUrls,
            projectId: options.projectId
        });
        return extendedNetworks;
    }
    extendDefaultCaipNetwork(options) {
        const defaultNetwork = options.networks.find((n)=>n.id === options.defaultNetwork?.id);
        const extendedNetwork = defaultNetwork ? (0, $3a7f156758201cdc$export$c2b0ef8ebe2589ea).extendCaipNetwork(defaultNetwork, {
            customNetworkImageUrls: options.chainImages,
            customRpcUrls: options.customRpcUrls,
            projectId: options.projectId
        }) : undefined;
        return extendedNetwork;
    }
    // -- Client Initialization ---------------------------------------------------
    createClients() {
        this.connectionControllerClient = {
            connectWalletConnect: async ()=>{
                const activeChain = (0, $gD0RX.ChainController).state.activeChain;
                const adapter = this.getAdapter(activeChain);
                const chainId = this.getCaipNetwork(activeChain)?.id;
                if (!adapter) throw new Error("Adapter not found");
                const result = await adapter.connectWalletConnect(chainId);
                this.close();
                this.setClientId(result?.clientId || null);
                (0, $bc5dy.StorageUtil).setConnectedNamespaces([
                    ...(0, $gD0RX.ChainController).state.chains.keys()
                ]);
                this.chainNamespaces.forEach((namespace)=>{
                    (0, $58cAm.ConnectorController).setConnectorId((0, $5SSdQ.ConstantsUtil).CONNECTOR_TYPE_WALLET_CONNECT, namespace);
                });
                await this.syncWalletConnectAccount();
            },
            connectExternal: async ({ id: id, info: info, type: type, provider: provider, chain: chain, caipNetwork: caipNetwork, socialUri: socialUri })=>{
                const activeChain = (0, $gD0RX.ChainController).state.activeChain;
                const chainToUse = chain || activeChain;
                const adapter = this.getAdapter(chainToUse);
                if (chain && chain !== activeChain && !caipNetwork) {
                    const toConnectNetwork = this.getCaipNetworks().find((network)=>network.chainNamespace === chain);
                    if (toConnectNetwork) this.setCaipNetwork(toConnectNetwork);
                }
                if (!adapter) throw new Error("Adapter not found");
                const fallbackCaipNetwork = this.getCaipNetwork(chainToUse);
                const res = await adapter.connect({
                    id: id,
                    info: info,
                    type: type,
                    provider: provider,
                    socialUri: socialUri,
                    chainId: caipNetwork?.id || fallbackCaipNetwork?.id,
                    rpcUrl: caipNetwork?.rpcUrls?.default?.http?.[0] || fallbackCaipNetwork?.rpcUrls?.default?.http?.[0]
                });
                if (!res) return;
                (0, $bc5dy.StorageUtil).addConnectedNamespace(chainToUse);
                this.syncProvider({
                    ...res,
                    chainNamespace: chainToUse
                });
                /*
                 * SyncAllAccounts already set the accounts in the state
                 * and its more efficient to use the stored accounts rather than fetching them again
                 */ const syncedAccounts = (0, $kfwQH.AccountController).state.allAccounts;
                const { accounts: accounts } = syncedAccounts?.length > 0 ? // Using new array else the accounts will have the same reference and react will not re-render
                {
                    accounts: [
                        ...syncedAccounts
                    ]
                } : await adapter.getAccounts({
                    namespace: chainToUse,
                    id: id
                });
                this.setAllAccounts(accounts, chainToUse);
                this.setStatus("connected", chainToUse);
                this.syncConnectedWalletInfo(chainToUse);
            },
            reconnectExternal: async ({ id: id, info: info, type: type, provider: provider })=>{
                const namespace = (0, $gD0RX.ChainController).state.activeChain;
                const adapter = this.getAdapter(namespace);
                if (adapter?.reconnect) {
                    await adapter?.reconnect({
                        id: id,
                        info: info,
                        type: type,
                        provider: provider,
                        chainId: this.getCaipNetwork()?.id
                    });
                    (0, $bc5dy.StorageUtil).addConnectedNamespace(namespace);
                    this.syncConnectedWalletInfo(namespace);
                }
            },
            disconnect: async (chainNamespace)=>{
                const namespace = chainNamespace || (0, $gD0RX.ChainController).state.activeChain;
                const adapter = this.getAdapter(namespace);
                const provider = (0, $bCoR3.ProviderUtil).getProvider(namespace);
                const providerType = (0, $bCoR3.ProviderUtil).getProviderId(namespace);
                await adapter?.disconnect({
                    provider: provider,
                    providerType: providerType
                });
                (0, $bc5dy.StorageUtil).removeConnectedNamespace(namespace);
                (0, $bCoR3.ProviderUtil).resetChain(namespace);
                this.setUser(undefined, namespace);
                this.setStatus("disconnected", namespace);
                this.setConnectedWalletInfo(undefined, namespace);
            },
            checkInstalled: (ids)=>{
                if (!ids) return Boolean(window.ethereum);
                return ids.some((id)=>Boolean(window.ethereum?.[String(id)]));
            },
            signMessage: async (message)=>{
                const adapter = this.getAdapter((0, $gD0RX.ChainController).state.activeChain);
                const result = await adapter?.signMessage({
                    message: message,
                    address: (0, $kfwQH.AccountController).state.address,
                    provider: (0, $bCoR3.ProviderUtil).getProvider((0, $gD0RX.ChainController).state.activeChain)
                });
                return result?.signature || "";
            },
            sendTransaction: async (args)=>{
                const namespace = args.chainNamespace;
                if ((0, $3h0dG.ConstantsUtil).SEND_SUPPORTED_NAMESPACES.includes(namespace)) {
                    const adapter = this.getAdapter((0, $gD0RX.ChainController).state.activeChain);
                    const provider = (0, $bCoR3.ProviderUtil).getProvider(namespace);
                    const result = await adapter?.sendTransaction({
                        ...args,
                        caipNetwork: this.getCaipNetwork(),
                        provider: provider
                    });
                    return result?.hash || "";
                }
                return "";
            },
            estimateGas: async (args)=>{
                if (args.chainNamespace === (0, $b3v9s.ConstantsUtil).CHAIN.EVM) {
                    const adapter = this.getAdapter((0, $gD0RX.ChainController).state.activeChain);
                    const provider = (0, $bCoR3.ProviderUtil).getProvider((0, $gD0RX.ChainController).state.activeChain);
                    const caipNetwork = this.getCaipNetwork();
                    if (!caipNetwork) throw new Error("CaipNetwork is undefined");
                    const result = await adapter?.estimateGas({
                        ...args,
                        provider: provider,
                        caipNetwork: caipNetwork
                    });
                    return result?.gas || 0n;
                }
                return 0n;
            },
            getEnsAvatar: async ()=>{
                await this.syncIdentity({
                    address: (0, $kfwQH.AccountController).state.address,
                    chainId: Number(this.getCaipNetwork()?.id),
                    chainNamespace: (0, $gD0RX.ChainController).state.activeChain
                });
                return (0, $kfwQH.AccountController).state.profileImage || false;
            },
            getEnsAddress: async (name)=>await (0, $6c592072e95901b7$export$4267940df2f33c5a).resolveReownName(name),
            writeContract: async (args)=>{
                const adapter = this.getAdapter((0, $gD0RX.ChainController).state.activeChain);
                const caipNetwork = this.getCaipNetwork();
                const caipAddress = this.getCaipAddress();
                const provider = (0, $bCoR3.ProviderUtil).getProvider((0, $gD0RX.ChainController).state.activeChain);
                if (!caipNetwork || !caipAddress) throw new Error("CaipNetwork or CaipAddress is undefined");
                const result = await adapter?.writeContract({
                    ...args,
                    caipNetwork: caipNetwork,
                    provider: provider,
                    caipAddress: caipAddress
                });
                return result?.hash;
            },
            parseUnits: (value, decimals)=>{
                const adapter = this.getAdapter((0, $gD0RX.ChainController).state.activeChain);
                return adapter?.parseUnits({
                    value: value,
                    decimals: decimals
                }) ?? 0n;
            },
            formatUnits: (value, decimals)=>{
                const adapter = this.getAdapter((0, $gD0RX.ChainController).state.activeChain);
                return adapter?.formatUnits({
                    value: value,
                    decimals: decimals
                }) ?? "0";
            },
            getCapabilities: async (params)=>{
                const adapter = this.getAdapter((0, $gD0RX.ChainController).state.activeChain);
                return await adapter?.getCapabilities(params);
            },
            grantPermissions: async (params)=>{
                const adapter = this.getAdapter((0, $gD0RX.ChainController).state.activeChain);
                return await adapter?.grantPermissions(params);
            },
            revokePermissions: async (params)=>{
                const adapter = this.getAdapter((0, $gD0RX.ChainController).state.activeChain);
                if (adapter?.revokePermissions) return await adapter.revokePermissions(params);
                return "0x";
            },
            walletGetAssets: async (params)=>{
                const adapter = this.getAdapter((0, $gD0RX.ChainController).state.activeChain);
                return await adapter?.walletGetAssets(params) ?? {};
            },
            updateBalance: (namespace)=>{
                const caipNetwork = this.getCaipNetwork(namespace);
                if (!caipNetwork || !(0, $kfwQH.AccountController).state.address) return;
                this.updateNativeBalance((0, $kfwQH.AccountController).state.address, caipNetwork?.id, namespace);
            }
        };
        this.networkControllerClient = {
            switchCaipNetwork: async (caipNetwork)=>await this.switchCaipNetwork(caipNetwork),
            // eslint-disable-next-line @typescript-eslint/require-await
            getApprovedCaipNetworksData: async ()=>this.getApprovedCaipNetworksData()
        };
        (0, $efZLi.ConnectionController).setClient(this.connectionControllerClient);
    }
    getApprovedCaipNetworksData() {
        const providerType = (0, $bCoR3.ProviderUtil).getProviderId((0, $gD0RX.ChainController).state.activeChain);
        if (providerType === (0, $5SSdQ.ConstantsUtil).CONNECTOR_TYPE_WALLET_CONNECT) {
            const namespaces = this.universalProvider?.session?.namespaces;
            return {
                /*
                 * MetaMask Wallet only returns 1 namespace in the session object. This makes it imposible
                 * to switch to other networks. Setting supportsAllNetworks to true for MetaMask Wallet
                 * will make it possible to switch to other networks.
                 */ supportsAllNetworks: this.universalProvider?.session?.peer?.metadata.name === "MetaMask Wallet",
                approvedCaipNetworkIds: this.getChainsFromNamespaces(namespaces)
            };
        }
        return {
            supportsAllNetworks: true,
            approvedCaipNetworkIds: []
        };
    }
    async switchCaipNetwork(caipNetwork) {
        if (!caipNetwork) return;
        const networkNamespace = caipNetwork.chainNamespace;
        const namespaceAddress = this.getAddressByChainNamespace(caipNetwork.chainNamespace);
        if (namespaceAddress) {
            const provider = (0, $bCoR3.ProviderUtil).getProvider(networkNamespace);
            const providerType = (0, $bCoR3.ProviderUtil).getProviderId(networkNamespace);
            if (caipNetwork.chainNamespace === (0, $gD0RX.ChainController).state.activeChain) {
                const adapter = this.getAdapter(networkNamespace);
                await adapter?.switchNetwork({
                    caipNetwork: caipNetwork,
                    provider: provider,
                    providerType: providerType
                });
            } else {
                this.setCaipNetwork(caipNetwork);
                if (providerType === (0, $5SSdQ.ConstantsUtil).CONNECTOR_TYPE_WALLET_CONNECT) this.syncWalletConnectAccount();
                else {
                    const address = this.getAddressByChainNamespace(networkNamespace);
                    if (address) this.syncAccount({
                        address: address,
                        chainId: caipNetwork.id,
                        chainNamespace: networkNamespace
                    });
                }
            }
        } else this.setCaipNetwork(caipNetwork);
    }
    getChainsFromNamespaces(namespaces = {}) {
        return Object.values(namespaces).flatMap((namespace)=>{
            const chains = namespace.chains || [];
            const accountsChains = namespace.accounts.map((account)=>{
                const { chainId: chainId, chainNamespace: chainNamespace } = (0, $6WAiR.ParseUtil).parseCaipAddress(account);
                return `${chainNamespace}:${chainId}`;
            });
            return Array.from(new Set([
                ...chains,
                ...accountsChains
            ]));
        });
    }
    // -- Adapter Initialization ---------------------------------------------------
    createAdapters(blueprints) {
        this.createClients();
        return this.chainNamespaces.reduce((adapters, namespace)=>{
            const blueprint = blueprints?.find((b)=>b.namespace === namespace);
            if (blueprint) {
                blueprint.construct({
                    namespace: namespace,
                    projectId: this.options?.projectId,
                    networks: this.getCaipNetworks()
                });
                adapters[namespace] = blueprint;
            } else adapters[namespace] = new (0, $e006d0b3ae4c2ce3$export$10ed1c0736be619c)({
                namespace: namespace,
                networks: this.getCaipNetworks()
            });
            return adapters;
        // eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter
        }, {});
    }
    async initChainAdapter(namespace) {
        this.onConnectors(namespace);
        this.listenAdapter(namespace);
        this.chainAdapters?.[namespace].syncConnectors(this.options, this);
        await this.createUniversalProviderForAdapter(namespace);
    }
    async initChainAdapters() {
        await Promise.all(this.chainNamespaces.map(async (namespace)=>{
            await this.initChainAdapter(namespace);
        }));
    }
    onConnectors(chainNamespace) {
        const adapter = this.getAdapter(chainNamespace);
        adapter?.on("connectors", this.setConnectors.bind(this));
    }
    listenAdapter(chainNamespace) {
        const adapter = this.getAdapter(chainNamespace);
        if (!adapter) return;
        const connectionStatus = (0, $bc5dy.StorageUtil).getConnectionStatus();
        if (connectionStatus === "connected") this.setStatus("connecting", chainNamespace);
        else if (connectionStatus === "disconnected") {
            /*
             * Address cache is kept after disconnecting from the wallet
             * but should be cleared if appkit is launched in disconnected state
             */ (0, $bc5dy.StorageUtil).clearAddressCache();
            this.setStatus(connectionStatus, chainNamespace);
        } else this.setStatus(connectionStatus, chainNamespace);
        adapter.on("switchNetwork", ({ address: address, chainId: chainId })=>{
            const caipNetwork = this.getCaipNetworks().find((n)=>n.id === chainId || n.caipNetworkId === chainId);
            const isSameNamespace = (0, $gD0RX.ChainController).state.activeChain === chainNamespace;
            const accountAddress = (0, $gD0RX.ChainController).getAccountProp("address", chainNamespace);
            if (caipNetwork) {
                const account = isSameNamespace && address ? address : accountAddress;
                if (account) this.syncAccount({
                    address: account,
                    chainId: caipNetwork.id,
                    chainNamespace: chainNamespace
                });
            } else this.setUnsupportedNetwork(chainId);
        });
        adapter.on("disconnect", this.disconnect.bind(this, chainNamespace));
        adapter.on("connections", (connections)=>{
            this.setConnections(connections, chainNamespace);
        });
        adapter.on("pendingTransactions", ()=>{
            const address = (0, $kfwQH.AccountController).state.address;
            const activeCaipNetwork = (0, $gD0RX.ChainController).state.activeCaipNetwork;
            if (!address || !activeCaipNetwork?.id) return;
            this.updateNativeBalance(address, activeCaipNetwork.id, activeCaipNetwork.chainNamespace);
        });
        adapter.on("accountChanged", ({ address: address, chainId: chainId })=>{
            const isActiveChain = (0, $gD0RX.ChainController).state.activeChain === chainNamespace;
            if (isActiveChain && chainId) this.syncAccount({
                address: address,
                chainId: chainId,
                chainNamespace: chainNamespace
            });
            else if (isActiveChain && (0, $gD0RX.ChainController).state.activeCaipNetwork?.id) this.syncAccount({
                address: address,
                chainId: (0, $gD0RX.ChainController).state.activeCaipNetwork?.id,
                chainNamespace: chainNamespace
            });
            else this.syncAccountInfo(address, chainId, chainNamespace);
            this.syncAllAccounts(chainNamespace);
        });
    }
    async createUniversalProviderForAdapter(chainNamespace) {
        await this.getUniversalProvider();
        if (this.universalProvider) this.chainAdapters?.[chainNamespace]?.setUniversalProvider?.(this.universalProvider);
    }
    // -- Connection Sync ---------------------------------------------------
    async syncExistingConnection() {
        await Promise.allSettled(this.chainNamespaces.map((namespace)=>this.syncNamespaceConnection(namespace)));
    }
    async syncNamespaceConnection(namespace) {
        try {
            const connectorId = (0, $58cAm.ConnectorController).getConnectorId(namespace);
            this.setStatus("connecting", namespace);
            switch(connectorId){
                case (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.WALLET_CONNECT:
                    await this.syncWalletConnectAccount();
                    break;
                case (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH:
                    break;
                default:
                    await this.syncAdapterConnection(namespace);
            }
        } catch (err) {
            console.warn("AppKit couldn't sync existing connection", err);
            this.setStatus("disconnected", namespace);
        }
    }
    async syncAdapterConnection(namespace) {
        const adapter = this.getAdapter(namespace);
        const connectorId = (0, $58cAm.ConnectorController).getConnectorId(namespace);
        const caipNetwork = this.getCaipNetwork(namespace);
        const connector = (0, $58cAm.ConnectorController).getConnectors(namespace).find((c)=>c.id === connectorId);
        try {
            if (!adapter || !connector) throw new Error(`Adapter or connector not found for namespace ${namespace}`);
            if (!caipNetwork?.id) throw new Error("CaipNetwork not found");
            const connection = await adapter?.syncConnection({
                namespace: namespace,
                id: connector.id,
                chainId: caipNetwork.id,
                rpcUrl: caipNetwork?.rpcUrls?.default?.http?.[0]
            });
            if (connection) {
                const accounts = await adapter?.getAccounts({
                    namespace: namespace,
                    id: connector.id
                });
                if (accounts && accounts.accounts.length > 0) this.setAllAccounts(accounts.accounts, namespace);
                else this.setAllAccounts([
                    (0, $lpmCO.CoreHelperUtil).createAccount(namespace, connection.address, "eoa")
                ], namespace);
                this.syncProvider({
                    ...connection,
                    chainNamespace: namespace
                });
                await this.syncAccount({
                    ...connection,
                    chainNamespace: namespace
                });
                this.setStatus("connected", namespace);
            } else this.setStatus("disconnected", namespace);
        } catch (e) {
            this.setStatus("disconnected", namespace);
        }
    }
    async syncWalletConnectAccount() {
        const syncTasks = this.chainNamespaces.map(async (chainNamespace)=>{
            const adapter = this.getAdapter(chainNamespace);
            const namespaceAccounts = this.universalProvider?.session?.namespaces?.[chainNamespace]?.accounts || [];
            // We try and find the address for this network in the session object.
            const activeChainId = (0, $gD0RX.ChainController).state.activeCaipNetwork?.id;
            const sessionAddress = namespaceAccounts.find((account)=>{
                const { chainId: chainId } = (0, $6WAiR.ParseUtil).parseCaipAddress(account);
                return chainId === activeChainId?.toString();
            }) || namespaceAccounts[0];
            if (sessionAddress) {
                const caipAddress = (0, $6WAiR.ParseUtil).validateCaipAddress(sessionAddress);
                const { chainId: chainId, address: address } = (0, $6WAiR.ParseUtil).parseCaipAddress(caipAddress);
                (0, $bCoR3.ProviderUtil).setProviderId(chainNamespace, (0, $5SSdQ.ConstantsUtil).CONNECTOR_TYPE_WALLET_CONNECT);
                if (this.caipNetworks && (0, $gD0RX.ChainController).state.activeCaipNetwork && adapter?.namespace !== (0, $b3v9s.ConstantsUtil).CHAIN.EVM) {
                    const provider = adapter?.getWalletConnectProvider({
                        caipNetworks: this.getCaipNetworks(),
                        provider: this.universalProvider,
                        activeCaipNetwork: (0, $gD0RX.ChainController).state.activeCaipNetwork
                    });
                    (0, $bCoR3.ProviderUtil).setProvider(chainNamespace, provider);
                } else (0, $bCoR3.ProviderUtil).setProvider(chainNamespace, this.universalProvider);
                (0, $58cAm.ConnectorController).setConnectorId((0, $b3v9s.ConstantsUtil).CONNECTOR_ID.WALLET_CONNECT, chainNamespace);
                (0, $bc5dy.StorageUtil).addConnectedNamespace(chainNamespace);
                this.syncWalletConnectAccounts(chainNamespace);
                await this.syncAccount({
                    address: address,
                    chainId: chainId,
                    chainNamespace: chainNamespace
                });
            } else this.setStatus("disconnected", chainNamespace);
            this.syncConnectedWalletInfo(chainNamespace);
            await (0, $gD0RX.ChainController).setApprovedCaipNetworksData(chainNamespace);
        });
        await Promise.all(syncTasks);
    }
    syncWalletConnectAccounts(chainNamespace) {
        const addresses = this.universalProvider?.session?.namespaces?.[chainNamespace]?.accounts?.map((account)=>{
            const { address: address } = (0, $6WAiR.ParseUtil).parseCaipAddress(account);
            return address;
        }).filter((address, index, self)=>self.indexOf(address) === index);
        if (addresses) this.setAllAccounts(addresses.map((address)=>(0, $lpmCO.CoreHelperUtil).createAccount(chainNamespace, address, chainNamespace === "bip122" ? "payment" : "eoa")), chainNamespace);
    }
    syncProvider({ type: type, provider: provider, id: id, chainNamespace: chainNamespace }) {
        (0, $bCoR3.ProviderUtil).setProviderId(chainNamespace, type);
        (0, $bCoR3.ProviderUtil).setProvider(chainNamespace, provider);
        (0, $58cAm.ConnectorController).setConnectorId(id, chainNamespace);
    }
    async syncAllAccounts(namespace) {
        const connectorId = (0, $58cAm.ConnectorController).getConnectorId(namespace);
        if (!connectorId) return;
        const adapter = this.getAdapter(namespace);
        const accounts = await adapter?.getAccounts({
            namespace: namespace,
            id: connectorId
        });
        if (accounts && accounts.accounts.length > 0) this.setAllAccounts(accounts.accounts, namespace);
    }
    async syncAccount(params) {
        const isActiveNamespace = params.chainNamespace === (0, $gD0RX.ChainController).state.activeChain;
        const networkOfChain = (0, $gD0RX.ChainController).getCaipNetworkByNamespace(params.chainNamespace, params.chainId);
        const { address: address, chainId: chainId, chainNamespace: chainNamespace } = params;
        const { chainId: activeChainId } = (0, $bc5dy.StorageUtil).getActiveNetworkProps();
        const chainIdToUse = chainId || activeChainId;
        const isUnsupportedNetwork = (0, $gD0RX.ChainController).state.activeCaipNetwork?.name === (0, $b3v9s.ConstantsUtil).UNSUPPORTED_NETWORK_NAME;
        const shouldSupportAllNetworks = (0, $gD0RX.ChainController).getNetworkProp("supportsAllNetworks", chainNamespace);
        this.setStatus("connected", chainNamespace);
        if (isUnsupportedNetwork && !shouldSupportAllNetworks) return;
        if (chainIdToUse) {
            let caipNetwork = this.getCaipNetworks().find((n)=>n.id.toString() === chainIdToUse.toString());
            let fallbackCaipNetwork = this.getCaipNetworks().find((n)=>n.chainNamespace === chainNamespace);
            // If doesn't support all networks, we need to use approved networks
            if (!shouldSupportAllNetworks && !caipNetwork && !fallbackCaipNetwork) {
                // Connection can be requested for a chain that is not supported by the wallet so we need to use approved networks here
                const caipNetworkIds = this.getApprovedCaipNetworkIds() || [];
                const caipNetworkId = caipNetworkIds.find((id)=>(0, $6WAiR.ParseUtil).parseCaipNetworkId(id)?.chainId === chainIdToUse.toString());
                const fallBackCaipNetworkId = caipNetworkIds.find((id)=>(0, $6WAiR.ParseUtil).parseCaipNetworkId(id)?.chainNamespace === chainNamespace);
                caipNetwork = this.getCaipNetworks().find((n)=>n.caipNetworkId === caipNetworkId);
                fallbackCaipNetwork = this.getCaipNetworks().find((n)=>n.caipNetworkId === fallBackCaipNetworkId || // This is a workaround used in Solana network to support deprecated caipNetworkId
                    "deprecatedCaipNetworkId" in n && n.deprecatedCaipNetworkId === fallBackCaipNetworkId);
            }
            const network = caipNetwork || fallbackCaipNetwork;
            if (network?.chainNamespace === (0, $gD0RX.ChainController).state.activeChain) {
                // If the network is unsupported and the user doesn't allow unsupported chains, we show the unsupported chain UI
                if ((0, $knC5d.OptionsController).state.enableNetworkSwitch && !(0, $knC5d.OptionsController).state.allowUnsupportedChain && (0, $gD0RX.ChainController).state.activeCaipNetwork?.name === (0, $b3v9s.ConstantsUtil).UNSUPPORTED_NETWORK_NAME) (0, $gD0RX.ChainController).showUnsupportedChainUI();
                else this.setCaipNetwork(network);
            } else if (!isActiveNamespace) {
                if (networkOfChain) this.setCaipNetworkOfNamespace(networkOfChain, chainNamespace);
            }
            this.syncConnectedWalletInfo(chainNamespace);
            if (!(0, $ePwaB.HelpersUtil).isLowerCaseMatch(address, (0, $kfwQH.AccountController).state.address)) this.syncAccountInfo(address, network?.id, chainNamespace);
            if (isActiveNamespace) await this.syncBalance({
                address: address,
                chainId: network?.id,
                chainNamespace: chainNamespace
            });
            else await this.syncBalance({
                address: address,
                chainId: networkOfChain?.id,
                chainNamespace: chainNamespace
            });
        }
    }
    async syncAccountInfo(address, chainId, chainNamespace) {
        const caipAddress = this.getCaipAddress(chainNamespace);
        const newChainId = chainId || caipAddress?.split(":")[1];
        if (!newChainId) return;
        const newCaipAddress = `${chainNamespace}:${newChainId}:${address}`;
        this.setCaipAddress(newCaipAddress, chainNamespace);
        await this.syncIdentity({
            address: address,
            chainId: newChainId,
            chainNamespace: chainNamespace
        });
    }
    async syncReownName(address, chainNamespace) {
        try {
            const registeredWcNames = await this.getReownName(address);
            if (registeredWcNames[0]) {
                const wcName = registeredWcNames[0];
                this.setProfileName(wcName.name, chainNamespace);
            } else this.setProfileName(null, chainNamespace);
        } catch  {
            this.setProfileName(null, chainNamespace);
        }
    }
    syncConnectedWalletInfo(chainNamespace) {
        const connectorId = (0, $58cAm.ConnectorController).getConnectorId(chainNamespace);
        const providerType = (0, $bCoR3.ProviderUtil).getProviderId(chainNamespace);
        if (providerType === (0, $5SSdQ.ConstantsUtil).CONNECTOR_TYPE_ANNOUNCED || providerType === (0, $5SSdQ.ConstantsUtil).CONNECTOR_TYPE_INJECTED) {
            if (connectorId) {
                const connector = this.getConnectors().find((c)=>c.id === connectorId);
                if (connector) {
                    const { info: info, name: name, imageUrl: imageUrl } = connector;
                    const icon = imageUrl || this.getConnectorImage(connector);
                    this.setConnectedWalletInfo({
                        name: name,
                        icon: icon,
                        ...info
                    }, chainNamespace);
                }
            }
        } else if (providerType === (0, $5SSdQ.ConstantsUtil).CONNECTOR_TYPE_WALLET_CONNECT) {
            const provider = (0, $bCoR3.ProviderUtil).getProvider(chainNamespace);
            if (provider?.session) this.setConnectedWalletInfo({
                ...provider.session.peer.metadata,
                name: provider.session.peer.metadata.name,
                icon: provider.session.peer.metadata.icons?.[0]
            }, chainNamespace);
        } else if (connectorId) {
            if (connectorId === (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.COINBASE) {
                const connector = this.getConnectors().find((c)=>c.id === (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.COINBASE);
                this.setConnectedWalletInfo({
                    name: "Coinbase Wallet",
                    icon: this.getConnectorImage(connector)
                }, chainNamespace);
            }
        }
    }
    async syncBalance(params) {
        const caipNetwork = (0, $dawjb.NetworkUtil).getNetworksByNamespace(this.getCaipNetworks(), params.chainNamespace).find((n)=>n.id.toString() === params.chainId?.toString());
        if (!caipNetwork || !params.chainId) return;
        await this.updateNativeBalance(params.address, params.chainId, params.chainNamespace);
    }
    async ready() {
        await this.readyPromise;
    }
    async updateNativeBalance(address, chainId, namespace) {
        const adapter = this.getAdapter(namespace);
        const caipNetwork = (0, $gD0RX.ChainController).getCaipNetworkByNamespace(namespace, chainId);
        if (adapter) {
            const balance = await adapter.getBalance({
                address: address,
                chainId: chainId,
                caipNetwork: caipNetwork,
                tokens: this.options.tokens
            });
            this.setBalance(balance.balance, balance.symbol, namespace);
            return balance;
        }
        return undefined;
    }
    // -- Universal Provider ---------------------------------------------------
    async initializeUniversalAdapter() {
        const logger = (0, $877ffcea83859f3f$export$1605cc4fc0ce8504).createLogger((error, ...args)=>{
            if (error) this.handleAlertError(error);
            // eslint-disable-next-line no-console
            console.error(...args);
        });
        const universalProviderOptions = {
            projectId: this.options?.projectId,
            metadata: {
                name: this.options?.metadata ? this.options?.metadata.name : "",
                description: this.options?.metadata ? this.options?.metadata.description : "",
                url: this.options?.metadata ? this.options?.metadata.url : "",
                icons: this.options?.metadata ? this.options?.metadata.icons : [
                    ""
                ]
            },
            logger: logger
        };
        (0, $knC5d.OptionsController).setManualWCControl(Boolean(this.options?.manualWCControl));
        this.universalProvider = this.options.universalProvider ?? await (0, $5ID99.default).init(universalProviderOptions);
        this.listenWalletConnect();
    }
    listenWalletConnect() {
        if (this.universalProvider) {
            this.universalProvider.on("display_uri", (uri)=>{
                (0, $efZLi.ConnectionController).setUri(uri);
            });
            this.universalProvider.on("connect", (0, $efZLi.ConnectionController).finalizeWcConnection);
            this.universalProvider.on("disconnect", ()=>{
                this.chainNamespaces.forEach((namespace)=>{
                    this.resetAccount(namespace);
                });
                (0, $efZLi.ConnectionController).resetWcConnection();
            });
            this.universalProvider.on("chainChanged", (chainId)=>{
                // eslint-disable-next-line eqeqeq
                const caipNetwork = this.getCaipNetworks().find((c)=>c.id == chainId);
                const currentCaipNetwork = this.getCaipNetwork();
                if (!caipNetwork) {
                    this.setUnsupportedNetwork(chainId);
                    return;
                }
                if (currentCaipNetwork?.id !== caipNetwork?.id) this.setCaipNetwork(caipNetwork);
            });
            this.universalProvider.on("session_event", (callbackData)=>{
                if ((0, $6c592072e95901b7$export$4267940df2f33c5a).isSessionEventData(callbackData)) {
                    const { name: name, data: data } = callbackData.params.event;
                    if (name === "accountsChanged" && Array.isArray(data) && (0, $lpmCO.CoreHelperUtil).isCaipAddress(data[0])) this.syncAccount((0, $6WAiR.ParseUtil).parseCaipAddress(data[0]));
                }
            });
        }
    }
    createUniversalProvider() {
        if (!this.universalProviderInitPromise && (0, $lpmCO.CoreHelperUtil).isClient() && this.options?.projectId) this.universalProviderInitPromise = this.initializeUniversalAdapter();
        return this.universalProviderInitPromise;
    }
    async getUniversalProvider() {
        if (!this.universalProvider) try {
            await this.createUniversalProvider();
        } catch (err) {
            (0, $5FNhR.EventsController).sendEvent({
                type: "error",
                event: "INTERNAL_SDK_ERROR",
                properties: {
                    errorType: "UniversalProviderInitError",
                    errorMessage: err instanceof Error ? err.message : "Unknown",
                    uncaught: false
                }
            });
            // eslint-disable-next-line no-console
            console.error("AppKit:getUniversalProvider - Cannot create provider", err);
        }
        return this.universalProvider;
    }
    // - Utils -------------------------------------------------------------------
    handleAlertError(error) {
        const matchedUniversalProviderError = Object.entries((0, $6rTj5.ErrorUtil).UniversalProviderErrors).find(([, { message: message }])=>error.message.includes(message));
        const [errorKey, errorValue] = matchedUniversalProviderError ?? [];
        const { message: message, alertErrorKey: alertErrorKey } = errorValue ?? {};
        if (errorKey && message && !this.reportedAlertErrors[errorKey]) {
            const alertError = (0, $6rTj5.ErrorUtil).ALERT_ERRORS[alertErrorKey];
            if (alertError) {
                (0, $5PQZs.AlertController).open(alertError, "error");
                this.reportedAlertErrors[errorKey] = true;
            }
        }
    }
    getAdapter(namespace) {
        if (!namespace) return undefined;
        return this.chainAdapters?.[namespace];
    }
    createAdapter(blueprint) {
        if (!blueprint) return;
        const namespace = blueprint.namespace;
        if (!namespace) return;
        this.createClients();
        const adapterBlueprint = blueprint;
        adapterBlueprint.namespace = namespace;
        adapterBlueprint.construct({
            namespace: namespace,
            projectId: this.options?.projectId,
            networks: this.getCaipNetworks()
        });
        if (!this.chainNamespaces.includes(namespace)) this.chainNamespaces.push(namespace);
        if (this.chainAdapters) this.chainAdapters[namespace] = adapterBlueprint;
    }
    // -- Public -------------------------------------------------------------------
    async open(options) {
        await this.injectModalUi();
        if (options?.uri) (0, $efZLi.ConnectionController).setUri(options.uri);
        if (options?.arguments) switch(options?.view){
            case "Swap":
                return (0, $6aBkR.ModalController).open({
                    ...options,
                    data: {
                        swap: options.arguments
                    }
                });
            default:
        }
        return (0, $6aBkR.ModalController).open(options);
    }
    async close() {
        await this.injectModalUi();
        (0, $6aBkR.ModalController).close();
    }
    setLoading(loading, namespace) {
        (0, $6aBkR.ModalController).setLoading(loading, namespace);
    }
    async disconnect(chainNamespace) {
        await (0, $efZLi.ConnectionController).disconnect(chainNamespace);
    }
    getSIWX() {
        return (0, $knC5d.OptionsController).state.siwx;
    }
    // -- review these -------------------------------------------------------------------
    getError() {
        return "";
    }
    getChainId() {
        return (0, $gD0RX.ChainController).state.activeCaipNetwork?.id;
    }
    async switchNetwork(appKitNetwork) {
        const network = this.getCaipNetworks().find((n)=>n.id === appKitNetwork.id);
        if (!network) {
            (0, $5PQZs.AlertController).open((0, $6rTj5.ErrorUtil).ALERT_ERRORS.SWITCH_NETWORK_NOT_FOUND, "error");
            return;
        }
        await (0, $gD0RX.ChainController).switchActiveNetwork(network);
    }
    getWalletProvider() {
        return (0, $gD0RX.ChainController).state.activeChain ? (0, $bCoR3.ProviderUtil).state.providers[(0, $gD0RX.ChainController).state.activeChain] : null;
    }
    getWalletProviderType() {
        return (0, $bCoR3.ProviderUtil).getProviderId((0, $gD0RX.ChainController).state.activeChain);
    }
    subscribeProviders(callback) {
        return (0, $bCoR3.ProviderUtil).subscribeProviders(callback);
    }
    getThemeMode() {
        return (0, $1VSgi.ThemeController).state.themeMode;
    }
    getThemeVariables() {
        return (0, $1VSgi.ThemeController).state.themeVariables;
    }
    setThemeMode(themeMode) {
        (0, $1VSgi.ThemeController).setThemeMode(themeMode);
        (0, $gqttf.setColorTheme)((0, $1VSgi.ThemeController).state.themeMode);
    }
    setTermsConditionsUrl(termsConditionsUrl) {
        (0, $knC5d.OptionsController).setTermsConditionsUrl(termsConditionsUrl);
    }
    setPrivacyPolicyUrl(privacyPolicyUrl) {
        (0, $knC5d.OptionsController).setPrivacyPolicyUrl(privacyPolicyUrl);
    }
    setThemeVariables(themeVariables) {
        (0, $1VSgi.ThemeController).setThemeVariables(themeVariables);
        (0, $gqttf.setThemeVariables)((0, $1VSgi.ThemeController).state.themeVariables);
    }
    subscribeTheme(callback) {
        return (0, $1VSgi.ThemeController).subscribe(callback);
    }
    getWalletInfo() {
        return (0, $kfwQH.AccountController).state.connectedWalletInfo;
    }
    getAccount(namespace) {
        const authConnector = (0, $58cAm.ConnectorController).getAuthConnector(namespace);
        const accountState = (0, $gD0RX.ChainController).getAccountData(namespace);
        const activeChain = (0, $gD0RX.ChainController).state.activeChain;
        const activeConnectorId = (0, $bc5dy.StorageUtil).getConnectedConnectorId(namespace);
        if (!accountState) return undefined;
        return {
            allAccounts: accountState.allAccounts,
            caipAddress: accountState.caipAddress,
            address: (0, $lpmCO.CoreHelperUtil).getPlainAddress(accountState.caipAddress),
            isConnected: Boolean(accountState.caipAddress),
            status: accountState.status,
            embeddedWalletInfo: authConnector && activeConnectorId === (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH ? {
                user: accountState.user ? {
                    ...accountState.user,
                    /*
                             * Getting the username from the chain controller works well for social logins,
                             * but Farcaster uses a different connection flow and doesn't emit the username via events.
                             * Since the username is stored in local storage before the chain controller updates,
                             * it's safe to use the local storage value here.
                             */ username: (0, $bc5dy.StorageUtil).getConnectedSocialUsername()
                } : undefined,
                authProvider: accountState.socialProvider || "email",
                accountType: accountState.preferredAccountTypes?.[namespace || activeChain],
                isSmartAccountDeployed: Boolean(accountState.smartAccountDeployed)
            } : undefined
        };
    }
    subscribeAccount(callback, namespace) {
        const updateVal = ()=>{
            const account = this.getAccount(namespace);
            if (!account) return;
            callback(account);
        };
        if (namespace) (0, $gD0RX.ChainController).subscribeChainProp("accountState", updateVal, namespace);
        else (0, $gD0RX.ChainController).subscribe(updateVal);
        (0, $58cAm.ConnectorController).subscribe(updateVal);
    }
    subscribeNetwork(callback) {
        return (0, $gD0RX.ChainController).subscribe(({ activeCaipNetwork: activeCaipNetwork })=>{
            callback({
                caipNetwork: activeCaipNetwork,
                chainId: activeCaipNetwork?.id,
                caipNetworkId: activeCaipNetwork?.caipNetworkId
            });
        });
    }
    subscribeWalletInfo(callback) {
        return (0, $kfwQH.AccountController).subscribeKey("connectedWalletInfo", callback);
    }
    subscribeShouldUpdateToAddress(callback) {
        (0, $kfwQH.AccountController).subscribeKey("shouldUpdateToAddress", callback);
    }
    subscribeCaipNetworkChange(callback) {
        (0, $gD0RX.ChainController).subscribeKey("activeCaipNetwork", callback);
    }
    getState() {
        return (0, $1dM5v.PublicStateController).state;
    }
    subscribeState(callback) {
        return (0, $1dM5v.PublicStateController).subscribe(callback);
    }
    showErrorMessage(message) {
        (0, $4hCRh.SnackController).showError(message);
    }
    showSuccessMessage(message) {
        (0, $4hCRh.SnackController).showSuccess(message);
    }
    getEvent() {
        return {
            ...(0, $5FNhR.EventsController).state
        };
    }
    subscribeEvents(callback) {
        return (0, $5FNhR.EventsController).subscribe(callback);
    }
    replace(route) {
        (0, $aZ8hw.RouterController).replace(route);
    }
    redirect(route) {
        (0, $aZ8hw.RouterController).push(route);
    }
    popTransactionStack(status) {
        (0, $aZ8hw.RouterController).popTransactionStack(status);
    }
    isOpen() {
        return (0, $6aBkR.ModalController).state.open;
    }
    isTransactionStackEmpty() {
        return (0, $aZ8hw.RouterController).state.transactionStack.length === 0;
    }
    static getInstance() {
        return this.instance;
    }
    updateFeatures(newFeatures) {
        (0, $knC5d.OptionsController).setFeatures(newFeatures);
    }
    updateRemoteFeatures(newRemoteFeatures) {
        (0, $knC5d.OptionsController).setRemoteFeatures(newRemoteFeatures);
    }
    updateOptions(newOptions) {
        const currentOptions = (0, $knC5d.OptionsController).state || {};
        const updatedOptions = {
            ...currentOptions,
            ...newOptions
        };
        (0, $knC5d.OptionsController).setOptions(updatedOptions);
    }
    setConnectMethodsOrder(connectMethodsOrder) {
        (0, $knC5d.OptionsController).setConnectMethodsOrder(connectMethodsOrder);
    }
    setWalletFeaturesOrder(walletFeaturesOrder) {
        (0, $knC5d.OptionsController).setWalletFeaturesOrder(walletFeaturesOrder);
    }
    setCollapseWallets(collapseWallets) {
        (0, $knC5d.OptionsController).setCollapseWallets(collapseWallets);
    }
    setSocialsOrder(socialsOrder) {
        (0, $knC5d.OptionsController).setSocialsOrder(socialsOrder);
    }
    getConnectMethodsOrder() {
        return (0, $lDgVc.WalletUtil).getConnectOrderMethod((0, $knC5d.OptionsController).state.features, (0, $58cAm.ConnectorController).getConnectors());
    }
    /**
     * Adds a network to an existing adapter in AppKit.
     * @param namespace - The chain namespace to add the network to (e.g. 'eip155', 'solana')
     * @param network - The network configuration to add
     * @throws Error if adapter for namespace doesn't exist
     */ addNetwork(namespace, network) {
        if (this.chainAdapters && !this.chainAdapters[namespace]) throw new Error(`Adapter for namespace ${namespace} doesn't exist`);
        const extendedNetwork = this.extendCaipNetwork(network, this.options);
        if (!this.getCaipNetworks().find((n)=>n.id === extendedNetwork.id)) (0, $gD0RX.ChainController).addNetwork(extendedNetwork);
    }
    /**
     * Removes a network from an existing adapter in AppKit.
     * @param namespace - The chain namespace the network belongs to
     * @param networkId - The network ID to remove
     * @throws Error if adapter for namespace doesn't exist or if removing last network
     */ removeNetwork(namespace, networkId) {
        if (this.chainAdapters && !this.chainAdapters[namespace]) throw new Error(`Adapter for namespace ${namespace} doesn't exist`);
        const networkToRemove = this.getCaipNetworks().find((n)=>n.id === networkId);
        if (!networkToRemove) return;
        (0, $gD0RX.ChainController).removeNetwork(namespace, networkId);
    }
}


// -- Helpers -------------------------------------------------------------------
let $fd3886b08403045a$var$isInitialized = false;











class $fd3886b08403045a$export$fc94c40ea502fa4c extends (0, $481119b7501ec63c$export$4586931bc94dcec5) {
    // -- Private ------------------------------------------------------------------
    setupAuthConnectorListeners(provider) {
        provider.onRpcRequest((request)=>{
            if ((0, $5nPZz.W3mFrameHelpers).checkIfRequestExists(request)) {
                if (!(0, $5nPZz.W3mFrameHelpers).checkIfRequestIsSafe(request)) this.handleUnsafeRPCRequest();
            } else {
                this.open();
                // eslint-disable-next-line no-console
                console.error((0, $034Ac.W3mFrameRpcConstants).RPC_METHOD_NOT_ALLOWED_MESSAGE, {
                    method: request.method
                });
                setTimeout(()=>{
                    this.showErrorMessage((0, $034Ac.W3mFrameRpcConstants).RPC_METHOD_NOT_ALLOWED_UI_MESSAGE);
                }, 300);
                provider.rejectRpcRequests();
            }
        });
        provider.onRpcError(()=>{
            const isModalOpen = this.isOpen();
            if (isModalOpen) {
                if (this.isTransactionStackEmpty()) this.close();
                else this.popTransactionStack("error");
            }
        });
        provider.onRpcSuccess((_, request)=>{
            const isSafeRequest = (0, $5nPZz.W3mFrameHelpers).checkIfRequestIsSafe(request);
            const address = (0, $kfwQH.AccountController).state.address;
            const caipNetwork = (0, $gD0RX.ChainController).state.activeCaipNetwork;
            if (isSafeRequest) return;
            if (address && caipNetwork?.id) this.updateNativeBalance(address, caipNetwork.id, caipNetwork.chainNamespace);
            if (this.isTransactionStackEmpty()) this.close();
            else this.popTransactionStack("success");
        });
        provider.onNotConnected(()=>{
            const namespace = (0, $gD0RX.ChainController).state.activeChain;
            const connectorId = (0, $58cAm.ConnectorController).getConnectorId(namespace);
            const isConnectedWithAuth = connectorId === (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH;
            if (isConnectedWithAuth) {
                this.setCaipAddress(undefined, namespace);
                this.setLoading(false, namespace);
            }
        });
        provider.onConnect((user)=>{
            const namespace = (0, $gD0RX.ChainController).state.activeChain;
            // To keep backwards compatibility, eip155 chainIds are numbers and not actual caipChainIds
            const caipAddress = namespace === (0, $b3v9s.ConstantsUtil).CHAIN.EVM ? `eip155:${user.chainId}:${user.address}` : `${user.chainId}:${user.address}`;
            const defaultAccountType = (0, $knC5d.OptionsController).state.defaultAccountTypes[namespace];
            const currentAccountType = (0, $kfwQH.AccountController).state.preferredAccountTypes?.[namespace];
            const preferredAccountType = user.preferredAccountType || currentAccountType || defaultAccountType;
            /*
             * This covers the case where user switches back from a smart account supported
             *  network to a non-smart account supported network resulting in a different address
             */ if (!(0, $ePwaB.HelpersUtil).isLowerCaseMatch(user.address, (0, $kfwQH.AccountController).state.address)) this.syncIdentity({
                address: user.address,
                chainId: user.chainId,
                chainNamespace: namespace
            });
            this.setCaipAddress(caipAddress, namespace);
            this.setUser({
                ...(0, $kfwQH.AccountController).state.user || {},
                ...user
            }, namespace);
            this.setSmartAccountDeployed(Boolean(user.smartAccountDeployed), namespace);
            this.setPreferredAccountType(preferredAccountType, namespace);
            const userAccounts = user.accounts?.map((account)=>(0, $lpmCO.CoreHelperUtil).createAccount(namespace, account.address, account.type || currentAccountType || defaultAccountType));
            this.setAllAccounts(userAccounts || [
                (0, $lpmCO.CoreHelperUtil).createAccount(namespace, user.address, user.preferredAccountType || preferredAccountType)
            ], namespace);
            this.setLoading(false, namespace);
        });
        provider.onSocialConnected(({ userName: userName })=>{
            this.setUser({
                ...(0, $kfwQH.AccountController).state.user || {},
                username: userName
            }, (0, $gD0RX.ChainController).state.activeChain);
        });
        provider.onGetSmartAccountEnabledNetworks((networks)=>{
            this.setSmartAccountEnabledNetworks(networks, (0, $gD0RX.ChainController).state.activeChain);
        });
        provider.onSetPreferredAccount(({ address: address, type: type })=>{
            if (!address) return;
            this.setPreferredAccountType(type, (0, $gD0RX.ChainController).state.activeChain);
        });
    }
    async syncAuthConnector(provider, chainNamespace) {
        const isAuthSupported = (0, $b3v9s.ConstantsUtil).AUTH_CONNECTOR_SUPPORTED_CHAINS.includes(chainNamespace);
        if (!isAuthSupported) return;
        this.setLoading(true, chainNamespace);
        const isLoginEmailUsed = provider.getLoginEmailUsed();
        this.setLoading(isLoginEmailUsed, chainNamespace);
        if (isLoginEmailUsed) this.setStatus("connecting", chainNamespace);
        const email = provider.getEmail();
        const username = provider.getUsername();
        this.setUser({
            ...(0, $kfwQH.AccountController).state?.user || {},
            username: username,
            email: email
        }, (0, $gD0RX.ChainController).state.activeChain);
        this.setupAuthConnectorListeners(provider);
        const { isConnected: isConnected } = await provider.isConnected();
        const theme = (0, $1VSgi.ThemeController).getSnapshot();
        const options = (0, $knC5d.OptionsController).getSnapshot();
        await Promise.all([
            provider.syncDappData({
                metadata: options.metadata,
                sdkVersion: options.sdkVersion,
                projectId: options.projectId,
                sdkType: options.sdkType
            }),
            provider.syncTheme({
                themeMode: theme.themeMode,
                themeVariables: theme.themeVariables,
                w3mThemeVariables: (0, $2Z0OY.getW3mThemeVariables)(theme.themeVariables, theme.themeMode)
            })
        ]);
        await provider.getSmartAccountEnabledNetworks();
        if (chainNamespace && isAuthSupported) {
            if (isConnected && this.connectionControllerClient?.connectExternal) {
                await this.connectionControllerClient?.connectExternal({
                    id: (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH,
                    info: {
                        name: (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH
                    },
                    type: (0, $5SSdQ.ConstantsUtil).CONNECTOR_TYPE_AUTH,
                    provider: provider,
                    chainId: (0, $gD0RX.ChainController).state.activeCaipNetwork?.id,
                    chain: chainNamespace
                });
                this.setStatus("connected", chainNamespace);
            } else if ((0, $58cAm.ConnectorController).getConnectorId(chainNamespace) === (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH) {
                this.setStatus("disconnected", chainNamespace);
                (0, $bc5dy.StorageUtil).removeConnectedNamespace(chainNamespace);
            }
        }
        this.setLoading(false, chainNamespace);
    }
    async checkExistingTelegramSocialConnection(chainNamespace) {
        try {
            if (!(0, $lpmCO.CoreHelperUtil).isTelegram()) return;
            const socialProviderToConnect = (0, $bc5dy.StorageUtil).getTelegramSocialProvider();
            if (!socialProviderToConnect) return;
            if (!(0, $lpmCO.CoreHelperUtil).isClient()) return;
            const url = new URL(window.location.href);
            const resultUri = url.searchParams.get("result_uri");
            if (!resultUri) return;
            (0, $kfwQH.AccountController).setSocialProvider(socialProviderToConnect, chainNamespace);
            await this.authProvider?.init();
            const authConnector = (0, $58cAm.ConnectorController).getAuthConnector();
            if (socialProviderToConnect && authConnector) {
                this.setLoading(true, chainNamespace);
                await (0, $efZLi.ConnectionController).connectExternal({
                    id: authConnector.id,
                    type: authConnector.type,
                    socialUri: resultUri
                }, authConnector.chain);
                (0, $bc5dy.StorageUtil).setConnectedSocialProvider(socialProviderToConnect);
                (0, $bc5dy.StorageUtil).removeTelegramSocialProvider();
                (0, $5FNhR.EventsController).sendEvent({
                    type: "track",
                    event: "SOCIAL_LOGIN_SUCCESS",
                    properties: {
                        provider: socialProviderToConnect
                    }
                });
            }
        } catch (error) {
            this.setLoading(false, chainNamespace);
            // eslint-disable-next-line no-console
            console.error("checkExistingSTelegramocialConnection error", error);
        }
        try {
            const url = new URL(window.location.href);
            // Remove the 'result_uri' parameter
            url.searchParams.delete("result_uri");
            // Update the URL without reloading the page
            window.history.replaceState({}, document.title, url.toString());
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error("tma social login failed", error);
        }
    }
    createAuthProvider(chainNamespace) {
        const isSupported = (0, $b3v9s.ConstantsUtil).AUTH_CONNECTOR_SUPPORTED_CHAINS.includes(chainNamespace);
        if (!isSupported) return;
        const isEmailEnabled = this.remoteFeatures?.email;
        const isSocialsEnabled = Array.isArray(this.remoteFeatures?.socials) && this.remoteFeatures.socials.length > 0;
        const isAuthEnabled = isEmailEnabled || isSocialsEnabled;
        if (!this.authProvider && this.options?.projectId && isAuthEnabled) {
            this.authProvider = (0, $52cf67d5bf1c16df$export$a0344615582d8da3).getInstance({
                projectId: this.options.projectId,
                enableLogger: this.options.enableAuthLogger,
                chainId: this.getCaipNetwork(chainNamespace)?.caipNetworkId,
                abortController: (0, $6rTj5.ErrorUtil).EmbeddedWalletAbortController,
                onTimeout: (reason)=>{
                    if (reason === "iframe_load_failed") (0, $5PQZs.AlertController).open((0, $6rTj5.ErrorUtil).ALERT_ERRORS.IFRAME_LOAD_FAILED, "error");
                    else if (reason === "iframe_request_timeout") (0, $5PQZs.AlertController).open((0, $6rTj5.ErrorUtil).ALERT_ERRORS.IFRAME_REQUEST_TIMEOUT, "error");
                    else if (reason === "unverified_domain") (0, $5PQZs.AlertController).open((0, $6rTj5.ErrorUtil).ALERT_ERRORS.UNVERIFIED_DOMAIN, "error");
                }
            });
            (0, $1dM5v.PublicStateController).subscribeOpen((isOpen)=>{
                if (!isOpen && this.isTransactionStackEmpty()) this.authProvider?.rejectRpcRequests();
            });
            this.syncAuthConnector(this.authProvider, chainNamespace);
            this.checkExistingTelegramSocialConnection(chainNamespace);
        }
    }
    createAuthProviderForAdapter(chainNamespace) {
        // Override as we need to set authProvider for each adapter
        this.createAuthProvider(chainNamespace);
        if (this.authProvider) this.chainAdapters?.[chainNamespace]?.setAuthProvider?.(this.authProvider);
    }
    // -- Overrides ----------------------------------------------------------------
    initControllers(options) {
        super.initControllers(options);
        if (this.options.excludeWalletIds) (0, $g9yWp.ApiController).initializeExcludedWallets({
            ids: this.options.excludeWalletIds
        });
    }
    async switchCaipNetwork(caipNetwork) {
        if (!caipNetwork) return;
        const currentNamespace = (0, $gD0RX.ChainController).state.activeChain;
        const networkNamespace = caipNetwork.chainNamespace;
        const namespaceAddress = this.getAddressByChainNamespace(networkNamespace);
        const isSameNamespace = networkNamespace === currentNamespace;
        if (isSameNamespace && namespaceAddress) {
            const adapter = this.getAdapter(networkNamespace);
            const provider = (0, $bCoR3.ProviderUtil).getProvider(networkNamespace);
            const providerType = (0, $bCoR3.ProviderUtil).getProviderId(networkNamespace);
            await adapter?.switchNetwork({
                caipNetwork: caipNetwork,
                provider: provider,
                providerType: providerType
            });
            this.setCaipNetwork(caipNetwork);
        } else {
            const currentNamespaceProviderType = (0, $bCoR3.ProviderUtil).getProviderId(currentNamespace);
            const isCurrentNamespaceAuthProvider = currentNamespaceProviderType === (0, $5SSdQ.ConstantsUtil).CONNECTOR_TYPE_AUTH;
            const newNamespaceProviderType = (0, $bCoR3.ProviderUtil).getProviderId(networkNamespace);
            const isNewNamespaceAuthProvider = newNamespaceProviderType === (0, $5SSdQ.ConstantsUtil).CONNECTOR_TYPE_AUTH;
            const isNewNamespaceSupportsAuthConnector = (0, $b3v9s.ConstantsUtil).AUTH_CONNECTOR_SUPPORTED_CHAINS.includes(networkNamespace);
            /*
             * Only connect with the auth connector if:
             * 1. The current namespace is an auth connector AND
             *    the new namespace provider type is undefined
             * OR
             * 2. The new namespace provider type is auth connector AND
             *    the new namespace supports auth connector
             *
             * Note: There are cases where the current namespace is an auth connector
             * but the new namespace uses a different connector type (injected, walletconnect, etc).
             * In those cases, we should not connect with the auth connector.
             */ if ((isCurrentNamespaceAuthProvider && newNamespaceProviderType === undefined || isNewNamespaceAuthProvider) && isNewNamespaceSupportsAuthConnector) try {
                (0, $gD0RX.ChainController).state.activeChain = caipNetwork.chainNamespace;
                if (namespaceAddress) {
                    const adapter = this.getAdapter(networkNamespace);
                    await adapter?.switchNetwork({
                        caipNetwork: caipNetwork,
                        provider: this.authProvider,
                        providerType: newNamespaceProviderType
                    });
                } else await this.connectionControllerClient?.connectExternal?.({
                    id: (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH,
                    provider: this.authProvider,
                    chain: networkNamespace,
                    chainId: caipNetwork.id,
                    type: (0, $5SSdQ.ConstantsUtil).CONNECTOR_TYPE_AUTH,
                    caipNetwork: caipNetwork
                });
                this.setCaipNetwork(caipNetwork);
            } catch (error) {
                const adapter = this.getAdapter(networkNamespace);
                await adapter?.switchNetwork({
                    caipNetwork: caipNetwork,
                    provider: this.authProvider,
                    providerType: newNamespaceProviderType
                });
            }
            else if (newNamespaceProviderType === (0, $5SSdQ.ConstantsUtil).CONNECTOR_TYPE_WALLET_CONNECT) {
                this.setCaipNetwork(caipNetwork);
                this.syncWalletConnectAccount();
            } else {
                this.setCaipNetwork(caipNetwork);
                if (namespaceAddress) this.syncAccount({
                    address: namespaceAddress,
                    chainId: caipNetwork.id,
                    chainNamespace: networkNamespace
                });
            }
        }
    }
    async initialize(options) {
        await super.initialize(options);
        this.chainNamespaces?.forEach((namespace)=>{
            this.createAuthProviderForAdapter(namespace);
            this.chainAdapters?.[namespace].syncConnectors(this.options, this);
        });
        await this.injectModalUi();
        (0, $1dM5v.PublicStateController).set({
            initialized: true
        });
    }
    async syncIdentity({ address: address, chainId: chainId, chainNamespace: chainNamespace }) {
        const caipNetworkId = `${chainNamespace}:${chainId}`;
        const activeCaipNetwork = this.caipNetworks?.find((n)=>n.caipNetworkId === caipNetworkId);
        if (chainNamespace !== (0, $b3v9s.ConstantsUtil).CHAIN.EVM || activeCaipNetwork?.testnet) {
            this.setProfileName(null, chainNamespace);
            this.setProfileImage(null, chainNamespace);
            return;
        }
        try {
            const { name: name, avatar: avatar } = await this.fetchIdentity({
                address: address,
                caipNetworkId: caipNetworkId
            });
            this.setProfileName(name, chainNamespace);
            this.setProfileImage(avatar, chainNamespace);
        } catch  {
            await this.syncReownName(address, chainNamespace);
            if (chainId !== 1) this.setProfileImage(null, chainNamespace);
        }
    }
    syncConnectedWalletInfo(chainNamespace) {
        const providerType = (0, $bCoR3.ProviderUtil).getProviderId(chainNamespace);
        if (providerType === (0, $5SSdQ.ConstantsUtil).CONNECTOR_TYPE_AUTH) {
            const provider = this.authProvider;
            if (provider) {
                const social = (0, $bc5dy.StorageUtil).getConnectedSocialProvider() ?? "email";
                const identifier = provider.getEmail() ?? provider.getUsername();
                this.setConnectedWalletInfo({
                    name: providerType,
                    identifier: identifier,
                    social: social
                }, chainNamespace);
            }
        } else super.syncConnectedWalletInfo(chainNamespace);
    }
    async injectModalUi() {
        // Skip entirely in non-browser environments - ensures proper tree-shaking during build
        if (!(0, $lpmCO.CoreHelperUtil).isClient()) return;
        if (!$fd3886b08403045a$var$isInitialized) try {
            const features = {
                ...(0, $3h0dG.ConstantsUtil).DEFAULT_FEATURES,
                ...this.options.features
            };
            const remoteFeatures = this.remoteFeatures;
            // Use a factory function that will be properly tree-shaken in SSR builds
            await this.loadModalComponents(features, remoteFeatures);
            // Always check again in case environment changed during async operations
            if ((0, $lpmCO.CoreHelperUtil).isClient()) {
                const isElementCreated = document.querySelector("w3m-modal");
                if (!isElementCreated) {
                    const modal = document.createElement("w3m-modal");
                    if (!(0, $knC5d.OptionsController).state.disableAppend && !(0, $knC5d.OptionsController).state.enableEmbedded) document.body.insertAdjacentElement("beforeend", modal);
                }
            }
            $fd3886b08403045a$var$isInitialized = true;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error("Error injecting modal UI:", error);
        }
    }
    // This separate method helps with tree-shaking for SSR builds
    async loadModalComponents(features, remoteFeatures) {
        // Early explicit check forces bundlers to exclude this code in SSR builds
        if (!(0, $lpmCO.CoreHelperUtil).isClient()) return;
        const featureImportPromises = [];
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        const usingEmbeddedWallet = remoteFeatures.email || remoteFeatures.socials && remoteFeatures.socials.length > 0;
        if (usingEmbeddedWallet) featureImportPromises.push((parcelRequire("6LDR0")));
        if (remoteFeatures.email) featureImportPromises.push((parcelRequire("5AOtn")));
        if (remoteFeatures.socials) featureImportPromises.push((parcelRequire("bBR0C")));
        if (remoteFeatures.swaps && remoteFeatures.swaps.length > 0) featureImportPromises.push((parcelRequire("5pl4x")));
        if (features.send) featureImportPromises.push((parcelRequire("3cUZu")));
        if (features.receive) featureImportPromises.push((parcelRequire("03SUl")));
        if (remoteFeatures.onramp && remoteFeatures.onramp.length > 0) featureImportPromises.push((parcelRequire("2Oo5D")));
        if (remoteFeatures.activity) featureImportPromises.push((parcelRequire("kdAAl")));
        if (features.pay) featureImportPromises.push((parcelRequire("cANvU")));
        await Promise.all([
            ...featureImportPromises,
            (parcelRequire("5jIRQ")),
            (parcelRequire("aL8PV"))
        ]);
    }
}



var $tZqWC = parcelRequire("tZqWC");


var $bCoR3 = parcelRequire("bCoR3");

let $02b65957f7a9bfcc$var$modal = undefined;
function $02b65957f7a9bfcc$export$577b3f669454857(appKit) {
    if (appKit) $02b65957f7a9bfcc$var$modal = appKit;
}
function $02b65957f7a9bfcc$export$7efbc9b78cd6e553(chainNamespace) {
    const { providers: providers, providerIds: providerIds } = (0, $a47f529d25029b45$export$12201ede76c4c5e1)((0, $bCoR3.ProviderUtil).state);
    const walletProvider = providers[chainNamespace];
    const walletProviderType = providerIds[chainNamespace];
    return {
        walletProvider: walletProvider,
        walletProviderType: walletProviderType
    };
}
function $02b65957f7a9bfcc$export$fc5b87987d6f5bd() {
    if (!$02b65957f7a9bfcc$var$modal) throw new Error('Please call "createAppKit" before using "useAppKitTheme" hook');
    function setThemeMode(themeMode) {
        if (themeMode) $02b65957f7a9bfcc$var$modal?.setThemeMode(themeMode);
    }
    function setThemeVariables(themeVariables) {
        if (themeVariables) $02b65957f7a9bfcc$var$modal?.setThemeVariables(themeVariables);
    }
    const [themeMode, setInternalThemeMode] = (0, $tZqWC.useState)($02b65957f7a9bfcc$var$modal.getThemeMode());
    const [themeVariables, setInternalThemeVariables] = (0, $tZqWC.useState)($02b65957f7a9bfcc$var$modal.getThemeVariables());
    (0, $tZqWC.useEffect)(()=>{
        const unsubscribe = $02b65957f7a9bfcc$var$modal?.subscribeTheme((state)=>{
            setInternalThemeMode(state.themeMode);
            setInternalThemeVariables(state.themeVariables);
        });
        return ()=>{
            unsubscribe?.();
        };
    }, []);
    return {
        themeMode: themeMode,
        themeVariables: themeVariables,
        setThemeMode: setThemeMode,
        setThemeVariables: setThemeVariables
    };
}
function $02b65957f7a9bfcc$export$6c4cc75441b14b9() {
    if (!$02b65957f7a9bfcc$var$modal) throw new Error('Please call "createAppKit" before using "useAppKit" hook');
    async function open(options) {
        await $02b65957f7a9bfcc$var$modal?.open(options);
    }
    async function close() {
        await $02b65957f7a9bfcc$var$modal?.close();
    }
    return {
        open: open,
        close: close
    };
}
function $02b65957f7a9bfcc$export$eeb8ee10880c5bf1() {
    if (!$02b65957f7a9bfcc$var$modal) throw new Error('Please call "createAppKit" before using "useWalletInfo" hook');
    const walletInfo = (0, $tZqWC.useSyncExternalStore)($02b65957f7a9bfcc$var$modal.subscribeWalletInfo, $02b65957f7a9bfcc$var$modal.getWalletInfo, $02b65957f7a9bfcc$var$modal.getWalletInfo);
    return {
        walletInfo: walletInfo
    };
}
function $02b65957f7a9bfcc$export$d8d3808c2f4e61b6() {
    if (!$02b65957f7a9bfcc$var$modal) throw new Error('Please call "createAppKit" before using "useAppKitState" hook');
    const [state, setState] = (0, $tZqWC.useState)({
        ...$02b65957f7a9bfcc$var$modal.getState(),
        initialized: false
    });
    (0, $tZqWC.useEffect)(()=>{
        if ($02b65957f7a9bfcc$var$modal) {
            setState({
                ...$02b65957f7a9bfcc$var$modal.getState()
            });
            const unsubscribe = $02b65957f7a9bfcc$var$modal?.subscribeState((newState)=>{
                setState({
                    ...newState
                });
            });
            return ()=>{
                unsubscribe?.();
            };
        }
        return ()=>null;
    }, []);
    return state;
}
function $02b65957f7a9bfcc$export$82a0e63f0c719443() {
    if (!$02b65957f7a9bfcc$var$modal) throw new Error('Please call "createAppKit" before using "useAppKitEvents" hook');
    const [event, setEvents] = (0, $tZqWC.useState)($02b65957f7a9bfcc$var$modal.getEvent());
    (0, $tZqWC.useEffect)(()=>{
        const unsubscribe = $02b65957f7a9bfcc$var$modal?.subscribeEvents((newEvent)=>{
            setEvents({
                ...newEvent
            });
        });
        return ()=>{
            unsubscribe?.();
        };
    }, []);
    return event;
}


// Unified method for fetching balance for vue/react
async function $e0667cf9ab6c3e32$export$755cbcf1ab0d4cfa(appKit) {
    if (!appKit) throw new Error("AppKit not initialized when  fetchBalance was called.");
    return await $e0667cf9ab6c3e32$export$f3230d91d3cd4a8b(appKit);
}
async function $e0667cf9ab6c3e32$export$f3230d91d3cd4a8b(appKit) {
    const address = appKit.getAddress();
    const chainNamespace = appKit.getActiveChainNamespace();
    const chainId = appKit.getCaipNetwork()?.id;
    if (!address || !chainNamespace || !chainId) return {
        data: undefined,
        error: "Not able to retrieve balance",
        isSuccess: false,
        isError: true
    };
    const balance = await appKit.updateNativeBalance(address, chainId, chainNamespace);
    return {
        data: balance,
        error: balance ? null : "No balance found",
        isSuccess: Boolean(balance),
        isError: !balance
    };
}


const $fcb2c6c83776f4b4$export$4a03ffab3315ee34 = "1.7.7";



let $43581e8bfc4231fd$export$96e4b36520c26a2c = undefined;
function $43581e8bfc4231fd$export$805fba51c5f25785(options) {
    if (!$43581e8bfc4231fd$export$96e4b36520c26a2c) {
        $43581e8bfc4231fd$export$96e4b36520c26a2c = new (0, $fd3886b08403045a$export$fc94c40ea502fa4c)({
            ...options,
            sdkVersion: (0, $lpmCO.CoreHelperUtil).generateSdkVersion(options.adapters ?? [], "react", (0, $fcb2c6c83776f4b4$export$4a03ffab3315ee34))
        });
        (0, $02b65957f7a9bfcc$export$577b3f669454857)($43581e8bfc4231fd$export$96e4b36520c26a2c);
    }
    return $43581e8bfc4231fd$export$96e4b36520c26a2c;
}
function $43581e8bfc4231fd$export$d6b48111a3ec7b16() {
    const { caipNetwork: caipNetwork, caipNetworkId: caipNetworkId, chainId: chainId } = (0, $2b5a8e9ff96f5bfb$export$5c775cffc88d83ea)();
    function switchNetwork(network) {
        $43581e8bfc4231fd$export$96e4b36520c26a2c?.switchNetwork(network);
    }
    return {
        caipNetwork: caipNetwork,
        caipNetworkId: caipNetworkId,
        chainId: chainId,
        switchNetwork: switchNetwork
    };
}
function $43581e8bfc4231fd$export$b2aae725c45edb80() {
    async function fetchBalance() {
        return await (0, $e0667cf9ab6c3e32$export$755cbcf1ab0d4cfa)($43581e8bfc4231fd$export$96e4b36520c26a2c);
    }
    return {
        fetchBalance: fetchBalance
    };
}



var $tZqWC = parcelRequire("tZqWC");
let $130ca6b4c79955ed$var$isReconnecting = false;
async function $130ca6b4c79955ed$export$f0e7018a430fa792(config, parameters = {}) {
    // If already reconnecting, do nothing
    if ($130ca6b4c79955ed$var$isReconnecting) return [];
    $130ca6b4c79955ed$var$isReconnecting = true;
    config.setState((x)=>({
            ...x,
            status: x.current ? "reconnecting" : "connecting"
        }));
    const connectors = [];
    if (parameters.connectors?.length) for (const connector_ of parameters.connectors){
        let connector;
        // "Register" connector if not already created
        if (typeof connector_ === "function") connector = config._internal.connectors.setup(connector_);
        else connector = connector_;
        connectors.push(connector);
    }
    else connectors.push(...config.connectors);
    // Try recently-used connectors first
    let recentConnectorId;
    try {
        recentConnectorId = await config.storage?.getItem("recentConnectorId");
    } catch  {}
    const scores = {};
    for (const [, connection] of config.state.connections)scores[connection.connector.id] = 1;
    if (recentConnectorId) scores[recentConnectorId] = 0;
    const sorted = Object.keys(scores).length > 0 ? [
        ...connectors
    ].sort((a, b)=>(scores[a.id] ?? 10) - (scores[b.id] ?? 10)) : connectors;
    // Iterate through each connector and try to connect
    let connected = false;
    const connections = [];
    const providers = [];
    for (const connector of sorted){
        const provider = await connector.getProvider().catch(()=>undefined);
        if (!provider) continue;
        // If we already have an instance of this connector's provider,
        // then we have already checked it (ie. injected connectors can
        // share the same `window.ethereum` instance, so we don't want to
        // connect to it again).
        if (providers.some((x)=>x === provider)) continue;
        const isAuthorized = await connector.isAuthorized();
        if (!isAuthorized) continue;
        const data = await connector.connect({
            isReconnecting: true
        }).catch(()=>null);
        if (!data) continue;
        connector.emitter.off("connect", config._internal.events.connect);
        connector.emitter.on("change", config._internal.events.change);
        connector.emitter.on("disconnect", config._internal.events.disconnect);
        config.setState((x)=>{
            const connections = new Map(connected ? x.connections : new Map()).set(connector.uid, {
                accounts: data.accounts,
                chainId: data.chainId,
                connector: connector
            });
            return {
                ...x,
                current: connected ? x.current : connector.uid,
                connections: connections
            };
        });
        connections.push({
            accounts: data.accounts,
            chainId: data.chainId,
            connector: connector
        });
        providers.push(provider);
        connected = true;
    }
    // Prevent overwriting connected status from race condition
    if (config.state.status === "reconnecting" || config.state.status === "connecting") {
        // If connecting didn't succeed, set to disconnected
        if (!connected) config.setState((x)=>({
                ...x,
                connections: new Map(),
                current: null,
                status: "disconnected"
            }));
        else config.setState((x)=>({
                ...x,
                status: "connected"
            }));
    }
    $130ca6b4c79955ed$var$isReconnecting = false;
    return connections;
}


function $20d7ad5e6c9cbb30$export$fa8d919ba61d84db(config, parameters) {
    const { initialState: initialState, reconnectOnMount: reconnectOnMount } = parameters;
    if (initialState && !config._internal.store.persist.hasHydrated()) config.setState({
        ...initialState,
        chainId: config.chains.some((x)=>x.id === initialState.chainId) ? initialState.chainId : config.chains[0].id,
        connections: reconnectOnMount ? initialState.connections : new Map(),
        status: reconnectOnMount ? "reconnecting" : "disconnected"
    });
    return {
        async onMount () {
            if (config._internal.ssr) {
                await config._internal.store.persist.rehydrate();
                if (config._internal.mipd) config._internal.connectors.setState((connectors)=>{
                    const rdnsSet = new Set();
                    for (const connector of connectors ?? [])if (connector.rdns) {
                        const rdnsValues = Array.isArray(connector.rdns) ? connector.rdns : [
                            connector.rdns
                        ];
                        for (const rdns of rdnsValues)rdnsSet.add(rdns);
                    }
                    const mipdConnectors = [];
                    const providers = config._internal.mipd?.getProviders() ?? [];
                    for (const provider of providers){
                        if (rdnsSet.has(provider.info.rdns)) continue;
                        const connectorFn = config._internal.connectors.providerDetailToConnector(provider);
                        const connector = config._internal.connectors.setup(connectorFn);
                        mipdConnectors.push(connector);
                    }
                    return [
                        ...connectors,
                        ...mipdConnectors
                    ];
                });
            }
            if (reconnectOnMount) (0, $130ca6b4c79955ed$export$f0e7018a430fa792)(config);
            else if (config.storage) // Reset connections that may have been hydrated from storage.
            config.setState((x)=>({
                    ...x,
                    connections: new Map()
                }));
        }
    };
}



var $tZqWC = parcelRequire("tZqWC");
"use client";
function $92e63fe2335727e7$export$f49feec8afe53ddd(parameters) {
    const { children: children, config: config, initialState: initialState, reconnectOnMount: reconnectOnMount = true } = parameters;
    const { onMount: onMount } = (0, $20d7ad5e6c9cbb30$export$fa8d919ba61d84db)(config, {
        initialState: initialState,
        reconnectOnMount: reconnectOnMount
    });
    // Hydrate for non-SSR
    if (!config._internal.ssr) onMount();
    // Hydrate for SSR
    const active = (0, $tZqWC.useRef)(true);
    // biome-ignore lint/correctness/useExhaustiveDependencies: `queryKey` not required
    (0, $tZqWC.useEffect)(()=>{
        if (!active.current) return;
        if (!config._internal.ssr) return;
        onMount();
        return ()=>{
            active.current = false;
        };
    }, []);
    return children;
}


"use client";
const $682f018675332343$export$da7c16611087c70c = (0, $tZqWC.createContext)(undefined);
function $682f018675332343$export$a28463dc600bc9f8(parameters) {
    const { children: children, config: config } = parameters;
    const props = {
        value: config
    };
    return (0, $tZqWC.createElement)((0, $92e63fe2335727e7$export$f49feec8afe53ddd), parameters, (0, $tZqWC.createElement)($682f018675332343$export$da7c16611087c70c.Provider, props, children));
}


// src/queryClient.ts
// src/utils.ts
var $2616d046cc676fa5$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $2616d046cc676fa5$export$8793edee2d425525() {}
function $2616d046cc676fa5$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $2616d046cc676fa5$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $2616d046cc676fa5$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $2616d046cc676fa5$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $2616d046cc676fa5$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $2616d046cc676fa5$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $2616d046cc676fa5$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$2616d046cc676fa5$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $2616d046cc676fa5$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($2616d046cc676fa5$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $2616d046cc676fa5$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$2616d046cc676fa5$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $2616d046cc676fa5$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = options?.queryKeyHashFn || $2616d046cc676fa5$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $2616d046cc676fa5$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$2616d046cc676fa5$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $2616d046cc676fa5$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return Object.keys(b).every((key)=>$2616d046cc676fa5$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $2616d046cc676fa5$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $2616d046cc676fa5$export$7a8558113332b71e(a) && $2616d046cc676fa5$export$7a8558113332b71e(b);
    if (array || $2616d046cc676fa5$export$53b83ca8eaab0383(a) && $2616d046cc676fa5$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if ((!array && aItems.includes(key) || array) && a[key] === void 0 && b[key] === void 0) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $2616d046cc676fa5$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $2616d046cc676fa5$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $2616d046cc676fa5$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $2616d046cc676fa5$export$53b83ca8eaab0383(o) {
    if (!$2616d046cc676fa5$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$2616d046cc676fa5$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $2616d046cc676fa5$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $2616d046cc676fa5$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
function $2616d046cc676fa5$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $2616d046cc676fa5$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $2616d046cc676fa5$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $2616d046cc676fa5$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $2616d046cc676fa5$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $2616d046cc676fa5$export$1aa5a89531b7670d = Symbol();
function $2616d046cc676fa5$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && fetchOptions?.initialPromise) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $2616d046cc676fa5$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
function $2616d046cc676fa5$export$2072f68e6c3507cf(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}


// src/queryCache.ts

// src/query.ts

// src/notifyManager.ts
var $f9a0e795163e3406$export$7c76da44185e6090 = (cb)=>setTimeout(cb, 0);
function $f9a0e795163e3406$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $f9a0e795163e3406$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $f9a0e795163e3406$export$520687f44db6e1ab = $f9a0e795163e3406$export$316a8efd03cd1458();


// src/retryer.ts
// src/focusManager.ts
// src/subscribable.ts
var $63a0fc4fa9429cfd$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $ff3a62592b5d6e3f$export$86f1af424b2ca4de = class extends (0, $63a0fc4fa9429cfd$export$d26086b469ecdbcc) {
    #focused;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onFocus)=>{
            if (!(0, $2616d046cc676fa5$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.#focused !== focused;
        if (changed) {
            this.#focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        if (typeof this.#focused === "boolean") return this.#focused;
        return globalThis.document?.visibilityState !== "hidden";
    }
};
var $ff3a62592b5d6e3f$export$6bf54661be5b02cf = new $ff3a62592b5d6e3f$export$86f1af424b2ca4de();


// src/onlineManager.ts


var $e35f0aaff5e44e61$export$58774fb55d5ff7fc = class extends (0, $63a0fc4fa9429cfd$export$d26086b469ecdbcc) {
    #online = true;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onOnline)=>{
            if (!(0, $2616d046cc676fa5$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup(this.setOnline.bind(this));
    }
    setOnline(online) {
        const changed = this.#online !== online;
        if (changed) {
            this.#online = online;
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return this.#online;
    }
};
var $e35f0aaff5e44e61$export$b113e788b2dd3fdc = new $e35f0aaff5e44e61$export$58774fb55d5ff7fc();


// src/thenable.ts

function $39749989228c60f8$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}
function $39749989228c60f8$export$216296c47a9d1275(promise) {
    let data;
    promise.then((result)=>{
        data = result;
        return result;
    })?.catch((0, $2616d046cc676fa5$export$8793edee2d425525));
    if (data !== void 0) return {
        data: data
    };
    return void 0;
}



function $95a8be8ee5a01008$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $95a8be8ee5a01008$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $e35f0aaff5e44e61$export$b113e788b2dd3fdc).isOnline() : true;
}
var $95a8be8ee5a01008$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options?.revert;
        this.silent = options?.silent;
    }
};
function $95a8be8ee5a01008$export$986cc6445c1d323(value) {
    return value instanceof $95a8be8ee5a01008$export$a8430ed4188f35a9;
}
function $95a8be8ee5a01008$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    const thenable = (0, $39749989228c60f8$export$d54630db02a12b72)();
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $95a8be8ee5a01008$export$a8430ed4188f35a9(cancelOptions));
            config.abort?.();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $ff3a62592b5d6e3f$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $e35f0aaff5e44e61$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$95a8be8ee5a01008$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess?.(value);
            continueFn?.();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError?.(value);
            continueFn?.();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                if (isResolved || canContinue()) continueResolve(value);
            };
            config.onPause?.();
        }).then(()=>{
            continueFn = void 0;
            if (!isResolved) config.onContinue?.();
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            if (isResolved) return;
            const retry = config.retry ?? ((0, $2616d046cc676fa5$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $95a8be8ee5a01008$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            config.onFail?.(failureCount, error);
            (0, $2616d046cc676fa5$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        cancel: cancel,
        continue: ()=>{
            continueFn?.();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}


// src/removable.ts

var $c51a427595867882$export$e09608847fcc8c59 = class {
    #gcTimeout;
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $2616d046cc676fa5$export$e539f754e934e270)(this.gcTime)) this.#gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime);
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $2616d046cc676fa5$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if (this.#gcTimeout) {
            clearTimeout(this.#gcTimeout);
            this.#gcTimeout = void 0;
        }
    }
};


var $f47f783447b05860$export$62297b13309008b2 = class extends (0, $c51a427595867882$export$e09608847fcc8c59) {
    #initialState;
    #revertState;
    #cache;
    #client;
    #retryer;
    #defaultOptions;
    #abortSignalConsumed;
    constructor(config){
        super();
        this.#abortSignalConsumed = false;
        this.#defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.#client = config.client;
        this.#cache = this.#client.getQueryCache();
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.#initialState = $f47f783447b05860$var$getDefaultState(this.options);
        this.state = config.state ?? this.#initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        return this.#retryer?.promise;
    }
    setOptions(options) {
        this.options = {
            ...this.#defaultOptions,
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.#cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $2616d046cc676fa5$export$17619bac5b909b23)(this.state.data, newData, this.options);
        this.#dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options?.updatedAt,
            manual: options?.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.#dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        const promise = this.#retryer?.promise;
        this.#retryer?.cancel(options);
        return promise ? promise.then((0, $2616d046cc676fa5$export$8793edee2d425525)).catch((0, $2616d046cc676fa5$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.#initialState);
    }
    isActive() {
        return this.observers.some((observer)=>(0, $2616d046cc676fa5$export$8c88ee6f2357230d)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $2616d046cc676fa5$export$1aa5a89531b7670d) || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStale() {
        if (this.state.isInvalidated) return true;
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0;
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || this.state.data === void 0 || !(0, $2616d046cc676fa5$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    onOnline() {
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            this.#cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if (this.#retryer) {
                    if (this.#abortSignalConsumed) this.#retryer.cancel({
                        revert: true
                    });
                    else this.#retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.#cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.#dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        if (this.state.fetchStatus !== "idle") {
            if (this.state.data !== void 0 && fetchOptions?.cancelRefetch) this.cancel({
                silent: true
            });
            else if (this.#retryer) {
                this.#retryer.continueRetry();
                return this.#retryer.promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    this.#abortSignalConsumed = true;
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $2616d046cc676fa5$export$c71c44209368a3bc)(this.options, fetchOptions);
            const queryFnContext = {
                client: this.#client,
                queryKey: this.queryKey,
                meta: this.meta
            };
            addSignalProperty(queryFnContext);
            this.#abortSignalConsumed = false;
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            client: this.#client,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        this.options.behavior?.onFetch(context, this);
        this.#revertState = this.state;
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== context.fetchOptions?.meta) this.#dispatch({
            type: "fetch",
            meta: context.fetchOptions?.meta
        });
        const onError = (error)=>{
            if (!((0, $95a8be8ee5a01008$export$986cc6445c1d323)(error) && error.silent)) this.#dispatch({
                type: "error",
                error: error
            });
            if (!(0, $95a8be8ee5a01008$export$986cc6445c1d323)(error)) {
                this.#cache.config.onError?.(error, this);
                this.#cache.config.onSettled?.(this.state.data, error, this);
            }
            this.scheduleGc();
        };
        this.#retryer = (0, $95a8be8ee5a01008$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions?.initialPromise,
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                if (data === void 0) {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                try {
                    this.setData(data);
                } catch (error) {
                    onError(error);
                    return;
                }
                this.#cache.config.onSuccess?.(data, this);
                this.#cache.config.onSettled?.(data, this.state.error, this);
                this.scheduleGc();
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.#dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        });
        return this.#retryer.start();
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        ...$f47f783447b05860$export$f3df9013f2b58bce(state.data, this.options),
                        fetchMeta: action.meta ?? null
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, $95a8be8ee5a01008$export$986cc6445c1d323)(error) && error.revert && this.#revertState) return {
                        ...this.#revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $f9a0e795163e3406$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate();
            });
            this.#cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $f47f783447b05860$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $95a8be8ee5a01008$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $f47f783447b05860$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $978139d20f3eb30e$export$5dde0cd941da8468 = class extends (0, $63a0fc4fa9429cfd$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#queries = /* @__PURE__ */ new Map();
    }
    #queries;
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $2616d046cc676fa5$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $f47f783447b05860$export$62297b13309008b2)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.#queries.has(query.queryHash)) {
            this.#queries.set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.#queries.get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) this.#queries.delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $f9a0e795163e3406$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.#queries.get(queryHash);
    }
    getAll() {
        return [
            ...this.#queries.values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $2616d046cc676fa5$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $2616d046cc676fa5$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $f9a0e795163e3406$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $f9a0e795163e3406$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $f9a0e795163e3406$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};


// src/mutationCache.ts

// src/mutation.ts



var $80fffc8dc535a806$export$17b8b19c814bcf56 = class extends (0, $c51a427595867882$export$e09608847fcc8c59) {
    #observers;
    #mutationCache;
    #retryer;
    constructor(config){
        super();
        this.mutationId = config.mutationId;
        this.#mutationCache = config.mutationCache;
        this.#observers = [];
        this.state = config.state || $80fffc8dc535a806$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!this.#observers.includes(observer)) {
            this.#observers.push(observer);
            this.clearGcTimeout();
            this.#mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.#observers = this.#observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.#mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.#observers.length) {
            if (this.state.status === "pending") this.scheduleGc();
            else this.#mutationCache.remove(this);
        }
    }
    continue() {
        return this.#retryer?.continue() ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        const onContinue = ()=>{
            this.#dispatch({
                type: "continue"
            });
        };
        this.#retryer = (0, $95a8be8ee5a01008$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables);
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>this.#mutationCache.canRun(this)
        });
        const restored = this.state.status === "pending";
        const isPaused = !this.#retryer.canStart();
        try {
            if (restored) onContinue();
            else {
                this.#dispatch({
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                await this.#mutationCache.config.onMutate?.(variables, this);
                const context = await this.options.onMutate?.(variables);
                if (context !== this.state.context) this.#dispatch({
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await this.#retryer.start();
            await this.#mutationCache.config.onSuccess?.(data, variables, this.state.context, this);
            await this.options.onSuccess?.(data, variables, this.state.context);
            await this.#mutationCache.config.onSettled?.(data, null, this.state.variables, this.state.context, this);
            await this.options.onSettled?.(data, null, variables, this.state.context);
            this.#dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await this.#mutationCache.config.onError?.(error, variables, this.state.context, this);
                await this.options.onError?.(error, variables, this.state.context);
                await this.#mutationCache.config.onSettled?.(void 0, error, this.state.variables, this.state.context, this);
                await this.options.onSettled?.(void 0, error, variables, this.state.context);
                throw error;
            } finally{
                this.#dispatch({
                    type: "error",
                    error: error
                });
            }
        } finally{
            this.#mutationCache.runNext(this);
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "pending":
                    return {
                        ...state,
                        context: action.context,
                        data: void 0,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: action.isPaused,
                        status: "pending",
                        variables: action.variables,
                        submittedAt: Date.now()
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: void 0,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $f9a0e795163e3406$export$520687f44db6e1ab).batch(()=>{
            this.#observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.#mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $80fffc8dc535a806$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $90f8e8feee8ecb8b$export$1fcfd9a244434844 = class extends (0, $63a0fc4fa9429cfd$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#mutations = /* @__PURE__ */ new Set();
        this.#scopes = /* @__PURE__ */ new Map();
        this.#mutationId = 0;
    }
    #mutations;
    #scopes;
    #mutationId;
    build(client, options, state) {
        const mutation = new (0, $80fffc8dc535a806$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++this.#mutationId,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.#mutations.add(mutation);
        const scope = $90f8e8feee8ecb8b$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = this.#scopes.get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else this.#scopes.set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        if (this.#mutations.delete(mutation)) {
            const scope = $90f8e8feee8ecb8b$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = this.#scopes.get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) this.#scopes.delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const scope = $90f8e8feee8ecb8b$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = this.#scopes.get(scope);
            const firstPendingMutation = mutationsWithSameScope?.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        const scope = $90f8e8feee8ecb8b$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const foundMutation = this.#scopes.get(scope)?.find((m)=>m !== mutation && m.state.isPaused);
            return foundMutation?.continue() ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, $f9a0e795163e3406$export$520687f44db6e1ab).batch(()=>{
            this.#mutations.forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            this.#mutations.clear();
            this.#scopes.clear();
        });
    }
    getAll() {
        return Array.from(this.#mutations);
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $2616d046cc676fa5$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $2616d046cc676fa5$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $f9a0e795163e3406$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $f9a0e795163e3406$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $2616d046cc676fa5$export$8793edee2d425525)))));
    }
};
function $90f8e8feee8ecb8b$var$scopeFor(mutation) {
    return mutation.options.scope?.id;
}





// src/infiniteQueryBehavior.ts

function $34373fa3b6ab4652$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const options = context.options;
            const direction = context.fetchOptions?.meta?.fetchMore?.direction;
            const oldPages = context.state.data?.pages || [];
            const oldPageParams = context.state.data?.pageParams || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = (0, $2616d046cc676fa5$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        client: context.client,
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $2616d046cc676fa5$export$8c6246b73dd61f4a) : (0, $2616d046cc676fa5$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $34373fa3b6ab4652$var$getPreviousPageParam : $34373fa3b6ab4652$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $34373fa3b6ab4652$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                return context.options.persister?.(fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $34373fa3b6ab4652$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $34373fa3b6ab4652$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    return pages.length > 0 ? options.getPreviousPageParam?.(pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $34373fa3b6ab4652$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $34373fa3b6ab4652$var$getNextPageParam(options, data) != null;
}
function $34373fa3b6ab4652$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $34373fa3b6ab4652$var$getPreviousPageParam(options, data) != null;
}


var $8bb63d02ffa217e6$export$405d0624ed55a03f = class {
    #queryCache;
    #mutationCache;
    #defaultOptions;
    #queryDefaults;
    #mutationDefaults;
    #mountCount;
    #unsubscribeFocus;
    #unsubscribeOnline;
    constructor(config = {}){
        this.#queryCache = config.queryCache || new (0, $978139d20f3eb30e$export$5dde0cd941da8468)();
        this.#mutationCache = config.mutationCache || new (0, $90f8e8feee8ecb8b$export$1fcfd9a244434844)();
        this.#defaultOptions = config.defaultOptions || {};
        this.#queryDefaults = /* @__PURE__ */ new Map();
        this.#mutationDefaults = /* @__PURE__ */ new Map();
        this.#mountCount = 0;
    }
    mount() {
        this.#mountCount++;
        if (this.#mountCount !== 1) return;
        this.#unsubscribeFocus = (0, $ff3a62592b5d6e3f$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                this.#queryCache.onFocus();
            }
        });
        this.#unsubscribeOnline = (0, $e35f0aaff5e44e61$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                this.#queryCache.onOnline();
            }
        });
    }
    unmount() {
        this.#mountCount--;
        if (this.#mountCount !== 0) return;
        this.#unsubscribeFocus?.();
        this.#unsubscribeFocus = void 0;
        this.#unsubscribeOnline?.();
        this.#unsubscribeOnline = void 0;
    }
    isFetching(filters) {
        return this.#queryCache.findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return this.#mutationCache.findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */ getQueryData(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = this.#queryCache.build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $2616d046cc676fa5$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return this.#queryCache.findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = this.#queryCache.get(defaultedOptions.queryHash);
        const prevData = query?.state.data;
        const data = (0, $2616d046cc676fa5$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return this.#queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $f9a0e795163e3406$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state;
    }
    removeQueries(filters) {
        const queryCache = this.#queryCache;
        (0, $f9a0e795163e3406$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = this.#queryCache;
        return (0, $f9a0e795163e3406$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                ...filters
            }, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $f9a0e795163e3406$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $2616d046cc676fa5$export$8793edee2d425525)).catch((0, $2616d046cc676fa5$export$8793edee2d425525));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $f9a0e795163e3406$export$520687f44db6e1ab).batch(()=>{
            this.#queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters?.refetchType === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: filters?.refetchType ?? filters?.type ?? "active"
            }, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $f9a0e795163e3406$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $2616d046cc676fa5$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $2616d046cc676fa5$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = this.#queryCache.build(this, defaultedOptions);
        return query.isStaleByTime((0, $2616d046cc676fa5$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $2616d046cc676fa5$export$8793edee2d425525)).catch((0, $2616d046cc676fa5$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $34373fa3b6ab4652$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $2616d046cc676fa5$export$8793edee2d425525)).catch((0, $2616d046cc676fa5$export$8793edee2d425525));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, $34373fa3b6ab4652$export$84470d1367601e8d)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $e35f0aaff5e44e61$export$b113e788b2dd3fdc).isOnline()) return this.#mutationCache.resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return this.#queryCache;
    }
    getMutationCache() {
        return this.#mutationCache;
    }
    getDefaultOptions() {
        return this.#defaultOptions;
    }
    setDefaultOptions(options) {
        this.#defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        this.#queryDefaults.set((0, $2616d046cc676fa5$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...this.#queryDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $2616d046cc676fa5$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        this.#mutationDefaults.set((0, $2616d046cc676fa5$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...this.#mutationDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $2616d046cc676fa5$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...this.#defaultOptions.queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $2616d046cc676fa5$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $2616d046cc676fa5$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options?._defaulted) return options;
        return {
            ...this.#defaultOptions.mutations,
            ...options?.mutationKey && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.#queryCache.clear();
        this.#mutationCache.clear();
    }
};


var $tZqWC = parcelRequire("tZqWC");

"use client";
var $adea362784545879$export$da112d31b0149f31 = $tZqWC.createContext(void 0);
var $adea362784545879$export$22e77b9572c4fded = (queryClient)=>{
    const client = $tZqWC.useContext($adea362784545879$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $adea362784545879$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $tZqWC.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $8bbd0dc1ab5297af$exports.jsx)($adea362784545879$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};






var $9yvAP = parcelRequire("9yvAP");
async function $af0121e896d24861$export$64605811ab45167f(config, parameters) {
    // "Register" connector if not already created
    let connector;
    if (typeof parameters.connector === "function") connector = config._internal.connectors.setup(parameters.connector);
    else connector = parameters.connector;
    // Check if connector is already connected
    if (connector.uid === config.state.current) throw new (0, $9yvAP.ConnectorAlreadyConnectedError)();
    try {
        config.setState((x)=>({
                ...x,
                status: "connecting"
            }));
        connector.emitter.emit("message", {
            type: "connecting"
        });
        const { connector: _, ...rest } = parameters;
        const data = await connector.connect(rest);
        const accounts = data.accounts;
        connector.emitter.off("connect", config._internal.events.connect);
        connector.emitter.on("change", config._internal.events.change);
        connector.emitter.on("disconnect", config._internal.events.disconnect);
        await config.storage?.setItem("recentConnectorId", connector.id);
        config.setState((x)=>({
                ...x,
                connections: new Map(x.connections).set(connector.uid, {
                    accounts: accounts,
                    chainId: data.chainId,
                    connector: connector
                }),
                current: connector.uid,
                status: "connected"
            }));
        return {
            accounts: accounts,
            chainId: data.chainId
        };
    } catch (error) {
        config.setState((x)=>({
                ...x,
                // Keep existing connector connected in case of error
                status: x.current ? "connected" : "disconnected"
            }));
        throw error;
    }
}

/**
 * Announces an EIP-1193 Provider.
 */ function $f39bd0987a76396b$export$60dbeacb3287962a(detail) {
    const event = new CustomEvent("eip6963:announceProvider", {
        detail: Object.freeze(detail)
    });
    window.dispatchEvent(event);
    const handler = ()=>window.dispatchEvent(event);
    window.addEventListener("eip6963:requestProvider", handler);
    return ()=>window.removeEventListener("eip6963:requestProvider", handler);
}
function $f39bd0987a76396b$export$f262fc9233ecbc18(listener) {
    if (typeof window === "undefined") return;
    const handler = (event)=>listener(event.detail);
    window.addEventListener("eip6963:announceProvider", handler);
    window.dispatchEvent(new CustomEvent("eip6963:requestProvider"));
    return ()=>window.removeEventListener("eip6963:announceProvider", handler);
}


function $c438b1f595af803f$export$f51a9068ac82ea43() {
    const listeners = new Set();
    let providerDetails = [];
    const request = ()=>(0, $f39bd0987a76396b$export$f262fc9233ecbc18)((providerDetail)=>{
            if (providerDetails.some(({ info: info })=>info.uuid === providerDetail.info.uuid)) return;
            providerDetails = [
                ...providerDetails,
                providerDetail
            ];
            listeners.forEach((listener)=>listener(providerDetails, {
                    added: [
                        providerDetail
                    ]
                }));
        });
    let unwatch = request();
    return {
        _listeners () {
            return listeners;
        },
        clear () {
            listeners.forEach((listener)=>listener([], {
                    removed: [
                        ...providerDetails
                    ]
                }));
            providerDetails = [];
        },
        destroy () {
            this.clear();
            listeners.clear();
            unwatch?.();
        },
        findProvider ({ rdns: rdns }) {
            return providerDetails.find((providerDetail)=>providerDetail.info.rdns === rdns);
        },
        getProviders () {
            return providerDetails;
        },
        reset () {
            this.clear();
            unwatch?.();
            unwatch = request();
        },
        subscribe (listener, { emitImmediately: emitImmediately } = {}) {
            listeners.add(listener);
            if (emitImmediately) listener(providerDetails, {
                added: providerDetails
            });
            return ()=>listeners.delete(listener);
        }
    };
}



var $fbsYZ = parcelRequire("fbsYZ");

function $c6c405c1b78bf5b3$export$5d730b7aed1a3eb0(parameters) {
    const { batch: batch, cacheTime: cacheTime = parameters.pollingInterval ?? 4000, ccipRead: ccipRead, key: key = "base", name: name = "Base Client", pollingInterval: pollingInterval = 4000, type: type = "base" } = parameters;
    const chain = parameters.chain;
    const account = parameters.account ? (0, $fbsYZ.parseAccount)(parameters.account) : undefined;
    const { config: config, request: request, value: value } = parameters.transport({
        chain: chain,
        pollingInterval: pollingInterval
    });
    const transport = {
        ...config,
        ...value
    };
    const client = {
        account: account,
        batch: batch,
        cacheTime: cacheTime,
        ccipRead: ccipRead,
        chain: chain,
        key: key,
        name: name,
        pollingInterval: pollingInterval,
        request: request,
        transport: transport,
        type: type,
        uid: (0, $93931935b93b2e48$export$e2a22331486dcca0)()
    };
    function extend(base) {
        return (extendFn)=>{
            const extended = extendFn(base);
            for(const key in client)delete extended[key];
            const combined = {
                ...base,
                ...extended
            };
            return Object.assign(combined, {
                extend: extend(combined)
            });
        };
    }
    return Object.assign(client, {
        extend: extend(client)
    });
}
function $c6c405c1b78bf5b3$export$3db60a9e016ddd81() {
    return null;
}


var $c329531445af2e84$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $c329531445af2e84$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $c329531445af2e84$export$4feba8a1bc8e9afd = $c329531445af2e84$var$reduxImpl;
const $c329531445af2e84$var$trackedConnections = /* @__PURE__ */ new Map();
const $c329531445af2e84$var$getTrackedConnectionState = (name)=>{
    const api = $c329531445af2e84$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $c329531445af2e84$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $c329531445af2e84$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $c329531445af2e84$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $c329531445af2e84$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($c329531445af2e84$import_meta.env ? $c329531445af2e84$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) return fn(set, get, api);
        const { connection: connection, ...connectionInformation } = $c329531445af2e84$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$c329531445af2e84$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($c329531445af2e84$import_meta.env ? $c329531445af2e84$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $c329531445af2e84$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format.
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($c329531445af2e84$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($c329531445af2e84$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $c329531445af2e84$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($c329531445af2e84$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $c329531445af2e84$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $c329531445af2e84$export$6922d3b3a607469e = $c329531445af2e84$var$devtoolsImpl;
const $c329531445af2e84$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $c329531445af2e84$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $c329531445af2e84$export$5c593627aef9f076 = $c329531445af2e84$var$subscribeWithSelectorImpl;
const $c329531445af2e84$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $c329531445af2e84$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $c329531445af2e84$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $c329531445af2e84$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $c329531445af2e84$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $c329531445af2e84$var$persistImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $c329531445af2e84$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $c329531445af2e84$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return [
                            true,
                            options.migrate(deserializedStorageValue.state, deserializedStorageValue.version)
                        ];
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    void 0
                ];
            }).then((migrationResult)=>{
                var _a2;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $c329531445af2e84$export$9a6132153fba2e0 = $c329531445af2e84$var$persistImpl;


const $ed571a1561f7ffa8$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $ed571a1561f7ffa8$export$f51a9068ac82ea43 = (createState)=>createState ? $ed571a1561f7ffa8$var$createStoreImpl(createState) : $ed571a1561f7ffa8$var$createStoreImpl;



var $bOQZu = parcelRequire("bOQZu");
var $nDot9 = parcelRequire("nDot9");
var $16W4z = parcelRequire("16W4z");

var $9yvAP = parcelRequire("9yvAP");

var $jWASA = parcelRequire("jWASA");
class $064d9adb8a9c12a4$export$43839b3ff6336f15 extends (0, $jWASA.BaseError) {
    constructor(){
        super("Provider not found.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ProviderNotFoundError"
        });
    }
}
class $064d9adb8a9c12a4$export$a4296a4b7763e5d8 extends (0, $jWASA.BaseError) {
    constructor({ connector: connector }){
        super(`"${connector.name}" does not support programmatic chain switching.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SwitchChainNotSupportedError"
        });
    }
}



var $jb2AH = parcelRequire("jb2AH");
$990abb03632f8397$export$a7a34dad4983656f.type = "injected";
function $990abb03632f8397$export$a7a34dad4983656f(parameters = {}) {
    const { shimDisconnect: shimDisconnect = true, unstable_shimAsyncInject: unstable_shimAsyncInject } = parameters;
    function getTarget() {
        const target = parameters.target;
        if (typeof target === "function") {
            const result = target();
            if (result) return result;
        }
        if (typeof target === "object") return target;
        if (typeof target === "string") return {
            ...$990abb03632f8397$var$targetMap[target] ?? {
                id: target,
                name: `${target[0].toUpperCase()}${target.slice(1)}`,
                provider: `is${target[0].toUpperCase()}${target.slice(1)}`
            }
        };
        return {
            id: "injected",
            name: "Injected",
            provider (window1) {
                return window1?.ethereum;
            }
        };
    }
    let accountsChanged;
    let chainChanged;
    let connect;
    let disconnect;
    return (0, $jb2AH.createConnector)((config)=>({
            get icon () {
                return getTarget().icon;
            },
            get id () {
                return getTarget().id;
            },
            get name () {
                return getTarget().name;
            },
            /** @deprecated */ get supportsSimulation () {
                return true;
            },
            type: $990abb03632f8397$export$a7a34dad4983656f.type,
            async setup () {
                const provider = await this.getProvider();
                // Only start listening for events if `target` is set, otherwise `injected()` will also receive events
                if (provider?.on && parameters.target) {
                    if (!connect) {
                        connect = this.onConnect.bind(this);
                        provider.on("connect", connect);
                    }
                    // We shouldn't need to listen for `'accountsChanged'` here since the `'connect'` event should suffice (and wallet shouldn't be connected yet).
                    // Some wallets, like MetaMask, do not implement the `'connect'` event and overload `'accountsChanged'` instead.
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                }
            },
            async connect ({ chainId: chainId, isReconnecting: isReconnecting } = {}) {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $064d9adb8a9c12a4$export$43839b3ff6336f15)();
                let accounts = [];
                if (isReconnecting) accounts = await this.getAccounts().catch(()=>[]);
                else if (shimDisconnect) // Attempt to show another prompt for selecting account if `shimDisconnect` flag is enabled
                try {
                    const permissions = await provider.request({
                        method: "wallet_requestPermissions",
                        params: [
                            {
                                eth_accounts: {}
                            }
                        ]
                    });
                    accounts = permissions[0]?.caveats?.[0]?.value?.map((x)=>(0, $bOQZu.getAddress)(x));
                    // `'wallet_requestPermissions'` can return a different order of accounts than `'eth_accounts'`
                    // switch to `'eth_accounts'` ordering if more than one account is connected
                    // https://github.com/wevm/wagmi/issues/4140
                    if (accounts.length > 0) {
                        const sortedAccounts = await this.getAccounts();
                        accounts = sortedAccounts;
                    }
                } catch (err) {
                    const error = err;
                    // Not all injected providers support `wallet_requestPermissions` (e.g. MetaMask iOS).
                    // Only bubble up error if user rejects request
                    if (error.code === (0, $16W4z.UserRejectedRequestError).code) throw new (0, $16W4z.UserRejectedRequestError)(error);
                    // Or prompt is already open
                    if (error.code === (0, $16W4z.ResourceUnavailableRpcError).code) throw error;
                }
                try {
                    if (!accounts?.length && !isReconnecting) {
                        const requestedAccounts = await provider.request({
                            method: "eth_requestAccounts"
                        });
                        accounts = requestedAccounts.map((x)=>(0, $bOQZu.getAddress)(x));
                    }
                    // Manage EIP-1193 event listeners
                    // https://eips.ethereum.org/EIPS/eip-1193#events
                    if (connect) {
                        provider.removeListener("connect", connect);
                        connect = undefined;
                    }
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                    if (!chainChanged) {
                        chainChanged = this.onChainChanged.bind(this);
                        provider.on("chainChanged", chainChanged);
                    }
                    if (!disconnect) {
                        disconnect = this.onDisconnect.bind(this);
                        provider.on("disconnect", disconnect);
                    }
                    // Switch to chain if provided
                    let currentChainId = await this.getChainId();
                    if (chainId && currentChainId !== chainId) {
                        const chain = await this.switchChain({
                            chainId: chainId
                        }).catch((error)=>{
                            if (error.code === (0, $16W4z.UserRejectedRequestError).code) throw error;
                            return {
                                id: currentChainId
                            };
                        });
                        currentChainId = chain?.id ?? currentChainId;
                    }
                    // Remove disconnected shim if it exists
                    if (shimDisconnect) await config.storage?.removeItem(`${this.id}.disconnected`);
                    // Add connected shim if no target exists
                    if (!parameters.target) await config.storage?.setItem("injected.connected", true);
                    return {
                        accounts: accounts,
                        chainId: currentChainId
                    };
                } catch (err) {
                    const error = err;
                    if (error.code === (0, $16W4z.UserRejectedRequestError).code) throw new (0, $16W4z.UserRejectedRequestError)(error);
                    if (error.code === (0, $16W4z.ResourceUnavailableRpcError).code) throw new (0, $16W4z.ResourceUnavailableRpcError)(error);
                    throw error;
                }
            },
            async disconnect () {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $064d9adb8a9c12a4$export$43839b3ff6336f15)();
                // Manage EIP-1193 event listeners
                if (chainChanged) {
                    provider.removeListener("chainChanged", chainChanged);
                    chainChanged = undefined;
                }
                if (disconnect) {
                    provider.removeListener("disconnect", disconnect);
                    disconnect = undefined;
                }
                if (!connect) {
                    connect = this.onConnect.bind(this);
                    provider.on("connect", connect);
                }
                // Experimental support for MetaMask disconnect
                // https://github.com/MetaMask/metamask-improvement-proposals/blob/main/MIPs/mip-2.md
                try {
                    // Adding timeout as not all wallets support this method and can hang
                    // https://github.com/wevm/wagmi/issues/4064
                    await (0, $9ca27c1b24cc14cb$export$e86e19342bc4850e)(()=>// TODO: Remove explicit type for viem@3
                        provider.request({
                            // `'wallet_revokePermissions'` added in `viem@2.10.3`
                            method: "wallet_revokePermissions",
                            params: [
                                {
                                    eth_accounts: {}
                                }
                            ]
                        }), {
                        timeout: 100
                    });
                } catch  {}
                // Add shim signalling connector is disconnected
                if (shimDisconnect) await config.storage?.setItem(`${this.id}.disconnected`, true);
                if (!parameters.target) await config.storage?.removeItem("injected.connected");
            },
            async getAccounts () {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $064d9adb8a9c12a4$export$43839b3ff6336f15)();
                const accounts = await provider.request({
                    method: "eth_accounts"
                });
                return accounts.map((x)=>(0, $bOQZu.getAddress)(x));
            },
            async getChainId () {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $064d9adb8a9c12a4$export$43839b3ff6336f15)();
                const hexChainId = await provider.request({
                    method: "eth_chainId"
                });
                return Number(hexChainId);
            },
            async getProvider () {
                if (typeof window === "undefined") return undefined;
                let provider;
                const target = getTarget();
                if (typeof target.provider === "function") provider = target.provider(window);
                else if (typeof target.provider === "string") provider = $990abb03632f8397$var$findProvider(window, target.provider);
                else provider = target.provider;
                // Some wallets do not conform to EIP-1193 (e.g. Trust Wallet)
                // https://github.com/wevm/wagmi/issues/3526#issuecomment-1912683002
                if (provider && !provider.removeListener) {
                    // Try using `off` handler if it exists, otherwise noop
                    if ("off" in provider && typeof provider.off === "function") provider.removeListener = provider.off;
                    else provider.removeListener = ()=>{};
                }
                return provider;
            },
            async isAuthorized () {
                try {
                    const isDisconnected = shimDisconnect && // If shim exists in storage, connector is disconnected
                    await config.storage?.getItem(`${this.id}.disconnected`);
                    if (isDisconnected) return false;
                    // Don't allow injected connector to connect if no target is set and it hasn't already connected
                    // (e.g. flag in storage is not set). This prevents a targetless injected connector from connecting
                    // automatically whenever there is a targeted connector configured.
                    if (!parameters.target) {
                        const connected = await config.storage?.getItem("injected.connected");
                        if (!connected) return false;
                    }
                    const provider = await this.getProvider();
                    if (!provider) {
                        if (unstable_shimAsyncInject !== undefined && unstable_shimAsyncInject !== false) {
                            // If no provider is found, check for async injection
                            // https://github.com/wevm/references/issues/167
                            // https://github.com/MetaMask/detect-provider
                            const handleEthereum = async ()=>{
                                if (typeof window !== "undefined") window.removeEventListener("ethereum#initialized", handleEthereum);
                                const provider = await this.getProvider();
                                return !!provider;
                            };
                            const timeout = typeof unstable_shimAsyncInject === "number" ? unstable_shimAsyncInject : 1000;
                            const res = await Promise.race([
                                ...typeof window !== "undefined" ? [
                                    new Promise((resolve)=>window.addEventListener("ethereum#initialized", ()=>resolve(handleEthereum()), {
                                            once: true
                                        }))
                                ] : [],
                                new Promise((resolve)=>setTimeout(()=>resolve(handleEthereum()), timeout))
                            ]);
                            if (res) return true;
                        }
                        throw new (0, $064d9adb8a9c12a4$export$43839b3ff6336f15)();
                    }
                    // Use retry strategy as some injected wallets (e.g. MetaMask) fail to
                    // immediately resolve JSON-RPC requests on page load.
                    const accounts = await (0, $4aecf79c34be183e$export$188df5ecf8e7961a)(()=>this.getAccounts());
                    return !!accounts.length;
                } catch  {
                    return false;
                }
            },
            async switchChain ({ addEthereumChainParameter: addEthereumChainParameter, chainId: chainId }) {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $064d9adb8a9c12a4$export$43839b3ff6336f15)();
                const chain = config.chains.find((x)=>x.id === chainId);
                if (!chain) throw new (0, $16W4z.SwitchChainError)(new (0, $9yvAP.ChainNotConfiguredError)());
                const promise = new Promise((resolve)=>{
                    const listener = (data)=>{
                        if ("chainId" in data && data.chainId === chainId) {
                            config.emitter.off("change", listener);
                            resolve();
                        }
                    };
                    config.emitter.on("change", listener);
                });
                try {
                    await Promise.all([
                        provider.request({
                            method: "wallet_switchEthereumChain",
                            params: [
                                {
                                    chainId: (0, $nDot9.numberToHex)(chainId)
                                }
                            ]
                        })// During `'wallet_switchEthereumChain'`, MetaMask makes a `'net_version'` RPC call to the target chain.
                        // If this request fails, MetaMask does not emit the `'chainChanged'` event, but will still switch the chain.
                        // To counter this behavior, we request and emit the current chain ID to confirm the chain switch either via
                        // this callback or an externally emitted `'chainChanged'` event.
                        // https://github.com/MetaMask/metamask-extension/issues/24247
                        .then(async ()=>{
                            const currentChainId = await this.getChainId();
                            if (currentChainId === chainId) config.emitter.emit("change", {
                                chainId: chainId
                            });
                        }),
                        promise
                    ]);
                    return chain;
                } catch (err) {
                    const error = err;
                    // Indicates chain is not added to provider
                    if (error.code === 4902 || // Unwrapping for MetaMask Mobile
                    // https://github.com/MetaMask/metamask-mobile/issues/2944#issuecomment-976988719
                    error?.data?.originalError?.code === 4902) try {
                        const { default: blockExplorer, ...blockExplorers } = chain.blockExplorers ?? {};
                        let blockExplorerUrls;
                        if (addEthereumChainParameter?.blockExplorerUrls) blockExplorerUrls = addEthereumChainParameter.blockExplorerUrls;
                        else if (blockExplorer) blockExplorerUrls = [
                            blockExplorer.url,
                            ...Object.values(blockExplorers).map((x)=>x.url)
                        ];
                        let rpcUrls;
                        if (addEthereumChainParameter?.rpcUrls?.length) rpcUrls = addEthereumChainParameter.rpcUrls;
                        else rpcUrls = [
                            chain.rpcUrls.default?.http[0] ?? ""
                        ];
                        const addEthereumChain = {
                            blockExplorerUrls: blockExplorerUrls,
                            chainId: (0, $nDot9.numberToHex)(chainId),
                            chainName: addEthereumChainParameter?.chainName ?? chain.name,
                            iconUrls: addEthereumChainParameter?.iconUrls,
                            nativeCurrency: addEthereumChainParameter?.nativeCurrency ?? chain.nativeCurrency,
                            rpcUrls: rpcUrls
                        };
                        await Promise.all([
                            provider.request({
                                method: "wallet_addEthereumChain",
                                params: [
                                    addEthereumChain
                                ]
                            }).then(async ()=>{
                                const currentChainId = await this.getChainId();
                                if (currentChainId === chainId) config.emitter.emit("change", {
                                    chainId: chainId
                                });
                                else throw new (0, $16W4z.UserRejectedRequestError)(new Error("User rejected switch after adding network."));
                            }),
                            promise
                        ]);
                        return chain;
                    } catch (error) {
                        throw new (0, $16W4z.UserRejectedRequestError)(error);
                    }
                    if (error.code === (0, $16W4z.UserRejectedRequestError).code) throw new (0, $16W4z.UserRejectedRequestError)(error);
                    throw new (0, $16W4z.SwitchChainError)(error);
                }
            },
            async onAccountsChanged (accounts) {
                // Disconnect if there are no accounts
                if (accounts.length === 0) this.onDisconnect();
                else if (config.emitter.listenerCount("connect")) {
                    const chainId = (await this.getChainId()).toString();
                    this.onConnect({
                        chainId: chainId
                    });
                    // Remove disconnected shim if it exists
                    if (shimDisconnect) await config.storage?.removeItem(`${this.id}.disconnected`);
                } else config.emitter.emit("change", {
                    accounts: accounts.map((x)=>(0, $bOQZu.getAddress)(x))
                });
            },
            onChainChanged (chain) {
                const chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            async onConnect (connectInfo) {
                const accounts = await this.getAccounts();
                if (accounts.length === 0) return;
                const chainId = Number(connectInfo.chainId);
                config.emitter.emit("connect", {
                    accounts: accounts,
                    chainId: chainId
                });
                // Manage EIP-1193 event listeners
                const provider = await this.getProvider();
                if (provider) {
                    if (connect) {
                        provider.removeListener("connect", connect);
                        connect = undefined;
                    }
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                    if (!chainChanged) {
                        chainChanged = this.onChainChanged.bind(this);
                        provider.on("chainChanged", chainChanged);
                    }
                    if (!disconnect) {
                        disconnect = this.onDisconnect.bind(this);
                        provider.on("disconnect", disconnect);
                    }
                }
            },
            async onDisconnect (error) {
                const provider = await this.getProvider();
                // If MetaMask emits a `code: 1013` error, wait for reconnection before disconnecting
                // https://github.com/MetaMask/providers/pull/120
                if (error && error.code === 1013) {
                    if (provider && !!(await this.getAccounts()).length) return;
                }
                // No need to remove `${this.id}.disconnected` from storage because `onDisconnect` is typically
                // only called when the wallet is disconnected through the wallet's interface, meaning the wallet
                // actually disconnected and we don't need to simulate it.
                config.emitter.emit("disconnect");
                // Manage EIP-1193 event listeners
                if (provider) {
                    if (chainChanged) {
                        provider.removeListener("chainChanged", chainChanged);
                        chainChanged = undefined;
                    }
                    if (disconnect) {
                        provider.removeListener("disconnect", disconnect);
                        disconnect = undefined;
                    }
                    if (!connect) {
                        connect = this.onConnect.bind(this);
                        provider.on("connect", connect);
                    }
                }
            }
        }));
}
const $990abb03632f8397$var$targetMap = {
    coinbaseWallet: {
        id: "coinbaseWallet",
        name: "Coinbase Wallet",
        provider (window1) {
            if (window1?.coinbaseWalletExtension) return window1.coinbaseWalletExtension;
            return $990abb03632f8397$var$findProvider(window1, "isCoinbaseWallet");
        }
    },
    metaMask: {
        id: "metaMask",
        name: "MetaMask",
        provider (window1) {
            return $990abb03632f8397$var$findProvider(window1, (provider)=>{
                if (!provider.isMetaMask) return false;
                // Brave tries to make itself look like MetaMask
                // Could also try RPC `web3_clientVersion` if following is unreliable
                if (provider.isBraveWallet && !provider._events && !provider._state) return false;
                // Other wallets that try to look like MetaMask
                const flags = [
                    "isApexWallet",
                    "isAvalanche",
                    "isBitKeep",
                    "isBlockWallet",
                    "isKuCoinWallet",
                    "isMathWallet",
                    "isOkxWallet",
                    "isOKExWallet",
                    "isOneInchIOSWallet",
                    "isOneInchAndroidWallet",
                    "isOpera",
                    "isPhantom",
                    "isPortal",
                    "isRabby",
                    "isTokenPocket",
                    "isTokenary",
                    "isUniswapWallet",
                    "isZerion"
                ];
                for (const flag of flags)if (provider[flag]) return false;
                return true;
            });
        }
    },
    phantom: {
        id: "phantom",
        name: "Phantom",
        provider (window1) {
            if (window1?.phantom?.ethereum) return window1.phantom?.ethereum;
            return $990abb03632f8397$var$findProvider(window1, "isPhantom");
        }
    }
};
function $990abb03632f8397$var$findProvider(window1, select) {
    function isProvider(provider) {
        if (typeof select === "function") return select(provider);
        if (typeof select === "string") return provider[select];
        return true;
    }
    const ethereum = window1.ethereum;
    if (ethereum?.providers) return ethereum.providers.find((provider)=>isProvider(provider));
    if (ethereum && isProvider(ethereum)) return ethereum;
    return undefined;
}


parcelRequire("e7UPq");
var $1P3yO = parcelRequire("1P3yO");
class $6e5abc91d1dd2871$export$4293555f241ae35a {
    constructor(uid){
        Object.defineProperty(this, "uid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: uid
        });
        Object.defineProperty(this, "_emitter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new (0, (/*@__PURE__*/$parcel$interopDefault($1P3yO)))()
        });
    }
    on(eventName, fn) {
        this._emitter.on(eventName, fn);
    }
    once(eventName, fn) {
        this._emitter.once(eventName, fn);
    }
    off(eventName, fn) {
        this._emitter.off(eventName, fn);
    }
    emit(eventName, ...params) {
        const data = params[0];
        this._emitter.emit(eventName, {
            uid: this.uid,
            ...data
        });
    }
    listenerCount(eventName) {
        return this._emitter.listenerCount(eventName);
    }
}
function $6e5abc91d1dd2871$export$6f5e8f34570e3ad1(uid) {
    return new $6e5abc91d1dd2871$export$4293555f241ae35a(uid);
}


function $530705dd46b199f5$export$efcd34ab6248d3cd(value, reviver) {
    return JSON.parse(value, (key, value_)=>{
        let value = value_;
        if (value?.__type === "bigint") value = BigInt(value.value);
        if (value?.__type === "Map") value = new Map(value.value);
        return reviver?.(key, value) ?? value;
    });
}


/**
 * Get the reference key for the circular value
 *
 * @param keys the keys to build the reference key from
 * @param cutoff the maximum number of keys to include
 * @returns the reference key
 */ function $6c78f0eaf6364c8d$var$getReferenceKey(keys, cutoff) {
    return keys.slice(0, cutoff).join(".") || ".";
}
/**
 * Faster `Array.prototype.indexOf` implementation build for slicing / splicing
 *
 * @param array the array to match the value in
 * @param value the value to match
 * @returns the matching index, or -1
 */ function $6c78f0eaf6364c8d$var$getCutoff(array, value) {
    const { length: length } = array;
    for(let index = 0; index < length; ++index){
        if (array[index] === value) return index + 1;
    }
    return 0;
}
/**
 * Create a replacer method that handles circular values
 *
 * @param [replacer] a custom replacer to use for non-circular values
 * @param [circularReplacer] a custom replacer to use for circular methods
 * @returns the value to stringify
 */ function $6c78f0eaf6364c8d$var$createReplacer(replacer, circularReplacer) {
    const hasReplacer = typeof replacer === "function";
    const hasCircularReplacer = typeof circularReplacer === "function";
    const cache = [];
    const keys = [];
    return function replace(key, value) {
        if (typeof value === "object") {
            if (cache.length) {
                const thisCutoff = $6c78f0eaf6364c8d$var$getCutoff(cache, this);
                if (thisCutoff === 0) cache[cache.length] = this;
                else {
                    cache.splice(thisCutoff);
                    keys.splice(thisCutoff);
                }
                keys[keys.length] = key;
                const valueCutoff = $6c78f0eaf6364c8d$var$getCutoff(cache, value);
                if (valueCutoff !== 0) return hasCircularReplacer ? circularReplacer.call(this, key, value, $6c78f0eaf6364c8d$var$getReferenceKey(keys, valueCutoff)) : `[ref=${$6c78f0eaf6364c8d$var$getReferenceKey(keys, valueCutoff)}]`;
            } else {
                cache[0] = value;
                keys[0] = key;
            }
        }
        return hasReplacer ? replacer.call(this, key, value) : value;
    };
}
function $6c78f0eaf6364c8d$export$dfdc1655ccc5b9cb(value, replacer, indent, circularReplacer) {
    return JSON.stringify(value, $6c78f0eaf6364c8d$var$createReplacer((key, value_)=>{
        let value = value_;
        if (typeof value === "bigint") value = {
            __type: "bigint",
            value: value_.toString()
        };
        if (value instanceof Map) value = {
            __type: "Map",
            value: Array.from(value_.entries())
        };
        return replacer?.(key, value) ?? value;
    }, circularReplacer), indent ?? undefined);
}


function $430633b696d08891$export$d184a47a971dd4b9(parameters) {
    const { deserialize: deserialize = (0, $530705dd46b199f5$export$efcd34ab6248d3cd), key: prefix = "wagmi", serialize: serialize = (0, $6c78f0eaf6364c8d$export$dfdc1655ccc5b9cb), storage: storage = $430633b696d08891$export$e2ef6c4b988c05b } = parameters;
    function unwrap(value) {
        if (value instanceof Promise) return value.then((x)=>x).catch(()=>null);
        return value;
    }
    return {
        ...storage,
        key: prefix,
        async getItem (key, defaultValue) {
            const value = storage.getItem(`${prefix}.${key}`);
            const unwrapped = await unwrap(value);
            if (unwrapped) return deserialize(unwrapped) ?? null;
            return defaultValue ?? null;
        },
        async setItem (key, value) {
            const storageKey = `${prefix}.${key}`;
            if (value === null) await unwrap(storage.removeItem(storageKey));
            else await unwrap(storage.setItem(storageKey, serialize(value)));
        },
        async removeItem (key) {
            await unwrap(storage.removeItem(`${prefix}.${key}`));
        }
    };
}
const $430633b696d08891$export$e2ef6c4b988c05b = {
    getItem: ()=>null,
    setItem: ()=>{},
    removeItem: ()=>{}
};
function $430633b696d08891$export$c164ff19f266df37() {
    const storage = (()=>{
        if (typeof window !== "undefined" && window.localStorage) return window.localStorage;
        return $430633b696d08891$export$e2ef6c4b988c05b;
    })();
    return {
        getItem (key) {
            return storage.getItem(key);
        },
        removeItem (key) {
            storage.removeItem(key);
        },
        setItem (key, value) {
            try {
                storage.setItem(key, value);
            // silence errors by default (QuotaExceededError, SecurityError, etc.)
            } catch  {}
        }
    };
}



var $9yvAP = parcelRequire("9yvAP");
const $9e7ded09068a5c80$var$size = 256;
let $9e7ded09068a5c80$var$index = $9e7ded09068a5c80$var$size;
let $9e7ded09068a5c80$var$buffer;
function $9e7ded09068a5c80$export$e2a22331486dcca0(length = 11) {
    if (!$9e7ded09068a5c80$var$buffer || $9e7ded09068a5c80$var$index + length > $9e7ded09068a5c80$var$size * 2) {
        $9e7ded09068a5c80$var$buffer = "";
        $9e7ded09068a5c80$var$index = 0;
        for(let i = 0; i < $9e7ded09068a5c80$var$size; i++)$9e7ded09068a5c80$var$buffer += (256 + Math.random() * 256 | 0).toString(16).substring(1);
    }
    return $9e7ded09068a5c80$var$buffer.substring($9e7ded09068a5c80$var$index, $9e7ded09068a5c80$var$index++ + length);
}



var $4wZB6 = parcelRequire("4wZB6");
function $acea716a433e2ca3$export$45a69314cf48a3eb(parameters) {
    const { multiInjectedProviderDiscovery: multiInjectedProviderDiscovery = true, storage: storage = (0, $430633b696d08891$export$d184a47a971dd4b9)({
        storage: (0, $430633b696d08891$export$c164ff19f266df37)()
    }), syncConnectedChain: syncConnectedChain = true, ssr: ssr = false, ...rest } = parameters;
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Set up connectors, clients, etc.
    /////////////////////////////////////////////////////////////////////////////////////////////////
    const mipd = typeof window !== "undefined" && multiInjectedProviderDiscovery ? (0, $c438b1f595af803f$export$f51a9068ac82ea43)() : undefined;
    const chains = (0, $ed571a1561f7ffa8$export$f51a9068ac82ea43)(()=>rest.chains);
    const connectors = (0, $ed571a1561f7ffa8$export$f51a9068ac82ea43)(()=>{
        const collection = [];
        const rdnsSet = new Set();
        for (const connectorFns of rest.connectors ?? []){
            const connector = setup(connectorFns);
            collection.push(connector);
            if (!ssr && connector.rdns) {
                const rdnsValues = typeof connector.rdns === "string" ? [
                    connector.rdns
                ] : connector.rdns;
                for (const rdns of rdnsValues)rdnsSet.add(rdns);
            }
        }
        if (!ssr && mipd) {
            const providers = mipd.getProviders();
            for (const provider of providers){
                if (rdnsSet.has(provider.info.rdns)) continue;
                collection.push(setup(providerDetailToConnector(provider)));
            }
        }
        return collection;
    });
    function setup(connectorFn) {
        // Set up emitter with uid and add to connector so they are "linked" together.
        const emitter = (0, $6e5abc91d1dd2871$export$6f5e8f34570e3ad1)((0, $9e7ded09068a5c80$export$e2a22331486dcca0)());
        const connector = {
            ...connectorFn({
                emitter: emitter,
                chains: chains.getState(),
                storage: storage,
                transports: rest.transports
            }),
            emitter: emitter,
            uid: emitter.uid
        };
        // Start listening for `connect` events on connector setup
        // This allows connectors to "connect" themselves without user interaction (e.g. MetaMask's "Manually connect to current site")
        emitter.on("connect", connect);
        connector.setup?.();
        return connector;
    }
    function providerDetailToConnector(providerDetail) {
        const { info: info } = providerDetail;
        const provider = providerDetail.provider;
        return (0, $990abb03632f8397$export$a7a34dad4983656f)({
            target: {
                ...info,
                id: info.rdns,
                provider: provider
            }
        });
    }
    const clients = new Map();
    function getClient(config = {}) {
        const chainId = config.chainId ?? store.getState().chainId;
        const chain = chains.getState().find((x)=>x.id === chainId);
        // chainId specified and not configured
        if (config.chainId && !chain) throw new (0, $9yvAP.ChainNotConfiguredError)();
        {
            const client = clients.get(store.getState().chainId);
            if (client && !chain) return client;
            if (!chain) throw new (0, $9yvAP.ChainNotConfiguredError)();
        }
        // If a memoized client exists for a chain id, use that.
        {
            const client = clients.get(chainId);
            if (client) return client;
        }
        let client;
        if (rest.client) client = rest.client({
            chain: chain
        });
        else {
            const chainId = chain.id;
            const chainIds = chains.getState().map((x)=>x.id);
            // Grab all properties off `rest` and resolve for use in `createClient`
            const properties = {};
            const entries = Object.entries(rest);
            for (const [key, value] of entries){
                if (key === "chains" || key === "client" || key === "connectors" || key === "transports") continue;
                if (typeof value === "object") {
                    // check if value is chainId-specific since some values can be objects
                    // e.g. { batch: { multicall: { batchSize: 1024 } } }
                    if (chainId in value) properties[key] = value[chainId];
                    else {
                        // check if value is chainId-specific, but does not have value for current chainId
                        const hasChainSpecificValue = chainIds.some((x)=>x in value);
                        if (hasChainSpecificValue) continue;
                        properties[key] = value;
                    }
                } else properties[key] = value;
            }
            client = (0, $c6c405c1b78bf5b3$export$5d730b7aed1a3eb0)({
                ...properties,
                chain: chain,
                batch: properties.batch ?? {
                    multicall: true
                },
                transport: (parameters)=>rest.transports[chainId]({
                        ...parameters,
                        connectors: connectors
                    })
            });
        }
        clients.set(chainId, client);
        return client;
    }
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Create store
    /////////////////////////////////////////////////////////////////////////////////////////////////
    function getInitialState() {
        return {
            chainId: chains.getState()[0].id,
            connections: new Map(),
            current: null,
            status: "disconnected"
        };
    }
    let currentVersion;
    const prefix = "0.0.0-canary-";
    if ((0, $4wZB6.version).startsWith(prefix)) currentVersion = Number.parseInt((0, $4wZB6.version).replace(prefix, ""));
    else currentVersion = Number.parseInt((0, $4wZB6.version).split(".")[0] ?? "0");
    const store = (0, $ed571a1561f7ffa8$export$f51a9068ac82ea43)((0, $c329531445af2e84$export$5c593627aef9f076)(// only use persist middleware if storage exists
    storage ? (0, $c329531445af2e84$export$9a6132153fba2e0)(getInitialState, {
        migrate (persistedState, version) {
            if (version === currentVersion) return persistedState;
            const initialState = getInitialState();
            const chainId = validatePersistedChainId(persistedState, initialState.chainId);
            return {
                ...initialState,
                chainId: chainId
            };
        },
        name: "store",
        partialize (state) {
            // Only persist "critical" store properties to preserve storage size.
            return {
                connections: {
                    __type: "Map",
                    value: Array.from(state.connections.entries()).map(([key, connection])=>{
                        const { id: id, name: name, type: type, uid: uid } = connection.connector;
                        const connector = {
                            id: id,
                            name: name,
                            type: type,
                            uid: uid
                        };
                        return [
                            key,
                            {
                                ...connection,
                                connector: connector
                            }
                        ];
                    })
                },
                chainId: state.chainId,
                current: state.current
            };
        },
        merge (persistedState, currentState) {
            // `status` should not be persisted as it messes with reconnection
            if (typeof persistedState === "object" && persistedState && "status" in persistedState) delete persistedState.status;
            // Make sure persisted `chainId` is valid
            const chainId = validatePersistedChainId(persistedState, currentState.chainId);
            return {
                ...currentState,
                ...persistedState,
                chainId: chainId
            };
        },
        skipHydration: ssr,
        storage: storage,
        version: currentVersion
    }) : getInitialState));
    store.setState(getInitialState());
    function validatePersistedChainId(persistedState, defaultChainId) {
        return persistedState && typeof persistedState === "object" && "chainId" in persistedState && typeof persistedState.chainId === "number" && chains.getState().some((x)=>x.id === persistedState.chainId) ? persistedState.chainId : defaultChainId;
    }
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Subscribe to changes
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Update default chain when connector chain changes
    if (syncConnectedChain) store.subscribe(({ connections: connections, current: current })=>current ? connections.get(current)?.chainId : undefined, (chainId)=>{
        // If chain is not configured, then don't switch over to it.
        const isChainConfigured = chains.getState().some((x)=>x.id === chainId);
        if (!isChainConfigured) return;
        return store.setState((x)=>({
                ...x,
                chainId: chainId ?? x.chainId
            }));
    });
    // EIP-6963 subscribe for new wallet providers
    mipd?.subscribe((providerDetails)=>{
        const connectorIdSet = new Set();
        const connectorRdnsSet = new Set();
        for (const connector of connectors.getState()){
            connectorIdSet.add(connector.id);
            if (connector.rdns) {
                const rdnsValues = typeof connector.rdns === "string" ? [
                    connector.rdns
                ] : connector.rdns;
                for (const rdns of rdnsValues)connectorRdnsSet.add(rdns);
            }
        }
        const newConnectors = [];
        for (const providerDetail of providerDetails){
            if (connectorRdnsSet.has(providerDetail.info.rdns)) continue;
            const connector = setup(providerDetailToConnector(providerDetail));
            if (connectorIdSet.has(connector.id)) continue;
            newConnectors.push(connector);
        }
        if (storage && !store.persist.hasHydrated()) return;
        connectors.setState((x)=>[
                ...x,
                ...newConnectors
            ], true);
    });
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Emitter listeners
    /////////////////////////////////////////////////////////////////////////////////////////////////
    function change(data) {
        store.setState((x)=>{
            const connection = x.connections.get(data.uid);
            if (!connection) return x;
            return {
                ...x,
                connections: new Map(x.connections).set(data.uid, {
                    accounts: data.accounts ?? connection.accounts,
                    chainId: data.chainId ?? connection.chainId,
                    connector: connection.connector
                })
            };
        });
    }
    function connect(data) {
        // Disable handling if reconnecting/connecting
        if (store.getState().status === "connecting" || store.getState().status === "reconnecting") return;
        store.setState((x)=>{
            const connector = connectors.getState().find((x)=>x.uid === data.uid);
            if (!connector) return x;
            if (connector.emitter.listenerCount("connect")) connector.emitter.off("connect", change);
            if (!connector.emitter.listenerCount("change")) connector.emitter.on("change", change);
            if (!connector.emitter.listenerCount("disconnect")) connector.emitter.on("disconnect", disconnect);
            return {
                ...x,
                connections: new Map(x.connections).set(data.uid, {
                    accounts: data.accounts,
                    chainId: data.chainId,
                    connector: connector
                }),
                current: data.uid,
                status: "connected"
            };
        });
    }
    function disconnect(data) {
        store.setState((x)=>{
            const connection = x.connections.get(data.uid);
            if (connection) {
                const connector = connection.connector;
                if (connector.emitter.listenerCount("change")) connection.connector.emitter.off("change", change);
                if (connector.emitter.listenerCount("disconnect")) connection.connector.emitter.off("disconnect", disconnect);
                if (!connector.emitter.listenerCount("connect")) connection.connector.emitter.on("connect", connect);
            }
            x.connections.delete(data.uid);
            if (x.connections.size === 0) return {
                ...x,
                connections: new Map(),
                current: null,
                status: "disconnected"
            };
            const nextConnection = x.connections.values().next().value;
            return {
                ...x,
                connections: new Map(x.connections),
                current: nextConnection.connector.uid
            };
        });
    }
    return {
        get chains () {
            return chains.getState();
        },
        get connectors () {
            return connectors.getState();
        },
        storage: storage,
        getClient: getClient,
        get state () {
            return store.getState();
        },
        setState (value) {
            let newState;
            if (typeof value === "function") newState = value(store.getState());
            else newState = value;
            // Reset state if it got set to something not matching the base state
            const initialState = getInitialState();
            if (typeof newState !== "object") newState = initialState;
            const isCorrupt = Object.keys(initialState).some((x)=>!(x in newState));
            if (isCorrupt) newState = initialState;
            store.setState(newState, true);
        },
        subscribe (selector, listener, options) {
            return store.subscribe(selector, listener, options ? {
                ...options,
                fireImmediately: options.emitImmediately
            } : undefined);
        },
        _internal: {
            mipd: mipd,
            store: store,
            ssr: Boolean(ssr),
            syncConnectedChain: syncConnectedChain,
            transports: rest.transports,
            chains: {
                setState (value) {
                    const nextChains = typeof value === "function" ? value(chains.getState()) : value;
                    if (nextChains.length === 0) return;
                    return chains.setState(nextChains, true);
                },
                subscribe (listener) {
                    return chains.subscribe(listener);
                }
            },
            connectors: {
                providerDetailToConnector: providerDetailToConnector,
                setup: setup,
                setState (value) {
                    return connectors.setState(typeof value === "function" ? value(connectors.getState()) : value, true);
                },
                subscribe (listener) {
                    return connectors.subscribe(listener);
                }
            },
            events: {
                change: change,
                connect: connect,
                disconnect: disconnect
            }
        }
    };
}

/** https://wagmi.sh/core/api/actions/disconnect */ async function $63b5610077a80b6f$export$37dfea93db2e14ed(config, parameters = {}) {
    let connector;
    if (parameters.connector) connector = parameters.connector;
    else {
        const { connections: connections, current: current } = config.state;
        const connection = connections.get(current);
        connector = connection?.connector;
    }
    const connections = config.state.connections;
    if (connector) {
        await connector.disconnect();
        connector.emitter.off("change", config._internal.events.change);
        connector.emitter.off("disconnect", config._internal.events.disconnect);
        connector.emitter.on("connect", config._internal.events.connect);
        connections.delete(connector.uid);
    }
    config.setState((x)=>{
        // if no connections exist, move to disconnected state
        if (connections.size === 0) return {
            ...x,
            connections: new Map(),
            current: null,
            status: "disconnected"
        };
        // switch over to another connection
        const nextConnection = connections.values().next().value;
        return {
            ...x,
            connections: new Map(connections),
            current: nextConnection.connector.uid
        };
    });
    // Set recent connector if exists
    {
        const current = config.state.current;
        if (!current) return;
        const connector = config.state.connections.get(current)?.connector;
        if (!connector) return;
        await config.storage?.setItem("recentConnectorId", connector.id);
    }
}


var $fbsYZ = parcelRequire("fbsYZ");

var $3cVvs = parcelRequire("3cVvs");

var $bOQZu = parcelRequire("bOQZu");

var $bHm1a = parcelRequire("bHm1a");
function $0ca941d3e462d662$export$462669520a9d12d1(publicKey) {
    const address = (0, $bHm1a.keccak256)(`0x${publicKey.substring(4)}`).substring(26);
    return (0, $bOQZu.checksumAddress)(`0x${address}`);
}



var $ifibB = parcelRequire("ifibB");

var $loik3 = parcelRequire("loik3");

var $9Hxnd = parcelRequire("9Hxnd");

var $nDot9 = parcelRequire("nDot9");

async function $ca2d1454c87bee0d$export$952dd09fbe0232b7({ hash: hash, signature: signature }) {
    const hashHex = (0, $ifibB.isHex)(hash) ? hash : (0, $nDot9.toHex)(hash);
    const { secp256k1: secp256k1 } = await Promise.resolve((parcelRequire("7pdKa")));
    const signature_ = (()=>{
        // typeof signature: `Signature`
        if (typeof signature === "object" && "r" in signature && "s" in signature) {
            const { r: r, s: s, v: v, yParity: yParity } = signature;
            const yParityOrV = Number(yParity ?? v);
            const recoveryBit = $ca2d1454c87bee0d$var$toRecoveryBit(yParityOrV);
            return new secp256k1.Signature((0, $9Hxnd.hexToBigInt)(r), (0, $9Hxnd.hexToBigInt)(s)).addRecoveryBit(recoveryBit);
        }
        // typeof signature: `Hex | ByteArray`
        const signatureHex = (0, $ifibB.isHex)(signature) ? signature : (0, $nDot9.toHex)(signature);
        if ((0, $loik3.size)(signatureHex) !== 65) throw new Error("invalid signature length");
        const yParityOrV = (0, $9Hxnd.hexToNumber)(`0x${signatureHex.slice(130)}`);
        const recoveryBit = $ca2d1454c87bee0d$var$toRecoveryBit(yParityOrV);
        return secp256k1.Signature.fromCompact(signatureHex.substring(2, 130)).addRecoveryBit(recoveryBit);
    })();
    const publicKey = signature_.recoverPublicKey(hashHex.substring(2)).toHex(false);
    return `0x${publicKey}`;
}
function $ca2d1454c87bee0d$var$toRecoveryBit(yParityOrV) {
    if (yParityOrV === 0 || yParityOrV === 1) return yParityOrV;
    if (yParityOrV === 27) return 0;
    if (yParityOrV === 28) return 1;
    throw new Error("Invalid yParityOrV value");
}


async function $ac126831f828e3dd$export$23cc18f96d8510e2({ hash: hash, signature: signature }) {
    return (0, $0ca941d3e462d662$export$462669520a9d12d1)(await (0, $ca2d1454c87bee0d$export$952dd09fbe0232b7)({
        hash: hash,
        signature: signature
    }));
}



var $04Jxx = parcelRequire("04Jxx");

var $lbhq0 = parcelRequire("lbhq0");

var $nDot9 = parcelRequire("nDot9");

var $3cVvs = parcelRequire("3cVvs");

var $7gKPm = parcelRequire("7gKPm");

var $lbhq0 = parcelRequire("lbhq0");

var $nDot9 = parcelRequire("nDot9");
function $12afd6c4dd2bd250$export$140c78e750979cda(bytes, to = "hex") {
    const encodable = $12afd6c4dd2bd250$var$getEncodable(bytes);
    const cursor = (0, $7gKPm.createCursor)(new Uint8Array(encodable.length));
    encodable.encode(cursor);
    if (to === "hex") return (0, $nDot9.bytesToHex)(cursor.bytes);
    return cursor.bytes;
}
function $12afd6c4dd2bd250$export$643d3163062ff0f3(bytes, to = "bytes") {
    return $12afd6c4dd2bd250$export$140c78e750979cda(bytes, to);
}
function $12afd6c4dd2bd250$export$e01da38311234e95(hex, to = "hex") {
    return $12afd6c4dd2bd250$export$140c78e750979cda(hex, to);
}
function $12afd6c4dd2bd250$var$getEncodable(bytes) {
    if (Array.isArray(bytes)) return $12afd6c4dd2bd250$var$getEncodableList(bytes.map((x)=>$12afd6c4dd2bd250$var$getEncodable(x)));
    return $12afd6c4dd2bd250$var$getEncodableBytes(bytes);
}
function $12afd6c4dd2bd250$var$getEncodableList(list) {
    const bodyLength = list.reduce((acc, x)=>acc + x.length, 0);
    const sizeOfBodyLength = $12afd6c4dd2bd250$var$getSizeOfLength(bodyLength);
    const length = (()=>{
        if (bodyLength <= 55) return 1 + bodyLength;
        return 1 + sizeOfBodyLength + bodyLength;
    })();
    return {
        length: length,
        encode (cursor) {
            if (bodyLength <= 55) cursor.pushByte(0xc0 + bodyLength);
            else {
                cursor.pushByte(247 + sizeOfBodyLength);
                if (sizeOfBodyLength === 1) cursor.pushUint8(bodyLength);
                else if (sizeOfBodyLength === 2) cursor.pushUint16(bodyLength);
                else if (sizeOfBodyLength === 3) cursor.pushUint24(bodyLength);
                else cursor.pushUint32(bodyLength);
            }
            for (const { encode: encode } of list)encode(cursor);
        }
    };
}
function $12afd6c4dd2bd250$var$getEncodableBytes(bytesOrHex) {
    const bytes = typeof bytesOrHex === "string" ? (0, $lbhq0.hexToBytes)(bytesOrHex) : bytesOrHex;
    const sizeOfBytesLength = $12afd6c4dd2bd250$var$getSizeOfLength(bytes.length);
    const length = (()=>{
        if (bytes.length === 1 && bytes[0] < 0x80) return 1;
        if (bytes.length <= 55) return 1 + bytes.length;
        return 1 + sizeOfBytesLength + bytes.length;
    })();
    return {
        length: length,
        encode (cursor) {
            if (bytes.length === 1 && bytes[0] < 0x80) cursor.pushBytes(bytes);
            else if (bytes.length <= 55) {
                cursor.pushByte(0x80 + bytes.length);
                cursor.pushBytes(bytes);
            } else {
                cursor.pushByte(183 + sizeOfBytesLength);
                if (sizeOfBytesLength === 1) cursor.pushUint8(bytes.length);
                else if (sizeOfBytesLength === 2) cursor.pushUint16(bytes.length);
                else if (sizeOfBytesLength === 3) cursor.pushUint24(bytes.length);
                else cursor.pushUint32(bytes.length);
                cursor.pushBytes(bytes);
            }
        }
    };
}
function $12afd6c4dd2bd250$var$getSizeOfLength(length) {
    if (length < 256) return 1;
    if (length < 2 ** 16) return 2;
    if (length < 2 ** 24) return 3;
    if (length < 2 ** 32) return 4;
    throw new (0, $3cVvs.BaseError)("Length is too large.");
}



var $bHm1a = parcelRequire("bHm1a");
function $b20ae74128405477$export$52e574e057b290dc(parameters) {
    const { chainId: chainId, nonce: nonce, to: to } = parameters;
    const address = parameters.contractAddress ?? parameters.address;
    const hash = (0, $bHm1a.keccak256)((0, $04Jxx.concatHex)([
        "0x05",
        (0, $12afd6c4dd2bd250$export$140c78e750979cda)([
            chainId ? (0, $nDot9.numberToHex)(chainId) : "0x",
            address,
            nonce ? (0, $nDot9.numberToHex)(nonce) : "0x"
        ])
    ]));
    if (to === "bytes") return (0, $lbhq0.hexToBytes)(hash);
    return hash;
}


async function $a3352ab597e57927$export$415d0315604a8515(parameters) {
    const { authorization: authorization, signature: signature } = parameters;
    return (0, $ac126831f828e3dd$export$23cc18f96d8510e2)({
        hash: (0, $b20ae74128405477$export$52e574e057b290dc)(authorization),
        signature: signature ?? authorization
    });
}



var $nDot9 = parcelRequire("nDot9");

var $huI8N = parcelRequire("huI8N");

var $iQ1Hl = parcelRequire("iQ1Hl");

var $3cVvs = parcelRequire("3cVvs");

var $lfct8 = parcelRequire("lfct8");
class $e3ca225051443be0$export$9e393e362ab0c102 extends (0, $3cVvs.BaseError) {
    constructor(cause, { account: account, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }){
        const prettyArgs = (0, $lfct8.prettyPrint)({
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $huI8N.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $iQ1Hl.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $iQ1Hl.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $iQ1Hl.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Estimate Gas Arguments:",
                prettyArgs
            ].filter(Boolean),
            name: "EstimateGasExecutionError"
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cause = cause;
    }
}



var $hOdyB = parcelRequire("hOdyB");

var $b0rjl = parcelRequire("b0rjl");
function $6bcd7c728bb232ab$export$f201b805dbcd7c48(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $b0rjl.getNodeError)(err, args);
        if (cause instanceof (0, $hOdyB.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $e3ca225051443be0$export$9e393e362ab0c102)(cause, {
        docsPath: docsPath,
        ...args
    });
}



var $6ztP3 = parcelRequire("6ztP3");

var $csK11 = parcelRequire("csK11");

var $6Pzc8 = parcelRequire("6Pzc8");

var $hQGp6 = parcelRequire("hQGp6");

var $fbsYZ = parcelRequire("fbsYZ");

var $iQ1Hl = parcelRequire("iQ1Hl");

var $3cVvs = parcelRequire("3cVvs");
class $8ac6ceb86692bbba$export$200c092bedf29ac0 extends (0, $3cVvs.BaseError) {
    constructor(){
        super("`baseFeeMultiplier` must be greater than 1.", {
            name: "BaseFeeScalarError"
        });
    }
}
class $8ac6ceb86692bbba$export$dcf53c0ae183fb46 extends (0, $3cVvs.BaseError) {
    constructor(){
        super("Chain does not support EIP-1559 fees.", {
            name: "Eip1559FeesNotSupportedError"
        });
    }
}
class $8ac6ceb86692bbba$export$bcf9730904a1086f extends (0, $3cVvs.BaseError) {
    constructor({ maxPriorityFeePerGas: maxPriorityFeePerGas }){
        super(`\`maxFeePerGas\` cannot be less than the \`maxPriorityFeePerGas\` (${(0, $iQ1Hl.formatGwei)(maxPriorityFeePerGas)} gwei).`, {
            name: "MaxFeePerGasTooLowError"
        });
    }
}


/**
 * Retrieves and returns an action from the client (if exists), and falls
 * back to the tree-shakable action.
 *
 * Useful for extracting overridden actions from a client (ie. if a consumer
 * wants to override the `sendTransaction` implementation).
 */ function $1942e1266009a208$export$6ca3170acb89054(client, actionFn, // Some minifiers drop `Function.prototype.name`, or replace it with short letters,
// meaning that `actionFn.name` will not always work. For that case, the consumer
// needs to pass the name explicitly.
name) {
    const action_implicit = client[actionFn.name];
    if (typeof action_implicit === "function") return action_implicit;
    const action_explicit = client[name];
    if (typeof action_explicit === "function") return action_explicit;
    return (params)=>actionFn(client, params);
}




var $9Hxnd = parcelRequire("9Hxnd");


var $3cVvs = parcelRequire("3cVvs");
class $eba37413c57b7950$export$f5a00468af285e38 extends (0, $3cVvs.BaseError) {
    constructor({ blockHash: blockHash, blockNumber: blockNumber }){
        let identifier = "Block";
        if (blockHash) identifier = `Block at hash "${blockHash}"`;
        if (blockNumber) identifier = `Block at number "${blockNumber}"`;
        super(`${identifier} could not be found.`, {
            name: "BlockNotFoundError"
        });
    }
}



var $nDot9 = parcelRequire("nDot9");

var $4jLjg = parcelRequire("4jLjg");

var $9Hxnd = parcelRequire("9Hxnd");

var $4jLjg = parcelRequire("4jLjg");
const $fc8eee6bab3ad68f$export$cd5f936b62a5e91 = {
    "0x0": "legacy",
    "0x1": "eip2930",
    "0x2": "eip1559",
    "0x3": "eip4844",
    "0x4": "eip7702"
};
function $fc8eee6bab3ad68f$export$b02b16590d26dadc(transaction) {
    const transaction_ = {
        ...transaction,
        blockHash: transaction.blockHash ? transaction.blockHash : null,
        blockNumber: transaction.blockNumber ? BigInt(transaction.blockNumber) : null,
        chainId: transaction.chainId ? (0, $9Hxnd.hexToNumber)(transaction.chainId) : undefined,
        gas: transaction.gas ? BigInt(transaction.gas) : undefined,
        gasPrice: transaction.gasPrice ? BigInt(transaction.gasPrice) : undefined,
        maxFeePerBlobGas: transaction.maxFeePerBlobGas ? BigInt(transaction.maxFeePerBlobGas) : undefined,
        maxFeePerGas: transaction.maxFeePerGas ? BigInt(transaction.maxFeePerGas) : undefined,
        maxPriorityFeePerGas: transaction.maxPriorityFeePerGas ? BigInt(transaction.maxPriorityFeePerGas) : undefined,
        nonce: transaction.nonce ? (0, $9Hxnd.hexToNumber)(transaction.nonce) : undefined,
        to: transaction.to ? transaction.to : null,
        transactionIndex: transaction.transactionIndex ? Number(transaction.transactionIndex) : null,
        type: transaction.type ? $fc8eee6bab3ad68f$export$cd5f936b62a5e91[transaction.type] : undefined,
        typeHex: transaction.type ? transaction.type : undefined,
        value: transaction.value ? BigInt(transaction.value) : undefined,
        v: transaction.v ? BigInt(transaction.v) : undefined
    };
    if (transaction.authorizationList) transaction_.authorizationList = $fc8eee6bab3ad68f$var$formatAuthorizationList(transaction.authorizationList);
    transaction_.yParity = (()=>{
        // If `yParity` is provided, we will use it.
        if (transaction.yParity) return Number(transaction.yParity);
        // If no `yParity` provided, try derive from `v`.
        if (typeof transaction_.v === "bigint") {
            if (transaction_.v === 0n || transaction_.v === 27n) return 0;
            if (transaction_.v === 1n || transaction_.v === 28n) return 1;
            if (transaction_.v >= 35n) return transaction_.v % 2n === 0n ? 1 : 0;
        }
        return undefined;
    })();
    if (transaction_.type === "legacy") {
        delete transaction_.accessList;
        delete transaction_.maxFeePerBlobGas;
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
        delete transaction_.yParity;
    }
    if (transaction_.type === "eip2930") {
        delete transaction_.maxFeePerBlobGas;
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
    }
    if (transaction_.type === "eip1559") delete transaction_.maxFeePerBlobGas;
    return transaction_;
}
const $fc8eee6bab3ad68f$export$c19bdc7dbe69198d = /*#__PURE__*/ (0, $4jLjg.defineFormatter)("transaction", $fc8eee6bab3ad68f$export$b02b16590d26dadc);
//////////////////////////////////////////////////////////////////////////////
function $fc8eee6bab3ad68f$var$formatAuthorizationList(authorizationList) {
    return authorizationList.map((authorization)=>({
            address: authorization.address,
            chainId: Number(authorization.chainId),
            nonce: Number(authorization.nonce),
            r: authorization.r,
            s: authorization.s,
            yParity: Number(authorization.yParity)
        }));
}


function $6a25535181bf6099$export$ba1152bc4017d62a(block) {
    const transactions = (block.transactions ?? []).map((transaction)=>{
        if (typeof transaction === "string") return transaction;
        return (0, $fc8eee6bab3ad68f$export$b02b16590d26dadc)(transaction);
    });
    return {
        ...block,
        baseFeePerGas: block.baseFeePerGas ? BigInt(block.baseFeePerGas) : null,
        blobGasUsed: block.blobGasUsed ? BigInt(block.blobGasUsed) : undefined,
        difficulty: block.difficulty ? BigInt(block.difficulty) : undefined,
        excessBlobGas: block.excessBlobGas ? BigInt(block.excessBlobGas) : undefined,
        gasLimit: block.gasLimit ? BigInt(block.gasLimit) : undefined,
        gasUsed: block.gasUsed ? BigInt(block.gasUsed) : undefined,
        hash: block.hash ? block.hash : null,
        logsBloom: block.logsBloom ? block.logsBloom : null,
        nonce: block.nonce ? block.nonce : null,
        number: block.number ? BigInt(block.number) : null,
        size: block.size ? BigInt(block.size) : undefined,
        timestamp: block.timestamp ? BigInt(block.timestamp) : undefined,
        transactions: transactions,
        totalDifficulty: block.totalDifficulty ? BigInt(block.totalDifficulty) : null
    };
}
const $6a25535181bf6099$export$9f35cb3327f1a5c5 = /*#__PURE__*/ (0, $4jLjg.defineFormatter)("block", $6a25535181bf6099$export$ba1152bc4017d62a);


async function $46802f01c8edc21d$export$ea0af84ed2e77902(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag_, includeTransactions: includeTransactions_ } = {}) {
    const blockTag = blockTag_ ?? "latest";
    const includeTransactions = includeTransactions_ ?? false;
    const blockNumberHex = blockNumber !== undefined ? (0, $nDot9.numberToHex)(blockNumber) : undefined;
    let block = null;
    if (blockHash) block = await client.request({
        method: "eth_getBlockByHash",
        params: [
            blockHash,
            includeTransactions
        ]
    }, {
        dedupe: true
    });
    else block = await client.request({
        method: "eth_getBlockByNumber",
        params: [
            blockNumberHex || blockTag,
            includeTransactions
        ]
    }, {
        dedupe: Boolean(blockNumberHex)
    });
    if (!block) throw new (0, $eba37413c57b7950$export$f5a00468af285e38)({
        blockHash: blockHash,
        blockNumber: blockNumber
    });
    const format = client.chain?.formatters?.block?.format || (0, $6a25535181bf6099$export$ba1152bc4017d62a);
    return format(block);
}


/**
 * Returns the current price of gas (in wei).
 *
 * - Docs: https://viem.sh/docs/actions/public/getGasPrice
 * - JSON-RPC Methods: [`eth_gasPrice`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_gasprice)
 *
 * @param client - Client to use
 * @returns The gas price (in wei). {@link GetGasPriceReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getGasPrice } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const gasPrice = await getGasPrice(client)
 */ async function $4fc767dcb44c9317$export$89c15b50d46d3f8c(client) {
    const gasPrice = await client.request({
        method: "eth_gasPrice"
    });
    return BigInt(gasPrice);
}


async function $daec7068e3869d08$export$fd79a693887f886c(client, args) {
    return $daec7068e3869d08$export$59275bafd388148(client, args);
}
async function $daec7068e3869d08$export$59275bafd388148(client, args) {
    const { block: block_, chain: chain = client.chain, request: request } = args || {};
    try {
        const maxPriorityFeePerGas = chain?.fees?.maxPriorityFeePerGas ?? chain?.fees?.defaultPriorityFee;
        if (typeof maxPriorityFeePerGas === "function") {
            const block = block_ || await (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $46802f01c8edc21d$export$ea0af84ed2e77902), "getBlock")({});
            const maxPriorityFeePerGas_ = await maxPriorityFeePerGas({
                block: block,
                client: client,
                request: request
            });
            if (maxPriorityFeePerGas_ === null) throw new Error();
            return maxPriorityFeePerGas_;
        }
        if (typeof maxPriorityFeePerGas !== "undefined") return maxPriorityFeePerGas;
        const maxPriorityFeePerGasHex = await client.request({
            method: "eth_maxPriorityFeePerGas"
        });
        return (0, $9Hxnd.hexToBigInt)(maxPriorityFeePerGasHex);
    } catch  {
        // If the RPC Provider does not support `eth_maxPriorityFeePerGas`
        // fall back to calculating it manually via `gasPrice - baseFeePerGas`.
        // See: https://github.com/ethereum/pm/issues/328#:~:text=eth_maxPriorityFeePerGas%20after%20London%20will%20effectively%20return%20eth_gasPrice%20%2D%20baseFee
        const [block, gasPrice] = await Promise.all([
            block_ ? Promise.resolve(block_) : (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $46802f01c8edc21d$export$ea0af84ed2e77902), "getBlock")({}),
            (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $4fc767dcb44c9317$export$89c15b50d46d3f8c), "getGasPrice")({})
        ]);
        if (typeof block.baseFeePerGas !== "bigint") throw new (0, $8ac6ceb86692bbba$export$dcf53c0ae183fb46)();
        const maxPriorityFeePerGas = gasPrice - block.baseFeePerGas;
        if (maxPriorityFeePerGas < 0n) return 0n;
        return maxPriorityFeePerGas;
    }
}




async function $2268cbc7c5ccd444$export$8193bed8c46d2831(client, args) {
    return $2268cbc7c5ccd444$export$67115e8707c5a9e(client, args);
}
async function $2268cbc7c5ccd444$export$67115e8707c5a9e(client, args) {
    const { block: block_, chain: chain = client.chain, request: request, type: type = "eip1559" } = args || {};
    const baseFeeMultiplier = await (async ()=>{
        if (typeof chain?.fees?.baseFeeMultiplier === "function") return chain.fees.baseFeeMultiplier({
            block: block_,
            client: client,
            request: request
        });
        return chain?.fees?.baseFeeMultiplier ?? 1.2;
    })();
    if (baseFeeMultiplier < 1) throw new (0, $8ac6ceb86692bbba$export$200c092bedf29ac0)();
    const decimals = baseFeeMultiplier.toString().split(".")[1]?.length ?? 0;
    const denominator = 10 ** decimals;
    const multiply = (base)=>base * BigInt(Math.ceil(baseFeeMultiplier * denominator)) / BigInt(denominator);
    const block = block_ ? block_ : await (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $46802f01c8edc21d$export$ea0af84ed2e77902), "getBlock")({});
    if (typeof chain?.fees?.estimateFeesPerGas === "function") {
        const fees = await chain.fees.estimateFeesPerGas({
            block: block_,
            client: client,
            multiply: multiply,
            request: request,
            type: type
        });
        if (fees !== null) return fees;
    }
    if (type === "eip1559") {
        if (typeof block.baseFeePerGas !== "bigint") throw new (0, $8ac6ceb86692bbba$export$dcf53c0ae183fb46)();
        const maxPriorityFeePerGas = typeof request?.maxPriorityFeePerGas === "bigint" ? request.maxPriorityFeePerGas : await (0, $daec7068e3869d08$export$59275bafd388148)(client, {
            block: block,
            chain: chain,
            request: request
        });
        const baseFeePerGas = multiply(block.baseFeePerGas);
        const maxFeePerGas = request?.maxFeePerGas ?? baseFeePerGas + maxPriorityFeePerGas;
        return {
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas
        };
    }
    const gasPrice = request?.gasPrice ?? multiply(await (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $4fc767dcb44c9317$export$89c15b50d46d3f8c), "getGasPrice")({}));
    return {
        gasPrice: gasPrice
    };
}





var $9Hxnd = parcelRequire("9Hxnd");

var $nDot9 = parcelRequire("nDot9");
async function $c78c201fb851919e$export$b18e66333ec1361e(client, { address: address, blockTag: blockTag = "latest", blockNumber: blockNumber }) {
    const count = await client.request({
        method: "eth_getTransactionCount",
        params: [
            address,
            typeof blockNumber === "bigint" ? (0, $nDot9.numberToHex)(blockNumber) : blockTag
        ]
    }, {
        dedupe: Boolean(blockNumber)
    });
    return (0, $9Hxnd.hexToNumber)(count);
}




var $lbhq0 = parcelRequire("lbhq0");

var $nDot9 = parcelRequire("nDot9");
function $78f8601335f903af$export$b67626aab22a659b(parameters) {
    const { kzg: kzg } = parameters;
    const to = parameters.to ?? (typeof parameters.blobs[0] === "string" ? "hex" : "bytes");
    const blobs = typeof parameters.blobs[0] === "string" ? parameters.blobs.map((x)=>(0, $lbhq0.hexToBytes)(x)) : parameters.blobs;
    const commitments = [];
    for (const blob of blobs)commitments.push(Uint8Array.from(kzg.blobToKzgCommitment(blob)));
    return to === "bytes" ? commitments : commitments.map((x)=>(0, $nDot9.bytesToHex)(x));
}



var $lbhq0 = parcelRequire("lbhq0");

var $nDot9 = parcelRequire("nDot9");
function $c253dc2b82943204$export$78a225f8922765eb(parameters) {
    const { kzg: kzg } = parameters;
    const to = parameters.to ?? (typeof parameters.blobs[0] === "string" ? "hex" : "bytes");
    const blobs = typeof parameters.blobs[0] === "string" ? parameters.blobs.map((x)=>(0, $lbhq0.hexToBytes)(x)) : parameters.blobs;
    const commitments = typeof parameters.commitments[0] === "string" ? parameters.commitments.map((x)=>(0, $lbhq0.hexToBytes)(x)) : parameters.commitments;
    const proofs = [];
    for(let i = 0; i < blobs.length; i++){
        const blob = blobs[i];
        const commitment = commitments[i];
        proofs.push(Uint8Array.from(kzg.computeBlobKzgProof(blob, commitment)));
    }
    return to === "bytes" ? proofs : proofs.map((x)=>(0, $nDot9.bytesToHex)(x));
}



var $nDot9 = parcelRequire("nDot9");

var $6kbuD = parcelRequire("6kbuD");

var $ifibB = parcelRequire("ifibB");

var $lbhq0 = parcelRequire("lbhq0");

var $nDot9 = parcelRequire("nDot9");
function $ffe356ff1a05f888$export$bced8d2aada2d1c9(value, to_) {
    const to = to_ || "hex";
    const bytes = (0, $6kbuD.sha256)((0, $ifibB.isHex)(value, {
        strict: false
    }) ? (0, $lbhq0.toBytes)(value) : value);
    if (to === "bytes") return bytes;
    return (0, $nDot9.toHex)(bytes);
}


function $a8b517630d9c54fe$export$7b2f762c7eb1ecea(parameters) {
    const { commitment: commitment, version: version = 1 } = parameters;
    const to = parameters.to ?? (typeof commitment === "string" ? "hex" : "bytes");
    const versionedHash = (0, $ffe356ff1a05f888$export$bced8d2aada2d1c9)(commitment, "bytes");
    versionedHash.set([
        version
    ], 0);
    return to === "bytes" ? versionedHash : (0, $nDot9.bytesToHex)(versionedHash);
}


function $a79835f0229d5c49$export$e31b3e59dda37b17(parameters) {
    const { commitments: commitments, version: version } = parameters;
    const to = parameters.to ?? (typeof commitments[0] === "string" ? "hex" : "bytes");
    const hashes = [];
    for (const commitment of commitments)hashes.push((0, $a8b517630d9c54fe$export$7b2f762c7eb1ecea)({
        commitment: commitment,
        to: to,
        version: version
    }));
    return hashes;
}




// https://github.com/ethereum/EIPs/blob/master/EIPS/eip-4844.md#parameters
/** Blob limit per transaction. */ const $b97754026c601dbf$var$blobsPerTransaction = 6;
const $b97754026c601dbf$export$a5d2a246d959344 = 32;
const $b97754026c601dbf$export$57577a1a84b7e334 = 4096;
const $b97754026c601dbf$export$6f30828563a6c6ef = $b97754026c601dbf$export$a5d2a246d959344 * $b97754026c601dbf$export$57577a1a84b7e334;
const $b97754026c601dbf$export$b8db4e3f07d08e09 = $b97754026c601dbf$export$6f30828563a6c6ef * $b97754026c601dbf$var$blobsPerTransaction - // terminator byte (0x80).
1 - // zero byte (0x00) appended to each field element.
1 * $b97754026c601dbf$export$57577a1a84b7e334 * $b97754026c601dbf$var$blobsPerTransaction;


// https://github.com/ethereum/EIPs/blob/master/EIPS/eip-4844.md#parameters
const $c9ac0a0bc44bccdb$export$de38d5f871f0b1cd = 1;



var $3cVvs = parcelRequire("3cVvs");
class $a8d6b296d9742f43$export$4000e90bfe41caa1 extends (0, $3cVvs.BaseError) {
    constructor({ maxSize: maxSize, size: size }){
        super("Blob size is too large.", {
            metaMessages: [
                `Max: ${maxSize} bytes`,
                `Given: ${size} bytes`
            ],
            name: "BlobSizeTooLargeError"
        });
    }
}
class $a8d6b296d9742f43$export$d145394ceab4d1c3 extends (0, $3cVvs.BaseError) {
    constructor(){
        super("Blob data must not be empty.", {
            name: "EmptyBlobError"
        });
    }
}
class $a8d6b296d9742f43$export$ebd5b15dd92c680 extends (0, $3cVvs.BaseError) {
    constructor({ hash: hash, size: size }){
        super(`Versioned hash "${hash}" size is invalid.`, {
            metaMessages: [
                "Expected: 32",
                `Received: ${size}`
            ],
            name: "InvalidVersionedHashSizeError"
        });
    }
}
class $a8d6b296d9742f43$export$509ed1d312c500 extends (0, $3cVvs.BaseError) {
    constructor({ hash: hash, version: version }){
        super(`Versioned hash "${hash}" version is invalid.`, {
            metaMessages: [
                `Expected: ${(0, $c9ac0a0bc44bccdb$export$de38d5f871f0b1cd)}`,
                `Received: ${version}`
            ],
            name: "InvalidVersionedHashVersionError"
        });
    }
}



var $7gKPm = parcelRequire("7gKPm");

var $loik3 = parcelRequire("loik3");

var $lbhq0 = parcelRequire("lbhq0");

var $nDot9 = parcelRequire("nDot9");
function $4f3fd1af2a1dd9ea$export$7ec339bd77d6ed92(parameters) {
    const to = parameters.to ?? (typeof parameters.data === "string" ? "hex" : "bytes");
    const data = typeof parameters.data === "string" ? (0, $lbhq0.hexToBytes)(parameters.data) : parameters.data;
    const size_ = (0, $loik3.size)(data);
    if (!size_) throw new (0, $a8d6b296d9742f43$export$d145394ceab4d1c3)();
    if (size_ > (0, $b97754026c601dbf$export$b8db4e3f07d08e09)) throw new (0, $a8d6b296d9742f43$export$4000e90bfe41caa1)({
        maxSize: (0, $b97754026c601dbf$export$b8db4e3f07d08e09),
        size: size_
    });
    const blobs = [];
    let active = true;
    let position = 0;
    while(active){
        const blob = (0, $7gKPm.createCursor)(new Uint8Array((0, $b97754026c601dbf$export$6f30828563a6c6ef)));
        let size = 0;
        while(size < (0, $b97754026c601dbf$export$57577a1a84b7e334)){
            const bytes = data.slice(position, position + ((0, $b97754026c601dbf$export$a5d2a246d959344) - 1));
            // Push a zero byte so the field element doesn't overflow the BLS modulus.
            blob.pushByte(0x00);
            // Push the current segment of data bytes.
            blob.pushBytes(bytes);
            // If we detect that the current segment of data bytes is less than 31 bytes,
            // we can stop processing and push a terminator byte to indicate the end of the blob.
            if (bytes.length < 31) {
                blob.pushByte(0x80);
                active = false;
                break;
            }
            size++;
            position += 31;
        }
        blobs.push(blob);
    }
    return to === "bytes" ? blobs.map((x)=>x.bytes) : blobs.map((x)=>(0, $nDot9.bytesToHex)(x.bytes));
}


function $f61f1f911cd55ec3$export$44960962e1c9641b(parameters) {
    const { data: data, kzg: kzg, to: to } = parameters;
    const blobs = parameters.blobs ?? (0, $4f3fd1af2a1dd9ea$export$7ec339bd77d6ed92)({
        data: data,
        to: to
    });
    const commitments = parameters.commitments ?? (0, $78f8601335f903af$export$b67626aab22a659b)({
        blobs: blobs,
        kzg: kzg,
        to: to
    });
    const proofs = parameters.proofs ?? (0, $c253dc2b82943204$export$78a225f8922765eb)({
        blobs: blobs,
        commitments: commitments,
        kzg: kzg,
        to: to
    });
    const sidecars = [];
    for(let i = 0; i < blobs.length; i++)sidecars.push({
        blob: blobs[i],
        commitment: commitments[i],
        proof: proofs[i]
    });
    return sidecars;
}




var $hQGp6 = parcelRequire("hQGp6");

var $lfct8 = parcelRequire("lfct8");
function $88de7271e7e1033c$export$944c6678cd5a1ea8(transaction) {
    if (transaction.type) return transaction.type;
    if (typeof transaction.authorizationList !== "undefined") return "eip7702";
    if (typeof transaction.blobs !== "undefined" || typeof transaction.blobVersionedHashes !== "undefined" || typeof transaction.maxFeePerBlobGas !== "undefined" || typeof transaction.sidecars !== "undefined") return "eip4844";
    if (typeof transaction.maxFeePerGas !== "undefined" || typeof transaction.maxPriorityFeePerGas !== "undefined") return "eip1559";
    if (typeof transaction.gasPrice !== "undefined") {
        if (typeof transaction.accessList !== "undefined") return "eip2930";
        return "legacy";
    }
    throw new (0, $lfct8.InvalidSerializableTransactionError)({
        transaction: transaction
    });
}



var $9Hxnd = parcelRequire("9Hxnd");
async function $a8187a7531df30a7$export$850fa7b3891187c(client) {
    const chainIdHex = await client.request({
        method: "eth_chainId"
    }, {
        dedupe: true
    });
    return (0, $9Hxnd.hexToNumber)(chainIdHex);
}


const $a8cddba47d5ae2a7$export$4f3e0c2bc77eca55 = [
    "blobVersionedHashes",
    "chainId",
    "fees",
    "gas",
    "nonce",
    "type"
];
const $a8cddba47d5ae2a7$export$1cdc34309351bc26 = /*#__PURE__*/ new Map();
async function $a8cddba47d5ae2a7$export$2e8a9232fb815d77(client, args) {
    const { account: account_ = client.account, blobs: blobs, chain: chain, gas: gas, kzg: kzg, nonce: nonce, nonceManager: nonceManager, parameters: parameters = $a8cddba47d5ae2a7$export$4f3e0c2bc77eca55, type: type } = args;
    const account = account_ ? (0, $fbsYZ.parseAccount)(account_) : account_;
    const request = {
        ...args,
        ...account ? {
            from: account?.address
        } : {}
    };
    let block;
    async function getBlock() {
        if (block) return block;
        block = await (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $46802f01c8edc21d$export$ea0af84ed2e77902), "getBlock")({
            blockTag: "latest"
        });
        return block;
    }
    let chainId;
    async function getChainId() {
        if (chainId) return chainId;
        if (chain) return chain.id;
        if (typeof args.chainId !== "undefined") return args.chainId;
        const chainId_ = await (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $a8187a7531df30a7$export$850fa7b3891187c), "getChainId")({});
        chainId = chainId_;
        return chainId;
    }
    if (parameters.includes("nonce") && typeof nonce === "undefined" && account) {
        if (nonceManager) {
            const chainId = await getChainId();
            request.nonce = await nonceManager.consume({
                address: account.address,
                chainId: chainId,
                client: client
            });
        } else request.nonce = await (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $c78c201fb851919e$export$b18e66333ec1361e), "getTransactionCount")({
            address: account.address,
            blockTag: "pending"
        });
    }
    if ((parameters.includes("blobVersionedHashes") || parameters.includes("sidecars")) && blobs && kzg) {
        const commitments = (0, $78f8601335f903af$export$b67626aab22a659b)({
            blobs: blobs,
            kzg: kzg
        });
        if (parameters.includes("blobVersionedHashes")) {
            const versionedHashes = (0, $a79835f0229d5c49$export$e31b3e59dda37b17)({
                commitments: commitments,
                to: "hex"
            });
            request.blobVersionedHashes = versionedHashes;
        }
        if (parameters.includes("sidecars")) {
            const proofs = (0, $c253dc2b82943204$export$78a225f8922765eb)({
                blobs: blobs,
                commitments: commitments,
                kzg: kzg
            });
            const sidecars = (0, $f61f1f911cd55ec3$export$44960962e1c9641b)({
                blobs: blobs,
                commitments: commitments,
                proofs: proofs,
                to: "hex"
            });
            request.sidecars = sidecars;
        }
    }
    if (parameters.includes("chainId")) request.chainId = await getChainId();
    if ((parameters.includes("fees") || parameters.includes("type")) && typeof type === "undefined") try {
        request.type = (0, $88de7271e7e1033c$export$944c6678cd5a1ea8)(request);
    } catch  {
        let isEip1559Network = $a8cddba47d5ae2a7$export$1cdc34309351bc26.get(client.uid);
        if (typeof isEip1559Network === "undefined") {
            const block = await getBlock();
            isEip1559Network = typeof block?.baseFeePerGas === "bigint";
            $a8cddba47d5ae2a7$export$1cdc34309351bc26.set(client.uid, isEip1559Network);
        }
        request.type = isEip1559Network ? "eip1559" : "legacy";
    }
    if (parameters.includes("fees")) {
        // TODO(4844): derive blob base fees once https://github.com/ethereum/execution-apis/pull/486 is merged.
        if (request.type !== "legacy" && request.type !== "eip2930") // EIP-1559 fees
        {
            if (typeof request.maxFeePerGas === "undefined" || typeof request.maxPriorityFeePerGas === "undefined") {
                const block = await getBlock();
                const { maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas } = await (0, $2268cbc7c5ccd444$export$67115e8707c5a9e)(client, {
                    block: block,
                    chain: chain,
                    request: request
                });
                if (typeof args.maxPriorityFeePerGas === "undefined" && args.maxFeePerGas && args.maxFeePerGas < maxPriorityFeePerGas) throw new (0, $8ac6ceb86692bbba$export$bcf9730904a1086f)({
                    maxPriorityFeePerGas: maxPriorityFeePerGas
                });
                request.maxPriorityFeePerGas = maxPriorityFeePerGas;
                request.maxFeePerGas = maxFeePerGas;
            }
        } else {
            // Legacy fees
            if (typeof args.maxFeePerGas !== "undefined" || typeof args.maxPriorityFeePerGas !== "undefined") throw new (0, $8ac6ceb86692bbba$export$dcf53c0ae183fb46)();
            if (typeof args.gasPrice === "undefined") {
                const block = await getBlock();
                const { gasPrice: gasPrice_ } = await (0, $2268cbc7c5ccd444$export$67115e8707c5a9e)(client, {
                    block: block,
                    chain: chain,
                    request: request,
                    type: "legacy"
                });
                request.gasPrice = gasPrice_;
            }
        }
    }
    if (parameters.includes("gas") && typeof gas === "undefined") request.gas = await (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $b70a54c45c4aa30c$export$e0580ae1f48db848), "estimateGas")({
        ...request,
        account: account ? {
            address: account.address,
            type: "json-rpc"
        } : account
    });
    (0, $hQGp6.assertRequest)(request);
    delete request.parameters;
    return request;
}



var $nDot9 = parcelRequire("nDot9");
async function $104f496ae83f0f17$export$df96cd8d56be0ab1(client, { address: address, blockNumber: blockNumber, blockTag: blockTag = "latest" }) {
    const blockNumberHex = typeof blockNumber === "bigint" ? (0, $nDot9.numberToHex)(blockNumber) : undefined;
    const balance = await client.request({
        method: "eth_getBalance",
        params: [
            address,
            blockNumberHex || blockTag
        ]
    });
    return BigInt(balance);
}


async function $b70a54c45c4aa30c$export$e0580ae1f48db848(client, args) {
    const { account: account_ = client.account } = args;
    const account = account_ ? (0, $fbsYZ.parseAccount)(account_) : undefined;
    try {
        const { accessList: accessList, authorizationList: authorizationList, blobs: blobs, blobVersionedHashes: blobVersionedHashes, blockNumber: blockNumber, blockTag: blockTag, data: data, gas: gas, gasPrice: gasPrice, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, value: value, stateOverride: stateOverride, ...rest } = await (0, $a8cddba47d5ae2a7$export$2e8a9232fb815d77)(client, {
            ...args,
            parameters: // Some RPC Providers do not compute versioned hashes from blobs. We will need
            // to compute them.
            account?.type === "local" ? undefined : [
                "blobVersionedHashes"
            ]
        });
        const blockNumberHex = typeof blockNumber === "bigint" ? (0, $nDot9.numberToHex)(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        const rpcStateOverride = (0, $6Pzc8.serializeStateOverride)(stateOverride);
        const to = await (async ()=>{
            // If `to` exists on the parameters, use that.
            if (rest.to) return rest.to;
            // If no `to` exists, and we are sending a EIP-7702 transaction, use the
            // address of the first authorization in the list.
            if (authorizationList && authorizationList.length > 0) return await (0, $a3352ab597e57927$export$415d0315604a8515)({
                authorization: authorizationList[0]
            }).catch(()=>{
                throw new (0, $3cVvs.BaseError)("`to` is required. Could not infer from `authorizationList`");
            });
            // Otherwise, we are sending a deployment transaction.
            return undefined;
        })();
        (0, $hQGp6.assertRequest)(args);
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || (0, $csK11.formatTransactionRequest);
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...(0, $6ztP3.extract)(rest, {
                format: chainFormat
            }),
            from: account?.address,
            accessList: accessList,
            authorizationList: authorizationList,
            blobs: blobs,
            blobVersionedHashes: blobVersionedHashes,
            data: data,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerBlobGas: maxFeePerBlobGas,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: to,
            value: value
        });
        function estimateGas_rpc(parameters) {
            const { block: block, request: request, rpcStateOverride: rpcStateOverride } = parameters;
            return client.request({
                method: "eth_estimateGas",
                params: rpcStateOverride ? [
                    request,
                    block ?? "latest",
                    rpcStateOverride
                ] : block ? [
                    request,
                    block
                ] : [
                    request
                ]
            });
        }
        let estimate = BigInt(await estimateGas_rpc({
            block: block,
            request: request,
            rpcStateOverride: rpcStateOverride
        }));
        // TODO(7702): Remove this once https://github.com/ethereum/execution-apis/issues/561 is resolved.
        //       Authorization list schema is not implemented on JSON-RPC spec yet, so we need to
        //       manually estimate the gas.
        if (authorizationList) {
            const value = await (0, $104f496ae83f0f17$export$df96cd8d56be0ab1)(client, {
                address: request.from
            });
            const estimates = await Promise.all(authorizationList.map(async (authorization)=>{
                const { address: address } = authorization;
                const estimate = await estimateGas_rpc({
                    block: block,
                    request: {
                        authorizationList: undefined,
                        data: data,
                        from: account?.address,
                        to: address,
                        value: (0, $nDot9.numberToHex)(value)
                    },
                    rpcStateOverride: rpcStateOverride
                }).catch(()=>100000n);
                return 2n * BigInt(estimate);
            }));
            estimate += estimates.reduce((acc, curr)=>acc + curr, 0n);
        }
        return estimate;
    } catch (err) {
        throw (0, $6bcd7c728bb232ab$export$f201b805dbcd7c48)(err, {
            ...args,
            account: account,
            chain: client.chain
        });
    }
}


/**
 * Retrieves and returns an action from the client (if exists), and falls
 * back to the tree-shakable action.
 *
 * Useful for extracting overridden actions from a client (ie. if a consumer
 * wants to override the `sendTransaction` implementation).
 */ function $e46aee3e8f3061da$export$6ca3170acb89054(client, actionFn, // Some minifiers drop `Function.prototype.name`, or replace it with short letters,
// meaning that `actionFn.name` will not always work. For that case, the consumer
// needs to pass the name explicitly.
name) {
    const action_implicit = client[actionFn.name];
    if (typeof action_implicit === "function") return action_implicit;
    const action_explicit = client[name];
    if (typeof action_explicit === "function") return action_explicit;
    return (params)=>actionFn(client, params);
}



function $6ae9a7c88f35c0b0$export$4c00f665f0d4b443(provider, config = {}) {
    const { key: key = "custom", methods: methods, name: name = "Custom Provider", retryDelay: retryDelay } = config;
    return ({ retryCount: defaultRetryCount })=>(0, $4275087a240c0d34$export$d09f50d9ab7f7b69)({
            key: key,
            methods: methods,
            name: name,
            request: provider.request.bind(provider),
            retryCount: config.retryCount ?? defaultRetryCount,
            retryDelay: retryDelay,
            type: "custom"
        });
}



var $bOQZu = parcelRequire("bOQZu");
var $fbsYZ = parcelRequire("fbsYZ");

var $9yvAP = parcelRequire("9yvAP");
async function $3e82a7de501bc551$export$d784801ca17b4aec(config, parameters = {}) {
    // Get connection
    let connection;
    if (parameters.connector) {
        const { connector: connector } = parameters;
        if (config.state.status === "reconnecting" && !connector.getAccounts && !connector.getChainId) throw new (0, $9yvAP.ConnectorUnavailableReconnectingError)({
            connector: connector
        });
        const [accounts, chainId] = await Promise.all([
            connector.getAccounts().catch((e)=>{
                if (parameters.account === null) return [];
                throw e;
            }),
            connector.getChainId()
        ]);
        connection = {
            accounts: accounts,
            chainId: chainId,
            connector: connector
        };
    } else connection = config.state.connections.get(config.state.current);
    if (!connection) throw new (0, $9yvAP.ConnectorNotConnectedError)();
    const chainId = parameters.chainId ?? connection.chainId;
    // Check connector using same chainId as connection
    const connectorChainId = await connection.connector.getChainId();
    if (connectorChainId !== connection.chainId) throw new (0, $9yvAP.ConnectorChainMismatchError)({
        connectionChainId: connection.chainId,
        connectorChainId: connectorChainId
    });
    const connector = connection.connector;
    if (connector.getClient) return connector.getClient({
        chainId: chainId
    });
    // Default using `custom` transport
    const account = (0, $fbsYZ.parseAccount)(parameters.account ?? connection.accounts[0]);
    if (account) account.address = (0, $bOQZu.getAddress)(account.address); // TODO: Checksum address as part of `parseAccount`?
    // If account was provided, check that it exists on the connector
    if (parameters.account && !connection.accounts.some((x)=>x.toLowerCase() === account.address.toLowerCase())) throw new (0, $9yvAP.ConnectorAccountNotFoundError)({
        address: account.address,
        connector: connector
    });
    const chain = config.chains.find((chain)=>chain.id === chainId);
    const provider = await connection.connector.getProvider({
        chainId: chainId
    });
    return (0, $c6c405c1b78bf5b3$export$5d730b7aed1a3eb0)({
        account: account,
        chain: chain,
        name: "Connector Client",
        transport: (opts)=>(0, $6ae9a7c88f35c0b0$export$4c00f665f0d4b443)(provider)({
                ...opts,
                retryCount: 0
            })
    });
}


async function $594e0294981efc63$export$e0580ae1f48db848(config, parameters) {
    const { chainId: chainId, connector: connector, ...rest } = parameters;
    let account;
    if (parameters.account) account = parameters.account;
    else {
        const connectorClient = await (0, $3e82a7de501bc551$export$d784801ca17b4aec)(config, {
            account: parameters.account,
            chainId: chainId,
            connector: connector
        });
        account = connectorClient.account;
    }
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $e46aee3e8f3061da$export$6ca3170acb89054)(client, (0, $b70a54c45c4aa30c$export$e0580ae1f48db848), "estimateGas");
    return action({
        ...rest,
        account: account
    });
}

/** https://wagmi.sh/core/api/actions/getAccount */ function $fa6344f751511ecb$export$4f9234baf34abd0(config) {
    const uid = config.state.current;
    const connection = config.state.connections.get(uid);
    const addresses = connection?.accounts;
    const address = addresses?.[0];
    const chain = config.chains.find((chain)=>chain.id === connection?.chainId);
    const status = config.state.status;
    switch(status){
        case "connected":
            return {
                address: address,
                addresses: addresses,
                chain: chain,
                chainId: connection?.chainId,
                connector: connection?.connector,
                isConnected: true,
                isConnecting: false,
                isDisconnected: false,
                isReconnecting: false,
                status: status
            };
        case "reconnecting":
            return {
                address: address,
                addresses: addresses,
                chain: chain,
                chainId: connection?.chainId,
                connector: connection?.connector,
                isConnected: !!address,
                isConnecting: false,
                isDisconnected: false,
                isReconnecting: true,
                status: status
            };
        case "connecting":
            return {
                address: address,
                addresses: addresses,
                chain: chain,
                chainId: connection?.chainId,
                connector: connection?.connector,
                isConnected: false,
                isConnecting: true,
                isDisconnected: false,
                isReconnecting: false,
                status: status
            };
        case "disconnected":
            return {
                address: undefined,
                addresses: undefined,
                chain: undefined,
                chainId: undefined,
                connector: undefined,
                isConnected: false,
                isConnecting: false,
                isDisconnected: true,
                isReconnecting: false,
                status: status
            };
    }
}


var $lUvCu = parcelRequire("lUvCu");
var $9Hxnd = parcelRequire("9Hxnd");
var $4Khm8 = parcelRequire("4Khm8");



var $9e4ts = parcelRequire("9e4ts");
function $7a407e5b34f08830$export$65f2564e9a9b9222(unit) {
    if (typeof unit === "number") return unit;
    if (unit === "wei") return 0;
    return Math.abs((0, $9e4ts.weiUnits)[unit]);
}



var $9juKK = parcelRequire("9juKK");

var $2znys = parcelRequire("2znys");

var $ie3rb = parcelRequire("ie3rb");

var $3cVvs = parcelRequire("3cVvs");

var $9juKK = parcelRequire("9juKK");

var $9Nj5J = parcelRequire("9Nj5J");

var $83bOE = parcelRequire("83bOE");

var $ejxc0 = parcelRequire("ejxc0");

var $ie3rb = parcelRequire("ie3rb");

var $3cVvs = parcelRequire("3cVvs");

var $9juKK = parcelRequire("9juKK");

var $kbqwz = parcelRequire("kbqwz");

var $16W4z = parcelRequire("16W4z");
const $e06269ffd337955e$var$EXECUTION_REVERTED_ERROR_CODE = 3;
function $e06269ffd337955e$export$4414444aba6ddd8a(err, { abi: abi, address: address, args: args, docsPath: docsPath, functionName: functionName, sender: sender }) {
    const error = err instanceof (0, $9juKK.RawContractError) ? err : err instanceof (0, $3cVvs.BaseError) ? err.walk((err)=>"data" in err) || err.walk() : {};
    const { code: code, data: data, details: details, message: message, shortMessage: shortMessage } = error;
    const cause = (()=>{
        if (err instanceof (0, $ie3rb.AbiDecodingZeroDataError)) return new (0, $9juKK.ContractFunctionZeroDataError)({
            functionName: functionName
        });
        if ([
            $e06269ffd337955e$var$EXECUTION_REVERTED_ERROR_CODE,
            (0, $16W4z.InternalRpcError).code
        ].includes(code) && (data || details || message || shortMessage)) return new (0, $9juKK.ContractFunctionRevertedError)({
            abi: abi,
            data: typeof data === "object" ? data.data : data,
            functionName: functionName,
            message: error instanceof (0, $kbqwz.RpcRequestError) ? details : shortMessage ?? message
        });
        return err;
    })();
    return new (0, $9juKK.ContractFunctionExecutionError)(cause, {
        abi: abi,
        args: args,
        contractAddress: address,
        docsPath: docsPath,
        functionName: functionName,
        sender: sender
    });
}




var $9Nj5J = parcelRequire("9Nj5J");

var $83bOE = parcelRequire("83bOE");



var $eNB0a = parcelRequire("eNB0a");
async function $1e5d2166dacdbfb2$export$43af7de392176737(client, parameters) {
    const { abi: abi, address: address, args: args, functionName: functionName, ...rest } = parameters;
    const calldata = (0, $83bOE.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        const { data: data } = await (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $eNB0a.call), "call")({
            ...rest,
            data: calldata,
            to: address
        });
        return (0, $9Nj5J.decodeFunctionResult)({
            abi: abi,
            args: args,
            functionName: functionName,
            data: data || "0x"
        });
    } catch (error) {
        throw (0, $e06269ffd337955e$export$4414444aba6ddd8a)(error, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/readContract",
            functionName: functionName
        });
    }
}


async function $ab7e55e3cb6ad33e$export$60ef70589ee4f7ad(client, parameters) {
    const { account: account, allowFailure: allowFailure = true, batchSize: batchSize_, blockNumber: blockNumber, blockTag: blockTag, multicallAddress: multicallAddress_, stateOverride: stateOverride } = parameters;
    const contracts = parameters.contracts;
    const batchSize = batchSize_ ?? (typeof client.batch?.multicall === "object" && client.batch.multicall.batchSize || 1024);
    let multicallAddress = multicallAddress_;
    if (!multicallAddress) {
        if (!client.chain) throw new Error("client chain not configured. multicallAddress is required.");
        multicallAddress = (0, $ejxc0.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "multicall3"
        });
    }
    const chunkedCalls = [
        []
    ];
    let currentChunk = 0;
    let currentChunkSize = 0;
    for(let i = 0; i < contracts.length; i++){
        const { abi: abi, address: address, args: args, functionName: functionName } = contracts[i];
        try {
            const callData = (0, $83bOE.encodeFunctionData)({
                abi: abi,
                args: args,
                functionName: functionName
            });
            currentChunkSize += (callData.length - 2) / 2;
            // Check to see if we need to create a new chunk.
            if (// Check if batching is enabled.
            batchSize > 0 && // Check if the current size of the batch exceeds the size limit.
            currentChunkSize > batchSize && // Check if the current chunk is not already empty.
            chunkedCalls[currentChunk].length > 0) {
                currentChunk++;
                currentChunkSize = (callData.length - 2) / 2;
                chunkedCalls[currentChunk] = [];
            }
            chunkedCalls[currentChunk] = [
                ...chunkedCalls[currentChunk],
                {
                    allowFailure: true,
                    callData: callData,
                    target: address
                }
            ];
        } catch (err) {
            const error = (0, $e06269ffd337955e$export$4414444aba6ddd8a)(err, {
                abi: abi,
                address: address,
                args: args,
                docsPath: "/docs/contract/multicall",
                functionName: functionName,
                sender: account
            });
            if (!allowFailure) throw error;
            chunkedCalls[currentChunk] = [
                ...chunkedCalls[currentChunk],
                {
                    allowFailure: true,
                    callData: "0x",
                    target: address
                }
            ];
        }
    }
    const aggregate3Results = await Promise.allSettled(chunkedCalls.map((calls)=>(0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $1e5d2166dacdbfb2$export$43af7de392176737), "readContract")({
            abi: (0, $2znys.multicall3Abi),
            account: account,
            address: multicallAddress,
            args: [
                calls
            ],
            blockNumber: blockNumber,
            blockTag: blockTag,
            functionName: "aggregate3",
            stateOverride: stateOverride
        })));
    const results = [];
    for(let i = 0; i < aggregate3Results.length; i++){
        const result = aggregate3Results[i];
        // If an error occurred in a `readContract` invocation (ie. network error),
        // then append the failure reason to each contract result.
        if (result.status === "rejected") {
            if (!allowFailure) throw result.reason;
            for(let j = 0; j < chunkedCalls[i].length; j++)results.push({
                status: "failure",
                error: result.reason,
                result: undefined
            });
            continue;
        }
        // If the `readContract` call was successful, then decode the results.
        const aggregate3Result = result.value;
        for(let j = 0; j < aggregate3Result.length; j++){
            // Extract the response from `readContract`
            const { returnData: returnData, success: success } = aggregate3Result[j];
            // Extract the request call data from the original call.
            const { callData: callData } = chunkedCalls[i][j];
            // Extract the contract config for this call from the `contracts` argument
            // for decoding.
            const { abi: abi, address: address, functionName: functionName, args: args } = contracts[results.length];
            try {
                if (callData === "0x") throw new (0, $ie3rb.AbiDecodingZeroDataError)();
                if (!success) throw new (0, $9juKK.RawContractError)({
                    data: returnData
                });
                const result = (0, $9Nj5J.decodeFunctionResult)({
                    abi: abi,
                    args: args,
                    data: returnData,
                    functionName: functionName
                });
                results.push(allowFailure ? {
                    result: result,
                    status: "success"
                } : result);
            } catch (err) {
                const error = (0, $e06269ffd337955e$export$4414444aba6ddd8a)(err, {
                    abi: abi,
                    address: address,
                    args: args,
                    docsPath: "/docs/contract/multicall",
                    functionName: functionName
                });
                if (!allowFailure) throw error;
                results.push({
                    error: error,
                    result: undefined,
                    status: "failure"
                });
            }
        }
    }
    if (results.length !== contracts.length) throw new (0, $3cVvs.BaseError)("multicall results mismatch");
    return results;
}



async function $6803b90e6ccfaa83$export$60ef70589ee4f7ad(config, parameters) {
    const { allowFailure: allowFailure = true, chainId: chainId, contracts: contracts, ...rest } = parameters;
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $e46aee3e8f3061da$export$6ca3170acb89054)(client, (0, $ab7e55e3cb6ad33e$export$60ef70589ee4f7ad), "multicall");
    return action({
        allowFailure: allowFailure,
        contracts: contracts,
        ...rest
    });
}




function $90ca2f136589dd6d$export$43af7de392176737(config, parameters) {
    const { chainId: chainId, ...rest } = parameters;
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $e46aee3e8f3061da$export$6ca3170acb89054)(client, (0, $1e5d2166dacdbfb2$export$43af7de392176737), "readContract");
    return action(rest);
}


async function $0cd452421f20ddb0$export$aa7cd72d27ce4a5(config, parameters) {
    const { allowFailure: allowFailure = true, blockNumber: blockNumber, blockTag: blockTag, ...rest } = parameters;
    const contracts = parameters.contracts;
    try {
        const contractsByChainId = {};
        for (const [index, contract] of contracts.entries()){
            const chainId = contract.chainId ?? config.state.chainId;
            if (!contractsByChainId[chainId]) contractsByChainId[chainId] = [];
            contractsByChainId[chainId]?.push({
                contract: contract,
                index: index
            });
        }
        const promises = ()=>Object.entries(contractsByChainId).map(([chainId, contracts])=>(0, $6803b90e6ccfaa83$export$60ef70589ee4f7ad)(config, {
                    ...rest,
                    allowFailure: allowFailure,
                    blockNumber: blockNumber,
                    blockTag: blockTag,
                    chainId: Number.parseInt(chainId),
                    contracts: contracts.map(({ contract: contract })=>contract)
                }));
        const multicallResults = (await Promise.all(promises())).flat();
        // Reorder the contract results back to the order they were
        // provided in.
        const resultIndexes = Object.values(contractsByChainId).flatMap((contracts)=>contracts.map(({ index: index })=>index));
        return multicallResults.reduce((results, result, index)=>{
            if (results) results[resultIndexes[index]] = result;
            return results;
        }, []);
    } catch (error) {
        if (error instanceof (0, $9juKK.ContractFunctionExecutionError)) throw error;
        const promises = ()=>contracts.map((contract)=>(0, $90ca2f136589dd6d$export$43af7de392176737)(config, {
                    ...contract,
                    blockNumber: blockNumber,
                    blockTag: blockTag
                }));
        if (allowFailure) return (await Promise.allSettled(promises())).map((result)=>{
            if (result.status === "fulfilled") return {
                result: result.value,
                status: "success"
            };
            return {
                error: result.reason,
                result: undefined,
                status: "failure"
            };
        });
        return await Promise.all(promises());
    }
}


async function $08881dd69704a4e2$export$df96cd8d56be0ab1(config, parameters) {
    const { address: address, blockNumber: blockNumber, blockTag: blockTag, chainId: chainId, token: tokenAddress, unit: unit = "ether" } = parameters;
    if (tokenAddress) try {
        return await $08881dd69704a4e2$var$getTokenBalance(config, {
            balanceAddress: address,
            chainId: chainId,
            symbolType: "string",
            tokenAddress: tokenAddress
        });
    } catch (error) {
        // In the chance that there is an error upon decoding the contract result,
        // it could be likely that the contract data is represented as bytes32 instead
        // of a string.
        if (error.name === "ContractFunctionExecutionError") {
            const balance = await $08881dd69704a4e2$var$getTokenBalance(config, {
                balanceAddress: address,
                chainId: chainId,
                symbolType: "bytes32",
                tokenAddress: tokenAddress
            });
            const symbol = (0, $9Hxnd.hexToString)((0, $4Khm8.trim)(balance.symbol, {
                dir: "right"
            }));
            return {
                ...balance,
                symbol: symbol
            };
        }
        throw error;
    }
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $e46aee3e8f3061da$export$6ca3170acb89054)(client, (0, $104f496ae83f0f17$export$df96cd8d56be0ab1), "getBalance");
    const value = await action(blockNumber ? {
        address: address,
        blockNumber: blockNumber
    } : {
        address: address,
        blockTag: blockTag
    });
    const chain = config.chains.find((x)=>x.id === chainId) ?? client.chain;
    return {
        decimals: chain.nativeCurrency.decimals,
        formatted: (0, $lUvCu.formatUnits)(value, (0, $7a407e5b34f08830$export$65f2564e9a9b9222)(unit)),
        symbol: chain.nativeCurrency.symbol,
        value: value
    };
}
async function $08881dd69704a4e2$var$getTokenBalance(config, parameters) {
    const { balanceAddress: balanceAddress, chainId: chainId, symbolType: symbolType, tokenAddress: tokenAddress, unit: unit } = parameters;
    const contract = {
        abi: [
            {
                type: "function",
                name: "balanceOf",
                stateMutability: "view",
                inputs: [
                    {
                        type: "address"
                    }
                ],
                outputs: [
                    {
                        type: "uint256"
                    }
                ]
            },
            {
                type: "function",
                name: "decimals",
                stateMutability: "view",
                inputs: [],
                outputs: [
                    {
                        type: "uint8"
                    }
                ]
            },
            {
                type: "function",
                name: "symbol",
                stateMutability: "view",
                inputs: [],
                outputs: [
                    {
                        type: symbolType
                    }
                ]
            }
        ],
        address: tokenAddress
    };
    const [value, decimals, symbol] = await (0, $0cd452421f20ddb0$export$aa7cd72d27ce4a5)(config, {
        allowFailure: false,
        contracts: [
            {
                ...contract,
                functionName: "balanceOf",
                args: [
                    balanceAddress
                ],
                chainId: chainId
            },
            {
                ...contract,
                functionName: "decimals",
                chainId: chainId
            },
            {
                ...contract,
                functionName: "symbol",
                chainId: chainId
            }
        ]
    });
    const formatted = (0, $lUvCu.formatUnits)(value ?? "0", (0, $7a407e5b34f08830$export$65f2564e9a9b9222)(unit ?? decimals));
    return {
        decimals: decimals,
        formatted: formatted,
        symbol: symbol,
        value: value
    };
}

/** Forked from https://github.com/epoberezkin/fast-deep-equal */ function $e451a93999f3c4ed$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    if (a && b && typeof a === "object" && typeof b === "object") {
        if (a.constructor !== b.constructor) return false;
        let length;
        let i;
        if (Array.isArray(a) && Array.isArray(b)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;)if (!$e451a93999f3c4ed$export$9cb4719e2e525b7a(a[i], b[i])) return false;
            return true;
        }
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        const keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key && !$e451a93999f3c4ed$export$9cb4719e2e525b7a(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    // biome-ignore lint/suspicious/noSelfCompare: <explanation>
    return a !== a && b !== b;
}


let $66327d0720639dd4$var$previousConnections = [];
function $66327d0720639dd4$export$82b9f8f75cc709b4(config) {
    const connections = [
        ...config.state.connections.values()
    ];
    if (config.state.status === "reconnecting") return $66327d0720639dd4$var$previousConnections;
    if ((0, $e451a93999f3c4ed$export$9cb4719e2e525b7a)($66327d0720639dd4$var$previousConnections, connections)) return $66327d0720639dd4$var$previousConnections;
    $66327d0720639dd4$var$previousConnections = connections;
    return connections;
}




async function $4f22ff319bfbc509$export$2e8a9232fb815d77(config, parameters) {
    const { account: account_, chainId: chainId, ...rest } = parameters;
    const account = account_ ?? (0, $fa6344f751511ecb$export$4f9234baf34abd0)(config).address;
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $e46aee3e8f3061da$export$6ca3170acb89054)(client, (0, $a8cddba47d5ae2a7$export$2e8a9232fb815d77), "prepareTransactionRequest");
    return action({
        ...rest,
        ...account ? {
            account: account
        } : {}
    });
}


var $fbsYZ = parcelRequire("fbsYZ");

var $3cVvs = parcelRequire("3cVvs");
class $9565d0f317c58323$export$62ee6b05f0767f28 extends (0, $3cVvs.BaseError) {
    constructor({ docsPath: docsPath } = {}){
        super([
            "Could not find an Account to execute with this Action.",
            "Please provide an Account with the `account` argument on the Action, or by supplying an `account` to the Client."
        ].join("\n"), {
            docsPath: docsPath,
            docsSlug: "account",
            name: "AccountNotFoundError"
        });
    }
}
class $9565d0f317c58323$export$22c1d840ef5fbc66 extends (0, $3cVvs.BaseError) {
    constructor({ docsPath: docsPath, metaMessages: metaMessages, type: type }){
        super(`Account type "${type}" is not supported.`, {
            docsPath: docsPath,
            metaMessages: metaMessages,
            name: "AccountTypeNotSupportedError"
        });
    }
}



var $3cVvs = parcelRequire("3cVvs");


var $4TNV6 = parcelRequire("4TNV6");
function $129c56104eadfc3b$export$390d312ab46d0597({ chain: chain, currentChainId: currentChainId }) {
    if (!chain) throw new (0, $4TNV6.ChainNotFoundError)();
    if (currentChainId !== chain.id) throw new (0, $4TNV6.ChainMismatchError)({
        chain: chain,
        currentChainId: currentChainId
    });
}



var $hOdyB = parcelRequire("hOdyB");

var $lfct8 = parcelRequire("lfct8");

var $b0rjl = parcelRequire("b0rjl");
function $13294389c9ef6ddf$export$da1758db1985646e(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $b0rjl.getNodeError)(err, args);
        if (cause instanceof (0, $hOdyB.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $lfct8.TransactionExecutionError)(cause, {
        docsPath: docsPath,
        ...args
    });
}



var $6ztP3 = parcelRequire("6ztP3");

var $csK11 = parcelRequire("csK11");


var $2MUIq = parcelRequire("2MUIq");

var $hQGp6 = parcelRequire("hQGp6");


/**
 * Sends a **signed** transaction to the network
 *
 * - Docs: https://viem.sh/docs/actions/wallet/sendRawTransaction
 * - JSON-RPC Method: [`eth_sendRawTransaction`](https://ethereum.github.io/execution-apis/api-documentation/)
 *
 * @param client - Client to use
 * @param parameters - {@link SendRawTransactionParameters}
 * @returns The transaction hash. {@link SendRawTransactionReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { sendRawTransaction } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 *
 * const hash = await sendRawTransaction(client, {
 *   serializedTransaction: '0x02f850018203118080825208808080c080a04012522854168b27e5dc3d5839bab5e6b39e1a0ffd343901ce1622e3d64b48f1a04e00902ae0502c4728cbf12156290df99c3ed7de85b1dbfe20b5c36931733a33'
 * })
 */ async function $43ff59b80815f88b$export$4e309754b4830e29(client, { serializedTransaction: serializedTransaction }) {
    return client.request({
        method: "eth_sendRawTransaction",
        params: [
            serializedTransaction
        ]
    }, {
        retryCount: 0
    });
}


const $02b3018b7c29f08e$var$supportsWalletNamespace = new (0, $2MUIq.LruMap)(128);
async function $02b3018b7c29f08e$export$8e0e7ffc78696d30(client, parameters) {
    const { account: account_ = client.account, chain: chain = client.chain, accessList: accessList, authorizationList: authorizationList, blobs: blobs, data: data, gas: gas, gasPrice: gasPrice, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, type: type, value: value, ...rest } = parameters;
    if (typeof account_ === "undefined") throw new (0, $9565d0f317c58323$export$62ee6b05f0767f28)({
        docsPath: "/docs/actions/wallet/sendTransaction"
    });
    const account = account_ ? (0, $fbsYZ.parseAccount)(account_) : null;
    try {
        (0, $hQGp6.assertRequest)(parameters);
        const to = await (async ()=>{
            // If `to` exists on the parameters, use that.
            if (parameters.to) return parameters.to;
            // If `to` is null, we are sending a deployment transaction.
            if (parameters.to === null) return undefined;
            // If no `to` exists, and we are sending a EIP-7702 transaction, use the
            // address of the first authorization in the list.
            if (authorizationList && authorizationList.length > 0) return await (0, $a3352ab597e57927$export$415d0315604a8515)({
                authorization: authorizationList[0]
            }).catch(()=>{
                throw new (0, $3cVvs.BaseError)("`to` is required. Could not infer from `authorizationList`.");
            });
            // Otherwise, we are sending a deployment transaction.
            return undefined;
        })();
        if (account?.type === "json-rpc" || account === null) {
            let chainId;
            if (chain !== null) {
                chainId = await (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $a8187a7531df30a7$export$850fa7b3891187c), "getChainId")({});
                (0, $129c56104eadfc3b$export$390d312ab46d0597)({
                    currentChainId: chainId,
                    chain: chain
                });
            }
            const chainFormat = client.chain?.formatters?.transactionRequest?.format;
            const format = chainFormat || (0, $csK11.formatTransactionRequest);
            const request = format({
                // Pick out extra data that might exist on the chain's transaction request type.
                ...(0, $6ztP3.extract)(rest, {
                    format: chainFormat
                }),
                accessList: accessList,
                authorizationList: authorizationList,
                blobs: blobs,
                chainId: chainId,
                data: data,
                from: account?.address,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerBlobGas: maxFeePerBlobGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                nonce: nonce,
                to: to,
                type: type,
                value: value
            });
            const isWalletNamespaceSupported = $02b3018b7c29f08e$var$supportsWalletNamespace.get(client.uid);
            const method = isWalletNamespaceSupported ? "wallet_sendTransaction" : "eth_sendTransaction";
            try {
                return await client.request({
                    method: method,
                    params: [
                        request
                    ]
                }, {
                    retryCount: 0
                });
            } catch (e) {
                if (isWalletNamespaceSupported === false) throw e;
                const error = e;
                // If the transport does not support the method or input, attempt to use the
                // `wallet_sendTransaction` method.
                if (error.name === "InvalidInputRpcError" || error.name === "InvalidParamsRpcError" || error.name === "MethodNotFoundRpcError" || error.name === "MethodNotSupportedRpcError") return await client.request({
                    method: "wallet_sendTransaction",
                    params: [
                        request
                    ]
                }, {
                    retryCount: 0
                }).then((hash)=>{
                    $02b3018b7c29f08e$var$supportsWalletNamespace.set(client.uid, true);
                    return hash;
                }).catch((e)=>{
                    const walletNamespaceError = e;
                    if (walletNamespaceError.name === "MethodNotFoundRpcError" || walletNamespaceError.name === "MethodNotSupportedRpcError") {
                        $02b3018b7c29f08e$var$supportsWalletNamespace.set(client.uid, false);
                        throw error;
                    }
                    throw walletNamespaceError;
                });
                throw error;
            }
        }
        if (account?.type === "local") {
            // Prepare the request for signing (assign appropriate fees, etc.)
            const request = await (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $a8cddba47d5ae2a7$export$2e8a9232fb815d77), "prepareTransactionRequest")({
                account: account,
                accessList: accessList,
                authorizationList: authorizationList,
                blobs: blobs,
                chain: chain,
                data: data,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerBlobGas: maxFeePerBlobGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                nonce: nonce,
                nonceManager: account.nonceManager,
                parameters: [
                    ...(0, $a8cddba47d5ae2a7$export$4f3e0c2bc77eca55),
                    "sidecars"
                ],
                type: type,
                value: value,
                ...rest,
                to: to
            });
            const serializer = chain?.serializers?.transaction;
            const serializedTransaction = await account.signTransaction(request, {
                serializer: serializer
            });
            return await (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $43ff59b80815f88b$export$4e309754b4830e29), "sendRawTransaction")({
                serializedTransaction: serializedTransaction
            });
        }
        if (account?.type === "smart") throw new (0, $9565d0f317c58323$export$22c1d840ef5fbc66)({
            metaMessages: [
                "Consider using the `sendUserOperation` Action instead."
            ],
            docsPath: "/docs/actions/bundler/sendUserOperation",
            type: "smart"
        });
        throw new (0, $9565d0f317c58323$export$22c1d840ef5fbc66)({
            docsPath: "/docs/actions/wallet/sendTransaction",
            type: account?.type
        });
    } catch (err) {
        if (err instanceof (0, $9565d0f317c58323$export$22c1d840ef5fbc66)) throw err;
        throw (0, $13294389c9ef6ddf$export$da1758db1985646e)(err, {
            ...parameters,
            account: account,
            chain: parameters.chain || undefined
        });
    }
}




async function $6decec9706d5dc0a$export$8e0e7ffc78696d30(config, parameters) {
    const { account: account, chainId: chainId, connector: connector, ...rest } = parameters;
    let client;
    if (typeof account === "object" && account?.type === "local") client = config.getClient({
        chainId: chainId
    });
    else client = await (0, $3e82a7de501bc551$export$d784801ca17b4aec)(config, {
        account: account ?? undefined,
        chainId: chainId,
        connector: connector
    });
    const action = (0, $e46aee3e8f3061da$export$6ca3170acb89054)(client, (0, $02b3018b7c29f08e$export$8e0e7ffc78696d30), "sendTransaction");
    const hash = await action({
        ...rest,
        ...account ? {
            account: account
        } : {},
        chain: chainId ? {
            id: chainId
        } : null,
        gas: rest.gas ?? undefined
    });
    return hash;
}


var $fbsYZ = parcelRequire("fbsYZ");


var $nDot9 = parcelRequire("nDot9");
async function $d51286fed84b080a$export$1d9a7a8a40780de(client, { account: account_ = client.account, message: message }) {
    if (!account_) throw new (0, $9565d0f317c58323$export$62ee6b05f0767f28)({
        docsPath: "/docs/actions/wallet/signMessage"
    });
    const account = (0, $fbsYZ.parseAccount)(account_);
    if (account.signMessage) return account.signMessage({
        message: message
    });
    const message_ = (()=>{
        if (typeof message === "string") return (0, $nDot9.stringToHex)(message);
        if (message.raw instanceof Uint8Array) return (0, $nDot9.toHex)(message.raw);
        return message.raw;
    })();
    return client.request({
        method: "personal_sign",
        params: [
            message_,
            account.address
        ]
    }, {
        retryCount: 0
    });
}




async function $0710ed85e3b8b4c8$export$1d9a7a8a40780de(config, parameters) {
    const { account: account, connector: connector, ...rest } = parameters;
    let client;
    if (typeof account === "object" && account.type === "local") client = config.getClient();
    else client = await (0, $3e82a7de501bc551$export$d784801ca17b4aec)(config, {
        account: account,
        connector: connector
    });
    const action = (0, $e46aee3e8f3061da$export$6ca3170acb89054)(client, (0, $d51286fed84b080a$export$1d9a7a8a40780de), "signMessage");
    return action({
        ...rest,
        ...account ? {
            account: account
        } : {}
    });
}


var $9yvAP = parcelRequire("9yvAP");

async function $2bcb8ae7ecd06b82$export$15599da40e72d2f(config, parameters) {
    const { addEthereumChainParameter: addEthereumChainParameter, chainId: chainId } = parameters;
    const connection = config.state.connections.get(parameters.connector?.uid ?? config.state.current);
    if (connection) {
        const connector = connection.connector;
        if (!connector.switchChain) throw new (0, $064d9adb8a9c12a4$export$a4296a4b7763e5d8)({
            connector: connector
        });
        const chain = await connector.switchChain({
            addEthereumChainParameter: addEthereumChainParameter,
            chainId: chainId
        });
        return chain;
    }
    const chain = config.chains.find((x)=>x.id === chainId);
    if (!chain) throw new (0, $9yvAP.ChainNotConfiguredError)();
    config.setState((x)=>({
            ...x,
            chainId: chainId
        }));
    return chain;
}


var $9Hxnd = parcelRequire("9Hxnd");

var $eNB0a = parcelRequire("eNB0a");
var $lfct8 = parcelRequire("lfct8");

var $nDot9 = parcelRequire("nDot9");

async function $5aee70ec212e40a6$export$ec0c6556a09b65b8(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag_, hash: hash, index: index }) {
    const blockTag = blockTag_ || "latest";
    const blockNumberHex = blockNumber !== undefined ? (0, $nDot9.numberToHex)(blockNumber) : undefined;
    let transaction = null;
    if (hash) transaction = await client.request({
        method: "eth_getTransactionByHash",
        params: [
            hash
        ]
    }, {
        dedupe: true
    });
    else if (blockHash) transaction = await client.request({
        method: "eth_getTransactionByBlockHashAndIndex",
        params: [
            blockHash,
            (0, $nDot9.numberToHex)(index)
        ]
    }, {
        dedupe: true
    });
    else if (blockNumberHex || blockTag) transaction = await client.request({
        method: "eth_getTransactionByBlockNumberAndIndex",
        params: [
            blockNumberHex || blockTag,
            (0, $nDot9.numberToHex)(index)
        ]
    }, {
        dedupe: Boolean(blockNumberHex)
    });
    if (!transaction) throw new (0, $lfct8.TransactionNotFoundError)({
        blockHash: blockHash,
        blockNumber: blockNumber,
        blockTag: blockTag,
        hash: hash,
        index: index
    });
    const format = client.chain?.formatters?.transaction?.format || (0, $fc8eee6bab3ad68f$export$b02b16590d26dadc);
    return format(transaction);
}



var $lfct8 = parcelRequire("lfct8");

/** @internal */ const $acc3207d4640e06f$export$94ab3a05cb07971d = /*#__PURE__*/ new Map();
const $acc3207d4640e06f$export$b4a4aba7c5f97c17 = /*#__PURE__*/ new Map();
let $acc3207d4640e06f$var$callbackCount = 0;
function $acc3207d4640e06f$export$d1203567a167490e(observerId, callbacks, fn) {
    const callbackId = ++$acc3207d4640e06f$var$callbackCount;
    const getListeners = ()=>$acc3207d4640e06f$export$94ab3a05cb07971d.get(observerId) || [];
    const unsubscribe = ()=>{
        const listeners = getListeners();
        $acc3207d4640e06f$export$94ab3a05cb07971d.set(observerId, listeners.filter((cb)=>cb.id !== callbackId));
    };
    const unwatch = ()=>{
        const listeners = getListeners();
        if (!listeners.some((cb)=>cb.id === callbackId)) return;
        const cleanup = $acc3207d4640e06f$export$b4a4aba7c5f97c17.get(observerId);
        if (listeners.length === 1 && cleanup) cleanup();
        unsubscribe();
    };
    const listeners = getListeners();
    $acc3207d4640e06f$export$94ab3a05cb07971d.set(observerId, [
        ...listeners,
        {
            id: callbackId,
            fns: callbacks
        }
    ]);
    if (listeners && listeners.length > 0) return unwatch;
    const emit = {};
    for(const key in callbacks)emit[key] = (...args)=>{
        const listeners = getListeners();
        if (listeners.length === 0) return;
        for (const listener of listeners)listener.fns[key]?.(...args);
    };
    const cleanup = fn(emit);
    if (typeof cleanup === "function") $acc3207d4640e06f$export$b4a4aba7c5f97c17.set(observerId, cleanup);
    return unwatch;
}



var $4BHVN = parcelRequire("4BHVN");


var $c0R7l = parcelRequire("c0R7l");



var $lfct8 = parcelRequire("lfct8");

var $9Hxnd = parcelRequire("9Hxnd");

var $4jLjg = parcelRequire("4jLjg");
function $b1c8c518cc547e60$export$fccdbdc2b9d7893(log, { args: args, eventName: eventName } = {}) {
    return {
        ...log,
        blockHash: log.blockHash ? log.blockHash : null,
        blockNumber: log.blockNumber ? BigInt(log.blockNumber) : null,
        logIndex: log.logIndex ? Number(log.logIndex) : null,
        transactionHash: log.transactionHash ? log.transactionHash : null,
        transactionIndex: log.transactionIndex ? Number(log.transactionIndex) : null,
        ...eventName ? {
            args: args,
            eventName: eventName
        } : {}
    };
}



const $3a6db70bbbdd1d80$export$3f17d120ae0df04 = {
    "0x0": "reverted",
    "0x1": "success"
};
function $3a6db70bbbdd1d80$export$30da670e49d6fc31(transactionReceipt) {
    const receipt = {
        ...transactionReceipt,
        blockNumber: transactionReceipt.blockNumber ? BigInt(transactionReceipt.blockNumber) : null,
        contractAddress: transactionReceipt.contractAddress ? transactionReceipt.contractAddress : null,
        cumulativeGasUsed: transactionReceipt.cumulativeGasUsed ? BigInt(transactionReceipt.cumulativeGasUsed) : null,
        effectiveGasPrice: transactionReceipt.effectiveGasPrice ? BigInt(transactionReceipt.effectiveGasPrice) : null,
        gasUsed: transactionReceipt.gasUsed ? BigInt(transactionReceipt.gasUsed) : null,
        logs: transactionReceipt.logs ? transactionReceipt.logs.map((log)=>(0, $b1c8c518cc547e60$export$fccdbdc2b9d7893)(log)) : null,
        to: transactionReceipt.to ? transactionReceipt.to : null,
        transactionIndex: transactionReceipt.transactionIndex ? (0, $9Hxnd.hexToNumber)(transactionReceipt.transactionIndex) : null,
        status: transactionReceipt.status ? $3a6db70bbbdd1d80$export$3f17d120ae0df04[transactionReceipt.status] : null,
        type: transactionReceipt.type ? (0, $fc8eee6bab3ad68f$export$cd5f936b62a5e91)[transactionReceipt.type] || transactionReceipt.type : null
    };
    if (transactionReceipt.blobGasPrice) receipt.blobGasPrice = BigInt(transactionReceipt.blobGasPrice);
    if (transactionReceipt.blobGasUsed) receipt.blobGasUsed = BigInt(transactionReceipt.blobGasUsed);
    return receipt;
}
const $3a6db70bbbdd1d80$export$8d3f90420000ba71 = /*#__PURE__*/ (0, $4jLjg.defineFormatter)("transactionReceipt", $3a6db70bbbdd1d80$export$30da670e49d6fc31);


async function $8964c8daad07aef6$export$6b1ceb3cd5f8b21f(client, { hash: hash }) {
    const receipt = await client.request({
        method: "eth_getTransactionReceipt",
        params: [
            hash
        ]
    }, {
        dedupe: true
    });
    if (!receipt) throw new (0, $lfct8.TransactionReceiptNotFoundError)({
        hash: hash
    });
    const format = client.chain?.formatters?.transactionReceipt?.format || (0, $3a6db70bbbdd1d80$export$30da670e49d6fc31);
    return format(receipt);
}



var $9Hxnd = parcelRequire("9Hxnd");



function $ded0719b938037fd$export$e0c10349b2c5e1d4(fn, { emitOnBegin: emitOnBegin, initialWaitTime: initialWaitTime, interval: interval }) {
    let active = true;
    const unwatch = ()=>active = false;
    const watch = async ()=>{
        let data = undefined;
        if (emitOnBegin) data = await fn({
            unpoll: unwatch
        });
        const initialWait = await initialWaitTime?.(data) ?? interval;
        await (0, $1feed7ec9525f20d$export$5c069c93d2b7493f)(initialWait);
        const poll = async ()=>{
            if (!active) return;
            await fn({
                unpoll: unwatch
            });
            await (0, $1feed7ec9525f20d$export$5c069c93d2b7493f)(interval);
            poll();
        };
        poll();
    };
    watch();
    return unwatch;
}



var $c0R7l = parcelRequire("c0R7l");
/** @internal */ const $fbcd90f406def0db$export$e89e805418f4d2c = /*#__PURE__*/ new Map();
const $fbcd90f406def0db$export$b4c67320c85a8b9d = /*#__PURE__*/ new Map();
function $fbcd90f406def0db$export$e2575ed62a2f107b(cacheKey) {
    const buildCache = (cacheKey, cache)=>({
            clear: ()=>cache.delete(cacheKey),
            get: ()=>cache.get(cacheKey),
            set: (data)=>cache.set(cacheKey, data)
        });
    const promise = buildCache(cacheKey, $fbcd90f406def0db$export$e89e805418f4d2c);
    const response = buildCache(cacheKey, $fbcd90f406def0db$export$b4c67320c85a8b9d);
    return {
        clear: ()=>{
            promise.clear();
            response.clear();
        },
        promise: promise,
        response: response
    };
}
async function $fbcd90f406def0db$export$33b32b3abf8170f0(fn, { cacheKey: cacheKey, cacheTime: cacheTime = Number.POSITIVE_INFINITY }) {
    const cache = $fbcd90f406def0db$export$e2575ed62a2f107b(cacheKey);
    // If a response exists in the cache, and it's not expired, return it
    // and do not invoke the promise.
    // If the max age is 0, the cache is disabled.
    const response = cache.response.get();
    if (response && cacheTime > 0) {
        const age = new Date().getTime() - response.created.getTime();
        if (age < cacheTime) return response.data;
    }
    let promise = cache.promise.get();
    if (!promise) {
        promise = fn();
        // Store the promise in the cache so that subsequent invocations
        // will wait for the same promise to resolve (deduping).
        cache.promise.set(promise);
    }
    try {
        const data = await promise;
        // Store the response in the cache so that subsequent invocations
        // will return the same response.
        cache.response.set({
            created: new Date(),
            data: data
        });
        return data;
    } finally{
        // Clear the promise cache so that subsequent invocations will
        // invoke the promise again.
        cache.promise.clear();
    }
}


const $2c2fe0035a21ac83$var$cacheKey = (id)=>`blockNumber.${id}`;
function $2c2fe0035a21ac83$export$bc78c57a2d1b4a2b(id) {
    return (0, $fbcd90f406def0db$export$e2575ed62a2f107b)($2c2fe0035a21ac83$var$cacheKey(id));
}
async function $2c2fe0035a21ac83$export$9328b5c92c53a20e(client, { cacheTime: cacheTime = client.cacheTime } = {}) {
    const blockNumberHex = await (0, $fbcd90f406def0db$export$33b32b3abf8170f0)(()=>client.request({
            method: "eth_blockNumber"
        }), {
        cacheKey: $2c2fe0035a21ac83$var$cacheKey(client.uid),
        cacheTime: cacheTime
    });
    return BigInt(blockNumberHex);
}


function $de77d0fc92e66d19$export$fc5f622dd0d82466(client, { emitOnBegin: emitOnBegin = false, emitMissed: emitMissed = false, onBlockNumber: onBlockNumber, onError: onError, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval }) {
    const enablePolling = (()=>{
        if (typeof poll_ !== "undefined") return poll_;
        if (client.transport.type === "webSocket") return false;
        if (client.transport.type === "fallback" && client.transport.transports[0].config.type === "webSocket") return false;
        return true;
    })();
    let prevBlockNumber;
    const pollBlockNumber = ()=>{
        const observerId = (0, $c0R7l.stringify)([
            "watchBlockNumber",
            client.uid,
            emitOnBegin,
            emitMissed,
            pollingInterval
        ]);
        return (0, $acc3207d4640e06f$export$d1203567a167490e)(observerId, {
            onBlockNumber: onBlockNumber,
            onError: onError
        }, (emit)=>(0, $ded0719b938037fd$export$e0c10349b2c5e1d4)(async ()=>{
                try {
                    const blockNumber = await (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $2c2fe0035a21ac83$export$9328b5c92c53a20e), "getBlockNumber")({
                        cacheTime: 0
                    });
                    if (prevBlockNumber) {
                        // If the current block number is the same as the previous,
                        // we can skip.
                        if (blockNumber === prevBlockNumber) return;
                        // If we have missed out on some previous blocks, and the
                        // `emitMissed` flag is truthy, let's emit those blocks.
                        if (blockNumber - prevBlockNumber > 1 && emitMissed) for(let i = prevBlockNumber + 1n; i < blockNumber; i++){
                            emit.onBlockNumber(i, prevBlockNumber);
                            prevBlockNumber = i;
                        }
                    }
                    // If the next block number is greater than the previous,
                    // it is not in the past, and we can emit the new block number.
                    if (!prevBlockNumber || blockNumber > prevBlockNumber) {
                        emit.onBlockNumber(blockNumber, prevBlockNumber);
                        prevBlockNumber = blockNumber;
                    }
                } catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: emitOnBegin,
                interval: pollingInterval
            }));
    };
    const subscribeBlockNumber = ()=>{
        const observerId = (0, $c0R7l.stringify)([
            "watchBlockNumber",
            client.uid,
            emitOnBegin,
            emitMissed
        ]);
        return (0, $acc3207d4640e06f$export$d1203567a167490e)(observerId, {
            onBlockNumber: onBlockNumber,
            onError: onError
        }, (emit)=>{
            let active = true;
            let unsubscribe = ()=>active = false;
            (async ()=>{
                try {
                    const transport = (()=>{
                        if (client.transport.type === "fallback") {
                            const transport = client.transport.transports.find((transport)=>transport.config.type === "webSocket");
                            if (!transport) return client.transport;
                            return transport.value;
                        }
                        return client.transport;
                    })();
                    const { unsubscribe: unsubscribe_ } = await transport.subscribe({
                        params: [
                            "newHeads"
                        ],
                        onData (data) {
                            if (!active) return;
                            const blockNumber = (0, $9Hxnd.hexToBigInt)(data.result?.number);
                            emit.onBlockNumber(blockNumber, prevBlockNumber);
                            prevBlockNumber = blockNumber;
                        },
                        onError (error) {
                            emit.onError?.(error);
                        }
                    });
                    unsubscribe = unsubscribe_;
                    if (!active) unsubscribe();
                } catch (err) {
                    onError?.(err);
                }
            })();
            return ()=>unsubscribe();
        });
    };
    return enablePolling ? pollBlockNumber() : subscribeBlockNumber();
}


async function $85f21a2c3ee53dcb$export$694ec9bdf0bb55cf(client, { confirmations: confirmations = 1, hash: hash, onReplaced: onReplaced, pollingInterval: pollingInterval = client.pollingInterval, retryCount: retryCount = 6, retryDelay: retryDelay = ({ count: count })=>~~(1 << count) * 200, timeout: timeout = 180000 }) {
    const observerId = (0, $c0R7l.stringify)([
        "waitForTransactionReceipt",
        client.uid,
        hash
    ]);
    let transaction;
    let replacedTransaction;
    let receipt;
    let retrying = false;
    // biome-ignore lint/style/useConst:
    let _unobserve;
    let _unwatch;
    const { promise: promise, resolve: resolve, reject: reject } = (0, $4BHVN.withResolvers)();
    const timer = timeout ? setTimeout(()=>{
        _unwatch();
        _unobserve();
        reject(new (0, $lfct8.WaitForTransactionReceiptTimeoutError)({
            hash: hash
        }));
    }, timeout) : undefined;
    _unobserve = (0, $acc3207d4640e06f$export$d1203567a167490e)(observerId, {
        onReplaced: onReplaced,
        resolve: resolve,
        reject: reject
    }, (emit)=>{
        _unwatch = (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $de77d0fc92e66d19$export$fc5f622dd0d82466), "watchBlockNumber")({
            emitMissed: true,
            emitOnBegin: true,
            poll: true,
            pollingInterval: pollingInterval,
            async onBlockNumber (blockNumber_) {
                const done = (fn)=>{
                    clearTimeout(timer);
                    _unwatch();
                    fn();
                    _unobserve();
                };
                let blockNumber = blockNumber_;
                if (retrying) return;
                try {
                    // If we already have a valid receipt, let's check if we have enough
                    // confirmations. If we do, then we can resolve.
                    if (receipt) {
                        if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                        done(()=>emit.resolve(receipt));
                        return;
                    }
                    // Get the transaction to check if it's been replaced.
                    // We need to retry as some RPC Providers may be slow to sync
                    // up mined transactions.
                    if (!transaction) {
                        retrying = true;
                        await (0, $4aecf79c34be183e$export$188df5ecf8e7961a)(async ()=>{
                            transaction = await (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $5aee70ec212e40a6$export$ec0c6556a09b65b8), "getTransaction")({
                                hash: hash
                            });
                            if (transaction.blockNumber) blockNumber = transaction.blockNumber;
                        }, {
                            delay: retryDelay,
                            retryCount: retryCount
                        });
                        retrying = false;
                    }
                    // Get the receipt to check if it's been processed.
                    receipt = await (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $8964c8daad07aef6$export$6b1ceb3cd5f8b21f), "getTransactionReceipt")({
                        hash: hash
                    });
                    // Check if we have enough confirmations. If not, continue polling.
                    if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                    done(()=>emit.resolve(receipt));
                } catch (err) {
                    // If the receipt is not found, the transaction will be pending.
                    // We need to check if it has potentially been replaced.
                    if (err instanceof (0, $lfct8.TransactionNotFoundError) || err instanceof (0, $lfct8.TransactionReceiptNotFoundError)) {
                        if (!transaction) {
                            retrying = false;
                            return;
                        }
                        try {
                            replacedTransaction = transaction;
                            // Let's retrieve the transactions from the current block.
                            // We need to retry as some RPC Providers may be slow to sync
                            // up mined blocks.
                            retrying = true;
                            const block = await (0, $4aecf79c34be183e$export$188df5ecf8e7961a)(()=>(0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $46802f01c8edc21d$export$ea0af84ed2e77902), "getBlock")({
                                    blockNumber: blockNumber,
                                    includeTransactions: true
                                }), {
                                delay: retryDelay,
                                retryCount: retryCount,
                                shouldRetry: ({ error: error })=>error instanceof (0, $eba37413c57b7950$export$f5a00468af285e38)
                            });
                            retrying = false;
                            const replacementTransaction = block.transactions.find(({ from: from, nonce: nonce })=>from === replacedTransaction.from && nonce === replacedTransaction.nonce);
                            // If we couldn't find a replacement transaction, continue polling.
                            if (!replacementTransaction) return;
                            // If we found a replacement transaction, return it's receipt.
                            receipt = await (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $8964c8daad07aef6$export$6b1ceb3cd5f8b21f), "getTransactionReceipt")({
                                hash: replacementTransaction.hash
                            });
                            // Check if we have enough confirmations. If not, continue polling.
                            if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                            let reason = "replaced";
                            if (replacementTransaction.to === replacedTransaction.to && replacementTransaction.value === replacedTransaction.value && replacementTransaction.input === replacedTransaction.input) reason = "repriced";
                            else if (replacementTransaction.from === replacementTransaction.to && replacementTransaction.value === 0n) reason = "cancelled";
                            done(()=>{
                                emit.onReplaced?.({
                                    reason: reason,
                                    replacedTransaction: replacedTransaction,
                                    transaction: replacementTransaction,
                                    transactionReceipt: receipt
                                });
                                emit.resolve(receipt);
                            });
                        } catch (err_) {
                            done(()=>emit.reject(err_));
                        }
                    } else done(()=>emit.reject(err));
                }
            }
        });
    });
    return promise;
}



async function $1d255c6a6527b703$export$694ec9bdf0bb55cf(config, parameters) {
    const { chainId: chainId, timeout: timeout = 0, ...rest } = parameters;
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $e46aee3e8f3061da$export$6ca3170acb89054)(client, (0, $85f21a2c3ee53dcb$export$694ec9bdf0bb55cf), "waitForTransactionReceipt");
    const receipt = await action({
        ...rest,
        timeout: timeout
    });
    if (receipt.status === "reverted") {
        const action_getTransaction = (0, $e46aee3e8f3061da$export$6ca3170acb89054)(client, (0, $5aee70ec212e40a6$export$ec0c6556a09b65b8), "getTransaction");
        const txn = await action_getTransaction({
            hash: receipt.transactionHash
        });
        const action_call = (0, $e46aee3e8f3061da$export$6ca3170acb89054)(client, (0, $eNB0a.call), "call");
        const code = await action_call({
            ...txn,
            data: txn.input,
            gasPrice: txn.type !== "eip1559" ? txn.gasPrice : undefined,
            maxFeePerGas: txn.type === "eip1559" ? txn.maxFeePerGas : undefined,
            maxPriorityFeePerGas: txn.type === "eip1559" ? txn.maxPriorityFeePerGas : undefined
        });
        const reason = code?.data ? (0, $9Hxnd.hexToString)(`0x${code.data.substring(138)}`) : "unknown reason";
        throw new Error(reason);
    }
    return {
        ...receipt,
        chainId: client.chain.id
    };
}



function $cc1079935b5d84ff$export$30c94aeff2da2ac6(config, parameters) {
    const { onChange: onChange } = parameters;
    return config.subscribe(()=>(0, $fa6344f751511ecb$export$4f9234baf34abd0)(config), onChange, {
        equalityFn (a, b) {
            const { connector: aConnector, ...aRest } = a;
            const { connector: bConnector, ...bRest } = b;
            return (0, $e451a93999f3c4ed$export$9cb4719e2e525b7a)(aRest, bRest) && // check connector separately
            aConnector?.id === bConnector?.id && aConnector?.uid === bConnector?.uid;
        }
    });
}

/** https://wagmi.sh/core/api/actions/watchConnectors */ function $93ef6e240712b52a$export$9c8eec0a0da048a0(config, parameters) {
    const { onChange: onChange } = parameters;
    return config._internal.connectors.subscribe((connectors, prevConnectors)=>{
        onChange(Object.values(connectors), prevConnectors);
    });
}





var $c0R7l = parcelRequire("c0R7l");
/**
 * Scopes `request` to the filter ID. If the client is a fallback, it will
 * listen for responses and scope the child transport `request` function
 * to the successful filter ID.
 */ function $1a85dd757159bc44$export$b7aadf80a875f555(client, { method: method }) {
    const requestMap = {};
    if (client.transport.type === "fallback") client.transport.onResponse?.(({ method: method_, response: id, status: status, transport: transport })=>{
        if (status === "success" && method === method_) requestMap[id] = transport.request;
    });
    return (id)=>requestMap[id] || client.request;
}


async function $32a4f66446e055fd$export$d455ed04c3e85241(client) {
    const getRequest = (0, $1a85dd757159bc44$export$b7aadf80a875f555)(client, {
        method: "eth_newPendingTransactionFilter"
    });
    const id = await client.request({
        method: "eth_newPendingTransactionFilter"
    });
    return {
        id: id,
        request: getRequest(id),
        type: "transaction"
    };
}


// TODO(v3): checksum address.

var $ie3rb = parcelRequire("ie3rb");

var $hKzxL = parcelRequire("hKzxL");

var $lbhq0 = parcelRequire("lbhq0");

var $bHm1a = parcelRequire("bHm1a");

var $h5q9B = parcelRequire("h5q9B");

var $ie3rb = parcelRequire("ie3rb");

var $loik3 = parcelRequire("loik3");

var $h5q9B = parcelRequire("h5q9B");

var $h6fPA = parcelRequire("h6fPA");

var $dY2s0 = parcelRequire("dY2s0");

var $gDCe1 = parcelRequire("gDCe1");
const $91498e106c05bc71$var$docsPath = "/docs/contract/decodeEventLog";
function $91498e106c05bc71$export$ec0597e81db3d947(parameters) {
    const { abi: abi, data: data, strict: strict_, topics: topics } = parameters;
    const strict = strict_ ?? true;
    const [signature, ...argTopics] = topics;
    if (!signature) throw new (0, $ie3rb.AbiEventSignatureEmptyTopicsError)({
        docsPath: $91498e106c05bc71$var$docsPath
    });
    const abiItem = (()=>{
        if (abi.length === 1) return abi[0];
        return abi.find((x)=>x.type === "event" && signature === (0, $h5q9B.toEventSelector)((0, $gDCe1.formatAbiItem)(x)));
    })();
    if (!(abiItem && "name" in abiItem) || abiItem.type !== "event") throw new (0, $ie3rb.AbiEventSignatureNotFoundError)(signature, {
        docsPath: $91498e106c05bc71$var$docsPath
    });
    const { name: name, inputs: inputs } = abiItem;
    const isUnnamed = inputs?.some((x)=>!("name" in x && x.name));
    let args = isUnnamed ? [] : {};
    // Decode topics (indexed args).
    const indexedInputs = inputs.filter((x)=>"indexed" in x && x.indexed);
    for(let i = 0; i < indexedInputs.length; i++){
        const param = indexedInputs[i];
        const topic = argTopics[i];
        if (!topic) throw new (0, $ie3rb.DecodeLogTopicsMismatch)({
            abiItem: abiItem,
            param: param
        });
        args[isUnnamed ? i : param.name || i] = $91498e106c05bc71$var$decodeTopic({
            param: param,
            value: topic
        });
    }
    // Decode data (non-indexed args).
    const nonIndexedInputs = inputs.filter((x)=>!("indexed" in x && x.indexed));
    if (nonIndexedInputs.length > 0) {
        if (data && data !== "0x") try {
            const decodedData = (0, $dY2s0.decodeAbiParameters)(nonIndexedInputs, data);
            if (decodedData) {
                if (isUnnamed) args = [
                    ...args,
                    ...decodedData
                ];
                else for(let i = 0; i < nonIndexedInputs.length; i++)args[nonIndexedInputs[i].name] = decodedData[i];
            }
        } catch (err) {
            if (strict) {
                if (err instanceof (0, $ie3rb.AbiDecodingDataSizeTooSmallError) || err instanceof (0, $h6fPA.PositionOutOfBoundsError)) throw new (0, $ie3rb.DecodeLogDataMismatch)({
                    abiItem: abiItem,
                    data: data,
                    params: nonIndexedInputs,
                    size: (0, $loik3.size)(data)
                });
                throw err;
            }
        }
        else if (strict) throw new (0, $ie3rb.DecodeLogDataMismatch)({
            abiItem: abiItem,
            data: "0x",
            params: nonIndexedInputs,
            size: 0
        });
    }
    return {
        eventName: name,
        args: Object.values(args).length > 0 ? args : undefined
    };
}
function $91498e106c05bc71$var$decodeTopic({ param: param, value: value }) {
    if (param.type === "string" || param.type === "bytes" || param.type === "tuple" || param.type.match(/^(.*)\[(\d+)?\]$/)) return value;
    const decodedArg = (0, $dY2s0.decodeAbiParameters)([
        param
    ], value) || [];
    return decodedArg[0];
}


function $04842b23c7f098ee$export$7d811a19971cdf46(parameters) {
    const { abi: abi, args: args, logs: logs, strict: strict = true } = parameters;
    const eventName = (()=>{
        if (!parameters.eventName) return undefined;
        if (Array.isArray(parameters.eventName)) return parameters.eventName;
        return [
            parameters.eventName
        ];
    })();
    return logs.map((log)=>{
        try {
            const abiItem = abi.find((abiItem)=>abiItem.type === "event" && log.topics[0] === (0, $h5q9B.toEventSelector)(abiItem));
            if (!abiItem) return null;
            const event = (0, $91498e106c05bc71$export$ec0597e81db3d947)({
                ...log,
                abi: [
                    abiItem
                ],
                strict: strict
            });
            // Check that the decoded event name matches the provided event name.
            if (eventName && !eventName.includes(event.eventName)) return null;
            // Check that the decoded event args match the provided args.
            if (!$04842b23c7f098ee$var$includesArgs({
                args: event.args,
                inputs: abiItem.inputs,
                matchArgs: args
            })) return null;
            return {
                ...event,
                ...log
            };
        } catch (err) {
            let eventName;
            let isUnnamed;
            if (err instanceof (0, $ie3rb.AbiEventSignatureNotFoundError)) return null;
            if (err instanceof (0, $ie3rb.DecodeLogDataMismatch) || err instanceof (0, $ie3rb.DecodeLogTopicsMismatch)) {
                // If strict mode is on, and log data/topics do not match event definition, skip.
                if (strict) return null;
                eventName = err.abiItem.name;
                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
            }
            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
            return {
                ...log,
                args: isUnnamed ? [] : {},
                eventName: eventName
            };
        }
    }).filter(Boolean);
}
function $04842b23c7f098ee$var$includesArgs(parameters) {
    const { args: args, inputs: inputs, matchArgs: matchArgs } = parameters;
    if (!matchArgs) return true;
    if (!args) return false;
    function isEqual(input, value, arg) {
        try {
            if (input.type === "address") return (0, $hKzxL.isAddressEqual)(value, arg);
            if (input.type === "string" || input.type === "bytes") return (0, $bHm1a.keccak256)((0, $lbhq0.toBytes)(value)) === arg;
            return value === arg;
        } catch  {
            return false;
        }
    }
    if (Array.isArray(args) && Array.isArray(matchArgs)) return matchArgs.every((value, index)=>{
        if (value === null || value === undefined) return true;
        const input = inputs[index];
        if (!input) return false;
        const value_ = Array.isArray(value) ? value : [
            value
        ];
        return value_.some((value)=>isEqual(input, value, args[index]));
    });
    if (typeof args === "object" && !Array.isArray(args) && typeof matchArgs === "object" && !Array.isArray(matchArgs)) return Object.entries(matchArgs).every(([key, value])=>{
        if (value === null || value === undefined) return true;
        const input = inputs.find((input)=>input.name === key);
        if (!input) return false;
        const value_ = Array.isArray(value) ? value : [
            value
        ];
        return value_.some((value)=>isEqual(input, value, args[key]));
    });
    return false;
}



async function $9d9c530f593ba139$export$e69fa84ce52a94fd(_client, { filter: filter }) {
    const strict = "strict" in filter && filter.strict;
    const logs = await filter.request({
        method: "eth_getFilterChanges",
        params: [
            filter.id
        ]
    });
    if (typeof logs[0] === "string") return logs;
    const formattedLogs = logs.map((log)=>(0, $b1c8c518cc547e60$export$fccdbdc2b9d7893)(log));
    if (!("abi" in filter) || !filter.abi) return formattedLogs;
    return (0, $04842b23c7f098ee$export$7d811a19971cdf46)({
        abi: filter.abi,
        logs: formattedLogs,
        strict: strict
    });
}


/**
 * Destroys a [`Filter`](https://viem.sh/docs/glossary/types#filter).
 *
 * - Docs: https://viem.sh/docs/actions/public/uninstallFilter
 * - JSON-RPC Methods: [`eth_uninstallFilter`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_uninstallFilter)
 *
 * Destroys a Filter that was created from one of the following Actions:
 * - [`createBlockFilter`](https://viem.sh/docs/actions/public/createBlockFilter)
 * - [`createEventFilter`](https://viem.sh/docs/actions/public/createEventFilter)
 * - [`createPendingTransactionFilter`](https://viem.sh/docs/actions/public/createPendingTransactionFilter)
 *
 * @param client - Client to use
 * @param parameters - {@link UninstallFilterParameters}
 * @returns A boolean indicating if the Filter was successfully uninstalled. {@link UninstallFilterReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { createPendingTransactionFilter, uninstallFilter } from 'viem/public'
 *
 * const filter = await createPendingTransactionFilter(client)
 * const uninstalled = await uninstallFilter(client, { filter })
 * // true
 */ async function $90d1bd0f64e239de$export$54eb7d691768f7f3(_client, { filter: filter }) {
    return filter.request({
        method: "eth_uninstallFilter",
        params: [
            filter.id
        ]
    });
}


function $11eef34b0a28de95$export$223080172c87e789(client, { batch: batch = true, onError: onError, onTransactions: onTransactions, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval }) {
    const enablePolling = typeof poll_ !== "undefined" ? poll_ : client.transport.type !== "webSocket";
    const pollPendingTransactions = ()=>{
        const observerId = (0, $c0R7l.stringify)([
            "watchPendingTransactions",
            client.uid,
            batch,
            pollingInterval
        ]);
        return (0, $acc3207d4640e06f$export$d1203567a167490e)(observerId, {
            onTransactions: onTransactions,
            onError: onError
        }, (emit)=>{
            let filter;
            const unwatch = (0, $ded0719b938037fd$export$e0c10349b2c5e1d4)(async ()=>{
                try {
                    if (!filter) try {
                        filter = await (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $32a4f66446e055fd$export$d455ed04c3e85241), "createPendingTransactionFilter")({});
                        return;
                    } catch (err) {
                        unwatch();
                        throw err;
                    }
                    const hashes = await (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $9d9c530f593ba139$export$e69fa84ce52a94fd), "getFilterChanges")({
                        filter: filter
                    });
                    if (hashes.length === 0) return;
                    if (batch) emit.onTransactions(hashes);
                    else for (const hash of hashes)emit.onTransactions([
                        hash
                    ]);
                } catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: true,
                interval: pollingInterval
            });
            return async ()=>{
                if (filter) await (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $90d1bd0f64e239de$export$54eb7d691768f7f3), "uninstallFilter")({
                    filter: filter
                });
                unwatch();
            };
        });
    };
    const subscribePendingTransactions = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
                    params: [
                        "newPendingTransactions"
                    ],
                    onData (data) {
                        if (!active) return;
                        const transaction = data.result;
                        onTransactions([
                            transaction
                        ]);
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return ()=>unsubscribe();
    };
    return enablePolling ? pollPendingTransactions() : subscribePendingTransactions();
}



function $d0cd3b76a9698d00$export$223080172c87e789(config, parameters) {
    const { syncConnectedChain: syncConnectedChain = config._internal.syncConnectedChain, ...rest } = parameters;
    let unwatch;
    const listener = (chainId)=>{
        if (unwatch) unwatch();
        const client = config.getClient({
            chainId: chainId
        });
        const action = (0, $e46aee3e8f3061da$export$6ca3170acb89054)(client, (0, $11eef34b0a28de95$export$223080172c87e789), "watchPendingTransactions");
        unwatch = action(rest);
        return unwatch;
    };
    // set up listener for transaction changes
    const unlisten = listener(parameters.chainId);
    // set up subscriber for connected chain changes
    let unsubscribe;
    if (syncConnectedChain && !parameters.chainId) unsubscribe = config.subscribe(({ chainId: chainId })=>chainId, async (chainId)=>listener(chainId));
    return ()=>{
        unlisten?.();
        unsubscribe?.();
    };
}


var $fbsYZ = parcelRequire("fbsYZ");


var $83bOE = parcelRequire("83bOE");



async function $53e3014c8fa02f44$export$4c0f201bc17cbf23(client, parameters) {
    const { abi: abi, account: account_ = client.account, address: address, args: args, dataSuffix: dataSuffix, functionName: functionName, ...request } = parameters;
    if (typeof account_ === "undefined") throw new (0, $9565d0f317c58323$export$62ee6b05f0767f28)({
        docsPath: "/docs/contract/writeContract"
    });
    const account = account_ ? (0, $fbsYZ.parseAccount)(account_) : null;
    const data = (0, $83bOE.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        return await (0, $1942e1266009a208$export$6ca3170acb89054)(client, (0, $02b3018b7c29f08e$export$8e0e7ffc78696d30), "sendTransaction")({
            data: `${data}${dataSuffix ? dataSuffix.replace("0x", "") : ""}`,
            to: address,
            account: account,
            ...request
        });
    } catch (error) {
        throw (0, $e06269ffd337955e$export$4414444aba6ddd8a)(error, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/writeContract",
            functionName: functionName,
            sender: account?.address
        });
    }
}




async function $54d056da97aba73a$export$4c0f201bc17cbf23(config, parameters) {
    const { account: account, chainId: chainId, connector: connector, ...request } = parameters;
    let client;
    if (typeof account === "object" && account?.type === "local") client = config.getClient({
        chainId: chainId
    });
    else client = await (0, $3e82a7de501bc551$export$d784801ca17b4aec)(config, {
        account: account ?? undefined,
        chainId: chainId,
        connector: connector
    });
    const action = (0, $e46aee3e8f3061da$export$6ca3170acb89054)(client, (0, $53e3014c8fa02f44$export$4c0f201bc17cbf23), "writeContract");
    const hash = await action({
        ...request,
        ...account ? {
            account: account
        } : {},
        chain: chainId ? {
            id: chainId
        } : null
    });
    return hash;
}




var $lUvCu = parcelRequire("lUvCu");
var $3cVvs = parcelRequire("3cVvs");
class $35f37b33b4a0a7e7$export$7c1f3850adf73cff extends (0, $3cVvs.BaseError) {
    constructor({ value: value }){
        super(`Number \`${value}\` is not a valid decimal number.`, {
            name: "InvalidDecimalNumberError"
        });
    }
}


function $c443e793bc66489a$export$203ae30b4f6490b3(value, decimals) {
    if (!/^(-?)([0-9]*)\.?([0-9]*)$/.test(value)) throw new (0, $35f37b33b4a0a7e7$export$7c1f3850adf73cff)({
        value: value
    });
    let [integer, fraction = "0"] = value.split(".");
    const negative = integer.startsWith("-");
    if (negative) integer = integer.slice(1);
    // trim trailing zeros.
    fraction = fraction.replace(/(0+)$/, "");
    // round off if the fraction is larger than the number of decimals.
    if (decimals === 0) {
        if (Math.round(Number(`.${fraction}`)) === 1) integer = `${BigInt(integer) + 1n}`;
        fraction = "";
    } else if (fraction.length > decimals) {
        const [left, unit, right] = [
            fraction.slice(0, decimals - 1),
            fraction.slice(decimals - 1, decimals),
            fraction.slice(decimals)
        ];
        const rounded = Math.round(Number(`${unit}.${right}`));
        if (rounded > 9) fraction = `${BigInt(left) + BigInt(1)}0`.padStart(left.length + 1, "0");
        else fraction = `${left}${rounded}`;
        if (fraction.length > decimals) {
            fraction = fraction.slice(1);
            integer = `${BigInt(integer) + 1n}`;
        }
        fraction = fraction.slice(0, decimals);
    } else fraction = fraction.padEnd(decimals, "0");
    return BigInt(`${negative ? "-" : ""}${integer}${fraction}`);
}



var $lpmCO = parcelRequire("lpmCO");



function $7ad9bd33ae93af21$export$805fba51c5f25785(options) {
    return new (0, $fd3886b08403045a$export$fc94c40ea502fa4c)({
        ...options,
        sdkVersion: (0, $lpmCO.CoreHelperUtil).generateSdkVersion(options.adapters ?? [], "html", (0, $fcb2c6c83776f4b4$export$4a03ffab3315ee34))
    });
}



var $b3v9s = parcelRequire("b3v9s");
var $dawjb = parcelRequire("dawjb");

var $lpmCO = parcelRequire("lpmCO");
var $bc5dy = parcelRequire("bc5dy");












var $jb2AH = parcelRequire("jb2AH");

var $bOQZu = parcelRequire("bOQZu");
var $16W4z = parcelRequire("16W4z");

var $b3v9s = parcelRequire("b3v9s");
var $dawjb = parcelRequire("dawjb");

var $kfwQH = parcelRequire("kfwQH");
var $5PQZs = parcelRequire("5PQZs");
var $gD0RX = parcelRequire("gD0RX");

var $6rTj5 = parcelRequire("6rTj5");






function $c3691ab180177f18$export$f3a67f9bdc78b494(parameters) {
    let currentAccounts = [];
    let socialProvider = undefined;
    let connectSocialPromise = undefined;
    function parseChainId(chainId) {
        return (0, $dawjb.NetworkUtil).parseEvmChainId(chainId) || 1;
    }
    function getProviderInstance() {
        if (!socialProvider) socialProvider = (0, $52cf67d5bf1c16df$export$a0344615582d8da3).getInstance({
            projectId: parameters.options.projectId,
            chainId: (0, $gD0RX.ChainController).getActiveCaipNetwork()?.caipNetworkId,
            enableLogger: parameters.options.enableAuthLogger,
            onTimeout: (reason)=>{
                if (reason === "iframe_load_failed") (0, $5PQZs.AlertController).open((0, $6rTj5.ErrorUtil).ALERT_ERRORS.IFRAME_LOAD_FAILED, "error");
                else if (reason === "iframe_request_timeout") (0, $5PQZs.AlertController).open((0, $6rTj5.ErrorUtil).ALERT_ERRORS.IFRAME_REQUEST_TIMEOUT, "error");
                else if (reason === "unverified_domain") (0, $5PQZs.AlertController).open((0, $6rTj5.ErrorUtil).ALERT_ERRORS.UNVERIFIED_DOMAIN, "error");
            },
            abortController: (0, $6rTj5.ErrorUtil).EmbeddedWalletAbortController
        });
        return socialProvider;
    }
    async function connectSocial(options = {}) {
        const provider = getProviderInstance();
        let chainId = options.chainId;
        if (options.isReconnecting) {
            const lastUsedChainId = (0, $dawjb.NetworkUtil).parseEvmChainId(provider.getLastUsedChainId() || "");
            const defaultChainId = parameters.chains?.[0].id;
            chainId = lastUsedChainId || defaultChainId;
            if (!chainId) throw new Error("ChainId not found in provider");
        }
        const preferredAccountType = (0, $kfwQH.AccountController).state.preferredAccountTypes?.eip155;
        const { address: address, chainId: frameChainId, accounts: accounts } = await provider.connect({
            chainId: chainId,
            preferredAccountType: preferredAccountType,
            socialUri: options.socialUri
        });
        currentAccounts = accounts?.map((a)=>a.address) || [
            address
        ];
        const parsedChainId = parseChainId(frameChainId);
        return {
            accounts: currentAccounts,
            account: address,
            chainId: parsedChainId,
            chain: {
                id: parsedChainId,
                unsuported: false
            }
        };
    }
    return (0, $jb2AH.createConnector)((config)=>({
            id: (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH,
            name: (0, $b3v9s.ConstantsUtil).CONNECTOR_NAMES.AUTH,
            type: "AUTH",
            chain: (0, $b3v9s.ConstantsUtil).CHAIN.EVM,
            async connect (options = {}) {
                if (connectSocialPromise) return connectSocialPromise;
                if (!connectSocialPromise) connectSocialPromise = new Promise((resolve)=>{
                    resolve(connectSocial(options));
                });
                const result = await connectSocialPromise;
                connectSocialPromise = undefined;
                return result;
            },
            async disconnect () {
                const provider = await this.getProvider();
                await provider.disconnect();
            },
            getAccounts () {
                if (!currentAccounts?.length) return Promise.resolve([]);
                config.emitter.emit("change", {
                    accounts: currentAccounts
                });
                return Promise.resolve(currentAccounts);
            },
            async getProvider () {
                if (!this.provider) this.provider = (0, $52cf67d5bf1c16df$export$a0344615582d8da3).getInstance({
                    projectId: parameters.options.projectId,
                    chainId: (0, $gD0RX.ChainController).getActiveCaipNetwork()?.caipNetworkId,
                    enableLogger: parameters.options.enableAuthLogger,
                    abortController: (0, $6rTj5.ErrorUtil).EmbeddedWalletAbortController,
                    onTimeout: (reason)=>{
                        if (reason === "iframe_load_failed") (0, $5PQZs.AlertController).open((0, $6rTj5.ErrorUtil).ALERT_ERRORS.IFRAME_LOAD_FAILED, "error");
                        else if (reason === "iframe_request_timeout") (0, $5PQZs.AlertController).open((0, $6rTj5.ErrorUtil).ALERT_ERRORS.IFRAME_REQUEST_TIMEOUT, "error");
                        else if (reason === "unverified_domain") (0, $5PQZs.AlertController).open((0, $6rTj5.ErrorUtil).ALERT_ERRORS.UNVERIFIED_DOMAIN, "error");
                    }
                });
                return Promise.resolve(this.provider);
            },
            async getChainId () {
                const provider = await this.getProvider();
                const { chainId: chainId } = await provider.getChainId();
                return parseChainId(chainId);
            },
            async isAuthorized () {
                const provider = await this.getProvider();
                return Promise.resolve(provider.getLoginEmailUsed());
            },
            async switchChain ({ chainId: chainId }) {
                try {
                    const chain = config.chains.find((c)=>c.id === chainId);
                    if (!chain) throw new (0, $16W4z.SwitchChainError)(new Error("chain not found on connector."));
                    const provider = await this.getProvider();
                    const preferredAccountType = (0, $kfwQH.AccountController).state.preferredAccountTypes?.eip155;
                    const response = await provider.connect({
                        chainId: chainId,
                        preferredAccountType: preferredAccountType
                    });
                    currentAccounts = response?.accounts?.map((a)=>a.address) || [
                        response.address
                    ];
                    config.emitter.emit("change", {
                        chainId: Number(chainId),
                        accounts: currentAccounts
                    });
                    return chain;
                } catch (error) {
                    if (error instanceof Error) throw new (0, $16W4z.SwitchChainError)(error);
                    throw error;
                }
            },
            onAccountsChanged (accounts) {
                if (accounts.length === 0) this.onDisconnect();
                else config.emitter.emit("change", {
                    accounts: accounts.map((0, $bOQZu.getAddress))
                });
            },
            onChainChanged (chain) {
                const chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            async onDisconnect (_error) {
                const provider = await this.getProvider();
                await provider.disconnect();
            }
        }));
}



var $9yvAP = parcelRequire("9yvAP");
var $jb2AH = parcelRequire("jb2AH");
parcelRequire("5ID99");

var $bOQZu = parcelRequire("bOQZu");
var $nDot9 = parcelRequire("nDot9");
var $16W4z = parcelRequire("16W4z");


var $b3v9s = parcelRequire("b3v9s");

var $gD0RX = parcelRequire("gD0RX");
var $knC5d = parcelRequire("knC5d");
var $bc5dy = parcelRequire("bc5dy");
$0669a67b23c55dc5$export$340cc50ae9d9f255.type = "walletConnect";
function $0669a67b23c55dc5$export$340cc50ae9d9f255(parameters, appKit) {
    const isNewChainsStale = parameters.isNewChainsStale ?? true;
    let provider_;
    let accountsChanged;
    let chainChanged;
    let connect;
    let displayUri;
    let sessionDelete;
    let disconnect;
    return (0, $jb2AH.createConnector)((config)=>({
            id: "walletConnect",
            name: "WalletConnect",
            type: $0669a67b23c55dc5$export$340cc50ae9d9f255.type,
            async setup () {
                const provider = await this.getProvider().catch(()=>null);
                if (!provider) return;
                if (!connect) {
                    connect = this.onConnect.bind(this);
                    provider.on("connect", connect);
                }
                if (!sessionDelete) {
                    sessionDelete = this.onSessionDelete.bind(this);
                    provider.on("session_delete", sessionDelete);
                }
            },
            async connect ({ ...rest } = {}) {
                try {
                    const caipNetworks = (0, $gD0RX.ChainController).getCaipNetworks();
                    const provider = await this.getProvider();
                    if (!provider) throw new (0, $064d9adb8a9c12a4$export$43839b3ff6336f15)();
                    if (!displayUri) {
                        displayUri = this.onDisplayUri;
                        provider.on("display_uri", displayUri);
                    }
                    const isChainsStale = await this.isChainsStale();
                    if (provider.session && isChainsStale) await provider.disconnect();
                    const universalProviderConfigOverride = (0, $knC5d.OptionsController).state.universalProviderConfigOverride;
                    if (!provider.session || isChainsStale) {
                        const namespaces = (0, $6c592072e95901b7$export$4267940df2f33c5a).createNamespaces(caipNetworks, universalProviderConfigOverride);
                        await provider.connect({
                            optionalNamespaces: namespaces,
                            ..."pairingTopic" in rest ? {
                                pairingTopic: rest.pairingTopic
                            } : {}
                        });
                        this.setRequestedChainsIds(caipNetworks.map((x)=>Number(x.id)));
                    }
                    const accounts = await this.getAccounts();
                    const requestChainId = await this.getChainId();
                    const chains = provider.session?.namespaces?.["eip155"]?.chains;
                    const isRequestedChainSupported = chains?.some((chain)=>Number(chain.split(":")[1]) === requestChainId);
                    let currentChainId = 1;
                    if (isRequestedChainSupported) currentChainId = requestChainId;
                    else if (chains?.[0]) currentChainId = Number(chains[0].split(":")[1]);
                    if (displayUri) {
                        provider.removeListener("display_uri", displayUri);
                        displayUri = undefined;
                    }
                    if (connect) {
                        provider.removeListener("connect", connect);
                        connect = undefined;
                    }
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                    if (!chainChanged) {
                        chainChanged = this.onChainChanged.bind(this);
                        provider.on("chainChanged", chainChanged);
                    }
                    if (!disconnect) {
                        disconnect = this.onDisconnect.bind(this);
                        provider.on("disconnect", disconnect);
                    }
                    if (!sessionDelete) {
                        sessionDelete = this.onSessionDelete.bind(this);
                        provider.on("session_delete", sessionDelete);
                    }
                    const defaultChain = universalProviderConfigOverride?.defaultChain;
                    provider.setDefaultChain(defaultChain ?? `eip155:${currentChainId}`);
                    return {
                        accounts: accounts,
                        chainId: currentChainId
                    };
                } catch (error) {
                    if (/(user rejected|connection request reset)/i.test(error?.message)) throw new (0, $16W4z.UserRejectedRequestError)(error);
                    throw error;
                }
            },
            async disconnect () {
                const provider = await this.getProvider();
                try {
                    await provider?.disconnect();
                } catch (error) {
                    if (!/No matching key/i.test(error.message)) throw error;
                } finally{
                    if (chainChanged) {
                        provider?.removeListener("chainChanged", chainChanged);
                        chainChanged = undefined;
                    }
                    if (disconnect) {
                        provider?.removeListener("disconnect", disconnect);
                        disconnect = undefined;
                    }
                    if (!connect) {
                        connect = this.onConnect.bind(this);
                        provider?.on("connect", connect);
                    }
                    if (accountsChanged) {
                        provider?.removeListener("accountsChanged", accountsChanged);
                        accountsChanged = undefined;
                    }
                    if (sessionDelete) {
                        provider?.removeListener("session_delete", sessionDelete);
                        sessionDelete = undefined;
                    }
                    this.setRequestedChainsIds([]);
                }
            },
            async getAccounts () {
                const provider = await this.getProvider();
                if (!provider?.session?.namespaces) return [];
                const accountsList = provider?.session?.namespaces[(0, $b3v9s.ConstantsUtil).CHAIN.EVM]?.accounts;
                const accounts = accountsList?.map((account)=>account.split(":")[2]) ?? [];
                return accounts;
            },
            async getProvider ({ chainId: chainId } = {}) {
                if (!provider_) {
                    provider_ = await appKit.getUniversalProvider();
                    provider_?.events.setMaxListeners(Number.POSITIVE_INFINITY);
                }
                const activeNamespace = (0, $bc5dy.StorageUtil).getActiveNamespace();
                const currentChainId = appKit.getCaipNetwork()?.id;
                if (chainId && currentChainId !== chainId && activeNamespace) {
                    const storedCaipNetworkId = (0, $bc5dy.StorageUtil).getStoredActiveCaipNetworkId();
                    const appKitCaipNetworks = appKit.getCaipNetworks(activeNamespace);
                    const storedCaipNetwork = appKitCaipNetworks?.find((n)=>n.id === storedCaipNetworkId);
                    if (storedCaipNetwork && storedCaipNetwork.chainNamespace === (0, $b3v9s.ConstantsUtil).CHAIN.EVM) await this.switchChain?.({
                        chainId: Number(storedCaipNetwork.id)
                    });
                }
                return provider_;
            },
            async getChainId () {
                const chainId = appKit.getCaipNetwork((0, $b3v9s.ConstantsUtil).CHAIN.EVM)?.id;
                if (chainId) return chainId;
                const provider = await this.getProvider();
                const chain = provider.session?.namespaces[(0, $b3v9s.ConstantsUtil).CHAIN.EVM]?.chains?.[0];
                const network = (0, $gD0RX.ChainController).getCaipNetworks().find((c)=>c.id === chain);
                return network?.id;
            },
            async isAuthorized () {
                try {
                    const [accounts, provider] = await Promise.all([
                        this.getAccounts(),
                        this.getProvider()
                    ]);
                    if (!accounts.length) return false;
                    const isChainsStale = await this.isChainsStale();
                    if (isChainsStale && provider.session) {
                        await provider.disconnect().catch(()=>{});
                        return false;
                    }
                    return true;
                } catch  {
                    return false;
                }
            },
            async switchChain ({ addEthereumChainParameter: addEthereumChainParameter, chainId: chainId }) {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $064d9adb8a9c12a4$export$43839b3ff6336f15)();
                const chainToSwitch = (0, $gD0RX.ChainController).getCaipNetworks().find((x)=>x.id === chainId);
                if (!chainToSwitch) throw new (0, $16W4z.SwitchChainError)(new (0, $9yvAP.ChainNotConfiguredError)());
                try {
                    await provider.request({
                        method: "wallet_switchEthereumChain",
                        params: [
                            {
                                chainId: (0, $nDot9.numberToHex)(chainId)
                            }
                        ]
                    });
                    if (chainToSwitch?.caipNetworkId) provider.setDefaultChain(chainToSwitch?.caipNetworkId);
                    config.emitter.emit("change", {
                        chainId: Number(chainId)
                    });
                    const requestedChains = await this.getRequestedChainsIds();
                    this.setRequestedChainsIds([
                        ...requestedChains,
                        chainId
                    ]);
                    return {
                        ...chainToSwitch,
                        id: chainToSwitch.id
                    };
                } catch (err) {
                    const error = err;
                    if (/(?:user rejected)/iu.test(error.message)) throw new (0, $16W4z.UserRejectedRequestError)(error);
                    try {
                        let blockExplorerUrls;
                        if (addEthereumChainParameter?.blockExplorerUrls) blockExplorerUrls = addEthereumChainParameter.blockExplorerUrls;
                        else blockExplorerUrls = chainToSwitch.blockExplorers?.default.url ? [
                            chainToSwitch.blockExplorers?.default.url
                        ] : [];
                        const rpcUrls = chainToSwitch.rpcUrls?.["chainDefault"]?.http || [];
                        const addEthereumChain = {
                            blockExplorerUrls: blockExplorerUrls,
                            chainId: (0, $nDot9.numberToHex)(chainId),
                            chainName: chainToSwitch.name,
                            iconUrls: addEthereumChainParameter?.iconUrls,
                            nativeCurrency: chainToSwitch.nativeCurrency,
                            rpcUrls: rpcUrls
                        };
                        await provider.request({
                            method: "wallet_addEthereumChain",
                            params: [
                                addEthereumChain
                            ]
                        });
                        const requestedChains = await this.getRequestedChainsIds();
                        this.setRequestedChainsIds([
                            ...requestedChains,
                            chainId
                        ]);
                        return {
                            ...chainToSwitch,
                            id: chainToSwitch.id
                        };
                    } catch (e) {
                        throw new (0, $16W4z.UserRejectedRequestError)(e);
                    }
                }
            },
            onAccountsChanged (accounts) {
                if (accounts.length === 0) this.onDisconnect();
                else config.emitter.emit("change", {
                    accounts: accounts.map((x)=>(0, $bOQZu.getAddress)(x))
                });
            },
            onChainChanged (chain) {
                const chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            onConnect (_connectInfo) {
                this.setRequestedChainsIds((0, $gD0RX.ChainController).getCaipNetworks().map((x)=>Number(x.id)));
            },
            async onDisconnect (_error) {
                this.setRequestedChainsIds([]);
                config.emitter.emit("disconnect");
                const provider = await this.getProvider();
                if (accountsChanged) {
                    provider.removeListener("accountsChanged", accountsChanged);
                    accountsChanged = undefined;
                }
                if (chainChanged) {
                    provider.removeListener("chainChanged", chainChanged);
                    chainChanged = undefined;
                }
                if (disconnect) {
                    provider.removeListener("disconnect", disconnect);
                    disconnect = undefined;
                }
                if (sessionDelete) {
                    provider.removeListener("session_delete", sessionDelete);
                    sessionDelete = undefined;
                }
                if (!connect) {
                    connect = this.onConnect.bind(this);
                    provider.on("connect", connect);
                }
            },
            onDisplayUri (uri) {
                config.emitter.emit("message", {
                    type: "display_uri",
                    data: uri
                });
            },
            onSessionDelete () {
                this.onDisconnect();
            },
            getNamespaceChainsIds () {
                if (!provider_?.session?.namespaces) return [];
                const accounts = provider_?.session?.namespaces[(0, $b3v9s.ConstantsUtil).CHAIN.EVM]?.accounts;
                const chainIds = accounts?.map((account)=>Number.parseInt(account.split(":")[1] ?? "")) ?? [];
                return chainIds;
            },
            async getRequestedChainsIds () {
                const chainIds = await config.storage?.getItem(this.requestedChainsStorageKey) ?? [];
                return [
                    ...new Set(chainIds)
                ];
            },
            async isChainsStale () {
                if (!isNewChainsStale) return false;
                const connectorChains = config.chains.map((x)=>x.id);
                const namespaceChains = this.getNamespaceChainsIds();
                if (namespaceChains.length && !namespaceChains.some((id)=>connectorChains.includes(id))) return false;
                const requestedChains = await this.getRequestedChainsIds();
                return !connectorChains.every((id)=>requestedChains.includes(Number(id)));
            },
            async setRequestedChainsIds (chains) {
                await config.storage?.setItem(this.requestedChainsStorageKey, chains);
            },
            get requestedChainsStorageKey () {
                return `${this.id}.requestedChains`;
            }
        }));
}



var $7zrdF = parcelRequire("7zrdF");

var $eFS1l = parcelRequire("eFS1l");
const $18b6d2a3a0e46d9c$var$state = (0, $7zrdF.proxy)({
    pendingTransactions: 0
});
const $18b6d2a3a0e46d9c$export$399d961cb92bca2e = {
    state: $18b6d2a3a0e46d9c$var$state,
    subscribeKey (key, callback) {
        return (0, $eFS1l.subscribeKey)($18b6d2a3a0e46d9c$var$state, key, callback);
    },
    increase (value) {
        $18b6d2a3a0e46d9c$var$state[value] += 1;
    },
    decrease (value) {
        $18b6d2a3a0e46d9c$var$state[value] -= 1;
    },
    reset (value) {
        $18b6d2a3a0e46d9c$var$state[value] = 0;
    }
};


parcelRequire("5ID99");




var $5SSdQ = parcelRequire("5SSdQ");
async function $260552581236db38$export$24a8d1cae47a6f(connector) {
    if (!connector) throw new Error("networkControllerClient:getApprovedCaipNetworks - connector is undefined");
    const provider = await connector?.getProvider();
    const approvedCaipNetworkIds = (0, $6c592072e95901b7$export$4267940df2f33c5a).getChainsFromNamespaces(provider?.session?.namespaces);
    return {
        supportsAllNetworks: false,
        approvedCaipNetworkIds: approvedCaipNetworkIds
    };
}
function $260552581236db38$export$94f91666d3e5b28f() {
    return {
        supportsAllNetworks: true,
        approvedCaipNetworkIds: (0, $8a4fed4bf263e097$export$fd35d6514357600).WalletConnectRpcChainIds.map((id)=>`${(0, $5SSdQ.ConstantsUtil).EIP155}:${id}`)
    };
}
function $260552581236db38$export$c1398e40f52e8b4a(caipAddress) {
    if (!caipAddress) throw new Error("No CAIP address provided");
    const account = caipAddress.split(":")[2];
    if (!account) throw new Error("Invalid CAIP address");
    return account;
}
function $260552581236db38$export$644380e4fcc9c934(str) {
    try {
        return JSON.parse(str);
    } catch (error) {
        throw new Error("Error parsing wallet capabilities");
    }
}


const $fb0395c945bfeac2$var$DEFAULT_PENDING_TRANSACTIONS_FILTER = {
    enable: false,
    pollingInterval: 30000
};

class $fb0395c945bfeac2$export$fd2ede79ce4f0b54 extends (0, $047ef4420d4ccb1d$export$993f0e61ab122f72) {
    constructor(configParams){
        const networks = (0, $3a7f156758201cdc$export$c2b0ef8ebe2589ea).extendCaipNetworks(configParams.networks, {
            projectId: configParams.projectId,
            customNetworkImageUrls: {},
            customRpcUrls: configParams.customRpcUrls
        });
        super();
        this.balancePromises = {};
        this.namespace = (0, $b3v9s.ConstantsUtil).CHAIN.EVM;
        this.adapterType = (0, $b3v9s.ConstantsUtil).ADAPTER_TYPES.WAGMI;
        this.projectId = configParams.projectId;
        this.pendingTransactionsFilter = {
            ...$fb0395c945bfeac2$var$DEFAULT_PENDING_TRANSACTIONS_FILTER,
            ...configParams.pendingTransactionsFilter ?? {}
        };
        this.createConfig({
            ...configParams,
            networks: networks
        });
    }
    construct(_options) {
        this.setupWatchers();
    }
    async getAccounts(params) {
        const connector = this.getWagmiConnector(params.id);
        if (!connector) return {
            accounts: []
        };
        if (connector.id === (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH) {
            const provider = await connector.getProvider();
            if (!provider?.user) return {
                accounts: []
            };
            const { address: address, accounts: accounts } = provider.user;
            return Promise.resolve({
                accounts: (accounts || [
                    {
                        address: address,
                        type: "eoa"
                    }
                ]).map((account)=>(0, $lpmCO.CoreHelperUtil).createAccount("eip155", account.address, account.type))
            });
        }
        const { addresses: addresses, address: address } = (0, $fa6344f751511ecb$export$4f9234baf34abd0)(this.wagmiConfig);
        return Promise.resolve({
            accounts: [
                ...new Set(addresses || [
                    address
                ])
            ]?.map((val)=>(0, $lpmCO.CoreHelperUtil).createAccount("eip155", val || "", "eoa"))
        });
    }
    getWagmiConnector(id) {
        return this.wagmiConfig.connectors.find((c)=>c.id === id);
    }
    createConfig(configParams) {
        this.wagmiChains = configParams.networks.filter((caipNetwork)=>caipNetwork.chainNamespace === (0, $b3v9s.ConstantsUtil).CHAIN.EVM);
        const transports = {};
        const connectors = [
            ...configParams.connectors ?? []
        ];
        this.wagmiChains.forEach((element)=>{
            const fromTransportProp = configParams.transports?.[element.id];
            const caipNetworkId = (0, $3a7f156758201cdc$export$c2b0ef8ebe2589ea).getCaipNetworkId(element);
            if (fromTransportProp) transports[element.id] = (0, $3a7f156758201cdc$export$c2b0ef8ebe2589ea).extendWagmiTransports(element, configParams.projectId, fromTransportProp);
            else transports[element.id] = (0, $3a7f156758201cdc$export$c2b0ef8ebe2589ea).getViemTransport(element, configParams.projectId, configParams.customRpcUrls?.[caipNetworkId]);
        });
        this.wagmiConfig = (0, $acea716a433e2ca3$export$45a69314cf48a3eb)({
            ...configParams,
            chains: this.wagmiChains,
            connectors: connectors,
            transports: transports
        });
    }
    setupWatchPendingTransactions() {
        if (!this.pendingTransactionsFilter.enable || this.unwatchPendingTransactions) return;
        this.unwatchPendingTransactions = (0, $d0cd3b76a9698d00$export$223080172c87e789)(this.wagmiConfig, {
            pollingInterval: this.pendingTransactionsFilter.pollingInterval,
            onError: ()=>{},
            onTransactions: ()=>{
                this.emit("pendingTransactions");
                (0, $18b6d2a3a0e46d9c$export$399d961cb92bca2e).increase("pendingTransactions");
            }
        });
        const unsubscribe = (0, $18b6d2a3a0e46d9c$export$399d961cb92bca2e).subscribeKey("pendingTransactions", (val)=>{
            if (val >= (0, $b3v9s.ConstantsUtil).LIMITS.PENDING_TRANSACTIONS) {
                this.unwatchPendingTransactions?.();
                unsubscribe();
            }
        });
    }
    setupWatchers() {
        (0, $cc1079935b5d84ff$export$30c94aeff2da2ac6)(this.wagmiConfig, {
            onChange: (accountData, prevAccountData)=>{
                if (accountData.status === "disconnected" && prevAccountData.address) this.emit("disconnect");
                if (accountData.status === "connected") {
                    if (accountData.address !== prevAccountData?.address || prevAccountData.status !== "connected") {
                        this.setupWatchPendingTransactions();
                        this.emit("accountChanged", {
                            address: accountData.address,
                            chainId: accountData.chainId
                        });
                    }
                    if (accountData.chainId !== prevAccountData?.chainId) this.emit("switchNetwork", {
                        address: accountData.address,
                        chainId: accountData.chainId
                    });
                }
            }
        });
    }
    async addThirdPartyConnectors(options) {
        const thirdPartyConnectors = [];
        if (options.enableCoinbase !== false) try {
            const { coinbaseWallet: coinbaseWallet } = await (parcelRequire("ammkE"));
            if (coinbaseWallet) thirdPartyConnectors.push(coinbaseWallet({
                version: "4",
                appName: options.metadata?.name ?? "Unknown",
                appLogoUrl: options.metadata?.icons[0] ?? "Unknown",
                preference: options.coinbasePreference ?? "all"
            }));
        } catch (error) {
            console.error("Failed to import Coinbase Wallet SDK:", error);
        }
        thirdPartyConnectors.forEach((connector)=>{
            const cnctr = this.wagmiConfig._internal.connectors.setup(connector);
            this.wagmiConfig._internal.connectors.setState((prev)=>[
                    ...prev,
                    cnctr
                ]);
        });
    }
    addWagmiConnectors(options, appKit) {
        const customConnectors = [];
        if (options.enableWalletConnect !== false) customConnectors.push((0, $0669a67b23c55dc5$export$340cc50ae9d9f255)(options, appKit));
        if (options.enableInjected !== false) customConnectors.push((0, $990abb03632f8397$export$a7a34dad4983656f)({
            shimDisconnect: true
        }));
        const isEmailEnabled = appKit?.remoteFeatures?.email ?? true;
        const socialsEnabled = Array.isArray(appKit?.remoteFeatures?.socials) && appKit?.remoteFeatures?.socials?.length > 0;
        if (isEmailEnabled || socialsEnabled) customConnectors.push((0, $c3691ab180177f18$export$f3a67f9bdc78b494)({
            chains: this.wagmiChains,
            options: {
                projectId: options.projectId,
                enableAuthLogger: options.enableAuthLogger
            }
        }));
        customConnectors.forEach((connector)=>{
            const cnctr = this.wagmiConfig._internal.connectors.setup(connector);
            this.wagmiConfig._internal.connectors.setState((prev)=>[
                    ...prev,
                    cnctr
                ]);
        });
    }
    async signMessage(params) {
        try {
            const signature = await (0, $0710ed85e3b8b4c8$export$1d9a7a8a40780de)(this.wagmiConfig, {
                message: params.message,
                account: params.address
            });
            return {
                signature: signature
            };
        } catch (error) {
            throw new Error("WagmiAdapter:signMessage - Sign message failed");
        }
    }
    async sendTransaction(params) {
        const { chainId: chainId, address: address } = (0, $fa6344f751511ecb$export$4f9234baf34abd0)(this.wagmiConfig);
        const txParams = {
            account: address,
            to: params.to,
            value: Number.isNaN(Number(params.value)) ? BigInt(0) : BigInt(params.value),
            gas: params.gas ? BigInt(params.gas) : undefined,
            gasPrice: params.gasPrice ? BigInt(params.gasPrice) : undefined,
            data: params.data,
            chainId: chainId,
            type: "legacy",
            parameters: [
                "nonce"
            ]
        };
        await (0, $4f22ff319bfbc509$export$2e8a9232fb815d77)(this.wagmiConfig, txParams);
        const tx = await (0, $6decec9706d5dc0a$export$8e0e7ffc78696d30)(this.wagmiConfig, txParams);
        await (0, $1d255c6a6527b703$export$694ec9bdf0bb55cf)(this.wagmiConfig, {
            hash: tx,
            timeout: 25000
        });
        return {
            hash: tx
        };
    }
    async writeContract(params) {
        const { caipNetwork: caipNetwork, ...data } = params;
        const chainId = Number((0, $dawjb.NetworkUtil).caipNetworkIdToNumber(caipNetwork.caipNetworkId));
        const tx = await (0, $54d056da97aba73a$export$4c0f201bc17cbf23)(this.wagmiConfig, {
            chain: this.wagmiChains?.[chainId],
            chainId: chainId,
            address: data.tokenAddress,
            account: data.fromAddress,
            abi: data.abi,
            functionName: data.method,
            args: data.args,
            __mode: "prepared"
        });
        return {
            hash: tx
        };
    }
    async estimateGas(params) {
        try {
            const result = await (0, $594e0294981efc63$export$e0580ae1f48db848)(this.wagmiConfig, {
                account: params.address,
                to: params.to,
                data: params.data,
                type: "legacy"
            });
            return {
                gas: result
            };
        } catch (error) {
            throw new Error("WagmiAdapter:estimateGas - error estimating gas");
        }
    }
    parseUnits(params) {
        return (0, $c443e793bc66489a$export$203ae30b4f6490b3)(params.value, params.decimals);
    }
    formatUnits(params) {
        return (0, $lUvCu.formatUnits)(params.value, params.decimals);
    }
    async addWagmiConnector(connector, options) {
        if (connector.id === (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH || connector.id === (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.WALLET_CONNECT) return;
        const provider = await connector.getProvider().catch(()=>undefined);
        this.addConnector({
            id: connector.id,
            explorerId: (0, $8a4fed4bf263e097$export$fd35d6514357600).ConnectorExplorerIds[connector.id],
            imageUrl: options?.connectorImages?.[connector.id] ?? connector.icon,
            name: (0, $8a4fed4bf263e097$export$fd35d6514357600).ConnectorNamesMap[connector.id] ?? connector.name,
            imageId: (0, $8a4fed4bf263e097$export$fd35d6514357600).ConnectorImageIds[connector.id],
            type: (0, $8a4fed4bf263e097$export$fd35d6514357600).ConnectorTypesMap[connector.type] ?? "EXTERNAL",
            info: connector.id === (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.INJECTED ? undefined : {
                rdns: connector.id
            },
            provider: provider,
            chain: this.namespace,
            chains: []
        });
    }
    async syncConnectors(options, appKit) {
        (0, $93ef6e240712b52a$export$9c8eec0a0da048a0)(this.wagmiConfig, {
            onChange: (connectors)=>{
                connectors.forEach((connector)=>this.addWagmiConnector(connector, options));
            }
        });
        await Promise.all(this.wagmiConfig.connectors.map((connector)=>this.addWagmiConnector(connector, options)));
        this.addWagmiConnectors(options, appKit);
        await this.addThirdPartyConnectors(options);
    }
    async syncConnection(params) {
        const { id: id } = params;
        const connections = (0, $66327d0720639dd4$export$82b9f8f75cc709b4)(this.wagmiConfig);
        const connection = connections.find((c)=>c.connector.id === id);
        const connector = this.getWagmiConnector(id);
        const provider = await connector?.getProvider();
        return {
            chainId: Number(connection?.chainId),
            address: connection?.accounts[0],
            provider: provider,
            type: connection?.connector.type?.toUpperCase(),
            id: connection?.connector.id
        };
    }
    async connectWalletConnect(chainId) {
        const walletConnectConnector = this.getWalletConnectConnector();
        await walletConnectConnector.authenticate();
        const wagmiConnector = this.getWagmiConnector("walletConnect");
        if (!wagmiConnector) throw new Error("UniversalAdapter:connectWalletConnect - connector not found");
        const res = await (0, $af0121e896d24861$export$64605811ab45167f)(this.wagmiConfig, {
            connector: wagmiConnector,
            chainId: chainId ? Number(chainId) : undefined
        });
        if (res.chainId !== Number(chainId)) await (0, $2bcb8ae7ecd06b82$export$15599da40e72d2f)(this.wagmiConfig, {
            chainId: res.chainId
        });
        return {
            clientId: await walletConnectConnector.provider.client.core.crypto.getClientId()
        };
    }
    async connect(params) {
        const { id: id, provider: provider, type: type, info: info, chainId: chainId, socialUri: socialUri } = params;
        const connector = this.getWagmiConnector(id);
        if (!connector) throw new Error("connectionControllerClient:connectExternal - connector is undefined");
        if (provider && info && connector.id === (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.EIP6963) connector.setEip6963Wallet?.({
            provider: provider,
            info: info
        });
        if (connector.uid === this.wagmiConfig?.state?.current) {
            const connection = this.wagmiConfig.state?.connections?.get(connector.uid);
            if (connection) return {
                address: connection?.accounts[0],
                chainId: connection?.chainId,
                provider: provider,
                type: type,
                id: id
            };
        }
        const res = await (0, $af0121e896d24861$export$64605811ab45167f)(this.wagmiConfig, {
            connector: connector,
            chainId: chainId ? Number(chainId) : undefined,
            socialUri: socialUri
        });
        return {
            address: res.accounts[0],
            chainId: res.chainId,
            provider: provider,
            type: type,
            id: id
        };
    }
    async reconnect(params) {
        const { id: id } = params;
        const connector = this.getWagmiConnector(id);
        if (!connector) throw new Error("connectionControllerClient:connectExternal - connector is undefined");
        await (0, $130ca6b4c79955ed$export$f0e7018a430fa792)(this.wagmiConfig, {
            connectors: [
                connector
            ]
        });
    }
    async getBalance(params) {
        const address = params.address;
        const caipNetwork = this.getCaipNetworks().find((network)=>network.id === params.chainId);
        if (!address) return Promise.resolve({
            balance: "0.00",
            symbol: "ETH"
        });
        if (caipNetwork && this.wagmiConfig) {
            const caipAddress = `${caipNetwork.caipNetworkId}:${params.address}`;
            const cachedPromise = this.balancePromises[caipAddress];
            if (cachedPromise) return cachedPromise;
            const cachedBalance = (0, $bc5dy.StorageUtil).getNativeBalanceCacheForCaipAddress(caipAddress);
            if (cachedBalance) return {
                balance: cachedBalance.balance,
                symbol: cachedBalance.symbol
            };
            this.balancePromises[caipAddress] = new Promise(async (resolve)=>{
                try {
                    const chainId = Number(params.chainId);
                    const balance = await (0, $08881dd69704a4e2$export$df96cd8d56be0ab1)(this.wagmiConfig, {
                        address: params.address,
                        chainId: chainId,
                        token: params.tokens?.[caipNetwork.caipNetworkId]?.address
                    });
                    (0, $bc5dy.StorageUtil).updateNativeBalanceCache({
                        caipAddress: caipAddress,
                        balance: balance.formatted,
                        symbol: balance.symbol,
                        timestamp: Date.now()
                    });
                    resolve({
                        balance: balance.formatted,
                        symbol: balance.symbol
                    });
                } catch (error) {
                    console.warn("Appkit:WagmiAdapter:getBalance - Error getting balance", error);
                    resolve({
                        balance: "0.00",
                        symbol: "ETH"
                    });
                }
            }).finally(()=>{
                delete this.balancePromises[caipAddress];
            });
            return this.balancePromises[caipAddress] || {
                balance: "0.00",
                symbol: "ETH"
            };
        }
        return {
            balance: "",
            symbol: ""
        };
    }
    getWalletConnectProvider() {
        return this.getWagmiConnector("walletConnect")?.["provider"];
    }
    async disconnect() {
        const connections = (0, $66327d0720639dd4$export$82b9f8f75cc709b4)(this.wagmiConfig);
        await Promise.allSettled(connections.map(async (connection)=>{
            const connector = this.getWagmiConnector(connection.connector.id);
            if (connector) await (0, $63b5610077a80b6f$export$37dfea93db2e14ed)(this.wagmiConfig, {
                connector: connector
            });
        }));
        this.wagmiConfig.state.connections.clear();
    }
    async switchNetwork(params) {
        await (0, $2bcb8ae7ecd06b82$export$15599da40e72d2f)(this.wagmiConfig, {
            chainId: params.caipNetwork.id
        });
        await super.switchNetwork(params);
    }
    async getCapabilities(params) {
        if (!this.wagmiConfig) throw new Error("connectionControllerClient:getCapabilities - wagmiConfig is undefined");
        const connections = (0, $66327d0720639dd4$export$82b9f8f75cc709b4)(this.wagmiConfig);
        const connection = connections[0];
        const connector = connection ? this.getWagmiConnector(connection.connector.id) : null;
        if (!connector) throw new Error("connectionControllerClient:getCapabilities - connector is undefined");
        const provider = await connector.getProvider();
        if (!provider) throw new Error("connectionControllerClient:getCapabilities - provider is undefined");
        const walletCapabilitiesString = provider.session?.sessionProperties?.["capabilities"];
        if (walletCapabilitiesString) {
            const walletCapabilities = (0, $260552581236db38$export$644380e4fcc9c934)(walletCapabilitiesString);
            const accountCapabilities = walletCapabilities[params];
            if (accountCapabilities) return accountCapabilities;
        }
        return await provider.request({
            method: "wallet_getCapabilities",
            params: [
                params
            ]
        });
    }
    async grantPermissions(params) {
        if (!this.wagmiConfig) throw new Error("connectionControllerClient:grantPermissions - wagmiConfig is undefined");
        const connections = (0, $66327d0720639dd4$export$82b9f8f75cc709b4)(this.wagmiConfig);
        const connection = connections[0];
        const connector = connection ? this.getWagmiConnector(connection.connector.id) : null;
        if (!connector) throw new Error("connectionControllerClient:grantPermissions - connector is undefined");
        const provider = await connector.getProvider();
        if (!provider) throw new Error("connectionControllerClient:grantPermissions - provider is undefined");
        return provider.request({
            method: "wallet_grantPermissions",
            params: params
        });
    }
    async revokePermissions(params) {
        if (!this.wagmiConfig) throw new Error("connectionControllerClient:revokePermissions - wagmiConfig is undefined");
        const connections = (0, $66327d0720639dd4$export$82b9f8f75cc709b4)(this.wagmiConfig);
        const connection = connections[0];
        const connector = connection ? this.getWagmiConnector(connection.connector.id) : null;
        if (!connector) throw new Error("connectionControllerClient:revokePermissions - connector is undefined");
        const provider = await connector.getProvider();
        if (!provider) throw new Error("connectionControllerClient:revokePermissions - provider is undefined");
        return provider.request({
            method: "wallet_revokePermissions",
            params: params
        });
    }
    async walletGetAssets(params) {
        if (!this.wagmiConfig) throw new Error("connectionControllerClient:walletGetAssets - wagmiConfig is undefined");
        const connections = (0, $66327d0720639dd4$export$82b9f8f75cc709b4)(this.wagmiConfig);
        const connection = connections[0];
        const connector = connection ? this.getWagmiConnector(connection.connector.id) : null;
        if (!connector) throw new Error("connectionControllerClient:walletGetAssets - connector is undefined");
        const provider = await connector.getProvider();
        if (!provider) throw new Error("connectionControllerClient:walletGetAssets - provider is undefined");
        return provider.request({
            method: "wallet_getAssets",
            params: [
                params
            ]
        });
    }
    setUniversalProvider(universalProvider) {
        universalProvider.on("connect", ()=>{
            const connections = (0, $66327d0720639dd4$export$82b9f8f75cc709b4)(this.wagmiConfig);
            const connector = this.getWagmiConnector("walletConnect");
            if (connector && !connections.find((c)=>c.connector.id === connector.id)) (0, $130ca6b4c79955ed$export$f0e7018a430fa792)(this.wagmiConfig, {
                connectors: [
                    connector
                ]
            });
        });
        this.addConnector(new (0, $ffb539405861dea3$export$c456b2d327ac201f)({
            provider: universalProvider,
            caipNetworks: this.getCaipNetworks(),
            namespace: "eip155"
        }));
    }
}



var $lewJ9 = parcelRequire("lewJ9");
/**
 * ed25519 Twisted Edwards curve with following addons:
 * - X25519 ECDH
 * - Ristretto cofactor elimination
 * - Elligator hash-to-group / point indistinguishability
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $2UD1v = parcelRequire("2UD1v");

var $7MXpH = parcelRequire("7MXpH");

var $3hdCU = parcelRequire("3hdCU");
/**
 * Twisted Edwards curve. The formula is: ax² + y² = 1 + dx²y².
 * For design rationale of types / exports, see weierstrass module documentation.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // prettier-ignore

var $3hdCU = parcelRequire("3hdCU");

var $eyPLr = parcelRequire("eyPLr");

var $igT8E = parcelRequire("igT8E");
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $9fee626f3c006c72$var$_0n = BigInt(0), $9fee626f3c006c72$var$_1n = BigInt(1), $9fee626f3c006c72$var$_2n = BigInt(2), $9fee626f3c006c72$var$_8n = BigInt(8);
// verification rule is either zip215 or rfc8032 / nist186-5. Consult fromHex:
const $9fee626f3c006c72$var$VERIFY_DEFAULT = {
    zip215: true
};
function $9fee626f3c006c72$var$validateOpts(curve) {
    const opts = (0, $3hdCU.validateBasic)(curve);
    (0, $igT8E.validateObject)(curve, {
        hash: "function",
        a: "bigint",
        d: "bigint",
        randomBytes: "function"
    }, {
        adjustScalarBytes: "function",
        domain: "function",
        uvRatio: "function",
        mapToCurve: "function"
    });
    // Set defaults
    return Object.freeze({
        ...opts
    });
}
function $9fee626f3c006c72$export$f0c1eee63ea541eb(curveDef) {
    const CURVE = $9fee626f3c006c72$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER, prehash: prehash, hash: cHash, randomBytes: randomBytes, nByteLength: nByteLength, h: cofactor } = CURVE;
    // Important:
    // There are some places where Fp.BYTES is used instead of nByteLength.
    // So far, everything has been tested with curves of Fp.BYTES == nByteLength.
    // TODO: test and find curves which behave otherwise.
    const MASK = $9fee626f3c006c72$var$_2n << BigInt(nByteLength * 8) - $9fee626f3c006c72$var$_1n;
    const modP = Fp.create; // Function overrides
    const Fn = (0, $eyPLr.Field)(CURVE.n, CURVE.nBitLength);
    function isEdValidXY(x, y) {
        const x2 = Fp.sqr(x);
        const y2 = Fp.sqr(y);
        const left = Fp.add(Fp.mul(CURVE.a, x2), y2);
        const right = Fp.add(Fp.ONE, Fp.mul(CURVE.d, Fp.mul(x2, y2)));
        return Fp.eql(left, right);
    }
    // Validate whether the passed curve params are valid.
    // equation ax² + y² = 1 + dx²y² should work for generator point.
    if (!isEdValidXY(CURVE.Gx, CURVE.Gy)) throw new Error("bad curve params: generator point");
    // sqrt(u/v)
    const uvRatio = CURVE.uvRatio || ((u, v)=>{
        try {
            return {
                isValid: true,
                value: Fp.sqrt(u * Fp.inv(v))
            };
        } catch (e) {
            return {
                isValid: false,
                value: $9fee626f3c006c72$var$_0n
            };
        }
    });
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes); // NOOP
    const domain = CURVE.domain || ((data, ctx, phflag)=>{
        (0, $igT8E.abool)("phflag", phflag);
        if (ctx.length || phflag) throw new Error("Contexts/pre-hash are not supported");
        return data;
    }); // NOOP
    // 0 <= n < MASK
    // Coordinates larger than Fp.ORDER are allowed for zip215
    function aCoordinate(title, n, banZero = false) {
        const min = banZero ? $9fee626f3c006c72$var$_1n : $9fee626f3c006c72$var$_0n;
        (0, $igT8E.aInRange)("coordinate " + title, n, min, MASK);
    }
    function aextpoint(other) {
        if (!(other instanceof Point)) throw new Error("ExtendedPoint expected");
    }
    // Converts Extended point to default (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    const toAffineMemo = (0, $igT8E.memoized)((p, iz)=>{
        const { ex: x, ey: y, ez: z } = p;
        const is0 = p.is0();
        if (iz == null) iz = is0 ? $9fee626f3c006c72$var$_8n : Fp.inv(z); // 8 was chosen arbitrarily
        const ax = modP(x * iz);
        const ay = modP(y * iz);
        const zz = modP(z * iz);
        if (is0) return {
            x: $9fee626f3c006c72$var$_0n,
            y: $9fee626f3c006c72$var$_1n
        };
        if (zz !== $9fee626f3c006c72$var$_1n) throw new Error("invZ was invalid");
        return {
            x: ax,
            y: ay
        };
    });
    const assertValidMemo = (0, $igT8E.memoized)((p)=>{
        const { a: a, d: d } = CURVE;
        if (p.is0()) throw new Error("bad point: ZERO"); // TODO: optimize, with vars below?
        // Equation in affine coordinates: ax² + y² = 1 + dx²y²
        // Equation in projective coordinates (X/Z, Y/Z, Z):  (aX² + Y²)Z² = Z⁴ + dX²Y²
        const { ex: X, ey: Y, ez: Z, et: T } = p;
        const X2 = modP(X * X); // X²
        const Y2 = modP(Y * Y); // Y²
        const Z2 = modP(Z * Z); // Z²
        const Z4 = modP(Z2 * Z2); // Z⁴
        const aX2 = modP(X2 * a); // aX²
        const left = modP(Z2 * modP(aX2 + Y2)); // (aX² + Y²)Z²
        const right = modP(Z4 + modP(d * modP(X2 * Y2))); // Z⁴ + dX²Y²
        if (left !== right) throw new Error("bad point: equation left != right (1)");
        // In Extended coordinates we also have T, which is x*y=T/Z: check X*Y == Z*T
        const XY = modP(X * Y);
        const ZT = modP(Z * T);
        if (XY !== ZT) throw new Error("bad point: equation left != right (2)");
        return true;
    });
    // Extended Point works in extended coordinates: (X, Y, Z, T) ∋ (x=X/Z, y=Y/Z, T=xy).
    // https://en.wikipedia.org/wiki/Twisted_Edwards_curve#Extended_coordinates
    class Point {
        constructor(ex, ey, ez, et){
            aCoordinate("x", ex);
            aCoordinate("y", ey);
            aCoordinate("z", ez, true);
            aCoordinate("t", et);
            this.ex = ex;
            this.ey = ey;
            this.ez = ez;
            this.et = et;
            Object.freeze(this);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static fromAffine(p) {
            if (p instanceof Point) throw new Error("extended point not allowed");
            const { x: x, y: y } = p || {};
            aCoordinate("x", x);
            aCoordinate("y", y);
            return new Point(x, y, $9fee626f3c006c72$var$_1n, modP(x * y));
        }
        static normalizeZ(points) {
            const toInv = (0, $eyPLr.FpInvertBatch)(Fp, points.map((p)=>p.ez));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        // Multiscalar Multiplication
        static msm(points, scalars) {
            return (0, $3hdCU.pippenger)(Point, Fn, points, scalars);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            wnaf.setWindowSize(this, windowSize);
        }
        // Not required for fromHex(), which always creates valid points.
        // Could be useful for fromAffine().
        assertValidity() {
            assertValidMemo(this);
        }
        // Compare one point to another.
        equals(other) {
            aextpoint(other);
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const { ex: X2, ey: Y2, ez: Z2 } = other;
            const X1Z2 = modP(X1 * Z2);
            const X2Z1 = modP(X2 * Z1);
            const Y1Z2 = modP(Y1 * Z2);
            const Y2Z1 = modP(Y2 * Z1);
            return X1Z2 === X2Z1 && Y1Z2 === Y2Z1;
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        negate() {
            // Flips point sign to a negative one (-x, y in affine coords)
            return new Point(modP(-this.ex), this.ey, this.ez, modP(-this.et));
        }
        // Fast algo for doubling Extended Point.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
        // Cost: 4M + 4S + 1*a + 6add + 1*2.
        double() {
            const { a: a } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const A = modP(X1 * X1); // A = X12
            const B = modP(Y1 * Y1); // B = Y12
            const C = modP($9fee626f3c006c72$var$_2n * modP(Z1 * Z1)); // C = 2*Z12
            const D = modP(a * A); // D = a*A
            const x1y1 = X1 + Y1;
            const E = modP(modP(x1y1 * x1y1) - A - B); // E = (X1+Y1)2-A-B
            const G = D + B; // G = D+B
            const F = G - C; // F = G-C
            const H = D - B; // H = D-B
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        // Fast algo for adding 2 Extended Points.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
        // Cost: 9M + 1*a + 1*d + 7add.
        add(other) {
            aextpoint(other);
            const { a: a, d: d } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1, et: T1 } = this;
            const { ex: X2, ey: Y2, ez: Z2, et: T2 } = other;
            const A = modP(X1 * X2); // A = X1*X2
            const B = modP(Y1 * Y2); // B = Y1*Y2
            const C = modP(T1 * d * T2); // C = T1*d*T2
            const D = modP(Z1 * Z2); // D = Z1*Z2
            const E = modP((X1 + Y1) * (X2 + Y2) - A - B); // E = (X1+Y1)*(X2+Y2)-A-B
            const F = D - C; // F = D-C
            const G = D + C; // G = D+C
            const H = modP(B - a * A); // H = B-a*A
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, n, Point.normalizeZ);
        }
        // Constant-time multiplication.
        multiply(scalar) {
            const n = scalar;
            (0, $igT8E.aInRange)("scalar", n, $9fee626f3c006c72$var$_1n, CURVE_ORDER); // 1 <= scalar < L
            const { p: p, f: f } = this.wNAF(n);
            return Point.normalizeZ([
                p,
                f
            ])[0];
        }
        // Non-constant-time multiplication. Uses double-and-add algorithm.
        // It's faster, but should only be used when you don't care about
        // an exposed private key e.g. sig verification.
        // Does NOT allow scalars higher than CURVE.n.
        // Accepts optional accumulator to merge with multiply (important for sparse scalars)
        multiplyUnsafe(scalar, acc = Point.ZERO) {
            const n = scalar;
            (0, $igT8E.aInRange)("scalar", n, $9fee626f3c006c72$var$_0n, CURVE_ORDER); // 0 <= scalar < L
            if (n === $9fee626f3c006c72$var$_0n) return I;
            if (this.is0() || n === $9fee626f3c006c72$var$_1n) return this;
            return wnaf.wNAFCachedUnsafe(this, n, Point.normalizeZ, acc);
        }
        // Checks if point is of small order.
        // If you add something to small order point, you will have "dirty"
        // point with torsion component.
        // Multiplies point by cofactor and checks if the result is 0.
        isSmallOrder() {
            return this.multiplyUnsafe(cofactor).is0();
        }
        // Multiplies point by curve order and checks if the result is 0.
        // Returns `false` is the point is dirty.
        isTorsionFree() {
            return wnaf.unsafeLadder(this, CURVE_ORDER).is0();
        }
        // Converts Extended point to default (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        toAffine(iz) {
            return toAffineMemo(this, iz);
        }
        clearCofactor() {
            const { h: cofactor } = CURVE;
            if (cofactor === $9fee626f3c006c72$var$_1n) return this;
            return this.multiplyUnsafe(cofactor);
        }
        // Converts hash string or Uint8Array to Point.
        // Uses algo from RFC8032 5.1.3.
        static fromHex(hex, zip215 = false) {
            const { d: d, a: a } = CURVE;
            const len = Fp.BYTES;
            hex = (0, $igT8E.ensureBytes)("pointHex", hex, len); // copy hex to a new array
            (0, $igT8E.abool)("zip215", zip215);
            const normed = hex.slice(); // copy again, we'll manipulate it
            const lastByte = hex[len - 1]; // select last byte
            normed[len - 1] = lastByte & -129; // clear last bit
            const y = (0, $igT8E.bytesToNumberLE)(normed);
            // zip215=true is good for consensus-critical apps. =false follows RFC8032 / NIST186-5.
            // RFC8032 prohibits >= p, but ZIP215 doesn't
            // zip215=true:  0 <= y < MASK (2^256 for ed25519)
            // zip215=false: 0 <= y < P (2^255-19 for ed25519)
            const max = zip215 ? MASK : Fp.ORDER;
            (0, $igT8E.aInRange)("pointHex.y", y, $9fee626f3c006c72$var$_0n, max);
            // Ed25519: x² = (y²-1)/(dy²+1) mod p. Ed448: x² = (y²-1)/(dy²-1) mod p. Generic case:
            // ax²+y²=1+dx²y² => y²-1=dx²y²-ax² => y²-1=x²(dy²-a) => x²=(y²-1)/(dy²-a)
            const y2 = modP(y * y); // denominator is always non-0 mod p.
            const u = modP(y2 - $9fee626f3c006c72$var$_1n); // u = y² - 1
            const v = modP(d * y2 - a); // v = d y² + 1.
            let { isValid: isValid, value: x } = uvRatio(u, v); // √(u/v)
            if (!isValid) throw new Error("Point.fromHex: invalid y coordinate");
            const isXOdd = (x & $9fee626f3c006c72$var$_1n) === $9fee626f3c006c72$var$_1n; // There are 2 square roots. Use x_0 bit to select proper
            const isLastByteOdd = (lastByte & 0x80) !== 0; // x_0, last bit
            if (!zip215 && x === $9fee626f3c006c72$var$_0n && isLastByteOdd) // if x=0 and x_0 = 1, fail
            throw new Error("Point.fromHex: x=0 and x_0=1");
            if (isLastByteOdd !== isXOdd) x = modP(-x); // if x_0 != x mod 2, set x = p-x
            return Point.fromAffine({
                x: x,
                y: y
            });
        }
        static fromPrivateKey(privKey) {
            const { scalar: scalar } = getPrivateScalar(privKey);
            return G.multiply(scalar); // reduced one call of `toRawBytes`
        }
        toRawBytes() {
            const { x: x, y: y } = this.toAffine();
            const bytes = (0, $igT8E.numberToBytesLE)(y, Fp.BYTES); // each y has 2 x values (x, -y)
            bytes[bytes.length - 1] |= x & $9fee626f3c006c72$var$_1n ? 0x80 : 0; // when compressing, it's enough to store y
            return bytes; // and use the last byte to encode sign of x
        }
        toHex() {
            return (0, $igT8E.bytesToHex)(this.toRawBytes()); // Same as toRawBytes, but returns string.
        }
    }
    // base / generator point
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, $9fee626f3c006c72$var$_1n, modP(CURVE.Gx * CURVE.Gy));
    // zero / infinity / identity point
    Point.ZERO = new Point($9fee626f3c006c72$var$_0n, $9fee626f3c006c72$var$_1n, $9fee626f3c006c72$var$_1n, $9fee626f3c006c72$var$_0n); // 0, 1, 1, 0
    const { BASE: G, ZERO: I } = Point;
    const wnaf = (0, $3hdCU.wNAF)(Point, nByteLength * 8);
    function modN(a) {
        return (0, $eyPLr.mod)(a, CURVE_ORDER);
    }
    // Little-endian SHA512 with modulo n
    function modN_LE(hash) {
        return modN((0, $igT8E.bytesToNumberLE)(hash));
    }
    // Get the hashed private scalar per RFC8032 5.1.5
    function getPrivateScalar(key) {
        const len = Fp.BYTES;
        key = (0, $igT8E.ensureBytes)("private key", key, len);
        // Hash private key with curve's hash function to produce uniformingly random input
        // Check byte lengths: ensure(64, h(ensure(32, key)))
        const hashed = (0, $igT8E.ensureBytes)("hashed private key", cHash(key), 2 * len);
        const head = adjustScalarBytes(hashed.slice(0, len)); // clear first half bits, produce FE
        const prefix = hashed.slice(len, 2 * len); // second half is called key prefix (5.1.6)
        const scalar = modN_LE(head); // The actual private scalar
        return {
            head: head,
            prefix: prefix,
            scalar: scalar
        };
    }
    // Convenience method that creates public key from scalar. RFC8032 5.1.5
    function getExtendedPublicKey(key) {
        const { head: head, prefix: prefix, scalar: scalar } = getPrivateScalar(key);
        const point = G.multiply(scalar); // Point on Edwards curve aka public key
        const pointBytes = point.toRawBytes(); // Uint8Array representation
        return {
            head: head,
            prefix: prefix,
            scalar: scalar,
            point: point,
            pointBytes: pointBytes
        };
    }
    // Calculates EdDSA pub key. RFC8032 5.1.5. Privkey is hashed. Use first half with 3 bits cleared
    function getPublicKey(privKey) {
        return getExtendedPublicKey(privKey).pointBytes;
    }
    // int('LE', SHA512(dom2(F, C) || msgs)) mod N
    function hashDomainToScalar(context = Uint8Array.of(), ...msgs) {
        const msg = (0, $igT8E.concatBytes)(...msgs);
        return modN_LE(cHash(domain(msg, (0, $igT8E.ensureBytes)("context", context), !!prehash)));
    }
    /** Signs message with privateKey. RFC8032 5.1.6 */ function sign(msg, privKey, options = {}) {
        msg = (0, $igT8E.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph etc.
        const { prefix: prefix, scalar: scalar, pointBytes: pointBytes } = getExtendedPublicKey(privKey);
        const r = hashDomainToScalar(options.context, prefix, msg); // r = dom2(F, C) || prefix || PH(M)
        const R = G.multiply(r).toRawBytes(); // R = rG
        const k = hashDomainToScalar(options.context, R, pointBytes, msg); // R || A || PH(M)
        const s = modN(r + k * scalar); // S = (r + k * s) mod L
        (0, $igT8E.aInRange)("signature.s", s, $9fee626f3c006c72$var$_0n, CURVE_ORDER); // 0 <= s < l
        const res = (0, $igT8E.concatBytes)(R, (0, $igT8E.numberToBytesLE)(s, Fp.BYTES));
        return (0, $igT8E.ensureBytes)("result", res, Fp.BYTES * 2); // 64-byte signature
    }
    const verifyOpts = $9fee626f3c006c72$var$VERIFY_DEFAULT;
    /**
     * Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
     * An extended group equation is checked.
     */ function verify(sig, msg, publicKey, options = verifyOpts) {
        const { context: context, zip215: zip215 } = options;
        const len = Fp.BYTES; // Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
        sig = (0, $igT8E.ensureBytes)("signature", sig, 2 * len); // An extended group equation is checked.
        msg = (0, $igT8E.ensureBytes)("message", msg);
        publicKey = (0, $igT8E.ensureBytes)("publicKey", publicKey, len);
        if (zip215 !== undefined) (0, $igT8E.abool)("zip215", zip215);
        if (prehash) msg = prehash(msg); // for ed25519ph, etc
        const s = (0, $igT8E.bytesToNumberLE)(sig.slice(len, 2 * len));
        let A, R, SB;
        try {
            // zip215=true is good for consensus-critical apps. =false follows RFC8032 / NIST186-5.
            // zip215=true:  0 <= y < MASK (2^256 for ed25519)
            // zip215=false: 0 <= y < P (2^255-19 for ed25519)
            A = Point.fromHex(publicKey, zip215);
            R = Point.fromHex(sig.slice(0, len), zip215);
            SB = G.multiplyUnsafe(s); // 0 <= s < l is done inside
        } catch (error) {
            return false;
        }
        if (!zip215 && A.isSmallOrder()) return false;
        const k = hashDomainToScalar(context, R.toRawBytes(), A.toRawBytes(), msg);
        const RkA = R.add(A.multiplyUnsafe(k));
        // Extended group equation
        // [8][S]B = [8]R + [8][k]A'
        return RkA.subtract(SB).clearCofactor().equals(Point.ZERO);
    }
    G._setWindowSize(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    const utils = {
        getExtendedPublicKey: getExtendedPublicKey,
        /** ed25519 priv keys are uniform 32b. No need to check for modulo bias, like in secp256k1. */ randomPrivateKey: ()=>randomBytes(Fp.BYTES),
        /**
         * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
         * values. This slows down first getPublicKey() by milliseconds (see Speed section),
         * but allows to speed-up subsequent getPublicKey() calls up to 20x.
         * @param windowSize 2, 4, 8, 16
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3));
            return point;
        }
    };
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        sign: sign,
        verify: verify,
        ExtendedPoint: Point,
        utils: utils
    };
}



var $fNnAT = parcelRequire("fNnAT");

var $eyPLr = parcelRequire("eyPLr");
/**
 * Montgomery curve methods. It's not really whole montgomery curve,
 * just bunch of very specific methods for X25519 / X448 from
 * [RFC 7748](https://www.rfc-editor.org/rfc/rfc7748)
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $eyPLr = parcelRequire("eyPLr");

var $igT8E = parcelRequire("igT8E");
const $67944bbaaa265f1d$var$_0n = BigInt(0);
const $67944bbaaa265f1d$var$_1n = BigInt(1);
const $67944bbaaa265f1d$var$_2n = BigInt(2);
function $67944bbaaa265f1d$var$validateOpts(curve) {
    (0, $igT8E.validateObject)(curve, {
        adjustScalarBytes: "function",
        powPminus2: "function"
    });
    return Object.freeze({
        ...curve
    });
}
function $67944bbaaa265f1d$export$bdbee0d01bf914a7(curveDef) {
    const CURVE = $67944bbaaa265f1d$var$validateOpts(curveDef);
    const { P: P, type: type, adjustScalarBytes: adjustScalarBytes, powPminus2: powPminus2 } = CURVE;
    const is25519 = type === "x25519";
    if (!is25519 && type !== "x448") throw new Error("invalid type");
    const montgomeryBits = is25519 ? 255 : 448;
    const fieldLen = is25519 ? 32 : 56;
    const Gu = is25519 ? BigInt(9) : BigInt(5);
    // RFC 7748 #5:
    // The constant a24 is (486662 - 2) / 4 = 121665 for curve25519/X25519 and
    // (156326 - 2) / 4 = 39081 for curve448/X448
    // const a = is25519 ? 156326n : 486662n;
    const a24 = is25519 ? BigInt(121665) : BigInt(39081);
    // RFC: x25519 "the resulting integer is of the form 2^254 plus
    // eight times a value between 0 and 2^251 - 1 (inclusive)"
    // x448: "2^447 plus four times a value between 0 and 2^445 - 1 (inclusive)"
    const minScalar = is25519 ? $67944bbaaa265f1d$var$_2n ** BigInt(254) : $67944bbaaa265f1d$var$_2n ** BigInt(447);
    const maxAdded = is25519 ? BigInt(8) * $67944bbaaa265f1d$var$_2n ** BigInt(251) - $67944bbaaa265f1d$var$_1n : BigInt(4) * $67944bbaaa265f1d$var$_2n ** BigInt(445) - $67944bbaaa265f1d$var$_1n;
    const maxScalar = minScalar + maxAdded + $67944bbaaa265f1d$var$_1n; // (inclusive)
    const modP = (n)=>(0, $eyPLr.mod)(n, P);
    const GuBytes = encodeU(Gu);
    function encodeU(u) {
        return (0, $igT8E.numberToBytesLE)(modP(u), fieldLen);
    }
    function decodeU(u) {
        const _u = (0, $igT8E.ensureBytes)("u coordinate", u, fieldLen);
        // RFC: When receiving such an array, implementations of X25519
        // (but not X448) MUST mask the most significant bit in the final byte.
        if (is25519) _u[31] &= 127; // 0b0111_1111
        // RFC: Implementations MUST accept non-canonical values and process them as
        // if they had been reduced modulo the field prime.  The non-canonical
        // values are 2^255 - 19 through 2^255 - 1 for X25519 and 2^448 - 2^224
        // - 1 through 2^448 - 1 for X448.
        return modP((0, $igT8E.bytesToNumberLE)(_u));
    }
    function decodeScalar(scalar) {
        return (0, $igT8E.bytesToNumberLE)(adjustScalarBytes((0, $igT8E.ensureBytes)("scalar", scalar, fieldLen)));
    }
    function scalarMult(scalar, u) {
        const pu = montgomeryLadder(decodeU(u), decodeScalar(scalar));
        // Some public keys are useless, of low-order. Curve author doesn't think
        // it needs to be validated, but we do it nonetheless.
        // https://cr.yp.to/ecdh.html#validate
        if (pu === $67944bbaaa265f1d$var$_0n) throw new Error("invalid private or public key received");
        return encodeU(pu);
    }
    // Computes public key from private. By doing scalar multiplication of base point.
    function scalarMultBase(scalar) {
        return scalarMult(scalar, GuBytes);
    }
    // cswap from RFC7748 "example code"
    function cswap(swap, x_2, x_3) {
        // dummy = mask(swap) AND (x_2 XOR x_3)
        // Where mask(swap) is the all-1 or all-0 word of the same length as x_2
        // and x_3, computed, e.g., as mask(swap) = 0 - swap.
        const dummy = modP(swap * (x_2 - x_3));
        x_2 = modP(x_2 - dummy); // x_2 = x_2 XOR dummy
        x_3 = modP(x_3 + dummy); // x_3 = x_3 XOR dummy
        return {
            x_2: x_2,
            x_3: x_3
        };
    }
    /**
     * Montgomery x-only multiplication ladder.
     * @param pointU u coordinate (x) on Montgomery Curve 25519
     * @param scalar by which the point would be multiplied
     * @returns new Point on Montgomery curve
     */ function montgomeryLadder(u, scalar) {
        (0, $igT8E.aInRange)("u", u, $67944bbaaa265f1d$var$_0n, P);
        (0, $igT8E.aInRange)("scalar", scalar, minScalar, maxScalar);
        const k = scalar;
        const x_1 = u;
        let x_2 = $67944bbaaa265f1d$var$_1n;
        let z_2 = $67944bbaaa265f1d$var$_0n;
        let x_3 = u;
        let z_3 = $67944bbaaa265f1d$var$_1n;
        let swap = $67944bbaaa265f1d$var$_0n;
        for(let t = BigInt(montgomeryBits - 1); t >= $67944bbaaa265f1d$var$_0n; t--){
            const k_t = k >> t & $67944bbaaa265f1d$var$_1n;
            swap ^= k_t;
            ({ x_2: x_2, x_3: x_3 } = cswap(swap, x_2, x_3));
            ({ x_2: z_2, x_3: z_3 } = cswap(swap, z_2, z_3));
            swap = k_t;
            const A = x_2 + z_2;
            const AA = modP(A * A);
            const B = x_2 - z_2;
            const BB = modP(B * B);
            const E = AA - BB;
            const C = x_3 + z_3;
            const D = x_3 - z_3;
            const DA = modP(D * A);
            const CB = modP(C * B);
            const dacb = DA + CB;
            const da_cb = DA - CB;
            x_3 = modP(dacb * dacb);
            z_3 = modP(x_1 * modP(da_cb * da_cb));
            x_2 = modP(AA * BB);
            z_2 = modP(E * (AA + modP(a24 * E)));
        }
        ({ x_2: x_2, x_3: x_3 } = cswap(swap, x_2, x_3));
        ({ x_2: z_2, x_3: z_3 } = cswap(swap, z_2, z_3));
        const z2 = powPminus2(z_2); // `Fp.pow(x, P - _2n)` is much slower equivalent
        return modP(x_2 * z2); // Return x_2 * (z_2^(p - 2))
    }
    return {
        scalarMult: scalarMult,
        scalarMultBase: scalarMultBase,
        getSharedSecret: (privateKey, publicKey)=>scalarMult(privateKey, publicKey),
        getPublicKey: (privateKey)=>scalarMultBase(privateKey),
        utils: {
            randomPrivateKey: ()=>CURVE.randomBytes(fieldLen)
        },
        GuBytes: GuBytes.slice()
    };
}



var $igT8E = parcelRequire("igT8E");
// 2n**255n - 19n
const $2866510f4dc204d4$var$ED25519_P = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949");
// √(-1) aka √(a) aka 2^((p-1)/4)
// Fp.sqrt(Fp.neg(1))
const $2866510f4dc204d4$var$ED25519_SQRT_M1 = /* @__PURE__ */ BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
// prettier-ignore
const $2866510f4dc204d4$var$_0n = BigInt(0), $2866510f4dc204d4$var$_1n = BigInt(1), $2866510f4dc204d4$var$_2n = BigInt(2), $2866510f4dc204d4$var$_3n = BigInt(3);
// prettier-ignore
const $2866510f4dc204d4$var$_5n = BigInt(5), $2866510f4dc204d4$var$_8n = BigInt(8);
function $2866510f4dc204d4$var$ed25519_pow_2_252_3(x) {
    // prettier-ignore
    const _10n = BigInt(10), _20n = BigInt(20), _40n = BigInt(40), _80n = BigInt(80);
    const P = $2866510f4dc204d4$var$ED25519_P;
    const x2 = x * x % P;
    const b2 = x2 * x % P; // x^3, 11
    const b4 = (0, $eyPLr.pow2)(b2, $2866510f4dc204d4$var$_2n, P) * b2 % P; // x^15, 1111
    const b5 = (0, $eyPLr.pow2)(b4, $2866510f4dc204d4$var$_1n, P) * x % P; // x^31
    const b10 = (0, $eyPLr.pow2)(b5, $2866510f4dc204d4$var$_5n, P) * b5 % P;
    const b20 = (0, $eyPLr.pow2)(b10, _10n, P) * b10 % P;
    const b40 = (0, $eyPLr.pow2)(b20, _20n, P) * b20 % P;
    const b80 = (0, $eyPLr.pow2)(b40, _40n, P) * b40 % P;
    const b160 = (0, $eyPLr.pow2)(b80, _80n, P) * b80 % P;
    const b240 = (0, $eyPLr.pow2)(b160, _80n, P) * b80 % P;
    const b250 = (0, $eyPLr.pow2)(b240, _10n, P) * b10 % P;
    const pow_p_5_8 = (0, $eyPLr.pow2)(b250, $2866510f4dc204d4$var$_2n, P) * x % P;
    // ^ To pow to (p+3)/8, multiply it by x.
    return {
        pow_p_5_8: pow_p_5_8,
        b2: b2
    };
}
function $2866510f4dc204d4$var$adjustScalarBytes(bytes) {
    // Section 5: For X25519, in order to decode 32 random bytes as an integer scalar,
    // set the three least significant bits of the first byte
    bytes[0] &= 248; // 0b1111_1000
    // and the most significant bit of the last to zero,
    bytes[31] &= 127; // 0b0111_1111
    // set the second most significant bit of the last byte to 1
    bytes[31] |= 64; // 0b0100_0000
    return bytes;
}
// sqrt(u/v)
function $2866510f4dc204d4$var$uvRatio(u, v) {
    const P = $2866510f4dc204d4$var$ED25519_P;
    const v3 = (0, $eyPLr.mod)(v * v * v, P); // v³
    const v7 = (0, $eyPLr.mod)(v3 * v3 * v, P); // v⁷
    // (p+3)/8 and (p-5)/8
    const pow = $2866510f4dc204d4$var$ed25519_pow_2_252_3(u * v7).pow_p_5_8;
    let x = (0, $eyPLr.mod)(u * v3 * pow, P); // (uv³)(uv⁷)^(p-5)/8
    const vx2 = (0, $eyPLr.mod)(v * x * x, P); // vx²
    const root1 = x; // First root candidate
    const root2 = (0, $eyPLr.mod)(x * $2866510f4dc204d4$var$ED25519_SQRT_M1, P); // Second root candidate
    const useRoot1 = vx2 === u; // If vx² = u (mod p), x is a square root
    const useRoot2 = vx2 === (0, $eyPLr.mod)(-u, P); // If vx² = -u, set x <-- x * 2^((p-1)/4)
    const noRoot = vx2 === (0, $eyPLr.mod)(-u * $2866510f4dc204d4$var$ED25519_SQRT_M1, P); // There is no valid root, vx² = -u√(-1)
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2; // We return root2 anyway, for const-time
    if ((0, $eyPLr.isNegativeLE)(x, P)) x = (0, $eyPLr.mod)(-x, P);
    return {
        isValid: useRoot1 || useRoot2,
        value: x
    };
}
const $2866510f4dc204d4$export$5ce3305f0d0b8e6f = [
    "0100000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a",
    "0000000000000000000000000000000000000000000000000000000000000080",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05",
    "ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85",
    "0000000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa"
];
const $2866510f4dc204d4$var$Fp = /* @__PURE__ */ (()=>(0, $eyPLr.Field)($2866510f4dc204d4$var$ED25519_P, undefined, true))();
const $2866510f4dc204d4$var$ed25519Defaults = /* @__PURE__ */ (()=>({
        // Removing Fp.create() will still work, and is 10% faster on sign
        a: $2866510f4dc204d4$var$Fp.create(BigInt(-1)),
        // d is -121665/121666 a.k.a. Fp.neg(121665 * Fp.inv(121666))
        d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
        Fp: // Finite field 2n**255n - 19n
        $2866510f4dc204d4$var$Fp,
        // Subgroup order 2n**252n + 27742317777372353535851937790883648493n;
        n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
        h: $2866510f4dc204d4$var$_8n,
        Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
        Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
        hash: (0, $2UD1v.sha512),
        randomBytes: $7MXpH.randomBytes,
        adjustScalarBytes: $2866510f4dc204d4$var$adjustScalarBytes,
        uvRatio: // dom2
        // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
        // Constant-time, u/√v
        $2866510f4dc204d4$var$uvRatio
    }))();
const $2866510f4dc204d4$export$f63794f4a09a19c1 = /* @__PURE__ */ (()=>(0, $9fee626f3c006c72$export$f0c1eee63ea541eb)($2866510f4dc204d4$var$ed25519Defaults))();
function $2866510f4dc204d4$var$ed25519_domain(data, ctx, phflag) {
    if (ctx.length > 255) throw new Error("Context is too big");
    return (0, $7MXpH.concatBytes)((0, $7MXpH.utf8ToBytes)("SigEd25519 no Ed25519 collisions"), new Uint8Array([
        phflag ? 1 : 0,
        ctx.length
    ]), ctx, data);
}
const $2866510f4dc204d4$export$1bc11da7986b0196 = /* @__PURE__ */ (()=>(0, $9fee626f3c006c72$export$f0c1eee63ea541eb)({
        ...$2866510f4dc204d4$var$ed25519Defaults,
        domain: $2866510f4dc204d4$var$ed25519_domain
    }))();
const $2866510f4dc204d4$export$473acbb6f701cbb6 = /* @__PURE__ */ (()=>(0, $9fee626f3c006c72$export$f0c1eee63ea541eb)(Object.assign({}, $2866510f4dc204d4$var$ed25519Defaults, {
        domain: $2866510f4dc204d4$var$ed25519_domain,
        prehash: (0, $2UD1v.sha512)
    })))();
const $2866510f4dc204d4$export$dab9625394da700 = /* @__PURE__ */ (()=>(0, $67944bbaaa265f1d$export$bdbee0d01bf914a7)({
        P: $2866510f4dc204d4$var$ED25519_P,
        type: "x25519",
        powPminus2: (x)=>{
            const P = $2866510f4dc204d4$var$ED25519_P;
            // x^(p-2) aka x^(2^255-21)
            const { pow_p_5_8: pow_p_5_8, b2: b2 } = $2866510f4dc204d4$var$ed25519_pow_2_252_3(x);
            return (0, $eyPLr.mod)((0, $eyPLr.pow2)(pow_p_5_8, $2866510f4dc204d4$var$_3n, P) * b2, P);
        },
        adjustScalarBytes: $2866510f4dc204d4$var$adjustScalarBytes,
        randomBytes: $7MXpH.randomBytes
    }))();
function $2866510f4dc204d4$export$78609ae56f1edf04(edwardsPub) {
    const { y: y } = $2866510f4dc204d4$export$f63794f4a09a19c1.ExtendedPoint.fromHex(edwardsPub);
    const _1n = BigInt(1);
    return $2866510f4dc204d4$var$Fp.toBytes($2866510f4dc204d4$var$Fp.create((_1n + y) * $2866510f4dc204d4$var$Fp.inv(_1n - y)));
}
const $2866510f4dc204d4$export$84bc39a6e4664b07 = $2866510f4dc204d4$export$78609ae56f1edf04; // deprecated
function $2866510f4dc204d4$export$c32b0f86cebbdf19(edwardsPriv) {
    const hashed = $2866510f4dc204d4$var$ed25519Defaults.hash(edwardsPriv.subarray(0, 32));
    return $2866510f4dc204d4$var$ed25519Defaults.adjustScalarBytes(hashed).subarray(0, 32);
}
// Hash To Curve Elligator2 Map (NOTE: different from ristretto255 elligator)
// NOTE: very important part is usage of FpSqrtEven for ELL2_C1_EDWARDS, since
// SageMath returns different root first and everything falls apart
const $2866510f4dc204d4$var$ELL2_C1 = /* @__PURE__ */ (()=>($2866510f4dc204d4$var$Fp.ORDER + $2866510f4dc204d4$var$_3n) / $2866510f4dc204d4$var$_8n)(); // 1. c1 = (q + 3) / 8       # Integer arithmetic
const $2866510f4dc204d4$var$ELL2_C2 = /* @__PURE__ */ (()=>$2866510f4dc204d4$var$Fp.pow($2866510f4dc204d4$var$_2n, $2866510f4dc204d4$var$ELL2_C1))(); // 2. c2 = 2^c1
const $2866510f4dc204d4$var$ELL2_C3 = /* @__PURE__ */ (()=>$2866510f4dc204d4$var$Fp.sqrt($2866510f4dc204d4$var$Fp.neg($2866510f4dc204d4$var$Fp.ONE)))(); // 3. c3 = sqrt(-1)
// prettier-ignore
function $2866510f4dc204d4$var$map_to_curve_elligator2_curve25519(u) {
    const ELL2_C4 = ($2866510f4dc204d4$var$Fp.ORDER - $2866510f4dc204d4$var$_5n) / $2866510f4dc204d4$var$_8n; // 4. c4 = (q - 5) / 8       # Integer arithmetic
    const ELL2_J = BigInt(486662);
    let tv1 = $2866510f4dc204d4$var$Fp.sqr(u); //  1.  tv1 = u^2
    tv1 = $2866510f4dc204d4$var$Fp.mul(tv1, $2866510f4dc204d4$var$_2n); //  2.  tv1 = 2 * tv1
    let xd = $2866510f4dc204d4$var$Fp.add(tv1, $2866510f4dc204d4$var$Fp.ONE); //  3.   xd = tv1 + 1         # Nonzero: -1 is square (mod p), tv1 is not
    let x1n = $2866510f4dc204d4$var$Fp.neg(ELL2_J); //  4.  x1n = -J              # x1 = x1n / xd = -J / (1 + 2 * u^2)
    let tv2 = $2866510f4dc204d4$var$Fp.sqr(xd); //  5.  tv2 = xd^2
    let gxd = $2866510f4dc204d4$var$Fp.mul(tv2, xd); //  6.  gxd = tv2 * xd        # gxd = xd^3
    let gx1 = $2866510f4dc204d4$var$Fp.mul(tv1, ELL2_J); //  7.  gx1 = J * tv1         # x1n + J * xd
    gx1 = $2866510f4dc204d4$var$Fp.mul(gx1, x1n); //  8.  gx1 = gx1 * x1n       # x1n^2 + J * x1n * xd
    gx1 = $2866510f4dc204d4$var$Fp.add(gx1, tv2); //  9.  gx1 = gx1 + tv2       # x1n^2 + J * x1n * xd + xd^2
    gx1 = $2866510f4dc204d4$var$Fp.mul(gx1, x1n); //  10. gx1 = gx1 * x1n       # x1n^3 + J * x1n^2 * xd + x1n * xd^2
    let tv3 = $2866510f4dc204d4$var$Fp.sqr(gxd); //  11. tv3 = gxd^2
    tv2 = $2866510f4dc204d4$var$Fp.sqr(tv3); //  12. tv2 = tv3^2           # gxd^4
    tv3 = $2866510f4dc204d4$var$Fp.mul(tv3, gxd); //  13. tv3 = tv3 * gxd       # gxd^3
    tv3 = $2866510f4dc204d4$var$Fp.mul(tv3, gx1); //  14. tv3 = tv3 * gx1       # gx1 * gxd^3
    tv2 = $2866510f4dc204d4$var$Fp.mul(tv2, tv3); //  15. tv2 = tv2 * tv3       # gx1 * gxd^7
    let y11 = $2866510f4dc204d4$var$Fp.pow(tv2, ELL2_C4); //  16. y11 = tv2^c4        # (gx1 * gxd^7)^((p - 5) / 8)
    y11 = $2866510f4dc204d4$var$Fp.mul(y11, tv3); //  17. y11 = y11 * tv3       # gx1*gxd^3*(gx1*gxd^7)^((p-5)/8)
    let y12 = $2866510f4dc204d4$var$Fp.mul(y11, $2866510f4dc204d4$var$ELL2_C3); //  18. y12 = y11 * c3
    tv2 = $2866510f4dc204d4$var$Fp.sqr(y11); //  19. tv2 = y11^2
    tv2 = $2866510f4dc204d4$var$Fp.mul(tv2, gxd); //  20. tv2 = tv2 * gxd
    let e1 = $2866510f4dc204d4$var$Fp.eql(tv2, gx1); //  21.  e1 = tv2 == gx1
    let y1 = $2866510f4dc204d4$var$Fp.cmov(y12, y11, e1); //  22.  y1 = CMOV(y12, y11, e1)  # If g(x1) is square, this is its sqrt
    let x2n = $2866510f4dc204d4$var$Fp.mul(x1n, tv1); //  23. x2n = x1n * tv1       # x2 = x2n / xd = 2 * u^2 * x1n / xd
    let y21 = $2866510f4dc204d4$var$Fp.mul(y11, u); //  24. y21 = y11 * u
    y21 = $2866510f4dc204d4$var$Fp.mul(y21, $2866510f4dc204d4$var$ELL2_C2); //  25. y21 = y21 * c2
    let y22 = $2866510f4dc204d4$var$Fp.mul(y21, $2866510f4dc204d4$var$ELL2_C3); //  26. y22 = y21 * c3
    let gx2 = $2866510f4dc204d4$var$Fp.mul(gx1, tv1); //  27. gx2 = gx1 * tv1       # g(x2) = gx2 / gxd = 2 * u^2 * g(x1)
    tv2 = $2866510f4dc204d4$var$Fp.sqr(y21); //  28. tv2 = y21^2
    tv2 = $2866510f4dc204d4$var$Fp.mul(tv2, gxd); //  29. tv2 = tv2 * gxd
    let e2 = $2866510f4dc204d4$var$Fp.eql(tv2, gx2); //  30.  e2 = tv2 == gx2
    let y2 = $2866510f4dc204d4$var$Fp.cmov(y22, y21, e2); //  31.  y2 = CMOV(y22, y21, e2)  # If g(x2) is square, this is its sqrt
    tv2 = $2866510f4dc204d4$var$Fp.sqr(y1); //  32. tv2 = y1^2
    tv2 = $2866510f4dc204d4$var$Fp.mul(tv2, gxd); //  33. tv2 = tv2 * gxd
    let e3 = $2866510f4dc204d4$var$Fp.eql(tv2, gx1); //  34.  e3 = tv2 == gx1
    let xn = $2866510f4dc204d4$var$Fp.cmov(x2n, x1n, e3); //  35.  xn = CMOV(x2n, x1n, e3)  # If e3, x = x1, else x = x2
    let y = $2866510f4dc204d4$var$Fp.cmov(y2, y1, e3); //  36.   y = CMOV(y2, y1, e3)    # If e3, y = y1, else y = y2
    let e4 = $2866510f4dc204d4$var$Fp.isOdd(y); //  37.  e4 = sgn0(y) == 1        # Fix sign of y
    y = $2866510f4dc204d4$var$Fp.cmov(y, $2866510f4dc204d4$var$Fp.neg(y), e3 !== e4); //  38.   y = CMOV(y, -y, e3 XOR e4)
    return {
        xMn: xn,
        xMd: xd,
        yMn: y,
        yMd: $2866510f4dc204d4$var$_1n
    }; //  39. return (xn, xd, y, 1)
}
const $2866510f4dc204d4$var$ELL2_C1_EDWARDS = /* @__PURE__ */ (()=>(0, $eyPLr.FpSqrtEven)($2866510f4dc204d4$var$Fp, $2866510f4dc204d4$var$Fp.neg(BigInt(486664))))(); // sgn0(c1) MUST equal 0
function $2866510f4dc204d4$var$map_to_curve_elligator2_edwards25519(u) {
    const { xMn: xMn, xMd: xMd, yMn: yMn, yMd: yMd } = $2866510f4dc204d4$var$map_to_curve_elligator2_curve25519(u); //  1.  (xMn, xMd, yMn, yMd) =
    // map_to_curve_elligator2_curve25519(u)
    let xn = $2866510f4dc204d4$var$Fp.mul(xMn, yMd); //  2.  xn = xMn * yMd
    xn = $2866510f4dc204d4$var$Fp.mul(xn, $2866510f4dc204d4$var$ELL2_C1_EDWARDS); //  3.  xn = xn * c1
    let xd = $2866510f4dc204d4$var$Fp.mul(xMd, yMn); //  4.  xd = xMd * yMn    # xn / xd = c1 * xM / yM
    let yn = $2866510f4dc204d4$var$Fp.sub(xMn, xMd); //  5.  yn = xMn - xMd
    let yd = $2866510f4dc204d4$var$Fp.add(xMn, xMd); //  6.  yd = xMn + xMd    # (n / d - 1) / (n / d + 1) = (n - d) / (n + d)
    let tv1 = $2866510f4dc204d4$var$Fp.mul(xd, yd); //  7. tv1 = xd * yd
    let e = $2866510f4dc204d4$var$Fp.eql(tv1, $2866510f4dc204d4$var$Fp.ZERO); //  8.   e = tv1 == 0
    xn = $2866510f4dc204d4$var$Fp.cmov(xn, $2866510f4dc204d4$var$Fp.ZERO, e); //  9.  xn = CMOV(xn, 0, e)
    xd = $2866510f4dc204d4$var$Fp.cmov(xd, $2866510f4dc204d4$var$Fp.ONE, e); //  10. xd = CMOV(xd, 1, e)
    yn = $2866510f4dc204d4$var$Fp.cmov(yn, $2866510f4dc204d4$var$Fp.ONE, e); //  11. yn = CMOV(yn, 1, e)
    yd = $2866510f4dc204d4$var$Fp.cmov(yd, $2866510f4dc204d4$var$Fp.ONE, e); //  12. yd = CMOV(yd, 1, e)
    const [xd_inv, yd_inv] = (0, $eyPLr.FpInvertBatch)($2866510f4dc204d4$var$Fp, [
        xd,
        yd
    ], true); // batch division
    return {
        x: $2866510f4dc204d4$var$Fp.mul(xn, xd_inv),
        y: $2866510f4dc204d4$var$Fp.mul(yn, yd_inv)
    }; //  13. return (xn, xd, yn, yd)
}
const $2866510f4dc204d4$export$bd158472185fbd42 = /* @__PURE__ */ (()=>(0, $fNnAT.createHasher)($2866510f4dc204d4$export$f63794f4a09a19c1.ExtendedPoint, (scalars)=>$2866510f4dc204d4$var$map_to_curve_elligator2_edwards25519(scalars[0]), {
        DST: "edwards25519_XMD:SHA-512_ELL2_RO_",
        encodeDST: "edwards25519_XMD:SHA-512_ELL2_NU_",
        p: $2866510f4dc204d4$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $2UD1v.sha512)
    }))();
const $2866510f4dc204d4$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$2866510f4dc204d4$export$bd158472185fbd42.hashToCurve)();
const $2866510f4dc204d4$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$2866510f4dc204d4$export$bd158472185fbd42.encodeToCurve)();
function $2866510f4dc204d4$var$aristp(other) {
    if (!(other instanceof $2866510f4dc204d4$var$RistPoint)) throw new Error("RistrettoPoint expected");
}
// √(-1) aka √(a) aka 2^((p-1)/4)
const $2866510f4dc204d4$var$SQRT_M1 = $2866510f4dc204d4$var$ED25519_SQRT_M1;
// √(ad - 1)
const $2866510f4dc204d4$var$SQRT_AD_MINUS_ONE = /* @__PURE__ */ BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235");
// 1 / √(a-d)
const $2866510f4dc204d4$var$INVSQRT_A_MINUS_D = /* @__PURE__ */ BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578");
// 1-d²
const $2866510f4dc204d4$var$ONE_MINUS_D_SQ = /* @__PURE__ */ BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838");
// (d-1)²
const $2866510f4dc204d4$var$D_MINUS_ONE_SQ = /* @__PURE__ */ BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
// Calculates 1/√(number)
const $2866510f4dc204d4$var$invertSqrt = (number)=>$2866510f4dc204d4$var$uvRatio($2866510f4dc204d4$var$_1n, number);
const $2866510f4dc204d4$var$MAX_255B = /* @__PURE__ */ BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $2866510f4dc204d4$var$bytes255ToNumberLE = (bytes)=>$2866510f4dc204d4$export$f63794f4a09a19c1.CURVE.Fp.create((0, $igT8E.bytesToNumberLE)(bytes) & $2866510f4dc204d4$var$MAX_255B);
/**
 * Computes Elligator map for Ristretto255.
 * Described in [RFC9380](https://www.rfc-editor.org/rfc/rfc9380#appendix-B) and on
 * the [website](https://ristretto.group/formulas/elligator.html).
 */ function $2866510f4dc204d4$var$calcElligatorRistrettoMap(r0) {
    const { d: d } = $2866510f4dc204d4$export$f63794f4a09a19c1.CURVE;
    const P = $2866510f4dc204d4$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
    const mod = $2866510f4dc204d4$export$f63794f4a09a19c1.CURVE.Fp.create;
    const r = mod($2866510f4dc204d4$var$SQRT_M1 * r0 * r0); // 1
    const Ns = mod((r + $2866510f4dc204d4$var$_1n) * $2866510f4dc204d4$var$ONE_MINUS_D_SQ); // 2
    let c = BigInt(-1); // 3
    const D = mod((c - d * r) * mod(r + d)); // 4
    let { isValid: Ns_D_is_sq, value: s } = $2866510f4dc204d4$var$uvRatio(Ns, D); // 5
    let s_ = mod(s * r0); // 6
    if (!(0, $eyPLr.isNegativeLE)(s_, P)) s_ = mod(-s_);
    if (!Ns_D_is_sq) s = s_; // 7
    if (!Ns_D_is_sq) c = r; // 8
    const Nt = mod(c * (r - $2866510f4dc204d4$var$_1n) * $2866510f4dc204d4$var$D_MINUS_ONE_SQ - D); // 9
    const s2 = s * s;
    const W0 = mod((s + s) * D); // 10
    const W1 = mod(Nt * $2866510f4dc204d4$var$SQRT_AD_MINUS_ONE); // 11
    const W2 = mod($2866510f4dc204d4$var$_1n - s2); // 12
    const W3 = mod($2866510f4dc204d4$var$_1n + s2); // 13
    return new $2866510f4dc204d4$export$f63794f4a09a19c1.ExtendedPoint(mod(W0 * W3), mod(W2 * W1), mod(W1 * W3), mod(W0 * W2));
}
/**
 * Each ed25519/ExtendedPoint has 8 different equivalent points. This can be
 * a source of bugs for protocols like ring signatures. Ristretto was created to solve this.
 * Ristretto point operates in X:Y:Z:T extended coordinates like ExtendedPoint,
 * but it should work in its own namespace: do not combine those two.
 * See [RFC9496](https://www.rfc-editor.org/rfc/rfc9496).
 */ class $2866510f4dc204d4$var$RistPoint {
    // Private property to discourage combining ExtendedPoint + RistrettoPoint
    // Always use Ristretto encoding/decoding instead.
    constructor(ep){
        this.ep = ep;
    }
    static fromAffine(ap) {
        return new $2866510f4dc204d4$var$RistPoint($2866510f4dc204d4$export$f63794f4a09a19c1.ExtendedPoint.fromAffine(ap));
    }
    /**
     * Takes uniform output of 64-byte hash function like sha512 and converts it to `RistrettoPoint`.
     * The hash-to-group operation applies Elligator twice and adds the results.
     * **Note:** this is one-way map, there is no conversion from point to hash.
     * Described in [RFC9380](https://www.rfc-editor.org/rfc/rfc9380#appendix-B) and on
     * the [website](https://ristretto.group/formulas/elligator.html).
     * @param hex 64-byte output of a hash function
     */ static hashToCurve(hex) {
        hex = (0, $igT8E.ensureBytes)("ristrettoHash", hex, 64);
        const r1 = $2866510f4dc204d4$var$bytes255ToNumberLE(hex.slice(0, 32));
        const R1 = $2866510f4dc204d4$var$calcElligatorRistrettoMap(r1);
        const r2 = $2866510f4dc204d4$var$bytes255ToNumberLE(hex.slice(32, 64));
        const R2 = $2866510f4dc204d4$var$calcElligatorRistrettoMap(r2);
        return new $2866510f4dc204d4$var$RistPoint(R1.add(R2));
    }
    /**
     * Converts ristretto-encoded string to ristretto point.
     * Described in [RFC9496](https://www.rfc-editor.org/rfc/rfc9496#name-decode).
     * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
     */ static fromHex(hex) {
        hex = (0, $igT8E.ensureBytes)("ristrettoHex", hex, 32);
        const { a: a, d: d } = $2866510f4dc204d4$export$f63794f4a09a19c1.CURVE;
        const P = $2866510f4dc204d4$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
        const mod = $2866510f4dc204d4$export$f63794f4a09a19c1.CURVE.Fp.create;
        const emsg = "RistrettoPoint.fromHex: the hex is not valid encoding of RistrettoPoint";
        const s = $2866510f4dc204d4$var$bytes255ToNumberLE(hex);
        // 1. Check that s_bytes is the canonical encoding of a field element, or else abort.
        // 3. Check that s is non-negative, or else abort
        if (!(0, $igT8E.equalBytes)((0, $igT8E.numberToBytesLE)(s, 32), hex) || (0, $eyPLr.isNegativeLE)(s, P)) throw new Error(emsg);
        const s2 = mod(s * s);
        const u1 = mod($2866510f4dc204d4$var$_1n + a * s2); // 4 (a is -1)
        const u2 = mod($2866510f4dc204d4$var$_1n - a * s2); // 5
        const u1_2 = mod(u1 * u1);
        const u2_2 = mod(u2 * u2);
        const v = mod(a * d * u1_2 - u2_2); // 6
        const { isValid: isValid, value: I } = $2866510f4dc204d4$var$invertSqrt(mod(v * u2_2)); // 7
        const Dx = mod(I * u2); // 8
        const Dy = mod(I * Dx * v); // 9
        let x = mod((s + s) * Dx); // 10
        if ((0, $eyPLr.isNegativeLE)(x, P)) x = mod(-x); // 10
        const y = mod(u1 * Dy); // 11
        const t = mod(x * y); // 12
        if (!isValid || (0, $eyPLr.isNegativeLE)(t, P) || y === $2866510f4dc204d4$var$_0n) throw new Error(emsg);
        return new $2866510f4dc204d4$var$RistPoint(new $2866510f4dc204d4$export$f63794f4a09a19c1.ExtendedPoint(x, y, $2866510f4dc204d4$var$_1n, t));
    }
    static msm(points, scalars) {
        const Fn = (0, $eyPLr.Field)($2866510f4dc204d4$export$f63794f4a09a19c1.CURVE.n, $2866510f4dc204d4$export$f63794f4a09a19c1.CURVE.nBitLength);
        return (0, $3hdCU.pippenger)($2866510f4dc204d4$var$RistPoint, Fn, points, scalars);
    }
    /**
     * Encodes ristretto point to Uint8Array.
     * Described in [RFC9496](https://www.rfc-editor.org/rfc/rfc9496#name-encode).
     */ toRawBytes() {
        let { ex: x, ey: y, ez: z, et: t } = this.ep;
        const P = $2866510f4dc204d4$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
        const mod = $2866510f4dc204d4$export$f63794f4a09a19c1.CURVE.Fp.create;
        const u1 = mod(mod(z + y) * mod(z - y)); // 1
        const u2 = mod(x * y); // 2
        // Square root always exists
        const u2sq = mod(u2 * u2);
        const { value: invsqrt } = $2866510f4dc204d4$var$invertSqrt(mod(u1 * u2sq)); // 3
        const D1 = mod(invsqrt * u1); // 4
        const D2 = mod(invsqrt * u2); // 5
        const zInv = mod(D1 * D2 * t); // 6
        let D; // 7
        if ((0, $eyPLr.isNegativeLE)(t * zInv, P)) {
            let _x = mod(y * $2866510f4dc204d4$var$SQRT_M1);
            let _y = mod(x * $2866510f4dc204d4$var$SQRT_M1);
            x = _x;
            y = _y;
            D = mod(D1 * $2866510f4dc204d4$var$INVSQRT_A_MINUS_D);
        } else D = D2; // 8
        if ((0, $eyPLr.isNegativeLE)(x * zInv, P)) y = mod(-y); // 9
        let s = mod((z - y) * D); // 10 (check footer's note, no sqrt(-a))
        if ((0, $eyPLr.isNegativeLE)(s, P)) s = mod(-s);
        return (0, $igT8E.numberToBytesLE)(s, 32); // 11
    }
    toHex() {
        return (0, $igT8E.bytesToHex)(this.toRawBytes());
    }
    toString() {
        return this.toHex();
    }
    /**
     * Compares two Ristretto points.
     * Described in [RFC9496](https://www.rfc-editor.org/rfc/rfc9496#name-equals).
     */ equals(other) {
        $2866510f4dc204d4$var$aristp(other);
        const { ex: X1, ey: Y1 } = this.ep;
        const { ex: X2, ey: Y2 } = other.ep;
        const mod = $2866510f4dc204d4$export$f63794f4a09a19c1.CURVE.Fp.create;
        // (x1 * y2 == y1 * x2) | (y1 * y2 == x1 * x2)
        const one = mod(X1 * Y2) === mod(Y1 * X2);
        const two = mod(Y1 * Y2) === mod(X1 * X2);
        return one || two;
    }
    add(other) {
        $2866510f4dc204d4$var$aristp(other);
        return new $2866510f4dc204d4$var$RistPoint(this.ep.add(other.ep));
    }
    subtract(other) {
        $2866510f4dc204d4$var$aristp(other);
        return new $2866510f4dc204d4$var$RistPoint(this.ep.subtract(other.ep));
    }
    multiply(scalar) {
        return new $2866510f4dc204d4$var$RistPoint(this.ep.multiply(scalar));
    }
    multiplyUnsafe(scalar) {
        return new $2866510f4dc204d4$var$RistPoint(this.ep.multiplyUnsafe(scalar));
    }
    double() {
        return new $2866510f4dc204d4$var$RistPoint(this.ep.double());
    }
    negate() {
        return new $2866510f4dc204d4$var$RistPoint(this.ep.negate());
    }
}
const $2866510f4dc204d4$export$5e87c4f36f27816d = /* @__PURE__ */ (()=>{
    if (!$2866510f4dc204d4$var$RistPoint.BASE) $2866510f4dc204d4$var$RistPoint.BASE = new $2866510f4dc204d4$var$RistPoint($2866510f4dc204d4$export$f63794f4a09a19c1.ExtendedPoint.BASE);
    if (!$2866510f4dc204d4$var$RistPoint.ZERO) $2866510f4dc204d4$var$RistPoint.ZERO = new $2866510f4dc204d4$var$RistPoint($2866510f4dc204d4$export$f63794f4a09a19c1.ExtendedPoint.ZERO);
    return $2866510f4dc204d4$var$RistPoint;
})();
const $2866510f4dc204d4$export$c9ad4c0d917ad3 = (msg, options)=>{
    const d = options.DST;
    const DST = typeof d === "string" ? (0, $7MXpH.utf8ToBytes)(d) : d;
    const uniform_bytes = (0, $fNnAT.expand_message_xmd)(msg, DST, 64, (0, $2UD1v.sha512));
    const P = $2866510f4dc204d4$var$RistPoint.hashToCurve(uniform_bytes);
    return P;
};
const $2866510f4dc204d4$export$667ef88de7a83a7f = $2866510f4dc204d4$export$c9ad4c0d917ad3; // legacy



var $lCikh = parcelRequire("lCikh");
var $4fa1ea39de93f4d6$exports = {};
var $a735f9efa8b391da$exports = {};
"use strict";

var $dqH3B = parcelRequire("dqH3B");
var $a735f9efa8b391da$require$_Buffer = $dqH3B.Buffer;
function $a735f9efa8b391da$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $a735f9efa8b391da$require$_Buffer.from(source);
        if (!$a735f9efa8b391da$require$_Buffer.isBuffer(source)) throw new TypeError("Expected Buffer");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return $a735f9efa8b391da$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(psz < source.length){
            // Find code of next character
            var charCode = source.charCodeAt(psz);
            // Base map can not be indexed using char code
            if (charCode > 255) return;
            // Decode character
            var carry = BASE_MAP[charCode];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $a735f9efa8b391da$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
$a735f9efa8b391da$exports = $a735f9efa8b391da$var$base;


var $4fa1ea39de93f4d6$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
$4fa1ea39de93f4d6$exports = $a735f9efa8b391da$exports($4fa1ea39de93f4d6$var$ALPHABET);



var $6kbuD = parcelRequire("6kbuD");
var $14466b1998da68ad$exports = {};

var $lewJ9 = parcelRequire("lewJ9");
var $14466b1998da68ad$require$Buffer = $lewJ9.Buffer;
"use strict";
var $14466b1998da68ad$var$__createBinding = $14466b1998da68ad$exports && $14466b1998da68ad$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $14466b1998da68ad$var$__setModuleDefault = $14466b1998da68ad$exports && $14466b1998da68ad$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $14466b1998da68ad$var$__decorate = $14466b1998da68ad$exports && $14466b1998da68ad$exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $14466b1998da68ad$var$__importStar = $14466b1998da68ad$exports && $14466b1998da68ad$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $14466b1998da68ad$var$__createBinding(result, mod, k);
    }
    $14466b1998da68ad$var$__setModuleDefault(result, mod);
    return result;
};
var $14466b1998da68ad$var$__importDefault = $14466b1998da68ad$exports && $14466b1998da68ad$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($14466b1998da68ad$exports, "__esModule", {
    value: true
});
$14466b1998da68ad$exports.deserializeUnchecked = $14466b1998da68ad$exports.deserialize = $14466b1998da68ad$exports.serialize = $14466b1998da68ad$exports.BinaryReader = $14466b1998da68ad$exports.BinaryWriter = $14466b1998da68ad$exports.BorshError = $14466b1998da68ad$exports.baseDecode = $14466b1998da68ad$exports.baseEncode = void 0;

const $14466b1998da68ad$var$bn_js_1 = $14466b1998da68ad$var$__importDefault((parcelRequire("lCikh")));

const $14466b1998da68ad$var$bs58_1 = $14466b1998da68ad$var$__importDefault((parcelRequire("lQSzJ")));

// TODO: Make sure this polyfill not included when not required
const $14466b1998da68ad$var$encoding = $14466b1998da68ad$var$__importStar((parcelRequire("1ukto")));
const $14466b1998da68ad$var$ResolvedTextDecoder = typeof TextDecoder !== "function" ? $14466b1998da68ad$var$encoding.TextDecoder : TextDecoder;
const $14466b1998da68ad$var$textDecoder = new $14466b1998da68ad$var$ResolvedTextDecoder("utf-8", {
    fatal: true
});
function $14466b1998da68ad$var$baseEncode(value) {
    if (typeof value === "string") value = $14466b1998da68ad$require$Buffer.from(value, "utf8");
    return $14466b1998da68ad$var$bs58_1.default.encode($14466b1998da68ad$require$Buffer.from(value));
}
$14466b1998da68ad$exports.baseEncode = $14466b1998da68ad$var$baseEncode;
function $14466b1998da68ad$var$baseDecode(value) {
    return $14466b1998da68ad$require$Buffer.from($14466b1998da68ad$var$bs58_1.default.decode(value));
}
$14466b1998da68ad$exports.baseDecode = $14466b1998da68ad$var$baseDecode;
const $14466b1998da68ad$var$INITIAL_LENGTH = 1024;
class $14466b1998da68ad$var$BorshError extends Error {
    constructor(message){
        super(message);
        this.fieldPath = [];
        this.originalMessage = message;
    }
    addToFieldPath(fieldName) {
        this.fieldPath.splice(0, 0, fieldName);
        // NOTE: Modifying message directly as jest doesn't use .toString()
        this.message = this.originalMessage + ": " + this.fieldPath.join(".");
    }
}
$14466b1998da68ad$exports.BorshError = $14466b1998da68ad$var$BorshError;
/// Binary encoder.
class $14466b1998da68ad$var$BinaryWriter {
    constructor(){
        this.buf = $14466b1998da68ad$require$Buffer.alloc($14466b1998da68ad$var$INITIAL_LENGTH);
        this.length = 0;
    }
    maybeResize() {
        if (this.buf.length < 16 + this.length) this.buf = $14466b1998da68ad$require$Buffer.concat([
            this.buf,
            $14466b1998da68ad$require$Buffer.alloc($14466b1998da68ad$var$INITIAL_LENGTH)
        ]);
    }
    writeU8(value) {
        this.maybeResize();
        this.buf.writeUInt8(value, this.length);
        this.length += 1;
    }
    writeU16(value) {
        this.maybeResize();
        this.buf.writeUInt16LE(value, this.length);
        this.length += 2;
    }
    writeU32(value) {
        this.maybeResize();
        this.buf.writeUInt32LE(value, this.length);
        this.length += 4;
    }
    writeU64(value) {
        this.maybeResize();
        this.writeBuffer($14466b1998da68ad$require$Buffer.from(new $14466b1998da68ad$var$bn_js_1.default(value).toArray("le", 8)));
    }
    writeU128(value) {
        this.maybeResize();
        this.writeBuffer($14466b1998da68ad$require$Buffer.from(new $14466b1998da68ad$var$bn_js_1.default(value).toArray("le", 16)));
    }
    writeU256(value) {
        this.maybeResize();
        this.writeBuffer($14466b1998da68ad$require$Buffer.from(new $14466b1998da68ad$var$bn_js_1.default(value).toArray("le", 32)));
    }
    writeU512(value) {
        this.maybeResize();
        this.writeBuffer($14466b1998da68ad$require$Buffer.from(new $14466b1998da68ad$var$bn_js_1.default(value).toArray("le", 64)));
    }
    writeBuffer(buffer) {
        // Buffer.from is needed as this.buf.subarray can return plain Uint8Array in browser
        this.buf = $14466b1998da68ad$require$Buffer.concat([
            $14466b1998da68ad$require$Buffer.from(this.buf.subarray(0, this.length)),
            buffer,
            $14466b1998da68ad$require$Buffer.alloc($14466b1998da68ad$var$INITIAL_LENGTH)
        ]);
        this.length += buffer.length;
    }
    writeString(str) {
        this.maybeResize();
        const b = $14466b1998da68ad$require$Buffer.from(str, "utf8");
        this.writeU32(b.length);
        this.writeBuffer(b);
    }
    writeFixedArray(array) {
        this.writeBuffer($14466b1998da68ad$require$Buffer.from(array));
    }
    writeArray(array, fn) {
        this.maybeResize();
        this.writeU32(array.length);
        for (const elem of array){
            this.maybeResize();
            fn(elem);
        }
    }
    toArray() {
        return this.buf.subarray(0, this.length);
    }
}
$14466b1998da68ad$exports.BinaryWriter = $14466b1998da68ad$var$BinaryWriter;
function $14466b1998da68ad$var$handlingRangeError(target, propertyKey, propertyDescriptor) {
    const originalMethod = propertyDescriptor.value;
    propertyDescriptor.value = function(...args) {
        try {
            return originalMethod.apply(this, args);
        } catch (e) {
            if (e instanceof RangeError) {
                const code = e.code;
                if ([
                    "ERR_BUFFER_OUT_OF_BOUNDS",
                    "ERR_OUT_OF_RANGE"
                ].indexOf(code) >= 0) throw new $14466b1998da68ad$var$BorshError("Reached the end of buffer when deserializing");
            }
            throw e;
        }
    };
}
class $14466b1998da68ad$var$BinaryReader {
    constructor(buf){
        this.buf = buf;
        this.offset = 0;
    }
    readU8() {
        const value = this.buf.readUInt8(this.offset);
        this.offset += 1;
        return value;
    }
    readU16() {
        const value = this.buf.readUInt16LE(this.offset);
        this.offset += 2;
        return value;
    }
    readU32() {
        const value = this.buf.readUInt32LE(this.offset);
        this.offset += 4;
        return value;
    }
    readU64() {
        const buf = this.readBuffer(8);
        return new $14466b1998da68ad$var$bn_js_1.default(buf, "le");
    }
    readU128() {
        const buf = this.readBuffer(16);
        return new $14466b1998da68ad$var$bn_js_1.default(buf, "le");
    }
    readU256() {
        const buf = this.readBuffer(32);
        return new $14466b1998da68ad$var$bn_js_1.default(buf, "le");
    }
    readU512() {
        const buf = this.readBuffer(64);
        return new $14466b1998da68ad$var$bn_js_1.default(buf, "le");
    }
    readBuffer(len) {
        if (this.offset + len > this.buf.length) throw new $14466b1998da68ad$var$BorshError(`Expected buffer length ${len} isn't within bounds`);
        const result = this.buf.slice(this.offset, this.offset + len);
        this.offset += len;
        return result;
    }
    readString() {
        const len = this.readU32();
        const buf = this.readBuffer(len);
        try {
            // NOTE: Using TextDecoder to fail on invalid UTF-8
            return $14466b1998da68ad$var$textDecoder.decode(buf);
        } catch (e) {
            throw new $14466b1998da68ad$var$BorshError(`Error decoding UTF-8 string: ${e}`);
        }
    }
    readFixedArray(len) {
        return new Uint8Array(this.readBuffer(len));
    }
    readArray(fn) {
        const len = this.readU32();
        const result = Array();
        for(let i = 0; i < len; ++i)result.push(fn());
        return result;
    }
}
$14466b1998da68ad$var$__decorate([
    $14466b1998da68ad$var$handlingRangeError
], $14466b1998da68ad$var$BinaryReader.prototype, "readU8", null);
$14466b1998da68ad$var$__decorate([
    $14466b1998da68ad$var$handlingRangeError
], $14466b1998da68ad$var$BinaryReader.prototype, "readU16", null);
$14466b1998da68ad$var$__decorate([
    $14466b1998da68ad$var$handlingRangeError
], $14466b1998da68ad$var$BinaryReader.prototype, "readU32", null);
$14466b1998da68ad$var$__decorate([
    $14466b1998da68ad$var$handlingRangeError
], $14466b1998da68ad$var$BinaryReader.prototype, "readU64", null);
$14466b1998da68ad$var$__decorate([
    $14466b1998da68ad$var$handlingRangeError
], $14466b1998da68ad$var$BinaryReader.prototype, "readU128", null);
$14466b1998da68ad$var$__decorate([
    $14466b1998da68ad$var$handlingRangeError
], $14466b1998da68ad$var$BinaryReader.prototype, "readU256", null);
$14466b1998da68ad$var$__decorate([
    $14466b1998da68ad$var$handlingRangeError
], $14466b1998da68ad$var$BinaryReader.prototype, "readU512", null);
$14466b1998da68ad$var$__decorate([
    $14466b1998da68ad$var$handlingRangeError
], $14466b1998da68ad$var$BinaryReader.prototype, "readString", null);
$14466b1998da68ad$var$__decorate([
    $14466b1998da68ad$var$handlingRangeError
], $14466b1998da68ad$var$BinaryReader.prototype, "readFixedArray", null);
$14466b1998da68ad$var$__decorate([
    $14466b1998da68ad$var$handlingRangeError
], $14466b1998da68ad$var$BinaryReader.prototype, "readArray", null);
$14466b1998da68ad$exports.BinaryReader = $14466b1998da68ad$var$BinaryReader;
function $14466b1998da68ad$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $14466b1998da68ad$var$serializeField(schema, fieldName, value, fieldType, writer) {
    try {
        // TODO: Handle missing values properly (make sure they never result in just skipped write)
        if (typeof fieldType === "string") writer[`write${$14466b1998da68ad$var$capitalizeFirstLetter(fieldType)}`](value);
        else if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") {
                if (value.length !== fieldType[0]) throw new $14466b1998da68ad$var$BorshError(`Expecting byte array of length ${fieldType[0]}, but got ${value.length} bytes`);
                writer.writeFixedArray(value);
            } else if (fieldType.length === 2 && typeof fieldType[1] === "number") {
                if (value.length !== fieldType[1]) throw new $14466b1998da68ad$var$BorshError(`Expecting byte array of length ${fieldType[1]}, but got ${value.length} bytes`);
                for(let i = 0; i < fieldType[1]; i++)$14466b1998da68ad$var$serializeField(schema, null, value[i], fieldType[0], writer);
            } else writer.writeArray(value, (item)=>{
                $14466b1998da68ad$var$serializeField(schema, fieldName, item, fieldType[0], writer);
            });
        } else if (fieldType.kind !== undefined) switch(fieldType.kind){
            case "option":
                if (value === null || value === undefined) writer.writeU8(0);
                else {
                    writer.writeU8(1);
                    $14466b1998da68ad$var$serializeField(schema, fieldName, value, fieldType.type, writer);
                }
                break;
            case "map":
                writer.writeU32(value.size);
                value.forEach((val, key)=>{
                    $14466b1998da68ad$var$serializeField(schema, fieldName, key, fieldType.key, writer);
                    $14466b1998da68ad$var$serializeField(schema, fieldName, val, fieldType.value, writer);
                });
                break;
            default:
                throw new $14466b1998da68ad$var$BorshError(`FieldType ${fieldType} unrecognized`);
        }
        else $14466b1998da68ad$var$serializeStruct(schema, value, writer);
    } catch (error) {
        if (error instanceof $14466b1998da68ad$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $14466b1998da68ad$var$serializeStruct(schema, obj, writer) {
    if (typeof obj.borshSerialize === "function") {
        obj.borshSerialize(writer);
        return;
    }
    const structSchema = schema.get(obj.constructor);
    if (!structSchema) throw new $14466b1998da68ad$var$BorshError(`Class ${obj.constructor.name} is missing in schema`);
    if (structSchema.kind === "struct") structSchema.fields.map(([fieldName, fieldType])=>{
        $14466b1998da68ad$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
    });
    else if (structSchema.kind === "enum") {
        const name = obj[structSchema.field];
        for(let idx = 0; idx < structSchema.values.length; ++idx){
            const [fieldName, fieldType] = structSchema.values[idx];
            if (fieldName === name) {
                writer.writeU8(idx);
                $14466b1998da68ad$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
                break;
            }
        }
    } else throw new $14466b1998da68ad$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${obj.constructor.name}`);
}
/// Serialize given object using schema of the form:
/// { class_name -> [ [field_name, field_type], .. ], .. }
function $14466b1998da68ad$var$serialize(schema, obj, Writer = $14466b1998da68ad$var$BinaryWriter) {
    const writer = new Writer();
    $14466b1998da68ad$var$serializeStruct(schema, obj, writer);
    return writer.toArray();
}
$14466b1998da68ad$exports.serialize = $14466b1998da68ad$var$serialize;
function $14466b1998da68ad$var$deserializeField(schema, fieldName, fieldType, reader) {
    try {
        if (typeof fieldType === "string") return reader[`read${$14466b1998da68ad$var$capitalizeFirstLetter(fieldType)}`]();
        if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") return reader.readFixedArray(fieldType[0]);
            else if (typeof fieldType[1] === "number") {
                const arr = [];
                for(let i = 0; i < fieldType[1]; i++)arr.push($14466b1998da68ad$var$deserializeField(schema, null, fieldType[0], reader));
                return arr;
            } else return reader.readArray(()=>$14466b1998da68ad$var$deserializeField(schema, fieldName, fieldType[0], reader));
        }
        if (fieldType.kind === "option") {
            const option = reader.readU8();
            if (option) return $14466b1998da68ad$var$deserializeField(schema, fieldName, fieldType.type, reader);
            return undefined;
        }
        if (fieldType.kind === "map") {
            let map = new Map();
            const length = reader.readU32();
            for(let i = 0; i < length; i++){
                const key = $14466b1998da68ad$var$deserializeField(schema, fieldName, fieldType.key, reader);
                const val = $14466b1998da68ad$var$deserializeField(schema, fieldName, fieldType.value, reader);
                map.set(key, val);
            }
            return map;
        }
        return $14466b1998da68ad$var$deserializeStruct(schema, fieldType, reader);
    } catch (error) {
        if (error instanceof $14466b1998da68ad$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $14466b1998da68ad$var$deserializeStruct(schema, classType, reader) {
    if (typeof classType.borshDeserialize === "function") return classType.borshDeserialize(reader);
    const structSchema = schema.get(classType);
    if (!structSchema) throw new $14466b1998da68ad$var$BorshError(`Class ${classType.name} is missing in schema`);
    if (structSchema.kind === "struct") {
        const result = {};
        for (const [fieldName, fieldType] of schema.get(classType).fields)result[fieldName] = $14466b1998da68ad$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType(result);
    }
    if (structSchema.kind === "enum") {
        const idx = reader.readU8();
        if (idx >= structSchema.values.length) throw new $14466b1998da68ad$var$BorshError(`Enum index: ${idx} is out of range`);
        const [fieldName, fieldType] = structSchema.values[idx];
        const fieldValue = $14466b1998da68ad$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType({
            [fieldName]: fieldValue
        });
    }
    throw new $14466b1998da68ad$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${classType.constructor.name}`);
}
/// Deserializes object from bytes using schema.
function $14466b1998da68ad$var$deserialize(schema, classType, buffer, Reader = $14466b1998da68ad$var$BinaryReader) {
    const reader = new Reader(buffer);
    const result = $14466b1998da68ad$var$deserializeStruct(schema, classType, reader);
    if (reader.offset < buffer.length) throw new $14466b1998da68ad$var$BorshError(`Unexpected ${buffer.length - reader.offset} bytes after deserialized data`);
    return result;
}
$14466b1998da68ad$exports.deserialize = $14466b1998da68ad$var$deserialize;
/// Deserializes object from bytes using schema, without checking the length read
function $14466b1998da68ad$var$deserializeUnchecked(schema, classType, buffer, Reader = $14466b1998da68ad$var$BinaryReader) {
    const reader = new Reader(buffer);
    return $14466b1998da68ad$var$deserializeStruct(schema, classType, reader);
}
$14466b1998da68ad$exports.deserializeUnchecked = $14466b1998da68ad$var$deserializeUnchecked;


var $10b678223f208f49$exports = {};
/* The MIT License (MIT)
 *
 * Copyright 2015-2018 Peter A. Bigot
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Support for translating between Uint8Array instances and JavaScript
 * native types.
 *
 * {@link module:Layout~Layout|Layout} is the basis of a class
 * hierarchy that associates property names with sequences of encoded
 * bytes.
 *
 * Layouts are supported for these scalar (numeric) types:
 * * {@link module:Layout~UInt|Unsigned integers in little-endian
 *   format} with {@link module:Layout.u8|8-bit}, {@link
 *   module:Layout.u16|16-bit}, {@link module:Layout.u24|24-bit},
 *   {@link module:Layout.u32|32-bit}, {@link
 *   module:Layout.u40|40-bit}, and {@link module:Layout.u48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~UIntBE|Unsigned integers in big-endian
 *   format} with {@link module:Layout.u16be|16-bit}, {@link
 *   module:Layout.u24be|24-bit}, {@link module:Layout.u32be|32-bit},
 *   {@link module:Layout.u40be|40-bit}, and {@link
 *   module:Layout.u48be|48-bit} representation ranges;
 * * {@link module:Layout~Int|Signed integers in little-endian
 *   format} with {@link module:Layout.s8|8-bit}, {@link
 *   module:Layout.s16|16-bit}, {@link module:Layout.s24|24-bit},
 *   {@link module:Layout.s32|32-bit}, {@link
 *   module:Layout.s40|40-bit}, and {@link module:Layout.s48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~IntBE|Signed integers in big-endian format}
 *   with {@link module:Layout.s16be|16-bit}, {@link
 *   module:Layout.s24be|24-bit}, {@link module:Layout.s32be|32-bit},
 *   {@link module:Layout.s40be|40-bit}, and {@link
 *   module:Layout.s48be|48-bit} representation ranges;
 * * 64-bit integral values that decode to an exact (if magnitude is
 *   less than 2^53) or nearby integral Number in {@link
 *   module:Layout.nu64|unsigned little-endian}, {@link
 *   module:Layout.nu64be|unsigned big-endian}, {@link
 *   module:Layout.ns64|signed little-endian}, and {@link
 *   module:Layout.ns64be|unsigned big-endian} encodings;
 * * 32-bit floating point values with {@link
 *   module:Layout.f32|little-endian} and {@link
 *   module:Layout.f32be|big-endian} representations;
 * * 64-bit floating point values with {@link
 *   module:Layout.f64|little-endian} and {@link
 *   module:Layout.f64be|big-endian} representations;
 * * {@link module:Layout.const|Constants} that take no space in the
 *   encoded expression.
 *
 * and for these aggregate types:
 * * {@link module:Layout.seq|Sequence}s of instances of a {@link
 *   module:Layout~Layout|Layout}, with JavaScript representation as
 *   an Array and constant or data-dependent {@link
 *   module:Layout~Sequence#count|length};
 * * {@link module:Layout.struct|Structure}s that aggregate a
 *   heterogeneous sequence of {@link module:Layout~Layout|Layout}
 *   instances, with JavaScript representation as an Object;
 * * {@link module:Layout.union|Union}s that support multiple {@link
 *   module:Layout~VariantLayout|variant layouts} over a fixed
 *   (padded) or variable (not padded) span of bytes, using an
 *   unsigned integer at the start of the data or a separate {@link
 *   module:Layout.unionLayoutDiscriminator|layout element} to
 *   determine which layout to use when interpreting the buffer
 *   contents;
 * * {@link module:Layout.bits|BitStructure}s that contain a sequence
 *   of individual {@link
 *   module:Layout~BitStructure#addField|BitField}s packed into an 8,
 *   16, 24, or 32-bit unsigned integer starting at the least- or
 *   most-significant bit;
 * * {@link module:Layout.cstr|C strings} of varying length;
 * * {@link module:Layout.blob|Blobs} of fixed- or variable-{@link
 *   module:Layout~Blob#length|length} raw data.
 *
 * All {@link module:Layout~Layout|Layout} instances are immutable
 * after construction, to prevent internal state from becoming
 * inconsistent.
 *
 * @local Layout
 * @local ExternalLayout
 * @local GreedyCount
 * @local OffsetLayout
 * @local UInt
 * @local UIntBE
 * @local Int
 * @local IntBE
 * @local NearUInt64
 * @local NearUInt64BE
 * @local NearInt64
 * @local NearInt64BE
 * @local Float
 * @local FloatBE
 * @local Double
 * @local DoubleBE
 * @local Sequence
 * @local Structure
 * @local UnionDiscriminator
 * @local UnionLayoutDiscriminator
 * @local Union
 * @local VariantLayout
 * @local BitStructure
 * @local BitField
 * @local Boolean
 * @local Blob
 * @local CString
 * @local Constant
 * @local bindConstructorLayout
 * @module Layout
 * @license MIT
 * @author Peter A. Bigot
 * @see {@link https://github.com/pabigot/buffer-layout|buffer-layout on GitHub}
 */ "use strict";
Object.defineProperty($10b678223f208f49$exports, "__esModule", {
    value: true
});
$10b678223f208f49$exports.s16 = $10b678223f208f49$exports.s8 = $10b678223f208f49$exports.nu64be = $10b678223f208f49$exports.u48be = $10b678223f208f49$exports.u40be = $10b678223f208f49$exports.u32be = $10b678223f208f49$exports.u24be = $10b678223f208f49$exports.u16be = $10b678223f208f49$exports.nu64 = $10b678223f208f49$exports.u48 = $10b678223f208f49$exports.u40 = $10b678223f208f49$exports.u32 = $10b678223f208f49$exports.u24 = $10b678223f208f49$exports.u16 = $10b678223f208f49$exports.u8 = $10b678223f208f49$exports.offset = $10b678223f208f49$exports.greedy = $10b678223f208f49$exports.Constant = $10b678223f208f49$exports.UTF8 = $10b678223f208f49$exports.CString = $10b678223f208f49$exports.Blob = $10b678223f208f49$exports.Boolean = $10b678223f208f49$exports.BitField = $10b678223f208f49$exports.BitStructure = $10b678223f208f49$exports.VariantLayout = $10b678223f208f49$exports.Union = $10b678223f208f49$exports.UnionLayoutDiscriminator = $10b678223f208f49$exports.UnionDiscriminator = $10b678223f208f49$exports.Structure = $10b678223f208f49$exports.Sequence = $10b678223f208f49$exports.DoubleBE = $10b678223f208f49$exports.Double = $10b678223f208f49$exports.FloatBE = $10b678223f208f49$exports.Float = $10b678223f208f49$exports.NearInt64BE = $10b678223f208f49$exports.NearInt64 = $10b678223f208f49$exports.NearUInt64BE = $10b678223f208f49$exports.NearUInt64 = $10b678223f208f49$exports.IntBE = $10b678223f208f49$exports.Int = $10b678223f208f49$exports.UIntBE = $10b678223f208f49$exports.UInt = $10b678223f208f49$exports.OffsetLayout = $10b678223f208f49$exports.GreedyCount = $10b678223f208f49$exports.ExternalLayout = $10b678223f208f49$exports.bindConstructorLayout = $10b678223f208f49$exports.nameWithProperty = $10b678223f208f49$exports.Layout = $10b678223f208f49$exports.uint8ArrayToBuffer = $10b678223f208f49$exports.checkUint8Array = void 0;
$10b678223f208f49$exports.constant = $10b678223f208f49$exports.utf8 = $10b678223f208f49$exports.cstr = $10b678223f208f49$exports.blob = $10b678223f208f49$exports.unionLayoutDiscriminator = $10b678223f208f49$exports.union = $10b678223f208f49$exports.seq = $10b678223f208f49$exports.bits = $10b678223f208f49$exports.struct = $10b678223f208f49$exports.f64be = $10b678223f208f49$exports.f64 = $10b678223f208f49$exports.f32be = $10b678223f208f49$exports.f32 = $10b678223f208f49$exports.ns64be = $10b678223f208f49$exports.s48be = $10b678223f208f49$exports.s40be = $10b678223f208f49$exports.s32be = $10b678223f208f49$exports.s24be = $10b678223f208f49$exports.s16be = $10b678223f208f49$exports.ns64 = $10b678223f208f49$exports.s48 = $10b678223f208f49$exports.s40 = $10b678223f208f49$exports.s32 = $10b678223f208f49$exports.s24 = void 0;

var $lewJ9 = parcelRequire("lewJ9");
/* Check if a value is a Uint8Array.
 *
 * @ignore */ function $10b678223f208f49$var$checkUint8Array(b) {
    if (!(b instanceof Uint8Array)) throw new TypeError("b must be a Uint8Array");
}
$10b678223f208f49$exports.checkUint8Array = $10b678223f208f49$var$checkUint8Array;
/* Create a Buffer instance from a Uint8Array.
 *
 * @ignore */ function $10b678223f208f49$var$uint8ArrayToBuffer(b) {
    $10b678223f208f49$var$checkUint8Array(b);
    return $lewJ9.Buffer.from(b.buffer, b.byteOffset, b.length);
}
$10b678223f208f49$exports.uint8ArrayToBuffer = $10b678223f208f49$var$uint8ArrayToBuffer;
/**
 * Base class for layout objects.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * Layout#encode|encode} or {@link Layout#decode|decode} functions.
 *
 * @param {Number} span - Initializer for {@link Layout#span|span}.  The
 * parameter must be an integer; a negative value signifies that the
 * span is {@link Layout#getSpan|value-specific}.
 *
 * @param {string} [property] - Initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 */ class $10b678223f208f49$var$Layout {
    constructor(span, property){
        if (!Number.isInteger(span)) throw new TypeError("span must be an integer");
        /** The span of the layout in bytes.
         *
         * Positive values are generally expected.
         *
         * Zero will only appear in {@link Constant}s and in {@link
         * Sequence}s where the {@link Sequence#count|count} is zero.
         *
         * A negative value indicates that the span is value-specific, and
         * must be obtained using {@link Layout#getSpan|getSpan}. */ this.span = span;
        /** The property name used when this layout is represented in an
         * Object.
         *
         * Used only for layouts that {@link Layout#decode|decode} to Object
         * instances.  If left undefined the span of the unnamed layout will
         * be treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Function to create an Object into which decoded properties will
     * be written.
     *
     * Used only for layouts that {@link Layout#decode|decode} to Object
     * instances, which means:
     * * {@link Structure}
     * * {@link Union}
     * * {@link VariantLayout}
     * * {@link BitStructure}
     *
     * If left undefined the JavaScript representation of these layouts
     * will be Object instances.
     *
     * See {@link bindConstructorLayout}.
     */ makeDestinationObject() {
        return {};
    }
    /**
     * Calculate the span of a specific instance of a layout.
     *
     * @param {Uint8Array} b - the buffer that contains an encoded instance.
     *
     * @param {Number} [offset] - the offset at which the encoded instance
     * starts.  If absent a zero offset is inferred.
     *
     * @return {Number} - the number of bytes covered by the layout
     * instance.  If this method is not overridden in a subclass the
     * definition-time constant {@link Layout#span|span} will be
     * returned.
     *
     * @throws {RangeError} - if the length of the value cannot be
     * determined.
     */ getSpan(b, offset) {
        if (0 > this.span) throw new RangeError("indeterminate span");
        return this.span;
    }
    /**
     * Replicate the layout using a new property.
     *
     * This function must be used to get a structurally-equivalent layout
     * with a different name since all {@link Layout} instances are
     * immutable.
     *
     * **NOTE** This is a shallow copy.  All fields except {@link
     * Layout#property|property} are strictly equal to the origin layout.
     *
     * @param {String} property - the value for {@link
     * Layout#property|property} in the replica.
     *
     * @returns {Layout} - the copy with {@link Layout#property|property}
     * set to `property`.
     */ replicate(property) {
        const rv = Object.create(this.constructor.prototype);
        Object.assign(rv, this);
        rv.property = property;
        return rv;
    }
    /**
     * Create an object from layout properties and an array of values.
     *
     * **NOTE** This function returns `undefined` if invoked on a layout
     * that does not return its value as an Object.  Objects are
     * returned for things that are a {@link Structure}, which includes
     * {@link VariantLayout|variant layouts} if they are structures, and
     * excludes {@link Union}s.  If you want this feature for a union
     * you must use {@link Union.getVariant|getVariant} to select the
     * desired layout.
     *
     * @param {Array} values - an array of values that correspond to the
     * default order for properties.  As with {@link Layout#decode|decode}
     * layout elements that have no property name are skipped when
     * iterating over the array values.  Only the top-level properties are
     * assigned; arguments are not assigned to properties of contained
     * layouts.  Any unused values are ignored.
     *
     * @return {(Object|undefined)}
     */ fromArray(values) {
        return undefined;
    }
}
$10b678223f208f49$exports.Layout = $10b678223f208f49$var$Layout;
/* Provide text that carries a name (such as for a function that will
 * be throwing an error) annotated with the property of a given layout
 * (such as one for which the value was unacceptable).
 *
 * @ignore */ function $10b678223f208f49$var$nameWithProperty(name, lo) {
    if (lo.property) return name + "[" + lo.property + "]";
    return name;
}
$10b678223f208f49$exports.nameWithProperty = $10b678223f208f49$var$nameWithProperty;
/**
 * Augment a class so that instances can be encoded/decoded using a
 * given layout.
 *
 * Calling this function couples `Class` with `layout` in several ways:
 *
 * * `Class.layout_` becomes a static member property equal to `layout`;
 * * `layout.boundConstructor_` becomes a static member property equal
 *    to `Class`;
 * * The {@link Layout#makeDestinationObject|makeDestinationObject()}
 *   property of `layout` is set to a function that returns a `new
 *   Class()`;
 * * `Class.decode(b, offset)` becomes a static member function that
 *   delegates to {@link Layout#decode|layout.decode}.  The
 *   synthesized function may be captured and extended.
 * * `Class.prototype.encode(b, offset)` provides an instance member
 *   function that delegates to {@link Layout#encode|layout.encode}
 *   with `src` set to `this`.  The synthesized function may be
 *   captured and extended, but when the extension is invoked `this`
 *   must be explicitly bound to the instance.
 *
 * @param {class} Class - a JavaScript class with a nullary
 * constructor.
 *
 * @param {Layout} layout - the {@link Layout} instance used to encode
 * instances of `Class`.
 */ // `Class` must be a constructor Function, but the assignment of a `layout_` property to it makes it difficult to type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $10b678223f208f49$var$bindConstructorLayout(Class, layout) {
    if ("function" !== typeof Class) throw new TypeError("Class must be constructor");
    if (Object.prototype.hasOwnProperty.call(Class, "layout_")) throw new Error("Class is already bound to a layout");
    if (!(layout && layout instanceof $10b678223f208f49$var$Layout)) throw new TypeError("layout must be a Layout");
    if (Object.prototype.hasOwnProperty.call(layout, "boundConstructor_")) throw new Error("layout is already bound to a constructor");
    Class.layout_ = layout;
    layout.boundConstructor_ = Class;
    layout.makeDestinationObject = ()=>new Class();
    Object.defineProperty(Class.prototype, "encode", {
        value (b, offset) {
            return layout.encode(this, b, offset);
        },
        writable: true
    });
    Object.defineProperty(Class, "decode", {
        value (b, offset) {
            return layout.decode(b, offset);
        },
        writable: true
    });
}
$10b678223f208f49$exports.bindConstructorLayout = $10b678223f208f49$var$bindConstructorLayout;
/**
 * An object that behaves like a layout but does not consume space
 * within its containing layout.
 *
 * This is primarily used to obtain metadata about a member, such as a
 * {@link OffsetLayout} that can provide data about a {@link
 * Layout#getSpan|value-specific span}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support {@link
 * ExternalLayout#isCount|isCount} or other {@link Layout} functions.
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 * @augments {Layout}
 */ class $10b678223f208f49$var$ExternalLayout extends $10b678223f208f49$var$Layout {
    /**
     * Return `true` iff the external layout decodes to an unsigned
     * integer layout.
     *
     * In that case it can be used as the source of {@link
     * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
     * or as {@link UnionLayoutDiscriminator#layout|external union
     * discriminators}.
     *
     * @abstract
     */ isCount() {
        throw new Error("ExternalLayout is abstract");
    }
}
$10b678223f208f49$exports.ExternalLayout = $10b678223f208f49$var$ExternalLayout;
/**
 * An {@link ExternalLayout} that determines its {@link
 * Layout#decode|value} based on offset into and length of the buffer
 * on which it is invoked.
 *
 * *Factory*: {@link module:Layout.greedy|greedy}
 *
 * @param {Number} [elementSpan] - initializer for {@link
 * GreedyCount#elementSpan|elementSpan}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {ExternalLayout}
 */ class $10b678223f208f49$var$GreedyCount extends $10b678223f208f49$var$ExternalLayout {
    constructor(elementSpan = 1, property){
        if (!Number.isInteger(elementSpan) || 0 >= elementSpan) throw new TypeError("elementSpan must be a (positive) integer");
        super(-1, property);
        /** The layout for individual elements of the sequence.  The value
         * must be a positive integer.  If not provided, the value will be
         * 1. */ this.elementSpan = elementSpan;
    }
    /** @override */ isCount() {
        return true;
    }
    /** @override */ decode(b, offset = 0) {
        $10b678223f208f49$var$checkUint8Array(b);
        const rem = b.length - offset;
        return Math.floor(rem / this.elementSpan);
    }
    /** @override */ encode(src, b, offset) {
        return 0;
    }
}
$10b678223f208f49$exports.GreedyCount = $10b678223f208f49$var$GreedyCount;
/**
 * An {@link ExternalLayout} that supports accessing a {@link Layout}
 * at a fixed offset from the start of another Layout.  The offset may
 * be before, within, or after the base layout.
 *
 * *Factory*: {@link module:Layout.offset|offset}
 *
 * @param {Layout} layout - initializer for {@link
 * OffsetLayout#layout|layout}, modulo `property`.
 *
 * @param {Number} [offset] - Initializes {@link
 * OffsetLayout#offset|offset}.  Defaults to zero.
 *
 * @param {string} [property] - Optional new property name for a
 * {@link Layout#replicate| replica} of `layout` to be used as {@link
 * OffsetLayout#layout|layout}.  If not provided the `layout` is used
 * unchanged.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$OffsetLayout extends $10b678223f208f49$var$ExternalLayout {
    constructor(layout, offset = 0, property){
        if (!(layout instanceof $10b678223f208f49$var$Layout)) throw new TypeError("layout must be a Layout");
        if (!Number.isInteger(offset)) throw new TypeError("offset must be integer or undefined");
        super(layout.span, property || layout.property);
        /** The subordinated layout. */ this.layout = layout;
        /** The location of {@link OffsetLayout#layout} relative to the
         * start of another layout.
         *
         * The value may be positive or negative, but an error will thrown
         * if at the point of use it goes outside the span of the Uint8Array
         * being accessed.  */ this.offset = offset;
    }
    /** @override */ isCount() {
        return this.layout instanceof $10b678223f208f49$var$UInt || this.layout instanceof $10b678223f208f49$var$UIntBE;
    }
    /** @override */ decode(b, offset = 0) {
        return this.layout.decode(b, offset + this.offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        return this.layout.encode(src, b, offset + this.offset);
    }
}
$10b678223f208f49$exports.OffsetLayout = $10b678223f208f49$var$OffsetLayout;
/**
 * Represent an unsigned integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.u8|u8}, {@link
 *  module:Layout.u16|u16}, {@link module:Layout.u24|u24}, {@link
 *  module:Layout.u32|u32}, {@link module:Layout.u40|u40}, {@link
 *  module:Layout.u48|u48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$UInt extends $10b678223f208f49$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $10b678223f208f49$var$uint8ArrayToBuffer(b).readUIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $10b678223f208f49$var$uint8ArrayToBuffer(b).writeUIntLE(src, offset, this.span);
        return this.span;
    }
}
$10b678223f208f49$exports.UInt = $10b678223f208f49$var$UInt;
/**
 * Represent an unsigned integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.u8be|u8be}, {@link
 * module:Layout.u16be|u16be}, {@link module:Layout.u24be|u24be},
 * {@link module:Layout.u32be|u32be}, {@link
 * module:Layout.u40be|u40be}, {@link module:Layout.u48be|u48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$UIntBE extends $10b678223f208f49$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $10b678223f208f49$var$uint8ArrayToBuffer(b).readUIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $10b678223f208f49$var$uint8ArrayToBuffer(b).writeUIntBE(src, offset, this.span);
        return this.span;
    }
}
$10b678223f208f49$exports.UIntBE = $10b678223f208f49$var$UIntBE;
/**
 * Represent a signed integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.s8|s8}, {@link
 *  module:Layout.s16|s16}, {@link module:Layout.s24|s24}, {@link
 *  module:Layout.s32|s32}, {@link module:Layout.s40|s40}, {@link
 *  module:Layout.s48|s48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$Int extends $10b678223f208f49$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $10b678223f208f49$var$uint8ArrayToBuffer(b).readIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $10b678223f208f49$var$uint8ArrayToBuffer(b).writeIntLE(src, offset, this.span);
        return this.span;
    }
}
$10b678223f208f49$exports.Int = $10b678223f208f49$var$Int;
/**
 * Represent a signed integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.s8be|s8be}, {@link
 * module:Layout.s16be|s16be}, {@link module:Layout.s24be|s24be},
 * {@link module:Layout.s32be|s32be}, {@link
 * module:Layout.s40be|s40be}, {@link module:Layout.s48be|s48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$IntBE extends $10b678223f208f49$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $10b678223f208f49$var$uint8ArrayToBuffer(b).readIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $10b678223f208f49$var$uint8ArrayToBuffer(b).writeIntBE(src, offset, this.span);
        return this.span;
    }
}
$10b678223f208f49$exports.IntBE = $10b678223f208f49$var$IntBE;
const $10b678223f208f49$var$V2E32 = Math.pow(2, 32);
/* True modulus high and low 32-bit words, where low word is always
 * non-negative. */ function $10b678223f208f49$var$divmodInt64(src) {
    const hi32 = Math.floor(src / $10b678223f208f49$var$V2E32);
    const lo32 = src - hi32 * $10b678223f208f49$var$V2E32;
    return {
        hi32: hi32,
        lo32: lo32
    };
}
/* Reconstruct Number from quotient and non-negative remainder */ function $10b678223f208f49$var$roundedInt64(hi32, lo32) {
    return hi32 * $10b678223f208f49$var$V2E32 + lo32;
}
/**
 * Represent an unsigned 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64|nu64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$NearUInt64 extends $10b678223f208f49$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $10b678223f208f49$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readUInt32LE(offset + 4);
        return $10b678223f208f49$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $10b678223f208f49$var$divmodInt64(src);
        const buffer = $10b678223f208f49$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeUInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
$10b678223f208f49$exports.NearUInt64 = $10b678223f208f49$var$NearUInt64;
/**
 * Represent an unsigned 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64be|nu64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$NearUInt64BE extends $10b678223f208f49$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $10b678223f208f49$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readUInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $10b678223f208f49$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $10b678223f208f49$var$divmodInt64(src);
        const buffer = $10b678223f208f49$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
$10b678223f208f49$exports.NearUInt64BE = $10b678223f208f49$var$NearUInt64BE;
/**
 * Represent a signed 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64|ns64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$NearInt64 extends $10b678223f208f49$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $10b678223f208f49$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readInt32LE(offset + 4);
        return $10b678223f208f49$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $10b678223f208f49$var$divmodInt64(src);
        const buffer = $10b678223f208f49$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
$10b678223f208f49$exports.NearInt64 = $10b678223f208f49$var$NearInt64;
/**
 * Represent a signed 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64be|ns64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$NearInt64BE extends $10b678223f208f49$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $10b678223f208f49$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $10b678223f208f49$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $10b678223f208f49$var$divmodInt64(src);
        const buffer = $10b678223f208f49$var$uint8ArrayToBuffer(b);
        buffer.writeInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
$10b678223f208f49$exports.NearInt64BE = $10b678223f208f49$var$NearInt64BE;
/**
 * Represent a 32-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f32|f32}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$Float extends $10b678223f208f49$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $10b678223f208f49$var$uint8ArrayToBuffer(b).readFloatLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $10b678223f208f49$var$uint8ArrayToBuffer(b).writeFloatLE(src, offset);
        return 4;
    }
}
$10b678223f208f49$exports.Float = $10b678223f208f49$var$Float;
/**
 * Represent a 32-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f32be|f32be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$FloatBE extends $10b678223f208f49$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $10b678223f208f49$var$uint8ArrayToBuffer(b).readFloatBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $10b678223f208f49$var$uint8ArrayToBuffer(b).writeFloatBE(src, offset);
        return 4;
    }
}
$10b678223f208f49$exports.FloatBE = $10b678223f208f49$var$FloatBE;
/**
 * Represent a 64-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f64|f64}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$Double extends $10b678223f208f49$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $10b678223f208f49$var$uint8ArrayToBuffer(b).readDoubleLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $10b678223f208f49$var$uint8ArrayToBuffer(b).writeDoubleLE(src, offset);
        return 8;
    }
}
$10b678223f208f49$exports.Double = $10b678223f208f49$var$Double;
/**
 * Represent a 64-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f64be|f64be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$DoubleBE extends $10b678223f208f49$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $10b678223f208f49$var$uint8ArrayToBuffer(b).readDoubleBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $10b678223f208f49$var$uint8ArrayToBuffer(b).writeDoubleBE(src, offset);
        return 8;
    }
}
$10b678223f208f49$exports.DoubleBE = $10b678223f208f49$var$DoubleBE;
/**
 * Represent a contiguous sequence of a specific layout as an Array.
 *
 * *Factory*: {@link module:Layout.seq|seq}
 *
 * @param {Layout} elementLayout - initializer for {@link
 * Sequence#elementLayout|elementLayout}.
 *
 * @param {(Number|ExternalLayout)} count - initializer for {@link
 * Sequence#count|count}.  The parameter must be either a positive
 * integer or an instance of {@link ExternalLayout}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$Sequence extends $10b678223f208f49$var$Layout {
    constructor(elementLayout, count, property){
        if (!(elementLayout instanceof $10b678223f208f49$var$Layout)) throw new TypeError("elementLayout must be a Layout");
        if (!(count instanceof $10b678223f208f49$var$ExternalLayout && count.isCount() || Number.isInteger(count) && 0 <= count)) throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(count instanceof $10b678223f208f49$var$ExternalLayout) && 0 < elementLayout.span) span = count * elementLayout.span;
        super(span, property);
        /** The layout for individual elements of the sequence. */ this.elementLayout = elementLayout;
        /** The number of elements in the sequence.
         *
         * This will be either a non-negative integer or an instance of
         * {@link ExternalLayout} for which {@link
         * ExternalLayout#isCount|isCount()} is `true`. */ this.count = count;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        let count = this.count;
        if (count instanceof $10b678223f208f49$var$ExternalLayout) count = count.decode(b, offset);
        if (0 < this.elementLayout.span) span = count * this.elementLayout.span;
        else {
            let idx = 0;
            while(idx < count){
                span += this.elementLayout.getSpan(b, offset + span);
                ++idx;
            }
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        const rv = [];
        let i = 0;
        let count = this.count;
        if (count instanceof $10b678223f208f49$var$ExternalLayout) count = count.decode(b, offset);
        while(i < count){
            rv.push(this.elementLayout.decode(b, offset));
            offset += this.elementLayout.getSpan(b, offset);
            i += 1;
        }
        return rv;
    }
    /** Implement {@link Layout#encode|encode} for {@link Sequence}.
     *
     * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
     * the unused space in the buffer is left unchanged.  If `src` is
     * longer than {@link Sequence#count|count} the unneeded elements are
     * ignored.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset = 0) {
        const elo = this.elementLayout;
        const span = src.reduce((span, v)=>{
            return span + elo.encode(v, b, offset + span);
        }, 0);
        if (this.count instanceof $10b678223f208f49$var$ExternalLayout) this.count.encode(src.length, b, offset);
        return span;
    }
}
$10b678223f208f49$exports.Sequence = $10b678223f208f49$var$Sequence;
/**
 * Represent a contiguous sequence of arbitrary layout elements as an
 * Object.
 *
 * *Factory*: {@link module:Layout.struct|struct}
 *
 * **NOTE** The {@link Layout#span|span} of the structure is variable
 * if any layout in {@link Structure#fields|fields} has a variable
 * span.  When {@link Layout#encode|encoding} we must have a value for
 * all variable-length fields, or we wouldn't be able to figure out
 * how much space to use for storage.  We can only identify the value
 * for a field when it has a {@link Layout#property|property}.  As
 * such, although a structure may contain both unnamed fields and
 * variable-length fields, it cannot contain an unnamed
 * variable-length field.
 *
 * @param {Layout[]} fields - initializer for {@link
 * Structure#fields|fields}.  An error is raised if this contains a
 * variable-length field for which a {@link Layout#property|property}
 * is not defined.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @param {Boolean} [decodePrefixes] - initializer for {@link
 * Structure#decodePrefixes|property}.
 *
 * @throws {Error} - if `fields` contains an unnamed variable-length
 * layout.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$Structure extends $10b678223f208f49$var$Layout {
    constructor(fields, property, decodePrefixes){
        if (!(Array.isArray(fields) && fields.reduce((acc, v)=>acc && v instanceof $10b678223f208f49$var$Layout, true))) throw new TypeError("fields must be array of Layout instances");
        if ("boolean" === typeof property && undefined === decodePrefixes) {
            decodePrefixes = property;
            property = undefined;
        }
        /* Verify absence of unnamed variable-length fields. */ for (const fd of fields){
            if (0 > fd.span && undefined === fd.property) throw new Error("fields cannot contain unnamed variable-length layout");
        }
        let span = -1;
        try {
            span = fields.reduce((span, fd)=>span + fd.getSpan(), 0);
        } catch (e) {
        // ignore error
        }
        super(span, property);
        /** The sequence of {@link Layout} values that comprise the
         * structure.
         *
         * The individual elements need not be the same type, and may be
         * either scalar or aggregate layouts.  If a member layout leaves
         * its {@link Layout#property|property} undefined the
         * corresponding region of the buffer associated with the element
         * will not be mutated.
         *
         * @type {Layout[]} */ this.fields = fields;
        /** Control behavior of {@link Layout#decode|decode()} given short
         * buffers.
         *
         * In some situations a structure many be extended with additional
         * fields over time, with older installations providing only a
         * prefix of the full structure.  If this property is `true`
         * decoding will accept those buffers and leave subsequent fields
         * undefined, as long as the buffer ends at a field boundary.
         * Defaults to `false`. */ this.decodePrefixes = !!decodePrefixes;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        try {
            span = this.fields.reduce((span, fd)=>{
                const fsp = fd.getSpan(b, offset);
                offset += fsp;
                return span + fsp;
            }, 0);
        } catch (e) {
            throw new RangeError("indeterminate span");
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        $10b678223f208f49$var$checkUint8Array(b);
        const dest = this.makeDestinationObject();
        for (const fd of this.fields){
            if (undefined !== fd.property) dest[fd.property] = fd.decode(b, offset);
            offset += fd.getSpan(b, offset);
            if (this.decodePrefixes && b.length === offset) break;
        }
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Structure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the buffer is
     * left unmodified. */ encode(src, b, offset = 0) {
        const firstOffset = offset;
        let lastOffset = 0;
        let lastWrote = 0;
        for (const fd of this.fields){
            let span = fd.span;
            lastWrote = 0 < span ? span : 0;
            if (undefined !== fd.property) {
                const fv = src[fd.property];
                if (undefined !== fv) {
                    lastWrote = fd.encode(fv, b, offset);
                    if (0 > span) /* Read the as-encoded span, which is not necessarily the
                         * same as what we wrote. */ span = fd.getSpan(b, offset);
                }
            }
            lastOffset = offset;
            offset += span;
        }
        /* Use (lastOffset + lastWrote) instead of offset because the last
         * item may have had a dynamic length and we don't want to include
         * the padding between it and the end of the space reserved for
         * it. */ return lastOffset + lastWrote - firstOffset;
    }
    /** @override */ fromArray(values) {
        const dest = this.makeDestinationObject();
        for (const fd of this.fields)if (undefined !== fd.property && 0 < values.length) dest[fd.property] = values.shift();
        return dest;
    }
    /**
     * Get access to the layout of a given property.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Layout} - the layout associated with `property`, or
     * undefined if there is no such property.
     */ layoutFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
    /**
     * Get the offset of a structure member.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Number} - the offset in bytes to the start of `property`
     * within the structure, or undefined if `property` is not a field
     * within the structure.  If the property is a member but follows a
     * variable-length structure member a negative number will be
     * returned.
     */ offsetOf(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        let offset = 0;
        for (const fd of this.fields){
            if (fd.property === property) return offset;
            if (0 > fd.span) offset = -1;
            else if (0 <= offset) offset += fd.span;
        }
        return undefined;
    }
}
$10b678223f208f49$exports.Structure = $10b678223f208f49$var$Structure;
/**
 * An object that can provide a {@link
 * Union#discriminator|discriminator} API for {@link Union}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * UnionDiscriminator#encode|encode} or {@link
 * UnionDiscriminator#decode|decode} functions.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}.
 *
 * @abstract
 */ class $10b678223f208f49$var$UnionDiscriminator {
    constructor(property){
        /** The {@link Layout#property|property} to be used when the
         * discriminator is referenced in isolation (generally when {@link
         * Union#decode|Union decode} cannot delegate to a specific
         * variant). */ this.property = property;
    }
    /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
     *
     * The implementation of this method need not reference the buffer if
     * variant information is available through other means. */ decode(b, offset) {
        throw new Error("UnionDiscriminator is abstract");
    }
    /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
     *
     * The implementation of this method need not store the value if
     * variant information is maintained through other means. */ encode(src, b, offset) {
        throw new Error("UnionDiscriminator is abstract");
    }
}
$10b678223f208f49$exports.UnionDiscriminator = $10b678223f208f49$var$UnionDiscriminator;
/**
 * An object that can provide a {@link
 * UnionDiscriminator|discriminator API} for {@link Union} using an
 * unsigned integral {@link Layout} instance located either inside or
 * outside the union.
 *
 * @param {ExternalLayout} layout - initializes {@link
 * UnionLayoutDiscriminator#layout|layout}.  Must satisfy {@link
 * ExternalLayout#isCount|isCount()}.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}, superseding the property
 * from `layout`, but defaulting to `variant` if neither `property`
 * nor layout provide a property name.
 *
 * @augments {UnionDiscriminator}
 */ class $10b678223f208f49$var$UnionLayoutDiscriminator extends $10b678223f208f49$var$UnionDiscriminator {
    constructor(layout, property){
        if (!(layout instanceof $10b678223f208f49$var$ExternalLayout && layout.isCount())) throw new TypeError("layout must be an unsigned integer ExternalLayout");
        super(property || layout.property || "variant");
        /** The {@link ExternalLayout} used to access the discriminator
         * value. */ this.layout = layout;
    }
    /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */ decode(b, offset) {
        return this.layout.decode(b, offset);
    }
    /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */ encode(src, b, offset) {
        return this.layout.encode(src, b, offset);
    }
}
$10b678223f208f49$exports.UnionLayoutDiscriminator = $10b678223f208f49$var$UnionLayoutDiscriminator;
/**
 * Represent any number of span-compatible layouts.
 *
 * *Factory*: {@link module:Layout.union|union}
 *
 * If the union has a {@link Union#defaultLayout|default layout} that
 * layout must have a non-negative {@link Layout#span|span}.  The span
 * of a fixed-span union includes its {@link
 * Union#discriminator|discriminator} if the variant is a {@link
 * Union#usesPrefixDiscriminator|prefix of the union}, plus the span
 * of its {@link Union#defaultLayout|default layout}.
 *
 * If the union does not have a default layout then the encoded span
 * of the union depends on the encoded span of its variant (which may
 * be fixed or variable).
 *
 * {@link VariantLayout#layout|Variant layout}s are added through
 * {@link Union#addVariant|addVariant}.  If the union has a default
 * layout, the span of the {@link VariantLayout#layout|layout
 * contained by the variant} must not exceed the span of the {@link
 * Union#defaultLayout|default layout} (minus the span of a {@link
 * Union#usesPrefixDiscriminator|prefix disriminator}, if used).  The
 * span of the variant will equal the span of the union itself.
 *
 * The variant for a buffer can only be identified from the {@link
 * Union#discriminator|discriminator} {@link
 * UnionDiscriminator#property|property} (in the case of the {@link
 * Union#defaultLayout|default layout}), or by using {@link
 * Union#getVariant|getVariant} and examining the resulting {@link
 * VariantLayout} instance.
 *
 * A variant compatible with a JavaScript object can be identified
 * using {@link Union#getSourceVariant|getSourceVariant}.
 *
 * @param {(UnionDiscriminator|ExternalLayout|Layout)} discr - How to
 * identify the layout used to interpret the union contents.  The
 * parameter must be an instance of {@link UnionDiscriminator}, an
 * {@link ExternalLayout} that satisfies {@link
 * ExternalLayout#isCount|isCount()}, or {@link UInt} (or {@link
 * UIntBE}).  When a non-external layout element is passed the layout
 * appears at the start of the union.  In all cases the (synthesized)
 * {@link UnionDiscriminator} instance is recorded as {@link
 * Union#discriminator|discriminator}.
 *
 * @param {(Layout|null)} defaultLayout - initializer for {@link
 * Union#defaultLayout|defaultLayout}.  If absent defaults to `null`.
 * If `null` there is no default layout: the union has data-dependent
 * length and attempts to decode or encode unrecognized variants will
 * throw an exception.  A {@link Layout} instance must have a
 * non-negative {@link Layout#span|span}, and if it lacks a {@link
 * Layout#property|property} the {@link
 * Union#defaultLayout|defaultLayout} will be a {@link
 * Layout#replicate|replica} with property `content`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$Union extends $10b678223f208f49$var$Layout {
    constructor(discr, defaultLayout, property){
        let discriminator;
        if (discr instanceof $10b678223f208f49$var$UInt || discr instanceof $10b678223f208f49$var$UIntBE) discriminator = new $10b678223f208f49$var$UnionLayoutDiscriminator(new $10b678223f208f49$var$OffsetLayout(discr));
        else if (discr instanceof $10b678223f208f49$var$ExternalLayout && discr.isCount()) discriminator = new $10b678223f208f49$var$UnionLayoutDiscriminator(discr);
        else if (!(discr instanceof $10b678223f208f49$var$UnionDiscriminator)) throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
        else discriminator = discr;
        if (undefined === defaultLayout) defaultLayout = null;
        if (!(null === defaultLayout || defaultLayout instanceof $10b678223f208f49$var$Layout)) throw new TypeError("defaultLayout must be null or a Layout");
        if (null !== defaultLayout) {
            if (0 > defaultLayout.span) throw new Error("defaultLayout must have constant span");
            if (undefined === defaultLayout.property) defaultLayout = defaultLayout.replicate("content");
        }
        /* The union span can be estimated only if there's a default
         * layout.  The union spans its default layout, plus any prefix
         * variant layout.  By construction both layouts, if present, have
         * non-negative span. */ let span = -1;
        if (defaultLayout) {
            span = defaultLayout.span;
            if (0 <= span && (discr instanceof $10b678223f208f49$var$UInt || discr instanceof $10b678223f208f49$var$UIntBE)) span += discriminator.layout.span;
        }
        super(span, property);
        /** The interface for the discriminator value in isolation.
         *
         * This a {@link UnionDiscriminator} either passed to the
         * constructor or synthesized from the `discr` constructor
         * argument.  {@link
         * Union#usesPrefixDiscriminator|usesPrefixDiscriminator} will be
         * `true` iff the `discr` parameter was a non-offset {@link
         * Layout} instance. */ this.discriminator = discriminator;
        /** `true` if the {@link Union#discriminator|discriminator} is the
         * first field in the union.
         *
         * If `false` the discriminator is obtained from somewhere
         * else. */ this.usesPrefixDiscriminator = discr instanceof $10b678223f208f49$var$UInt || discr instanceof $10b678223f208f49$var$UIntBE;
        /** The layout for non-discriminator content when the value of the
         * discriminator is not recognized.
         *
         * This is the value passed to the constructor.  It is
         * structurally equivalent to the second component of {@link
         * Union#layout|layout} but may have a different property
         * name. */ this.defaultLayout = defaultLayout;
        /** A registry of allowed variants.
         *
         * The keys are unsigned integers which should be compatible with
         * {@link Union.discriminator|discriminator}.  The property value
         * is the corresponding {@link VariantLayout} instances assigned
         * to this union by {@link Union#addVariant|addVariant}.
         *
         * **NOTE** The registry remains mutable so that variants can be
         * {@link Union#addVariant|added} at any time.  Users should not
         * manipulate the content of this property. */ this.registry = {};
        /* Private variable used when invoking getSourceVariant */ let boundGetSourceVariant = this.defaultGetSourceVariant.bind(this);
        /** Function to infer the variant selected by a source object.
         *
         * Defaults to {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant} but may
         * be overridden using {@link
         * Union#configGetSourceVariant|configGetSourceVariant}.
         *
         * @param {Object} src - as with {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * @returns {(undefined|VariantLayout)} The default variant
         * (`undefined`) or first registered variant that uses a property
         * available in `src`. */ this.getSourceVariant = function(src) {
            return boundGetSourceVariant(src);
        };
        /** Function to override the implementation of {@link
         * Union#getSourceVariant|getSourceVariant}.
         *
         * Use this if the desired variant cannot be identified using the
         * algorithm of {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * **NOTE** The provided function will be invoked bound to this
         * Union instance, providing local access to {@link
         * Union#registry|registry}.
         *
         * @param {Function} gsv - a function that follows the API of
         * {@link Union#defaultGetSourceVariant|defaultGetSourceVariant}. */ this.configGetSourceVariant = function(gsv) {
            boundGetSourceVariant = gsv.bind(this);
        };
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        /* Default layouts always have non-negative span, so we don't have
         * one and we have to recognize the variant which will in turn
         * determine the span. */ const vlo = this.getVariant(b, offset);
        if (!vlo) throw new Error("unable to determine span for unrecognized variant");
        return vlo.getSpan(b, offset);
    }
    /**
     * Method to infer a registered Union variant compatible with `src`.
     *
     * The first satisfied rule in the following sequence defines the
     * return value:
     * * If `src` has properties matching the Union discriminator and
     *   the default layout, `undefined` is returned regardless of the
     *   value of the discriminator property (this ensures the default
     *   layout will be used);
     * * If `src` has a property matching the Union discriminator, the
     *   value of the discriminator identifies a registered variant, and
     *   either (a) the variant has no layout, or (b) `src` has the
     *   variant's property, then the variant is returned (because the
     *   source satisfies the constraints of the variant it identifies);
     * * If `src` does not have a property matching the Union
     *   discriminator, but does have a property matching a registered
     *   variant, then the variant is returned (because the source
     *   matches a variant without an explicit conflict);
     * * An error is thrown (because we either can't identify a variant,
     *   or we were explicitly told the variant but can't satisfy it).
     *
     * @param {Object} src - an object presumed to be compatible with
     * the content of the Union.
     *
     * @return {(undefined|VariantLayout)} - as described above.
     *
     * @throws {Error} - if `src` cannot be associated with a default or
     * registered variant.
     */ defaultGetSourceVariant(src) {
        if (Object.prototype.hasOwnProperty.call(src, this.discriminator.property)) {
            if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(src, this.defaultLayout.property)) return undefined;
            const vlo = this.registry[src[this.discriminator.property]];
            if (vlo && (!vlo.layout || vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property))) return vlo;
        } else for(const tag in this.registry){
            const vlo = this.registry[tag];
            if (vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property)) return vlo;
        }
        throw new Error("unable to infer src variant");
    }
    /** Implement {@link Layout#decode|decode} for {@link Union}.
     *
     * If the variant is {@link Union#addVariant|registered} the return
     * value is an instance of that variant, with no explicit
     * discriminator.  Otherwise the {@link Union#defaultLayout|default
     * layout} is used to decode the content. */ decode(b, offset = 0) {
        let dest;
        const dlo = this.discriminator;
        const discr = dlo.decode(b, offset);
        const clo = this.registry[discr];
        if (undefined === clo) {
            const defaultLayout = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dest = this.makeDestinationObject();
            dest[dlo.property] = discr;
            // defaultLayout.property can be undefined, but this is allowed by buffer-layout
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dest[defaultLayout.property] = defaultLayout.decode(b, offset + contentOffset);
        } else dest = clo.decode(b, offset);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Union}.
     *
     * This API assumes the `src` object is consistent with the union's
     * {@link Union#defaultLayout|default layout}.  To encode variants
     * use the appropriate variant-specific {@link VariantLayout#encode}
     * method. */ encode(src, b, offset = 0) {
        const vlo = this.getSourceVariant(src);
        if (undefined === vlo) {
            const dlo = this.discriminator;
            // this.defaultLayout is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const clo = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dlo.encode(src[dlo.property], b, offset);
            // clo.property is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return contentOffset + clo.encode(src[clo.property], b, offset + contentOffset);
        }
        return vlo.encode(src, b, offset);
    }
    /** Register a new variant structure within a union.  The newly
     * created variant is returned.
     *
     * @param {Number} variant - initializer for {@link
     * VariantLayout#variant|variant}.
     *
     * @param {Layout} layout - initializer for {@link
     * VariantLayout#layout|layout}.
     *
     * @param {String} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {VariantLayout} */ addVariant(variant, layout, property) {
        const rv = new $10b678223f208f49$var$VariantLayout(this, variant, layout, property);
        this.registry[variant] = rv;
        return rv;
    }
    /**
     * Get the layout associated with a registered variant.
     *
     * If `vb` does not produce a registered variant the function returns
     * `undefined`.
     *
     * @param {(Number|Uint8Array)} vb - either the variant number, or a
     * buffer from which the discriminator is to be read.
     *
     * @param {Number} offset - offset into `vb` for the start of the
     * union.  Used only when `vb` is an instance of {Uint8Array}.
     *
     * @return {({VariantLayout}|undefined)}
     */ getVariant(vb, offset = 0) {
        let variant;
        if (vb instanceof Uint8Array) variant = this.discriminator.decode(vb, offset);
        else variant = vb;
        return this.registry[variant];
    }
}
$10b678223f208f49$exports.Union = $10b678223f208f49$var$Union;
/**
 * Represent a specific variant within a containing union.
 *
 * **NOTE** The {@link Layout#span|span} of the variant may include
 * the span of the {@link Union#discriminator|discriminator} used to
 * identify it, but values read and written using the variant strictly
 * conform to the content of {@link VariantLayout#layout|layout}.
 *
 * **NOTE** User code should not invoke this constructor directly.  Use
 * the union {@link Union#addVariant|addVariant} helper method.
 *
 * @param {Union} union - initializer for {@link
 * VariantLayout#union|union}.
 *
 * @param {Number} variant - initializer for {@link
 * VariantLayout#variant|variant}.
 *
 * @param {Layout} [layout] - initializer for {@link
 * VariantLayout#layout|layout}.  If absent the variant carries no
 * data.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.  Unlike many other layouts, variant
 * layouts normally include a property name so they can be identified
 * within their containing {@link Union}.  The property identifier may
 * be absent only if `layout` is is absent.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$VariantLayout extends $10b678223f208f49$var$Layout {
    constructor(union, variant, layout, property){
        if (!(union instanceof $10b678223f208f49$var$Union)) throw new TypeError("union must be a Union");
        if (!Number.isInteger(variant) || 0 > variant) throw new TypeError("variant must be a (non-negative) integer");
        if ("string" === typeof layout && undefined === property) {
            property = layout;
            layout = null;
        }
        if (layout) {
            if (!(layout instanceof $10b678223f208f49$var$Layout)) throw new TypeError("layout must be a Layout");
            if (null !== union.defaultLayout && 0 <= layout.span && layout.span > union.defaultLayout.span) throw new Error("variant span exceeds span of containing union");
            if ("string" !== typeof property) throw new TypeError("variant must have a String property");
        }
        let span = union.span;
        if (0 > union.span) {
            span = layout ? layout.span : 0;
            if (0 <= span && union.usesPrefixDiscriminator) span += union.discriminator.layout.span;
        }
        super(span, property);
        /** The {@link Union} to which this variant belongs. */ this.union = union;
        /** The unsigned integral value identifying this variant within
         * the {@link Union#discriminator|discriminator} of the containing
         * union. */ this.variant = variant;
        /** The {@link Layout} to be used when reading/writing the
         * non-discriminator part of the {@link
         * VariantLayout#union|union}.  If `null` the variant carries no
         * data. */ this.layout = layout || null;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) /* Will be equal to the containing union span if that is not
             * variable. */ return this.span;
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        /* Span is defined solely by the variant (and prefix discriminator) */ let span = 0;
        if (this.layout) span = this.layout.getSpan(b, offset + contentOffset);
        return contentOffset + span;
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        if (this !== this.union.getVariant(b, offset)) throw new Error("variant mismatch");
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout) dest[this.property] = this.layout.decode(b, offset + contentOffset);
        else if (this.property) dest[this.property] = true;
        else if (this.union.usesPrefixDiscriminator) dest[this.union.discriminator.property] = this.variant;
        return dest;
    }
    /** @override */ encode(src, b, offset = 0) {
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout && !Object.prototype.hasOwnProperty.call(src, this.property)) throw new TypeError("variant lacks property " + this.property);
        this.union.discriminator.encode(this.variant, b, offset);
        let span = contentOffset;
        if (this.layout) {
            this.layout.encode(src[this.property], b, offset + contentOffset);
            span += this.layout.getSpan(b, offset + contentOffset);
            if (0 <= this.union.span && span > this.union.span) throw new Error("encoded variant overruns containing union");
        }
        return span;
    }
    /** Delegate {@link Layout#fromArray|fromArray} to {@link
     * VariantLayout#layout|layout}. */ fromArray(values) {
        if (this.layout) return this.layout.fromArray(values);
        return undefined;
    }
}
$10b678223f208f49$exports.VariantLayout = $10b678223f208f49$var$VariantLayout;
/** JavaScript chose to define bitwise operations as operating on
 * signed 32-bit values in 2's complement form, meaning any integer
 * with bit 31 set is going to look negative.  For right shifts that's
 * not a problem, because `>>>` is a logical shift, but for every
 * other bitwise operator we have to compensate for possible negative
 * results. */ function $10b678223f208f49$var$fixBitwiseResult(v) {
    if (0 > v) v += 0x100000000;
    return v;
}
/**
 * Contain a sequence of bit fields as an unsigned integer.
 *
 * *Factory*: {@link module:Layout.bits|bits}
 *
 * This is a container element; within it there are {@link BitField}
 * instances that provide the extracted properties.  The container
 * simply defines the aggregate representation and its bit ordering.
 * The representation is an object containing properties with numeric
 * or {@link Boolean} values.
 *
 * {@link BitField}s are added with the {@link
 * BitStructure#addField|addField} and {@link
 * BitStructure#addBoolean|addBoolean} methods.

 * @param {Layout} word - initializer for {@link
 * BitStructure#word|word}.  The parameter must be an instance of
 * {@link UInt} (or {@link UIntBE}) that is no more than 4 bytes wide.
 *
 * @param {bool} [msb] - `true` if the bit numbering starts at the
 * most significant bit of the containing word; `false` (default) if
 * it starts at the least significant bit of the containing word.  If
 * the parameter at this position is a string and `property` is
 * `undefined` the value of this argument will instead be used as the
 * value of `property`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$BitStructure extends $10b678223f208f49$var$Layout {
    constructor(word, msb, property){
        if (!(word instanceof $10b678223f208f49$var$UInt || word instanceof $10b678223f208f49$var$UIntBE)) throw new TypeError("word must be a UInt or UIntBE layout");
        if ("string" === typeof msb && undefined === property) {
            property = msb;
            msb = false;
        }
        if (4 < word.span) throw new RangeError("word cannot exceed 32 bits");
        super(word.span, property);
        /** The layout used for the packed value.  {@link BitField}
         * instances are packed sequentially depending on {@link
         * BitStructure#msb|msb}. */ this.word = word;
        /** Whether the bit sequences are packed starting at the most
         * significant bit growing down (`true`), or the least significant
         * bit growing up (`false`).
         *
         * **NOTE** Regardless of this value, the least significant bit of
         * any {@link BitField} value is the least significant bit of the
         * corresponding section of the packed value. */ this.msb = !!msb;
        /** The sequence of {@link BitField} layouts that comprise the
         * packed structure.
         *
         * **NOTE** The array remains mutable to allow fields to be {@link
         * BitStructure#addField|added} after construction.  Users should
         * not manipulate the content of this property.*/ this.fields = [];
        /* Storage for the value.  Capture a variable instead of using an
         * instance property because we don't want anything to change the
         * value without going through the mutator. */ let value = 0;
        this._packedSetValue = function(v) {
            value = $10b678223f208f49$var$fixBitwiseResult(v);
            return this;
        };
        this._packedGetValue = function() {
            return value;
        };
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) dest[fd.property] = fd.decode(b);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the packed
     * value is left unmodified.  Unused bits are also left unmodified. */ encode(src, b, offset = 0) {
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) {
            const fv = src[fd.property];
            if (undefined !== fv) fd.encode(fv);
        }
        return this.word.encode(this._packedGetValue(), b, offset);
    }
    /** Register a new bitfield with a containing bit structure.  The
     * resulting bitfield is returned.
     *
     * @param {Number} bits - initializer for {@link BitField#bits|bits}.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {BitField} */ addField(bits, property) {
        const bf = new $10b678223f208f49$var$BitField(this, bits, property);
        this.fields.push(bf);
        return bf;
    }
    /** As with {@link BitStructure#addField|addField} for single-bit
     * fields with `boolean` value representation.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {Boolean} */ // `Boolean` conflicts with the native primitive type
    // eslint-disable-next-line @typescript-eslint/ban-types
    addBoolean(property) {
        // This is my Boolean, not the Javascript one.
        const bf = new $10b678223f208f49$var$Boolean(this, property);
        this.fields.push(bf);
        return bf;
    }
    /**
     * Get access to the bit field for a given property.
     *
     * @param {String} property - the bit field of interest.
     *
     * @return {BitField} - the field associated with `property`, or
     * undefined if there is no such property.
     */ fieldFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
}
$10b678223f208f49$exports.BitStructure = $10b678223f208f49$var$BitStructure;
/**
 * Represent a sequence of bits within a {@link BitStructure}.
 *
 * All bit field values are represented as unsigned integers.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addField|addField} helper
 * method.
 *
 * **NOTE** BitField instances are not instances of {@link Layout}
 * since {@link Layout#span|span} measures 8-bit units.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {Number} bits - initializer for {@link BitField#bits|bits}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 */ class $10b678223f208f49$var$BitField {
    constructor(container, bits, property){
        if (!(container instanceof $10b678223f208f49$var$BitStructure)) throw new TypeError("container must be a BitStructure");
        if (!Number.isInteger(bits) || 0 >= bits) throw new TypeError("bits must be positive integer");
        const totalBits = 8 * container.span;
        const usedBits = container.fields.reduce((sum, fd)=>sum + fd.bits, 0);
        if (bits + usedBits > totalBits) throw new Error("bits too long for span remainder (" + (totalBits - usedBits) + " of " + totalBits + " remain)");
        /** The {@link BitStructure} instance to which this bit field
         * belongs. */ this.container = container;
        /** The span of this value in bits. */ this.bits = bits;
        /** A mask of {@link BitField#bits|bits} bits isolating value bits
         * that fit within the field.
         *
         * That is, it masks a value that has not yet been shifted into
         * position within its containing packed integer. */ this.valueMask = (1 << bits) - 1;
        if (32 === bits) this.valueMask = 0xFFFFFFFF;
        /** The offset of the value within the containing packed unsigned
         * integer.  The least significant bit of the packed value is at
         * offset zero, regardless of bit ordering used. */ this.start = usedBits;
        if (this.container.msb) this.start = totalBits - usedBits - bits;
        /** A mask of {@link BitField#bits|bits} isolating the field value
         * within the containing packed unsigned integer. */ this.wordMask = $10b678223f208f49$var$fixBitwiseResult(this.valueMask << this.start);
        /** The property name used when this bitfield is represented in an
         * Object.
         *
         * Intended to be functionally equivalent to {@link
         * Layout#property}.
         *
         * If left undefined the corresponding span of bits will be
         * treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field. */ decode(b, offset) {
        const word = this.container._packedGetValue();
        const wordValue = $10b678223f208f49$var$fixBitwiseResult(word & this.wordMask);
        const value = wordValue >>> this.start;
        return value;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field.
     *
     * **NOTE** This is not a specialization of {@link
     * Layout#encode|Layout.encode} and there is no return value. */ encode(value) {
        if ("number" !== typeof value || !Number.isInteger(value) || value !== $10b678223f208f49$var$fixBitwiseResult(value & this.valueMask)) throw new TypeError($10b678223f208f49$var$nameWithProperty("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
        const word = this.container._packedGetValue();
        const wordValue = $10b678223f208f49$var$fixBitwiseResult(value << this.start);
        this.container._packedSetValue($10b678223f208f49$var$fixBitwiseResult(word & ~this.wordMask) | wordValue);
    }
}
$10b678223f208f49$exports.BitField = $10b678223f208f49$var$BitField;
/**
 * Represent a single bit within a {@link BitStructure} as a
 * JavaScript boolean.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addBoolean|addBoolean} helper
 * method.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {BitField}
 */ /* eslint-disable no-extend-native */ class $10b678223f208f49$var$Boolean extends $10b678223f208f49$var$BitField {
    constructor(container, property){
        super(container, 1, property);
    }
    /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
     *
     * @returns {boolean} */ decode(b, offset) {
        return !!super.decode(b, offset);
    }
    /** @override */ encode(value) {
        if ("boolean" === typeof value) // BitField requires integer values
        value = +value;
        super.encode(value);
    }
}
$10b678223f208f49$exports.Boolean = $10b678223f208f49$var$Boolean;
/* eslint-enable no-extend-native */ /**
 * Contain a fixed-length block of arbitrary data, represented as a
 * Uint8Array.
 *
 * *Factory*: {@link module:Layout.blob|blob}
 *
 * @param {(Number|ExternalLayout)} length - initializes {@link
 * Blob#length|length}.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$Blob extends $10b678223f208f49$var$Layout {
    constructor(length, property){
        if (!(length instanceof $10b678223f208f49$var$ExternalLayout && length.isCount() || Number.isInteger(length) && 0 <= length)) throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(length instanceof $10b678223f208f49$var$ExternalLayout)) span = length;
        super(span, property);
        /** The number of bytes in the blob.
         *
         * This may be a non-negative integer, or an instance of {@link
         * ExternalLayout} that satisfies {@link
         * ExternalLayout#isCount|isCount()}. */ this.length = length;
    }
    /** @override */ getSpan(b, offset) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return $10b678223f208f49$var$uint8ArrayToBuffer(b).slice(offset, offset + span);
    }
    /** Implement {@link Layout#encode|encode} for {@link Blob}.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset) {
        let span = this.length;
        if (this.length instanceof $10b678223f208f49$var$ExternalLayout) span = src.length;
        if (!(src instanceof Uint8Array && span === src.length)) throw new TypeError($10b678223f208f49$var$nameWithProperty("Blob.encode", this) + " requires (length " + span + ") Uint8Array as src");
        if (offset + span > b.length) throw new RangeError("encoding overruns Uint8Array");
        const srcBuffer = $10b678223f208f49$var$uint8ArrayToBuffer(src);
        $10b678223f208f49$var$uint8ArrayToBuffer(b).write(srcBuffer.toString("hex"), offset, span, "hex");
        if (this.length instanceof $10b678223f208f49$var$ExternalLayout) this.length.encode(span, b, offset);
        return span;
    }
}
$10b678223f208f49$exports.Blob = $10b678223f208f49$var$Blob;
/**
 * Contain a `NUL`-terminated UTF8 string.
 *
 * *Factory*: {@link module:Layout.cstr|cstr}
 *
 * **NOTE** Any UTF8 string that incorporates a zero-valued byte will
 * not be correctly decoded by this layout.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$CString extends $10b678223f208f49$var$Layout {
    constructor(property){
        super(-1, property);
    }
    /** @override */ getSpan(b, offset = 0) {
        $10b678223f208f49$var$checkUint8Array(b);
        let idx = offset;
        while(idx < b.length && 0 !== b[idx])idx += 1;
        return 1 + idx - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        return $10b678223f208f49$var$uint8ArrayToBuffer(b).slice(offset, offset + span - 1).toString("utf-8");
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
        const srcb = $lewJ9.Buffer.from(src, "utf8");
        const span = srcb.length;
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        const buffer = $10b678223f208f49$var$uint8ArrayToBuffer(b);
        srcb.copy(buffer, offset);
        buffer[offset + span] = 0;
        return span + 1;
    }
}
$10b678223f208f49$exports.CString = $10b678223f208f49$var$CString;
/**
 * Contain a UTF8 string with implicit length.
 *
 * *Factory*: {@link module:Layout.utf8|utf8}
 *
 * **NOTE** Because the length is implicit in the size of the buffer
 * this layout should be used only in isolation, or in a situation
 * where the length can be expressed by operating on a slice of the
 * containing buffer.
 *
 * @param {Number} [maxSpan] - the maximum length allowed for encoded
 * string content.  If not provided there is no bound on the allowed
 * content.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$UTF8 extends $10b678223f208f49$var$Layout {
    constructor(maxSpan, property){
        if ("string" === typeof maxSpan && undefined === property) {
            property = maxSpan;
            maxSpan = undefined;
        }
        if (undefined === maxSpan) maxSpan = -1;
        else if (!Number.isInteger(maxSpan)) throw new TypeError("maxSpan must be an integer");
        super(-1, property);
        /** The maximum span of the layout in bytes.
         *
         * Positive values are generally expected.  Zero is abnormal.
         * Attempts to encode or decode a value that exceeds this length
         * will throw a `RangeError`.
         *
         * A negative value indicates that there is no bound on the length
         * of the content. */ this.maxSpan = maxSpan;
    }
    /** @override */ getSpan(b, offset = 0) {
        $10b678223f208f49$var$checkUint8Array(b);
        return b.length - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        return $10b678223f208f49$var$uint8ArrayToBuffer(b).slice(offset, offset + span).toString("utf-8");
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
        const srcb = $lewJ9.Buffer.from(src, "utf8");
        const span = srcb.length;
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        srcb.copy($10b678223f208f49$var$uint8ArrayToBuffer(b), offset);
        return span;
    }
}
$10b678223f208f49$exports.UTF8 = $10b678223f208f49$var$UTF8;
/**
 * Contain a constant value.
 *
 * This layout may be used in cases where a JavaScript value can be
 * inferred without an expression in the binary encoding.  An example
 * would be a {@link VariantLayout|variant layout} where the content
 * is implied by the union {@link Union#discriminator|discriminator}.
 *
 * @param {Object|Number|String} value - initializer for {@link
 * Constant#value|value}.  If the value is an object (or array) and
 * the application intends the object to remain unchanged regardless
 * of what is done to values decoded by this layout, the value should
 * be frozen prior passing it to this constructor.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $10b678223f208f49$var$Constant extends $10b678223f208f49$var$Layout {
    constructor(value, property){
        super(0, property);
        /** The value produced by this constant when the layout is {@link
         * Constant#decode|decoded}.
         *
         * Any JavaScript value including `null` and `undefined` is
         * permitted.
         *
         * **WARNING** If `value` passed in the constructor was not
         * frozen, it is possible for users of decoded values to change
         * the content of the value. */ this.value = value;
    }
    /** @override */ decode(b, offset) {
        return this.value;
    }
    /** @override */ encode(src, b, offset) {
        /* Constants take no space */ return 0;
    }
}
$10b678223f208f49$exports.Constant = $10b678223f208f49$var$Constant;
/** Factory for {@link GreedyCount}. */ $10b678223f208f49$exports.greedy = (elementSpan, property)=>new $10b678223f208f49$var$GreedyCount(elementSpan, property);
/** Factory for {@link OffsetLayout}. */ $10b678223f208f49$exports.offset = (layout, offset, property)=>new $10b678223f208f49$var$OffsetLayout(layout, offset, property);
/** Factory for {@link UInt|unsigned int layouts} spanning one
 * byte. */ $10b678223f208f49$exports.u8 = (property)=>new $10b678223f208f49$var$UInt(1, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning two bytes. */ $10b678223f208f49$exports.u16 = (property)=>new $10b678223f208f49$var$UInt(2, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning three bytes. */ $10b678223f208f49$exports.u24 = (property)=>new $10b678223f208f49$var$UInt(3, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning four bytes. */ $10b678223f208f49$exports.u32 = (property)=>new $10b678223f208f49$var$UInt(4, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning five bytes. */ $10b678223f208f49$exports.u40 = (property)=>new $10b678223f208f49$var$UInt(5, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning six bytes. */ $10b678223f208f49$exports.u48 = (property)=>new $10b678223f208f49$var$UInt(6, property);
/** Factory for {@link NearUInt64|little-endian unsigned int
 * layouts} interpreted as Numbers. */ $10b678223f208f49$exports.nu64 = (property)=>new $10b678223f208f49$var$NearUInt64(property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning two bytes. */ $10b678223f208f49$exports.u16be = (property)=>new $10b678223f208f49$var$UIntBE(2, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning three bytes. */ $10b678223f208f49$exports.u24be = (property)=>new $10b678223f208f49$var$UIntBE(3, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning four bytes. */ $10b678223f208f49$exports.u32be = (property)=>new $10b678223f208f49$var$UIntBE(4, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning five bytes. */ $10b678223f208f49$exports.u40be = (property)=>new $10b678223f208f49$var$UIntBE(5, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning six bytes. */ $10b678223f208f49$exports.u48be = (property)=>new $10b678223f208f49$var$UIntBE(6, property);
/** Factory for {@link NearUInt64BE|big-endian unsigned int
 * layouts} interpreted as Numbers. */ $10b678223f208f49$exports.nu64be = (property)=>new $10b678223f208f49$var$NearUInt64BE(property);
/** Factory for {@link Int|signed int layouts} spanning one
 * byte. */ $10b678223f208f49$exports.s8 = (property)=>new $10b678223f208f49$var$Int(1, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning two bytes. */ $10b678223f208f49$exports.s16 = (property)=>new $10b678223f208f49$var$Int(2, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning three bytes. */ $10b678223f208f49$exports.s24 = (property)=>new $10b678223f208f49$var$Int(3, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning four bytes. */ $10b678223f208f49$exports.s32 = (property)=>new $10b678223f208f49$var$Int(4, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning five bytes. */ $10b678223f208f49$exports.s40 = (property)=>new $10b678223f208f49$var$Int(5, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning six bytes. */ $10b678223f208f49$exports.s48 = (property)=>new $10b678223f208f49$var$Int(6, property);
/** Factory for {@link NearInt64|little-endian signed int layouts}
 * interpreted as Numbers. */ $10b678223f208f49$exports.ns64 = (property)=>new $10b678223f208f49$var$NearInt64(property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning two bytes. */ $10b678223f208f49$exports.s16be = (property)=>new $10b678223f208f49$var$IntBE(2, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning three bytes. */ $10b678223f208f49$exports.s24be = (property)=>new $10b678223f208f49$var$IntBE(3, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning four bytes. */ $10b678223f208f49$exports.s32be = (property)=>new $10b678223f208f49$var$IntBE(4, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning five bytes. */ $10b678223f208f49$exports.s40be = (property)=>new $10b678223f208f49$var$IntBE(5, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning six bytes. */ $10b678223f208f49$exports.s48be = (property)=>new $10b678223f208f49$var$IntBE(6, property);
/** Factory for {@link NearInt64BE|big-endian signed int layouts}
 * interpreted as Numbers. */ $10b678223f208f49$exports.ns64be = (property)=>new $10b678223f208f49$var$NearInt64BE(property);
/** Factory for {@link Float|little-endian 32-bit floating point} values. */ $10b678223f208f49$exports.f32 = (property)=>new $10b678223f208f49$var$Float(property);
/** Factory for {@link FloatBE|big-endian 32-bit floating point} values. */ $10b678223f208f49$exports.f32be = (property)=>new $10b678223f208f49$var$FloatBE(property);
/** Factory for {@link Double|little-endian 64-bit floating point} values. */ $10b678223f208f49$exports.f64 = (property)=>new $10b678223f208f49$var$Double(property);
/** Factory for {@link DoubleBE|big-endian 64-bit floating point} values. */ $10b678223f208f49$exports.f64be = (property)=>new $10b678223f208f49$var$DoubleBE(property);
/** Factory for {@link Structure} values. */ $10b678223f208f49$exports.struct = (fields, property, decodePrefixes)=>new $10b678223f208f49$var$Structure(fields, property, decodePrefixes);
/** Factory for {@link BitStructure} values. */ $10b678223f208f49$exports.bits = (word, msb, property)=>new $10b678223f208f49$var$BitStructure(word, msb, property);
/** Factory for {@link Sequence} values. */ $10b678223f208f49$exports.seq = (elementLayout, count, property)=>new $10b678223f208f49$var$Sequence(elementLayout, count, property);
/** Factory for {@link Union} values. */ $10b678223f208f49$exports.union = (discr, defaultLayout, property)=>new $10b678223f208f49$var$Union(discr, defaultLayout, property);
/** Factory for {@link UnionLayoutDiscriminator} values. */ $10b678223f208f49$exports.unionLayoutDiscriminator = (layout, property)=>new $10b678223f208f49$var$UnionLayoutDiscriminator(layout, property);
/** Factory for {@link Blob} values. */ $10b678223f208f49$exports.blob = (length, property)=>new $10b678223f208f49$var$Blob(length, property);
/** Factory for {@link CString} values. */ $10b678223f208f49$exports.cstr = (property)=>new $10b678223f208f49$var$CString(property);
/** Factory for {@link UTF8} values. */ $10b678223f208f49$exports.utf8 = (maxSpan, property)=>new $10b678223f208f49$var$UTF8(maxSpan, property);
/** Factory for {@link Constant} values. */ $10b678223f208f49$exports.constant = (value, property)=>new $10b678223f208f49$var$Constant(value, property);


// src/codes.ts
var $68590ac3373b9249$export$637a712014b81b9c = 1;
var $68590ac3373b9249$export$2b45309b0547a9c4 = 2;
var $68590ac3373b9249$export$7cf14cde1226b7cb = 3;
var $68590ac3373b9249$export$6ad19ea5e363a944 = 4;
var $68590ac3373b9249$export$c37fe345cc9b38e7 = 5;
var $68590ac3373b9249$export$cf7b28c4ea07497b = 6;
var $68590ac3373b9249$export$e8ff0c73a3d6800d = 7;
var $68590ac3373b9249$export$7dd7d17f1f93a166 = 8;
var $68590ac3373b9249$export$8b23617676679e2d = 9;
var $68590ac3373b9249$export$1cf7bba40d7d2361 = 10;
var $68590ac3373b9249$export$e09e3905081e44fe = -32700;
var $68590ac3373b9249$export$afa40fd3fc01204 = -32603;
var $68590ac3373b9249$export$2981978a530b1a7c = -32602;
var $68590ac3373b9249$export$5ec955cc8b7e8cf9 = -32601;
var $68590ac3373b9249$export$23cb4efd59427895 = -32600;
var $68590ac3373b9249$export$4f93db3d1b48599e = -32016;
var $68590ac3373b9249$export$f7685139153f9191 = -32015;
var $68590ac3373b9249$export$65235469ebe9845e = -32014;
var $68590ac3373b9249$export$bdeebdca616ef1f3 = -32013;
var $68590ac3373b9249$export$1b90c411626421b1 = -32012;
var $68590ac3373b9249$export$8e678bf9b4e5cb64 = -32011;
var $68590ac3373b9249$export$54dea2286c43ec1e = -32010;
var $68590ac3373b9249$export$e71fbee92648fc61 = -32009;
var $68590ac3373b9249$export$eb4f7515ff6aa19d = -32008;
var $68590ac3373b9249$export$d21075fd06730e = -32007;
var $68590ac3373b9249$export$d964b43bb02eacdf = -32006;
var $68590ac3373b9249$export$6bad0f4fb625ae6e = -32005;
var $68590ac3373b9249$export$bfbf8b75e865efa0 = -32004;
var $68590ac3373b9249$export$83dce8c0aef70463 = -32003;
var $68590ac3373b9249$export$426cc73f5ad00f38 = -32002;
var $68590ac3373b9249$export$6ae475e85fe02aad = -32001;
var $68590ac3373b9249$export$fe284a92110eab86 = 28e5;
var $68590ac3373b9249$export$8aae3518bf4ea38c = 2800001;
var $68590ac3373b9249$export$e31a90a3bf6aebaa = 2800002;
var $68590ac3373b9249$export$adaec66b544981e7 = 2800003;
var $68590ac3373b9249$export$523a769cce7318bf = 2800004;
var $68590ac3373b9249$export$68473acf744cabf5 = 2800005;
var $68590ac3373b9249$export$940d17d3b63dba7c = 2800006;
var $68590ac3373b9249$export$a1cf857da540ee2e = 2800007;
var $68590ac3373b9249$export$30501b98da9564bb = 2800008;
var $68590ac3373b9249$export$123d01dd469dc2ef = 2800009;
var $68590ac3373b9249$export$2a7684440f52314e = 2800010;
var $68590ac3373b9249$export$8f39956700e64760 = 323e4;
var $68590ac3373b9249$export$1239089c4564c858 = 32300001;
var $68590ac3373b9249$export$afc08ee11abbc257 = 3230002;
var $68590ac3373b9249$export$57836d13a84f54b0 = 3230003;
var $68590ac3373b9249$export$f080cd056a56cd54 = 3230004;
var $68590ac3373b9249$export$f2bbb3c14e29977e = 361e4;
var $68590ac3373b9249$export$f18173f573d8bb21 = 3610001;
var $68590ac3373b9249$export$7ad09900bd645a86 = 3610002;
var $68590ac3373b9249$export$69c08c51e1841f29 = 3610003;
var $68590ac3373b9249$export$325dad4e0a6bd514 = 3610004;
var $68590ac3373b9249$export$242c341c7c464bee = 3610005;
var $68590ac3373b9249$export$a73c064bb32a7c36 = 3610006;
var $68590ac3373b9249$export$b6497aaa1c3cb4a7 = 3610007;
var $68590ac3373b9249$export$bc2b26beee0f9a0b = 3611e3;
var $68590ac3373b9249$export$bc1242deaa4d848d = 3704e3;
var $68590ac3373b9249$export$44352af09ecae39f = 3704001;
var $68590ac3373b9249$export$d2a0e93e506be463 = 3704002;
var $68590ac3373b9249$export$bbe4ed5687bc7f55 = 3704003;
var $68590ac3373b9249$export$436df06ce5af77b3 = 3704004;
var $68590ac3373b9249$export$552eeff1216c4a1e = 4128e3;
var $68590ac3373b9249$export$b260fc8c8d3cde52 = 4128001;
var $68590ac3373b9249$export$b81e507604713b9b = 4128002;
var $68590ac3373b9249$export$d308cb6df5c28ff6 = 4615e3;
var $68590ac3373b9249$export$ab2273c84ffc5d61 = 4615001;
var $68590ac3373b9249$export$23cc359156888c7f = 4615002;
var $68590ac3373b9249$export$a4193356408e9ff0 = 4615003;
var $68590ac3373b9249$export$f9ae264f831e3bcf = 4615004;
var $68590ac3373b9249$export$e170b44d99a3d17c = 4615005;
var $68590ac3373b9249$export$84ec8e94b54ae7d2 = 4615006;
var $68590ac3373b9249$export$4063fe8d5aed84a5 = 4615007;
var $68590ac3373b9249$export$ecdd3388f6a493b1 = 4615008;
var $68590ac3373b9249$export$df0a6d6cbb0d96a1 = 4615009;
var $68590ac3373b9249$export$e45bdcd5a97f01d1 = 4615010;
var $68590ac3373b9249$export$c2bfe7e903a0febb = 4615011;
var $68590ac3373b9249$export$fa2d8ac69bd6117e = 4615012;
var $68590ac3373b9249$export$2b7e7e6bd3d5b8c4 = 4615013;
var $68590ac3373b9249$export$72e64aed285de589 = 4615014;
var $68590ac3373b9249$export$95d7c72146ee65c6 = 4615015;
var $68590ac3373b9249$export$aa03f185732dc00b = 4615016;
var $68590ac3373b9249$export$c390f45549d7336b = 4615017;
var $68590ac3373b9249$export$2ea2f2f9a9e26449 = 4615018;
var $68590ac3373b9249$export$c9ece88629d0d2d8 = 4615019;
var $68590ac3373b9249$export$2f331454431511bf = 4615020;
var $68590ac3373b9249$export$3c4b9377ed4116a0 = 4615021;
var $68590ac3373b9249$export$211b990ef3bd19ce = 4615022;
var $68590ac3373b9249$export$ef486e0fcc8262b = 4615023;
var $68590ac3373b9249$export$afcb9eeb4bf056b5 = 4615024;
var $68590ac3373b9249$export$4db39a3a67e51db2 = 4615025;
var $68590ac3373b9249$export$5abe2d1d040bf6cf = 4615026;
var $68590ac3373b9249$export$35a7a209cf9aaee8 = 4615027;
var $68590ac3373b9249$export$203fce7ce63eb278 = 4615028;
var $68590ac3373b9249$export$c65d87b69a4b86e5 = 4615029;
var $68590ac3373b9249$export$d13686e596713674 = 4615030;
var $68590ac3373b9249$export$a070310f29fe959b = 4615031;
var $68590ac3373b9249$export$8eb8ce58a8afa4d8 = 4615032;
var $68590ac3373b9249$export$1224afa7bd705d3d = 4615033;
var $68590ac3373b9249$export$547fdb4fff65c547 = 4615034;
var $68590ac3373b9249$export$cbeea52e947eb081 = 4615035;
var $68590ac3373b9249$export$fd7a98f0746b6c8a = 4615036;
var $68590ac3373b9249$export$8e6d399c8fb88eaa = 4615037;
var $68590ac3373b9249$export$2c001ce75e66180d = 4615038;
var $68590ac3373b9249$export$ec7d592dad68aa12 = 4615039;
var $68590ac3373b9249$export$8815da3ec592d05a = 4615040;
var $68590ac3373b9249$export$b1b9bf899899a525 = 4615041;
var $68590ac3373b9249$export$67715a67add5645f = 4615042;
var $68590ac3373b9249$export$e343a153899b82e9 = 4615043;
var $68590ac3373b9249$export$2199fb95c7d85b85 = 4615044;
var $68590ac3373b9249$export$57c1675a0c20931f = 4615045;
var $68590ac3373b9249$export$9e62f446da191370 = 4615046;
var $68590ac3373b9249$export$b5ccaf975fe486a0 = 4615047;
var $68590ac3373b9249$export$4d39d4c2f04b41a8 = 4615048;
var $68590ac3373b9249$export$1997554dc67e9c4e = 4615049;
var $68590ac3373b9249$export$8a65209e9cece2cd = 4615050;
var $68590ac3373b9249$export$6b675123aa59300c = 4615051;
var $68590ac3373b9249$export$70b4e2dd1496c5a3 = 4615052;
var $68590ac3373b9249$export$43d5111034db211a = 4615053;
var $68590ac3373b9249$export$8aebe3e76f515046 = 4615054;
var $68590ac3373b9249$export$ee84b29a9985e516 = 5508e3;
var $68590ac3373b9249$export$9998b265c986beaa = 5508001;
var $68590ac3373b9249$export$dd792e9d67cd031b = 5508002;
var $68590ac3373b9249$export$14d32fbdad2233cd = 5508003;
var $68590ac3373b9249$export$8c6fc1cfcec8440c = 5508004;
var $68590ac3373b9249$export$dcec7171cff295d1 = 5508005;
var $68590ac3373b9249$export$200acbfc722e322b = 5508006;
var $68590ac3373b9249$export$4c96d9a95880ae4b = 5508007;
var $68590ac3373b9249$export$bba76b21ada319a5 = 5508008;
var $68590ac3373b9249$export$3cb3b480d2bfdacc = 5508009;
var $68590ac3373b9249$export$1f5fbaa83776feec = 5508010;
var $68590ac3373b9249$export$1d51c4c8b2c49e09 = 5508011;
var $68590ac3373b9249$export$694fd435994bcca = 5663e3;
var $68590ac3373b9249$export$707576ec00ca24d6 = 5663001;
var $68590ac3373b9249$export$e33d07a7526bded0 = 5663002;
var $68590ac3373b9249$export$a20747f749dd4515 = 5663003;
var $68590ac3373b9249$export$3963d9bca4091810 = 5663004;
var $68590ac3373b9249$export$b34a16b8adbffdc1 = 5663005;
var $68590ac3373b9249$export$3764bbcfb0679211 = 5663006;
var $68590ac3373b9249$export$ed2bdee7953e467f = 5663007;
var $68590ac3373b9249$export$11bea4440904349c = 5663008;
var $68590ac3373b9249$export$6d61b980429516bd = 5663009;
var $68590ac3373b9249$export$819b1b0603d2a966 = 5663010;
var $68590ac3373b9249$export$592862d1b11e32ac = 5663011;
var $68590ac3373b9249$export$242af5597d94abaf = 5663012;
var $68590ac3373b9249$export$802b3ebe5297e360 = 5663013;
var $68590ac3373b9249$export$bed6f92dafea0623 = 5663014;
var $68590ac3373b9249$export$36c2547c3c4d823f = 5663015;
var $68590ac3373b9249$export$de92784c954d1b84 = 5663016;
var $68590ac3373b9249$export$b55a3eb3d894ad9f = 5663017;
var $68590ac3373b9249$export$4e4582c633fc423e = 5663018;
var $68590ac3373b9249$export$923893d5c076a47c = 5663019;
var $68590ac3373b9249$export$8c82dde5b12c9789 = 705e4;
var $68590ac3373b9249$export$a746609ecc2f6acf = 7050001;
var $68590ac3373b9249$export$c4d8217d3eb3eaf8 = 7050002;
var $68590ac3373b9249$export$5d0f06cd8bc8e3af = 7050003;
var $68590ac3373b9249$export$83c8fe2717d1b271 = 7050004;
var $68590ac3373b9249$export$39ead28cf48a604c = 7050005;
var $68590ac3373b9249$export$624f65633216eb57 = 7050006;
var $68590ac3373b9249$export$2bbd9403cb117ea7 = 7050007;
var $68590ac3373b9249$export$e108dd5343c4c11 = 7050008;
var $68590ac3373b9249$export$a504ed6cab09ce4a = 7050009;
var $68590ac3373b9249$export$8c1ae05eccc11ef9 = 7050010;
var $68590ac3373b9249$export$47df44101c6f04b0 = 7050011;
var $68590ac3373b9249$export$89ae0c424691fbcb = 7050012;
var $68590ac3373b9249$export$bea5f92951bc42e7 = 7050013;
var $68590ac3373b9249$export$91a668e132084ecf = 7050014;
var $68590ac3373b9249$export$211b9b84186690f0 = 7050015;
var $68590ac3373b9249$export$291ea8d5a7496fde = 7050016;
var $68590ac3373b9249$export$5f027a86397cba92 = 7050017;
var $68590ac3373b9249$export$58bf90c73afbc02e = 7050018;
var $68590ac3373b9249$export$b8b2610c9a910763 = 7050019;
var $68590ac3373b9249$export$fb693aebffa32676 = 7050020;
var $68590ac3373b9249$export$572954173bc64b66 = 7050021;
var $68590ac3373b9249$export$fa9a13f1b40ee2fb = 7050022;
var $68590ac3373b9249$export$95c94f6ea500f1ab = 7050023;
var $68590ac3373b9249$export$11d69fb6993b2cf5 = 7050024;
var $68590ac3373b9249$export$bd54a9a85614b3a7 = 7050025;
var $68590ac3373b9249$export$df4ef1824fd194a3 = 7050026;
var $68590ac3373b9249$export$2725d50dd432fb3a = 7050027;
var $68590ac3373b9249$export$41f13726b04d8d05 = 7050028;
var $68590ac3373b9249$export$7b4a7eebff68ca7b = 7050029;
var $68590ac3373b9249$export$e3a4007020a2e8f5 = 7050030;
var $68590ac3373b9249$export$2ecc275dffbc087c = 7050031;
var $68590ac3373b9249$export$e3289c5954208202 = 7050032;
var $68590ac3373b9249$export$3569c6c71e349538 = 7050033;
var $68590ac3373b9249$export$4f413e02d5e82221 = 7050034;
var $68590ac3373b9249$export$1cd0de5dfcdeb99d = 7050035;
var $68590ac3373b9249$export$87e01307d368f511 = 7050036;
var $68590ac3373b9249$export$9c9326ce1e3df40c = 8078e3;
var $68590ac3373b9249$export$18fbf24f19efc69b = 8078001;
var $68590ac3373b9249$export$93561b31b951410d = 8078002;
var $68590ac3373b9249$export$3417da5bc6bcb45 = 8078003;
var $68590ac3373b9249$export$c4c73ab3c0833591 = 8078004;
var $68590ac3373b9249$export$824d79ab1779d517 = 8078005;
var $68590ac3373b9249$export$c464f3b291f1f3d0 = 8078006;
var $68590ac3373b9249$export$c04710d31ef4d278 = 8078007;
var $68590ac3373b9249$export$1fa107ead8489cf2 = 8078008;
var $68590ac3373b9249$export$2bb0703affb8fe68 = 8078009;
var $68590ac3373b9249$export$f6bf8a7c1f3defe4 = 8078010;
var $68590ac3373b9249$export$8653c145864f47f4 = 8078011;
var $68590ac3373b9249$export$89b582b06852d433 = 8078012;
var $68590ac3373b9249$export$4c1fcb4bd20b2951 = 8078013;
var $68590ac3373b9249$export$a617dff403944ec6 = 8078014;
var $68590ac3373b9249$export$c89f43f0d783cd50 = 8078015;
var $68590ac3373b9249$export$f73fb8ecbd4b2395 = 8078016;
var $68590ac3373b9249$export$efbd199de191d2aa = 8078017;
var $68590ac3373b9249$export$cb77f5a0f0fa7f18 = 8078018;
var $68590ac3373b9249$export$47278510a511031b = 8078019;
var $68590ac3373b9249$export$a9282ed13660c9f6 = 8078020;
var $68590ac3373b9249$export$5bdfee6423bc35ce = 8078021;
var $68590ac3373b9249$export$a2e9526594022372 = 8078022;
var $68590ac3373b9249$export$ef742b7036fb9005 = 81e5;
var $68590ac3373b9249$export$2a2f0f75708d1697 = 8100001;
var $68590ac3373b9249$export$7f6822f75edb8f41 = 8100002;
var $68590ac3373b9249$export$119023a74b281384 = 8100003;
var $68590ac3373b9249$export$c32108b180210fc5 = 819e4;
var $68590ac3373b9249$export$e1a3658b043aad8e = 8190001;
var $68590ac3373b9249$export$ae8da83a78732501 = 8190002;
var $68590ac3373b9249$export$73f01f46f9a97cf0 = 8190003;
var $68590ac3373b9249$export$5293460f390d6127 = 8190004;
var $68590ac3373b9249$export$a12ca71185bd51db = 99e5;
var $68590ac3373b9249$export$d5b3c70e0e0f470a = 9900001;
var $68590ac3373b9249$export$b57ffff6ec11f63 = 9900002;
var $68590ac3373b9249$export$6fe73388375373f = 9900003;
var $68590ac3373b9249$export$8b0d360227f3435e = 9900004;
// src/context.ts
function $68590ac3373b9249$var$encodeValue(value) {
    if (Array.isArray(value)) {
        const commaSeparatedValues = value.map($68590ac3373b9249$var$encodeValue).join("%2C%20");
        return "%5B" + commaSeparatedValues + /* "]" */ "%5D";
    } else if (typeof value === "bigint") return `${value}n`;
    else return encodeURIComponent(String(value != null && Object.getPrototypeOf(value) === null ? // Plain objects with no prototype don't have a `toString` method.
    // Convert them before stringifying them.
    {
        ...value
    } : value));
}
function $68590ac3373b9249$var$encodeObjectContextEntry([key, value]) {
    return `${key}=${$68590ac3373b9249$var$encodeValue(value)}`;
}
function $68590ac3373b9249$var$encodeContextObject(context) {
    const searchParamsString = Object.entries(context).map($68590ac3373b9249$var$encodeObjectContextEntry).join("&");
    return btoa(searchParamsString);
}
// src/messages.ts
var $68590ac3373b9249$var$SolanaErrorMessages = {
    [$68590ac3373b9249$export$8f39956700e64760]: "Account not found at address: $address",
    [$68590ac3373b9249$export$f080cd056a56cd54]: "Not all accounts were decoded. Encoded accounts found at addresses: $addresses.",
    [$68590ac3373b9249$export$57836d13a84f54b0]: "Expected decoded account at address: $address",
    [$68590ac3373b9249$export$afc08ee11abbc257]: "Failed to decode account data at address: $address",
    [$68590ac3373b9249$export$1239089c4564c858]: "Accounts not found at addresses: $addresses",
    [$68590ac3373b9249$export$123d01dd469dc2ef]: "Unable to find a viable program address bump seed.",
    [$68590ac3373b9249$export$e31a90a3bf6aebaa]: "$putativeAddress is not a base58-encoded address.",
    [$68590ac3373b9249$export$fe284a92110eab86]: "Expected base58 encoded address to decode to a byte array of length 32. Actual length: $actualLength.",
    [$68590ac3373b9249$export$adaec66b544981e7]: "The `CryptoKey` must be an `Ed25519` public key.",
    [$68590ac3373b9249$export$30501b98da9564bb]: "Invalid seeds; point must fall off the Ed25519 curve.",
    [$68590ac3373b9249$export$523a769cce7318bf]: "Expected given program derived address to have the following format: [Address, ProgramDerivedAddressBump].",
    [$68590ac3373b9249$export$940d17d3b63dba7c]: "A maximum of $maxSeeds seeds, including the bump seed, may be supplied when creating an address. Received: $actual.",
    [$68590ac3373b9249$export$a1cf857da540ee2e]: "The seed at index $index with length $actual exceeds the maximum length of $maxSeedLength bytes.",
    [$68590ac3373b9249$export$68473acf744cabf5]: "Expected program derived address bump to be in the range [0, 255], got: $bump.",
    [$68590ac3373b9249$export$2a7684440f52314e]: "Program address cannot end with PDA marker.",
    [$68590ac3373b9249$export$8aae3518bf4ea38c]: "Expected base58-encoded address string of length in the range [32, 44]. Actual length: $actualLength.",
    [$68590ac3373b9249$export$6ad19ea5e363a944]: "Expected base58-encoded blockash string of length in the range [32, 44]. Actual length: $actualLength.",
    [$68590ac3373b9249$export$637a712014b81b9c]: "The network has progressed past the last block for which this transaction could have been committed.",
    [$68590ac3373b9249$export$9c9326ce1e3df40c]: "Codec [$codecDescription] cannot decode empty byte arrays.",
    [$68590ac3373b9249$export$a2e9526594022372]: "Enum codec cannot use lexical values [$stringValues] as discriminators. Either remove all lexical values or set `useValuesAsDiscriminators` to `false`.",
    [$68590ac3373b9249$export$a9282ed13660c9f6]: "Sentinel [$hexSentinel] must not be present in encoded bytes [$hexEncodedBytes].",
    [$68590ac3373b9249$export$824d79ab1779d517]: "Encoder and decoder must have the same fixed size, got [$encoderFixedSize] and [$decoderFixedSize].",
    [$68590ac3373b9249$export$c464f3b291f1f3d0]: "Encoder and decoder must have the same max size, got [$encoderMaxSize] and [$decoderMaxSize].",
    [$68590ac3373b9249$export$c4c73ab3c0833591]: "Encoder and decoder must either both be fixed-size or variable-size.",
    [$68590ac3373b9249$export$1fa107ead8489cf2]: "Enum discriminator out of range. Expected a number in [$formattedValidDiscriminators], got $discriminator.",
    [$68590ac3373b9249$export$93561b31b951410d]: "Expected a fixed-size codec, got a variable-size one.",
    [$68590ac3373b9249$export$4c1fcb4bd20b2951]: "Codec [$codecDescription] expected a positive byte length, got $bytesLength.",
    [$68590ac3373b9249$export$3417da5bc6bcb45]: "Expected a variable-size codec, got a fixed-size one.",
    [$68590ac3373b9249$export$47278510a511031b]: "Codec [$codecDescription] expected zero-value [$hexZeroValue] to have the same size as the provided fixed-size item [$expectedSize bytes].",
    [$68590ac3373b9249$export$18fbf24f19efc69b]: "Codec [$codecDescription] expected $expected bytes, got $bytesLength.",
    [$68590ac3373b9249$export$cb77f5a0f0fa7f18]: "Expected byte array constant [$hexConstant] to be present in data [$hexData] at offset [$offset].",
    [$68590ac3373b9249$export$2bb0703affb8fe68]: "Invalid discriminated union variant. Expected one of [$variants], got $value.",
    [$68590ac3373b9249$export$f6bf8a7c1f3defe4]: "Invalid enum variant. Expected one of [$stringValues] or a number in [$formattedNumericalValues], got $variant.",
    [$68590ac3373b9249$export$c89f43f0d783cd50]: "Invalid literal union variant. Expected one of [$variants], got $value.",
    [$68590ac3373b9249$export$c04710d31ef4d278]: "Expected [$codecDescription] to have $expected items, got $actual.",
    [$68590ac3373b9249$export$89b582b06852d433]: "Invalid value $value for base $base with alphabet $alphabet.",
    [$68590ac3373b9249$export$f73fb8ecbd4b2395]: "Literal union discriminator out of range. Expected a number between $minRange and $maxRange, got $discriminator.",
    [$68590ac3373b9249$export$8653c145864f47f4]: "Codec [$codecDescription] expected number to be in the range [$min, $max], got $value.",
    [$68590ac3373b9249$export$a617dff403944ec6]: "Codec [$codecDescription] expected offset to be in the range [0, $bytesLength], got $offset.",
    [$68590ac3373b9249$export$5bdfee6423bc35ce]: "Expected sentinel [$hexSentinel] to be present in decoded bytes [$hexDecodedBytes].",
    [$68590ac3373b9249$export$efbd199de191d2aa]: "Union variant out of range. Expected an index between $minRange and $maxRange, got $variant.",
    [$68590ac3373b9249$export$bc2b26beee0f9a0b]: "No random values implementation could be found.",
    [$68590ac3373b9249$export$df0a6d6cbb0d96a1]: "instruction requires an uninitialized account",
    [$68590ac3373b9249$export$ef486e0fcc8262b]: "instruction tries to borrow reference for an account which is already borrowed",
    [$68590ac3373b9249$export$afcb9eeb4bf056b5]: "instruction left account with an outstanding borrowed reference",
    [$68590ac3373b9249$export$3c4b9377ed4116a0]: "program other than the account's owner changed the size of the account data",
    [$68590ac3373b9249$export$e170b44d99a3d17c]: "account data too small for instruction",
    [$68590ac3373b9249$export$211b990ef3bd19ce]: "instruction expected an executable account",
    [$68590ac3373b9249$export$9e62f446da191370]: "An account does not have enough lamports to be rent-exempt",
    [$68590ac3373b9249$export$4d39d4c2f04b41a8]: "Program arithmetic overflowed",
    [$68590ac3373b9249$export$57c1675a0c20931f]: "Failed to serialize or deserialize account data: $encodedData",
    [$68590ac3373b9249$export$8aebe3e76f515046]: "Builtin programs must consume compute units",
    [$68590ac3373b9249$export$8eb8ce58a8afa4d8]: "Cross-program invocation call depth too deep",
    [$68590ac3373b9249$export$2c001ce75e66180d]: "Computational budget exceeded",
    [$68590ac3373b9249$export$5abe2d1d040bf6cf]: "custom program error: #$code",
    [$68590ac3373b9249$export$c390f45549d7336b]: "instruction contains duplicate accounts",
    [$68590ac3373b9249$export$4db39a3a67e51db2]: "instruction modifications of multiply-passed account differ",
    [$68590ac3373b9249$export$d13686e596713674]: "executable accounts must be rent exempt",
    [$68590ac3373b9249$export$203fce7ce63eb278]: "instruction changed executable accounts data",
    [$68590ac3373b9249$export$c65d87b69a4b86e5]: "instruction changed the balance of an executable account",
    [$68590ac3373b9249$export$2ea2f2f9a9e26449]: "instruction changed executable bit of an account",
    [$68590ac3373b9249$export$72e64aed285de589]: "instruction modified data of an account it does not own",
    [$68590ac3373b9249$export$2b7e7e6bd3d5b8c4]: "instruction spent from the balance of an account it does not own",
    [$68590ac3373b9249$export$ab2273c84ffc5d61]: "generic instruction error",
    [$68590ac3373b9249$export$8a65209e9cece2cd]: "Provided owner is not allowed",
    [$68590ac3373b9249$export$e343a153899b82e9]: "Account is immutable",
    [$68590ac3373b9249$export$2199fb95c7d85b85]: "Incorrect authority provided",
    [$68590ac3373b9249$export$4063fe8d5aed84a5]: "incorrect program id for instruction",
    [$68590ac3373b9249$export$84ec8e94b54ae7d2]: "insufficient funds for instruction",
    [$68590ac3373b9249$export$f9ae264f831e3bcf]: "invalid account data for instruction",
    [$68590ac3373b9249$export$b5ccaf975fe486a0]: "Invalid account owner",
    [$68590ac3373b9249$export$23cc359156888c7f]: "invalid program argument",
    [$68590ac3373b9249$export$35a7a209cf9aaee8]: "program returned invalid error code",
    [$68590ac3373b9249$export$a4193356408e9ff0]: "invalid instruction data",
    [$68590ac3373b9249$export$8e6d399c8fb88eaa]: "Failed to reallocate account data",
    [$68590ac3373b9249$export$fd7a98f0746b6c8a]: "Provided seeds do not result in a valid address",
    [$68590ac3373b9249$export$6b675123aa59300c]: "Accounts data allocations exceeded the maximum allowed per transaction",
    [$68590ac3373b9249$export$70b4e2dd1496c5a3]: "Max accounts exceeded",
    [$68590ac3373b9249$export$43d5111034db211a]: "Max instruction trace length exceeded",
    [$68590ac3373b9249$export$cbeea52e947eb081]: "Length of the seed is too long for address generation",
    [$68590ac3373b9249$export$1224afa7bd705d3d]: "An account required by the instruction is missing",
    [$68590ac3373b9249$export$ecdd3388f6a493b1]: "missing required signature for instruction",
    [$68590ac3373b9249$export$fa2d8ac69bd6117e]: "instruction illegally modified the program id of an account",
    [$68590ac3373b9249$export$2f331454431511bf]: "insufficient account keys for instruction",
    [$68590ac3373b9249$export$ec7d592dad68aa12]: "Cross-program invocation with unauthorized signer or writable account",
    [$68590ac3373b9249$export$8815da3ec592d05a]: "Failed to create program execution environment",
    [$68590ac3373b9249$export$67715a67add5645f]: "Program failed to compile",
    [$68590ac3373b9249$export$b1b9bf899899a525]: "Program failed to complete",
    [$68590ac3373b9249$export$aa03f185732dc00b]: "instruction modified data of a read-only account",
    [$68590ac3373b9249$export$95d7c72146ee65c6]: "instruction changed the balance of a read-only account",
    [$68590ac3373b9249$export$547fdb4fff65c547]: "Cross-program invocation reentrancy not allowed for this instruction",
    [$68590ac3373b9249$export$c9ece88629d0d2d8]: "instruction modified rent epoch of an account",
    [$68590ac3373b9249$export$c2bfe7e903a0febb]: "sum of account balances before and after instruction do not match",
    [$68590ac3373b9249$export$e45bdcd5a97f01d1]: "instruction requires an initialized account",
    [$68590ac3373b9249$export$d308cb6df5c28ff6]: "",
    [$68590ac3373b9249$export$a070310f29fe959b]: "Unsupported program id",
    [$68590ac3373b9249$export$1997554dc67e9c4e]: "Unsupported sysvar",
    [$68590ac3373b9249$export$552eeff1216c4a1e]: "The instruction does not have any accounts.",
    [$68590ac3373b9249$export$b260fc8c8d3cde52]: "The instruction does not have any data.",
    [$68590ac3373b9249$export$b81e507604713b9b]: "Expected instruction to have progress address $expectedProgramAddress, got $actualProgramAddress.",
    [$68590ac3373b9249$export$c37fe345cc9b38e7]: "Expected base58 encoded blockhash to decode to a byte array of length 32. Actual length: $actualLength.",
    [$68590ac3373b9249$export$2b45309b0547a9c4]: "The nonce `$expectedNonceValue` is no longer valid. It has advanced to `$actualNonceValue`",
    [$68590ac3373b9249$export$b57ffff6ec11f63]: "Invariant violation: Found no abortable iterable cache entry for key `$cacheKey`. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$68590ac3373b9249$export$8b0d360227f3435e]: "Invariant violation: This data publisher does not publish to the channel named `$channelName`. Supported channels include $supportedChannelNames.",
    [$68590ac3373b9249$export$d5b3c70e0e0f470a]: "Invariant violation: WebSocket message iterator state is corrupt; iterated without first resolving existing message promise. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$68590ac3373b9249$export$a12ca71185bd51db]: "Invariant violation: WebSocket message iterator is missing state storage. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$68590ac3373b9249$export$6fe73388375373f]: "Invariant violation: Switch statement non-exhaustive. Received unexpected value `$unexpectedValue`. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$68590ac3373b9249$export$afa40fd3fc01204]: "JSON-RPC error: Internal JSON-RPC error ($__serverMessage)",
    [$68590ac3373b9249$export$2981978a530b1a7c]: "JSON-RPC error: Invalid method parameter(s) ($__serverMessage)",
    [$68590ac3373b9249$export$23cb4efd59427895]: "JSON-RPC error: The JSON sent is not a valid `Request` object ($__serverMessage)",
    [$68590ac3373b9249$export$5ec955cc8b7e8cf9]: "JSON-RPC error: The method does not exist / is not available ($__serverMessage)",
    [$68590ac3373b9249$export$e09e3905081e44fe]: "JSON-RPC error: An error occurred on the server while parsing the JSON text ($__serverMessage)",
    [$68590ac3373b9249$export$1b90c411626421b1]: "$__serverMessage",
    [$68590ac3373b9249$export$6ae475e85fe02aad]: "$__serverMessage",
    [$68590ac3373b9249$export$bfbf8b75e865efa0]: "$__serverMessage",
    [$68590ac3373b9249$export$65235469ebe9845e]: "$__serverMessage",
    [$68590ac3373b9249$export$54dea2286c43ec1e]: "$__serverMessage",
    [$68590ac3373b9249$export$e71fbee92648fc61]: "$__serverMessage",
    [$68590ac3373b9249$export$4f93db3d1b48599e]: "Minimum context slot has not been reached",
    [$68590ac3373b9249$export$6bad0f4fb625ae6e]: "Node is unhealthy; behind by $numSlotsBehind slots",
    [$68590ac3373b9249$export$eb4f7515ff6aa19d]: "No snapshot",
    [$68590ac3373b9249$export$426cc73f5ad00f38]: "Transaction simulation failed",
    [$68590ac3373b9249$export$d21075fd06730e]: "$__serverMessage",
    [$68590ac3373b9249$export$8e678bf9b4e5cb64]: "Transaction history is not available from this node",
    [$68590ac3373b9249$export$d964b43bb02eacdf]: "$__serverMessage",
    [$68590ac3373b9249$export$bdeebdca616ef1f3]: "Transaction signature length mismatch",
    [$68590ac3373b9249$export$83dce8c0aef70463]: "Transaction signature verification failure",
    [$68590ac3373b9249$export$f7685139153f9191]: "$__serverMessage",
    [$68590ac3373b9249$export$bc1242deaa4d848d]: "Key pair bytes must be of length 64, got $byteLength.",
    [$68590ac3373b9249$export$44352af09ecae39f]: "Expected private key bytes with length 32. Actual length: $actualLength.",
    [$68590ac3373b9249$export$d2a0e93e506be463]: "Expected base58-encoded signature to decode to a byte array of length 64. Actual length: $actualLength.",
    [$68590ac3373b9249$export$436df06ce5af77b3]: "The provided private key does not match the provided public key.",
    [$68590ac3373b9249$export$bbe4ed5687bc7f55]: "Expected base58-encoded signature string of length in the range [64, 88]. Actual length: $actualLength.",
    [$68590ac3373b9249$export$cf7b28c4ea07497b]: "Lamports value must be in the range [0, 2e64-1]",
    [$68590ac3373b9249$export$e8ff0c73a3d6800d]: "`$value` cannot be parsed as a `BigInt`",
    [$68590ac3373b9249$export$1cf7bba40d7d2361]: "$message",
    [$68590ac3373b9249$export$7dd7d17f1f93a166]: "`$value` cannot be parsed as a `Number`",
    [$68590ac3373b9249$export$7cf14cde1226b7cb]: "No nonce account could be found at address `$nonceAccountAddress`",
    [$68590ac3373b9249$export$c32108b180210fc5]: "The notification name must end in 'Notifications' and the API must supply a subscription plan creator function for the notification '$notificationName'.",
    [$68590ac3373b9249$export$ae8da83a78732501]: "WebSocket was closed before payload could be added to the send buffer",
    [$68590ac3373b9249$export$73f01f46f9a97cf0]: "WebSocket connection closed",
    [$68590ac3373b9249$export$5293460f390d6127]: "WebSocket failed to connect",
    [$68590ac3373b9249$export$e1a3658b043aad8e]: "Failed to obtain a subscription id from the server",
    [$68590ac3373b9249$export$119023a74b281384]: "Could not find an API plan for RPC method: `$method`",
    [$68590ac3373b9249$export$ef742b7036fb9005]: "The $argumentLabel argument to the `$methodName` RPC method$optionalPathLabel was `$value`. This number is unsafe for use with the Solana JSON-RPC because it exceeds `Number.MAX_SAFE_INTEGER`.",
    [$68590ac3373b9249$export$7f6822f75edb8f41]: "HTTP error ($statusCode): $message",
    [$68590ac3373b9249$export$2a2f0f75708d1697]: "HTTP header(s) forbidden: $headers. Learn more at https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name.",
    [$68590ac3373b9249$export$ee84b29a9985e516]: "Multiple distinct signers were identified for address `$address`. Please ensure that you are using the same signer instance for each address.",
    [$68590ac3373b9249$export$9998b265c986beaa]: "The provided value does not implement the `KeyPairSigner` interface",
    [$68590ac3373b9249$export$14d32fbdad2233cd]: "The provided value does not implement the `MessageModifyingSigner` interface",
    [$68590ac3373b9249$export$8c6fc1cfcec8440c]: "The provided value does not implement the `MessagePartialSigner` interface",
    [$68590ac3373b9249$export$dd792e9d67cd031b]: "The provided value does not implement any of the `MessageSigner` interfaces",
    [$68590ac3373b9249$export$200acbfc722e322b]: "The provided value does not implement the `TransactionModifyingSigner` interface",
    [$68590ac3373b9249$export$4c96d9a95880ae4b]: "The provided value does not implement the `TransactionPartialSigner` interface",
    [$68590ac3373b9249$export$bba76b21ada319a5]: "The provided value does not implement the `TransactionSendingSigner` interface",
    [$68590ac3373b9249$export$dcec7171cff295d1]: "The provided value does not implement any of the `TransactionSigner` interfaces",
    [$68590ac3373b9249$export$3cb3b480d2bfdacc]: "More than one `TransactionSendingSigner` was identified.",
    [$68590ac3373b9249$export$1f5fbaa83776feec]: "No `TransactionSendingSigner` was identified. Please provide a valid `ITransactionWithSingleSendingSigner` transaction.",
    [$68590ac3373b9249$export$1d51c4c8b2c49e09]: "Wallet account signers do not support signing multiple messages/transactions in a single operation",
    [$68590ac3373b9249$export$b6497aaa1c3cb4a7]: "Cannot export a non-extractable key.",
    [$68590ac3373b9249$export$f18173f573d8bb21]: "No digest implementation could be found.",
    [$68590ac3373b9249$export$f2bbb3c14e29977e]: "Cryptographic operations are only allowed in secure browser contexts. Read more here: https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts.",
    [$68590ac3373b9249$export$7ad09900bd645a86]: "This runtime does not support the generation of Ed25519 key pairs.\n\nInstall @solana/webcrypto-ed25519-polyfill and call its `install` function before generating keys in environments that do not support Ed25519.\n\nFor a list of runtimes that currently support Ed25519 operations, visit https://github.com/WICG/webcrypto-secure-curves/issues/20.",
    [$68590ac3373b9249$export$69c08c51e1841f29]: "No signature verification implementation could be found.",
    [$68590ac3373b9249$export$325dad4e0a6bd514]: "No key generation implementation could be found.",
    [$68590ac3373b9249$export$242c341c7c464bee]: "No signing implementation could be found.",
    [$68590ac3373b9249$export$a73c064bb32a7c36]: "No key export implementation could be found.",
    [$68590ac3373b9249$export$8b23617676679e2d]: "Timestamp value must be in the range [-(2n ** 63n), (2n ** 63n) - 1]. `$value` given",
    [$68590ac3373b9249$export$291ea8d5a7496fde]: "Transaction processing left an account with an outstanding borrowed reference",
    [$68590ac3373b9249$export$a746609ecc2f6acf]: "Account in use",
    [$68590ac3373b9249$export$c4d8217d3eb3eaf8]: "Account loaded twice",
    [$68590ac3373b9249$export$5d0f06cd8bc8e3af]: "Attempt to debit an account but found no record of a prior credit.",
    [$68590ac3373b9249$export$95c94f6ea500f1ab]: "Transaction loads an address table account that doesn't exist",
    [$68590ac3373b9249$export$2bbd9403cb117ea7]: "This transaction has already been processed",
    [$68590ac3373b9249$export$e108dd5343c4c11]: "Blockhash not found",
    [$68590ac3373b9249$export$a504ed6cab09ce4a]: "Loader call chain is too deep",
    [$68590ac3373b9249$export$211b9b84186690f0]: "Transactions are currently disabled due to cluster maintenance",
    [$68590ac3373b9249$export$e3a4007020a2e8f5]: "Transaction contains a duplicate instruction ($index) that is not allowed",
    [$68590ac3373b9249$export$39ead28cf48a604c]: "Insufficient funds for fee",
    [$68590ac3373b9249$export$2ecc275dffbc087c]: "Transaction results in an account ($accountIndex) with insufficient funds for rent",
    [$68590ac3373b9249$export$624f65633216eb57]: "This account may not be used to pay transaction fees",
    [$68590ac3373b9249$export$47df44101c6f04b0]: "Transaction contains an invalid account reference",
    [$68590ac3373b9249$export$bd54a9a85614b3a7]: "Transaction loads an address table account with invalid data",
    [$68590ac3373b9249$export$df4ef1824fd194a3]: "Transaction address table lookup uses an invalid index",
    [$68590ac3373b9249$export$11d69fb6993b2cf5]: "Transaction loads an address table account with an invalid owner",
    [$68590ac3373b9249$export$3569c6c71e349538]: "LoadedAccountsDataSizeLimit set for transaction must be greater than 0.",
    [$68590ac3373b9249$export$bea5f92951bc42e7]: "This program may not be used for executing instructions",
    [$68590ac3373b9249$export$2725d50dd432fb3a]: "Transaction leaves an account with a lower balance than rent-exempt minimum",
    [$68590ac3373b9249$export$b8b2610c9a910763]: "Transaction loads a writable account that cannot be written",
    [$68590ac3373b9249$export$e3289c5954208202]: "Transaction exceeded max loaded accounts data size cap",
    [$68590ac3373b9249$export$8c1ae05eccc11ef9]: "Transaction requires a fee but has no signature present",
    [$68590ac3373b9249$export$83c8fe2717d1b271]: "Attempt to load a program that does not exist",
    [$68590ac3373b9249$export$1cd0de5dfcdeb99d]: "Execution of the program referenced by account at index $accountIndex is temporarily restricted.",
    [$68590ac3373b9249$export$4f413e02d5e82221]: "ResanitizationNeeded",
    [$68590ac3373b9249$export$91a668e132084ecf]: "Transaction failed to sanitize accounts offsets correctly",
    [$68590ac3373b9249$export$89ae0c424691fbcb]: "Transaction did not pass signature verification",
    [$68590ac3373b9249$export$fa9a13f1b40ee2fb]: "Transaction locked too many accounts",
    [$68590ac3373b9249$export$87e01307d368f511]: "Sum of account balances before and after transaction do not match",
    [$68590ac3373b9249$export$8c82dde5b12c9789]: "The transaction failed with the error `$errorName`",
    [$68590ac3373b9249$export$58bf90c73afbc02e]: "Transaction version is unsupported",
    [$68590ac3373b9249$export$572954173bc64b66]: "Transaction would exceed account data limit within the block",
    [$68590ac3373b9249$export$7b4a7eebff68ca7b]: "Transaction would exceed total account data limit",
    [$68590ac3373b9249$export$fb693aebffa32676]: "Transaction would exceed max account limit within the block",
    [$68590ac3373b9249$export$5f027a86397cba92]: "Transaction would exceed max Block Cost Limit",
    [$68590ac3373b9249$export$41f13726b04d8d05]: "Transaction would exceed max Vote Cost Limit",
    [$68590ac3373b9249$export$36c2547c3c4d823f]: "Attempted to sign a transaction with an address that is not a signer for it",
    [$68590ac3373b9249$export$819b1b0603d2a966]: "Transaction is missing an address at index: $index.",
    [$68590ac3373b9249$export$de92784c954d1b84]: "Transaction has no expected signers therefore it cannot be encoded",
    [$68590ac3373b9249$export$e33d07a7526bded0]: "Transaction does not have a blockhash lifetime",
    [$68590ac3373b9249$export$a20747f749dd4515]: "Transaction is not a durable nonce transaction",
    [$68590ac3373b9249$export$b34a16b8adbffdc1]: "Contents of these address lookup tables unknown: $lookupTableAddresses",
    [$68590ac3373b9249$export$3764bbcfb0679211]: "Lookup of address at index $highestRequestedIndex failed for lookup table `$lookupTableAddress`. Highest known index is $highestKnownIndex. The lookup table may have been extended since its contents were retrieved",
    [$68590ac3373b9249$export$11bea4440904349c]: "No fee payer set in CompiledTransaction",
    [$68590ac3373b9249$export$ed2bdee7953e467f]: "Could not find program address at index $index",
    [$68590ac3373b9249$export$4e4582c633fc423e]: "Failed to estimate the compute unit consumption for this transaction message. This is likely because simulating the transaction failed. Inspect the `cause` property of this error to learn more",
    [$68590ac3373b9249$export$923893d5c076a47c]: "Transaction failed when it was simulated in order to estimate the compute unit consumption. The compute unit estimate provided is for a transaction that failed when simulated and may not be representative of the compute units this transaction would consume if successful. Inspect the `cause` property of this error to learn more",
    [$68590ac3373b9249$export$592862d1b11e32ac]: "Transaction is missing a fee payer.",
    [$68590ac3373b9249$export$242af5597d94abaf]: "Could not determine this transaction's signature. Make sure that the transaction has been signed by its fee payer.",
    [$68590ac3373b9249$export$bed6f92dafea0623]: "Transaction first instruction is not advance nonce account instruction.",
    [$68590ac3373b9249$export$802b3ebe5297e360]: "Transaction with no instructions cannot be durable nonce transaction.",
    [$68590ac3373b9249$export$694fd435994bcca]: "This transaction includes an address (`$programAddress`) which is both invoked and set as the fee payer. Program addresses may not pay fees",
    [$68590ac3373b9249$export$707576ec00ca24d6]: "This transaction includes an address (`$programAddress`) which is both invoked and marked writable. Program addresses may not be writable",
    [$68590ac3373b9249$export$b55a3eb3d894ad9f]: "The transaction message expected the transaction to have $signerAddressesLength signatures, got $signaturesLength.",
    [$68590ac3373b9249$export$6d61b980429516bd]: "Transaction is missing signatures for addresses: $addresses.",
    [$68590ac3373b9249$export$3963d9bca4091810]: "Transaction version must be in the range [0, 127]. `$actualVersion` given"
};
// src/message-formatter.ts
var $68590ac3373b9249$var$START_INDEX = "i";
var $68590ac3373b9249$var$TYPE = "t";
function $68590ac3373b9249$var$getHumanReadableErrorMessage(code, context = {}) {
    const messageFormatString = $68590ac3373b9249$var$SolanaErrorMessages[code];
    if (messageFormatString.length === 0) return "";
    let state;
    function commitStateUpTo(endIndex) {
        if (state[$68590ac3373b9249$var$TYPE] === 2 /* Variable */ ) {
            const variableName = messageFormatString.slice(state[$68590ac3373b9249$var$START_INDEX] + 1, endIndex);
            fragments.push(variableName in context ? // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `${context[variableName]}` : `$${variableName}`);
        } else if (state[$68590ac3373b9249$var$TYPE] === 1 /* Text */ ) fragments.push(messageFormatString.slice(state[$68590ac3373b9249$var$START_INDEX], endIndex));
    }
    const fragments = [];
    messageFormatString.split("").forEach((char, ii)=>{
        if (ii === 0) {
            state = {
                [$68590ac3373b9249$var$START_INDEX]: 0,
                [$68590ac3373b9249$var$TYPE]: messageFormatString[0] === "\\" ? 0 /* EscapeSequence */  : messageFormatString[0] === "$" ? 2 /* Variable */  : 1 /* Text */ 
            };
            return;
        }
        let nextState;
        switch(state[$68590ac3373b9249$var$TYPE]){
            case 0 /* EscapeSequence */ :
                nextState = {
                    [$68590ac3373b9249$var$START_INDEX]: ii,
                    [$68590ac3373b9249$var$TYPE]: 1 /* Text */ 
                };
                break;
            case 1 /* Text */ :
                if (char === "\\") nextState = {
                    [$68590ac3373b9249$var$START_INDEX]: ii,
                    [$68590ac3373b9249$var$TYPE]: 0 /* EscapeSequence */ 
                };
                else if (char === "$") nextState = {
                    [$68590ac3373b9249$var$START_INDEX]: ii,
                    [$68590ac3373b9249$var$TYPE]: 2 /* Variable */ 
                };
                break;
            case 2 /* Variable */ :
                if (char === "\\") nextState = {
                    [$68590ac3373b9249$var$START_INDEX]: ii,
                    [$68590ac3373b9249$var$TYPE]: 0 /* EscapeSequence */ 
                };
                else if (char === "$") nextState = {
                    [$68590ac3373b9249$var$START_INDEX]: ii,
                    [$68590ac3373b9249$var$TYPE]: 2 /* Variable */ 
                };
                else if (!char.match(/\w/)) nextState = {
                    [$68590ac3373b9249$var$START_INDEX]: ii,
                    [$68590ac3373b9249$var$TYPE]: 1 /* Text */ 
                };
                break;
        }
        if (nextState) {
            if (state !== nextState) commitStateUpTo(ii);
            state = nextState;
        }
    });
    commitStateUpTo();
    return fragments.join("");
}
function $68590ac3373b9249$var$getErrorMessage(code, context = {}) {
    {
        let decodingAdviceMessage = `Solana error #${code}; Decode this error by running \`npx @solana/errors decode -- ${code}`;
        if (Object.keys(context).length) decodingAdviceMessage += ` '${$68590ac3373b9249$var$encodeContextObject(context)}'`;
        return `${decodingAdviceMessage}\``;
    }
}
// src/error.ts
function $68590ac3373b9249$export$cfead212e52d9961(e, code) {
    const isSolanaError2 = e instanceof Error && e.name === "SolanaError";
    if (isSolanaError2) {
        if (code !== void 0) return e.context.__code === code;
        return true;
    }
    return false;
}
var $68590ac3373b9249$export$8349fd9adaaed269 = class extends Error {
    /**
   * Indicates the root cause of this {@link SolanaError}, if any.
   *
   * For example, a transaction error might have an instruction error as its root cause. In this
   * case, you will be able to access the instruction error on the transaction error as `cause`.
   */ cause = this.cause;
    /**
   * Contains context that can assist in understanding or recovering from a {@link SolanaError}.
   */ context;
    constructor(...[code, contextAndErrorOptions]){
        let context;
        let errorOptions;
        if (contextAndErrorOptions) {
            const { cause: cause, ...contextRest } = contextAndErrorOptions;
            if (cause) errorOptions = {
                cause: cause
            };
            if (Object.keys(contextRest).length > 0) context = contextRest;
        }
        const message = $68590ac3373b9249$var$getErrorMessage(code, context);
        super(message, errorOptions);
        this.context = {
            __code: code,
            ...context
        };
        this.name = "SolanaError";
    }
};
// src/stack-trace.ts
function $68590ac3373b9249$export$4608fd6508cb51(...args) {
    if ("captureStackTrace" in Error && typeof Error.captureStackTrace === "function") Error.captureStackTrace(...args);
}
// src/rpc-enum-errors.ts
function $68590ac3373b9249$var$getSolanaErrorFromRpcError({ errorCodeBaseOffset: errorCodeBaseOffset, getErrorContext: getErrorContext, orderedErrorNames: orderedErrorNames, rpcEnumError: rpcEnumError }, constructorOpt) {
    let rpcErrorName;
    let rpcErrorContext;
    if (typeof rpcEnumError === "string") rpcErrorName = rpcEnumError;
    else {
        rpcErrorName = Object.keys(rpcEnumError)[0];
        rpcErrorContext = rpcEnumError[rpcErrorName];
    }
    const codeOffset = orderedErrorNames.indexOf(rpcErrorName);
    const errorCode = errorCodeBaseOffset + codeOffset;
    const errorContext = getErrorContext(errorCode, rpcErrorName, rpcErrorContext);
    const err = new $68590ac3373b9249$export$8349fd9adaaed269(errorCode, errorContext);
    $68590ac3373b9249$export$4608fd6508cb51(err, constructorOpt);
    return err;
}
// src/instruction-error.ts
var $68590ac3373b9249$var$ORDERED_ERROR_NAMES = [
    // Keep synced with RPC source: https://github.com/anza-xyz/agave/blob/master/sdk/program/src/instruction.rs
    // If this list ever gets too large, consider implementing a compression strategy like this:
    // https://gist.github.com/steveluscher/aaa7cbbb5433b1197983908a40860c47
    "GenericError",
    "InvalidArgument",
    "InvalidInstructionData",
    "InvalidAccountData",
    "AccountDataTooSmall",
    "InsufficientFunds",
    "IncorrectProgramId",
    "MissingRequiredSignature",
    "AccountAlreadyInitialized",
    "UninitializedAccount",
    "UnbalancedInstruction",
    "ModifiedProgramId",
    "ExternalAccountLamportSpend",
    "ExternalAccountDataModified",
    "ReadonlyLamportChange",
    "ReadonlyDataModified",
    "DuplicateAccountIndex",
    "ExecutableModified",
    "RentEpochModified",
    "NotEnoughAccountKeys",
    "AccountDataSizeChanged",
    "AccountNotExecutable",
    "AccountBorrowFailed",
    "AccountBorrowOutstanding",
    "DuplicateAccountOutOfSync",
    "Custom",
    "InvalidError",
    "ExecutableDataModified",
    "ExecutableLamportChange",
    "ExecutableAccountNotRentExempt",
    "UnsupportedProgramId",
    "CallDepth",
    "MissingAccount",
    "ReentrancyNotAllowed",
    "MaxSeedLengthExceeded",
    "InvalidSeeds",
    "InvalidRealloc",
    "ComputationalBudgetExceeded",
    "PrivilegeEscalation",
    "ProgramEnvironmentSetupFailure",
    "ProgramFailedToComplete",
    "ProgramFailedToCompile",
    "Immutable",
    "IncorrectAuthority",
    "BorshIoError",
    "AccountNotRentExempt",
    "InvalidAccountOwner",
    "ArithmeticOverflow",
    "UnsupportedSysvar",
    "IllegalOwner",
    "MaxAccountsDataAllocationsExceeded",
    "MaxAccountsExceeded",
    "MaxInstructionTraceLengthExceeded",
    "BuiltinProgramsMustConsumeComputeUnits"
];
function $68590ac3373b9249$export$4e38d43e41953f9e(index, instructionError) {
    const numberIndex = Number(index);
    return $68590ac3373b9249$var$getSolanaErrorFromRpcError({
        errorCodeBaseOffset: 4615001,
        getErrorContext (errorCode, rpcErrorName, rpcErrorContext) {
            if (errorCode === $68590ac3373b9249$export$d308cb6df5c28ff6) return {
                errorName: rpcErrorName,
                index: numberIndex,
                ...rpcErrorContext !== void 0 ? {
                    instructionErrorContext: rpcErrorContext
                } : null
            };
            else if (errorCode === $68590ac3373b9249$export$5abe2d1d040bf6cf) return {
                code: Number(rpcErrorContext),
                index: numberIndex
            };
            else if (errorCode === $68590ac3373b9249$export$57c1675a0c20931f) return {
                encodedData: rpcErrorContext,
                index: numberIndex
            };
            return {
                index: numberIndex
            };
        },
        orderedErrorNames: $68590ac3373b9249$var$ORDERED_ERROR_NAMES,
        rpcEnumError: instructionError
    }, $68590ac3373b9249$export$4e38d43e41953f9e);
}
// src/transaction-error.ts
var $68590ac3373b9249$var$ORDERED_ERROR_NAMES2 = [
    // Keep synced with RPC source: https://github.com/anza-xyz/agave/blob/master/sdk/src/transaction/error.rs
    // If this list ever gets too large, consider implementing a compression strategy like this:
    // https://gist.github.com/steveluscher/aaa7cbbb5433b1197983908a40860c47
    "AccountInUse",
    "AccountLoadedTwice",
    "AccountNotFound",
    "ProgramAccountNotFound",
    "InsufficientFundsForFee",
    "InvalidAccountForFee",
    "AlreadyProcessed",
    "BlockhashNotFound",
    // `InstructionError` intentionally omitted; delegated to `getSolanaErrorFromInstructionError`
    "CallChainTooDeep",
    "MissingSignatureForFee",
    "InvalidAccountIndex",
    "SignatureFailure",
    "InvalidProgramForExecution",
    "SanitizeFailure",
    "ClusterMaintenance",
    "AccountBorrowOutstanding",
    "WouldExceedMaxBlockCostLimit",
    "UnsupportedVersion",
    "InvalidWritableAccount",
    "WouldExceedMaxAccountCostLimit",
    "WouldExceedAccountDataBlockLimit",
    "TooManyAccountLocks",
    "AddressLookupTableNotFound",
    "InvalidAddressLookupTableOwner",
    "InvalidAddressLookupTableData",
    "InvalidAddressLookupTableIndex",
    "InvalidRentPayingAccount",
    "WouldExceedMaxVoteCostLimit",
    "WouldExceedAccountDataTotalLimit",
    "DuplicateInstruction",
    "InsufficientFundsForRent",
    "MaxLoadedAccountsDataSizeExceeded",
    "InvalidLoadedAccountsDataSizeLimit",
    "ResanitizationNeeded",
    "ProgramExecutionTemporarilyRestricted",
    "UnbalancedTransaction"
];
function $68590ac3373b9249$export$c10ce7a2fd9c66f0(transactionError) {
    if (typeof transactionError === "object" && "InstructionError" in transactionError) return $68590ac3373b9249$export$4e38d43e41953f9e(...transactionError.InstructionError);
    return $68590ac3373b9249$var$getSolanaErrorFromRpcError({
        errorCodeBaseOffset: 7050001,
        getErrorContext (errorCode, rpcErrorName, rpcErrorContext) {
            if (errorCode === $68590ac3373b9249$export$8c82dde5b12c9789) return {
                errorName: rpcErrorName,
                ...rpcErrorContext !== void 0 ? {
                    transactionErrorContext: rpcErrorContext
                } : null
            };
            else if (errorCode === $68590ac3373b9249$export$e3a4007020a2e8f5) return {
                index: Number(rpcErrorContext)
            };
            else if (errorCode === $68590ac3373b9249$export$2ecc275dffbc087c || errorCode === $68590ac3373b9249$export$1cd0de5dfcdeb99d) return {
                accountIndex: Number(rpcErrorContext.account_index)
            };
        },
        orderedErrorNames: $68590ac3373b9249$var$ORDERED_ERROR_NAMES2,
        rpcEnumError: transactionError
    }, $68590ac3373b9249$export$c10ce7a2fd9c66f0);
}
// src/json-rpc-error.ts
function $68590ac3373b9249$export$1f67f8d128316a6d(putativeErrorResponse) {
    let out;
    if ($68590ac3373b9249$var$isRpcErrorResponse(putativeErrorResponse)) {
        const { code: rawCode, data: data, message: message } = putativeErrorResponse;
        const code = Number(rawCode);
        if (code === $68590ac3373b9249$export$426cc73f5ad00f38) {
            const { err: err, ...preflightErrorContext } = data;
            const causeObject = err ? {
                cause: $68590ac3373b9249$export$c10ce7a2fd9c66f0(err)
            } : null;
            out = new $68590ac3373b9249$export$8349fd9adaaed269($68590ac3373b9249$export$426cc73f5ad00f38, {
                ...preflightErrorContext,
                ...causeObject
            });
        } else {
            let errorContext;
            switch(code){
                case $68590ac3373b9249$export$afa40fd3fc01204:
                case $68590ac3373b9249$export$2981978a530b1a7c:
                case $68590ac3373b9249$export$23cb4efd59427895:
                case $68590ac3373b9249$export$5ec955cc8b7e8cf9:
                case $68590ac3373b9249$export$e09e3905081e44fe:
                case $68590ac3373b9249$export$1b90c411626421b1:
                case $68590ac3373b9249$export$6ae475e85fe02aad:
                case $68590ac3373b9249$export$bfbf8b75e865efa0:
                case $68590ac3373b9249$export$65235469ebe9845e:
                case $68590ac3373b9249$export$54dea2286c43ec1e:
                case $68590ac3373b9249$export$e71fbee92648fc61:
                case $68590ac3373b9249$export$d21075fd06730e:
                case $68590ac3373b9249$export$d964b43bb02eacdf:
                case $68590ac3373b9249$export$f7685139153f9191:
                    errorContext = {
                        __serverMessage: message
                    };
                    break;
                default:
                    if (typeof data === "object" && !Array.isArray(data)) errorContext = data;
            }
            out = new $68590ac3373b9249$export$8349fd9adaaed269(code, errorContext);
        }
    } else {
        const message = typeof putativeErrorResponse === "object" && putativeErrorResponse !== null && "message" in putativeErrorResponse && typeof putativeErrorResponse.message === "string" ? putativeErrorResponse.message : "Malformed JSON-RPC error with no message attribute";
        out = new $68590ac3373b9249$export$8349fd9adaaed269($68590ac3373b9249$export$1cf7bba40d7d2361, {
            error: putativeErrorResponse,
            message: message
        });
    }
    $68590ac3373b9249$export$4608fd6508cb51(out, $68590ac3373b9249$export$1f67f8d128316a6d);
    return out;
}
function $68590ac3373b9249$var$isRpcErrorResponse(value) {
    return typeof value === "object" && value !== null && "code" in value && "message" in value && (typeof value.code === "number" || typeof value.code === "bigint") && typeof value.message === "string";
}
 //# sourceMappingURL=index.browser.mjs.map



// src/add-codec-sentinel.ts
// src/bytes.ts
var $0542a91ee175cf5c$export$6cf3317d55598fde = (byteArrays)=>{
    const nonEmptyByteArrays = byteArrays.filter((arr)=>arr.length);
    if (nonEmptyByteArrays.length === 0) return byteArrays.length ? byteArrays[0] : new Uint8Array();
    if (nonEmptyByteArrays.length === 1) return nonEmptyByteArrays[0];
    const totalLength = nonEmptyByteArrays.reduce((total, arr)=>total + arr.length, 0);
    const result = new Uint8Array(totalLength);
    let offset = 0;
    nonEmptyByteArrays.forEach((arr)=>{
        result.set(arr, offset);
        offset += arr.length;
    });
    return result;
};
var $0542a91ee175cf5c$export$4c6b868113605df3 = (bytes, length)=>{
    if (bytes.length >= length) return bytes;
    const paddedBytes = new Uint8Array(length).fill(0);
    paddedBytes.set(bytes);
    return paddedBytes;
};
var $0542a91ee175cf5c$export$11b3146a4f4702ef = (bytes, length)=>$0542a91ee175cf5c$export$4c6b868113605df3(bytes.length <= length ? bytes : bytes.slice(0, length), length);
function $0542a91ee175cf5c$export$1b62aef2a79e6b21(data, bytes, offset) {
    const slice = offset === 0 && data.length === bytes.length ? data : data.slice(offset, offset + bytes.length);
    if (slice.length !== bytes.length) return false;
    return bytes.every((b, i)=>b === slice[i]);
}
function $0542a91ee175cf5c$export$30f3257599397621(value, encoder) {
    return "fixedSize" in encoder ? encoder.fixedSize : encoder.getSizeFromValue(value);
}
function $0542a91ee175cf5c$export$4e76eeb6df88c889(encoder) {
    return Object.freeze({
        ...encoder,
        encode: (value)=>{
            const bytes = new Uint8Array($0542a91ee175cf5c$export$30f3257599397621(value, encoder));
            encoder.write(value, bytes, 0);
            return bytes;
        }
    });
}
function $0542a91ee175cf5c$export$f8c898e83b60faaa(decoder) {
    return Object.freeze({
        ...decoder,
        decode: (bytes, offset = 0)=>decoder.read(bytes, offset)[0]
    });
}
function $0542a91ee175cf5c$export$a4cf2f585987cc8(codec) {
    return Object.freeze({
        ...codec,
        decode: (bytes, offset = 0)=>codec.read(bytes, offset)[0],
        encode: (value)=>{
            const bytes = new Uint8Array($0542a91ee175cf5c$export$30f3257599397621(value, codec));
            codec.write(value, bytes, 0);
            return bytes;
        }
    });
}
function $0542a91ee175cf5c$export$f9d60229c95384d4(codec) {
    return "fixedSize" in codec && typeof codec.fixedSize === "number";
}
function $0542a91ee175cf5c$export$4e85b7423fd6bc55(codec) {
    if (!$0542a91ee175cf5c$export$f9d60229c95384d4(codec)) throw new (0, $68590ac3373b9249$export$8349fd9adaaed269)((0, $68590ac3373b9249$export$93561b31b951410d));
}
function $0542a91ee175cf5c$export$d76fd0b6e42f051a(codec) {
    return !$0542a91ee175cf5c$export$f9d60229c95384d4(codec);
}
function $0542a91ee175cf5c$export$6bf5fc425e413c8a(codec) {
    if (!$0542a91ee175cf5c$export$d76fd0b6e42f051a(codec)) throw new (0, $68590ac3373b9249$export$8349fd9adaaed269)((0, $68590ac3373b9249$export$3417da5bc6bcb45));
}
function $0542a91ee175cf5c$export$b88681b853abde79(encoder, decoder) {
    if ($0542a91ee175cf5c$export$f9d60229c95384d4(encoder) !== $0542a91ee175cf5c$export$f9d60229c95384d4(decoder)) throw new (0, $68590ac3373b9249$export$8349fd9adaaed269)((0, $68590ac3373b9249$export$c4c73ab3c0833591));
    if ($0542a91ee175cf5c$export$f9d60229c95384d4(encoder) && $0542a91ee175cf5c$export$f9d60229c95384d4(decoder) && encoder.fixedSize !== decoder.fixedSize) throw new (0, $68590ac3373b9249$export$8349fd9adaaed269)((0, $68590ac3373b9249$export$824d79ab1779d517), {
        decoderFixedSize: decoder.fixedSize,
        encoderFixedSize: encoder.fixedSize
    });
    if (!$0542a91ee175cf5c$export$f9d60229c95384d4(encoder) && !$0542a91ee175cf5c$export$f9d60229c95384d4(decoder) && encoder.maxSize !== decoder.maxSize) throw new (0, $68590ac3373b9249$export$8349fd9adaaed269)((0, $68590ac3373b9249$export$c464f3b291f1f3d0), {
        decoderMaxSize: decoder.maxSize,
        encoderMaxSize: encoder.maxSize
    });
    return {
        ...decoder,
        ...encoder,
        decode: decoder.decode,
        encode: encoder.encode,
        read: decoder.read,
        write: encoder.write
    };
}
// src/add-codec-sentinel.ts
function $0542a91ee175cf5c$export$e98b1308839de22(encoder, sentinel) {
    const write = (value, bytes, offset)=>{
        const encoderBytes = encoder.encode(value);
        if ($0542a91ee175cf5c$var$findSentinelIndex(encoderBytes, sentinel) >= 0) throw new (0, $68590ac3373b9249$export$8349fd9adaaed269)((0, $68590ac3373b9249$export$a9282ed13660c9f6), {
            encodedBytes: encoderBytes,
            hexEncodedBytes: $0542a91ee175cf5c$var$hexBytes(encoderBytes),
            hexSentinel: $0542a91ee175cf5c$var$hexBytes(sentinel),
            sentinel: sentinel
        });
        bytes.set(encoderBytes, offset);
        offset += encoderBytes.length;
        bytes.set(sentinel, offset);
        offset += sentinel.length;
        return offset;
    };
    if ($0542a91ee175cf5c$export$f9d60229c95384d4(encoder)) return $0542a91ee175cf5c$export$4e76eeb6df88c889({
        ...encoder,
        fixedSize: encoder.fixedSize + sentinel.length,
        write: write
    });
    return $0542a91ee175cf5c$export$4e76eeb6df88c889({
        ...encoder,
        ...encoder.maxSize != null ? {
            maxSize: encoder.maxSize + sentinel.length
        } : {},
        getSizeFromValue: (value)=>encoder.getSizeFromValue(value) + sentinel.length,
        write: write
    });
}
function $0542a91ee175cf5c$export$cdbc1a8bfd8f69c8(decoder, sentinel) {
    const read = (bytes, offset)=>{
        const candidateBytes = offset === 0 ? bytes : bytes.slice(offset);
        const sentinelIndex = $0542a91ee175cf5c$var$findSentinelIndex(candidateBytes, sentinel);
        if (sentinelIndex === -1) throw new (0, $68590ac3373b9249$export$8349fd9adaaed269)((0, $68590ac3373b9249$export$5bdfee6423bc35ce), {
            decodedBytes: candidateBytes,
            hexDecodedBytes: $0542a91ee175cf5c$var$hexBytes(candidateBytes),
            hexSentinel: $0542a91ee175cf5c$var$hexBytes(sentinel),
            sentinel: sentinel
        });
        const preSentinelBytes = candidateBytes.slice(0, sentinelIndex);
        return [
            decoder.decode(preSentinelBytes),
            offset + preSentinelBytes.length + sentinel.length
        ];
    };
    if ($0542a91ee175cf5c$export$f9d60229c95384d4(decoder)) return $0542a91ee175cf5c$export$f8c898e83b60faaa({
        ...decoder,
        fixedSize: decoder.fixedSize + sentinel.length,
        read: read
    });
    return $0542a91ee175cf5c$export$f8c898e83b60faaa({
        ...decoder,
        ...decoder.maxSize != null ? {
            maxSize: decoder.maxSize + sentinel.length
        } : {},
        read: read
    });
}
function $0542a91ee175cf5c$export$56d7c5070d1e9d9b(codec, sentinel) {
    return $0542a91ee175cf5c$export$b88681b853abde79($0542a91ee175cf5c$export$e98b1308839de22(codec, sentinel), $0542a91ee175cf5c$export$cdbc1a8bfd8f69c8(codec, sentinel));
}
function $0542a91ee175cf5c$var$findSentinelIndex(bytes, sentinel) {
    return bytes.findIndex((byte, index, arr)=>{
        if (sentinel.length === 1) return byte === sentinel[0];
        return $0542a91ee175cf5c$export$1b62aef2a79e6b21(arr, sentinel, index);
    });
}
function $0542a91ee175cf5c$var$hexBytes(bytes) {
    return bytes.reduce((str, byte)=>str + byte.toString(16).padStart(2, "0"), "");
}
function $0542a91ee175cf5c$export$bf929351331b7b89(codecDescription, bytes, offset = 0) {
    if (bytes.length - offset <= 0) throw new (0, $68590ac3373b9249$export$8349fd9adaaed269)((0, $68590ac3373b9249$export$9c9326ce1e3df40c), {
        codecDescription: codecDescription
    });
}
function $0542a91ee175cf5c$export$4a981e7c9ed0b6bf(codecDescription, expected, bytes, offset = 0) {
    const bytesLength = bytes.length - offset;
    if (bytesLength < expected) throw new (0, $68590ac3373b9249$export$8349fd9adaaed269)((0, $68590ac3373b9249$export$18fbf24f19efc69b), {
        bytesLength: bytesLength,
        codecDescription: codecDescription,
        expected: expected
    });
}
function $0542a91ee175cf5c$export$9319e0aa6a4927d2(codecDescription, offset, bytesLength) {
    if (offset < 0 || offset > bytesLength) throw new (0, $68590ac3373b9249$export$8349fd9adaaed269)((0, $68590ac3373b9249$export$a617dff403944ec6), {
        bytesLength: bytesLength,
        codecDescription: codecDescription,
        offset: offset
    });
}
// src/add-codec-size-prefix.ts
function $0542a91ee175cf5c$export$37e5b12cb5a8d560(encoder, prefix) {
    const write = (value, bytes, offset)=>{
        const encoderBytes = encoder.encode(value);
        offset = prefix.write(encoderBytes.length, bytes, offset);
        bytes.set(encoderBytes, offset);
        return offset + encoderBytes.length;
    };
    if ($0542a91ee175cf5c$export$f9d60229c95384d4(prefix) && $0542a91ee175cf5c$export$f9d60229c95384d4(encoder)) return $0542a91ee175cf5c$export$4e76eeb6df88c889({
        ...encoder,
        fixedSize: prefix.fixedSize + encoder.fixedSize,
        write: write
    });
    const prefixMaxSize = $0542a91ee175cf5c$export$f9d60229c95384d4(prefix) ? prefix.fixedSize : prefix.maxSize ?? null;
    const encoderMaxSize = $0542a91ee175cf5c$export$f9d60229c95384d4(encoder) ? encoder.fixedSize : encoder.maxSize ?? null;
    const maxSize = prefixMaxSize !== null && encoderMaxSize !== null ? prefixMaxSize + encoderMaxSize : null;
    return $0542a91ee175cf5c$export$4e76eeb6df88c889({
        ...encoder,
        ...maxSize !== null ? {
            maxSize: maxSize
        } : {},
        getSizeFromValue: (value)=>{
            const encoderSize = $0542a91ee175cf5c$export$30f3257599397621(value, encoder);
            return $0542a91ee175cf5c$export$30f3257599397621(encoderSize, prefix) + encoderSize;
        },
        write: write
    });
}
function $0542a91ee175cf5c$export$fe2b33c81523b294(decoder, prefix) {
    const read = (bytes, offset)=>{
        const [bigintSize, decoderOffset] = prefix.read(bytes, offset);
        const size = Number(bigintSize);
        offset = decoderOffset;
        if (offset > 0 || bytes.length > size) bytes = bytes.slice(offset, offset + size);
        $0542a91ee175cf5c$export$4a981e7c9ed0b6bf("addDecoderSizePrefix", size, bytes);
        return [
            decoder.decode(bytes),
            offset + size
        ];
    };
    if ($0542a91ee175cf5c$export$f9d60229c95384d4(prefix) && $0542a91ee175cf5c$export$f9d60229c95384d4(decoder)) return $0542a91ee175cf5c$export$f8c898e83b60faaa({
        ...decoder,
        fixedSize: prefix.fixedSize + decoder.fixedSize,
        read: read
    });
    const prefixMaxSize = $0542a91ee175cf5c$export$f9d60229c95384d4(prefix) ? prefix.fixedSize : prefix.maxSize ?? null;
    const decoderMaxSize = $0542a91ee175cf5c$export$f9d60229c95384d4(decoder) ? decoder.fixedSize : decoder.maxSize ?? null;
    const maxSize = prefixMaxSize !== null && decoderMaxSize !== null ? prefixMaxSize + decoderMaxSize : null;
    return $0542a91ee175cf5c$export$f8c898e83b60faaa({
        ...decoder,
        ...maxSize !== null ? {
            maxSize: maxSize
        } : {},
        read: read
    });
}
function $0542a91ee175cf5c$export$ec85c1caba397ab2(codec, prefix) {
    return $0542a91ee175cf5c$export$b88681b853abde79($0542a91ee175cf5c$export$37e5b12cb5a8d560(codec, prefix), $0542a91ee175cf5c$export$fe2b33c81523b294(codec, prefix));
}
// src/fix-codec-size.ts
function $0542a91ee175cf5c$export$cbdfce031443a1(encoder, fixedBytes) {
    return $0542a91ee175cf5c$export$4e76eeb6df88c889({
        fixedSize: fixedBytes,
        write: (value, bytes, offset)=>{
            const variableByteArray = encoder.encode(value);
            const fixedByteArray = variableByteArray.length > fixedBytes ? variableByteArray.slice(0, fixedBytes) : variableByteArray;
            bytes.set(fixedByteArray, offset);
            return offset + fixedBytes;
        }
    });
}
function $0542a91ee175cf5c$export$1f85f8b8d2788007(decoder, fixedBytes) {
    return $0542a91ee175cf5c$export$f8c898e83b60faaa({
        fixedSize: fixedBytes,
        read: (bytes, offset)=>{
            $0542a91ee175cf5c$export$4a981e7c9ed0b6bf("fixCodecSize", fixedBytes, bytes, offset);
            if (offset > 0 || bytes.length > fixedBytes) bytes = bytes.slice(offset, offset + fixedBytes);
            if ($0542a91ee175cf5c$export$f9d60229c95384d4(decoder)) bytes = $0542a91ee175cf5c$export$11b3146a4f4702ef(bytes, decoder.fixedSize);
            const [value] = decoder.read(bytes, 0);
            return [
                value,
                offset + fixedBytes
            ];
        }
    });
}
function $0542a91ee175cf5c$export$ff7dc697d5cc308f(codec, fixedBytes) {
    return $0542a91ee175cf5c$export$b88681b853abde79($0542a91ee175cf5c$export$cbdfce031443a1(codec, fixedBytes), $0542a91ee175cf5c$export$1f85f8b8d2788007(codec, fixedBytes));
}
// src/offset-codec.ts
function $0542a91ee175cf5c$export$92407871fbff8926(encoder, config) {
    return $0542a91ee175cf5c$export$4e76eeb6df88c889({
        ...encoder,
        write: (value, bytes, preOffset)=>{
            const wrapBytes = (offset)=>$0542a91ee175cf5c$var$modulo(offset, bytes.length);
            const newPreOffset = config.preOffset ? config.preOffset({
                bytes: bytes,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : preOffset;
            $0542a91ee175cf5c$export$9319e0aa6a4927d2("offsetEncoder", newPreOffset, bytes.length);
            const postOffset = encoder.write(value, bytes, newPreOffset);
            const newPostOffset = config.postOffset ? config.postOffset({
                bytes: bytes,
                newPreOffset: newPreOffset,
                postOffset: postOffset,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : postOffset;
            $0542a91ee175cf5c$export$9319e0aa6a4927d2("offsetEncoder", newPostOffset, bytes.length);
            return newPostOffset;
        }
    });
}
function $0542a91ee175cf5c$export$24667feddece166a(decoder, config) {
    return $0542a91ee175cf5c$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, preOffset)=>{
            const wrapBytes = (offset)=>$0542a91ee175cf5c$var$modulo(offset, bytes.length);
            const newPreOffset = config.preOffset ? config.preOffset({
                bytes: bytes,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : preOffset;
            $0542a91ee175cf5c$export$9319e0aa6a4927d2("offsetDecoder", newPreOffset, bytes.length);
            const [value, postOffset] = decoder.read(bytes, newPreOffset);
            const newPostOffset = config.postOffset ? config.postOffset({
                bytes: bytes,
                newPreOffset: newPreOffset,
                postOffset: postOffset,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : postOffset;
            $0542a91ee175cf5c$export$9319e0aa6a4927d2("offsetDecoder", newPostOffset, bytes.length);
            return [
                value,
                newPostOffset
            ];
        }
    });
}
function $0542a91ee175cf5c$export$8170ddca0f3f53ea(codec, config) {
    return $0542a91ee175cf5c$export$b88681b853abde79($0542a91ee175cf5c$export$92407871fbff8926(codec, config), $0542a91ee175cf5c$export$24667feddece166a(codec, config));
}
function $0542a91ee175cf5c$var$modulo(dividend, divisor) {
    if (divisor === 0) return 0;
    return (dividend % divisor + divisor) % divisor;
}
function $0542a91ee175cf5c$export$d41c2ca858573bc6(encoder, resize) {
    if ($0542a91ee175cf5c$export$f9d60229c95384d4(encoder)) {
        const fixedSize = resize(encoder.fixedSize);
        if (fixedSize < 0) throw new (0, $68590ac3373b9249$export$8349fd9adaaed269)((0, $68590ac3373b9249$export$4c1fcb4bd20b2951), {
            bytesLength: fixedSize,
            codecDescription: "resizeEncoder"
        });
        return $0542a91ee175cf5c$export$4e76eeb6df88c889({
            ...encoder,
            fixedSize: fixedSize
        });
    }
    return $0542a91ee175cf5c$export$4e76eeb6df88c889({
        ...encoder,
        getSizeFromValue: (value)=>{
            const newSize = resize(encoder.getSizeFromValue(value));
            if (newSize < 0) throw new (0, $68590ac3373b9249$export$8349fd9adaaed269)((0, $68590ac3373b9249$export$4c1fcb4bd20b2951), {
                bytesLength: newSize,
                codecDescription: "resizeEncoder"
            });
            return newSize;
        }
    });
}
function $0542a91ee175cf5c$export$7369e12a03366140(decoder, resize) {
    if ($0542a91ee175cf5c$export$f9d60229c95384d4(decoder)) {
        const fixedSize = resize(decoder.fixedSize);
        if (fixedSize < 0) throw new (0, $68590ac3373b9249$export$8349fd9adaaed269)((0, $68590ac3373b9249$export$4c1fcb4bd20b2951), {
            bytesLength: fixedSize,
            codecDescription: "resizeDecoder"
        });
        return $0542a91ee175cf5c$export$f8c898e83b60faaa({
            ...decoder,
            fixedSize: fixedSize
        });
    }
    return decoder;
}
function $0542a91ee175cf5c$export$aff234b7657ae683(codec, resize) {
    return $0542a91ee175cf5c$export$b88681b853abde79($0542a91ee175cf5c$export$d41c2ca858573bc6(codec, resize), $0542a91ee175cf5c$export$7369e12a03366140(codec, resize));
}
// src/pad-codec.ts
function $0542a91ee175cf5c$export$66b1746799cd3030(encoder, offset) {
    return $0542a91ee175cf5c$export$92407871fbff8926($0542a91ee175cf5c$export$d41c2ca858573bc6(encoder, (size)=>size + offset), {
        preOffset: ({ preOffset: preOffset })=>preOffset + offset
    });
}
function $0542a91ee175cf5c$export$770586d1e6f1e5b(encoder, offset) {
    return $0542a91ee175cf5c$export$92407871fbff8926($0542a91ee175cf5c$export$d41c2ca858573bc6(encoder, (size)=>size + offset), {
        postOffset: ({ postOffset: postOffset })=>postOffset + offset
    });
}
function $0542a91ee175cf5c$export$d88f5bbaa5c2e177(decoder, offset) {
    return $0542a91ee175cf5c$export$24667feddece166a($0542a91ee175cf5c$export$7369e12a03366140(decoder, (size)=>size + offset), {
        preOffset: ({ preOffset: preOffset })=>preOffset + offset
    });
}
function $0542a91ee175cf5c$export$57a7baba87e0aed9(decoder, offset) {
    return $0542a91ee175cf5c$export$24667feddece166a($0542a91ee175cf5c$export$7369e12a03366140(decoder, (size)=>size + offset), {
        postOffset: ({ postOffset: postOffset })=>postOffset + offset
    });
}
function $0542a91ee175cf5c$export$d6ed5bbf596a5505(codec, offset) {
    return $0542a91ee175cf5c$export$b88681b853abde79($0542a91ee175cf5c$export$66b1746799cd3030(codec, offset), $0542a91ee175cf5c$export$d88f5bbaa5c2e177(codec, offset));
}
function $0542a91ee175cf5c$export$b11ce69168faaa31(codec, offset) {
    return $0542a91ee175cf5c$export$b88681b853abde79($0542a91ee175cf5c$export$770586d1e6f1e5b(codec, offset), $0542a91ee175cf5c$export$57a7baba87e0aed9(codec, offset));
}
// src/reverse-codec.ts
function $0542a91ee175cf5c$var$copySourceToTargetInReverse(source, target_WILL_MUTATE, sourceOffset, sourceLength, targetOffset = 0) {
    while(sourceOffset < --sourceLength){
        const leftValue = source[sourceOffset];
        target_WILL_MUTATE[sourceOffset + targetOffset] = source[sourceLength];
        target_WILL_MUTATE[sourceLength + targetOffset] = leftValue;
        sourceOffset++;
    }
    if (sourceOffset === sourceLength) target_WILL_MUTATE[sourceOffset + targetOffset] = source[sourceOffset];
}
function $0542a91ee175cf5c$export$290b4b66fdcc682c(encoder) {
    $0542a91ee175cf5c$export$4e85b7423fd6bc55(encoder);
    return $0542a91ee175cf5c$export$4e76eeb6df88c889({
        ...encoder,
        write: (value, bytes, offset)=>{
            const newOffset = encoder.write(value, bytes, offset);
            $0542a91ee175cf5c$var$copySourceToTargetInReverse(bytes, bytes, offset, offset + encoder.fixedSize);
            return newOffset;
        }
    });
}
function $0542a91ee175cf5c$export$1dded7e9fb3087ff(decoder) {
    $0542a91ee175cf5c$export$4e85b7423fd6bc55(decoder);
    return $0542a91ee175cf5c$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, offset)=>{
            const reversedBytes = bytes.slice();
            $0542a91ee175cf5c$var$copySourceToTargetInReverse(bytes, reversedBytes, offset, offset + decoder.fixedSize);
            return decoder.read(reversedBytes, offset);
        }
    });
}
function $0542a91ee175cf5c$export$e1ef688f83355e2e(codec) {
    return $0542a91ee175cf5c$export$b88681b853abde79($0542a91ee175cf5c$export$290b4b66fdcc682c(codec), $0542a91ee175cf5c$export$1dded7e9fb3087ff(codec));
}
// src/transform-codec.ts
function $0542a91ee175cf5c$export$30169aca64409a56(encoder, unmap) {
    return $0542a91ee175cf5c$export$4e76eeb6df88c889({
        ...$0542a91ee175cf5c$export$d76fd0b6e42f051a(encoder) ? {
            ...encoder,
            getSizeFromValue: (value)=>encoder.getSizeFromValue(unmap(value))
        } : encoder,
        write: (value, bytes, offset)=>encoder.write(unmap(value), bytes, offset)
    });
}
function $0542a91ee175cf5c$export$605b10ee38669daa(decoder, map) {
    return $0542a91ee175cf5c$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, offset)=>{
            const [value, newOffset] = decoder.read(bytes, offset);
            return [
                map(value, bytes, offset),
                newOffset
            ];
        }
    });
}
function $0542a91ee175cf5c$export$59b20038bbe52b5f(codec, unmap, map) {
    return $0542a91ee175cf5c$export$a4cf2f585987cc8({
        ...$0542a91ee175cf5c$export$30169aca64409a56(codec, unmap),
        read: map ? $0542a91ee175cf5c$export$605b10ee38669daa(codec, map).read : codec.read
    });
}
 //# sourceMappingURL=index.browser.mjs.map


// src/assertions.ts
function $d15510cabed22f5e$export$50ab5941a148d055(codecDescription, min, max, value) {
    if (value < min || value > max) throw new (0, $68590ac3373b9249$export$8349fd9adaaed269)((0, $68590ac3373b9249$export$8653c145864f47f4), {
        codecDescription: codecDescription,
        max: max,
        min: min,
        value: value
    });
}
// src/common.ts
var $d15510cabed22f5e$export$54493dce0da47833 = /* @__PURE__ */ ((Endian2)=>{
    Endian2[Endian2["Little"] = 0] = "Little";
    Endian2[Endian2["Big"] = 1] = "Big";
    return Endian2;
})($d15510cabed22f5e$export$54493dce0da47833 || {});
function $d15510cabed22f5e$var$isLittleEndian(config) {
    return config?.endian === 1 /* Big */  ? false : true;
}
function $d15510cabed22f5e$var$numberEncoderFactory(input) {
    return (0, $0542a91ee175cf5c$export$4e76eeb6df88c889)({
        fixedSize: input.size,
        write (value, bytes, offset) {
            if (input.range) $d15510cabed22f5e$export$50ab5941a148d055(input.name, input.range[0], input.range[1], value);
            const arrayBuffer = new ArrayBuffer(input.size);
            input.set(new DataView(arrayBuffer), value, $d15510cabed22f5e$var$isLittleEndian(input.config));
            bytes.set(new Uint8Array(arrayBuffer), offset);
            return offset + input.size;
        }
    });
}
function $d15510cabed22f5e$var$numberDecoderFactory(input) {
    return (0, $0542a91ee175cf5c$export$f8c898e83b60faaa)({
        fixedSize: input.size,
        read (bytes, offset = 0) {
            (0, $0542a91ee175cf5c$export$bf929351331b7b89)(input.name, bytes, offset);
            (0, $0542a91ee175cf5c$export$4a981e7c9ed0b6bf)(input.name, input.size, bytes, offset);
            const view = new DataView($d15510cabed22f5e$var$toArrayBuffer(bytes, offset, input.size));
            return [
                input.get(view, $d15510cabed22f5e$var$isLittleEndian(input.config)),
                offset + input.size
            ];
        }
    });
}
function $d15510cabed22f5e$var$toArrayBuffer(bytes, offset, length) {
    const bytesOffset = bytes.byteOffset + (offset ?? 0);
    const bytesLength = length ?? bytes.byteLength;
    return bytes.buffer.slice(bytesOffset, bytesOffset + bytesLength);
}
// src/f32.ts
var $d15510cabed22f5e$export$d76ef1cfec201bc9 = (config = {})=>$d15510cabed22f5e$var$numberEncoderFactory({
        config: config,
        name: "f32",
        set: (view, value, le)=>view.setFloat32(0, Number(value), le),
        size: 4
    });
var $d15510cabed22f5e$export$314df11445cfa5d0 = (config = {})=>$d15510cabed22f5e$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getFloat32(0, le),
        name: "f32",
        size: 4
    });
var $d15510cabed22f5e$export$97a035f0564c51de = (config = {})=>(0, $0542a91ee175cf5c$export$b88681b853abde79)($d15510cabed22f5e$export$d76ef1cfec201bc9(config), $d15510cabed22f5e$export$314df11445cfa5d0(config));
var $d15510cabed22f5e$export$551368d522177b99 = (config = {})=>$d15510cabed22f5e$var$numberEncoderFactory({
        config: config,
        name: "f64",
        set: (view, value, le)=>view.setFloat64(0, Number(value), le),
        size: 8
    });
var $d15510cabed22f5e$export$9475ae45ddf86dec = (config = {})=>$d15510cabed22f5e$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getFloat64(0, le),
        name: "f64",
        size: 8
    });
var $d15510cabed22f5e$export$9db82e6fbf3ec8ac = (config = {})=>(0, $0542a91ee175cf5c$export$b88681b853abde79)($d15510cabed22f5e$export$551368d522177b99(config), $d15510cabed22f5e$export$9475ae45ddf86dec(config));
var $d15510cabed22f5e$export$cf7587f741407205 = (config = {})=>$d15510cabed22f5e$var$numberEncoderFactory({
        config: config,
        name: "i128",
        range: [
            -BigInt("0x7fffffffffffffffffffffffffffffff") - 1n,
            BigInt("0x7fffffffffffffffffffffffffffffff")
        ],
        set: (view, value, le)=>{
            const leftOffset = le ? 8 : 0;
            const rightOffset = le ? 0 : 8;
            const rightMask = 0xffffffffffffffffn;
            view.setBigInt64(leftOffset, BigInt(value) >> 64n, le);
            view.setBigUint64(rightOffset, BigInt(value) & rightMask, le);
        },
        size: 16
    });
var $d15510cabed22f5e$export$aacd18c97984700c = (config = {})=>$d15510cabed22f5e$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>{
            const leftOffset = le ? 8 : 0;
            const rightOffset = le ? 0 : 8;
            const left = view.getBigInt64(leftOffset, le);
            const right = view.getBigUint64(rightOffset, le);
            return (left << 64n) + right;
        },
        name: "i128",
        size: 16
    });
var $d15510cabed22f5e$export$b2a180b15845f643 = (config = {})=>(0, $0542a91ee175cf5c$export$b88681b853abde79)($d15510cabed22f5e$export$cf7587f741407205(config), $d15510cabed22f5e$export$aacd18c97984700c(config));
var $d15510cabed22f5e$export$45d575c12b2bb6a5 = (config = {})=>$d15510cabed22f5e$var$numberEncoderFactory({
        config: config,
        name: "i16",
        range: [
            -Number("0x7fff") - 1,
            Number("0x7fff")
        ],
        set: (view, value, le)=>view.setInt16(0, Number(value), le),
        size: 2
    });
var $d15510cabed22f5e$export$4617ff1e22909f4 = (config = {})=>$d15510cabed22f5e$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getInt16(0, le),
        name: "i16",
        size: 2
    });
var $d15510cabed22f5e$export$c82cd783a714bca2 = (config = {})=>(0, $0542a91ee175cf5c$export$b88681b853abde79)($d15510cabed22f5e$export$45d575c12b2bb6a5(config), $d15510cabed22f5e$export$4617ff1e22909f4(config));
var $d15510cabed22f5e$export$73a58a16e77bb58b = (config = {})=>$d15510cabed22f5e$var$numberEncoderFactory({
        config: config,
        name: "i32",
        range: [
            -Number("0x7fffffff") - 1,
            Number("0x7fffffff")
        ],
        set: (view, value, le)=>view.setInt32(0, Number(value), le),
        size: 4
    });
var $d15510cabed22f5e$export$a7167d44cb5c65b9 = (config = {})=>$d15510cabed22f5e$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getInt32(0, le),
        name: "i32",
        size: 4
    });
var $d15510cabed22f5e$export$c31d2e083195a86f = (config = {})=>(0, $0542a91ee175cf5c$export$b88681b853abde79)($d15510cabed22f5e$export$73a58a16e77bb58b(config), $d15510cabed22f5e$export$a7167d44cb5c65b9(config));
var $d15510cabed22f5e$export$42b58a304e7edd67 = (config = {})=>$d15510cabed22f5e$var$numberEncoderFactory({
        config: config,
        name: "i64",
        range: [
            -BigInt("0x7fffffffffffffff") - 1n,
            BigInt("0x7fffffffffffffff")
        ],
        set: (view, value, le)=>view.setBigInt64(0, BigInt(value), le),
        size: 8
    });
var $d15510cabed22f5e$export$6f14c9b3a349f404 = (config = {})=>$d15510cabed22f5e$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getBigInt64(0, le),
        name: "i64",
        size: 8
    });
var $d15510cabed22f5e$export$ebdc4dbdba726e6a = (config = {})=>(0, $0542a91ee175cf5c$export$b88681b853abde79)($d15510cabed22f5e$export$42b58a304e7edd67(config), $d15510cabed22f5e$export$6f14c9b3a349f404(config));
var $d15510cabed22f5e$export$44792a8c35b3c0ce = ()=>$d15510cabed22f5e$var$numberEncoderFactory({
        name: "i8",
        range: [
            -Number("0x7f") - 1,
            Number("0x7f")
        ],
        set: (view, value)=>view.setInt8(0, Number(value)),
        size: 1
    });
var $d15510cabed22f5e$export$fdc22c4a59dfe6be = ()=>$d15510cabed22f5e$var$numberDecoderFactory({
        get: (view)=>view.getInt8(0),
        name: "i8",
        size: 1
    });
var $d15510cabed22f5e$export$f930a8952cfab173 = ()=>(0, $0542a91ee175cf5c$export$b88681b853abde79)($d15510cabed22f5e$export$44792a8c35b3c0ce(), $d15510cabed22f5e$export$fdc22c4a59dfe6be());
var $d15510cabed22f5e$export$6f025a6ce2a023fc = ()=>(0, $0542a91ee175cf5c$export$4e76eeb6df88c889)({
        getSizeFromValue: (value)=>{
            if (value <= 127) return 1;
            if (value <= 16383) return 2;
            return 3;
        },
        maxSize: 3,
        write: (value, bytes, offset)=>{
            $d15510cabed22f5e$export$50ab5941a148d055("shortU16", 0, 65535, value);
            const shortU16Bytes = [
                0
            ];
            for(let ii = 0;; ii += 1){
                const alignedValue = Number(value) >> ii * 7;
                if (alignedValue === 0) break;
                const nextSevenBits = 127 & alignedValue;
                shortU16Bytes[ii] = nextSevenBits;
                if (ii > 0) shortU16Bytes[ii - 1] |= 128;
            }
            bytes.set(shortU16Bytes, offset);
            return offset + shortU16Bytes.length;
        }
    });
var $d15510cabed22f5e$export$fa35aa457fb08b4a = ()=>(0, $0542a91ee175cf5c$export$f8c898e83b60faaa)({
        maxSize: 3,
        read: (bytes, offset)=>{
            let value = 0;
            let byteCount = 0;
            while(++byteCount){
                const byteIndex = byteCount - 1;
                const currentByte = bytes[offset + byteIndex];
                const nextSevenBits = 127 & currentByte;
                value |= nextSevenBits << byteIndex * 7;
                if ((currentByte & 128) === 0) break;
            }
            return [
                value,
                offset + byteCount
            ];
        }
    });
var $d15510cabed22f5e$export$9f6b1d6c8cda8e31 = ()=>(0, $0542a91ee175cf5c$export$b88681b853abde79)($d15510cabed22f5e$export$6f025a6ce2a023fc(), $d15510cabed22f5e$export$fa35aa457fb08b4a());
var $d15510cabed22f5e$export$3333225663a8d6bb = (config = {})=>$d15510cabed22f5e$var$numberEncoderFactory({
        config: config,
        name: "u128",
        range: [
            0n,
            BigInt("0xffffffffffffffffffffffffffffffff")
        ],
        set: (view, value, le)=>{
            const leftOffset = le ? 8 : 0;
            const rightOffset = le ? 0 : 8;
            const rightMask = 0xffffffffffffffffn;
            view.setBigUint64(leftOffset, BigInt(value) >> 64n, le);
            view.setBigUint64(rightOffset, BigInt(value) & rightMask, le);
        },
        size: 16
    });
var $d15510cabed22f5e$export$523e33537e060693 = (config = {})=>$d15510cabed22f5e$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>{
            const leftOffset = le ? 8 : 0;
            const rightOffset = le ? 0 : 8;
            const left = view.getBigUint64(leftOffset, le);
            const right = view.getBigUint64(rightOffset, le);
            return (left << 64n) + right;
        },
        name: "u128",
        size: 16
    });
var $d15510cabed22f5e$export$e775878beaafab29 = (config = {})=>(0, $0542a91ee175cf5c$export$b88681b853abde79)($d15510cabed22f5e$export$3333225663a8d6bb(config), $d15510cabed22f5e$export$523e33537e060693(config));
var $d15510cabed22f5e$export$e156211d06496a2f = (config = {})=>$d15510cabed22f5e$var$numberEncoderFactory({
        config: config,
        name: "u16",
        range: [
            0,
            Number("0xffff")
        ],
        set: (view, value, le)=>view.setUint16(0, Number(value), le),
        size: 2
    });
var $d15510cabed22f5e$export$1a649eb0055ac058 = (config = {})=>$d15510cabed22f5e$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getUint16(0, le),
        name: "u16",
        size: 2
    });
var $d15510cabed22f5e$export$dda1212c8afd5e5c = (config = {})=>(0, $0542a91ee175cf5c$export$b88681b853abde79)($d15510cabed22f5e$export$e156211d06496a2f(config), $d15510cabed22f5e$export$1a649eb0055ac058(config));
var $d15510cabed22f5e$export$3e3136013a349951 = (config = {})=>$d15510cabed22f5e$var$numberEncoderFactory({
        config: config,
        name: "u32",
        range: [
            0,
            Number("0xffffffff")
        ],
        set: (view, value, le)=>view.setUint32(0, Number(value), le),
        size: 4
    });
var $d15510cabed22f5e$export$ddc26825031b1ac9 = (config = {})=>$d15510cabed22f5e$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getUint32(0, le),
        name: "u32",
        size: 4
    });
var $d15510cabed22f5e$export$172bf721fe9bbfd1 = (config = {})=>(0, $0542a91ee175cf5c$export$b88681b853abde79)($d15510cabed22f5e$export$3e3136013a349951(config), $d15510cabed22f5e$export$ddc26825031b1ac9(config));
var $d15510cabed22f5e$export$59d3bc8d559487ec = (config = {})=>$d15510cabed22f5e$var$numberEncoderFactory({
        config: config,
        name: "u64",
        range: [
            0n,
            BigInt("0xffffffffffffffff")
        ],
        set: (view, value, le)=>view.setBigUint64(0, BigInt(value), le),
        size: 8
    });
var $d15510cabed22f5e$export$faa05ffebebd465d = (config = {})=>$d15510cabed22f5e$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getBigUint64(0, le),
        name: "u64",
        size: 8
    });
var $d15510cabed22f5e$export$7e56ec13f6029ccc = (config = {})=>(0, $0542a91ee175cf5c$export$b88681b853abde79)($d15510cabed22f5e$export$59d3bc8d559487ec(config), $d15510cabed22f5e$export$faa05ffebebd465d(config));
var $d15510cabed22f5e$export$dc9732115561fb4b = ()=>$d15510cabed22f5e$var$numberEncoderFactory({
        name: "u8",
        range: [
            0,
            Number("0xff")
        ],
        set: (view, value)=>view.setUint8(0, Number(value)),
        size: 1
    });
var $d15510cabed22f5e$export$edadf68f5f1a8bc6 = ()=>$d15510cabed22f5e$var$numberDecoderFactory({
        get: (view)=>view.getUint8(0),
        name: "u8",
        size: 1
    });
var $d15510cabed22f5e$export$5ae2d5c46a10d97 = ()=>(0, $0542a91ee175cf5c$export$b88681b853abde79)($d15510cabed22f5e$export$dc9732115561fb4b(), $d15510cabed22f5e$export$edadf68f5f1a8bc6());
 //# sourceMappingURL=index.browser.mjs.map


/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ class $11e466829bcc37ce$export$58cc9131e3e8861b extends TypeError {
    constructor(failure, failures){
        let cached;
        const { message: message, explanation: explanation, ...rest } = failure;
        const { path: path } = failure;
        const msg = path.length === 0 ? message : `At path: ${path.join(".")} -- ${message}`;
        super(explanation ?? msg);
        if (explanation != null) this.cause = msg;
        Object.assign(this, rest);
        this.name = this.constructor.name;
        this.failures = ()=>{
            return cached ?? (cached = [
                failure,
                ...failures()
            ]);
        };
    }
}
/**
 * Check if a value is an iterator.
 */ function $11e466829bcc37ce$var$isIterable(x) {
    return $11e466829bcc37ce$var$isObject(x) && typeof x[Symbol.iterator] === "function";
}
/**
 * Check if a value is a plain object.
 */ function $11e466829bcc37ce$var$isObject(x) {
    return typeof x === "object" && x != null;
}
/**
 * Check if a value is a non-array object.
 */ function $11e466829bcc37ce$var$isNonArrayObject(x) {
    return $11e466829bcc37ce$var$isObject(x) && !Array.isArray(x);
}
/**
 * Check if a value is a plain object.
 */ function $11e466829bcc37ce$var$isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function $11e466829bcc37ce$var$print(value) {
    if (typeof value === "symbol") return value.toString();
    return typeof value === "string" ? JSON.stringify(value) : `${value}`;
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function $11e466829bcc37ce$var$shiftIterator(input) {
    const { done: done, value: value } = input.next();
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function $11e466829bcc37ce$var$toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === "string") result = {
        message: result
    };
    const { path: path, branch: branch } = context;
    const { type: type } = struct;
    const { refinement: refinement, message: message = `Expected a value of type \`${type}\`${refinement ? ` with refinement \`${refinement}\`` : ""}, but received: \`${$11e466829bcc37ce$var$print(value)}\`` } = result;
    return {
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch,
        ...result,
        message: message
    };
}
/**
 * Convert a validation result to an iterable of failures.
 */ function* $11e466829bcc37ce$var$toFailures(result, context, struct, value) {
    if (!$11e466829bcc37ce$var$isIterable(result)) result = [
        result
    ];
    for (const r of result){
        const failure = $11e466829bcc37ce$var$toFailure(r, context, struct, value);
        if (failure) yield failure;
    }
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function* $11e466829bcc37ce$var$run(value, struct, options = {}) {
    const { path: path = [], branch: branch = [
        value
    ], coerce: coerce = false, mask: mask = false } = options;
    const ctx = {
        path: path,
        branch: branch,
        mask: mask
    };
    if (coerce) value = struct.coercer(value, ctx);
    let status = "valid";
    for (const failure of struct.validator(value, ctx)){
        failure.explanation = options.message;
        status = "not_valid";
        yield [
            failure,
            undefined
        ];
    }
    for (let [k, v, s] of struct.entries(value, ctx)){
        const ts = $11e466829bcc37ce$var$run(v, s, {
            path: k === undefined ? path : [
                ...path,
                k
            ],
            branch: k === undefined ? branch : [
                ...branch,
                v
            ],
            coerce: coerce,
            mask: mask,
            message: options.message
        });
        for (const t of ts){
            if (t[0]) {
                status = t[0].refinement != null ? "not_refined" : "not_valid";
                yield [
                    t[0],
                    undefined
                ];
            } else if (coerce) {
                v = t[1];
                if (k === undefined) value = v;
                else if (value instanceof Map) value.set(k, v);
                else if (value instanceof Set) value.add(v);
                else if ($11e466829bcc37ce$var$isObject(value)) {
                    if (v !== undefined || k in value) value[k] = v;
                }
            }
        }
    }
    if (status !== "not_valid") for (const failure of struct.refiner(value, ctx)){
        failure.explanation = options.message;
        status = "not_refined";
        yield [
            failure,
            undefined
        ];
    }
    if (status === "valid") yield [
        undefined,
        value
    ];
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ class $11e466829bcc37ce$export$eabc71f011df675a {
    constructor(props){
        const { type: type, schema: schema, validator: validator, refiner: refiner, coercer: coercer = (value)=>value, entries: entries = function*() {} } = props;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = (value, context)=>{
            const result = validator(value, context);
            return $11e466829bcc37ce$var$toFailures(result, context, this, value);
        };
        else this.validator = ()=>[];
        if (refiner) this.refiner = (value, context)=>{
            const result = refiner(value, context);
            return $11e466829bcc37ce$var$toFailures(result, context, this, value);
        };
        else this.refiner = ()=>[];
    }
    /**
     * Assert that a value passes the struct's validation, throwing if it doesn't.
     */ assert(value, message) {
        return $11e466829bcc37ce$export$a7a9523472993e97(value, this, message);
    }
    /**
     * Create a value with the struct's coercion logic, then validate it.
     */ create(value, message) {
        return $11e466829bcc37ce$export$185802fd694ee1f5(value, this, message);
    }
    /**
     * Check if a value passes the struct's validation.
     */ is(value) {
        return $11e466829bcc37ce$export$226b3eccf92c9ed9(value, this);
    }
    /**
     * Mask a value, coercing and validating it, but returning only the subset of
     * properties defined by the struct's schema. Masking applies recursively to
     * props of `object` structs only.
     */ mask(value, message) {
        return $11e466829bcc37ce$export$d99f0801a68bbcf1(value, this, message);
    }
    /**
     * Validate a value with the struct's validation logic, returning a tuple
     * representing the result.
     *
     * You may optionally pass `true` for the `coerce` argument to coerce
     * the value before attempting to validate it. If you do, the result will
     * contain the coerced result when successful. Also, `mask` will turn on
     * masking of the unknown `object` props recursively if passed.
     */ validate(value, options = {}) {
        return $11e466829bcc37ce$export$a22775fa5e2eebd9(value, this, options);
    }
}
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function $11e466829bcc37ce$export$a7a9523472993e97(value, struct, message) {
    const result = $11e466829bcc37ce$export$a22775fa5e2eebd9(value, struct, {
        message: message
    });
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function $11e466829bcc37ce$export$185802fd694ee1f5(value, struct, message) {
    const result = $11e466829bcc37ce$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function $11e466829bcc37ce$export$d99f0801a68bbcf1(value, struct, message) {
    const result = $11e466829bcc37ce$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        mask: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function $11e466829bcc37ce$export$226b3eccf92c9ed9(value, struct) {
    const result = $11e466829bcc37ce$export$a22775fa5e2eebd9(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function $11e466829bcc37ce$export$a22775fa5e2eebd9(value, struct, options = {}) {
    const tuples = $11e466829bcc37ce$var$run(value, struct, options);
    const tuple = $11e466829bcc37ce$var$shiftIterator(tuples);
    if (tuple[0]) {
        const error = new $11e466829bcc37ce$export$58cc9131e3e8861b(tuple[0], function*() {
            for (const t of tuples)if (t[0]) yield t[0];
        });
        return [
            error,
            undefined
        ];
    } else {
        const v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function $11e466829bcc37ce$export$e6e34fd1f2686227(...Structs) {
    const isType = Structs[0].type === "type";
    const schemas = Structs.map((s)=>s.schema);
    const schema = Object.assign({}, ...schemas);
    return isType ? $11e466829bcc37ce$export$bf9fb029d174d554(schema) : $11e466829bcc37ce$export$be5493f9613cbbe(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function $11e466829bcc37ce$export$f36d6a7a5c09a23e(name, validator) {
    return new $11e466829bcc37ce$export$eabc71f011df675a({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function $11e466829bcc37ce$export$cdd73fc4100a6ef4(struct, log) {
    return new $11e466829bcc37ce$export$eabc71f011df675a({
        ...struct,
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx),
        validator (value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    });
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function $11e466829bcc37ce$export$7077912c31975674(fn) {
    return new $11e466829bcc37ce$export$eabc71f011df675a({
        type: "dynamic",
        schema: null,
        *entries (value, ctx) {
            const struct = fn(value, ctx);
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            const struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            const struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        },
        refiner (value, ctx) {
            const struct = fn(value, ctx);
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function $11e466829bcc37ce$export$488013bae63b21da(fn) {
    let struct;
    return new $11e466829bcc37ce$export$eabc71f011df675a({
        type: "lazy",
        schema: null,
        *entries (value, ctx) {
            struct ?? (struct = fn());
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            struct ?? (struct = fn());
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            struct ?? (struct = fn());
            return struct.coercer(value, ctx);
        },
        refiner (value, ctx) {
            struct ?? (struct = fn());
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function $11e466829bcc37ce$export$30a06c8d3562193f(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {
        ...schema
    };
    for (const key of keys)delete subschema[key];
    switch(struct.type){
        case "type":
            return $11e466829bcc37ce$export$bf9fb029d174d554(subschema);
        default:
            return $11e466829bcc37ce$export$be5493f9613cbbe(subschema);
    }
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function $11e466829bcc37ce$export$e45945969df8035a(struct) {
    const isStruct = struct instanceof $11e466829bcc37ce$export$eabc71f011df675a;
    const schema = isStruct ? {
        ...struct.schema
    } : {
        ...struct
    };
    for(const key in schema)schema[key] = $11e466829bcc37ce$export$516e28dec6a4b6d4(schema[key]);
    if (isStruct && struct.type === "type") return $11e466829bcc37ce$export$bf9fb029d174d554(schema);
    return $11e466829bcc37ce$export$be5493f9613cbbe(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function $11e466829bcc37ce$export$357523c63a2253b9(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {};
    for (const key of keys)subschema[key] = schema[key];
    switch(struct.type){
        case "type":
            return $11e466829bcc37ce$export$bf9fb029d174d554(subschema);
        default:
            return $11e466829bcc37ce$export$be5493f9613cbbe(subschema);
    }
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function $11e466829bcc37ce$export$8cf3da7c1c9174ea(name, validator) {
    console.warn("superstruct@0.11 - The `struct` helper has been renamed to `define`.");
    return $11e466829bcc37ce$export$f36d6a7a5c09a23e(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function $11e466829bcc37ce$export$4154a199d7d90455() {
    return $11e466829bcc37ce$export$f36d6a7a5c09a23e("any", ()=>true);
}
function $11e466829bcc37ce$export$2f23118c22fb2630(Element) {
    return new $11e466829bcc37ce$export$eabc71f011df675a({
        type: "array",
        schema: Element,
        *entries (value) {
            if (Element && Array.isArray(value)) for (const [i, v] of value.entries())yield [
                i,
                v,
                Element
            ];
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator (value) {
            return Array.isArray(value) || `Expected an array value, but received: ${$11e466829bcc37ce$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a bigint.
 */ function $11e466829bcc37ce$export$a0f65b52274bcc00() {
    return $11e466829bcc37ce$export$f36d6a7a5c09a23e("bigint", (value)=>{
        return typeof value === "bigint";
    });
}
/**
 * Ensure that a value is a boolean.
 */ function $11e466829bcc37ce$export$4a21f16c33752377() {
    return $11e466829bcc37ce$export$f36d6a7a5c09a23e("boolean", (value)=>{
        return typeof value === "boolean";
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function $11e466829bcc37ce$export$324d90190a8b822a() {
    return $11e466829bcc37ce$export$f36d6a7a5c09a23e("date", (value)=>{
        return value instanceof Date && !isNaN(value.getTime()) || `Expected a valid \`Date\` object, but received: ${$11e466829bcc37ce$var$print(value)}`;
    });
}
function $11e466829bcc37ce$export$9b16c434df8cc259(values) {
    const schema = {};
    const description = values.map((v)=>$11e466829bcc37ce$var$print(v)).join();
    for (const key of values)schema[key] = key;
    return new $11e466829bcc37ce$export$eabc71f011df675a({
        type: "enums",
        schema: schema,
        validator (value) {
            return values.includes(value) || `Expected one of \`${description}\`, but received: ${$11e466829bcc37ce$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function $11e466829bcc37ce$export$86951950244e2001() {
    return $11e466829bcc37ce$export$f36d6a7a5c09a23e("func", (value)=>{
        return typeof value === "function" || `Expected a function, but received: ${$11e466829bcc37ce$var$print(value)}`;
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function $11e466829bcc37ce$export$9544d5bb712b01ea(Class) {
    return $11e466829bcc37ce$export$f36d6a7a5c09a23e("instance", (value)=>{
        return value instanceof Class || `Expected a \`${Class.name}\` instance, but received: ${$11e466829bcc37ce$var$print(value)}`;
    });
}
/**
 * Ensure that a value is an integer.
 */ function $11e466829bcc37ce$export$32744b5b3bba4764() {
    return $11e466829bcc37ce$export$f36d6a7a5c09a23e("integer", (value)=>{
        return typeof value === "number" && !isNaN(value) && Number.isInteger(value) || `Expected an integer, but received: ${$11e466829bcc37ce$var$print(value)}`;
    });
}
/**
 * Ensure that a value matches all of a set of types.
 */ function $11e466829bcc37ce$export$bc86dfbf7795668c(Structs) {
    return new $11e466829bcc37ce$export$eabc71f011df675a({
        type: "intersection",
        schema: null,
        *entries (value, ctx) {
            for (const S of Structs)yield* S.entries(value, ctx);
        },
        *validator (value, ctx) {
            for (const S of Structs)yield* S.validator(value, ctx);
        },
        *refiner (value, ctx) {
            for (const S of Structs)yield* S.refiner(value, ctx);
        }
    });
}
function $11e466829bcc37ce$export$c8ec6e1ec9fefcb0(constant) {
    const description = $11e466829bcc37ce$var$print(constant);
    const t = typeof constant;
    return new $11e466829bcc37ce$export$eabc71f011df675a({
        type: "literal",
        schema: t === "string" || t === "number" || t === "boolean" ? constant : null,
        validator (value) {
            return value === constant || `Expected the literal \`${description}\`, but received: ${$11e466829bcc37ce$var$print(value)}`;
        }
    });
}
function $11e466829bcc37ce$export$871de8747c9eaa88(Key, Value) {
    return new $11e466829bcc37ce$export$eabc71f011df675a({
        type: "map",
        schema: null,
        *entries (value) {
            if (Key && Value && value instanceof Map) for (const [k, v] of value.entries()){
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        coercer (value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator (value) {
            return value instanceof Map || `Expected a \`Map\` object, but received: ${$11e466829bcc37ce$var$print(value)}`;
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function $11e466829bcc37ce$export$b3e22bcfd64c1022() {
    return $11e466829bcc37ce$export$f36d6a7a5c09a23e("never", ()=>false);
}
/**
 * Augment an existing struct to allow `null` values.
 */ function $11e466829bcc37ce$export$133fc36489ac9add(struct) {
    return new $11e466829bcc37ce$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === null || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === null || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is a number.
 */ function $11e466829bcc37ce$export$98e628dec113755e() {
    return $11e466829bcc37ce$export$f36d6a7a5c09a23e("number", (value)=>{
        return typeof value === "number" && !isNaN(value) || `Expected a number, but received: ${$11e466829bcc37ce$var$print(value)}`;
    });
}
function $11e466829bcc37ce$export$be5493f9613cbbe(schema) {
    const knowns = schema ? Object.keys(schema) : [];
    const Never = $11e466829bcc37ce$export$b3e22bcfd64c1022();
    return new $11e466829bcc37ce$export$eabc71f011df675a({
        type: "object",
        schema: schema ? schema : null,
        *entries (value) {
            if (schema && $11e466829bcc37ce$var$isObject(value)) {
                const unknowns = new Set(Object.keys(value));
                for (const key of knowns){
                    unknowns.delete(key);
                    yield [
                        key,
                        value[key],
                        schema[key]
                    ];
                }
                for (const key of unknowns)yield [
                    key,
                    value[key],
                    Never
                ];
            }
        },
        validator (value) {
            return $11e466829bcc37ce$var$isNonArrayObject(value) || `Expected an object, but received: ${$11e466829bcc37ce$var$print(value)}`;
        },
        coercer (value, ctx) {
            if (!$11e466829bcc37ce$var$isNonArrayObject(value)) return value;
            const coerced = {
                ...value
            };
            // The `object` struct has special behaviour enabled by the mask flag.
            // When masking, properties that are not in the schema are deleted from
            // the coerced object instead of eventually failing validaiton.
            if (ctx.mask && schema) {
                for(const key in coerced)if (schema[key] === undefined) delete coerced[key];
            }
            return coerced;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function $11e466829bcc37ce$export$516e28dec6a4b6d4(struct) {
    return new $11e466829bcc37ce$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === undefined || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function $11e466829bcc37ce$export$e5185e241753e543(Key, Value) {
    return new $11e466829bcc37ce$export$eabc71f011df675a({
        type: "record",
        schema: null,
        *entries (value) {
            if ($11e466829bcc37ce$var$isObject(value)) for(const k in value){
                const v = value[k];
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        validator (value) {
            return $11e466829bcc37ce$var$isNonArrayObject(value) || `Expected an object, but received: ${$11e466829bcc37ce$var$print(value)}`;
        },
        coercer (value) {
            return $11e466829bcc37ce$var$isNonArrayObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function $11e466829bcc37ce$export$efdc1e5bdb609bb() {
    return $11e466829bcc37ce$export$f36d6a7a5c09a23e("regexp", (value)=>{
        return value instanceof RegExp;
    });
}
function $11e466829bcc37ce$export$adaa4cf7ef1b65be(Element) {
    return new $11e466829bcc37ce$export$eabc71f011df675a({
        type: "set",
        schema: null,
        *entries (value) {
            if (Element && value instanceof Set) for (const v of value)yield [
                v,
                v,
                Element
            ];
        },
        coercer (value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator (value) {
            return value instanceof Set || `Expected a \`Set\` object, but received: ${$11e466829bcc37ce$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function $11e466829bcc37ce$export$22b082955e083ec3() {
    return $11e466829bcc37ce$export$f36d6a7a5c09a23e("string", (value)=>{
        return typeof value === "string" || `Expected a string, but received: ${$11e466829bcc37ce$var$print(value)}`;
    });
}
/**
 * Ensure that a value is a tuple of a specific length, and that each of its
 * elements is of a specific type.
 */ function $11e466829bcc37ce$export$65e3907585753458(Structs) {
    const Never = $11e466829bcc37ce$export$b3e22bcfd64c1022();
    return new $11e466829bcc37ce$export$eabc71f011df675a({
        type: "tuple",
        schema: null,
        *entries (value) {
            if (Array.isArray(value)) {
                const length = Math.max(Structs.length, value.length);
                for(let i = 0; i < length; i++)yield [
                    i,
                    value[i],
                    Structs[i] || Never
                ];
            }
        },
        validator (value) {
            return Array.isArray(value) || `Expected an array, but received: ${$11e466829bcc37ce$var$print(value)}`;
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function $11e466829bcc37ce$export$bf9fb029d174d554(schema) {
    const keys = Object.keys(schema);
    return new $11e466829bcc37ce$export$eabc71f011df675a({
        type: "type",
        schema: schema,
        *entries (value) {
            if ($11e466829bcc37ce$var$isObject(value)) for (const k of keys)yield [
                k,
                value[k],
                schema[k]
            ];
        },
        validator (value) {
            return $11e466829bcc37ce$var$isNonArrayObject(value) || `Expected an object, but received: ${$11e466829bcc37ce$var$print(value)}`;
        },
        coercer (value) {
            return $11e466829bcc37ce$var$isNonArrayObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Ensure that a value matches one of a set of types.
 */ function $11e466829bcc37ce$export$971dd5b0dfd021b6(Structs) {
    const description = Structs.map((s)=>s.type).join(" | ");
    return new $11e466829bcc37ce$export$eabc71f011df675a({
        type: "union",
        schema: null,
        coercer (value, ctx) {
            for (const S of Structs){
                const [error, coerced] = S.validate(value, {
                    coerce: true,
                    mask: ctx.mask
                });
                if (!error) return coerced;
            }
            return value;
        },
        validator (value, ctx) {
            const failures = [];
            for (const S of Structs){
                const [...tuples] = $11e466829bcc37ce$var$run(value, S, ctx);
                const [first] = tuples;
                if (!first[0]) return [];
                else {
                    for (const [failure] of tuples)if (failure) failures.push(failure);
                }
            }
            return [
                `Expected the value to satisfy a union of \`${description}\`, but received: ${$11e466829bcc37ce$var$print(value)}`,
                ...failures
            ];
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function $11e466829bcc37ce$export$19282c40b967aec6() {
    return $11e466829bcc37ce$export$f36d6a7a5c09a23e("unknown", ()=>true);
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $11e466829bcc37ce$export$8c14e57e778d3873(struct, condition, coercer) {
    return new $11e466829bcc37ce$export$eabc71f011df675a({
        ...struct,
        coercer: (value, ctx)=>{
            return $11e466829bcc37ce$export$226b3eccf92c9ed9(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    });
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $11e466829bcc37ce$export$83c510c4356017ae(struct, fallback, options = {}) {
    return $11e466829bcc37ce$export$8c14e57e778d3873(struct, $11e466829bcc37ce$export$19282c40b967aec6(), (x)=>{
        const f = typeof fallback === "function" ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && $11e466829bcc37ce$var$isPlainObject(x) && $11e466829bcc37ce$var$isPlainObject(f)) {
            const ret = {
                ...x
            };
            let changed = false;
            for(const key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $11e466829bcc37ce$export$41f369984ed28930(struct) {
    return $11e466829bcc37ce$export$8c14e57e778d3873(struct, $11e466829bcc37ce$export$22b082955e083ec3(), (x)=>x.trim());
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function $11e466829bcc37ce$export$6e22c362a0406a2c(struct) {
    return $11e466829bcc37ce$export$edc9d475108b3212(struct, "empty", (value)=>{
        const size = $11e466829bcc37ce$var$getSize(value);
        return size === 0 || `Expected an empty ${struct.type} but received one with a size of \`${size}\``;
    });
}
function $11e466829bcc37ce$var$getSize(value) {
    if (value instanceof Map || value instanceof Set) return value.size;
    else return value.length;
}
/**
 * Ensure that a number or date is below a threshold.
 */ function $11e466829bcc37ce$export$8960430cfd85939f(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $11e466829bcc37ce$export$edc9d475108b3212(struct, "max", (value)=>{
        return exclusive ? value < threshold : value <= threshold || `Expected a ${struct.type} less than ${exclusive ? "" : "or equal to "}${threshold} but received \`${value}\``;
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function $11e466829bcc37ce$export$96ec731ed4dcb222(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $11e466829bcc37ce$export$edc9d475108b3212(struct, "min", (value)=>{
        return exclusive ? value > threshold : value >= threshold || `Expected a ${struct.type} greater than ${exclusive ? "" : "or equal to "}${threshold} but received \`${value}\``;
    });
}
/**
 * Ensure that a string, array, map or set is not empty.
 */ function $11e466829bcc37ce$export$6ce6c9218151d511(struct) {
    return $11e466829bcc37ce$export$edc9d475108b3212(struct, "nonempty", (value)=>{
        const size = $11e466829bcc37ce$var$getSize(value);
        return size > 0 || `Expected a nonempty ${struct.type} but received an empty one`;
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function $11e466829bcc37ce$export$24f82734ea047e6f(struct, regexp) {
    return $11e466829bcc37ce$export$edc9d475108b3212(struct, "pattern", (value)=>{
        return regexp.test(value) || `Expected a ${struct.type} matching \`/${regexp.source}/\` but received "${value}"`;
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function $11e466829bcc37ce$export$346677f925de839c(struct, min, max = min) {
    const expected = `Expected a ${struct.type}`;
    const of = min === max ? `of \`${min}\`` : `between \`${min}\` and \`${max}\``;
    return $11e466829bcc37ce$export$edc9d475108b3212(struct, "size", (value)=>{
        if (typeof value === "number" || value instanceof Date) return min <= value && value <= max || `${expected} ${of} but received \`${value}\``;
        else if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return min <= size && size <= max || `${expected} with a size ${of} but received one with a size of \`${size}\``;
        } else {
            const { length: length } = value;
            return min <= length && length <= max || `${expected} with a length ${of} but received one with a length of \`${length}\``;
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function $11e466829bcc37ce$export$edc9d475108b3212(struct, name, refiner) {
    return new $11e466829bcc37ce$export$eabc71f011df675a({
        ...struct,
        *refiner (value, ctx) {
            yield* struct.refiner(value, ctx);
            const result = refiner(value, ctx);
            const failures = $11e466829bcc37ce$var$toFailures(result, ctx, struct, value);
            for (const failure of failures)yield {
                ...failure,
                refinement: name
            };
        }
    });
}


var $a4b42cf2794dd0fd$exports = {};
"use strict";
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $e9a590d0e6dc1a35$var$getRandomValues;
var $e9a590d0e6dc1a35$var$rnds8 = new Uint8Array(16);
function $e9a590d0e6dc1a35$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$e9a590d0e6dc1a35$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $e9a590d0e6dc1a35$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$e9a590d0e6dc1a35$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $e9a590d0e6dc1a35$var$getRandomValues($e9a590d0e6dc1a35$var$rnds8);
}


var $0e1a6deb19c25dd4$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $5ed09d944b6ac18f$var$validate(uuid) {
    return typeof uuid === "string" && (0, $0e1a6deb19c25dd4$export$2e2bcd8739ae039).test(uuid);
}
var $5ed09d944b6ac18f$export$2e2bcd8739ae039 = $5ed09d944b6ac18f$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $6161f3955c61bad2$var$byteToHex = [];
for(var $6161f3955c61bad2$var$i = 0; $6161f3955c61bad2$var$i < 256; ++$6161f3955c61bad2$var$i)$6161f3955c61bad2$var$byteToHex.push(($6161f3955c61bad2$var$i + 0x100).toString(16).substr(1));
function $6161f3955c61bad2$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($6161f3955c61bad2$var$byteToHex[arr[offset + 0]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 1]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 2]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 3]] + "-" + $6161f3955c61bad2$var$byteToHex[arr[offset + 4]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 5]] + "-" + $6161f3955c61bad2$var$byteToHex[arr[offset + 6]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 7]] + "-" + $6161f3955c61bad2$var$byteToHex[arr[offset + 8]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 9]] + "-" + $6161f3955c61bad2$var$byteToHex[arr[offset + 10]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 11]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 12]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 13]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 14]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $5ed09d944b6ac18f$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $6161f3955c61bad2$export$2e2bcd8739ae039 = $6161f3955c61bad2$var$stringify;


function $5d7f1dba4fbacab8$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $e9a590d0e6dc1a35$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $6161f3955c61bad2$export$2e2bcd8739ae039)(rnds);
}
var $5d7f1dba4fbacab8$export$2e2bcd8739ae039 = $5d7f1dba4fbacab8$var$v4;


var $a4b42cf2794dd0fd$require$uuid = $5d7f1dba4fbacab8$export$2e2bcd8739ae039;
var $d3f0b2d708f771de$exports = {};
"use strict";

var $d3f0b2d708f771de$require$uuid = $5d7f1dba4fbacab8$export$2e2bcd8739ae039;
/**
 *  Generates a JSON-RPC 1.0 or 2.0 request
 *  @param {String} method Name of method to call
 *  @param {Array|Object} params Array of parameters passed to the method as specified, or an object of parameter names and corresponding value
 *  @param {String|Number|null} [id] Request ID can be a string, number, null for explicit notification or left out for automatic generation
 *  @param {Object} [options]
 *  @param {Number} [options.version=2] JSON-RPC version to use (1 or 2)
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 *  @param {Function} [options.generator] Passed the request, and the options object and is expected to return a request ID
 *  @throws {TypeError} If any of the parameters are invalid
 *  @return {Object} A JSON-RPC 1.0 or 2.0 request
 *  @memberOf Utils
 */ const $d3f0b2d708f771de$var$generateRequest = function(method, params, id, options) {
    if (typeof method !== "string") throw new TypeError(method + " must be a string");
    options = options || {};
    // check valid version provided
    const version = typeof options.version === "number" ? options.version : 2;
    if (version !== 1 && version !== 2) throw new TypeError(version + " must be 1 or 2");
    const request = {
        method: method
    };
    if (version === 2) request.jsonrpc = "2.0";
    if (params) {
        // params given, but invalid?
        if (typeof params !== "object" && !Array.isArray(params)) throw new TypeError(params + " must be an object, array or omitted");
        request.params = params;
    }
    // if id was left out, generate one (null means explicit notification)
    if (typeof id === "undefined") {
        const generator = typeof options.generator === "function" ? options.generator : function() {
            return $d3f0b2d708f771de$require$uuid();
        };
        request.id = generator(request, options);
    } else if (version === 2 && id === null) // we have a version 2 notification
    {
        if (options.notificationIdNull) request.id = null; // id will not be set at all unless option provided
    } else request.id = id;
    return request;
};
$d3f0b2d708f771de$exports = $d3f0b2d708f771de$var$generateRequest;


/**
 * Constructor for a Jayson Browser Client that does not depend any node.js core libraries
 * @class ClientBrowser
 * @param {Function} callServer Method that calls the server, receives the stringified request and a regular node-style callback
 * @param {Object} [options]
 * @param {Function} [options.reviver] Reviver function for JSON
 * @param {Function} [options.replacer] Replacer function for JSON
 * @param {Number} [options.version=2] JSON-RPC version to use (1|2)
 * @param {Function} [options.generator] Function to use for generating request IDs
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 * @return {ClientBrowser}
 */ const $a4b42cf2794dd0fd$var$ClientBrowser = function(callServer, options) {
    if (!(this instanceof $a4b42cf2794dd0fd$var$ClientBrowser)) return new $a4b42cf2794dd0fd$var$ClientBrowser(callServer, options);
    if (!options) options = {};
    this.options = {
        reviver: typeof options.reviver !== "undefined" ? options.reviver : null,
        replacer: typeof options.replacer !== "undefined" ? options.replacer : null,
        generator: typeof options.generator !== "undefined" ? options.generator : function() {
            return $a4b42cf2794dd0fd$require$uuid();
        },
        version: typeof options.version !== "undefined" ? options.version : 2,
        notificationIdNull: typeof options.notificationIdNull === "boolean" ? options.notificationIdNull : false
    };
    this.callServer = callServer;
};
$a4b42cf2794dd0fd$exports = $a4b42cf2794dd0fd$var$ClientBrowser;
/**
 *  Creates a request and dispatches it if given a callback.
 *  @param {String|Array} method A batch request if passed an Array, or a method name if passed a String
 *  @param {Array|Object} [params] Parameters for the method
 *  @param {String|Number} [id] Optional id. If undefined an id will be generated. If null it creates a notification request
 *  @param {Function} [callback] Request callback. If specified, executes the request rather than only returning it.
 *  @throws {TypeError} Invalid parameters
 *  @return {Object} JSON-RPC 1.0 or 2.0 compatible request
 */ $a4b42cf2794dd0fd$var$ClientBrowser.prototype.request = function(method, params, id, callback) {
    const self = this;
    let request = null;
    // is this a batch request?
    const isBatch = Array.isArray(method) && typeof params === "function";
    if (this.options.version === 1 && isBatch) throw new TypeError("JSON-RPC 1.0 does not support batching");
    // is this a raw request?
    const isRaw = !isBatch && method && typeof method === "object" && typeof params === "function";
    if (isBatch || isRaw) {
        callback = params;
        request = method;
    } else {
        if (typeof id === "function") {
            callback = id;
            // specifically undefined because "null" is a notification request
            id = undefined;
        }
        const hasCallback = typeof callback === "function";
        try {
            request = $d3f0b2d708f771de$exports(method, params, id, {
                generator: this.options.generator,
                version: this.options.version,
                notificationIdNull: this.options.notificationIdNull
            });
        } catch (err) {
            if (hasCallback) return callback(err);
            throw err;
        }
        // no callback means we should just return a raw request
        if (!hasCallback) return request;
    }
    let message;
    try {
        message = JSON.stringify(request, this.options.replacer);
    } catch (err) {
        return callback(err);
    }
    this.callServer(message, function(err, response) {
        self._parseResponse(err, response, callback);
    });
    // always return the raw request
    return request;
};
/**
 * Parses a response from a server
 * @param {Object} err Error to pass on that is unrelated to the actual response
 * @param {String} responseText JSON-RPC 1.0 or 2.0 response
 * @param {Function} callback Callback that will receive different arguments depending on the amount of parameters
 * @private
 */ $a4b42cf2794dd0fd$var$ClientBrowser.prototype._parseResponse = function(err, responseText, callback) {
    if (err) {
        callback(err);
        return;
    }
    if (!responseText) // empty response text, assume that is correct because it could be a
    // notification which jayson does not give any body for
    return callback();
    let response;
    try {
        response = JSON.parse(responseText, this.options.reviver);
    } catch (err) {
        return callback(err);
    }
    if (callback.length === 3) {
        // if callback length is 3, we split callback arguments on error and response
        // is batch response?
        if (Array.isArray(response)) {
            // neccesary to split strictly on validity according to spec here
            const isError = function(res) {
                return typeof res.error !== "undefined";
            };
            const isNotError = function(res) {
                return !isError(res);
            };
            return callback(null, response.filter(isError), response.filter(isNotError));
        } else // split regardless of validity
        return callback(null, response.error, response.result);
    }
    callback(null, response);
};



var $lewJ9 = parcelRequire("lewJ9");
parcelRequire("e7UPq");
var $1P3yO = parcelRequire("1P3yO");
// node_modules/esbuild-plugin-polyfill-node/polyfills/buffer.js
var $188fda512f3e94b2$var$WebSocketBrowserImpl = class extends (0, (/*@__PURE__*/$parcel$interopDefault($1P3yO))) {
    socket;
    /** Instantiate a WebSocket class
  * @constructor
  * @param {String} address - url to a websocket server
  * @param {(Object)} options - websocket options
  * @param {(String|Array)} protocols - a list of protocols
  * @return {WebSocketBrowserImpl} - returns a WebSocket instance
  */ constructor(address, options, protocols){
        super();
        this.socket = new window.WebSocket(address, protocols);
        this.socket.onopen = ()=>this.emit("open");
        this.socket.onmessage = (event)=>this.emit("message", event.data);
        this.socket.onerror = (error)=>this.emit("error", error);
        this.socket.onclose = (event)=>{
            this.emit("close", event.code, event.reason);
        };
    }
    /**
  * Sends data through a websocket connection
  * @method
  * @param {(String|Object)} data - data to be sent via websocket
  * @param {Object} optionsOrCallback - ws options
  * @param {Function} callback - a callback called once the data is sent
  * @return {Undefined}
  */ send(data, optionsOrCallback, callback) {
        const cb = callback || optionsOrCallback;
        try {
            this.socket.send(data);
            cb();
        } catch (error) {
            cb(error);
        }
    }
    /**
  * Closes an underlying socket
  * @method
  * @param {Number} code - status code explaining why the connection is being closed
  * @param {String} reason - a description why the connection is closing
  * @return {Undefined}
  * @throws {Error}
  */ close(code, reason) {
        this.socket.close(code, reason);
    }
    addEventListener(type, listener, options) {
        this.socket.addEventListener(type, listener, options);
    }
};
function $188fda512f3e94b2$export$3909fb301d3dc8c9(address, options) {
    return new $188fda512f3e94b2$var$WebSocketBrowserImpl(address, options);
}
// src/lib/utils.ts
var $188fda512f3e94b2$export$9fd32f4b4353d82d = class {
    encode(value) {
        return JSON.stringify(value);
    }
    decode(value) {
        return JSON.parse(value);
    }
};
// src/lib/client.ts
var $188fda512f3e94b2$export$b43a6d9568fa5272 = class extends (0, (/*@__PURE__*/$parcel$interopDefault($1P3yO))) {
    address;
    rpc_id;
    queue;
    options;
    autoconnect;
    ready;
    reconnect;
    reconnect_timer_id;
    reconnect_interval;
    max_reconnects;
    rest_options;
    current_reconnects;
    generate_request_id;
    socket;
    webSocketFactory;
    dataPack;
    /**
  * Instantiate a Client class.
  * @constructor
  * @param {webSocketFactory} webSocketFactory - factory method for WebSocket
  * @param {String} address - url to a websocket server
  * @param {Object} options - ws options object with reconnect parameters
  * @param {Function} generate_request_id - custom generation request Id
  * @param {DataPack} dataPack - data pack contains encoder and decoder
  * @return {CommonClient}
  */ constructor(webSocketFactory, address = "ws://localhost:8080", { autoconnect: autoconnect = true, reconnect: reconnect = true, reconnect_interval: reconnect_interval = 1e3, max_reconnects: max_reconnects = 5, ...rest_options } = {}, generate_request_id, dataPack){
        super();
        this.webSocketFactory = webSocketFactory;
        this.queue = {};
        this.rpc_id = 0;
        this.address = address;
        this.autoconnect = autoconnect;
        this.ready = false;
        this.reconnect = reconnect;
        this.reconnect_timer_id = void 0;
        this.reconnect_interval = reconnect_interval;
        this.max_reconnects = max_reconnects;
        this.rest_options = rest_options;
        this.current_reconnects = 0;
        this.generate_request_id = generate_request_id || (()=>typeof this.rpc_id === "number" ? ++this.rpc_id : Number(this.rpc_id) + 1);
        if (!dataPack) this.dataPack = new $188fda512f3e94b2$export$9fd32f4b4353d82d();
        else this.dataPack = dataPack;
        if (this.autoconnect) this._connect(this.address, {
            autoconnect: this.autoconnect,
            reconnect: this.reconnect,
            reconnect_interval: this.reconnect_interval,
            max_reconnects: this.max_reconnects,
            ...this.rest_options
        });
    }
    /**
  * Connects to a defined server if not connected already.
  * @method
  * @return {Undefined}
  */ connect() {
        if (this.socket) return;
        this._connect(this.address, {
            autoconnect: this.autoconnect,
            reconnect: this.reconnect,
            reconnect_interval: this.reconnect_interval,
            max_reconnects: this.max_reconnects,
            ...this.rest_options
        });
    }
    /**
  * Calls a registered RPC method on server.
  * @method
  * @param {String} method - RPC method name
  * @param {Object|Array} params - optional method parameters
  * @param {Number} timeout - RPC reply timeout value
  * @param {Object} ws_opts - options passed to ws
  * @return {Promise}
  */ call(method, params, timeout, ws_opts) {
        if (!ws_opts && "object" === typeof timeout) {
            ws_opts = timeout;
            timeout = null;
        }
        return new Promise((resolve, reject)=>{
            if (!this.ready) return reject(new Error("socket not ready"));
            const rpc_id = this.generate_request_id(method, params);
            const message = {
                jsonrpc: "2.0",
                method: method,
                params: params || void 0,
                id: rpc_id
            };
            this.socket.send(this.dataPack.encode(message), ws_opts, (error)=>{
                if (error) return reject(error);
                this.queue[rpc_id] = {
                    promise: [
                        resolve,
                        reject
                    ]
                };
                if (timeout) this.queue[rpc_id].timeout = setTimeout(()=>{
                    delete this.queue[rpc_id];
                    reject(new Error("reply timeout"));
                }, timeout);
            });
        });
    }
    /**
  * Logins with the other side of the connection.
  * @method
  * @param {Object} params - Login credentials object
  * @return {Promise}
  */ async login(params) {
        const resp = await this.call("rpc.login", params);
        if (!resp) throw new Error("authentication failed");
        return resp;
    }
    /**
  * Fetches a list of client's methods registered on server.
  * @method
  * @return {Array}
  */ async listMethods() {
        return await this.call("__listMethods");
    }
    /**
  * Sends a JSON-RPC 2.0 notification to server.
  * @method
  * @param {String} method - RPC method name
  * @param {Object} params - optional method parameters
  * @return {Promise}
  */ notify(method, params) {
        return new Promise((resolve, reject)=>{
            if (!this.ready) return reject(new Error("socket not ready"));
            const message = {
                jsonrpc: "2.0",
                method: method,
                params: params
            };
            this.socket.send(this.dataPack.encode(message), (error)=>{
                if (error) return reject(error);
                resolve();
            });
        });
    }
    /**
  * Subscribes for a defined event.
  * @method
  * @param {String|Array} event - event name
  * @return {Undefined}
  * @throws {Error}
  */ async subscribe(event) {
        if (typeof event === "string") event = [
            event
        ];
        const result = await this.call("rpc.on", event);
        if (typeof event === "string" && result[event] !== "ok") throw new Error("Failed subscribing to an event '" + event + "' with: " + result[event]);
        return result;
    }
    /**
  * Unsubscribes from a defined event.
  * @method
  * @param {String|Array} event - event name
  * @return {Undefined}
  * @throws {Error}
  */ async unsubscribe(event) {
        if (typeof event === "string") event = [
            event
        ];
        const result = await this.call("rpc.off", event);
        if (typeof event === "string" && result[event] !== "ok") throw new Error("Failed unsubscribing from an event with: " + result);
        return result;
    }
    /**
  * Closes a WebSocket connection gracefully.
  * @method
  * @param {Number} code - socket close code
  * @param {String} data - optional data to be sent before closing
  * @return {Undefined}
  */ close(code, data) {
        this.socket.close(code || 1e3, data);
    }
    /**
  * Enable / disable automatic reconnection.
  * @method
  * @param {Boolean} reconnect - enable / disable reconnection
  * @return {Undefined}
  */ setAutoReconnect(reconnect) {
        this.reconnect = reconnect;
    }
    /**
  * Set the interval between reconnection attempts.
  * @method
  * @param {Number} interval - reconnection interval in milliseconds
  * @return {Undefined}
  */ setReconnectInterval(interval) {
        this.reconnect_interval = interval;
    }
    /**
  * Set the maximum number of reconnection attempts.
  * @method
  * @param {Number} max_reconnects - maximum reconnection attempts
  * @return {Undefined}
  */ setMaxReconnects(max_reconnects) {
        this.max_reconnects = max_reconnects;
    }
    /**
  * Connection/Message handler.
  * @method
  * @private
  * @param {String} address - WebSocket API address
  * @param {Object} options - ws options object
  * @return {Undefined}
  */ _connect(address, options) {
        clearTimeout(this.reconnect_timer_id);
        this.socket = this.webSocketFactory(address, options);
        this.socket.addEventListener("open", ()=>{
            this.ready = true;
            this.emit("open");
            this.current_reconnects = 0;
        });
        this.socket.addEventListener("message", ({ data: message })=>{
            if (message instanceof ArrayBuffer) message = (0, $lewJ9.Buffer).from(message).toString();
            try {
                message = this.dataPack.decode(message);
            } catch (error) {
                return;
            }
            if (message.notification && this.listeners(message.notification).length) {
                if (!Object.keys(message.params).length) return this.emit(message.notification);
                const args = [
                    message.notification
                ];
                if (message.params.constructor === Object) args.push(message.params);
                else for(let i = 0; i < message.params.length; i++)args.push(message.params[i]);
                return Promise.resolve().then(()=>{
                    this.emit.apply(this, args);
                });
            }
            if (!this.queue[message.id]) {
                if (message.method) return Promise.resolve().then(()=>{
                    this.emit(message.method, message?.params);
                });
                return;
            }
            if ("error" in message === "result" in message) this.queue[message.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.'));
            if (this.queue[message.id].timeout) clearTimeout(this.queue[message.id].timeout);
            if (message.error) this.queue[message.id].promise[1](message.error);
            else this.queue[message.id].promise[0](message.result);
            delete this.queue[message.id];
        });
        this.socket.addEventListener("error", (error)=>this.emit("error", error));
        this.socket.addEventListener("close", ({ code: code, reason: reason })=>{
            if (this.ready) setTimeout(()=>this.emit("close", code, reason), 0);
            this.ready = false;
            this.socket = void 0;
            if (code === 1e3) return;
            this.current_reconnects++;
            if (this.reconnect && (this.max_reconnects > this.current_reconnects || this.max_reconnects === 0)) this.reconnect_timer_id = setTimeout(()=>this._connect(address, options), this.reconnect_interval);
        });
    }
};
// src/index.browser.ts
var $188fda512f3e94b2$export$1f2bb630327ac4b6 = class extends $188fda512f3e94b2$export$b43a6d9568fa5272 {
    constructor(address = "ws://localhost:8080", { autoconnect: autoconnect = true, reconnect: reconnect = true, reconnect_interval: reconnect_interval = 1e3, max_reconnects: max_reconnects = 5 } = {}, generate_request_id){
        super($188fda512f3e94b2$export$3909fb301d3dc8c9, address, {
            autoconnect: autoconnect,
            reconnect: reconnect,
            reconnect_interval: reconnect_interval,
            max_reconnects: max_reconnects
        }, generate_request_id);
    }
};
 //# sourceMappingURL=out.js.map



var $j0one = parcelRequire("j0one");

var $7pdKa = parcelRequire("7pdKa");
/**
 * A 64 byte secret key, the first 32 bytes of which is the
 * private scalar and the last 32 bytes is the public key.
 * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
 */ /**
 * Ed25519 Keypair
 */ const $bccf75ed4dec0420$var$generatePrivateKey = (0, $2866510f4dc204d4$export$f63794f4a09a19c1).utils.randomPrivateKey;
const $bccf75ed4dec0420$var$generateKeypair = ()=>{
    const privateScalar = (0, $2866510f4dc204d4$export$f63794f4a09a19c1).utils.randomPrivateKey();
    const publicKey = $bccf75ed4dec0420$var$getPublicKey(privateScalar);
    const secretKey = new Uint8Array(64);
    secretKey.set(privateScalar);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
};
const $bccf75ed4dec0420$var$getPublicKey = (0, $2866510f4dc204d4$export$f63794f4a09a19c1).getPublicKey;
function $bccf75ed4dec0420$var$isOnCurve(publicKey) {
    try {
        (0, $2866510f4dc204d4$export$f63794f4a09a19c1).ExtendedPoint.fromHex(publicKey);
        return true;
    } catch  {
        return false;
    }
}
const $bccf75ed4dec0420$var$sign = (message, secretKey)=>(0, $2866510f4dc204d4$export$f63794f4a09a19c1).sign(message, secretKey.slice(0, 32));
const $bccf75ed4dec0420$var$verify = (0, $2866510f4dc204d4$export$f63794f4a09a19c1).verify;
const $bccf75ed4dec0420$var$toBuffer = (arr)=>{
    if ((0, $lewJ9.Buffer).isBuffer(arr)) return arr;
    else if (arr instanceof Uint8Array) return (0, $lewJ9.Buffer).from(arr.buffer, arr.byteOffset, arr.byteLength);
    else return (0, $lewJ9.Buffer).from(arr);
};
// Class wrapping a plain object
class $bccf75ed4dec0420$export$eabc71f011df675a {
    constructor(properties){
        Object.assign(this, properties);
    }
    encode() {
        return (0, $lewJ9.Buffer).from((0, $14466b1998da68ad$exports.serialize)($bccf75ed4dec0420$export$68d13ce9b4cc48f3, this));
    }
    static decode(data) {
        return (0, $14466b1998da68ad$exports.deserialize)($bccf75ed4dec0420$export$68d13ce9b4cc48f3, this, data);
    }
    static decodeUnchecked(data) {
        return (0, $14466b1998da68ad$exports.deserializeUnchecked)($bccf75ed4dec0420$export$68d13ce9b4cc48f3, this, data);
    }
}
// Class representing a Rust-compatible enum, since enums are only strings or
// numbers in pure JS
class $bccf75ed4dec0420$export$deb82508dd66d288 extends $bccf75ed4dec0420$export$eabc71f011df675a {
    constructor(properties){
        super(properties);
        this.enum = "";
        if (Object.keys(properties).length !== 1) throw new Error("Enum can only take single value");
        Object.keys(properties).map((key)=>{
            this.enum = key;
        });
    }
}
const $bccf75ed4dec0420$export$68d13ce9b4cc48f3 = new Map();
var $bccf75ed4dec0420$var$_PublicKey;
/**
 * Maximum length of derived pubkey seed
 */ const $bccf75ed4dec0420$export$8240f9da84ad7873 = 32;
/**
 * Size of public key in bytes
 */ const $bccf75ed4dec0420$export$84fc0a248cc54343 = 32;
/**
 * Value to be converted into public key
 */ /**
 * JSON object representation of PublicKey class
 */ function $bccf75ed4dec0420$var$isPublicKeyData(value) {
    return value._bn !== undefined;
}
// local counter used by PublicKey.unique()
let $bccf75ed4dec0420$var$uniquePublicKeyCounter = 1;
/**
 * A public key
 */ class $bccf75ed4dec0420$export$ca8b6604d6ce14de extends $bccf75ed4dec0420$export$eabc71f011df675a {
    /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */ constructor(value){
        super({});
        /** @internal */ this._bn = void 0;
        if ($bccf75ed4dec0420$var$isPublicKeyData(value)) this._bn = value._bn;
        else {
            if (typeof value === "string") {
                // assume base 58 encoding by default
                const decoded = (0, (/*@__PURE__*/$parcel$interopDefault($4fa1ea39de93f4d6$exports))).decode(value);
                if (decoded.length != $bccf75ed4dec0420$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
                this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($lCikh)))(decoded);
            } else this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($lCikh)))(value);
            if (this._bn.byteLength() > $bccf75ed4dec0420$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
        }
    }
    /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */ static unique() {
        const key = new $bccf75ed4dec0420$export$ca8b6604d6ce14de($bccf75ed4dec0420$var$uniquePublicKeyCounter);
        $bccf75ed4dec0420$var$uniquePublicKeyCounter += 1;
        return new $bccf75ed4dec0420$export$ca8b6604d6ce14de(key.toBuffer());
    }
    /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */ /**
   * Checks if two publicKeys are equal
   */ equals(publicKey) {
        return this._bn.eq(publicKey._bn);
    }
    /**
   * Return the base-58 representation of the public key
   */ toBase58() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($4fa1ea39de93f4d6$exports))).encode(this.toBytes());
    }
    toJSON() {
        return this.toBase58();
    }
    /**
   * Return the byte array representation of the public key in big endian
   */ toBytes() {
        const buf = this.toBuffer();
        return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    }
    /**
   * Return the Buffer representation of the public key in big endian
   */ toBuffer() {
        const b = this._bn.toArrayLike((0, $lewJ9.Buffer));
        if (b.length === $bccf75ed4dec0420$export$84fc0a248cc54343) return b;
        const zeroPad = (0, $lewJ9.Buffer).alloc(32);
        b.copy(zeroPad, 32 - b.length);
        return zeroPad;
    }
    get [Symbol.toStringTag]() {
        return `PublicKey(${this.toString()})`;
    }
    /**
   * Return the base-58 representation of the public key
   */ toString() {
        return this.toBase58();
    }
    /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */ /* eslint-disable require-await */ static async createWithSeed(fromPublicKey, seed, programId) {
        const buffer = (0, $lewJ9.Buffer).concat([
            fromPublicKey.toBuffer(),
            (0, $lewJ9.Buffer).from(seed),
            programId.toBuffer()
        ]);
        const publicKeyBytes = (0, $6kbuD.sha256)(buffer);
        return new $bccf75ed4dec0420$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Derive a program address from seeds and a program ID.
   */ /* eslint-disable require-await */ static createProgramAddressSync(seeds, programId) {
        let buffer = (0, $lewJ9.Buffer).alloc(0);
        seeds.forEach(function(seed) {
            if (seed.length > $bccf75ed4dec0420$export$8240f9da84ad7873) throw new TypeError(`Max seed length exceeded`);
            buffer = (0, $lewJ9.Buffer).concat([
                buffer,
                $bccf75ed4dec0420$var$toBuffer(seed)
            ]);
        });
        buffer = (0, $lewJ9.Buffer).concat([
            buffer,
            programId.toBuffer(),
            (0, $lewJ9.Buffer).from("ProgramDerivedAddress")
        ]);
        const publicKeyBytes = (0, $6kbuD.sha256)(buffer);
        if ($bccf75ed4dec0420$var$isOnCurve(publicKeyBytes)) throw new Error(`Invalid seeds, address must fall off the curve`);
        return new $bccf75ed4dec0420$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */ /* eslint-disable require-await */ static async createProgramAddress(seeds, programId) {
        return this.createProgramAddressSync(seeds, programId);
    }
    /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */ static findProgramAddressSync(seeds, programId) {
        let nonce = 255;
        let address;
        while(nonce != 0){
            try {
                const seedsWithNonce = seeds.concat((0, $lewJ9.Buffer).from([
                    nonce
                ]));
                address = this.createProgramAddressSync(seedsWithNonce, programId);
            } catch (err) {
                if (err instanceof TypeError) throw err;
                nonce--;
                continue;
            }
            return [
                address,
                nonce
            ];
        }
        throw new Error(`Unable to find a viable program address nonce`);
    }
    /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */ static async findProgramAddress(seeds, programId) {
        return this.findProgramAddressSync(seeds, programId);
    }
    /**
   * Check that a pubkey is on the ed25519 curve.
   */ static isOnCurve(pubkeyData) {
        const pubkey = new $bccf75ed4dec0420$export$ca8b6604d6ce14de(pubkeyData);
        return $bccf75ed4dec0420$var$isOnCurve(pubkey.toBytes());
    }
}
$bccf75ed4dec0420$var$_PublicKey = $bccf75ed4dec0420$export$ca8b6604d6ce14de;
$bccf75ed4dec0420$export$ca8b6604d6ce14de.default = new $bccf75ed4dec0420$var$_PublicKey("11111111111111111111111111111111");
$bccf75ed4dec0420$export$68d13ce9b4cc48f3.set($bccf75ed4dec0420$export$ca8b6604d6ce14de, {
    kind: "struct",
    fields: [
        [
            "_bn",
            "u256"
        ]
    ]
});
/**
 * An account key pair (public and secret keys).
 *
 * @deprecated since v1.10.0, please use {@link Keypair} instead.
 */ class $bccf75ed4dec0420$export$1ed4b10e4aba04a7 {
    /**
   * Create a new Account object
   *
   * If the secretKey parameter is not provided a new key pair is randomly
   * created for the account
   *
   * @param secretKey Secret key for the account
   */ constructor(secretKey){
        /** @internal */ this._publicKey = void 0;
        /** @internal */ this._secretKey = void 0;
        if (secretKey) {
            const secretKeyBuffer = $bccf75ed4dec0420$var$toBuffer(secretKey);
            if (secretKey.length !== 64) throw new Error("bad secret key size");
            this._publicKey = secretKeyBuffer.slice(32, 64);
            this._secretKey = secretKeyBuffer.slice(0, 32);
        } else {
            this._secretKey = $bccf75ed4dec0420$var$toBuffer($bccf75ed4dec0420$var$generatePrivateKey());
            this._publicKey = $bccf75ed4dec0420$var$toBuffer($bccf75ed4dec0420$var$getPublicKey(this._secretKey));
        }
    }
    /**
   * The public key for this account
   */ get publicKey() {
        return new $bccf75ed4dec0420$export$ca8b6604d6ce14de(this._publicKey);
    }
    /**
   * The **unencrypted** secret key for this account. The first 32 bytes
   * is the private scalar and the last 32 bytes is the public key.
   * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */ get secretKey() {
        return (0, $lewJ9.Buffer).concat([
            this._secretKey,
            this._publicKey
        ], 64);
    }
}
const $bccf75ed4dec0420$export$42bd37c1c64962b6 = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("BPFLoader1111111111111111111111111111111111");
/**
 * Maximum over-the-wire size of a Transaction
 *
 * 1280 is IPv6 minimum MTU
 * 40 bytes is the size of the IPv6 header
 * 8 bytes is the size of the fragment header
 */ const $bccf75ed4dec0420$export$4c6d5b89e1596f26 = 1232;
const $bccf75ed4dec0420$export$3c3793d809f8b858 = 0x7f;
const $bccf75ed4dec0420$export$14aee086fde78fa6 = 64;
class $bccf75ed4dec0420$export$718fcd78527f88ed extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: block height exceeded.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($bccf75ed4dec0420$export$718fcd78527f88ed.prototype, "name", {
    value: "TransactionExpiredBlockheightExceededError"
});
class $bccf75ed4dec0420$export$b822204c22e46bdf extends Error {
    constructor(signature, timeoutSeconds){
        super(`Transaction was not confirmed in ${timeoutSeconds.toFixed(2)} seconds. It is ` + "unknown if it succeeded or failed. Check signature " + `${signature} using the Solana Explorer or CLI tools.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($bccf75ed4dec0420$export$b822204c22e46bdf.prototype, "name", {
    value: "TransactionExpiredTimeoutError"
});
class $bccf75ed4dec0420$export$a3e7565a95f5a1e5 extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: the nonce is no longer valid.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($bccf75ed4dec0420$export$a3e7565a95f5a1e5.prototype, "name", {
    value: "TransactionExpiredNonceInvalidError"
});
class $bccf75ed4dec0420$export$109914c107623102 {
    constructor(staticAccountKeys, accountKeysFromLookups){
        this.staticAccountKeys = void 0;
        this.accountKeysFromLookups = void 0;
        this.staticAccountKeys = staticAccountKeys;
        this.accountKeysFromLookups = accountKeysFromLookups;
    }
    keySegments() {
        const keySegments = [
            this.staticAccountKeys
        ];
        if (this.accountKeysFromLookups) {
            keySegments.push(this.accountKeysFromLookups.writable);
            keySegments.push(this.accountKeysFromLookups.readonly);
        }
        return keySegments;
    }
    get(index) {
        for (const keySegment of this.keySegments()){
            if (index < keySegment.length) return keySegment[index];
            else index -= keySegment.length;
        }
        return;
    }
    get length() {
        return this.keySegments().flat().length;
    }
    compileInstructions(instructions) {
        // Bail early if any account indexes would overflow a u8
        const U8_MAX = 255;
        if (this.length > U8_MAX + 1) throw new Error("Account index overflow encountered during compilation");
        const keyIndexMap = new Map();
        this.keySegments().flat().forEach((key, index)=>{
            keyIndexMap.set(key.toBase58(), index);
        });
        const findKeyIndex = (key)=>{
            const keyIndex = keyIndexMap.get(key.toBase58());
            if (keyIndex === undefined) throw new Error("Encountered an unknown instruction account key during compilation");
            return keyIndex;
        };
        return instructions.map((instruction)=>{
            return {
                programIdIndex: findKeyIndex(instruction.programId),
                accountKeyIndexes: instruction.keys.map((meta)=>findKeyIndex(meta.pubkey)),
                data: instruction.data
            };
        });
    }
}
/**
 * Layout for a public key
 */ const $bccf75ed4dec0420$var$publicKey = (property = "publicKey")=>{
    return $10b678223f208f49$exports.blob(32, property);
};
/**
 * Layout for a signature
 */ const $bccf75ed4dec0420$var$signature = (property = "signature")=>{
    return $10b678223f208f49$exports.blob(64, property);
};
/**
 * Layout for a Rust String type
 */ const $bccf75ed4dec0420$var$rustString = (property = "string")=>{
    const rsl = $10b678223f208f49$exports.struct([
        $10b678223f208f49$exports.u32("length"),
        $10b678223f208f49$exports.u32("lengthPadding"),
        $10b678223f208f49$exports.blob($10b678223f208f49$exports.offset($10b678223f208f49$exports.u32(), -8), "chars")
    ], property);
    const _decode = rsl.decode.bind(rsl);
    const _encode = rsl.encode.bind(rsl);
    const rslShim = rsl;
    rslShim.decode = (b, offset)=>{
        const data = _decode(b, offset);
        return data["chars"].toString();
    };
    rslShim.encode = (str, b, offset)=>{
        const data = {
            chars: (0, $lewJ9.Buffer).from(str, "utf8")
        };
        return _encode(data, b, offset);
    };
    rslShim.alloc = (str)=>{
        return $10b678223f208f49$exports.u32().span + $10b678223f208f49$exports.u32().span + (0, $lewJ9.Buffer).from(str, "utf8").length;
    };
    return rslShim;
};
/**
 * Layout for an Authorized object
 */ const $bccf75ed4dec0420$var$authorized = (property = "authorized")=>{
    return $10b678223f208f49$exports.struct([
        $bccf75ed4dec0420$var$publicKey("staker"),
        $bccf75ed4dec0420$var$publicKey("withdrawer")
    ], property);
};
/**
 * Layout for a Lockup object
 */ const $bccf75ed4dec0420$var$lockup = (property = "lockup")=>{
    return $10b678223f208f49$exports.struct([
        $10b678223f208f49$exports.ns64("unixTimestamp"),
        $10b678223f208f49$exports.ns64("epoch"),
        $bccf75ed4dec0420$var$publicKey("custodian")
    ], property);
};
/**
 *  Layout for a VoteInit object
 */ const $bccf75ed4dec0420$var$voteInit = (property = "voteInit")=>{
    return $10b678223f208f49$exports.struct([
        $bccf75ed4dec0420$var$publicKey("nodePubkey"),
        $bccf75ed4dec0420$var$publicKey("authorizedVoter"),
        $bccf75ed4dec0420$var$publicKey("authorizedWithdrawer"),
        $10b678223f208f49$exports.u8("commission")
    ], property);
};
/**
 *  Layout for a VoteAuthorizeWithSeedArgs object
 */ const $bccf75ed4dec0420$var$voteAuthorizeWithSeedArgs = (property = "voteAuthorizeWithSeedArgs")=>{
    return $10b678223f208f49$exports.struct([
        $10b678223f208f49$exports.u32("voteAuthorizationType"),
        $bccf75ed4dec0420$var$publicKey("currentAuthorityDerivedKeyOwnerPubkey"),
        $bccf75ed4dec0420$var$rustString("currentAuthorityDerivedKeySeed"),
        $bccf75ed4dec0420$var$publicKey("newAuthorized")
    ], property);
};
function $bccf75ed4dec0420$var$getAlloc(type, fields) {
    const getItemAlloc = (item)=>{
        if (item.span >= 0) return item.span;
        else if (typeof item.alloc === "function") return item.alloc(fields[item.property]);
        else if ("count" in item && "elementLayout" in item) {
            const field = fields[item.property];
            if (Array.isArray(field)) return field.length * getItemAlloc(item.elementLayout);
        } else if ("fields" in item) // This is a `Structure` whose size needs to be recursively measured.
        return $bccf75ed4dec0420$var$getAlloc({
            layout: item
        }, fields[item.property]);
        // Couldn't determine allocated size of layout
        return 0;
    };
    let alloc = 0;
    type.layout.fields.forEach((item)=>{
        alloc += getItemAlloc(item);
    });
    return alloc;
}
function $bccf75ed4dec0420$var$decodeLength(bytes) {
    let len = 0;
    let size = 0;
    for(;;){
        let elem = bytes.shift();
        len |= (elem & 0x7f) << size * 7;
        size += 1;
        if ((elem & 0x80) === 0) break;
    }
    return len;
}
function $bccf75ed4dec0420$var$encodeLength(bytes, len) {
    let rem_len = len;
    for(;;){
        let elem = rem_len & 0x7f;
        rem_len >>= 7;
        if (rem_len == 0) {
            bytes.push(elem);
            break;
        } else {
            elem |= 0x80;
            bytes.push(elem);
        }
    }
}
function $bccf75ed4dec0420$var$assert(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}
class $bccf75ed4dec0420$var$CompiledKeys {
    constructor(payer, keyMetaMap){
        this.payer = void 0;
        this.keyMetaMap = void 0;
        this.payer = payer;
        this.keyMetaMap = keyMetaMap;
    }
    static compile(instructions, payer) {
        const keyMetaMap = new Map();
        const getOrInsertDefault = (pubkey)=>{
            const address = pubkey.toBase58();
            let keyMeta = keyMetaMap.get(address);
            if (keyMeta === undefined) {
                keyMeta = {
                    isSigner: false,
                    isWritable: false,
                    isInvoked: false
                };
                keyMetaMap.set(address, keyMeta);
            }
            return keyMeta;
        };
        const payerKeyMeta = getOrInsertDefault(payer);
        payerKeyMeta.isSigner = true;
        payerKeyMeta.isWritable = true;
        for (const ix of instructions){
            getOrInsertDefault(ix.programId).isInvoked = true;
            for (const accountMeta of ix.keys){
                const keyMeta = getOrInsertDefault(accountMeta.pubkey);
                keyMeta.isSigner ||= accountMeta.isSigner;
                keyMeta.isWritable ||= accountMeta.isWritable;
            }
        }
        return new $bccf75ed4dec0420$var$CompiledKeys(payer, keyMetaMap);
    }
    getMessageComponents() {
        const mapEntries = [
            ...this.keyMetaMap.entries()
        ];
        $bccf75ed4dec0420$var$assert(mapEntries.length <= 256, "Max static account keys length exceeded");
        const writableSigners = mapEntries.filter(([, meta])=>meta.isSigner && meta.isWritable);
        const readonlySigners = mapEntries.filter(([, meta])=>meta.isSigner && !meta.isWritable);
        const writableNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && meta.isWritable);
        const readonlyNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && !meta.isWritable);
        const header = {
            numRequiredSignatures: writableSigners.length + readonlySigners.length,
            numReadonlySignedAccounts: readonlySigners.length,
            numReadonlyUnsignedAccounts: readonlyNonSigners.length
        };
        // sanity checks
        {
            $bccf75ed4dec0420$var$assert(writableSigners.length > 0, "Expected at least one writable signer key");
            const [payerAddress] = writableSigners[0];
            $bccf75ed4dec0420$var$assert(payerAddress === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
        }
        const staticAccountKeys = [
            ...writableSigners.map(([address])=>new $bccf75ed4dec0420$export$ca8b6604d6ce14de(address)),
            ...readonlySigners.map(([address])=>new $bccf75ed4dec0420$export$ca8b6604d6ce14de(address)),
            ...writableNonSigners.map(([address])=>new $bccf75ed4dec0420$export$ca8b6604d6ce14de(address)),
            ...readonlyNonSigners.map(([address])=>new $bccf75ed4dec0420$export$ca8b6604d6ce14de(address))
        ];
        return [
            header,
            staticAccountKeys
        ];
    }
    extractTableLookup(lookupTable) {
        const [writableIndexes, drainedWritableKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && keyMeta.isWritable);
        const [readonlyIndexes, drainedReadonlyKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && !keyMeta.isWritable);
        // Don't extract lookup if no keys were found
        if (writableIndexes.length === 0 && readonlyIndexes.length === 0) return;
        return [
            {
                accountKey: lookupTable.key,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            },
            {
                writable: drainedWritableKeys,
                readonly: drainedReadonlyKeys
            }
        ];
    }
    /** @internal */ drainKeysFoundInLookupTable(lookupTableEntries, keyMetaFilter) {
        const lookupTableIndexes = new Array();
        const drainedKeys = new Array();
        for (const [address, keyMeta] of this.keyMetaMap.entries())if (keyMetaFilter(keyMeta)) {
            const key = new $bccf75ed4dec0420$export$ca8b6604d6ce14de(address);
            const lookupTableIndex = lookupTableEntries.findIndex((entry)=>entry.equals(key));
            if (lookupTableIndex >= 0) {
                $bccf75ed4dec0420$var$assert(lookupTableIndex < 256, "Max lookup table index exceeded");
                lookupTableIndexes.push(lookupTableIndex);
                drainedKeys.push(key);
                this.keyMetaMap.delete(address);
            }
        }
        return [
            lookupTableIndexes,
            drainedKeys
        ];
    }
}
const $bccf75ed4dec0420$var$END_OF_BUFFER_ERROR_MESSAGE = "Reached end of buffer unexpectedly";
/**
 * Delegates to `Array#shift`, but throws if the array is zero-length.
 */ function $bccf75ed4dec0420$var$guardedShift(byteArray) {
    if (byteArray.length === 0) throw new Error($bccf75ed4dec0420$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.shift();
}
/**
 * Delegates to `Array#splice`, but throws if the section being spliced out extends past the end of
 * the array.
 */ function $bccf75ed4dec0420$var$guardedSplice(byteArray, ...args) {
    const [start] = args;
    if (args.length === 2 // Implies that `deleteCount` was supplied
     ? start + (args[1] ?? 0) > byteArray.length : start >= byteArray.length) throw new Error($bccf75ed4dec0420$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.splice(...args);
}
/**
 * An instruction to execute by a program
 *
 * @property {number} programIdIndex
 * @property {number[]} accounts
 * @property {string} data
 */ /**
 * Message constructor arguments
 */ /**
 * List of instructions to be processed atomically
 */ class $bccf75ed4dec0420$export$f69c19e57285b83a {
    constructor(args){
        this.header = void 0;
        this.accountKeys = void 0;
        this.recentBlockhash = void 0;
        this.instructions = void 0;
        this.indexToProgramIds = new Map();
        this.header = args.header;
        this.accountKeys = args.accountKeys.map((account)=>new $bccf75ed4dec0420$export$ca8b6604d6ce14de(account));
        this.recentBlockhash = args.recentBlockhash;
        this.instructions = args.instructions;
        this.instructions.forEach((ix)=>this.indexToProgramIds.set(ix.programIdIndex, this.accountKeys[ix.programIdIndex]));
    }
    get version() {
        return "legacy";
    }
    get staticAccountKeys() {
        return this.accountKeys;
    }
    get compiledInstructions() {
        return this.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($4fa1ea39de93f4d6$exports))).decode(ix.data)
            }));
    }
    get addressTableLookups() {
        return [];
    }
    getAccountKeys() {
        return new $bccf75ed4dec0420$export$109914c107623102(this.staticAccountKeys);
    }
    static compile(args) {
        const compiledKeys = $bccf75ed4dec0420$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $bccf75ed4dec0420$export$109914c107623102(staticAccountKeys);
        const instructions = accountKeys.compileInstructions(args.instructions).map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accounts: ix.accountKeyIndexes,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($4fa1ea39de93f4d6$exports))).encode(ix.data)
            }));
        return new $bccf75ed4dec0420$export$f69c19e57285b83a({
            header: header,
            accountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            instructions: instructions
        });
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = this.accountKeys.length - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    isProgramId(index) {
        return this.indexToProgramIds.has(index);
    }
    programIds() {
        return [
            ...this.indexToProgramIds.values()
        ];
    }
    nonProgramIds() {
        return this.accountKeys.filter((_, index)=>!this.isProgramId(index));
    }
    serialize() {
        const numKeys = this.accountKeys.length;
        let keyCount = [];
        $bccf75ed4dec0420$var$encodeLength(keyCount, numKeys);
        const instructions = this.instructions.map((instruction)=>{
            const { accounts: accounts, programIdIndex: programIdIndex } = instruction;
            const data = Array.from((0, (/*@__PURE__*/$parcel$interopDefault($4fa1ea39de93f4d6$exports))).decode(instruction.data));
            let keyIndicesCount = [];
            $bccf75ed4dec0420$var$encodeLength(keyIndicesCount, accounts.length);
            let dataCount = [];
            $bccf75ed4dec0420$var$encodeLength(dataCount, data.length);
            return {
                programIdIndex: programIdIndex,
                keyIndicesCount: (0, $lewJ9.Buffer).from(keyIndicesCount),
                keyIndices: accounts,
                dataLength: (0, $lewJ9.Buffer).from(dataCount),
                data: data
            };
        });
        let instructionCount = [];
        $bccf75ed4dec0420$var$encodeLength(instructionCount, instructions.length);
        let instructionBuffer = (0, $lewJ9.Buffer).alloc($bccf75ed4dec0420$export$4c6d5b89e1596f26);
        (0, $lewJ9.Buffer).from(instructionCount).copy(instructionBuffer);
        let instructionBufferLength = instructionCount.length;
        instructions.forEach((instruction)=>{
            const instructionLayout = $10b678223f208f49$exports.struct([
                $10b678223f208f49$exports.u8("programIdIndex"),
                $10b678223f208f49$exports.blob(instruction.keyIndicesCount.length, "keyIndicesCount"),
                $10b678223f208f49$exports.seq($10b678223f208f49$exports.u8("keyIndex"), instruction.keyIndices.length, "keyIndices"),
                $10b678223f208f49$exports.blob(instruction.dataLength.length, "dataLength"),
                $10b678223f208f49$exports.seq($10b678223f208f49$exports.u8("userdatum"), instruction.data.length, "data")
            ]);
            const length = instructionLayout.encode(instruction, instructionBuffer, instructionBufferLength);
            instructionBufferLength += length;
        });
        instructionBuffer = instructionBuffer.slice(0, instructionBufferLength);
        const signDataLayout = $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.blob(1, "numRequiredSignatures"),
            $10b678223f208f49$exports.blob(1, "numReadonlySignedAccounts"),
            $10b678223f208f49$exports.blob(1, "numReadonlyUnsignedAccounts"),
            $10b678223f208f49$exports.blob(keyCount.length, "keyCount"),
            $10b678223f208f49$exports.seq($bccf75ed4dec0420$var$publicKey("key"), numKeys, "keys"),
            $bccf75ed4dec0420$var$publicKey("recentBlockhash")
        ]);
        const transaction = {
            numRequiredSignatures: (0, $lewJ9.Buffer).from([
                this.header.numRequiredSignatures
            ]),
            numReadonlySignedAccounts: (0, $lewJ9.Buffer).from([
                this.header.numReadonlySignedAccounts
            ]),
            numReadonlyUnsignedAccounts: (0, $lewJ9.Buffer).from([
                this.header.numReadonlyUnsignedAccounts
            ]),
            keyCount: (0, $lewJ9.Buffer).from(keyCount),
            keys: this.accountKeys.map((key)=>$bccf75ed4dec0420$var$toBuffer(key.toBytes())),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($4fa1ea39de93f4d6$exports))).decode(this.recentBlockhash)
        };
        let signData = (0, $lewJ9.Buffer).alloc(2048);
        const length = signDataLayout.encode(transaction, signData);
        instructionBuffer.copy(signData, length);
        return signData.slice(0, length + instructionBuffer.length);
    }
    /**
   * Decode a compiled message into a Message object.
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const numRequiredSignatures = $bccf75ed4dec0420$var$guardedShift(byteArray);
        if (numRequiredSignatures !== (numRequiredSignatures & $bccf75ed4dec0420$export$3c3793d809f8b858)) throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
        const numReadonlySignedAccounts = $bccf75ed4dec0420$var$guardedShift(byteArray);
        const numReadonlyUnsignedAccounts = $bccf75ed4dec0420$var$guardedShift(byteArray);
        const accountCount = $bccf75ed4dec0420$var$decodeLength(byteArray);
        let accountKeys = [];
        for(let i = 0; i < accountCount; i++){
            const account = $bccf75ed4dec0420$var$guardedSplice(byteArray, 0, $bccf75ed4dec0420$export$84fc0a248cc54343);
            accountKeys.push(new $bccf75ed4dec0420$export$ca8b6604d6ce14de((0, $lewJ9.Buffer).from(account)));
        }
        const recentBlockhash = $bccf75ed4dec0420$var$guardedSplice(byteArray, 0, $bccf75ed4dec0420$export$84fc0a248cc54343);
        const instructionCount = $bccf75ed4dec0420$var$decodeLength(byteArray);
        let instructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = $bccf75ed4dec0420$var$guardedShift(byteArray);
            const accountCount = $bccf75ed4dec0420$var$decodeLength(byteArray);
            const accounts = $bccf75ed4dec0420$var$guardedSplice(byteArray, 0, accountCount);
            const dataLength = $bccf75ed4dec0420$var$decodeLength(byteArray);
            const dataSlice = $bccf75ed4dec0420$var$guardedSplice(byteArray, 0, dataLength);
            const data = (0, (/*@__PURE__*/$parcel$interopDefault($4fa1ea39de93f4d6$exports))).encode((0, $lewJ9.Buffer).from(dataSlice));
            instructions.push({
                programIdIndex: programIdIndex,
                accounts: accounts,
                data: data
            });
        }
        const messageArgs = {
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($4fa1ea39de93f4d6$exports))).encode((0, $lewJ9.Buffer).from(recentBlockhash)),
            accountKeys: accountKeys,
            instructions: instructions
        };
        return new $bccf75ed4dec0420$export$f69c19e57285b83a(messageArgs);
    }
}
/**
 * Message constructor arguments
 */ class $bccf75ed4dec0420$export$ee274c70e0fae590 {
    constructor(args){
        this.header = void 0;
        this.staticAccountKeys = void 0;
        this.recentBlockhash = void 0;
        this.compiledInstructions = void 0;
        this.addressTableLookups = void 0;
        this.header = args.header;
        this.staticAccountKeys = args.staticAccountKeys;
        this.recentBlockhash = args.recentBlockhash;
        this.compiledInstructions = args.compiledInstructions;
        this.addressTableLookups = args.addressTableLookups;
    }
    get version() {
        return 0;
    }
    get numAccountKeysFromLookups() {
        let count = 0;
        for (const lookup of this.addressTableLookups)count += lookup.readonlyIndexes.length + lookup.writableIndexes.length;
        return count;
    }
    getAccountKeys(args) {
        let accountKeysFromLookups;
        if (args && "accountKeysFromLookups" in args && args.accountKeysFromLookups) {
            if (this.numAccountKeysFromLookups != args.accountKeysFromLookups.writable.length + args.accountKeysFromLookups.readonly.length) throw new Error("Failed to get account keys because of a mismatch in the number of account keys from lookups");
            accountKeysFromLookups = args.accountKeysFromLookups;
        } else if (args && "addressLookupTableAccounts" in args && args.addressLookupTableAccounts) accountKeysFromLookups = this.resolveAddressTableLookups(args.addressLookupTableAccounts);
        else if (this.addressTableLookups.length > 0) throw new Error("Failed to get account keys because address table lookups were not resolved");
        return new $bccf75ed4dec0420$export$109914c107623102(this.staticAccountKeys, accountKeysFromLookups);
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        const numStaticAccountKeys = this.staticAccountKeys.length;
        if (index >= numStaticAccountKeys) {
            const lookupAccountKeysIndex = index - numStaticAccountKeys;
            const numWritableLookupAccountKeys = this.addressTableLookups.reduce((count, lookup)=>count + lookup.writableIndexes.length, 0);
            return lookupAccountKeysIndex < numWritableLookupAccountKeys;
        } else if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = numStaticAccountKeys - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    resolveAddressTableLookups(addressLookupTableAccounts) {
        const accountKeysFromLookups = {
            writable: [],
            readonly: []
        };
        for (const tableLookup of this.addressTableLookups){
            const tableAccount = addressLookupTableAccounts.find((account)=>account.key.equals(tableLookup.accountKey));
            if (!tableAccount) throw new Error(`Failed to find address lookup table account for table key ${tableLookup.accountKey.toBase58()}`);
            for (const index of tableLookup.writableIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.writable.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
            for (const index of tableLookup.readonlyIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.readonly.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
        }
        return accountKeysFromLookups;
    }
    static compile(args) {
        const compiledKeys = $bccf75ed4dec0420$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const addressTableLookups = new Array();
        const accountKeysFromLookups = {
            writable: new Array(),
            readonly: new Array()
        };
        const lookupTableAccounts = args.addressLookupTableAccounts || [];
        for (const lookupTable of lookupTableAccounts){
            const extractResult = compiledKeys.extractTableLookup(lookupTable);
            if (extractResult !== undefined) {
                const [addressTableLookup, { writable: writable, readonly: readonly }] = extractResult;
                addressTableLookups.push(addressTableLookup);
                accountKeysFromLookups.writable.push(...writable);
                accountKeysFromLookups.readonly.push(...readonly);
            }
        }
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $bccf75ed4dec0420$export$109914c107623102(staticAccountKeys, accountKeysFromLookups);
        const compiledInstructions = accountKeys.compileInstructions(args.instructions);
        return new $bccf75ed4dec0420$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
    serialize() {
        const encodedStaticAccountKeysLength = Array();
        $bccf75ed4dec0420$var$encodeLength(encodedStaticAccountKeysLength, this.staticAccountKeys.length);
        const serializedInstructions = this.serializeInstructions();
        const encodedInstructionsLength = Array();
        $bccf75ed4dec0420$var$encodeLength(encodedInstructionsLength, this.compiledInstructions.length);
        const serializedAddressTableLookups = this.serializeAddressTableLookups();
        const encodedAddressTableLookupsLength = Array();
        $bccf75ed4dec0420$var$encodeLength(encodedAddressTableLookupsLength, this.addressTableLookups.length);
        const messageLayout = $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u8("prefix"),
            $10b678223f208f49$exports.struct([
                $10b678223f208f49$exports.u8("numRequiredSignatures"),
                $10b678223f208f49$exports.u8("numReadonlySignedAccounts"),
                $10b678223f208f49$exports.u8("numReadonlyUnsignedAccounts")
            ], "header"),
            $10b678223f208f49$exports.blob(encodedStaticAccountKeysLength.length, "staticAccountKeysLength"),
            $10b678223f208f49$exports.seq($bccf75ed4dec0420$var$publicKey(), this.staticAccountKeys.length, "staticAccountKeys"),
            $bccf75ed4dec0420$var$publicKey("recentBlockhash"),
            $10b678223f208f49$exports.blob(encodedInstructionsLength.length, "instructionsLength"),
            $10b678223f208f49$exports.blob(serializedInstructions.length, "serializedInstructions"),
            $10b678223f208f49$exports.blob(encodedAddressTableLookupsLength.length, "addressTableLookupsLength"),
            $10b678223f208f49$exports.blob(serializedAddressTableLookups.length, "serializedAddressTableLookups")
        ]);
        const serializedMessage = new Uint8Array($bccf75ed4dec0420$export$4c6d5b89e1596f26);
        const MESSAGE_VERSION_0_PREFIX = 128;
        const serializedMessageLength = messageLayout.encode({
            prefix: MESSAGE_VERSION_0_PREFIX,
            header: this.header,
            staticAccountKeysLength: new Uint8Array(encodedStaticAccountKeysLength),
            staticAccountKeys: this.staticAccountKeys.map((key)=>key.toBytes()),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($4fa1ea39de93f4d6$exports))).decode(this.recentBlockhash),
            instructionsLength: new Uint8Array(encodedInstructionsLength),
            serializedInstructions: serializedInstructions,
            addressTableLookupsLength: new Uint8Array(encodedAddressTableLookupsLength),
            serializedAddressTableLookups: serializedAddressTableLookups
        }, serializedMessage);
        return serializedMessage.slice(0, serializedMessageLength);
    }
    serializeInstructions() {
        let serializedLength = 0;
        const serializedInstructions = new Uint8Array($bccf75ed4dec0420$export$4c6d5b89e1596f26);
        for (const instruction of this.compiledInstructions){
            const encodedAccountKeyIndexesLength = Array();
            $bccf75ed4dec0420$var$encodeLength(encodedAccountKeyIndexesLength, instruction.accountKeyIndexes.length);
            const encodedDataLength = Array();
            $bccf75ed4dec0420$var$encodeLength(encodedDataLength, instruction.data.length);
            const instructionLayout = $10b678223f208f49$exports.struct([
                $10b678223f208f49$exports.u8("programIdIndex"),
                $10b678223f208f49$exports.blob(encodedAccountKeyIndexesLength.length, "encodedAccountKeyIndexesLength"),
                $10b678223f208f49$exports.seq($10b678223f208f49$exports.u8(), instruction.accountKeyIndexes.length, "accountKeyIndexes"),
                $10b678223f208f49$exports.blob(encodedDataLength.length, "encodedDataLength"),
                $10b678223f208f49$exports.blob(instruction.data.length, "data")
            ]);
            serializedLength += instructionLayout.encode({
                programIdIndex: instruction.programIdIndex,
                encodedAccountKeyIndexesLength: new Uint8Array(encodedAccountKeyIndexesLength),
                accountKeyIndexes: instruction.accountKeyIndexes,
                encodedDataLength: new Uint8Array(encodedDataLength),
                data: instruction.data
            }, serializedInstructions, serializedLength);
        }
        return serializedInstructions.slice(0, serializedLength);
    }
    serializeAddressTableLookups() {
        let serializedLength = 0;
        const serializedAddressTableLookups = new Uint8Array($bccf75ed4dec0420$export$4c6d5b89e1596f26);
        for (const lookup of this.addressTableLookups){
            const encodedWritableIndexesLength = Array();
            $bccf75ed4dec0420$var$encodeLength(encodedWritableIndexesLength, lookup.writableIndexes.length);
            const encodedReadonlyIndexesLength = Array();
            $bccf75ed4dec0420$var$encodeLength(encodedReadonlyIndexesLength, lookup.readonlyIndexes.length);
            const addressTableLookupLayout = $10b678223f208f49$exports.struct([
                $bccf75ed4dec0420$var$publicKey("accountKey"),
                $10b678223f208f49$exports.blob(encodedWritableIndexesLength.length, "encodedWritableIndexesLength"),
                $10b678223f208f49$exports.seq($10b678223f208f49$exports.u8(), lookup.writableIndexes.length, "writableIndexes"),
                $10b678223f208f49$exports.blob(encodedReadonlyIndexesLength.length, "encodedReadonlyIndexesLength"),
                $10b678223f208f49$exports.seq($10b678223f208f49$exports.u8(), lookup.readonlyIndexes.length, "readonlyIndexes")
            ]);
            serializedLength += addressTableLookupLayout.encode({
                accountKey: lookup.accountKey.toBytes(),
                encodedWritableIndexesLength: new Uint8Array(encodedWritableIndexesLength),
                writableIndexes: lookup.writableIndexes,
                encodedReadonlyIndexesLength: new Uint8Array(encodedReadonlyIndexesLength),
                readonlyIndexes: lookup.readonlyIndexes
            }, serializedAddressTableLookups, serializedLength);
        }
        return serializedAddressTableLookups.slice(0, serializedLength);
    }
    static deserialize(serializedMessage) {
        let byteArray = [
            ...serializedMessage
        ];
        const prefix = $bccf75ed4dec0420$var$guardedShift(byteArray);
        const maskedPrefix = prefix & $bccf75ed4dec0420$export$3c3793d809f8b858;
        $bccf75ed4dec0420$var$assert(prefix !== maskedPrefix, `Expected versioned message but received legacy message`);
        const version = maskedPrefix;
        $bccf75ed4dec0420$var$assert(version === 0, `Expected versioned message with version 0 but found version ${version}`);
        const header = {
            numRequiredSignatures: $bccf75ed4dec0420$var$guardedShift(byteArray),
            numReadonlySignedAccounts: $bccf75ed4dec0420$var$guardedShift(byteArray),
            numReadonlyUnsignedAccounts: $bccf75ed4dec0420$var$guardedShift(byteArray)
        };
        const staticAccountKeys = [];
        const staticAccountKeysLength = $bccf75ed4dec0420$var$decodeLength(byteArray);
        for(let i = 0; i < staticAccountKeysLength; i++)staticAccountKeys.push(new $bccf75ed4dec0420$export$ca8b6604d6ce14de($bccf75ed4dec0420$var$guardedSplice(byteArray, 0, $bccf75ed4dec0420$export$84fc0a248cc54343)));
        const recentBlockhash = (0, (/*@__PURE__*/$parcel$interopDefault($4fa1ea39de93f4d6$exports))).encode($bccf75ed4dec0420$var$guardedSplice(byteArray, 0, $bccf75ed4dec0420$export$84fc0a248cc54343));
        const instructionCount = $bccf75ed4dec0420$var$decodeLength(byteArray);
        const compiledInstructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = $bccf75ed4dec0420$var$guardedShift(byteArray);
            const accountKeyIndexesLength = $bccf75ed4dec0420$var$decodeLength(byteArray);
            const accountKeyIndexes = $bccf75ed4dec0420$var$guardedSplice(byteArray, 0, accountKeyIndexesLength);
            const dataLength = $bccf75ed4dec0420$var$decodeLength(byteArray);
            const data = new Uint8Array($bccf75ed4dec0420$var$guardedSplice(byteArray, 0, dataLength));
            compiledInstructions.push({
                programIdIndex: programIdIndex,
                accountKeyIndexes: accountKeyIndexes,
                data: data
            });
        }
        const addressTableLookupsCount = $bccf75ed4dec0420$var$decodeLength(byteArray);
        const addressTableLookups = [];
        for(let i = 0; i < addressTableLookupsCount; i++){
            const accountKey = new $bccf75ed4dec0420$export$ca8b6604d6ce14de($bccf75ed4dec0420$var$guardedSplice(byteArray, 0, $bccf75ed4dec0420$export$84fc0a248cc54343));
            const writableIndexesLength = $bccf75ed4dec0420$var$decodeLength(byteArray);
            const writableIndexes = $bccf75ed4dec0420$var$guardedSplice(byteArray, 0, writableIndexesLength);
            const readonlyIndexesLength = $bccf75ed4dec0420$var$decodeLength(byteArray);
            const readonlyIndexes = $bccf75ed4dec0420$var$guardedSplice(byteArray, 0, readonlyIndexesLength);
            addressTableLookups.push({
                accountKey: accountKey,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            });
        }
        return new $bccf75ed4dec0420$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
}
// eslint-disable-next-line no-redeclare
const $bccf75ed4dec0420$export$b0a61927d00ede7f = {
    deserializeMessageVersion (serializedMessage) {
        const prefix = serializedMessage[0];
        const maskedPrefix = prefix & $bccf75ed4dec0420$export$3c3793d809f8b858;
        // if the highest bit of the prefix is not set, the message is not versioned
        if (maskedPrefix === prefix) return "legacy";
        // the lower 7 bits of the prefix indicate the message version
        return maskedPrefix;
    },
    deserialize: (serializedMessage)=>{
        const version = $bccf75ed4dec0420$export$b0a61927d00ede7f.deserializeMessageVersion(serializedMessage);
        if (version === "legacy") return $bccf75ed4dec0420$export$f69c19e57285b83a.from(serializedMessage);
        if (version === 0) return $bccf75ed4dec0420$export$ee274c70e0fae590.deserialize(serializedMessage);
        else throw new Error(`Transaction message version ${version} deserialization is not supported`);
    }
};
/** @internal */ /**
 * Transaction signature as base-58 encoded string
 */ let $bccf75ed4dec0420$export$7c391bd3b61d2374 = /*#__PURE__*/ function(TransactionStatus) {
    TransactionStatus[TransactionStatus["BLOCKHEIGHT_EXCEEDED"] = 0] = "BLOCKHEIGHT_EXCEEDED";
    TransactionStatus[TransactionStatus["PROCESSED"] = 1] = "PROCESSED";
    TransactionStatus[TransactionStatus["TIMED_OUT"] = 2] = "TIMED_OUT";
    TransactionStatus[TransactionStatus["NONCE_INVALID"] = 3] = "NONCE_INVALID";
    return TransactionStatus;
}({});
/**
 * Default (empty) signature
 */ const $bccf75ed4dec0420$var$DEFAULT_SIGNATURE = (0, $lewJ9.Buffer).alloc($bccf75ed4dec0420$export$14aee086fde78fa6).fill(0);
/**
 * Account metadata used to define instructions
 */ /**
 * List of TransactionInstruction object fields that may be initialized at construction
 */ /**
 * Configuration object for Transaction.serialize()
 */ /**
 * @internal
 */ /**
 * Transaction Instruction class
 */ class $bccf75ed4dec0420$export$a7a3aa8360ac9f59 {
    constructor(opts){
        /**
     * Public keys to include in this transaction
     * Boolean represents whether this pubkey needs to sign the transaction
     */ this.keys = void 0;
        /**
     * Program Id to execute
     */ this.programId = void 0;
        /**
     * Program input
     */ this.data = (0, $lewJ9.Buffer).alloc(0);
        this.programId = opts.programId;
        this.keys = opts.keys;
        if (opts.data) this.data = opts.data;
    }
    /**
   * @internal
   */ toJSON() {
        return {
            keys: this.keys.map(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>({
                    pubkey: pubkey.toJSON(),
                    isSigner: isSigner,
                    isWritable: isWritable
                })),
            programId: this.programId.toJSON(),
            data: [
                ...this.data
            ]
        };
    }
}
/**
 * Pair of signature and corresponding public key
 */ /**
 * List of Transaction object fields that may be initialized at construction
 */ // For backward compatibility; an unfortunate consequence of being
// forced to over-export types by the documentation generator.
// See https://github.com/solana-labs/solana/pull/25820
/**
 * Blockhash-based transactions have a lifetime that are defined by
 * the blockhash they include. Any transaction whose blockhash is
 * too old will be rejected.
 */ /**
 * Use these options to construct a durable nonce transaction.
 */ /**
 * Nonce information to be used to build an offline Transaction.
 */ /**
 * @internal
 */ /**
 * Transaction class
 */ class $bccf75ed4dec0420$export$febc5573c75cefb0 {
    /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */ get signature() {
        if (this.signatures.length > 0) return this.signatures[0].signature;
        return null;
    }
    /**
   * The transaction fee payer
   */ // Construct a transaction with a blockhash and lastValidBlockHeight
    // Construct a transaction using a durable nonce
    /**
   * @deprecated `TransactionCtorFields` has been deprecated and will be removed in a future version.
   * Please supply a `TransactionBlockhashCtor` instead.
   */ /**
   * Construct an empty Transaction
   */ constructor(opts){
        /**
     * Signatures for the transaction.  Typically created by invoking the
     * `sign()` method
     */ this.signatures = [];
        this.feePayer = void 0;
        /**
     * The instructions to atomically execute
     */ this.instructions = [];
        /**
     * A recent transaction id. Must be populated by the caller
     */ this.recentBlockhash = void 0;
        /**
     * the last block chain can advance to before tx is declared expired
     * */ this.lastValidBlockHeight = void 0;
        /**
     * Optional Nonce information. If populated, transaction will use a durable
     * Nonce hash instead of a recentBlockhash. Must be populated by the caller
     */ this.nonceInfo = void 0;
        /**
     * If this is a nonce transaction this represents the minimum slot from which
     * to evaluate if the nonce has advanced when attempting to confirm the
     * transaction. This protects against a case where the transaction confirmation
     * logic loads the nonce account from an old slot and assumes the mismatch in
     * nonce value implies that the nonce has been advanced.
     */ this.minNonceContextSlot = void 0;
        /**
     * @internal
     */ this._message = void 0;
        /**
     * @internal
     */ this._json = void 0;
        if (!opts) return;
        if (opts.feePayer) this.feePayer = opts.feePayer;
        if (opts.signatures) this.signatures = opts.signatures;
        if (Object.prototype.hasOwnProperty.call(opts, "nonceInfo")) {
            const { minContextSlot: minContextSlot, nonceInfo: nonceInfo } = opts;
            this.minNonceContextSlot = minContextSlot;
            this.nonceInfo = nonceInfo;
        } else if (Object.prototype.hasOwnProperty.call(opts, "lastValidBlockHeight")) {
            const { blockhash: blockhash, lastValidBlockHeight: lastValidBlockHeight } = opts;
            this.recentBlockhash = blockhash;
            this.lastValidBlockHeight = lastValidBlockHeight;
        } else {
            const { recentBlockhash: recentBlockhash, nonceInfo: nonceInfo } = opts;
            if (nonceInfo) this.nonceInfo = nonceInfo;
            this.recentBlockhash = recentBlockhash;
        }
    }
    /**
   * @internal
   */ toJSON() {
        return {
            recentBlockhash: this.recentBlockhash || null,
            feePayer: this.feePayer ? this.feePayer.toJSON() : null,
            nonceInfo: this.nonceInfo ? {
                nonce: this.nonceInfo.nonce,
                nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
            } : null,
            instructions: this.instructions.map((instruction)=>instruction.toJSON()),
            signers: this.signatures.map(({ publicKey: publicKey })=>{
                return publicKey.toJSON();
            })
        };
    }
    /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */ add(...items) {
        if (items.length === 0) throw new Error("No instructions");
        items.forEach((item)=>{
            if ("instructions" in item) this.instructions = this.instructions.concat(item.instructions);
            else if ("data" in item && "programId" in item && "keys" in item) this.instructions.push(item);
            else this.instructions.push(new $bccf75ed4dec0420$export$a7a3aa8360ac9f59(item));
        });
        return this;
    }
    /**
   * Compile transaction data
   */ compileMessage() {
        if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json)) return this._message;
        let recentBlockhash;
        let instructions;
        if (this.nonceInfo) {
            recentBlockhash = this.nonceInfo.nonce;
            if (this.instructions[0] != this.nonceInfo.nonceInstruction) instructions = [
                this.nonceInfo.nonceInstruction,
                ...this.instructions
            ];
            else instructions = this.instructions;
        } else {
            recentBlockhash = this.recentBlockhash;
            instructions = this.instructions;
        }
        if (!recentBlockhash) throw new Error("Transaction recentBlockhash required");
        if (instructions.length < 1) console.warn("No instructions provided");
        let feePayer;
        if (this.feePayer) feePayer = this.feePayer;
        else if (this.signatures.length > 0 && this.signatures[0].publicKey) // Use implicit fee payer
        feePayer = this.signatures[0].publicKey;
        else throw new Error("Transaction fee payer required");
        for(let i = 0; i < instructions.length; i++){
            if (instructions[i].programId === undefined) throw new Error(`Transaction instruction index ${i} has undefined program id`);
        }
        const programIds = [];
        const accountMetas = [];
        instructions.forEach((instruction)=>{
            instruction.keys.forEach((accountMeta)=>{
                accountMetas.push({
                    ...accountMeta
                });
            });
            const programId = instruction.programId.toString();
            if (!programIds.includes(programId)) programIds.push(programId);
        });
        // Append programID account metas
        programIds.forEach((programId)=>{
            accountMetas.push({
                pubkey: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(programId),
                isSigner: false,
                isWritable: false
            });
        });
        // Cull duplicate account metas
        const uniqueMetas = [];
        accountMetas.forEach((accountMeta)=>{
            const pubkeyString = accountMeta.pubkey.toString();
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.toString() === pubkeyString;
            });
            if (uniqueIndex > -1) {
                uniqueMetas[uniqueIndex].isWritable = uniqueMetas[uniqueIndex].isWritable || accountMeta.isWritable;
                uniqueMetas[uniqueIndex].isSigner = uniqueMetas[uniqueIndex].isSigner || accountMeta.isSigner;
            } else uniqueMetas.push(accountMeta);
        });
        // Sort. Prioritizing first by signer, then by writable
        uniqueMetas.sort(function(x, y) {
            if (x.isSigner !== y.isSigner) // Signers always come before non-signers
            return x.isSigner ? -1 : 1;
            if (x.isWritable !== y.isWritable) // Writable accounts always come before read-only accounts
            return x.isWritable ? -1 : 1;
            // Otherwise, sort by pubkey, stringwise.
            const options = {
                localeMatcher: "best fit",
                usage: "sort",
                sensitivity: "variant",
                ignorePunctuation: false,
                numeric: false,
                caseFirst: "lower"
            };
            return x.pubkey.toBase58().localeCompare(y.pubkey.toBase58(), "en", options);
        });
        // Move fee payer to the front
        const feePayerIndex = uniqueMetas.findIndex((x)=>{
            return x.pubkey.equals(feePayer);
        });
        if (feePayerIndex > -1) {
            const [payerMeta] = uniqueMetas.splice(feePayerIndex, 1);
            payerMeta.isSigner = true;
            payerMeta.isWritable = true;
            uniqueMetas.unshift(payerMeta);
        } else uniqueMetas.unshift({
            pubkey: feePayer,
            isSigner: true,
            isWritable: true
        });
        // Disallow unknown signers
        for (const signature of this.signatures){
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.equals(signature.publicKey);
            });
            if (uniqueIndex > -1) {
                if (!uniqueMetas[uniqueIndex].isSigner) {
                    uniqueMetas[uniqueIndex].isSigner = true;
                    console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release.");
                }
            } else throw new Error(`unknown signer: ${signature.publicKey.toString()}`);
        }
        let numRequiredSignatures = 0;
        let numReadonlySignedAccounts = 0;
        let numReadonlyUnsignedAccounts = 0;
        // Split out signing from non-signing keys and count header values
        const signedKeys = [];
        const unsignedKeys = [];
        uniqueMetas.forEach(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>{
            if (isSigner) {
                signedKeys.push(pubkey.toString());
                numRequiredSignatures += 1;
                if (!isWritable) numReadonlySignedAccounts += 1;
            } else {
                unsignedKeys.push(pubkey.toString());
                if (!isWritable) numReadonlyUnsignedAccounts += 1;
            }
        });
        const accountKeys = signedKeys.concat(unsignedKeys);
        const compiledInstructions = instructions.map((instruction)=>{
            const { data: data, programId: programId } = instruction;
            return {
                programIdIndex: accountKeys.indexOf(programId.toString()),
                accounts: instruction.keys.map((meta)=>accountKeys.indexOf(meta.pubkey.toString())),
                data: (0, (/*@__PURE__*/$parcel$interopDefault($4fa1ea39de93f4d6$exports))).encode(data)
            };
        });
        compiledInstructions.forEach((instruction)=>{
            $bccf75ed4dec0420$var$assert(instruction.programIdIndex >= 0);
            instruction.accounts.forEach((keyIndex)=>$bccf75ed4dec0420$var$assert(keyIndex >= 0));
        });
        return new $bccf75ed4dec0420$export$f69c19e57285b83a({
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            accountKeys: accountKeys,
            recentBlockhash: recentBlockhash,
            instructions: compiledInstructions
        });
    }
    /**
   * @internal
   */ _compile() {
        const message = this.compileMessage();
        const signedKeys = message.accountKeys.slice(0, message.header.numRequiredSignatures);
        if (this.signatures.length === signedKeys.length) {
            const valid = this.signatures.every((pair, index)=>{
                return signedKeys[index].equals(pair.publicKey);
            });
            if (valid) return message;
        }
        this.signatures = signedKeys.map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
        return message;
    }
    /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */ serializeMessage() {
        return this._compile().serialize();
    }
    /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */ async getEstimatedFee(connection) {
        return (await connection.getFeeForMessage(this.compileMessage())).value;
    }
    /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */ setSigners(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        const seen = new Set();
        this.signatures = signers.filter((publicKey)=>{
            const key = publicKey.toString();
            if (seen.has(key)) return false;
            else {
                seen.add(key);
                return true;
            }
        }).map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
    }
    /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ sign(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        this.signatures = uniqueSigners.map((signer)=>({
                signature: null,
                publicKey: signer.publicKey
            }));
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ partialSign(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * @internal
   */ _partialSign(message, ...signers) {
        const signData = message.serialize();
        signers.forEach((signer)=>{
            const signature = $bccf75ed4dec0420$var$sign(signData, signer.secretKey);
            this._addSignature(signer.publicKey, $bccf75ed4dec0420$var$toBuffer(signature));
        });
    }
    /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */ addSignature(pubkey, signature) {
        this._compile(); // Ensure signatures array is populated
        this._addSignature(pubkey, signature);
    }
    /**
   * @internal
   */ _addSignature(pubkey, signature) {
        $bccf75ed4dec0420$var$assert(signature.length === 64);
        const index = this.signatures.findIndex((sigpair)=>pubkey.equals(sigpair.publicKey));
        if (index < 0) throw new Error(`unknown signer: ${pubkey.toString()}`);
        this.signatures[index].signature = (0, $lewJ9.Buffer).from(signature);
    }
    /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */ verifySignatures(requireAllSignatures = true) {
        const signatureErrors = this._getMessageSignednessErrors(this.serializeMessage(), requireAllSignatures);
        return !signatureErrors;
    }
    /**
   * @internal
   */ _getMessageSignednessErrors(message, requireAllSignatures) {
        const errors = {};
        for (const { signature: signature, publicKey: publicKey } of this.signatures){
            if (signature === null) {
                if (requireAllSignatures) (errors.missing ||= []).push(publicKey);
            } else if (!$bccf75ed4dec0420$var$verify(signature, message, publicKey.toBytes())) (errors.invalid ||= []).push(publicKey);
        }
        return errors.invalid || errors.missing ? errors : undefined;
    }
    /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */ serialize(config) {
        const { requireAllSignatures: requireAllSignatures, verifySignatures: verifySignatures } = Object.assign({
            requireAllSignatures: true,
            verifySignatures: true
        }, config);
        const signData = this.serializeMessage();
        if (verifySignatures) {
            const sigErrors = this._getMessageSignednessErrors(signData, requireAllSignatures);
            if (sigErrors) {
                let errorMessage = "Signature verification failed.";
                if (sigErrors.invalid) errorMessage += `\nInvalid signature for public key${sigErrors.invalid.length === 1 ? "" : "(s)"} [\`${sigErrors.invalid.map((p)=>p.toBase58()).join("`, `")}\`].`;
                if (sigErrors.missing) errorMessage += `\nMissing signature for public key${sigErrors.missing.length === 1 ? "" : "(s)"} [\`${sigErrors.missing.map((p)=>p.toBase58()).join("`, `")}\`].`;
                throw new Error(errorMessage);
            }
        }
        return this._serialize(signData);
    }
    /**
   * @internal
   */ _serialize(signData) {
        const { signatures: signatures } = this;
        const signatureCount = [];
        $bccf75ed4dec0420$var$encodeLength(signatureCount, signatures.length);
        const transactionLength = signatureCount.length + signatures.length * 64 + signData.length;
        const wireTransaction = (0, $lewJ9.Buffer).alloc(transactionLength);
        $bccf75ed4dec0420$var$assert(signatures.length < 256);
        (0, $lewJ9.Buffer).from(signatureCount).copy(wireTransaction, 0);
        signatures.forEach(({ signature: signature }, index)=>{
            if (signature !== null) {
                $bccf75ed4dec0420$var$assert(signature.length === 64, `signature has invalid length`);
                (0, $lewJ9.Buffer).from(signature).copy(wireTransaction, signatureCount.length + index * 64);
            }
        });
        signData.copy(wireTransaction, signatureCount.length + signatures.length * 64);
        $bccf75ed4dec0420$var$assert(wireTransaction.length <= $bccf75ed4dec0420$export$4c6d5b89e1596f26, `Transaction too large: ${wireTransaction.length} > ${$bccf75ed4dec0420$export$4c6d5b89e1596f26}`);
        return wireTransaction;
    }
    /**
   * Deprecated method
   * @internal
   */ get keys() {
        $bccf75ed4dec0420$var$assert(this.instructions.length === 1);
        return this.instructions[0].keys.map((keyObj)=>keyObj.pubkey);
    }
    /**
   * Deprecated method
   * @internal
   */ get programId() {
        $bccf75ed4dec0420$var$assert(this.instructions.length === 1);
        return this.instructions[0].programId;
    }
    /**
   * Deprecated method
   * @internal
   */ get data() {
        $bccf75ed4dec0420$var$assert(this.instructions.length === 1);
        return this.instructions[0].data;
    }
    /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const signatureCount = $bccf75ed4dec0420$var$decodeLength(byteArray);
        let signatures = [];
        for(let i = 0; i < signatureCount; i++){
            const signature = $bccf75ed4dec0420$var$guardedSplice(byteArray, 0, $bccf75ed4dec0420$export$14aee086fde78fa6);
            signatures.push((0, (/*@__PURE__*/$parcel$interopDefault($4fa1ea39de93f4d6$exports))).encode((0, $lewJ9.Buffer).from(signature)));
        }
        return $bccf75ed4dec0420$export$febc5573c75cefb0.populate($bccf75ed4dec0420$export$f69c19e57285b83a.from(byteArray), signatures);
    }
    /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */ static populate(message, signatures = []) {
        const transaction = new $bccf75ed4dec0420$export$febc5573c75cefb0();
        transaction.recentBlockhash = message.recentBlockhash;
        if (message.header.numRequiredSignatures > 0) transaction.feePayer = message.accountKeys[0];
        signatures.forEach((signature, index)=>{
            const sigPubkeyPair = {
                signature: signature == (0, (/*@__PURE__*/$parcel$interopDefault($4fa1ea39de93f4d6$exports))).encode($bccf75ed4dec0420$var$DEFAULT_SIGNATURE) ? null : (0, (/*@__PURE__*/$parcel$interopDefault($4fa1ea39de93f4d6$exports))).decode(signature),
                publicKey: message.accountKeys[index]
            };
            transaction.signatures.push(sigPubkeyPair);
        });
        message.instructions.forEach((instruction)=>{
            const keys = instruction.accounts.map((account)=>{
                const pubkey = message.accountKeys[account];
                return {
                    pubkey: pubkey,
                    isSigner: transaction.signatures.some((keyObj)=>keyObj.publicKey.toString() === pubkey.toString()) || message.isAccountSigner(account),
                    isWritable: message.isAccountWritable(account)
                };
            });
            transaction.instructions.push(new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
                keys: keys,
                programId: message.accountKeys[instruction.programIdIndex],
                data: (0, (/*@__PURE__*/$parcel$interopDefault($4fa1ea39de93f4d6$exports))).decode(instruction.data)
            }));
        });
        transaction._message = message;
        transaction._json = transaction.toJSON();
        return transaction;
    }
}
class $bccf75ed4dec0420$export$eb15f3e001dd262d {
    constructor(args){
        this.payerKey = void 0;
        this.instructions = void 0;
        this.recentBlockhash = void 0;
        this.payerKey = args.payerKey;
        this.instructions = args.instructions;
        this.recentBlockhash = args.recentBlockhash;
    }
    static decompile(message, args) {
        const { header: header, compiledInstructions: compiledInstructions, recentBlockhash: recentBlockhash } = message;
        const { numRequiredSignatures: numRequiredSignatures, numReadonlySignedAccounts: numReadonlySignedAccounts, numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts } = header;
        const numWritableSignedAccounts = numRequiredSignatures - numReadonlySignedAccounts;
        $bccf75ed4dec0420$var$assert(numWritableSignedAccounts > 0, "Message header is invalid");
        const numWritableUnsignedAccounts = message.staticAccountKeys.length - numRequiredSignatures - numReadonlyUnsignedAccounts;
        $bccf75ed4dec0420$var$assert(numWritableUnsignedAccounts >= 0, "Message header is invalid");
        const accountKeys = message.getAccountKeys(args);
        const payerKey = accountKeys.get(0);
        if (payerKey === undefined) throw new Error("Failed to decompile message because no account keys were found");
        const instructions = [];
        for (const compiledIx of compiledInstructions){
            const keys = [];
            for (const keyIndex of compiledIx.accountKeyIndexes){
                const pubkey = accountKeys.get(keyIndex);
                if (pubkey === undefined) throw new Error(`Failed to find key for account key index ${keyIndex}`);
                const isSigner = keyIndex < numRequiredSignatures;
                let isWritable;
                if (isSigner) isWritable = keyIndex < numWritableSignedAccounts;
                else if (keyIndex < accountKeys.staticAccountKeys.length) isWritable = keyIndex - numRequiredSignatures < numWritableUnsignedAccounts;
                else isWritable = keyIndex - accountKeys.staticAccountKeys.length < // accountKeysFromLookups cannot be undefined because we already found a pubkey for this index above
                accountKeys.accountKeysFromLookups.writable.length;
                keys.push({
                    pubkey: pubkey,
                    isSigner: keyIndex < header.numRequiredSignatures,
                    isWritable: isWritable
                });
            }
            const programId = accountKeys.get(compiledIx.programIdIndex);
            if (programId === undefined) throw new Error(`Failed to find program id for program id index ${compiledIx.programIdIndex}`);
            instructions.push(new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
                programId: programId,
                data: $bccf75ed4dec0420$var$toBuffer(compiledIx.data),
                keys: keys
            }));
        }
        return new $bccf75ed4dec0420$export$eb15f3e001dd262d({
            payerKey: payerKey,
            instructions: instructions,
            recentBlockhash: recentBlockhash
        });
    }
    compileToLegacyMessage() {
        return $bccf75ed4dec0420$export$f69c19e57285b83a.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions
        });
    }
    compileToV0Message(addressLookupTableAccounts) {
        return $bccf75ed4dec0420$export$ee274c70e0fae590.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions,
            addressLookupTableAccounts: addressLookupTableAccounts
        });
    }
}
/**
 * Versioned transaction class
 */ class $bccf75ed4dec0420$export$232cc3f078dcc284 {
    get version() {
        return this.message.version;
    }
    constructor(message, signatures){
        this.signatures = void 0;
        this.message = void 0;
        if (signatures !== undefined) {
            $bccf75ed4dec0420$var$assert(signatures.length === message.header.numRequiredSignatures, "Expected signatures length to be equal to the number of required signatures");
            this.signatures = signatures;
        } else {
            const defaultSignatures = [];
            for(let i = 0; i < message.header.numRequiredSignatures; i++)defaultSignatures.push(new Uint8Array($bccf75ed4dec0420$export$14aee086fde78fa6));
            this.signatures = defaultSignatures;
        }
        this.message = message;
    }
    serialize() {
        const serializedMessage = this.message.serialize();
        const encodedSignaturesLength = Array();
        $bccf75ed4dec0420$var$encodeLength(encodedSignaturesLength, this.signatures.length);
        const transactionLayout = $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.blob(encodedSignaturesLength.length, "encodedSignaturesLength"),
            $10b678223f208f49$exports.seq($bccf75ed4dec0420$var$signature(), this.signatures.length, "signatures"),
            $10b678223f208f49$exports.blob(serializedMessage.length, "serializedMessage")
        ]);
        const serializedTransaction = new Uint8Array(2048);
        const serializedTransactionLength = transactionLayout.encode({
            encodedSignaturesLength: new Uint8Array(encodedSignaturesLength),
            signatures: this.signatures,
            serializedMessage: serializedMessage
        }, serializedTransaction);
        return serializedTransaction.slice(0, serializedTransactionLength);
    }
    static deserialize(serializedTransaction) {
        let byteArray = [
            ...serializedTransaction
        ];
        const signatures = [];
        const signaturesLength = $bccf75ed4dec0420$var$decodeLength(byteArray);
        for(let i = 0; i < signaturesLength; i++)signatures.push(new Uint8Array($bccf75ed4dec0420$var$guardedSplice(byteArray, 0, $bccf75ed4dec0420$export$14aee086fde78fa6)));
        const message = $bccf75ed4dec0420$export$b0a61927d00ede7f.deserialize(new Uint8Array(byteArray));
        return new $bccf75ed4dec0420$export$232cc3f078dcc284(message, signatures);
    }
    sign(signers) {
        const messageData = this.message.serialize();
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        for (const signer of signers){
            const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(signer.publicKey));
            $bccf75ed4dec0420$var$assert(signerIndex >= 0, `Cannot sign with non signer key ${signer.publicKey.toBase58()}`);
            this.signatures[signerIndex] = $bccf75ed4dec0420$var$sign(messageData, signer.secretKey);
        }
    }
    addSignature(publicKey, signature) {
        $bccf75ed4dec0420$var$assert(signature.byteLength === 64, "Signature must be 64 bytes long");
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(publicKey));
        $bccf75ed4dec0420$var$assert(signerIndex >= 0, `Can not add signature; \`${publicKey.toBase58()}\` is not required to sign this transaction`);
        this.signatures[signerIndex] = signature;
    }
}
// TODO: These constants should be removed in favor of reading them out of a
// Syscall account
/**
 * @internal
 */ const $bccf75ed4dec0420$var$NUM_TICKS_PER_SECOND = 160;
/**
 * @internal
 */ const $bccf75ed4dec0420$var$DEFAULT_TICKS_PER_SLOT = 64;
/**
 * @internal
 */ const $bccf75ed4dec0420$var$NUM_SLOTS_PER_SECOND = $bccf75ed4dec0420$var$NUM_TICKS_PER_SECOND / $bccf75ed4dec0420$var$DEFAULT_TICKS_PER_SLOT;
/**
 * @internal
 */ const $bccf75ed4dec0420$var$MS_PER_SLOT = 1000 / $bccf75ed4dec0420$var$NUM_SLOTS_PER_SECOND;
const $bccf75ed4dec0420$export$393aa1412d47050e = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("SysvarC1ock11111111111111111111111111111111");
const $bccf75ed4dec0420$export$2b71d479444d2f4 = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("SysvarEpochSchedu1e111111111111111111111111");
const $bccf75ed4dec0420$export$54419cc1a3ece8d6 = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("Sysvar1nstructions1111111111111111111111111");
const $bccf75ed4dec0420$export$e74201139e9833db = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("SysvarRecentB1ockHashes11111111111111111111");
const $bccf75ed4dec0420$export$970d0190cdb3a8e9 = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("SysvarRent111111111111111111111111111111111");
const $bccf75ed4dec0420$export$da3b38d796bc1af1 = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("SysvarRewards111111111111111111111111111111");
const $bccf75ed4dec0420$export$7b3a057916a4a7ae = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("SysvarS1otHashes111111111111111111111111111");
const $bccf75ed4dec0420$export$3272815bf0633907 = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("SysvarS1otHistory11111111111111111111111111");
const $bccf75ed4dec0420$export$ca994171317280ea = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("SysvarStakeHistory1111111111111111111111111");
class $bccf75ed4dec0420$export$121e803f723b3045 extends Error {
    constructor({ action: action, signature: signature, transactionMessage: transactionMessage, logs: logs }){
        const maybeLogsOutput = logs ? `Logs: \n${JSON.stringify(logs.slice(-10), null, 2)}. ` : "";
        const guideText = "\nCatch the `SendTransactionError` and call `getLogs()` on it for full details.";
        let message;
        switch(action){
            case "send":
                message = `Transaction ${signature} resulted in an error. \n` + `${transactionMessage}. ` + maybeLogsOutput + guideText;
                break;
            case "simulate":
                message = `Simulation failed. \nMessage: ${transactionMessage}. \n` + maybeLogsOutput + guideText;
                break;
            default:
                message = `Unknown action '${((a)=>a)(action)}'`;
        }
        super(message);
        this.signature = void 0;
        this.transactionMessage = void 0;
        this.transactionLogs = void 0;
        this.signature = signature;
        this.transactionMessage = transactionMessage;
        this.transactionLogs = logs ? logs : undefined;
    }
    get transactionError() {
        return {
            message: this.transactionMessage,
            logs: Array.isArray(this.transactionLogs) ? this.transactionLogs : undefined
        };
    }
    /* @deprecated Use `await getLogs()` instead */ get logs() {
        const cachedLogs = this.transactionLogs;
        if (cachedLogs != null && typeof cachedLogs === "object" && "then" in cachedLogs) return undefined;
        return cachedLogs;
    }
    async getLogs(connection) {
        if (!Array.isArray(this.transactionLogs)) this.transactionLogs = new Promise((resolve, reject)=>{
            connection.getTransaction(this.signature).then((tx)=>{
                if (tx && tx.meta && tx.meta.logMessages) {
                    const logs = tx.meta.logMessages;
                    this.transactionLogs = logs;
                    resolve(logs);
                } else reject(new Error("Log messages not found"));
            }).catch(reject);
        });
        return await this.transactionLogs;
    }
}
// Keep in sync with client/src/rpc_custom_errors.rs
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $bccf75ed4dec0420$export$e5e9869922dd22f8 = {
    JSON_RPC_SERVER_ERROR_BLOCK_CLEANED_UP: -32001,
    JSON_RPC_SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE: -32002,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE: -32003,
    JSON_RPC_SERVER_ERROR_BLOCK_NOT_AVAILABLE: -32004,
    JSON_RPC_SERVER_ERROR_NODE_UNHEALTHY: -32005,
    JSON_RPC_SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE: -32006,
    JSON_RPC_SERVER_ERROR_SLOT_SKIPPED: -32007,
    JSON_RPC_SERVER_ERROR_NO_SNAPSHOT: -32008,
    JSON_RPC_SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED: -32009,
    JSON_RPC_SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX: -32010,
    JSON_RPC_SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE: -32011,
    JSON_RPC_SCAN_ERROR: -32012,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH: -32013,
    JSON_RPC_SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET: -32014,
    JSON_RPC_SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION: -32015,
    JSON_RPC_SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED: -32016
};
class $bccf75ed4dec0420$export$ea1b1a1bba5c14ad extends Error {
    constructor({ code: code, message: message, data: data }, customMessage){
        super(customMessage != null ? `${customMessage}: ${message}` : message);
        this.code = void 0;
        this.data = void 0;
        this.code = code;
        this.data = data;
        this.name = "SolanaJSONRPCError";
    }
}
/**
 * Sign, send and confirm a transaction.
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Transaction} transaction
 * @param {Array<Signer>} signers
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ async function $bccf75ed4dec0420$export$4ad6fe6dae0b6bc3(connection, transaction, signers, options) {
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        maxRetries: options.maxRetries,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendTransaction(transaction, signers, sendOptions);
    let status;
    if (transaction.recentBlockhash != null && transaction.lastValidBlockHeight != null) status = (await connection.confirmTransaction({
        abortSignal: options?.abortSignal,
        signature: signature,
        blockhash: transaction.recentBlockhash,
        lastValidBlockHeight: transaction.lastValidBlockHeight
    }, options && options.commitment)).value;
    else if (transaction.minNonceContextSlot != null && transaction.nonceInfo != null) {
        const { nonceInstruction: nonceInstruction } = transaction.nonceInfo;
        const nonceAccountPubkey = nonceInstruction.keys[0].pubkey;
        status = (await connection.confirmTransaction({
            abortSignal: options?.abortSignal,
            minContextSlot: transaction.minNonceContextSlot,
            nonceAccountPubkey: nonceAccountPubkey,
            nonceValue: transaction.nonceInfo.nonce,
            signature: signature
        }, options && options.commitment)).value;
    } else {
        if (options?.abortSignal != null) console.warn("sendAndConfirmTransaction(): A transaction with a deprecated confirmation strategy was supplied along with an `abortSignal`. Only transactions having `lastValidBlockHeight` or a combination of `nonceInfo` and `minNonceContextSlot` are abortable.");
        status = (await connection.confirmTransaction(signature, options && options.commitment)).value;
    }
    if (status.err) {
        if (signature != null) throw new $bccf75ed4dec0420$export$121e803f723b3045({
            action: "send",
            signature: signature,
            transactionMessage: `Status: (${JSON.stringify(status)})`
        });
        throw new Error(`Transaction ${signature} failed (${JSON.stringify(status)})`);
    }
    return signature;
}
// zzz
function $bccf75ed4dec0420$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
/**
 * @internal
 */ /**
 * Populate a buffer of instruction data using an InstructionType
 * @internal
 */ function $bccf75ed4dec0420$var$encodeData(type, fields) {
    const allocLength = type.layout.span >= 0 ? type.layout.span : $bccf75ed4dec0420$var$getAlloc(type, fields);
    const data = (0, $lewJ9.Buffer).alloc(allocLength);
    const layoutFields = Object.assign({
        instruction: type.index
    }, fields);
    type.layout.encode(layoutFields, data);
    return data;
}
/**
 * Decode instruction data buffer using an InstructionType
 * @internal
 */ function $bccf75ed4dec0420$var$decodeData$1(type, buffer) {
    let data;
    try {
        data = type.layout.decode(buffer);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (data.instruction !== type.index) throw new Error(`invalid instruction; instruction index mismatch ${data.instruction} != ${type.index}`);
    return data;
}
/**
 * https://github.com/solana-labs/solana/blob/90bedd7e067b5b8f3ddbb45da00a4e9cabb22c62/sdk/src/fee_calculator.rs#L7-L11
 *
 * @internal
 */ const $bccf75ed4dec0420$export$d1cc579b1c48f515 = $10b678223f208f49$exports.nu64("lamportsPerSignature");
/**
 * Calculator for transaction fees.
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * See https://github.com/solana-labs/solana/blob/0ea2843ec9cdc517572b8e62c959f41b55cf4453/sdk/src/nonce_state.rs#L29-L32
 *
 * @internal
 */ const $bccf75ed4dec0420$var$NonceAccountLayout = $10b678223f208f49$exports.struct([
    $10b678223f208f49$exports.u32("version"),
    $10b678223f208f49$exports.u32("state"),
    $bccf75ed4dec0420$var$publicKey("authorizedPubkey"),
    $bccf75ed4dec0420$var$publicKey("nonce"),
    $10b678223f208f49$exports.struct([
        $bccf75ed4dec0420$export$d1cc579b1c48f515
    ], "feeCalculator")
]);
const $bccf75ed4dec0420$export$7126250b6d8bd94a = $bccf75ed4dec0420$var$NonceAccountLayout.span;
/**
 * A durable nonce is a 32 byte value encoded as a base58 string.
 */ /**
 * NonceAccount class
 */ class $bccf75ed4dec0420$export$ed1c2356ce604759 {
    /**
   * @internal
   */ constructor(args){
        this.authorizedPubkey = void 0;
        this.nonce = void 0;
        this.feeCalculator = void 0;
        this.authorizedPubkey = args.authorizedPubkey;
        this.nonce = args.nonce;
        this.feeCalculator = args.feeCalculator;
    }
    /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */ static fromAccountData(buffer) {
        const nonceAccount = $bccf75ed4dec0420$var$NonceAccountLayout.decode($bccf75ed4dec0420$var$toBuffer(buffer), 0);
        return new $bccf75ed4dec0420$export$ed1c2356ce604759({
            authorizedPubkey: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(nonceAccount.authorizedPubkey),
            nonce: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(nonceAccount.nonce).toString(),
            feeCalculator: nonceAccount.feeCalculator
        });
    }
}
function $bccf75ed4dec0420$var$u64(property) {
    const layout = (0, $10b678223f208f49$exports.blob)(8 /* bytes */ , property);
    const decode = layout.decode.bind(layout);
    const encode = layout.encode.bind(layout);
    const bigIntLayout = layout;
    const codec = (0, $d15510cabed22f5e$export$7e56ec13f6029ccc)();
    bigIntLayout.decode = (buffer, offset)=>{
        const src = decode(buffer, offset);
        return codec.decode(src);
    };
    bigIntLayout.encode = (bigInt, buffer, offset)=>{
        const src = codec.encode(bigInt);
        return encode(src, buffer, offset);
    };
    return bigIntLayout;
}
/**
 * Create account system transaction params
 */ /**
 * Transfer system transaction params
 */ /**
 * Assign system transaction params
 */ /**
 * Create account with seed system transaction params
 */ /**
 * Create nonce account system transaction params
 */ /**
 * Create nonce account with seed system transaction params
 */ /**
 * Initialize nonce account system instruction params
 */ /**
 * Advance nonce account system instruction params
 */ /**
 * Withdraw nonce account system transaction params
 */ /**
 * Authorize nonce account system transaction params
 */ /**
 * Allocate account system transaction params
 */ /**
 * Allocate account with seed system transaction params
 */ /**
 * Assign account with seed system transaction params
 */ /**
 * Transfer with seed system transaction params
 */ /** Decoded transfer system transaction instruction */ /** Decoded transferWithSeed system transaction instruction */ /**
 * System Instruction class
 */ class $bccf75ed4dec0420$export$f009802131fa3d06 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a system instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $10b678223f208f49$exports.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($bccf75ed4dec0420$export$74bdf41d8d1e7108))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a SystemInstruction");
        return type;
    }
    /**
   * Decode a create account system instruction and retrieve the instruction params.
   */ static decodeCreateAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports, space: space, programId: programId } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$74bdf41d8d1e7108.Create, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            lamports: lamports,
            space: space,
            programId: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a transfer system instruction and retrieve the instruction params.
   */ static decodeTransfer(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$74bdf41d8d1e7108.Transfer, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a transfer with seed system instruction and retrieve the instruction params.
   */ static decodeTransferWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports, seed: seed, programId: programId } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$74bdf41d8d1e7108.TransferWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            basePubkey: instruction.keys[1].pubkey,
            toPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            seed: seed,
            programId: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an allocate system instruction and retrieve the instruction params.
   */ static decodeAllocate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { space: space } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$74bdf41d8d1e7108.Allocate, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            space: space
        };
    }
    /**
   * Decode an allocate with seed system instruction and retrieve the instruction params.
   */ static decodeAllocateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, space: space, programId: programId } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$74bdf41d8d1e7108.AllocateWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(base),
            seed: seed,
            space: space,
            programId: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign system instruction and retrieve the instruction params.
   */ static decodeAssign(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { programId: programId } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$74bdf41d8d1e7108.Assign, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            programId: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign with seed system instruction and retrieve the instruction params.
   */ static decodeAssignWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, programId: programId } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$74bdf41d8d1e7108.AssignWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(base),
            seed: seed,
            programId: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a create account with seed system instruction and retrieve the instruction params.
   */ static decodeCreateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { base: base, seed: seed, lamports: lamports, space: space, programId: programId } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$74bdf41d8d1e7108.CreateWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            basePubkey: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(base),
            seed: seed,
            lamports: lamports,
            space: space,
            programId: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a nonce initialize system instruction and retrieve the instruction params.
   */ static decodeNonceInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { authorized: authorized } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$74bdf41d8d1e7108.InitializeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * Decode a nonce advance system instruction and retrieve the instruction params.
   */ static decodeNonceAdvance(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$74bdf41d8d1e7108.AdvanceNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * Decode a nonce withdraw system instruction and retrieve the instruction params.
   */ static decodeNonceWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$74bdf41d8d1e7108.WithdrawNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a nonce authorize system instruction and retrieve the instruction params.
   */ static decodeNonceAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$74bdf41d8d1e7108.AuthorizeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[1].pubkey,
            newAuthorizedPubkey: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($bccf75ed4dec0420$export$d8c4e17726848113.programId)) throw new Error("invalid instruction; programId is not SystemProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid SystemInstructionType's
 */ /**
 * An enumeration of valid system InstructionType's
 * @internal
 */ const $bccf75ed4dec0420$export$74bdf41d8d1e7108 = Object.freeze({
    Create: {
        index: 0,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $10b678223f208f49$exports.ns64("lamports"),
            $10b678223f208f49$exports.ns64("space"),
            $bccf75ed4dec0420$var$publicKey("programId")
        ])
    },
    Assign: {
        index: 1,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $bccf75ed4dec0420$var$publicKey("programId")
        ])
    },
    Transfer: {
        index: 2,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $bccf75ed4dec0420$var$u64("lamports")
        ])
    },
    CreateWithSeed: {
        index: 3,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $bccf75ed4dec0420$var$publicKey("base"),
            $bccf75ed4dec0420$var$rustString("seed"),
            $10b678223f208f49$exports.ns64("lamports"),
            $10b678223f208f49$exports.ns64("space"),
            $bccf75ed4dec0420$var$publicKey("programId")
        ])
    },
    AdvanceNonceAccount: {
        index: 4,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction")
        ])
    },
    WithdrawNonceAccount: {
        index: 5,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $10b678223f208f49$exports.ns64("lamports")
        ])
    },
    InitializeNonceAccount: {
        index: 6,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $bccf75ed4dec0420$var$publicKey("authorized")
        ])
    },
    AuthorizeNonceAccount: {
        index: 7,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $bccf75ed4dec0420$var$publicKey("authorized")
        ])
    },
    Allocate: {
        index: 8,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $10b678223f208f49$exports.ns64("space")
        ])
    },
    AllocateWithSeed: {
        index: 9,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $bccf75ed4dec0420$var$publicKey("base"),
            $bccf75ed4dec0420$var$rustString("seed"),
            $10b678223f208f49$exports.ns64("space"),
            $bccf75ed4dec0420$var$publicKey("programId")
        ])
    },
    AssignWithSeed: {
        index: 10,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $bccf75ed4dec0420$var$publicKey("base"),
            $bccf75ed4dec0420$var$rustString("seed"),
            $bccf75ed4dec0420$var$publicKey("programId")
        ])
    },
    TransferWithSeed: {
        index: 11,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $bccf75ed4dec0420$var$u64("lamports"),
            $bccf75ed4dec0420$var$rustString("seed"),
            $bccf75ed4dec0420$var$publicKey("programId")
        ])
    },
    UpgradeNonceAccount: {
        index: 12,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction")
        ])
    }
});
/**
 * Factory class for transactions to interact with the System program
 */ class $bccf75ed4dec0420$export$d8c4e17726848113 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the System program
   */ /**
   * Generate a transaction instruction that creates a new account
   */ static createAccount(params) {
        const type = $bccf75ed4dec0420$export$74bdf41d8d1e7108.Create;
        const data = $bccf75ed4dec0420$var$encodeData(type, {
            lamports: params.lamports,
            space: params.space,
            programId: $bccf75ed4dec0420$var$toBuffer(params.programId.toBuffer())
        });
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.newAccountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */ static transfer(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $bccf75ed4dec0420$export$74bdf41d8d1e7108.TransferWithSeed;
            data = $bccf75ed4dec0420$var$encodeData(type, {
                lamports: BigInt(params.lamports),
                seed: params.seed,
                programId: $bccf75ed4dec0420$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        } else {
            const type = $bccf75ed4dec0420$export$74bdf41d8d1e7108.Transfer;
            data = $bccf75ed4dec0420$var$encodeData(type, {
                lamports: BigInt(params.lamports)
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        }
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that assigns an account to a program
   */ static assign(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $bccf75ed4dec0420$export$74bdf41d8d1e7108.AssignWithSeed;
            data = $bccf75ed4dec0420$var$encodeData(type, {
                base: $bccf75ed4dec0420$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                programId: $bccf75ed4dec0420$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $bccf75ed4dec0420$export$74bdf41d8d1e7108.Assign;
            data = $bccf75ed4dec0420$var$encodeData(type, {
                programId: $bccf75ed4dec0420$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */ static createAccountWithSeed(params) {
        const type = $bccf75ed4dec0420$export$74bdf41d8d1e7108.CreateWithSeed;
        const data = $bccf75ed4dec0420$var$encodeData(type, {
            base: $bccf75ed4dec0420$var$toBuffer(params.basePubkey.toBuffer()),
            seed: params.seed,
            lamports: params.lamports,
            space: params.space,
            programId: $bccf75ed4dec0420$var$toBuffer(params.programId.toBuffer())
        });
        let keys = [
            {
                pubkey: params.fromPubkey,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: params.newAccountPubkey,
                isSigner: false,
                isWritable: true
            }
        ];
        if (!params.basePubkey.equals(params.fromPubkey)) keys.push({
            pubkey: params.basePubkey,
            isSigner: true,
            isWritable: false
        });
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that creates a new Nonce account
   */ static createNonceAccount(params) {
        const transaction = new $bccf75ed4dec0420$export$febc5573c75cefb0();
        if ("basePubkey" in params && "seed" in params) transaction.add($bccf75ed4dec0420$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: $bccf75ed4dec0420$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        else transaction.add($bccf75ed4dec0420$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            lamports: params.lamports,
            space: $bccf75ed4dec0420$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        const initParams = {
            noncePubkey: params.noncePubkey,
            authorizedPubkey: params.authorizedPubkey
        };
        transaction.add(this.nonceInitialize(initParams));
        return transaction;
    }
    /**
   * Generate an instruction to initialize a Nonce account
   */ static nonceInitialize(params) {
        const type = $bccf75ed4dec0420$export$74bdf41d8d1e7108.InitializeNonceAccount;
        const data = $bccf75ed4dec0420$var$encodeData(type, {
            authorized: $bccf75ed4dec0420$var$toBuffer(params.authorizedPubkey.toBuffer())
        });
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $bccf75ed4dec0420$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $bccf75ed4dec0420$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate an instruction to advance the nonce in a Nonce account
   */ static nonceAdvance(params) {
        const type = $bccf75ed4dec0420$export$74bdf41d8d1e7108.AdvanceNonceAccount;
        const data = $bccf75ed4dec0420$var$encodeData(type);
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $bccf75ed4dec0420$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */ static nonceWithdraw(params) {
        const type = $bccf75ed4dec0420$export$74bdf41d8d1e7108.WithdrawNonceAccount;
        const data = $bccf75ed4dec0420$var$encodeData(type, {
            lamports: params.lamports
        });
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $bccf75ed4dec0420$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $bccf75ed4dec0420$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */ static nonceAuthorize(params) {
        const type = $bccf75ed4dec0420$export$74bdf41d8d1e7108.AuthorizeNonceAccount;
        const data = $bccf75ed4dec0420$var$encodeData(type, {
            authorized: $bccf75ed4dec0420$var$toBuffer(params.newAuthorizedPubkey.toBuffer())
        });
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that allocates space in an account without funding
   */ static allocate(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $bccf75ed4dec0420$export$74bdf41d8d1e7108.AllocateWithSeed;
            data = $bccf75ed4dec0420$var$encodeData(type, {
                base: $bccf75ed4dec0420$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                space: params.space,
                programId: $bccf75ed4dec0420$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $bccf75ed4dec0420$export$74bdf41d8d1e7108.Allocate;
            data = $bccf75ed4dec0420$var$encodeData(type, {
                space: params.space
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$bccf75ed4dec0420$export$d8c4e17726848113.programId = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("11111111111111111111111111111111");
// Keep program chunks under PACKET_DATA_SIZE, leaving enough room for the
// rest of the Transaction fields
//
// TODO: replace 300 with a proper constant for the size of the other
// Transaction fields
const $bccf75ed4dec0420$var$CHUNK_SIZE = $bccf75ed4dec0420$export$4c6d5b89e1596f26 - 300;
/**
 * Program loader interface
 */ class $bccf75ed4dec0420$export$3b0d6d7590275603 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Amount of program data placed in each load Transaction
   */ /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return 2 * // Every transaction requires two signatures (payer + program)
        (Math.ceil(dataLength / $bccf75ed4dec0420$export$3b0d6d7590275603.chunkSize) + 1 + // Add one for Create transaction
        1 // Add one for Finalize transaction
        );
    }
    /**
   * Loads a generic program
   *
   * @param connection The connection to use
   * @param payer System account that pays to load the program
   * @param program Account to load the program into
   * @param programId Public key that identifies the loader
   * @param data Program octets
   * @return true if program was loaded successfully, false if program was already loaded
   */ static async load(connection, payer, program, programId, data) {
        {
            const balanceNeeded = await connection.getMinimumBalanceForRentExemption(data.length);
            // Fetch program account info to check if it has already been created
            const programInfo = await connection.getAccountInfo(program.publicKey, "confirmed");
            let transaction = null;
            if (programInfo !== null) {
                if (programInfo.executable) {
                    console.error("Program load failed, account is already executable");
                    return false;
                }
                if (programInfo.data.length !== data.length) {
                    transaction = transaction || new $bccf75ed4dec0420$export$febc5573c75cefb0();
                    transaction.add($bccf75ed4dec0420$export$d8c4e17726848113.allocate({
                        accountPubkey: program.publicKey,
                        space: data.length
                    }));
                }
                if (!programInfo.owner.equals(programId)) {
                    transaction = transaction || new $bccf75ed4dec0420$export$febc5573c75cefb0();
                    transaction.add($bccf75ed4dec0420$export$d8c4e17726848113.assign({
                        accountPubkey: program.publicKey,
                        programId: programId
                    }));
                }
                if (programInfo.lamports < balanceNeeded) {
                    transaction = transaction || new $bccf75ed4dec0420$export$febc5573c75cefb0();
                    transaction.add($bccf75ed4dec0420$export$d8c4e17726848113.transfer({
                        fromPubkey: payer.publicKey,
                        toPubkey: program.publicKey,
                        lamports: balanceNeeded - programInfo.lamports
                    }));
                }
            } else transaction = new $bccf75ed4dec0420$export$febc5573c75cefb0().add($bccf75ed4dec0420$export$d8c4e17726848113.createAccount({
                fromPubkey: payer.publicKey,
                newAccountPubkey: program.publicKey,
                lamports: balanceNeeded > 0 ? balanceNeeded : 1,
                space: data.length,
                programId: programId
            }));
            // If the account is already created correctly, skip this step
            // and proceed directly to loading instructions
            if (transaction !== null) await $bccf75ed4dec0420$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: "confirmed"
            });
        }
        const dataLayout = $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $10b678223f208f49$exports.u32("offset"),
            $10b678223f208f49$exports.u32("bytesLength"),
            $10b678223f208f49$exports.u32("bytesLengthPadding"),
            $10b678223f208f49$exports.seq($10b678223f208f49$exports.u8("byte"), $10b678223f208f49$exports.offset($10b678223f208f49$exports.u32(), -8), "bytes")
        ]);
        const chunkSize = $bccf75ed4dec0420$export$3b0d6d7590275603.chunkSize;
        let offset = 0;
        let array = data;
        let transactions = [];
        while(array.length > 0){
            const bytes = array.slice(0, chunkSize);
            const data = (0, $lewJ9.Buffer).alloc(chunkSize + 16);
            dataLayout.encode({
                instruction: 0,
                offset: // Load instruction
                offset,
                bytes: bytes,
                bytesLength: 0,
                bytesLengthPadding: 0
            }, data);
            const transaction = new $bccf75ed4dec0420$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    }
                ],
                programId: programId,
                data: data
            });
            transactions.push($bccf75ed4dec0420$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: "confirmed"
            }));
            // Delay between sends in an attempt to reduce rate limit errors
            if (connection._rpcEndpoint.includes("solana.com")) {
                const REQUESTS_PER_SECOND = 4;
                await $bccf75ed4dec0420$var$sleep(1000 / REQUESTS_PER_SECOND);
            }
            offset += chunkSize;
            array = array.slice(chunkSize);
        }
        await Promise.all(transactions);
        // Finalize the account loaded with program data for execution
        {
            const dataLayout = $10b678223f208f49$exports.struct([
                $10b678223f208f49$exports.u32("instruction")
            ]);
            const data = (0, $lewJ9.Buffer).alloc(dataLayout.span);
            dataLayout.encode({
                instruction: 1 // Finalize instruction
            }, data);
            const transaction = new $bccf75ed4dec0420$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    },
                    {
                        pubkey: $bccf75ed4dec0420$export$970d0190cdb3a8e9,
                        isSigner: false,
                        isWritable: false
                    }
                ],
                programId: programId,
                data: data
            });
            const deployCommitment = "processed";
            const finalizeSignature = await connection.sendTransaction(transaction, [
                payer,
                program
            ], {
                preflightCommitment: deployCommitment
            });
            const { context: context, value: value } = await connection.confirmTransaction({
                signature: finalizeSignature,
                lastValidBlockHeight: transaction.lastValidBlockHeight,
                blockhash: transaction.recentBlockhash
            }, deployCommitment);
            if (value.err) throw new Error(`Transaction ${finalizeSignature} failed (${JSON.stringify(value)})`);
            // We prevent programs from being usable until the slot after their deployment.
            // See https://github.com/solana-labs/solana/pull/29654
            while(true // eslint-disable-line no-constant-condition
            ){
                try {
                    const currentSlot = await connection.getSlot({
                        commitment: deployCommitment
                    });
                    if (currentSlot > context.slot) break;
                } catch  {
                /* empty */ }
                await new Promise((resolve)=>setTimeout(resolve, Math.round($bccf75ed4dec0420$var$MS_PER_SLOT / 2)));
            }
        }
        // success
        return true;
    }
}
$bccf75ed4dec0420$export$3b0d6d7590275603.chunkSize = $bccf75ed4dec0420$var$CHUNK_SIZE;
/**
 * @deprecated Deprecated since Solana v1.17.20.
 */ const $bccf75ed4dec0420$export$59833422f998b937 = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("BPFLoader2111111111111111111111111111111111");
/**
 * Factory class for transactions to interact with a program loader
 *
 * @deprecated Deprecated since Solana v1.17.20.
 */ class $bccf75ed4dec0420$export$493be68e6a240d3b {
    /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return $bccf75ed4dec0420$export$3b0d6d7590275603.getMinNumSignatures(dataLength);
    }
    /**
   * Load a SBF program
   *
   * @param connection The connection to use
   * @param payer Account that will pay program loading fees
   * @param program Account to load the program into
   * @param elf The entire ELF containing the SBF program
   * @param loaderProgramId The program id of the BPF loader to use
   * @return true if program was loaded successfully, false if program was already loaded
   */ static load(connection, payer, program, elf, loaderProgramId) {
        return $bccf75ed4dec0420$export$3b0d6d7590275603.load(connection, payer, program, loaderProgramId, elf);
    }
}
function $bccf75ed4dec0420$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $bccf75ed4dec0420$var$fastStableStringify$1;
var $bccf75ed4dec0420$var$hasRequiredFastStableStringify;
function $bccf75ed4dec0420$var$requireFastStableStringify() {
    if ($bccf75ed4dec0420$var$hasRequiredFastStableStringify) return $bccf75ed4dec0420$var$fastStableStringify$1;
    $bccf75ed4dec0420$var$hasRequiredFastStableStringify = 1;
    var objToString = Object.prototype.toString;
    var objKeys = Object.keys || function(obj) {
        var keys = [];
        for(var name in obj)keys.push(name);
        return keys;
    };
    function stringify(val, isArrayProp) {
        var i, max, str, keys, key, propVal, toStr;
        if (val === true) return "true";
        if (val === false) return "false";
        switch(typeof val){
            case "object":
                if (val === null) return null;
                else if (val.toJSON && typeof val.toJSON === "function") return stringify(val.toJSON(), isArrayProp);
                else {
                    toStr = objToString.call(val);
                    if (toStr === "[object Array]") {
                        str = "[";
                        max = val.length - 1;
                        for(i = 0; i < max; i++)str += stringify(val[i], true) + ",";
                        if (max > -1) str += stringify(val[i], true);
                        return str + "]";
                    } else if (toStr === "[object Object]") {
                        // only object is left
                        keys = objKeys(val).sort();
                        max = keys.length;
                        str = "";
                        i = 0;
                        while(i < max){
                            key = keys[i];
                            propVal = stringify(val[key], false);
                            if (propVal !== undefined) {
                                if (str) str += ",";
                                str += JSON.stringify(key) + ":" + propVal;
                            }
                            i++;
                        }
                        return "{" + str + "}";
                    } else return JSON.stringify(val);
                }
            case "function":
            case "undefined":
                return isArrayProp ? null : undefined;
            case "string":
                return JSON.stringify(val);
            default:
                return isFinite(val) ? val : null;
        }
    }
    $bccf75ed4dec0420$var$fastStableStringify$1 = function(val) {
        var returnVal = stringify(val, false);
        if (returnVal !== undefined) return "" + returnVal;
    };
    return $bccf75ed4dec0420$var$fastStableStringify$1;
}
var $bccf75ed4dec0420$var$fastStableStringifyExports = /*@__PURE__*/ $bccf75ed4dec0420$var$requireFastStableStringify();
var $bccf75ed4dec0420$var$fastStableStringify = /*@__PURE__*/ $bccf75ed4dec0420$var$getDefaultExportFromCjs($bccf75ed4dec0420$var$fastStableStringifyExports);
const $bccf75ed4dec0420$var$MINIMUM_SLOT_PER_EPOCH = 32;
// Returns the number of trailing zeros in the binary representation of self.
function $bccf75ed4dec0420$var$trailingZeros(n) {
    let trailingZeros = 0;
    while(n > 1){
        n /= 2;
        trailingZeros++;
    }
    return trailingZeros;
}
// Returns the smallest power of two greater than or equal to n
function $bccf75ed4dec0420$var$nextPowerOfTwo(n) {
    if (n === 0) return 1;
    n--;
    n |= n >> 1;
    n |= n >> 2;
    n |= n >> 4;
    n |= n >> 8;
    n |= n >> 16;
    n |= n >> 32;
    return n + 1;
}
/**
 * Epoch schedule
 * (see https://docs.solana.com/terminology#epoch)
 * Can be retrieved with the {@link Connection.getEpochSchedule} method
 */ class $bccf75ed4dec0420$export$df8ed3e830b1d591 {
    constructor(slotsPerEpoch, leaderScheduleSlotOffset, warmup, firstNormalEpoch, firstNormalSlot){
        /** The maximum number of slots in each epoch */ this.slotsPerEpoch = void 0;
        /** The number of slots before beginning of an epoch to calculate a leader schedule for that epoch */ this.leaderScheduleSlotOffset = void 0;
        /** Indicates whether epochs start short and grow */ this.warmup = void 0;
        /** The first epoch with `slotsPerEpoch` slots */ this.firstNormalEpoch = void 0;
        /** The first slot of `firstNormalEpoch` */ this.firstNormalSlot = void 0;
        this.slotsPerEpoch = slotsPerEpoch;
        this.leaderScheduleSlotOffset = leaderScheduleSlotOffset;
        this.warmup = warmup;
        this.firstNormalEpoch = firstNormalEpoch;
        this.firstNormalSlot = firstNormalSlot;
    }
    getEpoch(slot) {
        return this.getEpochAndSlotIndex(slot)[0];
    }
    getEpochAndSlotIndex(slot) {
        if (slot < this.firstNormalSlot) {
            const epoch = $bccf75ed4dec0420$var$trailingZeros($bccf75ed4dec0420$var$nextPowerOfTwo(slot + $bccf75ed4dec0420$var$MINIMUM_SLOT_PER_EPOCH + 1)) - $bccf75ed4dec0420$var$trailingZeros($bccf75ed4dec0420$var$MINIMUM_SLOT_PER_EPOCH) - 1;
            const epochLen = this.getSlotsInEpoch(epoch);
            const slotIndex = slot - (epochLen - $bccf75ed4dec0420$var$MINIMUM_SLOT_PER_EPOCH);
            return [
                epoch,
                slotIndex
            ];
        } else {
            const normalSlotIndex = slot - this.firstNormalSlot;
            const normalEpochIndex = Math.floor(normalSlotIndex / this.slotsPerEpoch);
            const epoch = this.firstNormalEpoch + normalEpochIndex;
            const slotIndex = normalSlotIndex % this.slotsPerEpoch;
            return [
                epoch,
                slotIndex
            ];
        }
    }
    getFirstSlotInEpoch(epoch) {
        if (epoch <= this.firstNormalEpoch) return (Math.pow(2, epoch) - 1) * $bccf75ed4dec0420$var$MINIMUM_SLOT_PER_EPOCH;
        else return (epoch - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
    }
    getLastSlotInEpoch(epoch) {
        return this.getFirstSlotInEpoch(epoch) + this.getSlotsInEpoch(epoch) - 1;
    }
    getSlotsInEpoch(epoch) {
        if (epoch < this.firstNormalEpoch) return Math.pow(2, epoch + $bccf75ed4dec0420$var$trailingZeros($bccf75ed4dec0420$var$MINIMUM_SLOT_PER_EPOCH));
        else return this.slotsPerEpoch;
    }
}
var $bccf75ed4dec0420$var$fetchImpl = globalThis.fetch;
class $bccf75ed4dec0420$var$RpcWebSocketClient extends (0, $188fda512f3e94b2$export$b43a6d9568fa5272) {
    constructor(address, options, generate_request_id){
        const webSocketFactory = (url)=>{
            const rpc = (0, $188fda512f3e94b2$export$3909fb301d3dc8c9)(url, {
                autoconnect: true,
                max_reconnects: 5,
                reconnect: true,
                reconnect_interval: 1000,
                ...options
            });
            if ("socket" in rpc) this.underlyingSocket = rpc.socket;
            else this.underlyingSocket = rpc;
            return rpc;
        };
        super(webSocketFactory, address, options, generate_request_id);
        this.underlyingSocket = void 0;
    }
    call(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.call(...args);
        return Promise.reject(new Error("Tried to call a JSON-RPC method `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
    }
    notify(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.notify(...args);
        return Promise.reject(new Error("Tried to send a JSON-RPC notification `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
    }
}
/**
 * @internal
 */ /**
 * Decode account data buffer using an AccountType
 * @internal
 */ function $bccf75ed4dec0420$var$decodeData(type, data) {
    let decoded;
    try {
        decoded = type.layout.decode(data);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (decoded.typeIndex !== type.index) throw new Error(`invalid account data; account type mismatch ${decoded.typeIndex} != ${type.index}`);
    return decoded;
}
/// The serialized size of lookup table metadata
const $bccf75ed4dec0420$var$LOOKUP_TABLE_META_SIZE = 56;
class $bccf75ed4dec0420$export$5b2310da10e607da {
    constructor(args){
        this.key = void 0;
        this.state = void 0;
        this.key = args.key;
        this.state = args.state;
    }
    isActive() {
        const U64_MAX = BigInt("0xffffffffffffffff");
        return this.state.deactivationSlot === U64_MAX;
    }
    static deserialize(accountData) {
        const meta = $bccf75ed4dec0420$var$decodeData($bccf75ed4dec0420$var$LookupTableMetaLayout, accountData);
        const serializedAddressesLen = accountData.length - $bccf75ed4dec0420$var$LOOKUP_TABLE_META_SIZE;
        $bccf75ed4dec0420$var$assert(serializedAddressesLen >= 0, "lookup table is invalid");
        $bccf75ed4dec0420$var$assert(serializedAddressesLen % 32 === 0, "lookup table is invalid");
        const numSerializedAddresses = serializedAddressesLen / 32;
        const { addresses: addresses } = $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.seq($bccf75ed4dec0420$var$publicKey(), numSerializedAddresses, "addresses")
        ]).decode(accountData.slice($bccf75ed4dec0420$var$LOOKUP_TABLE_META_SIZE));
        return {
            deactivationSlot: meta.deactivationSlot,
            lastExtendedSlot: meta.lastExtendedSlot,
            lastExtendedSlotStartIndex: meta.lastExtendedStartIndex,
            authority: meta.authority.length !== 0 ? new $bccf75ed4dec0420$export$ca8b6604d6ce14de(meta.authority[0]) : undefined,
            addresses: addresses.map((address)=>new $bccf75ed4dec0420$export$ca8b6604d6ce14de(address))
        };
    }
}
const $bccf75ed4dec0420$var$LookupTableMetaLayout = {
    index: 1,
    layout: $10b678223f208f49$exports.struct([
        $10b678223f208f49$exports.u32("typeIndex"),
        $bccf75ed4dec0420$var$u64("deactivationSlot"),
        $10b678223f208f49$exports.nu64("lastExtendedSlot"),
        $10b678223f208f49$exports.u8("lastExtendedStartIndex"),
        $10b678223f208f49$exports.u8(),
        // option
        $10b678223f208f49$exports.seq($bccf75ed4dec0420$var$publicKey(), $10b678223f208f49$exports.offset($10b678223f208f49$exports.u8(), -1), "authority")
    ])
};
const $bccf75ed4dec0420$var$URL_RE = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function $bccf75ed4dec0420$var$makeWebsocketUrl(endpoint) {
    const matches = endpoint.match($bccf75ed4dec0420$var$URL_RE);
    if (matches == null) throw TypeError(`Failed to validate endpoint URL \`${endpoint}\``);
    const [_, // eslint-disable-line @typescript-eslint/no-unused-vars
    hostish, portWithColon, rest] = matches;
    const protocol = endpoint.startsWith("https:") ? "wss:" : "ws:";
    const startPort = portWithColon == null ? null : parseInt(portWithColon.slice(1), 10);
    const websocketPort = // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explicitly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to agave-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    startPort == null ? "" : `:${startPort + 1}`;
    return `${protocol}//${hostish}${websocketPort}${rest}`;
}
const $bccf75ed4dec0420$var$PublicKeyFromString = (0, $11e466829bcc37ce$export$8c14e57e778d3873)((0, $11e466829bcc37ce$export$9544d5bb712b01ea)($bccf75ed4dec0420$export$ca8b6604d6ce14de), (0, $11e466829bcc37ce$export$22b082955e083ec3)(), (value)=>new $bccf75ed4dec0420$export$ca8b6604d6ce14de(value));
const $bccf75ed4dec0420$var$RawAccountDataResult = (0, $11e466829bcc37ce$export$65e3907585753458)([
    (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("base64")
]);
const $bccf75ed4dec0420$var$BufferFromRawAccountData = (0, $11e466829bcc37ce$export$8c14e57e778d3873)((0, $11e466829bcc37ce$export$9544d5bb712b01ea)((0, $lewJ9.Buffer)), $bccf75ed4dec0420$var$RawAccountDataResult, (value)=>(0, $lewJ9.Buffer).from(value[0], "base64"));
/**
 * Attempt to use a recent blockhash for up to 30 seconds
 * @internal
 */ const $bccf75ed4dec0420$export$fcb705732fb5c597 = 30000;
/**
 * HACK.
 * Copied from rpc-websockets/dist/lib/client.
 * Otherwise, `yarn build` fails with:
 * https://gist.github.com/steveluscher/c057eca81d479ef705cdb53162f9971d
 */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /**
 * @internal
 * Every subscription contains the args used to open the subscription with
 * the server, and a list of callers interested in notifications.
 */ /**
 * @internal
 * A subscription may be in various states of connectedness. Only when it is
 * fully connected will it have a server subscription id associated with it.
 * This id can be returned to the server to unsubscribe the client entirely.
 */ /**
 * A type that encapsulates a subscription's RPC method
 * names and notification (callback) signature.
 */ /**
 * @internal
 * Utility type that keeps tagged unions intact while omitting properties.
 */ /**
 * @internal
 * This type represents a single subscribable 'topic.' It's made up of:
 *
 * - The args used to open the subscription with the server,
 * - The state of the subscription, in terms of its connectedness, and
 * - The set of callbacks to call when the server publishes notifications
 *
 * This record gets indexed by `SubscriptionConfigHash` and is used to
 * set up subscriptions, fan out notifications, and track subscription state.
 */ /**
 * @internal
 */ /**
 * Extra contextual information for RPC responses
 */ /**
 * Options for sending transactions
 */ /**
 * Options for confirming transactions
 */ /**
 * Options for getConfirmedSignaturesForAddress2
 */ /**
 * Options for getSignaturesForAddress
 */ /**
 * RPC Response with extra contextual information
 */ /**
 * A strategy for confirming transactions that uses the last valid
 * block height for a given blockhash to check for transaction expiration.
 */ /**
 * A strategy for confirming durable nonce transactions.
 */ /**
 * Properties shared by all transaction confirmation strategies
 */ /**
 * This type represents all transaction confirmation strategies
 */ /* @internal */ function $bccf75ed4dec0420$var$assertEndpointUrl(putativeUrl) {
    if (/^https?:/.test(putativeUrl) === false) throw new TypeError("Endpoint URL must start with `http:` or `https:`.");
    return putativeUrl;
}
/** @internal */ function $bccf75ed4dec0420$var$extractCommitmentFromConfig(commitmentOrConfig) {
    let commitment;
    let config;
    if (typeof commitmentOrConfig === "string") commitment = commitmentOrConfig;
    else if (commitmentOrConfig) {
        const { commitment: specifiedCommitment, ...specifiedConfig } = commitmentOrConfig;
        commitment = specifiedCommitment;
        config = specifiedConfig;
    }
    return {
        commitment: commitment,
        config: config
    };
}
/**
 * @internal
 */ function $bccf75ed4dec0420$var$applyDefaultMemcmpEncodingToFilters(filters) {
    return filters.map((filter)=>"memcmp" in filter ? {
            ...filter,
            memcmp: {
                ...filter.memcmp,
                encoding: filter.memcmp.encoding ?? "base58"
            }
        } : filter);
}
/**
 * @internal
 */ function $bccf75ed4dec0420$var$createRpcResult(result) {
    return (0, $11e466829bcc37ce$export$971dd5b0dfd021b6)([
        (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
            jsonrpc: (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("2.0"),
            id: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
            result: result
        }),
        (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
            jsonrpc: (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("2.0"),
            id: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
            error: (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
                code: (0, $11e466829bcc37ce$export$19282c40b967aec6)(),
                message: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
                data: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$4154a199d7d90455)())
            })
        })
    ]);
}
const $bccf75ed4dec0420$var$UnknownRpcResult = $bccf75ed4dec0420$var$createRpcResult((0, $11e466829bcc37ce$export$19282c40b967aec6)());
/**
 * @internal
 */ function $bccf75ed4dec0420$var$jsonRpcResult(schema) {
    return (0, $11e466829bcc37ce$export$8c14e57e778d3873)($bccf75ed4dec0420$var$createRpcResult(schema), $bccf75ed4dec0420$var$UnknownRpcResult, (value)=>{
        if ("error" in value) return value;
        else return {
            ...value,
            result: (0, $11e466829bcc37ce$export$185802fd694ee1f5)(value.result, schema)
        };
    });
}
/**
 * @internal
 */ function $bccf75ed4dec0420$var$jsonRpcResultAndContext(value) {
    return $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        context: (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
            slot: (0, $11e466829bcc37ce$export$98e628dec113755e)()
        }),
        value: value
    }));
}
/**
 * @internal
 */ function $bccf75ed4dec0420$var$notificationResultAndContext(value) {
    return (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        context: (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
            slot: (0, $11e466829bcc37ce$export$98e628dec113755e)()
        }),
        value: value
    });
}
/**
 * @internal
 */ function $bccf75ed4dec0420$var$versionedMessageFromResponse(version, response) {
    if (version === 0) return new $bccf75ed4dec0420$export$ee274c70e0fae590({
        header: response.header,
        staticAccountKeys: response.accountKeys.map((accountKey)=>new $bccf75ed4dec0420$export$ca8b6604d6ce14de(accountKey)),
        recentBlockhash: response.recentBlockhash,
        compiledInstructions: response.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($4fa1ea39de93f4d6$exports))).decode(ix.data)
            })),
        addressTableLookups: response.addressTableLookups
    });
    else return new $bccf75ed4dec0420$export$f69c19e57285b83a(response);
}
/**
 * The level of commitment desired when querying state
 * <pre>
 *   'processed': Query the most recent block which has reached 1 confirmation by the connected node
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ // Deprecated as of v1.5.5
/**
 * A subset of Commitment levels, which are at least optimistically confirmed
 * <pre>
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ /**
 * Filter for largest accounts query
 * <pre>
 *   'circulating':    Return the largest accounts that are part of the circulating supply
 *   'nonCirculating': Return the largest accounts that are not part of the circulating supply
 * </pre>
 */ /**
 * Configuration object for changing `getAccountInfo` query behavior
 */ /**
 * Configuration object for changing `getBalance` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getStakeMinimumDelegation` query behavior
 */ /**
 * Configuration object for changing `getBlockHeight` query behavior
 */ /**
 * Configuration object for changing `getEpochInfo` query behavior
 */ /**
 * Configuration object for changing `getInflationReward` query behavior
 */ /**
 * Configuration object for changing `getLatestBlockhash` query behavior
 */ /**
 * Configuration object for changing `isBlockhashValid` query behavior
 */ /**
 * Configuration object for changing `getSlot` query behavior
 */ /**
 * Configuration object for changing `getSlotLeader` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getLargestAccounts` query behavior
 */ /**
 * Configuration object for changing `getSupply` request behavior
 */ /**
 * Configuration object for changing query behavior
 */ /**
 * Information describing a cluster node
 */ /**
 * Information describing a vote account
 */ /**
 * A collection of cluster vote accounts
 */ /**
 * Network Inflation
 * (see https://docs.solana.com/implemented-proposals/ed_overview)
 */ const $bccf75ed4dec0420$var$GetInflationGovernorResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    foundation: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    foundationTerm: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    initial: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    taper: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    terminal: (0, $11e466829bcc37ce$export$98e628dec113755e)()
});
/**
 * The inflation reward for an epoch
 */ /**
 * Expected JSON RPC response for the "getInflationReward" message
 */ const $bccf75ed4dec0420$var$GetInflationRewardResult = $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    epoch: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    effectiveSlot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    amount: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    postBalance: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    commission: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)()))
}))));
/**
 * Configuration object for changing `getRecentPrioritizationFees` query behavior
 */ /**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $bccf75ed4dec0420$var$GetRecentPrioritizationFeesResult = (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    slot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    prioritizationFee: (0, $11e466829bcc37ce$export$98e628dec113755e)()
}));
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $bccf75ed4dec0420$var$GetInflationRateResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    total: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    validator: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    foundation: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    epoch: (0, $11e466829bcc37ce$export$98e628dec113755e)()
});
/**
 * Information about the current epoch
 */ const $bccf75ed4dec0420$var$GetEpochInfoResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    epoch: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    slotIndex: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    slotsInEpoch: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    absoluteSlot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    blockHeight: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$98e628dec113755e)()),
    transactionCount: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$98e628dec113755e)())
});
const $bccf75ed4dec0420$var$GetEpochScheduleResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    slotsPerEpoch: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    leaderScheduleSlotOffset: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    warmup: (0, $11e466829bcc37ce$export$4a21f16c33752377)(),
    firstNormalEpoch: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    firstNormalSlot: (0, $11e466829bcc37ce$export$98e628dec113755e)()
});
/**
 * Leader schedule
 * (see https://docs.solana.com/terminology#leader-schedule)
 */ const $bccf75ed4dec0420$var$GetLeaderScheduleResult = (0, $11e466829bcc37ce$export$e5185e241753e543)((0, $11e466829bcc37ce$export$22b082955e083ec3)(), (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$98e628dec113755e)()));
/**
 * Transaction error or null
 */ const $bccf75ed4dec0420$var$TransactionErrorResult = (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$971dd5b0dfd021b6)([
    (0, $11e466829bcc37ce$export$bf9fb029d174d554)({}),
    (0, $11e466829bcc37ce$export$22b082955e083ec3)()
]));
/**
 * Signature status for a transaction
 */ const $bccf75ed4dec0420$var$SignatureStatusResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    err: $bccf75ed4dec0420$var$TransactionErrorResult
});
/**
 * Transaction signature received notification
 */ const $bccf75ed4dec0420$var$SignatureReceivedResult = (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("receivedSignature");
/**
 * Version info for a node
 */ const $bccf75ed4dec0420$var$VersionResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    "solana-core": (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    "feature-set": (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$98e628dec113755e)())
});
const $bccf75ed4dec0420$var$ParsedInstructionStruct = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    program: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    programId: $bccf75ed4dec0420$var$PublicKeyFromString,
    parsed: (0, $11e466829bcc37ce$export$19282c40b967aec6)()
});
const $bccf75ed4dec0420$var$PartiallyDecodedInstructionStruct = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    programId: $bccf75ed4dec0420$var$PublicKeyFromString,
    accounts: (0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$PublicKeyFromString),
    data: (0, $11e466829bcc37ce$export$22b082955e083ec3)()
});
const $bccf75ed4dec0420$var$SimulatedTransactionResponseStruct = $bccf75ed4dec0420$var$jsonRpcResultAndContext((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    err: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$971dd5b0dfd021b6)([
        (0, $11e466829bcc37ce$export$bf9fb029d174d554)({}),
        (0, $11e466829bcc37ce$export$22b082955e083ec3)()
    ])),
    logs: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$22b082955e083ec3)())),
    accounts: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        executable: (0, $11e466829bcc37ce$export$4a21f16c33752377)(),
        owner: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
        lamports: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
        data: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$22b082955e083ec3)()),
        rentEpoch: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$98e628dec113755e)())
    }))))),
    unitsConsumed: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$98e628dec113755e)()),
    returnData: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        programId: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
        data: (0, $11e466829bcc37ce$export$65e3907585753458)([
            (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
            (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("base64")
        ])
    }))),
    innerInstructions: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        index: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
        instructions: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$971dd5b0dfd021b6)([
            $bccf75ed4dec0420$var$ParsedInstructionStruct,
            $bccf75ed4dec0420$var$PartiallyDecodedInstructionStruct
        ]))
    }))))
}));
/**
 * Metadata for a parsed confirmed transaction on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link ParsedTransactionMeta} instead.
 */ /**
 * Collection of addresses loaded by a transaction using address table lookups
 */ /**
 * Metadata for a parsed transaction on the ledger
 */ /**
 * Metadata for a confirmed transaction on the ledger
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction message from the RPC API
 */ /**
 * A confirmed transaction on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0.
 */ /**
 * A partially decoded transaction instruction
 */ /**
 * A parsed transaction message account
 */ /**
 * A parsed transaction instruction
 */ /**
 * A parsed address table lookup
 */ /**
 * A parsed transaction message
 */ /**
 * A parsed transaction
 */ /**
 * A parsed and confirmed transaction on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link ParsedTransactionWithMeta} instead.
 */ /**
 * A parsed transaction on the ledger with meta
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A block with parsed transactions
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `accounts`
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `none`
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A confirmed block on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0.
 */ /**
 * A Block on the ledger with signatures only
 */ /**
 * recent block production information
 */ /**
 * Expected JSON RPC response for the "getBlockProduction" message
 */ const $bccf75ed4dec0420$var$BlockProductionResponseStruct = $bccf75ed4dec0420$var$jsonRpcResultAndContext((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    byIdentity: (0, $11e466829bcc37ce$export$e5185e241753e543)((0, $11e466829bcc37ce$export$22b082955e083ec3)(), (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$98e628dec113755e)())),
    range: (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        firstSlot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
        lastSlot: (0, $11e466829bcc37ce$export$98e628dec113755e)()
    })
}));
/**
 * A performance sample
 */ function $bccf75ed4dec0420$var$createRpcClient(url, httpHeaders, customFetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent) {
    const fetch = customFetch ? customFetch : $bccf75ed4dec0420$var$fetchImpl;
    let agent;
    if (httpAgent != null) console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
    let fetchWithMiddleware;
    if (fetchMiddleware) fetchWithMiddleware = async (info, init)=>{
        const modifiedFetchArgs = await new Promise((resolve, reject)=>{
            try {
                fetchMiddleware(info, init, (modifiedInfo, modifiedInit)=>resolve([
                        modifiedInfo,
                        modifiedInit
                    ]));
            } catch (error) {
                reject(error);
            }
        });
        return await fetch(...modifiedFetchArgs);
    };
    const clientBrowser = new (0, (/*@__PURE__*/$parcel$interopDefault($a4b42cf2794dd0fd$exports)))(async (request, callback)=>{
        const options = {
            method: "POST",
            body: request,
            agent: agent,
            headers: Object.assign({
                "Content-Type": "application/json"
            }, httpHeaders || {}, $bccf75ed4dec0420$var$COMMON_HTTP_HEADERS)
        };
        try {
            let too_many_requests_retries = 5;
            let res;
            let waitTime = 500;
            for(;;){
                if (fetchWithMiddleware) res = await fetchWithMiddleware(url, options);
                else res = await fetch(url, options);
                if (res.status !== 429 /* Too many requests */ ) break;
                if (disableRetryOnRateLimit === true) break;
                too_many_requests_retries -= 1;
                if (too_many_requests_retries === 0) break;
                console.error(`Server responded with ${res.status} ${res.statusText}.  Retrying after ${waitTime}ms delay...`);
                await $bccf75ed4dec0420$var$sleep(waitTime);
                waitTime *= 2;
            }
            const text = await res.text();
            if (res.ok) callback(null, text);
            else callback(new Error(`${res.status} ${res.statusText}: ${text}`));
        } catch (err) {
            if (err instanceof Error) callback(err);
        }
    }, {});
    return clientBrowser;
}
function $bccf75ed4dec0420$var$createRpcRequest(client) {
    return (method, args)=>{
        return new Promise((resolve, reject)=>{
            client.request(method, args, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
function $bccf75ed4dec0420$var$createRpcBatchRequest(client) {
    return (requests)=>{
        return new Promise((resolve, reject)=>{
            // Do nothing if requests is empty
            if (requests.length === 0) resolve([]);
            const batch = requests.map((params)=>{
                return client.request(params.methodName, params.args);
            });
            client.request(batch, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
/**
 * Expected JSON RPC response for the "getInflationGovernor" message
 */ const $bccf75ed4dec0420$var$GetInflationGovernorRpcResult = $bccf75ed4dec0420$var$jsonRpcResult($bccf75ed4dec0420$var$GetInflationGovernorResult);
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $bccf75ed4dec0420$var$GetInflationRateRpcResult = $bccf75ed4dec0420$var$jsonRpcResult($bccf75ed4dec0420$var$GetInflationRateResult);
/**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $bccf75ed4dec0420$var$GetRecentPrioritizationFeesRpcResult = $bccf75ed4dec0420$var$jsonRpcResult($bccf75ed4dec0420$var$GetRecentPrioritizationFeesResult);
/**
 * Expected JSON RPC response for the "getEpochInfo" message
 */ const $bccf75ed4dec0420$var$GetEpochInfoRpcResult = $bccf75ed4dec0420$var$jsonRpcResult($bccf75ed4dec0420$var$GetEpochInfoResult);
/**
 * Expected JSON RPC response for the "getEpochSchedule" message
 */ const $bccf75ed4dec0420$var$GetEpochScheduleRpcResult = $bccf75ed4dec0420$var$jsonRpcResult($bccf75ed4dec0420$var$GetEpochScheduleResult);
/**
 * Expected JSON RPC response for the "getLeaderSchedule" message
 */ const $bccf75ed4dec0420$var$GetLeaderScheduleRpcResult = $bccf75ed4dec0420$var$jsonRpcResult($bccf75ed4dec0420$var$GetLeaderScheduleResult);
/**
 * Expected JSON RPC response for the "minimumLedgerSlot" and "getFirstAvailableBlock" messages
 */ const $bccf75ed4dec0420$var$SlotRpcResult = $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$98e628dec113755e)());
/**
 * Supply
 */ /**
 * Expected JSON RPC response for the "getSupply" message
 */ const $bccf75ed4dec0420$var$GetSupplyRpcResult = $bccf75ed4dec0420$var$jsonRpcResultAndContext((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    total: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    circulating: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    nonCirculating: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    nonCirculatingAccounts: (0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$PublicKeyFromString)
}));
/**
 * Token amount object which returns a token amount in different formats
 * for various client use cases.
 */ /**
 * Expected JSON RPC structure for token amounts
 */ const $bccf75ed4dec0420$var$TokenAmountResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    amount: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    uiAmount: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)()),
    decimals: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    uiAmountString: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$22b082955e083ec3)())
});
/**
 * Token address and balance.
 */ /**
 * Expected JSON RPC response for the "getTokenLargestAccounts" message
 */ const $bccf75ed4dec0420$var$GetTokenLargestAccountsResult = $bccf75ed4dec0420$var$jsonRpcResultAndContext((0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    address: $bccf75ed4dec0420$var$PublicKeyFromString,
    amount: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    uiAmount: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)()),
    decimals: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    uiAmountString: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$22b082955e083ec3)())
})));
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message
 */ const $bccf75ed4dec0420$var$GetTokenAccountsByOwner = $bccf75ed4dec0420$var$jsonRpcResultAndContext((0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    pubkey: $bccf75ed4dec0420$var$PublicKeyFromString,
    account: (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        executable: (0, $11e466829bcc37ce$export$4a21f16c33752377)(),
        owner: $bccf75ed4dec0420$var$PublicKeyFromString,
        lamports: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
        data: $bccf75ed4dec0420$var$BufferFromRawAccountData,
        rentEpoch: (0, $11e466829bcc37ce$export$98e628dec113755e)()
    })
})));
const $bccf75ed4dec0420$var$ParsedAccountDataResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    program: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    parsed: (0, $11e466829bcc37ce$export$19282c40b967aec6)(),
    space: (0, $11e466829bcc37ce$export$98e628dec113755e)()
});
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message with parsed data
 */ const $bccf75ed4dec0420$var$GetParsedTokenAccountsByOwner = $bccf75ed4dec0420$var$jsonRpcResultAndContext((0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    pubkey: $bccf75ed4dec0420$var$PublicKeyFromString,
    account: (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        executable: (0, $11e466829bcc37ce$export$4a21f16c33752377)(),
        owner: $bccf75ed4dec0420$var$PublicKeyFromString,
        lamports: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
        data: $bccf75ed4dec0420$var$ParsedAccountDataResult,
        rentEpoch: (0, $11e466829bcc37ce$export$98e628dec113755e)()
    })
})));
/**
 * Pair of an account address and its balance
 */ /**
 * Expected JSON RPC response for the "getLargestAccounts" message
 */ const $bccf75ed4dec0420$var$GetLargestAccountsRpcResult = $bccf75ed4dec0420$var$jsonRpcResultAndContext((0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    lamports: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    address: $bccf75ed4dec0420$var$PublicKeyFromString
})));
/**
 * @internal
 */ const $bccf75ed4dec0420$var$AccountInfoResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    executable: (0, $11e466829bcc37ce$export$4a21f16c33752377)(),
    owner: $bccf75ed4dec0420$var$PublicKeyFromString,
    lamports: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    data: $bccf75ed4dec0420$var$BufferFromRawAccountData,
    rentEpoch: (0, $11e466829bcc37ce$export$98e628dec113755e)()
});
/**
 * @internal
 */ const $bccf75ed4dec0420$var$KeyedAccountInfoResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    pubkey: $bccf75ed4dec0420$var$PublicKeyFromString,
    account: $bccf75ed4dec0420$var$AccountInfoResult
});
const $bccf75ed4dec0420$var$ParsedOrRawAccountData = (0, $11e466829bcc37ce$export$8c14e57e778d3873)((0, $11e466829bcc37ce$export$971dd5b0dfd021b6)([
    (0, $11e466829bcc37ce$export$9544d5bb712b01ea)((0, $lewJ9.Buffer)),
    $bccf75ed4dec0420$var$ParsedAccountDataResult
]), (0, $11e466829bcc37ce$export$971dd5b0dfd021b6)([
    $bccf75ed4dec0420$var$RawAccountDataResult,
    $bccf75ed4dec0420$var$ParsedAccountDataResult
]), (value)=>{
    if (Array.isArray(value)) return (0, $11e466829bcc37ce$export$185802fd694ee1f5)(value, $bccf75ed4dec0420$var$BufferFromRawAccountData);
    else return value;
});
/**
 * @internal
 */ const $bccf75ed4dec0420$var$ParsedAccountInfoResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    executable: (0, $11e466829bcc37ce$export$4a21f16c33752377)(),
    owner: $bccf75ed4dec0420$var$PublicKeyFromString,
    lamports: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    data: $bccf75ed4dec0420$var$ParsedOrRawAccountData,
    rentEpoch: (0, $11e466829bcc37ce$export$98e628dec113755e)()
});
const $bccf75ed4dec0420$var$KeyedParsedAccountInfoResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    pubkey: $bccf75ed4dec0420$var$PublicKeyFromString,
    account: $bccf75ed4dec0420$var$ParsedAccountInfoResult
});
/**
 * @internal
 */ const $bccf75ed4dec0420$var$StakeActivationResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    state: (0, $11e466829bcc37ce$export$971dd5b0dfd021b6)([
        (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("active"),
        (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("inactive"),
        (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("activating"),
        (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("deactivating")
    ]),
    active: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    inactive: (0, $11e466829bcc37ce$export$98e628dec113755e)()
});
/**
 * Expected JSON RPC response for the "getConfirmedSignaturesForAddress2" message
 */ const $bccf75ed4dec0420$var$GetConfirmedSignaturesForAddress2RpcResult = $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    signature: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    slot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    err: $bccf75ed4dec0420$var$TransactionErrorResult,
    memo: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$22b082955e083ec3)()),
    blockTime: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)()))
})));
/**
 * Expected JSON RPC response for the "getSignaturesForAddress" message
 */ const $bccf75ed4dec0420$var$GetSignaturesForAddressRpcResult = $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    signature: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    slot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    err: $bccf75ed4dec0420$var$TransactionErrorResult,
    memo: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$22b082955e083ec3)()),
    blockTime: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)()))
})));
/***
 * Expected JSON RPC response for the "accountNotification" message
 */ const $bccf75ed4dec0420$var$AccountNotificationResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    subscription: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    result: $bccf75ed4dec0420$var$notificationResultAndContext($bccf75ed4dec0420$var$AccountInfoResult)
});
/**
 * @internal
 */ const $bccf75ed4dec0420$var$ProgramAccountInfoResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    pubkey: $bccf75ed4dec0420$var$PublicKeyFromString,
    account: $bccf75ed4dec0420$var$AccountInfoResult
});
/***
 * Expected JSON RPC response for the "programNotification" message
 */ const $bccf75ed4dec0420$var$ProgramAccountNotificationResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    subscription: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    result: $bccf75ed4dec0420$var$notificationResultAndContext($bccf75ed4dec0420$var$ProgramAccountInfoResult)
});
/**
 * @internal
 */ const $bccf75ed4dec0420$var$SlotInfoResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    parent: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    slot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    root: (0, $11e466829bcc37ce$export$98e628dec113755e)()
});
/**
 * Expected JSON RPC response for the "slotNotification" message
 */ const $bccf75ed4dec0420$var$SlotNotificationResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    subscription: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    result: $bccf75ed4dec0420$var$SlotInfoResult
});
/**
 * Slot updates which can be used for tracking the live progress of a cluster.
 * - `"firstShredReceived"`: connected node received the first shred of a block.
 * Indicates that a new block that is being produced.
 * - `"completed"`: connected node has received all shreds of a block. Indicates
 * a block was recently produced.
 * - `"optimisticConfirmation"`: block was optimistically confirmed by the
 * cluster. It is not guaranteed that an optimistic confirmation notification
 * will be sent for every finalized blocks.
 * - `"root"`: the connected node rooted this block.
 * - `"createdBank"`: the connected node has started validating this block.
 * - `"frozen"`: the connected node has validated this block.
 * - `"dead"`: the connected node failed to validate this block.
 */ /**
 * @internal
 */ const $bccf75ed4dec0420$var$SlotUpdateResult = (0, $11e466829bcc37ce$export$971dd5b0dfd021b6)([
    (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        type: (0, $11e466829bcc37ce$export$971dd5b0dfd021b6)([
            (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("firstShredReceived"),
            (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("completed"),
            (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("optimisticConfirmation"),
            (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("root")
        ]),
        slot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
        timestamp: (0, $11e466829bcc37ce$export$98e628dec113755e)()
    }),
    (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        type: (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("createdBank"),
        parent: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
        slot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
        timestamp: (0, $11e466829bcc37ce$export$98e628dec113755e)()
    }),
    (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        type: (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("frozen"),
        slot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
        timestamp: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
        stats: (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
            numTransactionEntries: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
            numSuccessfulTransactions: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
            numFailedTransactions: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
            maxTransactionsPerEntry: (0, $11e466829bcc37ce$export$98e628dec113755e)()
        })
    }),
    (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        type: (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("dead"),
        slot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
        timestamp: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
        err: (0, $11e466829bcc37ce$export$22b082955e083ec3)()
    })
]);
/**
 * Expected JSON RPC response for the "slotsUpdatesNotification" message
 */ const $bccf75ed4dec0420$var$SlotUpdateNotificationResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    subscription: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    result: $bccf75ed4dec0420$var$SlotUpdateResult
});
/**
 * Expected JSON RPC response for the "signatureNotification" message
 */ const $bccf75ed4dec0420$var$SignatureNotificationResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    subscription: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    result: $bccf75ed4dec0420$var$notificationResultAndContext((0, $11e466829bcc37ce$export$971dd5b0dfd021b6)([
        $bccf75ed4dec0420$var$SignatureStatusResult,
        $bccf75ed4dec0420$var$SignatureReceivedResult
    ]))
});
/**
 * Expected JSON RPC response for the "rootNotification" message
 */ const $bccf75ed4dec0420$var$RootNotificationResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    subscription: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    result: (0, $11e466829bcc37ce$export$98e628dec113755e)()
});
const $bccf75ed4dec0420$var$ContactInfoResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    pubkey: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    gossip: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$22b082955e083ec3)()),
    tpu: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$22b082955e083ec3)()),
    rpc: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$22b082955e083ec3)()),
    version: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$22b082955e083ec3)())
});
const $bccf75ed4dec0420$var$VoteAccountInfoResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    votePubkey: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    nodePubkey: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    activatedStake: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    epochVoteAccount: (0, $11e466829bcc37ce$export$4a21f16c33752377)(),
    epochCredits: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$65e3907585753458)([
        (0, $11e466829bcc37ce$export$98e628dec113755e)(),
        (0, $11e466829bcc37ce$export$98e628dec113755e)(),
        (0, $11e466829bcc37ce$export$98e628dec113755e)()
    ])),
    commission: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    lastVote: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    rootSlot: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)())
});
/**
 * Expected JSON RPC response for the "getVoteAccounts" message
 */ const $bccf75ed4dec0420$var$GetVoteAccounts = $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    current: (0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$VoteAccountInfoResult),
    delinquent: (0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$VoteAccountInfoResult)
}));
const $bccf75ed4dec0420$var$ConfirmationStatus = (0, $11e466829bcc37ce$export$971dd5b0dfd021b6)([
    (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("processed"),
    (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("confirmed"),
    (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("finalized")
]);
const $bccf75ed4dec0420$var$SignatureStatusResponse = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    slot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    confirmations: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)()),
    err: $bccf75ed4dec0420$var$TransactionErrorResult,
    confirmationStatus: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)($bccf75ed4dec0420$var$ConfirmationStatus)
});
/**
 * Expected JSON RPC response for the "getSignatureStatuses" message
 */ const $bccf75ed4dec0420$var$GetSignatureStatusesRpcResult = $bccf75ed4dec0420$var$jsonRpcResultAndContext((0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$133fc36489ac9add)($bccf75ed4dec0420$var$SignatureStatusResponse)));
/**
 * Expected JSON RPC response for the "getMinimumBalanceForRentExemption" message
 */ const $bccf75ed4dec0420$var$GetMinimumBalanceForRentExemptionRpcResult = $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$98e628dec113755e)());
const $bccf75ed4dec0420$var$AddressTableLookupStruct = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    accountKey: $bccf75ed4dec0420$var$PublicKeyFromString,
    writableIndexes: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$98e628dec113755e)()),
    readonlyIndexes: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$98e628dec113755e)())
});
const $bccf75ed4dec0420$var$ConfirmedTransactionResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    signatures: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$22b082955e083ec3)()),
    message: (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        accountKeys: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$22b082955e083ec3)()),
        header: (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
            numRequiredSignatures: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
            numReadonlySignedAccounts: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
            numReadonlyUnsignedAccounts: (0, $11e466829bcc37ce$export$98e628dec113755e)()
        }),
        instructions: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
            accounts: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$98e628dec113755e)()),
            data: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
            programIdIndex: (0, $11e466829bcc37ce$export$98e628dec113755e)()
        })),
        recentBlockhash: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
        addressTableLookups: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$AddressTableLookupStruct))
    })
});
const $bccf75ed4dec0420$var$AnnotatedAccountKey = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    pubkey: $bccf75ed4dec0420$var$PublicKeyFromString,
    signer: (0, $11e466829bcc37ce$export$4a21f16c33752377)(),
    writable: (0, $11e466829bcc37ce$export$4a21f16c33752377)(),
    source: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$971dd5b0dfd021b6)([
        (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("transaction"),
        (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("lookupTable")
    ]))
});
const $bccf75ed4dec0420$var$ConfirmedTransactionAccountsModeResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    accountKeys: (0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$AnnotatedAccountKey),
    signatures: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$22b082955e083ec3)())
});
const $bccf75ed4dec0420$var$ParsedInstructionResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    parsed: (0, $11e466829bcc37ce$export$19282c40b967aec6)(),
    program: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    programId: $bccf75ed4dec0420$var$PublicKeyFromString
});
const $bccf75ed4dec0420$var$RawInstructionResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    accounts: (0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$PublicKeyFromString),
    data: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    programId: $bccf75ed4dec0420$var$PublicKeyFromString
});
const $bccf75ed4dec0420$var$InstructionResult = (0, $11e466829bcc37ce$export$971dd5b0dfd021b6)([
    $bccf75ed4dec0420$var$RawInstructionResult,
    $bccf75ed4dec0420$var$ParsedInstructionResult
]);
const $bccf75ed4dec0420$var$UnknownInstructionResult = (0, $11e466829bcc37ce$export$971dd5b0dfd021b6)([
    (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        parsed: (0, $11e466829bcc37ce$export$19282c40b967aec6)(),
        program: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
        programId: (0, $11e466829bcc37ce$export$22b082955e083ec3)()
    }),
    (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        accounts: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$22b082955e083ec3)()),
        data: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
        programId: (0, $11e466829bcc37ce$export$22b082955e083ec3)()
    })
]);
const $bccf75ed4dec0420$var$ParsedOrRawInstruction = (0, $11e466829bcc37ce$export$8c14e57e778d3873)($bccf75ed4dec0420$var$InstructionResult, $bccf75ed4dec0420$var$UnknownInstructionResult, (value)=>{
    if ("accounts" in value) return (0, $11e466829bcc37ce$export$185802fd694ee1f5)(value, $bccf75ed4dec0420$var$RawInstructionResult);
    else return (0, $11e466829bcc37ce$export$185802fd694ee1f5)(value, $bccf75ed4dec0420$var$ParsedInstructionResult);
});
/**
 * @internal
 */ const $bccf75ed4dec0420$var$ParsedConfirmedTransactionResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    signatures: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$22b082955e083ec3)()),
    message: (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        accountKeys: (0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$AnnotatedAccountKey),
        instructions: (0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$ParsedOrRawInstruction),
        recentBlockhash: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
        addressTableLookups: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$AddressTableLookupStruct)))
    })
});
const $bccf75ed4dec0420$var$TokenBalanceResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    accountIndex: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    mint: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    owner: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$22b082955e083ec3)()),
    programId: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$22b082955e083ec3)()),
    uiTokenAmount: $bccf75ed4dec0420$var$TokenAmountResult
});
const $bccf75ed4dec0420$var$LoadedAddressesResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    writable: (0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$PublicKeyFromString),
    readonly: (0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$PublicKeyFromString)
});
/**
 * @internal
 */ const $bccf75ed4dec0420$var$ConfirmedTransactionMetaResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    err: $bccf75ed4dec0420$var$TransactionErrorResult,
    fee: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    innerInstructions: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        index: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
        instructions: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
            accounts: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$98e628dec113755e)()),
            data: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
            programIdIndex: (0, $11e466829bcc37ce$export$98e628dec113755e)()
        }))
    })))),
    preBalances: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$98e628dec113755e)()),
    postBalances: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$98e628dec113755e)()),
    logMessages: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$22b082955e083ec3)()))),
    preTokenBalances: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$TokenBalanceResult))),
    postTokenBalances: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$TokenBalanceResult))),
    loadedAddresses: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)($bccf75ed4dec0420$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$98e628dec113755e)())
});
/**
 * @internal
 */ const $bccf75ed4dec0420$var$ParsedConfirmedTransactionMetaResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    err: $bccf75ed4dec0420$var$TransactionErrorResult,
    fee: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    innerInstructions: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        index: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
        instructions: (0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$ParsedOrRawInstruction)
    })))),
    preBalances: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$98e628dec113755e)()),
    postBalances: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$98e628dec113755e)()),
    logMessages: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$22b082955e083ec3)()))),
    preTokenBalances: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$TokenBalanceResult))),
    postTokenBalances: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$TokenBalanceResult))),
    loadedAddresses: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)($bccf75ed4dec0420$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$98e628dec113755e)())
});
const $bccf75ed4dec0420$var$TransactionVersionStruct = (0, $11e466829bcc37ce$export$971dd5b0dfd021b6)([
    (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)(0),
    (0, $11e466829bcc37ce$export$c8ec6e1ec9fefcb0)("legacy")
]);
/** @internal */ const $bccf75ed4dec0420$var$RewardsResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    pubkey: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    lamports: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    postBalance: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)()),
    rewardType: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$22b082955e083ec3)()),
    commission: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)()))
});
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $bccf75ed4dec0420$var$GetBlockRpcResult = $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    blockhash: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    previousBlockhash: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    parentSlot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    transactions: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        transaction: $bccf75ed4dec0420$var$ConfirmedTransactionResult,
        meta: (0, $11e466829bcc37ce$export$133fc36489ac9add)($bccf75ed4dec0420$var$ConfirmedTransactionMetaResult),
        version: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)($bccf75ed4dec0420$var$TransactionVersionStruct)
    })),
    rewards: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$RewardsResult)),
    blockTime: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)()),
    blockHeight: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `none`
 */ const $bccf75ed4dec0420$var$GetNoneModeBlockRpcResult = $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    blockhash: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    previousBlockhash: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    parentSlot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    rewards: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$RewardsResult)),
    blockTime: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)()),
    blockHeight: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `accounts`
 */ const $bccf75ed4dec0420$var$GetAccountsModeBlockRpcResult = $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    blockhash: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    previousBlockhash: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    parentSlot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    transactions: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        transaction: $bccf75ed4dec0420$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $11e466829bcc37ce$export$133fc36489ac9add)($bccf75ed4dec0420$var$ConfirmedTransactionMetaResult),
        version: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)($bccf75ed4dec0420$var$TransactionVersionStruct)
    })),
    rewards: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$RewardsResult)),
    blockTime: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)()),
    blockHeight: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message
 */ const $bccf75ed4dec0420$var$GetParsedBlockRpcResult = $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    blockhash: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    previousBlockhash: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    parentSlot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    transactions: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        transaction: $bccf75ed4dec0420$var$ParsedConfirmedTransactionResult,
        meta: (0, $11e466829bcc37ce$export$133fc36489ac9add)($bccf75ed4dec0420$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)($bccf75ed4dec0420$var$TransactionVersionStruct)
    })),
    rewards: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$RewardsResult)),
    blockTime: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)()),
    blockHeight: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `accounts`
 */ const $bccf75ed4dec0420$var$GetParsedAccountsModeBlockRpcResult = $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    blockhash: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    previousBlockhash: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    parentSlot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    transactions: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        transaction: $bccf75ed4dec0420$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $11e466829bcc37ce$export$133fc36489ac9add)($bccf75ed4dec0420$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)($bccf75ed4dec0420$var$TransactionVersionStruct)
    })),
    rewards: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$RewardsResult)),
    blockTime: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)()),
    blockHeight: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `none`
 */ const $bccf75ed4dec0420$var$GetParsedNoneModeBlockRpcResult = $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    blockhash: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    previousBlockhash: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    parentSlot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    rewards: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$RewardsResult)),
    blockTime: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)()),
    blockHeight: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getConfirmedBlock" message
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link GetBlockRpcResult} instead.
 */ const $bccf75ed4dec0420$var$GetConfirmedBlockRpcResult = $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    blockhash: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    previousBlockhash: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    parentSlot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    transactions: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        transaction: $bccf75ed4dec0420$var$ConfirmedTransactionResult,
        meta: (0, $11e466829bcc37ce$export$133fc36489ac9add)($bccf75ed4dec0420$var$ConfirmedTransactionMetaResult)
    })),
    rewards: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$RewardsResult)),
    blockTime: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $bccf75ed4dec0420$var$GetBlockSignaturesRpcResult = $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    blockhash: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    previousBlockhash: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    parentSlot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    signatures: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$22b082955e083ec3)()),
    blockTime: (0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getTransaction" message
 */ const $bccf75ed4dec0420$var$GetTransactionRpcResult = $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    slot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    meta: (0, $11e466829bcc37ce$export$133fc36489ac9add)($bccf75ed4dec0420$var$ConfirmedTransactionMetaResult),
    blockTime: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)())),
    transaction: $bccf75ed4dec0420$var$ConfirmedTransactionResult,
    version: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)($bccf75ed4dec0420$var$TransactionVersionStruct)
})));
/**
 * Expected parsed JSON RPC response for the "getTransaction" message
 */ const $bccf75ed4dec0420$var$GetParsedTransactionRpcResult = $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    slot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    transaction: $bccf75ed4dec0420$var$ParsedConfirmedTransactionResult,
    meta: (0, $11e466829bcc37ce$export$133fc36489ac9add)($bccf75ed4dec0420$var$ParsedConfirmedTransactionMetaResult),
    blockTime: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)())),
    version: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)($bccf75ed4dec0420$var$TransactionVersionStruct)
})));
/**
 * Expected JSON RPC response for the "getLatestBlockhash" message
 */ const $bccf75ed4dec0420$var$GetLatestBlockhashRpcResult = $bccf75ed4dec0420$var$jsonRpcResultAndContext((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    blockhash: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    lastValidBlockHeight: (0, $11e466829bcc37ce$export$98e628dec113755e)()
}));
/**
 * Expected JSON RPC response for the "isBlockhashValid" message
 */ const $bccf75ed4dec0420$var$IsBlockhashValidRpcResult = $bccf75ed4dec0420$var$jsonRpcResultAndContext((0, $11e466829bcc37ce$export$4a21f16c33752377)());
const $bccf75ed4dec0420$var$PerfSampleResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    slot: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    numTransactions: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    numSlots: (0, $11e466829bcc37ce$export$98e628dec113755e)(),
    samplePeriodSecs: (0, $11e466829bcc37ce$export$98e628dec113755e)()
});
/*
 * Expected JSON RPC response for "getRecentPerformanceSamples" message
 */ const $bccf75ed4dec0420$var$GetRecentPerformanceSamplesRpcResult = $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$PerfSampleResult));
/**
 * Expected JSON RPC response for the "getFeeCalculatorForBlockhash" message
 */ const $bccf75ed4dec0420$var$GetFeeCalculatorRpcResult = $bccf75ed4dec0420$var$jsonRpcResultAndContext((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    feeCalculator: (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
        lamportsPerSignature: (0, $11e466829bcc37ce$export$98e628dec113755e)()
    })
})));
/**
 * Expected JSON RPC response for the "requestAirdrop" message
 */ const $bccf75ed4dec0420$var$RequestAirdropRpcResult = $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$22b082955e083ec3)());
/**
 * Expected JSON RPC response for the "sendTransaction" message
 */ const $bccf75ed4dec0420$var$SendTransactionRpcResult = $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$22b082955e083ec3)());
/**
 * Information about the latest slot being processed by a node
 */ /**
 * Parsed account data
 */ /**
 * Stake Activation data
 */ /**
 * Data slice argument for getProgramAccounts
 */ /**
 * Memory comparison filter for getProgramAccounts
 */ /**
 * Data size comparison filter for getProgramAccounts
 */ /**
 * A filter object for getProgramAccounts
 */ /**
 * Configuration object for getProgramAccounts requests
 */ /**
 * Configuration object for getParsedProgramAccounts
 */ /**
 * Configuration object for getMultipleAccounts
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getNonce`
 */ /**
 * Configuration object for `getNonceAndContext`
 */ /**
 * Information describing an account
 */ /**
 * Account information identified by pubkey
 */ /**
 * Callback function for account change notifications
 */ /**
 * Callback function for program account change notifications
 */ /**
 * Callback function for slot change notifications
 */ /**
 * Callback function for slot update notifications
 */ /**
 * Callback function for signature status notifications
 */ /**
 * Signature status notification with transaction result
 */ /**
 * Signature received notification
 */ /**
 * Callback function for signature notifications
 */ /**
 * Signature subscription options
 */ /**
 * Callback function for root change notifications
 */ /**
 * @internal
 */ const $bccf75ed4dec0420$var$LogsResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    err: $bccf75ed4dec0420$var$TransactionErrorResult,
    logs: (0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$22b082955e083ec3)()),
    signature: (0, $11e466829bcc37ce$export$22b082955e083ec3)()
});
/**
 * Logs result.
 */ /**
 * Expected JSON RPC response for the "logsNotification" message.
 */ const $bccf75ed4dec0420$var$LogsNotificationResult = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    result: $bccf75ed4dec0420$var$notificationResultAndContext($bccf75ed4dec0420$var$LogsResult),
    subscription: (0, $11e466829bcc37ce$export$98e628dec113755e)()
});
/**
 * Filter for log subscriptions.
 */ /**
 * Callback function for log notifications.
 */ /**
 * Signature result
 */ /**
 * Transaction error
 */ /**
 * Transaction confirmation status
 * <pre>
 *   'processed': Transaction landed in a block which has reached 1 confirmation by the connected node
 *   'confirmed': Transaction landed in a block which has reached 1 confirmation by the cluster
 *   'finalized': Transaction landed in a block which has been finalized by the cluster
 * </pre>
 */ /**
 * Signature status
 */ /**
 * A confirmed signature with its status
 */ /**
 * An object defining headers to be passed to the RPC server
 */ /**
 * The type of the JavaScript `fetch()` API
 */ /**
 * A callback used to augment the outgoing HTTP request
 */ /**
 * Configuration for instantiating a Connection
 */ /** @internal */ const $bccf75ed4dec0420$var$COMMON_HTTP_HEADERS = {
    "solana-client": `js/${"1.0.0-maintenance"}`
};
/**
 * A connection to a fullnode JSON RPC endpoint
 */ class $bccf75ed4dec0420$export$98b66c25bb38499d {
    /**
   * Establish a JSON RPC connection
   *
   * @param endpoint URL to the fullnode JSON RPC endpoint
   * @param commitmentOrConfig optional default commitment level or optional ConnectionConfig configuration object
   */ constructor(endpoint, _commitmentOrConfig){
        /** @internal */ this._commitment = void 0;
        /** @internal */ this._confirmTransactionInitialTimeout = void 0;
        /** @internal */ this._rpcEndpoint = void 0;
        /** @internal */ this._rpcWsEndpoint = void 0;
        /** @internal */ this._rpcClient = void 0;
        /** @internal */ this._rpcRequest = void 0;
        /** @internal */ this._rpcBatchRequest = void 0;
        /** @internal */ this._rpcWebSocket = void 0;
        /** @internal */ this._rpcWebSocketConnected = false;
        /** @internal */ this._rpcWebSocketHeartbeat = null;
        /** @internal */ this._rpcWebSocketIdleTimeout = null;
        /** @internal
     * A number that we increment every time an active connection closes.
     * Used to determine whether the same socket connection that was open
     * when an async operation started is the same one that's active when
     * its continuation fires.
     *
     */ this._rpcWebSocketGeneration = 0;
        /** @internal */ this._disableBlockhashCaching = false;
        /** @internal */ this._pollingBlockhash = false;
        /** @internal */ this._blockhashInfo = {
            latestBlockhash: null,
            lastFetch: 0,
            transactionSignatures: [],
            simulatedSignatures: []
        };
        /** @internal */ this._nextClientSubscriptionId = 0;
        /** @internal */ this._subscriptionDisposeFunctionsByClientSubscriptionId = {};
        /** @internal */ this._subscriptionHashByClientSubscriptionId = {};
        /** @internal */ this._subscriptionStateChangeCallbacksByHash = {};
        /** @internal */ this._subscriptionCallbacksByServerSubscriptionId = {};
        /** @internal */ this._subscriptionsByHash = {};
        /**
     * Special case.
     * After a signature is processed, RPCs automatically dispose of the
     * subscription on the server side. We need to track which of these
     * subscriptions have been disposed in such a way, so that we know
     * whether the client is dealing with a not-yet-processed signature
     * (in which case we must tear down the server subscription) or an
     * already-processed signature (in which case the client can simply
     * clear out the subscription locally without telling the server).
     *
     * NOTE: There is a proposal to eliminate this special case, here:
     * https://github.com/solana-labs/solana/issues/18892
     */ /** @internal */ this._subscriptionsAutoDisposedByRpc = new Set();
        /*
     * Returns the current block height of the node
     */ this.getBlockHeight = (()=>{
            const requestPromises = {};
            return async (commitmentOrConfig)=>{
                const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(commitmentOrConfig);
                const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
                const requestHash = $bccf75ed4dec0420$var$fastStableStringify(args);
                requestPromises[requestHash] = requestPromises[requestHash] ?? (async ()=>{
                    try {
                        const unsafeRes = await this._rpcRequest("getBlockHeight", args);
                        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$98e628dec113755e)()));
                        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get block height information");
                        return res.result;
                    } finally{
                        delete requestPromises[requestHash];
                    }
                })();
                return await requestPromises[requestHash];
            };
        })();
        let wsEndpoint;
        let httpHeaders;
        let fetch;
        let fetchMiddleware;
        let disableRetryOnRateLimit;
        let httpAgent;
        if (_commitmentOrConfig && typeof _commitmentOrConfig === "string") this._commitment = _commitmentOrConfig;
        else if (_commitmentOrConfig) {
            this._commitment = _commitmentOrConfig.commitment;
            this._confirmTransactionInitialTimeout = _commitmentOrConfig.confirmTransactionInitialTimeout;
            wsEndpoint = _commitmentOrConfig.wsEndpoint;
            httpHeaders = _commitmentOrConfig.httpHeaders;
            fetch = _commitmentOrConfig.fetch;
            fetchMiddleware = _commitmentOrConfig.fetchMiddleware;
            disableRetryOnRateLimit = _commitmentOrConfig.disableRetryOnRateLimit;
            httpAgent = _commitmentOrConfig.httpAgent;
        }
        this._rpcEndpoint = $bccf75ed4dec0420$var$assertEndpointUrl(endpoint);
        this._rpcWsEndpoint = wsEndpoint || $bccf75ed4dec0420$var$makeWebsocketUrl(endpoint);
        this._rpcClient = $bccf75ed4dec0420$var$createRpcClient(endpoint, httpHeaders, fetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent);
        this._rpcRequest = $bccf75ed4dec0420$var$createRpcRequest(this._rpcClient);
        this._rpcBatchRequest = $bccf75ed4dec0420$var$createRpcBatchRequest(this._rpcClient);
        this._rpcWebSocket = new $bccf75ed4dec0420$var$RpcWebSocketClient(this._rpcWsEndpoint, {
            autoconnect: false,
            max_reconnects: Infinity
        });
        this._rpcWebSocket.on("open", this._wsOnOpen.bind(this));
        this._rpcWebSocket.on("error", this._wsOnError.bind(this));
        this._rpcWebSocket.on("close", this._wsOnClose.bind(this));
        this._rpcWebSocket.on("accountNotification", this._wsOnAccountNotification.bind(this));
        this._rpcWebSocket.on("programNotification", this._wsOnProgramAccountNotification.bind(this));
        this._rpcWebSocket.on("slotNotification", this._wsOnSlotNotification.bind(this));
        this._rpcWebSocket.on("slotsUpdatesNotification", this._wsOnSlotUpdatesNotification.bind(this));
        this._rpcWebSocket.on("signatureNotification", this._wsOnSignatureNotification.bind(this));
        this._rpcWebSocket.on("rootNotification", this._wsOnRootNotification.bind(this));
        this._rpcWebSocket.on("logsNotification", this._wsOnLogsNotification.bind(this));
    }
    /**
   * The default commitment used for requests
   */ get commitment() {
        return this._commitment;
    }
    /**
   * The RPC endpoint
   */ get rpcEndpoint() {
        return this._rpcEndpoint;
    }
    /**
   * Fetch the balance for the specified public key, return with context
   */ async getBalanceAndContext(publicKey, commitmentOrConfig) {
        /** @internal */ const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getBalance", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResultAndContext((0, $11e466829bcc37ce$export$98e628dec113755e)()));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, `failed to get balance for ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the balance for the specified public key
   */ async getBalance(publicKey, commitmentOrConfig) {
        return await this.getBalanceAndContext(publicKey, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error("failed to get balance of account " + publicKey.toBase58() + ": " + e);
        });
    }
    /**
   * Fetch the estimated production time of a block
   */ async getBlockTime(slot) {
        const unsafeRes = await this._rpcRequest("getBlockTime", [
            slot
        ]);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)())));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, `failed to get block time for slot ${slot}`);
        return res.result;
    }
    /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */ async getMinimumLedgerSlot() {
        const unsafeRes = await this._rpcRequest("minimumLedgerSlot", []);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$98e628dec113755e)()));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get minimum ledger slot");
        return res.result;
    }
    /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */ async getFirstAvailableBlock() {
        const unsafeRes = await this._rpcRequest("getFirstAvailableBlock", []);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$SlotRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get first available block");
        return res.result;
    }
    /**
   * Fetch information about the current supply
   */ async getSupply(config) {
        let configArg = {};
        if (typeof config === "string") configArg = {
            commitment: config
        };
        else if (config) configArg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        else configArg = {
            commitment: this.commitment
        };
        const unsafeRes = await this._rpcRequest("getSupply", [
            configArg
        ]);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetSupplyRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get supply");
        return res.result;
    }
    /**
   * Fetch the current supply of a token mint
   */ async getTokenSupply(tokenMintAddress, commitment) {
        const args = this._buildArgs([
            tokenMintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenSupply", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResultAndContext($bccf75ed4dec0420$var$TokenAmountResult));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get token supply");
        return res.result;
    }
    /**
   * Fetch the current balance of a token account
   */ async getTokenAccountBalance(tokenAddress, commitment) {
        const args = this._buildArgs([
            tokenAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenAccountBalance", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResultAndContext($bccf75ed4dec0420$var$TokenAmountResult));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get token account balance");
        return res.result;
    }
    /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<GetProgramAccountsResponse>}
   */ async getTokenAccountsByOwner(ownerAddress, filter, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(commitmentOrConfig);
        let _args = [
            ownerAddress.toBase58()
        ];
        if ("mint" in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getTokenAccountsByOwner", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetTokenAccountsByOwner);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */ async getParsedTokenAccountsByOwner(ownerAddress, filter, commitment) {
        let _args = [
            ownerAddress.toBase58()
        ];
        if ("mint" in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, "jsonParsed");
        const unsafeRes = await this._rpcRequest("getTokenAccountsByOwner", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetParsedTokenAccountsByOwner);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the 20 largest accounts with their current balances
   */ async getLargestAccounts(config) {
        const arg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        const args = arg.filter || arg.commitment ? [
            arg
        ] : [];
        const unsafeRes = await this._rpcRequest("getLargestAccounts", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetLargestAccountsRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get largest accounts");
        return res.result;
    }
    /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */ async getTokenLargestAccounts(mintAddress, commitment) {
        const args = this._buildArgs([
            mintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenLargestAccounts", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetTokenLargestAccountsResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get token largest accounts");
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key, return with context
   */ async getAccountInfoAndContext(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getAccountInfo", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResultAndContext((0, $11e466829bcc37ce$export$133fc36489ac9add)($bccf75ed4dec0420$var$AccountInfoResult)));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed account info for the specified public key
   */ async getParsedAccountInfo(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getAccountInfo", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResultAndContext((0, $11e466829bcc37ce$export$133fc36489ac9add)($bccf75ed4dec0420$var$ParsedAccountInfoResult)));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key
   */ async getAccountInfo(publicKey, commitmentOrConfig) {
        try {
            const res = await this.getAccountInfoAndContext(publicKey, commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error("failed to get info about account " + publicKey.toBase58() + ": " + e);
        }
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleParsedAccounts(publicKeys, rawConfig) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(rawConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getMultipleAccounts", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResultAndContext((0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$133fc36489ac9add)($bccf75ed4dec0420$var$ParsedAccountInfoResult))));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(commitmentOrConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getMultipleAccounts", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResultAndContext((0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$133fc36489ac9add)($bccf75ed4dec0420$var$AccountInfoResult))));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */ async getMultipleAccountsInfo(publicKeys, commitmentOrConfig) {
        const res = await this.getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig);
        return res.value;
    }
    /**
   * Returns epoch activation information for a stake account that has been delegated
   *
   * @deprecated Deprecated since RPC v1.18; will be removed in a future version.
   */ async getStakeActivation(publicKey, commitmentOrConfig, epoch) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest("getStakeActivation", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResult($bccf75ed4dec0420$var$StakeActivationResult));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, `failed to get Stake Activation ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(configOrCommitment);
        const { encoding: encoding, ...configWithoutEncoding } = config || {};
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, encoding || "base64", {
            ...configWithoutEncoding,
            ...configWithoutEncoding.filters ? {
                filters: $bccf75ed4dec0420$var$applyDefaultMemcmpEncodingToFilters(configWithoutEncoding.filters)
            } : null
        });
        const unsafeRes = await this._rpcRequest("getProgramAccounts", args);
        const baseSchema = (0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$KeyedAccountInfoResult);
        const res = configWithoutEncoding.withContext === true ? (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResultAndContext(baseSchema)) : (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResult(baseSchema));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */ async getParsedProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(configOrCommitment);
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getProgramAccounts", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$KeyedParsedAccountInfoResult)));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /** @deprecated Instead, call `confirmTransaction` and pass in {@link TransactionConfirmationStrategy} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async confirmTransaction(strategy, commitment) {
        let rawSignature;
        if (typeof strategy == "string") rawSignature = strategy;
        else {
            const config = strategy;
            if (config.abortSignal?.aborted) return Promise.reject(config.abortSignal.reason);
            rawSignature = config.signature;
        }
        let decodedSignature;
        try {
            decodedSignature = (0, (/*@__PURE__*/$parcel$interopDefault($4fa1ea39de93f4d6$exports))).decode(rawSignature);
        } catch (err) {
            throw new Error("signature must be base58 encoded: " + rawSignature);
        }
        $bccf75ed4dec0420$var$assert(decodedSignature.length === 64, "signature has invalid length");
        if (typeof strategy === "string") return await this.confirmTransactionUsingLegacyTimeoutStrategy({
            commitment: commitment || this.commitment,
            signature: rawSignature
        });
        else if ("lastValidBlockHeight" in strategy) return await this.confirmTransactionUsingBlockHeightExceedanceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
        else return await this.confirmTransactionUsingDurableNonceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
    }
    getCancellationPromise(signal) {
        return new Promise((_, reject)=>{
            if (signal == null) return;
            if (signal.aborted) reject(signal.reason);
            else signal.addEventListener("abort", ()=>{
                reject(signal.reason);
            });
        });
    }
    getTransactionConfirmationPromise({ commitment: commitment, signature: signature }) {
        let signatureSubscriptionId;
        let disposeSignatureSubscriptionStateChangeObserver;
        let done = false;
        const confirmationPromise = new Promise((resolve, reject)=>{
            try {
                signatureSubscriptionId = this.onSignature(signature, (result, context)=>{
                    signatureSubscriptionId = undefined;
                    const response = {
                        context: context,
                        value: result
                    };
                    resolve({
                        __type: $bccf75ed4dec0420$export$7c391bd3b61d2374.PROCESSED,
                        response: response
                    });
                }, commitment);
                const subscriptionSetupPromise = new Promise((resolveSubscriptionSetup)=>{
                    if (signatureSubscriptionId == null) resolveSubscriptionSetup();
                    else disposeSignatureSubscriptionStateChangeObserver = this._onSubscriptionStateChange(signatureSubscriptionId, (nextState)=>{
                        if (nextState === "subscribed") resolveSubscriptionSetup();
                    });
                });
                (async ()=>{
                    await subscriptionSetupPromise;
                    if (done) return;
                    const response = await this.getSignatureStatus(signature);
                    if (done) return;
                    if (response == null) return;
                    const { context: context, value: value } = response;
                    if (value == null) return;
                    if (value?.err) reject(value.err);
                    else {
                        switch(commitment){
                            case "confirmed":
                            case "single":
                            case "singleGossip":
                                if (value.confirmationStatus === "processed") return;
                                break;
                            case "finalized":
                            case "max":
                            case "root":
                                if (value.confirmationStatus === "processed" || value.confirmationStatus === "confirmed") return;
                                break;
                            // exhaust enums to ensure full coverage
                            case "processed":
                            case "recent":
                        }
                        done = true;
                        resolve({
                            __type: $bccf75ed4dec0420$export$7c391bd3b61d2374.PROCESSED,
                            response: {
                                context: context,
                                value: value
                            }
                        });
                    }
                })();
            } catch (err) {
                reject(err);
            }
        });
        const abortConfirmation = ()=>{
            if (disposeSignatureSubscriptionStateChangeObserver) {
                disposeSignatureSubscriptionStateChangeObserver();
                disposeSignatureSubscriptionStateChangeObserver = undefined;
            }
            if (signatureSubscriptionId != null) {
                this.removeSignatureListener(signatureSubscriptionId);
                signatureSubscriptionId = undefined;
            }
        };
        return {
            abortConfirmation: abortConfirmation,
            confirmationPromise: confirmationPromise
        };
    }
    async confirmTransactionUsingBlockHeightExceedanceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, lastValidBlockHeight: lastValidBlockHeight, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            const checkBlockHeight = async ()=>{
                try {
                    const blockHeight = await this.getBlockHeight(commitment);
                    return blockHeight;
                } catch (_e) {
                    return -1;
                }
            };
            (async ()=>{
                let currentBlockHeight = await checkBlockHeight();
                if (done) return;
                while(currentBlockHeight <= lastValidBlockHeight){
                    await $bccf75ed4dec0420$var$sleep(1000);
                    if (done) return;
                    currentBlockHeight = await checkBlockHeight();
                    if (done) return;
                }
                resolve({
                    __type: $bccf75ed4dec0420$export$7c391bd3b61d2374.BLOCKHEIGHT_EXCEEDED
                });
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $bccf75ed4dec0420$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $bccf75ed4dec0420$export$718fcd78527f88ed(signature);
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingDurableNonceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, minContextSlot: minContextSlot, nonceAccountPubkey: nonceAccountPubkey, nonceValue: nonceValue, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            let currentNonceValue = nonceValue;
            let lastCheckedSlot = null;
            const getCurrentNonceValue = async ()=>{
                try {
                    const { context: context, value: nonceAccount } = await this.getNonceAndContext(nonceAccountPubkey, {
                        commitment: commitment,
                        minContextSlot: minContextSlot
                    });
                    lastCheckedSlot = context.slot;
                    return nonceAccount?.nonce;
                } catch (e) {
                    // If for whatever reason we can't reach/read the nonce
                    // account, just keep using the last-known value.
                    return currentNonceValue;
                }
            };
            (async ()=>{
                currentNonceValue = await getCurrentNonceValue();
                if (done) return;
                while(true // eslint-disable-line no-constant-condition
                ){
                    if (nonceValue !== currentNonceValue) {
                        resolve({
                            __type: $bccf75ed4dec0420$export$7c391bd3b61d2374.NONCE_INVALID,
                            slotInWhichNonceDidAdvance: lastCheckedSlot
                        });
                        return;
                    }
                    await $bccf75ed4dec0420$var$sleep(2000);
                    if (done) return;
                    currentNonceValue = await getCurrentNonceValue();
                    if (done) return;
                }
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $bccf75ed4dec0420$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else {
                // Double check that the transaction is indeed unconfirmed.
                let signatureStatus;
                while(true // eslint-disable-line no-constant-condition
                ){
                    const status = await this.getSignatureStatus(signature);
                    if (status == null) break;
                    if (status.context.slot < (outcome.slotInWhichNonceDidAdvance ?? minContextSlot)) {
                        await $bccf75ed4dec0420$var$sleep(400);
                        continue;
                    }
                    signatureStatus = status;
                    break;
                }
                if (signatureStatus?.value) {
                    const commitmentForStatus = commitment || "finalized";
                    const { confirmationStatus: confirmationStatus } = signatureStatus.value;
                    switch(commitmentForStatus){
                        case "processed":
                        case "recent":
                            if (confirmationStatus !== "processed" && confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $bccf75ed4dec0420$export$a3e7565a95f5a1e5(signature);
                            break;
                        case "confirmed":
                        case "single":
                        case "singleGossip":
                            if (confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $bccf75ed4dec0420$export$a3e7565a95f5a1e5(signature);
                            break;
                        case "finalized":
                        case "max":
                        case "root":
                            if (confirmationStatus !== "finalized") throw new $bccf75ed4dec0420$export$a3e7565a95f5a1e5(signature);
                            break;
                        default:
                            // Exhaustive switch.
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            ((_)=>{})(commitmentForStatus);
                    }
                    result = {
                        context: signatureStatus.context,
                        value: {
                            err: signatureStatus.value.err
                        }
                    };
                } else throw new $bccf75ed4dec0420$export$a3e7565a95f5a1e5(signature);
            }
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingLegacyTimeoutStrategy({ commitment: commitment, signature: signature }) {
        let timeoutId;
        const expiryPromise = new Promise((resolve)=>{
            let timeoutMs = this._confirmTransactionInitialTimeout || 60000;
            switch(commitment){
                case "processed":
                case "recent":
                case "single":
                case "confirmed":
                case "singleGossip":
                    timeoutMs = this._confirmTransactionInitialTimeout || 30000;
                    break;
            }
            timeoutId = setTimeout(()=>resolve({
                    __type: $bccf75ed4dec0420$export$7c391bd3b61d2374.TIMED_OUT,
                    timeoutMs: timeoutMs
                }), timeoutMs);
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        let result;
        try {
            const outcome = await Promise.race([
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $bccf75ed4dec0420$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $bccf75ed4dec0420$export$b822204c22e46bdf(signature, outcome.timeoutMs / 1000);
        } finally{
            clearTimeout(timeoutId);
            abortConfirmation();
        }
        return result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getClusterNodes() {
        const unsafeRes = await this._rpcRequest("getClusterNodes", []);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$ContactInfoResult)));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get cluster nodes");
        return res.result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getVoteAccounts(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getVoteAccounts", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetVoteAccounts);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get vote accounts");
        return res.result;
    }
    /**
   * Fetch the current slot that the node is processing
   */ async getSlot(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getSlot", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$98e628dec113755e)()));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get slot");
        return res.result;
    }
    /**
   * Fetch the current slot leader of the cluster
   */ async getSlotLeader(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getSlotLeader", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$22b082955e083ec3)()));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leader");
        return res.result;
    }
    /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */ async getSlotLeaders(startSlot, limit) {
        const args = [
            startSlot,
            limit
        ];
        const unsafeRes = await this._rpcRequest("getSlotLeaders", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$2f23118c22fb2630)($bccf75ed4dec0420$var$PublicKeyFromString)));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leaders");
        return res.result;
    }
    /**
   * Fetch the current status of a signature
   */ async getSignatureStatus(signature, config) {
        const { context: context, value: values } = await this.getSignatureStatuses([
            signature
        ], config);
        $bccf75ed4dec0420$var$assert(values.length === 1);
        const value = values[0];
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the current statuses of a batch of signatures
   */ async getSignatureStatuses(signatures, config) {
        const params = [
            signatures
        ];
        if (config) params.push(config);
        const unsafeRes = await this._rpcRequest("getSignatureStatuses", params);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetSignatureStatusesRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get signature status");
        return res.result;
    }
    /**
   * Fetch the current transaction count of the cluster
   */ async getTransactionCount(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getTransactionCount", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$98e628dec113755e)()));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction count");
        return res.result;
    }
    /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since RPC v1.2.8. Please use {@link getSupply} instead.
   */ async getTotalSupply(commitment) {
        const result = await this.getSupply({
            commitment: commitment,
            excludeNonCirculatingAccountsList: true
        });
        return result.value.total;
    }
    /**
   * Fetch the cluster InflationGovernor parameters
   */ async getInflationGovernor(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getInflationGovernor", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetInflationGovernorRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation");
        return res.result;
    }
    /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */ async getInflationReward(addresses, epoch, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            addresses.map((pubkey)=>pubkey.toBase58())
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest("getInflationReward", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetInflationRewardResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation reward");
        return res.result;
    }
    /**
   * Fetch the specific inflation values for the current epoch
   */ async getInflationRate() {
        const unsafeRes = await this._rpcRequest("getInflationRate", []);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetInflationRateRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation rate");
        return res.result;
    }
    /**
   * Fetch the Epoch Info parameters
   */ async getEpochInfo(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getEpochInfo", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetEpochInfoRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch info");
        return res.result;
    }
    /**
   * Fetch the Epoch Schedule parameters
   */ async getEpochSchedule() {
        const unsafeRes = await this._rpcRequest("getEpochSchedule", []);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetEpochScheduleRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch schedule");
        const epochSchedule = res.result;
        return new $bccf75ed4dec0420$export$df8ed3e830b1d591(epochSchedule.slotsPerEpoch, epochSchedule.leaderScheduleSlotOffset, epochSchedule.warmup, epochSchedule.firstNormalEpoch, epochSchedule.firstNormalSlot);
    }
    /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */ async getLeaderSchedule() {
        const unsafeRes = await this._rpcRequest("getLeaderSchedule", []);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetLeaderScheduleRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get leader schedule");
        return res.result;
    }
    /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */ async getMinimumBalanceForRentExemption(dataLength, commitment) {
        const args = this._buildArgs([
            dataLength
        ], commitment);
        const unsafeRes = await this._rpcRequest("getMinimumBalanceForRentExemption", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetMinimumBalanceForRentExemptionRpcResult);
        if ("error" in res) {
            console.warn("Unable to fetch minimum balance for rent exemption");
            return 0;
        }
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since RPC v1.9.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhashAndContext(commitment) {
        const { context: context, value: { blockhash: blockhash } } = await this.getLatestBlockhashAndContext(commitment);
        const feeCalculator = {
            get lamportsPerSignature () {
                throw new Error("The capability to fetch `lamportsPerSignature` using the `getRecentBlockhash` API is no longer offered by the network. Use the `getFeeForMessage` API to obtain the fee for a given message.");
            },
            toJSON () {
                return {};
            }
        };
        return {
            context: context,
            value: {
                blockhash: blockhash,
                feeCalculator: feeCalculator
            }
        };
    }
    /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */ async getRecentPerformanceSamples(limit) {
        const unsafeRes = await this._rpcRequest("getRecentPerformanceSamples", limit ? [
            limit
        ] : []);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetRecentPerformanceSamplesRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get recent performance samples");
        return res.result;
    }
    /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since RPC v1.9.0. Please use {@link getFeeForMessage} instead.
   */ async getFeeCalculatorForBlockhash(blockhash, commitment) {
        const args = this._buildArgs([
            blockhash
        ], commitment);
        const unsafeRes = await this._rpcRequest("getFeeCalculatorForBlockhash", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetFeeCalculatorRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get fee calculator");
        const { context: context, value: value } = res.result;
        return {
            context: context,
            value: value !== null ? value.feeCalculator : null
        };
    }
    /**
   * Fetch the fee for a message from the cluster, return with context
   */ async getFeeForMessage(message, commitment) {
        const wireMessage = $bccf75ed4dec0420$var$toBuffer(message.serialize()).toString("base64");
        const args = this._buildArgs([
            wireMessage
        ], commitment);
        const unsafeRes = await this._rpcRequest("getFeeForMessage", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResultAndContext((0, $11e466829bcc37ce$export$133fc36489ac9add)((0, $11e466829bcc37ce$export$98e628dec113755e)())));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get fee for message");
        if (res.result === null) throw new Error("invalid blockhash");
        return res.result;
    }
    /**
   * Fetch a list of prioritization fees from recent blocks.
   */ async getRecentPrioritizationFees(config) {
        const accounts = config?.lockedWritableAccounts?.map((key)=>key.toBase58());
        const args = accounts?.length ? [
            accounts
        ] : [];
        const unsafeRes = await this._rpcRequest("getRecentPrioritizationFees", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetRecentPrioritizationFeesRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get recent prioritization fees");
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since RPC v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhash(commitment) {
        try {
            const res = await this.getRecentBlockhashAndContext(commitment);
            return res.value;
        } catch (e) {
            throw new Error("failed to get recent blockhash: " + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhash(commitmentOrConfig) {
        try {
            const res = await this.getLatestBlockhashAndContext(commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error("failed to get recent blockhash: " + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhashAndContext(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getLatestBlockhash", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetLatestBlockhashRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get latest blockhash");
        return res.result;
    }
    /**
   * Returns whether a blockhash is still valid or not
   */ async isBlockhashValid(blockhash, rawConfig) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgs([
            blockhash
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("isBlockhashValid", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$IsBlockhashValidRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to determine if the blockhash `" + blockhash + "`is valid");
        return res.result;
    }
    /**
   * Fetch the node version
   */ async getVersion() {
        const unsafeRes = await this._rpcRequest("getVersion", []);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResult($bccf75ed4dec0420$var$VersionResult));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get version");
        return res.result;
    }
    /**
   * Fetch the genesis hash
   */ async getGenesisHash() {
        const unsafeRes = await this._rpcRequest("getGenesisHash", []);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$22b082955e083ec3)()));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get genesis hash");
        return res.result;
    }
    /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getBlock", args);
        try {
            switch(config?.transactionDetails){
                case "accounts":
                    {
                        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetAccountsModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                case "none":
                    {
                        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetNoneModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetBlockRpcResult);
                        if ("error" in res) throw res.error;
                        const { result: result } = res;
                        return result ? {
                            ...result,
                            transactions: result.transactions.map(({ transaction: transaction, meta: meta, version: version })=>({
                                    meta: meta,
                                    transaction: {
                                        ...transaction,
                                        message: $bccf75ed4dec0420$var$versionedMessageFromResponse(version, transaction.message)
                                    },
                                    version: version
                                }))
                        } : null;
                    }
            }
        } catch (e) {
            throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(e, "failed to get confirmed block");
        }
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getParsedBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getBlock", args);
        try {
            switch(config?.transactionDetails){
                case "accounts":
                    {
                        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetParsedAccountsModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                case "none":
                    {
                        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetParsedNoneModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetParsedBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
            }
        } catch (e) {
            throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(e, "failed to get block");
        }
    }
    /*
   * Returns recent block production information from the current or previous epoch
   */ async getBlockProduction(configOrCommitment) {
        let extra;
        let commitment;
        if (typeof configOrCommitment === "string") commitment = configOrCommitment;
        else if (configOrCommitment) {
            const { commitment: c, ...rest } = configOrCommitment;
            commitment = c;
            extra = rest;
        }
        const args = this._buildArgs([], commitment, "base64", extra);
        const unsafeRes = await this._rpcRequest("getBlockProduction", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$BlockProductionResponseStruct);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get block production information");
        return res.result;
    }
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransaction(signature, rawConfig) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetTransactionRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        const result = res.result;
        if (!result) return result;
        return {
            ...result,
            transaction: {
                ...result.transaction,
                message: $bccf75ed4dec0420$var$versionedMessageFromResponse(result.version, result.transaction.message)
            }
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */ async getParsedTransaction(signature, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetParsedTransactionRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */ async getParsedTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, "jsonParsed", config);
            return {
                methodName: "getTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetParsedTransactionRpcResult);
            if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
            return res.result;
        });
        return res;
    }
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, undefined /* encoding */ , config);
            return {
                methodName: "getTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetTransactionRpcResult);
            if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
            const result = res.result;
            if (!result) return result;
            return {
                ...result,
                transaction: {
                    ...result.transaction,
                    message: $bccf75ed4dec0420$var$versionedMessageFromResponse(result.version, result.transaction.message)
                }
            };
        });
        return res;
    }
    /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getBlock} instead.
   */ async getConfirmedBlock(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment);
        const unsafeRes = await this._rpcRequest("getBlock", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetConfirmedBlockRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
        const result = res.result;
        if (!result) throw new Error("Confirmed block " + slot + " not found");
        const block = {
            ...result,
            transactions: result.transactions.map(({ transaction: transaction, meta: meta })=>{
                const message = new $bccf75ed4dec0420$export$f69c19e57285b83a(transaction.message);
                return {
                    meta: meta,
                    transaction: {
                        ...transaction,
                        message: message
                    }
                };
            })
        };
        return {
            ...block,
            transactions: block.transactions.map(({ transaction: transaction, meta: meta })=>{
                return {
                    meta: meta,
                    transaction: $bccf75ed4dec0420$export$febc5573c75cefb0.populate(transaction.message, transaction.signatures)
                };
            })
        };
    }
    /**
   * Fetch confirmed blocks between two slots
   */ async getBlocks(startSlot, endSlot, commitment) {
        const args = this._buildArgsAtLeastConfirmed(endSlot !== undefined ? [
            startSlot,
            endSlot
        ] : [
            startSlot
        ], commitment);
        const unsafeRes = await this._rpcRequest("getBlocks", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResult((0, $11e466829bcc37ce$export$2f23118c22fb2630)((0, $11e466829bcc37ce$export$98e628dec113755e)())));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get blocks");
        return res.result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */ async getBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: "signatures",
            rewards: false
        });
        const unsafeRes = await this._rpcRequest("getBlock", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetBlockSignaturesRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get block");
        const result = res.result;
        if (!result) throw new Error("Block " + slot + " not found");
        return result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getBlockSignatures} instead.
   */ async getConfirmedBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: "signatures",
            rewards: false
        });
        const unsafeRes = await this._rpcRequest("getBlock", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetBlockSignaturesRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
        const result = res.result;
        if (!result) throw new Error("Confirmed block " + slot + " not found");
        return result;
    }
    /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getTransaction} instead.
   */ async getConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetTransactionRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        const result = res.result;
        if (!result) return result;
        const message = new $bccf75ed4dec0420$export$f69c19e57285b83a(result.transaction.message);
        const signatures = result.transaction.signatures;
        return {
            ...result,
            transaction: $bccf75ed4dec0420$export$febc5573c75cefb0.populate(message, signatures)
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getParsedTransaction} instead.
   */ async getParsedConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, "jsonParsed");
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetParsedTransactionRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transaction");
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getParsedTransactions} instead.
   */ async getParsedConfirmedTransactions(signatures, commitment) {
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, "jsonParsed");
            return {
                methodName: "getTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetParsedTransactionRpcResult);
            if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transactions");
            return res.result;
        });
        return res;
    }
    /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since RPC v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */ async getConfirmedSignaturesForAddress(address, startSlot, endSlot) {
        let options = {};
        let firstAvailableBlock = await this.getFirstAvailableBlock();
        while(!("until" in options)){
            startSlot--;
            if (startSlot <= 0 || startSlot < firstAvailableBlock) break;
            try {
                const block = await this.getConfirmedBlockSignatures(startSlot, "finalized");
                if (block.signatures.length > 0) options.until = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes("skipped")) continue;
                else throw err;
            }
        }
        let highestConfirmedRoot = await this.getSlot("finalized");
        while(!("before" in options)){
            endSlot++;
            if (endSlot > highestConfirmedRoot) break;
            try {
                const block = await this.getConfirmedBlockSignatures(endSlot);
                if (block.signatures.length > 0) options.before = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes("skipped")) continue;
                else throw err;
            }
        }
        const confirmedSignatureInfo = await this.getConfirmedSignaturesForAddress2(address, options);
        return confirmedSignatureInfo.map((info)=>info.signature);
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getSignaturesForAddress} instead.
   */ async getConfirmedSignaturesForAddress2(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest("getConfirmedSignaturesForAddress2", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetConfirmedSignaturesForAddress2RpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed signatures for address");
        return res.result;
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getSignaturesForAddress(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest("getSignaturesForAddress", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$GetSignaturesForAddressRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, "failed to get signatures for address");
        return res.result;
    }
    async getAddressLookupTable(accountKey, config) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(accountKey, config);
        let value = null;
        if (accountInfo !== null) value = new $bccf75ed4dec0420$export$5b2310da10e607da({
            key: accountKey,
            state: $bccf75ed4dec0420$export$5b2310da10e607da.deserialize(accountInfo.data)
        });
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */ async getNonceAndContext(nonceAccount, commitmentOrConfig) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(nonceAccount, commitmentOrConfig);
        let value = null;
        if (accountInfo !== null) value = $bccf75ed4dec0420$export$ed1c2356ce604759.fromAccountData(accountInfo.data);
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster
   */ async getNonce(nonceAccount, commitmentOrConfig) {
        return await this.getNonceAndContext(nonceAccount, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error("failed to get nonce for account " + nonceAccount.toBase58() + ": " + e);
        });
    }
    /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */ async requestAirdrop(to, lamports) {
        const unsafeRes = await this._rpcRequest("requestAirdrop", [
            to.toBase58(),
            lamports
        ]);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$RequestAirdropRpcResult);
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, `airdrop to ${to.toBase58()} failed`);
        return res.result;
    }
    /**
   * @internal
   */ async _blockhashWithExpiryBlockHeight(disableCache) {
        if (!disableCache) {
            // Wait for polling to finish
            while(this._pollingBlockhash)await $bccf75ed4dec0420$var$sleep(100);
            const timeSinceFetch = Date.now() - this._blockhashInfo.lastFetch;
            const expired = timeSinceFetch >= $bccf75ed4dec0420$export$fcb705732fb5c597;
            if (this._blockhashInfo.latestBlockhash !== null && !expired) return this._blockhashInfo.latestBlockhash;
        }
        return await this._pollNewBlockhash();
    }
    /**
   * @internal
   */ async _pollNewBlockhash() {
        this._pollingBlockhash = true;
        try {
            const startTime = Date.now();
            const cachedLatestBlockhash = this._blockhashInfo.latestBlockhash;
            const cachedBlockhash = cachedLatestBlockhash ? cachedLatestBlockhash.blockhash : null;
            for(let i = 0; i < 50; i++){
                const latestBlockhash = await this.getLatestBlockhash("finalized");
                if (cachedBlockhash !== latestBlockhash.blockhash) {
                    this._blockhashInfo = {
                        latestBlockhash: latestBlockhash,
                        lastFetch: Date.now(),
                        transactionSignatures: [],
                        simulatedSignatures: []
                    };
                    return latestBlockhash;
                }
                // Sleep for approximately half a slot
                await $bccf75ed4dec0420$var$sleep($bccf75ed4dec0420$var$MS_PER_SLOT / 2);
            }
            throw new Error(`Unable to obtain a new blockhash after ${Date.now() - startTime}ms`);
        } finally{
            this._pollingBlockhash = false;
        }
    }
    /**
   * get the stake minimum delegation
   */ async getStakeMinimumDelegation(config) {
        const { commitment: commitment, config: configArg } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(config);
        const args = this._buildArgs([], commitment, "base64", configArg);
        const unsafeRes = await this._rpcRequest("getStakeMinimumDelegation", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$jsonRpcResultAndContext((0, $11e466829bcc37ce$export$98e628dec113755e)()));
        if ("error" in res) throw new $bccf75ed4dec0420$export$ea1b1a1bba5c14ad(res.error, `failed to get stake minimum delegation`);
        return res.result;
    }
    /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */ /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async simulateTransaction(transactionOrMessage, configOrSigners, includeAccounts) {
        if ("message" in transactionOrMessage) {
            const versionedTx = transactionOrMessage;
            const wireTransaction = versionedTx.serialize();
            const encodedTransaction = (0, $lewJ9.Buffer).from(wireTransaction).toString("base64");
            if (Array.isArray(configOrSigners) || includeAccounts !== undefined) throw new Error("Invalid arguments");
            const config = configOrSigners || {};
            config.encoding = "base64";
            if (!("commitment" in config)) config.commitment = this.commitment;
            if (configOrSigners && typeof configOrSigners === "object" && "innerInstructions" in configOrSigners) config.innerInstructions = configOrSigners.innerInstructions;
            const args = [
                encodedTransaction,
                config
            ];
            const unsafeRes = await this._rpcRequest("simulateTransaction", args);
            const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$SimulatedTransactionResponseStruct);
            if ("error" in res) throw new Error("failed to simulate transaction: " + res.error.message);
            return res.result;
        }
        let transaction;
        if (transactionOrMessage instanceof $bccf75ed4dec0420$export$febc5573c75cefb0) {
            let originalTx = transactionOrMessage;
            transaction = new $bccf75ed4dec0420$export$febc5573c75cefb0();
            transaction.feePayer = originalTx.feePayer;
            transaction.instructions = transactionOrMessage.instructions;
            transaction.nonceInfo = originalTx.nonceInfo;
            transaction.signatures = originalTx.signatures;
        } else {
            transaction = $bccf75ed4dec0420$export$febc5573c75cefb0.populate(transactionOrMessage);
            // HACK: this function relies on mutating the populated transaction
            transaction._message = transaction._json = undefined;
        }
        if (configOrSigners !== undefined && !Array.isArray(configOrSigners)) throw new Error("Invalid arguments");
        const signers = configOrSigners;
        if (transaction.nonceInfo && signers) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                if (!signers) break;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error("!signature"); // should never happen
                const signature = transaction.signature.toString("base64");
                if (!this._blockhashInfo.simulatedSignatures.includes(signature) && !this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.simulatedSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const message = transaction._compile();
        const signData = message.serialize();
        const wireTransaction = transaction._serialize(signData);
        const encodedTransaction = wireTransaction.toString("base64");
        const config = {
            encoding: "base64",
            commitment: this.commitment
        };
        if (includeAccounts) {
            const addresses = (Array.isArray(includeAccounts) ? includeAccounts : message.nonProgramIds()).map((key)=>key.toBase58());
            config["accounts"] = {
                encoding: "base64",
                addresses: addresses
            };
        }
        if (signers) config.sigVerify = true;
        if (configOrSigners && typeof configOrSigners === "object" && "innerInstructions" in configOrSigners) config.innerInstructions = configOrSigners.innerInstructions;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest("simulateTransaction", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$SimulatedTransactionResponseStruct);
        if ("error" in res) {
            let logs;
            if ("data" in res.error) {
                logs = res.error.data.logs;
                if (logs && Array.isArray(logs)) {
                    const traceIndent = "\n    ";
                    const logTrace = traceIndent + logs.join(traceIndent);
                    console.error(res.error.message, logTrace);
                }
            }
            throw new $bccf75ed4dec0420$export$121e803f723b3045({
                action: "simulate",
                signature: "",
                transactionMessage: res.error.message,
                logs: logs
            });
        }
        return res.result;
    }
    /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */ /**
   * Send a signed transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Sign and send a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async sendTransaction(transaction, signersOrOptions, options) {
        if ("version" in transaction) {
            if (signersOrOptions && Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
            const wireTransaction = transaction.serialize();
            return await this.sendRawTransaction(wireTransaction, signersOrOptions);
        }
        if (signersOrOptions === undefined || !Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
        const signers = signersOrOptions;
        if (transaction.nonceInfo) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error("!signature"); // should never happen
                const signature = transaction.signature.toString("base64");
                if (!this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.transactionSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const wireTransaction = transaction.serialize();
        return await this.sendRawTransaction(wireTransaction, options);
    }
    /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */ async sendRawTransaction(rawTransaction, options) {
        const encodedTransaction = $bccf75ed4dec0420$var$toBuffer(rawTransaction).toString("base64");
        const result = await this.sendEncodedTransaction(encodedTransaction, options);
        return result;
    }
    /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */ async sendEncodedTransaction(encodedTransaction, options) {
        const config = {
            encoding: "base64"
        };
        const skipPreflight = options && options.skipPreflight;
        const preflightCommitment = skipPreflight === true ? "processed" // FIXME Remove when https://github.com/anza-xyz/agave/pull/483 is deployed.
         : options && options.preflightCommitment || this.commitment;
        if (options && options.maxRetries != null) config.maxRetries = options.maxRetries;
        if (options && options.minContextSlot != null) config.minContextSlot = options.minContextSlot;
        if (skipPreflight) config.skipPreflight = skipPreflight;
        if (preflightCommitment) config.preflightCommitment = preflightCommitment;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest("sendTransaction", args);
        const res = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(unsafeRes, $bccf75ed4dec0420$var$SendTransactionRpcResult);
        if ("error" in res) {
            let logs = undefined;
            if ("data" in res.error) logs = res.error.data.logs;
            throw new $bccf75ed4dec0420$export$121e803f723b3045({
                action: skipPreflight ? "send" : "simulate",
                signature: "",
                transactionMessage: res.error.message,
                logs: logs
            });
        }
        return res.result;
    }
    /**
   * @internal
   */ _wsOnOpen() {
        this._rpcWebSocketConnected = true;
        this._rpcWebSocketHeartbeat = setInterval(()=>{
            // Ping server every 5s to prevent idle timeouts
            (async ()=>{
                try {
                    await this._rpcWebSocket.notify("ping");
                // eslint-disable-next-line no-empty
                } catch  {}
            })();
        }, 5000);
        this._updateSubscriptions();
    }
    /**
   * @internal
   */ _wsOnError(err) {
        this._rpcWebSocketConnected = false;
        console.error("ws error:", err.message);
    }
    /**
   * @internal
   */ _wsOnClose(code) {
        this._rpcWebSocketConnected = false;
        this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER;
        if (this._rpcWebSocketIdleTimeout) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
        }
        if (this._rpcWebSocketHeartbeat) {
            clearInterval(this._rpcWebSocketHeartbeat);
            this._rpcWebSocketHeartbeat = null;
        }
        if (code === 1000) {
            // explicit close, check if any subscriptions have been made since close
            this._updateSubscriptions();
            return;
        }
        // implicit close, prepare subscriptions for auto-reconnect
        this._subscriptionCallbacksByServerSubscriptionId = {};
        Object.entries(this._subscriptionsByHash).forEach(([hash, subscription])=>{
            this._setSubscription(hash, {
                ...subscription,
                state: "pending"
            });
        });
    }
    /**
   * @internal
   */ _setSubscription(hash, nextSubscription) {
        const prevState = this._subscriptionsByHash[hash]?.state;
        this._subscriptionsByHash[hash] = nextSubscription;
        if (prevState !== nextSubscription.state) {
            const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash];
            if (stateChangeCallbacks) stateChangeCallbacks.forEach((cb)=>{
                try {
                    cb(nextSubscription.state);
                // eslint-disable-next-line no-empty
                } catch  {}
            });
        }
    }
    /**
   * @internal
   */ _onSubscriptionStateChange(clientSubscriptionId, callback) {
        const hash = this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
        if (hash == null) return ()=>{};
        const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash] ||= new Set();
        stateChangeCallbacks.add(callback);
        return ()=>{
            stateChangeCallbacks.delete(callback);
            if (stateChangeCallbacks.size === 0) delete this._subscriptionStateChangeCallbacksByHash[hash];
        };
    }
    /**
   * @internal
   */ async _updateSubscriptions() {
        if (Object.keys(this._subscriptionsByHash).length === 0) {
            if (this._rpcWebSocketConnected) {
                this._rpcWebSocketConnected = false;
                this._rpcWebSocketIdleTimeout = setTimeout(()=>{
                    this._rpcWebSocketIdleTimeout = null;
                    try {
                        this._rpcWebSocket.close();
                    } catch (err) {
                        // swallow error if socket has already been closed.
                        if (err instanceof Error) console.log(`Error when closing socket connection: ${err.message}`);
                    }
                }, 500);
            }
            return;
        }
        if (this._rpcWebSocketIdleTimeout !== null) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
            this._rpcWebSocketConnected = true;
        }
        if (!this._rpcWebSocketConnected) {
            this._rpcWebSocket.connect();
            return;
        }
        const activeWebSocketGeneration = this._rpcWebSocketGeneration;
        const isCurrentConnectionStillActive = ()=>{
            return activeWebSocketGeneration === this._rpcWebSocketGeneration;
        };
        await Promise.all(// Don't be tempted to change this to `Object.entries`. We call
        // `_updateSubscriptions` recursively when processing the state,
        // so it's important that we look up the *current* version of
        // each subscription, every time we process a hash.
        Object.keys(this._subscriptionsByHash).map(async (hash)=>{
            const subscription = this._subscriptionsByHash[hash];
            if (subscription === undefined) // This entry has since been deleted. Skip.
            return;
            switch(subscription.state){
                case "pending":
                case "unsubscribed":
                    if (subscription.callbacks.size === 0) {
                        /**
             * You can end up here when:
             *
             * - a subscription has recently unsubscribed
             *   without having new callbacks added to it
             *   while the unsubscribe was in flight, or
             * - when a pending subscription has its
             *   listeners removed before a request was
             *   sent to the server.
             *
             * Being that nobody is interested in this
             * subscription any longer, delete it.
             */ delete this._subscriptionsByHash[hash];
                        if (subscription.state === "unsubscribed") delete this._subscriptionCallbacksByServerSubscriptionId[subscription.serverSubscriptionId];
                        await this._updateSubscriptions();
                        return;
                    }
                    await (async ()=>{
                        const { args: args, method: method } = subscription;
                        try {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "subscribing"
                            });
                            const serverSubscriptionId = await this._rpcWebSocket.call(method, args);
                            this._setSubscription(hash, {
                                ...subscription,
                                serverSubscriptionId: serverSubscriptionId,
                                state: "subscribed"
                            });
                            this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId] = subscription.callbacks;
                            await this._updateSubscriptions();
                        } catch (e) {
                            console.error(`Received ${e instanceof Error ? "" : "JSON-RPC "}error calling \`${method}\``, {
                                args: args,
                                error: e
                            });
                            if (!isCurrentConnectionStillActive()) return;
                            // TODO: Maybe add an 'errored' state or a retry limit?
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "pending"
                            });
                            await this._updateSubscriptions();
                        }
                    })();
                    break;
                case "subscribed":
                    if (subscription.callbacks.size === 0) // By the time we successfully set up a subscription
                    // with the server, the client stopped caring about it.
                    // Tear it down now.
                    await (async ()=>{
                        const { serverSubscriptionId: serverSubscriptionId, unsubscribeMethod: unsubscribeMethod } = subscription;
                        if (this._subscriptionsAutoDisposedByRpc.has(serverSubscriptionId)) /**
                 * Special case.
                 * If we're dealing with a subscription that has been auto-
                 * disposed by the RPC, then we can skip the RPC call to
                 * tear down the subscription here.
                 *
                 * NOTE: There is a proposal to eliminate this special case, here:
                 * https://github.com/solana-labs/solana/issues/18892
                 */ this._subscriptionsAutoDisposedByRpc.delete(serverSubscriptionId);
                        else {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "unsubscribing"
                            });
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "unsubscribing"
                            });
                            try {
                                await this._rpcWebSocket.call(unsubscribeMethod, [
                                    serverSubscriptionId
                                ]);
                            } catch (e) {
                                if (e instanceof Error) console.error(`${unsubscribeMethod} error:`, e.message);
                                if (!isCurrentConnectionStillActive()) return;
                                // TODO: Maybe add an 'errored' state or a retry limit?
                                this._setSubscription(hash, {
                                    ...subscription,
                                    state: "subscribed"
                                });
                                await this._updateSubscriptions();
                                return;
                            }
                        }
                        this._setSubscription(hash, {
                            ...subscription,
                            state: "unsubscribed"
                        });
                        await this._updateSubscriptions();
                    })();
                    break;
            }
        }));
    }
    /**
   * @internal
   */ _handleServerNotification(serverSubscriptionId, callbackArgs) {
        const callbacks = this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId];
        if (callbacks === undefined) return;
        callbacks.forEach((cb)=>{
            try {
                cb(// I failed to find a way to convince TypeScript that `cb` is of type
                // `TCallback` which is certainly compatible with `Parameters<TCallback>`.
                // See https://github.com/microsoft/TypeScript/issues/47615
                // @ts-ignore
                ...callbackArgs);
            } catch (e) {
                console.error(e);
            }
        });
    }
    /**
   * @internal
   */ _wsOnAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(notification, $bccf75ed4dec0420$var$AccountNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _makeSubscription(subscriptionConfig, /**
   * When preparing `args` for a call to `_makeSubscription`, be sure
   * to carefully apply a default `commitment` property, if necessary.
   *
   * - If the user supplied a `commitment` use that.
   * - Otherwise, if the `Connection::commitment` is set, use that.
   * - Otherwise, set it to the RPC server default: `finalized`.
   *
   * This is extremely important to ensure that these two fundamentally
   * identical subscriptions produce the same identifying hash:
   *
   * - A subscription made without specifying a commitment.
   * - A subscription made where the commitment specified is the same
   *   as the default applied to the subscription above.
   *
   * Example; these two subscriptions must produce the same hash:
   *
   * - An `accountSubscribe` subscription for `'PUBKEY'`
   * - An `accountSubscribe` subscription for `'PUBKEY'` with commitment
   *   `'finalized'`.
   *
   * See the 'making a subscription with defaulted params omitted' test
   * in `connection-subscriptions.ts` for more.
   */ args) {
        const clientSubscriptionId = this._nextClientSubscriptionId++;
        const hash = $bccf75ed4dec0420$var$fastStableStringify([
            subscriptionConfig.method,
            args
        ]);
        const existingSubscription = this._subscriptionsByHash[hash];
        if (existingSubscription === undefined) this._subscriptionsByHash[hash] = {
            ...subscriptionConfig,
            args: args,
            callbacks: new Set([
                subscriptionConfig.callback
            ]),
            state: "pending"
        };
        else existingSubscription.callbacks.add(subscriptionConfig.callback);
        this._subscriptionHashByClientSubscriptionId[clientSubscriptionId] = hash;
        this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId] = async ()=>{
            delete this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
            delete this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
            const subscription = this._subscriptionsByHash[hash];
            $bccf75ed4dec0420$var$assert(subscription !== undefined, `Could not find a \`Subscription\` when tearing down client subscription #${clientSubscriptionId}`);
            subscription.callbacks.delete(subscriptionConfig.callback);
            await this._updateSubscriptions();
        };
        this._updateSubscriptions();
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param config
   * @return subscription id
   */ /** @deprecated Instead, pass in an {@link AccountSubscriptionConfig} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    onAccountChange(publicKey, callback, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment || this._commitment || "finalized", // Apply connection/server default.
        "base64", config);
        return this._makeSubscription({
            callback: callback,
            method: "accountSubscribe",
            unsubscribeMethod: "accountUnsubscribe"
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "account change");
    }
    /**
   * @internal
   */ _wsOnProgramAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(notification, $bccf75ed4dec0420$var$ProgramAccountNotificationResult);
        this._handleServerNotification(subscription, [
            {
                accountId: result.value.pubkey,
                accountInfo: result.value.account
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param config
   * @return subscription id
   */ /** @deprecated Instead, pass in a {@link ProgramAccountSubscriptionConfig} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    onProgramAccountChange(programId, callback, commitmentOrConfig, maybeFilters) {
        const { commitment: commitment, config: config } = $bccf75ed4dec0420$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment || this._commitment || "finalized", // Apply connection/server default.
        "base64" /* encoding */ , config ? config : maybeFilters ? {
            filters: $bccf75ed4dec0420$var$applyDefaultMemcmpEncodingToFilters(maybeFilters)
        } : undefined /* extra */ );
        return this._makeSubscription({
            callback: callback,
            method: "programSubscribe",
            unsubscribeMethod: "programUnsubscribe"
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeProgramAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "program account change");
    }
    /**
   * Registers a callback to be invoked whenever logs are emitted.
   */ onLogs(filter, callback, commitment) {
        const args = this._buildArgs([
            typeof filter === "object" ? {
                mentions: [
                    filter.toString()
                ]
            } : filter
        ], commitment || this._commitment || "finalized" // Apply connection/server default.
        );
        return this._makeSubscription({
            callback: callback,
            method: "logsSubscribe",
            unsubscribeMethod: "logsUnsubscribe"
        }, args);
    }
    /**
   * Deregister a logs callback.
   *
   * @param clientSubscriptionId client subscription id to deregister.
   */ async removeOnLogsListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "logs");
    }
    /**
   * @internal
   */ _wsOnLogsNotification(notification) {
        const { result: result, subscription: subscription } = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(notification, $bccf75ed4dec0420$var$LogsNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _wsOnSlotNotification(notification) {
        const { result: result, subscription: subscription } = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(notification, $bccf75ed4dec0420$var$SlotNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */ onSlotChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "slotSubscribe",
            unsubscribeMethod: "slotUnsubscribe"
        }, []);
    }
    /**
   * Deregister a slot notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSlotChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "slot change");
    }
    /**
   * @internal
   */ _wsOnSlotUpdatesNotification(notification) {
        const { result: result, subscription: subscription } = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(notification, $bccf75ed4dec0420$var$SlotUpdateNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */ onSlotUpdate(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "slotsUpdatesSubscribe",
            unsubscribeMethod: "slotsUpdatesUnsubscribe"
        }, []);
    }
    /**
   * Deregister a slot update notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSlotUpdateListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "slot update");
    }
    /**
   * @internal
   */ async _unsubscribeClientSubscription(clientSubscriptionId, subscriptionName) {
        const dispose = this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
        if (dispose) await dispose();
        else console.warn("Ignored unsubscribe request because an active subscription with id " + `\`${clientSubscriptionId}\` for '${subscriptionName}' events ` + "could not be found.");
    }
    _buildArgs(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment || encoding || extra) {
            let options = {};
            if (encoding) options.encoding = encoding;
            if (commitment) options.commitment = commitment;
            if (extra) options = Object.assign(options, extra);
            args.push(options);
        }
        return args;
    }
    /**
   * @internal
   */ _buildArgsAtLeastConfirmed(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment && ![
            "confirmed",
            "finalized"
        ].includes(commitment)) throw new Error("Using Connection with default commitment: `" + this._commitment + "`, but method requires at least `confirmed`");
        return this._buildArgs(args, override, encoding, extra);
    }
    /**
   * @internal
   */ _wsOnSignatureNotification(notification) {
        const { result: result, subscription: subscription } = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(notification, $bccf75ed4dec0420$var$SignatureNotificationResult);
        if (result.value !== "receivedSignature") /**
       * Special case.
       * After a signature is processed, RPCs automatically dispose of the
       * subscription on the server side. We need to track which of these
       * subscriptions have been disposed in such a way, so that we know
       * whether the client is dealing with a not-yet-processed signature
       * (in which case we must tear down the server subscription) or an
       * already-processed signature (in which case the client can simply
       * clear out the subscription locally without telling the server).
       *
       * NOTE: There is a proposal to eliminate this special case, here:
       * https://github.com/solana-labs/solana/issues/18892
       */ this._subscriptionsAutoDisposedByRpc.add(subscription);
        this._handleServerNotification(subscription, result.value === "receivedSignature" ? [
            {
                type: "received"
            },
            result.context
        ] : [
            {
                type: "status",
                result: result.value
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */ onSignature(signature, callback, commitment) {
        const args = this._buildArgs([
            signature
        ], commitment || this._commitment || "finalized" // Apply connection/server default.
        );
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                if (notification.type === "status") {
                    callback(notification.result, context);
                    // Signatures subscriptions are auto-removed by the RPC service
                    // so no need to explicitly send an unsubscribe message.
                    try {
                        this.removeSignatureListener(clientSubscriptionId);
                    // eslint-disable-next-line no-empty
                    } catch (_err) {
                    // Already removed.
                    }
                }
            },
            method: "signatureSubscribe",
            unsubscribeMethod: "signatureUnsubscribe"
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */ onSignatureWithOptions(signature, callback, options) {
        const { commitment: commitment, ...extra } = {
            ...options,
            commitment: options && options.commitment || this._commitment || "finalized" // Apply connection/server default.
        };
        const args = this._buildArgs([
            signature
        ], commitment, undefined /* encoding */ , extra);
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                callback(notification, context);
                // Signatures subscriptions are auto-removed by the RPC service
                // so no need to explicitly send an unsubscribe message.
                try {
                    this.removeSignatureListener(clientSubscriptionId);
                // eslint-disable-next-line no-empty
                } catch (_err) {
                // Already removed.
                }
            },
            method: "signatureSubscribe",
            unsubscribeMethod: "signatureUnsubscribe"
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Deregister a signature notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSignatureListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "signature result");
    }
    /**
   * @internal
   */ _wsOnRootNotification(notification) {
        const { result: result, subscription: subscription } = (0, $11e466829bcc37ce$export$185802fd694ee1f5)(notification, $bccf75ed4dec0420$var$RootNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */ onRootChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "rootSubscribe",
            unsubscribeMethod: "rootUnsubscribe"
        }, []);
    }
    /**
   * Deregister a root notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeRootChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "root change");
    }
}
/**
 * Keypair signer interface
 */ /**
 * An account keypair used for signing transactions.
 */ class $bccf75ed4dec0420$export$c53bca448cf33676 {
    /**
   * Create a new keypair instance.
   * Generate random keypair if no {@link Ed25519Keypair} is provided.
   *
   * @param {Ed25519Keypair} keypair ed25519 keypair
   */ constructor(keypair){
        this._keypair = void 0;
        this._keypair = keypair ?? $bccf75ed4dec0420$var$generateKeypair();
    }
    /**
   * Generate a new random keypair
   *
   * @returns {Keypair} Keypair
   */ static generate() {
        return new $bccf75ed4dec0420$export$c53bca448cf33676($bccf75ed4dec0420$var$generateKeypair());
    }
    /**
   * Create a keypair from a raw secret key byte array.
   *
   * This method should only be used to recreate a keypair from a previously
   * generated secret key. Generating keypairs from a random seed should be done
   * with the {@link Keypair.fromSeed} method.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options skip secret key validation
   *
   * @returns {Keypair} Keypair
   */ static fromSecretKey(secretKey, options) {
        if (secretKey.byteLength !== 64) throw new Error("bad secret key size");
        const publicKey = secretKey.slice(32, 64);
        if (!options || !options.skipValidation) {
            const privateScalar = secretKey.slice(0, 32);
            const computedPublicKey = $bccf75ed4dec0420$var$getPublicKey(privateScalar);
            for(let ii = 0; ii < 32; ii++){
                if (publicKey[ii] !== computedPublicKey[ii]) throw new Error("provided secretKey is invalid");
            }
        }
        return new $bccf75ed4dec0420$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * Generate a keypair from a 32 byte seed.
   *
   * @param seed seed byte array
   *
   * @returns {Keypair} Keypair
   */ static fromSeed(seed) {
        const publicKey = $bccf75ed4dec0420$var$getPublicKey(seed);
        const secretKey = new Uint8Array(64);
        secretKey.set(seed);
        secretKey.set(publicKey, 32);
        return new $bccf75ed4dec0420$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * The public key for this keypair
   *
   * @returns {PublicKey} PublicKey
   */ get publicKey() {
        return new $bccf75ed4dec0420$export$ca8b6604d6ce14de(this._keypair.publicKey);
    }
    /**
   * The raw secret key for this keypair
   * @returns {Uint8Array} Secret key in an array of Uint8 bytes
   */ get secretKey() {
        return new Uint8Array(this._keypair.secretKey);
    }
}
/**
 * An enumeration of valid LookupTableInstructionType's
 */ /**
 * An enumeration of valid address lookup table InstructionType's
 * @internal
 */ const $bccf75ed4dec0420$export$7d102200c3a357d6 = Object.freeze({
    CreateLookupTable: {
        index: 0,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $bccf75ed4dec0420$var$u64("recentSlot"),
            $10b678223f208f49$exports.u8("bumpSeed")
        ])
    },
    FreezeLookupTable: {
        index: 1,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction")
        ])
    },
    ExtendLookupTable: {
        index: 2,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $bccf75ed4dec0420$var$u64(),
            $10b678223f208f49$exports.seq($bccf75ed4dec0420$var$publicKey(), $10b678223f208f49$exports.offset($10b678223f208f49$exports.u32(), -8), "addresses")
        ])
    },
    DeactivateLookupTable: {
        index: 3,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction")
        ])
    },
    CloseLookupTable: {
        index: 4,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction")
        ])
    }
});
class $bccf75ed4dec0420$export$3ab2b24d551f0dc2 {
    /**
   * @internal
   */ constructor(){}
    static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $10b678223f208f49$exports.u32("instruction");
        const index = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [layoutType, layout] of Object.entries($bccf75ed4dec0420$export$7d102200c3a357d6))if (layout.index == index) {
            type = layoutType;
            break;
        }
        if (!type) throw new Error("Invalid Instruction. Should be a LookupTable Instruction");
        return type;
    }
    static decodeCreateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 4);
        const { recentSlot: recentSlot } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$7d102200c3a357d6.CreateLookupTable, instruction.data);
        return {
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys[2].pubkey,
            recentSlot: Number(recentSlot)
        };
    }
    static decodeExtendLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        if (instruction.keys.length < 2) throw new Error(`invalid instruction; found ${instruction.keys.length} keys, expected at least 2`);
        const { addresses: addresses } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$7d102200c3a357d6.ExtendLookupTable, instruction.data);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys.length > 2 ? instruction.keys[2].pubkey : undefined,
            addresses: addresses.map((buffer)=>new $bccf75ed4dec0420$export$ca8b6604d6ce14de(buffer))
        };
    }
    static decodeCloseLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 3);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            recipient: instruction.keys[2].pubkey
        };
    }
    static decodeFreezeLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    static decodeDeactivateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($bccf75ed4dec0420$export$5147a345798de168.programId)) throw new Error("invalid instruction; programId is not AddressLookupTable Program");
    }
    /**
   * @internal
   */ static checkKeysLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
class $bccf75ed4dec0420$export$5147a345798de168 {
    /**
   * @internal
   */ constructor(){}
    static createLookupTable(params) {
        const [lookupTableAddress, bumpSeed] = $bccf75ed4dec0420$export$ca8b6604d6ce14de.findProgramAddressSync([
            params.authority.toBuffer(),
            (0, $d15510cabed22f5e$export$59d3bc8d559487ec)().encode(params.recentSlot)
        ], this.programId);
        const type = $bccf75ed4dec0420$export$7d102200c3a357d6.CreateLookupTable;
        const data = $bccf75ed4dec0420$var$encodeData(type, {
            recentSlot: BigInt(params.recentSlot),
            bumpSeed: bumpSeed
        });
        const keys = [
            {
                pubkey: lookupTableAddress,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.payer,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: $bccf75ed4dec0420$export$d8c4e17726848113.programId,
                isSigner: false,
                isWritable: false
            }
        ];
        return [
            new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
                programId: this.programId,
                keys: keys,
                data: data
            }),
            lookupTableAddress
        ];
    }
    static freezeLookupTable(params) {
        const type = $bccf75ed4dec0420$export$7d102200c3a357d6.FreezeLookupTable;
        const data = $bccf75ed4dec0420$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static extendLookupTable(params) {
        const type = $bccf75ed4dec0420$export$7d102200c3a357d6.ExtendLookupTable;
        const data = $bccf75ed4dec0420$var$encodeData(type, {
            addresses: params.addresses.map((addr)=>addr.toBytes())
        });
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        if (params.payer) keys.push({
            pubkey: params.payer,
            isSigner: true,
            isWritable: true
        }, {
            pubkey: $bccf75ed4dec0420$export$d8c4e17726848113.programId,
            isSigner: false,
            isWritable: false
        });
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static deactivateLookupTable(params) {
        const type = $bccf75ed4dec0420$export$7d102200c3a357d6.DeactivateLookupTable;
        const data = $bccf75ed4dec0420$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static closeLookupTable(params) {
        const type = $bccf75ed4dec0420$export$7d102200c3a357d6.CloseLookupTable;
        const data = $bccf75ed4dec0420$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.recipient,
                isSigner: false,
                isWritable: true
            }
        ];
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
}
$bccf75ed4dec0420$export$5147a345798de168.programId = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("AddressLookupTab1e1111111111111111111111111");
/**
 * Compute Budget Instruction class
 */ class $bccf75ed4dec0420$export$bc4776847c641a67 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a compute budget instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $10b678223f208f49$exports.u8("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($bccf75ed4dec0420$export$b7c79c50764da3d6))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a ComputeBudgetInstruction");
        return type;
    }
    /**
   * Decode request units compute budget instruction and retrieve the instruction params.
   */ static decodeRequestUnits(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units, additionalFee: additionalFee } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$b7c79c50764da3d6.RequestUnits, instruction.data);
        return {
            units: units,
            additionalFee: additionalFee
        };
    }
    /**
   * Decode request heap frame compute budget instruction and retrieve the instruction params.
   */ static decodeRequestHeapFrame(instruction) {
        this.checkProgramId(instruction.programId);
        const { bytes: bytes } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$b7c79c50764da3d6.RequestHeapFrame, instruction.data);
        return {
            bytes: bytes
        };
    }
    /**
   * Decode set compute unit limit compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitLimit(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$b7c79c50764da3d6.SetComputeUnitLimit, instruction.data);
        return {
            units: units
        };
    }
    /**
   * Decode set compute unit price compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitPrice(instruction) {
        this.checkProgramId(instruction.programId);
        const { microLamports: microLamports } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$b7c79c50764da3d6.SetComputeUnitPrice, instruction.data);
        return {
            microLamports: microLamports
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($bccf75ed4dec0420$export$11585db5942bcdb7.programId)) throw new Error("invalid instruction; programId is not ComputeBudgetProgram");
    }
}
/**
 * An enumeration of valid ComputeBudgetInstructionType's
 */ /**
 * Request units instruction params
 */ /**
 * Request heap frame instruction params
 */ /**
 * Set compute unit limit instruction params
 */ /**
 * Set compute unit price instruction params
 */ /**
 * An enumeration of valid ComputeBudget InstructionType's
 * @internal
 */ const $bccf75ed4dec0420$export$b7c79c50764da3d6 = Object.freeze({
    RequestUnits: {
        index: 0,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u8("instruction"),
            $10b678223f208f49$exports.u32("units"),
            $10b678223f208f49$exports.u32("additionalFee")
        ])
    },
    RequestHeapFrame: {
        index: 1,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u8("instruction"),
            $10b678223f208f49$exports.u32("bytes")
        ])
    },
    SetComputeUnitLimit: {
        index: 2,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u8("instruction"),
            $10b678223f208f49$exports.u32("units")
        ])
    },
    SetComputeUnitPrice: {
        index: 3,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u8("instruction"),
            $bccf75ed4dec0420$var$u64("microLamports")
        ])
    }
});
/**
 * Factory class for transaction instructions to interact with the Compute Budget program
 */ class $bccf75ed4dec0420$export$11585db5942bcdb7 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Compute Budget program
   */ /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */ static requestUnits(params) {
        const type = $bccf75ed4dec0420$export$b7c79c50764da3d6.RequestUnits;
        const data = $bccf75ed4dec0420$var$encodeData(type, params);
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static requestHeapFrame(params) {
        const type = $bccf75ed4dec0420$export$b7c79c50764da3d6.RequestHeapFrame;
        const data = $bccf75ed4dec0420$var$encodeData(type, params);
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitLimit(params) {
        const type = $bccf75ed4dec0420$export$b7c79c50764da3d6.SetComputeUnitLimit;
        const data = $bccf75ed4dec0420$var$encodeData(type, params);
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitPrice(params) {
        const type = $bccf75ed4dec0420$export$b7c79c50764da3d6.SetComputeUnitPrice;
        const data = $bccf75ed4dec0420$var$encodeData(type, {
            microLamports: BigInt(params.microLamports)
        });
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
}
$bccf75ed4dec0420$export$11585db5942bcdb7.programId = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("ComputeBudget111111111111111111111111111111");
const $bccf75ed4dec0420$var$PRIVATE_KEY_BYTES$1 = 64;
const $bccf75ed4dec0420$var$PUBLIC_KEY_BYTES$1 = 32;
const $bccf75ed4dec0420$var$SIGNATURE_BYTES = 64;
/**
 * Params for creating an ed25519 instruction using a public key
 */ /**
 * Params for creating an ed25519 instruction using a private key
 */ const $bccf75ed4dec0420$var$ED25519_INSTRUCTION_LAYOUT = $10b678223f208f49$exports.struct([
    $10b678223f208f49$exports.u8("numSignatures"),
    $10b678223f208f49$exports.u8("padding"),
    $10b678223f208f49$exports.u16("signatureOffset"),
    $10b678223f208f49$exports.u16("signatureInstructionIndex"),
    $10b678223f208f49$exports.u16("publicKeyOffset"),
    $10b678223f208f49$exports.u16("publicKeyInstructionIndex"),
    $10b678223f208f49$exports.u16("messageDataOffset"),
    $10b678223f208f49$exports.u16("messageDataSize"),
    $10b678223f208f49$exports.u16("messageInstructionIndex")
]);
class $bccf75ed4dec0420$export$e5087aea02631e {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the ed25519 program
   */ /**
   * Create an ed25519 instruction with a public key and signature. The
   * public key must be a buffer that is 32 bytes long, and the signature
   * must be a buffer of 64 bytes.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, instructionIndex: instructionIndex } = params;
        $bccf75ed4dec0420$var$assert(publicKey.length === $bccf75ed4dec0420$var$PUBLIC_KEY_BYTES$1, `Public Key must be ${$bccf75ed4dec0420$var$PUBLIC_KEY_BYTES$1} bytes but received ${publicKey.length} bytes`);
        $bccf75ed4dec0420$var$assert(signature.length === $bccf75ed4dec0420$var$SIGNATURE_BYTES, `Signature must be ${$bccf75ed4dec0420$var$SIGNATURE_BYTES} bytes but received ${signature.length} bytes`);
        const publicKeyOffset = $bccf75ed4dec0420$var$ED25519_INSTRUCTION_LAYOUT.span;
        const signatureOffset = publicKeyOffset + publicKey.length;
        const messageDataOffset = signatureOffset + signature.length;
        const numSignatures = 1;
        const instructionData = (0, $lewJ9.Buffer).alloc(messageDataOffset + message.length);
        const index = instructionIndex == null ? 0xffff // An index of `u16::MAX` makes it default to the current instruction.
         : instructionIndex;
        $bccf75ed4dec0420$var$ED25519_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            padding: 0,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: index,
            publicKeyOffset: publicKeyOffset,
            publicKeyInstructionIndex: index,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: index
        }, instructionData);
        instructionData.fill(publicKey, publicKeyOffset);
        instructionData.fill(signature, signatureOffset);
        instructionData.fill(message, messageDataOffset);
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $bccf75ed4dec0420$export$e5087aea02631e.programId,
            data: instructionData
        });
    }
    /**
   * Create an ed25519 instruction with a private key. The private key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: privateKey, message: message, instructionIndex: instructionIndex } = params;
        $bccf75ed4dec0420$var$assert(privateKey.length === $bccf75ed4dec0420$var$PRIVATE_KEY_BYTES$1, `Private key must be ${$bccf75ed4dec0420$var$PRIVATE_KEY_BYTES$1} bytes but received ${privateKey.length} bytes`);
        try {
            const keypair = $bccf75ed4dec0420$export$c53bca448cf33676.fromSecretKey(privateKey);
            const publicKey = keypair.publicKey.toBytes();
            const signature = $bccf75ed4dec0420$var$sign(message, keypair.secretKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$bccf75ed4dec0420$export$e5087aea02631e.programId = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("Ed25519SigVerify111111111111111111111111111");
const $bccf75ed4dec0420$var$ecdsaSign = (msgHash, privKey)=>{
    const signature = (0, $7pdKa.secp256k1).sign(msgHash, privKey);
    return [
        signature.toCompactRawBytes(),
        signature.recovery
    ];
};
(0, $7pdKa.secp256k1).utils.isValidPrivateKey;
const $bccf75ed4dec0420$var$publicKeyCreate = (0, $7pdKa.secp256k1).getPublicKey;
const $bccf75ed4dec0420$var$PRIVATE_KEY_BYTES = 32;
const $bccf75ed4dec0420$var$ETHEREUM_ADDRESS_BYTES = 20;
const $bccf75ed4dec0420$var$PUBLIC_KEY_BYTES = 64;
const $bccf75ed4dec0420$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE = 11;
/**
 * Params for creating an secp256k1 instruction using a public key
 */ /**
 * Params for creating an secp256k1 instruction using an Ethereum address
 */ /**
 * Params for creating an secp256k1 instruction using a private key
 */ const $bccf75ed4dec0420$var$SECP256K1_INSTRUCTION_LAYOUT = $10b678223f208f49$exports.struct([
    $10b678223f208f49$exports.u8("numSignatures"),
    $10b678223f208f49$exports.u16("signatureOffset"),
    $10b678223f208f49$exports.u8("signatureInstructionIndex"),
    $10b678223f208f49$exports.u16("ethAddressOffset"),
    $10b678223f208f49$exports.u8("ethAddressInstructionIndex"),
    $10b678223f208f49$exports.u16("messageDataOffset"),
    $10b678223f208f49$exports.u16("messageDataSize"),
    $10b678223f208f49$exports.u8("messageInstructionIndex"),
    $10b678223f208f49$exports.blob(20, "ethAddress"),
    $10b678223f208f49$exports.blob(64, "signature"),
    $10b678223f208f49$exports.u8("recoveryId")
]);
class $bccf75ed4dec0420$export$d85dd4c1161d13c9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the secp256k1 program
   */ /**
   * Construct an Ethereum address from a secp256k1 public key buffer.
   * @param {Buffer} publicKey a 64 byte secp256k1 public key buffer
   */ static publicKeyToEthAddress(publicKey) {
        $bccf75ed4dec0420$var$assert(publicKey.length === $bccf75ed4dec0420$var$PUBLIC_KEY_BYTES, `Public key must be ${$bccf75ed4dec0420$var$PUBLIC_KEY_BYTES} bytes but received ${publicKey.length} bytes`);
        try {
            return (0, $lewJ9.Buffer).from((0, $j0one.keccak_256)($bccf75ed4dec0420$var$toBuffer(publicKey))).slice(-$bccf75ed4dec0420$var$ETHEREUM_ADDRESS_BYTES);
        } catch (error) {
            throw new Error(`Error constructing Ethereum address: ${error}`);
        }
    }
    /**
   * Create an secp256k1 instruction with a public key. The public key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex } = params;
        return $bccf75ed4dec0420$export$d85dd4c1161d13c9.createInstructionWithEthAddress({
            ethAddress: $bccf75ed4dec0420$export$d85dd4c1161d13c9.publicKeyToEthAddress(publicKey),
            message: message,
            signature: signature,
            recoveryId: recoveryId,
            instructionIndex: instructionIndex
        });
    }
    /**
   * Create an secp256k1 instruction with an Ethereum address. The address
   * must be a hex string or a buffer that is 20 bytes long.
   */ static createInstructionWithEthAddress(params) {
        const { ethAddress: rawAddress, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex = 0 } = params;
        let ethAddress;
        if (typeof rawAddress === "string") {
            if (rawAddress.startsWith("0x")) ethAddress = (0, $lewJ9.Buffer).from(rawAddress.substr(2), "hex");
            else ethAddress = (0, $lewJ9.Buffer).from(rawAddress, "hex");
        } else ethAddress = rawAddress;
        $bccf75ed4dec0420$var$assert(ethAddress.length === $bccf75ed4dec0420$var$ETHEREUM_ADDRESS_BYTES, `Address must be ${$bccf75ed4dec0420$var$ETHEREUM_ADDRESS_BYTES} bytes but received ${ethAddress.length} bytes`);
        const dataStart = 1 + $bccf75ed4dec0420$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE;
        const ethAddressOffset = dataStart;
        const signatureOffset = dataStart + ethAddress.length;
        const messageDataOffset = signatureOffset + signature.length + 1;
        const numSignatures = 1;
        const instructionData = (0, $lewJ9.Buffer).alloc($bccf75ed4dec0420$var$SECP256K1_INSTRUCTION_LAYOUT.span + message.length);
        $bccf75ed4dec0420$var$SECP256K1_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: instructionIndex,
            ethAddressOffset: ethAddressOffset,
            ethAddressInstructionIndex: instructionIndex,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: instructionIndex,
            signature: $bccf75ed4dec0420$var$toBuffer(signature),
            ethAddress: $bccf75ed4dec0420$var$toBuffer(ethAddress),
            recoveryId: recoveryId
        }, instructionData);
        instructionData.fill($bccf75ed4dec0420$var$toBuffer(message), $bccf75ed4dec0420$var$SECP256K1_INSTRUCTION_LAYOUT.span);
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $bccf75ed4dec0420$export$d85dd4c1161d13c9.programId,
            data: instructionData
        });
    }
    /**
   * Create an secp256k1 instruction with a private key. The private key
   * must be a buffer that is 32 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: pkey, message: message, instructionIndex: instructionIndex } = params;
        $bccf75ed4dec0420$var$assert(pkey.length === $bccf75ed4dec0420$var$PRIVATE_KEY_BYTES, `Private key must be ${$bccf75ed4dec0420$var$PRIVATE_KEY_BYTES} bytes but received ${pkey.length} bytes`);
        try {
            const privateKey = $bccf75ed4dec0420$var$toBuffer(pkey);
            const publicKey = $bccf75ed4dec0420$var$publicKeyCreate(privateKey, false).slice(1); // throw away leading byte
            const messageHash = (0, $lewJ9.Buffer).from((0, $j0one.keccak_256)($bccf75ed4dec0420$var$toBuffer(message)));
            const [signature, recoveryId] = $bccf75ed4dec0420$var$ecdsaSign(messageHash, privateKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                recoveryId: recoveryId,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$bccf75ed4dec0420$export$d85dd4c1161d13c9.programId = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("KeccakSecp256k11111111111111111111111111111");
var $bccf75ed4dec0420$var$_Lockup;
/**
 * Address of the stake config account which configures the rate
 * of stake warmup and cooldown as well as the slashing penalty.
 */ const $bccf75ed4dec0420$export$18aac71979bdd08f = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("StakeConfig11111111111111111111111111111111");
/**
 * Stake account authority info
 */ class $bccf75ed4dec0420$export$9ac74ae66932a145 {
    /**
   * Create a new Authorized object
   * @param staker the stake authority
   * @param withdrawer the withdraw authority
   */ constructor(staker, withdrawer){
        /** stake authority */ this.staker = void 0;
        /** withdraw authority */ this.withdrawer = void 0;
        this.staker = staker;
        this.withdrawer = withdrawer;
    }
}
/**
 * Stake account lockup info
 */ class $bccf75ed4dec0420$export$e7f3941ade35598c {
    /**
   * Create a new Lockup object
   */ constructor(unixTimestamp, epoch, custodian){
        /** Unix timestamp of lockup expiration */ this.unixTimestamp = void 0;
        /** Epoch of lockup expiration */ this.epoch = void 0;
        /** Lockup custodian authority */ this.custodian = void 0;
        this.unixTimestamp = unixTimestamp;
        this.epoch = epoch;
        this.custodian = custodian;
    }
}
$bccf75ed4dec0420$var$_Lockup = $bccf75ed4dec0420$export$e7f3941ade35598c;
$bccf75ed4dec0420$export$e7f3941ade35598c.default = new $bccf75ed4dec0420$var$_Lockup(0, 0, $bccf75ed4dec0420$export$ca8b6604d6ce14de.default);
/**
 * Create stake account transaction params
 */ /**
 * Create stake account with seed transaction params
 */ /**
 * Initialize stake instruction params
 */ /**
 * Delegate stake instruction params
 */ /**
 * Authorize stake instruction params
 */ /**
 * Authorize stake instruction params using a derived key
 */ /**
 * Split stake instruction params
 */ /**
 * Split with seed transaction params
 */ /**
 * Withdraw stake instruction params
 */ /**
 * Deactivate stake instruction params
 */ /**
 * Merge stake instruction params
 */ /**
 * Stake Instruction class
 */ class $bccf75ed4dec0420$export$aded313c3a4800f9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a stake instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $10b678223f208f49$exports.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($bccf75ed4dec0420$export$c89793bd2bba8b2e))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a StakeInstruction");
        return type;
    }
    /**
   * Decode a initialize stake instruction and retrieve the instruction params.
   */ static decodeInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized, lockup: lockup } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$c89793bd2bba8b2e.Initialize, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorized: new $bccf75ed4dec0420$export$9ac74ae66932a145(new $bccf75ed4dec0420$export$ca8b6604d6ce14de(authorized.staker), new $bccf75ed4dec0420$export$ca8b6604d6ce14de(authorized.withdrawer)),
            lockup: new $bccf75ed4dec0420$export$e7f3941ade35598c(lockup.unixTimestamp, lockup.epoch, new $bccf75ed4dec0420$export$ca8b6604d6ce14de(lockup.custodian))
        };
    }
    /**
   * Decode a delegate stake instruction and retrieve the instruction params.
   */ static decodeDelegate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 6);
        $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$c89793bd2bba8b2e.Delegate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            votePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[5].pubkey
        };
    }
    /**
   * Decode an authorize stake instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$c89793bd2bba8b2e.Authorize, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode an authorize-with-seed stake instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType, authoritySeed: authoritySeed, authorityOwner: authorityOwner } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$c89793bd2bba8b2e.AuthorizeWithSeed, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorityBase: instruction.keys[1].pubkey,
            authoritySeed: authoritySeed,
            authorityOwner: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(authorityOwner),
            newAuthorizedPubkey: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode a split stake instruction and retrieve the instruction params.
   */ static decodeSplit(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$c89793bd2bba8b2e.Split, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            splitStakePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a merge stake instruction and retrieve the instruction params.
   */ static decodeMerge(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$c89793bd2bba8b2e.Merge, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            sourceStakePubKey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey
        };
    }
    /**
   * Decode a withdraw stake instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$c89793bd2bba8b2e.Withdraw, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
        if (instruction.keys.length > 5) o.custodianPubkey = instruction.keys[5].pubkey;
        return o;
    }
    /**
   * Decode a deactivate stake instruction and retrieve the instruction params.
   */ static decodeDeactivate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$export$c89793bd2bba8b2e.Deactivate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($bccf75ed4dec0420$export$df86f933e9f8fb15.programId)) throw new Error("invalid instruction; programId is not StakeProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid StakeInstructionType's
 */ /**
 * An enumeration of valid stake InstructionType's
 * @internal
 */ const $bccf75ed4dec0420$export$c89793bd2bba8b2e = Object.freeze({
    Initialize: {
        index: 0,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $bccf75ed4dec0420$var$authorized(),
            $bccf75ed4dec0420$var$lockup()
        ])
    },
    Authorize: {
        index: 1,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $bccf75ed4dec0420$var$publicKey("newAuthorized"),
            $10b678223f208f49$exports.u32("stakeAuthorizationType")
        ])
    },
    Delegate: {
        index: 2,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction")
        ])
    },
    Split: {
        index: 3,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $10b678223f208f49$exports.ns64("lamports")
        ])
    },
    Withdraw: {
        index: 4,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $10b678223f208f49$exports.ns64("lamports")
        ])
    },
    Deactivate: {
        index: 5,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction")
        ])
    },
    Merge: {
        index: 7,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction")
        ])
    },
    AuthorizeWithSeed: {
        index: 8,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $bccf75ed4dec0420$var$publicKey("newAuthorized"),
            $10b678223f208f49$exports.u32("stakeAuthorizationType"),
            $bccf75ed4dec0420$var$rustString("authoritySeed"),
            $bccf75ed4dec0420$var$publicKey("authorityOwner")
        ])
    }
});
/**
 * Stake authorization type
 */ /**
 * An enumeration of valid StakeAuthorizationLayout's
 */ const $bccf75ed4dec0420$export$4783920eadd34361 = Object.freeze({
    Staker: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Stake program
 */ class $bccf75ed4dec0420$export$df86f933e9f8fb15 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Stake program
   */ /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */ static initialize(params) {
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: maybeLockup } = params;
        const lockup = maybeLockup || $bccf75ed4dec0420$export$e7f3941ade35598c.default;
        const type = $bccf75ed4dec0420$export$c89793bd2bba8b2e.Initialize;
        const data = $bccf75ed4dec0420$var$encodeData(type, {
            authorized: {
                staker: $bccf75ed4dec0420$var$toBuffer(authorized.staker.toBuffer()),
                withdrawer: $bccf75ed4dec0420$var$toBuffer(authorized.withdrawer.toBuffer())
            },
            lockup: {
                unixTimestamp: lockup.unixTimestamp,
                epoch: lockup.epoch,
                custodian: $bccf75ed4dec0420$var$toBuffer(lockup.custodian.toBuffer())
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $bccf75ed4dec0420$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */ static createAccountWithSeed(params) {
        const transaction = new $bccf75ed4dec0420$export$febc5573c75cefb0();
        transaction.add($bccf75ed4dec0420$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that creates a new Stake account
   */ static createAccount(params) {
        const transaction = new $bccf75ed4dec0420$export$febc5573c75cefb0();
        transaction.add($bccf75ed4dec0420$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */ static delegate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, votePubkey: votePubkey } = params;
        const type = $bccf75ed4dec0420$export$c89793bd2bba8b2e.Delegate;
        const data = $bccf75ed4dec0420$var$encodeData(type);
        return new $bccf75ed4dec0420$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $bccf75ed4dec0420$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $bccf75ed4dec0420$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $bccf75ed4dec0420$export$18aac71979bdd08f,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorize(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $bccf75ed4dec0420$export$c89793bd2bba8b2e.Authorize;
        const data = $bccf75ed4dec0420$var$encodeData(type, {
            newAuthorized: $bccf75ed4dec0420$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $bccf75ed4dec0420$export$393aa1412d47050e,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $bccf75ed4dec0420$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorizeWithSeed(params) {
        const { stakePubkey: stakePubkey, authorityBase: authorityBase, authoritySeed: authoritySeed, authorityOwner: authorityOwner, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $bccf75ed4dec0420$export$c89793bd2bba8b2e.AuthorizeWithSeed;
        const data = $bccf75ed4dec0420$var$encodeData(type, {
            newAuthorized: $bccf75ed4dec0420$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index,
            authoritySeed: authoritySeed,
            authorityOwner: $bccf75ed4dec0420$var$toBuffer(authorityOwner.toBuffer())
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorityBase,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: $bccf75ed4dec0420$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $bccf75ed4dec0420$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * @internal
   */ static splitInstruction(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, lamports: lamports } = params;
        const type = $bccf75ed4dec0420$export$c89793bd2bba8b2e.Split;
        const data = $bccf75ed4dec0420$var$encodeData(type, {
            lamports: lamports
        });
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: splitStakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that splits Stake tokens into another stake account
   */ static split(params, // Compute the cost of allocating the new stake account in lamports
    rentExemptReserve) {
        const transaction = new $bccf75ed4dec0420$export$febc5573c75cefb0();
        transaction.add($bccf75ed4dec0420$export$d8c4e17726848113.createAccount({
            fromPubkey: params.authorizedPubkey,
            newAccountPubkey: params.splitStakePubkey,
            lamports: rentExemptReserve,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.splitInstruction(params));
    }
    /**
   * Generate a Transaction that splits Stake tokens into another account
   * derived from a base public key and seed
   */ static splitWithSeed(params, // If this stake account is new, compute the cost of allocating it in lamports
    rentExemptReserve) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, basePubkey: basePubkey, seed: seed, lamports: lamports } = params;
        const transaction = new $bccf75ed4dec0420$export$febc5573c75cefb0();
        transaction.add($bccf75ed4dec0420$export$d8c4e17726848113.allocate({
            accountPubkey: splitStakePubkey,
            basePubkey: basePubkey,
            seed: seed,
            space: this.space,
            programId: this.programId
        }));
        if (rentExemptReserve && rentExemptReserve > 0) transaction.add($bccf75ed4dec0420$export$d8c4e17726848113.transfer({
            fromPubkey: params.authorizedPubkey,
            toPubkey: splitStakePubkey,
            lamports: rentExemptReserve
        }));
        return transaction.add(this.splitInstruction({
            stakePubkey: stakePubkey,
            authorizedPubkey: authorizedPubkey,
            splitStakePubkey: splitStakePubkey,
            lamports: lamports
        }));
    }
    /**
   * Generate a Transaction that merges Stake accounts.
   */ static merge(params) {
        const { stakePubkey: stakePubkey, sourceStakePubKey: sourceStakePubKey, authorizedPubkey: authorizedPubkey } = params;
        const type = $bccf75ed4dec0420$export$c89793bd2bba8b2e.Merge;
        const data = $bccf75ed4dec0420$var$encodeData(type);
        return new $bccf75ed4dec0420$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: sourceStakePubKey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $bccf75ed4dec0420$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $bccf75ed4dec0420$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */ static withdraw(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, toPubkey: toPubkey, lamports: lamports, custodianPubkey: custodianPubkey } = params;
        const type = $bccf75ed4dec0420$export$c89793bd2bba8b2e.Withdraw;
        const data = $bccf75ed4dec0420$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $bccf75ed4dec0420$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: $bccf75ed4dec0420$export$ca994171317280ea,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $bccf75ed4dec0420$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that deactivates Stake tokens.
   */ static deactivate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey } = params;
        const type = $bccf75ed4dec0420$export$c89793bd2bba8b2e.Deactivate;
        const data = $bccf75ed4dec0420$var$encodeData(type);
        return new $bccf75ed4dec0420$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $bccf75ed4dec0420$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
}
$bccf75ed4dec0420$export$df86f933e9f8fb15.programId = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("Stake11111111111111111111111111111111111111");
/**
 * Max space of a Stake account
 *
 * This is generated from the solana-stake-program StakeState struct as
 * `StakeStateV2::size_of()`:
 * https://docs.rs/solana-stake-program/latest/solana_stake_program/stake_state/enum.StakeStateV2.html
 */ $bccf75ed4dec0420$export$df86f933e9f8fb15.space = 200;
/**
 * Vote account info
 */ class $bccf75ed4dec0420$export$3f9d1b16ff840d7 {
    /** [0, 100] */ constructor(nodePubkey, authorizedVoter, authorizedWithdrawer, commission){
        this.nodePubkey = void 0;
        this.authorizedVoter = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.nodePubkey = nodePubkey;
        this.authorizedVoter = authorizedVoter;
        this.authorizedWithdrawer = authorizedWithdrawer;
        this.commission = commission;
    }
}
/**
 * Create vote account transaction params
 */ /**
 * InitializeAccount instruction params
 */ /**
 * Authorize instruction params
 */ /**
 * AuthorizeWithSeed instruction params
 */ /**
 * Withdraw from vote account transaction params
 */ /**
 * Update validator identity (node pubkey) vote account instruction params.
 */ /**
 * Vote Instruction class
 */ class $bccf75ed4dec0420$export$af8300401fc56047 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a vote instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $10b678223f208f49$exports.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($bccf75ed4dec0420$var$VOTE_INSTRUCTION_LAYOUTS))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a VoteInstruction");
        return type;
    }
    /**
   * Decode an initialize vote instruction and retrieve the instruction params.
   */ static decodeInitializeAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 4);
        const { voteInit: voteInit } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            nodePubkey: instruction.keys[3].pubkey,
            voteInit: new $bccf75ed4dec0420$export$3f9d1b16ff840d7(new $bccf75ed4dec0420$export$ca8b6604d6ce14de(voteInit.nodePubkey), new $bccf75ed4dec0420$export$ca8b6604d6ce14de(voteInit.authorizedVoter), new $bccf75ed4dec0420$export$ca8b6604d6ce14de(voteInit.authorizedWithdrawer), voteInit.commission)
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$var$VOTE_INSTRUCTION_LAYOUTS.Authorize, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            }
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { voteAuthorizeWithSeedArgs: { currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, instruction.data);
        return {
            currentAuthorityDerivedKeyBasePubkey: instruction.keys[2].pubkey,
            currentAuthorityDerivedKeyOwnerPubkey: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(currentAuthorityDerivedKeyOwnerPubkey),
            currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
            newAuthorizedPubkey: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            },
            votePubkey: instruction.keys[0].pubkey
        };
    }
    /**
   * Decode a withdraw instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $bccf75ed4dec0420$var$decodeData$1($bccf75ed4dec0420$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedWithdrawerPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            toPubkey: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($bccf75ed4dec0420$export$83db2bc702bee1eb.programId)) throw new Error("invalid instruction; programId is not VoteProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid VoteInstructionType's
 */ /** @internal */ const $bccf75ed4dec0420$var$VOTE_INSTRUCTION_LAYOUTS = Object.freeze({
    InitializeAccount: {
        index: 0,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $bccf75ed4dec0420$var$voteInit()
        ])
    },
    Authorize: {
        index: 1,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $bccf75ed4dec0420$var$publicKey("newAuthorized"),
            $10b678223f208f49$exports.u32("voteAuthorizationType")
        ])
    },
    Withdraw: {
        index: 3,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $10b678223f208f49$exports.ns64("lamports")
        ])
    },
    UpdateValidatorIdentity: {
        index: 4,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction")
        ])
    },
    AuthorizeWithSeed: {
        index: 10,
        layout: $10b678223f208f49$exports.struct([
            $10b678223f208f49$exports.u32("instruction"),
            $bccf75ed4dec0420$var$voteAuthorizeWithSeedArgs()
        ])
    }
});
/**
 * VoteAuthorize type
 */ /**
 * An enumeration of valid VoteAuthorization layouts.
 */ const $bccf75ed4dec0420$export$3f2a92246fa9f71c = Object.freeze({
    Voter: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Vote program
 */ class $bccf75ed4dec0420$export$83db2bc702bee1eb {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Vote program
   */ /**
   * Generate an Initialize instruction.
   */ static initializeAccount(params) {
        const { votePubkey: votePubkey, nodePubkey: nodePubkey, voteInit: voteInit } = params;
        const type = $bccf75ed4dec0420$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount;
        const data = $bccf75ed4dec0420$var$encodeData(type, {
            voteInit: {
                nodePubkey: $bccf75ed4dec0420$var$toBuffer(voteInit.nodePubkey.toBuffer()),
                authorizedVoter: $bccf75ed4dec0420$var$toBuffer(voteInit.authorizedVoter.toBuffer()),
                authorizedWithdrawer: $bccf75ed4dec0420$var$toBuffer(voteInit.authorizedWithdrawer.toBuffer()),
                commission: voteInit.commission
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $bccf75ed4dec0420$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $bccf75ed4dec0420$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: nodePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $bccf75ed4dec0420$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction that creates a new Vote account.
   */ static createAccount(params) {
        const transaction = new $bccf75ed4dec0420$export$febc5573c75cefb0();
        transaction.add($bccf75ed4dec0420$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.votePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.initializeAccount({
            votePubkey: params.votePubkey,
            nodePubkey: params.voteInit.nodePubkey,
            voteInit: params.voteInit
        }));
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account.
   */ static authorize(params) {
        const { votePubkey: votePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType } = params;
        const type = $bccf75ed4dec0420$var$VOTE_INSTRUCTION_LAYOUTS.Authorize;
        const data = $bccf75ed4dec0420$var$encodeData(type, {
            newAuthorized: $bccf75ed4dec0420$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            voteAuthorizationType: voteAuthorizationType.index
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $bccf75ed4dec0420$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $bccf75ed4dec0420$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account
   * where the current Voter or Withdrawer authority is a derived key.
   */ static authorizeWithSeed(params) {
        const { currentAuthorityDerivedKeyBasePubkey: currentAuthorityDerivedKeyBasePubkey, currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType, votePubkey: votePubkey } = params;
        const type = $bccf75ed4dec0420$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed;
        const data = $bccf75ed4dec0420$var$encodeData(type, {
            voteAuthorizeWithSeedArgs: {
                currentAuthorityDerivedKeyOwnerPubkey: $bccf75ed4dec0420$var$toBuffer(currentAuthorityDerivedKeyOwnerPubkey.toBuffer()),
                currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
                newAuthorized: $bccf75ed4dec0420$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                voteAuthorizationType: voteAuthorizationType.index
            }
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $bccf75ed4dec0420$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: currentAuthorityDerivedKeyBasePubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $bccf75ed4dec0420$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw from a Vote account.
   */ static withdraw(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, lamports: lamports, toPubkey: toPubkey } = params;
        const type = $bccf75ed4dec0420$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw;
        const data = $bccf75ed4dec0420$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $bccf75ed4dec0420$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw safely from a Vote account.
   *
   * This function was created as a safeguard for vote accounts running validators, `safeWithdraw`
   * checks that the withdraw amount will not exceed the specified balance while leaving enough left
   * to cover rent. If you wish to close the vote account by withdrawing the full amount, call the
   * `withdraw` method directly.
   */ static safeWithdraw(params, currentVoteAccountBalance, rentExemptMinimum) {
        if (params.lamports > currentVoteAccountBalance - rentExemptMinimum) throw new Error("Withdraw will leave vote account with insufficient funds.");
        return $bccf75ed4dec0420$export$83db2bc702bee1eb.withdraw(params);
    }
    /**
   * Generate a transaction to update the validator identity (node pubkey) of a Vote account.
   */ static updateValidatorIdentity(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, nodePubkey: nodePubkey } = params;
        const type = $bccf75ed4dec0420$var$VOTE_INSTRUCTION_LAYOUTS.UpdateValidatorIdentity;
        const data = $bccf75ed4dec0420$var$encodeData(type);
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: nodePubkey,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $bccf75ed4dec0420$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$bccf75ed4dec0420$export$83db2bc702bee1eb.programId = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * Max space of a Vote account
 *
 * This is generated from the solana-vote-program VoteState struct as
 * `VoteState::size_of()`:
 * https://docs.rs/solana-vote-program/1.9.5/solana_vote_program/vote_state/struct.VoteState.html#method.size_of
 *
 * KEEP IN SYNC WITH `VoteState::size_of()` in https://github.com/solana-labs/solana/blob/a474cb24b9238f5edcc982f65c0b37d4a1046f7e/sdk/program/src/vote/state/mod.rs#L340-L342
 */ $bccf75ed4dec0420$export$83db2bc702bee1eb.space = 3762;
const $bccf75ed4dec0420$export$afdb09d3afdde87c = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("Va1idator1nfo111111111111111111111111111111");
/**
 * @internal
 */ /**
 * Info used to identity validators.
 */ const $bccf75ed4dec0420$var$InfoString = (0, $11e466829bcc37ce$export$bf9fb029d174d554)({
    name: (0, $11e466829bcc37ce$export$22b082955e083ec3)(),
    website: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$22b082955e083ec3)()),
    details: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$22b082955e083ec3)()),
    iconUrl: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$22b082955e083ec3)()),
    keybaseUsername: (0, $11e466829bcc37ce$export$516e28dec6a4b6d4)((0, $11e466829bcc37ce$export$22b082955e083ec3)())
});
/**
 * ValidatorInfo class
 */ class $bccf75ed4dec0420$export$152d279cf067309b {
    /**
   * Construct a valid ValidatorInfo
   *
   * @param key validator public key
   * @param info validator information
   */ constructor(key, info){
        /**
     * validator public key
     */ this.key = void 0;
        /**
     * validator information
     */ this.info = void 0;
        this.key = key;
        this.info = info;
    }
    /**
   * Deserialize ValidatorInfo from the config account data. Exactly two config
   * keys are required in the data.
   *
   * @param buffer config account data
   * @return null if info was not found
   */ static fromConfigData(buffer) {
        let byteArray = [
            ...buffer
        ];
        const configKeyCount = $bccf75ed4dec0420$var$decodeLength(byteArray);
        if (configKeyCount !== 2) return null;
        const configKeys = [];
        for(let i = 0; i < 2; i++){
            const publicKey = new $bccf75ed4dec0420$export$ca8b6604d6ce14de($bccf75ed4dec0420$var$guardedSplice(byteArray, 0, $bccf75ed4dec0420$export$84fc0a248cc54343));
            const isSigner = $bccf75ed4dec0420$var$guardedShift(byteArray) === 1;
            configKeys.push({
                publicKey: publicKey,
                isSigner: isSigner
            });
        }
        if (configKeys[0].publicKey.equals($bccf75ed4dec0420$export$afdb09d3afdde87c)) {
            if (configKeys[1].isSigner) {
                const rawInfo = $bccf75ed4dec0420$var$rustString().decode((0, $lewJ9.Buffer).from(byteArray));
                const info = JSON.parse(rawInfo);
                (0, $11e466829bcc37ce$export$a7a9523472993e97)(info, $bccf75ed4dec0420$var$InfoString);
                return new $bccf75ed4dec0420$export$152d279cf067309b(configKeys[1].publicKey, info);
            }
        }
        return null;
    }
}
const $bccf75ed4dec0420$export$90bca02a3aea0768 = new $bccf75ed4dec0420$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * History of how many credits earned by the end of each epoch
 */ /**
 * See https://github.com/solana-labs/solana/blob/8a12ed029cfa38d4a45400916c2463fb82bbec8c/programs/vote_api/src/vote_state.rs#L68-L88
 *
 * @internal
 */ const $bccf75ed4dec0420$var$VoteAccountLayout = $10b678223f208f49$exports.struct([
    $bccf75ed4dec0420$var$publicKey("nodePubkey"),
    $bccf75ed4dec0420$var$publicKey("authorizedWithdrawer"),
    $10b678223f208f49$exports.u8("commission"),
    $10b678223f208f49$exports.nu64(),
    // votes.length
    $10b678223f208f49$exports.seq($10b678223f208f49$exports.struct([
        $10b678223f208f49$exports.nu64("slot"),
        $10b678223f208f49$exports.u32("confirmationCount")
    ]), $10b678223f208f49$exports.offset($10b678223f208f49$exports.u32(), -8), "votes"),
    $10b678223f208f49$exports.u8("rootSlotValid"),
    $10b678223f208f49$exports.nu64("rootSlot"),
    $10b678223f208f49$exports.nu64(),
    // authorizedVoters.length
    $10b678223f208f49$exports.seq($10b678223f208f49$exports.struct([
        $10b678223f208f49$exports.nu64("epoch"),
        $bccf75ed4dec0420$var$publicKey("authorizedVoter")
    ]), $10b678223f208f49$exports.offset($10b678223f208f49$exports.u32(), -8), "authorizedVoters"),
    $10b678223f208f49$exports.struct([
        $10b678223f208f49$exports.seq($10b678223f208f49$exports.struct([
            $bccf75ed4dec0420$var$publicKey("authorizedPubkey"),
            $10b678223f208f49$exports.nu64("epochOfLastAuthorizedSwitch"),
            $10b678223f208f49$exports.nu64("targetEpoch")
        ]), 32, "buf"),
        $10b678223f208f49$exports.nu64("idx"),
        $10b678223f208f49$exports.u8("isEmpty")
    ], "priorVoters"),
    $10b678223f208f49$exports.nu64(),
    // epochCredits.length
    $10b678223f208f49$exports.seq($10b678223f208f49$exports.struct([
        $10b678223f208f49$exports.nu64("epoch"),
        $10b678223f208f49$exports.nu64("credits"),
        $10b678223f208f49$exports.nu64("prevCredits")
    ]), $10b678223f208f49$exports.offset($10b678223f208f49$exports.u32(), -8), "epochCredits"),
    $10b678223f208f49$exports.struct([
        $10b678223f208f49$exports.nu64("slot"),
        $10b678223f208f49$exports.nu64("timestamp")
    ], "lastTimestamp")
]);
/**
 * VoteAccount class
 */ class $bccf75ed4dec0420$export$89ef186f708d638b {
    /**
   * @internal
   */ constructor(args){
        this.nodePubkey = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.rootSlot = void 0;
        this.votes = void 0;
        this.authorizedVoters = void 0;
        this.priorVoters = void 0;
        this.epochCredits = void 0;
        this.lastTimestamp = void 0;
        this.nodePubkey = args.nodePubkey;
        this.authorizedWithdrawer = args.authorizedWithdrawer;
        this.commission = args.commission;
        this.rootSlot = args.rootSlot;
        this.votes = args.votes;
        this.authorizedVoters = args.authorizedVoters;
        this.priorVoters = args.priorVoters;
        this.epochCredits = args.epochCredits;
        this.lastTimestamp = args.lastTimestamp;
    }
    /**
   * Deserialize VoteAccount from the account data.
   *
   * @param buffer account data
   * @return VoteAccount
   */ static fromAccountData(buffer) {
        const versionOffset = 4;
        const va = $bccf75ed4dec0420$var$VoteAccountLayout.decode($bccf75ed4dec0420$var$toBuffer(buffer), versionOffset);
        let rootSlot = va.rootSlot;
        if (!va.rootSlotValid) rootSlot = null;
        return new $bccf75ed4dec0420$export$89ef186f708d638b({
            nodePubkey: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(va.nodePubkey),
            authorizedWithdrawer: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(va.authorizedWithdrawer),
            commission: va.commission,
            votes: va.votes,
            rootSlot: rootSlot,
            authorizedVoters: va.authorizedVoters.map($bccf75ed4dec0420$var$parseAuthorizedVoter),
            priorVoters: $bccf75ed4dec0420$var$getPriorVoters(va.priorVoters),
            epochCredits: va.epochCredits,
            lastTimestamp: va.lastTimestamp
        });
    }
}
function $bccf75ed4dec0420$var$parseAuthorizedVoter({ authorizedVoter: authorizedVoter, epoch: epoch }) {
    return {
        epoch: epoch,
        authorizedVoter: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(authorizedVoter)
    };
}
function $bccf75ed4dec0420$var$parsePriorVoters({ authorizedPubkey: authorizedPubkey, epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch, targetEpoch: targetEpoch }) {
    return {
        authorizedPubkey: new $bccf75ed4dec0420$export$ca8b6604d6ce14de(authorizedPubkey),
        epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch,
        targetEpoch: targetEpoch
    };
}
function $bccf75ed4dec0420$var$getPriorVoters({ buf: buf, idx: idx, isEmpty: isEmpty }) {
    if (isEmpty) return [];
    return [
        ...buf.slice(idx + 1).map($bccf75ed4dec0420$var$parsePriorVoters),
        ...buf.slice(0, idx).map($bccf75ed4dec0420$var$parsePriorVoters)
    ];
}
const $bccf75ed4dec0420$var$endpoint = {
    http: {
        devnet: "http://api.devnet.solana.com",
        testnet: "http://api.testnet.solana.com",
        "mainnet-beta": "http://api.mainnet-beta.solana.com/"
    },
    https: {
        devnet: "https://api.devnet.solana.com",
        testnet: "https://api.testnet.solana.com",
        "mainnet-beta": "https://api.mainnet-beta.solana.com/"
    }
};
/**
 * Retrieves the RPC API URL for the specified cluster
 * @param {Cluster} [cluster="devnet"] - The cluster name of the RPC API URL to use. Possible options: 'devnet' | 'testnet' | 'mainnet-beta'
 * @param {boolean} [tls="http"] - Use TLS when connecting to cluster.
 *
 * @returns {string} URL string of the RPC endpoint
 */ function $bccf75ed4dec0420$export$11656287b4eb76ff(cluster, tls) {
    const key = tls === false ? "http" : "https";
    if (!cluster) return $bccf75ed4dec0420$var$endpoint[key]["devnet"];
    const url = $bccf75ed4dec0420$var$endpoint[key][cluster];
    if (!url) throw new Error(`Unknown ${key} cluster: ${cluster}`);
    return url;
}
/**
 * Send and confirm a raw transaction
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Buffer} rawTransaction
 * @param {TransactionConfirmationStrategy} confirmationStrategy
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ /**
 * @deprecated Calling `sendAndConfirmRawTransaction()` without a `confirmationStrategy`
 * is no longer supported and will be removed in a future version.
 */ // eslint-disable-next-line no-redeclare
// eslint-disable-next-line no-redeclare
async function $bccf75ed4dec0420$export$554271b88fdb7843(connection, rawTransaction, confirmationStrategyOrConfirmOptions, maybeConfirmOptions) {
    let confirmationStrategy;
    let options;
    if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "lastValidBlockHeight")) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "nonceValue")) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else options = confirmationStrategyOrConfirmOptions;
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendRawTransaction(rawTransaction, sendOptions);
    const commitment = options && options.commitment;
    const confirmationPromise = confirmationStrategy ? connection.confirmTransaction(confirmationStrategy, commitment) : connection.confirmTransaction(signature, commitment);
    const status = (await confirmationPromise).value;
    if (status.err) {
        if (signature != null) throw new $bccf75ed4dec0420$export$121e803f723b3045({
            action: sendOptions?.skipPreflight ? "send" : "simulate",
            signature: signature,
            transactionMessage: `Status: (${JSON.stringify(status)})`
        });
        throw new Error(`Raw transaction ${signature} failed (${JSON.stringify(status)})`);
    }
    return signature;
}
/**
 * There are 1-billion lamports in one SOL
 */ const $bccf75ed4dec0420$export$5f6a2f2669741bbe = 1000000000;


parcelRequire("5ID99");

var $4zT52 = parcelRequire("4zT52");


var $b3v9s = parcelRequire("b3v9s");

var $5PQZs = parcelRequire("5PQZs");
var $gD0RX = parcelRequire("gD0RX");
var $lpmCO = parcelRequire("lpmCO");
var $bc5dy = parcelRequire("bc5dy");

var $6rTj5 = parcelRequire("6rTj5");


var $b3v9s = parcelRequire("b3v9s");
const $e18f15cebe1ef482$export$c1784c327b5e3fac = {
    UNIVERSAL_PROVIDER_RELAY_URL: "wss://relay.walletconnect.org",
    HASH_PREFIX: "SPL Name Service",
    ROOT_DOMAIN_ACCOUNT: new (0, $bccf75ed4dec0420$export$ca8b6604d6ce14de)("58PwtjSDuFHuUkYjH9BYnnQKHfwo9reZhC2zMJv9JPkx"),
    NAME_PROGRAM_ID: new (0, $bccf75ed4dec0420$export$ca8b6604d6ce14de)("namesLPneVptA9Z5rqUDD9tMTWEJwofgaYwp8cawRkX"),
    REVERSE_LOOKUP_CLASS: new (0, $bccf75ed4dec0420$export$ca8b6604d6ce14de)("33m47vH6Eav6jr5Ry86XjhRft2jRBLDnDgPSHoquXi2Z"),
    DEFAULT_CHAIN: {
        id: "5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp",
        caipNetworkId: "solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp",
        name: "Solana",
        chainNamespace: (0, $b3v9s.ConstantsUtil).CHAIN.SOLANA,
        nativeCurrency: {
            name: "Solana",
            decimals: 9,
            symbol: "SOL"
        },
        blockExplorers: {
            default: {
                name: "Solscan",
                url: "https://solscan.io"
            }
        },
        rpcUrls: {
            default: {
                http: [
                    `${(0, $b3v9s.ConstantsUtil).BLOCKCHAIN_API_RPC_URL}/v1`
                ]
            }
        }
    },
    CHAIN_IDS: {
        Mainnet: "solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp",
        Devnet: "solana:EtWTRABZaYq6iMfeYKouRu166VU2xqa1",
        Testnet: "solana:4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z",
        Deprecated_Mainnet: "solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ",
        Deprecated_Devnet: "solana:8E9rvCKLFQia2Y35HXjjpWzj8weVo44K"
    },
    LAMPORTS_PER_SOL: 1000000000
};




function $b2b60f05b08d2306$export$37ce1cc82e255d8(transaction) {
    return "version" in transaction;
}




var $4zT52 = parcelRequire("4zT52");

var $b3v9s = parcelRequire("b3v9s");

var $kfwQH = parcelRequire("kfwQH");

function $cb263ece615a278a$export$3ce495201451cda2(chainId) {
    if (typeof chainId === "string") return `solana:${chainId}`;
    return undefined;
}


class $913120838350aaba$export$72b040f461a56853 {
    constructor(){
        this.listeners = {
            accountsChanged: [],
            chainChanged: [],
            connect: [],
            disconnect: [],
            pendingTransaction: [],
            auth_rpcRequest: [],
            auth_rpcSuccess: [],
            auth_rpcError: []
        };
    }
    on(event, listener) {
        this.listeners[event].push(listener);
    }
    removeListener(event, listener) {
        this.listeners[event] = this.listeners[event].filter((l)=>l !== listener);
    }
    emit(event, data) {
        this.listeners[event].forEach((listener)=>listener(data));
    }
}


class $dc5c0c0499becc6d$export$87091915187a1a85 extends (0, $913120838350aaba$export$72b040f461a56853) {
    constructor(params){
        super();
        this.id = (0, $b3v9s.ConstantsUtil).CONNECTOR_ID.AUTH;
        this.name = (0, $b3v9s.ConstantsUtil).CONNECTOR_NAMES.AUTH;
        this.type = "AUTH";
        this.chain = (0, $b3v9s.ConstantsUtil).CHAIN.SOLANA;
        this.provider = params.w3mFrameProvider;
        this.requestedChains = params.chains;
        this.getActiveChain = params.getActiveChain;
    }
    get publicKey() {
        const address = this.provider.user?.address;
        return address ? new (0, $bccf75ed4dec0420$export$ca8b6604d6ce14de)(address) : undefined;
    }
    get chains() {
        const availableChainIds = this.provider.getAvailableChainIds();
        return this.requestedChains.filter((requestedChain)=>availableChainIds.includes(requestedChain.caipNetworkId));
    }
    async connect(params = {}) {
        const chainId = params.chainId || this.getActiveChain()?.id;
        const preferredAccountType = (0, $kfwQH.AccountController).state.preferredAccountTypes?.solana;
        await this.provider.connect({
            chainId: (0, $cb263ece615a278a$export$3ce495201451cda2)(chainId),
            socialUri: params.socialUri,
            preferredAccountType: preferredAccountType
        });
        if (!this.publicKey) throw new Error("Failed to connect to the wallet");
        this.emit("connect", this.publicKey);
        return this.publicKey.toBase58();
    }
    async disconnect() {
        await this.provider.disconnect();
        this.emit("disconnect", undefined);
    }
    async signMessage(message) {
        if (!this.publicKey) throw new Error("Wallet not connected");
        const result = await this.provider.request({
            method: "solana_signMessage",
            params: {
                message: (0, $4zT52.default).encode(message),
                pubkey: this.publicKey.toBase58()
            }
        });
        return (0, $4zT52.default).decode(result.signature);
    }
    async signTransaction(transaction) {
        const result = await this.provider.request({
            method: "solana_signTransaction",
            params: {
                transaction: this.serializeTransaction(transaction)
            }
        });
        const decodedTransaction = (0, $4zT52.default).decode(result.transaction);
        if ((0, $b2b60f05b08d2306$export$37ce1cc82e255d8)(transaction)) return (0, $bccf75ed4dec0420$export$232cc3f078dcc284).deserialize(decodedTransaction);
        return (0, $bccf75ed4dec0420$export$febc5573c75cefb0).from(decodedTransaction);
    }
    async signAndSendTransaction(transaction, options) {
        const serializedTransaction = this.serializeTransaction(transaction);
        const result = await this.provider.request({
            method: "solana_signAndSendTransaction",
            params: {
                transaction: serializedTransaction,
                options: options
            }
        });
        return result.signature;
    }
    async sendTransaction(transaction, connection, options) {
        const signedTransaction = await this.signTransaction(transaction);
        const signature = await connection.sendRawTransaction(signedTransaction.serialize(), options);
        return signature;
    }
    async signAllTransactions(transactions) {
        const result = await this.provider.request({
            method: "solana_signAllTransactions",
            params: {
                transactions: transactions.map((transaction)=>this.serializeTransaction(transaction))
            }
        });
        return result.transactions.map((encodedTransaction, index)=>{
            const transaction = transactions[index];
            if (!transaction) throw new Error("Invalid solana_signAllTransactions response");
            const decodedTransaction = (0, $4zT52.default).decode(encodedTransaction);
            if ((0, $b2b60f05b08d2306$export$37ce1cc82e255d8)(transaction)) return (0, $bccf75ed4dec0420$export$232cc3f078dcc284).deserialize(decodedTransaction);
            return (0, $bccf75ed4dec0420$export$febc5573c75cefb0).from(decodedTransaction);
        });
    }
    async request(args) {
        return this.provider.request({
            method: args.method,
            params: args.params
        });
    }
    async getAccounts() {
        if (!this.publicKey) return Promise.resolve([]);
        return Promise.resolve([
            {
                namespace: this.chain,
                address: this.publicKey.toBase58(),
                type: "eoa"
            }
        ]);
    }
    serializeTransaction(transaction) {
        return (0, $4zT52.default).encode(new Uint8Array(transaction.serialize({
            verifySignatures: false
        })));
    }
}



var $b3v9s = parcelRequire("b3v9s");




class $8cc4561b5b187a06$export$fb48caf2a73232f9 extends (0, $913120838350aaba$export$72b040f461a56853) {
    constructor(params){
        super();
        this.name = "Coinbase Wallet";
        this.id = (0, $8a4fed4bf263e097$export$fd35d6514357600).ConnectorExplorerIds[(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.COINBASE_SDK] || this.name;
        this.explorerId = (0, $8a4fed4bf263e097$export$fd35d6514357600).ConnectorExplorerIds[(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.COINBASE_SDK];
        this.type = "ANNOUNCED";
        this.imageUrl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8Y2lyY2xlIGN4PSI1MTIiIGN5PSI1MTIiIHI9IjUxMiIgZmlsbD0iIzAwNTJGRiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE1MiA1MTJDMTUyIDcxMC44MjMgMzEzLjE3NyA4NzIgNTEyIDg3MkM3MTAuODIzIDg3MiA4NzIgNzEwLjgyMyA4NzIgNTEyQzg3MiAzMTMuMTc3IDcxMC44MjMgMTUyIDUxMiAxNTJDMzEzLjE3NyAxNTIgMTUyIDMxMy4xNzcgMTUyIDUxMlpNNDIwIDM5NkM0MDYuNzQ1IDM5NiAzOTYgNDA2Ljc0NSAzOTYgNDIwVjYwNEMzOTYgNjE3LjI1NSA0MDYuNzQ1IDYyOCA0MjAgNjI4SDYwNEM2MTcuMjU1IDYyOCA2MjggNjE3LjI1NSA2MjggNjA0VjQyMEM2MjggNDA2Ljc0NSA2MTcuMjU1IDM5NiA2MDQgMzk2SDQyMFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
        this.chain = (0, $b3v9s.ConstantsUtil).CHAIN.SOLANA;
        this.provider = this;
        this.coinbase = params.provider;
        this.requestedChains = params.chains;
    }
    get chains() {
        return this.requestedChains.filter((chain)=>chain.id === (0, $f1509a8399dc02d3$export$ee6400bf8f8c2a0d).id);
    }
    get publicKey() {
        return this.coinbase.publicKey;
    }
    get imageId() {
        return (0, $8a4fed4bf263e097$export$fd35d6514357600).ConnectorImageIds[(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.COINBASE];
    }
    async connect() {
        try {
            await this.coinbase.connect();
            const account = this.getAccount(true);
            this.coinbase.emit("connect", this.coinbase.publicKey);
            this.emit("connect", account);
            return account.toBase58();
        } catch (error) {
            this.coinbase.emit("error", error);
            throw error;
        }
    }
    async disconnect() {
        await this.coinbase.disconnect();
        this.coinbase.emit("disconnect", undefined);
        this.emit("disconnect", undefined);
    }
    async signMessage(message) {
        const result = await this.coinbase.signMessage(message);
        return result.signature;
    }
    async signTransaction(transaction) {
        return this.coinbase.signTransaction(transaction);
    }
    async signAndSendTransaction(transaction, sendOptions) {
        const result = await this.coinbase.signAndSendTransaction(transaction, sendOptions);
        return result.signature;
    }
    async sendTransaction(transaction, connection, options) {
        const signedTransaction = await this.signTransaction(transaction);
        const signature = await connection.sendRawTransaction(signedTransaction.serialize(), options);
        return signature;
    }
    async signAllTransactions(transactions) {
        return await this.coinbase.signAllTransactions(transactions);
    }
    async request(_args) {
        return Promise.reject(new Error('The "request" method is not supported on Coinbase Wallet'));
    }
    async getAccounts() {
        const account = this.getAccount();
        if (!account) return Promise.resolve([]);
        return Promise.resolve([
            {
                namespace: this.chain,
                address: account.toBase58(),
                type: "eoa"
            }
        ]);
    }
    getAccount(required) {
        const account = this.coinbase.publicKey;
        if (required && !account) throw new Error("Not connected");
        return account;
    }
}




parcelRequire("5ID99");

var $4zT52 = parcelRequire("4zT52");


var $6WAiR = parcelRequire("6WAiR");


class $42b6b9349811affb$export$94c9eb73fc38ac50 extends Error {
    constructor(feature){
        super(`The wallet does not support the "${feature}" feature`);
    }
}
class $42b6b9349811affb$export$81828abbb75fba24 extends Error {
    constructor(method){
        super(`The method "${method}" is not supported by the wallet`);
    }
}




var $lewJ9 = parcelRequire("lewJ9");
var $d32bb1d4e95159e6$require$Buffer = $lewJ9.Buffer;
class $d32bb1d4e95159e6$export$12a0f739bdb07621 extends (0, $ffb539405861dea3$export$c456b2d327ac201f) {
    constructor({ provider: provider, chains: chains, getActiveChain: getActiveChain }){
        super({
            caipNetworks: chains,
            namespace: "solana",
            provider: provider
        });
        this.eventEmitter = new (0, $913120838350aaba$export$72b040f461a56853)();
        this.emit = this.eventEmitter.emit.bind(this.eventEmitter);
        this.on = this.eventEmitter.on.bind(this.eventEmitter);
        this.removeListener = this.eventEmitter.removeListener.bind(this.eventEmitter);
        this.getActiveChain = getActiveChain;
    }
    get session() {
        return this.provider.session;
    }
    get chains() {
        return this.sessionChains.map((sessionChainId)=>{
            let chainId = sessionChainId;
            if (chainId === (0, $e18f15cebe1ef482$export$c1784c327b5e3fac).CHAIN_IDS.Deprecated_Mainnet) chainId = (0, $e18f15cebe1ef482$export$c1784c327b5e3fac).CHAIN_IDS.Mainnet;
            else if (chainId === (0, $e18f15cebe1ef482$export$c1784c327b5e3fac).CHAIN_IDS.Deprecated_Devnet) chainId = (0, $e18f15cebe1ef482$export$c1784c327b5e3fac).CHAIN_IDS.Devnet;
            return this.caipNetworks.find((chain)=>chain.caipNetworkId === chainId);
        }).filter(Boolean);
    }
    get publicKey() {
        const account = this.getAccount(false);
        if (account) return new (0, $bccf75ed4dec0420$export$ca8b6604d6ce14de)(account.publicKey);
        return undefined;
    }
    async connect() {
        await super.connectWalletConnect();
        const account = this.getAccount(true);
        this.emit("connect", new (0, $bccf75ed4dec0420$export$ca8b6604d6ce14de)(account.publicKey));
        return account.address;
    }
    async disconnect() {
        await super.disconnect();
        this.emit("disconnect", undefined);
    }
    async signMessage(message) {
        this.checkIfMethodIsSupported("solana_signMessage");
        const signedMessage = await this.internalRequest("solana_signMessage", {
            message: (0, $4zT52.default).encode(message),
            pubkey: this.getAccount(true).address
        });
        return (0, $4zT52.default).decode(signedMessage.signature);
    }
    async signTransaction(transaction) {
        this.checkIfMethodIsSupported("solana_signTransaction");
        const serializedTransaction = this.serializeTransaction(transaction);
        const result = await this.internalRequest("solana_signTransaction", {
            transaction: serializedTransaction,
            pubkey: this.getAccount(true).address,
            ...this.getRawRPCParams(transaction)
        });
        if ("signature" in result) {
            const decoded = (0, $4zT52.default).decode(result.signature);
            transaction.addSignature(new (0, $bccf75ed4dec0420$export$ca8b6604d6ce14de)(this.getAccount(true).publicKey), $d32bb1d4e95159e6$require$Buffer.from(decoded));
            return transaction;
        }
        const decodedTransaction = $d32bb1d4e95159e6$require$Buffer.from(result.transaction, "base64");
        if ((0, $b2b60f05b08d2306$export$37ce1cc82e255d8)(transaction)) return (0, $bccf75ed4dec0420$export$232cc3f078dcc284).deserialize(new Uint8Array(decodedTransaction));
        return (0, $bccf75ed4dec0420$export$febc5573c75cefb0).from(decodedTransaction);
    }
    async signAndSendTransaction(transaction, sendOptions) {
        this.checkIfMethodIsSupported("solana_signAndSendTransaction");
        const serializedTransaction = this.serializeTransaction(transaction);
        const result = await this.internalRequest("solana_signAndSendTransaction", {
            transaction: serializedTransaction,
            pubkey: this.getAccount(true).address,
            sendOptions: sendOptions
        });
        this.emit("pendingTransaction", undefined);
        return result.signature;
    }
    async sendTransaction(transaction, connection, options) {
        const signedTransaction = await this.signTransaction(transaction);
        const signature = await connection.sendRawTransaction(signedTransaction.serialize(), options);
        this.emit("pendingTransaction", undefined);
        return signature;
    }
    async signAllTransactions(transactions) {
        try {
            this.checkIfMethodIsSupported("solana_signAllTransactions");
            const result = await this.internalRequest("solana_signAllTransactions", {
                transactions: transactions.map((transaction)=>this.serializeTransaction(transaction))
            });
            return result.transactions.map((serializedTransaction, index)=>{
                const transaction = transactions[index];
                if (!transaction) throw new Error("Invalid transactions response");
                const decodedTransaction = $d32bb1d4e95159e6$require$Buffer.from(serializedTransaction, "base64");
                if ((0, $b2b60f05b08d2306$export$37ce1cc82e255d8)(transaction)) return (0, $bccf75ed4dec0420$export$232cc3f078dcc284).deserialize(new Uint8Array(decodedTransaction));
                this.emit("pendingTransaction", undefined);
                return (0, $bccf75ed4dec0420$export$febc5573c75cefb0).from(decodedTransaction);
            });
        } catch (error) {
            if (error instanceof (0, $42b6b9349811affb$export$81828abbb75fba24)) {
                const signedTransactions = [];
                for (const transaction of transactions)signedTransactions.push(await this.signTransaction(transaction));
                return signedTransactions;
            }
            throw error;
        }
    }
    request(args) {
        return this.internalRequest(args.method, args.params);
    }
    async getAccounts() {
        const accounts = this.session?.namespaces["solana"]?.accounts || [];
        return Promise.resolve(accounts.map((account)=>({
                namespace: this.chain,
                address: (0, $6WAiR.ParseUtil).parseCaipAddress(account).address,
                type: "eoa"
            })));
    }
    internalRequest(method, params) {
        const chain = this.chains.find((c)=>this.getActiveChain()?.id === c.id);
        let chainId = chain?.caipNetworkId;
        switch(chainId){
            case (0, $e18f15cebe1ef482$export$c1784c327b5e3fac).CHAIN_IDS.Mainnet:
                if (!this.sessionChains.includes((0, $e18f15cebe1ef482$export$c1784c327b5e3fac).CHAIN_IDS.Mainnet)) chainId = (0, $e18f15cebe1ef482$export$c1784c327b5e3fac).CHAIN_IDS.Deprecated_Mainnet;
                break;
            case (0, $e18f15cebe1ef482$export$c1784c327b5e3fac).CHAIN_IDS.Devnet:
                if (!this.sessionChains.includes((0, $e18f15cebe1ef482$export$c1784c327b5e3fac).CHAIN_IDS.Devnet)) chainId = (0, $e18f15cebe1ef482$export$c1784c327b5e3fac).CHAIN_IDS.Deprecated_Devnet;
                break;
            default:
                break;
        }
        return this.provider?.request({
            method: method,
            params: params
        }, chainId);
    }
    get sessionChains() {
        return (0, $6c592072e95901b7$export$4267940df2f33c5a).getChainsFromNamespaces(this.session?.namespaces);
    }
    serializeTransaction(transaction) {
        return $d32bb1d4e95159e6$require$Buffer.from(new Uint8Array(transaction.serialize({
            verifySignatures: false
        }))).toString("base64");
    }
    getAccount(required) {
        const account = this.session?.namespaces["solana"]?.accounts[0];
        if (!account) {
            if (required) throw new Error("Account not found");
            return undefined;
        }
        const address = account.split(":")[2];
        if (!address) {
            if (required) throw new Error("Address not found");
            return undefined;
        }
        return {
            address: address,
            publicKey: (0, $4zT52.default).decode(address)
        };
    }
    getRawRPCParams(transaction) {
        if ((0, $b2b60f05b08d2306$export$37ce1cc82e255d8)(transaction)) return {};
        return {
            feePayer: transaction.feePayer?.toBase58() ?? "",
            instructions: transaction.instructions.map((instruction)=>({
                    data: (0, $4zT52.default).encode(new Uint8Array(instruction.data)),
                    keys: instruction.keys.map((key)=>({
                            isWritable: key.isWritable,
                            isSigner: key.isSigner,
                            pubkey: key.pubkey.toBase58()
                        })),
                    programId: instruction.programId.toBase58()
                })),
            recentBlockhash: transaction.recentBlockhash ?? ""
        };
    }
    checkIfMethodIsSupported(method) {
        if (!this.session?.namespaces["solana"]?.methods.includes(method)) throw new (0, $42b6b9349811affb$export$81828abbb75fba24)(method);
    }
}



var $7zrdF = parcelRequire("7zrdF");

var $eFS1l = parcelRequire("eFS1l");
const $c9f06e5e88a456d8$var$state = (0, $7zrdF.proxy)({
    connection: null
});
const $c9f06e5e88a456d8$export$3893a42f67201971 = {
    state: $c9f06e5e88a456d8$var$state,
    subscribeKey (key, callback) {
        return (0, $eFS1l.subscribeKey)($c9f06e5e88a456d8$var$state, key, callback);
    },
    subscribe (callback) {
        return (0, $7zrdF.subscribe)($c9f06e5e88a456d8$var$state, ()=>callback($c9f06e5e88a456d8$var$state));
    },
    setConnection (connection) {
        $c9f06e5e88a456d8$var$state.connection = (0, $7zrdF.ref)(connection);
    }
};



const $b0cd5b36eac3ae00$var$COMPUTE_BUDGET_CONSTANTS = {
    UNIT_PRICE_MICRO_LAMPORTS: 20000000,
    UNIT_LIMIT: 500
};
async function $b0cd5b36eac3ae00$export$feb28ae5b5d20a9d({ provider: provider, to: to, value: value, connection: connection }) {
    if (!provider.publicKey) throw Error("No public key found");
    const toPubkey = new (0, $bccf75ed4dec0420$export$ca8b6604d6ce14de)(to);
    const lamports = Math.floor(value * (0, $bccf75ed4dec0420$export$5f6a2f2669741bbe));
    const { blockhash: blockhash, lastValidBlockHeight: lastValidBlockHeight } = await connection.getLatestBlockhash();
    const instructions = [
        (0, $bccf75ed4dec0420$export$11585db5942bcdb7).setComputeUnitPrice({
            microLamports: $b0cd5b36eac3ae00$var$COMPUTE_BUDGET_CONSTANTS.UNIT_PRICE_MICRO_LAMPORTS
        }),
        (0, $bccf75ed4dec0420$export$11585db5942bcdb7).setComputeUnitLimit({
            units: $b0cd5b36eac3ae00$var$COMPUTE_BUDGET_CONSTANTS.UNIT_LIMIT
        }),
        (0, $bccf75ed4dec0420$export$d8c4e17726848113).transfer({
            fromPubkey: provider.publicKey,
            toPubkey: toPubkey,
            lamports: lamports
        })
    ];
    return new (0, $bccf75ed4dec0420$export$febc5573c75cefb0)({
        feePayer: provider.publicKey,
        blockhash: blockhash,
        lastValidBlockHeight: lastValidBlockHeight
    }).add(...instructions);
}


/** Name of the feature. */ const $efe2922d772e992f$export$dd64f32469f35f81 = "solana:signAndSendTransaction";

/** Name of the feature. */ const $26d98d2430867429$export$54187c3796d0ecb = "solana:signTransaction";


/** Name of the feature. */ const $d255eaf3cad225e9$export$cc68487eeb93b1d4 = "standard:connect";
const $d255eaf3cad225e9$export$59e6910693f047c2 = $d255eaf3cad225e9$export$cc68487eeb93b1d4;

/** Name of the feature. */ const $aea08b9dc648afcf$export$5296443ca9e9fa0f = "standard:events";
const $aea08b9dc648afcf$export$ada873a34909da65 = $aea08b9dc648afcf$export$5296443ca9e9fa0f;


function $0e2fa8d378dd4655$export$de6946e7c2c87e9a(wallet) {
    return (0, $d255eaf3cad225e9$export$cc68487eeb93b1d4) in wallet.features && (0, $aea08b9dc648afcf$export$5296443ca9e9fa0f) in wallet.features && ((0, $efe2922d772e992f$export$dd64f32469f35f81) in wallet.features || (0, $26d98d2430867429$export$54187c3796d0ecb) in wallet.features);
}


var $58abfe4577c72634$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $58abfe4577c72634$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $58abfe4577c72634$var$_AppReadyEvent_detail;
let $58abfe4577c72634$var$wallets = undefined;
const $58abfe4577c72634$var$registeredWalletsSet = new Set();
function $58abfe4577c72634$var$addRegisteredWallet(wallet) {
    $58abfe4577c72634$var$cachedWalletsArray = undefined;
    $58abfe4577c72634$var$registeredWalletsSet.add(wallet);
}
function $58abfe4577c72634$var$removeRegisteredWallet(wallet) {
    $58abfe4577c72634$var$cachedWalletsArray = undefined;
    $58abfe4577c72634$var$registeredWalletsSet.delete(wallet);
}
const $58abfe4577c72634$var$listeners = {};
function $58abfe4577c72634$export$ac4d188b6eef3eb7() {
    if ($58abfe4577c72634$var$wallets) return $58abfe4577c72634$var$wallets;
    $58abfe4577c72634$var$wallets = Object.freeze({
        register: $58abfe4577c72634$var$register,
        get: $58abfe4577c72634$var$get,
        on: $58abfe4577c72634$var$on
    });
    if (typeof window === "undefined") return $58abfe4577c72634$var$wallets;
    const api = Object.freeze({
        register: $58abfe4577c72634$var$register
    });
    try {
        window.addEventListener("wallet-standard:register-wallet", ({ detail: callback })=>callback(api));
    } catch (error) {
        console.error("wallet-standard:register-wallet event listener could not be added\n", error);
    }
    try {
        window.dispatchEvent(new $58abfe4577c72634$var$AppReadyEvent(api));
    } catch (error) {
        console.error("wallet-standard:app-ready event could not be dispatched\n", error);
    }
    return $58abfe4577c72634$var$wallets;
}
function $58abfe4577c72634$var$register(...wallets) {
    // Filter out wallets that have already been registered.
    // This prevents the same wallet from being registered twice, but it also prevents wallets from being
    // unregistered by reusing a reference to the wallet to obtain the unregister function for it.
    wallets = wallets.filter((wallet)=>!$58abfe4577c72634$var$registeredWalletsSet.has(wallet));
    // If there are no new wallets to register, just return a no-op unregister function.
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!wallets.length) return ()=>{};
    wallets.forEach((wallet)=>$58abfe4577c72634$var$addRegisteredWallet(wallet));
    $58abfe4577c72634$var$listeners["register"]?.forEach((listener)=>$58abfe4577c72634$var$guard(()=>listener(...wallets)));
    // Return a function that unregisters the registered wallets.
    return function unregister() {
        wallets.forEach((wallet)=>$58abfe4577c72634$var$removeRegisteredWallet(wallet));
        $58abfe4577c72634$var$listeners["unregister"]?.forEach((listener)=>$58abfe4577c72634$var$guard(()=>listener(...wallets)));
    };
}
let $58abfe4577c72634$var$cachedWalletsArray;
function $58abfe4577c72634$var$get() {
    if (!$58abfe4577c72634$var$cachedWalletsArray) $58abfe4577c72634$var$cachedWalletsArray = [
        ...$58abfe4577c72634$var$registeredWalletsSet
    ];
    return $58abfe4577c72634$var$cachedWalletsArray;
}
function $58abfe4577c72634$var$on(event, listener) {
    $58abfe4577c72634$var$listeners[event]?.push(listener) || ($58abfe4577c72634$var$listeners[event] = [
        listener
    ]);
    // Return a function that removes the event listener.
    return function off() {
        $58abfe4577c72634$var$listeners[event] = $58abfe4577c72634$var$listeners[event]?.filter((existingListener)=>listener !== existingListener);
    };
}
function $58abfe4577c72634$var$guard(callback) {
    try {
        callback();
    } catch (error) {
        console.error(error);
    }
}
class $58abfe4577c72634$var$AppReadyEvent extends Event {
    get detail() {
        return $58abfe4577c72634$var$__classPrivateFieldGet(this, $58abfe4577c72634$var$_AppReadyEvent_detail, "f");
    }
    get type() {
        return "wallet-standard:app-ready";
    }
    constructor(api){
        super("wallet-standard:app-ready", {
            bubbles: false,
            cancelable: false,
            composed: false
        });
        $58abfe4577c72634$var$_AppReadyEvent_detail.set(this, void 0);
        $58abfe4577c72634$var$__classPrivateFieldSet(this, $58abfe4577c72634$var$_AppReadyEvent_detail, api, "f");
    }
    /** @deprecated */ preventDefault() {
        throw new Error("preventDefault cannot be called");
    }
    /** @deprecated */ stopImmediatePropagation() {
        throw new Error("stopImmediatePropagation cannot be called");
    }
    /** @deprecated */ stopPropagation() {
        throw new Error("stopPropagation cannot be called");
    }
}
$58abfe4577c72634$var$_AppReadyEvent_detail = new WeakMap();
function $58abfe4577c72634$export$2194deb72a59836d() {
    if ($58abfe4577c72634$var$wallets) return $58abfe4577c72634$var$wallets;
    $58abfe4577c72634$var$wallets = $58abfe4577c72634$export$ac4d188b6eef3eb7();
    if (typeof window === "undefined") return $58abfe4577c72634$var$wallets;
    const callbacks = window.navigator.wallets || [];
    if (!Array.isArray(callbacks)) {
        console.error("window.navigator.wallets is not an array");
        return $58abfe4577c72634$var$wallets;
    }
    const { register: register } = $58abfe4577c72634$var$wallets;
    const push = (...callbacks)=>callbacks.forEach((callback)=>$58abfe4577c72634$var$guard(()=>callback({
                    register: register
                })));
    try {
        Object.defineProperty(window.navigator, "wallets", {
            value: Object.freeze({
                push: push
            })
        });
    } catch (error) {
        console.error("window.navigator.wallets could not be set");
        return $58abfe4577c72634$var$wallets;
    }
    push(...callbacks);
    return $58abfe4577c72634$var$wallets;
}


class $c6bcb286760f6ed9$export$f46ec6f9dba8711d extends Error {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(message, error){
        super(message);
        this.error = error;
    }
}
class $c6bcb286760f6ed9$export$d65db264eda99cd7 extends $c6bcb286760f6ed9$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletNotReadyError";
    }
}
class $c6bcb286760f6ed9$export$9a551f94af9b0bf8 extends $c6bcb286760f6ed9$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletLoadError";
    }
}
class $c6bcb286760f6ed9$export$9525019988612a5e extends $c6bcb286760f6ed9$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletConfigError";
    }
}
class $c6bcb286760f6ed9$export$38f21f1c810261c7 extends $c6bcb286760f6ed9$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletConnectionError";
    }
}
class $c6bcb286760f6ed9$export$bf7028c52ebda81e extends $c6bcb286760f6ed9$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletDisconnectedError";
    }
}
class $c6bcb286760f6ed9$export$92e2b26fad5723ee extends $c6bcb286760f6ed9$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletDisconnectionError";
    }
}
class $c6bcb286760f6ed9$export$cd6fa2f8e2a8a612 extends $c6bcb286760f6ed9$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletAccountError";
    }
}
class $c6bcb286760f6ed9$export$735bef3bfb0f2c86 extends $c6bcb286760f6ed9$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletPublicKeyError";
    }
}
class $c6bcb286760f6ed9$export$c2957028686b1575 extends $c6bcb286760f6ed9$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletKeypairError";
    }
}
class $c6bcb286760f6ed9$export$313d299817c74896 extends $c6bcb286760f6ed9$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletNotConnectedError";
    }
}
class $c6bcb286760f6ed9$export$769332ac3f90f46c extends $c6bcb286760f6ed9$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSendTransactionError";
    }
}
class $c6bcb286760f6ed9$export$96f177062fdd8180 extends $c6bcb286760f6ed9$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSignTransactionError";
    }
}
class $c6bcb286760f6ed9$export$2622c1721bbd4b17 extends $c6bcb286760f6ed9$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSignMessageError";
    }
}
class $c6bcb286760f6ed9$export$a4c7d3c66e3cdd6c extends $c6bcb286760f6ed9$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSignInError";
    }
}
class $c6bcb286760f6ed9$export$ec3efbdc71ef5c8c extends $c6bcb286760f6ed9$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletTimeoutError";
    }
}
class $c6bcb286760f6ed9$export$c87b9320dc154c95 extends $c6bcb286760f6ed9$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletWindowBlockedError";
    }
}
class $c6bcb286760f6ed9$export$d02b2d00a97edcea extends $c6bcb286760f6ed9$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletWindowClosedError";
    }
}


/** Name of the feature. */ const $acd1a5799842b2cf$export$22c7939a38084172 = "solana:signMessage";


/**
 * TODO: docs
 */ function $e729ec90efcd4ccc$export$430b2bce150d42d4(commitment) {
    switch(commitment){
        case "processed":
        case "confirmed":
        case "finalized":
        case undefined:
            return commitment;
        case "recent":
            return "processed";
        case "single":
        case "singleGossip":
            return "confirmed";
        case "max":
        case "root":
            return "finalized";
        default:
            return undefined;
    }
}



/** Name of the feature. */ const $2480898b57cad359$export$38dbd4bbb9b696e6 = "standard:disconnect";
const $2480898b57cad359$export$9e282393ab352bcd = $2480898b57cad359$export$38dbd4bbb9b696e6;



var $4zT52 = parcelRequire("4zT52");

var $b3v9s = parcelRequire("b3v9s");



const $da4dda07a0349e23$export$f8864bf53bd96f6a = {
    "solana:mainnet": (0, $f1509a8399dc02d3$export$ee6400bf8f8c2a0d),
    "solana:testnet": (0, $2b1a7288ee6d92fd$export$df5e497f95906b2a),
    "solana:devnet": (0, $1ffbd897ba4d115b$export$7e6894daae5bd681)
};




class $8344bd58c8e0c662$export$2624e386166f774e extends (0, $913120838350aaba$export$72b040f461a56853) {
    constructor({ wallet: wallet, getActiveChain: getActiveChain, requestedChains: requestedChains }){
        super();
        this.chain = (0, $b3v9s.ConstantsUtil).CHAIN.SOLANA;
        this.provider = this;
        this.wallet = wallet;
        this.getActiveChain = getActiveChain;
        this.requestedChains = requestedChains;
        this.bindEvents();
    }
    get id() {
        const name = this.name;
        return (0, $8a4fed4bf263e097$export$fd35d6514357600).ConnectorExplorerIds[name] || name;
    }
    get name() {
        if (this.wallet.name === "Trust") return "Trust Wallet";
        return this.wallet.name;
    }
    get type() {
        return "ANNOUNCED";
    }
    get explorerId() {
        return (0, $8a4fed4bf263e097$export$fd35d6514357600).ConnectorExplorerIds[this.name];
    }
    get publicKey() {
        const account = this.getAccount(false);
        if (account) return new (0, $bccf75ed4dec0420$export$ca8b6604d6ce14de)(account.publicKey);
        return undefined;
    }
    get imageUrl() {
        return this.wallet.icon;
    }
    get chains() {
        return this.wallet.chains.map((chainId)=>this.requestedChains.find((chain)=>chain.id === chainId || chain.id === (0, $da4dda07a0349e23$export$f8864bf53bd96f6a)[chainId]?.id)).filter(Boolean);
    }
    async connect() {
        const feature = this.getWalletFeature((0, $d255eaf3cad225e9$export$cc68487eeb93b1d4));
        await feature.connect();
        const account = this.getAccount(true);
        const publicKey = new (0, $bccf75ed4dec0420$export$ca8b6604d6ce14de)(account.publicKey);
        this.emit("connect", publicKey);
        return account.address;
    }
    async disconnect() {
        const feature = this.getWalletFeature((0, $2480898b57cad359$export$38dbd4bbb9b696e6));
        await feature.disconnect();
        this.emit("disconnect", undefined);
    }
    async signMessage(message) {
        const feature = this.getWalletFeature((0, $acd1a5799842b2cf$export$22c7939a38084172));
        const account = this.getAccount(true);
        const [result] = await feature.signMessage({
            message: message,
            account: account
        });
        if (!result) throw new (0, $c6bcb286760f6ed9$export$2622c1721bbd4b17)("Empty result");
        return result.signature;
    }
    async signTransaction(transaction) {
        const feature = this.getWalletFeature((0, $26d98d2430867429$export$54187c3796d0ecb));
        const account = this.getAccount(true);
        const serializedTransaction = this.serializeTransaction(transaction);
        const [result] = await feature.signTransaction({
            account: account,
            transaction: new Uint8Array(serializedTransaction),
            chain: this.getActiveChainName()
        });
        if (!result) throw new (0, $c6bcb286760f6ed9$export$96f177062fdd8180)("Empty result");
        this.emit("pendingTransaction", undefined);
        if ((0, $b2b60f05b08d2306$export$37ce1cc82e255d8)(transaction)) return (0, $bccf75ed4dec0420$export$232cc3f078dcc284).deserialize(result.signedTransaction);
        return (0, $bccf75ed4dec0420$export$febc5573c75cefb0).from(result.signedTransaction);
    }
    async signAndSendTransaction(transaction, sendOptions) {
        const feature = this.getWalletFeature((0, $efe2922d772e992f$export$dd64f32469f35f81));
        const account = this.getAccount(true);
        const [result] = await feature.signAndSendTransaction({
            account: account,
            transaction: new Uint8Array(this.serializeTransaction(transaction)),
            options: {
                ...sendOptions,
                preflightCommitment: (0, $e729ec90efcd4ccc$export$430b2bce150d42d4)(sendOptions?.preflightCommitment)
            },
            chain: this.getActiveChainName()
        });
        if (!result) throw new (0, $c6bcb286760f6ed9$export$769332ac3f90f46c)("Empty result");
        this.emit("pendingTransaction", undefined);
        return (0, $4zT52.default).encode(result.signature);
    }
    async sendTransaction(transaction, connection, options) {
        const signedTransaction = await this.signTransaction(transaction);
        const signature = await connection.sendRawTransaction(signedTransaction.serialize(), options);
        return signature;
    }
    async signAllTransactions(transactions) {
        const feature = this.getWalletFeature((0, $26d98d2430867429$export$54187c3796d0ecb));
        const account = this.getAccount(true);
        const chain = this.getActiveChainName();
        const result = await feature.signTransaction(...transactions.map((transaction)=>({
                transaction: new Uint8Array(this.serializeTransaction(transaction)),
                account: account,
                chain: chain
            })));
        return result.map(({ signedTransaction: signedTransaction }, index)=>{
            const transaction = transactions[index];
            if (!transaction) throw new (0, $c6bcb286760f6ed9$export$96f177062fdd8180)("Invalid transaction signature response");
            this.emit("pendingTransaction", undefined);
            if ((0, $b2b60f05b08d2306$export$37ce1cc82e255d8)(transaction)) return (0, $bccf75ed4dec0420$export$232cc3f078dcc284).deserialize(signedTransaction);
            return (0, $bccf75ed4dec0420$export$febc5573c75cefb0).from(signedTransaction);
        });
    }
    async request(_args) {
        return Promise.reject(new (0, $42b6b9349811affb$export$94c9eb73fc38ac50)("request"));
    }
    async getAccounts() {
        return Promise.resolve(this.wallet.accounts.map((account)=>({
                namespace: this.chain,
                address: account.address,
                type: "eoa"
            })));
    }
    serializeTransaction(transaction) {
        return transaction.serialize({
            verifySignatures: false
        });
    }
    getAccount(required) {
        const account = this.wallet.accounts[0];
        if (required && !account) throw new (0, $c6bcb286760f6ed9$export$cd6fa2f8e2a8a612)();
        return account;
    }
    getWalletFeature(feature) {
        if (!(feature in this.wallet.features)) throw new (0, $42b6b9349811affb$export$94c9eb73fc38ac50)(feature);
        return this.wallet.features[feature];
    }
    getActiveChainName() {
        const entry = Object.entries((0, $da4dda07a0349e23$export$f8864bf53bd96f6a)).find(([, chain])=>chain.id === this.getActiveChain()?.id);
        if (!entry) throw new Error("Invalid chain id");
        return entry[0];
    }
    bindEvents() {
        const features = this.getWalletFeature((0, $aea08b9dc648afcf$export$5296443ca9e9fa0f));
        features.on("change", (params)=>{
            if (params.accounts) {
                const account = params.accounts[0];
                if (account) this.emit("accountsChanged", new (0, $bccf75ed4dec0420$export$ca8b6604d6ce14de)(account.publicKey));
            }
        });
    }
}


const { get: $0e1c492db084c624$var$get, on: $0e1c492db084c624$var$on } = (0, $58abfe4577c72634$export$ac4d188b6eef3eb7)();
let $0e1c492db084c624$var$standardAdapters = [];
function $0e1c492db084c624$export$738456d93eced2bd(requestedChains, getActiveChain, callback) {
    const listeners = [
        $0e1c492db084c624$var$on("register", (...wallets)=>{
            $0e1c492db084c624$var$standardAdapters = [
                ...$0e1c492db084c624$var$standardAdapters,
                ...$0e1c492db084c624$var$wrapWalletsWithAdapters(wallets, requestedChains, getActiveChain)
            ];
            callback(...$0e1c492db084c624$var$standardAdapters);
        }),
        $0e1c492db084c624$var$on("unregister", (...wallets)=>{
            $0e1c492db084c624$var$standardAdapters = $0e1c492db084c624$var$standardAdapters.filter((standardAdapter)=>wallets.some((wallet)=>wallet.name === standardAdapter.wallet.name));
            callback(...$0e1c492db084c624$var$standardAdapters);
        })
    ];
    $0e1c492db084c624$var$standardAdapters = $0e1c492db084c624$var$wrapWalletsWithAdapters($0e1c492db084c624$var$get(), requestedChains, getActiveChain);
    callback(...$0e1c492db084c624$var$standardAdapters);
    return ()=>listeners.forEach((off)=>off());
}
function $0e1c492db084c624$var$wrapWalletsWithAdapters(wallets, requestedChains, getActiveChain) {
    return wallets.filter((0, $0e2fa8d378dd4655$export$de6946e7c2c87e9a)).map((wallet)=>new (0, $8344bd58c8e0c662$export$2624e386166f774e)({
            wallet: wallet,
            requestedChains: requestedChains,
            getActiveChain: getActiveChain
        }));
}


class $8c7193b741506980$export$5773b6c43b66f81f extends (0, $047ef4420d4ccb1d$export$993f0e61ab122f72) {
    constructor(options = {}){
        super({
            adapterType: (0, $b3v9s.ConstantsUtil).ADAPTER_TYPES.SOLANA,
            namespace: (0, $b3v9s.ConstantsUtil).CHAIN.SOLANA
        });
        this.balancePromises = {};
        this.providerHandlers = null;
        this.connectionSettings = options.connectionSettings || "confirmed";
        this.wallets = options.wallets;
    }
    construct(params) {
        super.construct(params);
        const connectedCaipNetwork = (0, $bc5dy.StorageUtil).getActiveCaipNetworkId();
        const caipNetwork = params.networks?.find((n)=>n.caipNetworkId === connectedCaipNetwork) || params.networks?.[0];
        const rpcUrl = caipNetwork?.rpcUrls.default.http[0];
        if (rpcUrl) (0, $c9f06e5e88a456d8$export$3893a42f67201971).setConnection(new (0, $bccf75ed4dec0420$export$98b66c25bb38499d)(rpcUrl, this.connectionSettings));
    }
    setAuthProvider(w3mFrameProvider) {
        this.addConnector(new (0, $dc5c0c0499becc6d$export$87091915187a1a85)({
            w3mFrameProvider: w3mFrameProvider,
            getActiveChain: ()=>(0, $gD0RX.ChainController).getCaipNetworkByNamespace(this.namespace),
            chains: this.getCaipNetworks()
        }));
    }
    syncConnectors(options, appKit) {
        if (!options.projectId) (0, $5PQZs.AlertController).open((0, $6rTj5.ErrorUtil).ALERT_ERRORS.PROJECT_ID_NOT_CONFIGURED, "error");
        const getActiveChain = ()=>appKit.getCaipNetwork(this.namespace);
        if ((0, $lpmCO.CoreHelperUtil).isClient() && "coinbaseSolana" in window) this.addConnector(new (0, $8cc4561b5b187a06$export$fb48caf2a73232f9)({
            provider: window.coinbaseSolana,
            chains: this.getCaipNetworks(),
            getActiveChain: getActiveChain
        }));
        (0, $0e1c492db084c624$export$738456d93eced2bd)(this.getCaipNetworks(), getActiveChain, this.addConnector.bind(this));
    }
    async writeContract() {
        return Promise.resolve({
            hash: ""
        });
    }
    async getCapabilities() {
        return Promise.resolve({});
    }
    async grantPermissions() {
        return Promise.resolve({});
    }
    async revokePermissions() {
        return Promise.resolve("0x");
    }
    async walletGetAssets(_params) {
        return Promise.resolve({});
    }
    async getAccounts(params) {
        const connector = this.connectors.find((c)=>c.id === params.id);
        if (!connector) return {
            accounts: []
        };
        return {
            accounts: await connector.getAccounts()
        };
    }
    async signMessage(params) {
        const provider = params.provider;
        if (!provider) throw new Error("connectionControllerClient:signMessage - provider is undefined");
        const signature = await provider.signMessage(new TextEncoder().encode(params.message));
        return {
            signature: (0, $4zT52.default).encode(signature)
        };
    }
    async estimateGas(params) {
        const connection = (0, $c9f06e5e88a456d8$export$3893a42f67201971).state.connection;
        if (!connection || !params.provider) throw new Error("Connection is not set");
        const transaction = await (0, $b0cd5b36eac3ae00$export$feb28ae5b5d20a9d)({
            provider: params.provider,
            connection: connection,
            to: "11111111111111111111111111111111",
            value: 1
        });
        const fee = await transaction.getEstimatedFee(connection);
        return {
            gas: BigInt(fee || 0)
        };
    }
    async sendTransaction(params) {
        const connection = (0, $c9f06e5e88a456d8$export$3893a42f67201971).state.connection;
        if (!connection || !params.provider) throw new Error("Connection is not set");
        const provider = params.provider;
        const transaction = await (0, $b0cd5b36eac3ae00$export$feb28ae5b5d20a9d)({
            provider: provider,
            connection: connection,
            to: params.to,
            value: Number.isNaN(Number(params.value)) ? 0 : Number(params.value)
        });
        const result = await provider.sendTransaction(transaction, connection);
        await new Promise((resolve)=>{
            const interval = setInterval(async ()=>{
                const status = await connection.getSignatureStatus(result);
                if (status?.value) {
                    clearInterval(interval);
                    resolve();
                }
            }, 1000);
        });
        return {
            hash: result
        };
    }
    parseUnits() {
        return 0n;
    }
    formatUnits() {
        return "";
    }
    async connect(params) {
        const connector = this.connectors.find((c)=>c.id === params.id);
        if (!connector) throw new Error("Provider not found");
        const rpcUrl = params.rpcUrl || this.getCaipNetworks()?.find((n)=>n.id === params.chainId)?.rpcUrls.default.http[0];
        if (!rpcUrl) throw new Error(`RPC URL not found for chainId: ${params.chainId}`);
        const address = await connector.connect({
            chainId: params.chainId,
            socialUri: params.socialUri
        });
        this.listenProviderEvents(connector);
        (0, $c9f06e5e88a456d8$export$3893a42f67201971).setConnection(new (0, $bccf75ed4dec0420$export$98b66c25bb38499d)(rpcUrl, this.connectionSettings));
        this.emit("accountChanged", {
            address: address,
            chainId: params.chainId
        });
        return {
            id: connector.id,
            address: address,
            chainId: params.chainId,
            provider: connector,
            type: connector.type
        };
    }
    async getBalance(params) {
        const address = params.address;
        const caipNetwork = this.getCaipNetworks()?.find((network)=>network.id === params.chainId);
        if (!address) return Promise.resolve({
            balance: "0.00",
            symbol: "SOL"
        });
        const connection = new (0, $bccf75ed4dec0420$export$98b66c25bb38499d)(caipNetwork?.rpcUrls?.default?.http?.[0], this.connectionSettings);
        const caipAddress = `${caipNetwork?.caipNetworkId}:${params.address}`;
        const cachedPromise = this.balancePromises[caipAddress];
        if (cachedPromise) return cachedPromise;
        const cachedBalance = (0, $bc5dy.StorageUtil).getNativeBalanceCacheForCaipAddress(caipAddress);
        if (cachedBalance) return {
            balance: cachedBalance.balance,
            symbol: cachedBalance.symbol
        };
        this.balancePromises[caipAddress] = new Promise(async (resolve)=>{
            try {
                const balance = await connection.getBalance(new (0, $bccf75ed4dec0420$export$ca8b6604d6ce14de)(address));
                const formattedBalance = (balance / (0, $e18f15cebe1ef482$export$c1784c327b5e3fac).LAMPORTS_PER_SOL).toString();
                (0, $bc5dy.StorageUtil).updateNativeBalanceCache({
                    caipAddress: caipAddress,
                    balance: formattedBalance,
                    symbol: params.caipNetwork?.nativeCurrency.symbol || "SOL",
                    timestamp: Date.now()
                });
                if (!params.caipNetwork) throw new Error("caipNetwork is required");
                resolve({
                    balance: formattedBalance,
                    symbol: params.caipNetwork?.nativeCurrency.symbol
                });
            } catch (error) {
                resolve({
                    balance: "0.00",
                    symbol: "SOL"
                });
            }
        }).finally(()=>{
            delete this.balancePromises[caipAddress];
        });
        return this.balancePromises[caipAddress] || {
            balance: "0.00",
            symbol: "SOL"
        };
    }
    async switchNetwork(params) {
        await super.switchNetwork(params);
        const { caipNetwork: caipNetwork } = params;
        if (caipNetwork?.rpcUrls?.default?.http?.[0]) (0, $c9f06e5e88a456d8$export$3893a42f67201971).setConnection(new (0, $bccf75ed4dec0420$export$98b66c25bb38499d)(caipNetwork.rpcUrls.default.http[0], this.connectionSettings));
    }
    listenProviderEvents(provider) {
        const disconnectHandler = ()=>{
            this.removeProviderListeners(provider);
            this.emit("disconnect");
        };
        const accountsChangedHandler = (publicKey)=>{
            const address = publicKey.toBase58();
            if (address) this.emit("accountChanged", {
                address: address
            });
        };
        provider.on("disconnect", disconnectHandler);
        provider.on("accountsChanged", accountsChangedHandler);
        provider.on("connect", accountsChangedHandler);
        provider.on("pendingTransaction", ()=>{
            this.emit("pendingTransactions");
        });
        this.providerHandlers = {
            disconnect: disconnectHandler,
            accountsChanged: accountsChangedHandler
        };
    }
    removeProviderListeners(provider) {
        if (this.providerHandlers) {
            provider.removeListener("disconnect", this.providerHandlers.disconnect);
            provider.removeListener("accountsChanged", this.providerHandlers.accountsChanged);
            provider.removeListener("connect", this.providerHandlers.accountsChanged);
            this.providerHandlers = null;
        }
    }
    setUniversalProvider(universalProvider) {
        this.addConnector(new (0, $d32bb1d4e95159e6$export$12a0f739bdb07621)({
            provider: universalProvider,
            chains: this.getCaipNetworks(),
            getActiveChain: ()=>(0, $gD0RX.ChainController).getCaipNetworkByNamespace(this.namespace)
        }));
    }
    async connectWalletConnect(chainId) {
        const result = await super.connectWalletConnect(chainId);
        const rpcUrl = this.getCaipNetworks()?.find((n)=>n.id === chainId)?.rpcUrls.default.http[0];
        const connection = new (0, $bccf75ed4dec0420$export$98b66c25bb38499d)(rpcUrl, this.connectionSettings);
        (0, $c9f06e5e88a456d8$export$3893a42f67201971).setConnection(connection);
        return result;
    }
    async disconnect(params) {
        if (!params.provider || !params.providerType) throw new Error("Provider or providerType not provided");
        await params.provider.disconnect();
    }
    async syncConnection(params) {
        return this.connect({
            ...params,
            type: ""
        });
    }
    getWalletConnectProvider(params) {
        const walletConnectProvider = new (0, $d32bb1d4e95159e6$export$12a0f739bdb07621)({
            provider: params.provider,
            chains: params.caipNetworks,
            getActiveChain: ()=>(0, $gD0RX.ChainController).getCaipNetworkByNamespace(this.namespace)
        });
        return walletConnectProvider;
    }
}



var $lpmCO = parcelRequire("lpmCO");

var $b3v9s = parcelRequire("b3v9s");

var $gD0RX = parcelRequire("gD0RX");
var $bc5dy = parcelRequire("bc5dy");


parcelRequire("5ID99");


// src/index.ts
// src/addresses/index.ts
var $88dd9319ba2ad0ba$exports = {};
"use strict";
var $88dd9319ba2ad0ba$var$__createBinding = $88dd9319ba2ad0ba$exports && $88dd9319ba2ad0ba$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $88dd9319ba2ad0ba$var$__exportStar = $88dd9319ba2ad0ba$exports && $88dd9319ba2ad0ba$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $88dd9319ba2ad0ba$var$__createBinding(exports1, m, p);
};
Object.defineProperty($88dd9319ba2ad0ba$exports, "__esModule", {
    value: true
});

$88dd9319ba2ad0ba$var$__exportStar((parcelRequire("02Twl")), $88dd9319ba2ad0ba$exports);

$88dd9319ba2ad0ba$var$__exportStar((parcelRequire("gEccP")), $88dd9319ba2ad0ba$exports);

$88dd9319ba2ad0ba$var$__exportStar((parcelRequire("j8owO")), $88dd9319ba2ad0ba$exports);

$88dd9319ba2ad0ba$var$__exportStar((parcelRequire("kDPfV")), $88dd9319ba2ad0ba$exports);

$88dd9319ba2ad0ba$var$__exportStar((parcelRequire("ccACr")), $88dd9319ba2ad0ba$exports);



var $asgrE = parcelRequire("asgrE");
"use strict";
function $9a280f6218891140$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}



var $kuzpm = parcelRequire("kuzpm");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $0edcafdbfed057bf$var$toString } = Object.prototype;
const { getPrototypeOf: $0edcafdbfed057bf$var$getPrototypeOf } = Object;
const $0edcafdbfed057bf$var$kindOf = ((cache)=>(thing)=>{
        const str = $0edcafdbfed057bf$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $0edcafdbfed057bf$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$0edcafdbfed057bf$var$kindOf(thing) === type;
};
const $0edcafdbfed057bf$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $0edcafdbfed057bf$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $0edcafdbfed057bf$var$isUndefined = $0edcafdbfed057bf$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $0edcafdbfed057bf$var$isBuffer(val) {
    return val !== null && !$0edcafdbfed057bf$var$isUndefined(val) && val.constructor !== null && !$0edcafdbfed057bf$var$isUndefined(val.constructor) && $0edcafdbfed057bf$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $0edcafdbfed057bf$var$isArrayBuffer = $0edcafdbfed057bf$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $0edcafdbfed057bf$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $0edcafdbfed057bf$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $0edcafdbfed057bf$var$isString = $0edcafdbfed057bf$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $0edcafdbfed057bf$var$isFunction = $0edcafdbfed057bf$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $0edcafdbfed057bf$var$isNumber = $0edcafdbfed057bf$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $0edcafdbfed057bf$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $0edcafdbfed057bf$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $0edcafdbfed057bf$var$isPlainObject = (val)=>{
    if ($0edcafdbfed057bf$var$kindOf(val) !== "object") return false;
    const prototype = $0edcafdbfed057bf$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $0edcafdbfed057bf$var$isDate = $0edcafdbfed057bf$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $0edcafdbfed057bf$var$isFile = $0edcafdbfed057bf$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $0edcafdbfed057bf$var$isBlob = $0edcafdbfed057bf$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $0edcafdbfed057bf$var$isFileList = $0edcafdbfed057bf$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $0edcafdbfed057bf$var$isStream = (val)=>$0edcafdbfed057bf$var$isObject(val) && $0edcafdbfed057bf$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $0edcafdbfed057bf$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $0edcafdbfed057bf$var$isFunction(thing.append) && ((kind = $0edcafdbfed057bf$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $0edcafdbfed057bf$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $0edcafdbfed057bf$var$isURLSearchParams = $0edcafdbfed057bf$var$kindOfTest("URLSearchParams");
const [$0edcafdbfed057bf$var$isReadableStream, $0edcafdbfed057bf$var$isRequest, $0edcafdbfed057bf$var$isResponse, $0edcafdbfed057bf$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($0edcafdbfed057bf$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $0edcafdbfed057bf$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $0edcafdbfed057bf$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($0edcafdbfed057bf$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $0edcafdbfed057bf$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $0edcafdbfed057bf$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $0edcafdbfed057bf$var$isContextDefined = (context)=>!$0edcafdbfed057bf$var$isUndefined(context) && context !== $0edcafdbfed057bf$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $0edcafdbfed057bf$var$merge() {
    const { caseless: caseless } = $0edcafdbfed057bf$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $0edcafdbfed057bf$var$findKey(result, key) || key;
        if ($0edcafdbfed057bf$var$isPlainObject(result[targetKey]) && $0edcafdbfed057bf$var$isPlainObject(val)) result[targetKey] = $0edcafdbfed057bf$var$merge(result[targetKey], val);
        else if ($0edcafdbfed057bf$var$isPlainObject(val)) result[targetKey] = $0edcafdbfed057bf$var$merge({}, val);
        else if ($0edcafdbfed057bf$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $0edcafdbfed057bf$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $0edcafdbfed057bf$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $0edcafdbfed057bf$var$forEach(b, (val, key)=>{
        if (thisArg && $0edcafdbfed057bf$var$isFunction(val)) a[key] = (0, $9a280f6218891140$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $0edcafdbfed057bf$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $0edcafdbfed057bf$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $0edcafdbfed057bf$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $0edcafdbfed057bf$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $0edcafdbfed057bf$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $0edcafdbfed057bf$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($0edcafdbfed057bf$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$0edcafdbfed057bf$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $0edcafdbfed057bf$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $0edcafdbfed057bf$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $0edcafdbfed057bf$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $0edcafdbfed057bf$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $0edcafdbfed057bf$var$isHTMLForm = $0edcafdbfed057bf$var$kindOfTest("HTMLFormElement");
const $0edcafdbfed057bf$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $0edcafdbfed057bf$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $0edcafdbfed057bf$var$isRegExp = $0edcafdbfed057bf$var$kindOfTest("RegExp");
const $0edcafdbfed057bf$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $0edcafdbfed057bf$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $0edcafdbfed057bf$var$freezeMethods = (obj)=>{
    $0edcafdbfed057bf$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($0edcafdbfed057bf$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$0edcafdbfed057bf$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $0edcafdbfed057bf$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $0edcafdbfed057bf$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $0edcafdbfed057bf$var$noop = ()=>{};
const $0edcafdbfed057bf$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $0edcafdbfed057bf$var$isSpecCompliantForm(thing) {
    return !!(thing && $0edcafdbfed057bf$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $0edcafdbfed057bf$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($0edcafdbfed057bf$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $0edcafdbfed057bf$var$isArray(source) ? [] : {};
                $0edcafdbfed057bf$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$0edcafdbfed057bf$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $0edcafdbfed057bf$var$isAsyncFn = $0edcafdbfed057bf$var$kindOfTest("AsyncFunction");
const $0edcafdbfed057bf$var$isThenable = (thing)=>thing && ($0edcafdbfed057bf$var$isObject(thing) || $0edcafdbfed057bf$var$isFunction(thing)) && $0edcafdbfed057bf$var$isFunction(thing.then) && $0edcafdbfed057bf$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $0edcafdbfed057bf$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $0edcafdbfed057bf$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $0edcafdbfed057bf$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $0edcafdbfed057bf$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $0edcafdbfed057bf$var$isFunction($0edcafdbfed057bf$var$_global.postMessage));
const $0edcafdbfed057bf$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($0edcafdbfed057bf$var$_global) : typeof $kuzpm !== "undefined" && $kuzpm.nextTick || $0edcafdbfed057bf$var$_setImmediate;
var // *********************
$0edcafdbfed057bf$export$2e2bcd8739ae039 = {
    isArray: $0edcafdbfed057bf$var$isArray,
    isArrayBuffer: $0edcafdbfed057bf$var$isArrayBuffer,
    isBuffer: $0edcafdbfed057bf$var$isBuffer,
    isFormData: $0edcafdbfed057bf$var$isFormData,
    isArrayBufferView: $0edcafdbfed057bf$var$isArrayBufferView,
    isString: $0edcafdbfed057bf$var$isString,
    isNumber: $0edcafdbfed057bf$var$isNumber,
    isBoolean: $0edcafdbfed057bf$var$isBoolean,
    isObject: $0edcafdbfed057bf$var$isObject,
    isPlainObject: $0edcafdbfed057bf$var$isPlainObject,
    isReadableStream: $0edcafdbfed057bf$var$isReadableStream,
    isRequest: $0edcafdbfed057bf$var$isRequest,
    isResponse: $0edcafdbfed057bf$var$isResponse,
    isHeaders: $0edcafdbfed057bf$var$isHeaders,
    isUndefined: $0edcafdbfed057bf$var$isUndefined,
    isDate: $0edcafdbfed057bf$var$isDate,
    isFile: $0edcafdbfed057bf$var$isFile,
    isBlob: $0edcafdbfed057bf$var$isBlob,
    isRegExp: $0edcafdbfed057bf$var$isRegExp,
    isFunction: $0edcafdbfed057bf$var$isFunction,
    isStream: $0edcafdbfed057bf$var$isStream,
    isURLSearchParams: $0edcafdbfed057bf$var$isURLSearchParams,
    isTypedArray: $0edcafdbfed057bf$var$isTypedArray,
    isFileList: $0edcafdbfed057bf$var$isFileList,
    forEach: $0edcafdbfed057bf$var$forEach,
    merge: $0edcafdbfed057bf$var$merge,
    extend: $0edcafdbfed057bf$var$extend,
    trim: $0edcafdbfed057bf$var$trim,
    stripBOM: $0edcafdbfed057bf$var$stripBOM,
    inherits: $0edcafdbfed057bf$var$inherits,
    toFlatObject: $0edcafdbfed057bf$var$toFlatObject,
    kindOf: $0edcafdbfed057bf$var$kindOf,
    kindOfTest: $0edcafdbfed057bf$var$kindOfTest,
    endsWith: $0edcafdbfed057bf$var$endsWith,
    toArray: $0edcafdbfed057bf$var$toArray,
    forEachEntry: $0edcafdbfed057bf$var$forEachEntry,
    matchAll: $0edcafdbfed057bf$var$matchAll,
    isHTMLForm: $0edcafdbfed057bf$var$isHTMLForm,
    hasOwnProperty: $0edcafdbfed057bf$var$hasOwnProperty,
    hasOwnProp: $0edcafdbfed057bf$var$hasOwnProperty,
    reduceDescriptors: $0edcafdbfed057bf$var$reduceDescriptors,
    freezeMethods: $0edcafdbfed057bf$var$freezeMethods,
    toObjectSet: $0edcafdbfed057bf$var$toObjectSet,
    toCamelCase: $0edcafdbfed057bf$var$toCamelCase,
    noop: $0edcafdbfed057bf$var$noop,
    toFiniteNumber: $0edcafdbfed057bf$var$toFiniteNumber,
    findKey: $0edcafdbfed057bf$var$findKey,
    global: $0edcafdbfed057bf$var$_global,
    isContextDefined: $0edcafdbfed057bf$var$isContextDefined,
    isSpecCompliantForm: $0edcafdbfed057bf$var$isSpecCompliantForm,
    toJSONObject: $0edcafdbfed057bf$var$toJSONObject,
    isAsyncFn: $0edcafdbfed057bf$var$isAsyncFn,
    isThenable: $0edcafdbfed057bf$var$isThenable,
    setImmediate: $0edcafdbfed057bf$var$_setImmediate,
    asap: $0edcafdbfed057bf$var$asap
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $0a7b7446a5e7d4a3$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).inherits($0a7b7446a5e7d4a3$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $0a7b7446a5e7d4a3$var$prototype = $0a7b7446a5e7d4a3$var$AxiosError.prototype;
const $0a7b7446a5e7d4a3$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $0a7b7446a5e7d4a3$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($0a7b7446a5e7d4a3$var$AxiosError, $0a7b7446a5e7d4a3$var$descriptors);
Object.defineProperty($0a7b7446a5e7d4a3$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$0a7b7446a5e7d4a3$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($0a7b7446a5e7d4a3$var$prototype);
    (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $0a7b7446a5e7d4a3$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $0a7b7446a5e7d4a3$export$2e2bcd8739ae039 = $0a7b7446a5e7d4a3$var$AxiosError;


// eslint-disable-next-line strict
var $79130de14aba1c2b$export$2e2bcd8739ae039 = null;



var $lewJ9 = parcelRequire("lewJ9");
var $46b3ed111e3eabe0$require$Buffer = $lewJ9.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $46b3ed111e3eabe0$var$isVisitable(thing) {
    return (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $46b3ed111e3eabe0$var$removeBrackets(key) {
    return (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $46b3ed111e3eabe0$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $46b3ed111e3eabe0$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $46b3ed111e3eabe0$var$isFlatArray(arr) {
    return (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isArray(arr) && !arr.some($46b3ed111e3eabe0$var$isVisitable);
}
const $46b3ed111e3eabe0$var$predicates = (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).toFlatObject((0, $0edcafdbfed057bf$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $46b3ed111e3eabe0$var$toFormData(obj, formData, options) {
    if (!(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $79130de14aba1c2b$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $46b3ed111e3eabe0$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isArray(value) && $46b3ed111e3eabe0$var$isFlatArray(value) || ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isFileList(value) || (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $46b3ed111e3eabe0$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $46b3ed111e3eabe0$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($46b3ed111e3eabe0$var$isVisitable(value)) return true;
        formData.append($46b3ed111e3eabe0$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($46b3ed111e3eabe0$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $46b3ed111e3eabe0$var$isVisitable
    });
    function build(value, path) {
        if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $46b3ed111e3eabe0$export$2e2bcd8739ae039 = $46b3ed111e3eabe0$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $4bda9c2b4bd8ad01$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $4bda9c2b4bd8ad01$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $46b3ed111e3eabe0$export$2e2bcd8739ae039)(params, this, options);
}
const $4bda9c2b4bd8ad01$var$prototype = $4bda9c2b4bd8ad01$var$AxiosURLSearchParams.prototype;
$4bda9c2b4bd8ad01$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$4bda9c2b4bd8ad01$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $4bda9c2b4bd8ad01$var$encode);
    } : $4bda9c2b4bd8ad01$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $4bda9c2b4bd8ad01$export$2e2bcd8739ae039 = $4bda9c2b4bd8ad01$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $f43d8a2dbcd29bae$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $f43d8a2dbcd29bae$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $f43d8a2dbcd29bae$var$encode;
    if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $4bda9c2b4bd8ad01$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $553698a2c378d5fc$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $553698a2c378d5fc$export$2e2bcd8739ae039 = $553698a2c378d5fc$var$InterceptorManager;





"use strict";
var $86987ba1500502fe$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $d77a11e9d64cf4de$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $4bda9c2b4bd8ad01$export$2e2bcd8739ae039);


"use strict";
var $507a000ccec34632$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $61d74f2c5986867a$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $b4ed25890179ac3e$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $d77a11e9d64cf4de$export$2e2bcd8739ae039,
        FormData: $507a000ccec34632$export$2e2bcd8739ae039,
        Blob: $61d74f2c5986867a$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $78bf8f59b637f42f$exports = {};

$parcel$export($78bf8f59b637f42f$exports, "hasBrowserEnv", () => $78bf8f59b637f42f$export$c4996c4b7b93b0bf);
$parcel$export($78bf8f59b637f42f$exports, "navigator", () => $78bf8f59b637f42f$export$ec7c8efa7f5790ae);
$parcel$export($78bf8f59b637f42f$exports, "hasStandardBrowserEnv", () => $78bf8f59b637f42f$export$c0bcc9250309d66);
$parcel$export($78bf8f59b637f42f$exports, "hasStandardBrowserWebWorkerEnv", () => $78bf8f59b637f42f$export$c81692cf5af97dac);
$parcel$export($78bf8f59b637f42f$exports, "origin", () => $78bf8f59b637f42f$export$f710a83a91838a36);
const $78bf8f59b637f42f$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $78bf8f59b637f42f$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $78bf8f59b637f42f$export$c0bcc9250309d66 = $78bf8f59b637f42f$export$c4996c4b7b93b0bf && (!$78bf8f59b637f42f$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($78bf8f59b637f42f$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $78bf8f59b637f42f$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $78bf8f59b637f42f$export$f710a83a91838a36 = $78bf8f59b637f42f$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $955a3474a68be9b0$export$2e2bcd8739ae039 = {
    ...$78bf8f59b637f42f$exports,
    ...(0, $b4ed25890179ac3e$export$2e2bcd8739ae039)
};


"use strict";
function $5643f69be190b2fd$export$2e2bcd8739ae039(data, options) {
    return (0, $46b3ed111e3eabe0$export$2e2bcd8739ae039)(data, new (0, $955a3474a68be9b0$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $955a3474a68be9b0$export$2e2bcd8739ae039).isNode && (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $af7c9ef82a27b8dc$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $af7c9ef82a27b8dc$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $af7c9ef82a27b8dc$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $af7c9ef82a27b8dc$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isFormData(formData) && (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($af7c9ef82a27b8dc$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $af7c9ef82a27b8dc$export$2e2bcd8739ae039 = $af7c9ef82a27b8dc$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $d29a9e9badc3eb7d$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $d29a9e9badc3eb7d$var$defaults = {
    transitional: (0, $86987ba1500502fe$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $af7c9ef82a27b8dc$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isBuffer(data) || (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isStream(data) || (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isFile(data) || (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isBlob(data) || (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $5643f69be190b2fd$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $46b3ed111e3eabe0$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $d29a9e9badc3eb7d$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $d29a9e9badc3eb7d$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isResponse(data) || (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039).from(e, (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $955a3474a68be9b0$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $955a3474a68be9b0$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $d29a9e9badc3eb7d$var$defaults.headers[method] = {};
});
var $d29a9e9badc3eb7d$export$2e2bcd8739ae039 = $d29a9e9badc3eb7d$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $134fb1cfa32c902b$var$ignoreDuplicateOf = (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $134fb1cfa32c902b$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $134fb1cfa32c902b$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $c089bcefb8cc5e20$var$$internals = Symbol("internals");
function $c089bcefb8cc5e20$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c089bcefb8cc5e20$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isArray(value) ? value.map($c089bcefb8cc5e20$var$normalizeValue) : String(value);
}
function $c089bcefb8cc5e20$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c089bcefb8cc5e20$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c089bcefb8cc5e20$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $c089bcefb8cc5e20$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c089bcefb8cc5e20$var$buildAccessors(obj, header) {
    const accessorName = (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c089bcefb8cc5e20$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c089bcefb8cc5e20$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c089bcefb8cc5e20$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$c089bcefb8cc5e20$var$isValidHeaderName(header)) setHeaders((0, $134fb1cfa32c902b$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c089bcefb8cc5e20$var$normalizeHeader(header);
        if (header) {
            const key = (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c089bcefb8cc5e20$var$parseTokens(value);
                if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $c089bcefb8cc5e20$var$normalizeHeader(header);
        if (header) {
            const key = (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c089bcefb8cc5e20$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c089bcefb8cc5e20$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $c089bcefb8cc5e20$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c089bcefb8cc5e20$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $c089bcefb8cc5e20$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c089bcefb8cc5e20$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c089bcefb8cc5e20$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c089bcefb8cc5e20$var$$internals] = this[$c089bcefb8cc5e20$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c089bcefb8cc5e20$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c089bcefb8cc5e20$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$c089bcefb8cc5e20$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).reduceDescriptors($c089bcefb8cc5e20$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).freezeMethods($c089bcefb8cc5e20$var$AxiosHeaders);
var $c089bcefb8cc5e20$export$2e2bcd8739ae039 = $c089bcefb8cc5e20$var$AxiosHeaders;


"use strict";
function $b2de67563ee64d7e$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $d29a9e9badc3eb7d$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $c089bcefb8cc5e20$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $9be74b04fa68b11a$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $6d5d0e9c6418b78f$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).inherits($6d5d0e9c6418b78f$var$CanceledError, (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $6d5d0e9c6418b78f$export$2e2bcd8739ae039 = $6d5d0e9c6418b78f$var$CanceledError;







"use strict";
function $888399a12559f3aa$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $a0e1fd80513a11cb$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $7ee31cfe7f6b8b46$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $7ee31cfe7f6b8b46$export$2e2bcd8739ae039 = $7ee31cfe7f6b8b46$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $5d2e32f0ceae3339$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $5d2e32f0ceae3339$export$2e2bcd8739ae039 = $5d2e32f0ceae3339$var$throttle;



const $3168db4127032f42$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $7ee31cfe7f6b8b46$export$2e2bcd8739ae039)(50, 250);
    return (0, $5d2e32f0ceae3339$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $3168db4127032f42$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $3168db4127032f42$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $cc1f2bfebc5de30c$export$2e2bcd8739ae039 = (0, $955a3474a68be9b0$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $955a3474a68be9b0$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $955a3474a68be9b0$export$2e2bcd8739ae039).origin), (0, $955a3474a68be9b0$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $955a3474a68be9b0$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $169f0ebfa4a1e286$export$2e2bcd8739ae039 = (0, $955a3474a68be9b0$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


"use strict";
function $ff38d79f353ba099$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $bca244839a61fca3$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $3c2b904876ec3c8b$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $ff38d79f353ba099$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $bca244839a61fca3$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
const $a08b30df95e206ff$var$headersToObject = (thing)=>thing instanceof (0, $c089bcefb8cc5e20$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $a08b30df95e206ff$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isPlainObject(target) && (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($a08b30df95e206ff$var$headersToObject(a), $a08b30df95e206ff$var$headersToObject(b), prop, true)
    };
    (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $55e0b949d3c8390c$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $a08b30df95e206ff$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $c089bcefb8cc5e20$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $f43d8a2dbcd29bae$export$2e2bcd8739ae039)((0, $3c2b904876ec3c8b$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $955a3474a68be9b0$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $955a3474a68be9b0$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $955a3474a68be9b0$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $cc1f2bfebc5de30c$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $169f0ebfa4a1e286$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $5bede7e26b60f289$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $5bede7e26b60f289$export$2e2bcd8739ae039 = $5bede7e26b60f289$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $55e0b949d3c8390c$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $c089bcefb8cc5e20$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $c089bcefb8cc5e20$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $888399a12559f3aa$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039)("Request aborted", (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039)("Network Error", (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $86987ba1500502fe$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039).ETIMEDOUT : (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $3168db4127032f42$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $3168db4127032f42$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $6d5d0e9c6418b78f$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $a0e1fd80513a11cb$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $955a3474a68be9b0$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $3e87371a2ff6f112$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039) ? err : new (0, $6d5d0e9c6418b78f$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener("abort", onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $3e87371a2ff6f112$export$2e2bcd8739ae039 = $3e87371a2ff6f112$var$composeSignals;


const $4ca67603ea452175$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $4ca67603ea452175$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $4ca67603ea452175$var$readStream(iterable))yield* $4ca67603ea452175$export$71b051935044bd5d(chunk, chunkSize);
};
const $4ca67603ea452175$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $4ca67603ea452175$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $4ca67603ea452175$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $954f9a96c87e7e1e$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $954f9a96c87e7e1e$var$isReadableStreamSupported = $954f9a96c87e7e1e$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $954f9a96c87e7e1e$var$encodeText = $954f9a96c87e7e1e$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $954f9a96c87e7e1e$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $954f9a96c87e7e1e$var$supportsRequestStream = $954f9a96c87e7e1e$var$isReadableStreamSupported && $954f9a96c87e7e1e$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $955a3474a68be9b0$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
const $954f9a96c87e7e1e$var$DEFAULT_CHUNK_SIZE = 65536;
const $954f9a96c87e7e1e$var$supportsResponseStream = $954f9a96c87e7e1e$var$isReadableStreamSupported && $954f9a96c87e7e1e$var$test(()=>(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isReadableStream(new Response("").body));
const $954f9a96c87e7e1e$var$resolvers = {
    stream: $954f9a96c87e7e1e$var$supportsResponseStream && ((res)=>res.body)
};
$954f9a96c87e7e1e$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$954f9a96c87e7e1e$var$resolvers[type] && ($954f9a96c87e7e1e$var$resolvers[type] = (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $954f9a96c87e7e1e$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $955a3474a68be9b0$export$2e2bcd8739ae039).origin, {
            method: "POST",
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
    if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isString(body)) return (await $954f9a96c87e7e1e$var$encodeText(body)).byteLength;
};
const $954f9a96c87e7e1e$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $954f9a96c87e7e1e$var$getBodyLength(body) : length;
};
var $954f9a96c87e7e1e$export$2e2bcd8739ae039 = $954f9a96c87e7e1e$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $55e0b949d3c8390c$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let composedSignal = (0, $3e87371a2ff6f112$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $954f9a96c87e7e1e$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $954f9a96c87e7e1e$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $3168db4127032f42$export$d9fadd12586c18d6)(requestContentLength, (0, $3168db4127032f42$export$c1b28109d46c3592)((0, $3168db4127032f42$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $4ca67603ea452175$export$b0119225647bd83)(_request.body, $954f9a96c87e7e1e$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $954f9a96c87e7e1e$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($954f9a96c87e7e1e$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
            const [onProgress, flush] = onDownloadProgress && (0, $3168db4127032f42$export$d9fadd12586c18d6)(responseContentLength, (0, $3168db4127032f42$export$c1b28109d46c3592)((0, $3168db4127032f42$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $4ca67603ea452175$export$b0119225647bd83)(response.body, $954f9a96c87e7e1e$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || "text";
        let responseData = await $954f9a96c87e7e1e$var$resolvers[(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).findKey($954f9a96c87e7e1e$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $888399a12559f3aa$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $c089bcefb8cc5e20$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039)("Network Error", (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $03a2a013b47f4297$var$knownAdapters = {
    http: (0, $79130de14aba1c2b$export$2e2bcd8739ae039),
    xhr: (0, $5bede7e26b60f289$export$2e2bcd8739ae039),
    fetch: (0, $954f9a96c87e7e1e$export$2e2bcd8739ae039)
};
(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).forEach($03a2a013b47f4297$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $03a2a013b47f4297$var$renderReason = (reason)=>`- ${reason}`;
const $03a2a013b47f4297$var$isResolvedHandle = (adapter)=>(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $03a2a013b47f4297$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$03a2a013b47f4297$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $03a2a013b47f4297$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($03a2a013b47f4297$var$renderReason).join("\n") : " " + $03a2a013b47f4297$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $03a2a013b47f4297$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $5a408926fea93e7a$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $6d5d0e9c6418b78f$export$2e2bcd8739ae039)(null, config);
}
function $5a408926fea93e7a$export$2e2bcd8739ae039(config) {
    $5a408926fea93e7a$var$throwIfCancellationRequested(config);
    config.headers = (0, $c089bcefb8cc5e20$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $b2de67563ee64d7e$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $03a2a013b47f4297$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $d29a9e9badc3eb7d$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $5a408926fea93e7a$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $b2de67563ee64d7e$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $c089bcefb8cc5e20$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $9be74b04fa68b11a$export$2e2bcd8739ae039)(reason)) {
            $5a408926fea93e7a$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $b2de67563ee64d7e$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $c089bcefb8cc5e20$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $008bb74f96f1773d$export$a4ad2735b021c132 = "1.8.4";



"use strict";
const $a4f389f20ed03ec0$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $a4f389f20ed03ec0$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $a4f389f20ed03ec0$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $a4f389f20ed03ec0$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $008bb74f96f1773d$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$a4f389f20ed03ec0$var$deprecatedWarnings[opt]) {
            $a4f389f20ed03ec0$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$a4f389f20ed03ec0$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $a4f389f20ed03ec0$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039)("options must be an object", (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $a4f389f20ed03ec0$export$2e2bcd8739ae039 = {
    assertOptions: $a4f389f20ed03ec0$var$assertOptions,
    validators: $a4f389f20ed03ec0$var$validators
};



"use strict";
const $599e717b649f1473$var$validators = (0, $a4f389f20ed03ec0$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $599e717b649f1473$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $553698a2c378d5fc$export$2e2bcd8739ae039)(),
            response: new (0, $553698a2c378d5fc$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $a08b30df95e206ff$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $a4f389f20ed03ec0$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $599e717b649f1473$var$validators.transitional($599e717b649f1473$var$validators.boolean),
            forcedJSONParsing: $599e717b649f1473$var$validators.transitional($599e717b649f1473$var$validators.boolean),
            clarifyTimeoutError: $599e717b649f1473$var$validators.transitional($599e717b649f1473$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $a4f389f20ed03ec0$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $599e717b649f1473$var$validators.function,
                serialize: $599e717b649f1473$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $a4f389f20ed03ec0$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $599e717b649f1473$var$validators.spelling("baseURL"),
            withXsrfToken: $599e717b649f1473$var$validators.spelling("withXSRFToken")
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $c089bcefb8cc5e20$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $5a408926fea93e7a$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $5a408926fea93e7a$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $a08b30df95e206ff$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $3c2b904876ec3c8b$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $f43d8a2dbcd29bae$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $599e717b649f1473$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $a08b30df95e206ff$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $0edcafdbfed057bf$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $a08b30df95e206ff$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $599e717b649f1473$var$Axios.prototype[method] = generateHTTPMethod();
    $599e717b649f1473$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $599e717b649f1473$export$2e2bcd8739ae039 = $599e717b649f1473$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $e8b63f6c7701250d$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $6d5d0e9c6418b78f$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $e8b63f6c7701250d$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $e8b63f6c7701250d$export$2e2bcd8739ae039 = $e8b63f6c7701250d$var$CancelToken;






"use strict";
function $df6881104e8a9e7e$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $79b21617b0632fe4$export$2e2bcd8739ae039(payload) {
    return (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $cebe5223da395071$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($cebe5223da395071$var$HttpStatusCode).forEach(([key, value])=>{
    $cebe5223da395071$var$HttpStatusCode[value] = key;
});
var $cebe5223da395071$export$2e2bcd8739ae039 = $cebe5223da395071$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $cf69f5c5e40703db$var$createInstance(defaultConfig) {
    const context = new (0, $599e717b649f1473$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $9a280f6218891140$export$2e2bcd8739ae039)((0, $599e717b649f1473$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).extend(instance, (0, $599e717b649f1473$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $0edcafdbfed057bf$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $cf69f5c5e40703db$var$createInstance((0, $a08b30df95e206ff$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $cf69f5c5e40703db$var$axios = $cf69f5c5e40703db$var$createInstance((0, $d29a9e9badc3eb7d$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$cf69f5c5e40703db$var$axios.Axios = (0, $599e717b649f1473$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$cf69f5c5e40703db$var$axios.CanceledError = (0, $6d5d0e9c6418b78f$export$2e2bcd8739ae039);
$cf69f5c5e40703db$var$axios.CancelToken = (0, $e8b63f6c7701250d$export$2e2bcd8739ae039);
$cf69f5c5e40703db$var$axios.isCancel = (0, $9be74b04fa68b11a$export$2e2bcd8739ae039);
$cf69f5c5e40703db$var$axios.VERSION = (0, $008bb74f96f1773d$export$a4ad2735b021c132);
$cf69f5c5e40703db$var$axios.toFormData = (0, $46b3ed111e3eabe0$export$2e2bcd8739ae039);
// Expose AxiosError class
$cf69f5c5e40703db$var$axios.AxiosError = (0, $0a7b7446a5e7d4a3$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$cf69f5c5e40703db$var$axios.Cancel = $cf69f5c5e40703db$var$axios.CanceledError;
// Expose all/spread
$cf69f5c5e40703db$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$cf69f5c5e40703db$var$axios.spread = (0, $df6881104e8a9e7e$export$2e2bcd8739ae039);
// Expose isAxiosError
$cf69f5c5e40703db$var$axios.isAxiosError = (0, $79b21617b0632fe4$export$2e2bcd8739ae039);
// Expose mergeConfig
$cf69f5c5e40703db$var$axios.mergeConfig = (0, $a08b30df95e206ff$export$2e2bcd8739ae039);
$cf69f5c5e40703db$var$axios.AxiosHeaders = (0, $c089bcefb8cc5e20$export$2e2bcd8739ae039);
$cf69f5c5e40703db$var$axios.formToJSON = (thing)=>(0, $af7c9ef82a27b8dc$export$2e2bcd8739ae039)((0, $0edcafdbfed057bf$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$cf69f5c5e40703db$var$axios.getAdapter = (0, $03a2a013b47f4297$export$2e2bcd8739ae039).getAdapter;
$cf69f5c5e40703db$var$axios.HttpStatusCode = (0, $cebe5223da395071$export$2e2bcd8739ae039);
$cf69f5c5e40703db$var$axios.default = $cf69f5c5e40703db$var$axios;
var // this module should only have a default export
$cf69f5c5e40703db$export$2e2bcd8739ae039 = $cf69f5c5e40703db$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $470d03a625f7f3a6$export$1c00760e9e5a4e95, AxiosError: $470d03a625f7f3a6$export$c1fbed17c2f6a328, CanceledError: $470d03a625f7f3a6$export$1ab0c6b20d94fa14, isCancel: $470d03a625f7f3a6$export$3b22524397b493c6, CancelToken: $470d03a625f7f3a6$export$fd08e3cb425f0d61, VERSION: $470d03a625f7f3a6$export$a4ad2735b021c132, all: $470d03a625f7f3a6$export$84bf76cd7afc7469, Cancel: $470d03a625f7f3a6$export$848c9b7ead0df967, isAxiosError: $470d03a625f7f3a6$export$fbafdbe06a5b5a9a, spread: $470d03a625f7f3a6$export$3ae0fd4797ed47c8, toFormData: $470d03a625f7f3a6$export$10ae0d317ea97f8b, AxiosHeaders: $470d03a625f7f3a6$export$4e7d6ff0f3e6520, HttpStatusCode: $470d03a625f7f3a6$export$a972f69c851492b3, formToJSON: $470d03a625f7f3a6$export$86d7c59254d6a2c9, getAdapter: $470d03a625f7f3a6$export$17ddc20a97d669e2, mergeConfig: $470d03a625f7f3a6$export$7ec1ebcfa9d8bd6a } = (0, $cf69f5c5e40703db$export$2e2bcd8739ae039);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $21c5f62793064411$var$t = function() {
    return $21c5f62793064411$var$t = Object.assign || function(t) {
        for(var r, e = 1, n = arguments.length; e < n; e++)for(var s in r = arguments[e])Object.prototype.hasOwnProperty.call(r, s) && (t[s] = r[s]);
        return t;
    }, $21c5f62793064411$var$t.apply(this, arguments);
};
var $21c5f62793064411$var$r = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var $21c5f62793064411$var$e = (t)=>{
    if (!t || "string" != typeof t) throw new Error(`Expected base58 string but got \u{201C}${t}\u{201D}`);
    if (t.match(/[IOl0]/gmu)) throw new Error(`Invalid base58 character \u{201C}${t.match(/[IOl0]/gmu)}\u{201D}`);
    const e = t.match(/^1+/gmu), n = e ? e[0].length : 0, s = (t.length - n) * (Math.log(58) / Math.log(256)) + 1 >>> 0;
    var i;
    return new Uint8Array([
        ...new Uint8Array(n),
        ...t.match(/.{1}/gmu).map((t)=>$21c5f62793064411$var$r.indexOf(t)).reduce((t, r)=>t = t.map((t)=>{
                const e = 58 * t + r;
                return r = e >> 8, e;
            }), new Uint8Array(s)).reverse().filter((i = !1, (t)=>i = i || t))
    ]);
};
(()=>{
    const t = Array(256).fill(-1);
    for(let e = 0; e < $21c5f62793064411$var$r.length; ++e)t[$21c5f62793064411$var$r.charCodeAt(e)] = e;
})();
var $21c5f62793064411$var$n = $21c5f62793064411$var$e;
var $21c5f62793064411$var$s, $21c5f62793064411$var$i, $21c5f62793064411$var$o, $21c5f62793064411$var$h = ($21c5f62793064411$var$s = function(t, r) {
    Object.defineProperty(r, "__esModule", {
        value: !0
    }), r.bech32m = r.bech32 = void 0;
    const e = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", n = {};
    for(let t = 0; t < 32; t++){
        const r = e.charAt(t);
        n[r] = t;
    }
    function s(t) {
        const r = t >> 25;
        return (33554431 & t) << 5 ^ 996825010 & -(r >> 0 & 1) ^ 642813549 & -(r >> 1 & 1) ^ 513874426 & -(r >> 2 & 1) ^ 1027748829 & -(r >> 3 & 1) ^ 705979059 & -(r >> 4 & 1);
    }
    function i(t) {
        let r = 1;
        for(let e = 0; e < t.length; ++e){
            const n = t.charCodeAt(e);
            if (n < 33 || n > 126) return "Invalid prefix (" + t + ")";
            r = s(r) ^ n >> 5;
        }
        r = s(r);
        for(let e = 0; e < t.length; ++e){
            const n = t.charCodeAt(e);
            r = s(r) ^ 31 & n;
        }
        return r;
    }
    function o(t, r, e, n) {
        let s = 0, i = 0;
        const o = (1 << e) - 1, h = [];
        for(let n = 0; n < t.length; ++n)for(s = s << r | t[n], i += r; i >= e;)i -= e, h.push(s >> i & o);
        if (n) i > 0 && h.push(s << e - i & o);
        else {
            if (i >= r) return "Excess padding";
            if (s << e - i & o) return "Non-zero padding";
        }
        return h;
    }
    function h(t) {
        return o(t, 8, 5, !0);
    }
    function c(t) {
        const r = o(t, 5, 8, !1);
        if (Array.isArray(r)) return r;
    }
    function a(t) {
        const r = o(t, 5, 8, !1);
        if (Array.isArray(r)) return r;
        throw new Error(r);
    }
    function f(t) {
        let r;
        function o(t, e) {
            if (e = e || 90, t.length < 8) return t + " too short";
            if (t.length > e) return "Exceeds length limit";
            const o = t.toLowerCase(), h = t.toUpperCase();
            if (t !== o && t !== h) return "Mixed-case string " + t;
            const c = (t = o).lastIndexOf("1");
            if (-1 === c) return "No separator character for " + t;
            if (0 === c) return "Missing prefix for " + t;
            const a = t.slice(0, c), f = t.slice(c + 1);
            if (f.length < 6) return "Data too short";
            let u = i(a);
            if ("string" == typeof u) return u;
            const l = [];
            for(let t = 0; t < f.length; ++t){
                const r = f.charAt(t), e = n[r];
                if (void 0 === e) return "Unknown character " + r;
                u = s(u) ^ e, t + 6 >= f.length || l.push(e);
            }
            return u !== r ? "Invalid checksum for " + t : {
                prefix: a,
                words: l
            };
        }
        return r = "bech32" === t ? 1 : 734539939, {
            decodeUnsafe: function(t, r) {
                const e = o(t, r);
                if ("object" == typeof e) return e;
            },
            decode: function(t, r) {
                const e = o(t, r);
                if ("object" == typeof e) return e;
                throw new Error(e);
            },
            encode: function(t, n, o) {
                if (o = o || 90, t.length + 7 + n.length > o) throw new TypeError("Exceeds length limit");
                let h = i(t = t.toLowerCase());
                if ("string" == typeof h) throw new Error(h);
                let c = t + "1";
                for(let t = 0; t < n.length; ++t){
                    const r = n[t];
                    if (r >> 5 != 0) throw new Error("Non 5-bit word");
                    h = s(h) ^ r, c += e.charAt(r);
                }
                for(let t = 0; t < 6; ++t)h = s(h);
                h ^= r;
                for(let t = 0; t < 6; ++t)c += e.charAt(h >> 5 * (5 - t) & 31);
                return c;
            },
            toWords: h,
            fromWordsUnsafe: c,
            fromWords: a
        };
    }
    r.bech32 = f("bech32"), r.bech32m = f("bech32m");
}, $21c5f62793064411$var$s($21c5f62793064411$var$i = {
    exports: {}
}, $21c5f62793064411$var$i.exports), $21c5f62793064411$var$i.exports);
($21c5f62793064411$var$o = $21c5f62793064411$var$h) && $21c5f62793064411$var$o.__esModule && Object.prototype.hasOwnProperty.call($21c5f62793064411$var$o, "default") && $21c5f62793064411$var$o.default;
var $21c5f62793064411$var$c = $21c5f62793064411$var$h.bech32m, $21c5f62793064411$var$a = $21c5f62793064411$var$h.bech32;
const $21c5f62793064411$var$f = [
    1116352408,
    1899447441,
    -1245643825,
    -373957723,
    961987163,
    1508970993,
    -1841331548,
    -1424204075,
    -670586216,
    310598401,
    607225278,
    1426881987,
    1925078388,
    -2132889090,
    -1680079193,
    -1046744716,
    -459576895,
    -272742522,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    -1740746414,
    -1473132947,
    -1341970488,
    -1084653625,
    -958395405,
    -710438585,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    -2117940946,
    -1838011259,
    -1564481375,
    -1474664885,
    -1035236496,
    -949202525,
    -778901479,
    -694614492,
    -200395387,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    -2067236844,
    -1933114872,
    -1866530822,
    -1538233109,
    -1090935817,
    -965641998
], $21c5f62793064411$var$u = {
    sha256: 1
};
class $21c5f62793064411$var$l {
    constructor(){
        this.A = 1779033703, this.B = -1150833019, this.C = 1013904242, this.D = -1521486534, this.E = 1359893119, this.F = -1694144372, this.G = 528734635, this.H = 1541459225, this._size = 0, this._sp = 0, (!$21c5f62793064411$var$p || $21c5f62793064411$var$w >= 8e3) && ($21c5f62793064411$var$p = new ArrayBuffer(8e3), $21c5f62793064411$var$w = 0), this._byte = new Uint8Array($21c5f62793064411$var$p, $21c5f62793064411$var$w, 80), this._word = new Int32Array($21c5f62793064411$var$p, $21c5f62793064411$var$w, 20), $21c5f62793064411$var$w += 80;
    }
    update(t) {
        if ("string" == typeof t) return this._utf8(t);
        if (null == t) throw new TypeError("Invalid type: " + typeof t);
        const r = t.byteOffset, e = t.byteLength;
        let n = e / 64 | 0, s = 0;
        if (n && !(3 & r) && !(this._size % 64)) {
            const e = new Int32Array(t.buffer, r, 16 * n);
            for(; n--;)this._int32(e, s >> 2), s += 64;
            this._size += s;
        }
        if (1 !== t.BYTES_PER_ELEMENT && t.buffer) {
            const n = new Uint8Array(t.buffer, r + s, e - s);
            return this._uint8(n);
        }
        return s === e ? this : this._uint8(t, s);
    }
    _uint8(t, r) {
        const { _byte: e, _word: n } = this, s = t.length;
        for(r |= 0; r < s;){
            const i = this._size % 64;
            let o = i;
            for(; r < s && o < 64;)e[o++] = t[r++];
            o >= 64 && this._int32(n), this._size += o - i;
        }
        return this;
    }
    _utf8(t) {
        const { _byte: r, _word: e } = this, n = t.length;
        let s = this._sp;
        for(let i = 0; i < n;){
            const o = this._size % 64;
            let h = o;
            for(; i < n && h < 64;){
                let e = 0 | t.charCodeAt(i++);
                e < 128 ? r[h++] = e : e < 2048 ? (r[h++] = 192 | e >>> 6, r[h++] = 128 | 63 & e) : e < 55296 || e > 57343 ? (r[h++] = 224 | e >>> 12, r[h++] = 128 | e >>> 6 & 63, r[h++] = 128 | 63 & e) : s ? (e = ((1023 & s) << 10) + (1023 & e) + 65536, r[h++] = 240 | e >>> 18, r[h++] = 128 | e >>> 12 & 63, r[h++] = 128 | e >>> 6 & 63, r[h++] = 128 | 63 & e, s = 0) : s = e;
            }
            h >= 64 && (this._int32(e), e[0] = e[16]), this._size += h - o;
        }
        return this._sp = s, this;
    }
    _int32(t, r) {
        let { A: e, B: n, C: s, D: i, E: o, F: h, G: c, H: a } = this, u = 0;
        for(r |= 0; u < 16;)$21c5f62793064411$var$d[u++] = $21c5f62793064411$var$g(t[r++]);
        for(u = 16; u < 64; u++)$21c5f62793064411$var$d[u] = $21c5f62793064411$var$A($21c5f62793064411$var$d[u - 2]) + $21c5f62793064411$var$d[u - 7] + $21c5f62793064411$var$m($21c5f62793064411$var$d[u - 15]) + $21c5f62793064411$var$d[u - 16] | 0;
        for(u = 0; u < 64; u++){
            const t = a + $21c5f62793064411$var$E(o) + $21c5f62793064411$var$b(o, h, c) + $21c5f62793064411$var$f[u] + $21c5f62793064411$var$d[u] | 0, r = $21c5f62793064411$var$v(e) + $21c5f62793064411$var$_(e, n, s) | 0;
            a = c, c = h, h = o, o = i + t | 0, i = s, s = n, n = e, e = t + r | 0;
        }
        this.A = e + this.A | 0, this.B = n + this.B | 0, this.C = s + this.C | 0, this.D = i + this.D | 0, this.E = o + this.E | 0, this.F = h + this.F | 0, this.G = c + this.G | 0, this.H = a + this.H | 0;
    }
    digest(t) {
        const { _byte: r, _word: e } = this;
        let n = this._size % 64 | 0;
        for(r[n++] = 128; 3 & n;)r[n++] = 0;
        if (n >>= 2, n > 14) {
            for(; n < 16;)e[n++] = 0;
            n = 0, this._int32(e);
        }
        for(; n < 16;)e[n++] = 0;
        const s = 8 * this._size, i = (4294967295 & s) >>> 0, o = (s - i) / 4294967296;
        return o && (e[14] = $21c5f62793064411$var$g(o)), i && (e[15] = $21c5f62793064411$var$g(i)), this._int32(e), "hex" === t ? this._hex() : this._bin();
    }
    _hex() {
        const { A: t, B: r, C: e, D: n, E: s, F: i, G: o, H: h } = this;
        return $21c5f62793064411$var$y(t) + $21c5f62793064411$var$y(r) + $21c5f62793064411$var$y(e) + $21c5f62793064411$var$y(n) + $21c5f62793064411$var$y(s) + $21c5f62793064411$var$y(i) + $21c5f62793064411$var$y(o) + $21c5f62793064411$var$y(h);
    }
    _bin() {
        const { A: t, B: r, C: e, D: n, E: s, F: i, G: o, H: h, _byte: c, _word: a } = this;
        return a[0] = $21c5f62793064411$var$g(t), a[1] = $21c5f62793064411$var$g(r), a[2] = $21c5f62793064411$var$g(e), a[3] = $21c5f62793064411$var$g(n), a[4] = $21c5f62793064411$var$g(s), a[5] = $21c5f62793064411$var$g(i), a[6] = $21c5f62793064411$var$g(o), a[7] = $21c5f62793064411$var$g(h), c.slice(0, 32);
    }
}
const $21c5f62793064411$var$d = new Int32Array(64);
let $21c5f62793064411$var$p, $21c5f62793064411$var$w = 0;
const $21c5f62793064411$var$y = (t)=>(t + 4294967296).toString(16).substr(-8), $21c5f62793064411$var$g = 254 === new Uint8Array(new Uint16Array([
    65279
]).buffer)[0] ? (t)=>t : (t)=>t << 24 & 4278190080 | t << 8 & 16711680 | t >> 8 & 65280 | t >> 24 & 255, $21c5f62793064411$var$b = (t, r, e)=>e ^ t & (r ^ e), $21c5f62793064411$var$_ = (t, r, e)=>t & r | e & (t | r), $21c5f62793064411$var$v = (t)=>(t >>> 2 | t << 30) ^ (t >>> 13 | t << 19) ^ (t >>> 22 | t << 10), $21c5f62793064411$var$E = (t)=>(t >>> 6 | t << 26) ^ (t >>> 11 | t << 21) ^ (t >>> 25 | t << 7), $21c5f62793064411$var$m = (t)=>(t >>> 7 | t << 25) ^ (t >>> 18 | t << 14) ^ t >>> 3, $21c5f62793064411$var$A = (t)=>(t >>> 17 | t << 15) ^ (t >>> 19 | t << 13) ^ t >>> 10;
var $21c5f62793064411$export$95be4ae94445245a, $21c5f62793064411$export$189c6ba3eaa96ac2, $21c5f62793064411$var$I = function(t) {
    return (function(t) {
        if (t && !$21c5f62793064411$var$u[t] && !$21c5f62793064411$var$u[t.toLowerCase()]) throw new Error("Digest method not supported");
        return new $21c5f62793064411$var$l;
    })().update(t).digest();
};
!function(t) {
    t.mainnet = "mainnet", t.testnet = "testnet", t.regtest = "regtest";
}($21c5f62793064411$export$95be4ae94445245a || ($21c5f62793064411$export$95be4ae94445245a = {})), function(t) {
    t.p2pkh = "p2pkh", t.p2sh = "p2sh", t.p2wpkh = "p2wpkh", t.p2wsh = "p2wsh", t.p2tr = "p2tr";
}($21c5f62793064411$export$189c6ba3eaa96ac2 || ($21c5f62793064411$export$189c6ba3eaa96ac2 = {}));
var $21c5f62793064411$var$C = {
    0: {
        type: $21c5f62793064411$export$189c6ba3eaa96ac2.p2pkh,
        network: $21c5f62793064411$export$95be4ae94445245a.mainnet
    },
    111: {
        type: $21c5f62793064411$export$189c6ba3eaa96ac2.p2pkh,
        network: $21c5f62793064411$export$95be4ae94445245a.testnet
    },
    5: {
        type: $21c5f62793064411$export$189c6ba3eaa96ac2.p2sh,
        network: $21c5f62793064411$export$95be4ae94445245a.mainnet
    },
    196: {
        type: $21c5f62793064411$export$189c6ba3eaa96ac2.p2sh,
        network: $21c5f62793064411$export$95be4ae94445245a.testnet
    }
}, $21c5f62793064411$export$e276b9dec452d0e2 = function(r) {
    var e, s = r.substr(0, 2).toLowerCase();
    if ("bc" === s || "tb" === s) return function(t) {
        var r;
        try {
            r = t.startsWith("bc1p") || t.startsWith("tb1p") || t.startsWith("bcrt1p") ? $21c5f62793064411$var$c.decode(t) : $21c5f62793064411$var$a.decode(t);
        } catch (t) {
            throw new Error("Invalid address");
        }
        var e = {
            bc: $21c5f62793064411$export$95be4ae94445245a.mainnet,
            tb: $21c5f62793064411$export$95be4ae94445245a.testnet,
            bcrt: $21c5f62793064411$export$95be4ae94445245a.regtest
        }[r.prefix];
        if (void 0 === e) throw new Error("Invalid address");
        var n = r.words[0];
        if (n < 0 || n > 16) throw new Error("Invalid address");
        return {
            bech32: !0,
            network: e,
            address: t,
            type: 20 === $21c5f62793064411$var$a.fromWords(r.words.slice(1)).length ? $21c5f62793064411$export$189c6ba3eaa96ac2.p2wpkh : 1 === n ? $21c5f62793064411$export$189c6ba3eaa96ac2.p2tr : $21c5f62793064411$export$189c6ba3eaa96ac2.p2wsh
        };
    }(r);
    try {
        e = $21c5f62793064411$var$n(r);
    } catch (t) {
        throw new Error("Invalid address");
    }
    var i = e.length;
    if (25 !== i) throw new Error("Invalid address");
    var o = e[0], h = e.slice(i - 4, i), f = e.slice(0, i - 4), u = $21c5f62793064411$var$I($21c5f62793064411$var$I(f)).slice(0, 4);
    if (h.some(function(t, r) {
        return t !== u[r];
    })) throw new Error("Invalid address");
    if (!Object.keys($21c5f62793064411$var$C).map(Number).includes(o)) throw new Error("Invalid address");
    return $21c5f62793064411$var$t($21c5f62793064411$var$t({}, $21c5f62793064411$var$C[o]), {
        address: r,
        bech32: !1
    });
}, $21c5f62793064411$export$2e2bcd8739ae039 = function(t, r) {
    try {
        var e = $21c5f62793064411$export$e276b9dec452d0e2(t);
        return !r || r === e.network;
    } catch (t) {
        return !1;
    }
};



var $lewJ9 = parcelRequire("lewJ9");
var $adfbe621f07e3fbf$export$908dc115f6c7d98d = [
    "software",
    "ledger",
    "keystone"
];
var $adfbe621f07e3fbf$export$27274fc5a05663c = $asgrE.picklist($adfbe621f07e3fbf$export$908dc115f6c7d98d);
// src/addresses/types.ts
var $adfbe621f07e3fbf$export$b6218cda604ca8c9 = /* @__PURE__ */ ((AddressPurpose2)=>{
    AddressPurpose2["Ordinals"] = "ordinals";
    AddressPurpose2["Payment"] = "payment";
    AddressPurpose2["Stacks"] = "stacks";
    return AddressPurpose2;
})($adfbe621f07e3fbf$export$b6218cda604ca8c9 || {});
var $adfbe621f07e3fbf$export$189c6ba3eaa96ac2 = /* @__PURE__ */ ((AddressType3)=>{
    AddressType3["p2pkh"] = "p2pkh";
    AddressType3["p2sh"] = "p2sh";
    AddressType3["p2wpkh"] = "p2wpkh";
    AddressType3["p2wsh"] = "p2wsh";
    AddressType3["p2tr"] = "p2tr";
    AddressType3["stacks"] = "stacks";
    return AddressType3;
})($adfbe621f07e3fbf$export$189c6ba3eaa96ac2 || {});
var $adfbe621f07e3fbf$export$1f4b34a75f681415 = $asgrE.object({
    address: $asgrE.string(),
    publicKey: $asgrE.string(),
    purpose: $asgrE.enum($adfbe621f07e3fbf$export$b6218cda604ca8c9),
    addressType: $asgrE.enum($adfbe621f07e3fbf$export$189c6ba3eaa96ac2),
    walletType: $adfbe621f07e3fbf$export$27274fc5a05663c
});
// src/addresses/index.ts
var $adfbe621f07e3fbf$export$88411125f012957a = async (options)=>{
    const provider = await $adfbe621f07e3fbf$export$c30e75ed267ee3c5(options.getProvider);
    const { purposes: purposes } = options.payload;
    if (!purposes) throw new Error("Address purposes are required");
    try {
        const request2 = (0, $88dd9319ba2ad0ba$exports.createUnsecuredToken)(options.payload);
        const response = await provider.connect(request2);
        options.onFinish?.(response);
    } catch (error) {
        console.error("[Connect] Error during address request", error);
        options.onCancel?.();
    }
};
var $adfbe621f07e3fbf$export$1773106817ea4e92 = /* @__PURE__ */ ((BitcoinNetworkType2)=>{
    BitcoinNetworkType2["Mainnet"] = "Mainnet";
    BitcoinNetworkType2["Testnet"] = "Testnet";
    BitcoinNetworkType2["Testnet4"] = "Testnet4";
    BitcoinNetworkType2["Signet"] = "Signet";
    BitcoinNetworkType2["Regtest"] = "Regtest";
    return BitcoinNetworkType2;
})($adfbe621f07e3fbf$export$1773106817ea4e92 || {});
var $adfbe621f07e3fbf$export$1b4b53d9862ee443 = $asgrE.optional($asgrE.union([
    $asgrE.string(),
    $asgrE.number(),
    $asgrE.null()
]));
var $adfbe621f07e3fbf$export$8fb26f28887c0fe9 = $asgrE.object({
    jsonrpc: $asgrE.literal("2.0"),
    method: $asgrE.string(),
    params: $asgrE.optional($asgrE.union([
        $asgrE.array($asgrE.unknown()),
        $asgrE.looseObject({}),
        // Note: This is to support current incorrect usage of RPC 2.0. Params need
        // to be either an array or an object when provided. Changing this now would
        // be a breaking change, so accepting null values for now. Tracking in
        // https://linear.app/xverseapp/issue/ENG-4538.
        $asgrE.null()
    ])),
    id: $asgrE.unwrap($adfbe621f07e3fbf$export$1b4b53d9862ee443)
});
var $adfbe621f07e3fbf$export$b376ef3ad38fc2b7 = /* @__PURE__ */ ((RpcErrorCode2)=>{
    RpcErrorCode2[RpcErrorCode2["PARSE_ERROR"] = -32700] = "PARSE_ERROR";
    RpcErrorCode2[RpcErrorCode2["INVALID_REQUEST"] = -32600] = "INVALID_REQUEST";
    RpcErrorCode2[RpcErrorCode2["METHOD_NOT_FOUND"] = -32601] = "METHOD_NOT_FOUND";
    RpcErrorCode2[RpcErrorCode2["INVALID_PARAMS"] = -32602] = "INVALID_PARAMS";
    RpcErrorCode2[RpcErrorCode2["INTERNAL_ERROR"] = -32603] = "INTERNAL_ERROR";
    RpcErrorCode2[RpcErrorCode2["USER_REJECTION"] = -32000] = "USER_REJECTION";
    RpcErrorCode2[RpcErrorCode2["METHOD_NOT_SUPPORTED"] = -32001] = "METHOD_NOT_SUPPORTED";
    RpcErrorCode2[RpcErrorCode2["ACCESS_DENIED"] = -32002] = "ACCESS_DENIED";
    return RpcErrorCode2;
})($adfbe621f07e3fbf$export$b376ef3ad38fc2b7 || {});
var $adfbe621f07e3fbf$export$8cf33954d8681c61 = $asgrE.object({
    jsonrpc: $asgrE.literal("2.0"),
    result: $asgrE.nonOptional($asgrE.unknown()),
    id: $adfbe621f07e3fbf$export$1b4b53d9862ee443
});
var $adfbe621f07e3fbf$export$d429a28c5a3a0402 = $asgrE.object({
    jsonrpc: $asgrE.literal("2.0"),
    error: $asgrE.nonOptional($asgrE.unknown()),
    id: $adfbe621f07e3fbf$export$1b4b53d9862ee443
});
var $adfbe621f07e3fbf$export$f75fab7d0735115e = $asgrE.union([
    $adfbe621f07e3fbf$export$8cf33954d8681c61,
    $adfbe621f07e3fbf$export$d429a28c5a3a0402
]);
var $adfbe621f07e3fbf$export$acce71558956472a = "accountChange";
var $adfbe621f07e3fbf$export$327628bfdc4dc198 = $asgrE.object({
    type: $asgrE.literal($adfbe621f07e3fbf$export$acce71558956472a),
    addresses: $asgrE.optional($asgrE.array($adfbe621f07e3fbf$export$1f4b34a75f681415))
});
var $adfbe621f07e3fbf$export$da0cc2464fe38ddc = "networkChange";
var $adfbe621f07e3fbf$export$e59a51a90e699d61 = $asgrE.object({
    type: $asgrE.literal($adfbe621f07e3fbf$export$da0cc2464fe38ddc),
    bitcoin: $asgrE.object({
        name: $asgrE.enum($adfbe621f07e3fbf$export$1773106817ea4e92)
    }),
    stacks: $asgrE.object({
        name: $asgrE.string()
    })
});
var $adfbe621f07e3fbf$export$922bae0935e22dbe = "disconnect";
var $adfbe621f07e3fbf$export$90eb868647c3c83f = $asgrE.object({
    type: $asgrE.literal($adfbe621f07e3fbf$export$922bae0935e22dbe)
});
var $adfbe621f07e3fbf$export$28854ced5196d7f1 = $asgrE.variant("type", [
    $adfbe621f07e3fbf$export$327628bfdc4dc198,
    $adfbe621f07e3fbf$export$e59a51a90e699d61,
    $adfbe621f07e3fbf$export$90eb868647c3c83f
]);
// src/provider/index.ts
async function $adfbe621f07e3fbf$export$c30e75ed267ee3c5(getProvider) {
    const provider = await getProvider?.() || window.XverseProviders?.BitcoinProvider || window.BitcoinProvider;
    if (!provider) throw new Error("No Bitcoin wallet installed");
    return provider;
}
function $adfbe621f07e3fbf$export$4e044719025cb45d() {
    if (!window.btc_providers) window.btc_providers = [];
    return window.btc_providers;
}
function $adfbe621f07e3fbf$export$367a63e5543d5442(providerId) {
    return providerId?.split(".").reduce((acc, part)=>acc?.[part], window);
}
function $adfbe621f07e3fbf$export$2c7e42d8c9136563(providerId) {
    return !!$adfbe621f07e3fbf$export$367a63e5543d5442(providerId);
}
function $adfbe621f07e3fbf$export$a727891859a233e8(providerId) {
    localStorage.setItem("sats-connect_defaultProvider", providerId);
}
function $adfbe621f07e3fbf$export$4f77a1d3c1ac6642() {
    return localStorage.getItem("sats-connect_defaultProvider");
}
function $adfbe621f07e3fbf$export$27208945b0d79d1f() {
    localStorage.removeItem("sats-connect_defaultProvider");
}
function $adfbe621f07e3fbf$export$8d8f8813b8f9b83() {
    const wallets = Object.values($adfbe621f07e3fbf$export$eea66190956591ea).map((provider)=>{
        return {
            ...provider,
            isInstalled: $adfbe621f07e3fbf$export$2c7e42d8c9136563(provider.id)
        };
    });
    return wallets;
}
var $adfbe621f07e3fbf$export$e7fb53a07ed4093c = "stx_callContract";
var $adfbe621f07e3fbf$export$86e058f7a635494f = $asgrE.object({
    /**
   * The contract principal.
   *
   * E.g. `"SPKE...GD5C.my-contract"`
   */ contract: $asgrE.string(),
    /**
   * The name of the function to call.
   *
   * Note: spec changes ongoing,
   * https://github.com/stacksgov/sips/pull/166#pullrequestreview-1914236999
   */ functionName: $asgrE.string(),
    /**
   * @deprecated in favor of `functionArgs` for @stacks/connect compatibility
   */ arguments: $asgrE.optional($asgrE.array($asgrE.string())),
    /**
   * The function's arguments. The arguments are expected to be hex-encoded
   * strings of Clarity values.
   *
   * To convert Clarity values to their hex representation, the `cvToHex`
   * helper from the `@stacks/transactions` package may be helpful.
   *
   * ```js
   * import { cvToHex } from '@stacks/transactions';
   *
   * const functionArgs = [someClarityValue1, someClarityValue2];
   * const hexArgs = functionArgs.map(cvToHex);
   * ```
   */ functionArgs: $asgrE.optional($asgrE.array($asgrE.string())),
    /**
   * The post conditions to apply to the contract call.
   */ postConditions: $asgrE.optional($asgrE.array($asgrE.string())),
    /**
   * The mode to apply to the post conditions.
   */ postConditionMode: $asgrE.optional($asgrE.union([
        $asgrE.literal("allow"),
        $asgrE.literal("deny")
    ]))
});
var $adfbe621f07e3fbf$export$3d87131daa0a7f8d = $asgrE.object({
    /**
   * The ID of the transaction.
   */ txid: $asgrE.string(),
    /**
   * A Stacks transaction as a hex-encoded string.
   */ transaction: $asgrE.string()
});
var $adfbe621f07e3fbf$export$f91d85924218f0d1 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$e7fb53a07ed4093c),
        params: $adfbe621f07e3fbf$export$86e058f7a635494f,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$6fc1fc1a11f27a0b = "stx_deployContract";
var $adfbe621f07e3fbf$export$7444a17f5c2d1d7e = $asgrE.object({
    /**
   * Name of the contract.
   */ name: $asgrE.string(),
    /**
   * The source code of the Clarity contract.
   */ clarityCode: $asgrE.string(),
    /**
   * The version of the Clarity contract.
   */ clarityVersion: $asgrE.optional($asgrE.string()),
    /**
   * The post conditions to apply to the contract call.
   */ postConditions: $asgrE.optional($asgrE.array($asgrE.string())),
    /**
   * The mode to apply to the post conditions.
   */ postConditionMode: $asgrE.optional($asgrE.union([
        $asgrE.literal("allow"),
        $asgrE.literal("deny")
    ]))
});
var $adfbe621f07e3fbf$export$9941b46c25bcc1b6 = $asgrE.object({
    /**
   * The ID of the transaction.
   */ txid: $asgrE.string(),
    /**
   * A Stacks transaction as a hex-encoded string.
   */ transaction: $asgrE.string()
});
var $adfbe621f07e3fbf$export$b2c04b0d2d59a2ec = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$6fc1fc1a11f27a0b),
        params: $adfbe621f07e3fbf$export$7444a17f5c2d1d7e,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$9e082160bc960a63 = $asgrE.object({
    read: $asgrE.optional($asgrE.boolean())
});
var $adfbe621f07e3fbf$export$99c0d41b97ea09c5 = $asgrE.object({
    readNetwork: $asgrE.optional($asgrE.boolean())
});
var $adfbe621f07e3fbf$export$1b31b229bc45817f = $asgrE.object({
    type: $asgrE.literal("account"),
    resourceId: $asgrE.string(),
    clientId: $asgrE.string(),
    actions: $adfbe621f07e3fbf$export$9e082160bc960a63
});
var $adfbe621f07e3fbf$export$d9ea5c05391dd649 = $asgrE.object({
    type: $asgrE.literal("wallet"),
    resourceId: $asgrE.string(),
    clientId: $asgrE.string(),
    actions: $adfbe621f07e3fbf$export$99c0d41b97ea09c5
});
var $adfbe621f07e3fbf$export$e219d58d2cc01697 = $asgrE.variant("type", [
    $asgrE.object({
        ...$asgrE.omit($adfbe621f07e3fbf$export$1b31b229bc45817f, [
            "clientId"
        ]).entries
    }),
    $asgrE.object({
        ...$asgrE.omit($adfbe621f07e3fbf$export$d9ea5c05391dd649, [
            "clientId"
        ]).entries
    })
]);
var $adfbe621f07e3fbf$export$ff398d236afe1183 = $asgrE.variant("type", [
    $adfbe621f07e3fbf$export$1b31b229bc45817f,
    $adfbe621f07e3fbf$export$d9ea5c05391dd649
]);
var $adfbe621f07e3fbf$export$3a10e7b53d4ed20c = "wallet_requestPermissions";
var $adfbe621f07e3fbf$export$7dd08be48fb11491 = $asgrE.nullish($asgrE.array($adfbe621f07e3fbf$export$e219d58d2cc01697));
var $adfbe621f07e3fbf$export$735a0d4ca88f37b4 = $asgrE.literal(true);
var $adfbe621f07e3fbf$export$aa8b70caf1db7967 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$3a10e7b53d4ed20c),
        params: $adfbe621f07e3fbf$export$7dd08be48fb11491,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$6fc924a9410b5fae = "wallet_renouncePermissions";
var $adfbe621f07e3fbf$export$f254fea8cf5452cd = $asgrE.nullish($asgrE.null());
var $adfbe621f07e3fbf$export$80dfa6022c3f77c5 = $asgrE.nullish($asgrE.null());
var $adfbe621f07e3fbf$export$db2e59fd6b79646 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$6fc924a9410b5fae),
        params: $adfbe621f07e3fbf$export$f254fea8cf5452cd,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$3585a3716ff68a1 = "wallet_disconnect";
var $adfbe621f07e3fbf$export$45241d5266d42bf1 = $asgrE.nullish($asgrE.null());
var $adfbe621f07e3fbf$export$c70b7303c7fb14c6 = $asgrE.nullish($asgrE.null());
var $adfbe621f07e3fbf$export$d1b29ebafe0342cb = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$3585a3716ff68a1),
        params: $adfbe621f07e3fbf$export$45241d5266d42bf1,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$355811880db3a744 = "wallet_getWalletType";
var $adfbe621f07e3fbf$export$c691bef0cfbfd6b9 = $asgrE.nullish($asgrE.null());
var $adfbe621f07e3fbf$export$5b92c6d73950f33d = $adfbe621f07e3fbf$export$27274fc5a05663c;
var $adfbe621f07e3fbf$export$53cfa8ce7eea3201 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$355811880db3a744),
        params: $adfbe621f07e3fbf$export$c691bef0cfbfd6b9,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$c984795ed70d226f = "wallet_getCurrentPermissions";
var $adfbe621f07e3fbf$export$f0eeeafad706c08e = $asgrE.nullish($asgrE.null());
var $adfbe621f07e3fbf$export$bd6398e37ce845cc = $asgrE.array($adfbe621f07e3fbf$export$ff398d236afe1183);
var $adfbe621f07e3fbf$export$e11fdb615a262b26 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$c984795ed70d226f),
        params: $adfbe621f07e3fbf$export$f0eeeafad706c08e,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$62e3e70d6c0d3ff5 = "wallet_getNetwork";
var $adfbe621f07e3fbf$export$1ba981a68f2ac0e4 = $asgrE.nullish($asgrE.null());
var $adfbe621f07e3fbf$export$2e9df7d0bf3fa49b = $asgrE.object({
    bitcoin: $asgrE.object({
        name: $asgrE.enum($adfbe621f07e3fbf$export$1773106817ea4e92)
    }),
    stacks: $asgrE.object({
        name: $asgrE.string()
    })
});
var $adfbe621f07e3fbf$export$625324653b447eb0 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$62e3e70d6c0d3ff5),
        params: $adfbe621f07e3fbf$export$1ba981a68f2ac0e4,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$ef3ec89374407a64 = "wallet_changeNetwork";
var $adfbe621f07e3fbf$export$e51fdce2213c1c0b = $asgrE.object({
    name: $asgrE.enum($adfbe621f07e3fbf$export$1773106817ea4e92)
});
var $adfbe621f07e3fbf$export$d56f4ef7eab38786 = $asgrE.nullish($asgrE.null());
var $adfbe621f07e3fbf$export$44c53cd7e599b979 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$ef3ec89374407a64),
        params: $adfbe621f07e3fbf$export$e51fdce2213c1c0b,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$459c4cbd71e84cdc = "wallet_getAccount";
var $adfbe621f07e3fbf$export$cba9cb21cbc2531c = $asgrE.nullish($asgrE.null());
var $adfbe621f07e3fbf$export$5a26746990d7f333 = $asgrE.object({
    id: $asgrE.string(),
    addresses: $asgrE.array($adfbe621f07e3fbf$export$1f4b34a75f681415),
    walletType: $adfbe621f07e3fbf$export$27274fc5a05663c,
    network: $adfbe621f07e3fbf$export$2e9df7d0bf3fa49b
});
var $adfbe621f07e3fbf$export$b05f446a2daa3932 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$459c4cbd71e84cdc),
        params: $adfbe621f07e3fbf$export$cba9cb21cbc2531c,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$7ac6097daef4ed2e = "wallet_connect";
var $adfbe621f07e3fbf$export$19675e179db1ae16 = $asgrE.nullish($asgrE.object({
    permissions: $asgrE.optional($asgrE.array($adfbe621f07e3fbf$export$e219d58d2cc01697)),
    addresses: $asgrE.optional($asgrE.array($asgrE.enum($adfbe621f07e3fbf$export$b6218cda604ca8c9))),
    message: $asgrE.optional($asgrE.pipe($asgrE.string(), $asgrE.maxLength(80, "The message must not exceed 80 characters."))),
    network: $asgrE.optional($asgrE.enum($adfbe621f07e3fbf$export$1773106817ea4e92))
}));
var $adfbe621f07e3fbf$export$84a30b81f4da4ced = $asgrE.object({
    id: $asgrE.string(),
    addresses: $asgrE.array($adfbe621f07e3fbf$export$1f4b34a75f681415),
    walletType: $adfbe621f07e3fbf$export$27274fc5a05663c,
    network: $adfbe621f07e3fbf$export$2e9df7d0bf3fa49b
});
var $adfbe621f07e3fbf$export$a48d621a0acc58ba = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$7ac6097daef4ed2e),
        params: $adfbe621f07e3fbf$export$19675e179db1ae16,
        id: $asgrE.string()
    }).entries
});
// src/request/types/stxMethods/getAccounts.ts
var $adfbe621f07e3fbf$export$40bc7dc74559c4f7 = "stx_getAccounts";
var $adfbe621f07e3fbf$export$da52e4aa01a8caad = $asgrE.nullish($asgrE.null());
var $adfbe621f07e3fbf$export$c659b037e8551018 = $asgrE.object({
    /**
   * The addresses generated for the given purposes.
   */ addresses: $asgrE.array($asgrE.object({
        address: $asgrE.string(),
        publicKey: $asgrE.string(),
        gaiaHubUrl: $asgrE.string(),
        gaiaAppKey: $asgrE.string()
    })),
    network: $adfbe621f07e3fbf$export$2e9df7d0bf3fa49b
});
var $adfbe621f07e3fbf$export$ebbdcaae7ee552e3 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$40bc7dc74559c4f7),
        params: $adfbe621f07e3fbf$export$da52e4aa01a8caad,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$a2a93518a9a4fc02 = "stx_getAddresses";
var $adfbe621f07e3fbf$export$d081480e45110fdb = $asgrE.nullish($asgrE.object({
    /**
     * A message to be displayed to the user in the request prompt.
     */ message: $asgrE.optional($asgrE.string())
}));
var $adfbe621f07e3fbf$export$512eac7a360b0909 = $asgrE.object({
    /**
   * The addresses generated for the given purposes.
   */ addresses: $asgrE.array($adfbe621f07e3fbf$export$1f4b34a75f681415),
    network: $adfbe621f07e3fbf$export$2e9df7d0bf3fa49b
});
var $adfbe621f07e3fbf$export$3f17c71ab706b862 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$a2a93518a9a4fc02),
        params: $adfbe621f07e3fbf$export$d081480e45110fdb,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$fbbe29ead7e773fd = "stx_signMessage";
var $adfbe621f07e3fbf$export$8e89c6c5bbc13c90 = $asgrE.object({
    /**
   * The message to sign.
   */ message: $asgrE.string()
});
var $adfbe621f07e3fbf$export$446c22c59eb576fd = $asgrE.object({
    /**
   * The signature of the message.
   */ signature: $asgrE.string(),
    /**
   * The public key used to sign the message.
   */ publicKey: $asgrE.string()
});
var $adfbe621f07e3fbf$export$b8d6e42d16e0937f = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$fbbe29ead7e773fd),
        params: $adfbe621f07e3fbf$export$8e89c6c5bbc13c90,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$a37c1d69d49383c = "stx_signStructuredMessage";
var $adfbe621f07e3fbf$export$f67e1a7aa06455b = $asgrE.object({
    /**
   * The domain to be signed.
   */ domain: $asgrE.string(),
    /**
   * Message payload to be signed.
   */ message: $asgrE.string(),
    /**
   * The public key to sign the message with.
   */ publicKey: $asgrE.optional($asgrE.string())
});
var $adfbe621f07e3fbf$export$9dc4983cfdb48521 = $asgrE.object({
    /**
   * Signature of the message.
   */ signature: $asgrE.string(),
    /**
   * Public key as hex-encoded string.
   */ publicKey: $asgrE.string()
});
var $adfbe621f07e3fbf$export$62cc4e8277dbe19b = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$a37c1d69d49383c),
        params: $adfbe621f07e3fbf$export$f67e1a7aa06455b,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$d7671403004b97f0 = "stx_signTransaction";
var $adfbe621f07e3fbf$export$e11c7bc31678709b = $asgrE.object({
    /**
   * The transaction to sign as a hex-encoded string.
   */ transaction: $asgrE.string(),
    /**
   * The public key to sign the transaction with. The wallet may use any key
   * when not provided.
   */ pubkey: $asgrE.optional($asgrE.string()),
    /**
   * Whether to broadcast the transaction after signing. Defaults to `true`.
   */ broadcast: $asgrE.optional($asgrE.boolean())
});
var $adfbe621f07e3fbf$export$a2e671be678d11da = $asgrE.object({
    /**
   * The signed transaction as a hex-encoded string.
   */ transaction: $asgrE.string()
});
var $adfbe621f07e3fbf$export$102e657b68b47db0 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$d7671403004b97f0),
        params: $adfbe621f07e3fbf$export$e11c7bc31678709b,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$fe73bfb8ca1788a2 = "stx_signTransactions";
var $adfbe621f07e3fbf$export$fdd18d423c07c160 = $asgrE.object({
    /**
   * The transactions to sign as hex-encoded strings.
   */ transactions: $asgrE.pipe($asgrE.array($asgrE.pipe($asgrE.string(), $asgrE.check((hex)=>{
        return true;
    }, "Invalid hex-encoded Stacks transaction."))), $asgrE.minLength(1)),
    /**
   * Whether the signed transactions should be broadcast after signing. Defaults
   * to `true`.
   */ broadcast: $asgrE.optional($asgrE.boolean())
});
var $adfbe621f07e3fbf$export$d3c3a8a5e2a858c8 = $asgrE.object({
    /**
   * The signed transactions as hex-encoded strings, in the same order as in the
   * sign request.
   */ transactions: $asgrE.array($asgrE.string())
});
var $adfbe621f07e3fbf$export$5392bf754f613943 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$fe73bfb8ca1788a2),
        params: $adfbe621f07e3fbf$export$fdd18d423c07c160,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$c67513e7f00fca3d = "stx_transferStx";
var $adfbe621f07e3fbf$export$8996b13982c3fc48 = $asgrE.object({
    /**
   * Amount of STX tokens to transfer in microstacks as a string. Anything
   * parseable by `BigInt` is acceptable.
   *
   * Example,
   *
   * ```js
   * const amount1 = 1234;
   * const amount2 = 1234n;
   * const amount3 = '1234';
   * ```
   */ amount: $asgrE.union([
        $asgrE.number(),
        $asgrE.string()
    ]),
    /**
   * The recipeint's principal.
   */ recipient: $asgrE.string(),
    /**
   * A string representing the memo.
   */ memo: $asgrE.optional($asgrE.string()),
    /**
   * Version of parameter format.
   */ version: $asgrE.optional($asgrE.string()),
    /**
   * The mode of the post conditions.
   */ postConditionMode: $asgrE.optional($asgrE.number()),
    /**
   * A hex-encoded string representing the post conditions.
   *
   * A post condition may be converted to it's hex representation using the `serializePostCondition` helper from the `@stacks/transactions` package,
   *
   * ```js
   * import { serializePostCondition } from '@stacks/transactions';
   *
   * const postCondition = somePostCondition;
   * const hexPostCondition = serializePostCondition(postCondition).toString('hex');
   * ```
   */ postConditions: $asgrE.optional($asgrE.array($asgrE.string())),
    /**
   * The public key to sign the transaction with. The wallet may use any key
   * when not provided.
   */ pubkey: $asgrE.optional($asgrE.string())
});
var $adfbe621f07e3fbf$export$5c7774d6150e6b67 = $asgrE.object({
    /**
   * The ID of the transaction.
   */ txid: $asgrE.string(),
    /**
   * A Stacks transaction as a hex-encoded string.
   */ transaction: $asgrE.string()
});
var $adfbe621f07e3fbf$export$df67d763167b152d = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$c67513e7f00fca3d),
        params: $adfbe621f07e3fbf$export$8996b13982c3fc48,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$6797c3de3a93bf59 = "getInfo";
var $adfbe621f07e3fbf$export$70c701e9f984f97a = $asgrE.nullish($asgrE.null());
var $adfbe621f07e3fbf$export$317799cf1f35c899 = $asgrE.object({
    /**
   * Version of the wallet.
   */ version: $asgrE.string(),
    /**
   * [WBIP](https://wbips.netlify.app/wbips/WBIP002) methods supported by the wallet.
   */ methods: $asgrE.optional($asgrE.array($asgrE.string())),
    /**
   * List of WBIP standards supported by the wallet. Not currently used.
   */ supports: $asgrE.array($asgrE.string())
});
var $adfbe621f07e3fbf$export$da8296f0c82c6882 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$6797c3de3a93bf59),
        params: $adfbe621f07e3fbf$export$70c701e9f984f97a,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$b885a41c5fea7b53 = "getAddresses";
var $adfbe621f07e3fbf$export$aafbdd453a719be4 = $asgrE.object({
    /**
   * The purposes for which to generate addresses. See
   * {@linkcode AddressPurpose} for available purposes.
   */ purposes: $asgrE.array($asgrE.enum($adfbe621f07e3fbf$export$b6218cda604ca8c9)),
    /**
   * A message to be displayed to the user in the request prompt.
   */ message: $asgrE.optional($asgrE.string())
});
var $adfbe621f07e3fbf$export$ed0e0a5e162a0c4f = $asgrE.object({
    /**
   * The addresses generated for the given purposes.
   */ addresses: $asgrE.array($adfbe621f07e3fbf$export$1f4b34a75f681415),
    network: $adfbe621f07e3fbf$export$2e9df7d0bf3fa49b
});
var $adfbe621f07e3fbf$export$ee09fc22b5ff6437 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$b885a41c5fea7b53),
        params: $adfbe621f07e3fbf$export$aafbdd453a719be4,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$57979915a7152a15 = "signMessage";
var $adfbe621f07e3fbf$export$55ecfd40d9826802 = /* @__PURE__ */ ((MessageSigningProtocols2)=>{
    MessageSigningProtocols2["ECDSA"] = "ECDSA";
    MessageSigningProtocols2["BIP322"] = "BIP322";
    return MessageSigningProtocols2;
})($adfbe621f07e3fbf$export$55ecfd40d9826802 || {});
var $adfbe621f07e3fbf$export$7925ecc25528982e = $asgrE.object({
    /**
   * The address used for signing.
   **/ address: $asgrE.string(),
    /**
   * The message to sign.
   **/ message: $asgrE.string(),
    /**
   * The protocol to use for signing the message.
   */ protocol: $asgrE.optional($asgrE.enum($adfbe621f07e3fbf$export$55ecfd40d9826802))
});
var $adfbe621f07e3fbf$export$7291bc53dfc44191 = $asgrE.object({
    /**
   * The signature of the message.
   */ signature: $asgrE.string(),
    /**
   * hash of the message.
   */ messageHash: $asgrE.string(),
    /**
   * The address used for signing.
   */ address: $asgrE.string(),
    /**
   * The protocol to use for signing the message.
   */ protocol: $asgrE.enum($adfbe621f07e3fbf$export$55ecfd40d9826802)
});
var $adfbe621f07e3fbf$export$98d37c1ae07c64a3 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$57979915a7152a15),
        params: $adfbe621f07e3fbf$export$7925ecc25528982e,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$9e10833d0ba23e0f = "sendTransfer";
var $adfbe621f07e3fbf$export$cc05fc7ff99e697a = $asgrE.object({
    /**
   * Array of recipients to send to.
   * The amount to send to each recipient is in satoshis.
   */ recipients: $asgrE.array($asgrE.object({
        address: $asgrE.string(),
        amount: $asgrE.number()
    }))
});
var $adfbe621f07e3fbf$export$b5d443cbcebbf519 = $asgrE.object({
    /**
   * The transaction id as a hex-encoded string.
   */ txid: $asgrE.string()
});
var $adfbe621f07e3fbf$export$484d587245bac436 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$9e10833d0ba23e0f),
        params: $adfbe621f07e3fbf$export$cc05fc7ff99e697a,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$ddff9cf0444f1f98 = "signPsbt";
var $adfbe621f07e3fbf$export$ededc6bc05748fd3 = $asgrE.object({
    /**
   * The base64 encoded PSBT to sign.
   */ psbt: $asgrE.string(),
    /**
   * The inputs to sign.
   * The key is the address and the value is an array of indexes of the inputs to sign.
   */ signInputs: $asgrE.record($asgrE.string(), $asgrE.array($asgrE.number())),
    /**
   * Whether to broadcast the transaction after signing.
   **/ broadcast: $asgrE.optional($asgrE.boolean())
});
var $adfbe621f07e3fbf$export$f9445d6941e76a34 = $asgrE.object({
    /**
   * The base64 encoded PSBT after signing.
   */ psbt: $asgrE.string(),
    /**
   * The transaction id as a hex-encoded string.
   * This is only returned if the transaction was broadcast.
   **/ txid: $asgrE.optional($asgrE.string())
});
var $adfbe621f07e3fbf$export$bacd77bf0025fb15 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$ddff9cf0444f1f98),
        params: $adfbe621f07e3fbf$export$ededc6bc05748fd3,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$fc7bb88c977eaf4 = "getAccounts";
var $adfbe621f07e3fbf$export$c0b1f00fa3b7a8b3 = $asgrE.object({
    /**
   * The purposes for which to generate addresses. See
   * {@linkcode AddressPurpose} for available purposes.
   */ purposes: $asgrE.array($asgrE.enum($adfbe621f07e3fbf$export$b6218cda604ca8c9)),
    /**
   * A message to be displayed to the user in the request prompt.
   */ message: $asgrE.optional($asgrE.string())
});
var $adfbe621f07e3fbf$export$1270bef2fbecba5d = $asgrE.array($asgrE.object({
    ...$adfbe621f07e3fbf$export$1f4b34a75f681415.entries,
    ...$asgrE.object({
        walletType: $adfbe621f07e3fbf$export$27274fc5a05663c
    }).entries
}));
var $adfbe621f07e3fbf$export$dd4c6aee2d812207 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$fc7bb88c977eaf4),
        params: $adfbe621f07e3fbf$export$c0b1f00fa3b7a8b3,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$31eff28b677405e9 = "getBalance";
var $adfbe621f07e3fbf$export$470ea97664181427 = $asgrE.nullish($asgrE.null());
var $adfbe621f07e3fbf$export$9a48d3c783d89680 = $asgrE.object({
    /**
   * The confirmed balance of the wallet in sats. Using a string due to chrome
   * messages not supporting bigint
   * (https://issues.chromium.org/issues/40116184).
   */ confirmed: $asgrE.string(),
    /**
   * The unconfirmed balance of the wallet in sats. Using a string due to chrome
   * messages not supporting bigint
   * (https://issues.chromium.org/issues/40116184).
   */ unconfirmed: $asgrE.string(),
    /**
   * The total balance (both confirmed and unconfrimed UTXOs) of the wallet in
   * sats. Using a string due to chrome messages not supporting bigint
   * (https://issues.chromium.org/issues/40116184).
   */ total: $asgrE.string()
});
var $adfbe621f07e3fbf$export$9e5e1be5a11b18a8 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$31eff28b677405e9),
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$27b678a47513abfd = "runes_etch";
var $adfbe621f07e3fbf$var$etchTermsSchema = $asgrE.object({
    amount: $asgrE.string(),
    cap: $asgrE.string(),
    heightStart: $asgrE.optional($asgrE.string()),
    heightEnd: $asgrE.optional($asgrE.string()),
    offsetStart: $asgrE.optional($asgrE.string()),
    offsetEnd: $asgrE.optional($asgrE.string())
});
var $adfbe621f07e3fbf$var$inscriptionDetailsSchema = $asgrE.object({
    contentType: $asgrE.string(),
    contentBase64: $asgrE.string()
});
var $adfbe621f07e3fbf$export$3bf5646b585d329f = $asgrE.object({
    runeName: $asgrE.string(),
    divisibility: $asgrE.optional($asgrE.number()),
    symbol: $asgrE.optional($asgrE.string()),
    premine: $asgrE.optional($asgrE.string()),
    isMintable: $asgrE.boolean(),
    delegateInscriptionId: $asgrE.optional($asgrE.string()),
    destinationAddress: $asgrE.string(),
    refundAddress: $asgrE.string(),
    feeRate: $asgrE.number(),
    appServiceFee: $asgrE.optional($asgrE.number()),
    appServiceFeeAddress: $asgrE.optional($asgrE.string()),
    terms: $asgrE.optional($adfbe621f07e3fbf$var$etchTermsSchema),
    inscriptionDetails: $asgrE.optional($adfbe621f07e3fbf$var$inscriptionDetailsSchema),
    network: $asgrE.optional($asgrE.enum($adfbe621f07e3fbf$export$1773106817ea4e92))
});
var $adfbe621f07e3fbf$export$bd7ebc8f3596daea = $asgrE.object({
    orderId: $asgrE.string(),
    fundTransactionId: $asgrE.string(),
    fundingAddress: $asgrE.string()
});
var $adfbe621f07e3fbf$export$d246b02186dd3859 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$27b678a47513abfd),
        params: $adfbe621f07e3fbf$export$3bf5646b585d329f,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$ec23479105bd4057 = "runes_getBalance";
var $adfbe621f07e3fbf$export$1eb9e9da951a1e01 = $asgrE.nullish($asgrE.null());
var $adfbe621f07e3fbf$export$7339b8d23e80b463 = $asgrE.object({
    balances: $asgrE.array($asgrE.object({
        runeName: $asgrE.string(),
        amount: $asgrE.string(),
        divisibility: $asgrE.number(),
        symbol: $asgrE.string(),
        inscriptionId: $asgrE.nullish($asgrE.string()),
        spendableBalance: $asgrE.string()
    }))
});
var $adfbe621f07e3fbf$export$960eca50d393a156 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$ec23479105bd4057),
        params: $adfbe621f07e3fbf$export$1eb9e9da951a1e01,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$6aa749011b81ef77 = "runes_mint";
var $adfbe621f07e3fbf$export$facbd9133910d79d = $asgrE.object({
    appServiceFee: $asgrE.optional($asgrE.number()),
    appServiceFeeAddress: $asgrE.optional($asgrE.string()),
    destinationAddress: $asgrE.string(),
    feeRate: $asgrE.number(),
    refundAddress: $asgrE.string(),
    repeats: $asgrE.number(),
    runeName: $asgrE.string(),
    network: $asgrE.optional($asgrE.enum($adfbe621f07e3fbf$export$1773106817ea4e92))
});
var $adfbe621f07e3fbf$export$b1e6cbfd20b514be = $asgrE.object({
    orderId: $asgrE.string(),
    fundTransactionId: $asgrE.string(),
    fundingAddress: $asgrE.string()
});
var $adfbe621f07e3fbf$export$42d55a544b5222ce = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$6aa749011b81ef77),
        params: $adfbe621f07e3fbf$export$facbd9133910d79d,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$f0eede8b950bcd1 = "runes_transfer";
var $adfbe621f07e3fbf$export$b6c7881b81a69bc = $asgrE.object({
    recipients: $asgrE.array($asgrE.object({
        runeName: $asgrE.string(),
        amount: $asgrE.string(),
        address: $asgrE.string()
    }))
});
var $adfbe621f07e3fbf$export$313a9ca93ef71e21 = $asgrE.object({
    txid: $asgrE.string()
});
var $adfbe621f07e3fbf$export$10d6d584786b3973 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$f0eede8b950bcd1),
        params: $adfbe621f07e3fbf$export$b6c7881b81a69bc,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$633787be56c106e2 = "ord_getInscriptions";
var $adfbe621f07e3fbf$export$29dee8f40a366a75 = $asgrE.object({
    offset: $asgrE.number(),
    limit: $asgrE.number()
});
var $adfbe621f07e3fbf$export$f52a223b64269ac7 = $asgrE.object({
    total: $asgrE.number(),
    limit: $asgrE.number(),
    offset: $asgrE.number(),
    inscriptions: $asgrE.array($asgrE.object({
        inscriptionId: $asgrE.string(),
        inscriptionNumber: $asgrE.string(),
        address: $asgrE.string(),
        collectionName: $asgrE.optional($asgrE.string()),
        postage: $asgrE.string(),
        contentLength: $asgrE.string(),
        contentType: $asgrE.string(),
        timestamp: $asgrE.number(),
        offset: $asgrE.number(),
        genesisTransaction: $asgrE.string(),
        output: $asgrE.string()
    }))
});
var $adfbe621f07e3fbf$export$4c28ba8562472297 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$633787be56c106e2),
        params: $adfbe621f07e3fbf$export$29dee8f40a366a75,
        id: $asgrE.string()
    }).entries
});
var $adfbe621f07e3fbf$export$3f42059a05c6877d = "ord_sendInscriptions";
var $adfbe621f07e3fbf$export$65bdc77d2652724f = $asgrE.object({
    transfers: $asgrE.array($asgrE.object({
        address: $asgrE.string(),
        inscriptionId: $asgrE.string()
    }))
});
var $adfbe621f07e3fbf$export$49a8b3b6fe6cfba7 = $asgrE.object({
    txid: $asgrE.string()
});
var $adfbe621f07e3fbf$export$9df34d457363d7f6 = $asgrE.object({
    ...$adfbe621f07e3fbf$export$8fb26f28887c0fe9.entries,
    ...$asgrE.object({
        method: $asgrE.literal($adfbe621f07e3fbf$export$3f42059a05c6877d),
        params: $adfbe621f07e3fbf$export$65bdc77d2652724f,
        id: $asgrE.string()
    }).entries
});
// src/request/index.ts
var $adfbe621f07e3fbf$export$b5fe3f66a567bec0 = async (method, params, providerId)=>{
    let provider = window.XverseProviders?.BitcoinProvider || window.BitcoinProvider;
    if (providerId) provider = await $adfbe621f07e3fbf$export$367a63e5543d5442(providerId);
    if (!provider) throw new Error("no wallet provider was found");
    if (!method) throw new Error("A wallet method is required");
    const response = await provider.request(method, params);
    if ($asgrE.is($adfbe621f07e3fbf$export$d429a28c5a3a0402, response)) return {
        status: "error",
        error: response.error
    };
    if ($asgrE.is($adfbe621f07e3fbf$export$8cf33954d8681c61, response)) return {
        status: "success",
        result: response.result
    };
    return {
        status: "error",
        error: {
            code: -32603 /* INTERNAL_ERROR */ ,
            message: "Received unknown response from provider.",
            data: response
        }
    };
};
var $adfbe621f07e3fbf$export$f03a6b845d3fb58b = (event, cb, providerId)=>{
    let provider = window.XverseProviders?.BitcoinProvider || window.BitcoinProvider;
    if (providerId) provider = $adfbe621f07e3fbf$export$367a63e5543d5442(providerId);
    if (!provider) throw new Error("no wallet provider was found");
    if (!provider.addListener) {
        console.error(`The wallet provider you are using does not support the addListener method. Please update your wallet provider.`);
        return ()=>{};
    }
    return provider.addListener(event, cb);
};
var $adfbe621f07e3fbf$var$urlNetworkSuffix = {
    ["Mainnet" /* Mainnet */ ]: "",
    ["Testnet" /* Testnet */ ]: "-testnet",
    ["Testnet4" /* Testnet4 */ ]: "-testnet4",
    ["Signet" /* Signet */ ]: "-signet"
};
var $adfbe621f07e3fbf$var$ORDINALS_API_BASE_URL = (network = "Mainnet" /* Mainnet */ )=>{
    if (network === "Regtest" /* Regtest */ ) throw new Error(`Ordinals API does not support ${network} network`);
    return `https://ordinals${$adfbe621f07e3fbf$var$urlNetworkSuffix[network]}.xverse.app/v1`;
};
var $adfbe621f07e3fbf$var$RunesApi = class {
    client;
    constructor(network){
        this.client = (0, $cf69f5c5e40703db$export$2e2bcd8739ae039).create({
            baseURL: $adfbe621f07e3fbf$var$ORDINALS_API_BASE_URL(network)
        });
    }
    parseError = (error)=>{
        return {
            code: error.response?.status,
            message: JSON.stringify(error.response?.data)
        };
    };
    estimateMintCost = async (mintParams)=>{
        try {
            const response = await this.client.post("/runes/mint/estimate", {
                ...mintParams
            });
            return {
                data: response.data
            };
        } catch (error) {
            const err = error;
            return {
                error: this.parseError(err)
            };
        }
    };
    estimateEtchCost = async (etchParams)=>{
        try {
            const response = await this.client.post("/runes/etch/estimate", {
                ...etchParams
            });
            return {
                data: response.data
            };
        } catch (error) {
            const err = error;
            return {
                error: this.parseError(err)
            };
        }
    };
    createMintOrder = async (mintOrderParams)=>{
        try {
            const response = await this.client.post("/runes/mint/orders", {
                ...mintOrderParams
            });
            return {
                data: response.data
            };
        } catch (error) {
            const err = error;
            return {
                error: this.parseError(err)
            };
        }
    };
    createEtchOrder = async (etchOrderParams)=>{
        try {
            const response = await this.client.post("/runes/etch/orders", {
                ...etchOrderParams
            });
            return {
                data: response.data
            };
        } catch (error) {
            const err = error;
            return {
                error: this.parseError(err)
            };
        }
    };
    executeMint = async (orderId, fundTransactionId)=>{
        try {
            const response = await this.client.post(`/runes/mint/orders/${orderId}/execute`, {
                fundTransactionId: fundTransactionId
            });
            return {
                data: response.data
            };
        } catch (error) {
            const err = error;
            return {
                error: this.parseError(err)
            };
        }
    };
    executeEtch = async (orderId, fundTransactionId)=>{
        try {
            const response = await this.client.post(`/runes/etch/orders/${orderId}/execute`, {
                fundTransactionId: fundTransactionId
            });
            return {
                data: response.data
            };
        } catch (error) {
            const err = error;
            return {
                error: this.parseError(err)
            };
        }
    };
    getOrder = async (orderId)=>{
        try {
            const response = await this.client.get(`/orders/${orderId}`);
            return {
                data: response.data
            };
        } catch (error) {
            const err = error;
            return {
                error: this.parseError(err)
            };
        }
    };
    rbfOrder = async (rbfRequest)=>{
        const { orderId: orderId, newFeeRate: newFeeRate } = rbfRequest;
        try {
            const response = await this.client.post(`/orders/${orderId}/rbf-estimate`, {
                newFeeRate: newFeeRate
            });
            return {
                data: response.data
            };
        } catch (error) {
            const err = error;
            return {
                error: this.parseError(err)
            };
        }
    };
};
var $adfbe621f07e3fbf$var$clients = {};
var $adfbe621f07e3fbf$var$getRunesApiClient = (network = "Mainnet" /* Mainnet */ )=>{
    if (!$adfbe621f07e3fbf$var$clients[network]) $adfbe621f07e3fbf$var$clients[network] = new $adfbe621f07e3fbf$var$RunesApi(network);
    return $adfbe621f07e3fbf$var$clients[network];
};
// src/adapters/satsConnectAdapter.ts
var $adfbe621f07e3fbf$export$9ce9842739eebc36 = class {
    async mintRunes(params) {
        try {
            const walletInfo = await this.requestInternal("getInfo", null).catch(()=>null);
            if (walletInfo && walletInfo.status === "success") {
                const isMintSupported = walletInfo.result.methods?.includes("runes_mint");
                if (isMintSupported) {
                    const response = await this.requestInternal("runes_mint", params);
                    if (response) {
                        if (response.status === "success") return response;
                        if (response.status === "error" && response.error.code !== -32601 /* METHOD_NOT_FOUND */ ) return response;
                    }
                }
            }
            const mintRequest = {
                destinationAddress: params.destinationAddress,
                feeRate: params.feeRate,
                refundAddress: params.refundAddress,
                repeats: params.repeats,
                runeName: params.runeName,
                appServiceFee: params.appServiceFee,
                appServiceFeeAddress: params.appServiceFeeAddress
            };
            const orderResponse = await new $adfbe621f07e3fbf$var$RunesApi(params.network).createMintOrder(mintRequest);
            if (!orderResponse.data) return {
                status: "error",
                error: {
                    code: orderResponse.error.code === 400 ? -32600 /* INVALID_REQUEST */  : -32603 /* INTERNAL_ERROR */ ,
                    message: orderResponse.error.message
                }
            };
            const paymentResponse = await this.requestInternal("sendTransfer", {
                recipients: [
                    {
                        address: orderResponse.data.fundAddress,
                        amount: orderResponse.data.fundAmount
                    }
                ]
            });
            if (paymentResponse.status !== "success") return paymentResponse;
            await new $adfbe621f07e3fbf$var$RunesApi(params.network).executeMint(orderResponse.data.orderId, paymentResponse.result.txid);
            return {
                status: "success",
                result: {
                    orderId: orderResponse.data.orderId,
                    fundTransactionId: paymentResponse.result.txid,
                    fundingAddress: orderResponse.data.fundAddress
                }
            };
        } catch (error) {
            return {
                status: "error",
                error: {
                    code: -32603 /* INTERNAL_ERROR */ ,
                    message: error.message
                }
            };
        }
    }
    async etchRunes(params) {
        const etchRequest = {
            destinationAddress: params.destinationAddress,
            refundAddress: params.refundAddress,
            feeRate: params.feeRate,
            runeName: params.runeName,
            divisibility: params.divisibility,
            symbol: params.symbol,
            premine: params.premine,
            isMintable: params.isMintable,
            terms: params.terms,
            inscriptionDetails: params.inscriptionDetails,
            delegateInscriptionId: params.delegateInscriptionId,
            appServiceFee: params.appServiceFee,
            appServiceFeeAddress: params.appServiceFeeAddress
        };
        try {
            const walletInfo = await this.requestInternal("getInfo", null).catch(()=>null);
            if (walletInfo && walletInfo.status === "success") {
                const isEtchSupported = walletInfo.result.methods?.includes("runes_etch");
                if (isEtchSupported) {
                    const response = await this.requestInternal("runes_etch", params);
                    if (response) {
                        if (response.status === "success") return response;
                        if (response.status === "error" && response.error.code !== -32601 /* METHOD_NOT_FOUND */ ) return response;
                    }
                }
            }
            const orderResponse = await new $adfbe621f07e3fbf$var$RunesApi(params.network).createEtchOrder(etchRequest);
            if (!orderResponse.data) return {
                status: "error",
                error: {
                    code: orderResponse.error.code === 400 ? -32600 /* INVALID_REQUEST */  : -32603 /* INTERNAL_ERROR */ ,
                    message: orderResponse.error.message
                }
            };
            const paymentResponse = await this.requestInternal("sendTransfer", {
                recipients: [
                    {
                        address: orderResponse.data.fundAddress,
                        amount: orderResponse.data.fundAmount
                    }
                ]
            });
            if (paymentResponse.status !== "success") return paymentResponse;
            await new $adfbe621f07e3fbf$var$RunesApi(params.network).executeEtch(orderResponse.data.orderId, paymentResponse.result.txid);
            return {
                status: "success",
                result: {
                    orderId: orderResponse.data.orderId,
                    fundTransactionId: paymentResponse.result.txid,
                    fundingAddress: orderResponse.data.fundAddress
                }
            };
        } catch (error) {
            return {
                status: "error",
                error: {
                    code: -32603 /* INTERNAL_ERROR */ ,
                    message: error.message
                }
            };
        }
    }
    async estimateMint(params) {
        const estimateMintRequest = {
            destinationAddress: params.destinationAddress,
            feeRate: params.feeRate,
            repeats: params.repeats,
            runeName: params.runeName,
            appServiceFee: params.appServiceFee,
            appServiceFeeAddress: params.appServiceFeeAddress
        };
        const response = await $adfbe621f07e3fbf$var$getRunesApiClient(params.network).estimateMintCost(estimateMintRequest);
        if (response.data) return {
            status: "success",
            result: response.data
        };
        return {
            status: "error",
            error: {
                code: response.error.code === 400 ? -32600 /* INVALID_REQUEST */  : -32603 /* INTERNAL_ERROR */ ,
                message: response.error.message
            }
        };
    }
    async estimateEtch(params) {
        const estimateEtchRequest = {
            destinationAddress: params.destinationAddress,
            feeRate: params.feeRate,
            runeName: params.runeName,
            divisibility: params.divisibility,
            symbol: params.symbol,
            premine: params.premine,
            isMintable: params.isMintable,
            terms: params.terms,
            inscriptionDetails: params.inscriptionDetails,
            delegateInscriptionId: params.delegateInscriptionId,
            appServiceFee: params.appServiceFee,
            appServiceFeeAddress: params.appServiceFeeAddress
        };
        const response = await $adfbe621f07e3fbf$var$getRunesApiClient(params.network).estimateEtchCost(estimateEtchRequest);
        if (response.data) return {
            status: "success",
            result: response.data
        };
        return {
            status: "error",
            error: {
                code: response.error.code === 400 ? -32600 /* INVALID_REQUEST */  : -32603 /* INTERNAL_ERROR */ ,
                message: response.error.message
            }
        };
    }
    async getOrder(params) {
        const response = await $adfbe621f07e3fbf$var$getRunesApiClient(params.network).getOrder(params.id);
        if (response.data) return {
            status: "success",
            result: response.data
        };
        return {
            status: "error",
            error: {
                code: response.error.code === 400 || response.error.code === 404 ? -32600 /* INVALID_REQUEST */  : -32603 /* INTERNAL_ERROR */ ,
                message: response.error.message
            }
        };
    }
    async estimateRbfOrder(params) {
        const rbfOrderRequest = {
            newFeeRate: params.newFeeRate,
            orderId: params.orderId
        };
        const response = await $adfbe621f07e3fbf$var$getRunesApiClient(params.network).rbfOrder(rbfOrderRequest);
        if (response.data) return {
            status: "success",
            result: {
                fundingAddress: response.data.fundingAddress,
                rbfCost: response.data.rbfCost
            }
        };
        return {
            status: "error",
            error: {
                code: response.error.code === 400 || response.error.code === 404 ? -32600 /* INVALID_REQUEST */  : -32603 /* INTERNAL_ERROR */ ,
                message: response.error.message
            }
        };
    }
    async rbfOrder(params) {
        try {
            const rbfOrderRequest = {
                newFeeRate: params.newFeeRate,
                orderId: params.orderId
            };
            const orderResponse = await $adfbe621f07e3fbf$var$getRunesApiClient(params.network).rbfOrder(rbfOrderRequest);
            if (!orderResponse.data) return {
                status: "error",
                error: {
                    code: orderResponse.error.code === 400 || orderResponse.error.code === 404 ? -32600 /* INVALID_REQUEST */  : -32603 /* INTERNAL_ERROR */ ,
                    message: orderResponse.error.message
                }
            };
            const paymentResponse = await this.requestInternal("sendTransfer", {
                recipients: [
                    {
                        address: orderResponse.data.fundingAddress,
                        amount: orderResponse.data.rbfCost
                    }
                ]
            });
            if (paymentResponse.status !== "success") return paymentResponse;
            return {
                status: "success",
                result: {
                    fundingAddress: orderResponse.data.fundingAddress,
                    orderId: rbfOrderRequest.orderId,
                    fundRBFTransactionId: paymentResponse.result.txid
                }
            };
        } catch (error) {
            return {
                status: "error",
                error: {
                    code: -32603 /* INTERNAL_ERROR */ ,
                    message: error.message
                }
            };
        }
    }
    async request(method, params) {
        switch(method){
            case "runes_mint":
                return this.mintRunes(params);
            case "runes_etch":
                return this.etchRunes(params);
            case "runes_estimateMint":
                return this.estimateMint(params);
            case "runes_estimateEtch":
                return this.estimateEtch(params);
            case "runes_getOrder":
                return this.getOrder(params);
            case "runes_estimateRbfOrder":
                return this.estimateRbfOrder(params);
            case "runes_rbfOrder":
                return this.rbfOrder(params);
            default:
                return this.requestInternal(method, params);
        }
    }
};
// src/adapters/xverse.ts
var $adfbe621f07e3fbf$var$XverseAdapter = class extends $adfbe621f07e3fbf$export$9ce9842739eebc36 {
    id = $adfbe621f07e3fbf$export$eea66190956591ea.xverse.id;
    requestInternal = async (method, params)=>{
        return $adfbe621f07e3fbf$export$b5fe3f66a567bec0(method, params, this.id);
    };
    addListener = (event, cb)=>{
        return $adfbe621f07e3fbf$export$f03a6b845d3fb58b(event, // The types of the `addListener` function being called here are not
        // entirely accurate.
        cb, this.id);
    };
};
function $adfbe621f07e3fbf$var$convertSignInputsToInputType(signInputs) {
    let result = [];
    for(let address in signInputs){
        let indexes = signInputs[address];
        for (let index of indexes)result.push({
            index: index,
            address: address
        });
    }
    return result;
}
var $adfbe621f07e3fbf$var$UnisatAdapter = class extends $adfbe621f07e3fbf$export$9ce9842739eebc36 {
    id = $adfbe621f07e3fbf$export$eea66190956591ea.unisat.id;
    async getAccounts(params) {
        const { purposes: purposes } = params;
        if (purposes.includes("stacks" /* Stacks */ )) throw new Error("Only bitcoin addresses are supported");
        const accounts = await window.unisat.requestAccounts();
        const publicKey = await window.unisat.getPublicKey();
        const address = accounts[0];
        const addressType = (0, $21c5f62793064411$export$e276b9dec452d0e2)(accounts[0]).type;
        const pk = addressType === (0, $21c5f62793064411$export$189c6ba3eaa96ac2).p2tr ? publicKey.slice(2) : publicKey;
        const paymentAddress = {
            address: address,
            publicKey: pk,
            addressType: addressType,
            purpose: "payment" /* Payment */ ,
            walletType: "software"
        };
        const ordinalsAddress = {
            address: address,
            publicKey: pk,
            addressType: addressType,
            purpose: "ordinals" /* Ordinals */ ,
            walletType: "software"
        };
        const response = [];
        if (purposes.includes("payment" /* Payment */ )) response.push({
            ...paymentAddress,
            walletType: "software"
        });
        if (purposes.includes("ordinals" /* Ordinals */ )) response.push({
            ...ordinalsAddress,
            walletType: "software"
        });
        return response;
    }
    async signMessage(params) {
        const { message: message, address: address } = params;
        const addressType = (0, $21c5f62793064411$export$e276b9dec452d0e2)(address).type;
        const Bip322supportedTypes = [
            (0, $21c5f62793064411$export$189c6ba3eaa96ac2).p2wpkh,
            (0, $21c5f62793064411$export$189c6ba3eaa96ac2).p2tr
        ];
        if (Bip322supportedTypes.includes(addressType)) {
            const response2 = await window.unisat.signMessage(message, "bip322-simple");
            return {
                address: address,
                messageHash: "",
                signature: response2,
                protocol: "BIP322" /* BIP322 */ 
            };
        }
        const response = await window.unisat.signMessage(message, "ecdsa");
        return {
            address: address,
            messageHash: "",
            signature: response,
            protocol: "ECDSA" /* ECDSA */ 
        };
    }
    async sendTransfer(params) {
        const { recipients: recipients } = params;
        if (recipients.length > 1) throw new Error("Only one recipient is supported by this wallet provider");
        const txid = await window.unisat.sendBitcoin(recipients[0].address, recipients[0].amount);
        return {
            txid: txid
        };
    }
    async signPsbt(params) {
        const { psbt: psbt, signInputs: signInputs, broadcast: broadcast } = params;
        const psbtHex = (0, $lewJ9.Buffer).from(psbt, "base64").toString("hex");
        const signedPsbt = await window.unisat.signPsbt(psbtHex, {
            autoFinalized: broadcast,
            toSignInputs: $adfbe621f07e3fbf$var$convertSignInputsToInputType(signInputs)
        });
        const signedPsbtBase64 = (0, $lewJ9.Buffer).from(signedPsbt, "hex").toString("base64");
        let txid;
        if (broadcast) txid = await window.unisat.pushPsbt(signedPsbt);
        return {
            psbt: signedPsbtBase64,
            txid: txid
        };
    }
    requestInternal = async (method, params)=>{
        try {
            switch(method){
                case "getAccounts":
                    {
                        const response = await this.getAccounts(params);
                        return {
                            status: "success",
                            result: response
                        };
                    }
                case "sendTransfer":
                    {
                        const response = await this.sendTransfer(params);
                        return {
                            status: "success",
                            result: response
                        };
                    }
                case "signMessage":
                    {
                        const response = await this.signMessage(params);
                        return {
                            status: "success",
                            result: response
                        };
                    }
                case "signPsbt":
                    {
                        const response = await this.signPsbt(params);
                        return {
                            status: "success",
                            result: response
                        };
                    }
                default:
                    {
                        const error = {
                            code: -32001 /* METHOD_NOT_SUPPORTED */ ,
                            message: "Method not supported by the selected wallet"
                        };
                        console.error("Error calling the method", error);
                        return {
                            status: "error",
                            error: error
                        };
                    }
            }
        } catch (error) {
            console.error("Error calling the method", error);
            return {
                status: "error",
                error: {
                    code: error.code === 4001 ? -32000 /* USER_REJECTION */  : -32603 /* INTERNAL_ERROR */ ,
                    message: error.message ? error.message : "Wallet method call error",
                    data: error
                }
            };
        }
    };
    addListener = (eventName, cb)=>{
        switch(eventName){
            case "accountChange":
                {
                    const handler = ()=>{
                        cb({
                            type: "accountChange"
                        });
                    };
                    window.unisat.on("accountsChanged", handler);
                    return ()=>{
                        window.unisat.removeListener("accountsChanged", handler);
                    };
                }
            case "networkChange":
                {
                    const handler = ()=>{
                        cb({
                            type: "networkChange"
                        });
                    };
                    window.unisat.on("networkChanged", handler);
                    return ()=>{
                        window.unisat.removeListener("networkChanged", handler);
                    };
                }
            default:
                console.error("Event not supported by the selected wallet");
                return ()=>{};
        }
    };
};
// src/adapters/fordefi.ts
var $adfbe621f07e3fbf$var$FordefiAdapter = class extends $adfbe621f07e3fbf$export$9ce9842739eebc36 {
    id = $adfbe621f07e3fbf$export$eea66190956591ea.fordefi.id;
    requestInternal = async (method, params)=>{
        const provider = $adfbe621f07e3fbf$export$367a63e5543d5442(this.id);
        if (!provider) throw new Error("no wallet provider was found");
        if (!method) throw new Error("A wallet method is required");
        return await provider.request(method, params);
    };
    addListener = (eventName, cb)=>{
        const provider = $adfbe621f07e3fbf$export$367a63e5543d5442(this.id);
        if (!provider) throw new Error("no wallet provider was found");
        if (!provider.addListener) {
            console.error(`The wallet provider you are using does not support the addListener method. Please update your wallet provider.`);
            return ()=>{};
        }
        return provider.addListener(eventName, cb);
    };
};
// src/adapters/BaseAdapter.ts
var $adfbe621f07e3fbf$export$3f8a66e424843755 = class extends $adfbe621f07e3fbf$export$9ce9842739eebc36 {
    id = "";
    constructor(providerId){
        super();
        this.id = providerId;
    }
    requestInternal = async (method, params)=>{
        return $adfbe621f07e3fbf$export$b5fe3f66a567bec0(method, params, this.id);
    };
    addListener = (..._args)=>{
        throw new Error("Method not supported for `BaseAdapter`.");
    };
};
// src/adapters/index.ts
var $adfbe621f07e3fbf$export$eea66190956591ea = {
    fordefi: {
        id: "FordefiProviders.UtxoProvider",
        name: "Fordefi",
        webUrl: "https://www.fordefi.com/",
        chromeWebStoreUrl: "https://chromewebstore.google.com/detail/fordefi/hcmehenccjdmfbojapcbcofkgdpbnlle",
        icon: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEzNDk0XzY2MjU0KSI+CjxwYXRoIGQ9Ik0xMC44NzY5IDE1LjYzNzhIMS41VjE4LjM5OUMxLjUgMTkuODAxMyAyLjYzNDQ3IDIwLjkzOCA0LjAzMzkyIDIwLjkzOEg4LjI0OTkyTDEwLjg3NjkgMTUuNjM3OFoiIGZpbGw9IiM3OTk0RkYiLz4KPHBhdGggZD0iTTEuNSA5Ljc3NTUxSDE5LjA1MTZMMTcuMDEzOSAxMy44NzExSDEuNVY5Ljc3NTUxWiIgZmlsbD0iIzQ4NkRGRiIvPgo8cGF0aCBkPSJNNy42NTk5NiAzSDEuNTI0NDFWOC4wMDcwNEgyMi40NjEyVjNIMTYuMzI1NlY2LjczOTQ0SDE1LjA2MDZWM0g4LjkyNTAyVjYuNzM5NDRINy42NTk5NlYzWiIgZmlsbD0iIzVDRDFGQSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzEzNDk0XzY2MjU0Ij4KPHJlY3Qgd2lkdGg9IjIxIiBoZWlnaHQ9IjE4IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS41IDMpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg=="
    },
    xverse: {
        id: "XverseProviders.BitcoinProvider",
        name: "Xverse",
        webUrl: "https://www.xverse.app/",
        googlePlayStoreUrl: "https://play.google.com/store/apps/details?id=com.secretkeylabs.xverse",
        iOSAppStoreUrl: "https://apps.apple.com/app/xverse-bitcoin-web3-wallet/id1552272513",
        chromeWebStoreUrl: "https://chromewebstore.google.com/detail/xverse-wallet/idnnbdplmphpflfnlkomgpfbpcgelopg",
        icon: "data:image/svg+xml;base64,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"
    },
    unisat: {
        id: "unisat",
        name: "Unisat",
        webUrl: "https://unisat.io/",
        icon: "data:image/svg+xml;base64,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"
    }
};
var $adfbe621f07e3fbf$export$594c7d98ad79c9c6 = {
    [$adfbe621f07e3fbf$export$eea66190956591ea.fordefi.id]: $adfbe621f07e3fbf$var$FordefiAdapter,
    [$adfbe621f07e3fbf$export$eea66190956591ea.xverse.id]: $adfbe621f07e3fbf$var$XverseAdapter,
    [$adfbe621f07e3fbf$export$eea66190956591ea.unisat.id]: $adfbe621f07e3fbf$var$UnisatAdapter
};
var $adfbe621f07e3fbf$var$extractOrValidateCapabilities = (provider, reportedCapabilities)=>{
    const validateCapability = (capability)=>{
        if (!provider[capability]) return false;
        if (reportedCapabilities && !reportedCapabilities.has(capability)) return false;
        return true;
    };
    const capabilityMap = {
        request: validateCapability("request"),
        connect: validateCapability("connect"),
        signMessage: validateCapability("signMessage"),
        signTransaction: validateCapability("signTransaction"),
        sendBtcTransaction: validateCapability("sendBtcTransaction"),
        createInscription: validateCapability("createInscription"),
        createRepeatInscriptions: validateCapability("createRepeatInscriptions"),
        signMultipleTransactions: validateCapability("signMultipleTransactions"),
        addListener: validateCapability("addListener")
    };
    return Object.entries(capabilityMap).reduce((acc, [capability, value])=>{
        if (value) return [
            ...acc,
            capability
        ];
        return acc;
    }, []);
};
var $adfbe621f07e3fbf$export$80a6dbd652bdbd9e = async (options)=>{
    const provider = await $adfbe621f07e3fbf$export$c30e75ed267ee3c5(options.getProvider);
    const request2 = (0, $88dd9319ba2ad0ba$exports.createUnsecuredToken)(options.payload);
    if (provider.getCapabilities) try {
        const response = await provider.getCapabilities(request2);
        options.onFinish?.($adfbe621f07e3fbf$var$extractOrValidateCapabilities(provider, new Set(response)));
    } catch (error) {
        console.error("[Connect] Error during capabilities request", error);
    }
    try {
        const inferredCapabilities = $adfbe621f07e3fbf$var$extractOrValidateCapabilities(provider);
        options.onFinish?.(inferredCapabilities);
    } catch (error) {
        console.error("[Connect] Error during capabilities request", error);
        options.onCancel?.();
    }
};
// src/inscriptions/utils.ts
var $adfbe621f07e3fbf$var$MAX_CONTENT_LENGTH_MAINNET = 4e5;
var $adfbe621f07e3fbf$var$MAX_CONTENT_LENGTH_TESTNET = 6e4;
var $adfbe621f07e3fbf$var$validateInscriptionPayload = (payload)=>{
    const { contentType: contentType, content: content, payloadType: payloadType, network: network, appFeeAddress: appFeeAddress, appFee: appFee } = payload;
    if (!/^[a-z]+\/[a-z0-9\-\.\+]+(?=;.*|$)/.test(contentType)) throw new Error("Invalid content type detected");
    if (!content || content.length === 0) throw new Error("Empty content not allowed");
    if (!payloadType || payloadType !== "BASE_64" && payloadType !== "PLAIN_TEXT") throw new Error("Empty invalid payloadType specified");
    if (content.length > (network.type === "Mainnet" ? $adfbe621f07e3fbf$var$MAX_CONTENT_LENGTH_MAINNET : $adfbe621f07e3fbf$var$MAX_CONTENT_LENGTH_TESTNET)) throw new Error("Content too large");
    if ((appFeeAddress?.length ?? 0) > 0 && (appFee ?? 0) <= 0) throw new Error("Invalid combination of app fee address and fee provided");
};
// src/inscriptions/createInscription.ts
var $adfbe621f07e3fbf$export$c9b9cbfba6db0b42 = async (options)=>{
    const { getProvider: getProvider } = options;
    const provider = await $adfbe621f07e3fbf$export$c30e75ed267ee3c5(getProvider);
    $adfbe621f07e3fbf$var$validateInscriptionPayload(options.payload);
    try {
        const request2 = (0, $88dd9319ba2ad0ba$exports.createUnsecuredToken)(options.payload);
        const response = await provider.createInscription(request2);
        options.onFinish?.(response);
    } catch (error) {
        console.error("[Connect] Error during create inscription", error);
        options.onCancel?.();
    }
};
var $adfbe621f07e3fbf$export$af7f74f3ddc632e0 = async (options)=>{
    const { getProvider: getProvider } = options;
    const provider = await $adfbe621f07e3fbf$export$c30e75ed267ee3c5(getProvider);
    $adfbe621f07e3fbf$var$validateInscriptionPayload(options.payload);
    try {
        const request2 = (0, $88dd9319ba2ad0ba$exports.createUnsecuredToken)(options.payload);
        const response = await provider.createRepeatInscriptions(request2);
        options.onFinish?.(response);
    } catch (error) {
        console.error("[Connect] Error during create repeat inscriptions", error);
        options.onCancel?.();
    }
};
var $adfbe621f07e3fbf$export$1d9a7a8a40780de = async (options)=>{
    const provider = await $adfbe621f07e3fbf$export$c30e75ed267ee3c5(options.getProvider);
    const { address: address, message: message } = options.payload;
    if (!address) throw new Error("An address is required to sign a message");
    if (!message) throw new Error("A message to be signed is required");
    try {
        const request2 = (0, $88dd9319ba2ad0ba$exports.createUnsecuredToken)(options.payload);
        const response = await provider.signMessage(request2);
        options.onFinish?.(response);
    } catch (error) {
        console.error("[Connect] Error during sign message request", error);
        options.onCancel?.();
    }
};
var $adfbe621f07e3fbf$var$serializer = (recipient)=>{
    return recipient.map((value)=>{
        const { address: address, amountSats: amountSats } = value;
        return {
            address: address,
            amountSats: amountSats.toString()
        };
    });
};
var $adfbe621f07e3fbf$export$c1b12202c7aeed9c = async (options)=>{
    const provider = await $adfbe621f07e3fbf$export$c30e75ed267ee3c5(options.getProvider);
    const { recipients: recipients, senderAddress: senderAddress, network: network, message: message } = options.payload;
    if (!recipients || recipients.length === 0) throw new Error("At least one recipient is required");
    if (recipients.some((item)=>typeof item.address !== "string" || typeof item.amountSats !== "bigint")) throw new Error("Incorrect recipient format");
    if (!senderAddress) throw new Error("The sender address is required");
    try {
        const serializedRecipients = $adfbe621f07e3fbf$var$serializer(recipients);
        const serializedPayload = {
            network: network,
            senderAddress: senderAddress,
            message: message,
            recipients: serializedRecipients
        };
        const request2 = (0, $88dd9319ba2ad0ba$exports.createUnsecuredToken)(serializedPayload);
        const response = await provider.sendBtcTransaction(request2);
        options.onFinish?.(response);
    } catch (error) {
        console.error("[Connect] Error during send BTC transaction request", error);
        options.onCancel?.();
    }
};
var $adfbe621f07e3fbf$export$6ad02cc4966b42ab = async (options)=>{
    const provider = await $adfbe621f07e3fbf$export$c30e75ed267ee3c5(options.getProvider);
    const { psbtBase64: psbtBase64, inputsToSign: inputsToSign } = options.payload;
    if (!psbtBase64) throw new Error("A value for psbtBase64 representing the tx hash is required");
    if (!inputsToSign) throw new Error("An array specifying the inputs to be signed by the wallet is required");
    try {
        const request2 = (0, $88dd9319ba2ad0ba$exports.createUnsecuredToken)(options.payload);
        const response = await provider.signTransaction(request2);
        options.onFinish?.(response);
    } catch (error) {
        console.error("[Connect] Error during sign transaction request", error);
        options.onCancel?.();
    }
};
var $adfbe621f07e3fbf$export$c4d215fa8dbabd1 = async (options)=>{
    const provider = await $adfbe621f07e3fbf$export$c30e75ed267ee3c5(options.getProvider);
    const { psbts: psbts } = options.payload;
    if (!psbts || !psbts.length) throw new Error("psbts array is required");
    if (psbts.length > 100) throw new Error("psbts array must contain less than 100 psbts");
    try {
        const request2 = (0, $88dd9319ba2ad0ba$exports.createUnsecuredToken)(options.payload);
        const response = await provider.signMultipleTransactions(request2);
        options.onFinish?.(response);
    } catch (error) {
        console.error("[Connect] Error during sign Multiple transactions request", error);
        options.onCancel?.();
    }
};



function $4236f07f676147d4$var$st(e) {
    return Object.keys(e).reduce((n, i)=>{
        const r = e[i];
        return n[i] = Object.assign({}, r), $4236f07f676147d4$var$ze(r.value) && !$4236f07f676147d4$var$ut(r.value) && !Array.isArray(r.value) && (n[i].value = Object.assign({}, r.value)), Array.isArray(r.value) && (n[i].value = r.value.slice(0)), n;
    }, {});
}
function $4236f07f676147d4$var$ot(e) {
    return e ? Object.keys(e).reduce((n, i)=>{
        const r = e[i];
        return n[i] = $4236f07f676147d4$var$ze(r) && "value" in r ? r : {
            value: r
        }, n[i].attribute || (n[i].attribute = $4236f07f676147d4$var$ct(i)), n[i].parse = "parse" in n[i] ? n[i].parse : typeof n[i].value != "string", n;
    }, {}) : {};
}
function $4236f07f676147d4$var$lt(e) {
    return Object.keys(e).reduce((n, i)=>(n[i] = e[i].value, n), {});
}
function $4236f07f676147d4$var$at(e, t) {
    const n = $4236f07f676147d4$var$st(t);
    return Object.keys(t).forEach((r)=>{
        const s = n[r], l = e.getAttribute(s.attribute), o = e[r];
        l && (s.value = s.parse ? $4236f07f676147d4$var$Ne(l) : l), o != null && (s.value = Array.isArray(o) ? o.slice(0) : o), s.reflect && $4236f07f676147d4$var$$e(e, s.attribute, s.value), Object.defineProperty(e, r, {
            get () {
                return s.value;
            },
            set (c) {
                const f = s.value;
                s.value = c, s.reflect && $4236f07f676147d4$var$$e(this, s.attribute, s.value);
                for(let a = 0, u = this.__propertyChangedCallbacks.length; a < u; a++)this.__propertyChangedCallbacks[a](r, c, f);
            },
            enumerable: !0,
            configurable: !0
        });
    }), n;
}
function $4236f07f676147d4$var$Ne(e) {
    if (e) try {
        return JSON.parse(e);
    } catch  {
        return e;
    }
}
function $4236f07f676147d4$var$$e(e, t, n) {
    if (n == null || n === !1) return e.removeAttribute(t);
    let i = JSON.stringify(n);
    e.__updating[t] = !0, i === "true" && (i = ""), e.setAttribute(t, i), Promise.resolve().then(()=>delete e.__updating[t]);
}
function $4236f07f676147d4$var$ct(e) {
    return e.replace(/\.?([A-Z]+)/g, (t, n)=>"-" + n.toLowerCase()).replace("_", "-").replace(/^-/, "");
}
function $4236f07f676147d4$var$ze(e) {
    return e != null && (typeof e == "object" || typeof e == "function");
}
function $4236f07f676147d4$var$ut(e) {
    return Object.prototype.toString.call(e) === "[object Function]";
}
function $4236f07f676147d4$var$dt(e) {
    return typeof e == "function" && e.toString().indexOf("class") === 0;
}
let $4236f07f676147d4$var$ue;
function $4236f07f676147d4$var$ft(e, t) {
    const n = Object.keys(t);
    return class extends e {
        static get observedAttributes() {
            return n.map((r)=>t[r].attribute);
        }
        constructor(){
            super(), this.__initialized = !1, this.__released = !1, this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = {};
        }
        connectedCallback() {
            if (this.__initialized) return;
            this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = $4236f07f676147d4$var$at(this, t);
            const r = $4236f07f676147d4$var$lt(this.props), s = this.Component, l = $4236f07f676147d4$var$ue;
            try {
                $4236f07f676147d4$var$ue = this, this.__initialized = !0, $4236f07f676147d4$var$dt(s) ? new s(r, {
                    element: this
                }) : s(r, {
                    element: this
                });
            } finally{
                $4236f07f676147d4$var$ue = l;
            }
        }
        async disconnectedCallback() {
            if (await Promise.resolve(), this.isConnected) return;
            this.__propertyChangedCallbacks.length = 0;
            let r = null;
            for(; r = this.__releaseCallbacks.pop();)r(this);
            delete this.__initialized, this.__released = !0;
        }
        attributeChangedCallback(r, s, l) {
            if (this.__initialized && !this.__updating[r] && (r = this.lookupProp(r), r in t)) {
                if (l == null && !this[r]) return;
                this[r] = t[r].parse ? $4236f07f676147d4$var$Ne(l) : l;
            }
        }
        lookupProp(r) {
            if (t) return n.find((s)=>r === s || r === t[s].attribute);
        }
        get renderRoot() {
            return this.shadowRoot || this.attachShadow({
                mode: "open"
            });
        }
        addReleaseCallback(r) {
            this.__releaseCallbacks.push(r);
        }
        addPropertyChangedCallback(r) {
            this.__propertyChangedCallbacks.push(r);
        }
    };
}
function $4236f07f676147d4$var$ht(e, t = {}, n = {}) {
    const { BaseElement: i = HTMLElement, extension: r } = n;
    return (s)=>{
        if (!e) throw new Error("tag is required to register a Component");
        let l = customElements.get(e);
        return l ? (l.prototype.Component = s, l) : (l = $4236f07f676147d4$var$ft(i, $4236f07f676147d4$var$ot(t)), l.prototype.Component = s, l.prototype.registeredTag = e, customElements.define(e, l, r), l);
    };
}
const $4236f07f676147d4$var$pt = (e, t)=>e === t, $4236f07f676147d4$var$me = Symbol("solid-proxy"), $4236f07f676147d4$var$yt = Symbol("solid-track"), $4236f07f676147d4$var$J = {
    equals: $4236f07f676147d4$var$pt
};
let $4236f07f676147d4$var$Re = $4236f07f676147d4$var$De;
const $4236f07f676147d4$var$M = 1, $4236f07f676147d4$var$Q = 2, $4236f07f676147d4$var$Ie = {
    owned: null,
    cleanups: null,
    context: null,
    owner: null
};
var $4236f07f676147d4$var$w = null;
let $4236f07f676147d4$var$de = null, $4236f07f676147d4$var$gt = null, $4236f07f676147d4$var$m = null, $4236f07f676147d4$var$S = null, $4236f07f676147d4$var$I = null, $4236f07f676147d4$var$ne = 0;
function $4236f07f676147d4$var$Z(e, t) {
    const n = $4236f07f676147d4$var$m, i = $4236f07f676147d4$var$w, r = e.length === 0, s = t === void 0 ? i : t, l = r ? $4236f07f676147d4$var$Ie : {
        owned: null,
        cleanups: null,
        context: s ? s.context : null,
        owner: s
    }, o = r ? e : ()=>e(()=>$4236f07f676147d4$var$T(()=>$4236f07f676147d4$var$ie(l)));
    $4236f07f676147d4$var$w = l, $4236f07f676147d4$var$m = null;
    try {
        return $4236f07f676147d4$var$V(o, !0);
    } finally{
        $4236f07f676147d4$var$m = n, $4236f07f676147d4$var$w = i;
    }
}
function $4236f07f676147d4$var$j(e, t) {
    t = t ? Object.assign({}, $4236f07f676147d4$var$J, t) : $4236f07f676147d4$var$J;
    const n = {
        value: e,
        observers: null,
        observerSlots: null,
        comparator: t.equals || void 0
    }, i = (r)=>(typeof r == "function" && (r = r(n.value)), $4236f07f676147d4$var$Be(n, r));
    return [
        $4236f07f676147d4$var$Ke.bind(n),
        i
    ];
}
function $4236f07f676147d4$var$A(e, t, n) {
    const i = $4236f07f676147d4$var$_e(e, t, !1, $4236f07f676147d4$var$M);
    $4236f07f676147d4$var$q(i);
}
function $4236f07f676147d4$var$Fe(e, t, n) {
    $4236f07f676147d4$var$Re = $4236f07f676147d4$var$Ct;
    const i = $4236f07f676147d4$var$_e(e, t, !1, $4236f07f676147d4$var$M);
    (!n || !n.render) && (i.user = !0), $4236f07f676147d4$var$I ? $4236f07f676147d4$var$I.push(i) : $4236f07f676147d4$var$q(i);
}
function $4236f07f676147d4$var$F(e, t, n) {
    n = n ? Object.assign({}, $4236f07f676147d4$var$J, n) : $4236f07f676147d4$var$J;
    const i = $4236f07f676147d4$var$_e(e, t, !0, 0);
    return i.observers = null, i.observerSlots = null, i.comparator = n.equals || void 0, $4236f07f676147d4$var$q(i), $4236f07f676147d4$var$Ke.bind(i);
}
function $4236f07f676147d4$var$mt(e) {
    return $4236f07f676147d4$var$V(e, !1);
}
function $4236f07f676147d4$var$T(e) {
    if ($4236f07f676147d4$var$m === null) return e();
    const t = $4236f07f676147d4$var$m;
    $4236f07f676147d4$var$m = null;
    try {
        return e();
    } finally{
        $4236f07f676147d4$var$m = t;
    }
}
function $4236f07f676147d4$var$bt(e) {
    $4236f07f676147d4$var$Fe(()=>$4236f07f676147d4$var$T(e));
}
function $4236f07f676147d4$var$Me(e) {
    return $4236f07f676147d4$var$w === null || ($4236f07f676147d4$var$w.cleanups === null ? $4236f07f676147d4$var$w.cleanups = [
        e
    ] : $4236f07f676147d4$var$w.cleanups.push(e)), e;
}
function $4236f07f676147d4$var$wt(e) {
    const t = $4236f07f676147d4$var$F(e), n = $4236f07f676147d4$var$F(()=>$4236f07f676147d4$var$be(t()));
    return n.toArray = ()=>{
        const i = n();
        return Array.isArray(i) ? i : i != null ? [
            i
        ] : [];
    }, n;
}
function $4236f07f676147d4$var$Ke() {
    if (this.sources && this.state) {
        if (this.state === $4236f07f676147d4$var$M) $4236f07f676147d4$var$q(this);
        else {
            const e = $4236f07f676147d4$var$S;
            $4236f07f676147d4$var$S = null, $4236f07f676147d4$var$V(()=>$4236f07f676147d4$var$te(this), !1), $4236f07f676147d4$var$S = e;
        }
    }
    if ($4236f07f676147d4$var$m) {
        const e = this.observers ? this.observers.length : 0;
        $4236f07f676147d4$var$m.sources ? ($4236f07f676147d4$var$m.sources.push(this), $4236f07f676147d4$var$m.sourceSlots.push(e)) : ($4236f07f676147d4$var$m.sources = [
            this
        ], $4236f07f676147d4$var$m.sourceSlots = [
            e
        ]), this.observers ? (this.observers.push($4236f07f676147d4$var$m), this.observerSlots.push($4236f07f676147d4$var$m.sources.length - 1)) : (this.observers = [
            $4236f07f676147d4$var$m
        ], this.observerSlots = [
            $4236f07f676147d4$var$m.sources.length - 1
        ]);
    }
    return this.value;
}
function $4236f07f676147d4$var$Be(e, t, n) {
    let i = e.value;
    return (!e.comparator || !e.comparator(i, t)) && (e.value = t, e.observers && e.observers.length && $4236f07f676147d4$var$V(()=>{
        for(let r = 0; r < e.observers.length; r += 1){
            const s = e.observers[r], l = $4236f07f676147d4$var$de && $4236f07f676147d4$var$de.running;
            l && $4236f07f676147d4$var$de.disposed.has(s), (l ? !s.tState : !s.state) && (s.pure ? $4236f07f676147d4$var$S.push(s) : $4236f07f676147d4$var$I.push(s), s.observers && $4236f07f676147d4$var$Ue(s)), l || (s.state = $4236f07f676147d4$var$M);
        }
        if ($4236f07f676147d4$var$S.length > 1e6) throw $4236f07f676147d4$var$S = [], new Error();
    }, !1)), t;
}
function $4236f07f676147d4$var$q(e) {
    if (!e.fn) return;
    $4236f07f676147d4$var$ie(e);
    const t = $4236f07f676147d4$var$ne;
    $4236f07f676147d4$var$vt(e, e.value, t);
}
function $4236f07f676147d4$var$vt(e, t, n) {
    let i;
    const r = $4236f07f676147d4$var$w, s = $4236f07f676147d4$var$m;
    $4236f07f676147d4$var$m = $4236f07f676147d4$var$w = e;
    try {
        i = e.fn(t);
    } catch (l) {
        return e.pure && (e.state = $4236f07f676147d4$var$M, e.owned && e.owned.forEach($4236f07f676147d4$var$ie), e.owned = null), e.updatedAt = n + 1, $4236f07f676147d4$var$We(l);
    } finally{
        $4236f07f676147d4$var$m = s, $4236f07f676147d4$var$w = r;
    }
    (!e.updatedAt || e.updatedAt <= n) && (e.updatedAt != null && "observers" in e ? $4236f07f676147d4$var$Be(e, i) : e.value = i, e.updatedAt = n);
}
function $4236f07f676147d4$var$_e(e, t, n, i = $4236f07f676147d4$var$M, r) {
    const s = {
        fn: e,
        state: i,
        updatedAt: null,
        owned: null,
        sources: null,
        sourceSlots: null,
        cleanups: null,
        value: t,
        owner: $4236f07f676147d4$var$w,
        context: $4236f07f676147d4$var$w ? $4236f07f676147d4$var$w.context : null,
        pure: n
    };
    return $4236f07f676147d4$var$w === null || $4236f07f676147d4$var$w !== $4236f07f676147d4$var$Ie && ($4236f07f676147d4$var$w.owned ? $4236f07f676147d4$var$w.owned.push(s) : $4236f07f676147d4$var$w.owned = [
        s
    ]), s;
}
function $4236f07f676147d4$var$ee(e) {
    if (e.state === 0) return;
    if (e.state === $4236f07f676147d4$var$Q) return $4236f07f676147d4$var$te(e);
    if (e.suspense && $4236f07f676147d4$var$T(e.suspense.inFallback)) return e.suspense.effects.push(e);
    const t = [
        e
    ];
    for(; (e = e.owner) && (!e.updatedAt || e.updatedAt < $4236f07f676147d4$var$ne);)e.state && t.push(e);
    for(let n = t.length - 1; n >= 0; n--)if (e = t[n], e.state === $4236f07f676147d4$var$M) $4236f07f676147d4$var$q(e);
    else if (e.state === $4236f07f676147d4$var$Q) {
        const i = $4236f07f676147d4$var$S;
        $4236f07f676147d4$var$S = null, $4236f07f676147d4$var$V(()=>$4236f07f676147d4$var$te(e, t[0]), !1), $4236f07f676147d4$var$S = i;
    }
}
function $4236f07f676147d4$var$V(e, t) {
    if ($4236f07f676147d4$var$S) return e();
    let n = !1;
    t || ($4236f07f676147d4$var$S = []), $4236f07f676147d4$var$I ? n = !0 : $4236f07f676147d4$var$I = [], $4236f07f676147d4$var$ne++;
    try {
        const i = e();
        return $4236f07f676147d4$var$xt(n), i;
    } catch (i) {
        n || ($4236f07f676147d4$var$I = null), $4236f07f676147d4$var$S = null, $4236f07f676147d4$var$We(i);
    }
}
function $4236f07f676147d4$var$xt(e) {
    if ($4236f07f676147d4$var$S && ($4236f07f676147d4$var$De($4236f07f676147d4$var$S), $4236f07f676147d4$var$S = null), e) return;
    const t = $4236f07f676147d4$var$I;
    $4236f07f676147d4$var$I = null, t.length && $4236f07f676147d4$var$V(()=>$4236f07f676147d4$var$Re(t), !1);
}
function $4236f07f676147d4$var$De(e) {
    for(let t = 0; t < e.length; t++)$4236f07f676147d4$var$ee(e[t]);
}
function $4236f07f676147d4$var$Ct(e) {
    let t, n = 0;
    for(t = 0; t < e.length; t++){
        const i = e[t];
        i.user ? e[n++] = i : $4236f07f676147d4$var$ee(i);
    }
    for(t = 0; t < n; t++)$4236f07f676147d4$var$ee(e[t]);
}
function $4236f07f676147d4$var$te(e, t) {
    e.state = 0;
    for(let n = 0; n < e.sources.length; n += 1){
        const i = e.sources[n];
        if (i.sources) {
            const r = i.state;
            r === $4236f07f676147d4$var$M ? i !== t && (!i.updatedAt || i.updatedAt < $4236f07f676147d4$var$ne) && $4236f07f676147d4$var$ee(i) : r === $4236f07f676147d4$var$Q && $4236f07f676147d4$var$te(i, t);
        }
    }
}
function $4236f07f676147d4$var$Ue(e) {
    for(let t = 0; t < e.observers.length; t += 1){
        const n = e.observers[t];
        n.state || (n.state = $4236f07f676147d4$var$Q, n.pure ? $4236f07f676147d4$var$S.push(n) : $4236f07f676147d4$var$I.push(n), n.observers && $4236f07f676147d4$var$Ue(n));
    }
}
function $4236f07f676147d4$var$ie(e) {
    let t;
    if (e.sources) for(; e.sources.length;){
        const n = e.sources.pop(), i = e.sourceSlots.pop(), r = n.observers;
        if (r && r.length) {
            const s = r.pop(), l = n.observerSlots.pop();
            i < r.length && (s.sourceSlots[l] = i, r[i] = s, n.observerSlots[i] = l);
        }
    }
    if (e.owned) {
        for(t = e.owned.length - 1; t >= 0; t--)$4236f07f676147d4$var$ie(e.owned[t]);
        e.owned = null;
    }
    if (e.cleanups) {
        for(t = e.cleanups.length - 1; t >= 0; t--)e.cleanups[t]();
        e.cleanups = null;
    }
    e.state = 0;
}
function $4236f07f676147d4$var$Pt(e) {
    return e instanceof Error ? e : new Error(typeof e == "string" ? e : "Unknown error", {
        cause: e
    });
}
function $4236f07f676147d4$var$We(e, t = $4236f07f676147d4$var$w) {
    throw $4236f07f676147d4$var$Pt(e);
}
function $4236f07f676147d4$var$be(e) {
    if (typeof e == "function" && !e.length) return $4236f07f676147d4$var$be(e());
    if (Array.isArray(e)) {
        const t = [];
        for(let n = 0; n < e.length; n++){
            const i = $4236f07f676147d4$var$be(e[n]);
            Array.isArray(i) ? t.push.apply(t, i) : t.push(i);
        }
        return t;
    }
    return e;
}
const $4236f07f676147d4$var$St = Symbol("fallback");
function $4236f07f676147d4$var$Ae(e) {
    for(let t = 0; t < e.length; t++)e[t]();
}
function $4236f07f676147d4$var$_t(e, t, n = {}) {
    let i = [], r = [], s = [], l = 0, o = t.length > 1 ? [] : null;
    return $4236f07f676147d4$var$Me(()=>$4236f07f676147d4$var$Ae(s)), ()=>{
        let c = e() || [], f, a;
        return c[$4236f07f676147d4$var$yt], $4236f07f676147d4$var$T(()=>{
            let d = c.length, h, v, y, z, $, P, _, E, R;
            if (d === 0) l !== 0 && ($4236f07f676147d4$var$Ae(s), s = [], i = [], r = [], l = 0, o && (o = [])), n.fallback && (i = [
                $4236f07f676147d4$var$St
            ], r[0] = $4236f07f676147d4$var$Z((se)=>(s[0] = se, n.fallback())), l = 1);
            else if (l === 0) {
                for(r = new Array(d), a = 0; a < d; a++)i[a] = c[a], r[a] = $4236f07f676147d4$var$Z(u);
                l = d;
            } else {
                for(y = new Array(d), z = new Array(d), o && ($ = new Array(d)), P = 0, _ = Math.min(l, d); P < _ && i[P] === c[P]; P++);
                for(_ = l - 1, E = d - 1; _ >= P && E >= P && i[_] === c[E]; _--, E--)y[E] = r[_], z[E] = s[_], o && ($[E] = o[_]);
                for(h = /* @__PURE__ */ new Map(), v = new Array(E + 1), a = E; a >= P; a--)R = c[a], f = h.get(R), v[a] = f === void 0 ? -1 : f, h.set(R, a);
                for(f = P; f <= _; f++)R = i[f], a = h.get(R), a !== void 0 && a !== -1 ? (y[a] = r[f], z[a] = s[f], o && ($[a] = o[f]), a = v[a], h.set(R, a)) : s[f]();
                for(a = P; a < d; a++)a in y ? (r[a] = y[a], s[a] = z[a], o && (o[a] = $[a], o[a](a))) : r[a] = $4236f07f676147d4$var$Z(u);
                r = r.slice(0, l = d), i = c.slice(0);
            }
            return r;
        });
        function u(d) {
            if (s[a] = d, o) {
                const [h, v] = $4236f07f676147d4$var$j(a);
                return o[a] = v, t(c[a], h);
            }
            return t(c[a]);
        }
    };
}
function $4236f07f676147d4$var$g(e, t) {
    return $4236f07f676147d4$var$T(()=>e(t || {}));
}
function $4236f07f676147d4$var$Y() {
    return !0;
}
const $4236f07f676147d4$var$Et = {
    get (e, t, n) {
        return t === $4236f07f676147d4$var$me ? n : e.get(t);
    },
    has (e, t) {
        return t === $4236f07f676147d4$var$me ? !0 : e.has(t);
    },
    set: $4236f07f676147d4$var$Y,
    deleteProperty: $4236f07f676147d4$var$Y,
    getOwnPropertyDescriptor (e, t) {
        return {
            configurable: !0,
            enumerable: !0,
            get () {
                return e.get(t);
            },
            set: $4236f07f676147d4$var$Y,
            deleteProperty: $4236f07f676147d4$var$Y
        };
    },
    ownKeys (e) {
        return e.keys();
    }
};
function $4236f07f676147d4$var$fe(e) {
    return (e = typeof e == "function" ? e() : e) ? e : {};
}
function $4236f07f676147d4$var$kt() {
    for(let e = 0, t = this.length; e < t; ++e){
        const n = this[e]();
        if (n !== void 0) return n;
    }
}
function $4236f07f676147d4$var$$t(...e) {
    let t = !1;
    for(let l = 0; l < e.length; l++){
        const o = e[l];
        t = t || !!o && $4236f07f676147d4$var$me in o, e[l] = typeof o == "function" ? (t = !0, $4236f07f676147d4$var$F(o)) : o;
    }
    if (t) return new Proxy({
        get (l) {
            for(let o = e.length - 1; o >= 0; o--){
                const c = $4236f07f676147d4$var$fe(e[o])[l];
                if (c !== void 0) return c;
            }
        },
        has (l) {
            for(let o = e.length - 1; o >= 0; o--)if (l in $4236f07f676147d4$var$fe(e[o])) return !0;
            return !1;
        },
        keys () {
            const l = [];
            for(let o = 0; o < e.length; o++)l.push(...Object.keys($4236f07f676147d4$var$fe(e[o])));
            return [
                ...new Set(l)
            ];
        }
    }, $4236f07f676147d4$var$Et);
    const n = {}, i = /* @__PURE__ */ Object.create(null);
    for(let l = e.length - 1; l >= 0; l--){
        const o = e[l];
        if (!o) continue;
        const c = Object.getOwnPropertyNames(o);
        for(let f = c.length - 1; f >= 0; f--){
            const a = c[f];
            if (a === "__proto__" || a === "constructor") continue;
            const u = Object.getOwnPropertyDescriptor(o, a);
            if (!i[a]) i[a] = u.get ? {
                enumerable: !0,
                configurable: !0,
                get: $4236f07f676147d4$var$kt.bind(n[a] = [
                    u.get.bind(o)
                ])
            } : u.value !== void 0 ? u : void 0;
            else {
                const d = n[a];
                d && (u.get ? d.push(u.get.bind(o)) : u.value !== void 0 && d.push(()=>u.value));
            }
        }
    }
    const r = {}, s = Object.keys(i);
    for(let l = s.length - 1; l >= 0; l--){
        const o = s[l], c = i[o];
        c && c.get ? Object.defineProperty(r, o, c) : r[o] = c ? c.value : void 0;
    }
    return r;
}
const $4236f07f676147d4$var$Ve = (e)=>`Stale read from <${e}>.`;
function $4236f07f676147d4$var$At(e) {
    const t = "fallback" in e && {
        fallback: ()=>e.fallback
    };
    return $4236f07f676147d4$var$F($4236f07f676147d4$var$_t(()=>e.each, e.children, t || void 0));
}
function $4236f07f676147d4$var$he(e) {
    const t = e.keyed, n = $4236f07f676147d4$var$F(()=>e.when, void 0, {
        equals: (i, r)=>t ? i === r : !i == !r
    });
    return $4236f07f676147d4$var$F(()=>{
        const i = n();
        if (i) {
            const r = e.children;
            return typeof r == "function" && r.length > 0 ? $4236f07f676147d4$var$T(()=>r(t ? i : ()=>{
                    if (!$4236f07f676147d4$var$T(n)) throw $4236f07f676147d4$var$Ve("Show");
                    return e.when;
                })) : r;
        }
        return e.fallback;
    }, void 0, void 0);
}
function $4236f07f676147d4$var$Lt(e) {
    let t = !1;
    const n = (s, l)=>(t ? s[1] === l[1] : !s[1] == !l[1]) && s[2] === l[2], i = $4236f07f676147d4$var$wt(()=>e.children), r = $4236f07f676147d4$var$F(()=>{
        let s = i();
        Array.isArray(s) || (s = [
            s
        ]);
        for(let l = 0; l < s.length; l++){
            const o = s[l].when;
            if (o) return t = !!s[l].keyed, [
                l,
                o,
                s[l]
            ];
        }
        return [
            -1
        ];
    }, void 0, {
        equals: n
    });
    return $4236f07f676147d4$var$F(()=>{
        const [s, l, o] = r();
        if (s < 0) return e.fallback;
        const c = o.children;
        return typeof c == "function" && c.length > 0 ? $4236f07f676147d4$var$T(()=>c(t ? l : ()=>{
                if ($4236f07f676147d4$var$T(r)[0] !== s) throw $4236f07f676147d4$var$Ve("Match");
                return o.when;
            })) : c;
    }, void 0, void 0);
}
function $4236f07f676147d4$var$pe(e) {
    return e;
}
const $4236f07f676147d4$var$Ot = [
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "disabled",
    "formnovalidate",
    "hidden",
    "indeterminate",
    "inert",
    "ismap",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "seamless",
    "selected"
], $4236f07f676147d4$var$jt = /* @__PURE__ */ new Set([
    "className",
    "value",
    "readOnly",
    "formNoValidate",
    "isMap",
    "noModule",
    "playsInline",
    ...$4236f07f676147d4$var$Ot
]), $4236f07f676147d4$var$Tt = /* @__PURE__ */ new Set([
    "innerHTML",
    "textContent",
    "innerText",
    "children"
]), $4236f07f676147d4$var$Nt = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
    className: "class",
    htmlFor: "for"
}), $4236f07f676147d4$var$zt = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
    class: "className",
    formnovalidate: {
        $: "formNoValidate",
        BUTTON: 1,
        INPUT: 1
    },
    ismap: {
        $: "isMap",
        IMG: 1
    },
    nomodule: {
        $: "noModule",
        SCRIPT: 1
    },
    playsinline: {
        $: "playsInline",
        VIDEO: 1
    },
    readonly: {
        $: "readOnly",
        INPUT: 1,
        TEXTAREA: 1
    }
});
function $4236f07f676147d4$var$Rt(e, t) {
    const n = $4236f07f676147d4$var$zt[e];
    return typeof n == "object" ? n[t] ? n.$ : void 0 : n;
}
const $4236f07f676147d4$var$It = /* @__PURE__ */ new Set([
    "beforeinput",
    "click",
    "dblclick",
    "contextmenu",
    "focusin",
    "focusout",
    "input",
    "keydown",
    "keyup",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "pointerdown",
    "pointermove",
    "pointerout",
    "pointerover",
    "pointerup",
    "touchend",
    "touchmove",
    "touchstart"
]), $4236f07f676147d4$var$Ft = {
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace"
};
function $4236f07f676147d4$var$Mt(e, t, n) {
    let i = n.length, r = t.length, s = i, l = 0, o = 0, c = t[r - 1].nextSibling, f = null;
    for(; l < r || o < s;){
        if (t[l] === n[o]) {
            l++, o++;
            continue;
        }
        for(; t[r - 1] === n[s - 1];)r--, s--;
        if (r === l) {
            const a = s < i ? o ? n[o - 1].nextSibling : n[s - o] : c;
            for(; o < s;)e.insertBefore(n[o++], a);
        } else if (s === o) for(; l < r;)(!f || !f.has(t[l])) && t[l].remove(), l++;
        else if (t[l] === n[s - 1] && n[o] === t[r - 1]) {
            const a = t[--r].nextSibling;
            e.insertBefore(n[o++], t[l++].nextSibling), e.insertBefore(n[--s], a), t[r] = n[s];
        } else {
            if (!f) {
                f = /* @__PURE__ */ new Map();
                let u = o;
                for(; u < s;)f.set(n[u], u++);
            }
            const a = f.get(t[l]);
            if (a != null) {
                if (o < a && a < s) {
                    let u = l, d = 1, h;
                    for(; ++u < r && u < s && !((h = f.get(t[u])) == null || h !== a + d);)d++;
                    if (d > a - o) {
                        const v = t[l];
                        for(; o < a;)e.insertBefore(n[o++], v);
                    } else e.replaceChild(n[o++], t[l++]);
                } else l++;
            } else t[l++].remove();
        }
    }
}
const $4236f07f676147d4$var$Le = "_$DX_DELEGATE";
function $4236f07f676147d4$var$C(e, t, n) {
    let i;
    const r = ()=>{
        const l = document.createElement("template");
        return l.innerHTML = e, n ? l.content.firstChild.firstChild : l.content.firstChild;
    }, s = t ? ()=>$4236f07f676147d4$var$T(()=>document.importNode(i || (i = r()), !0)) : ()=>(i || (i = r())).cloneNode(!0);
    return s.cloneNode = s, s;
}
function $4236f07f676147d4$var$Kt(e, t = window.document) {
    const n = t[$4236f07f676147d4$var$Le] || (t[$4236f07f676147d4$var$Le] = /* @__PURE__ */ new Set());
    for(let i = 0, r = e.length; i < r; i++){
        const s = e[i];
        n.has(s) || (n.add(s), t.addEventListener(s, $4236f07f676147d4$var$Ht));
    }
}
function $4236f07f676147d4$var$N(e, t, n) {
    n == null ? e.removeAttribute(t) : e.setAttribute(t, n);
}
function $4236f07f676147d4$var$Bt(e, t, n, i) {
    i == null ? e.removeAttributeNS(t, n) : e.setAttributeNS(t, n, i);
}
function $4236f07f676147d4$var$Dt(e, t) {
    t == null ? e.removeAttribute("class") : e.className = t;
}
function $4236f07f676147d4$var$Ut(e, t, n, i) {
    if (i) Array.isArray(n) ? (e[`$$${t}`] = n[0], e[`$$${t}Data`] = n[1]) : e[`$$${t}`] = n;
    else if (Array.isArray(n)) {
        const r = n[0];
        e.addEventListener(t, n[0] = (s)=>r.call(e, n[1], s));
    } else e.addEventListener(t, n);
}
function $4236f07f676147d4$var$Wt(e, t, n = {}) {
    const i = Object.keys(t || {}), r = Object.keys(n);
    let s, l;
    for(s = 0, l = r.length; s < l; s++){
        const o = r[s];
        !o || o === "undefined" || t[o] || ($4236f07f676147d4$var$Oe(e, o, !1), delete n[o]);
    }
    for(s = 0, l = i.length; s < l; s++){
        const o = i[s], c = !!t[o];
        !o || o === "undefined" || n[o] === c || !c || ($4236f07f676147d4$var$Oe(e, o, !0), n[o] = c);
    }
    return n;
}
function $4236f07f676147d4$var$L(e, t, n) {
    if (!t) return n ? $4236f07f676147d4$var$N(e, "style") : t;
    const i = e.style;
    if (typeof t == "string") return i.cssText = t;
    typeof n == "string" && (i.cssText = n = void 0), n || (n = {}), t || (t = {});
    let r, s;
    for(s in n)t[s] == null && i.removeProperty(s), delete n[s];
    for(s in t)r = t[s], r !== n[s] && (i.setProperty(s, r), n[s] = r);
    return n;
}
function $4236f07f676147d4$var$Vt(e, t = {}, n, i) {
    const r = {};
    return i || $4236f07f676147d4$var$A(()=>r.children = $4236f07f676147d4$var$U(e, t.children, r.children)), $4236f07f676147d4$var$A(()=>t.ref && t.ref(e)), $4236f07f676147d4$var$A(()=>$4236f07f676147d4$var$Xt(e, t, n, !0, r, !0)), r;
}
function $4236f07f676147d4$var$ye(e, t, n) {
    return $4236f07f676147d4$var$T(()=>e(t, n));
}
function $4236f07f676147d4$var$b(e, t, n, i) {
    if (n !== void 0 && !i && (i = []), typeof t != "function") return $4236f07f676147d4$var$U(e, t, i, n);
    $4236f07f676147d4$var$A((r)=>$4236f07f676147d4$var$U(e, t(), r, n), i);
}
function $4236f07f676147d4$var$Xt(e, t, n, i, r = {}, s = !1) {
    t || (t = {});
    for(const l in r)if (!(l in t)) {
        if (l === "children") continue;
        r[l] = $4236f07f676147d4$var$je(e, l, null, r[l], n, s);
    }
    for(const l in t){
        if (l === "children") {
            i || $4236f07f676147d4$var$U(e, t.children);
            continue;
        }
        const o = t[l];
        r[l] = $4236f07f676147d4$var$je(e, l, o, r[l], n, s);
    }
}
function $4236f07f676147d4$var$qt(e) {
    return e.toLowerCase().replace(/-([a-z])/g, (t, n)=>n.toUpperCase());
}
function $4236f07f676147d4$var$Oe(e, t, n) {
    const i = t.trim().split(/\s+/);
    for(let r = 0, s = i.length; r < s; r++)e.classList.toggle(i[r], n);
}
function $4236f07f676147d4$var$je(e, t, n, i, r, s) {
    let l, o, c, f, a;
    if (t === "style") return $4236f07f676147d4$var$L(e, n, i);
    if (t === "classList") return $4236f07f676147d4$var$Wt(e, n, i);
    if (n === i) return i;
    if (t === "ref") s || n(e);
    else if (t.slice(0, 3) === "on:") {
        const u = t.slice(3);
        i && e.removeEventListener(u, i), n && e.addEventListener(u, n);
    } else if (t.slice(0, 10) === "oncapture:") {
        const u = t.slice(10);
        i && e.removeEventListener(u, i, !0), n && e.addEventListener(u, n, !0);
    } else if (t.slice(0, 2) === "on") {
        const u = t.slice(2).toLowerCase(), d = $4236f07f676147d4$var$It.has(u);
        if (!d && i) {
            const h = Array.isArray(i) ? i[0] : i;
            e.removeEventListener(u, h);
        }
        (d || n) && ($4236f07f676147d4$var$Ut(e, u, n, d), d && $4236f07f676147d4$var$Kt([
            u
        ]));
    } else if (t.slice(0, 5) === "attr:") $4236f07f676147d4$var$N(e, t.slice(5), n);
    else if ((a = t.slice(0, 5) === "prop:") || (c = $4236f07f676147d4$var$Tt.has(t)) || !r && ((f = $4236f07f676147d4$var$Rt(t, e.tagName)) || (o = $4236f07f676147d4$var$jt.has(t))) || (l = e.nodeName.includes("-"))) a && (t = t.slice(5), o = !0), t === "class" || t === "className" ? $4236f07f676147d4$var$Dt(e, n) : l && !o && !c ? e[$4236f07f676147d4$var$qt(t)] = n : e[f || t] = n;
    else {
        const u = r && t.indexOf(":") > -1 && $4236f07f676147d4$var$Ft[t.split(":")[0]];
        u ? $4236f07f676147d4$var$Bt(e, u, t, n) : $4236f07f676147d4$var$N(e, $4236f07f676147d4$var$Nt[t] || t, n);
    }
    return n;
}
function $4236f07f676147d4$var$Ht(e) {
    const t = `$$${e.type}`;
    let n = e.composedPath && e.composedPath()[0] || e.target;
    for(e.target !== n && Object.defineProperty(e, "target", {
        configurable: !0,
        value: n
    }), Object.defineProperty(e, "currentTarget", {
        configurable: !0,
        get () {
            return n || document;
        }
    }); n;){
        const i = n[t];
        if (i && !n.disabled) {
            const r = n[`${t}Data`];
            if (r !== void 0 ? i.call(n, r, e) : i.call(n, e), e.cancelBubble) return;
        }
        n = n._$host || n.parentNode || n.host;
    }
}
function $4236f07f676147d4$var$U(e, t, n, i, r) {
    for(; typeof n == "function";)n = n();
    if (t === n) return n;
    const s = typeof t, l = i !== void 0;
    if (e = l && n[0] && n[0].parentNode || e, s === "string" || s === "number") {
        if (s === "number" && (t = t.toString()), l) {
            let o = n[0];
            o && o.nodeType === 3 ? o.data !== t && (o.data = t) : o = document.createTextNode(t), n = $4236f07f676147d4$var$D(e, n, i, o);
        } else n !== "" && typeof n == "string" ? n = e.firstChild.data = t : n = e.textContent = t;
    } else if (t == null || s === "boolean") n = $4236f07f676147d4$var$D(e, n, i);
    else {
        if (s === "function") return $4236f07f676147d4$var$A(()=>{
            let o = t();
            for(; typeof o == "function";)o = o();
            n = $4236f07f676147d4$var$U(e, o, n, i);
        }), ()=>n;
        if (Array.isArray(t)) {
            const o = [], c = n && Array.isArray(n);
            if ($4236f07f676147d4$var$we(o, t, n, r)) return $4236f07f676147d4$var$A(()=>n = $4236f07f676147d4$var$U(e, o, n, i, !0)), ()=>n;
            if (o.length === 0) {
                if (n = $4236f07f676147d4$var$D(e, n, i), l) return n;
            } else c ? n.length === 0 ? $4236f07f676147d4$var$Te(e, o, i) : $4236f07f676147d4$var$Mt(e, n, o) : (n && $4236f07f676147d4$var$D(e), $4236f07f676147d4$var$Te(e, o));
            n = o;
        } else if (t.nodeType) {
            if (Array.isArray(n)) {
                if (l) return n = $4236f07f676147d4$var$D(e, n, i, t);
                $4236f07f676147d4$var$D(e, n, null, t);
            } else n == null || n === "" || !e.firstChild ? e.appendChild(t) : e.replaceChild(t, e.firstChild);
            n = t;
        }
    }
    return n;
}
function $4236f07f676147d4$var$we(e, t, n, i) {
    let r = !1;
    for(let s = 0, l = t.length; s < l; s++){
        let o = t[s], c = n && n[e.length], f;
        if (!(o == null || o === !0 || o === !1)) {
            if ((f = typeof o) == "object" && o.nodeType) e.push(o);
            else if (Array.isArray(o)) r = $4236f07f676147d4$var$we(e, o, c) || r;
            else if (f === "function") {
                if (i) {
                    for(; typeof o == "function";)o = o();
                    r = $4236f07f676147d4$var$we(e, Array.isArray(o) ? o : [
                        o
                    ], Array.isArray(c) ? c : [
                        c
                    ]) || r;
                } else e.push(o), r = !0;
            } else {
                const a = String(o);
                c && c.nodeType === 3 && c.data === a ? e.push(c) : e.push(document.createTextNode(a));
            }
        }
    }
    return r;
}
function $4236f07f676147d4$var$Te(e, t, n = null) {
    for(let i = 0, r = t.length; i < r; i++)e.insertBefore(t[i], n);
}
function $4236f07f676147d4$var$D(e, t, n, i) {
    if (n === void 0) return e.textContent = "";
    const r = i || document.createTextNode("");
    if (t.length) {
        let s = !1;
        for(let l = t.length - 1; l >= 0; l--){
            const o = t[l];
            if (r !== o) {
                const c = o.parentNode === e;
                !s && !l ? c ? e.replaceChild(r, o) : e.insertBefore(r, n) : c && o.remove();
            } else s = !0;
        }
    } else e.insertBefore(r, n);
    return [
        r
    ];
}
function $4236f07f676147d4$var$Yt(e) {
    const t = Object.keys(e), n = {};
    for(let i = 0; i < t.length; i++){
        const [r, s] = $4236f07f676147d4$var$j(e[t[i]]);
        Object.defineProperty(n, t[i], {
            get: r,
            set (l) {
                s(()=>l);
            }
        });
    }
    return n;
}
function $4236f07f676147d4$var$Gt(e) {
    if (e.assignedSlot && e.assignedSlot._$owner) return e.assignedSlot._$owner;
    let t = e.parentNode;
    for(; t && !t._$owner && !(t.assignedSlot && t.assignedSlot._$owner);)t = t.parentNode;
    return t && t.assignedSlot ? t.assignedSlot._$owner : e._$owner;
}
function $4236f07f676147d4$var$Zt(e) {
    return (t, n)=>{
        const { element: i } = n;
        return $4236f07f676147d4$var$Z((r)=>{
            const s = $4236f07f676147d4$var$Yt(t);
            i.addPropertyChangedCallback((o, c)=>s[o] = c), i.addReleaseCallback(()=>{
                i.renderRoot.textContent = "", r();
            });
            const l = e(s, n);
            return $4236f07f676147d4$var$b(i.renderRoot, l);
        }, $4236f07f676147d4$var$Gt(i));
    };
}
function $4236f07f676147d4$var$Jt(e, t, n) {
    return arguments.length === 2 && (n = t, t = {}), $4236f07f676147d4$var$ht(e, t)($4236f07f676147d4$var$Zt(n));
}
const $4236f07f676147d4$var$ve = "sats-connect_wallet-provider-selector_select", $4236f07f676147d4$var$xe = "sats-connect_wallet-provider-selector_cancel", $4236f07f676147d4$var$Ce = "sats-connect_wallet-provider-selector_open", $4236f07f676147d4$var$Pe = "sats-connect_wallet-provider-selector_close", $4236f07f676147d4$var$Xe = "sats-connect_wallet-provider-selector_walletOpen", $4236f07f676147d4$var$qe = "sats-connect_wallet-provider-selector_walletClose", $4236f07f676147d4$var$re = {
    color: "#181818",
    "font-size": "18px",
    "font-weight": "700",
    "line-height": "1.4"
}, $4236f07f676147d4$var$W = {
    color: "#181818",
    "font-size": "14px",
    "font-weight": "400",
    "line-height": "1.4"
}, $4236f07f676147d4$var$Qt = {
    color: "#181818",
    "font-size": "14px",
    "font-weight": "500"
};
var $4236f07f676147d4$var$en = /* @__PURE__ */ $4236f07f676147d4$var$C('<svg width=24 height=24 viewBox="0 0 24 24"fill=none xmlns=http://www.w3.org/2000/svg><g id=XCircle><path id=Vector d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.745 9.41566 20.7162 6.93859 18.8888 5.11118C17.0614 3.28378 14.5843 2.25496 12 2.25ZM15.5344 14.4656C15.6752 14.6078 15.7542 14.7999 15.7542 15C15.7542 15.2001 15.6752 15.3922 15.5344 15.5344C15.391 15.673 15.1994 15.7505 15 15.7505C14.8006 15.7505 14.609 15.673 14.4656 15.5344L12 13.0594L9.53438 15.5344C9.39102 15.673 9.19942 15.7505 9 15.7505C8.80059 15.7505 8.60898 15.673 8.46563 15.5344C8.32479 15.3922 8.24578 15.2001 8.24578 15C8.24578 14.7999 8.32479 14.6078 8.46563 14.4656L10.9406 12L8.46563 9.53437C8.34603 9.38865 8.28491 9.20366 8.29416 9.01537C8.30341 8.82708 8.38236 8.64896 8.51566 8.51566C8.64896 8.38236 8.82708 8.3034 9.01537 8.29416C9.20366 8.28491 9.38866 8.34603 9.53438 8.46563L12 10.9406L14.4656 8.46563C14.6114 8.34603 14.7963 8.28491 14.9846 8.29416C15.1729 8.3034 15.351 8.38236 15.4843 8.51566C15.6176 8.64896 15.6966 8.82708 15.7058 9.01537C15.7151 9.20366 15.654 9.38865 15.5344 9.53437L13.0594 12L15.5344 14.4656Z"fill=black fill-opacity=0.3>'), $4236f07f676147d4$var$tn = /* @__PURE__ */ $4236f07f676147d4$var$C(`<style>
          .close-selector-button:focus-visible {
            outline: 2px solid #181818;
            outline-offset: -0.25px;
          }
        `), $4236f07f676147d4$var$nn = /* @__PURE__ */ $4236f07f676147d4$var$C("<div role=button tabindex=0 class=close-selector-button>");
function $4236f07f676147d4$var$rn(e) {
    return (()=>{
        var t = $4236f07f676147d4$var$en();
        return t.style.setProperty("display", "block"), $4236f07f676147d4$var$Vt(t, e, !0, !0), t;
    })();
}
function $4236f07f676147d4$var$sn(e) {
    function t(n) {
        (n.key === "Enter" || n.key === " ") && e.onClose();
    }
    return [
        $4236f07f676147d4$var$tn(),
        (()=>{
            var n = $4236f07f676147d4$var$nn();
            return n.style.setProperty("position", "absolute"), n.style.setProperty("top", "16px"), n.style.setProperty("right", "16px"), n.style.setProperty("background", "none"), n.style.setProperty("border", "none"), n.style.setProperty("cursor", "pointer"), n.style.setProperty("padding", "0"), n.style.setProperty("margin", "0"), n.style.setProperty("border-radius", "50%"), n.addEventListener("click", e.onClose), n.addEventListener("keydown", t), $4236f07f676147d4$var$b(n, $4236f07f676147d4$var$g($4236f07f676147d4$var$rn, {})), n;
        })()
    ];
}
var $4236f07f676147d4$var$on = /* @__PURE__ */ $4236f07f676147d4$var$C(`<style>
/*! modern-normalize v2.0.0 | MIT License | https://github.com/sindresorhus/modern-normalize */

/*
Document
========
*/

/**
Use a better box model (opinionated).
*/

*,
::before,
::after {
	box-sizing: border-box;
	margin: 0; /* Remove all margins from everywhere. */
}

:host {
	/* Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3) */
	font-family:
		'DM Sans', /* Note: not part of modern-normalize, added specifically for this project. */
		system-ui,
		'Segoe UI',
		Roboto,
		Helvetica,
		Arial,
		sans-serif,
		'Apple Color Emoji',
		'Segoe UI Emoji';
	line-height: 1.15; /* 1. Correct the line height in all browsers. */
	-webkit-text-size-adjust: 100%; /* 2. Prevent adjustments of font size after orientation changes in iOS. */
	-moz-tab-size: 4; /* 3. Use a more readable tab size (opinionated). */
	tab-size: 4; /* 3 */
}

/*
Sections
========
*/

:host {
	margin: 0; /* Remove the margin in all browsers. */
}

/*
Grouping content
================
*/

/**
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
*/

hr {
	height: 0; /* 1 */
	color: inherit; /* 2 */
}

/*
Text-level semantics
====================
*/

/**
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr[title] {
	text-decoration: underline dotted;
}

/**
Add the correct font weight in Edge and Safari.
*/

b,
strong {
	font-weight: bolder;
}

/**
1. Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)
2. Correct the odd 'em' font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
	font-family:
		ui-monospace,
		SFMono-Regular,
		Consolas,
		'Liberation Mono',
		Menlo,
		monospace; /* 1 */
	font-size: 1em; /* 2 */
}

/**
Add the correct font size in all browsers.
*/

small {
	font-size: 80%;
}

/**
Prevent 'sub' and 'sup' elements from affecting the line height in all browsers.
*/

sub,
sup {
	font-size: 75%;
	line-height: 0;
	position: relative;
	vertical-align: baseline;
}

sub {
	bottom: -0.25em;
}

sup {
	top: -0.5em;
}

/*
Tabular data
============
*/

/**
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
*/

table {
	text-indent: 0; /* 1 */
	border-color: inherit; /* 2 */
}

/*
Forms
=====
*/

/**
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
*/

button,
input,
optgroup,
select,
textarea {
	font-family: inherit; /* 1 */
	font-size: 100%; /* 1 */
	line-height: 1.15; /* 1 */
	margin: 0; /* 2 */
}

/**
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
	text-transform: none;
}

/**
Correct the inability to style clickable types in iOS and Safari.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
	-webkit-appearance: button;
}

/**
Remove the inner border and padding in Firefox.
*/

::-moz-focus-inner {
	border-style: none;
	padding: 0;
}

/**
Restore the focus styles unset by the previous rule.
*/

:-moz-focusring {
	outline: 1px dotted ButtonText;
}

/**
Remove the additional ':invalid' styles in Firefox.
See: https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737
*/

:-moz-ui-invalid {
	box-shadow: none;
}

/**
Remove the padding so developers are not caught out when they zero out 'fieldset' elements in all browsers.
*/

legend {
	padding: 0;
}

/**
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
	vertical-align: baseline;
}

/**
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
	height: auto;
}

/**
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
	-webkit-appearance: textfield; /* 1 */
	outline-offset: -2px; /* 2 */
}

/**
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
	-webkit-appearance: none;
}

/**
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to 'inherit' in Safari.
*/

::-webkit-file-upload-button {
	-webkit-appearance: button; /* 1 */
	font: inherit; /* 2 */
}

/*
Interactive
===========
*/

/*
Add the correct display in Chrome and Safari.
*/

summary {
	display: list-item;
}
`);
function $4236f07f676147d4$var$ln() {
    return $4236f07f676147d4$var$on();
}
var $4236f07f676147d4$var$an = /* @__PURE__ */ $4236f07f676147d4$var$C("<div class=divider><div>");
function $4236f07f676147d4$var$cn() {
    return (()=>{
        var e = $4236f07f676147d4$var$an(), t = e.firstChild;
        return t.style.setProperty("height", "100%"), t.style.setProperty("width", "1px"), t.style.setProperty("background", "#dcdcdc"), e;
    })();
}
var $4236f07f676147d4$var$un = /* @__PURE__ */ $4236f07f676147d4$var$C("<div>");
function $4236f07f676147d4$var$dn(e) {
    return (()=>{
        var t = $4236f07f676147d4$var$un();
        return t.style.setProperty("padding", "24px"), t.style.setProperty("height", "100%"), $4236f07f676147d4$var$b(t, ()=>e.children), t;
    })();
}
var $4236f07f676147d4$var$fn = /* @__PURE__ */ $4236f07f676147d4$var$C("<div>");
function $4236f07f676147d4$var$hn(e) {
    return (()=>{
        var t = $4236f07f676147d4$var$fn();
        return t.style.setProperty("display", "flex"), t.style.setProperty("flex-direction", "column"), t.style.setProperty("justify-content", "center"), t.style.setProperty("align-items", "center"), t.style.setProperty("height", "100%"), $4236f07f676147d4$var$b(t, ()=>e.children), t;
    })();
}
var $4236f07f676147d4$var$pn = /* @__PURE__ */ $4236f07f676147d4$var$C("<div><div>\uD83E\uDD14</div><div>What is a wallet?</div><p>Wallets let you send, receive, store and display digital assets like Bitcoin, Stacks, Ordinals & NFTs.</p><p>Explore Bitcoin apps by connecting your wallet.");
function $4236f07f676147d4$var$yn() {
    return (()=>{
        var e = $4236f07f676147d4$var$pn(), t = e.firstChild, n = t.nextSibling, i = n.nextSibling, r = i.nextSibling;
        return e.style.setProperty("display", "flex"), e.style.setProperty("flex-direction", "column"), e.style.setProperty("row-gap", "8px"), e.style.setProperty("justify-content", "center"), e.style.setProperty("align-items", "center"), t.style.setProperty("font-size", "50px"), t.style.setProperty("line-height", "140%"), $4236f07f676147d4$var$A((s)=>{
            var l = $4236f07f676147d4$var$re, o = $4236f07f676147d4$var$W, c = $4236f07f676147d4$var$W;
            return s.e = $4236f07f676147d4$var$L(n, l, s.e), s.t = $4236f07f676147d4$var$L(i, o, s.t), s.a = $4236f07f676147d4$var$L(r, c, s.a), s;
        }, {
            e: void 0,
            t: void 0,
            a: void 0
        }), e;
    })();
}
function $4236f07f676147d4$var$Se(e) {
    var n;
    const t = (n = e.installPrompt) == null ? void 0 : n.url;
    if (!t) {
        console.error("No install prompt URL found for", e.id);
        return;
    }
    window.open(t, "_blank");
}
var $4236f07f676147d4$var$gn = /* @__PURE__ */ $4236f07f676147d4$var$C(`<style>
          .install-prompt-button:focus-visible {
            outline: 2px solid #181818;
            outline-offset: 2px;
          }
        `), $4236f07f676147d4$var$mn = /* @__PURE__ */ $4236f07f676147d4$var$C("<div><img><h1>Don't have <!>?</h1><p>Download it on the Chrome web store.</p><div class=install-prompt-button role=button tabindex=0>Get");
function $4236f07f676147d4$var$bn(e) {
    function t(i) {
        (i.key === "Enter" || i.key === " ") && $4236f07f676147d4$var$Se(e.option);
    }
    function n() {
        $4236f07f676147d4$var$Se(e.option);
    }
    return [
        $4236f07f676147d4$var$gn(),
        (()=>{
            var i = $4236f07f676147d4$var$mn(), r = i.firstChild, s = r.nextSibling, l = s.firstChild, o = l.nextSibling;
            o.nextSibling;
            var c = s.nextSibling, f = c.nextSibling;
            return i.style.setProperty("display", "flex"), i.style.setProperty("flex-direction", "column"), i.style.setProperty("align-items", "center"), i.style.setProperty("row-gap", "16px"), r.style.setProperty("border-radius", "12px"), r.style.setProperty("height", "64px"), r.style.setProperty("width", "64px"), r.style.setProperty("object-fit", "cover"), $4236f07f676147d4$var$b(s, ()=>e.option.name, o), f.addEventListener("click", n), f.addEventListener("keydown", t), $4236f07f676147d4$var$A((a)=>{
                var u = e.option.icon, d = e.option.name, h = {
                    ...$4236f07f676147d4$var$re,
                    "text-align": "center"
                }, v = $4236f07f676147d4$var$W, y = {
                    ...$4236f07f676147d4$var$Qt,
                    cursor: "pointer",
                    "border-radius": "12px",
                    background: "#181818",
                    color: "white",
                    padding: "12px 16px"
                };
                return u !== a.e && $4236f07f676147d4$var$N(r, "src", a.e = u), d !== a.t && $4236f07f676147d4$var$N(r, "alt", a.t = d), a.a = $4236f07f676147d4$var$L(s, h, a.a), a.o = $4236f07f676147d4$var$L(c, v, a.o), a.i = $4236f07f676147d4$var$L(f, y, a.i), a;
            }, {
                e: void 0,
                t: void 0,
                a: void 0,
                o: void 0,
                i: void 0
            }), i;
        })()
    ];
}
var $4236f07f676147d4$var$wn = /* @__PURE__ */ $4236f07f676147d4$var$C('<svg width=20 height=20 viewBox="0 0 20 20"xmlns=http://www.w3.org/2000/svg><circle cx=10 cy=10 r=9.05 stroke=black stroke-width=1.9 fill=none stroke-dasharray="42.65 14.22"stroke-dashoffset=0><animateTransform attributeName=transform attributeType=XML type=rotate from="0 10 10"to="360 10 10"dur=0.75s repeatCount=indefinite>'), $4236f07f676147d4$var$vn = /* @__PURE__ */ $4236f07f676147d4$var$C("<div>");
const $4236f07f676147d4$var$xn = ()=>$4236f07f676147d4$var$wn();
function $4236f07f676147d4$var$Cn() {
    return (()=>{
        var e = $4236f07f676147d4$var$vn();
        return e.style.setProperty("display", "flex"), e.style.setProperty("justify-content", "center"), e.style.setProperty("align-items", "center"), e.style.setProperty("height", "100%"), e.style.setProperty("animation", "spin 1s linear infinite"), $4236f07f676147d4$var$b(e, $4236f07f676147d4$var$g($4236f07f676147d4$var$xn, {})), e;
    })();
}
var $4236f07f676147d4$var$Pn = /* @__PURE__ */ $4236f07f676147d4$var$C("<div><img><h1>Opening <!>...</h1><p>Confirm the operation in ");
function $4236f07f676147d4$var$Sn(e) {
    return (()=>{
        var t = $4236f07f676147d4$var$Pn(), n = t.firstChild, i = n.nextSibling, r = i.firstChild, s = r.nextSibling;
        s.nextSibling;
        var l = i.nextSibling;
        return l.firstChild, t.style.setProperty("display", "flex"), t.style.setProperty("flex-direction", "column"), t.style.setProperty("align-items", "center"), t.style.setProperty("row-gap", "16px"), n.style.setProperty("border-radius", "12px"), n.style.setProperty("height", "64px"), n.style.setProperty("width", "64px"), n.style.setProperty("object-fit", "cover"), $4236f07f676147d4$var$b(i, ()=>e.option.name, s), $4236f07f676147d4$var$b(l, ()=>e.option.name, null), $4236f07f676147d4$var$b(t, $4236f07f676147d4$var$g($4236f07f676147d4$var$Cn, {}), null), $4236f07f676147d4$var$A((o)=>{
            var c = e.option.icon, f = e.option.name, a = {
                ...$4236f07f676147d4$var$re,
                "text-align": "center"
            }, u = $4236f07f676147d4$var$W;
            return c !== o.e && $4236f07f676147d4$var$N(n, "src", o.e = c), f !== o.t && $4236f07f676147d4$var$N(n, "alt", o.t = f), o.a = $4236f07f676147d4$var$L(i, a, o.a), o.o = $4236f07f676147d4$var$L(l, u, o.o), o;
        }, {
            e: void 0,
            t: void 0,
            a: void 0,
            o: void 0
        }), t;
    })();
}
var $4236f07f676147d4$var$_n = /* @__PURE__ */ $4236f07f676147d4$var$C("<div><div tabindex=0><img><div>");
function $4236f07f676147d4$var$En(e) {
    function t() {
        e.onProviderSelected(e.id);
    }
    const n = $4236f07f676147d4$var$F(()=>$4236f07f676147d4$export$723d9c21be5da6c5(e) ? "button" : "link");
    function i(u) {
        if (n() === "link") {
            u.key === "Enter" && t();
            return;
        }
        if (n() === "button") {
            (u.key === "Enter" || u.key === " ") && t();
            return;
        }
    }
    const [r, s] = $4236f07f676147d4$var$j(!1), [l, o] = $4236f07f676147d4$var$j(!1), c = ()=>r() || l(), f = "rgba(24, 24, 24, 0.20)", a = "rgba(24, 24, 24, 0.60)";
    return (()=>{
        var u = $4236f07f676147d4$var$_n(), d = u.firstChild, h = d.firstChild, v = h.nextSibling;
        return u.style.setProperty("aspect-ratio", "1 / 1"), u.style.setProperty("overflow", "hidden"), d.style.setProperty("display", "flex"), d.style.setProperty("flex-direction", "column"), d.style.setProperty("row-gap", "12px"), d.style.setProperty("align-items", "center"), d.style.setProperty("cursor", "pointer"), d.style.setProperty("outline", "none"), d.style.setProperty("padding-top", "10px"), d.addEventListener("click", t), d.addEventListener("keydown", i), d.addEventListener("mouseenter", ()=>s(!0)), d.addEventListener("mouseleave", ()=>s(!1)), d.addEventListener("focus", ()=>o(!0)), d.addEventListener("blur", ()=>o(!1)), h.style.setProperty("width", "56px"), h.style.setProperty("height", "56px"), h.style.setProperty("object-fit", "cover"), h.style.setProperty("border-radius", "12px"), $4236f07f676147d4$var$b(v, ()=>e.name), $4236f07f676147d4$var$A((y)=>{
            var z = n(), $ = c() ? `6px solid ${f}` : "none", P = e.icon, _ = e.name, E = {
                ...$4236f07f676147d4$var$W,
                color: c() ? a : void 0,
                "text-align": "center"
            };
            return z !== y.e && $4236f07f676147d4$var$N(d, "role", y.e = z), $ !== y.t && ((y.t = $) != null ? h.style.setProperty("outline", $) : h.style.removeProperty("outline")), P !== y.a && $4236f07f676147d4$var$N(h, "src", y.a = P), _ !== y.o && $4236f07f676147d4$var$N(h, "alt", y.o = _), y.i = $4236f07f676147d4$var$L(v, E, y.i), y;
        }, {
            e: void 0,
            t: void 0,
            a: void 0,
            o: void 0,
            i: void 0
        }), u;
    })();
}
var $4236f07f676147d4$var$kn = /* @__PURE__ */ $4236f07f676147d4$var$C('<link href="https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&amp;display=swap"rel=stylesheet>'), $4236f07f676147d4$var$$n = /* @__PURE__ */ $4236f07f676147d4$var$C("<div class=side-panel>"), $4236f07f676147d4$var$An = /* @__PURE__ */ $4236f07f676147d4$var$C('<div><div></div><div><div class=card-width-container><div class=card-height-container><div class=card><div class=card-grid><div class=main-panel><div></div><div></div><div class=wallets-grid-container data-desc="wallet grid container for padding"><div class=wallets-grid data-desc="wallet grid container">'), $4236f07f676147d4$var$Ln = /* @__PURE__ */ $4236f07f676147d4$var$C(`<div><style>
        @keyframes wallet-selector-fade-in {
          from {opacity: 0; transform: translateY(40px);}
          to {opacity: 1; transform: translateY(0);}
        }

        @keyframes wallet-selector-fade-out {
          from {opacity: 1; transform: translateY(0);}
          to {opacity: 0; transform: translateY(40px);}
        }
        @keyframes wallet-selector-blur-in {
          from {opacity: 0; backdrop-filter: blur(0px);}
          to {opacity: 1; backdrop-filter: blur(10px);}
        }

        @keyframes wallet-selector-blur-out {
          from {opacity: 1; backdrop-filter: blur(10px);}
          to {opacity: 0; backdrop-filter: blur(0px);}
        }
      </style><style>`);
const $4236f07f676147d4$var$G = "24px";
function $4236f07f676147d4$var$On() {
    const [e, t] = $4236f07f676147d4$var$j(), [n, i] = $4236f07f676147d4$var$j(), [r, s] = $4236f07f676147d4$var$j();
    function l() {
        const p = e(), x = r();
        return !(!p || !x || !p.contains(x) || getComputedStyle(x).display === "none");
    }
    const [o, c] = $4236f07f676147d4$var$j(!1), [f, a] = $4236f07f676147d4$var$j(!1), [u, d] = $4236f07f676147d4$var$j([]), [h, v] = $4236f07f676147d4$var$j({
        type: "none"
    }), y = ()=>u().some((p)=>$4236f07f676147d4$export$1a7ce0848b9df5ad(p)), z = ()=>c(!1);
    function $() {
        const p = new CustomEvent($4236f07f676147d4$var$xe, {
            bubbles: !0,
            composed: !0
        });
        window.dispatchEvent(p), z();
    }
    function P(p) {
        p.key === "Escape" && $();
    }
    $4236f07f676147d4$var$Fe(()=>{
        if (o()) {
            window.addEventListener("keydown", P);
            return;
        }
        window.removeEventListener("keydown", P);
    });
    function _(p) {
        const x = u().find((K)=>K.id === p);
        if ($4236f07f676147d4$export$723d9c21be5da6c5(x)) {
            l() ? v({
                type: "install-wallet-prompt",
                option: x
            }) : $4236f07f676147d4$var$Se(x);
            return;
        }
        const O = new CustomEvent($4236f07f676147d4$var$ve, {
            detail: p,
            bubbles: !0,
            composed: !0
        });
        window.dispatchEvent(O);
    }
    function E(p) {
        $4236f07f676147d4$var$mt(()=>{
            c(!0), a(!0);
            const x = p.detail.options;
            d(x), x.some((O)=>!O.installPrompt) ? v({
                type: "explainer"
            }) : v({
                type: "none"
            });
        });
    }
    function R() {
        c(!1);
    }
    const se = ()=>{
        o() || a(!1);
    };
    function Ye(p) {
        const x = p.detail;
        v({
            type: "opening-wallet",
            option: u().find((O)=>O.id === x)
        });
    }
    function Ge() {
        v({
            type: "explainer"
        });
    }
    $4236f07f676147d4$var$bt(()=>{
        window.addEventListener($4236f07f676147d4$var$Ce, E), window.addEventListener($4236f07f676147d4$var$Pe, R), window.addEventListener($4236f07f676147d4$var$Xe, Ye), window.addEventListener($4236f07f676147d4$var$qe, Ge), document.head.appendChild($4236f07f676147d4$var$kn());
    }), $4236f07f676147d4$var$Me(()=>{
        window.removeEventListener($4236f07f676147d4$var$Ce, E), window.removeEventListener($4236f07f676147d4$var$Pe, R);
    });
    function Ze(p) {
        const x = p.target;
        if (!x) return;
        const O = n();
        O && (O.contains(x) || $());
    }
    return (()=>{
        var p = $4236f07f676147d4$var$Ln(), x = p.firstChild, O = x.nextSibling;
        return $4236f07f676147d4$var$ye(t, p), p.style.setProperty("inset", "0"), p.addEventListener("click", Ze), p.addEventListener("keydown", ()=>{
            console.log("Inside root keydown");
        }), $4236f07f676147d4$var$b(p, $4236f07f676147d4$var$g($4236f07f676147d4$var$ln, {}), x), $4236f07f676147d4$var$b(O, ()=>`
        .card-width-container {
          container: card-width-container / inline-size;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
          width: 740px;
        }

        .card-height-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-end;
          height: 100%;
          width: 100%;
        }

        .card {
          min-height: 340px;
          max-height: calc(100vh - 8rem);
          width: 100%;
          border-top-left-radius: ${$4236f07f676147d4$var$G};
          border-top-right-radius: ${$4236f07f676147d4$var$G};

          background: rgb(196, 177, 217);
          overflow: hidden;

          display: flex;
          flex-direction: column;

          position: "relative"; /* For the close button */
          background-color: #ffffff;
          display: ${f() ? "block" : "none"};

          box-shadow: 0px 8px 64px 0px rgba(0, 0, 0, 0.25);
          animation: ${o() ? "wallet-selector-fade-in 0.4s cubic-bezier(.05, .7, .1, 1) forwards" : "wallet-selector-fade-out 0.2s cubic-bezier(.3, 0, .8, .15) forwards"};
        }

        .card-grid {
          flex-grow: 1;
          height: 100%;
          
          display: grid;
          grid-template-columns: 1fr;
          grid-template-areas: "mainPanel";
        }

        .main-panel {
          height: 100%;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          grid-area: mainPanel;
        }

        .wallets-grid-container {
          overflow: auto;
          flex-grow: 1;
        }

        .wallets-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
          align-content: start;

          padding-left: 24px;
          padding-right: 24px;
          padding-bottom: 40px;
        }

        .divider {
          display: none;
          grid-area: divider;
        }

        .side-panel {
          display: none;
          grid-area: sidePanel;
        }

        @container card-width-container (width > 400px) {
          .card-height-container {
            justify-content: center;
          }

          .card {
            max-width: calc(100vw - 2rem);
            max-height: 460px;
            ${y() ? "" : "width: 360px;"}
            border-bottom-left-radius: ${$4236f07f676147d4$var$G};
            border-bottom-right-radius: ${$4236f07f676147d4$var$G};
          }

          .card-grid {
            grid-template-columns: ${y() ? "5fr auto 4fr" : "1fr"};
            grid-template-areas: ${y() ? '"mainPanel divider sidePanel"' : '"mainPanel"'};
          }

          .divider {
            display: block;
          }

          .side-panel {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
        }
      `), $4236f07f676147d4$var$b(p, $4236f07f676147d4$var$g($4236f07f676147d4$var$he, {
            get when () {
                return f();
            },
            get children () {
                var K = $4236f07f676147d4$var$An(), B = K.firstChild, X = B.nextSibling, Je = X.firstChild, Qe = Je.firstChild, H = Qe.firstChild, oe = H.firstChild, et = oe.firstChild, le = et.firstChild, ae = le.nextSibling, tt = ae.nextSibling, nt = tt.firstChild;
                return K.style.setProperty("position", "fixed"), K.style.setProperty("inset", "0"), B.style.setProperty("background-color", "#FFFFFF80"), B.style.setProperty("position", "absolute"), B.style.setProperty("inset", "0"), X.style.setProperty("display", "flex"), X.style.setProperty("justify-content", "center"), X.style.setProperty("align-items", "center"), X.style.setProperty("height", "100%"), $4236f07f676147d4$var$ye(i, H), H.addEventListener("animationend", se), $4236f07f676147d4$var$b(le, ()=>y() ? "Choose wallet to connect" : "Don't have a wallet?"), $4236f07f676147d4$var$b(ae, ()=>y() ? "Start by selecting with one of the wallets below and confirming the connection." : "Start by installing one of the wallets below."), $4236f07f676147d4$var$b(nt, $4236f07f676147d4$var$g($4236f07f676147d4$var$At, {
                    get each () {
                        return u();
                    },
                    children: (k)=>$4236f07f676147d4$var$g($4236f07f676147d4$var$En, $4236f07f676147d4$var$$t(k, {
                            onProviderSelected: _
                        }))
                })), $4236f07f676147d4$var$b(oe, $4236f07f676147d4$var$g($4236f07f676147d4$var$he, {
                    get when () {
                        return h().type !== "none";
                    },
                    get children () {
                        return $4236f07f676147d4$var$g($4236f07f676147d4$var$cn, {});
                    }
                }), null), $4236f07f676147d4$var$b(oe, $4236f07f676147d4$var$g($4236f07f676147d4$var$he, {
                    get when () {
                        return h().type !== "none";
                    },
                    get children () {
                        var k = $4236f07f676147d4$var$$n();
                        return $4236f07f676147d4$var$ye(s, k), $4236f07f676147d4$var$b(k, $4236f07f676147d4$var$g($4236f07f676147d4$var$dn, {
                            get children () {
                                return $4236f07f676147d4$var$g($4236f07f676147d4$var$hn, {
                                    get children () {
                                        return $4236f07f676147d4$var$g($4236f07f676147d4$var$Lt, {
                                            fallback: null,
                                            get children () {
                                                return [
                                                    $4236f07f676147d4$var$g($4236f07f676147d4$var$pe, {
                                                        get when () {
                                                            return h().type === "install-wallet-prompt";
                                                        },
                                                        get children () {
                                                            return $4236f07f676147d4$var$g($4236f07f676147d4$var$bn, {
                                                                get option () {
                                                                    return h().option;
                                                                }
                                                            });
                                                        }
                                                    }),
                                                    $4236f07f676147d4$var$g($4236f07f676147d4$var$pe, {
                                                        get when () {
                                                            return h().type === "explainer";
                                                        },
                                                        get children () {
                                                            return $4236f07f676147d4$var$g($4236f07f676147d4$var$yn, {});
                                                        }
                                                    }),
                                                    $4236f07f676147d4$var$g($4236f07f676147d4$var$pe, {
                                                        get when () {
                                                            return h().type === "opening-wallet";
                                                        },
                                                        get children () {
                                                            return $4236f07f676147d4$var$g($4236f07f676147d4$var$Sn, {
                                                                get option () {
                                                                    return h().option;
                                                                }
                                                            });
                                                        }
                                                    })
                                                ];
                                            }
                                        });
                                    }
                                });
                            }
                        })), k;
                    }
                }), null), $4236f07f676147d4$var$b(H, $4236f07f676147d4$var$g($4236f07f676147d4$var$sn, {
                    onClose: $
                }), null), $4236f07f676147d4$var$A((k)=>{
                    var ce = o() ? "wallet-selector-blur-in 0.2s cubic-bezier(.05, .7, .1, 1) forwards" : "wallet-selector-blur-out 0.2s cubic-bezier(.3, 0, .8, .15) forwards", it = {
                        ...$4236f07f676147d4$var$re,
                        margin: "0",
                        "padding-top": "24px",
                        "padding-left": "24px",
                        "padding-right": "24px",
                        "padding-bottom": "16px"
                    }, rt = {
                        ...$4236f07f676147d4$var$W,
                        "padding-left": "24px",
                        "padding-right": "24px",
                        "padding-bottom": "30px"
                    };
                    return ce !== k.e && ((k.e = ce) != null ? B.style.setProperty("animation", ce) : B.style.removeProperty("animation")), k.t = $4236f07f676147d4$var$L(le, it, k.t), k.a = $4236f07f676147d4$var$L(ae, rt, k.a), k;
                }, {
                    e: void 0,
                    t: void 0,
                    a: void 0
                }), K;
            }
        }), null), $4236f07f676147d4$var$A(()=>(f(), p.style.setProperty("position", f() ? "fixed" : "static"))), p;
    })();
}
const $4236f07f676147d4$export$89882c0ac7af12a4 = "sats-connect-wallet-provider-selector", $4236f07f676147d4$export$befb8987f3390baa = $4236f07f676147d4$export$89882c0ac7af12a4;
function $4236f07f676147d4$export$dba43aa3566c900c() {
    return document.getElementById($4236f07f676147d4$export$89882c0ac7af12a4);
}
function $4236f07f676147d4$export$9e28020f9ccd3a22() {
    if (customElements.get($4236f07f676147d4$export$befb8987f3390baa)) return;
    $4236f07f676147d4$var$Jt($4236f07f676147d4$export$befb8987f3390baa, $4236f07f676147d4$var$On);
    const e = document.createElement($4236f07f676147d4$export$befb8987f3390baa);
    e.id = $4236f07f676147d4$export$89882c0ac7af12a4, e.style.position = "relative", e.style.zIndex = "999999", document.body.appendChild(e);
}
function $4236f07f676147d4$export$de863c629cb9919d() {
    const e = $4236f07f676147d4$export$dba43aa3566c900c();
    e && e.remove();
}
function $4236f07f676147d4$export$723d9c21be5da6c5(e) {
    return !!e.installPrompt;
}
function $4236f07f676147d4$export$1a7ce0848b9df5ad(e) {
    return !$4236f07f676147d4$export$723d9c21be5da6c5(e);
}
function $4236f07f676147d4$export$572bf5fa695e2507(e) {
    return new Promise((t, n)=>{
        if (!$4236f07f676147d4$export$dba43aa3566c900c()) {
            n("Failed to detect the wallet provider selector.");
            return;
        }
        function r() {
            window.removeEventListener($4236f07f676147d4$var$ve, s), window.removeEventListener($4236f07f676147d4$var$xe, l);
        }
        function s(c) {
            t(c.detail), r();
        }
        function l() {
            n(), r();
        }
        window.addEventListener($4236f07f676147d4$var$ve, s), window.addEventListener($4236f07f676147d4$var$xe, l);
        const o = new CustomEvent($4236f07f676147d4$var$Ce, {
            detail: e
        });
        window.dispatchEvent(o);
    });
}
function $4236f07f676147d4$export$5fb5d07e7a2c7576(e) {
    const t = new CustomEvent($4236f07f676147d4$var$Xe, {
        detail: e
    });
    window.dispatchEvent(t);
}
function $4236f07f676147d4$export$3ed1f38bf5c4770b() {
    const e = new CustomEvent($4236f07f676147d4$var$qe);
    window.dispatchEvent(e);
}
function $4236f07f676147d4$export$8360e631d277ea4d() {
    const e = new CustomEvent($4236f07f676147d4$var$Pe);
    window.dispatchEvent(e);
}


var $bacd6aa7e37c1989$exports = {};
!function(e, t) {
    $bacd6aa7e37c1989$exports = t();
}($bacd6aa7e37c1989$exports, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});


function $a89c46b335b83e44$export$37525ff87a8ef57d() {
    return typeof window.ReactNativeWebView !== "undefined";
}


function $f8a5672653aa0b22$var$appStoreUrl(p) {
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($bacd6aa7e37c1989$exports))).getParser(window.navigator.userAgent);
    if (browser.satisfies({
        desktop: {
            chrome: ">=1"
        }
    })) return p.chromeWebStoreUrl;
    if (browser.satisfies({
        desktop: {
            firefox: ">=1"
        }
    })) return p.mozillaAddOnsUrl;
    if (browser.satisfies({
        android: {
            chrome: ">=1",
            safari: ">=1"
        }
    })) return p.googlePlayStoreUrl;
    if (browser.satisfies({
        ios: {
            chrome: ">=1",
            safari: ">=1"
        }
    })) return p.iOSAppStoreUrl;
}
function $f8a5672653aa0b22$var$getInstallPrompt(provider) {
    const url = $f8a5672653aa0b22$var$appStoreUrl(provider);
    if (url) return {
        installPrompt: {
            url: url
        }
    };
    console.error(`[makeDefaultConfig]: No app store URL found for ${provider.name}.`);
    return {};
}
function $f8a5672653aa0b22$export$246c4b321fef5774(providers) {
    const config = {
        options: []
    };
    // Xverse
    const xverseProvider = providers.find((provider)=>provider.id === (0, $adfbe621f07e3fbf$export$eea66190956591ea).xverse.id);
    config.options.push(xverseProvider ? xverseProvider : {
        ...(0, $adfbe621f07e3fbf$export$eea66190956591ea).xverse,
        ...$f8a5672653aa0b22$var$getInstallPrompt((0, $adfbe621f07e3fbf$export$eea66190956591ea).xverse)
    });
    if ((0, $a89c46b335b83e44$export$37525ff87a8ef57d)()) return config;
    // Unisat
    const unisatProvider = providers.find((provider)=>provider.id === "unisat");
    if (unisatProvider && unisatProvider.isInstalled) config.options.push(unisatProvider);
    // Rest
    config.options = config.options.concat(providers.filter((provider)=>{
        return provider.id !== (0, $adfbe621f07e3fbf$export$eea66190956591ea).xverse.id && provider.id !== "unisat";
    }).map((provider)=>{
        return {
            ...provider,
            ...provider.isInstalled ? {} : $f8a5672653aa0b22$var$getInstallPrompt(provider)
        };
    }));
    return config;
}


function $46c24eb3104107ba$var$st(e) {
    return Object.keys(e).reduce((n, i)=>{
        const r = e[i];
        return n[i] = Object.assign({}, r), $46c24eb3104107ba$var$ze(r.value) && !$46c24eb3104107ba$var$ut(r.value) && !Array.isArray(r.value) && (n[i].value = Object.assign({}, r.value)), Array.isArray(r.value) && (n[i].value = r.value.slice(0)), n;
    }, {});
}
function $46c24eb3104107ba$var$ot(e) {
    return e ? Object.keys(e).reduce((n, i)=>{
        const r = e[i];
        return n[i] = $46c24eb3104107ba$var$ze(r) && "value" in r ? r : {
            value: r
        }, n[i].attribute || (n[i].attribute = $46c24eb3104107ba$var$ct(i)), n[i].parse = "parse" in n[i] ? n[i].parse : typeof n[i].value != "string", n;
    }, {}) : {};
}
function $46c24eb3104107ba$var$lt(e) {
    return Object.keys(e).reduce((n, i)=>(n[i] = e[i].value, n), {});
}
function $46c24eb3104107ba$var$at(e, t) {
    const n = $46c24eb3104107ba$var$st(t);
    return Object.keys(t).forEach((r)=>{
        const s = n[r], l = e.getAttribute(s.attribute), o = e[r];
        l && (s.value = s.parse ? $46c24eb3104107ba$var$Ne(l) : l), o != null && (s.value = Array.isArray(o) ? o.slice(0) : o), s.reflect && $46c24eb3104107ba$var$$e(e, s.attribute, s.value), Object.defineProperty(e, r, {
            get () {
                return s.value;
            },
            set (c) {
                const f = s.value;
                s.value = c, s.reflect && $46c24eb3104107ba$var$$e(this, s.attribute, s.value);
                for(let a = 0, u = this.__propertyChangedCallbacks.length; a < u; a++)this.__propertyChangedCallbacks[a](r, c, f);
            },
            enumerable: !0,
            configurable: !0
        });
    }), n;
}
function $46c24eb3104107ba$var$Ne(e) {
    if (e) try {
        return JSON.parse(e);
    } catch  {
        return e;
    }
}
function $46c24eb3104107ba$var$$e(e, t, n) {
    if (n == null || n === !1) return e.removeAttribute(t);
    let i = JSON.stringify(n);
    e.__updating[t] = !0, i === "true" && (i = ""), e.setAttribute(t, i), Promise.resolve().then(()=>delete e.__updating[t]);
}
function $46c24eb3104107ba$var$ct(e) {
    return e.replace(/\.?([A-Z]+)/g, (t, n)=>"-" + n.toLowerCase()).replace("_", "-").replace(/^-/, "");
}
function $46c24eb3104107ba$var$ze(e) {
    return e != null && (typeof e == "object" || typeof e == "function");
}
function $46c24eb3104107ba$var$ut(e) {
    return Object.prototype.toString.call(e) === "[object Function]";
}
function $46c24eb3104107ba$var$dt(e) {
    return typeof e == "function" && e.toString().indexOf("class") === 0;
}
let $46c24eb3104107ba$var$ue;
function $46c24eb3104107ba$var$ft(e, t) {
    const n = Object.keys(t);
    return class extends e {
        static get observedAttributes() {
            return n.map((r)=>t[r].attribute);
        }
        constructor(){
            super(), this.__initialized = !1, this.__released = !1, this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = {};
        }
        connectedCallback() {
            if (this.__initialized) return;
            this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = $46c24eb3104107ba$var$at(this, t);
            const r = $46c24eb3104107ba$var$lt(this.props), s = this.Component, l = $46c24eb3104107ba$var$ue;
            try {
                $46c24eb3104107ba$var$ue = this, this.__initialized = !0, $46c24eb3104107ba$var$dt(s) ? new s(r, {
                    element: this
                }) : s(r, {
                    element: this
                });
            } finally{
                $46c24eb3104107ba$var$ue = l;
            }
        }
        async disconnectedCallback() {
            if (await Promise.resolve(), this.isConnected) return;
            this.__propertyChangedCallbacks.length = 0;
            let r = null;
            for(; r = this.__releaseCallbacks.pop();)r(this);
            delete this.__initialized, this.__released = !0;
        }
        attributeChangedCallback(r, s, l) {
            if (this.__initialized && !this.__updating[r] && (r = this.lookupProp(r), r in t)) {
                if (l == null && !this[r]) return;
                this[r] = t[r].parse ? $46c24eb3104107ba$var$Ne(l) : l;
            }
        }
        lookupProp(r) {
            if (t) return n.find((s)=>r === s || r === t[s].attribute);
        }
        get renderRoot() {
            return this.shadowRoot || this.attachShadow({
                mode: "open"
            });
        }
        addReleaseCallback(r) {
            this.__releaseCallbacks.push(r);
        }
        addPropertyChangedCallback(r) {
            this.__propertyChangedCallbacks.push(r);
        }
    };
}
function $46c24eb3104107ba$var$ht(e, t = {}, n = {}) {
    const { BaseElement: i = HTMLElement, extension: r } = n;
    return (s)=>{
        if (!e) throw new Error("tag is required to register a Component");
        let l = customElements.get(e);
        return l ? (l.prototype.Component = s, l) : (l = $46c24eb3104107ba$var$ft(i, $46c24eb3104107ba$var$ot(t)), l.prototype.Component = s, l.prototype.registeredTag = e, customElements.define(e, l, r), l);
    };
}
const $46c24eb3104107ba$var$pt = (e, t)=>e === t, $46c24eb3104107ba$var$me = Symbol("solid-proxy"), $46c24eb3104107ba$var$yt = Symbol("solid-track"), $46c24eb3104107ba$var$J = {
    equals: $46c24eb3104107ba$var$pt
};
let $46c24eb3104107ba$var$Re = $46c24eb3104107ba$var$De;
const $46c24eb3104107ba$var$M = 1, $46c24eb3104107ba$var$Q = 2, $46c24eb3104107ba$var$Ie = {
    owned: null,
    cleanups: null,
    context: null,
    owner: null
};
var $46c24eb3104107ba$var$w = null;
let $46c24eb3104107ba$var$de = null, $46c24eb3104107ba$var$gt = null, $46c24eb3104107ba$var$m = null, $46c24eb3104107ba$var$S = null, $46c24eb3104107ba$var$I = null, $46c24eb3104107ba$var$ne = 0;
function $46c24eb3104107ba$var$Z(e, t) {
    const n = $46c24eb3104107ba$var$m, i = $46c24eb3104107ba$var$w, r = e.length === 0, s = t === void 0 ? i : t, l = r ? $46c24eb3104107ba$var$Ie : {
        owned: null,
        cleanups: null,
        context: s ? s.context : null,
        owner: s
    }, o = r ? e : ()=>e(()=>$46c24eb3104107ba$var$T(()=>$46c24eb3104107ba$var$ie(l)));
    $46c24eb3104107ba$var$w = l, $46c24eb3104107ba$var$m = null;
    try {
        return $46c24eb3104107ba$var$V(o, !0);
    } finally{
        $46c24eb3104107ba$var$m = n, $46c24eb3104107ba$var$w = i;
    }
}
function $46c24eb3104107ba$var$j(e, t) {
    t = t ? Object.assign({}, $46c24eb3104107ba$var$J, t) : $46c24eb3104107ba$var$J;
    const n = {
        value: e,
        observers: null,
        observerSlots: null,
        comparator: t.equals || void 0
    }, i = (r)=>(typeof r == "function" && (r = r(n.value)), $46c24eb3104107ba$var$Be(n, r));
    return [
        $46c24eb3104107ba$var$Ke.bind(n),
        i
    ];
}
function $46c24eb3104107ba$var$A(e, t, n) {
    const i = $46c24eb3104107ba$var$_e(e, t, !1, $46c24eb3104107ba$var$M);
    $46c24eb3104107ba$var$q(i);
}
function $46c24eb3104107ba$var$Fe(e, t, n) {
    $46c24eb3104107ba$var$Re = $46c24eb3104107ba$var$Ct;
    const i = $46c24eb3104107ba$var$_e(e, t, !1, $46c24eb3104107ba$var$M);
    (!n || !n.render) && (i.user = !0), $46c24eb3104107ba$var$I ? $46c24eb3104107ba$var$I.push(i) : $46c24eb3104107ba$var$q(i);
}
function $46c24eb3104107ba$var$F(e, t, n) {
    n = n ? Object.assign({}, $46c24eb3104107ba$var$J, n) : $46c24eb3104107ba$var$J;
    const i = $46c24eb3104107ba$var$_e(e, t, !0, 0);
    return i.observers = null, i.observerSlots = null, i.comparator = n.equals || void 0, $46c24eb3104107ba$var$q(i), $46c24eb3104107ba$var$Ke.bind(i);
}
function $46c24eb3104107ba$var$mt(e) {
    return $46c24eb3104107ba$var$V(e, !1);
}
function $46c24eb3104107ba$var$T(e) {
    if ($46c24eb3104107ba$var$m === null) return e();
    const t = $46c24eb3104107ba$var$m;
    $46c24eb3104107ba$var$m = null;
    try {
        return e();
    } finally{
        $46c24eb3104107ba$var$m = t;
    }
}
function $46c24eb3104107ba$var$bt(e) {
    $46c24eb3104107ba$var$Fe(()=>$46c24eb3104107ba$var$T(e));
}
function $46c24eb3104107ba$var$Me(e) {
    return $46c24eb3104107ba$var$w === null || ($46c24eb3104107ba$var$w.cleanups === null ? $46c24eb3104107ba$var$w.cleanups = [
        e
    ] : $46c24eb3104107ba$var$w.cleanups.push(e)), e;
}
function $46c24eb3104107ba$var$wt(e) {
    const t = $46c24eb3104107ba$var$F(e), n = $46c24eb3104107ba$var$F(()=>$46c24eb3104107ba$var$be(t()));
    return n.toArray = ()=>{
        const i = n();
        return Array.isArray(i) ? i : i != null ? [
            i
        ] : [];
    }, n;
}
function $46c24eb3104107ba$var$Ke() {
    if (this.sources && this.state) {
        if (this.state === $46c24eb3104107ba$var$M) $46c24eb3104107ba$var$q(this);
        else {
            const e = $46c24eb3104107ba$var$S;
            $46c24eb3104107ba$var$S = null, $46c24eb3104107ba$var$V(()=>$46c24eb3104107ba$var$te(this), !1), $46c24eb3104107ba$var$S = e;
        }
    }
    if ($46c24eb3104107ba$var$m) {
        const e = this.observers ? this.observers.length : 0;
        $46c24eb3104107ba$var$m.sources ? ($46c24eb3104107ba$var$m.sources.push(this), $46c24eb3104107ba$var$m.sourceSlots.push(e)) : ($46c24eb3104107ba$var$m.sources = [
            this
        ], $46c24eb3104107ba$var$m.sourceSlots = [
            e
        ]), this.observers ? (this.observers.push($46c24eb3104107ba$var$m), this.observerSlots.push($46c24eb3104107ba$var$m.sources.length - 1)) : (this.observers = [
            $46c24eb3104107ba$var$m
        ], this.observerSlots = [
            $46c24eb3104107ba$var$m.sources.length - 1
        ]);
    }
    return this.value;
}
function $46c24eb3104107ba$var$Be(e, t, n) {
    let i = e.value;
    return (!e.comparator || !e.comparator(i, t)) && (e.value = t, e.observers && e.observers.length && $46c24eb3104107ba$var$V(()=>{
        for(let r = 0; r < e.observers.length; r += 1){
            const s = e.observers[r], l = $46c24eb3104107ba$var$de && $46c24eb3104107ba$var$de.running;
            l && $46c24eb3104107ba$var$de.disposed.has(s), (l ? !s.tState : !s.state) && (s.pure ? $46c24eb3104107ba$var$S.push(s) : $46c24eb3104107ba$var$I.push(s), s.observers && $46c24eb3104107ba$var$Ue(s)), l || (s.state = $46c24eb3104107ba$var$M);
        }
        if ($46c24eb3104107ba$var$S.length > 1e6) throw $46c24eb3104107ba$var$S = [], new Error();
    }, !1)), t;
}
function $46c24eb3104107ba$var$q(e) {
    if (!e.fn) return;
    $46c24eb3104107ba$var$ie(e);
    const t = $46c24eb3104107ba$var$ne;
    $46c24eb3104107ba$var$vt(e, e.value, t);
}
function $46c24eb3104107ba$var$vt(e, t, n) {
    let i;
    const r = $46c24eb3104107ba$var$w, s = $46c24eb3104107ba$var$m;
    $46c24eb3104107ba$var$m = $46c24eb3104107ba$var$w = e;
    try {
        i = e.fn(t);
    } catch (l) {
        return e.pure && (e.state = $46c24eb3104107ba$var$M, e.owned && e.owned.forEach($46c24eb3104107ba$var$ie), e.owned = null), e.updatedAt = n + 1, $46c24eb3104107ba$var$We(l);
    } finally{
        $46c24eb3104107ba$var$m = s, $46c24eb3104107ba$var$w = r;
    }
    (!e.updatedAt || e.updatedAt <= n) && (e.updatedAt != null && "observers" in e ? $46c24eb3104107ba$var$Be(e, i) : e.value = i, e.updatedAt = n);
}
function $46c24eb3104107ba$var$_e(e, t, n, i = $46c24eb3104107ba$var$M, r) {
    const s = {
        fn: e,
        state: i,
        updatedAt: null,
        owned: null,
        sources: null,
        sourceSlots: null,
        cleanups: null,
        value: t,
        owner: $46c24eb3104107ba$var$w,
        context: $46c24eb3104107ba$var$w ? $46c24eb3104107ba$var$w.context : null,
        pure: n
    };
    return $46c24eb3104107ba$var$w === null || $46c24eb3104107ba$var$w !== $46c24eb3104107ba$var$Ie && ($46c24eb3104107ba$var$w.owned ? $46c24eb3104107ba$var$w.owned.push(s) : $46c24eb3104107ba$var$w.owned = [
        s
    ]), s;
}
function $46c24eb3104107ba$var$ee(e) {
    if (e.state === 0) return;
    if (e.state === $46c24eb3104107ba$var$Q) return $46c24eb3104107ba$var$te(e);
    if (e.suspense && $46c24eb3104107ba$var$T(e.suspense.inFallback)) return e.suspense.effects.push(e);
    const t = [
        e
    ];
    for(; (e = e.owner) && (!e.updatedAt || e.updatedAt < $46c24eb3104107ba$var$ne);)e.state && t.push(e);
    for(let n = t.length - 1; n >= 0; n--)if (e = t[n], e.state === $46c24eb3104107ba$var$M) $46c24eb3104107ba$var$q(e);
    else if (e.state === $46c24eb3104107ba$var$Q) {
        const i = $46c24eb3104107ba$var$S;
        $46c24eb3104107ba$var$S = null, $46c24eb3104107ba$var$V(()=>$46c24eb3104107ba$var$te(e, t[0]), !1), $46c24eb3104107ba$var$S = i;
    }
}
function $46c24eb3104107ba$var$V(e, t) {
    if ($46c24eb3104107ba$var$S) return e();
    let n = !1;
    t || ($46c24eb3104107ba$var$S = []), $46c24eb3104107ba$var$I ? n = !0 : $46c24eb3104107ba$var$I = [], $46c24eb3104107ba$var$ne++;
    try {
        const i = e();
        return $46c24eb3104107ba$var$xt(n), i;
    } catch (i) {
        n || ($46c24eb3104107ba$var$I = null), $46c24eb3104107ba$var$S = null, $46c24eb3104107ba$var$We(i);
    }
}
function $46c24eb3104107ba$var$xt(e) {
    if ($46c24eb3104107ba$var$S && ($46c24eb3104107ba$var$De($46c24eb3104107ba$var$S), $46c24eb3104107ba$var$S = null), e) return;
    const t = $46c24eb3104107ba$var$I;
    $46c24eb3104107ba$var$I = null, t.length && $46c24eb3104107ba$var$V(()=>$46c24eb3104107ba$var$Re(t), !1);
}
function $46c24eb3104107ba$var$De(e) {
    for(let t = 0; t < e.length; t++)$46c24eb3104107ba$var$ee(e[t]);
}
function $46c24eb3104107ba$var$Ct(e) {
    let t, n = 0;
    for(t = 0; t < e.length; t++){
        const i = e[t];
        i.user ? e[n++] = i : $46c24eb3104107ba$var$ee(i);
    }
    for(t = 0; t < n; t++)$46c24eb3104107ba$var$ee(e[t]);
}
function $46c24eb3104107ba$var$te(e, t) {
    e.state = 0;
    for(let n = 0; n < e.sources.length; n += 1){
        const i = e.sources[n];
        if (i.sources) {
            const r = i.state;
            r === $46c24eb3104107ba$var$M ? i !== t && (!i.updatedAt || i.updatedAt < $46c24eb3104107ba$var$ne) && $46c24eb3104107ba$var$ee(i) : r === $46c24eb3104107ba$var$Q && $46c24eb3104107ba$var$te(i, t);
        }
    }
}
function $46c24eb3104107ba$var$Ue(e) {
    for(let t = 0; t < e.observers.length; t += 1){
        const n = e.observers[t];
        n.state || (n.state = $46c24eb3104107ba$var$Q, n.pure ? $46c24eb3104107ba$var$S.push(n) : $46c24eb3104107ba$var$I.push(n), n.observers && $46c24eb3104107ba$var$Ue(n));
    }
}
function $46c24eb3104107ba$var$ie(e) {
    let t;
    if (e.sources) for(; e.sources.length;){
        const n = e.sources.pop(), i = e.sourceSlots.pop(), r = n.observers;
        if (r && r.length) {
            const s = r.pop(), l = n.observerSlots.pop();
            i < r.length && (s.sourceSlots[l] = i, r[i] = s, n.observerSlots[i] = l);
        }
    }
    if (e.owned) {
        for(t = e.owned.length - 1; t >= 0; t--)$46c24eb3104107ba$var$ie(e.owned[t]);
        e.owned = null;
    }
    if (e.cleanups) {
        for(t = e.cleanups.length - 1; t >= 0; t--)e.cleanups[t]();
        e.cleanups = null;
    }
    e.state = 0;
}
function $46c24eb3104107ba$var$Pt(e) {
    return e instanceof Error ? e : new Error(typeof e == "string" ? e : "Unknown error", {
        cause: e
    });
}
function $46c24eb3104107ba$var$We(e, t = $46c24eb3104107ba$var$w) {
    throw $46c24eb3104107ba$var$Pt(e);
}
function $46c24eb3104107ba$var$be(e) {
    if (typeof e == "function" && !e.length) return $46c24eb3104107ba$var$be(e());
    if (Array.isArray(e)) {
        const t = [];
        for(let n = 0; n < e.length; n++){
            const i = $46c24eb3104107ba$var$be(e[n]);
            Array.isArray(i) ? t.push.apply(t, i) : t.push(i);
        }
        return t;
    }
    return e;
}
const $46c24eb3104107ba$var$St = Symbol("fallback");
function $46c24eb3104107ba$var$Ae(e) {
    for(let t = 0; t < e.length; t++)e[t]();
}
function $46c24eb3104107ba$var$_t(e, t, n = {}) {
    let i = [], r = [], s = [], l = 0, o = t.length > 1 ? [] : null;
    return $46c24eb3104107ba$var$Me(()=>$46c24eb3104107ba$var$Ae(s)), ()=>{
        let c = e() || [], f, a;
        return c[$46c24eb3104107ba$var$yt], $46c24eb3104107ba$var$T(()=>{
            let d = c.length, h, v, y, z, $, P, _, E, R;
            if (d === 0) l !== 0 && ($46c24eb3104107ba$var$Ae(s), s = [], i = [], r = [], l = 0, o && (o = [])), n.fallback && (i = [
                $46c24eb3104107ba$var$St
            ], r[0] = $46c24eb3104107ba$var$Z((se)=>(s[0] = se, n.fallback())), l = 1);
            else if (l === 0) {
                for(r = new Array(d), a = 0; a < d; a++)i[a] = c[a], r[a] = $46c24eb3104107ba$var$Z(u);
                l = d;
            } else {
                for(y = new Array(d), z = new Array(d), o && ($ = new Array(d)), P = 0, _ = Math.min(l, d); P < _ && i[P] === c[P]; P++);
                for(_ = l - 1, E = d - 1; _ >= P && E >= P && i[_] === c[E]; _--, E--)y[E] = r[_], z[E] = s[_], o && ($[E] = o[_]);
                for(h = /* @__PURE__ */ new Map(), v = new Array(E + 1), a = E; a >= P; a--)R = c[a], f = h.get(R), v[a] = f === void 0 ? -1 : f, h.set(R, a);
                for(f = P; f <= _; f++)R = i[f], a = h.get(R), a !== void 0 && a !== -1 ? (y[a] = r[f], z[a] = s[f], o && ($[a] = o[f]), a = v[a], h.set(R, a)) : s[f]();
                for(a = P; a < d; a++)a in y ? (r[a] = y[a], s[a] = z[a], o && (o[a] = $[a], o[a](a))) : r[a] = $46c24eb3104107ba$var$Z(u);
                r = r.slice(0, l = d), i = c.slice(0);
            }
            return r;
        });
        function u(d) {
            if (s[a] = d, o) {
                const [h, v] = $46c24eb3104107ba$var$j(a);
                return o[a] = v, t(c[a], h);
            }
            return t(c[a]);
        }
    };
}
function $46c24eb3104107ba$var$g(e, t) {
    return $46c24eb3104107ba$var$T(()=>e(t || {}));
}
function $46c24eb3104107ba$var$Y() {
    return !0;
}
const $46c24eb3104107ba$var$Et = {
    get (e, t, n) {
        return t === $46c24eb3104107ba$var$me ? n : e.get(t);
    },
    has (e, t) {
        return t === $46c24eb3104107ba$var$me ? !0 : e.has(t);
    },
    set: $46c24eb3104107ba$var$Y,
    deleteProperty: $46c24eb3104107ba$var$Y,
    getOwnPropertyDescriptor (e, t) {
        return {
            configurable: !0,
            enumerable: !0,
            get () {
                return e.get(t);
            },
            set: $46c24eb3104107ba$var$Y,
            deleteProperty: $46c24eb3104107ba$var$Y
        };
    },
    ownKeys (e) {
        return e.keys();
    }
};
function $46c24eb3104107ba$var$fe(e) {
    return (e = typeof e == "function" ? e() : e) ? e : {};
}
function $46c24eb3104107ba$var$kt() {
    for(let e = 0, t = this.length; e < t; ++e){
        const n = this[e]();
        if (n !== void 0) return n;
    }
}
function $46c24eb3104107ba$var$$t(...e) {
    let t = !1;
    for(let l = 0; l < e.length; l++){
        const o = e[l];
        t = t || !!o && $46c24eb3104107ba$var$me in o, e[l] = typeof o == "function" ? (t = !0, $46c24eb3104107ba$var$F(o)) : o;
    }
    if (t) return new Proxy({
        get (l) {
            for(let o = e.length - 1; o >= 0; o--){
                const c = $46c24eb3104107ba$var$fe(e[o])[l];
                if (c !== void 0) return c;
            }
        },
        has (l) {
            for(let o = e.length - 1; o >= 0; o--)if (l in $46c24eb3104107ba$var$fe(e[o])) return !0;
            return !1;
        },
        keys () {
            const l = [];
            for(let o = 0; o < e.length; o++)l.push(...Object.keys($46c24eb3104107ba$var$fe(e[o])));
            return [
                ...new Set(l)
            ];
        }
    }, $46c24eb3104107ba$var$Et);
    const n = {}, i = /* @__PURE__ */ Object.create(null);
    for(let l = e.length - 1; l >= 0; l--){
        const o = e[l];
        if (!o) continue;
        const c = Object.getOwnPropertyNames(o);
        for(let f = c.length - 1; f >= 0; f--){
            const a = c[f];
            if (a === "__proto__" || a === "constructor") continue;
            const u = Object.getOwnPropertyDescriptor(o, a);
            if (!i[a]) i[a] = u.get ? {
                enumerable: !0,
                configurable: !0,
                get: $46c24eb3104107ba$var$kt.bind(n[a] = [
                    u.get.bind(o)
                ])
            } : u.value !== void 0 ? u : void 0;
            else {
                const d = n[a];
                d && (u.get ? d.push(u.get.bind(o)) : u.value !== void 0 && d.push(()=>u.value));
            }
        }
    }
    const r = {}, s = Object.keys(i);
    for(let l = s.length - 1; l >= 0; l--){
        const o = s[l], c = i[o];
        c && c.get ? Object.defineProperty(r, o, c) : r[o] = c ? c.value : void 0;
    }
    return r;
}
const $46c24eb3104107ba$var$Ve = (e)=>`Stale read from <${e}>.`;
function $46c24eb3104107ba$var$At(e) {
    const t = "fallback" in e && {
        fallback: ()=>e.fallback
    };
    return $46c24eb3104107ba$var$F($46c24eb3104107ba$var$_t(()=>e.each, e.children, t || void 0));
}
function $46c24eb3104107ba$var$he(e) {
    const t = e.keyed, n = $46c24eb3104107ba$var$F(()=>e.when, void 0, {
        equals: (i, r)=>t ? i === r : !i == !r
    });
    return $46c24eb3104107ba$var$F(()=>{
        const i = n();
        if (i) {
            const r = e.children;
            return typeof r == "function" && r.length > 0 ? $46c24eb3104107ba$var$T(()=>r(t ? i : ()=>{
                    if (!$46c24eb3104107ba$var$T(n)) throw $46c24eb3104107ba$var$Ve("Show");
                    return e.when;
                })) : r;
        }
        return e.fallback;
    }, void 0, void 0);
}
function $46c24eb3104107ba$var$Lt(e) {
    let t = !1;
    const n = (s, l)=>(t ? s[1] === l[1] : !s[1] == !l[1]) && s[2] === l[2], i = $46c24eb3104107ba$var$wt(()=>e.children), r = $46c24eb3104107ba$var$F(()=>{
        let s = i();
        Array.isArray(s) || (s = [
            s
        ]);
        for(let l = 0; l < s.length; l++){
            const o = s[l].when;
            if (o) return t = !!s[l].keyed, [
                l,
                o,
                s[l]
            ];
        }
        return [
            -1
        ];
    }, void 0, {
        equals: n
    });
    return $46c24eb3104107ba$var$F(()=>{
        const [s, l, o] = r();
        if (s < 0) return e.fallback;
        const c = o.children;
        return typeof c == "function" && c.length > 0 ? $46c24eb3104107ba$var$T(()=>c(t ? l : ()=>{
                if ($46c24eb3104107ba$var$T(r)[0] !== s) throw $46c24eb3104107ba$var$Ve("Match");
                return o.when;
            })) : c;
    }, void 0, void 0);
}
function $46c24eb3104107ba$var$pe(e) {
    return e;
}
const $46c24eb3104107ba$var$Ot = [
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "disabled",
    "formnovalidate",
    "hidden",
    "indeterminate",
    "inert",
    "ismap",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "seamless",
    "selected"
], $46c24eb3104107ba$var$jt = /* @__PURE__ */ new Set([
    "className",
    "value",
    "readOnly",
    "formNoValidate",
    "isMap",
    "noModule",
    "playsInline",
    ...$46c24eb3104107ba$var$Ot
]), $46c24eb3104107ba$var$Tt = /* @__PURE__ */ new Set([
    "innerHTML",
    "textContent",
    "innerText",
    "children"
]), $46c24eb3104107ba$var$Nt = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
    className: "class",
    htmlFor: "for"
}), $46c24eb3104107ba$var$zt = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
    class: "className",
    formnovalidate: {
        $: "formNoValidate",
        BUTTON: 1,
        INPUT: 1
    },
    ismap: {
        $: "isMap",
        IMG: 1
    },
    nomodule: {
        $: "noModule",
        SCRIPT: 1
    },
    playsinline: {
        $: "playsInline",
        VIDEO: 1
    },
    readonly: {
        $: "readOnly",
        INPUT: 1,
        TEXTAREA: 1
    }
});
function $46c24eb3104107ba$var$Rt(e, t) {
    const n = $46c24eb3104107ba$var$zt[e];
    return typeof n == "object" ? n[t] ? n.$ : void 0 : n;
}
const $46c24eb3104107ba$var$It = /* @__PURE__ */ new Set([
    "beforeinput",
    "click",
    "dblclick",
    "contextmenu",
    "focusin",
    "focusout",
    "input",
    "keydown",
    "keyup",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "pointerdown",
    "pointermove",
    "pointerout",
    "pointerover",
    "pointerup",
    "touchend",
    "touchmove",
    "touchstart"
]), $46c24eb3104107ba$var$Ft = {
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace"
};
function $46c24eb3104107ba$var$Mt(e, t, n) {
    let i = n.length, r = t.length, s = i, l = 0, o = 0, c = t[r - 1].nextSibling, f = null;
    for(; l < r || o < s;){
        if (t[l] === n[o]) {
            l++, o++;
            continue;
        }
        for(; t[r - 1] === n[s - 1];)r--, s--;
        if (r === l) {
            const a = s < i ? o ? n[o - 1].nextSibling : n[s - o] : c;
            for(; o < s;)e.insertBefore(n[o++], a);
        } else if (s === o) for(; l < r;)(!f || !f.has(t[l])) && t[l].remove(), l++;
        else if (t[l] === n[s - 1] && n[o] === t[r - 1]) {
            const a = t[--r].nextSibling;
            e.insertBefore(n[o++], t[l++].nextSibling), e.insertBefore(n[--s], a), t[r] = n[s];
        } else {
            if (!f) {
                f = /* @__PURE__ */ new Map();
                let u = o;
                for(; u < s;)f.set(n[u], u++);
            }
            const a = f.get(t[l]);
            if (a != null) {
                if (o < a && a < s) {
                    let u = l, d = 1, h;
                    for(; ++u < r && u < s && !((h = f.get(t[u])) == null || h !== a + d);)d++;
                    if (d > a - o) {
                        const v = t[l];
                        for(; o < a;)e.insertBefore(n[o++], v);
                    } else e.replaceChild(n[o++], t[l++]);
                } else l++;
            } else t[l++].remove();
        }
    }
}
const $46c24eb3104107ba$var$Le = "_$DX_DELEGATE";
function $46c24eb3104107ba$var$C(e, t, n) {
    let i;
    const r = ()=>{
        const l = document.createElement("template");
        return l.innerHTML = e, n ? l.content.firstChild.firstChild : l.content.firstChild;
    }, s = t ? ()=>$46c24eb3104107ba$var$T(()=>document.importNode(i || (i = r()), !0)) : ()=>(i || (i = r())).cloneNode(!0);
    return s.cloneNode = s, s;
}
function $46c24eb3104107ba$var$Kt(e, t = window.document) {
    const n = t[$46c24eb3104107ba$var$Le] || (t[$46c24eb3104107ba$var$Le] = /* @__PURE__ */ new Set());
    for(let i = 0, r = e.length; i < r; i++){
        const s = e[i];
        n.has(s) || (n.add(s), t.addEventListener(s, $46c24eb3104107ba$var$Ht));
    }
}
function $46c24eb3104107ba$var$N(e, t, n) {
    n == null ? e.removeAttribute(t) : e.setAttribute(t, n);
}
function $46c24eb3104107ba$var$Bt(e, t, n, i) {
    i == null ? e.removeAttributeNS(t, n) : e.setAttributeNS(t, n, i);
}
function $46c24eb3104107ba$var$Dt(e, t) {
    t == null ? e.removeAttribute("class") : e.className = t;
}
function $46c24eb3104107ba$var$Ut(e, t, n, i) {
    if (i) Array.isArray(n) ? (e[`$$${t}`] = n[0], e[`$$${t}Data`] = n[1]) : e[`$$${t}`] = n;
    else if (Array.isArray(n)) {
        const r = n[0];
        e.addEventListener(t, n[0] = (s)=>r.call(e, n[1], s));
    } else e.addEventListener(t, n);
}
function $46c24eb3104107ba$var$Wt(e, t, n = {}) {
    const i = Object.keys(t || {}), r = Object.keys(n);
    let s, l;
    for(s = 0, l = r.length; s < l; s++){
        const o = r[s];
        !o || o === "undefined" || t[o] || ($46c24eb3104107ba$var$Oe(e, o, !1), delete n[o]);
    }
    for(s = 0, l = i.length; s < l; s++){
        const o = i[s], c = !!t[o];
        !o || o === "undefined" || n[o] === c || !c || ($46c24eb3104107ba$var$Oe(e, o, !0), n[o] = c);
    }
    return n;
}
function $46c24eb3104107ba$var$L(e, t, n) {
    if (!t) return n ? $46c24eb3104107ba$var$N(e, "style") : t;
    const i = e.style;
    if (typeof t == "string") return i.cssText = t;
    typeof n == "string" && (i.cssText = n = void 0), n || (n = {}), t || (t = {});
    let r, s;
    for(s in n)t[s] == null && i.removeProperty(s), delete n[s];
    for(s in t)r = t[s], r !== n[s] && (i.setProperty(s, r), n[s] = r);
    return n;
}
function $46c24eb3104107ba$var$Vt(e, t = {}, n, i) {
    const r = {};
    return i || $46c24eb3104107ba$var$A(()=>r.children = $46c24eb3104107ba$var$U(e, t.children, r.children)), $46c24eb3104107ba$var$A(()=>t.ref && t.ref(e)), $46c24eb3104107ba$var$A(()=>$46c24eb3104107ba$var$Xt(e, t, n, !0, r, !0)), r;
}
function $46c24eb3104107ba$var$ye(e, t, n) {
    return $46c24eb3104107ba$var$T(()=>e(t, n));
}
function $46c24eb3104107ba$var$b(e, t, n, i) {
    if (n !== void 0 && !i && (i = []), typeof t != "function") return $46c24eb3104107ba$var$U(e, t, i, n);
    $46c24eb3104107ba$var$A((r)=>$46c24eb3104107ba$var$U(e, t(), r, n), i);
}
function $46c24eb3104107ba$var$Xt(e, t, n, i, r = {}, s = !1) {
    t || (t = {});
    for(const l in r)if (!(l in t)) {
        if (l === "children") continue;
        r[l] = $46c24eb3104107ba$var$je(e, l, null, r[l], n, s);
    }
    for(const l in t){
        if (l === "children") {
            i || $46c24eb3104107ba$var$U(e, t.children);
            continue;
        }
        const o = t[l];
        r[l] = $46c24eb3104107ba$var$je(e, l, o, r[l], n, s);
    }
}
function $46c24eb3104107ba$var$qt(e) {
    return e.toLowerCase().replace(/-([a-z])/g, (t, n)=>n.toUpperCase());
}
function $46c24eb3104107ba$var$Oe(e, t, n) {
    const i = t.trim().split(/\s+/);
    for(let r = 0, s = i.length; r < s; r++)e.classList.toggle(i[r], n);
}
function $46c24eb3104107ba$var$je(e, t, n, i, r, s) {
    let l, o, c, f, a;
    if (t === "style") return $46c24eb3104107ba$var$L(e, n, i);
    if (t === "classList") return $46c24eb3104107ba$var$Wt(e, n, i);
    if (n === i) return i;
    if (t === "ref") s || n(e);
    else if (t.slice(0, 3) === "on:") {
        const u = t.slice(3);
        i && e.removeEventListener(u, i), n && e.addEventListener(u, n);
    } else if (t.slice(0, 10) === "oncapture:") {
        const u = t.slice(10);
        i && e.removeEventListener(u, i, !0), n && e.addEventListener(u, n, !0);
    } else if (t.slice(0, 2) === "on") {
        const u = t.slice(2).toLowerCase(), d = $46c24eb3104107ba$var$It.has(u);
        if (!d && i) {
            const h = Array.isArray(i) ? i[0] : i;
            e.removeEventListener(u, h);
        }
        (d || n) && ($46c24eb3104107ba$var$Ut(e, u, n, d), d && $46c24eb3104107ba$var$Kt([
            u
        ]));
    } else if (t.slice(0, 5) === "attr:") $46c24eb3104107ba$var$N(e, t.slice(5), n);
    else if ((a = t.slice(0, 5) === "prop:") || (c = $46c24eb3104107ba$var$Tt.has(t)) || !r && ((f = $46c24eb3104107ba$var$Rt(t, e.tagName)) || (o = $46c24eb3104107ba$var$jt.has(t))) || (l = e.nodeName.includes("-"))) a && (t = t.slice(5), o = !0), t === "class" || t === "className" ? $46c24eb3104107ba$var$Dt(e, n) : l && !o && !c ? e[$46c24eb3104107ba$var$qt(t)] = n : e[f || t] = n;
    else {
        const u = r && t.indexOf(":") > -1 && $46c24eb3104107ba$var$Ft[t.split(":")[0]];
        u ? $46c24eb3104107ba$var$Bt(e, u, t, n) : $46c24eb3104107ba$var$N(e, $46c24eb3104107ba$var$Nt[t] || t, n);
    }
    return n;
}
function $46c24eb3104107ba$var$Ht(e) {
    const t = `$$${e.type}`;
    let n = e.composedPath && e.composedPath()[0] || e.target;
    for(e.target !== n && Object.defineProperty(e, "target", {
        configurable: !0,
        value: n
    }), Object.defineProperty(e, "currentTarget", {
        configurable: !0,
        get () {
            return n || document;
        }
    }); n;){
        const i = n[t];
        if (i && !n.disabled) {
            const r = n[`${t}Data`];
            if (r !== void 0 ? i.call(n, r, e) : i.call(n, e), e.cancelBubble) return;
        }
        n = n._$host || n.parentNode || n.host;
    }
}
function $46c24eb3104107ba$var$U(e, t, n, i, r) {
    for(; typeof n == "function";)n = n();
    if (t === n) return n;
    const s = typeof t, l = i !== void 0;
    if (e = l && n[0] && n[0].parentNode || e, s === "string" || s === "number") {
        if (s === "number" && (t = t.toString()), l) {
            let o = n[0];
            o && o.nodeType === 3 ? o.data !== t && (o.data = t) : o = document.createTextNode(t), n = $46c24eb3104107ba$var$D(e, n, i, o);
        } else n !== "" && typeof n == "string" ? n = e.firstChild.data = t : n = e.textContent = t;
    } else if (t == null || s === "boolean") n = $46c24eb3104107ba$var$D(e, n, i);
    else {
        if (s === "function") return $46c24eb3104107ba$var$A(()=>{
            let o = t();
            for(; typeof o == "function";)o = o();
            n = $46c24eb3104107ba$var$U(e, o, n, i);
        }), ()=>n;
        if (Array.isArray(t)) {
            const o = [], c = n && Array.isArray(n);
            if ($46c24eb3104107ba$var$we(o, t, n, r)) return $46c24eb3104107ba$var$A(()=>n = $46c24eb3104107ba$var$U(e, o, n, i, !0)), ()=>n;
            if (o.length === 0) {
                if (n = $46c24eb3104107ba$var$D(e, n, i), l) return n;
            } else c ? n.length === 0 ? $46c24eb3104107ba$var$Te(e, o, i) : $46c24eb3104107ba$var$Mt(e, n, o) : (n && $46c24eb3104107ba$var$D(e), $46c24eb3104107ba$var$Te(e, o));
            n = o;
        } else if (t.nodeType) {
            if (Array.isArray(n)) {
                if (l) return n = $46c24eb3104107ba$var$D(e, n, i, t);
                $46c24eb3104107ba$var$D(e, n, null, t);
            } else n == null || n === "" || !e.firstChild ? e.appendChild(t) : e.replaceChild(t, e.firstChild);
            n = t;
        }
    }
    return n;
}
function $46c24eb3104107ba$var$we(e, t, n, i) {
    let r = !1;
    for(let s = 0, l = t.length; s < l; s++){
        let o = t[s], c = n && n[e.length], f;
        if (!(o == null || o === !0 || o === !1)) {
            if ((f = typeof o) == "object" && o.nodeType) e.push(o);
            else if (Array.isArray(o)) r = $46c24eb3104107ba$var$we(e, o, c) || r;
            else if (f === "function") {
                if (i) {
                    for(; typeof o == "function";)o = o();
                    r = $46c24eb3104107ba$var$we(e, Array.isArray(o) ? o : [
                        o
                    ], Array.isArray(c) ? c : [
                        c
                    ]) || r;
                } else e.push(o), r = !0;
            } else {
                const a = String(o);
                c && c.nodeType === 3 && c.data === a ? e.push(c) : e.push(document.createTextNode(a));
            }
        }
    }
    return r;
}
function $46c24eb3104107ba$var$Te(e, t, n = null) {
    for(let i = 0, r = t.length; i < r; i++)e.insertBefore(t[i], n);
}
function $46c24eb3104107ba$var$D(e, t, n, i) {
    if (n === void 0) return e.textContent = "";
    const r = i || document.createTextNode("");
    if (t.length) {
        let s = !1;
        for(let l = t.length - 1; l >= 0; l--){
            const o = t[l];
            if (r !== o) {
                const c = o.parentNode === e;
                !s && !l ? c ? e.replaceChild(r, o) : e.insertBefore(r, n) : c && o.remove();
            } else s = !0;
        }
    } else e.insertBefore(r, n);
    return [
        r
    ];
}
function $46c24eb3104107ba$var$Yt(e) {
    const t = Object.keys(e), n = {};
    for(let i = 0; i < t.length; i++){
        const [r, s] = $46c24eb3104107ba$var$j(e[t[i]]);
        Object.defineProperty(n, t[i], {
            get: r,
            set (l) {
                s(()=>l);
            }
        });
    }
    return n;
}
function $46c24eb3104107ba$var$Gt(e) {
    if (e.assignedSlot && e.assignedSlot._$owner) return e.assignedSlot._$owner;
    let t = e.parentNode;
    for(; t && !t._$owner && !(t.assignedSlot && t.assignedSlot._$owner);)t = t.parentNode;
    return t && t.assignedSlot ? t.assignedSlot._$owner : e._$owner;
}
function $46c24eb3104107ba$var$Zt(e) {
    return (t, n)=>{
        const { element: i } = n;
        return $46c24eb3104107ba$var$Z((r)=>{
            const s = $46c24eb3104107ba$var$Yt(t);
            i.addPropertyChangedCallback((o, c)=>s[o] = c), i.addReleaseCallback(()=>{
                i.renderRoot.textContent = "", r();
            });
            const l = e(s, n);
            return $46c24eb3104107ba$var$b(i.renderRoot, l);
        }, $46c24eb3104107ba$var$Gt(i));
    };
}
function $46c24eb3104107ba$var$Jt(e, t, n) {
    return arguments.length === 2 && (n = t, t = {}), $46c24eb3104107ba$var$ht(e, t)($46c24eb3104107ba$var$Zt(n));
}
const $46c24eb3104107ba$var$ve = "sats-connect_wallet-provider-selector_select", $46c24eb3104107ba$var$xe = "sats-connect_wallet-provider-selector_cancel", $46c24eb3104107ba$var$Ce = "sats-connect_wallet-provider-selector_open", $46c24eb3104107ba$var$Pe = "sats-connect_wallet-provider-selector_close", $46c24eb3104107ba$var$Xe = "sats-connect_wallet-provider-selector_walletOpen", $46c24eb3104107ba$var$qe = "sats-connect_wallet-provider-selector_walletClose", $46c24eb3104107ba$var$re = {
    color: "#181818",
    "font-size": "18px",
    "font-weight": "700",
    "line-height": "1.4"
}, $46c24eb3104107ba$var$W = {
    color: "#181818",
    "font-size": "14px",
    "font-weight": "400",
    "line-height": "1.4"
}, $46c24eb3104107ba$var$Qt = {
    color: "#181818",
    "font-size": "14px",
    "font-weight": "500"
};
var $46c24eb3104107ba$var$en = /* @__PURE__ */ $46c24eb3104107ba$var$C('<svg width=24 height=24 viewBox="0 0 24 24"fill=none xmlns=http://www.w3.org/2000/svg><g id=XCircle><path id=Vector d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.745 9.41566 20.7162 6.93859 18.8888 5.11118C17.0614 3.28378 14.5843 2.25496 12 2.25ZM15.5344 14.4656C15.6752 14.6078 15.7542 14.7999 15.7542 15C15.7542 15.2001 15.6752 15.3922 15.5344 15.5344C15.391 15.673 15.1994 15.7505 15 15.7505C14.8006 15.7505 14.609 15.673 14.4656 15.5344L12 13.0594L9.53438 15.5344C9.39102 15.673 9.19942 15.7505 9 15.7505C8.80059 15.7505 8.60898 15.673 8.46563 15.5344C8.32479 15.3922 8.24578 15.2001 8.24578 15C8.24578 14.7999 8.32479 14.6078 8.46563 14.4656L10.9406 12L8.46563 9.53437C8.34603 9.38865 8.28491 9.20366 8.29416 9.01537C8.30341 8.82708 8.38236 8.64896 8.51566 8.51566C8.64896 8.38236 8.82708 8.3034 9.01537 8.29416C9.20366 8.28491 9.38866 8.34603 9.53438 8.46563L12 10.9406L14.4656 8.46563C14.6114 8.34603 14.7963 8.28491 14.9846 8.29416C15.1729 8.3034 15.351 8.38236 15.4843 8.51566C15.6176 8.64896 15.6966 8.82708 15.7058 9.01537C15.7151 9.20366 15.654 9.38865 15.5344 9.53437L13.0594 12L15.5344 14.4656Z"fill=black fill-opacity=0.3>'), $46c24eb3104107ba$var$tn = /* @__PURE__ */ $46c24eb3104107ba$var$C(`<style>
          .close-selector-button:focus-visible {
            outline: 2px solid #181818;
            outline-offset: -0.25px;
          }
        `), $46c24eb3104107ba$var$nn = /* @__PURE__ */ $46c24eb3104107ba$var$C("<div role=button tabindex=0 class=close-selector-button>");
function $46c24eb3104107ba$var$rn(e) {
    return (()=>{
        var t = $46c24eb3104107ba$var$en();
        return t.style.setProperty("display", "block"), $46c24eb3104107ba$var$Vt(t, e, !0, !0), t;
    })();
}
function $46c24eb3104107ba$var$sn(e) {
    function t(n) {
        (n.key === "Enter" || n.key === " ") && e.onClose();
    }
    return [
        $46c24eb3104107ba$var$tn(),
        (()=>{
            var n = $46c24eb3104107ba$var$nn();
            return n.style.setProperty("position", "absolute"), n.style.setProperty("top", "16px"), n.style.setProperty("right", "16px"), n.style.setProperty("background", "none"), n.style.setProperty("border", "none"), n.style.setProperty("cursor", "pointer"), n.style.setProperty("padding", "0"), n.style.setProperty("margin", "0"), n.style.setProperty("border-radius", "50%"), n.addEventListener("click", e.onClose), n.addEventListener("keydown", t), $46c24eb3104107ba$var$b(n, $46c24eb3104107ba$var$g($46c24eb3104107ba$var$rn, {})), n;
        })()
    ];
}
var $46c24eb3104107ba$var$on = /* @__PURE__ */ $46c24eb3104107ba$var$C(`<style>
/*! modern-normalize v2.0.0 | MIT License | https://github.com/sindresorhus/modern-normalize */

/*
Document
========
*/

/**
Use a better box model (opinionated).
*/

*,
::before,
::after {
	box-sizing: border-box;
	margin: 0; /* Remove all margins from everywhere. */
}

:host {
	/* Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3) */
	font-family:
		'DM Sans', /* Note: not part of modern-normalize, added specifically for this project. */
		system-ui,
		'Segoe UI',
		Roboto,
		Helvetica,
		Arial,
		sans-serif,
		'Apple Color Emoji',
		'Segoe UI Emoji';
	line-height: 1.15; /* 1. Correct the line height in all browsers. */
	-webkit-text-size-adjust: 100%; /* 2. Prevent adjustments of font size after orientation changes in iOS. */
	-moz-tab-size: 4; /* 3. Use a more readable tab size (opinionated). */
	tab-size: 4; /* 3 */
}

/*
Sections
========
*/

:host {
	margin: 0; /* Remove the margin in all browsers. */
}

/*
Grouping content
================
*/

/**
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
*/

hr {
	height: 0; /* 1 */
	color: inherit; /* 2 */
}

/*
Text-level semantics
====================
*/

/**
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr[title] {
	text-decoration: underline dotted;
}

/**
Add the correct font weight in Edge and Safari.
*/

b,
strong {
	font-weight: bolder;
}

/**
1. Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)
2. Correct the odd 'em' font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
	font-family:
		ui-monospace,
		SFMono-Regular,
		Consolas,
		'Liberation Mono',
		Menlo,
		monospace; /* 1 */
	font-size: 1em; /* 2 */
}

/**
Add the correct font size in all browsers.
*/

small {
	font-size: 80%;
}

/**
Prevent 'sub' and 'sup' elements from affecting the line height in all browsers.
*/

sub,
sup {
	font-size: 75%;
	line-height: 0;
	position: relative;
	vertical-align: baseline;
}

sub {
	bottom: -0.25em;
}

sup {
	top: -0.5em;
}

/*
Tabular data
============
*/

/**
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
*/

table {
	text-indent: 0; /* 1 */
	border-color: inherit; /* 2 */
}

/*
Forms
=====
*/

/**
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
*/

button,
input,
optgroup,
select,
textarea {
	font-family: inherit; /* 1 */
	font-size: 100%; /* 1 */
	line-height: 1.15; /* 1 */
	margin: 0; /* 2 */
}

/**
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
	text-transform: none;
}

/**
Correct the inability to style clickable types in iOS and Safari.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
	-webkit-appearance: button;
}

/**
Remove the inner border and padding in Firefox.
*/

::-moz-focus-inner {
	border-style: none;
	padding: 0;
}

/**
Restore the focus styles unset by the previous rule.
*/

:-moz-focusring {
	outline: 1px dotted ButtonText;
}

/**
Remove the additional ':invalid' styles in Firefox.
See: https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737
*/

:-moz-ui-invalid {
	box-shadow: none;
}

/**
Remove the padding so developers are not caught out when they zero out 'fieldset' elements in all browsers.
*/

legend {
	padding: 0;
}

/**
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
	vertical-align: baseline;
}

/**
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
	height: auto;
}

/**
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
	-webkit-appearance: textfield; /* 1 */
	outline-offset: -2px; /* 2 */
}

/**
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
	-webkit-appearance: none;
}

/**
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to 'inherit' in Safari.
*/

::-webkit-file-upload-button {
	-webkit-appearance: button; /* 1 */
	font: inherit; /* 2 */
}

/*
Interactive
===========
*/

/*
Add the correct display in Chrome and Safari.
*/

summary {
	display: list-item;
}
`);
function $46c24eb3104107ba$var$ln() {
    return $46c24eb3104107ba$var$on();
}
var $46c24eb3104107ba$var$an = /* @__PURE__ */ $46c24eb3104107ba$var$C("<div class=divider><div>");
function $46c24eb3104107ba$var$cn() {
    return (()=>{
        var e = $46c24eb3104107ba$var$an(), t = e.firstChild;
        return t.style.setProperty("height", "100%"), t.style.setProperty("width", "1px"), t.style.setProperty("background", "#dcdcdc"), e;
    })();
}
var $46c24eb3104107ba$var$un = /* @__PURE__ */ $46c24eb3104107ba$var$C("<div>");
function $46c24eb3104107ba$var$dn(e) {
    return (()=>{
        var t = $46c24eb3104107ba$var$un();
        return t.style.setProperty("padding", "24px"), t.style.setProperty("height", "100%"), $46c24eb3104107ba$var$b(t, ()=>e.children), t;
    })();
}
var $46c24eb3104107ba$var$fn = /* @__PURE__ */ $46c24eb3104107ba$var$C("<div>");
function $46c24eb3104107ba$var$hn(e) {
    return (()=>{
        var t = $46c24eb3104107ba$var$fn();
        return t.style.setProperty("display", "flex"), t.style.setProperty("flex-direction", "column"), t.style.setProperty("justify-content", "center"), t.style.setProperty("align-items", "center"), t.style.setProperty("height", "100%"), $46c24eb3104107ba$var$b(t, ()=>e.children), t;
    })();
}
var $46c24eb3104107ba$var$pn = /* @__PURE__ */ $46c24eb3104107ba$var$C("<div><div>\uD83E\uDD14</div><div>What is a wallet?</div><p>Wallets let you send, receive, store and display digital assets like Bitcoin, Stacks, Ordinals & NFTs.</p><p>Explore Bitcoin apps by connecting your wallet.");
function $46c24eb3104107ba$var$yn() {
    return (()=>{
        var e = $46c24eb3104107ba$var$pn(), t = e.firstChild, n = t.nextSibling, i = n.nextSibling, r = i.nextSibling;
        return e.style.setProperty("display", "flex"), e.style.setProperty("flex-direction", "column"), e.style.setProperty("row-gap", "8px"), e.style.setProperty("justify-content", "center"), e.style.setProperty("align-items", "center"), t.style.setProperty("font-size", "50px"), t.style.setProperty("line-height", "140%"), $46c24eb3104107ba$var$A((s)=>{
            var l = $46c24eb3104107ba$var$re, o = $46c24eb3104107ba$var$W, c = $46c24eb3104107ba$var$W;
            return s.e = $46c24eb3104107ba$var$L(n, l, s.e), s.t = $46c24eb3104107ba$var$L(i, o, s.t), s.a = $46c24eb3104107ba$var$L(r, c, s.a), s;
        }, {
            e: void 0,
            t: void 0,
            a: void 0
        }), e;
    })();
}
function $46c24eb3104107ba$var$Se(e) {
    var n;
    const t = (n = e.installPrompt) == null ? void 0 : n.url;
    if (!t) {
        console.error("No install prompt URL found for", e.id);
        return;
    }
    window.open(t, "_blank");
}
var $46c24eb3104107ba$var$gn = /* @__PURE__ */ $46c24eb3104107ba$var$C(`<style>
          .install-prompt-button:focus-visible {
            outline: 2px solid #181818;
            outline-offset: 2px;
          }
        `), $46c24eb3104107ba$var$mn = /* @__PURE__ */ $46c24eb3104107ba$var$C("<div><img><h1>Don't have <!>?</h1><p>Download it on the Chrome web store.</p><div class=install-prompt-button role=button tabindex=0>Get");
function $46c24eb3104107ba$var$bn(e) {
    function t(i) {
        (i.key === "Enter" || i.key === " ") && $46c24eb3104107ba$var$Se(e.option);
    }
    function n() {
        $46c24eb3104107ba$var$Se(e.option);
    }
    return [
        $46c24eb3104107ba$var$gn(),
        (()=>{
            var i = $46c24eb3104107ba$var$mn(), r = i.firstChild, s = r.nextSibling, l = s.firstChild, o = l.nextSibling;
            o.nextSibling;
            var c = s.nextSibling, f = c.nextSibling;
            return i.style.setProperty("display", "flex"), i.style.setProperty("flex-direction", "column"), i.style.setProperty("align-items", "center"), i.style.setProperty("row-gap", "16px"), r.style.setProperty("border-radius", "12px"), r.style.setProperty("height", "64px"), r.style.setProperty("width", "64px"), r.style.setProperty("object-fit", "cover"), $46c24eb3104107ba$var$b(s, ()=>e.option.name, o), f.addEventListener("click", n), f.addEventListener("keydown", t), $46c24eb3104107ba$var$A((a)=>{
                var u = e.option.icon, d = e.option.name, h = {
                    ...$46c24eb3104107ba$var$re,
                    "text-align": "center"
                }, v = $46c24eb3104107ba$var$W, y = {
                    ...$46c24eb3104107ba$var$Qt,
                    cursor: "pointer",
                    "border-radius": "12px",
                    background: "#181818",
                    color: "white",
                    padding: "12px 16px"
                };
                return u !== a.e && $46c24eb3104107ba$var$N(r, "src", a.e = u), d !== a.t && $46c24eb3104107ba$var$N(r, "alt", a.t = d), a.a = $46c24eb3104107ba$var$L(s, h, a.a), a.o = $46c24eb3104107ba$var$L(c, v, a.o), a.i = $46c24eb3104107ba$var$L(f, y, a.i), a;
            }, {
                e: void 0,
                t: void 0,
                a: void 0,
                o: void 0,
                i: void 0
            }), i;
        })()
    ];
}
var $46c24eb3104107ba$var$wn = /* @__PURE__ */ $46c24eb3104107ba$var$C('<svg width=20 height=20 viewBox="0 0 20 20"xmlns=http://www.w3.org/2000/svg><circle cx=10 cy=10 r=9.05 stroke=black stroke-width=1.9 fill=none stroke-dasharray="42.65 14.22"stroke-dashoffset=0><animateTransform attributeName=transform attributeType=XML type=rotate from="0 10 10"to="360 10 10"dur=0.75s repeatCount=indefinite>'), $46c24eb3104107ba$var$vn = /* @__PURE__ */ $46c24eb3104107ba$var$C("<div>");
const $46c24eb3104107ba$var$xn = ()=>$46c24eb3104107ba$var$wn();
function $46c24eb3104107ba$var$Cn() {
    return (()=>{
        var e = $46c24eb3104107ba$var$vn();
        return e.style.setProperty("display", "flex"), e.style.setProperty("justify-content", "center"), e.style.setProperty("align-items", "center"), e.style.setProperty("height", "100%"), e.style.setProperty("animation", "spin 1s linear infinite"), $46c24eb3104107ba$var$b(e, $46c24eb3104107ba$var$g($46c24eb3104107ba$var$xn, {})), e;
    })();
}
var $46c24eb3104107ba$var$Pn = /* @__PURE__ */ $46c24eb3104107ba$var$C("<div><img><h1>Opening <!>...</h1><p>Confirm the operation in ");
function $46c24eb3104107ba$var$Sn(e) {
    return (()=>{
        var t = $46c24eb3104107ba$var$Pn(), n = t.firstChild, i = n.nextSibling, r = i.firstChild, s = r.nextSibling;
        s.nextSibling;
        var l = i.nextSibling;
        return l.firstChild, t.style.setProperty("display", "flex"), t.style.setProperty("flex-direction", "column"), t.style.setProperty("align-items", "center"), t.style.setProperty("row-gap", "16px"), n.style.setProperty("border-radius", "12px"), n.style.setProperty("height", "64px"), n.style.setProperty("width", "64px"), n.style.setProperty("object-fit", "cover"), $46c24eb3104107ba$var$b(i, ()=>e.option.name, s), $46c24eb3104107ba$var$b(l, ()=>e.option.name, null), $46c24eb3104107ba$var$b(t, $46c24eb3104107ba$var$g($46c24eb3104107ba$var$Cn, {}), null), $46c24eb3104107ba$var$A((o)=>{
            var c = e.option.icon, f = e.option.name, a = {
                ...$46c24eb3104107ba$var$re,
                "text-align": "center"
            }, u = $46c24eb3104107ba$var$W;
            return c !== o.e && $46c24eb3104107ba$var$N(n, "src", o.e = c), f !== o.t && $46c24eb3104107ba$var$N(n, "alt", o.t = f), o.a = $46c24eb3104107ba$var$L(i, a, o.a), o.o = $46c24eb3104107ba$var$L(l, u, o.o), o;
        }, {
            e: void 0,
            t: void 0,
            a: void 0,
            o: void 0
        }), t;
    })();
}
var $46c24eb3104107ba$var$_n = /* @__PURE__ */ $46c24eb3104107ba$var$C("<div><div tabindex=0><img><div>");
function $46c24eb3104107ba$var$En(e) {
    function t() {
        e.onProviderSelected(e.id);
    }
    const n = $46c24eb3104107ba$var$F(()=>$46c24eb3104107ba$export$723d9c21be5da6c5(e) ? "button" : "link");
    function i(u) {
        if (n() === "link") {
            u.key === "Enter" && t();
            return;
        }
        if (n() === "button") {
            (u.key === "Enter" || u.key === " ") && t();
            return;
        }
    }
    const [r, s] = $46c24eb3104107ba$var$j(!1), [l, o] = $46c24eb3104107ba$var$j(!1), c = ()=>r() || l(), f = "rgba(24, 24, 24, 0.20)", a = "rgba(24, 24, 24, 0.60)";
    return (()=>{
        var u = $46c24eb3104107ba$var$_n(), d = u.firstChild, h = d.firstChild, v = h.nextSibling;
        return u.style.setProperty("aspect-ratio", "1 / 1"), u.style.setProperty("overflow", "hidden"), d.style.setProperty("display", "flex"), d.style.setProperty("flex-direction", "column"), d.style.setProperty("row-gap", "12px"), d.style.setProperty("align-items", "center"), d.style.setProperty("cursor", "pointer"), d.style.setProperty("outline", "none"), d.style.setProperty("padding-top", "10px"), d.addEventListener("click", t), d.addEventListener("keydown", i), d.addEventListener("mouseenter", ()=>s(!0)), d.addEventListener("mouseleave", ()=>s(!1)), d.addEventListener("focus", ()=>o(!0)), d.addEventListener("blur", ()=>o(!1)), h.style.setProperty("width", "56px"), h.style.setProperty("height", "56px"), h.style.setProperty("object-fit", "cover"), h.style.setProperty("border-radius", "12px"), $46c24eb3104107ba$var$b(v, ()=>e.name), $46c24eb3104107ba$var$A((y)=>{
            var z = n(), $ = c() ? `6px solid ${f}` : "none", P = e.icon, _ = e.name, E = {
                ...$46c24eb3104107ba$var$W,
                color: c() ? a : void 0,
                "text-align": "center"
            };
            return z !== y.e && $46c24eb3104107ba$var$N(d, "role", y.e = z), $ !== y.t && ((y.t = $) != null ? h.style.setProperty("outline", $) : h.style.removeProperty("outline")), P !== y.a && $46c24eb3104107ba$var$N(h, "src", y.a = P), _ !== y.o && $46c24eb3104107ba$var$N(h, "alt", y.o = _), y.i = $46c24eb3104107ba$var$L(v, E, y.i), y;
        }, {
            e: void 0,
            t: void 0,
            a: void 0,
            o: void 0,
            i: void 0
        }), u;
    })();
}
var $46c24eb3104107ba$var$kn = /* @__PURE__ */ $46c24eb3104107ba$var$C('<link href="https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&amp;display=swap"rel=stylesheet>'), $46c24eb3104107ba$var$$n = /* @__PURE__ */ $46c24eb3104107ba$var$C("<div class=side-panel>"), $46c24eb3104107ba$var$An = /* @__PURE__ */ $46c24eb3104107ba$var$C('<div><div></div><div><div class=card-width-container><div class=card-height-container><div class=card><div class=card-grid><div class=main-panel><div></div><div></div><div class=wallets-grid-container data-desc="wallet grid container for padding"><div class=wallets-grid data-desc="wallet grid container">'), $46c24eb3104107ba$var$Ln = /* @__PURE__ */ $46c24eb3104107ba$var$C(`<div><style>
        @keyframes wallet-selector-fade-in {
          from {opacity: 0; transform: translateY(40px);}
          to {opacity: 1; transform: translateY(0);}
        }

        @keyframes wallet-selector-fade-out {
          from {opacity: 1; transform: translateY(0);}
          to {opacity: 0; transform: translateY(40px);}
        }
        @keyframes wallet-selector-blur-in {
          from {opacity: 0; backdrop-filter: blur(0px);}
          to {opacity: 1; backdrop-filter: blur(10px);}
        }

        @keyframes wallet-selector-blur-out {
          from {opacity: 1; backdrop-filter: blur(10px);}
          to {opacity: 0; backdrop-filter: blur(0px);}
        }
      </style><style>`);
const $46c24eb3104107ba$var$G = "24px";
function $46c24eb3104107ba$var$On() {
    const [e, t] = $46c24eb3104107ba$var$j(), [n, i] = $46c24eb3104107ba$var$j(), [r, s] = $46c24eb3104107ba$var$j();
    function l() {
        const p = e(), x = r();
        return !(!p || !x || !p.contains(x) || getComputedStyle(x).display === "none");
    }
    const [o, c] = $46c24eb3104107ba$var$j(!1), [f, a] = $46c24eb3104107ba$var$j(!1), [u, d] = $46c24eb3104107ba$var$j([]), [h, v] = $46c24eb3104107ba$var$j({
        type: "none"
    }), y = ()=>u().some((p)=>$46c24eb3104107ba$export$1a7ce0848b9df5ad(p)), z = ()=>c(!1);
    function $() {
        const p = new CustomEvent($46c24eb3104107ba$var$xe, {
            bubbles: !0,
            composed: !0
        });
        window.dispatchEvent(p), z();
    }
    function P(p) {
        p.key === "Escape" && $();
    }
    $46c24eb3104107ba$var$Fe(()=>{
        if (o()) {
            window.addEventListener("keydown", P);
            return;
        }
        window.removeEventListener("keydown", P);
    });
    function _(p) {
        const x = u().find((K)=>K.id === p);
        if ($46c24eb3104107ba$export$723d9c21be5da6c5(x)) {
            l() ? v({
                type: "install-wallet-prompt",
                option: x
            }) : $46c24eb3104107ba$var$Se(x);
            return;
        }
        const O = new CustomEvent($46c24eb3104107ba$var$ve, {
            detail: p,
            bubbles: !0,
            composed: !0
        });
        window.dispatchEvent(O);
    }
    function E(p) {
        $46c24eb3104107ba$var$mt(()=>{
            c(!0), a(!0);
            const x = p.detail.options;
            d(x), x.some((O)=>!O.installPrompt) ? v({
                type: "explainer"
            }) : v({
                type: "none"
            });
        });
    }
    function R() {
        c(!1);
    }
    const se = ()=>{
        o() || a(!1);
    };
    function Ye(p) {
        const x = p.detail;
        v({
            type: "opening-wallet",
            option: u().find((O)=>O.id === x)
        });
    }
    function Ge() {
        v({
            type: "explainer"
        });
    }
    $46c24eb3104107ba$var$bt(()=>{
        window.addEventListener($46c24eb3104107ba$var$Ce, E), window.addEventListener($46c24eb3104107ba$var$Pe, R), window.addEventListener($46c24eb3104107ba$var$Xe, Ye), window.addEventListener($46c24eb3104107ba$var$qe, Ge), document.head.appendChild($46c24eb3104107ba$var$kn());
    }), $46c24eb3104107ba$var$Me(()=>{
        window.removeEventListener($46c24eb3104107ba$var$Ce, E), window.removeEventListener($46c24eb3104107ba$var$Pe, R);
    });
    function Ze(p) {
        const x = p.target;
        if (!x) return;
        const O = n();
        O && (O.contains(x) || $());
    }
    return (()=>{
        var p = $46c24eb3104107ba$var$Ln(), x = p.firstChild, O = x.nextSibling;
        return $46c24eb3104107ba$var$ye(t, p), p.style.setProperty("inset", "0"), p.addEventListener("click", Ze), p.addEventListener("keydown", ()=>{
            console.log("Inside root keydown");
        }), $46c24eb3104107ba$var$b(p, $46c24eb3104107ba$var$g($46c24eb3104107ba$var$ln, {}), x), $46c24eb3104107ba$var$b(O, ()=>`
        .card-width-container {
          container: card-width-container / inline-size;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
          width: 740px;
        }

        .card-height-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-end;
          height: 100%;
          width: 100%;
        }

        .card {
          min-height: 340px;
          max-height: calc(100vh - 8rem);
          width: 100%;
          border-top-left-radius: ${$46c24eb3104107ba$var$G};
          border-top-right-radius: ${$46c24eb3104107ba$var$G};

          background: rgb(196, 177, 217);
          overflow: hidden;

          display: flex;
          flex-direction: column;

          position: "relative"; /* For the close button */
          background-color: #ffffff;
          display: ${f() ? "block" : "none"};

          box-shadow: 0px 8px 64px 0px rgba(0, 0, 0, 0.25);
          animation: ${o() ? "wallet-selector-fade-in 0.4s cubic-bezier(.05, .7, .1, 1) forwards" : "wallet-selector-fade-out 0.2s cubic-bezier(.3, 0, .8, .15) forwards"};
        }

        .card-grid {
          flex-grow: 1;
          height: 100%;
          
          display: grid;
          grid-template-columns: 1fr;
          grid-template-areas: "mainPanel";
        }

        .main-panel {
          height: 100%;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          grid-area: mainPanel;
        }

        .wallets-grid-container {
          overflow: auto;
          flex-grow: 1;
        }

        .wallets-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
          align-content: start;

          padding-left: 24px;
          padding-right: 24px;
          padding-bottom: 40px;
        }

        .divider {
          display: none;
          grid-area: divider;
        }

        .side-panel {
          display: none;
          grid-area: sidePanel;
        }

        @container card-width-container (width > 400px) {
          .card-height-container {
            justify-content: center;
          }

          .card {
            max-width: calc(100vw - 2rem);
            max-height: 460px;
            ${y() ? "" : "width: 360px;"}
            border-bottom-left-radius: ${$46c24eb3104107ba$var$G};
            border-bottom-right-radius: ${$46c24eb3104107ba$var$G};
          }

          .card-grid {
            grid-template-columns: ${y() ? "5fr auto 4fr" : "1fr"};
            grid-template-areas: ${y() ? '"mainPanel divider sidePanel"' : '"mainPanel"'};
          }

          .divider {
            display: block;
          }

          .side-panel {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
        }
      `), $46c24eb3104107ba$var$b(p, $46c24eb3104107ba$var$g($46c24eb3104107ba$var$he, {
            get when () {
                return f();
            },
            get children () {
                var K = $46c24eb3104107ba$var$An(), B = K.firstChild, X = B.nextSibling, Je = X.firstChild, Qe = Je.firstChild, H = Qe.firstChild, oe = H.firstChild, et = oe.firstChild, le = et.firstChild, ae = le.nextSibling, tt = ae.nextSibling, nt = tt.firstChild;
                return K.style.setProperty("position", "fixed"), K.style.setProperty("inset", "0"), B.style.setProperty("background-color", "#FFFFFF80"), B.style.setProperty("position", "absolute"), B.style.setProperty("inset", "0"), X.style.setProperty("display", "flex"), X.style.setProperty("justify-content", "center"), X.style.setProperty("align-items", "center"), X.style.setProperty("height", "100%"), $46c24eb3104107ba$var$ye(i, H), H.addEventListener("animationend", se), $46c24eb3104107ba$var$b(le, ()=>y() ? "Choose wallet to connect" : "Don't have a wallet?"), $46c24eb3104107ba$var$b(ae, ()=>y() ? "Start by selecting one of the wallets below and confirming the connection." : "Start by installing one of the wallets below."), $46c24eb3104107ba$var$b(nt, $46c24eb3104107ba$var$g($46c24eb3104107ba$var$At, {
                    get each () {
                        return u();
                    },
                    children: (k)=>$46c24eb3104107ba$var$g($46c24eb3104107ba$var$En, $46c24eb3104107ba$var$$t(k, {
                            onProviderSelected: _
                        }))
                })), $46c24eb3104107ba$var$b(oe, $46c24eb3104107ba$var$g($46c24eb3104107ba$var$he, {
                    get when () {
                        return h().type !== "none";
                    },
                    get children () {
                        return $46c24eb3104107ba$var$g($46c24eb3104107ba$var$cn, {});
                    }
                }), null), $46c24eb3104107ba$var$b(oe, $46c24eb3104107ba$var$g($46c24eb3104107ba$var$he, {
                    get when () {
                        return h().type !== "none";
                    },
                    get children () {
                        var k = $46c24eb3104107ba$var$$n();
                        return $46c24eb3104107ba$var$ye(s, k), $46c24eb3104107ba$var$b(k, $46c24eb3104107ba$var$g($46c24eb3104107ba$var$dn, {
                            get children () {
                                return $46c24eb3104107ba$var$g($46c24eb3104107ba$var$hn, {
                                    get children () {
                                        return $46c24eb3104107ba$var$g($46c24eb3104107ba$var$Lt, {
                                            fallback: null,
                                            get children () {
                                                return [
                                                    $46c24eb3104107ba$var$g($46c24eb3104107ba$var$pe, {
                                                        get when () {
                                                            return h().type === "install-wallet-prompt";
                                                        },
                                                        get children () {
                                                            return $46c24eb3104107ba$var$g($46c24eb3104107ba$var$bn, {
                                                                get option () {
                                                                    return h().option;
                                                                }
                                                            });
                                                        }
                                                    }),
                                                    $46c24eb3104107ba$var$g($46c24eb3104107ba$var$pe, {
                                                        get when () {
                                                            return h().type === "explainer";
                                                        },
                                                        get children () {
                                                            return $46c24eb3104107ba$var$g($46c24eb3104107ba$var$yn, {});
                                                        }
                                                    }),
                                                    $46c24eb3104107ba$var$g($46c24eb3104107ba$var$pe, {
                                                        get when () {
                                                            return h().type === "opening-wallet";
                                                        },
                                                        get children () {
                                                            return $46c24eb3104107ba$var$g($46c24eb3104107ba$var$Sn, {
                                                                get option () {
                                                                    return h().option;
                                                                }
                                                            });
                                                        }
                                                    })
                                                ];
                                            }
                                        });
                                    }
                                });
                            }
                        })), k;
                    }
                }), null), $46c24eb3104107ba$var$b(H, $46c24eb3104107ba$var$g($46c24eb3104107ba$var$sn, {
                    onClose: $
                }), null), $46c24eb3104107ba$var$A((k)=>{
                    var ce = o() ? "wallet-selector-blur-in 0.2s cubic-bezier(.05, .7, .1, 1) forwards" : "wallet-selector-blur-out 0.2s cubic-bezier(.3, 0, .8, .15) forwards", it = {
                        ...$46c24eb3104107ba$var$re,
                        margin: "0",
                        "padding-top": "24px",
                        "padding-left": "24px",
                        "padding-right": "24px",
                        "padding-bottom": "16px"
                    }, rt = {
                        ...$46c24eb3104107ba$var$W,
                        "padding-left": "24px",
                        "padding-right": "24px",
                        "padding-bottom": "30px"
                    };
                    return ce !== k.e && ((k.e = ce) != null ? B.style.setProperty("animation", ce) : B.style.removeProperty("animation")), k.t = $46c24eb3104107ba$var$L(le, it, k.t), k.a = $46c24eb3104107ba$var$L(ae, rt, k.a), k;
                }, {
                    e: void 0,
                    t: void 0,
                    a: void 0
                }), K;
            }
        }), null), $46c24eb3104107ba$var$A(()=>(f(), p.style.setProperty("position", f() ? "fixed" : "static"))), p;
    })();
}
const $46c24eb3104107ba$export$89882c0ac7af12a4 = "sats-connect-wallet-provider-selector", $46c24eb3104107ba$export$befb8987f3390baa = $46c24eb3104107ba$export$89882c0ac7af12a4;
function $46c24eb3104107ba$export$dba43aa3566c900c() {
    return document.getElementById($46c24eb3104107ba$export$89882c0ac7af12a4);
}
function $46c24eb3104107ba$export$9e28020f9ccd3a22() {
    if (customElements.get($46c24eb3104107ba$export$befb8987f3390baa)) return;
    $46c24eb3104107ba$var$Jt($46c24eb3104107ba$export$befb8987f3390baa, $46c24eb3104107ba$var$On);
    const e = document.createElement($46c24eb3104107ba$export$befb8987f3390baa);
    e.id = $46c24eb3104107ba$export$89882c0ac7af12a4, e.style.position = "relative", e.style.zIndex = "999999", document.body.appendChild(e);
}
function $46c24eb3104107ba$export$de863c629cb9919d() {
    const e = $46c24eb3104107ba$export$dba43aa3566c900c();
    e && e.remove();
}
function $46c24eb3104107ba$export$723d9c21be5da6c5(e) {
    return !!e.installPrompt;
}
function $46c24eb3104107ba$export$1a7ce0848b9df5ad(e) {
    return !$46c24eb3104107ba$export$723d9c21be5da6c5(e);
}
function $46c24eb3104107ba$export$572bf5fa695e2507(e) {
    return new Promise((t, n)=>{
        if (!$46c24eb3104107ba$export$dba43aa3566c900c()) {
            n("Failed to detect the wallet provider selector.");
            return;
        }
        function r() {
            window.removeEventListener($46c24eb3104107ba$var$ve, s), window.removeEventListener($46c24eb3104107ba$var$xe, l);
        }
        function s(c) {
            t(c.detail), r();
        }
        function l() {
            n(), r();
        }
        window.addEventListener($46c24eb3104107ba$var$ve, s), window.addEventListener($46c24eb3104107ba$var$xe, l);
        const o = new CustomEvent($46c24eb3104107ba$var$Ce, {
            detail: e
        });
        window.dispatchEvent(o);
    });
}
function $46c24eb3104107ba$export$5fb5d07e7a2c7576(e) {
    const t = new CustomEvent($46c24eb3104107ba$var$Xe, {
        detail: e
    });
    window.dispatchEvent(t);
}
function $46c24eb3104107ba$export$3ed1f38bf5c4770b() {
    const e = new CustomEvent($46c24eb3104107ba$var$qe);
    window.dispatchEvent(e);
}
function $46c24eb3104107ba$export$8360e631d277ea4d() {
    const e = new CustomEvent($46c24eb3104107ba$var$Pe);
    window.dispatchEvent(e);
}


var $b78bfbd0f1845d8a$var$Wallet = class {
    providerId;
    defaultAdapters = (0, $adfbe621f07e3fbf$export$594c7d98ad79c9c6);
    createCustomConfig;
    isProviderSet() {
        return !!this.providerId;
    }
    setCreateCustomConfig(createCustomConfig) {
        this.createCustomConfig = createCustomConfig;
    }
    async selectProvider() {
        const providers = (0, $adfbe621f07e3fbf$export$8d8f8813b8f9b83)();
        if (providers.length === 0) throw new Error("No wallets detected, may want to prompt user to install a wallet.");
        const selectorConfig = this.createCustomConfig ? this.createCustomConfig(providers) : (0, $f8a5672653aa0b22$export$246c4b321fef5774)(providers);
        const nextProviderId = await (0, $46c24eb3104107ba$export$572bf5fa695e2507)(selectorConfig);
        this.providerId = nextProviderId;
    }
    async disconnect() {
        await this.request("wallet_renouncePermissions", void 0);
        this.providerId = void 0;
        (0, $adfbe621f07e3fbf$export$27208945b0d79d1f)();
    }
    async request(method, params) {
        (0, $46c24eb3104107ba$export$9e28020f9ccd3a22)();
        const defaultProvider = (0, $adfbe621f07e3fbf$export$4f77a1d3c1ac6642)();
        if (!this.isProviderSet()) {
            if (defaultProvider) this.providerId = defaultProvider;
            else try {
                await this.selectProvider();
            } catch  {
                return {
                    status: "error",
                    error: {
                        code: (0, $adfbe621f07e3fbf$export$b376ef3ad38fc2b7).INTERNAL_ERROR,
                        message: "Failed to select the provider. User may have cancelled the selection prompt."
                    }
                };
            }
        }
        const adapter = this.defaultAdapters[this.providerId];
        (0, $46c24eb3104107ba$export$5fb5d07e7a2c7576)(this.providerId);
        const response = adapter ? await new adapter().request(method, params) : await new (0, $adfbe621f07e3fbf$export$3f8a66e424843755)(this.providerId).request(method, params);
        (0, $46c24eb3104107ba$export$3ed1f38bf5c4770b)();
        if (response?.status === "error" && response.error?.code === (0, $adfbe621f07e3fbf$export$b376ef3ad38fc2b7).USER_REJECTION) {
            if (!defaultProvider) this.providerId = void 0;
        } else (0, $adfbe621f07e3fbf$export$a727891859a233e8)(this.providerId);
        (0, $46c24eb3104107ba$export$8360e631d277ea4d)();
        if (!response) return {
            status: "error",
            error: {
                code: (0, $adfbe621f07e3fbf$export$b376ef3ad38fc2b7).INTERNAL_ERROR,
                message: "Wallet Error processing the request"
            }
        };
        return response;
    }
    addListener = (event, cb)=>{
        const defaultProvider = (0, $adfbe621f07e3fbf$export$4f77a1d3c1ac6642)();
        if (!this.isProviderSet() && defaultProvider) this.providerId = defaultProvider;
        if (!this.isProviderSet()) {
            console.error("No wallet provider selected. The user must first select a wallet before adding listeners to wallet events.");
            return ()=>{};
        }
        const adapter = this.defaultAdapters[this.providerId];
        if (!adapter || !new adapter().addListener) {
            console.error(`The wallet provider you are using does not support the addListener method. Please update your wallet provider.`);
            return ()=>{};
        }
        return new adapter().addListener(event, cb);
    };
};
var $b78bfbd0f1845d8a$export$2e2bcd8739ae039 = new $b78bfbd0f1845d8a$var$Wallet();


var $0261998ae2fc59f7$export$b6218cda604ca8c9;
(function(AddressPurpose) {
    AddressPurpose["Ordinal"] = "ordinal";
    AddressPurpose["Payment"] = "payment";
    AddressPurpose["Stacks"] = "stx";
})($0261998ae2fc59f7$export$b6218cda604ca8c9 || ($0261998ae2fc59f7$export$b6218cda604ca8c9 = {}));
function $0261998ae2fc59f7$export$26186881902d8ee7(purpose) {
    switch(purpose){
        case (0, $adfbe621f07e3fbf$export$b6218cda604ca8c9).Payment:
            return $0261998ae2fc59f7$export$b6218cda604ca8c9.Payment;
        case (0, $adfbe621f07e3fbf$export$b6218cda604ca8c9).Ordinals:
            return $0261998ae2fc59f7$export$b6218cda604ca8c9.Ordinal;
        case (0, $adfbe621f07e3fbf$export$b6218cda604ca8c9).Stacks:
            return $0261998ae2fc59f7$export$b6218cda604ca8c9.Stacks;
        default:
            return undefined;
    }
}


class $9e20527ab7df0ae1$export$72b040f461a56853 {
    constructor(){
        this.listeners = {
            accountsChanged: [],
            chainChanged: [],
            connect: [],
            disconnect: [],
            display_uri: [],
            message: []
        };
    }
    on(event, listener) {
        this.listeners[event].push(listener);
    }
    removeListener(event, listener) {
        if (event in this.listeners) // @ts-expect-error - Bad typed Provider from core package
        this.listeners[event] = this.listeners[event].filter((l)=>l !== listener);
    }
    emit(event, data) {
        if (event in this.listeners) // @ts-expect-error - Bad typed Provider from core package
        this.listeners[event].forEach((listener)=>listener(data));
    }
}



var $lewJ9 = parcelRequire("lewJ9");
var $b586f3a75b4ed631$require$Buffer = $lewJ9.Buffer;
class $b586f3a75b4ed631$export$1ba8e87dd8dcb162 extends (0, $ffb539405861dea3$export$c456b2d327ac201f) {
    constructor({ provider: provider, chains: chains, getActiveChain: getActiveChain }){
        super({
            provider: provider,
            caipNetworks: chains,
            namespace: "bip122"
        });
        this.eventEmitter = new (0, $9e20527ab7df0ae1$export$72b040f461a56853)();
        this.emit = this.eventEmitter.emit.bind(this.eventEmitter);
        this.on = this.eventEmitter.on.bind(this.eventEmitter);
        this.removeListener = this.eventEmitter.removeListener.bind(this.eventEmitter);
        this.getActiveChain = getActiveChain;
    }
    // -- Public ------------------------------------------- //
    get chains() {
        return this.sessionChains.map((chainId)=>this.caipNetworks.find((chain)=>chain.caipNetworkId === chainId)).filter(Boolean);
    }
    async connect() {
        return Promise.reject(new Error("Connection of WalletConnectProvider should be done via UniversalAdapter"));
    }
    async signMessage({ message: message, address: address, protocol: protocol }) {
        this.checkIfMethodIsSupported("signMessage");
        const signedMessage = await this.internalRequest({
            method: "signMessage",
            params: {
                message: message,
                account: address,
                address: address,
                protocol: protocol
            }
        });
        return $b586f3a75b4ed631$require$Buffer.from(signedMessage.signature, "hex").toString("base64");
    }
    async sendTransfer({ recipient: recipient, amount: amount }) {
        this.checkIfMethodIsSupported("sendTransfer");
        const account = this.getAccount(true);
        const result = await this.internalRequest({
            method: "sendTransfer",
            params: {
                account: account,
                recipientAddress: recipient,
                amount: amount
            }
        });
        return result.txid;
    }
    async getAccountAddresses() {
        this.checkIfMethodIsSupported("getAccountAddresses");
        const addresses = await this.internalRequest({
            method: "getAccountAddresses",
            params: undefined
        });
        return addresses.map((address)=>({
                address: address,
                purpose: (0, $0261998ae2fc59f7$export$b6218cda604ca8c9).Payment
            }));
    }
    async signPSBT(params) {
        this.checkIfMethodIsSupported("signPsbt");
        const account = this.getAccount(true);
        const response = await this.internalRequest({
            method: "signPsbt",
            params: {
                account: account,
                psbt: params.psbt,
                signInputs: params.signInputs,
                broadcast: params.broadcast
            }
        });
        return {
            psbt: response.psbt,
            txid: response.txid
        };
    }
    async switchNetwork(_caipNetworkId) {
        // ChainAdapterBlueprint.switchNetwork will be called instead
        return Promise.resolve();
    }
    request(args) {
        // @ts-expect-error - args type should match internalRequest arguments but it's not correctly typed in Provider
        return this.internalRequest(args);
    }
    // -- Private ------------------------------------------ //
    get sessionChains() {
        return (0, $6c592072e95901b7$export$4267940df2f33c5a).getChainsFromNamespaces(this.provider.session?.namespaces);
    }
    getAccount(required) {
        const account = this.provider.session?.namespaces["bip122"]?.accounts[0];
        if (!account) {
            if (required) throw new Error("Account not found");
            return undefined;
        }
        const address = account.split(":")[2];
        if (!address) {
            if (required) throw new Error("Address not found");
            return undefined;
        }
        return address;
    }
    checkIfMethodIsSupported(method) {
        if (!this.provider.session?.namespaces["bip122"]?.methods.includes(method)) throw new Error(`Method ${method} is not supported`);
    }
    async internalRequest({ method: method, params: params }) {
        const chain = this.getActiveChain();
        if (!chain) throw new Error("Chain not found");
        return await this.provider.request({
            method: method,
            params: params
        }, chain.caipNetworkId);
    }
}





var $lpmCO = parcelRequire("lpmCO");




function $0dbaf6a99b4cc11e$export$be0632905b6cbf2(caipNetworkId) {
    if (!caipNetworkId) throw new Error("mapCaipNetworkToXverseName: Invalid caipNetworkId provided");
    switch(caipNetworkId){
        case (0, $bb01571ccd77b52d$export$794b04b0756618df).caipNetworkId:
            return (0, $adfbe621f07e3fbf$export$1773106817ea4e92).Mainnet;
        case (0, $bb01571ccd77b52d$export$866db670255e931d).caipNetworkId:
            return (0, $adfbe621f07e3fbf$export$1773106817ea4e92).Testnet4;
        default:
            throw new Error(`Network ${caipNetworkId} not supported by Xverse wallet`);
    }
}
function $0dbaf6a99b4cc11e$export$2565dddb463874d(network) {
    switch(network){
        case (0, $adfbe621f07e3fbf$export$1773106817ea4e92).Mainnet:
            return (0, $bb01571ccd77b52d$export$794b04b0756618df).caipNetworkId;
        case (0, $adfbe621f07e3fbf$export$1773106817ea4e92).Testnet4:
            return (0, $bb01571ccd77b52d$export$866db670255e931d).caipNetworkId;
        default:
            throw new Error(`Network ${network} not supported by Xverse wallet`);
    }
}



class $d30cc49932703cee$export$7cab713f12dd520c extends (0, $9e20527ab7df0ae1$export$72b040f461a56853) {
    constructor({ provider: provider, requestedChains: requestedChains, getActiveNetwork: getActiveNetwork }){
        super();
        this.chain = "bip122";
        this.type = "ANNOUNCED";
        this.requestedChains = [];
        this.walletUnsubscribes = [];
        this.wallet = provider;
        this.requestedChains = requestedChains;
        this.provider = this;
        this.getActiveNetwork = getActiveNetwork;
    }
    get id() {
        return this.name;
    }
    get name() {
        return this.wallet.name;
    }
    get explorerId() {
        return (0, $8a4fed4bf263e097$export$fd35d6514357600).ConnectorExplorerIds[this.wallet.name];
    }
    get imageUrl() {
        return this.wallet.icon;
    }
    get chains() {
        return this.requestedChains.filter((chain)=>chain.chainNamespace === "bip122");
    }
    async request(args) {
        return this.internalRequest(args.method, args.params);
    }
    async connect() {
        const currentNetwork = this.getActiveNetwork();
        const networkName = (0, $0dbaf6a99b4cc11e$export$be0632905b6cbf2)(currentNetwork?.caipNetworkId);
        const address = await this.getAccountAddresses().then((addresses)=>addresses[0]?.address).catch(()=>this.internalRequest("wallet_connect", {
                network: networkName
            }).then((response)=>response?.addresses.map((add)=>({
                        ...add,
                        purpose: (0, $0261998ae2fc59f7$export$26186881902d8ee7)(add.purpose)
                    })).find((add)=>add.purpose === (0, $0261998ae2fc59f7$export$b6218cda604ca8c9).Payment)?.address));
        if (!address) throw new Error("No address available");
        this.bindEvents();
        this.emit("accountsChanged", [
            address
        ]);
        return address;
    }
    async disconnect() {
        await this.internalRequest("wallet_disconnect", null);
        this.unbindEvents();
    }
    async getAccountAddresses() {
        const response = await this.internalRequest("getAddresses", {
            purposes: [
                (0, $adfbe621f07e3fbf$export$b6218cda604ca8c9).Payment,
                (0, $adfbe621f07e3fbf$export$b6218cda604ca8c9).Ordinals,
                (0, $adfbe621f07e3fbf$export$b6218cda604ca8c9).Stacks
            ],
            message: "Connect to your wallet"
        });
        if (response.addresses.length === 0) throw new Error("No address available");
        return response.addresses.map((address)=>({
                ...address,
                purpose: (0, $0261998ae2fc59f7$export$26186881902d8ee7)(address.purpose)
            }));
    }
    static getWallets({ requestedChains: requestedChains, getActiveNetwork: getActiveNetwork }) {
        if (!(0, $lpmCO.CoreHelperUtil).isClient()) return [];
        const providers = (0, $adfbe621f07e3fbf$export$4e044719025cb45d)();
        return providers.map((provider)=>new $d30cc49932703cee$export$7cab713f12dd520c({
                provider: provider,
                requestedChains: requestedChains,
                getActiveNetwork: getActiveNetwork
            }));
    }
    async signMessage(params) {
        const protocol = params.protocol?.toUpperCase();
        const res = await this.internalRequest("signMessage", {
            ...params,
            protocol: protocol
        });
        return res.signature;
    }
    async signPSBT(params) {
        const signInputs = params.signInputs.reduce((acc, input)=>{
            const currentIndexes = acc[input.address] || [];
            currentIndexes.push(input.index);
            return {
                ...acc,
                [input.address]: currentIndexes
            };
        }, {});
        const res = await this.internalRequest("signPsbt", {
            psbt: params.psbt,
            broadcast: params.broadcast,
            signInputs: signInputs
        });
        return res;
    }
    async switchNetwork(caipNetworkId) {
        const networkName = (0, $0dbaf6a99b4cc11e$export$be0632905b6cbf2)(caipNetworkId);
        await this.internalRequest("wallet_changeNetwork", {
            name: networkName
        });
    }
    async sendTransfer({ amount: amount, recipient: recipient }) {
        const parsedAmount = Number(amount);
        if (isNaN(parsedAmount)) throw new Error("Invalid amount");
        const res = await this.internalRequest("sendTransfer", {
            recipients: [
                {
                    address: recipient,
                    amount: parsedAmount
                }
            ]
        });
        return res.txid;
    }
    getWalletProvider() {
        return (0, $adfbe621f07e3fbf$export$367a63e5543d5442)(this.wallet.id);
    }
    async internalRequest(method, options) {
        const response = await this.getWalletProvider().request(method, options).catch((error)=>{
            if ("jsonrpc" in error && "error" in error) return error;
            throw error;
        });
        if ("result" in response) return response.result;
        throw {
            ...response.error,
            name: "RPCError"
        };
    }
    bindEvents() {
        this.unbindEvents();
        const provider = this.getWalletProvider();
        if (typeof provider.addListener !== "function") {
            console.warn(`SatsConnectConnector:bindEvents - wallet provider "${this.name}" does not support events`);
            return;
        }
        this.walletUnsubscribes.push(provider.addListener("accountChange", async (_data)=>{
            const address = await this.connect();
            this.emit("accountsChanged", [
                address
            ]);
        }), provider.addListener("disconnect", (_data)=>{
            this.emit("disconnect");
        }), provider.addListener("networkChange", (_data)=>{
            const chainId = (0, $0dbaf6a99b4cc11e$export$2565dddb463874d)(_data.stacks.name);
            this.emit("chainChanged", chainId);
        }));
    }
    unbindEvents() {
        this.walletUnsubscribes.forEach((unsubscribe)=>unsubscribe());
        this.walletUnsubscribes = [];
    }
}



var $lewJ9 = parcelRequire("lewJ9");
var $3e62494aeb398f9f$require$Buffer = $lewJ9.Buffer;
class $3e62494aeb398f9f$export$108d012b1df72b00 extends (0, $d30cc49932703cee$export$7cab713f12dd520c) {
    constructor({ connector: connector }){
        if (connector.wallet.id !== $3e62494aeb398f9f$export$108d012b1df72b00.ProviderId) throw new Error("LeatherConnector: wallet must be a LeatherProvider");
        super({
            provider: connector.wallet,
            requestedChains: connector.requestedChains,
            getActiveNetwork: connector.getActiveNetwork
        });
    }
    get imageUrl() {
        return this.wallet?.icon?.replace("data:image/svg", "data:image/svg+xml");
    }
    async getAccountAddresses() {
        // Keep the connected accounts in memory to avoid repeated requests because Leather doesn't have a connect method
        if (this.connectedAccounts) return this.connectedAccounts;
        this.connectedAccounts = await super.getAccountAddresses();
        return this.connectedAccounts;
    }
    disconnect() {
        // Leather doesn't have disconnect method
        this.connectedAccounts = undefined;
        return Promise.resolve();
    }
    async sendTransfer({ amount: amount, recipient: recipient }) {
        const params = {
            address: recipient,
            amount: amount
        };
        const res = await this.internalRequest("sendTransfer", // @ts-expect-error - expected LeatherWallet params don't match sats-connect
        params);
        return res.txid;
    }
    async signPSBT({ psbt: psbt, broadcast: broadcast = false }) {
        const params = {
            hex: $3e62494aeb398f9f$require$Buffer.from(psbt, "base64").toString("hex"),
            network: this.getNetwork(),
            broadcast: broadcast
        };
        // @ts-expect-error - expected LeatherWallet params don't match sats-connect
        const res = await this.internalRequest("signPsbt", params);
        return {
            psbt: $3e62494aeb398f9f$require$Buffer.from(res.hex, "hex").toString("base64"),
            txid: res.txid
        };
    }
    getNetwork() {
        const activeCaipNetwork = this.getActiveNetwork();
        switch(activeCaipNetwork?.caipNetworkId){
            case (0, $bb01571ccd77b52d$export$794b04b0756618df).caipNetworkId:
                return "mainnet";
            case (0, $bb01571ccd77b52d$export$866db670255e931d).caipNetworkId:
                return "testnet";
            default:
                throw new Error("LeatherConnector: unsupported network");
        }
    }
}
$3e62494aeb398f9f$export$108d012b1df72b00.ProviderId = "LeatherProvider";


/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/require-await */ 
var $b3v9s = parcelRequire("b3v9s");

var $lpmCO = parcelRequire("lpmCO");


class $ba07e71df2444fc6$export$9d51944a6cc92c46 extends Error {
    constructor(walletId, method, log){
        super(`Wallet call is not supported`);
        this.name = "MethodNotSupported";
        this.method = method;
        this.walletId = walletId;
        // eslint-disable-next-line no-console
        console.error(`BitcoinAdapter:MethodNotSupportedError:${walletId} - The connected wallet doesn't support the method "${method}".${log ? ` ${log}` : ""}`);
    }
}




const $c860462adfedbc0a$export$b521c3a58ad65432 = {
    parseSatoshis (amount, network) {
        const value = parseFloat(amount) / 10 ** network.nativeCurrency.decimals;
        // eslint-disable-next-line new-cap
        return Intl.NumberFormat("en-US", {
            maximumFractionDigits: network.nativeCurrency.decimals
        }).format(value);
    }
};



var $lewJ9 = parcelRequire("lewJ9");
var $6f84d6be9c2e0f98$require$Buffer = $lewJ9.Buffer;
class $6f84d6be9c2e0f98$export$a93b7758493132bd extends (0, $9e20527ab7df0ae1$export$72b040f461a56853) {
    constructor({ wallet: wallet, requestedChains: requestedChains, getActiveNetwork: getActiveNetwork, imageUrl: imageUrl }){
        super();
        this.id = "OKX";
        this.name = "OKX Wallet";
        this.chain = "bip122";
        this.type = "ANNOUNCED";
        this.explorerId = (0, $8a4fed4bf263e097$export$fd35d6514357600).ConnectorExplorerIds[(0, $b3v9s.ConstantsUtil).CONNECTOR_ID.OKX];
        this.provider = this;
        this.requestedChains = [];
        this.wallet = wallet;
        this.requestedChains = requestedChains;
        this.getActiveNetwork = getActiveNetwork;
        this.imageUrl = imageUrl;
    }
    get chains() {
        return this.requestedChains.filter((chain)=>chain.caipNetworkId === (0, $bb01571ccd77b52d$export$794b04b0756618df).caipNetworkId);
    }
    async connect() {
        const result = await this.wallet.connect();
        this.bindEvents();
        return result.address;
    }
    async disconnect() {
        this.unbindEvents();
        await this.wallet.disconnect();
    }
    async getAccountAddresses() {
        const accounts = await this.wallet.getAccounts();
        const publicKeyOfActiveAccount = await this.wallet.getPublicKey();
        const accountList = accounts.map((account)=>({
                address: account,
                purpose: (0, $0261998ae2fc59f7$export$b6218cda604ca8c9).Payment,
                publicKey: publicKeyOfActiveAccount
            }));
        return accountList;
    }
    async signMessage(params) {
        const protocol = params.protocol === "bip322" ? "bip322-simple" : params.protocol;
        return this.wallet.signMessage(params.message, protocol);
    }
    async sendTransfer(params) {
        const network = this.getActiveNetwork();
        if (!network) throw new Error("No active network available");
        const from = (await this.wallet.getAccounts())[0];
        if (!from) throw new Error("No account available");
        const result = await this.wallet.send({
            from: from,
            to: params.recipient,
            value: (0, $c860462adfedbc0a$export$b521c3a58ad65432).parseSatoshis(params.amount, network)
        });
        return result.txhash;
    }
    async signPSBT(params) {
        const psbtHex = $6f84d6be9c2e0f98$require$Buffer.from(params.psbt, "base64").toString("hex");
        const signedPsbtHex = await this.wallet.signPsbt(psbtHex);
        let txid = undefined;
        if (params.broadcast) txid = await this.wallet.pushPsbt(signedPsbtHex);
        return {
            psbt: $6f84d6be9c2e0f98$require$Buffer.from(signedPsbtHex, "hex").toString("base64"),
            txid: txid
        };
    }
    async switchNetwork(_caipNetworkId) {
        throw new Error(`${this.name} wallet does not support network switching`);
    }
    request(_args) {
        return Promise.reject(new (0, $ba07e71df2444fc6$export$9d51944a6cc92c46)(this.id, "request"));
    }
    bindEvents() {
        this.unbindEvents();
        this.wallet.on("accountChanged", (account)=>{
            if (typeof account === "object" && account && "address" in account) this.emit("accountsChanged", [
                account.address
            ]);
        });
        this.wallet.on("disconnect", ()=>{
            this.emit("disconnect");
        });
    }
    unbindEvents() {
        this.wallet.removeAllListeners();
    }
    static getWallet(params) {
        if (!(0, $lpmCO.CoreHelperUtil).isClient()) return undefined;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const okxwallet = window?.okxwallet;
        const wallet = okxwallet?.bitcoin;
        /**
         * OKX doesn't provide a way to get the image URL specifally for bitcoin
         * so we use the icon for cardano as a fallback
         */ const imageUrl = okxwallet?.cardano?.icon || "";
        if (wallet) return new $6f84d6be9c2e0f98$export$a93b7758493132bd({
            wallet: wallet,
            imageUrl: imageUrl,
            ...params
        });
        return undefined;
    }
    async getPublicKey() {
        return this.wallet.getPublicKey();
    }
}



/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/require-await */ 






var $lewJ9 = parcelRequire("lewJ9");
var $8182b6ce66de825a$require$Buffer = $lewJ9.Buffer;
class $8182b6ce66de825a$export$c2f62bffabb9ff80 extends (0, $9e20527ab7df0ae1$export$72b040f461a56853) {
    constructor({ wallet: wallet, requestedChains: requestedChains }){
        super();
        this.chain = "bip122";
        this.type = "ANNOUNCED";
        this.requestedChains = [];
        this.walletUnsubscribes = [];
        this.provider = this;
        this.wallet = wallet;
        this.requestedChains = requestedChains;
        this.provider = this;
    }
    get id() {
        return this.name;
    }
    get name() {
        return this.wallet.name;
    }
    get imageUrl() {
        return this.wallet.icon;
    }
    get explorerId() {
        return (0, $8a4fed4bf263e097$export$fd35d6514357600).ConnectorExplorerIds[this.name];
    }
    get chains() {
        return this.wallet.chains.map((chainId)=>this.requestedChains.find((chain)=>{
                switch(chainId){
                    case "bitcoin:mainnet":
                        return chain.caipNetworkId === (0, $bb01571ccd77b52d$export$794b04b0756618df).caipNetworkId;
                    case "bitcoin:testnet":
                        return chain.caipNetworkId === (0, $bb01571ccd77b52d$export$866db670255e931d).caipNetworkId;
                    default:
                        return chain.caipNetworkId === chainId;
                }
            })).filter(Boolean);
    }
    async connect() {
        const connectFeature = this.getWalletFeature("bitcoin:connect");
        this.bindEvents();
        const response = await connectFeature.connect({
            purposes: [
                "payment",
                "ordinals"
            ]
        });
        const account = response.accounts[0];
        if (!account) throw new Error("No account found");
        return account.address;
    }
    async getAccountAddresses() {
        const addresses = new Set();
        const mappedAccounts = this.wallet.accounts.map((acc)=>({
                address: acc.address,
                purpose: (0, $0261998ae2fc59f7$export$b6218cda604ca8c9).Payment,
                publicKey: $8182b6ce66de825a$require$Buffer.from(acc.publicKey).toString("hex")
            })).filter((acc)=>{
            if (addresses.has(acc.address)) return false;
            addresses.add(acc.address);
            return true;
        });
        return Promise.resolve(mappedAccounts);
    }
    async signMessage(params) {
        if (params.protocol) console.warn("WalletStandardConnector:signMessage - protocol parameter not supported in WalletStandard:bitcoin - signMessage");
        const feature = this.getWalletFeature("bitcoin:signMessage");
        const account = this.wallet.accounts.find((acc)=>acc.address === params.address);
        if (!account) throw new Error("Account not found");
        const message = new TextEncoder().encode(params.message);
        const response = (await feature.signMessage({
            account: account,
            message: message
        }))[0];
        if (!response) throw new Error("No response from wallet");
        return $8182b6ce66de825a$require$Buffer.from(response.signature).toString("base64");
    }
    async signPSBT(params) {
        const feature = this.getWalletFeature("bitcoin:signTransaction");
        if (params.broadcast) throw new (0, $ba07e71df2444fc6$export$9d51944a6cc92c46)(this.id, "signPSBT", "This wallet does not support broadcasting, please broadcast it manually or contact the development team.");
        const inputsToSign = params.signInputs.map((input)=>{
            const account = this.wallet.accounts.find((acc)=>acc.address === input.address);
            if (!account) throw new Error(`Account with address ${input.address} not found`);
            return {
                account: account,
                signingIndexes: [
                    input.index
                ],
                sigHash: undefined
            };
        });
        const response = (await feature.signTransaction({
            psbt: new Uint8Array($8182b6ce66de825a$require$Buffer.from(params.psbt, "base64")),
            inputsToSign: inputsToSign
        }))[0];
        if (!response) throw new Error("No response from wallet");
        return {
            psbt: $8182b6ce66de825a$require$Buffer.from(response.signedPsbt).toString("base64"),
            txid: undefined
        };
    }
    async sendTransfer(_params) {
        return Promise.reject(new (0, $ba07e71df2444fc6$export$9d51944a6cc92c46)(this.id, "sendTransfer", 'Please use "signPSBT" instead and broadcast the transaction manually.'));
    }
    async disconnect() {
        this.unbindEvents();
        return Promise.resolve();
    }
    async request(_args) {
        return Promise.reject(new (0, $ba07e71df2444fc6$export$9d51944a6cc92c46)(this.id, "request"));
    }
    getWalletFeature(feature) {
        if (!(feature in this.wallet.features)) throw new (0, $ba07e71df2444fc6$export$9d51944a6cc92c46)(this.id, feature);
        return this.wallet.features[feature];
    }
    bindEvents() {
        this.unbindEvents();
        try {
            const feature = this.getWalletFeature("standard:events");
            this.walletUnsubscribes.push(feature.on("change", (data)=>{
                if ("accounts" in data && data.accounts) {
                    if (data.accounts.length === 0) this.emit("disconnect");
                    else this.emit("accountsChanged", data.accounts.map((acc)=>acc.address));
                }
            }));
        } catch  {
            console.warn(`WalletStandardConnector:bindEvents - wallet provider "${this.name}" does not support events`);
        }
    }
    unbindEvents() {
        this.walletUnsubscribes.forEach((unsubscribe)=>unsubscribe());
        this.walletUnsubscribes = [];
    }
    static watchWallets({ callback: callback, requestedChains: requestedChains }) {
        const { get: get, on: on } = (0, $58abfe4577c72634$export$ac4d188b6eef3eb7)();
        function wrapWallets(wallets) {
            // Must replace the filter with the correct function to identify bitcoin wallets
            return wallets.filter((wallet)=>"bitcoin:connect" in wallet.features).map((wallet)=>new $8182b6ce66de825a$export$c2f62bffabb9ff80({
                    wallet: wallet,
                    requestedChains: requestedChains
                }));
        }
        callback(...wrapWallets(get()));
        return on("register", (...wallets)=>callback(...wrapWallets(wallets)));
    }
    async switchNetwork(_caipNetworkId) {
        throw new Error(`${this.name} wallet does not support network switching`);
    }
}



const $432e1414a42adfd2$export$70554faf6d098e35 = {
    getUTXOs: async ({ network: network, address: address })=>{
        const isTestnet = network.caipNetworkId === (0, $bb01571ccd77b52d$export$866db670255e931d).caipNetworkId;
        // Make chain dynamic
        const response = await fetch(`https://mempool.space${isTestnet ? "/testnet" : ""}/api/address/${address}/utxo`);
        if (!response.ok) throw new Error(`Failed to fetch UTXOs: ${await response.text()}`);
        return await response.json();
    }
};



class $45477d631d686b01$export$1967d54504ca1913 extends (0, $047ef4420d4ccb1d$export$993f0e61ab122f72) {
    constructor({ api: api = {}, ...params } = {}){
        super({
            namespace: (0, $b3v9s.ConstantsUtil).CHAIN.BITCOIN,
            adapterType: (0, $b3v9s.ConstantsUtil).ADAPTER_TYPES.BITCOIN,
            ...params
        });
        this.eventsToUnbind = [];
        this.balancePromises = {};
        this.api = {
            ...(0, $432e1414a42adfd2$export$70554faf6d098e35),
            ...api
        };
    }
    async connect(params) {
        const connector = this.connectors.find((c)=>c.id === params.id);
        if (!connector) throw new Error("connectionControllerClient:connectExternal - connector is undefined");
        this.connector = connector;
        this.bindEvents(this.connector);
        const address = await connector.connect();
        const chain = connector.chains.find((c)=>c.id === params.chainId) || connector.chains[0];
        if (!chain) throw new Error("The connector does not support any of the requested chains");
        return {
            id: connector.id,
            type: connector.type,
            address: address,
            chainId: chain.id,
            provider: connector.provider
        };
    }
    async getAccounts(params) {
        const addresses = await this.connectors.find((connector)=>connector.id === params.id)?.getAccountAddresses().catch(()=>[]);
        const accounts = addresses?.map((a)=>(0, $lpmCO.CoreHelperUtil).createAccount((0, $b3v9s.ConstantsUtil).CHAIN.BITCOIN, a.address, a.purpose || "payment", a.publicKey, a.path));
        return {
            accounts: accounts || []
        };
    }
    syncConnectors(_options, appKit) {
        function getActiveNetwork() {
            return appKit?.getCaipNetwork();
        }
        (0, $8182b6ce66de825a$export$c2f62bffabb9ff80).watchWallets({
            callback: this.addConnector.bind(this),
            requestedChains: this.networks
        });
        this.addConnector(...(0, $d30cc49932703cee$export$7cab713f12dd520c).getWallets({
            requestedChains: this.networks,
            getActiveNetwork: getActiveNetwork
        }).map((connector)=>{
            switch(connector.wallet.id){
                case (0, $3e62494aeb398f9f$export$108d012b1df72b00).ProviderId:
                    return new (0, $3e62494aeb398f9f$export$108d012b1df72b00)({
                        connector: connector
                    });
                default:
                    return connector;
            }
        }));
        const okxConnector = (0, $6f84d6be9c2e0f98$export$a93b7758493132bd).getWallet({
            requestedChains: this.networks,
            getActiveNetwork: getActiveNetwork
        });
        if (okxConnector) this.addConnector(okxConnector);
    }
    syncConnection(params) {
        return this.connect({
            id: params.id,
            chainId: params.chainId,
            type: ""
        });
    }
    async signMessage(params) {
        const connector = params.provider;
        if (!connector) throw new Error("BitcoinAdapter:signMessage - connector is undefined");
        const signature = await connector.signMessage({
            message: params.message,
            address: params.address
        });
        return {
            signature: signature
        };
    }
    getWalletConnectProvider(params) {
        const walletConnectProvider = new (0, $b586f3a75b4ed631$export$1ba8e87dd8dcb162)({
            provider: params.provider,
            chains: params.caipNetworks,
            getActiveChain: ()=>(0, $gD0RX.ChainController).getCaipNetworkByNamespace(this.namespace)
        });
        return walletConnectProvider;
    }
    async disconnect(params) {
        if (params?.provider) await params.provider.disconnect();
        else if (this.connector) await this.connector.disconnect();
        this.unbindEvents();
    }
    async getBalance(params) {
        const caipNetwork = params.caipNetwork;
        const address = params.address;
        if (!address) return Promise.resolve({
            balance: "0.00",
            symbol: "BTC"
        });
        if (caipNetwork && caipNetwork.chainNamespace === this.namespace) {
            const caipAddress = `${caipNetwork?.caipNetworkId}:${address}`;
            const cachedPromise = this.balancePromises[caipAddress];
            if (cachedPromise) return cachedPromise;
            const cachedBalance = (0, $bc5dy.StorageUtil).getNativeBalanceCacheForCaipAddress(caipAddress);
            if (cachedBalance) return {
                balance: cachedBalance.balance,
                symbol: cachedBalance.symbol
            };
            this.balancePromises[caipAddress] = new Promise(async (resolve)=>{
                const utxos = await this.api.getUTXOs({
                    network: caipNetwork,
                    address: address
                });
                const balance = utxos.reduce((acc, utxo)=>acc + utxo.value, 0);
                const formattedBalance = (0, $c860462adfedbc0a$export$b521c3a58ad65432).parseSatoshis(balance.toString(), caipNetwork);
                (0, $bc5dy.StorageUtil).updateNativeBalanceCache({
                    caipAddress: caipAddress,
                    balance: formattedBalance,
                    symbol: caipNetwork.nativeCurrency.symbol,
                    timestamp: Date.now()
                });
                resolve({
                    balance: formattedBalance,
                    symbol: caipNetwork.nativeCurrency.symbol
                });
            }).finally(()=>{
                // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete this.balancePromises[caipAddress];
            });
            return this.balancePromises[caipAddress] || Promise.resolve({
                balance: "0.00",
                symbol: "BTC"
            });
        }
        // Get balance
        return Promise.resolve({
            balance: "0",
            symbol: (0, $bb01571ccd77b52d$export$794b04b0756618df).nativeCurrency.symbol
        });
    }
    async switchNetwork(params) {
        if (params.providerType === "WALLET_CONNECT" || params.providerType === "AUTH") return await super.switchNetwork(params);
        const connector = params.provider;
        if (!connector) throw new Error("BitcoinAdapter:switchNetwork - provider is undefined");
        return await connector.switchNetwork(params.caipNetwork.caipNetworkId);
    }
    // -- Unused => Refactor ------------------------------------------- //
    estimateGas(_params) {
        // Estimate gas
        return Promise.resolve({});
    }
    sendTransaction(_params) {
        // Send transaction
        return Promise.resolve({});
    }
    writeContract(_params) {
        // Write contract
        return Promise.resolve({});
    }
    parseUnits(_params) {
        // Parse units
        return BigInt(0);
    }
    formatUnits(_params) {
        // Format units
        return "";
    }
    grantPermissions(_params) {
        // Grant permissions
        return Promise.resolve({});
    }
    getCapabilities(_params) {
        // Revoke permissions
        return Promise.resolve({});
    }
    revokePermissions(_params) {
        // Get capabilities
        return Promise.resolve("0x");
    }
    async walletGetAssets(_params) {
        return Promise.resolve({});
    }
    // -- Private ------------------------------------------ //
    bindEvents(connector) {
        this.unbindEvents();
        const accountsChanged = (data)=>{
            const [newAccount] = data;
            if (newAccount) this.emit("accountChanged", {
                address: newAccount
            });
        };
        connector.on("accountsChanged", accountsChanged);
        this.eventsToUnbind.push(()=>connector.removeListener("accountsChanged", accountsChanged));
        const chainChanged = async (data)=>{
            const address = await this.connect({
                id: connector.id,
                chainId: data,
                type: ""
            });
            this.emit("switchNetwork", {
                chainId: data,
                address: address.address
            });
        };
        connector.on("chainChanged", chainChanged);
        this.eventsToUnbind.push(()=>connector.removeListener("chainChanged", chainChanged));
        const disconnect = ()=>{
            this.emit("disconnect");
        };
        connector.on("disconnect", disconnect);
        this.eventsToUnbind.push(()=>connector.removeListener("disconnect", disconnect));
    }
    unbindEvents() {
        this.eventsToUnbind.forEach((unsubscribe)=>unsubscribe());
        this.eventsToUnbind = [];
    }
    setUniversalProvider(universalProvider) {
        this.addConnector(new (0, $b586f3a75b4ed631$export$1ba8e87dd8dcb162)({
            provider: universalProvider,
            chains: this.getCaipNetworks(),
            getActiveChain: ()=>(0, $gD0RX.ChainController).getCaipNetworkByNamespace(this.namespace)
        }));
    }
}


// 0. Setup queryClient
const $8f386341ec2e7333$var$queryClient = new (0, $8bb63d02ffa217e6$export$405d0624ed55a03f)();
// 1. Get projectId from https://cloud.reown.com
const $8f386341ec2e7333$var$projectId = "c2cb8c9de6bd983bac3bd2073de2ebc7";
// 2. Create a metadata object - optional
const $8f386341ec2e7333$var$metadata = {
    name: "Ospree",
    description: "Ospree Verification",
    url: "http://localhost:3000",
    icons: [
        "https://avatars.githubusercontent.com/u/179229932"
    ]
};
// 3. Set the networks
const $8f386341ec2e7333$var$networks = [
    (0, $4e7083cdb1b68451$export$536d3e0d2c7baf54),
    (0, $17af278e83b94a22$export$625cf84d855940d4),
    (0, $f1509a8399dc02d3$export$ee6400bf8f8c2a0d),
    (0, $bb01571ccd77b52d$export$794b04b0756618df)
];
// 4. Create Wagmi Adapter
const $8f386341ec2e7333$var$wagmiAdapter = new (0, $fb0395c945bfeac2$export$fd2ede79ce4f0b54)({
    networks: $8f386341ec2e7333$var$networks,
    projectId: $8f386341ec2e7333$var$projectId,
    ssr: true
});
const $8f386341ec2e7333$var$solanaAdapter = new (0, $8c7193b741506980$export$5773b6c43b66f81f)({
    projectId: $8f386341ec2e7333$var$projectId,
    ssr: true
});
const $8f386341ec2e7333$var$bitcoinAdapter = new (0, $45477d631d686b01$export$1967d54504ca1913)({
    projectId: $8f386341ec2e7333$var$projectId,
    ssr: true
});
// 5. Create modal
(0, $43581e8bfc4231fd$export$805fba51c5f25785)({
    adapters: [
        $8f386341ec2e7333$var$wagmiAdapter,
        $8f386341ec2e7333$var$solanaAdapter,
        $8f386341ec2e7333$var$bitcoinAdapter
    ],
    networks: $8f386341ec2e7333$var$networks,
    projectId: $8f386341ec2e7333$var$projectId,
    metadata: $8f386341ec2e7333$var$metadata,
    features: {
        analytics: true,
        email: false,
        socials: [],
        emailShowWallets: false
    },
    themeVariables: {
        "--w3m-font-family": "OpenSans",
        "--w3m-accent": "#00CACD",
        "--w3m-color-mix": "#3c4351",
        "--w3m-border-radius-master": "3px"
    }
});
function $8f386341ec2e7333$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $682f018675332343$export$a28463dc600bc9f8), {
        config: $8f386341ec2e7333$var$wagmiAdapter.wagmiConfig,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $adea362784545879$export$45604f0cc8ae667b), {
            client: $8f386341ec2e7333$var$queryClient,
            children: children
        })
    });
}


/* eslint-disable wrap-iife */ /* eslint-disable prefer-rest-params */ /* eslint-disable no-extra-semi */ /* eslint-disable func-names */ /* eslint-disable no-underscore-dangle */ /* eslint-disable prefer-destructuring */ 

var $tZqWC = parcelRequire("tZqWC");

var $1gxF5 = parcelRequire("1gxF5");

var $tZqWC = parcelRequire("tZqWC");


var $j1NUG = parcelRequire("j1NUG");
function $d8d4e3a3233599a5$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $d8d4e3a3233599a5$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $d8d4e3a3233599a5$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $d8d4e3a3233599a5$var$isAbsolute(to);
    var isFromAbs = from && $d8d4e3a3233599a5$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $d8d4e3a3233599a5$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $d8d4e3a3233599a5$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $d8d4e3a3233599a5$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $d8d4e3a3233599a5$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$d8d4e3a3233599a5$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $d8d4e3a3233599a5$export$2e2bcd8739ae039 = $d8d4e3a3233599a5$var$resolvePathname;


function $64e65a4a41a6b92b$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $64e65a4a41a6b92b$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $64e65a4a41a6b92b$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $64e65a4a41a6b92b$var$valueOf(a);
        var bValue = $64e65a4a41a6b92b$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $64e65a4a41a6b92b$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $64e65a4a41a6b92b$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $64e65a4a41a6b92b$export$2e2bcd8739ae039 = $64e65a4a41a6b92b$var$valueEqual;



var $8097209926f5b57c$var$isProduction = true;
var $8097209926f5b57c$var$prefix = "Invariant failed";
function $8097209926f5b57c$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($8097209926f5b57c$var$isProduction) throw new Error($8097209926f5b57c$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? $8097209926f5b57c$var$prefix + ": " + provided : $8097209926f5b57c$var$prefix;
    throw new Error(value);
}


function $de6afe589b6eae99$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $de6afe589b6eae99$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $de6afe589b6eae99$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $de6afe589b6eae99$var$stripBasename(path, prefix) {
    return $de6afe589b6eae99$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $de6afe589b6eae99$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $de6afe589b6eae99$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $de6afe589b6eae99$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $de6afe589b6eae99$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $de6afe589b6eae99$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $j1NUG.default)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $d8d4e3a3233599a5$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $de6afe589b6eae99$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $64e65a4a41a6b92b$export$2e2bcd8739ae039)(a.state, b.state);
}
function $de6afe589b6eae99$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $de6afe589b6eae99$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $de6afe589b6eae99$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $de6afe589b6eae99$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $de6afe589b6eae99$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $de6afe589b6eae99$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $de6afe589b6eae99$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $de6afe589b6eae99$var$PopStateEvent = "popstate";
var $de6afe589b6eae99$var$HashChangeEvent = "hashchange";
function $de6afe589b6eae99$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $de6afe589b6eae99$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$de6afe589b6eae99$var$canUseDOM && (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $de6afe589b6eae99$var$supportsHistory();
    var needsHashChangeListener = !$de6afe589b6eae99$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $de6afe589b6eae99$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $de6afe589b6eae99$var$stripTrailingSlash($de6afe589b6eae99$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $de6afe589b6eae99$var$stripBasename(path, basename);
        return $de6afe589b6eae99$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $de6afe589b6eae99$var$createTransitionManager();
    function setState(nextState) {
        (0, $j1NUG.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($de6afe589b6eae99$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($de6afe589b6eae99$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($de6afe589b6eae99$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $de6afe589b6eae99$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $de6afe589b6eae99$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $de6afe589b6eae99$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($de6afe589b6eae99$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($de6afe589b6eae99$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($de6afe589b6eae99$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($de6afe589b6eae99$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $de6afe589b6eae99$var$HashChangeEvent$1 = "hashchange";
var $de6afe589b6eae99$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $de6afe589b6eae99$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $de6afe589b6eae99$var$stripLeadingSlash,
        decodePath: $de6afe589b6eae99$var$addLeadingSlash
    },
    slash: {
        encodePath: $de6afe589b6eae99$var$addLeadingSlash,
        decodePath: $de6afe589b6eae99$var$addLeadingSlash
    }
};
function $de6afe589b6eae99$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $de6afe589b6eae99$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $de6afe589b6eae99$var$pushHashPath(path) {
    window.location.hash = path;
}
function $de6afe589b6eae99$var$replaceHashPath(path) {
    window.location.replace($de6afe589b6eae99$var$stripHash(window.location.href) + "#" + path);
}
function $de6afe589b6eae99$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$de6afe589b6eae99$var$canUseDOM && (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $de6afe589b6eae99$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $de6afe589b6eae99$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $de6afe589b6eae99$var$stripTrailingSlash($de6afe589b6eae99$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $de6afe589b6eae99$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($de6afe589b6eae99$var$getHashPath());
        if (basename) path = $de6afe589b6eae99$var$stripBasename(path, basename);
        return $de6afe589b6eae99$export$90c043f1c57770b8(path);
    }
    var transitionManager = $de6afe589b6eae99$var$createTransitionManager();
    function setState(nextState) {
        (0, $j1NUG.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $de6afe589b6eae99$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $de6afe589b6eae99$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $de6afe589b6eae99$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($de6afe589b6eae99$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($de6afe589b6eae99$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $de6afe589b6eae99$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $de6afe589b6eae99$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $de6afe589b6eae99$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $de6afe589b6eae99$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $de6afe589b6eae99$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $de6afe589b6eae99$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $de6afe589b6eae99$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $de6afe589b6eae99$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $de6afe589b6eae99$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($de6afe589b6eae99$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $de6afe589b6eae99$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $de6afe589b6eae99$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $de6afe589b6eae99$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $de6afe589b6eae99$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($de6afe589b6eae99$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($de6afe589b6eae99$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($de6afe589b6eae99$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $de6afe589b6eae99$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $de6afe589b6eae99$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $de6afe589b6eae99$var$createTransitionManager();
    function setState(nextState) {
        (0, $j1NUG.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $de6afe589b6eae99$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $de6afe589b6eae99$export$90c043f1c57770b8(entry, undefined, createKey()) : $de6afe589b6eae99$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $de6afe589b6eae99$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $de6afe589b6eae99$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $de6afe589b6eae99$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $de6afe589b6eae99$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}




var $tZqWC = parcelRequire("tZqWC");

var $1gxF5 = parcelRequire("1gxF5");

var $4L3zM = parcelRequire("4L3zM");

var $5655354bf4d09baf$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $5655354bf4d09baf$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {};
function $5655354bf4d09baf$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $5655354bf4d09baf$var$commonjsGlobal[key] = ($5655354bf4d09baf$var$commonjsGlobal[key] || 0) + 1;
}
function $5655354bf4d09baf$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $5655354bf4d09baf$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $5655354bf4d09baf$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $5655354bf4d09baf$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $5655354bf4d09baf$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_Component) {
        (0, $1gxF5.default)(Provider, _Component);
        function Provider() {
            var _this;
            _this = _Component.apply(this, arguments) || this;
            _this.emitter = $5655354bf4d09baf$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($5655354bf4d09baf$var$objectIs(oldValue, newValue)) changedBits = 0;
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $5655354bf4d09baf$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, $tZqWC.Component));
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_Component2) {
        (0, $1gxF5.default)(Consumer, _Component2);
        function Consumer() {
            var _this2;
            _this2 = _Component2.apply(this, arguments) || this;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $5655354bf4d09baf$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $5655354bf4d09baf$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $5655354bf4d09baf$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, $tZqWC.Component));
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
var $5655354bf4d09baf$var$index = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext || $5655354bf4d09baf$var$createReactContext;
var $5655354bf4d09baf$export$2e2bcd8739ae039 = $5655354bf4d09baf$var$index;




var $j1NUG = parcelRequire("j1NUG");
var $869213495fe808a0$exports = {};
var $cb345c743a3f81aa$exports = {};
$cb345c743a3f81aa$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};


/**
 * Expose `pathToRegexp`.
 */ $869213495fe808a0$exports = $869213495fe808a0$var$pathToRegexp;
$869213495fe808a0$exports.parse = $869213495fe808a0$var$parse;
$869213495fe808a0$exports.compile = $869213495fe808a0$var$compile;
$869213495fe808a0$exports.tokensToFunction = $869213495fe808a0$var$tokensToFunction;
$869213495fe808a0$exports.tokensToRegExp = $869213495fe808a0$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $869213495fe808a0$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $869213495fe808a0$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $869213495fe808a0$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $869213495fe808a0$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $869213495fe808a0$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $869213495fe808a0$var$compile(str, options) {
    return $869213495fe808a0$var$tokensToFunction($869213495fe808a0$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $869213495fe808a0$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $869213495fe808a0$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $869213495fe808a0$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $869213495fe808a0$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $869213495fe808a0$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($cb345c743a3f81aa$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $869213495fe808a0$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $869213495fe808a0$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $869213495fe808a0$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $869213495fe808a0$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $869213495fe808a0$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $869213495fe808a0$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $869213495fe808a0$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $869213495fe808a0$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($869213495fe808a0$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $869213495fe808a0$var$flags(options));
    return $869213495fe808a0$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $869213495fe808a0$var$stringToRegexp(path, keys, options) {
    return $869213495fe808a0$var$tokensToRegExp($869213495fe808a0$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $869213495fe808a0$var$tokensToRegExp(tokens, keys, options) {
    if (!$cb345c743a3f81aa$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $869213495fe808a0$var$escapeString(token);
        else {
            var prefix = $869213495fe808a0$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $869213495fe808a0$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $869213495fe808a0$var$attachKeys(new RegExp("^" + route, $869213495fe808a0$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $869213495fe808a0$var$pathToRegexp(path, keys, options) {
    if (!$cb345c743a3f81aa$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $869213495fe808a0$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($cb345c743a3f81aa$exports(path)) return $869213495fe808a0$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $869213495fe808a0$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $847dee34c05b51aa$exports = {};
"use strict";

$847dee34c05b51aa$exports = (parcelRequire("nNv0y"));



var $cGhSa = parcelRequire("cGhSa");

var $7g5pF = parcelRequire("7g5pF");
// TODO: Replace with React.createContext once we can assume React 16+
var $a0d5c3f2fe524011$var$createNamedContext = function createNamedContext(name) {
    var context = (0, $5655354bf4d09baf$export$2e2bcd8739ae039)();
    context.displayName = name;
    return context;
};
var $a0d5c3f2fe524011$export$c213558b66925821 = /*#__PURE__*/ $a0d5c3f2fe524011$var$createNamedContext("Router-History");
// TODO: Replace with React.createContext once we can assume React 16+
var $a0d5c3f2fe524011$var$createNamedContext$1 = function createNamedContext(name) {
    var context = (0, $5655354bf4d09baf$export$2e2bcd8739ae039)();
    context.displayName = name;
    return context;
};
var $a0d5c3f2fe524011$export$63baa8ccbe60bb07 = /*#__PURE__*/ $a0d5c3f2fe524011$var$createNamedContext$1("Router");
/**
 * The public API for putting history on context.
 */ var $a0d5c3f2fe524011$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $1gxF5.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            if (_this._isMounted) _this.setState({
                location: location
            });
            else _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) this.unlisten();
    };
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $a0d5c3f2fe524011$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $1gxF5.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $de6afe589b6eae99$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component);
var $a0d5c3f2fe524011$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $1gxF5.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $a0d5c3f2fe524011$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $a0d5c3f2fe524011$var$messageType;
var $a0d5c3f2fe524011$var$cache = {};
var $a0d5c3f2fe524011$var$cacheLimit = 10000;
var $a0d5c3f2fe524011$var$cacheCount = 0;
function $a0d5c3f2fe524011$var$compilePath(path) {
    if ($a0d5c3f2fe524011$var$cache[path]) return $a0d5c3f2fe524011$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($869213495fe808a0$exports))).compile(path);
    if ($a0d5c3f2fe524011$var$cacheCount < $a0d5c3f2fe524011$var$cacheLimit) {
        $a0d5c3f2fe524011$var$cache[path] = generator;
        $a0d5c3f2fe524011$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $a0d5c3f2fe524011$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $a0d5c3f2fe524011$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $a0d5c3f2fe524011$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $de6afe589b6eae99$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $a0d5c3f2fe524011$export$82476f982757e71e(to, computedMatch.params) : (0, $j1NUG.default)({}, to, {
            pathname: $a0d5c3f2fe524011$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $de6afe589b6eae99$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $de6afe589b6eae99$export$c3e8bb440bd55b18)(prevLocation, (0, $j1NUG.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $a0d5c3f2fe524011$var$cache$1 = {};
var $a0d5c3f2fe524011$var$cacheLimit$1 = 10000;
var $a0d5c3f2fe524011$var$cacheCount$1 = 0;
function $a0d5c3f2fe524011$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $a0d5c3f2fe524011$var$cache$1[cacheKey] || ($a0d5c3f2fe524011$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($869213495fe808a0$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($a0d5c3f2fe524011$var$cacheCount$1 < $a0d5c3f2fe524011$var$cacheLimit$1) {
        pathCache[path] = result;
        $a0d5c3f2fe524011$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $a0d5c3f2fe524011$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $a0d5c3f2fe524011$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $a0d5c3f2fe524011$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Children.count(children) === 0;
}
function $a0d5c3f2fe524011$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $a0d5c3f2fe524011$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $1gxF5.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $a0d5c3f2fe524011$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $j1NUG.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && children.length === 0) children = null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component);
function $a0d5c3f2fe524011$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $a0d5c3f2fe524011$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $j1NUG.default)({}, location, {
        pathname: $a0d5c3f2fe524011$var$addLeadingSlash(basename) + location.pathname
    });
}
function $a0d5c3f2fe524011$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $a0d5c3f2fe524011$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $j1NUG.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $a0d5c3f2fe524011$var$createURL(location) {
    return typeof location === "string" ? location : (0, $de6afe589b6eae99$export$fe53371bee54353d)(location);
}
function $a0d5c3f2fe524011$var$staticHandler(methodName) {
    return function() {
        (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
    };
}
function $a0d5c3f2fe524011$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $a0d5c3f2fe524011$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $1gxF5.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $a0d5c3f2fe524011$var$noop;
        };
        _this.handleBlock = function() {
            return $a0d5c3f2fe524011$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $a0d5c3f2fe524011$var$addBasename(basename, (0, $de6afe589b6eae99$export$90c043f1c57770b8)(location));
        context.url = $a0d5c3f2fe524011$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $cGhSa.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $a0d5c3f2fe524011$var$addLeadingSlash(basename + $a0d5c3f2fe524011$var$createURL(path));
            },
            action: "POP",
            location: $a0d5c3f2fe524011$var$stripBasename(basename, (0, $de6afe589b6eae99$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $a0d5c3f2fe524011$var$staticHandler("go"),
            goBack: $a0d5c3f2fe524011$var$staticHandler("goBack"),
            goForward: $a0d5c3f2fe524011$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$55185c17a0fcbe46, (0, $j1NUG.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $a0d5c3f2fe524011$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $1gxF5.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Children.forEach(_this.props.children, function(child) {
                if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $a0d5c3f2fe524011$export$81336c211d5ff295(location.pathname, (0, $j1NUG.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $a0d5c3f2fe524011$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $cGhSa.default)(props, [
            "wrappedComponentRef"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
            return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Component, (0, $j1NUG.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7g5pF)))(C, Component);
}
var $a0d5c3f2fe524011$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useContext;
function $a0d5c3f2fe524011$export$3420e1dc2c4a518c() {
    return $a0d5c3f2fe524011$var$useContext($a0d5c3f2fe524011$export$c213558b66925821);
}
function $a0d5c3f2fe524011$export$45d76561a5302f2b() {
    return $a0d5c3f2fe524011$var$useContext($a0d5c3f2fe524011$export$63baa8ccbe60bb07).location;
}
function $a0d5c3f2fe524011$export$99eaa27ddbbb95ef() {
    var match = $a0d5c3f2fe524011$var$useContext($a0d5c3f2fe524011$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $a0d5c3f2fe524011$export$632be4bb944c1bc7(path) {
    var location = $a0d5c3f2fe524011$export$45d76561a5302f2b();
    var match = $a0d5c3f2fe524011$var$useContext($a0d5c3f2fe524011$export$63baa8ccbe60bb07).match;
    return path ? $a0d5c3f2fe524011$export$81336c211d5ff295(location.pathname, path) : match;
}
var $a0d5c3f2fe524011$var$global, $a0d5c3f2fe524011$var$key, $a0d5c3f2fe524011$var$buildNames, $a0d5c3f2fe524011$var$initialBuildName, $a0d5c3f2fe524011$var$secondaryBuildName;



var $1gxF5 = parcelRequire("1gxF5");

var $tZqWC = parcelRequire("tZqWC");




var $j1NUG = parcelRequire("j1NUG");

var $cGhSa = parcelRequire("cGhSa");

/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $12b33660068e86aa$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $1gxF5.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $de6afe589b6eae99$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement((0, $a0d5c3f2fe524011$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $12b33660068e86aa$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $1gxF5.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $de6afe589b6eae99$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement((0, $a0d5c3f2fe524011$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component);
var $12b33660068e86aa$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $12b33660068e86aa$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $de6afe589b6eae99$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $12b33660068e86aa$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $12b33660068e86aa$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).forwardRef;
if (typeof $12b33660068e86aa$var$forwardRef === "undefined") $12b33660068e86aa$var$forwardRef = $12b33660068e86aa$var$forwardRefShim;
function $12b33660068e86aa$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $12b33660068e86aa$var$LinkAnchor = $12b33660068e86aa$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $cGhSa.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $j1NUG.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$12b33660068e86aa$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($12b33660068e86aa$var$forwardRefShim !== $12b33660068e86aa$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $12b33660068e86aa$export$a6c7ac8248d6e38a = $12b33660068e86aa$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $12b33660068e86aa$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $cGhSa.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement((0, $a0d5c3f2fe524011$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $12b33660068e86aa$var$normalizeToLocation($12b33660068e86aa$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $j1NUG.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $12b33660068e86aa$var$resolveToLocation(to, context.location);
                var method = replace ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($12b33660068e86aa$var$forwardRefShim !== $12b33660068e86aa$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(component, props);
    });
});
var $12b33660068e86aa$var$toType, $12b33660068e86aa$var$refType;
var $12b33660068e86aa$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $12b33660068e86aa$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).forwardRef;
if (typeof $12b33660068e86aa$var$forwardRef$1 === "undefined") $12b33660068e86aa$var$forwardRef$1 = $12b33660068e86aa$var$forwardRefShim$1;
function $12b33660068e86aa$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $12b33660068e86aa$export$b0d92dbee9b5b60d = $12b33660068e86aa$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $cGhSa.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement((0, $a0d5c3f2fe524011$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $12b33660068e86aa$var$normalizeToLocation($12b33660068e86aa$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $a0d5c3f2fe524011$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = isActive ? $12b33660068e86aa$var$joinClassnames(classNameProp, activeClassName) : classNameProp;
        var style = isActive ? (0, $j1NUG.default)({}, styleProp, {}, activeStyle) : styleProp;
        var props = (0, $j1NUG.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($12b33660068e86aa$var$forwardRefShim$1 !== $12b33660068e86aa$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($12b33660068e86aa$export$a6c7ac8248d6e38a, props);
    });
});
var $12b33660068e86aa$var$ariaCurrentType;



// Route Components
// Auth/Accounts Pages


var $tZqWC = parcelRequire("tZqWC");

/* eslint-disable max-len */ // Common

parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $be1298c1561b3bf4$export$6cd5d5c1dae69a36 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  height: 100%;
  min-height: 100vh;

  padding: 50px 0 0 100px;
  overflow-x: hidden;
  background-color: ${({ theme: theme })=>theme.colors.lightGray};
`;


function $6089f7d2f7406f87$var$App(props) {
    // Destructure
    const { children: children } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $be1298c1561b3bf4$export$6cd5d5c1dae69a36), {
        children: children
    });
}
// Default Props
$6089f7d2f7406f87$var$App.defaultProps = {
    children: ""
};
// Proptypes Validation
$6089f7d2f7406f87$var$App.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $6089f7d2f7406f87$export$2e2bcd8739ae039 = $6089f7d2f7406f87$var$App;


var $7873b6261a2b1051$export$2e2bcd8739ae039 = (0, $6089f7d2f7406f87$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $6cfe515b8fe4ba1c$export$6ce170286acaa8d3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 0px 0px 0px 0px;
  width: 100%;
  height: 100%;
  background-color: ${({ theme: theme })=>theme.colors.lightGray};
`;


function $db2e79bc686da229$var$Content(props) {
    // Destructure
    const { children: children } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6cfe515b8fe4ba1c$export$6ce170286acaa8d3), {
        children: children
    });
}
// Default Props
$db2e79bc686da229$var$Content.defaultProps = {
    children: ""
};
// Proptypes Validation
$db2e79bc686da229$var$Content.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $db2e79bc686da229$export$2e2bcd8739ae039 = $db2e79bc686da229$var$Content;


var $b27722fc7d4f5ccf$export$2e2bcd8739ae039 = (0, $db2e79bc686da229$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $5fc1bdce12551c00$export$6eaa4d78e3725d73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 5px 0 15px 15px;
`;
const $5fc1bdce12551c00$export$900eb51494311d89 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).ul`
  display: flex;
  padding: 0;
  margin: 0;
  gap: 30px;
  list-style: none;
`;
const $5fc1bdce12551c00$export$252f28a9c2dbb35d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).li`
  display: flex;
  justify-content: flex-start;
  padding: 0px;
  margin: 0;

  &:first-child {
    justify-content: flex-end;
  }
`;
const $5fc1bdce12551c00$export$874959254c7a97f4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: block;
  padding: 0 0 8px 0;
  margin: 0px;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;

  // TODO: Use theme mixins
  &.active {
    font-weight: 700;
  }

  &.active,
  &:hover {
    color: ${({ theme: theme })=>theme.colors.blue};

    &:before {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: ${({ theme: theme })=>theme.colors.blue};
    }
  }

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;


function $c8d088047409ad6e$var$AddressDetailsSubHeader(props) {
    // Hooks
    const { page: page, setPage: setPage } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5fc1bdce12551c00$export$6eaa4d78e3725d73), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5fc1bdce12551c00$export$900eb51494311d89), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5fc1bdce12551c00$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5fc1bdce12551c00$export$874959254c7a97f4), {
                        className: page === 0 && "active",
                        onClick: ()=>{
                            setPage(0);
                        },
                        children: "Summary"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5fc1bdce12551c00$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5fc1bdce12551c00$export$874959254c7a97f4), {
                        className: page === 1 && "active",
                        onClick: ()=>{
                            setPage(1);
                        },
                        children: "Linkage"
                    })
                })
            ]
        })
    });
}
// Default Props
$c8d088047409ad6e$var$AddressDetailsSubHeader.defaultProps = {
    page: 0,
    setPage: ()=>{}
};
// Proptypes Validation
$c8d088047409ad6e$var$AddressDetailsSubHeader.propTypes = {
    page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    setPage: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $c8d088047409ad6e$export$2e2bcd8739ae039 = $c8d088047409ad6e$var$AddressDetailsSubHeader;


var $b34cad56374d5647$export$2e2bcd8739ae039 = (0, $c8d088047409ad6e$export$2e2bcd8739ae039);



parcelRequire("tZqWC");
// Common

parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $a1d1bb5849939e9b$export$1312e4658e616d9d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 24px 24px 24px;
  max-width: 1440px;
`;


function $3f5354c803b4cbf9$var$Container(props) {
    // Destructure
    const { children: children } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a1d1bb5849939e9b$export$1312e4658e616d9d), {
        children: children
    });
}
// Default Props
$3f5354c803b4cbf9$var$Container.defaultProps = {
    children: ""
};
// Proptypes Validation
$3f5354c803b4cbf9$var$Container.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $3f5354c803b4cbf9$export$2e2bcd8739ae039 = $3f5354c803b4cbf9$var$Container;


var $d9a5995c1b70ae93$export$2e2bcd8739ae039 = (0, $3f5354c803b4cbf9$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $160bf94c41225418$export$4a6e9fd3dfec8158 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0 auto;
  padding: 0px 20px;
`;


function $c3dcb4cae378007b$var$ContainerFluid(props) {
    // Destructure
    const { children: children } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $160bf94c41225418$export$4a6e9fd3dfec8158), {
        children: children
    });
}
// Default Props
$c3dcb4cae378007b$var$ContainerFluid.defaultProps = {
    children: ""
};
// Proptypes Validation
$c3dcb4cae378007b$var$ContainerFluid.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $c3dcb4cae378007b$export$2e2bcd8739ae039 = $c3dcb4cae378007b$var$ContainerFluid;


var $57ef4024e9f043d0$export$2e2bcd8739ae039 = (0, $c3dcb4cae378007b$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $d49bca50a279c44c$export$75f07c36086c2c81 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).img`
  width: 100%;
  height: 100%;

  font-weight: inherit;
  font-size: inherit;

  // Conditional Props
  ${({ width: width })=>width && `width:${width}px;`}
  ${({ height: height })=>height && `height:${height}px;`}
`;


function $c135de98a880dc0a$var$Image(props) {
    // Destructure
    const { src: src, alt: alt, width: width, height: height, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d49bca50a279c44c$export$75f07c36086c2c81), {
        src: src,
        alt: alt,
        width: width,
        height: height,
        ...rest
    });
}
// Default Props
$c135de98a880dc0a$var$Image.defaultProps = {
    src: null,
    alt: "",
    width: "",
    height: ""
};
// Proptypes Validation
$c135de98a880dc0a$var$Image.propTypes = {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    alt: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    ])
};
var $c135de98a880dc0a$export$2e2bcd8739ae039 = $c135de98a880dc0a$var$Image;


var $65f0d7ff3fd922b2$export$2e2bcd8739ae039 = (0, $c135de98a880dc0a$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $90d8a7fe28bd27db$export$e620df7ec292c807 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  width: fit-content;
  color: ${({ theme: theme })=>theme.colors.darkGray} !important;
  font-size: 14px;
  border-radius: 10px;
  background-color: ${({ theme: theme })=>`${theme.colors.white}`};
`;
const $90d8a7fe28bd27db$export$9456d3a121d4b39 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  padding: 4px;
  border-radius: 10px;
  background-color: ${({ theme: theme })=>`${theme.colors.gray}20`};
`;
const $90d8a7fe28bd27db$export$47d673d6549649b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $90d8a7fe28bd27db$export$6d702cd3660ac20b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 8px 24px;
  border-radius: 7px;
  font-weight: 600;
  cursor: pointer;
  &.active {
    background-color: ${({ theme: theme })=>theme.colors.lightGray};
    color: ${({ theme: theme })=>theme.colors.blue};
  }
`;


function $6615b71bf0a9dcf3$var$Tabs(props) {
    // Destructure
    const { page: page, setPage: setPage, pages: pages } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $90d8a7fe28bd27db$export$e620df7ec292c807), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $90d8a7fe28bd27db$export$9456d3a121d4b39), {
            children: pages && pages?.map((item)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $90d8a7fe28bd27db$export$47d673d6549649b6), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $90d8a7fe28bd27db$export$6d702cd3660ac20b), {
                        className: page === item.value && "active",
                        onClick: ()=>{
                            setPage(item.value);
                        },
                        children: item.label
                    })
                }, item.value))
        })
    });
}
// Default Props
$6615b71bf0a9dcf3$var$Tabs.defaultProps = {
    page: "",
    setPage: ()=>{},
    pages: []
};
// Proptypes Validation
$6615b71bf0a9dcf3$var$Tabs.propTypes = {
    page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    setPage: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    pages: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }))
};
var $6615b71bf0a9dcf3$export$2e2bcd8739ae039 = $6615b71bf0a9dcf3$var$Tabs;


var $9943dd893d8bba32$export$2e2bcd8739ae039 = (0, $6615b71bf0a9dcf3$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $9A5xi = parcelRequire("9A5xi");

var $tZqWC = parcelRequire("tZqWC");
var $cb0b0dd810051858$export$3dbd3405086fec7b = $tZqWC.createContext();
var $cb0b0dd810051858$export$cbabb21c2529b130 = $tZqWC.createContext();
function $cb0b0dd810051858$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $tZqWC.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $tZqWC.useRef(false);
    $tZqWC.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $tZqWC.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $tZqWC.createElement($cb0b0dd810051858$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $tZqWC.createElement($cb0b0dd810051858$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}


var $tZqWC = parcelRequire("tZqWC");


var $tZqWC = parcelRequire("tZqWC");
var $4e9f2a57def71fd7$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $4e9f2a57def71fd7$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $4e9f2a57def71fd7$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $4e9f2a57def71fd7$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $4e9f2a57def71fd7$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $4e9f2a57def71fd7$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $tZqWC.useLayoutEffect : $tZqWC.useEffect;



var $tZqWC = parcelRequire("tZqWC");
function $19558851baf82ab4$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $62a825b9d8440eac$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $19558851baf82ab4$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $62a825b9d8440eac$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $19558851baf82ab4$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $62a825b9d8440eac$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $19558851baf82ab4$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $0510bd601162f306$export$8960430cfd85939f = Math.max;
var $0510bd601162f306$export$96ec731ed4dcb222 = Math.min;
var $0510bd601162f306$export$2077e0241d6afd3c = Math.round;


function $71e70ee5b2f1455a$export$2e2bcd8739ae039(element, includeScale) {
    if (includeScale === void 0) includeScale = false;
    var rect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if ((0, $62a825b9d8440eac$export$1b3bfaa9684536aa)(element) && includeScale) {
        var offsetHeight = element.offsetHeight;
        var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
        // Fallback to 1 in case both values are `0`
        if (offsetWidth > 0) scaleX = (0, $0510bd601162f306$export$2077e0241d6afd3c)(rect.width) / offsetWidth || 1;
        if (offsetHeight > 0) scaleY = (0, $0510bd601162f306$export$2077e0241d6afd3c)(rect.height) / offsetHeight || 1;
    }
    return {
        width: rect.width / scaleX,
        height: rect.height / scaleY,
        top: rect.top / scaleY,
        right: rect.right / scaleX,
        bottom: rect.bottom / scaleY,
        left: rect.left / scaleX,
        x: rect.left / scaleX,
        y: rect.top / scaleY
    };
}



function $3d4585451f46269a$export$2e2bcd8739ae039(node) {
    var win = (0, $19558851baf82ab4$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $e637dffea3e8b391$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b85abc49f4c03759$export$2e2bcd8739ae039(node) {
    if (node === (0, $19558851baf82ab4$export$2e2bcd8739ae039)(node) || !(0, $62a825b9d8440eac$export$1b3bfaa9684536aa)(node)) return (0, $3d4585451f46269a$export$2e2bcd8739ae039)(node);
    else return (0, $e637dffea3e8b391$export$2e2bcd8739ae039)(node);
}


function $9cbcc184c3f3056c$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $a2be94d6ea0eec02$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $62a825b9d8440eac$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $883f6066d44b5e19$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $71e70ee5b2f1455a$export$2e2bcd8739ae039)((0, $a2be94d6ea0eec02$export$2e2bcd8739ae039)(element)).left + (0, $3d4585451f46269a$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $be9d0f85caf6074c$export$2e2bcd8739ae039(element) {
    return (0, $19558851baf82ab4$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $fa6487331acfd7d2$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $be9d0f85caf6074c$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $c9e4fabc2329005b$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $0510bd601162f306$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $0510bd601162f306$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $c9e4fabc2329005b$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $62a825b9d8440eac$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $62a825b9d8440eac$export$1b3bfaa9684536aa)(offsetParent) && $c9e4fabc2329005b$var$isElementScaled(offsetParent);
    var documentElement = (0, $a2be94d6ea0eec02$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $71e70ee5b2f1455a$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $9cbcc184c3f3056c$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $fa6487331acfd7d2$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b85abc49f4c03759$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $62a825b9d8440eac$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $71e70ee5b2f1455a$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $883f6066d44b5e19$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $98ad26331b621aef$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $71e70ee5b2f1455a$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $94c1bc6e29cde709$export$2e2bcd8739ae039(element) {
    if ((0, $9cbcc184c3f3056c$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $62a825b9d8440eac$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $a2be94d6ea0eec02$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $c792d1589f4f41e1$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $9cbcc184c3f3056c$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $62a825b9d8440eac$export$1b3bfaa9684536aa)(node) && (0, $fa6487331acfd7d2$export$2e2bcd8739ae039)(node)) return node;
    return $c792d1589f4f41e1$export$2e2bcd8739ae039((0, $94c1bc6e29cde709$export$2e2bcd8739ae039)(node));
}





function $a95d81430f4d1dea$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $c792d1589f4f41e1$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $19558851baf82ab4$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $fa6487331acfd7d2$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a95d81430f4d1dea$export$2e2bcd8739ae039((0, $94c1bc6e29cde709$export$2e2bcd8739ae039)(target)));
}







function $be9472a761285d2e$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $9cbcc184c3f3056c$export$2e2bcd8739ae039)(element)) >= 0;
}



function $9216a7baaf6cfa3d$var$getTrueOffsetParent(element) {
    if (!(0, $62a825b9d8440eac$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $be9d0f85caf6074c$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $9216a7baaf6cfa3d$var$getContainingBlock(element) {
    var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1;
    var isIE = navigator.userAgent.indexOf("Trident") !== -1;
    if (isIE && (0, $62a825b9d8440eac$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $be9d0f85caf6074c$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $94c1bc6e29cde709$export$2e2bcd8739ae039)(element);
    while((0, $62a825b9d8440eac$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $9cbcc184c3f3056c$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $be9d0f85caf6074c$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $9216a7baaf6cfa3d$export$2e2bcd8739ae039(element) {
    var window = (0, $19558851baf82ab4$export$2e2bcd8739ae039)(element);
    var offsetParent = $9216a7baaf6cfa3d$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $be9472a761285d2e$export$2e2bcd8739ae039)(offsetParent) && (0, $be9d0f85caf6074c$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $9216a7baaf6cfa3d$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $9cbcc184c3f3056c$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $9cbcc184c3f3056c$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $be9d0f85caf6074c$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $9216a7baaf6cfa3d$var$getContainingBlock(element) || window;
}



var $d059d5b7a8e05ae4$export$1e95b668f3b82d = "top";
var $d059d5b7a8e05ae4$export$40e543e69a8b3fbb = "bottom";
var $d059d5b7a8e05ae4$export$79ffe56a765070d2 = "right";
var $d059d5b7a8e05ae4$export$eabcd2c8791e7bf4 = "left";
var $d059d5b7a8e05ae4$export$dfb5619354ba860 = "auto";
var $d059d5b7a8e05ae4$export$aec2ce47c367b8c3 = [
    $d059d5b7a8e05ae4$export$1e95b668f3b82d,
    $d059d5b7a8e05ae4$export$40e543e69a8b3fbb,
    $d059d5b7a8e05ae4$export$79ffe56a765070d2,
    $d059d5b7a8e05ae4$export$eabcd2c8791e7bf4
];
var $d059d5b7a8e05ae4$export$b3571188c770cc5a = "start";
var $d059d5b7a8e05ae4$export$bd5df0f255a350f8 = "end";
var $d059d5b7a8e05ae4$export$390fd549c5303b4d = "clippingParents";
var $d059d5b7a8e05ae4$export$d7b7311ec04a3e8f = "viewport";
var $d059d5b7a8e05ae4$export$ae5ab1c730825774 = "popper";
var $d059d5b7a8e05ae4$export$ca50aac9f3ba507f = "reference";
var $d059d5b7a8e05ae4$export$368f9a87e87fa4e1 = /*#__PURE__*/ $d059d5b7a8e05ae4$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $d059d5b7a8e05ae4$export$b3571188c770cc5a,
        placement + "-" + $d059d5b7a8e05ae4$export$bd5df0f255a350f8
    ]);
}, []);
var $d059d5b7a8e05ae4$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($d059d5b7a8e05ae4$export$aec2ce47c367b8c3, [
    $d059d5b7a8e05ae4$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $d059d5b7a8e05ae4$export$b3571188c770cc5a,
        placement + "-" + $d059d5b7a8e05ae4$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $d059d5b7a8e05ae4$export$421679a7c3d56e = "beforeRead";
var $d059d5b7a8e05ae4$export$aafa59e2e03f2942 = "read";
var $d059d5b7a8e05ae4$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $d059d5b7a8e05ae4$export$c65e99957a05207c = "beforeMain";
var $d059d5b7a8e05ae4$export$f22da7240b7add18 = "main";
var $d059d5b7a8e05ae4$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $d059d5b7a8e05ae4$export$8d4d2d70e7d46032 = "beforeWrite";
var $d059d5b7a8e05ae4$export$68d8715fc104d294 = "write";
var $d059d5b7a8e05ae4$export$70a6e5159acce2e6 = "afterWrite";
var $d059d5b7a8e05ae4$export$d087d3878fdf71d5 = [
    $d059d5b7a8e05ae4$export$421679a7c3d56e,
    $d059d5b7a8e05ae4$export$aafa59e2e03f2942,
    $d059d5b7a8e05ae4$export$6964f6c886723980,
    $d059d5b7a8e05ae4$export$c65e99957a05207c,
    $d059d5b7a8e05ae4$export$f22da7240b7add18,
    $d059d5b7a8e05ae4$export$bab79516f2d662fe,
    $d059d5b7a8e05ae4$export$8d4d2d70e7d46032,
    $d059d5b7a8e05ae4$export$68d8715fc104d294,
    $d059d5b7a8e05ae4$export$70a6e5159acce2e6
];


function $bb64a405c041c549$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $bb64a405c041c549$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $bb64a405c041c549$var$order(modifiers); // order based on phase
    return (0, $d059d5b7a8e05ae4$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $bfaee90531160c4b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}





function $a33efd0ebcc8ba42$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}





var $6ae667d1a6c4ffb7$var$INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var $6ae667d1a6c4ffb7$var$INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var $6ae667d1a6c4ffb7$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $6ae667d1a6c4ffb7$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $6ae667d1a6c4ffb7$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $6ae667d1a6c4ffb7$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $6ae667d1a6c4ffb7$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $62a825b9d8440eac$export$45a5e7f76e0caa8d)(reference) ? (0, $a95d81430f4d1dea$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $a95d81430f4d1dea$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $a95d81430f4d1dea$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $bb64a405c041c549$export$2e2bcd8739ae039)((0, $a33efd0ebcc8ba42$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers, flipModifier, _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft;
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$6ae667d1a6c4ffb7$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $c9e4fabc2329005b$export$2e2bcd8739ae039)(reference, (0, $9216a7baaf6cfa3d$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $98ad26331b621aef$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $bfaee90531160c4b$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$6ae667d1a6c4ffb7$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $6ae667d1a6c4ffb7$export$8f7491d57c8f97a9 = /*#__PURE__*/ $6ae667d1a6c4ffb7$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $d772e4bf9016e4ad$var$passive = {
    passive: true
};
function $d772e4bf9016e4ad$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $19558851baf82ab4$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $d772e4bf9016e4ad$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $d772e4bf9016e4ad$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $d772e4bf9016e4ad$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $d772e4bf9016e4ad$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $d772e4bf9016e4ad$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $d772e4bf9016e4ad$var$effect,
    data: {}
};



function $c6aa8d16ac5c2fbd$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $1a1d765e805ddb4e$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $f9eebe532a23d407$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $b0216aa30e230595$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6aa8d16ac5c2fbd$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $1a1d765e805ddb4e$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $d059d5b7a8e05ae4$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $d059d5b7a8e05ae4$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $d059d5b7a8e05ae4$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $d059d5b7a8e05ae4$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $f9eebe532a23d407$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $d059d5b7a8e05ae4$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $d059d5b7a8e05ae4$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $830c0976e45b95ad$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $b0216aa30e230595$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $830c0976e45b95ad$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $830c0976e45b95ad$var$popperOffsets,
    data: {}
};










var $3b0d353c28f4a2c8$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $3b0d353c28f4a2c8$var$roundOffsetsByDPR(_ref) {
    var x = _ref.x, y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $0510bd601162f306$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $0510bd601162f306$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $3b0d353c28f4a2c8$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $d059d5b7a8e05ae4$export$eabcd2c8791e7bf4);
    var sideY = (0, $d059d5b7a8e05ae4$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $9216a7baaf6cfa3d$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $19558851baf82ab4$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $a2be94d6ea0eec02$export$2e2bcd8739ae039)(popper);
            if ((0, $be9d0f85caf6074c$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $d059d5b7a8e05ae4$export$1e95b668f3b82d) || (placement === (0, $d059d5b7a8e05ae4$export$eabcd2c8791e7bf4) || placement === (0, $d059d5b7a8e05ae4$export$79ffe56a765070d2)) && variation === (0, $d059d5b7a8e05ae4$export$bd5df0f255a350f8)) {
            sideY = (0, $d059d5b7a8e05ae4$export$40e543e69a8b3fbb);
            var offsetY = isFixed && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $d059d5b7a8e05ae4$export$eabcd2c8791e7bf4) || (placement === (0, $d059d5b7a8e05ae4$export$1e95b668f3b82d) || placement === (0, $d059d5b7a8e05ae4$export$40e543e69a8b3fbb)) && variation === (0, $d059d5b7a8e05ae4$export$bd5df0f255a350f8)) {
            sideX = (0, $d059d5b7a8e05ae4$export$79ffe56a765070d2);
            var offsetX = isFixed && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $3b0d353c28f4a2c8$var$unsetSides);
    var _ref4 = roundOffsets === true ? $3b0d353c28f4a2c8$var$roundOffsetsByDPR({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $3b0d353c28f4a2c8$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var transitionProperty;
    var commonStyles = {
        placement: (0, $c6aa8d16ac5c2fbd$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $1a1d765e805ddb4e$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $3b0d353c28f4a2c8$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $3b0d353c28f4a2c8$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3b0d353c28f4a2c8$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $3b0d353c28f4a2c8$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $7690a96c252d2599$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $62a825b9d8440eac$export$1b3bfaa9684536aa)(element) || !(0, $9cbcc184c3f3056c$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7690a96c252d2599$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $62a825b9d8440eac$export$1b3bfaa9684536aa)(element) || !(0, $9cbcc184c3f3056c$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7690a96c252d2599$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7690a96c252d2599$var$applyStyles,
    effect: $7690a96c252d2599$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $6e5541cad4162d43$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6aa8d16ac5c2fbd$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $d059d5b7a8e05ae4$export$eabcd2c8791e7bf4),
        (0, $d059d5b7a8e05ae4$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $d059d5b7a8e05ae4$export$eabcd2c8791e7bf4),
        (0, $d059d5b7a8e05ae4$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $6e5541cad4162d43$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $d059d5b7a8e05ae4$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $6e5541cad4162d43$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $6e5541cad4162d43$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $6e5541cad4162d43$var$offset
};


var $1b55de214b438ce7$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $1b55de214b438ce7$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $1b55de214b438ce7$var$hash[matched];
    });
}



var $9b0ca5883ce01f94$var$hash = {
    start: "end",
    end: "start"
};
function $9b0ca5883ce01f94$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $9b0ca5883ce01f94$var$hash[matched];
    });
}






function $c8dea68a511c1bce$export$2e2bcd8739ae039(element) {
    var win = (0, $19558851baf82ab4$export$2e2bcd8739ae039)(element);
    var html = (0, $a2be94d6ea0eec02$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
    // can be obscured underneath it.
    // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
    // if it isn't open, so if this isn't available, the popper will be detected
    // to overflow the bottom of the screen too early.
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
        // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
        // errors due to floating point numbers, so we need to check precision.
        // Safari returns a number <= 0, usually < -1 when pinch-zoomed
        // Feature detection fails in mobile emulation mode in Chrome.
        // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
        // 0.001
        // Fallback here: "Not Safari" userAgent
        if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $883f6066d44b5e19$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $1beb1f23877dbc8f$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $a2be94d6ea0eec02$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $3d4585451f46269a$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $0510bd601162f306$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $0510bd601162f306$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $883f6066d44b5e19$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $be9d0f85caf6074c$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $0510bd601162f306$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $fb4362bee364d6aa$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $62a825b9d8440eac$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $71f001960e2859da$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $5f4a107a2486b487$var$getInnerBoundingClientRect(element) {
    var rect = (0, $71e70ee5b2f1455a$export$2e2bcd8739ae039)(element);
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $5f4a107a2486b487$var$getClientRectFromMixedType(element, clippingParent) {
    return clippingParent === (0, $d059d5b7a8e05ae4$export$d7b7311ec04a3e8f) ? (0, $71f001960e2859da$export$2e2bcd8739ae039)((0, $c8dea68a511c1bce$export$2e2bcd8739ae039)(element)) : (0, $62a825b9d8440eac$export$45a5e7f76e0caa8d)(clippingParent) ? $5f4a107a2486b487$var$getInnerBoundingClientRect(clippingParent) : (0, $71f001960e2859da$export$2e2bcd8739ae039)((0, $1beb1f23877dbc8f$export$2e2bcd8739ae039)((0, $a2be94d6ea0eec02$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $5f4a107a2486b487$var$getClippingParents(element) {
    var clippingParents = (0, $a95d81430f4d1dea$export$2e2bcd8739ae039)((0, $94c1bc6e29cde709$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $be9d0f85caf6074c$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $62a825b9d8440eac$export$1b3bfaa9684536aa)(element) ? (0, $9216a7baaf6cfa3d$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $62a825b9d8440eac$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $62a825b9d8440eac$export$45a5e7f76e0caa8d)(clippingParent) && (0, $fb4362bee364d6aa$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $9cbcc184c3f3056c$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $5f4a107a2486b487$export$2e2bcd8739ae039(element, boundary, rootBoundary) {
    var mainClippingParents = boundary === "clippingParents" ? $5f4a107a2486b487$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $5f4a107a2486b487$var$getClientRectFromMixedType(element, clippingParent);
        accRect.top = (0, $0510bd601162f306$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $0510bd601162f306$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $0510bd601162f306$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $0510bd601162f306$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $5f4a107a2486b487$var$getClientRectFromMixedType(element, firstClippingParent));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $3083399bffc75062$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $bf3855cd6a8fdf7b$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $3083399bffc75062$export$2e2bcd8739ae039)(), paddingObject);
}


function $cdcce288e11f34ec$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $041f1f212e95a561$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $d059d5b7a8e05ae4$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $d059d5b7a8e05ae4$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $d059d5b7a8e05ae4$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $bf3855cd6a8fdf7b$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $cdcce288e11f34ec$export$2e2bcd8739ae039)(padding, (0, $d059d5b7a8e05ae4$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $d059d5b7a8e05ae4$export$ae5ab1c730825774) ? (0, $d059d5b7a8e05ae4$export$ca50aac9f3ba507f) : (0, $d059d5b7a8e05ae4$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5f4a107a2486b487$export$2e2bcd8739ae039)((0, $62a825b9d8440eac$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $a2be94d6ea0eec02$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary);
    var referenceClientRect = (0, $71e70ee5b2f1455a$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $b0216aa30e230595$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $71f001960e2859da$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $d059d5b7a8e05ae4$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $d059d5b7a8e05ae4$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $d059d5b7a8e05ae4$export$79ffe56a765070d2),
                (0, $d059d5b7a8e05ae4$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $d059d5b7a8e05ae4$export$1e95b668f3b82d),
                (0, $d059d5b7a8e05ae4$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $21ec34f8f4543e69$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $d059d5b7a8e05ae4$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $1a1d765e805ddb4e$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $d059d5b7a8e05ae4$export$368f9a87e87fa4e1) : (0, $d059d5b7a8e05ae4$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $1a1d765e805ddb4e$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $d059d5b7a8e05ae4$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $041f1f212e95a561$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6aa8d16ac5c2fbd$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $dc962822a4fee865$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6aa8d16ac5c2fbd$export$2e2bcd8739ae039)(placement) === (0, $d059d5b7a8e05ae4$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $1b55de214b438ce7$export$2e2bcd8739ae039)(placement);
    return [
        (0, $9b0ca5883ce01f94$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $9b0ca5883ce01f94$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $dc962822a4fee865$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6aa8d16ac5c2fbd$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $1b55de214b438ce7$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $dc962822a4fee865$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6aa8d16ac5c2fbd$export$2e2bcd8739ae039)(placement) === (0, $d059d5b7a8e05ae4$export$dfb5619354ba860) ? (0, $21ec34f8f4543e69$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6aa8d16ac5c2fbd$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $1a1d765e805ddb4e$export$2e2bcd8739ae039)(placement) === (0, $d059d5b7a8e05ae4$export$b3571188c770cc5a);
        var isVertical = [
            (0, $d059d5b7a8e05ae4$export$1e95b668f3b82d),
            (0, $d059d5b7a8e05ae4$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $041f1f212e95a561$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $d059d5b7a8e05ae4$export$79ffe56a765070d2) : (0, $d059d5b7a8e05ae4$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $d059d5b7a8e05ae4$export$40e543e69a8b3fbb) : (0, $d059d5b7a8e05ae4$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $1b55de214b438ce7$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $1b55de214b438ce7$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $dc962822a4fee865$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $dc962822a4fee865$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $3e83728bd971a443$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $ebc8a55b6c73a4b6$export$f28d906d67a997f3(min, value, max) {
    return (0, $0510bd601162f306$export$8960430cfd85939f)(min, (0, $0510bd601162f306$export$96ec731ed4dcb222)(value, max));
}
function $ebc8a55b6c73a4b6$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $ebc8a55b6c73a4b6$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $7086e8dd456f32f4$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $041f1f212e95a561$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6aa8d16ac5c2fbd$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $1a1d765e805ddb4e$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $f9eebe532a23d407$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $3e83728bd971a443$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $d059d5b7a8e05ae4$export$1e95b668f3b82d) : (0, $d059d5b7a8e05ae4$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $d059d5b7a8e05ae4$export$40e543e69a8b3fbb) : (0, $d059d5b7a8e05ae4$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $d059d5b7a8e05ae4$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $d059d5b7a8e05ae4$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $98ad26331b621aef$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $3083399bffc75062$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $ebc8a55b6c73a4b6$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $9216a7baaf6cfa3d$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $ebc8a55b6c73a4b6$export$f28d906d67a997f3)(tether ? (0, $0510bd601162f306$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $0510bd601162f306$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $d059d5b7a8e05ae4$export$1e95b668f3b82d) : (0, $d059d5b7a8e05ae4$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $d059d5b7a8e05ae4$export$40e543e69a8b3fbb) : (0, $d059d5b7a8e05ae4$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $d059d5b7a8e05ae4$export$1e95b668f3b82d),
            (0, $d059d5b7a8e05ae4$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $ebc8a55b6c73a4b6$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $ebc8a55b6c73a4b6$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7086e8dd456f32f4$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $7086e8dd456f32f4$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};












var $fda01e12077ba9f7$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $bf3855cd6a8fdf7b$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $cdcce288e11f34ec$export$2e2bcd8739ae039)(padding, (0, $d059d5b7a8e05ae4$export$aec2ce47c367b8c3)));
};
function $fda01e12077ba9f7$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6aa8d16ac5c2fbd$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $f9eebe532a23d407$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $d059d5b7a8e05ae4$export$eabcd2c8791e7bf4),
        (0, $d059d5b7a8e05ae4$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $fda01e12077ba9f7$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $98ad26331b621aef$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $d059d5b7a8e05ae4$export$1e95b668f3b82d) : (0, $d059d5b7a8e05ae4$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $d059d5b7a8e05ae4$export$40e543e69a8b3fbb) : (0, $d059d5b7a8e05ae4$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $9216a7baaf6cfa3d$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $ebc8a55b6c73a4b6$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $fda01e12077ba9f7$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $fb4362bee364d6aa$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $fda01e12077ba9f7$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $fda01e12077ba9f7$var$arrow,
    effect: $fda01e12077ba9f7$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $bb9041b67e033895$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $bb9041b67e033895$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $d059d5b7a8e05ae4$export$1e95b668f3b82d),
        (0, $d059d5b7a8e05ae4$export$79ffe56a765070d2),
        (0, $d059d5b7a8e05ae4$export$40e543e69a8b3fbb),
        (0, $d059d5b7a8e05ae4$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $bb9041b67e033895$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $041f1f212e95a561$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $041f1f212e95a561$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $bb9041b67e033895$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $bb9041b67e033895$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $bb9041b67e033895$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $bb9041b67e033895$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $bb9041b67e033895$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $bb9041b67e033895$var$hide
};




var $e9aaa782a6c25ee4$export$d34966752335dd47 = [
    (0, $d772e4bf9016e4ad$export$2e2bcd8739ae039),
    (0, $830c0976e45b95ad$export$2e2bcd8739ae039),
    (0, $3b0d353c28f4a2c8$export$2e2bcd8739ae039),
    (0, $7690a96c252d2599$export$2e2bcd8739ae039),
    (0, $6e5541cad4162d43$export$2e2bcd8739ae039),
    (0, $dc962822a4fee865$export$2e2bcd8739ae039),
    (0, $7086e8dd456f32f4$export$2e2bcd8739ae039),
    (0, $fda01e12077ba9f7$export$2e2bcd8739ae039),
    (0, $bb9041b67e033895$export$2e2bcd8739ae039)
];
var $e9aaa782a6c25ee4$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $6ae667d1a6c4ffb7$export$ed5e13716264f202)({
    defaultModifiers: $e9aaa782a6c25ee4$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $adb32785e846fd3a$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $adb32785e846fd3a$var$hasElementType = typeof Element !== "undefined";
var $adb32785e846fd3a$var$hasMap = typeof Map === "function";
var $adb32785e846fd3a$var$hasSet = typeof Set === "function";
var $adb32785e846fd3a$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $adb32785e846fd3a$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.1
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$adb32785e846fd3a$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($adb32785e846fd3a$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$adb32785e846fd3a$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($adb32785e846fd3a$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($adb32785e846fd3a$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($adb32785e846fd3a$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$adb32785e846fd3a$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$adb32785e846fd3a$exports = function isEqual(a, b) {
    try {
        return $adb32785e846fd3a$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $6b61ce8177b92e78$var$EMPTY_MODIFIERS = [];
var $6b61ce8177b92e78$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $tZqWC.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $6b61ce8177b92e78$var$EMPTY_MODIFIERS
    };
    var _React$useState = $tZqWC.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $tZqWC.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                setState({
                    styles: (0, $4e9f2a57def71fd7$export$5150077fc2e7c662)(elements.map(function(element) {
                        return [
                            element,
                            state.styles[element] || {}
                        ];
                    })),
                    attributes: (0, $4e9f2a57def71fd7$export$5150077fc2e7c662)(elements.map(function(element) {
                        return [
                            element,
                            state.attributes[element]
                        ];
                    }))
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $tZqWC.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($adb32785e846fd3a$exports)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $tZqWC.useRef();
    (0, $4e9f2a57def71fd7$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $4e9f2a57def71fd7$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $e9aaa782a6c25ee4$export$8f7491d57c8f97a9);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};


var $1fd7a0715ff9509b$var$NOOP = function NOOP() {
    return void 0;
};
var $1fd7a0715ff9509b$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $1fd7a0715ff9509b$var$EMPTY_MODIFIERS = [];
function $1fd7a0715ff9509b$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "absolute" : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $1fd7a0715ff9509b$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $tZqWC.useContext((0, $cb0b0dd810051858$export$3dbd3405086fec7b));
    var _React$useState = $tZqWC.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $tZqWC.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $tZqWC.useEffect(function() {
        (0, $4e9f2a57def71fd7$export$4bb192c7cacf928f)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $tZqWC.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: "arrow",
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $6b61ce8177b92e78$export$f4d5bf230a36dd6e)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $tZqWC.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $1fd7a0715ff9509b$var$NOOP,
            update: update || $1fd7a0715ff9509b$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $4e9f2a57def71fd7$export$f52c55943429c8b6)(children)(childrenProps);
}


var $tZqWC = parcelRequire("tZqWC");
var $2fa5a684c3c68fbc$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $2fa5a684c3c68fbc$var$__DEV__ = false;
var $2fa5a684c3c68fbc$var$warning = function() {};
if ($2fa5a684c3c68fbc$var$__DEV__) {
    var $2fa5a684c3c68fbc$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $2fa5a684c3c68fbc$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $2fa5a684c3c68fbc$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$2fa5a684c3c68fbc$exports = $2fa5a684c3c68fbc$var$warning;




function $4303928b97615b86$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $tZqWC.useContext((0, $cb0b0dd810051858$export$cbabb21c2529b130));
    var refHandler = $tZqWC.useCallback(function(node) {
        (0, $4e9f2a57def71fd7$export$4bb192c7cacf928f)(innerRef, node);
        (0, $4e9f2a57def71fd7$export$3dfa7c28635fe028)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    $tZqWC.useEffect(function() {
        return function() {
            return (0, $4e9f2a57def71fd7$export$4bb192c7cacf928f)(innerRef, null);
        };
    });
    $tZqWC.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($2fa5a684c3c68fbc$exports)))(Boolean(setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
    }, [
        setReferenceNode
    ]);
    return (0, $4e9f2a57def71fd7$export$f52c55943429c8b6)(children)({
        ref: refHandler
    });
}




var $cGhSa = parcelRequire("cGhSa");

var $1gxF5 = parcelRequire("1gxF5");


var $tZqWC = parcelRequire("tZqWC");

var $26706e46f9f6203d$export$2e2bcd8739ae039 = {
    disabled: false
};




var $tZqWC = parcelRequire("tZqWC");
var $f1f6c674a64aba6a$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext(null);


var $a648815ae929180c$export$bb38bb9a1161268 = "unmounted";
var $a648815ae929180c$export$84cbff306f539230 = "exited";
var $a648815ae929180c$export$df38205c966be359 = "entering";
var $a648815ae929180c$export$78e9e6e3e014d60a = "entered";
var $a648815ae929180c$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $a648815ae929180c$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $1gxF5.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $a648815ae929180c$export$84cbff306f539230;
                _this.appearStatus = $a648815ae929180c$export$df38205c966be359;
            } else initialStatus = $a648815ae929180c$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $a648815ae929180c$export$bb38bb9a1161268;
        else initialStatus = $a648815ae929180c$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $a648815ae929180c$export$bb38bb9a1161268) return {
            status: $a648815ae929180c$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $a648815ae929180c$export$df38205c966be359 && status !== $a648815ae929180c$export$78e9e6e3e014d60a) nextStatus = $a648815ae929180c$export$df38205c966be359;
            } else if (status === $a648815ae929180c$export$df38205c966be359 || status === $a648815ae929180c$export$78e9e6e3e014d60a) nextStatus = $a648815ae929180c$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $a648815ae929180c$export$df38205c966be359) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $a648815ae929180c$export$84cbff306f539230) this.setState({
            status: $a648815ae929180c$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($f419cfc3d92fe631$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $26706e46f9f6203d$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $a648815ae929180c$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $a648815ae929180c$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $a648815ae929180c$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($f419cfc3d92fe631$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $26706e46f9f6203d$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $a648815ae929180c$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $a648815ae929180c$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $a648815ae929180c$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($f419cfc3d92fe631$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $a648815ae929180c$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $cGhSa.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement((0, $f1f6c674a64aba6a$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component);
$a648815ae929180c$var$Transition.contextType = (0, $f1f6c674a64aba6a$export$2e2bcd8739ae039);
$a648815ae929180c$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $a648815ae929180c$var$noop() {}
$a648815ae929180c$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $a648815ae929180c$var$noop,
    onEntering: $a648815ae929180c$var$noop,
    onEntered: $a648815ae929180c$var$noop,
    onExit: $a648815ae929180c$var$noop,
    onExiting: $a648815ae929180c$var$noop,
    onExited: $a648815ae929180c$var$noop
};
$a648815ae929180c$var$Transition.UNMOUNTED = $a648815ae929180c$export$bb38bb9a1161268;
$a648815ae929180c$var$Transition.EXITED = $a648815ae929180c$export$84cbff306f539230;
$a648815ae929180c$var$Transition.ENTERING = $a648815ae929180c$export$df38205c966be359;
$a648815ae929180c$var$Transition.ENTERED = $a648815ae929180c$export$78e9e6e3e014d60a;
$a648815ae929180c$var$Transition.EXITING = $a648815ae929180c$export$4aacc83d4d59139f;
var $a648815ae929180c$export$2e2bcd8739ae039 = $a648815ae929180c$var$Transition;


function $51b32cf9efbde13e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $51b32cf9efbde13e$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $51b32cf9efbde13e$var$ownKeys(Object(source), true).forEach(function(key) {
            $51b32cf9efbde13e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $51b32cf9efbde13e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $51b32cf9efbde13e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $51b32cf9efbde13e$var$_extends() {
    $51b32cf9efbde13e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $51b32cf9efbde13e$var$_extends.apply(this, arguments);
}
function $51b32cf9efbde13e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $51b32cf9efbde13e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $51b32cf9efbde13e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $51b32cf9efbde13e$var$getScrollbarWidth() {
    let scrollDiv = document.createElement("div"); // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    scrollDiv.style.width = "50px";
    scrollDiv.style.height = "50px";
    scrollDiv.style.overflow = "scroll";
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
}
function $51b32cf9efbde13e$var$setScrollbarWidth(padding) {
    document.body.style.paddingRight = padding > 0 ? `${padding}px` : null;
}
function $51b32cf9efbde13e$var$isBodyOverflowing() {
    return document.body.clientWidth < window.innerWidth;
}
function $51b32cf9efbde13e$var$getOriginalBodyPadding() {
    const style = window.getComputedStyle(document.body, null);
    return parseInt(style && style.getPropertyValue("padding-right") || 0, 10);
}
function $51b32cf9efbde13e$var$conditionallyUpdateScrollbar() {
    const scrollbarWidth = $51b32cf9efbde13e$var$getScrollbarWidth(); // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433
    const fixedContent = document.querySelectorAll(".fixed-top, .fixed-bottom, .is-fixed, .sticky-top")[0];
    const bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;
    if ($51b32cf9efbde13e$var$isBodyOverflowing()) $51b32cf9efbde13e$var$setScrollbarWidth(bodyPadding + scrollbarWidth);
}
let $51b32cf9efbde13e$var$globalCssModule;
function $51b32cf9efbde13e$var$setGlobalCssModule(cssModule) {
    $51b32cf9efbde13e$var$globalCssModule = cssModule;
}
function $51b32cf9efbde13e$var$mapToCssModules(className = "", cssModule = $51b32cf9efbde13e$var$globalCssModule) {
    if (!cssModule) return className;
    return className.split(" ").map((c)=>cssModule[c] || c).join(" ");
}
/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */ function $51b32cf9efbde13e$var$omit(obj, omitKeys) {
    const result = {};
    Object.keys(obj).forEach((key)=>{
        if (omitKeys.indexOf(key) === -1) result[key] = obj[key];
    });
    return result;
}
/**
 * Returns a filtered copy of an object with only the specified keys.
 */ function $51b32cf9efbde13e$var$pick(obj, keys) {
    const pickKeys = Array.isArray(keys) ? keys : [
        keys
    ];
    let length = pickKeys.length;
    let key;
    const result = {};
    while(length > 0){
        length -= 1;
        key = pickKeys[length];
        result[key] = obj[key];
    }
    return result;
}
let $51b32cf9efbde13e$var$warned = {};
function $51b32cf9efbde13e$var$warnOnce(message) {
    if (!$51b32cf9efbde13e$var$warned[message]) {
        /* istanbul ignore else */ if (typeof console !== "undefined") console.error(message); // eslint-disable-line no-console
        $51b32cf9efbde13e$var$warned[message] = true;
    }
}
function $51b32cf9efbde13e$var$deprecated(propType, explanation) {
    return function validate(props, propName, componentName, ...rest) {
        if (props[propName] !== null && typeof props[propName] !== "undefined") $51b32cf9efbde13e$var$warnOnce(`"${propName}" property of "${componentName}" has been deprecated.\n${explanation}`);
        return propType(props, propName, componentName, ...rest);
    };
} // Shim Element if needed (e.g. in Node environment)
const $51b32cf9efbde13e$var$Element = typeof window === "object" && window.Element || function() {};
function $51b32cf9efbde13e$var$DOMElement(props, propName, componentName) {
    if (!(props[propName] instanceof $51b32cf9efbde13e$var$Element)) return new Error("Invalid prop `" + propName + "` supplied to `" + componentName + "`. Expected prop to be an instance of Element. Validation failed.");
}
const $51b32cf9efbde13e$var$targetPropType = (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    $51b32cf9efbde13e$var$DOMElement,
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any
    })
]);
const $51b32cf9efbde13e$var$tagPropType = (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        $$typeof: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).symbol,
        render: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            $$typeof: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).symbol,
            render: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
        })
    ]))
]);
/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */ // These are all setup to match what is in the bootstrap _variables.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss
const $51b32cf9efbde13e$var$TransitionTimeouts = {
    Fade: 150,
    // $transition-fade
    Collapse: 350,
    // $transition-collapse
    Modal: 300,
    // $modal-transition
    Carousel: 600,
    // $carousel-transition
    Offcanvas: 300 // $offcanvas-transition
}; // Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.
const $51b32cf9efbde13e$var$TransitionPropTypeKeys = [
    "in",
    "mountOnEnter",
    "unmountOnExit",
    "appear",
    "enter",
    "exit",
    "timeout",
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited"
];
const $51b32cf9efbde13e$var$TransitionStatuses = {
    ENTERING: "entering",
    ENTERED: "entered",
    EXITING: "exiting",
    EXITED: "exited"
};
const $51b32cf9efbde13e$var$keyCodes = {
    esc: 27,
    space: 32,
    enter: 13,
    tab: 9,
    up: 38,
    down: 40,
    home: 36,
    end: 35,
    n: 78,
    p: 80
};
const $51b32cf9efbde13e$var$PopperPlacements = [
    "auto-start",
    "auto",
    "auto-end",
    "top-start",
    "top",
    "top-end",
    "right-start",
    "right",
    "right-end",
    "bottom-end",
    "bottom",
    "bottom-start",
    "left-end",
    "left",
    "left-start"
];
const $51b32cf9efbde13e$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $51b32cf9efbde13e$var$isReactRefObj(target) {
    if (target && typeof target === "object") return "current" in target;
    return false;
}
function $51b32cf9efbde13e$var$getTag(value) {
    if (value == null) return value === undefined ? "[object Undefined]" : "[object Null]";
    return Object.prototype.toString.call(value);
}
function $51b32cf9efbde13e$var$toNumber(value) {
    const type = typeof value;
    const NAN = 0 / 0;
    if (type === "number") return value;
    if (type === "symbol" || type === "object" && $51b32cf9efbde13e$var$getTag(value) === "[object Symbol]") return NAN;
    if ($51b32cf9efbde13e$var$isObject(value)) {
        const other = typeof value.valueOf === "function" ? value.valueOf() : value;
        value = $51b32cf9efbde13e$var$isObject(other) ? `${other}` : other;
    }
    if (type !== "string") return value === 0 ? value : +value;
    value = value.replace(/^\s+|\s+$/g, "");
    const isBinary = /^0b[01]+$/i.test(value);
    return isBinary || /^0o[0-7]+$/i.test(value) ? parseInt(value.slice(2), isBinary ? 2 : 8) : /^[-+]0x[0-9a-f]+$/i.test(value) ? NAN : +value;
}
function $51b32cf9efbde13e$var$isObject(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function");
}
function $51b32cf9efbde13e$var$isFunction(value) {
    if (!$51b32cf9efbde13e$var$isObject(value)) return false;
    const tag = $51b32cf9efbde13e$var$getTag(value);
    return tag === "[object Function]" || tag === "[object AsyncFunction]" || tag === "[object GeneratorFunction]" || tag === "[object Proxy]";
}
function $51b32cf9efbde13e$var$findDOMElements(target) {
    if ($51b32cf9efbde13e$var$isReactRefObj(target)) return target.current;
    if ($51b32cf9efbde13e$var$isFunction(target)) return target();
    if (typeof target === "string" && $51b32cf9efbde13e$var$canUseDOM) {
        let selection = document.querySelectorAll(target);
        if (!selection.length) selection = document.querySelectorAll(`#${target}`);
        if (!selection.length) throw new Error(`The target '${target}' could not be identified in the dom, tip: check spelling`);
        return selection;
    }
    return target;
}
function $51b32cf9efbde13e$var$isArrayOrNodeList(els) {
    if (els === null) return false;
    return Array.isArray(els) || $51b32cf9efbde13e$var$canUseDOM && typeof els.length === "number";
}
function $51b32cf9efbde13e$var$getTarget(target, allElements) {
    const els = $51b32cf9efbde13e$var$findDOMElements(target);
    if (allElements) {
        if ($51b32cf9efbde13e$var$isArrayOrNodeList(els)) return els;
        if (els === null) return [];
        return [
            els
        ];
    } else {
        if ($51b32cf9efbde13e$var$isArrayOrNodeList(els)) return els[0];
        return els;
    }
}
const $51b32cf9efbde13e$var$defaultToggleEvents = [
    "touchstart",
    "click"
];
function $51b32cf9efbde13e$var$addMultipleEventListeners(_els, handler, _events, useCapture) {
    let els = _els;
    if (!$51b32cf9efbde13e$var$isArrayOrNodeList(els)) els = [
        els
    ];
    let events = _events;
    if (typeof events === "string") events = events.split(/\s+/);
    if (!$51b32cf9efbde13e$var$isArrayOrNodeList(els) || typeof handler !== "function" || !Array.isArray(events)) throw new Error(`
      The first argument of this function must be DOM node or an array on DOM nodes or NodeList.
      The second must be a function.
      The third is a string or an array of strings that represents DOM events
    `);
    Array.prototype.forEach.call(events, (event)=>{
        Array.prototype.forEach.call(els, (el)=>{
            el.addEventListener(event, handler, useCapture);
        });
    });
    return function removeEvents() {
        Array.prototype.forEach.call(events, (event)=>{
            Array.prototype.forEach.call(els, (el)=>{
                el.removeEventListener(event, handler, useCapture);
            });
        });
    };
}
const $51b32cf9efbde13e$var$focusableElements = [
    "a[href]",
    "area[href]",
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "object",
    "embed",
    "[tabindex]:not(.modal)",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
];
var $51b32cf9efbde13e$export$f8f26dd395d7e1bd = {
    __proto__: null,
    getScrollbarWidth: $51b32cf9efbde13e$var$getScrollbarWidth,
    setScrollbarWidth: $51b32cf9efbde13e$var$setScrollbarWidth,
    isBodyOverflowing: $51b32cf9efbde13e$var$isBodyOverflowing,
    getOriginalBodyPadding: $51b32cf9efbde13e$var$getOriginalBodyPadding,
    conditionallyUpdateScrollbar: $51b32cf9efbde13e$var$conditionallyUpdateScrollbar,
    setGlobalCssModule: $51b32cf9efbde13e$var$setGlobalCssModule,
    mapToCssModules: $51b32cf9efbde13e$var$mapToCssModules,
    omit: $51b32cf9efbde13e$var$omit,
    pick: $51b32cf9efbde13e$var$pick,
    warnOnce: $51b32cf9efbde13e$var$warnOnce,
    deprecated: $51b32cf9efbde13e$var$deprecated,
    DOMElement: $51b32cf9efbde13e$var$DOMElement,
    targetPropType: $51b32cf9efbde13e$var$targetPropType,
    tagPropType: $51b32cf9efbde13e$var$tagPropType,
    TransitionTimeouts: $51b32cf9efbde13e$var$TransitionTimeouts,
    TransitionPropTypeKeys: $51b32cf9efbde13e$var$TransitionPropTypeKeys,
    TransitionStatuses: $51b32cf9efbde13e$var$TransitionStatuses,
    keyCodes: $51b32cf9efbde13e$var$keyCodes,
    PopperPlacements: $51b32cf9efbde13e$var$PopperPlacements,
    canUseDOM: $51b32cf9efbde13e$var$canUseDOM,
    isReactRefObj: $51b32cf9efbde13e$var$isReactRefObj,
    toNumber: $51b32cf9efbde13e$var$toNumber,
    isObject: $51b32cf9efbde13e$var$isObject,
    isFunction: $51b32cf9efbde13e$var$isFunction,
    findDOMElements: $51b32cf9efbde13e$var$findDOMElements,
    isArrayOrNodeList: $51b32cf9efbde13e$var$isArrayOrNodeList,
    getTarget: $51b32cf9efbde13e$var$getTarget,
    defaultToggleEvents: $51b32cf9efbde13e$var$defaultToggleEvents,
    addMultipleEventListeners: $51b32cf9efbde13e$var$addMultipleEventListeners,
    focusableElements: $51b32cf9efbde13e$var$focusableElements
};
const $51b32cf9efbde13e$var$_excluded$1e = [
    "className",
    "cssModule",
    "fluid",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$1k = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    fluid: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$1i = {
    tag: "div"
};
const $51b32cf9efbde13e$var$Container = (props)=>{
    const { className: className, cssModule: cssModule, fluid: fluid, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$1e);
    let containerClass = "container";
    if (fluid === true) containerClass = "container-fluid";
    else if (fluid) containerClass = `container-${fluid}`;
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, containerClass), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$Container.propTypes = $51b32cf9efbde13e$var$propTypes$1k;
$51b32cf9efbde13e$var$Container.defaultProps = $51b32cf9efbde13e$var$defaultProps$1i;
var $51b32cf9efbde13e$export$42a852a2b6b56249 = $51b32cf9efbde13e$var$Container;
const $51b32cf9efbde13e$var$_excluded$1d = [
    "className",
    "cssModule",
    "noGutters",
    "tag",
    "form",
    "widths"
];
const $51b32cf9efbde13e$var$rowColWidths = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
const $51b32cf9efbde13e$var$rowColsPropType = (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
]);
const $51b32cf9efbde13e$var$propTypes$1j = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    noGutters: $51b32cf9efbde13e$var$deprecated((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool, "Please use Bootstrap 5 gutter utility classes. https://getbootstrap.com/docs/5.0/layout/gutters/"),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    xs: $51b32cf9efbde13e$var$rowColsPropType,
    sm: $51b32cf9efbde13e$var$rowColsPropType,
    md: $51b32cf9efbde13e$var$rowColsPropType,
    lg: $51b32cf9efbde13e$var$rowColsPropType,
    xl: $51b32cf9efbde13e$var$rowColsPropType,
    xxl: $51b32cf9efbde13e$var$rowColsPropType
};
const $51b32cf9efbde13e$var$defaultProps$1h = {
    tag: "div",
    widths: $51b32cf9efbde13e$var$rowColWidths
};
const $51b32cf9efbde13e$var$Row = (props)=>{
    const { className: className, cssModule: cssModule, noGutters: noGutters, tag: Tag, form: form, widths: widths } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$1d);
    const colClasses = [];
    widths.forEach((colWidth, i)=>{
        let colSize = props[colWidth];
        delete attributes[colWidth];
        if (!colSize) return;
        const isXs = !i;
        colClasses.push(isXs ? `row-cols-${colSize}` : `row-cols-${colWidth}-${colSize}`);
    });
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, noGutters ? "gx-0" : null, form ? "form-row" : "row", colClasses), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$Row.propTypes = $51b32cf9efbde13e$var$propTypes$1j;
$51b32cf9efbde13e$var$Row.defaultProps = $51b32cf9efbde13e$var$defaultProps$1h;
var $51b32cf9efbde13e$export$b59bdbef9ce70de2 = $51b32cf9efbde13e$var$Row;
const $51b32cf9efbde13e$var$_excluded$1c = [
    "className",
    "cssModule",
    "widths",
    "tag"
];
const $51b32cf9efbde13e$var$colWidths$1 = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
const $51b32cf9efbde13e$var$stringOrNumberProp$1 = (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
]);
const $51b32cf9efbde13e$var$columnProps$1 = (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        ]),
        order: $51b32cf9efbde13e$var$stringOrNumberProp$1,
        offset: $51b32cf9efbde13e$var$stringOrNumberProp$1
    })
]);
const $51b32cf9efbde13e$var$propTypes$1i = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    xs: $51b32cf9efbde13e$var$columnProps$1,
    sm: $51b32cf9efbde13e$var$columnProps$1,
    md: $51b32cf9efbde13e$var$columnProps$1,
    lg: $51b32cf9efbde13e$var$columnProps$1,
    xl: $51b32cf9efbde13e$var$columnProps$1,
    xxl: $51b32cf9efbde13e$var$columnProps$1,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    widths: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).array
};
const $51b32cf9efbde13e$var$defaultProps$1g = {
    tag: "div",
    widths: $51b32cf9efbde13e$var$colWidths$1
};
const $51b32cf9efbde13e$var$getColumnSizeClass$1 = (isXs, colWidth, colSize)=>{
    if (colSize === true || colSize === "") return isXs ? "col" : `col-${colWidth}`;
    else if (colSize === "auto") return isXs ? "col-auto" : `col-${colWidth}-auto`;
    return isXs ? `col-${colSize}` : `col-${colWidth}-${colSize}`;
};
const $51b32cf9efbde13e$var$getColumnClasses = (attributes, cssModule, widths = $51b32cf9efbde13e$var$colWidths$1)=>{
    const colClasses = [];
    widths.forEach((colWidth, i)=>{
        let columnProp = attributes[colWidth];
        delete attributes[colWidth];
        if (!columnProp && columnProp !== "") return;
        const isXs = !i;
        if ($51b32cf9efbde13e$var$isObject(columnProp)) {
            const colSizeInterfix = isXs ? "-" : `-${colWidth}-`;
            const colClass = $51b32cf9efbde13e$var$getColumnSizeClass$1(isXs, colWidth, columnProp.size);
            colClasses.push($51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))({
                [colClass]: columnProp.size || columnProp.size === "",
                [`order${colSizeInterfix}${columnProp.order}`]: columnProp.order || columnProp.order === 0,
                [`offset${colSizeInterfix}${columnProp.offset}`]: columnProp.offset || columnProp.offset === 0
            }), cssModule));
        } else {
            const colClass = $51b32cf9efbde13e$var$getColumnSizeClass$1(isXs, colWidth, columnProp);
            colClasses.push(colClass);
        }
    });
    return {
        colClasses: colClasses,
        attributes: attributes
    };
};
const $51b32cf9efbde13e$var$Col = (props)=>{
    const { className: className, cssModule: cssModule, widths: widths, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$1c);
    let { attributes: modifiedAttributes, colClasses: colClasses } = $51b32cf9efbde13e$var$getColumnClasses(attributes, cssModule, widths);
    if (!colClasses.length) colClasses.push("col");
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, colClasses), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, modifiedAttributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$Col.propTypes = $51b32cf9efbde13e$var$propTypes$1i;
$51b32cf9efbde13e$var$Col.defaultProps = $51b32cf9efbde13e$var$defaultProps$1g;
var $51b32cf9efbde13e$export$963a4b2511a4b70c = $51b32cf9efbde13e$var$Col;
const $51b32cf9efbde13e$var$_excluded$1b = [
    "expand",
    "className",
    "cssModule",
    "light",
    "dark",
    "fixed",
    "sticky",
    "color",
    "container",
    "tag",
    "children"
];
const $51b32cf9efbde13e$var$propTypes$1h = {
    light: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    dark: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    full: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    fixed: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    sticky: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    tag: $51b32cf9efbde13e$var$tagPropType,
    container: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    expand: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
};
const $51b32cf9efbde13e$var$defaultProps$1f = {
    tag: "nav",
    expand: false,
    container: "fluid"
};
const $51b32cf9efbde13e$var$getExpandClass = (expand)=>{
    if (expand === false) return false;
    else if (expand === true || expand === "xs") return "navbar-expand";
    return `navbar-expand-${expand}`;
};
const $51b32cf9efbde13e$var$Navbar = (props)=>{
    const { expand: expand, className: className, cssModule: cssModule, light: light, dark: dark, fixed: fixed, sticky: sticky, color: color, container: container, tag: Tag, children: children } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$1b);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "navbar", $51b32cf9efbde13e$var$getExpandClass(expand), {
        "navbar-light": light,
        "navbar-dark": dark,
        [`bg-${color}`]: color,
        [`fixed-${fixed}`]: fixed,
        [`sticky-${sticky}`]: sticky
    }), cssModule);
    const containerClass = container && container === true ? "container" : `container-${container}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }), container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("div", {
        className: containerClass
    }, children) : children);
};
$51b32cf9efbde13e$var$Navbar.propTypes = $51b32cf9efbde13e$var$propTypes$1h;
$51b32cf9efbde13e$var$Navbar.defaultProps = $51b32cf9efbde13e$var$defaultProps$1f;
var $51b32cf9efbde13e$export$42cfbb80f7861e77 = $51b32cf9efbde13e$var$Navbar;
const $51b32cf9efbde13e$var$_excluded$1a = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$1g = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$1e = {
    tag: "a"
};
const $51b32cf9efbde13e$var$NavbarBrand = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$1a);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "navbar-brand"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$NavbarBrand.propTypes = $51b32cf9efbde13e$var$propTypes$1g;
$51b32cf9efbde13e$var$NavbarBrand.defaultProps = $51b32cf9efbde13e$var$defaultProps$1e;
var $51b32cf9efbde13e$export$2df9f3e5f6d355f6 = $51b32cf9efbde13e$var$NavbarBrand;
const $51b32cf9efbde13e$var$_excluded$19 = [
    "className",
    "cssModule",
    "active",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$1f = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$1d = {
    tag: "span"
};
const $51b32cf9efbde13e$var$NavbarText = (props)=>{
    const { className: className, cssModule: cssModule, active: active, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$19);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "navbar-text"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$NavbarText.propTypes = $51b32cf9efbde13e$var$propTypes$1f;
$51b32cf9efbde13e$var$NavbarText.defaultProps = $51b32cf9efbde13e$var$defaultProps$1d;
var $51b32cf9efbde13e$export$db5d1b154ea0a8f4 = $51b32cf9efbde13e$var$NavbarText;
const $51b32cf9efbde13e$var$_excluded$18 = [
    "className",
    "cssModule",
    "children",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$1e = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
};
const $51b32cf9efbde13e$var$defaultProps$1c = {
    tag: "button",
    type: "button"
};
const $51b32cf9efbde13e$var$NavbarToggler = (props)=>{
    const { className: className, cssModule: cssModule, children: children, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$18);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "navbar-toggler"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({
        "aria-label": "Toggle navigation"
    }, attributes, {
        className: classes
    }), children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("span", {
        className: $51b32cf9efbde13e$var$mapToCssModules("navbar-toggler-icon", cssModule)
    }));
};
$51b32cf9efbde13e$var$NavbarToggler.propTypes = $51b32cf9efbde13e$var$propTypes$1e;
$51b32cf9efbde13e$var$NavbarToggler.defaultProps = $51b32cf9efbde13e$var$defaultProps$1c;
var $51b32cf9efbde13e$export$3e627761863aa466 = $51b32cf9efbde13e$var$NavbarToggler;
const $51b32cf9efbde13e$var$_excluded$17 = [
    "className",
    "cssModule",
    "tabs",
    "pills",
    "vertical",
    "horizontal",
    "justified",
    "fill",
    "navbar",
    "card",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$1d = {
    tabs: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    pills: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    vertical: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    justified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    fill: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    navbar: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    card: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$1b = {
    tag: "ul",
    vertical: false
};
const $51b32cf9efbde13e$var$getVerticalClass = (vertical)=>{
    if (vertical === false) return false;
    else if (vertical === true || vertical === "xs") return "flex-column";
    return `flex-${vertical}-column`;
};
const $51b32cf9efbde13e$var$Nav = (props)=>{
    const { className: className, cssModule: cssModule, tabs: tabs, pills: pills, vertical: vertical, horizontal: horizontal, justified: justified, fill: fill, navbar: navbar, card: card, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$17);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, navbar ? "navbar-nav" : "nav", horizontal ? `justify-content-${horizontal}` : false, $51b32cf9efbde13e$var$getVerticalClass(vertical), {
        "nav-tabs": tabs,
        "card-header-tabs": card && tabs,
        "nav-pills": pills,
        "card-header-pills": card && pills,
        "nav-justified": justified,
        "nav-fill": fill
    }), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$Nav.propTypes = $51b32cf9efbde13e$var$propTypes$1d;
$51b32cf9efbde13e$var$Nav.defaultProps = $51b32cf9efbde13e$var$defaultProps$1b;
var $51b32cf9efbde13e$export$39140c7d8b0ba7b3 = $51b32cf9efbde13e$var$Nav;
const $51b32cf9efbde13e$var$_excluded$16 = [
    "className",
    "cssModule",
    "active",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$1c = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$1a = {
    tag: "li"
};
const $51b32cf9efbde13e$var$NavItem = (props)=>{
    const { className: className, cssModule: cssModule, active: active, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$16);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "nav-item", active ? "active" : false), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$NavItem.propTypes = $51b32cf9efbde13e$var$propTypes$1c;
$51b32cf9efbde13e$var$NavItem.defaultProps = $51b32cf9efbde13e$var$defaultProps$1a;
var $51b32cf9efbde13e$export$e3925dbaeffcc83f = $51b32cf9efbde13e$var$NavItem;
const $51b32cf9efbde13e$var$_excluded$15 = [
    "className",
    "cssModule",
    "active",
    "tag",
    "innerRef"
];
const $51b32cf9efbde13e$var$propTypes$1b = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any
};
const $51b32cf9efbde13e$var$defaultProps$19 = {
    tag: "a"
};
class $51b32cf9efbde13e$var$NavLink extends (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component {
    constructor(props){
        super(props);
        this.onClick = this.onClick.bind(this);
    }
    onClick(e) {
        if (this.props.disabled) {
            e.preventDefault();
            return;
        }
        if (this.props.href === "#") e.preventDefault();
        if (this.props.onClick) this.props.onClick(e);
    }
    render() {
        let _this$props = this.props, { className: className, cssModule: cssModule, active: active, tag: Tag, innerRef: innerRef } = _this$props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(_this$props, $51b32cf9efbde13e$var$_excluded$15);
        const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "nav-link", {
            disabled: attributes.disabled,
            active: active
        }), cssModule);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
            ref: innerRef,
            onClick: this.onClick,
            className: classes
        }));
    }
}
$51b32cf9efbde13e$var$NavLink.propTypes = $51b32cf9efbde13e$var$propTypes$1b;
$51b32cf9efbde13e$var$NavLink.defaultProps = $51b32cf9efbde13e$var$defaultProps$19;
var $51b32cf9efbde13e$export$b0d92dbee9b5b60d = $51b32cf9efbde13e$var$NavLink;
const $51b32cf9efbde13e$var$_excluded$14 = [
    "className",
    "listClassName",
    "cssModule",
    "children",
    "tag",
    "listTag",
    "aria-label"
];
const $51b32cf9efbde13e$var$propTypes$1a = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    listTag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    listClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
const $51b32cf9efbde13e$var$defaultProps$18 = {
    tag: "nav",
    listTag: "ol",
    "aria-label": "breadcrumb"
};
const $51b32cf9efbde13e$var$Breadcrumb = (props)=>{
    const { className: className, listClassName: listClassName, cssModule: cssModule, children: children, tag: Tag, listTag: ListTag, "aria-label": label } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$14);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className), cssModule);
    const listClasses = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("breadcrumb", listClassName), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes,
        "aria-label": label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(ListTag, {
        className: listClasses
    }, children));
};
$51b32cf9efbde13e$var$Breadcrumb.propTypes = $51b32cf9efbde13e$var$propTypes$1a;
$51b32cf9efbde13e$var$Breadcrumb.defaultProps = $51b32cf9efbde13e$var$defaultProps$18;
var $51b32cf9efbde13e$export$dabcc1ec9dd9d1cc = $51b32cf9efbde13e$var$Breadcrumb;
const $51b32cf9efbde13e$var$_excluded$13 = [
    "className",
    "cssModule",
    "active",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$19 = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$17 = {
    tag: "li"
};
const $51b32cf9efbde13e$var$BreadcrumbItem = (props)=>{
    const { className: className, cssModule: cssModule, active: active, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$13);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, active ? "active" : false, "breadcrumb-item"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes,
        "aria-current": active ? "page" : undefined
    }));
};
$51b32cf9efbde13e$var$BreadcrumbItem.propTypes = $51b32cf9efbde13e$var$propTypes$19;
$51b32cf9efbde13e$var$BreadcrumbItem.defaultProps = $51b32cf9efbde13e$var$defaultProps$17;
var $51b32cf9efbde13e$export$c13f210c706eb549 = $51b32cf9efbde13e$var$BreadcrumbItem;
const $51b32cf9efbde13e$var$_excluded$12 = [
    "active",
    "aria-label",
    "block",
    "className",
    "close",
    "cssModule",
    "color",
    "outline",
    "size",
    "tag",
    "innerRef"
];
const $51b32cf9efbde13e$var$propTypes$18 = {
    active: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    block: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    outline: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    tag: $51b32cf9efbde13e$var$tagPropType,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    close: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
const $51b32cf9efbde13e$var$defaultProps$16 = {
    color: "secondary",
    tag: "button"
};
class $51b32cf9efbde13e$var$Button extends (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component {
    constructor(props){
        super(props);
        this.onClick = this.onClick.bind(this);
    }
    onClick(e) {
        if (this.props.disabled) {
            e.preventDefault();
            return;
        }
        if (this.props.onClick) return this.props.onClick(e);
    }
    render() {
        let _this$props = this.props, { active: active, "aria-label": ariaLabel, block: block, className: className, close: close, cssModule: cssModule, color: color, outline: outline, size: size, tag: Tag, innerRef: innerRef } = _this$props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(_this$props, $51b32cf9efbde13e$var$_excluded$12);
        const btnOutlineColor = `btn${outline ? "-outline" : ""}-${color}`;
        const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, close && "btn-close", close || "btn", close || btnOutlineColor, size ? `btn-${size}` : false, block ? "d-block w-100" : false, {
            active: active,
            disabled: this.props.disabled
        }), cssModule);
        if (attributes.href && Tag === "button") Tag = "a";
        const defaultAriaLabel = close ? "Close" : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({
            type: Tag === "button" && attributes.onClick ? "button" : undefined
        }, attributes, {
            className: classes,
            ref: innerRef,
            onClick: this.onClick,
            "aria-label": ariaLabel || defaultAriaLabel
        }));
    }
}
$51b32cf9efbde13e$var$Button.propTypes = $51b32cf9efbde13e$var$propTypes$18;
$51b32cf9efbde13e$var$Button.defaultProps = $51b32cf9efbde13e$var$defaultProps$16;
var $51b32cf9efbde13e$export$353f5b6fc5456de1 = $51b32cf9efbde13e$var$Button;
const $51b32cf9efbde13e$var$_excluded$11 = [
    "className"
];
const $51b32cf9efbde13e$var$propTypes$17 = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
const $51b32cf9efbde13e$var$defaultProps$15 = {
    defaultValue: false
};
class $51b32cf9efbde13e$var$ButtonToggle extends (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component {
    constructor(props){
        super(props);
        this.state = {
            toggled: props.defaultValue,
            focus: false
        };
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onClick = this.onClick.bind(this);
    }
    onBlur(e) {
        if (this.props.onBlur) this.props.onBlur(e);
        this.setState({
            focus: false
        });
    }
    onFocus(e) {
        if (this.props.onFocus) this.props.onFocus(e);
        this.setState({
            focus: true
        });
    }
    onClick(e) {
        if (this.props.onClick) this.props.onClick(e);
        this.setState(({ toggled: toggled })=>({
                toggled: !toggled
            }));
    }
    render() {
        const _this$props = this.props, { className: className } = _this$props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(_this$props, $51b32cf9efbde13e$var$_excluded$11);
        const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, {
            focus: this.state.focus
        }), this.props.cssModule);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$353f5b6fc5456de1, $51b32cf9efbde13e$var$_extends({
            active: this.state.toggled,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            onClick: this.onClick,
            className: classes
        }, attributes));
    }
}
$51b32cf9efbde13e$var$ButtonToggle.propTypes = $51b32cf9efbde13e$var$propTypes$17;
$51b32cf9efbde13e$var$ButtonToggle.defaultProps = $51b32cf9efbde13e$var$defaultProps$15;
var $51b32cf9efbde13e$export$2bcaf2ecc9612e8f = $51b32cf9efbde13e$var$ButtonToggle;
/**
 * DropdownContext
 * {
 *  toggle: PropTypes.func.isRequired,
 *  isOpen: PropTypes.bool.isRequired,
 *  direction: PropTypes.oneOf(['up', 'down', 'start', 'end']).isRequired,
 *  inNavbar: PropTypes.bool.isRequired,
 *  disabled: PropTypes.bool
 * }
 */ const $51b32cf9efbde13e$export$df140987c38a308d = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext({});
const $51b32cf9efbde13e$var$_excluded$10 = [
    "className",
    "cssModule",
    "direction",
    "isOpen",
    "group",
    "size",
    "nav",
    "setActiveFromChild",
    "active",
    "tag",
    "menuRole"
];
const $51b32cf9efbde13e$var$propTypes$16 = {
    a11y: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOf([
        "up",
        "down",
        "start",
        "end",
        "left",
        "right"
    ]),
    group: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    nav: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    tag: $51b32cf9efbde13e$var$tagPropType,
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    inNavbar: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    setActiveFromChild: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    menuRole: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOf([
        "listbox",
        "menu"
    ])
};
const $51b32cf9efbde13e$var$defaultProps$14 = {
    a11y: true,
    isOpen: false,
    direction: "down",
    nav: false,
    active: false,
    inNavbar: false,
    setActiveFromChild: false
};
const $51b32cf9efbde13e$var$preventDefaultKeys = [
    $51b32cf9efbde13e$var$keyCodes.space,
    $51b32cf9efbde13e$var$keyCodes.enter,
    $51b32cf9efbde13e$var$keyCodes.up,
    $51b32cf9efbde13e$var$keyCodes.down,
    $51b32cf9efbde13e$var$keyCodes.end,
    $51b32cf9efbde13e$var$keyCodes.home
];
class $51b32cf9efbde13e$var$Dropdown extends (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component {
    constructor(props){
        super(props);
        this.addEvents = this.addEvents.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.removeEvents = this.removeEvents.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleMenuRef = this.handleMenuRef.bind(this);
        this.containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createRef();
        this.menuRef = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createRef();
    }
    handleMenuRef(menuRef) {
        this.menuRef.current = menuRef;
    }
    getContextValue() {
        return {
            toggle: this.toggle,
            isOpen: this.props.isOpen,
            direction: this.props.direction === "down" && this.props.dropup ? "up" : this.props.direction,
            inNavbar: this.props.inNavbar,
            disabled: this.props.disabled,
            // Callback that should be called by DropdownMenu to provide a ref to
            // a HTML tag that's used for the DropdownMenu
            onMenuRef: this.handleMenuRef,
            menuRole: this.props.menuRole
        };
    }
    componentDidMount() {
        this.handleProps();
    }
    componentDidUpdate(prevProps) {
        if (this.props.isOpen !== prevProps.isOpen) this.handleProps();
    }
    componentWillUnmount() {
        this.removeEvents();
    }
    getContainer() {
        return this.containerRef.current;
    }
    getMenu() {
        return this.menuRef.current;
    }
    getMenuCtrl() {
        if (this._$menuCtrl) return this._$menuCtrl;
        this._$menuCtrl = this.getContainer().querySelector("[aria-expanded]");
        return this._$menuCtrl;
    }
    getItemType() {
        if (this.context.menuRole === "listbox") return "option";
        return "menuitem";
    }
    getMenuItems() {
        // In a real menu with a child DropdownMenu, `this.getMenu()` should never
        // be null, but it is sometimes null in tests. To mitigate that, we just
        // use `this.getContainer()` as the fallback `menuContainer`.
        const menuContainer = this.getMenu() || this.getContainer();
        return [].slice.call(menuContainer.querySelectorAll(`[role="${this.getItemType()}"]`));
    }
    addEvents() {
        [
            "click",
            "touchstart",
            "keyup"
        ].forEach((event)=>document.addEventListener(event, this.handleDocumentClick, true));
    }
    removeEvents() {
        [
            "click",
            "touchstart",
            "keyup"
        ].forEach((event)=>document.removeEventListener(event, this.handleDocumentClick, true));
    }
    handleDocumentClick(e) {
        if (e && (e.which === 3 || e.type === "keyup" && e.which !== $51b32cf9efbde13e$var$keyCodes.tab)) return;
        const container = this.getContainer();
        const menu = this.getMenu();
        const clickIsInContainer = container.contains(e.target) && container !== e.target;
        const clickIsInInput = container.classList.contains("input-group") && container.classList.contains("dropdown") && e.target.tagName === "INPUT";
        const clickIsInMenu = menu && menu.contains(e.target) && menu !== e.target;
        if ((clickIsInContainer && !clickIsInInput || clickIsInMenu) && (e.type !== "keyup" || e.which === $51b32cf9efbde13e$var$keyCodes.tab)) return;
        this.toggle(e);
    }
    handleKeyDown(e) {
        const isTargetMenuItem = e.target.getAttribute("role") === "menuitem" || e.target.getAttribute("role") === "option";
        const isTargetMenuCtrl = this.getMenuCtrl() === e.target;
        const isTab = $51b32cf9efbde13e$var$keyCodes.tab === e.which;
        if (/input|textarea/i.test(e.target.tagName) || isTab && !this.props.a11y || isTab && !(isTargetMenuItem || isTargetMenuCtrl)) return;
        if ($51b32cf9efbde13e$var$preventDefaultKeys.indexOf(e.which) !== -1 || e.which >= 48 && e.which <= 90) e.preventDefault();
        if (this.props.disabled) return;
        if (isTargetMenuCtrl) {
            if ([
                $51b32cf9efbde13e$var$keyCodes.space,
                $51b32cf9efbde13e$var$keyCodes.enter,
                $51b32cf9efbde13e$var$keyCodes.up,
                $51b32cf9efbde13e$var$keyCodes.down
            ].indexOf(e.which) > -1) {
                // Open the menu (if not open) and focus the first menu item
                if (!this.props.isOpen) this.toggle(e);
                setTimeout(()=>this.getMenuItems()[0].focus());
            } else if (this.props.isOpen && isTab) {
                // Focus the first menu item if tabbing from an open menu. We need this
                // for cases where the DropdownMenu sets a custom container, which may
                // not be the natural next item to tab to from the DropdownToggle.
                e.preventDefault();
                this.getMenuItems()[0].focus();
            } else if (this.props.isOpen && e.which === $51b32cf9efbde13e$var$keyCodes.esc) this.toggle(e);
        }
        if (this.props.isOpen && isTargetMenuItem) {
            if ([
                $51b32cf9efbde13e$var$keyCodes.tab,
                $51b32cf9efbde13e$var$keyCodes.esc
            ].indexOf(e.which) > -1) {
                this.toggle(e);
                this.getMenuCtrl().focus();
            } else if ([
                $51b32cf9efbde13e$var$keyCodes.space,
                $51b32cf9efbde13e$var$keyCodes.enter
            ].indexOf(e.which) > -1) {
                e.target.click();
                this.getMenuCtrl().focus();
            } else if ([
                $51b32cf9efbde13e$var$keyCodes.down,
                $51b32cf9efbde13e$var$keyCodes.up
            ].indexOf(e.which) > -1 || [
                $51b32cf9efbde13e$var$keyCodes.n,
                $51b32cf9efbde13e$var$keyCodes.p
            ].indexOf(e.which) > -1 && e.ctrlKey) {
                const $menuitems = this.getMenuItems();
                let index = $menuitems.indexOf(e.target);
                if ($51b32cf9efbde13e$var$keyCodes.up === e.which || $51b32cf9efbde13e$var$keyCodes.p === e.which && e.ctrlKey) index = index !== 0 ? index - 1 : $menuitems.length - 1;
                else if ($51b32cf9efbde13e$var$keyCodes.down === e.which || $51b32cf9efbde13e$var$keyCodes.n === e.which && e.ctrlKey) index = index === $menuitems.length - 1 ? 0 : index + 1;
                $menuitems[index].focus();
            } else if ($51b32cf9efbde13e$var$keyCodes.end === e.which) {
                const $menuitems = this.getMenuItems();
                $menuitems[$menuitems.length - 1].focus();
            } else if ($51b32cf9efbde13e$var$keyCodes.home === e.which) {
                const $menuitems = this.getMenuItems();
                $menuitems[0].focus();
            } else if (e.which >= 48 && e.which <= 90) {
                const $menuitems = this.getMenuItems();
                const charPressed = String.fromCharCode(e.which).toLowerCase();
                for(let i = 0; i < $menuitems.length; i += 1){
                    const firstLetter = $menuitems[i].textContent && $menuitems[i].textContent[0].toLowerCase();
                    if (firstLetter === charPressed) {
                        $menuitems[i].focus();
                        break;
                    }
                }
            }
        }
    }
    handleProps() {
        if (this.props.isOpen) this.addEvents();
        else this.removeEvents();
    }
    toggle(e) {
        if (this.props.disabled) return e && e.preventDefault();
        return this.props.toggle(e);
    }
    render() {
        const _omit = $51b32cf9efbde13e$var$omit(this.props, [
            "toggle",
            "disabled",
            "inNavbar",
            "a11y"
        ]), { className: className, cssModule: cssModule, direction: direction, isOpen: isOpen, group: group, size: size, nav: nav, setActiveFromChild: setActiveFromChild, active: active, tag: tag, menuRole: menuRole } = _omit, attrs = $51b32cf9efbde13e$var$_objectWithoutProperties(_omit, $51b32cf9efbde13e$var$_excluded$10);
        const Tag = tag || (nav ? "li" : "div");
        let subItemIsActive = false;
        if (setActiveFromChild) (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Children.map(this.props.children[1].props.children, (dropdownItem)=>{
            if (dropdownItem && dropdownItem.props.active) subItemIsActive = true;
        });
        const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, nav && active ? "active" : false, setActiveFromChild && subItemIsActive ? "active" : false, {
            "btn-group": group,
            [`btn-group-${size}`]: !!size,
            dropdown: !group,
            dropup: direction === "up",
            dropstart: direction === "start" || direction === "left",
            dropend: direction === "end" || direction === "right",
            show: isOpen,
            "nav-item": nav
        }), cssModule);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$df140987c38a308d.Provider, {
            value: this.getContextValue()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement((0, $cb0b0dd810051858$export$d0d38e7dec7a1a61), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attrs, {
            [typeof Tag === "string" ? "ref" : "innerRef"]: this.containerRef,
            onKeyDown: this.handleKeyDown,
            className: classes
        }))));
    }
}
$51b32cf9efbde13e$var$Dropdown.propTypes = $51b32cf9efbde13e$var$propTypes$16;
$51b32cf9efbde13e$var$Dropdown.defaultProps = $51b32cf9efbde13e$var$defaultProps$14;
var $51b32cf9efbde13e$export$931cbfb6bfb85fc = $51b32cf9efbde13e$var$Dropdown;
const $51b32cf9efbde13e$var$propTypes$15 = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
};
const $51b32cf9efbde13e$var$ButtonDropdown = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$931cbfb6bfb85fc, $51b32cf9efbde13e$var$_extends({
        group: true
    }, props));
};
$51b32cf9efbde13e$var$ButtonDropdown.propTypes = $51b32cf9efbde13e$var$propTypes$15;
var $51b32cf9efbde13e$export$72d7ed2c84b0d1c0 = $51b32cf9efbde13e$var$ButtonDropdown;
const $51b32cf9efbde13e$var$_excluded$$ = [
    "className",
    "cssModule",
    "size",
    "vertical",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$14 = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    vertical: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
const $51b32cf9efbde13e$var$defaultProps$13 = {
    tag: "div",
    role: "group"
};
const $51b32cf9efbde13e$var$ButtonGroup = (props)=>{
    const { className: className, cssModule: cssModule, size: size, vertical: vertical, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$$);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, size ? "btn-group-" + size : false, vertical ? "btn-group-vertical" : "btn-group"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$ButtonGroup.propTypes = $51b32cf9efbde13e$var$propTypes$14;
$51b32cf9efbde13e$var$ButtonGroup.defaultProps = $51b32cf9efbde13e$var$defaultProps$13;
var $51b32cf9efbde13e$export$69b1032f2ecdf404 = $51b32cf9efbde13e$var$ButtonGroup;
const $51b32cf9efbde13e$var$_excluded$_ = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$13 = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
const $51b32cf9efbde13e$var$defaultProps$12 = {
    tag: "div",
    role: "toolbar"
};
const $51b32cf9efbde13e$var$ButtonToolbar = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$_);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "btn-toolbar"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$ButtonToolbar.propTypes = $51b32cf9efbde13e$var$propTypes$13;
$51b32cf9efbde13e$var$ButtonToolbar.defaultProps = $51b32cf9efbde13e$var$defaultProps$12;
var $51b32cf9efbde13e$export$478f41ba79e7b570 = $51b32cf9efbde13e$var$ButtonToolbar;
const $51b32cf9efbde13e$var$_excluded$Z = [
    "className",
    "cssModule",
    "divider",
    "tag",
    "header",
    "active",
    "text"
];
const $51b32cf9efbde13e$var$propTypes$12 = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    divider: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    tag: $51b32cf9efbde13e$var$tagPropType,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
const $51b32cf9efbde13e$var$defaultProps$11 = {
    tag: "button",
    toggle: true
};
class $51b32cf9efbde13e$var$DropdownItem extends (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component {
    constructor(props){
        super(props);
        this.onClick = this.onClick.bind(this);
        this.getTabIndex = this.getTabIndex.bind(this);
    }
    getRole() {
        if (this.context.menuRole === "listbox") return "option";
        return "menuitem";
    }
    onClick(e) {
        const { disabled: disabled, header: header, divider: divider, text: text } = this.props;
        if (disabled || header || divider || text) {
            e.preventDefault();
            return;
        }
        if (this.props.onClick) this.props.onClick(e);
        if (this.props.toggle) this.context.toggle(e);
    }
    getTabIndex() {
        const { disabled: disabled, header: header, divider: divider, text: text } = this.props;
        if (disabled || header || divider || text) return "-1";
        return "0";
    }
    render() {
        const tabIndex = this.getTabIndex();
        const role = tabIndex > -1 ? this.getRole() : undefined;
        let _omit = $51b32cf9efbde13e$var$omit(this.props, [
            "toggle"
        ]), { className: className, cssModule: cssModule, divider: divider, tag: Tag, header: header, active: active, text: text } = _omit, props = $51b32cf9efbde13e$var$_objectWithoutProperties(_omit, $51b32cf9efbde13e$var$_excluded$Z);
        const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, {
            disabled: props.disabled,
            "dropdown-item": !divider && !header && !text,
            active: active,
            "dropdown-header": header,
            "dropdown-divider": divider,
            "dropdown-item-text": text
        }), cssModule);
        if (Tag === "button") {
            if (header) Tag = "h6";
            else if (divider) Tag = "div";
            else if (props.href) Tag = "a";
            else if (text) Tag = "span";
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({
            type: Tag === "button" && (props.onClick || this.props.toggle) ? "button" : undefined
        }, props, {
            tabIndex: tabIndex,
            role: role,
            className: classes,
            onClick: this.onClick
        }));
    }
}
$51b32cf9efbde13e$var$DropdownItem.propTypes = $51b32cf9efbde13e$var$propTypes$12;
$51b32cf9efbde13e$var$DropdownItem.defaultProps = $51b32cf9efbde13e$var$defaultProps$11;
$51b32cf9efbde13e$var$DropdownItem.contextType = $51b32cf9efbde13e$export$df140987c38a308d;
var $51b32cf9efbde13e$export$6648d5fa18559e7f = $51b32cf9efbde13e$var$DropdownItem;
const $51b32cf9efbde13e$var$_excluded$Y = [
    "className",
    "cssModule",
    "dark",
    "end",
    "right",
    "tag",
    "flip",
    "modifiers",
    "persist",
    "strategy",
    "container"
];
const $51b32cf9efbde13e$var$propTypes$11 = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node.isRequired,
    dark: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    end: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).array,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    persist: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    strategy: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    container: $51b32cf9efbde13e$var$targetPropType,
    right: $51b32cf9efbde13e$var$deprecated((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool, 'Please use "end" instead.')
};
const $51b32cf9efbde13e$var$defaultProps$10 = {
    tag: "div",
    flip: true,
    modifiers: []
};
const $51b32cf9efbde13e$var$directionPositionMap = {
    up: "top",
    left: "left",
    right: "right",
    start: "left",
    end: "right",
    down: "bottom"
};
class $51b32cf9efbde13e$var$DropdownMenu extends (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component {
    getRole() {
        if (this.context.menuRole === "listbox") return "listbox";
        return "menu";
    }
    render() {
        const _this$props = this.props, { className: className, cssModule: cssModule, dark: dark, end: end, right: right, tag: tag, flip: flip, modifiers: modifiers, persist: persist, strategy: strategy, container: container } = _this$props, attrs = $51b32cf9efbde13e$var$_objectWithoutProperties(_this$props, $51b32cf9efbde13e$var$_excluded$Y);
        const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "dropdown-menu", {
            "dropdown-menu-dark": dark,
            "dropdown-menu-end": end || right,
            show: this.context.isOpen
        }), cssModule);
        const Tag = tag;
        if (persist || this.context.isOpen && !this.context.inNavbar) {
            const position1 = $51b32cf9efbde13e$var$directionPositionMap[this.context.direction] || "bottom";
            const position2 = end || right ? "end" : "start";
            const poperPlacement = `${position1}-${position2}`;
            const poperModifiers = [
                ...modifiers,
                {
                    name: "flip",
                    enabled: !!flip
                }
            ];
            const popper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement((0, $1fd7a0715ff9509b$export$badac9ada3a0bdf9), {
                placement: poperPlacement,
                modifiers: poperModifiers,
                strategy: strategy
            }, ({ ref: ref, style: style, placement: placement })=>{
                let combinedStyle = $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, this.props.style), style);
                const handleRef = (tagRef)=>{
                    // Send the ref to `react-popper`
                    ref(tagRef); // Send the ref to the parent Dropdown so that clicks outside
                    // it will cause it to close
                    const { onMenuRef: onMenuRef } = this.context;
                    if (onMenuRef) onMenuRef(tagRef);
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({
                    tabIndex: "-1",
                    role: this.getRole(),
                    ref: handleRef
                }, attrs, {
                    style: combinedStyle,
                    "aria-hidden": !this.context.isOpen,
                    className: classes,
                    "data-popper-placement": placement
                }));
            });
            if (container) return (0, (/*@__PURE__*/$parcel$interopDefault($f419cfc3d92fe631$exports))).createPortal(popper, $51b32cf9efbde13e$var$getTarget(container));
            else return popper;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({
            tabIndex: "-1",
            role: this.getRole()
        }, attrs, {
            "aria-hidden": !this.context.isOpen,
            className: classes,
            "data-popper-placement": attrs.placement
        }));
    }
}
$51b32cf9efbde13e$var$DropdownMenu.propTypes = $51b32cf9efbde13e$var$propTypes$11;
$51b32cf9efbde13e$var$DropdownMenu.defaultProps = $51b32cf9efbde13e$var$defaultProps$10;
$51b32cf9efbde13e$var$DropdownMenu.contextType = $51b32cf9efbde13e$export$df140987c38a308d;
var $51b32cf9efbde13e$export$e44a253a59704894 = $51b32cf9efbde13e$var$DropdownMenu;
const $51b32cf9efbde13e$var$_excluded$X = [
    "className",
    "color",
    "cssModule",
    "caret",
    "split",
    "nav",
    "tag",
    "innerRef"
];
const $51b32cf9efbde13e$var$propTypes$10 = {
    caret: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    "aria-haspopup": (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    split: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    tag: $51b32cf9efbde13e$var$tagPropType,
    nav: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
const $51b32cf9efbde13e$var$defaultProps$$ = {
    color: "secondary",
    "aria-haspopup": true
};
class $51b32cf9efbde13e$var$DropdownToggle extends (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component {
    constructor(props){
        super(props);
        this.onClick = this.onClick.bind(this);
    }
    onClick(e) {
        if (this.props.disabled || this.context.disabled) {
            e.preventDefault();
            return;
        }
        if (this.props.nav && !this.props.tag) e.preventDefault();
        if (this.props.onClick) this.props.onClick(e);
        this.context.toggle(e);
    }
    getRole() {
        return this.context.menuRole || this.props["aria-haspopup"];
    }
    render() {
        const _this$props = this.props, { className: className, color: color, cssModule: cssModule, caret: caret, split: split, nav: nav, tag: tag, innerRef: innerRef } = _this$props, props = $51b32cf9efbde13e$var$_objectWithoutProperties(_this$props, $51b32cf9efbde13e$var$_excluded$X);
        const ariaLabel = props["aria-label"] || "Toggle Dropdown";
        const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, {
            "dropdown-toggle": caret || split,
            "dropdown-toggle-split": split,
            "nav-link": nav
        }), cssModule);
        const children = typeof props.children !== "undefined" ? props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("span", {
            className: "visually-hidden"
        }, ariaLabel);
        let Tag;
        if (nav && !tag) {
            Tag = "a";
            props.href = "#";
        } else if (!tag) {
            Tag = $51b32cf9efbde13e$export$353f5b6fc5456de1;
            props.color = color;
            props.cssModule = cssModule;
        } else Tag = tag;
        if (this.context.inNavbar) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, props, {
            className: classes,
            onClick: this.onClick,
            "aria-expanded": this.context.isOpen,
            "aria-haspopup": this.getRole(),
            children: children
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement((0, $4303928b97615b86$export$e0be378c32fb70a7), {
            innerRef: innerRef
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, props, {
                [typeof Tag === "string" ? "ref" : "innerRef"]: ref,
                className: classes,
                onClick: this.onClick,
                "aria-expanded": this.context.isOpen,
                "aria-haspopup": this.getRole(),
                children: children
            })));
    }
}
$51b32cf9efbde13e$var$DropdownToggle.propTypes = $51b32cf9efbde13e$var$propTypes$10;
$51b32cf9efbde13e$var$DropdownToggle.defaultProps = $51b32cf9efbde13e$var$defaultProps$$;
$51b32cf9efbde13e$var$DropdownToggle.contextType = $51b32cf9efbde13e$export$df140987c38a308d;
var $51b32cf9efbde13e$export$8d5b7ffbb681f107 = $51b32cf9efbde13e$var$DropdownToggle;
const $51b32cf9efbde13e$var$_excluded$W = [
    "tag",
    "baseClass",
    "baseClassActive",
    "className",
    "cssModule",
    "children",
    "innerRef"
];
const $51b32cf9efbde13e$var$propTypes$$ = $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, (0, $a648815ae929180c$export$2e2bcd8739ae039).propTypes), {}, {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node),
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    tag: $51b32cf9efbde13e$var$tagPropType,
    baseClass: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    baseClassActive: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    ])
});
const $51b32cf9efbde13e$var$defaultProps$_ = $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, (0, $a648815ae929180c$export$2e2bcd8739ae039).defaultProps), {}, {
    tag: "div",
    baseClass: "fade",
    baseClassActive: "show",
    timeout: $51b32cf9efbde13e$var$TransitionTimeouts.Fade,
    appear: true,
    enter: true,
    exit: true,
    in: true
});
function $51b32cf9efbde13e$export$c983850c6c9d8b0e(props) {
    const { tag: Tag, baseClass: baseClass, baseClassActive: baseClassActive, className: className, cssModule: cssModule, children: children, innerRef: innerRef } = props, otherProps = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$W);
    const transitionProps = $51b32cf9efbde13e$var$pick(otherProps, $51b32cf9efbde13e$var$TransitionPropTypeKeys);
    const childProps = $51b32cf9efbde13e$var$omit(otherProps, $51b32cf9efbde13e$var$TransitionPropTypeKeys);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement((0, $a648815ae929180c$export$2e2bcd8739ae039), transitionProps, (status)=>{
        const isActive = status === "entered";
        const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, baseClass, isActive && baseClassActive), cssModule);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({
            className: classes
        }, childProps, {
            ref: innerRef
        }), children);
    });
}
$51b32cf9efbde13e$export$c983850c6c9d8b0e.propTypes = $51b32cf9efbde13e$var$propTypes$$;
$51b32cf9efbde13e$export$c983850c6c9d8b0e.defaultProps = $51b32cf9efbde13e$var$defaultProps$_;
/**
 * AccordionContext
 * {
 *  toggle: PropTypes.func.isRequired,
 *  openId: PropTypes.string,    
 * }
 */ const $51b32cf9efbde13e$export$6bd5bb82c987ab74 = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext({});
const $51b32cf9efbde13e$var$_excluded$V = [
    "flush",
    "open",
    "toggle",
    "className",
    "cssModule",
    "tag",
    "innerRef"
];
const $51b32cf9efbde13e$var$propTypes$_ = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    flush: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]).isRequired,
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func.isRequired
};
const $51b32cf9efbde13e$var$defaultProps$Z = {
    tag: "div"
};
const $51b32cf9efbde13e$var$Accordion = (props)=>{
    const { flush: flush, open: open, toggle: toggle, className: className, cssModule: cssModule, tag: Tag, innerRef: innerRef } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$V);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "accordion", {
        "accordion-flush": flush
    }), cssModule);
    const accordionContext = (0, $tZqWC.useMemo)(()=>({
            open: open,
            toggle: toggle
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$6bd5bb82c987ab74.Provider, {
        value: accordionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes,
        ref: innerRef
    })));
};
$51b32cf9efbde13e$var$Accordion.propTypes = $51b32cf9efbde13e$var$propTypes$_;
$51b32cf9efbde13e$var$Accordion.defaultProps = $51b32cf9efbde13e$var$defaultProps$Z;
var $51b32cf9efbde13e$export$a766cd26d0d69044 = $51b32cf9efbde13e$var$Accordion;
const $51b32cf9efbde13e$var$_excluded$U = [
    "defaultOpen",
    "stayOpen"
];
const $51b32cf9efbde13e$var$propTypes$Z = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    defaultOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    stayOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
const $51b32cf9efbde13e$var$defaultProps$Y = {
    tag: "div"
};
const $51b32cf9efbde13e$var$UncontrolledAccordion = (_ref)=>{
    let { defaultOpen: defaultOpen, stayOpen: stayOpen } = _ref, props = $51b32cf9efbde13e$var$_objectWithoutProperties(_ref, $51b32cf9efbde13e$var$_excluded$U);
    const [open, setOpen] = (0, $tZqWC.useState)(defaultOpen || (stayOpen ? [] : undefined));
    const toggle = (id)=>{
        if (stayOpen) open.includes(id) ? setOpen(open.filter((accordionId)=>accordionId !== id)) : setOpen([
            ...open,
            id
        ]);
        else open === id ? setOpen(undefined) : setOpen(id);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$a766cd26d0d69044, $51b32cf9efbde13e$var$_extends({}, props, {
        open: open,
        toggle: toggle
    }));
};
$51b32cf9efbde13e$export$a766cd26d0d69044.propTypes = $51b32cf9efbde13e$var$propTypes$Z;
$51b32cf9efbde13e$export$a766cd26d0d69044.defaultProps = $51b32cf9efbde13e$var$defaultProps$Y;
var $51b32cf9efbde13e$export$6c450cf37c32979e = $51b32cf9efbde13e$var$UncontrolledAccordion;
const $51b32cf9efbde13e$var$_excluded$T = [
    "className",
    "cssModule",
    "tag",
    "innerRef",
    "children",
    "targetId"
];
const $51b32cf9efbde13e$var$propTypes$Y = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    targetId: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string.isRequired
};
const $51b32cf9efbde13e$var$defaultProps$X = {
    tag: "h2"
};
const $51b32cf9efbde13e$var$AccordionHeader = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag, innerRef: innerRef, children: children, targetId: targetId } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$T);
    const { open: open, toggle: toggle } = (0, $tZqWC.useContext)($51b32cf9efbde13e$export$6bd5bb82c987ab74);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "accordion-header"), cssModule);
    const buttonClasses = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("accordion-button", {
        collapsed: !(Array.isArray(open) ? open.includes(targetId) : open === targetId)
    }), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes,
        ref: innerRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("button", {
        type: "button",
        className: buttonClasses,
        onClick: ()=>toggle(targetId)
    }, children));
};
$51b32cf9efbde13e$var$AccordionHeader.propTypes = $51b32cf9efbde13e$var$propTypes$Y;
$51b32cf9efbde13e$var$AccordionHeader.defaultProps = $51b32cf9efbde13e$var$defaultProps$X;
var $51b32cf9efbde13e$export$5e3e5deaaf81ee41 = $51b32cf9efbde13e$var$AccordionHeader;
const $51b32cf9efbde13e$var$_excluded$S = [
    "className",
    "cssModule",
    "tag",
    "innerRef"
];
const $51b32cf9efbde13e$var$propTypes$X = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
};
const $51b32cf9efbde13e$var$defaultProps$W = {
    tag: "div"
};
const $51b32cf9efbde13e$var$AccordionItem$2 = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag, innerRef: innerRef } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$S);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "accordion-item"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes,
        ref: innerRef
    }));
};
$51b32cf9efbde13e$var$AccordionItem$2.propTypes = $51b32cf9efbde13e$var$propTypes$X;
$51b32cf9efbde13e$var$AccordionItem$2.defaultProps = $51b32cf9efbde13e$var$defaultProps$W;
var $51b32cf9efbde13e$export$d99097c13d4dac9f = $51b32cf9efbde13e$var$AccordionItem$2;
const $51b32cf9efbde13e$var$_excluded$R = [
    "tag",
    "horizontal",
    "isOpen",
    "className",
    "navbar",
    "cssModule",
    "children",
    "innerRef"
];
const $51b32cf9efbde13e$var$propTypes$W = $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, (0, $a648815ae929180c$export$2e2bcd8739ae039).propTypes), {}, {
    horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node),
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    navbar: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
    ])
});
const $51b32cf9efbde13e$var$defaultProps$V = $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, (0, $a648815ae929180c$export$2e2bcd8739ae039).defaultProps), {}, {
    horizontal: false,
    isOpen: false,
    appear: false,
    enter: true,
    exit: true,
    tag: "div",
    timeout: $51b32cf9efbde13e$var$TransitionTimeouts.Collapse
});
const $51b32cf9efbde13e$var$transitionStatusToClassHash = {
    [$51b32cf9efbde13e$var$TransitionStatuses.ENTERING]: "collapsing",
    [$51b32cf9efbde13e$var$TransitionStatuses.ENTERED]: "collapse show",
    [$51b32cf9efbde13e$var$TransitionStatuses.EXITING]: "collapsing",
    [$51b32cf9efbde13e$var$TransitionStatuses.EXITED]: "collapse"
};
function $51b32cf9efbde13e$var$getTransitionClass(status) {
    return $51b32cf9efbde13e$var$transitionStatusToClassHash[status] || "collapse";
}
class $51b32cf9efbde13e$var$Collapse extends (0, $tZqWC.Component) {
    constructor(props){
        super(props);
        this.state = {
            dimension: null
        };
        [
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited"
        ].forEach((name)=>{
            this[name] = this[name].bind(this);
        });
    }
    getDimension(node) {
        return this.props.horizontal ? node.scrollWidth : node.scrollHeight;
    }
    onEntering(node, isAppearing) {
        this.setState({
            dimension: this.getDimension(node)
        });
        this.props.onEntering(node, isAppearing);
    }
    onEntered(node, isAppearing) {
        this.setState({
            dimension: null
        });
        this.props.onEntered(node, isAppearing);
    }
    onExit(node) {
        this.setState({
            dimension: this.getDimension(node)
        });
        this.props.onExit(node);
    }
    onExiting(node) {
        // getting this variable triggers a reflow
        this.getDimension(node); // eslint-disable-line no-unused-vars
        this.setState({
            dimension: 0
        });
        this.props.onExiting(node);
    }
    onExited(node) {
        this.setState({
            dimension: null
        });
        this.props.onExited(node);
    }
    render() {
        const _this$props = this.props, { tag: Tag, horizontal: horizontal, isOpen: isOpen, className: className, navbar: navbar, cssModule: cssModule, children: children, innerRef: innerRef } = _this$props, otherProps = $51b32cf9efbde13e$var$_objectWithoutProperties(_this$props, $51b32cf9efbde13e$var$_excluded$R);
        const { dimension: dimension } = this.state;
        const transitionProps = $51b32cf9efbde13e$var$pick(otherProps, $51b32cf9efbde13e$var$TransitionPropTypeKeys);
        const childProps = $51b32cf9efbde13e$var$omit(otherProps, $51b32cf9efbde13e$var$TransitionPropTypeKeys);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement((0, $a648815ae929180c$export$2e2bcd8739ae039), $51b32cf9efbde13e$var$_extends({}, transitionProps, {
            in: isOpen,
            onEntering: this.onEntering,
            onEntered: this.onEntered,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }), (status)=>{
            let collapseClass = $51b32cf9efbde13e$var$getTransitionClass(status);
            const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, horizontal && "collapse-horizontal", collapseClass, navbar && "navbar-collapse"), cssModule);
            const style = dimension === null ? null : {
                [horizontal ? "width" : "height"]: dimension
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, childProps, {
                style: $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, childProps.style), style),
                className: classes,
                ref: this.props.innerRef
            }), children);
        });
    }
}
$51b32cf9efbde13e$var$Collapse.propTypes = $51b32cf9efbde13e$var$propTypes$W;
$51b32cf9efbde13e$var$Collapse.defaultProps = $51b32cf9efbde13e$var$defaultProps$V;
var $51b32cf9efbde13e$export$78768a9af065a7b = $51b32cf9efbde13e$var$Collapse;
const $51b32cf9efbde13e$var$_excluded$Q = [
    "className",
    "cssModule",
    "tag",
    "innerRef",
    "children",
    "accordionId"
];
const $51b32cf9efbde13e$var$propTypes$V = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    accordionId: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string.isRequired
};
const $51b32cf9efbde13e$var$defaultProps$U = {
    tag: "div"
};
const $51b32cf9efbde13e$var$AccordionItem = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag, innerRef: innerRef, children: children, accordionId: accordionId } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$Q);
    const { open: open } = (0, $tZqWC.useContext)($51b32cf9efbde13e$export$6bd5bb82c987ab74);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "accordion-collapse"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$78768a9af065a7b, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes,
        ref: innerRef,
        isOpen: Array.isArray(open) ? open.includes(accordionId) : open === accordionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, {
        className: "accordion-body"
    }, children));
};
$51b32cf9efbde13e$var$AccordionItem.propTypes = $51b32cf9efbde13e$var$propTypes$V;
$51b32cf9efbde13e$var$AccordionItem.defaultProps = $51b32cf9efbde13e$var$defaultProps$U;
var $51b32cf9efbde13e$export$4f68206c92b94e7b = $51b32cf9efbde13e$var$AccordionItem;
const $51b32cf9efbde13e$var$_excluded$P = [
    "className",
    "cssModule",
    "color",
    "innerRef",
    "pill",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$U = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    pill: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    tag: $51b32cf9efbde13e$var$tagPropType,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$T = {
    color: "secondary",
    pill: false,
    tag: "span"
};
const $51b32cf9efbde13e$var$Badge = (props)=>{
    let { className: className, cssModule: cssModule, color: color, innerRef: innerRef, pill: pill, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$P);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "badge", "bg-" + color, pill ? "rounded-pill" : false), cssModule);
    if (attributes.href && Tag === "span") Tag = "a";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes,
        ref: innerRef
    }));
};
$51b32cf9efbde13e$var$Badge.propTypes = $51b32cf9efbde13e$var$propTypes$U;
$51b32cf9efbde13e$var$Badge.defaultProps = $51b32cf9efbde13e$var$defaultProps$T;
var $51b32cf9efbde13e$export$37acb3580601e69a = $51b32cf9efbde13e$var$Badge;
const $51b32cf9efbde13e$var$_excluded$O = [
    "className",
    "cssModule",
    "color",
    "body",
    "inverse",
    "outline",
    "tag",
    "innerRef"
];
const $51b32cf9efbde13e$var$propTypes$T = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    inverse: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    body: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    outline: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    ])
};
const $51b32cf9efbde13e$var$defaultProps$S = {
    tag: "div"
};
const $51b32cf9efbde13e$var$Card = (props)=>{
    const { className: className, cssModule: cssModule, color: color, body: body, inverse: inverse, outline: outline, tag: Tag, innerRef: innerRef } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$O);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "card", inverse ? "text-white" : false, body ? "card-body" : false, color ? `${outline ? "border" : "bg"}-${color}` : false), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes,
        ref: innerRef
    }));
};
$51b32cf9efbde13e$var$Card.propTypes = $51b32cf9efbde13e$var$propTypes$T;
$51b32cf9efbde13e$var$Card.defaultProps = $51b32cf9efbde13e$var$defaultProps$S;
var $51b32cf9efbde13e$export$60332b2344f7fe41 = $51b32cf9efbde13e$var$Card;
const $51b32cf9efbde13e$var$_excluded$N = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$S = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$R = {
    tag: "div"
};
const $51b32cf9efbde13e$var$CardGroup = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$N);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "card-group"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$CardGroup.propTypes = $51b32cf9efbde13e$var$propTypes$S;
$51b32cf9efbde13e$var$CardGroup.defaultProps = $51b32cf9efbde13e$var$defaultProps$R;
var $51b32cf9efbde13e$export$9acc0474485b44b2 = $51b32cf9efbde13e$var$CardGroup;
const $51b32cf9efbde13e$var$_excluded$M = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$R = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$Q = {
    tag: "div"
};
const $51b32cf9efbde13e$var$CardDeck = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$M);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "card-deck"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$CardDeck.propTypes = $51b32cf9efbde13e$var$propTypes$R;
$51b32cf9efbde13e$var$CardDeck.defaultProps = $51b32cf9efbde13e$var$defaultProps$Q;
var $51b32cf9efbde13e$export$98cd294fe7ef15d5 = $51b32cf9efbde13e$var$CardDeck;
const $51b32cf9efbde13e$var$_excluded$L = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$Q = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$P = {
    tag: "div"
};
const $51b32cf9efbde13e$var$CardColumns = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$L);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "card-columns"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$CardColumns.propTypes = $51b32cf9efbde13e$var$propTypes$Q;
$51b32cf9efbde13e$var$CardColumns.defaultProps = $51b32cf9efbde13e$var$defaultProps$P;
var $51b32cf9efbde13e$export$7df7c701a29eb196 = $51b32cf9efbde13e$var$CardColumns;
const $51b32cf9efbde13e$var$_excluded$K = [
    "className",
    "cssModule",
    "innerRef",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$P = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    ])
};
const $51b32cf9efbde13e$var$defaultProps$O = {
    tag: "div"
};
const $51b32cf9efbde13e$var$CardBody = (props)=>{
    const { className: className, cssModule: cssModule, innerRef: innerRef, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$K);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "card-body"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes,
        ref: innerRef
    }));
};
$51b32cf9efbde13e$var$CardBody.propTypes = $51b32cf9efbde13e$var$propTypes$P;
$51b32cf9efbde13e$var$CardBody.defaultProps = $51b32cf9efbde13e$var$defaultProps$O;
var $51b32cf9efbde13e$export$851de33184ecdac4 = $51b32cf9efbde13e$var$CardBody;
const $51b32cf9efbde13e$var$_excluded$J = [
    "className",
    "cssModule",
    "tag",
    "innerRef"
];
const $51b32cf9efbde13e$var$propTypes$O = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$N = {
    tag: "a"
};
const $51b32cf9efbde13e$var$CardLink = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag, innerRef: innerRef } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$J);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "card-link"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        ref: innerRef,
        className: classes
    }));
};
$51b32cf9efbde13e$var$CardLink.propTypes = $51b32cf9efbde13e$var$propTypes$O;
$51b32cf9efbde13e$var$CardLink.defaultProps = $51b32cf9efbde13e$var$defaultProps$N;
var $51b32cf9efbde13e$export$94b4c87f5c7de894 = $51b32cf9efbde13e$var$CardLink;
const $51b32cf9efbde13e$var$_excluded$I = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$N = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$M = {
    tag: "div"
};
const $51b32cf9efbde13e$var$CardFooter = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$I);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "card-footer"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$CardFooter.propTypes = $51b32cf9efbde13e$var$propTypes$N;
$51b32cf9efbde13e$var$CardFooter.defaultProps = $51b32cf9efbde13e$var$defaultProps$M;
var $51b32cf9efbde13e$export$e9897d434e0741ee = $51b32cf9efbde13e$var$CardFooter;
const $51b32cf9efbde13e$var$_excluded$H = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$M = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$L = {
    tag: "div"
};
const $51b32cf9efbde13e$var$CardHeader = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$H);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "card-header"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$CardHeader.propTypes = $51b32cf9efbde13e$var$propTypes$M;
$51b32cf9efbde13e$var$CardHeader.defaultProps = $51b32cf9efbde13e$var$defaultProps$L;
var $51b32cf9efbde13e$export$5665775b26e26c5d = $51b32cf9efbde13e$var$CardHeader;
const $51b32cf9efbde13e$var$_excluded$G = [
    "className",
    "cssModule",
    "top",
    "bottom",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$L = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    top: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    bottom: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$K = {
    tag: "img"
};
const $51b32cf9efbde13e$var$CardImg = (props)=>{
    const { className: className, cssModule: cssModule, top: top, bottom: bottom, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$G);
    let cardImgClassName = "card-img";
    if (top) cardImgClassName = "card-img-top";
    if (bottom) cardImgClassName = "card-img-bottom";
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, cardImgClassName), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$CardImg.propTypes = $51b32cf9efbde13e$var$propTypes$L;
$51b32cf9efbde13e$var$CardImg.defaultProps = $51b32cf9efbde13e$var$defaultProps$K;
var $51b32cf9efbde13e$export$96c5f37208f78bd7 = $51b32cf9efbde13e$var$CardImg;
const $51b32cf9efbde13e$var$_excluded$F = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$K = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$J = {
    tag: "div"
};
const $51b32cf9efbde13e$var$CardImgOverlay = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$F);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "card-img-overlay"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$CardImgOverlay.propTypes = $51b32cf9efbde13e$var$propTypes$K;
$51b32cf9efbde13e$var$CardImgOverlay.defaultProps = $51b32cf9efbde13e$var$defaultProps$J;
var $51b32cf9efbde13e$export$ad87e87dbc979c1a = $51b32cf9efbde13e$var$CardImgOverlay;
const $51b32cf9efbde13e$var$_excluded$E = [
    "in",
    "children",
    "cssModule",
    "slide",
    "tag",
    "className"
];
class $51b32cf9efbde13e$var$CarouselItem extends (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component {
    constructor(props){
        super(props);
        this.state = {
            startAnimation: false
        };
        this.onEnter = this.onEnter.bind(this);
        this.onEntering = this.onEntering.bind(this);
        this.onExit = this.onExit.bind(this);
        this.onExiting = this.onExiting.bind(this);
        this.onExited = this.onExited.bind(this);
    }
    onEnter(node, isAppearing) {
        this.setState({
            startAnimation: false
        });
        this.props.onEnter(node, isAppearing);
    }
    onEntering(node, isAppearing) {
        // getting this variable triggers a reflow
        const offsetHeight = node.offsetHeight;
        this.setState({
            startAnimation: true
        });
        this.props.onEntering(node, isAppearing);
        return offsetHeight;
    }
    onExit(node) {
        this.setState({
            startAnimation: false
        });
        this.props.onExit(node);
    }
    onExiting(node) {
        this.setState({
            startAnimation: true
        });
        node.dispatchEvent(new CustomEvent("slide.bs.carousel"));
        this.props.onExiting(node);
    }
    onExited(node) {
        node.dispatchEvent(new CustomEvent("slid.bs.carousel"));
        this.props.onExited(node);
    }
    render() {
        const _this$props = this.props, { in: isIn, children: children, cssModule: cssModule, slide: slide, tag: Tag, className: className } = _this$props, transitionProps = $51b32cf9efbde13e$var$_objectWithoutProperties(_this$props, $51b32cf9efbde13e$var$_excluded$E);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement((0, $a648815ae929180c$export$2e2bcd8739ae039), $51b32cf9efbde13e$var$_extends({}, transitionProps, {
            enter: slide,
            exit: slide,
            in: isIn,
            onEnter: this.onEnter,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }), (status)=>{
            const { direction: direction } = this.context;
            const isActive = status === $51b32cf9efbde13e$var$TransitionStatuses.ENTERED || status === $51b32cf9efbde13e$var$TransitionStatuses.EXITING;
            const directionClassName = (status === $51b32cf9efbde13e$var$TransitionStatuses.ENTERING || status === $51b32cf9efbde13e$var$TransitionStatuses.EXITING) && this.state.startAnimation && (direction === "end" ? "carousel-item-start" : "carousel-item-end");
            const orderClassName = status === $51b32cf9efbde13e$var$TransitionStatuses.ENTERING && (direction === "end" ? "carousel-item-next" : "carousel-item-prev");
            const itemClasses = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "carousel-item", isActive && "active", directionClassName, orderClassName), cssModule);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, {
                className: itemClasses
            }, children);
        });
    }
}
$51b32cf9efbde13e$var$CarouselItem.propTypes = $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, (0, $a648815ae929180c$export$2e2bcd8739ae039).propTypes), {}, {
    tag: $51b32cf9efbde13e$var$tagPropType,
    in: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    slide: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
});
$51b32cf9efbde13e$var$CarouselItem.defaultProps = $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, (0, $a648815ae929180c$export$2e2bcd8739ae039).defaultProps), {}, {
    tag: "div",
    timeout: $51b32cf9efbde13e$var$TransitionTimeouts.Carousel,
    slide: true
});
$51b32cf9efbde13e$var$CarouselItem.contextTypes = {
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $51b32cf9efbde13e$export$42c20acb2971398c = $51b32cf9efbde13e$var$CarouselItem;
/**
 * CarouselContext
 * {
 *  direction: PropTypes.oneOf(['start', 'end']).isRequired,
 * }
 */ const $51b32cf9efbde13e$var$CarouselContext = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext({});
const $51b32cf9efbde13e$var$SWIPE_THRESHOLD = 40;
class $51b32cf9efbde13e$var$Carousel extends (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component {
    constructor(props){
        super(props);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.renderItems = this.renderItems.bind(this);
        this.hoverStart = this.hoverStart.bind(this);
        this.hoverEnd = this.hoverEnd.bind(this);
        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.state = {
            activeIndex: this.props.activeIndex,
            direction: "end",
            indicatorClicked: false
        };
    }
    getContextValue() {
        return {
            direction: this.state.direction
        };
    }
    componentDidMount() {
        // Set up the cycle
        if (this.props.ride === "carousel") this.setInterval();
         // TODO: move this to the specific carousel like bootstrap. Currently it will trigger ALL carousels on the page.
        document.addEventListener("keyup", this.handleKeyPress);
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        let newState = null;
        let { activeIndex: activeIndex, direction: direction, indicatorClicked: indicatorClicked } = prevState;
        if (nextProps.activeIndex !== activeIndex) {
            // Calculate the direction to turn
            if (nextProps.activeIndex === activeIndex + 1) direction = "end";
            else if (nextProps.activeIndex === activeIndex - 1) direction = "start";
            else if (nextProps.activeIndex < activeIndex) direction = indicatorClicked ? "start" : "end";
            else if (nextProps.activeIndex !== activeIndex) direction = indicatorClicked ? "end" : "start";
            newState = {
                activeIndex: nextProps.activeIndex,
                direction: direction,
                indicatorClicked: false
            };
        }
        return newState;
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.activeIndex === this.state.activeIndex) return;
        this.setInterval(this.props);
    }
    componentWillUnmount() {
        this.clearInterval();
        document.removeEventListener("keyup", this.handleKeyPress);
    }
    setInterval(props = this.props) {
        // make sure not to have multiple intervals going...
        this.clearInterval();
        if (props.interval) this.cycleInterval = setInterval(()=>{
            props.next();
        }, parseInt(props.interval, 10));
    }
    clearInterval() {
        clearInterval(this.cycleInterval);
    }
    hoverStart(...args) {
        if (this.props.pause === "hover") this.clearInterval();
        if (this.props.mouseEnter) this.props.mouseEnter(...args);
    }
    hoverEnd(...args) {
        if (this.props.pause === "hover") this.setInterval();
        if (this.props.mouseLeave) this.props.mouseLeave(...args);
    }
    handleKeyPress(evt) {
        if (this.props.keyboard) {
            if (evt.keyCode === 37) this.props.previous();
            else if (evt.keyCode === 39) this.props.next();
        }
    }
    handleTouchStart(e) {
        if (!this.props.enableTouch) return;
        this.touchStartX = e.changedTouches[0].screenX;
        this.touchStartY = e.changedTouches[0].screenY;
    }
    handleTouchEnd(e) {
        if (!this.props.enableTouch) return;
        const currentX = e.changedTouches[0].screenX;
        const currentY = e.changedTouches[0].screenY;
        const diffX = Math.abs(this.touchStartX - currentX);
        const diffY = Math.abs(this.touchStartY - currentY); // Don't swipe if Y-movement is bigger than X-movement
        if (diffX < diffY) return;
        if (diffX < $51b32cf9efbde13e$var$SWIPE_THRESHOLD) return;
        if (currentX < this.touchStartX) this.props.next();
        else this.props.previous();
    }
    renderItems(carouselItems, className) {
        const { slide: slide } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("div", {
            className: className
        }, carouselItems.map((item, index)=>{
            const isIn = index === this.state.activeIndex;
            return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).cloneElement(item, {
                in: isIn,
                slide: slide
            });
        }));
    }
    render() {
        const { cssModule: cssModule, slide: slide, className: className, dark: dark, fade: fade } = this.props;
        const outerClasses = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "carousel", fade, slide && "slide", dark && "carousel-dark"), cssModule);
        const innerClasses = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("carousel-inner"), cssModule); // filter out booleans, null, or undefined
        const children = this.props.children.filter((child)=>child !== null && child !== undefined && typeof child !== "boolean");
        const slidesOnly = children.every((child)=>child.type === $51b32cf9efbde13e$export$42c20acb2971398c); // Rendering only slides
        if (slidesOnly) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("div", {
            className: outerClasses,
            onMouseEnter: this.hoverStart,
            onMouseLeave: this.hoverEnd
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$var$CarouselContext.Provider, {
            value: this.getContextValue()
        }, this.renderItems(children, innerClasses)));
         // Rendering slides and controls
        if (children[0] instanceof Array) {
            const _carouselItems = children[0];
            const _controlLeft = children[1];
            const _controlRight = children[2];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("div", {
                className: outerClasses,
                onMouseEnter: this.hoverStart,
                onMouseLeave: this.hoverEnd
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$var$CarouselContext.Provider, {
                value: this.getContextValue()
            }, this.renderItems(_carouselItems, innerClasses), _controlLeft, _controlRight));
        } // Rendering indicators, slides and controls
        const indicators = children[0];
        const wrappedOnClick = (e)=>{
            if (typeof indicators.props.onClickHandler === "function") this.setState({
                indicatorClicked: true
            }, ()=>indicators.props.onClickHandler(e));
        };
        const wrappedIndicators = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).cloneElement(indicators, {
            onClickHandler: wrappedOnClick
        });
        const carouselItems = children[1];
        const controlLeft = children[2];
        const controlRight = children[3];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("div", {
            className: outerClasses,
            onMouseEnter: this.hoverStart,
            onMouseLeave: this.hoverEnd,
            onTouchStart: this.handleTouchStart,
            onTouchEnd: this.handleTouchEnd
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$var$CarouselContext.Provider, {
            value: this.getContextValue()
        }, wrappedIndicators, this.renderItems(carouselItems, innerClasses), controlLeft, controlRight));
    }
}
$51b32cf9efbde13e$var$Carousel.propTypes = {
    // the current active slide of the carousel
    activeIndex: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    // a function which should advance the carousel to the next slide (via activeIndex)
    next: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func.isRequired,
    // a function which should advance the carousel to the previous slide (via activeIndex)
    previous: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func.isRequired,
    // controls if the left and right arrow keys should control the carousel
    keyboard: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    /* If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
   * mouseleave. If set to false, hovering over the carousel won't pause it. (default: "hover")
   */ pause: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOf([
        "hover",
        false
    ]),
    // Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load.
    // This is how bootstrap defines it... I would prefer a bool named autoplay or something...
    ride: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOf([
        "carousel"
    ]),
    // the interval at which the carousel automatically cycles (default: 5000)
    // eslint-disable-next-line react/no-unused-prop-types
    interval: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).array,
    // called when the mouse enters the Carousel
    mouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    // called when the mouse exits the Carousel
    mouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    // controls whether the slide animation on the Carousel works or not
    slide: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    // make the controls, indicators and captions dark on the Carousel
    dark: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    enableTouch: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
$51b32cf9efbde13e$var$Carousel.defaultProps = {
    interval: 5000,
    pause: "hover",
    keyboard: true,
    slide: true,
    enableTouch: true,
    fade: false
};
$51b32cf9efbde13e$var$Carousel.childContextTypes = {
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $51b32cf9efbde13e$export$144901db2ea8e967 = $51b32cf9efbde13e$var$Carousel;
const $51b32cf9efbde13e$var$CarouselControl = (props)=>{
    const { direction: direction, onClickHandler: onClickHandler, cssModule: cssModule, directionText: directionText, className: className } = props;
    const anchorClasses = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, `carousel-control-${direction}`), cssModule);
    const iconClasses = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(`carousel-control-${direction}-icon`), cssModule);
    const screenReaderClasses = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("visually-hidden"), cssModule);
    return(/*#__PURE__*/ // We need to disable this linting rule to use an `<a>` instead of
    // `<button>` because that's what the Bootstrap examples require:
    // https://getbootstrap.com/docs/4.5/components/carousel/#with-controls
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("a", {
        className: anchorClasses,
        style: {
            cursor: "pointer"
        },
        role: "button",
        tabIndex: "0",
        onClick: (e)=>{
            e.preventDefault();
            onClickHandler();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("span", {
        className: iconClasses,
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("span", {
        className: screenReaderClasses
    }, directionText || direction)));
};
$51b32cf9efbde13e$var$CarouselControl.propTypes = {
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOf([
        "prev",
        "next"
    ]).isRequired,
    onClickHandler: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func.isRequired,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    directionText: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $51b32cf9efbde13e$export$f4f648ca4de05347 = $51b32cf9efbde13e$var$CarouselControl;
const $51b32cf9efbde13e$var$CarouselIndicators = (props)=>{
    const { items: items, activeIndex: activeIndex, cssModule: cssModule, onClickHandler: onClickHandler, className: className } = props;
    const listClasses = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "carousel-indicators"), cssModule);
    const indicators = items.map((item, idx)=>{
        const indicatorClasses = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))({
            active: activeIndex === idx
        }), cssModule);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("button", {
            "aria-label": item.caption,
            "data-bs-target": true,
            key: `${item.key || Object.values(item).join("")}`,
            onClick: (e)=>{
                e.preventDefault();
                onClickHandler(idx);
            },
            className: indicatorClasses
        }, item.caption);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("div", {
        className: listClasses
    }, indicators);
};
$51b32cf9efbde13e$var$CarouselIndicators.propTypes = {
    items: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).array.isRequired,
    activeIndex: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number.isRequired,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    onClickHandler: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func.isRequired,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $51b32cf9efbde13e$export$8f3f8009f3ad62b8 = $51b32cf9efbde13e$var$CarouselIndicators;
const $51b32cf9efbde13e$var$CarouselCaption = (props)=>{
    const { captionHeader: captionHeader, captionText: captionText, cssModule: cssModule, className: className } = props;
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "carousel-caption", "d-none", "d-md-block"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("div", {
        className: classes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("h3", null, captionHeader), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("p", null, captionText));
};
$51b32cf9efbde13e$var$CarouselCaption.propTypes = {
    captionHeader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    captionText: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node.isRequired,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $51b32cf9efbde13e$export$a81c9b47f1cf1e63 = $51b32cf9efbde13e$var$CarouselCaption;
const $51b32cf9efbde13e$var$_excluded$D = [
    "defaultActiveIndex",
    "autoPlay",
    "indicators",
    "controls",
    "items",
    "goToIndex"
];
const $51b32cf9efbde13e$var$propTypes$J = {
    items: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).array.isRequired,
    indicators: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    controls: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    autoPlay: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    defaultActiveIndex: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    activeIndex: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    next: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    previous: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    goToIndex: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
class $51b32cf9efbde13e$var$UncontrolledCarousel extends (0, $tZqWC.Component) {
    constructor(props){
        super(props);
        this.animating = false;
        this.state = {
            activeIndex: props.defaultActiveIndex || 0
        };
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.goToIndex = this.goToIndex.bind(this);
        this.onExiting = this.onExiting.bind(this);
        this.onExited = this.onExited.bind(this);
    }
    onExiting() {
        this.animating = true;
    }
    onExited() {
        this.animating = false;
    }
    next() {
        if (this.animating) return;
        const nextIndex = this.state.activeIndex === this.props.items.length - 1 ? 0 : this.state.activeIndex + 1;
        this.setState({
            activeIndex: nextIndex
        });
    }
    previous() {
        if (this.animating) return;
        const nextIndex = this.state.activeIndex === 0 ? this.props.items.length - 1 : this.state.activeIndex - 1;
        this.setState({
            activeIndex: nextIndex
        });
    }
    goToIndex(newIndex) {
        if (this.animating) return;
        this.setState({
            activeIndex: newIndex
        });
    }
    render() {
        const _this$props = this.props, { defaultActiveIndex: defaultActiveIndex, autoPlay: autoPlay, indicators: indicators, controls: controls, items: items, goToIndex: goToIndex } = _this$props, props = $51b32cf9efbde13e$var$_objectWithoutProperties(_this$props, $51b32cf9efbde13e$var$_excluded$D);
        const { activeIndex: activeIndex } = this.state;
        const slides = items.map((item)=>{
            const key = item.key || item.src;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$42c20acb2971398c, {
                onExiting: this.onExiting,
                onExited: this.onExited,
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("img", {
                className: "d-block w-100",
                src: item.src,
                alt: item.altText
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$a81c9b47f1cf1e63, {
                captionText: item.caption,
                captionHeader: item.header || item.caption
            }));
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$144901db2ea8e967, $51b32cf9efbde13e$var$_extends({
            activeIndex: activeIndex,
            next: this.next,
            previous: this.previous,
            ride: autoPlay ? "carousel" : undefined
        }, props), indicators && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$8f3f8009f3ad62b8, {
            items: items,
            activeIndex: props.activeIndex || activeIndex,
            onClickHandler: goToIndex || this.goToIndex
        }), slides, controls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$f4f648ca4de05347, {
            direction: "prev",
            directionText: "Previous",
            onClickHandler: props.previous || this.previous
        }), controls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$f4f648ca4de05347, {
            direction: "next",
            directionText: "Next",
            onClickHandler: props.next || this.next
        }));
    }
}
$51b32cf9efbde13e$var$UncontrolledCarousel.propTypes = $51b32cf9efbde13e$var$propTypes$J;
$51b32cf9efbde13e$var$UncontrolledCarousel.defaultProps = {
    controls: true,
    indicators: true,
    autoPlay: true
};
var $51b32cf9efbde13e$export$a8e577dade4d0e6c = $51b32cf9efbde13e$var$UncontrolledCarousel;
const $51b32cf9efbde13e$var$_excluded$C = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$I = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$I = {
    tag: "div"
};
const $51b32cf9efbde13e$var$CardSubtitle = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$C);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "card-subtitle"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$CardSubtitle.propTypes = $51b32cf9efbde13e$var$propTypes$I;
$51b32cf9efbde13e$var$CardSubtitle.defaultProps = $51b32cf9efbde13e$var$defaultProps$I;
var $51b32cf9efbde13e$export$f37ee4cff56f2c69 = $51b32cf9efbde13e$var$CardSubtitle;
const $51b32cf9efbde13e$var$_excluded$B = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$H = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$H = {
    tag: "p"
};
const $51b32cf9efbde13e$var$CardText = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$B);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "card-text"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$CardText.propTypes = $51b32cf9efbde13e$var$propTypes$H;
$51b32cf9efbde13e$var$CardText.defaultProps = $51b32cf9efbde13e$var$defaultProps$H;
var $51b32cf9efbde13e$export$c6336bc933e0ce5f = $51b32cf9efbde13e$var$CardText;
const $51b32cf9efbde13e$var$_excluded$A = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$G = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$G = {
    tag: "div"
};
const $51b32cf9efbde13e$var$CardTitle = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$A);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "card-title"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$CardTitle.propTypes = $51b32cf9efbde13e$var$propTypes$G;
$51b32cf9efbde13e$var$CardTitle.defaultProps = $51b32cf9efbde13e$var$defaultProps$G;
var $51b32cf9efbde13e$export$474db65c3c394e1c = $51b32cf9efbde13e$var$CardTitle;
const $51b32cf9efbde13e$var$_excluded$z = [
    "cssModule",
    "children",
    "isOpen",
    "flip",
    "target",
    "offset",
    "fallbackPlacements",
    "placementPrefix",
    "arrowClassName",
    "hideArrow",
    "popperClassName",
    "tag",
    "container",
    "modifiers",
    "strategy",
    "boundariesElement",
    "onClosed",
    "fade",
    "transition",
    "placement"
];
function $51b32cf9efbde13e$var$noop$2() {}
const $51b32cf9efbde13e$var$propTypes$F = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    ]).isRequired,
    popperClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    placement: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    placementPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    arrowClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    hideArrow: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    tag: $51b32cf9efbde13e$var$tagPropType,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool.isRequired,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    offset: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number),
    fallbackPlacements: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).array,
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    container: $51b32cf9efbde13e$var$targetPropType,
    target: $51b32cf9efbde13e$var$targetPropType.isRequired,
    modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).array,
    strategy: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    boundariesElement: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        $51b32cf9efbde13e$var$DOMElement
    ]),
    onClosed: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    transition: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape($51b32cf9efbde13e$export$c983850c6c9d8b0e.propTypes)
};
const $51b32cf9efbde13e$var$defaultProps$F = {
    boundariesElement: "scrollParent",
    placement: "auto",
    hideArrow: false,
    isOpen: false,
    offset: [
        0,
        0
    ],
    flip: true,
    container: "body",
    modifiers: [],
    onClosed: $51b32cf9efbde13e$var$noop$2,
    fade: true,
    transition: $51b32cf9efbde13e$var$_objectSpread2({}, $51b32cf9efbde13e$export$c983850c6c9d8b0e.defaultProps)
};
class $51b32cf9efbde13e$var$PopperContent extends (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component {
    constructor(props){
        super(props);
        this.setTargetNode = this.setTargetNode.bind(this);
        this.getTargetNode = this.getTargetNode.bind(this);
        this.getRef = this.getRef.bind(this);
        this.onClosed = this.onClosed.bind(this);
        this.state = {
            isOpen: props.isOpen
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (props.isOpen && !state.isOpen) return {
            isOpen: props.isOpen
        };
        else return null;
    }
    componentDidUpdate() {
        if (this._element && this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) this._element.childNodes[0].focus();
    }
    setTargetNode(node) {
        this.targetNode = typeof node === "string" ? $51b32cf9efbde13e$var$getTarget(node) : node;
    }
    getTargetNode() {
        return this.targetNode;
    }
    getContainerNode() {
        return $51b32cf9efbde13e$var$getTarget(this.props.container);
    }
    getRef(ref) {
        this._element = ref;
    }
    onClosed() {
        this.props.onClosed();
        this.setState({
            isOpen: false
        });
    }
    renderChildren() {
        const _this$props = this.props, { cssModule: cssModule, children: children, isOpen: isOpen, flip: flip, target: target, offset: offset, fallbackPlacements: fallbackPlacements, placementPrefix: placementPrefix, arrowClassName: _arrowClassName, hideArrow: hideArrow, popperClassName: _popperClassName, tag: tag, container: container, modifiers: modifiers, strategy: strategy, boundariesElement: boundariesElement, onClosed: onClosed, fade: fade, transition: transition, placement: placement } = _this$props, attrs = $51b32cf9efbde13e$var$_objectWithoutProperties(_this$props, $51b32cf9efbde13e$var$_excluded$z);
        const arrowClassName = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("arrow", _arrowClassName), cssModule);
        const popperClassName = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(_popperClassName, placementPrefix ? `${placementPrefix}-auto` : ""), this.props.cssModule);
        const modifierNames = modifiers.map((m)=>m.name);
        const baseModifiers = [
            {
                name: "offset",
                options: {
                    offset: offset
                }
            },
            {
                name: "flip",
                enabled: flip,
                options: {
                    fallbackPlacements: fallbackPlacements
                }
            },
            {
                name: "preventOverflow",
                options: {
                    boundary: boundariesElement
                }
            }
        ].filter((m)=>!modifierNames.includes(m.name));
        const extendedModifiers = [
            ...baseModifiers,
            ...modifiers
        ];
        const popperTransition = $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, $51b32cf9efbde13e$export$c983850c6c9d8b0e.defaultProps), transition), {}, {
            baseClass: fade ? transition.baseClass : "",
            timeout: fade ? transition.timeout : 0
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$c983850c6c9d8b0e, $51b32cf9efbde13e$var$_extends({}, popperTransition, attrs, {
            in: isOpen,
            onExited: this.onClosed,
            tag: tag
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement((0, $1fd7a0715ff9509b$export$badac9ada3a0bdf9), {
            referenceElement: this.targetNode,
            modifiers: extendedModifiers,
            placement: placement,
            strategy: strategy
        }, ({ ref: ref, style: style, placement: popperPlacement, isReferenceHidden: isReferenceHidden, arrowProps: arrowProps, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("div", {
                ref: ref,
                style: style,
                className: popperClassName,
                "data-popper-placement": popperPlacement,
                "data-popper-reference-hidden": isReferenceHidden ? "true" : undefined
            }, typeof children === "function" ? children({
                update: update
            }) : children, !hideArrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("span", {
                ref: arrowProps.ref,
                className: arrowClassName,
                style: arrowProps.style
            }))));
    }
    render() {
        this.setTargetNode(this.props.target);
        if (this.state.isOpen) return this.props.container === "inline" ? this.renderChildren() : (0, (/*@__PURE__*/$parcel$interopDefault($f419cfc3d92fe631$exports))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("div", {
            ref: this.getRef
        }, this.renderChildren()), this.getContainerNode());
        return null;
    }
}
$51b32cf9efbde13e$var$PopperContent.propTypes = $51b32cf9efbde13e$var$propTypes$F;
$51b32cf9efbde13e$var$PopperContent.defaultProps = $51b32cf9efbde13e$var$defaultProps$F;
var $51b32cf9efbde13e$export$bc4ae5855d3c4fc = $51b32cf9efbde13e$var$PopperContent;
const $51b32cf9efbde13e$var$PopperTargetHelper = (props, context)=>{
    context.popperManager.setTargetNode($51b32cf9efbde13e$var$getTarget(props.target));
    return null;
};
$51b32cf9efbde13e$var$PopperTargetHelper.contextTypes = {
    popperManager: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object.isRequired
};
$51b32cf9efbde13e$var$PopperTargetHelper.propTypes = {
    target: $51b32cf9efbde13e$var$targetPropType.isRequired
};
var $51b32cf9efbde13e$export$75524d350612bd9b = $51b32cf9efbde13e$var$PopperTargetHelper;
const $51b32cf9efbde13e$var$propTypes$E = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    ]),
    placement: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOf($51b32cf9efbde13e$var$PopperPlacements),
    target: $51b32cf9efbde13e$var$targetPropType.isRequired,
    container: $51b32cf9efbde13e$var$targetPropType,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    hideArrow: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    boundariesElement: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        $51b32cf9efbde13e$var$DOMElement
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    innerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    arrowClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    popperClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    autohide: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    placementPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    delay: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            show: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            hide: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    ]),
    modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).array,
    strategy: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    offset: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number),
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
    ]),
    trigger: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
const $51b32cf9efbde13e$var$DEFAULT_DELAYS = {
    show: 0,
    hide: 50
};
const $51b32cf9efbde13e$var$defaultProps$E = {
    isOpen: false,
    hideArrow: false,
    autohide: false,
    delay: $51b32cf9efbde13e$var$DEFAULT_DELAYS,
    toggle: function() {},
    trigger: "click",
    fade: true
};
function $51b32cf9efbde13e$var$isInDOMSubtree(element, subtreeRoot) {
    return subtreeRoot && (element === subtreeRoot || subtreeRoot.contains(element));
}
function $51b32cf9efbde13e$var$isInDOMSubtrees(element, subtreeRoots = []) {
    return subtreeRoots && subtreeRoots.length && subtreeRoots.filter((subTreeRoot)=>$51b32cf9efbde13e$var$isInDOMSubtree(element, subTreeRoot))[0];
}
class $51b32cf9efbde13e$var$TooltipPopoverWrapper extends (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component {
    constructor(props){
        super(props);
        this._targets = [];
        this.currentTargetElement = null;
        this.addTargetEvents = this.addTargetEvents.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.removeTargetEvents = this.removeTargetEvents.bind(this);
        this.toggle = this.toggle.bind(this);
        this.showWithDelay = this.showWithDelay.bind(this);
        this.hideWithDelay = this.hideWithDelay.bind(this);
        this.onMouseOverTooltipContent = this.onMouseOverTooltipContent.bind(this);
        this.onMouseLeaveTooltipContent = this.onMouseLeaveTooltipContent.bind(this);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.onEscKeyDown = this.onEscKeyDown.bind(this);
        this.getRef = this.getRef.bind(this);
        this.state = {
            isOpen: props.isOpen
        };
        this._isMounted = false;
    }
    componentDidMount() {
        this._isMounted = true;
        this.updateTarget();
    }
    componentWillUnmount() {
        this._isMounted = false;
        this.removeTargetEvents();
        this._targets = null;
        this.clearShowTimeout();
        this.clearHideTimeout();
    }
    static getDerivedStateFromProps(props, state) {
        if (props.isOpen && !state.isOpen) return {
            isOpen: props.isOpen
        };
        else return null;
    }
    onMouseOverTooltipContent() {
        if (this.props.trigger.indexOf("hover") > -1 && !this.props.autohide) {
            if (this._hideTimeout) this.clearHideTimeout();
            if (this.state.isOpen && !this.props.isOpen) this.toggle();
        }
    }
    onMouseLeaveTooltipContent(e) {
        if (this.props.trigger.indexOf("hover") > -1 && !this.props.autohide) {
            if (this._showTimeout) this.clearShowTimeout();
            e.persist();
            this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay("hide"));
        }
    }
    onEscKeyDown(e) {
        if (e.key === "Escape") this.hide(e);
    }
    getRef(ref) {
        const { innerRef: innerRef } = this.props;
        if (innerRef) {
            if (typeof innerRef === "function") innerRef(ref);
            else if (typeof innerRef === "object") innerRef.current = ref;
        }
        this._popover = ref;
    }
    getDelay(key) {
        const { delay: delay } = this.props;
        if (typeof delay === "object") return isNaN(delay[key]) ? $51b32cf9efbde13e$var$DEFAULT_DELAYS[key] : delay[key];
        return delay;
    }
    getCurrentTarget(target) {
        if (!target) return null;
        const index = this._targets.indexOf(target);
        if (index >= 0) return this._targets[index];
        return this.getCurrentTarget(target.parentElement);
    }
    show(e) {
        if (!this.props.isOpen) {
            this.clearShowTimeout();
            this.currentTargetElement = e ? e.currentTarget || this.getCurrentTarget(e.target) : null;
            if (e && e.composedPath && typeof e.composedPath === "function") {
                const path = e.composedPath();
                this.currentTargetElement = path && path[0] || this.currentTargetElement;
            }
            this.toggle(e);
        }
    }
    showWithDelay(e) {
        if (this._hideTimeout) this.clearHideTimeout();
        this._showTimeout = setTimeout(this.show.bind(this, e), this.getDelay("show"));
    }
    hide(e) {
        if (this.props.isOpen) {
            this.clearHideTimeout();
            this.currentTargetElement = null;
            this.toggle(e);
        }
    }
    hideWithDelay(e) {
        if (this._showTimeout) this.clearShowTimeout();
        this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay("hide"));
    }
    clearShowTimeout() {
        clearTimeout(this._showTimeout);
        this._showTimeout = undefined;
    }
    clearHideTimeout() {
        clearTimeout(this._hideTimeout);
        this._hideTimeout = undefined;
    }
    handleDocumentClick(e) {
        const triggers = this.props.trigger.split(" ");
        if (triggers.indexOf("legacy") > -1 && (this.props.isOpen || $51b32cf9efbde13e$var$isInDOMSubtrees(e.target, this._targets))) {
            if (this._hideTimeout) this.clearHideTimeout();
            if (this.props.isOpen && !$51b32cf9efbde13e$var$isInDOMSubtree(e.target, this._popover)) this.hideWithDelay(e);
            else if (!this.props.isOpen) this.showWithDelay(e);
        } else if (triggers.indexOf("click") > -1 && $51b32cf9efbde13e$var$isInDOMSubtrees(e.target, this._targets)) {
            if (this._hideTimeout) this.clearHideTimeout();
            if (!this.props.isOpen) this.showWithDelay(e);
            else this.hideWithDelay(e);
        }
    }
    addEventOnTargets(type, handler, isBubble) {
        this._targets.forEach((target)=>{
            target.addEventListener(type, handler, isBubble);
        });
    }
    removeEventOnTargets(type, handler, isBubble) {
        this._targets.forEach((target)=>{
            target.removeEventListener(type, handler, isBubble);
        });
    }
    addTargetEvents() {
        if (this.props.trigger) {
            let triggers = this.props.trigger.split(" ");
            if (triggers.indexOf("manual") === -1) {
                if (triggers.indexOf("click") > -1 || triggers.indexOf("legacy") > -1) document.addEventListener("click", this.handleDocumentClick, true);
                if (this._targets && this._targets.length) {
                    if (triggers.indexOf("hover") > -1) {
                        this.addEventOnTargets("mouseover", this.showWithDelay, true);
                        this.addEventOnTargets("mouseout", this.hideWithDelay, true);
                    }
                    if (triggers.indexOf("focus") > -1) {
                        this.addEventOnTargets("focusin", this.show, true);
                        this.addEventOnTargets("focusout", this.hide, true);
                    }
                    this.addEventOnTargets("keydown", this.onEscKeyDown, true);
                }
            }
        }
    }
    removeTargetEvents() {
        if (this._targets) {
            this.removeEventOnTargets("mouseover", this.showWithDelay, true);
            this.removeEventOnTargets("mouseout", this.hideWithDelay, true);
            this.removeEventOnTargets("keydown", this.onEscKeyDown, true);
            this.removeEventOnTargets("focusin", this.show, true);
            this.removeEventOnTargets("focusout", this.hide, true);
        }
        document.removeEventListener("click", this.handleDocumentClick, true);
    }
    updateTarget() {
        const newTarget = $51b32cf9efbde13e$var$getTarget(this.props.target, true);
        if (newTarget !== this._targets) {
            this.removeTargetEvents();
            this._targets = newTarget ? Array.from(newTarget) : [];
            this.currentTargetElement = this.currentTargetElement || this._targets[0];
            this.addTargetEvents();
        }
    }
    toggle(e) {
        if (this.props.disabled || !this._isMounted) return e && e.preventDefault();
        return this.props.toggle(e);
    }
    render() {
        if (this.props.isOpen) this.updateTarget();
        const target = this.currentTargetElement || this._targets[0];
        if (!target) return null;
        const { className: className, cssModule: cssModule, innerClassName: innerClassName, isOpen: isOpen, hideArrow: hideArrow, boundariesElement: boundariesElement, placement: placement, placementPrefix: placementPrefix, arrowClassName: arrowClassName, popperClassName: popperClassName, container: container, modifiers: modifiers, strategy: strategy, offset: offset, fade: fade, flip: flip, children: children } = this.props;
        const attributes = $51b32cf9efbde13e$var$omit(this.props, Object.keys($51b32cf9efbde13e$var$propTypes$E));
        const popperClasses = $51b32cf9efbde13e$var$mapToCssModules(popperClassName, cssModule);
        const classes = $51b32cf9efbde13e$var$mapToCssModules(innerClassName, cssModule);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$bc4ae5855d3c4fc, {
            className: className,
            target: target,
            isOpen: isOpen,
            hideArrow: hideArrow,
            boundariesElement: boundariesElement,
            placement: placement,
            placementPrefix: placementPrefix,
            arrowClassName: arrowClassName,
            popperClassName: popperClasses,
            container: container,
            modifiers: modifiers,
            strategy: strategy,
            offset: offset,
            cssModule: cssModule,
            fade: fade,
            flip: flip
        }, ({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("div", $51b32cf9efbde13e$var$_extends({}, attributes, {
                ref: this.getRef,
                className: classes,
                role: "tooltip",
                onMouseOver: this.onMouseOverTooltipContent,
                onMouseLeave: this.onMouseLeaveTooltipContent,
                onKeyDown: this.onEscKeyDown
            }), typeof children === "function" ? children({
                update: update
            }) : children));
    }
}
$51b32cf9efbde13e$var$TooltipPopoverWrapper.propTypes = $51b32cf9efbde13e$var$propTypes$E;
$51b32cf9efbde13e$var$TooltipPopoverWrapper.defaultProps = $51b32cf9efbde13e$var$defaultProps$E;
var $51b32cf9efbde13e$var$TooltipPopoverWrapper$1 = $51b32cf9efbde13e$var$TooltipPopoverWrapper;
const $51b32cf9efbde13e$var$defaultProps$D = {
    placement: "right",
    placementPrefix: "bs-popover",
    trigger: "click",
    offset: [
        0,
        8
    ]
};
const $51b32cf9efbde13e$var$Popover = (props)=>{
    const popperClasses = (0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("popover", "show", props.popperClassName);
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("popover-inner", props.innerClassName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$var$TooltipPopoverWrapper$1, $51b32cf9efbde13e$var$_extends({}, props, {
        arrowClassName: "popover-arrow",
        popperClassName: popperClasses,
        innerClassName: classes
    }));
};
$51b32cf9efbde13e$var$Popover.propTypes = $51b32cf9efbde13e$var$propTypes$E;
$51b32cf9efbde13e$var$Popover.defaultProps = $51b32cf9efbde13e$var$defaultProps$D;
var $51b32cf9efbde13e$export$5b6b19405a83ff9d = $51b32cf9efbde13e$var$Popover;
const $51b32cf9efbde13e$var$omitKeys$4 = [
    "defaultOpen"
];
class $51b32cf9efbde13e$export$90cf3cf909ea9851 extends (0, $tZqWC.Component) {
    constructor(props){
        super(props);
        this.state = {
            isOpen: props.defaultOpen || false
        };
        this.toggle = this.toggle.bind(this);
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$5b6b19405a83ff9d, $51b32cf9efbde13e$var$_extends({
            isOpen: this.state.isOpen,
            toggle: this.toggle
        }, $51b32cf9efbde13e$var$omit(this.props, $51b32cf9efbde13e$var$omitKeys$4)));
    }
}
$51b32cf9efbde13e$export$90cf3cf909ea9851.propTypes = $51b32cf9efbde13e$var$_objectSpread2({
    defaultOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
}, $51b32cf9efbde13e$export$5b6b19405a83ff9d.propTypes);
const $51b32cf9efbde13e$var$_excluded$y = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$D = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$C = {
    tag: "h3"
};
const $51b32cf9efbde13e$var$PopoverHeader = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$y);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "popover-header"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$PopoverHeader.propTypes = $51b32cf9efbde13e$var$propTypes$D;
$51b32cf9efbde13e$var$PopoverHeader.defaultProps = $51b32cf9efbde13e$var$defaultProps$C;
var $51b32cf9efbde13e$export$24cbcada8f546cfe = $51b32cf9efbde13e$var$PopoverHeader;
const $51b32cf9efbde13e$var$_excluded$x = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$C = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$B = {
    tag: "div"
};
const $51b32cf9efbde13e$var$PopoverBody = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$x);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "popover-body"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$PopoverBody.propTypes = $51b32cf9efbde13e$var$propTypes$C;
$51b32cf9efbde13e$var$PopoverBody.defaultProps = $51b32cf9efbde13e$var$defaultProps$B;
var $51b32cf9efbde13e$export$472ec417bca1d382 = $51b32cf9efbde13e$var$PopoverBody;
const $51b32cf9efbde13e$var$_excluded$w = [
    "children",
    "className",
    "barClassName",
    "cssModule",
    "value",
    "min",
    "max",
    "animated",
    "striped",
    "color",
    "bar",
    "multi",
    "tag",
    "style",
    "barStyle",
    "barAriaValueText",
    "barAriaLabelledBy"
];
const $51b32cf9efbde13e$var$propTypes$B = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    bar: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    multi: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    tag: $51b32cf9efbde13e$var$tagPropType,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    ]),
    min: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    ]),
    max: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    ]),
    animated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    striped: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    barClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    barStyle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    barAriaValueText: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    barAriaLabelledBy: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
const $51b32cf9efbde13e$var$defaultProps$A = {
    tag: "div",
    value: 0,
    min: 0,
    max: 100,
    style: {},
    barStyle: {}
};
const $51b32cf9efbde13e$var$Progress = (props)=>{
    const { children: children, className: className, barClassName: barClassName, cssModule: cssModule, value: value, min: min, max: max, animated: animated, striped: striped, color: color, bar: bar, multi: multi, tag: Tag, style: style, barStyle: barStyle, barAriaValueText: barAriaValueText, barAriaLabelledBy: barAriaLabelledBy } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$w);
    const percent = $51b32cf9efbde13e$var$toNumber(value) / $51b32cf9efbde13e$var$toNumber(max) * 100;
    const progressClasses = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "progress"), cssModule);
    const progressBarClasses = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("progress-bar", bar ? className || barClassName : barClassName, animated ? "progress-bar-animated" : null, color ? `bg-${color}` : null, striped || animated ? "progress-bar-striped" : null), cssModule);
    const progressBarProps = {
        className: progressBarClasses,
        style: $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, bar ? style : {}), barStyle), {}, {
            width: `${percent}%`
        }),
        role: "progressbar",
        "aria-valuenow": value,
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuetext": barAriaValueText,
        "aria-labelledby": barAriaLabelledBy,
        children: children
    };
    if (bar) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, progressBarProps));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        style: style,
        className: progressClasses
    }), multi ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("div", progressBarProps));
};
$51b32cf9efbde13e$var$Progress.propTypes = $51b32cf9efbde13e$var$propTypes$B;
$51b32cf9efbde13e$var$Progress.defaultProps = $51b32cf9efbde13e$var$defaultProps$A;
var $51b32cf9efbde13e$export$b25a304ec7d746bb = $51b32cf9efbde13e$var$Progress;
const $51b32cf9efbde13e$var$propTypes$A = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node.isRequired,
    node: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any
};
class $51b32cf9efbde13e$var$Portal extends (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component {
    componentWillUnmount() {
        if (this.defaultNode) document.body.removeChild(this.defaultNode);
        this.defaultNode = null;
    }
    render() {
        if (!$51b32cf9efbde13e$var$canUseDOM) return null;
        if (!this.props.node && !this.defaultNode) {
            this.defaultNode = document.createElement("div");
            document.body.appendChild(this.defaultNode);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($f419cfc3d92fe631$exports))).createPortal(this.props.children, this.props.node || this.defaultNode);
    }
}
$51b32cf9efbde13e$var$Portal.propTypes = $51b32cf9efbde13e$var$propTypes$A;
var $51b32cf9efbde13e$var$Portal$1 = $51b32cf9efbde13e$var$Portal;
function $51b32cf9efbde13e$var$noop$1() {}
const $51b32cf9efbde13e$var$FadePropTypes$1 = (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape($51b32cf9efbde13e$export$c983850c6c9d8b0e.propTypes);
const $51b32cf9efbde13e$var$propTypes$z = {
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    centered: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    fullscreen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOf([
            "sm",
            "md",
            "lg",
            "xl"
        ])
    ]),
    scrollable: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    keyboard: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    labelledBy: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    backdrop: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOf([
            "static"
        ])
    ]),
    onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onExit: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onOpened: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onClosed: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    wrapClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    modalClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    backdropClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    contentClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    external: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    zIndex: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    backdropTransition: $51b32cf9efbde13e$var$FadePropTypes$1,
    modalTransition: $51b32cf9efbde13e$var$FadePropTypes$1,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    ]),
    unmountOnClose: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    returnFocusAfterClose: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    container: $51b32cf9efbde13e$var$targetPropType,
    trapFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
const $51b32cf9efbde13e$var$propsToOmit$1 = Object.keys($51b32cf9efbde13e$var$propTypes$z);
const $51b32cf9efbde13e$var$defaultProps$z = {
    isOpen: false,
    autoFocus: true,
    centered: false,
    scrollable: false,
    role: "dialog",
    backdrop: true,
    keyboard: true,
    zIndex: 1050,
    fade: true,
    onOpened: $51b32cf9efbde13e$var$noop$1,
    onClosed: $51b32cf9efbde13e$var$noop$1,
    modalTransition: {
        timeout: $51b32cf9efbde13e$var$TransitionTimeouts.Modal
    },
    backdropTransition: {
        mountOnEnter: true,
        timeout: $51b32cf9efbde13e$var$TransitionTimeouts.Fade // uses standard fade transition
    },
    unmountOnClose: true,
    returnFocusAfterClose: true,
    container: "body",
    trapFocus: false
};
class $51b32cf9efbde13e$var$Modal extends (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component {
    constructor(props){
        super(props);
        this._element = null;
        this._originalBodyPadding = null;
        this.getFocusableChildren = this.getFocusableChildren.bind(this);
        this.handleBackdropClick = this.handleBackdropClick.bind(this);
        this.handleBackdropMouseDown = this.handleBackdropMouseDown.bind(this);
        this.handleEscape = this.handleEscape.bind(this);
        this.handleStaticBackdropAnimation = this.handleStaticBackdropAnimation.bind(this);
        this.handleTab = this.handleTab.bind(this);
        this.onOpened = this.onOpened.bind(this);
        this.onClosed = this.onClosed.bind(this);
        this.manageFocusAfterClose = this.manageFocusAfterClose.bind(this);
        this.clearBackdropAnimationTimeout = this.clearBackdropAnimationTimeout.bind(this);
        this.trapFocus = this.trapFocus.bind(this);
        this.state = {
            isOpen: false,
            showStaticBackdropAnimation: false
        };
    }
    componentDidMount() {
        const { isOpen: isOpen, autoFocus: autoFocus, onEnter: onEnter } = this.props;
        if (isOpen) {
            this.init();
            this.setState({
                isOpen: true
            });
            if (autoFocus) this.setFocus();
        }
        if (onEnter) onEnter();
         // traps focus inside the Modal, even if the browser address bar is focused
        document.addEventListener("focus", this.trapFocus, true);
        this._isMounted = true;
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.init();
            this.setState({
                isOpen: true
            }); // let render() renders Modal Dialog first
            return;
        } // now Modal Dialog is rendered and we can refer this._element and this._dialog
        if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) this.setFocus();
        if (this._element && prevProps.zIndex !== this.props.zIndex) this._element.style.zIndex = this.props.zIndex;
    }
    componentWillUnmount() {
        this.clearBackdropAnimationTimeout();
        if (this.props.onExit) this.props.onExit();
        if (this._element) {
            this.destroy();
            if (this.props.isOpen || this.state.isOpen) this.close();
        }
        document.removeEventListener("focus", this.trapFocus, true);
        this._isMounted = false;
    }
    trapFocus(ev) {
        if (!this.props.trapFocus) return;
        if (!this._element) return;
        if (this._dialog && this._dialog.parentNode === ev.target) return;
        if (this.modalIndex < $51b32cf9efbde13e$var$Modal.openCount - 1) return;
        const children = this.getFocusableChildren();
        for(let i = 0; i < children.length; i++){
            // focus is already inside the Modal
            if (children[i] === ev.target) return;
        }
        if (children.length > 0) {
            // otherwise focus the first focusable element in the Modal
            ev.preventDefault();
            ev.stopPropagation();
            children[0].focus();
        }
    }
    onOpened(node, isAppearing) {
        this.props.onOpened();
        (this.props.modalTransition.onEntered || $51b32cf9efbde13e$var$noop$1)(node, isAppearing);
    }
    onClosed(node) {
        const { unmountOnClose: unmountOnClose } = this.props; // so all methods get called before it is unmounted
        this.props.onClosed();
        (this.props.modalTransition.onExited || $51b32cf9efbde13e$var$noop$1)(node);
        if (unmountOnClose) this.destroy();
        this.close();
        if (this._isMounted) this.setState({
            isOpen: false
        });
    }
    setFocus() {
        if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === "function") this._dialog.parentNode.focus();
    }
    getFocusableChildren() {
        return this._element.querySelectorAll($51b32cf9efbde13e$var$focusableElements.join(", "));
    }
    getFocusedChild() {
        let currentFocus;
        const focusableChildren = this.getFocusableChildren();
        try {
            currentFocus = document.activeElement;
        } catch (err) {
            currentFocus = focusableChildren[0];
        }
        return currentFocus;
    }
    handleBackdropClick(e) {
        if (e.target === this._mouseDownElement) {
            e.stopPropagation();
            const backdrop = this._dialog ? this._dialog.parentNode : null;
            if (backdrop && e.target === backdrop && this.props.backdrop === "static") this.handleStaticBackdropAnimation();
            if (!this.props.isOpen || this.props.backdrop !== true) return;
            if (backdrop && e.target === backdrop && this.props.toggle) this.props.toggle(e);
        }
    }
    handleTab(e) {
        if (e.which !== 9) return;
        if (this.modalIndex < $51b32cf9efbde13e$var$Modal.openCount - 1) return; // last opened modal
        const focusableChildren = this.getFocusableChildren();
        const totalFocusable = focusableChildren.length;
        if (totalFocusable === 0) return;
        const currentFocus = this.getFocusedChild();
        let focusedIndex = 0;
        for(let i = 0; i < totalFocusable; i += 1)if (focusableChildren[i] === currentFocus) {
            focusedIndex = i;
            break;
        }
        if (e.shiftKey && focusedIndex === 0) {
            e.preventDefault();
            focusableChildren[totalFocusable - 1].focus();
        } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
            e.preventDefault();
            focusableChildren[0].focus();
        }
    }
    handleBackdropMouseDown(e) {
        this._mouseDownElement = e.target;
    }
    handleEscape(e) {
        if (this.props.isOpen && e.keyCode === $51b32cf9efbde13e$var$keyCodes.esc && this.props.toggle) {
            if (this.props.keyboard) {
                e.preventDefault();
                e.stopPropagation();
                this.props.toggle(e);
            } else if (this.props.backdrop === "static") {
                e.preventDefault();
                e.stopPropagation();
                this.handleStaticBackdropAnimation();
            }
        }
    }
    handleStaticBackdropAnimation() {
        this.clearBackdropAnimationTimeout();
        this.setState({
            showStaticBackdropAnimation: true
        });
        this._backdropAnimationTimeout = setTimeout(()=>{
            this.setState({
                showStaticBackdropAnimation: false
            });
        }, 100);
    }
    init() {
        try {
            this._triggeringElement = document.activeElement;
        } catch (err) {
            this._triggeringElement = null;
        }
        if (!this._element) {
            this._element = document.createElement("div");
            this._element.setAttribute("tabindex", "-1");
            this._element.style.position = "relative";
            this._element.style.zIndex = this.props.zIndex;
            this._mountContainer = $51b32cf9efbde13e$var$getTarget(this.props.container);
            this._mountContainer.appendChild(this._element);
        }
        this._originalBodyPadding = $51b32cf9efbde13e$var$getOriginalBodyPadding();
        $51b32cf9efbde13e$var$conditionallyUpdateScrollbar();
        if ($51b32cf9efbde13e$var$Modal.openCount === 0) document.body.className = (0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(document.body.className, $51b32cf9efbde13e$var$mapToCssModules("modal-open", this.props.cssModule));
        this.modalIndex = $51b32cf9efbde13e$var$Modal.openCount;
        $51b32cf9efbde13e$var$Modal.openCount += 1;
    }
    destroy() {
        if (this._element) {
            this._mountContainer.removeChild(this._element);
            this._element = null;
        }
        this.manageFocusAfterClose();
    }
    manageFocusAfterClose() {
        if (this._triggeringElement) {
            const { returnFocusAfterClose: returnFocusAfterClose } = this.props;
            if (this._triggeringElement.focus && returnFocusAfterClose) this._triggeringElement.focus();
            this._triggeringElement = null;
        }
    }
    close() {
        if ($51b32cf9efbde13e$var$Modal.openCount <= 1) {
            const modalOpenClassName = $51b32cf9efbde13e$var$mapToCssModules("modal-open", this.props.cssModule); // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`
            const modalOpenClassNameRegex = new RegExp(`(^| )${modalOpenClassName}( |$)`);
            document.body.className = document.body.className.replace(modalOpenClassNameRegex, " ").trim();
        }
        this.manageFocusAfterClose();
        $51b32cf9efbde13e$var$Modal.openCount = Math.max(0, $51b32cf9efbde13e$var$Modal.openCount - 1);
        $51b32cf9efbde13e$var$setScrollbarWidth(this._originalBodyPadding);
    }
    renderModalDialog() {
        const attributes = $51b32cf9efbde13e$var$omit(this.props, $51b32cf9efbde13e$var$propsToOmit$1);
        const dialogBaseClass = "modal-dialog";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("div", $51b32cf9efbde13e$var$_extends({}, attributes, {
            className: $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(dialogBaseClass, this.props.className, {
                [`modal-${this.props.size}`]: this.props.size,
                [`${dialogBaseClass}-centered`]: this.props.centered,
                [`${dialogBaseClass}-scrollable`]: this.props.scrollable,
                "modal-fullscreen": this.props.fullscreen === true,
                [`modal-fullscreen-${this.props.fullscreen}-down`]: typeof this.props.fullscreen === "string"
            }), this.props.cssModule),
            role: "document",
            ref: (c)=>{
                this._dialog = c;
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("div", {
            className: $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("modal-content", this.props.contentClassName), this.props.cssModule)
        }, this.props.children));
    }
    render() {
        const { unmountOnClose: unmountOnClose } = this.props;
        if (!!this._element && (this.state.isOpen || !unmountOnClose)) {
            const isModalHidden = !!this._element && !this.state.isOpen && !unmountOnClose;
            this._element.style.display = isModalHidden ? "none" : "block";
            const { wrapClassName: wrapClassName, modalClassName: modalClassName, backdropClassName: backdropClassName, cssModule: cssModule, isOpen: isOpen, backdrop: backdrop, role: role, labelledBy: labelledBy, external: external, innerRef: innerRef } = this.props;
            const modalAttributes = {
                onClick: this.handleBackdropClick,
                onMouseDown: this.handleBackdropMouseDown,
                onKeyUp: this.handleEscape,
                onKeyDown: this.handleTab,
                style: {
                    display: "block"
                },
                "aria-labelledby": labelledBy,
                role: role,
                tabIndex: "-1"
            };
            const hasTransition = this.props.fade;
            const modalTransition = $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, $51b32cf9efbde13e$export$c983850c6c9d8b0e.defaultProps), this.props.modalTransition), {}, {
                baseClass: hasTransition ? this.props.modalTransition.baseClass : "",
                timeout: hasTransition ? this.props.modalTransition.timeout : 0
            });
            const backdropTransition = $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, $51b32cf9efbde13e$export$c983850c6c9d8b0e.defaultProps), this.props.backdropTransition), {}, {
                baseClass: hasTransition ? this.props.backdropTransition.baseClass : "",
                timeout: hasTransition ? this.props.backdropTransition.timeout : 0
            });
            const Backdrop = backdrop && (hasTransition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$c983850c6c9d8b0e, $51b32cf9efbde13e$var$_extends({}, backdropTransition, {
                in: isOpen && !!backdrop,
                cssModule: cssModule,
                className: $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("modal-backdrop", backdropClassName), cssModule)
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("div", {
                className: $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("modal-backdrop", "show", backdropClassName), cssModule)
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$var$Portal$1, {
                node: this._element
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("div", {
                className: $51b32cf9efbde13e$var$mapToCssModules(wrapClassName)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$c983850c6c9d8b0e, $51b32cf9efbde13e$var$_extends({}, modalAttributes, modalTransition, {
                in: isOpen,
                onEntered: this.onOpened,
                onExited: this.onClosed,
                cssModule: cssModule,
                className: $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("modal", modalClassName, this.state.showStaticBackdropAnimation && "modal-static"), cssModule),
                innerRef: innerRef
            }), external, this.renderModalDialog()), Backdrop));
        }
        return null;
    }
    clearBackdropAnimationTimeout() {
        if (this._backdropAnimationTimeout) {
            clearTimeout(this._backdropAnimationTimeout);
            this._backdropAnimationTimeout = undefined;
        }
    }
}
$51b32cf9efbde13e$var$Modal.propTypes = $51b32cf9efbde13e$var$propTypes$z;
$51b32cf9efbde13e$var$Modal.defaultProps = $51b32cf9efbde13e$var$defaultProps$z;
$51b32cf9efbde13e$var$Modal.openCount = 0;
var $51b32cf9efbde13e$export$2b77a92f1a5ad772 = $51b32cf9efbde13e$var$Modal;
const $51b32cf9efbde13e$var$_excluded$v = [
    "className",
    "cssModule",
    "children",
    "toggle",
    "tag",
    "wrapTag",
    "closeAriaLabel",
    "close"
];
const $51b32cf9efbde13e$var$propTypes$y = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    wrapTag: $51b32cf9efbde13e$var$tagPropType,
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    closeAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    close: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$y = {
    tag: "h5",
    wrapTag: "div",
    closeAriaLabel: "Close"
};
const $51b32cf9efbde13e$var$ModalHeader = (props)=>{
    let closeButton;
    const { className: className, cssModule: cssModule, children: children, toggle: toggle, tag: Tag, wrapTag: WrapTag, closeAriaLabel: closeAriaLabel, close: close } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$v);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "modal-header"), cssModule);
    if (!close && toggle) closeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("button", {
        type: "button",
        onClick: toggle,
        className: $51b32cf9efbde13e$var$mapToCssModules("btn-close", cssModule),
        "aria-label": closeAriaLabel
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(WrapTag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, {
        className: $51b32cf9efbde13e$var$mapToCssModules("modal-title", cssModule)
    }, children), close || closeButton);
};
$51b32cf9efbde13e$var$ModalHeader.propTypes = $51b32cf9efbde13e$var$propTypes$y;
$51b32cf9efbde13e$var$ModalHeader.defaultProps = $51b32cf9efbde13e$var$defaultProps$y;
var $51b32cf9efbde13e$export$f50a68e3694789ee = $51b32cf9efbde13e$var$ModalHeader;
const $51b32cf9efbde13e$var$_excluded$u = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$x = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$x = {
    tag: "div"
};
const $51b32cf9efbde13e$var$ModalBody = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$u);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "modal-body"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$ModalBody.propTypes = $51b32cf9efbde13e$var$propTypes$x;
$51b32cf9efbde13e$var$ModalBody.defaultProps = $51b32cf9efbde13e$var$defaultProps$x;
var $51b32cf9efbde13e$export$cb540d8b0ef7906c = $51b32cf9efbde13e$var$ModalBody;
const $51b32cf9efbde13e$var$_excluded$t = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$w = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$w = {
    tag: "div"
};
const $51b32cf9efbde13e$var$ModalFooter = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$t);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "modal-footer"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$ModalFooter.propTypes = $51b32cf9efbde13e$var$propTypes$w;
$51b32cf9efbde13e$var$ModalFooter.defaultProps = $51b32cf9efbde13e$var$defaultProps$w;
var $51b32cf9efbde13e$export$519437715052e656 = $51b32cf9efbde13e$var$ModalFooter;
const $51b32cf9efbde13e$var$defaultProps$v = {
    placement: "top",
    autohide: true,
    placementPrefix: "bs-tooltip",
    trigger: "hover focus"
};
const $51b32cf9efbde13e$var$Tooltip = (props)=>{
    const popperClasses = (0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("tooltip", "show", props.popperClassName);
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("tooltip-inner", props.innerClassName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$var$TooltipPopoverWrapper$1, $51b32cf9efbde13e$var$_extends({}, props, {
        arrowClassName: "tooltip-arrow",
        popperClassName: popperClasses,
        innerClassName: classes
    }));
};
$51b32cf9efbde13e$var$Tooltip.propTypes = $51b32cf9efbde13e$var$propTypes$E;
$51b32cf9efbde13e$var$Tooltip.defaultProps = $51b32cf9efbde13e$var$defaultProps$v;
var $51b32cf9efbde13e$export$28c660c63b792dea = $51b32cf9efbde13e$var$Tooltip;
const $51b32cf9efbde13e$var$_excluded$s = [
    "className",
    "cssModule",
    "size",
    "bordered",
    "borderless",
    "striped",
    "dark",
    "hover",
    "responsive",
    "tag",
    "responsiveTag",
    "innerRef"
];
const $51b32cf9efbde13e$var$propTypes$v = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    bordered: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    borderless: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    striped: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    dark: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    hover: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    responsive: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    tag: $51b32cf9efbde13e$var$tagPropType,
    responsiveTag: $51b32cf9efbde13e$var$tagPropType,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
    ])
};
const $51b32cf9efbde13e$var$defaultProps$u = {
    tag: "table",
    responsiveTag: "div"
};
const $51b32cf9efbde13e$var$Table = (props)=>{
    const { className: className, cssModule: cssModule, size: size, bordered: bordered, borderless: borderless, striped: striped, dark: dark, hover: hover, responsive: responsive, tag: Tag, responsiveTag: ResponsiveTag, innerRef: innerRef } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$s);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "table", size ? "table-" + size : false, bordered ? "table-bordered" : false, borderless ? "table-borderless" : false, striped ? "table-striped" : false, dark ? "table-dark" : false, hover ? "table-hover" : false), cssModule);
    const table = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        ref: innerRef,
        className: classes
    }));
    if (responsive) {
        const responsiveClassName = $51b32cf9efbde13e$var$mapToCssModules(responsive === true ? "table-responsive" : `table-responsive-${responsive}`, cssModule);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(ResponsiveTag, {
            className: responsiveClassName
        }, table);
    }
    return table;
};
$51b32cf9efbde13e$var$Table.propTypes = $51b32cf9efbde13e$var$propTypes$v;
$51b32cf9efbde13e$var$Table.defaultProps = $51b32cf9efbde13e$var$defaultProps$u;
var $51b32cf9efbde13e$export$54ec01a60f47d33d = $51b32cf9efbde13e$var$Table;
const $51b32cf9efbde13e$var$_excluded$r = [
    "className",
    "cssModule",
    "tag",
    "flush",
    "horizontal",
    "numbered"
];
const $51b32cf9efbde13e$var$propTypes$u = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    flush: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    numbered: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
const $51b32cf9efbde13e$var$defaultProps$t = {
    tag: "ul",
    horizontal: false,
    numbered: false
};
const $51b32cf9efbde13e$var$getHorizontalClass = (horizontal)=>{
    if (horizontal === false) return false;
    else if (horizontal === true || horizontal === "xs") return "list-group-horizontal";
    return `list-group-horizontal-${horizontal}`;
};
const $51b32cf9efbde13e$var$ListGroup = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag, flush: flush, horizontal: horizontal, numbered: numbered } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$r);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "list-group", // we only try to apply horizontal classes if flush is false
    flush ? "list-group-flush" : $51b32cf9efbde13e$var$getHorizontalClass(horizontal), {
        "list-group-numbered": numbered
    }), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$ListGroup.propTypes = $51b32cf9efbde13e$var$propTypes$u;
$51b32cf9efbde13e$var$ListGroup.defaultProps = $51b32cf9efbde13e$var$defaultProps$t;
var $51b32cf9efbde13e$export$9cc9809463a041c4 = $51b32cf9efbde13e$var$ListGroup;
const $51b32cf9efbde13e$var$_excluded$q = [
    "className",
    "cssModule",
    "inline",
    "tag",
    "innerRef"
];
const $51b32cf9efbde13e$var$propTypes$t = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    inline: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    tag: $51b32cf9efbde13e$var$tagPropType,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$s = {
    tag: "form"
};
class $51b32cf9efbde13e$var$Form extends (0, $tZqWC.Component) {
    constructor(props){
        super(props);
        this.getRef = this.getRef.bind(this);
        this.submit = this.submit.bind(this);
    }
    getRef(ref) {
        if (this.props.innerRef) this.props.innerRef(ref);
        this.ref = ref;
    }
    submit() {
        if (this.ref) this.ref.submit();
    }
    render() {
        const _this$props = this.props, { className: className, cssModule: cssModule, inline: inline, tag: Tag, innerRef: innerRef } = _this$props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(_this$props, $51b32cf9efbde13e$var$_excluded$q);
        const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, inline ? "form-inline" : false), cssModule);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
            ref: innerRef,
            className: classes
        }));
    }
}
$51b32cf9efbde13e$var$Form.propTypes = $51b32cf9efbde13e$var$propTypes$t;
$51b32cf9efbde13e$var$Form.defaultProps = $51b32cf9efbde13e$var$defaultProps$s;
var $51b32cf9efbde13e$export$a7fed597f4b8afd8 = $51b32cf9efbde13e$var$Form;
const $51b32cf9efbde13e$var$_excluded$p = [
    "className",
    "cssModule",
    "valid",
    "tooltip",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$s = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    valid: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
const $51b32cf9efbde13e$var$defaultProps$r = {
    tag: "div",
    valid: undefined
};
const $51b32cf9efbde13e$var$FormFeedback = (props)=>{
    const { className: className, cssModule: cssModule, valid: valid, tooltip: tooltip, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$p);
    const validMode = tooltip ? "tooltip" : "feedback";
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, valid ? `valid-${validMode}` : `invalid-${validMode}`), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$FormFeedback.propTypes = $51b32cf9efbde13e$var$propTypes$s;
$51b32cf9efbde13e$var$FormFeedback.defaultProps = $51b32cf9efbde13e$var$defaultProps$r;
var $51b32cf9efbde13e$export$3d1651c7c64d0848 = $51b32cf9efbde13e$var$FormFeedback;
const $51b32cf9efbde13e$var$_excluded$o = [
    "className",
    "cssModule",
    "row",
    "disabled",
    "check",
    "inline",
    "floating",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$r = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    row: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    check: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    switch: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    inline: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    floating: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$q = {
    tag: "div"
};
const $51b32cf9efbde13e$var$FormGroup = (props)=>{
    const { className: className, cssModule: cssModule, row: row, disabled: disabled, check: check, inline: inline, floating: floating, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$o);
    const formCheck = check || props.switch;
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, row ? "row" : false, formCheck ? "form-check" : "mb-3", props.switch ? "form-switch" : false, formCheck && inline ? "form-check-inline" : false, formCheck && disabled ? "disabled" : false, floating && "form-floating"), cssModule);
    if (Tag === "fieldset") attributes.disabled = disabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$FormGroup.propTypes = $51b32cf9efbde13e$var$propTypes$r;
$51b32cf9efbde13e$var$FormGroup.defaultProps = $51b32cf9efbde13e$var$defaultProps$q;
var $51b32cf9efbde13e$export$2d00230e1e6f7fbc = $51b32cf9efbde13e$var$FormGroup;
const $51b32cf9efbde13e$var$_excluded$n = [
    "className",
    "cssModule",
    "inline",
    "color",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$q = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    inline: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    tag: $51b32cf9efbde13e$var$tagPropType,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$p = {
    tag: "small",
    color: "muted"
};
const $51b32cf9efbde13e$var$FormText = (props)=>{
    const { className: className, cssModule: cssModule, inline: inline, color: color, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$n);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, !inline ? "form-text" : false, color ? `text-${color}` : false), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$FormText.propTypes = $51b32cf9efbde13e$var$propTypes$q;
$51b32cf9efbde13e$var$FormText.defaultProps = $51b32cf9efbde13e$var$defaultProps$p;
var $51b32cf9efbde13e$export$6593ac2583e007ee = $51b32cf9efbde13e$var$FormText;
const $51b32cf9efbde13e$var$_excluded$m = [
    "className",
    "cssModule",
    "type",
    "bsSize",
    "valid",
    "invalid",
    "tag",
    "addon",
    "plaintext",
    "innerRef"
];
const $51b32cf9efbde13e$var$propTypes$p = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    bsSize: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    valid: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    invalid: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    tag: $51b32cf9efbde13e$var$tagPropType,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    plaintext: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    addon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$o = {
    type: "text"
};
class $51b32cf9efbde13e$var$Input extends (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component {
    constructor(props){
        super(props);
        this.getRef = this.getRef.bind(this);
        this.focus = this.focus.bind(this);
    }
    getRef(ref) {
        if (this.props.innerRef) this.props.innerRef(ref);
        this.ref = ref;
    }
    focus() {
        if (this.ref) this.ref.focus();
    }
    render() {
        let _this$props = this.props, { className: className, cssModule: cssModule, type: type, bsSize: bsSize, valid: valid, invalid: invalid, tag: tag, addon: addon, plaintext: plaintext, innerRef: innerRef } = _this$props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(_this$props, $51b32cf9efbde13e$var$_excluded$m);
        const checkInput = [
            "switch",
            "radio",
            "checkbox"
        ].indexOf(type) > -1;
        const isNotaNumber = new RegExp("\\D", "g");
        const textareaInput = type === "textarea";
        const selectInput = type === "select";
        const rangeInput = type === "range";
        let Tag = tag || (selectInput || textareaInput ? type : "input");
        let formControlClass = "form-control";
        if (plaintext) {
            formControlClass = `${formControlClass}-plaintext`;
            Tag = tag || "input";
        } else if (rangeInput) formControlClass = "form-range";
        else if (selectInput) formControlClass = "form-select";
        else if (checkInput) {
            if (addon) formControlClass = null;
            else formControlClass = "form-check-input";
        }
        if (attributes.size && isNotaNumber.test(attributes.size)) {
            $51b32cf9efbde13e$var$warnOnce('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
            bsSize = attributes.size;
            delete attributes.size;
        }
        const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, invalid && "is-invalid", valid && "is-valid", bsSize ? selectInput ? `form-select-${bsSize}` : `form-control-${bsSize}` : false, formControlClass), cssModule);
        if (Tag === "input" || tag && typeof tag === "function") attributes.type = type === "switch" ? "checkbox" : type;
        if (attributes.children && !(plaintext || type === "select" || typeof Tag !== "string" || Tag === "select")) {
            $51b32cf9efbde13e$var$warnOnce(`Input with a type of "${type}" cannot have children. Please use "value"/"defaultValue" instead.`);
            delete attributes.children;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
            ref: innerRef,
            className: classes,
            "aria-invalid": invalid
        }));
    }
}
$51b32cf9efbde13e$var$Input.propTypes = $51b32cf9efbde13e$var$propTypes$p;
$51b32cf9efbde13e$var$Input.defaultProps = $51b32cf9efbde13e$var$defaultProps$o;
var $51b32cf9efbde13e$export$f5b8910cec6cf069 = $51b32cf9efbde13e$var$Input;
const $51b32cf9efbde13e$var$_excluded$l = [
    "className",
    "cssModule",
    "tag",
    "type",
    "size"
];
const $51b32cf9efbde13e$var$propTypes$o = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$n = {
    tag: "div"
};
const $51b32cf9efbde13e$var$InputGroup = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag, type: type, size: size } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$l);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "input-group", size ? `input-group-${size}` : null), cssModule);
    if (props.type === "dropdown") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$931cbfb6bfb85fc, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$InputGroup.propTypes = $51b32cf9efbde13e$var$propTypes$o;
$51b32cf9efbde13e$var$InputGroup.defaultProps = $51b32cf9efbde13e$var$defaultProps$n;
var $51b32cf9efbde13e$export$6e5a9cd40e0c9b97 = $51b32cf9efbde13e$var$InputGroup;
const $51b32cf9efbde13e$var$_excluded$k = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$n = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$m = {
    tag: "span"
};
const $51b32cf9efbde13e$var$InputGroupText = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$k);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "input-group-text"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$InputGroupText.propTypes = $51b32cf9efbde13e$var$propTypes$n;
$51b32cf9efbde13e$var$InputGroupText.defaultProps = $51b32cf9efbde13e$var$defaultProps$m;
var $51b32cf9efbde13e$export$219ad5c362b47f2f = $51b32cf9efbde13e$var$InputGroupText;
const $51b32cf9efbde13e$var$_excluded$j = [
    "className",
    "cssModule",
    "hidden",
    "widths",
    "tag",
    "check",
    "size",
    "for"
];
const $51b32cf9efbde13e$var$colWidths = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
const $51b32cf9efbde13e$var$stringOrNumberProp = (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
]);
const $51b32cf9efbde13e$var$columnProps = (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        size: $51b32cf9efbde13e$var$stringOrNumberProp,
        order: $51b32cf9efbde13e$var$stringOrNumberProp,
        offset: $51b32cf9efbde13e$var$stringOrNumberProp
    })
]);
const $51b32cf9efbde13e$var$propTypes$m = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    hidden: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    check: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    for: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    xs: $51b32cf9efbde13e$var$columnProps,
    sm: $51b32cf9efbde13e$var$columnProps,
    md: $51b32cf9efbde13e$var$columnProps,
    lg: $51b32cf9efbde13e$var$columnProps,
    xl: $51b32cf9efbde13e$var$columnProps,
    xxl: $51b32cf9efbde13e$var$columnProps,
    widths: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).array
};
const $51b32cf9efbde13e$var$defaultProps$l = {
    tag: "label",
    widths: $51b32cf9efbde13e$var$colWidths
};
const $51b32cf9efbde13e$var$getColumnSizeClass = (isXs, colWidth, colSize)=>{
    if (colSize === true || colSize === "") return isXs ? "col" : `col-${colWidth}`;
    else if (colSize === "auto") return isXs ? "col-auto" : `col-${colWidth}-auto`;
    return isXs ? `col-${colSize}` : `col-${colWidth}-${colSize}`;
};
const $51b32cf9efbde13e$var$Label = (props)=>{
    const { className: className, cssModule: cssModule, hidden: hidden, widths: widths, tag: Tag, check: check, size: size, for: htmlFor } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$j);
    const colClasses = [];
    widths.forEach((colWidth, i)=>{
        let columnProp = props[colWidth];
        delete attributes[colWidth];
        if (!columnProp && columnProp !== "") return;
        const isXs = !i;
        let colClass;
        if ($51b32cf9efbde13e$var$isObject(columnProp)) {
            const colSizeInterfix = isXs ? "-" : `-${colWidth}-`;
            colClass = $51b32cf9efbde13e$var$getColumnSizeClass(isXs, colWidth, columnProp.size);
            colClasses.push($51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))({
                [colClass]: columnProp.size || columnProp.size === "",
                [`order${colSizeInterfix}${columnProp.order}`]: columnProp.order || columnProp.order === 0,
                [`offset${colSizeInterfix}${columnProp.offset}`]: columnProp.offset || columnProp.offset === 0
            })), cssModule);
        } else {
            colClass = $51b32cf9efbde13e$var$getColumnSizeClass(isXs, colWidth, columnProp);
            colClasses.push(colClass);
        }
    });
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, hidden ? "visually-hidden" : false, check ? "form-check-label" : false, size ? `col-form-label-${size}` : false, colClasses, colClasses.length ? "col-form-label" : "form-label"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({
        htmlFor: htmlFor
    }, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$Label.propTypes = $51b32cf9efbde13e$var$propTypes$m;
$51b32cf9efbde13e$var$Label.defaultProps = $51b32cf9efbde13e$var$defaultProps$l;
var $51b32cf9efbde13e$export$b04be29aa201d4f5 = $51b32cf9efbde13e$var$Label;
const $51b32cf9efbde13e$var$_excluded$i = [
    "body",
    "bottom",
    "className",
    "cssModule",
    "heading",
    "left",
    "list",
    "middle",
    "object",
    "right",
    "tag",
    "top"
];
const $51b32cf9efbde13e$var$propTypes$l = {
    body: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    bottom: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    heading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    left: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    list: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    middle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    object: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    right: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    tag: $51b32cf9efbde13e$var$tagPropType,
    top: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
const $51b32cf9efbde13e$var$Media = (props)=>{
    const { body: body, bottom: bottom, className: className, cssModule: cssModule, heading: heading, left: left, list: list, middle: middle, object: object, right: right, tag: tag, top: top } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$i);
    let defaultTag;
    if (heading) defaultTag = "h4";
    else if (attributes.href) defaultTag = "a";
    else if (attributes.src || object) defaultTag = "img";
    else if (list) defaultTag = "ul";
    else defaultTag = "div";
    const Tag = tag || defaultTag;
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, {
        "media-body": body,
        "media-heading": heading,
        "media-left": left,
        "media-right": right,
        "media-top": top,
        "media-bottom": bottom,
        "media-middle": middle,
        "media-object": object,
        "media-list": list,
        media: !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list
    }), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$Media.propTypes = $51b32cf9efbde13e$var$propTypes$l;
var $51b32cf9efbde13e$export$7fc53215244aec38 = $51b32cf9efbde13e$var$Media;
function $51b32cf9efbde13e$var$noop() {}
const $51b32cf9efbde13e$var$FadePropTypes = (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape($51b32cf9efbde13e$export$c983850c6c9d8b0e.propTypes);
const $51b32cf9efbde13e$var$propTypes$k = {
    autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    backdrop: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    backdropClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    backdropTransition: $51b32cf9efbde13e$var$FadePropTypes,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    container: $51b32cf9efbde13e$var$targetPropType,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOf([
        "start",
        "end",
        "bottom",
        "top",
        "left",
        "right"
    ]),
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    ]),
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    keyboard: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    labelledBy: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    offcanvasTransition: $51b32cf9efbde13e$var$FadePropTypes,
    onClosed: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onExit: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onOpened: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    returnFocusAfterClose: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    scrollable: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    trapFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    unmountOnClose: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    zIndex: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ])
};
const $51b32cf9efbde13e$var$propsToOmit = Object.keys($51b32cf9efbde13e$var$propTypes$k);
const $51b32cf9efbde13e$var$defaultProps$k = {
    isOpen: false,
    autoFocus: true,
    direction: "start",
    scrollable: false,
    role: "dialog",
    backdrop: true,
    keyboard: true,
    zIndex: 1050,
    fade: true,
    onOpened: $51b32cf9efbde13e$var$noop,
    onClosed: $51b32cf9efbde13e$var$noop,
    offcanvasTransition: {
        timeout: $51b32cf9efbde13e$var$TransitionTimeouts.Offcanvas
    },
    backdropTransition: {
        mountOnEnter: true,
        timeout: $51b32cf9efbde13e$var$TransitionTimeouts.Fade // uses standard fade transition
    },
    unmountOnClose: true,
    returnFocusAfterClose: true,
    container: "body",
    trapFocus: false
};
class $51b32cf9efbde13e$var$Offcanvas extends (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component {
    constructor(props){
        super(props);
        this._element = null;
        this._originalBodyPadding = null;
        this.getFocusableChildren = this.getFocusableChildren.bind(this);
        this.handleBackdropClick = this.handleBackdropClick.bind(this);
        this.handleBackdropMouseDown = this.handleBackdropMouseDown.bind(this);
        this.handleEscape = this.handleEscape.bind(this);
        this.handleTab = this.handleTab.bind(this);
        this.onOpened = this.onOpened.bind(this);
        this.onClosed = this.onClosed.bind(this);
        this.manageFocusAfterClose = this.manageFocusAfterClose.bind(this);
        this.clearBackdropAnimationTimeout = this.clearBackdropAnimationTimeout.bind(this);
        this.trapFocus = this.trapFocus.bind(this);
        this.state = {
            isOpen: false
        };
    }
    componentDidMount() {
        const { isOpen: isOpen, autoFocus: autoFocus, onEnter: onEnter } = this.props;
        if (isOpen) {
            this.init();
            this.setState({
                isOpen: true
            });
            if (autoFocus) this.setFocus();
        }
        if (onEnter) onEnter();
         // traps focus inside the Offcanvas, even if the browser address bar is focused
        document.addEventListener("focus", this.trapFocus, true);
        this._isMounted = true;
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.init();
            this.setState({
                isOpen: true
            });
            return;
        } // now Offcanvas Dialog is rendered and we can refer this._element and this._dialog
        if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) this.setFocus();
        if (this._element && prevProps.zIndex !== this.props.zIndex) this._element.style.zIndex = this.props.zIndex;
    }
    componentWillUnmount() {
        this.clearBackdropAnimationTimeout();
        if (this.props.onExit) this.props.onExit();
        if (this._element) {
            this.destroy();
            if (this.props.isOpen || this.state.isOpen) this.close();
        }
        document.removeEventListener("focus", this.trapFocus, true);
        this._isMounted = false;
    }
    trapFocus(ev) {
        if (!this.props.trapFocus) return;
        if (!this._element) return;
        if (this._dialog === ev.target) return;
        if (this.offcanvasIndex < $51b32cf9efbde13e$var$Offcanvas.openCount - 1) return;
        const children = this.getFocusableChildren();
        for(let i = 0; i < children.length; i++){
            // focus is already inside the Offcanvas
            if (children[i] === ev.target) return;
        }
        if (children.length > 0) {
            // otherwise focus the first focusable element in the Offcanvas
            ev.preventDefault();
            ev.stopPropagation();
            children[0].focus();
        }
    }
    onOpened(node, isAppearing) {
        this.props.onOpened();
        (this.props.offcanvasTransition.onEntered || $51b32cf9efbde13e$var$noop)(node, isAppearing);
    }
    onClosed(node) {
        const { unmountOnClose: unmountOnClose } = this.props; // so all methods get called before it is unmounted
        this.props.onClosed();
        (this.props.offcanvasTransition.onExited || $51b32cf9efbde13e$var$noop)(node);
        if (unmountOnClose) this.destroy();
        this.close();
        if (this._isMounted) this.setState({
            isOpen: false
        });
    }
    setFocus() {
        if (this._dialog && typeof this._dialog.focus === "function") this._dialog.focus();
    }
    getFocusableChildren() {
        return this._element.querySelectorAll($51b32cf9efbde13e$var$focusableElements.join(", "));
    }
    getFocusedChild() {
        let currentFocus;
        const focusableChildren = this.getFocusableChildren();
        try {
            currentFocus = document.activeElement;
        } catch (err) {
            currentFocus = focusableChildren[0];
        }
        return currentFocus;
    }
    handleBackdropClick(e) {
        if (e.target === this._mouseDownElement) {
            e.stopPropagation();
            const backdrop = this._backdrop;
            if (!this.props.isOpen || this.props.backdrop !== true) return;
            if (backdrop && e.target === backdrop && this.props.toggle) this.props.toggle(e);
        }
    }
    handleTab(e) {
        if (e.which !== 9) return;
        if (this.offcanvasIndex < $51b32cf9efbde13e$var$Offcanvas.openCount - 1) return; // last opened offcanvas
        const focusableChildren = this.getFocusableChildren();
        const totalFocusable = focusableChildren.length;
        if (totalFocusable === 0) return;
        const currentFocus = this.getFocusedChild();
        let focusedIndex = 0;
        for(let i = 0; i < totalFocusable; i += 1)if (focusableChildren[i] === currentFocus) {
            focusedIndex = i;
            break;
        }
        if (e.shiftKey && focusedIndex === 0) {
            e.preventDefault();
            focusableChildren[totalFocusable - 1].focus();
        } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
            e.preventDefault();
            focusableChildren[0].focus();
        }
    }
    handleBackdropMouseDown(e) {
        this._mouseDownElement = e.target;
    }
    handleEscape(e) {
        if (this.props.isOpen && e.keyCode === $51b32cf9efbde13e$var$keyCodes.esc && this.props.toggle) {
            if (this.props.keyboard) {
                e.preventDefault();
                e.stopPropagation();
                this.props.toggle(e);
            }
        }
    }
    init() {
        try {
            this._triggeringElement = document.activeElement;
        } catch (err) {
            this._triggeringElement = null;
        }
        if (!this._element) {
            this._element = document.createElement("div");
            this._element.setAttribute("tabindex", "-1");
            this._element.style.position = "relative";
            this._element.style.zIndex = this.props.zIndex;
            this._mountContainer = $51b32cf9efbde13e$var$getTarget(this.props.container);
            this._mountContainer.appendChild(this._element);
        }
        this._originalBodyPadding = $51b32cf9efbde13e$var$getOriginalBodyPadding();
        $51b32cf9efbde13e$var$conditionallyUpdateScrollbar();
        if ($51b32cf9efbde13e$var$Offcanvas.openCount === 0 && this.props.backdrop && !this.props.scrollable) document.body.style.overflow = "hidden";
        this.offcanvasIndex = $51b32cf9efbde13e$var$Offcanvas.openCount;
        $51b32cf9efbde13e$var$Offcanvas.openCount += 1;
    }
    destroy() {
        if (this._element) {
            this._mountContainer.removeChild(this._element);
            this._element = null;
        }
        this.manageFocusAfterClose();
    }
    manageFocusAfterClose() {
        if (this._triggeringElement) {
            const { returnFocusAfterClose: returnFocusAfterClose } = this.props;
            if (this._triggeringElement.focus && returnFocusAfterClose) this._triggeringElement.focus();
            this._triggeringElement = null;
        }
    }
    close() {
        this.manageFocusAfterClose();
        $51b32cf9efbde13e$var$Offcanvas.openCount = Math.max(0, $51b32cf9efbde13e$var$Offcanvas.openCount - 1);
        document.body.style.overflow = null;
        $51b32cf9efbde13e$var$setScrollbarWidth(this._originalBodyPadding);
    }
    render() {
        const { direction: direction, unmountOnClose: unmountOnClose } = this.props;
        if (!!this._element && (this.state.isOpen || !unmountOnClose)) {
            const isOffcanvasHidden = !!this._element && !this.state.isOpen && !unmountOnClose;
            this._element.style.display = isOffcanvasHidden ? "none" : "block";
            const { className: className, backdropClassName: backdropClassName, cssModule: cssModule, isOpen: isOpen, backdrop: backdrop, role: role, labelledBy: labelledBy, style: style } = this.props;
            const offcanvasAttributes = {
                onKeyUp: this.handleEscape,
                onKeyDown: this.handleTab,
                "aria-labelledby": labelledBy,
                role: role,
                tabIndex: "-1"
            };
            const hasTransition = this.props.fade;
            const offcanvasTransition = $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, $51b32cf9efbde13e$export$c983850c6c9d8b0e.defaultProps), this.props.offcanvasTransition), {}, {
                baseClass: hasTransition ? this.props.offcanvasTransition.baseClass : "",
                timeout: hasTransition ? this.props.offcanvasTransition.timeout : 0
            });
            const backdropTransition = $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, $51b32cf9efbde13e$export$c983850c6c9d8b0e.defaultProps), this.props.backdropTransition), {}, {
                baseClass: hasTransition ? this.props.backdropTransition.baseClass : "",
                timeout: hasTransition ? this.props.backdropTransition.timeout : 0
            });
            const Backdrop = backdrop && (hasTransition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$c983850c6c9d8b0e, $51b32cf9efbde13e$var$_extends({}, backdropTransition, {
                in: isOpen && !!backdrop,
                innerRef: (c)=>{
                    this._backdrop = c;
                },
                cssModule: cssModule,
                className: $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("offcanvas-backdrop", backdropClassName), cssModule),
                onClick: this.handleBackdropClick,
                onMouseDown: this.handleBackdropMouseDown
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("div", {
                className: $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("offcanvas-backdrop", "show", backdropClassName), cssModule),
                onClick: this.handleBackdropClick,
                onMouseDown: this.handleBackdropMouseDown
            }));
            const attributes = $51b32cf9efbde13e$var$omit(this.props, $51b32cf9efbde13e$var$propsToOmit);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$var$Portal$1, {
                node: this._element
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$c983850c6c9d8b0e, $51b32cf9efbde13e$var$_extends({}, attributes, offcanvasAttributes, offcanvasTransition, {
                in: isOpen,
                onEntered: this.onOpened,
                onExited: this.onClosed,
                cssModule: cssModule,
                className: $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("offcanvas", className, `offcanvas-${direction}`), cssModule),
                innerRef: (c)=>{
                    this._dialog = c;
                },
                style: $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, style), {}, {
                    visibility: isOpen ? "visible" : "hidden"
                })
            }), this.props.children), Backdrop);
        }
        return null;
    }
    clearBackdropAnimationTimeout() {
        if (this._backdropAnimationTimeout) {
            clearTimeout(this._backdropAnimationTimeout);
            this._backdropAnimationTimeout = undefined;
        }
    }
}
$51b32cf9efbde13e$var$Offcanvas.propTypes = $51b32cf9efbde13e$var$propTypes$k;
$51b32cf9efbde13e$var$Offcanvas.defaultProps = $51b32cf9efbde13e$var$defaultProps$k;
$51b32cf9efbde13e$var$Offcanvas.openCount = 0;
var $51b32cf9efbde13e$export$591ca0244c9dfcd4 = $51b32cf9efbde13e$var$Offcanvas;
const $51b32cf9efbde13e$var$_excluded$h = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$j = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$j = {
    tag: "div"
};
const $51b32cf9efbde13e$var$OffcanvasBody = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$h);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "offcanvas-body"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$OffcanvasBody.propTypes = $51b32cf9efbde13e$var$propTypes$j;
$51b32cf9efbde13e$var$OffcanvasBody.defaultProps = $51b32cf9efbde13e$var$defaultProps$j;
var $51b32cf9efbde13e$export$c324d20ecc5b7dee = $51b32cf9efbde13e$var$OffcanvasBody;
const $51b32cf9efbde13e$var$_excluded$g = [
    "children",
    "className",
    "close",
    "closeAriaLabel",
    "cssModule",
    "tag",
    "toggle",
    "wrapTag"
];
const $51b32cf9efbde13e$var$propTypes$i = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    close: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    closeAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    tag: $51b32cf9efbde13e$var$tagPropType,
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    wrapTag: $51b32cf9efbde13e$var$tagPropType
};
const $51b32cf9efbde13e$var$defaultProps$i = {
    closeAriaLabel: "Close",
    tag: "h5",
    wrapTag: "div"
};
const $51b32cf9efbde13e$var$OffcanvasHeader = (props)=>{
    let closeButton;
    const { children: children, className: className, close: close, closeAriaLabel: closeAriaLabel, cssModule: cssModule, tag: Tag, toggle: toggle, wrapTag: WrapTag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$g);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "offcanvas-header"), cssModule);
    if (!close && toggle) closeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("button", {
        type: "button",
        onClick: toggle,
        className: $51b32cf9efbde13e$var$mapToCssModules("btn-close", cssModule),
        "aria-label": closeAriaLabel
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(WrapTag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, {
        className: $51b32cf9efbde13e$var$mapToCssModules("offcanvas-title", cssModule)
    }, children), close || closeButton);
};
$51b32cf9efbde13e$var$OffcanvasHeader.propTypes = $51b32cf9efbde13e$var$propTypes$i;
$51b32cf9efbde13e$var$OffcanvasHeader.defaultProps = $51b32cf9efbde13e$var$defaultProps$i;
var $51b32cf9efbde13e$export$b6c1518fb8dc5e75 = $51b32cf9efbde13e$var$OffcanvasHeader;
const $51b32cf9efbde13e$var$_excluded$f = [
    "className",
    "listClassName",
    "cssModule",
    "size",
    "tag",
    "listTag",
    "aria-label"
];
const $51b32cf9efbde13e$var$propTypes$h = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    listClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    tag: $51b32cf9efbde13e$var$tagPropType,
    listTag: $51b32cf9efbde13e$var$tagPropType,
    "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
const $51b32cf9efbde13e$var$defaultProps$h = {
    tag: "nav",
    listTag: "ul",
    "aria-label": "pagination"
};
const $51b32cf9efbde13e$var$Pagination = (props)=>{
    const { className: className, listClassName: listClassName, cssModule: cssModule, size: size, tag: Tag, listTag: ListTag, "aria-label": label } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$f);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className), cssModule);
    const listClasses = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(listClassName, "pagination", {
        [`pagination-${size}`]: !!size
    }), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, {
        className: classes,
        "aria-label": label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(ListTag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: listClasses
    })));
};
$51b32cf9efbde13e$var$Pagination.propTypes = $51b32cf9efbde13e$var$propTypes$h;
$51b32cf9efbde13e$var$Pagination.defaultProps = $51b32cf9efbde13e$var$defaultProps$h;
var $51b32cf9efbde13e$export$68f5e1453c188a82 = $51b32cf9efbde13e$var$Pagination;
const $51b32cf9efbde13e$var$_excluded$e = [
    "active",
    "className",
    "cssModule",
    "disabled",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$g = {
    active: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    tag: $51b32cf9efbde13e$var$tagPropType
};
const $51b32cf9efbde13e$var$defaultProps$g = {
    tag: "li"
};
const $51b32cf9efbde13e$var$PaginationItem = (props)=>{
    const { active: active, className: className, cssModule: cssModule, disabled: disabled, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$e);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "page-item", {
        active: active,
        disabled: disabled
    }), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$PaginationItem.propTypes = $51b32cf9efbde13e$var$propTypes$g;
$51b32cf9efbde13e$var$PaginationItem.defaultProps = $51b32cf9efbde13e$var$defaultProps$g;
var $51b32cf9efbde13e$export$c82a077939f0464b = $51b32cf9efbde13e$var$PaginationItem;
const $51b32cf9efbde13e$var$_excluded$d = [
    "className",
    "cssModule",
    "next",
    "previous",
    "first",
    "last",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$f = {
    "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    next: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    previous: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    first: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    last: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    tag: $51b32cf9efbde13e$var$tagPropType
};
const $51b32cf9efbde13e$var$defaultProps$f = {
    tag: "a"
};
const $51b32cf9efbde13e$var$PaginationLink = (props)=>{
    let { className: className, cssModule: cssModule, next: next, previous: previous, first: first, last: last, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$d);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "page-link"), cssModule);
    let defaultAriaLabel;
    if (previous) defaultAriaLabel = "Previous";
    else if (next) defaultAriaLabel = "Next";
    else if (first) defaultAriaLabel = "First";
    else if (last) defaultAriaLabel = "Last";
    const ariaLabel = props["aria-label"] || defaultAriaLabel;
    let defaultCaret;
    if (previous) defaultCaret = "\u2039";
    else if (next) defaultCaret = "\u203A";
    else if (first) defaultCaret = "\xab";
    else if (last) defaultCaret = "\xbb";
    let children = props.children;
    if (children && Array.isArray(children) && children.length === 0) children = null;
    if (!attributes.href && Tag === "a") Tag = "button";
    if (previous || next || first || last) children = [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("span", {
            "aria-hidden": "true",
            key: "caret"
        }, children || defaultCaret),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("span", {
            className: "visually-hidden",
            key: "ariaLabel"
        }, ariaLabel)
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes,
        "aria-label": ariaLabel
    }), children);
};
$51b32cf9efbde13e$var$PaginationLink.propTypes = $51b32cf9efbde13e$var$propTypes$f;
$51b32cf9efbde13e$var$PaginationLink.defaultProps = $51b32cf9efbde13e$var$defaultProps$f;
var $51b32cf9efbde13e$export$389c2523d2fb7ac8 = $51b32cf9efbde13e$var$PaginationLink;
/**
 * TabContext
 * {
 *  activeTabId: PropTypes.any
 * }
 */ const $51b32cf9efbde13e$var$TabContext = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext({});
const $51b32cf9efbde13e$var$propTypes$e = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    activeTab: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$e = {
    tag: "div"
};
class $51b32cf9efbde13e$var$TabContent extends (0, $tZqWC.Component) {
    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.activeTab !== nextProps.activeTab) return {
            activeTab: nextProps.activeTab
        };
        return null;
    }
    constructor(props){
        super(props);
        this.state = {
            activeTab: this.props.activeTab
        };
    }
    render() {
        const { className: className, cssModule: cssModule, tag: Tag } = this.props;
        const attributes = $51b32cf9efbde13e$var$omit(this.props, Object.keys($51b32cf9efbde13e$var$propTypes$e));
        const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("tab-content", className), cssModule);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$var$TabContext.Provider, {
            value: {
                activeTabId: this.state.activeTab
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
            className: classes
        })));
    }
}
var $51b32cf9efbde13e$export$9c591276dfd5d919 = $51b32cf9efbde13e$var$TabContent;
$51b32cf9efbde13e$var$TabContent.propTypes = $51b32cf9efbde13e$var$propTypes$e;
$51b32cf9efbde13e$var$TabContent.defaultProps = $51b32cf9efbde13e$var$defaultProps$e;
const $51b32cf9efbde13e$var$_excluded$c = [
    "className",
    "cssModule",
    "tabId",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$d = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    tabId: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any
};
const $51b32cf9efbde13e$var$defaultProps$d = {
    tag: "div"
};
function $51b32cf9efbde13e$export$6ebb62b9195ea916(props) {
    const { className: className, cssModule: cssModule, tabId: tabId, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$c);
    const getClasses = (activeTabId)=>$51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("tab-pane", className, {
            active: tabId === activeTabId
        }), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$var$TabContext.Consumer, null, ({ activeTabId: activeTabId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
            className: getClasses(activeTabId)
        })));
}
$51b32cf9efbde13e$export$6ebb62b9195ea916.propTypes = $51b32cf9efbde13e$var$propTypes$d;
$51b32cf9efbde13e$export$6ebb62b9195ea916.defaultProps = $51b32cf9efbde13e$var$defaultProps$d;
const $51b32cf9efbde13e$var$_excluded$b = [
    "className",
    "closeClassName",
    "closeAriaLabel",
    "cssModule",
    "tag",
    "color",
    "isOpen",
    "toggle",
    "children",
    "transition",
    "fade",
    "innerRef"
];
const $51b32cf9efbde13e$var$propTypes$c = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    closeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    closeAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    tag: $51b32cf9efbde13e$var$tagPropType,
    transition: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape($51b32cf9efbde13e$export$c983850c6c9d8b0e.propTypes),
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    ])
};
const $51b32cf9efbde13e$var$defaultProps$c = {
    color: "success",
    isOpen: true,
    tag: "div",
    closeAriaLabel: "Close",
    fade: true,
    transition: $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, $51b32cf9efbde13e$export$c983850c6c9d8b0e.defaultProps), {}, {
        unmountOnExit: true
    })
};
function $51b32cf9efbde13e$export$caec2af78bcc877f(props) {
    const { className: className, closeClassName: closeClassName, closeAriaLabel: closeAriaLabel, cssModule: cssModule, tag: Tag, color: color, isOpen: isOpen, toggle: toggle, children: children, transition: transition, fade: fade, innerRef: innerRef } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$b);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "alert", `alert-${color}`, {
        "alert-dismissible": toggle
    }), cssModule);
    const closeClasses = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("btn-close", closeClassName), cssModule);
    const alertTransition = $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, $51b32cf9efbde13e$export$c983850c6c9d8b0e.defaultProps), transition), {}, {
        baseClass: fade ? transition.baseClass : "",
        timeout: fade ? transition.timeout : 0
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$c983850c6c9d8b0e, $51b32cf9efbde13e$var$_extends({}, attributes, alertTransition, {
        tag: Tag,
        className: classes,
        in: isOpen,
        role: "alert",
        innerRef: innerRef
    }), toggle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("button", {
        type: "button",
        className: closeClasses,
        "aria-label": closeAriaLabel,
        onClick: toggle
    }) : null, children);
}
$51b32cf9efbde13e$export$caec2af78bcc877f.propTypes = $51b32cf9efbde13e$var$propTypes$c;
$51b32cf9efbde13e$export$caec2af78bcc877f.defaultProps = $51b32cf9efbde13e$var$defaultProps$c;
const $51b32cf9efbde13e$var$_excluded$a = [
    "className",
    "cssModule",
    "tag",
    "isOpen",
    "children",
    "transition",
    "fade",
    "innerRef"
];
const $51b32cf9efbde13e$var$propTypes$b = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    tag: $51b32cf9efbde13e$var$tagPropType,
    transition: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape($51b32cf9efbde13e$export$c983850c6c9d8b0e.propTypes),
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    ])
};
const $51b32cf9efbde13e$var$defaultProps$b = {
    isOpen: true,
    tag: "div",
    fade: true,
    transition: $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, $51b32cf9efbde13e$export$c983850c6c9d8b0e.defaultProps), {}, {
        unmountOnExit: true
    })
};
function $51b32cf9efbde13e$export$8d8dc7d5f743331b(props) {
    const { className: className, cssModule: cssModule, tag: Tag, isOpen: isOpen, children: children, transition: transition, fade: fade, innerRef: innerRef } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$a);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "toast"), cssModule);
    const toastTransition = $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, $51b32cf9efbde13e$export$c983850c6c9d8b0e.defaultProps), transition), {}, {
        baseClass: fade ? transition.baseClass : "",
        timeout: fade ? transition.timeout : 0
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$c983850c6c9d8b0e, $51b32cf9efbde13e$var$_extends({}, attributes, toastTransition, {
        tag: Tag,
        className: classes,
        in: isOpen,
        role: "alert",
        innerRef: innerRef
    }), children);
}
$51b32cf9efbde13e$export$8d8dc7d5f743331b.propTypes = $51b32cf9efbde13e$var$propTypes$b;
$51b32cf9efbde13e$export$8d8dc7d5f743331b.defaultProps = $51b32cf9efbde13e$var$defaultProps$b;
const $51b32cf9efbde13e$var$_excluded$9 = [
    "className",
    "cssModule",
    "innerRef",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$a = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    ])
};
const $51b32cf9efbde13e$var$defaultProps$a = {
    tag: "div"
};
const $51b32cf9efbde13e$var$ToastBody = (props)=>{
    const { className: className, cssModule: cssModule, innerRef: innerRef, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$9);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "toast-body"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes,
        ref: innerRef
    }));
};
$51b32cf9efbde13e$var$ToastBody.propTypes = $51b32cf9efbde13e$var$propTypes$a;
$51b32cf9efbde13e$var$ToastBody.defaultProps = $51b32cf9efbde13e$var$defaultProps$a;
var $51b32cf9efbde13e$export$a2fc124486ff7b59 = $51b32cf9efbde13e$var$ToastBody;
const $51b32cf9efbde13e$var$_excluded$8 = [
    "className",
    "cssModule",
    "children",
    "toggle",
    "tag",
    "wrapTag",
    "closeAriaLabel",
    "close",
    "tagClassName",
    "icon"
];
const $51b32cf9efbde13e$var$propTypes$9 = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    wrapTag: $51b32cf9efbde13e$var$tagPropType,
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    closeAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    charCode: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    ]),
    close: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$9 = {
    tag: "strong",
    wrapTag: "div",
    tagClassName: "me-auto",
    closeAriaLabel: "Close"
};
const $51b32cf9efbde13e$var$ToastHeader = (props)=>{
    let closeButton;
    let icon;
    const { className: className, cssModule: cssModule, children: children, toggle: toggle, tag: Tag, wrapTag: WrapTag, closeAriaLabel: closeAriaLabel, close: close, tagClassName: tagClassName, icon: iconProp } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$8);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "toast-header"), cssModule);
    if (!close && toggle) closeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("button", {
        type: "button",
        onClick: toggle,
        className: $51b32cf9efbde13e$var$mapToCssModules("btn-close", cssModule),
        "aria-label": closeAriaLabel
    });
    if (typeof iconProp === "string") icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("svg", {
        className: $51b32cf9efbde13e$var$mapToCssModules(`rounded text-${iconProp}`),
        width: "20",
        height: "20",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid slice",
        focusable: "false",
        role: "img"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("rect", {
        fill: "currentColor",
        width: "100%",
        height: "100%"
    }));
    else if (iconProp) icon = iconProp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(WrapTag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }), icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, {
        className: $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(tagClassName, {
            "ms-2": icon != null
        }), cssModule)
    }, children), close || closeButton);
};
$51b32cf9efbde13e$var$ToastHeader.propTypes = $51b32cf9efbde13e$var$propTypes$9;
$51b32cf9efbde13e$var$ToastHeader.defaultProps = $51b32cf9efbde13e$var$defaultProps$9;
var $51b32cf9efbde13e$export$32b6bd01d23c94bc = $51b32cf9efbde13e$var$ToastHeader;
const $51b32cf9efbde13e$var$_excluded$7 = [
    "className",
    "cssModule",
    "tag",
    "active",
    "disabled",
    "action",
    "color"
];
const $51b32cf9efbde13e$var$propTypes$8 = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    action: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$8 = {
    tag: "li"
};
const $51b32cf9efbde13e$var$handleDisabledOnClick = (e)=>{
    e.preventDefault();
};
const $51b32cf9efbde13e$var$ListGroupItem = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag, active: active, disabled: disabled, action: action, color: color } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$7);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, active ? "active" : false, disabled ? "disabled" : false, action ? "list-group-item-action" : false, color ? `list-group-item-${color}` : false, "list-group-item"), cssModule); // Prevent click event when disabled.
    if (disabled) attributes.onClick = $51b32cf9efbde13e$var$handleDisabledOnClick;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$ListGroupItem.propTypes = $51b32cf9efbde13e$var$propTypes$8;
$51b32cf9efbde13e$var$ListGroupItem.defaultProps = $51b32cf9efbde13e$var$defaultProps$8;
var $51b32cf9efbde13e$export$3175656842a28549 = $51b32cf9efbde13e$var$ListGroupItem;
const $51b32cf9efbde13e$var$_excluded$6 = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$7 = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$7 = {
    tag: "h5"
};
const $51b32cf9efbde13e$var$ListGroupItemHeading = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$6);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "list-group-item-heading"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$ListGroupItemHeading.propTypes = $51b32cf9efbde13e$var$propTypes$7;
$51b32cf9efbde13e$var$ListGroupItemHeading.defaultProps = $51b32cf9efbde13e$var$defaultProps$7;
var $51b32cf9efbde13e$export$1e092959ce0c5b57 = $51b32cf9efbde13e$var$ListGroupItemHeading;
const $51b32cf9efbde13e$var$_excluded$5 = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$6 = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$6 = {
    tag: "p"
};
const $51b32cf9efbde13e$var$ListGroupItemText = (props)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$5);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "list-group-item-text"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes
    }));
};
$51b32cf9efbde13e$var$ListGroupItemText.propTypes = $51b32cf9efbde13e$var$propTypes$6;
$51b32cf9efbde13e$var$ListGroupItemText.defaultProps = $51b32cf9efbde13e$var$defaultProps$6;
var $51b32cf9efbde13e$export$a9a84acb508c3670 = $51b32cf9efbde13e$var$ListGroupItemText;
const $51b32cf9efbde13e$var$_excluded$4 = [
    "className",
    "cssModule",
    "tag",
    "type"
];
const $51b32cf9efbde13e$var$propTypes$5 = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
const $51b32cf9efbde13e$var$defaultProps$5 = {
    tag: "ul"
};
const $51b32cf9efbde13e$var$List = (0, $tZqWC.forwardRef)((props, ref)=>{
    const { className: className, cssModule: cssModule, tag: Tag, type: type } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$4);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, type ? `list-${type}` : false), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes,
        ref: ref
    }));
});
$51b32cf9efbde13e$var$List.name = "List";
$51b32cf9efbde13e$var$List.propTypes = $51b32cf9efbde13e$var$propTypes$5;
$51b32cf9efbde13e$var$List.defaultProps = $51b32cf9efbde13e$var$defaultProps$5;
var $51b32cf9efbde13e$export$54c2e3dc7acea9f5 = $51b32cf9efbde13e$var$List;
const $51b32cf9efbde13e$var$_excluded$3 = [
    "className",
    "cssModule",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$4 = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object
};
const $51b32cf9efbde13e$var$defaultProps$4 = {
    tag: "li"
};
const $51b32cf9efbde13e$var$ListInlineItem = (0, $tZqWC.forwardRef)((props, ref)=>{
    const { className: className, cssModule: cssModule, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$3);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, "list-inline-item"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, attributes, {
        className: classes,
        ref: ref
    }));
});
$51b32cf9efbde13e$var$ListInlineItem.name = "ListInlineItem";
$51b32cf9efbde13e$var$ListInlineItem.propTypes = $51b32cf9efbde13e$var$propTypes$4;
$51b32cf9efbde13e$var$ListInlineItem.defaultProps = $51b32cf9efbde13e$var$defaultProps$4;
var $51b32cf9efbde13e$export$6810ec78cae95d4 = $51b32cf9efbde13e$var$ListInlineItem;
class $51b32cf9efbde13e$var$UncontrolledAlert extends (0, $tZqWC.Component) {
    constructor(props){
        super(props);
        this.state = {
            isOpen: true
        };
        this.toggle = this.toggle.bind(this);
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$caec2af78bcc877f, $51b32cf9efbde13e$var$_extends({
            isOpen: this.state.isOpen,
            toggle: this.toggle
        }, this.props));
    }
}
var $51b32cf9efbde13e$export$91b8e350d5cd3158 = $51b32cf9efbde13e$var$UncontrolledAlert;
const $51b32cf9efbde13e$var$omitKeys$3 = [
    "defaultOpen"
];
class $51b32cf9efbde13e$export$384fe546d5d3a6a9 extends (0, $tZqWC.Component) {
    constructor(props){
        super(props);
        this.state = {
            isOpen: props.defaultOpen || false
        };
        this.toggle = this.toggle.bind(this);
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$72d7ed2c84b0d1c0, $51b32cf9efbde13e$var$_extends({
            isOpen: this.state.isOpen,
            toggle: this.toggle
        }, $51b32cf9efbde13e$var$omit(this.props, $51b32cf9efbde13e$var$omitKeys$3)));
    }
}
$51b32cf9efbde13e$export$384fe546d5d3a6a9.propTypes = $51b32cf9efbde13e$var$_objectSpread2({
    defaultOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
}, $51b32cf9efbde13e$export$72d7ed2c84b0d1c0.propTypes);
const $51b32cf9efbde13e$var$omitKeys$2 = [
    "toggleEvents",
    "defaultOpen"
];
const $51b32cf9efbde13e$var$propTypes$3 = {
    defaultOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    toggler: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string.isRequired,
    toggleEvents: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string)
};
const $51b32cf9efbde13e$var$defaultProps$3 = {
    toggleEvents: $51b32cf9efbde13e$var$defaultToggleEvents
};
class $51b32cf9efbde13e$var$UncontrolledCollapse extends (0, $tZqWC.Component) {
    constructor(props){
        super(props);
        this.togglers = null;
        this.removeEventListeners = null;
        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: props.defaultOpen || false
        };
    }
    componentDidMount() {
        this.togglers = $51b32cf9efbde13e$var$findDOMElements(this.props.toggler);
        if (this.togglers.length) this.removeEventListeners = $51b32cf9efbde13e$var$addMultipleEventListeners(this.togglers, this.toggle, this.props.toggleEvents);
    }
    componentWillUnmount() {
        if (this.togglers.length && this.removeEventListeners) this.removeEventListeners();
    }
    toggle(e) {
        this.setState(({ isOpen: isOpen })=>({
                isOpen: !isOpen
            }));
        e.preventDefault();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$78768a9af065a7b, $51b32cf9efbde13e$var$_extends({
            isOpen: this.state.isOpen
        }, $51b32cf9efbde13e$var$omit(this.props, $51b32cf9efbde13e$var$omitKeys$2)));
    }
}
$51b32cf9efbde13e$var$UncontrolledCollapse.propTypes = $51b32cf9efbde13e$var$propTypes$3;
$51b32cf9efbde13e$var$UncontrolledCollapse.defaultProps = $51b32cf9efbde13e$var$defaultProps$3;
var $51b32cf9efbde13e$export$293344e6b80913af = $51b32cf9efbde13e$var$UncontrolledCollapse;
const $51b32cf9efbde13e$var$omitKeys$1 = [
    "defaultOpen"
];
class $51b32cf9efbde13e$export$b92340dd2916436 extends (0, $tZqWC.Component) {
    constructor(props){
        super(props);
        this.state = {
            isOpen: props.defaultOpen || false
        };
        this.toggle = this.toggle.bind(this);
    }
    toggle(e) {
        const isOpen = !this.state.isOpen;
        this.setState({
            isOpen: isOpen
        }, ()=>{
            if (this.props.onToggle) this.props.onToggle(e, isOpen);
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$931cbfb6bfb85fc, $51b32cf9efbde13e$var$_extends({
            isOpen: this.state.isOpen,
            toggle: this.toggle
        }, $51b32cf9efbde13e$var$omit(this.props, $51b32cf9efbde13e$var$omitKeys$1)));
    }
}
$51b32cf9efbde13e$export$b92340dd2916436.propTypes = $51b32cf9efbde13e$var$_objectSpread2({
    defaultOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
}, $51b32cf9efbde13e$export$931cbfb6bfb85fc.propTypes);
const $51b32cf9efbde13e$var$omitKeys = [
    "defaultOpen"
];
class $51b32cf9efbde13e$export$4006422790a754b1 extends (0, $tZqWC.Component) {
    constructor(props){
        super(props);
        this.state = {
            isOpen: props.defaultOpen || false
        };
        this.toggle = this.toggle.bind(this);
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$28c660c63b792dea, $51b32cf9efbde13e$var$_extends({
            isOpen: this.state.isOpen,
            toggle: this.toggle
        }, $51b32cf9efbde13e$var$omit(this.props, $51b32cf9efbde13e$var$omitKeys)));
    }
}
$51b32cf9efbde13e$export$4006422790a754b1.propTypes = $51b32cf9efbde13e$var$_objectSpread2({
    defaultOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
}, $51b32cf9efbde13e$export$28c660c63b792dea.propTypes);
const $51b32cf9efbde13e$var$_excluded$2 = [
    "className",
    "cssModule",
    "type",
    "size",
    "color",
    "children",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes$2 = {
    tag: $51b32cf9efbde13e$var$tagPropType,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
const $51b32cf9efbde13e$var$defaultProps$2 = {
    tag: "div",
    type: "border",
    children: "Loading..."
};
const $51b32cf9efbde13e$var$Spinner = (props)=>{
    const { className: className, cssModule: cssModule, type: type, size: size, color: color, children: children, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$2);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, size ? `spinner-${type}-${size}` : false, `spinner-${type}`, color ? `text-${color}` : false), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({
        role: "status"
    }, attributes, {
        className: classes
    }), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("span", {
        className: $51b32cf9efbde13e$var$mapToCssModules("visually-hidden", cssModule)
    }, children));
};
$51b32cf9efbde13e$var$Spinner.propTypes = $51b32cf9efbde13e$var$propTypes$2;
$51b32cf9efbde13e$var$Spinner.defaultProps = $51b32cf9efbde13e$var$defaultProps$2;
var $51b32cf9efbde13e$export$7f7cbe89f1eacd2 = $51b32cf9efbde13e$var$Spinner;
const $51b32cf9efbde13e$var$_excluded$1 = [
    "className",
    "cssModule",
    "color",
    "innerRef",
    "tag",
    "animation",
    "size",
    "widths"
];
const $51b32cf9efbde13e$var$propTypes$1 = $51b32cf9efbde13e$var$_objectSpread2($51b32cf9efbde13e$var$_objectSpread2({}, $51b32cf9efbde13e$export$963a4b2511a4b70c.propTypes), {}, {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    tag: $51b32cf9efbde13e$var$tagPropType,
    animation: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOf([
        "glow",
        "wave"
    ]),
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOf([
        "lg",
        "sm",
        "xs"
    ])
});
const $51b32cf9efbde13e$var$defaultProps$1 = {
    tag: "span"
};
const $51b32cf9efbde13e$var$Placeholder = (props)=>{
    let { className: className, cssModule: cssModule, color: color, innerRef: innerRef, tag: Tag, animation: animation, size: size, widths: widths } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded$1);
    let { attributes: modifiedAttributes, colClasses: colClasses } = $51b32cf9efbde13e$var$getColumnClasses(attributes, cssModule, widths);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))(className, colClasses, "placeholder" + (animation ? "-" + animation : ""), size ? "placeholder-" + size : false, color ? "bg-" + color : false), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Tag, $51b32cf9efbde13e$var$_extends({}, modifiedAttributes, {
        className: classes,
        ref: innerRef
    }));
};
$51b32cf9efbde13e$var$Placeholder.propTypes = $51b32cf9efbde13e$var$propTypes$1;
$51b32cf9efbde13e$var$Placeholder.defaultProps = $51b32cf9efbde13e$var$defaultProps$1;
var $51b32cf9efbde13e$export$84712d0562a614b8 = $51b32cf9efbde13e$var$Placeholder;
const $51b32cf9efbde13e$var$_excluded = [
    "cssModule",
    "className",
    "tag"
];
const $51b32cf9efbde13e$var$propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    outline: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    tag: $51b32cf9efbde13e$var$tagPropType
};
const $51b32cf9efbde13e$var$defaultProps = {
    color: "primary",
    tag: $51b32cf9efbde13e$export$353f5b6fc5456de1
};
const $51b32cf9efbde13e$var$PlaceholderButton = (props)=>{
    let { cssModule: cssModule, className: className, tag: Tag } = props, attributes = $51b32cf9efbde13e$var$_objectWithoutProperties(props, $51b32cf9efbde13e$var$_excluded);
    let { attributes: modifiedAttributes, colClasses: colClasses } = $51b32cf9efbde13e$var$getColumnClasses(attributes, cssModule);
    const classes = $51b32cf9efbde13e$var$mapToCssModules((0, (/*@__PURE__*/$parcel$interopDefault($9A5xi)))("placeholder", className, colClasses), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($51b32cf9efbde13e$export$353f5b6fc5456de1, $51b32cf9efbde13e$var$_extends({}, modifiedAttributes, {
        className: classes,
        disabled: true
    }));
};
$51b32cf9efbde13e$var$PlaceholderButton.propTypes = $51b32cf9efbde13e$var$propTypes;
$51b32cf9efbde13e$var$PlaceholderButton.defaultProps = $51b32cf9efbde13e$var$defaultProps;
var $51b32cf9efbde13e$export$1a60973f666c230b = $51b32cf9efbde13e$var$PlaceholderButton;
(()=>{
    if (typeof window !== "object" || typeof window.CustomEvent === "function") return;
    const CustomEvent1 = (event, params)=>{
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: null
        };
        var evt = document.createEvent("CustomEvent");
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    };
    window.CustomEvent = CustomEvent1;
})();
(()=>{
    if (typeof Object.values === "function") return;
    const values = (O)=>Object.keys(O).map((key)=>O[key]);
    Object.values = values;
})();
var $51b32cf9efbde13e$export$a303ca4010227d04 = {
    __proto__: null
};


const $1a4cbf548dcd1ce8$export$d07751f4f3400269 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $51b32cf9efbde13e$export$6ebb62b9195ea916))``;


function $78a1fd22133eec24$var$TabPane(props) {
    // Destructure
    const { id: id, children: children } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1a4cbf548dcd1ce8$export$d07751f4f3400269), {
        tabId: id,
        children: children
    });
}
// Default Props
$78a1fd22133eec24$var$TabPane.defaultProps = {
    id: "1",
    children: ""
};
// Proptypes Validation
$78a1fd22133eec24$var$TabPane.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $78a1fd22133eec24$export$2e2bcd8739ae039 = $78a1fd22133eec24$var$TabPane;


var $205d1e28d2d78ef4$export$2e2bcd8739ae039 = (0, $78a1fd22133eec24$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $krg3S = parcelRequire("krg3S");
function $46830b05731d72d3$var$Form(props) {
    // Destructure
    const { children: children, initialValues: initialValues, onSubmit: onSubmit, validationSchema: validationSchema, formRef: formRef, autoComplete: autoComplete, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $krg3S.Formik), {
        autoComplete: "off",
        initialValues: initialValues,
        onSubmit: onSubmit,
        validationSchema: validationSchema,
        innerRef: formRef,
        ...rest,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $krg3S.Form), {
            autoComplete: "off",
            children: children
        })
    });
}
// Default Props
$46830b05731d72d3$var$Form.defaultProps = {
    children: "",
    initialValues: {},
    onSubmit: ()=>{},
    validationSchema: {},
    formRef: /*#__PURE__*/ (0, $tZqWC.createRef)(),
    autoComplete: "on"
};
// Proptypes Validation
$46830b05731d72d3$var$Form.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    initialValues: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    validationSchema: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $46830b05731d72d3$export$2e2bcd8739ae039 = $46830b05731d72d3$var$Form;


var $506ef65bbb4994b7$export$2e2bcd8739ae039 = (0, $46830b05731d72d3$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");
var $638c0eb86fd107b8$exports = {};
var $c1a715e3879d5de0$exports = {};
var $7f670113ed8e5f5d$exports = {};
var $58fab9ded43a18f7$exports = {};

var $lewJ9 = parcelRequire("lewJ9");
var $58fab9ded43a18f7$require$Buffer = $lewJ9.Buffer;

var $h8F4l = parcelRequire("h8F4l");
var $72f7ce4ad4f74805$exports = {};

var $kuzpm = parcelRequire("kuzpm");
/*
 * [js-sha512]{@link https://github.com/emn178/js-sha512}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA512_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA512_NO_NODE_JS && typeof $kuzpm === "object" && $kuzpm.versions && $kuzpm.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA512_NO_COMMON_JS && true && $72f7ce4ad4f74805$exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA512_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var EXTRA = [
        -2147483648,
        8388608,
        32768,
        128
    ];
    var SHIFT = [
        24,
        16,
        8,
        0
    ];
    var K = [
        0x428A2F98,
        0xD728AE22,
        0x71374491,
        0x23EF65CD,
        0xB5C0FBCF,
        0xEC4D3B2F,
        0xE9B5DBA5,
        0x8189DBBC,
        0x3956C25B,
        0xF348B538,
        0x59F111F1,
        0xB605D019,
        0x923F82A4,
        0xAF194F9B,
        0xAB1C5ED5,
        0xDA6D8118,
        0xD807AA98,
        0xA3030242,
        0x12835B01,
        0x45706FBE,
        0x243185BE,
        0x4EE4B28C,
        0x550C7DC3,
        0xD5FFB4E2,
        0x72BE5D74,
        0xF27B896F,
        0x80DEB1FE,
        0x3B1696B1,
        0x9BDC06A7,
        0x25C71235,
        0xC19BF174,
        0xCF692694,
        0xE49B69C1,
        0x9EF14AD2,
        0xEFBE4786,
        0x384F25E3,
        0x0FC19DC6,
        0x8B8CD5B5,
        0x240CA1CC,
        0x77AC9C65,
        0x2DE92C6F,
        0x592B0275,
        0x4A7484AA,
        0x6EA6E483,
        0x5CB0A9DC,
        0xBD41FBD4,
        0x76F988DA,
        0x831153B5,
        0x983E5152,
        0xEE66DFAB,
        0xA831C66D,
        0x2DB43210,
        0xB00327C8,
        0x98FB213F,
        0xBF597FC7,
        0xBEEF0EE4,
        0xC6E00BF3,
        0x3DA88FC2,
        0xD5A79147,
        0x930AA725,
        0x06CA6351,
        0xE003826F,
        0x14292967,
        0x0A0E6E70,
        0x27B70A85,
        0x46D22FFC,
        0x2E1B2138,
        0x5C26C926,
        0x4D2C6DFC,
        0x5AC42AED,
        0x53380D13,
        0x9D95B3DF,
        0x650A7354,
        0x8BAF63DE,
        0x766A0ABB,
        0x3C77B2A8,
        0x81C2C92E,
        0x47EDAEE6,
        0x92722C85,
        0x1482353B,
        0xA2BFE8A1,
        0x4CF10364,
        0xA81A664B,
        0xBC423001,
        0xC24B8B70,
        0xD0F89791,
        0xC76C51A3,
        0x0654BE30,
        0xD192E819,
        0xD6EF5218,
        0xD6990624,
        0x5565A910,
        0xF40E3585,
        0x5771202A,
        0x106AA070,
        0x32BBD1B8,
        0x19A4C116,
        0xB8D2D0C8,
        0x1E376C08,
        0x5141AB53,
        0x2748774C,
        0xDF8EEB99,
        0x34B0BCB5,
        0xE19B48A8,
        0x391C0CB3,
        0xC5C95A63,
        0x4ED8AA4A,
        0xE3418ACB,
        0x5B9CCA4F,
        0x7763E373,
        0x682E6FF3,
        0xD6B2B8A3,
        0x748F82EE,
        0x5DEFB2FC,
        0x78A5636F,
        0x43172F60,
        0x84C87814,
        0xA1F0AB72,
        0x8CC70208,
        0x1A6439EC,
        0x90BEFFFA,
        0x23631E28,
        0xA4506CEB,
        0xDE82BDE9,
        0xBEF9A3F7,
        0xB2C67915,
        0xC67178F2,
        0xE372532B,
        0xCA273ECE,
        0xEA26619C,
        0xD186B8C7,
        0x21C0C207,
        0xEADA7DD6,
        0xCDE0EB1E,
        0xF57D4F7F,
        0xEE6ED178,
        0x06F067AA,
        0x72176FBA,
        0x0A637DC5,
        0xA2C898A6,
        0x113F9804,
        0xBEF90DAE,
        0x1B710B35,
        0x131C471B,
        0x28DB77F5,
        0x23047D84,
        0x32CAAB7B,
        0x40C72493,
        0x3C9EBE0A,
        0x15C9BEBC,
        0x431D67C4,
        0x9C100D4C,
        0x4CC5D4BE,
        0xCB3E42B6,
        0x597F299C,
        0xFC657E2A,
        0x5FCB6FAB,
        0x3AD6FAEC,
        0x6C44198C,
        0x4A475817
    ];
    var OUTPUT_TYPES = [
        "hex",
        "array",
        "digest",
        "arrayBuffer"
    ];
    var blocks = [];
    if (root.JS_SHA512_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA512_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(outputType, bits) {
        return function(message) {
            return new Sha512(bits, true).update(message)[outputType]();
        };
    };
    var createMethod = function(bits) {
        var method = createOutputMethod("hex", bits);
        method.create = function() {
            return new Sha512(bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type, bits);
        }
        return method;
    };
    var createHmacOutputMethod = function(outputType, bits) {
        return function(key, message) {
            return new HmacSha512(key, bits, true).update(message)[outputType]();
        };
    };
    var createHmacMethod = function(bits) {
        var method = createHmacOutputMethod("hex", bits);
        method.create = function(key) {
            return new HmacSha512(key, bits);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type, bits);
        }
        return method;
    };
    function Sha512(bits, sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = blocks[16] = blocks[17] = blocks[18] = blocks[19] = blocks[20] = blocks[21] = blocks[22] = blocks[23] = blocks[24] = blocks[25] = blocks[26] = blocks[27] = blocks[28] = blocks[29] = blocks[30] = blocks[31] = blocks[32] = 0;
            this.blocks = blocks;
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (bits == 384) {
            this.h0h = 0xCBBB9D5D;
            this.h0l = 0xC1059ED8;
            this.h1h = 0x629A292A;
            this.h1l = 0x367CD507;
            this.h2h = 0x9159015A;
            this.h2l = 0x3070DD17;
            this.h3h = 0x152FECD8;
            this.h3l = 0xF70E5939;
            this.h4h = 0x67332667;
            this.h4l = 0xFFC00B31;
            this.h5h = 0x8EB44A87;
            this.h5l = 0x68581511;
            this.h6h = 0xDB0C2E0D;
            this.h6l = 0x64F98FA7;
            this.h7h = 0x47B5481D;
            this.h7l = 0xBEFA4FA4;
        } else if (bits == 256) {
            this.h0h = 0x22312194;
            this.h0l = 0xFC2BF72C;
            this.h1h = 0x9F555FA3;
            this.h1l = 0xC84C64C2;
            this.h2h = 0x2393B86B;
            this.h2l = 0x6F53B151;
            this.h3h = 0x96387719;
            this.h3l = 0x5940EABD;
            this.h4h = 0x96283EE2;
            this.h4l = 0xA88EFFE3;
            this.h5h = 0xBE5E1E25;
            this.h5l = 0x53863992;
            this.h6h = 0x2B0199FC;
            this.h6l = 0x2C85B8AA;
            this.h7h = 0x0EB72DDC;
            this.h7l = 0x81C52CA2;
        } else if (bits == 224) {
            this.h0h = 0x8C3D37C8;
            this.h0l = 0x19544DA2;
            this.h1h = 0x73E19966;
            this.h1l = 0x89DCD4D6;
            this.h2h = 0x1DFAB7AE;
            this.h2l = 0x32FF9C82;
            this.h3h = 0x679DD514;
            this.h3l = 0x582F9FCF;
            this.h4h = 0x0F6D2B69;
            this.h4l = 0x7BD44DA8;
            this.h5h = 0x77E36F73;
            this.h5l = 0x04C48942;
            this.h6h = 0x3F9D85A8;
            this.h6l = 0x6A1D36C8;
            this.h7h = 0x1112E6AD;
            this.h7l = 0x91D692A1;
        } else {
            this.h0h = 0x6A09E667;
            this.h0l = 0xF3BCC908;
            this.h1h = 0xBB67AE85;
            this.h1l = 0x84CAA73B;
            this.h2h = 0x3C6EF372;
            this.h2l = 0xFE94F82B;
            this.h3h = 0xA54FF53A;
            this.h3l = 0x5F1D36F1;
            this.h4h = 0x510E527F;
            this.h4l = 0xADE682D1;
            this.h5h = 0x9B05688C;
            this.h5l = 0x2B3E6C1F;
            this.h6h = 0x1F83D9AB;
            this.h6l = 0xFB41BD6B;
            this.h7h = 0x5BE0CD19;
            this.h7l = 0x137E2179;
        }
        this.bits = bits;
        this.block = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
    }
    Sha512.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = this.block;
                blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = blocks[16] = blocks[17] = blocks[18] = blocks[19] = blocks[20] = blocks[21] = blocks[22] = blocks[23] = blocks[24] = blocks[25] = blocks[26] = blocks[27] = blocks[28] = blocks[29] = blocks[30] = blocks[31] = blocks[32] = 0;
            }
            if (notString) for(i = this.start; index < length && i < 128; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < 128; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 128) {
                this.block = blocks[32];
                this.start = i - 128;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Sha512.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[32] = this.block;
        blocks[i >> 2] |= EXTRA[i & 3];
        this.block = blocks[32];
        if (i >= 112) {
            if (!this.hashed) this.hash();
            blocks[0] = this.block;
            blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = blocks[16] = blocks[17] = blocks[18] = blocks[19] = blocks[20] = blocks[21] = blocks[22] = blocks[23] = blocks[24] = blocks[25] = blocks[26] = blocks[27] = blocks[28] = blocks[29] = blocks[30] = blocks[31] = blocks[32] = 0;
        }
        blocks[30] = this.hBytes << 3 | this.bytes >>> 29;
        blocks[31] = this.bytes << 3;
        this.hash();
    };
    Sha512.prototype.hash = function() {
        var h0h = this.h0h, h0l = this.h0l, h1h = this.h1h, h1l = this.h1l, h2h = this.h2h, h2l = this.h2l, h3h = this.h3h, h3l = this.h3l, h4h = this.h4h, h4l = this.h4l, h5h = this.h5h, h5l = this.h5l, h6h = this.h6h, h6l = this.h6l, h7h = this.h7h, h7l = this.h7l, blocks = this.blocks, j, s0h, s0l, s1h, s1l, c1, c2, c3, c4, abh, abl, dah, dal, cdh, cdl, bch, bcl, majh, majl, t1h, t1l, t2h, t2l, chh, chl;
        for(j = 32; j < 160; j += 2){
            t1h = blocks[j - 30];
            t1l = blocks[j - 29];
            s0h = (t1h >>> 1 | t1l << 31) ^ (t1h >>> 8 | t1l << 24) ^ t1h >>> 7;
            s0l = (t1l >>> 1 | t1h << 31) ^ (t1l >>> 8 | t1h << 24) ^ (t1l >>> 7 | t1h << 25);
            t1h = blocks[j - 4];
            t1l = blocks[j - 3];
            s1h = (t1h >>> 19 | t1l << 13) ^ (t1l >>> 29 | t1h << 3) ^ t1h >>> 6;
            s1l = (t1l >>> 19 | t1h << 13) ^ (t1h >>> 29 | t1l << 3) ^ (t1l >>> 6 | t1h << 26);
            t1h = blocks[j - 32];
            t1l = blocks[j - 31];
            t2h = blocks[j - 14];
            t2l = blocks[j - 13];
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (s0l & 0xFFFF) + (s1l & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (s0l >>> 16) + (s1l >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (s0h & 0xFFFF) + (s1h & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (s0h >>> 16) + (s1h >>> 16) + (c3 >>> 16);
            blocks[j] = c4 << 16 | c3 & 0xFFFF;
            blocks[j + 1] = c2 << 16 | c1 & 0xFFFF;
        }
        var ah = h0h, al = h0l, bh = h1h, bl = h1l, ch = h2h, cl = h2l, dh = h3h, dl = h3l, eh = h4h, el = h4l, fh = h5h, fl = h5l, gh = h6h, gl = h6l, hh = h7h, hl = h7l;
        bch = bh & ch;
        bcl = bl & cl;
        for(j = 0; j < 160; j += 8){
            s0h = (ah >>> 28 | al << 4) ^ (al >>> 2 | ah << 30) ^ (al >>> 7 | ah << 25);
            s0l = (al >>> 28 | ah << 4) ^ (ah >>> 2 | al << 30) ^ (ah >>> 7 | al << 25);
            s1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (el >>> 9 | eh << 23);
            s1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (eh >>> 9 | el << 23);
            abh = ah & bh;
            abl = al & bl;
            majh = abh ^ ah & ch ^ bch;
            majl = abl ^ al & cl ^ bcl;
            chh = eh & fh ^ ~eh & gh;
            chl = el & fl ^ ~el & gl;
            t1h = blocks[j];
            t1l = blocks[j + 1];
            t2h = K[j];
            t2l = K[j + 1];
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (hl & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (hl >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (hh & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (hh >>> 16) + (c3 >>> 16);
            t1h = c4 << 16 | c3 & 0xFFFF;
            t1l = c2 << 16 | c1 & 0xFFFF;
            c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
            c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
            c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
            c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);
            t2h = c4 << 16 | c3 & 0xFFFF;
            t2l = c2 << 16 | c1 & 0xFFFF;
            c1 = (dl & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (dl >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (dh & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (dh >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            hh = c4 << 16 | c3 & 0xFFFF;
            hl = c2 << 16 | c1 & 0xFFFF;
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            dh = c4 << 16 | c3 & 0xFFFF;
            dl = c2 << 16 | c1 & 0xFFFF;
            s0h = (dh >>> 28 | dl << 4) ^ (dl >>> 2 | dh << 30) ^ (dl >>> 7 | dh << 25);
            s0l = (dl >>> 28 | dh << 4) ^ (dh >>> 2 | dl << 30) ^ (dh >>> 7 | dl << 25);
            s1h = (hh >>> 14 | hl << 18) ^ (hh >>> 18 | hl << 14) ^ (hl >>> 9 | hh << 23);
            s1l = (hl >>> 14 | hh << 18) ^ (hl >>> 18 | hh << 14) ^ (hh >>> 9 | hl << 23);
            dah = dh & ah;
            dal = dl & al;
            majh = dah ^ dh & bh ^ abh;
            majl = dal ^ dl & bl ^ abl;
            chh = hh & eh ^ ~hh & fh;
            chl = hl & el ^ ~hl & fl;
            t1h = blocks[j + 2];
            t1l = blocks[j + 3];
            t2h = K[j + 2];
            t2l = K[j + 3];
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (gl & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (gl >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (gh & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (gh >>> 16) + (c3 >>> 16);
            t1h = c4 << 16 | c3 & 0xFFFF;
            t1l = c2 << 16 | c1 & 0xFFFF;
            c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
            c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
            c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
            c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);
            t2h = c4 << 16 | c3 & 0xFFFF;
            t2l = c2 << 16 | c1 & 0xFFFF;
            c1 = (cl & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (cl >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (ch & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (ch >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            gh = c4 << 16 | c3 & 0xFFFF;
            gl = c2 << 16 | c1 & 0xFFFF;
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            ch = c4 << 16 | c3 & 0xFFFF;
            cl = c2 << 16 | c1 & 0xFFFF;
            s0h = (ch >>> 28 | cl << 4) ^ (cl >>> 2 | ch << 30) ^ (cl >>> 7 | ch << 25);
            s0l = (cl >>> 28 | ch << 4) ^ (ch >>> 2 | cl << 30) ^ (ch >>> 7 | cl << 25);
            s1h = (gh >>> 14 | gl << 18) ^ (gh >>> 18 | gl << 14) ^ (gl >>> 9 | gh << 23);
            s1l = (gl >>> 14 | gh << 18) ^ (gl >>> 18 | gh << 14) ^ (gh >>> 9 | gl << 23);
            cdh = ch & dh;
            cdl = cl & dl;
            majh = cdh ^ ch & ah ^ dah;
            majl = cdl ^ cl & al ^ dal;
            chh = gh & hh ^ ~gh & eh;
            chl = gl & hl ^ ~gl & el;
            t1h = blocks[j + 4];
            t1l = blocks[j + 5];
            t2h = K[j + 4];
            t2l = K[j + 5];
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (fl & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (fl >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (fh & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (fh >>> 16) + (c3 >>> 16);
            t1h = c4 << 16 | c3 & 0xFFFF;
            t1l = c2 << 16 | c1 & 0xFFFF;
            c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
            c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
            c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
            c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);
            t2h = c4 << 16 | c3 & 0xFFFF;
            t2l = c2 << 16 | c1 & 0xFFFF;
            c1 = (bl & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (bl >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (bh & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (bh >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            fh = c4 << 16 | c3 & 0xFFFF;
            fl = c2 << 16 | c1 & 0xFFFF;
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            bh = c4 << 16 | c3 & 0xFFFF;
            bl = c2 << 16 | c1 & 0xFFFF;
            s0h = (bh >>> 28 | bl << 4) ^ (bl >>> 2 | bh << 30) ^ (bl >>> 7 | bh << 25);
            s0l = (bl >>> 28 | bh << 4) ^ (bh >>> 2 | bl << 30) ^ (bh >>> 7 | bl << 25);
            s1h = (fh >>> 14 | fl << 18) ^ (fh >>> 18 | fl << 14) ^ (fl >>> 9 | fh << 23);
            s1l = (fl >>> 14 | fh << 18) ^ (fl >>> 18 | fh << 14) ^ (fh >>> 9 | fl << 23);
            bch = bh & ch;
            bcl = bl & cl;
            majh = bch ^ bh & dh ^ cdh;
            majl = bcl ^ bl & dl ^ cdl;
            chh = fh & gh ^ ~fh & hh;
            chl = fl & gl ^ ~fl & hl;
            t1h = blocks[j + 6];
            t1l = blocks[j + 7];
            t2h = K[j + 6];
            t2l = K[j + 7];
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (el & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (el >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (eh & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (eh >>> 16) + (c3 >>> 16);
            t1h = c4 << 16 | c3 & 0xFFFF;
            t1l = c2 << 16 | c1 & 0xFFFF;
            c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
            c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
            c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
            c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);
            t2h = c4 << 16 | c3 & 0xFFFF;
            t2l = c2 << 16 | c1 & 0xFFFF;
            c1 = (al & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (al >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (ah & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (ah >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            eh = c4 << 16 | c3 & 0xFFFF;
            el = c2 << 16 | c1 & 0xFFFF;
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            ah = c4 << 16 | c3 & 0xFFFF;
            al = c2 << 16 | c1 & 0xFFFF;
        }
        c1 = (h0l & 0xFFFF) + (al & 0xFFFF);
        c2 = (h0l >>> 16) + (al >>> 16) + (c1 >>> 16);
        c3 = (h0h & 0xFFFF) + (ah & 0xFFFF) + (c2 >>> 16);
        c4 = (h0h >>> 16) + (ah >>> 16) + (c3 >>> 16);
        this.h0h = c4 << 16 | c3 & 0xFFFF;
        this.h0l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h1l & 0xFFFF) + (bl & 0xFFFF);
        c2 = (h1l >>> 16) + (bl >>> 16) + (c1 >>> 16);
        c3 = (h1h & 0xFFFF) + (bh & 0xFFFF) + (c2 >>> 16);
        c4 = (h1h >>> 16) + (bh >>> 16) + (c3 >>> 16);
        this.h1h = c4 << 16 | c3 & 0xFFFF;
        this.h1l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h2l & 0xFFFF) + (cl & 0xFFFF);
        c2 = (h2l >>> 16) + (cl >>> 16) + (c1 >>> 16);
        c3 = (h2h & 0xFFFF) + (ch & 0xFFFF) + (c2 >>> 16);
        c4 = (h2h >>> 16) + (ch >>> 16) + (c3 >>> 16);
        this.h2h = c4 << 16 | c3 & 0xFFFF;
        this.h2l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h3l & 0xFFFF) + (dl & 0xFFFF);
        c2 = (h3l >>> 16) + (dl >>> 16) + (c1 >>> 16);
        c3 = (h3h & 0xFFFF) + (dh & 0xFFFF) + (c2 >>> 16);
        c4 = (h3h >>> 16) + (dh >>> 16) + (c3 >>> 16);
        this.h3h = c4 << 16 | c3 & 0xFFFF;
        this.h3l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h4l & 0xFFFF) + (el & 0xFFFF);
        c2 = (h4l >>> 16) + (el >>> 16) + (c1 >>> 16);
        c3 = (h4h & 0xFFFF) + (eh & 0xFFFF) + (c2 >>> 16);
        c4 = (h4h >>> 16) + (eh >>> 16) + (c3 >>> 16);
        this.h4h = c4 << 16 | c3 & 0xFFFF;
        this.h4l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h5l & 0xFFFF) + (fl & 0xFFFF);
        c2 = (h5l >>> 16) + (fl >>> 16) + (c1 >>> 16);
        c3 = (h5h & 0xFFFF) + (fh & 0xFFFF) + (c2 >>> 16);
        c4 = (h5h >>> 16) + (fh >>> 16) + (c3 >>> 16);
        this.h5h = c4 << 16 | c3 & 0xFFFF;
        this.h5l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h6l & 0xFFFF) + (gl & 0xFFFF);
        c2 = (h6l >>> 16) + (gl >>> 16) + (c1 >>> 16);
        c3 = (h6h & 0xFFFF) + (gh & 0xFFFF) + (c2 >>> 16);
        c4 = (h6h >>> 16) + (gh >>> 16) + (c3 >>> 16);
        this.h6h = c4 << 16 | c3 & 0xFFFF;
        this.h6l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h7l & 0xFFFF) + (hl & 0xFFFF);
        c2 = (h7l >>> 16) + (hl >>> 16) + (c1 >>> 16);
        c3 = (h7h & 0xFFFF) + (hh & 0xFFFF) + (c2 >>> 16);
        c4 = (h7h >>> 16) + (hh >>> 16) + (c3 >>> 16);
        this.h7h = c4 << 16 | c3 & 0xFFFF;
        this.h7l = c2 << 16 | c1 & 0xFFFF;
    };
    Sha512.prototype.hex = function() {
        this.finalize();
        var h0h = this.h0h, h0l = this.h0l, h1h = this.h1h, h1l = this.h1l, h2h = this.h2h, h2l = this.h2l, h3h = this.h3h, h3l = this.h3l, h4h = this.h4h, h4l = this.h4l, h5h = this.h5h, h5l = this.h5l, h6h = this.h6h, h6l = this.h6l, h7h = this.h7h, h7l = this.h7l, bits = this.bits;
        var hex = HEX_CHARS[h0h >> 28 & 0x0F] + HEX_CHARS[h0h >> 24 & 0x0F] + HEX_CHARS[h0h >> 20 & 0x0F] + HEX_CHARS[h0h >> 16 & 0x0F] + HEX_CHARS[h0h >> 12 & 0x0F] + HEX_CHARS[h0h >> 8 & 0x0F] + HEX_CHARS[h0h >> 4 & 0x0F] + HEX_CHARS[h0h & 0x0F] + HEX_CHARS[h0l >> 28 & 0x0F] + HEX_CHARS[h0l >> 24 & 0x0F] + HEX_CHARS[h0l >> 20 & 0x0F] + HEX_CHARS[h0l >> 16 & 0x0F] + HEX_CHARS[h0l >> 12 & 0x0F] + HEX_CHARS[h0l >> 8 & 0x0F] + HEX_CHARS[h0l >> 4 & 0x0F] + HEX_CHARS[h0l & 0x0F] + HEX_CHARS[h1h >> 28 & 0x0F] + HEX_CHARS[h1h >> 24 & 0x0F] + HEX_CHARS[h1h >> 20 & 0x0F] + HEX_CHARS[h1h >> 16 & 0x0F] + HEX_CHARS[h1h >> 12 & 0x0F] + HEX_CHARS[h1h >> 8 & 0x0F] + HEX_CHARS[h1h >> 4 & 0x0F] + HEX_CHARS[h1h & 0x0F] + HEX_CHARS[h1l >> 28 & 0x0F] + HEX_CHARS[h1l >> 24 & 0x0F] + HEX_CHARS[h1l >> 20 & 0x0F] + HEX_CHARS[h1l >> 16 & 0x0F] + HEX_CHARS[h1l >> 12 & 0x0F] + HEX_CHARS[h1l >> 8 & 0x0F] + HEX_CHARS[h1l >> 4 & 0x0F] + HEX_CHARS[h1l & 0x0F] + HEX_CHARS[h2h >> 28 & 0x0F] + HEX_CHARS[h2h >> 24 & 0x0F] + HEX_CHARS[h2h >> 20 & 0x0F] + HEX_CHARS[h2h >> 16 & 0x0F] + HEX_CHARS[h2h >> 12 & 0x0F] + HEX_CHARS[h2h >> 8 & 0x0F] + HEX_CHARS[h2h >> 4 & 0x0F] + HEX_CHARS[h2h & 0x0F] + HEX_CHARS[h2l >> 28 & 0x0F] + HEX_CHARS[h2l >> 24 & 0x0F] + HEX_CHARS[h2l >> 20 & 0x0F] + HEX_CHARS[h2l >> 16 & 0x0F] + HEX_CHARS[h2l >> 12 & 0x0F] + HEX_CHARS[h2l >> 8 & 0x0F] + HEX_CHARS[h2l >> 4 & 0x0F] + HEX_CHARS[h2l & 0x0F] + HEX_CHARS[h3h >> 28 & 0x0F] + HEX_CHARS[h3h >> 24 & 0x0F] + HEX_CHARS[h3h >> 20 & 0x0F] + HEX_CHARS[h3h >> 16 & 0x0F] + HEX_CHARS[h3h >> 12 & 0x0F] + HEX_CHARS[h3h >> 8 & 0x0F] + HEX_CHARS[h3h >> 4 & 0x0F] + HEX_CHARS[h3h & 0x0F];
        if (bits >= 256) hex += HEX_CHARS[h3l >> 28 & 0x0F] + HEX_CHARS[h3l >> 24 & 0x0F] + HEX_CHARS[h3l >> 20 & 0x0F] + HEX_CHARS[h3l >> 16 & 0x0F] + HEX_CHARS[h3l >> 12 & 0x0F] + HEX_CHARS[h3l >> 8 & 0x0F] + HEX_CHARS[h3l >> 4 & 0x0F] + HEX_CHARS[h3l & 0x0F];
        if (bits >= 384) hex += HEX_CHARS[h4h >> 28 & 0x0F] + HEX_CHARS[h4h >> 24 & 0x0F] + HEX_CHARS[h4h >> 20 & 0x0F] + HEX_CHARS[h4h >> 16 & 0x0F] + HEX_CHARS[h4h >> 12 & 0x0F] + HEX_CHARS[h4h >> 8 & 0x0F] + HEX_CHARS[h4h >> 4 & 0x0F] + HEX_CHARS[h4h & 0x0F] + HEX_CHARS[h4l >> 28 & 0x0F] + HEX_CHARS[h4l >> 24 & 0x0F] + HEX_CHARS[h4l >> 20 & 0x0F] + HEX_CHARS[h4l >> 16 & 0x0F] + HEX_CHARS[h4l >> 12 & 0x0F] + HEX_CHARS[h4l >> 8 & 0x0F] + HEX_CHARS[h4l >> 4 & 0x0F] + HEX_CHARS[h4l & 0x0F] + HEX_CHARS[h5h >> 28 & 0x0F] + HEX_CHARS[h5h >> 24 & 0x0F] + HEX_CHARS[h5h >> 20 & 0x0F] + HEX_CHARS[h5h >> 16 & 0x0F] + HEX_CHARS[h5h >> 12 & 0x0F] + HEX_CHARS[h5h >> 8 & 0x0F] + HEX_CHARS[h5h >> 4 & 0x0F] + HEX_CHARS[h5h & 0x0F] + HEX_CHARS[h5l >> 28 & 0x0F] + HEX_CHARS[h5l >> 24 & 0x0F] + HEX_CHARS[h5l >> 20 & 0x0F] + HEX_CHARS[h5l >> 16 & 0x0F] + HEX_CHARS[h5l >> 12 & 0x0F] + HEX_CHARS[h5l >> 8 & 0x0F] + HEX_CHARS[h5l >> 4 & 0x0F] + HEX_CHARS[h5l & 0x0F];
        if (bits == 512) hex += HEX_CHARS[h6h >> 28 & 0x0F] + HEX_CHARS[h6h >> 24 & 0x0F] + HEX_CHARS[h6h >> 20 & 0x0F] + HEX_CHARS[h6h >> 16 & 0x0F] + HEX_CHARS[h6h >> 12 & 0x0F] + HEX_CHARS[h6h >> 8 & 0x0F] + HEX_CHARS[h6h >> 4 & 0x0F] + HEX_CHARS[h6h & 0x0F] + HEX_CHARS[h6l >> 28 & 0x0F] + HEX_CHARS[h6l >> 24 & 0x0F] + HEX_CHARS[h6l >> 20 & 0x0F] + HEX_CHARS[h6l >> 16 & 0x0F] + HEX_CHARS[h6l >> 12 & 0x0F] + HEX_CHARS[h6l >> 8 & 0x0F] + HEX_CHARS[h6l >> 4 & 0x0F] + HEX_CHARS[h6l & 0x0F] + HEX_CHARS[h7h >> 28 & 0x0F] + HEX_CHARS[h7h >> 24 & 0x0F] + HEX_CHARS[h7h >> 20 & 0x0F] + HEX_CHARS[h7h >> 16 & 0x0F] + HEX_CHARS[h7h >> 12 & 0x0F] + HEX_CHARS[h7h >> 8 & 0x0F] + HEX_CHARS[h7h >> 4 & 0x0F] + HEX_CHARS[h7h & 0x0F] + HEX_CHARS[h7l >> 28 & 0x0F] + HEX_CHARS[h7l >> 24 & 0x0F] + HEX_CHARS[h7l >> 20 & 0x0F] + HEX_CHARS[h7l >> 16 & 0x0F] + HEX_CHARS[h7l >> 12 & 0x0F] + HEX_CHARS[h7l >> 8 & 0x0F] + HEX_CHARS[h7l >> 4 & 0x0F] + HEX_CHARS[h7l & 0x0F];
        return hex;
    };
    Sha512.prototype.toString = Sha512.prototype.hex;
    Sha512.prototype.digest = function() {
        this.finalize();
        var h0h = this.h0h, h0l = this.h0l, h1h = this.h1h, h1l = this.h1l, h2h = this.h2h, h2l = this.h2l, h3h = this.h3h, h3l = this.h3l, h4h = this.h4h, h4l = this.h4l, h5h = this.h5h, h5l = this.h5l, h6h = this.h6h, h6l = this.h6l, h7h = this.h7h, h7l = this.h7l, bits = this.bits;
        var arr = [
            h0h >> 24 & 0xFF,
            h0h >> 16 & 0xFF,
            h0h >> 8 & 0xFF,
            h0h & 0xFF,
            h0l >> 24 & 0xFF,
            h0l >> 16 & 0xFF,
            h0l >> 8 & 0xFF,
            h0l & 0xFF,
            h1h >> 24 & 0xFF,
            h1h >> 16 & 0xFF,
            h1h >> 8 & 0xFF,
            h1h & 0xFF,
            h1l >> 24 & 0xFF,
            h1l >> 16 & 0xFF,
            h1l >> 8 & 0xFF,
            h1l & 0xFF,
            h2h >> 24 & 0xFF,
            h2h >> 16 & 0xFF,
            h2h >> 8 & 0xFF,
            h2h & 0xFF,
            h2l >> 24 & 0xFF,
            h2l >> 16 & 0xFF,
            h2l >> 8 & 0xFF,
            h2l & 0xFF,
            h3h >> 24 & 0xFF,
            h3h >> 16 & 0xFF,
            h3h >> 8 & 0xFF,
            h3h & 0xFF
        ];
        if (bits >= 256) arr.push(h3l >> 24 & 0xFF, h3l >> 16 & 0xFF, h3l >> 8 & 0xFF, h3l & 0xFF);
        if (bits >= 384) arr.push(h4h >> 24 & 0xFF, h4h >> 16 & 0xFF, h4h >> 8 & 0xFF, h4h & 0xFF, h4l >> 24 & 0xFF, h4l >> 16 & 0xFF, h4l >> 8 & 0xFF, h4l & 0xFF, h5h >> 24 & 0xFF, h5h >> 16 & 0xFF, h5h >> 8 & 0xFF, h5h & 0xFF, h5l >> 24 & 0xFF, h5l >> 16 & 0xFF, h5l >> 8 & 0xFF, h5l & 0xFF);
        if (bits == 512) arr.push(h6h >> 24 & 0xFF, h6h >> 16 & 0xFF, h6h >> 8 & 0xFF, h6h & 0xFF, h6l >> 24 & 0xFF, h6l >> 16 & 0xFF, h6l >> 8 & 0xFF, h6l & 0xFF, h7h >> 24 & 0xFF, h7h >> 16 & 0xFF, h7h >> 8 & 0xFF, h7h & 0xFF, h7l >> 24 & 0xFF, h7l >> 16 & 0xFF, h7l >> 8 & 0xFF, h7l & 0xFF);
        return arr;
    };
    Sha512.prototype.array = Sha512.prototype.digest;
    Sha512.prototype.arrayBuffer = function() {
        this.finalize();
        var bits = this.bits;
        var buffer = new ArrayBuffer(bits / 8);
        var dataView = new DataView(buffer);
        dataView.setUint32(0, this.h0h);
        dataView.setUint32(4, this.h0l);
        dataView.setUint32(8, this.h1h);
        dataView.setUint32(12, this.h1l);
        dataView.setUint32(16, this.h2h);
        dataView.setUint32(20, this.h2l);
        dataView.setUint32(24, this.h3h);
        if (bits >= 256) dataView.setUint32(28, this.h3l);
        if (bits >= 384) {
            dataView.setUint32(32, this.h4h);
            dataView.setUint32(36, this.h4l);
            dataView.setUint32(40, this.h5h);
            dataView.setUint32(44, this.h5l);
        }
        if (bits == 512) {
            dataView.setUint32(48, this.h6h);
            dataView.setUint32(52, this.h6l);
            dataView.setUint32(56, this.h7h);
            dataView.setUint32(60, this.h7l);
        }
        return buffer;
    };
    Sha512.prototype.clone = function() {
        var hash = new Sha512(this.bits, false);
        this.copyTo(hash);
        return hash;
    };
    Sha512.prototype.copyTo = function(hash) {
        var i = 0, attrs = [
            "h0h",
            "h0l",
            "h1h",
            "h1l",
            "h2h",
            "h2l",
            "h3h",
            "h3l",
            "h4h",
            "h4l",
            "h5h",
            "h5l",
            "h6h",
            "h6l",
            "h7h",
            "h7l",
            "start",
            "bytes",
            "hBytes",
            "finalized",
            "hashed",
            "lastByteIndex"
        ];
        for(i = 0; i < attrs.length; ++i)hash[attrs[i]] = this[attrs[i]];
        for(i = 0; i < this.blocks.length; ++i)hash.blocks[i] = this.blocks[i];
    };
    function HmacSha512(key, bits, sharedMemory) {
        var notString, type = typeof key;
        if (type !== "string") {
            if (type === "object") {
                if (key === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) key = new Uint8Array(key);
                else if (!Array.isArray(key)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var length = key.length;
        if (!notString) {
            var bytes = [], length = key.length, index = 0, code;
            for(var i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >> 12;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >> 18;
                    bytes[index++] = 0x80 | code >> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        }
        if (key.length > 128) key = new Sha512(bits, true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(var i = 0; i < 128; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Sha512.call(this, bits, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacSha512.prototype = new Sha512();
    HmacSha512.prototype.finalize = function() {
        Sha512.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Sha512.call(this, this.bits, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Sha512.prototype.finalize.call(this);
        }
    };
    HmacSha512.prototype.clone = function() {
        var hash = new HmacSha512([], this.bits, false);
        this.copyTo(hash);
        hash.inner = this.inner;
        for(var i = 0; i < this.oKeyPad.length; ++i)hash.oKeyPad[i] = this.oKeyPad[i];
        return hash;
    };
    var exports = createMethod(512);
    exports.sha512 = exports;
    exports.sha384 = createMethod(384);
    exports.sha512_256 = createMethod(256);
    exports.sha512_224 = createMethod(224);
    exports.sha512.hmac = createHmacMethod(512);
    exports.sha384.hmac = createHmacMethod(384);
    exports.sha512_256.hmac = createHmacMethod(256);
    exports.sha512_224.hmac = createHmacMethod(224);
    if (COMMON_JS) $72f7ce4ad4f74805$exports = exports;
    else {
        root.sha512 = exports.sha512;
        root.sha384 = exports.sha384;
        root.sha512_256 = exports.sha512_256;
        root.sha512_224 = exports.sha512_224;
        if (AMD) define(function() {
            return exports;
        });
    }
})();


var $58fab9ded43a18f7$require$sha512256 = $72f7ce4ad4f74805$exports.sha512_256;
var $c985bd2c80ab4d8e$exports = {};

var $lewJ9 = parcelRequire("lewJ9");
var $c985bd2c80ab4d8e$require$Buffer = $lewJ9.Buffer;
"use strict";
/**
 * Credits to https://github.com/cryptocoinjs/blake-hash
 */ $c985bd2c80ab4d8e$var$Blake256.sigma = [
    [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
    ],
    [
        14,
        10,
        4,
        8,
        9,
        15,
        13,
        6,
        1,
        12,
        0,
        2,
        11,
        7,
        5,
        3
    ],
    [
        11,
        8,
        12,
        0,
        5,
        2,
        15,
        13,
        10,
        14,
        3,
        6,
        7,
        1,
        9,
        4
    ],
    [
        7,
        9,
        3,
        1,
        13,
        12,
        11,
        14,
        2,
        6,
        5,
        10,
        4,
        0,
        15,
        8
    ],
    [
        9,
        0,
        5,
        7,
        2,
        4,
        10,
        15,
        14,
        1,
        11,
        12,
        6,
        8,
        3,
        13
    ],
    [
        2,
        12,
        6,
        10,
        0,
        11,
        8,
        3,
        4,
        13,
        7,
        5,
        15,
        14,
        1,
        9
    ],
    [
        12,
        5,
        1,
        15,
        14,
        13,
        4,
        10,
        0,
        7,
        6,
        3,
        9,
        2,
        8,
        11
    ],
    [
        13,
        11,
        7,
        14,
        12,
        1,
        3,
        9,
        5,
        0,
        15,
        4,
        8,
        6,
        2,
        10
    ],
    [
        6,
        15,
        14,
        9,
        11,
        3,
        0,
        8,
        12,
        2,
        13,
        7,
        1,
        4,
        10,
        5
    ],
    [
        10,
        2,
        8,
        4,
        7,
        6,
        1,
        5,
        15,
        11,
        9,
        14,
        3,
        12,
        13,
        0
    ],
    [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
    ],
    [
        14,
        10,
        4,
        8,
        9,
        15,
        13,
        6,
        1,
        12,
        0,
        2,
        11,
        7,
        5,
        3
    ],
    [
        11,
        8,
        12,
        0,
        5,
        2,
        15,
        13,
        10,
        14,
        3,
        6,
        7,
        1,
        9,
        4
    ],
    [
        7,
        9,
        3,
        1,
        13,
        12,
        11,
        14,
        2,
        6,
        5,
        10,
        4,
        0,
        15,
        8
    ],
    [
        9,
        0,
        5,
        7,
        2,
        4,
        10,
        15,
        14,
        1,
        11,
        12,
        6,
        8,
        3,
        13
    ],
    [
        2,
        12,
        6,
        10,
        0,
        11,
        8,
        3,
        4,
        13,
        7,
        5,
        15,
        14,
        1,
        9
    ]
];
$c985bd2c80ab4d8e$var$Blake256.u256 = [
    0x243f6a88,
    0x85a308d3,
    0x13198a2e,
    0x03707344,
    0xa4093822,
    0x299f31d0,
    0x082efa98,
    0xec4e6c89,
    0x452821e6,
    0x38d01377,
    0xbe5466cf,
    0x34e90c6c,
    0xc0ac29b7,
    0xc97c50dd,
    0x3f84d5b5,
    0xb5470917
];
$c985bd2c80ab4d8e$var$Blake256.padding = $c985bd2c80ab4d8e$require$Buffer.from([
    0x80,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
]);
$c985bd2c80ab4d8e$var$Blake256.prototype._length_carry = function(arr) {
    for(var j = 0; j < arr.length; ++j){
        if (arr[j] < 0x0100000000) break;
        arr[j] -= 0x0100000000;
        arr[j + 1] += 1;
    }
};
$c985bd2c80ab4d8e$var$Blake256.prototype.update = function(data, encoding) {
    data = $c985bd2c80ab4d8e$require$Buffer.from(data, encoding);
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= block.length){
        for(var i = this._blockOffset; i < block.length;)block[i++] = data[offset++];
        this._length[0] += block.length * 8;
        this._length_carry(this._length);
        this._compress();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    return this;
};
var $c985bd2c80ab4d8e$var$zo = $c985bd2c80ab4d8e$require$Buffer.from([
    0x01
]);
var $c985bd2c80ab4d8e$var$oo = $c985bd2c80ab4d8e$require$Buffer.from([
    0x81
]);
function $c985bd2c80ab4d8e$var$rot(x, n) {
    return (x << 32 - n | x >>> n) >>> 0;
}
function $c985bd2c80ab4d8e$var$g(v, m, i, a, b, c, d, e) {
    var sigma = $c985bd2c80ab4d8e$var$Blake256.sigma;
    var u256 = $c985bd2c80ab4d8e$var$Blake256.u256;
    v[a] = v[a] + ((m[sigma[i][e]] ^ u256[sigma[i][e + 1]]) >>> 0) + v[b] >>> 0;
    v[d] = $c985bd2c80ab4d8e$var$rot(v[d] ^ v[a], 16);
    v[c] = v[c] + v[d] >>> 0;
    v[b] = $c985bd2c80ab4d8e$var$rot(v[b] ^ v[c], 12);
    v[a] = v[a] + ((m[sigma[i][e + 1]] ^ u256[sigma[i][e]]) >>> 0) + v[b] >>> 0;
    v[d] = $c985bd2c80ab4d8e$var$rot(v[d] ^ v[a], 8);
    v[c] = v[c] + v[d] >>> 0;
    v[b] = $c985bd2c80ab4d8e$var$rot(v[b] ^ v[c], 7);
}
function $c985bd2c80ab4d8e$var$Blake256() {
    this._h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this._s = [
        0,
        0,
        0,
        0
    ];
    this._block = $c985bd2c80ab4d8e$require$Buffer.allocUnsafe(64);
    this._blockOffset = 0;
    this._length = [
        0,
        0
    ];
    this._nullt = false;
    this._zo = $c985bd2c80ab4d8e$var$zo;
    this._oo = $c985bd2c80ab4d8e$var$oo;
}
$c985bd2c80ab4d8e$var$Blake256.prototype._compress = function() {
    var u256 = $c985bd2c80ab4d8e$var$Blake256.u256;
    var v = new Array(16);
    var m = new Array(16);
    var i;
    for(i = 0; i < 16; ++i)m[i] = this._block.readUInt32BE(i * 4);
    for(i = 0; i < 8; ++i)v[i] = this._h[i] >>> 0;
    for(i = 8; i < 12; ++i)v[i] = (this._s[i - 8] ^ u256[i - 8]) >>> 0;
    for(i = 12; i < 16; ++i)v[i] = u256[i - 8];
    if (!this._nullt) {
        v[12] = (v[12] ^ this._length[0]) >>> 0;
        v[13] = (v[13] ^ this._length[0]) >>> 0;
        v[14] = (v[14] ^ this._length[1]) >>> 0;
        v[15] = (v[15] ^ this._length[1]) >>> 0;
    }
    for(i = 0; i < 14; ++i){
        /* column step */ $c985bd2c80ab4d8e$var$g(v, m, i, 0, 4, 8, 12, 0);
        $c985bd2c80ab4d8e$var$g(v, m, i, 1, 5, 9, 13, 2);
        $c985bd2c80ab4d8e$var$g(v, m, i, 2, 6, 10, 14, 4);
        $c985bd2c80ab4d8e$var$g(v, m, i, 3, 7, 11, 15, 6);
        /* diagonal step */ $c985bd2c80ab4d8e$var$g(v, m, i, 0, 5, 10, 15, 8);
        $c985bd2c80ab4d8e$var$g(v, m, i, 1, 6, 11, 12, 10);
        $c985bd2c80ab4d8e$var$g(v, m, i, 2, 7, 8, 13, 12);
        $c985bd2c80ab4d8e$var$g(v, m, i, 3, 4, 9, 14, 14);
    }
    for(i = 0; i < 16; ++i)this._h[i % 8] = (this._h[i % 8] ^ v[i]) >>> 0;
    for(i = 0; i < 8; ++i)this._h[i] = (this._h[i] ^ this._s[i % 4]) >>> 0;
};
$c985bd2c80ab4d8e$var$Blake256.prototype._padding = function() {
    var lo = this._length[0] + this._blockOffset * 8;
    var hi = this._length[1];
    if (lo >= 0x0100000000) {
        lo -= 0x0100000000;
        hi += 1;
    }
    var msglen = $c985bd2c80ab4d8e$require$Buffer.allocUnsafe(8);
    msglen.writeUInt32BE(hi, 0);
    msglen.writeUInt32BE(lo, 4);
    if (this._blockOffset === 55) {
        this._length[0] -= 8;
        this.update(this._oo);
    } else {
        if (this._blockOffset < 55) {
            if (this._blockOffset === 0) this._nullt = true;
            this._length[0] -= (55 - this._blockOffset) * 8;
            this.update($c985bd2c80ab4d8e$var$Blake256.padding.slice(0, 55 - this._blockOffset));
        } else {
            this._length[0] -= (64 - this._blockOffset) * 8;
            this.update($c985bd2c80ab4d8e$var$Blake256.padding.slice(0, 64 - this._blockOffset));
            this._length[0] -= 440;
            this.update($c985bd2c80ab4d8e$var$Blake256.padding.slice(1, 56));
            this._nullt = true;
        }
        this.update(this._zo);
        this._length[0] -= 8;
    }
    this._length[0] -= 64;
    this.update(msglen);
};
$c985bd2c80ab4d8e$var$Blake256.prototype.digest = function(encoding) {
    this._padding();
    var buffer = $c985bd2c80ab4d8e$require$Buffer.allocUnsafe(32);
    for(var i = 0; i < 8; ++i)buffer.writeUInt32BE(this._h[i], i * 4);
    return buffer.toString(encoding);
};
$c985bd2c80ab4d8e$exports = $c985bd2c80ab4d8e$var$Blake256;


var $48bbb49bf873cc09$exports = {};
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.7.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2017
 * @license MIT
 */ /*jslint bitwise: true */ 
var $kuzpm = parcelRequire("kuzpm");
"use strict";
var $48bbb49bf873cc09$var$ERROR = "input is invalid type";
var $48bbb49bf873cc09$var$WINDOW = typeof window === "object";
var $48bbb49bf873cc09$var$root = $48bbb49bf873cc09$var$WINDOW ? window : {};
if ($48bbb49bf873cc09$var$root.JS_SHA3_NO_WINDOW) $48bbb49bf873cc09$var$WINDOW = false;
var $48bbb49bf873cc09$var$WEB_WORKER = !$48bbb49bf873cc09$var$WINDOW && typeof self === "object";
var $48bbb49bf873cc09$var$NODE_JS = !$48bbb49bf873cc09$var$root.JS_SHA3_NO_NODE_JS && typeof $kuzpm === "object" && $kuzpm.versions && $kuzpm.versions.node;
if ($48bbb49bf873cc09$var$NODE_JS) $48bbb49bf873cc09$var$root = $parcel$global;
else if ($48bbb49bf873cc09$var$WEB_WORKER) $48bbb49bf873cc09$var$root = self;
var $48bbb49bf873cc09$var$ARRAY_BUFFER = !$48bbb49bf873cc09$var$root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
var $48bbb49bf873cc09$var$HEX_CHARS = "0123456789abcdef".split("");
var $48bbb49bf873cc09$var$SHAKE_PADDING = [
    31,
    7936,
    2031616,
    520093696
];
var $48bbb49bf873cc09$var$CSHAKE_PADDING = [
    4,
    1024,
    262144,
    67108864
];
var $48bbb49bf873cc09$var$KECCAK_PADDING = [
    1,
    256,
    65536,
    16777216
];
var $48bbb49bf873cc09$var$PADDING = [
    6,
    1536,
    393216,
    100663296
];
var $48bbb49bf873cc09$var$SHIFT = [
    0,
    8,
    16,
    24
];
var $48bbb49bf873cc09$var$RC = [
    1,
    0,
    32898,
    0,
    32906,
    2147483648,
    2147516416,
    2147483648,
    32907,
    0,
    2147483649,
    0,
    2147516545,
    2147483648,
    32777,
    2147483648,
    138,
    0,
    136,
    0,
    2147516425,
    0,
    2147483658,
    0,
    2147516555,
    0,
    139,
    2147483648,
    32905,
    2147483648,
    32771,
    2147483648,
    32770,
    2147483648,
    128,
    2147483648,
    32778,
    0,
    2147483658,
    2147483648,
    2147516545,
    2147483648,
    32896,
    2147483648,
    2147483649,
    0,
    2147516424,
    2147483648
];
var $48bbb49bf873cc09$var$BITS = [
    224,
    256,
    384,
    512
];
var $48bbb49bf873cc09$var$SHAKE_BITS = [
    128,
    256
];
var $48bbb49bf873cc09$var$OUTPUT_TYPES = [
    "hex",
    "buffer",
    "arrayBuffer",
    "array",
    "digest"
];
var $48bbb49bf873cc09$var$CSHAKE_BYTEPAD = {
    "128": 168,
    "256": 136
};
if ($48bbb49bf873cc09$var$root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
    return Object.prototype.toString.call(obj) === "[object Array]";
};
if ($48bbb49bf873cc09$var$ARRAY_BUFFER && ($48bbb49bf873cc09$var$root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
    return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
};
var $48bbb49bf873cc09$var$createOutputMethod = function(bits, padding, outputType) {
    return function(message) {
        return new $48bbb49bf873cc09$var$Keccak(bits, padding, bits).update(message)[outputType]();
    };
};
var $48bbb49bf873cc09$var$createShakeOutputMethod = function(bits, padding, outputType) {
    return function(message, outputBits) {
        return new $48bbb49bf873cc09$var$Keccak(bits, padding, outputBits).update(message)[outputType]();
    };
};
var $48bbb49bf873cc09$var$createCshakeOutputMethod = function(bits, padding, outputType) {
    return function(message, outputBits, n, s) {
        return $48bbb49bf873cc09$var$methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
    };
};
var $48bbb49bf873cc09$var$createKmacOutputMethod = function(bits, padding, outputType) {
    return function(key, message, outputBits, s) {
        return $48bbb49bf873cc09$var$methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
    };
};
var $48bbb49bf873cc09$var$createOutputMethods = function(method, createMethod, bits, padding) {
    for(var i = 0; i < $48bbb49bf873cc09$var$OUTPUT_TYPES.length; ++i){
        var type = $48bbb49bf873cc09$var$OUTPUT_TYPES[i];
        method[type] = createMethod(bits, padding, type);
    }
    return method;
};
var $48bbb49bf873cc09$var$createMethod = function(bits, padding) {
    var method = $48bbb49bf873cc09$var$createOutputMethod(bits, padding, "hex");
    method.create = function() {
        return new $48bbb49bf873cc09$var$Keccak(bits, padding, bits);
    };
    method.update = function(message) {
        return method.create().update(message);
    };
    return $48bbb49bf873cc09$var$createOutputMethods(method, $48bbb49bf873cc09$var$createOutputMethod, bits, padding);
};
var $48bbb49bf873cc09$var$createShakeMethod = function(bits, padding) {
    var method = $48bbb49bf873cc09$var$createShakeOutputMethod(bits, padding, "hex");
    method.create = function(outputBits) {
        return new $48bbb49bf873cc09$var$Keccak(bits, padding, outputBits);
    };
    method.update = function(message, outputBits) {
        return method.create(outputBits).update(message);
    };
    return $48bbb49bf873cc09$var$createOutputMethods(method, $48bbb49bf873cc09$var$createShakeOutputMethod, bits, padding);
};
var $48bbb49bf873cc09$var$createCshakeMethod = function(bits, padding) {
    var w = $48bbb49bf873cc09$var$CSHAKE_BYTEPAD[bits];
    var method = $48bbb49bf873cc09$var$createCshakeOutputMethod(bits, padding, "hex");
    method.create = function(outputBits, n, s) {
        if (!n && !s) return $48bbb49bf873cc09$var$methods["shake" + bits].create(outputBits);
        else return new $48bbb49bf873cc09$var$Keccak(bits, padding, outputBits).bytepad([
            n,
            s
        ], w);
    };
    method.update = function(message, outputBits, n, s) {
        return method.create(outputBits, n, s).update(message);
    };
    return $48bbb49bf873cc09$var$createOutputMethods(method, $48bbb49bf873cc09$var$createCshakeOutputMethod, bits, padding);
};
var $48bbb49bf873cc09$var$createKmacMethod = function(bits, padding) {
    var w = $48bbb49bf873cc09$var$CSHAKE_BYTEPAD[bits];
    var method = $48bbb49bf873cc09$var$createKmacOutputMethod(bits, padding, "hex");
    method.create = function(key, outputBits, s) {
        return new $48bbb49bf873cc09$var$Kmac(bits, padding, outputBits).bytepad([
            "KMAC",
            s
        ], w).bytepad([
            key
        ], w);
    };
    method.update = function(key, message, outputBits, s) {
        return method.create(key, outputBits, s).update(message);
    };
    return $48bbb49bf873cc09$var$createOutputMethods(method, $48bbb49bf873cc09$var$createKmacOutputMethod, bits, padding);
};
var $48bbb49bf873cc09$var$algorithms = [
    {
        name: "keccak",
        padding: $48bbb49bf873cc09$var$KECCAK_PADDING,
        bits: $48bbb49bf873cc09$var$BITS,
        createMethod: $48bbb49bf873cc09$var$createMethod
    },
    {
        name: "sha3",
        padding: $48bbb49bf873cc09$var$PADDING,
        bits: $48bbb49bf873cc09$var$BITS,
        createMethod: $48bbb49bf873cc09$var$createMethod
    },
    {
        name: "shake",
        padding: $48bbb49bf873cc09$var$SHAKE_PADDING,
        bits: $48bbb49bf873cc09$var$SHAKE_BITS,
        createMethod: $48bbb49bf873cc09$var$createShakeMethod
    },
    {
        name: "cshake",
        padding: $48bbb49bf873cc09$var$CSHAKE_PADDING,
        bits: $48bbb49bf873cc09$var$SHAKE_BITS,
        createMethod: $48bbb49bf873cc09$var$createCshakeMethod
    },
    {
        name: "kmac",
        padding: $48bbb49bf873cc09$var$CSHAKE_PADDING,
        bits: $48bbb49bf873cc09$var$SHAKE_BITS,
        createMethod: $48bbb49bf873cc09$var$createKmacMethod
    }
];
var $48bbb49bf873cc09$var$methods = {}, $48bbb49bf873cc09$var$methodNames = [];
for(var $48bbb49bf873cc09$var$i = 0; $48bbb49bf873cc09$var$i < $48bbb49bf873cc09$var$algorithms.length; ++$48bbb49bf873cc09$var$i){
    var $48bbb49bf873cc09$var$algorithm = $48bbb49bf873cc09$var$algorithms[$48bbb49bf873cc09$var$i];
    var $48bbb49bf873cc09$var$bits = $48bbb49bf873cc09$var$algorithm.bits;
    for(var $48bbb49bf873cc09$var$j = 0; $48bbb49bf873cc09$var$j < $48bbb49bf873cc09$var$bits.length; ++$48bbb49bf873cc09$var$j){
        var $48bbb49bf873cc09$var$methodName = $48bbb49bf873cc09$var$algorithm.name + "_" + $48bbb49bf873cc09$var$bits[$48bbb49bf873cc09$var$j];
        $48bbb49bf873cc09$var$methodNames.push($48bbb49bf873cc09$var$methodName);
        $48bbb49bf873cc09$var$methods[$48bbb49bf873cc09$var$methodName] = $48bbb49bf873cc09$var$algorithm.createMethod($48bbb49bf873cc09$var$bits[$48bbb49bf873cc09$var$j], $48bbb49bf873cc09$var$algorithm.padding);
        if ($48bbb49bf873cc09$var$algorithm.name !== "sha3") {
            var $48bbb49bf873cc09$var$newMethodName = $48bbb49bf873cc09$var$algorithm.name + $48bbb49bf873cc09$var$bits[$48bbb49bf873cc09$var$j];
            $48bbb49bf873cc09$var$methodNames.push($48bbb49bf873cc09$var$newMethodName);
            $48bbb49bf873cc09$var$methods[$48bbb49bf873cc09$var$newMethodName] = $48bbb49bf873cc09$var$methods[$48bbb49bf873cc09$var$methodName];
        }
    }
}
function $48bbb49bf873cc09$var$Keccak(bits, padding, outputBits) {
    this.blocks = [];
    this.s = [];
    this.padding = padding;
    this.outputBits = outputBits;
    this.reset = true;
    this.finalized = false;
    this.block = 0;
    this.start = 0;
    this.blockCount = 1600 - (bits << 1) >> 5;
    this.byteCount = this.blockCount << 2;
    this.outputBlocks = outputBits >> 5;
    this.extraBytes = (outputBits & 31) >> 3;
    for(var i = 0; i < 50; ++i)this.s[i] = 0;
}
$48bbb49bf873cc09$var$Keccak.prototype.update = function(message) {
    if (this.finalized) return;
    var notString, type = typeof message;
    if (type !== "string") {
        if (type === "object") {
            if (message === null) throw $48bbb49bf873cc09$var$ERROR;
            else if ($48bbb49bf873cc09$var$ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
            else if (!Array.isArray(message)) {
                if (!$48bbb49bf873cc09$var$ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw $48bbb49bf873cc09$var$ERROR;
            }
        } else throw $48bbb49bf873cc09$var$ERROR;
        notString = true;
    }
    var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
    while(index < length){
        if (this.reset) {
            this.reset = false;
            blocks[0] = this.block;
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << $48bbb49bf873cc09$var$SHIFT[i++ & 3];
        else for(i = this.start; index < length && i < byteCount; ++index){
            code = message.charCodeAt(index);
            if (code < 0x80) blocks[i >> 2] |= code << $48bbb49bf873cc09$var$SHIFT[i++ & 3];
            else if (code < 0x800) {
                blocks[i >> 2] |= (0xc0 | code >> 6) << $48bbb49bf873cc09$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code & 0x3f) << $48bbb49bf873cc09$var$SHIFT[i++ & 3];
            } else if (code < 0xd800 || code >= 0xe000) {
                blocks[i >> 2] |= (0xe0 | code >> 12) << $48bbb49bf873cc09$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << $48bbb49bf873cc09$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code & 0x3f) << $48bbb49bf873cc09$var$SHIFT[i++ & 3];
            } else {
                code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                blocks[i >> 2] |= (0xf0 | code >> 18) << $48bbb49bf873cc09$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << $48bbb49bf873cc09$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << $48bbb49bf873cc09$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code & 0x3f) << $48bbb49bf873cc09$var$SHIFT[i++ & 3];
            }
        }
        this.lastByteIndex = i;
        if (i >= byteCount) {
            this.start = i - byteCount;
            this.block = blocks[blockCount];
            for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
            $48bbb49bf873cc09$var$f(s);
            this.reset = true;
        } else this.start = i;
    }
    return this;
};
$48bbb49bf873cc09$var$Keccak.prototype.encode = function(x, right) {
    var o = x & 255, n = 1;
    var bytes = [
        o
    ];
    x = x >> 8;
    o = x & 255;
    while(o > 0){
        bytes.unshift(o);
        x = x >> 8;
        o = x & 255;
        ++n;
    }
    if (right) bytes.push(n);
    else bytes.unshift(n);
    this.update(bytes);
    return bytes.length;
};
$48bbb49bf873cc09$var$Keccak.prototype.encodeString = function(str) {
    var notString, type = typeof str;
    if (type !== "string") {
        if (type === "object") {
            if (str === null) throw $48bbb49bf873cc09$var$ERROR;
            else if ($48bbb49bf873cc09$var$ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
            else if (!Array.isArray(str)) {
                if (!$48bbb49bf873cc09$var$ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw $48bbb49bf873cc09$var$ERROR;
            }
        } else throw $48bbb49bf873cc09$var$ERROR;
        notString = true;
    }
    var bytes = 0, length = str.length;
    if (notString) bytes = length;
    else for(var i = 0; i < str.length; ++i){
        var code = str.charCodeAt(i);
        if (code < 0x80) bytes += 1;
        else if (code < 0x800) bytes += 2;
        else if (code < 0xd800 || code >= 0xe000) bytes += 3;
        else {
            code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
            bytes += 4;
        }
    }
    bytes += this.encode(bytes * 8);
    this.update(str);
    return bytes;
};
$48bbb49bf873cc09$var$Keccak.prototype.bytepad = function(strs, w) {
    var bytes = this.encode(w);
    for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
    var paddingBytes = w - bytes % w;
    var zeros = [];
    zeros.length = paddingBytes;
    this.update(zeros);
    return this;
};
$48bbb49bf873cc09$var$Keccak.prototype.finalize = function() {
    if (this.finalized) return;
    this.finalized = true;
    var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
    blocks[i >> 2] |= this.padding[i & 3];
    if (this.lastByteIndex === this.byteCount) {
        blocks[0] = blocks[blockCount];
        for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
    }
    blocks[blockCount - 1] |= 0x80000000;
    for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
    $48bbb49bf873cc09$var$f(s);
};
$48bbb49bf873cc09$var$Keccak.prototype.toString = $48bbb49bf873cc09$var$Keccak.prototype.hex = function() {
    this.finalize();
    var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
    var hex = "", block;
    while(j < outputBlocks){
        for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
            block = s[i];
            hex += $48bbb49bf873cc09$var$HEX_CHARS[block >> 4 & 0x0F] + $48bbb49bf873cc09$var$HEX_CHARS[block & 0x0F] + $48bbb49bf873cc09$var$HEX_CHARS[block >> 12 & 0x0F] + $48bbb49bf873cc09$var$HEX_CHARS[block >> 8 & 0x0F] + $48bbb49bf873cc09$var$HEX_CHARS[block >> 20 & 0x0F] + $48bbb49bf873cc09$var$HEX_CHARS[block >> 16 & 0x0F] + $48bbb49bf873cc09$var$HEX_CHARS[block >> 28 & 0x0F] + $48bbb49bf873cc09$var$HEX_CHARS[block >> 24 & 0x0F];
        }
        if (j % blockCount === 0) {
            $48bbb49bf873cc09$var$f(s);
            i = 0;
        }
    }
    if (extraBytes) {
        block = s[i];
        hex += $48bbb49bf873cc09$var$HEX_CHARS[block >> 4 & 0x0F] + $48bbb49bf873cc09$var$HEX_CHARS[block & 0x0F];
        if (extraBytes > 1) hex += $48bbb49bf873cc09$var$HEX_CHARS[block >> 12 & 0x0F] + $48bbb49bf873cc09$var$HEX_CHARS[block >> 8 & 0x0F];
        if (extraBytes > 2) hex += $48bbb49bf873cc09$var$HEX_CHARS[block >> 20 & 0x0F] + $48bbb49bf873cc09$var$HEX_CHARS[block >> 16 & 0x0F];
    }
    return hex;
};
$48bbb49bf873cc09$var$Keccak.prototype.arrayBuffer = function() {
    this.finalize();
    var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
    var bytes = this.outputBits >> 3;
    var buffer;
    if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
    else buffer = new ArrayBuffer(bytes);
    var array = new Uint32Array(buffer);
    while(j < outputBlocks){
        for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
        if (j % blockCount === 0) $48bbb49bf873cc09$var$f(s);
    }
    if (extraBytes) {
        array[i] = s[i];
        buffer = buffer.slice(0, bytes);
    }
    return buffer;
};
$48bbb49bf873cc09$var$Keccak.prototype.buffer = $48bbb49bf873cc09$var$Keccak.prototype.arrayBuffer;
$48bbb49bf873cc09$var$Keccak.prototype.digest = $48bbb49bf873cc09$var$Keccak.prototype.array = function() {
    this.finalize();
    var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
    var array = [], offset, block;
    while(j < outputBlocks){
        for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            array[offset + 1] = block >> 8 & 0xFF;
            array[offset + 2] = block >> 16 & 0xFF;
            array[offset + 3] = block >> 24 & 0xFF;
        }
        if (j % blockCount === 0) $48bbb49bf873cc09$var$f(s);
    }
    if (extraBytes) {
        offset = j << 2;
        block = s[i];
        array[offset] = block & 0xFF;
        if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
        if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
    }
    return array;
};
function $48bbb49bf873cc09$var$Kmac(bits, padding, outputBits) {
    $48bbb49bf873cc09$var$Keccak.call(this, bits, padding, outputBits);
}
$48bbb49bf873cc09$var$Kmac.prototype = new $48bbb49bf873cc09$var$Keccak();
$48bbb49bf873cc09$var$Kmac.prototype.finalize = function() {
    this.encode(this.outputBits, true);
    return $48bbb49bf873cc09$var$Keccak.prototype.finalize.call(this);
};
var $48bbb49bf873cc09$var$f = function(s) {
    var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
    for(n = 0; n < 48; n += 2){
        c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
        c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
        c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
        c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
        c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
        c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
        c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
        c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
        c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
        c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
        h = c8 ^ (c2 << 1 | c3 >>> 31);
        l = c9 ^ (c3 << 1 | c2 >>> 31);
        s[0] ^= h;
        s[1] ^= l;
        s[10] ^= h;
        s[11] ^= l;
        s[20] ^= h;
        s[21] ^= l;
        s[30] ^= h;
        s[31] ^= l;
        s[40] ^= h;
        s[41] ^= l;
        h = c0 ^ (c4 << 1 | c5 >>> 31);
        l = c1 ^ (c5 << 1 | c4 >>> 31);
        s[2] ^= h;
        s[3] ^= l;
        s[12] ^= h;
        s[13] ^= l;
        s[22] ^= h;
        s[23] ^= l;
        s[32] ^= h;
        s[33] ^= l;
        s[42] ^= h;
        s[43] ^= l;
        h = c2 ^ (c6 << 1 | c7 >>> 31);
        l = c3 ^ (c7 << 1 | c6 >>> 31);
        s[4] ^= h;
        s[5] ^= l;
        s[14] ^= h;
        s[15] ^= l;
        s[24] ^= h;
        s[25] ^= l;
        s[34] ^= h;
        s[35] ^= l;
        s[44] ^= h;
        s[45] ^= l;
        h = c4 ^ (c8 << 1 | c9 >>> 31);
        l = c5 ^ (c9 << 1 | c8 >>> 31);
        s[6] ^= h;
        s[7] ^= l;
        s[16] ^= h;
        s[17] ^= l;
        s[26] ^= h;
        s[27] ^= l;
        s[36] ^= h;
        s[37] ^= l;
        s[46] ^= h;
        s[47] ^= l;
        h = c6 ^ (c0 << 1 | c1 >>> 31);
        l = c7 ^ (c1 << 1 | c0 >>> 31);
        s[8] ^= h;
        s[9] ^= l;
        s[18] ^= h;
        s[19] ^= l;
        s[28] ^= h;
        s[29] ^= l;
        s[38] ^= h;
        s[39] ^= l;
        s[48] ^= h;
        s[49] ^= l;
        b0 = s[0];
        b1 = s[1];
        b32 = s[11] << 4 | s[10] >>> 28;
        b33 = s[10] << 4 | s[11] >>> 28;
        b14 = s[20] << 3 | s[21] >>> 29;
        b15 = s[21] << 3 | s[20] >>> 29;
        b46 = s[31] << 9 | s[30] >>> 23;
        b47 = s[30] << 9 | s[31] >>> 23;
        b28 = s[40] << 18 | s[41] >>> 14;
        b29 = s[41] << 18 | s[40] >>> 14;
        b20 = s[2] << 1 | s[3] >>> 31;
        b21 = s[3] << 1 | s[2] >>> 31;
        b2 = s[13] << 12 | s[12] >>> 20;
        b3 = s[12] << 12 | s[13] >>> 20;
        b34 = s[22] << 10 | s[23] >>> 22;
        b35 = s[23] << 10 | s[22] >>> 22;
        b16 = s[33] << 13 | s[32] >>> 19;
        b17 = s[32] << 13 | s[33] >>> 19;
        b48 = s[42] << 2 | s[43] >>> 30;
        b49 = s[43] << 2 | s[42] >>> 30;
        b40 = s[5] << 30 | s[4] >>> 2;
        b41 = s[4] << 30 | s[5] >>> 2;
        b22 = s[14] << 6 | s[15] >>> 26;
        b23 = s[15] << 6 | s[14] >>> 26;
        b4 = s[25] << 11 | s[24] >>> 21;
        b5 = s[24] << 11 | s[25] >>> 21;
        b36 = s[34] << 15 | s[35] >>> 17;
        b37 = s[35] << 15 | s[34] >>> 17;
        b18 = s[45] << 29 | s[44] >>> 3;
        b19 = s[44] << 29 | s[45] >>> 3;
        b10 = s[6] << 28 | s[7] >>> 4;
        b11 = s[7] << 28 | s[6] >>> 4;
        b42 = s[17] << 23 | s[16] >>> 9;
        b43 = s[16] << 23 | s[17] >>> 9;
        b24 = s[26] << 25 | s[27] >>> 7;
        b25 = s[27] << 25 | s[26] >>> 7;
        b6 = s[36] << 21 | s[37] >>> 11;
        b7 = s[37] << 21 | s[36] >>> 11;
        b38 = s[47] << 24 | s[46] >>> 8;
        b39 = s[46] << 24 | s[47] >>> 8;
        b30 = s[8] << 27 | s[9] >>> 5;
        b31 = s[9] << 27 | s[8] >>> 5;
        b12 = s[18] << 20 | s[19] >>> 12;
        b13 = s[19] << 20 | s[18] >>> 12;
        b44 = s[29] << 7 | s[28] >>> 25;
        b45 = s[28] << 7 | s[29] >>> 25;
        b26 = s[38] << 8 | s[39] >>> 24;
        b27 = s[39] << 8 | s[38] >>> 24;
        b8 = s[48] << 14 | s[49] >>> 18;
        b9 = s[49] << 14 | s[48] >>> 18;
        s[0] = b0 ^ ~b2 & b4;
        s[1] = b1 ^ ~b3 & b5;
        s[10] = b10 ^ ~b12 & b14;
        s[11] = b11 ^ ~b13 & b15;
        s[20] = b20 ^ ~b22 & b24;
        s[21] = b21 ^ ~b23 & b25;
        s[30] = b30 ^ ~b32 & b34;
        s[31] = b31 ^ ~b33 & b35;
        s[40] = b40 ^ ~b42 & b44;
        s[41] = b41 ^ ~b43 & b45;
        s[2] = b2 ^ ~b4 & b6;
        s[3] = b3 ^ ~b5 & b7;
        s[12] = b12 ^ ~b14 & b16;
        s[13] = b13 ^ ~b15 & b17;
        s[22] = b22 ^ ~b24 & b26;
        s[23] = b23 ^ ~b25 & b27;
        s[32] = b32 ^ ~b34 & b36;
        s[33] = b33 ^ ~b35 & b37;
        s[42] = b42 ^ ~b44 & b46;
        s[43] = b43 ^ ~b45 & b47;
        s[4] = b4 ^ ~b6 & b8;
        s[5] = b5 ^ ~b7 & b9;
        s[14] = b14 ^ ~b16 & b18;
        s[15] = b15 ^ ~b17 & b19;
        s[24] = b24 ^ ~b26 & b28;
        s[25] = b25 ^ ~b27 & b29;
        s[34] = b34 ^ ~b36 & b38;
        s[35] = b35 ^ ~b37 & b39;
        s[44] = b44 ^ ~b46 & b48;
        s[45] = b45 ^ ~b47 & b49;
        s[6] = b6 ^ ~b8 & b0;
        s[7] = b7 ^ ~b9 & b1;
        s[16] = b16 ^ ~b18 & b10;
        s[17] = b17 ^ ~b19 & b11;
        s[26] = b26 ^ ~b28 & b20;
        s[27] = b27 ^ ~b29 & b21;
        s[36] = b36 ^ ~b38 & b30;
        s[37] = b37 ^ ~b39 & b31;
        s[46] = b46 ^ ~b48 & b40;
        s[47] = b47 ^ ~b49 & b41;
        s[8] = b8 ^ ~b0 & b2;
        s[9] = b9 ^ ~b1 & b3;
        s[18] = b18 ^ ~b10 & b12;
        s[19] = b19 ^ ~b11 & b13;
        s[28] = b28 ^ ~b20 & b22;
        s[29] = b29 ^ ~b21 & b23;
        s[38] = b38 ^ ~b30 & b32;
        s[39] = b39 ^ ~b31 & b33;
        s[48] = b48 ^ ~b40 & b42;
        s[49] = b49 ^ ~b41 & b43;
        s[0] ^= $48bbb49bf873cc09$var$RC[n];
        s[1] ^= $48bbb49bf873cc09$var$RC[n + 1];
    }
};
$48bbb49bf873cc09$exports = $48bbb49bf873cc09$var$methods;


var $58fab9ded43a18f7$var$keccak256 = $48bbb49bf873cc09$exports.keccak256;
var $a22620d818e7325b$exports = {};
"use strict";
/**
 * Credits to https://github.com/emilbayes/blake2b
 *
 * Copyright (c) 2017, Emil Bay github@tixz.dk
 *
 * Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */ // 64-bit unsigned addition
// Sets v[a,a+1] += v[b,b+1]
// v should be a Uint32Array
function $a22620d818e7325b$var$ADD64AA(v, a, b) {
    var o0 = v[a] + v[b];
    var o1 = v[a + 1] + v[b + 1];
    if (o0 >= 0x100000000) o1++;
    v[a] = o0;
    v[a + 1] = o1;
}
// 64-bit unsigned addition
// Sets v[a,a+1] += b
// b0 is the low 32 bits of b, b1 represents the high 32 bits
function $a22620d818e7325b$var$ADD64AC(v, a, b0, b1) {
    var o0 = v[a] + b0;
    if (b0 < 0) o0 += 0x100000000;
    var o1 = v[a + 1] + b1;
    if (o0 >= 0x100000000) o1++;
    v[a] = o0;
    v[a + 1] = o1;
}
// Little-endian byte access
function $a22620d818e7325b$var$B2B_GET32(arr, i) {
    return arr[i] ^ arr[i + 1] << 8 ^ arr[i + 2] << 16 ^ arr[i + 3] << 24;
}
// G Mixing function
// The ROTRs are inlined for speed
function $a22620d818e7325b$var$B2B_G(a, b, c, d, ix, iy) {
    var x0 = $a22620d818e7325b$var$m[ix];
    var x1 = $a22620d818e7325b$var$m[ix + 1];
    var y0 = $a22620d818e7325b$var$m[iy];
    var y1 = $a22620d818e7325b$var$m[iy + 1];
    $a22620d818e7325b$var$ADD64AA($a22620d818e7325b$var$v, a, b) // v[a,a+1] += v[b,b+1] ... in JS we must store a uint64 as two uint32s
    ;
    $a22620d818e7325b$var$ADD64AC($a22620d818e7325b$var$v, a, x0, x1) // v[a, a+1] += x ... x0 is the low 32 bits of x, x1 is the high 32 bits
    ;
    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated to the right by 32 bits
    var xor0 = $a22620d818e7325b$var$v[d] ^ $a22620d818e7325b$var$v[a];
    var xor1 = $a22620d818e7325b$var$v[d + 1] ^ $a22620d818e7325b$var$v[a + 1];
    $a22620d818e7325b$var$v[d] = xor1;
    $a22620d818e7325b$var$v[d + 1] = xor0;
    $a22620d818e7325b$var$ADD64AA($a22620d818e7325b$var$v, c, d);
    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 24 bits
    xor0 = $a22620d818e7325b$var$v[b] ^ $a22620d818e7325b$var$v[c];
    xor1 = $a22620d818e7325b$var$v[b + 1] ^ $a22620d818e7325b$var$v[c + 1];
    $a22620d818e7325b$var$v[b] = xor0 >>> 24 ^ xor1 << 8;
    $a22620d818e7325b$var$v[b + 1] = xor1 >>> 24 ^ xor0 << 8;
    $a22620d818e7325b$var$ADD64AA($a22620d818e7325b$var$v, a, b);
    $a22620d818e7325b$var$ADD64AC($a22620d818e7325b$var$v, a, y0, y1);
    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated right by 16 bits
    xor0 = $a22620d818e7325b$var$v[d] ^ $a22620d818e7325b$var$v[a];
    xor1 = $a22620d818e7325b$var$v[d + 1] ^ $a22620d818e7325b$var$v[a + 1];
    $a22620d818e7325b$var$v[d] = xor0 >>> 16 ^ xor1 << 16;
    $a22620d818e7325b$var$v[d + 1] = xor1 >>> 16 ^ xor0 << 16;
    $a22620d818e7325b$var$ADD64AA($a22620d818e7325b$var$v, c, d);
    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 63 bits
    xor0 = $a22620d818e7325b$var$v[b] ^ $a22620d818e7325b$var$v[c];
    xor1 = $a22620d818e7325b$var$v[b + 1] ^ $a22620d818e7325b$var$v[c + 1];
    $a22620d818e7325b$var$v[b] = xor1 >>> 31 ^ xor0 << 1;
    $a22620d818e7325b$var$v[b + 1] = xor0 >>> 31 ^ xor1 << 1;
}
// Initialization Vector
var $a22620d818e7325b$var$BLAKE2B_IV32 = new Uint32Array([
    0xF3BCC908,
    0x6A09E667,
    0x84CAA73B,
    0xBB67AE85,
    0xFE94F82B,
    0x3C6EF372,
    0x5F1D36F1,
    0xA54FF53A,
    0xADE682D1,
    0x510E527F,
    0x2B3E6C1F,
    0x9B05688C,
    0xFB41BD6B,
    0x1F83D9AB,
    0x137E2179,
    0x5BE0CD19
]);
var $a22620d818e7325b$var$SIGMA8 = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9,
    12,
    5,
    1,
    15,
    14,
    13,
    4,
    10,
    0,
    7,
    6,
    3,
    9,
    2,
    8,
    11,
    13,
    11,
    7,
    14,
    12,
    1,
    3,
    9,
    5,
    0,
    15,
    4,
    8,
    6,
    2,
    10,
    6,
    15,
    14,
    9,
    11,
    3,
    0,
    8,
    12,
    2,
    13,
    7,
    1,
    4,
    10,
    5,
    10,
    2,
    8,
    4,
    7,
    6,
    1,
    5,
    15,
    11,
    9,
    14,
    3,
    12,
    13,
    0,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3
];
// These are offsets into a uint64 buffer.
// Multiply them all by 2 to make them offsets into a uint32 buffer,
// because this is Javascript and we don't have uint64s
var $a22620d818e7325b$var$SIGMA82 = new Uint8Array($a22620d818e7325b$var$SIGMA8.map(function(x) {
    return x * 2;
}));
// Compression function. 'last' flag indicates last block.
// Note we're representing 16 uint64s as 32 uint32s
var $a22620d818e7325b$var$v = new Uint32Array(32);
var $a22620d818e7325b$var$m = new Uint32Array(32);
function $a22620d818e7325b$var$blake2bCompress(ctx, last) {
    var i = 0;
    // init work variables
    for(i = 0; i < 16; i++){
        $a22620d818e7325b$var$v[i] = ctx.h[i];
        $a22620d818e7325b$var$v[i + 16] = $a22620d818e7325b$var$BLAKE2B_IV32[i];
    }
    // low 64 bits of offset
    $a22620d818e7325b$var$v[24] = $a22620d818e7325b$var$v[24] ^ ctx.t;
    $a22620d818e7325b$var$v[25] = $a22620d818e7325b$var$v[25] ^ ctx.t / 0x100000000;
    // high 64 bits not supported, offset may not be higher than 2**53-1
    // last block flag set ?
    if (last) {
        $a22620d818e7325b$var$v[28] = ~$a22620d818e7325b$var$v[28];
        $a22620d818e7325b$var$v[29] = ~$a22620d818e7325b$var$v[29];
    }
    // get little-endian words
    for(i = 0; i < 32; i++)$a22620d818e7325b$var$m[i] = $a22620d818e7325b$var$B2B_GET32(ctx.b, 4 * i);
    // twelve rounds of mixing
    for(i = 0; i < 12; i++){
        $a22620d818e7325b$var$B2B_G(0, 8, 16, 24, $a22620d818e7325b$var$SIGMA82[i * 16 + 0], $a22620d818e7325b$var$SIGMA82[i * 16 + 1]);
        $a22620d818e7325b$var$B2B_G(2, 10, 18, 26, $a22620d818e7325b$var$SIGMA82[i * 16 + 2], $a22620d818e7325b$var$SIGMA82[i * 16 + 3]);
        $a22620d818e7325b$var$B2B_G(4, 12, 20, 28, $a22620d818e7325b$var$SIGMA82[i * 16 + 4], $a22620d818e7325b$var$SIGMA82[i * 16 + 5]);
        $a22620d818e7325b$var$B2B_G(6, 14, 22, 30, $a22620d818e7325b$var$SIGMA82[i * 16 + 6], $a22620d818e7325b$var$SIGMA82[i * 16 + 7]);
        $a22620d818e7325b$var$B2B_G(0, 10, 20, 30, $a22620d818e7325b$var$SIGMA82[i * 16 + 8], $a22620d818e7325b$var$SIGMA82[i * 16 + 9]);
        $a22620d818e7325b$var$B2B_G(2, 12, 22, 24, $a22620d818e7325b$var$SIGMA82[i * 16 + 10], $a22620d818e7325b$var$SIGMA82[i * 16 + 11]);
        $a22620d818e7325b$var$B2B_G(4, 14, 16, 26, $a22620d818e7325b$var$SIGMA82[i * 16 + 12], $a22620d818e7325b$var$SIGMA82[i * 16 + 13]);
        $a22620d818e7325b$var$B2B_G(6, 8, 18, 28, $a22620d818e7325b$var$SIGMA82[i * 16 + 14], $a22620d818e7325b$var$SIGMA82[i * 16 + 15]);
    }
    for(i = 0; i < 16; i++)ctx.h[i] = ctx.h[i] ^ $a22620d818e7325b$var$v[i] ^ $a22620d818e7325b$var$v[i + 16];
}
// reusable parameter_block
var $a22620d818e7325b$var$parameter_block = new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0 // 60: personal
]);
// Creates a BLAKE2b hashing context
// Requires an output length between 1 and 64 bytes
// Takes an optional Uint8Array key
function $a22620d818e7325b$var$Blake2b(outlen, key, salt, personal) {
    // zero out parameter_block before usage
    $a22620d818e7325b$var$parameter_block.fill(0);
    // state, 'param block'
    this.b = new Uint8Array(128);
    this.h = new Uint32Array(16);
    this.t = 0 // input count
    ;
    this.c = 0 // pointer within buffer
    ;
    this.outlen = outlen // output length in bytes
    ;
    $a22620d818e7325b$var$parameter_block[0] = outlen;
    if (key) $a22620d818e7325b$var$parameter_block[1] = key.length;
    $a22620d818e7325b$var$parameter_block[2] = 1 // fanout
    ;
    $a22620d818e7325b$var$parameter_block[3] = 1 // depth
    ;
    if (salt) $a22620d818e7325b$var$parameter_block.set(salt, 32);
    if (personal) $a22620d818e7325b$var$parameter_block.set(personal, 48);
    // initialize hash state
    for(var i = 0; i < 16; i++)this.h[i] = $a22620d818e7325b$var$BLAKE2B_IV32[i] ^ $a22620d818e7325b$var$B2B_GET32($a22620d818e7325b$var$parameter_block, i * 4);
    // key the hash, if applicable
    if (key) {
        $a22620d818e7325b$var$blake2bUpdate(this, key);
        // at the end
        this.c = 128;
    }
}
$a22620d818e7325b$var$Blake2b.prototype.update = function(input) {
    $a22620d818e7325b$var$blake2bUpdate(this, input);
    return this;
};
$a22620d818e7325b$var$Blake2b.prototype.digest = function(out) {
    var buf = !out || out === "binary" || out === "hex" ? new Uint8Array(this.outlen) : out;
    $a22620d818e7325b$var$blake2bFinal(this, buf);
    if (out === "hex") return $a22620d818e7325b$var$hexSlice(buf);
    return buf;
};
$a22620d818e7325b$var$Blake2b.prototype.final = $a22620d818e7325b$var$Blake2b.prototype.digest;
// Updates a BLAKE2b streaming hash
// Requires hash context and Uint8Array (byte array)
function $a22620d818e7325b$var$blake2bUpdate(ctx, input) {
    for(var i = 0; i < input.length; i++){
        if (ctx.c === 128) {
            ctx.t += ctx.c // add counters
            ;
            $a22620d818e7325b$var$blake2bCompress(ctx, false) // compress (not last)
            ;
            ctx.c = 0 // counter to zero
            ;
        }
        ctx.b[ctx.c++] = input[i];
    }
}
// Completes a BLAKE2b streaming hash
// Returns a Uint8Array containing the message digest
function $a22620d818e7325b$var$blake2bFinal(ctx, out) {
    ctx.t += ctx.c // mark last block offset
    ;
    while(ctx.c < 128)ctx.b[ctx.c++] = 0;
    $a22620d818e7325b$var$blake2bCompress(ctx, true) // final block flag = 1
    ;
    for(var i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3);
    return out;
}
function $a22620d818e7325b$var$hexSlice(buf) {
    var str = "";
    for(var i = 0; i < buf.length; i++)str += $a22620d818e7325b$var$toHex(buf[i]);
    return str;
}
function $a22620d818e7325b$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
$a22620d818e7325b$exports = $a22620d818e7325b$var$Blake2b;


var $8560caef586a2c5f$exports = {};
// Base58 encoding/decoding
// Originally written by Mike Hearn for BitcoinJ
// Copyright (c) 2011 Google Inc
// Ported to JavaScript by Stefan Thomas
// Merged Buffer refactorings from base58-native by Stephen Pair
// Copyright (c) 2013 BitPay Inc
var $8560caef586a2c5f$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var $8560caef586a2c5f$var$ALPHABET_MAP = {};
for(var $8560caef586a2c5f$var$i = 0; $8560caef586a2c5f$var$i < $8560caef586a2c5f$var$ALPHABET.length; ++$8560caef586a2c5f$var$i)$8560caef586a2c5f$var$ALPHABET_MAP[$8560caef586a2c5f$var$ALPHABET.charAt($8560caef586a2c5f$var$i)] = $8560caef586a2c5f$var$i;
var $8560caef586a2c5f$var$BASE = $8560caef586a2c5f$var$ALPHABET.length;
$8560caef586a2c5f$exports = {
    decode: function(string) {
        if (string.length === 0) return [];
        var i, j, bytes = [
            0
        ];
        for(i = 0; i < string.length; ++i){
            var c = string[i];
            if (!(c in $8560caef586a2c5f$var$ALPHABET_MAP)) throw new Error("Non-base58 character");
            for(j = 0; j < bytes.length; ++j)bytes[j] *= $8560caef586a2c5f$var$BASE;
            bytes[0] += $8560caef586a2c5f$var$ALPHABET_MAP[c];
            var carry = 0;
            for(j = 0; j < bytes.length; ++j){
                bytes[j] += carry;
                carry = bytes[j] >> 8;
                bytes[j] &= 0xff;
            }
            while(carry){
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for(i = 0; string[i] === "1" && i < string.length - 1; ++i)bytes.push(0);
        return bytes.reverse();
    }
};


var $2097381b44c604d9$exports = {};
var $2097381b44c604d9$var$alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
/**
* Encode a string to base32
*/ var $2097381b44c604d9$var$b32encode = function(s) {
    var parts = [];
    var quanta = Math.floor(s.length / 5);
    var leftover = s.length % 5;
    if (leftover != 0) {
        for(var i = 0; i < 5 - leftover; i++)s += "\x00";
        quanta += 1;
    }
    for(var i = 0; i < quanta; i++){
        parts.push($2097381b44c604d9$var$alphabet.charAt(s.charCodeAt(i * 5) >> 3));
        parts.push($2097381b44c604d9$var$alphabet.charAt((s.charCodeAt(i * 5) & 0x07) << 2 | s.charCodeAt(i * 5 + 1) >> 6));
        parts.push($2097381b44c604d9$var$alphabet.charAt((s.charCodeAt(i * 5 + 1) & 0x3F) >> 1));
        parts.push($2097381b44c604d9$var$alphabet.charAt((s.charCodeAt(i * 5 + 1) & 0x01) << 4 | s.charCodeAt(i * 5 + 2) >> 4));
        parts.push($2097381b44c604d9$var$alphabet.charAt((s.charCodeAt(i * 5 + 2) & 0x0F) << 1 | s.charCodeAt(i * 5 + 3) >> 7));
        parts.push($2097381b44c604d9$var$alphabet.charAt((s.charCodeAt(i * 5 + 3) & 0x7F) >> 2));
        parts.push($2097381b44c604d9$var$alphabet.charAt((s.charCodeAt(i * 5 + 3) & 0x03) << 3 | s.charCodeAt(i * 5 + 4) >> 5));
        parts.push($2097381b44c604d9$var$alphabet.charAt(s.charCodeAt(i * 5 + 4) & 0x1F));
    }
    var replace = 0;
    if (leftover == 1) replace = 6;
    else if (leftover == 2) replace = 4;
    else if (leftover == 3) replace = 3;
    else if (leftover == 4) replace = 1;
    for(var i = 0; i < replace; i++)parts.pop();
    for(var i = 0; i < replace; i++)parts.push("=");
    return parts.join("");
};
/**
* Decode a base32 string.
* This is made specifically for our use, deals only with proper strings
*/ var $2097381b44c604d9$var$b32decode = function(s) {
    var r = new ArrayBuffer(s.length * 5 / 8);
    var b = new Uint8Array(r);
    for(var j = 0; j < s.length / 8; j++){
        var v = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(var i = 0; i < 8; ++i)v[i] = $2097381b44c604d9$var$alphabet.indexOf(s[j * 8 + i]);
        var i = 0;
        b[j * 5 + 0] = v[i + 0] << 3 | v[i + 1] >> 2;
        b[j * 5 + 1] = (v[i + 1] & 0x3) << 6 | v[i + 2] << 1 | v[i + 3] >> 4;
        b[j * 5 + 2] = (v[i + 3] & 0xf) << 4 | v[i + 4] >> 1;
        b[j * 5 + 3] = (v[i + 4] & 0x1) << 7 | v[i + 5] << 2 | v[i + 6] >> 3;
        b[j * 5 + 4] = (v[i + 6] & 0x7) << 5 | v[i + 7];
    }
    return b;
};
$2097381b44c604d9$exports = {
    b32decode: $2097381b44c604d9$var$b32decode,
    b32encode: $2097381b44c604d9$var$b32encode
};


var $2e4f919920daf140$exports = {};
/* bignumber.js v1.3.0 https://github.com/MikeMcl/bignumber.js/LICENCE */ /*jslint bitwise: true, eqeq: true, plusplus: true, sub: true, white: true, maxerr: 500 */ /*global module */ /*
  bignumber.js v1.3.0
  A JavaScript library for arbitrary-precision arithmetic.
  https://github.com/MikeMcl/bignumber.js
  Copyright (c) 2012 Michael Mclaughlin <M8ch88l@gmail.com>
  MIT Expat Licence
*/ /*********************************** DEFAULTS ************************************/ /*
 * The default values below must be integers within the stated ranges (inclusive).
 * Most of these values can be changed during run-time using BigNumber.config().
 */ /*
 * The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP,
 * MAX_EXP, and the argument to toFixed, toPrecision and toExponential, beyond
 * which an exception is thrown (if ERRORS is true).
 */ 
var $lewJ9 = parcelRequire("lewJ9");
var $2e4f919920daf140$require$Buffer = $lewJ9.Buffer;
var $2e4f919920daf140$var$MAX = 1E9, // Limit of magnitude of exponent argument to toPower.
$2e4f919920daf140$var$MAX_POWER = 1E6, // The maximum number of decimal places for operations involving division.
$2e4f919920daf140$var$DECIMAL_PLACES = 20, /*
     * The rounding mode used when rounding to the above decimal places, and when
     * using toFixed, toPrecision and toExponential, and round (default value).
     * UP         0 Away from zero.
     * DOWN       1 Towards zero.
     * CEIL       2 Towards +Infinity.
     * FLOOR      3 Towards -Infinity.
     * HALF_UP    4 Towards nearest neighbour. If equidistant, up.
     * HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
     * HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
     * HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
     * HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
     */ $2e4f919920daf140$var$ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
// The exponent value at and beneath which toString returns exponential notation.
// Number type: -7
$2e4f919920daf140$var$TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
// Number type: 21
$2e4f919920daf140$var$TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
// The minimum exponent value, beneath which underflow to zero occurs.
// Number type: -324  (5e-324)
$2e4f919920daf140$var$MIN_EXP = -$2e4f919920daf140$var$MAX, // The maximum exponent value, above which overflow to Infinity occurs.
// Number type:  308  (1.7976931348623157e+308)
$2e4f919920daf140$var$MAX_EXP = $2e4f919920daf140$var$MAX, // Whether BigNumber Errors are ever thrown.
// CHANGE parseInt to parseFloat if changing ERRORS to false.
$2e4f919920daf140$var$ERRORS = true, $2e4f919920daf140$var$parse = parseInt, /***********************************************************************************/ $2e4f919920daf140$var$P = $2e4f919920daf140$var$BigNumber.prototype, $2e4f919920daf140$var$DIGITS = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_", $2e4f919920daf140$var$outOfRange, $2e4f919920daf140$var$id = 0, $2e4f919920daf140$var$isValid = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, $2e4f919920daf140$var$trim = String.prototype.trim || function() {
    return this.replace(/^\s+|\s+$/g, "");
}, $2e4f919920daf140$var$ONE = $2e4f919920daf140$var$BigNumber(1);
// CONSTRUCTOR
/*
 * The exported function.
 * Create and return a new instance of a BigNumber object.
 *
 * n {number|string|BigNumber} A numeric value.
 * [b] {number} The base of n. Integer, 2 to 64 inclusive.
 */ function $2e4f919920daf140$var$BigNumber(n, b) {
    var e, i, isNum, digits, valid, orig, x = this;
    // Enable constructor usage without new.
    if (!(x instanceof $2e4f919920daf140$var$BigNumber)) return new $2e4f919920daf140$var$BigNumber(n, b);
    // Duplicate.
    if (n instanceof $2e4f919920daf140$var$BigNumber) {
        $2e4f919920daf140$var$id = 0;
        // e is undefined.
        if (b !== e) n += "";
        else {
            x["s"] = n["s"];
            x["e"] = n["e"];
            x["c"] = (n = n["c"]) ? n.slice() : n;
            return;
        }
    }
    // If number, check if minus zero.
    if (typeof n != "string") n = (isNum = typeof n == "number" || Object.prototype.toString.call(n) == "[object Number]") && n === 0 && 1 / n < 0 ? "-0" : n + "";
    orig = n;
    if (b === e && $2e4f919920daf140$var$isValid.test(n)) // Determine sign.
    x["s"] = n.charAt(0) == "-" ? (n = n.slice(1), -1) : 1;
    else {
        // Enable exponential notation to be used with base 10 argument.
        // Ensure return value is rounded to DECIMAL_PLACES as with other bases.
        if (b == 10) return $2e4f919920daf140$var$setMode(n, $2e4f919920daf140$var$DECIMAL_PLACES, $2e4f919920daf140$var$ROUNDING_MODE);
        n = $2e4f919920daf140$var$trim.call(n).replace(/^\+(?!-)/, "");
        x["s"] = n.charAt(0) == "-" ? (n = n.replace(/^-(?!-)/, ""), -1) : 1;
        if (b != null) {
            if ((b == (b | 0) || !$2e4f919920daf140$var$ERRORS) && !($2e4f919920daf140$var$outOfRange = !(b >= 2 && b < 65))) {
                digits = "[" + $2e4f919920daf140$var$DIGITS.slice(0, b = b | 0) + "]+";
                // Before non-decimal number validity test and base conversion
                // remove the `.` from e.g. '1.', and replace e.g. '.1' with '0.1'.
                n = n.replace(/\.$/, "").replace(/^\./, "0.");
                // Any number in exponential form will fail due to the e+/-.
                if (valid = new RegExp("^" + digits + "(?:\\." + digits + ")?$", b < 37 ? "i" : "").test(n)) {
                    if (isNum) {
                        if (n.replace(/^0\.0*|\./, "").length > 15) // 'new BigNumber() number type has more than 15 significant digits: {n}'
                        $2e4f919920daf140$var$ifExceptionsThrow(orig, 0);
                        // Prevent later check for length on converted number.
                        isNum = !isNum;
                    }
                    n = $2e4f919920daf140$var$convert(n, 10, b, x["s"]);
                } else if (n != "Infinity" && n != "NaN") {
                    // 'new BigNumber() not a base {b} number: {n}'
                    $2e4f919920daf140$var$ifExceptionsThrow(orig, 1, b);
                    n = "NaN";
                }
            } else {
                // 'new BigNumber() base not an integer: {b}'
                // 'new BigNumber() base out of range: {b}'
                $2e4f919920daf140$var$ifExceptionsThrow(b, 2);
                // Ignore base.
                valid = $2e4f919920daf140$var$isValid.test(n);
            }
        } else valid = $2e4f919920daf140$var$isValid.test(n);
        if (!valid) {
            // Infinity/NaN
            x["c"] = x["e"] = null;
            // NaN
            if (n != "Infinity") {
                // No exception on NaN.
                if (n != "NaN") // 'new BigNumber() not a number: {n}'
                $2e4f919920daf140$var$ifExceptionsThrow(orig, 3);
                x["s"] = null;
            }
            $2e4f919920daf140$var$id = 0;
            return;
        }
    }
    // Decimal point?
    if ((e = n.indexOf(".")) > -1) n = n.replace(".", "");
    // Exponential form?
    if ((i = n.search(/e/i)) > 0) {
        // Determine exponent.
        if (e < 0) e = i;
        e += +n.slice(i + 1);
        n = n.substring(0, i);
    } else if (e < 0) // Integer.
    e = n.length;
    // Determine leading zeros.
    for(i = 0; n.charAt(i) == "0"; i++);
    b = n.length;
    // Disallow numbers with over 15 significant digits if number type.
    if (isNum && b > 15 && n.slice(i).length > 15) // 'new BigNumber() number type has more than 15 significant digits: {n}'
    $2e4f919920daf140$var$ifExceptionsThrow(orig, 0);
    $2e4f919920daf140$var$id = 0;
    // Overflow?
    if ((e -= i + 1) > $2e4f919920daf140$var$MAX_EXP) // Infinity.
    x["c"] = x["e"] = null;
    else if (i == b || e < $2e4f919920daf140$var$MIN_EXP) // Zero.
    x["c"] = [
        x["e"] = 0
    ];
    else {
        // Determine trailing zeros.
        for(; n.charAt(--b) == "0";);
        x["e"] = e;
        x["c"] = [];
        // Convert string to array of digits (without leading and trailing zeros).
        for(e = 0; i <= b; x["c"][e++] = +n.charAt(i++));
    }
}
// CONSTRUCTOR PROPERTIES/METHODS
$2e4f919920daf140$var$BigNumber["ROUND_UP"] = 0;
$2e4f919920daf140$var$BigNumber["ROUND_DOWN"] = 1;
$2e4f919920daf140$var$BigNumber["ROUND_CEIL"] = 2;
$2e4f919920daf140$var$BigNumber["ROUND_FLOOR"] = 3;
$2e4f919920daf140$var$BigNumber["ROUND_HALF_UP"] = 4;
$2e4f919920daf140$var$BigNumber["ROUND_HALF_DOWN"] = 5;
$2e4f919920daf140$var$BigNumber["ROUND_HALF_EVEN"] = 6;
$2e4f919920daf140$var$BigNumber["ROUND_HALF_CEIL"] = 7;
$2e4f919920daf140$var$BigNumber["ROUND_HALF_FLOOR"] = 8;
/*
 * Create an instance from a Buffer
 */ $2e4f919920daf140$var$BigNumber["fromBuffer"] = function(buf, opts) {
    if (!opts) opts = {};
    var endian = {
        1: "big",
        "-1": "little"
    }[opts.endian] || opts.endian || "big";
    var size = opts.size === "auto" ? Math.ceil(buf.length) : opts.size || 1;
    if (buf.length % size !== 0) throw new RangeError("Buffer length (" + buf.length + ")" + " must be a multiple of size (" + size + ")");
    var hex = [];
    for(var i = 0; i < buf.length; i += size){
        var chunk = [];
        for(var j = 0; j < size; j++)chunk.push(buf[i + (endian === "big" ? j : size - j - 1)]);
        hex.push(chunk.map(function(c) {
            return (c < 16 ? "0" : "") + c.toString(16);
        }).join(""));
    }
    return $2e4f919920daf140$var$BigNumber(hex.join(""), 16);
};
/*
 * Configure infrequently-changing library-wide settings.
 *
 * Accept an object or an argument list, with one or many of the following
 * properties or parameters respectively:
 * [ DECIMAL_PLACES [, ROUNDING_MODE [, EXPONENTIAL_AT [, RANGE [, ERRORS ]]]]]
 *
 * E.g.
 * BigNumber.config(20, 4) is equivalent to
 * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
 * Ignore properties/parameters set to null or undefined.
 *
 * Return an object with the properties current values.
 */ $2e4f919920daf140$var$BigNumber["config"] = function() {
    var v, p, i = 0, r = {}, a = arguments, o = a[0], c = "config", inRange = function(n, lo, hi) {
        return !(($2e4f919920daf140$var$outOfRange = n < lo || n > hi) || $2e4f919920daf140$var$parse(n) != n && n !== 0);
    }, has = o && typeof o == "object" ? function() {
        if (o.hasOwnProperty(p)) return (v = o[p]) != null;
    } : function() {
        if (a.length > i) return (v = a[i++]) != null;
    };
    // [DECIMAL_PLACES] {number} Integer, 0 to MAX inclusive.
    if (has(p = "DECIMAL_PLACES")) {
        if (inRange(v, 0, $2e4f919920daf140$var$MAX)) $2e4f919920daf140$var$DECIMAL_PLACES = v | 0;
        else // 'config() DECIMAL_PLACES not an integer: {v}'
        // 'config() DECIMAL_PLACES out of range: {v}'
        $2e4f919920daf140$var$ifExceptionsThrow(v, p, c);
    }
    r[p] = $2e4f919920daf140$var$DECIMAL_PLACES;
    // [ROUNDING_MODE] {number} Integer, 0 to 8 inclusive.
    if (has(p = "ROUNDING_MODE")) {
        if (inRange(v, 0, 8)) $2e4f919920daf140$var$ROUNDING_MODE = v | 0;
        else // 'config() ROUNDING_MODE not an integer: {v}'
        // 'config() ROUNDING_MODE out of range: {v}'
        $2e4f919920daf140$var$ifExceptionsThrow(v, p, c);
    }
    r[p] = $2e4f919920daf140$var$ROUNDING_MODE;
    /*
     * [EXPONENTIAL_AT] {number|number[]} Integer, -MAX to MAX inclusive or
     * [ integer -MAX to 0 inclusive, 0 to MAX inclusive ].
     */ if (has(p = "EXPONENTIAL_AT")) {
        if (inRange(v, -$2e4f919920daf140$var$MAX, $2e4f919920daf140$var$MAX)) $2e4f919920daf140$var$TO_EXP_NEG = -($2e4f919920daf140$var$TO_EXP_POS = ~~(v < 0 ? -v : +v));
        else if (!$2e4f919920daf140$var$outOfRange && v && inRange(v[0], -$2e4f919920daf140$var$MAX, 0) && inRange(v[1], 0, $2e4f919920daf140$var$MAX)) {
            $2e4f919920daf140$var$TO_EXP_NEG = ~~v[0];
            $2e4f919920daf140$var$TO_EXP_POS = ~~v[1];
        } else // 'config() EXPONENTIAL_AT not an integer or not [integer, integer]: {v}'
        // 'config() EXPONENTIAL_AT out of range or not [negative, positive: {v}'
        $2e4f919920daf140$var$ifExceptionsThrow(v, p, c, 1);
    }
    r[p] = [
        $2e4f919920daf140$var$TO_EXP_NEG,
        $2e4f919920daf140$var$TO_EXP_POS
    ];
    /*
     * [RANGE][ {number|number[]} Non-zero integer, -MAX to MAX inclusive or
     * [ integer -MAX to -1 inclusive, integer 1 to MAX inclusive ].
     */ if (has(p = "RANGE")) {
        if (inRange(v, -$2e4f919920daf140$var$MAX, $2e4f919920daf140$var$MAX) && ~~v) $2e4f919920daf140$var$MIN_EXP = -($2e4f919920daf140$var$MAX_EXP = ~~(v < 0 ? -v : +v));
        else if (!$2e4f919920daf140$var$outOfRange && v && inRange(v[0], -$2e4f919920daf140$var$MAX, -1) && inRange(v[1], 1, $2e4f919920daf140$var$MAX)) $2e4f919920daf140$var$MIN_EXP = ~~v[0], $2e4f919920daf140$var$MAX_EXP = ~~v[1];
        else // 'config() RANGE not a non-zero integer or not [integer, integer]: {v}'
        // 'config() RANGE out of range or not [negative, positive: {v}'
        $2e4f919920daf140$var$ifExceptionsThrow(v, p, c, 1, 1);
    }
    r[p] = [
        $2e4f919920daf140$var$MIN_EXP,
        $2e4f919920daf140$var$MAX_EXP
    ];
    // [ERRORS] {boolean|number} true, false, 1 or 0.
    if (has(p = "ERRORS")) {
        if (v === !!v || v === 1 || v === 0) $2e4f919920daf140$var$parse = ($2e4f919920daf140$var$outOfRange = $2e4f919920daf140$var$id = 0, $2e4f919920daf140$var$ERRORS = !!v) ? parseInt : parseFloat;
        else // 'config() ERRORS not a boolean or binary digit: {v}'
        $2e4f919920daf140$var$ifExceptionsThrow(v, p, c, 0, 0, 1);
    }
    r[p] = $2e4f919920daf140$var$ERRORS;
    return r;
};
// PRIVATE FUNCTIONS
// Assemble error messages. Throw BigNumber Errors.
function $2e4f919920daf140$var$ifExceptionsThrow(arg, i, j, isArray, isRange, isErrors) {
    if ($2e4f919920daf140$var$ERRORS) {
        var error, method = [
            "new BigNumber",
            "cmp",
            "div",
            "eq",
            "gt",
            "gte",
            "lt",
            "lte",
            "minus",
            "mod",
            "plus",
            "times",
            "toFr"
        ][$2e4f919920daf140$var$id ? $2e4f919920daf140$var$id < 0 ? -$2e4f919920daf140$var$id : $2e4f919920daf140$var$id : 1 / $2e4f919920daf140$var$id < 0 ? 1 : 0] + "()", message = $2e4f919920daf140$var$outOfRange ? " out of range" : " not a" + (isRange ? " non-zero" : "n") + " integer";
        message = ([
            method + " number type has more than 15 significant digits",
            method + " not a base " + j + " number",
            method + " base" + message,
            method + " not a number"
        ][i] || j + "() " + i + (isErrors ? " not a boolean or binary digit" : message + (isArray ? " or not [" + ($2e4f919920daf140$var$outOfRange ? " negative, positive" : " integer, integer") + " ]" : ""))) + ": " + arg;
        $2e4f919920daf140$var$outOfRange = $2e4f919920daf140$var$id = 0;
        error = new Error(message);
        error["name"] = "BigNumber Error";
        throw error;
    }
}
/*
 * Convert a numeric string of baseIn to a numeric string of baseOut.
 */ function $2e4f919920daf140$var$convert(nStr, baseOut, baseIn, sign) {
    var e, dvs, dvd, nArr, fracArr, fracBN;
    // Convert string of base bIn to an array of numbers of baseOut.
    // Eg. strToArr('255', 10) where baseOut is 16, returns [15, 15].
    // Eg. strToArr('ff', 16)  where baseOut is 10, returns [2, 5, 5].
    function strToArr(str, bIn) {
        var j, i = 0, strL = str.length, arrL, arr = [
            0
        ];
        for(bIn = bIn || baseIn; i < strL; i++){
            for(arrL = arr.length, j = 0; j < arrL; arr[j] *= bIn, j++);
            for(arr[0] += $2e4f919920daf140$var$DIGITS.indexOf(str.charAt(i)), j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                if (arr[j + 1] == null) arr[j + 1] = 0;
                arr[j + 1] += arr[j] / baseOut ^ 0;
                arr[j] %= baseOut;
            }
        }
        return arr.reverse();
    }
    // Convert array to string.
    // E.g. arrToStr( [9, 10, 11] ) becomes '9ab' (in bases above 11).
    function arrToStr(arr) {
        var i = 0, arrL = arr.length, str = "";
        for(; i < arrL; str += $2e4f919920daf140$var$DIGITS.charAt(arr[i++]));
        return str;
    }
    if (baseIn < 37) nStr = nStr.toLowerCase();
    /*
     * If non-integer convert integer part and fraction part separately.
     * Convert the fraction part as if it is an integer than use division to
     * reduce it down again to a value less than one.
     */ if ((e = nStr.indexOf(".")) > -1) {
        /*
         * Calculate the power to which to raise the base to get the number
         * to divide the fraction part by after it has been converted as an
         * integer to the required base.
         */ e = nStr.length - e - 1;
        // Use toFixed to avoid possible exponential notation.
        dvs = strToArr(new $2e4f919920daf140$var$BigNumber(baseIn)["pow"](e)["toF"](), 10);
        nArr = nStr.split(".");
        // Convert the base of the fraction part (as integer).
        dvd = strToArr(nArr[1]);
        // Convert the base of the integer part.
        nArr = strToArr(nArr[0]);
        // Result will be a BigNumber with a value less than 1.
        fracBN = $2e4f919920daf140$var$divide(dvd, dvs, dvd.length - dvs.length, sign, baseOut, // Is least significant digit of integer part an odd number?
        nArr[nArr.length - 1] & 1);
        fracArr = fracBN["c"];
        // e can be <= 0  ( if e == 0, fracArr is [0] or [1] ).
        if (e = fracBN["e"]) {
            // Append zeros according to the exponent of the result.
            for(; ++e; fracArr.unshift(0));
            // Append the fraction part to the converted integer part.
            nStr = arrToStr(nArr) + "." + arrToStr(fracArr);
        // fracArr is [1].
        // Fraction digits rounded up, so increment last digit of integer part.
        } else if (fracArr[0]) {
            if (nArr[e = nArr.length - 1] < baseOut - 1) {
                ++nArr[e];
                nStr = arrToStr(nArr);
            } else nStr = new $2e4f919920daf140$var$BigNumber(arrToStr(nArr), baseOut)["plus"]($2e4f919920daf140$var$ONE)["toS"](baseOut);
        } else nStr = arrToStr(nArr);
    } else // Simple integer. Convert base.
    nStr = arrToStr(strToArr(nStr));
    return nStr;
}
// Perform division in the specified base. Called by div and convert.
function $2e4f919920daf140$var$divide(dvd, dvs, exp, s, base, isOdd) {
    var dvsL, dvsT, next, cmp, remI, dvsZ = dvs.slice(), dvdI = dvsL = dvs.length, dvdL = dvd.length, rem = dvd.slice(0, dvsL), remL = rem.length, quo = new $2e4f919920daf140$var$BigNumber($2e4f919920daf140$var$ONE), qc = quo["c"] = [], qi = 0, dig = $2e4f919920daf140$var$DECIMAL_PLACES + (quo["e"] = exp) + 1;
    quo["s"] = s;
    s = dig < 0 ? 0 : dig;
    // Add zeros to make remainder as long as divisor.
    for(; remL++ < dvsL; rem.push(0));
    // Create version of divisor with leading zero.
    dvsZ.unshift(0);
    do {
        // 'next' is how many times the divisor goes into the current remainder.
        for(next = 0; next < base; next++){
            // Compare divisor and remainder.
            if (dvsL != (remL = rem.length)) cmp = dvsL > remL ? 1 : -1;
            else {
                for(remI = -1, cmp = 0; ++remI < dvsL;)if (dvs[remI] != rem[remI]) {
                    cmp = dvs[remI] > rem[remI] ? 1 : -1;
                    break;
                }
            }
            // Subtract divisor from remainder (if divisor < remainder).
            if (cmp < 0) {
                // Remainder cannot be more than one digit longer than divisor.
                // Equalise lengths using divisor with extra leading zero?
                for(dvsT = remL == dvsL ? dvs : dvsZ; remL;){
                    if (rem[--remL] < dvsT[remL]) {
                        for(remI = remL; remI && !rem[--remI]; rem[remI] = base - 1);
                        --rem[remI];
                        rem[remL] += base;
                    }
                    rem[remL] -= dvsT[remL];
                }
                for(; !rem[0]; rem.shift());
            } else break;
        }
        // Add the 'next' digit to the result array.
        qc[qi++] = cmp ? next : ++next;
        // Update the remainder.
        rem[0] && cmp ? rem[remL] = dvd[dvdI] || 0 : rem = [
            dvd[dvdI]
        ];
    }while ((dvdI++ < dvdL || rem[0] != null) && s--);
    // Leading zero? Do not remove if result is simply zero (qi == 1).
    if (!qc[0] && qi != 1) {
        // There can't be more than one zero.
        --quo["e"];
        qc.shift();
    }
    // Round?
    if (qi > dig) $2e4f919920daf140$var$rnd(quo, $2e4f919920daf140$var$DECIMAL_PLACES, base, isOdd, rem[0] != null);
    // Overflow?
    if (quo["e"] > $2e4f919920daf140$var$MAX_EXP) // Infinity.
    quo["c"] = quo["e"] = null;
    else if (quo["e"] < $2e4f919920daf140$var$MIN_EXP) // Zero.
    quo["c"] = [
        quo["e"] = 0
    ];
    return quo;
}
/*
 * Return a string representing the value of BigNumber n in normal or
 * exponential notation rounded to the specified decimal places or
 * significant digits.
 * Called by toString, toExponential (exp 1), toFixed, and toPrecision (exp 2).
 * d is the index (with the value in normal notation) of the digit that may be
 * rounded up.
 */ function $2e4f919920daf140$var$format(n, d, exp) {
    // Initially, i is the number of decimal places required.
    var i = d - (n = new $2e4f919920daf140$var$BigNumber(n))["e"], c = n["c"];
    // +-Infinity or NaN?
    if (!c) return n["toS"]();
    // Round?
    if (c.length > ++d) $2e4f919920daf140$var$rnd(n, i, 10);
    // Recalculate d if toFixed as n['e'] may have changed if value rounded up.
    i = c[0] == 0 ? i + 1 : exp ? d : n["e"] + i + 1;
    // Append zeros?
    for(; c.length < i; c.push(0));
    i = n["e"];
    /*
     * toPrecision returns exponential notation if the number of significant
     * digits specified is less than the number of digits necessary to
     * represent the integer part of the value in normal notation.
     */ return exp == 1 || exp == 2 && (--d < i || i <= $2e4f919920daf140$var$TO_EXP_NEG) ? (n["s"] < 0 && c[0] ? "-" : "") + (c.length > 1 ? (c.splice(1, 0, "."), c.join("")) : c[0]) + (i < 0 ? "e" : "e+") + i : n["toS"]();
}
// Round if necessary.
// Called by divide, format, setMode and sqrt.
function $2e4f919920daf140$var$rnd(x, dp, base, isOdd, r) {
    var xc = x["c"], isNeg = x["s"] < 0, half = base / 2, i = x["e"] + dp + 1, // 'next' is the digit after the digit that may be rounded up.
    next = xc[i], /*
         * 'more' is whether there are digits after 'next'.
         * E.g.
         * 0.005 (e = -3) to be rounded to 0 decimal places (dp = 0) gives i = -2
         * The 'next' digit is zero, and there ARE 'more' digits after it.
         * 0.5 (e = -1) dp = 0 gives i = 0
         * The 'next' digit is 5 and there are no 'more' digits after it.
         */ more = r || i < 0 || xc[i + 1] != null;
    r = $2e4f919920daf140$var$ROUNDING_MODE < 4 ? (next != null || more) && ($2e4f919920daf140$var$ROUNDING_MODE == 0 || $2e4f919920daf140$var$ROUNDING_MODE == 2 && !isNeg || $2e4f919920daf140$var$ROUNDING_MODE == 3 && isNeg) : next > half || next == half && ($2e4f919920daf140$var$ROUNDING_MODE == 4 || more || /*
           * isOdd is used in base conversion and refers to the least significant
           * digit of the integer part of the value to be converted. The fraction
           * part is rounded by this method separately from the integer part.
           */ $2e4f919920daf140$var$ROUNDING_MODE == 6 && (xc[i - 1] & 1 || !dp && isOdd) || $2e4f919920daf140$var$ROUNDING_MODE == 7 && !isNeg || $2e4f919920daf140$var$ROUNDING_MODE == 8 && isNeg);
    if (i < 1 || !xc[0]) {
        xc.length = 0;
        xc.push(0);
        if (r) {
            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
            xc[0] = 1;
            x["e"] = -dp;
        } else // Zero.
        x["e"] = 0;
        return x;
    }
    // Remove any digits after the required decimal places.
    xc.length = i--;
    // Round up?
    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
    for(--base; ++xc[i] > base;){
        xc[i] = 0;
        if (!i--) {
            ++x["e"];
            xc.unshift(1);
        }
    }
    // Remove trailing zeros.
    for(i = xc.length; !xc[--i]; xc.pop());
    return x;
}
// Round after setting the appropriate rounding mode.
// Handles ceil, floor and round.
function $2e4f919920daf140$var$setMode(x, dp, rm) {
    var r = $2e4f919920daf140$var$ROUNDING_MODE;
    $2e4f919920daf140$var$ROUNDING_MODE = rm;
    x = new $2e4f919920daf140$var$BigNumber(x);
    x["c"] && $2e4f919920daf140$var$rnd(x, dp, 10);
    $2e4f919920daf140$var$ROUNDING_MODE = r;
    return x;
}
// PROTOTYPE/INSTANCE METHODS
/*
 * Return a new BigNumber whose value is the absolute value of this BigNumber.
 */ $2e4f919920daf140$var$P["abs"] = $2e4f919920daf140$var$P["absoluteValue"] = function() {
    var x = new $2e4f919920daf140$var$BigNumber(this);
    if (x["s"] < 0) x["s"] = 1;
    return x;
};
/*
 * Return the bit length of the number.
 */ $2e4f919920daf140$var$P["bitLength"] = function() {
    return this.toString(2).length;
};
/*
 * Return a new BigNumber whose value is the value of this BigNumber
 * rounded to a whole number in the direction of Infinity.
 */ $2e4f919920daf140$var$P["ceil"] = function() {
    return $2e4f919920daf140$var$setMode(this, 0, 2);
};
/*
 * Return
 * 1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
 * -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
 * 0 if they have the same value,
 * or null if the value of either is NaN.
 */ $2e4f919920daf140$var$P["comparedTo"] = $2e4f919920daf140$var$P["cmp"] = function(y, b) {
    var a, x = this, xc = x["c"], yc = ($2e4f919920daf140$var$id = -$2e4f919920daf140$var$id, y = new $2e4f919920daf140$var$BigNumber(y, b))["c"], i = x["s"], j = y["s"], k = x["e"], l = y["e"];
    // Either NaN?
    if (!i || !j) return null;
    a = xc && !xc[0], b = yc && !yc[0];
    // Either zero?
    if (a || b) return a ? b ? 0 : -j : i;
    // Signs differ?
    if (i != j) return i;
    // Either Infinity?
    if (a = i < 0, b = k == l, !xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
    // Compare exponents.
    if (!b) return k > l ^ a ? 1 : -1;
    // Compare digit by digit.
    for(i = -1, j = (k = xc.length) < (l = yc.length) ? k : l; ++i < j;){
        if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
    }
    // Compare lengths.
    return k == l ? 0 : k > l ^ a ? 1 : -1;
};
/*
 *  n / 0 = I
 *  n / N = N
 *  n / I = 0
 *  0 / n = 0
 *  0 / 0 = N
 *  0 / N = N
 *  0 / I = 0
 *  N / n = N
 *  N / 0 = N
 *  N / N = N
 *  N / I = N
 *  I / n = I
 *  I / 0 = I
 *  I / N = N
 *  I / I = N
 *
 * Return a new BigNumber whose value is the value of this BigNumber
 * divided by the value of BigNumber(y, b), rounded according to
 * DECIMAL_PLACES and ROUNDING_MODE.
 */ $2e4f919920daf140$var$P["dividedBy"] = $2e4f919920daf140$var$P["div"] = function(y, b) {
    var xc = this["c"], xe = this["e"], xs = this["s"], yc = ($2e4f919920daf140$var$id = 2, y = new $2e4f919920daf140$var$BigNumber(y, b))["c"], ye = y["e"], ys = y["s"], s = xs == ys ? 1 : -1;
    // Either NaN/Infinity/0?
    return !xe && (!xc || !xc[0]) || !ye && (!yc || !yc[0]) ? new $2e4f919920daf140$var$BigNumber(!xs || !ys || // Both 0 or both Infinity?
    (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : xc && xc[0] == 0 || !yc ? s * 0 : s / 0) : $2e4f919920daf140$var$divide(xc, yc, xe - ye, s, 10);
};
/*
 * Return true if the value of this BigNumber is equal to the value of
 * BigNumber(n, b), otherwise returns false.
 */ $2e4f919920daf140$var$P["equals"] = $2e4f919920daf140$var$P["eq"] = function(n, b) {
    $2e4f919920daf140$var$id = 3;
    return this["cmp"](n, b) === 0;
};
/*
 * Return a new BigNumber whose value is the value of this BigNumber
 * rounded to a whole number in the direction of -Infinity.
 */ $2e4f919920daf140$var$P["floor"] = function() {
    return $2e4f919920daf140$var$setMode(this, 0, 3);
};
/*
 * Return true if the value of this BigNumber is greater than the value of
 * BigNumber(n, b), otherwise returns false.
 */ $2e4f919920daf140$var$P["greaterThan"] = $2e4f919920daf140$var$P["gt"] = function(n, b) {
    $2e4f919920daf140$var$id = 4;
    return this["cmp"](n, b) > 0;
};
/*
 * Return true if the value of this BigNumber is greater than or equal to
 * the value of BigNumber(n, b), otherwise returns false.
 */ $2e4f919920daf140$var$P["greaterThanOrEqualTo"] = $2e4f919920daf140$var$P["gte"] = $2e4f919920daf140$var$P["gt"] = function(n, b) {
    $2e4f919920daf140$var$id = 5;
    return (b = this["cmp"](n, b)) == 1 || b === 0;
};
/*
 * Return true if the value of this BigNumber is a finite number, otherwise
 * returns false.
 */ $2e4f919920daf140$var$P["isFinite"] = $2e4f919920daf140$var$P["isF"] = function() {
    return !!this["c"];
};
/*
 * Return true if the value of this BigNumber is NaN, otherwise returns
 * false.
 */ $2e4f919920daf140$var$P["isNaN"] = function() {
    return !this["s"];
};
/*
 * Return true if the value of this BigNumber is negative, otherwise
 * returns false.
 */ $2e4f919920daf140$var$P["isNegative"] = $2e4f919920daf140$var$P["isNeg"] = function() {
    return this["s"] < 0;
};
/*
 * Return true if the value of this BigNumber is 0 or -0, otherwise returns
 * false.
 */ $2e4f919920daf140$var$P["isZero"] = $2e4f919920daf140$var$P["isZ"] = function() {
    return !!this["c"] && this["c"][0] == 0;
};
/*
 * Return true if the value of this BigNumber is less than the value of
 * BigNumber(n, b), otherwise returns false.
 */ $2e4f919920daf140$var$P["lessThan"] = $2e4f919920daf140$var$P["lt"] = function(n, b) {
    $2e4f919920daf140$var$id = 6;
    return this["cmp"](n, b) < 0;
};
/*
 * Return true if the value of this BigNumber is less than or equal to the
 * value of BigNumber(n, b), otherwise returns false.
 */ $2e4f919920daf140$var$P["lessThanOrEqualTo"] = $2e4f919920daf140$var$P["lte"] = $2e4f919920daf140$var$P["le"] = function(n, b) {
    $2e4f919920daf140$var$id = 7;
    return (b = this["cmp"](n, b)) == -1 || b === 0;
};
/*
 *  n - 0 = n
 *  n - N = N
 *  n - I = -I
 *  0 - n = -n
 *  0 - 0 = 0
 *  0 - N = N
 *  0 - I = -I
 *  N - n = N
 *  N - 0 = N
 *  N - N = N
 *  N - I = N
 *  I - n = I
 *  I - 0 = I
 *  I - N = N
 *  I - I = N
 *
 * Return a new BigNumber whose value is the value of this BigNumber minus
 * the value of BigNumber(y, b).
 */ $2e4f919920daf140$var$P["minus"] = $2e4f919920daf140$var$P["sub"] = function(y, b) {
    var d, i, j, xLTy, x = this, a = x["s"];
    b = ($2e4f919920daf140$var$id = 8, y = new $2e4f919920daf140$var$BigNumber(y, b))["s"];
    // Either NaN?
    if (!a || !b) return new $2e4f919920daf140$var$BigNumber(NaN);
    // Signs differ?
    if (a != b) return y["s"] = -b, x["plus"](y);
    var xc = x["c"], xe = x["e"], yc = y["c"], ye = y["e"];
    if (!xe || !ye) {
        // Either Infinity?
        if (!xc || !yc) return xc ? (y["s"] = -b, y) : new $2e4f919920daf140$var$BigNumber(yc ? x : NaN);
        // Either zero?
        if (!xc[0] || !yc[0]) // y is non-zero?
        return yc[0] ? (y["s"] = -b, y) : new $2e4f919920daf140$var$BigNumber(xc[0] ? x : $2e4f919920daf140$var$ROUNDING_MODE == 3 ? -0 : 0);
    }
    // Determine which is the bigger number.
    // Prepend zeros to equalise exponents.
    if (xc = xc.slice(), a = xe - ye) {
        d = (xLTy = a < 0) ? (a = -a, xc) : (ye = xe, yc);
        for(d.reverse(), b = a; b--; d.push(0));
        d.reverse();
    } else {
        // Exponents equal. Check digit by digit.
        j = ((xLTy = xc.length < yc.length) ? xc : yc).length;
        for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
            xLTy = xc[b] < yc[b];
            break;
        }
    }
    // x < y? Point xc to the array of the bigger number.
    if (xLTy) {
        d = xc, xc = yc, yc = d;
        y["s"] = -y["s"];
    }
    /*
     * Append zeros to xc if shorter. No need to add zeros to yc if shorter
     * as subtraction only needs to start at yc.length.
     */ if ((b = -((j = xc.length) - yc.length)) > 0) {
        for(; b--; xc[j++] = 0);
    }
    // Subtract yc from xc.
    for(b = yc.length; b > a;){
        if (xc[--b] < yc[b]) {
            for(i = b; i && !xc[--i]; xc[i] = 9);
            --xc[i];
            xc[b] += 10;
        }
        xc[b] -= yc[b];
    }
    // Remove trailing zeros.
    for(; xc[--j] == 0; xc.pop());
    // Remove leading zeros and adjust exponent accordingly.
    for(; xc[0] == 0; xc.shift(), --ye);
    /*
     * No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
     * when neither x or y are Infinity.
     */ // Underflow?
    if (ye < $2e4f919920daf140$var$MIN_EXP || !xc[0]) {
        /*
         * Following IEEE 754 (2008) 6.3,
         * n - n = +0  but  n - n = -0 when rounding towards -Infinity.
         */ if (!xc[0]) y["s"] = $2e4f919920daf140$var$ROUNDING_MODE == 3 ? -1 : 1;
        // Result is zero.
        xc = [
            ye = 0
        ];
    }
    return y["c"] = xc, y["e"] = ye, y;
};
/*
 *   n % 0 =  N
 *   n % N =  N
 *   0 % n =  0
 *  -0 % n = -0
 *   0 % 0 =  N
 *   0 % N =  N
 *   N % n =  N
 *   N % 0 =  N
 *   N % N =  N
 *
 * Return a new BigNumber whose value is the value of this BigNumber modulo
 * the value of BigNumber(y, b).
 */ $2e4f919920daf140$var$P["modulo"] = $2e4f919920daf140$var$P["mod"] = function(y, b) {
    var x = this, xc = x["c"], yc = ($2e4f919920daf140$var$id = 9, y = new $2e4f919920daf140$var$BigNumber(y, b))["c"], i = x["s"], j = y["s"];
    // Is x or y NaN, or y zero?
    b = !i || !j || yc && !yc[0];
    if (b || xc && !xc[0]) return new $2e4f919920daf140$var$BigNumber(b ? NaN : x);
    x["s"] = y["s"] = 1;
    b = y["cmp"](x) == 1;
    x["s"] = i, y["s"] = j;
    return b ? new $2e4f919920daf140$var$BigNumber(x) : (i = $2e4f919920daf140$var$DECIMAL_PLACES, j = $2e4f919920daf140$var$ROUNDING_MODE, $2e4f919920daf140$var$DECIMAL_PLACES = 0, $2e4f919920daf140$var$ROUNDING_MODE = 1, x = x["div"](y), $2e4f919920daf140$var$DECIMAL_PLACES = i, $2e4f919920daf140$var$ROUNDING_MODE = j, this["minus"](x["times"](y)));
};
/*
 * Return a new BigNumber whose value is the value of this BigNumber
 * negated, i.e. multiplied by -1.
 */ $2e4f919920daf140$var$P["negated"] = $2e4f919920daf140$var$P["neg"] = function() {
    var x = new $2e4f919920daf140$var$BigNumber(this);
    return x["s"] = -x["s"] || null, x;
};
/*
 *  n + 0 = n
 *  n + N = N
 *  n + I = I
 *  0 + n = n
 *  0 + 0 = 0
 *  0 + N = N
 *  0 + I = I
 *  N + n = N
 *  N + 0 = N
 *  N + N = N
 *  N + I = N
 *  I + n = I
 *  I + 0 = I
 *  I + N = N
 *  I + I = I
 *
 * Return a new BigNumber whose value is the value of this BigNumber plus
 * the value of BigNumber(y, b).
 */ $2e4f919920daf140$var$P["plus"] = $2e4f919920daf140$var$P["add"] = function(y, b) {
    var d, x = this, a = x["s"];
    b = ($2e4f919920daf140$var$id = 10, y = new $2e4f919920daf140$var$BigNumber(y, b))["s"];
    // Either NaN?
    if (!a || !b) return new $2e4f919920daf140$var$BigNumber(NaN);
    // Signs differ?
    if (a != b) return y["s"] = -b, x["minus"](y);
    var xe = x["e"], xc = x["c"], ye = y["e"], yc = y["c"];
    if (!xe || !ye) {
        // Either Infinity?
        if (!xc || !yc) // Return +-Infinity.
        return new $2e4f919920daf140$var$BigNumber(a / 0);
        // Either zero?
        if (!xc[0] || !yc[0]) // y is non-zero?
        return yc[0] ? y : new $2e4f919920daf140$var$BigNumber(xc[0] ? x : a * 0);
    }
    // Prepend zeros to equalise exponents.
    // Note: Faster to use reverse then do unshifts.
    if (xc = xc.slice(), a = xe - ye) {
        d = a > 0 ? (ye = xe, yc) : (a = -a, xc);
        for(d.reverse(); a--; d.push(0));
        d.reverse();
    }
    // Point xc to the longer array.
    if (xc.length - yc.length < 0) d = yc, yc = xc, xc = d;
    /*
     * Only start adding at yc.length - 1 as the
     * further digits of xc can be left as they are.
     */ for(a = yc.length, b = 0; a; b = (xc[--a] = xc[a] + yc[a] + b) / 10 ^ 0, xc[a] %= 10);
    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
    if (b) {
        xc.unshift(b);
        // Overflow? (MAX_EXP + 1 possible)
        if (++ye > $2e4f919920daf140$var$MAX_EXP) // Infinity.
        xc = ye = null;
    }
    // Remove trailing zeros.
    for(a = xc.length; xc[--a] == 0; xc.pop());
    return y["c"] = xc, y["e"] = ye, y;
};
/*
 * Return a BigNumber whose value is the value of this BigNumber raised to
 * the power e. If e is negative round according to DECIMAL_PLACES and
 * ROUNDING_MODE.
 *
 * e {number} Integer, -MAX_POWER to MAX_POWER inclusive.
 */ $2e4f919920daf140$var$P["toPower"] = $2e4f919920daf140$var$P["pow"] = function(e) {
    // e to integer, avoiding NaN or Infinity becoming 0.
    var i = e * 0 == 0 ? e | 0 : e, x = new $2e4f919920daf140$var$BigNumber(this), y = new $2e4f919920daf140$var$BigNumber($2e4f919920daf140$var$ONE);
    // Use Math.pow?
    // Pass +-Infinity for out of range exponents.
    if ((($2e4f919920daf140$var$outOfRange = e < -$2e4f919920daf140$var$MAX_POWER || e > $2e4f919920daf140$var$MAX_POWER) && (i = e * 1 / 0) || /*
          * Any exponent that fails the parse becomes NaN.
          *
          * Include 'e !== 0' because on Opera -0 == parseFloat(-0) is false,
          * despite -0 === parseFloat(-0) && -0 == parseFloat('-0') is true.
          */ $2e4f919920daf140$var$parse(e) != e && e !== 0 && (i = NaN, true)) && // 'pow() exponent not an integer: {e}'
    // 'pow() exponent out of range: {e}'
    !$2e4f919920daf140$var$ifExceptionsThrow(e, "exponent", "pow") || // Pass zero to Math.pow, as any value to the power zero is 1.
    !i) // i is +-Infinity, NaN or 0.
    return new $2e4f919920daf140$var$BigNumber(Math.pow(x["toS"](), i));
    for(i = i < 0 ? -i : i;;){
        if (i & 1) y = y["times"](x);
        i >>= 1;
        if (!i) break;
        x = x["times"](x);
    }
    return e < 0 ? $2e4f919920daf140$var$ONE["div"](y) : y;
};
/*
 * Return a BigNumber whose value is the value of this BigNumber raised to
 * the power m modulo n.
 *
 * m {BigNumber} the value to take the power of
 * n {BigNumber} the value to modulo by
 */ $2e4f919920daf140$var$P["powm"] = function(m, n) {
    return this.pow(m).mod(n);
};
/*
 * Return a new BigNumber whose value is the value of this BigNumber
 * rounded to a maximum of dp decimal places using rounding mode rm, or to
 * 0 and ROUNDING_MODE respectively if omitted.
 *
 * [dp] {number} Integer, 0 to MAX inclusive.
 * [rm] {number} Integer, 0 to 8 inclusive.
 */ $2e4f919920daf140$var$P["round"] = function(dp, rm) {
    dp = dp == null || (($2e4f919920daf140$var$outOfRange = dp < 0 || dp > $2e4f919920daf140$var$MAX) || $2e4f919920daf140$var$parse(dp) != dp) && // 'round() decimal places out of range: {dp}'
    // 'round() decimal places not an integer: {dp}'
    !$2e4f919920daf140$var$ifExceptionsThrow(dp, "decimal places", "round") ? 0 : dp | 0;
    rm = rm == null || (($2e4f919920daf140$var$outOfRange = rm < 0 || rm > 8) || // Include '&& rm !== 0' because with Opera -0 == parseFloat(-0) is false.
    $2e4f919920daf140$var$parse(rm) != rm && rm !== 0) && // 'round() mode not an integer: {rm}'
    // 'round() mode out of range: {rm}'
    !$2e4f919920daf140$var$ifExceptionsThrow(rm, "mode", "round") ? $2e4f919920daf140$var$ROUNDING_MODE : rm | 0;
    return $2e4f919920daf140$var$setMode(this, dp, rm);
};
/*
 *  sqrt(-n) =  N
 *  sqrt( N) =  N
 *  sqrt(-I) =  N
 *  sqrt( I) =  I
 *  sqrt( 0) =  0
 *  sqrt(-0) = -0
 *
 * Return a new BigNumber whose value is the square root of the value of
 * this BigNumber, rounded according to DECIMAL_PLACES and ROUNDING_MODE.
 */ $2e4f919920daf140$var$P["squareRoot"] = $2e4f919920daf140$var$P["sqrt"] = function() {
    var n, r, re, t, x = this, c = x["c"], s = x["s"], e = x["e"], dp = $2e4f919920daf140$var$DECIMAL_PLACES, rm = $2e4f919920daf140$var$ROUNDING_MODE, half = new $2e4f919920daf140$var$BigNumber("0.5");
    // Negative/NaN/Infinity/zero?
    if (s !== 1 || !c || !c[0]) return new $2e4f919920daf140$var$BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
    // Initial estimate.
    s = Math.sqrt(x["toS"]());
    $2e4f919920daf140$var$ROUNDING_MODE = 1;
    /*
      Math.sqrt underflow/overflow?
      Pass x to Math.sqrt as integer, then adjust the exponent of the result.
     */ if (s == 0 || s == 1 / 0) {
        n = c.join("");
        if (!(n.length + e & 1)) n += "0";
        r = new $2e4f919920daf140$var$BigNumber(Math.sqrt(n) + "");
        // r may still not be finite.
        if (!r["c"]) r["c"] = [
            1
        ];
        r["e"] = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
    } else r = new $2e4f919920daf140$var$BigNumber(n = s.toString());
    re = r["e"];
    s = re + ($2e4f919920daf140$var$DECIMAL_PLACES += 4);
    if (s < 3) s = 0;
    e = s;
    // Newton-Raphson iteration.
    for(;;){
        t = r;
        r = half["times"](t["plus"](x["div"](t)));
        if (t["c"].slice(0, s).join("") === r["c"].slice(0, s).join("")) {
            c = r["c"];
            /*
              The exponent of r may here be one less than the final result
              exponent (re), e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust
              s so the rounding digits are indexed correctly.
             */ s = s - (n && r["e"] < re);
            /*
              The 4th rounding digit may be in error by -1 so if the 4 rounding
              digits are 9999 or 4999 (i.e. approaching a rounding boundary)
              continue the iteration.
             */ if (c[s] == 9 && c[s - 1] == 9 && c[s - 2] == 9 && (c[s - 3] == 9 || n && c[s - 3] == 4)) {
                /*
                  If 9999 on first run through, check to see if rounding up
                  gives the exact result as the nines may infinitely repeat.
                 */ if (n && c[s - 3] == 9) {
                    t = r["round"](dp, 0);
                    if (t["times"](t)["eq"](x)) {
                        $2e4f919920daf140$var$ROUNDING_MODE = rm;
                        $2e4f919920daf140$var$DECIMAL_PLACES = dp;
                        return t;
                    }
                }
                $2e4f919920daf140$var$DECIMAL_PLACES += 4;
                s += 4;
                n = "";
            } else {
                /*
                  If the rounding digits are null, 0000 or 5000, check for an
                  exact result. If not, then there are further digits so
                  increment the 1st rounding digit to ensure correct rounding.
                 */ if (!c[e] && !c[e - 1] && !c[e - 2] && (!c[e - 3] || c[e - 3] == 5)) {
                    // Truncate to the first rounding digit.
                    if (c.length > e - 2) c.length = e - 2;
                    if (!r["times"](r)["eq"](x)) {
                        while(c.length < e - 3)c.push(0);
                        c[e - 3]++;
                    }
                }
                $2e4f919920daf140$var$ROUNDING_MODE = rm;
                $2e4f919920daf140$var$rnd(r, $2e4f919920daf140$var$DECIMAL_PLACES = dp, 10);
                return r;
            }
        }
    }
};
/*
 *  n * 0 = 0
 *  n * N = N
 *  n * I = I
 *  0 * n = 0
 *  0 * 0 = 0
 *  0 * N = N
 *  0 * I = N
 *  N * n = N
 *  N * 0 = N
 *  N * N = N
 *  N * I = N
 *  I * n = I
 *  I * 0 = N
 *  I * N = N
 *  I * I = I
 *
 * Return a new BigNumber whose value is the value of this BigNumber times
 * the value of BigNumber(y, b).
 */ $2e4f919920daf140$var$P["times"] = $2e4f919920daf140$var$P["mul"] = function(y, b) {
    var c, x = this, xc = x["c"], yc = ($2e4f919920daf140$var$id = 11, y = new $2e4f919920daf140$var$BigNumber(y, b))["c"], i = x["e"], j = y["e"], a = x["s"];
    y["s"] = a == (b = y["s"]) ? 1 : -1;
    // Either NaN/Infinity/0?
    if (!i && (!xc || !xc[0]) || !j && (!yc || !yc[0])) // Either NaN?
    return new $2e4f919920daf140$var$BigNumber(!a || !b || // x is 0 and y is Infinity  or  y is 0 and x is Infinity?
    xc && !xc[0] && !yc || yc && !yc[0] && !xc ? NaN : !xc || !yc ? y["s"] / 0 : y["s"] * 0);
    y["e"] = i + j;
    if ((a = xc.length) < (b = yc.length)) c = xc, xc = yc, yc = c, j = a, a = b, b = j;
    for(j = a + b, c = []; j--; c.push(0));
    // Multiply!
    for(i = b - 1; i > -1; i--){
        for(b = 0, j = a + i; j > i; b = c[j] + yc[i] * xc[j - i - 1] + b, c[j--] = b % 10 | 0, b = b / 10 | 0);
        if (b) c[j] = (c[j] + b) % 10;
    }
    b && ++y["e"];
    // Remove any leading zero.
    !c[0] && c.shift();
    // Remove trailing zeros.
    for(j = c.length; !c[--j]; c.pop());
    // No zero check needed as only x * 0 == 0 etc.
    // Overflow?
    y["c"] = y["e"] > $2e4f919920daf140$var$MAX_EXP ? y["e"] = null : y["e"] < $2e4f919920daf140$var$MIN_EXP ? [
        y["e"] = 0
    ] : c;
    return y;
};
/*
 * Return a buffer containing the 
 */ $2e4f919920daf140$var$P["toBuffer"] = function(opts) {
    if (typeof opts === "string") {
        if (opts !== "mpint") return "Unsupported Buffer representation";
        var abs = this.abs();
        var buf = abs.toBuffer({
            size: 1,
            endian: "big"
        });
        var len = buf.length === 1 && buf[0] === 0 ? 0 : buf.length;
        if (buf[0] & 0x80) len++;
        var ret = new $2e4f919920daf140$require$Buffer(4 + len);
        if (len > 0) buf.copy(ret, 4 + (buf[0] & 0x80 ? 1 : 0));
        if (buf[0] & 0x80) ret[4] = 0;
        ret[0] = len & -16777216;
        ret[1] = len & 16711680;
        ret[2] = len & 65280;
        ret[3] = len & 255;
        // two's compliment for negative integers:
        var isNeg = this.lt(0);
        if (isNeg) for(var i = 4; i < ret.length; i++)ret[i] = 0xff - ret[i];
        ret[4] = ret[4] & 0x7f | (isNeg ? 0x80 : 0);
        if (isNeg) ret[ret.length - 1]++;
        return ret;
    }
    if (!opts) opts = {};
    var endian = {
        1: "big",
        "-1": "little"
    }[opts.endian] || opts.endian || "big";
    var hex = this.toString(16);
    if (hex.charAt(0) === "-") throw new Error("converting negative numbers to Buffers not supported yet");
    var size = opts.size === "auto" ? Math.ceil(hex.length / 2) : opts.size || 1;
    var len = Math.ceil(hex.length / (2 * size)) * size;
    var buf = new $2e4f919920daf140$require$Buffer(len);
    // zero-pad the hex string so the chunks are all `size` long
    while(hex.length < 2 * len)hex = "0" + hex;
    var hx = hex.split(new RegExp("(.{" + 2 * size + "})")).filter(function(s) {
        return s.length > 0;
    });
    hx.forEach(function(chunk, i) {
        for(var j = 0; j < size; j++){
            var ix = i * size + (endian === "big" ? j : size - j - 1);
            buf[ix] = parseInt(chunk.slice(j * 2, j * 2 + 2), 16);
        }
    });
    return buf;
};
/*
 * Return a string representing the value of this BigNumber in exponential
 * notation to dp fixed decimal places and rounded using ROUNDING_MODE if
 * necessary.
 *
 * [dp] {number} Integer, 0 to MAX inclusive.
 */ $2e4f919920daf140$var$P["toExponential"] = $2e4f919920daf140$var$P["toE"] = function(dp) {
    return $2e4f919920daf140$var$format(this, (dp == null || (($2e4f919920daf140$var$outOfRange = dp < 0 || dp > $2e4f919920daf140$var$MAX) || /*
         * Include '&& dp !== 0' because with Opera -0 == parseFloat(-0) is
         * false, despite -0 == parseFloat('-0') && 0 == -0 being true.
         */ $2e4f919920daf140$var$parse(dp) != dp && dp !== 0) && // 'toE() decimal places not an integer: {dp}'
    // 'toE() decimal places out of range: {dp}'
    !$2e4f919920daf140$var$ifExceptionsThrow(dp, "decimal places", "toE")) && this["c"] ? this["c"].length - 1 : dp | 0, 1);
};
/*
 * Return a string representing the value of this BigNumber in normal
 * notation to dp fixed decimal places and rounded using ROUNDING_MODE if
 * necessary.
 *
 * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
 * but e.g. (-0.00001).toFixed(0) is '-0'.
 *
 * [dp] {number} Integer, 0 to MAX inclusive.
 */ $2e4f919920daf140$var$P["toFixed"] = $2e4f919920daf140$var$P["toF"] = function(dp) {
    var n, str, d, x = this;
    if (!(dp == null || (($2e4f919920daf140$var$outOfRange = dp < 0 || dp > $2e4f919920daf140$var$MAX) || $2e4f919920daf140$var$parse(dp) != dp && dp !== 0) && // 'toF() decimal places not an integer: {dp}'
    // 'toF() decimal places out of range: {dp}'
    !$2e4f919920daf140$var$ifExceptionsThrow(dp, "decimal places", "toF"))) d = x["e"] + (dp | 0);
    n = $2e4f919920daf140$var$TO_EXP_NEG, dp = $2e4f919920daf140$var$TO_EXP_POS;
    $2e4f919920daf140$var$TO_EXP_NEG = -($2e4f919920daf140$var$TO_EXP_POS = 1 / 0);
    // Note: str is initially undefined.
    if (d == str) str = x["toS"]();
    else {
        str = $2e4f919920daf140$var$format(x, d);
        // (-0).toFixed() is '0', but (-0.1).toFixed() is '-0'.
        // (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
        if (x["s"] < 0 && x["c"]) {
            // As e.g. -0 toFixed(3), will wrongly be returned as -0.000 from toString.
            if (!x["c"][0]) str = str.replace(/^-/, "");
            else if (str.indexOf("-") < 0) str = "-" + str;
        }
    }
    $2e4f919920daf140$var$TO_EXP_NEG = n, $2e4f919920daf140$var$TO_EXP_POS = dp;
    return str;
};
/*
 * Return a string array representing the value of this BigNumber as a
 * simple fraction with an integer numerator and an integer denominator.
 * The denominator will be a positive non-zero value less than or equal to
 * the specified maximum denominator. If a maximum denominator is not
 * specified, the denominator will be the lowest value necessary to
 * represent the number exactly.
 *
 * [maxD] {number|string|BigNumber} Integer >= 1 and < Infinity.
 */ $2e4f919920daf140$var$P["toFraction"] = $2e4f919920daf140$var$P["toFr"] = function(maxD) {
    var q, frac, n0, d0, d2, n, e, n1 = d0 = new $2e4f919920daf140$var$BigNumber($2e4f919920daf140$var$ONE), d1 = n0 = new $2e4f919920daf140$var$BigNumber("0"), x = this, xc = x["c"], exp = $2e4f919920daf140$var$MAX_EXP, dp = $2e4f919920daf140$var$DECIMAL_PLACES, rm = $2e4f919920daf140$var$ROUNDING_MODE, d = new $2e4f919920daf140$var$BigNumber($2e4f919920daf140$var$ONE);
    // NaN, Infinity.
    if (!xc) return x["toS"]();
    e = d["e"] = xc.length - x["e"] - 1;
    // If max denominator is undefined or null...
    if (maxD == null || // or NaN...
    (!($2e4f919920daf140$var$id = 12, n = new $2e4f919920daf140$var$BigNumber(maxD))["s"] || // or less than 1, or Infinity...
    ($2e4f919920daf140$var$outOfRange = n["cmp"](n1) < 0 || !n["c"]) || // or not an integer...
    $2e4f919920daf140$var$ERRORS && n["e"] < n["c"].length - 1) && // 'toFr() max denominator not an integer: {maxD}'
    // 'toFr() max denominator out of range: {maxD}'
    !$2e4f919920daf140$var$ifExceptionsThrow(maxD, "max denominator", "toFr") || // or greater than the maxD needed to specify the value exactly...
    (maxD = n)["cmp"](d) > 0) // d is e.g. 10, 100, 1000, 10000... , n1 is 1.
    maxD = e > 0 ? d : n1;
    $2e4f919920daf140$var$MAX_EXP = 1 / 0;
    n = new $2e4f919920daf140$var$BigNumber(xc.join(""));
    for($2e4f919920daf140$var$DECIMAL_PLACES = 0, $2e4f919920daf140$var$ROUNDING_MODE = 1;;){
        q = n["div"](d);
        d2 = d0["plus"](q["times"](d1));
        if (d2["cmp"](maxD) == 1) break;
        d0 = d1, d1 = d2;
        n1 = n0["plus"](q["times"](d2 = n1));
        n0 = d2;
        d = n["minus"](q["times"](d2 = d));
        n = d2;
    }
    d2 = maxD["minus"](d0)["div"](d1);
    n0 = n0["plus"](d2["times"](n1));
    d0 = d0["plus"](d2["times"](d1));
    n0["s"] = n1["s"] = x["s"];
    $2e4f919920daf140$var$DECIMAL_PLACES = e * 2;
    $2e4f919920daf140$var$ROUNDING_MODE = rm;
    // Determine which fraction is closer to x, n0 / d0 or n1 / d1?
    frac = n1["div"](d1)["minus"](x)["abs"]()["cmp"](n0["div"](d0)["minus"](x)["abs"]()) < 1 ? [
        n1["toS"](),
        d1["toS"]()
    ] : [
        n0["toS"](),
        d0["toS"]()
    ];
    return $2e4f919920daf140$var$MAX_EXP = exp, $2e4f919920daf140$var$DECIMAL_PLACES = dp, frac;
};
/*
 * Return a string representing the value of this BigNumber to sd significant
 * digits and rounded using ROUNDING_MODE if necessary.
 * If sd is less than the number of digits necessary to represent the integer
 * part of the value in normal notation, then use exponential notation.
 *
 * sd {number} Integer, 1 to MAX inclusive.
 */ $2e4f919920daf140$var$P["toPrecision"] = $2e4f919920daf140$var$P["toP"] = function(sd) {
    /*
     * ERRORS true: Throw if sd not undefined, null or an integer in range.
     * ERRORS false: Ignore sd if not a number or not in range.
     * Truncate non-integers.
     */ return sd == null || (($2e4f919920daf140$var$outOfRange = sd < 1 || sd > $2e4f919920daf140$var$MAX) || $2e4f919920daf140$var$parse(sd) != sd) && // 'toP() precision not an integer: {sd}'
    // 'toP() precision out of range: {sd}'
    !$2e4f919920daf140$var$ifExceptionsThrow(sd, "precision", "toP") ? this["toS"]() : $2e4f919920daf140$var$format(this, --sd | 0, 2);
};
/*
 * Return a string representing the value of this BigNumber in base b, or
 * base 10 if b is omitted. If a base is specified, including base 10,
 * round according to DECIMAL_PLACES and ROUNDING_MODE.
 * If a base is not specified, and this BigNumber has a positive exponent
 * that is equal to or greater than TO_EXP_POS, or a negative exponent equal
 * to or less than TO_EXP_NEG, return exponential notation.
 *
 * [b] {number} Integer, 2 to 64 inclusive.
 */ $2e4f919920daf140$var$P["toString"] = $2e4f919920daf140$var$P["toS"] = function(b) {
    var u, str, strL, x = this, xe = x["e"];
    // Infinity or NaN?
    if (xe === null) str = x["s"] ? "Infinity" : "NaN";
    else if (b === u && (xe <= $2e4f919920daf140$var$TO_EXP_NEG || xe >= $2e4f919920daf140$var$TO_EXP_POS)) return $2e4f919920daf140$var$format(x, x["c"].length - 1, 1);
    else {
        str = x["c"].join("");
        // Negative exponent?
        if (xe < 0) {
            // Prepend zeros.
            for(; ++xe; str = "0" + str);
            str = "0." + str;
        // Positive exponent?
        } else if (strL = str.length, xe > 0) {
            if (++xe > strL) {
                // Append zeros.
                for(xe -= strL; xe--; str += "0");
            } else if (xe < strL) str = str.slice(0, xe) + "." + str.slice(xe);
        // Exponent zero.
        } else {
            if (u = str.charAt(0), strL > 1) str = u + "." + str.slice(1);
            else if (u == "0") return u;
        }
        if (b != null) {
            if (!($2e4f919920daf140$var$outOfRange = !(b >= 2 && b < 65)) && (b == (b | 0) || !$2e4f919920daf140$var$ERRORS)) {
                str = $2e4f919920daf140$var$convert(str, b | 0, 10, x["s"]);
                // Avoid '-0'
                if (str == "0") return str;
            } else // 'toS() base not an integer: {b}'
            // 'toS() base out of range: {b}'
            $2e4f919920daf140$var$ifExceptionsThrow(b, "base", "toS");
        }
    }
    return x["s"] < 0 ? "-" + str : str;
};
/*
 * Return as toString, but do not accept a base argument.
 */ $2e4f919920daf140$var$P["valueOf"] = function() {
    return this["toS"]();
};
// Add aliases for BigDecimal methods.
//P['add'] = P['plus'];
//P['subtract'] = P['minus'];
//P['multiply'] = P['times'];
//P['divide'] = P['div'];
//P['remainder'] = P['mod'];
//P['compareTo'] = P['cmp'];
//P['negate'] = P['neg'];
// EXPORT
$2e4f919920daf140$exports = $2e4f919920daf140$var$BigNumber;


function $58fab9ded43a18f7$var$numberToHex(number, length) {
    var hex = number.toString(16);
    if (hex.length % 2 === 1) hex = "0" + hex;
    return hex.padStart(length, "0");
}
function $58fab9ded43a18f7$var$isHexChar(c) {
    if (c >= "A" && c <= "F" || c >= "a" && c <= "f" || c >= "0" && c <= "9") return 1;
    return 0;
}
/* Convert a hex char to value */ function $58fab9ded43a18f7$var$hexChar2byte(c) {
    var d = 0;
    if (c >= "A" && c <= "F") d = c.charCodeAt(0) - "A".charCodeAt(0) + 10;
    else if (c >= "a" && c <= "f") d = c.charCodeAt(0) - "a".charCodeAt(0) + 10;
    else if (c >= "0" && c <= "9") d = c.charCodeAt(0) - "0".charCodeAt(0);
    return d;
}
/* Convert a byte to string */ function $58fab9ded43a18f7$var$byte2hexStr(byte) {
    var hexByteMap = "0123456789ABCDEF";
    var str = "";
    str += hexByteMap.charAt(byte >> 4);
    str += hexByteMap.charAt(byte & 0x0f);
    return str;
}
function $58fab9ded43a18f7$var$byteArray2hexStr(byteArray) {
    var str = "";
    for(var i = 0; i < byteArray.length - 1; i++)str += $58fab9ded43a18f7$var$byte2hexStr(byteArray[i]);
    str += $58fab9ded43a18f7$var$byte2hexStr(byteArray[i]);
    return str;
}
function $58fab9ded43a18f7$var$hexStr2byteArray(str) {
    var byteArray = Array();
    var d = 0;
    var i = 0;
    var j = 0;
    var k = 0;
    for(i = 0; i < str.length; i++){
        var c = str.charAt(i);
        if ($58fab9ded43a18f7$var$isHexChar(c)) {
            d <<= 4;
            d += $58fab9ded43a18f7$var$hexChar2byte(c);
            j++;
            if (0 === j % 2) {
                byteArray[k++] = d;
                d = 0;
            }
        }
    }
    return byteArray;
}
$58fab9ded43a18f7$exports = {
    numberToHex: $58fab9ded43a18f7$var$numberToHex,
    toHex: function(arrayOfBytes) {
        var hex = "";
        for(var i = 0; i < arrayOfBytes.length; i++)hex += $58fab9ded43a18f7$var$numberToHex(arrayOfBytes[i]);
        return hex;
    },
    sha256: function(payload, format = "HEX") {
        var sha = new $h8F4l("SHA-256", format);
        sha.update(payload);
        return sha.getHash(format);
    },
    sha256x2: function(buffer, format = "HEX") {
        return this.sha256(this.sha256(buffer, format), format);
    },
    sha256Checksum: function(payload) {
        return this.sha256(this.sha256(payload)).substr(0, 8);
    },
    sha512_256: function(payload, format = "HEX") {
        const hash = $58fab9ded43a18f7$require$sha512256.create();
        hash.update($58fab9ded43a18f7$require$Buffer.from(payload, format));
        return hash.hex().toUpperCase();
    },
    blake256: function(hexString) {
        return new $c985bd2c80ab4d8e$exports().update(hexString, "hex").digest("hex");
    },
    blake256Checksum: function(payload) {
        return this.blake256(this.blake256(payload)).substr(0, 8);
    },
    blake2b: function(hexString, outlen) {
        return new $a22620d818e7325b$exports(outlen).update($58fab9ded43a18f7$require$Buffer.from(hexString, "hex")).digest("hex");
    },
    keccak256: function(hexString) {
        return $58fab9ded43a18f7$var$keccak256(hexString);
    },
    keccak256Checksum: function(payload) {
        return $58fab9ded43a18f7$var$keccak256(payload).toString().substr(0, 8);
    },
    blake2b256: function(hexString) {
        return new $a22620d818e7325b$exports(32).update($58fab9ded43a18f7$require$Buffer.from(hexString, "hex"), 32).digest("hex");
    },
    base58: $8560caef586a2c5f$exports.decode,
    byteArray2hexStr: $58fab9ded43a18f7$var$byteArray2hexStr,
    hexStr2byteArray: $58fab9ded43a18f7$var$hexStr2byteArray,
    bigNumberToBuffer: function(bignumber, size) {
        return new $2e4f919920daf140$exports(bignumber).toBuffer({
            size: size,
            endian: "big"
        });
    },
    base32: $2097381b44c604d9$exports
};


var $4f801e3572f21127$exports = {};
"use strict";

var $dqH3B = parcelRequire("dqH3B");
var $4f801e3572f21127$require$_Buffer = $dqH3B.Buffer;
function $4f801e3572f21127$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $4f801e3572f21127$require$_Buffer.from(source);
        if (!$4f801e3572f21127$require$_Buffer.isBuffer(source)) throw new TypeError("Expected Buffer");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return $4f801e3572f21127$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $4f801e3572f21127$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
$4f801e3572f21127$exports = $4f801e3572f21127$var$base;


var $7f670113ed8e5f5d$var$ALLOWED_CHARS = "rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz";
var $7f670113ed8e5f5d$var$codec = $4f801e3572f21127$exports($7f670113ed8e5f5d$var$ALLOWED_CHARS);
var $7f670113ed8e5f5d$var$regexp = new RegExp("^r[" + $7f670113ed8e5f5d$var$ALLOWED_CHARS + "]{27,35}$");
$7f670113ed8e5f5d$exports = {
    /**
     * ripple address validation
     */ isValidAddress: function(address) {
        if ($7f670113ed8e5f5d$var$regexp.test(address)) return this.verifyChecksum(address);
        return false;
    },
    verifyChecksum: function(address) {
        var bytes = $7f670113ed8e5f5d$var$codec.decode(address);
        var computedChecksum = $58fab9ded43a18f7$exports.sha256Checksum($58fab9ded43a18f7$exports.toHex(bytes.slice(0, -4)));
        var checksum = $58fab9ded43a18f7$exports.toHex(bytes.slice(-4));
        return computedChecksum === checksum;
    }
};


var $a0584d44d5748453$exports = {};

$a0584d44d5748453$exports = {
    isValidAddress: function(address) {
        if (!/^0x[0-9a-fA-F]{40}$/.test(address)) // Check if it has the basic requirements of an address
        return false;
        if (/^0x[0-9a-f]{40}$/.test(address) || /^0x?[0-9A-F]{40}$/.test(address)) // If it's all small caps or all all caps, return true
        return true;
        // Otherwise check each case
        return this.verifyChecksum(address);
    },
    verifyChecksum: function(address) {
        // Check each case
        address = address.replace("0x", "");
        var addressHash = $58fab9ded43a18f7$exports.keccak256(address.toLowerCase());
        for(var i = 0; i < 40; i++){
            // The nth letter should be uppercase if the nth digit of casemap is 1
            if (parseInt(addressHash[i], 16) > 7 && address[i].toUpperCase() !== address[i] || parseInt(addressHash[i], 16) <= 7 && address[i].toLowerCase() !== address[i]) return false;
        }
        return true;
    }
};


var $d7830e5c3dae45dc$exports = {};

var $lewJ9 = parcelRequire("lewJ9");
var $d7830e5c3dae45dc$require$Buffer = $lewJ9.Buffer;

var $af09192fdcf07e85$exports = {};
// Copyright (c) 2017, 2021 Pieter Wuille
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
var $3c2eebea5d8da41b$exports = {};
// Copyright (c) 2017, 2021 Pieter Wuille
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
var $3c2eebea5d8da41b$var$CHARSET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
var $3c2eebea5d8da41b$var$GENERATOR = [
    0x3b6a57b2,
    0x26508e6d,
    0x1ea119fa,
    0x3d4233dd,
    0x2a1462b3
];
const $3c2eebea5d8da41b$var$encodings = {
    BECH32: "bech32",
    BECH32M: "bech32m"
};
$3c2eebea5d8da41b$exports = {
    decode: $3c2eebea5d8da41b$var$decode,
    encode: $3c2eebea5d8da41b$var$encode,
    encodings: $3c2eebea5d8da41b$var$encodings,
    verifyChecksum: $3c2eebea5d8da41b$var$verifyChecksum
};
function $3c2eebea5d8da41b$var$getEncodingConst(enc) {
    if (enc == $3c2eebea5d8da41b$var$encodings.BECH32) return 1;
    else if (enc == $3c2eebea5d8da41b$var$encodings.BECH32M) return 0x2bc830a3;
    else return null;
}
function $3c2eebea5d8da41b$var$polymod(values) {
    var chk = 1;
    for(var p = 0; p < values.length; ++p){
        var top = chk >> 25;
        chk = (chk & 0x1ffffff) << 5 ^ values[p];
        for(var i = 0; i < 5; ++i)if (top >> i & 1) chk ^= $3c2eebea5d8da41b$var$GENERATOR[i];
    }
    return chk;
}
function $3c2eebea5d8da41b$var$hrpExpand(hrp) {
    var ret = [];
    var p;
    for(p = 0; p < hrp.length; ++p)ret.push(hrp.charCodeAt(p) >> 5);
    ret.push(0);
    for(p = 0; p < hrp.length; ++p)ret.push(hrp.charCodeAt(p) & 31);
    return ret;
}
function $3c2eebea5d8da41b$var$verifyChecksum(hrp, data, enc) {
    return $3c2eebea5d8da41b$var$polymod($3c2eebea5d8da41b$var$hrpExpand(hrp).concat(data)) === $3c2eebea5d8da41b$var$getEncodingConst(enc);
}
function $3c2eebea5d8da41b$var$createChecksum(hrp, data, enc) {
    var values = $3c2eebea5d8da41b$var$hrpExpand(hrp).concat(data).concat([
        0,
        0,
        0,
        0,
        0,
        0
    ]);
    var mod = $3c2eebea5d8da41b$var$polymod(values) ^ $3c2eebea5d8da41b$var$getEncodingConst(enc);
    var ret = [];
    for(var p = 0; p < 6; ++p)ret.push(mod >> 5 * (5 - p) & 31);
    return ret;
}
function $3c2eebea5d8da41b$var$encode(hrp, data, enc) {
    var combined = data.concat($3c2eebea5d8da41b$var$createChecksum(hrp, data, enc));
    var ret = hrp + "1";
    for(var p = 0; p < combined.length; ++p)ret += $3c2eebea5d8da41b$var$CHARSET.charAt(combined[p]);
    return ret;
}
function $3c2eebea5d8da41b$var$decode(bechString, enc) {
    var p;
    var has_lower = false;
    var has_upper = false;
    for(p = 0; p < bechString.length; ++p){
        if (bechString.charCodeAt(p) < 33 || bechString.charCodeAt(p) > 126) return null;
        if (bechString.charCodeAt(p) >= 97 && bechString.charCodeAt(p) <= 122) has_lower = true;
        if (bechString.charCodeAt(p) >= 65 && bechString.charCodeAt(p) <= 90) has_upper = true;
    }
    if (has_lower && has_upper) return null;
    bechString = bechString.toLowerCase();
    var pos = bechString.lastIndexOf("1");
    if (pos < 1 || pos + 7 > bechString.length || bechString.length > 110) return null;
    var hrp = bechString.substring(0, pos);
    var data = [];
    for(p = pos + 1; p < bechString.length; ++p){
        var d = $3c2eebea5d8da41b$var$CHARSET.indexOf(bechString.charAt(p));
        if (d === -1) return null;
        data.push(d);
    }
    if (!$3c2eebea5d8da41b$var$verifyChecksum(hrp, data, enc)) return null;
    return {
        hrp: hrp,
        data: data.slice(0, data.length - 6)
    };
}


function $af09192fdcf07e85$var$convertbits(data, frombits, tobits, pad) {
    var acc = 0;
    var bits = 0;
    var ret = [];
    var maxv = (1 << tobits) - 1;
    for(var p = 0; p < data.length; ++p){
        var value = data[p];
        if (value < 0 || value >> frombits !== 0) return null;
        acc = acc << frombits | value;
        bits += frombits;
        while(bits >= tobits){
            bits -= tobits;
            ret.push(acc >> bits & maxv);
        }
    }
    if (pad) {
        if (bits > 0) ret.push(acc << tobits - bits & maxv);
    } else if (bits >= frombits || acc << tobits - bits & maxv) return null;
    return ret;
}
function $af09192fdcf07e85$var$decode(hrp, addr) {
    var bech32m = false;
    var dec = $3c2eebea5d8da41b$exports.decode(addr, $3c2eebea5d8da41b$exports.encodings.BECH32);
    if (dec === null) {
        dec = $3c2eebea5d8da41b$exports.decode(addr, $3c2eebea5d8da41b$exports.encodings.BECH32M);
        bech32m = true;
    }
    if (dec === null || dec.hrp !== hrp || dec.data.length < 1 || dec.data[0] > 16) return null;
    var res = $af09192fdcf07e85$var$convertbits(dec.data.slice(1), 5, 8, false);
    if (res === null || res.length < 2 || res.length > 40) return null;
    if (dec.data[0] === 0 && res.length !== 20 && res.length !== 32) return null;
    if (dec.data[0] === 0 && bech32m) return null;
    if (dec.data[0] !== 0 && !bech32m) return null;
    return {
        version: dec.data[0],
        program: res
    };
}
function $af09192fdcf07e85$var$encode(hrp, version, program) {
    var enc = $3c2eebea5d8da41b$exports.encodings.BECH32;
    if (version > 0) enc = $3c2eebea5d8da41b$exports.encodings.BECH32M;
    var ret = $3c2eebea5d8da41b$exports.encode(hrp, [
        version
    ].concat($af09192fdcf07e85$var$convertbits(program, 8, 5, true)), enc);
    if ($af09192fdcf07e85$var$decode(hrp, ret, enc) === null) return null;
    return ret;
}
/////////////////////////////////////////////////////
var $af09192fdcf07e85$var$DEFAULT_NETWORK_TYPE = "prod";
function $af09192fdcf07e85$var$isValidAddress(address, currency, opts = {}) {
    if (!currency.bech32Hrp || currency.bech32Hrp.length === 0) return false;
    const { networkType: networkType = $af09192fdcf07e85$var$DEFAULT_NETWORK_TYPE } = opts;
    var correctBech32Hrps;
    if (networkType === "prod" || networkType === "testnet") correctBech32Hrps = currency.bech32Hrp[networkType];
    else if (currency.bech32Hrp) correctBech32Hrps = currency.bech32Hrp.prod.concat(currency.bech32Hrp.testnet);
    else return false;
    for (var chrp of correctBech32Hrps){
        var ret = $af09192fdcf07e85$var$decode(chrp, address);
        if (ret) return $af09192fdcf07e85$var$encode(chrp, ret.version, ret.program) === address.toLowerCase();
    }
    return false;
}
$af09192fdcf07e85$exports = {
    encode: $af09192fdcf07e85$var$encode,
    decode: $af09192fdcf07e85$var$decode,
    isValidAddress: $af09192fdcf07e85$var$isValidAddress
};



var $d7830e5c3dae45dc$var$DEFAULT_NETWORK_TYPE = "prod";
function $d7830e5c3dae45dc$var$getDecoded(address) {
    try {
        return $8560caef586a2c5f$exports.decode(address);
    } catch (e) {
        // if decoding fails, assume invalid address
        return null;
    }
}
function $d7830e5c3dae45dc$var$getChecksum(hashFunction, payload) {
    // Each currency may implement different hashing algorithm
    switch(hashFunction){
        // blake then keccak hash chain
        case "blake256keccak256":
            var blake = $58fab9ded43a18f7$exports.blake2b256(payload);
            return $58fab9ded43a18f7$exports.keccak256Checksum($d7830e5c3dae45dc$require$Buffer.from(blake, "hex"));
        case "blake256":
            return $58fab9ded43a18f7$exports.blake256Checksum(payload);
        case "keccak256":
            return $58fab9ded43a18f7$exports.keccak256Checksum(payload);
        case "sha256":
        default:
            return $58fab9ded43a18f7$exports.sha256Checksum(payload);
    }
}
function $d7830e5c3dae45dc$var$getAddressType(address, currency) {
    currency = currency || {};
    // should be 25 bytes per btc address spec and 26 decred
    var expectedLength = currency.expectedLength || 25;
    var hashFunction = currency.hashFunction || "sha256";
    var decoded = $d7830e5c3dae45dc$var$getDecoded(address);
    if (decoded) {
        var length = decoded.length;
        if (length !== expectedLength) return null;
        if (currency.regex) {
            if (!currency.regex.test(address)) return false;
        }
        var checksum = $58fab9ded43a18f7$exports.toHex(decoded.slice(length - 4, length)), body = $58fab9ded43a18f7$exports.toHex(decoded.slice(0, length - 4)), goodChecksum = $d7830e5c3dae45dc$var$getChecksum(hashFunction, body);
        return checksum === goodChecksum ? $58fab9ded43a18f7$exports.toHex(decoded.slice(0, expectedLength - 24)) : null;
    }
    return null;
}
function $d7830e5c3dae45dc$var$isValidP2PKHandP2SHAddress(address, currency, opts) {
    const { networkType: networkType = $d7830e5c3dae45dc$var$DEFAULT_NETWORK_TYPE } = opts;
    var correctAddressTypes;
    var addressType = $d7830e5c3dae45dc$var$getAddressType(address, currency);
    if (addressType) {
        if (networkType === "prod" || networkType === "testnet") correctAddressTypes = currency.addressTypes[networkType];
        else if (currency.addressTypes) correctAddressTypes = currency.addressTypes.prod.concat(currency.addressTypes.testnet);
        else return false;
        return correctAddressTypes.indexOf(addressType) >= 0;
    }
    return false;
}
$d7830e5c3dae45dc$exports = {
    isValidAddress: function(address, currency, opts = {}) {
        return $d7830e5c3dae45dc$var$isValidP2PKHandP2SHAddress(address, currency, opts) || $af09192fdcf07e85$exports.isValidAddress(address, currency, opts);
    }
};


var $afee0a8b798c70de$exports = {};
var $1e0d9cd559aaa21d$exports = {};
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Patrick Gansterer <paroga@paroga.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ (function(global, undefined) {
    "use strict";
    var POW_2_24 = Math.pow(2, -24), POW_2_32 = Math.pow(2, 32), POW_2_53 = Math.pow(2, 53);
    function encode(value) {
        var data = new ArrayBuffer(256);
        var dataView = new DataView(data);
        var lastLength;
        var offset = 0;
        function ensureSpace(length) {
            var newByteLength = data.byteLength;
            var requiredLength = offset + length;
            while(newByteLength < requiredLength)newByteLength *= 2;
            if (newByteLength !== data.byteLength) {
                var oldDataView = dataView;
                data = new ArrayBuffer(newByteLength);
                dataView = new DataView(data);
                var uint32count = offset + 3 >> 2;
                for(var i = 0; i < uint32count; ++i)dataView.setUint32(i * 4, oldDataView.getUint32(i * 4));
            }
            lastLength = length;
            return dataView;
        }
        function write() {
            offset += lastLength;
        }
        function writeFloat64(value) {
            write(ensureSpace(8).setFloat64(offset, value));
        }
        function writeUint8(value) {
            write(ensureSpace(1).setUint8(offset, value));
        }
        function writeUint8Array(value) {
            var dataView = ensureSpace(value.length);
            for(var i = 0; i < value.length; ++i)dataView.setUint8(offset + i, value[i]);
            write();
        }
        function writeUint16(value) {
            write(ensureSpace(2).setUint16(offset, value));
        }
        function writeUint32(value) {
            write(ensureSpace(4).setUint32(offset, value));
        }
        function writeUint64(value) {
            var low = value % POW_2_32;
            var high = (value - low) / POW_2_32;
            var dataView = ensureSpace(8);
            dataView.setUint32(offset, high);
            dataView.setUint32(offset + 4, low);
            write();
        }
        function writeTypeAndLength(type, length) {
            if (length < 24) writeUint8(type << 5 | length);
            else if (length < 0x100) {
                writeUint8(type << 5 | 24);
                writeUint8(length);
            } else if (length < 0x10000) {
                writeUint8(type << 5 | 25);
                writeUint16(length);
            } else if (length < 0x100000000) {
                writeUint8(type << 5 | 26);
                writeUint32(length);
            } else {
                writeUint8(type << 5 | 27);
                writeUint64(length);
            }
        }
        function encodeItem(value) {
            var i;
            if (value === false) return writeUint8(0xf4);
            if (value === true) return writeUint8(0xf5);
            if (value === null) return writeUint8(0xf6);
            if (value === undefined) return writeUint8(0xf7);
            switch(typeof value){
                case "number":
                    if (Math.floor(value) === value) {
                        if (0 <= value && value <= POW_2_53) return writeTypeAndLength(0, value);
                        if (-POW_2_53 <= value && value < 0) return writeTypeAndLength(1, -(value + 1));
                    }
                    writeUint8(0xfb);
                    return writeFloat64(value);
                case "string":
                    var utf8data = [];
                    for(i = 0; i < value.length; ++i){
                        var charCode = value.charCodeAt(i);
                        if (charCode < 0x80) utf8data.push(charCode);
                        else if (charCode < 0x800) {
                            utf8data.push(0xc0 | charCode >> 6);
                            utf8data.push(0x80 | charCode & 0x3f);
                        } else if (charCode < 0xd800) {
                            utf8data.push(0xe0 | charCode >> 12);
                            utf8data.push(0x80 | charCode >> 6 & 0x3f);
                            utf8data.push(0x80 | charCode & 0x3f);
                        } else {
                            charCode = (charCode & 0x3ff) << 10;
                            charCode |= value.charCodeAt(++i) & 0x3ff;
                            charCode += 0x10000;
                            utf8data.push(0xf0 | charCode >> 18);
                            utf8data.push(0x80 | charCode >> 12 & 0x3f);
                            utf8data.push(0x80 | charCode >> 6 & 0x3f);
                            utf8data.push(0x80 | charCode & 0x3f);
                        }
                    }
                    writeTypeAndLength(3, utf8data.length);
                    return writeUint8Array(utf8data);
                default:
                    var length;
                    if (Array.isArray(value)) {
                        length = value.length;
                        writeTypeAndLength(4, length);
                        for(i = 0; i < length; ++i)encodeItem(value[i]);
                    } else if (value instanceof Uint8Array) {
                        writeTypeAndLength(2, value.length);
                        writeUint8Array(value);
                    } else {
                        var keys = Object.keys(value);
                        length = keys.length;
                        writeTypeAndLength(5, length);
                        for(i = 0; i < length; ++i){
                            var key = keys[i];
                            encodeItem(key);
                            encodeItem(value[key]);
                        }
                    }
            }
        }
        encodeItem(value);
        if ("slice" in data) return data.slice(0, offset);
        var ret = new ArrayBuffer(offset);
        var retView = new DataView(ret);
        for(var i = 0; i < offset; ++i)retView.setUint8(i, dataView.getUint8(i));
        return ret;
    }
    function decode(data, tagger, simpleValue) {
        var dataView = new DataView(data);
        var offset = 0;
        if (typeof tagger !== "function") tagger = function(value) {
            return value;
        };
        if (typeof simpleValue !== "function") simpleValue = function() {
            return undefined;
        };
        function read(value, length) {
            offset += length;
            return value;
        }
        function readArrayBuffer(length) {
            return read(new Uint8Array(data, offset, length), length);
        }
        function readFloat16() {
            var tempArrayBuffer = new ArrayBuffer(4);
            var tempDataView = new DataView(tempArrayBuffer);
            var value = readUint16();
            var sign = value & 0x8000;
            var exponent = value & 0x7c00;
            var fraction = value & 0x03ff;
            if (exponent === 0x7c00) exponent = 261120;
            else if (exponent !== 0) exponent += 114688;
            else if (fraction !== 0) return fraction * POW_2_24;
            tempDataView.setUint32(0, sign << 16 | exponent << 13 | fraction << 13);
            return tempDataView.getFloat32(0);
        }
        function readFloat32() {
            return read(dataView.getFloat32(offset), 4);
        }
        function readFloat64() {
            return read(dataView.getFloat64(offset), 8);
        }
        function readUint8() {
            return read(dataView.getUint8(offset), 1);
        }
        function readUint16() {
            return read(dataView.getUint16(offset), 2);
        }
        function readUint32() {
            return read(dataView.getUint32(offset), 4);
        }
        function readUint64() {
            return readUint32() * POW_2_32 + readUint32();
        }
        function readBreak() {
            if (dataView.getUint8(offset) !== 0xff) return false;
            offset += 1;
            return true;
        }
        function readLength(additionalInformation) {
            if (additionalInformation < 24) return additionalInformation;
            if (additionalInformation === 24) return readUint8();
            if (additionalInformation === 25) return readUint16();
            if (additionalInformation === 26) return readUint32();
            if (additionalInformation === 27) return readUint64();
            if (additionalInformation === 31) return -1;
            throw "Invalid length encoding";
        }
        function readIndefiniteStringLength(majorType) {
            var initialByte = readUint8();
            if (initialByte === 0xff) return -1;
            var length = readLength(initialByte & 0x1f);
            if (length < 0 || initialByte >> 5 !== majorType) throw "Invalid indefinite length element";
            return length;
        }
        function appendUtf16data(utf16data, length) {
            for(var i = 0; i < length; ++i){
                var value = readUint8();
                if (value & 0x80) {
                    if (value < 0xe0) {
                        value = (value & 0x1f) << 6 | readUint8() & 0x3f;
                        length -= 1;
                    } else if (value < 0xf0) {
                        value = (value & 0x0f) << 12 | (readUint8() & 0x3f) << 6 | readUint8() & 0x3f;
                        length -= 2;
                    } else {
                        value = (value & 0x0f) << 18 | (readUint8() & 0x3f) << 12 | (readUint8() & 0x3f) << 6 | readUint8() & 0x3f;
                        length -= 3;
                    }
                }
                if (value < 0x10000) utf16data.push(value);
                else {
                    value -= 0x10000;
                    utf16data.push(0xd800 | value >> 10);
                    utf16data.push(0xdc00 | value & 0x3ff);
                }
            }
        }
        function decodeItem() {
            var initialByte = readUint8();
            var majorType = initialByte >> 5;
            var additionalInformation = initialByte & 0x1f;
            var i;
            var length;
            if (majorType === 7) switch(additionalInformation){
                case 25:
                    return readFloat16();
                case 26:
                    return readFloat32();
                case 27:
                    return readFloat64();
            }
            length = readLength(additionalInformation);
            if (length < 0 && (majorType < 2 || 6 < majorType)) throw "Invalid length";
            switch(majorType){
                case 0:
                    return length;
                case 1:
                    return -1 - length;
                case 2:
                    if (length < 0) {
                        var elements = [];
                        var fullArrayLength = 0;
                        while((length = readIndefiniteStringLength(majorType)) >= 0){
                            fullArrayLength += length;
                            elements.push(readArrayBuffer(length));
                        }
                        var fullArray = new Uint8Array(fullArrayLength);
                        var fullArrayOffset = 0;
                        for(i = 0; i < elements.length; ++i){
                            fullArray.set(elements[i], fullArrayOffset);
                            fullArrayOffset += elements[i].length;
                        }
                        return fullArray;
                    }
                    return readArrayBuffer(length);
                case 3:
                    var utf16data = [];
                    if (length < 0) while((length = readIndefiniteStringLength(majorType)) >= 0)appendUtf16data(utf16data, length);
                    else appendUtf16data(utf16data, length);
                    return String.fromCharCode.apply(null, utf16data);
                case 4:
                    var retArray;
                    if (length < 0) {
                        retArray = [];
                        while(!readBreak())retArray.push(decodeItem());
                    } else {
                        retArray = new Array(length);
                        for(i = 0; i < length; ++i)retArray[i] = decodeItem();
                    }
                    return retArray;
                case 5:
                    var retObject = {};
                    for(i = 0; i < length || length < 0 && !readBreak(); ++i){
                        var key = decodeItem();
                        retObject[key] = decodeItem();
                    }
                    return retObject;
                case 6:
                    return tagger(decodeItem(), length);
                case 7:
                    switch(length){
                        case 20:
                            return false;
                        case 21:
                            return true;
                        case 22:
                            return null;
                        case 23:
                            return undefined;
                        default:
                            return simpleValue(length);
                    }
            }
        }
        var ret = decodeItem();
        if (offset !== data.byteLength) throw "Remaining bytes";
        return ret;
    }
    var obj = {
        encode: encode,
        decode: decode
    };
    if (typeof define === "function" && define.amd) define("cbor/cbor", obj);
    else if (0, $1e0d9cd559aaa21d$exports) $1e0d9cd559aaa21d$exports = obj;
    else if (!global.CBOR) global.CBOR = obj;
})($1e0d9cd559aaa21d$exports);


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $919af1d2850606eb$export$a143d493d941bafc;
var $919af1d2850606eb$export$e4cf37d7f6fb9e0a;
var $919af1d2850606eb$export$f99ded8fe4b79145;
var $919af1d2850606eb$export$599f31c3813fae4d;
"use strict";

var $gKBU6 = parcelRequire("gKBU6");

var $OUdei = parcelRequire("OUdei");
var $919af1d2850606eb$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$919af1d2850606eb$export$a143d493d941bafc = $919af1d2850606eb$var$Buffer;
$919af1d2850606eb$export$e4cf37d7f6fb9e0a = $919af1d2850606eb$var$SlowBuffer;
$919af1d2850606eb$export$f99ded8fe4b79145 = 50;
var $919af1d2850606eb$var$K_MAX_LENGTH = 0x7fffffff;
$919af1d2850606eb$export$599f31c3813fae4d = $919af1d2850606eb$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $919af1d2850606eb$var$Buffer.TYPED_ARRAY_SUPPORT = $919af1d2850606eb$var$typedArraySupport();
if (!$919af1d2850606eb$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $919af1d2850606eb$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($919af1d2850606eb$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$919af1d2850606eb$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($919af1d2850606eb$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$919af1d2850606eb$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $919af1d2850606eb$var$createBuffer(length) {
    if (length > $919af1d2850606eb$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $919af1d2850606eb$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $919af1d2850606eb$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $919af1d2850606eb$var$allocUnsafe(arg);
    }
    return $919af1d2850606eb$var$from(arg, encodingOrOffset, length);
}
$919af1d2850606eb$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $919af1d2850606eb$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $919af1d2850606eb$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $919af1d2850606eb$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($919af1d2850606eb$var$isInstance(value, ArrayBuffer) || value && $919af1d2850606eb$var$isInstance(value.buffer, ArrayBuffer)) return $919af1d2850606eb$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($919af1d2850606eb$var$isInstance(value, SharedArrayBuffer) || value && $919af1d2850606eb$var$isInstance(value.buffer, SharedArrayBuffer))) return $919af1d2850606eb$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $919af1d2850606eb$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $919af1d2850606eb$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $919af1d2850606eb$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $919af1d2850606eb$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $919af1d2850606eb$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($919af1d2850606eb$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($919af1d2850606eb$var$Buffer, Uint8Array);
function $919af1d2850606eb$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $919af1d2850606eb$var$alloc(size, fill, encoding) {
    $919af1d2850606eb$var$assertSize(size);
    if (size <= 0) return $919af1d2850606eb$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $919af1d2850606eb$var$createBuffer(size).fill(fill, encoding) : $919af1d2850606eb$var$createBuffer(size).fill(fill);
    return $919af1d2850606eb$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $919af1d2850606eb$var$Buffer.alloc = function(size, fill, encoding) {
    return $919af1d2850606eb$var$alloc(size, fill, encoding);
};
function $919af1d2850606eb$var$allocUnsafe(size) {
    $919af1d2850606eb$var$assertSize(size);
    return $919af1d2850606eb$var$createBuffer(size < 0 ? 0 : $919af1d2850606eb$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $919af1d2850606eb$var$Buffer.allocUnsafe = function(size) {
    return $919af1d2850606eb$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $919af1d2850606eb$var$Buffer.allocUnsafeSlow = function(size) {
    return $919af1d2850606eb$var$allocUnsafe(size);
};
function $919af1d2850606eb$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$919af1d2850606eb$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $919af1d2850606eb$var$byteLength(string, encoding) | 0;
    var buf = $919af1d2850606eb$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $919af1d2850606eb$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $919af1d2850606eb$var$checked(array.length) | 0;
    var buf = $919af1d2850606eb$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $919af1d2850606eb$var$fromArrayView(arrayView) {
    if ($919af1d2850606eb$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $919af1d2850606eb$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $919af1d2850606eb$var$fromArrayLike(arrayView);
}
function $919af1d2850606eb$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $919af1d2850606eb$var$Buffer.prototype);
    return buf;
}
function $919af1d2850606eb$var$fromObject(obj) {
    if ($919af1d2850606eb$var$Buffer.isBuffer(obj)) {
        var len = $919af1d2850606eb$var$checked(obj.length) | 0;
        var buf = $919af1d2850606eb$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $919af1d2850606eb$var$numberIsNaN(obj.length)) return $919af1d2850606eb$var$createBuffer(0);
        return $919af1d2850606eb$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $919af1d2850606eb$var$fromArrayLike(obj.data);
}
function $919af1d2850606eb$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $919af1d2850606eb$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $919af1d2850606eb$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $919af1d2850606eb$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $919af1d2850606eb$var$Buffer.alloc(+length);
}
$919af1d2850606eb$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $919af1d2850606eb$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$919af1d2850606eb$var$Buffer.compare = function compare(a, b) {
    if ($919af1d2850606eb$var$isInstance(a, Uint8Array)) a = $919af1d2850606eb$var$Buffer.from(a, a.offset, a.byteLength);
    if ($919af1d2850606eb$var$isInstance(b, Uint8Array)) b = $919af1d2850606eb$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$919af1d2850606eb$var$Buffer.isBuffer(a) || !$919af1d2850606eb$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$919af1d2850606eb$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$919af1d2850606eb$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $919af1d2850606eb$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $919af1d2850606eb$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($919af1d2850606eb$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $919af1d2850606eb$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$919af1d2850606eb$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $919af1d2850606eb$var$byteLength(string, encoding) {
    if ($919af1d2850606eb$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $919af1d2850606eb$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $919af1d2850606eb$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $919af1d2850606eb$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $919af1d2850606eb$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$919af1d2850606eb$var$Buffer.byteLength = $919af1d2850606eb$var$byteLength;
function $919af1d2850606eb$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $919af1d2850606eb$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $919af1d2850606eb$var$utf8Slice(this, start, end);
        case "ascii":
            return $919af1d2850606eb$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $919af1d2850606eb$var$latin1Slice(this, start, end);
        case "base64":
            return $919af1d2850606eb$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $919af1d2850606eb$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$919af1d2850606eb$var$Buffer.prototype._isBuffer = true;
function $919af1d2850606eb$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$919af1d2850606eb$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$919af1d2850606eb$var$swap(this, i, i + 1);
    return this;
};
$919af1d2850606eb$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $919af1d2850606eb$var$swap(this, i, i + 3);
        $919af1d2850606eb$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$919af1d2850606eb$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $919af1d2850606eb$var$swap(this, i, i + 7);
        $919af1d2850606eb$var$swap(this, i + 1, i + 6);
        $919af1d2850606eb$var$swap(this, i + 2, i + 5);
        $919af1d2850606eb$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$919af1d2850606eb$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $919af1d2850606eb$var$utf8Slice(this, 0, length);
    return $919af1d2850606eb$var$slowToString.apply(this, arguments);
};
$919af1d2850606eb$var$Buffer.prototype.toLocaleString = $919af1d2850606eb$var$Buffer.prototype.toString;
$919af1d2850606eb$var$Buffer.prototype.equals = function equals(b) {
    if (!$919af1d2850606eb$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $919af1d2850606eb$var$Buffer.compare(this, b) === 0;
};
$919af1d2850606eb$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $919af1d2850606eb$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($919af1d2850606eb$var$customInspectSymbol) $919af1d2850606eb$var$Buffer.prototype[$919af1d2850606eb$var$customInspectSymbol] = $919af1d2850606eb$var$Buffer.prototype.inspect;
$919af1d2850606eb$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($919af1d2850606eb$var$isInstance(target, Uint8Array)) target = $919af1d2850606eb$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$919af1d2850606eb$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $919af1d2850606eb$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($919af1d2850606eb$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $919af1d2850606eb$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($919af1d2850606eb$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $919af1d2850606eb$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $919af1d2850606eb$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $919af1d2850606eb$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$919af1d2850606eb$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$919af1d2850606eb$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $919af1d2850606eb$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$919af1d2850606eb$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $919af1d2850606eb$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $919af1d2850606eb$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($919af1d2850606eb$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $919af1d2850606eb$var$utf8Write(buf, string, offset, length) {
    return $919af1d2850606eb$var$blitBuffer($919af1d2850606eb$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $919af1d2850606eb$var$asciiWrite(buf, string, offset, length) {
    return $919af1d2850606eb$var$blitBuffer($919af1d2850606eb$var$asciiToBytes(string), buf, offset, length);
}
function $919af1d2850606eb$var$base64Write(buf, string, offset, length) {
    return $919af1d2850606eb$var$blitBuffer($919af1d2850606eb$var$base64ToBytes(string), buf, offset, length);
}
function $919af1d2850606eb$var$ucs2Write(buf, string, offset, length) {
    return $919af1d2850606eb$var$blitBuffer($919af1d2850606eb$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$919af1d2850606eb$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $919af1d2850606eb$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $919af1d2850606eb$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $919af1d2850606eb$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $919af1d2850606eb$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $919af1d2850606eb$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$919af1d2850606eb$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $919af1d2850606eb$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gKBU6.fromByteArray(buf);
    else return $gKBU6.fromByteArray(buf.slice(start, end));
}
function $919af1d2850606eb$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $919af1d2850606eb$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $919af1d2850606eb$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $919af1d2850606eb$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $919af1d2850606eb$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $919af1d2850606eb$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $919af1d2850606eb$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $919af1d2850606eb$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $919af1d2850606eb$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $919af1d2850606eb$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $919af1d2850606eb$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$919af1d2850606eb$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $919af1d2850606eb$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $919af1d2850606eb$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$919af1d2850606eb$var$Buffer.prototype.readUintLE = $919af1d2850606eb$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$919af1d2850606eb$var$Buffer.prototype.readUintBE = $919af1d2850606eb$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$919af1d2850606eb$var$Buffer.prototype.readUint8 = $919af1d2850606eb$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$919af1d2850606eb$var$Buffer.prototype.readUint16LE = $919af1d2850606eb$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$919af1d2850606eb$var$Buffer.prototype.readUint16BE = $919af1d2850606eb$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$919af1d2850606eb$var$Buffer.prototype.readUint32LE = $919af1d2850606eb$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$919af1d2850606eb$var$Buffer.prototype.readUint32BE = $919af1d2850606eb$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$919af1d2850606eb$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$919af1d2850606eb$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$919af1d2850606eb$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$919af1d2850606eb$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$919af1d2850606eb$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$919af1d2850606eb$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$919af1d2850606eb$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$919af1d2850606eb$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkOffset(offset, 4, this.length);
    return $OUdei.read(this, offset, true, 23, 4);
};
$919af1d2850606eb$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkOffset(offset, 4, this.length);
    return $OUdei.read(this, offset, false, 23, 4);
};
$919af1d2850606eb$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkOffset(offset, 8, this.length);
    return $OUdei.read(this, offset, true, 52, 8);
};
$919af1d2850606eb$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkOffset(offset, 8, this.length);
    return $OUdei.read(this, offset, false, 52, 8);
};
function $919af1d2850606eb$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$919af1d2850606eb$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$919af1d2850606eb$var$Buffer.prototype.writeUintLE = $919af1d2850606eb$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $919af1d2850606eb$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$919af1d2850606eb$var$Buffer.prototype.writeUintBE = $919af1d2850606eb$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $919af1d2850606eb$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$919af1d2850606eb$var$Buffer.prototype.writeUint8 = $919af1d2850606eb$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$919af1d2850606eb$var$Buffer.prototype.writeUint16LE = $919af1d2850606eb$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$919af1d2850606eb$var$Buffer.prototype.writeUint16BE = $919af1d2850606eb$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$919af1d2850606eb$var$Buffer.prototype.writeUint32LE = $919af1d2850606eb$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$919af1d2850606eb$var$Buffer.prototype.writeUint32BE = $919af1d2850606eb$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$919af1d2850606eb$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $919af1d2850606eb$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$919af1d2850606eb$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $919af1d2850606eb$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$919af1d2850606eb$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$919af1d2850606eb$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$919af1d2850606eb$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$919af1d2850606eb$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$919af1d2850606eb$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $919af1d2850606eb$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $919af1d2850606eb$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $OUdei.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$919af1d2850606eb$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $919af1d2850606eb$var$writeFloat(this, value, offset, true, noAssert);
};
$919af1d2850606eb$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $919af1d2850606eb$var$writeFloat(this, value, offset, false, noAssert);
};
function $919af1d2850606eb$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $919af1d2850606eb$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $OUdei.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$919af1d2850606eb$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $919af1d2850606eb$var$writeDouble(this, value, offset, true, noAssert);
};
$919af1d2850606eb$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $919af1d2850606eb$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$919af1d2850606eb$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$919af1d2850606eb$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$919af1d2850606eb$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$919af1d2850606eb$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $919af1d2850606eb$var$Buffer.isBuffer(val) ? val : $919af1d2850606eb$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $919af1d2850606eb$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $919af1d2850606eb$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($919af1d2850606eb$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $919af1d2850606eb$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $919af1d2850606eb$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $919af1d2850606eb$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $919af1d2850606eb$var$base64ToBytes(str) {
    return $gKBU6.toByteArray($919af1d2850606eb$var$base64clean(str));
}
function $919af1d2850606eb$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $919af1d2850606eb$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $919af1d2850606eb$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $919af1d2850606eb$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();



const $54dbf901ab9931e8$var$createBuffer = (0, $919af1d2850606eb$export$a143d493d941bafc).from && (0, $919af1d2850606eb$export$a143d493d941bafc).alloc && (0, $919af1d2850606eb$export$a143d493d941bafc).allocUnsafe && (0, $919af1d2850606eb$export$a143d493d941bafc).allocUnsafeSlow ? (0, $919af1d2850606eb$export$a143d493d941bafc).from : (val)=>new (0, $919af1d2850606eb$export$a143d493d941bafc)(val);
var $54dbf901ab9931e8$export$2e2bcd8739ae039 = $54dbf901ab9931e8$var$createBuffer;


function $3ece5e4f58cfdf2d$export$2e2bcd8739ae039(model, calc) {
    const fn = (buf, previous)=>calc(buf, previous) >>> 0;
    fn.signed = calc;
    fn.unsigned = fn;
    fn.model = model;
    return fn;
}


const $859b0538169a5c14$var$crc1 = (0, $3ece5e4f58cfdf2d$export$2e2bcd8739ae039)("crc1", function(buf, previous) {
    if (!(0, $919af1d2850606eb$export$a143d493d941bafc).isBuffer(buf)) buf = (0, $54dbf901ab9931e8$export$2e2bcd8739ae039)(buf);
    let crc = ~~previous;
    let accum = 0;
    for(let index = 0; index < buf.length; index++){
        const byte = buf[index];
        accum += byte;
    }
    crc += accum % 256;
    return crc % 256;
});
var $859b0538169a5c14$export$2e2bcd8739ae039 = $859b0538169a5c14$var$crc1;





// Generated by `./pycrc.py --algorithm=table-driven --model=crc-8 --generate=c`
// prettier-ignore
let $9d562bff356ea457$var$TABLE = [
    0x00,
    0x07,
    0x0e,
    0x09,
    0x1c,
    0x1b,
    0x12,
    0x15,
    0x38,
    0x3f,
    0x36,
    0x31,
    0x24,
    0x23,
    0x2a,
    0x2d,
    0x70,
    0x77,
    0x7e,
    0x79,
    0x6c,
    0x6b,
    0x62,
    0x65,
    0x48,
    0x4f,
    0x46,
    0x41,
    0x54,
    0x53,
    0x5a,
    0x5d,
    0xe0,
    0xe7,
    0xee,
    0xe9,
    0xfc,
    0xfb,
    0xf2,
    0xf5,
    0xd8,
    0xdf,
    0xd6,
    0xd1,
    0xc4,
    0xc3,
    0xca,
    0xcd,
    0x90,
    0x97,
    0x9e,
    0x99,
    0x8c,
    0x8b,
    0x82,
    0x85,
    0xa8,
    0xaf,
    0xa6,
    0xa1,
    0xb4,
    0xb3,
    0xba,
    0xbd,
    0xc7,
    0xc0,
    0xc9,
    0xce,
    0xdb,
    0xdc,
    0xd5,
    0xd2,
    0xff,
    0xf8,
    0xf1,
    0xf6,
    0xe3,
    0xe4,
    0xed,
    0xea,
    0xb7,
    0xb0,
    0xb9,
    0xbe,
    0xab,
    0xac,
    0xa5,
    0xa2,
    0x8f,
    0x88,
    0x81,
    0x86,
    0x93,
    0x94,
    0x9d,
    0x9a,
    0x27,
    0x20,
    0x29,
    0x2e,
    0x3b,
    0x3c,
    0x35,
    0x32,
    0x1f,
    0x18,
    0x11,
    0x16,
    0x03,
    0x04,
    0x0d,
    0x0a,
    0x57,
    0x50,
    0x59,
    0x5e,
    0x4b,
    0x4c,
    0x45,
    0x42,
    0x6f,
    0x68,
    0x61,
    0x66,
    0x73,
    0x74,
    0x7d,
    0x7a,
    0x89,
    0x8e,
    0x87,
    0x80,
    0x95,
    0x92,
    0x9b,
    0x9c,
    0xb1,
    0xb6,
    0xbf,
    0xb8,
    0xad,
    0xaa,
    0xa3,
    0xa4,
    0xf9,
    0xfe,
    0xf7,
    0xf0,
    0xe5,
    0xe2,
    0xeb,
    0xec,
    0xc1,
    0xc6,
    0xcf,
    0xc8,
    0xdd,
    0xda,
    0xd3,
    0xd4,
    0x69,
    0x6e,
    0x67,
    0x60,
    0x75,
    0x72,
    0x7b,
    0x7c,
    0x51,
    0x56,
    0x5f,
    0x58,
    0x4d,
    0x4a,
    0x43,
    0x44,
    0x19,
    0x1e,
    0x17,
    0x10,
    0x05,
    0x02,
    0x0b,
    0x0c,
    0x21,
    0x26,
    0x2f,
    0x28,
    0x3d,
    0x3a,
    0x33,
    0x34,
    0x4e,
    0x49,
    0x40,
    0x47,
    0x52,
    0x55,
    0x5c,
    0x5b,
    0x76,
    0x71,
    0x78,
    0x7f,
    0x6a,
    0x6d,
    0x64,
    0x63,
    0x3e,
    0x39,
    0x30,
    0x37,
    0x22,
    0x25,
    0x2c,
    0x2b,
    0x06,
    0x01,
    0x08,
    0x0f,
    0x1a,
    0x1d,
    0x14,
    0x13,
    0xae,
    0xa9,
    0xa0,
    0xa7,
    0xb2,
    0xb5,
    0xbc,
    0xbb,
    0x96,
    0x91,
    0x98,
    0x9f,
    0x8a,
    0x8d,
    0x84,
    0x83,
    0xde,
    0xd9,
    0xd0,
    0xd7,
    0xc2,
    0xc5,
    0xcc,
    0xcb,
    0xe6,
    0xe1,
    0xe8,
    0xef,
    0xfa,
    0xfd,
    0xf4,
    0xf3
];
if (typeof Int32Array !== "undefined") $9d562bff356ea457$var$TABLE = new Int32Array($9d562bff356ea457$var$TABLE);
const $9d562bff356ea457$var$crc8 = (0, $3ece5e4f58cfdf2d$export$2e2bcd8739ae039)("crc-8", function(buf, previous) {
    if (!(0, $919af1d2850606eb$export$a143d493d941bafc).isBuffer(buf)) buf = (0, $54dbf901ab9931e8$export$2e2bcd8739ae039)(buf);
    let crc = ~~previous;
    for(let index = 0; index < buf.length; index++){
        const byte = buf[index];
        crc = $9d562bff356ea457$var$TABLE[(crc ^ byte) & 0xff] & 0xff;
    }
    return crc;
});
var $9d562bff356ea457$export$2e2bcd8739ae039 = $9d562bff356ea457$var$crc8;





// Generated by `./pycrc.py --algorithm=table-driven --model=dallas-1-wire --generate=c`
// prettier-ignore
let $95a504a162276221$var$TABLE = [
    0x00,
    0x5e,
    0xbc,
    0xe2,
    0x61,
    0x3f,
    0xdd,
    0x83,
    0xc2,
    0x9c,
    0x7e,
    0x20,
    0xa3,
    0xfd,
    0x1f,
    0x41,
    0x9d,
    0xc3,
    0x21,
    0x7f,
    0xfc,
    0xa2,
    0x40,
    0x1e,
    0x5f,
    0x01,
    0xe3,
    0xbd,
    0x3e,
    0x60,
    0x82,
    0xdc,
    0x23,
    0x7d,
    0x9f,
    0xc1,
    0x42,
    0x1c,
    0xfe,
    0xa0,
    0xe1,
    0xbf,
    0x5d,
    0x03,
    0x80,
    0xde,
    0x3c,
    0x62,
    0xbe,
    0xe0,
    0x02,
    0x5c,
    0xdf,
    0x81,
    0x63,
    0x3d,
    0x7c,
    0x22,
    0xc0,
    0x9e,
    0x1d,
    0x43,
    0xa1,
    0xff,
    0x46,
    0x18,
    0xfa,
    0xa4,
    0x27,
    0x79,
    0x9b,
    0xc5,
    0x84,
    0xda,
    0x38,
    0x66,
    0xe5,
    0xbb,
    0x59,
    0x07,
    0xdb,
    0x85,
    0x67,
    0x39,
    0xba,
    0xe4,
    0x06,
    0x58,
    0x19,
    0x47,
    0xa5,
    0xfb,
    0x78,
    0x26,
    0xc4,
    0x9a,
    0x65,
    0x3b,
    0xd9,
    0x87,
    0x04,
    0x5a,
    0xb8,
    0xe6,
    0xa7,
    0xf9,
    0x1b,
    0x45,
    0xc6,
    0x98,
    0x7a,
    0x24,
    0xf8,
    0xa6,
    0x44,
    0x1a,
    0x99,
    0xc7,
    0x25,
    0x7b,
    0x3a,
    0x64,
    0x86,
    0xd8,
    0x5b,
    0x05,
    0xe7,
    0xb9,
    0x8c,
    0xd2,
    0x30,
    0x6e,
    0xed,
    0xb3,
    0x51,
    0x0f,
    0x4e,
    0x10,
    0xf2,
    0xac,
    0x2f,
    0x71,
    0x93,
    0xcd,
    0x11,
    0x4f,
    0xad,
    0xf3,
    0x70,
    0x2e,
    0xcc,
    0x92,
    0xd3,
    0x8d,
    0x6f,
    0x31,
    0xb2,
    0xec,
    0x0e,
    0x50,
    0xaf,
    0xf1,
    0x13,
    0x4d,
    0xce,
    0x90,
    0x72,
    0x2c,
    0x6d,
    0x33,
    0xd1,
    0x8f,
    0x0c,
    0x52,
    0xb0,
    0xee,
    0x32,
    0x6c,
    0x8e,
    0xd0,
    0x53,
    0x0d,
    0xef,
    0xb1,
    0xf0,
    0xae,
    0x4c,
    0x12,
    0x91,
    0xcf,
    0x2d,
    0x73,
    0xca,
    0x94,
    0x76,
    0x28,
    0xab,
    0xf5,
    0x17,
    0x49,
    0x08,
    0x56,
    0xb4,
    0xea,
    0x69,
    0x37,
    0xd5,
    0x8b,
    0x57,
    0x09,
    0xeb,
    0xb5,
    0x36,
    0x68,
    0x8a,
    0xd4,
    0x95,
    0xcb,
    0x29,
    0x77,
    0xf4,
    0xaa,
    0x48,
    0x16,
    0xe9,
    0xb7,
    0x55,
    0x0b,
    0x88,
    0xd6,
    0x34,
    0x6a,
    0x2b,
    0x75,
    0x97,
    0xc9,
    0x4a,
    0x14,
    0xf6,
    0xa8,
    0x74,
    0x2a,
    0xc8,
    0x96,
    0x15,
    0x4b,
    0xa9,
    0xf7,
    0xb6,
    0xe8,
    0x0a,
    0x54,
    0xd7,
    0x89,
    0x6b,
    0x35
];
if (typeof Int32Array !== "undefined") $95a504a162276221$var$TABLE = new Int32Array($95a504a162276221$var$TABLE);
const $95a504a162276221$var$crc81wire = (0, $3ece5e4f58cfdf2d$export$2e2bcd8739ae039)("dallas-1-wire", function(buf, previous) {
    if (!(0, $919af1d2850606eb$export$a143d493d941bafc).isBuffer(buf)) buf = (0, $54dbf901ab9931e8$export$2e2bcd8739ae039)(buf);
    let crc = ~~previous;
    for(let index = 0; index < buf.length; index++){
        const byte = buf[index];
        crc = $95a504a162276221$var$TABLE[(crc ^ byte) & 0xff] & 0xff;
    }
    return crc;
});
var $95a504a162276221$export$2e2bcd8739ae039 = $95a504a162276221$var$crc81wire;





// Generated by `./pycrc.py --algorithm=table-driven --model=crc-16 --generate=c`
// prettier-ignore
let $d40ca97efc44b812$var$TABLE = [
    0x0000,
    0xc0c1,
    0xc181,
    0x0140,
    0xc301,
    0x03c0,
    0x0280,
    0xc241,
    0xc601,
    0x06c0,
    0x0780,
    0xc741,
    0x0500,
    0xc5c1,
    0xc481,
    0x0440,
    0xcc01,
    0x0cc0,
    0x0d80,
    0xcd41,
    0x0f00,
    0xcfc1,
    0xce81,
    0x0e40,
    0x0a00,
    0xcac1,
    0xcb81,
    0x0b40,
    0xc901,
    0x09c0,
    0x0880,
    0xc841,
    0xd801,
    0x18c0,
    0x1980,
    0xd941,
    0x1b00,
    0xdbc1,
    0xda81,
    0x1a40,
    0x1e00,
    0xdec1,
    0xdf81,
    0x1f40,
    0xdd01,
    0x1dc0,
    0x1c80,
    0xdc41,
    0x1400,
    0xd4c1,
    0xd581,
    0x1540,
    0xd701,
    0x17c0,
    0x1680,
    0xd641,
    0xd201,
    0x12c0,
    0x1380,
    0xd341,
    0x1100,
    0xd1c1,
    0xd081,
    0x1040,
    0xf001,
    0x30c0,
    0x3180,
    0xf141,
    0x3300,
    0xf3c1,
    0xf281,
    0x3240,
    0x3600,
    0xf6c1,
    0xf781,
    0x3740,
    0xf501,
    0x35c0,
    0x3480,
    0xf441,
    0x3c00,
    0xfcc1,
    0xfd81,
    0x3d40,
    0xff01,
    0x3fc0,
    0x3e80,
    0xfe41,
    0xfa01,
    0x3ac0,
    0x3b80,
    0xfb41,
    0x3900,
    0xf9c1,
    0xf881,
    0x3840,
    0x2800,
    0xe8c1,
    0xe981,
    0x2940,
    0xeb01,
    0x2bc0,
    0x2a80,
    0xea41,
    0xee01,
    0x2ec0,
    0x2f80,
    0xef41,
    0x2d00,
    0xedc1,
    0xec81,
    0x2c40,
    0xe401,
    0x24c0,
    0x2580,
    0xe541,
    0x2700,
    0xe7c1,
    0xe681,
    0x2640,
    0x2200,
    0xe2c1,
    0xe381,
    0x2340,
    0xe101,
    0x21c0,
    0x2080,
    0xe041,
    0xa001,
    0x60c0,
    0x6180,
    0xa141,
    0x6300,
    0xa3c1,
    0xa281,
    0x6240,
    0x6600,
    0xa6c1,
    0xa781,
    0x6740,
    0xa501,
    0x65c0,
    0x6480,
    0xa441,
    0x6c00,
    0xacc1,
    0xad81,
    0x6d40,
    0xaf01,
    0x6fc0,
    0x6e80,
    0xae41,
    0xaa01,
    0x6ac0,
    0x6b80,
    0xab41,
    0x6900,
    0xa9c1,
    0xa881,
    0x6840,
    0x7800,
    0xb8c1,
    0xb981,
    0x7940,
    0xbb01,
    0x7bc0,
    0x7a80,
    0xba41,
    0xbe01,
    0x7ec0,
    0x7f80,
    0xbf41,
    0x7d00,
    0xbdc1,
    0xbc81,
    0x7c40,
    0xb401,
    0x74c0,
    0x7580,
    0xb541,
    0x7700,
    0xb7c1,
    0xb681,
    0x7640,
    0x7200,
    0xb2c1,
    0xb381,
    0x7340,
    0xb101,
    0x71c0,
    0x7080,
    0xb041,
    0x5000,
    0x90c1,
    0x9181,
    0x5140,
    0x9301,
    0x53c0,
    0x5280,
    0x9241,
    0x9601,
    0x56c0,
    0x5780,
    0x9741,
    0x5500,
    0x95c1,
    0x9481,
    0x5440,
    0x9c01,
    0x5cc0,
    0x5d80,
    0x9d41,
    0x5f00,
    0x9fc1,
    0x9e81,
    0x5e40,
    0x5a00,
    0x9ac1,
    0x9b81,
    0x5b40,
    0x9901,
    0x59c0,
    0x5880,
    0x9841,
    0x8801,
    0x48c0,
    0x4980,
    0x8941,
    0x4b00,
    0x8bc1,
    0x8a81,
    0x4a40,
    0x4e00,
    0x8ec1,
    0x8f81,
    0x4f40,
    0x8d01,
    0x4dc0,
    0x4c80,
    0x8c41,
    0x4400,
    0x84c1,
    0x8581,
    0x4540,
    0x8701,
    0x47c0,
    0x4680,
    0x8641,
    0x8201,
    0x42c0,
    0x4380,
    0x8341,
    0x4100,
    0x81c1,
    0x8081,
    0x4040
];
if (typeof Int32Array !== "undefined") $d40ca97efc44b812$var$TABLE = new Int32Array($d40ca97efc44b812$var$TABLE);
const $d40ca97efc44b812$var$crc16 = (0, $3ece5e4f58cfdf2d$export$2e2bcd8739ae039)("crc-16", function(buf, previous) {
    if (!(0, $919af1d2850606eb$export$a143d493d941bafc).isBuffer(buf)) buf = (0, $54dbf901ab9931e8$export$2e2bcd8739ae039)(buf);
    let crc = ~~previous;
    for(let index = 0; index < buf.length; index++){
        const byte = buf[index];
        crc = ($d40ca97efc44b812$var$TABLE[(crc ^ byte) & 0xff] ^ crc >> 8) & 0xffff;
    }
    return crc;
});
var $d40ca97efc44b812$export$2e2bcd8739ae039 = $d40ca97efc44b812$var$crc16;





// Generated by `./pycrc.py --algorithm=table-driven --model=ccitt --generate=c`
// prettier-ignore
let $755349af12deb141$var$TABLE = [
    0x0000,
    0x1021,
    0x2042,
    0x3063,
    0x4084,
    0x50a5,
    0x60c6,
    0x70e7,
    0x8108,
    0x9129,
    0xa14a,
    0xb16b,
    0xc18c,
    0xd1ad,
    0xe1ce,
    0xf1ef,
    0x1231,
    0x0210,
    0x3273,
    0x2252,
    0x52b5,
    0x4294,
    0x72f7,
    0x62d6,
    0x9339,
    0x8318,
    0xb37b,
    0xa35a,
    0xd3bd,
    0xc39c,
    0xf3ff,
    0xe3de,
    0x2462,
    0x3443,
    0x0420,
    0x1401,
    0x64e6,
    0x74c7,
    0x44a4,
    0x5485,
    0xa56a,
    0xb54b,
    0x8528,
    0x9509,
    0xe5ee,
    0xf5cf,
    0xc5ac,
    0xd58d,
    0x3653,
    0x2672,
    0x1611,
    0x0630,
    0x76d7,
    0x66f6,
    0x5695,
    0x46b4,
    0xb75b,
    0xa77a,
    0x9719,
    0x8738,
    0xf7df,
    0xe7fe,
    0xd79d,
    0xc7bc,
    0x48c4,
    0x58e5,
    0x6886,
    0x78a7,
    0x0840,
    0x1861,
    0x2802,
    0x3823,
    0xc9cc,
    0xd9ed,
    0xe98e,
    0xf9af,
    0x8948,
    0x9969,
    0xa90a,
    0xb92b,
    0x5af5,
    0x4ad4,
    0x7ab7,
    0x6a96,
    0x1a71,
    0x0a50,
    0x3a33,
    0x2a12,
    0xdbfd,
    0xcbdc,
    0xfbbf,
    0xeb9e,
    0x9b79,
    0x8b58,
    0xbb3b,
    0xab1a,
    0x6ca6,
    0x7c87,
    0x4ce4,
    0x5cc5,
    0x2c22,
    0x3c03,
    0x0c60,
    0x1c41,
    0xedae,
    0xfd8f,
    0xcdec,
    0xddcd,
    0xad2a,
    0xbd0b,
    0x8d68,
    0x9d49,
    0x7e97,
    0x6eb6,
    0x5ed5,
    0x4ef4,
    0x3e13,
    0x2e32,
    0x1e51,
    0x0e70,
    0xff9f,
    0xefbe,
    0xdfdd,
    0xcffc,
    0xbf1b,
    0xaf3a,
    0x9f59,
    0x8f78,
    0x9188,
    0x81a9,
    0xb1ca,
    0xa1eb,
    0xd10c,
    0xc12d,
    0xf14e,
    0xe16f,
    0x1080,
    0x00a1,
    0x30c2,
    0x20e3,
    0x5004,
    0x4025,
    0x7046,
    0x6067,
    0x83b9,
    0x9398,
    0xa3fb,
    0xb3da,
    0xc33d,
    0xd31c,
    0xe37f,
    0xf35e,
    0x02b1,
    0x1290,
    0x22f3,
    0x32d2,
    0x4235,
    0x5214,
    0x6277,
    0x7256,
    0xb5ea,
    0xa5cb,
    0x95a8,
    0x8589,
    0xf56e,
    0xe54f,
    0xd52c,
    0xc50d,
    0x34e2,
    0x24c3,
    0x14a0,
    0x0481,
    0x7466,
    0x6447,
    0x5424,
    0x4405,
    0xa7db,
    0xb7fa,
    0x8799,
    0x97b8,
    0xe75f,
    0xf77e,
    0xc71d,
    0xd73c,
    0x26d3,
    0x36f2,
    0x0691,
    0x16b0,
    0x6657,
    0x7676,
    0x4615,
    0x5634,
    0xd94c,
    0xc96d,
    0xf90e,
    0xe92f,
    0x99c8,
    0x89e9,
    0xb98a,
    0xa9ab,
    0x5844,
    0x4865,
    0x7806,
    0x6827,
    0x18c0,
    0x08e1,
    0x3882,
    0x28a3,
    0xcb7d,
    0xdb5c,
    0xeb3f,
    0xfb1e,
    0x8bf9,
    0x9bd8,
    0xabbb,
    0xbb9a,
    0x4a75,
    0x5a54,
    0x6a37,
    0x7a16,
    0x0af1,
    0x1ad0,
    0x2ab3,
    0x3a92,
    0xfd2e,
    0xed0f,
    0xdd6c,
    0xcd4d,
    0xbdaa,
    0xad8b,
    0x9de8,
    0x8dc9,
    0x7c26,
    0x6c07,
    0x5c64,
    0x4c45,
    0x3ca2,
    0x2c83,
    0x1ce0,
    0x0cc1,
    0xef1f,
    0xff3e,
    0xcf5d,
    0xdf7c,
    0xaf9b,
    0xbfba,
    0x8fd9,
    0x9ff8,
    0x6e17,
    0x7e36,
    0x4e55,
    0x5e74,
    0x2e93,
    0x3eb2,
    0x0ed1,
    0x1ef0
];
if (typeof Int32Array !== "undefined") $755349af12deb141$var$TABLE = new Int32Array($755349af12deb141$var$TABLE);
const $755349af12deb141$var$crc16ccitt = (0, $3ece5e4f58cfdf2d$export$2e2bcd8739ae039)("ccitt", function(buf, previous) {
    if (!(0, $919af1d2850606eb$export$a143d493d941bafc).isBuffer(buf)) buf = (0, $54dbf901ab9931e8$export$2e2bcd8739ae039)(buf);
    let crc = typeof previous !== "undefined" ? ~~previous : 0xffff;
    for(let index = 0; index < buf.length; index++){
        const byte = buf[index];
        crc = ($755349af12deb141$var$TABLE[(crc >> 8 ^ byte) & 0xff] ^ crc << 8) & 0xffff;
    }
    return crc;
});
var $755349af12deb141$export$2e2bcd8739ae039 = $755349af12deb141$var$crc16ccitt;





// Generated by `./pycrc.py --algorithm=table-driven --model=crc-16-modbus --generate=c`
// prettier-ignore
let $9efec5a7c5dde2cc$var$TABLE = [
    0x0000,
    0xc0c1,
    0xc181,
    0x0140,
    0xc301,
    0x03c0,
    0x0280,
    0xc241,
    0xc601,
    0x06c0,
    0x0780,
    0xc741,
    0x0500,
    0xc5c1,
    0xc481,
    0x0440,
    0xcc01,
    0x0cc0,
    0x0d80,
    0xcd41,
    0x0f00,
    0xcfc1,
    0xce81,
    0x0e40,
    0x0a00,
    0xcac1,
    0xcb81,
    0x0b40,
    0xc901,
    0x09c0,
    0x0880,
    0xc841,
    0xd801,
    0x18c0,
    0x1980,
    0xd941,
    0x1b00,
    0xdbc1,
    0xda81,
    0x1a40,
    0x1e00,
    0xdec1,
    0xdf81,
    0x1f40,
    0xdd01,
    0x1dc0,
    0x1c80,
    0xdc41,
    0x1400,
    0xd4c1,
    0xd581,
    0x1540,
    0xd701,
    0x17c0,
    0x1680,
    0xd641,
    0xd201,
    0x12c0,
    0x1380,
    0xd341,
    0x1100,
    0xd1c1,
    0xd081,
    0x1040,
    0xf001,
    0x30c0,
    0x3180,
    0xf141,
    0x3300,
    0xf3c1,
    0xf281,
    0x3240,
    0x3600,
    0xf6c1,
    0xf781,
    0x3740,
    0xf501,
    0x35c0,
    0x3480,
    0xf441,
    0x3c00,
    0xfcc1,
    0xfd81,
    0x3d40,
    0xff01,
    0x3fc0,
    0x3e80,
    0xfe41,
    0xfa01,
    0x3ac0,
    0x3b80,
    0xfb41,
    0x3900,
    0xf9c1,
    0xf881,
    0x3840,
    0x2800,
    0xe8c1,
    0xe981,
    0x2940,
    0xeb01,
    0x2bc0,
    0x2a80,
    0xea41,
    0xee01,
    0x2ec0,
    0x2f80,
    0xef41,
    0x2d00,
    0xedc1,
    0xec81,
    0x2c40,
    0xe401,
    0x24c0,
    0x2580,
    0xe541,
    0x2700,
    0xe7c1,
    0xe681,
    0x2640,
    0x2200,
    0xe2c1,
    0xe381,
    0x2340,
    0xe101,
    0x21c0,
    0x2080,
    0xe041,
    0xa001,
    0x60c0,
    0x6180,
    0xa141,
    0x6300,
    0xa3c1,
    0xa281,
    0x6240,
    0x6600,
    0xa6c1,
    0xa781,
    0x6740,
    0xa501,
    0x65c0,
    0x6480,
    0xa441,
    0x6c00,
    0xacc1,
    0xad81,
    0x6d40,
    0xaf01,
    0x6fc0,
    0x6e80,
    0xae41,
    0xaa01,
    0x6ac0,
    0x6b80,
    0xab41,
    0x6900,
    0xa9c1,
    0xa881,
    0x6840,
    0x7800,
    0xb8c1,
    0xb981,
    0x7940,
    0xbb01,
    0x7bc0,
    0x7a80,
    0xba41,
    0xbe01,
    0x7ec0,
    0x7f80,
    0xbf41,
    0x7d00,
    0xbdc1,
    0xbc81,
    0x7c40,
    0xb401,
    0x74c0,
    0x7580,
    0xb541,
    0x7700,
    0xb7c1,
    0xb681,
    0x7640,
    0x7200,
    0xb2c1,
    0xb381,
    0x7340,
    0xb101,
    0x71c0,
    0x7080,
    0xb041,
    0x5000,
    0x90c1,
    0x9181,
    0x5140,
    0x9301,
    0x53c0,
    0x5280,
    0x9241,
    0x9601,
    0x56c0,
    0x5780,
    0x9741,
    0x5500,
    0x95c1,
    0x9481,
    0x5440,
    0x9c01,
    0x5cc0,
    0x5d80,
    0x9d41,
    0x5f00,
    0x9fc1,
    0x9e81,
    0x5e40,
    0x5a00,
    0x9ac1,
    0x9b81,
    0x5b40,
    0x9901,
    0x59c0,
    0x5880,
    0x9841,
    0x8801,
    0x48c0,
    0x4980,
    0x8941,
    0x4b00,
    0x8bc1,
    0x8a81,
    0x4a40,
    0x4e00,
    0x8ec1,
    0x8f81,
    0x4f40,
    0x8d01,
    0x4dc0,
    0x4c80,
    0x8c41,
    0x4400,
    0x84c1,
    0x8581,
    0x4540,
    0x8701,
    0x47c0,
    0x4680,
    0x8641,
    0x8201,
    0x42c0,
    0x4380,
    0x8341,
    0x4100,
    0x81c1,
    0x8081,
    0x4040
];
if (typeof Int32Array !== "undefined") $9efec5a7c5dde2cc$var$TABLE = new Int32Array($9efec5a7c5dde2cc$var$TABLE);
const $9efec5a7c5dde2cc$var$crc16modbus = (0, $3ece5e4f58cfdf2d$export$2e2bcd8739ae039)("crc-16-modbus", function(buf, previous) {
    if (!(0, $919af1d2850606eb$export$a143d493d941bafc).isBuffer(buf)) buf = (0, $54dbf901ab9931e8$export$2e2bcd8739ae039)(buf);
    let crc = typeof previous !== "undefined" ? ~~previous : 0xffff;
    for(let index = 0; index < buf.length; index++){
        const byte = buf[index];
        crc = ($9efec5a7c5dde2cc$var$TABLE[(crc ^ byte) & 0xff] ^ crc >> 8) & 0xffff;
    }
    return crc;
});
var $9efec5a7c5dde2cc$export$2e2bcd8739ae039 = $9efec5a7c5dde2cc$var$crc16modbus;





const $37901099455222b1$var$crc16xmodem = (0, $3ece5e4f58cfdf2d$export$2e2bcd8739ae039)("xmodem", function(buf, previous) {
    if (!(0, $919af1d2850606eb$export$a143d493d941bafc).isBuffer(buf)) buf = (0, $54dbf901ab9931e8$export$2e2bcd8739ae039)(buf);
    let crc = typeof previous !== "undefined" ? ~~previous : 0x0;
    for(let index = 0; index < buf.length; index++){
        const byte = buf[index];
        let code = crc >>> 8 & 0xff;
        code ^= byte & 0xff;
        code ^= code >>> 4;
        crc = crc << 8 & 0xffff;
        crc ^= code;
        code = code << 5 & 0xffff;
        crc ^= code;
        code = code << 7 & 0xffff;
        crc ^= code;
    }
    return crc;
});
var $37901099455222b1$export$2e2bcd8739ae039 = $37901099455222b1$var$crc16xmodem;





// Generated by `./pycrc.py --algorithm=table-driven --model=kermit --generate=c`
// prettier-ignore
let $a6a4bcf3d09e53b1$var$TABLE = [
    0x0000,
    0x1189,
    0x2312,
    0x329b,
    0x4624,
    0x57ad,
    0x6536,
    0x74bf,
    0x8c48,
    0x9dc1,
    0xaf5a,
    0xbed3,
    0xca6c,
    0xdbe5,
    0xe97e,
    0xf8f7,
    0x1081,
    0x0108,
    0x3393,
    0x221a,
    0x56a5,
    0x472c,
    0x75b7,
    0x643e,
    0x9cc9,
    0x8d40,
    0xbfdb,
    0xae52,
    0xdaed,
    0xcb64,
    0xf9ff,
    0xe876,
    0x2102,
    0x308b,
    0x0210,
    0x1399,
    0x6726,
    0x76af,
    0x4434,
    0x55bd,
    0xad4a,
    0xbcc3,
    0x8e58,
    0x9fd1,
    0xeb6e,
    0xfae7,
    0xc87c,
    0xd9f5,
    0x3183,
    0x200a,
    0x1291,
    0x0318,
    0x77a7,
    0x662e,
    0x54b5,
    0x453c,
    0xbdcb,
    0xac42,
    0x9ed9,
    0x8f50,
    0xfbef,
    0xea66,
    0xd8fd,
    0xc974,
    0x4204,
    0x538d,
    0x6116,
    0x709f,
    0x0420,
    0x15a9,
    0x2732,
    0x36bb,
    0xce4c,
    0xdfc5,
    0xed5e,
    0xfcd7,
    0x8868,
    0x99e1,
    0xab7a,
    0xbaf3,
    0x5285,
    0x430c,
    0x7197,
    0x601e,
    0x14a1,
    0x0528,
    0x37b3,
    0x263a,
    0xdecd,
    0xcf44,
    0xfddf,
    0xec56,
    0x98e9,
    0x8960,
    0xbbfb,
    0xaa72,
    0x6306,
    0x728f,
    0x4014,
    0x519d,
    0x2522,
    0x34ab,
    0x0630,
    0x17b9,
    0xef4e,
    0xfec7,
    0xcc5c,
    0xddd5,
    0xa96a,
    0xb8e3,
    0x8a78,
    0x9bf1,
    0x7387,
    0x620e,
    0x5095,
    0x411c,
    0x35a3,
    0x242a,
    0x16b1,
    0x0738,
    0xffcf,
    0xee46,
    0xdcdd,
    0xcd54,
    0xb9eb,
    0xa862,
    0x9af9,
    0x8b70,
    0x8408,
    0x9581,
    0xa71a,
    0xb693,
    0xc22c,
    0xd3a5,
    0xe13e,
    0xf0b7,
    0x0840,
    0x19c9,
    0x2b52,
    0x3adb,
    0x4e64,
    0x5fed,
    0x6d76,
    0x7cff,
    0x9489,
    0x8500,
    0xb79b,
    0xa612,
    0xd2ad,
    0xc324,
    0xf1bf,
    0xe036,
    0x18c1,
    0x0948,
    0x3bd3,
    0x2a5a,
    0x5ee5,
    0x4f6c,
    0x7df7,
    0x6c7e,
    0xa50a,
    0xb483,
    0x8618,
    0x9791,
    0xe32e,
    0xf2a7,
    0xc03c,
    0xd1b5,
    0x2942,
    0x38cb,
    0x0a50,
    0x1bd9,
    0x6f66,
    0x7eef,
    0x4c74,
    0x5dfd,
    0xb58b,
    0xa402,
    0x9699,
    0x8710,
    0xf3af,
    0xe226,
    0xd0bd,
    0xc134,
    0x39c3,
    0x284a,
    0x1ad1,
    0x0b58,
    0x7fe7,
    0x6e6e,
    0x5cf5,
    0x4d7c,
    0xc60c,
    0xd785,
    0xe51e,
    0xf497,
    0x8028,
    0x91a1,
    0xa33a,
    0xb2b3,
    0x4a44,
    0x5bcd,
    0x6956,
    0x78df,
    0x0c60,
    0x1de9,
    0x2f72,
    0x3efb,
    0xd68d,
    0xc704,
    0xf59f,
    0xe416,
    0x90a9,
    0x8120,
    0xb3bb,
    0xa232,
    0x5ac5,
    0x4b4c,
    0x79d7,
    0x685e,
    0x1ce1,
    0x0d68,
    0x3ff3,
    0x2e7a,
    0xe70e,
    0xf687,
    0xc41c,
    0xd595,
    0xa12a,
    0xb0a3,
    0x8238,
    0x93b1,
    0x6b46,
    0x7acf,
    0x4854,
    0x59dd,
    0x2d62,
    0x3ceb,
    0x0e70,
    0x1ff9,
    0xf78f,
    0xe606,
    0xd49d,
    0xc514,
    0xb1ab,
    0xa022,
    0x92b9,
    0x8330,
    0x7bc7,
    0x6a4e,
    0x58d5,
    0x495c,
    0x3de3,
    0x2c6a,
    0x1ef1,
    0x0f78
];
if (typeof Int32Array !== "undefined") $a6a4bcf3d09e53b1$var$TABLE = new Int32Array($a6a4bcf3d09e53b1$var$TABLE);
const $a6a4bcf3d09e53b1$var$crc16kermit = (0, $3ece5e4f58cfdf2d$export$2e2bcd8739ae039)("kermit", function(buf, previous) {
    if (!(0, $919af1d2850606eb$export$a143d493d941bafc).isBuffer(buf)) buf = (0, $54dbf901ab9931e8$export$2e2bcd8739ae039)(buf);
    let crc = typeof previous !== "undefined" ? ~~previous : 0x0000;
    for(let index = 0; index < buf.length; index++){
        const byte = buf[index];
        crc = ($a6a4bcf3d09e53b1$var$TABLE[(crc ^ byte) & 0xff] ^ crc >> 8) & 0xffff;
    }
    return crc;
});
var $a6a4bcf3d09e53b1$export$2e2bcd8739ae039 = $a6a4bcf3d09e53b1$var$crc16kermit;





// Generated by `./pycrc.py --algorithm=table-drive --model=crc-24 --generate=c`
// prettier-ignore
let $1c2b521624408a7b$var$TABLE = [
    0x000000,
    0x864cfb,
    0x8ad50d,
    0x0c99f6,
    0x93e6e1,
    0x15aa1a,
    0x1933ec,
    0x9f7f17,
    0xa18139,
    0x27cdc2,
    0x2b5434,
    0xad18cf,
    0x3267d8,
    0xb42b23,
    0xb8b2d5,
    0x3efe2e,
    0xc54e89,
    0x430272,
    0x4f9b84,
    0xc9d77f,
    0x56a868,
    0xd0e493,
    0xdc7d65,
    0x5a319e,
    0x64cfb0,
    0xe2834b,
    0xee1abd,
    0x685646,
    0xf72951,
    0x7165aa,
    0x7dfc5c,
    0xfbb0a7,
    0x0cd1e9,
    0x8a9d12,
    0x8604e4,
    0x00481f,
    0x9f3708,
    0x197bf3,
    0x15e205,
    0x93aefe,
    0xad50d0,
    0x2b1c2b,
    0x2785dd,
    0xa1c926,
    0x3eb631,
    0xb8faca,
    0xb4633c,
    0x322fc7,
    0xc99f60,
    0x4fd39b,
    0x434a6d,
    0xc50696,
    0x5a7981,
    0xdc357a,
    0xd0ac8c,
    0x56e077,
    0x681e59,
    0xee52a2,
    0xe2cb54,
    0x6487af,
    0xfbf8b8,
    0x7db443,
    0x712db5,
    0xf7614e,
    0x19a3d2,
    0x9fef29,
    0x9376df,
    0x153a24,
    0x8a4533,
    0x0c09c8,
    0x00903e,
    0x86dcc5,
    0xb822eb,
    0x3e6e10,
    0x32f7e6,
    0xb4bb1d,
    0x2bc40a,
    0xad88f1,
    0xa11107,
    0x275dfc,
    0xdced5b,
    0x5aa1a0,
    0x563856,
    0xd074ad,
    0x4f0bba,
    0xc94741,
    0xc5deb7,
    0x43924c,
    0x7d6c62,
    0xfb2099,
    0xf7b96f,
    0x71f594,
    0xee8a83,
    0x68c678,
    0x645f8e,
    0xe21375,
    0x15723b,
    0x933ec0,
    0x9fa736,
    0x19ebcd,
    0x8694da,
    0x00d821,
    0x0c41d7,
    0x8a0d2c,
    0xb4f302,
    0x32bff9,
    0x3e260f,
    0xb86af4,
    0x2715e3,
    0xa15918,
    0xadc0ee,
    0x2b8c15,
    0xd03cb2,
    0x567049,
    0x5ae9bf,
    0xdca544,
    0x43da53,
    0xc596a8,
    0xc90f5e,
    0x4f43a5,
    0x71bd8b,
    0xf7f170,
    0xfb6886,
    0x7d247d,
    0xe25b6a,
    0x641791,
    0x688e67,
    0xeec29c,
    0x3347a4,
    0xb50b5f,
    0xb992a9,
    0x3fde52,
    0xa0a145,
    0x26edbe,
    0x2a7448,
    0xac38b3,
    0x92c69d,
    0x148a66,
    0x181390,
    0x9e5f6b,
    0x01207c,
    0x876c87,
    0x8bf571,
    0x0db98a,
    0xf6092d,
    0x7045d6,
    0x7cdc20,
    0xfa90db,
    0x65efcc,
    0xe3a337,
    0xef3ac1,
    0x69763a,
    0x578814,
    0xd1c4ef,
    0xdd5d19,
    0x5b11e2,
    0xc46ef5,
    0x42220e,
    0x4ebbf8,
    0xc8f703,
    0x3f964d,
    0xb9dab6,
    0xb54340,
    0x330fbb,
    0xac70ac,
    0x2a3c57,
    0x26a5a1,
    0xa0e95a,
    0x9e1774,
    0x185b8f,
    0x14c279,
    0x928e82,
    0x0df195,
    0x8bbd6e,
    0x872498,
    0x016863,
    0xfad8c4,
    0x7c943f,
    0x700dc9,
    0xf64132,
    0x693e25,
    0xef72de,
    0xe3eb28,
    0x65a7d3,
    0x5b59fd,
    0xdd1506,
    0xd18cf0,
    0x57c00b,
    0xc8bf1c,
    0x4ef3e7,
    0x426a11,
    0xc426ea,
    0x2ae476,
    0xaca88d,
    0xa0317b,
    0x267d80,
    0xb90297,
    0x3f4e6c,
    0x33d79a,
    0xb59b61,
    0x8b654f,
    0x0d29b4,
    0x01b042,
    0x87fcb9,
    0x1883ae,
    0x9ecf55,
    0x9256a3,
    0x141a58,
    0xefaaff,
    0x69e604,
    0x657ff2,
    0xe33309,
    0x7c4c1e,
    0xfa00e5,
    0xf69913,
    0x70d5e8,
    0x4e2bc6,
    0xc8673d,
    0xc4fecb,
    0x42b230,
    0xddcd27,
    0x5b81dc,
    0x57182a,
    0xd154d1,
    0x26359f,
    0xa07964,
    0xace092,
    0x2aac69,
    0xb5d37e,
    0x339f85,
    0x3f0673,
    0xb94a88,
    0x87b4a6,
    0x01f85d,
    0x0d61ab,
    0x8b2d50,
    0x145247,
    0x921ebc,
    0x9e874a,
    0x18cbb1,
    0xe37b16,
    0x6537ed,
    0x69ae1b,
    0xefe2e0,
    0x709df7,
    0xf6d10c,
    0xfa48fa,
    0x7c0401,
    0x42fa2f,
    0xc4b6d4,
    0xc82f22,
    0x4e63d9,
    0xd11cce,
    0x575035,
    0x5bc9c3,
    0xdd8538
];
if (typeof Int32Array !== "undefined") $1c2b521624408a7b$var$TABLE = new Int32Array($1c2b521624408a7b$var$TABLE);
const $1c2b521624408a7b$var$crc24 = (0, $3ece5e4f58cfdf2d$export$2e2bcd8739ae039)("crc-24", function(buf, previous) {
    if (!(0, $919af1d2850606eb$export$a143d493d941bafc).isBuffer(buf)) buf = (0, $54dbf901ab9931e8$export$2e2bcd8739ae039)(buf);
    let crc = typeof previous !== "undefined" ? ~~previous : 0xb704ce;
    for(let index = 0; index < buf.length; index++){
        const byte = buf[index];
        crc = ($1c2b521624408a7b$var$TABLE[(crc >> 16 ^ byte) & 0xff] ^ crc << 8) & 0xffffff;
    }
    return crc;
});
var $1c2b521624408a7b$export$2e2bcd8739ae039 = $1c2b521624408a7b$var$crc24;





// Generated by `./pycrc.py --algorithm=table-driven --model=crc-32 --generate=c`
// prettier-ignore
let $56084beaddbef44d$var$TABLE = [
    0x00000000,
    0x77073096,
    0xee0e612c,
    0x990951ba,
    0x076dc419,
    0x706af48f,
    0xe963a535,
    0x9e6495a3,
    0x0edb8832,
    0x79dcb8a4,
    0xe0d5e91e,
    0x97d2d988,
    0x09b64c2b,
    0x7eb17cbd,
    0xe7b82d07,
    0x90bf1d91,
    0x1db71064,
    0x6ab020f2,
    0xf3b97148,
    0x84be41de,
    0x1adad47d,
    0x6ddde4eb,
    0xf4d4b551,
    0x83d385c7,
    0x136c9856,
    0x646ba8c0,
    0xfd62f97a,
    0x8a65c9ec,
    0x14015c4f,
    0x63066cd9,
    0xfa0f3d63,
    0x8d080df5,
    0x3b6e20c8,
    0x4c69105e,
    0xd56041e4,
    0xa2677172,
    0x3c03e4d1,
    0x4b04d447,
    0xd20d85fd,
    0xa50ab56b,
    0x35b5a8fa,
    0x42b2986c,
    0xdbbbc9d6,
    0xacbcf940,
    0x32d86ce3,
    0x45df5c75,
    0xdcd60dcf,
    0xabd13d59,
    0x26d930ac,
    0x51de003a,
    0xc8d75180,
    0xbfd06116,
    0x21b4f4b5,
    0x56b3c423,
    0xcfba9599,
    0xb8bda50f,
    0x2802b89e,
    0x5f058808,
    0xc60cd9b2,
    0xb10be924,
    0x2f6f7c87,
    0x58684c11,
    0xc1611dab,
    0xb6662d3d,
    0x76dc4190,
    0x01db7106,
    0x98d220bc,
    0xefd5102a,
    0x71b18589,
    0x06b6b51f,
    0x9fbfe4a5,
    0xe8b8d433,
    0x7807c9a2,
    0x0f00f934,
    0x9609a88e,
    0xe10e9818,
    0x7f6a0dbb,
    0x086d3d2d,
    0x91646c97,
    0xe6635c01,
    0x6b6b51f4,
    0x1c6c6162,
    0x856530d8,
    0xf262004e,
    0x6c0695ed,
    0x1b01a57b,
    0x8208f4c1,
    0xf50fc457,
    0x65b0d9c6,
    0x12b7e950,
    0x8bbeb8ea,
    0xfcb9887c,
    0x62dd1ddf,
    0x15da2d49,
    0x8cd37cf3,
    0xfbd44c65,
    0x4db26158,
    0x3ab551ce,
    0xa3bc0074,
    0xd4bb30e2,
    0x4adfa541,
    0x3dd895d7,
    0xa4d1c46d,
    0xd3d6f4fb,
    0x4369e96a,
    0x346ed9fc,
    0xad678846,
    0xda60b8d0,
    0x44042d73,
    0x33031de5,
    0xaa0a4c5f,
    0xdd0d7cc9,
    0x5005713c,
    0x270241aa,
    0xbe0b1010,
    0xc90c2086,
    0x5768b525,
    0x206f85b3,
    0xb966d409,
    0xce61e49f,
    0x5edef90e,
    0x29d9c998,
    0xb0d09822,
    0xc7d7a8b4,
    0x59b33d17,
    0x2eb40d81,
    0xb7bd5c3b,
    0xc0ba6cad,
    0xedb88320,
    0x9abfb3b6,
    0x03b6e20c,
    0x74b1d29a,
    0xead54739,
    0x9dd277af,
    0x04db2615,
    0x73dc1683,
    0xe3630b12,
    0x94643b84,
    0x0d6d6a3e,
    0x7a6a5aa8,
    0xe40ecf0b,
    0x9309ff9d,
    0x0a00ae27,
    0x7d079eb1,
    0xf00f9344,
    0x8708a3d2,
    0x1e01f268,
    0x6906c2fe,
    0xf762575d,
    0x806567cb,
    0x196c3671,
    0x6e6b06e7,
    0xfed41b76,
    0x89d32be0,
    0x10da7a5a,
    0x67dd4acc,
    0xf9b9df6f,
    0x8ebeeff9,
    0x17b7be43,
    0x60b08ed5,
    0xd6d6a3e8,
    0xa1d1937e,
    0x38d8c2c4,
    0x4fdff252,
    0xd1bb67f1,
    0xa6bc5767,
    0x3fb506dd,
    0x48b2364b,
    0xd80d2bda,
    0xaf0a1b4c,
    0x36034af6,
    0x41047a60,
    0xdf60efc3,
    0xa867df55,
    0x316e8eef,
    0x4669be79,
    0xcb61b38c,
    0xbc66831a,
    0x256fd2a0,
    0x5268e236,
    0xcc0c7795,
    0xbb0b4703,
    0x220216b9,
    0x5505262f,
    0xc5ba3bbe,
    0xb2bd0b28,
    0x2bb45a92,
    0x5cb36a04,
    0xc2d7ffa7,
    0xb5d0cf31,
    0x2cd99e8b,
    0x5bdeae1d,
    0x9b64c2b0,
    0xec63f226,
    0x756aa39c,
    0x026d930a,
    0x9c0906a9,
    0xeb0e363f,
    0x72076785,
    0x05005713,
    0x95bf4a82,
    0xe2b87a14,
    0x7bb12bae,
    0x0cb61b38,
    0x92d28e9b,
    0xe5d5be0d,
    0x7cdcefb7,
    0x0bdbdf21,
    0x86d3d2d4,
    0xf1d4e242,
    0x68ddb3f8,
    0x1fda836e,
    0x81be16cd,
    0xf6b9265b,
    0x6fb077e1,
    0x18b74777,
    0x88085ae6,
    0xff0f6a70,
    0x66063bca,
    0x11010b5c,
    0x8f659eff,
    0xf862ae69,
    0x616bffd3,
    0x166ccf45,
    0xa00ae278,
    0xd70dd2ee,
    0x4e048354,
    0x3903b3c2,
    0xa7672661,
    0xd06016f7,
    0x4969474d,
    0x3e6e77db,
    0xaed16a4a,
    0xd9d65adc,
    0x40df0b66,
    0x37d83bf0,
    0xa9bcae53,
    0xdebb9ec5,
    0x47b2cf7f,
    0x30b5ffe9,
    0xbdbdf21c,
    0xcabac28a,
    0x53b39330,
    0x24b4a3a6,
    0xbad03605,
    0xcdd70693,
    0x54de5729,
    0x23d967bf,
    0xb3667a2e,
    0xc4614ab8,
    0x5d681b02,
    0x2a6f2b94,
    0xb40bbe37,
    0xc30c8ea1,
    0x5a05df1b,
    0x2d02ef8d
];
if (typeof Int32Array !== "undefined") $56084beaddbef44d$var$TABLE = new Int32Array($56084beaddbef44d$var$TABLE);
const $56084beaddbef44d$var$crc32 = (0, $3ece5e4f58cfdf2d$export$2e2bcd8739ae039)("crc-32", function(buf, previous) {
    if (!(0, $919af1d2850606eb$export$a143d493d941bafc).isBuffer(buf)) buf = (0, $54dbf901ab9931e8$export$2e2bcd8739ae039)(buf);
    let crc = previous === 0 ? 0 : ~~previous ^ -1;
    for(let index = 0; index < buf.length; index++){
        const byte = buf[index];
        crc = $56084beaddbef44d$var$TABLE[(crc ^ byte) & 0xff] ^ crc >>> 8;
    }
    return crc ^ -1;
});
var $56084beaddbef44d$export$2e2bcd8739ae039 = $56084beaddbef44d$var$crc32;





// Generated by `./pycrc.py --algorithm=table-driven --model=jam --generate=c`
// prettier-ignore
let $c166312aea4dacd1$var$TABLE = [
    0x00000000,
    0x77073096,
    0xee0e612c,
    0x990951ba,
    0x076dc419,
    0x706af48f,
    0xe963a535,
    0x9e6495a3,
    0x0edb8832,
    0x79dcb8a4,
    0xe0d5e91e,
    0x97d2d988,
    0x09b64c2b,
    0x7eb17cbd,
    0xe7b82d07,
    0x90bf1d91,
    0x1db71064,
    0x6ab020f2,
    0xf3b97148,
    0x84be41de,
    0x1adad47d,
    0x6ddde4eb,
    0xf4d4b551,
    0x83d385c7,
    0x136c9856,
    0x646ba8c0,
    0xfd62f97a,
    0x8a65c9ec,
    0x14015c4f,
    0x63066cd9,
    0xfa0f3d63,
    0x8d080df5,
    0x3b6e20c8,
    0x4c69105e,
    0xd56041e4,
    0xa2677172,
    0x3c03e4d1,
    0x4b04d447,
    0xd20d85fd,
    0xa50ab56b,
    0x35b5a8fa,
    0x42b2986c,
    0xdbbbc9d6,
    0xacbcf940,
    0x32d86ce3,
    0x45df5c75,
    0xdcd60dcf,
    0xabd13d59,
    0x26d930ac,
    0x51de003a,
    0xc8d75180,
    0xbfd06116,
    0x21b4f4b5,
    0x56b3c423,
    0xcfba9599,
    0xb8bda50f,
    0x2802b89e,
    0x5f058808,
    0xc60cd9b2,
    0xb10be924,
    0x2f6f7c87,
    0x58684c11,
    0xc1611dab,
    0xb6662d3d,
    0x76dc4190,
    0x01db7106,
    0x98d220bc,
    0xefd5102a,
    0x71b18589,
    0x06b6b51f,
    0x9fbfe4a5,
    0xe8b8d433,
    0x7807c9a2,
    0x0f00f934,
    0x9609a88e,
    0xe10e9818,
    0x7f6a0dbb,
    0x086d3d2d,
    0x91646c97,
    0xe6635c01,
    0x6b6b51f4,
    0x1c6c6162,
    0x856530d8,
    0xf262004e,
    0x6c0695ed,
    0x1b01a57b,
    0x8208f4c1,
    0xf50fc457,
    0x65b0d9c6,
    0x12b7e950,
    0x8bbeb8ea,
    0xfcb9887c,
    0x62dd1ddf,
    0x15da2d49,
    0x8cd37cf3,
    0xfbd44c65,
    0x4db26158,
    0x3ab551ce,
    0xa3bc0074,
    0xd4bb30e2,
    0x4adfa541,
    0x3dd895d7,
    0xa4d1c46d,
    0xd3d6f4fb,
    0x4369e96a,
    0x346ed9fc,
    0xad678846,
    0xda60b8d0,
    0x44042d73,
    0x33031de5,
    0xaa0a4c5f,
    0xdd0d7cc9,
    0x5005713c,
    0x270241aa,
    0xbe0b1010,
    0xc90c2086,
    0x5768b525,
    0x206f85b3,
    0xb966d409,
    0xce61e49f,
    0x5edef90e,
    0x29d9c998,
    0xb0d09822,
    0xc7d7a8b4,
    0x59b33d17,
    0x2eb40d81,
    0xb7bd5c3b,
    0xc0ba6cad,
    0xedb88320,
    0x9abfb3b6,
    0x03b6e20c,
    0x74b1d29a,
    0xead54739,
    0x9dd277af,
    0x04db2615,
    0x73dc1683,
    0xe3630b12,
    0x94643b84,
    0x0d6d6a3e,
    0x7a6a5aa8,
    0xe40ecf0b,
    0x9309ff9d,
    0x0a00ae27,
    0x7d079eb1,
    0xf00f9344,
    0x8708a3d2,
    0x1e01f268,
    0x6906c2fe,
    0xf762575d,
    0x806567cb,
    0x196c3671,
    0x6e6b06e7,
    0xfed41b76,
    0x89d32be0,
    0x10da7a5a,
    0x67dd4acc,
    0xf9b9df6f,
    0x8ebeeff9,
    0x17b7be43,
    0x60b08ed5,
    0xd6d6a3e8,
    0xa1d1937e,
    0x38d8c2c4,
    0x4fdff252,
    0xd1bb67f1,
    0xa6bc5767,
    0x3fb506dd,
    0x48b2364b,
    0xd80d2bda,
    0xaf0a1b4c,
    0x36034af6,
    0x41047a60,
    0xdf60efc3,
    0xa867df55,
    0x316e8eef,
    0x4669be79,
    0xcb61b38c,
    0xbc66831a,
    0x256fd2a0,
    0x5268e236,
    0xcc0c7795,
    0xbb0b4703,
    0x220216b9,
    0x5505262f,
    0xc5ba3bbe,
    0xb2bd0b28,
    0x2bb45a92,
    0x5cb36a04,
    0xc2d7ffa7,
    0xb5d0cf31,
    0x2cd99e8b,
    0x5bdeae1d,
    0x9b64c2b0,
    0xec63f226,
    0x756aa39c,
    0x026d930a,
    0x9c0906a9,
    0xeb0e363f,
    0x72076785,
    0x05005713,
    0x95bf4a82,
    0xe2b87a14,
    0x7bb12bae,
    0x0cb61b38,
    0x92d28e9b,
    0xe5d5be0d,
    0x7cdcefb7,
    0x0bdbdf21,
    0x86d3d2d4,
    0xf1d4e242,
    0x68ddb3f8,
    0x1fda836e,
    0x81be16cd,
    0xf6b9265b,
    0x6fb077e1,
    0x18b74777,
    0x88085ae6,
    0xff0f6a70,
    0x66063bca,
    0x11010b5c,
    0x8f659eff,
    0xf862ae69,
    0x616bffd3,
    0x166ccf45,
    0xa00ae278,
    0xd70dd2ee,
    0x4e048354,
    0x3903b3c2,
    0xa7672661,
    0xd06016f7,
    0x4969474d,
    0x3e6e77db,
    0xaed16a4a,
    0xd9d65adc,
    0x40df0b66,
    0x37d83bf0,
    0xa9bcae53,
    0xdebb9ec5,
    0x47b2cf7f,
    0x30b5ffe9,
    0xbdbdf21c,
    0xcabac28a,
    0x53b39330,
    0x24b4a3a6,
    0xbad03605,
    0xcdd70693,
    0x54de5729,
    0x23d967bf,
    0xb3667a2e,
    0xc4614ab8,
    0x5d681b02,
    0x2a6f2b94,
    0xb40bbe37,
    0xc30c8ea1,
    0x5a05df1b,
    0x2d02ef8d
];
if (typeof Int32Array !== "undefined") $c166312aea4dacd1$var$TABLE = new Int32Array($c166312aea4dacd1$var$TABLE);
const $c166312aea4dacd1$var$crcjam = (0, $3ece5e4f58cfdf2d$export$2e2bcd8739ae039)("jam", function(buf, previous = -1) {
    if (!(0, $919af1d2850606eb$export$a143d493d941bafc).isBuffer(buf)) buf = (0, $54dbf901ab9931e8$export$2e2bcd8739ae039)(buf);
    let crc = previous === 0 ? 0 : ~~previous;
    for(let index = 0; index < buf.length; index++){
        const byte = buf[index];
        crc = $c166312aea4dacd1$var$TABLE[(crc ^ byte) & 0xff] ^ crc >>> 8;
    }
    return crc;
});
var $c166312aea4dacd1$export$2e2bcd8739ae039 = $c166312aea4dacd1$var$crcjam;


var $d0e3cae8dd384801$export$2e2bcd8739ae039 = {
    crc1: $859b0538169a5c14$export$2e2bcd8739ae039,
    crc8: $9d562bff356ea457$export$2e2bcd8739ae039,
    crc81wire: $95a504a162276221$export$2e2bcd8739ae039,
    crc16: $d40ca97efc44b812$export$2e2bcd8739ae039,
    crc16ccitt: $755349af12deb141$export$2e2bcd8739ae039,
    crc16modbus: $9efec5a7c5dde2cc$export$2e2bcd8739ae039,
    crc16xmodem: $37901099455222b1$export$2e2bcd8739ae039,
    crc16kermit: $a6a4bcf3d09e53b1$export$2e2bcd8739ae039,
    crc24: $1c2b521624408a7b$export$2e2bcd8739ae039,
    crc32: $56084beaddbef44d$export$2e2bcd8739ae039,
    crcjam: $c166312aea4dacd1$export$2e2bcd8739ae039
};



var $8022e38477187c54$exports = {};

// bip 173 bech 32 addresses (https://github.com/bitcoin/bips/blob/master/bip-0173.mediawiki)
$8022e38477187c54$exports = {
    isValidAddress: function(address, currency, opts = {}) {
        const { networkType: networkType = "prod" } = opts;
        const decoded = $3c2eebea5d8da41b$exports.decode(address, $3c2eebea5d8da41b$exports.encodings.BECH32);
        if (!decoded) return false;
        const bech32Hrp = decoded.hrp;
        let correctBech32Hrps;
        if (networkType === "prod" || networkType === "testnet") correctBech32Hrps = currency.bech32Hrp[networkType];
        else if (currency.bech32Hrp) correctBech32Hrps = currency.bech32Hrp.prod.concat(currency.bech32Hrp.testnet);
        else return false;
        if (correctBech32Hrps.indexOf(bech32Hrp) === -1) return false;
        return true;
    }
};


function $afee0a8b798c70de$var$getDecoded(address) {
    try {
        var decoded = $8560caef586a2c5f$exports.decode(address);
        return $1e0d9cd559aaa21d$exports.decode(new Uint8Array(decoded).buffer);
    } catch (e) {
        // if decoding fails, assume invalid address
        return null;
    }
}
function $afee0a8b798c70de$var$isValidAddressV1(address) {
    var decoded = $afee0a8b798c70de$var$getDecoded(address);
    if (!decoded || !Array.isArray(decoded) && decoded.length != 2) return false;
    var tagged = decoded[0];
    var validCrc = decoded[1];
    if (typeof validCrc != "number") return false;
    // get crc of the payload
    var crc = $56084beaddbef44d$export$2e2bcd8739ae039(tagged);
    return crc == validCrc;
}
function $afee0a8b798c70de$var$isValidAddressShelley(address, currency, opts) {
    // shelley address are just bip 173 - bech32 addresses (https://cips.cardano.org/cips/cip4/)
    return $8022e38477187c54$exports.isValidAddress(address, currency, opts);
}
$afee0a8b798c70de$exports = {
    isValidAddress: function(address, currency, opts = {}) {
        return $afee0a8b798c70de$var$isValidAddressV1(address) || $afee0a8b798c70de$var$isValidAddressShelley(address, currency, opts);
    }
};


var $5f2aef207c8ec557$exports = {};

var $7a42e159fb5b6be8$exports = {};
var $35fbaf3b7451c14f$exports = {};
/*
	JavaScript BigInteger library version 0.9.1
	http://silentmatt.com/biginteger/
	Copyright (c) 2009 Matthew Crumley <email@matthewcrumley.com>
	Copyright (c) 2010,2011 by John Tobey <John.Tobey@gmail.com>
	Licensed under the MIT license.
	Support for arbitrary internal representation base was added by
	Vitaly Magerya.
*/ /*
	File: biginteger.js
	Exports:
		<BigInteger>
*/ (function(exports1) {
    "use strict";
    /*
        Class: BigInteger
        An arbitrarily-large integer.
        <BigInteger> objects should be considered immutable. None of the "built-in"
        methods modify *this* or their arguments. All properties should be
        considered private.
        All the methods of <BigInteger> instances can be called "statically". The
        static versions are convenient if you don't already have a <BigInteger>
        object.
        As an example, these calls are equivalent.
        > BigInteger(4).multiply(5); // returns BigInteger(20);
        > BigInteger.multiply(4, 5); // returns BigInteger(20);
        > var a = 42;
        > var a = BigInteger.toJSValue("0b101010"); // Not completely useless...
    */ var CONSTRUCT = {}; // Unique token to call "private" version of constructor
    /*
        Constructor: BigInteger()
        Convert a value to a <BigInteger>.
        Although <BigInteger()> is the constructor for <BigInteger> objects, it is
        best not to call it as a constructor. If *n* is a <BigInteger> object, it is
        simply returned as-is. Otherwise, <BigInteger()> is equivalent to <parse>
        without a radix argument.
        > var n0 = BigInteger();      // Same as <BigInteger.ZERO>
        > var n1 = BigInteger("123"); // Create a new <BigInteger> with value 123
        > var n2 = BigInteger(123);   // Create a new <BigInteger> with value 123
        > var n3 = BigInteger(n2);    // Return n2, unchanged
        The constructor form only takes an array and a sign. *n* must be an
        array of numbers in little-endian order, where each digit is between 0
        and BigInteger.base.  The second parameter sets the sign: -1 for
        negative, +1 for positive, or 0 for zero. The array is *not copied and
        may be modified*. If the array contains only zeros, the sign parameter
        is ignored and is forced to zero.
        > new BigInteger([5], -1): create a new BigInteger with value -5
        Parameters:
            n - Value to convert to a <BigInteger>.
        Returns:
            A <BigInteger> value.
        See Also:
            <parse>, <BigInteger>
    */ function BigInteger(n, s, token) {
        if (token !== CONSTRUCT) {
            if (n instanceof BigInteger) return n;
            else if (typeof n === "undefined") return ZERO;
            return BigInteger.parse(n);
        }
        n = n || []; // Provide the nullary constructor for subclasses.
        while(n.length && !n[n.length - 1])--n.length;
        this._d = n;
        this._s = n.length ? s || 1 : 0;
    }
    BigInteger._construct = function(n, s) {
        return new BigInteger(n, s, CONSTRUCT);
    };
    // Base-10 speedup hacks in parse, toString, exp10 and log functions
    // require base to be a power of 10. 10^7 is the largest such power
    // that won't cause a precision loss when digits are multiplied.
    var BigInteger_base = 10000000;
    var BigInteger_base_log10 = 7;
    BigInteger.base = BigInteger_base;
    BigInteger.base_log10 = BigInteger_base_log10;
    var ZERO = new BigInteger([], 0, CONSTRUCT);
    // Constant: ZERO
    // <BigInteger> 0.
    BigInteger.ZERO = ZERO;
    var ONE = new BigInteger([
        1
    ], 1, CONSTRUCT);
    // Constant: ONE
    // <BigInteger> 1.
    BigInteger.ONE = ONE;
    var M_ONE = new BigInteger(ONE._d, -1, CONSTRUCT);
    // Constant: M_ONE
    // <BigInteger> -1.
    BigInteger.M_ONE = M_ONE;
    // Constant: _0
    // Shortcut for <ZERO>.
    BigInteger._0 = ZERO;
    // Constant: _1
    // Shortcut for <ONE>.
    BigInteger._1 = ONE;
    /*
        Constant: small
        Array of <BigIntegers> from 0 to 36.
        These are used internally for parsing, but useful when you need a "small"
        <BigInteger>.
        See Also:
            <ZERO>, <ONE>, <_0>, <_1>
    */ BigInteger.small = [
        ZERO,
        ONE,
        /* Assuming BigInteger_base > 36 */ new BigInteger([
            2
        ], 1, CONSTRUCT),
        new BigInteger([
            3
        ], 1, CONSTRUCT),
        new BigInteger([
            4
        ], 1, CONSTRUCT),
        new BigInteger([
            5
        ], 1, CONSTRUCT),
        new BigInteger([
            6
        ], 1, CONSTRUCT),
        new BigInteger([
            7
        ], 1, CONSTRUCT),
        new BigInteger([
            8
        ], 1, CONSTRUCT),
        new BigInteger([
            9
        ], 1, CONSTRUCT),
        new BigInteger([
            10
        ], 1, CONSTRUCT),
        new BigInteger([
            11
        ], 1, CONSTRUCT),
        new BigInteger([
            12
        ], 1, CONSTRUCT),
        new BigInteger([
            13
        ], 1, CONSTRUCT),
        new BigInteger([
            14
        ], 1, CONSTRUCT),
        new BigInteger([
            15
        ], 1, CONSTRUCT),
        new BigInteger([
            16
        ], 1, CONSTRUCT),
        new BigInteger([
            17
        ], 1, CONSTRUCT),
        new BigInteger([
            18
        ], 1, CONSTRUCT),
        new BigInteger([
            19
        ], 1, CONSTRUCT),
        new BigInteger([
            20
        ], 1, CONSTRUCT),
        new BigInteger([
            21
        ], 1, CONSTRUCT),
        new BigInteger([
            22
        ], 1, CONSTRUCT),
        new BigInteger([
            23
        ], 1, CONSTRUCT),
        new BigInteger([
            24
        ], 1, CONSTRUCT),
        new BigInteger([
            25
        ], 1, CONSTRUCT),
        new BigInteger([
            26
        ], 1, CONSTRUCT),
        new BigInteger([
            27
        ], 1, CONSTRUCT),
        new BigInteger([
            28
        ], 1, CONSTRUCT),
        new BigInteger([
            29
        ], 1, CONSTRUCT),
        new BigInteger([
            30
        ], 1, CONSTRUCT),
        new BigInteger([
            31
        ], 1, CONSTRUCT),
        new BigInteger([
            32
        ], 1, CONSTRUCT),
        new BigInteger([
            33
        ], 1, CONSTRUCT),
        new BigInteger([
            34
        ], 1, CONSTRUCT),
        new BigInteger([
            35
        ], 1, CONSTRUCT),
        new BigInteger([
            36
        ], 1, CONSTRUCT)
    ];
    // Used for parsing/radix conversion
    BigInteger.digits = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    /*
        Method: toString
        Convert a <BigInteger> to a string.
        When *base* is greater than 10, letters are upper case.
        Parameters:
            base - Optional base to represent the number in (default is base 10).
                   Must be between 2 and 36 inclusive, or an Error will be thrown.
        Returns:
            The string representation of the <BigInteger>.
    */ BigInteger.prototype.toString = function(base) {
        base = +base || 10;
        if (base < 2 || base > 36) throw new Error("illegal radix " + base + ".");
        if (this._s === 0) return "0";
        if (base === 10) {
            var str = this._s < 0 ? "-" : "";
            str += this._d[this._d.length - 1].toString();
            for(var i = this._d.length - 2; i >= 0; i--){
                var group = this._d[i].toString();
                while(group.length < BigInteger_base_log10)group = "0" + group;
                str += group;
            }
            return str;
        } else {
            var numerals = BigInteger.digits;
            base = BigInteger.small[base];
            var sign = this._s;
            var n = this.abs();
            var digits = [];
            var digit;
            while(n._s !== 0){
                var divmod = n.divRem(base);
                n = divmod[0];
                digit = divmod[1];
                // TODO: This could be changed to unshift instead of reversing at the end.
                // Benchmark both to compare speeds.
                digits.push(numerals[digit.valueOf()]);
            }
            return (sign < 0 ? "-" : "") + digits.reverse().join("");
        }
    };
    // Verify strings for parsing
    BigInteger.radixRegex = [
        /^$/,
        /^$/,
        /^[01]*$/,
        /^[012]*$/,
        /^[0-3]*$/,
        /^[0-4]*$/,
        /^[0-5]*$/,
        /^[0-6]*$/,
        /^[0-7]*$/,
        /^[0-8]*$/,
        /^[0-9]*$/,
        /^[0-9aA]*$/,
        /^[0-9abAB]*$/,
        /^[0-9abcABC]*$/,
        /^[0-9a-dA-D]*$/,
        /^[0-9a-eA-E]*$/,
        /^[0-9a-fA-F]*$/,
        /^[0-9a-gA-G]*$/,
        /^[0-9a-hA-H]*$/,
        /^[0-9a-iA-I]*$/,
        /^[0-9a-jA-J]*$/,
        /^[0-9a-kA-K]*$/,
        /^[0-9a-lA-L]*$/,
        /^[0-9a-mA-M]*$/,
        /^[0-9a-nA-N]*$/,
        /^[0-9a-oA-O]*$/,
        /^[0-9a-pA-P]*$/,
        /^[0-9a-qA-Q]*$/,
        /^[0-9a-rA-R]*$/,
        /^[0-9a-sA-S]*$/,
        /^[0-9a-tA-T]*$/,
        /^[0-9a-uA-U]*$/,
        /^[0-9a-vA-V]*$/,
        /^[0-9a-wA-W]*$/,
        /^[0-9a-xA-X]*$/,
        /^[0-9a-yA-Y]*$/,
        /^[0-9a-zA-Z]*$/
    ];
    /*
        Function: parse
        Parse a string into a <BigInteger>.
        *base* is optional but, if provided, must be from 2 to 36 inclusive. If
        *base* is not provided, it will be guessed based on the leading characters
        of *s* as follows:
        - "0x" or "0X": *base* = 16
        - "0c" or "0C": *base* = 8
        - "0b" or "0B": *base* = 2
        - else: *base* = 10
        If no base is provided, or *base* is 10, the number can be in exponential
        form. For example, these are all valid:
        > BigInteger.parse("1e9");              // Same as "1000000000"
        > BigInteger.parse("1.234*10^3");       // Same as 1234
        > BigInteger.parse("56789 * 10 ** -2"); // Same as 567
        If any characters fall outside the range defined by the radix, an exception
        will be thrown.
        Parameters:
            s - The string to parse.
            base - Optional radix (default is to guess based on *s*).
        Returns:
            a <BigInteger> instance.
    */ BigInteger.parse = function(s, base) {
        // Expands a number in exponential form to decimal form.
        // expandExponential("-13.441*10^5") === "1344100";
        // expandExponential("1.12300e-1") === "0.112300";
        // expandExponential(1000000000000000000000000000000) === "1000000000000000000000000000000";
        function expandExponential(str) {
            str = str.replace(/\s*[*xX]\s*10\s*(\^|\*\*)\s*/, "e");
            return str.replace(/^([+\-])?(\d+)\.?(\d*)[eE]([+\-]?\d+)$/, function(x, s, n, f, c) {
                c = +c;
                var l = c < 0;
                var i = n.length + c;
                x = (l ? n : f).length;
                c = (c = Math.abs(c)) >= x ? c - x + l : 0;
                var z = new Array(c + 1).join("0");
                var r = n + f;
                return (s || "") + (l ? r = z + r : r += z).substr(0, i += l ? z.length : 0) + (i < r.length ? "." + r.substr(i) : "");
            });
        }
        s = s.toString();
        if (typeof base === "undefined" || +base === 10) s = expandExponential(s);
        var prefixRE;
        if (typeof base === "undefined") prefixRE = "0[xcb]";
        else if (base == 16) prefixRE = "0x";
        else if (base == 8) prefixRE = "0c";
        else if (base == 2) prefixRE = "0b";
        else prefixRE = "";
        var parts = new RegExp("^([+\\-]?)(" + prefixRE + ")?([0-9a-z]*)(?:\\.\\d*)?$", "i").exec(s);
        if (parts) {
            var sign = parts[1] || "+";
            var baseSection = parts[2] || "";
            var digits = parts[3] || "";
            if (typeof base === "undefined") {
                // Guess base
                if (baseSection === "0x" || baseSection === "0X") base = 16;
                else if (baseSection === "0c" || baseSection === "0C") base = 8;
                else if (baseSection === "0b" || baseSection === "0B") base = 2;
                else base = 10;
            } else if (base < 2 || base > 36) throw new Error("Illegal radix " + base + ".");
            base = +base;
            // Check for digits outside the range
            if (!BigInteger.radixRegex[base].test(digits)) throw new Error("Bad digit for radix " + base);
            // Strip leading zeros, and convert to array
            digits = digits.replace(/^0+/, "").split("");
            if (digits.length === 0) return ZERO;
            // Get the sign (we know it's not zero)
            sign = sign === "-" ? -1 : 1;
            // Optimize 10
            if (base == 10) {
                var d = [];
                while(digits.length >= BigInteger_base_log10)d.push(parseInt(digits.splice(digits.length - BigInteger.base_log10, BigInteger.base_log10).join(""), 10));
                d.push(parseInt(digits.join(""), 10));
                return new BigInteger(d, sign, CONSTRUCT);
            }
            // Do the conversion
            var d = ZERO;
            base = BigInteger.small[base];
            var small = BigInteger.small;
            for(var i = 0; i < digits.length; i++)d = d.multiply(base).add(small[parseInt(digits[i], 36)]);
            return new BigInteger(d._d, sign, CONSTRUCT);
        } else throw new Error("Invalid BigInteger format: " + s);
    };
    /*
        Function: add
        Add two <BigIntegers>.
        Parameters:
            n - The number to add to *this*. Will be converted to a <BigInteger>.
        Returns:
            The numbers added together.
        See Also:
            <subtract>, <multiply>, <quotient>, <next>
    */ BigInteger.prototype.add = function(n) {
        if (this._s === 0) return BigInteger(n);
        n = BigInteger(n);
        if (n._s === 0) return this;
        if (this._s !== n._s) {
            n = n.negate();
            return this.subtract(n);
        }
        var a = this._d;
        var b = n._d;
        var al = a.length;
        var bl = b.length;
        var sum = new Array(Math.max(al, bl) + 1);
        var size = Math.min(al, bl);
        var carry = 0;
        var digit;
        for(var i = 0; i < size; i++){
            digit = a[i] + b[i] + carry;
            sum[i] = digit % BigInteger_base;
            carry = digit / BigInteger_base | 0;
        }
        if (bl > al) {
            a = b;
            al = bl;
        }
        for(i = size; carry && i < al; i++){
            digit = a[i] + carry;
            sum[i] = digit % BigInteger_base;
            carry = digit / BigInteger_base | 0;
        }
        if (carry) sum[i] = carry;
        for(; i < al; i++)sum[i] = a[i];
        return new BigInteger(sum, this._s, CONSTRUCT);
    };
    /*
        Function: negate
        Get the additive inverse of a <BigInteger>.
        Returns:
            A <BigInteger> with the same magnatude, but with the opposite sign.
        See Also:
            <abs>
    */ BigInteger.prototype.negate = function() {
        return new BigInteger(this._d, -this._s | 0, CONSTRUCT);
    };
    /*
        Function: abs
        Get the absolute value of a <BigInteger>.
        Returns:
            A <BigInteger> with the same magnatude, but always positive (or zero).
        See Also:
            <negate>
    */ BigInteger.prototype.abs = function() {
        return this._s < 0 ? this.negate() : this;
    };
    /*
        Function: subtract
        Subtract two <BigIntegers>.
        Parameters:
            n - The number to subtract from *this*. Will be converted to a <BigInteger>.
        Returns:
            The *n* subtracted from *this*.
        See Also:
            <add>, <multiply>, <quotient>, <prev>
    */ BigInteger.prototype.subtract = function(n) {
        if (this._s === 0) return BigInteger(n).negate();
        n = BigInteger(n);
        if (n._s === 0) return this;
        if (this._s !== n._s) {
            n = n.negate();
            return this.add(n);
        }
        var m = this;
        // negative - negative => -|a| - -|b| => -|a| + |b| => |b| - |a|
        if (this._s < 0) {
            m = new BigInteger(n._d, 1, CONSTRUCT);
            n = new BigInteger(this._d, 1, CONSTRUCT);
        }
        // Both are positive => a - b
        var sign = m.compareAbs(n);
        if (sign === 0) return ZERO;
        else if (sign < 0) {
            // swap m and n
            var t = n;
            n = m;
            m = t;
        }
        // a > b
        var a = m._d;
        var b = n._d;
        var al = a.length;
        var bl = b.length;
        var diff = new Array(al); // al >= bl since a > b
        var borrow = 0;
        var i;
        var digit;
        for(i = 0; i < bl; i++){
            digit = a[i] - borrow - b[i];
            if (digit < 0) {
                digit += BigInteger_base;
                borrow = 1;
            } else borrow = 0;
            diff[i] = digit;
        }
        for(i = bl; i < al; i++){
            digit = a[i] - borrow;
            if (digit < 0) digit += BigInteger_base;
            else {
                diff[i++] = digit;
                break;
            }
            diff[i] = digit;
        }
        for(; i < al; i++)diff[i] = a[i];
        return new BigInteger(diff, sign, CONSTRUCT);
    };
    (function() {
        function addOne(n, sign) {
            var a = n._d;
            var sum = a.slice();
            var carry = true;
            var i = 0;
            while(true){
                var digit = (a[i] || 0) + 1;
                sum[i] = digit % BigInteger_base;
                if (digit <= BigInteger_base - 1) break;
                ++i;
            }
            return new BigInteger(sum, sign, CONSTRUCT);
        }
        function subtractOne(n, sign) {
            var a = n._d;
            var sum = a.slice();
            var borrow = true;
            var i = 0;
            while(true){
                var digit = (a[i] || 0) - 1;
                if (digit < 0) sum[i] = digit + BigInteger_base;
                else {
                    sum[i] = digit;
                    break;
                }
                ++i;
            }
            return new BigInteger(sum, sign, CONSTRUCT);
        }
        /*
            Function: next
            Get the next <BigInteger> (add one).
            Returns:
                *this* + 1.
            See Also:
                <add>, <prev>
        */ BigInteger.prototype.next = function() {
            switch(this._s){
                case 0:
                    return ONE;
                case -1:
                    return subtractOne(this, -1);
                // case 1:
                default:
                    return addOne(this, 1);
            }
        };
        /*
            Function: prev
            Get the previous <BigInteger> (subtract one).
            Returns:
                *this* - 1.
            See Also:
                <next>, <subtract>
        */ BigInteger.prototype.prev = function() {
            switch(this._s){
                case 0:
                    return M_ONE;
                case -1:
                    return addOne(this, -1);
                // case 1:
                default:
                    return subtractOne(this, 1);
            }
        };
    })();
    /*
        Function: compareAbs
        Compare the absolute value of two <BigIntegers>.
        Calling <compareAbs> is faster than calling <abs> twice, then <compare>.
        Parameters:
            n - The number to compare to *this*. Will be converted to a <BigInteger>.
        Returns:
            -1, 0, or +1 if *|this|* is less than, equal to, or greater than *|n|*.
        See Also:
            <compare>, <abs>
    */ BigInteger.prototype.compareAbs = function(n) {
        if (this === n) return 0;
        if (!(n instanceof BigInteger)) {
            if (!isFinite(n)) return isNaN(n) ? n : -1;
            n = BigInteger(n);
        }
        if (this._s === 0) return n._s !== 0 ? -1 : 0;
        if (n._s === 0) return 1;
        var l = this._d.length;
        var nl = n._d.length;
        if (l < nl) return -1;
        else if (l > nl) return 1;
        var a = this._d;
        var b = n._d;
        for(var i = l - 1; i >= 0; i--){
            if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
        }
        return 0;
    };
    /*
        Function: compare
        Compare two <BigIntegers>.
        Parameters:
            n - The number to compare to *this*. Will be converted to a <BigInteger>.
        Returns:
            -1, 0, or +1 if *this* is less than, equal to, or greater than *n*.
        See Also:
            <compareAbs>, <isPositive>, <isNegative>, <isUnit>
    */ BigInteger.prototype.compare = function(n) {
        if (this === n) return 0;
        n = BigInteger(n);
        if (this._s === 0) return -n._s;
        if (this._s === n._s) {
            var cmp = this.compareAbs(n);
            return cmp * this._s;
        } else return this._s;
    };
    /*
        Function: isUnit
        Return true iff *this* is either 1 or -1.
        Returns:
            true if *this* compares equal to <BigInteger.ONE> or <BigInteger.M_ONE>.
        See Also:
            <isZero>, <isNegative>, <isPositive>, <compareAbs>, <compare>,
            <BigInteger.ONE>, <BigInteger.M_ONE>
    */ BigInteger.prototype.isUnit = function() {
        return this === ONE || this === M_ONE || this._d.length === 1 && this._d[0] === 1;
    };
    /*
        Function: multiply
        Multiply two <BigIntegers>.
        Parameters:
            n - The number to multiply *this* by. Will be converted to a
            <BigInteger>.
        Returns:
            The numbers multiplied together.
        See Also:
            <add>, <subtract>, <quotient>, <square>
    */ BigInteger.prototype.multiply = function(n) {
        // TODO: Consider adding Karatsuba multiplication for large numbers
        if (this._s === 0) return ZERO;
        n = BigInteger(n);
        if (n._s === 0) return ZERO;
        if (this.isUnit()) {
            if (this._s < 0) return n.negate();
            return n;
        }
        if (n.isUnit()) {
            if (n._s < 0) return this.negate();
            return this;
        }
        if (this === n) return this.square();
        var r = this._d.length >= n._d.length;
        var a = (r ? this : n)._d; // a will be longer than b
        var b = (r ? n : this)._d;
        var al = a.length;
        var bl = b.length;
        var pl = al + bl;
        var partial = new Array(pl);
        var i;
        for(i = 0; i < pl; i++)partial[i] = 0;
        for(i = 0; i < bl; i++){
            var carry = 0;
            var bi = b[i];
            var jlimit = al + i;
            var digit;
            for(var j = i; j < jlimit; j++){
                digit = partial[j] + bi * a[j - i] + carry;
                carry = digit / BigInteger_base | 0;
                partial[j] = digit % BigInteger_base | 0;
            }
            if (carry) {
                digit = partial[j] + carry;
                carry = digit / BigInteger_base | 0;
                partial[j] = digit % BigInteger_base;
            }
        }
        return new BigInteger(partial, this._s * n._s, CONSTRUCT);
    };
    // Multiply a BigInteger by a single-digit native number
    // Assumes that this and n are >= 0
    // This is not really intended to be used outside the library itself
    BigInteger.prototype.multiplySingleDigit = function(n) {
        if (n === 0 || this._s === 0) return ZERO;
        if (n === 1) return this;
        var digit;
        if (this._d.length === 1) {
            digit = this._d[0] * n;
            if (digit >= BigInteger_base) return new BigInteger([
                digit % BigInteger_base | 0,
                digit / BigInteger_base | 0
            ], 1, CONSTRUCT);
            return new BigInteger([
                digit
            ], 1, CONSTRUCT);
        }
        if (n === 2) return this.add(this);
        if (this.isUnit()) return new BigInteger([
            n
        ], 1, CONSTRUCT);
        var a = this._d;
        var al = a.length;
        var pl = al + 1;
        var partial = new Array(pl);
        for(var i = 0; i < pl; i++)partial[i] = 0;
        var carry = 0;
        for(var j = 0; j < al; j++){
            digit = n * a[j] + carry;
            carry = digit / BigInteger_base | 0;
            partial[j] = digit % BigInteger_base | 0;
        }
        if (carry) partial[j] = carry;
        return new BigInteger(partial, 1, CONSTRUCT);
    };
    /*
        Function: square
        Multiply a <BigInteger> by itself.
        This is slightly faster than regular multiplication, since it removes the
        duplicated multiplcations.
        Returns:
            > this.multiply(this)
        See Also:
            <multiply>
    */ BigInteger.prototype.square = function() {
        // Normally, squaring a 10-digit number would take 100 multiplications.
        // Of these 10 are unique diagonals, of the remaining 90 (100-10), 45 are repeated.
        // This procedure saves (N*(N-1))/2 multiplications, (e.g., 45 of 100 multiplies).
        // Based on code by Gary Darby, Intellitech Systems Inc., www.DelphiForFun.org
        if (this._s === 0) return ZERO;
        if (this.isUnit()) return ONE;
        var digits = this._d;
        var length = digits.length;
        var imult1 = new Array(length + length + 1);
        var product, carry, k;
        var i;
        // Calculate diagonal
        for(i = 0; i < length; i++){
            k = i * 2;
            product = digits[i] * digits[i];
            carry = product / BigInteger_base | 0;
            imult1[k] = product % BigInteger_base;
            imult1[k + 1] = carry;
        }
        // Calculate repeating part
        for(i = 0; i < length; i++){
            carry = 0;
            k = i * 2 + 1;
            for(var j = i + 1; j < length; j++, k++){
                product = digits[j] * digits[i] * 2 + imult1[k] + carry;
                carry = product / BigInteger_base | 0;
                imult1[k] = product % BigInteger_base;
            }
            k = length + i;
            var digit = carry + imult1[k];
            carry = digit / BigInteger_base | 0;
            imult1[k] = digit % BigInteger_base;
            imult1[k + 1] += carry;
        }
        return new BigInteger(imult1, 1, CONSTRUCT);
    };
    /*
        Function: quotient
        Divide two <BigIntegers> and truncate towards zero.
        <quotient> throws an exception if *n* is zero.
        Parameters:
            n - The number to divide *this* by. Will be converted to a <BigInteger>.
        Returns:
            The *this* / *n*, truncated to an integer.
        See Also:
            <add>, <subtract>, <multiply>, <divRem>, <remainder>
    */ BigInteger.prototype.quotient = function(n) {
        return this.divRem(n)[0];
    };
    /*
        Function: divide
        Deprecated synonym for <quotient>.
    */ BigInteger.prototype.divide = BigInteger.prototype.quotient;
    /*
        Function: remainder
        Calculate the remainder of two <BigIntegers>.
        <remainder> throws an exception if *n* is zero.
        Parameters:
            n - The remainder after *this* is divided *this* by *n*. Will be
                converted to a <BigInteger>.
        Returns:
            *this* % *n*.
        See Also:
            <divRem>, <quotient>
    */ BigInteger.prototype.remainder = function(n) {
        return this.divRem(n)[1];
    };
    /*
        Function: divRem
        Calculate the integer quotient and remainder of two <BigIntegers>.
        <divRem> throws an exception if *n* is zero.
        Parameters:
            n - The number to divide *this* by. Will be converted to a <BigInteger>.
        Returns:
            A two-element array containing the quotient and the remainder.
            > a.divRem(b)
            is exactly equivalent to
            > [a.quotient(b), a.remainder(b)]
            except it is faster, because they are calculated at the same time.
        See Also:
            <quotient>, <remainder>
    */ BigInteger.prototype.divRem = function(n) {
        n = BigInteger(n);
        if (n._s === 0) throw new Error("Divide by zero");
        if (this._s === 0) return [
            ZERO,
            ZERO
        ];
        if (n._d.length === 1) return this.divRemSmall(n._s * n._d[0]);
        // Test for easy cases -- |n1| <= |n2|
        switch(this.compareAbs(n)){
            case 0:
                return [
                    this._s === n._s ? ONE : M_ONE,
                    ZERO
                ];
            case -1:
                return [
                    ZERO,
                    this
                ];
        }
        var sign = this._s * n._s;
        var a = n.abs();
        var b_digits = this._d;
        var b_index = b_digits.length;
        var digits = n._d.length;
        var quot = [];
        var guess;
        var part = new BigInteger([], 0, CONSTRUCT);
        while(b_index){
            part._d.unshift(b_digits[--b_index]);
            part = new BigInteger(part._d, 1, CONSTRUCT);
            if (part.compareAbs(n) < 0) {
                quot.push(0);
                continue;
            }
            if (part._s === 0) guess = 0;
            else {
                var xlen = part._d.length, ylen = a._d.length;
                var highx = part._d[xlen - 1] * BigInteger_base + part._d[xlen - 2];
                var highy = a._d[ylen - 1] * BigInteger_base + a._d[ylen - 2];
                if (part._d.length > a._d.length) // The length of part._d can either match a._d length,
                // or exceed it by one.
                highx = (highx + 1) * BigInteger_base;
                guess = Math.ceil(highx / highy);
            }
            do {
                var check = a.multiplySingleDigit(guess);
                if (check.compareAbs(part) <= 0) break;
                guess--;
            }while (guess);
            quot.push(guess);
            if (!guess) continue;
            var diff = part.subtract(check);
            part._d = diff._d.slice();
        }
        return [
            new BigInteger(quot.reverse(), sign, CONSTRUCT),
            new BigInteger(part._d, this._s, CONSTRUCT)
        ];
    };
    // Throws an exception if n is outside of (-BigInteger.base, -1] or
    // [1, BigInteger.base).  It's not necessary to call this, since the
    // other division functions will call it if they are able to.
    BigInteger.prototype.divRemSmall = function(n) {
        var r;
        n = +n;
        if (n === 0) throw new Error("Divide by zero");
        var n_s = n < 0 ? -1 : 1;
        var sign = this._s * n_s;
        n = Math.abs(n);
        if (n < 1 || n >= BigInteger_base) throw new Error("Argument out of range");
        if (this._s === 0) return [
            ZERO,
            ZERO
        ];
        if (n === 1 || n === -1) return [
            sign === 1 ? this.abs() : new BigInteger(this._d, sign, CONSTRUCT),
            ZERO
        ];
        // 2 <= n < BigInteger_base
        // divide a single digit by a single digit
        if (this._d.length === 1) {
            var q = new BigInteger([
                this._d[0] / n | 0
            ], 1, CONSTRUCT);
            r = new BigInteger([
                this._d[0] % n | 0
            ], 1, CONSTRUCT);
            if (sign < 0) q = q.negate();
            if (this._s < 0) r = r.negate();
            return [
                q,
                r
            ];
        }
        var digits = this._d.slice();
        var quot = new Array(digits.length);
        var part = 0;
        var diff = 0;
        var i = 0;
        var guess;
        while(digits.length){
            part = part * BigInteger_base + digits[digits.length - 1];
            if (part < n) {
                quot[i++] = 0;
                digits.pop();
                diff = BigInteger_base * diff + part;
                continue;
            }
            if (part === 0) guess = 0;
            else guess = part / n | 0;
            var check = n * guess;
            diff = part - check;
            quot[i++] = guess;
            if (!guess) {
                digits.pop();
                continue;
            }
            digits.pop();
            part = diff;
        }
        r = new BigInteger([
            diff
        ], 1, CONSTRUCT);
        if (this._s < 0) r = r.negate();
        return [
            new BigInteger(quot.reverse(), sign, CONSTRUCT),
            r
        ];
    };
    /*
        Function: isEven
        Return true iff *this* is divisible by two.
        Note that <BigInteger.ZERO> is even.
        Returns:
            true if *this* is even, false otherwise.
        See Also:
            <isOdd>
    */ BigInteger.prototype.isEven = function() {
        var digits = this._d;
        return this._s === 0 || digits.length === 0 || digits[0] % 2 === 0;
    };
    /*
        Function: isOdd
        Return true iff *this* is not divisible by two.
        Returns:
            true if *this* is odd, false otherwise.
        See Also:
            <isEven>
    */ BigInteger.prototype.isOdd = function() {
        return !this.isEven();
    };
    /*
        Function: sign
        Get the sign of a <BigInteger>.
        Returns:
            * -1 if *this* < 0
            * 0 if *this* == 0
            * +1 if *this* > 0
        See Also:
            <isZero>, <isPositive>, <isNegative>, <compare>, <BigInteger.ZERO>
    */ BigInteger.prototype.sign = function() {
        return this._s;
    };
    /*
        Function: isPositive
        Return true iff *this* > 0.
        Returns:
            true if *this*.compare(<BigInteger.ZERO>) == 1.
        See Also:
            <sign>, <isZero>, <isNegative>, <isUnit>, <compare>, <BigInteger.ZERO>
    */ BigInteger.prototype.isPositive = function() {
        return this._s > 0;
    };
    /*
        Function: isNegative
        Return true iff *this* < 0.
        Returns:
            true if *this*.compare(<BigInteger.ZERO>) == -1.
        See Also:
            <sign>, <isPositive>, <isZero>, <isUnit>, <compare>, <BigInteger.ZERO>
    */ BigInteger.prototype.isNegative = function() {
        return this._s < 0;
    };
    /*
        Function: isZero
        Return true iff *this* == 0.
        Returns:
            true if *this*.compare(<BigInteger.ZERO>) == 0.
        See Also:
            <sign>, <isPositive>, <isNegative>, <isUnit>, <BigInteger.ZERO>
    */ BigInteger.prototype.isZero = function() {
        return this._s === 0;
    };
    /*
        Function: exp10
        Multiply a <BigInteger> by a power of 10.
        This is equivalent to, but faster than
        > if (n >= 0) {
        >     return this.multiply(BigInteger("1e" + n));
        > }
        > else { // n <= 0
        >     return this.quotient(BigInteger("1e" + -n));
        > }
        Parameters:
            n - The power of 10 to multiply *this* by. *n* is converted to a
            javascipt number and must be no greater than <BigInteger.MAX_EXP>
            (0x7FFFFFFF), or an exception will be thrown.
        Returns:
            *this* * (10 ** *n*), truncated to an integer if necessary.
        See Also:
            <pow>, <multiply>
    */ BigInteger.prototype.exp10 = function(n) {
        n = +n;
        if (n === 0) return this;
        if (Math.abs(n) > Number(MAX_EXP)) throw new Error("exponent too large in BigInteger.exp10");
        // Optimization for this == 0. This also keeps us from having to trim zeros in the positive n case
        if (this._s === 0) return ZERO;
        if (n > 0) {
            var k = new BigInteger(this._d.slice(), this._s, CONSTRUCT);
            for(; n >= BigInteger_base_log10; n -= BigInteger_base_log10)k._d.unshift(0);
            if (n == 0) return k;
            k._s = 1;
            k = k.multiplySingleDigit(Math.pow(10, n));
            return this._s < 0 ? k.negate() : k;
        } else if (-n >= this._d.length * BigInteger_base_log10) return ZERO;
        else {
            var k = new BigInteger(this._d.slice(), this._s, CONSTRUCT);
            for(n = -n; n >= BigInteger_base_log10; n -= BigInteger_base_log10)k._d.shift();
            return n == 0 ? k : k.divRemSmall(Math.pow(10, n))[0];
        }
    };
    /*
        Function: pow
        Raise a <BigInteger> to a power.
        In this implementation, 0**0 is 1.
        Parameters:
            n - The exponent to raise *this* by. *n* must be no greater than
            <BigInteger.MAX_EXP> (0x7FFFFFFF), or an exception will be thrown.
        Returns:
            *this* raised to the *nth* power.
        See Also:
            <modPow>
    */ BigInteger.prototype.pow = function(n) {
        if (this.isUnit()) {
            if (this._s > 0) return this;
            else return BigInteger(n).isOdd() ? this : this.negate();
        }
        n = BigInteger(n);
        if (n._s === 0) return ONE;
        else if (n._s < 0) {
            if (this._s === 0) throw new Error("Divide by zero");
            else return ZERO;
        }
        if (this._s === 0) return ZERO;
        if (n.isUnit()) return this;
        if (n.compareAbs(MAX_EXP) > 0) throw new Error("exponent too large in BigInteger.pow");
        var x = this;
        var aux = ONE;
        var two = BigInteger.small[2];
        while(n.isPositive()){
            if (n.isOdd()) {
                aux = aux.multiply(x);
                if (n.isUnit()) return aux;
            }
            x = x.square();
            n = n.quotient(two);
        }
        return aux;
    };
    /*
        Function: modPow
        Raise a <BigInteger> to a power (mod m).
        Because it is reduced by a modulus, <modPow> is not limited by
        <BigInteger.MAX_EXP> like <pow>.
        Parameters:
            exponent - The exponent to raise *this* by. Must be positive.
            modulus - The modulus.
        Returns:
            *this* ^ *exponent* (mod *modulus*).
        See Also:
            <pow>, <mod>
    */ BigInteger.prototype.modPow = function(exponent, modulus) {
        var result = ONE;
        var base = this;
        while(exponent.isPositive()){
            if (exponent.isOdd()) result = result.multiply(base).remainder(modulus);
            exponent = exponent.quotient(BigInteger.small[2]);
            if (exponent.isPositive()) base = base.square().remainder(modulus);
        }
        return result;
    };
    /*
        Function: log
        Get the natural logarithm of a <BigInteger> as a native JavaScript number.
        This is equivalent to
        > Math.log(this.toJSValue())
        but handles values outside of the native number range.
        Returns:
            log( *this* )
        See Also:
            <toJSValue>
    */ BigInteger.prototype.log = function() {
        switch(this._s){
            case 0:
                return -Infinity;
            case -1:
                return NaN;
            default:
        }
        var l = this._d.length;
        if (l * BigInteger_base_log10 < 30) return Math.log(this.valueOf());
        var N = Math.ceil(30 / BigInteger_base_log10);
        var firstNdigits = this._d.slice(l - N);
        return Math.log(new BigInteger(firstNdigits, 1, CONSTRUCT).valueOf()) + (l - N) * Math.log(BigInteger_base);
    };
    /*
        Function: valueOf
        Convert a <BigInteger> to a native JavaScript integer.
        This is called automatically by JavaScipt to convert a <BigInteger> to a
        native value.
        Returns:
            > parseInt(this.toString(), 10)
        See Also:
            <toString>, <toJSValue>
    */ BigInteger.prototype.valueOf = function() {
        return parseInt(this.toString(), 10);
    };
    /*
        Function: toJSValue
        Convert a <BigInteger> to a native JavaScript integer.
        This is the same as valueOf, but more explicitly named.
        Returns:
            > parseInt(this.toString(), 10)
        See Also:
            <toString>, <valueOf>
    */ BigInteger.prototype.toJSValue = function() {
        return parseInt(this.toString(), 10);
    };
    /*
     Function: lowVal
     Author: Lucas Jones
     */ BigInteger.prototype.lowVal = function() {
        return this._d[0] || 0;
    };
    var MAX_EXP = BigInteger(0x7FFFFFFF);
    // Constant: MAX_EXP
    // The largest exponent allowed in <pow> and <exp10> (0x7FFFFFFF or 2147483647).
    BigInteger.MAX_EXP = MAX_EXP;
    (function() {
        function makeUnary(fn) {
            return function(a) {
                return fn.call(BigInteger(a));
            };
        }
        function makeBinary(fn) {
            return function(a, b) {
                return fn.call(BigInteger(a), BigInteger(b));
            };
        }
        function makeTrinary(fn) {
            return function(a, b, c) {
                return fn.call(BigInteger(a), BigInteger(b), BigInteger(c));
            };
        }
        (function() {
            var i, fn;
            var unary = "toJSValue,isEven,isOdd,sign,isZero,isNegative,abs,isUnit,square,negate,isPositive,toString,next,prev,log".split(",");
            var binary = "compare,remainder,divRem,subtract,add,quotient,divide,multiply,pow,compareAbs".split(",");
            var trinary = [
                "modPow"
            ];
            for(i = 0; i < unary.length; i++){
                fn = unary[i];
                BigInteger[fn] = makeUnary(BigInteger.prototype[fn]);
            }
            for(i = 0; i < binary.length; i++){
                fn = binary[i];
                BigInteger[fn] = makeBinary(BigInteger.prototype[fn]);
            }
            for(i = 0; i < trinary.length; i++){
                fn = trinary[i];
                BigInteger[fn] = makeTrinary(BigInteger.prototype[fn]);
            }
            BigInteger.exp10 = function(x, n) {
                return BigInteger(x).exp10(n);
            };
        })();
    })();
    exports1.JSBigInt = BigInteger; // exports.BigInteger changed to exports.JSBigInt
})($35fbaf3b7451c14f$exports);


var $7a42e159fb5b6be8$var$JSBigInt = $35fbaf3b7451c14f$exports.JSBigInt;
/**
Copyright (c) 2017, moneroexamples

All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

1. Redistributions of source code must retain the above copyright notice, this
list of conditions and the following disclaimer.

2. Redistributions in binary form must reproduce the above copyright notice,
this list of conditions and the following disclaimer in the documentation
and/or other materials provided with the distribution.

3. Neither the name of the copyright holder nor the names of its contributors
may be used to endorse or promote products derived from this software without
specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

Parts of the project are originally copyright (c) 2014-2017, MyMonero.com
*/ var $7a42e159fb5b6be8$var$cnBase58 = function() {
    var b58 = {};
    var alphabet_str = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
    var alphabet = [];
    for(var i = 0; i < alphabet_str.length; i++)alphabet.push(alphabet_str.charCodeAt(i));
    var encoded_block_sizes = [
        0,
        2,
        3,
        5,
        6,
        7,
        9,
        10,
        11
    ];
    var alphabet_size = alphabet.length;
    var full_block_size = 8;
    var full_encoded_block_size = 11;
    var UINT64_MAX = new $7a42e159fb5b6be8$var$JSBigInt(2).pow(64);
    function hextobin(hex) {
        if (hex.length % 2 !== 0) throw "Hex string has invalid length!";
        var res = new Uint8Array(hex.length / 2);
        for(var i = 0; i < hex.length / 2; ++i)res[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
        return res;
    }
    function bintohex(bin) {
        var out = [];
        for(var i = 0; i < bin.length; ++i)out.push(("0" + bin[i].toString(16)).slice(-2));
        return out.join("");
    }
    function strtobin(str) {
        var res = new Uint8Array(str.length);
        for(var i = 0; i < str.length; i++)res[i] = str.charCodeAt(i);
        return res;
    }
    function bintostr(bin) {
        var out = [];
        for(var i = 0; i < bin.length; i++)out.push(String.fromCharCode(bin[i]));
        return out.join("");
    }
    function uint8_be_to_64(data) {
        if (data.length < 1 || data.length > 8) throw "Invalid input length";
        var res = $7a42e159fb5b6be8$var$JSBigInt.ZERO;
        var twopow8 = new $7a42e159fb5b6be8$var$JSBigInt(2).pow(8);
        var i = 0;
        switch(9 - data.length){
            case 1:
                res = res.add(data[i++]);
            case 2:
                res = res.multiply(twopow8).add(data[i++]);
            case 3:
                res = res.multiply(twopow8).add(data[i++]);
            case 4:
                res = res.multiply(twopow8).add(data[i++]);
            case 5:
                res = res.multiply(twopow8).add(data[i++]);
            case 6:
                res = res.multiply(twopow8).add(data[i++]);
            case 7:
                res = res.multiply(twopow8).add(data[i++]);
            case 8:
                res = res.multiply(twopow8).add(data[i++]);
                break;
            default:
                throw "Impossible condition";
        }
        return res;
    }
    function uint64_to_8be(num, size) {
        var res = new Uint8Array(size);
        if (size < 1 || size > 8) throw "Invalid input length";
        var twopow8 = new $7a42e159fb5b6be8$var$JSBigInt(2).pow(8);
        for(var i = size - 1; i >= 0; i--){
            res[i] = num.remainder(twopow8).toJSValue();
            num = num.divide(twopow8);
        }
        return res;
    }
    b58.encode_block = function(data, buf, index) {
        if (data.length < 1 || data.length > full_encoded_block_size) throw "Invalid block length: " + data.length;
        var num = uint8_be_to_64(data);
        var i = encoded_block_sizes[data.length] - 1;
        // while num > 0
        while(num.compare(0) === 1){
            var div = num.divRem(alphabet_size);
            // remainder = num % alphabet_size
            var remainder = div[1];
            // num = num / alphabet_size
            num = div[0];
            buf[index + i] = alphabet[remainder.toJSValue()];
            i--;
        }
        return buf;
    };
    b58.encode = function(hex) {
        var data = hextobin(hex);
        if (data.length === 0) return "";
        var full_block_count = Math.floor(data.length / full_block_size);
        var last_block_size = data.length % full_block_size;
        var res_size = full_block_count * full_encoded_block_size + encoded_block_sizes[last_block_size];
        var res = new Uint8Array(res_size);
        var i;
        for(i = 0; i < res_size; ++i)res[i] = alphabet[0];
        for(i = 0; i < full_block_count; i++)res = b58.encode_block(data.subarray(i * full_block_size, i * full_block_size + full_block_size), res, i * full_encoded_block_size);
        if (last_block_size > 0) res = b58.encode_block(data.subarray(full_block_count * full_block_size, full_block_count * full_block_size + last_block_size), res, full_block_count * full_encoded_block_size);
        return bintostr(res);
    };
    b58.decode_block = function(data, buf, index) {
        if (data.length < 1 || data.length > full_encoded_block_size) throw "Invalid block length: " + data.length;
        var res_size = encoded_block_sizes.indexOf(data.length);
        if (res_size <= 0) throw "Invalid block size";
        var res_num = new $7a42e159fb5b6be8$var$JSBigInt(0);
        var order = new $7a42e159fb5b6be8$var$JSBigInt(1);
        for(var i = data.length - 1; i >= 0; i--){
            var digit = alphabet.indexOf(data[i]);
            if (digit < 0) throw "Invalid symbol";
            var product = order.multiply(digit).add(res_num);
            // if product > UINT64_MAX
            if (product.compare(UINT64_MAX) === 1) throw "Overflow";
            res_num = product;
            order = order.multiply(alphabet_size);
        }
        if (res_size < full_block_size && new $7a42e159fb5b6be8$var$JSBigInt(2).pow(8 * res_size).compare(res_num) <= 0) throw "Overflow 2";
        buf.set(uint64_to_8be(res_num, res_size), index);
        return buf;
    };
    b58.decode = function(enc) {
        enc = strtobin(enc);
        if (enc.length === 0) return "";
        var full_block_count = Math.floor(enc.length / full_encoded_block_size);
        var last_block_size = enc.length % full_encoded_block_size;
        var last_block_decoded_size = encoded_block_sizes.indexOf(last_block_size);
        if (last_block_decoded_size < 0) throw "Invalid encoded length";
        var data_size = full_block_count * full_block_size + last_block_decoded_size;
        var data = new Uint8Array(data_size);
        for(var i = 0; i < full_block_count; i++)data = b58.decode_block(enc.subarray(i * full_encoded_block_size, i * full_encoded_block_size + full_encoded_block_size), data, i * full_block_size);
        if (last_block_size > 0) data = b58.decode_block(enc.subarray(full_block_count * full_encoded_block_size, full_block_count * full_encoded_block_size + last_block_size), data, full_block_count * full_block_size);
        return bintohex(data);
    };
    return b58;
}();
$7a42e159fb5b6be8$exports = $7a42e159fb5b6be8$var$cnBase58;


var $5f2aef207c8ec557$var$DEFAULT_NETWORK_TYPE = "prod";
var $5f2aef207c8ec557$var$addressRegTest = new RegExp("^[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{95}$");
var $5f2aef207c8ec557$var$integratedAddressRegTest = new RegExp("^[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{106}$");
function $5f2aef207c8ec557$var$validateNetwork(decoded, currency, networkType, addressType) {
    var network = currency.addressTypes;
    if (addressType == "integrated") network = currency.iAddressTypes;
    var at = parseInt(decoded.substr(0, 2), 16).toString();
    switch(networkType){
        case "prod":
            return network.prod.indexOf(at) >= 0;
        case "testnet":
            return network.testnet.indexOf(at) >= 0;
        case "stagenet":
            return network.stagenet.indexOf(at) >= 0;
        case "both":
            return network.prod.indexOf(at) >= 0 || network.testnet.indexOf(at) >= 0 || network.stagenet.indexOf(at) >= 0;
        default:
            return false;
    }
}
function $5f2aef207c8ec557$var$hextobin(hex) {
    if (hex.length % 2 !== 0) return null;
    var res = new Uint8Array(hex.length / 2);
    for(var i = 0; i < hex.length / 2; ++i)res[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
    return res;
}
$5f2aef207c8ec557$exports = {
    isValidAddress: function(address, currency, opts = {}) {
        const { networkType: networkType = $5f2aef207c8ec557$var$DEFAULT_NETWORK_TYPE } = opts;
        var addressType = "standard";
        if (!$5f2aef207c8ec557$var$addressRegTest.test(address)) {
            if ($5f2aef207c8ec557$var$integratedAddressRegTest.test(address)) addressType = "integrated";
            else return false;
        }
        var decodedAddrStr = $7a42e159fb5b6be8$exports.decode(address);
        if (!decodedAddrStr) return false;
        if (!$5f2aef207c8ec557$var$validateNetwork(decodedAddrStr, currency, networkType, addressType)) return false;
        var addrChecksum = decodedAddrStr.slice(-8);
        var hashChecksum = $58fab9ded43a18f7$exports.keccak256Checksum($5f2aef207c8ec557$var$hextobin(decodedAddrStr.slice(0, -8)));
        return addrChecksum === hashChecksum;
    }
};


var $336dba217d6ddac6$exports = {};


var $336dba217d6ddac6$var$ALLOWED_CHARS = "13456789abcdefghijkmnopqrstuwxyz";
var $336dba217d6ddac6$var$codec = $4f801e3572f21127$exports($336dba217d6ddac6$var$ALLOWED_CHARS);
// https://github.com/nanocurrency/raiblocks/wiki/Accounts,-Keys,-Seeds,-and-Wallet-Identifiers
var $336dba217d6ddac6$var$regexp = new RegExp("^(xrb|nano)_([" + $336dba217d6ddac6$var$ALLOWED_CHARS + "]{60})$");
$336dba217d6ddac6$exports = {
    isValidAddress: function(address) {
        if ($336dba217d6ddac6$var$regexp.test(address)) return this.verifyChecksum(address);
        return false;
    },
    verifyChecksum: function(address) {
        var bytes = $336dba217d6ddac6$var$codec.decode($336dba217d6ddac6$var$regexp.exec(address)[2]).slice(-37);
        // https://github.com/nanocurrency/raiblocks/blob/master/rai/lib/numbers.cpp#L73
        var computedChecksum = $58fab9ded43a18f7$exports.blake2b($58fab9ded43a18f7$exports.toHex(bytes.slice(0, -5)), 5);
        var checksum = $58fab9ded43a18f7$exports.toHex(bytes.slice(-5).reverse());
        return computedChecksum === checksum;
    }
};


var $6b026ccf4821881e$exports = {};


var $4Dyi7 = parcelRequire("4Dyi7");
function $6b026ccf4821881e$var$hexToBytes(hex) {
    var bytes = [];
    for(var c = 0; c < hex.length; c += 2)bytes.push(parseInt(hex.substr(c, 2), 16));
    return bytes;
}
$6b026ccf4821881e$exports = {
    isValidAddress: function(address) {
        if (address.length !== 76) // Check if it has the basic requirements of an address
        return false;
        // Otherwise check each case
        return this.verifyChecksum(address);
    },
    verifyChecksum: function(address) {
        var checksumBytes = address.slice(0, 64);
        var check = address.slice(64, 76);
        var blakeHash = $58fab9ded43a18f7$exports.blake2b(checksumBytes, 32).slice(0, 12);
        return !!$4Dyi7(blakeHash, check);
    }
};


var $e3834544189981e1$exports = {};

function $e3834544189981e1$var$decodeBase58Address(base58Sting) {
    if (typeof base58Sting !== "string") return false;
    if (base58Sting.length <= 4) return false;
    try {
        var address = $58fab9ded43a18f7$exports.base58(base58Sting);
    } catch (e) {
        return false;
    }
    /*if (base58Sting.length <= 4) {
        return false;
    }*/ var len = address.length;
    var offset = len - 4;
    var checkSum = address.slice(offset);
    address = address.slice(0, offset);
    var hash0 = $58fab9ded43a18f7$exports.sha256($58fab9ded43a18f7$exports.byteArray2hexStr(address));
    var hash1 = $58fab9ded43a18f7$exports.hexStr2byteArray($58fab9ded43a18f7$exports.sha256(hash0));
    var checkSum1 = hash1.slice(0, 4);
    if (checkSum[0] === checkSum1[0] && checkSum[1] === checkSum1[1] && checkSum[2] === checkSum1[2] && checkSum[3] === checkSum1[3]) return address;
    return false;
}
function $e3834544189981e1$var$getEnv(currency, networkType) {
    var evn = networkType || "prod";
    if (evn !== "prod" && evn !== "testnet") evn = "prod";
    return currency.addressTypes[evn][0];
}
$e3834544189981e1$exports = {
    /**
     * tron address validation
     */ isValidAddress: function(mainAddress, currency, opts) {
        var networkType = opts ? opts.networkType : "";
        var address = $e3834544189981e1$var$decodeBase58Address(mainAddress);
        if (!address) return false;
        if (address.length !== 21) return false;
        return $e3834544189981e1$var$getEnv(currency, networkType) === address[0];
    }
};


var $15b26037f9b2142e$exports = {};

var $lewJ9 = parcelRequire("lewJ9");
var $15b26037f9b2142e$require$Buffer = $lewJ9.Buffer;

/**
* Check if an address is valid
*
* @param {string} _address - An address
*
* @return {boolean} - True if address is valid, false otherwise
*/ var $15b26037f9b2142e$var$isValidAddress = function(_address) {
    var address = _address.toString().toUpperCase().replace(/-/g, "");
    if (!address || address.length !== 40) return false;
    var decoded = $58fab9ded43a18f7$exports.toHex($58fab9ded43a18f7$exports.base32.b32decode(address));
    var stepThreeChecksum = $58fab9ded43a18f7$exports.keccak256Checksum($15b26037f9b2142e$require$Buffer.from(decoded.slice(0, 42), "hex"));
    return stepThreeChecksum === decoded.slice(42);
};
$15b26037f9b2142e$exports = {
    isValidAddress: $15b26037f9b2142e$var$isValidAddress
};


var $49240c05227c39c5$exports = {};

var $lewJ9 = parcelRequire("lewJ9");
var $49240c05227c39c5$require$Buffer = $lewJ9.Buffer;

var $49240c05227c39c5$var$regexp = new RegExp("^[0-9]{1,20}L$");
$49240c05227c39c5$exports = {
    isValidAddress: function(address) {
        if (!$49240c05227c39c5$var$regexp.test(address)) return false;
        return this.verifyAddress(address);
    },
    verifyAddress: function(address) {
        var BUFFER_SIZE = 8;
        var bigNumber = address.substring(0, address.length - 1);
        var addressBuffer = $58fab9ded43a18f7$exports.bigNumberToBuffer(bigNumber);
        return $49240c05227c39c5$require$Buffer.from(addressBuffer).slice(0, BUFFER_SIZE).equals(addressBuffer);
    }
};


var $9310bcdb9cc57dc6$exports = {};



function $9310bcdb9cc57dc6$var$validateAddress(address, currency, opts) {
    var networkType = opts ? opts.networkType : "";
    var prefix = "bitcoincash";
    var regexp = new RegExp(currency.regexp);
    var raw_address;
    var res = address.split(":");
    if (res.length === 1) raw_address = address;
    else {
        if (res[0] !== "bitcoincash") return false;
        raw_address = res[1];
    }
    if (!regexp.test(raw_address)) return false;
    if (raw_address.toLowerCase() != raw_address && raw_address.toUpperCase() != raw_address) return false;
    var decoded = $58fab9ded43a18f7$exports.base32.b32decode(raw_address);
    if (networkType === "testnet") prefix = "bchtest";
    try {
        if ($3c2eebea5d8da41b$exports.verifyChecksum(prefix, decoded, $3c2eebea5d8da41b$exports.encodings.BECH32)) return false;
    } catch (e) {
        return false;
    }
    return true;
}
$9310bcdb9cc57dc6$exports = {
    isValidAddress: function(address, currency, networkType) {
        return $9310bcdb9cc57dc6$var$validateAddress(address, currency, networkType) || $d7830e5c3dae45dc$exports.isValidAddress(address, currency, networkType);
    }
};


var $4f9a595db52b4d12$exports = {};



var $4f9a595db52b4d12$var$ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
var $4f9a595db52b4d12$var$base32 = $4f801e3572f21127$exports($4f9a595db52b4d12$var$ALPHABET);
var $4f9a595db52b4d12$var$regexp = new RegExp("^[" + $4f9a595db52b4d12$var$ALPHABET + "]{56}$");
var $4f9a595db52b4d12$var$ed25519PublicKeyVersionByte = 48;
function $4f9a595db52b4d12$var$swap16(number) {
    var lower = number & 0xFF;
    var upper = number >> 8 & 0xFF;
    return lower << 8 | upper;
}
$4f9a595db52b4d12$exports = {
    isValidAddress: function(address) {
        if ($4f9a595db52b4d12$var$regexp.test(address)) return this.verifyChecksum(address);
        return false;
    },
    verifyChecksum: function(address) {
        // based on https://github.com/stellar/js-stellar-base/blob/master/src/strkey.js#L126
        var bytes = $4f9a595db52b4d12$var$base32.decode(address);
        if (bytes[0] !== $4f9a595db52b4d12$var$ed25519PublicKeyVersionByte) return false;
        var computedChecksum = $58fab9ded43a18f7$exports.numberToHex($4f9a595db52b4d12$var$swap16($37901099455222b1$export$2e2bcd8739ae039(bytes.slice(0, -2))), 4);
        var checksum = $58fab9ded43a18f7$exports.toHex(bytes.slice(-2));
        return computedChecksum === checksum;
    }
};


var $46dd7559f0a0b287$exports = {};
function $46dd7559f0a0b287$var$isValidEOSAddress(address, currency, networkType) {
    var regex = /^[a-z0-9.]+$/g // Must be numbers, lowercase letters and decimal points only
    ;
    if (address.search(regex) !== -1 && address.length === 12) return true;
    else return false;
}
$46dd7559f0a0b287$exports = {
    isValidAddress: function(address, currency, networkType) {
        return $46dd7559f0a0b287$var$isValidEOSAddress(address, currency, networkType);
    }
};


var $9c79c08d4915caf3$exports = {};


const $9c79c08d4915caf3$var$prefix = new Uint8Array([
    6,
    161,
    159
]);
function $9c79c08d4915caf3$var$decodeRaw(buffer) {
    let payload = buffer.slice(0, -4);
    let checksum = buffer.slice(-4);
    let newChecksum = $58fab9ded43a18f7$exports.hexStr2byteArray($58fab9ded43a18f7$exports.sha256x2($58fab9ded43a18f7$exports.byteArray2hexStr(payload)));
    if (checksum[0] ^ newChecksum[0] | checksum[1] ^ newChecksum[1] | checksum[2] ^ newChecksum[2] | checksum[3] ^ newChecksum[3]) return;
    return payload;
}
const $9c79c08d4915caf3$var$isValidAddress = function(address) {
    try {
        let buffer = $8560caef586a2c5f$exports.decode(address);
        let payload = $9c79c08d4915caf3$var$decodeRaw(buffer);
        if (!payload) return false;
        payload.slice($9c79c08d4915caf3$var$prefix.length);
        return true;
    } catch (e) {
        return false;
    }
};
$9c79c08d4915caf3$exports = {
    isValidAddress: $9c79c08d4915caf3$var$isValidAddress
};


var $8ab285fc975f24a2$exports = {};


function $8ab285fc975f24a2$var$checkBothValidators(address, currency, networkType) {
    var result = $d7830e5c3dae45dc$exports.isValidAddress(address, currency, networkType);
    return result ? result : $a0584d44d5748453$exports.isValidAddress(address, currency, networkType);
}
$8ab285fc975f24a2$exports = {
    isValidAddress: function(address, currency, opts) {
        if (opts) {
            if (opts.chainType === "erc20") return $a0584d44d5748453$exports.isValidAddress(address, currency, opts.networkType);
            else if (opts.chainType === "omni") return $d7830e5c3dae45dc$exports.isValidAddress(address, currency, opts.networkType);
        }
        return $8ab285fc975f24a2$var$checkBothValidators(address, currency, opts);
    }
};


var $587f3f830bec1d54$exports = {};

const $587f3f830bec1d54$var$ALGORAND_CHECKSUM_BYTE_LENGTH = 4;
const $587f3f830bec1d54$var$ALGORAND_ADDRESS_LENGTH = 58;
$587f3f830bec1d54$exports = {
    isValidAddress: function(address, currency, opts = {}) {
        const { networkType: networkType = "prod" } = opts;
        return this.verifyChecksum(address);
    },
    verifyChecksum: function(address) {
        if (address.length !== $587f3f830bec1d54$var$ALGORAND_ADDRESS_LENGTH) return false;
        else {
            // Decode base32 Address
            const decoded = $58fab9ded43a18f7$exports.base32.b32decode(address);
            const addr = decoded.slice(0, decoded.length - $587f3f830bec1d54$var$ALGORAND_CHECKSUM_BYTE_LENGTH);
            const checksum = $58fab9ded43a18f7$exports.byteArray2hexStr(decoded.slice(-4)).toString("HEX");
            // Hash Address - Checksum
            const code = $58fab9ded43a18f7$exports.sha512_256($58fab9ded43a18f7$exports.byteArray2hexStr(addr)).substr(-$587f3f830bec1d54$var$ALGORAND_CHECKSUM_BYTE_LENGTH * 2);
            return code === checksum;
        }
    }
};


var $df84a3afc54966ce$exports = {};

// from https://github.com/paritytech/substrate/wiki/External-Address-Format-(SS58)
const $df84a3afc54966ce$var$addressFormats = [
    {
        addressLength: 3,
        accountIndexLength: 1,
        checkSumLength: 1
    },
    {
        addressLength: 4,
        accountIndexLength: 2,
        checkSumLength: 1
    },
    {
        addressLength: 5,
        accountIndexLength: 2,
        checkSumLength: 2
    },
    {
        addressLength: 6,
        accountIndexLength: 4,
        checkSumLength: 1
    },
    {
        addressLength: 7,
        accountIndexLength: 4,
        checkSumLength: 2
    },
    {
        addressLength: 8,
        accountIndexLength: 4,
        checkSumLength: 3
    },
    {
        addressLength: 9,
        accountIndexLength: 4,
        checkSumLength: 4
    },
    {
        addressLength: 10,
        accountIndexLength: 8,
        checkSumLength: 1
    },
    {
        addressLength: 11,
        accountIndexLength: 8,
        checkSumLength: 2
    },
    {
        addressLength: 12,
        accountIndexLength: 8,
        checkSumLength: 3
    },
    {
        addressLength: 13,
        accountIndexLength: 8,
        checkSumLength: 4
    },
    {
        addressLength: 14,
        accountIndexLength: 8,
        checkSumLength: 5
    },
    {
        addressLength: 15,
        accountIndexLength: 8,
        checkSumLength: 6
    },
    {
        addressLength: 16,
        accountIndexLength: 8,
        checkSumLength: 7
    },
    {
        addressLength: 17,
        accountIndexLength: 8,
        checkSumLength: 8
    },
    {
        addressLength: 34,
        accountIndexLength: 32,
        checkSumLength: 2
    }
];
$df84a3afc54966ce$exports = {
    isValidAddress: function(address, currency, opts = {}) {
        const { networkType: networkType = "prod" } = opts;
        return this.verifyChecksum(address);
    },
    verifyChecksum: function(address) {
        try {
            const preImage = "53533538505245";
            const decoded = $58fab9ded43a18f7$exports.base58(address);
            const addressType = $58fab9ded43a18f7$exports.byteArray2hexStr(decoded.slice(0, 1));
            const addressAndChecksum = decoded.slice(1);
            // get the address format
            const addressFormat = $df84a3afc54966ce$var$addressFormats.find((af)=>af.addressLength === addressAndChecksum.length);
            if (!addressFormat) throw new Error("Invalid address length");
            const decodedAddress = $58fab9ded43a18f7$exports.byteArray2hexStr(addressAndChecksum.slice(0, addressFormat.accountIndexLength));
            const checksum = $58fab9ded43a18f7$exports.byteArray2hexStr(addressAndChecksum.slice(-addressFormat.checkSumLength));
            const calculatedHash = $58fab9ded43a18f7$exports.blake2b(preImage + addressType + decodedAddress, 64).substr(0, addressFormat.checkSumLength * 2).toUpperCase();
            return calculatedHash == checksum;
        } catch (err) {
            return false;
        }
    }
};



var $59b81c15657aa75a$exports = {};

// simple base58 validator.  Just checks if it can be decoded.
$59b81c15657aa75a$exports = {
    isValidAddress: function(address, currency, opts = {}) {
        try {
            if (!address || address.length == 0) return false;
            if (currency.minLength && address.length < currency.minLength) return false;
            if (currency.maxLength && address.length > currency.maxLength) return false;
            try {
                const decoded = $8560caef586a2c5f$exports.decode(address);
                if (!decoded || !decoded.length) return false;
            } catch (e) {
                // if decoding fails, assume invalid address
                return false;
            }
            return true;
        } catch (e) {
            return false;
        }
    }
};


// defines P2PKH and P2SH address types for standard (prod) and testnet networks
var $c1a715e3879d5de0$var$CURRENCIES = [
    {
        name: "Bitcoin",
        symbol: "btc",
        addressTypes: {
            prod: [
                "00",
                "05"
            ],
            testnet: [
                "6f",
                "c4",
                "3c",
                "26"
            ]
        },
        bech32Hrp: {
            prod: [
                "bc"
            ],
            testnet: [
                "tb"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "BitcoinCash",
        symbol: "bch",
        regexp: "^[qQpP]{1}[0-9a-zA-Z]{41}$",
        addressTypes: {
            prod: [
                "00",
                "05"
            ],
            testnet: [
                "6f",
                "c4"
            ]
        },
        validator: $9310bcdb9cc57dc6$exports
    },
    {
        name: "Bitcoin SV",
        symbol: "bsv",
        regexp: "^[qQ]{1}[0-9a-zA-Z]{41}$",
        addressTypes: {
            prod: [
                "00",
                "05"
            ],
            testnet: [
                "6f",
                "c4"
            ]
        },
        validator: $9310bcdb9cc57dc6$exports
    },
    {
        name: "LiteCoin",
        symbol: "ltc",
        addressTypes: {
            prod: [
                "30",
                "05",
                "32"
            ],
            testnet: [
                "6f",
                "c4",
                "3a"
            ]
        },
        bech32Hrp: {
            prod: [
                "ltc"
            ],
            testnet: [
                "tltc"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "PeerCoin",
        symbol: "ppc",
        addressTypes: {
            prod: [
                "37",
                "75"
            ],
            testnet: [
                "6f",
                "c4"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "DogeCoin",
        symbol: "doge",
        addressTypes: {
            prod: [
                "1e",
                "16"
            ],
            testnet: [
                "71",
                "c4"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "BeaverCoin",
        symbol: "bvc",
        addressTypes: {
            prod: [
                "19",
                "05"
            ],
            testnet: [
                "6f",
                "c4"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "FreiCoin",
        symbol: "frc",
        addressTypes: {
            prod: [
                "00",
                "05"
            ],
            testnet: [
                "6f",
                "c4"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "ProtoShares",
        symbol: "pts",
        addressTypes: {
            prod: [
                "38",
                "05"
            ],
            testnet: [
                "6f",
                "c4"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "MegaCoin",
        symbol: "mec",
        addressTypes: {
            prod: [
                "32",
                "05"
            ],
            testnet: [
                "6f",
                "c4"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "PrimeCoin",
        symbol: "xpm",
        addressTypes: {
            prod: [
                "17",
                "53"
            ],
            testnet: [
                "6f",
                "c4"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "AuroraCoin",
        symbol: "aur",
        addressTypes: {
            prod: [
                "17",
                "05"
            ],
            testnet: [
                "6f",
                "c4"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "NameCoin",
        symbol: "nmc",
        addressTypes: {
            prod: [
                "34"
            ],
            testnet: []
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "BioCoin",
        symbol: "bio",
        addressTypes: {
            prod: [
                "19",
                "14"
            ],
            testnet: [
                "6f",
                "c4"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "GarliCoin",
        symbol: "grlc",
        addressTypes: {
            prod: [
                "26",
                "05"
            ],
            testnet: [
                "6f",
                "c4"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "VertCoin",
        symbol: "vtc",
        addressTypes: {
            prod: [
                "0x",
                "47",
                "71",
                "05"
            ],
            testnet: [
                "6f",
                "c4"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "BitcoinGold",
        symbol: "btg",
        addressTypes: {
            prod: [
                "26",
                "17"
            ],
            testnet: [
                "6f",
                "c4"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "Komodo",
        symbol: "kmd",
        addressTypes: {
            prod: [
                "3c",
                "55"
            ],
            testnet: [
                "0",
                "5"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "BitcoinZ",
        symbol: "btcz",
        expectedLength: 26,
        addressTypes: {
            prod: [
                "1cb8",
                "1cbd"
            ],
            testnet: [
                "1d25",
                "1cba"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "BitcoinPrivate",
        symbol: "btcp",
        expectedLength: 26,
        addressTypes: {
            prod: [
                "1325",
                "13af"
            ],
            testnet: [
                "1957",
                "19e0"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "Hush",
        symbol: "hush",
        expectedLength: 26,
        addressTypes: {
            prod: [
                "1cb8",
                "1cbd"
            ],
            testnet: [
                "1d25",
                "1cba"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "SnowGem",
        symbol: "sng",
        expectedLength: 26,
        addressTypes: {
            prod: [
                "1c28",
                "1c2d"
            ],
            testnet: [
                "1d25",
                "1cba"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "ZCash",
        symbol: "zec",
        expectedLength: 26,
        addressTypes: {
            prod: [
                "1cb8",
                "1cbd"
            ],
            testnet: [
                "1d25",
                "1cba"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "ZClassic",
        symbol: "zcl",
        expectedLength: 26,
        addressTypes: {
            prod: [
                "1cb8",
                "1cbd"
            ],
            testnet: [
                "1d25",
                "1cba"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "ZenCash",
        symbol: "zen",
        expectedLength: 26,
        addressTypes: {
            prod: [
                "2089",
                "2096"
            ],
            testnet: [
                "2092",
                "2098"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "VoteCoin",
        symbol: "vot",
        expectedLength: 26,
        addressTypes: {
            prod: [
                "1cb8",
                "1cbd"
            ],
            testnet: [
                "1d25",
                "1cba"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "Decred",
        symbol: "dcr",
        addressTypes: {
            prod: [
                "073f",
                "071a"
            ],
            testnet: [
                "0f21",
                "0efc"
            ]
        },
        hashFunction: "blake256",
        expectedLength: 26,
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "GameCredits",
        symbol: "game",
        addressTypes: {
            prod: [
                "26",
                "05"
            ],
            testnet: []
        },
        validator: $a0584d44d5748453$exports
    },
    {
        name: "PIVX",
        symbol: "pivx",
        addressTypes: {
            prod: [
                "1e",
                "0d"
            ],
            testnet: []
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "SolarCoin",
        symbol: "slr",
        addressTypes: {
            prod: [
                "12",
                "05"
            ],
            testnet: []
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "MonaCoin",
        symbol: "mona",
        addressTypes: {
            prod: [
                "32",
                "37"
            ],
            testnet: []
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "DigiByte",
        symbol: "dgb",
        addressTypes: {
            prod: [
                "1e",
                "3f"
            ],
            testnet: []
        },
        bech32Hrp: {
            prod: [
                "dgb",
                "S"
            ],
            testnet: []
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "Tether",
        symbol: "usdt",
        addressTypes: {
            prod: [
                "00",
                "05"
            ],
            testnet: [
                "6f",
                "c4"
            ]
        },
        validator: $8ab285fc975f24a2$exports
    },
    {
        name: "Ripple",
        symbol: "xrp",
        validator: $7f670113ed8e5f5d$exports
    },
    {
        name: "Dash",
        symbol: "dash",
        addressTypes: {
            prod: [
                "4c",
                "10"
            ],
            testnet: [
                "8c",
                "13"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "Neo",
        symbol: "neo",
        addressTypes: {
            prod: [
                "17"
            ],
            testnet: []
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "NeoGas",
        symbol: "gas",
        addressTypes: {
            prod: [
                "17"
            ],
            testnet: []
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "Qtum",
        symbol: "qtum",
        addressTypes: {
            prod: [
                "3a",
                "32"
            ],
            testnet: [
                "78",
                "6e"
            ]
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "Waves",
        symbol: "waves",
        addressTypes: {
            prod: [
                "0157"
            ],
            testnet: [
                "0154"
            ]
        },
        expectedLength: 26,
        hashFunction: "blake256keccak256",
        regex: /^[a-zA-Z0-9]{35}$/,
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "Ethereum",
        symbol: "eth",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "EtherZero",
        symbol: "etz",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "EthereumClassic",
        symbol: "etc",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Callisto",
        symbol: "clo",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Bankex",
        symbol: "bkx",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Cardano",
        symbol: "ada",
        bech32Hrp: {
            prod: [
                "addr"
            ],
            testnet: [
                "addr"
            ]
        },
        validator: $afee0a8b798c70de$exports
    },
    {
        name: "Monero",
        symbol: "xmr",
        addressTypes: {
            prod: [
                "18",
                "42"
            ],
            testnet: [
                "53",
                "63"
            ],
            stagenet: [
                "24"
            ]
        },
        iAddressTypes: {
            prod: [
                "19"
            ],
            testnet: [
                "54"
            ],
            stagenet: [
                "25"
            ]
        },
        validator: $5f2aef207c8ec557$exports
    },
    {
        name: "Aragon",
        symbol: "ant",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Basic Attention Token",
        symbol: "bat",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Bancor",
        symbol: "bnt",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Civic",
        symbol: "cvc",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "District0x",
        symbol: "dnt",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Gnosis",
        symbol: "gno",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Golem (GNT)",
        symbol: "gnt",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Golem",
        symbol: "glm",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Matchpool",
        symbol: "gup",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Melon",
        symbol: "mln",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Numeraire",
        symbol: "nmr",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "OmiseGO",
        symbol: "omg",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "TenX",
        symbol: "pay",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Ripio Credit Network",
        symbol: "rcn",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Augur",
        symbol: "rep",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "iExec RLC",
        symbol: "rlc",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Salt",
        symbol: "salt",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Status",
        symbol: "snt",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Storj",
        symbol: "storj",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Swarm City",
        symbol: "swt",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "TrueUSD",
        symbol: "tusd",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Wings",
        symbol: "wings",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "0x",
        symbol: "zrx",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Expanse",
        symbol: "exp",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Viberate",
        symbol: "vib",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Odyssey",
        symbol: "ocn",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Polymath",
        symbol: "poly",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Storm",
        symbol: "storm",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Nano",
        symbol: "nano",
        validator: $336dba217d6ddac6$exports
    },
    {
        name: "RaiBlocks",
        symbol: "xrb",
        validator: $336dba217d6ddac6$exports
    },
    {
        name: "Siacoin",
        symbol: "sc",
        validator: $6b026ccf4821881e$exports
    },
    {
        name: "HyperSpace",
        symbol: "xsc",
        validator: $6b026ccf4821881e$exports
    },
    {
        name: "loki",
        symbol: "loki",
        addressTypes: {
            prod: [
                "114",
                "115",
                "116"
            ],
            testnet: []
        },
        iAddressTypes: {
            prod: [
                "115"
            ],
            testnet: []
        },
        validator: $5f2aef207c8ec557$exports
    },
    {
        name: "LBRY Credits",
        symbol: "lbc",
        addressTypes: {
            prod: [
                "55"
            ],
            testnet: []
        },
        validator: $d7830e5c3dae45dc$exports
    },
    {
        name: "Tron",
        symbol: "trx",
        addressTypes: {
            prod: [
                0x41
            ],
            testnet: [
                0xa0
            ]
        },
        validator: $e3834544189981e1$exports
    },
    {
        name: "Nem",
        symbol: "xem",
        validator: $15b26037f9b2142e$exports
    },
    {
        name: "Lisk",
        symbol: "lsk",
        validator: $49240c05227c39c5$exports
    },
    {
        name: "Stellar",
        symbol: "xlm",
        validator: $4f9a595db52b4d12$exports
    },
    {
        name: "BTU Protocol",
        symbol: "btu",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Crypto.com Coin",
        symbol: "cro",
        bech32Hrp: {
            prod: [
                "cro"
            ],
            testnet: [
                "tcro"
            ]
        },
        validator: $8022e38477187c54$exports
    },
    {
        name: "Multi-collateral DAI",
        symbol: "dai",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Enjin Coin",
        symbol: "enj",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "HedgeTrade",
        symbol: "hedg",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Cred",
        symbol: "lba",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Chainlink",
        symbol: "link",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Loom Network",
        symbol: "loom",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Maker",
        symbol: "mkr",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Metal",
        symbol: "mtl",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Ocean Protocol",
        symbol: "ocean",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Quant",
        symbol: "qnt",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Synthetix Network",
        symbol: "snx",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "SOLVE",
        symbol: "solve",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Spendcoin",
        symbol: "spnd",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "TEMCO",
        symbol: "temco",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "EOS",
        symbol: "eos",
        validator: $46dd7559f0a0b287$exports
    },
    {
        name: "Tezos",
        symbol: "xtz",
        validator: $9c79c08d4915caf3$exports
    },
    {
        name: "VeChain",
        symbol: "vet",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "StormX",
        symbol: "stmx",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "AugurV2",
        symbol: "repv2",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "FirmaChain",
        symbol: "fct",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "BlockTrade",
        symbol: "btt",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Quantum Resistant Ledger",
        symbol: "qrl",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Serve",
        symbol: "serv",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Tap",
        symbol: "xtp",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Compound",
        symbol: "comp",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Paxos",
        symbol: "pax",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "USD Coin",
        symbol: "usdc",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "CUSD",
        symbol: "cusd",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Algorand",
        symbol: "algo",
        validator: $587f3f830bec1d54$exports
    },
    {
        name: "Polkadot",
        symbol: "dot",
        validator: $df84a3afc54966ce$exports
    },
    {
        name: "Uniswap Coin",
        symbol: "uni",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Aave Coin",
        symbol: "aave",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Matic",
        symbol: "matic",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Decentraland",
        symbol: "mana",
        validator: $a0584d44d5748453$exports
    },
    {
        name: "Solana",
        symbol: "sol",
        validator: $59b81c15657aa75a$exports,
        maxLength: 44,
        minLength: 43
    },
    {
        name: "Binance",
        symbol: "bnb",
        validator: $a0584d44d5748453$exports
    }
];
$c1a715e3879d5de0$exports = {
    getByNameOrSymbol: function(currencyNameOrSymbol) {
        var nameOrSymbol = currencyNameOrSymbol.toLowerCase();
        return $c1a715e3879d5de0$var$CURRENCIES.find(function(currency) {
            return currency.name.toLowerCase() === nameOrSymbol || currency.symbol.toLowerCase() === nameOrSymbol;
        });
    },
    getAll: function() {
        return $c1a715e3879d5de0$var$CURRENCIES;
    }
}; ////spit out details for readme.md
 // CURRENCIES
 //     .sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1)
 //     .forEach(c => console.log(`* ${c.name}/${c.symbol} \`'${c.name}'\` or \`'${c.symbol}'\` `));
 ////spit out keywords for package.json
 // CURRENCIES
 //     .sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1)
 //     .forEach(c => console.log(`"${c.name}","${c.symbol}",`));
 //


var $638c0eb86fd107b8$var$DEFAULT_CURRENCY_NAME = "bitcoin";
$638c0eb86fd107b8$exports = {
    //validate: function (address, currencyNameOrSymbol, networkType) {
    validate: function(address, currencyNameOrSymbol, opts) {
        var currency = $c1a715e3879d5de0$exports.getByNameOrSymbol(currencyNameOrSymbol || $638c0eb86fd107b8$var$DEFAULT_CURRENCY_NAME);
        if (currency && currency.validator) {
            if (opts && typeof opts === "string") return currency.validator.isValidAddress(address, currency, {
                networkType: opts
            });
            return currency.validator.isValidAddress(address, currency, opts);
        }
        throw new Error("Missing validator for currency: " + currencyNameOrSymbol);
    },
    getCurrencies: function() {
        return $c1a715e3879d5de0$exports.getAll();
    },
    findCurrency: function(symbol) {
        return $c1a715e3879d5de0$exports.getByNameOrSymbol(symbol) || null;
    }
};


// Assets
var $ca02f078baba240c$exports = {};
$ca02f078baba240c$exports = new URL("bitcoin.515991ba.png", import.meta.url).toString();


var $528dd5e4df7f1b97$exports = {};
$528dd5e4df7f1b97$exports = new URL("bitcoinCash.9f736f7c.png", import.meta.url).toString();


var $692d37cdc4ae9500$exports = {};
$692d37cdc4ae9500$exports = new URL("ethereum.9fc0fcb9.png", import.meta.url).toString();


var $21adf9fb2f7e9def$exports = {};
$21adf9fb2f7e9def$exports = new URL("litecoin.318ef1f5.png", import.meta.url).toString();


const $f398806f8c37b1c3$export$d631eb4fd6125e2b = [
    {
        value: true,
        label: "Yes"
    },
    {
        value: false,
        label: "No"
    }
];
const $f398806f8c37b1c3$export$1602228db68db5a2 = [
    {
        value: "customer",
        label: "Customer"
    },
    {
        value: "non-customer",
        label: "Non-Customer"
    }
];
const $f398806f8c37b1c3$export$e7143bbefb1abdd7 = [
    {
        value: "all",
        label: "All"
    },
    {
        value: "customer",
        label: "Customer"
    },
    {
        value: "non-customer",
        label: "Non-Customer"
    }
];
const $f398806f8c37b1c3$export$ba280eda23443882 = {
    customer: {
        value: "customer",
        label: "Customer"
    },
    nonCustomer: {
        value: "non-customer",
        label: "Non-Customer"
    },
    all: {
        value: "all",
        label: "All"
    }
};
const $f398806f8c37b1c3$export$788d60523da67a3d = [
    {
        value: 0,
        label: "Overview"
    }
];
const $f398806f8c37b1c3$export$969ddde627a04710 = [
    {
        value: 0,
        label: "Activity"
    },
    {
        value: 1,
        label: "Account Details"
    }
];
const $f398806f8c37b1c3$export$a1047fed33151c40 = [
    // { value: 0, label: 'Activity' },
    {
        value: 0,
        label: "Transactions"
    },
    {
        value: 1,
        label: "Travel Rule"
    },
    {
        value: 2,
        label: "Alerts"
    }
];
const $f398806f8c37b1c3$export$480784e1043d360 = [
    {
        value: 1,
        label: "User"
    },
    {
        value: 1,
        label: "Super User"
    },
    {
        value: 2,
        label: "Admin"
    }
];
const $f398806f8c37b1c3$export$6096865e4aa58c8a = [
    {
        value: 1,
        label: "Individual"
    },
    {
        value: 2,
        label: "Entity"
    }
];
const $f398806f8c37b1c3$export$e4493caf40597bf1 = [
    {
        value: 0,
        label: "Inactive"
    },
    {
        value: 1,
        label: "Active"
    },
    {
        value: 2,
        label: "On Hold"
    },
    {
        value: 3,
        label: "Dormant"
    }
];
const $f398806f8c37b1c3$export$ac88620a652f8304 = [
    {
        value: 0,
        label: "-"
    },
    {
        value: 1,
        label: "Low"
    },
    {
        value: 2,
        label: "Medium"
    },
    {
        value: 3,
        label: "High"
    }
];
const $f398806f8c37b1c3$export$25da77dc5a049837 = [
    {
        value: 1,
        label: "No"
    },
    {
        value: 2,
        label: "Yes"
    }
];
const $f398806f8c37b1c3$export$387652efbf140906 = [
    {
        value: 1,
        label: "Bank"
    },
    {
        value: 2,
        label: "Asset Provider"
    }
];
const $f398806f8c37b1c3$export$e15fc428f51df618 = [
    {
        value: 1,
        label: "Teacher"
    },
    {
        value: 2,
        label: "Software Developer"
    }
];
const $f398806f8c37b1c3$export$879b0a313b10655e = [
    {
        value: false,
        label: "Account"
    },
    {
        value: true,
        label: "Non-Customer"
    }
];
const $f398806f8c37b1c3$export$248e562e1e9718a2 = [
    {
        value: "AnalystLevel1",
        label: "Analyst Level 1"
    },
    {
        value: "AnalystLevel2",
        label: "Analyst Level 2"
    },
    {
        value: "AnalystLevel3",
        label: "Analyst Level 3"
    }
];
const $f398806f8c37b1c3$export$c1a00cf5f70fe545 = [
    {
        value: "open",
        label: "Open"
    },
    {
        value: "pending",
        label: "Pending"
    },
    {
        value: "closed",
        label: "Closed"
    }
];
const $f398806f8c37b1c3$export$a4c8beecaa30f3f4 = {
    AnalystLevel1: {
        value: "AnalystLevel1",
        label: "Analyst Level 1"
    },
    AnalystLevel2: {
        value: "AnalystLevel2",
        label: "Analyst Level 2"
    },
    AnalystLevel3: {
        value: "AnalystLevel3",
        label: "Analyst Level 3"
    }
};
const $f398806f8c37b1c3$export$ce1a7fad323de9c4 = {
    open: {
        value: "open",
        label: "Open"
    },
    pending: {
        value: "pending",
        label: "Pending"
    },
    closed: {
        value: "closed",
        label: "Closed"
    }
};
const $f398806f8c37b1c3$export$3621effa4f93f147 = [
    {
        label: "All"
    },
    {
        value: 1,
        label: "Natural Person"
    },
    {
        value: 2,
        label: "Legal Person"
    }
];
const $f398806f8c37b1c3$export$f21254d1452fae92 = [
    {
        value: 0,
        label: "Not Available"
    },
    {
        value: 1,
        label: "Low"
    },
    {
        value: 2,
        label: "Medium"
    },
    {
        value: 3,
        label: "High"
    }
];
const $f398806f8c37b1c3$export$b58677bc839a7d0a = [
    {
        value: 0,
        label: "Not Available"
    },
    {
        value: 1,
        label: "No"
    },
    {
        value: 2,
        label: "Yes"
    }
];
const $f398806f8c37b1c3$export$390dad8ed933960f = [
    {
        value: "Case_Since",
        label: "Case Since"
    },
    {
        value: "AddressCount",
        label: "Address Count"
    },
    {
        value: "TxCount",
        label: "Transaction Count"
    }
];
const $f398806f8c37b1c3$export$b5af4da0b7df094e = [
    {
        value: 0,
        label: "Not Available"
    },
    {
        value: 1,
        label: "No"
    },
    {
        value: 2,
        label: "Yes"
    }
];
const $f398806f8c37b1c3$export$9f6eacc7441dfea9 = [
    {
        value: "bitcoin",
        label: "Bitcoin",
        abrv: "BTC",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ca02f078baba240c$exports))),
        regex: {
            transaction: /^[a-fA-F0-9]{64}$/,
            address: /^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$/
        }
    },
    {
        value: "ethereum",
        label: "Ethereum",
        abrv: "ETH",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($692d37cdc4ae9500$exports))),
        regex: {
            transaction: /^0x([A-Fa-f0-9]{64})$/,
            address: /^(0x){1}[0-9a-fA-F]{40}/
        }
    },
    {
        value: "bitcoin-cash",
        label: "Bitcoin Cash",
        abrv: "BCH",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($528dd5e4df7f1b97$exports))),
        regex: {
            /* transaction id regex identifies any SHA256 hash */ transaction: /[0-9a-f]{64}/,
            address: /[13][a-km-zA-HJ-NP-Z1-9]{33}/
        }
    },
    {
        value: "litecoin",
        label: "Litecoin",
        abrv: "LTC",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($21adf9fb2f7e9def$exports))),
        regex: {
            /* transaction id regex identifies any Scrypt hash */ transaction: /^\\$s0\\$[0-9a-f]{5,6}\\$[a-zA-Z0-9/+]+[=]*\\$[a-zA-Z0-9/+]+[=]*$/,
            address: /[lm3][a-zA-Z0-9]{26,42}|[LM3][a-km-zA-HJ-NP-Z1-9]{26,33}/
        }
    }
];
const $f398806f8c37b1c3$export$cfce4cc2a24073 = [
    {
        value: "BTC",
        label: "BTC"
    },
    {
        value: "ETH",
        label: "ETH"
    },
    {
        value: "BCH",
        label: "BCH"
    },
    {
        value: "LTC",
        label: "LTC"
    },
    {
        value: "BSV",
        label: "BSV"
    },
    {
        value: "DOGE",
        label: "DOGE"
    },
    {
        value: "ZEC",
        label: "ZEC"
    },
    {
        value: "XRP",
        label: "XRP"
    },
    {
        value: "XLM",
        label: "XLM"
    },
    {
        value: "XDC",
        label: "XDC"
    },
    {
        value: "SOL",
        label: "SOL"
    },
    {
        value: "ALGO",
        label: "ALGO"
    },
    {
        value: "MATIC",
        label: "MATIC"
    },
    {
        value: "DOT",
        label: "DOT"
    },
    {
        value: "XTZ",
        label: "XTZ"
    },
    {
        value: "NEAR",
        label: "NEAR"
    }
];
const $f398806f8c37b1c3$export$53c0b7944743072a = {
    ALGO: {
        dti: "M8Z9JSG9Q",
        chain: "ALGO",
        chain_name: "algorand"
    },
    BTC: {
        dti: "4H95J0R2X",
        chain: "BTC",
        chain_name: "bitcoin"
    },
    BCH: {
        dti: "J9K583ZGG",
        chain: "BCH",
        chain_name: "bitcoin-cash"
    },
    BSV: {
        dti: "2L8HS2MNP",
        chain: "BSV",
        chain_name: "bitcoin-sv"
    },
    DASH: {
        dti: "M5D76SHV5",
        chain: "DASH",
        chain_name: "dash"
    },
    DOGE: {
        dti: "820B7G1NL",
        chain: "DOGE",
        chain_name: "doge"
    },
    ETH: {
        dti: "X9J9K872S",
        chain: "ETH",
        chain_name: "ethereum"
    },
    LTC: {
        dti: "WTX0G7K46",
        chain: "LTC",
        chain_name: "litecoin"
    },
    NEAR: {
        dti: "DC83NXWML",
        chain: "NEAR",
        chain_name: "near"
    },
    ROSE: {
        dti: "NVD7LRM61",
        chain: "ROSE",
        chain_name: "oasis"
    },
    OP: {
        dti: "9NRMM2RC4",
        chain: "OP",
        chain_name: "optimism"
    },
    DOT: {
        dti: "P5B46MFPP",
        chain: "DOT",
        chain_name: "polkadot"
    },
    MATIC: {
        dti: "RQWW6J6K0",
        chain: "MATIC",
        chain_name: "polygon"
    },
    XRP: {
        dti: "L6GTZC9G4",
        chain: "XRP",
        chain_name: "ripple"
    },
    SOL: {
        dti: "20J63Z4N3",
        chain: "SOL",
        chain_name: "solana"
    },
    XLM: {
        dti: "C4SRNZD8K",
        chain: "XLM",
        chain_name: "stellar"
    },
    XTZ: {
        dti: "7VTRKSC7S",
        chain: "XTZ",
        chain_name: "tezos"
    },
    XDC: {
        dti: "CCQZQXFDC",
        chain: "XDC",
        chain_name: "xdc"
    },
    ZEC: {
        dti: "3DHMJ5Q02",
        chain: "ZEC",
        chain_name: "zcash"
    }
};
const $f398806f8c37b1c3$export$7000f41a852f3e5 = {
    bitcoin: "bitcoin",
    ethereum: "ethereum",
    litecoin: "litecoin",
    "bitcoin-cash": "bitcoin-cash",
    "bitcoin-sv": "bitcoin-sv",
    doge: "doge",
    zcash: "zcash",
    ripple: "ripple",
    stellar: "stellar",
    xdc: "xdc",
    solana: "solana",
    algorand: "algorand",
    polygon: "polygon",
    polkadot: "polkadot",
    tezos: "tezos",
    near: "near"
};
const $f398806f8c37b1c3$export$2078812dcc559f01 = {
    BTC: "bitcoin",
    ETH: "ethereum",
    LTC: "litecoin",
    BCH: "bitcoin-cash",
    BSV: "bitcoin-sv",
    DOGE: "doge",
    ZEC: "zcash",
    XRP: "ripple",
    XLM: "stellar",
    XDC: "xdc",
    SOL: "solana",
    ALGO: "algorand",
    MATIC: "polygon",
    DOT: "polkadot",
    XTZ: "tezos",
    NEAR: "near"
};
const $f398806f8c37b1c3$export$ee40726984762919 = {
    address: 1,
    transaction: 2,
    directory: 3
};
const $f398806f8c37b1c3$export$8b2bc8759ae1fa3a = [
    {
        value: "scores",
        label: "Risk Scores"
    },
    {
        value: "financials",
        label: "Financial Details"
    },
    {
        value: "link_id",
        label: "Associated Account"
    }
];
const $f398806f8c37b1c3$export$22efbd5ad1f2c0ec = [
    {
        value: "inputs",
        label: "Input Events"
    },
    {
        value: "outputs",
        label: "Output Events"
    }
];
const $f398806f8c37b1c3$export$4b0b8bccc82aecb4 = [
    {
        value: "last_month",
        label: "Last month"
    },
    {
        value: "last_6_months",
        label: "Last 6 months"
    },
    {
        value: "last_12_months",
        label: "Last 12 months"
    }
];
const $f398806f8c37b1c3$export$1e0b44d7c26be259 = {
    last_month: {
        value: "last_month",
        label: "Last month"
    },
    last_6_months: {
        value: "last_6_months",
        label: "Last 6 months"
    },
    last_12_months: {
        value: "last_12_months",
        label: "Last 12 months"
    }
};
const $f398806f8c37b1c3$export$b56212d6dd5ac0d7 = [
    {
        value: "csv",
        label: "CSV"
    },
    {
        value: "pdf",
        label: "PDF"
    }
];
const $f398806f8c37b1c3$export$48abd99a9d2a7899 = {
    bitcoin: {
        disabled: false,
        value: "bitcoin",
        label: "bitcoin"
    },
    ethereum: {
        disabled: false,
        value: "ethereum",
        label: "ethereum"
    },
    litecoin: {
        disabled: false,
        value: "litecoin",
        label: "litecoin"
    },
    bitcoin_cash: {
        disabled: true,
        value: "bitcoin-cash",
        label: "bitcoin-cash"
    },
    bitcoin_sv: {
        disabled: true,
        value: "bitcoin-sv",
        label: "bitcoin-sv"
    },
    doge: {
        disabled: true,
        value: "doge",
        label: "doge"
    },
    dash: {
        disabled: true,
        value: "dash",
        label: "dash"
    },
    zcash: {
        disabled: true,
        value: "zcash",
        label: "zcash"
    },
    groestlcoin: {
        disabled: true,
        value: "groestlcoin",
        label: "groestlcoin"
    },
    cardano: {
        disabled: true,
        value: "cardano",
        label: "cardano"
    },
    solana: {
        disabled: true,
        value: "solana",
        label: "solana"
    },
    eos: {
        disabled: true,
        value: "eos",
        label: "eos"
    },
    ethereum_classic: {
        disabled: true,
        value: "ethereum-classic",
        label: "ethereum-classic"
    },
    ripple: {
        disabled: true,
        value: "ripple",
        label: "ripple"
    },
    xdc: {
        disabled: true,
        value: "xdc",
        label: "xdc"
    },
    stellar: {
        disabled: true,
        value: "stellar",
        label: "stellar"
    },
    algorand: {
        disabled: true,
        value: "algorand",
        label: "algorand"
    },
    tron: {
        disabled: true,
        value: "tron",
        label: "tron"
    },
    polygon: {
        disabled: true,
        value: "polygon",
        label: "polygon"
    },
    syscoin: {
        disabled: true,
        value: "syscoin",
        label: "syscoin"
    },
    xinfin: {
        disabled: true,
        value: "xinfin",
        label: "xinfin"
    }
};
const $f398806f8c37b1c3$export$5dcccb4958458517 = [
    {
        value: "0183c0fe-3f2b-7d4f-8a02-941b8a4f3442",
        label: "RDBIG"
    },
    {
        value: "0183c0fe-3f3a-76f7-9cf4-af0b628d068c",
        label: "RDCFI"
    },
    {
        value: "018379b8-a215-71bd-a8e8-001e812812c1",
        label: "RDCSL"
    },
    {
        value: "0183c15e-8d17-7c8d-ae5c-c6a645d8fd7a",
        label: "RDCTR"
    }
];
const $f398806f8c37b1c3$export$77157746a83277ad = [
    {
        value: "01836485-906e-7d3f-a6aa-c6134d6384b8",
        label: "FDBLC"
    },
    {
        value: "0183c101-f0e6-7a1e-84d1-ecdddd045437",
        label: "Crypto Compare"
    }
];
const $f398806f8c37b1c3$export$aa3828c5134f3b80 = {
    "018379b8-a215-71bd-a8e8-001e812812c1": "RDCSL",
    "0183c0fe-3f2b-7d4f-8a02-941b8a4f3442": "RDBIG",
    "0183c15e-8d17-7c8d-ae5c-c6a645d8fd7a": "RDCTR",
    "0183c0fe-3f3a-76f7-9cf4-af0b628d068c": "RDCFI"
};
const $f398806f8c37b1c3$export$896b6d2be20bb187 = {
    bitcoin: "^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$",
    ethereum: "/(\b0x[a-f0-9]{40}\b)/g",
    litecoin: "/^L[a-zA-Z0-9]{26,33}$/"
};
const $f398806f8c37b1c3$export$36a704e1fcbca502 = [
    {
        chain: "bitcoin",
        regex: "^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$"
    },
    {
        chain: "ethereum",
        regex: "/(\b0x[a-f0-9]{40}\b)/g"
    },
    {
        chain: "litecoin",
        regex: "/^L[a-zA-Z0-9]{26,33}$/"
    }
];
const $f398806f8c37b1c3$export$240fb83e234eca1c = [
    {
        disabled: false,
        value: "bitcoin",
        label: "bitcoin"
    },
    {
        disabled: false,
        value: "ethereum",
        label: "ethereum"
    },
    {
        disabled: false,
        value: "litecoin",
        label: "litecoin"
    },
    {
        disabled: false,
        value: "bitcoin-cash",
        label: "bitcoin-cash"
    },
    {
        disabled: false,
        value: "doge",
        label: "doge"
    },
    {
        disabled: false,
        value: "solana",
        label: "solana"
    },
    {
        disabled: false,
        value: "ripple",
        label: "ripple"
    },
    {
        disabled: false,
        value: "xdc",
        label: "xdc"
    },
    {
        disabled: false,
        value: "stellar",
        label: "stellar"
    },
    {
        disabled: false,
        value: "algorand",
        label: "algorand"
    },
    {
        disabled: false,
        value: "polygon",
        label: "polygon"
    },
    {
        disabled: false,
        value: "polkadot",
        label: "polkadot"
    },
    {
        disabled: false,
        value: "tezos",
        label: "tezos"
    },
    {
        disabled: false,
        value: "near",
        label: "near"
    },
    {
        disabled: false,
        value: "xinfin",
        label: "xinfin"
    }
];
const $f398806f8c37b1c3$export$57f5ee0e57b5098e = [
    {
        disabled: false,
        value: "bitcoin",
        label: "bitcoin"
    },
    {
        disabled: false,
        value: "ethereum",
        label: "ethereum"
    },
    {
        disabled: false,
        value: "litecoin",
        label: "litecoin"
    },
    {
        disabled: false,
        value: "bitcoin-cash",
        label: "bitcoin-cash"
    },
    {
        disabled: false,
        value: "doge",
        label: "doge"
    },
    {
        disabled: false,
        value: "solana",
        label: "solana"
    },
    {
        disabled: false,
        value: "ripple",
        label: "ripple"
    },
    {
        disabled: false,
        value: "xdc",
        label: "xdc"
    },
    {
        disabled: false,
        value: "stellar",
        label: "stellar"
    },
    {
        disabled: true,
        value: "algorand",
        label: "algorand"
    },
    {
        disabled: true,
        value: "polygon",
        label: "polygon"
    },
    {
        disabled: true,
        value: "polkadot",
        label: "polkadot"
    },
    {
        disabled: true,
        value: "tezos",
        label: "tezos"
    },
    {
        disabled: true,
        value: "near",
        label: "near"
    },
    {
        disabled: true,
        value: "xinfin",
        label: "xinfin"
    }
];
const $f398806f8c37b1c3$export$bd7ef7143357c357 = {
    bitcoin: true,
    ethereum: true,
    litecoin: true,
    "bitcoin-cash": true,
    "bitcoin-sv": true,
    doge: true,
    zcash: true,
    ripple: true,
    stellar: true,
    xdc: true
};
const $f398806f8c37b1c3$export$139deef207d16f27 = {
    bitcoin: true,
    ethereum: true,
    litecoin: true,
    "bitcoin-cash": true,
    "bitcoin-sv": true,
    doge: true,
    zcash: true,
    solana: true,
    ripple: true,
    stellar: true,
    algorand: true,
    polygon: true,
    polkadot: true,
    tezos: true,
    near: true
};
const $f398806f8c37b1c3$export$e40ddf4c9d6fc9cc = {
    bitcoin: "0183c0fe-3f2b-7d4f-8a02-941b8a4f3442",
    ethereum: "0183c0fe-3f2b-7d4f-8a02-941b8a4f3442",
    litecoin: "0183c0fe-3f2b-7d4f-8a02-941b8a4f3442",
    "bitcoin-cash": "0183c0fe-3f2b-7d4f-8a02-941b8a4f3442",
    "bitcoin-sv": "0183c0fe-3f2b-7d4f-8a02-941b8a4f3442",
    doge: "0183c0fe-3f2b-7d4f-8a02-941b8a4f3442",
    zcash: "0183c0fe-3f2b-7d4f-8a02-941b8a4f3442",
    ripple: "0183c0fe-3f2b-7d4f-8a02-941b8a4f3442",
    stellar: "0183c0fe-3f2b-7d4f-8a02-941b8a4f3442",
    //
    solana: "0183c0fe-3f3a-76f7-9cf4-af0b628d068c",
    algorand: "0183c0fe-3f3a-76f7-9cf4-af0b628d068c",
    polygon: "0183c0fe-3f3a-76f7-9cf4-af0b628d068c",
    polkadot: "0183c0fe-3f3a-76f7-9cf4-af0b628d068c",
    tezos: "0183c0fe-3f3a-76f7-9cf4-af0b628d068c",
    near: "0183c0fe-3f3a-76f7-9cf4-af0b628d068c"
};
const $f398806f8c37b1c3$export$504a2eb15af43985 = {
    RDBIG: $f398806f8c37b1c3$export$bd7ef7143357c357,
    RDCFI: $f398806f8c37b1c3$export$139deef207d16f27
};
const $f398806f8c37b1c3$export$a1293b6f12329fc4 = [
    {
        zoneName: "Pacific/Pago_Pago",
        value: "GMT-11",
        label: "(GMT-11:00) Pacific/Pago_Pago"
    },
    {
        zoneName: "Pacific/Midway",
        value: "GMT-11",
        label: "(GMT-11:00) Pacific/Midway"
    },
    {
        zoneName: "Pacific/Honolulu",
        value: "GMT-10",
        label: "(GMT-10:00) Pacific/Honolulu"
    },
    {
        zoneName: "Pacific/Rarotonga",
        value: "GMT-10",
        label: "(GMT-10:00) Pacific/Rarotonga"
    },
    {
        zoneName: "Pacific/Tahiti",
        value: "GMT-10",
        label: "(GMT-10:00) Pacific/Tahiti"
    },
    {
        zoneName: "Pacific/Marquesas",
        value: "GMT-9",
        label: "(GMT-09:30) Pacific/Marquesas"
    },
    {
        zoneName: "America/Anchorage",
        value: "GMT-8",
        label: "(GMT-08:00) America/Anchorage"
    },
    {
        zoneName: "America/Los_Angeles",
        value: "GMT-7",
        label: "(GMT-07:00) America/Los_Angeles"
    },
    {
        zoneName: "America/Denver",
        value: "GMT-6",
        label: "(GMT-06:00) America/Denver"
    },
    {
        zoneName: "America/Chicago",
        value: "GMT-5",
        label: "(GMT-05:00) America/Chicago"
    },
    {
        zoneName: "America/New_York",
        value: "GMT-4",
        label: "(GMT-04:00) America/New_York"
    },
    {
        zoneName: "America/Caracas",
        value: "GMT-4",
        label: "(GMT-04:00) America/Caracas"
    },
    {
        zoneName: "America/Sao_Paulo",
        value: "GMT-3",
        label: "(GMT-03:00) America/Sao_Paulo"
    },
    {
        zoneName: "America/Argentina/Buenos_Aires",
        value: "GMT-3",
        label: "(GMT-03:00) America/Argentina/Buenos_Aires"
    },
    {
        zoneName: "Atlantic/South_Georgia",
        value: "GMT-2",
        label: "(GMT-02:00) Atlantic/South_Georgia"
    },
    {
        zoneName: "Atlantic/Azores",
        value: "GMT-1",
        label: "(GMT-01:00) Atlantic/Azores"
    },
    {
        zoneName: "Europe/London",
        value: "GMT+0",
        label: "(GMT+00:00) Europe/London"
    },
    {
        zoneName: "Europe/Paris",
        value: "GMT+1",
        label: "(GMT+01:00) Europe/Paris"
    },
    {
        zoneName: "Europe/Athens",
        value: "GMT+2",
        label: "(GMT+02:00) Europe/Athens"
    },
    {
        zoneName: "Europe/Moscow",
        value: "GMT+3",
        label: "(GMT+03:00) Europe/Moscow"
    },
    {
        zoneName: "Asia/Dubai",
        value: "GMT+4",
        label: "(GMT+04:00) Asia/Dubai"
    },
    {
        zoneName: "Asia/Kolkata",
        value: "GMT+5",
        label: "(GMT+05:30) Asia/Kolkata"
    },
    {
        zoneName: "Asia/Kathmandu",
        value: "GMT+5",
        label: "(GMT+05:45) Asia/Kathmandu"
    },
    {
        zoneName: "Asia/Dhaka",
        value: "GMT+6",
        label: "(GMT+06:00) Asia/Dhaka"
    },
    {
        zoneName: "Asia/Bangkok",
        value: "GMT+7",
        label: "(GMT+07:00) Asia/Bangkok"
    },
    {
        zoneName: "Asia/Hong_Kong",
        value: "GMT+8",
        label: "(GMT+08:00) Asia/Hong_Kong"
    },
    {
        zoneName: "Asia/Tokyo",
        value: "GMT+9",
        label: "(GMT+09:00) Asia/Tokyo"
    },
    {
        zoneName: "Australia/Sydney",
        value: "GMT+10",
        label: "(GMT+10:00) Australia/Sydney"
    },
    {
        zoneName: "Pacific/Noumea",
        value: "GMT+11",
        label: "(GMT+11:00) Pacific/Noumea"
    },
    {
        zoneName: "Pacific/Auckland",
        value: "GMT+12",
        label: "(GMT+12:00) Pacific/Auckland"
    }
];
const $f398806f8c37b1c3$export$71c31dec0f381b7e = [
    {
        value: "flow",
        label: "Flow",
        disabled: false
    },
    {
        value: "trisa",
        label: "TRISA",
        disabled: true
    },
    {
        value: "trp",
        label: "TRP",
        disabled: true
    },
    {
        value: "gtr",
        label: "GTR",
        disabled: true
    }
];
const $f398806f8c37b1c3$export$81d62d4c398740e0 = [
    {
        value: "ARNU",
        label: "ARNU"
    },
    {
        value: "CCPT",
        label: "CCPT"
    },
    {
        value: "DRLC",
        label: "DRLC"
    },
    {
        value: "FIIN",
        label: "FIIN"
    },
    {
        value: "SOCS",
        label: "SOCS"
    },
    {
        value: "IDCD",
        label: "IDCD"
    },
    {
        value: "MISC",
        label: "MISC"
    }
];
const $f398806f8c37b1c3$export$4f81732cc85b5d1d = [
    {
        value: "RAID",
        label: "RAID"
    },
    {
        value: "TXID",
        label: "TXID"
    },
    {
        value: "LEIX",
        label: "LEIX"
    },
    {
        value: "MISC",
        label: "MISC"
    }
];
const $f398806f8c37b1c3$export$1d9e1f0caa6e0145 = [
    {
        value: "ARNU",
        label: "ARNU"
    },
    {
        value: "CCPT",
        label: "CCPT"
    },
    {
        value: "RAID",
        label: "RAID"
    },
    {
        value: "DRLC",
        label: "DRLC"
    },
    {
        value: "FIIN",
        label: "FIIN"
    },
    {
        value: "TXID",
        label: "TXID"
    },
    {
        value: "SOCS",
        label: "SOCS"
    },
    {
        value: "IDCD",
        label: "IDCD"
    },
    {
        value: "LEIX",
        label: "LEIX"
    },
    {
        value: "MISC",
        label: "MISC"
    }
];
const $f398806f8c37b1c3$export$43fbb932cb09c7d = [
    {
        label: "Manager",
        value: 1
    },
    {
        label: "Basic User",
        value: 2
    }
];
const $f398806f8c37b1c3$export$d34134843134085a = {
    1: {
        label: "Manager",
        value: 1
    },
    2: {
        label: "Basic User",
        value: 2
    }
};



const $4df9fc4fc5250ec2$export$e75da522f7883ec8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 10px;
`;
const $4df9fc4fc5250ec2$export$d586e0ae81c7b89b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 250px;
  width: 100%;
`;
const $4df9fc4fc5250ec2$export$b6261a2c5ea449d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  padding: 0.7rem 0.75rem;
  height: auto;
  width: 100%;
  min-height: 40px;
  box-sizing: border-box;
  margin-bottom: 1rem;

  border-radius: 5px;
  outline: none;
  border: 1px solid ${({ theme: theme })=>theme.colors.lightGray};

  &:focus {
    box-shadow: none;
    outline: none;
  }

  ${({ theme: theme, error: error })=>error && `border-color: ${theme.colors.red};`}

  &:focus {
    ${({ theme: theme, error: error })=>error && `border-color: ${theme.colors.red};`}
  }
`;



function $1cc23f157c65097f$var$SearchInput(props) {
    // Destructure
    const { error: error, handleOnSubmit: handleOnSubmit, type: type } = props;
    // States
    const [hash, setHash] = (0, $tZqWC.useState)("");
    const [chainOptions, setChainOptions] = (0, $tZqWC.useState)((0, $f398806f8c37b1c3$export$9f6eacc7441dfea9));
    const [placeholder, setPlaceholder] = (0, $tZqWC.useState)("Select Chain");
    const [chainType, setChainType] = (0, $tZqWC.useState)("");
    // Functions
    const checkChain = (value)=>{
        if (value) {
            const data = [];
            (0, $f398806f8c37b1c3$export$9f6eacc7441dfea9).map((item)=>{
                if (type === "address") {
                    const valid = (0, (/*@__PURE__*/$parcel$interopDefault($638c0eb86fd107b8$exports))).validate(value, item.abrv.toLowerCase());
                    if (valid) return data.push(item);
                }
                if (type === "transaction") return data.push(item);
            });
            if (data?.length) setChainOptions(data);
            else if (!data?.length) setChainOptions((0, $f398806f8c37b1c3$export$9f6eacc7441dfea9));
        }
        if (!value) setChainOptions((0, $f398806f8c37b1c3$export$9f6eacc7441dfea9));
    };
    const handleInputChange = (event)=>{
        const { value: value } = event.target;
        setPlaceholder("Select Chain");
        setHash(value);
        checkChain(value);
    };
    const handleSelectChange = (value)=>{
        setChainType(value);
        if (hash && value) {
            handleOnSubmit(hash, value);
            setTimeout(()=>{
                setHash("");
                setChainType("");
            }, 500);
        }
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $4df9fc4fc5250ec2$export$e75da522f7883ec8), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4df9fc4fc5250ec2$export$b6261a2c5ea449d), {
                placeholder: "Enter Hash",
                error: error ? 1 : 0,
                value: hash,
                onChange: handleInputChange
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4df9fc4fc5250ec2$export$d586e0ae81c7b89b), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $47c62aa7410890bd$export$2e2bcd8739ae039), {
                    placeholder: placeholder,
                    options: chainOptions,
                    value: chainType,
                    disabled: !hash,
                    onChange: handleSelectChange
                })
            })
        ]
    });
}
// Default Props
$1cc23f157c65097f$var$SearchInput.defaultProps = {
    error: false,
    handleOnSubmit: ()=>{},
    type: ""
};
// Proptypes Validation
$1cc23f157c65097f$var$SearchInput.propTypes = {
    error: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    handleOnSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $1cc23f157c65097f$export$2e2bcd8739ae039 = $1cc23f157c65097f$var$SearchInput;


var $255c48fb0e89589f$export$2e2bcd8739ae039 = (0, $1cc23f157c65097f$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $57e87faffac03b42$export$6aa22a823032b784 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  border-radius: 5px;

  // Themed Properties
  border: 1px solid ${({ theme: theme })=>theme.colors.ash};
  background-color: ${({ theme: theme })=>theme.colors.white};
`;
const $57e87faffac03b42$export$5665775b26e26c5d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 15px 15px 15px 20px;

  // Themed Properties
  border-bottom: 1px solid ${({ theme: theme })=>theme.colors.ash};
`;
const $57e87faffac03b42$export$fc7d07610936a2e3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: table-cell;
  width: 30px;
  min-width: 30px;
  vertical-align: middle;
`;
const $57e87faffac03b42$export$3d29e566b93fc027 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: table-cell;
  font-weight: 500;
  white-space: nowrap;
  padding-left: 10px;
  vertical-align: middle;

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.darkGray};

  // Responsive Properties
  ${({ theme: theme })=>theme.functions.mediaQuery("font-size", [
        "14px",
        "14px",
        "14px",
        "14px",
        "14px",
        "14px",
        "17px",
        "17px"
    ])}
`;
const $57e87faffac03b42$export$851de33184ecdac4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 15px;
`;
const $57e87faffac03b42$export$e9897d434e0741ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;


function $0620e7d3969b2377$var$Card(props) {
    // Destructure
    const { children: children, titleIcon: titleIcon, title: title, footer: footer } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $57e87faffac03b42$export$6aa22a823032b784), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $57e87faffac03b42$export$5665775b26e26c5d), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $57e87faffac03b42$export$fc7d07610936a2e3), {
                        children: titleIcon
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $57e87faffac03b42$export$3d29e566b93fc027), {
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $57e87faffac03b42$export$851de33184ecdac4), {
                children: children
            }),
            footer && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $57e87faffac03b42$export$e9897d434e0741ee), {
                children: footer
            })
        ]
    });
}
// Default Props
$0620e7d3969b2377$var$Card.defaultProps = {
    title: "",
    titleIcon: "",
    footer: "",
    children: ""
};
// Proptypes Validation
$0620e7d3969b2377$var$Card.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    footer: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $0620e7d3969b2377$export$2e2bcd8739ae039 = $0620e7d3969b2377$var$Card;


var $fda44ae20bb64b6c$export$2e2bcd8739ae039 = (0, $0620e7d3969b2377$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $e71f38b40042922b$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;

  border-radius: 10px;
  width: 100%;
  transition: 0.3s;
  cursor: pointer;

  background-color: ${({ theme: theme })=>theme.colors.white};
  border: 1px solid ${({ active: active, theme: theme })=>active ? theme.colors.blue : theme.colors.gray};
  color: ${({ theme: theme })=>theme.colors.darkGray};
  padding: 20px;

  &:hover {
    border: 1px solid ${({ theme: theme })=>theme.colors.blue};
  }
`;
const $e71f38b40042922b$export$35e09ba17cc51c69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 16px;

  & svg path {
    stroke: ${({ theme: theme })=>theme.colors.darkGray};
  }
`;
const $e71f38b40042922b$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $e71f38b40042922b$export$8f314e512d92575f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px;
  border-radius: 100%;
  border: 1px solid ${({ theme: theme })=>theme.colors.darkGray};
  height: 35px;
  width: 35px;
`;
const $e71f38b40042922b$export$d7a54cba636a8cd6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 30px;
  width: 100%;
`;
const $e71f38b40042922b$export$2580bc860330613c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 60px;
`;
const $e71f38b40042922b$export$5ec4077fbf8c4ba6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;
const $e71f38b40042922b$export$2b4a904504ac8010 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.gray};
  font-size: 12px;
`;
const $e71f38b40042922b$export$4354e6bdd4f3551a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.blue};
  font-size: 20px !important;
  font-weight: 600 !important;
`;


function $2e45d4d2cf64e7ff$var$CardInfo(props) {
    // Destructure
    const { title: title, icon: icon, data: data, active: active, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e71f38b40042922b$export$e6dfd72ab29f8598), {
        active: active,
        ...rest,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e71f38b40042922b$export$35e09ba17cc51c69), {
                children: [
                    icon && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e71f38b40042922b$export$8f314e512d92575f), {
                        children: icon
                    }),
                    title && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e71f38b40042922b$export$f99233281efd08a0), {
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e71f38b40042922b$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e71f38b40042922b$export$2580bc860330613c), {
                children: data && data?.map((item)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e71f38b40042922b$export$5ec4077fbf8c4ba6), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e71f38b40042922b$export$2b4a904504ac8010), {
                                children: [
                                    item?.label,
                                    ": "
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e71f38b40042922b$export$4354e6bdd4f3551a), {
                                children: item?.value
                            })
                        ]
                    }, item?.label))
            })
        ]
    });
}
// Default Props
$2e45d4d2cf64e7ff$var$CardInfo.defaultProps = {
    title: "",
    data: [],
    active: false
};
// Proptypes Validation
$2e45d4d2cf64e7ff$var$CardInfo.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})),
    active: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $2e45d4d2cf64e7ff$export$2e2bcd8739ae039 = $2e45d4d2cf64e7ff$var$CardInfo;


var $97b5b998d9c9faaf$export$2e2bcd8739ae039 = (0, $2e45d4d2cf64e7ff$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $tZqWC = parcelRequire("tZqWC");

var $92ABP = parcelRequire("92ABP");
var $a70cb0f111aafadd$exports = {};


/**
* @version: 3.1
* @author: Dan Grossman http://www.dangrossman.info/
* @copyright: Copyright (c) 2012-2019 Dan Grossman. All rights reserved.
* @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
* @website: http://www.daterangepicker.com/
*/ // Following the UMD template https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js
(function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Make globaly available as well
    define([
        "moment",
        "jquery"
    ], function(moment, jquery) {
        if (!jquery.fn) jquery.fn = {}; // webpack server rendering
        if (typeof moment !== "function" && moment.hasOwnProperty("default")) moment = moment["default"];
        return factory(moment, jquery);
    });
    else if (0, $a70cb0f111aafadd$exports) {
        // Node / Browserify
        //isomorphic issue
        var jQuery = typeof window != "undefined" ? window.jQuery : undefined;
        if (!jQuery) {
            jQuery = (parcelRequire("92ABP"));
            if (!jQuery.fn) jQuery.fn = {};
        }
        var moment = typeof window != "undefined" && typeof window.moment != "undefined" ? window.moment : (parcelRequire("ejSM7"));
        $a70cb0f111aafadd$exports = factory(moment, jQuery);
    } else // Browser globals
    root.daterangepicker = factory(root.moment, root.jQuery);
})($a70cb0f111aafadd$exports, function(moment, $) {
    var DateRangePicker = function(element, options, cb) {
        //default settings for options
        this.parentEl = "body";
        this.element = $(element);
        this.startDate = moment().startOf("day");
        this.endDate = moment().endOf("day");
        this.minDate = false;
        this.maxDate = false;
        this.maxSpan = false;
        this.autoApply = false;
        this.singleDatePicker = false;
        this.showDropdowns = false;
        this.minYear = moment().subtract(100, "year").format("YYYY");
        this.maxYear = moment().add(100, "year").format("YYYY");
        this.showWeekNumbers = false;
        this.showISOWeekNumbers = false;
        this.showCustomRangeLabel = true;
        this.timePicker = false;
        this.timePicker24Hour = false;
        this.timePickerIncrement = 1;
        this.timePickerSeconds = false;
        this.linkedCalendars = true;
        this.autoUpdateInput = true;
        this.alwaysShowCalendars = false;
        this.ranges = {};
        this.opens = "right";
        if (this.element.hasClass("pull-right")) this.opens = "left";
        this.drops = "down";
        if (this.element.hasClass("dropup")) this.drops = "up";
        this.buttonClasses = "btn btn-sm";
        this.applyButtonClasses = "btn-primary";
        this.cancelButtonClasses = "btn-default";
        this.locale = {
            direction: "ltr",
            format: moment.localeData().longDateFormat("L"),
            separator: " - ",
            applyLabel: "Apply",
            cancelLabel: "Cancel",
            weekLabel: "W",
            customRangeLabel: "Custom Range",
            daysOfWeek: moment.weekdaysMin(),
            monthNames: moment.monthsShort(),
            firstDay: moment.localeData().firstDayOfWeek()
        };
        this.callback = function() {};
        //some state information
        this.isShowing = false;
        this.leftCalendar = {};
        this.rightCalendar = {};
        //custom options from user
        if (typeof options !== "object" || options === null) options = {};
        //allow setting options with data attributes
        //data-api options will be overwritten with custom javascript options
        options = $.extend(this.element.data(), options);
        //html template for the picker UI
        if (typeof options.template !== "string" && !(options.template instanceof $)) options.template = '<div class="daterangepicker"><div class="ranges"></div><div class="drp-calendar left"><div class="calendar-table"></div><div class="calendar-time"></div></div><div class="drp-calendar right"><div class="calendar-table"></div><div class="calendar-time"></div></div><div class="drp-buttons"><span class="drp-selected"></span><button class="cancelBtn" type="button"></button><button class="applyBtn" disabled="disabled" type="button"></button> </div></div>';
        this.parentEl = options.parentEl && $(options.parentEl).length ? $(options.parentEl) : $(this.parentEl);
        this.container = $(options.template).appendTo(this.parentEl);
        //
        // handle all the possible options overriding defaults
        //
        if (typeof options.locale === "object") {
            if (typeof options.locale.direction === "string") this.locale.direction = options.locale.direction;
            if (typeof options.locale.format === "string") this.locale.format = options.locale.format;
            if (typeof options.locale.separator === "string") this.locale.separator = options.locale.separator;
            if (typeof options.locale.daysOfWeek === "object") this.locale.daysOfWeek = options.locale.daysOfWeek.slice();
            if (typeof options.locale.monthNames === "object") this.locale.monthNames = options.locale.monthNames.slice();
            if (typeof options.locale.firstDay === "number") this.locale.firstDay = options.locale.firstDay;
            if (typeof options.locale.applyLabel === "string") this.locale.applyLabel = options.locale.applyLabel;
            if (typeof options.locale.cancelLabel === "string") this.locale.cancelLabel = options.locale.cancelLabel;
            if (typeof options.locale.weekLabel === "string") this.locale.weekLabel = options.locale.weekLabel;
            if (typeof options.locale.customRangeLabel === "string") {
                //Support unicode chars in the custom range name.
                var elem = document.createElement("textarea");
                elem.innerHTML = options.locale.customRangeLabel;
                var rangeHtml = elem.value;
                this.locale.customRangeLabel = rangeHtml;
            }
        }
        this.container.addClass(this.locale.direction);
        if (typeof options.startDate === "string") this.startDate = moment(options.startDate, this.locale.format);
        if (typeof options.endDate === "string") this.endDate = moment(options.endDate, this.locale.format);
        if (typeof options.minDate === "string") this.minDate = moment(options.minDate, this.locale.format);
        if (typeof options.maxDate === "string") this.maxDate = moment(options.maxDate, this.locale.format);
        if (typeof options.startDate === "object") this.startDate = moment(options.startDate);
        if (typeof options.endDate === "object") this.endDate = moment(options.endDate);
        if (typeof options.minDate === "object") this.minDate = moment(options.minDate);
        if (typeof options.maxDate === "object") this.maxDate = moment(options.maxDate);
        // sanity check for bad options
        if (this.minDate && this.startDate.isBefore(this.minDate)) this.startDate = this.minDate.clone();
        // sanity check for bad options
        if (this.maxDate && this.endDate.isAfter(this.maxDate)) this.endDate = this.maxDate.clone();
        if (typeof options.applyButtonClasses === "string") this.applyButtonClasses = options.applyButtonClasses;
        if (typeof options.applyClass === "string") this.applyButtonClasses = options.applyClass;
        if (typeof options.cancelButtonClasses === "string") this.cancelButtonClasses = options.cancelButtonClasses;
        if (typeof options.cancelClass === "string") this.cancelButtonClasses = options.cancelClass;
        if (typeof options.maxSpan === "object") this.maxSpan = options.maxSpan;
        if (typeof options.dateLimit === "object") this.maxSpan = options.dateLimit;
        if (typeof options.opens === "string") this.opens = options.opens;
        if (typeof options.drops === "string") this.drops = options.drops;
        if (typeof options.showWeekNumbers === "boolean") this.showWeekNumbers = options.showWeekNumbers;
        if (typeof options.showISOWeekNumbers === "boolean") this.showISOWeekNumbers = options.showISOWeekNumbers;
        if (typeof options.buttonClasses === "string") this.buttonClasses = options.buttonClasses;
        if (typeof options.buttonClasses === "object") this.buttonClasses = options.buttonClasses.join(" ");
        if (typeof options.showDropdowns === "boolean") this.showDropdowns = options.showDropdowns;
        if (typeof options.minYear === "number") this.minYear = options.minYear;
        if (typeof options.maxYear === "number") this.maxYear = options.maxYear;
        if (typeof options.showCustomRangeLabel === "boolean") this.showCustomRangeLabel = options.showCustomRangeLabel;
        if (typeof options.singleDatePicker === "boolean") {
            this.singleDatePicker = options.singleDatePicker;
            if (this.singleDatePicker) this.endDate = this.startDate.clone();
        }
        if (typeof options.timePicker === "boolean") this.timePicker = options.timePicker;
        if (typeof options.timePickerSeconds === "boolean") this.timePickerSeconds = options.timePickerSeconds;
        if (typeof options.timePickerIncrement === "number") this.timePickerIncrement = options.timePickerIncrement;
        if (typeof options.timePicker24Hour === "boolean") this.timePicker24Hour = options.timePicker24Hour;
        if (typeof options.autoApply === "boolean") this.autoApply = options.autoApply;
        if (typeof options.autoUpdateInput === "boolean") this.autoUpdateInput = options.autoUpdateInput;
        if (typeof options.linkedCalendars === "boolean") this.linkedCalendars = options.linkedCalendars;
        if (typeof options.isInvalidDate === "function") this.isInvalidDate = options.isInvalidDate;
        if (typeof options.isCustomDate === "function") this.isCustomDate = options.isCustomDate;
        if (typeof options.alwaysShowCalendars === "boolean") this.alwaysShowCalendars = options.alwaysShowCalendars;
        // update day names order to firstDay
        if (this.locale.firstDay != 0) {
            var iterator = this.locale.firstDay;
            while(iterator > 0){
                this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
                iterator--;
            }
        }
        var start, end, range;
        //if no start/end dates set, check if an input element contains initial values
        if (typeof options.startDate === "undefined" && typeof options.endDate === "undefined") {
            if ($(this.element).is(":text")) {
                var val = $(this.element).val(), split = val.split(this.locale.separator);
                start = end = null;
                if (split.length == 2) {
                    start = moment(split[0], this.locale.format);
                    end = moment(split[1], this.locale.format);
                } else if (this.singleDatePicker && val !== "") {
                    start = moment(val, this.locale.format);
                    end = moment(val, this.locale.format);
                }
                if (start !== null && end !== null) {
                    this.setStartDate(start);
                    this.setEndDate(end);
                }
            }
        }
        if (typeof options.ranges === "object") {
            for(range in options.ranges){
                if (typeof options.ranges[range][0] === "string") start = moment(options.ranges[range][0], this.locale.format);
                else start = moment(options.ranges[range][0]);
                if (typeof options.ranges[range][1] === "string") end = moment(options.ranges[range][1], this.locale.format);
                else end = moment(options.ranges[range][1]);
                // If the start or end date exceed those allowed by the minDate or maxSpan
                // options, shorten the range to the allowable period.
                if (this.minDate && start.isBefore(this.minDate)) start = this.minDate.clone();
                var maxDate = this.maxDate;
                if (this.maxSpan && maxDate && start.clone().add(this.maxSpan).isAfter(maxDate)) maxDate = start.clone().add(this.maxSpan);
                if (maxDate && end.isAfter(maxDate)) end = maxDate.clone();
                // If the end of the range is before the minimum or the start of the range is
                // after the maximum, don't display this range option at all.
                if (this.minDate && end.isBefore(this.minDate, this.timepicker ? "minute" : "day") || maxDate && start.isAfter(maxDate, this.timepicker ? "minute" : "day")) continue;
                //Support unicode chars in the range names.
                var elem = document.createElement("textarea");
                elem.innerHTML = range;
                var rangeHtml = elem.value;
                this.ranges[rangeHtml] = [
                    start,
                    end
                ];
            }
            var list = "<ul>";
            for(range in this.ranges)list += '<li data-range-key="' + range + '">' + range + "</li>";
            if (this.showCustomRangeLabel) list += '<li data-range-key="' + this.locale.customRangeLabel + '">' + this.locale.customRangeLabel + "</li>";
            list += "</ul>";
            this.container.find(".ranges").prepend(list);
        }
        if (typeof cb === "function") this.callback = cb;
        if (!this.timePicker) {
            this.startDate = this.startDate.startOf("day");
            this.endDate = this.endDate.endOf("day");
            this.container.find(".calendar-time").hide();
        }
        //can't be used together for now
        if (this.timePicker && this.autoApply) this.autoApply = false;
        if (this.autoApply) this.container.addClass("auto-apply");
        if (typeof options.ranges === "object") this.container.addClass("show-ranges");
        if (this.singleDatePicker) {
            this.container.addClass("single");
            this.container.find(".drp-calendar.left").addClass("single");
            this.container.find(".drp-calendar.left").show();
            this.container.find(".drp-calendar.right").hide();
            if (!this.timePicker && this.autoApply) this.container.addClass("auto-apply");
        }
        if (typeof options.ranges === "undefined" && !this.singleDatePicker || this.alwaysShowCalendars) this.container.addClass("show-calendar");
        this.container.addClass("opens" + this.opens);
        //apply CSS classes and labels to buttons
        this.container.find(".applyBtn, .cancelBtn").addClass(this.buttonClasses);
        if (this.applyButtonClasses.length) this.container.find(".applyBtn").addClass(this.applyButtonClasses);
        if (this.cancelButtonClasses.length) this.container.find(".cancelBtn").addClass(this.cancelButtonClasses);
        this.container.find(".applyBtn").html(this.locale.applyLabel);
        this.container.find(".cancelBtn").html(this.locale.cancelLabel);
        //
        // event listeners
        //
        this.container.find(".drp-calendar").on("click.daterangepicker", ".prev", $.proxy(this.clickPrev, this)).on("click.daterangepicker", ".next", $.proxy(this.clickNext, this)).on("mousedown.daterangepicker", "td.available", $.proxy(this.clickDate, this)).on("mouseenter.daterangepicker", "td.available", $.proxy(this.hoverDate, this)).on("change.daterangepicker", "select.yearselect", $.proxy(this.monthOrYearChanged, this)).on("change.daterangepicker", "select.monthselect", $.proxy(this.monthOrYearChanged, this)).on("change.daterangepicker", "select.hourselect,select.minuteselect,select.secondselect,select.ampmselect", $.proxy(this.timeChanged, this));
        this.container.find(".ranges").on("click.daterangepicker", "li", $.proxy(this.clickRange, this));
        this.container.find(".drp-buttons").on("click.daterangepicker", "button.applyBtn", $.proxy(this.clickApply, this)).on("click.daterangepicker", "button.cancelBtn", $.proxy(this.clickCancel, this));
        if (this.element.is("input") || this.element.is("button")) this.element.on({
            "click.daterangepicker": $.proxy(this.show, this),
            "focus.daterangepicker": $.proxy(this.show, this),
            "keyup.daterangepicker": $.proxy(this.elementChanged, this),
            "keydown.daterangepicker": $.proxy(this.keydown, this) //IE 11 compatibility
        });
        else {
            this.element.on("click.daterangepicker", $.proxy(this.toggle, this));
            this.element.on("keydown.daterangepicker", $.proxy(this.toggle, this));
        }
        //
        // if attached to a text input, set the initial value
        //
        this.updateElement();
    };
    DateRangePicker.prototype = {
        constructor: DateRangePicker,
        setStartDate: function(startDate) {
            if (typeof startDate === "string") this.startDate = moment(startDate, this.locale.format);
            if (typeof startDate === "object") this.startDate = moment(startDate);
            if (!this.timePicker) this.startDate = this.startDate.startOf("day");
            if (this.timePicker && this.timePickerIncrement) this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            if (this.minDate && this.startDate.isBefore(this.minDate)) {
                this.startDate = this.minDate.clone();
                if (this.timePicker && this.timePickerIncrement) this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }
            if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
                this.startDate = this.maxDate.clone();
                if (this.timePicker && this.timePickerIncrement) this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }
            if (!this.isShowing) this.updateElement();
            this.updateMonthsInView();
        },
        setEndDate: function(endDate) {
            if (typeof endDate === "string") this.endDate = moment(endDate, this.locale.format);
            if (typeof endDate === "object") this.endDate = moment(endDate);
            if (!this.timePicker) this.endDate = this.endDate.endOf("day");
            if (this.timePicker && this.timePickerIncrement) this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            if (this.endDate.isBefore(this.startDate)) this.endDate = this.startDate.clone();
            if (this.maxDate && this.endDate.isAfter(this.maxDate)) this.endDate = this.maxDate.clone();
            if (this.maxSpan && this.startDate.clone().add(this.maxSpan).isBefore(this.endDate)) this.endDate = this.startDate.clone().add(this.maxSpan);
            this.previousRightTime = this.endDate.clone();
            this.container.find(".drp-selected").html(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
            if (!this.isShowing) this.updateElement();
            this.updateMonthsInView();
        },
        isInvalidDate: function() {
            return false;
        },
        isCustomDate: function() {
            return false;
        },
        updateView: function() {
            if (this.timePicker) {
                this.renderTimePicker("left");
                this.renderTimePicker("right");
                if (!this.endDate) this.container.find(".right .calendar-time select").prop("disabled", true).addClass("disabled");
                else this.container.find(".right .calendar-time select").prop("disabled", false).removeClass("disabled");
            }
            if (this.endDate) this.container.find(".drp-selected").html(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
            this.updateMonthsInView();
            this.updateCalendars();
            this.updateFormInputs();
        },
        updateMonthsInView: function() {
            if (this.endDate) {
                //if both dates are visible already, do nothing
                if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month && (this.startDate.format("YYYY-MM") == this.leftCalendar.month.format("YYYY-MM") || this.startDate.format("YYYY-MM") == this.rightCalendar.month.format("YYYY-MM")) && (this.endDate.format("YYYY-MM") == this.leftCalendar.month.format("YYYY-MM") || this.endDate.format("YYYY-MM") == this.rightCalendar.month.format("YYYY-MM"))) return;
                this.leftCalendar.month = this.startDate.clone().date(2);
                if (!this.linkedCalendars && (this.endDate.month() != this.startDate.month() || this.endDate.year() != this.startDate.year())) this.rightCalendar.month = this.endDate.clone().date(2);
                else this.rightCalendar.month = this.startDate.clone().date(2).add(1, "month");
            } else if (this.leftCalendar.month.format("YYYY-MM") != this.startDate.format("YYYY-MM") && this.rightCalendar.month.format("YYYY-MM") != this.startDate.format("YYYY-MM")) {
                this.leftCalendar.month = this.startDate.clone().date(2);
                this.rightCalendar.month = this.startDate.clone().date(2).add(1, "month");
            }
            if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
                this.rightCalendar.month = this.maxDate.clone().date(2);
                this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, "month");
            }
        },
        updateCalendars: function() {
            if (this.timePicker) {
                var hour, minute, second;
                if (this.endDate) {
                    hour = parseInt(this.container.find(".left .hourselect").val(), 10);
                    minute = parseInt(this.container.find(".left .minuteselect").val(), 10);
                    if (isNaN(minute)) minute = parseInt(this.container.find(".left .minuteselect option:last").val(), 10);
                    second = this.timePickerSeconds ? parseInt(this.container.find(".left .secondselect").val(), 10) : 0;
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find(".left .ampmselect").val();
                        if (ampm === "PM" && hour < 12) hour += 12;
                        if (ampm === "AM" && hour === 12) hour = 0;
                    }
                } else {
                    hour = parseInt(this.container.find(".right .hourselect").val(), 10);
                    minute = parseInt(this.container.find(".right .minuteselect").val(), 10);
                    if (isNaN(minute)) minute = parseInt(this.container.find(".right .minuteselect option:last").val(), 10);
                    second = this.timePickerSeconds ? parseInt(this.container.find(".right .secondselect").val(), 10) : 0;
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find(".right .ampmselect").val();
                        if (ampm === "PM" && hour < 12) hour += 12;
                        if (ampm === "AM" && hour === 12) hour = 0;
                    }
                }
                this.leftCalendar.month.hour(hour).minute(minute).second(second);
                this.rightCalendar.month.hour(hour).minute(minute).second(second);
            }
            this.renderCalendar("left");
            this.renderCalendar("right");
            //highlight any predefined range matching the current start and end dates
            this.container.find(".ranges li").removeClass("active");
            if (this.endDate == null) return;
            this.calculateChosenLabel();
        },
        renderCalendar: function(side) {
            //
            // Build the matrix of dates that will populate the calendar
            //
            var calendar = side == "left" ? this.leftCalendar : this.rightCalendar;
            var month = calendar.month.month();
            var year = calendar.month.year();
            var hour = calendar.month.hour();
            var minute = calendar.month.minute();
            var second = calendar.month.second();
            var daysInMonth = moment([
                year,
                month
            ]).daysInMonth();
            var firstDay = moment([
                year,
                month,
                1
            ]);
            var lastDay = moment([
                year,
                month,
                daysInMonth
            ]);
            var lastMonth = moment(firstDay).subtract(1, "month").month();
            var lastYear = moment(firstDay).subtract(1, "month").year();
            var daysInLastMonth = moment([
                lastYear,
                lastMonth
            ]).daysInMonth();
            var dayOfWeek = firstDay.day();
            //initialize a 6 rows x 7 columns array for the calendar
            var calendar = [];
            calendar.firstDay = firstDay;
            calendar.lastDay = lastDay;
            for(var i = 0; i < 6; i++)calendar[i] = [];
            //populate the calendar with date objects
            var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
            if (startDay > daysInLastMonth) startDay -= 7;
            if (dayOfWeek == this.locale.firstDay) startDay = daysInLastMonth - 6;
            var curDate = moment([
                lastYear,
                lastMonth,
                startDay,
                12,
                minute,
                second
            ]);
            var col, row;
            for(var i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add(24, "hour")){
                if (i > 0 && col % 7 === 0) {
                    col = 0;
                    row++;
                }
                calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
                curDate.hour(12);
                if (this.minDate && calendar[row][col].format("YYYY-MM-DD") == this.minDate.format("YYYY-MM-DD") && calendar[row][col].isBefore(this.minDate) && side == "left") calendar[row][col] = this.minDate.clone();
                if (this.maxDate && calendar[row][col].format("YYYY-MM-DD") == this.maxDate.format("YYYY-MM-DD") && calendar[row][col].isAfter(this.maxDate) && side == "right") calendar[row][col] = this.maxDate.clone();
            }
            //make the calendar object available to hoverDate/clickDate
            if (side == "left") this.leftCalendar.calendar = calendar;
            else this.rightCalendar.calendar = calendar;
            //
            // Display the calendar
            //
            var minDate = side == "left" ? this.minDate : this.startDate;
            var maxDate = this.maxDate;
            var selected = side == "left" ? this.startDate : this.endDate;
            var arrow = this.locale.direction == "ltr" ? {
                left: "chevron-left",
                right: "chevron-right"
            } : {
                left: "chevron-right",
                right: "chevron-left"
            };
            var html = '<table class="table-condensed">';
            html += "<thead>";
            html += "<tr>";
            // add empty cell for week number
            if (this.showWeekNumbers || this.showISOWeekNumbers) html += "<th></th>";
            if ((!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || side == "left")) html += '<th class="prev available"><span></span></th>';
            else html += "<th></th>";
            var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");
            if (this.showDropdowns) {
                var currentMonth = calendar[1][1].month();
                var currentYear = calendar[1][1].year();
                var maxYear = maxDate && maxDate.year() || this.maxYear;
                var minYear = minDate && minDate.year() || this.minYear;
                var inMinYear = currentYear == minYear;
                var inMaxYear = currentYear == maxYear;
                var monthHtml = '<select class="monthselect">';
                for(var m = 0; m < 12; m++)if ((!inMinYear || minDate && m >= minDate.month()) && (!inMaxYear || maxDate && m <= maxDate.month())) monthHtml += "<option value='" + m + "'" + (m === currentMonth ? " selected='selected'" : "") + ">" + this.locale.monthNames[m] + "</option>";
                else monthHtml += "<option value='" + m + "'" + (m === currentMonth ? " selected='selected'" : "") + " disabled='disabled'>" + this.locale.monthNames[m] + "</option>";
                monthHtml += "</select>";
                var yearHtml = '<select class="yearselect">';
                for(var y = minYear; y <= maxYear; y++)yearHtml += '<option value="' + y + '"' + (y === currentYear ? ' selected="selected"' : "") + ">" + y + "</option>";
                yearHtml += "</select>";
                dateHtml = monthHtml + yearHtml;
            }
            html += '<th colspan="5" class="month">' + dateHtml + "</th>";
            if ((!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || side == "right" || this.singleDatePicker)) html += '<th class="next available"><span></span></th>';
            else html += "<th></th>";
            html += "</tr>";
            html += "<tr>";
            // add week number label
            if (this.showWeekNumbers || this.showISOWeekNumbers) html += '<th class="week">' + this.locale.weekLabel + "</th>";
            $.each(this.locale.daysOfWeek, function(index, dayOfWeek) {
                html += "<th>" + dayOfWeek + "</th>";
            });
            html += "</tr>";
            html += "</thead>";
            html += "<tbody>";
            //adjust maxDate to reflect the maxSpan setting in order to
            //grey out end dates beyond the maxSpan
            if (this.endDate == null && this.maxSpan) {
                var maxLimit = this.startDate.clone().add(this.maxSpan).endOf("day");
                if (!maxDate || maxLimit.isBefore(maxDate)) maxDate = maxLimit;
            }
            for(var row = 0; row < 6; row++){
                html += "<tr>";
                // add week number
                if (this.showWeekNumbers) html += '<td class="week">' + calendar[row][0].week() + "</td>";
                else if (this.showISOWeekNumbers) html += '<td class="week">' + calendar[row][0].isoWeek() + "</td>";
                for(var col = 0; col < 7; col++){
                    var classes = [];
                    //highlight today's date
                    if (calendar[row][col].isSame(new Date(), "day")) classes.push("today");
                    //highlight weekends
                    if (calendar[row][col].isoWeekday() > 5) classes.push("weekend");
                    //grey out the dates in other months displayed at beginning and end of this calendar
                    if (calendar[row][col].month() != calendar[1][1].month()) classes.push("off", "ends");
                    //don't allow selection of dates before the minimum date
                    if (this.minDate && calendar[row][col].isBefore(this.minDate, "day")) classes.push("off", "disabled");
                    //don't allow selection of dates after the maximum date
                    if (maxDate && calendar[row][col].isAfter(maxDate, "day")) classes.push("off", "disabled");
                    //don't allow selection of date if a custom function decides it's invalid
                    if (this.isInvalidDate(calendar[row][col])) classes.push("off", "disabled");
                    //highlight the currently selected start date
                    if (calendar[row][col].format("YYYY-MM-DD") == this.startDate.format("YYYY-MM-DD")) classes.push("active", "start-date");
                    //highlight the currently selected end date
                    if (this.endDate != null && calendar[row][col].format("YYYY-MM-DD") == this.endDate.format("YYYY-MM-DD")) classes.push("active", "end-date");
                    //highlight dates in-between the selected dates
                    if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate) classes.push("in-range");
                    //apply custom classes for this date
                    var isCustom = this.isCustomDate(calendar[row][col]);
                    if (isCustom !== false) {
                        if (typeof isCustom === "string") classes.push(isCustom);
                        else Array.prototype.push.apply(classes, isCustom);
                    }
                    var cname = "", disabled = false;
                    for(var i = 0; i < classes.length; i++){
                        cname += classes[i] + " ";
                        if (classes[i] == "disabled") disabled = true;
                    }
                    if (!disabled) cname += "available";
                    html += '<td class="' + cname.replace(/^\s+|\s+$/g, "") + '" data-title="' + "r" + row + "c" + col + '">' + calendar[row][col].date() + "</td>";
                }
                html += "</tr>";
            }
            html += "</tbody>";
            html += "</table>";
            this.container.find(".drp-calendar." + side + " .calendar-table").html(html);
        },
        renderTimePicker: function(side) {
            // Don't bother updating the time picker if it's currently disabled
            // because an end date hasn't been clicked yet
            if (side == "right" && !this.endDate) return;
            var html, selected, minDate, maxDate = this.maxDate;
            if (this.maxSpan && (!this.maxDate || this.startDate.clone().add(this.maxSpan).isBefore(this.maxDate))) maxDate = this.startDate.clone().add(this.maxSpan);
            if (side == "left") {
                selected = this.startDate.clone();
                minDate = this.minDate;
            } else if (side == "right") {
                selected = this.endDate.clone();
                minDate = this.startDate;
                //Preserve the time already selected
                var timeSelector = this.container.find(".drp-calendar.right .calendar-time");
                if (timeSelector.html() != "") {
                    selected.hour(!isNaN(selected.hour()) ? selected.hour() : timeSelector.find(".hourselect option:selected").val());
                    selected.minute(!isNaN(selected.minute()) ? selected.minute() : timeSelector.find(".minuteselect option:selected").val());
                    selected.second(!isNaN(selected.second()) ? selected.second() : timeSelector.find(".secondselect option:selected").val());
                    if (!this.timePicker24Hour) {
                        var ampm = timeSelector.find(".ampmselect option:selected").val();
                        if (ampm === "PM" && selected.hour() < 12) selected.hour(selected.hour() + 12);
                        if (ampm === "AM" && selected.hour() === 12) selected.hour(0);
                    }
                }
                if (selected.isBefore(this.startDate)) selected = this.startDate.clone();
                if (maxDate && selected.isAfter(maxDate)) selected = maxDate.clone();
            }
            //
            // hours
            //
            html = '<select class="hourselect">';
            var start = this.timePicker24Hour ? 0 : 1;
            var end = this.timePicker24Hour ? 23 : 12;
            for(var i = start; i <= end; i++){
                var i_in_24 = i;
                if (!this.timePicker24Hour) i_in_24 = selected.hour() >= 12 ? i == 12 ? 12 : i + 12 : i == 12 ? 0 : i;
                var time = selected.clone().hour(i_in_24);
                var disabled = false;
                if (minDate && time.minute(59).isBefore(minDate)) disabled = true;
                if (maxDate && time.minute(0).isAfter(maxDate)) disabled = true;
                if (i_in_24 == selected.hour() && !disabled) html += '<option value="' + i + '" selected="selected">' + i + "</option>";
                else if (disabled) html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + "</option>";
                else html += '<option value="' + i + '">' + i + "</option>";
            }
            html += "</select> ";
            //
            // minutes
            //
            html += ': <select class="minuteselect">';
            for(var i = 0; i < 60; i += this.timePickerIncrement){
                var padded = i < 10 ? "0" + i : i;
                var time = selected.clone().minute(i);
                var disabled = false;
                if (minDate && time.second(59).isBefore(minDate)) disabled = true;
                if (maxDate && time.second(0).isAfter(maxDate)) disabled = true;
                if (selected.minute() == i && !disabled) html += '<option value="' + i + '" selected="selected">' + padded + "</option>";
                else if (disabled) html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + "</option>";
                else html += '<option value="' + i + '">' + padded + "</option>";
            }
            html += "</select> ";
            //
            // seconds
            //
            if (this.timePickerSeconds) {
                html += ': <select class="secondselect">';
                for(var i = 0; i < 60; i++){
                    var padded = i < 10 ? "0" + i : i;
                    var time = selected.clone().second(i);
                    var disabled = false;
                    if (minDate && time.isBefore(minDate)) disabled = true;
                    if (maxDate && time.isAfter(maxDate)) disabled = true;
                    if (selected.second() == i && !disabled) html += '<option value="' + i + '" selected="selected">' + padded + "</option>";
                    else if (disabled) html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + "</option>";
                    else html += '<option value="' + i + '">' + padded + "</option>";
                }
                html += "</select> ";
            }
            //
            // AM/PM
            //
            if (!this.timePicker24Hour) {
                html += '<select class="ampmselect">';
                var am_html = "";
                var pm_html = "";
                if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate)) am_html = ' disabled="disabled" class="disabled"';
                if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate)) pm_html = ' disabled="disabled" class="disabled"';
                if (selected.hour() >= 12) html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + ">PM</option>";
                else html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + ">PM</option>";
                html += "</select>";
            }
            this.container.find(".drp-calendar." + side + " .calendar-time").html(html);
        },
        updateFormInputs: function() {
            if (this.singleDatePicker || this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate))) this.container.find("button.applyBtn").prop("disabled", false);
            else this.container.find("button.applyBtn").prop("disabled", true);
        },
        move: function() {
            var parentOffset = {
                top: 0,
                left: 0
            }, containerTop, drops = this.drops;
            var parentRightEdge = $(window).width();
            if (!this.parentEl.is("body")) {
                parentOffset = {
                    top: this.parentEl.offset().top - this.parentEl.scrollTop(),
                    left: this.parentEl.offset().left - this.parentEl.scrollLeft()
                };
                parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
            }
            switch(drops){
                case "auto":
                    containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
                    if (containerTop + this.container.outerHeight() >= this.parentEl[0].scrollHeight) {
                        containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
                        drops = "up";
                    }
                    break;
                case "up":
                    containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
                    break;
                default:
                    containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
                    break;
            }
            // Force the container to it's actual width
            this.container.css({
                top: 0,
                left: 0,
                right: "auto"
            });
            var containerWidth = this.container.outerWidth();
            this.container.toggleClass("drop-up", drops == "up");
            if (this.opens == "left") {
                var containerRight = parentRightEdge - this.element.offset().left - this.element.outerWidth();
                if (containerWidth + containerRight > $(window).width()) this.container.css({
                    top: containerTop,
                    right: "auto",
                    left: 9
                });
                else this.container.css({
                    top: containerTop,
                    right: containerRight,
                    left: "auto"
                });
            } else if (this.opens == "center") {
                var containerLeft = this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2 - containerWidth / 2;
                if (containerLeft < 0) this.container.css({
                    top: containerTop,
                    right: "auto",
                    left: 9
                });
                else if (containerLeft + containerWidth > $(window).width()) this.container.css({
                    top: containerTop,
                    left: "auto",
                    right: 0
                });
                else this.container.css({
                    top: containerTop,
                    left: containerLeft,
                    right: "auto"
                });
            } else {
                var containerLeft = this.element.offset().left - parentOffset.left;
                if (containerLeft + containerWidth > $(window).width()) this.container.css({
                    top: containerTop,
                    left: "auto",
                    right: 0
                });
                else this.container.css({
                    top: containerTop,
                    left: containerLeft,
                    right: "auto"
                });
            }
        },
        show: function(e) {
            if (this.isShowing) return;
            // Create a click proxy that is private to this instance of datepicker, for unbinding
            this._outsideClickProxy = $.proxy(function(e) {
                this.outsideClick(e);
            }, this);
            // Bind global datepicker mousedown for hiding and
            $(document).on("mousedown.daterangepicker", this._outsideClickProxy)// also support mobile devices
            .on("touchend.daterangepicker", this._outsideClickProxy)// also explicitly play nice with Bootstrap dropdowns, which stopPropagation when clicking them
            .on("click.daterangepicker", "[data-toggle=dropdown]", this._outsideClickProxy)// and also close when focus changes to outside the picker (eg. tabbing between controls)
            .on("focusin.daterangepicker", this._outsideClickProxy);
            // Reposition the picker if the window is resized while it's open
            $(window).on("resize.daterangepicker", $.proxy(function(e) {
                this.move(e);
            }, this));
            this.oldStartDate = this.startDate.clone();
            this.oldEndDate = this.endDate.clone();
            this.previousRightTime = this.endDate.clone();
            this.updateView();
            this.container.show();
            this.move();
            this.element.trigger("show.daterangepicker", this);
            this.isShowing = true;
        },
        hide: function(e) {
            if (!this.isShowing) return;
            //incomplete date selection, revert to last values
            if (!this.endDate) {
                this.startDate = this.oldStartDate.clone();
                this.endDate = this.oldEndDate.clone();
            }
            //if a new date range was selected, invoke the user callback function
            if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate)) this.callback(this.startDate.clone(), this.endDate.clone(), this.chosenLabel);
            //if picker is attached to a text input, update it
            this.updateElement();
            $(document).off(".daterangepicker");
            $(window).off(".daterangepicker");
            this.container.hide();
            this.element.trigger("hide.daterangepicker", this);
            this.isShowing = false;
        },
        toggle: function(e) {
            if (this.isShowing) this.hide();
            else this.show();
        },
        outsideClick: function(e) {
            var target = $(e.target);
            // if the page is clicked anywhere except within the daterangerpicker/button
            // itself then call this.hide()
            if (// ie modal dialog fix
            e.type == "focusin" || target.closest(this.element).length || target.closest(this.container).length || target.closest(".calendar-table").length) return;
            this.hide();
            this.element.trigger("outsideClick.daterangepicker", this);
        },
        showCalendars: function() {
            this.container.addClass("show-calendar");
            this.move();
            this.element.trigger("showCalendar.daterangepicker", this);
        },
        hideCalendars: function() {
            this.container.removeClass("show-calendar");
            this.element.trigger("hideCalendar.daterangepicker", this);
        },
        clickRange: function(e) {
            var label = e.target.getAttribute("data-range-key");
            this.chosenLabel = label;
            if (label == this.locale.customRangeLabel) this.showCalendars();
            else {
                var dates = this.ranges[label];
                this.startDate = dates[0];
                this.endDate = dates[1];
                if (!this.timePicker) {
                    this.startDate.startOf("day");
                    this.endDate.endOf("day");
                }
                if (!this.alwaysShowCalendars) this.hideCalendars();
                this.clickApply();
            }
        },
        clickPrev: function(e) {
            var cal = $(e.target).parents(".drp-calendar");
            if (cal.hasClass("left")) {
                this.leftCalendar.month.subtract(1, "month");
                if (this.linkedCalendars) this.rightCalendar.month.subtract(1, "month");
            } else this.rightCalendar.month.subtract(1, "month");
            this.updateCalendars();
        },
        clickNext: function(e) {
            var cal = $(e.target).parents(".drp-calendar");
            if (cal.hasClass("left")) this.leftCalendar.month.add(1, "month");
            else {
                this.rightCalendar.month.add(1, "month");
                if (this.linkedCalendars) this.leftCalendar.month.add(1, "month");
            }
            this.updateCalendars();
        },
        hoverDate: function(e) {
            //ignore dates that can't be selected
            if (!$(e.target).hasClass("available")) return;
            var title = $(e.target).attr("data-title");
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents(".drp-calendar");
            var date = cal.hasClass("left") ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
            //highlight the dates between the start date and the date being hovered as a potential end date
            var leftCalendar = this.leftCalendar;
            var rightCalendar = this.rightCalendar;
            var startDate = this.startDate;
            if (!this.endDate) this.container.find(".drp-calendar tbody td").each(function(index, el) {
                //skip week numbers, only look at dates
                if ($(el).hasClass("week")) return;
                var title = $(el).attr("data-title");
                var row = title.substr(1, 1);
                var col = title.substr(3, 1);
                var cal = $(el).parents(".drp-calendar");
                var dt = cal.hasClass("left") ? leftCalendar.calendar[row][col] : rightCalendar.calendar[row][col];
                if (dt.isAfter(startDate) && dt.isBefore(date) || dt.isSame(date, "day")) $(el).addClass("in-range");
                else $(el).removeClass("in-range");
            });
        },
        clickDate: function(e) {
            if (!$(e.target).hasClass("available")) return;
            var title = $(e.target).attr("data-title");
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents(".drp-calendar");
            var date = cal.hasClass("left") ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
            //
            // this function needs to do a few things:
            // * alternate between selecting a start and end date for the range,
            // * if the time picker is enabled, apply the hour/minute/second from the select boxes to the clicked date
            // * if autoapply is enabled, and an end date was chosen, apply the selection
            // * if single date picker mode, and time picker isn't enabled, apply the selection immediately
            // * if one of the inputs above the calendars was focused, cancel that manual input
            //
            if (this.endDate || date.isBefore(this.startDate, "day")) {
                if (this.timePicker) {
                    var hour = parseInt(this.container.find(".left .hourselect").val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find(".left .ampmselect").val();
                        if (ampm === "PM" && hour < 12) hour += 12;
                        if (ampm === "AM" && hour === 12) hour = 0;
                    }
                    var minute = parseInt(this.container.find(".left .minuteselect").val(), 10);
                    if (isNaN(minute)) minute = parseInt(this.container.find(".left .minuteselect option:last").val(), 10);
                    var second = this.timePickerSeconds ? parseInt(this.container.find(".left .secondselect").val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }
                this.endDate = null;
                this.setStartDate(date.clone());
            } else if (!this.endDate && date.isBefore(this.startDate)) //special case: clicking the same date for start/end,
            //but the time of the end date is before the start date
            this.setEndDate(this.startDate.clone());
            else {
                if (this.timePicker) {
                    var hour = parseInt(this.container.find(".right .hourselect").val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find(".right .ampmselect").val();
                        if (ampm === "PM" && hour < 12) hour += 12;
                        if (ampm === "AM" && hour === 12) hour = 0;
                    }
                    var minute = parseInt(this.container.find(".right .minuteselect").val(), 10);
                    if (isNaN(minute)) minute = parseInt(this.container.find(".right .minuteselect option:last").val(), 10);
                    var second = this.timePickerSeconds ? parseInt(this.container.find(".right .secondselect").val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }
                this.setEndDate(date.clone());
                if (this.autoApply) {
                    this.calculateChosenLabel();
                    this.clickApply();
                }
            }
            if (this.singleDatePicker) {
                this.setEndDate(this.startDate);
                if (!this.timePicker && this.autoApply) this.clickApply();
            }
            this.updateView();
            //This is to cancel the blur event handler if the mouse was in one of the inputs
            e.stopPropagation();
        },
        calculateChosenLabel: function() {
            var customRange = true;
            var i = 0;
            for(var range in this.ranges){
                if (this.timePicker) {
                    var format = this.timePickerSeconds ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD HH:mm";
                    //ignore times when comparing dates if time picker seconds is not enabled
                    if (this.startDate.format(format) == this.ranges[range][0].format(format) && this.endDate.format(format) == this.ranges[range][1].format(format)) {
                        customRange = false;
                        this.chosenLabel = this.container.find(".ranges li:eq(" + i + ")").addClass("active").attr("data-range-key");
                        break;
                    }
                } else //ignore times when comparing dates if time picker is not enabled
                if (this.startDate.format("YYYY-MM-DD") == this.ranges[range][0].format("YYYY-MM-DD") && this.endDate.format("YYYY-MM-DD") == this.ranges[range][1].format("YYYY-MM-DD")) {
                    customRange = false;
                    this.chosenLabel = this.container.find(".ranges li:eq(" + i + ")").addClass("active").attr("data-range-key");
                    break;
                }
                i++;
            }
            if (customRange) {
                if (this.showCustomRangeLabel) this.chosenLabel = this.container.find(".ranges li:last").addClass("active").attr("data-range-key");
                else this.chosenLabel = null;
                this.showCalendars();
            }
        },
        clickApply: function(e) {
            this.hide();
            this.element.trigger("apply.daterangepicker", this);
        },
        clickCancel: function(e) {
            this.startDate = this.oldStartDate;
            this.endDate = this.oldEndDate;
            this.hide();
            this.element.trigger("cancel.daterangepicker", this);
        },
        monthOrYearChanged: function(e) {
            var isLeft = $(e.target).closest(".drp-calendar").hasClass("left"), leftOrRight = isLeft ? "left" : "right", cal = this.container.find(".drp-calendar." + leftOrRight);
            // Month must be Number for new moment versions
            var month = parseInt(cal.find(".monthselect").val(), 10);
            var year = cal.find(".yearselect").val();
            if (!isLeft) {
                if (year < this.startDate.year() || year == this.startDate.year() && month < this.startDate.month()) {
                    month = this.startDate.month();
                    year = this.startDate.year();
                }
            }
            if (this.minDate) {
                if (year < this.minDate.year() || year == this.minDate.year() && month < this.minDate.month()) {
                    month = this.minDate.month();
                    year = this.minDate.year();
                }
            }
            if (this.maxDate) {
                if (year > this.maxDate.year() || year == this.maxDate.year() && month > this.maxDate.month()) {
                    month = this.maxDate.month();
                    year = this.maxDate.year();
                }
            }
            if (isLeft) {
                this.leftCalendar.month.month(month).year(year);
                if (this.linkedCalendars) this.rightCalendar.month = this.leftCalendar.month.clone().add(1, "month");
            } else {
                this.rightCalendar.month.month(month).year(year);
                if (this.linkedCalendars) this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, "month");
            }
            this.updateCalendars();
        },
        timeChanged: function(e) {
            var cal = $(e.target).closest(".drp-calendar"), isLeft = cal.hasClass("left");
            var hour = parseInt(cal.find(".hourselect").val(), 10);
            var minute = parseInt(cal.find(".minuteselect").val(), 10);
            if (isNaN(minute)) minute = parseInt(cal.find(".minuteselect option:last").val(), 10);
            var second = this.timePickerSeconds ? parseInt(cal.find(".secondselect").val(), 10) : 0;
            if (!this.timePicker24Hour) {
                var ampm = cal.find(".ampmselect").val();
                if (ampm === "PM" && hour < 12) hour += 12;
                if (ampm === "AM" && hour === 12) hour = 0;
            }
            if (isLeft) {
                var start = this.startDate.clone();
                start.hour(hour);
                start.minute(minute);
                start.second(second);
                this.setStartDate(start);
                if (this.singleDatePicker) this.endDate = this.startDate.clone();
                else if (this.endDate && this.endDate.format("YYYY-MM-DD") == start.format("YYYY-MM-DD") && this.endDate.isBefore(start)) this.setEndDate(start.clone());
            } else if (this.endDate) {
                var end = this.endDate.clone();
                end.hour(hour);
                end.minute(minute);
                end.second(second);
                this.setEndDate(end);
            }
            //update the calendars so all clickable dates reflect the new time component
            this.updateCalendars();
            //update the form inputs above the calendars with the new time
            this.updateFormInputs();
            //re-render the time pickers because changing one selection can affect what's enabled in another
            this.renderTimePicker("left");
            this.renderTimePicker("right");
        },
        elementChanged: function() {
            if (!this.element.is("input")) return;
            if (!this.element.val().length) return;
            var dateString = this.element.val().split(this.locale.separator), start = null, end = null;
            if (dateString.length === 2) {
                start = moment(dateString[0], this.locale.format);
                end = moment(dateString[1], this.locale.format);
            }
            if (this.singleDatePicker || start === null || end === null) {
                start = moment(this.element.val(), this.locale.format);
                end = start;
            }
            if (!start.isValid() || !end.isValid()) return;
            this.setStartDate(start);
            this.setEndDate(end);
            this.updateView();
        },
        keydown: function(e) {
            //hide on tab or enter
            if (e.keyCode === 9 || e.keyCode === 13) this.hide();
            //hide on esc and prevent propagation
            if (e.keyCode === 27) {
                e.preventDefault();
                e.stopPropagation();
                this.hide();
            }
        },
        updateElement: function() {
            if (this.element.is("input") && this.autoUpdateInput) {
                var newValue = this.startDate.format(this.locale.format);
                if (!this.singleDatePicker) newValue += this.locale.separator + this.endDate.format(this.locale.format);
                if (newValue !== this.element.val()) this.element.val(newValue).trigger("change");
            }
        },
        remove: function() {
            this.container.remove();
            this.element.off(".daterangepicker");
            this.element.removeData();
        }
    };
    $.fn.daterangepicker = function(options, callback) {
        var implementOptions = $.extend(true, {}, $.fn.daterangepicker.defaultOptions, options);
        this.each(function() {
            var el = $(this);
            if (el.data("daterangepicker")) el.data("daterangepicker").remove();
            el.data("daterangepicker", new DateRangePicker(el, implementOptions, callback));
        });
        return this;
    };
    return DateRangePicker;
});


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $cd75171c8621b7d2$var$extendStatics = function(d, b) {
    $cd75171c8621b7d2$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $cd75171c8621b7d2$var$extendStatics(d, b);
};
function $cd75171c8621b7d2$var$__extends(d, b) {
    $cd75171c8621b7d2$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $cd75171c8621b7d2$export$17334619f3ac2224 = /** @class */ function(_super) {
    $cd75171c8621b7d2$var$__extends(DateRangePicker, _super);
    function DateRangePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = null;
        _this.$picker = null;
        return _this;
    }
    DateRangePicker.prototype.componentDidMount = function() {
        var _this = this;
        // initialize daterangepicker
        this.$picker = (0, (/*@__PURE__*/$parcel$interopDefault($92ABP)))(this.ref);
        this.$picker.daterangepicker(this.props.initialSettings, this.handleCallback.bind(this));
        // attach event listeners
        [
            "Show",
            "Hide",
            "ShowCalendar",
            "HideCalendar",
            "Apply",
            "Cancel"
        ].forEach(function(event) {
            var _a;
            var lcase = event.toLowerCase();
            (_a = _this.$picker) === null || _a === void 0 || _a.on(lcase + ".daterangepicker", _this.makeEventHandler("on" + event));
        });
    };
    DateRangePicker.prototype.componentWillUnmount = function() {
        var _a, _b;
        (_b = (_a = this.$picker) === null || _a === void 0 ? void 0 : _a.data("daterangepicker")) === null || _b === void 0 || _b.remove();
    };
    DateRangePicker.prototype.handleCallback = function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (typeof this.props.onCallback === "function") (_a = this.props).onCallback.apply(_a, args);
    };
    DateRangePicker.prototype.makeEventHandler = function(eventType) {
        var _this = this;
        var onEvent = this.props.onEvent;
        return function(event, picker) {
            if (typeof onEvent === "function") onEvent(event, picker);
            if (typeof _this.props[eventType] === "function") _this.props[eventType](event, picker);
        };
    };
    DateRangePicker.prototype.setStartDate = function(dateOrString) {
        var _a, _b;
        (_b = (_a = this.$picker) === null || _a === void 0 ? void 0 : _a.data("daterangepicker")) === null || _b === void 0 || _b.setStartDate(dateOrString);
    };
    DateRangePicker.prototype.setEndDate = function(dateOrString) {
        var _a, _b;
        (_b = (_a = this.$picker) === null || _a === void 0 ? void 0 : _a.data("daterangepicker")) === null || _b === void 0 || _b.setEndDate(dateOrString);
    };
    DateRangePicker.prototype.render = function() {
        var _this = this;
        var childElement = (0, $tZqWC.Children).only(this.props.children);
        return (0, $tZqWC.cloneElement)(childElement, {
            ref: function(el) {
                return _this.ref = el;
            }
        });
    };
    return DateRangePicker;
}((0, $tZqWC.Component));
var $cd75171c8621b7d2$export$2e2bcd8739ae039 = $cd75171c8621b7d2$export$17334619f3ac2224;



var $ejSM7 = parcelRequire("ejSM7");
const $41a9e38e6be32f35$export$1bceb808939a9f0c = "YYYY-MM-DD";
const $41a9e38e6be32f35$export$c003002ffeb9f3c0 = "YYYY MM DD";
const $41a9e38e6be32f35$export$859ef203c4495ed2 = "YYYY-MM-DD, hh:mm";
const $41a9e38e6be32f35$export$67a03cd247c60132 = "YYYY-MM-DD";



const $9e67d414e0ebe46e$export$acf2d8d0e9d6a367 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-family: Roboto;
  font-size: 18px;

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $9e67d414e0ebe46e$export$bb90a058c746d162 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;

  display: flex;
  padding: 8px 15px 7px 15px;
  width: fit-content;
  height: 50px;

  border-radius: 5px;

  cursor: pointer;

  // Themed Properties
  border: 2px solid ${({ theme: theme })=>theme.colors.lightGray};
`;
const $9e67d414e0ebe46e$export$8ca157c44bc5e43d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 14px;
  margin: 7px 0px 0px 0px;

  // TODO: Use themed functions
  &:first-child {
    margin-right: 10px;
  }
  & span {
    &:nth-child(2) {
      color: ${({ theme: theme })=>theme.colors.blue};
    }
  }

  & svg > * {
    stroke: ${({ theme: theme })=>theme.colors.blue};
  }
`;
const $9e67d414e0ebe46e$export$df892887963f236a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  // TODO: Use themed functions
  &:first-child {
    font-weight: 500;
    margin: 0px 5px 0px 0px;
  }
`;



parcelRequire("tZqWC");
function $60f83047747d7ceb$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "15",
        height: "11",
        viewBox: "0 0 15 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M1 1.9231H13.9874",
                stroke: "#00CACD",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M1 6H9.51935",
                stroke: "#00CACD",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("line", {
                x1: "1",
                y1: "10",
                x2: "3.46808",
                y2: "10",
                stroke: "#00CACD",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}



parcelRequire("tZqWC");
function $da94d5183dd964b8$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z",
                stroke: "#303D4B",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M19.0004 19L14.6504 14.65",
                stroke: "#303D4B",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}



parcelRequire("tZqWC");
function $32278e654c8306f0$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "13",
        height: "13",
        viewBox: "0 0 13 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M1 6.4209H12",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M6.5 11.4863L6.5 1.35475",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $f8b21e6e39ef8af9$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("svg", {
        width: "19",
        height: "19",
        viewBox: "0 0 19 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.84391 2.3144C3.42564 1.89566 2.74695 1.89513 2.32802 2.31322C1.9091 2.73132 1.90857 3.40971 2.32684 3.82845L7.98529 9.49325L2.31336 15.1715C1.89509 15.5903 1.89561 16.2687 2.31454 16.6868C2.73347 17.1049 3.41215 17.1043 3.83043 16.6856L9.49325 11.0164L15.1561 16.6856C15.5744 17.1043 16.2531 17.1049 16.672 16.6868C17.0909 16.2687 17.0914 15.5903 16.6731 15.1715L11.0147 9.50675L16.6866 3.82845C17.1049 3.40971 17.1044 2.73132 16.6855 2.31322C16.2665 1.89513 15.5879 1.89566 15.1696 2.3144L9.50674 7.98359L3.84391 2.3144Z",
            fill: "white"
        })
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $305c2f9432d7c751$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "19",
        height: "16",
        viewBox: "0 0 19 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M8.33337 8.85527C8.66898 9.25462 9.09714 9.58508 9.58882 9.82418C10.0805 10.0633 10.6242 10.2055 11.1831 10.2411C11.7419 10.2767 12.3028 10.205 12.8278 10.0307C13.3527 9.85636 13.8294 9.58359 14.2255 9.23088L16.5699 7.14412C17.2816 6.48818 17.6755 5.60962 17.6666 4.69772C17.6577 3.78581 17.2467 2.91351 16.5223 2.26866C15.7978 1.62383 14.8179 1.25805 13.7934 1.25013C12.7689 1.2422 11.7819 1.59276 11.045 2.22629L9.70092 3.41576",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M10.6667 7.14473C10.3311 6.74537 9.90295 6.41494 9.41127 6.17581C8.91959 5.9367 8.37587 5.7945 7.81704 5.75888C7.25818 5.72327 6.69725 5.79502 6.17232 5.96933C5.64737 6.14363 5.17067 6.4164 4.77456 6.76911L2.43019 8.85587C1.71845 9.51182 1.32463 10.3904 1.33352 11.3023C1.34243 12.2142 1.75336 13.0865 2.47779 13.7313C3.20224 14.3762 4.18222 14.7419 5.20669 14.7499C6.23117 14.7578 7.21814 14.4072 7.95508 13.7737L9.29136 12.5842",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $8b6b9ef34375e76b$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "19",
        height: "14",
        viewBox: "0 0 19 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M1.33337 6.99999C1.33337 6.99999 4.30308 1.28571 9.50004 1.28571C14.697 1.28571 17.6667 6.99999 17.6667 6.99999C17.6667 6.99999 14.697 12.7143 9.50004 12.7143C4.30308 12.7143 1.33337 6.99999 1.33337 6.99999Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M9.50004 8.14283C10.1444 8.14283 10.6667 7.63115 10.6667 6.99997C10.6667 6.3688 10.1444 5.85712 9.50004 5.85712C8.85571 5.85712 8.33337 6.3688 8.33337 6.99997C8.33337 7.63115 8.85571 8.14283 9.50004 8.14283Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $53f06c63dbc6ba6a$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("svg", {
        width: "23",
        height: "24",
        viewBox: "0 0 23 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
            d: "M7.07524 1.48828H3.74191C3.15254 1.48828 2.58731 1.73247 2.17056 2.16712C1.75381 2.60178 1.51968 3.1913 1.51968 3.80599V7.28255M21.5197 7.28255V3.80599C21.5197 3.1913 21.2856 2.60178 20.8688 2.16712C20.4521 1.73247 19.8868 1.48828 19.2975 1.48828H15.9641M15.9641 22.3477H19.2975C19.8868 22.3477 20.4521 22.1035 20.8688 21.6688C21.2856 21.2342 21.5197 20.6446 21.5197 20.0299V16.5534M1.51968 16.5534V20.0299C1.51968 20.6446 1.75381 21.2342 2.17056 21.6688C2.58731 22.1035 3.15254 22.3477 3.74191 22.3477H7.07524",
            stroke: "white",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $e754135bbdb083e2$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "3",
        height: "13",
        viewBox: "0 0 3 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("ellipse", {
                cx: "1.48911",
                cy: "1.5",
                rx: "1.48911",
                ry: "1.5",
                fill: "#727F97"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("ellipse", {
                cx: "1.48911",
                cy: "6.5",
                rx: "1.48911",
                ry: "1.5",
                fill: "#727F97"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("ellipse", {
                cx: "1.48911",
                cy: "11.5",
                rx: "1.48911",
                ry: "1.5",
                fill: "#727F97"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $9f276c67f34b7a71$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "16",
        height: "15",
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M12.0143 2.5H3.26434C2.57399 2.5 2.01434 3.05964 2.01434 3.75V12.5C2.01434 13.1904 2.57399 13.75 3.26434 13.75H12.0143C12.7047 13.75 13.2643 13.1904 13.2643 12.5V3.75C13.2643 3.05964 12.7047 2.5 12.0143 2.5Z",
                stroke: "#606167",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M10.1393 1.25V3.75",
                stroke: "#606167",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M5.13934 1.25V3.75",
                stroke: "#606167",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M2.01434 6.25H13.2643",
                stroke: "#606167",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}



parcelRequire("tZqWC");
function $05f77f0f270ba5cb$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-file-plus",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("polyline", {
                points: "14 2 14 8 20 8"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("line", {
                x1: "12",
                y1: "18",
                x2: "12",
                y2: "12"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("line", {
                x1: "9",
                y1: "15",
                x2: "15",
                y2: "15"
            })
        ]
    });
}


/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $120c2e082126beda$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || "11px",
        height: props?.size || "11px",
        viewBox: "0 0 11 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M5.50033 10.0846C8.03163 10.0846 10.0837 8.03261 10.0837 5.5013C10.0837 2.97 8.03163 0.917969 5.50033 0.917969C2.96902 0.917969 0.916992 2.97 0.916992 5.5013C0.916992 8.03261 2.96902 10.0846 5.50033 10.0846Z",
                fill: "#F3F4F7"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M4.16602 4.12575C4.27377 3.81943 4.48646 3.56113 4.76641 3.3966C5.04636 3.23207 5.37551 3.17193 5.69555 3.22683C6.0156 3.28172 6.30589 3.44811 6.51501 3.69653C6.72413 3.94495 6.83858 4.25936 6.8381 4.58408C6.8381 5.50075 5.4631 5.95908 5.4631 5.95908",
                stroke: "#393D46",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M5.5 7.79297H5.50609",
                stroke: "#393D46",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $2ba823b4035ac31e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#fff",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-external-link",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("polyline", {
                points: "15 3 21 3 21 9"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("line", {
                x1: "10",
                y1: "14",
                x2: "21",
                y2: "3"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $29b5e751497c77eb$export$2e2bcd8739ae039(props) {
    const { ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-copy",
        ...rest,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("rect", {
                x: "9",
                y: "9",
                width: "13",
                height: "13",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $a18cc772f37d0119$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "71",
        height: "78",
        viewBox: "0 0 71 78",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M68.667 48.668H48.667L42 58.668H28.667L22 48.668H2",
                stroke: "white",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M13.5 25.7L2 48.667V68.667C2 70.435 2.702 72.13 3.953 73.381C5.203 74.631 6.89899 75.333 8.66699 75.333H62C63.768 75.333 65.464 74.631 66.714 73.381C67.964 72.13 68.667 70.435 68.667 68.667V48.667L57.167 25.7C56.615 24.589 55.764 23.655 54.71 23.001C53.656 22.347 52.44 22.001 51.2 22H19.467C18.226 22.001 17.011 22.347 15.957 23.001C14.903 23.655 14.052 24.589 13.5 25.7Z",
                stroke: "white",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M34.75 2V10",
                stroke: "white",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M49.2319 4.73602L45.2319 11.664",
                stroke: "white",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M25.2681 11.659L21.2681 4.72998",
                stroke: "white",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $fb01a62649e45f27$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.width ? props.width : "30",
        height: props?.height ? props.height : "30",
        viewBox: "0 0 25 25",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M24.5 12.5001C24.5 19.127 19.1275 24.5 12.5001 24.5C5.8729 24.5 0.5 19.127 0.5 12.5001C0.5 5.8726 5.87289 0.5 12.5001 0.5C19.1276 0.5 24.5 5.87249 24.5 12.5001Z",
                fill: "white",
                fillOpacity: "0.1",
                stroke: "#393D46"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M10 10.6654V8.91536C10 8.53234 10.0754 8.15307 10.222 7.7992C10.3686 7.44534 10.5834 7.12381 10.8543 6.85297C11.1251 6.58213 11.4466 6.36729 11.8005 6.22071C12.1544 6.07414 12.5336 5.9987 12.9167 5.9987C13.2997 5.9987 13.679 6.07414 14.0328 6.22071C14.3867 6.36729 14.7082 6.58213 14.9791 6.85297C15.2499 7.12381 15.4647 7.44534 15.6113 7.7992C15.7579 8.15307 15.8333 8.53234 15.8333 8.91536V10.6654M15.8333 14.1654V15.9154C15.8333 16.2984 15.7579 16.6777 15.6113 17.0315C15.4647 17.3854 15.2499 17.7069 14.9791 17.9778C14.4321 18.5247 13.6902 18.832 12.9167 18.832C12.1431 18.832 11.4013 18.5247 10.8543 17.9778C10.3073 17.4308 10 16.6889 10 15.9154V14.1654",
                stroke: "#393D46",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M13 14.832V10.1654",
                stroke: "#393D46",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $7b6ebcf5a9c52610$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "23",
        height: "23",
        fill: "none",
        viewBox: "0 0 23 23",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("circle", {
                cx: "11.142",
                cy: "11.145",
                r: "5",
                stroke: "#D5D6D8",
                strokeWidth: "2",
                transform: "rotate(-45 11.142 11.145)"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                stroke: "#D5D6D8",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M18.213 18.216c3.905-3.906 3.905-10.237 0-14.143C14.308.168 7.976.168 4.071 4.073.166 7.98.166 14.31 4.071 18.216c3.905 3.905 10.237 3.905 14.142 0zM18.215 4.074l-2.828 2.828M6.899 15.386L4.07 18.215M6.899 6.903L4.07 4.074M18.215 18.215l-2.828-2.828"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $969ded54f1743196$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "23",
        height: "23",
        viewBox: "0 0 23 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M11.5023 14.364C13.0839 14.364 14.3659 13.0819 14.3659 11.5004C14.3659 9.91881 13.0839 8.63672 11.5023 8.63672C9.92077 8.63672 8.63867 9.91881 8.63867 11.5004C8.63867 13.0819 9.92077 14.364 11.5023 14.364Z",
                stroke: "#727F97",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M18.5636 14.3636C18.4366 14.6515 18.3987 14.9709 18.4548 15.2806C18.511 15.5902 18.6586 15.8759 18.8786 16.1009L18.9359 16.1582C19.1134 16.3355 19.2542 16.546 19.3503 16.7778C19.4464 17.0096 19.4958 17.258 19.4958 17.5089C19.4958 17.7597 19.4464 18.0082 19.3503 18.2399C19.2542 18.4717 19.1134 18.6822 18.9359 18.8595C18.7586 19.037 18.5481 19.1779 18.3163 19.2739C18.0845 19.37 17.8361 19.4195 17.5852 19.4195C17.3343 19.4195 17.0859 19.37 16.8542 19.2739C16.6224 19.1779 16.4118 19.037 16.2345 18.8595L16.1773 18.8023C15.9523 18.5822 15.6666 18.4346 15.3569 18.3785C15.0473 18.3223 14.7279 18.3602 14.44 18.4873C14.1577 18.6083 13.9169 18.8092 13.7473 19.0653C13.5777 19.3214 13.4867 19.6215 13.4855 19.9286V20.0909C13.4855 20.5972 13.2843 21.0828 12.9263 21.4408C12.5683 21.7989 12.0827 22 11.5764 22C11.07 22 10.5845 21.7989 10.2264 21.4408C9.86841 21.0828 9.66727 20.5972 9.66727 20.0909V20.005C9.65988 19.689 9.55761 19.3826 9.37376 19.1256C9.18991 18.8685 8.93297 18.6727 8.63636 18.5636C8.34846 18.4366 8.02909 18.3987 7.71944 18.4548C7.40979 18.511 7.12406 18.6586 6.89909 18.8786L6.84182 18.9359C6.66451 19.1134 6.45396 19.2542 6.2222 19.3503C5.99044 19.4464 5.74202 19.4958 5.49114 19.4958C5.24025 19.4958 4.99183 19.4464 4.76007 19.3503C4.52831 19.2542 4.31776 19.1134 4.14045 18.9359C3.96295 18.7586 3.82214 18.5481 3.72607 18.3163C3.62999 18.0845 3.58054 17.8361 3.58054 17.5852C3.58054 17.3343 3.62999 17.0859 3.72607 16.8542C3.82214 16.6224 3.96295 16.4118 4.14045 16.2345L4.19773 16.1773C4.41779 15.9523 4.5654 15.6666 4.62155 15.3569C4.67769 15.0473 4.63979 14.7279 4.51273 14.44C4.39173 14.1577 4.19081 13.9169 3.93472 13.7473C3.67862 13.5777 3.37852 13.4867 3.07136 13.4855H2.90909C2.40277 13.4855 1.91718 13.2843 1.55916 12.9263C1.20114 12.5683 1 12.0827 1 11.5764C1 11.07 1.20114 10.5845 1.55916 10.2264C1.91718 9.86841 2.40277 9.66727 2.90909 9.66727H2.995C3.31095 9.65988 3.61737 9.55761 3.87442 9.37376C4.13148 9.18991 4.32727 8.93297 4.43636 8.63636C4.56343 8.34846 4.60133 8.02909 4.54519 7.71944C4.48904 7.40979 4.34142 7.12406 4.12136 6.89909L4.06409 6.84182C3.88659 6.66451 3.74578 6.45396 3.6497 6.2222C3.55363 5.99044 3.50418 5.74202 3.50418 5.49114C3.50418 5.24025 3.55363 4.99183 3.6497 4.76007C3.74578 4.52831 3.88659 4.31776 4.06409 4.14045C4.24139 3.96295 4.45194 3.82214 4.6837 3.72607C4.91546 3.62999 5.16389 3.58054 5.41477 3.58054C5.66566 3.58054 5.91408 3.62999 6.14584 3.72607C6.3776 3.82214 6.58815 3.96295 6.76545 4.14045L6.82273 4.19773C7.04769 4.41779 7.33342 4.5654 7.64307 4.62155C7.95272 4.67769 8.27209 4.63979 8.56 4.51273H8.63636C8.91869 4.39173 9.15947 4.19081 9.32907 3.93472C9.49867 3.67862 9.58968 3.37852 9.59091 3.07136V2.90909C9.59091 2.40277 9.79205 1.91718 10.1501 1.55916C10.5081 1.20114 10.9937 1 11.5 1C12.0063 1 12.4919 1.20114 12.8499 1.55916C13.208 1.91718 13.4091 2.40277 13.4091 2.90909V2.995C13.4103 3.30216 13.5013 3.60226 13.6709 3.85835C13.8405 4.11445 14.0813 4.31536 14.3636 4.43636C14.6515 4.56343 14.9709 4.60133 15.2806 4.54519C15.5902 4.48904 15.8759 4.34142 16.1009 4.12136L16.1582 4.06409C16.3355 3.88659 16.546 3.74578 16.7778 3.6497C17.0096 3.55363 17.258 3.50418 17.5089 3.50418C17.7597 3.50418 18.0082 3.55363 18.2399 3.6497C18.4717 3.74578 18.6822 3.88659 18.8595 4.06409C19.037 4.24139 19.1779 4.45194 19.2739 4.6837C19.37 4.91546 19.4195 5.16389 19.4195 5.41477C19.4195 5.66566 19.37 5.91408 19.2739 6.14584C19.1779 6.3776 19.037 6.58815 18.8595 6.76545L18.8023 6.82273C18.5822 7.04769 18.4346 7.33342 18.3785 7.64307C18.3223 7.95272 18.3602 8.27209 18.4873 8.56V8.63636C18.6083 8.91869 18.8092 9.15947 19.0653 9.32907C19.3214 9.49867 19.6215 9.58968 19.9286 9.59091H20.0909C20.5972 9.59091 21.0828 9.79205 21.4408 10.1501C21.7989 10.5081 22 10.9937 22 11.5C22 12.0063 21.7989 12.4919 21.4408 12.8499C21.0828 13.208 20.5972 13.4091 20.0909 13.4091H20.005C19.6978 13.4103 19.3977 13.5013 19.1416 13.6709C18.8856 13.8405 18.6846 14.0813 18.5636 14.3636V14.3636Z",
                stroke: "#727F97",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}



parcelRequire("tZqWC");
function $315be7fb257ba6c0$var$DocumentIcon() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M14 2v6h6M16 13H8M16 17H8M10 9H8"
            })
        ]
    });
}
var $315be7fb257ba6c0$export$2e2bcd8739ae039 = $315be7fb257ba6c0$var$DocumentIcon;


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $aaf2a156dc219a10$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
            d: "M24.6899 2.9707V22.9707C24.6899 24.0707 23.7899 24.9707 22.6899 24.9707H13.6899C13.1399 24.9707 12.6899 24.5207 12.6899 23.9707C12.6899 23.4207 13.1399 22.9707 13.6899 22.9707H22.6899V2.9707H2.68994V14.9707C2.68994 15.5207 2.23994 15.9707 1.68994 15.9707C1.13994 15.9707 0.689941 15.5207 0.689941 14.9707V2.9707C0.689941 1.8707 1.58994 0.970703 2.68994 0.970703H22.6899C23.7899 0.970703 24.6899 1.8707 24.6899 2.9707ZM12.3999 16.2707C12.0099 15.8807 11.3799 15.8807 10.9899 16.2707L4.69995 22.5607L2.40994 20.2707C2.01994 19.8807 1.38993 19.8807 0.989929 20.2707C0.589929 20.6607 0.599929 21.2907 0.989929 21.6907L3.98993 24.6907C4.37993 25.0807 5.00993 25.0807 5.39993 24.6907L12.3999 17.6907C12.7899 17.3007 12.7899 16.6707 12.3999 16.2807V16.2707Z",
            fill: "#FFFFFF"
        })
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $c2425b2ce69350fc$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M24.5 12.5001C24.5 19.127 19.1275 24.5 12.5001 24.5C5.8729 24.5 0.5 19.127 0.5 12.5001C0.5 5.8726 5.87289 0.5 12.5001 0.5C19.1276 0.5 24.5 5.87249 24.5 12.5001Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M9 13H18.125",
                stroke: "#00CACD",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M14.4746 16.5L18.1246 13L14.4746 9.5",
                stroke: "#00CACD",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("circle", {
                cx: "6",
                cy: "13",
                r: "2",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $73f1b5bca40a81c4$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M24.5 12.5001C24.5 19.127 19.1275 24.5 12.5001 24.5C5.8729 24.5 0.5 19.127 0.5 12.5001C0.5 5.8726 5.87289 0.5 12.5001 0.5C19.1276 0.5 24.5 5.87249 24.5 12.5001Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M4 13H13.125",
                stroke: "#00CACD",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M9.47461 16.5L13.1246 13L9.47461 9.5",
                stroke: "#00CACD",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("circle", {
                cx: "18",
                cy: "13",
                r: "2",
                fill: "#00CACD"
            })
        ]
    });
}



parcelRequire("tZqWC");
function $76fabb61791e82e0$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M11 7L7 11L11 15",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M15 11H7",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}



parcelRequire("tZqWC");
function $39f02159828fe73c$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M11 15L15 11L11 7",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M7 11H15",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $82029be26caac316$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || "22",
        height: props?.size || "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M11 7L7 11L11 15",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M15 11H7",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $e60251c96c02ed62$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || "22",
        height: props?.size || "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M11 15L15 11L11 7",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M7 11H15",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $f88c89a3444c031a$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "14",
        height: "18",
        viewBox: "0 0 14 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M13 17V10",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M7 17V1",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M1 17V6",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $42e4486c9b57be38$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "24",
        height: "21",
        viewBox: "0 0 24 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M13.4344 20C18.7171 20 22.9996 15.7467 22.9996 10.5C22.9996 5.25329 18.7171 1 13.4344 1C8.15163 1 3.86914 5.25329 3.86914 10.5C3.86914 15.7467 8.15163 20 13.4344 20Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M5.78261 20C8.42397 20 10.5652 17.8734 10.5652 15.25C10.5652 12.6266 8.42397 10.5 5.78261 10.5C3.14125 10.5 1 12.6266 1 15.25C1 17.8734 3.14125 20 5.78261 20Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $09fd668a6b4f101c$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "24",
        height: "20",
        viewBox: "0 0 24 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M17 19V17C17 15.9391 16.5786 14.9217 15.8284 14.1716C15.0783 13.4214 14.0609 13 13 13H5C3.93913 13 2.92172 13.4214 2.17157 14.1716C1.42143 14.9217 1 15.9391 1 17V19",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M9 9C11.2091 9 13 7.20914 13 5C13 2.79086 11.2091 1 9 1C6.79086 1 5 2.79086 5 5C5 7.20914 6.79086 9 9 9Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M23 18.9999V16.9999C22.9993 16.1136 22.7044 15.2527 22.1614 14.5522C21.6184 13.8517 20.8581 13.3515 20 13.1299",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M16 1.12988C16.8604 1.35018 17.623 1.85058 18.1676 2.55219C18.7122 3.2538 19.0078 4.11671 19.0078 5.00488C19.0078 5.89305 18.7122 6.75596 18.1676 7.45757C17.623 8.15918 16.8604 8.65958 16 8.87988",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $7f7515fc5e255a46$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M15.5 18.25C17.0188 18.25 18.25 17.0188 18.25 15.5C18.25 13.9812 17.0188 12.75 15.5 12.75C13.9812 12.75 12.75 13.9812 12.75 15.5C12.75 17.0188 13.9812 18.25 15.5 18.25Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M4.5 7.25C6.01878 7.25 7.25 6.01878 7.25 4.5C7.25 2.98122 6.01878 1.75 4.5 1.75C2.98122 1.75 1.75 2.98122 1.75 4.5C1.75 6.01878 2.98122 7.25 4.5 7.25Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M10.916 4.5H13.666C14.1522 4.5 14.6186 4.69315 14.9624 5.03697C15.3062 5.38079 15.4993 5.8471 15.4993 6.33333V12.75",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M4.5 7.25V18.25",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}




function $282dc1243d6123ff$var$DateRangePicker(props) {
    // Destructure
    const { opens: opens, onApply: onApply, start: start, end: end, id: id, ...rest } = props;
    // States
    const [dateRange, setDateRange] = (0, $tZqWC.useState)({
        startDate: start || (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(30, "days").format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
        endDate: end || (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().add(1, "days").format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c))
    });
    // Functions
    const handleApplyDatePicker = (e, picker)=>{
        // Ignoring changes to table filters that are exactly the same as previous state
        // const { startDate, endDate } = dateRange
        // if (
        //   startDate === picker.startDate.format(DASHED_DATE_FORMAT) &&
        //   endDate === picker.endDate.format(DASHED_DATE_FORMAT)
        // ) {
        //   return
        // }
        setDateRange({
            startDate: picker.startDate.format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
            endDate: picker.endDate.format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c))
        });
        onApply({
            start: picker.startDate.format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
            end: picker.endDate.format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c))
        });
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9e67d414e0ebe46e$export$acf2d8d0e9d6a367), {
        id: id,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cd75171c8621b7d2$export$2e2bcd8739ae039), {
            onApply: handleApplyDatePicker,
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
            locale: {
                format: (0, $41a9e38e6be32f35$export$1bceb808939a9f0c)
            },
            initialSettings: {
                maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), (0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
                startDate: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(dateRange.startDate, (0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
                endDate: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(dateRange.endDate, (0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
                showDropdowns: true
            },
            opens: opens,
            ...rest,
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9e67d414e0ebe46e$export$bb90a058c746d162), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9e67d414e0ebe46e$export$8ca157c44bc5e43d), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9e67d414e0ebe46e$export$df892887963f236a), {
                                children: "From:"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9e67d414e0ebe46e$export$df892887963f236a), {
                                children: dateRange.startDate
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9e67d414e0ebe46e$export$8ca157c44bc5e43d), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9e67d414e0ebe46e$export$df892887963f236a), {
                                children: "To:"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9e67d414e0ebe46e$export$df892887963f236a), {
                                children: dateRange.endDate
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9e67d414e0ebe46e$export$8ca157c44bc5e43d), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f276c67f34b7a71$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        })
    });
}
// Default Props
$282dc1243d6123ff$var$DateRangePicker.defaultProps = {
    opens: "center",
    onApply: ()=>{},
    start: "",
    end: "",
    id: ""
};
// Proptypes Validation
$282dc1243d6123ff$var$DateRangePicker.propTypes = {
    opens: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    onApply: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    start: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    end: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $282dc1243d6123ff$export$2e2bcd8739ae039 = $282dc1243d6123ff$var$DateRangePicker;


var $876f12cab8dab028$export$2e2bcd8739ae039 = (0, $282dc1243d6123ff$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");
const $f986938d3cd2fdf2$var$buildCalendarDays = (value)=>{
    const startDay = value.clone().startOf("month").startOf("week");
    const endDay = value.clone().endOf("month").endOf("week");
    const day = startDay.clone().subtract(1, "day");
    const days = [];
    while(day.isBefore(endDay, "day"))days.push(Array(7).fill(0).map(()=>day.add(1, "day").clone()));
    return days;
};
var $f986938d3cd2fdf2$export$2e2bcd8739ae039 = $f986938d3cd2fdf2$var$buildCalendarDays;



var $ejSM7 = parcelRequire("ejSM7");



var $tZqWC = parcelRequire("tZqWC");
const $54f47a39f461db48$export$50ec7b7ff742aae5 = (ref, setShowOptions)=>{
    (0, $tZqWC.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) setShowOptions(false);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref
    ]);
};



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $d885bb434a8631da$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).button`
  cursor: pointer;
  width: fit-content;
  height: fit-content;
  font-weight: 400;
  font-size: 16px;
  padding: 10px 15px;
  border-radius: 7px;
  transition: 0.3s;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 7px;
  /*-------------------------------
    Events Properties
  -------------------------------*/
  &:focus {
    outline: none;
  }
  &:hover {
    color: ${({ theme: theme })=>theme.colors.darkGray};
    background: transparent;
    border: 1px solid ${({ theme: theme })=>`${theme.colors.blue}40`};
    & svg > path {
      stroke: ${({ theme: theme })=>theme.colors.blue};
      ${({ theme: theme, variant: variant })=>variant === "outlined" && `stroke: ${theme.colors.darkGray} ;`}
      ${({ theme: theme, color: color })=>color === "default" && `stroke: ${theme.colors.white} ;`}
      ${({ theme: theme, color: color })=>color === "primary" && `stroke: ${theme.colors.blue} ;`}
      ${({ theme: theme, color: color })=>color === "secondary" && `stroke: ${theme.colors.red} ;`}
      ${({ theme: theme, color: color })=>color === "secondary-default" && `stroke: ${theme.colors.white} ;`}
      ${({ theme: theme, color: color })=>color === "tertiary" && `stroke: ${theme.colors.white} ;`}
    }
    & svg > line {
      stroke: ${({ theme: theme })=>theme.colors.blue};
      ${({ theme: theme, variant: variant })=>variant === "outlined" && `stroke: ${theme.colors.darkGray} ;`}
      ${({ theme: theme, color: color })=>color === "default" && `stroke: ${theme.colors.white} ;`}
      ${({ theme: theme, color: color })=>color === "primary" && `stroke: ${theme.colors.blue} ;`}
      ${({ theme: theme, color: color })=>color === "secondary" && `stroke: ${theme.colors.red} ;`}
      ${({ theme: theme, color: color })=>color === "secondary-default" && `stroke: ${theme.colors.white} ;`}
      ${({ theme: theme, color: color })=>color === "tertiary" && `stroke: ${theme.colors.white} ;`}
    }
    outline: none;

    ${({ theme: theme, variant: variant })=>variant === "outlined" && `border: 1px solid ${theme.colors.blue}40;`}
    ${({ theme: theme, variant: variant })=>variant === "outlined" && `background: ${theme.colors.white};`}
    ${({ theme: theme, variant: variant })=>variant === "outlined" && `color: ${theme.colors.darkGray};`}
    
    ${({ theme: theme, color: color })=>color === "default" && `background: ${theme.colors.blue}00;`}
    ${({ theme: theme, color: color })=>color === "default" && `color: ${theme.colors.darkGray};`}
    ${({ theme: theme, color: color })=>color === "default" && `border: 1px solid ${theme.colors.blue}40;`}
    
    ${({ theme: theme, color: color })=>color === "primary" && `background: ${theme.colors.white};`}
    ${({ theme: theme, color: color })=>color === "primary" && `border: 1px solid ${theme.colors.white};`}
    
    ${({ theme: theme, color: color })=>color === "secondary" && `background: ${theme.colors.white};`}
    ${({ theme: theme, color: color })=>color === "secondary" && `color: ${theme.colors.red};`}
    ${({ theme: theme, color: color })=>color === "secondary" && `border: 1px solid ${theme.colors.red};`}
    
    ${({ theme: theme, color: color })=>color === "secondary-default" && `background: ${theme.colors.red};`}
    ${({ theme: theme, color: color })=>color === "secondary-default" && `color: ${theme.colors.white};`}
    ${({ theme: theme, color: color })=>color === "secondary-default" && `border: 1px solid ${theme.colors.red};`}
    
    ${({ theme: theme, color: color })=>color === "tertiary" && `background: ${theme.colors.blue};`}
    ${({ theme: theme, color: color })=>color === "tertiary" && `color: ${theme.colors.white};`}
    ${({ theme: theme, color: color })=>color === "tertiary" && `border: 1px solid ${theme.colors.blue};`}
  }
  &:disabled {
    color: ${({ theme: theme })=>theme.colors.darkGray} !important;
    background-color: ${({ theme: theme })=>theme.colors.lightGray} !important;
    border: 1px solid ${({ theme: theme })=>theme.colors.lightGray} !important;
    cursor: not-allowed !important;
    &:hover {
      background-color: ${({ theme: theme })=>theme.colors.lightGray} !important;
      border: 1px solid ${({ theme: theme })=>theme.colors.lightGray} !important;
    }
  }
  /*-------------------------------
    Themed Properties
  -------------------------------*/
  border: 1px solid ${({ theme: theme })=>theme.colors.blue};
  color: ${({ theme: theme })=>theme.colors.darkGray};
  background: ${({ theme: theme })=>`${theme.colors.blue}40`};
  & svg {
    max-height: 20px;
    max-width: 20px;
    ${({ size: size })=>size === "tiny" && "max-height: 8px !important; max-width: 8px !important;"}
    ${({ size: size })=>size === "small" && "max-height: 10px !important; max-width: 10px !important;"} 
    ${({ size: size })=>size === "medium" && "max-height: 15px !important; max-width: 15px !important;"}
    ${({ size: size })=>size === "large" && "max-height: 20px !important; max-width: 20px !important;"}
  }
  & svg > path {
    stroke: ${({ theme: theme })=>theme.colors.pureWhite};
    ${({ theme: theme, variant: variant })=>variant === "outlined" && `stroke: ${theme.colors.darkGray} ;`}
    ${({ theme: theme, color: color })=>color === "default" && `stroke: ${theme.colors.darkGray} ;`}
    ${({ theme: theme, color: color })=>color === "primary" && `stroke: ${theme.colors.white} ;`}
    ${({ theme: theme, color: color })=>color === "secondary" && `stroke: ${theme.colors.white} ;`}
    ${({ theme: theme, color: color })=>color === "secondary-default" && `stroke: ${theme.colors.red} ;`}
    ${({ theme: theme, color: color })=>color === "tertiary" && `stroke: ${theme.colors.blue} ;`}
  }
  & svg > line {
    stroke: ${({ theme: theme })=>theme.colors.pureWhite};
    ${({ theme: theme, variant: variant })=>variant === "outlined" && `stroke: ${theme.colors.darkGray} ;`}
    ${({ theme: theme, color: color })=>color === "default" && `stroke: ${theme.colors.darkGray} ;`}
    ${({ theme: theme, color: color })=>color === "primary" && `stroke: ${theme.colors.white} ;`}
    ${({ theme: theme, color: color })=>color === "secondary" && `stroke: ${theme.colors.white} ;`}
    ${({ theme: theme, color: color })=>color === "secondary-default" && `stroke: ${theme.colors.red} ;`}
    ${({ theme: theme, color: color })=>color === "tertiary" && `stroke: ${theme.colors.blue} ;`}
  }

  /*-------------------------------
    Variant Colors
  -------------------------------*/
  ${({ theme: theme, variant: variant })=>variant === "outlined" && `border: 1px solid ${theme.colors.gray};`}
  ${({ theme: theme, variant: variant })=>variant === "outlined" && `color: ${theme.colors.darkGray};`}
  ${({ variant: variant })=>variant === "outlined" && "background: transparent;"}

  ${({ theme: theme, color: color })=>color === "default" && `background: ${theme.colors.blue}40;`}
  ${({ theme: theme, color: color })=>color === "default" && `color: ${theme.colors.darkGray};`}
  ${({ theme: theme, color: color })=>color === "default" && `border: 1px solid ${theme.colors.blue};`}
    
  ${({ theme: theme, color: color })=>color === "primary" && `background: ${theme.colors.darkGray};`}
  ${({ theme: theme, color: color })=>color === "primary" && `border: 1px solid ${theme.colors.darkGray};`}
  ${({ theme: theme, color: color })=>color === "primary" && `color: ${theme.colors.white};`}

  ${({ theme: theme, color: color })=>color === "secondary" && `background: ${theme.colors.red};`}
  ${({ theme: theme, color: color })=>color === "secondary" && `color: ${theme.colors.pureWhite};`}
  ${({ theme: theme, color: color })=>color === "secondary" && `border: 1px solid ${theme.colors.red};`}

  ${({ theme: theme, color: color })=>color === "secondary-default" && `background: ${theme.colors.white};`}
  ${({ theme: theme, color: color })=>color === "secondary-default" && `color: ${theme.colors.red};`}
  ${({ theme: theme, color: color })=>color === "secondary-default" && `border: 1px solid ${theme.colors.red};`}
    
  ${({ theme: theme, color: color })=>color === "tertiary" && `background: ${theme.colors.lightGray};`}
  ${({ theme: theme, color: color })=>color === "tertiary" && `color: ${theme.colors.darkGray};`}
  ${({ theme: theme, color: color })=>color === "tertiary" && `border: 1px solid ${theme.colors.lightGray};`}
  /*-------------------------------
    Variant Sizes
  -------------------------------*/
  ${({ size: size })=>size === "tiny" && "padding: 0 5px !important; border-radius: 3px; font-size: 8px !important;"} 
  ${({ size: size })=>size === "small" && "font-size: 12px !important;"} 
  ${({ size: size })=>size === "medium" && "font-size: 16px !important;"} 
  ${({ size: size })=>size === "large" && "font-size: 20px !important;"} 

  /*-------------------------------
    Conditional Properties
  -------------------------------*/
  ${({ fullWidth: fullWidth })=>fullWidth && "width: 100%;"}
`;


function $e99593d75dd35a7e$var$Button(props) {
    // Destructure
    const { type: type, size: size, value: value, children: children, onClick: onClick, variant: variant, startIcon: startIcon, endIcon: endIcon, color: color, fullWidth: fullWidth, disabled: disabled, id: id } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d885bb434a8631da$export$d53c836cccbb0d90), {
        id: id,
        type: type,
        size: size,
        onClick: onClick,
        variant: variant,
        color: color,
        fullWidth: fullWidth,
        disabled: disabled,
        children: [
            startIcon && startIcon,
            value || children,
            endIcon && endIcon
        ]
    });
}
// Default Props
$e99593d75dd35a7e$var$Button.defaultProps = {
    onClick: ()=>{},
    type: "primary",
    size: "medium",
    value: "",
    children: "",
    startIcon: "",
    endIcon: "",
    variant: "contained",
    color: "",
    fullWidth: false,
    disabled: false
};
// Proptypes Validation
$e99593d75dd35a7e$var$Button.propTypes = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    startIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    endIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $e99593d75dd35a7e$export$2e2bcd8739ae039 = $e99593d75dd35a7e$var$Button;


var $9f02f87ab33cad18$export$2e2bcd8739ae039 = (0, $e99593d75dd35a7e$export$2e2bcd8739ae039);





var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $382056b345e884a9$export$d586e0ae81c7b89b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  min-height: 48px;
  margin-top: ${({ label: label })=>label && "-5px;"};
`;
const $382056b345e884a9$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $51b32cf9efbde13e$export$2d00230e1e6f7fbc))`
  position: relative;

  // Overrides
  &.form-group {
    margin: 0px;
  }
`;
const $382056b345e884a9$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  position: relative;
  z-index: 1;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  font-size: 12px;
  padding: 0 8px;
  transform: translate(15px, 15px);

  background-color: ${({ theme: theme })=>theme.colors.white};
  border-radius: 5px;
`;
const $382056b345e884a9$export$d6701e98ab1a6725 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).select`
  display: none;
`;
const $382056b345e884a9$export$11a8a1ea41bf55d8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).option`
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $382056b345e884a9$export$37cdf0d06bb542b5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.darkGray};
  cursor: ${(props)=>props.disabled ? "default" : "pointer"};
  transition: 0.4s;

  position: relative;
  // TODO: Use theme functions
  &:after {
    content: '';

    position: absolute;
    top: 42%;
    right: 15px;

    display: ${({ disabled: disabled })=>disabled ? "none" : "inline-block"};
    margin-left: 0.255em;
    vertical-align: 0.255em;

    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
    color: ${({ theme: theme })=>theme.colors.darkGray};
  }

  min-height: 54px;
  height: fit-content;
  width: 100%;

  padding: 15px 20px;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  box-shadow: none;

  border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? "transparent" : theme.colors.white};
  border-radius: ${({ open: open })=>open ? "10px 10px 0 0" : "10px"};
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.07);
`;
const $382056b345e884a9$export$a6151309bfd46137 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: 3;
  position: absolute;
  top: 100%;
  display: flex;
  flex-direction: column;
  color: ${({ theme: theme })=>theme.colors.darkGray};

  padding: 10px;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;

  font-size: 16px;
  font-weight: 400;
  background-color: ${({ theme: theme })=>theme.colors.white};
  border-left: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
  border-right: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
  border-bottom: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
  border-radius: ${({ open: open })=>open ? "0 0 10px 10px" : "10px"};
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.07);
  user-select: none;
`;
const $382056b345e884a9$export$ba141e9a22070242 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  gap: 10px;

  transition: 0.4s;

  border-radius: 8px;
  border: ${({ disabled: disabled })=>!disabled && "1px solid rgba(0, 0, 0, 0)"};
  color: ${(props)=>props.theme.colors.darkGray};
  cursor: ${({ disabled: disabled })=>disabled ? "not-allowed" : "pointer"};

  &:hover {
    background: ${({ theme: theme, disabled: disabled })=>!disabled && theme.colors.lightGray};
  }
`;
const $382056b345e884a9$export$8a186fdbfc12f934 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${(props)=>props.theme.colors.darkGray};
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const $382056b345e884a9$export$a11e67ac8be84bf9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.lightGray};
  min-width: 40px;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const $382056b345e884a9$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-width: 40px;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;


// Function that listens to oustide clicks of given ref
const $afe5329dc5514fbe$var$useOutsideAlerter = (ref, setShowOptions)=>{
    (0, $tZqWC.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) setShowOptions(false);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref
    ]);
};
function $afe5329dc5514fbe$var$Select(props) {
    // Destructure
    const { id: id, label: label, placeholder: placeholder, options: options, onChange: onChange, value: value, disabled: disabled, ...rest } = props;
    // Variables
    const withOptions = options && options?.length > 0;
    const wrapperRef = (0, $tZqWC.useRef)();
    // States
    const [formValue, setFormValue] = (0, $tZqWC.useState)("");
    const [valueLabel, setValueLabel] = (0, $tZqWC.useState)("");
    const [showOptions, setShowOptions] = (0, $tZqWC.useState)(false);
    // Functions
    const handleOnChange = (value, label)=>{
        onChange(value);
        if (value === undefined) {
            setFormValue(value);
            setValueLabel(placeholder || "");
            return setShowOptions(false);
        }
        setFormValue(value);
        setValueLabel(label);
        setShowOptions(false);
    };
    // Closing options on click away
    $afe5329dc5514fbe$var$useOutsideAlerter(wrapperRef, setShowOptions);
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        // setting the value and label on initial load
        if (value !== undefined && value !== null) {
            setFormValue(value);
            const currentLabel = options.find((data)=>{
                if (typeof data.value === "number") return data.value === Number(value);
                return data.value === value;
            });
            if (currentLabel?.label) setValueLabel(currentLabel.label);
            else if (!currentLabel?.label) setValueLabel(placeholder || "");
        }
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $382056b345e884a9$export$d586e0ae81c7b89b), {
        ref: wrapperRef,
        label: label,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $382056b345e884a9$export$b04be29aa201d4f5), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $382056b345e884a9$export$8f1ff89fa1ec9605), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $382056b345e884a9$export$d6701e98ab1a6725), {
                        id: id,
                        type: "select",
                        value: `${formValue}`,
                        onChange: ()=>{},
                        ...rest
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $382056b345e884a9$export$37cdf0d06bb542b5), {
                        open: showOptions,
                        disabled: disabled,
                        onClick: ()=>{
                            if (!disabled) setShowOptions((prevState)=>!prevState);
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $382056b345e884a9$export$8a186fdbfc12f934), {
                            disabled: disabled,
                            children: [
                                " ",
                                !valueLabel ? placeholder : valueLabel,
                                " "
                            ]
                        })
                    }),
                    showOptions && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $382056b345e884a9$export$a6151309bfd46137), {
                        open: showOptions,
                        children: withOptions && options.map(({ value: value, label: label, disabled: disabled, abrv: abrv, icon: icon })=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                                children: label !== valueLabel && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $382056b345e884a9$export$ba141e9a22070242), {
                                    disabled: disabled,
                                    onClick: ()=>{
                                        if (!disabled) handleOnChange(value, label);
                                    },
                                    value: value,
                                    children: [
                                        icon && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $65f0d7ff3fd922b2$export$2e2bcd8739ae039), {
                                            src: icon,
                                            width: 30,
                                            height: 30
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $382056b345e884a9$export$5f1af8db9871e1d6), {
                                            children: label
                                        }),
                                        abrv && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $382056b345e884a9$export$a11e67ac8be84bf9), {
                                            children: [
                                                " ",
                                                abrv,
                                                " "
                                            ]
                                        })
                                    ]
                                })
                            }, label))
                    })
                ]
            })
        ]
    });
}
// Default Props
$afe5329dc5514fbe$var$Select.defaultProps = {
    id: "",
    label: "",
    value: "",
    placeholder: "",
    options: [],
    onChange: ()=>{},
    disabled: false
};
// Proptypes Validation
$afe5329dc5514fbe$var$Select.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    ]),
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $afe5329dc5514fbe$export$2e2bcd8739ae039 = $afe5329dc5514fbe$var$Select;


const $6a91653b1537854f$export$acf2d8d0e9d6a367 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: 10;
  display: flex;
  flex-direction: column;
  position: relative;
`;
const $6a91653b1537854f$export$efd2ee3668abe4a5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 20px;
`;
const $6a91653b1537854f$export$15e68730ccc59c2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: ${({ vertical: vertical })=>vertical ? "column" : "row"};
  align-items: ${({ vertical: vertical })=>vertical ? "flex-start" : "center"};
  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  gap: ${({ vertical: vertical })=>vertical ? "0px" : "5px"};
  cursor: pointer;
  min-width: 90px;
`;
const $6a91653b1537854f$export$7fea8804b551b679 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.blue};
  font-size: 14px;
  font-weight: 400;
`;
const $6a91653b1537854f$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-weight: 200;
`;
const $6a91653b1537854f$export$a915f81916d25a71 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-width: 490px;
  top: 100%;
  margin-top: 15px;
  position: absolute;
  height: ${({ open: open })=>open ? "fit-content" : 0} !important;
  padding: ${({ open: open })=>open ? "20px" : "0 20px"} !important;
  overflow: ${({ open: open })=>open ? "auto" : "hidden"} !important;
  transition: 0.3s;

  display: flex;
  flex-direction: column;
  background-color: ${({ theme: theme })=>theme.colors.white};
  width: fit-content;
  border-radius: 10px;
  box-shadow: 0px 0px 7px rgb(0 0 0 / 10%);
`;
const $6a91653b1537854f$export$abb4b0be5cbfc1e9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-width: 490px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: fit-content;

  & button {
    height: 40px;
    width: 40px;
    padding: 5px;
    border: none;
    & svg {
      max-width: 100% !important;
      max-height: 100% !important;
    }
    &:hover {
      border: none;
      background-color: ${({ theme: theme })=>theme.colors.blue};
    }
  }
`;
const $6a91653b1537854f$export$f4924b24ba81735c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-width: 290px;
  display: flex;
  gap: 10px;
  width: 100%;

  & div {
    margin: 0 !important;
    font-size: 12px !important;
  }
`;
const $6a91653b1537854f$export$80ddb20a2792901 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $afe5329dc5514fbe$export$2e2bcd8739ae039))``;
const $6a91653b1537854f$export$9b1eb6d1773fc30b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;

  & > div > div > div:last-child {
    max-height: 200px;
    & div > div {
      padding: 3px 5px;
    }
  }
`;
const $6a91653b1537854f$export$ced7e5994573e44b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 30px;
  min-width: 490px;
`;
const $6a91653b1537854f$export$38995e55f23dbe5b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0 0 0;
  min-width: 230px;
`;
const $6a91653b1537854f$export$eb9874e3f5c4acea = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $6a91653b1537854f$export$49c3657ed19fd125 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px !important;
  min-width: 230px;
`;
const $6a91653b1537854f$export$c4485302f8878b91 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid !important;
  grid-template-columns: repeat(7, minmax(20px, 1fr)) !important;
  gap: 10px !important;
  min-width: 230px;
`;
const $6a91653b1537854f$export$56537c841c97711f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  text-align: center;
  color: ${({ theme: theme, disabled: disabled })=>disabled ? `${theme.colors.gray} !important` : theme.colors.darkGray};
  color: ${({ theme: theme, active: active })=>active && theme.colors.white};
  cursor: pointer;

  padding: 3px 5px;
  border-radius: 5px;
  text-decoration: ${({ forbidden: forbidden })=>forbidden && "line-through"};

  background-color: ${({ active: active, theme: theme })=>active && theme.colors.blue};
  background-color: ${({ disabled: disabled })=>disabled && "transparent !important"};
  &:hover {
    background-color: ${({ disabled: disabled, theme: theme })=>!disabled && theme.colors.gray};
  }
`;
const $6a91653b1537854f$export$46b05479ef2711b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-width: 490px;
  padding: 20px 0 0 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  height: fit-content;

  & button {
    font-size: 14px !important;
    padding: 5px 10px !important;
    border: 2px solid ${({ theme: theme })=>theme.colors.lightGray};
    box-shadow: none;
  }
`;
const $6a91653b1537854f$export$46b753c3e7a7fae9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 10px;
  max-width: none !important;
`;


function $9b33735bb973900e$var$CustomDateRangePicker(props) {
    // props
    const { onApply: onApply, start: start, end: end, simplifiedDate: simplifiedDate, vertical: vertical, ...rest } = props;
    const [open, setOpen] = (0, $tZqWC.useState)(false);
    const [days, setDays] = (0, $tZqWC.useState)([]);
    const [days2, setDays2] = (0, $tZqWC.useState)([]);
    const [currDay, setCurrDay] = (0, $tZqWC.useState)((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))());
    const [currDay2, setCurrDay2] = (0, $tZqWC.useState)((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(1, "month"));
    const [selectedStart, setSelectedStart] = (0, $tZqWC.useState)(start ? (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(start) : (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(1, "month"));
    const [selectedEnd, setSelectedEnd] = (0, $tZqWC.useState)(end ? (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(end) : (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))());
    const pickerRef = (0, $tZqWC.useRef)();
    // functions
    const handleOpen = ()=>{
        setOpen((prevValue)=>!prevValue);
    };
    const handleCancel = ()=>{
        if (start && end) {
            setSelectedStart((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(start));
            setSelectedEnd((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(end));
        } else {
            setSelectedStart((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(1, "month"));
            setSelectedEnd((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))());
        }
        setOpen(false);
    };
    const handleApply = ()=>{
        if (selectedStart && selectedEnd) {
            onApply({
                start: selectedStart.format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
                end: selectedEnd.format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c))
            });
            setOpen(false);
        }
    };
    const moveBack = ()=>{
        setCurrDay(currDay.clone().subtract(1, "month"));
        setCurrDay2(currDay2.clone().subtract(1, "month"));
    };
    const moveNext = ()=>{
        if (!currDay.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(1, "month"), "month")) {
            setCurrDay(currDay.clone().add(1, "month"));
            setCurrDay2(currDay2.clone().add(1, "month"));
        }
    };
    const getYears = (back)=>{
        const year = new Date().getFullYear();
        let reversedYears = [];
        Array.from({
            length: back
        }, (v, i)=>{
            reversedYears = [
                {
                    value: year - back + i + 1,
                    label: year - back + i + 1
                },
                ...reversedYears
            ];
        });
        return reversedYears;
    };
    const handleMonthChange = (value)=>{
        setCurrDay((prevValue)=>prevValue.clone().set("month", value));
        setCurrDay2((prevValue)=>prevValue.clone().set("month", value).subtract(1, "month"));
    };
    const handleYearChange = (value)=>{
        setCurrDay((prevValue)=>prevValue.clone().set("year", value));
        setCurrDay2((prevValue)=>prevValue.clone().set("year", value));
    };
    const handleClick = (value)=>{
        if (!selectedStart) return setSelectedStart(value);
        if (selectedStart) {
            if (value.isSame(selectedStart)) return;
            if (!selectedEnd) {
                if (value.isAfter(selectedStart)) return setSelectedEnd(value);
                setSelectedStart(value);
            }
            if (selectedEnd) {
                setSelectedStart(value);
                setSelectedEnd();
            }
        }
    };
    // UseEffect
    (0, $tZqWC.useEffect)(()=>{
        setDays((0, $f986938d3cd2fdf2$export$2e2bcd8739ae039)(currDay));
        setDays2((0, $f986938d3cd2fdf2$export$2e2bcd8739ae039)(currDay2));
    }, [
        currDay,
        currDay2
    ]);
    (0, $54f47a39f461db48$export$50ec7b7ff742aae5)(pickerRef, handleCancel);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a91653b1537854f$export$acf2d8d0e9d6a367), {
        ...rest,
        ref: pickerRef,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a91653b1537854f$export$efd2ee3668abe4a5), {
                onClick: handleOpen,
                vertical: vertical,
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a91653b1537854f$export$15e68730ccc59c2), {
                        vertical: vertical,
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a91653b1537854f$export$b04be29aa201d4f5), {
                                children: "From: "
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a91653b1537854f$export$7fea8804b551b679), {
                                children: selectedStart && (simplifiedDate ? selectedStart.format("MMM. DD, YYYY") : selectedStart.format("MMMM DD YYYY"))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a91653b1537854f$export$15e68730ccc59c2), {
                        vertical: vertical,
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a91653b1537854f$export$b04be29aa201d4f5), {
                                children: "To: "
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a91653b1537854f$export$7fea8804b551b679), {
                                children: selectedEnd && (simplifiedDate ? selectedEnd.format("MMM. DD, YYYY") : selectedEnd.format("MMMM DD YYYY"))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a91653b1537854f$export$a915f81916d25a71), {
                open: open,
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a91653b1537854f$export$abb4b0be5cbfc1e9), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                onClick: moveBack,
                                variant: "outlined",
                                startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $76fabb61791e82e0$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a91653b1537854f$export$f4924b24ba81735c), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a91653b1537854f$export$9b1eb6d1773fc30b), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a91653b1537854f$export$80ddb20a2792901), {
                                            options: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7))).months().map((item)=>({
                                                    value: item,
                                                    label: item
                                                })),
                                            onChange: handleMonthChange,
                                            value: currDay.format("MMMM"),
                                            placeholder: currDay.format("MMMM")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a91653b1537854f$export$9b1eb6d1773fc30b), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a91653b1537854f$export$80ddb20a2792901), {
                                            options: getYears(20),
                                            onChange: handleYearChange,
                                            value: currDay.format("YYYY"),
                                            placeholder: currDay.format("YYYY")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                onClick: moveNext,
                                disabled: currDay.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(1, "month"), "month"),
                                variant: "outlined",
                                startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $39f02159828fe73c$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a91653b1537854f$export$ced7e5994573e44b), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a91653b1537854f$export$38995e55f23dbe5b), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a91653b1537854f$export$eb9874e3f5c4acea), {
                                        children: currDay2.format("MMMM YYYY")
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a91653b1537854f$export$49c3657ed19fd125), {
                                        children: days2.map((week)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a91653b1537854f$export$c4485302f8878b91), {
                                                style: {
                                                    display: "flex",
                                                    gap: "20px"
                                                },
                                                children: week.map((day)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a91653b1537854f$export$56537c841c97711f), {
                                                        onClick: ()=>!day.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), "day") && handleClick(day),
                                                        forbidden: day.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), "day"),
                                                        disabled: day.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), "day") || !day.isSame(currDay2, "month"),
                                                        active: day.isSame(selectedStart) || !!selectedEnd && !!selectedStart && day.isSameOrBefore(selectedEnd) && day.isSameOrAfter(selectedStart),
                                                        children: day.format("D")
                                                    }, day.format("MM/DD")))
                                            }, week))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a91653b1537854f$export$38995e55f23dbe5b), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a91653b1537854f$export$eb9874e3f5c4acea), {
                                        children: currDay.format("MMMM YYYY")
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a91653b1537854f$export$49c3657ed19fd125), {
                                        children: days.map((week)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a91653b1537854f$export$c4485302f8878b91), {
                                                style: {
                                                    display: "flex",
                                                    gap: "20px"
                                                },
                                                children: week.map((day)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a91653b1537854f$export$56537c841c97711f), {
                                                        onClick: ()=>!day.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), "day") && handleClick(day),
                                                        forbidden: day.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), "day"),
                                                        disabled: day.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), "day") || !day.isSame(currDay, "month"),
                                                        active: day.isSame(selectedStart) || !!selectedEnd && !!selectedStart && day.isSameOrBefore(selectedEnd) && day.isSameOrAfter(selectedStart),
                                                        children: day.format("D")
                                                    }, day.format("MM/DD")))
                                            }, week))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a91653b1537854f$export$46b05479ef2711b), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a91653b1537854f$export$46b753c3e7a7fae9), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a91653b1537854f$export$15e68730ccc59c2), {
                                        children: [
                                            "From: ",
                                            selectedStart && selectedStart.format("MMMM DD YYYY")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a91653b1537854f$export$15e68730ccc59c2), {
                                        children: [
                                            "To: ",
                                            selectedEnd && selectedEnd.format("MMMM DD YYYY")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a91653b1537854f$export$46b753c3e7a7fae9), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                        variant: "outlined",
                                        onClick: handleCancel,
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                        id: "apply",
                                        onClick: handleApply,
                                        disabled: !selectedStart || !selectedEnd,
                                        children: "Apply"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
// Default Props
$9b33735bb973900e$var$CustomDateRangePicker.defaultProps = {
    onApply: ()=>{},
    start: "",
    end: "",
    simplifiedDate: false,
    vertical: false
};
// Proptypes Validation
$9b33735bb973900e$var$CustomDateRangePicker.propTypes = {
    onApply: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    start: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    end: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    simplifiedDate: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    vertical: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $9b33735bb973900e$export$2e2bcd8739ae039 = $9b33735bb973900e$var$CustomDateRangePicker;


var $9fb0841741f8ee1f$export$2e2bcd8739ae039 = (0, $9b33735bb973900e$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $ba9a4b3ec47cf4f4$export$89d116ece15bc5b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  display: flex;
  cursor: pointer;
  padding: 6px;

  // TODO: Use theme function
  &:hover {
    background-color: #e9e9e9;
    border-radius: 50%;
  }
`;


function $aa172c93a6433d02$var$IconButton(props) {
    // Destructure
    const { children: children, onClick: onClick } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ba9a4b3ec47cf4f4$export$89d116ece15bc5b6), {
        onClick: onClick,
        children: children
    });
}
// Default Props
$aa172c93a6433d02$var$IconButton.defaultProps = {
    onClick: ()=>{},
    children: ""
};
// Proptypes Validation
$aa172c93a6433d02$var$IconButton.propTypes = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $aa172c93a6433d02$export$2e2bcd8739ae039 = $aa172c93a6433d02$var$IconButton;


var $1ae7df2396c7235c$export$2e2bcd8739ae039 = (0, $aa172c93a6433d02$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");
var $c9646de1e9b18cbc$exports = {};
$c9646de1e9b18cbc$exports = new URL("chevron-left.2c10fe86.svg", import.meta.url).toString();


var $698600f03b73500c$exports = {};
$698600f03b73500c$exports = new URL("chevron-right.17d26598.svg", import.meta.url).toString();



var $1408042ff9926c4c$exports = {};
"use strict";
Object.defineProperty($1408042ff9926c4c$exports, "__esModule", {
    value: true
});
$1408042ff9926c4c$exports["default"] = void 0;

var $1408042ff9926c4c$var$_react = $1408042ff9926c4c$var$_interopRequireWildcard((parcelRequire("jt1nG")));

var $1408042ff9926c4c$var$_propTypes = $1408042ff9926c4c$var$_interopRequireDefault((parcelRequire("4L3zM")));

var $1408042ff9926c4c$var$_paginator = $1408042ff9926c4c$var$_interopRequireDefault((parcelRequire("4ndnV")));

var $1408042ff9926c4c$var$_Page = $1408042ff9926c4c$var$_interopRequireDefault((parcelRequire("61x14")));

var $1408042ff9926c4c$var$_classnames = $1408042ff9926c4c$var$_interopRequireDefault((parcelRequire("9A5xi")));
function $1408042ff9926c4c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1408042ff9926c4c$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $1408042ff9926c4c$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $1408042ff9926c4c$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $1408042ff9926c4c$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $1408042ff9926c4c$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $1408042ff9926c4c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $1408042ff9926c4c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $1408042ff9926c4c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $1408042ff9926c4c$var$_typeof(obj);
}
function $1408042ff9926c4c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1408042ff9926c4c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1408042ff9926c4c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1408042ff9926c4c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1408042ff9926c4c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1408042ff9926c4c$var$_possibleConstructorReturn(self, call) {
    if (call && ($1408042ff9926c4c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $1408042ff9926c4c$var$_assertThisInitialized(self);
}
function $1408042ff9926c4c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1408042ff9926c4c$var$_getPrototypeOf(o) {
    $1408042ff9926c4c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1408042ff9926c4c$var$_getPrototypeOf(o);
}
function $1408042ff9926c4c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $1408042ff9926c4c$var$_setPrototypeOf(subClass, superClass);
}
function $1408042ff9926c4c$var$_setPrototypeOf(o, p) {
    $1408042ff9926c4c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1408042ff9926c4c$var$_setPrototypeOf(o, p);
}
function $1408042ff9926c4c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $1408042ff9926c4c$var$Pagination = /*#__PURE__*/ function(_React$Component) {
    $1408042ff9926c4c$var$_inherits(Pagination, _React$Component);
    function Pagination() {
        $1408042ff9926c4c$var$_classCallCheck(this, Pagination);
        return $1408042ff9926c4c$var$_possibleConstructorReturn(this, $1408042ff9926c4c$var$_getPrototypeOf(Pagination).apply(this, arguments));
    }
    $1408042ff9926c4c$var$_createClass(Pagination, [
        {
            key: "isFirstPageVisible",
            value: function isFirstPageVisible(has_previous_page) {
                var _this$props = this.props, hideDisabled = _this$props.hideDisabled, hideNavigation = _this$props.hideNavigation, hideFirstLastPages = _this$props.hideFirstLastPages;
                if (hideFirstLastPages || hideDisabled && !has_previous_page) return false;
                return true;
            }
        },
        {
            key: "isPrevPageVisible",
            value: function isPrevPageVisible(has_previous_page) {
                var _this$props2 = this.props, hideDisabled = _this$props2.hideDisabled, hideNavigation = _this$props2.hideNavigation;
                if (hideNavigation || hideDisabled && !has_previous_page) return false;
                return true;
            }
        },
        {
            key: "isNextPageVisible",
            value: function isNextPageVisible(has_next_page) {
                var _this$props3 = this.props, hideDisabled = _this$props3.hideDisabled, hideNavigation = _this$props3.hideNavigation;
                if (hideNavigation || hideDisabled && !has_next_page) return false;
                return true;
            }
        },
        {
            key: "isLastPageVisible",
            value: function isLastPageVisible(has_next_page) {
                var _this$props4 = this.props, hideDisabled = _this$props4.hideDisabled, hideNavigation = _this$props4.hideNavigation, hideFirstLastPages = _this$props4.hideFirstLastPages;
                if (hideFirstLastPages || hideDisabled && !has_next_page) return false;
                return true;
            }
        },
        {
            key: "buildPages",
            value: function buildPages() {
                var pages = [];
                var _this$props5 = this.props, itemsCountPerPage = _this$props5.itemsCountPerPage, pageRangeDisplayed = _this$props5.pageRangeDisplayed, activePage = _this$props5.activePage, prevPageText = _this$props5.prevPageText, nextPageText = _this$props5.nextPageText, firstPageText = _this$props5.firstPageText, lastPageText = _this$props5.lastPageText, totalItemsCount = _this$props5.totalItemsCount, onChange = _this$props5.onChange, activeClass = _this$props5.activeClass, itemClass = _this$props5.itemClass, itemClassFirst = _this$props5.itemClassFirst, itemClassPrev = _this$props5.itemClassPrev, itemClassNext = _this$props5.itemClassNext, itemClassLast = _this$props5.itemClassLast, activeLinkClass = _this$props5.activeLinkClass, disabledClass = _this$props5.disabledClass, hideDisabled = _this$props5.hideDisabled, hideNavigation = _this$props5.hideNavigation, linkClass = _this$props5.linkClass, linkClassFirst = _this$props5.linkClassFirst, linkClassPrev = _this$props5.linkClassPrev, linkClassNext = _this$props5.linkClassNext, linkClassLast = _this$props5.linkClassLast, hideFirstLastPages = _this$props5.hideFirstLastPages, getPageUrl = _this$props5.getPageUrl;
                var paginationInfo = new $1408042ff9926c4c$var$_paginator["default"](itemsCountPerPage, pageRangeDisplayed).build(totalItemsCount, activePage);
                for(var i = paginationInfo.first_page; i <= paginationInfo.last_page; i++)pages.push($1408042ff9926c4c$var$_react["default"].createElement($1408042ff9926c4c$var$_Page["default"], {
                    isActive: i === activePage,
                    key: i,
                    href: getPageUrl(i),
                    pageNumber: i,
                    pageText: i + "",
                    onClick: onChange,
                    itemClass: itemClass,
                    linkClass: linkClass,
                    activeClass: activeClass,
                    activeLinkClass: activeLinkClass,
                    ariaLabel: "Go to page number ".concat(i)
                }));
                this.isPrevPageVisible(paginationInfo.has_previous_page) && pages.unshift($1408042ff9926c4c$var$_react["default"].createElement($1408042ff9926c4c$var$_Page["default"], {
                    key: "prev" + paginationInfo.previous_page,
                    href: getPageUrl(paginationInfo.previous_page),
                    pageNumber: paginationInfo.previous_page,
                    onClick: onChange,
                    pageText: prevPageText,
                    isDisabled: !paginationInfo.has_previous_page,
                    itemClass: (0, $1408042ff9926c4c$var$_classnames["default"])(itemClass, itemClassPrev),
                    linkClass: (0, $1408042ff9926c4c$var$_classnames["default"])(linkClass, linkClassPrev),
                    disabledClass: disabledClass,
                    ariaLabel: "Go to previous page"
                }));
                this.isFirstPageVisible(paginationInfo.has_previous_page) && pages.unshift($1408042ff9926c4c$var$_react["default"].createElement($1408042ff9926c4c$var$_Page["default"], {
                    key: "first",
                    href: getPageUrl(1),
                    pageNumber: 1,
                    onClick: onChange,
                    pageText: firstPageText,
                    isDisabled: !paginationInfo.has_previous_page,
                    itemClass: (0, $1408042ff9926c4c$var$_classnames["default"])(itemClass, itemClassFirst),
                    linkClass: (0, $1408042ff9926c4c$var$_classnames["default"])(linkClass, linkClassFirst),
                    disabledClass: disabledClass,
                    ariaLabel: "Go to first page"
                }));
                this.isNextPageVisible(paginationInfo.has_next_page) && pages.push($1408042ff9926c4c$var$_react["default"].createElement($1408042ff9926c4c$var$_Page["default"], {
                    key: "next" + paginationInfo.next_page,
                    href: getPageUrl(paginationInfo.next_page),
                    pageNumber: paginationInfo.next_page,
                    onClick: onChange,
                    pageText: nextPageText,
                    isDisabled: !paginationInfo.has_next_page,
                    itemClass: (0, $1408042ff9926c4c$var$_classnames["default"])(itemClass, itemClassNext),
                    linkClass: (0, $1408042ff9926c4c$var$_classnames["default"])(linkClass, linkClassNext),
                    disabledClass: disabledClass,
                    ariaLabel: "Go to next page"
                }));
                this.isLastPageVisible(paginationInfo.has_next_page) && pages.push($1408042ff9926c4c$var$_react["default"].createElement($1408042ff9926c4c$var$_Page["default"], {
                    key: "last",
                    href: getPageUrl(paginationInfo.total_pages),
                    pageNumber: paginationInfo.total_pages,
                    onClick: onChange,
                    pageText: lastPageText,
                    isDisabled: paginationInfo.current_page === paginationInfo.total_pages,
                    itemClass: (0, $1408042ff9926c4c$var$_classnames["default"])(itemClass, itemClassLast),
                    linkClass: (0, $1408042ff9926c4c$var$_classnames["default"])(linkClass, linkClassLast),
                    disabledClass: disabledClass,
                    ariaLabel: "Go to last page"
                }));
                return pages;
            }
        },
        {
            key: "render",
            value: function render() {
                var pages = this.buildPages();
                return $1408042ff9926c4c$var$_react["default"].createElement("ul", {
                    className: this.props.innerClass
                }, pages);
            }
        }
    ]);
    return Pagination;
}($1408042ff9926c4c$var$_react["default"].Component);
$1408042ff9926c4c$exports["default"] = $1408042ff9926c4c$var$Pagination;
$1408042ff9926c4c$var$_defineProperty($1408042ff9926c4c$var$Pagination, "propTypes", {
    totalItemsCount: $1408042ff9926c4c$var$_propTypes["default"].number.isRequired,
    onChange: $1408042ff9926c4c$var$_propTypes["default"].func.isRequired,
    activePage: $1408042ff9926c4c$var$_propTypes["default"].number,
    itemsCountPerPage: $1408042ff9926c4c$var$_propTypes["default"].number,
    pageRangeDisplayed: $1408042ff9926c4c$var$_propTypes["default"].number,
    prevPageText: $1408042ff9926c4c$var$_propTypes["default"].oneOfType([
        $1408042ff9926c4c$var$_propTypes["default"].string,
        $1408042ff9926c4c$var$_propTypes["default"].element
    ]),
    nextPageText: $1408042ff9926c4c$var$_propTypes["default"].oneOfType([
        $1408042ff9926c4c$var$_propTypes["default"].string,
        $1408042ff9926c4c$var$_propTypes["default"].element
    ]),
    lastPageText: $1408042ff9926c4c$var$_propTypes["default"].oneOfType([
        $1408042ff9926c4c$var$_propTypes["default"].string,
        $1408042ff9926c4c$var$_propTypes["default"].element
    ]),
    firstPageText: $1408042ff9926c4c$var$_propTypes["default"].oneOfType([
        $1408042ff9926c4c$var$_propTypes["default"].string,
        $1408042ff9926c4c$var$_propTypes["default"].element
    ]),
    disabledClass: $1408042ff9926c4c$var$_propTypes["default"].string,
    hideDisabled: $1408042ff9926c4c$var$_propTypes["default"].bool,
    hideNavigation: $1408042ff9926c4c$var$_propTypes["default"].bool,
    innerClass: $1408042ff9926c4c$var$_propTypes["default"].string,
    itemClass: $1408042ff9926c4c$var$_propTypes["default"].string,
    itemClassFirst: $1408042ff9926c4c$var$_propTypes["default"].string,
    itemClassPrev: $1408042ff9926c4c$var$_propTypes["default"].string,
    itemClassNext: $1408042ff9926c4c$var$_propTypes["default"].string,
    itemClassLast: $1408042ff9926c4c$var$_propTypes["default"].string,
    linkClass: $1408042ff9926c4c$var$_propTypes["default"].string,
    activeClass: $1408042ff9926c4c$var$_propTypes["default"].string,
    activeLinkClass: $1408042ff9926c4c$var$_propTypes["default"].string,
    linkClassFirst: $1408042ff9926c4c$var$_propTypes["default"].string,
    linkClassPrev: $1408042ff9926c4c$var$_propTypes["default"].string,
    linkClassNext: $1408042ff9926c4c$var$_propTypes["default"].string,
    linkClassLast: $1408042ff9926c4c$var$_propTypes["default"].string,
    hideFirstLastPages: $1408042ff9926c4c$var$_propTypes["default"].bool,
    getPageUrl: $1408042ff9926c4c$var$_propTypes["default"].func
});
$1408042ff9926c4c$var$_defineProperty($1408042ff9926c4c$var$Pagination, "defaultProps", {
    itemsCountPerPage: 10,
    pageRangeDisplayed: 5,
    activePage: 1,
    prevPageText: "\u27E8",
    firstPageText: "\xab",
    nextPageText: "\u27E9",
    lastPageText: "\xbb",
    innerClass: "pagination",
    itemClass: undefined,
    linkClass: undefined,
    activeLinkClass: undefined,
    hideFirstLastPages: false,
    getPageUrl: function getPageUrl(i) {
        return "#";
    }
});


const $aaf622d5f68ae696$export$3e5e12dc01f20a43 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: 20px;
  margin-top: 10px;
  padding: 22px 0;

  // Overrides
  & ul {
    & li {
      margin: 0 11px;
      color: ${({ theme: theme })=>theme.colors.darkGray};

      &:first-child,
      &:last-child {
        display: none;
      }
    }

    & .active {
      margin: 0 2px;
      padding: 0 7px;

      font-size: 15px;
      font-weight: 400;

      border-radius: 5px;
      border: 1px solid ${({ theme: theme })=>theme.colors.gray};
      background: ${({ theme: theme })=>theme.colors.white};

      a {
        -webkit-font-smoothing: antialiased;
        font-size: 15px;
        color: ${({ theme: theme })=>theme.colors.darkGray};
      }
    }
  }
`;
const $aaf622d5f68ae696$export$1f1b920a94aec4db = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($1408042ff9926c4c$exports))))``;
const $aaf622d5f68ae696$export$96537c2cba8f79c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  max-width: 140px;

  // TODO: Use theme function
  &:after {
    color: ${({ theme: theme })=>theme.colors.darkGray};
  }
`;
const $aaf622d5f68ae696$export$c76e7538c9817e46 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).select`
  padding: 0 10px;
  width: 140px;

  font-size: 16px;
  font-weight: 400;

  border: none;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  text-align: center;
  background: transparent;

  // TODO: Use theme function
  &:focus {
    outline: none;
  }
`;
const $aaf622d5f68ae696$export$4cca26793905b8d3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).option`
  font-size: 15px;
  font-weight: 200;
  padding: 2px 5px;
  background-color: ${({ theme: theme })=>theme.colors.white};
  box-shadow: 5px 10px #888888;
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;



function $c109a2490e8ecf9c$var$Pagination(props) {
    // Destructure
    const { prevPageText: prevPageText, nextPageText: nextPageText, onChange: onChange, itemsCountPerPage: itemsCountPerPage, totalItemsCount: totalItemsCount, pageRangeDisplayed: pageRangeDisplayed, page: page } = props;
    // States
    const [size, setSize] = (0, $tZqWC.useState)(10);
    // Functions
    const handlePageChange = (page)=>{
        onChange({
            page: +page,
            size: size
        });
    };
    const handleOnSelectChange = ({ target: target })=>{
        setSize(+target.value);
        onChange({
            page: 1,
            size: +target.value
        });
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $aaf622d5f68ae696$export$3e5e12dc01f20a43), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $aaf622d5f68ae696$export$1f1b920a94aec4db), {
                prevPageText: prevPageText,
                nextPageText: nextPageText,
                activePage: page,
                itemsCountPerPage: itemsCountPerPage,
                totalItemsCount: totalItemsCount,
                pageRangeDisplayed: pageRangeDisplayed,
                onChange: handlePageChange
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $aaf622d5f68ae696$export$96537c2cba8f79c), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $aaf622d5f68ae696$export$c76e7538c9817e46), {
                    onChange: handleOnSelectChange,
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $aaf622d5f68ae696$export$4cca26793905b8d3), {
                            value: "10",
                            children: "10 per page"
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $aaf622d5f68ae696$export$4cca26793905b8d3), {
                            value: "20",
                            children: "20 per page"
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $aaf622d5f68ae696$export$4cca26793905b8d3), {
                            value: "30",
                            children: "30 per page"
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $aaf622d5f68ae696$export$4cca26793905b8d3), {
                            value: "40",
                            children: "40 per page"
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $aaf622d5f68ae696$export$4cca26793905b8d3), {
                            value: "50",
                            children: "50 per page"
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $aaf622d5f68ae696$export$4cca26793905b8d3), {
                            value: "100",
                            children: "100 per page"
                        })
                    ]
                })
            })
        ]
    });
}
// Default Props
$c109a2490e8ecf9c$var$Pagination.defaultProps = {
    prevPageText: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $65f0d7ff3fd922b2$export$2e2bcd8739ae039), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c9646de1e9b18cbc$exports)))
    }),
    nextPageText: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $65f0d7ff3fd922b2$export$2e2bcd8739ae039), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($698600f03b73500c$exports)))
    }),
    onChange: ()=>{},
    itemsCountPerPage: 10,
    totalItemsCount: 10,
    pageRangeDisplayed: 5,
    page: 0
};
// Proptypes Validation
$c109a2490e8ecf9c$var$Pagination.propTypes = {
    prevPageText: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    nextPageText: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    itemsCountPerPage: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    totalItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    pageRangeDisplayed: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
};
var $c109a2490e8ecf9c$export$2e2bcd8739ae039 = $c109a2490e8ecf9c$var$Pagination;


var $9deaec2f043c7dfd$export$2e2bcd8739ae039 = (0, $c109a2490e8ecf9c$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $f68fcb2fcd9c6103$export$304c5d81524150ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  width: 100%;
  height: 100%;
`;
const $f68fcb2fcd9c6103$export$6a861cde3ab663c8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  width: 200px;
`;
const $f68fcb2fcd9c6103$export$99d9fbaae75677b8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $f68fcb2fcd9c6103$export$46a8c87cc0d102d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 20px;
  font-weight: 600;

  text-align: center;
`;
const $f68fcb2fcd9c6103$export$c67cd974b35e2ed8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 16px;
  font-weight: 400;

  text-align: center;
`;
const $f68fcb2fcd9c6103$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  padding: 30px 0;
`;


function $9c4e8fb083423408$var$EmptyTablePlaceholder(props) {
    const { setFilter: setFilter, title: title, content: content } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f68fcb2fcd9c6103$export$304c5d81524150ee), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f68fcb2fcd9c6103$export$6a861cde3ab663c8), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a18cc772f37d0119$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f68fcb2fcd9c6103$export$99d9fbaae75677b8), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f68fcb2fcd9c6103$export$46a8c87cc0d102d6), {
                        children: title || "No search result"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f68fcb2fcd9c6103$export$c67cd974b35e2ed8), {
                        children: content || "Please, try a different combination of filters"
                    }),
                    setFilter && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f68fcb2fcd9c6103$export$d53c836cccbb0d90), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            onClick: ()=>setFilter(),
                            children: "Reset Filters"
                        })
                    })
                ]
            })
        ]
    });
}
// Default Props
$9c4e8fb083423408$var$EmptyTablePlaceholder.defaultProps = {
    setFilter: null,
    title: "",
    content: ""
};
// Proptypes Validation
$9c4e8fb083423408$var$EmptyTablePlaceholder.propTypes = {
    setFilter: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    content: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $9c4e8fb083423408$export$2e2bcd8739ae039 = $9c4e8fb083423408$var$EmptyTablePlaceholder;


var $a6ea3b0f3caed586$export$2e2bcd8739ae039 = (0, $9c4e8fb083423408$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

const $8b917fb29beb5fce$export$a966b54425251788 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 140px 0px;
`;



function $80b568fc662f2449$var$LoadingTablePlaceholder(props) {
    const { ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8b917fb29beb5fce$export$a966b54425251788), {
        ...rest,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6fa6c8d0625529f$export$2e2bcd8739ae039), {})
    });
}
// Default Props
$80b568fc662f2449$var$LoadingTablePlaceholder.defaultProps = {};
// Proptypes Validation
$80b568fc662f2449$var$LoadingTablePlaceholder.propTypes = {};
var $80b568fc662f2449$export$2e2bcd8739ae039 = $80b568fc662f2449$var$LoadingTablePlaceholder;


var $647b8bc68ebce54f$export$2e2bcd8739ae039 = (0, $80b568fc662f2449$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $j1NUG = parcelRequire("j1NUG");


var $tZqWC = parcelRequire("tZqWC");

function $e36291aa02fe850c$var$toVal(mix) {
    var k, y, str = "";
    if (typeof mix === "string" || typeof mix === "number") str += mix;
    else if (typeof mix === "object") {
        if (Array.isArray(mix)) for(k = 0; k < mix.length; k++){
            if (mix[k]) {
                if (y = $e36291aa02fe850c$var$toVal(mix[k])) {
                    str && (str += " ");
                    str += y;
                }
            }
        }
        else {
            for(k in mix)if (mix[k]) {
                str && (str += " ");
                str += k;
            }
        }
    }
    return str;
}
function $e36291aa02fe850c$export$2e2bcd8739ae039() {
    var i = 0, tmp, x, str = "";
    while(i < arguments.length){
        if (tmp = arguments[i++]) {
            if (x = $e36291aa02fe850c$var$toVal(tmp)) {
                str && (str += " ");
                str += x;
            }
        }
    }
    return str;
}




var $j1NUG = parcelRequire("j1NUG");

var $j1NUG = parcelRequire("j1NUG");


var $tZqWC = parcelRequire("tZqWC");


var $7g5pF = parcelRequire("7g5pF");



var $j1NUG = parcelRequire("j1NUG");

var $tZqWC = parcelRequire("tZqWC");

var $4Z4HE = parcelRequire("4Z4HE");

var $j1NUG = parcelRequire("j1NUG");

function $7c568fbb311ac859$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var baseClasses = options.baseClasses, newClasses = options.newClasses, Component = options.Component;
    if (!newClasses) return baseClasses;
    var nextClasses = (0, $j1NUG.default)({}, baseClasses);
    Object.keys(newClasses).forEach(function(key) {
        if (newClasses[key]) nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    });
    return nextClasses;
}


// Used https://github.com/thinkloop/multi-key-cache as inspiration
var $df988647f3f9d2d5$var$multiKeyStore = {
    set: function set(cache, key1, key2, value) {
        var subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: function get(cache, key1, key2) {
        var subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: function _delete(cache, key1, key2) {
        var subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $df988647f3f9d2d5$export$2e2bcd8739ae039 = $df988647f3f9d2d5$var$multiKeyStore;




/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var $49a3a6e9c0cc142b$var$indexCounter = -1000000000;
function $49a3a6e9c0cc142b$export$a2647aa13413c947() {
    $49a3a6e9c0cc142b$var$indexCounter += 1;
    return $49a3a6e9c0cc142b$var$indexCounter;
}



var $j1NUG = parcelRequire("j1NUG");



function $d0297faabdef5766$export$2e2bcd8739ae039(stylesOrCreator) {
    var themingEnabled = typeof stylesOrCreator === "function";
    return {
        create: function create(theme, name) {
            var styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.overrides || !theme.overrides[name]) return styles;
            var overrides = theme.overrides[name];
            var stylesWithOverrides = (0, $j1NUG.default)({}, styles);
            Object.keys(overrides).forEach(function(key) {
                stylesWithOverrides[key] = (0, $04bac6f1fa6ae0d7$export$2e2bcd8739ae039)(stylesWithOverrides[key], overrides[key]);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}


// We use the same empty object to ref count the styles that don't need a theme object.
var $c92bd3ff9c5ca066$var$noopTheme = {};
var $c92bd3ff9c5ca066$export$2e2bcd8739ae039 = $c92bd3ff9c5ca066$var$noopTheme;


function $2d973182ee16abac$var$getClasses(_ref, classes, Component) {
    var state = _ref.state, stylesOptions = _ref.stylesOptions;
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
     // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    var generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $7c568fbb311ac859$export$2e2bcd8739ae039)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $2d973182ee16abac$var$attach(_ref2, props) {
    var state = _ref2.state, theme = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $df988647f3f9d2d5$export$2e2bcd8739ae039).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $df988647f3f9d2d5$export$2e2bcd8739ae039).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    var options = (0, $j1NUG.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === "boolean" ? stylesOptions.flip : theme.direction === "rtl"
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        var staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $df988647f3f9d2d5$export$2e2bcd8739ae039).get(stylesOptions.sheetsCache, stylesCreator, theme);
        var styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $j1NUG.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $df988647f3f9d2d5$export$2e2bcd8739ae039).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $4Z4HE.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $j1NUG.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $7c568fbb311ac859$export$2e2bcd8739ae039)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $2d973182ee16abac$var$update(_ref3, props) {
    var state = _ref3.state;
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $2d973182ee16abac$var$detach(_ref4) {
    var state = _ref4.state, theme = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $df988647f3f9d2d5$export$2e2bcd8739ae039).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $df988647f3f9d2d5$export$2e2bcd8739ae039).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $2d973182ee16abac$var$useSynchronousEffect(func, values) {
    var key = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useRef([]);
    var output; // Store "generation" key. Just returns a new object every time
    var currentKey = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useMemo(function() {
        return {};
    }, values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useEffect(function() {
        return function() {
            if (output) output();
        };
    }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $2d973182ee16abac$export$2e2bcd8739ae039(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = options.name, classNamePrefixOption = options.classNamePrefix, Component = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme = _options$defaultTheme === void 0 ? (0, $c92bd3ff9c5ca066$export$2e2bcd8739ae039) : _options$defaultTheme, stylesOptions2 = (0, $636333a0deecc159$export$2e2bcd8739ae039)(options, [
        "name",
        "classNamePrefix",
        "Component",
        "defaultTheme"
    ]);
    var stylesCreator = (0, $d0297faabdef5766$export$2e2bcd8739ae039)(stylesOrCreator);
    var classNamePrefix = name || classNamePrefixOption || "makeStyles";
    stylesCreator.options = {
        index: (0, $49a3a6e9c0cc142b$export$a2647aa13413c947)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    var useStyles = function useStyles() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var theme = (0, $8610d05fa52a0f79$export$2e2bcd8739ae039)() || defaultTheme;
        var stylesOptions = (0, $j1NUG.default)({}, (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useContext((0, $e19cddf4a31c4c83$export$f4de434b269fe487)), stylesOptions2);
        var instance = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useRef();
        var shouldUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useRef();
        $2d973182ee16abac$var$useSynchronousEffect(function() {
            var current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $2d973182ee16abac$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return function() {
                $2d973182ee16abac$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useEffect(function() {
            if (shouldUpdate.current) $2d973182ee16abac$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        var classes = $2d973182ee16abac$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}


/* eslint-disable no-restricted-syntax */ function $0d1f5bbd82cd1622$export$2e2bcd8739ae039(params) {
    var theme = params.theme, name = params.name, props = params.props;
    if (!theme || !theme.props || !theme.props[name]) return props;
     // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    var defaultProps = theme.props[name];
    var propName;
    for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
    return props;
}



// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var $13f7c8f6c6f6f480$var$withStyles = function withStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(Component) {
        var defaultTheme = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = (0, $636333a0deecc159$export$2e2bcd8739ae039)(options, [
            "defaultTheme",
            "withTheme",
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var useStyles = (0, $2d973182ee16abac$export$2e2bcd8739ae039)(stylesOrCreator, (0, $j1NUG.default)({
            defaultTheme: defaultTheme,
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var WithStyles = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).forwardRef(function WithStyles(props, ref) {
            var classesProp = props.classes, innerRef = props.innerRef, other = (0, $636333a0deecc159$export$2e2bcd8739ae039)(props, [
                "classes",
                "innerRef"
            ]); // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            var classes = useStyles((0, $j1NUG.default)({}, Component.defaultProps, props));
            var theme;
            var more = other;
            if (typeof name === "string" || withTheme) {
                // name and withTheme are invariant in the outer scope
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = (0, $8610d05fa52a0f79$export$2e2bcd8739ae039)() || defaultTheme;
                if (name) more = (0, $0d1f5bbd82cd1622$export$2e2bcd8739ae039)({
                    theme: theme,
                    name: name,
                    props: other
                });
                 // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Component, (0, $j1NUG.default)({
                ref: innerRef || ref,
                classes: classes
            }, more));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($7g5pF)))(WithStyles, Component);
        return WithStyles;
    };
};
var $13f7c8f6c6f6f480$export$2e2bcd8739ae039 = $13f7c8f6c6f6f480$var$withStyles;



var $0c1626483bb70d5c$var$defaultTheme = (0, $e0ad99f052315c23$export$2e2bcd8739ae039)();
var $0c1626483bb70d5c$export$2e2bcd8739ae039 = $0c1626483bb70d5c$var$defaultTheme;


function $874b89081beb3c93$var$withStyles(stylesOrCreator, options) {
    return (0, $13f7c8f6c6f6f480$export$2e2bcd8739ae039)(stylesOrCreator, (0, $j1NUG.default)({
        defaultTheme: (0, $0c1626483bb70d5c$export$2e2bcd8739ae039)
    }, options));
}
var $874b89081beb3c93$export$2e2bcd8739ae039 = $874b89081beb3c93$var$withStyles;




var $j1NUG = parcelRequire("j1NUG");


var $tZqWC = parcelRequire("tZqWC");





var $tZqWC = parcelRequire("tZqWC");
// TODO v5: consider to make it private
function $c8c06050dfa174b6$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


function $7e459a01419f96d3$export$2e2bcd8739ae039(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */ return $tZqWC.useMemo(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            (0, $c8c06050dfa174b6$export$2e2bcd8739ae039)(refA, refValue);
            (0, $c8c06050dfa174b6$export$2e2bcd8739ae039)(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}



var $tZqWC = parcelRequire("tZqWC");
var $39d8c0112ee28bf4$var$useEnhancedEffect = typeof window !== "undefined" ? $tZqWC.useLayoutEffect : $tZqWC.useEffect;
function $39d8c0112ee28bf4$export$2e2bcd8739ae039(fn) {
    var ref = $tZqWC.useRef(fn);
    $39d8c0112ee28bf4$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return $tZqWC.useCallback(function() {
        return (0, ref.current).apply(void 0, arguments);
    }, []);
}




// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $tZqWC = parcelRequire("tZqWC");

var $c1eee5c552f6f036$var$hadKeyboardEvent = true;
var $c1eee5c552f6f036$var$hadFocusVisibleRecently = false;
var $c1eee5c552f6f036$var$hadFocusVisibleRecentlyTimeout = null;
var $c1eee5c552f6f036$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */ function $c1eee5c552f6f036$var$focusTriggersKeyboardModality(node) {
    var type = node.type, tagName = node.tagName;
    if (tagName === "INPUT" && $c1eee5c552f6f036$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $c1eee5c552f6f036$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $c1eee5c552f6f036$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $c1eee5c552f6f036$var$handlePointerDown() {
    $c1eee5c552f6f036$var$hadKeyboardEvent = false;
}
function $c1eee5c552f6f036$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($c1eee5c552f6f036$var$hadFocusVisibleRecently) $c1eee5c552f6f036$var$hadKeyboardEvent = true;
    }
}
function $c1eee5c552f6f036$var$prepare(doc) {
    doc.addEventListener("keydown", $c1eee5c552f6f036$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $c1eee5c552f6f036$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $c1eee5c552f6f036$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $c1eee5c552f6f036$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $c1eee5c552f6f036$var$handleVisibilityChange, true);
}
function $c1eee5c552f6f036$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $c1eee5c552f6f036$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $c1eee5c552f6f036$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $c1eee5c552f6f036$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $c1eee5c552f6f036$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $c1eee5c552f6f036$var$handleVisibilityChange, true);
}
function $c1eee5c552f6f036$var$isFocusVisible(event) {
    var target = event.target;
    try {
        return target.matches(":focus-visible");
    } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    // no need for validFocusTarget check. the user does that by attaching it to
    // focusable events only
    return $c1eee5c552f6f036$var$hadKeyboardEvent || $c1eee5c552f6f036$var$focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */ function $c1eee5c552f6f036$var$handleBlurVisible() {
    // To detect a tab/window switch, we look for a blur event followed
    // rapidly by a visibility change.
    // If we don't see a visibility change within 100ms, it's probably a
    // regular focus change.
    $c1eee5c552f6f036$var$hadFocusVisibleRecently = true;
    window.clearTimeout($c1eee5c552f6f036$var$hadFocusVisibleRecentlyTimeout);
    $c1eee5c552f6f036$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
        $c1eee5c552f6f036$var$hadFocusVisibleRecently = false;
    }, 100);
}
function $c1eee5c552f6f036$export$2e2bcd8739ae039() {
    var ref = $tZqWC.useCallback(function(instance) {
        var node = $f419cfc3d92fe631$exports.findDOMNode(instance);
        if (node != null) $c1eee5c552f6f036$var$prepare(node.ownerDocument);
    }, []);
    return {
        isFocusVisible: $c1eee5c552f6f036$var$isFocusVisible,
        onBlurVisible: $c1eee5c552f6f036$var$handleBlurVisible,
        ref: ref
    };
}



var $j1NUG = parcelRequire("j1NUG");



var $tZqWC = parcelRequire("tZqWC");


var $cGhSa = parcelRequire("cGhSa");

var $j1NUG = parcelRequire("j1NUG");

var $an7Fk = parcelRequire("an7Fk");

var $1gxF5 = parcelRequire("1gxF5");


var $tZqWC = parcelRequire("tZqWC");


var $tZqWC = parcelRequire("tZqWC");
function $68acb55b6931daae$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $tZqWC.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $tZqWC.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $68acb55b6931daae$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $68acb55b6931daae$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $68acb55b6931daae$export$fa71e2345c31d7a2(props, onExited) {
    return $68acb55b6931daae$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $tZqWC.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $68acb55b6931daae$var$getProp(child, "appear", props),
            enter: $68acb55b6931daae$var$getProp(child, "enter", props),
            exit: $68acb55b6931daae$var$getProp(child, "exit", props)
        });
    });
}
function $68acb55b6931daae$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $68acb55b6931daae$export$bbc8a025727ea824(nextProps.children);
    var children = $68acb55b6931daae$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $tZqWC.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $tZqWC.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $tZqWC.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $68acb55b6931daae$var$getProp(child, "exit", nextProps),
            enter: $68acb55b6931daae$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $tZqWC.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $tZqWC.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $tZqWC.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $68acb55b6931daae$var$getProp(child, "exit", nextProps),
            enter: $68acb55b6931daae$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $56d9a09e565f3e99$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $56d9a09e565f3e99$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $56d9a09e565f3e99$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $1gxF5.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $an7Fk.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $68acb55b6931daae$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $68acb55b6931daae$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $68acb55b6931daae$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $j1NUG.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $cGhSa.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $56d9a09e565f3e99$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement((0, $f1f6c674a64aba6a$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement((0, $f1f6c674a64aba6a$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component);
$56d9a09e565f3e99$var$TransitionGroup.propTypes = {};
$56d9a09e565f3e99$var$TransitionGroup.defaultProps = $56d9a09e565f3e99$var$defaultProps;
var $56d9a09e565f3e99$export$2e2bcd8739ae039 = $56d9a09e565f3e99$var$TransitionGroup;





var $tZqWC = parcelRequire("tZqWC");



var $ce7754a844cc8e80$var$useEnhancedEffect = typeof window === "undefined" ? $tZqWC.useEffect : $tZqWC.useLayoutEffect;
/**
 * @ignore - internal component.
 */ function $ce7754a844cc8e80$var$Ripple(props) {
    var classes = props.classes, _props$pulsate = props.pulsate, pulsate = _props$pulsate === void 0 ? false : _props$pulsate, rippleX = props.rippleX, rippleY = props.rippleY, rippleSize = props.rippleSize, inProp = props.in, _props$onExited = props.onExited, onExited = _props$onExited === void 0 ? function() {} : _props$onExited, timeout = props.timeout;
    var _React$useState = $tZqWC.useState(false), leaving = _React$useState[0], setLeaving = _React$useState[1];
    var rippleClassName = (0, $e36291aa02fe850c$export$2e2bcd8739ae039)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    var childClassName = (0, $e36291aa02fe850c$export$2e2bcd8739ae039)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    var handleExited = (0, $39d8c0112ee28bf4$export$2e2bcd8739ae039)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
    $ce7754a844cc8e80$var$useEnhancedEffect(function() {
        if (!inProp) {
            // react-transition-group#onExit
            setLeaving(true); // react-transition-group#onExited
            var timeoutId = setTimeout(handleExited, timeout);
            return function() {
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        handleExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ $tZqWC.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
    }, /*#__PURE__*/ $tZqWC.createElement("span", {
        className: childClassName
    }));
}
var $ce7754a844cc8e80$export$2e2bcd8739ae039 = $ce7754a844cc8e80$var$Ripple;


var $3855715fe42272b2$var$DURATION = 550;
var $3855715fe42272b2$export$95d0c9356b2231a3 = 80;
var $3855715fe42272b2$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: "hidden",
            pointerEvents: "none",
            position: "absolute",
            zIndex: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: "inherit"
        },
        /* Styles applied to the internal `Ripple` components `ripple` class. */ ripple: {
            opacity: 0,
            position: "absolute"
        },
        /* Styles applied to the internal `Ripple` components `rippleVisible` class. */ rippleVisible: {
            opacity: 0.3,
            transform: "scale(1)",
            animation: "$enter ".concat($3855715fe42272b2$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */ ripplePulsate: {
            animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
        },
        /* Styles applied to the internal `Ripple` components `child` class. */ child: {
            opacity: 1,
            display: "block",
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            backgroundColor: "currentColor"
        },
        /* Styles applied to the internal `Ripple` components `childLeaving` class. */ childLeaving: {
            opacity: 0,
            animation: "$exit ".concat($3855715fe42272b2$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `childPulsate` class. */ childPulsate: {
            position: "absolute",
            left: 0,
            top: 0,
            animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
        },
        "@keyframes enter": {
            "0%": {
                transform: "scale(0)",
                opacity: 0.1
            },
            "100%": {
                transform: "scale(1)",
                opacity: 0.3
            }
        },
        "@keyframes exit": {
            "0%": {
                opacity: 1
            },
            "100%": {
                opacity: 0
            }
        },
        "@keyframes pulsate": {
            "0%": {
                transform: "scale(1)"
            },
            "50%": {
                transform: "scale(0.92)"
            },
            "100%": {
                transform: "scale(1)"
            }
        }
    };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ var $3855715fe42272b2$var$TouchRipple = /*#__PURE__*/ $tZqWC.forwardRef(function TouchRipple(props, ref) {
    var _props$center = props.center, centerProp = _props$center === void 0 ? false : _props$center, classes = props.classes, className = props.className, other = (0, $636333a0deecc159$export$2e2bcd8739ae039)(props, [
        "center",
        "classes",
        "className"
    ]);
    var _React$useState = $tZqWC.useState([]), ripples = _React$useState[0], setRipples = _React$useState[1];
    var nextKey = $tZqWC.useRef(0);
    var rippleCallback = $tZqWC.useRef(null);
    $tZqWC.useEffect(function() {
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]); // Used to filter out mouse emulated events on mobile.
    var ignoringMouseDown = $tZqWC.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    var startTimer = $tZqWC.useRef(null); // This is the hook called once the previous timeout is ready.
    var startTimerCommit = $tZqWC.useRef(null);
    var container = $tZqWC.useRef(null);
    $tZqWC.useEffect(function() {
        return function() {
            clearTimeout(startTimer.current);
        };
    }, []);
    var startCommit = $tZqWC.useCallback(function(params) {
        var pulsate = params.pulsate, rippleX = params.rippleX, rippleY = params.rippleY, rippleSize = params.rippleSize, cb = params.cb;
        setRipples(function(oldRipples) {
            return [].concat((0, $cc85964c3bb5b33f$export$2e2bcd8739ae039)(oldRipples), [
                /*#__PURE__*/ $tZqWC.createElement((0, $ce7754a844cc8e80$export$2e2bcd8739ae039), {
                    key: nextKey.current,
                    classes: classes,
                    timeout: $3855715fe42272b2$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                })
            ]);
        });
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    var start = $tZqWC.useCallback(function() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cb = arguments.length > 2 ? arguments[2] : undefined;
        var _options$pulsate = options.pulsate, pulsate = _options$pulsate === void 0 ? false : _options$pulsate, _options$center = options.center, center = _options$center === void 0 ? centerProp || options.pulsate : _options$center, _options$fakeElement = options.fakeElement, fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
        if (event.type === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event.type === "touchstart") ignoringMouseDown.current = true;
        var element = fakeElement ? null : container.current;
        var rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        }; // Get the size of the ripple
        var rippleX;
        var rippleY;
        var rippleSize;
        if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            var _ref = event.touches ? event.touches[0] : event, clientX = _ref.clientX, clientY = _ref.clientY;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
        } // Touche devices
        if (event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = function() {
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                }; // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(function() {
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $3855715fe42272b2$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    var pulsate = $tZqWC.useCallback(function() {
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    var stop = $tZqWC.useCallback(function(event, cb) {
        clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event.type === "touchend" && startTimerCommit.current) {
            event.persist();
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(function() {
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples(function(oldRipples) {
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $tZqWC.useImperativeHandle(ref, function() {
        return {
            pulsate: pulsate,
            start: start,
            stop: stop
        };
    }, [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ $tZqWC.createElement("span", (0, $j1NUG.default)({
        className: (0, $e36291aa02fe850c$export$2e2bcd8739ae039)(classes.root, className),
        ref: container
    }, other), /*#__PURE__*/ $tZqWC.createElement((0, $56d9a09e565f3e99$export$2e2bcd8739ae039), {
        component: null,
        exit: true
    }, ripples));
});
var $3855715fe42272b2$export$2e2bcd8739ae039 = (0, $874b89081beb3c93$export$2e2bcd8739ae039)($3855715fe42272b2$export$9dd6ff9ea0189349, {
    flip: false,
    name: "MuiTouchRipple"
})(/*#__PURE__*/ $tZqWC.memo($3855715fe42272b2$var$TouchRipple));


var $df6497400ddf2e42$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        "-moz-appearance": "none",
        // Reset
        "-webkit-appearance": "none",
        // Reset
        textDecoration: "none",
        // So we take precedent over the style of a native <a /> element.
        color: "inherit",
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        "&$disabled": {
            pointerEvents: "none",
            // Disable link interactions
            cursor: "default"
        },
        "@media print": {
            colorAdjust: "exact"
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
    /* Pseudo-class applied to the root element if keyboard focused. */ focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ var $df6497400ddf2e42$var$ButtonBase = /*#__PURE__*/ $tZqWC.forwardRef(function ButtonBase(props, ref) {
    var action = props.action, buttonRefProp = props.buttonRef, _props$centerRipple = props.centerRipple, centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple, children = props.children, classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$disableTouchRi = props.disableTouchRipple, disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi, _props$focusRipple = props.focusRipple, focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple, focusVisibleClassName = props.focusVisibleClassName, onBlur = props.onBlur, onClick = props.onClick, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, onDragLeave = props.onDragLeave, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, TouchRippleProps = props.TouchRippleProps, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, other = (0, $636333a0deecc159$export$2e2bcd8739ae039)(props, [
        "action",
        "buttonRef",
        "centerRipple",
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "disableRipple",
        "disableTouchRipple",
        "focusRipple",
        "focusVisibleClassName",
        "onBlur",
        "onClick",
        "onFocus",
        "onFocusVisible",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onMouseLeave",
        "onMouseUp",
        "onTouchEnd",
        "onTouchMove",
        "onTouchStart",
        "onDragLeave",
        "tabIndex",
        "TouchRippleProps",
        "type"
    ]);
    var buttonRef = $tZqWC.useRef(null);
    function getButtonNode() {
        // #StrictMode ready
        return $f419cfc3d92fe631$exports.findDOMNode(buttonRef.current);
    }
    var rippleRef = $tZqWC.useRef(null);
    var _React$useState = $tZqWC.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    if (disabled && focusVisible) setFocusVisible(false);
    var _useIsFocusVisible = (0, $c1eee5c552f6f036$export$2e2bcd8739ae039)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    $tZqWC.useImperativeHandle(action, function() {
        return {
            focusVisible: function focusVisible() {
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        };
    }, []);
    $tZqWC.useEffect(function() {
        if (focusVisible && focusRipple && !disableRipple) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible
    ]);
    function useRippleHandler(rippleAction, eventCallback) {
        var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
        return (0, $39d8c0112ee28bf4$export$2e2bcd8739ae039)(function(event) {
            if (eventCallback) eventCallback(event);
            var ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    var handleMouseDown = useRippleHandler("start", onMouseDown);
    var handleDragLeave = useRippleHandler("stop", onDragLeave);
    var handleMouseUp = useRippleHandler("stop", onMouseUp);
    var handleMouseLeave = useRippleHandler("stop", function(event) {
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    var handleTouchStart = useRippleHandler("start", onTouchStart);
    var handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    var handleTouchMove = useRippleHandler("stop", onTouchMove);
    var handleBlur = useRippleHandler("stop", function(event) {
        if (focusVisible) {
            onBlurVisible(event);
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    }, false);
    var handleFocus = (0, $39d8c0112ee28bf4$export$2e2bcd8739ae039)(function(event) {
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if (isFocusVisible(event)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    var isNonNativeButton = function isNonNativeButton() {
        var button = getButtonNode();
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ var keydownRef = $tZqWC.useRef(false);
    var handleKeyDown = (0, $39d8c0112ee28bf4$export$2e2bcd8739ae039)(function(event) {
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
         // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    var handleKeyUp = (0, $39d8c0112ee28bf4$export$2e2bcd8739ae039)(function(event) {
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
         // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    var ComponentProp = component;
    if (ComponentProp === "button" && other.href) ComponentProp = "a";
    var buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type;
        buttonProps.disabled = disabled;
    } else {
        if (ComponentProp !== "a" || !other.href) buttonProps.role = "button";
        buttonProps["aria-disabled"] = disabled;
    }
    var handleUserRef = (0, $7e459a01419f96d3$export$2e2bcd8739ae039)(buttonRefProp, ref);
    var handleOwnRef = (0, $7e459a01419f96d3$export$2e2bcd8739ae039)(focusVisibleRef, buttonRef);
    var handleRef = (0, $7e459a01419f96d3$export$2e2bcd8739ae039)(handleUserRef, handleOwnRef);
    var _React$useState2 = $tZqWC.useState(false), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    $tZqWC.useEffect(function() {
        setMountedState(true);
    }, []);
    var enableTouchRipple = mountedState && !disableRipple && !disabled;
    return /*#__PURE__*/ $tZqWC.createElement(ComponentProp, (0, $j1NUG.default)({
        className: (0, $e36291aa02fe850c$export$2e2bcd8739ae039)(classes.root, className, focusVisible && [
            classes.focusVisible,
            focusVisibleClassName
        ], disabled && classes.disabled),
        onBlur: handleBlur,
        onClick: onClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex
    }, buttonProps, other), children, enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ $tZqWC.createElement((0, $3855715fe42272b2$export$2e2bcd8739ae039), (0, $j1NUG.default)({
        ref: rippleRef,
        center: centerRipple
    }, TouchRippleProps)) : null);
});
var $df6497400ddf2e42$export$2e2bcd8739ae039 = (0, $874b89081beb3c93$export$2e2bcd8739ae039)($df6497400ddf2e42$export$9dd6ff9ea0189349, {
    name: "MuiButtonBase"
})($df6497400ddf2e42$var$ButtonBase);



function $b8dee6a068c54130$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $6e0d87268766b68e$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}


var $f045e7afb70ff9d3$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            textAlign: "center",
            flex: "0 0 auto",
            fontSize: theme.typography.pxToRem(24),
            padding: 12,
            borderRadius: "50%",
            overflow: "visible",
            // Explicitly set the default value to solve a bug on IE 11.
            color: theme.palette.action.active,
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shortest
            }),
            "&:hover": {
                backgroundColor: (0, $355c8a6a53929a53$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                backgroundColor: "transparent",
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `edge="start"`. */ edgeStart: {
            marginLeft: -12,
            "$sizeSmall&": {
                marginLeft: -3
            }
        },
        /* Styles applied to the root element if `edge="end"`. */ edgeEnd: {
            marginRight: -12,
            "$sizeSmall&": {
                marginRight: -3
            }
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: (0, $355c8a6a53929a53$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: (0, $355c8a6a53929a53$export$58f0f39f63f3cf42)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: 3,
            fontSize: theme.typography.pxToRem(18)
        },
        /* Styles applied to the children container element. */ label: {
            width: "100%",
            display: "flex",
            alignItems: "inherit",
            justifyContent: "inherit"
        }
    };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */ var $f045e7afb70ff9d3$var$IconButton = /*#__PURE__*/ $tZqWC.forwardRef(function IconButton(props, ref) {
    var _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0, $636333a0deecc159$export$2e2bcd8739ae039)(props, [
        "edge",
        "children",
        "classes",
        "className",
        "color",
        "disabled",
        "disableFocusRipple",
        "size"
    ]);
    return /*#__PURE__*/ $tZqWC.createElement((0, $df6497400ddf2e42$export$2e2bcd8739ae039), (0, $j1NUG.default)({
        className: (0, $e36291aa02fe850c$export$2e2bcd8739ae039)(classes.root, className, color !== "default" && classes["color".concat((0, $b8dee6a068c54130$export$2e2bcd8739ae039)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, $b8dee6a068c54130$export$2e2bcd8739ae039)(size))], {
            "start": classes.edgeStart,
            "end": classes.edgeEnd
        }[edge]),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other), /*#__PURE__*/ $tZqWC.createElement("span", {
        className: classes.label
    }, children));
});
var $f045e7afb70ff9d3$export$2e2bcd8739ae039 = (0, $874b89081beb3c93$export$2e2bcd8739ae039)($f045e7afb70ff9d3$export$9dd6ff9ea0189349, {
    name: "MuiIconButton"
})($f045e7afb70ff9d3$var$IconButton);







var $j1NUG = parcelRequire("j1NUG");

var $tZqWC = parcelRequire("tZqWC");





var $tZqWC = parcelRequire("tZqWC");


function $3d975f2378953cd0$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}





function $0ef74dfb36172892$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $0ef74dfb36172892$var$clickedRootScrollbar(event) {
    return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */ function $0ef74dfb36172892$var$ClickAwayListener(props) {
    var children = props.children, _props$disableReactTr = props.disableReactTree, disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr, _props$mouseEvent = props.mouseEvent, mouseEvent = _props$mouseEvent === void 0 ? "onClick" : _props$mouseEvent, onClickAway = props.onClickAway, _props$touchEvent = props.touchEvent, touchEvent = _props$touchEvent === void 0 ? "onTouchEnd" : _props$touchEvent;
    var movedRef = $tZqWC.useRef(false);
    var nodeRef = $tZqWC.useRef(null);
    var activatedRef = $tZqWC.useRef(false);
    var syntheticEventRef = $tZqWC.useRef(false);
    $tZqWC.useEffect(function() {
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(function() {
            activatedRef.current = true;
        }, 0);
        return function() {
            activatedRef.current = false;
        };
    }, []); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $tZqWC.useCallback(function(instance) {
        // #StrictMode ready
        nodeRef.current = $f419cfc3d92fe631$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $7e459a01419f96d3$export$2e2bcd8739ae039)(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviours like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    var handleClickAway = (0, $39d8c0112ee28bf4$export$2e2bcd8739ae039)(function(event) {
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        var insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || $0ef74dfb36172892$var$clickedRootScrollbar(event)) return;
         // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else {
            // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
            var doc = (0, $3d975f2378953cd0$export$2e2bcd8739ae039)(nodeRef.current);
            insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        }
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    }); // Keep track of mouse/touch events that bubbled up through the portal.
    var createHandleSynthetic = function createHandleSynthetic(handlerName) {
        return function(event) {
            syntheticEventRef.current = true;
            var childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    };
    var childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $tZqWC.useEffect(function() {
        if (touchEvent !== false) {
            var mappedTouchEvent = $0ef74dfb36172892$var$mapEventPropToEvent(touchEvent);
            var doc = (0, $3d975f2378953cd0$export$2e2bcd8739ae039)(nodeRef.current);
            var handleTouchMove = function handleTouchMove() {
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return function() {
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $tZqWC.useEffect(function() {
        if (mouseEvent !== false) {
            var mappedMouseEvent = $0ef74dfb36172892$var$mapEventPropToEvent(mouseEvent);
            var doc = (0, $3d975f2378953cd0$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return function() {
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $tZqWC.createElement($tZqWC.Fragment, null, /*#__PURE__*/ $tZqWC.cloneElement(children, childrenProps));
}
var $0ef74dfb36172892$export$2e2bcd8739ae039 = $0ef74dfb36172892$var$ClickAwayListener;




/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $b710cd9a00dda165$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    return funcs.reduce(function(acc, func) {
        if (func == null) return acc;
        return function chainedFunction() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, function() {});
}




var $j1NUG = parcelRequire("j1NUG");



var $tZqWC = parcelRequire("tZqWC");



parcelRequire("tZqWC");

function $8e87f4aa209ae0c1$export$2e2bcd8739ae039() {
    var theme = (0, $8610d05fa52a0f79$export$2e2bcd8739ae039)() || (0, $0c1626483bb70d5c$export$2e2bcd8739ae039);
    return theme;
}


var $e773cce81cf3ac98$export$b7a864e1eaef9de5 = function reflow(node) {
    return node.scrollTop;
};
function $e773cce81cf3ac98$export$8cb1e9b404609ae9(props, options) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style;
    return {
        duration: style.transitionDuration || typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        delay: style.transitionDelay
    };
}



function $a053770fc19fabb1$var$getScale(value) {
    return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}
var $a053770fc19fabb1$var$styles = {
    entering: {
        opacity: 1,
        transform: $a053770fc19fabb1$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $a053770fc19fabb1$var$Grow = /*#__PURE__*/ $tZqWC.forwardRef(function Grow(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? "auto" : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $a648815ae929180c$export$2e2bcd8739ae039) : _props$TransitionComp, other = (0, $636333a0deecc159$export$2e2bcd8739ae039)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var timer = $tZqWC.useRef();
    var autoTimeout = $tZqWC.useRef();
    var theme = (0, $8e87f4aa209ae0c1$export$2e2bcd8739ae039)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $tZqWC.useRef(null);
    var foreignRef = (0, $7e459a01419f96d3$export$2e2bcd8739ae039)(children.ref, ref);
    var handleRef = (0, $7e459a01419f96d3$export$2e2bcd8739ae039)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $e6b4a46368942149$export$2e2bcd8739ae039)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $e773cce81cf3ac98$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        var _getTransitionProps = (0, $e773cce81cf3ac98$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: "enter"
        }), transitionDuration = _getTransitionProps.duration, delay = _getTransitionProps.delay;
        var duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: duration * 0.666,
                delay: delay
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var _getTransitionProps2 = (0, $e773cce81cf3ac98$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: "exit"
        }), transitionDuration = _getTransitionProps2.duration, delay = _getTransitionProps2.delay;
        var duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: duration * 0.666,
                delay: delay || duration * 0.333
            })
        ].join(",");
        node.style.opacity = "0";
        node.style.transform = $a053770fc19fabb1$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
        var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
    };
    $tZqWC.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ $tZqWC.createElement(TransitionComponent, (0, $j1NUG.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: addEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $tZqWC.cloneElement(children, (0, $j1NUG.default)({
            style: (0, $j1NUG.default)({
                opacity: 0,
                transform: $a053770fc19fabb1$var$getScale(0.75),
                visibility: state === "exited" && !inProp ? "hidden" : undefined
            }, $a053770fc19fabb1$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
$a053770fc19fabb1$var$Grow.muiSupportAuto = true;
var $a053770fc19fabb1$export$2e2bcd8739ae039 = $a053770fc19fabb1$var$Grow;





var $j1NUG = parcelRequire("j1NUG");

var $tZqWC = parcelRequire("tZqWC");





var $j1NUG = parcelRequire("j1NUG");

var $tZqWC = parcelRequire("tZqWC");




var $fed5cd4d48f88561$export$9dd6ff9ea0189349 = function styles(theme) {
    var elevations = {};
    theme.shadows.forEach(function(shadow, index) {
        elevations["elevation".concat(index)] = {
            boxShadow: shadow
        };
    });
    return (0, $j1NUG.default)({
        /* Styles applied to the root element. */ root: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            transition: theme.transitions.create("box-shadow")
        },
        /* Styles applied to the root element if `square={false}`. */ rounded: {
            borderRadius: theme.shape.borderRadius
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            border: "1px solid ".concat(theme.palette.divider)
        }
    }, elevations);
};
var $fed5cd4d48f88561$var$Paper = /*#__PURE__*/ $tZqWC.forwardRef(function Paper(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$square = props.square, square = _props$square === void 0 ? false : _props$square, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 1 : _props$elevation, _props$variant = props.variant, variant = _props$variant === void 0 ? "elevation" : _props$variant, other = (0, $636333a0deecc159$export$2e2bcd8739ae039)(props, [
        "classes",
        "className",
        "component",
        "square",
        "elevation",
        "variant"
    ]);
    return /*#__PURE__*/ $tZqWC.createElement(Component, (0, $j1NUG.default)({
        className: (0, $e36291aa02fe850c$export$2e2bcd8739ae039)(classes.root, className, variant === "outlined" ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
        ref: ref
    }, other));
});
var $fed5cd4d48f88561$export$2e2bcd8739ae039 = (0, $874b89081beb3c93$export$2e2bcd8739ae039)($fed5cd4d48f88561$export$9dd6ff9ea0189349, {
    name: "MuiPaper"
})($fed5cd4d48f88561$var$Paper);



var $56e7a2c69b2143ba$export$9dd6ff9ea0189349 = function styles(theme) {
    var emphasis = theme.palette.type === "light" ? 0.8 : 0.98;
    var backgroundColor = (0, $355c8a6a53929a53$export$e665714f76e581fd)(theme.palette.background.default, emphasis);
    return {
        /* Styles applied to the root element. */ root: (0, $j1NUG.default)({}, theme.typography.body2, (0, $271d31b42c64d81e$export$2e2bcd8739ae039)({
            color: theme.palette.getContrastText(backgroundColor),
            backgroundColor: backgroundColor,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            padding: "6px 16px",
            borderRadius: theme.shape.borderRadius,
            flexGrow: 1
        }, theme.breakpoints.up("sm"), {
            flexGrow: "initial",
            minWidth: 288
        })),
        /* Styles applied to the message wrapper element. */ message: {
            padding: "8px 0"
        },
        /* Styles applied to the action wrapper element if `action` is provided. */ action: {
            display: "flex",
            alignItems: "center",
            marginLeft: "auto",
            paddingLeft: 16,
            marginRight: -8
        }
    };
};
var $56e7a2c69b2143ba$var$SnackbarContent = /*#__PURE__*/ $tZqWC.forwardRef(function SnackbarContent(props, ref) {
    var action = props.action, classes = props.classes, className = props.className, message = props.message, _props$role = props.role, role = _props$role === void 0 ? "alert" : _props$role, other = (0, $636333a0deecc159$export$2e2bcd8739ae039)(props, [
        "action",
        "classes",
        "className",
        "message",
        "role"
    ]);
    return /*#__PURE__*/ $tZqWC.createElement((0, $fed5cd4d48f88561$export$2e2bcd8739ae039), (0, $j1NUG.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $e36291aa02fe850c$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other), /*#__PURE__*/ $tZqWC.createElement("div", {
        className: classes.message
    }, message), action ? /*#__PURE__*/ $tZqWC.createElement("div", {
        className: classes.action
    }, action) : null);
});
var $56e7a2c69b2143ba$export$2e2bcd8739ae039 = (0, $874b89081beb3c93$export$2e2bcd8739ae039)($56e7a2c69b2143ba$export$9dd6ff9ea0189349, {
    name: "MuiSnackbarContent"
})($56e7a2c69b2143ba$var$SnackbarContent);


var $4bd613956274dc1d$export$9dd6ff9ea0189349 = function styles(theme) {
    var top1 = {
        top: 8
    };
    var bottom1 = {
        bottom: 8
    };
    var right = {
        justifyContent: "flex-end"
    };
    var left = {
        justifyContent: "flex-start"
    };
    var top3 = {
        top: 24
    };
    var bottom3 = {
        bottom: 24
    };
    var right3 = {
        right: 24
    };
    var left3 = {
        left: 24
    };
    var center = {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
    };
    return {
        /* Styles applied to the root element. */ root: {
            zIndex: theme.zIndex.snackbar,
            position: "fixed",
            display: "flex",
            left: 8,
            right: 8,
            justifyContent: "center",
            alignItems: "center"
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */ anchorOriginTopCenter: (0, $j1NUG.default)({}, top1, (0, $271d31b42c64d81e$export$2e2bcd8739ae039)({}, theme.breakpoints.up("sm"), (0, $j1NUG.default)({}, top3, center))),
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */ anchorOriginBottomCenter: (0, $j1NUG.default)({}, bottom1, (0, $271d31b42c64d81e$export$2e2bcd8739ae039)({}, theme.breakpoints.up("sm"), (0, $j1NUG.default)({}, bottom3, center))),
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */ anchorOriginTopRight: (0, $j1NUG.default)({}, top1, right, (0, $271d31b42c64d81e$export$2e2bcd8739ae039)({}, theme.breakpoints.up("sm"), (0, $j1NUG.default)({
            left: "auto"
        }, top3, right3))),
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */ anchorOriginBottomRight: (0, $j1NUG.default)({}, bottom1, right, (0, $271d31b42c64d81e$export$2e2bcd8739ae039)({}, theme.breakpoints.up("sm"), (0, $j1NUG.default)({
            left: "auto"
        }, bottom3, right3))),
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */ anchorOriginTopLeft: (0, $j1NUG.default)({}, top1, left, (0, $271d31b42c64d81e$export$2e2bcd8739ae039)({}, theme.breakpoints.up("sm"), (0, $j1NUG.default)({
            right: "auto"
        }, top3, left3))),
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */ anchorOriginBottomLeft: (0, $j1NUG.default)({}, bottom1, left, (0, $271d31b42c64d81e$export$2e2bcd8739ae039)({}, theme.breakpoints.up("sm"), (0, $j1NUG.default)({
            right: "auto"
        }, bottom3, left3)))
    };
};
var $4bd613956274dc1d$var$Snackbar = /*#__PURE__*/ $tZqWC.forwardRef(function Snackbar(props, ref) {
    var action = props.action, _props$anchorOrigin = props.anchorOrigin;
    _props$anchorOrigin = _props$anchorOrigin === void 0 ? {
        vertical: "bottom",
        horizontal: "center"
    } : _props$anchorOrigin;
    var vertical = _props$anchorOrigin.vertical, horizontal = _props$anchorOrigin.horizontal, _props$autoHideDurati = props.autoHideDuration, autoHideDuration = _props$autoHideDurati === void 0 ? null : _props$autoHideDurati, children = props.children, classes = props.classes, className = props.className, ClickAwayListenerProps = props.ClickAwayListenerProps, ContentProps = props.ContentProps, _props$disableWindowB = props.disableWindowBlurListener, disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB, message = props.message, onClose = props.onClose, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, open = props.open, resumeHideDuration = props.resumeHideDuration, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $a053770fc19fabb1$export$2e2bcd8739ae039) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? {
        enter: (0, $79cf0b50b6f9ce39$export$1f34108aa9eb96ab).enteringScreen,
        exit: (0, $79cf0b50b6f9ce39$export$1f34108aa9eb96ab).leavingScreen
    } : _props$transitionDura, TransitionProps = props.TransitionProps, other = (0, $636333a0deecc159$export$2e2bcd8739ae039)(props, [
        "action",
        "anchorOrigin",
        "autoHideDuration",
        "children",
        "classes",
        "className",
        "ClickAwayListenerProps",
        "ContentProps",
        "disableWindowBlurListener",
        "message",
        "onClose",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "onMouseEnter",
        "onMouseLeave",
        "open",
        "resumeHideDuration",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps"
    ]);
    var timerAutoHide = $tZqWC.useRef();
    var _React$useState = $tZqWC.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var handleClose = (0, $39d8c0112ee28bf4$export$2e2bcd8739ae039)(function() {
        if (onClose) onClose.apply(void 0, arguments);
    });
    var setAutoHideTimer = (0, $39d8c0112ee28bf4$export$2e2bcd8739ae039)(function(autoHideDurationParam) {
        if (!onClose || autoHideDurationParam == null) return;
        clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(function() {
            handleClose(null, "timeout");
        }, autoHideDurationParam);
    });
    $tZqWC.useEffect(function() {
        if (open) setAutoHideTimer(autoHideDuration);
        return function() {
            clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]); // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    var handlePause = function handlePause() {
        clearTimeout(timerAutoHide.current);
    }; // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    var handleResume = $tZqWC.useCallback(function() {
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    var handleMouseEnter = function handleMouseEnter(event) {
        if (onMouseEnter) onMouseEnter(event);
        handlePause();
    };
    var handleMouseLeave = function handleMouseLeave(event) {
        if (onMouseLeave) onMouseLeave(event);
        handleResume();
    };
    var handleClickAway = function handleClickAway(event) {
        if (onClose) onClose(event, "clickaway");
    };
    var handleExited = function handleExited() {
        setExited(true);
    };
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    $tZqWC.useEffect(function() {
        if (!disableWindowBlurListener && open) {
            window.addEventListener("focus", handleResume);
            window.addEventListener("blur", handlePause);
            return function() {
                window.removeEventListener("focus", handleResume);
                window.removeEventListener("blur", handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]); // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ $tZqWC.createElement((0, $0ef74dfb36172892$export$2e2bcd8739ae039), (0, $j1NUG.default)({
        onClickAway: handleClickAway
    }, ClickAwayListenerProps), /*#__PURE__*/ $tZqWC.createElement("div", (0, $j1NUG.default)({
        className: (0, $e36291aa02fe850c$export$2e2bcd8739ae039)(classes.root, classes["anchorOrigin".concat((0, $b8dee6a068c54130$export$2e2bcd8739ae039)(vertical)).concat((0, $b8dee6a068c54130$export$2e2bcd8739ae039)(horizontal))], className),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ref: ref
    }, other), /*#__PURE__*/ $tZqWC.createElement(TransitionComponent, (0, $j1NUG.default)({
        appear: true,
        in: open,
        onEnter: (0, $b710cd9a00dda165$export$2e2bcd8739ae039)(handleEnter, onEnter),
        onEntered: onEntered,
        onEntering: onEntering,
        onExit: onExit,
        onExited: (0, $b710cd9a00dda165$export$2e2bcd8739ae039)(handleExited, onExited),
        onExiting: onExiting,
        timeout: transitionDuration,
        direction: vertical === "top" ? "down" : "up"
    }, TransitionProps), children || /*#__PURE__*/ $tZqWC.createElement((0, $56e7a2c69b2143ba$export$2e2bcd8739ae039), (0, $j1NUG.default)({
        message: message,
        action: action
    }, ContentProps)))));
});
var $4bd613956274dc1d$export$2e2bcd8739ae039 = (0, $874b89081beb3c93$export$2e2bcd8739ae039)($4bd613956274dc1d$export$9dd6ff9ea0189349, {
    flip: false,
    name: "MuiSnackbar"
})($4bd613956274dc1d$var$Snackbar);


const $b66eab9ddb05db46$export$7738e9160ff0021e = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $4bd613956274dc1d$export$2e2bcd8739ae039))`
  & .MuiPaper-root {
    border-radius: 8px;
    border: ${({ theme: theme })=>`2px solid ${theme.colors.lightGray}`};

    // Variants
    ${({ theme: theme })=>`color: ${theme.colors.pureWhite};`}
    ${({ type: type, theme: theme })=>type === "success" && `background-color: ${theme.colors.success} !important;`}
    ${({ type: type, theme: theme })=>type === "warning" && `background-color: ${theme.colors.warning} !important;`}
    ${({ type: type, theme: theme })=>type === "error" && `background-color: ${theme.colors.red} !important;`}
    ${({ type: type, theme: theme })=>type === "info" && `background-color: ${theme.colors.blueGray} !important;`}
  }
  & button {
    padding: 6px !important;
  }
`;


function $60eeb3e26491a187$var$Alert(props) {
    // Destructure
    const { open: open, message: message, onClose: onClose, anchorOrigin: anchorOrigin, color: color, autoHideDuration: autoHideDuration, ...rest } = props;
    // Functions
    const handleOnClose = (e)=>{
        onClose(e);
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b66eab9ddb05db46$export$7738e9160ff0021e), {
        anchorOrigin: anchorOrigin,
        open: open,
        onClose: handleOnClose,
        autoHideDuration: autoHideDuration,
        message: message,
        action: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f045e7afb70ff9d3$export$2e2bcd8739ae039), {
            size: "small",
            "aria-label": "close",
            color: "inherit",
            onClick: handleOnClose,
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f8b21e6e39ef8af9$export$2e2bcd8739ae039), {
                onClick: handleOnClose
            })
        }),
        ...rest
    });
}
// Default Props
$60eeb3e26491a187$var$Alert.defaultProps = {
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
    },
    open: false,
    autoHideDuration: 3000,
    onClose: ()=>{},
    color: "",
    message: ""
};
// Proptypes Validation
$60eeb3e26491a187$var$Alert.propTypes = {
    anchorOrigin: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    open: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    autoHideDuration: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    message: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $60eeb3e26491a187$export$2e2bcd8739ae039 = $60eeb3e26491a187$var$Alert;


var $ffd80d6545166898$export$2e2bcd8739ae039 = (0, $60eeb3e26491a187$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $j1NUG = parcelRequire("j1NUG");


var $tZqWC = parcelRequire("tZqWC");




var $j1NUG = parcelRequire("j1NUG");

var $tZqWC = parcelRequire("tZqWC");







var $tZqWC = parcelRequire("tZqWC");






function $9b61747b18540e45$var$getContainer(container) {
    container = typeof container === "function" ? container() : container; // #StrictMode ready
    return $f419cfc3d92fe631$exports.findDOMNode(container);
}
var $9b61747b18540e45$var$useEnhancedEffect = typeof window !== "undefined" ? $tZqWC.useLayoutEffect : $tZqWC.useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */ var $9b61747b18540e45$var$Portal = /*#__PURE__*/ $tZqWC.forwardRef(function Portal(props, ref) {
    var children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, onRendered = props.onRendered;
    var _React$useState = $tZqWC.useState(null), mountNode = _React$useState[0], setMountNode = _React$useState[1];
    var handleRef = (0, $7e459a01419f96d3$export$2e2bcd8739ae039)(/*#__PURE__*/ $tZqWC.isValidElement(children) ? children.ref : null, ref);
    $9b61747b18540e45$var$useEnhancedEffect(function() {
        if (!disablePortal) setMountNode($9b61747b18540e45$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    $9b61747b18540e45$var$useEnhancedEffect(function() {
        if (mountNode && !disablePortal) {
            (0, $c8c06050dfa174b6$export$2e2bcd8739ae039)(ref, mountNode);
            return function() {
                (0, $c8c06050dfa174b6$export$2e2bcd8739ae039)(ref, null);
            };
        }
        return undefined;
    }, [
        ref,
        mountNode,
        disablePortal
    ]);
    $9b61747b18540e45$var$useEnhancedEffect(function() {
        if (onRendered && (mountNode || disablePortal)) onRendered();
    }, [
        onRendered,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $tZqWC.isValidElement(children)) return /*#__PURE__*/ $tZqWC.cloneElement(children, {
            ref: handleRef
        });
        return children;
    }
    return mountNode ? /*#__PURE__*/ $f419cfc3d92fe631$exports.createPortal(children, mountNode) : mountNode;
});
var $9b61747b18540e45$export$2e2bcd8739ae039 = $9b61747b18540e45$var$Portal;






function $a94d922e6e97cb79$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



var $avH1z = parcelRequire("avH1z");

// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function $094b6af1ea0b1fd0$export$2e2bcd8739ae039() {
    var scrollDiv = document.createElement("div");
    scrollDiv.style.width = "99px";
    scrollDiv.style.height = "99px";
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    scrollDiv.style.overflow = "scroll";
    document.body.appendChild(scrollDiv);
    var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarSize;
}




function $a321f9d051b92603$export$2e2bcd8739ae039(node) {
    var doc = (0, $3d975f2378953cd0$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


function $4a1bbbc136fd8724$var$isOverflowing(container) {
    var doc = (0, $3d975f2378953cd0$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $a321f9d051b92603$export$2e2bcd8739ae039)(doc).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $4a1bbbc136fd8724$export$e1bd0c6150f13d96(node, show) {
    if (show) node.setAttribute("aria-hidden", "true");
    else node.removeAttribute("aria-hidden");
}
function $4a1bbbc136fd8724$var$getPaddingRight(node) {
    return parseInt(window.getComputedStyle(node)["padding-right"], 10) || 0;
}
function $4a1bbbc136fd8724$var$ariaHiddenSiblings(container, mountNode, currentNode) {
    var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var show = arguments.length > 4 ? arguments[4] : undefined;
    var blacklist = [
        mountNode,
        currentNode
    ].concat((0, $cc85964c3bb5b33f$export$2e2bcd8739ae039)(nodesToExclude));
    var blacklistTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE"
    ];
    [].forEach.call(container.children, function(node) {
        if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) $4a1bbbc136fd8724$export$e1bd0c6150f13d96(node, show);
    });
}
function $4a1bbbc136fd8724$var$findIndexOf(containerInfo, callback) {
    var idx = -1;
    containerInfo.some(function(item, index) {
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $4a1bbbc136fd8724$var$handleContainer(containerInfo, props) {
    var restoreStyle = [];
    var restorePaddings = [];
    var container = containerInfo.container;
    var fixedNodes;
    if (!props.disableScrollLock) {
        if ($4a1bbbc136fd8724$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            var scrollbarSize = (0, $094b6af1ea0b1fd0$export$2e2bcd8739ae039)();
            restoreStyle.push({
                value: container.style.paddingRight,
                key: "padding-right",
                el: container
            }); // Use computed style, here to get the real padding to add our scrollbar width.
            container.style["padding-right"] = "".concat($4a1bbbc136fd8724$var$getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
            fixedNodes = (0, $3d975f2378953cd0$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedNodes, function(node) {
                restorePaddings.push(node.style.paddingRight);
                node.style.paddingRight = "".concat($4a1bbbc136fd8724$var$getPaddingRight(node) + scrollbarSize, "px");
            });
        } // Improve Gatsby support
        // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
        var parent = container.parentElement;
        var scrollContainer = parent.nodeName === "HTML" && window.getComputedStyle(parent)["overflow-y"] === "scroll" ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            key: "overflow",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    var restore = function restore() {
        if (fixedNodes) [].forEach.call(fixedNodes, function(node, i) {
            if (restorePaddings[i]) node.style.paddingRight = restorePaddings[i];
            else node.style.removeProperty("padding-right");
        });
        restoreStyle.forEach(function(_ref) {
            var value = _ref.value, el = _ref.el, key = _ref.key;
            if (value) el.style.setProperty(key, value);
            else el.style.removeProperty(key);
        });
    };
    return restore;
}
function $4a1bbbc136fd8724$var$getHiddenSiblings(container) {
    var hiddenSiblings = [];
    [].forEach.call(container.children, function(node) {
        if (node.getAttribute && node.getAttribute("aria-hidden") === "true") hiddenSiblings.push(node);
    });
    return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */ var $4a1bbbc136fd8724$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ModalManager() {
        (0, $a94d922e6e97cb79$export$2e2bcd8739ae039)(this, ModalManager);
        // this.modals[modalIndex] = modal
        this.modals = []; // this.containers[containerIndex] = {
        //   modals: [],
        //   container,
        //   restore: null,
        // }
        this.containers = [];
    }
    (0, $avH1z.default)(ModalManager, [
        {
            key: "add",
            value: function add(modal, container) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex !== -1) return modalIndex;
                modalIndex = this.modals.length;
                this.modals.push(modal); // If the modal we are adding is already in the DOM.
                if (modal.modalRef) $4a1bbbc136fd8724$export$e1bd0c6150f13d96(modal.modalRef, false);
                var hiddenSiblingNodes = $4a1bbbc136fd8724$var$getHiddenSiblings(container);
                $4a1bbbc136fd8724$var$ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
                var containerIndex = $4a1bbbc136fd8724$var$findIndexOf(this.containers, function(item) {
                    return item.container === container;
                });
                if (containerIndex !== -1) {
                    this.containers[containerIndex].modals.push(modal);
                    return modalIndex;
                }
                this.containers.push({
                    modals: [
                        modal
                    ],
                    container: container,
                    restore: null,
                    hiddenSiblingNodes: hiddenSiblingNodes
                });
                return modalIndex;
            }
        },
        {
            key: "mount",
            value: function mount(modal, props) {
                var containerIndex = $4a1bbbc136fd8724$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                if (!containerInfo.restore) containerInfo.restore = $4a1bbbc136fd8724$var$handleContainer(containerInfo, props);
            }
        },
        {
            key: "remove",
            value: function remove(modal) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex === -1) return modalIndex;
                var containerIndex = $4a1bbbc136fd8724$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
                this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
                if (containerInfo.modals.length === 0) {
                    // The modal might be closed before it had the chance to be mounted in the DOM.
                    if (containerInfo.restore) containerInfo.restore();
                    if (modal.modalRef) // In case the modal wasn't in the DOM yet.
                    $4a1bbbc136fd8724$export$e1bd0c6150f13d96(modal.modalRef, true);
                    $4a1bbbc136fd8724$var$ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
                    this.containers.splice(containerIndex, 1);
                } else {
                    // Otherwise make sure the next top modal is visible to a screen reader.
                    var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
                    // aria-hidden because the dom element doesn't exist either
                    // when modal was unmounted before modalRef gets null
                    if (nextTop.modalRef) $4a1bbbc136fd8724$export$e1bd0c6150f13d96(nextTop.modalRef, false);
                }
                return modalIndex;
            }
        },
        {
            key: "isTopModal",
            value: function isTopModal(modal) {
                return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
            }
        }
    ]);
    return ModalManager;
}();


/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */ 
var $tZqWC = parcelRequire("tZqWC");





/**
 * Utility component that locks focus inside the component.
 */ function $8601fb1cdf2332ed$var$Unstable_TrapFocus(props) {
    var children = props.children, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, getDoc = props.getDoc, isEnabled = props.isEnabled, open = props.open;
    var ignoreNextEnforceFocus = $tZqWC.useRef();
    var sentinelStart = $tZqWC.useRef(null);
    var sentinelEnd = $tZqWC.useRef(null);
    var nodeToRestore = $tZqWC.useRef();
    var rootRef = $tZqWC.useRef(null); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $tZqWC.useCallback(function(instance) {
        // #StrictMode ready
        rootRef.current = $f419cfc3d92fe631$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $7e459a01419f96d3$export$2e2bcd8739ae039)(children.ref, handleOwnRef);
    var prevOpenRef = $tZqWC.useRef();
    $tZqWC.useEffect(function() {
        prevOpenRef.current = open;
    }, [
        open
    ]);
    if (!prevOpenRef.current && open && typeof window !== "undefined") // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
    $tZqWC.useEffect(function() {
        if (!open) return;
        var doc = (0, $3d975f2378953cd0$export$2e2bcd8739ae039)(rootRef.current); // We might render an empty child.
        if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", -1);
            rootRef.current.focus();
        }
        var contain = function contain() {
            var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (rootRef.current && !rootRef.current.contains(doc.activeElement)) rootRef.current.focus();
        };
        var loopFocus = function loopFocus(event) {
            // 9 = Tab
            if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) return;
             // Make sure the next tab starts from the right place.
            if (doc.activeElement === rootRef.current) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (event.shiftKey) sentinelEnd.current.focus();
                else sentinelStart.current.focus();
            }
        };
        doc.addEventListener("focus", contain, true);
        doc.addEventListener("keydown", loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        var interval = setInterval(function() {
            contain();
        }, 50);
        return function() {
            clearInterval(interval);
            doc.removeEventListener("focus", contain, true);
            doc.removeEventListener("keydown", loopFocus, true); // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE 11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE 11 have a focus method.
                // Once IE 11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) nodeToRestore.current.focus();
                nodeToRestore.current = null;
            }
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open
    ]);
    return /*#__PURE__*/ $tZqWC.createElement($tZqWC.Fragment, null, /*#__PURE__*/ $tZqWC.createElement("div", {
        tabIndex: 0,
        ref: sentinelStart,
        "data-test": "sentinelStart"
    }), /*#__PURE__*/ $tZqWC.cloneElement(children, {
        ref: handleRef
    }), /*#__PURE__*/ $tZqWC.createElement("div", {
        tabIndex: 0,
        ref: sentinelEnd,
        "data-test": "sentinelEnd"
    }));
}
var $8601fb1cdf2332ed$export$2e2bcd8739ae039 = $8601fb1cdf2332ed$var$Unstable_TrapFocus;



var $j1NUG = parcelRequire("j1NUG");


var $tZqWC = parcelRequire("tZqWC");

var $5a0cc09b2b7bf7af$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        zIndex: -1,
        position: "fixed",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: "transparent"
    }
};
/**
 * @ignore - internal component.
 */ var $5a0cc09b2b7bf7af$var$SimpleBackdrop = /*#__PURE__*/ $tZqWC.forwardRef(function SimpleBackdrop(props, ref) {
    var _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, other = (0, $636333a0deecc159$export$2e2bcd8739ae039)(props, [
        "invisible",
        "open"
    ]);
    return open ? /*#__PURE__*/ $tZqWC.createElement("div", (0, $j1NUG.default)({
        "aria-hidden": true,
        ref: ref
    }, other, {
        style: (0, $j1NUG.default)({}, $5a0cc09b2b7bf7af$export$9dd6ff9ea0189349.root, invisible ? $5a0cc09b2b7bf7af$export$9dd6ff9ea0189349.invisible : {}, other.style)
    })) : null;
});
var $5a0cc09b2b7bf7af$export$2e2bcd8739ae039 = $5a0cc09b2b7bf7af$var$SimpleBackdrop;


function $f5007fd34f9b7a06$var$getContainer(container) {
    container = typeof container === "function" ? container() : container;
    return $f419cfc3d92fe631$exports.findDOMNode(container);
}
function $f5007fd34f9b7a06$var$getHasTransition(props) {
    return props.children ? props.children.props.hasOwnProperty("in") : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
var $f5007fd34f9b7a06$var$defaultManager = new (0, $4a1bbbc136fd8724$export$2e2bcd8739ae039)();
var $f5007fd34f9b7a06$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "fixed",
            zIndex: theme.zIndex.modal,
            right: 0,
            bottom: 0,
            top: 0,
            left: 0
        },
        /* Styles applied to the root element if the `Modal` has exited. */ hidden: {
            visibility: "hidden"
        }
    };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ var $f5007fd34f9b7a06$var$Modal = /*#__PURE__*/ $tZqWC.forwardRef(function Modal(inProps, ref) {
    var theme = (0, $8610d05fa52a0f79$export$2e2bcd8739ae039)();
    var props = (0, $0d1f5bbd82cd1622$export$2e2bcd8739ae039)({
        name: "MuiModal",
        props: (0, $j1NUG.default)({}, inProps),
        theme: theme
    });
    var _props$BackdropCompon = props.BackdropComponent, BackdropComponent = _props$BackdropCompon === void 0 ? (0, $5a0cc09b2b7bf7af$export$2e2bcd8739ae039) : _props$BackdropCompon, BackdropProps = props.BackdropProps, children = props.children, _props$closeAfterTran = props.closeAfterTransition, closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran, container = props.container, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, _props$disableScrollL = props.disableScrollLock, disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL, _props$hideBackdrop = props.hideBackdrop, hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, _props$manager = props.manager, manager = _props$manager === void 0 ? $f5007fd34f9b7a06$var$defaultManager : _props$manager, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEscapeKeyDown = props.onEscapeKeyDown, onRendered = props.onRendered, open = props.open, other = (0, $636333a0deecc159$export$2e2bcd8739ae039)(props, [
        "BackdropComponent",
        "BackdropProps",
        "children",
        "closeAfterTransition",
        "container",
        "disableAutoFocus",
        "disableBackdropClick",
        "disableEnforceFocus",
        "disableEscapeKeyDown",
        "disablePortal",
        "disableRestoreFocus",
        "disableScrollLock",
        "hideBackdrop",
        "keepMounted",
        "manager",
        "onBackdropClick",
        "onClose",
        "onEscapeKeyDown",
        "onRendered",
        "open"
    ]);
    var _React$useState = $tZqWC.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var modal = $tZqWC.useRef({});
    var mountNodeRef = $tZqWC.useRef(null);
    var modalRef = $tZqWC.useRef(null);
    var handleRef = (0, $7e459a01419f96d3$export$2e2bcd8739ae039)(modalRef, ref);
    var hasTransition = $f5007fd34f9b7a06$var$getHasTransition(props);
    var getDoc = function getDoc() {
        return (0, $3d975f2378953cd0$export$2e2bcd8739ae039)(mountNodeRef.current);
    };
    var getModal = function getModal() {
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    var handleMounted = function handleMounted() {
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        }); // Fix a bug on Chrome where the scroll isn't initially 0.
        modalRef.current.scrollTop = 0;
    };
    var handleOpen = (0, $39d8c0112ee28bf4$export$2e2bcd8739ae039)(function() {
        var resolvedContainer = $f5007fd34f9b7a06$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer); // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    var isTopModal = $tZqWC.useCallback(function() {
        return manager.isTopModal(getModal());
    }, [
        manager
    ]);
    var handlePortalRef = (0, $39d8c0112ee28bf4$export$2e2bcd8739ae039)(function(node) {
        mountNodeRef.current = node;
        if (!node) return;
        if (onRendered) onRendered();
        if (open && isTopModal()) handleMounted();
        else (0, $4a1bbbc136fd8724$export$e1bd0c6150f13d96)(modalRef.current, true);
    });
    var handleClose = $tZqWC.useCallback(function() {
        manager.remove(getModal());
    }, [
        manager
    ]);
    $tZqWC.useEffect(function() {
        return function() {
            handleClose();
        };
    }, [
        handleClose
    ]);
    $tZqWC.useEffect(function() {
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    var handleExited = function handleExited() {
        setExited(true);
        if (closeAfterTransition) handleClose();
    };
    var handleBackdropClick = function handleBackdropClick(event) {
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (!disableBackdropClick && onClose) onClose(event, "backdropClick");
    };
    var handleKeyDown = function handleKeyDown(event) {
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviours like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== "Escape" || !isTopModal()) return;
        if (onEscapeKeyDown) onEscapeKeyDown(event);
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, "escapeKeyDown");
        }
    };
    var inlineStyle = $f5007fd34f9b7a06$export$9dd6ff9ea0189349(theme || {
        zIndex: (0, $33b246dad8c4b06b$export$2e2bcd8739ae039)
    });
    var childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = children.props.tabIndex || "-1";
     // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $b710cd9a00dda165$export$2e2bcd8739ae039)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $b710cd9a00dda165$export$2e2bcd8739ae039)(handleExited, children.props.onExited);
    }
    return /*#__PURE__*/ $tZqWC.createElement((0, $9b61747b18540e45$export$2e2bcd8739ae039), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal
    }, /*#__PURE__*/ $tZqWC.createElement("div", (0, $j1NUG.default)({
        ref: handleRef,
        onKeyDown: handleKeyDown,
        role: "presentation"
    }, other, {
        style: (0, $j1NUG.default)({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
    }), hideBackdrop ? null : /*#__PURE__*/ $tZqWC.createElement(BackdropComponent, (0, $j1NUG.default)({
        open: open,
        onClick: handleBackdropClick
    }, BackdropProps)), /*#__PURE__*/ $tZqWC.createElement((0, $8601fb1cdf2332ed$export$2e2bcd8739ae039), {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        getDoc: getDoc,
        isEnabled: isTopModal,
        open: open
    }, /*#__PURE__*/ $tZqWC.cloneElement(children, childProps))));
});
var $f5007fd34f9b7a06$export$2e2bcd8739ae039 = $f5007fd34f9b7a06$var$Modal;



var $j1NUG = parcelRequire("j1NUG");


var $tZqWC = parcelRequire("tZqWC");




var $j1NUG = parcelRequire("j1NUG");



var $tZqWC = parcelRequire("tZqWC");






var $4f10851c9f37ea15$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
var $4f10851c9f37ea15$var$defaultTimeout = {
    enter: (0, $79cf0b50b6f9ce39$export$1f34108aa9eb96ab).enteringScreen,
    exit: (0, $79cf0b50b6f9ce39$export$1f34108aa9eb96ab).leavingScreen
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $4f10851c9f37ea15$var$Fade = /*#__PURE__*/ $tZqWC.forwardRef(function Fade(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $a648815ae929180c$export$2e2bcd8739ae039) : _props$TransitionComp, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? $4f10851c9f37ea15$var$defaultTimeout : _props$timeout, other = (0, $636333a0deecc159$export$2e2bcd8739ae039)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "TransitionComponent",
        "timeout"
    ]);
    var theme = (0, $8e87f4aa209ae0c1$export$2e2bcd8739ae039)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $tZqWC.useRef(null);
    var foreignRef = (0, $7e459a01419f96d3$export$2e2bcd8739ae039)(children.ref, ref);
    var handleRef = (0, $7e459a01419f96d3$export$2e2bcd8739ae039)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $e6b4a46368942149$export$2e2bcd8739ae039)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $e773cce81cf3ac98$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        var transitionProps = (0, $e773cce81cf3ac98$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var transitionProps = (0, $e773cce81cf3ac98$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    return /*#__PURE__*/ $tZqWC.createElement(TransitionComponent, (0, $j1NUG.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        timeout: timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $tZqWC.cloneElement(children, (0, $j1NUG.default)({
            style: (0, $j1NUG.default)({
                opacity: 0,
                visibility: state === "exited" && !inProp ? "hidden" : undefined
            }, $4f10851c9f37ea15$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
var $4f10851c9f37ea15$export$2e2bcd8739ae039 = $4f10851c9f37ea15$var$Fade;


var $1bb0be9a0d221dc3$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        // Improve scrollable dialog support.
        zIndex: -1,
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: "transparent"
    }
};
var $1bb0be9a0d221dc3$var$Backdrop = /*#__PURE__*/ $tZqWC.forwardRef(function Backdrop(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, transitionDuration = props.transitionDuration, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $4f10851c9f37ea15$export$2e2bcd8739ae039) : _props$TransitionComp, other = (0, $636333a0deecc159$export$2e2bcd8739ae039)(props, [
        "children",
        "classes",
        "className",
        "invisible",
        "open",
        "transitionDuration",
        "TransitionComponent"
    ]);
    return /*#__PURE__*/ $tZqWC.createElement(TransitionComponent, (0, $j1NUG.default)({
        in: open,
        timeout: transitionDuration
    }, other), /*#__PURE__*/ $tZqWC.createElement("div", {
        className: (0, $e36291aa02fe850c$export$2e2bcd8739ae039)(classes.root, className, invisible && classes.invisible),
        "aria-hidden": true,
        ref: ref
    }, children));
});
var $1bb0be9a0d221dc3$export$2e2bcd8739ae039 = (0, $874b89081beb3c93$export$2e2bcd8739ae039)($1bb0be9a0d221dc3$export$9dd6ff9ea0189349, {
    name: "MuiBackdrop"
})($1bb0be9a0d221dc3$var$Backdrop);




var $j1NUG = parcelRequire("j1NUG");


var $tZqWC = parcelRequire("tZqWC");


// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $099130b4aaa4645a$export$2e2bcd8739ae039(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
    var timeout;
    function debounced() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // eslint-disable-next-line consistent-this
        var that = this;
        var later = function later() {
            func.apply(that, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}








// Later, we gonna translate back the node to his original location
// with `none`.`
function $31c713e6ab82917d$var$getTranslateValue(direction, node) {
    var rect = node.getBoundingClientRect();
    var transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        var computedStyle = window.getComputedStyle(node);
        transform = computedStyle.getPropertyValue("-webkit-transform") || computedStyle.getPropertyValue("transform");
    }
    var offsetX = 0;
    var offsetY = 0;
    if (transform && transform !== "none" && typeof transform === "string") {
        var transformValues = transform.split("(")[1].split(")")[0].split(",");
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === "left") return "translateX(".concat(window.innerWidth, "px) translateX(").concat(offsetX - rect.left, "px)");
    if (direction === "right") return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
    if (direction === "up") return "translateY(".concat(window.innerHeight, "px) translateY(").concat(offsetY - rect.top, "px)");
     // direction === 'down'
    return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
}
function $31c713e6ab82917d$export$f820ccdc5b48abdf(direction, node) {
    var transform = $31c713e6ab82917d$var$getTranslateValue(direction, node);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
var $31c713e6ab82917d$var$defaultTimeout = {
    enter: (0, $79cf0b50b6f9ce39$export$1f34108aa9eb96ab).enteringScreen,
    exit: (0, $79cf0b50b6f9ce39$export$1f34108aa9eb96ab).leavingScreen
};
/**
 * The Slide transition is used by the [Drawer](/components/drawers/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $31c713e6ab82917d$var$Slide = /*#__PURE__*/ $tZqWC.forwardRef(function Slide(props, ref) {
    var children = props.children, _props$direction = props.direction, direction = _props$direction === void 0 ? "down" : _props$direction, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? $31c713e6ab82917d$var$defaultTimeout : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $a648815ae929180c$export$2e2bcd8739ae039) : _props$TransitionComp, other = (0, $636333a0deecc159$export$2e2bcd8739ae039)(props, [
        "children",
        "direction",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var theme = (0, $8e87f4aa209ae0c1$export$2e2bcd8739ae039)();
    var childrenRef = $tZqWC.useRef(null);
    /**
   * used in cloneElement(children, { ref: handleRef })
   */ var handleOwnRef = $tZqWC.useCallback(function(instance) {
        // #StrictMode ready
        childrenRef.current = $f419cfc3d92fe631$exports.findDOMNode(instance);
    }, []);
    var handleRefIntermediary = (0, $7e459a01419f96d3$export$2e2bcd8739ae039)(children.ref, handleOwnRef);
    var handleRef = (0, $7e459a01419f96d3$export$2e2bcd8739ae039)(handleRefIntermediary, ref);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(isAppearing) {
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    };
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        $31c713e6ab82917d$export$f820ccdc5b48abdf(direction, node);
        (0, $e773cce81cf3ac98$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntering = normalizedTransitionCallback(function(node, isAppearing) {
        var transitionProps = (0, $e773cce81cf3ac98$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", (0, $j1NUG.default)({}, transitionProps, {
            easing: theme.transitions.easing.easeOut
        }));
        node.style.transition = theme.transitions.create("transform", (0, $j1NUG.default)({}, transitionProps, {
            easing: theme.transitions.easing.easeOut
        }));
        node.style.webkitTransform = "none";
        node.style.transform = "none";
        if (onEntering) onEntering(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var transitionProps = (0, $e773cce81cf3ac98$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", (0, $j1NUG.default)({}, transitionProps, {
            easing: theme.transitions.easing.sharp
        }));
        node.style.transition = theme.transitions.create("transform", (0, $j1NUG.default)({}, transitionProps, {
            easing: theme.transitions.easing.sharp
        }));
        $31c713e6ab82917d$export$f820ccdc5b48abdf(direction, node);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(function(node) {
        // No need for transitions when the component is hidden
        node.style.webkitTransition = "";
        node.style.transition = "";
        if (onExited) onExited(node);
    });
    var updatePosition = $tZqWC.useCallback(function() {
        if (childrenRef.current) $31c713e6ab82917d$export$f820ccdc5b48abdf(direction, childrenRef.current);
    }, [
        direction
    ]);
    $tZqWC.useEffect(function() {
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === "down" || direction === "right") return undefined;
        var handleResize = (0, $099130b4aaa4645a$export$2e2bcd8739ae039)(function() {
            if (childrenRef.current) $31c713e6ab82917d$export$f820ccdc5b48abdf(direction, childrenRef.current);
        });
        window.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener("resize", handleResize);
        };
    }, [
        direction,
        inProp
    ]);
    $tZqWC.useEffect(function() {
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ $tZqWC.createElement(TransitionComponent, (0, $j1NUG.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        appear: true,
        in: inProp,
        timeout: timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $tZqWC.cloneElement(children, (0, $j1NUG.default)({
            ref: handleRef,
            style: (0, $j1NUG.default)({
                visibility: state === "exited" && !inProp ? "hidden" : undefined
            }, style, children.props.style)
        }, childProps));
    });
});
var $31c713e6ab82917d$export$2e2bcd8739ae039 = $31c713e6ab82917d$var$Slide;






var $caa65bb4a374a30a$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {},
        /* Styles applied to the root element if `variant="permanent or persistent"`. */ docked: {
            flex: "0 0 auto"
        },
        /* Styles applied to the `Paper` component. */ paper: {
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            flex: "1 0 auto",
            zIndex: theme.zIndex.drawer,
            WebkitOverflowScrolling: "touch",
            // Add iOS momentum scrolling.
            // temporary style
            position: "fixed",
            top: 0,
            // We disable the focus ring for mouse, touch and keyboard users.
            // At some point, it would be better to keep it for keyboard users.
            // :focus-ring CSS pseudo-class will help.
            outline: 0
        },
        /* Styles applied to the `Paper` component if `anchor="left"`. */ paperAnchorLeft: {
            left: 0,
            right: "auto"
        },
        /* Styles applied to the `Paper` component if `anchor="right"`. */ paperAnchorRight: {
            left: "auto",
            right: 0
        },
        /* Styles applied to the `Paper` component if `anchor="top"`. */ paperAnchorTop: {
            top: 0,
            left: 0,
            bottom: "auto",
            right: 0,
            height: "auto",
            maxHeight: "100%"
        },
        /* Styles applied to the `Paper` component if `anchor="bottom"`. */ paperAnchorBottom: {
            top: "auto",
            left: 0,
            bottom: 0,
            right: 0,
            height: "auto",
            maxHeight: "100%"
        },
        /* Styles applied to the `Paper` component if `anchor="left"` and `variant` is not "temporary". */ paperAnchorDockedLeft: {
            borderRight: "1px solid ".concat(theme.palette.divider)
        },
        /* Styles applied to the `Paper` component if `anchor="top"` and `variant` is not "temporary". */ paperAnchorDockedTop: {
            borderBottom: "1px solid ".concat(theme.palette.divider)
        },
        /* Styles applied to the `Paper` component if `anchor="right"` and `variant` is not "temporary". */ paperAnchorDockedRight: {
            borderLeft: "1px solid ".concat(theme.palette.divider)
        },
        /* Styles applied to the `Paper` component if `anchor="bottom"` and `variant` is not "temporary". */ paperAnchorDockedBottom: {
            borderTop: "1px solid ".concat(theme.palette.divider)
        },
        /* Styles applied to the `Modal` component. */ modal: {}
    };
};
var $caa65bb4a374a30a$var$oppositeDirection = {
    left: "right",
    right: "left",
    top: "down",
    bottom: "up"
};
function $caa65bb4a374a30a$export$2a62b49acb270576(anchor) {
    return [
        "left",
        "right"
    ].indexOf(anchor) !== -1;
}
function $caa65bb4a374a30a$export$830f4f08342d299e(theme, anchor) {
    return theme.direction === "rtl" && $caa65bb4a374a30a$export$2a62b49acb270576(anchor) ? $caa65bb4a374a30a$var$oppositeDirection[anchor] : anchor;
}
var $caa65bb4a374a30a$var$defaultTransitionDuration = {
    enter: (0, $79cf0b50b6f9ce39$export$1f34108aa9eb96ab).enteringScreen,
    exit: (0, $79cf0b50b6f9ce39$export$1f34108aa9eb96ab).leavingScreen
};
/**
 * The props of the [Modal](/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ var $caa65bb4a374a30a$var$Drawer = /*#__PURE__*/ $tZqWC.forwardRef(function Drawer(props, ref) {
    var _props$anchor = props.anchor, anchorProp = _props$anchor === void 0 ? "left" : _props$anchor, BackdropProps = props.BackdropProps, children = props.children, classes = props.classes, className = props.className, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 16 : _props$elevation, _props$ModalProps = props.ModalProps;
    _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
    var BackdropPropsProp = _props$ModalProps.BackdropProps, ModalProps = (0, $636333a0deecc159$export$2e2bcd8739ae039)(_props$ModalProps, [
        "BackdropProps"
    ]), onClose = props.onClose, _props$open = props.open, open = _props$open === void 0 ? false : _props$open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, SlideProps = props.SlideProps, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $31c713e6ab82917d$export$2e2bcd8739ae039) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? $caa65bb4a374a30a$var$defaultTransitionDuration : _props$transitionDura, _props$variant = props.variant, variant = _props$variant === void 0 ? "temporary" : _props$variant, other = (0, $636333a0deecc159$export$2e2bcd8739ae039)(props, [
        "anchor",
        "BackdropProps",
        "children",
        "classes",
        "className",
        "elevation",
        "ModalProps",
        "onClose",
        "open",
        "PaperProps",
        "SlideProps",
        "TransitionComponent",
        "transitionDuration",
        "variant"
    ]);
    var theme = (0, $8e87f4aa209ae0c1$export$2e2bcd8739ae039)(); // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    var mounted = $tZqWC.useRef(false);
    $tZqWC.useEffect(function() {
        mounted.current = true;
    }, []);
    var anchor = $caa65bb4a374a30a$export$830f4f08342d299e(theme, anchorProp);
    var drawer = /*#__PURE__*/ $tZqWC.createElement((0, $fed5cd4d48f88561$export$2e2bcd8739ae039), (0, $j1NUG.default)({
        elevation: variant === "temporary" ? elevation : 0,
        square: true
    }, PaperProps, {
        className: (0, $e36291aa02fe850c$export$2e2bcd8739ae039)(classes.paper, classes["paperAnchor".concat((0, $b8dee6a068c54130$export$2e2bcd8739ae039)(anchor))], PaperProps.className, variant !== "temporary" && classes["paperAnchorDocked".concat((0, $b8dee6a068c54130$export$2e2bcd8739ae039)(anchor))])
    }), children);
    if (variant === "permanent") return /*#__PURE__*/ $tZqWC.createElement("div", (0, $j1NUG.default)({
        className: (0, $e36291aa02fe850c$export$2e2bcd8739ae039)(classes.root, classes.docked, className),
        ref: ref
    }, other), drawer);
    var slidingDrawer = /*#__PURE__*/ $tZqWC.createElement(TransitionComponent, (0, $j1NUG.default)({
        in: open,
        direction: $caa65bb4a374a30a$var$oppositeDirection[anchor],
        timeout: transitionDuration,
        appear: mounted.current
    }, SlideProps), drawer);
    if (variant === "persistent") return /*#__PURE__*/ $tZqWC.createElement("div", (0, $j1NUG.default)({
        className: (0, $e36291aa02fe850c$export$2e2bcd8739ae039)(classes.root, classes.docked, className),
        ref: ref
    }, other), slidingDrawer);
     // variant === temporary
    return /*#__PURE__*/ $tZqWC.createElement((0, $f5007fd34f9b7a06$export$2e2bcd8739ae039), (0, $j1NUG.default)({
        BackdropProps: (0, $j1NUG.default)({}, BackdropProps, BackdropPropsProp, {
            transitionDuration: transitionDuration
        }),
        BackdropComponent: (0, $1bb0be9a0d221dc3$export$2e2bcd8739ae039),
        className: (0, $e36291aa02fe850c$export$2e2bcd8739ae039)(classes.root, classes.modal, className),
        open: open,
        onClose: onClose,
        ref: ref
    }, other, ModalProps), slidingDrawer);
});
var $caa65bb4a374a30a$export$2e2bcd8739ae039 = (0, $874b89081beb3c93$export$2e2bcd8739ae039)($caa65bb4a374a30a$export$9dd6ff9ea0189349, {
    name: "MuiDrawer",
    flip: false
})($caa65bb4a374a30a$var$Drawer);


const $0100016f6f3c6d02$export$75f51cf067955710 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $caa65bb4a374a30a$export$2e2bcd8739ae039))`
  // Overrides
  & .MuiPaper-root {
    // Conditional Properties
    ${({ theme: theme, maxwidth: maxwidth })=>{
    if (typeof maxwidth === "string") return `width ${maxwidth}`;
    if (typeof maxwidth === "object") return theme.functions.mediaQuery("width", maxwidth);
}}
  }
`;


function $138a899e4916a8f5$var$Drawer(props) {
    // Destructure
    const { anchor: anchor, open: open, onClose: onClose, children: children, maxWidth: maxWidth } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0100016f6f3c6d02$export$75f51cf067955710), {
        anchor: anchor,
        open: open,
        transitionDuration: 200,
        onClose: onClose,
        maxwidth: maxWidth,
        children: children
    });
}
// Default Props
$138a899e4916a8f5$var$Drawer.defaultProps = {
    anchor: "",
    open: false,
    onClose: ()=>{},
    children: "",
    maxWidth: ""
};
// Proptypes Validation
$138a899e4916a8f5$var$Drawer.propTypes = {
    anchor: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    maxWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
    ])
};
var $138a899e4916a8f5$export$2e2bcd8739ae039 = $138a899e4916a8f5$var$Drawer;


var $7c0b6d1401667fb6$export$2e2bcd8739ae039 = (0, $138a899e4916a8f5$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $2c2d134138b35d93$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
`;
const $2c2d134138b35d93$export$68c28438b26ae806 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  z-index: 0;
  width: 100%;
  top: 18px;
  left: 0;
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.lightGray};
`;
const $2c2d134138b35d93$export$305694ba63064ba1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  z-index: 0;
  top: 18px;
  left: 0;
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.blue};
  width: ${({ width: width })=>width && `${width}%;`};
  transition: 0.5s;
`;
const $2c2d134138b35d93$export$960a49cc3d27a090 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(52px, 1fr));

  /* cursor: pointer; */
`;
const $2c2d134138b35d93$export$1e86fd0e1db89578 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  position: relative;
`;
const $2c2d134138b35d93$export$a71e0d665206bf82 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  z-index: 1;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${({ theme: theme })=>theme.colors.white};
  border: 2px solid ${({ theme: theme })=>theme.colors.lightGray};
  color: ${({ theme: theme })=>theme.colors.gray};

  font-size: 14px;
  font-weight: 500;

  ${({ theme: theme, active: active })=>active && `background-color: ${theme.colors.blue} !important;`};
  ${({ theme: theme, active: active })=>active && `color: ${theme.colors.white} !important;`};
  ${({ theme: theme, active: active })=>active && `border: 2px solid ${theme.colors.blue} !important;`};

  ${({ theme: theme, completed: completed })=>completed && `color: ${theme.colors.blue} !important;`};
  ${({ theme: theme, completed: completed })=>completed && `border: 2px solid ${theme.colors.blue} !important;`};
  transition: 0.5s;
`;
const $2c2d134138b35d93$export$f5ae33f1b01a6402 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  text-align: center;
  font-size: 12px;
  font-weight: 400;

  color: ${({ theme: theme })=>theme.colors.gray};

  ${({ theme: theme, active: active })=>active && `color: ${theme.colors.blue} !important;`};
  ${({ theme: theme, completed: completed })=>completed && `color: ${theme.colors.blue} !important;`};
`;


function $40ae36cec30433fb$var$FormNavigation(props) {
    // Destructure
    const { headers: headers, pageNumber: pageNumber, setPageNumber: setPageNumber, ...rest } = props;
    const handlePageChange = (value)=>{
        if (setPageNumber) setPageNumber(value);
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2c2d134138b35d93$export$e6dfd72ab29f8598), {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2c2d134138b35d93$export$68c28438b26ae806), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2c2d134138b35d93$export$960a49cc3d27a090), {
                children: headers.map((header, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2c2d134138b35d93$export$1e86fd0e1db89578), {
                        onClick: ()=>{
                            handlePageChange(i + 1);
                        },
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2c2d134138b35d93$export$a71e0d665206bf82), {
                                active: pageNumber === i + 1,
                                completed: pageNumber > i + 1,
                                children: i + 1
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2c2d134138b35d93$export$305694ba63064ba1), {
                                width: pageNumber === i + 1 || pageNumber > i + 1 ? "100" : 0
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2c2d134138b35d93$export$f5ae33f1b01a6402), {
                                active: pageNumber === i + 1,
                                completed: pageNumber > i + 1,
                                children: header.label
                            })
                        ]
                    }, header.label))
            })
        ]
    });
}
// Default Props
$40ae36cec30433fb$var$FormNavigation.defaultProps = {
    headers: {},
    pageNumber: 0,
    setPageNumber: ()=>{}
};
// Proptypes Validation
$40ae36cec30433fb$var$FormNavigation.propTypes = {
    headers: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })),
    pageNumber: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    setPageNumber: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $40ae36cec30433fb$export$2e2bcd8739ae039 = $40ae36cec30433fb$var$FormNavigation;


var $ef69c736ae57a14f$export$2e2bcd8739ae039 = (0, $40ae36cec30433fb$export$2e2bcd8739ae039);


/* eslint-disable react/no-array-index-key */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");
/* eslint-disable no-confusing-arrow */ 
const $2047c5ef9f3cc53c$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
  min-width: 500px;
  margin-top: 10px;
  margin-bottom: -20px;
`;
const $2047c5ef9f3cc53c$export$960a49cc3d27a090 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
const $2047c5ef9f3cc53c$export$6ca7af6973c1582a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  margin: 0;
`;
const $2047c5ef9f3cc53c$export$b99cc8e24b997903 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 13px;
  text-align: right;
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $2047c5ef9f3cc53c$export$d4c1f8c9b1ee31f6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  min-width: 100px;

  padding: 0 40px 30px 0;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  transform: translateY(5px);
`;
const $2047c5ef9f3cc53c$export$eb10258d8c8e0230 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  margin: 0;
`;
const $2047c5ef9f3cc53c$export$ebb989c117bbb2e8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  text-align: left;
  font-size: 13px;
  color: ${({ theme: theme, disabled: disabled })=>disabled ? theme.colors.gray : theme.colors.darkGray};
  transform: translateY(5px);
`;
const $2047c5ef9f3cc53c$export$ce17eabc850a52ae = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  min-width: 100px;

  padding: 30px 0 0 40px;
  border-left: 2px solid ${({ theme: theme, active: active })=>active ? `${theme.colors.blue}` : `${theme.colors.gray}`};
  border-left: ${({ theme: theme, failed: failed })=>failed && `2px solid ${theme.colors.red} !important`};
  border-left: ${({ theme: theme, disabled: disabled })=>disabled && `2px solid ${theme.colors.gray}50 !important`};
  &:first-child {
    padding: 0 0 0 40px;
    border-left: 2px solid transparent !important;
  }
  ::before {
    content: '.';
    color: transparent;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    position: absolute;
    left: -6.5px;
    bottom: 0px;

    background-color: ${({ theme: theme, active: active })=>active ? `${theme.colors.blue}` : `${theme.colors.gray}`};
    background-color: ${({ theme: theme, failed: failed })=>failed && `${theme.colors.red} !important`};
    background-color: ${({ theme: theme, disabled: disabled })=>disabled && `${theme.colors.gray}50 !important`};
  }
  ::after {
    content: '.';
    color: transparent;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    position: absolute;
    left: -14px;
    bottom: -7px;

    background-color: ${({ theme: theme, active: active })=>active ? `${theme.colors.blue}4f` : `${theme.colors.gray}4f`};
    background-color: ${({ theme: theme, failed: failed })=>failed && `${theme.colors.red}4f !important`};
  }
`;


function $854a5791180d8a91$var$VerticalDotProgress(props) {
    // Destructure
    const { headers: headers } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2047c5ef9f3cc53c$export$e6dfd72ab29f8598), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2047c5ef9f3cc53c$export$960a49cc3d27a090), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2047c5ef9f3cc53c$export$6ca7af6973c1582a), {
                    children: headers.map(({ leftLabel: leftLabel }, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2047c5ef9f3cc53c$export$d4c1f8c9b1ee31f6), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2047c5ef9f3cc53c$export$b99cc8e24b997903), {
                                children: leftLabel && leftLabel
                            })
                        }, i))
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2047c5ef9f3cc53c$export$eb10258d8c8e0230), {
                    children: headers.map(({ rightLabel: rightLabel, leftLabel: leftLabel, disabled: disabled, failed: failed }, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2047c5ef9f3cc53c$export$ce17eabc850a52ae), {
                            failed: failed,
                            disabled: disabled,
                            active: leftLabel !== null,
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2047c5ef9f3cc53c$export$ebb989c117bbb2e8), {
                                disabled: disabled,
                                children: rightLabel && rightLabel
                            })
                        }, i))
                })
            ]
        })
    });
}
// Default Props
$854a5791180d8a91$var$VerticalDotProgress.defaultProps = {
    headers: {}
};
// Proptypes Validation
$854a5791180d8a91$var$VerticalDotProgress.propTypes = {
    headers: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        leftLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        rightLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        failed: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        success: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }))
};
var $854a5791180d8a91$export$2e2bcd8739ae039 = $854a5791180d8a91$var$VerticalDotProgress;


var $1388d6ff56865309$export$2e2bcd8739ae039 = (0, $854a5791180d8a91$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $2c7d236c973f6897$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%;

  & iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
`;


function $77d8038ac1b98a79$var$YoutubeEmbed(props) {
    // Destructure
    const { embedId: embedId, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2c7d236c973f6897$export$e6dfd72ab29f8598), {
        ...rest,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("iframe", {
            src: `https://www.youtube.com/embed/${embedId}`,
            frameBorder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: true,
            title: "Video"
        })
    });
}
// Default Props
$77d8038ac1b98a79$var$YoutubeEmbed.defaultProps = {
    embedId: ""
};
// Proptypes Validation
$77d8038ac1b98a79$var$YoutubeEmbed.propTypes = {
    embedId: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $77d8038ac1b98a79$export$2e2bcd8739ae039 = $77d8038ac1b98a79$var$YoutubeEmbed;


var $85a23adae7b840a5$export$2e2bcd8739ae039 = (0, $77d8038ac1b98a79$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $c14566d5a0b3e6c3$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 320px;
  min-width: 260px;
  position: relative;
  width: 100%;
`;
const $c14566d5a0b3e6c3$export$e7797fd764838308 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  background-color: ${({ theme: theme })=>theme.colors.lightGray};
  height: 10px;
  width: 100%;
  border-radius: 15px;
`;
const $c14566d5a0b3e6c3$export$407ded98a8f28593 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  left: 0;
  height: 10px;
  background-color: ${({ theme: theme, failed: failed })=>failed ? theme.colors.red : theme.colors.blue};
  border-radius: 15px;
`;


function $679483085e9c66a3$var$ProgressBar(props) {
    // Destructure
    const { width: width, failed: failed } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c14566d5a0b3e6c3$export$e6dfd72ab29f8598), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c14566d5a0b3e6c3$export$e7797fd764838308), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c14566d5a0b3e6c3$export$407ded98a8f28593), {
                failed: failed,
                style: {
                    width: width
                }
            })
        ]
    });
}
// Default Props
$679483085e9c66a3$var$ProgressBar.defaultProps = {
    width: ""
};
// Proptypes Validation
$679483085e9c66a3$var$ProgressBar.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    failed: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $679483085e9c66a3$export$2e2bcd8739ae039 = $679483085e9c66a3$var$ProgressBar;


var $badb5a82015e7095$export$2e2bcd8739ae039 = (0, $679483085e9c66a3$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $de72560b32eeea1d$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 400px;
  min-width: 260px;
  position: relative;
  width: 100%;
`;
const $de72560b32eeea1d$export$407ded98a8f28593 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  background: linear-gradient(45deg, #caff0a, #caff0a 30%, #ec8800 50%, #cb5300 100%);
  height: ${({ height: height })=>height ? `${height}px` : "8px"};
  width: 100%;
  border-radius: 5px;
  width: 100%;
`;
const $de72560b32eeea1d$export$e7797fd764838308 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  right: 0;
  height: ${({ height: height })=>height ? `${height}px` : "8px"};
  background-color: ${({ theme: theme })=>theme.colors.lightGray};
  border-radius: 0 5px 5px 0;
`;


function $44e40bfc1d5457a6$var$RiskBar(props) {
    // Destructure
    const { width: width, height: height } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $de72560b32eeea1d$export$e6dfd72ab29f8598), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $de72560b32eeea1d$export$e7797fd764838308), {
                height: height,
                style: {
                    width: `${(parseInt(width, 10) - 100) * -1}%`
                }
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $de72560b32eeea1d$export$407ded98a8f28593), {
                height: height
            })
        ]
    });
}
// Default Props
$44e40bfc1d5457a6$var$RiskBar.defaultProps = {
    width: "",
    height: 0
};
// Proptypes Validation
$44e40bfc1d5457a6$var$RiskBar.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
};
var $44e40bfc1d5457a6$export$2e2bcd8739ae039 = $44e40bfc1d5457a6$var$RiskBar;


var $9f598a52270fcc8c$export$2e2bcd8739ae039 = (0, $44e40bfc1d5457a6$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $ebb592c91ace2df2$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
`;
const $ebb592c91ace2df2$export$e7797fd764838308 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  background-color: ${({ theme: theme })=>theme.colors.lightGray};
  height: 13px;
  width: 100%;
  border-radius: 3px;
`;
const $ebb592c91ace2df2$export$407ded98a8f28593 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  left: 0;
  height: 13px;
  background-color: ${({ theme: theme })=>`${theme.colors.darkGray}20`};
  border-right: 2px solid ${({ theme: theme })=>theme.colors.darkGray};
  border-radius: 3px 0 0 3px;
`;


function $73260deb129c6edd$var$MoneyBar(props) {
    // Destructure
    const { width: width, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ebb592c91ace2df2$export$e6dfd72ab29f8598), {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ebb592c91ace2df2$export$e7797fd764838308), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ebb592c91ace2df2$export$407ded98a8f28593), {
                style: {
                    width: width
                }
            })
        ]
    });
}
// Default Props
$73260deb129c6edd$var$MoneyBar.defaultProps = {
    width: ""
};
// Proptypes Validation
$73260deb129c6edd$var$MoneyBar.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ])
};
var $73260deb129c6edd$export$2e2bcd8739ae039 = $73260deb129c6edd$var$MoneyBar;


var $0c49f31014f9f4a2$export$2e2bcd8739ae039 = (0, $73260deb129c6edd$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $986db810922f0c4d$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
`;
const $986db810922f0c4d$export$e7797fd764838308 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  background-color: ${({ theme: theme })=>theme.colors.lightGray};
  height: 10px;
  width: 100%;
  border-radius: 15px;
`;
const $986db810922f0c4d$export$460e3f9bbf2f34ce = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme: theme })=>`${theme.colors.white}`};
  height: 85px;
  width: 85px;
  border-radius: 100%;
  border: 5px solid ${({ theme: theme })=>theme.colors.white};
`;
const $986db810922f0c4d$export$698223c589197ab7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme: theme })=>`${theme.colors.darkGray}20`};
  color: ${({ theme: theme })=>theme.colors.darkGray};
  height: 100%;
  width: 100%;
  border-radius: 100%;
`;
const $986db810922f0c4d$export$407ded98a8f28593 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 110px;
  width: 110px;
  border-radius: 100% !important;
  background: ${({ theme: theme, deg: deg })=>`conic-gradient(${theme.colors.yellowGreen} ${deg}deg, ${theme.colors.darkGray}20 0deg)`};
  border-radius: 15px;
`;


function $9b9f2ab0bdeb97b4$var$CircleProgressBar(props) {
    // Destructure
    const { width: width, children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $986db810922f0c4d$export$e6dfd72ab29f8598), {
        ...rest,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $986db810922f0c4d$export$407ded98a8f28593), {
            deg: width / 100 * 360,
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $986db810922f0c4d$export$460e3f9bbf2f34ce), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $986db810922f0c4d$export$698223c589197ab7), {
                    children: children && children
                })
            })
        })
    });
}
// Default Props
$9b9f2ab0bdeb97b4$var$CircleProgressBar.defaultProps = {
    width: "",
    children: ""
};
// Proptypes Validation
$9b9f2ab0bdeb97b4$var$CircleProgressBar.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $9b9f2ab0bdeb97b4$export$2e2bcd8739ae039 = $9b9f2ab0bdeb97b4$var$CircleProgressBar;


var $cfa79532d2a0741d$export$2e2bcd8739ae039 = (0, $9b9f2ab0bdeb97b4$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $572a842dec10b615$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;

  & g {
    & #foreground {
      stroke: ${({ theme: theme })=>theme.colors.lightGray};
    }
  }
`;
const $572a842dec10b615$export$d9eb77d8aa91d4c8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  width: 100%;
  height: 100%;
`;
const $572a842dec10b615$export$7c3018f441722857 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  width: 100%;
  height: 100%;
`;
const $572a842dec10b615$export$762240c6611b6ed2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  width: ${({ size: size })=>`${size}px`};
  height: ${({ size: size })=>`${size}px`};
`;
const $572a842dec10b615$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.gray};
`;


function $a11b5c3f100394ce$var$CircularProgressBar(props) {
    const { size: sizeProp, progress: progressProp, id: id, children: children, ...rest } = props;
    // Usestates
    const [size, setSize] = (0, $tZqWC.useState)(sizeProp);
    const [progress, setProgress] = (0, $tZqWC.useState)(progressProp);
    // Advanced
    const strokeWidth = (0, $tZqWC.useMemo)(()=>size * 0.12, [
        size
    ]);
    const center = (0, $tZqWC.useMemo)(()=>size / 2, [
        size
    ]);
    const radius = (0, $tZqWC.useMemo)(()=>size / 2 - strokeWidth / 2, [
        strokeWidth
    ]);
    const circumference = (0, $tZqWC.useMemo)(()=>2 * Math.PI * radius, [
        radius
    ]);
    const maskValue = (0, $tZqWC.useMemo)(()=>(100 - progress) * 0.7, [
        progress
    ]);
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        setSize(sizeProp);
    }, [
        sizeProp
    ]);
    (0, $tZqWC.useEffect)(()=>{
        setProgress(progressProp);
    }, [
        progressProp
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $572a842dec10b615$export$e6dfd72ab29f8598), {
        ...rest,
        children: [
            strokeWidth && center && radius && circumference && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
                height: size,
                width: size,
                fill: "none",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("g", {
                        transform: `rotate(216 ${center} ${center})`,
                        origin: center,
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("circle", {
                                id: "background",
                                cx: center,
                                cy: center,
                                r: radius,
                                strokeWidth: strokeWidth,
                                stroke: `url(#gradient${id})`,
                                strokeDasharray: circumference,
                                strokeDashoffset: circumference - circumference * 70 / 100,
                                transform: `translate(${2 * center},0) scale(-1, 1) `,
                                mask: `url(#circleMask${id})`
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("circle", {
                                id: "foreground",
                                transform: `translate(${2 * center},0) scale(-1, 1) `,
                                cx: center,
                                cy: center,
                                r: radius,
                                strokeWidth: strokeWidth + 1,
                                strokeDasharray: circumference,
                                strokeDashoffset: circumference - circumference * maskValue / 100
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("mask", {
                                id: `#circleMask${id}`,
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("rect", {
                                        x: "0",
                                        y: "0",
                                        width: "100%",
                                        height: "100%",
                                        fill: "white"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("circle", {
                                        cx: center,
                                        cy: center,
                                        r: radius,
                                        strokeWidth: strokeWidth + 20,
                                        stroke: "black",
                                        fill: "none",
                                        strokeDasharray: circumference,
                                        strokeDashoffset: circumference - circumference * maskValue / 100
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("linearGradient", {
                                id: `gradient${id}`,
                                x1: "0%",
                                y1: "0%",
                                x2: "100%",
                                y2: "100%",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("stop", {
                                        stopColor: "#CAFF0A"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("stop", {
                                        offset: "30%",
                                        stopColor: "#CAFF0A"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("stop", {
                                        offset: "50%",
                                        stopColor: "#EC8800"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("stop", {
                                        offset: "100%",
                                        stopColor: "#CB5300"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $572a842dec10b615$export$d9eb77d8aa91d4c8), {
                children: [
                    children,
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $572a842dec10b615$export$7c3018f441722857), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $572a842dec10b615$export$762240c6611b6ed2), {
                            size: size,
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $572a842dec10b615$export$5f1af8db9871e1d6), {
                                    children: "Low"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $572a842dec10b615$export$5f1af8db9871e1d6), {
                                    children: "High"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
// Default Props
$a11b5c3f100394ce$var$CircularProgressBar.defaultProps = {
    size: 100,
    progress: 0,
    children: "",
    id: ""
};
// Proptypes Validation
$a11b5c3f100394ce$var$CircularProgressBar.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    progress: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $a11b5c3f100394ce$export$2e2bcd8739ae039 = $a11b5c3f100394ce$var$CircularProgressBar;


var $ba8982a7854b309f$export$2e2bcd8739ae039 = (0, $a11b5c3f100394ce$export$2e2bcd8739ae039);



/* eslint-disable react/forbid-prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $1bc4b33b919eb7b6$export$64761ff3688f328 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
  margin-top: ${({ label: label })=>label ? "-5px;" : "40px;"};
  /* background: ${({ theme: theme })=>theme.colors.white};

  border-radius: ${({ open: open })=>open ? "10px 10px 0 0" : "10px"};
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.07); */
`;
const $1bc4b33b919eb7b6$export$ca4b1fc43afa0212 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 20px;
`;
const $1bc4b33b919eb7b6$export$2f96f6f204f87534 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 20px;
  width: 100%;
  max-height: 35.5px;

  opacity: 1;
  transition: 0.3s;

  max-width: ${({ collapseFilter: collapseFilter })=>collapseFilter ? "0px" : "2000px"};
  overflow: ${({ collapseFilter: collapseFilter })=>collapseFilter ? "hidden" : "visible"};
`;





// Function that listens to oustide clicks of given ref
const $3a8b1bf51a4fb7a5$var$useOutsideAlerter = (ref, handleClose)=>{
    (0, $tZqWC.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) handleClose();
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref
    ]);
};
function $3a8b1bf51a4fb7a5$var$ButtonFilter(props) {
    // Destructure
    const { filter: // label,
    // options,
    // disabledOptions,
    // setOptions,
    // placeholder,
    filter, id: // bottomOptions,
    // onInputChange,
    // disabled,
    // onSelect,
    // isLoading,
    // value,
    id, ...rest } = props;
    // Variables
    const wrapperRef = (0, $tZqWC.useRef)();
    // States
    const [collapseFilter, setCollapseFilter] = (0, $tZqWC.useState)(true);
    // Functions
    const handleCollapseFilter = ()=>{
        setCollapseFilter((prevState)=>!prevState);
    };
    // Closing options on click away
    $3a8b1bf51a4fb7a5$var$useOutsideAlerter(wrapperRef, handleCollapseFilter);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1bc4b33b919eb7b6$export$64761ff3688f328), {
        children: filter && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1bc4b33b919eb7b6$export$ca4b1fc43afa0212), {
            id: id,
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                    size: "small",
                    onClick: handleCollapseFilter,
                    startIcon: collapseFilter ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $60f83047747d7ceb$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f8b21e6e39ef8af9$export$2e2bcd8739ae039), {}),
                    variant: "outlined",
                    ...rest,
                    children: collapseFilter ? "Filters" : "Close"
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1bc4b33b919eb7b6$export$2f96f6f204f87534), {
                    collapseFilter: collapseFilter,
                    children: filter
                })
            ]
        })
    });
}
// Default Props
$3a8b1bf51a4fb7a5$var$ButtonFilter.defaultProps = {
    id: "",
    label: "",
    placeholder: "",
    options: [],
    setOptions: ()=>{},
    onSelect: ()=>{},
    onInputChange: ()=>{},
    isLoading: false,
    disabled: false,
    value: ""
};
// Proptypes Validation
$3a8b1bf51a4fb7a5$var$ButtonFilter.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
    setOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabledOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    filter: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any,
    bottomOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any
};
var $3a8b1bf51a4fb7a5$export$2e2bcd8739ae039 = $3a8b1bf51a4fb7a5$var$ButtonFilter;


var $246a616d3a63a7c1$export$2e2bcd8739ae039 = (0, $3a8b1bf51a4fb7a5$export$2e2bcd8739ae039);


/* eslint-disable react/no-array-index-key */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


parcelRequire("tZqWC");
function $cb5e0819ba2d0c4e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("svg", {
        width: "14",
        height: "8",
        viewBox: "0 0 14 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
            d: "M1 1L6.85858 6.85858C6.93668 6.93668 7.06332 6.93668 7.14142 6.85858L13 1",
            stroke: "#727F97",
            strokeLinecap: "round"
        })
    });
}




const $99184e4597f6f950$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
`;
const $99184e4597f6f950$export$eddf54ea3db8d0f0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  background-color: ${({ theme: theme })=>theme.colors.white};
  border: ${({ theme: theme })=>`2px solid ${theme.colors.lightGray}`};
  color: ${({ theme: theme })=>theme.colors.darkGray};
  padding: 5px;
  border-radius: 10px;

  & button:first-child {
    padding: 3px 10px;
    border-radius: 0;
    border-right: 1px solid ${({ theme: theme })=>theme.colors.white};
  }
  & button:last-child {
    padding: 3px 5px;
  }

  & button {
    background-color: ${({ theme: theme })=>theme.colors.white};
    border: ${({ theme: theme })=>`2px solid ${theme.colors.white}`};
    color: ${({ theme: theme })=>theme.colors.darkGray};
    & svg > * {
      stroke: ${({ theme: theme })=>theme.colors.darkGray};
    }
  }
  & button:hover {
    opacity: 0.8;
    background-color: ${({ theme: theme })=>theme.colors.lightGray};
    border: ${({ theme: theme })=>`2px solid ${theme.colors.lightGray}`};
    color: ${({ theme: theme })=>theme.colors.darkGray};

    & svg > * {
      stroke: ${({ theme: theme })=>theme.colors.darkGray};
    }

    &:last-child {
      border-radius: 0 5px 5px 0;
    }
    &:first-child {
      border-radius: 5px 0 0 5px;
    }
  }
`;
const $99184e4597f6f950$export$8ddf75262614729 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  margin-top: 5px;
  top: 100%;
  right: 0;
  width: 100%;
  z-index: 1;

  display: flex;
  flex-direction: column;
  padding: 10px;

  background-color: ${({ theme: theme })=>theme.colors.white};
  border: ${({ theme: theme })=>`2px solid ${theme.colors.lightGray}`};
  border-radius: 10px;

  & button {
    width: 100%;
    background-color: transparent;
    border: none;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  & button:hover {
    background-color: transparent;
    color: ${({ theme: theme })=>theme.colors.blue};
    border: none;
  }
`;
const $99184e4597f6f950$export$9405ec469c396699 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  border-top: ${({ theme: theme })=>`2px solid ${theme.colors.lightGray}`};
  height: 2px;
`;


function $6f099a07cd068522$var$ButtonSplitSelect(props) {
    // Destructure
    const { type: type, value: value, onClick: onClick, variant: variant, fullWidth: fullWidth, disabled: disabled, options: options, children: children } = props;
    // Hooks
    const [isExpanded, setIsExpanded] = (0, $tZqWC.useState)(false);
    // Refs
    const btnRef = (0, $tZqWC.useRef)();
    // utils
    (0, $54f47a39f461db48$export$50ec7b7ff742aae5)(btnRef, setIsExpanded);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $99184e4597f6f950$export$d53c836cccbb0d90), {
        ref: btnRef,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $99184e4597f6f950$export$eddf54ea3db8d0f0), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        type: type,
                        size: "small",
                        onClick: onClick,
                        variant: variant,
                        fullWidth: fullWidth,
                        disabled: disabled,
                        value: value,
                        children: children && children
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        type: "button",
                        size: "small",
                        onClick: ()=>{
                            setIsExpanded(!isExpanded);
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cb5e0819ba2d0c4e$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            isExpanded && options && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99184e4597f6f950$export$8ddf75262614729), {
                children: options.map((item, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99184e4597f6f950$export$9405ec469c396699), {}),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                color: "tertiary",
                                size: "small",
                                onClick: ()=>{
                                    setIsExpanded(!isExpanded);
                                    item.onClick();
                                },
                                value: item.value,
                                endIcon: item.endIcon
                            }, i)
                        ]
                    }))
            })
        ]
    });
}
// Default Props
$6f099a07cd068522$var$ButtonSplitSelect.defaultProps = {
    onClick: ()=>{},
    type: "primary",
    value: "",
    variant: "contained",
    fullWidth: false,
    disabled: false,
    options: []
};
// Proptypes Validation
$6f099a07cd068522$var$ButtonSplitSelect.propTypes = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        endIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
            (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
        ])
    }))
};
var $6f099a07cd068522$export$2e2bcd8739ae039 = $6f099a07cd068522$var$ButtonSplitSelect;


var $431db40ca57b78c9$export$2e2bcd8739ae039 = (0, $6f099a07cd068522$export$2e2bcd8739ae039);


/* eslint-disable react/no-array-index-key */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $a3c4b54c08f1ad26$export$1a39e1dbc61f7b9a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  padding-bottom: 31px;
  border-collapse: collapse;
`;
const $a3c4b54c08f1ad26$export$b19f7435132f3c6e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  // Themed Properties
  border-bottom: ${({ theme: theme })=>`2px solid ${theme.colors.darkGray}`};

  // Conditional Properties
  ${({ withHeader: withHeader })=>!withHeader && "display: none;"}
`;
const $a3c4b54c08f1ad26$export$36573e250be9fa34 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
`;
const $a3c4b54c08f1ad26$export$d26ce3ae0eb07079 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  padding: 5px 0;
`;
const $a3c4b54c08f1ad26$export$13cdc9bdf71ffbf7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14px;
  font-weight: 400;
  font-family: Roboto;

  text-align: right;
  -webkit-font-smoothing: antialiased;

  // TODO: Use theme functions
  &:first-of-type {
    text-align: left;
  }

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $a3c4b54c08f1ad26$export$b2ec8499d4fe8ec = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  // Conditional Properties
  ${({ withData: withData })=>!withData && "display: none;"}
`;
const $a3c4b54c08f1ad26$export$a090da186c207e1c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  padding: 5px 0;

  // Themed Properties
  border-bottom: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
`;
const $a3c4b54c08f1ad26$export$6ca34208ed16a999 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  padding: 5px 0;

  // Themed Properties
  border-bottom: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
`;
const $a3c4b54c08f1ad26$export$65215521ba8e46f8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14px;
  font-weight: 400;
  font-family: Roboto;

  text-align: right;
  -webkit-font-smoothing: antialiased;

  // TODO: Use theme functions
  &:first-of-type {
    text-align: left;
    font-weight: 100;
  }

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;


function $2e06e4f767ae86c4$var$DataBreakdownTable(props) {
    // Destructure
    const { headers: headers, data: data } = props;
    // Variable
    const withHeader = headers.length;
    const withData = data.length;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a3c4b54c08f1ad26$export$1a39e1dbc61f7b9a), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$b19f7435132f3c6e), {
                withHeader: withHeader,
                children: headers?.length > 2 ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$d26ce3ae0eb07079), {
                    children: headers && headers.map((name, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$13cdc9bdf71ffbf7), {
                            children: name
                        }, i))
                }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$36573e250be9fa34), {
                    children: headers && headers.map((name, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$13cdc9bdf71ffbf7), {
                            children: name
                        }, i))
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$b2ec8499d4fe8ec), {
                withData: withData,
                children: data && headers?.length > 2 ? data.map(({ name: name, data: data }, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a3c4b54c08f1ad26$export$6ca34208ed16a999), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$65215521ba8e46f8), {
                                children: name
                            }),
                            data.map((value, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$65215521ba8e46f8), {
                                    children: value
                                }, i))
                        ]
                    }, i)) : data.map(({ name: name, data: data }, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a3c4b54c08f1ad26$export$a090da186c207e1c), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$65215521ba8e46f8), {
                                children: name
                            }),
                            data.map((value, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$65215521ba8e46f8), {
                                    children: value
                                }, i))
                        ]
                    }, i))
            })
        ]
    });
}
// Default Props
$2e06e4f767ae86c4$var$DataBreakdownTable.defaultProps = {
    headers: [],
    data: []
};
// Proptypes Validation
$2e06e4f767ae86c4$var$DataBreakdownTable.propTypes = {
    headers: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
};
var $2e06e4f767ae86c4$export$2e2bcd8739ae039 = $2e06e4f767ae86c4$var$DataBreakdownTable;


var $a327d89f9c78791e$export$2e2bcd8739ae039 = (0, $2e06e4f767ae86c4$export$2e2bcd8739ae039);


/* eslint-disable react/no-array-index-key */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $53cdb4ba6311901f$export$8be2fd478ca98928 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 0 0 30px 0;
`;
const $53cdb4ba6311901f$export$8be602f50b4943be = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 5px 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 2.3fr;
  
  font-size: 14px;
  font-weight: 300;
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $53cdb4ba6311901f$export$91aee0d5fc0a4b2f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  text-align: right;
  &:first-child {
    text-align: left;
  }
`;
const $53cdb4ba6311901f$export$4b2dccc09b8448ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 5px 0px 10px 0px;

  border-top: ${({ theme: theme })=>`2px solid ${theme.colors.darkGray}`};
  border-bottom: ${({ theme: theme })=>`2px solid ${theme.colors.darkGray}`};

  max-height: 120px;
  min-height: 120px;
  overflow-y: auto;
`;
const $53cdb4ba6311901f$export$ad417a3002a11c59 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  padding-right: 5px;
  
  font-weight: 300;
`;
const $53cdb4ba6311901f$export$ac8475813a60081e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  padding: 5px 0;
  grid-template-columns: 1fr 1fr 1fr 2.3fr;

  border-bottom: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
  
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $53cdb4ba6311901f$export$d7ffd008943baa91 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  text-align: right;
  &:first-child {
    text-align: left;
  }
`;


const $ecf1d77ac1b82678$export$a2db1876938cd11d = (value)=>value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : value;
const $ecf1d77ac1b82678$export$36d5e0d2b514f546 = (value, decimalPlace = 0)=>{
    const si = [
        {
            value: 1,
            symbol: ""
        },
        {
            value: 1e3,
            symbol: " k"
        },
        {
            value: 1e6,
            symbol: " M"
        },
        {
            value: 1e9,
            symbol: " B"
        },
        {
            value: 1e12,
            symbol: " T"
        }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    let i;
    for(i = si.length - 1; i > 0; i--){
        if (Number.isNaN(value) ? 0 : value >= si[i].value) break;
    }
    const safeValue = value / si[i].value || 0;
    return $ecf1d77ac1b82678$export$a2db1876938cd11d(safeValue.toFixed(decimalPlace).replace(rx, "$1")) + si[i].symbol;
};
const $ecf1d77ac1b82678$export$24f8d0049300de03 = (value)=>value.replace("-", " ");
const $ecf1d77ac1b82678$export$866ef2858852149a = Intl.NumberFormat("en", {
    notation: "compact"
});
const $ecf1d77ac1b82678$export$b45ea3e8106087a8 = Intl.NumberFormat("en");
const $ecf1d77ac1b82678$export$7dac1d63a1a3adff = (str)=>str.split(" ").map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(" ");


function $1f039e24a84dc549$var$DataBreakdownTableScroll(props) {
    // Destructure
    const { headers: headers, data: data } = props;
    // Variable
    const withHeader = headers.length;
    const withData = data.length;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $53cdb4ba6311901f$export$8be2fd478ca98928), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $53cdb4ba6311901f$export$8be602f50b4943be), {
                children: withHeader && headers.map((name, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $53cdb4ba6311901f$export$91aee0d5fc0a4b2f), {
                        children: name
                    }, i))
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $53cdb4ba6311901f$export$4b2dccc09b8448ee), {
                children: withData && data.map((item, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $53cdb4ba6311901f$export$ac8475813a60081e), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $53cdb4ba6311901f$export$d7ffd008943baa91), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $53cdb4ba6311901f$export$ad417a3002a11c59), {
                                        children: item.token_symbol
                                    }),
                                    item.token_name
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $53cdb4ba6311901f$export$d7ffd008943baa91), {
                                title: `${(0, $ecf1d77ac1b82678$export$a2db1876938cd11d)(item.balance_usd)}`,
                                children: [
                                    "$",
                                    (0, $ecf1d77ac1b82678$export$36d5e0d2b514f546)(item.balance_usd)
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $53cdb4ba6311901f$export$d7ffd008943baa91), {
                                title: `${(0, $ecf1d77ac1b82678$export$a2db1876938cd11d)(item.balance)}`,
                                children: (0, $ecf1d77ac1b82678$export$36d5e0d2b514f546)(item.balance)
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $53cdb4ba6311901f$export$d7ffd008943baa91), {
                                children: item.token_address
                            })
                        ]
                    }, i))
            })
        ]
    });
}
// Default Props
$1f039e24a84dc549$var$DataBreakdownTableScroll.defaultProps = {
    headers: [],
    data: []
};
// Proptypes Validation
$1f039e24a84dc549$var$DataBreakdownTableScroll.propTypes = {
    headers: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
};
var $1f039e24a84dc549$export$2e2bcd8739ae039 = $1f039e24a84dc549$var$DataBreakdownTableScroll;


var $0ebbffae0cb1277a$export$2e2bcd8739ae039 = (0, $1f039e24a84dc549$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $45b66c5bf83aea2f$export$cdbf26d09eb26f7d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
`;
const $45b66c5bf83aea2f$export$8ffee4d574d6d8ac = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  color: #393e46;
  font-size: 15px;
  font-weight: 300;
  line-height: 24px;
`;
const $45b66c5bf83aea2f$export$e3b367540feed165 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 0 0 100%;
  font-size: 15px;

  // TODO: Use mixins
  &:first-child {
    font-weight: 300;
  }
`;
const $45b66c5bf83aea2f$export$e66a56b9de978542 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0px;

  // Themed Properties
  border-top: 1px solid ${({ theme: theme })=>theme.colors.darkGray};
  border-bottom: 1px solid ${({ theme: theme })=>theme.colors.darkGray};
`;
const $45b66c5bf83aea2f$export$59da4d8dd56c9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 45px;
  font-weight: 300;
`;
const $45b66c5bf83aea2f$export$affe59685c6a9626 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  text-align: right;
`;
const $45b66c5bf83aea2f$export$310103aef48a2fd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-weight: 100;
  font-size: 15px;
  line-height: 16px;
`;
const $45b66c5bf83aea2f$export$dcb4c05eda02c81a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-weight: 100;
  font-size: 15px;
  line-height: 16px;
`;



function $fbb1ca685fba8dda$var$DataBreakdownSummary(props) {
    // Destructure
    const { title: title, figureTotalValue: figureTotalValue, figureTitle: figureTitle, figureSubtitle: figureSubtitle, breakdownData: breakdownData } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $45b66c5bf83aea2f$export$cdbf26d09eb26f7d), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $45b66c5bf83aea2f$export$8ffee4d574d6d8ac), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $45b66c5bf83aea2f$export$e3b367540feed165), {
                    children: title
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $45b66c5bf83aea2f$export$e66a56b9de978542), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $45b66c5bf83aea2f$export$59da4d8dd56c9ef), {
                            children: figureTotalValue
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $45b66c5bf83aea2f$export$affe59685c6a9626), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $45b66c5bf83aea2f$export$310103aef48a2fd), {
                                    children: figureTitle
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $45b66c5bf83aea2f$export$dcb4c05eda02c81a), {
                                    children: figureSubtitle
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a327d89f9c78791e$export$2e2bcd8739ae039), {
                    data: breakdownData
                })
            ]
        })
    });
}
// Default Props
$fbb1ca685fba8dda$var$DataBreakdownSummary.defaultProps = {
    title: "Title",
    figureTotalValue: 0,
    figureTitle: "Figure Title",
    figureSubtitle: "Figure Subtitle",
    breakdownData: []
};
// Proptypes Validation
$fbb1ca685fba8dda$var$DataBreakdownSummary.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    figureTotalValue: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    figureTitle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    figureSubtitle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    breakdownData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
};
var $fbb1ca685fba8dda$export$2e2bcd8739ae039 = $fbb1ca685fba8dda$var$DataBreakdownSummary;


var $67f236fcb92e6fa6$export$2e2bcd8739ae039 = (0, $fbb1ca685fba8dda$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $e43d514ba8169b10$export$aa2701f40b51de05 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  width: 100%;
`;
const $e43d514ba8169b10$export$8e997029ddacd4cf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 62px;

  padding: 10px 10px 0px 10px;
  border-radius: 5px;

  background-color: ${({ theme: theme })=>theme.colors.white};
  color: ${({ theme: theme })=>theme.colors.darkGray};
  border: ${({ theme: theme })=>`solid 1px ${theme.colors.lightGray}`};
`;
const $e43d514ba8169b10$export$85f6abbce7b266fb = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  font-weight: 500;
`;
const $e43d514ba8169b10$export$4e5b825bf7b8903c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 30px;
  font-weight: 500;
`;
const $e43d514ba8169b10$export$97092a2fc35766fa = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  position: absolute;
  bottom: 7px;
  right: 7px;

`;


function $a9d13c554082a3aa$var$AlertBreakDownBoxes(props) {
    // Destructure
    const { data: data } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e43d514ba8169b10$export$aa2701f40b51de05), {
        children: data?.length > 0 && data.map((item)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e43d514ba8169b10$export$8e997029ddacd4cf), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e43d514ba8169b10$export$85f6abbce7b266fb), {
                        children: [
                            item.alert_status,
                            " Alerts"
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e43d514ba8169b10$export$4e5b825bf7b8903c), {
                        children: item.alert_count
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e43d514ba8169b10$export$97092a2fc35766fa), {
                        children: [
                            item.percent,
                            "%"
                        ]
                    })
                ]
            }, item.alert_status))
    });
}
// Default Props
$a9d13c554082a3aa$var$AlertBreakDownBoxes.defaultProps = {
    data: []
};
// Proptypes Validation
$a9d13c554082a3aa$var$AlertBreakDownBoxes.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        alert_status: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        alert_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        percent: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    }))
};
var $a9d13c554082a3aa$export$2e2bcd8739ae039 = $a9d13c554082a3aa$var$AlertBreakDownBoxes;


var $b31c725c94cb80b7$export$2e2bcd8739ae039 = (0, $a9d13c554082a3aa$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $f0bb4b958e2c14ca$export$5f7211d21bfdae05 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $51b32cf9efbde13e$export$931cbfb6bfb85fc))`
  display: flex;
  align-items: center;
`;


function $45c3eac682169e84$var$Dropdown(props) {
    // Destructure
    const { children: children, direction: direction, isOpen: isOpen, toggle: toggle, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f0bb4b958e2c14ca$export$5f7211d21bfdae05), {
        isOpen: isOpen,
        toggle: toggle,
        direction: direction,
        ...rest,
        children: children
    });
}
// Default Props
$45c3eac682169e84$var$Dropdown.defaultProps = {
    children: "",
    direction: "",
    isOpen: false,
    toggle: ()=>{}
};
// Proptypes Validation
$45c3eac682169e84$var$Dropdown.propTypes = {
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $45c3eac682169e84$export$2e2bcd8739ae039 = $45c3eac682169e84$var$Dropdown;


var $3d924f0f94116478$export$2e2bcd8739ae039 = (0, $45c3eac682169e84$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $6131ff7b0912a79b$export$f713b95536ce1a73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $51b32cf9efbde13e$export$b92340dd2916436))`
  display: flex;
  align-items: center;

  & > div {
    padding: 0;
  }
`;


function $89b7e4c0bcb049ea$var$UncontrolledDropdown(props) {
    // Destructure
    const { children: children, direction: direction, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6131ff7b0912a79b$export$f713b95536ce1a73), {
        direction: direction,
        ...rest,
        children: children
    });
}
// Default Props
$89b7e4c0bcb049ea$var$UncontrolledDropdown.defaultProps = {
    children: "",
    direction: ""
};
// Proptypes Validation
$89b7e4c0bcb049ea$var$UncontrolledDropdown.propTypes = {
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $89b7e4c0bcb049ea$export$2e2bcd8739ae039 = $89b7e4c0bcb049ea$var$UncontrolledDropdown;


var $ca6f920a36c82944$export$2e2bcd8739ae039 = (0, $89b7e4c0bcb049ea$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $1662035c760adcc4$export$145fd9ebbc372ed1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $51b32cf9efbde13e$export$8d5b7ffbb681f107))`
  position: relative;
  padding: 0 5px;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;

  // Themed Properties
  ${({ theme: theme })=>theme.functions.mixins.onEvent(`
    box-shadow: none;
    outline: 0;
  `)}
`;


function $76b4630bf899438e$var$DropdownToggle(props) {
    // Destructure
    const { children: children, caret: caret, color: color } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1662035c760adcc4$export$145fd9ebbc372ed1), {
        caret: caret,
        color: color,
        tag: "div",
        children: children
    });
}
// Default Props
$76b4630bf899438e$var$DropdownToggle.defaultProps = {
    caret: false,
    color: "",
    children: ""
};
// Proptypes Validation
$76b4630bf899438e$var$DropdownToggle.propTypes = {
    caret: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $76b4630bf899438e$export$2e2bcd8739ae039 = $76b4630bf899438e$var$DropdownToggle;


var $478ff5739380e08c$export$2e2bcd8739ae039 = (0, $76b4630bf899438e$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $a8d803bdab3860a6$export$830205478e704534 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $51b32cf9efbde13e$export$e44a253a59704894))`
  padding: 5px;
  margin: 5px;
  border: 1px solid ${({ theme: theme })=>theme.colors.lightGray};
  background: ${({ theme: theme })=>theme.colors.white};
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  min-width: 230px;
`;


function $9a31681822d9be3d$var$DropdownMenu(props) {
    // Destructure
    const { children: children, left: left, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a8d803bdab3860a6$export$830205478e704534), {
        end: left,
        ...rest,
        children: children
    });
}
// Default Props
$9a31681822d9be3d$var$DropdownMenu.defaultProps = {
    left: false,
    children: ""
};
// Proptypes Validation
$9a31681822d9be3d$var$DropdownMenu.propTypes = {
    left: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $9a31681822d9be3d$export$2e2bcd8739ae039 = $9a31681822d9be3d$var$DropdownMenu;


var $7a68433660fee9cb$export$2e2bcd8739ae039 = (0, $9a31681822d9be3d$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $8f5f74328f70d5cb$export$9483a234b63f52ae = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;

  padding: 8px 20px;

  font-weight: 300;
  font-size: 16px;
  color: ${({ theme: theme, disabled: disabled })=>disabled ? theme.colors.blue : theme.colors.darkGray};

  transition: 0.3s;
  cursor: pointer;

  & svg {
    max-width: 20px;
  }
  & svg > path {
    stroke: ${({ theme: theme })=>theme.colors.darkGray};
  }
  & svg > ellipse {
    fill: ${({ theme: theme })=>theme.colors.darkGray};
  }
  & svg > circle {
    stroke: ${({ theme: theme })=>theme.colors.darkGray};
  }
  & svg > rect {
    stroke: ${({ theme: theme })=>theme.colors.darkGray};
  }
  &:not(:last-child) {
    border-bottom: 2px solid ${({ theme: theme })=>theme.colors.lightGray};
  }
  &:first-child {
    border-radius: 7px 7px 0 0;
  }
  &:last-child {
    border-radius: 0 0 7px 7px;
  }
  &:only-child {
    border-radius: 7px;
  }

  &:hover {
    background-color: ${({ theme: theme, disabled: disabled })=>!disabled && theme.colors.lightGray};
  }

  &:focus {
    background-color: unset;
    color: inherit;
  }

  cursor: ${({ disabled: disabled })=>disabled && "not-allowed"};

  & p {
    color: ${({ theme: theme, disabled: disabled })=>disabled ? theme.colors.gray : theme.colors.darkGray};
  }
  & a {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 200px;

    padding: 5px 0px;
    font-size: 15px;
    font-weight: 400;
    color: ${({ theme: theme, disabled: disabled })=>disabled ? theme.colors.gray : theme.colors.darkGray};

    & > svg {
      height: 12px;
      width: 12px;
    }
  }
`;


function $59b3f17000547f94$var$DropdownItem(props) {
    // Destructure
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8f5f74328f70d5cb$export$9483a234b63f52ae), {
        ...rest,
        children: children
    });
}
// Default Props
$59b3f17000547f94$var$DropdownItem.defaultProps = {
    children: ""
};
// Proptypes Validation
$59b3f17000547f94$var$DropdownItem.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $59b3f17000547f94$export$2e2bcd8739ae039 = $59b3f17000547f94$var$DropdownItem;


var $c7b007afae0a2778$export$2e2bcd8739ae039 = (0, $59b3f17000547f94$export$2e2bcd8739ae039);


/* eslint-disable no-nested-ternary */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $5155947f39a5fc97$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  height: fit-content;
  min-height: 600px;

  font-size: 18px;

  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const $5155947f39a5fc97$export$3613a8ca9911582e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 20px;
  border-radius: 15px;

  // Themed Properties
  background: ${({ theme: theme })=>theme.colors.white};
  border: 1px solid ${({ theme: theme })=>theme.colors.lightGray};
`;
const $5155947f39a5fc97$export$95894068160c7b16 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-self: flex-end;
`;
const $5155947f39a5fc97$export$a8c98c079905a0dd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  gap: 5px;
`;
const $5155947f39a5fc97$export$ca4b1fc43afa0212 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;

  height: 0px;
  width: 100%;
  padding: 0px 20px;
  border: 1px solid ${({ theme: theme })=>theme.colors.white};
  border-top: none;
  border-radius: 0 0 15px 15px;
  transform: translateY(-22px);

  transition: all 0.3s;

  // Themed Properties
  background: ${({ theme: theme })=>theme.colors.white};

  // Responsive Properties
  ${({ theme: theme })=>theme.functions.mediaQuery("display", [
        "none",
        "none",
        "none",
        "none",
        "none",
        "flex"
    ])}

  // Conditional Properties
  ${({ collapseFilter: collapseFilter, withFilter: withFilter })=>!collapseFilter && withFilter ? "height: auto;" : "height: 0;"}
  ${({ collapseFilter: collapseFilter, withFilter: withFilter })=>!collapseFilter && withFilter && "padding: 20px;"}
  ${({ collapseFilter: collapseFilter, withFilter: withFilter })=>!collapseFilter && withFilter ? "overflow: visible;" : "overflow: hidden;"}
  ${({ theme: theme, collapseFilter: collapseFilter, withFilter: withFilter })=>!collapseFilter && withFilter && `border: 1px solid ${theme.colors.lightGray}; border-top: none;`}
`;
const $5155947f39a5fc97$export$bdc7a021372550df = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  overflow-x: visible;
`;
const $5155947f39a5fc97$export$e69b868dadc3d68f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  ${({ minWidth: minWidth })=>minWidth && `min-width: ${minWidth}px;`}
`;
const $5155947f39a5fc97$export$f8fabc1369b3b337 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: none;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: ${(props)=>props.gap ? `${props.gap}px` : "10px"};

  padding: ${(props)=>props.headerPadding ? `${props.headerPadding}` : "20px"};
  border: 1px solid ${({ theme: theme })=>theme.colors.lightGray};
  background: ${({ theme: theme })=>theme.colors.darkishWhite};
  border-radius: 15px;

  // Conditional Properties
  ${({ showHeader: showHeader })=>showHeader && "display: flex;"}
`;
const $5155947f39a5fc97$export$7c49f4ee92af794 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  white-space: nowrap;

  text-align: left;
  font-weight: 400;
  font-size: 15px;
  font-family: Roboto;

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.darkGray};

  // Conditional Properties
  ${({ sortable: sortable })=>sortable && "cursor: pointer;"}
  ${({ width: width })=>width && `width: ${width}px;`}
  ${({ width: width })=>width && "flex: none;"}
`;
const $5155947f39a5fc97$export$7afd0841c5547fb9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $5155947f39a5fc97$export$6facde1b466086d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  text-align: left;
  font-size: 12px;
  font-weight: 300;
`;
const $5155947f39a5fc97$export$cd1a4d589804f400 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  display: none;

  margin: 0px 0px 0px 6px;
  transition: all 0.1s ease-in;

  // Conditional Properties
  ${({ active: active })=>active && "display: flex;"}
  ${({ sortDirection: sortDirection })=>sortDirection === "DESC" && "transform: rotate(180deg);"}
`;
const $5155947f39a5fc97$export$58cbaf49f81d530a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;



// Map Redux Props
const $0fc581bc3bb7f47f$var$mapStateToProps = ({ filters: filters })=>({
        filters: filters
    });
const $0fc581bc3bb7f47f$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $0fc581bc3bb7f47f$var$Table(props) {
    // Destructure
    const { totalItems: totalItems, filterComponents: filterComponents, tableFilters: tableFilters, hidePagination: hidePagination, setTableFilters: setTableFilters, children: children, minWidth: minWidth } = props;
    // States
    const { size: size, page: page } = tableFilters;
    // Functions
    const handlePageChange = async ({ page: page, size: size })=>{
        await setTableFilters({
            ...tableFilters,
            page: page,
            size: size
        });
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5155947f39a5fc97$export$4267411171632d35), {
                allowZeroExpanded: true,
                children: [
                    filterComponents && filterComponents,
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5155947f39a5fc97$export$bdc7a021372550df), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5155947f39a5fc97$export$e69b868dadc3d68f), {
                            minWidth: minWidth,
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5155947f39a5fc97$export$58cbaf49f81d530a), {
                                children: children
                            })
                        })
                    })
                ]
            }),
            !hidePagination && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9deaec2f043c7dfd$export$2e2bcd8739ae039), {
                itemsCountPerPage: size,
                totalItemsCount: totalItems,
                page: page,
                pageRangeDisplayed: 5,
                onChange: handlePageChange
            })
        ]
    });
}
// Default Props
$0fc581bc3bb7f47f$var$Table.defaultProps = {
    totalItems: 0,
    filterComponents: "",
    filters: {},
    actions: {}
};
// Proptypes Validation
$0fc581bc3bb7f47f$var$Table.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    minWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    totalItems: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    filterComponents: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    tableFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        sortBy: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        sortDirection: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    }),
    setTableFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        caseManagementFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            sortBy: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            sortDirection: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        })
    }),
    hidePagination: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setCaseManagementFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $0fc581bc3bb7f47f$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($0fc581bc3bb7f47f$var$mapStateToProps, $0fc581bc3bb7f47f$var$mapDispatchToProps)($0fc581bc3bb7f47f$var$Table);


var $06a400f584629957$export$2e2bcd8739ae039 = (0, $0fc581bc3bb7f47f$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $4806464c0fb19f25$export$70e76e17cbdfd358 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 10px 20px;

  // TODO: Use theme functions
  &:focus {
    outline: none;
  }

  border-radius: 10px;
  background: ${({ theme: theme })=>theme.colors.white};
  border: 1px solid ${({ theme: theme })=>theme.colors.lightGray};

  transition: 0.3s;
  border: 1px solid ${({ theme: theme })=>`${theme.colors.lightGray}`};
  &:hover {
    border: 1px solid ${({ theme: theme })=>`${theme.colors.blue}40`};
  }
`;
const $4806464c0fb19f25$export$97f72a458f7f2793 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const $4806464c0fb19f25$export$c8ac3ff7edb21922 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  font-weight: 100;
  font-size: 15px;
`;
const $4806464c0fb19f25$export$1bc4a606727dc98c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  max-height: 30px;
  max-width: 30px;

  transition: all 0.15s ease-in;
`;
const $4806464c0fb19f25$export$b31430871ee3a3a7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  max-height: 30px;
  max-width: 30px;

  transition: all 0.15s ease-in;
`;


function $10726a98b7d7fa02$var$TableItem(props) {
    // Destructure
    const { children: children, startIcon: startIcon, endIcon: endIcon } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4806464c0fb19f25$export$70e76e17cbdfd358), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $4806464c0fb19f25$export$97f72a458f7f2793), {
            children: [
                startIcon && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4806464c0fb19f25$export$1bc4a606727dc98c), {
                    children: startIcon
                }),
                children && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4806464c0fb19f25$export$c8ac3ff7edb21922), {
                    children: children
                }),
                endIcon && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4806464c0fb19f25$export$b31430871ee3a3a7), {
                    children: endIcon
                })
            ]
        })
    });
}
// Default Props
$10726a98b7d7fa02$var$TableItem.defaultProps = {
    children: "",
    endIcon: "",
    startIcon: ""
};
// Proptypes Validation
$10726a98b7d7fa02$var$TableItem.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    endIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    startIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $10726a98b7d7fa02$export$2e2bcd8739ae039 = $10726a98b7d7fa02$var$TableItem;


var $f32a2c939d2829ea$export$2e2bcd8739ae039 = (0, $10726a98b7d7fa02$export$2e2bcd8739ae039);


/* eslint-disable react/forbid-prop-types */ /* eslint-disable no-nested-ternary */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $6baa47136ba9474d$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  height: fit-content;
  min-height: 500px;
  height: 100%;

  font-size: 18px;
`;
const $6baa47136ba9474d$export$95894068160c7b16 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 20px;
`;
const $6baa47136ba9474d$export$a8c98c079905a0dd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  gap: 5px;
  margin-bottom: -20px;
`;
const $6baa47136ba9474d$export$e69b868dadc3d68f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 40px;
  width: 100%;
`;
const $6baa47136ba9474d$export$58cbaf49f81d530a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: ${({ length: length })=>length > 1 ? "repeat(auto-fill, minmax(300px, 1fr))" : "1fr"};
  gap: 20px;
`;



// Map Redux Props
function $b35d29c6fded8c5e$var$Table(props) {
    // Destructure
    const { headerOptions: headerOptions, children: children, totalItems: totalItems, minWidth: minWidth, filterComponents: filterComponents, tableFilters: tableFilters, setTableFilters: setTableFilters, tableKey: tableKey } = props;
    const { size: size, page: page } = tableFilters;
    const handlePageChange = async ({ page: page, size: size })=>{
        await setTableFilters({
            ...tableFilters,
            page: page,
            size: size
        });
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6baa47136ba9474d$export$4267411171632d35), {
                allowZeroExpanded: true,
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6baa47136ba9474d$export$95894068160c7b16), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6baa47136ba9474d$export$a8c98c079905a0dd), {
                            children: headerOptions
                        })
                    }),
                    filterComponents && filterComponents,
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6baa47136ba9474d$export$e69b868dadc3d68f), {
                        minWidth: minWidth,
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6baa47136ba9474d$export$58cbaf49f81d530a), {
                            length: (0, $tZqWC.Children).count(children),
                            children: children
                        }, tableKey)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9deaec2f043c7dfd$export$2e2bcd8739ae039), {
                itemsCountPerPage: size,
                totalItemsCount: totalItems,
                page: page,
                pageRangeDisplayed: 5,
                onChange: handlePageChange
            })
        ]
    });
}
// Default Props
$b35d29c6fded8c5e$var$Table.defaultProps = {
    tableKey: undefined,
    headerOptions: "",
    children: "",
    minWidth: 0,
    totalItems: 0,
    filterComponents: "",
    tableFilters: {},
    actions: {}
};
// Proptypes Validation
$b35d29c6fded8c5e$var$Table.propTypes = {
    tableKey: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any,
    headerOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    minWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    totalItems: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    filterComponents: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    setTableFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    tableFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setCaseManagementFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $b35d29c6fded8c5e$export$2e2bcd8739ae039 = $b35d29c6fded8c5e$var$Table;


var $7139282abdeb8ca4$export$2e2bcd8739ae039 = (0, $b35d29c6fded8c5e$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $f2fd2af94c5311d7$export$70e76e17cbdfd358 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  border-radius: 10px;
  width: 100%;
  height: 100%;
  max-width: 450px;
  transition: 0.3s;
  cursor: pointer;

  /* display: flex;
  justify-content: center;
  align-items: center; */

  // Themed Properties
  background-color: ${({ theme: theme })=>theme.colors.white};
  border: 1px solid ${({ theme: theme })=>theme.colors.lightGray};
  color: ${({ theme: theme })=>theme.colors.darkGray};
  border: 1px solid ${({ theme: theme })=>`${theme.colors.lightGray}`};
  &:hover {
    border: 1px solid ${({ theme: theme })=>`${theme.colors.blue}40`};
  }
`;


function $7d6426b4158f873d$var$CardTableItem(props) {
    // Destructure
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f2fd2af94c5311d7$export$70e76e17cbdfd358), {
        ...rest,
        children: children && children
    });
}
// Default Props
$7d6426b4158f873d$var$CardTableItem.defaultProps = {
    children: ""
};
// Proptypes Validation
$7d6426b4158f873d$var$CardTableItem.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $7d6426b4158f873d$export$2e2bcd8739ae039 = $7d6426b4158f873d$var$CardTableItem;


var $37202d75ee8521c4$export$2e2bcd8739ae039 = (0, $7d6426b4158f873d$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");
const $60e52eb6c2680325$export$96c4cef8dff1bd45 = ()=>{
    const token = localStorage.getItem("userCredentials");
    if (!token) return null;
    try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = atob(base64);
        const credentials = JSON.parse(jsonPayload);
        if (credentials?.csi !== undefined && credentials?.csi !== null) return credentials?.csi;
        return null;
    } catch (error) {
        return null;
    }
};
const $60e52eb6c2680325$export$7ca4b19155f576fa = (toggleUpgradeModal)=>{
    toggleUpgradeModal(true);
};



const $e96331e94b302397$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  height: fit-content;
  min-height: 600px;

  font-size: 18px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const $e96331e94b302397$export$ee4732a561d65ad3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex: 1;
`;
const $e96331e94b302397$export$14966827497f4695 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  // Conditional Properties
  ${({ minWidth: minWidth })=>minWidth && `min-width: ${minWidth}px;`}
`;
const $e96331e94b302397$export$95894068160c7b16 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: -20px;
`;
const $e96331e94b302397$export$a8c98c079905a0dd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  gap: 5px;
  width: 100%;
`;
const $e96331e94b302397$export$db7e3192f4fa5264 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  width: 100%;
`;



function $354ef3273ec6220e$var$AccordionTable(props) {
    // Destructure
    const { headerOptions: headerOptions, children: children, minWidth: minWidth, totalItems: totalItems, filterComponents: filterComponents, tableFilters: tableFilters, setTableFilters: setTableFilters } = props;
    // States
    const { size: size, page: page } = tableFilters;
    const [csi] = (0, $tZqWC.useState)((0, $60e52eb6c2680325$export$96c4cef8dff1bd45)());
    // Variables
    // Functions
    const handlePageChange = async ({ page: page, size: size })=>{
        await setTableFilters({
            ...tableFilters,
            page: page,
            size: size
        });
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e96331e94b302397$export$e6dfd72ab29f8598), {
                allowZeroExpanded: true,
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e96331e94b302397$export$95894068160c7b16), {
                        children: headerOptions && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e96331e94b302397$export$a8c98c079905a0dd), {
                            children: headerOptions
                        })
                    }),
                    filterComponents && filterComponents,
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e96331e94b302397$export$ee4732a561d65ad3), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e96331e94b302397$export$14966827497f4695), {
                            minWidth: minWidth,
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e96331e94b302397$export$db7e3192f4fa5264), {
                                children: children
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9deaec2f043c7dfd$export$2e2bcd8739ae039), {
                itemsCountPerPage: size,
                totalItemsCount: totalItems,
                page: page,
                pageRangeDisplayed: 5,
                onChange: handlePageChange
            })
        ]
    });
}
// Default Props
$354ef3273ec6220e$var$AccordionTable.defaultProps = {
    headerOptions: "",
    children: "",
    minWidth: 0,
    totalItems: 0,
    filterComponents: "",
    tableFilters: {},
    setTableFilters: ()=>{}
};
// Proptypes Validation
$354ef3273ec6220e$var$AccordionTable.propTypes = {
    headerOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    minWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    totalItems: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    filterComponents: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    tableFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        sortBy: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        sortDirection: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    }),
    setTableFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $354ef3273ec6220e$export$2e2bcd8739ae039 = $354ef3273ec6220e$var$AccordionTable;


var $d2b0b55dc8f66a40$export$2e2bcd8739ae039 = (0, $354ef3273ec6220e$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $27ae8f806736fbfc$export$d99097c13d4dac9f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin-bottom: 5px;
`;
const $27ae8f806736fbfc$export$9837e16d1af48a7e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  cursor: pointer;
`;
const $27ae8f806736fbfc$export$b341db839aa4fe47 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 5px 20px;
  transition: all 0.3s;
  -webkit-font-smoothing: antialiased;

  // TODO: Use theme functions
  &:focus {
    outline: none;
  }

  border: 1px solid ${({ theme: theme })=>theme.colors.lightGray};
  color: ${({ theme: theme })=>theme.colors.darkGray};
  border-radius: 10px;
  background: ${({ theme: theme })=>theme.colors.white};
  ${({ expanded: expanded })=>expanded && "border-radius: 10px 10px 0 0"};

  &:hover {
    border: 1px solid ${({ theme: theme })=>`${theme.colors.blue}40`};
  }
`;
const $27ae8f806736fbfc$export$be2ca760d2eb1165 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  position: relative;
`;
const $27ae8f806736fbfc$export$f2abb93903ae27ea = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  padding: 0;
  font-size: 15px;
  font-weight: 100;
`;
const $27ae8f806736fbfc$export$2abe7b6f8bf4f242 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
  height: 40px;
  width: 40px;
  cursor: pointer;
  border-radius: 50%;

  transition: all 0.3s;
  & svg > path {
    stroke: ${({ theme: theme })=>theme.colors.darkGray};
  }
  &:hover {
    background-color: ${({ theme: theme })=>theme.colors.lightGray};
  }

  // Conditional Properties
  ${({ withExpandIcon: withExpandIcon })=>!withExpandIcon && "display: none;"}
  ${({ expanded: expanded })=>expanded && "transform: rotate(180deg) translateY(50%);"};
`;
const $27ae8f806736fbfc$export$94c75639e734cc35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 0 20px;
  height: 0px;
  ${({ expanded: expanded })=>expanded ? "overflow: visible;" : "overflow: hidden;"}

  transition: all 0.3s;
  background: ${({ theme: theme })=>theme.colors.white};
  border: 1px solid ${({ theme: theme })=>theme.colors.lightGray};
  border-top: none;
  border-bottom: none;
  border-radius: 0 0 10px 10px;

  ${({ expanded: expanded })=>expanded && "height: auto; padding: 20px;"}
  ${({ expanded: expanded, theme: theme })=>expanded && `border-bottom: 1px solid ${theme.colors.lightGray};`}
`;


function $1761af5eb4bcf74d$var$AccordionTableItem(props) {
    // Destructure
    const { button: button, panel: panel, withExpandIcon: withExpandIcon, expandIcon: expandIcon, setIsExpanded: setIsExpanded, expandPanel: expandPanel, ...rest } = props;
    const wrapperRef = (0, $tZqWC.useRef)();
    // TODO ADD THIS FEATURE BACK BUT NOT AN OUTSIDE ALERTER
    // TODO make the item close only when clicking another item. not on click away
    // useOutsideAlerter(wrapperRef, setIsExpanded)
    // Functions
    const handleExpand = (event)=>{
        if (event.target.className?.baseVal && event.target.className?.baseVal === "hashWrapper") return;
        if (typeof event.target.className === "string" && event.target.className !== "") {
            const classnames = event.target.className.split(" ");
            if (classnames.indexOf("hashWrapper") > -1) return;
        }
        setIsExpanded((prevState)=>!prevState);
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $27ae8f806736fbfc$export$d99097c13d4dac9f), {
        ref: wrapperRef,
        ...rest,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $27ae8f806736fbfc$export$9837e16d1af48a7e), {
                onClick: handleExpand,
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $27ae8f806736fbfc$export$b341db839aa4fe47), {
                    expanded: expandPanel ? 1 : 0,
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $27ae8f806736fbfc$export$be2ca760d2eb1165), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $27ae8f806736fbfc$export$f2abb93903ae27ea), {
                                children: /*#__PURE__*/ (0, $tZqWC.cloneElement)(button, {
                                    expanded: expandPanel
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $27ae8f806736fbfc$export$2abe7b6f8bf4f242), {
                                withExpandIcon: withExpandIcon ? 1 : 0,
                                expanded: expandPanel ? 1 : 0,
                                children: expandIcon || /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cb5e0819ba2d0c4e$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $27ae8f806736fbfc$export$94c75639e734cc35), {
                expanded: expandPanel ? 1 : 0,
                children: /*#__PURE__*/ (0, $tZqWC.cloneElement)(panel, {
                    expanded: expandPanel
                })
            })
        ]
    });
}
// Default Props
$1761af5eb4bcf74d$var$AccordionTableItem.defaultProps = {
    button: "",
    panel: "",
    withExpandIcon: true,
    expandIcon: "",
    expandPanel: false
};
// Proptypes Validation
$1761af5eb4bcf74d$var$AccordionTableItem.propTypes = {
    button: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    panel: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    withExpandIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    expandIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    setIsExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    expandPanel: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $1761af5eb4bcf74d$export$2e2bcd8739ae039 = $1761af5eb4bcf74d$var$AccordionTableItem;


var $b3f7dc6528742bb0$export$2e2bcd8739ae039 = (0, $1761af5eb4bcf74d$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $57bdb122e3a1d55f$export$651b1d8cb53f440a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  padding: 20px 0;
`;
const $57bdb122e3a1d55f$export$1873c29c05a8ea07 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $57bdb122e3a1d55f$export$5944fbbbb3039079 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $57bdb122e3a1d55f$export$b2ac77728d2817af = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1.8;
`;
const $57bdb122e3a1d55f$export$4d4c554f88ffa0ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;

  padding: 0px 0px 0px 20px;
`;
const $57bdb122e3a1d55f$export$1a93101d4b5afe6a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
`;
const $57bdb122e3a1d55f$export$9c2ca51ac581de42 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 6px 0px;
  
  font-size: 16px;
  font-weight: 500;
  
  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $57bdb122e3a1d55f$export$8dc49548733a6fce = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;


const $5da03e9742b402e0$export$755b68ef863b5f58 = [
    {
        Asset: "BTC",
        Chain: "Bitcoin",
        Balance_USD: 23,
        Balance: 141125151,
        Contract: "1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa"
    },
    {
        Asset: "BTC",
        Chain: "Bitcoin",
        Balance_USD: 23,
        Balance: 141125151,
        Contract: "1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa"
    },
    {
        Asset: "BTC",
        Chain: "Bitcoin",
        Balance_USD: 23,
        Balance: 141125151,
        Contract: "1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa"
    },
    {
        Asset: "BTC",
        Chain: "Bitcoin",
        Balance_USD: 23,
        Balance: 141125151,
        Contract: "1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa"
    },
    {
        Asset: "BTC",
        Chain: "Bitcoin",
        Balance_USD: 23,
        Balance: 141125151,
        Contract: "1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa"
    },
    {
        Asset: "BTC",
        Chain: "Bitcoin",
        Balance_USD: 23,
        Balance: 141125151,
        Contract: "1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa"
    },
    {
        Asset: "BTC",
        Chain: "Bitcoin",
        Balance_USD: 23,
        Balance: 141125151,
        Contract: "1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa"
    }
];
const $5da03e9742b402e0$export$2fcb5ef18466f82d = [
    "Token Name",
    "USD Balance",
    "Balance",
    "Contract"
];



function $3d0834dd6b2d946a$var$AccordionTableDetails(props) {
    // Destructure
    const { data: { itemDetails: itemDetails, totalDetails: totalDetails, accountDetails: accountDetails, token: token, notes: notes }, type: type, onTextChange: onTextChange, caseLoading: caseLoading } = props;
    // State
    const [textValue, setTextValue] = (0, $tZqWC.useState)(notes);
    const [isNoteLoading, setIsNoteLoading] = (0, $tZqWC.useState)(false);
    // Variables
    const itemTitle = type === "address" ? "Address Details" : "Transaction Details";
    // Functions
    const handleTextChange = (e)=>{
        setTextValue(e.target.value);
        onTextChange(e.target.value, setIsNoteLoading);
    // the loading state must be in the child component for it to re render
    // the state is changed in the parent because debounce isnt working in the child component
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $57bdb122e3a1d55f$export$651b1d8cb53f440a), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $57bdb122e3a1d55f$export$5944fbbbb3039079), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $57bdb122e3a1d55f$export$b2ac77728d2817af), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $57bdb122e3a1d55f$export$9c2ca51ac581de42), {
                                children: itemTitle
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $57bdb122e3a1d55f$export$1a93101d4b5afe6a), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a327d89f9c78791e$export$2e2bcd8739ae039), {
                                    headers: itemDetails.headers,
                                    data: itemDetails.data
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $57bdb122e3a1d55f$export$1a93101d4b5afe6a), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a327d89f9c78791e$export$2e2bcd8739ae039), {
                                    headers: totalDetails.headers,
                                    data: totalDetails.data
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $57bdb122e3a1d55f$export$4d4c554f88ffa0ee), {
                        children: [
                            !caseLoading && accountDetails && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $57bdb122e3a1d55f$export$9c2ca51ac581de42), {
                                        children: "Account Information"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $57bdb122e3a1d55f$export$1a93101d4b5afe6a), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a327d89f9c78791e$export$2e2bcd8739ae039), {
                                            headers: accountDetails.headers,
                                            data: accountDetails.data
                                        })
                                    })
                                ]
                            }),
                            caseLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $57bdb122e3a1d55f$export$8dc49548733a6fce), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6fa6c8d0625529f$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                ]
            }),
            token && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $57bdb122e3a1d55f$export$1873c29c05a8ea07), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $57bdb122e3a1d55f$export$9c2ca51ac581de42), {
                        children: "Token Information"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0ebbffae0cb1277a$export$2e2bcd8739ae039), {
                        headers: (0, $5da03e9742b402e0$export$2fcb5ef18466f82d),
                        data: token
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $57bdb122e3a1d55f$export$1873c29c05a8ea07), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $57bdb122e3a1d55f$export$9c2ca51ac581de42), {
                        children: "Note"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d03facd9d698d253$export$2e2bcd8739ae039), {
                        saveLoading: isNoteLoading,
                        value: textValue,
                        onChange: handleTextChange,
                        resize: true,
                        rows: 4,
                        placeholder: "Write a note"
                    })
                ]
            })
        ]
    });
}
// Default Props
$3d0834dd6b2d946a$var$AccordionTableDetails.defaultProps = {
    type: "",
    data: {},
    onTextChange: ()=>{},
    caseLoading: false
};
// Proptypes Validation
$3d0834dd6b2d946a$var$AccordionTableDetails.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        itemDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            headers: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
            data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
        }),
        totalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            headers: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
            data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
        }),
        accountDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            headers: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
            data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
        }),
        token: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
        ]),
        notes: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    onTextChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    caseLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $3d0834dd6b2d946a$export$2e2bcd8739ae039 = $3d0834dd6b2d946a$var$AccordionTableDetails;


var $5aace8fc7165a7c2$export$2e2bcd8739ae039 = (0, $3d0834dd6b2d946a$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $b62c33fdd70157e1$export$946f6311cdbdcb12 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 19px;
  margin-left: 1px;
  margin-right: 1px;
  width: 12px;
  background-color: ${({ theme: theme })=>theme.colors.ash};
  font-weight: inherit;
  font-size: inherit;

  // Conditional Properties
  ${({ height: height })=>height && `height: ${height}px;`}
  ${({ width: width })=>width && `width: ${width}px;`};
  ${({ color: color })=>color && `background-color: ${color};`};
`;


function $66b880b88d16fd6c$var$TextBlur(props) {
    // Destructure
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b62c33fdd70157e1$export$946f6311cdbdcb12), {
        width: width,
        height: height,
        color: color
    });
}
// Default Props
$66b880b88d16fd6c$var$TextBlur.defaultProps = {
    width: "",
    height: "",
    color: ""
};
// Proptypes Validation
$66b880b88d16fd6c$var$TextBlur.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $66b880b88d16fd6c$export$2e2bcd8739ae039 = $66b880b88d16fd6c$var$TextBlur;


var $5a5c430251b9911a$export$2e2bcd8739ae039 = (0, $66b880b88d16fd6c$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $8b96c3eee706cc13$export$7d27b64f88bc73bf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: inherit;
  font-size: inherit;
`;
const $8b96c3eee706cc13$export$11148202a11b3cc8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  margin-right: 5px;
  font-size: 10px;
  text-transform: uppercase;
  line-height: 10px;
  opacity: 0.9;

  // Conditional Properties
  ${({ withCurrency: withCurrency })=>!withCurrency && "display: none;"}
`;


function $00ac925e04093214$var$NumericText(props) {
    // Destructure
    const { currency: currency, children: children, title: title } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8b96c3eee706cc13$export$7d27b64f88bc73bf), {
        title: title,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8b96c3eee706cc13$export$11148202a11b3cc8), {
                withCurrency: currency,
                children: currency
            }),
            children
        ]
    });
}
// Default Props
$00ac925e04093214$var$NumericText.defaultProps = {
    children: "",
    currency: "",
    title: ""
};
// Proptypes Validation
$00ac925e04093214$var$NumericText.propTypes = {
    currency: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $00ac925e04093214$export$2e2bcd8739ae039 = $00ac925e04093214$var$NumericText;


var $78de70d994ef00b4$export$2e2bcd8739ae039 = (0, $00ac925e04093214$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $ef5e6ca39e35870f$export$49e91462178ac8af = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display:flex;
  justify-content: center;
  align-items: center;
  padding: 2px 10px;

  margin-left: 1px;
  margin-right: 1px;
  width: fit-content;
  border-radius: 5px;
  font-weight: inherit;
  font-size: inherit;

  // Conditional Properties
  ${({ height: height })=>height && `height: ${height}px;`}
  ${({ width: width })=>width && `width: ${width}px;`};
  ${({ color: color })=>color && `background-color: ${color}33;`};
`;
const $ef5e6ca39e35870f$export$b53d3ce74888dbe0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ color: color })=>color && `color: ${color};`};
`;


function $ed61d5ee88edd3fd$var$BadgeText(props) {
    // Destructure
    const { width: width, height: height, color: color, children: children } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ef5e6ca39e35870f$export$49e91462178ac8af), {
        width: width,
        height: height,
        color: color,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ef5e6ca39e35870f$export$b53d3ce74888dbe0), {
            color: color,
            children: children
        })
    });
}
// Default Props
$ed61d5ee88edd3fd$var$BadgeText.defaultProps = {
    width: "",
    height: "",
    color: "",
    children: ""
};
// Proptypes Validation
$ed61d5ee88edd3fd$var$BadgeText.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ])
};
var $ed61d5ee88edd3fd$export$2e2bcd8739ae039 = $ed61d5ee88edd3fd$var$BadgeText;


var $f04f9a686e885cbf$export$2e2bcd8739ae039 = (0, $ed61d5ee88edd3fd$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $c5967a79296dd557$export$d451e87453299184 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: inherit;
  font-size: inherit;
`;
const $c5967a79296dd557$export$9640911fd10d701c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  margin-right: 15px;
  width: 8px;
  height: 8px;

  // Conditional Properties
  ${({ color: color })=>color && `background-color: ${color};`}
`;


function $d90acdfdee272f08$var$LegendText(props) {
    // Destructure
    const { color: color, children: children } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c5967a79296dd557$export$d451e87453299184), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c5967a79296dd557$export$9640911fd10d701c), {
                color: color
            }),
            children
        ]
    });
}
// Default Props
$d90acdfdee272f08$var$LegendText.defaultProps = {
    children: "",
    color: ""
};
// Proptypes Validation
$d90acdfdee272f08$var$LegendText.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    ]),
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $d90acdfdee272f08$export$2e2bcd8739ae039 = $d90acdfdee272f08$var$LegendText;


var $1d507f2e862cde19$export$2e2bcd8739ae039 = (0, $d90acdfdee272f08$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $ab5e0feb4e45d9de$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin-bottom: 11px;
  font-size: 17px;
  font-weight: 500;

  color: ${({ theme: theme })=>theme.colors.darkGray};
`;


function $c81884aec2374b6b$var$FormTitle(props) {
    // Destructure
    const { children: children } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ab5e0feb4e45d9de$export$f99233281efd08a0), {
        children: children
    });
}
// Default Props
$c81884aec2374b6b$var$FormTitle.defaultProps = {
    children: ""
};
// Proptypes Validation
$c81884aec2374b6b$var$FormTitle.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $c81884aec2374b6b$export$2e2bcd8739ae039 = $c81884aec2374b6b$var$FormTitle;


var $759b853456fe110f$export$2e2bcd8739ae039 = (0, $c81884aec2374b6b$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $102fce3f5bc6a163$export$37c7bf7739d54f18 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 7px;
`;
const $102fce3f5bc6a163$export$762240c6611b6ed2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $102fce3f5bc6a163$export$37d9a66f155fa89d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 7px;
  width: 7px;
  background-color: ${({ theme: theme })=>theme.colors.darkGray};
  border-radius: 2px;
`;


function $8d9ae1b5ba780168$var$TextSliced(props) {
    // Destructure
    const { text: text, sliceLength: sliceLength } = props;
    const startText = text.slice(0, sliceLength);
    const endText = text.slice(sliceLength * -1);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $102fce3f5bc6a163$export$37c7bf7739d54f18), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $102fce3f5bc6a163$export$762240c6611b6ed2), {
                children: startText
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $102fce3f5bc6a163$export$37d9a66f155fa89d), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $102fce3f5bc6a163$export$37d9a66f155fa89d), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $102fce3f5bc6a163$export$37d9a66f155fa89d), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $102fce3f5bc6a163$export$762240c6611b6ed2), {
                children: endText
            })
        ]
    });
}
// Default Props
$8d9ae1b5ba780168$var$TextSliced.defaultProps = {
    text: "",
    sliceLength: ""
};
// Proptypes Validation
$8d9ae1b5ba780168$var$TextSliced.propTypes = {
    text: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    sliceLength: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
};
var $8d9ae1b5ba780168$export$2e2bcd8739ae039 = $8d9ae1b5ba780168$var$TextSliced;


var $a6f961941b47e982$export$2e2bcd8739ae039 = (0, $8d9ae1b5ba780168$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $646ee85e8ecd7f3b$export$ee096d6f521202b9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 300px;
  height: 20px;
  background: #474f5f;

  border-radius: 5px;

  // Conditional Properties
  ${({ borderRadius: borderRadius })=>borderRadius && `border-radius: ${borderRadius}px;`}
  ${({ height: height })=>height && `height: ${height}px;`}
  ${({ width: width })=>width && `width: ${width}px;`};
`;


function $f860ddaa299fdc69$var$SkeletonText(props) {
    // Destructure
    const { width: width, height: height, borderRadius: borderRadius, children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $646ee85e8ecd7f3b$export$ee096d6f521202b9), {
        width: width,
        height: height,
        borderRadius: borderRadius,
        ...rest,
        children: children
    });
}
// Default Props
$f860ddaa299fdc69$var$SkeletonText.defaultProps = {
    width: "",
    height: "",
    borderRadius: "",
    children: ""
};
// Proptypes Validation
$f860ddaa299fdc69$var$SkeletonText.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    borderRadius: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ])
};
var $f860ddaa299fdc69$export$2e2bcd8739ae039 = $f860ddaa299fdc69$var$SkeletonText;


var $bc65e302a570aac6$export$2e2bcd8739ae039 = (0, $f860ddaa299fdc69$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $7eeb0932f90e5786$export$ee096d6f521202b9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 300px;
  height: 20px;
  background: #474f5f;

  border-radius: 5px;

  // Conditional Properties
  ${({ borderRadius: borderRadius })=>borderRadius && `border-radius: ${borderRadius}px;`}
  ${({ height: height })=>height && `height: ${height}px;`}
  ${({ width: width })=>width && `width: ${width}px;`};

  background: linear-gradient(
      100deg,
      rgba(255, 255, 255, 0) 40%,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 60%
    )
    #474f5f;
  background-size: 200% 100%;
  background-position-x: 180%;
  animation: 1s loading ease-out infinite;

  @keyframes loading {
    to {
      background-position-x: -20%;
    }
  }
`;


function $cb49e031ae113b47$var$TextLoading(props) {
    // Destructure
    const { width: width, height: height, borderRadius: borderRadius, children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7eeb0932f90e5786$export$ee096d6f521202b9), {
        width: width,
        height: height,
        borderRadius: borderRadius,
        ...rest,
        children: children
    });
}
// Default Props
$cb49e031ae113b47$var$TextLoading.defaultProps = {
    width: "",
    height: "",
    borderRadius: "",
    children: ""
};
// Proptypes Validation
$cb49e031ae113b47$var$TextLoading.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    borderRadius: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ])
};
var $cb49e031ae113b47$export$2e2bcd8739ae039 = $cb49e031ae113b47$var$TextLoading;


var $5facfc7bc5a170d3$export$2e2bcd8739ae039 = (0, $cb49e031ae113b47$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $b4bbcb147d3e6263$export$fb9f58ebe9de6283 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  margin-top: ${({ label: label })=>label && "-5px;"};
`;
const $b4bbcb147d3e6263$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  position: relative;
  z-index: 1;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  font-size: 12px;
  padding: 0 8px;
  transform: translate(15px, 15px);

  background-color: ${({ theme: theme })=>theme.colors.white};
  border-radius: 5px;
`;
const $b4bbcb147d3e6263$export$85ac2b26e5942195 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  padding: 15px 20px;
  font-size: 16px;
  border-radius: 10px;
  width: 100%;
  font-weight: 400;
  outline: none;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  -webkit-font-smoothing: antialiased;

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? "transparent" : theme.colors.lightGray};
  border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};

  &::placeholder {
    color: ${({ theme: theme })=>theme.colors.darkGray};
  }
`;


function $6d10f696a066d428$var$TextField(props) {
    // Destructure
    const { id: id, type: type, label: label, disabled: disabled, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b4bbcb147d3e6263$export$fb9f58ebe9de6283), {
        label: label,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b4bbcb147d3e6263$export$b04be29aa201d4f5), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b4bbcb147d3e6263$export$85ac2b26e5942195), {
                disabled: disabled,
                id: id,
                type: type,
                ...rest
            })
        ]
    });
}
// Default Props
$6d10f696a066d428$var$TextField.defaultProps = {
    id: "",
    type: "",
    label: "",
    disabled: false
};
// Proptypes Validation
$6d10f696a066d428$var$TextField.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $6d10f696a066d428$export$2e2bcd8739ae039 = $6d10f696a066d428$var$TextField;


var $ae78f1d128dc50d5$export$2e2bcd8739ae039 = (0, $6d10f696a066d428$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $d7939b1b294ff43d$export$a8cf7e2c856df78d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
  margin-top: ${({ label: label })=>label && "-5px;"};
`;
const $d7939b1b294ff43d$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  position: relative;
  z-index: 1;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  font-size: 12px;
  padding: 0 7px;
  transform: translate(15px, 15px);

  background-color: ${({ theme: theme })=>theme.colors.white};
  border-radius: 5px;
`;
const $d7939b1b294ff43d$export$c9719dfad4306c45 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  transition: 0.4s;

  position: relative;

  min-height: 54px;
  height: fit-content;
  width: 100%;

  padding: 15px 20px;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  box-shadow: none;
  outline: none;
  color: ${({ theme: theme })=>theme.colors.darkGray};

  border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? "transparent" : theme.colors.lightGray};

  &::placeholder {
    color: ${({ theme: theme })=>theme.colors.darkGray};
  }
`;
const $d7939b1b294ff43d$export$a6151309bfd46137 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 110%;
  left: 0;
  display: flex;
  flex-direction: column;
  color: ${({ theme: theme })=>theme.colors.darkGray};

  padding: 10px;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  background-color: ${({ theme: theme })=>theme.colors.white};
  border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
  user-select: none;
  z-index: 2;
`;
const $d7939b1b294ff43d$export$ba141e9a22070242 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  gap: 10px;

  color: ${({ theme: theme })=>theme.colors.darkGray};

  cursor: pointer;
  transition: 0.4s;

  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0);

  &:hover {
    border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
  }
`;
const $d7939b1b294ff43d$export$97a3b778b1052a22 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 16px;
`;
const $d7939b1b294ff43d$export$ea5e76b5dd06c221 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;

  color: ${({ theme: theme })=>theme.colors.gray};
`;


// Function that listens to oustide clicks of given ref
const $18408de06d61c793$var$useOutsideAlerter = (ref, setShowOptions)=>{
    (0, $tZqWC.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) setShowOptions(false);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref
    ]);
};
function $18408de06d61c793$var$AutoComplete(props) {
    // Destructure
    const { label: label, options: options, placeholder: placeholder, onInputChange: onInputChange, disabled: disabled, onSelect: onSelect, isLoading: isLoading, value: value, ...rest } = props;
    // Variables
    const withOptions = options && options?.length > 0;
    const wrapperRef = (0, $tZqWC.useRef)();
    // States
    const [inputValue, setInputValue] = (0, $tZqWC.useState)(value || "");
    const [showOptions, setShowOptions] = (0, $tZqWC.useState)(false);
    // Functions
    const handleOnSelect = ({ value: value, label: label })=>{
        setInputValue(label || value);
        onSelect(value);
        setShowOptions(false);
    };
    const handleOnChange = (e)=>{
        setInputValue(e.target.value);
        onInputChange(e.target.value);
    };
    // Closing options on click away
    $18408de06d61c793$var$useOutsideAlerter(wrapperRef, setShowOptions);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d7939b1b294ff43d$export$a8cf7e2c856df78d), {
        ref: wrapperRef,
        label: label,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d7939b1b294ff43d$export$b04be29aa201d4f5), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d7939b1b294ff43d$export$c9719dfad4306c45), {
                value: inputValue,
                onChange: handleOnChange,
                placeholder: placeholder,
                onFocus: ()=>{
                    setShowOptions(true);
                },
                type: "search",
                autoComplete: "off",
                disabled: disabled,
                ...rest
            }),
            showOptions && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d7939b1b294ff43d$export$a6151309bfd46137), {
                children: withOptions ? options.map(({ value: value, label: label, subLabel: subLabel })=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d7939b1b294ff43d$export$ba141e9a22070242), {
                        onClick: ()=>{
                            handleOnSelect({
                                value: value,
                                label: label
                            });
                        },
                        value: value,
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d7939b1b294ff43d$export$97a3b778b1052a22), {
                                children: label
                            }),
                            subLabel && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d7939b1b294ff43d$export$ea5e76b5dd06c221), {
                                children: subLabel
                            })
                        ]
                    }, label)) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                    children: isLoading ? "loading..." : "No results found"
                })
            })
        ]
    });
}
// Default Props
$18408de06d61c793$var$AutoComplete.defaultProps = {
    label: "",
    placeholder: "",
    options: [],
    onSelect: ()=>{},
    onInputChange: ()=>{},
    isLoading: false,
    disabled: false,
    value: ""
};
// Proptypes Validation
$18408de06d61c793$var$AutoComplete.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $18408de06d61c793$export$2e2bcd8739ae039 = $18408de06d61c793$var$AutoComplete;


var $0fe6a5346271ecbe$export$2e2bcd8739ae039 = (0, $18408de06d61c793$export$2e2bcd8739ae039);


/* eslint-disable react/forbid-prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $21b941bab2c8afc0$export$fdd500c294eff378 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
  padding: 10px;
  margin-top: ${({ label: label })=>label ? "-5px;" : "20px;"};
  background: ${({ theme: theme })=>theme.colors.white};

  border-radius: ${({ open: open })=>open ? "10px 10px 0 0" : "10px"};
  transition: 0.3s;
  border: 1px solid ${({ theme: theme })=>`${theme.colors.lightGray}`};
  &:hover {
    border: 1px solid ${({ theme: theme })=>`${theme.colors.blue}40`};
  }
`;
const $21b941bab2c8afc0$export$be58b4326e23250f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  z-index: 2;
  top: 12px;
  left: 10px;

  & svg {
    min-width: 20px;
    margin: 0 0 0 10px;
    & > path {
      stroke: ${({ theme: theme })=>theme.colors.darkGray};
    }
  }
`;
const $21b941bab2c8afc0$export$c636d9aa34eb47a6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 10px;
  background: ${({ theme: theme })=>theme.colors.lightGray};
  margin: 0;
`;
const $21b941bab2c8afc0$export$b8aa00b0e772c98a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 10px 10px 10px 40px;
  padding: 10px 20px;
`;
const $21b941bab2c8afc0$export$ca4b1fc43afa0212 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  // Themed Properties
  background: ${({ theme: theme })=>theme.colors.white};

  & button > svg > path {
    stroke: ${({ theme: theme })=>theme.colors.blue};
  }
  & button > svg > line {
    stroke: ${({ theme: theme })=>theme.colors.blue};
  }
`;
const $21b941bab2c8afc0$export$2f96f6f204f87534 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  max-height: 35.5px;
  gap: 20px;

  opacity: 1;
  transition: 0.3s;

  max-width: ${({ collapseFilter: collapseFilter })=>collapseFilter ? "0px" : "2000px"};
  overflow: ${({ collapseFilter: collapseFilter })=>collapseFilter ? "hidden" : "visible"};
`;
const $21b941bab2c8afc0$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  position: relative;
  z-index: 2;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  font-size: 12px;
  padding: 0 7px;
  transform: translate(15px, 15px);

  background-color: ${({ theme: theme })=>theme.colors.white};
  border-radius: 5px;
  word-break: keep-all;
`;
const $21b941bab2c8afc0$export$55d7609a8f1eccd2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  transition: 0.4s;

  position: relative;

  min-height: 35.5px;
  height: fit-content;
  width: 100%;

  padding: 0 12px 0 50px;

  font-size: 16px;
  font-weight: 400;
  box-shadow: none;
  outline: none;
  border: none;

  color: ${({ theme: theme })=>theme.colors.darkGray};
  border-radius: ${({ open: open })=>open ? "0 0 10px 10px" : "10px"};

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? "transparent" : theme.colors.white};

  &:hover {
    box-shadow: none;
  }

  &::placeholder {
    color: ${({ theme: theme })=>theme.colors.darkGray};
  }
`;
const $21b941bab2c8afc0$export$a6151309bfd46137 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 100%;
  left: 0;
  display: flex;
  flex-direction: column;

  width: 100%;
  max-height: 300px;
  overflow-y: auto;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.darkGray};

  background-color: ${({ theme: theme })=>theme.colors.white};
  user-select: none;
  z-index: 2;

  border-top: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
  border-radius: 0 0 10px 10px;
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.07);
`;
const $21b941bab2c8afc0$export$ba141e9a22070242 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 20px;
  gap: 10px;

  color: ${({ theme: theme })=>theme.colors.darkGray};

  cursor: pointer;
  transition: 0.4s;

  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0);

  margin: 0 10px 0 40px;

  &:first-child {
    margin: 10px 10px 0 40px;
  }
  &:last-child {
    margin: 0 10px 10px 40px;
  }
  &:only-child {
    margin: 10px 10px 10px 40px;
  }
  &:hover {
    background: ${({ theme: theme })=>theme.colors.lightGray};
  }
`;
const $21b941bab2c8afc0$export$97a3b778b1052a22 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 16px;
  min-width: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const $21b941bab2c8afc0$export$ea5e76b5dd06c221 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  min-width: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  color: ${({ theme: theme })=>theme.colors.gray};
`;






// Function that listens to oustide clicks of given ref
const $9af919c9e7b333f7$var$useOutsideAlerter = (ref, handleClose)=>{
    (0, $tZqWC.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) handleClose();
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref
    ]);
};
function $9af919c9e7b333f7$var$Search(props) {
    // Destructure
    const { label: label, options: options, disabledOptions: disabledOptions, setOptions: setOptions, placeholder: placeholder, filter: filter, bottomOptions: bottomOptions, onInputChange: onInputChange, disabled: disabled, onSelect: onSelect, isLoading: isLoading, value: value, ...rest } = props;
    // Variables
    const withOptions = options && options?.length > 0;
    const wrapperRef = (0, $tZqWC.useRef)();
    // States
    const [inputValue, setInputValue] = (0, $tZqWC.useState)(value || "");
    const [showOptions, setShowOptions] = (0, $tZqWC.useState)(false);
    const [collapseFilter, setCollapseFilter] = (0, $tZqWC.useState)(true);
    // Functions
    const handleOnSelect = ({ value: value, label: label })=>{
        setInputValue(label || value);
        onSelect(value);
        setShowOptions(false);
    };
    const handleOnChange = (e)=>{
        setInputValue(e.target.value);
        onInputChange(e.target.value);
    };
    const handleCollapseFilter = ()=>{
        setCollapseFilter((prevState)=>!prevState);
        setShowOptions(false);
    };
    const handleCloseOptions = ()=>{
        setShowOptions(false);
    };
    // Closing options on click away
    $9af919c9e7b333f7$var$useOutsideAlerter(wrapperRef, handleCloseOptions);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $21b941bab2c8afc0$export$fdd500c294eff378), {
        ref: wrapperRef,
        label: label,
        open: showOptions,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21b941bab2c8afc0$export$b04be29aa201d4f5), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21b941bab2c8afc0$export$be58b4326e23250f), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $da94d5183dd964b8$export$2e2bcd8739ae039), {})
            }),
            filter && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $21b941bab2c8afc0$export$ca4b1fc43afa0212), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21b941bab2c8afc0$export$2f96f6f204f87534), {
                        collapseFilter: collapseFilter,
                        children: filter
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        variant: "outlined",
                        size: "small",
                        onClick: handleCollapseFilter,
                        startIcon: collapseFilter ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $60f83047747d7ceb$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f8b21e6e39ef8af9$export$2e2bcd8739ae039), {}),
                        children: collapseFilter ? "Filters" : "Close"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21b941bab2c8afc0$export$55d7609a8f1eccd2), {
                value: inputValue,
                onChange: handleOnChange,
                placeholder: placeholder,
                onFocus: ()=>{
                    if (!disabledOptions) setShowOptions(true);
                    setCollapseFilter(true);
                },
                type: "search",
                autoComplete: "off",
                disabled: disabled,
                ...rest
            }),
            showOptions && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21b941bab2c8afc0$export$a6151309bfd46137), {
                children: withOptions ? options.map(({ value: value, label: label, subLabel: subLabel })=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $21b941bab2c8afc0$export$ba141e9a22070242), {
                        onClick: ()=>{
                            handleOnSelect({
                                value: value,
                                label: label
                            });
                        },
                        value: value,
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21b941bab2c8afc0$export$97a3b778b1052a22), {
                                children: label
                            }),
                            subLabel && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21b941bab2c8afc0$export$ea5e76b5dd06c221), {
                                children: subLabel
                            })
                        ]
                    }, label)) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                    children: isLoading ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21b941bab2c8afc0$export$b8aa00b0e772c98a), {
                        children: "loading..."
                    }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21b941bab2c8afc0$export$b8aa00b0e772c98a), {
                                children: "No results found"
                            }),
                            bottomOptions && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21b941bab2c8afc0$export$c636d9aa34eb47a6), {
                                children: bottomOptions
                            })
                        ]
                    })
                })
            })
        ]
    });
}
// Default Props
$9af919c9e7b333f7$var$Search.defaultProps = {
    label: "",
    placeholder: "",
    options: [],
    setOptions: ()=>{},
    onSelect: ()=>{},
    onInputChange: ()=>{},
    isLoading: false,
    disabled: false,
    value: ""
};
// Proptypes Validation
$9af919c9e7b333f7$var$Search.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
    setOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabledOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    filter: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any,
    bottomOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any
};
var $9af919c9e7b333f7$export$2e2bcd8739ae039 = $9af919c9e7b333f7$var$Search;


var $69a991355976a1a9$export$2e2bcd8739ae039 = (0, $9af919c9e7b333f7$export$2e2bcd8739ae039);



var $47c62aa7410890bd$export$2e2bcd8739ae039 = (0, $afe5329dc5514fbe$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $03d2db516d68681e$export$d586e0ae81c7b89b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: fit-content;
  min-height: 35.5px;
  display: flex;
  gap: ${({ vertical: vertical })=>vertical ? "0px" : "5px"};
  margin: 0 !important;
  flex-direction: ${({ vertical: vertical })=>vertical ? "column" : "row"};
  align-items: ${({ vertical: vertical })=>vertical ? "flex-start" : "center"};
`;
const $03d2db516d68681e$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  margin: 0 !important;
  width: fit-content;
`;
const $03d2db516d68681e$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  position: relative;
  z-index: 1;
  padding: ${({ vertical: vertical })=>vertical ? "0 20px 0 0" : "0"};

  width: fit-content;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  margin: 0 !important;
  font-size: 12px;
  font-weight: 200;
  word-break: keep-all;
`;
const $03d2db516d68681e$export$d6701e98ab1a6725 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).select`
  display: none;
`;
const $03d2db516d68681e$export$11a8a1ea41bf55d8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).option`
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $03d2db516d68681e$export$37cdf0d06bb542b5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  cursor: ${(props)=>props.disabled ? "default" : "pointer"};

  position: relative;
  // TODO: Use theme functions
  &:after {
    content: '';

    position: absolute;
    top: 42%;
    right: 0px;

    display: ${({ disabled: disabled })=>disabled ? "none" : "inline-block"};
    margin-left: 0.255em;
    vertical-align: 0.255em;

    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
    color: ${({ theme: theme })=>theme.colors.darkGray};
  }

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? theme.colors.lightGray : "transparent"};
  height: fit-content;
  width: fit-content;

  font-size: 12px;
  font-weight: 400;
  box-shadow: none;
  padding: 0 20px 0 0;
`;
const $03d2db516d68681e$export$a6151309bfd46137 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 110%;
  display: flex;
  flex-direction: column;
  color: ${({ theme: theme })=>theme.colors.darkGray};

  padding: 5px;
  width: fit-content;
  max-height: 300px;
  min-width: 100px;
  overflow-y: auto;

  font-size: 14px;
  border-radius: 8px;
  font-weight: 400;
  background-color: ${({ theme: theme })=>theme.colors.white};
  border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
  user-select: none;
  z-index: 2;
`;
const $03d2db516d68681e$export$ba141e9a22070242 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  padding: 2px 10px;
  gap: 10px;
  word-break: keep-all;
  white-space: nowrap;

  color: ${({ theme: theme })=>theme.colors.darkGray};

  cursor: pointer;
  transition: 0.4s;

  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0);

  &:hover {
    border: ${({ theme: theme })=>`1px solid ${theme.colors.blue}`};
    color: ${({ theme: theme })=>`${theme.colors.blue}`};
  }
`;
const $03d2db516d68681e$export$8a186fdbfc12f934 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${(props)=>props.disabled ? props.theme.colors.darkGray : props.theme.colors.blue};
  font-weight: 400;
  margin: 0 !important;
  font-size: 14px;
  word-break: keep-all;
`;
const $03d2db516d68681e$export$a11e67ac8be84bf9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.lightGray};
`;


// Function that listens to oustide clicks of given ref
const $c5892724db161e9a$var$useOutsideAlerter = (ref, setShowOptions)=>{
    (0, $tZqWC.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) setShowOptions(false);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref
    ]);
};
function $c5892724db161e9a$var$SimpleSelect(props) {
    // Destructure
    const { id: id, label: label, placeholder: placeholder, options: options, onChange: onChange, value: value, disabled: disabled, vertical: vertical, ...rest } = props;
    // Variables
    const withOptions = options && options?.length > 0;
    const wrapperRef = (0, $tZqWC.useRef)();
    // States
    const [formValue, setFormValue] = (0, $tZqWC.useState)("");
    const [valueLabel, setValueLabel] = (0, $tZqWC.useState)("");
    const [showOptions, setShowOptions] = (0, $tZqWC.useState)(false);
    // Functions
    const handleOnChange = (value, label)=>{
        onChange(value);
        if (value === undefined) {
            setFormValue(value);
            setValueLabel(placeholder || "");
            return setShowOptions(false);
        }
        setFormValue(value);
        setValueLabel(label);
        setShowOptions(false);
    };
    // Closing options on click away
    $c5892724db161e9a$var$useOutsideAlerter(wrapperRef, setShowOptions);
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        // setting the value and label on initial load
        if (value === undefined || value === null) {
            setValueLabel(placeholder);
            return;
        }
        setFormValue(value);
        const currentLabel = options.find((data)=>{
            if (typeof data.value === "number") return data.value === Number(value);
            return data.value === value;
        });
        if (currentLabel?.label) setValueLabel(currentLabel.label);
        else if (!currentLabel?.label) setValueLabel(placeholder || "");
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $03d2db516d68681e$export$d586e0ae81c7b89b), {
        ref: wrapperRef,
        id: id,
        vertical: vertical,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $03d2db516d68681e$export$b04be29aa201d4f5), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $03d2db516d68681e$export$8f1ff89fa1ec9605), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $03d2db516d68681e$export$d6701e98ab1a6725), {
                        disabled: disabled,
                        type: "select",
                        value: `${formValue}`,
                        onChange: ()=>{},
                        ...rest
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $03d2db516d68681e$export$37cdf0d06bb542b5), {
                        className: "simpleSelectInputLabel",
                        disabled: disabled,
                        onClick: ()=>{
                            if (!disabled) setShowOptions((prevState)=>!prevState);
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $03d2db516d68681e$export$8a186fdbfc12f934), {
                            vertical: vertical,
                            disabled: disabled,
                            children: [
                                " ",
                                !valueLabel ? placeholder : valueLabel,
                                " "
                            ]
                        })
                    }),
                    showOptions && options?.length > 0 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $03d2db516d68681e$export$a6151309bfd46137), {
                        vertical: vertical,
                        children: withOptions && options.map(({ value: value, label: label, abrv: abrv, icon: icon, SVG: SVG })=>{
                            if (label !== valueLabel) return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $03d2db516d68681e$export$ba141e9a22070242), {
                                onClick: ()=>{
                                    handleOnChange(value, label);
                                },
                                value: value,
                                children: [
                                    icon && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $65f0d7ff3fd922b2$export$2e2bcd8739ae039), {
                                        src: icon,
                                        width: 30,
                                        height: 30
                                    }),
                                    SVG && SVG,
                                    label,
                                    abrv && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $03d2db516d68681e$export$a11e67ac8be84bf9), {
                                        children: [
                                            " ",
                                            abrv,
                                            " "
                                        ]
                                    })
                                ]
                            }, label);
                        })
                    })
                ]
            })
        ]
    });
}
// Default Props
$c5892724db161e9a$var$SimpleSelect.defaultProps = {
    id: "",
    label: "",
    value: undefined,
    placeholder: "",
    options: [],
    onChange: ()=>{},
    disabled: false,
    vertical: false
};
// Proptypes Validation
$c5892724db161e9a$var$SimpleSelect.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    ]),
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    vertical: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $c5892724db161e9a$export$2e2bcd8739ae039 = $c5892724db161e9a$var$SimpleSelect;


var $430484cb816801bc$export$2e2bcd8739ae039 = (0, $c5892724db161e9a$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $23f6dd882885821b$export$fb9f58ebe9de6283 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  margin-top: ${({ label: label })=>label && "-5px;"};
`;
const $23f6dd882885821b$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  position: relative;
  z-index: 1;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  font-size: 12px;
  padding: 0 8px;
  transform: translate(15px, 15px);

  background-color: ${({ theme: theme })=>theme.colors.white};
  border-radius: 5px;
`;
const $23f6dd882885821b$export$ce9b1cc0c34506d0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).textarea`
  padding: 15px 20px;
  font-size: 16px;
  border-radius: 10px;
  width: 100%;
  height: 100%;
  font-weight: 400;
  outline: none;
  color: ${({ theme: theme })=>theme.colors.darkGray};

  border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? "transparent" : theme.colors.lightGray};

  ${({ resize: resize })=>!resize && "resize: none;"}

  &::placeholder {
    color: ${({ theme: theme })=>theme.colors.darkGray};
  }
`;
const $23f6dd882885821b$export$256c1f58b9340d4e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: 10px;
  right: 10px;
`;
const $23f6dd882885821b$export$42f892acd431d334 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  cursor: default;
  font-size: 10px;
  color: ${({ theme: theme })=>theme.colors.lightGray};
`;



var $ae0aff91963c2b29$exports = {};
$ae0aff91963c2b29$exports = new URL("save.43a7205e.svg", import.meta.url).toString();


function $71f083882eba2781$var$TextArea(props) {
    // Destructure
    const { type: type, label: label, resize: resize, saveLoading: saveLoading, disabled: disabled, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $23f6dd882885821b$export$fb9f58ebe9de6283), {
        label: label,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $23f6dd882885821b$export$b04be29aa201d4f5), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $23f6dd882885821b$export$ce9b1cc0c34506d0), {
                disabled: disabled,
                type: type,
                resize: resize,
                ...rest
            }),
            saveLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $23f6dd882885821b$export$256c1f58b9340d4e), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $23f6dd882885821b$export$42f892acd431d334), {
                        children: "Saving..."
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $65f0d7ff3fd922b2$export$2e2bcd8739ae039), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ae0aff91963c2b29$exports))),
                        width: 16,
                        height: 16
                    })
                ]
            })
        ]
    });
}
// Default Props
$71f083882eba2781$var$TextArea.defaultProps = {
    type: "",
    label: "",
    resize: true,
    saveLoading: false,
    disabled: false
};
// Proptypes Validation
$71f083882eba2781$var$TextArea.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    resize: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    saveLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $71f083882eba2781$export$2e2bcd8739ae039 = $71f083882eba2781$var$TextArea;


var $d03facd9d698d253$export$2e2bcd8739ae039 = (0, $71f083882eba2781$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $0f292754b80fe50c$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;

  font-size: 15px;
  color: ${({ theme: theme, isChecked: isChecked })=>isChecked ? theme.colors.blue : theme.colors.darkGray};
`;
const $0f292754b80fe50c$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $0f292754b80fe50c$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
`;
const $0f292754b80fe50c$export$d4e232ca161ccdd3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  display: none;

  &:checked ~ label > div > span {
    background: ${({ theme: theme })=>theme.colors.blue};
  }
`;
const $0f292754b80fe50c$export$fc9014afe1b6db0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const $0f292754b80fe50c$export$60bffc6e2a50e7f9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  border-radius: 5px;
  background: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $0f292754b80fe50c$export$d046b3c4a416f60d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  display: flex;
  height: 10px;
  width: 10px;
  border-radius: 2px;
  background: ${({ theme: theme })=>theme.colors.darkGray};
`;


function $bd53d24aaa482d5a$var$Checkbox(props) {
    // Destructure
    const { id: id, name: name, type: type, label: label, options: options, onChange: onChange, value: value, disabled: disabled, ...rest } = props;
    function handleChange(selectedValue, checked) {
        let newItems = [
            ...value
        ];
        if (checked) newItems.push(selectedValue);
        if (!checked) {
            newItems = [];
            value.forEach((item)=>{
                if (item !== selectedValue) newItems.push(item);
            });
        }
        onChange(newItems);
    }
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0f292754b80fe50c$export$e6dfd72ab29f8598), {
        ...rest,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0f292754b80fe50c$export$f99233281efd08a0), {
                children: label
            }),
            options && options.map((item)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0f292754b80fe50c$export$bc7adc8ef74607f), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0f292754b80fe50c$export$d4e232ca161ccdd3), {
                            name: name,
                            id: item.value,
                            type: "checkbox",
                            onChange: (e)=>handleChange(item.value, e.target.checked)
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0f292754b80fe50c$export$fc9014afe1b6db0), {
                            for: item.value,
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0f292754b80fe50c$export$60bffc6e2a50e7f9), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0f292754b80fe50c$export$d046b3c4a416f60d), {})
                                }),
                                item.label
                            ]
                        })
                    ]
                }, item.value))
        ]
    });
}
// Default Props
$bd53d24aaa482d5a$var$Checkbox.defaultProps = {
    id: "",
    name: "",
    type: "",
    label: "",
    disabled: false,
    options: [],
    onChange: ()=>{},
    value: []
};
// Proptypes Validation
$bd53d24aaa482d5a$var$Checkbox.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string),
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
};
var $bd53d24aaa482d5a$export$2e2bcd8739ae039 = $bd53d24aaa482d5a$var$Checkbox;


var $d05da0d1610c883b$export$2e2bcd8739ae039 = (0, $bd53d24aaa482d5a$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $ejSM7 = parcelRequire("ejSM7");



var $e1e1beb7234e17b0$exports = {};
$e1e1beb7234e17b0$exports = new URL("icon-calendar.daa99e52.svg", import.meta.url).toString();


const $9dafb53491fb7bd6$export$a915f81916d25a71 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 18px;

  width: 100%;

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $9dafb53491fb7bd6$export$4667e3f69e3ef411 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $cd75171c8621b7d2$export$2e2bcd8739ae039))``;
const $9dafb53491fb7bd6$export$f148b00fad07a3a7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;

  display: flex;
  padding: 15px 20px;
  width: 100%;

  border-radius: 10px;

  cursor: pointer;

  // TODO: Use themed functions
  &:after {
    content: '';

    position: absolute;
    top: 50%;
    right: 15px;

    transform: translateY(-50%);

    width: 15px;
    height: 15px;

    background-image: url(${(0, (/*@__PURE__*/$parcel$interopDefault($e1e1beb7234e17b0$exports)))});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  // Themed Properties
  border: 1px solid ${({ theme: theme })=>theme.colors.lightGray};

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? "transparent" : theme.colors.lightGray};
`;
const $9dafb53491fb7bd6$export$d470a9ec77478a10 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 16px;
  margin: 0;
`;
const $9dafb53491fb7bd6$export$ce60b6237151ffd0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span``;


function $c4b62a3a7f68834b$var$DateRangePicker(props) {
    // Destructure
    const { opens: opens, onApply: onApply, defaultDate: defaultDate, disabled: disabled } = props;
    // States
    const [date, setDate] = (0, $tZqWC.useState)("");
    // Functions
    const handleApplyDatePicker = (e, picker)=>{
        // Ignoring changes to table filters that are exactly the same as previous state
        if (date !== picker.startDate.format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c))) {
            setDate(picker.startDate.format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)));
            onApply(picker.startDate.format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)));
        }
    };
    (0, $tZqWC.useEffect)(()=>{
        if (defaultDate) setDate(defaultDate);
        if (!defaultDate || defaultDate === "Invalid date") setDate("Select Date");
    }, [
        defaultDate
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$a915f81916d25a71), {
        children: disabled ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$f148b00fad07a3a7), {
            disabled: disabled,
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$d470a9ec77478a10), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$ce60b6237151ffd0), {
                    children: date || "Select Date"
                })
            })
        }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$4667e3f69e3ef411), {
            onApply: handleApplyDatePicker,
            locale: {
                format: (0, $41a9e38e6be32f35$export$1bceb808939a9f0c)
            },
            initialSettings: {
                maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), (0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
                singleDatePicker: true,
                showDropdowns: true
            },
            opens: opens,
            disabled: disabled,
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$f148b00fad07a3a7), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$d470a9ec77478a10), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$ce60b6237151ffd0), {
                        children: date || "Select Date"
                    })
                })
            })
        })
    });
}
// Default Props
$c4b62a3a7f68834b$var$DateRangePicker.defaultProps = {
    opens: "center",
    onApply: ()=>{},
    defaultDate: "",
    disabled: false
};
// Proptypes Validation
$c4b62a3a7f68834b$var$DateRangePicker.propTypes = {
    opens: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    onApply: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    defaultDate: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $c4b62a3a7f68834b$export$2e2bcd8739ae039 = $c4b62a3a7f68834b$var$DateRangePicker;


var $0c99b953747ef22f$export$2e2bcd8739ae039 = (0, $c4b62a3a7f68834b$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $eb96aaaf4ffa5364$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;

  font-size: 15px;
  color: ${({ theme: theme, isChecked: isChecked })=>isChecked ? theme.colors.blue : theme.colors.darkGray};
  cursor: ${({ disabled: disabled })=>disabled ? "not-allowed" : "pointer"};

  ${({ horizontal: horizontal })=>horizontal ? "flex-direction: row; gap: 15px !important;" : "flex-direction: column;"};
`;
const $eb96aaaf4ffa5364$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $eb96aaaf4ffa5364$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
`;
const $eb96aaaf4ffa5364$export$83a1b8e4fcf0dd8e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  display: none;

  cursor: ${({ disabled: disabled })=>disabled ? "not-allowed" : "pointer"};
  &:checked ~ label > div > span {
    background: ${({ theme: theme })=>theme.colors.blue};
  }
`;
const $eb96aaaf4ffa5364$export$53bebd46e4b5307b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: ${({ disabled: disabled })=>disabled ? "not-allowed" : "pointer"};
`;
const $eb96aaaf4ffa5364$export$ebd6c85e02a47789 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  border-radius: 100%;
  background: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $eb96aaaf4ffa5364$export$53a79cbe5c6b97c1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  display: flex;
  height: 18px;
  width: 18px;
  border-radius: 100%;
  background: ${({ theme: theme })=>theme.colors.darkGray};
`;


function $75dbfd197a98b412$var$Radio(props) {
    // Destructure
    const { id: id, name: name, type: type, label: label, options: options, onChange: onChange, value: value, disabled: disabled, horizontal: horizontal, ...rest } = props;
    const [inputValue, setInputValue] = (0, $tZqWC.useState)(value);
    function handleChange(selectedValue) {
        setInputValue(selectedValue);
        onChange(selectedValue);
    }
    console.log(options);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eb96aaaf4ffa5364$export$e6dfd72ab29f8598), {
        horizontal: horizontal,
        ...rest,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eb96aaaf4ffa5364$export$f99233281efd08a0), {
                children: label
            }),
            options && options.map((item)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eb96aaaf4ffa5364$export$bc7adc8ef74607f), {
                    onClick: ()=>{
                        if (!item?.disabled) handleChange(item.value);
                    },
                    disabled: item?.disabled,
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eb96aaaf4ffa5364$export$83a1b8e4fcf0dd8e), {
                            name: name,
                            id: item.value,
                            type: "radio",
                            value: item.value,
                            checked: item.value === inputValue,
                            disabled: item?.disabled
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eb96aaaf4ffa5364$export$53bebd46e4b5307b), {
                            for: item.value,
                            disabled: item?.disabled,
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eb96aaaf4ffa5364$export$ebd6c85e02a47789), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eb96aaaf4ffa5364$export$53a79cbe5c6b97c1), {})
                                }),
                                item.label
                            ]
                        })
                    ]
                }, item.value))
        ]
    });
}
// Default Props
$75dbfd197a98b412$var$Radio.defaultProps = {
    id: "",
    name: "",
    type: "",
    label: "",
    disabled: false,
    options: [],
    onChange: ()=>{},
    value: ""
};
// Proptypes Validation
$75dbfd197a98b412$var$Radio.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    ]),
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
};
var $75dbfd197a98b412$export$2e2bcd8739ae039 = $75dbfd197a98b412$var$Radio;


var $b6cab7af1259ed03$export$2e2bcd8739ae039 = (0, $75dbfd197a98b412$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $krg3S = parcelRequire("krg3S");

const $b8a4f37823867cae$export$bd2d217f1bfbe4e5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  margin-top: ${({ label: label })=>label && "-5px;"};
`;
const $b8a4f37823867cae$export$842aba50ed0ce9d7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  position: relative;
  z-index: 1;
  margin-bottom: 5px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  font-size: 12px;
  padding: 0 8px;
  transform: translate(15px, 15px);

  background-color: ${({ theme: theme })=>theme.colors.white};
  border-radius: 5px;
`;
const $b8a4f37823867cae$export$a2dc1e79bfbe1301 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  padding: 15px 20px;
  font-size: 16px;
  border-radius: 10px;
  width: 100%;
  font-weight: 400;
  outline: none;
  -webkit-font-smoothing: antialiased;
  color: ${({ theme: theme })=>theme.colors.darkGray};

  border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? "transparent;" : theme.colors.lightGray};

  &::placeholder {
    color: ${({ theme: theme })=>theme.colors.darkGray};
  }
`;
const $b8a4f37823867cae$export$185a8afe504e8fca = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  bottom: -20px;
  right: 5px;
  color: ${({ theme: theme })=>theme.colors.brightRed};
  font-size: 14px;
`;


function $5f372565ec15d92d$var$FormTextField(props) {
    // Destructure
    const { type: type, label: label, disabled: disabled, ...rest } = props;
    // Hooks
    const [fields] = (0, $krg3S.useField)(props);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b8a4f37823867cae$export$bd2d217f1bfbe4e5), {
        label: label,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b8a4f37823867cae$export$842aba50ed0ce9d7), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b8a4f37823867cae$export$a2dc1e79bfbe1301), {
                disabled: disabled,
                type: type,
                ...fields,
                ...rest
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b8a4f37823867cae$export$185a8afe504e8fca), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $krg3S.ErrorMessage), {
                    ...fields
                })
            })
        ]
    });
}
// Default Props
$5f372565ec15d92d$var$FormTextField.defaultProps = {
    type: "",
    label: "",
    disabled: false
};
// Proptypes Validation
$5f372565ec15d92d$var$FormTextField.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $5f372565ec15d92d$export$2e2bcd8739ae039 = $5f372565ec15d92d$var$FormTextField;


var $9d75ef3d13fecbc2$export$2e2bcd8739ae039 = (0, $5f372565ec15d92d$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $krg3S = parcelRequire("krg3S");

const $ae547c30c95b2eea$export$a8cf7e2c856df78d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
  margin-top: ${({ label: label })=>label && "-5px;"};
`;
const $ae547c30c95b2eea$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  position: relative;
  z-index: 1;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  font-size: 12px;
  padding: 0 7px;
  transform: translate(15px, 15px);

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? theme.colors.white : "transparent"};
`;
const $ae547c30c95b2eea$export$c9719dfad4306c45 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  transition: 0.4s;

  position: relative;

  min-height: 54px;
  height: fit-content;
  width: 100%;

  padding: 15px 20px;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  box-shadow: none;
  outline: none;
  color: ${({ theme: theme })=>theme.colors.lightGray};

  border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? "transparent" : theme.colors.lightGray};

  &::placeholder {
    color: ${({ theme: theme })=>theme.colors.darkGray};
  }
`;
const $ae547c30c95b2eea$export$a6151309bfd46137 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 110%;
  display: flex;
  flex-direction: column;

  padding: 10px;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;

  border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? theme.colors.lightGray : "transparent"};
  user-select: none;
  z-index: 2;
`;
const $ae547c30c95b2eea$export$ba141e9a22070242 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  gap: 10px;
  color: ${({ theme: theme })=>theme.colors.darkGray};

  cursor: pointer;
  transition: 0.4s;

  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0);

  &:hover {
    border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
  }
`;
const $ae547c30c95b2eea$export$98321245064bc252 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  display: none;
`;


// Function that listens to oustide clicks of given ref
const $02ac069fe8061d02$var$useOutsideAlerter = (ref, setShowOptions)=>{
    (0, $tZqWC.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) setShowOptions(false);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref
    ]);
};
function $02ac069fe8061d02$var$FormAutoComplete(props) {
    // Destructure
    const { label: label, options: options, placeholder: placeholder, onInputChange: onInputChange, onSelect: onSelect, isLoading: isLoading, disabled: disabled, ...rest } = props;
    // Variables
    const withOptions = options && options?.length > 0;
    // Refs
    const inputRef = (0, $tZqWC.useRef)();
    const wrapperRef = (0, $tZqWC.useRef)();
    // Hooks
    const [{ name: name }, , { setValue: setValue }] = (0, $krg3S.useField)(props);
    // States
    const [inputValue, setInputValue] = (0, $tZqWC.useState)("");
    const [showOptions, setShowOptions] = (0, $tZqWC.useState)(false);
    // Functions
    const handleOnSelect = (e)=>{
        onSelect(e);
    };
    const handleOnClick = async (value)=>{
        await setValue(value);
        await setInputValue(value);
        await setShowOptions(false);
        inputRef.current.click();
    };
    const handleOnChange = (e)=>{
        setInputValue(e.target.value);
        onInputChange(e);
    };
    // Closing options on click away
    $02ac069fe8061d02$var$useOutsideAlerter(wrapperRef, setShowOptions);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ae547c30c95b2eea$export$a8cf7e2c856df78d), {
        label: label,
        ref: wrapperRef,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae547c30c95b2eea$export$b04be29aa201d4f5), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae547c30c95b2eea$export$98321245064bc252), {
                ref: inputRef,
                value: inputValue,
                onChange: ()=>{},
                onClick: handleOnSelect
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae547c30c95b2eea$export$c9719dfad4306c45), {
                name: name,
                value: inputValue,
                onChange: handleOnChange,
                placeholder: placeholder,
                onFocus: ()=>{
                    setShowOptions(true);
                },
                type: "search",
                autoComplete: "off",
                disabled: disabled,
                ...rest
            }),
            showOptions && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae547c30c95b2eea$export$a6151309bfd46137), {
                children: withOptions ? options.map(({ value: value, label: label })=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae547c30c95b2eea$export$ba141e9a22070242), {
                        onClick: ()=>{
                            handleOnClick(value);
                        },
                        value: value,
                        children: label
                    }, label)) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                    children: [
                        isLoading && "loading...",
                        !isLoading && "No results found"
                    ]
                })
            })
        ]
    });
}
// Default Props
$02ac069fe8061d02$var$FormAutoComplete.defaultProps = {
    type: "",
    label: "",
    placeholder: "",
    variant: "outlined",
    options: [],
    onSelect: ()=>{},
    onInputChange: ()=>{},
    getOptionSelected: ()=>{},
    getOptionLabel: ()=>{},
    isLoading: false,
    disabled: false
};
// Proptypes Validation
$02ac069fe8061d02$var$FormAutoComplete.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    getOptionSelected: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    getOptionLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $02ac069fe8061d02$export$2e2bcd8739ae039 = $02ac069fe8061d02$var$FormAutoComplete;


var $477398b21fbfc3ae$export$2e2bcd8739ae039 = (0, $02ac069fe8061d02$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $krg3S = parcelRequire("krg3S");


const $a72bd2775d62c5a0$export$d586e0ae81c7b89b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  margin-top: ${({ label: label })=>label && "-5px;"};
`;
const $a72bd2775d62c5a0$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  min-height: 48px;
`;
const $a72bd2775d62c5a0$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  position: relative;
  z-index: 1;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  font-size: 12px;
  padding: 0 8px;
  transform: translate(15px, 15px);

  background-color: ${({ theme: theme })=>theme.colors.white};
  border-radius: 5px;
`;
const $a72bd2775d62c5a0$export$d6701e98ab1a6725 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  display: none;
`;
const $a72bd2775d62c5a0$export$37cdf0d06bb542b5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  cursor: ${(props)=>props.disabled ? "default" : "pointer"};
  color: ${({ theme: theme })=>theme.colors.darkGray};
  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? "transparent" : theme.colors.lightGray};
  transition: 0.4s;

  position: relative;
  // TODO: Use theme functions
  &:after {
    content: '';

    position: absolute;
    top: 42%;
    right: 15px;

    display: ${({ disabled: disabled })=>disabled ? "none" : "inline-block"};
    margin-left: 0.255em;
    vertical-align: 0.255em;

    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
    color: ${({ theme: theme })=>theme.colors.darkGray};
  }

  min-height: 54px;
  height: fit-content;
  width: 100%;

  padding: 15px 20px;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  box-shadow: none;

  border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
`;
const $a72bd2775d62c5a0$export$a6151309bfd46137 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 100%;
  display: flex;
  flex-direction: column;
  max-height: 300px;
  overflow-y: auto;

  padding: 10px 15px;
  width: 100%;

  font-size: 14px;
  border-radius: 10px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  background-color: ${({ theme: theme })=>theme.colors.white};
  border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
  user-select: none;
  z-index: 2;
`;
const $a72bd2775d62c5a0$export$ba141e9a22070242 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  padding: 10px;

  cursor: pointer;
  transition: 0.4s;

  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 10px;

  min-width: 40px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
  }
`;
const $a72bd2775d62c5a0$export$185a8afe504e8fca = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  bottom: -20px;
  right: 5px;
  color: ${({ theme: theme })=>theme.colors.brightRed};
  font-size: 14px;
`;
const $a72bd2775d62c5a0$export$a11e67ac8be84bf9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.lightGray};
  min-width: 40px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;


// Function that listens to oustide clicks of given ref
const $71bdcd7c0fde8ceb$var$useOutsideAlerter = (ref, setShowOptions)=>{
    (0, $tZqWC.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) setShowOptions(false);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref
    ]);
};
function $71bdcd7c0fde8ceb$var$FormSelect(props) {
    // Destructure
    const { label: label, placeholder: placeholder, options: options, disabled: disabled, type: type, ...rest } = props;
    const [fields] = (0, $krg3S.useField)(props);
    // Variables
    const withOptions = options && options?.length > 0;
    const wrapperRef = (0, $tZqWC.useRef)();
    const inputRef = (0, $tZqWC.useRef)(null);
    const { name: name, value: value, onChange: onChange } = fields;
    // Hooks
    const [formValue, setValue] = (0, $tZqWC.useState)("");
    const [valueLabel, setValueLabel] = (0, $tZqWC.useState)(placeholder || "");
    const [showOptions, setShowOptions] = (0, $tZqWC.useState)(false);
    // Functions
    const handleOnChange = async (elValue, elLabel)=>{
        await setValue(elValue);
        if (elValue === undefined) {
            await setValueLabel(placeholder || "");
            return setShowOptions(false);
        }
        await setValueLabel(elLabel);
        onChange({
            target: {
                name: name,
                value: elValue
            }
        });
        setShowOptions(false);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        // setting the value and label on initial load
        if (value !== undefined && value !== null) {
            setValue(value);
            const currentLabel = options.find((data)=>{
                if (typeof data.value === "number") return data.value === Number(value);
                return data.value === value;
            });
            if (currentLabel?.label) setValueLabel(currentLabel.label);
            else if (!currentLabel?.label) setValueLabel(placeholder || "");
        }
    }, [
        value
    ]);
    // Closing options on click away
    $71bdcd7c0fde8ceb$var$useOutsideAlerter(wrapperRef, setShowOptions);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a72bd2775d62c5a0$export$d586e0ae81c7b89b), {
        label: label,
        ref: wrapperRef,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a72bd2775d62c5a0$export$b04be29aa201d4f5), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a72bd2775d62c5a0$export$8f1ff89fa1ec9605), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a72bd2775d62c5a0$export$d6701e98ab1a6725), {
                        ref: inputRef,
                        type: type,
                        name: name,
                        onChange: ()=>{},
                        value: formValue,
                        ...rest
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a72bd2775d62c5a0$export$37cdf0d06bb542b5), {
                        disabled: disabled,
                        onClick: ()=>{
                            if (!disabled) setShowOptions((prevState)=>!prevState);
                        },
                        children: valueLabel !== undefined ? valueLabel : placeholder
                    }),
                    showOptions && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a72bd2775d62c5a0$export$a6151309bfd46137), {
                        children: withOptions && options.map(({ value: value, label: label, abrv: abrv, icon: icon })=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                                children: label !== valueLabel && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a72bd2775d62c5a0$export$ba141e9a22070242), {
                                    onClick: ()=>{
                                        handleOnChange(value, label);
                                    },
                                    value: value,
                                    children: [
                                        icon && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $65f0d7ff3fd922b2$export$2e2bcd8739ae039), {
                                            src: icon,
                                            width: 30,
                                            height: 30
                                        }),
                                        label,
                                        abrv && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a72bd2775d62c5a0$export$a11e67ac8be84bf9), {
                                            children: [
                                                " ",
                                                abrv,
                                                " "
                                            ]
                                        })
                                    ]
                                })
                            }, label))
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a72bd2775d62c5a0$export$185a8afe504e8fca), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $krg3S.ErrorMessage), {
                            ...fields
                        })
                    })
                ]
            })
        ]
    });
}
// Default Props
$71bdcd7c0fde8ceb$var$FormSelect.defaultProps = {
    label: "",
    placeholder: "",
    type: "",
    options: []
};
// Proptypes Validation
$71bdcd7c0fde8ceb$var$FormSelect.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
};
var $71bdcd7c0fde8ceb$export$2e2bcd8739ae039 = $71bdcd7c0fde8ceb$var$FormSelect;


var $99b5eccf8ae49d07$export$2e2bcd8739ae039 = (0, $71bdcd7c0fde8ceb$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $krg3S = parcelRequire("krg3S");


const $8dac84b60b4d7b1d$export$d586e0ae81c7b89b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  margin-top: ${({ label: label })=>label && "-5px;"};
`;
const $8dac84b60b4d7b1d$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  min-height: 48px;
`;
const $8dac84b60b4d7b1d$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  position: relative;
  z-index: 1;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  font-size: 12px;
  padding: 0 8px;
  transform: translate(15px, 15px);

  background-color: ${({ theme: theme })=>theme.colors.white};
  border-radius: 5px;
`;
const $8dac84b60b4d7b1d$export$d6701e98ab1a6725 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  display: none;
`;
const $8dac84b60b4d7b1d$export$11a8a1ea41bf55d8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).option`
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $8dac84b60b4d7b1d$export$37cdf0d06bb542b5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  color: ${({ theme: theme })=>theme.colors.darkGray};
  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? "transparent" : theme.colors.lightGray};
  transition: 0.4s;

  position: relative;
  // TODO: Use theme functions
  &:after {
    content: '';

    position: absolute;
    top: 42%;
    right: 15px;

    display: ${({ disabled: disabled })=>disabled ? "none" : "inline-block"};
    margin-left: 0.255em;
    vertical-align: 0.255em;

    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
    color: ${({ theme: theme })=>theme.colors.darkGray};
  }

  min-height: 54px;
  height: fit-content;
  width: 100%;

  padding: 15px 20px;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  box-shadow: none;

  border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;
const $8dac84b60b4d7b1d$export$a6151309bfd46137 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 100%;
  display: flex;
  flex-direction: column;
  max-height: 300px;
  overflow-y: auto;

  padding: 10px 15px;
  width: 100%;

  font-size: 14px;
  border-radius: 10px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  background-color: ${({ theme: theme })=>theme.colors.white};
  border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
  user-select: none;
  z-index: 2;
`;
const $8dac84b60b4d7b1d$export$ba141e9a22070242 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  padding: 10px;

  cursor: pointer;
  transition: 0.4s;

  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 10px;

  &:hover {
    border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
  }
`;
const $8dac84b60b4d7b1d$export$185a8afe504e8fca = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  bottom: -20px;
  right: 5px;
  color: ${({ theme: theme })=>theme.colors.brightRed};
  font-size: 14px;
`;
const $8dac84b60b4d7b1d$export$a11e67ac8be84bf9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.lightGray};
`;


// Function that listens to oustide clicks of given ref
const $410e5da9cf493fe8$var$useOutsideAlerter = (ref, setShowOptions)=>{
    (0, $tZqWC.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) setShowOptions(false);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref
    ]);
};
function $410e5da9cf493fe8$var$FormSearchSelect(props) {
    // Destructure
    const { label: label, placeholder: placeholder, options: options, disabled: disabled, type: type, ...rest } = props;
    const [fields] = (0, $krg3S.useField)(props);
    // Variables
    const wrapperRef = (0, $tZqWC.useRef)();
    const inputRef = (0, $tZqWC.useRef)(null);
    const { name: name, value: value, onChange: onChange } = fields;
    // Hooks
    const [formValue, setValue] = (0, $tZqWC.useState)("");
    const [formValueChanged, setFormValueChanged] = (0, $tZqWC.useState)(false);
    const [valueLabel, setValueLabel] = (0, $tZqWC.useState)(placeholder || "");
    const [showOptions, setShowOptions] = (0, $tZqWC.useState)(false);
    const [optionState, setOptionState] = (0, $tZqWC.useState)(options);
    // Functions
    const handleOnChange = (inputValue, inputLabel)=>{
        setValue(inputValue);
        if (inputValue === undefined) {
            setValueLabel(placeholder || "");
            setFormValueChanged(true);
            return setShowOptions(false);
        }
        setValueLabel(inputLabel);
        setFormValueChanged(true);
        setShowOptions(false);
    };
    const handleOnSearch = (inputValue)=>{
        if (!showOptions) setShowOptions(true);
        setValueLabel(inputValue);
        if (!inputValue) {
            setOptionState(options);
            setValue("");
            return setFormValueChanged(true);
        }
        const newOptions = [];
        options.forEach((option)=>{
            if (option?.label.toLowerCase().startsWith(inputValue.toLowerCase())) newOptions.push(option);
        });
        if (newOptions.length < 1) return setOptionState([]);
        setOptionState(newOptions);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        // setting the value and label on initial load
        if (value !== undefined && value !== null) {
            setValue(value);
            const currentLabel = options.find((data)=>{
                if (typeof data.value === "number") return data.value === Number(value);
                return data.value === value;
            });
            if (currentLabel?.label) setValueLabel(currentLabel.label);
            else if (!currentLabel?.label) setValueLabel(placeholder || "");
        }
    }, [
        value
    ]);
    // manually calling onchange event of formik input through onClick
    (0, $tZqWC.useEffect)(()=>{
        if (formValueChanged) {
            inputRef.current.click();
            setFormValueChanged(false);
        }
    }, [
        formValueChanged
    ]);
    (0, $tZqWC.useEffect)(()=>setOptionState(options), [
        options
    ]);
    // Closing options on click away
    $410e5da9cf493fe8$var$useOutsideAlerter(wrapperRef, setShowOptions);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8dac84b60b4d7b1d$export$d586e0ae81c7b89b), {
        label: label,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8dac84b60b4d7b1d$export$b04be29aa201d4f5), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8dac84b60b4d7b1d$export$8f1ff89fa1ec9605), {
                ref: wrapperRef,
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8dac84b60b4d7b1d$export$d6701e98ab1a6725), {
                        autoComplete: "form-search-select",
                        ref: inputRef,
                        type: "search",
                        onClick: (e)=>{
                            onChange(e);
                        },
                        name: name,
                        onChange: ()=>{},
                        value: formValue,
                        ...rest
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8dac84b60b4d7b1d$export$37cdf0d06bb542b5), {
                        autoComplete: "form-search-select",
                        disabled: disabled,
                        value: valueLabel !== undefined ? valueLabel : placeholder,
                        type: "search",
                        onChange: (e)=>handleOnSearch(e.target.value),
                        onClick: ()=>{
                            if (!disabled) setShowOptions(true);
                        }
                    }),
                    showOptions && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8dac84b60b4d7b1d$export$a6151309bfd46137), {
                        children: [
                            optionState.length > 0 && optionState.map(({ value: value, label: label, abrv: abrv, icon: icon })=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                                    children: label !== valueLabel && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8dac84b60b4d7b1d$export$ba141e9a22070242), {
                                        onClick: ()=>{
                                            handleOnChange(value, label);
                                        },
                                        value: value,
                                        children: [
                                            icon && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $65f0d7ff3fd922b2$export$2e2bcd8739ae039), {
                                                src: icon,
                                                width: 30,
                                                height: 30
                                            }),
                                            label,
                                            abrv && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8dac84b60b4d7b1d$export$a11e67ac8be84bf9), {
                                                children: [
                                                    " ",
                                                    abrv,
                                                    " "
                                                ]
                                            })
                                        ]
                                    })
                                }, label)),
                            optionState.length < 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                                children: " No Options Found"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8dac84b60b4d7b1d$export$185a8afe504e8fca), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $krg3S.ErrorMessage), {
                            ...fields
                        })
                    })
                ]
            })
        ]
    });
}
// Default Props
$410e5da9cf493fe8$var$FormSearchSelect.defaultProps = {
    label: "",
    placeholder: "",
    type: "",
    options: []
};
// Proptypes Validation
$410e5da9cf493fe8$var$FormSearchSelect.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
};
var $410e5da9cf493fe8$export$2e2bcd8739ae039 = $410e5da9cf493fe8$var$FormSearchSelect;


var $6e833112b656c531$export$2e2bcd8739ae039 = (0, $410e5da9cf493fe8$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $krg3S = parcelRequire("krg3S");

const $5dbcf21c9661f74b$export$bd2d217f1bfbe4e5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  margin-top: ${({ label: label })=>label && "-5px;"};
`;
const $5dbcf21c9661f74b$export$842aba50ed0ce9d7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  position: relative;
  z-index: 1;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  font-size: 12px;
  padding: 0 8px;
  transform: translate(15px, 15px);

  background-color: ${({ theme: theme })=>theme.colors.white};
  border-radius: 5px;
`;
const $5dbcf21c9661f74b$export$60f0a624ce7f4c8e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).textarea`
  padding: 15px 20px;
  font-size: 16px;
  border-radius: 10px;
  width: 100%;
  height: 100%;
  font-weight: 400;
  outline: none;
  color: ${({ theme: theme })=>theme.colors.darkGray};

  border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? "transparent" : theme.colors.lightGray};

  ${({ resize: resize })=>!resize && "resize: none;"}

  &::placeholder {
    color: ${({ theme: theme })=>theme.colors.darkGray};
  }
`;
const $5dbcf21c9661f74b$export$185a8afe504e8fca = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  bottom: -20px;
  right: 5px;
  color: ${({ theme: theme })=>theme.colors.brightRed};
  font-size: 14px;
`;


function $82245cdcedb5ed12$var$FormTextArea(props) {
    // Destructure
    const { type: type, label: label, resize: resize, disabled: disabled, ...rest } = props;
    // Hooks
    const [fields] = (0, $krg3S.useField)(props);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5dbcf21c9661f74b$export$bd2d217f1bfbe4e5), {
        label: label,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5dbcf21c9661f74b$export$842aba50ed0ce9d7), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5dbcf21c9661f74b$export$60f0a624ce7f4c8e), {
                disabled: disabled,
                type: type,
                resize: resize,
                ...fields,
                ...rest
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5dbcf21c9661f74b$export$185a8afe504e8fca), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $krg3S.ErrorMessage), {
                    ...fields
                })
            })
        ]
    });
}
// Default Props
$82245cdcedb5ed12$var$FormTextArea.defaultProps = {
    type: "",
    label: "",
    resize: true,
    disabled: false
};
// Proptypes Validation
$82245cdcedb5ed12$var$FormTextArea.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    resize: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $82245cdcedb5ed12$export$2e2bcd8739ae039 = $82245cdcedb5ed12$var$FormTextArea;


var $dfc171aac0fd6ec5$export$2e2bcd8739ae039 = (0, $82245cdcedb5ed12$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $krg3S = parcelRequire("krg3S");

const $88815f1cf6dffe6d$export$a915f81916d25a71 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  margin-top: ${({ label: label })=>label && "-5px;"};
  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? theme.colors.lightGray : "transparent"};
`;
const $88815f1cf6dffe6d$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  min-height: 48px;
`;
const $88815f1cf6dffe6d$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  position: relative;
  z-index: 1;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  font-size: 12px;
  padding: 0 8px;
  transform: translate(15px, 15px);

  background-color: ${({ theme: theme })=>theme.colors.white};
  border-radius: 5px;
`;
const $88815f1cf6dffe6d$export$7edc06cf1783b30f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  display: none;
`;
const $88815f1cf6dffe6d$export$11a8a1ea41bf55d8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).option`
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $88815f1cf6dffe6d$export$ced7ae022d0f5ee5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  cursor: pointer;
  transition: 0.4s;
  color: ${({ theme: theme })=>theme.colors.darkGray};

  position: relative;
  // TODO: Use theme functions
  &:after {
    content: '';

    position: absolute;
    top: 42%;
    right: 15px;

    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;

    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
    color: ${({ theme: theme })=>theme.colors.darkGray};
  }

  min-height: 48px;
  height: fit-content;
  width: 100%;

  padding: 15px 20px;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  box-shadow: none;

  border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};

  &:hover {
    box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.1);
  }
`;
const $88815f1cf6dffe6d$export$a6151309bfd46137 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 300px;
  overflow-y: auto;

  padding: 10px;
  width: 100%;

  font-size: 14px;
  border-radius: 10px;
  font-weight: 400;
  background-color: ${({ theme: theme })=>theme.colors.white};
  border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
  user-select: none;
  z-index: 2;
`;
const $88815f1cf6dffe6d$export$ba141e9a22070242 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.darkGray};

  cursor: pointer;
  transition: 0.4s;

  border: ${({ theme: theme })=>`1px solid ${theme.colors.lightGray}`};
  border-radius: 10px;

  &:hover {
    background: ${({ theme: theme })=>theme.colors.ash};
  }
`;
const $88815f1cf6dffe6d$export$185a8afe504e8fca = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  bottom: -20px;
  right: 5px;
  color: ${({ theme: theme })=>theme.colors.brightRed};
  font-size: 14px;
`;



function $d2e044837429ccb8$var$FormDatePicker(props) {
    // Destructure
    const { label: label, disabled: disabled, placeholder: placeholder, options: options, ...rest } = props;
    const [fields] = (0, $krg3S.useField)(props);
    // Variables
    const wrapperRef = (0, $tZqWC.useRef)();
    const inputRef = (0, $tZqWC.useRef)(null);
    const { name: name, value: value, onChange: onChange } = fields;
    // Hooks
    const [formValue, setFormValue] = (0, $tZqWC.useState)("");
    // Functions
    const handleOnChange = async (elValue)=>{
        await setFormValue(elValue);
        // manually calling onchange event of formik input through onClick
        inputRef.current.click();
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        // setting the value on initial load
        if (value) setFormValue(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $88815f1cf6dffe6d$export$a915f81916d25a71), {
        label: label,
        ref: wrapperRef,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $88815f1cf6dffe6d$export$b04be29aa201d4f5), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $88815f1cf6dffe6d$export$8f1ff89fa1ec9605), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $88815f1cf6dffe6d$export$7edc06cf1783b30f), {
                        ref: inputRef,
                        onClick: (e)=>{
                            onChange(e);
                        },
                        name: name,
                        onChange: ()=>{},
                        value: formValue,
                        type: "date",
                        disabled: disabled,
                        ...rest
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0c99b953747ef22f$export$2e2bcd8739ae039), {
                        disabled: disabled,
                        defaultDate: formValue,
                        onApply: handleOnChange
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $88815f1cf6dffe6d$export$185a8afe504e8fca), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $krg3S.ErrorMessage), {
                            ...fields
                        })
                    })
                ]
            })
        ]
    });
}
// Default Props
$d2e044837429ccb8$var$FormDatePicker.defaultProps = {
    label: "",
    placeholder: "",
    disabled: false,
    options: []
};
// Proptypes Validation
$d2e044837429ccb8$var$FormDatePicker.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
};
var $d2e044837429ccb8$export$2e2bcd8739ae039 = $d2e044837429ccb8$var$FormDatePicker;


var $a5484141b8231e9a$export$2e2bcd8739ae039 = (0, $d2e044837429ccb8$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");
var $70bae84a94585e38$exports = {};

var $kuzpm = parcelRequire("kuzpm");
"use strict";
Object.defineProperty($70bae84a94585e38$exports, "__esModule", {
    value: true
});
Object.defineProperty($70bae84a94585e38$exports, "Chart", {
    enumerable: true,
    get: function get() {
        return $70bae84a94585e38$var$_chart["default"];
    }
});
$70bae84a94585e38$exports.defaults = $70bae84a94585e38$exports.Scatter = $70bae84a94585e38$exports.Bubble = $70bae84a94585e38$exports.Polar = $70bae84a94585e38$exports.Radar = $70bae84a94585e38$exports.HorizontalBar = $70bae84a94585e38$exports.Bar = $70bae84a94585e38$exports.Line = $70bae84a94585e38$exports.Pie = $70bae84a94585e38$exports.Doughnut = $70bae84a94585e38$exports["default"] = void 0;

var $70bae84a94585e38$var$_react = $70bae84a94585e38$var$_interopRequireDefault((parcelRequire("tZqWC")));

var $70bae84a94585e38$var$_propTypes = $70bae84a94585e38$var$_interopRequireDefault((parcelRequire("4L3zM")));

var $70bae84a94585e38$var$_chart = $70bae84a94585e38$var$_interopRequireDefault((parcelRequire("lb2du")));

var $70bae84a94585e38$var$_isEqual = $70bae84a94585e38$var$_interopRequireDefault((parcelRequire("a39iZ")));

var $70bae84a94585e38$var$_keyBy = $70bae84a94585e38$var$_interopRequireDefault((parcelRequire("eKkfN")));
function $70bae84a94585e38$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $70bae84a94585e38$var$_extends() {
    $70bae84a94585e38$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $70bae84a94585e38$var$_extends.apply(this, arguments);
}
function $70bae84a94585e38$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $70bae84a94585e38$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $70bae84a94585e38$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $70bae84a94585e38$var$_typeof(obj);
}
function $70bae84a94585e38$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $70bae84a94585e38$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $70bae84a94585e38$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $70bae84a94585e38$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $70bae84a94585e38$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $70bae84a94585e38$var$ownKeys(Object(source), true).forEach(function(key) {
            $70bae84a94585e38$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $70bae84a94585e38$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $70bae84a94585e38$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $70bae84a94585e38$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $70bae84a94585e38$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $70bae84a94585e38$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $70bae84a94585e38$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $70bae84a94585e38$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $70bae84a94585e38$var$_setPrototypeOf(subClass, superClass);
}
function $70bae84a94585e38$var$_setPrototypeOf(o, p) {
    $70bae84a94585e38$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $70bae84a94585e38$var$_setPrototypeOf(o, p);
}
function $70bae84a94585e38$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $70bae84a94585e38$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $70bae84a94585e38$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $70bae84a94585e38$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $70bae84a94585e38$var$_possibleConstructorReturn(this, result);
    };
}
function $70bae84a94585e38$var$_possibleConstructorReturn(self, call) {
    if (call && ($70bae84a94585e38$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $70bae84a94585e38$var$_assertThisInitialized(self);
}
function $70bae84a94585e38$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $70bae84a94585e38$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $70bae84a94585e38$var$_getPrototypeOf(o) {
    $70bae84a94585e38$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $70bae84a94585e38$var$_getPrototypeOf(o);
}
function $70bae84a94585e38$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $70bae84a94585e38$var$NODE_ENV = typeof $kuzpm !== "undefined" && $kuzpm.env && "production";
var $70bae84a94585e38$var$ChartComponent = /*#__PURE__*/ function(_React$Component) {
    $70bae84a94585e38$var$_inherits(ChartComponent, _React$Component);
    var _super = $70bae84a94585e38$var$_createSuper(ChartComponent);
    function ChartComponent() {
        var _this;
        $70bae84a94585e38$var$_classCallCheck(this, ChartComponent);
        _this = _super.call(this);
        $70bae84a94585e38$var$_defineProperty($70bae84a94585e38$var$_assertThisInitialized(_this), "handleOnClick", function(event) {
            var instance = _this.chartInstance;
            var _this$props = _this.props, getDatasetAtEvent = _this$props.getDatasetAtEvent, getElementAtEvent = _this$props.getElementAtEvent, getElementsAtEvent = _this$props.getElementsAtEvent, onElementsClick = _this$props.onElementsClick;
            getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
            getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
            getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
            onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
        });
        $70bae84a94585e38$var$_defineProperty($70bae84a94585e38$var$_assertThisInitialized(_this), "ref", function(element) {
            _this.element = element;
        });
        _this.chartInstance = undefined;
        return _this;
    }
    $70bae84a94585e38$var$_createClass(ChartComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.renderChart();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this.props.redraw) {
                    this.destroyChart();
                    this.renderChart();
                    return;
                }
                this.updateChart();
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var _this$props2 = this.props, redraw = _this$props2.redraw, type = _this$props2.type, options = _this$props2.options, plugins = _this$props2.plugins, legend = _this$props2.legend, height = _this$props2.height, width = _this$props2.width;
                if (nextProps.redraw === true) return true;
                if (height !== nextProps.height || width !== nextProps.width) return true;
                if (type !== nextProps.type) return true;
                if (!(0, $70bae84a94585e38$var$_isEqual["default"])(legend, nextProps.legend)) return true;
                if (!(0, $70bae84a94585e38$var$_isEqual["default"])(options, nextProps.options)) return true;
                var nextData = this.transformDataProp(nextProps);
                if (!(0, $70bae84a94585e38$var$_isEqual["default"])(this.shadowDataProp, nextData)) return true;
                return !(0, $70bae84a94585e38$var$_isEqual["default"])(plugins, nextProps.plugins);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.destroyChart();
            }
        },
        {
            key: "transformDataProp",
            value: function transformDataProp(props) {
                var data = props.data;
                if (typeof data == "function") {
                    var node = this.element;
                    return data(node);
                } else return data;
            } // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
        },
        {
            key: "memoizeDataProps",
            value: function memoizeDataProps() {
                if (!this.props.data) return;
                var data = this.transformDataProp(this.props);
                this.shadowDataProp = $70bae84a94585e38$var$_objectSpread($70bae84a94585e38$var$_objectSpread({}, data), {}, {
                    datasets: data.datasets && data.datasets.map(function(set) {
                        return $70bae84a94585e38$var$_objectSpread({}, set);
                    })
                });
                this.saveCurrentDatasets(); // to remove the dataset metadata from this chart when the chart is destroyed
                return data;
            }
        },
        {
            key: "checkDatasets",
            value: function checkDatasets(datasets) {
                var isDev = $70bae84a94585e38$var$NODE_ENV !== "production" && $70bae84a94585e38$var$NODE_ENV !== "prod";
                var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
                var multipleDatasets = datasets.length > 1;
                if (isDev && multipleDatasets && !usingCustomKeyProvider) {
                    var shouldWarn = false;
                    datasets.forEach(function(dataset) {
                        if (!dataset.label) shouldWarn = true;
                    });
                    if (shouldWarn) console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
                }
            }
        },
        {
            key: "getCurrentDatasets",
            value: function getCurrentDatasets() {
                return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
            }
        },
        {
            key: "saveCurrentDatasets",
            value: function saveCurrentDatasets() {
                var _this2 = this;
                this.datasets = this.datasets || {};
                var currentDatasets = this.getCurrentDatasets();
                currentDatasets.forEach(function(d) {
                    _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
                });
            }
        },
        {
            key: "updateChart",
            value: function updateChart() {
                var _this3 = this;
                var options = this.props.options;
                var data = this.memoizeDataProps(this.props);
                if (!this.chartInstance) return;
                if (options) this.chartInstance.options = $70bae84a94585e38$var$_chart["default"].helpers.configMerge(this.chartInstance.options, options);
                 // Pipe datasets to chart instance datasets enabling
                // seamless transitions
                var currentDatasets = this.getCurrentDatasets();
                var nextDatasets = data.datasets || [];
                this.checkDatasets(currentDatasets);
                var currentDatasetsIndexed = (0, $70bae84a94585e38$var$_keyBy["default"])(currentDatasets, this.props.datasetKeyProvider); // We can safely replace the dataset array, as long as we retain the _meta property
                // on each dataset.
                this.chartInstance.config.data.datasets = nextDatasets.map(function(next) {
                    var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];
                    if (current && current.type === next.type && next.data) {
                        // Be robust to no data. Relevant for other update mechanisms as in chartjs-plugin-streaming.
                        // The data array must be edited in place. As chart.js adds listeners to it.
                        current.data.splice(next.data.length);
                        next.data.forEach(function(point, pid) {
                            current.data[pid] = next.data[pid];
                        });
                        var _data = next.data, otherProps = $70bae84a94585e38$var$_objectWithoutProperties(next, [
                            "data"
                        ]); // Merge properties. Notice a weakness here. If a property is removed
                        // from next, it will be retained by current and never disappears.
                        // Workaround is to set value to null or undefined in next.
                        return $70bae84a94585e38$var$_objectSpread($70bae84a94585e38$var$_objectSpread({}, current), otherProps);
                    } else return next;
                });
                var datasets = data.datasets, rest = $70bae84a94585e38$var$_objectWithoutProperties(data, [
                    "datasets"
                ]);
                this.chartInstance.config.data = $70bae84a94585e38$var$_objectSpread($70bae84a94585e38$var$_objectSpread({}, this.chartInstance.config.data), rest);
                this.chartInstance.update();
            }
        },
        {
            key: "renderChart",
            value: function renderChart() {
                var _this$props3 = this.props, options = _this$props3.options, legend = _this$props3.legend, type = _this$props3.type, plugins = _this$props3.plugins;
                var node = this.element;
                var data = this.memoizeDataProps();
                if (typeof legend !== "undefined" && !(0, $70bae84a94585e38$var$_isEqual["default"])(ChartComponent.defaultProps.legend, legend)) options.legend = legend;
                this.chartInstance = new $70bae84a94585e38$var$_chart["default"](node, {
                    type: type,
                    data: data,
                    options: options,
                    plugins: plugins
                });
            }
        },
        {
            key: "destroyChart",
            value: function destroyChart() {
                if (!this.chartInstance) return;
                 // Put all of the datasets that have existed in the chart back on the chart
                // so that the metadata associated with this chart get destroyed.
                // This allows the datasets to be used in another chart. This can happen,
                // for example, in a tabbed UI where the chart gets created each time the
                // tab gets switched to the chart and uses the same data).
                this.saveCurrentDatasets();
                var datasets = Object.values(this.datasets);
                this.chartInstance.config.data.datasets = datasets;
                this.chartInstance.destroy();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, height = _this$props4.height, width = _this$props4.width, id = _this$props4.id;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement("canvas", {
                    ref: this.ref,
                    height: height,
                    width: width,
                    id: id,
                    onClick: this.handleOnClick
                });
            }
        }
    ]);
    return ChartComponent;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$var$_defineProperty($70bae84a94585e38$var$ChartComponent, "getLabelAsKey", function(d) {
    return d.label;
});
$70bae84a94585e38$var$_defineProperty($70bae84a94585e38$var$ChartComponent, "propTypes", {
    data: $70bae84a94585e38$var$_propTypes["default"].oneOfType([
        $70bae84a94585e38$var$_propTypes["default"].object,
        $70bae84a94585e38$var$_propTypes["default"].func
    ]).isRequired,
    getDatasetAtEvent: $70bae84a94585e38$var$_propTypes["default"].func,
    getElementAtEvent: $70bae84a94585e38$var$_propTypes["default"].func,
    getElementsAtEvent: $70bae84a94585e38$var$_propTypes["default"].func,
    height: $70bae84a94585e38$var$_propTypes["default"].number,
    legend: $70bae84a94585e38$var$_propTypes["default"].object,
    onElementsClick: $70bae84a94585e38$var$_propTypes["default"].func,
    options: $70bae84a94585e38$var$_propTypes["default"].object,
    plugins: $70bae84a94585e38$var$_propTypes["default"].arrayOf($70bae84a94585e38$var$_propTypes["default"].object),
    redraw: $70bae84a94585e38$var$_propTypes["default"].bool,
    type: function type(props, propName, componentName) {
        if (!$70bae84a94585e38$var$_chart["default"].controllers[props[propName]]) return new Error("Invalid chart type `" + props[propName] + "` supplied to" + " `" + componentName + "`.");
    },
    width: $70bae84a94585e38$var$_propTypes["default"].number,
    datasetKeyProvider: $70bae84a94585e38$var$_propTypes["default"].func
});
$70bae84a94585e38$var$_defineProperty($70bae84a94585e38$var$ChartComponent, "defaultProps", {
    legend: {
        display: true,
        position: "bottom"
    },
    type: "doughnut",
    height: 150,
    width: 300,
    redraw: false,
    options: {},
    datasetKeyProvider: $70bae84a94585e38$var$ChartComponent.getLabelAsKey
});
var $70bae84a94585e38$var$_default = $70bae84a94585e38$var$ChartComponent;
$70bae84a94585e38$exports["default"] = $70bae84a94585e38$var$_default;
var $70bae84a94585e38$var$Doughnut = /*#__PURE__*/ function(_React$Component2) {
    $70bae84a94585e38$var$_inherits(Doughnut, _React$Component2);
    var _super2 = $70bae84a94585e38$var$_createSuper(Doughnut);
    function Doughnut() {
        $70bae84a94585e38$var$_classCallCheck(this, Doughnut);
        return _super2.apply(this, arguments);
    }
    $70bae84a94585e38$var$_createClass(Doughnut, [
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement($70bae84a94585e38$var$ChartComponent, $70bae84a94585e38$var$_extends({}, this.props, {
                    ref: function ref(_ref) {
                        return _this4.chartInstance = _ref && _ref.chartInstance;
                    },
                    type: "doughnut"
                }));
            }
        }
    ]);
    return Doughnut;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$exports.Doughnut = $70bae84a94585e38$var$Doughnut;
var $70bae84a94585e38$var$Pie = /*#__PURE__*/ function(_React$Component3) {
    $70bae84a94585e38$var$_inherits(Pie, _React$Component3);
    var _super3 = $70bae84a94585e38$var$_createSuper(Pie);
    function Pie() {
        $70bae84a94585e38$var$_classCallCheck(this, Pie);
        return _super3.apply(this, arguments);
    }
    $70bae84a94585e38$var$_createClass(Pie, [
        {
            key: "render",
            value: function render() {
                var _this5 = this;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement($70bae84a94585e38$var$ChartComponent, $70bae84a94585e38$var$_extends({}, this.props, {
                    ref: function ref(_ref2) {
                        return _this5.chartInstance = _ref2 && _ref2.chartInstance;
                    },
                    type: "pie"
                }));
            }
        }
    ]);
    return Pie;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$exports.Pie = $70bae84a94585e38$var$Pie;
var $70bae84a94585e38$var$Line = /*#__PURE__*/ function(_React$Component4) {
    $70bae84a94585e38$var$_inherits(Line, _React$Component4);
    var _super4 = $70bae84a94585e38$var$_createSuper(Line);
    function Line() {
        $70bae84a94585e38$var$_classCallCheck(this, Line);
        return _super4.apply(this, arguments);
    }
    $70bae84a94585e38$var$_createClass(Line, [
        {
            key: "render",
            value: function render() {
                var _this6 = this;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement($70bae84a94585e38$var$ChartComponent, $70bae84a94585e38$var$_extends({}, this.props, {
                    ref: function ref(_ref3) {
                        return _this6.chartInstance = _ref3 && _ref3.chartInstance;
                    },
                    type: "line"
                }));
            }
        }
    ]);
    return Line;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$exports.Line = $70bae84a94585e38$var$Line;
var $70bae84a94585e38$var$Bar = /*#__PURE__*/ function(_React$Component5) {
    $70bae84a94585e38$var$_inherits(Bar, _React$Component5);
    var _super5 = $70bae84a94585e38$var$_createSuper(Bar);
    function Bar() {
        $70bae84a94585e38$var$_classCallCheck(this, Bar);
        return _super5.apply(this, arguments);
    }
    $70bae84a94585e38$var$_createClass(Bar, [
        {
            key: "render",
            value: function render() {
                var _this7 = this;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement($70bae84a94585e38$var$ChartComponent, $70bae84a94585e38$var$_extends({}, this.props, {
                    ref: function ref(_ref4) {
                        return _this7.chartInstance = _ref4 && _ref4.chartInstance;
                    },
                    type: "bar"
                }));
            }
        }
    ]);
    return Bar;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$exports.Bar = $70bae84a94585e38$var$Bar;
var $70bae84a94585e38$var$HorizontalBar = /*#__PURE__*/ function(_React$Component6) {
    $70bae84a94585e38$var$_inherits(HorizontalBar, _React$Component6);
    var _super6 = $70bae84a94585e38$var$_createSuper(HorizontalBar);
    function HorizontalBar() {
        $70bae84a94585e38$var$_classCallCheck(this, HorizontalBar);
        return _super6.apply(this, arguments);
    }
    $70bae84a94585e38$var$_createClass(HorizontalBar, [
        {
            key: "render",
            value: function render() {
                var _this8 = this;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement($70bae84a94585e38$var$ChartComponent, $70bae84a94585e38$var$_extends({}, this.props, {
                    ref: function ref(_ref5) {
                        return _this8.chartInstance = _ref5 && _ref5.chartInstance;
                    },
                    type: "horizontalBar"
                }));
            }
        }
    ]);
    return HorizontalBar;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$exports.HorizontalBar = $70bae84a94585e38$var$HorizontalBar;
var $70bae84a94585e38$var$Radar = /*#__PURE__*/ function(_React$Component7) {
    $70bae84a94585e38$var$_inherits(Radar, _React$Component7);
    var _super7 = $70bae84a94585e38$var$_createSuper(Radar);
    function Radar() {
        $70bae84a94585e38$var$_classCallCheck(this, Radar);
        return _super7.apply(this, arguments);
    }
    $70bae84a94585e38$var$_createClass(Radar, [
        {
            key: "render",
            value: function render() {
                var _this9 = this;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement($70bae84a94585e38$var$ChartComponent, $70bae84a94585e38$var$_extends({}, this.props, {
                    ref: function ref(_ref6) {
                        return _this9.chartInstance = _ref6 && _ref6.chartInstance;
                    },
                    type: "radar"
                }));
            }
        }
    ]);
    return Radar;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$exports.Radar = $70bae84a94585e38$var$Radar;
var $70bae84a94585e38$var$Polar = /*#__PURE__*/ function(_React$Component8) {
    $70bae84a94585e38$var$_inherits(Polar, _React$Component8);
    var _super8 = $70bae84a94585e38$var$_createSuper(Polar);
    function Polar() {
        $70bae84a94585e38$var$_classCallCheck(this, Polar);
        return _super8.apply(this, arguments);
    }
    $70bae84a94585e38$var$_createClass(Polar, [
        {
            key: "render",
            value: function render() {
                var _this10 = this;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement($70bae84a94585e38$var$ChartComponent, $70bae84a94585e38$var$_extends({}, this.props, {
                    ref: function ref(_ref7) {
                        return _this10.chartInstance = _ref7 && _ref7.chartInstance;
                    },
                    type: "polarArea"
                }));
            }
        }
    ]);
    return Polar;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$exports.Polar = $70bae84a94585e38$var$Polar;
var $70bae84a94585e38$var$Bubble = /*#__PURE__*/ function(_React$Component9) {
    $70bae84a94585e38$var$_inherits(Bubble, _React$Component9);
    var _super9 = $70bae84a94585e38$var$_createSuper(Bubble);
    function Bubble() {
        $70bae84a94585e38$var$_classCallCheck(this, Bubble);
        return _super9.apply(this, arguments);
    }
    $70bae84a94585e38$var$_createClass(Bubble, [
        {
            key: "render",
            value: function render() {
                var _this11 = this;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement($70bae84a94585e38$var$ChartComponent, $70bae84a94585e38$var$_extends({}, this.props, {
                    ref: function ref(_ref8) {
                        return _this11.chartInstance = _ref8 && _ref8.chartInstance;
                    },
                    type: "bubble"
                }));
            }
        }
    ]);
    return Bubble;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$exports.Bubble = $70bae84a94585e38$var$Bubble;
var $70bae84a94585e38$var$Scatter = /*#__PURE__*/ function(_React$Component10) {
    $70bae84a94585e38$var$_inherits(Scatter, _React$Component10);
    var _super10 = $70bae84a94585e38$var$_createSuper(Scatter);
    function Scatter() {
        $70bae84a94585e38$var$_classCallCheck(this, Scatter);
        return _super10.apply(this, arguments);
    }
    $70bae84a94585e38$var$_createClass(Scatter, [
        {
            key: "render",
            value: function render() {
                var _this12 = this;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement($70bae84a94585e38$var$ChartComponent, $70bae84a94585e38$var$_extends({}, this.props, {
                    ref: function ref(_ref9) {
                        return _this12.chartInstance = _ref9 && _ref9.chartInstance;
                    },
                    type: "scatter"
                }));
            }
        }
    ]);
    return Scatter;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$exports.Scatter = $70bae84a94585e38$var$Scatter;
var $70bae84a94585e38$var$defaults = $70bae84a94585e38$var$_chart["default"].defaults;
$70bae84a94585e38$exports.defaults = $70bae84a94585e38$var$defaults;



const $f9f6294eaa038b13$export$cd4324e55f792afb = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
	position: relative;
	height: 100%;
	width: 100%;
`;


function $5018f20743ac426f$var$DoughnutChart(props) {
    // Destructure
    const { data: data, width: width, height: height, options: options } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f9f6294eaa038b13$export$cd4324e55f792afb), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $70bae84a94585e38$exports.Doughnut), {
            data: data,
            width: width,
            height: height,
            options: options
        })
    });
}
// Default Props
$5018f20743ac426f$var$DoughnutChart.defaultProps = {
    data: {
        label: [],
        datasets: []
    },
    width: "",
    height: "",
    options: {}
};
// Proptypes Validation
$5018f20743ac426f$var$DoughnutChart.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        labels: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        datasets: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
    }),
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $5018f20743ac426f$export$2e2bcd8739ae039 = $5018f20743ac426f$var$DoughnutChart;


var $7b658d9b90651bd3$export$2e2bcd8739ae039 = (0, $5018f20743ac426f$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $228500a065751d1b$export$898f5ec6036845f7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
	min-height: 230px;
	position: relative;
	height: 100%;
	width: 100%;
`;


function $59172335196825eb$var$BarChart(props) {
    // Destructure
    const { data: data, width: width, height: height, options: options, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $228500a065751d1b$export$898f5ec6036845f7), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $70bae84a94585e38$exports.Bar), {
            data: data,
            width: width,
            height: height,
            options: options,
            ...rest
        })
    });
}
// Default Props
$59172335196825eb$var$BarChart.defaultProps = {
    data: {},
    width: 200,
    height: 90,
    options: {}
};
// Proptypes Validation
$59172335196825eb$var$BarChart.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $59172335196825eb$export$2e2bcd8739ae039 = $59172335196825eb$var$BarChart;


var $bff95e0871fbe022$export$2e2bcd8739ae039 = (0, $59172335196825eb$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $5ed367a705090257$export$ec7c7d6f0ed2fed1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
	position: relative;
	height: 100%;
	width: 100%;
`;


function $b606c2edd7083662$var$LineChart(props) {
    // Destructure
    const { data: data, width: width, height: height, options: options } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5ed367a705090257$export$ec7c7d6f0ed2fed1), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $70bae84a94585e38$exports.Line), {
            data: data,
            width: width,
            height: height,
            options: options
        })
    });
}
// Default Props
$b606c2edd7083662$var$LineChart.defaultProps = {
    data: {},
    width: 200,
    height: 90,
    options: {}
};
// Proptypes Validation
$b606c2edd7083662$var$LineChart.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $b606c2edd7083662$export$2e2bcd8739ae039 = $b606c2edd7083662$var$LineChart;


var $1b9c00692a27807c$export$2e2bcd8739ae039 = (0, $b606c2edd7083662$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");
var $91aec0fe3a4b98f2$exports = {};
"use strict";
Object.defineProperty($91aec0fe3a4b98f2$exports, "__esModule", {
    value: true
});
$91aec0fe3a4b98f2$exports["default"] = undefined;
var $5451110f8ff557ba$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $f406636b535430a7$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // (1) The code `if (__DEV__) ...` can be removed by build tool.
// (2) If intend to use `__DEV__`, this module should be imported. Use a global
// variable `__DEV__` may cause that miss the declaration (see #6535), or the
// declaration is behind of the using position (for example in `Model.extent`,
// And tools like rollup can not analysis the dependency if not import).
var $f06357f91478219a$export$a866f231438cc228;
var $f06357f91478219a$var$dev; // In browser
if (typeof window !== "undefined") $f06357f91478219a$var$dev = window.__DEV__;
else if (typeof $parcel$global !== "undefined") $f06357f91478219a$var$dev = $parcel$global.__DEV__;
if (typeof $f06357f91478219a$var$dev === "undefined") $f06357f91478219a$var$dev = true;
var $f06357f91478219a$var$__DEV__ = $f06357f91478219a$var$dev;
$f06357f91478219a$export$a866f231438cc228 = $f06357f91478219a$var$__DEV__;


var $f406636b535430a7$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;
var $ec1efdd8e4428d18$exports = {};

$parcel$export($ec1efdd8e4428d18$exports, "version", () => $ec1efdd8e4428d18$export$83d89fbfd8236492, (v) => $ec1efdd8e4428d18$export$83d89fbfd8236492 = v);
$parcel$export($ec1efdd8e4428d18$exports, "init", () => $ec1efdd8e4428d18$export$2cd8252107eb640b, (v) => $ec1efdd8e4428d18$export$2cd8252107eb640b = v);
$parcel$export($ec1efdd8e4428d18$exports, "dispose", () => $ec1efdd8e4428d18$export$fcfbbcec2cb820d5, (v) => $ec1efdd8e4428d18$export$fcfbbcec2cb820d5 = v);
$parcel$export($ec1efdd8e4428d18$exports, "getInstance", () => $ec1efdd8e4428d18$export$8bedcca5bbd73999, (v) => $ec1efdd8e4428d18$export$8bedcca5bbd73999 = v);
$parcel$export($ec1efdd8e4428d18$exports, "registerPainter", () => $ec1efdd8e4428d18$export$a3e793ccb11823a5, (v) => $ec1efdd8e4428d18$export$a3e793ccb11823a5 = v);
var $ec1efdd8e4428d18$export$83d89fbfd8236492;
var $ec1efdd8e4428d18$export$2cd8252107eb640b;
var $ec1efdd8e4428d18$export$fcfbbcec2cb820d5;
var $ec1efdd8e4428d18$export$8bedcca5bbd73999;
var $ec1efdd8e4428d18$export$a3e793ccb11823a5;
var $b2a309a7eafc27fc$exports = {};
/**
 * zrender: 生成唯一id
 *
 * @author errorrik (errorrik@gmail.com)
 */ var $b2a309a7eafc27fc$var$idStart = 0x0907;
function $b2a309a7eafc27fc$var$_default() {
    return $b2a309a7eafc27fc$var$idStart++;
}
$b2a309a7eafc27fc$exports = $b2a309a7eafc27fc$var$_default;


var $27ac1413ecc67076$exports = {};
/**
 * echarts设备环境识别
 *
 * @desc echarts基于Canvas，纯Javascript图表库，提供直观，生动，可交互，可个性化定制的数据统计图表。
 * @author firede[firede@firede.us]
 * @desc thanks zepto.
 */ /* global wx */ var $27ac1413ecc67076$var$env = {};
if (typeof wx === "object" && typeof wx.getSystemInfoSync === "function") // In Weixin Application
$27ac1413ecc67076$var$env = {
    browser: {},
    os: {},
    node: false,
    wxa: true,
    // Weixin Application
    canvasSupported: true,
    svgSupported: false,
    touchEventsSupported: true,
    domSupported: false
};
else if (typeof document === "undefined" && typeof self !== "undefined") // In worker
$27ac1413ecc67076$var$env = {
    browser: {},
    os: {},
    node: false,
    worker: true,
    canvasSupported: true,
    domSupported: false
};
else if (typeof navigator === "undefined") // In node
$27ac1413ecc67076$var$env = {
    browser: {},
    os: {},
    node: true,
    worker: false,
    // Assume canvas is supported
    canvasSupported: true,
    svgSupported: true,
    domSupported: false
};
else $27ac1413ecc67076$var$env = $27ac1413ecc67076$var$detect(navigator.userAgent);
var $27ac1413ecc67076$var$_default = $27ac1413ecc67076$var$env; // Zepto.js
// (c) 2010-2013 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
function $27ac1413ecc67076$var$detect(ua) {
    var os = {};
    var browser = {}; // var webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/);
    // var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
    // var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    // var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    // var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
    // var webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/);
    // var touchpad = webos && ua.match(/TouchPad/);
    // var kindle = ua.match(/Kindle\/([\d.]+)/);
    // var silk = ua.match(/Silk\/([\d._]+)/);
    // var blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
    // var bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
    // var rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
    // var playbook = ua.match(/PlayBook/);
    // var chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);
    var firefox = ua.match(/Firefox\/([\d.]+)/); // var safari = webkit && ua.match(/Mobile\//) && !chrome;
    // var webview = ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/) && !chrome;
    var ie = ua.match(/MSIE\s([\d.]+)/) // IE 11 Trident/7.0; rv:11.0
     || ua.match(/Trident\/.+?rv:(([\d.]+))/);
    var edge = ua.match(/Edge\/([\d.]+)/); // IE 12 and 12+
    var weChat = /micromessenger/i.test(ua); // Todo: clean this up with a better OS/browser seperation:
    // - discern (more) between multiple browsers on android
    // - decide if kindle fire in silk mode is android or not
    // - Firefox on Android doesn't specify the Android version
    // - possibly devide in os, device and browser hashes
    // if (browser.webkit = !!webkit) browser.version = webkit[1];
    // if (android) os.android = true, os.version = android[2];
    // if (iphone && !ipod) os.ios = os.iphone = true, os.version = iphone[2].replace(/_/g, '.');
    // if (ipad) os.ios = os.ipad = true, os.version = ipad[2].replace(/_/g, '.');
    // if (ipod) os.ios = os.ipod = true, os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
    // if (webos) os.webos = true, os.version = webos[2];
    // if (touchpad) os.touchpad = true;
    // if (blackberry) os.blackberry = true, os.version = blackberry[2];
    // if (bb10) os.bb10 = true, os.version = bb10[2];
    // if (rimtabletos) os.rimtabletos = true, os.version = rimtabletos[2];
    // if (playbook) browser.playbook = true;
    // if (kindle) os.kindle = true, os.version = kindle[1];
    // if (silk) browser.silk = true, browser.version = silk[1];
    // if (!silk && os.android && ua.match(/Kindle Fire/)) browser.silk = true;
    // if (chrome) browser.chrome = true, browser.version = chrome[1];
    if (firefox) {
        browser.firefox = true;
        browser.version = firefox[1];
    } // if (safari && (ua.match(/Safari/) || !!os.ios)) browser.safari = true;
    // if (webview) browser.webview = true;
    if (ie) {
        browser.ie = true;
        browser.version = ie[1];
    }
    if (edge) {
        browser.edge = true;
        browser.version = edge[1];
    } // It is difficult to detect WeChat in Win Phone precisely, because ua can
    // not be set on win phone. So we do not consider Win Phone.
    if (weChat) browser.weChat = true;
     // os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) ||
    //     (firefox && ua.match(/Tablet/)) || (ie && !ua.match(/Phone/) && ua.match(/Touch/)));
    // os.phone  = !!(!os.tablet && !os.ipod && (android || iphone || webos ||
    //     (chrome && ua.match(/Android/)) || (chrome && ua.match(/CriOS\/([\d.]+)/)) ||
    //     (firefox && ua.match(/Mobile/)) || (ie && ua.match(/Touch/))));
    return {
        browser: browser,
        os: os,
        node: false,
        // 原生canvas支持，改极端点了
        // canvasSupported : !(browser.ie && parseFloat(browser.version) < 9)
        canvasSupported: !!document.createElement("canvas").getContext,
        svgSupported: typeof SVGRect !== "undefined",
        // works on most browsers
        // IE10/11 does not support touch event, and MS Edge supports them but not by
        // default, so we dont check navigator.maxTouchPoints for them here.
        touchEventsSupported: "ontouchstart" in window && !browser.ie && !browser.edge,
        // <http://caniuse.com/#search=pointer%20event>.
        pointerEventsSupported: // events currently. So we dont use that on other browsers unless tested sufficiently.
        // For example, in iOS 13 Mobile Chromium 78, if the touching behavior starts page
        // scroll, the `pointermove` event can not be fired any more. That will break some
        // features like "pan horizontally to move something and pan vertically to page scroll".
        // The horizontal pan probably be interrupted by the casually triggered page scroll.
        // (2) Although IE 10 supports pointer event, it use old style and is different from the
        // standard. So we exclude that. (IE 10 is hardly used on touch device)
        "onpointerdown" in window && (browser.edge || browser.ie && browser.version >= 11),
        // passiveSupported: detectPassiveSupport()
        domSupported: typeof document !== "undefined"
    };
} // See https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
// function detectPassiveSupport() {
//     // Test via a getter in the options object to see if the passive property is accessed
//     var supportsPassive = false;
//     try {
//         var opts = Object.defineProperty({}, 'passive', {
//             get: function() {
//                 supportsPassive = true;
//             }
//         });
//         window.addEventListener('testPassive', function() {}, opts);
//     } catch (e) {
//     }
//     return supportsPassive;
// }
$27ac1413ecc67076$exports = $27ac1413ecc67076$var$_default;


var $ec279652dd95c27b$exports = {};

$parcel$export($ec279652dd95c27b$exports, "$override", () => $ec279652dd95c27b$export$d35a04b83ea6803e, (v) => $ec279652dd95c27b$export$d35a04b83ea6803e = v);
$parcel$export($ec279652dd95c27b$exports, "clone", () => $ec279652dd95c27b$export$9cd59f9826255e47, (v) => $ec279652dd95c27b$export$9cd59f9826255e47 = v);
$parcel$export($ec279652dd95c27b$exports, "merge", () => $ec279652dd95c27b$export$4950aa0f605343fb, (v) => $ec279652dd95c27b$export$4950aa0f605343fb = v);
$parcel$export($ec279652dd95c27b$exports, "mergeAll", () => $ec279652dd95c27b$export$18aef43295bbe906, (v) => $ec279652dd95c27b$export$18aef43295bbe906 = v);
$parcel$export($ec279652dd95c27b$exports, "extend", () => $ec279652dd95c27b$export$8b58be045bf06082, (v) => $ec279652dd95c27b$export$8b58be045bf06082 = v);
$parcel$export($ec279652dd95c27b$exports, "defaults", () => $ec279652dd95c27b$export$ebe90cb607ad99e, (v) => $ec279652dd95c27b$export$ebe90cb607ad99e = v);
$parcel$export($ec279652dd95c27b$exports, "createCanvas", () => $ec279652dd95c27b$export$cd3d1f114b139967, (v) => $ec279652dd95c27b$export$cd3d1f114b139967 = v);
$parcel$export($ec279652dd95c27b$exports, "getContext", () => $ec279652dd95c27b$export$31553aaa555c1514, (v) => $ec279652dd95c27b$export$31553aaa555c1514 = v);
$parcel$export($ec279652dd95c27b$exports, "indexOf", () => $ec279652dd95c27b$export$305f7d4e9d4624f2, (v) => $ec279652dd95c27b$export$305f7d4e9d4624f2 = v);
$parcel$export($ec279652dd95c27b$exports, "inherits", () => $ec279652dd95c27b$export$69f1b2dcda23c5f8, (v) => $ec279652dd95c27b$export$69f1b2dcda23c5f8 = v);
$parcel$export($ec279652dd95c27b$exports, "mixin", () => $ec279652dd95c27b$export$e36fc9d62a853069, (v) => $ec279652dd95c27b$export$e36fc9d62a853069 = v);
$parcel$export($ec279652dd95c27b$exports, "isArrayLike", () => $ec279652dd95c27b$export$1e2f57719e155213, (v) => $ec279652dd95c27b$export$1e2f57719e155213 = v);
$parcel$export($ec279652dd95c27b$exports, "each", () => $ec279652dd95c27b$export$79b2f7037acddd43, (v) => $ec279652dd95c27b$export$79b2f7037acddd43 = v);
$parcel$export($ec279652dd95c27b$exports, "map", () => $ec279652dd95c27b$export$871de8747c9eaa88, (v) => $ec279652dd95c27b$export$871de8747c9eaa88 = v);
$parcel$export($ec279652dd95c27b$exports, "reduce", () => $ec279652dd95c27b$export$533b26079ad0b4b, (v) => $ec279652dd95c27b$export$533b26079ad0b4b = v);
$parcel$export($ec279652dd95c27b$exports, "filter", () => $ec279652dd95c27b$export$3dea766d36a8935f, (v) => $ec279652dd95c27b$export$3dea766d36a8935f = v);
$parcel$export($ec279652dd95c27b$exports, "find", () => $ec279652dd95c27b$export$71aa6c912b956294, (v) => $ec279652dd95c27b$export$71aa6c912b956294 = v);
$parcel$export($ec279652dd95c27b$exports, "bind", () => $ec279652dd95c27b$export$2385a24977818dd0, (v) => $ec279652dd95c27b$export$2385a24977818dd0 = v);
$parcel$export($ec279652dd95c27b$exports, "curry", () => $ec279652dd95c27b$export$c3095a23b368d1f2, (v) => $ec279652dd95c27b$export$c3095a23b368d1f2 = v);
$parcel$export($ec279652dd95c27b$exports, "isArray", () => $ec279652dd95c27b$export$43bee75e5e14138e, (v) => $ec279652dd95c27b$export$43bee75e5e14138e = v);
$parcel$export($ec279652dd95c27b$exports, "isFunction", () => $ec279652dd95c27b$export$f6e2535fb5126e54, (v) => $ec279652dd95c27b$export$f6e2535fb5126e54 = v);
$parcel$export($ec279652dd95c27b$exports, "isString", () => $ec279652dd95c27b$export$844ec244b1367d54, (v) => $ec279652dd95c27b$export$844ec244b1367d54 = v);
$parcel$export($ec279652dd95c27b$exports, "isObject", () => $ec279652dd95c27b$export$a6cdc56e425d0d0a, (v) => $ec279652dd95c27b$export$a6cdc56e425d0d0a = v);
$parcel$export($ec279652dd95c27b$exports, "isBuiltInObject", () => $ec279652dd95c27b$export$fa523b2c4941fd4f, (v) => $ec279652dd95c27b$export$fa523b2c4941fd4f = v);
$parcel$export($ec279652dd95c27b$exports, "isTypedArray", () => $ec279652dd95c27b$export$b119cc7e1840e59c, (v) => $ec279652dd95c27b$export$b119cc7e1840e59c = v);
$parcel$export($ec279652dd95c27b$exports, "isDom", () => $ec279652dd95c27b$export$9f57505b7bd8dae, (v) => $ec279652dd95c27b$export$9f57505b7bd8dae = v);
$parcel$export($ec279652dd95c27b$exports, "eqNaN", () => $ec279652dd95c27b$export$7d667b9a0c48c975, (v) => $ec279652dd95c27b$export$7d667b9a0c48c975 = v);
$parcel$export($ec279652dd95c27b$exports, "retrieve", () => $ec279652dd95c27b$export$8a4d17b6e8486e66, (v) => $ec279652dd95c27b$export$8a4d17b6e8486e66 = v);
$parcel$export($ec279652dd95c27b$exports, "retrieve2", () => $ec279652dd95c27b$export$995e01f2f5c9d030, (v) => $ec279652dd95c27b$export$995e01f2f5c9d030 = v);
$parcel$export($ec279652dd95c27b$exports, "retrieve3", () => $ec279652dd95c27b$export$2e94551289abb95b, (v) => $ec279652dd95c27b$export$2e94551289abb95b = v);
$parcel$export($ec279652dd95c27b$exports, "slice", () => $ec279652dd95c27b$export$58adb3bec8346d0f, (v) => $ec279652dd95c27b$export$58adb3bec8346d0f = v);
$parcel$export($ec279652dd95c27b$exports, "normalizeCssArray", () => $ec279652dd95c27b$export$f3a38102c49f4268, (v) => $ec279652dd95c27b$export$f3a38102c49f4268 = v);
$parcel$export($ec279652dd95c27b$exports, "assert", () => $ec279652dd95c27b$export$a7a9523472993e97, (v) => $ec279652dd95c27b$export$a7a9523472993e97 = v);
$parcel$export($ec279652dd95c27b$exports, "trim", () => $ec279652dd95c27b$export$87c2784dc9fc4ab, (v) => $ec279652dd95c27b$export$87c2784dc9fc4ab = v);
$parcel$export($ec279652dd95c27b$exports, "setAsPrimitive", () => $ec279652dd95c27b$export$112e66431016387b, (v) => $ec279652dd95c27b$export$112e66431016387b = v);
$parcel$export($ec279652dd95c27b$exports, "isPrimitive", () => $ec279652dd95c27b$export$c3825b437cbdea5c, (v) => $ec279652dd95c27b$export$c3825b437cbdea5c = v);
$parcel$export($ec279652dd95c27b$exports, "createHashMap", () => $ec279652dd95c27b$export$55f8aa7ef875b0a4, (v) => $ec279652dd95c27b$export$55f8aa7ef875b0a4 = v);
$parcel$export($ec279652dd95c27b$exports, "concatArray", () => $ec279652dd95c27b$export$4fd8af2c48c43416, (v) => $ec279652dd95c27b$export$4fd8af2c48c43416 = v);
$parcel$export($ec279652dd95c27b$exports, "noop", () => $ec279652dd95c27b$export$8793edee2d425525, (v) => $ec279652dd95c27b$export$8793edee2d425525 = v);
/**
 * @module zrender/core/util
 */ // 用于处理merge时无法遍历Date等对象的问题
var $ec279652dd95c27b$export$d35a04b83ea6803e;
var $ec279652dd95c27b$export$9cd59f9826255e47;
var $ec279652dd95c27b$export$4950aa0f605343fb;
var $ec279652dd95c27b$export$18aef43295bbe906;
var $ec279652dd95c27b$export$8b58be045bf06082;
var $ec279652dd95c27b$export$ebe90cb607ad99e;
var $ec279652dd95c27b$export$cd3d1f114b139967;
var $ec279652dd95c27b$export$31553aaa555c1514;
var $ec279652dd95c27b$export$305f7d4e9d4624f2;
var $ec279652dd95c27b$export$69f1b2dcda23c5f8;
var $ec279652dd95c27b$export$e36fc9d62a853069;
var $ec279652dd95c27b$export$1e2f57719e155213;
var $ec279652dd95c27b$export$79b2f7037acddd43;
var $ec279652dd95c27b$export$871de8747c9eaa88;
var $ec279652dd95c27b$export$533b26079ad0b4b;
var $ec279652dd95c27b$export$3dea766d36a8935f;
var $ec279652dd95c27b$export$71aa6c912b956294;
var $ec279652dd95c27b$export$2385a24977818dd0;
var $ec279652dd95c27b$export$c3095a23b368d1f2;
var $ec279652dd95c27b$export$43bee75e5e14138e;
var $ec279652dd95c27b$export$f6e2535fb5126e54;
var $ec279652dd95c27b$export$844ec244b1367d54;
var $ec279652dd95c27b$export$a6cdc56e425d0d0a;
var $ec279652dd95c27b$export$fa523b2c4941fd4f;
var $ec279652dd95c27b$export$b119cc7e1840e59c;
var $ec279652dd95c27b$export$9f57505b7bd8dae;
var $ec279652dd95c27b$export$7d667b9a0c48c975;
var $ec279652dd95c27b$export$8a4d17b6e8486e66;
var $ec279652dd95c27b$export$995e01f2f5c9d030;
var $ec279652dd95c27b$export$2e94551289abb95b;
var $ec279652dd95c27b$export$58adb3bec8346d0f;
var $ec279652dd95c27b$export$f3a38102c49f4268;
var $ec279652dd95c27b$export$a7a9523472993e97;
var $ec279652dd95c27b$export$87c2784dc9fc4ab;
var $ec279652dd95c27b$export$112e66431016387b;
var $ec279652dd95c27b$export$c3825b437cbdea5c;
var $ec279652dd95c27b$export$55f8aa7ef875b0a4;
var $ec279652dd95c27b$export$4fd8af2c48c43416;
var $ec279652dd95c27b$export$8793edee2d425525;
var $ec279652dd95c27b$var$BUILTIN_OBJECT = {
    "[object Function]": 1,
    "[object RegExp]": 1,
    "[object Date]": 1,
    "[object Error]": 1,
    "[object CanvasGradient]": 1,
    "[object CanvasPattern]": 1,
    // For node-canvas
    "[object Image]": 1,
    "[object Canvas]": 1
};
var $ec279652dd95c27b$var$TYPED_ARRAY = {
    "[object Int8Array]": 1,
    "[object Uint8Array]": 1,
    "[object Uint8ClampedArray]": 1,
    "[object Int16Array]": 1,
    "[object Uint16Array]": 1,
    "[object Int32Array]": 1,
    "[object Uint32Array]": 1,
    "[object Float32Array]": 1,
    "[object Float64Array]": 1
};
var $ec279652dd95c27b$var$objToString = Object.prototype.toString;
var $ec279652dd95c27b$var$arrayProto = Array.prototype;
var $ec279652dd95c27b$var$nativeForEach = $ec279652dd95c27b$var$arrayProto.forEach;
var $ec279652dd95c27b$var$nativeFilter = $ec279652dd95c27b$var$arrayProto.filter;
var $ec279652dd95c27b$var$nativeSlice = $ec279652dd95c27b$var$arrayProto.slice;
var $ec279652dd95c27b$var$nativeMap = $ec279652dd95c27b$var$arrayProto.map;
var $ec279652dd95c27b$var$nativeReduce = $ec279652dd95c27b$var$arrayProto.reduce; // Avoid assign to an exported variable, for transforming to cjs.
var $ec279652dd95c27b$var$methods = {};
function $ec279652dd95c27b$var$$override(name, fn) {
    // Clear ctx instance for different environment
    if (name === "createCanvas") $ec279652dd95c27b$var$_ctx = null;
    $ec279652dd95c27b$var$methods[name] = fn;
}
/**
 * Those data types can be cloned:
 *     Plain object, Array, TypedArray, number, string, null, undefined.
 * Those data types will be assgined using the orginal data:
 *     BUILTIN_OBJECT
 * Instance of user defined class will be cloned to a plain object, without
 * properties in prototype.
 * Other data types is not supported (not sure what will happen).
 *
 * Caution: do not support clone Date, for performance consideration.
 * (There might be a large number of date in `series.data`).
 * So date should not be modified in and out of echarts.
 *
 * @param {*} source
 * @return {*} new
 */ function $ec279652dd95c27b$var$clone(source) {
    if (source == null || typeof source !== "object") return source;
    var result = source;
    var typeStr = $ec279652dd95c27b$var$objToString.call(source);
    if (typeStr === "[object Array]") {
        if (!$ec279652dd95c27b$var$isPrimitive(source)) {
            result = [];
            for(var i = 0, len = source.length; i < len; i++)result[i] = $ec279652dd95c27b$var$clone(source[i]);
        }
    } else if ($ec279652dd95c27b$var$TYPED_ARRAY[typeStr]) {
        if (!$ec279652dd95c27b$var$isPrimitive(source)) {
            var Ctor = source.constructor;
            if (source.constructor.from) result = Ctor.from(source);
            else {
                result = new Ctor(source.length);
                for(var i = 0, len = source.length; i < len; i++)result[i] = $ec279652dd95c27b$var$clone(source[i]);
            }
        }
    } else if (!$ec279652dd95c27b$var$BUILTIN_OBJECT[typeStr] && !$ec279652dd95c27b$var$isPrimitive(source) && !$ec279652dd95c27b$var$isDom(source)) {
        result = {};
        for(var key in source)if (source.hasOwnProperty(key)) result[key] = $ec279652dd95c27b$var$clone(source[key]);
    }
    return result;
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} target
 * @param {*} source
 * @param {boolean} [overwrite=false]
 */ function $ec279652dd95c27b$var$merge(target, source, overwrite) {
    // We should escapse that source is string
    // and enter for ... in ...
    if (!$ec279652dd95c27b$var$isObject(source) || !$ec279652dd95c27b$var$isObject(target)) return overwrite ? $ec279652dd95c27b$var$clone(source) : target;
    for(var key in source)if (source.hasOwnProperty(key)) {
        var targetProp = target[key];
        var sourceProp = source[key];
        if ($ec279652dd95c27b$var$isObject(sourceProp) && $ec279652dd95c27b$var$isObject(targetProp) && !$ec279652dd95c27b$var$isArray(sourceProp) && !$ec279652dd95c27b$var$isArray(targetProp) && !$ec279652dd95c27b$var$isDom(sourceProp) && !$ec279652dd95c27b$var$isDom(targetProp) && !$ec279652dd95c27b$var$isBuiltInObject(sourceProp) && !$ec279652dd95c27b$var$isBuiltInObject(targetProp) && !$ec279652dd95c27b$var$isPrimitive(sourceProp) && !$ec279652dd95c27b$var$isPrimitive(targetProp)) // 如果需要递归覆盖，就递归调用merge
        $ec279652dd95c27b$var$merge(targetProp, sourceProp, overwrite);
        else if (overwrite || !(key in target)) // 否则只处理overwrite为true，或者在目标对象中没有此属性的情况
        // NOTE，在 target[key] 不存在的时候也是直接覆盖
        target[key] = $ec279652dd95c27b$var$clone(source[key], true);
    }
    return target;
}
/**
 * @param {Array} targetAndSources The first item is target, and the rests are source.
 * @param {boolean} [overwrite=false]
 * @return {*} target
 */ function $ec279652dd95c27b$var$mergeAll(targetAndSources, overwrite) {
    var result = targetAndSources[0];
    for(var i = 1, len = targetAndSources.length; i < len; i++)result = $ec279652dd95c27b$var$merge(result, targetAndSources[i], overwrite);
    return result;
}
/**
 * @param {*} target
 * @param {*} source
 * @memberOf module:zrender/core/util
 */ function $ec279652dd95c27b$var$extend(target, source) {
    for(var key in source)if (source.hasOwnProperty(key)) target[key] = source[key];
    return target;
}
/**
 * @param {*} target
 * @param {*} source
 * @param {boolean} [overlay=false]
 * @memberOf module:zrender/core/util
 */ function $ec279652dd95c27b$var$defaults(target, source, overlay) {
    for(var key in source)if (source.hasOwnProperty(key) && (overlay ? source[key] != null : target[key] == null)) target[key] = source[key];
    return target;
}
var $ec279652dd95c27b$var$createCanvas = function() {
    return $ec279652dd95c27b$var$methods.createCanvas();
};
$ec279652dd95c27b$var$methods.createCanvas = function() {
    return document.createElement("canvas");
}; // FIXME
var $ec279652dd95c27b$var$_ctx;
function $ec279652dd95c27b$var$getContext() {
    if (!$ec279652dd95c27b$var$_ctx) // Use util.createCanvas instead of createCanvas
    // because createCanvas may be overwritten in different environment
    $ec279652dd95c27b$var$_ctx = $ec279652dd95c27b$var$createCanvas().getContext("2d");
    return $ec279652dd95c27b$var$_ctx;
}
/**
 * 查询数组中元素的index
 * @memberOf module:zrender/core/util
 */ function $ec279652dd95c27b$var$indexOf(array, value) {
    if (array) {
        if (array.indexOf) return array.indexOf(value);
        for(var i = 0, len = array.length; i < len; i++){
            if (array[i] === value) return i;
        }
    }
    return -1;
}
/**
 * 构造类继承关系
 *
 * @memberOf module:zrender/core/util
 * @param {Function} clazz 源类
 * @param {Function} baseClazz 基类
 */ function $ec279652dd95c27b$var$inherits(clazz, baseClazz) {
    var clazzPrototype = clazz.prototype;
    function F() {}
    F.prototype = baseClazz.prototype;
    clazz.prototype = new F();
    for(var prop in clazzPrototype)if (clazzPrototype.hasOwnProperty(prop)) clazz.prototype[prop] = clazzPrototype[prop];
    clazz.prototype.constructor = clazz;
    clazz.superClass = baseClazz;
}
/**
 * @memberOf module:zrender/core/util
 * @param {Object|Function} target
 * @param {Object|Function} sorce
 * @param {boolean} overlay
 */ function $ec279652dd95c27b$var$mixin(target, source, overlay) {
    target = "prototype" in target ? target.prototype : target;
    source = "prototype" in source ? source.prototype : source;
    $ec279652dd95c27b$var$defaults(target, source, overlay);
}
/**
 * Consider typed array.
 * @param {Array|TypedArray} data
 */ function $ec279652dd95c27b$var$isArrayLike(data) {
    if (!data) return;
    if (typeof data === "string") return false;
    return typeof data.length === "number";
}
/**
 * 数组或对象遍历
 * @memberOf module:zrender/core/util
 * @param {Object|Array} obj
 * @param {Function} cb
 * @param {*} [context]
 */ function $ec279652dd95c27b$var$each(obj, cb, context) {
    if (!(obj && cb)) return;
    if (obj.forEach && obj.forEach === $ec279652dd95c27b$var$nativeForEach) obj.forEach(cb, context);
    else if (obj.length === +obj.length) for(var i = 0, len = obj.length; i < len; i++)cb.call(context, obj[i], i, obj);
    else {
        for(var key in obj)if (obj.hasOwnProperty(key)) cb.call(context, obj[key], key, obj);
    }
}
/**
 * 数组映射
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {*} [context]
 * @return {Array}
 */ function $ec279652dd95c27b$var$map(obj, cb, context) {
    if (!(obj && cb)) return;
    if (obj.map && obj.map === $ec279652dd95c27b$var$nativeMap) return obj.map(cb, context);
    else {
        var result = [];
        for(var i = 0, len = obj.length; i < len; i++)result.push(cb.call(context, obj[i], i, obj));
        return result;
    }
}
/**
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {Object} [memo]
 * @param {*} [context]
 * @return {Array}
 */ function $ec279652dd95c27b$var$reduce(obj, cb, memo, context) {
    if (!(obj && cb)) return;
    if (obj.reduce && obj.reduce === $ec279652dd95c27b$var$nativeReduce) return obj.reduce(cb, memo, context);
    else {
        for(var i = 0, len = obj.length; i < len; i++)memo = cb.call(context, memo, obj[i], i, obj);
        return memo;
    }
}
/**
 * 数组过滤
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {*} [context]
 * @return {Array}
 */ function $ec279652dd95c27b$var$filter(obj, cb, context) {
    if (!(obj && cb)) return;
    if (obj.filter && obj.filter === $ec279652dd95c27b$var$nativeFilter) return obj.filter(cb, context);
    else {
        var result = [];
        for(var i = 0, len = obj.length; i < len; i++)if (cb.call(context, obj[i], i, obj)) result.push(obj[i]);
        return result;
    }
}
/**
 * 数组项查找
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {*} [context]
 * @return {*}
 */ function $ec279652dd95c27b$var$find(obj, cb, context) {
    if (!(obj && cb)) return;
    for(var i = 0, len = obj.length; i < len; i++){
        if (cb.call(context, obj[i], i, obj)) return obj[i];
    }
}
/**
 * @memberOf module:zrender/core/util
 * @param {Function} func
 * @param {*} context
 * @return {Function}
 */ function $ec279652dd95c27b$var$bind(func, context) {
    var args = $ec279652dd95c27b$var$nativeSlice.call(arguments, 2);
    return function() {
        return func.apply(context, args.concat($ec279652dd95c27b$var$nativeSlice.call(arguments)));
    };
}
/**
 * @memberOf module:zrender/core/util
 * @param {Function} func
 * @return {Function}
 */ function $ec279652dd95c27b$var$curry(func) {
    var args = $ec279652dd95c27b$var$nativeSlice.call(arguments, 1);
    return function() {
        return func.apply(this, args.concat($ec279652dd95c27b$var$nativeSlice.call(arguments)));
    };
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */ function $ec279652dd95c27b$var$isArray(value) {
    return $ec279652dd95c27b$var$objToString.call(value) === "[object Array]";
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */ function $ec279652dd95c27b$var$isFunction(value) {
    return typeof value === "function";
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */ function $ec279652dd95c27b$var$isString(value) {
    return $ec279652dd95c27b$var$objToString.call(value) === "[object String]";
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */ function $ec279652dd95c27b$var$isObject(value) {
    // Avoid a V8 JIT bug in Chrome 19-20.
    // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
    var type = typeof value;
    return type === "function" || !!value && type === "object";
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */ function $ec279652dd95c27b$var$isBuiltInObject(value) {
    return !!$ec279652dd95c27b$var$BUILTIN_OBJECT[$ec279652dd95c27b$var$objToString.call(value)];
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */ function $ec279652dd95c27b$var$isTypedArray(value) {
    return !!$ec279652dd95c27b$var$TYPED_ARRAY[$ec279652dd95c27b$var$objToString.call(value)];
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */ function $ec279652dd95c27b$var$isDom(value) {
    return typeof value === "object" && typeof value.nodeType === "number" && typeof value.ownerDocument === "object";
}
/**
 * Whether is exactly NaN. Notice isNaN('a') returns true.
 * @param {*} value
 * @return {boolean}
 */ function $ec279652dd95c27b$var$eqNaN(value) {
    /* eslint-disable-next-line no-self-compare */ return value !== value;
}
/**
 * If value1 is not null, then return value1, otherwise judget rest of values.
 * Low performance.
 * @memberOf module:zrender/core/util
 * @return {*} Final value
 */ function $ec279652dd95c27b$var$retrieve(values) {
    for(var i = 0, len = arguments.length; i < len; i++){
        if (arguments[i] != null) return arguments[i];
    }
}
function $ec279652dd95c27b$var$retrieve2(value0, value1) {
    return value0 != null ? value0 : value1;
}
function $ec279652dd95c27b$var$retrieve3(value0, value1, value2) {
    return value0 != null ? value0 : value1 != null ? value1 : value2;
}
/**
 * @memberOf module:zrender/core/util
 * @param {Array} arr
 * @param {number} startIndex
 * @param {number} endIndex
 * @return {Array}
 */ function $ec279652dd95c27b$var$slice() {
    return Function.call.apply($ec279652dd95c27b$var$nativeSlice, arguments);
}
/**
 * Normalize css liked array configuration
 * e.g.
 *  3 => [3, 3, 3, 3]
 *  [4, 2] => [4, 2, 4, 2]
 *  [4, 3, 2] => [4, 3, 2, 3]
 * @param {number|Array.<number>} val
 * @return {Array.<number>}
 */ function $ec279652dd95c27b$var$normalizeCssArray(val) {
    if (typeof val === "number") return [
        val,
        val,
        val,
        val
    ];
    var len = val.length;
    if (len === 2) // vertical | horizontal
    return [
        val[0],
        val[1],
        val[0],
        val[1]
    ];
    else if (len === 3) // top | horizontal | bottom
    return [
        val[0],
        val[1],
        val[2],
        val[1]
    ];
    return val;
}
/**
 * @memberOf module:zrender/core/util
 * @param {boolean} condition
 * @param {string} message
 */ function $ec279652dd95c27b$var$assert(condition, message) {
    if (!condition) throw new Error(message);
}
/**
 * @memberOf module:zrender/core/util
 * @param {string} str string to be trimed
 * @return {string} trimed string
 */ function $ec279652dd95c27b$var$trim(str) {
    if (str == null) return null;
    else if (typeof str.trim === "function") return str.trim();
    else return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
}
var $ec279652dd95c27b$var$primitiveKey = "__ec_primitive__";
/**
 * Set an object as primitive to be ignored traversing children in clone or merge
 */ function $ec279652dd95c27b$var$setAsPrimitive(obj) {
    obj[$ec279652dd95c27b$var$primitiveKey] = true;
}
function $ec279652dd95c27b$var$isPrimitive(obj) {
    return obj[$ec279652dd95c27b$var$primitiveKey];
}
/**
 * @constructor
 * @param {Object} obj Only apply `ownProperty`.
 */ function $ec279652dd95c27b$var$HashMap(obj) {
    var isArr = $ec279652dd95c27b$var$isArray(obj); // Key should not be set on this, otherwise
    // methods get/set/... may be overrided.
    this.data = {};
    var thisMap = this;
    obj instanceof $ec279652dd95c27b$var$HashMap ? obj.each(visit) : obj && $ec279652dd95c27b$var$each(obj, visit);
    function visit(value, key) {
        isArr ? thisMap.set(value, key) : thisMap.set(key, value);
    }
}
$ec279652dd95c27b$var$HashMap.prototype = {
    constructor: $ec279652dd95c27b$var$HashMap,
    // Do not provide `has` method to avoid defining what is `has`.
    // (We usually treat `null` and `undefined` as the same, different
    // from ES6 Map).
    get: function(key) {
        return this.data.hasOwnProperty(key) ? this.data[key] : null;
    },
    set: function(key, value) {
        // Comparing with invocation chaining, `return value` is more commonly
        // used in this case: `var someVal = map.set('a', genVal());`
        return this.data[key] = value;
    },
    // Although util.each can be performed on this hashMap directly, user
    // should not use the exposed keys, who are prefixed.
    each: function(cb, context) {
        context !== void 0 && (cb = $ec279652dd95c27b$var$bind(cb, context));
        /* eslint-disable guard-for-in */ for(var key in this.data)this.data.hasOwnProperty(key) && cb(this.data[key], key);
    /* eslint-enable guard-for-in */ },
    // Do not use this method if performance sensitive.
    removeKey: function(key) {
        delete this.data[key];
    }
};
function $ec279652dd95c27b$var$createHashMap(obj) {
    return new $ec279652dd95c27b$var$HashMap(obj);
}
function $ec279652dd95c27b$var$concatArray(a, b) {
    var newArray = new a.constructor(a.length + b.length);
    for(var i = 0; i < a.length; i++)newArray[i] = a[i];
    var offset = a.length;
    for(i = 0; i < b.length; i++)newArray[i + offset] = b[i];
    return newArray;
}
function $ec279652dd95c27b$var$noop() {}
$ec279652dd95c27b$export$d35a04b83ea6803e = $ec279652dd95c27b$var$$override;
$ec279652dd95c27b$export$9cd59f9826255e47 = $ec279652dd95c27b$var$clone;
$ec279652dd95c27b$export$4950aa0f605343fb = $ec279652dd95c27b$var$merge;
$ec279652dd95c27b$export$18aef43295bbe906 = $ec279652dd95c27b$var$mergeAll;
$ec279652dd95c27b$export$8b58be045bf06082 = $ec279652dd95c27b$var$extend;
$ec279652dd95c27b$export$ebe90cb607ad99e = $ec279652dd95c27b$var$defaults;
$ec279652dd95c27b$export$cd3d1f114b139967 = $ec279652dd95c27b$var$createCanvas;
$ec279652dd95c27b$export$31553aaa555c1514 = $ec279652dd95c27b$var$getContext;
$ec279652dd95c27b$export$305f7d4e9d4624f2 = $ec279652dd95c27b$var$indexOf;
$ec279652dd95c27b$export$69f1b2dcda23c5f8 = $ec279652dd95c27b$var$inherits;
$ec279652dd95c27b$export$e36fc9d62a853069 = $ec279652dd95c27b$var$mixin;
$ec279652dd95c27b$export$1e2f57719e155213 = $ec279652dd95c27b$var$isArrayLike;
$ec279652dd95c27b$export$79b2f7037acddd43 = $ec279652dd95c27b$var$each;
$ec279652dd95c27b$export$871de8747c9eaa88 = $ec279652dd95c27b$var$map;
$ec279652dd95c27b$export$533b26079ad0b4b = $ec279652dd95c27b$var$reduce;
$ec279652dd95c27b$export$3dea766d36a8935f = $ec279652dd95c27b$var$filter;
$ec279652dd95c27b$export$71aa6c912b956294 = $ec279652dd95c27b$var$find;
$ec279652dd95c27b$export$2385a24977818dd0 = $ec279652dd95c27b$var$bind;
$ec279652dd95c27b$export$c3095a23b368d1f2 = $ec279652dd95c27b$var$curry;
$ec279652dd95c27b$export$43bee75e5e14138e = $ec279652dd95c27b$var$isArray;
$ec279652dd95c27b$export$f6e2535fb5126e54 = $ec279652dd95c27b$var$isFunction;
$ec279652dd95c27b$export$844ec244b1367d54 = $ec279652dd95c27b$var$isString;
$ec279652dd95c27b$export$a6cdc56e425d0d0a = $ec279652dd95c27b$var$isObject;
$ec279652dd95c27b$export$fa523b2c4941fd4f = $ec279652dd95c27b$var$isBuiltInObject;
$ec279652dd95c27b$export$b119cc7e1840e59c = $ec279652dd95c27b$var$isTypedArray;
$ec279652dd95c27b$export$9f57505b7bd8dae = $ec279652dd95c27b$var$isDom;
$ec279652dd95c27b$export$7d667b9a0c48c975 = $ec279652dd95c27b$var$eqNaN;
$ec279652dd95c27b$export$8a4d17b6e8486e66 = $ec279652dd95c27b$var$retrieve;
$ec279652dd95c27b$export$995e01f2f5c9d030 = $ec279652dd95c27b$var$retrieve2;
$ec279652dd95c27b$export$2e94551289abb95b = $ec279652dd95c27b$var$retrieve3;
$ec279652dd95c27b$export$58adb3bec8346d0f = $ec279652dd95c27b$var$slice;
$ec279652dd95c27b$export$f3a38102c49f4268 = $ec279652dd95c27b$var$normalizeCssArray;
$ec279652dd95c27b$export$a7a9523472993e97 = $ec279652dd95c27b$var$assert;
$ec279652dd95c27b$export$87c2784dc9fc4ab = $ec279652dd95c27b$var$trim;
$ec279652dd95c27b$export$112e66431016387b = $ec279652dd95c27b$var$setAsPrimitive;
$ec279652dd95c27b$export$c3825b437cbdea5c = $ec279652dd95c27b$var$isPrimitive;
$ec279652dd95c27b$export$55f8aa7ef875b0a4 = $ec279652dd95c27b$var$createHashMap;
$ec279652dd95c27b$export$4fd8af2c48c43416 = $ec279652dd95c27b$var$concatArray;
$ec279652dd95c27b$export$8793edee2d425525 = $ec279652dd95c27b$var$noop;


var $9f5fe6326a736418$exports = {};

var $9eb63d101f3bcd79$exports = {};

$parcel$export($9eb63d101f3bcd79$exports, "create", () => $9eb63d101f3bcd79$export$185802fd694ee1f5, (v) => $9eb63d101f3bcd79$export$185802fd694ee1f5 = v);
$parcel$export($9eb63d101f3bcd79$exports, "copy", () => $9eb63d101f3bcd79$export$784d13d8ee351f07, (v) => $9eb63d101f3bcd79$export$784d13d8ee351f07 = v);
$parcel$export($9eb63d101f3bcd79$exports, "clone", () => $9eb63d101f3bcd79$export$9cd59f9826255e47, (v) => $9eb63d101f3bcd79$export$9cd59f9826255e47 = v);
$parcel$export($9eb63d101f3bcd79$exports, "set", () => $9eb63d101f3bcd79$export$adaa4cf7ef1b65be, (v) => $9eb63d101f3bcd79$export$adaa4cf7ef1b65be = v);
$parcel$export($9eb63d101f3bcd79$exports, "add", () => $9eb63d101f3bcd79$export$e16d8520af44a096, (v) => $9eb63d101f3bcd79$export$e16d8520af44a096 = v);
$parcel$export($9eb63d101f3bcd79$exports, "scaleAndAdd", () => $9eb63d101f3bcd79$export$19cedf1da84ba854, (v) => $9eb63d101f3bcd79$export$19cedf1da84ba854 = v);
$parcel$export($9eb63d101f3bcd79$exports, "sub", () => $9eb63d101f3bcd79$export$f93b5905241a7cca, (v) => $9eb63d101f3bcd79$export$f93b5905241a7cca = v);
$parcel$export($9eb63d101f3bcd79$exports, "len", () => $9eb63d101f3bcd79$export$fc1400facf92c78, (v) => $9eb63d101f3bcd79$export$fc1400facf92c78 = v);
$parcel$export($9eb63d101f3bcd79$exports, "length", () => $9eb63d101f3bcd79$export$f24224f1c91d8156, (v) => $9eb63d101f3bcd79$export$f24224f1c91d8156 = v);
$parcel$export($9eb63d101f3bcd79$exports, "lenSquare", () => $9eb63d101f3bcd79$export$48e33bc611e4c25a, (v) => $9eb63d101f3bcd79$export$48e33bc611e4c25a = v);
$parcel$export($9eb63d101f3bcd79$exports, "lengthSquare", () => $9eb63d101f3bcd79$export$2f106540dd9a5136, (v) => $9eb63d101f3bcd79$export$2f106540dd9a5136 = v);
$parcel$export($9eb63d101f3bcd79$exports, "mul", () => $9eb63d101f3bcd79$export$6e3a27864ab166fe, (v) => $9eb63d101f3bcd79$export$6e3a27864ab166fe = v);
$parcel$export($9eb63d101f3bcd79$exports, "div", () => $9eb63d101f3bcd79$export$159d9494db57879b, (v) => $9eb63d101f3bcd79$export$159d9494db57879b = v);
$parcel$export($9eb63d101f3bcd79$exports, "dot", () => $9eb63d101f3bcd79$export$94132a0e348806d4, (v) => $9eb63d101f3bcd79$export$94132a0e348806d4 = v);
$parcel$export($9eb63d101f3bcd79$exports, "scale", () => $9eb63d101f3bcd79$export$dcdf75081b88279d, (v) => $9eb63d101f3bcd79$export$dcdf75081b88279d = v);
$parcel$export($9eb63d101f3bcd79$exports, "normalize", () => $9eb63d101f3bcd79$export$a3295358bff77e, (v) => $9eb63d101f3bcd79$export$a3295358bff77e = v);
$parcel$export($9eb63d101f3bcd79$exports, "distance", () => $9eb63d101f3bcd79$export$9f17032d917177de, (v) => $9eb63d101f3bcd79$export$9f17032d917177de = v);
$parcel$export($9eb63d101f3bcd79$exports, "dist", () => $9eb63d101f3bcd79$export$6c4a311cc157c764, (v) => $9eb63d101f3bcd79$export$6c4a311cc157c764 = v);
$parcel$export($9eb63d101f3bcd79$exports, "distanceSquare", () => $9eb63d101f3bcd79$export$137c0a69d1ff4a79, (v) => $9eb63d101f3bcd79$export$137c0a69d1ff4a79 = v);
$parcel$export($9eb63d101f3bcd79$exports, "distSquare", () => $9eb63d101f3bcd79$export$c68db45a034c13b0, (v) => $9eb63d101f3bcd79$export$c68db45a034c13b0 = v);
$parcel$export($9eb63d101f3bcd79$exports, "negate", () => $9eb63d101f3bcd79$export$aef51622e549b8b0, (v) => $9eb63d101f3bcd79$export$aef51622e549b8b0 = v);
$parcel$export($9eb63d101f3bcd79$exports, "lerp", () => $9eb63d101f3bcd79$export$3a89f8d6f6bf6c9f, (v) => $9eb63d101f3bcd79$export$3a89f8d6f6bf6c9f = v);
$parcel$export($9eb63d101f3bcd79$exports, "applyTransform", () => $9eb63d101f3bcd79$export$9f9dcb98c894b623, (v) => $9eb63d101f3bcd79$export$9f9dcb98c894b623 = v);
$parcel$export($9eb63d101f3bcd79$exports, "min", () => $9eb63d101f3bcd79$export$96ec731ed4dcb222, (v) => $9eb63d101f3bcd79$export$96ec731ed4dcb222 = v);
$parcel$export($9eb63d101f3bcd79$exports, "max", () => $9eb63d101f3bcd79$export$8960430cfd85939f, (v) => $9eb63d101f3bcd79$export$8960430cfd85939f = v);
/* global Float32Array */ var $9eb63d101f3bcd79$export$185802fd694ee1f5;
var $9eb63d101f3bcd79$export$784d13d8ee351f07;
var $9eb63d101f3bcd79$export$9cd59f9826255e47;
var $9eb63d101f3bcd79$export$adaa4cf7ef1b65be;
var $9eb63d101f3bcd79$export$e16d8520af44a096;
var $9eb63d101f3bcd79$export$19cedf1da84ba854;
var $9eb63d101f3bcd79$export$f93b5905241a7cca;
var $9eb63d101f3bcd79$export$fc1400facf92c78;
var $9eb63d101f3bcd79$export$f24224f1c91d8156;
var $9eb63d101f3bcd79$export$48e33bc611e4c25a;
var $9eb63d101f3bcd79$export$2f106540dd9a5136;
var $9eb63d101f3bcd79$export$6e3a27864ab166fe;
var $9eb63d101f3bcd79$export$159d9494db57879b;
var $9eb63d101f3bcd79$export$94132a0e348806d4;
var $9eb63d101f3bcd79$export$dcdf75081b88279d;
var $9eb63d101f3bcd79$export$a3295358bff77e;
var $9eb63d101f3bcd79$export$9f17032d917177de;
var $9eb63d101f3bcd79$export$6c4a311cc157c764;
var $9eb63d101f3bcd79$export$137c0a69d1ff4a79;
var $9eb63d101f3bcd79$export$c68db45a034c13b0;
var $9eb63d101f3bcd79$export$aef51622e549b8b0;
var $9eb63d101f3bcd79$export$3a89f8d6f6bf6c9f;
var $9eb63d101f3bcd79$export$9f9dcb98c894b623;
var $9eb63d101f3bcd79$export$96ec731ed4dcb222;
var $9eb63d101f3bcd79$export$8960430cfd85939f;
var $9eb63d101f3bcd79$var$ArrayCtor = typeof Float32Array === "undefined" ? Array : Float32Array;
/**
 * 创建一个向量
 * @param {number} [x=0]
 * @param {number} [y=0]
 * @return {Vector2}
 */ function $9eb63d101f3bcd79$var$create(x, y) {
    var out = new $9eb63d101f3bcd79$var$ArrayCtor(2);
    if (x == null) x = 0;
    if (y == null) y = 0;
    out[0] = x;
    out[1] = y;
    return out;
}
/**
 * 复制向量数据
 * @param {Vector2} out
 * @param {Vector2} v
 * @return {Vector2}
 */ function $9eb63d101f3bcd79$var$copy(out, v) {
    out[0] = v[0];
    out[1] = v[1];
    return out;
}
/**
 * 克隆一个向量
 * @param {Vector2} v
 * @return {Vector2}
 */ function $9eb63d101f3bcd79$var$clone(v) {
    var out = new $9eb63d101f3bcd79$var$ArrayCtor(2);
    out[0] = v[0];
    out[1] = v[1];
    return out;
}
/**
 * 设置向量的两个项
 * @param {Vector2} out
 * @param {number} a
 * @param {number} b
 * @return {Vector2} 结果
 */ function $9eb63d101f3bcd79$var$set(out, a, b) {
    out[0] = a;
    out[1] = b;
    return out;
}
/**
 * 向量相加
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */ function $9eb63d101f3bcd79$var$add(out, v1, v2) {
    out[0] = v1[0] + v2[0];
    out[1] = v1[1] + v2[1];
    return out;
}
/**
 * 向量缩放后相加
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @param {number} a
 */ function $9eb63d101f3bcd79$var$scaleAndAdd(out, v1, v2, a) {
    out[0] = v1[0] + v2[0] * a;
    out[1] = v1[1] + v2[1] * a;
    return out;
}
/**
 * 向量相减
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */ function $9eb63d101f3bcd79$var$sub(out, v1, v2) {
    out[0] = v1[0] - v2[0];
    out[1] = v1[1] - v2[1];
    return out;
}
/**
 * 向量长度
 * @param {Vector2} v
 * @return {number}
 */ function $9eb63d101f3bcd79$var$len(v) {
    return Math.sqrt($9eb63d101f3bcd79$var$lenSquare(v));
}
var $9eb63d101f3bcd79$var$length = $9eb63d101f3bcd79$var$len; // jshint ignore:line
/**
 * 向量长度平方
 * @param {Vector2} v
 * @return {number}
 */ function $9eb63d101f3bcd79$var$lenSquare(v) {
    return v[0] * v[0] + v[1] * v[1];
}
var $9eb63d101f3bcd79$var$lengthSquare = $9eb63d101f3bcd79$var$lenSquare;
/**
 * 向量乘法
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */ function $9eb63d101f3bcd79$var$mul(out, v1, v2) {
    out[0] = v1[0] * v2[0];
    out[1] = v1[1] * v2[1];
    return out;
}
/**
 * 向量除法
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */ function $9eb63d101f3bcd79$var$div(out, v1, v2) {
    out[0] = v1[0] / v2[0];
    out[1] = v1[1] / v2[1];
    return out;
}
/**
 * 向量点乘
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @return {number}
 */ function $9eb63d101f3bcd79$var$dot(v1, v2) {
    return v1[0] * v2[0] + v1[1] * v2[1];
}
/**
 * 向量缩放
 * @param {Vector2} out
 * @param {Vector2} v
 * @param {number} s
 */ function $9eb63d101f3bcd79$var$scale(out, v, s) {
    out[0] = v[0] * s;
    out[1] = v[1] * s;
    return out;
}
/**
 * 向量归一化
 * @param {Vector2} out
 * @param {Vector2} v
 */ function $9eb63d101f3bcd79$var$normalize(out, v) {
    var d = $9eb63d101f3bcd79$var$len(v);
    if (d === 0) {
        out[0] = 0;
        out[1] = 0;
    } else {
        out[0] = v[0] / d;
        out[1] = v[1] / d;
    }
    return out;
}
/**
 * 计算向量间距离
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @return {number}
 */ function $9eb63d101f3bcd79$var$distance(v1, v2) {
    return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}
var $9eb63d101f3bcd79$var$dist = $9eb63d101f3bcd79$var$distance;
/**
 * 向量距离平方
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @return {number}
 */ function $9eb63d101f3bcd79$var$distanceSquare(v1, v2) {
    return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}
var $9eb63d101f3bcd79$var$distSquare = $9eb63d101f3bcd79$var$distanceSquare;
/**
 * 求负向量
 * @param {Vector2} out
 * @param {Vector2} v
 */ function $9eb63d101f3bcd79$var$negate(out, v) {
    out[0] = -v[0];
    out[1] = -v[1];
    return out;
}
/**
 * 插值两个点
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @param {number} t
 */ function $9eb63d101f3bcd79$var$lerp(out, v1, v2, t) {
    out[0] = v1[0] + t * (v2[0] - v1[0]);
    out[1] = v1[1] + t * (v2[1] - v1[1]);
    return out;
}
/**
 * 矩阵左乘向量
 * @param {Vector2} out
 * @param {Vector2} v
 * @param {Vector2} m
 */ function $9eb63d101f3bcd79$var$applyTransform(out, v, m) {
    var x = v[0];
    var y = v[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
/**
 * 求两个向量最小值
 * @param  {Vector2} out
 * @param  {Vector2} v1
 * @param  {Vector2} v2
 */ function $9eb63d101f3bcd79$var$min(out, v1, v2) {
    out[0] = Math.min(v1[0], v2[0]);
    out[1] = Math.min(v1[1], v2[1]);
    return out;
}
/**
 * 求两个向量最大值
 * @param  {Vector2} out
 * @param  {Vector2} v1
 * @param  {Vector2} v2
 */ function $9eb63d101f3bcd79$var$max(out, v1, v2) {
    out[0] = Math.max(v1[0], v2[0]);
    out[1] = Math.max(v1[1], v2[1]);
    return out;
}
$9eb63d101f3bcd79$export$185802fd694ee1f5 = $9eb63d101f3bcd79$var$create;
$9eb63d101f3bcd79$export$784d13d8ee351f07 = $9eb63d101f3bcd79$var$copy;
$9eb63d101f3bcd79$export$9cd59f9826255e47 = $9eb63d101f3bcd79$var$clone;
$9eb63d101f3bcd79$export$adaa4cf7ef1b65be = $9eb63d101f3bcd79$var$set;
$9eb63d101f3bcd79$export$e16d8520af44a096 = $9eb63d101f3bcd79$var$add;
$9eb63d101f3bcd79$export$19cedf1da84ba854 = $9eb63d101f3bcd79$var$scaleAndAdd;
$9eb63d101f3bcd79$export$f93b5905241a7cca = $9eb63d101f3bcd79$var$sub;
$9eb63d101f3bcd79$export$fc1400facf92c78 = $9eb63d101f3bcd79$var$len;
$9eb63d101f3bcd79$export$f24224f1c91d8156 = $9eb63d101f3bcd79$var$length;
$9eb63d101f3bcd79$export$48e33bc611e4c25a = $9eb63d101f3bcd79$var$lenSquare;
$9eb63d101f3bcd79$export$2f106540dd9a5136 = $9eb63d101f3bcd79$var$lengthSquare;
$9eb63d101f3bcd79$export$6e3a27864ab166fe = $9eb63d101f3bcd79$var$mul;
$9eb63d101f3bcd79$export$159d9494db57879b = $9eb63d101f3bcd79$var$div;
$9eb63d101f3bcd79$export$94132a0e348806d4 = $9eb63d101f3bcd79$var$dot;
$9eb63d101f3bcd79$export$dcdf75081b88279d = $9eb63d101f3bcd79$var$scale;
$9eb63d101f3bcd79$export$a3295358bff77e = $9eb63d101f3bcd79$var$normalize;
$9eb63d101f3bcd79$export$9f17032d917177de = $9eb63d101f3bcd79$var$distance;
$9eb63d101f3bcd79$export$6c4a311cc157c764 = $9eb63d101f3bcd79$var$dist;
$9eb63d101f3bcd79$export$137c0a69d1ff4a79 = $9eb63d101f3bcd79$var$distanceSquare;
$9eb63d101f3bcd79$export$c68db45a034c13b0 = $9eb63d101f3bcd79$var$distSquare;
$9eb63d101f3bcd79$export$aef51622e549b8b0 = $9eb63d101f3bcd79$var$negate;
$9eb63d101f3bcd79$export$3a89f8d6f6bf6c9f = $9eb63d101f3bcd79$var$lerp;
$9eb63d101f3bcd79$export$9f9dcb98c894b623 = $9eb63d101f3bcd79$var$applyTransform;
$9eb63d101f3bcd79$export$96ec731ed4dcb222 = $9eb63d101f3bcd79$var$min;
$9eb63d101f3bcd79$export$8960430cfd85939f = $9eb63d101f3bcd79$var$max;


var $f18af77d68e34617$exports = {};
// TODO Draggable for group
// FIXME Draggable on element which has parent rotation or scale
function $f18af77d68e34617$var$Draggable() {
    this.on("mousedown", this._dragStart, this);
    this.on("mousemove", this._drag, this);
    this.on("mouseup", this._dragEnd, this); // `mosuemove` and `mouseup` can be continue to fire when dragging.
// See [Drag outside] in `Handler.js`. So we do not need to trigger
// `_dragEnd` when globalout. That would brings better user experience.
// this.on('globalout', this._dragEnd, this);
// this._dropTarget = null;
// this._draggingTarget = null;
// this._x = 0;
// this._y = 0;
}
$f18af77d68e34617$var$Draggable.prototype = {
    constructor: $f18af77d68e34617$var$Draggable,
    _dragStart: function(e) {
        var draggingTarget = e.target; // Find if there is draggable in the ancestor
        while(draggingTarget && !draggingTarget.draggable)draggingTarget = draggingTarget.parent;
        if (draggingTarget) {
            this._draggingTarget = draggingTarget;
            draggingTarget.dragging = true;
            this._x = e.offsetX;
            this._y = e.offsetY;
            this.dispatchToElement($f18af77d68e34617$var$param(draggingTarget, e), "dragstart", e.event);
        }
    },
    _drag: function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) {
            var x = e.offsetX;
            var y = e.offsetY;
            var dx = x - this._x;
            var dy = y - this._y;
            this._x = x;
            this._y = y;
            draggingTarget.drift(dx, dy, e);
            this.dispatchToElement($f18af77d68e34617$var$param(draggingTarget, e), "drag", e.event);
            var dropTarget = this.findHover(x, y, draggingTarget).target;
            var lastDropTarget = this._dropTarget;
            this._dropTarget = dropTarget;
            if (draggingTarget !== dropTarget) {
                if (lastDropTarget && dropTarget !== lastDropTarget) this.dispatchToElement($f18af77d68e34617$var$param(lastDropTarget, e), "dragleave", e.event);
                if (dropTarget && dropTarget !== lastDropTarget) this.dispatchToElement($f18af77d68e34617$var$param(dropTarget, e), "dragenter", e.event);
            }
        }
    },
    _dragEnd: function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) draggingTarget.dragging = false;
        this.dispatchToElement($f18af77d68e34617$var$param(draggingTarget, e), "dragend", e.event);
        if (this._dropTarget) this.dispatchToElement($f18af77d68e34617$var$param(this._dropTarget, e), "drop", e.event);
        this._draggingTarget = null;
        this._dropTarget = null;
    }
};
function $f18af77d68e34617$var$param(target, e) {
    return {
        target: target,
        topTarget: e && e.topTarget
    };
}
var $f18af77d68e34617$var$_default = $f18af77d68e34617$var$Draggable;
$f18af77d68e34617$exports = $f18af77d68e34617$var$_default;


var $b7a44647f5b5bfa5$exports = {};
/**
 * Event Mixin
 * @module zrender/mixin/Eventful
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         pissang (https://www.github.com/pissang)
 */ var $b7a44647f5b5bfa5$var$arrySlice = Array.prototype.slice;
/**
 * Event dispatcher.
 *
 * @alias module:zrender/mixin/Eventful
 * @constructor
 * @param {Object} [eventProcessor] The object eventProcessor is the scope when
 *        `eventProcessor.xxx` called.
 * @param {Function} [eventProcessor.normalizeQuery]
 *        param: {string|Object} Raw query.
 *        return: {string|Object} Normalized query.
 * @param {Function} [eventProcessor.filter] Event will be dispatched only
 *        if it returns `true`.
 *        param: {string} eventType
 *        param: {string|Object} query
 *        return: {boolean}
 * @param {Function} [eventProcessor.afterTrigger] Called after all handlers called.
 *        param: {string} eventType
 */ var $b7a44647f5b5bfa5$var$Eventful = function(eventProcessor) {
    this._$handlers = {};
    this._$eventProcessor = eventProcessor;
};
$b7a44647f5b5bfa5$var$Eventful.prototype = {
    constructor: $b7a44647f5b5bfa5$var$Eventful,
    /**
   * The handler can only be triggered once, then removed.
   *
   * @param {string} event The event name.
   * @param {string|Object} [query] Condition used on event filter.
   * @param {Function} handler The event handler.
   * @param {Object} context
   */ one: function(event, query, handler, context) {
        return $b7a44647f5b5bfa5$var$on(this, event, query, handler, context, true);
    },
    /**
   * Bind a handler.
   *
   * @param {string} event The event name.
   * @param {string|Object} [query] Condition used on event filter.
   * @param {Function} handler The event handler.
   * @param {Object} [context]
   */ on: function(event, query, handler, context) {
        return $b7a44647f5b5bfa5$var$on(this, event, query, handler, context, false);
    },
    /**
   * Whether any handler has bound.
   *
   * @param  {string}  event
   * @return {boolean}
   */ isSilent: function(event) {
        var _h = this._$handlers;
        return !_h[event] || !_h[event].length;
    },
    /**
   * Unbind a event.
   *
   * @param {string} [event] The event name.
   *        If no `event` input, "off" all listeners.
   * @param {Function} [handler] The event handler.
   *        If no `handler` input, "off" all listeners of the `event`.
   */ off: function(event, handler) {
        var _h = this._$handlers;
        if (!event) {
            this._$handlers = {};
            return this;
        }
        if (handler) {
            if (_h[event]) {
                var newList = [];
                for(var i = 0, l = _h[event].length; i < l; i++)if (_h[event][i].h !== handler) newList.push(_h[event][i]);
                _h[event] = newList;
            }
            if (_h[event] && _h[event].length === 0) delete _h[event];
        } else delete _h[event];
        return this;
    },
    /**
   * Dispatch a event.
   *
   * @param {string} type The event name.
   */ trigger: function(type) {
        var _h = this._$handlers[type];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var args = arguments;
            var argLen = args.length;
            if (argLen > 3) args = $b7a44647f5b5bfa5$var$arrySlice.call(args, 1);
            var len = _h.length;
            for(var i = 0; i < len;){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) {
                    i++;
                    continue;
                } // Optimize advise from backbone
                switch(argLen){
                    case 1:
                        hItem.h.call(hItem.ctx);
                        break;
                    case 2:
                        hItem.h.call(hItem.ctx, args[1]);
                        break;
                    case 3:
                        hItem.h.call(hItem.ctx, args[1], args[2]);
                        break;
                    default:
                        // have more than 2 given arguments
                        hItem.h.apply(hItem.ctx, args);
                        break;
                }
                if (hItem.one) {
                    _h.splice(i, 1);
                    len--;
                } else i++;
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
        return this;
    },
    /**
   * Dispatch a event with context, which is specified at the last parameter.
   *
   * @param {string} type The event name.
   */ triggerWithContext: function(type) {
        var _h = this._$handlers[type];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var args = arguments;
            var argLen = args.length;
            if (argLen > 4) args = $b7a44647f5b5bfa5$var$arrySlice.call(args, 1, args.length - 1);
            var ctx = args[args.length - 1];
            var len = _h.length;
            for(var i = 0; i < len;){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) {
                    i++;
                    continue;
                } // Optimize advise from backbone
                switch(argLen){
                    case 1:
                        hItem.h.call(ctx);
                        break;
                    case 2:
                        hItem.h.call(ctx, args[1]);
                        break;
                    case 3:
                        hItem.h.call(ctx, args[1], args[2]);
                        break;
                    default:
                        // have more than 2 given arguments
                        hItem.h.apply(ctx, args);
                        break;
                }
                if (hItem.one) {
                    _h.splice(i, 1);
                    len--;
                } else i++;
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
        return this;
    }
};
function $b7a44647f5b5bfa5$var$normalizeQuery(host, query) {
    var eventProcessor = host._$eventProcessor;
    if (query != null && eventProcessor && eventProcessor.normalizeQuery) query = eventProcessor.normalizeQuery(query);
    return query;
}
function $b7a44647f5b5bfa5$var$on(eventful, event, query, handler, context, isOnce) {
    var _h = eventful._$handlers;
    if (typeof query === "function") {
        context = handler;
        handler = query;
        query = null;
    }
    if (!handler || !event) return eventful;
    query = $b7a44647f5b5bfa5$var$normalizeQuery(eventful, query);
    if (!_h[event]) _h[event] = [];
    for(var i = 0; i < _h[event].length; i++){
        if (_h[event][i].h === handler) return eventful;
    }
    var wrap = {
        h: handler,
        one: isOnce,
        query: query,
        ctx: context || eventful,
        // FIXME
        // Do not publish this feature util it is proved that it makes sense.
        callAtLast: handler.zrEventfulCallAtLast
    };
    var lastIndex = _h[event].length - 1;
    var lastWrap = _h[event][lastIndex];
    lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
    return eventful;
} // ----------------------
// The events in zrender
// ----------------------
/**
 * @event module:zrender/mixin/Eventful#onclick
 * @type {Function}
 * @default null
 */ /**
 * @event module:zrender/mixin/Eventful#onmouseover
 * @type {Function}
 * @default null
 */ /**
 * @event module:zrender/mixin/Eventful#onmouseout
 * @type {Function}
 * @default null
 */ /**
 * @event module:zrender/mixin/Eventful#onmousemove
 * @type {Function}
 * @default null
 */ /**
 * @event module:zrender/mixin/Eventful#onmousewheel
 * @type {Function}
 * @default null
 */ /**
 * @event module:zrender/mixin/Eventful#onmousedown
 * @type {Function}
 * @default null
 */ /**
 * @event module:zrender/mixin/Eventful#onmouseup
 * @type {Function}
 * @default null
 */ /**
 * @event module:zrender/mixin/Eventful#ondrag
 * @type {Function}
 * @default null
 */ /**
 * @event module:zrender/mixin/Eventful#ondragstart
 * @type {Function}
 * @default null
 */ /**
 * @event module:zrender/mixin/Eventful#ondragend
 * @type {Function}
 * @default null
 */ /**
 * @event module:zrender/mixin/Eventful#ondragenter
 * @type {Function}
 * @default null
 */ /**
 * @event module:zrender/mixin/Eventful#ondragleave
 * @type {Function}
 * @default null
 */ /**
 * @event module:zrender/mixin/Eventful#ondragover
 * @type {Function}
 * @default null
 */ /**
 * @event module:zrender/mixin/Eventful#ondrop
 * @type {Function}
 * @default null
 */ var $b7a44647f5b5bfa5$var$_default = $b7a44647f5b5bfa5$var$Eventful;
$b7a44647f5b5bfa5$exports = $b7a44647f5b5bfa5$var$_default;


var $adca58e5ac25631a$export$ab054a1ef92eeb01;
var $adca58e5ac25631a$export$7d5fecde839eee88;
var $adca58e5ac25631a$export$4abe0e945399ac1d;
var $adca58e5ac25631a$export$40fadb093aebad71;
var $adca58e5ac25631a$export$3f65cefe8380dbea;
var $adca58e5ac25631a$export$8ff9f68337b520c0;
var $adca58e5ac25631a$export$fa6813432f753b0d;
var $adca58e5ac25631a$export$b7ae4cded3e71bd2;
var $adca58e5ac25631a$export$a564e1c0090572c3;

$adca58e5ac25631a$export$ab054a1ef92eeb01 = $b7a44647f5b5bfa5$exports;

var $41f9987155a2665f$export$8c5c02e118307e20;
var $41f9987155a2665f$export$1219648acc517df4;
var $41f9987155a2665f$export$1b92e4fe606eff6d;

/**
 * The algoritm is learnt from
 * https://franklinta.com/2014/09/08/computing-css-matrix3d-transforms/
 * And we made some optimization for matrix inversion.
 * Other similar approaches:
 * "cv::getPerspectiveTransform", "Direct Linear Transformation".
 */ var $42d48aa2b69d4971$export$fbdb2748a8171a7e;
var $42d48aa2b69d4971$var$LN2 = Math.log(2);
function $42d48aa2b69d4971$var$determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
    var cacheKey = rowMask + "-" + colMask;
    var fullRank = rows.length;
    if (detCache.hasOwnProperty(cacheKey)) return detCache[cacheKey];
    if (rank === 1) {
        // In this case the colMask must be like: `11101111`. We can find the place of `0`.
        var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / $42d48aa2b69d4971$var$LN2);
        return rows[rowStart][colStart];
    }
    var subRowMask = rowMask | 1 << rowStart;
    var subRowStart = rowStart + 1;
    while(rowMask & 1 << subRowStart)subRowStart++;
    var sum = 0;
    for(var j = 0, colLocalIdx = 0; j < fullRank; j++){
        var colTag = 1 << j;
        if (!(colTag & colMask)) {
            sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] // det(subMatrix(0, j))
             * $42d48aa2b69d4971$var$determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
            colLocalIdx++;
        }
    }
    detCache[cacheKey] = sum;
    return sum;
}
/**
 * Usage:
 * ```js
 * var transformer = buildTransformer(
 *     [10, 44, 100, 44, 100, 300, 10, 300],
 *     [50, 54, 130, 14, 140, 330, 14, 220]
 * );
 * var out = [];
 * transformer && transformer([11, 33], out);
 * ```
 *
 * Notice: `buildTransformer` may take more than 10ms in some Android device.
 *
 * @param {Array.<number>} src source four points, [x0, y0, x1, y1, x2, y2, x3, y3]
 * @param {Array.<number>} dest destination four points, [x0, y0, x1, y1, x2, y2, x3, y3]
 * @return {Function} transformer If fail, return null/undefined.
 */ function $42d48aa2b69d4971$var$buildTransformer(src, dest) {
    var mA = [
        [
            src[0],
            src[1],
            1,
            0,
            0,
            0,
            -dest[0] * src[0],
            -dest[0] * src[1]
        ],
        [
            0,
            0,
            0,
            src[0],
            src[1],
            1,
            -dest[1] * src[0],
            -dest[1] * src[1]
        ],
        [
            src[2],
            src[3],
            1,
            0,
            0,
            0,
            -dest[2] * src[2],
            -dest[2] * src[3]
        ],
        [
            0,
            0,
            0,
            src[2],
            src[3],
            1,
            -dest[3] * src[2],
            -dest[3] * src[3]
        ],
        [
            src[4],
            src[5],
            1,
            0,
            0,
            0,
            -dest[4] * src[4],
            -dest[4] * src[5]
        ],
        [
            0,
            0,
            0,
            src[4],
            src[5],
            1,
            -dest[5] * src[4],
            -dest[5] * src[5]
        ],
        [
            src[6],
            src[7],
            1,
            0,
            0,
            0,
            -dest[6] * src[6],
            -dest[6] * src[7]
        ],
        [
            0,
            0,
            0,
            src[6],
            src[7],
            1,
            -dest[7] * src[6],
            -dest[7] * src[7]
        ]
    ];
    var detCache = {};
    var det = $42d48aa2b69d4971$var$determinant(mA, 8, 0, 0, 0, detCache);
    if (det === 0) // can not make transformer when and only when
    // any three of the markers are collinear.
    return;
     // `invert(mA) * dest`, that is, `adj(mA) / det * dest`.
    var vh = [];
    for(var i = 0; i < 8; i++)for(var j = 0; j < 8; j++){
        vh[j] == null && (vh[j] = 0);
        vh[j] += ((i + j) % 2 ? -1 : 1) * // det(subMatrix(i, j))
        $42d48aa2b69d4971$var$determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
    }
    return function(out, srcPointX, srcPointY) {
        var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
        out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
        out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
    };
}
$42d48aa2b69d4971$export$fbdb2748a8171a7e = $42d48aa2b69d4971$var$buildTransformer;


var $41f9987155a2665f$var$buildTransformer = $42d48aa2b69d4971$export$fbdb2748a8171a7e;
var $41f9987155a2665f$var$EVENT_SAVED_PROP = "___zrEVENTSAVED";
var $41f9987155a2665f$var$_calcOut = [];
/**
 * Transform "local coord" from `elFrom` to `elTarget`.
 * "local coord": the coord based on the input `el`. The origin point is at
 *     the position of "left: 0; top: 0;" in the `el`.
 *
 * Support when CSS transform is used.
 *
 * Having the `out` (that is, `[outX, outY]`), we can create an DOM element
 * and set the CSS style as "left: outX; top: outY;" and append it to `elTarge`
 * to locate the element.
 *
 * For example, this code below positions a child of `document.body` on the event
 * point, no matter whether `body` has `margin`/`paddin`/`transfrom`/... :
 * ```js
 * transformLocalCoord(out, container, document.body, event.offsetX, event.offsetY);
 * if (!eqNaN(out[0])) {
 *     // Then locate the tip element on the event point.
 *     var tipEl = document.createElement('div');
 *     tipEl.style.cssText = 'position: absolute; left:' + out[0] + ';top:' + out[1] + ';';
 *     document.body.appendChild(tipEl);
 * }
 * ```
 *
 * Notice: In some env this method is not supported. If called, `out` will be `[NaN, NaN]`.
 *
 * @param {Array.<number>} out [inX: number, inY: number] The output..
 *        If can not transform, `out` will not be modified but return `false`.
 * @param {HTMLElement} elFrom The `[inX, inY]` is based on elFrom.
 * @param {HTMLElement} elTarget The `out` is based on elTarget.
 * @param {number} inX
 * @param {number} inY
 * @return {boolean} Whether transform successfully.
 */ function $41f9987155a2665f$var$transformLocalCoord(out, elFrom, elTarget, inX, inY) {
    return $41f9987155a2665f$var$transformCoordWithViewport($41f9987155a2665f$var$_calcOut, elFrom, inX, inY, true) && $41f9987155a2665f$var$transformCoordWithViewport(out, elTarget, $41f9987155a2665f$var$_calcOut[0], $41f9987155a2665f$var$_calcOut[1]);
}
/**
 * Transform between a "viewport coord" and a "local coord".
 * "viewport coord": the coord based on the left-top corner of the viewport
 *     of the browser.
 * "local coord": the coord based on the input `el`. The origin point is at
 *     the position of "left: 0; top: 0;" in the `el`.
 *
 * Support the case when CSS transform is used on el.
 *
 * @param {Array.<number>} out [inX: number, inY: number] The output. If `inverse: false`,
 *        it represents "local coord", otherwise "vireport coord".
 *        If can not transform, `out` will not be modified but return `false`.
 * @param {HTMLElement} el The "local coord" is based on the `el`, see comment above.
 * @param {number} inX If `inverse: false`,
 *        it represents "vireport coord", otherwise "local coord".
 * @param {number} inY If `inverse: false`,
 *        it represents "vireport coord", otherwise "local coord".
 * @param {boolean} [inverse=false]
 *        `true`: from "viewport coord" to "local coord".
 *        `false`: from "local coord" to "viewport coord".
 * @return {boolean} Whether transform successfully.
 */ function $41f9987155a2665f$var$transformCoordWithViewport(out, el, inX, inY, inverse) {
    if (el.getBoundingClientRect && $27ac1413ecc67076$exports.domSupported && !$41f9987155a2665f$var$isCanvasEl(el)) {
        var saved = el[$41f9987155a2665f$var$EVENT_SAVED_PROP] || (el[$41f9987155a2665f$var$EVENT_SAVED_PROP] = {});
        var markers = $41f9987155a2665f$var$prepareCoordMarkers(el, saved);
        var transformer = $41f9987155a2665f$var$preparePointerTransformer(markers, saved, inverse);
        if (transformer) {
            transformer(out, inX, inY);
            return true;
        }
    }
    return false;
}
function $41f9987155a2665f$var$prepareCoordMarkers(el, saved) {
    var markers = saved.markers;
    if (markers) return markers;
    markers = saved.markers = [];
    var propLR = [
        "left",
        "right"
    ];
    var propTB = [
        "top",
        "bottom"
    ];
    for(var i = 0; i < 4; i++){
        var marker = document.createElement("div");
        var stl = marker.style;
        var idxLR = i % 2;
        var idxTB = (i >> 1) % 2;
        stl.cssText = [
            "position: absolute",
            "visibility: hidden",
            "padding: 0",
            "margin: 0",
            "border-width: 0",
            "user-select: none",
            "width:0",
            "height:0",
            // 'height: 5px',
            propLR[idxLR] + ":0",
            propTB[idxTB] + ":0",
            propLR[1 - idxLR] + ":auto",
            propTB[1 - idxTB] + ":auto",
            ""
        ].join("!important;");
        el.appendChild(marker);
        markers.push(marker);
    }
    return markers;
}
function $41f9987155a2665f$var$preparePointerTransformer(markers, saved, inverse) {
    var transformerName = inverse ? "invTrans" : "trans";
    var transformer = saved[transformerName];
    var oldSrcCoords = saved.srcCoords;
    var oldCoordTheSame = true;
    var srcCoords = [];
    var destCoords = [];
    for(var i = 0; i < 4; i++){
        var rect = markers[i].getBoundingClientRect();
        var ii = 2 * i;
        var x = rect.left;
        var y = rect.top;
        srcCoords.push(x, y);
        oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
        destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
    } // Cache to avoid time consuming of `buildTransformer`.
    return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? $41f9987155a2665f$var$buildTransformer(destCoords, srcCoords) : $41f9987155a2665f$var$buildTransformer(srcCoords, destCoords));
}
function $41f9987155a2665f$var$isCanvasEl(el) {
    return el.nodeName.toUpperCase() === "CANVAS";
}
$41f9987155a2665f$export$8c5c02e118307e20 = $41f9987155a2665f$var$transformLocalCoord;
$41f9987155a2665f$export$1219648acc517df4 = $41f9987155a2665f$var$transformCoordWithViewport;
$41f9987155a2665f$export$1b92e4fe606eff6d = $41f9987155a2665f$var$isCanvasEl;


var $adca58e5ac25631a$var$isCanvasEl = $41f9987155a2665f$export$1b92e4fe606eff6d;
var $adca58e5ac25631a$var$transformCoordWithViewport = $41f9987155a2665f$export$1219648acc517df4;
/**
 * Utilities for mouse or touch events.
 */ var $adca58e5ac25631a$var$isDomLevel2 = typeof window !== "undefined" && !!window.addEventListener;
var $adca58e5ac25631a$var$MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
var $adca58e5ac25631a$var$_calcOut = [];
/**
 * Get the `zrX` and `zrY`, which are relative to the top-left of
 * the input `el`.
 * CSS transform (2D & 3D) is supported.
 *
 * The strategy to fetch the coords:
 * + If `calculate` is not set as `true`, users of this method should
 * ensure that `el` is the same or the same size & location as `e.target`.
 * Otherwise the result coords are probably not expected. Because we
 * firstly try to get coords from e.offsetX/e.offsetY.
 * + If `calculate` is set as `true`, the input `el` can be any element
 * and we force to calculate the coords based on `el`.
 * + The input `el` should be positionable (not position:static).
 *
 * The force `calculate` can be used in case like:
 * When mousemove event triggered on ec tooltip, `e.target` is not `el`(zr painter.dom).
 *
 * @param {HTMLElement} el DOM element.
 * @param {Event} e Mouse event or touch event.
 * @param {Object} out Get `out.zrX` and `out.zrY` as the result.
 * @param {boolean} [calculate=false] Whether to force calculate
 *        the coordinates but not use ones provided by browser.
 */ function $adca58e5ac25631a$var$clientToLocal(el, e, out, calculate) {
    out = out || {}; // According to the W3C Working Draft, offsetX and offsetY should be relative
    // to the padding edge of the target element. The only browser using this convention
    // is IE. Webkit uses the border edge, Opera uses the content edge, and FireFox does
    // not support the properties.
    // (see http://www.jacklmoore.com/notes/mouse-position/)
    // In zr painter.dom, padding edge equals to border edge.
    if (calculate || !$27ac1413ecc67076$exports.canvasSupported) $adca58e5ac25631a$var$calculateZrXY(el, e, out);
    else if ($27ac1413ecc67076$exports.browser.firefox && e.layerX != null && e.layerX !== e.offsetX) {
        out.zrX = e.layerX;
        out.zrY = e.layerY;
    } else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
    } else $adca58e5ac25631a$var$calculateZrXY(el, e, out);
    return out;
}
function $adca58e5ac25631a$var$calculateZrXY(el, e, out) {
    // BlackBerry 5, iOS 3 (original iPhone) don't have getBoundingRect.
    if ($27ac1413ecc67076$exports.domSupported && el.getBoundingClientRect) {
        var ex = e.clientX;
        var ey = e.clientY;
        if ($adca58e5ac25631a$var$isCanvasEl(el)) {
            // Original approach, which do not support CSS transform.
            // marker can not be locationed in a canvas container
            // (getBoundingClientRect is always 0). We do not support
            // that input a pre-created canvas to zr while using css
            // transform in iOS.
            var box = el.getBoundingClientRect();
            out.zrX = ex - box.left;
            out.zrY = ey - box.top;
            return;
        } else if ($adca58e5ac25631a$var$transformCoordWithViewport($adca58e5ac25631a$var$_calcOut, el, ex, ey)) {
            out.zrX = $adca58e5ac25631a$var$_calcOut[0];
            out.zrY = $adca58e5ac25631a$var$_calcOut[1];
            return;
        }
    }
    out.zrX = out.zrY = 0;
}
/**
 * Find native event compat for legency IE.
 * Should be called at the begining of a native event listener.
 *
 * @param {Event} [e] Mouse event or touch event or pointer event.
 *        For lagency IE, we use `window.event` is used.
 * @return {Event} The native event.
 */ function $adca58e5ac25631a$var$getNativeEvent(e) {
    return e || window.event;
}
/**
 * Normalize the coordinates of the input event.
 *
 * Get the `e.zrX` and `e.zrY`, which are relative to the top-left of
 * the input `el`.
 * Get `e.zrDelta` if using mouse wheel.
 * Get `e.which`, see the comment inside this function.
 *
 * Do not calculate repeatly if `zrX` and `zrY` already exist.
 *
 * Notice: see comments in `clientToLocal`. check the relationship
 * between the result coords and the parameters `el` and `calculate`.
 *
 * @param {HTMLElement} el DOM element.
 * @param {Event} [e] See `getNativeEvent`.
 * @param {boolean} [calculate=false] Whether to force calculate
 *        the coordinates but not use ones provided by browser.
 * @return {UIEvent} The normalized native UIEvent.
 */ function $adca58e5ac25631a$var$normalizeEvent(el, e, calculate) {
    e = $adca58e5ac25631a$var$getNativeEvent(e);
    if (e.zrX != null) return e;
    var eventType = e.type;
    var isTouch = eventType && eventType.indexOf("touch") >= 0;
    if (!isTouch) {
        $adca58e5ac25631a$var$clientToLocal(el, e, e, calculate);
        e.zrDelta = e.wheelDelta ? e.wheelDelta / 120 : -(e.detail || 0) / 3;
    } else {
        var touch = eventType !== "touchend" ? e.targetTouches[0] : e.changedTouches[0];
        touch && $adca58e5ac25631a$var$clientToLocal(el, touch, e, calculate);
    } // Add which for click: 1 === left; 2 === middle; 3 === right; otherwise: 0;
    // See jQuery: https://github.com/jquery/jquery/blob/master/src/event.js
    // If e.which has been defined, it may be readonly,
    // see: https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/which
    var button = e.button;
    if (e.which == null && button !== undefined && $adca58e5ac25631a$var$MOUSE_EVENT_REG.test(e.type)) e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
     // [Caution]: `e.which` from browser is not always reliable. For example,
    // when press left button and `mousemove (pointermove)` in Edge, the `e.which`
    // is 65536 and the `e.button` is -1. But the `mouseup (pointerup)` and
    // `mousedown (pointerdown)` is the same as Chrome does.
    return e;
}
/**
 * @param {HTMLElement} el
 * @param {string} name
 * @param {Function} handler
 * @param {Object|boolean} opt If boolean, means `opt.capture`
 * @param {boolean} [opt.capture=false]
 * @param {boolean} [opt.passive=false]
 */ function $adca58e5ac25631a$var$addEventListener(el, name, handler, opt) {
    if ($adca58e5ac25631a$var$isDomLevel2) // Reproduct the console warning:
    // [Violation] Added non-passive event listener to a scroll-blocking <some> event.
    // Consider marking event handler as 'passive' to make the page more responsive.
    // Just set console log level: verbose in chrome dev tool.
    // then the warning log will be printed when addEventListener called.
    // See https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
    // We have not yet found a neat way to using passive. Because in zrender the dom event
    // listener delegate all of the upper events of element. Some of those events need
    // to prevent default. For example, the feature `preventDefaultMouseMove` of echarts.
    // Before passive can be adopted, these issues should be considered:
    // (1) Whether and how a zrender user specifies an event listener passive. And by default,
    // passive or not.
    // (2) How to tread that some zrender event listener is passive, and some is not. If
    // we use other way but not preventDefault of mousewheel and touchmove, browser
    // compatibility should be handled.
    // var opts = (env.passiveSupported && name === 'mousewheel')
    //     ? {passive: true}
    //     // By default, the third param of el.addEventListener is `capture: false`.
    //     : void 0;
    // el.addEventListener(name, handler /* , opts */);
    el.addEventListener(name, handler, opt);
    else // For simplicity, do not implement `setCapture` for IE9-.
    el.attachEvent("on" + name, handler);
}
/**
 * Parameter are the same as `addEventListener`.
 *
 * Notice that if a listener is registered twice, one with capture and one without,
 * remove each one separately. Removal of a capturing listener does not affect a
 * non-capturing version of the same listener, and vice versa.
 */ function $adca58e5ac25631a$var$removeEventListener(el, name, handler, opt) {
    if ($adca58e5ac25631a$var$isDomLevel2) el.removeEventListener(name, handler, opt);
    else el.detachEvent("on" + name, handler);
}
/**
 * preventDefault and stopPropagation.
 * Notice: do not use this method in zrender. It can only be
 * used by upper applications if necessary.
 *
 * @param {Event} e A mouse or touch event.
 */ var $adca58e5ac25631a$var$stop = $adca58e5ac25631a$var$isDomLevel2 ? function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
} : function(e) {
    e.returnValue = false;
    e.cancelBubble = true;
};
/**
 * This method only works for mouseup and mousedown. The functionality is restricted
 * for fault tolerance, See the `e.which` compatibility above.
 *
 * @param {MouseEvent} e
 * @return {boolean}
 */ function $adca58e5ac25631a$var$isMiddleOrRightButtonOnMouseUpDown(e) {
    return e.which === 2 || e.which === 3;
}
/**
 * To be removed.
 * @deprecated
 */ function $adca58e5ac25631a$var$notLeftMouse(e) {
    // If e.which is undefined, considered as left mouse event.
    return e.which > 1;
} // For backward compatibility
$adca58e5ac25631a$export$7d5fecde839eee88 = $adca58e5ac25631a$var$clientToLocal;
$adca58e5ac25631a$export$4abe0e945399ac1d = $adca58e5ac25631a$var$getNativeEvent;
$adca58e5ac25631a$export$40fadb093aebad71 = $adca58e5ac25631a$var$normalizeEvent;
$adca58e5ac25631a$export$3f65cefe8380dbea = $adca58e5ac25631a$var$addEventListener;
$adca58e5ac25631a$export$8ff9f68337b520c0 = $adca58e5ac25631a$var$removeEventListener;
$adca58e5ac25631a$export$fa6813432f753b0d = $adca58e5ac25631a$var$stop;
$adca58e5ac25631a$export$b7ae4cded3e71bd2 = $adca58e5ac25631a$var$isMiddleOrRightButtonOnMouseUpDown;
$adca58e5ac25631a$export$a564e1c0090572c3 = $adca58e5ac25631a$var$notLeftMouse;


var $6476e2e090d660b0$exports = {};

/**
 * Only implements needed gestures for mobile.
 */ var $6476e2e090d660b0$var$GestureMgr = function() {
    /**
   * @private
   * @type {Array.<Object>}
   */ this._track = [];
};
$6476e2e090d660b0$var$GestureMgr.prototype = {
    constructor: $6476e2e090d660b0$var$GestureMgr,
    recognize: function(event, target, root) {
        this._doTrack(event, target, root);
        return this._recognize(event);
    },
    clear: function() {
        this._track.length = 0;
        return this;
    },
    _doTrack: function(event, target, root) {
        var touches = event.touches;
        if (!touches) return;
        var trackItem = {
            points: [],
            touches: [],
            target: target,
            event: event
        };
        for(var i = 0, len = touches.length; i < len; i++){
            var touch = touches[i];
            var pos = $adca58e5ac25631a$export$7d5fecde839eee88(root, touch, {});
            trackItem.points.push([
                pos.zrX,
                pos.zrY
            ]);
            trackItem.touches.push(touch);
        }
        this._track.push(trackItem);
    },
    _recognize: function(event) {
        for(var eventName in $6476e2e090d660b0$var$recognizers)if ($6476e2e090d660b0$var$recognizers.hasOwnProperty(eventName)) {
            var gestureInfo = $6476e2e090d660b0$var$recognizers[eventName](this._track, event);
            if (gestureInfo) return gestureInfo;
        }
    }
};
function $6476e2e090d660b0$var$dist(pointPair) {
    var dx = pointPair[1][0] - pointPair[0][0];
    var dy = pointPair[1][1] - pointPair[0][1];
    return Math.sqrt(dx * dx + dy * dy);
}
function $6476e2e090d660b0$var$center(pointPair) {
    return [
        (pointPair[0][0] + pointPair[1][0]) / 2,
        (pointPair[0][1] + pointPair[1][1]) / 2
    ];
}
var $6476e2e090d660b0$var$recognizers = {
    pinch: function(track, event) {
        var trackLen = track.length;
        if (!trackLen) return;
        var pinchEnd = (track[trackLen - 1] || {}).points;
        var pinchPre = (track[trackLen - 2] || {}).points || pinchEnd;
        if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
            var pinchScale = $6476e2e090d660b0$var$dist(pinchEnd) / $6476e2e090d660b0$var$dist(pinchPre);
            !isFinite(pinchScale) && (pinchScale = 1);
            event.pinchScale = pinchScale;
            var pinchCenter = $6476e2e090d660b0$var$center(pinchEnd);
            event.pinchX = pinchCenter[0];
            event.pinchY = pinchCenter[1];
            return {
                type: "pinch",
                target: track[0].target,
                event: event
            };
        }
    } // Only pinch currently.
};
var $6476e2e090d660b0$var$_default = $6476e2e090d660b0$var$GestureMgr;
$6476e2e090d660b0$exports = $6476e2e090d660b0$var$_default;


/**
 * [The interface between `Handler` and `HandlerProxy`]:
 *
 * The default `HandlerProxy` only support the common standard web environment
 * (e.g., standalone browser, headless browser, embed browser in mobild APP, ...).
 * But `HandlerProxy` can be replaced to support more non-standard environment
 * (e.g., mini app), or to support more feature that the default `HandlerProxy`
 * not provided (like echarts-gl did).
 * So the interface between `Handler` and `HandlerProxy` should be stable. Do not
 * make break changes util inevitable. The interface include the public methods
 * of `Handler` and the events listed in `handlerNames` below, by which `HandlerProxy`
 * drives `Handler`.
 */ /**
 * [Drag outside]:
 *
 * That is, triggering `mousemove` and `mouseup` event when the pointer is out of the
 * zrender area when dragging. That is important for the improvement of the user experience
 * when dragging something near the boundary without being terminated unexpectedly.
 *
 * We originally consider to introduce new events like `pagemovemove` and `pagemouseup`
 * to resolve this issue. But some drawbacks of it is described in
 * https://github.com/ecomfe/zrender/pull/536#issuecomment-560286899
 *
 * Instead, we referenced the specifications:
 * https://www.w3.org/TR/touch-events/#the-touchmove-event
 * https://www.w3.org/TR/2014/WD-DOM-Level-3-Events-20140925/#event-type-mousemove
 * where the the mousemove/touchmove can be continue to fire if the user began a drag
 * operation and the pointer has left the boundary. (for the mouse event, browsers
 * only do it on `document` and when the pointer has left the boundary of the browser.)
 *
 * So the default `HandlerProxy` supports this feature similarly: if it is in the dragging
 * state (see `pointerCapture` in `HandlerProxy`), the `mousemove` and `mouseup` continue
 * to fire until release the pointer. That is implemented by listen to those event on
 * `document`.
 * If we implement some other `HandlerProxy` only for touch device, that would be easier.
 * The touch event support this feature by default.
 *
 * Note:
 * There might be some cases that the mouse event can not be
 * received on `document`. For example,
 * (A) `useCapture` is not supported and some user defined event listeners on the ancestor
 * of zr dom throw Error .
 * (B) `useCapture` is not supported Some user defined event listeners on the ancestor of
 * zr dom call `stopPropagation`.
 * In these cases, the `mousemove` event might be keep triggered event
 * if the mouse is released. We try to reduce the side-effect in those cases.
 * That is, do nothing (especially, `findHover`) in those cases. See `isOutsideBoundary`.
 *
 * Note:
 * If `HandlerProxy` listens to `document` with `useCapture`, `HandlerProxy` needs to
 * make sure `stopPropagation` and `preventDefault` doing nothing if and only if the event
 * target is not zrender dom. Becuase it is dangerous to enable users to call them in
 * `document` capture phase to prevent the propagation to any listener of the webpage.
 * But they are needed to work when the pointer inside the zrender dom.
 */ var $9f5fe6326a736418$var$SILENT = "silent";
function $9f5fe6326a736418$var$makeEventPacket(eveType, targetInfo, event) {
    return {
        type: eveType,
        event: event,
        // target can only be an element that is not silent.
        target: targetInfo.target,
        // topTarget can be a silent element.
        topTarget: targetInfo.topTarget,
        cancelBubble: false,
        offsetX: event.zrX,
        offsetY: event.zrY,
        gestureEvent: event.gestureEvent,
        pinchX: event.pinchX,
        pinchY: event.pinchY,
        pinchScale: event.pinchScale,
        wheelDelta: event.zrDelta,
        zrByTouch: event.zrByTouch,
        which: event.which,
        stop: $9f5fe6326a736418$var$stopEvent
    };
}
function $9f5fe6326a736418$var$stopEvent() {
    $adca58e5ac25631a$export$fa6813432f753b0d(this.event);
}
function $9f5fe6326a736418$var$EmptyProxy() {}
$9f5fe6326a736418$var$EmptyProxy.prototype.dispose = function() {};
var $9f5fe6326a736418$var$handlerNames = [
    "click",
    "dblclick",
    "mousewheel",
    "mouseout",
    "mouseup",
    "mousedown",
    "mousemove",
    "contextmenu"
];
/**
 * @alias module:zrender/Handler
 * @constructor
 * @extends module:zrender/mixin/Eventful
 * @param {module:zrender/Storage} storage Storage instance.
 * @param {module:zrender/Painter} painter Painter instance.
 * @param {module:zrender/dom/HandlerProxy} proxy HandlerProxy instance.
 * @param {HTMLElement} painterRoot painter.root (not painter.getViewportRoot()).
 */ var $9f5fe6326a736418$var$Handler = function(storage, painter, proxy, painterRoot) {
    $b7a44647f5b5bfa5$exports.call(this);
    this.storage = storage;
    this.painter = painter;
    this.painterRoot = painterRoot;
    proxy = proxy || new $9f5fe6326a736418$var$EmptyProxy();
    /**
   * Proxy of event. can be Dom, WebGLSurface, etc.
   */ this.proxy = null;
    /**
   * {target, topTarget, x, y}
   * @private
   * @type {Object}
   */ this._hovered = {};
    /**
   * @private
   * @type {Date}
   */ this._lastTouchMoment;
    /**
   * @private
   * @type {number}
   */ this._lastX;
    /**
   * @private
   * @type {number}
   */ this._lastY;
    /**
   * @private
   * @type {module:zrender/core/GestureMgr}
   */ this._gestureMgr;
    $f18af77d68e34617$exports.call(this);
    this.setHandlerProxy(proxy);
};
$9f5fe6326a736418$var$Handler.prototype = {
    constructor: $9f5fe6326a736418$var$Handler,
    setHandlerProxy: function(proxy) {
        if (this.proxy) this.proxy.dispose();
        if (proxy) {
            $ec279652dd95c27b$export$79b2f7037acddd43($9f5fe6326a736418$var$handlerNames, function(name) {
                proxy.on && proxy.on(name, this[name], this);
            }, this); // Attach handler
            proxy.handler = this;
        }
        this.proxy = proxy;
    },
    mousemove: function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $9f5fe6326a736418$var$isOutsideBoundary(this, x, y);
        var lastHovered = this._hovered;
        var lastHoveredTarget = lastHovered.target; // If lastHoveredTarget is removed from zr (detected by '__zr') by some API call
        // (like 'setOption' or 'dispatchAction') in event handlers, we should find
        // lastHovered again here. Otherwise 'mouseout' can not be triggered normally.
        // See #6198.
        if (lastHoveredTarget && !lastHoveredTarget.__zr) {
            lastHovered = this.findHover(lastHovered.x, lastHovered.y);
            lastHoveredTarget = lastHovered.target;
        }
        var hovered = this._hovered = isOutside ? {
            x: x,
            y: y
        } : this.findHover(x, y);
        var hoveredTarget = hovered.target;
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : "default"); // Mouse out on previous hovered element
        if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(lastHovered, "mouseout", event);
         // Mouse moving on one element
        this.dispatchToElement(hovered, "mousemove", event); // Mouse over on a new element
        if (hoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(hovered, "mouseover", event);
    },
    mouseout: function(event) {
        var eventControl = event.zrEventControl;
        var zrIsToLocalDOM = event.zrIsToLocalDOM;
        if (eventControl !== "only_globalout") this.dispatchToElement(this._hovered, "mouseout", event);
        if (eventControl !== "no_globalout") // FIXME: if the pointer moving from the extra doms to realy "outside",
        // the `globalout` should have been triggered. But currently not.
        !zrIsToLocalDOM && this.trigger("globalout", {
            type: "globalout",
            event: event
        });
    },
    /**
   * Resize
   */ resize: function(event) {
        this._hovered = {};
    },
    /**
   * Dispatch event
   * @param {string} eventName
   * @param {event=} eventArgs
   */ dispatch: function(eventName, eventArgs) {
        var handler = this[eventName];
        handler && handler.call(this, eventArgs);
    },
    /**
   * Dispose
   */ dispose: function() {
        this.proxy.dispose();
        this.storage = this.proxy = this.painter = null;
    },
    /**
   * 设置默认的cursor style
   * @param {string} [cursorStyle='default'] 例如 crosshair
   */ setCursorStyle: function(cursorStyle) {
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(cursorStyle);
    },
    /**
   * 事件分发代理
   *
   * @private
   * @param {Object} targetInfo {target, topTarget} 目标图形元素
   * @param {string} eventName 事件名称
   * @param {Object} event 事件对象
   */ dispatchToElement: function(targetInfo, eventName, event) {
        targetInfo = targetInfo || {};
        var el = targetInfo.target;
        if (el && el.silent) return;
        var eventHandler = "on" + eventName;
        var eventPacket = $9f5fe6326a736418$var$makeEventPacket(eventName, targetInfo, event);
        while(el){
            el[eventHandler] && (eventPacket.cancelBubble = el[eventHandler].call(el, eventPacket));
            el.trigger(eventName, eventPacket);
            el = el.parent;
            if (eventPacket.cancelBubble) break;
        }
        if (!eventPacket.cancelBubble) {
            // 冒泡到顶级 zrender 对象
            this.trigger(eventName, eventPacket); // 分发事件到用户自定义层
            // 用户有可能在全局 click 事件中 dispose，所以需要判断下 painter 是否存在
            this.painter && this.painter.eachOtherLayer(function(layer) {
                if (typeof layer[eventHandler] === "function") layer[eventHandler].call(layer, eventPacket);
                if (layer.trigger) layer.trigger(eventName, eventPacket);
            });
        }
    },
    /**
   * @private
   * @param {number} x
   * @param {number} y
   * @param {module:zrender/graphic/Displayable} exclude
   * @return {model:zrender/Element}
   * @method
   */ findHover: function(x, y, exclude) {
        var list = this.storage.getDisplayList();
        var out = {
            x: x,
            y: y
        };
        for(var i = list.length - 1; i >= 0; i--){
            var hoverCheckResult;
            if (list[i] !== exclude // getDisplayList may include ignored item in VML mode
             && !list[i].ignore && (hoverCheckResult = $9f5fe6326a736418$var$isHover(list[i], x, y))) {
                !out.topTarget && (out.topTarget = list[i]);
                if (hoverCheckResult !== $9f5fe6326a736418$var$SILENT) {
                    out.target = list[i];
                    break;
                }
            }
        }
        return out;
    },
    processGesture: function(event, stage) {
        if (!this._gestureMgr) this._gestureMgr = new $6476e2e090d660b0$exports();
        var gestureMgr = this._gestureMgr;
        stage === "start" && gestureMgr.clear();
        var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
        stage === "end" && gestureMgr.clear(); // Do not do any preventDefault here. Upper application do that if necessary.
        if (gestureInfo) {
            var type = gestureInfo.type;
            event.gestureEvent = type;
            this.dispatchToElement({
                target: gestureInfo.target
            }, type, gestureInfo.event);
        }
    }
}; // Common handlers
$ec279652dd95c27b$export$79b2f7037acddd43([
    "click",
    "mousedown",
    "mouseup",
    "mousewheel",
    "dblclick",
    "contextmenu"
], function(name) {
    $9f5fe6326a736418$var$Handler.prototype[name] = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $9f5fe6326a736418$var$isOutsideBoundary(this, x, y);
        var hovered;
        var hoveredTarget;
        if (name !== "mouseup" || !isOutside) {
            // Find hover again to avoid click event is dispatched manually. Or click is triggered without mouseover
            hovered = this.findHover(x, y);
            hoveredTarget = hovered.target;
        }
        if (name === "mousedown") {
            this._downEl = hoveredTarget;
            this._downPoint = [
                event.zrX,
                event.zrY
            ]; // In case click triggered before mouseup
            this._upEl = hoveredTarget;
        } else if (name === "mouseup") this._upEl = hoveredTarget;
        else if (name === "click") {
            if (this._downEl !== this._upEl // Original click event is triggered on the whole canvas element,
             || !this._downPoint // Arbitrary value
             || $9eb63d101f3bcd79$export$6c4a311cc157c764(this._downPoint, [
                event.zrX,
                event.zrY
            ]) > 4) return;
            this._downPoint = null;
        }
        this.dispatchToElement(hovered, name, event);
    };
});
function $9f5fe6326a736418$var$isHover(displayable, x, y) {
    if (displayable[displayable.rectHover ? "rectContain" : "contain"](x, y)) {
        var el = displayable;
        var isSilent;
        while(el){
            // If clipped by ancestor.
            // FIXME: If clipPath has neither stroke nor fill,
            // el.clipPath.contain(x, y) will always return false.
            if (el.clipPath && !el.clipPath.contain(x, y)) return false;
            if (el.silent) isSilent = true;
            el = el.parent;
        }
        return isSilent ? $9f5fe6326a736418$var$SILENT : true;
    }
    return false;
}
/**
 * See [Drag outside].
 */ function $9f5fe6326a736418$var$isOutsideBoundary(handlerInstance, x, y) {
    var painter = handlerInstance.painter;
    return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
}
$ec279652dd95c27b$export$e36fc9d62a853069($9f5fe6326a736418$var$Handler, $b7a44647f5b5bfa5$exports);
$ec279652dd95c27b$export$e36fc9d62a853069($9f5fe6326a736418$var$Handler, $f18af77d68e34617$exports);
var $9f5fe6326a736418$var$_default = $9f5fe6326a736418$var$Handler;
$9f5fe6326a736418$exports = $9f5fe6326a736418$var$_default;


var $cf128beaa1ab720c$exports = {};


var $48aa8d5160ffcc64$exports = {};

var $e85cd217b6cf99d0$exports = {};


var $af5c198eb02e5120$exports = {};
var $6c6dd9610ba660f0$exports = {};

$parcel$export($6c6dd9610ba660f0$exports, "create", () => $6c6dd9610ba660f0$export$185802fd694ee1f5, (v) => $6c6dd9610ba660f0$export$185802fd694ee1f5 = v);
$parcel$export($6c6dd9610ba660f0$exports, "identity", () => $6c6dd9610ba660f0$export$f0954fd7d5368655, (v) => $6c6dd9610ba660f0$export$f0954fd7d5368655 = v);
$parcel$export($6c6dd9610ba660f0$exports, "copy", () => $6c6dd9610ba660f0$export$784d13d8ee351f07, (v) => $6c6dd9610ba660f0$export$784d13d8ee351f07 = v);
$parcel$export($6c6dd9610ba660f0$exports, "mul", () => $6c6dd9610ba660f0$export$6e3a27864ab166fe, (v) => $6c6dd9610ba660f0$export$6e3a27864ab166fe = v);
$parcel$export($6c6dd9610ba660f0$exports, "translate", () => $6c6dd9610ba660f0$export$d73ee8ef04f5226a, (v) => $6c6dd9610ba660f0$export$d73ee8ef04f5226a = v);
$parcel$export($6c6dd9610ba660f0$exports, "rotate", () => $6c6dd9610ba660f0$export$bb628a54ab399bc9, (v) => $6c6dd9610ba660f0$export$bb628a54ab399bc9 = v);
$parcel$export($6c6dd9610ba660f0$exports, "scale", () => $6c6dd9610ba660f0$export$dcdf75081b88279d, (v) => $6c6dd9610ba660f0$export$dcdf75081b88279d = v);
$parcel$export($6c6dd9610ba660f0$exports, "invert", () => $6c6dd9610ba660f0$export$6897c284b6f9f4dc, (v) => $6c6dd9610ba660f0$export$6897c284b6f9f4dc = v);
$parcel$export($6c6dd9610ba660f0$exports, "clone", () => $6c6dd9610ba660f0$export$9cd59f9826255e47, (v) => $6c6dd9610ba660f0$export$9cd59f9826255e47 = v);
/**
 * 3x2矩阵操作类
 * @exports zrender/tool/matrix
 */ /* global Float32Array */ var $6c6dd9610ba660f0$export$185802fd694ee1f5;
var $6c6dd9610ba660f0$export$f0954fd7d5368655;
var $6c6dd9610ba660f0$export$784d13d8ee351f07;
var $6c6dd9610ba660f0$export$6e3a27864ab166fe;
var $6c6dd9610ba660f0$export$d73ee8ef04f5226a;
var $6c6dd9610ba660f0$export$bb628a54ab399bc9;
var $6c6dd9610ba660f0$export$dcdf75081b88279d;
var $6c6dd9610ba660f0$export$6897c284b6f9f4dc;
var $6c6dd9610ba660f0$export$9cd59f9826255e47;
var $6c6dd9610ba660f0$var$ArrayCtor = typeof Float32Array === "undefined" ? Array : Float32Array;
/**
 * Create a identity matrix.
 * @return {Float32Array|Array.<number>}
 */ function $6c6dd9610ba660f0$var$create() {
    var out = new $6c6dd9610ba660f0$var$ArrayCtor(6);
    $6c6dd9610ba660f0$var$identity(out);
    return out;
}
/**
 * 设置矩阵为单位矩阵
 * @param {Float32Array|Array.<number>} out
 */ function $6c6dd9610ba660f0$var$identity(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
}
/**
 * 复制矩阵
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} m
 */ function $6c6dd9610ba660f0$var$copy(out, m) {
    out[0] = m[0];
    out[1] = m[1];
    out[2] = m[2];
    out[3] = m[3];
    out[4] = m[4];
    out[5] = m[5];
    return out;
}
/**
 * 矩阵相乘
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} m1
 * @param {Float32Array|Array.<number>} m2
 */ function $6c6dd9610ba660f0$var$mul(out, m1, m2) {
    // Consider matrix.mul(m, m2, m);
    // where out is the same as m2.
    // So use temp variable to escape error.
    var out0 = m1[0] * m2[0] + m1[2] * m2[1];
    var out1 = m1[1] * m2[0] + m1[3] * m2[1];
    var out2 = m1[0] * m2[2] + m1[2] * m2[3];
    var out3 = m1[1] * m2[2] + m1[3] * m2[3];
    var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
    var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = out3;
    out[4] = out4;
    out[5] = out5;
    return out;
}
/**
 * 平移变换
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 * @param {Float32Array|Array.<number>} v
 */ function $6c6dd9610ba660f0$var$translate(out, a, v) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4] + v[0];
    out[5] = a[5] + v[1];
    return out;
}
/**
 * 旋转变换
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 * @param {number} rad
 */ function $6c6dd9610ba660f0$var$rotate(out, a, rad) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var st = Math.sin(rad);
    var ct = Math.cos(rad);
    out[0] = aa * ct + ab * st;
    out[1] = -aa * st + ab * ct;
    out[2] = ac * ct + ad * st;
    out[3] = -ac * st + ct * ad;
    out[4] = ct * atx + st * aty;
    out[5] = ct * aty - st * atx;
    return out;
}
/**
 * 缩放变换
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 * @param {Float32Array|Array.<number>} v
 */ function $6c6dd9610ba660f0$var$scale(out, a, v) {
    var vx = v[0];
    var vy = v[1];
    out[0] = a[0] * vx;
    out[1] = a[1] * vy;
    out[2] = a[2] * vx;
    out[3] = a[3] * vy;
    out[4] = a[4] * vx;
    out[5] = a[5] * vy;
    return out;
}
/**
 * 求逆矩阵
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 */ function $6c6dd9610ba660f0$var$invert(out, a) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
}
/**
 * Clone a new matrix.
 * @param {Float32Array|Array.<number>} a
 */ function $6c6dd9610ba660f0$var$clone(a) {
    var b = $6c6dd9610ba660f0$var$create();
    $6c6dd9610ba660f0$var$copy(b, a);
    return b;
}
$6c6dd9610ba660f0$export$185802fd694ee1f5 = $6c6dd9610ba660f0$var$create;
$6c6dd9610ba660f0$export$f0954fd7d5368655 = $6c6dd9610ba660f0$var$identity;
$6c6dd9610ba660f0$export$784d13d8ee351f07 = $6c6dd9610ba660f0$var$copy;
$6c6dd9610ba660f0$export$6e3a27864ab166fe = $6c6dd9610ba660f0$var$mul;
$6c6dd9610ba660f0$export$d73ee8ef04f5226a = $6c6dd9610ba660f0$var$translate;
$6c6dd9610ba660f0$export$bb628a54ab399bc9 = $6c6dd9610ba660f0$var$rotate;
$6c6dd9610ba660f0$export$dcdf75081b88279d = $6c6dd9610ba660f0$var$scale;
$6c6dd9610ba660f0$export$6897c284b6f9f4dc = $6c6dd9610ba660f0$var$invert;
$6c6dd9610ba660f0$export$9cd59f9826255e47 = $6c6dd9610ba660f0$var$clone;



/**
 * 提供变换扩展
 * @module zrender/mixin/Transformable
 * @author pissang (https://www.github.com/pissang)
 */ var $af5c198eb02e5120$var$mIdentity = $6c6dd9610ba660f0$export$f0954fd7d5368655;
var $af5c198eb02e5120$var$EPSILON = 5e-5;
function $af5c198eb02e5120$var$isNotAroundZero(val) {
    return val > $af5c198eb02e5120$var$EPSILON || val < -$af5c198eb02e5120$var$EPSILON;
}
/**
 * @alias module:zrender/mixin/Transformable
 * @constructor
 */ var $af5c198eb02e5120$var$Transformable = function(opts) {
    opts = opts || {}; // If there are no given position, rotation, scale
    if (!opts.position) /**
     * 平移
     * @type {Array.<number>}
     * @default [0, 0]
     */ this.position = [
        0,
        0
    ];
    if (opts.rotation == null) /**
     * 旋转
     * @type {Array.<number>}
     * @default 0
     */ this.rotation = 0;
    if (!opts.scale) /**
     * 缩放
     * @type {Array.<number>}
     * @default [1, 1]
     */ this.scale = [
        1,
        1
    ];
    /**
   * 旋转和缩放的原点
   * @type {Array.<number>}
   * @default null
   */ this.origin = this.origin || null;
};
var $af5c198eb02e5120$var$transformableProto = $af5c198eb02e5120$var$Transformable.prototype;
$af5c198eb02e5120$var$transformableProto.transform = null;
/**
 * 判断是否需要有坐标变换
 * 如果有坐标变换, 则从position, rotation, scale以及父节点的transform计算出自身的transform矩阵
 */ $af5c198eb02e5120$var$transformableProto.needLocalTransform = function() {
    return $af5c198eb02e5120$var$isNotAroundZero(this.rotation) || $af5c198eb02e5120$var$isNotAroundZero(this.position[0]) || $af5c198eb02e5120$var$isNotAroundZero(this.position[1]) || $af5c198eb02e5120$var$isNotAroundZero(this.scale[0] - 1) || $af5c198eb02e5120$var$isNotAroundZero(this.scale[1] - 1);
};
var $af5c198eb02e5120$var$scaleTmp = [];
$af5c198eb02e5120$var$transformableProto.updateTransform = function() {
    var parent = this.parent;
    var parentHasTransform = parent && parent.transform;
    var needLocalTransform = this.needLocalTransform();
    var m = this.transform;
    if (!(needLocalTransform || parentHasTransform)) {
        m && $af5c198eb02e5120$var$mIdentity(m);
        return;
    }
    m = m || $6c6dd9610ba660f0$export$185802fd694ee1f5();
    if (needLocalTransform) this.getLocalTransform(m);
    else $af5c198eb02e5120$var$mIdentity(m);
     // 应用父节点变换
    if (parentHasTransform) {
        if (needLocalTransform) $6c6dd9610ba660f0$export$6e3a27864ab166fe(m, parent.transform, m);
        else $6c6dd9610ba660f0$export$784d13d8ee351f07(m, parent.transform);
    } // 保存这个变换矩阵
    this.transform = m;
    var globalScaleRatio = this.globalScaleRatio;
    if (globalScaleRatio != null && globalScaleRatio !== 1) {
        this.getGlobalScale($af5c198eb02e5120$var$scaleTmp);
        var relX = $af5c198eb02e5120$var$scaleTmp[0] < 0 ? -1 : 1;
        var relY = $af5c198eb02e5120$var$scaleTmp[1] < 0 ? -1 : 1;
        var sx = (($af5c198eb02e5120$var$scaleTmp[0] - relX) * globalScaleRatio + relX) / $af5c198eb02e5120$var$scaleTmp[0] || 0;
        var sy = (($af5c198eb02e5120$var$scaleTmp[1] - relY) * globalScaleRatio + relY) / $af5c198eb02e5120$var$scaleTmp[1] || 0;
        m[0] *= sx;
        m[1] *= sx;
        m[2] *= sy;
        m[3] *= sy;
    }
    this.invTransform = this.invTransform || $6c6dd9610ba660f0$export$185802fd694ee1f5();
    $6c6dd9610ba660f0$export$6897c284b6f9f4dc(this.invTransform, m);
};
$af5c198eb02e5120$var$transformableProto.getLocalTransform = function(m) {
    return $af5c198eb02e5120$var$Transformable.getLocalTransform(this, m);
};
/**
 * 将自己的transform应用到context上
 * @param {CanvasRenderingContext2D} ctx
 */ $af5c198eb02e5120$var$transformableProto.setTransform = function(ctx) {
    var m = this.transform;
    var dpr = ctx.dpr || 1;
    if (m) ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
    else ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
};
$af5c198eb02e5120$var$transformableProto.restoreTransform = function(ctx) {
    var dpr = ctx.dpr || 1;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
};
var $af5c198eb02e5120$var$tmpTransform = [];
var $af5c198eb02e5120$var$originTransform = $6c6dd9610ba660f0$export$185802fd694ee1f5();
$af5c198eb02e5120$var$transformableProto.setLocalTransform = function(m) {
    if (!m) // TODO return or set identity?
    return;
    var sx = m[0] * m[0] + m[1] * m[1];
    var sy = m[2] * m[2] + m[3] * m[3];
    var position = this.position;
    var scale = this.scale;
    if ($af5c198eb02e5120$var$isNotAroundZero(sx - 1)) sx = Math.sqrt(sx);
    if ($af5c198eb02e5120$var$isNotAroundZero(sy - 1)) sy = Math.sqrt(sy);
    if (m[0] < 0) sx = -sx;
    if (m[3] < 0) sy = -sy;
    position[0] = m[4];
    position[1] = m[5];
    scale[0] = sx;
    scale[1] = sy;
    this.rotation = Math.atan2(-m[1] / sy, m[0] / sx);
};
/**
 * 分解`transform`矩阵到`position`, `rotation`, `scale`
 */ $af5c198eb02e5120$var$transformableProto.decomposeTransform = function() {
    if (!this.transform) return;
    var parent = this.parent;
    var m = this.transform;
    if (parent && parent.transform) {
        // Get local transform and decompose them to position, scale, rotation
        $6c6dd9610ba660f0$export$6e3a27864ab166fe($af5c198eb02e5120$var$tmpTransform, parent.invTransform, m);
        m = $af5c198eb02e5120$var$tmpTransform;
    }
    var origin = this.origin;
    if (origin && (origin[0] || origin[1])) {
        $af5c198eb02e5120$var$originTransform[4] = origin[0];
        $af5c198eb02e5120$var$originTransform[5] = origin[1];
        $6c6dd9610ba660f0$export$6e3a27864ab166fe($af5c198eb02e5120$var$tmpTransform, m, $af5c198eb02e5120$var$originTransform);
        $af5c198eb02e5120$var$tmpTransform[4] -= origin[0];
        $af5c198eb02e5120$var$tmpTransform[5] -= origin[1];
        m = $af5c198eb02e5120$var$tmpTransform;
    }
    this.setLocalTransform(m);
};
/**
 * Get global scale
 * @return {Array.<number>}
 */ $af5c198eb02e5120$var$transformableProto.getGlobalScale = function(out) {
    var m = this.transform;
    out = out || [];
    if (!m) {
        out[0] = 1;
        out[1] = 1;
        return out;
    }
    out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
    out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
    if (m[0] < 0) out[0] = -out[0];
    if (m[3] < 0) out[1] = -out[1];
    return out;
};
/**
 * 变换坐标位置到 shape 的局部坐标空间
 * @method
 * @param {number} x
 * @param {number} y
 * @return {Array.<number>}
 */ $af5c198eb02e5120$var$transformableProto.transformCoordToLocal = function(x, y) {
    var v2 = [
        x,
        y
    ];
    var invTransform = this.invTransform;
    if (invTransform) $9eb63d101f3bcd79$export$9f9dcb98c894b623(v2, v2, invTransform);
    return v2;
};
/**
 * 变换局部坐标位置到全局坐标空间
 * @method
 * @param {number} x
 * @param {number} y
 * @return {Array.<number>}
 */ $af5c198eb02e5120$var$transformableProto.transformCoordToGlobal = function(x, y) {
    var v2 = [
        x,
        y
    ];
    var transform = this.transform;
    if (transform) $9eb63d101f3bcd79$export$9f9dcb98c894b623(v2, v2, transform);
    return v2;
};
/**
 * @static
 * @param {Object} target
 * @param {Array.<number>} target.origin
 * @param {number} target.rotation
 * @param {Array.<number>} target.position
 * @param {Array.<number>} [m]
 */ $af5c198eb02e5120$var$Transformable.getLocalTransform = function(target, m) {
    m = m || [];
    $af5c198eb02e5120$var$mIdentity(m);
    var origin = target.origin;
    var scale = target.scale || [
        1,
        1
    ];
    var rotation = target.rotation || 0;
    var position = target.position || [
        0,
        0
    ];
    if (origin) {
        // Translate to origin
        m[4] -= origin[0];
        m[5] -= origin[1];
    }
    $6c6dd9610ba660f0$export$dcdf75081b88279d(m, m, scale);
    if (rotation) $6c6dd9610ba660f0$export$bb628a54ab399bc9(m, m, rotation);
    if (origin) {
        // Translate back from origin
        m[4] += origin[0];
        m[5] += origin[1];
    }
    m[4] += position[0];
    m[5] += position[1];
    return m;
};
var $af5c198eb02e5120$var$_default = $af5c198eb02e5120$var$Transformable;
$af5c198eb02e5120$exports = $af5c198eb02e5120$var$_default;


var $286759ee96158d70$exports = {};
var $ffa340c0956116a5$exports = {};
var $18410b6a619c04ed$exports = {};
var $f7f777d09249ad33$exports = {};
/**
 * 缓动代码来自 https://github.com/sole/tween.js/blob/master/src/Tween.js
 * @see http://sole.github.io/tween.js/examples/03_graphs.html
 * @exports zrender/animation/easing
 */ var $f7f777d09249ad33$var$easing = {
    /**
  * @param {number} k
  * @return {number}
  */ linear: function(k) {
        return k;
    },
    /**
  * @param {number} k
  * @return {number}
  */ quadraticIn: function(k) {
        return k * k;
    },
    /**
  * @param {number} k
  * @return {number}
  */ quadraticOut: function(k) {
        return k * (2 - k);
    },
    /**
  * @param {number} k
  * @return {number}
  */ quadraticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k;
        return -0.5 * (--k * (k - 2) - 1);
    },
    // 三次方的缓动（t^3）
    /**
  * @param {number} k
  * @return {number}
  */ cubicIn: function(k) {
        return k * k * k;
    },
    /**
  * @param {number} k
  * @return {number}
  */ cubicOut: function(k) {
        return --k * k * k + 1;
    },
    /**
  * @param {number} k
  * @return {number}
  */ cubicInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k;
        return 0.5 * ((k -= 2) * k * k + 2);
    },
    // 四次方的缓动（t^4）
    /**
  * @param {number} k
  * @return {number}
  */ quarticIn: function(k) {
        return k * k * k * k;
    },
    /**
  * @param {number} k
  * @return {number}
  */ quarticOut: function(k) {
        return 1 - --k * k * k * k;
    },
    /**
  * @param {number} k
  * @return {number}
  */ quarticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k;
        return -0.5 * ((k -= 2) * k * k * k - 2);
    },
    // 五次方的缓动（t^5）
    /**
  * @param {number} k
  * @return {number}
  */ quinticIn: function(k) {
        return k * k * k * k * k;
    },
    /**
  * @param {number} k
  * @return {number}
  */ quinticOut: function(k) {
        return --k * k * k * k * k + 1;
    },
    /**
  * @param {number} k
  * @return {number}
  */ quinticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
        return 0.5 * ((k -= 2) * k * k * k * k + 2);
    },
    // 正弦曲线的缓动（sin(t)）
    /**
  * @param {number} k
  * @return {number}
  */ sinusoidalIn: function(k) {
        return 1 - Math.cos(k * Math.PI / 2);
    },
    /**
  * @param {number} k
  * @return {number}
  */ sinusoidalOut: function(k) {
        return Math.sin(k * Math.PI / 2);
    },
    /**
  * @param {number} k
  * @return {number}
  */ sinusoidalInOut: function(k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    },
    // 指数曲线的缓动（2^t）
    /**
  * @param {number} k
  * @return {number}
  */ exponentialIn: function(k) {
        return k === 0 ? 0 : Math.pow(1024, k - 1);
    },
    /**
  * @param {number} k
  * @return {number}
  */ exponentialOut: function(k) {
        return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
    },
    /**
  * @param {number} k
  * @return {number}
  */ exponentialInOut: function(k) {
        if (k === 0) return 0;
        if (k === 1) return 1;
        if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
        return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
    },
    // 圆形曲线的缓动（sqrt(1-t^2)）
    /**
  * @param {number} k
  * @return {number}
  */ circularIn: function(k) {
        return 1 - Math.sqrt(1 - k * k);
    },
    /**
  * @param {number} k
  * @return {number}
  */ circularOut: function(k) {
        return Math.sqrt(1 - --k * k);
    },
    /**
  * @param {number} k
  * @return {number}
  */ circularInOut: function(k) {
        if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
        return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
    },
    // 创建类似于弹簧在停止前来回振荡的动画
    /**
  * @param {number} k
  * @return {number}
  */ elasticIn: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
    },
    /**
  * @param {number} k
  * @return {number}
  */ elasticOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
    },
    /**
  * @param {number} k
  * @return {number}
  */ elasticInOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        if ((k *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
        return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
    },
    // 在某一动画开始沿指示的路径进行动画处理前稍稍收回该动画的移动
    /**
  * @param {number} k
  * @return {number}
  */ backIn: function(k) {
        var s = 1.70158;
        return k * k * ((s + 1) * k - s);
    },
    /**
  * @param {number} k
  * @return {number}
  */ backOut: function(k) {
        var s = 1.70158;
        return --k * k * ((s + 1) * k + s) + 1;
    },
    /**
  * @param {number} k
  * @return {number}
  */ backInOut: function(k) {
        var s = 2.5949095;
        if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
        return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
    },
    // 创建弹跳效果
    /**
  * @param {number} k
  * @return {number}
  */ bounceIn: function(k) {
        return 1 - $f7f777d09249ad33$var$easing.bounceOut(1 - k);
    },
    /**
  * @param {number} k
  * @return {number}
  */ bounceOut: function(k) {
        if (k < 1 / 2.75) return 7.5625 * k * k;
        else if (k < 2 / 2.75) return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
        else if (k < 2.5 / 2.75) return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
        else return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    },
    /**
  * @param {number} k
  * @return {number}
  */ bounceInOut: function(k) {
        if (k < 0.5) return $f7f777d09249ad33$var$easing.bounceIn(k * 2) * 0.5;
        return $f7f777d09249ad33$var$easing.bounceOut(k * 2 - 1) * 0.5 + 0.5;
    }
};
var $f7f777d09249ad33$var$_default = $f7f777d09249ad33$var$easing;
$f7f777d09249ad33$exports = $f7f777d09249ad33$var$_default;


/**
 * 动画主控制器
 * @config target 动画对象，可以是数组，如果是数组的话会批量分发onframe等事件
 * @config life(1000) 动画时长
 * @config delay(0) 动画延迟时间
 * @config loop(true)
 * @config gap(0) 循环的间隔时间
 * @config onframe
 * @config easing(optional)
 * @config ondestroy(optional)
 * @config onrestart(optional)
 *
 * TODO pause
 */ function $18410b6a619c04ed$var$Clip(options) {
    this._target = options.target; // 生命周期
    this._life = options.life || 1000; // 延时
    this._delay = options.delay || 0; // 开始时间
    // this._startTime = new Date().getTime() + this._delay;// 单位毫秒
    this._initialized = false; // 是否循环
    this.loop = options.loop == null ? false : options.loop;
    this.gap = options.gap || 0;
    this.easing = options.easing || "Linear";
    this.onframe = options.onframe;
    this.ondestroy = options.ondestroy;
    this.onrestart = options.onrestart;
    this._pausedTime = 0;
    this._paused = false;
}
$18410b6a619c04ed$var$Clip.prototype = {
    constructor: $18410b6a619c04ed$var$Clip,
    step: function(globalTime, deltaTime) {
        // Set startTime on first step, or _startTime may has milleseconds different between clips
        // PENDING
        if (!this._initialized) {
            this._startTime = globalTime + this._delay;
            this._initialized = true;
        }
        if (this._paused) {
            this._pausedTime += deltaTime;
            return;
        }
        var percent = (globalTime - this._startTime - this._pausedTime) / this._life; // 还没开始
        if (percent < 0) return;
        percent = Math.min(percent, 1);
        var easing = this.easing;
        var easingFunc = typeof easing === "string" ? $f7f777d09249ad33$exports[easing] : easing;
        var schedule = typeof easingFunc === "function" ? easingFunc(percent) : percent;
        this.fire("frame", schedule); // 结束
        if (percent === 1) {
            if (this.loop) {
                this.restart(globalTime); // 重新开始周期
                // 抛出而不是直接调用事件直到 stage.update 后再统一调用这些事件
                return "restart";
            } // 动画完成将这个控制器标识为待删除
            // 在Animation.update中进行批量删除
            this._needsRemove = true;
            return "destroy";
        }
        return null;
    },
    restart: function(globalTime) {
        var remainder = (globalTime - this._startTime - this._pausedTime) % this._life;
        this._startTime = globalTime - remainder + this.gap;
        this._pausedTime = 0;
        this._needsRemove = false;
    },
    fire: function(eventType, arg) {
        eventType = "on" + eventType;
        if (this[eventType]) this[eventType](this._target, arg);
    },
    pause: function() {
        this._paused = true;
    },
    resume: function() {
        this._paused = false;
    }
};
var $18410b6a619c04ed$var$_default = $18410b6a619c04ed$var$Clip;
$18410b6a619c04ed$exports = $18410b6a619c04ed$var$_default;


var $b1179c91b052e827$exports = {};

$parcel$export($b1179c91b052e827$exports, "parse", () => $b1179c91b052e827$export$98e6a39c04603d36, (v) => $b1179c91b052e827$export$98e6a39c04603d36 = v);
$parcel$export($b1179c91b052e827$exports, "lift", () => $b1179c91b052e827$export$590e8b2c435046d9, (v) => $b1179c91b052e827$export$590e8b2c435046d9 = v);
$parcel$export($b1179c91b052e827$exports, "toHex", () => $b1179c91b052e827$export$7ea66e3774a60b67, (v) => $b1179c91b052e827$export$7ea66e3774a60b67 = v);
$parcel$export($b1179c91b052e827$exports, "fastLerp", () => $b1179c91b052e827$export$66cb3c0e9efc61c8, (v) => $b1179c91b052e827$export$66cb3c0e9efc61c8 = v);
$parcel$export($b1179c91b052e827$exports, "fastMapToColor", () => $b1179c91b052e827$export$daa5a65daad5df58, (v) => $b1179c91b052e827$export$daa5a65daad5df58 = v);
$parcel$export($b1179c91b052e827$exports, "lerp", () => $b1179c91b052e827$export$3a89f8d6f6bf6c9f, (v) => $b1179c91b052e827$export$3a89f8d6f6bf6c9f = v);
$parcel$export($b1179c91b052e827$exports, "mapToColor", () => $b1179c91b052e827$export$296e08242b78a3ec, (v) => $b1179c91b052e827$export$296e08242b78a3ec = v);
$parcel$export($b1179c91b052e827$exports, "modifyHSL", () => $b1179c91b052e827$export$d898ae866e27bf18, (v) => $b1179c91b052e827$export$d898ae866e27bf18 = v);
$parcel$export($b1179c91b052e827$exports, "modifyAlpha", () => $b1179c91b052e827$export$ab4754bf42583a26, (v) => $b1179c91b052e827$export$ab4754bf42583a26 = v);
$parcel$export($b1179c91b052e827$exports, "stringify", () => $b1179c91b052e827$export$fac44ee5b035f737, (v) => $b1179c91b052e827$export$fac44ee5b035f737 = v);
var $b1179c91b052e827$export$98e6a39c04603d36;
var $b1179c91b052e827$export$590e8b2c435046d9;
var $b1179c91b052e827$export$7ea66e3774a60b67;
var $b1179c91b052e827$export$66cb3c0e9efc61c8;
var $b1179c91b052e827$export$daa5a65daad5df58;
var $b1179c91b052e827$export$3a89f8d6f6bf6c9f;
var $b1179c91b052e827$export$296e08242b78a3ec;
var $b1179c91b052e827$export$d898ae866e27bf18;
var $b1179c91b052e827$export$ab4754bf42583a26;
var $b1179c91b052e827$export$fac44ee5b035f737;
var $8f310e996ed18a8a$exports = {};
// Simple LRU cache use doubly linked list
// @module zrender/core/LRU
/**
 * Simple double linked list. Compared with array, it has O(1) remove operation.
 * @constructor
 */ var $8f310e996ed18a8a$var$LinkedList = function() {
    /**
   * @type {module:zrender/core/LRU~Entry}
   */ this.head = null;
    /**
   * @type {module:zrender/core/LRU~Entry}
   */ this.tail = null;
    this._len = 0;
};
var $8f310e996ed18a8a$var$linkedListProto = $8f310e996ed18a8a$var$LinkedList.prototype;
/**
 * Insert a new value at the tail
 * @param  {} val
 * @return {module:zrender/core/LRU~Entry}
 */ $8f310e996ed18a8a$var$linkedListProto.insert = function(val) {
    var entry = new $8f310e996ed18a8a$var$Entry(val);
    this.insertEntry(entry);
    return entry;
};
/**
 * Insert an entry at the tail
 * @param  {module:zrender/core/LRU~Entry} entry
 */ $8f310e996ed18a8a$var$linkedListProto.insertEntry = function(entry) {
    if (!this.head) this.head = this.tail = entry;
    else {
        this.tail.next = entry;
        entry.prev = this.tail;
        entry.next = null;
        this.tail = entry;
    }
    this._len++;
};
/**
 * Remove entry.
 * @param  {module:zrender/core/LRU~Entry} entry
 */ $8f310e996ed18a8a$var$linkedListProto.remove = function(entry) {
    var prev = entry.prev;
    var next = entry.next;
    if (prev) prev.next = next;
    else // Is head
    this.head = next;
    if (next) next.prev = prev;
    else // Is tail
    this.tail = prev;
    entry.next = entry.prev = null;
    this._len--;
};
/**
 * @return {number}
 */ $8f310e996ed18a8a$var$linkedListProto.len = function() {
    return this._len;
};
/**
 * Clear list
 */ $8f310e996ed18a8a$var$linkedListProto.clear = function() {
    this.head = this.tail = null;
    this._len = 0;
};
/**
 * @constructor
 * @param {} val
 */ var $8f310e996ed18a8a$var$Entry = function(val) {
    /**
   * @type {}
   */ this.value = val;
    /**
   * @type {module:zrender/core/LRU~Entry}
   */ this.next;
    /**
   * @type {module:zrender/core/LRU~Entry}
   */ this.prev;
};
/**
 * LRU Cache
 * @constructor
 * @alias module:zrender/core/LRU
 */ var $8f310e996ed18a8a$var$LRU = function(maxSize) {
    this._list = new $8f310e996ed18a8a$var$LinkedList();
    this._map = {};
    this._maxSize = maxSize || 10;
    this._lastRemovedEntry = null;
};
var $8f310e996ed18a8a$var$LRUProto = $8f310e996ed18a8a$var$LRU.prototype;
/**
 * @param  {string} key
 * @param  {} value
 * @return {} Removed value
 */ $8f310e996ed18a8a$var$LRUProto.put = function(key, value) {
    var list = this._list;
    var map = this._map;
    var removed = null;
    if (map[key] == null) {
        var len = list.len(); // Reuse last removed entry
        var entry = this._lastRemovedEntry;
        if (len >= this._maxSize && len > 0) {
            // Remove the least recently used
            var leastUsedEntry = list.head;
            list.remove(leastUsedEntry);
            delete map[leastUsedEntry.key];
            removed = leastUsedEntry.value;
            this._lastRemovedEntry = leastUsedEntry;
        }
        if (entry) entry.value = value;
        else entry = new $8f310e996ed18a8a$var$Entry(value);
        entry.key = key;
        list.insertEntry(entry);
        map[key] = entry;
    }
    return removed;
};
/**
 * @param  {string} key
 * @return {}
 */ $8f310e996ed18a8a$var$LRUProto.get = function(key) {
    var entry = this._map[key];
    var list = this._list;
    if (entry != null) {
        // Put the latest used entry in the tail
        if (entry !== list.tail) {
            list.remove(entry);
            list.insertEntry(entry);
        }
        return entry.value;
    }
};
/**
 * Clear the cache
 */ $8f310e996ed18a8a$var$LRUProto.clear = function() {
    this._list.clear();
    this._map = {};
};
var $8f310e996ed18a8a$var$_default = $8f310e996ed18a8a$var$LRU;
$8f310e996ed18a8a$exports = $8f310e996ed18a8a$var$_default;


var $b1179c91b052e827$var$kCSSColorTable = {
    "transparent": [
        0,
        0,
        0,
        0
    ],
    "aliceblue": [
        240,
        248,
        255,
        1
    ],
    "antiquewhite": [
        250,
        235,
        215,
        1
    ],
    "aqua": [
        0,
        255,
        255,
        1
    ],
    "aquamarine": [
        127,
        255,
        212,
        1
    ],
    "azure": [
        240,
        255,
        255,
        1
    ],
    "beige": [
        245,
        245,
        220,
        1
    ],
    "bisque": [
        255,
        228,
        196,
        1
    ],
    "black": [
        0,
        0,
        0,
        1
    ],
    "blanchedalmond": [
        255,
        235,
        205,
        1
    ],
    "blue": [
        0,
        0,
        255,
        1
    ],
    "blueviolet": [
        138,
        43,
        226,
        1
    ],
    "brown": [
        165,
        42,
        42,
        1
    ],
    "burlywood": [
        222,
        184,
        135,
        1
    ],
    "cadetblue": [
        95,
        158,
        160,
        1
    ],
    "chartreuse": [
        127,
        255,
        0,
        1
    ],
    "chocolate": [
        210,
        105,
        30,
        1
    ],
    "coral": [
        255,
        127,
        80,
        1
    ],
    "cornflowerblue": [
        100,
        149,
        237,
        1
    ],
    "cornsilk": [
        255,
        248,
        220,
        1
    ],
    "crimson": [
        220,
        20,
        60,
        1
    ],
    "cyan": [
        0,
        255,
        255,
        1
    ],
    "darkblue": [
        0,
        0,
        139,
        1
    ],
    "darkcyan": [
        0,
        139,
        139,
        1
    ],
    "darkgoldenrod": [
        184,
        134,
        11,
        1
    ],
    "darkgray": [
        169,
        169,
        169,
        1
    ],
    "darkgreen": [
        0,
        100,
        0,
        1
    ],
    "darkgrey": [
        169,
        169,
        169,
        1
    ],
    "darkkhaki": [
        189,
        183,
        107,
        1
    ],
    "darkmagenta": [
        139,
        0,
        139,
        1
    ],
    "darkolivegreen": [
        85,
        107,
        47,
        1
    ],
    "darkorange": [
        255,
        140,
        0,
        1
    ],
    "darkorchid": [
        153,
        50,
        204,
        1
    ],
    "darkred": [
        139,
        0,
        0,
        1
    ],
    "darksalmon": [
        233,
        150,
        122,
        1
    ],
    "darkseagreen": [
        143,
        188,
        143,
        1
    ],
    "darkslateblue": [
        72,
        61,
        139,
        1
    ],
    "darkslategray": [
        47,
        79,
        79,
        1
    ],
    "darkslategrey": [
        47,
        79,
        79,
        1
    ],
    "darkturquoise": [
        0,
        206,
        209,
        1
    ],
    "darkviolet": [
        148,
        0,
        211,
        1
    ],
    "deeppink": [
        255,
        20,
        147,
        1
    ],
    "deepskyblue": [
        0,
        191,
        255,
        1
    ],
    "dimgray": [
        105,
        105,
        105,
        1
    ],
    "dimgrey": [
        105,
        105,
        105,
        1
    ],
    "dodgerblue": [
        30,
        144,
        255,
        1
    ],
    "firebrick": [
        178,
        34,
        34,
        1
    ],
    "floralwhite": [
        255,
        250,
        240,
        1
    ],
    "forestgreen": [
        34,
        139,
        34,
        1
    ],
    "fuchsia": [
        255,
        0,
        255,
        1
    ],
    "gainsboro": [
        220,
        220,
        220,
        1
    ],
    "ghostwhite": [
        248,
        248,
        255,
        1
    ],
    "gold": [
        255,
        215,
        0,
        1
    ],
    "goldenrod": [
        218,
        165,
        32,
        1
    ],
    "gray": [
        128,
        128,
        128,
        1
    ],
    "green": [
        0,
        128,
        0,
        1
    ],
    "greenyellow": [
        173,
        255,
        47,
        1
    ],
    "grey": [
        128,
        128,
        128,
        1
    ],
    "honeydew": [
        240,
        255,
        240,
        1
    ],
    "hotpink": [
        255,
        105,
        180,
        1
    ],
    "indianred": [
        205,
        92,
        92,
        1
    ],
    "indigo": [
        75,
        0,
        130,
        1
    ],
    "ivory": [
        255,
        255,
        240,
        1
    ],
    "khaki": [
        240,
        230,
        140,
        1
    ],
    "lavender": [
        230,
        230,
        250,
        1
    ],
    "lavenderblush": [
        255,
        240,
        245,
        1
    ],
    "lawngreen": [
        124,
        252,
        0,
        1
    ],
    "lemonchiffon": [
        255,
        250,
        205,
        1
    ],
    "lightblue": [
        173,
        216,
        230,
        1
    ],
    "lightcoral": [
        240,
        128,
        128,
        1
    ],
    "lightcyan": [
        224,
        255,
        255,
        1
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210,
        1
    ],
    "lightgray": [
        211,
        211,
        211,
        1
    ],
    "lightgreen": [
        144,
        238,
        144,
        1
    ],
    "lightgrey": [
        211,
        211,
        211,
        1
    ],
    "lightpink": [
        255,
        182,
        193,
        1
    ],
    "lightsalmon": [
        255,
        160,
        122,
        1
    ],
    "lightseagreen": [
        32,
        178,
        170,
        1
    ],
    "lightskyblue": [
        135,
        206,
        250,
        1
    ],
    "lightslategray": [
        119,
        136,
        153,
        1
    ],
    "lightslategrey": [
        119,
        136,
        153,
        1
    ],
    "lightsteelblue": [
        176,
        196,
        222,
        1
    ],
    "lightyellow": [
        255,
        255,
        224,
        1
    ],
    "lime": [
        0,
        255,
        0,
        1
    ],
    "limegreen": [
        50,
        205,
        50,
        1
    ],
    "linen": [
        250,
        240,
        230,
        1
    ],
    "magenta": [
        255,
        0,
        255,
        1
    ],
    "maroon": [
        128,
        0,
        0,
        1
    ],
    "mediumaquamarine": [
        102,
        205,
        170,
        1
    ],
    "mediumblue": [
        0,
        0,
        205,
        1
    ],
    "mediumorchid": [
        186,
        85,
        211,
        1
    ],
    "mediumpurple": [
        147,
        112,
        219,
        1
    ],
    "mediumseagreen": [
        60,
        179,
        113,
        1
    ],
    "mediumslateblue": [
        123,
        104,
        238,
        1
    ],
    "mediumspringgreen": [
        0,
        250,
        154,
        1
    ],
    "mediumturquoise": [
        72,
        209,
        204,
        1
    ],
    "mediumvioletred": [
        199,
        21,
        133,
        1
    ],
    "midnightblue": [
        25,
        25,
        112,
        1
    ],
    "mintcream": [
        245,
        255,
        250,
        1
    ],
    "mistyrose": [
        255,
        228,
        225,
        1
    ],
    "moccasin": [
        255,
        228,
        181,
        1
    ],
    "navajowhite": [
        255,
        222,
        173,
        1
    ],
    "navy": [
        0,
        0,
        128,
        1
    ],
    "oldlace": [
        253,
        245,
        230,
        1
    ],
    "olive": [
        128,
        128,
        0,
        1
    ],
    "olivedrab": [
        107,
        142,
        35,
        1
    ],
    "orange": [
        255,
        165,
        0,
        1
    ],
    "orangered": [
        255,
        69,
        0,
        1
    ],
    "orchid": [
        218,
        112,
        214,
        1
    ],
    "palegoldenrod": [
        238,
        232,
        170,
        1
    ],
    "palegreen": [
        152,
        251,
        152,
        1
    ],
    "paleturquoise": [
        175,
        238,
        238,
        1
    ],
    "palevioletred": [
        219,
        112,
        147,
        1
    ],
    "papayawhip": [
        255,
        239,
        213,
        1
    ],
    "peachpuff": [
        255,
        218,
        185,
        1
    ],
    "peru": [
        205,
        133,
        63,
        1
    ],
    "pink": [
        255,
        192,
        203,
        1
    ],
    "plum": [
        221,
        160,
        221,
        1
    ],
    "powderblue": [
        176,
        224,
        230,
        1
    ],
    "purple": [
        128,
        0,
        128,
        1
    ],
    "red": [
        255,
        0,
        0,
        1
    ],
    "rosybrown": [
        188,
        143,
        143,
        1
    ],
    "royalblue": [
        65,
        105,
        225,
        1
    ],
    "saddlebrown": [
        139,
        69,
        19,
        1
    ],
    "salmon": [
        250,
        128,
        114,
        1
    ],
    "sandybrown": [
        244,
        164,
        96,
        1
    ],
    "seagreen": [
        46,
        139,
        87,
        1
    ],
    "seashell": [
        255,
        245,
        238,
        1
    ],
    "sienna": [
        160,
        82,
        45,
        1
    ],
    "silver": [
        192,
        192,
        192,
        1
    ],
    "skyblue": [
        135,
        206,
        235,
        1
    ],
    "slateblue": [
        106,
        90,
        205,
        1
    ],
    "slategray": [
        112,
        128,
        144,
        1
    ],
    "slategrey": [
        112,
        128,
        144,
        1
    ],
    "snow": [
        255,
        250,
        250,
        1
    ],
    "springgreen": [
        0,
        255,
        127,
        1
    ],
    "steelblue": [
        70,
        130,
        180,
        1
    ],
    "tan": [
        210,
        180,
        140,
        1
    ],
    "teal": [
        0,
        128,
        128,
        1
    ],
    "thistle": [
        216,
        191,
        216,
        1
    ],
    "tomato": [
        255,
        99,
        71,
        1
    ],
    "turquoise": [
        64,
        224,
        208,
        1
    ],
    "violet": [
        238,
        130,
        238,
        1
    ],
    "wheat": [
        245,
        222,
        179,
        1
    ],
    "white": [
        255,
        255,
        255,
        1
    ],
    "whitesmoke": [
        245,
        245,
        245,
        1
    ],
    "yellow": [
        255,
        255,
        0,
        1
    ],
    "yellowgreen": [
        154,
        205,
        50,
        1
    ]
};
function $b1179c91b052e827$var$clampCssByte(i) {
    // Clamp to integer 0 .. 255.
    i = Math.round(i); // Seems to be what Chrome does (vs truncation).
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function $b1179c91b052e827$var$clampCssAngle(i) {
    // Clamp to integer 0 .. 360.
    i = Math.round(i); // Seems to be what Chrome does (vs truncation).
    return i < 0 ? 0 : i > 360 ? 360 : i;
}
function $b1179c91b052e827$var$clampCssFloat(f) {
    // Clamp to float 0.0 .. 1.0.
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function $b1179c91b052e827$var$parseCssInt(str) {
    // int or percentage.
    if (str.length && str.charAt(str.length - 1) === "%") return $b1179c91b052e827$var$clampCssByte(parseFloat(str) / 100 * 255);
    return $b1179c91b052e827$var$clampCssByte(parseInt(str, 10));
}
function $b1179c91b052e827$var$parseCssFloat(str) {
    // float or percentage.
    if (str.length && str.charAt(str.length - 1) === "%") return $b1179c91b052e827$var$clampCssFloat(parseFloat(str) / 100);
    return $b1179c91b052e827$var$clampCssFloat(parseFloat(str));
}
function $b1179c91b052e827$var$cssHueToRgb(m1, m2, h) {
    if (h < 0) h += 1;
    else if (h > 1) h -= 1;
    if (h * 6 < 1) return m1 + (m2 - m1) * h * 6;
    if (h * 2 < 1) return m2;
    if (h * 3 < 2) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    return m1;
}
function $b1179c91b052e827$var$lerpNumber(a, b, p) {
    return a + (b - a) * p;
}
function $b1179c91b052e827$var$setRgba(out, r, g, b, a) {
    out[0] = r;
    out[1] = g;
    out[2] = b;
    out[3] = a;
    return out;
}
function $b1179c91b052e827$var$copyRgba(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
var $b1179c91b052e827$var$colorCache = new $8f310e996ed18a8a$exports(20);
var $b1179c91b052e827$var$lastRemovedArr = null;
function $b1179c91b052e827$var$putToCache(colorStr, rgbaArr) {
    // Reuse removed array
    if ($b1179c91b052e827$var$lastRemovedArr) $b1179c91b052e827$var$copyRgba($b1179c91b052e827$var$lastRemovedArr, rgbaArr);
    $b1179c91b052e827$var$lastRemovedArr = $b1179c91b052e827$var$colorCache.put(colorStr, $b1179c91b052e827$var$lastRemovedArr || rgbaArr.slice());
}
/**
 * @param {string} colorStr
 * @param {Array.<number>} out
 * @return {Array.<number>}
 * @memberOf module:zrender/util/color
 */ function $b1179c91b052e827$var$parse(colorStr, rgbaArr) {
    if (!colorStr) return;
    rgbaArr = rgbaArr || [];
    var cached = $b1179c91b052e827$var$colorCache.get(colorStr);
    if (cached) return $b1179c91b052e827$var$copyRgba(rgbaArr, cached);
     // colorStr may be not string
    colorStr = colorStr + ""; // Remove all whitespace, not compliant, but should just be more accepting.
    var str = colorStr.replace(/ /g, "").toLowerCase(); // Color keywords (and transparent) lookup.
    if (str in $b1179c91b052e827$var$kCSSColorTable) {
        $b1179c91b052e827$var$copyRgba(rgbaArr, $b1179c91b052e827$var$kCSSColorTable[str]);
        $b1179c91b052e827$var$putToCache(colorStr, rgbaArr);
        return rgbaArr;
    } // #abc and #abc123 syntax.
    if (str.charAt(0) === "#") {
        if (str.length === 4) {
            var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.
            if (!(iv >= 0 && iv <= 0xfff)) {
                $b1179c91b052e827$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return; // Covers NaN.
            }
            $b1179c91b052e827$var$setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, 1);
            $b1179c91b052e827$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        } else if (str.length === 7) {
            var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.
            if (!(iv >= 0 && iv <= 0xffffff)) {
                $b1179c91b052e827$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return; // Covers NaN.
            }
            $b1179c91b052e827$var$setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, 1);
            $b1179c91b052e827$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        return;
    }
    var op = str.indexOf("(");
    var ep = str.indexOf(")");
    if (op !== -1 && ep + 1 === str.length) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(",");
        var alpha = 1; // To allow case fallthrough.
        switch(fname){
            case "rgba":
                if (params.length !== 4) {
                    $b1179c91b052e827$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                alpha = $b1179c91b052e827$var$parseCssFloat(params.pop());
            // jshint ignore:line
            // Fall through.
            case "rgb":
                if (params.length !== 3) {
                    $b1179c91b052e827$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $b1179c91b052e827$var$setRgba(rgbaArr, $b1179c91b052e827$var$parseCssInt(params[0]), $b1179c91b052e827$var$parseCssInt(params[1]), $b1179c91b052e827$var$parseCssInt(params[2]), alpha);
                $b1179c91b052e827$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case "hsla":
                if (params.length !== 4) {
                    $b1179c91b052e827$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                params[3] = $b1179c91b052e827$var$parseCssFloat(params[3]);
                $b1179c91b052e827$var$hsla2rgba(params, rgbaArr);
                $b1179c91b052e827$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case "hsl":
                if (params.length !== 3) {
                    $b1179c91b052e827$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $b1179c91b052e827$var$hsla2rgba(params, rgbaArr);
                $b1179c91b052e827$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            default:
                return;
        }
    }
    $b1179c91b052e827$var$setRgba(rgbaArr, 0, 0, 0, 1);
    return;
}
/**
 * @param {Array.<number>} hsla
 * @param {Array.<number>} rgba
 * @return {Array.<number>} rgba
 */ function $b1179c91b052e827$var$hsla2rgba(hsla, rgba) {
    var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360; // 0 .. 1
    // NOTE(deanm): According to the CSS spec s/l should only be
    // percentages, but we don't bother and let float or percentage.
    var s = $b1179c91b052e827$var$parseCssFloat(hsla[1]);
    var l = $b1179c91b052e827$var$parseCssFloat(hsla[2]);
    var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
    var m1 = l * 2 - m2;
    rgba = rgba || [];
    $b1179c91b052e827$var$setRgba(rgba, $b1179c91b052e827$var$clampCssByte($b1179c91b052e827$var$cssHueToRgb(m1, m2, h + 1 / 3) * 255), $b1179c91b052e827$var$clampCssByte($b1179c91b052e827$var$cssHueToRgb(m1, m2, h) * 255), $b1179c91b052e827$var$clampCssByte($b1179c91b052e827$var$cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
    if (hsla.length === 4) rgba[3] = hsla[3];
    return rgba;
}
/**
 * @param {Array.<number>} rgba
 * @return {Array.<number>} hsla
 */ function $b1179c91b052e827$var$rgba2hsla(rgba) {
    if (!rgba) return;
     // RGB from 0 to 255
    var R = rgba[0] / 255;
    var G = rgba[1] / 255;
    var B = rgba[2] / 255;
    var vMin = Math.min(R, G, B); // Min. value of RGB
    var vMax = Math.max(R, G, B); // Max. value of RGB
    var delta = vMax - vMin; // Delta RGB value
    var L = (vMax + vMin) / 2;
    var H;
    var S; // HSL results from 0 to 1
    if (delta === 0) {
        H = 0;
        S = 0;
    } else {
        if (L < 0.5) S = delta / (vMax + vMin);
        else S = delta / (2 - vMax - vMin);
        var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
        var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
        var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
        if (R === vMax) H = deltaB - deltaG;
        else if (G === vMax) H = 1 / 3 + deltaR - deltaB;
        else if (B === vMax) H = 2 / 3 + deltaG - deltaR;
        if (H < 0) H += 1;
        if (H > 1) H -= 1;
    }
    var hsla = [
        H * 360,
        S,
        L
    ];
    if (rgba[3] != null) hsla.push(rgba[3]);
    return hsla;
}
/**
 * @param {string} color
 * @param {number} level
 * @return {string}
 * @memberOf module:zrender/util/color
 */ function $b1179c91b052e827$var$lift(color, level) {
    var colorArr = $b1179c91b052e827$var$parse(color);
    if (colorArr) {
        for(var i = 0; i < 3; i++){
            if (level < 0) colorArr[i] = colorArr[i] * (1 - level) | 0;
            else colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
            if (colorArr[i] > 255) colorArr[i] = 255;
            else if (color[i] < 0) colorArr[i] = 0;
        }
        return $b1179c91b052e827$var$stringify(colorArr, colorArr.length === 4 ? "rgba" : "rgb");
    }
}
/**
 * @param {string} color
 * @return {string}
 * @memberOf module:zrender/util/color
 */ function $b1179c91b052e827$var$toHex(color) {
    var colorArr = $b1179c91b052e827$var$parse(color);
    if (colorArr) return (16777216 + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
}
/**
 * Map value to color. Faster than lerp methods because color is represented by rgba array.
 * @param {number} normalizedValue A float between 0 and 1.
 * @param {Array.<Array.<number>>} colors List of rgba color array
 * @param {Array.<number>} [out] Mapped gba color array
 * @return {Array.<number>} will be null/undefined if input illegal.
 */ function $b1179c91b052e827$var$fastLerp(normalizedValue, colors, out) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    out = out || [];
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = colors[leftIndex];
    var rightColor = colors[rightIndex];
    var dv = value - leftIndex;
    out[0] = $b1179c91b052e827$var$clampCssByte($b1179c91b052e827$var$lerpNumber(leftColor[0], rightColor[0], dv));
    out[1] = $b1179c91b052e827$var$clampCssByte($b1179c91b052e827$var$lerpNumber(leftColor[1], rightColor[1], dv));
    out[2] = $b1179c91b052e827$var$clampCssByte($b1179c91b052e827$var$lerpNumber(leftColor[2], rightColor[2], dv));
    out[3] = $b1179c91b052e827$var$clampCssFloat($b1179c91b052e827$var$lerpNumber(leftColor[3], rightColor[3], dv));
    return out;
}
/**
 * @deprecated
 */ var $b1179c91b052e827$var$fastMapToColor = $b1179c91b052e827$var$fastLerp;
/**
 * @param {number} normalizedValue A float between 0 and 1.
 * @param {Array.<string>} colors Color list.
 * @param {boolean=} fullOutput Default false.
 * @return {(string|Object)} Result color. If fullOutput,
 *                           return {color: ..., leftIndex: ..., rightIndex: ..., value: ...},
 * @memberOf module:zrender/util/color
 */ function $b1179c91b052e827$var$lerp(normalizedValue, colors, fullOutput) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = $b1179c91b052e827$var$parse(colors[leftIndex]);
    var rightColor = $b1179c91b052e827$var$parse(colors[rightIndex]);
    var dv = value - leftIndex;
    var color = $b1179c91b052e827$var$stringify([
        $b1179c91b052e827$var$clampCssByte($b1179c91b052e827$var$lerpNumber(leftColor[0], rightColor[0], dv)),
        $b1179c91b052e827$var$clampCssByte($b1179c91b052e827$var$lerpNumber(leftColor[1], rightColor[1], dv)),
        $b1179c91b052e827$var$clampCssByte($b1179c91b052e827$var$lerpNumber(leftColor[2], rightColor[2], dv)),
        $b1179c91b052e827$var$clampCssFloat($b1179c91b052e827$var$lerpNumber(leftColor[3], rightColor[3], dv))
    ], "rgba");
    return fullOutput ? {
        color: color,
        leftIndex: leftIndex,
        rightIndex: rightIndex,
        value: value
    } : color;
}
/**
 * @deprecated
 */ var $b1179c91b052e827$var$mapToColor = $b1179c91b052e827$var$lerp;
/**
 * @param {string} color
 * @param {number=} h 0 ~ 360, ignore when null.
 * @param {number=} s 0 ~ 1, ignore when null.
 * @param {number=} l 0 ~ 1, ignore when null.
 * @return {string} Color string in rgba format.
 * @memberOf module:zrender/util/color
 */ function $b1179c91b052e827$var$modifyHSL(color, h, s, l) {
    color = $b1179c91b052e827$var$parse(color);
    if (color) {
        color = $b1179c91b052e827$var$rgba2hsla(color);
        h != null && (color[0] = $b1179c91b052e827$var$clampCssAngle(h));
        s != null && (color[1] = $b1179c91b052e827$var$parseCssFloat(s));
        l != null && (color[2] = $b1179c91b052e827$var$parseCssFloat(l));
        return $b1179c91b052e827$var$stringify($b1179c91b052e827$var$hsla2rgba(color), "rgba");
    }
}
/**
 * @param {string} color
 * @param {number=} alpha 0 ~ 1
 * @return {string} Color string in rgba format.
 * @memberOf module:zrender/util/color
 */ function $b1179c91b052e827$var$modifyAlpha(color, alpha) {
    color = $b1179c91b052e827$var$parse(color);
    if (color && alpha != null) {
        color[3] = $b1179c91b052e827$var$clampCssFloat(alpha);
        return $b1179c91b052e827$var$stringify(color, "rgba");
    }
}
/**
 * @param {Array.<number>} arrColor like [12,33,44,0.4]
 * @param {string} type 'rgba', 'hsva', ...
 * @return {string} Result color. (If input illegal, return undefined).
 */ function $b1179c91b052e827$var$stringify(arrColor, type) {
    if (!arrColor || !arrColor.length) return;
    var colorStr = arrColor[0] + "," + arrColor[1] + "," + arrColor[2];
    if (type === "rgba" || type === "hsva" || type === "hsla") colorStr += "," + arrColor[3];
    return type + "(" + colorStr + ")";
}
$b1179c91b052e827$export$98e6a39c04603d36 = $b1179c91b052e827$var$parse;
$b1179c91b052e827$export$590e8b2c435046d9 = $b1179c91b052e827$var$lift;
$b1179c91b052e827$export$7ea66e3774a60b67 = $b1179c91b052e827$var$toHex;
$b1179c91b052e827$export$66cb3c0e9efc61c8 = $b1179c91b052e827$var$fastLerp;
$b1179c91b052e827$export$daa5a65daad5df58 = $b1179c91b052e827$var$fastMapToColor;
$b1179c91b052e827$export$3a89f8d6f6bf6c9f = $b1179c91b052e827$var$lerp;
$b1179c91b052e827$export$296e08242b78a3ec = $b1179c91b052e827$var$mapToColor;
$b1179c91b052e827$export$d898ae866e27bf18 = $b1179c91b052e827$var$modifyHSL;
$b1179c91b052e827$export$ab4754bf42583a26 = $b1179c91b052e827$var$modifyAlpha;
$b1179c91b052e827$export$fac44ee5b035f737 = $b1179c91b052e827$var$stringify;



var $ffa340c0956116a5$var$isArrayLike = $ec279652dd95c27b$export$1e2f57719e155213;
/**
 * @module echarts/animation/Animator
 */ var $ffa340c0956116a5$var$arraySlice = Array.prototype.slice;
function $ffa340c0956116a5$var$defaultGetter(target, key) {
    return target[key];
}
function $ffa340c0956116a5$var$defaultSetter(target, key, value) {
    target[key] = value;
}
/**
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} percent
 * @return {number}
 */ function $ffa340c0956116a5$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
/**
 * @param  {string} p0
 * @param  {string} p1
 * @param  {number} percent
 * @return {string}
 */ function $ffa340c0956116a5$var$interpolateString(p0, p1, percent) {
    return percent > 0.5 ? p1 : p0;
}
/**
 * @param  {Array} p0
 * @param  {Array} p1
 * @param  {number} percent
 * @param  {Array} out
 * @param  {number} arrDim
 */ function $ffa340c0956116a5$var$interpolateArray(p0, p1, percent, out, arrDim) {
    var len = p0.length;
    if (arrDim === 1) for(var i = 0; i < len; i++)out[i] = $ffa340c0956116a5$var$interpolateNumber(p0[i], p1[i], percent);
    else {
        var len2 = len && p0[0].length;
        for(var i = 0; i < len; i++)for(var j = 0; j < len2; j++)out[i][j] = $ffa340c0956116a5$var$interpolateNumber(p0[i][j], p1[i][j], percent);
    }
} // arr0 is source array, arr1 is target array.
// Do some preprocess to avoid error happened when interpolating from arr0 to arr1
function $ffa340c0956116a5$var$fillArr(arr0, arr1, arrDim) {
    var arr0Len = arr0.length;
    var arr1Len = arr1.length;
    if (arr0Len !== arr1Len) {
        // FIXME Not work for TypedArray
        var isPreviousLarger = arr0Len > arr1Len;
        if (isPreviousLarger) // Cut the previous
        arr0.length = arr1Len;
        else // Fill the previous
        for(var i = arr0Len; i < arr1Len; i++)arr0.push(arrDim === 1 ? arr1[i] : $ffa340c0956116a5$var$arraySlice.call(arr1[i]));
    } // Handling NaN value
    var len2 = arr0[0] && arr0[0].length;
    for(var i = 0; i < arr0.length; i++){
        if (arrDim === 1) {
            if (isNaN(arr0[i])) arr0[i] = arr1[i];
        } else {
            for(var j = 0; j < len2; j++)if (isNaN(arr0[i][j])) arr0[i][j] = arr1[i][j];
        }
    }
}
/**
 * @param  {Array} arr0
 * @param  {Array} arr1
 * @param  {number} arrDim
 * @return {boolean}
 */ function $ffa340c0956116a5$var$isArraySame(arr0, arr1, arrDim) {
    if (arr0 === arr1) return true;
    var len = arr0.length;
    if (len !== arr1.length) return false;
    if (arrDim === 1) for(var i = 0; i < len; i++){
        if (arr0[i] !== arr1[i]) return false;
    }
    else {
        var len2 = arr0[0].length;
        for(var i = 0; i < len; i++)for(var j = 0; j < len2; j++){
            if (arr0[i][j] !== arr1[i][j]) return false;
        }
    }
    return true;
}
/**
 * Catmull Rom interpolate array
 * @param  {Array} p0
 * @param  {Array} p1
 * @param  {Array} p2
 * @param  {Array} p3
 * @param  {number} t
 * @param  {number} t2
 * @param  {number} t3
 * @param  {Array} out
 * @param  {number} arrDim
 */ function $ffa340c0956116a5$var$catmullRomInterpolateArray(p0, p1, p2, p3, t, t2, t3, out, arrDim) {
    var len = p0.length;
    if (arrDim === 1) for(var i = 0; i < len; i++)out[i] = $ffa340c0956116a5$var$catmullRomInterpolate(p0[i], p1[i], p2[i], p3[i], t, t2, t3);
    else {
        var len2 = p0[0].length;
        for(var i = 0; i < len; i++)for(var j = 0; j < len2; j++)out[i][j] = $ffa340c0956116a5$var$catmullRomInterpolate(p0[i][j], p1[i][j], p2[i][j], p3[i][j], t, t2, t3);
    }
}
/**
 * Catmull Rom interpolate number
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @param  {number} t2
 * @param  {number} t3
 * @return {number}
 */ function $ffa340c0956116a5$var$catmullRomInterpolate(p0, p1, p2, p3, t, t2, t3) {
    var v0 = (p2 - p0) * 0.5;
    var v1 = (p3 - p1) * 0.5;
    return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
}
function $ffa340c0956116a5$var$cloneValue(value) {
    if ($ffa340c0956116a5$var$isArrayLike(value)) {
        var len = value.length;
        if ($ffa340c0956116a5$var$isArrayLike(value[0])) {
            var ret = [];
            for(var i = 0; i < len; i++)ret.push($ffa340c0956116a5$var$arraySlice.call(value[i]));
            return ret;
        }
        return $ffa340c0956116a5$var$arraySlice.call(value);
    }
    return value;
}
function $ffa340c0956116a5$var$rgba2String(rgba) {
    rgba[0] = Math.floor(rgba[0]);
    rgba[1] = Math.floor(rgba[1]);
    rgba[2] = Math.floor(rgba[2]);
    return "rgba(" + rgba.join(",") + ")";
}
function $ffa340c0956116a5$var$getArrayDim(keyframes) {
    var lastValue = keyframes[keyframes.length - 1].value;
    return $ffa340c0956116a5$var$isArrayLike(lastValue && lastValue[0]) ? 2 : 1;
}
function $ffa340c0956116a5$var$createTrackClip(animator, easing, oneTrackDone, keyframes, propName, forceAnimate) {
    var getter = animator._getter;
    var setter = animator._setter;
    var useSpline = easing === "spline";
    var trackLen = keyframes.length;
    if (!trackLen) return;
     // Guess data type
    var firstVal = keyframes[0].value;
    var isValueArray = $ffa340c0956116a5$var$isArrayLike(firstVal);
    var isValueColor = false;
    var isValueString = false; // For vertices morphing
    var arrDim = isValueArray ? $ffa340c0956116a5$var$getArrayDim(keyframes) : 0;
    var trackMaxTime; // Sort keyframe as ascending
    keyframes.sort(function(a, b) {
        return a.time - b.time;
    });
    trackMaxTime = keyframes[trackLen - 1].time; // Percents of each keyframe
    var kfPercents = []; // Value of each keyframe
    var kfValues = [];
    var prevValue = keyframes[0].value;
    var isAllValueEqual = true;
    for(var i = 0; i < trackLen; i++){
        kfPercents.push(keyframes[i].time / trackMaxTime); // Assume value is a color when it is a string
        var value = keyframes[i].value; // Check if value is equal, deep check if value is array
        if (!(isValueArray && $ffa340c0956116a5$var$isArraySame(value, prevValue, arrDim) || !isValueArray && value === prevValue)) isAllValueEqual = false;
        prevValue = value; // Try converting a string to a color array
        if (typeof value === "string") {
            var colorArray = $b1179c91b052e827$export$98e6a39c04603d36(value);
            if (colorArray) {
                value = colorArray;
                isValueColor = true;
            } else isValueString = true;
        }
        kfValues.push(value);
    }
    if (!forceAnimate && isAllValueEqual) return;
    var lastValue = kfValues[trackLen - 1]; // Polyfill array and NaN value
    for(var i = 0; i < trackLen - 1; i++){
        if (isValueArray) $ffa340c0956116a5$var$fillArr(kfValues[i], lastValue, arrDim);
        else if (isNaN(kfValues[i]) && !isNaN(lastValue) && !isValueString && !isValueColor) kfValues[i] = lastValue;
    }
    isValueArray && $ffa340c0956116a5$var$fillArr(getter(animator._target, propName), lastValue, arrDim); // Cache the key of last frame to speed up when
    // animation playback is sequency
    var lastFrame = 0;
    var lastFramePercent = 0;
    var start;
    var w;
    var p0;
    var p1;
    var p2;
    var p3;
    if (isValueColor) var rgba = [
        0,
        0,
        0,
        0
    ];
    var onframe = function(target, percent) {
        // Find the range keyframes
        // kf1-----kf2---------current--------kf3
        // find kf2 and kf3 and do interpolation
        var frame; // In the easing function like elasticOut, percent may less than 0
        if (percent < 0) frame = 0;
        else if (percent < lastFramePercent) {
            // Start from next key
            // PENDING start from lastFrame ?
            start = Math.min(lastFrame + 1, trackLen - 1);
            for(frame = start; frame >= 0; frame--){
                if (kfPercents[frame] <= percent) break;
            } // PENDING really need to do this ?
            frame = Math.min(frame, trackLen - 2);
        } else {
            for(frame = lastFrame; frame < trackLen; frame++){
                if (kfPercents[frame] > percent) break;
            }
            frame = Math.min(frame - 1, trackLen - 2);
        }
        lastFrame = frame;
        lastFramePercent = percent;
        var range = kfPercents[frame + 1] - kfPercents[frame];
        if (range === 0) return;
        else w = (percent - kfPercents[frame]) / range;
        if (useSpline) {
            p1 = kfValues[frame];
            p0 = kfValues[frame === 0 ? frame : frame - 1];
            p2 = kfValues[frame > trackLen - 2 ? trackLen - 1 : frame + 1];
            p3 = kfValues[frame > trackLen - 3 ? trackLen - 1 : frame + 2];
            if (isValueArray) $ffa340c0956116a5$var$catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, getter(target, propName), arrDim);
            else {
                var value;
                if (isValueColor) {
                    value = $ffa340c0956116a5$var$catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, rgba, 1);
                    value = $ffa340c0956116a5$var$rgba2String(rgba);
                } else if (isValueString) // String is step(0.5)
                return $ffa340c0956116a5$var$interpolateString(p1, p2, w);
                else value = $ffa340c0956116a5$var$catmullRomInterpolate(p0, p1, p2, p3, w, w * w, w * w * w);
                setter(target, propName, value);
            }
        } else if (isValueArray) $ffa340c0956116a5$var$interpolateArray(kfValues[frame], kfValues[frame + 1], w, getter(target, propName), arrDim);
        else {
            var value;
            if (isValueColor) {
                $ffa340c0956116a5$var$interpolateArray(kfValues[frame], kfValues[frame + 1], w, rgba, 1);
                value = $ffa340c0956116a5$var$rgba2String(rgba);
            } else if (isValueString) // String is step(0.5)
            return $ffa340c0956116a5$var$interpolateString(kfValues[frame], kfValues[frame + 1], w);
            else value = $ffa340c0956116a5$var$interpolateNumber(kfValues[frame], kfValues[frame + 1], w);
            setter(target, propName, value);
        }
    };
    var clip = new $18410b6a619c04ed$exports({
        target: animator._target,
        life: trackMaxTime,
        loop: animator._loop,
        delay: animator._delay,
        onframe: onframe,
        ondestroy: oneTrackDone
    });
    if (easing && easing !== "spline") clip.easing = easing;
    return clip;
}
/**
 * @alias module:zrender/animation/Animator
 * @constructor
 * @param {Object} target
 * @param {boolean} loop
 * @param {Function} getter
 * @param {Function} setter
 */ var $ffa340c0956116a5$var$Animator = function(target, loop, getter, setter) {
    this._tracks = {};
    this._target = target;
    this._loop = loop || false;
    this._getter = getter || $ffa340c0956116a5$var$defaultGetter;
    this._setter = setter || $ffa340c0956116a5$var$defaultSetter;
    this._clipCount = 0;
    this._delay = 0;
    this._doneList = [];
    this._onframeList = [];
    this._clipList = [];
};
$ffa340c0956116a5$var$Animator.prototype = {
    /**
   * Set Animation keyframe
   * @param  {number} time 关键帧时间，单位是ms
   * @param  {Object} props 关键帧的属性值，key-value表示
   * @return {module:zrender/animation/Animator}
   */ when: function(time, props) {
        var tracks = this._tracks;
        for(var propName in props){
            if (!props.hasOwnProperty(propName)) continue;
            if (!tracks[propName]) {
                tracks[propName] = []; // Invalid value
                var value = this._getter(this._target, propName);
                if (value == null) continue;
                 // If time is 0
                //  Then props is given initialize value
                // Else
                //  Initialize value from current prop value
                if (time !== 0) tracks[propName].push({
                    time: 0,
                    value: $ffa340c0956116a5$var$cloneValue(value)
                });
            }
            tracks[propName].push({
                time: time,
                value: props[propName]
            });
        }
        return this;
    },
    /**
   * 添加动画每一帧的回调函数
   * @param  {Function} callback
   * @return {module:zrender/animation/Animator}
   */ during: function(callback) {
        this._onframeList.push(callback);
        return this;
    },
    pause: function() {
        for(var i = 0; i < this._clipList.length; i++)this._clipList[i].pause();
        this._paused = true;
    },
    resume: function() {
        for(var i = 0; i < this._clipList.length; i++)this._clipList[i].resume();
        this._paused = false;
    },
    isPaused: function() {
        return !!this._paused;
    },
    _doneCallback: function() {
        // Clear all tracks
        this._tracks = {}; // Clear all clips
        this._clipList.length = 0;
        var doneList = this._doneList;
        var len = doneList.length;
        for(var i = 0; i < len; i++)doneList[i].call(this);
    },
    /**
   * Start the animation
   * @param  {string|Function} [easing]
   *         动画缓动函数，详见{@link module:zrender/animation/easing}
   * @param  {boolean} forceAnimate
   * @return {module:zrender/animation/Animator}
   */ start: function(easing, forceAnimate) {
        var self = this;
        var clipCount = 0;
        var oneTrackDone = function() {
            clipCount--;
            if (!clipCount) self._doneCallback();
        };
        var lastClip;
        for(var propName in this._tracks){
            if (!this._tracks.hasOwnProperty(propName)) continue;
            var clip = $ffa340c0956116a5$var$createTrackClip(this, easing, oneTrackDone, this._tracks[propName], propName, forceAnimate);
            if (clip) {
                this._clipList.push(clip);
                clipCount++; // If start after added to animation
                if (this.animation) this.animation.addClip(clip);
                lastClip = clip;
            }
        } // Add during callback on the last clip
        if (lastClip) {
            var oldOnFrame = lastClip.onframe;
            lastClip.onframe = function(target, percent) {
                oldOnFrame(target, percent);
                for(var i = 0; i < self._onframeList.length; i++)self._onframeList[i](target, percent);
            };
        } // This optimization will help the case that in the upper application
        // the view may be refreshed frequently, where animation will be
        // called repeatly but nothing changed.
        if (!clipCount) this._doneCallback();
        return this;
    },
    /**
   * Stop animation
   * @param {boolean} forwardToLast If move to last frame before stop
   */ stop: function(forwardToLast) {
        var clipList = this._clipList;
        var animation = this.animation;
        for(var i = 0; i < clipList.length; i++){
            var clip = clipList[i];
            if (forwardToLast) // Move to last frame before stop
            clip.onframe(this._target, 1);
            animation && animation.removeClip(clip);
        }
        clipList.length = 0;
    },
    /**
   * Set when animation delay starts
   * @param  {number} time 单位ms
   * @return {module:zrender/animation/Animator}
   */ delay: function(time) {
        this._delay = time;
        return this;
    },
    /**
   * Add callback for animation end
   * @param  {Function} cb
   * @return {module:zrender/animation/Animator}
   */ done: function(cb) {
        if (cb) this._doneList.push(cb);
        return this;
    },
    /**
   * @return {Array.<module:zrender/animation/Clip>}
   */ getClips: function() {
        return this._clipList;
    }
};
var $ffa340c0956116a5$var$_default = $ffa340c0956116a5$var$Animator;
$ffa340c0956116a5$exports = $ffa340c0956116a5$var$_default;


var $5067a17fa0db893f$exports = {};
var $2f7815d0a3a302c3$export$7cdcde344c85339c;
var $2f7815d0a3a302c3$export$508f096bfcdaac40;
var $2f7815d0a3a302c3$var$dpr = 1; // If in browser environment
if (typeof window !== "undefined") $2f7815d0a3a302c3$var$dpr = Math.max(window.devicePixelRatio || 1, 1);
/**
 * config默认配置项
 * @exports zrender/config
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 */ /**
 * Debug log mode:
 * 0: Do nothing, for release.
 * 1: console.error, for debug.
 */ var $2f7815d0a3a302c3$var$debugMode = 0; // retina 屏幕优化
var $2f7815d0a3a302c3$var$devicePixelRatio = $2f7815d0a3a302c3$var$dpr;
$2f7815d0a3a302c3$export$7cdcde344c85339c = $2f7815d0a3a302c3$var$debugMode;
$2f7815d0a3a302c3$export$508f096bfcdaac40 = $2f7815d0a3a302c3$var$devicePixelRatio;


var $5067a17fa0db893f$var$debugMode = $2f7815d0a3a302c3$export$7cdcde344c85339c;
var $5067a17fa0db893f$var$logError = function() {};
if ($5067a17fa0db893f$var$debugMode === 1) $5067a17fa0db893f$var$logError = console.error;
var $5067a17fa0db893f$var$_default = $5067a17fa0db893f$var$logError;
$5067a17fa0db893f$exports = $5067a17fa0db893f$var$_default;



var $286759ee96158d70$var$isString = $ec279652dd95c27b$export$844ec244b1367d54;
var $286759ee96158d70$var$isFunction = $ec279652dd95c27b$export$f6e2535fb5126e54;
var $286759ee96158d70$var$isObject = $ec279652dd95c27b$export$a6cdc56e425d0d0a;
var $286759ee96158d70$var$isArrayLike = $ec279652dd95c27b$export$1e2f57719e155213;
var $286759ee96158d70$var$indexOf = $ec279652dd95c27b$export$305f7d4e9d4624f2;
/**
 * @alias module:zrender/mixin/Animatable
 * @constructor
 */ var $286759ee96158d70$var$Animatable = function() {
    /**
   * @type {Array.<module:zrender/animation/Animator>}
   * @readOnly
   */ this.animators = [];
};
$286759ee96158d70$var$Animatable.prototype = {
    constructor: $286759ee96158d70$var$Animatable,
    /**
   * 动画
   *
   * @param {string} path The path to fetch value from object, like 'a.b.c'.
   * @param {boolean} [loop] Whether to loop animation.
   * @return {module:zrender/animation/Animator}
   * @example:
   *     el.animate('style', false)
   *         .when(1000, {x: 10} )
   *         .done(function(){ // Animation done })
   *         .start()
   */ animate: function(path, loop) {
        var target;
        var animatingShape = false;
        var el = this;
        var zr = this.__zr;
        if (path) {
            var pathSplitted = path.split(".");
            var prop = el; // If animating shape
            animatingShape = pathSplitted[0] === "shape";
            for(var i = 0, l = pathSplitted.length; i < l; i++){
                if (!prop) continue;
                prop = prop[pathSplitted[i]];
            }
            if (prop) target = prop;
        } else target = el;
        if (!target) {
            $5067a17fa0db893f$exports('Property "' + path + '" is not existed in element ' + el.id);
            return;
        }
        var animators = el.animators;
        var animator = new $ffa340c0956116a5$exports(target, loop);
        animator.during(function(target) {
            el.dirty(animatingShape);
        }).done(function() {
            // FIXME Animator will not be removed if use `Animator#stop` to stop animation
            animators.splice($286759ee96158d70$var$indexOf(animators, animator), 1);
        });
        animators.push(animator); // If animate after added to the zrender
        if (zr) zr.animation.addAnimator(animator);
        return animator;
    },
    /**
   * 停止动画
   * @param {boolean} forwardToLast If move to last frame before stop
   */ stopAnimation: function(forwardToLast) {
        var animators = this.animators;
        var len = animators.length;
        for(var i = 0; i < len; i++)animators[i].stop(forwardToLast);
        animators.length = 0;
        return this;
    },
    /**
   * Caution: this method will stop previous animation.
   * So do not use this method to one element twice before
   * animation starts, unless you know what you are doing.
   * @param {Object} target
   * @param {number} [time=500] Time in ms
   * @param {string} [easing='linear']
   * @param {number} [delay=0]
   * @param {Function} [callback]
   * @param {Function} [forceAnimate] Prevent stop animation and callback
   *        immediently when target values are the same as current values.
   *
   * @example
   *  // Animate position
   *  el.animateTo({
   *      position: [10, 10]
   *  }, function () { // done })
   *
   *  // Animate shape, style and position in 100ms, delayed 100ms, with cubicOut easing
   *  el.animateTo({
   *      shape: {
   *          width: 500
   *      },
   *      style: {
   *          fill: 'red'
   *      }
   *      position: [10, 10]
   *  }, 100, 100, 'cubicOut', function () { // done })
   */ // TODO Return animation key
    animateTo: function(target, time, delay, easing, callback, forceAnimate) {
        $286759ee96158d70$var$animateTo(this, target, time, delay, easing, callback, forceAnimate);
    },
    /**
   * Animate from the target state to current state.
   * The params and the return value are the same as `this.animateTo`.
   */ animateFrom: function(target, time, delay, easing, callback, forceAnimate) {
        $286759ee96158d70$var$animateTo(this, target, time, delay, easing, callback, forceAnimate, true);
    }
};
function $286759ee96158d70$var$animateTo(animatable, target, time, delay, easing, callback, forceAnimate, reverse) {
    // animateTo(target, time, easing, callback);
    if ($286759ee96158d70$var$isString(delay)) {
        callback = easing;
        easing = delay;
        delay = 0;
    } else if ($286759ee96158d70$var$isFunction(easing)) {
        callback = easing;
        easing = "linear";
        delay = 0;
    } else if ($286759ee96158d70$var$isFunction(delay)) {
        callback = delay;
        delay = 0;
    } else if ($286759ee96158d70$var$isFunction(time)) {
        callback = time;
        time = 500;
    } else if (!time) time = 500;
     // Stop all previous animations
    animatable.stopAnimation();
    $286759ee96158d70$var$animateToShallow(animatable, "", animatable, target, time, delay, reverse); // Animators may be removed immediately after start
    // if there is nothing to animate
    var animators = animatable.animators.slice();
    var count = animators.length;
    function done() {
        count--;
        if (!count) callback && callback();
    } // No animators. This should be checked before animators[i].start(),
    // because 'done' may be executed immediately if no need to animate.
    if (!count) callback && callback();
     // Start after all animators created
    // Incase any animator is done immediately when all animation properties are not changed
    for(var i = 0; i < animators.length; i++)animators[i].done(done).start(easing, forceAnimate);
}
/**
 * @param {string} path=''
 * @param {Object} source=animatable
 * @param {Object} target
 * @param {number} [time=500]
 * @param {number} [delay=0]
 * @param {boolean} [reverse] If `true`, animate
 *        from the `target` to current state.
 *
 * @example
 *  // Animate position
 *  el._animateToShallow({
 *      position: [10, 10]
 *  })
 *
 *  // Animate shape, style and position in 100ms, delayed 100ms
 *  el._animateToShallow({
 *      shape: {
 *          width: 500
 *      },
 *      style: {
 *          fill: 'red'
 *      }
 *      position: [10, 10]
 *  }, 100, 100)
 */ function $286759ee96158d70$var$animateToShallow(animatable, path, source, target, time, delay, reverse) {
    var objShallow = {};
    var propertyCount = 0;
    for(var name in target){
        if (!target.hasOwnProperty(name)) continue;
        if (source[name] != null) {
            if ($286759ee96158d70$var$isObject(target[name]) && !$286759ee96158d70$var$isArrayLike(target[name])) $286759ee96158d70$var$animateToShallow(animatable, path ? path + "." + name : name, source[name], target[name], time, delay, reverse);
            else {
                if (reverse) {
                    objShallow[name] = source[name];
                    $286759ee96158d70$var$setAttrByPath(animatable, path, name, target[name]);
                } else objShallow[name] = target[name];
                propertyCount++;
            }
        } else if (target[name] != null && !reverse) $286759ee96158d70$var$setAttrByPath(animatable, path, name, target[name]);
    }
    if (propertyCount > 0) animatable.animate(path, false).when(time == null ? 500 : time, objShallow).delay(delay || 0);
}
function $286759ee96158d70$var$setAttrByPath(el, path, name, value) {
    // Attr directly if not has property
    // FIXME, if some property not needed for element ?
    if (!path) el.attr(name, value);
    else {
        // Only support set shape or style
        var props = {};
        props[path] = {};
        props[path][name] = value;
        el.attr(props);
    }
}
var $286759ee96158d70$var$_default = $286759ee96158d70$var$Animatable;
$286759ee96158d70$exports = $286759ee96158d70$var$_default;



/**
 * @alias module:zrender/Element
 * @constructor
 * @extends {module:zrender/mixin/Animatable}
 * @extends {module:zrender/mixin/Transformable}
 * @extends {module:zrender/mixin/Eventful}
 */ var $e85cd217b6cf99d0$var$Element = function(opts) {
    // jshint ignore:line
    $af5c198eb02e5120$exports.call(this, opts);
    $b7a44647f5b5bfa5$exports.call(this, opts);
    $286759ee96158d70$exports.call(this, opts);
    /**
   * 画布元素ID
   * @type {string}
   */ this.id = opts.id || $b2a309a7eafc27fc$exports();
};
$e85cd217b6cf99d0$var$Element.prototype = {
    /**
   * 元素类型
   * Element type
   * @type {string}
   */ type: "element",
    /**
   * 元素名字
   * Element name
   * @type {string}
   */ name: "",
    /**
   * ZRender 实例对象，会在 element 添加到 zrender 实例中后自动赋值
   * ZRender instance will be assigned when element is associated with zrender
   * @name module:/zrender/Element#__zr
   * @type {module:zrender/ZRender}
   */ __zr: null,
    /**
   * 图形是否忽略，为true时忽略图形的绘制以及事件触发
   * If ignore drawing and events of the element object
   * @name module:/zrender/Element#ignore
   * @type {boolean}
   * @default false
   */ ignore: false,
    /**
   * 用于裁剪的路径(shape)，所有 Group 内的路径在绘制时都会被这个路径裁剪
   * 该路径会继承被裁减对象的变换
   * @type {module:zrender/graphic/Path}
   * @see http://www.w3.org/TR/2dcontext/#clipping-region
   * @readOnly
   */ clipPath: null,
    /**
   * 是否是 Group
   * @type {boolean}
   */ isGroup: false,
    /**
   * Drift element
   * @param  {number} dx dx on the global space
   * @param  {number} dy dy on the global space
   */ drift: function(dx, dy) {
        switch(this.draggable){
            case "horizontal":
                dy = 0;
                break;
            case "vertical":
                dx = 0;
                break;
        }
        var m = this.transform;
        if (!m) m = this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        m[4] += dx;
        m[5] += dy;
        this.decomposeTransform();
        this.dirty(false);
    },
    /**
   * Hook before update
   */ beforeUpdate: function() {},
    /**
   * Hook after update
   */ afterUpdate: function() {},
    /**
   * Update each frame
   */ update: function() {
        this.updateTransform();
    },
    /**
   * @param  {Function} cb
   * @param  {}   context
   */ traverse: function(cb, context) {},
    /**
   * @protected
   */ attrKV: function(key, value) {
        if (key === "position" || key === "scale" || key === "origin") // Copy the array
        {
            if (value) {
                var target = this[key];
                if (!target) target = this[key] = [];
                target[0] = value[0];
                target[1] = value[1];
            }
        } else this[key] = value;
    },
    /**
   * Hide the element
   */ hide: function() {
        this.ignore = true;
        this.__zr && this.__zr.refresh();
    },
    /**
   * Show the element
   */ show: function() {
        this.ignore = false;
        this.__zr && this.__zr.refresh();
    },
    /**
   * @param {string|Object} key
   * @param {*} value
   */ attr: function(key, value) {
        if (typeof key === "string") this.attrKV(key, value);
        else if ($ec279652dd95c27b$export$a6cdc56e425d0d0a(key)) {
            for(var name in key)if (key.hasOwnProperty(name)) this.attrKV(name, key[name]);
        }
        this.dirty(false);
        return this;
    },
    /**
   * @param {module:zrender/graphic/Path} clipPath
   */ setClipPath: function(clipPath) {
        var zr = this.__zr;
        if (zr) clipPath.addSelfToZr(zr);
         // Remove previous clip path
        if (this.clipPath && this.clipPath !== clipPath) this.removeClipPath();
        this.clipPath = clipPath;
        clipPath.__zr = zr;
        clipPath.__clipTarget = this;
        this.dirty(false);
    },
    /**
   */ removeClipPath: function() {
        var clipPath = this.clipPath;
        if (clipPath) {
            if (clipPath.__zr) clipPath.removeSelfFromZr(clipPath.__zr);
            clipPath.__zr = null;
            clipPath.__clipTarget = null;
            this.clipPath = null;
            this.dirty(false);
        }
    },
    /**
   * Add self from zrender instance.
   * Not recursively because it will be invoked when element added to storage.
   * @param {module:zrender/ZRender} zr
   */ addSelfToZr: function(zr) {
        this.__zr = zr; // 添加动画
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.addAnimator(animators[i]);
        if (this.clipPath) this.clipPath.addSelfToZr(zr);
    },
    /**
   * Remove self from zrender instance.
   * Not recursively because it will be invoked when element added to storage.
   * @param {module:zrender/ZRender} zr
   */ removeSelfFromZr: function(zr) {
        this.__zr = null; // 移除动画
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.removeAnimator(animators[i]);
        if (this.clipPath) this.clipPath.removeSelfFromZr(zr);
    }
};
$ec279652dd95c27b$export$e36fc9d62a853069($e85cd217b6cf99d0$var$Element, $286759ee96158d70$exports);
$ec279652dd95c27b$export$e36fc9d62a853069($e85cd217b6cf99d0$var$Element, $af5c198eb02e5120$exports);
$ec279652dd95c27b$export$e36fc9d62a853069($e85cd217b6cf99d0$var$Element, $b7a44647f5b5bfa5$exports);
var $e85cd217b6cf99d0$var$_default = $e85cd217b6cf99d0$var$Element;
$e85cd217b6cf99d0$exports = $e85cd217b6cf99d0$var$_default;


var $33e4fae744d34798$exports = {};


/**
 * @module echarts/core/BoundingRect
 */ var $33e4fae744d34798$var$v2ApplyTransform = $9eb63d101f3bcd79$export$9f9dcb98c894b623;
var $33e4fae744d34798$var$mathMin = Math.min;
var $33e4fae744d34798$var$mathMax = Math.max;
/**
 * @alias module:echarts/core/BoundingRect
 */ function $33e4fae744d34798$var$BoundingRect(x, y, width, height) {
    if (width < 0) {
        x = x + width;
        width = -width;
    }
    if (height < 0) {
        y = y + height;
        height = -height;
    }
    /**
   * @type {number}
   */ this.x = x;
    /**
   * @type {number}
   */ this.y = y;
    /**
   * @type {number}
   */ this.width = width;
    /**
   * @type {number}
   */ this.height = height;
}
$33e4fae744d34798$var$BoundingRect.prototype = {
    constructor: $33e4fae744d34798$var$BoundingRect,
    /**
   * @param {module:echarts/core/BoundingRect} other
   */ union: function(other) {
        var x = $33e4fae744d34798$var$mathMin(other.x, this.x);
        var y = $33e4fae744d34798$var$mathMin(other.y, this.y);
        this.width = $33e4fae744d34798$var$mathMax(other.x + other.width, this.x + this.width) - x;
        this.height = $33e4fae744d34798$var$mathMax(other.y + other.height, this.y + this.height) - y;
        this.x = x;
        this.y = y;
    },
    /**
   * @param {Array.<number>} m
   * @methods
   */ applyTransform: function() {
        var lt = [];
        var rb = [];
        var lb = [];
        var rt = [];
        return function(m) {
            // In case usage like this
            // el.getBoundingRect().applyTransform(el.transform)
            // And element has no transform
            if (!m) return;
            lt[0] = lb[0] = this.x;
            lt[1] = rt[1] = this.y;
            rb[0] = rt[0] = this.x + this.width;
            rb[1] = lb[1] = this.y + this.height;
            $33e4fae744d34798$var$v2ApplyTransform(lt, lt, m);
            $33e4fae744d34798$var$v2ApplyTransform(rb, rb, m);
            $33e4fae744d34798$var$v2ApplyTransform(lb, lb, m);
            $33e4fae744d34798$var$v2ApplyTransform(rt, rt, m);
            this.x = $33e4fae744d34798$var$mathMin(lt[0], rb[0], lb[0], rt[0]);
            this.y = $33e4fae744d34798$var$mathMin(lt[1], rb[1], lb[1], rt[1]);
            var maxX = $33e4fae744d34798$var$mathMax(lt[0], rb[0], lb[0], rt[0]);
            var maxY = $33e4fae744d34798$var$mathMax(lt[1], rb[1], lb[1], rt[1]);
            this.width = maxX - this.x;
            this.height = maxY - this.y;
        };
    }(),
    /**
   * Calculate matrix of transforming from self to target rect
   * @param  {module:zrender/core/BoundingRect} b
   * @return {Array.<number>}
   */ calculateTransform: function(b) {
        var a = this;
        var sx = b.width / a.width;
        var sy = b.height / a.height;
        var m = $6c6dd9610ba660f0$export$185802fd694ee1f5(); // 矩阵右乘
        $6c6dd9610ba660f0$export$d73ee8ef04f5226a(m, m, [
            -a.x,
            -a.y
        ]);
        $6c6dd9610ba660f0$export$dcdf75081b88279d(m, m, [
            sx,
            sy
        ]);
        $6c6dd9610ba660f0$export$d73ee8ef04f5226a(m, m, [
            b.x,
            b.y
        ]);
        return m;
    },
    /**
   * @param {(module:echarts/core/BoundingRect|Object)} b
   * @return {boolean}
   */ intersect: function(b) {
        if (!b) return false;
        if (!(b instanceof $33e4fae744d34798$var$BoundingRect)) // Normalize negative width/height.
        b = $33e4fae744d34798$var$BoundingRect.create(b);
        var a = this;
        var ax0 = a.x;
        var ax1 = a.x + a.width;
        var ay0 = a.y;
        var ay1 = a.y + a.height;
        var bx0 = b.x;
        var bx1 = b.x + b.width;
        var by0 = b.y;
        var by1 = b.y + b.height;
        return !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
    },
    contain: function(x, y) {
        var rect = this;
        return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
    },
    /**
   * @return {module:echarts/core/BoundingRect}
   */ clone: function() {
        return new $33e4fae744d34798$var$BoundingRect(this.x, this.y, this.width, this.height);
    },
    /**
   * Copy from another rect
   */ copy: function(other) {
        this.x = other.x;
        this.y = other.y;
        this.width = other.width;
        this.height = other.height;
    },
    plain: function() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    }
};
/**
 * @param {Object|module:zrender/core/BoundingRect} rect
 * @param {number} rect.x
 * @param {number} rect.y
 * @param {number} rect.width
 * @param {number} rect.height
 * @return {module:zrender/core/BoundingRect}
 */ $33e4fae744d34798$var$BoundingRect.create = function(rect) {
    return new $33e4fae744d34798$var$BoundingRect(rect.x, rect.y, rect.width, rect.height);
};
var $33e4fae744d34798$var$_default = $33e4fae744d34798$var$BoundingRect;
$33e4fae744d34798$exports = $33e4fae744d34798$var$_default;


/**
 * Group是一个容器，可以插入子节点，Group的变换也会被应用到子节点上
 * @module zrender/graphic/Group
 * @example
 *     var Group = require('zrender/container/Group');
 *     var Circle = require('zrender/graphic/shape/Circle');
 *     var g = new Group();
 *     g.position[0] = 100;
 *     g.position[1] = 100;
 *     g.add(new Circle({
 *         style: {
 *             x: 100,
 *             y: 100,
 *             r: 20,
 *         }
 *     }));
 *     zr.add(g);
 */ /**
 * @alias module:zrender/graphic/Group
 * @constructor
 * @extends module:zrender/mixin/Transformable
 * @extends module:zrender/mixin/Eventful
 */ var $48aa8d5160ffcc64$var$Group = function(opts) {
    opts = opts || {};
    $e85cd217b6cf99d0$exports.call(this, opts);
    for(var key in opts)if (opts.hasOwnProperty(key)) this[key] = opts[key];
    this._children = [];
    this.__storage = null;
    this.__dirty = true;
};
$48aa8d5160ffcc64$var$Group.prototype = {
    constructor: $48aa8d5160ffcc64$var$Group,
    isGroup: true,
    /**
   * @type {string}
   */ type: "group",
    /**
   * 所有子孙元素是否响应鼠标事件
   * @name module:/zrender/container/Group#silent
   * @type {boolean}
   * @default false
   */ silent: false,
    /**
   * @return {Array.<module:zrender/Element>}
   */ children: function() {
        return this._children.slice();
    },
    /**
   * 获取指定 index 的儿子节点
   * @param  {number} idx
   * @return {module:zrender/Element}
   */ childAt: function(idx) {
        return this._children[idx];
    },
    /**
   * 获取指定名字的儿子节点
   * @param  {string} name
   * @return {module:zrender/Element}
   */ childOfName: function(name) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            if (children[i].name === name) return children[i];
        }
    },
    /**
   * @return {number}
   */ childCount: function() {
        return this._children.length;
    },
    /**
   * 添加子节点到最后
   * @param {module:zrender/Element} child
   */ add: function(child) {
        if (child && child !== this && child.parent !== this) {
            this._children.push(child);
            this._doAdd(child);
        }
        return this;
    },
    /**
   * 添加子节点在 nextSibling 之前
   * @param {module:zrender/Element} child
   * @param {module:zrender/Element} nextSibling
   */ addBefore: function(child, nextSibling) {
        if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
            var children = this._children;
            var idx = children.indexOf(nextSibling);
            if (idx >= 0) {
                children.splice(idx, 0, child);
                this._doAdd(child);
            }
        }
        return this;
    },
    _doAdd: function(child) {
        if (child.parent) child.parent.remove(child);
        child.parent = this;
        var storage = this.__storage;
        var zr = this.__zr;
        if (storage && storage !== child.__storage) {
            storage.addToStorage(child);
            if (child instanceof $48aa8d5160ffcc64$var$Group) child.addChildrenToStorage(storage);
        }
        zr && zr.refresh();
    },
    /**
   * 移除子节点
   * @param {module:zrender/Element} child
   */ remove: function(child) {
        var zr = this.__zr;
        var storage = this.__storage;
        var children = this._children;
        var idx = $ec279652dd95c27b$export$305f7d4e9d4624f2(children, child);
        if (idx < 0) return this;
        children.splice(idx, 1);
        child.parent = null;
        if (storage) {
            storage.delFromStorage(child);
            if (child instanceof $48aa8d5160ffcc64$var$Group) child.delChildrenFromStorage(storage);
        }
        zr && zr.refresh();
        return this;
    },
    /**
   * 移除所有子节点
   */ removeAll: function() {
        var children = this._children;
        var storage = this.__storage;
        var child;
        var i;
        for(i = 0; i < children.length; i++){
            child = children[i];
            if (storage) {
                storage.delFromStorage(child);
                if (child instanceof $48aa8d5160ffcc64$var$Group) child.delChildrenFromStorage(storage);
            }
            child.parent = null;
        }
        children.length = 0;
        return this;
    },
    /**
   * 遍历所有子节点
   * @param  {Function} cb
   * @param  {}   context
   */ eachChild: function(cb, context) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            cb.call(context, child, i);
        }
        return this;
    },
    /**
   * 深度优先遍历所有子孙节点
   * @param  {Function} cb
   * @param  {}   context
   */ traverse: function(cb, context) {
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            cb.call(context, child);
            if (child.type === "group") child.traverse(cb, context);
        }
        return this;
    },
    addChildrenToStorage: function(storage) {
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            storage.addToStorage(child);
            if (child instanceof $48aa8d5160ffcc64$var$Group) child.addChildrenToStorage(storage);
        }
    },
    delChildrenFromStorage: function(storage) {
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            storage.delFromStorage(child);
            if (child instanceof $48aa8d5160ffcc64$var$Group) child.delChildrenFromStorage(storage);
        }
    },
    dirty: function() {
        this.__dirty = true;
        this.__zr && this.__zr.refresh();
        return this;
    },
    /**
   * @return {module:zrender/core/BoundingRect}
   */ getBoundingRect: function(includeChildren) {
        // TODO Caching
        var rect = null;
        var tmpRect = new $33e4fae744d34798$exports(0, 0, 0, 0);
        var children = includeChildren || this._children;
        var tmpMat = [];
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (child.ignore || child.invisible) continue;
            var childRect = child.getBoundingRect();
            var transform = child.getLocalTransform(tmpMat); // TODO
            // The boundingRect cacluated by transforming original
            // rect may be bigger than the actual bundingRect when rotation
            // is used. (Consider a circle rotated aginst its center, where
            // the actual boundingRect should be the same as that not be
            // rotated.) But we can not find better approach to calculate
            // actual boundingRect yet, considering performance.
            if (transform) {
                tmpRect.copy(childRect);
                tmpRect.applyTransform(transform);
                rect = rect || tmpRect.clone();
                rect.union(tmpRect);
            } else {
                rect = rect || childRect.clone();
                rect.union(childRect);
            }
        }
        return rect || tmpRect;
    }
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($48aa8d5160ffcc64$var$Group, $e85cd217b6cf99d0$exports);
var $48aa8d5160ffcc64$var$_default = $48aa8d5160ffcc64$var$Group;
$48aa8d5160ffcc64$exports = $48aa8d5160ffcc64$var$_default;


var $7f3d4243ceebe2b3$exports = {};
// https://github.com/mziccard/node-timsort
var $7f3d4243ceebe2b3$var$DEFAULT_MIN_MERGE = 32;
var $7f3d4243ceebe2b3$var$DEFAULT_MIN_GALLOPING = 7;
var $7f3d4243ceebe2b3$var$DEFAULT_TMP_STORAGE_LENGTH = 256;
function $7f3d4243ceebe2b3$var$minRunLength(n) {
    var r = 0;
    while(n >= $7f3d4243ceebe2b3$var$DEFAULT_MIN_MERGE){
        r |= n & 1;
        n >>= 1;
    }
    return n + r;
}
function $7f3d4243ceebe2b3$var$makeAscendingRun(array, lo, hi, compare) {
    var runHi = lo + 1;
    if (runHi === hi) return 1;
    if (compare(array[runHi++], array[lo]) < 0) {
        while(runHi < hi && compare(array[runHi], array[runHi - 1]) < 0)runHi++;
        $7f3d4243ceebe2b3$var$reverseRun(array, lo, runHi);
    } else while(runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0)runHi++;
    return runHi - lo;
}
function $7f3d4243ceebe2b3$var$reverseRun(array, lo, hi) {
    hi--;
    while(lo < hi){
        var t = array[lo];
        array[lo++] = array[hi];
        array[hi--] = t;
    }
}
function $7f3d4243ceebe2b3$var$binaryInsertionSort(array, lo, hi, start, compare) {
    if (start === lo) start++;
    for(; start < hi; start++){
        var pivot = array[start];
        var left = lo;
        var right = start;
        var mid;
        while(left < right){
            mid = left + right >>> 1;
            if (compare(pivot, array[mid]) < 0) right = mid;
            else left = mid + 1;
        }
        var n = start - left;
        switch(n){
            case 3:
                array[left + 3] = array[left + 2];
            case 2:
                array[left + 2] = array[left + 1];
            case 1:
                array[left + 1] = array[left];
                break;
            default:
                while(n > 0){
                    array[left + n] = array[left + n - 1];
                    n--;
                }
        }
        array[left] = pivot;
    }
}
function $7f3d4243ceebe2b3$var$gallopLeft(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) > 0) {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) > 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    } else {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) <= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) > 0) lastOffset = m + 1;
        else offset = m;
    }
    return offset;
}
function $7f3d4243ceebe2b3$var$gallopRight(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) < 0) {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) < 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    } else {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) >= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) < 0) offset = m;
        else lastOffset = m + 1;
    }
    return offset;
}
function $7f3d4243ceebe2b3$var$TimSort(array, compare) {
    var minGallop = $7f3d4243ceebe2b3$var$DEFAULT_MIN_GALLOPING;
    var length = 0;
    var tmpStorageLength = $7f3d4243ceebe2b3$var$DEFAULT_TMP_STORAGE_LENGTH;
    var stackLength = 0;
    var runStart;
    var runLength;
    var stackSize = 0;
    length = array.length;
    if (length < 2 * $7f3d4243ceebe2b3$var$DEFAULT_TMP_STORAGE_LENGTH) tmpStorageLength = length >>> 1;
    var tmp = [];
    stackLength = length < 120 ? 5 : length < 1542 ? 10 : length < 119151 ? 19 : 40;
    runStart = [];
    runLength = [];
    function pushRun(_runStart, _runLength) {
        runStart[stackSize] = _runStart;
        runLength[stackSize] = _runLength;
        stackSize += 1;
    }
    function mergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
                if (runLength[n - 1] < runLength[n + 1]) n--;
            } else if (runLength[n] > runLength[n + 1]) break;
            mergeAt(n);
        }
    }
    function forceMergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n > 0 && runLength[n - 1] < runLength[n + 1]) n--;
            mergeAt(n);
        }
    }
    function mergeAt(i) {
        var start1 = runStart[i];
        var length1 = runLength[i];
        var start2 = runStart[i + 1];
        var length2 = runLength[i + 1];
        runLength[i] = length1 + length2;
        if (i === stackSize - 3) {
            runStart[i + 1] = runStart[i + 2];
            runLength[i + 1] = runLength[i + 2];
        }
        stackSize--;
        var k = $7f3d4243ceebe2b3$var$gallopRight(array[start2], array, start1, length1, 0, compare);
        start1 += k;
        length1 -= k;
        if (length1 === 0) return;
        length2 = $7f3d4243ceebe2b3$var$gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
        if (length2 === 0) return;
        if (length1 <= length2) mergeLow(start1, length1, start2, length2);
        else mergeHigh(start1, length1, start2, length2);
    }
    function mergeLow(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length1; i++)tmp[i] = array[start1 + i];
        var cursor1 = 0;
        var cursor2 = start2;
        var dest = start1;
        array[dest++] = array[cursor2++];
        if (--length2 === 0) {
            for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
            return;
        }
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
            return;
        }
        var _minGallop = minGallop;
        var count1;
        var count2;
        var exit;
        while(true){
            count1 = 0;
            count2 = 0;
            exit = false;
            do if (compare(array[cursor2], tmp[cursor1]) < 0) {
                array[dest++] = array[cursor2++];
                count2++;
                count1 = 0;
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest++] = tmp[cursor1++];
                count1++;
                count2 = 0;
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = $7f3d4243ceebe2b3$var$gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                if (count1 !== 0) {
                    for(i = 0; i < count1; i++)array[dest + i] = tmp[cursor1 + i];
                    dest += count1;
                    cursor1 += count1;
                    length1 -= count1;
                    if (length1 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = array[cursor2++];
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
                count2 = $7f3d4243ceebe2b3$var$gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                if (count2 !== 0) {
                    for(i = 0; i < count2; i++)array[dest + i] = array[cursor2 + i];
                    dest += count2;
                    cursor2 += count2;
                    length2 -= count2;
                    if (length2 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = tmp[cursor1++];
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $7f3d4243ceebe2b3$var$DEFAULT_MIN_GALLOPING || count2 >= $7f3d4243ceebe2b3$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        minGallop < 1 && (minGallop = 1);
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
        } else if (length1 === 0) throw new Error(); // throw new Error('mergeLow preconditions were not respected');
        else for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
    }
    function mergeHigh(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length2; i++)tmp[i] = array[start2 + i];
        var cursor1 = start1 + length1 - 1;
        var cursor2 = length2 - 1;
        var dest = start2 + length2 - 1;
        var customCursor = 0;
        var customDest = 0;
        array[dest--] = array[cursor1--];
        if (--length1 === 0) {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
            return;
        }
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
            return;
        }
        var _minGallop = minGallop;
        while(true){
            var count1 = 0;
            var count2 = 0;
            var exit = false;
            do if (compare(tmp[cursor2], array[cursor1]) < 0) {
                array[dest--] = array[cursor1--];
                count1++;
                count2 = 0;
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest--] = tmp[cursor2--];
                count2++;
                count1 = 0;
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = length1 - $7f3d4243ceebe2b3$var$gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                if (count1 !== 0) {
                    dest -= count1;
                    cursor1 -= count1;
                    length1 -= count1;
                    customDest = dest + 1;
                    customCursor = cursor1 + 1;
                    for(i = count1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                    if (length1 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = tmp[cursor2--];
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
                count2 = length2 - $7f3d4243ceebe2b3$var$gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                if (count2 !== 0) {
                    dest -= count2;
                    cursor2 -= count2;
                    length2 -= count2;
                    customDest = dest + 1;
                    customCursor = cursor2 + 1;
                    for(i = 0; i < count2; i++)array[customDest + i] = tmp[customCursor + i];
                    if (length2 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = array[cursor1--];
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $7f3d4243ceebe2b3$var$DEFAULT_MIN_GALLOPING || count2 >= $7f3d4243ceebe2b3$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        if (minGallop < 1) minGallop = 1;
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
        } else if (length2 === 0) throw new Error(); // throw new Error('mergeHigh preconditions were not respected');
        else {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
        }
    }
    this.mergeRuns = mergeRuns;
    this.forceMergeRuns = forceMergeRuns;
    this.pushRun = pushRun;
}
function $7f3d4243ceebe2b3$var$sort(array, compare, lo, hi) {
    if (!lo) lo = 0;
    if (!hi) hi = array.length;
    var remaining = hi - lo;
    if (remaining < 2) return;
    var runLength = 0;
    if (remaining < $7f3d4243ceebe2b3$var$DEFAULT_MIN_MERGE) {
        runLength = $7f3d4243ceebe2b3$var$makeAscendingRun(array, lo, hi, compare);
        $7f3d4243ceebe2b3$var$binaryInsertionSort(array, lo, hi, lo + runLength, compare);
        return;
    }
    var ts = new $7f3d4243ceebe2b3$var$TimSort(array, compare);
    var minRun = $7f3d4243ceebe2b3$var$minRunLength(remaining);
    do {
        runLength = $7f3d4243ceebe2b3$var$makeAscendingRun(array, lo, hi, compare);
        if (runLength < minRun) {
            var force = remaining;
            if (force > minRun) force = minRun;
            $7f3d4243ceebe2b3$var$binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
            runLength = force;
        }
        ts.pushRun(lo, runLength);
        ts.mergeRuns();
        remaining -= runLength;
        lo += runLength;
    }while (remaining !== 0);
    ts.forceMergeRuns();
}
$7f3d4243ceebe2b3$exports = $7f3d4243ceebe2b3$var$sort;


// Use timsort because in most case elements are partially sorted
// https://jsfiddle.net/pissang/jr4x7mdm/8/
function $cf128beaa1ab720c$var$shapeCompareFunc(a, b) {
    if (a.zlevel === b.zlevel) {
        if (a.z === b.z) // if (a.z2 === b.z2) {
        //     // FIXME Slow has renderidx compare
        //     // http://stackoverflow.com/questions/20883421/sorting-in-javascript-should-every-compare-function-have-a-return-0-statement
        //     // https://github.com/v8/v8/blob/47cce544a31ed5577ffe2963f67acb4144ee0232/src/js/array.js#L1012
        //     return a.__renderidx - b.__renderidx;
        // }
        return a.z2 - b.z2;
        return a.z - b.z;
    }
    return a.zlevel - b.zlevel;
}
/**
 * 内容仓库 (M)
 * @alias module:zrender/Storage
 * @constructor
 */ var $cf128beaa1ab720c$var$Storage = function() {
    // jshint ignore:line
    this._roots = [];
    this._displayList = [];
    this._displayListLen = 0;
};
$cf128beaa1ab720c$var$Storage.prototype = {
    constructor: $cf128beaa1ab720c$var$Storage,
    /**
   * @param  {Function} cb
   *
   */ traverse: function(cb, context) {
        for(var i = 0; i < this._roots.length; i++)this._roots[i].traverse(cb, context);
    },
    /**
   * 返回所有图形的绘制队列
   * @param {boolean} [update=false] 是否在返回前更新该数组
   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组, 在 update 为 true 的时候有效
   *
   * 详见{@link module:zrender/graphic/Displayable.prototype.updateDisplayList}
   * @return {Array.<module:zrender/graphic/Displayable>}
   */ getDisplayList: function(update, includeIgnore) {
        includeIgnore = includeIgnore || false;
        if (update) this.updateDisplayList(includeIgnore);
        return this._displayList;
    },
    /**
   * 更新图形的绘制队列。
   * 每次绘制前都会调用，该方法会先深度优先遍历整个树，更新所有Group和Shape的变换并且把所有可见的Shape保存到数组中，
   * 最后根据绘制的优先级（zlevel > z > 插入顺序）排序得到绘制队列
   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组
   */ updateDisplayList: function(includeIgnore) {
        this._displayListLen = 0;
        var roots = this._roots;
        var displayList = this._displayList;
        for(var i = 0, len = roots.length; i < len; i++)this._updateAndAddDisplayable(roots[i], null, includeIgnore);
        displayList.length = this._displayListLen;
        $27ac1413ecc67076$exports.canvasSupported && $7f3d4243ceebe2b3$exports(displayList, $cf128beaa1ab720c$var$shapeCompareFunc);
    },
    _updateAndAddDisplayable: function(el, clipPaths, includeIgnore) {
        if (el.ignore && !includeIgnore) return;
        el.beforeUpdate();
        if (el.__dirty) el.update();
        el.afterUpdate();
        var userSetClipPath = el.clipPath;
        if (userSetClipPath) {
            // FIXME 效率影响
            if (clipPaths) clipPaths = clipPaths.slice();
            else clipPaths = [];
            var currentClipPath = userSetClipPath;
            var parentClipPath = el; // Recursively add clip path
            while(currentClipPath){
                // clipPath 的变换是基于使用这个 clipPath 的元素
                currentClipPath.parent = parentClipPath;
                currentClipPath.updateTransform();
                clipPaths.push(currentClipPath);
                parentClipPath = currentClipPath;
                currentClipPath = currentClipPath.clipPath;
            }
        }
        if (el.isGroup) {
            var children = el._children;
            for(var i = 0; i < children.length; i++){
                var child = children[i]; // Force to mark as dirty if group is dirty
                // FIXME __dirtyPath ?
                if (el.__dirty) child.__dirty = true;
                this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
            } // Mark group clean here
            el.__dirty = false;
        } else {
            el.__clipPaths = clipPaths;
            this._displayList[this._displayListLen++] = el;
        }
    },
    /**
   * 添加图形(Shape)或者组(Group)到根节点
   * @param {module:zrender/Element} el
   */ addRoot: function(el) {
        if (el.__storage === this) return;
        if (el instanceof $48aa8d5160ffcc64$exports) el.addChildrenToStorage(this);
        this.addToStorage(el);
        this._roots.push(el);
    },
    /**
   * 删除指定的图形(Shape)或者组(Group)
   * @param {string|Array.<string>} [el] 如果为空清空整个Storage
   */ delRoot: function(el) {
        if (el == null) {
            // 不指定el清空
            for(var i = 0; i < this._roots.length; i++){
                var root = this._roots[i];
                if (root instanceof $48aa8d5160ffcc64$exports) root.delChildrenFromStorage(this);
            }
            this._roots = [];
            this._displayList = [];
            this._displayListLen = 0;
            return;
        }
        if (el instanceof Array) {
            for(var i = 0, l = el.length; i < l; i++)this.delRoot(el[i]);
            return;
        }
        var idx = $ec279652dd95c27b$export$305f7d4e9d4624f2(this._roots, el);
        if (idx >= 0) {
            this.delFromStorage(el);
            this._roots.splice(idx, 1);
            if (el instanceof $48aa8d5160ffcc64$exports) el.delChildrenFromStorage(this);
        }
    },
    addToStorage: function(el) {
        if (el) {
            el.__storage = this;
            el.dirty(false);
        }
        return this;
    },
    delFromStorage: function(el) {
        if (el) el.__storage = null;
        return this;
    },
    /**
   * 清空并且释放Storage
   */ dispose: function() {
        this._renderList = this._roots = null;
    },
    displayableSortFunc: $cf128beaa1ab720c$var$shapeCompareFunc
};
var $cf128beaa1ab720c$var$_default = $cf128beaa1ab720c$var$Storage;
$cf128beaa1ab720c$exports = $cf128beaa1ab720c$var$_default;


var $17b58207a6548df7$exports = {};

var $17b58207a6548df7$var$devicePixelRatio = $2f7815d0a3a302c3$export$508f096bfcdaac40;




var $a6a14a6f46c4cad0$exports = {};


var $a6a14a6f46c4cad0$var$devicePixelRatio = $2f7815d0a3a302c3$export$508f096bfcdaac40;
var $5138c5bbf976c46c$exports = {};
var $280192321eaabe79$exports = {};
var $280192321eaabe79$var$SHADOW_PROPS = {
    "shadowBlur": 1,
    "shadowOffsetX": 1,
    "shadowOffsetY": 1,
    "textShadowBlur": 1,
    "textShadowOffsetX": 1,
    "textShadowOffsetY": 1,
    "textBoxShadowBlur": 1,
    "textBoxShadowOffsetX": 1,
    "textBoxShadowOffsetY": 1
};
function $280192321eaabe79$var$_default(ctx, propName, value) {
    if ($280192321eaabe79$var$SHADOW_PROPS.hasOwnProperty(propName)) return value *= ctx.dpr;
    return value;
}
$280192321eaabe79$exports = $280192321eaabe79$var$_default;


var $e1470dc860948586$export$4c866e61483cd9a4;
var $e1470dc860948586$export$25a5d7762d753e59;
var $e1470dc860948586$var$ContextCachedBy = {
    NONE: 0,
    STYLE_BIND: 1,
    PLAIN_TEXT: 2
}; // Avoid confused with 0/false.
var $e1470dc860948586$var$WILL_BE_RESTORED = 9;
$e1470dc860948586$export$4c866e61483cd9a4 = $e1470dc860948586$var$ContextCachedBy;
$e1470dc860948586$export$25a5d7762d753e59 = $e1470dc860948586$var$WILL_BE_RESTORED;


var $5138c5bbf976c46c$var$ContextCachedBy = $e1470dc860948586$export$4c866e61483cd9a4;
var $5138c5bbf976c46c$var$STYLE_COMMON_PROPS = [
    [
        "shadowBlur",
        0
    ],
    [
        "shadowOffsetX",
        0
    ],
    [
        "shadowOffsetY",
        0
    ],
    [
        "shadowColor",
        "#000"
    ],
    [
        "lineCap",
        "butt"
    ],
    [
        "lineJoin",
        "miter"
    ],
    [
        "miterLimit",
        10
    ]
]; // var SHADOW_PROPS = STYLE_COMMON_PROPS.slice(0, 4);
// var LINE_PROPS = STYLE_COMMON_PROPS.slice(4);
var $5138c5bbf976c46c$var$Style = function(opts) {
    this.extendFrom(opts, false);
};
function $5138c5bbf976c46c$var$createLinearGradient(ctx, obj, rect) {
    var x = obj.x == null ? 0 : obj.x;
    var x2 = obj.x2 == null ? 1 : obj.x2;
    var y = obj.y == null ? 0 : obj.y;
    var y2 = obj.y2 == null ? 0 : obj.y2;
    if (!obj.global) {
        x = x * rect.width + rect.x;
        x2 = x2 * rect.width + rect.x;
        y = y * rect.height + rect.y;
        y2 = y2 * rect.height + rect.y;
    } // Fix NaN when rect is Infinity
    x = isNaN(x) ? 0 : x;
    x2 = isNaN(x2) ? 1 : x2;
    y = isNaN(y) ? 0 : y;
    y2 = isNaN(y2) ? 0 : y2;
    var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
    return canvasGradient;
}
function $5138c5bbf976c46c$var$createRadialGradient(ctx, obj, rect) {
    var width = rect.width;
    var height = rect.height;
    var min = Math.min(width, height);
    var x = obj.x == null ? 0.5 : obj.x;
    var y = obj.y == null ? 0.5 : obj.y;
    var r = obj.r == null ? 0.5 : obj.r;
    if (!obj.global) {
        x = x * width + rect.x;
        y = y * height + rect.y;
        r = r * min;
    }
    var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
    return canvasGradient;
}
$5138c5bbf976c46c$var$Style.prototype = {
    constructor: $5138c5bbf976c46c$var$Style,
    /**
   * @type {string}
   */ fill: "#000",
    /**
   * @type {string}
   */ stroke: null,
    /**
   * @type {number}
   */ opacity: 1,
    /**
   * @type {number}
   */ fillOpacity: null,
    /**
   * @type {number}
   */ strokeOpacity: null,
    /**
   * `true` is not supported.
   * `false`/`null`/`undefined` are the same.
   * `false` is used to remove lineDash in some
   * case that `null`/`undefined` can not be set.
   * (e.g., emphasis.lineStyle in echarts)
   * @type {Array.<number>|boolean}
   */ lineDash: null,
    /**
   * @type {number}
   */ lineDashOffset: 0,
    /**
   * @type {number}
   */ shadowBlur: 0,
    /**
   * @type {number}
   */ shadowOffsetX: 0,
    /**
   * @type {number}
   */ shadowOffsetY: 0,
    /**
   * @type {number}
   */ lineWidth: 1,
    /**
   * If stroke ignore scale
   * @type {Boolean}
   */ strokeNoScale: false,
    // Bounding rect text configuration
    // Not affected by element transform
    /**
   * @type {string}
   */ text: null,
    /**
   * If `fontSize` or `fontFamily` exists, `font` will be reset by
   * `fontSize`, `fontStyle`, `fontWeight`, `fontFamily`.
   * So do not visit it directly in upper application (like echarts),
   * but use `contain/text#makeFont` instead.
   * @type {string}
   */ font: null,
    /**
   * The same as font. Use font please.
   * @deprecated
   * @type {string}
   */ textFont: null,
    /**
   * It helps merging respectively, rather than parsing an entire font string.
   * @type {string}
   */ fontStyle: null,
    /**
   * It helps merging respectively, rather than parsing an entire font string.
   * @type {string}
   */ fontWeight: null,
    /**
   * It helps merging respectively, rather than parsing an entire font string.
   * Should be 12 but not '12px'.
   * @type {number}
   */ fontSize: null,
    /**
   * It helps merging respectively, rather than parsing an entire font string.
   * @type {string}
   */ fontFamily: null,
    /**
   * Reserved for special functinality, like 'hr'.
   * @type {string}
   */ textTag: null,
    /**
   * @type {string}
   */ textFill: "#000",
    /**
   * @type {string}
   */ textStroke: null,
    /**
   * @type {number}
   */ textWidth: null,
    /**
   * Only for textBackground.
   * @type {number}
   */ textHeight: null,
    /**
   * textStroke may be set as some color as a default
   * value in upper applicaion, where the default value
   * of textStrokeWidth should be 0 to make sure that
   * user can choose to do not use text stroke.
   * @type {number}
   */ textStrokeWidth: 0,
    /**
   * @type {number}
   */ textLineHeight: null,
    /**
   * 'inside', 'left', 'right', 'top', 'bottom'
   * [x, y]
   * Based on x, y of rect.
   * @type {string|Array.<number>}
   * @default 'inside'
   */ textPosition: "inside",
    /**
   * If not specified, use the boundingRect of a `displayable`.
   * @type {Object}
   */ textRect: null,
    /**
   * [x, y]
   * @type {Array.<number>}
   */ textOffset: null,
    /**
   * @type {string}
   */ textAlign: null,
    /**
   * @type {string}
   */ textVerticalAlign: null,
    /**
   * @type {number}
   */ textDistance: 5,
    /**
   * @type {string}
   */ textShadowColor: "transparent",
    /**
   * @type {number}
   */ textShadowBlur: 0,
    /**
   * @type {number}
   */ textShadowOffsetX: 0,
    /**
   * @type {number}
   */ textShadowOffsetY: 0,
    /**
   * @type {string}
   */ textBoxShadowColor: "transparent",
    /**
   * @type {number}
   */ textBoxShadowBlur: 0,
    /**
   * @type {number}
   */ textBoxShadowOffsetX: 0,
    /**
   * @type {number}
   */ textBoxShadowOffsetY: 0,
    /**
   * Whether transform text.
   * Only available in Path and Image element,
   * where the text is called as `RectText`.
   * @type {boolean}
   */ transformText: false,
    /**
   * Text rotate around position of Path or Image.
   * The origin of the rotation can be specified by `textOrigin`.
   * Only available in Path and Image element,
   * where the text is called as `RectText`.
   */ textRotation: 0,
    /**
   * Text origin of text rotation.
   * Useful in the case like label rotation of circular symbol.
   * Only available in Path and Image element, where the text is called
   * as `RectText` and the element is called as "host element".
   * The value can be:
   * + If specified as a coordinate like `[10, 40]`, it is the `[x, y]`
   * base on the left-top corner of the rect of its host element.
   * + If specified as a string `center`, it is the center of the rect of
   * its host element.
   * + By default, this origin is the `textPosition`.
   * @type {string|Array.<number>}
   */ textOrigin: null,
    /**
   * @type {string}
   */ textBackgroundColor: null,
    /**
   * @type {string}
   */ textBorderColor: null,
    /**
   * @type {number}
   */ textBorderWidth: 0,
    /**
   * @type {number}
   */ textBorderRadius: 0,
    /**
   * Can be `2` or `[2, 4]` or `[2, 3, 4, 5]`
   * @type {number|Array.<number>}
   */ textPadding: null,
    /**
   * Text styles for rich text.
   * @type {Object}
   */ rich: null,
    /**
   * {outerWidth, outerHeight, ellipsis, placeholder}
   * @type {Object}
   */ truncate: null,
    /**
   * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
   * @type {string}
   */ blend: null,
    /**
   * @param {CanvasRenderingContext2D} ctx
   */ bind: function(ctx, el, prevEl) {
        var style = this;
        var prevStyle = prevEl && prevEl.style; // If no prevStyle, it means first draw.
        // Only apply cache if the last time cachced by this function.
        var notCheckCache = !prevStyle || ctx.__attrCachedBy !== $5138c5bbf976c46c$var$ContextCachedBy.STYLE_BIND;
        ctx.__attrCachedBy = $5138c5bbf976c46c$var$ContextCachedBy.STYLE_BIND;
        for(var i = 0; i < $5138c5bbf976c46c$var$STYLE_COMMON_PROPS.length; i++){
            var prop = $5138c5bbf976c46c$var$STYLE_COMMON_PROPS[i];
            var styleName = prop[0];
            if (notCheckCache || style[styleName] !== prevStyle[styleName]) // FIXME Invalid property value will cause style leak from previous element.
            ctx[styleName] = $280192321eaabe79$exports(ctx, styleName, style[styleName] || prop[1]);
        }
        if (notCheckCache || style.fill !== prevStyle.fill) ctx.fillStyle = style.fill;
        if (notCheckCache || style.stroke !== prevStyle.stroke) ctx.strokeStyle = style.stroke;
        if (notCheckCache || style.opacity !== prevStyle.opacity) ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
        if (notCheckCache || style.blend !== prevStyle.blend) ctx.globalCompositeOperation = style.blend || "source-over";
        if (this.hasStroke()) {
            var lineWidth = style.lineWidth;
            ctx.lineWidth = lineWidth / (this.strokeNoScale && el && el.getLineScale ? el.getLineScale() : 1);
        }
    },
    hasFill: function() {
        var fill = this.fill;
        return fill != null && fill !== "none";
    },
    hasStroke: function() {
        var stroke = this.stroke;
        return stroke != null && stroke !== "none" && this.lineWidth > 0;
    },
    /**
   * Extend from other style
   * @param {zrender/graphic/Style} otherStyle
   * @param {boolean} overwrite true: overwrirte any way.
   *                            false: overwrite only when !target.hasOwnProperty
   *                            others: overwrite when property is not null/undefined.
   */ extendFrom: function(otherStyle, overwrite) {
        if (otherStyle) {
            for(var name in otherStyle)if (otherStyle.hasOwnProperty(name) && (overwrite === true || (overwrite === false ? !this.hasOwnProperty(name) : otherStyle[name] != null))) this[name] = otherStyle[name];
        }
    },
    /**
   * Batch setting style with a given object
   * @param {Object|string} obj
   * @param {*} [obj]
   */ set: function(obj, value) {
        if (typeof obj === "string") this[obj] = value;
        else this.extendFrom(obj, true);
    },
    /**
   * Clone
   * @return {zrender/graphic/Style} [description]
   */ clone: function() {
        var newStyle = new this.constructor();
        newStyle.extendFrom(this, true);
        return newStyle;
    },
    getGradient: function(ctx, obj, rect) {
        var method = obj.type === "radial" ? $5138c5bbf976c46c$var$createRadialGradient : $5138c5bbf976c46c$var$createLinearGradient;
        var canvasGradient = method(ctx, obj, rect);
        var colorStops = obj.colorStops;
        for(var i = 0; i < colorStops.length; i++)canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
        return canvasGradient;
    }
};
var $5138c5bbf976c46c$var$styleProto = $5138c5bbf976c46c$var$Style.prototype;
for(var $5138c5bbf976c46c$var$i = 0; $5138c5bbf976c46c$var$i < $5138c5bbf976c46c$var$STYLE_COMMON_PROPS.length; $5138c5bbf976c46c$var$i++){
    var $5138c5bbf976c46c$var$prop = $5138c5bbf976c46c$var$STYLE_COMMON_PROPS[$5138c5bbf976c46c$var$i];
    if (!($5138c5bbf976c46c$var$prop[0] in $5138c5bbf976c46c$var$styleProto)) $5138c5bbf976c46c$var$styleProto[$5138c5bbf976c46c$var$prop[0]] = $5138c5bbf976c46c$var$prop[1];
} // Provide for others
$5138c5bbf976c46c$var$Style.getGradient = $5138c5bbf976c46c$var$styleProto.getGradient;
var $5138c5bbf976c46c$var$_default = $5138c5bbf976c46c$var$Style;
$5138c5bbf976c46c$exports = $5138c5bbf976c46c$var$_default;


var $db49346795b4d95d$exports = {};
var $db49346795b4d95d$var$Pattern = function(image, repeat) {
    // Should do nothing more in this constructor. Because gradient can be
    // declard by `color: {image: ...}`, where this constructor will not be called.
    this.image = image;
    this.repeat = repeat; // Can be cloned
    this.type = "pattern";
};
$db49346795b4d95d$var$Pattern.prototype.getCanvasPattern = function(ctx) {
    return ctx.createPattern(this.image, this.repeat || "repeat");
};
var $db49346795b4d95d$var$_default = $db49346795b4d95d$var$Pattern;
$db49346795b4d95d$exports = $db49346795b4d95d$var$_default;


/**
 * @module zrender/Layer
 * @author pissang(https://www.github.com/pissang)
 */ function $a6a14a6f46c4cad0$var$returnFalse() {
    return false;
}
/**
 * 创建dom
 *
 * @inner
 * @param {string} id dom id 待用
 * @param {Painter} painter painter instance
 * @param {number} number
 */ function $a6a14a6f46c4cad0$var$createDom(id, painter, dpr) {
    var newDom = $ec279652dd95c27b$export$cd3d1f114b139967();
    var width = painter.getWidth();
    var height = painter.getHeight();
    var newDomStyle = newDom.style;
    if (newDomStyle) {
        // In node or some other non-browser environment
        newDomStyle.position = "absolute";
        newDomStyle.left = 0;
        newDomStyle.top = 0;
        newDomStyle.width = width + "px";
        newDomStyle.height = height + "px";
        newDom.setAttribute("data-zr-dom-id", id);
    }
    newDom.width = width * dpr;
    newDom.height = height * dpr;
    return newDom;
}
/**
 * @alias module:zrender/Layer
 * @constructor
 * @extends module:zrender/mixin/Transformable
 * @param {string} id
 * @param {module:zrender/Painter} painter
 * @param {number} [dpr]
 */ var $a6a14a6f46c4cad0$var$Layer = function(id, painter, dpr) {
    var dom;
    dpr = dpr || $a6a14a6f46c4cad0$var$devicePixelRatio;
    if (typeof id === "string") dom = $a6a14a6f46c4cad0$var$createDom(id, painter, dpr);
    else if ($ec279652dd95c27b$export$a6cdc56e425d0d0a(id)) {
        dom = id;
        id = dom.id;
    }
    this.id = id;
    this.dom = dom;
    var domStyle = dom.style;
    if (domStyle) {
        // Not in node
        dom.onselectstart = $a6a14a6f46c4cad0$var$returnFalse; // 避免页面选中的尴尬
        domStyle["-webkit-user-select"] = "none";
        domStyle["user-select"] = "none";
        domStyle["-webkit-touch-callout"] = "none";
        domStyle["-webkit-tap-highlight-color"] = "rgba(0,0,0,0)";
        domStyle["padding"] = 0; // eslint-disable-line dot-notation
        domStyle["margin"] = 0; // eslint-disable-line dot-notation
        domStyle["border-width"] = 0;
    }
    this.domBack = null;
    this.ctxBack = null;
    this.painter = painter;
    this.config = null; // Configs
    /**
   * 每次清空画布的颜色
   * @type {string}
   * @default 0
   */ this.clearColor = 0;
    /**
   * 是否开启动态模糊
   * @type {boolean}
   * @default false
   */ this.motionBlur = false;
    /**
   * 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
   * @type {number}
   * @default 0.7
   */ this.lastFrameAlpha = 0.7;
    /**
   * Layer dpr
   * @type {number}
   */ this.dpr = dpr;
};
$a6a14a6f46c4cad0$var$Layer.prototype = {
    constructor: $a6a14a6f46c4cad0$var$Layer,
    __dirty: true,
    __used: false,
    __drawIndex: 0,
    __startIndex: 0,
    __endIndex: 0,
    incremental: false,
    getElementCount: function() {
        return this.__endIndex - this.__startIndex;
    },
    initContext: function() {
        this.ctx = this.dom.getContext("2d");
        this.ctx.dpr = this.dpr;
    },
    createBackBuffer: function() {
        var dpr = this.dpr;
        this.domBack = $a6a14a6f46c4cad0$var$createDom("back-" + this.id, this.painter, dpr);
        this.ctxBack = this.domBack.getContext("2d");
        if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
    },
    /**
   * @param  {number} width
   * @param  {number} height
   */ resize: function(width, height) {
        var dpr = this.dpr;
        var dom = this.dom;
        var domStyle = dom.style;
        var domBack = this.domBack;
        if (domStyle) {
            domStyle.width = width + "px";
            domStyle.height = height + "px";
        }
        dom.width = width * dpr;
        dom.height = height * dpr;
        if (domBack) {
            domBack.width = width * dpr;
            domBack.height = height * dpr;
            if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
        }
    },
    /**
   * 清空该层画布
   * @param {boolean} [clearAll]=false Clear all with out motion blur
   * @param {Color} [clearColor]
   */ clear: function(clearAll, clearColor) {
        var dom = this.dom;
        var ctx = this.ctx;
        var width = dom.width;
        var height = dom.height;
        var clearColor = clearColor || this.clearColor;
        var haveMotionBLur = this.motionBlur && !clearAll;
        var lastFrameAlpha = this.lastFrameAlpha;
        var dpr = this.dpr;
        if (haveMotionBLur) {
            if (!this.domBack) this.createBackBuffer();
            this.ctxBack.globalCompositeOperation = "copy";
            this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
        }
        ctx.clearRect(0, 0, width, height);
        if (clearColor && clearColor !== "transparent") {
            var clearColorGradientOrPattern; // Gradient
            if (clearColor.colorStops) {
                // Cache canvas gradient
                clearColorGradientOrPattern = clearColor.__canvasGradient || $5138c5bbf976c46c$exports.getGradient(ctx, clearColor, {
                    x: 0,
                    y: 0,
                    width: width,
                    height: height
                });
                clearColor.__canvasGradient = clearColorGradientOrPattern;
            } else if (clearColor.image) clearColorGradientOrPattern = $db49346795b4d95d$exports.prototype.getCanvasPattern.call(clearColor, ctx);
            ctx.save();
            ctx.fillStyle = clearColorGradientOrPattern || clearColor;
            ctx.fillRect(0, 0, width, height);
            ctx.restore();
        }
        if (haveMotionBLur) {
            var domBack = this.domBack;
            ctx.save();
            ctx.globalAlpha = lastFrameAlpha;
            ctx.drawImage(domBack, 0, 0, width, height);
            ctx.restore();
        }
    }
};
var $a6a14a6f46c4cad0$var$_default = $a6a14a6f46c4cad0$var$Layer;
$a6a14a6f46c4cad0$exports = $a6a14a6f46c4cad0$var$_default;


var $6351fcc6385a6fa9$exports = {};
var $6351fcc6385a6fa9$var$_default = typeof window !== "undefined" && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || // https://github.com/ecomfe/zrender/issues/189#issuecomment-224919809
window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(func) {
    setTimeout(func, 16);
};
$6351fcc6385a6fa9$exports = $6351fcc6385a6fa9$var$_default;


var $8d11db19115b899b$exports = {};
var $f95b0c44904a541d$exports = {};



var $b82ede1bca894b3a$exports = {};
var $5b0ace94e7e58ea5$export$176336068cc5371f;
var $5b0ace94e7e58ea5$export$482c90f94eb9717c;
var $5b0ace94e7e58ea5$export$13cc41b670c23b93;
var $5b0ace94e7e58ea5$export$d5e7b8855b0b151b;
var $5b0ace94e7e58ea5$export$2ca749095fe16708;
var $5b0ace94e7e58ea5$export$e8514cb5a5e2b40f;
var $5b0ace94e7e58ea5$export$15f386d282805840;

var $5b0ace94e7e58ea5$var$retrieve2 = $ec279652dd95c27b$export$995e01f2f5c9d030;
var $5b0ace94e7e58ea5$var$retrieve3 = $ec279652dd95c27b$export$2e94551289abb95b;
var $5b0ace94e7e58ea5$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $5b0ace94e7e58ea5$var$normalizeCssArray = $ec279652dd95c27b$export$f3a38102c49f4268;
var $5b0ace94e7e58ea5$var$isString = $ec279652dd95c27b$export$844ec244b1367d54;
var $5b0ace94e7e58ea5$var$isObject = $ec279652dd95c27b$export$a6cdc56e425d0d0a;
var $ebae9c4ebc22906c$export$7d7a232b6d2cc80c;
var $ebae9c4ebc22906c$export$d35a04b83ea6803e;
var $ebae9c4ebc22906c$export$3c49c185de0c2bfc;
var $ebae9c4ebc22906c$export$c381147bfed79d9f;
var $ebae9c4ebc22906c$export$eb5a525ef00ef9a4;
var $ebae9c4ebc22906c$export$bf7d6802d2badd9;
var $ebae9c4ebc22906c$export$eee3603b512feab7;
var $ebae9c4ebc22906c$export$31fec5c513bbf2ec;
var $ebae9c4ebc22906c$export$59a943b34a82e690;
var $ebae9c4ebc22906c$export$56204a27a2958a55;
var $ebae9c4ebc22906c$export$866cc30a33805630;
var $ebae9c4ebc22906c$export$5772575e34ef80f9;
var $ebae9c4ebc22906c$export$15ec9472ff2d721;
var $ebae9c4ebc22906c$export$624ea4f0c38e70fc;

var $b934863425020c49$export$1b614f30ac2c8867;
var $b934863425020c49$export$46c791b69ff9a0f;
var $b934863425020c49$export$37ca7dd901d0236d;

var $b934863425020c49$var$globalImageCache = new $8f310e996ed18a8a$exports(50);
/**
 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
 */ function $b934863425020c49$var$findExistImage(newImageOrSrc) {
    if (typeof newImageOrSrc === "string") {
        var cachedImgObj = $b934863425020c49$var$globalImageCache.get(newImageOrSrc);
        return cachedImgObj && cachedImgObj.image;
    } else return newImageOrSrc;
}
/**
 * Caution: User should cache loaded images, but not just count on LRU.
 * Consider if required images more than LRU size, will dead loop occur?
 *
 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
 * @param {HTMLImageElement|HTMLCanvasElement|Canvas} image Existent image.
 * @param {module:zrender/Element} [hostEl] For calling `dirty`.
 * @param {Function} [cb] params: (image, cbPayload)
 * @param {Object} [cbPayload] Payload on cb calling.
 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
 */ function $b934863425020c49$var$createOrUpdateImage(newImageOrSrc, image, hostEl, cb, cbPayload) {
    if (!newImageOrSrc) return image;
    else if (typeof newImageOrSrc === "string") {
        // Image should not be loaded repeatly.
        if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) return image;
         // Only when there is no existent image or existent image src
        // is different, this method is responsible for load.
        var cachedImgObj = $b934863425020c49$var$globalImageCache.get(newImageOrSrc);
        var pendingWrap = {
            hostEl: hostEl,
            cb: cb,
            cbPayload: cbPayload
        };
        if (cachedImgObj) {
            image = cachedImgObj.image;
            !$b934863425020c49$var$isImageReady(image) && cachedImgObj.pending.push(pendingWrap);
        } else {
            image = new Image();
            image.onload = image.onerror = $b934863425020c49$var$imageOnLoad;
            $b934863425020c49$var$globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
                image: image,
                pending: [
                    pendingWrap
                ]
            });
            image.src = image.__zrImageSrc = newImageOrSrc;
        }
        return image;
    } else return newImageOrSrc;
}
function $b934863425020c49$var$imageOnLoad() {
    var cachedImgObj = this.__cachedImgObj;
    this.onload = this.onerror = this.__cachedImgObj = null;
    for(var i = 0; i < cachedImgObj.pending.length; i++){
        var pendingWrap = cachedImgObj.pending[i];
        var cb = pendingWrap.cb;
        cb && cb(this, pendingWrap.cbPayload);
        pendingWrap.hostEl.dirty();
    }
    cachedImgObj.pending.length = 0;
}
function $b934863425020c49$var$isImageReady(image) {
    return image && image.width && image.height;
}
$b934863425020c49$export$1b614f30ac2c8867 = $b934863425020c49$var$findExistImage;
$b934863425020c49$export$46c791b69ff9a0f = $b934863425020c49$var$createOrUpdateImage;
$b934863425020c49$export$37ca7dd901d0236d = $b934863425020c49$var$isImageReady;



var $ebae9c4ebc22906c$var$getContext = $ec279652dd95c27b$export$31553aaa555c1514;
var $ebae9c4ebc22906c$var$extend = $ec279652dd95c27b$export$8b58be045bf06082;
var $ebae9c4ebc22906c$var$retrieve2 = $ec279652dd95c27b$export$995e01f2f5c9d030;
var $ebae9c4ebc22906c$var$retrieve3 = $ec279652dd95c27b$export$2e94551289abb95b;
var $ebae9c4ebc22906c$var$trim = $ec279652dd95c27b$export$87c2784dc9fc4ab;
var $ebae9c4ebc22906c$var$textWidthCache = {};
var $ebae9c4ebc22906c$var$textWidthCacheCounter = 0;
var $ebae9c4ebc22906c$var$TEXT_CACHE_MAX = 5000;
var $ebae9c4ebc22906c$var$STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
var $ebae9c4ebc22906c$var$DEFAULT_FONT = "12px sans-serif"; // Avoid assign to an exported variable, for transforming to cjs.
var $ebae9c4ebc22906c$var$methods = {};
function $ebae9c4ebc22906c$var$$override(name, fn) {
    $ebae9c4ebc22906c$var$methods[name] = fn;
}
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @return {number} width
 */ function $ebae9c4ebc22906c$var$getWidth(text, font) {
    font = font || $ebae9c4ebc22906c$var$DEFAULT_FONT;
    var key = text + ":" + font;
    if ($ebae9c4ebc22906c$var$textWidthCache[key]) return $ebae9c4ebc22906c$var$textWidthCache[key];
    var textLines = (text + "").split("\n");
    var width = 0;
    for(var i = 0, l = textLines.length; i < l; i++)// textContain.measureText may be overrided in SVG or VML
    width = Math.max($ebae9c4ebc22906c$var$measureText(textLines[i], font).width, width);
    if ($ebae9c4ebc22906c$var$textWidthCacheCounter > $ebae9c4ebc22906c$var$TEXT_CACHE_MAX) {
        $ebae9c4ebc22906c$var$textWidthCacheCounter = 0;
        $ebae9c4ebc22906c$var$textWidthCache = {};
    }
    $ebae9c4ebc22906c$var$textWidthCacheCounter++;
    $ebae9c4ebc22906c$var$textWidthCache[key] = width;
    return width;
}
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @param {string} [textAlign='left']
 * @param {string} [textVerticalAlign='top']
 * @param {Array.<number>} [textPadding]
 * @param {Object} [rich]
 * @param {Object} [truncate]
 * @return {Object} {x, y, width, height, lineHeight}
 */ function $ebae9c4ebc22906c$var$getBoundingRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) {
    return rich ? $ebae9c4ebc22906c$var$getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) : $ebae9c4ebc22906c$var$getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, truncate);
}
function $ebae9c4ebc22906c$var$getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, truncate) {
    var contentBlock = $ebae9c4ebc22906c$var$parsePlainText(text, font, textPadding, textLineHeight, truncate);
    var outerWidth = $ebae9c4ebc22906c$var$getWidth(text, font);
    if (textPadding) outerWidth += textPadding[1] + textPadding[3];
    var outerHeight = contentBlock.outerHeight;
    var x = $ebae9c4ebc22906c$var$adjustTextX(0, outerWidth, textAlign);
    var y = $ebae9c4ebc22906c$var$adjustTextY(0, outerHeight, textVerticalAlign);
    var rect = new $33e4fae744d34798$exports(x, y, outerWidth, outerHeight);
    rect.lineHeight = contentBlock.lineHeight;
    return rect;
}
function $ebae9c4ebc22906c$var$getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) {
    var contentBlock = $ebae9c4ebc22906c$var$parseRichText(text, {
        rich: rich,
        truncate: truncate,
        font: font,
        textAlign: textAlign,
        textPadding: textPadding,
        textLineHeight: textLineHeight
    });
    var outerWidth = contentBlock.outerWidth;
    var outerHeight = contentBlock.outerHeight;
    var x = $ebae9c4ebc22906c$var$adjustTextX(0, outerWidth, textAlign);
    var y = $ebae9c4ebc22906c$var$adjustTextY(0, outerHeight, textVerticalAlign);
    return new $33e4fae744d34798$exports(x, y, outerWidth, outerHeight);
}
/**
 * @public
 * @param {number} x
 * @param {number} width
 * @param {string} [textAlign='left']
 * @return {number} Adjusted x.
 */ function $ebae9c4ebc22906c$var$adjustTextX(x, width, textAlign) {
    // FIXME Right to left language
    if (textAlign === "right") x -= width;
    else if (textAlign === "center") x -= width / 2;
    return x;
}
/**
 * @public
 * @param {number} y
 * @param {number} height
 * @param {string} [textVerticalAlign='top']
 * @return {number} Adjusted y.
 */ function $ebae9c4ebc22906c$var$adjustTextY(y, height, textVerticalAlign) {
    if (textVerticalAlign === "middle") y -= height / 2;
    else if (textVerticalAlign === "bottom") y -= height;
    return y;
}
/**
 * Follow same interface to `Displayable.prototype.calculateTextPosition`.
 * @public
 * @param {Obejct} [out] Prepared out object. If not input, auto created in the method.
 * @param {module:zrender/graphic/Style} style where `textPosition` and `textDistance` are visited.
 * @param {Object} rect {x, y, width, height} Rect of the host elment, according to which the text positioned.
 * @return {Object} The input `out`. Set: {x, y, textAlign, textVerticalAlign}
 */ function $ebae9c4ebc22906c$var$calculateTextPosition(out, style, rect) {
    var textPosition = style.textPosition;
    var distance = style.textDistance;
    var x = rect.x;
    var y = rect.y;
    distance = distance || 0;
    var height = rect.height;
    var width = rect.width;
    var halfHeight = height / 2;
    var textAlign = "left";
    var textVerticalAlign = "top";
    switch(textPosition){
        case "left":
            x -= distance;
            y += halfHeight;
            textAlign = "right";
            textVerticalAlign = "middle";
            break;
        case "right":
            x += distance + width;
            y += halfHeight;
            textVerticalAlign = "middle";
            break;
        case "top":
            x += width / 2;
            y -= distance;
            textAlign = "center";
            textVerticalAlign = "bottom";
            break;
        case "bottom":
            x += width / 2;
            y += height + distance;
            textAlign = "center";
            break;
        case "inside":
            x += width / 2;
            y += halfHeight;
            textAlign = "center";
            textVerticalAlign = "middle";
            break;
        case "insideLeft":
            x += distance;
            y += halfHeight;
            textVerticalAlign = "middle";
            break;
        case "insideRight":
            x += width - distance;
            y += halfHeight;
            textAlign = "right";
            textVerticalAlign = "middle";
            break;
        case "insideTop":
            x += width / 2;
            y += distance;
            textAlign = "center";
            break;
        case "insideBottom":
            x += width / 2;
            y += height - distance;
            textAlign = "center";
            textVerticalAlign = "bottom";
            break;
        case "insideTopLeft":
            x += distance;
            y += distance;
            break;
        case "insideTopRight":
            x += width - distance;
            y += distance;
            textAlign = "right";
            break;
        case "insideBottomLeft":
            x += distance;
            y += height - distance;
            textVerticalAlign = "bottom";
            break;
        case "insideBottomRight":
            x += width - distance;
            y += height - distance;
            textAlign = "right";
            textVerticalAlign = "bottom";
            break;
    }
    out = out || {};
    out.x = x;
    out.y = y;
    out.textAlign = textAlign;
    out.textVerticalAlign = textVerticalAlign;
    return out;
}
/**
 * To be removed. But still do not remove in case that some one has imported it.
 * @deprecated
 * @public
 * @param {stirng} textPosition
 * @param {Object} rect {x, y, width, height}
 * @param {number} distance
 * @return {Object} {x, y, textAlign, textVerticalAlign}
 */ function $ebae9c4ebc22906c$var$adjustTextPositionOnRect(textPosition, rect, distance) {
    var dummyStyle = {
        textPosition: textPosition,
        textDistance: distance
    };
    return $ebae9c4ebc22906c$var$calculateTextPosition({}, dummyStyle, rect);
}
/**
 * Show ellipsis if overflow.
 *
 * @public
 * @param  {string} text
 * @param  {string} containerWidth
 * @param  {string} font
 * @param  {number} [ellipsis='...']
 * @param  {Object} [options]
 * @param  {number} [options.maxIterations=3]
 * @param  {number} [options.minChar=0] If truncate result are less
 *                  then minChar, ellipsis will not show, which is
 *                  better for user hint in some cases.
 * @param  {number} [options.placeholder=''] When all truncated, use the placeholder.
 * @return {string}
 */ function $ebae9c4ebc22906c$var$truncateText(text, containerWidth, font, ellipsis, options) {
    if (!containerWidth) return "";
    var textLines = (text + "").split("\n");
    options = $ebae9c4ebc22906c$var$prepareTruncateOptions(containerWidth, font, ellipsis, options); // FIXME
    // It is not appropriate that every line has '...' when truncate multiple lines.
    for(var i = 0, len = textLines.length; i < len; i++)textLines[i] = $ebae9c4ebc22906c$var$truncateSingleLine(textLines[i], options);
    return textLines.join("\n");
}
function $ebae9c4ebc22906c$var$prepareTruncateOptions(containerWidth, font, ellipsis, options) {
    options = $ebae9c4ebc22906c$var$extend({}, options);
    options.font = font;
    var ellipsis = $ebae9c4ebc22906c$var$retrieve2(ellipsis, "...");
    options.maxIterations = $ebae9c4ebc22906c$var$retrieve2(options.maxIterations, 2);
    var minChar = options.minChar = $ebae9c4ebc22906c$var$retrieve2(options.minChar, 0); // FIXME
    // Other languages?
    options.cnCharWidth = $ebae9c4ebc22906c$var$getWidth("\u56FD", font); // FIXME
    // Consider proportional font?
    var ascCharWidth = options.ascCharWidth = $ebae9c4ebc22906c$var$getWidth("a", font);
    options.placeholder = $ebae9c4ebc22906c$var$retrieve2(options.placeholder, ""); // Example 1: minChar: 3, text: 'asdfzxcv', truncate result: 'asdf', but not: 'a...'.
    // Example 2: minChar: 3, text: '维度', truncate result: '维', but not: '...'.
    var contentWidth = containerWidth = Math.max(0, containerWidth - 1); // Reserve some gap.
    for(var i = 0; i < minChar && contentWidth >= ascCharWidth; i++)contentWidth -= ascCharWidth;
    var ellipsisWidth = $ebae9c4ebc22906c$var$getWidth(ellipsis, font);
    if (ellipsisWidth > contentWidth) {
        ellipsis = "";
        ellipsisWidth = 0;
    }
    contentWidth = containerWidth - ellipsisWidth;
    options.ellipsis = ellipsis;
    options.ellipsisWidth = ellipsisWidth;
    options.contentWidth = contentWidth;
    options.containerWidth = containerWidth;
    return options;
}
function $ebae9c4ebc22906c$var$truncateSingleLine(textLine, options) {
    var containerWidth = options.containerWidth;
    var font = options.font;
    var contentWidth = options.contentWidth;
    if (!containerWidth) return "";
    var lineWidth = $ebae9c4ebc22906c$var$getWidth(textLine, font);
    if (lineWidth <= containerWidth) return textLine;
    for(var j = 0;; j++){
        if (lineWidth <= contentWidth || j >= options.maxIterations) {
            textLine += options.ellipsis;
            break;
        }
        var subLength = j === 0 ? $ebae9c4ebc22906c$var$estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
        textLine = textLine.substr(0, subLength);
        lineWidth = $ebae9c4ebc22906c$var$getWidth(textLine, font);
    }
    if (textLine === "") textLine = options.placeholder;
    return textLine;
}
function $ebae9c4ebc22906c$var$estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
    var width = 0;
    var i = 0;
    for(var len = text.length; i < len && width < contentWidth; i++){
        var charCode = text.charCodeAt(i);
        width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
    }
    return i;
}
/**
 * @public
 * @param {string} font
 * @return {number} line height
 */ function $ebae9c4ebc22906c$var$getLineHeight(font) {
    // FIXME A rough approach.
    return $ebae9c4ebc22906c$var$getWidth("\u56FD", font);
}
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @return {Object} width
 */ function $ebae9c4ebc22906c$var$measureText(text, font) {
    return $ebae9c4ebc22906c$var$methods.measureText(text, font);
} // Avoid assign to an exported variable, for transforming to cjs.
$ebae9c4ebc22906c$var$methods.measureText = function(text, font) {
    var ctx = $ebae9c4ebc22906c$var$getContext();
    ctx.font = font || $ebae9c4ebc22906c$var$DEFAULT_FONT;
    return ctx.measureText(text);
};
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @param {Object} [truncate]
 * @return {Object} block: {lineHeight, lines, height, outerHeight, canCacheByTextString}
 *  Notice: for performance, do not calculate outerWidth util needed.
 *  `canCacheByTextString` means the result `lines` is only determined by the input `text`.
 *  Thus we can simply comparing the `input` text to determin whether the result changed,
 *  without travel the result `lines`.
 */ function $ebae9c4ebc22906c$var$parsePlainText(text, font, padding, textLineHeight, truncate) {
    text != null && (text += "");
    var lineHeight = $ebae9c4ebc22906c$var$retrieve2(textLineHeight, $ebae9c4ebc22906c$var$getLineHeight(font));
    var lines = text ? text.split("\n") : [];
    var height = lines.length * lineHeight;
    var outerHeight = height;
    var canCacheByTextString = true;
    if (padding) outerHeight += padding[0] + padding[2];
    if (text && truncate) {
        canCacheByTextString = false;
        var truncOuterHeight = truncate.outerHeight;
        var truncOuterWidth = truncate.outerWidth;
        if (truncOuterHeight != null && outerHeight > truncOuterHeight) {
            text = "";
            lines = [];
        } else if (truncOuterWidth != null) {
            var options = $ebae9c4ebc22906c$var$prepareTruncateOptions(truncOuterWidth - (padding ? padding[1] + padding[3] : 0), font, truncate.ellipsis, {
                minChar: truncate.minChar,
                placeholder: truncate.placeholder
            }); // FIXME
            // It is not appropriate that every line has '...' when truncate multiple lines.
            for(var i = 0, len = lines.length; i < len; i++)lines[i] = $ebae9c4ebc22906c$var$truncateSingleLine(lines[i], options);
        }
    }
    return {
        lines: lines,
        height: height,
        outerHeight: outerHeight,
        lineHeight: lineHeight,
        canCacheByTextString: canCacheByTextString
    };
}
/**
 * For example: 'some text {a|some text}other text{b|some text}xxx{c|}xxx'
 * Also consider 'bbbb{a|xxx\nzzz}xxxx\naaaa'.
 *
 * @public
 * @param {string} text
 * @param {Object} style
 * @return {Object} block
 * {
 *      width,
 *      height,
 *      lines: [{
 *          lineHeight,
 *          width,
 *          tokens: [[{
 *              styleName,
 *              text,
 *              width,      // include textPadding
 *              height,     // include textPadding
 *              textWidth, // pure text width
 *              textHeight, // pure text height
 *              lineHeihgt,
 *              font,
 *              textAlign,
 *              textVerticalAlign
 *          }], [...], ...]
 *      }, ...]
 * }
 * If styleName is undefined, it is plain text.
 */ function $ebae9c4ebc22906c$var$parseRichText(text, style) {
    var contentBlock = {
        lines: [],
        width: 0,
        height: 0
    };
    text != null && (text += "");
    if (!text) return contentBlock;
    var lastIndex = $ebae9c4ebc22906c$var$STYLE_REG.lastIndex = 0;
    var result;
    while((result = $ebae9c4ebc22906c$var$STYLE_REG.exec(text)) != null){
        var matchedIndex = result.index;
        if (matchedIndex > lastIndex) $ebae9c4ebc22906c$var$pushTokens(contentBlock, text.substring(lastIndex, matchedIndex));
        $ebae9c4ebc22906c$var$pushTokens(contentBlock, result[2], result[1]);
        lastIndex = $ebae9c4ebc22906c$var$STYLE_REG.lastIndex;
    }
    if (lastIndex < text.length) $ebae9c4ebc22906c$var$pushTokens(contentBlock, text.substring(lastIndex, text.length));
    var lines = contentBlock.lines;
    var contentHeight = 0;
    var contentWidth = 0; // For `textWidth: 100%`
    var pendingList = [];
    var stlPadding = style.textPadding;
    var truncate = style.truncate;
    var truncateWidth = truncate && truncate.outerWidth;
    var truncateHeight = truncate && truncate.outerHeight;
    if (stlPadding) {
        truncateWidth != null && (truncateWidth -= stlPadding[1] + stlPadding[3]);
        truncateHeight != null && (truncateHeight -= stlPadding[0] + stlPadding[2]);
    } // Calculate layout info of tokens.
    for(var i = 0; i < lines.length; i++){
        var line = lines[i];
        var lineHeight = 0;
        var lineWidth = 0;
        for(var j = 0; j < line.tokens.length; j++){
            var token = line.tokens[j];
            var tokenStyle = token.styleName && style.rich[token.styleName] || {}; // textPadding should not inherit from style.
            var textPadding = token.textPadding = tokenStyle.textPadding; // textFont has been asigned to font by `normalizeStyle`.
            var font = token.font = tokenStyle.font || style.font; // textHeight can be used when textVerticalAlign is specified in token.
            var tokenHeight = token.textHeight = $ebae9c4ebc22906c$var$retrieve2(// as box height of the block.
            tokenStyle.textHeight, $ebae9c4ebc22906c$var$getLineHeight(font));
            textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
            token.height = tokenHeight;
            token.lineHeight = $ebae9c4ebc22906c$var$retrieve3(tokenStyle.textLineHeight, style.textLineHeight, tokenHeight);
            token.textAlign = tokenStyle && tokenStyle.textAlign || style.textAlign;
            token.textVerticalAlign = tokenStyle && tokenStyle.textVerticalAlign || "middle";
            if (truncateHeight != null && contentHeight + token.lineHeight > truncateHeight) return {
                lines: [],
                width: 0,
                height: 0
            };
            token.textWidth = $ebae9c4ebc22906c$var$getWidth(token.text, font);
            var tokenWidth = tokenStyle.textWidth;
            var tokenWidthNotSpecified = tokenWidth == null || tokenWidth === "auto"; // Percent width, can be `100%`, can be used in drawing separate
            // line when box width is needed to be auto.
            if (typeof tokenWidth === "string" && tokenWidth.charAt(tokenWidth.length - 1) === "%") {
                token.percentWidth = tokenWidth;
                pendingList.push(token);
                tokenWidth = 0; // Do not truncate in this case, because there is no user case
            // and it is too complicated.
            } else {
                if (tokenWidthNotSpecified) {
                    tokenWidth = token.textWidth; // FIXME: If image is not loaded and textWidth is not specified, calling
                    // `getBoundingRect()` will not get correct result.
                    var textBackgroundColor = tokenStyle.textBackgroundColor;
                    var bgImg = textBackgroundColor && textBackgroundColor.image; // Use cases:
                    // (1) If image is not loaded, it will be loaded at render phase and call
                    // `dirty()` and `textBackgroundColor.image` will be replaced with the loaded
                    // image, and then the right size will be calculated here at the next tick.
                    // See `graphic/helper/text.js`.
                    // (2) If image loaded, and `textBackgroundColor.image` is image src string,
                    // use `imageHelper.findExistImage` to find cached image.
                    // `imageHelper.findExistImage` will always be called here before
                    // `imageHelper.createOrUpdateImage` in `graphic/helper/text.js#renderRichText`
                    // which ensures that image will not be rendered before correct size calcualted.
                    if (bgImg) {
                        bgImg = $b934863425020c49$export$1b614f30ac2c8867(bgImg);
                        if ($b934863425020c49$export$37ca7dd901d0236d(bgImg)) tokenWidth = Math.max(tokenWidth, bgImg.width * tokenHeight / bgImg.height);
                    }
                }
                var paddingW = textPadding ? textPadding[1] + textPadding[3] : 0;
                tokenWidth += paddingW;
                var remianTruncWidth = truncateWidth != null ? truncateWidth - lineWidth : null;
                if (remianTruncWidth != null && remianTruncWidth < tokenWidth) {
                    if (!tokenWidthNotSpecified || remianTruncWidth < paddingW) {
                        token.text = "";
                        token.textWidth = tokenWidth = 0;
                    } else {
                        token.text = $ebae9c4ebc22906c$var$truncateText(token.text, remianTruncWidth - paddingW, font, truncate.ellipsis, {
                            minChar: truncate.minChar
                        });
                        token.textWidth = $ebae9c4ebc22906c$var$getWidth(token.text, font);
                        tokenWidth = token.textWidth + paddingW;
                    }
                }
            }
            lineWidth += token.width = tokenWidth;
            tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
        }
        line.width = lineWidth;
        line.lineHeight = lineHeight;
        contentHeight += lineHeight;
        contentWidth = Math.max(contentWidth, lineWidth);
    }
    contentBlock.outerWidth = contentBlock.width = $ebae9c4ebc22906c$var$retrieve2(style.textWidth, contentWidth);
    contentBlock.outerHeight = contentBlock.height = $ebae9c4ebc22906c$var$retrieve2(style.textHeight, contentHeight);
    if (stlPadding) {
        contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
        contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
    }
    for(var i = 0; i < pendingList.length; i++){
        var token = pendingList[i];
        var percentWidth = token.percentWidth; // Should not base on outerWidth, because token can not be placed out of padding.
        token.width = parseInt(percentWidth, 10) / 100 * contentWidth;
    }
    return contentBlock;
}
function $ebae9c4ebc22906c$var$pushTokens(block, str, styleName) {
    var isEmptyStr = str === "";
    var strs = str.split("\n");
    var lines = block.lines;
    for(var i = 0; i < strs.length; i++){
        var text = strs[i];
        var token = {
            styleName: styleName,
            text: text,
            isLineHolder: !text && !isEmptyStr
        }; // The first token should be appended to the last line.
        if (!i) {
            var tokens = (lines[lines.length - 1] || (lines[0] = {
                tokens: []
            })).tokens; // Consider cases:
            // (1) ''.split('\n') => ['', '\n', ''], the '' at the first item
            // (which is a placeholder) should be replaced by new token.
            // (2) A image backage, where token likes {a|}.
            // (3) A redundant '' will affect textAlign in line.
            // (4) tokens with the same tplName should not be merged, because
            // they should be displayed in different box (with border and padding).
            var tokensLen = tokens.length;
            tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : // "emptyStr". Otherwise a redundant '' will affect textAlign in line.
            (text || !tokensLen || isEmptyStr) && tokens.push(token);
        } else // If there is '', insert it as a placeholder.
        lines.push({
            tokens: [
                token
            ]
        });
    }
}
function $ebae9c4ebc22906c$var$makeFont(style) {
    // FIXME in node-canvas fontWeight is before fontStyle
    // Use `fontSize` `fontFamily` to check whether font properties are defined.
    var font = (style.fontSize || style.fontFamily) && [
        style.fontStyle,
        style.fontWeight,
        (style.fontSize || 12) + "px",
        style.fontFamily || "sans-serif"
    ].join(" ");
    return font && $ebae9c4ebc22906c$var$trim(font) || style.textFont || style.font;
}
$ebae9c4ebc22906c$export$7d7a232b6d2cc80c = $ebae9c4ebc22906c$var$DEFAULT_FONT;
$ebae9c4ebc22906c$export$d35a04b83ea6803e = $ebae9c4ebc22906c$var$$override;
$ebae9c4ebc22906c$export$3c49c185de0c2bfc = $ebae9c4ebc22906c$var$getWidth;
$ebae9c4ebc22906c$export$c381147bfed79d9f = $ebae9c4ebc22906c$var$getBoundingRect;
$ebae9c4ebc22906c$export$eb5a525ef00ef9a4 = $ebae9c4ebc22906c$var$adjustTextX;
$ebae9c4ebc22906c$export$bf7d6802d2badd9 = $ebae9c4ebc22906c$var$adjustTextY;
$ebae9c4ebc22906c$export$eee3603b512feab7 = $ebae9c4ebc22906c$var$calculateTextPosition;
$ebae9c4ebc22906c$export$31fec5c513bbf2ec = $ebae9c4ebc22906c$var$adjustTextPositionOnRect;
$ebae9c4ebc22906c$export$59a943b34a82e690 = $ebae9c4ebc22906c$var$truncateText;
$ebae9c4ebc22906c$export$56204a27a2958a55 = $ebae9c4ebc22906c$var$getLineHeight;
$ebae9c4ebc22906c$export$866cc30a33805630 = $ebae9c4ebc22906c$var$measureText;
$ebae9c4ebc22906c$export$5772575e34ef80f9 = $ebae9c4ebc22906c$var$parsePlainText;
$ebae9c4ebc22906c$export$15ec9472ff2d721 = $ebae9c4ebc22906c$var$parseRichText;
$ebae9c4ebc22906c$export$624ea4f0c38e70fc = $ebae9c4ebc22906c$var$makeFont;


/**
 * @param {Object} ctx
 * @param {Object} shape
 * @param {number} shape.x
 * @param {number} shape.y
 * @param {number} shape.width
 * @param {number} shape.height
 * @param {number} shape.r
 */ var $0d3fae5dbee73a0d$export$5cc7f731b5937e99;
function $0d3fae5dbee73a0d$var$buildPath(ctx, shape) {
    var x = shape.x;
    var y = shape.y;
    var width = shape.width;
    var height = shape.height;
    var r = shape.r;
    var r1;
    var r2;
    var r3;
    var r4; // Convert width and height to positive for better borderRadius
    if (width < 0) {
        x = x + width;
        width = -width;
    }
    if (height < 0) {
        y = y + height;
        height = -height;
    }
    if (typeof r === "number") r1 = r2 = r3 = r4 = r;
    else if (r instanceof Array) {
        if (r.length === 1) r1 = r2 = r3 = r4 = r[0];
        else if (r.length === 2) {
            r1 = r3 = r[0];
            r2 = r4 = r[1];
        } else if (r.length === 3) {
            r1 = r[0];
            r2 = r4 = r[1];
            r3 = r[2];
        } else {
            r1 = r[0];
            r2 = r[1];
            r3 = r[2];
            r4 = r[3];
        }
    } else r1 = r2 = r3 = r4 = 0;
    var total;
    if (r1 + r2 > width) {
        total = r1 + r2;
        r1 *= width / total;
        r2 *= width / total;
    }
    if (r3 + r4 > width) {
        total = r3 + r4;
        r3 *= width / total;
        r4 *= width / total;
    }
    if (r2 + r3 > height) {
        total = r2 + r3;
        r2 *= height / total;
        r3 *= height / total;
    }
    if (r1 + r4 > height) {
        total = r1 + r4;
        r1 *= height / total;
        r4 *= height / total;
    }
    ctx.moveTo(x + r1, y);
    ctx.lineTo(x + width - r2, y);
    r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
    ctx.lineTo(x + width, y + height - r3);
    r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
    ctx.lineTo(x + r4, y + height);
    r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
    ctx.lineTo(x, y + r1);
    r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
}
$0d3fae5dbee73a0d$export$5cc7f731b5937e99 = $0d3fae5dbee73a0d$var$buildPath;





var $5b0ace94e7e58ea5$var$ContextCachedBy = $e1470dc860948586$export$4c866e61483cd9a4;
var $5b0ace94e7e58ea5$var$WILL_BE_RESTORED = $e1470dc860948586$export$25a5d7762d753e59;
var $5b0ace94e7e58ea5$var$DEFAULT_FONT = $ebae9c4ebc22906c$export$7d7a232b6d2cc80c; // TODO: Have not support 'start', 'end' yet.
var $5b0ace94e7e58ea5$var$VALID_TEXT_ALIGN = {
    left: 1,
    right: 1,
    center: 1
};
var $5b0ace94e7e58ea5$var$VALID_TEXT_VERTICAL_ALIGN = {
    top: 1,
    bottom: 1,
    middle: 1
}; // Different from `STYLE_COMMON_PROPS` of `graphic/Style`,
// the default value of shadowColor is `'transparent'`.
var $5b0ace94e7e58ea5$var$SHADOW_STYLE_COMMON_PROPS = [
    [
        "textShadowBlur",
        "shadowBlur",
        0
    ],
    [
        "textShadowOffsetX",
        "shadowOffsetX",
        0
    ],
    [
        "textShadowOffsetY",
        "shadowOffsetY",
        0
    ],
    [
        "textShadowColor",
        "shadowColor",
        "transparent"
    ]
];
var $5b0ace94e7e58ea5$var$_tmpTextPositionResult = {};
var $5b0ace94e7e58ea5$var$_tmpBoxPositionResult = {};
/**
 * @param {module:zrender/graphic/Style} style
 * @return {module:zrender/graphic/Style} The input style.
 */ function $5b0ace94e7e58ea5$var$normalizeTextStyle(style) {
    $5b0ace94e7e58ea5$var$normalizeStyle(style);
    $5b0ace94e7e58ea5$var$each(style.rich, $5b0ace94e7e58ea5$var$normalizeStyle);
    return style;
}
function $5b0ace94e7e58ea5$var$normalizeStyle(style) {
    if (style) {
        style.font = $ebae9c4ebc22906c$export$624ea4f0c38e70fc(style);
        var textAlign = style.textAlign;
        textAlign === "middle" && (textAlign = "center");
        style.textAlign = textAlign == null || $5b0ace94e7e58ea5$var$VALID_TEXT_ALIGN[textAlign] ? textAlign : "left"; // Compatible with textBaseline.
        var textVerticalAlign = style.textVerticalAlign || style.textBaseline;
        textVerticalAlign === "center" && (textVerticalAlign = "middle");
        style.textVerticalAlign = textVerticalAlign == null || $5b0ace94e7e58ea5$var$VALID_TEXT_VERTICAL_ALIGN[textVerticalAlign] ? textVerticalAlign : "top";
        var textPadding = style.textPadding;
        if (textPadding) style.textPadding = $5b0ace94e7e58ea5$var$normalizeCssArray(style.textPadding);
    }
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {string} text
 * @param {module:zrender/graphic/Style} style
 * @param {Object|boolean} [rect] {x, y, width, height}
 *                  If set false, rect text is not used.
 * @param {Element|module:zrender/graphic/helper/constant.WILL_BE_RESTORED} [prevEl] For ctx prop cache.
 */ function $5b0ace94e7e58ea5$var$renderText(hostEl, ctx, text, style, rect, prevEl) {
    style.rich ? $5b0ace94e7e58ea5$var$renderRichText(hostEl, ctx, text, style, rect, prevEl) : $5b0ace94e7e58ea5$var$renderPlainText(hostEl, ctx, text, style, rect, prevEl);
} // Avoid setting to ctx according to prevEl if possible for
// performance in scenarios of large amount text.
function $5b0ace94e7e58ea5$var$renderPlainText(hostEl, ctx, text, style, rect, prevEl) {
    "use strict";
    var needDrawBg = $5b0ace94e7e58ea5$var$needDrawBackground(style);
    var prevStyle;
    var checkCache = false;
    var cachedByMe = ctx.__attrCachedBy === $5b0ace94e7e58ea5$var$ContextCachedBy.PLAIN_TEXT; // Only take and check cache for `Text` el, but not RectText.
    if (prevEl !== $5b0ace94e7e58ea5$var$WILL_BE_RESTORED) {
        if (prevEl) {
            prevStyle = prevEl.style;
            checkCache = !needDrawBg && cachedByMe && prevStyle;
        } // Prevent from using cache in `Style::bind`, because of the case:
        // ctx property is modified by other properties than `Style::bind`
        // used, and Style::bind is called next.
        ctx.__attrCachedBy = needDrawBg ? $5b0ace94e7e58ea5$var$ContextCachedBy.NONE : $5b0ace94e7e58ea5$var$ContextCachedBy.PLAIN_TEXT;
    } else if (cachedByMe) ctx.__attrCachedBy = $5b0ace94e7e58ea5$var$ContextCachedBy.NONE;
    var styleFont = style.font || $5b0ace94e7e58ea5$var$DEFAULT_FONT; // PENDING
    // Only `Text` el set `font` and keep it (`RectText` will restore). So theoretically
    // we can make font cache on ctx, which can cache for text el that are discontinuous.
    // But layer save/restore needed to be considered.
    // if (styleFont !== ctx.__fontCache) {
    //     ctx.font = styleFont;
    //     if (prevEl !== WILL_BE_RESTORED) {
    //         ctx.__fontCache = styleFont;
    //     }
    // }
    if (!checkCache || styleFont !== (prevStyle.font || $5b0ace94e7e58ea5$var$DEFAULT_FONT)) ctx.font = styleFont;
     // Use the final font from context-2d, because the final
    // font might not be the style.font when it is illegal.
    // But get `ctx.font` might be time consuming.
    var computedFont = hostEl.__computedFont;
    if (hostEl.__styleFont !== styleFont) {
        hostEl.__styleFont = styleFont;
        computedFont = hostEl.__computedFont = ctx.font;
    }
    var textPadding = style.textPadding;
    var textLineHeight = style.textLineHeight;
    var contentBlock = hostEl.__textCotentBlock;
    if (!contentBlock || hostEl.__dirtyText) contentBlock = hostEl.__textCotentBlock = $ebae9c4ebc22906c$export$5772575e34ef80f9(text, computedFont, textPadding, textLineHeight, style.truncate);
    var outerHeight = contentBlock.outerHeight;
    var textLines = contentBlock.lines;
    var lineHeight = contentBlock.lineHeight;
    var boxPos = $5b0ace94e7e58ea5$var$getBoxPosition($5b0ace94e7e58ea5$var$_tmpBoxPositionResult, hostEl, style, rect);
    var baseX = boxPos.baseX;
    var baseY = boxPos.baseY;
    var textAlign = boxPos.textAlign || "left";
    var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.
    $5b0ace94e7e58ea5$var$applyTextRotation(ctx, style, rect, baseX, baseY);
    var boxY = $ebae9c4ebc22906c$export$bf7d6802d2badd9(baseY, outerHeight, textVerticalAlign);
    var textX = baseX;
    var textY = boxY;
    if (needDrawBg || textPadding) {
        // Consider performance, do not call getTextWidth util necessary.
        var textWidth = $ebae9c4ebc22906c$export$3c49c185de0c2bfc(text, computedFont);
        var outerWidth = textWidth;
        textPadding && (outerWidth += textPadding[1] + textPadding[3]);
        var boxX = $ebae9c4ebc22906c$export$eb5a525ef00ef9a4(baseX, outerWidth, textAlign);
        needDrawBg && $5b0ace94e7e58ea5$var$drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);
        if (textPadding) {
            textX = $5b0ace94e7e58ea5$var$getTextXForPadding(baseX, textAlign, textPadding);
            textY += textPadding[0];
        }
    } // Always set textAlign and textBase line, because it is difficute to calculate
    // textAlign from prevEl, and we dont sure whether textAlign will be reset if
    // font set happened.
    ctx.textAlign = textAlign; // Force baseline to be "middle". Otherwise, if using "top", the
    // text will offset downward a little bit in font "Microsoft YaHei".
    ctx.textBaseline = "middle"; // Set text opacity
    ctx.globalAlpha = style.opacity || 1; // Always set shadowBlur and shadowOffset to avoid leak from displayable.
    for(var i = 0; i < $5b0ace94e7e58ea5$var$SHADOW_STYLE_COMMON_PROPS.length; i++){
        var propItem = $5b0ace94e7e58ea5$var$SHADOW_STYLE_COMMON_PROPS[i];
        var styleProp = propItem[0];
        var ctxProp = propItem[1];
        var val = style[styleProp];
        if (!checkCache || val !== prevStyle[styleProp]) ctx[ctxProp] = $280192321eaabe79$exports(ctx, ctxProp, val || propItem[2]);
    } // `textBaseline` is set as 'middle'.
    textY += lineHeight / 2;
    var textStrokeWidth = style.textStrokeWidth;
    var textStrokeWidthPrev = checkCache ? prevStyle.textStrokeWidth : null;
    var strokeWidthChanged = !checkCache || textStrokeWidth !== textStrokeWidthPrev;
    var strokeChanged = !checkCache || strokeWidthChanged || style.textStroke !== prevStyle.textStroke;
    var textStroke = $5b0ace94e7e58ea5$var$getStroke(style.textStroke, textStrokeWidth);
    var textFill = $5b0ace94e7e58ea5$var$getFill(style.textFill);
    if (textStroke) {
        if (strokeWidthChanged) ctx.lineWidth = textStrokeWidth;
        if (strokeChanged) ctx.strokeStyle = textStroke;
    }
    if (textFill) {
        if (!checkCache || style.textFill !== prevStyle.textFill) ctx.fillStyle = textFill;
    } // Optimize simply, in most cases only one line exists.
    if (textLines.length === 1) {
        // Fill after stroke so the outline will not cover the main part.
        textStroke && ctx.strokeText(textLines[0], textX, textY);
        textFill && ctx.fillText(textLines[0], textX, textY);
    } else for(var i = 0; i < textLines.length; i++){
        // Fill after stroke so the outline will not cover the main part.
        textStroke && ctx.strokeText(textLines[i], textX, textY);
        textFill && ctx.fillText(textLines[i], textX, textY);
        textY += lineHeight;
    }
}
function $5b0ace94e7e58ea5$var$renderRichText(hostEl, ctx, text, style, rect, prevEl) {
    // Do not do cache for rich text because of the complexity.
    // But `RectText` this will be restored, do not need to clear other cache like `Style::bind`.
    if (prevEl !== $5b0ace94e7e58ea5$var$WILL_BE_RESTORED) ctx.__attrCachedBy = $5b0ace94e7e58ea5$var$ContextCachedBy.NONE;
    var contentBlock = hostEl.__textCotentBlock;
    if (!contentBlock || hostEl.__dirtyText) contentBlock = hostEl.__textCotentBlock = $ebae9c4ebc22906c$export$15ec9472ff2d721(text, style);
    $5b0ace94e7e58ea5$var$drawRichText(hostEl, ctx, contentBlock, style, rect);
}
function $5b0ace94e7e58ea5$var$drawRichText(hostEl, ctx, contentBlock, style, rect) {
    var contentWidth = contentBlock.width;
    var outerWidth = contentBlock.outerWidth;
    var outerHeight = contentBlock.outerHeight;
    var textPadding = style.textPadding;
    var boxPos = $5b0ace94e7e58ea5$var$getBoxPosition($5b0ace94e7e58ea5$var$_tmpBoxPositionResult, hostEl, style, rect);
    var baseX = boxPos.baseX;
    var baseY = boxPos.baseY;
    var textAlign = boxPos.textAlign;
    var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.
    $5b0ace94e7e58ea5$var$applyTextRotation(ctx, style, rect, baseX, baseY);
    var boxX = $ebae9c4ebc22906c$export$eb5a525ef00ef9a4(baseX, outerWidth, textAlign);
    var boxY = $ebae9c4ebc22906c$export$bf7d6802d2badd9(baseY, outerHeight, textVerticalAlign);
    var xLeft = boxX;
    var lineTop = boxY;
    if (textPadding) {
        xLeft += textPadding[3];
        lineTop += textPadding[0];
    }
    var xRight = xLeft + contentWidth;
    $5b0ace94e7e58ea5$var$needDrawBackground(style) && $5b0ace94e7e58ea5$var$drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);
    for(var i = 0; i < contentBlock.lines.length; i++){
        var line = contentBlock.lines[i];
        var tokens = line.tokens;
        var tokenCount = tokens.length;
        var lineHeight = line.lineHeight;
        var usedWidth = line.width;
        var leftIndex = 0;
        var lineXLeft = xLeft;
        var lineXRight = xRight;
        var rightIndex = tokenCount - 1;
        var token;
        while(leftIndex < tokenCount && (token = tokens[leftIndex], !token.textAlign || token.textAlign === "left")){
            $5b0ace94e7e58ea5$var$placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft, "left");
            usedWidth -= token.width;
            lineXLeft += token.width;
            leftIndex++;
        }
        while(rightIndex >= 0 && (token = tokens[rightIndex], token.textAlign === "right")){
            $5b0ace94e7e58ea5$var$placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXRight, "right");
            usedWidth -= token.width;
            lineXRight -= token.width;
            rightIndex--;
        } // The other tokens are placed as textAlign 'center' if there is enough space.
        lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - usedWidth) / 2;
        while(leftIndex <= rightIndex){
            token = tokens[leftIndex]; // Consider width specified by user, use 'center' rather than 'left'.
            $5b0ace94e7e58ea5$var$placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft + token.width / 2, "center");
            lineXLeft += token.width;
            leftIndex++;
        }
        lineTop += lineHeight;
    }
}
function $5b0ace94e7e58ea5$var$applyTextRotation(ctx, style, rect, x, y) {
    // textRotation only apply in RectText.
    if (rect && style.textRotation) {
        var origin = style.textOrigin;
        if (origin === "center") {
            x = rect.width / 2 + rect.x;
            y = rect.height / 2 + rect.y;
        } else if (origin) {
            x = origin[0] + rect.x;
            y = origin[1] + rect.y;
        }
        ctx.translate(x, y); // Positive: anticlockwise
        ctx.rotate(-style.textRotation);
        ctx.translate(-x, -y);
    }
}
function $5b0ace94e7e58ea5$var$placeToken(hostEl, ctx, token, style, lineHeight, lineTop, x, textAlign) {
    var tokenStyle = style.rich[token.styleName] || {};
    tokenStyle.text = token.text; // 'ctx.textBaseline' is always set as 'middle', for sake of
    // the bias of "Microsoft YaHei".
    var textVerticalAlign = token.textVerticalAlign;
    var y = lineTop + lineHeight / 2;
    if (textVerticalAlign === "top") y = lineTop + token.height / 2;
    else if (textVerticalAlign === "bottom") y = lineTop + lineHeight - token.height / 2;
    !token.isLineHolder && $5b0ace94e7e58ea5$var$needDrawBackground(tokenStyle) && $5b0ace94e7e58ea5$var$drawBackground(hostEl, ctx, tokenStyle, textAlign === "right" ? x - token.width : textAlign === "center" ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
    var textPadding = token.textPadding;
    if (textPadding) {
        x = $5b0ace94e7e58ea5$var$getTextXForPadding(x, textAlign, textPadding);
        y -= token.height / 2 - textPadding[2] - token.textHeight / 2;
    }
    $5b0ace94e7e58ea5$var$setCtx(ctx, "shadowBlur", $5b0ace94e7e58ea5$var$retrieve3(tokenStyle.textShadowBlur, style.textShadowBlur, 0));
    $5b0ace94e7e58ea5$var$setCtx(ctx, "shadowColor", tokenStyle.textShadowColor || style.textShadowColor || "transparent");
    $5b0ace94e7e58ea5$var$setCtx(ctx, "shadowOffsetX", $5b0ace94e7e58ea5$var$retrieve3(tokenStyle.textShadowOffsetX, style.textShadowOffsetX, 0));
    $5b0ace94e7e58ea5$var$setCtx(ctx, "shadowOffsetY", $5b0ace94e7e58ea5$var$retrieve3(tokenStyle.textShadowOffsetY, style.textShadowOffsetY, 0));
    $5b0ace94e7e58ea5$var$setCtx(ctx, "textAlign", textAlign); // Force baseline to be "middle". Otherwise, if using "top", the
    // text will offset downward a little bit in font "Microsoft YaHei".
    $5b0ace94e7e58ea5$var$setCtx(ctx, "textBaseline", "middle");
    $5b0ace94e7e58ea5$var$setCtx(ctx, "font", token.font || $5b0ace94e7e58ea5$var$DEFAULT_FONT);
    var textStroke = $5b0ace94e7e58ea5$var$getStroke(tokenStyle.textStroke || style.textStroke, textStrokeWidth);
    var textFill = $5b0ace94e7e58ea5$var$getFill(tokenStyle.textFill || style.textFill);
    var textStrokeWidth = $5b0ace94e7e58ea5$var$retrieve2(tokenStyle.textStrokeWidth, style.textStrokeWidth); // Fill after stroke so the outline will not cover the main part.
    if (textStroke) {
        $5b0ace94e7e58ea5$var$setCtx(ctx, "lineWidth", textStrokeWidth);
        $5b0ace94e7e58ea5$var$setCtx(ctx, "strokeStyle", textStroke);
        ctx.strokeText(token.text, x, y);
    }
    if (textFill) {
        $5b0ace94e7e58ea5$var$setCtx(ctx, "fillStyle", textFill);
        ctx.fillText(token.text, x, y);
    }
}
function $5b0ace94e7e58ea5$var$needDrawBackground(style) {
    return !!(style.textBackgroundColor || style.textBorderWidth && style.textBorderColor);
} // style: {textBackgroundColor, textBorderWidth, textBorderColor, textBorderRadius, text}
// shape: {x, y, width, height}
function $5b0ace94e7e58ea5$var$drawBackground(hostEl, ctx, style, x, y, width, height) {
    var textBackgroundColor = style.textBackgroundColor;
    var textBorderWidth = style.textBorderWidth;
    var textBorderColor = style.textBorderColor;
    var isPlainBg = $5b0ace94e7e58ea5$var$isString(textBackgroundColor);
    $5b0ace94e7e58ea5$var$setCtx(ctx, "shadowBlur", style.textBoxShadowBlur || 0);
    $5b0ace94e7e58ea5$var$setCtx(ctx, "shadowColor", style.textBoxShadowColor || "transparent");
    $5b0ace94e7e58ea5$var$setCtx(ctx, "shadowOffsetX", style.textBoxShadowOffsetX || 0);
    $5b0ace94e7e58ea5$var$setCtx(ctx, "shadowOffsetY", style.textBoxShadowOffsetY || 0);
    if (isPlainBg || textBorderWidth && textBorderColor) {
        ctx.beginPath();
        var textBorderRadius = style.textBorderRadius;
        if (!textBorderRadius) ctx.rect(x, y, width, height);
        else $0d3fae5dbee73a0d$export$5cc7f731b5937e99(ctx, {
            x: x,
            y: y,
            width: width,
            height: height,
            r: textBorderRadius
        });
        ctx.closePath();
    }
    if (isPlainBg) {
        $5b0ace94e7e58ea5$var$setCtx(ctx, "fillStyle", textBackgroundColor);
        if (style.fillOpacity != null) {
            var originalGlobalAlpha = ctx.globalAlpha;
            ctx.globalAlpha = style.fillOpacity * style.opacity;
            ctx.fill();
            ctx.globalAlpha = originalGlobalAlpha;
        } else ctx.fill();
    } else if ($5b0ace94e7e58ea5$var$isObject(textBackgroundColor)) {
        var image = textBackgroundColor.image;
        image = $b934863425020c49$export$46c791b69ff9a0f(image, null, hostEl, $5b0ace94e7e58ea5$var$onBgImageLoaded, textBackgroundColor);
        if (image && $b934863425020c49$export$37ca7dd901d0236d(image)) ctx.drawImage(image, x, y, width, height);
    }
    if (textBorderWidth && textBorderColor) {
        $5b0ace94e7e58ea5$var$setCtx(ctx, "lineWidth", textBorderWidth);
        $5b0ace94e7e58ea5$var$setCtx(ctx, "strokeStyle", textBorderColor);
        if (style.strokeOpacity != null) {
            var originalGlobalAlpha = ctx.globalAlpha;
            ctx.globalAlpha = style.strokeOpacity * style.opacity;
            ctx.stroke();
            ctx.globalAlpha = originalGlobalAlpha;
        } else ctx.stroke();
    }
}
function $5b0ace94e7e58ea5$var$onBgImageLoaded(image, textBackgroundColor) {
    // Replace image, so that `contain/text.js#parseRichText`
    // will get correct result in next tick.
    textBackgroundColor.image = image;
}
function $5b0ace94e7e58ea5$var$getBoxPosition(out, hostEl, style, rect) {
    var baseX = style.x || 0;
    var baseY = style.y || 0;
    var textAlign = style.textAlign;
    var textVerticalAlign = style.textVerticalAlign; // Text position represented by coord
    if (rect) {
        var textPosition = style.textPosition;
        if (textPosition instanceof Array) {
            // Percent
            baseX = rect.x + $5b0ace94e7e58ea5$var$parsePercent(textPosition[0], rect.width);
            baseY = rect.y + $5b0ace94e7e58ea5$var$parsePercent(textPosition[1], rect.height);
        } else {
            var res = hostEl && hostEl.calculateTextPosition ? hostEl.calculateTextPosition($5b0ace94e7e58ea5$var$_tmpTextPositionResult, style, rect) : $ebae9c4ebc22906c$export$eee3603b512feab7($5b0ace94e7e58ea5$var$_tmpTextPositionResult, style, rect);
            baseX = res.x;
            baseY = res.y; // Default align and baseline when has textPosition
            textAlign = textAlign || res.textAlign;
            textVerticalAlign = textVerticalAlign || res.textVerticalAlign;
        } // textOffset is only support in RectText, otherwise
        // we have to adjust boundingRect for textOffset.
        var textOffset = style.textOffset;
        if (textOffset) {
            baseX += textOffset[0];
            baseY += textOffset[1];
        }
    }
    out = out || {};
    out.baseX = baseX;
    out.baseY = baseY;
    out.textAlign = textAlign;
    out.textVerticalAlign = textVerticalAlign;
    return out;
}
function $5b0ace94e7e58ea5$var$setCtx(ctx, prop, value) {
    ctx[prop] = $280192321eaabe79$exports(ctx, prop, value);
    return ctx[prop];
}
/**
 * @param {string} [stroke] If specified, do not check style.textStroke.
 * @param {string} [lineWidth] If specified, do not check style.textStroke.
 * @param {number} style
 */ function $5b0ace94e7e58ea5$var$getStroke(stroke, lineWidth) {
    return stroke == null || lineWidth <= 0 || stroke === "transparent" || stroke === "none" ? null // TODO pattern and gradient?
     : stroke.image || stroke.colorStops ? "#000" : stroke;
}
function $5b0ace94e7e58ea5$var$getFill(fill) {
    return fill == null || fill === "none" ? null // TODO pattern and gradient?
     : fill.image || fill.colorStops ? "#000" : fill;
}
function $5b0ace94e7e58ea5$var$parsePercent(value, maxValue) {
    if (typeof value === "string") {
        if (value.lastIndexOf("%") >= 0) return parseFloat(value) / 100 * maxValue;
        return parseFloat(value);
    }
    return value;
}
function $5b0ace94e7e58ea5$var$getTextXForPadding(x, textAlign, textPadding) {
    return textAlign === "right" ? x - textPadding[1] : textAlign === "center" ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
/**
 * @param {string} text
 * @param {module:zrender/Style} style
 * @return {boolean}
 */ function $5b0ace94e7e58ea5$var$needDrawText(text, style) {
    return text != null && (text || style.textBackgroundColor || style.textBorderWidth && style.textBorderColor || style.textPadding);
}
$5b0ace94e7e58ea5$export$176336068cc5371f = $5b0ace94e7e58ea5$var$normalizeTextStyle;
$5b0ace94e7e58ea5$export$482c90f94eb9717c = $5b0ace94e7e58ea5$var$renderText;
$5b0ace94e7e58ea5$export$13cc41b670c23b93 = $5b0ace94e7e58ea5$var$getBoxPosition;
$5b0ace94e7e58ea5$export$d5e7b8855b0b151b = $5b0ace94e7e58ea5$var$getStroke;
$5b0ace94e7e58ea5$export$2ca749095fe16708 = $5b0ace94e7e58ea5$var$getFill;
$5b0ace94e7e58ea5$export$e8514cb5a5e2b40f = $5b0ace94e7e58ea5$var$parsePercent;
$5b0ace94e7e58ea5$export$15f386d282805840 = $5b0ace94e7e58ea5$var$needDrawText;




var $b82ede1bca894b3a$var$WILL_BE_RESTORED = $e1470dc860948586$export$25a5d7762d753e59;
/**
 * Mixin for drawing text in a element bounding rect
 * @module zrender/mixin/RectText
 */ var $b82ede1bca894b3a$var$tmpRect = new $33e4fae744d34798$exports();
var $b82ede1bca894b3a$var$RectText = function() {};
$b82ede1bca894b3a$var$RectText.prototype = {
    constructor: $b82ede1bca894b3a$var$RectText,
    /**
   * Draw text in a rect with specified position.
   * @param  {CanvasRenderingContext2D} ctx
   * @param  {Object} rect Displayable rect
   */ drawRectText: function(ctx, rect) {
        var style = this.style;
        rect = style.textRect || rect; // Optimize, avoid normalize every time.
        this.__dirty && $5b0ace94e7e58ea5$export$176336068cc5371f(style, true);
        var text = style.text; // Convert to string
        text != null && (text += "");
        if (!$5b0ace94e7e58ea5$export$15f386d282805840(text, style)) return;
         // FIXME
        // Do not provide prevEl to `textHelper.renderText` for ctx prop cache,
        // but use `ctx.save()` and `ctx.restore()`. Because the cache for rect
        // text propably break the cache for its host elements.
        ctx.save(); // Transform rect to view space
        var transform = this.transform;
        if (!style.transformText) {
            if (transform) {
                $b82ede1bca894b3a$var$tmpRect.copy(rect);
                $b82ede1bca894b3a$var$tmpRect.applyTransform(transform);
                rect = $b82ede1bca894b3a$var$tmpRect;
            }
        } else this.setTransform(ctx);
         // transformText and textRotation can not be used at the same time.
        $5b0ace94e7e58ea5$export$482c90f94eb9717c(this, ctx, text, style, rect, $b82ede1bca894b3a$var$WILL_BE_RESTORED);
        ctx.restore();
    }
};
var $b82ede1bca894b3a$var$_default = $b82ede1bca894b3a$var$RectText;
$b82ede1bca894b3a$exports = $b82ede1bca894b3a$var$_default;


/**
 * Base class of all displayable graphic objects
 * @module zrender/graphic/Displayable
 */ /**
 * @alias module:zrender/graphic/Displayable
 * @extends module:zrender/Element
 * @extends module:zrender/graphic/mixin/RectText
 */ function $f95b0c44904a541d$var$Displayable(opts) {
    opts = opts || {};
    $e85cd217b6cf99d0$exports.call(this, opts); // Extend properties
    for(var name in opts)if (opts.hasOwnProperty(name) && name !== "style") this[name] = opts[name];
    /**
   * @type {module:zrender/graphic/Style}
   */ this.style = new $5138c5bbf976c46c$exports(opts.style, this);
    this._rect = null; // Shapes for cascade clipping.
    // Can only be `null`/`undefined` or an non-empty array, MUST NOT be an empty array.
    // because it is easy to only using null to check whether clipPaths changed.
    this.__clipPaths = null; // FIXME Stateful must be mixined after style is setted
// Stateful.call(this, opts);
}
$f95b0c44904a541d$var$Displayable.prototype = {
    constructor: $f95b0c44904a541d$var$Displayable,
    type: "displayable",
    /**
   * Dirty flag. From which painter will determine if this displayable object needs brush.
   * @name module:zrender/graphic/Displayable#__dirty
   * @type {boolean}
   */ __dirty: true,
    /**
   * Whether the displayable object is visible. when it is true, the displayable object
   * is not drawn, but the mouse event can still trigger the object.
   * @name module:/zrender/graphic/Displayable#invisible
   * @type {boolean}
   * @default false
   */ invisible: false,
    /**
   * @name module:/zrender/graphic/Displayable#z
   * @type {number}
   * @default 0
   */ z: 0,
    /**
   * @name module:/zrender/graphic/Displayable#z
   * @type {number}
   * @default 0
   */ z2: 0,
    /**
   * The z level determines the displayable object can be drawn in which layer canvas.
   * @name module:/zrender/graphic/Displayable#zlevel
   * @type {number}
   * @default 0
   */ zlevel: 0,
    /**
   * Whether it can be dragged.
   * @name module:/zrender/graphic/Displayable#draggable
   * @type {boolean}
   * @default false
   */ draggable: false,
    /**
   * Whether is it dragging.
   * @name module:/zrender/graphic/Displayable#draggable
   * @type {boolean}
   * @default false
   */ dragging: false,
    /**
   * Whether to respond to mouse events.
   * @name module:/zrender/graphic/Displayable#silent
   * @type {boolean}
   * @default false
   */ silent: false,
    /**
   * If enable culling
   * @type {boolean}
   * @default false
   */ culling: false,
    /**
   * Mouse cursor when hovered
   * @name module:/zrender/graphic/Displayable#cursor
   * @type {string}
   */ cursor: "pointer",
    /**
   * If hover area is bounding rect
   * @name module:/zrender/graphic/Displayable#rectHover
   * @type {string}
   */ rectHover: false,
    /**
   * Render the element progressively when the value >= 0,
   * usefull for large data.
   * @type {boolean}
   */ progressive: false,
    /**
   * @type {boolean}
   */ incremental: false,
    /**
   * Scale ratio for global scale.
   * @type {boolean}
   */ globalScaleRatio: 1,
    beforeBrush: function(ctx) {},
    afterBrush: function(ctx) {},
    /**
   * Graphic drawing method.
   * @param {CanvasRenderingContext2D} ctx
   */ // Interface
    brush: function(ctx, prevEl) {},
    /**
   * Get the minimum bounding box.
   * @return {module:zrender/core/BoundingRect}
   */ // Interface
    getBoundingRect: function() {},
    /**
   * If displayable element contain coord x, y
   * @param  {number} x
   * @param  {number} y
   * @return {boolean}
   */ contain: function(x, y) {
        return this.rectContain(x, y);
    },
    /**
   * @param  {Function} cb
   * @param  {}   context
   */ traverse: function(cb, context) {
        cb.call(context, this);
    },
    /**
   * If bounding rect of element contain coord x, y
   * @param  {number} x
   * @param  {number} y
   * @return {boolean}
   */ rectContain: function(x, y) {
        var coord = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        return rect.contain(coord[0], coord[1]);
    },
    /**
   * Mark displayable element dirty and refresh next frame
   */ dirty: function() {
        this.__dirty = this.__dirtyText = true;
        this._rect = null;
        this.__zr && this.__zr.refresh();
    },
    /**
   * If displayable object binded any event
   * @return {boolean}
   */ // TODO, events bound by bind
    // isSilent: function () {
    //     return !(
    //         this.hoverable || this.draggable
    //         || this.onmousemove || this.onmouseover || this.onmouseout
    //         || this.onmousedown || this.onmouseup || this.onclick
    //         || this.ondragenter || this.ondragover || this.ondragleave
    //         || this.ondrop
    //     );
    // },
    /**
   * Alias for animate('style')
   * @param {boolean} loop
   */ animateStyle: function(loop) {
        return this.animate("style", loop);
    },
    attrKV: function(key, value) {
        if (key !== "style") $e85cd217b6cf99d0$exports.prototype.attrKV.call(this, key, value);
        else this.style.set(value);
    },
    /**
   * @param {Object|string} key
   * @param {*} value
   */ setStyle: function(key, value) {
        this.style.set(key, value);
        this.dirty(false);
        return this;
    },
    /**
   * Use given style object
   * @param  {Object} obj
   */ useStyle: function(obj) {
        this.style = new $5138c5bbf976c46c$exports(obj, this);
        this.dirty(false);
        return this;
    },
    /**
   * The string value of `textPosition` needs to be calculated to a real postion.
   * For example, `'inside'` is calculated to `[rect.width/2, rect.height/2]`
   * by default. See `contain/text.js#calculateTextPosition` for more details.
   * But some coutom shapes like "pin", "flag" have center that is not exactly
   * `[width/2, height/2]`. So we provide this hook to customize the calculation
   * for those shapes. It will be called if the `style.textPosition` is a string.
   * @param {Obejct} [out] Prepared out object. If not provided, this method should
   *        be responsible for creating one.
   * @param {module:zrender/graphic/Style} style
   * @param {Object} rect {x, y, width, height}
   * @return {Obejct} out The same as the input out.
   *         {
   *             x: number. mandatory.
   *             y: number. mandatory.
   *             textAlign: string. optional. use style.textAlign by default.
   *             textVerticalAlign: string. optional. use style.textVerticalAlign by default.
   *         }
   */ calculateTextPosition: null
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($f95b0c44904a541d$var$Displayable, $e85cd217b6cf99d0$exports);
$ec279652dd95c27b$export$e36fc9d62a853069($f95b0c44904a541d$var$Displayable, $b82ede1bca894b3a$exports); // zrUtil.mixin(Displayable, Stateful);
var $f95b0c44904a541d$var$_default = $f95b0c44904a541d$var$Displayable;
$f95b0c44904a541d$exports = $f95b0c44904a541d$var$_default;





/**
 * @alias zrender/graphic/Image
 * @extends module:zrender/graphic/Displayable
 * @constructor
 * @param {Object} opts
 */ function $8d11db19115b899b$var$ZImage(opts) {
    $f95b0c44904a541d$exports.call(this, opts);
}
$8d11db19115b899b$var$ZImage.prototype = {
    constructor: $8d11db19115b899b$var$ZImage,
    type: "image",
    brush: function(ctx, prevEl) {
        var style = this.style;
        var src = style.image; // Must bind each time
        style.bind(ctx, this, prevEl);
        var image = this._image = $b934863425020c49$export$46c791b69ff9a0f(src, this._image, this, this.onload);
        if (!image || !$b934863425020c49$export$37ca7dd901d0236d(image)) return;
         // 图片已经加载完成
        // if (image.nodeName.toUpperCase() == 'IMG') {
        //     if (!image.complete) {
        //         return;
        //     }
        // }
        // Else is canvas
        var x = style.x || 0;
        var y = style.y || 0;
        var width = style.width;
        var height = style.height;
        var aspect = image.width / image.height;
        if (width == null && height != null) // Keep image/height ratio
        width = height * aspect;
        else if (height == null && width != null) height = width / aspect;
        else if (width == null && height == null) {
            width = image.width;
            height = image.height;
        } // 设置transform
        this.setTransform(ctx);
        if (style.sWidth && style.sHeight) {
            var sx = style.sx || 0;
            var sy = style.sy || 0;
            ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
        } else if (style.sx && style.sy) {
            var sx = style.sx;
            var sy = style.sy;
            var sWidth = width - sx;
            var sHeight = height - sy;
            ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
        } else ctx.drawImage(image, x, y, width, height);
         // Draw rect text
        if (style.text != null) {
            // Only restore transform when needs draw text.
            this.restoreTransform(ctx);
            this.drawRectText(ctx, this.getBoundingRect());
        }
    },
    getBoundingRect: function() {
        var style = this.style;
        if (!this._rect) this._rect = new $33e4fae744d34798$exports(style.x || 0, style.y || 0, style.width || 0, style.height || 0);
        return this._rect;
    }
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($8d11db19115b899b$var$ZImage, $f95b0c44904a541d$exports);
var $8d11db19115b899b$var$_default = $8d11db19115b899b$var$ZImage;
$8d11db19115b899b$exports = $8d11db19115b899b$var$_default;



var $17b58207a6548df7$var$HOVER_LAYER_ZLEVEL = 1e5;
var $17b58207a6548df7$var$CANVAS_ZLEVEL = 314159;
var $17b58207a6548df7$var$EL_AFTER_INCREMENTAL_INC = 0.01;
var $17b58207a6548df7$var$INCREMENTAL_INC = 0.001;
function $17b58207a6548df7$var$parseInt10(val) {
    return parseInt(val, 10);
}
function $17b58207a6548df7$var$isLayerValid(layer) {
    if (!layer) return false;
    if (layer.__builtin__) return true;
    if (typeof layer.resize !== "function" || typeof layer.refresh !== "function") return false;
    return true;
}
var $17b58207a6548df7$var$tmpRect = new $33e4fae744d34798$exports(0, 0, 0, 0);
var $17b58207a6548df7$var$viewRect = new $33e4fae744d34798$exports(0, 0, 0, 0);
function $17b58207a6548df7$var$isDisplayableCulled(el, width, height) {
    $17b58207a6548df7$var$tmpRect.copy(el.getBoundingRect());
    if (el.transform) $17b58207a6548df7$var$tmpRect.applyTransform(el.transform);
    $17b58207a6548df7$var$viewRect.width = width;
    $17b58207a6548df7$var$viewRect.height = height;
    return !$17b58207a6548df7$var$tmpRect.intersect($17b58207a6548df7$var$viewRect);
}
function $17b58207a6548df7$var$isClipPathChanged(clipPaths, prevClipPaths) {
    // displayable.__clipPaths can only be `null`/`undefined` or an non-empty array.
    if (clipPaths === prevClipPaths) return false;
    if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) return true;
    for(var i = 0; i < clipPaths.length; i++){
        if (clipPaths[i] !== prevClipPaths[i]) return true;
    }
    return false;
}
function $17b58207a6548df7$var$doClip(clipPaths, ctx) {
    for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        clipPath.setTransform(ctx);
        ctx.beginPath();
        clipPath.buildPath(ctx, clipPath.shape);
        ctx.clip(); // Transform back
        clipPath.restoreTransform(ctx);
    }
}
function $17b58207a6548df7$var$createRoot(width, height) {
    var domRoot = document.createElement("div"); // domRoot.onselectstart = returnFalse; // Avoid page selected
    domRoot.style.cssText = [
        "position:relative",
        // dom does not act as expected) when some of the parent dom has
        // `-webkit-overflow-scrolling: touch;` and the webpage is longer than one screen and
        // the canvas is not at the top part of the page.
        // Check `https://bugs.webkit.org/show_bug.cgi?id=203681` for more details. We remove
        // this `overflow:hidden` to avoid the bug.
        // 'overflow:hidden',
        "width:" + width + "px",
        "height:" + height + "px",
        "padding:0",
        "margin:0",
        "border-width:0"
    ].join(";") + ";";
    return domRoot;
}
/**
 * @alias module:zrender/Painter
 * @constructor
 * @param {HTMLElement} root 绘图容器
 * @param {module:zrender/Storage} storage
 * @param {Object} opts
 */ var $17b58207a6548df7$var$Painter = function(root, storage, opts) {
    this.type = "canvas"; // In node environment using node-canvas
    var singleCanvas = !root.nodeName // In node ?
     || root.nodeName.toUpperCase() === "CANVAS";
    this._opts = opts = $ec279652dd95c27b$export$8b58be045bf06082({}, opts || {});
    /**
   * @type {number}
   */ this.dpr = opts.devicePixelRatio || $17b58207a6548df7$var$devicePixelRatio;
    /**
   * @type {boolean}
   * @private
   */ this._singleCanvas = singleCanvas;
    /**
   * 绘图容器
   * @type {HTMLElement}
   */ this.root = root;
    var rootStyle = root.style;
    if (rootStyle) {
        rootStyle["-webkit-tap-highlight-color"] = "transparent";
        rootStyle["-webkit-user-select"] = rootStyle["user-select"] = rootStyle["-webkit-touch-callout"] = "none";
        root.innerHTML = "";
    }
    /**
   * @type {module:zrender/Storage}
   */ this.storage = storage;
    /**
   * @type {Array.<number>}
   * @private
   */ var zlevelList = this._zlevelList = [];
    /**
   * @type {Object.<string, module:zrender/Layer>}
   * @private
   */ var layers = this._layers = {};
    /**
   * @type {Object.<string, Object>}
   * @private
   */ this._layerConfig = {};
    /**
   * zrender will do compositing when root is a canvas and have multiple zlevels.
   */ this._needsManuallyCompositing = false;
    if (!singleCanvas) {
        this._width = this._getSize(0);
        this._height = this._getSize(1);
        var domRoot = this._domRoot = $17b58207a6548df7$var$createRoot(this._width, this._height);
        root.appendChild(domRoot);
    } else {
        var width = root.width;
        var height = root.height;
        if (opts.width != null) width = opts.width;
        if (opts.height != null) height = opts.height;
        this.dpr = opts.devicePixelRatio || 1; // Use canvas width and height directly
        root.width = width * this.dpr;
        root.height = height * this.dpr;
        this._width = width;
        this._height = height; // Create layer if only one given canvas
        // Device can be specified to create a high dpi image.
        var mainLayer = new $a6a14a6f46c4cad0$exports(root, this, this.dpr);
        mainLayer.__builtin__ = true;
        mainLayer.initContext(); // FIXME Use canvas width and height
        // mainLayer.resize(width, height);
        layers[$17b58207a6548df7$var$CANVAS_ZLEVEL] = mainLayer;
        mainLayer.zlevel = $17b58207a6548df7$var$CANVAS_ZLEVEL; // Not use common zlevel.
        zlevelList.push($17b58207a6548df7$var$CANVAS_ZLEVEL);
        this._domRoot = root;
    }
    /**
   * @type {module:zrender/Layer}
   * @private
   */ this._hoverlayer = null;
    this._hoverElements = [];
};
$17b58207a6548df7$var$Painter.prototype = {
    constructor: $17b58207a6548df7$var$Painter,
    getType: function() {
        return "canvas";
    },
    /**
   * If painter use a single canvas
   * @return {boolean}
   */ isSingleCanvas: function() {
        return this._singleCanvas;
    },
    /**
   * @return {HTMLDivElement}
   */ getViewportRoot: function() {
        return this._domRoot;
    },
    getViewportRootOffset: function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    },
    /**
   * 刷新
   * @param {boolean} [paintAll=false] 强制绘制所有displayable
   */ refresh: function(paintAll) {
        var list = this.storage.getDisplayList(true);
        var zlevelList = this._zlevelList;
        this._redrawId = Math.random();
        this._paintList(list, paintAll, this._redrawId); // Paint custum layers
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__ && layer.refresh) {
                var clearColor = i === 0 ? this._backgroundColor : null;
                layer.refresh(clearColor);
            }
        }
        this.refreshHover();
        return this;
    },
    addHover: function(el, hoverStyle) {
        if (el.__hoverMir) return;
        var elMirror = new el.constructor({
            style: el.style,
            shape: el.shape,
            z: el.z,
            z2: el.z2,
            silent: el.silent
        });
        elMirror.__from = el;
        el.__hoverMir = elMirror;
        hoverStyle && elMirror.setStyle(hoverStyle);
        this._hoverElements.push(elMirror);
        return elMirror;
    },
    removeHover: function(el) {
        var elMirror = el.__hoverMir;
        var hoverElements = this._hoverElements;
        var idx = $ec279652dd95c27b$export$305f7d4e9d4624f2(hoverElements, elMirror);
        if (idx >= 0) hoverElements.splice(idx, 1);
        el.__hoverMir = null;
    },
    clearHover: function(el) {
        var hoverElements = this._hoverElements;
        for(var i = 0; i < hoverElements.length; i++){
            var from = hoverElements[i].__from;
            if (from) from.__hoverMir = null;
        }
        hoverElements.length = 0;
    },
    refreshHover: function() {
        var hoverElements = this._hoverElements;
        var len = hoverElements.length;
        var hoverLayer = this._hoverlayer;
        hoverLayer && hoverLayer.clear();
        if (!len) return;
        $7f3d4243ceebe2b3$exports(hoverElements, this.storage.displayableSortFunc); // Use a extream large zlevel
        // FIXME?
        if (!hoverLayer) hoverLayer = this._hoverlayer = this.getLayer($17b58207a6548df7$var$HOVER_LAYER_ZLEVEL);
        var scope = {};
        hoverLayer.ctx.save();
        for(var i = 0; i < len;){
            var el = hoverElements[i];
            var originalEl = el.__from; // Original el is removed
            // PENDING
            if (!(originalEl && originalEl.__zr)) {
                hoverElements.splice(i, 1);
                originalEl.__hoverMir = null;
                len--;
                continue;
            }
            i++; // Use transform
            // FIXME style and shape ?
            if (!originalEl.invisible) {
                el.transform = originalEl.transform;
                el.invTransform = originalEl.invTransform;
                el.__clipPaths = originalEl.__clipPaths; // el.
                this._doPaintEl(el, hoverLayer, true, scope);
            }
        }
        hoverLayer.ctx.restore();
    },
    getHoverLayer: function() {
        return this.getLayer($17b58207a6548df7$var$HOVER_LAYER_ZLEVEL);
    },
    _paintList: function(list, paintAll, redrawId) {
        if (this._redrawId !== redrawId) return;
        paintAll = paintAll || false;
        this._updateLayerStatus(list);
        var finished = this._doPaintList(list, paintAll);
        if (this._needsManuallyCompositing) this._compositeManually();
        if (!finished) {
            var self = this;
            $6351fcc6385a6fa9$exports(function() {
                self._paintList(list, paintAll, redrawId);
            });
        }
    },
    _compositeManually: function() {
        var ctx = this.getLayer($17b58207a6548df7$var$CANVAS_ZLEVEL).ctx;
        var width = this._domRoot.width;
        var height = this._domRoot.height;
        ctx.clearRect(0, 0, width, height); // PENDING, If only builtin layer?
        this.eachBuiltinLayer(function(layer) {
            if (layer.virtual) ctx.drawImage(layer.dom, 0, 0, width, height);
        });
    },
    _doPaintList: function(list, paintAll) {
        var layerList = [];
        for(var zi = 0; zi < this._zlevelList.length; zi++){
            var zlevel = this._zlevelList[zi];
            var layer = this._layers[zlevel];
            if (layer.__builtin__ && layer !== this._hoverlayer && (layer.__dirty || paintAll)) layerList.push(layer);
        }
        var finished = true;
        for(var k = 0; k < layerList.length; k++){
            var layer = layerList[k];
            var ctx = layer.ctx;
            var scope = {};
            ctx.save();
            var start = paintAll ? layer.__startIndex : layer.__drawIndex;
            var useTimer = !paintAll && layer.incremental && Date.now;
            var startTime = useTimer && Date.now();
            var clearColor = layer.zlevel === this._zlevelList[0] ? this._backgroundColor : null; // All elements in this layer are cleared.
            if (layer.__startIndex === layer.__endIndex) layer.clear(false, clearColor);
            else if (start === layer.__startIndex) {
                var firstEl = list[start];
                if (!firstEl.incremental || !firstEl.notClear || paintAll) layer.clear(false, clearColor);
            }
            if (start === -1) {
                console.error("For some unknown reason. drawIndex is -1");
                start = layer.__startIndex;
            }
            for(var i = start; i < layer.__endIndex; i++){
                var el = list[i];
                this._doPaintEl(el, layer, paintAll, scope);
                el.__dirty = el.__dirtyText = false;
                if (useTimer) {
                    // Date.now can be executed in 13,025,305 ops/second.
                    var dTime = Date.now() - startTime; // Give 15 millisecond to draw.
                    // The rest elements will be drawn in the next frame.
                    if (dTime > 15) break;
                }
            }
            layer.__drawIndex = i;
            if (layer.__drawIndex < layer.__endIndex) finished = false;
            if (scope.prevElClipPaths) // Needs restore the state. If last drawn element is in the clipping area.
            ctx.restore();
            ctx.restore();
        }
        if ($27ac1413ecc67076$exports.wxa) // Flush for weixin application
        $ec279652dd95c27b$export$79b2f7037acddd43(this._layers, function(layer) {
            if (layer && layer.ctx && layer.ctx.draw) layer.ctx.draw();
        });
        return finished;
    },
    _doPaintEl: function(el, currentLayer, forcePaint, scope) {
        var ctx = currentLayer.ctx;
        var m = el.transform;
        if ((currentLayer.__dirty || forcePaint) && // Ignore invisible element
        !el.invisible // Ignore transparent element
         && el.style.opacity !== 0 // Ignore scale 0 element, in some environment like node-canvas
         && !(m && !m[0] && !m[3] // Ignore culled element
        ) && !(el.culling && $17b58207a6548df7$var$isDisplayableCulled(el, this._width, this._height))) {
            var clipPaths = el.__clipPaths;
            var prevElClipPaths = scope.prevElClipPaths; // Optimize when clipping on group with several elements
            if (!prevElClipPaths || $17b58207a6548df7$var$isClipPathChanged(clipPaths, prevElClipPaths)) {
                // If has previous clipping state, restore from it
                if (prevElClipPaths) {
                    ctx.restore();
                    scope.prevElClipPaths = null; // Reset prevEl since context has been restored
                    scope.prevEl = null;
                } // New clipping state
                if (clipPaths) {
                    ctx.save();
                    $17b58207a6548df7$var$doClip(clipPaths, ctx);
                    scope.prevElClipPaths = clipPaths;
                }
            }
            el.beforeBrush && el.beforeBrush(ctx);
            el.brush(ctx, scope.prevEl || null);
            scope.prevEl = el;
            el.afterBrush && el.afterBrush(ctx);
        }
    },
    /**
   * 获取 zlevel 所在层，如果不存在则会创建一个新的层
   * @param {number} zlevel
   * @param {boolean} virtual Virtual layer will not be inserted into dom.
   * @return {module:zrender/Layer}
   */ getLayer: function(zlevel, virtual) {
        if (this._singleCanvas && !this._needsManuallyCompositing) zlevel = $17b58207a6548df7$var$CANVAS_ZLEVEL;
        var layer = this._layers[zlevel];
        if (!layer) {
            // Create a new layer
            layer = new $a6a14a6f46c4cad0$exports("zr_" + zlevel, this, this.dpr);
            layer.zlevel = zlevel;
            layer.__builtin__ = true;
            if (this._layerConfig[zlevel]) $ec279652dd95c27b$export$4950aa0f605343fb(layer, this._layerConfig[zlevel], true);
            else if (this._layerConfig[zlevel - $17b58207a6548df7$var$EL_AFTER_INCREMENTAL_INC]) $ec279652dd95c27b$export$4950aa0f605343fb(layer, this._layerConfig[zlevel - $17b58207a6548df7$var$EL_AFTER_INCREMENTAL_INC], true);
            if (virtual) layer.virtual = virtual;
            this.insertLayer(zlevel, layer); // Context is created after dom inserted to document
            // Or excanvas will get 0px clientWidth and clientHeight
            layer.initContext();
        }
        return layer;
    },
    insertLayer: function(zlevel, layer) {
        var layersMap = this._layers;
        var zlevelList = this._zlevelList;
        var len = zlevelList.length;
        var prevLayer = null;
        var i = -1;
        var domRoot = this._domRoot;
        if (layersMap[zlevel]) {
            $5067a17fa0db893f$exports("ZLevel " + zlevel + " has been used already");
            return;
        } // Check if is a valid layer
        if (!$17b58207a6548df7$var$isLayerValid(layer)) {
            $5067a17fa0db893f$exports("Layer of zlevel " + zlevel + " is not valid");
            return;
        }
        if (len > 0 && zlevel > zlevelList[0]) {
            for(i = 0; i < len - 1; i++){
                if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) break;
            }
            prevLayer = layersMap[zlevelList[i]];
        }
        zlevelList.splice(i + 1, 0, zlevel);
        layersMap[zlevel] = layer; // Vitual layer will not directly show on the screen.
        // (It can be a WebGL layer and assigned to a ZImage element)
        // But it still under management of zrender.
        if (!layer.virtual) {
            if (prevLayer) {
                var prevDom = prevLayer.dom;
                if (prevDom.nextSibling) domRoot.insertBefore(layer.dom, prevDom.nextSibling);
                else domRoot.appendChild(layer.dom);
            } else if (domRoot.firstChild) domRoot.insertBefore(layer.dom, domRoot.firstChild);
            else domRoot.appendChild(layer.dom);
        }
    },
    // Iterate each layer
    eachLayer: function(cb, context) {
        var zlevelList = this._zlevelList;
        var z;
        var i;
        for(i = 0; i < zlevelList.length; i++){
            z = zlevelList[i];
            cb.call(context, this._layers[z], z);
        }
    },
    // Iterate each buildin layer
    eachBuiltinLayer: function(cb, context) {
        var zlevelList = this._zlevelList;
        var layer;
        var z;
        var i;
        for(i = 0; i < zlevelList.length; i++){
            z = zlevelList[i];
            layer = this._layers[z];
            if (layer.__builtin__) cb.call(context, layer, z);
        }
    },
    // Iterate each other layer except buildin layer
    eachOtherLayer: function(cb, context) {
        var zlevelList = this._zlevelList;
        var layer;
        var z;
        var i;
        for(i = 0; i < zlevelList.length; i++){
            z = zlevelList[i];
            layer = this._layers[z];
            if (!layer.__builtin__) cb.call(context, layer, z);
        }
    },
    /**
   * 获取所有已创建的层
   * @param {Array.<module:zrender/Layer>} [prevLayer]
   */ getLayers: function() {
        return this._layers;
    },
    _updateLayerStatus: function(list) {
        this.eachBuiltinLayer(function(layer, z) {
            layer.__dirty = layer.__used = false;
        });
        function updatePrevLayer(idx) {
            if (prevLayer) {
                if (prevLayer.__endIndex !== idx) prevLayer.__dirty = true;
                prevLayer.__endIndex = idx;
            }
        }
        if (this._singleCanvas) for(var i = 1; i < list.length; i++){
            var el = list[i];
            if (el.zlevel !== list[i - 1].zlevel || el.incremental) {
                this._needsManuallyCompositing = true;
                break;
            }
        }
        var prevLayer = null;
        var incrementalLayerCount = 0;
        var prevZlevel;
        for(var i = 0; i < list.length; i++){
            var el = list[i];
            var zlevel = el.zlevel;
            var layer;
            if (prevZlevel !== zlevel) {
                prevZlevel = zlevel;
                incrementalLayerCount = 0;
            } // TODO Not use magic number on zlevel.
            // Each layer with increment element can be separated to 3 layers.
            //          (Other Element drawn after incremental element)
            // -----------------zlevel + EL_AFTER_INCREMENTAL_INC--------------------
            //                      (Incremental element)
            // ----------------------zlevel + INCREMENTAL_INC------------------------
            //              (Element drawn before incremental element)
            // --------------------------------zlevel--------------------------------
            if (el.incremental) {
                layer = this.getLayer(zlevel + $17b58207a6548df7$var$INCREMENTAL_INC, this._needsManuallyCompositing);
                layer.incremental = true;
                incrementalLayerCount = 1;
            } else layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? $17b58207a6548df7$var$EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
            if (!layer.__builtin__) $5067a17fa0db893f$exports("ZLevel " + zlevel + " has been used by unkown layer " + layer.id);
            if (layer !== prevLayer) {
                layer.__used = true;
                if (layer.__startIndex !== i) layer.__dirty = true;
                layer.__startIndex = i;
                if (!layer.incremental) layer.__drawIndex = i;
                else // Mark layer draw index needs to update.
                layer.__drawIndex = -1;
                updatePrevLayer(i);
                prevLayer = layer;
            }
            if (el.__dirty) {
                layer.__dirty = true;
                if (layer.incremental && layer.__drawIndex < 0) // Start draw from the first dirty element.
                layer.__drawIndex = i;
            }
        }
        updatePrevLayer(i);
        this.eachBuiltinLayer(function(layer, z) {
            // Used in last frame but not in this frame. Needs clear
            if (!layer.__used && layer.getElementCount() > 0) {
                layer.__dirty = true;
                layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
            } // For incremental layer. In case start index changed and no elements are dirty.
            if (layer.__dirty && layer.__drawIndex < 0) layer.__drawIndex = layer.__startIndex;
        });
    },
    /**
   * 清除hover层外所有内容
   */ clear: function() {
        this.eachBuiltinLayer(this._clearLayer);
        return this;
    },
    _clearLayer: function(layer) {
        layer.clear();
    },
    setBackgroundColor: function(backgroundColor) {
        this._backgroundColor = backgroundColor;
    },
    /**
   * 修改指定zlevel的绘制参数
   *
   * @param {string} zlevel
   * @param {Object} config 配置对象
   * @param {string} [config.clearColor=0] 每次清空画布的颜色
   * @param {string} [config.motionBlur=false] 是否开启动态模糊
   * @param {number} [config.lastFrameAlpha=0.7]
   *                 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
   */ configLayer: function(zlevel, config) {
        if (config) {
            var layerConfig = this._layerConfig;
            if (!layerConfig[zlevel]) layerConfig[zlevel] = config;
            else $ec279652dd95c27b$export$4950aa0f605343fb(layerConfig[zlevel], config, true);
            for(var i = 0; i < this._zlevelList.length; i++){
                var _zlevel = this._zlevelList[i]; // TODO Remove EL_AFTER_INCREMENTAL_INC magic number
                if (_zlevel === zlevel || _zlevel === zlevel + $17b58207a6548df7$var$EL_AFTER_INCREMENTAL_INC) {
                    var layer = this._layers[_zlevel];
                    $ec279652dd95c27b$export$4950aa0f605343fb(layer, layerConfig[zlevel], true);
                }
            }
        }
    },
    /**
   * 删除指定层
   * @param {number} zlevel 层所在的zlevel
   */ delLayer: function(zlevel) {
        var layers = this._layers;
        var zlevelList = this._zlevelList;
        var layer = layers[zlevel];
        if (!layer) return;
        layer.dom.parentNode.removeChild(layer.dom);
        delete layers[zlevel];
        zlevelList.splice($ec279652dd95c27b$export$305f7d4e9d4624f2(zlevelList, zlevel), 1);
    },
    /**
   * 区域大小变化后重绘
   */ resize: function(width, height) {
        if (!this._domRoot.style) {
            // Maybe in node or worker
            if (width == null || height == null) return;
            this._width = width;
            this._height = height;
            this.getLayer($17b58207a6548df7$var$CANVAS_ZLEVEL).resize(width, height);
        } else {
            var domRoot = this._domRoot; // FIXME Why ?
            domRoot.style.display = "none"; // Save input w/h
            var opts = this._opts;
            width != null && (opts.width = width);
            height != null && (opts.height = height);
            width = this._getSize(0);
            height = this._getSize(1);
            domRoot.style.display = ""; // 优化没有实际改变的resize
            if (this._width !== width || height !== this._height) {
                domRoot.style.width = width + "px";
                domRoot.style.height = height + "px";
                for(var id in this._layers)if (this._layers.hasOwnProperty(id)) this._layers[id].resize(width, height);
                $ec279652dd95c27b$export$79b2f7037acddd43(this._progressiveLayers, function(layer) {
                    layer.resize(width, height);
                });
                this.refresh(true);
            }
            this._width = width;
            this._height = height;
        }
        return this;
    },
    /**
   * 清除单独的一个层
   * @param {number} zlevel
   */ clearLayer: function(zlevel) {
        var layer = this._layers[zlevel];
        if (layer) layer.clear();
    },
    /**
   * 释放
   */ dispose: function() {
        this.root.innerHTML = "";
        this.root = this.storage = this._domRoot = this._layers = null;
    },
    /**
   * Get canvas which has all thing rendered
   * @param {Object} opts
   * @param {string} [opts.backgroundColor]
   * @param {number} [opts.pixelRatio]
   */ getRenderedCanvas: function(opts) {
        opts = opts || {};
        if (this._singleCanvas && !this._compositeManually) return this._layers[$17b58207a6548df7$var$CANVAS_ZLEVEL].dom;
        var imageLayer = new $a6a14a6f46c4cad0$exports("image", this, opts.pixelRatio || this.dpr);
        imageLayer.initContext();
        imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);
        if (opts.pixelRatio <= this.dpr) {
            this.refresh();
            var width = imageLayer.dom.width;
            var height = imageLayer.dom.height;
            var ctx = imageLayer.ctx;
            this.eachLayer(function(layer) {
                if (layer.__builtin__) ctx.drawImage(layer.dom, 0, 0, width, height);
                else if (layer.renderToCanvas) {
                    imageLayer.ctx.save();
                    layer.renderToCanvas(imageLayer.ctx);
                    imageLayer.ctx.restore();
                }
            });
        } else {
            // PENDING, echarts-gl and incremental rendering.
            var scope = {};
            var displayList = this.storage.getDisplayList(true);
            for(var i = 0; i < displayList.length; i++){
                var el = displayList[i];
                this._doPaintEl(el, imageLayer, true, scope);
            }
        }
        return imageLayer.dom;
    },
    /**
   * 获取绘图区域宽度
   */ getWidth: function() {
        return this._width;
    },
    /**
   * 获取绘图区域高度
   */ getHeight: function() {
        return this._height;
    },
    _getSize: function(whIdx) {
        var opts = this._opts;
        var wh = [
            "width",
            "height"
        ][whIdx];
        var cwh = [
            "clientWidth",
            "clientHeight"
        ][whIdx];
        var plt = [
            "paddingLeft",
            "paddingTop"
        ][whIdx];
        var prb = [
            "paddingRight",
            "paddingBottom"
        ][whIdx];
        if (opts[wh] != null && opts[wh] !== "auto") return parseFloat(opts[wh]);
        var root = this.root; // IE8 does not support getComputedStyle, but it use VML.
        var stl = document.defaultView.getComputedStyle(root);
        return (root[cwh] || $17b58207a6548df7$var$parseInt10(stl[wh]) || $17b58207a6548df7$var$parseInt10(root.style[wh])) - ($17b58207a6548df7$var$parseInt10(stl[plt]) || 0) - ($17b58207a6548df7$var$parseInt10(stl[prb]) || 0) | 0;
    },
    pathToImage: function(path, dpr) {
        dpr = dpr || this.dpr;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        var rect = path.getBoundingRect();
        var style = path.style;
        var shadowBlurSize = style.shadowBlur * dpr;
        var shadowOffsetX = style.shadowOffsetX * dpr;
        var shadowOffsetY = style.shadowOffsetY * dpr;
        var lineWidth = style.hasStroke() ? style.lineWidth : 0;
        var leftMargin = Math.max(lineWidth / 2, -shadowOffsetX + shadowBlurSize);
        var rightMargin = Math.max(lineWidth / 2, shadowOffsetX + shadowBlurSize);
        var topMargin = Math.max(lineWidth / 2, -shadowOffsetY + shadowBlurSize);
        var bottomMargin = Math.max(lineWidth / 2, shadowOffsetY + shadowBlurSize);
        var width = rect.width + leftMargin + rightMargin;
        var height = rect.height + topMargin + bottomMargin;
        canvas.width = width * dpr;
        canvas.height = height * dpr;
        ctx.scale(dpr, dpr);
        ctx.clearRect(0, 0, width, height);
        ctx.dpr = dpr;
        var pathTransform = {
            position: path.position,
            rotation: path.rotation,
            scale: path.scale
        };
        path.position = [
            leftMargin - rect.x,
            topMargin - rect.y
        ];
        path.rotation = 0;
        path.scale = [
            1,
            1
        ];
        path.updateTransform();
        if (path) path.brush(ctx);
        var ImageShape = $8d11db19115b899b$exports;
        var imgShape = new ImageShape({
            style: {
                x: 0,
                y: 0,
                image: canvas
            }
        });
        if (pathTransform.position != null) imgShape.position = path.position = pathTransform.position;
        if (pathTransform.rotation != null) imgShape.rotation = path.rotation = pathTransform.rotation;
        if (pathTransform.scale != null) imgShape.scale = path.scale = pathTransform.scale;
        return imgShape;
    }
};
var $17b58207a6548df7$var$_default = $17b58207a6548df7$var$Painter;
$17b58207a6548df7$exports = $17b58207a6548df7$var$_default;


var $f2d9f9ca71dae48a$exports = {};


var $f2d9f9ca71dae48a$var$Dispatcher = $adca58e5ac25631a$export$ab054a1ef92eeb01;


/**
 * Animation main class, dispatch and manage all animation controllers
 *
 * @module zrender/animation/Animation
 * @author pissang(https://github.com/pissang)
 */ // TODO Additive animation
// http://iosoteric.com/additive-animations-animatewithduration-in-ios-8/
// https://developer.apple.com/videos/wwdc2014/#236
/**
 * @typedef {Object} IZRenderStage
 * @property {Function} update
 */ /**
 * @alias module:zrender/animation/Animation
 * @constructor
 * @param {Object} [options]
 * @param {Function} [options.onframe]
 * @param {IZRenderStage} [options.stage]
 * @example
 *     var animation = new Animation();
 *     var obj = {
 *         x: 100,
 *         y: 100
 *     };
 *     animation.animate(node.position)
 *         .when(1000, {
 *             x: 500,
 *             y: 500
 *         })
 *         .when(2000, {
 *             x: 100,
 *             y: 100
 *         })
 *         .start('spline');
 */ var $f2d9f9ca71dae48a$var$Animation = function(options) {
    options = options || {};
    this.stage = options.stage || {};
    this.onframe = options.onframe || function() {}; // private properties
    this._clips = [];
    this._running = false;
    this._time;
    this._pausedTime;
    this._pauseStart;
    this._paused = false;
    $f2d9f9ca71dae48a$var$Dispatcher.call(this);
};
$f2d9f9ca71dae48a$var$Animation.prototype = {
    constructor: $f2d9f9ca71dae48a$var$Animation,
    /**
   * Add clip
   * @param {module:zrender/animation/Clip} clip
   */ addClip: function(clip) {
        this._clips.push(clip);
    },
    /**
   * Add animator
   * @param {module:zrender/animation/Animator} animator
   */ addAnimator: function(animator) {
        animator.animation = this;
        var clips = animator.getClips();
        for(var i = 0; i < clips.length; i++)this.addClip(clips[i]);
    },
    /**
   * Delete animation clip
   * @param {module:zrender/animation/Clip} clip
   */ removeClip: function(clip) {
        var idx = $ec279652dd95c27b$export$305f7d4e9d4624f2(this._clips, clip);
        if (idx >= 0) this._clips.splice(idx, 1);
    },
    /**
   * Delete animation clip
   * @param {module:zrender/animation/Animator} animator
   */ removeAnimator: function(animator) {
        var clips = animator.getClips();
        for(var i = 0; i < clips.length; i++)this.removeClip(clips[i]);
        animator.animation = null;
    },
    _update: function() {
        var time = new Date().getTime() - this._pausedTime;
        var delta = time - this._time;
        var clips = this._clips;
        var len = clips.length;
        var deferredEvents = [];
        var deferredClips = [];
        for(var i = 0; i < len; i++){
            var clip = clips[i];
            var e = clip.step(time, delta); // Throw out the events need to be called after
            // stage.update, like destroy
            if (e) {
                deferredEvents.push(e);
                deferredClips.push(clip);
            }
        } // Remove the finished clip
        for(var i = 0; i < len;)if (clips[i]._needsRemove) {
            clips[i] = clips[len - 1];
            clips.pop();
            len--;
        } else i++;
        len = deferredEvents.length;
        for(var i = 0; i < len; i++)deferredClips[i].fire(deferredEvents[i]);
        this._time = time;
        this.onframe(delta); // 'frame' should be triggered before stage, because upper application
        // depends on the sequence (e.g., echarts-stream and finish
        // event judge)
        this.trigger("frame", delta);
        if (this.stage.update) this.stage.update();
    },
    _startLoop: function() {
        var self = this;
        this._running = true;
        function step() {
            if (self._running) {
                $6351fcc6385a6fa9$exports(step);
                !self._paused && self._update();
            }
        }
        $6351fcc6385a6fa9$exports(step);
    },
    /**
   * Start animation.
   */ start: function() {
        this._time = new Date().getTime();
        this._pausedTime = 0;
        this._startLoop();
    },
    /**
   * Stop animation.
   */ stop: function() {
        this._running = false;
    },
    /**
   * Pause animation.
   */ pause: function() {
        if (!this._paused) {
            this._pauseStart = new Date().getTime();
            this._paused = true;
        }
    },
    /**
   * Resume animation.
   */ resume: function() {
        if (this._paused) {
            this._pausedTime += new Date().getTime() - this._pauseStart;
            this._paused = false;
        }
    },
    /**
   * Clear animation.
   */ clear: function() {
        this._clips = [];
    },
    /**
   * Whether animation finished.
   */ isFinished: function() {
        return !this._clips.length;
    },
    /**
   * Creat animator for a target, whose props can be animated.
   *
   * @param  {Object} target
   * @param  {Object} options
   * @param  {boolean} [options.loop=false] Whether loop animation.
   * @param  {Function} [options.getter=null] Get value from target.
   * @param  {Function} [options.setter=null] Set value to target.
   * @return {module:zrender/animation/Animation~Animator}
   */ // TODO Gap
    animate: function(target, options) {
        options = options || {};
        var animator = new $ffa340c0956116a5$exports(target, options.loop, options.getter, options.setter);
        this.addAnimator(animator);
        return animator;
    }
};
$ec279652dd95c27b$export$e36fc9d62a853069($f2d9f9ca71dae48a$var$Animation, $f2d9f9ca71dae48a$var$Dispatcher);
var $f2d9f9ca71dae48a$var$_default = $f2d9f9ca71dae48a$var$Animation;
$f2d9f9ca71dae48a$exports = $f2d9f9ca71dae48a$var$_default;


var $59c13fc02be64f54$exports = {};

var $59c13fc02be64f54$var$addEventListener = $adca58e5ac25631a$export$3f65cefe8380dbea;
var $59c13fc02be64f54$var$removeEventListener = $adca58e5ac25631a$export$8ff9f68337b520c0;
var $59c13fc02be64f54$var$normalizeEvent = $adca58e5ac25631a$export$40fadb093aebad71;
var $59c13fc02be64f54$var$getNativeEvent = $adca58e5ac25631a$export$4abe0e945399ac1d;



/* global document */ var $59c13fc02be64f54$var$TOUCH_CLICK_DELAY = 300;
var $59c13fc02be64f54$var$globalEventSupported = $27ac1413ecc67076$exports.domSupported;
var $59c13fc02be64f54$var$localNativeListenerNames = function() {
    var mouseHandlerNames = [
        "click",
        "dblclick",
        "mousewheel",
        "mouseout",
        "mouseup",
        "mousedown",
        "mousemove",
        "contextmenu"
    ];
    var touchHandlerNames = [
        "touchstart",
        "touchend",
        "touchmove"
    ];
    var pointerEventNameMap = {
        pointerdown: 1,
        pointerup: 1,
        pointermove: 1,
        pointerout: 1
    };
    var pointerHandlerNames = $ec279652dd95c27b$export$871de8747c9eaa88(mouseHandlerNames, function(name) {
        var nm = name.replace("mouse", "pointer");
        return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
    });
    return {
        mouse: mouseHandlerNames,
        touch: touchHandlerNames,
        pointer: pointerHandlerNames
    };
}();
var $59c13fc02be64f54$var$globalNativeListenerNames = {
    mouse: [
        "mousemove",
        "mouseup"
    ],
    pointer: [
        "pointermove",
        "pointerup"
    ]
};
function $59c13fc02be64f54$var$eventNameFix(name) {
    return name === "mousewheel" && $27ac1413ecc67076$exports.browser.firefox ? "DOMMouseScroll" : name;
}
function $59c13fc02be64f54$var$isPointerFromTouch(event) {
    var pointerType = event.pointerType;
    return pointerType === "pen" || pointerType === "touch";
} // function useMSGuesture(handlerProxy, event) {
//     return isPointerFromTouch(event) && !!handlerProxy._msGesture;
// }
// function onMSGestureChange(proxy, event) {
//     if (event.translationX || event.translationY) {
//         // mousemove is carried by MSGesture to reduce the sensitivity.
//         proxy.handler.dispatchToElement(event.target, 'mousemove', event);
//     }
//     if (event.scale !== 1) {
//         event.pinchX = event.offsetX;
//         event.pinchY = event.offsetY;
//         event.pinchScale = event.scale;
//         proxy.handler.dispatchToElement(event.target, 'pinch', event);
//     }
// }
/**
 * Prevent mouse event from being dispatched after Touch Events action
 * @see <https://github.com/deltakosh/handjs/blob/master/src/hand.base.js>
 * 1. Mobile browsers dispatch mouse events 300ms after touchend.
 * 2. Chrome for Android dispatch mousedown for long-touch about 650ms
 * Result: Blocking Mouse Events for 700ms.
 *
 * @param {DOMHandlerScope} scope
 */ function $59c13fc02be64f54$var$setTouchTimer(scope) {
    scope.touching = true;
    if (scope.touchTimer != null) {
        clearTimeout(scope.touchTimer);
        scope.touchTimer = null;
    }
    scope.touchTimer = setTimeout(function() {
        scope.touching = false;
        scope.touchTimer = null;
    }, 700);
} // Mark touch, which is useful in distinguish touch and
// mouse event in upper applicatoin.
function $59c13fc02be64f54$var$markTouch(event) {
    event && (event.zrByTouch = true);
} // function markTriggeredFromLocal(event) {
//     event && (event.__zrIsFromLocal = true);
// }
// function isTriggeredFromLocal(instance, event) {
//     return !!(event && event.__zrIsFromLocal);
// }
function $59c13fc02be64f54$var$normalizeGlobalEvent(instance, event) {
    // offsetX, offsetY still need to be calculated. They are necessary in the event
    // handlers of the upper applications. Set `true` to force calculate them.
    return $59c13fc02be64f54$var$normalizeEvent(instance.dom, new $59c13fc02be64f54$var$FakeGlobalEvent(instance, event), true);
}
/**
 * Detect whether the given el is in `painterRoot`.
 */ function $59c13fc02be64f54$var$isLocalEl(instance, el) {
    var elTmp = el;
    var isLocal = false;
    while(elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot))elTmp = elTmp.parentNode;
    return isLocal;
}
/**
 * Make a fake event but not change the original event,
 * becuase the global event probably be used by other
 * listeners not belonging to zrender.
 * @class
 */ function $59c13fc02be64f54$var$FakeGlobalEvent(instance, event) {
    this.type = event.type;
    this.target = this.currentTarget = instance.dom;
    this.pointerType = event.pointerType; // Necessray for the force calculation of zrX, zrY
    this.clientX = event.clientX;
    this.clientY = event.clientY; // Because we do not mount global listeners to touch events,
// we do not copy `targetTouches` and `changedTouches` here.
}
var $59c13fc02be64f54$var$fakeGlobalEventProto = $59c13fc02be64f54$var$FakeGlobalEvent.prototype; // we make the default methods on the event do nothing,
// otherwise it is dangerous. See more details in
// [Drag outside] in `Handler.js`.
$59c13fc02be64f54$var$fakeGlobalEventProto.stopPropagation = $59c13fc02be64f54$var$fakeGlobalEventProto.stopImmediatePropagation = $59c13fc02be64f54$var$fakeGlobalEventProto.preventDefault = $ec279652dd95c27b$export$8793edee2d425525;
/**
 * Local DOM Handlers
 * @this {HandlerProxy}
 */ var $59c13fc02be64f54$var$localDOMHandlers = {
    mousedown: function(event) {
        event = $59c13fc02be64f54$var$normalizeEvent(this.dom, event);
        this._mayPointerCapture = [
            event.zrX,
            event.zrY
        ];
        this.trigger("mousedown", event);
    },
    mousemove: function(event) {
        event = $59c13fc02be64f54$var$normalizeEvent(this.dom, event);
        var downPoint = this._mayPointerCapture;
        if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) $59c13fc02be64f54$var$togglePointerCapture(this, true);
        this.trigger("mousemove", event);
    },
    mouseup: function(event) {
        event = $59c13fc02be64f54$var$normalizeEvent(this.dom, event);
        $59c13fc02be64f54$var$togglePointerCapture(this, false);
        this.trigger("mouseup", event);
    },
    mouseout: function(event) {
        event = $59c13fc02be64f54$var$normalizeEvent(this.dom, event); // Similarly to the browser did on `document` and touch event,
        // `globalout` will be delayed to final pointer cature release.
        if (this._pointerCapturing) event.zrEventControl = "no_globalout";
         // There might be some doms created by upper layer application
        // at the same level of painter.getViewportRoot() (e.g., tooltip
        // dom created by echarts), where 'globalout' event should not
        // be triggered when mouse enters these doms. (But 'mouseout'
        // should be triggered at the original hovered element as usual).
        var element = event.toElement || event.relatedTarget;
        event.zrIsToLocalDOM = $59c13fc02be64f54$var$isLocalEl(this, element);
        this.trigger("mouseout", event);
    },
    touchstart: function(event) {
        // Default mouse behaviour should not be disabled here.
        // For example, page may needs to be slided.
        event = $59c13fc02be64f54$var$normalizeEvent(this.dom, event);
        $59c13fc02be64f54$var$markTouch(event);
        this._lastTouchMoment = new Date();
        this.handler.processGesture(event, "start"); // For consistent event listener for both touch device and mouse device,
        // we simulate "mouseover-->mousedown" in touch device. So we trigger
        // `mousemove` here (to trigger `mouseover` inside), and then trigger
        // `mousedown`.
        $59c13fc02be64f54$var$localDOMHandlers.mousemove.call(this, event);
        $59c13fc02be64f54$var$localDOMHandlers.mousedown.call(this, event);
    },
    touchmove: function(event) {
        event = $59c13fc02be64f54$var$normalizeEvent(this.dom, event);
        $59c13fc02be64f54$var$markTouch(event);
        this.handler.processGesture(event, "change"); // Mouse move should always be triggered no matter whether
        // there is gestrue event, because mouse move and pinch may
        // be used at the same time.
        $59c13fc02be64f54$var$localDOMHandlers.mousemove.call(this, event);
    },
    touchend: function(event) {
        event = $59c13fc02be64f54$var$normalizeEvent(this.dom, event);
        $59c13fc02be64f54$var$markTouch(event);
        this.handler.processGesture(event, "end");
        $59c13fc02be64f54$var$localDOMHandlers.mouseup.call(this, event); // Do not trigger `mouseout` here, in spite of `mousemove`(`mouseover`) is
        // triggered in `touchstart`. This seems to be illogical, but by this mechanism,
        // we can conveniently implement "hover style" in both PC and touch device just
        // by listening to `mouseover` to add "hover style" and listening to `mouseout`
        // to remove "hover style" on an element, without any additional code for
        // compatibility. (`mouseout` will not be triggered in `touchend`, so "hover
        // style" will remain for user view)
        // click event should always be triggered no matter whether
        // there is gestrue event. System click can not be prevented.
        if (+new Date() - this._lastTouchMoment < $59c13fc02be64f54$var$TOUCH_CLICK_DELAY) $59c13fc02be64f54$var$localDOMHandlers.click.call(this, event);
    },
    pointerdown: function(event) {
        $59c13fc02be64f54$var$localDOMHandlers.mousedown.call(this, event); // if (useMSGuesture(this, event)) {
    //     this._msGesture.addPointer(event.pointerId);
    // }
    },
    pointermove: function(event) {
        // FIXME
        // pointermove is so sensitive that it always triggered when
        // tap(click) on touch screen, which affect some judgement in
        // upper application. So, we dont support mousemove on MS touch
        // device yet.
        if (!$59c13fc02be64f54$var$isPointerFromTouch(event)) $59c13fc02be64f54$var$localDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $59c13fc02be64f54$var$localDOMHandlers.mouseup.call(this, event);
    },
    pointerout: function(event) {
        // pointerout will be triggered when tap on touch screen
        // (IE11+/Edge on MS Surface) after click event triggered,
        // which is inconsistent with the mousout behavior we defined
        // in touchend. So we unify them.
        // (check localDOMHandlers.touchend for detailed explanation)
        if (!$59c13fc02be64f54$var$isPointerFromTouch(event)) $59c13fc02be64f54$var$localDOMHandlers.mouseout.call(this, event);
    }
};
/**
 * Othere DOM UI Event handlers for zr dom.
 * @this {HandlerProxy}
 */ $ec279652dd95c27b$export$79b2f7037acddd43([
    "click",
    "mousewheel",
    "dblclick",
    "contextmenu"
], function(name) {
    $59c13fc02be64f54$var$localDOMHandlers[name] = function(event) {
        event = $59c13fc02be64f54$var$normalizeEvent(this.dom, event);
        this.trigger(name, event);
    };
});
/**
 * DOM UI Event handlers for global page.
 *
 * [Caution]:
 * those handlers should both support in capture phase and bubble phase!
 *
 * @this {HandlerProxy}
 */ var $59c13fc02be64f54$var$globalDOMHandlers = {
    pointermove: function(event) {
        // FIXME
        // pointermove is so sensitive that it always triggered when
        // tap(click) on touch screen, which affect some judgement in
        // upper application. So, we dont support mousemove on MS touch
        // device yet.
        if (!$59c13fc02be64f54$var$isPointerFromTouch(event)) $59c13fc02be64f54$var$globalDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $59c13fc02be64f54$var$globalDOMHandlers.mouseup.call(this, event);
    },
    mousemove: function(event) {
        this.trigger("mousemove", event);
    },
    mouseup: function(event) {
        var pointerCaptureReleasing = this._pointerCapturing;
        $59c13fc02be64f54$var$togglePointerCapture(this, false);
        this.trigger("mouseup", event);
        if (pointerCaptureReleasing) {
            event.zrEventControl = "only_globalout";
            this.trigger("mouseout", event);
        }
    }
};
/**
 * @param {HandlerProxy} instance
 * @param {DOMHandlerScope} scope
 */ function $59c13fc02be64f54$var$mountLocalDOMEventListeners(instance, scope) {
    var domHandlers = scope.domHandlers;
    if ($27ac1413ecc67076$exports.pointerEventsSupported) // Only IE11+/Edge
    // 1. On devices that both enable touch and mouse (e.g., MS Surface and lenovo X240),
    // IE11+/Edge do not trigger touch event, but trigger pointer event and mouse event
    // at the same time.
    // 2. On MS Surface, it probablely only trigger mousedown but no mouseup when tap on
    // screen, which do not occurs in pointer event.
    // So we use pointer event to both detect touch gesture and mouse behavior.
    $ec279652dd95c27b$export$79b2f7037acddd43($59c13fc02be64f54$var$localNativeListenerNames.pointer, function(nativeEventName) {
        $59c13fc02be64f54$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
            // markTriggeredFromLocal(event);
            domHandlers[nativeEventName].call(instance, event);
        });
    }); // FIXME
    else {
        if ($27ac1413ecc67076$exports.touchEventsSupported) $ec279652dd95c27b$export$79b2f7037acddd43($59c13fc02be64f54$var$localNativeListenerNames.touch, function(nativeEventName) {
            $59c13fc02be64f54$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                // markTriggeredFromLocal(event);
                domHandlers[nativeEventName].call(instance, event);
                $59c13fc02be64f54$var$setTouchTimer(scope);
            });
        }); // Handler of 'mouseout' event is needed in touch mode, which will be mounted below.
         // 1. Considering some devices that both enable touch and mouse event (like on MS Surface
        // and lenovo X240, @see #2350), we make mouse event be always listened, otherwise
        // mouse event can not be handle in those devices.
        // 2. On MS Surface, Chrome will trigger both touch event and mouse event. How to prevent
        // mouseevent after touch event triggered, see `setTouchTimer`.
        $ec279652dd95c27b$export$79b2f7037acddd43($59c13fc02be64f54$var$localNativeListenerNames.mouse, function(nativeEventName) {
            $59c13fc02be64f54$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                event = $59c13fc02be64f54$var$getNativeEvent(event);
                if (!scope.touching) // markTriggeredFromLocal(event);
                domHandlers[nativeEventName].call(instance, event);
            });
        });
    }
}
/**
 * @param {HandlerProxy} instance
 * @param {DOMHandlerScope} scope
 */ function $59c13fc02be64f54$var$mountGlobalDOMEventListeners(instance, scope) {
    // Only IE11+/Edge. See the comment in `mountLocalDOMEventListeners`.
    if ($27ac1413ecc67076$exports.pointerEventsSupported) $ec279652dd95c27b$export$79b2f7037acddd43($59c13fc02be64f54$var$globalNativeListenerNames.pointer, mount);
    else if (!$27ac1413ecc67076$exports.touchEventsSupported) $ec279652dd95c27b$export$79b2f7037acddd43($59c13fc02be64f54$var$globalNativeListenerNames.mouse, mount);
    function mount(nativeEventName) {
        function nativeEventListener(event) {
            event = $59c13fc02be64f54$var$getNativeEvent(event); // See the reason in [Drag outside] in `Handler.js`
            // This checking supports both `useCapture` or not.
            // PENDING: if there is performance issue in some devices,
            // we probably can not use `useCapture` and change a easier
            // to judes whether local (mark).
            if (!$59c13fc02be64f54$var$isLocalEl(instance, event.target)) {
                event = $59c13fc02be64f54$var$normalizeGlobalEvent(instance, event);
                scope.domHandlers[nativeEventName].call(instance, event);
            }
        }
        $59c13fc02be64f54$var$mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
            capture: true
        } // See [Drag Outside] in `Handler.js`
        );
    }
}
function $59c13fc02be64f54$var$mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
    scope.mounted[nativeEventName] = listener;
    scope.listenerOpts[nativeEventName] = opt;
    $59c13fc02be64f54$var$addEventListener(scope.domTarget, $59c13fc02be64f54$var$eventNameFix(nativeEventName), listener, opt);
}
function $59c13fc02be64f54$var$unmountDOMEventListeners(scope) {
    var mounted = scope.mounted;
    for(var nativeEventName in mounted)if (mounted.hasOwnProperty(nativeEventName)) $59c13fc02be64f54$var$removeEventListener(scope.domTarget, $59c13fc02be64f54$var$eventNameFix(nativeEventName), mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
    scope.mounted = {};
}
/**
 * See [Drag Outside] in `Handler.js`.
 * @implement
 * @param {boolean} isPointerCapturing Should never be `null`/`undefined`.
 *        `true`: start to capture pointer if it is not capturing.
 *        `false`: end the capture if it is capturing.
 */ function $59c13fc02be64f54$var$togglePointerCapture(instance, isPointerCapturing) {
    instance._mayPointerCapture = null;
    if ($59c13fc02be64f54$var$globalEventSupported && instance._pointerCapturing ^ isPointerCapturing) {
        instance._pointerCapturing = isPointerCapturing;
        var globalHandlerScope = instance._globalHandlerScope;
        isPointerCapturing ? $59c13fc02be64f54$var$mountGlobalDOMEventListeners(instance, globalHandlerScope) : $59c13fc02be64f54$var$unmountDOMEventListeners(globalHandlerScope);
    }
}
/**
 * @inner
 * @class
 */ function $59c13fc02be64f54$var$DOMHandlerScope(domTarget, domHandlers) {
    this.domTarget = domTarget;
    this.domHandlers = domHandlers; // Key: eventName, value: mounted handler funcitons.
    // Used for unmount.
    this.mounted = {};
    this.listenerOpts = {};
    this.touchTimer = null;
    this.touching = false;
}
/**
 * @public
 * @class
 */ function $59c13fc02be64f54$var$HandlerDomProxy(dom, painterRoot) {
    $b7a44647f5b5bfa5$exports.call(this);
    this.dom = dom;
    this.painterRoot = painterRoot;
    this._localHandlerScope = new $59c13fc02be64f54$var$DOMHandlerScope(dom, $59c13fc02be64f54$var$localDOMHandlers);
    if ($59c13fc02be64f54$var$globalEventSupported) this._globalHandlerScope = new $59c13fc02be64f54$var$DOMHandlerScope(document, $59c13fc02be64f54$var$globalDOMHandlers);
    /**
   * @type {boolean}
   */ this._pointerCapturing = false;
    /**
   * @type {Array.<number>} [x, y] or null.
   */ this._mayPointerCapture = null;
    $59c13fc02be64f54$var$mountLocalDOMEventListeners(this, this._localHandlerScope);
}
var $59c13fc02be64f54$var$handlerDomProxyProto = $59c13fc02be64f54$var$HandlerDomProxy.prototype;
$59c13fc02be64f54$var$handlerDomProxyProto.dispose = function() {
    $59c13fc02be64f54$var$unmountDOMEventListeners(this._localHandlerScope);
    if ($59c13fc02be64f54$var$globalEventSupported) $59c13fc02be64f54$var$unmountDOMEventListeners(this._globalHandlerScope);
};
$59c13fc02be64f54$var$handlerDomProxyProto.setCursor = function(cursorStyle) {
    this.dom.style && (this.dom.style.cursor = cursorStyle || "default");
};
$ec279652dd95c27b$export$e36fc9d62a853069($59c13fc02be64f54$var$HandlerDomProxy, $b7a44647f5b5bfa5$exports);
var $59c13fc02be64f54$var$_default = $59c13fc02be64f54$var$HandlerDomProxy;
$59c13fc02be64f54$exports = $59c13fc02be64f54$var$_default;


/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/ var $ec1efdd8e4428d18$var$useVML = !$27ac1413ecc67076$exports.canvasSupported;
var $ec1efdd8e4428d18$var$painterCtors = {
    canvas: $17b58207a6548df7$exports
};
var $ec1efdd8e4428d18$var$instances = {}; // ZRender实例map索引
/**
 * @type {string}
 */ var $ec1efdd8e4428d18$var$version = "4.3.2";
/**
 * Initializing a zrender instance
 * @param {HTMLElement} dom
 * @param {Object} [opts]
 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
 * @param {number} [opts.devicePixelRatio]
 * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
 * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
 * @return {module:zrender/ZRender}
 */ function $ec1efdd8e4428d18$var$init(dom, opts) {
    var zr = new $ec1efdd8e4428d18$var$ZRender($b2a309a7eafc27fc$exports(), dom, opts);
    $ec1efdd8e4428d18$var$instances[zr.id] = zr;
    return zr;
}
/**
 * Dispose zrender instance
 * @param {module:zrender/ZRender} zr
 */ function $ec1efdd8e4428d18$var$dispose(zr) {
    if (zr) zr.dispose();
    else {
        for(var key in $ec1efdd8e4428d18$var$instances)if ($ec1efdd8e4428d18$var$instances.hasOwnProperty(key)) $ec1efdd8e4428d18$var$instances[key].dispose();
        $ec1efdd8e4428d18$var$instances = {};
    }
    return this;
}
/**
 * Get zrender instance by id
 * @param {string} id zrender instance id
 * @return {module:zrender/ZRender}
 */ function $ec1efdd8e4428d18$var$getInstance(id) {
    return $ec1efdd8e4428d18$var$instances[id];
}
function $ec1efdd8e4428d18$var$registerPainter(name, Ctor) {
    $ec1efdd8e4428d18$var$painterCtors[name] = Ctor;
}
function $ec1efdd8e4428d18$var$delInstance(id) {
    delete $ec1efdd8e4428d18$var$instances[id];
}
/**
 * @module zrender/ZRender
 */ /**
 * @constructor
 * @alias module:zrender/ZRender
 * @param {string} id
 * @param {HTMLElement} dom
 * @param {Object} opts
 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
 * @param {number} [opts.devicePixelRatio]
 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
 */ var $ec1efdd8e4428d18$var$ZRender = function(id, dom, opts) {
    opts = opts || {};
    /**
   * @type {HTMLDomElement}
   */ this.dom = dom;
    /**
   * @type {string}
   */ this.id = id;
    var self = this;
    var storage = new $cf128beaa1ab720c$exports();
    var rendererType = opts.renderer; // TODO WebGL
    if ($ec1efdd8e4428d18$var$useVML) {
        if (!$ec1efdd8e4428d18$var$painterCtors.vml) throw new Error("You need to require 'zrender/vml/vml' to support IE8");
        rendererType = "vml";
    } else if (!rendererType || !$ec1efdd8e4428d18$var$painterCtors[rendererType]) rendererType = "canvas";
    var painter = new $ec1efdd8e4428d18$var$painterCtors[rendererType](dom, storage, opts, id);
    this.storage = storage;
    this.painter = painter;
    var handerProxy = !$27ac1413ecc67076$exports.node && !$27ac1413ecc67076$exports.worker ? new $59c13fc02be64f54$exports(painter.getViewportRoot(), painter.root) : null;
    this.handler = new $9f5fe6326a736418$exports(storage, painter, handerProxy, painter.root);
    /**
   * @type {module:zrender/animation/Animation}
   */ this.animation = new $f2d9f9ca71dae48a$exports({
        stage: {
            update: $ec279652dd95c27b$export$2385a24977818dd0(this.flush, this)
        }
    });
    this.animation.start();
    /**
   * @type {boolean}
   * @private
   */ this._needsRefresh; // 修改 storage.delFromStorage, 每次删除元素之前删除动画
    // FIXME 有点ugly
    var oldDelFromStorage = storage.delFromStorage;
    var oldAddToStorage = storage.addToStorage;
    storage.delFromStorage = function(el) {
        oldDelFromStorage.call(storage, el);
        el && el.removeSelfFromZr(self);
    };
    storage.addToStorage = function(el) {
        oldAddToStorage.call(storage, el);
        el.addSelfToZr(self);
    };
};
$ec1efdd8e4428d18$var$ZRender.prototype = {
    constructor: $ec1efdd8e4428d18$var$ZRender,
    /**
   * 获取实例唯一标识
   * @return {string}
   */ getId: function() {
        return this.id;
    },
    /**
   * 添加元素
   * @param  {module:zrender/Element} el
   */ add: function(el) {
        this.storage.addRoot(el);
        this._needsRefresh = true;
    },
    /**
   * 删除元素
   * @param  {module:zrender/Element} el
   */ remove: function(el) {
        this.storage.delRoot(el);
        this._needsRefresh = true;
    },
    /**
   * Change configuration of layer
   * @param {string} zLevel
   * @param {Object} config
   * @param {string} [config.clearColor=0] Clear color
   * @param {string} [config.motionBlur=false] If enable motion blur
   * @param {number} [config.lastFrameAlpha=0.7] Motion blur factor. Larger value cause longer trailer
  */ configLayer: function(zLevel, config) {
        if (this.painter.configLayer) this.painter.configLayer(zLevel, config);
        this._needsRefresh = true;
    },
    /**
   * Set background color
   * @param {string} backgroundColor
   */ setBackgroundColor: function(backgroundColor) {
        if (this.painter.setBackgroundColor) this.painter.setBackgroundColor(backgroundColor);
        this._needsRefresh = true;
    },
    /**
   * Repaint the canvas immediately
   */ refreshImmediately: function() {
        // var start = new Date();
        // Clear needsRefresh ahead to avoid something wrong happens in refresh
        // Or it will cause zrender refreshes again and again.
        this._needsRefresh = this._needsRefreshHover = false;
        this.painter.refresh(); // Avoid trigger zr.refresh in Element#beforeUpdate hook
        this._needsRefresh = this._needsRefreshHover = false; // var end = new Date();
    // var log = document.getElementById('log');
    // if (log) {
    //     log.innerHTML = log.innerHTML + '<br>' + (end - start);
    // }
    },
    /**
   * Mark and repaint the canvas in the next frame of browser
   */ refresh: function() {
        this._needsRefresh = true;
    },
    /**
   * Perform all refresh
   */ flush: function() {
        var triggerRendered;
        if (this._needsRefresh) {
            triggerRendered = true;
            this.refreshImmediately();
        }
        if (this._needsRefreshHover) {
            triggerRendered = true;
            this.refreshHoverImmediately();
        }
        triggerRendered && this.trigger("rendered");
    },
    /**
   * Add element to hover layer
   * @param  {module:zrender/Element} el
   * @param {Object} style
   */ addHover: function(el, style) {
        if (this.painter.addHover) {
            var elMirror = this.painter.addHover(el, style);
            this.refreshHover();
            return elMirror;
        }
    },
    /**
   * Add element from hover layer
   * @param  {module:zrender/Element} el
   */ removeHover: function(el) {
        if (this.painter.removeHover) {
            this.painter.removeHover(el);
            this.refreshHover();
        }
    },
    /**
   * Clear all hover elements in hover layer
   * @param  {module:zrender/Element} el
   */ clearHover: function() {
        if (this.painter.clearHover) {
            this.painter.clearHover();
            this.refreshHover();
        }
    },
    /**
   * Refresh hover in next frame
   */ refreshHover: function() {
        this._needsRefreshHover = true;
    },
    /**
   * Refresh hover immediately
   */ refreshHoverImmediately: function() {
        this._needsRefreshHover = false;
        this.painter.refreshHover && this.painter.refreshHover();
    },
    /**
   * Resize the canvas.
   * Should be invoked when container size is changed
   * @param {Object} [opts]
   * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
   * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
   */ resize: function(opts) {
        opts = opts || {};
        this.painter.resize(opts.width, opts.height);
        this.handler.resize();
    },
    /**
   * Stop and clear all animation immediately
   */ clearAnimation: function() {
        this.animation.clear();
    },
    /**
   * Get container width
   */ getWidth: function() {
        return this.painter.getWidth();
    },
    /**
   * Get container height
   */ getHeight: function() {
        return this.painter.getHeight();
    },
    /**
   * Export the canvas as Base64 URL
   * @param {string} type
   * @param {string} [backgroundColor='#fff']
   * @return {string} Base64 URL
   */ // toDataURL: function(type, backgroundColor) {
    //     return this.painter.getRenderedCanvas({
    //         backgroundColor: backgroundColor
    //     }).toDataURL(type);
    // },
    /**
   * Converting a path to image.
   * It has much better performance of drawing image rather than drawing a vector path.
   * @param {module:zrender/graphic/Path} e
   * @param {number} width
   * @param {number} height
   */ pathToImage: function(e, dpr) {
        return this.painter.pathToImage(e, dpr);
    },
    /**
   * Set default cursor
   * @param {string} [cursorStyle='default'] 例如 crosshair
   */ setCursorStyle: function(cursorStyle) {
        this.handler.setCursorStyle(cursorStyle);
    },
    /**
   * Find hovered element
   * @param {number} x
   * @param {number} y
   * @return {Object} {target, topTarget}
   */ findHover: function(x, y) {
        return this.handler.findHover(x, y);
    },
    /**
   * Bind event
   *
   * @param {string} eventName Event name
   * @param {Function} eventHandler Handler function
   * @param {Object} [context] Context object
   */ on: function(eventName, eventHandler, context) {
        this.handler.on(eventName, eventHandler, context);
    },
    /**
   * Unbind event
   * @param {string} eventName Event name
   * @param {Function} [eventHandler] Handler function
   */ off: function(eventName, eventHandler) {
        this.handler.off(eventName, eventHandler);
    },
    /**
   * Trigger event manually
   *
   * @param {string} eventName Event name
   * @param {event=} event Event object
   */ trigger: function(eventName, event) {
        this.handler.trigger(eventName, event);
    },
    /**
   * Clear all objects and the canvas.
   */ clear: function() {
        this.storage.delRoot();
        this.painter.clear();
    },
    /**
   * Dispose self.
   */ dispose: function() {
        this.animation.stop();
        this.clear();
        this.storage.dispose();
        this.painter.dispose();
        this.handler.dispose();
        this.animation = this.storage = this.painter = this.handler = null;
        $ec1efdd8e4428d18$var$delInstance(this.id);
    }
};
$ec1efdd8e4428d18$export$83d89fbfd8236492 = $ec1efdd8e4428d18$var$version;
$ec1efdd8e4428d18$export$2cd8252107eb640b = $ec1efdd8e4428d18$var$init;
$ec1efdd8e4428d18$export$fcfbbcec2cb820d5 = $ec1efdd8e4428d18$var$dispose;
$ec1efdd8e4428d18$export$8bedcca5bbd73999 = $ec1efdd8e4428d18$var$getInstance;
$ec1efdd8e4428d18$export$a3e793ccb11823a5 = $ec1efdd8e4428d18$var$registerPainter;







var $6c7ab8052e1c6936$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $6c7ab8052e1c6936$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;

var $6c7ab8052e1c6936$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $6c7ab8052e1c6936$var$filter = $ec279652dd95c27b$export$3dea766d36a8935f;
var $6c7ab8052e1c6936$var$map = $ec279652dd95c27b$export$871de8747c9eaa88;
var $6c7ab8052e1c6936$var$isArray = $ec279652dd95c27b$export$43bee75e5e14138e;
var $6c7ab8052e1c6936$var$indexOf = $ec279652dd95c27b$export$305f7d4e9d4624f2;
var $6c7ab8052e1c6936$var$isObject = $ec279652dd95c27b$export$a6cdc56e425d0d0a;
var $6c7ab8052e1c6936$var$isString = $ec279652dd95c27b$export$844ec244b1367d54;
var $6c7ab8052e1c6936$var$createHashMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4;
var $6c7ab8052e1c6936$var$assert = $ec279652dd95c27b$export$a7a9523472993e97;
var $6c7ab8052e1c6936$var$clone = $ec279652dd95c27b$export$9cd59f9826255e47;
var $6c7ab8052e1c6936$var$merge = $ec279652dd95c27b$export$4950aa0f605343fb;
var $6c7ab8052e1c6936$var$extend = $ec279652dd95c27b$export$8b58be045bf06082;
var $6c7ab8052e1c6936$var$mixin = $ec279652dd95c27b$export$e36fc9d62a853069;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $d559f43cb9041423$export$4f07b212a02c8051;
var $d559f43cb9041423$export$abdcc6a26372f94b;
var $d559f43cb9041423$export$df45610347a602ad;
var $d559f43cb9041423$export$2c944e12edb48d4b;
var $d559f43cb9041423$export$3e1a543f33ef6883;
var $d559f43cb9041423$export$574f818966e4da87;
var $d559f43cb9041423$export$6f01005fe2e2ddc6;
var $d559f43cb9041423$export$beae19a2652b3368;
var $d559f43cb9041423$export$66efd7adff61f97d;
var $d559f43cb9041423$export$6d12cabb0c9bf8e3;
var $d559f43cb9041423$export$42b26cae8b8d10;
var $d559f43cb9041423$export$64df9f8d92ae083f;
var $d559f43cb9041423$export$95de80076abac814;
var $d559f43cb9041423$export$9fec4d97f1922e0b;
var $d559f43cb9041423$export$735ee1799fd02602;
var $d559f43cb9041423$export$cc0a17a5d27b4e17;
var $d559f43cb9041423$export$7ab5bda43e13168f;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $d559f43cb9041423$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $d559f43cb9041423$var$isObject = $ec279652dd95c27b$export$a6cdc56e425d0d0a;
var $d559f43cb9041423$var$isArray = $ec279652dd95c27b$export$43bee75e5e14138e;
/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */ var $d559f43cb9041423$var$DUMMY_COMPONENT_NAME_PREFIX = "series\x00";
/**
 * If value is not array, then translate it to array.
 * @param  {*} value
 * @return {Array} [value] or value
 */ function $d559f43cb9041423$var$normalizeToArray(value) {
    return value instanceof Array ? value : value == null ? [] : [
        value
    ];
}
/**
 * Sync default option between normal and emphasis like `position` and `show`
 * In case some one will write code like
 *     label: {
 *          show: false,
 *          position: 'outside',
 *          fontSize: 18
 *     },
 *     emphasis: {
 *          label: { show: true }
 *     }
 * @param {Object} opt
 * @param {string} key
 * @param {Array.<string>} subOpts
 */ function $d559f43cb9041423$var$defaultEmphasis(opt, key, subOpts) {
    // Caution: performance sensitive.
    if (opt) {
        opt[key] = opt[key] || {};
        opt.emphasis = opt.emphasis || {};
        opt.emphasis[key] = opt.emphasis[key] || {}; // Default emphasis option from normal
        for(var i = 0, len = subOpts.length; i < len; i++){
            var subOptName = subOpts[i];
            if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) opt.emphasis[key][subOptName] = opt[key][subOptName];
        }
    }
}
var $d559f43cb9041423$var$TEXT_STYLE_OPTIONS = [
    "fontStyle",
    "fontWeight",
    "fontSize",
    "fontFamily",
    "rich",
    "tag",
    "color",
    "textBorderColor",
    "textBorderWidth",
    "width",
    "height",
    "lineHeight",
    "align",
    "verticalAlign",
    "baseline",
    "shadowColor",
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY",
    "textShadowColor",
    "textShadowBlur",
    "textShadowOffsetX",
    "textShadowOffsetY",
    "backgroundColor",
    "borderColor",
    "borderWidth",
    "borderRadius",
    "padding"
]; // modelUtil.LABEL_OPTIONS = modelUtil.TEXT_STYLE_OPTIONS.concat([
//     'position', 'offset', 'rotate', 'origin', 'show', 'distance', 'formatter',
//     'fontStyle', 'fontWeight', 'fontSize', 'fontFamily',
//     // FIXME: deprecated, check and remove it.
//     'textStyle'
// ]);
/**
 * The method do not ensure performance.
 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
 * This helper method retieves value from data.
 * @param {string|number|Date|Array|Object} dataItem
 * @return {number|string|Date|Array.<number|string|Date>}
 */ function $d559f43cb9041423$var$getDataItemValue(dataItem) {
    return $d559f43cb9041423$var$isObject(dataItem) && !$d559f43cb9041423$var$isArray(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
}
/**
 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
 * This helper method determine if dataItem has extra option besides value
 * @param {string|number|Date|Array|Object} dataItem
 */ function $d559f43cb9041423$var$isDataItemOption(dataItem) {
    return $d559f43cb9041423$var$isObject(dataItem) && !(dataItem instanceof Array); // // markLine data can be array
// && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
/**
 * Mapping to exists for merge.
 *
 * @public
 * @param {Array.<Object>|Array.<module:echarts/model/Component>} exists
 * @param {Object|Array.<Object>} newCptOptions
 * @return {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
 *                          index of which is the same as exists.
 */ function $d559f43cb9041423$var$mappingToExists(exists, newCptOptions) {
    // Mapping by the order by original option (but not order of
    // new option) in merge mode. Because we should ensure
    // some specified index (like xAxisIndex) is consistent with
    // original option, which is easy to understand, espatially in
    // media query. And in most case, merge option is used to
    // update partial option but not be expected to change order.
    newCptOptions = (newCptOptions || []).slice();
    var result = $ec279652dd95c27b$export$871de8747c9eaa88(exists || [], function(obj, index) {
        return {
            exist: obj
        };
    }); // Mapping by id or name if specified.
    $d559f43cb9041423$var$each(newCptOptions, function(cptOption, index) {
        if (!$d559f43cb9041423$var$isObject(cptOption)) return;
         // id has highest priority.
        for(var i = 0; i < result.length; i++)if (!result[i].option // Consider name: two map to one.
         && cptOption.id != null && result[i].exist.id === cptOption.id + "") {
            result[i].option = cptOption;
            newCptOptions[index] = null;
            return;
        }
        for(var i = 0; i < result.length; i++){
            var exist = result[i].exist;
            if (!result[i].option // Consider name: two map to one.
             && (exist.id == null || cptOption.id == null) && cptOption.name != null && !$d559f43cb9041423$var$isIdInner(cptOption) && !$d559f43cb9041423$var$isIdInner(exist) && exist.name === cptOption.name + "") {
                result[i].option = cptOption;
                newCptOptions[index] = null;
                return;
            }
        }
    }); // Otherwise mapping by index.
    $d559f43cb9041423$var$each(newCptOptions, function(cptOption, index) {
        if (!$d559f43cb9041423$var$isObject(cptOption)) return;
        var i = 0;
        for(; i < result.length; i++){
            var exist = result[i].exist;
            if (!result[i].option // Existing model that already has id should be able to
             && !$d559f43cb9041423$var$isIdInner(exist) // Caution:
             && cptOption.id == null) {
                result[i].option = cptOption;
                break;
            }
        }
        if (i >= result.length) result.push({
            option: cptOption
        });
    });
    return result;
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 *
 * @public
 * @param {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
 *                          which order is the same as exists.
 * @return {Array.<Object>} The input.
 */ function $d559f43cb9041423$var$makeIdAndName(mapResult) {
    // We use this id to hash component models and view instances
    // in echarts. id can be specified by user, or auto generated.
    // The id generation rule ensures new view instance are able
    // to mapped to old instance when setOption are called in
    // no-merge mode. So we generate model id by name and plus
    // type in view id.
    // name can be duplicated among components, which is convenient
    // to specify multi components (like series) by one name.
    // Ensure that each id is distinct.
    var idMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4();
    $d559f43cb9041423$var$each(mapResult, function(item, index) {
        var existCpt = item.exist;
        existCpt && idMap.set(existCpt.id, item);
    });
    $d559f43cb9041423$var$each(mapResult, function(item, index) {
        var opt = item.option;
        $ec279652dd95c27b$export$a7a9523472993e97(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, "id duplicates: " + (opt && opt.id));
        opt && opt.id != null && idMap.set(opt.id, item);
        !item.keyInfo && (item.keyInfo = {});
    }); // Make name and id.
    $d559f43cb9041423$var$each(mapResult, function(item, index) {
        var existCpt = item.exist;
        var opt = item.option;
        var keyInfo = item.keyInfo;
        if (!$d559f43cb9041423$var$isObject(opt)) return;
         // name can be overwitten. Consider case: axis.name = '20km'.
        // But id generated by name will not be changed, which affect
        // only in that case: setOption with 'not merge mode' and view
        // instance will be recreated, which can be accepted.
        keyInfo.name = opt.name != null ? opt.name + "" : existCpt ? existCpt.name // Avoid diffferent series has the same name,
         : $d559f43cb9041423$var$DUMMY_COMPONENT_NAME_PREFIX + index;
        if (existCpt) keyInfo.id = existCpt.id;
        else if (opt.id != null) keyInfo.id = opt.id + "";
        else {
            // Consider this situatoin:
            //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
            //  optionB [{..}, {name: 'a'}, {name: 'a'}]
            // Series with the same name between optionA and optionB
            // should be mapped.
            var idNum = 0;
            do keyInfo.id = "\x00" + keyInfo.name + "\x00" + idNum++;
            while (idMap.get(keyInfo.id));
        }
        idMap.set(keyInfo.id, item);
    });
}
function $d559f43cb9041423$var$isNameSpecified(componentModel) {
    var name = componentModel.name; // Is specified when `indexOf` get -1 or > 0.
    return !!(name && name.indexOf($d559f43cb9041423$var$DUMMY_COMPONENT_NAME_PREFIX));
}
/**
 * @public
 * @param {Object} cptOption
 * @return {boolean}
 */ function $d559f43cb9041423$var$isIdInner(cptOption) {
    return $d559f43cb9041423$var$isObject(cptOption) && cptOption.id && (cptOption.id + "").indexOf("\x00_ec_\x00") === 0;
}
/**
 * A helper for removing duplicate items between batchA and batchB,
 * and in themselves, and categorize by series.
 *
 * @param {Array.<Object>} batchA Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
 * @param {Array.<Object>} batchB Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
 * @return {Array.<Array.<Object>, Array.<Object>>} result: [resultBatchA, resultBatchB]
 */ function $d559f43cb9041423$var$compressBatches(batchA, batchB) {
    var mapA = {};
    var mapB = {};
    makeMap(batchA || [], mapA);
    makeMap(batchB || [], mapB, mapA);
    return [
        mapToArray(mapA),
        mapToArray(mapB)
    ];
    function makeMap(sourceBatch, map, otherMap) {
        for(var i = 0, len = sourceBatch.length; i < len; i++){
            var seriesId = sourceBatch[i].seriesId;
            var dataIndices = $d559f43cb9041423$var$normalizeToArray(sourceBatch[i].dataIndex);
            var otherDataIndices = otherMap && otherMap[seriesId];
            for(var j = 0, lenj = dataIndices.length; j < lenj; j++){
                var dataIndex = dataIndices[j];
                if (otherDataIndices && otherDataIndices[dataIndex]) otherDataIndices[dataIndex] = null;
                else (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
            }
        }
    }
    function mapToArray(map, isData) {
        var result = [];
        for(var i in map)if (map.hasOwnProperty(i) && map[i] != null) {
            if (isData) result.push(+i);
            else {
                var dataIndices = mapToArray(map[i], true);
                dataIndices.length && result.push({
                    seriesId: i,
                    dataIndex: dataIndices
                });
            }
        }
        return result;
    }
}
/**
 * @param {module:echarts/data/List} data
 * @param {Object} payload Contains dataIndex (means rawIndex) / dataIndexInside / name
 *                         each of which can be Array or primary type.
 * @return {number|Array.<number>} dataIndex If not found, return undefined/null.
 */ function $d559f43cb9041423$var$queryDataIndex(data, payload) {
    if (payload.dataIndexInside != null) return payload.dataIndexInside;
    else if (payload.dataIndex != null) return $ec279652dd95c27b$export$43bee75e5e14138e(payload.dataIndex) ? $ec279652dd95c27b$export$871de8747c9eaa88(payload.dataIndex, function(value) {
        return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
    else if (payload.name != null) return $ec279652dd95c27b$export$43bee75e5e14138e(payload.name) ? $ec279652dd95c27b$export$871de8747c9eaa88(payload.name, function(value) {
        return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
}
/**
 * Enable property storage to any host object.
 * Notice: Serialization is not supported.
 *
 * For example:
 * var inner = zrUitl.makeInner();
 *
 * function some1(hostObj) {
 *      inner(hostObj).someProperty = 1212;
 *      ...
 * }
 * function some2() {
 *      var fields = inner(this);
 *      fields.someProperty1 = 1212;
 *      fields.someProperty2 = 'xx';
 *      ...
 * }
 *
 * @return {Function}
 */ function $d559f43cb9041423$var$makeInner() {
    // Consider different scope by es module import.
    var key = "__\x00ec_inner_" + $d559f43cb9041423$var$innerUniqueIndex++ + "_" + Math.random().toFixed(5);
    return function(hostObj) {
        return hostObj[key] || (hostObj[key] = {});
    };
}
var $d559f43cb9041423$var$innerUniqueIndex = 0;
/**
 * @param {module:echarts/model/Global} ecModel
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex, seriesId, seriesName,
 *            geoIndex, geoId, geoName,
 *            bmapIndex, bmapId, bmapName,
 *            xAxisIndex, xAxisId, xAxisName,
 *            yAxisIndex, yAxisId, yAxisName,
 *            gridIndex, gridId, gridName,
 *            ... (can be extended)
 *        }
 *        Each properties can be number|string|Array.<number>|Array.<string>
 *        For example, a finder could be
 *        {
 *            seriesIndex: 3,
 *            geoId: ['aa', 'cc'],
 *            gridName: ['xx', 'rr']
 *        }
 *        xxxIndex can be set as 'all' (means all xxx) or 'none' (means not specify)
 *        If nothing or null/undefined specified, return nothing.
 * @param {Object} [opt]
 * @param {string} [opt.defaultMainType]
 * @param {Array.<string>} [opt.includeMainTypes]
 * @return {Object} result like:
 *        {
 *            seriesModels: [seriesModel1, seriesModel2],
 *            seriesModel: seriesModel1, // The first model
 *            geoModels: [geoModel1, geoModel2],
 *            geoModel: geoModel1, // The first model
 *            ...
 *        }
 */ function $d559f43cb9041423$var$parseFinder(ecModel, finder, opt) {
    if ($ec279652dd95c27b$export$844ec244b1367d54(finder)) {
        var obj = {};
        obj[finder + "Index"] = 0;
        finder = obj;
    }
    var defaultMainType = opt && opt.defaultMainType;
    if (defaultMainType && !$d559f43cb9041423$var$has(finder, defaultMainType + "Index") && !$d559f43cb9041423$var$has(finder, defaultMainType + "Id") && !$d559f43cb9041423$var$has(finder, defaultMainType + "Name")) finder[defaultMainType + "Index"] = 0;
    var result = {};
    $d559f43cb9041423$var$each(finder, function(value, key) {
        var value = finder[key]; // Exclude 'dataIndex' and other illgal keys.
        if (key === "dataIndex" || key === "dataIndexInside") {
            result[key] = value;
            return;
        }
        var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
        var mainType = parsedKey[1];
        var queryType = (parsedKey[2] || "").toLowerCase();
        if (!mainType || !queryType || value == null || queryType === "index" && value === "none" || opt && opt.includeMainTypes && $ec279652dd95c27b$export$305f7d4e9d4624f2(opt.includeMainTypes, mainType) < 0) return;
        var queryParam = {
            mainType: mainType
        };
        if (queryType !== "index" || value !== "all") queryParam[queryType] = value;
        var models = ecModel.queryComponents(queryParam);
        result[mainType + "Models"] = models;
        result[mainType + "Model"] = models[0];
    });
    return result;
}
function $d559f43cb9041423$var$has(obj, prop) {
    return obj && obj.hasOwnProperty(prop);
}
function $d559f43cb9041423$var$setAttribute(dom, key, value) {
    dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
}
function $d559f43cb9041423$var$getAttribute(dom, key) {
    return dom.getAttribute ? dom.getAttribute(key) : dom[key];
}
function $d559f43cb9041423$var$getTooltipRenderMode(renderModeOption) {
    if (renderModeOption === "auto") // Using html when `document` exists, use richText otherwise
    return $27ac1413ecc67076$exports.domSupported ? "html" : "richText";
    else return renderModeOption || "html";
}
/**
 * Group a list by key.
 *
 * @param {Array} array
 * @param {Function} getKey
 *        param {*} Array item
 *        return {string} key
 * @return {Object} Result
 *        {Array}: keys,
 *        {module:zrender/core/util/HashMap} buckets: {key -> Array}
 */ function $d559f43cb9041423$var$groupData(array, getKey) {
    var buckets = $ec279652dd95c27b$export$55f8aa7ef875b0a4();
    var keys = [];
    $ec279652dd95c27b$export$79b2f7037acddd43(array, function(item) {
        var key = getKey(item);
        (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
    });
    return {
        keys: keys,
        buckets: buckets
    };
}
$d559f43cb9041423$export$4f07b212a02c8051 = $d559f43cb9041423$var$normalizeToArray;
$d559f43cb9041423$export$abdcc6a26372f94b = $d559f43cb9041423$var$defaultEmphasis;
$d559f43cb9041423$export$df45610347a602ad = $d559f43cb9041423$var$TEXT_STYLE_OPTIONS;
$d559f43cb9041423$export$2c944e12edb48d4b = $d559f43cb9041423$var$getDataItemValue;
$d559f43cb9041423$export$3e1a543f33ef6883 = $d559f43cb9041423$var$isDataItemOption;
$d559f43cb9041423$export$574f818966e4da87 = $d559f43cb9041423$var$mappingToExists;
$d559f43cb9041423$export$6f01005fe2e2ddc6 = $d559f43cb9041423$var$makeIdAndName;
$d559f43cb9041423$export$beae19a2652b3368 = $d559f43cb9041423$var$isNameSpecified;
$d559f43cb9041423$export$66efd7adff61f97d = $d559f43cb9041423$var$isIdInner;
$d559f43cb9041423$export$6d12cabb0c9bf8e3 = $d559f43cb9041423$var$compressBatches;
$d559f43cb9041423$export$42b26cae8b8d10 = $d559f43cb9041423$var$queryDataIndex;
$d559f43cb9041423$export$64df9f8d92ae083f = $d559f43cb9041423$var$makeInner;
$d559f43cb9041423$export$95de80076abac814 = $d559f43cb9041423$var$parseFinder;
$d559f43cb9041423$export$9fec4d97f1922e0b = $d559f43cb9041423$var$setAttribute;
$d559f43cb9041423$export$735ee1799fd02602 = $d559f43cb9041423$var$getAttribute;
$d559f43cb9041423$export$cc0a17a5d27b4e17 = $d559f43cb9041423$var$getTooltipRenderMode;
$d559f43cb9041423$export$7ab5bda43e13168f = $d559f43cb9041423$var$groupData;


var $2b51b4bf776ec22e$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $2b51b4bf776ec22e$var$makeInner = $d559f43cb9041423$export$64df9f8d92ae083f;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $c125ba1250423743$export$fbe18865d303bf01;
var $c125ba1250423743$export$cd4c3a4dca301c70;
var $c125ba1250423743$export$e1aac4552ae82081;
var $c125ba1250423743$export$241315e45585454d;
var $c125ba1250423743$export$62311ce54ddfc862;

var $c125ba1250423743$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $c125ba1250423743$var$TYPE_DELIMITER = ".";
var $c125ba1250423743$var$IS_CONTAINER = "___EC__COMPONENT__CONTAINER___";
/**
 * Notice, parseClassType('') should returns {main: '', sub: ''}
 * @public
 */ function $c125ba1250423743$var$parseClassType(componentType) {
    var ret = {
        main: "",
        sub: ""
    };
    if (componentType) {
        componentType = componentType.split($c125ba1250423743$var$TYPE_DELIMITER);
        ret.main = componentType[0] || "";
        ret.sub = componentType[1] || "";
    }
    return ret;
}
/**
 * @public
 */ function $c125ba1250423743$var$checkClassType(componentType) {
    $ec279652dd95c27b$export$a7a9523472993e97(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}
/**
 * @public
 */ function $c125ba1250423743$var$enableClassExtend(RootClass, mandatoryMethods) {
    RootClass.$constructor = RootClass;
    RootClass.extend = function(proto) {
        var superClass = this;
        var ExtendedClass = function() {
            if (!proto.$constructor) superClass.apply(this, arguments);
            else proto.$constructor.apply(this, arguments);
        };
        $ec279652dd95c27b$export$8b58be045bf06082(ExtendedClass.prototype, proto);
        ExtendedClass.extend = this.extend;
        ExtendedClass.superCall = $c125ba1250423743$var$superCall;
        ExtendedClass.superApply = $c125ba1250423743$var$superApply;
        $ec279652dd95c27b$export$69f1b2dcda23c5f8(ExtendedClass, this);
        ExtendedClass.superClass = superClass;
        return ExtendedClass;
    };
}
var $c125ba1250423743$var$classBase = 0;
/**
 * Can not use instanceof, consider different scope by
 * cross domain or es module import in ec extensions.
 * Mount a method "isInstance()" to Clz.
 */ function $c125ba1250423743$var$enableClassCheck(Clz) {
    var classAttr = [
        "__\x00is_clz",
        $c125ba1250423743$var$classBase++,
        Math.random().toFixed(3)
    ].join("_");
    Clz.prototype[classAttr] = true;
    Clz.isInstance = function(obj) {
        return !!(obj && obj[classAttr]);
    };
} // superCall should have class info, which can not be fetch from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, do not overrides method f,
// then when method of class C is called, dead loop occured.
function $c125ba1250423743$var$superCall(context, methodName) {
    var args = $ec279652dd95c27b$export$58adb3bec8346d0f(arguments, 2);
    return this.superClass.prototype[methodName].apply(context, args);
}
function $c125ba1250423743$var$superApply(context, methodName, args) {
    return this.superClass.prototype[methodName].apply(context, args);
}
/**
 * @param {Object} entity
 * @param {Object} options
 * @param {boolean} [options.registerWhenExtend]
 * @public
 */ function $c125ba1250423743$var$enableClassManagement(entity, options) {
    options = options || {};
    /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'xxx'
   *     or Object.<subKey, componentClass>, when componentType is 'xxx.yy'
   * @type {Object}
   */ var storage = {};
    entity.registerClass = function(Clazz, componentType) {
        if (componentType) {
            $c125ba1250423743$var$checkClassType(componentType);
            componentType = $c125ba1250423743$var$parseClassType(componentType);
            if (!componentType.sub) storage[componentType.main] = Clazz;
            else if (componentType.sub !== $c125ba1250423743$var$IS_CONTAINER) {
                var container = makeContainer(componentType);
                container[componentType.sub] = Clazz;
            }
        }
        return Clazz;
    };
    entity.getClass = function(componentMainType, subType, throwWhenNotFound) {
        var Clazz = storage[componentMainType];
        if (Clazz && Clazz[$c125ba1250423743$var$IS_CONTAINER]) Clazz = subType ? Clazz[subType] : null;
        if (throwWhenNotFound && !Clazz) throw new Error(!subType ? componentMainType + "." + "type should be specified." : "Component " + componentMainType + "." + (subType || "") + " not exists. Load it first.");
        return Clazz;
    };
    entity.getClassesByMainType = function(componentType) {
        componentType = $c125ba1250423743$var$parseClassType(componentType);
        var result = [];
        var obj = storage[componentType.main];
        if (obj && obj[$c125ba1250423743$var$IS_CONTAINER]) $ec279652dd95c27b$export$79b2f7037acddd43(obj, function(o, type) {
            type !== $c125ba1250423743$var$IS_CONTAINER && result.push(o);
        });
        else result.push(obj);
        return result;
    };
    entity.hasClass = function(componentType) {
        // Just consider componentType.main.
        componentType = $c125ba1250423743$var$parseClassType(componentType);
        return !!storage[componentType.main];
    };
    /**
   * @return {Array.<string>} Like ['aa', 'bb'], but can not be ['aa.xx']
   */ entity.getAllClassMainTypes = function() {
        var types = [];
        $ec279652dd95c27b$export$79b2f7037acddd43(storage, function(obj, type) {
            types.push(type);
        });
        return types;
    };
    /**
   * If a main type is container and has sub types
   * @param  {string}  mainType
   * @return {boolean}
   */ entity.hasSubTypes = function(componentType) {
        componentType = $c125ba1250423743$var$parseClassType(componentType);
        var obj = storage[componentType.main];
        return obj && obj[$c125ba1250423743$var$IS_CONTAINER];
    };
    entity.parseClassType = $c125ba1250423743$var$parseClassType;
    function makeContainer(componentType) {
        var container = storage[componentType.main];
        if (!container || !container[$c125ba1250423743$var$IS_CONTAINER]) {
            container = storage[componentType.main] = {};
            container[$c125ba1250423743$var$IS_CONTAINER] = true;
        }
        return container;
    }
    if (options.registerWhenExtend) {
        var originalExtend = entity.extend;
        if (originalExtend) entity.extend = function(proto) {
            var ExtendedClass = originalExtend.call(this, proto);
            return entity.registerClass(ExtendedClass, proto.type);
        };
    }
    return entity;
}
/**
 * @param {string|Array.<string>} properties
 */ function $c125ba1250423743$var$setReadOnly(obj, properties) {
// if (!zrUtil.isArray(properties)) {
//     properties = properties != null ? [properties] : [];
// }
// zrUtil.each(properties, function (prop) {
//     var value = obj[prop];
//     Object.defineProperty
//         && Object.defineProperty(obj, prop, {
//             value: value, writable: false
//         });
//     zrUtil.isArray(obj[prop])
//         && Object.freeze
//         && Object.freeze(obj[prop]);
// });
}
$c125ba1250423743$export$fbe18865d303bf01 = $c125ba1250423743$var$parseClassType;
$c125ba1250423743$export$cd4c3a4dca301c70 = $c125ba1250423743$var$enableClassExtend;
$c125ba1250423743$export$e1aac4552ae82081 = $c125ba1250423743$var$enableClassCheck;
$c125ba1250423743$export$241315e45585454d = $c125ba1250423743$var$enableClassManagement;
$c125ba1250423743$export$62311ce54ddfc862 = $c125ba1250423743$var$setReadOnly;


var $2b51b4bf776ec22e$var$enableClassExtend = $c125ba1250423743$export$cd4c3a4dca301c70;
var $2b51b4bf776ec22e$var$enableClassCheck = $c125ba1250423743$export$e1aac4552ae82081;
var $86d235be5020002e$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $d701679ba7a46009$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Parse shadow style
// TODO Only shallow path support
function $d701679ba7a46009$var$_default(properties) {
    // Normalize
    for(var i = 0; i < properties.length; i++)if (!properties[i][1]) properties[i][1] = properties[i][0];
    return function(model, excludes, includes) {
        var style = {};
        for(var i = 0; i < properties.length; i++){
            var propName = properties[i][1];
            if (excludes && $ec279652dd95c27b$export$305f7d4e9d4624f2(excludes, propName) >= 0 || includes && $ec279652dd95c27b$export$305f7d4e9d4624f2(includes, propName) < 0) continue;
            var val = model.getShallow(propName);
            if (val != null) style[properties[i][0]] = val;
        }
        return style;
    };
}
$d701679ba7a46009$exports = $d701679ba7a46009$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $86d235be5020002e$var$getLineStyle = $d701679ba7a46009$exports([
    [
        "lineWidth",
        "width"
    ],
    [
        "stroke",
        "color"
    ],
    [
        "opacity"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "shadowColor"
    ]
]);
var $86d235be5020002e$var$_default = {
    getLineStyle: function(excludes) {
        var style = $86d235be5020002e$var$getLineStyle(this, excludes); // Always set lineDash whether dashed, otherwise we can not
        // erase the previous style when assigning to el.style.
        style.lineDash = this.getLineDash(style.lineWidth);
        return style;
    },
    getLineDash: function(lineWidth) {
        if (lineWidth == null) lineWidth = 1;
        var lineType = this.get("type");
        var dotSize = Math.max(lineWidth, 2);
        var dashSize = lineWidth * 4;
        return lineType === "solid" || lineType == null ? // ignored when assigning to `el.style`. e.g., when setting `lineStyle.type` as
        // `'dashed'` and `emphasis.lineStyle.type` as `'solid'` in graph series, the
        // `lineDash` gotten form the latter one is not able to erase that from the former
        // one if using `null` here according to the emhpsis strategy in `util/graphic.js`.
        false : lineType === "dashed" ? [
            dashSize,
            dashSize
        ] : [
            dotSize,
            dotSize
        ];
    }
};
$86d235be5020002e$exports = $86d235be5020002e$var$_default;


var $6459279907957a83$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $6459279907957a83$var$getAreaStyle = $d701679ba7a46009$exports([
    [
        "fill",
        "color"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "opacity"
    ],
    [
        "shadowColor"
    ]
]);
var $6459279907957a83$var$_default = {
    getAreaStyle: function(excludes, includes) {
        return $6459279907957a83$var$getAreaStyle(this, excludes, includes);
    }
};
$6459279907957a83$exports = $6459279907957a83$var$_default;


var $16a1179a33351935$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4b57d6b582d579b7$exports = {};

$parcel$export($4b57d6b582d579b7$exports, "Image", () => $4b57d6b582d579b7$export$3e431a229df88919, (v) => $4b57d6b582d579b7$export$3e431a229df88919 = v);
$parcel$export($4b57d6b582d579b7$exports, "Group", () => $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4, (v) => $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4 = v);
$parcel$export($4b57d6b582d579b7$exports, "Text", () => $4b57d6b582d579b7$export$5f1af8db9871e1d6, (v) => $4b57d6b582d579b7$export$5f1af8db9871e1d6 = v);
$parcel$export($4b57d6b582d579b7$exports, "Circle", () => $4b57d6b582d579b7$export$c89a927ffc67e6fa, (v) => $4b57d6b582d579b7$export$c89a927ffc67e6fa = v);
$parcel$export($4b57d6b582d579b7$exports, "Sector", () => $4b57d6b582d579b7$export$e98c2c7eb2b14f45, (v) => $4b57d6b582d579b7$export$e98c2c7eb2b14f45 = v);
$parcel$export($4b57d6b582d579b7$exports, "Ring", () => $4b57d6b582d579b7$export$a6e3577650b6d6d7, (v) => $4b57d6b582d579b7$export$a6e3577650b6d6d7 = v);
$parcel$export($4b57d6b582d579b7$exports, "Polygon", () => $4b57d6b582d579b7$export$7d31b617c820d435, (v) => $4b57d6b582d579b7$export$7d31b617c820d435 = v);
$parcel$export($4b57d6b582d579b7$exports, "Polyline", () => $4b57d6b582d579b7$export$79f3ee03e63e7073, (v) => $4b57d6b582d579b7$export$79f3ee03e63e7073 = v);
$parcel$export($4b57d6b582d579b7$exports, "Rect", () => $4b57d6b582d579b7$export$c79fc6492f3af13d, (v) => $4b57d6b582d579b7$export$c79fc6492f3af13d = v);
$parcel$export($4b57d6b582d579b7$exports, "Line", () => $4b57d6b582d579b7$export$17d680238e50603e, (v) => $4b57d6b582d579b7$export$17d680238e50603e = v);
$parcel$export($4b57d6b582d579b7$exports, "BezierCurve", () => $4b57d6b582d579b7$export$a57c23a30525a34b, (v) => $4b57d6b582d579b7$export$a57c23a30525a34b = v);
$parcel$export($4b57d6b582d579b7$exports, "Arc", () => $4b57d6b582d579b7$export$6ef80ffb606dd232, (v) => $4b57d6b582d579b7$export$6ef80ffb606dd232 = v);
$parcel$export($4b57d6b582d579b7$exports, "CompoundPath", () => $4b57d6b582d579b7$export$eabfbb332713dc05, (v) => $4b57d6b582d579b7$export$eabfbb332713dc05 = v);
$parcel$export($4b57d6b582d579b7$exports, "LinearGradient", () => $4b57d6b582d579b7$export$39a41c7169757633, (v) => $4b57d6b582d579b7$export$39a41c7169757633 = v);
$parcel$export($4b57d6b582d579b7$exports, "RadialGradient", () => $4b57d6b582d579b7$export$a02a7a57e5353659, (v) => $4b57d6b582d579b7$export$a02a7a57e5353659 = v);
$parcel$export($4b57d6b582d579b7$exports, "BoundingRect", () => $4b57d6b582d579b7$export$2cf684e818bac055, (v) => $4b57d6b582d579b7$export$2cf684e818bac055 = v);
$parcel$export($4b57d6b582d579b7$exports, "IncrementalDisplayable", () => $4b57d6b582d579b7$export$2a80125dfdd88240, (v) => $4b57d6b582d579b7$export$2a80125dfdd88240 = v);
$parcel$export($4b57d6b582d579b7$exports, "Z2_EMPHASIS_LIFT", () => $4b57d6b582d579b7$export$1cb9fc6ed5b9836c, (v) => $4b57d6b582d579b7$export$1cb9fc6ed5b9836c = v);
$parcel$export($4b57d6b582d579b7$exports, "CACHED_LABEL_STYLE_PROPERTIES", () => $4b57d6b582d579b7$export$5f1d7d4030ae155b, (v) => $4b57d6b582d579b7$export$5f1d7d4030ae155b = v);
$parcel$export($4b57d6b582d579b7$exports, "extendShape", () => $4b57d6b582d579b7$export$d0d5398c9d612037, (v) => $4b57d6b582d579b7$export$d0d5398c9d612037 = v);
$parcel$export($4b57d6b582d579b7$exports, "extendPath", () => $4b57d6b582d579b7$export$53b54a3137026af0, (v) => $4b57d6b582d579b7$export$53b54a3137026af0 = v);
$parcel$export($4b57d6b582d579b7$exports, "registerShape", () => $4b57d6b582d579b7$export$2b95b62e3aaf6fdd, (v) => $4b57d6b582d579b7$export$2b95b62e3aaf6fdd = v);
$parcel$export($4b57d6b582d579b7$exports, "getShapeClass", () => $4b57d6b582d579b7$export$51df4b5565a58189, (v) => $4b57d6b582d579b7$export$51df4b5565a58189 = v);
$parcel$export($4b57d6b582d579b7$exports, "makePath", () => $4b57d6b582d579b7$export$aa9bab72412f5613, (v) => $4b57d6b582d579b7$export$aa9bab72412f5613 = v);
$parcel$export($4b57d6b582d579b7$exports, "makeImage", () => $4b57d6b582d579b7$export$7a2bdede98851ac5, (v) => $4b57d6b582d579b7$export$7a2bdede98851ac5 = v);
$parcel$export($4b57d6b582d579b7$exports, "mergePath", () => $4b57d6b582d579b7$export$7b1dd269fbc4e903, (v) => $4b57d6b582d579b7$export$7b1dd269fbc4e903 = v);
$parcel$export($4b57d6b582d579b7$exports, "resizePath", () => $4b57d6b582d579b7$export$566dbf1c62b04fc7, (v) => $4b57d6b582d579b7$export$566dbf1c62b04fc7 = v);
$parcel$export($4b57d6b582d579b7$exports, "subPixelOptimizeLine", () => $4b57d6b582d579b7$export$8b4b620d7f4aad1b, (v) => $4b57d6b582d579b7$export$8b4b620d7f4aad1b = v);
$parcel$export($4b57d6b582d579b7$exports, "subPixelOptimizeRect", () => $4b57d6b582d579b7$export$60e2aa74957d0b9d, (v) => $4b57d6b582d579b7$export$60e2aa74957d0b9d = v);
$parcel$export($4b57d6b582d579b7$exports, "subPixelOptimize", () => $4b57d6b582d579b7$export$72c4fd4c1b8fcb10, (v) => $4b57d6b582d579b7$export$72c4fd4c1b8fcb10 = v);
$parcel$export($4b57d6b582d579b7$exports, "setElementHoverStyle", () => $4b57d6b582d579b7$export$2397e568fe8d15a0, (v) => $4b57d6b582d579b7$export$2397e568fe8d15a0 = v);
$parcel$export($4b57d6b582d579b7$exports, "setHoverStyle", () => $4b57d6b582d579b7$export$28b42df8183f218c, (v) => $4b57d6b582d579b7$export$28b42df8183f218c = v);
$parcel$export($4b57d6b582d579b7$exports, "setAsHighDownDispatcher", () => $4b57d6b582d579b7$export$9ba15aea1e048d48, (v) => $4b57d6b582d579b7$export$9ba15aea1e048d48 = v);
$parcel$export($4b57d6b582d579b7$exports, "isHighDownDispatcher", () => $4b57d6b582d579b7$export$77d1445f699c58b5, (v) => $4b57d6b582d579b7$export$77d1445f699c58b5 = v);
$parcel$export($4b57d6b582d579b7$exports, "getHighlightDigit", () => $4b57d6b582d579b7$export$824af40eb714530d, (v) => $4b57d6b582d579b7$export$824af40eb714530d = v);
$parcel$export($4b57d6b582d579b7$exports, "setLabelStyle", () => $4b57d6b582d579b7$export$9a13992917966657, (v) => $4b57d6b582d579b7$export$9a13992917966657 = v);
$parcel$export($4b57d6b582d579b7$exports, "modifyLabelStyle", () => $4b57d6b582d579b7$export$377292315e79b7ac, (v) => $4b57d6b582d579b7$export$377292315e79b7ac = v);
$parcel$export($4b57d6b582d579b7$exports, "setTextStyle", () => $4b57d6b582d579b7$export$6605af501964d89a, (v) => $4b57d6b582d579b7$export$6605af501964d89a = v);
$parcel$export($4b57d6b582d579b7$exports, "setText", () => $4b57d6b582d579b7$export$cbe0d99836e1498f, (v) => $4b57d6b582d579b7$export$cbe0d99836e1498f = v);
$parcel$export($4b57d6b582d579b7$exports, "getFont", () => $4b57d6b582d579b7$export$155316a870a9d61e, (v) => $4b57d6b582d579b7$export$155316a870a9d61e = v);
$parcel$export($4b57d6b582d579b7$exports, "updateProps", () => $4b57d6b582d579b7$export$c8dce3c08436e91e, (v) => $4b57d6b582d579b7$export$c8dce3c08436e91e = v);
$parcel$export($4b57d6b582d579b7$exports, "initProps", () => $4b57d6b582d579b7$export$a121566aadcfe021, (v) => $4b57d6b582d579b7$export$a121566aadcfe021 = v);
$parcel$export($4b57d6b582d579b7$exports, "getTransform", () => $4b57d6b582d579b7$export$fce0c6cfca85ed96, (v) => $4b57d6b582d579b7$export$fce0c6cfca85ed96 = v);
$parcel$export($4b57d6b582d579b7$exports, "applyTransform", () => $4b57d6b582d579b7$export$9f9dcb98c894b623, (v) => $4b57d6b582d579b7$export$9f9dcb98c894b623 = v);
$parcel$export($4b57d6b582d579b7$exports, "transformDirection", () => $4b57d6b582d579b7$export$fff94e9792354cfa, (v) => $4b57d6b582d579b7$export$fff94e9792354cfa = v);
$parcel$export($4b57d6b582d579b7$exports, "groupTransition", () => $4b57d6b582d579b7$export$64fcab7860c216ae, (v) => $4b57d6b582d579b7$export$64fcab7860c216ae = v);
$parcel$export($4b57d6b582d579b7$exports, "clipPointsByRect", () => $4b57d6b582d579b7$export$e2f409471bbbc1dc, (v) => $4b57d6b582d579b7$export$e2f409471bbbc1dc = v);
$parcel$export($4b57d6b582d579b7$exports, "clipRectByRect", () => $4b57d6b582d579b7$export$d0d3709202b8b2a, (v) => $4b57d6b582d579b7$export$d0d3709202b8b2a = v);
$parcel$export($4b57d6b582d579b7$exports, "createIcon", () => $4b57d6b582d579b7$export$274edc73af1ae9c8, (v) => $4b57d6b582d579b7$export$274edc73af1ae9c8 = v);
$parcel$export($4b57d6b582d579b7$exports, "linePolygonIntersect", () => $4b57d6b582d579b7$export$4f47c855a5e9ae9, (v) => $4b57d6b582d579b7$export$4f47c855a5e9ae9 = v);
$parcel$export($4b57d6b582d579b7$exports, "lineLineIntersect", () => $4b57d6b582d579b7$export$6c0a70ea1d8d158b, (v) => $4b57d6b582d579b7$export$6c0a70ea1d8d158b = v);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $4b57d6b582d579b7$export$3e431a229df88919;
var $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4;
var $4b57d6b582d579b7$export$5f1af8db9871e1d6;
var $4b57d6b582d579b7$export$c89a927ffc67e6fa;
var $4b57d6b582d579b7$export$e98c2c7eb2b14f45;
var $4b57d6b582d579b7$export$a6e3577650b6d6d7;
var $4b57d6b582d579b7$export$7d31b617c820d435;
var $4b57d6b582d579b7$export$79f3ee03e63e7073;
var $4b57d6b582d579b7$export$c79fc6492f3af13d;
var $4b57d6b582d579b7$export$17d680238e50603e;
var $4b57d6b582d579b7$export$a57c23a30525a34b;
var $4b57d6b582d579b7$export$6ef80ffb606dd232;
var $4b57d6b582d579b7$export$eabfbb332713dc05;
var $4b57d6b582d579b7$export$39a41c7169757633;
var $4b57d6b582d579b7$export$a02a7a57e5353659;
var $4b57d6b582d579b7$export$2cf684e818bac055;
var $4b57d6b582d579b7$export$2a80125dfdd88240;
var $4b57d6b582d579b7$export$1cb9fc6ed5b9836c;
var $4b57d6b582d579b7$export$5f1d7d4030ae155b;
var $4b57d6b582d579b7$export$d0d5398c9d612037;
var $4b57d6b582d579b7$export$53b54a3137026af0;
var $4b57d6b582d579b7$export$2b95b62e3aaf6fdd;
var $4b57d6b582d579b7$export$51df4b5565a58189;
var $4b57d6b582d579b7$export$aa9bab72412f5613;
var $4b57d6b582d579b7$export$7a2bdede98851ac5;
var $4b57d6b582d579b7$export$7b1dd269fbc4e903;
var $4b57d6b582d579b7$export$566dbf1c62b04fc7;
var $4b57d6b582d579b7$export$8b4b620d7f4aad1b;
var $4b57d6b582d579b7$export$60e2aa74957d0b9d;
var $4b57d6b582d579b7$export$72c4fd4c1b8fcb10;
var $4b57d6b582d579b7$export$2397e568fe8d15a0;
var $4b57d6b582d579b7$export$28b42df8183f218c;
var $4b57d6b582d579b7$export$9ba15aea1e048d48;
var $4b57d6b582d579b7$export$77d1445f699c58b5;
var $4b57d6b582d579b7$export$824af40eb714530d;
var $4b57d6b582d579b7$export$9a13992917966657;
var $4b57d6b582d579b7$export$377292315e79b7ac;
var $4b57d6b582d579b7$export$6605af501964d89a;
var $4b57d6b582d579b7$export$cbe0d99836e1498f;
var $4b57d6b582d579b7$export$155316a870a9d61e;
var $4b57d6b582d579b7$export$c8dce3c08436e91e;
var $4b57d6b582d579b7$export$a121566aadcfe021;
var $4b57d6b582d579b7$export$fce0c6cfca85ed96;
var $4b57d6b582d579b7$export$9f9dcb98c894b623;
var $4b57d6b582d579b7$export$fff94e9792354cfa;
var $4b57d6b582d579b7$export$64fcab7860c216ae;
var $4b57d6b582d579b7$export$e2f409471bbbc1dc;
var $4b57d6b582d579b7$export$d0d3709202b8b2a;
var $4b57d6b582d579b7$export$274edc73af1ae9c8;
var $4b57d6b582d579b7$export$4f47c855a5e9ae9;
var $4b57d6b582d579b7$export$6c0a70ea1d8d158b;

var $69b77ae5b8565cf7$export$ae5b259626f00aeb;
var $69b77ae5b8565cf7$export$68e3a51ba2ed417c;
var $69b77ae5b8565cf7$export$7b1dd269fbc4e903;
var $b9701a0f23f767de$exports = {};


var $4c785e18473c2aa4$exports = {};
var $ab3ad2315df1d857$export$547c21de482bbcb2;
var $ab3ad2315df1d857$export$55fce925c60b6271;
var $ab3ad2315df1d857$export$ca5d13faa10b167e;
var $ab3ad2315df1d857$export$df1a172f100d0457;
var $ab3ad2315df1d857$export$a2ee23a0567039da;
var $ab3ad2315df1d857$export$dbaa3801d1284367;
var $ab3ad2315df1d857$export$af17094a950f5073;
var $ab3ad2315df1d857$export$7e161e77e6fff8cb;
var $ab3ad2315df1d857$export$fd895ac7ee764967;
var $ab3ad2315df1d857$export$752e1f8c6e7f7e11;
var $ab3ad2315df1d857$export$117c659e21a7a060;
var $ab3ad2315df1d857$export$81915a594fe10dee;

var $ab3ad2315df1d857$var$v2Create = $9eb63d101f3bcd79$export$185802fd694ee1f5;
var $ab3ad2315df1d857$var$v2DistSquare = $9eb63d101f3bcd79$export$c68db45a034c13b0;
/**
 * 曲线辅助模块
 * @module zrender/core/curve
 * @author pissang(https://www.github.com/pissang)
 */ var $ab3ad2315df1d857$var$mathPow = Math.pow;
var $ab3ad2315df1d857$var$mathSqrt = Math.sqrt;
var $ab3ad2315df1d857$var$EPSILON = 1e-8;
var $ab3ad2315df1d857$var$EPSILON_NUMERIC = 1e-4;
var $ab3ad2315df1d857$var$THREE_SQRT = $ab3ad2315df1d857$var$mathSqrt(3);
var $ab3ad2315df1d857$var$ONE_THIRD = 1 / 3; // 临时变量
var $ab3ad2315df1d857$var$_v0 = $ab3ad2315df1d857$var$v2Create();
var $ab3ad2315df1d857$var$_v1 = $ab3ad2315df1d857$var$v2Create();
var $ab3ad2315df1d857$var$_v2 = $ab3ad2315df1d857$var$v2Create();
function $ab3ad2315df1d857$var$isAroundZero(val) {
    return val > -$ab3ad2315df1d857$var$EPSILON && val < $ab3ad2315df1d857$var$EPSILON;
}
function $ab3ad2315df1d857$var$isNotAroundZero(val) {
    return val > $ab3ad2315df1d857$var$EPSILON || val < -$ab3ad2315df1d857$var$EPSILON;
}
/**
 * 计算三次贝塞尔值
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @return {number}
 */ function $ab3ad2315df1d857$var$cubicAt(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
}
/**
 * 计算三次贝塞尔导数值
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @return {number}
 */ function $ab3ad2315df1d857$var$cubicDerivativeAt(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
}
/**
 * 计算三次贝塞尔方程根，使用盛金公式
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} val
 * @param  {Array.<number>} roots
 * @return {number} 有效根数目
 */ function $ab3ad2315df1d857$var$cubicRootAt(p0, p1, p2, p3, val, roots) {
    // Evaluate roots of cubic functions
    var a = p3 + 3 * (p1 - p2) - p0;
    var b = 3 * (p2 - p1 * 2 + p0);
    var c = 3 * (p1 - p0);
    var d = p0 - val;
    var A = b * b - 3 * a * c;
    var B = b * c - 9 * a * d;
    var C = c * c - 3 * b * d;
    var n = 0;
    if ($ab3ad2315df1d857$var$isAroundZero(A) && $ab3ad2315df1d857$var$isAroundZero(B)) {
        if ($ab3ad2315df1d857$var$isAroundZero(b)) roots[0] = 0;
        else {
            var t1 = -c / b; //t1, t2, t3, b is not zero
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = B * B - 4 * A * C;
        if ($ab3ad2315df1d857$var$isAroundZero(disc)) {
            var K = B / A;
            var t1 = -b / a + K; // t1, a is not zero
            var t2 = -K / 2; // t2, t3
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        } else if (disc > 0) {
            var discSqrt = $ab3ad2315df1d857$var$mathSqrt(disc);
            var Y1 = A * b + 1.5 * a * (-B + discSqrt);
            var Y2 = A * b + 1.5 * a * (-B - discSqrt);
            if (Y1 < 0) Y1 = -$ab3ad2315df1d857$var$mathPow(-Y1, $ab3ad2315df1d857$var$ONE_THIRD);
            else Y1 = $ab3ad2315df1d857$var$mathPow(Y1, $ab3ad2315df1d857$var$ONE_THIRD);
            if (Y2 < 0) Y2 = -$ab3ad2315df1d857$var$mathPow(-Y2, $ab3ad2315df1d857$var$ONE_THIRD);
            else Y2 = $ab3ad2315df1d857$var$mathPow(Y2, $ab3ad2315df1d857$var$ONE_THIRD);
            var t1 = (-b - (Y1 + Y2)) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else {
            var T = (2 * A * b - 3 * a * B) / (2 * $ab3ad2315df1d857$var$mathSqrt(A * A * A));
            var theta = Math.acos(T) / 3;
            var ASqrt = $ab3ad2315df1d857$var$mathSqrt(A);
            var tmp = Math.cos(theta);
            var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
            var t2 = (-b + ASqrt * (tmp + $ab3ad2315df1d857$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            var t3 = (-b + ASqrt * (tmp - $ab3ad2315df1d857$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            if (t3 >= 0 && t3 <= 1) roots[n++] = t3;
        }
    }
    return n;
}
/**
 * 计算三次贝塞尔方程极限值的位置
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {Array.<number>} extrema
 * @return {number} 有效数目
 */ function $ab3ad2315df1d857$var$cubicExtrema(p0, p1, p2, p3, extrema) {
    var b = 6 * p2 - 12 * p1 + 6 * p0;
    var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
    var c = 3 * p1 - 3 * p0;
    var n = 0;
    if ($ab3ad2315df1d857$var$isAroundZero(a)) {
        if ($ab3ad2315df1d857$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($ab3ad2315df1d857$var$isAroundZero(disc)) extrema[0] = -b / (2 * a);
        else if (disc > 0) {
            var discSqrt = $ab3ad2315df1d857$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
            if (t2 >= 0 && t2 <= 1) extrema[n++] = t2;
        }
    }
    return n;
}
/**
 * 细分三次贝塞尔曲线
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @param  {Array.<number>} out
 */ function $ab3ad2315df1d857$var$cubicSubdivide(p0, p1, p2, p3, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p23 = (p3 - p2) * t + p2;
    var p012 = (p12 - p01) * t + p01;
    var p123 = (p23 - p12) * t + p12;
    var p0123 = (p123 - p012) * t + p012; // Seg0
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p0123; // Seg1
    out[4] = p0123;
    out[5] = p123;
    out[6] = p23;
    out[7] = p3;
}
/**
 * 投射点到三次贝塞尔曲线上，返回投射距离。
 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {number} x3
 * @param {number} y3
 * @param {number} x
 * @param {number} y
 * @param {Array.<number>} [out] 投射点
 * @return {number}
 */ function $ab3ad2315df1d857$var$cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
    // http://pomax.github.io/bezierinfo/#projections
    var t;
    var interval = 0.005;
    var d = Infinity;
    var prev;
    var next;
    var d1;
    var d2;
    $ab3ad2315df1d857$var$_v0[0] = x;
    $ab3ad2315df1d857$var$_v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
    // PENDING
    for(var _t = 0; _t < 1; _t += 0.05){
        $ab3ad2315df1d857$var$_v1[0] = $ab3ad2315df1d857$var$cubicAt(x0, x1, x2, x3, _t);
        $ab3ad2315df1d857$var$_v1[1] = $ab3ad2315df1d857$var$cubicAt(y0, y1, y2, y3, _t);
        d1 = $ab3ad2315df1d857$var$v2DistSquare($ab3ad2315df1d857$var$_v0, $ab3ad2315df1d857$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity; // At most 32 iteration
    for(var i = 0; i < 32; i++){
        if (interval < $ab3ad2315df1d857$var$EPSILON_NUMERIC) break;
        prev = t - interval;
        next = t + interval; // t - interval
        $ab3ad2315df1d857$var$_v1[0] = $ab3ad2315df1d857$var$cubicAt(x0, x1, x2, x3, prev);
        $ab3ad2315df1d857$var$_v1[1] = $ab3ad2315df1d857$var$cubicAt(y0, y1, y2, y3, prev);
        d1 = $ab3ad2315df1d857$var$v2DistSquare($ab3ad2315df1d857$var$_v1, $ab3ad2315df1d857$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            // t + interval
            $ab3ad2315df1d857$var$_v2[0] = $ab3ad2315df1d857$var$cubicAt(x0, x1, x2, x3, next);
            $ab3ad2315df1d857$var$_v2[1] = $ab3ad2315df1d857$var$cubicAt(y0, y1, y2, y3, next);
            d2 = $ab3ad2315df1d857$var$v2DistSquare($ab3ad2315df1d857$var$_v2, $ab3ad2315df1d857$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    } // t
    if (out) {
        out[0] = $ab3ad2315df1d857$var$cubicAt(x0, x1, x2, x3, t);
        out[1] = $ab3ad2315df1d857$var$cubicAt(y0, y1, y2, y3, t);
    } // console.log(interval, i);
    return $ab3ad2315df1d857$var$mathSqrt(d);
}
/**
 * 计算二次方贝塞尔值
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @return {number}
 */ function $ab3ad2315df1d857$var$quadraticAt(p0, p1, p2, t) {
    var onet = 1 - t;
    return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
/**
 * 计算二次方贝塞尔导数值
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @return {number}
 */ function $ab3ad2315df1d857$var$quadraticDerivativeAt(p0, p1, p2, t) {
    return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
/**
 * 计算二次方贝塞尔方程根
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @param  {Array.<number>} roots
 * @return {number} 有效根数目
 */ function $ab3ad2315df1d857$var$quadraticRootAt(p0, p1, p2, val, roots) {
    var a = p0 - 2 * p1 + p2;
    var b = 2 * (p1 - p0);
    var c = p0 - val;
    var n = 0;
    if ($ab3ad2315df1d857$var$isAroundZero(a)) {
        if ($ab3ad2315df1d857$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($ab3ad2315df1d857$var$isAroundZero(disc)) {
            var t1 = -b / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else if (disc > 0) {
            var discSqrt = $ab3ad2315df1d857$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        }
    }
    return n;
}
/**
 * 计算二次贝塞尔方程极限值
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @return {number}
 */ function $ab3ad2315df1d857$var$quadraticExtremum(p0, p1, p2) {
    var divider = p0 + p2 - 2 * p1;
    if (divider === 0) // p1 is center of p0 and p2
    return 0.5;
    else return (p0 - p1) / divider;
}
/**
 * 细分二次贝塞尔曲线
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @param  {Array.<number>} out
 */ function $ab3ad2315df1d857$var$quadraticSubdivide(p0, p1, p2, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p012 = (p12 - p01) * t + p01; // Seg0
    out[0] = p0;
    out[1] = p01;
    out[2] = p012; // Seg1
    out[3] = p012;
    out[4] = p12;
    out[5] = p2;
}
/**
 * 投射点到二次贝塞尔曲线上，返回投射距离。
 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {number} x
 * @param {number} y
 * @param {Array.<number>} out 投射点
 * @return {number}
 */ function $ab3ad2315df1d857$var$quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, out) {
    // http://pomax.github.io/bezierinfo/#projections
    var t;
    var interval = 0.005;
    var d = Infinity;
    $ab3ad2315df1d857$var$_v0[0] = x;
    $ab3ad2315df1d857$var$_v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
    // PENDING
    for(var _t = 0; _t < 1; _t += 0.05){
        $ab3ad2315df1d857$var$_v1[0] = $ab3ad2315df1d857$var$quadraticAt(x0, x1, x2, _t);
        $ab3ad2315df1d857$var$_v1[1] = $ab3ad2315df1d857$var$quadraticAt(y0, y1, y2, _t);
        var d1 = $ab3ad2315df1d857$var$v2DistSquare($ab3ad2315df1d857$var$_v0, $ab3ad2315df1d857$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity; // At most 32 iteration
    for(var i = 0; i < 32; i++){
        if (interval < $ab3ad2315df1d857$var$EPSILON_NUMERIC) break;
        var prev = t - interval;
        var next = t + interval; // t - interval
        $ab3ad2315df1d857$var$_v1[0] = $ab3ad2315df1d857$var$quadraticAt(x0, x1, x2, prev);
        $ab3ad2315df1d857$var$_v1[1] = $ab3ad2315df1d857$var$quadraticAt(y0, y1, y2, prev);
        var d1 = $ab3ad2315df1d857$var$v2DistSquare($ab3ad2315df1d857$var$_v1, $ab3ad2315df1d857$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            // t + interval
            $ab3ad2315df1d857$var$_v2[0] = $ab3ad2315df1d857$var$quadraticAt(x0, x1, x2, next);
            $ab3ad2315df1d857$var$_v2[1] = $ab3ad2315df1d857$var$quadraticAt(y0, y1, y2, next);
            var d2 = $ab3ad2315df1d857$var$v2DistSquare($ab3ad2315df1d857$var$_v2, $ab3ad2315df1d857$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    } // t
    if (out) {
        out[0] = $ab3ad2315df1d857$var$quadraticAt(x0, x1, x2, t);
        out[1] = $ab3ad2315df1d857$var$quadraticAt(y0, y1, y2, t);
    } // console.log(interval, i);
    return $ab3ad2315df1d857$var$mathSqrt(d);
}
$ab3ad2315df1d857$export$547c21de482bbcb2 = $ab3ad2315df1d857$var$cubicAt;
$ab3ad2315df1d857$export$55fce925c60b6271 = $ab3ad2315df1d857$var$cubicDerivativeAt;
$ab3ad2315df1d857$export$ca5d13faa10b167e = $ab3ad2315df1d857$var$cubicRootAt;
$ab3ad2315df1d857$export$df1a172f100d0457 = $ab3ad2315df1d857$var$cubicExtrema;
$ab3ad2315df1d857$export$a2ee23a0567039da = $ab3ad2315df1d857$var$cubicSubdivide;
$ab3ad2315df1d857$export$dbaa3801d1284367 = $ab3ad2315df1d857$var$cubicProjectPoint;
$ab3ad2315df1d857$export$af17094a950f5073 = $ab3ad2315df1d857$var$quadraticAt;
$ab3ad2315df1d857$export$7e161e77e6fff8cb = $ab3ad2315df1d857$var$quadraticDerivativeAt;
$ab3ad2315df1d857$export$fd895ac7ee764967 = $ab3ad2315df1d857$var$quadraticRootAt;
$ab3ad2315df1d857$export$752e1f8c6e7f7e11 = $ab3ad2315df1d857$var$quadraticExtremum;
$ab3ad2315df1d857$export$117c659e21a7a060 = $ab3ad2315df1d857$var$quadraticSubdivide;
$ab3ad2315df1d857$export$81915a594fe10dee = $ab3ad2315df1d857$var$quadraticProjectPoint;



var $22231ac051eb7cf7$export$188c3cd07b4129dd;
var $22231ac051eb7cf7$export$d2b1491e4450bf2c;
var $22231ac051eb7cf7$export$c1bc6be456bb6609;
var $22231ac051eb7cf7$export$16fbe795323a1f4c;
var $22231ac051eb7cf7$export$161c8bb0e1d9ef49;


/**
 * @author Yi Shen(https://github.com/pissang)
 */ var $22231ac051eb7cf7$var$mathMin = Math.min;
var $22231ac051eb7cf7$var$mathMax = Math.max;
var $22231ac051eb7cf7$var$mathSin = Math.sin;
var $22231ac051eb7cf7$var$mathCos = Math.cos;
var $22231ac051eb7cf7$var$PI2 = Math.PI * 2;
var $22231ac051eb7cf7$var$start = $9eb63d101f3bcd79$export$185802fd694ee1f5();
var $22231ac051eb7cf7$var$end = $9eb63d101f3bcd79$export$185802fd694ee1f5();
var $22231ac051eb7cf7$var$extremity = $9eb63d101f3bcd79$export$185802fd694ee1f5();
/**
 * 从顶点数组中计算出最小包围盒，写入`min`和`max`中
 * @module zrender/core/bbox
 * @param {Array<Object>} points 顶点数组
 * @param {number} min
 * @param {number} max
 */ function $22231ac051eb7cf7$var$fromPoints(points, min, max) {
    if (points.length === 0) return;
    var p = points[0];
    var left = p[0];
    var right = p[0];
    var top = p[1];
    var bottom = p[1];
    var i;
    for(i = 1; i < points.length; i++){
        p = points[i];
        left = $22231ac051eb7cf7$var$mathMin(left, p[0]);
        right = $22231ac051eb7cf7$var$mathMax(right, p[0]);
        top = $22231ac051eb7cf7$var$mathMin(top, p[1]);
        bottom = $22231ac051eb7cf7$var$mathMax(bottom, p[1]);
    }
    min[0] = left;
    min[1] = top;
    max[0] = right;
    max[1] = bottom;
}
/**
 * @memberOf module:zrender/core/bbox
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */ function $22231ac051eb7cf7$var$fromLine(x0, y0, x1, y1, min, max) {
    min[0] = $22231ac051eb7cf7$var$mathMin(x0, x1);
    min[1] = $22231ac051eb7cf7$var$mathMin(y0, y1);
    max[0] = $22231ac051eb7cf7$var$mathMax(x0, x1);
    max[1] = $22231ac051eb7cf7$var$mathMax(y0, y1);
}
var $22231ac051eb7cf7$var$xDim = [];
var $22231ac051eb7cf7$var$yDim = [];
/**
 * 从三阶贝塞尔曲线(p0, p1, p2, p3)中计算出最小包围盒，写入`min`和`max`中
 * @memberOf module:zrender/core/bbox
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {number} x3
 * @param {number} y3
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */ function $22231ac051eb7cf7$var$fromCubic(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
    var cubicExtrema = $ab3ad2315df1d857$export$df1a172f100d0457;
    var cubicAt = $ab3ad2315df1d857$export$547c21de482bbcb2;
    var i;
    var n = cubicExtrema(x0, x1, x2, x3, $22231ac051eb7cf7$var$xDim);
    min[0] = Infinity;
    min[1] = Infinity;
    max[0] = -Infinity;
    max[1] = -Infinity;
    for(i = 0; i < n; i++){
        var x = cubicAt(x0, x1, x2, x3, $22231ac051eb7cf7$var$xDim[i]);
        min[0] = $22231ac051eb7cf7$var$mathMin(x, min[0]);
        max[0] = $22231ac051eb7cf7$var$mathMax(x, max[0]);
    }
    n = cubicExtrema(y0, y1, y2, y3, $22231ac051eb7cf7$var$yDim);
    for(i = 0; i < n; i++){
        var y = cubicAt(y0, y1, y2, y3, $22231ac051eb7cf7$var$yDim[i]);
        min[1] = $22231ac051eb7cf7$var$mathMin(y, min[1]);
        max[1] = $22231ac051eb7cf7$var$mathMax(y, max[1]);
    }
    min[0] = $22231ac051eb7cf7$var$mathMin(x0, min[0]);
    max[0] = $22231ac051eb7cf7$var$mathMax(x0, max[0]);
    min[0] = $22231ac051eb7cf7$var$mathMin(x3, min[0]);
    max[0] = $22231ac051eb7cf7$var$mathMax(x3, max[0]);
    min[1] = $22231ac051eb7cf7$var$mathMin(y0, min[1]);
    max[1] = $22231ac051eb7cf7$var$mathMax(y0, max[1]);
    min[1] = $22231ac051eb7cf7$var$mathMin(y3, min[1]);
    max[1] = $22231ac051eb7cf7$var$mathMax(y3, max[1]);
}
/**
 * 从二阶贝塞尔曲线(p0, p1, p2)中计算出最小包围盒，写入`min`和`max`中
 * @memberOf module:zrender/core/bbox
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */ function $22231ac051eb7cf7$var$fromQuadratic(x0, y0, x1, y1, x2, y2, min, max) {
    var quadraticExtremum = $ab3ad2315df1d857$export$752e1f8c6e7f7e11;
    var quadraticAt = $ab3ad2315df1d857$export$af17094a950f5073; // Find extremities, where derivative in x dim or y dim is zero
    var tx = $22231ac051eb7cf7$var$mathMax($22231ac051eb7cf7$var$mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
    var ty = $22231ac051eb7cf7$var$mathMax($22231ac051eb7cf7$var$mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
    var x = quadraticAt(x0, x1, x2, tx);
    var y = quadraticAt(y0, y1, y2, ty);
    min[0] = $22231ac051eb7cf7$var$mathMin(x0, x2, x);
    min[1] = $22231ac051eb7cf7$var$mathMin(y0, y2, y);
    max[0] = $22231ac051eb7cf7$var$mathMax(x0, x2, x);
    max[1] = $22231ac051eb7cf7$var$mathMax(y0, y2, y);
}
/**
 * 从圆弧中计算出最小包围盒，写入`min`和`max`中
 * @method
 * @memberOf module:zrender/core/bbox
 * @param {number} x
 * @param {number} y
 * @param {number} rx
 * @param {number} ry
 * @param {number} startAngle
 * @param {number} endAngle
 * @param {number} anticlockwise
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */ function $22231ac051eb7cf7$var$fromArc(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
    var vec2Min = $9eb63d101f3bcd79$export$96ec731ed4dcb222;
    var vec2Max = $9eb63d101f3bcd79$export$8960430cfd85939f;
    var diff = Math.abs(startAngle - endAngle);
    if (diff % $22231ac051eb7cf7$var$PI2 < 1e-4 && diff > 1e-4) {
        // Is a circle
        min[0] = x - rx;
        min[1] = y - ry;
        max[0] = x + rx;
        max[1] = y + ry;
        return;
    }
    $22231ac051eb7cf7$var$start[0] = $22231ac051eb7cf7$var$mathCos(startAngle) * rx + x;
    $22231ac051eb7cf7$var$start[1] = $22231ac051eb7cf7$var$mathSin(startAngle) * ry + y;
    $22231ac051eb7cf7$var$end[0] = $22231ac051eb7cf7$var$mathCos(endAngle) * rx + x;
    $22231ac051eb7cf7$var$end[1] = $22231ac051eb7cf7$var$mathSin(endAngle) * ry + y;
    vec2Min(min, $22231ac051eb7cf7$var$start, $22231ac051eb7cf7$var$end);
    vec2Max(max, $22231ac051eb7cf7$var$start, $22231ac051eb7cf7$var$end); // Thresh to [0, Math.PI * 2]
    startAngle = startAngle % $22231ac051eb7cf7$var$PI2;
    if (startAngle < 0) startAngle = startAngle + $22231ac051eb7cf7$var$PI2;
    endAngle = endAngle % $22231ac051eb7cf7$var$PI2;
    if (endAngle < 0) endAngle = endAngle + $22231ac051eb7cf7$var$PI2;
    if (startAngle > endAngle && !anticlockwise) endAngle += $22231ac051eb7cf7$var$PI2;
    else if (startAngle < endAngle && anticlockwise) startAngle += $22231ac051eb7cf7$var$PI2;
    if (anticlockwise) {
        var tmp = endAngle;
        endAngle = startAngle;
        startAngle = tmp;
    } // var number = 0;
    // var step = (anticlockwise ? -Math.PI : Math.PI) / 2;
    for(var angle = 0; angle < endAngle; angle += Math.PI / 2)if (angle > startAngle) {
        $22231ac051eb7cf7$var$extremity[0] = $22231ac051eb7cf7$var$mathCos(angle) * rx + x;
        $22231ac051eb7cf7$var$extremity[1] = $22231ac051eb7cf7$var$mathSin(angle) * ry + y;
        vec2Min(min, $22231ac051eb7cf7$var$extremity, min);
        vec2Max(max, $22231ac051eb7cf7$var$extremity, max);
    }
}
$22231ac051eb7cf7$export$188c3cd07b4129dd = $22231ac051eb7cf7$var$fromPoints;
$22231ac051eb7cf7$export$d2b1491e4450bf2c = $22231ac051eb7cf7$var$fromLine;
$22231ac051eb7cf7$export$c1bc6be456bb6609 = $22231ac051eb7cf7$var$fromCubic;
$22231ac051eb7cf7$export$16fbe795323a1f4c = $22231ac051eb7cf7$var$fromQuadratic;
$22231ac051eb7cf7$export$161c8bb0e1d9ef49 = $22231ac051eb7cf7$var$fromArc;




var $4c785e18473c2aa4$var$dpr = $2f7815d0a3a302c3$export$508f096bfcdaac40;
/**
 * Path 代理，可以在`buildPath`中用于替代`ctx`, 会保存每个path操作的命令到pathCommands属性中
 * 可以用于 isInsidePath 判断以及获取boundingRect
 *
 * @module zrender/core/PathProxy
 * @author Yi Shen (http://www.github.com/pissang)
 */ // TODO getTotalLength, getPointAtLength
/* global Float32Array */ var $4c785e18473c2aa4$var$CMD = {
    M: 1,
    L: 2,
    C: 3,
    Q: 4,
    A: 5,
    Z: 6,
    // Rect
    R: 7
}; // var CMD_MEM_SIZE = {
//     M: 3,
//     L: 3,
//     C: 7,
//     Q: 5,
//     A: 9,
//     R: 5,
//     Z: 1
// };
var $4c785e18473c2aa4$var$min = [];
var $4c785e18473c2aa4$var$max = [];
var $4c785e18473c2aa4$var$min2 = [];
var $4c785e18473c2aa4$var$max2 = [];
var $4c785e18473c2aa4$var$mathMin = Math.min;
var $4c785e18473c2aa4$var$mathMax = Math.max;
var $4c785e18473c2aa4$var$mathCos = Math.cos;
var $4c785e18473c2aa4$var$mathSin = Math.sin;
var $4c785e18473c2aa4$var$mathSqrt = Math.sqrt;
var $4c785e18473c2aa4$var$mathAbs = Math.abs;
var $4c785e18473c2aa4$var$hasTypedArray = typeof Float32Array !== "undefined";
/**
 * @alias module:zrender/core/PathProxy
 * @constructor
 */ var $4c785e18473c2aa4$var$PathProxy = function(notSaveData) {
    this._saveData = !(notSaveData || false);
    if (this._saveData) /**
     * Path data. Stored as flat array
     * @type {Array.<Object>}
     */ this.data = [];
    this._ctx = null;
};
/**
 * 快速计算Path包围盒（并不是最小包围盒）
 * @return {Object}
 */ $4c785e18473c2aa4$var$PathProxy.prototype = {
    constructor: $4c785e18473c2aa4$var$PathProxy,
    _xi: 0,
    _yi: 0,
    _x0: 0,
    _y0: 0,
    // Unit x, Unit y. Provide for avoiding drawing that too short line segment
    _ux: 0,
    _uy: 0,
    _len: 0,
    _lineDash: null,
    _dashOffset: 0,
    _dashIdx: 0,
    _dashSum: 0,
    /**
   * @readOnly
   */ setScale: function(sx, sy, segmentIgnoreThreshold) {
        // Compat. Previously there is no segmentIgnoreThreshold.
        segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
        this._ux = $4c785e18473c2aa4$var$mathAbs(segmentIgnoreThreshold / $4c785e18473c2aa4$var$dpr / sx) || 0;
        this._uy = $4c785e18473c2aa4$var$mathAbs(segmentIgnoreThreshold / $4c785e18473c2aa4$var$dpr / sy) || 0;
    },
    getContext: function() {
        return this._ctx;
    },
    /**
   * @param  {CanvasRenderingContext2D} ctx
   * @return {module:zrender/core/PathProxy}
   */ beginPath: function(ctx) {
        this._ctx = ctx;
        ctx && ctx.beginPath();
        ctx && (this.dpr = ctx.dpr); // Reset
        if (this._saveData) this._len = 0;
        if (this._lineDash) {
            this._lineDash = null;
            this._dashOffset = 0;
        }
        return this;
    },
    /**
   * @param  {number} x
   * @param  {number} y
   * @return {module:zrender/core/PathProxy}
   */ moveTo: function(x, y) {
        this.addData($4c785e18473c2aa4$var$CMD.M, x, y);
        this._ctx && this._ctx.moveTo(x, y); // x0, y0, xi, yi 是记录在 _dashedXXXXTo 方法中使用
        // xi, yi 记录当前点, x0, y0 在 closePath 的时候回到起始点。
        // 有可能在 beginPath 之后直接调用 lineTo，这时候 x0, y0 需要
        // 在 lineTo 方法中记录，这里先不考虑这种情况，dashed line 也只在 IE10- 中不支持
        this._x0 = x;
        this._y0 = y;
        this._xi = x;
        this._yi = y;
        return this;
    },
    /**
   * @param  {number} x
   * @param  {number} y
   * @return {module:zrender/core/PathProxy}
   */ lineTo: function(x, y) {
        var exceedUnit = $4c785e18473c2aa4$var$mathAbs(x - this._xi) > this._ux || $4c785e18473c2aa4$var$mathAbs(y - this._yi) > this._uy // Force draw the first segment
         || this._len < 5;
        this.addData($4c785e18473c2aa4$var$CMD.L, x, y);
        if (this._ctx && exceedUnit) this._needsDash() ? this._dashedLineTo(x, y) : this._ctx.lineTo(x, y);
        if (exceedUnit) {
            this._xi = x;
            this._yi = y;
        }
        return this;
    },
    /**
   * @param  {number} x1
   * @param  {number} y1
   * @param  {number} x2
   * @param  {number} y2
   * @param  {number} x3
   * @param  {number} y3
   * @return {module:zrender/core/PathProxy}
   */ bezierCurveTo: function(x1, y1, x2, y2, x3, y3) {
        this.addData($4c785e18473c2aa4$var$CMD.C, x1, y1, x2, y2, x3, y3);
        if (this._ctx) this._needsDash() ? this._dashedBezierTo(x1, y1, x2, y2, x3, y3) : this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
        this._xi = x3;
        this._yi = y3;
        return this;
    },
    /**
   * @param  {number} x1
   * @param  {number} y1
   * @param  {number} x2
   * @param  {number} y2
   * @return {module:zrender/core/PathProxy}
   */ quadraticCurveTo: function(x1, y1, x2, y2) {
        this.addData($4c785e18473c2aa4$var$CMD.Q, x1, y1, x2, y2);
        if (this._ctx) this._needsDash() ? this._dashedQuadraticTo(x1, y1, x2, y2) : this._ctx.quadraticCurveTo(x1, y1, x2, y2);
        this._xi = x2;
        this._yi = y2;
        return this;
    },
    /**
   * @param  {number} cx
   * @param  {number} cy
   * @param  {number} r
   * @param  {number} startAngle
   * @param  {number} endAngle
   * @param  {boolean} anticlockwise
   * @return {module:zrender/core/PathProxy}
   */ arc: function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this.addData($4c785e18473c2aa4$var$CMD.A, cx, cy, r, r, startAngle, endAngle - startAngle, 0, anticlockwise ? 0 : 1);
        this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
        this._xi = $4c785e18473c2aa4$var$mathCos(endAngle) * r + cx;
        this._yi = $4c785e18473c2aa4$var$mathSin(endAngle) * r + cy;
        return this;
    },
    // TODO
    arcTo: function(x1, y1, x2, y2, radius) {
        if (this._ctx) this._ctx.arcTo(x1, y1, x2, y2, radius);
        return this;
    },
    // TODO
    rect: function(x, y, w, h) {
        this._ctx && this._ctx.rect(x, y, w, h);
        this.addData($4c785e18473c2aa4$var$CMD.R, x, y, w, h);
        return this;
    },
    /**
   * @return {module:zrender/core/PathProxy}
   */ closePath: function() {
        this.addData($4c785e18473c2aa4$var$CMD.Z);
        var ctx = this._ctx;
        var x0 = this._x0;
        var y0 = this._y0;
        if (ctx) {
            this._needsDash() && this._dashedLineTo(x0, y0);
            ctx.closePath();
        }
        this._xi = x0;
        this._yi = y0;
        return this;
    },
    /**
   * Context 从外部传入，因为有可能是 rebuildPath 完之后再 fill。
   * stroke 同样
   * @param {CanvasRenderingContext2D} ctx
   * @return {module:zrender/core/PathProxy}
   */ fill: function(ctx) {
        ctx && ctx.fill();
        this.toStatic();
    },
    /**
   * @param {CanvasRenderingContext2D} ctx
   * @return {module:zrender/core/PathProxy}
   */ stroke: function(ctx) {
        ctx && ctx.stroke();
        this.toStatic();
    },
    /**
   * 必须在其它绘制命令前调用
   * Must be invoked before all other path drawing methods
   * @return {module:zrender/core/PathProxy}
   */ setLineDash: function(lineDash) {
        if (lineDash instanceof Array) {
            this._lineDash = lineDash;
            this._dashIdx = 0;
            var lineDashSum = 0;
            for(var i = 0; i < lineDash.length; i++)lineDashSum += lineDash[i];
            this._dashSum = lineDashSum;
        }
        return this;
    },
    /**
   * 必须在其它绘制命令前调用
   * Must be invoked before all other path drawing methods
   * @return {module:zrender/core/PathProxy}
   */ setLineDashOffset: function(offset) {
        this._dashOffset = offset;
        return this;
    },
    /**
   *
   * @return {boolean}
   */ len: function() {
        return this._len;
    },
    /**
   * 直接设置 Path 数据
   */ setData: function(data) {
        var len = data.length;
        if (!(this.data && this.data.length === len) && $4c785e18473c2aa4$var$hasTypedArray) this.data = new Float32Array(len);
        for(var i = 0; i < len; i++)this.data[i] = data[i];
        this._len = len;
    },
    /**
   * 添加子路径
   * @param {module:zrender/core/PathProxy|Array.<module:zrender/core/PathProxy>} path
   */ appendPath: function(path) {
        if (!(path instanceof Array)) path = [
            path
        ];
        var len = path.length;
        var appendSize = 0;
        var offset = this._len;
        for(var i = 0; i < len; i++)appendSize += path[i].len();
        if ($4c785e18473c2aa4$var$hasTypedArray && this.data instanceof Float32Array) this.data = new Float32Array(offset + appendSize);
        for(var i = 0; i < len; i++){
            var appendPathData = path[i].data;
            for(var k = 0; k < appendPathData.length; k++)this.data[offset++] = appendPathData[k];
        }
        this._len = offset;
    },
    /**
   * 填充 Path 数据。
   * 尽量复用而不申明新的数组。大部分图形重绘的指令数据长度都是不变的。
   */ addData: function(cmd) {
        if (!this._saveData) return;
        var data = this.data;
        if (this._len + arguments.length > data.length) {
            // 因为之前的数组已经转换成静态的 Float32Array
            // 所以不够用时需要扩展一个新的动态数组
            this._expandData();
            data = this.data;
        }
        for(var i = 0; i < arguments.length; i++)data[this._len++] = arguments[i];
        this._prevCmd = cmd;
    },
    _expandData: function() {
        // Only if data is Float32Array
        if (!(this.data instanceof Array)) {
            var newData = [];
            for(var i = 0; i < this._len; i++)newData[i] = this.data[i];
            this.data = newData;
        }
    },
    /**
   * If needs js implemented dashed line
   * @return {boolean}
   * @private
   */ _needsDash: function() {
        return this._lineDash;
    },
    _dashedLineTo: function(x1, y1) {
        var dashSum = this._dashSum;
        var offset = this._dashOffset;
        var lineDash = this._lineDash;
        var ctx = this._ctx;
        var x0 = this._xi;
        var y0 = this._yi;
        var dx = x1 - x0;
        var dy = y1 - y0;
        var dist = $4c785e18473c2aa4$var$mathSqrt(dx * dx + dy * dy);
        var x = x0;
        var y = y0;
        var dash;
        var nDash = lineDash.length;
        var idx;
        dx /= dist;
        dy /= dist;
        if (offset < 0) // Convert to positive offset
        offset = dashSum + offset;
        offset %= dashSum;
        x -= offset * dx;
        y -= offset * dy;
        while(dx > 0 && x <= x1 || dx < 0 && x >= x1 || dx === 0 && (dy > 0 && y <= y1 || dy < 0 && y >= y1)){
            idx = this._dashIdx;
            dash = lineDash[idx];
            x += dx * dash;
            y += dy * dash;
            this._dashIdx = (idx + 1) % nDash; // Skip positive offset
            if (dx > 0 && x < x0 || dx < 0 && x > x0 || dy > 0 && y < y0 || dy < 0 && y > y0) continue;
            ctx[idx % 2 ? "moveTo" : "lineTo"](dx >= 0 ? $4c785e18473c2aa4$var$mathMin(x, x1) : $4c785e18473c2aa4$var$mathMax(x, x1), dy >= 0 ? $4c785e18473c2aa4$var$mathMin(y, y1) : $4c785e18473c2aa4$var$mathMax(y, y1));
        } // Offset for next lineTo
        dx = x - x1;
        dy = y - y1;
        this._dashOffset = -$4c785e18473c2aa4$var$mathSqrt(dx * dx + dy * dy);
    },
    // Not accurate dashed line to
    _dashedBezierTo: function(x1, y1, x2, y2, x3, y3) {
        var dashSum = this._dashSum;
        var offset = this._dashOffset;
        var lineDash = this._lineDash;
        var ctx = this._ctx;
        var x0 = this._xi;
        var y0 = this._yi;
        var t;
        var dx;
        var dy;
        var cubicAt = $ab3ad2315df1d857$export$547c21de482bbcb2;
        var bezierLen = 0;
        var idx = this._dashIdx;
        var nDash = lineDash.length;
        var x;
        var y;
        var tmpLen = 0;
        if (offset < 0) // Convert to positive offset
        offset = dashSum + offset;
        offset %= dashSum; // Bezier approx length
        for(t = 0; t < 1; t += 0.1){
            dx = cubicAt(x0, x1, x2, x3, t + 0.1) - cubicAt(x0, x1, x2, x3, t);
            dy = cubicAt(y0, y1, y2, y3, t + 0.1) - cubicAt(y0, y1, y2, y3, t);
            bezierLen += $4c785e18473c2aa4$var$mathSqrt(dx * dx + dy * dy);
        } // Find idx after add offset
        for(; idx < nDash; idx++){
            tmpLen += lineDash[idx];
            if (tmpLen > offset) break;
        }
        t = (tmpLen - offset) / bezierLen;
        while(t <= 1){
            x = cubicAt(x0, x1, x2, x3, t);
            y = cubicAt(y0, y1, y2, y3, t); // Use line to approximate dashed bezier
            // Bad result if dash is long
            idx % 2 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
            t += lineDash[idx] / bezierLen;
            idx = (idx + 1) % nDash;
        } // Finish the last segment and calculate the new offset
        idx % 2 !== 0 && ctx.lineTo(x3, y3);
        dx = x3 - x;
        dy = y3 - y;
        this._dashOffset = -$4c785e18473c2aa4$var$mathSqrt(dx * dx + dy * dy);
    },
    _dashedQuadraticTo: function(x1, y1, x2, y2) {
        // Convert quadratic to cubic using degree elevation
        var x3 = x2;
        var y3 = y2;
        x2 = (x2 + 2 * x1) / 3;
        y2 = (y2 + 2 * y1) / 3;
        x1 = (this._xi + 2 * x1) / 3;
        y1 = (this._yi + 2 * y1) / 3;
        this._dashedBezierTo(x1, y1, x2, y2, x3, y3);
    },
    /**
   * 转成静态的 Float32Array 减少堆内存占用
   * Convert dynamic array to static Float32Array
   */ toStatic: function() {
        var data = this.data;
        if (data instanceof Array) {
            data.length = this._len;
            if ($4c785e18473c2aa4$var$hasTypedArray) this.data = new Float32Array(data);
        }
    },
    /**
   * @return {module:zrender/core/BoundingRect}
   */ getBoundingRect: function() {
        $4c785e18473c2aa4$var$min[0] = $4c785e18473c2aa4$var$min[1] = $4c785e18473c2aa4$var$min2[0] = $4c785e18473c2aa4$var$min2[1] = Number.MAX_VALUE;
        $4c785e18473c2aa4$var$max[0] = $4c785e18473c2aa4$var$max[1] = $4c785e18473c2aa4$var$max2[0] = $4c785e18473c2aa4$var$max2[1] = -Number.MAX_VALUE;
        var data = this.data;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        for(var i = 0; i < data.length;){
            var cmd = data[i++];
            if (i === 1) {
                // 如果第一个命令是 L, C, Q
                // 则 previous point 同绘制命令的第一个 point
                //
                // 第一个命令为 Arc 的情况下会在后面特殊处理
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch(cmd){
                case $4c785e18473c2aa4$var$CMD.M:
                    // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
                    // 在 closePath 的时候使用
                    x0 = data[i++];
                    y0 = data[i++];
                    xi = x0;
                    yi = y0;
                    $4c785e18473c2aa4$var$min2[0] = x0;
                    $4c785e18473c2aa4$var$min2[1] = y0;
                    $4c785e18473c2aa4$var$max2[0] = x0;
                    $4c785e18473c2aa4$var$max2[1] = y0;
                    break;
                case $4c785e18473c2aa4$var$CMD.L:
                    $22231ac051eb7cf7$export$d2b1491e4450bf2c(xi, yi, data[i], data[i + 1], $4c785e18473c2aa4$var$min2, $4c785e18473c2aa4$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $4c785e18473c2aa4$var$CMD.C:
                    $22231ac051eb7cf7$export$c1bc6be456bb6609(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], $4c785e18473c2aa4$var$min2, $4c785e18473c2aa4$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $4c785e18473c2aa4$var$CMD.Q:
                    $22231ac051eb7cf7$export$16fbe795323a1f4c(xi, yi, data[i++], data[i++], data[i], data[i + 1], $4c785e18473c2aa4$var$min2, $4c785e18473c2aa4$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $4c785e18473c2aa4$var$CMD.A:
                    // TODO Arc 判断的开销比较大
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var endAngle = data[i++] + startAngle; // TODO Arc 旋转
                    i += 1;
                    var anticlockwise = 1 - data[i++];
                    if (i === 1) {
                        // 直接使用 arc 命令
                        // 第一个命令起点还未定义
                        x0 = $4c785e18473c2aa4$var$mathCos(startAngle) * rx + cx;
                        y0 = $4c785e18473c2aa4$var$mathSin(startAngle) * ry + cy;
                    }
                    $22231ac051eb7cf7$export$161c8bb0e1d9ef49(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, $4c785e18473c2aa4$var$min2, $4c785e18473c2aa4$var$max2);
                    xi = $4c785e18473c2aa4$var$mathCos(endAngle) * rx + cx;
                    yi = $4c785e18473c2aa4$var$mathSin(endAngle) * ry + cy;
                    break;
                case $4c785e18473c2aa4$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++]; // Use fromLine
                    $22231ac051eb7cf7$export$d2b1491e4450bf2c(x0, y0, x0 + width, y0 + height, $4c785e18473c2aa4$var$min2, $4c785e18473c2aa4$var$max2);
                    break;
                case $4c785e18473c2aa4$var$CMD.Z:
                    xi = x0;
                    yi = y0;
                    break;
            } // Union
            $9eb63d101f3bcd79$export$96ec731ed4dcb222($4c785e18473c2aa4$var$min, $4c785e18473c2aa4$var$min, $4c785e18473c2aa4$var$min2);
            $9eb63d101f3bcd79$export$8960430cfd85939f($4c785e18473c2aa4$var$max, $4c785e18473c2aa4$var$max, $4c785e18473c2aa4$var$max2);
        } // No data
        if (i === 0) $4c785e18473c2aa4$var$min[0] = $4c785e18473c2aa4$var$min[1] = $4c785e18473c2aa4$var$max[0] = $4c785e18473c2aa4$var$max[1] = 0;
        return new $33e4fae744d34798$exports($4c785e18473c2aa4$var$min[0], $4c785e18473c2aa4$var$min[1], $4c785e18473c2aa4$var$max[0] - $4c785e18473c2aa4$var$min[0], $4c785e18473c2aa4$var$max[1] - $4c785e18473c2aa4$var$min[1]);
    },
    /**
   * Rebuild path from current data
   * Rebuild path will not consider javascript implemented line dash.
   * @param {CanvasRenderingContext2D} ctx
   */ rebuildPath: function(ctx) {
        var d = this.data;
        var x0;
        var y0;
        var xi;
        var yi;
        var x;
        var y;
        var ux = this._ux;
        var uy = this._uy;
        var len = this._len;
        for(var i = 0; i < len;){
            var cmd = d[i++];
            if (i === 1) {
                // 如果第一个命令是 L, C, Q
                // 则 previous point 同绘制命令的第一个 point
                //
                // 第一个命令为 Arc 的情况下会在后面特殊处理
                xi = d[i];
                yi = d[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch(cmd){
                case $4c785e18473c2aa4$var$CMD.M:
                    x0 = xi = d[i++];
                    y0 = yi = d[i++];
                    ctx.moveTo(xi, yi);
                    break;
                case $4c785e18473c2aa4$var$CMD.L:
                    x = d[i++];
                    y = d[i++]; // Not draw too small seg between
                    if ($4c785e18473c2aa4$var$mathAbs(x - xi) > ux || $4c785e18473c2aa4$var$mathAbs(y - yi) > uy || i === len - 1) {
                        ctx.lineTo(x, y);
                        xi = x;
                        yi = y;
                    }
                    break;
                case $4c785e18473c2aa4$var$CMD.C:
                    ctx.bezierCurveTo(d[i++], d[i++], d[i++], d[i++], d[i++], d[i++]);
                    xi = d[i - 2];
                    yi = d[i - 1];
                    break;
                case $4c785e18473c2aa4$var$CMD.Q:
                    ctx.quadraticCurveTo(d[i++], d[i++], d[i++], d[i++]);
                    xi = d[i - 2];
                    yi = d[i - 1];
                    break;
                case $4c785e18473c2aa4$var$CMD.A:
                    var cx = d[i++];
                    var cy = d[i++];
                    var rx = d[i++];
                    var ry = d[i++];
                    var theta = d[i++];
                    var dTheta = d[i++];
                    var psi = d[i++];
                    var fs = d[i++];
                    var r = rx > ry ? rx : ry;
                    var scaleX = rx > ry ? 1 : rx / ry;
                    var scaleY = rx > ry ? ry / rx : 1;
                    var isEllipse = Math.abs(rx - ry) > 1e-3;
                    var endAngle = theta + dTheta;
                    if (isEllipse) {
                        ctx.translate(cx, cy);
                        ctx.rotate(psi);
                        ctx.scale(scaleX, scaleY);
                        ctx.arc(0, 0, r, theta, endAngle, 1 - fs);
                        ctx.scale(1 / scaleX, 1 / scaleY);
                        ctx.rotate(-psi);
                        ctx.translate(-cx, -cy);
                    } else ctx.arc(cx, cy, r, theta, endAngle, 1 - fs);
                    if (i === 1) {
                        // 直接使用 arc 命令
                        // 第一个命令起点还未定义
                        x0 = $4c785e18473c2aa4$var$mathCos(theta) * rx + cx;
                        y0 = $4c785e18473c2aa4$var$mathSin(theta) * ry + cy;
                    }
                    xi = $4c785e18473c2aa4$var$mathCos(endAngle) * rx + cx;
                    yi = $4c785e18473c2aa4$var$mathSin(endAngle) * ry + cy;
                    break;
                case $4c785e18473c2aa4$var$CMD.R:
                    x0 = xi = d[i];
                    y0 = yi = d[i + 1];
                    ctx.rect(d[i++], d[i++], d[i++], d[i++]);
                    break;
                case $4c785e18473c2aa4$var$CMD.Z:
                    ctx.closePath();
                    xi = x0;
                    yi = y0;
            }
        }
    }
};
$4c785e18473c2aa4$var$PathProxy.CMD = $4c785e18473c2aa4$var$CMD;
var $4c785e18473c2aa4$var$_default = $4c785e18473c2aa4$var$PathProxy;
$4c785e18473c2aa4$exports = $4c785e18473c2aa4$var$_default;


var $c1c053f32e111a81$export$8893e2b90ba10d92;
var $c1c053f32e111a81$export$8d36b1b5d19157c5;

/**
 * 线段包含判断
 * @param  {number}  x0
 * @param  {number}  y0
 * @param  {number}  x1
 * @param  {number}  y1
 * @param  {number}  lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {boolean}
 */ var $d76a7bd0bb84dce0$export$8d36b1b5d19157c5;
function $d76a7bd0bb84dce0$var$containStroke(x0, y0, x1, y1, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    var _a = 0;
    var _b = x0; // Quick reject
    if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) return false;
    if (x0 !== x1) {
        _a = (y0 - y1) / (x0 - x1);
        _b = (x0 * y1 - x1 * y0) / (x0 - x1);
    } else return Math.abs(x - x0) <= _l / 2;
    var tmp = _a * x - y + _b;
    var _s = tmp * tmp / (_a * _a + 1);
    return _s <= _l / 2 * _l / 2;
}
$d76a7bd0bb84dce0$export$8d36b1b5d19157c5 = $d76a7bd0bb84dce0$var$containStroke;


var $6938aa750c3a9e9c$export$8d36b1b5d19157c5;

/**
 * 三次贝塞尔曲线描边包含判断
 * @param  {number}  x0
 * @param  {number}  y0
 * @param  {number}  x1
 * @param  {number}  y1
 * @param  {number}  x2
 * @param  {number}  y2
 * @param  {number}  x3
 * @param  {number}  y3
 * @param  {number}  lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {boolean}
 */ function $6938aa750c3a9e9c$var$containStroke(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth; // Quick reject
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) return false;
    var d = $ab3ad2315df1d857$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
    return d <= _l / 2;
}
$6938aa750c3a9e9c$export$8d36b1b5d19157c5 = $6938aa750c3a9e9c$var$containStroke;


var $f75c89e8641a5e0c$export$8d36b1b5d19157c5;

var $f75c89e8641a5e0c$var$quadraticProjectPoint = $ab3ad2315df1d857$export$81915a594fe10dee;
/**
 * 二次贝塞尔曲线描边包含判断
 * @param  {number}  x0
 * @param  {number}  y0
 * @param  {number}  x1
 * @param  {number}  y1
 * @param  {number}  x2
 * @param  {number}  y2
 * @param  {number}  lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {boolean}
 */ function $f75c89e8641a5e0c$var$containStroke(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth; // Quick reject
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) return false;
    var d = $f75c89e8641a5e0c$var$quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, null);
    return d <= _l / 2;
}
$f75c89e8641a5e0c$export$8d36b1b5d19157c5 = $f75c89e8641a5e0c$var$containStroke;


var $8042d49c140298ec$export$8d36b1b5d19157c5;
var $af0127aedd7b60f5$export$d44861331f213635;
var $af0127aedd7b60f5$var$PI2 = Math.PI * 2;
function $af0127aedd7b60f5$var$normalizeRadian(angle) {
    angle %= $af0127aedd7b60f5$var$PI2;
    if (angle < 0) angle += $af0127aedd7b60f5$var$PI2;
    return angle;
}
$af0127aedd7b60f5$export$d44861331f213635 = $af0127aedd7b60f5$var$normalizeRadian;


var $8042d49c140298ec$var$normalizeRadian = $af0127aedd7b60f5$export$d44861331f213635;
var $8042d49c140298ec$var$PI2 = Math.PI * 2;
/**
 * 圆弧描边包含判断
 * @param  {number}  cx
 * @param  {number}  cy
 * @param  {number}  r
 * @param  {number}  startAngle
 * @param  {number}  endAngle
 * @param  {boolean}  anticlockwise
 * @param  {number} lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {Boolean}
 */ function $8042d49c140298ec$var$containStroke(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    if (d - _l > r || d + _l < r) return false;
    if (Math.abs(startAngle - endAngle) % $8042d49c140298ec$var$PI2 < 1e-4) // Is a circle
    return true;
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = $8042d49c140298ec$var$normalizeRadian(endAngle);
        endAngle = $8042d49c140298ec$var$normalizeRadian(tmp);
    } else {
        startAngle = $8042d49c140298ec$var$normalizeRadian(startAngle);
        endAngle = $8042d49c140298ec$var$normalizeRadian(endAngle);
    }
    if (startAngle > endAngle) endAngle += $8042d49c140298ec$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $8042d49c140298ec$var$PI2;
    return angle >= startAngle && angle <= endAngle || angle + $8042d49c140298ec$var$PI2 >= startAngle && angle + $8042d49c140298ec$var$PI2 <= endAngle;
}
$8042d49c140298ec$export$8d36b1b5d19157c5 = $8042d49c140298ec$var$containStroke;



var $c1c053f32e111a81$var$normalizeRadian = $af0127aedd7b60f5$export$d44861331f213635;

var $94d785909998a63b$exports = {};
function $94d785909998a63b$var$windingLine(x0, y0, x1, y1, x, y) {
    if (y > y0 && y > y1 || y < y0 && y < y1) return 0;
     // Ignore horizontal line
    if (y1 === y0) return 0;
    var dir = y1 < y0 ? 1 : -1;
    var t = (y - y0) / (y1 - y0); // Avoid winding error when intersection point is the connect point of two line of polygon
    if (t === 1 || t === 0) dir = y1 < y0 ? 0.5 : -0.5;
    var x_ = t * (x1 - x0) + x0; // If (x, y) on the line, considered as "contain".
    return x_ === x ? Infinity : x_ > x ? dir : 0;
}
$94d785909998a63b$exports = $94d785909998a63b$var$windingLine;


var $c1c053f32e111a81$var$CMD = $4c785e18473c2aa4$exports.CMD;
var $c1c053f32e111a81$var$PI2 = Math.PI * 2;
var $c1c053f32e111a81$var$EPSILON = 1e-4;
function $c1c053f32e111a81$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $c1c053f32e111a81$var$EPSILON;
} // 临时数组
var $c1c053f32e111a81$var$roots = [
    -1,
    -1,
    -1
];
var $c1c053f32e111a81$var$extrema = [
    -1,
    -1
];
function $c1c053f32e111a81$var$swapExtrema() {
    var tmp = $c1c053f32e111a81$var$extrema[0];
    $c1c053f32e111a81$var$extrema[0] = $c1c053f32e111a81$var$extrema[1];
    $c1c053f32e111a81$var$extrema[1] = tmp;
}
function $c1c053f32e111a81$var$windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
    // Quick reject
    if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) return 0;
    var nRoots = $ab3ad2315df1d857$export$ca5d13faa10b167e(y0, y1, y2, y3, y, $c1c053f32e111a81$var$roots);
    if (nRoots === 0) return 0;
    else {
        var w = 0;
        var nExtrema = -1;
        var y0_;
        var y1_;
        for(var i = 0; i < nRoots; i++){
            var t = $c1c053f32e111a81$var$roots[i]; // Avoid winding error when intersection point is the connect point of two line of polygon
            var unit = t === 0 || t === 1 ? 0.5 : 1;
            var x_ = $ab3ad2315df1d857$export$547c21de482bbcb2(x0, x1, x2, x3, t);
            if (x_ < x) continue;
            if (nExtrema < 0) {
                nExtrema = $ab3ad2315df1d857$export$df1a172f100d0457(y0, y1, y2, y3, $c1c053f32e111a81$var$extrema);
                if ($c1c053f32e111a81$var$extrema[1] < $c1c053f32e111a81$var$extrema[0] && nExtrema > 1) $c1c053f32e111a81$var$swapExtrema();
                y0_ = $ab3ad2315df1d857$export$547c21de482bbcb2(y0, y1, y2, y3, $c1c053f32e111a81$var$extrema[0]);
                if (nExtrema > 1) y1_ = $ab3ad2315df1d857$export$547c21de482bbcb2(y0, y1, y2, y3, $c1c053f32e111a81$var$extrema[1]);
            }
            if (nExtrema === 2) {
                // 分成三段单调函数
                if (t < $c1c053f32e111a81$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                else if (t < $c1c053f32e111a81$var$extrema[1]) w += y1_ < y0_ ? unit : -unit;
                else w += y3 < y1_ ? unit : -unit;
            } else // 分成两段单调函数
            if (t < $c1c053f32e111a81$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
            else w += y3 < y0_ ? unit : -unit;
        }
        return w;
    }
}
function $c1c053f32e111a81$var$windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
    // Quick reject
    if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) return 0;
    var nRoots = $ab3ad2315df1d857$export$fd895ac7ee764967(y0, y1, y2, y, $c1c053f32e111a81$var$roots);
    if (nRoots === 0) return 0;
    else {
        var t = $ab3ad2315df1d857$export$752e1f8c6e7f7e11(y0, y1, y2);
        if (t >= 0 && t <= 1) {
            var w = 0;
            var y_ = $ab3ad2315df1d857$export$af17094a950f5073(y0, y1, y2, t);
            for(var i = 0; i < nRoots; i++){
                // Remove one endpoint.
                var unit = $c1c053f32e111a81$var$roots[i] === 0 || $c1c053f32e111a81$var$roots[i] === 1 ? 0.5 : 1;
                var x_ = $ab3ad2315df1d857$export$af17094a950f5073(x0, x1, x2, $c1c053f32e111a81$var$roots[i]);
                if (x_ < x) continue;
                if ($c1c053f32e111a81$var$roots[i] < t) w += y_ < y0 ? unit : -unit;
                else w += y2 < y_ ? unit : -unit;
            }
            return w;
        } else {
            // Remove one endpoint.
            var unit = $c1c053f32e111a81$var$roots[0] === 0 || $c1c053f32e111a81$var$roots[0] === 1 ? 0.5 : 1;
            var x_ = $ab3ad2315df1d857$export$af17094a950f5073(x0, x1, x2, $c1c053f32e111a81$var$roots[0]);
            if (x_ < x) // Quick reject
            return 0;
            return y2 < y0 ? unit : -unit;
        }
    }
} // TODO
// Arc 旋转
function $c1c053f32e111a81$var$windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
    y -= cy;
    if (y > r || y < -r) return 0;
    var tmp = Math.sqrt(r * r - y * y);
    $c1c053f32e111a81$var$roots[0] = -tmp;
    $c1c053f32e111a81$var$roots[1] = tmp;
    var diff = Math.abs(startAngle - endAngle);
    if (diff < 1e-4) return 0;
    if (diff % $c1c053f32e111a81$var$PI2 < 1e-4) {
        // Is a circle
        startAngle = 0;
        endAngle = $c1c053f32e111a81$var$PI2;
        var dir = anticlockwise ? 1 : -1;
        if (x >= $c1c053f32e111a81$var$roots[0] + cx && x <= $c1c053f32e111a81$var$roots[1] + cx) return dir;
        else return 0;
    }
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = $c1c053f32e111a81$var$normalizeRadian(endAngle);
        endAngle = $c1c053f32e111a81$var$normalizeRadian(tmp);
    } else {
        startAngle = $c1c053f32e111a81$var$normalizeRadian(startAngle);
        endAngle = $c1c053f32e111a81$var$normalizeRadian(endAngle);
    }
    if (startAngle > endAngle) endAngle += $c1c053f32e111a81$var$PI2;
    var w = 0;
    for(var i = 0; i < 2; i++){
        var x_ = $c1c053f32e111a81$var$roots[i];
        if (x_ + cx > x) {
            var angle = Math.atan2(y, x_);
            var dir = anticlockwise ? 1 : -1;
            if (angle < 0) angle = $c1c053f32e111a81$var$PI2 + angle;
            if (angle >= startAngle && angle <= endAngle || angle + $c1c053f32e111a81$var$PI2 >= startAngle && angle + $c1c053f32e111a81$var$PI2 <= endAngle) {
                if (angle > Math.PI / 2 && angle < Math.PI * 1.5) dir = -dir;
                w += dir;
            }
        }
    }
    return w;
}
function $c1c053f32e111a81$var$containPath(data, lineWidth, isStroke, x, y) {
    var w = 0;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    for(var i = 0; i < data.length;){
        var cmd = data[i++]; // Begin a new subpath
        if (cmd === $c1c053f32e111a81$var$CMD.M && i > 1) // Close previous subpath
        {
            if (!isStroke) w += $94d785909998a63b$exports(xi, yi, x0, y0, x, y);
             // 如果被任何一个 subpath 包含
        }
        if (i === 1) {
            // 如果第一个命令是 L, C, Q
            // 则 previous point 同绘制命令的第一个 point
            //
            // 第一个命令为 Arc 的情况下会在后面特殊处理
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        switch(cmd){
            case $c1c053f32e111a81$var$CMD.M:
                // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
                // 在 closePath 的时候使用
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $c1c053f32e111a81$var$CMD.L:
                if (isStroke) {
                    if ($d76a7bd0bb84dce0$export$8d36b1b5d19157c5(xi, yi, data[i], data[i + 1], lineWidth, x, y)) return true;
                } else // NOTE 在第一个命令为 L, C, Q 的时候会计算出 NaN
                w += $94d785909998a63b$exports(xi, yi, data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $c1c053f32e111a81$var$CMD.C:
                if (isStroke) {
                    if ($6938aa750c3a9e9c$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $c1c053f32e111a81$var$windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $c1c053f32e111a81$var$CMD.Q:
                if (isStroke) {
                    if ($f75c89e8641a5e0c$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $c1c053f32e111a81$var$windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $c1c053f32e111a81$var$CMD.A:
                // TODO Arc 判断的开销比较大
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++]; // TODO Arc 旋转
                i += 1;
                var anticlockwise = 1 - data[i++];
                var x1 = Math.cos(theta) * rx + cx;
                var y1 = Math.sin(theta) * ry + cy; // 不是直接使用 arc 命令
                if (i > 1) w += $94d785909998a63b$exports(xi, yi, x1, y1, x, y);
                else {
                    // 第一个命令起点还未定义
                    x0 = x1;
                    y0 = y1;
                } // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
                var _x = (x - cx) * ry / rx + cx;
                if (isStroke) {
                    if ($8042d49c140298ec$export$8d36b1b5d19157c5(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) return true;
                } else w += $c1c053f32e111a81$var$windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $c1c053f32e111a81$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                var x1 = x0 + width;
                var y1 = y0 + height;
                if (isStroke) {
                    if ($d76a7bd0bb84dce0$export$8d36b1b5d19157c5(x0, y0, x1, y0, lineWidth, x, y) || $d76a7bd0bb84dce0$export$8d36b1b5d19157c5(x1, y0, x1, y1, lineWidth, x, y) || $d76a7bd0bb84dce0$export$8d36b1b5d19157c5(x1, y1, x0, y1, lineWidth, x, y) || $d76a7bd0bb84dce0$export$8d36b1b5d19157c5(x0, y1, x0, y0, lineWidth, x, y)) return true;
                } else {
                    // FIXME Clockwise ?
                    w += $94d785909998a63b$exports(x1, y0, x1, y1, x, y);
                    w += $94d785909998a63b$exports(x0, y1, x0, y0, x, y);
                }
                break;
            case $c1c053f32e111a81$var$CMD.Z:
                if (isStroke) {
                    if ($d76a7bd0bb84dce0$export$8d36b1b5d19157c5(xi, yi, x0, y0, lineWidth, x, y)) return true;
                } else // Close a subpath
                w += $94d785909998a63b$exports(xi, yi, x0, y0, x, y); // 如果被任何一个 subpath 包含
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (!isStroke && !$c1c053f32e111a81$var$isAroundEqual(yi, y0)) w += $94d785909998a63b$exports(xi, yi, x0, y0, x, y) || 0;
    return w !== 0;
}
function $c1c053f32e111a81$var$contain(pathData, x, y) {
    return $c1c053f32e111a81$var$containPath(pathData, 0, false, x, y);
}
function $c1c053f32e111a81$var$containStroke(pathData, lineWidth, x, y) {
    return $c1c053f32e111a81$var$containPath(pathData, lineWidth, true, x, y);
}
$c1c053f32e111a81$export$8893e2b90ba10d92 = $c1c053f32e111a81$var$contain;
$c1c053f32e111a81$export$8d36b1b5d19157c5 = $c1c053f32e111a81$var$containStroke;



var $b9701a0f23f767de$var$getCanvasPattern = $db49346795b4d95d$exports.prototype.getCanvasPattern;
var $b9701a0f23f767de$var$abs = Math.abs;
var $b9701a0f23f767de$var$pathProxyForDraw = new $4c785e18473c2aa4$exports(true);
/**
 * @alias module:zrender/graphic/Path
 * @extends module:zrender/graphic/Displayable
 * @constructor
 * @param {Object} opts
 */ function $b9701a0f23f767de$var$Path(opts) {
    $f95b0c44904a541d$exports.call(this, opts);
    /**
   * @type {module:zrender/core/PathProxy}
   * @readOnly
   */ this.path = null;
}
$b9701a0f23f767de$var$Path.prototype = {
    constructor: $b9701a0f23f767de$var$Path,
    type: "path",
    __dirtyPath: true,
    strokeContainThreshold: 5,
    // This item default to be false. But in map series in echarts,
    // in order to improve performance, it should be set to true,
    // so the shorty segment won't draw.
    segmentIgnoreThreshold: 0,
    /**
   * See `module:zrender/src/graphic/helper/subPixelOptimize`.
   * @type {boolean}
   */ subPixelOptimize: false,
    brush: function(ctx, prevEl) {
        var style = this.style;
        var path = this.path || $b9701a0f23f767de$var$pathProxyForDraw;
        var hasStroke = style.hasStroke();
        var hasFill = style.hasFill();
        var fill = style.fill;
        var stroke = style.stroke;
        var hasFillGradient = hasFill && !!fill.colorStops;
        var hasStrokeGradient = hasStroke && !!stroke.colorStops;
        var hasFillPattern = hasFill && !!fill.image;
        var hasStrokePattern = hasStroke && !!stroke.image;
        style.bind(ctx, this, prevEl);
        this.setTransform(ctx);
        if (this.__dirty) {
            var rect; // Update gradient because bounding rect may changed
            if (hasFillGradient) {
                rect = rect || this.getBoundingRect();
                this._fillGradient = style.getGradient(ctx, fill, rect);
            }
            if (hasStrokeGradient) {
                rect = rect || this.getBoundingRect();
                this._strokeGradient = style.getGradient(ctx, stroke, rect);
            }
        } // Use the gradient or pattern
        if (hasFillGradient) // PENDING If may have affect the state
        ctx.fillStyle = this._fillGradient;
        else if (hasFillPattern) ctx.fillStyle = $b9701a0f23f767de$var$getCanvasPattern.call(fill, ctx);
        if (hasStrokeGradient) ctx.strokeStyle = this._strokeGradient;
        else if (hasStrokePattern) ctx.strokeStyle = $b9701a0f23f767de$var$getCanvasPattern.call(stroke, ctx);
        var lineDash = style.lineDash;
        var lineDashOffset = style.lineDashOffset;
        var ctxLineDash = !!ctx.setLineDash; // Update path sx, sy
        var scale = this.getGlobalScale();
        path.setScale(scale[0], scale[1], this.segmentIgnoreThreshold); // Proxy context
        // Rebuild path in following 2 cases
        // 1. Path is dirty
        // 2. Path needs javascript implemented lineDash stroking.
        //    In this case, lineDash information will not be saved in PathProxy
        if (this.__dirtyPath || lineDash && !ctxLineDash && hasStroke) {
            path.beginPath(ctx); // Setting line dash before build path
            if (lineDash && !ctxLineDash) {
                path.setLineDash(lineDash);
                path.setLineDashOffset(lineDashOffset);
            }
            this.buildPath(path, this.shape, false); // Clear path dirty flag
            if (this.path) this.__dirtyPath = false;
        } else {
            // Replay path building
            ctx.beginPath();
            this.path.rebuildPath(ctx);
        }
        if (hasFill) {
            if (style.fillOpacity != null) {
                var originalGlobalAlpha = ctx.globalAlpha;
                ctx.globalAlpha = style.fillOpacity * style.opacity;
                path.fill(ctx);
                ctx.globalAlpha = originalGlobalAlpha;
            } else path.fill(ctx);
        }
        if (lineDash && ctxLineDash) {
            ctx.setLineDash(lineDash);
            ctx.lineDashOffset = lineDashOffset;
        }
        if (hasStroke) {
            if (style.strokeOpacity != null) {
                var originalGlobalAlpha = ctx.globalAlpha;
                ctx.globalAlpha = style.strokeOpacity * style.opacity;
                path.stroke(ctx);
                ctx.globalAlpha = originalGlobalAlpha;
            } else path.stroke(ctx);
        }
        if (lineDash && ctxLineDash) // PENDING
        // Remove lineDash
        ctx.setLineDash([]);
         // Draw rect text
        if (style.text != null) {
            // Only restore transform when needs draw text.
            this.restoreTransform(ctx);
            this.drawRectText(ctx, this.getBoundingRect());
        }
    },
    // When bundling path, some shape may decide if use moveTo to begin a new subpath or closePath
    // Like in circle
    buildPath: function(ctx, shapeCfg, inBundle) {},
    createPathProxy: function() {
        this.path = new $4c785e18473c2aa4$exports();
    },
    getBoundingRect: function() {
        var rect = this._rect;
        var style = this.style;
        var needsUpdateRect = !rect;
        if (needsUpdateRect) {
            var path = this.path;
            if (!path) // Create path on demand.
            path = this.path = new $4c785e18473c2aa4$exports();
            if (this.__dirtyPath) {
                path.beginPath();
                this.buildPath(path, this.shape, false);
            }
            rect = path.getBoundingRect();
        }
        this._rect = rect;
        if (style.hasStroke()) {
            // Needs update rect with stroke lineWidth when
            // 1. Element changes scale or lineWidth
            // 2. Shape is changed
            var rectWithStroke = this._rectWithStroke || (this._rectWithStroke = rect.clone());
            if (this.__dirty || needsUpdateRect) {
                rectWithStroke.copy(rect); // FIXME Must after updateTransform
                var w = style.lineWidth; // PENDING, Min line width is needed when line is horizontal or vertical
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Only add extra hover lineWidth when there are no fill
                if (!style.hasFill()) w = Math.max(w, this.strokeContainThreshold || 4);
                 // Consider line width
                // Line scale can't be 0;
                if (lineScale > 1e-10) {
                    rectWithStroke.width += w / lineScale;
                    rectWithStroke.height += w / lineScale;
                    rectWithStroke.x -= w / lineScale / 2;
                    rectWithStroke.y -= w / lineScale / 2;
                }
            } // Return rect with stroke
            return rectWithStroke;
        }
        return rect;
    },
    contain: function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        var style = this.style;
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            var pathData = this.path.data;
            if (style.hasStroke()) {
                var lineWidth = style.lineWidth;
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Line scale can't be 0;
                if (lineScale > 1e-10) {
                    // Only add extra hover lineWidth when there are no fill
                    if (!style.hasFill()) lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                    if ($c1c053f32e111a81$export$8d36b1b5d19157c5(pathData, lineWidth / lineScale, x, y)) return true;
                }
            }
            if (style.hasFill()) return $c1c053f32e111a81$export$8893e2b90ba10d92(pathData, x, y);
        }
        return false;
    },
    /**
   * @param  {boolean} dirtyPath
   */ dirty: function(dirtyPath) {
        if (dirtyPath == null) dirtyPath = true;
         // Only mark dirty, not mark clean
        if (dirtyPath) {
            this.__dirtyPath = dirtyPath;
            this._rect = null;
        }
        this.__dirty = this.__dirtyText = true;
        this.__zr && this.__zr.refresh(); // Used as a clipping path
        if (this.__clipTarget) this.__clipTarget.dirty();
    },
    /**
   * Alias for animate('shape')
   * @param {boolean} loop
   */ animateShape: function(loop) {
        return this.animate("shape", loop);
    },
    // Overwrite attrKV
    attrKV: function(key, value) {
        // FIXME
        if (key === "shape") {
            this.setShape(value);
            this.__dirtyPath = true;
            this._rect = null;
        } else $f95b0c44904a541d$exports.prototype.attrKV.call(this, key, value);
    },
    /**
   * @param {Object|string} key
   * @param {*} value
   */ setShape: function(key, value) {
        var shape = this.shape; // Path from string may not have shape
        if (shape) {
            if ($ec279652dd95c27b$export$a6cdc56e425d0d0a(key)) {
                for(var name in key)if (key.hasOwnProperty(name)) shape[name] = key[name];
            } else shape[key] = value;
            this.dirty(true);
        }
        return this;
    },
    getLineScale: function() {
        var m = this.transform; // Get the line scale.
        // Determinant of `m` means how much the area is enlarged by the
        // transformation. So its square root can be used as a scale factor
        // for width.
        return m && $b9701a0f23f767de$var$abs(m[0] - 1) > 1e-10 && $b9701a0f23f767de$var$abs(m[3] - 1) > 1e-10 ? Math.sqrt($b9701a0f23f767de$var$abs(m[0] * m[3] - m[2] * m[1])) : 1;
    }
};
/**
 * 扩展一个 Path element, 比如星形，圆等。
 * Extend a path element
 * @param {Object} props
 * @param {string} props.type Path type
 * @param {Function} props.init Initialize
 * @param {Function} props.buildPath Overwrite buildPath method
 * @param {Object} [props.style] Extended default style config
 * @param {Object} [props.shape] Extended default shape config
 */ $b9701a0f23f767de$var$Path.extend = function(defaults) {
    var Sub = function(opts) {
        $b9701a0f23f767de$var$Path.call(this, opts);
        if (defaults.style) // Extend default style
        this.style.extendFrom(defaults.style, false);
         // Extend default shape
        var defaultShape = defaults.shape;
        if (defaultShape) {
            this.shape = this.shape || {};
            var thisShape = this.shape;
            for(var name in defaultShape)if (!thisShape.hasOwnProperty(name) && defaultShape.hasOwnProperty(name)) thisShape[name] = defaultShape[name];
        }
        defaults.init && defaults.init.call(this, opts);
    };
    $ec279652dd95c27b$export$69f1b2dcda23c5f8(Sub, $b9701a0f23f767de$var$Path); // FIXME 不能 extend position, rotation 等引用对象
    for(var name in defaults)// Extending prototype values and methods
    if (name !== "style" && name !== "shape") Sub.prototype[name] = defaults[name];
    return Sub;
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($b9701a0f23f767de$var$Path, $f95b0c44904a541d$exports);
var $b9701a0f23f767de$var$_default = $b9701a0f23f767de$var$Path;
$b9701a0f23f767de$exports = $b9701a0f23f767de$var$_default;



var $78e396525d60bfe4$exports = {};


var $78e396525d60bfe4$var$v2ApplyTransform = $9eb63d101f3bcd79$export$9f9dcb98c894b623;
var $78e396525d60bfe4$var$CMD = $4c785e18473c2aa4$exports.CMD;
var $78e396525d60bfe4$var$points = [
    [],
    [],
    []
];
var $78e396525d60bfe4$var$mathSqrt = Math.sqrt;
var $78e396525d60bfe4$var$mathAtan2 = Math.atan2;
function $78e396525d60bfe4$var$_default(path, m) {
    var data = path.data;
    var cmd;
    var nPoint;
    var i;
    var j;
    var k;
    var p;
    var M = $78e396525d60bfe4$var$CMD.M;
    var C = $78e396525d60bfe4$var$CMD.C;
    var L = $78e396525d60bfe4$var$CMD.L;
    var R = $78e396525d60bfe4$var$CMD.R;
    var A = $78e396525d60bfe4$var$CMD.A;
    var Q = $78e396525d60bfe4$var$CMD.Q;
    for(i = 0, j = 0; i < data.length;){
        cmd = data[i++];
        j = i;
        nPoint = 0;
        switch(cmd){
            case M:
                nPoint = 1;
                break;
            case L:
                nPoint = 1;
                break;
            case C:
                nPoint = 3;
                break;
            case Q:
                nPoint = 2;
                break;
            case A:
                var x = m[4];
                var y = m[5];
                var sx = $78e396525d60bfe4$var$mathSqrt(m[0] * m[0] + m[1] * m[1]);
                var sy = $78e396525d60bfe4$var$mathSqrt(m[2] * m[2] + m[3] * m[3]);
                var angle = $78e396525d60bfe4$var$mathAtan2(-m[1] / sy, m[0] / sx); // cx
                data[i] *= sx;
                data[i++] += x; // cy
                data[i] *= sy;
                data[i++] += y; // Scale rx and ry
                // FIXME Assume psi is 0 here
                data[i++] *= sx;
                data[i++] *= sy; // Start angle
                data[i++] += angle; // end angle
                data[i++] += angle; // FIXME psi
                i += 2;
                j = i;
                break;
            case R:
                // x0, y0
                p[0] = data[i++];
                p[1] = data[i++];
                $78e396525d60bfe4$var$v2ApplyTransform(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1]; // x1, y1
                p[0] += data[i++];
                p[1] += data[i++];
                $78e396525d60bfe4$var$v2ApplyTransform(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
        }
        for(k = 0; k < nPoint; k++){
            var p = $78e396525d60bfe4$var$points[k];
            p[0] = data[i++];
            p[1] = data[i++];
            $78e396525d60bfe4$var$v2ApplyTransform(p, p, m); // Write back
            data[j++] = p[0];
            data[j++] = p[1];
        }
    }
}
$78e396525d60bfe4$exports = $78e396525d60bfe4$var$_default;


// command chars
// var cc = [
//     'm', 'M', 'l', 'L', 'v', 'V', 'h', 'H', 'z', 'Z',
//     'c', 'C', 'q', 'Q', 't', 'T', 's', 'S', 'a', 'A'
// ];
var $69b77ae5b8565cf7$var$mathSqrt = Math.sqrt;
var $69b77ae5b8565cf7$var$mathSin = Math.sin;
var $69b77ae5b8565cf7$var$mathCos = Math.cos;
var $69b77ae5b8565cf7$var$PI = Math.PI;
var $69b77ae5b8565cf7$var$vMag = function(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
};
var $69b77ae5b8565cf7$var$vRatio = function(u, v) {
    return (u[0] * v[0] + u[1] * v[1]) / ($69b77ae5b8565cf7$var$vMag(u) * $69b77ae5b8565cf7$var$vMag(v));
};
var $69b77ae5b8565cf7$var$vAngle = function(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos($69b77ae5b8565cf7$var$vRatio(u, v));
};
function $69b77ae5b8565cf7$var$processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
    var psi = psiDeg * ($69b77ae5b8565cf7$var$PI / 180.0);
    var xp = $69b77ae5b8565cf7$var$mathCos(psi) * (x1 - x2) / 2.0 + $69b77ae5b8565cf7$var$mathSin(psi) * (y1 - y2) / 2.0;
    var yp = -1 * $69b77ae5b8565cf7$var$mathSin(psi) * (x1 - x2) / 2.0 + $69b77ae5b8565cf7$var$mathCos(psi) * (y1 - y2) / 2.0;
    var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
    if (lambda > 1) {
        rx *= $69b77ae5b8565cf7$var$mathSqrt(lambda);
        ry *= $69b77ae5b8565cf7$var$mathSqrt(lambda);
    }
    var f = (fa === fs ? -1 : 1) * $69b77ae5b8565cf7$var$mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
    var cxp = f * rx * yp / ry;
    var cyp = f * -ry * xp / rx;
    var cx = (x1 + x2) / 2.0 + $69b77ae5b8565cf7$var$mathCos(psi) * cxp - $69b77ae5b8565cf7$var$mathSin(psi) * cyp;
    var cy = (y1 + y2) / 2.0 + $69b77ae5b8565cf7$var$mathSin(psi) * cxp + $69b77ae5b8565cf7$var$mathCos(psi) * cyp;
    var theta = $69b77ae5b8565cf7$var$vAngle([
        1,
        0
    ], [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ]);
    var u = [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ];
    var v = [
        (-1 * xp - cxp) / rx,
        (-1 * yp - cyp) / ry
    ];
    var dTheta = $69b77ae5b8565cf7$var$vAngle(u, v);
    if ($69b77ae5b8565cf7$var$vRatio(u, v) <= -1) dTheta = $69b77ae5b8565cf7$var$PI;
    if ($69b77ae5b8565cf7$var$vRatio(u, v) >= 1) dTheta = 0;
    if (fs === 0 && dTheta > 0) dTheta = dTheta - 2 * $69b77ae5b8565cf7$var$PI;
    if (fs === 1 && dTheta < 0) dTheta = dTheta + 2 * $69b77ae5b8565cf7$var$PI;
    path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}
var $69b77ae5b8565cf7$var$commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig; // Consider case:
// (1) delimiter can be comma or space, where continuous commas
// or spaces should be seen as one comma.
// (2) value can be like:
// '2e-4', 'l.5.9' (ignore 0), 'M-10-10', 'l-2.43e-1,34.9983',
// 'l-.5E1,54', '121-23-44-11' (no delimiter)
var $69b77ae5b8565cf7$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g; // var valueSplitReg = /[\s,]+/;
function $69b77ae5b8565cf7$var$createPathProxyFromString(data) {
    if (!data) return new $4c785e18473c2aa4$exports();
     // var data = data.replace(/-/g, ' -')
    //     .replace(/  /g, ' ')
    //     .replace(/ /g, ',')
    //     .replace(/,,/g, ',');
    // var n;
    // create pipes so that we can split the data
    // for (n = 0; n < cc.length; n++) {
    //     cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
    // }
    // data = data.replace(/-/g, ',-');
    // create array
    // var arr = cs.split('|');
    // init context point
    var cpx = 0;
    var cpy = 0;
    var subpathX = cpx;
    var subpathY = cpy;
    var prevCmd;
    var path = new $4c785e18473c2aa4$exports();
    var CMD = $4c785e18473c2aa4$exports.CMD; // commandReg.lastIndex = 0;
    // var cmdResult;
    // while ((cmdResult = commandReg.exec(data)) != null) {
    //     var cmdStr = cmdResult[1];
    //     var cmdContent = cmdResult[2];
    var cmdList = data.match($69b77ae5b8565cf7$var$commandReg);
    for(var l = 0; l < cmdList.length; l++){
        var cmdText = cmdList[l];
        var cmdStr = cmdText.charAt(0);
        var cmd; // String#split is faster a little bit than String#replace or RegExp#exec.
        // var p = cmdContent.split(valueSplitReg);
        // var pLen = 0;
        // for (var i = 0; i < p.length; i++) {
        //     // '' and other invalid str => NaN
        //     var val = parseFloat(p[i]);
        //     !isNaN(val) && (p[pLen++] = val);
        // }
        var p = cmdText.match($69b77ae5b8565cf7$var$numberReg) || [];
        var pLen = p.length;
        for(var i = 0; i < pLen; i++)p[i] = parseFloat(p[i]);
        var off = 0;
        while(off < pLen){
            var ctlPtx;
            var ctlPty;
            var rx;
            var ry;
            var psi;
            var fa;
            var fs;
            var x1 = cpx;
            var y1 = cpy; // convert l, H, h, V, and v to L
            switch(cmdStr){
                case "l":
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "L":
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "m":
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = "l";
                    break;
                case "M":
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = "L";
                    break;
                case "h":
                    cpx += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "H":
                    cpx = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "v":
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "V":
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "C":
                    cmd = CMD.C;
                    path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                    cpx = p[off - 2];
                    cpy = p[off - 1];
                    break;
                case "c":
                    cmd = CMD.C;
                    path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                    cpx += p[off - 2];
                    cpy += p[off - 1];
                    break;
                case "S":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    var len = path.len();
                    var pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case "s":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    var len = path.len();
                    var pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = cpx + p[off++];
                    y1 = cpy + p[off++];
                    cpx += p[off++];
                    cpy += p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case "Q":
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case "q":
                    x1 = p[off++] + cpx;
                    y1 = p[off++] + cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case "T":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    var len = path.len();
                    var pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case "t":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    var len = path.len();
                    var pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case "A":
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.A;
                    $69b77ae5b8565cf7$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
                case "a":
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.A;
                    $69b77ae5b8565cf7$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
            }
        }
        if (cmdStr === "z" || cmdStr === "Z") {
            cmd = CMD.Z;
            path.addData(cmd); // z may be in the middle of the path.
            cpx = subpathX;
            cpy = subpathY;
        }
        prevCmd = cmd;
    }
    path.toStatic();
    return path;
} // TODO Optimize double memory cost problem
function $69b77ae5b8565cf7$var$createPathOptions(str, opts) {
    var pathProxy = $69b77ae5b8565cf7$var$createPathProxyFromString(str);
    opts = opts || {};
    opts.buildPath = function(path) {
        if (path.setData) {
            path.setData(pathProxy.data); // Svg and vml renderer don't have context
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx);
        } else {
            var ctx = path;
            pathProxy.rebuildPath(ctx);
        }
    };
    opts.applyTransform = function(m) {
        $78e396525d60bfe4$exports(pathProxy, m);
        this.dirty(true);
    };
    return opts;
}
/**
 * Create a Path object from path string data
 * http://www.w3.org/TR/SVG/paths.html#PathData
 * @param  {Object} opts Other options
 */ function $69b77ae5b8565cf7$var$createFromString(str, opts) {
    return new $b9701a0f23f767de$exports($69b77ae5b8565cf7$var$createPathOptions(str, opts));
}
/**
 * Create a Path class from path string data
 * @param  {string} str
 * @param  {Object} opts Other options
 */ function $69b77ae5b8565cf7$var$extendFromString(str, opts) {
    return $b9701a0f23f767de$exports.extend($69b77ae5b8565cf7$var$createPathOptions(str, opts));
}
/**
 * Merge multiple paths
 */ // TODO Apply transform
// TODO stroke dash
// TODO Optimize double memory cost problem
function $69b77ae5b8565cf7$var$mergePath(pathEls, opts) {
    var pathList = [];
    var len = pathEls.length;
    for(var i = 0; i < len; i++){
        var pathEl = pathEls[i];
        if (!pathEl.path) pathEl.createPathProxy();
        if (pathEl.__dirtyPath) pathEl.buildPath(pathEl.path, pathEl.shape, true);
        pathList.push(pathEl.path);
    }
    var pathBundle = new $b9701a0f23f767de$exports(opts); // Need path proxy.
    pathBundle.createPathProxy();
    pathBundle.buildPath = function(path) {
        path.appendPath(pathList); // Svg and vml renderer don't have context
        var ctx = path.getContext();
        if (ctx) path.rebuildPath(ctx);
    };
    return pathBundle;
}
$69b77ae5b8565cf7$export$ae5b259626f00aeb = $69b77ae5b8565cf7$var$createFromString;
$69b77ae5b8565cf7$export$68e3a51ba2ed417c = $69b77ae5b8565cf7$var$extendFromString;
$69b77ae5b8565cf7$export$7b1dd269fbc4e903 = $69b77ae5b8565cf7$var$mergePath;








$4b57d6b582d579b7$export$3e431a229df88919 = $8d11db19115b899b$exports;

$4b57d6b582d579b7$export$eb2fcfdbd7ba97d4 = $48aa8d5160ffcc64$exports;
var $2fc81b997a587c68$exports = {};





var $2fc81b997a587c68$var$ContextCachedBy = $e1470dc860948586$export$4c866e61483cd9a4;
/**
 * @alias zrender/graphic/Text
 * @extends module:zrender/graphic/Displayable
 * @constructor
 * @param {Object} opts
 */ var $2fc81b997a587c68$var$Text = function(opts) {
    // jshint ignore:line
    $f95b0c44904a541d$exports.call(this, opts);
};
$2fc81b997a587c68$var$Text.prototype = {
    constructor: $2fc81b997a587c68$var$Text,
    type: "text",
    brush: function(ctx, prevEl) {
        var style = this.style; // Optimize, avoid normalize every time.
        this.__dirty && $5b0ace94e7e58ea5$export$176336068cc5371f(style, true); // Use props with prefix 'text'.
        style.fill = style.stroke = style.shadowBlur = style.shadowColor = style.shadowOffsetX = style.shadowOffsetY = null;
        var text = style.text; // Convert to string
        text != null && (text += ""); // Do not apply style.bind in Text node. Because the real bind job
        // is in textHelper.renderText, and performance of text render should
        // be considered.
        // style.bind(ctx, this, prevEl);
        if (!$5b0ace94e7e58ea5$export$15f386d282805840(text, style)) {
            // The current el.style is not applied
            // and should not be used as cache.
            ctx.__attrCachedBy = $2fc81b997a587c68$var$ContextCachedBy.NONE;
            return;
        }
        this.setTransform(ctx);
        $5b0ace94e7e58ea5$export$482c90f94eb9717c(this, ctx, text, style, null, prevEl);
        this.restoreTransform(ctx);
    },
    getBoundingRect: function() {
        var style = this.style; // Optimize, avoid normalize every time.
        this.__dirty && $5b0ace94e7e58ea5$export$176336068cc5371f(style, true);
        if (!this._rect) {
            var text = style.text;
            text != null ? text += "" : text = "";
            var rect = $ebae9c4ebc22906c$export$c381147bfed79d9f(style.text + "", style.font, style.textAlign, style.textVerticalAlign, style.textPadding, style.textLineHeight, style.rich);
            rect.x += style.x || 0;
            rect.y += style.y || 0;
            if ($5b0ace94e7e58ea5$export$d5e7b8855b0b151b(style.textStroke, style.textStrokeWidth)) {
                var w = style.textStrokeWidth;
                rect.x -= w / 2;
                rect.y -= w / 2;
                rect.width += w;
                rect.height += w;
            }
            this._rect = rect;
        }
        return this._rect;
    }
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($2fc81b997a587c68$var$Text, $f95b0c44904a541d$exports);
var $2fc81b997a587c68$var$_default = $2fc81b997a587c68$var$Text;
$2fc81b997a587c68$exports = $2fc81b997a587c68$var$_default;


$4b57d6b582d579b7$export$5f1af8db9871e1d6 = $2fc81b997a587c68$exports;
var $eddb4ac7833251bb$exports = {};

/**
 * 圆形
 * @module zrender/shape/Circle
 */ var $eddb4ac7833251bb$var$_default = $b9701a0f23f767de$exports.extend({
    type: "circle",
    shape: {
        cx: 0,
        cy: 0,
        r: 0
    },
    buildPath: function(ctx, shape, inBundle) {
        // Better stroking in ShapeBundle
        // Always do it may have performence issue ( fill may be 2x more cost)
        if (inBundle) ctx.moveTo(shape.cx + shape.r, shape.cy);
         // else {
        //     if (ctx.allocate && !ctx.data.length) {
        //         ctx.allocate(ctx.CMD_MEM_SIZE.A);
        //     }
        // }
        // Better stroking in ShapeBundle
        // ctx.moveTo(shape.cx + shape.r, shape.cy);
        ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2, true);
    }
});
$eddb4ac7833251bb$exports = $eddb4ac7833251bb$var$_default;


$4b57d6b582d579b7$export$c89a927ffc67e6fa = $eddb4ac7833251bb$exports;
var $d7bd8a41e5d15836$exports = {};

var $a68c476206b129a9$exports = {};

// Fix weird bug in some version of IE11 (like 11.0.9600.178**),
// where exception "unexpected call to method or property access"
// might be thrown when calling ctx.fill or ctx.stroke after a path
// whose area size is zero is drawn and ctx.clip() is called and
// shadowBlur is set. See #4572, #3112, #5777.
// (e.g.,
//  ctx.moveTo(10, 10);
//  ctx.lineTo(20, 10);
//  ctx.closePath();
//  ctx.clip();
//  ctx.shadowBlur = 10;
//  ...
//  ctx.fill();
// )
var $a68c476206b129a9$var$shadowTemp = [
    [
        "shadowBlur",
        0
    ],
    [
        "shadowColor",
        "#000"
    ],
    [
        "shadowOffsetX",
        0
    ],
    [
        "shadowOffsetY",
        0
    ]
];
function $a68c476206b129a9$var$_default(orignalBrush) {
    // version string can be: '11.0'
    return $27ac1413ecc67076$exports.browser.ie && $27ac1413ecc67076$exports.browser.version >= 11 ? function() {
        var clipPaths = this.__clipPaths;
        var style = this.style;
        var modified;
        if (clipPaths) for(var i = 0; i < clipPaths.length; i++){
            var clipPath = clipPaths[i];
            var shape = clipPath && clipPath.shape;
            var type = clipPath && clipPath.type;
            if (shape && (type === "sector" && shape.startAngle === shape.endAngle || type === "rect" && (!shape.width || !shape.height))) {
                for(var j = 0; j < $a68c476206b129a9$var$shadowTemp.length; j++){
                    // It is save to put shadowTemp static, because shadowTemp
                    // will be all modified each item brush called.
                    $a68c476206b129a9$var$shadowTemp[j][2] = style[$a68c476206b129a9$var$shadowTemp[j][0]];
                    style[$a68c476206b129a9$var$shadowTemp[j][0]] = $a68c476206b129a9$var$shadowTemp[j][1];
                }
                modified = true;
                break;
            }
        }
        orignalBrush.apply(this, arguments);
        if (modified) for(var j = 0; j < $a68c476206b129a9$var$shadowTemp.length; j++)style[$a68c476206b129a9$var$shadowTemp[j][0]] = $a68c476206b129a9$var$shadowTemp[j][2];
    } : orignalBrush;
}
$a68c476206b129a9$exports = $a68c476206b129a9$var$_default;


/**
 * 扇形
 * @module zrender/graphic/shape/Sector
 */ var $d7bd8a41e5d15836$var$_default = $b9701a0f23f767de$exports.extend({
    type: "sector",
    shape: {
        cx: 0,
        cy: 0,
        r0: 0,
        r: 0,
        startAngle: 0,
        endAngle: Math.PI * 2,
        clockwise: true
    },
    brush: $a68c476206b129a9$exports($b9701a0f23f767de$exports.prototype.brush),
    buildPath: function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r0 = Math.max(shape.r0 || 0, 0);
        var r = Math.max(shape.r, 0);
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitX = Math.cos(startAngle);
        var unitY = Math.sin(startAngle);
        ctx.moveTo(unitX * r0 + x, unitY * r0 + y);
        ctx.lineTo(unitX * r + x, unitY * r + y);
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
        ctx.lineTo(Math.cos(endAngle) * r0 + x, Math.sin(endAngle) * r0 + y);
        if (r0 !== 0) ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
        ctx.closePath();
    }
});
$d7bd8a41e5d15836$exports = $d7bd8a41e5d15836$var$_default;


$4b57d6b582d579b7$export$e98c2c7eb2b14f45 = $d7bd8a41e5d15836$exports;
var $35ca50b8f972e4c4$exports = {};

/**
 * 圆环
 * @module zrender/graphic/shape/Ring
 */ var $35ca50b8f972e4c4$var$_default = $b9701a0f23f767de$exports.extend({
    type: "ring",
    shape: {
        cx: 0,
        cy: 0,
        r: 0,
        r0: 0
    },
    buildPath: function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var PI2 = Math.PI * 2;
        ctx.moveTo(x + shape.r, y);
        ctx.arc(x, y, shape.r, 0, PI2, false);
        ctx.moveTo(x + shape.r0, y);
        ctx.arc(x, y, shape.r0, 0, PI2, true);
    }
});
$35ca50b8f972e4c4$exports = $35ca50b8f972e4c4$var$_default;


$4b57d6b582d579b7$export$a6e3577650b6d6d7 = $35ca50b8f972e4c4$exports;
var $b354b78e9d1919f1$exports = {};

var $f5a9a259c3e81bf5$export$5cc7f731b5937e99;
var $7bde36b1975a88bd$exports = {};

var $7bde36b1975a88bd$var$v2Distance = $9eb63d101f3bcd79$export$9f17032d917177de;
/**
 * Catmull-Rom spline 插值折线
 * @module zrender/shape/util/smoothSpline
 * @author pissang (https://www.github.com/pissang)
 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         errorrik (errorrik@gmail.com)
 */ /**
 * @inner
 */ function $7bde36b1975a88bd$var$interpolate(p0, p1, p2, p3, t, t2, t3) {
    var v0 = (p2 - p0) * 0.5;
    var v1 = (p3 - p1) * 0.5;
    return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
}
/**
 * @alias module:zrender/shape/util/smoothSpline
 * @param {Array} points 线段顶点数组
 * @param {boolean} isLoop
 * @return {Array}
 */ function $7bde36b1975a88bd$var$_default(points, isLoop) {
    var len = points.length;
    var ret = [];
    var distance = 0;
    for(var i = 1; i < len; i++)distance += $7bde36b1975a88bd$var$v2Distance(points[i - 1], points[i]);
    var segs = distance / 2;
    segs = segs < len ? len : segs;
    for(var i = 0; i < segs; i++){
        var pos = i / (segs - 1) * (isLoop ? len : len - 1);
        var idx = Math.floor(pos);
        var w = pos - idx;
        var p0;
        var p1 = points[idx % len];
        var p2;
        var p3;
        if (!isLoop) {
            p0 = points[idx === 0 ? idx : idx - 1];
            p2 = points[idx > len - 2 ? len - 1 : idx + 1];
            p3 = points[idx > len - 3 ? len - 1 : idx + 2];
        } else {
            p0 = points[(idx - 1 + len) % len];
            p2 = points[(idx + 1) % len];
            p3 = points[(idx + 2) % len];
        }
        var w2 = w * w;
        var w3 = w * w2;
        ret.push([
            $7bde36b1975a88bd$var$interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3),
            $7bde36b1975a88bd$var$interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)
        ]);
    }
    return ret;
}
$7bde36b1975a88bd$exports = $7bde36b1975a88bd$var$_default;


var $226c6f854cca964c$exports = {};

var $226c6f854cca964c$var$v2Min = $9eb63d101f3bcd79$export$96ec731ed4dcb222;
var $226c6f854cca964c$var$v2Max = $9eb63d101f3bcd79$export$8960430cfd85939f;
var $226c6f854cca964c$var$v2Scale = $9eb63d101f3bcd79$export$dcdf75081b88279d;
var $226c6f854cca964c$var$v2Distance = $9eb63d101f3bcd79$export$9f17032d917177de;
var $226c6f854cca964c$var$v2Add = $9eb63d101f3bcd79$export$e16d8520af44a096;
var $226c6f854cca964c$var$v2Clone = $9eb63d101f3bcd79$export$9cd59f9826255e47;
var $226c6f854cca964c$var$v2Sub = $9eb63d101f3bcd79$export$f93b5905241a7cca;
/**
 * 贝塞尔平滑曲线
 * @module zrender/shape/util/smoothBezier
 * @author pissang (https://www.github.com/pissang)
 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         errorrik (errorrik@gmail.com)
 */ /**
 * 贝塞尔平滑曲线
 * @alias module:zrender/shape/util/smoothBezier
 * @param {Array} points 线段顶点数组
 * @param {number} smooth 平滑等级, 0-1
 * @param {boolean} isLoop
 * @param {Array} constraint 将计算出来的控制点约束在一个包围盒内
 *                           比如 [[0, 0], [100, 100]], 这个包围盒会与
 *                           整个折线的包围盒做一个并集用来约束控制点。
 * @param {Array} 计算出来的控制点数组
 */ function $226c6f854cca964c$var$_default(points, smooth, isLoop, constraint) {
    var cps = [];
    var v = [];
    var v1 = [];
    var v2 = [];
    var prevPoint;
    var nextPoint;
    var min;
    var max;
    if (constraint) {
        min = [
            Infinity,
            Infinity
        ];
        max = [
            -Infinity,
            -Infinity
        ];
        for(var i = 0, len = points.length; i < len; i++){
            $226c6f854cca964c$var$v2Min(min, min, points[i]);
            $226c6f854cca964c$var$v2Max(max, max, points[i]);
        } // 与指定的包围盒做并集
        $226c6f854cca964c$var$v2Min(min, min, constraint[0]);
        $226c6f854cca964c$var$v2Max(max, max, constraint[1]);
    }
    for(var i = 0, len = points.length; i < len; i++){
        var point = points[i];
        if (isLoop) {
            prevPoint = points[i ? i - 1 : len - 1];
            nextPoint = points[(i + 1) % len];
        } else if (i === 0 || i === len - 1) {
            cps.push($226c6f854cca964c$var$v2Clone(points[i]));
            continue;
        } else {
            prevPoint = points[i - 1];
            nextPoint = points[i + 1];
        }
        $226c6f854cca964c$var$v2Sub(v, nextPoint, prevPoint); // use degree to scale the handle length
        $226c6f854cca964c$var$v2Scale(v, v, smooth);
        var d0 = $226c6f854cca964c$var$v2Distance(point, prevPoint);
        var d1 = $226c6f854cca964c$var$v2Distance(point, nextPoint);
        var sum = d0 + d1;
        if (sum !== 0) {
            d0 /= sum;
            d1 /= sum;
        }
        $226c6f854cca964c$var$v2Scale(v1, v, -d0);
        $226c6f854cca964c$var$v2Scale(v2, v, d1);
        var cp0 = $226c6f854cca964c$var$v2Add([], point, v1);
        var cp1 = $226c6f854cca964c$var$v2Add([], point, v2);
        if (constraint) {
            $226c6f854cca964c$var$v2Max(cp0, cp0, min);
            $226c6f854cca964c$var$v2Min(cp0, cp0, max);
            $226c6f854cca964c$var$v2Max(cp1, cp1, min);
            $226c6f854cca964c$var$v2Min(cp1, cp1, max);
        }
        cps.push(cp0);
        cps.push(cp1);
    }
    if (isLoop) cps.push(cps.shift());
    return cps;
}
$226c6f854cca964c$exports = $226c6f854cca964c$var$_default;


function $f5a9a259c3e81bf5$var$buildPath(ctx, shape, closePath) {
    var points = shape.points;
    var smooth = shape.smooth;
    if (points && points.length >= 2) {
        if (smooth && smooth !== "spline") {
            var controlPoints = $226c6f854cca964c$exports(points, smooth, closePath, shape.smoothConstraint);
            ctx.moveTo(points[0][0], points[0][1]);
            var len = points.length;
            for(var i = 0; i < (closePath ? len : len - 1); i++){
                var cp1 = controlPoints[i * 2];
                var cp2 = controlPoints[i * 2 + 1];
                var p = points[(i + 1) % len];
                ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
            }
        } else {
            if (smooth === "spline") points = $7bde36b1975a88bd$exports(points, closePath);
            ctx.moveTo(points[0][0], points[0][1]);
            for(var i = 1, l = points.length; i < l; i++)ctx.lineTo(points[i][0], points[i][1]);
        }
        closePath && ctx.closePath();
    }
}
$f5a9a259c3e81bf5$export$5cc7f731b5937e99 = $f5a9a259c3e81bf5$var$buildPath;


/**
 * 多边形
 * @module zrender/shape/Polygon
 */ var $b354b78e9d1919f1$var$_default = $b9701a0f23f767de$exports.extend({
    type: "polygon",
    shape: {
        points: null,
        smooth: false,
        smoothConstraint: null
    },
    buildPath: function(ctx, shape) {
        $f5a9a259c3e81bf5$export$5cc7f731b5937e99(ctx, shape, true);
    }
});
$b354b78e9d1919f1$exports = $b354b78e9d1919f1$var$_default;


$4b57d6b582d579b7$export$7d31b617c820d435 = $b354b78e9d1919f1$exports;
var $d6beacdc66e44020$exports = {};


/**
 * @module zrender/graphic/shape/Polyline
 */ var $d6beacdc66e44020$var$_default = $b9701a0f23f767de$exports.extend({
    type: "polyline",
    shape: {
        points: null,
        smooth: false,
        smoothConstraint: null
    },
    style: {
        stroke: "#000",
        fill: null
    },
    buildPath: function(ctx, shape) {
        $f5a9a259c3e81bf5$export$5cc7f731b5937e99(ctx, shape, false);
    }
});
$d6beacdc66e44020$exports = $d6beacdc66e44020$var$_default;


$4b57d6b582d579b7$export$79f3ee03e63e7073 = $d6beacdc66e44020$exports;
var $9dfde1361bdd05e1$exports = {};


/**
 * Sub-pixel optimize for canvas rendering, prevent from blur
 * when rendering a thin vertical/horizontal line.
 */ var $6aaf7d9f056a9deb$export$8b4b620d7f4aad1b;
var $6aaf7d9f056a9deb$export$60e2aa74957d0b9d;
var $6aaf7d9f056a9deb$export$72c4fd4c1b8fcb10;
var $6aaf7d9f056a9deb$var$round = Math.round;
/**
 * Sub pixel optimize line for canvas
 *
 * @param {Object} outputShape The modification will be performed on `outputShape`.
 *                 `outputShape` and `inputShape` can be the same object.
 *                 `outputShape` object can be used repeatly, because all of
 *                 the `x1`, `x2`, `y1`, `y2` will be assigned in this method.
 * @param {Object} [inputShape]
 * @param {number} [inputShape.x1]
 * @param {number} [inputShape.y1]
 * @param {number} [inputShape.x2]
 * @param {number} [inputShape.y2]
 * @param {Object} [style]
 * @param {number} [style.lineWidth] If `null`/`undefined`/`0`, do not optimize.
 */ function $6aaf7d9f056a9deb$var$subPixelOptimizeLine(outputShape, inputShape, style) {
    if (!inputShape) return;
    var x1 = inputShape.x1;
    var x2 = inputShape.x2;
    var y1 = inputShape.y1;
    var y2 = inputShape.y2;
    outputShape.x1 = x1;
    outputShape.x2 = x2;
    outputShape.y1 = y1;
    outputShape.y2 = y2;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return;
    if ($6aaf7d9f056a9deb$var$round(x1 * 2) === $6aaf7d9f056a9deb$var$round(x2 * 2)) outputShape.x1 = outputShape.x2 = $6aaf7d9f056a9deb$var$subPixelOptimize(x1, lineWidth, true);
    if ($6aaf7d9f056a9deb$var$round(y1 * 2) === $6aaf7d9f056a9deb$var$round(y2 * 2)) outputShape.y1 = outputShape.y2 = $6aaf7d9f056a9deb$var$subPixelOptimize(y1, lineWidth, true);
}
/**
 * Sub pixel optimize rect for canvas
 *
 * @param {Object} outputShape The modification will be performed on `outputShape`.
 *                 `outputShape` and `inputShape` can be the same object.
 *                 `outputShape` object can be used repeatly, because all of
 *                 the `x`, `y`, `width`, `height` will be assigned in this method.
 * @param {Object} [inputShape]
 * @param {number} [inputShape.x]
 * @param {number} [inputShape.y]
 * @param {number} [inputShape.width]
 * @param {number} [inputShape.height]
 * @param {Object} [style]
 * @param {number} [style.lineWidth] If `null`/`undefined`/`0`, do not optimize.
 */ function $6aaf7d9f056a9deb$var$subPixelOptimizeRect(outputShape, inputShape, style) {
    if (!inputShape) return;
    var originX = inputShape.x;
    var originY = inputShape.y;
    var originWidth = inputShape.width;
    var originHeight = inputShape.height;
    outputShape.x = originX;
    outputShape.y = originY;
    outputShape.width = originWidth;
    outputShape.height = originHeight;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return;
    outputShape.x = $6aaf7d9f056a9deb$var$subPixelOptimize(originX, lineWidth, true);
    outputShape.y = $6aaf7d9f056a9deb$var$subPixelOptimize(originY, lineWidth, true);
    outputShape.width = Math.max($6aaf7d9f056a9deb$var$subPixelOptimize(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
    outputShape.height = Math.max($6aaf7d9f056a9deb$var$subPixelOptimize(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
}
/**
 * Sub pixel optimize for canvas
 *
 * @param {number} position Coordinate, such as x, y
 * @param {number} lineWidth If `null`/`undefined`/`0`, do not optimize.
 * @param {boolean=} positiveOrNegative Default false (negative).
 * @return {number} Optimized position.
 */ function $6aaf7d9f056a9deb$var$subPixelOptimize(position, lineWidth, positiveOrNegative) {
    if (!lineWidth) return position;
     // Assure that (position + lineWidth / 2) is near integer edge,
    // otherwise line will be fuzzy in canvas.
    var doubledPosition = $6aaf7d9f056a9deb$var$round(position * 2);
    return (doubledPosition + $6aaf7d9f056a9deb$var$round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}
$6aaf7d9f056a9deb$export$8b4b620d7f4aad1b = $6aaf7d9f056a9deb$var$subPixelOptimizeLine;
$6aaf7d9f056a9deb$export$60e2aa74957d0b9d = $6aaf7d9f056a9deb$var$subPixelOptimizeRect;
$6aaf7d9f056a9deb$export$72c4fd4c1b8fcb10 = $6aaf7d9f056a9deb$var$subPixelOptimize;


var $9dfde1361bdd05e1$var$subPixelOptimizeRect = $6aaf7d9f056a9deb$export$60e2aa74957d0b9d;
/**
 * 矩形
 * @module zrender/graphic/shape/Rect
 */ // Avoid create repeatly.
var $9dfde1361bdd05e1$var$subPixelOptimizeOutputShape = {};
var $9dfde1361bdd05e1$var$_default = $b9701a0f23f767de$exports.extend({
    type: "rect",
    shape: {
        // 左上、右上、右下、左下角的半径依次为r1、r2、r3、r4
        // r缩写为1         相当于 [1, 1, 1, 1]
        // r缩写为[1]       相当于 [1, 1, 1, 1]
        // r缩写为[1, 2]    相当于 [1, 2, 1, 2]
        // r缩写为[1, 2, 3] 相当于 [1, 2, 3, 2]
        r: 0,
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(ctx, shape) {
        var x;
        var y;
        var width;
        var height;
        if (this.subPixelOptimize) {
            $9dfde1361bdd05e1$var$subPixelOptimizeRect($9dfde1361bdd05e1$var$subPixelOptimizeOutputShape, shape, this.style);
            x = $9dfde1361bdd05e1$var$subPixelOptimizeOutputShape.x;
            y = $9dfde1361bdd05e1$var$subPixelOptimizeOutputShape.y;
            width = $9dfde1361bdd05e1$var$subPixelOptimizeOutputShape.width;
            height = $9dfde1361bdd05e1$var$subPixelOptimizeOutputShape.height;
            $9dfde1361bdd05e1$var$subPixelOptimizeOutputShape.r = shape.r;
            shape = $9dfde1361bdd05e1$var$subPixelOptimizeOutputShape;
        } else {
            x = shape.x;
            y = shape.y;
            width = shape.width;
            height = shape.height;
        }
        if (!shape.r) ctx.rect(x, y, width, height);
        else $0d3fae5dbee73a0d$export$5cc7f731b5937e99(ctx, shape);
        ctx.closePath();
        return;
    }
});
$9dfde1361bdd05e1$exports = $9dfde1361bdd05e1$var$_default;


$4b57d6b582d579b7$export$c79fc6492f3af13d = $9dfde1361bdd05e1$exports;
var $f84975fd9f4e7d13$exports = {};


var $f84975fd9f4e7d13$var$subPixelOptimizeLine = $6aaf7d9f056a9deb$export$8b4b620d7f4aad1b;
/**
 * 直线
 * @module zrender/graphic/shape/Line
 */ // Avoid create repeatly.
var $f84975fd9f4e7d13$var$subPixelOptimizeOutputShape = {};
var $f84975fd9f4e7d13$var$_default = $b9701a0f23f767de$exports.extend({
    type: "line",
    shape: {
        // Start point
        x1: 0,
        y1: 0,
        // End point
        x2: 0,
        y2: 0,
        percent: 1
    },
    style: {
        stroke: "#000",
        fill: null
    },
    buildPath: function(ctx, shape) {
        var x1;
        var y1;
        var x2;
        var y2;
        if (this.subPixelOptimize) {
            $f84975fd9f4e7d13$var$subPixelOptimizeLine($f84975fd9f4e7d13$var$subPixelOptimizeOutputShape, shape, this.style);
            x1 = $f84975fd9f4e7d13$var$subPixelOptimizeOutputShape.x1;
            y1 = $f84975fd9f4e7d13$var$subPixelOptimizeOutputShape.y1;
            x2 = $f84975fd9f4e7d13$var$subPixelOptimizeOutputShape.x2;
            y2 = $f84975fd9f4e7d13$var$subPixelOptimizeOutputShape.y2;
        } else {
            x1 = shape.x1;
            y1 = shape.y1;
            x2 = shape.x2;
            y2 = shape.y2;
        }
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (percent < 1) {
            x2 = x1 * (1 - percent) + x2 * percent;
            y2 = y1 * (1 - percent) + y2 * percent;
        }
        ctx.lineTo(x2, y2);
    },
    /**
   * Get point at percent
   * @param  {number} percent
   * @return {Array.<number>}
   */ pointAt: function(p) {
        var shape = this.shape;
        return [
            shape.x1 * (1 - p) + shape.x2 * p,
            shape.y1 * (1 - p) + shape.y2 * p
        ];
    }
});
$f84975fd9f4e7d13$exports = $f84975fd9f4e7d13$var$_default;


$4b57d6b582d579b7$export$17d680238e50603e = $f84975fd9f4e7d13$exports;
var $fd40ae4a803aa3fa$exports = {};



var $fd40ae4a803aa3fa$var$quadraticSubdivide = $ab3ad2315df1d857$export$117c659e21a7a060;
var $fd40ae4a803aa3fa$var$cubicSubdivide = $ab3ad2315df1d857$export$a2ee23a0567039da;
var $fd40ae4a803aa3fa$var$quadraticAt = $ab3ad2315df1d857$export$af17094a950f5073;
var $fd40ae4a803aa3fa$var$cubicAt = $ab3ad2315df1d857$export$547c21de482bbcb2;
var $fd40ae4a803aa3fa$var$quadraticDerivativeAt = $ab3ad2315df1d857$export$7e161e77e6fff8cb;
var $fd40ae4a803aa3fa$var$cubicDerivativeAt = $ab3ad2315df1d857$export$55fce925c60b6271;
/**
 * 贝塞尔曲线
 * @module zrender/shape/BezierCurve
 */ var $fd40ae4a803aa3fa$var$out = [];
function $fd40ae4a803aa3fa$var$someVectorAt(shape, t, isTangent) {
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    if (cpx2 === null || cpy2 === null) return [
        (isTangent ? $fd40ae4a803aa3fa$var$cubicDerivativeAt : $fd40ae4a803aa3fa$var$cubicAt)(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
        (isTangent ? $fd40ae4a803aa3fa$var$cubicDerivativeAt : $fd40ae4a803aa3fa$var$cubicAt)(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
    ];
    else return [
        (isTangent ? $fd40ae4a803aa3fa$var$quadraticDerivativeAt : $fd40ae4a803aa3fa$var$quadraticAt)(shape.x1, shape.cpx1, shape.x2, t),
        (isTangent ? $fd40ae4a803aa3fa$var$quadraticDerivativeAt : $fd40ae4a803aa3fa$var$quadraticAt)(shape.y1, shape.cpy1, shape.y2, t)
    ];
}
var $fd40ae4a803aa3fa$var$_default = $b9701a0f23f767de$exports.extend({
    type: "bezier-curve",
    shape: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0,
        cpx1: 0,
        cpy1: 0,
        // cpx2: 0,
        // cpy2: 0
        // Curve show percent, for animating
        percent: 1
    },
    style: {
        stroke: "#000",
        fill: null
    },
    buildPath: function(ctx, shape) {
        var x1 = shape.x1;
        var y1 = shape.y1;
        var x2 = shape.x2;
        var y2 = shape.y2;
        var cpx1 = shape.cpx1;
        var cpy1 = shape.cpy1;
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (cpx2 == null || cpy2 == null) {
            if (percent < 1) {
                $fd40ae4a803aa3fa$var$quadraticSubdivide(x1, cpx1, x2, percent, $fd40ae4a803aa3fa$var$out);
                cpx1 = $fd40ae4a803aa3fa$var$out[1];
                x2 = $fd40ae4a803aa3fa$var$out[2];
                $fd40ae4a803aa3fa$var$quadraticSubdivide(y1, cpy1, y2, percent, $fd40ae4a803aa3fa$var$out);
                cpy1 = $fd40ae4a803aa3fa$var$out[1];
                y2 = $fd40ae4a803aa3fa$var$out[2];
            }
            ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
        } else {
            if (percent < 1) {
                $fd40ae4a803aa3fa$var$cubicSubdivide(x1, cpx1, cpx2, x2, percent, $fd40ae4a803aa3fa$var$out);
                cpx1 = $fd40ae4a803aa3fa$var$out[1];
                cpx2 = $fd40ae4a803aa3fa$var$out[2];
                x2 = $fd40ae4a803aa3fa$var$out[3];
                $fd40ae4a803aa3fa$var$cubicSubdivide(y1, cpy1, cpy2, y2, percent, $fd40ae4a803aa3fa$var$out);
                cpy1 = $fd40ae4a803aa3fa$var$out[1];
                cpy2 = $fd40ae4a803aa3fa$var$out[2];
                y2 = $fd40ae4a803aa3fa$var$out[3];
            }
            ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
        }
    },
    /**
   * Get point at percent
   * @param  {number} t
   * @return {Array.<number>}
   */ pointAt: function(t) {
        return $fd40ae4a803aa3fa$var$someVectorAt(this.shape, t, false);
    },
    /**
   * Get tangent at percent
   * @param  {number} t
   * @return {Array.<number>}
   */ tangentAt: function(t) {
        var p = $fd40ae4a803aa3fa$var$someVectorAt(this.shape, t, true);
        return $9eb63d101f3bcd79$export$a3295358bff77e(p, p);
    }
});
$fd40ae4a803aa3fa$exports = $fd40ae4a803aa3fa$var$_default;


$4b57d6b582d579b7$export$a57c23a30525a34b = $fd40ae4a803aa3fa$exports;
var $210ee3596a85e224$exports = {};

/**
 * 圆弧
 * @module zrender/graphic/shape/Arc
 */ var $210ee3596a85e224$var$_default = $b9701a0f23f767de$exports.extend({
    type: "arc",
    shape: {
        cx: 0,
        cy: 0,
        r: 0,
        startAngle: 0,
        endAngle: Math.PI * 2,
        clockwise: true
    },
    style: {
        stroke: "#000",
        fill: null
    },
    buildPath: function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r = Math.max(shape.r, 0);
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitX = Math.cos(startAngle);
        var unitY = Math.sin(startAngle);
        ctx.moveTo(unitX * r + x, unitY * r + y);
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    }
});
$210ee3596a85e224$exports = $210ee3596a85e224$var$_default;


$4b57d6b582d579b7$export$6ef80ffb606dd232 = $210ee3596a85e224$exports;
var $a84178d6df259532$exports = {};

// CompoundPath to improve performance
var $a84178d6df259532$var$_default = $b9701a0f23f767de$exports.extend({
    type: "compound",
    shape: {
        paths: null
    },
    _updatePathDirty: function() {
        var dirtyPath = this.__dirtyPath;
        var paths = this.shape.paths;
        for(var i = 0; i < paths.length; i++)// Mark as dirty if any subpath is dirty
        dirtyPath = dirtyPath || paths[i].__dirtyPath;
        this.__dirtyPath = dirtyPath;
        this.__dirty = this.__dirty || dirtyPath;
    },
    beforeBrush: function() {
        this._updatePathDirty();
        var paths = this.shape.paths || [];
        var scale = this.getGlobalScale(); // Update path scale
        for(var i = 0; i < paths.length; i++){
            if (!paths[i].path) paths[i].createPathProxy();
            paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
        }
    },
    buildPath: function(ctx, shape) {
        var paths = shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].buildPath(ctx, paths[i].shape, true);
    },
    afterBrush: function() {
        var paths = this.shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].__dirtyPath = false;
    },
    getBoundingRect: function() {
        this._updatePathDirty();
        return $b9701a0f23f767de$exports.prototype.getBoundingRect.call(this);
    }
});
$a84178d6df259532$exports = $a84178d6df259532$var$_default;


$4b57d6b582d579b7$export$eabfbb332713dc05 = $a84178d6df259532$exports;
var $2b8958ff0f4c4e26$exports = {};

var $256a1ff3f5381b07$exports = {};
/**
 * @param {Array.<Object>} colorStops
 */ var $256a1ff3f5381b07$var$Gradient = function(colorStops) {
    this.colorStops = colorStops || [];
};
$256a1ff3f5381b07$var$Gradient.prototype = {
    constructor: $256a1ff3f5381b07$var$Gradient,
    addColorStop: function(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: color
        });
    }
};
var $256a1ff3f5381b07$var$_default = $256a1ff3f5381b07$var$Gradient;
$256a1ff3f5381b07$exports = $256a1ff3f5381b07$var$_default;


/**
 * x, y, x2, y2 are all percent from 0 to 1
 * @param {number} [x=0]
 * @param {number} [y=0]
 * @param {number} [x2=1]
 * @param {number} [y2=0]
 * @param {Array.<Object>} colorStops
 * @param {boolean} [globalCoord=false]
 */ var $2b8958ff0f4c4e26$var$LinearGradient = function(x, y, x2, y2, colorStops, globalCoord) {
    // Should do nothing more in this constructor. Because gradient can be
    // declard by `color: {type: 'linear', colorStops: ...}`, where
    // this constructor will not be called.
    this.x = x == null ? 0 : x;
    this.y = y == null ? 0 : y;
    this.x2 = x2 == null ? 1 : x2;
    this.y2 = y2 == null ? 0 : y2; // Can be cloned
    this.type = "linear"; // If use global coord
    this.global = globalCoord || false;
    $256a1ff3f5381b07$exports.call(this, colorStops);
};
$2b8958ff0f4c4e26$var$LinearGradient.prototype = {
    constructor: $2b8958ff0f4c4e26$var$LinearGradient
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($2b8958ff0f4c4e26$var$LinearGradient, $256a1ff3f5381b07$exports);
var $2b8958ff0f4c4e26$var$_default = $2b8958ff0f4c4e26$var$LinearGradient;
$2b8958ff0f4c4e26$exports = $2b8958ff0f4c4e26$var$_default;


$4b57d6b582d579b7$export$39a41c7169757633 = $2b8958ff0f4c4e26$exports;
var $1dece1157099f551$exports = {};


/**
 * x, y, r are all percent from 0 to 1
 * @param {number} [x=0.5]
 * @param {number} [y=0.5]
 * @param {number} [r=0.5]
 * @param {Array.<Object>} [colorStops]
 * @param {boolean} [globalCoord=false]
 */ var $1dece1157099f551$var$RadialGradient = function(x, y, r, colorStops, globalCoord) {
    // Should do nothing more in this constructor. Because gradient can be
    // declard by `color: {type: 'radial', colorStops: ...}`, where
    // this constructor will not be called.
    this.x = x == null ? 0.5 : x;
    this.y = y == null ? 0.5 : y;
    this.r = r == null ? 0.5 : r; // Can be cloned
    this.type = "radial"; // If use global coord
    this.global = globalCoord || false;
    $256a1ff3f5381b07$exports.call(this, colorStops);
};
$1dece1157099f551$var$RadialGradient.prototype = {
    constructor: $1dece1157099f551$var$RadialGradient
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($1dece1157099f551$var$RadialGradient, $256a1ff3f5381b07$exports);
var $1dece1157099f551$var$_default = $1dece1157099f551$var$RadialGradient;
$1dece1157099f551$exports = $1dece1157099f551$var$_default;


$4b57d6b582d579b7$export$a02a7a57e5353659 = $1dece1157099f551$exports;

$4b57d6b582d579b7$export$2cf684e818bac055 = $33e4fae744d34798$exports;
var $06c8a3923ade9f4d$exports = {};

var $06c8a3923ade9f4d$var$inherits = $ec279652dd95c27b$export$69f1b2dcda23c5f8;


/**
 * Displayable for incremental rendering. It will be rendered in a separate layer
 * IncrementalDisplay have two main methods. `clearDisplayables` and `addDisplayables`
 * addDisplayables will render the added displayables incremetally.
 *
 * It use a not clearFlag to tell the painter don't clear the layer if it's the first element.
 */ // TODO Style override ?
function $06c8a3923ade9f4d$var$IncrementalDisplayble(opts) {
    $f95b0c44904a541d$exports.call(this, opts);
    this._displayables = [];
    this._temporaryDisplayables = [];
    this._cursor = 0;
    this.notClear = true;
}
$06c8a3923ade9f4d$var$IncrementalDisplayble.prototype.incremental = true;
$06c8a3923ade9f4d$var$IncrementalDisplayble.prototype.clearDisplaybles = function() {
    this._displayables = [];
    this._temporaryDisplayables = [];
    this._cursor = 0;
    this.dirty();
    this.notClear = false;
};
$06c8a3923ade9f4d$var$IncrementalDisplayble.prototype.addDisplayable = function(displayable, notPersistent) {
    if (notPersistent) this._temporaryDisplayables.push(displayable);
    else this._displayables.push(displayable);
    this.dirty();
};
$06c8a3923ade9f4d$var$IncrementalDisplayble.prototype.addDisplayables = function(displayables, notPersistent) {
    notPersistent = notPersistent || false;
    for(var i = 0; i < displayables.length; i++)this.addDisplayable(displayables[i], notPersistent);
};
$06c8a3923ade9f4d$var$IncrementalDisplayble.prototype.eachPendingDisplayable = function(cb) {
    for(var i = this._cursor; i < this._displayables.length; i++)cb && cb(this._displayables[i]);
    for(var i = 0; i < this._temporaryDisplayables.length; i++)cb && cb(this._temporaryDisplayables[i]);
};
$06c8a3923ade9f4d$var$IncrementalDisplayble.prototype.update = function() {
    this.updateTransform();
    for(var i = this._cursor; i < this._displayables.length; i++){
        var displayable = this._displayables[i]; // PENDING
        displayable.parent = this;
        displayable.update();
        displayable.parent = null;
    }
    for(var i = 0; i < this._temporaryDisplayables.length; i++){
        var displayable = this._temporaryDisplayables[i]; // PENDING
        displayable.parent = this;
        displayable.update();
        displayable.parent = null;
    }
};
$06c8a3923ade9f4d$var$IncrementalDisplayble.prototype.brush = function(ctx, prevEl) {
    // Render persistant displayables.
    for(var i = this._cursor; i < this._displayables.length; i++){
        var displayable = this._displayables[i];
        displayable.beforeBrush && displayable.beforeBrush(ctx);
        displayable.brush(ctx, i === this._cursor ? null : this._displayables[i - 1]);
        displayable.afterBrush && displayable.afterBrush(ctx);
    }
    this._cursor = i; // Render temporary displayables.
    for(var i = 0; i < this._temporaryDisplayables.length; i++){
        var displayable = this._temporaryDisplayables[i];
        displayable.beforeBrush && displayable.beforeBrush(ctx);
        displayable.brush(ctx, i === 0 ? null : this._temporaryDisplayables[i - 1]);
        displayable.afterBrush && displayable.afterBrush(ctx);
    }
    this._temporaryDisplayables = [];
    this.notClear = true;
};
var $06c8a3923ade9f4d$var$m = [];
$06c8a3923ade9f4d$var$IncrementalDisplayble.prototype.getBoundingRect = function() {
    if (!this._rect) {
        var rect = new $33e4fae744d34798$exports(Infinity, Infinity, -Infinity, -Infinity);
        for(var i = 0; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            var childRect = displayable.getBoundingRect().clone();
            if (displayable.needLocalTransform()) childRect.applyTransform(displayable.getLocalTransform($06c8a3923ade9f4d$var$m));
            rect.union(childRect);
        }
        this._rect = rect;
    }
    return this._rect;
};
$06c8a3923ade9f4d$var$IncrementalDisplayble.prototype.contain = function(x, y) {
    var localPos = this.transformCoordToLocal(x, y);
    var rect = this.getBoundingRect();
    if (rect.contain(localPos[0], localPos[1])) for(var i = 0; i < this._displayables.length; i++){
        var displayable = this._displayables[i];
        if (displayable.contain(x, y)) return true;
    }
    return false;
};
$06c8a3923ade9f4d$var$inherits($06c8a3923ade9f4d$var$IncrementalDisplayble, $f95b0c44904a541d$exports);
var $06c8a3923ade9f4d$var$_default = $06c8a3923ade9f4d$var$IncrementalDisplayble;
$06c8a3923ade9f4d$exports = $06c8a3923ade9f4d$var$_default;


$4b57d6b582d579b7$export$2a80125dfdd88240 = $06c8a3923ade9f4d$exports;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $4b57d6b582d579b7$var$mathMax = Math.max;
var $4b57d6b582d579b7$var$mathMin = Math.min;
var $4b57d6b582d579b7$var$EMPTY_OBJ = {};
var $4b57d6b582d579b7$var$Z2_EMPHASIS_LIFT = 1; // key: label model property nane, value: style property name.
var $4b57d6b582d579b7$var$CACHED_LABEL_STYLE_PROPERTIES = {
    color: "textFill",
    textBorderColor: "textStroke",
    textBorderWidth: "textStrokeWidth"
};
var $4b57d6b582d579b7$var$EMPHASIS = "emphasis";
var $4b57d6b582d579b7$var$NORMAL = "normal"; // Reserve 0 as default.
var $4b57d6b582d579b7$var$_highlightNextDigit = 1;
var $4b57d6b582d579b7$var$_highlightKeyMap = {};
var $4b57d6b582d579b7$var$_customShapeMap = {};
/**
 * Extend shape with parameters
 */ function $4b57d6b582d579b7$var$extendShape(opts) {
    return $b9701a0f23f767de$exports.extend(opts);
}
/**
 * Extend path
 */ function $4b57d6b582d579b7$var$extendPath(pathData, opts) {
    return $69b77ae5b8565cf7$export$68e3a51ba2ed417c(pathData, opts);
}
/**
 * Register a user defined shape.
 * The shape class can be fetched by `getShapeClass`
 * This method will overwrite the registered shapes, including
 * the registered built-in shapes, if using the same `name`.
 * The shape can be used in `custom series` and
 * `graphic component` by declaring `{type: name}`.
 *
 * @param {string} name
 * @param {Object} ShapeClass Can be generated by `extendShape`.
 */ function $4b57d6b582d579b7$var$registerShape(name, ShapeClass) {
    $4b57d6b582d579b7$var$_customShapeMap[name] = ShapeClass;
}
/**
 * Find shape class registered by `registerShape`. Usually used in
 * fetching user defined shape.
 *
 * [Caution]:
 * (1) This method **MUST NOT be used inside echarts !!!**, unless it is prepared
 * to use user registered shapes.
 * Because the built-in shape (see `getBuiltInShape`) will be registered by
 * `registerShape` by default. That enables users to get both built-in
 * shapes as well as the shapes belonging to themsleves. But users can overwrite
 * the built-in shapes by using names like 'circle', 'rect' via calling
 * `registerShape`. So the echarts inner featrues should not fetch shapes from here
 * in case that it is overwritten by users, except that some features, like
 * `custom series`, `graphic component`, do it deliberately.
 *
 * (2) In the features like `custom series`, `graphic component`, the user input
 * `{tpye: 'xxx'}` does not only specify shapes but also specify other graphic
 * elements like `'group'`, `'text'`, `'image'` or event `'path'`. Those names
 * are reserved names, that is, if some user register a shape named `'image'`,
 * the shape will not be used. If we intending to add some more reserved names
 * in feature, that might bring break changes (disable some existing user shape
 * names). But that case probably rearly happen. So we dont make more mechanism
 * to resolve this issue here.
 *
 * @param {string} name
 * @return {Object} The shape class. If not found, return nothing.
 */ function $4b57d6b582d579b7$var$getShapeClass(name) {
    if ($4b57d6b582d579b7$var$_customShapeMap.hasOwnProperty(name)) return $4b57d6b582d579b7$var$_customShapeMap[name];
}
/**
 * Create a path element from path data string
 * @param {string} pathData
 * @param {Object} opts
 * @param {module:zrender/core/BoundingRect} rect
 * @param {string} [layout=cover] 'center' or 'cover'
 */ function $4b57d6b582d579b7$var$makePath(pathData, opts, rect, layout) {
    var path = $69b77ae5b8565cf7$export$ae5b259626f00aeb(pathData, opts);
    if (rect) {
        if (layout === "center") rect = $4b57d6b582d579b7$var$centerGraphic(rect, path.getBoundingRect());
        $4b57d6b582d579b7$var$resizePath(path, rect);
    }
    return path;
}
/**
 * Create a image element from image url
 * @param {string} imageUrl image url
 * @param {Object} opts options
 * @param {module:zrender/core/BoundingRect} rect constrain rect
 * @param {string} [layout=cover] 'center' or 'cover'
 */ function $4b57d6b582d579b7$var$makeImage(imageUrl, rect, layout) {
    var path = new $8d11db19115b899b$exports({
        style: {
            image: imageUrl,
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        onload: function(img) {
            if (layout === "center") {
                var boundingRect = {
                    width: img.width,
                    height: img.height
                };
                path.setStyle($4b57d6b582d579b7$var$centerGraphic(rect, boundingRect));
            }
        }
    });
    return path;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  {Object} rect         element local bounding box
 * @param  {Object} boundingRect constraint bounding box
 * @return {Object} element position containing x, y, width, and height
 */ function $4b57d6b582d579b7$var$centerGraphic(rect, boundingRect) {
    // Set rect to center, keep width / height ratio.
    var aspect = boundingRect.width / boundingRect.height;
    var width = rect.height * aspect;
    var height;
    if (width <= rect.width) height = rect.height;
    else {
        width = rect.width;
        height = width / aspect;
    }
    var cx = rect.x + rect.width / 2;
    var cy = rect.y + rect.height / 2;
    return {
        x: cx - width / 2,
        y: cy - height / 2,
        width: width,
        height: height
    };
}
var $4b57d6b582d579b7$var$mergePath = $69b77ae5b8565cf7$export$7b1dd269fbc4e903;
/**
 * Resize a path to fit the rect
 * @param {module:zrender/graphic/Path} path
 * @param {Object} rect
 */ function $4b57d6b582d579b7$var$resizePath(path, rect) {
    if (!path.applyTransform) return;
    var pathRect = path.getBoundingRect();
    var m = pathRect.calculateTransform(rect);
    path.applyTransform(m);
}
/**
 * Sub pixel optimize line for canvas
 *
 * @param {Object} param
 * @param {Object} [param.shape]
 * @param {number} [param.shape.x1]
 * @param {number} [param.shape.y1]
 * @param {number} [param.shape.x2]
 * @param {number} [param.shape.y2]
 * @param {Object} [param.style]
 * @param {number} [param.style.lineWidth]
 * @return {Object} Modified param
 */ function $4b57d6b582d579b7$var$subPixelOptimizeLine(param) {
    $6aaf7d9f056a9deb$export$8b4b620d7f4aad1b(param.shape, param.shape, param.style);
    return param;
}
/**
 * Sub pixel optimize rect for canvas
 *
 * @param {Object} param
 * @param {Object} [param.shape]
 * @param {number} [param.shape.x]
 * @param {number} [param.shape.y]
 * @param {number} [param.shape.width]
 * @param {number} [param.shape.height]
 * @param {Object} [param.style]
 * @param {number} [param.style.lineWidth]
 * @return {Object} Modified param
 */ function $4b57d6b582d579b7$var$subPixelOptimizeRect(param) {
    $6aaf7d9f056a9deb$export$60e2aa74957d0b9d(param.shape, param.shape, param.style);
    return param;
}
/**
 * Sub pixel optimize for canvas
 *
 * @param {number} position Coordinate, such as x, y
 * @param {number} lineWidth Should be nonnegative integer.
 * @param {boolean=} positiveOrNegative Default false (negative).
 * @return {number} Optimized position.
 */ var $4b57d6b582d579b7$var$subPixelOptimize = $6aaf7d9f056a9deb$export$72c4fd4c1b8fcb10;
function $4b57d6b582d579b7$var$hasFillOrStroke(fillOrStroke) {
    return fillOrStroke != null && fillOrStroke !== "none";
} // Most lifted color are duplicated.
var $4b57d6b582d579b7$var$liftedColorMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4();
var $4b57d6b582d579b7$var$liftedColorCount = 0;
function $4b57d6b582d579b7$var$liftColor(color) {
    if (typeof color !== "string") return color;
    var liftedColor = $4b57d6b582d579b7$var$liftedColorMap.get(color);
    if (!liftedColor) {
        liftedColor = $b1179c91b052e827$export$590e8b2c435046d9(color, -0.1);
        if ($4b57d6b582d579b7$var$liftedColorCount < 10000) {
            $4b57d6b582d579b7$var$liftedColorMap.set(color, liftedColor);
            $4b57d6b582d579b7$var$liftedColorCount++;
        }
    }
    return liftedColor;
}
function $4b57d6b582d579b7$var$cacheElementStl(el) {
    if (!el.__hoverStlDirty) return;
    el.__hoverStlDirty = false;
    var hoverStyle = el.__hoverStl;
    if (!hoverStyle) {
        el.__cachedNormalStl = el.__cachedNormalZ2 = null;
        return;
    }
    var normalStyle = el.__cachedNormalStl = {};
    el.__cachedNormalZ2 = el.z2;
    var elStyle = el.style;
    for(var name in hoverStyle)// See comment in `singleEnterEmphasis`.
    if (hoverStyle[name] != null) normalStyle[name] = elStyle[name];
     // Always cache fill and stroke to normalStyle for lifting color.
    normalStyle.fill = elStyle.fill;
    normalStyle.stroke = elStyle.stroke;
}
function $4b57d6b582d579b7$var$singleEnterEmphasis(el) {
    var hoverStl = el.__hoverStl;
    if (!hoverStl || el.__highlighted) return;
    var zr = el.__zr;
    var useHoverLayer = el.useHoverLayer && zr && zr.painter.type === "canvas";
    el.__highlighted = useHoverLayer ? "layer" : "plain";
    if (el.isGroup || !zr && el.useHoverLayer) return;
    var elTarget = el;
    var targetStyle = el.style;
    if (useHoverLayer) {
        elTarget = zr.addHover(el);
        targetStyle = elTarget.style;
    }
    $4b57d6b582d579b7$var$rollbackDefaultTextStyle(targetStyle);
    if (!useHoverLayer) $4b57d6b582d579b7$var$cacheElementStl(elTarget);
     // styles can be:
    // {
    //    label: {
    //        show: false,
    //        position: 'outside',
    //        fontSize: 18
    //    },
    //    emphasis: {
    //        label: {
    //            show: true
    //        }
    //    }
    // },
    // where properties of `emphasis` may not appear in `normal`. We previously use
    // module:echarts/util/model#defaultEmphasis to merge `normal` to `emphasis`.
    // But consider rich text and setOption in merge mode, it is impossible to cover
    // all properties in merge. So we use merge mode when setting style here.
    // But we choose the merge strategy that only properties that is not `null/undefined`.
    // Because when making a textStyle (espacially rich text), it is not easy to distinguish
    // `hasOwnProperty` and `null/undefined` in code, so we trade them as the same for simplicity.
    // But this strategy brings a trouble that `null/undefined` can not be used to remove
    // style any more in `emphasis`. Users can both set properties directly on normal and
    // emphasis to avoid this issue, or we might support `'none'` for this case if required.
    targetStyle.extendFrom(hoverStl);
    $4b57d6b582d579b7$var$setDefaultHoverFillStroke(targetStyle, hoverStl, "fill");
    $4b57d6b582d579b7$var$setDefaultHoverFillStroke(targetStyle, hoverStl, "stroke");
    $4b57d6b582d579b7$var$applyDefaultTextStyle(targetStyle);
    if (!useHoverLayer) {
        el.dirty(false);
        el.z2 += $4b57d6b582d579b7$var$Z2_EMPHASIS_LIFT;
    }
}
function $4b57d6b582d579b7$var$setDefaultHoverFillStroke(targetStyle, hoverStyle, prop) {
    if (!$4b57d6b582d579b7$var$hasFillOrStroke(hoverStyle[prop]) && $4b57d6b582d579b7$var$hasFillOrStroke(targetStyle[prop])) targetStyle[prop] = $4b57d6b582d579b7$var$liftColor(targetStyle[prop]);
}
function $4b57d6b582d579b7$var$singleEnterNormal(el) {
    var highlighted = el.__highlighted;
    if (!highlighted) return;
    el.__highlighted = false;
    if (el.isGroup) return;
    if (highlighted === "layer") el.__zr && el.__zr.removeHover(el);
    else {
        var style = el.style;
        var normalStl = el.__cachedNormalStl;
        if (normalStl) {
            $4b57d6b582d579b7$var$rollbackDefaultTextStyle(style);
            el.setStyle(normalStl);
            $4b57d6b582d579b7$var$applyDefaultTextStyle(style);
        } // `__cachedNormalZ2` will not be reset if calling `setElementHoverStyle`
        // when `el` is on emphasis state. So here by comparing with 1, we try
        // hard to make the bug case rare.
        var normalZ2 = el.__cachedNormalZ2;
        if (normalZ2 != null && el.z2 - normalZ2 === $4b57d6b582d579b7$var$Z2_EMPHASIS_LIFT) el.z2 = normalZ2;
    }
}
function $4b57d6b582d579b7$var$traverseUpdate(el, updater, commonParam) {
    // If root is group, also enter updater for `highDownOnUpdate`.
    var fromState = $4b57d6b582d579b7$var$NORMAL;
    var toState = $4b57d6b582d579b7$var$NORMAL;
    var trigger; // See the rule of `highDownOnUpdate` on `graphic.setAsHighDownDispatcher`.
    el.__highlighted && (fromState = $4b57d6b582d579b7$var$EMPHASIS, trigger = true);
    updater(el, commonParam);
    el.__highlighted && (toState = $4b57d6b582d579b7$var$EMPHASIS, trigger = true);
    el.isGroup && el.traverse(function(child) {
        !child.isGroup && updater(child, commonParam);
    });
    trigger && el.__highDownOnUpdate && el.__highDownOnUpdate(fromState, toState);
}
/**
 * Set hover style (namely "emphasis style") of element, based on the current
 * style of the given `el`.
 * This method should be called after all of the normal styles have been adopted
 * to the `el`. See the reason on `setHoverStyle`.
 *
 * @param {module:zrender/Element} el Should not be `zrender/container/Group`.
 * @param {Object} [el.hoverStyle] Can be set on el or its descendants,
 *        e.g., `el.hoverStyle = ...; graphic.setHoverStyle(el); `.
 *        Often used when item group has a label element and it's hoverStyle is different.
 * @param {Object|boolean} [hoverStl] The specified hover style.
 *        If set as `false`, disable the hover style.
 *        Similarly, The `el.hoverStyle` can alse be set
 *        as `false` to disable the hover style.
 *        Otherwise, use the default hover style if not provided.
 */ function $4b57d6b582d579b7$var$setElementHoverStyle(el, hoverStl) {
    // For performance consideration, it might be better to make the "hover style" only the
    // difference properties from the "normal style", but not a entire copy of all styles.
    hoverStl = el.__hoverStl = hoverStl !== false && (el.hoverStyle || hoverStl || {});
    el.__hoverStlDirty = true; // FIXME
    // It is not completely right to save "normal"/"emphasis" flag on elements.
    // It probably should be saved on `data` of series. Consider the cases:
    // (1) A highlighted elements are moved out of the view port and re-enter
    // again by dataZoom.
    // (2) call `setOption` and replace elements totally when they are highlighted.
    if (el.__highlighted) {
        // Consider the case:
        // The styles of a highlighted `el` is being updated. The new "emphasis style"
        // should be adapted to the `el`. Notice here new "normal styles" should have
        // been set outside and the cached "normal style" is out of date.
        el.__cachedNormalStl = null; // Do not clear `__cachedNormalZ2` here, because setting `z2` is not a constraint
        // of this method. In most cases, `z2` is not set and hover style should be able
        // to rollback. Of course, that would bring bug, but only in a rare case, see
        // `doSingleLeaveHover` for details.
        $4b57d6b582d579b7$var$singleEnterNormal(el);
        $4b57d6b582d579b7$var$singleEnterEmphasis(el);
    }
}
function $4b57d6b582d579b7$var$onElementMouseOver(e) {
    !$4b57d6b582d579b7$var$shouldSilent(this, e) // "emphasis" event highlight has higher priority than mouse highlight.
     && !this.__highByOuter && $4b57d6b582d579b7$var$traverseUpdate(this, $4b57d6b582d579b7$var$singleEnterEmphasis);
}
function $4b57d6b582d579b7$var$onElementMouseOut(e) {
    !$4b57d6b582d579b7$var$shouldSilent(this, e) // "emphasis" event highlight has higher priority than mouse highlight.
     && !this.__highByOuter && $4b57d6b582d579b7$var$traverseUpdate(this, $4b57d6b582d579b7$var$singleEnterNormal);
}
function $4b57d6b582d579b7$var$onElementEmphasisEvent(highlightDigit) {
    this.__highByOuter |= 1 << (highlightDigit || 0);
    $4b57d6b582d579b7$var$traverseUpdate(this, $4b57d6b582d579b7$var$singleEnterEmphasis);
}
function $4b57d6b582d579b7$var$onElementNormalEvent(highlightDigit) {
    !(this.__highByOuter &= ~(1 << (highlightDigit || 0))) && $4b57d6b582d579b7$var$traverseUpdate(this, $4b57d6b582d579b7$var$singleEnterNormal);
}
function $4b57d6b582d579b7$var$shouldSilent(el, e) {
    return el.__highDownSilentOnTouch && e.zrByTouch;
}
/**
 * Set hover style (namely "emphasis style") of element,
 * based on the current style of the given `el`.
 *
 * (1)
 * **CONSTRAINTS** for this method:
 * <A> This method MUST be called after all of the normal styles having been adopted
 * to the `el`.
 * <B> The input `hoverStyle` (that is, "emphasis style") MUST be the subset of the
 * "normal style" having been set to the el.
 * <C> `color` MUST be one of the "normal styles" (because color might be lifted as
 * a default hover style).
 *
 * The reason: this method treat the current style of the `el` as the "normal style"
 * and cache them when enter/update the "emphasis style". Consider the case: the `el`
 * is in "emphasis" state and `setOption`/`dispatchAction` trigger the style updating
 * logic, where the el should shift from the original emphasis style to the new
 * "emphasis style" and should be able to "downplay" back to the new "normal style".
 *
 * Indeed, it is error-prone to make a interface has so many constraints, but I have
 * not found a better solution yet to fit the backward compatibility, performance and
 * the current programming style.
 *
 * (2)
 * Call the method for a "root" element once. Do not call it for each descendants.
 * If the descendants elemenets of a group has itself hover style different from the
 * root group, we can simply mount the style on `el.hoverStyle` for them, but should
 * not call this method for them.
 *
 * (3) These input parameters can be set directly on `el`:
 *
 * @param {module:zrender/Element} el
 * @param {Object} [el.hoverStyle] See `graphic.setElementHoverStyle`.
 * @param {boolean} [el.highDownSilentOnTouch=false] See `graphic.setAsHighDownDispatcher`.
 * @param {Function} [el.highDownOnUpdate] See `graphic.setAsHighDownDispatcher`.
 * @param {Object|boolean} [hoverStyle] See `graphic.setElementHoverStyle`.
 */ function $4b57d6b582d579b7$var$setHoverStyle(el, hoverStyle) {
    $4b57d6b582d579b7$var$setAsHighDownDispatcher(el, true);
    $4b57d6b582d579b7$var$traverseUpdate(el, $4b57d6b582d579b7$var$setElementHoverStyle, hoverStyle);
}
/**
 * @param {module:zrender/Element} el
 * @param {Function} [el.highDownOnUpdate] Called when state updated.
 *        Since `setHoverStyle` has the constraint that it must be called after
 *        all of the normal style updated, `highDownOnUpdate` is not needed to
 *        trigger if both `fromState` and `toState` is 'normal', and needed to
 *        trigger if both `fromState` and `toState` is 'emphasis', which enables
 *        to sync outside style settings to "emphasis" state.
 *        @this {string} This dispatcher `el`.
 *        @param {string} fromState Can be "normal" or "emphasis".
 *               `fromState` might equal to `toState`,
 *               for example, when this method is called when `el` is
 *               on "emphasis" state.
 *        @param {string} toState Can be "normal" or "emphasis".
 *
 *        FIXME
 *        CAUTION: Do not expose `highDownOnUpdate` outside echarts.
 *        Because it is not a complete solution. The update
 *        listener should not have been mount in element,
 *        and the normal/emphasis state should not have
 *        mantained on elements.
 *
 * @param {boolean} [el.highDownSilentOnTouch=false]
 *        In touch device, mouseover event will be trigger on touchstart event
 *        (see module:zrender/dom/HandlerProxy). By this mechanism, we can
 *        conveniently use hoverStyle when tap on touch screen without additional
 *        code for compatibility.
 *        But if the chart/component has select feature, which usually also use
 *        hoverStyle, there might be conflict between 'select-highlight' and
 *        'hover-highlight' especially when roam is enabled (see geo for example).
 *        In this case, `highDownSilentOnTouch` should be used to disable
 *        hover-highlight on touch device.
 * @param {boolean} [asDispatcher=true] If `false`, do not set as "highDownDispatcher".
 */ function $4b57d6b582d579b7$var$setAsHighDownDispatcher(el, asDispatcher) {
    var disable = asDispatcher === false; // Make `highDownSilentOnTouch` and `highDownOnUpdate` only work after
    // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
    el.__highDownSilentOnTouch = el.highDownSilentOnTouch;
    el.__highDownOnUpdate = el.highDownOnUpdate; // Simple optimize, since this method might be
    // called for each elements of a group in some cases.
    if (!disable || el.__highDownDispatcher) {
        var method = disable ? "off" : "on"; // Duplicated function will be auto-ignored, see Eventful.js.
        el[method]("mouseover", $4b57d6b582d579b7$var$onElementMouseOver)[method]("mouseout", $4b57d6b582d579b7$var$onElementMouseOut); // Emphasis, normal can be triggered manually by API or other components like hover link.
        el[method]("emphasis", $4b57d6b582d579b7$var$onElementEmphasisEvent)[method]("normal", $4b57d6b582d579b7$var$onElementNormalEvent); // Also keep previous record.
        el.__highByOuter = el.__highByOuter || 0;
        el.__highDownDispatcher = !disable;
    }
}
/**
 * @param {module:zrender/src/Element} el
 * @return {boolean}
 */ function $4b57d6b582d579b7$var$isHighDownDispatcher(el) {
    return !!(el && el.__highDownDispatcher);
}
/**
 * Support hightlight/downplay record on each elements.
 * For the case: hover highlight/downplay (legend, visualMap, ...) and
 * user triggerred hightlight/downplay should not conflict.
 * Only all of the highlightDigit cleared, return to normal.
 * @param {string} highlightKey
 * @return {number} highlightDigit
 */ function $4b57d6b582d579b7$var$getHighlightDigit(highlightKey) {
    var highlightDigit = $4b57d6b582d579b7$var$_highlightKeyMap[highlightKey];
    if (highlightDigit == null && $4b57d6b582d579b7$var$_highlightNextDigit <= 32) highlightDigit = $4b57d6b582d579b7$var$_highlightKeyMap[highlightKey] = $4b57d6b582d579b7$var$_highlightNextDigit++;
    return highlightDigit;
}
/**
 * See more info in `setTextStyleCommon`.
 * @param {Object|module:zrender/graphic/Style} normalStyle
 * @param {Object} emphasisStyle
 * @param {module:echarts/model/Model} normalModel
 * @param {module:echarts/model/Model} emphasisModel
 * @param {Object} opt Check `opt` of `setTextStyleCommon` to find other props.
 * @param {string|Function} [opt.defaultText]
 * @param {module:echarts/model/Model} [opt.labelFetcher] Fetch text by
 *      `opt.labelFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
 * @param {number} [opt.labelDataIndex] Fetch text by
 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
 * @param {number} [opt.labelDimIndex] Fetch text by
 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
 * @param {string} [opt.labelProp] Fetch text by
 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
 * @param {Object} [normalSpecified]
 * @param {Object} [emphasisSpecified]
 */ function $4b57d6b582d579b7$var$setLabelStyle(normalStyle, emphasisStyle, normalModel, emphasisModel, opt, normalSpecified, emphasisSpecified) {
    opt = opt || $4b57d6b582d579b7$var$EMPTY_OBJ;
    var labelFetcher = opt.labelFetcher;
    var labelDataIndex = opt.labelDataIndex;
    var labelDimIndex = opt.labelDimIndex;
    var labelProp = opt.labelProp; // This scenario, `label.normal.show = true; label.emphasis.show = false`,
    // is not supported util someone requests.
    var showNormal = normalModel.getShallow("show");
    var showEmphasis = emphasisModel.getShallow("show"); // Consider performance, only fetch label when necessary.
    // If `normal.show` is `false` and `emphasis.show` is `true` and `emphasis.formatter` is not set,
    // label should be displayed, where text is fetched by `normal.formatter` or `opt.defaultText`.
    var baseText;
    if (showNormal || showEmphasis) {
        if (labelFetcher) baseText = labelFetcher.getFormattedLabel(labelDataIndex, "normal", null, labelDimIndex, labelProp);
        if (baseText == null) baseText = $ec279652dd95c27b$export$f6e2535fb5126e54(opt.defaultText) ? opt.defaultText(labelDataIndex, opt) : opt.defaultText;
    }
    var normalStyleText = showNormal ? baseText : null;
    var emphasisStyleText = showEmphasis ? $ec279652dd95c27b$export$995e01f2f5c9d030(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, "emphasis", null, labelDimIndex, labelProp) : null, baseText) : null; // Optimize: If style.text is null, text will not be drawn.
    if (normalStyleText != null || emphasisStyleText != null) {
        // Always set `textStyle` even if `normalStyle.text` is null, because default
        // values have to be set on `normalStyle`.
        // If we set default values on `emphasisStyle`, consider case:
        // Firstly, `setOption(... label: {normal: {text: null}, emphasis: {show: true}} ...);`
        // Secondly, `setOption(... label: {noraml: {show: true, text: 'abc', color: 'red'} ...);`
        // Then the 'red' will not work on emphasis.
        $4b57d6b582d579b7$var$setTextStyle(normalStyle, normalModel, normalSpecified, opt);
        $4b57d6b582d579b7$var$setTextStyle(emphasisStyle, emphasisModel, emphasisSpecified, opt, true);
    }
    normalStyle.text = normalStyleText;
    emphasisStyle.text = emphasisStyleText;
}
/**
 * Modify label style manually.
 * Only works after `setLabelStyle` and `setElementHoverStyle` called.
 *
 * @param {module:zrender/src/Element} el
 * @param {Object} [normalStyleProps] optional
 * @param {Object} [emphasisStyleProps] optional
 */ function $4b57d6b582d579b7$var$modifyLabelStyle(el, normalStyleProps, emphasisStyleProps) {
    var elStyle = el.style;
    if (normalStyleProps) {
        $4b57d6b582d579b7$var$rollbackDefaultTextStyle(elStyle);
        el.setStyle(normalStyleProps);
        $4b57d6b582d579b7$var$applyDefaultTextStyle(elStyle);
    }
    elStyle = el.__hoverStl;
    if (emphasisStyleProps && elStyle) {
        $4b57d6b582d579b7$var$rollbackDefaultTextStyle(elStyle);
        $ec279652dd95c27b$export$8b58be045bf06082(elStyle, emphasisStyleProps);
        $4b57d6b582d579b7$var$applyDefaultTextStyle(elStyle);
    }
}
/**
 * Set basic textStyle properties.
 * See more info in `setTextStyleCommon`.
 * @param {Object|module:zrender/graphic/Style} textStyle
 * @param {module:echarts/model/Model} model
 * @param {Object} [specifiedTextStyle] Can be overrided by settings in model.
 * @param {Object} [opt] See `opt` of `setTextStyleCommon`.
 * @param {boolean} [isEmphasis]
 */ function $4b57d6b582d579b7$var$setTextStyle(textStyle, textStyleModel, specifiedTextStyle, opt, isEmphasis) {
    $4b57d6b582d579b7$var$setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis);
    specifiedTextStyle && $ec279652dd95c27b$export$8b58be045bf06082(textStyle, specifiedTextStyle); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
    return textStyle;
}
/**
 * Set text option in the style.
 * See more info in `setTextStyleCommon`.
 * @deprecated
 * @param {Object} textStyle
 * @param {module:echarts/model/Model} labelModel
 * @param {string|boolean} defaultColor Default text color.
 *        If set as false, it will be processed as a emphasis style.
 */ function $4b57d6b582d579b7$var$setText(textStyle, labelModel, defaultColor) {
    var opt = {
        isRectText: true
    };
    var isEmphasis;
    if (defaultColor === false) isEmphasis = true;
    else // Support setting color as 'auto' to get visual color.
    opt.autoColor = defaultColor;
    $4b57d6b582d579b7$var$setTextStyleCommon(textStyle, labelModel, opt, isEmphasis); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
}
/**
 * The uniform entry of set text style, that is, retrieve style definitions
 * from `model` and set to `textStyle` object.
 *
 * Never in merge mode, but in overwrite mode, that is, all of the text style
 * properties will be set. (Consider the states of normal and emphasis and
 * default value can be adopted, merge would make the logic too complicated
 * to manage.)
 *
 * The `textStyle` object can either be a plain object or an instance of
 * `zrender/src/graphic/Style`, and either be the style of normal or emphasis.
 * After this mothod called, the `textStyle` object can then be used in
 * `el.setStyle(textStyle)` or `el.hoverStyle = textStyle`.
 *
 * Default value will be adopted and `insideRollbackOpt` will be created.
 * See `applyDefaultTextStyle` `rollbackDefaultTextStyle` for more details.
 *
 * opt: {
 *      disableBox: boolean, Whether diable drawing box of block (outer most).
 *      isRectText: boolean,
 *      autoColor: string, specify a color when color is 'auto',
 *              for textFill, textStroke, textBackgroundColor, and textBorderColor.
 *              If autoColor specified, it is used as default textFill.
 *      useInsideStyle:
 *              `true`: Use inside style (textFill, textStroke, textStrokeWidth)
 *                  if `textFill` is not specified.
 *              `false`: Do not use inside style.
 *              `null/undefined`: use inside style if `isRectText` is true and
 *                  `textFill` is not specified and textPosition contains `'inside'`.
 *      forceRich: boolean
 * }
 */ function $4b57d6b582d579b7$var$setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis) {
    // Consider there will be abnormal when merge hover style to normal style if given default value.
    opt = opt || $4b57d6b582d579b7$var$EMPTY_OBJ;
    if (opt.isRectText) {
        var textPosition;
        if (opt.getTextPosition) textPosition = opt.getTextPosition(textStyleModel, isEmphasis);
        else {
            textPosition = textStyleModel.getShallow("position") || (isEmphasis ? null : "inside"); // 'outside' is not a valid zr textPostion value, but used
            // in bar series, and magric type should be considered.
            textPosition === "outside" && (textPosition = "top");
        }
        textStyle.textPosition = textPosition;
        textStyle.textOffset = textStyleModel.getShallow("offset");
        var labelRotate = textStyleModel.getShallow("rotate");
        labelRotate != null && (labelRotate *= Math.PI / 180);
        textStyle.textRotation = labelRotate;
        textStyle.textDistance = $ec279652dd95c27b$export$995e01f2f5c9d030(textStyleModel.getShallow("distance"), isEmphasis ? null : 5);
    }
    var ecModel = textStyleModel.ecModel;
    var globalTextStyle = ecModel && ecModel.option.textStyle; // Consider case:
    // {
    //     data: [{
    //         value: 12,
    //         label: {
    //             rich: {
    //                 // no 'a' here but using parent 'a'.
    //             }
    //         }
    //     }],
    //     rich: {
    //         a: { ... }
    //     }
    // }
    var richItemNames = $4b57d6b582d579b7$var$getRichItemNames(textStyleModel);
    var richResult;
    if (richItemNames) {
        richResult = {};
        for(var name in richItemNames)if (richItemNames.hasOwnProperty(name)) {
            // Cascade is supported in rich.
            var richTextStyle = textStyleModel.getModel([
                "rich",
                name
            ]); // In rich, never `disableBox`.
            // FIXME: consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
            // the default color `'blue'` will not be adopted if no color declared in `rich`.
            // That might confuses users. So probably we should put `textStyleModel` as the
            // root ancestor of the `richTextStyle`. But that would be a break change.
            $4b57d6b582d579b7$var$setTokenTextStyle(richResult[name] = {}, richTextStyle, globalTextStyle, opt, isEmphasis);
        }
    }
    textStyle.rich = richResult;
    $4b57d6b582d579b7$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, true);
    if (opt.forceRich && !opt.textStyle) opt.textStyle = {};
    return textStyle;
} // Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }
function $4b57d6b582d579b7$var$getRichItemNames(textStyleModel) {
    // Use object to remove duplicated names.
    var richItemNameMap;
    while(textStyleModel && textStyleModel !== textStyleModel.ecModel){
        var rich = (textStyleModel.option || $4b57d6b582d579b7$var$EMPTY_OBJ).rich;
        if (rich) {
            richItemNameMap = richItemNameMap || {};
            for(var name in rich)if (rich.hasOwnProperty(name)) richItemNameMap[name] = 1;
        }
        textStyleModel = textStyleModel.parentModel;
    }
    return richItemNameMap;
}
function $4b57d6b582d579b7$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, isBlock) {
    // In merge mode, default value should not be given.
    globalTextStyle = !isEmphasis && globalTextStyle || $4b57d6b582d579b7$var$EMPTY_OBJ;
    textStyle.textFill = $4b57d6b582d579b7$var$getAutoColor(textStyleModel.getShallow("color"), opt) || globalTextStyle.color;
    textStyle.textStroke = $4b57d6b582d579b7$var$getAutoColor(textStyleModel.getShallow("textBorderColor"), opt) || globalTextStyle.textBorderColor;
    textStyle.textStrokeWidth = $ec279652dd95c27b$export$995e01f2f5c9d030(textStyleModel.getShallow("textBorderWidth"), globalTextStyle.textBorderWidth);
    if (!isEmphasis) {
        if (isBlock) {
            textStyle.insideRollbackOpt = opt;
            $4b57d6b582d579b7$var$applyDefaultTextStyle(textStyle);
        } // Set default finally.
        if (textStyle.textFill == null) textStyle.textFill = opt.autoColor;
    } // Do not use `getFont` here, because merge should be supported, where
    // part of these properties may be changed in emphasis style, and the
    // others should remain their original value got from normal style.
    textStyle.fontStyle = textStyleModel.getShallow("fontStyle") || globalTextStyle.fontStyle;
    textStyle.fontWeight = textStyleModel.getShallow("fontWeight") || globalTextStyle.fontWeight;
    textStyle.fontSize = textStyleModel.getShallow("fontSize") || globalTextStyle.fontSize;
    textStyle.fontFamily = textStyleModel.getShallow("fontFamily") || globalTextStyle.fontFamily;
    textStyle.textAlign = textStyleModel.getShallow("align");
    textStyle.textVerticalAlign = textStyleModel.getShallow("verticalAlign") || textStyleModel.getShallow("baseline");
    textStyle.textLineHeight = textStyleModel.getShallow("lineHeight");
    textStyle.textWidth = textStyleModel.getShallow("width");
    textStyle.textHeight = textStyleModel.getShallow("height");
    textStyle.textTag = textStyleModel.getShallow("tag");
    if (!isBlock || !opt.disableBox) {
        textStyle.textBackgroundColor = $4b57d6b582d579b7$var$getAutoColor(textStyleModel.getShallow("backgroundColor"), opt);
        textStyle.textPadding = textStyleModel.getShallow("padding");
        textStyle.textBorderColor = $4b57d6b582d579b7$var$getAutoColor(textStyleModel.getShallow("borderColor"), opt);
        textStyle.textBorderWidth = textStyleModel.getShallow("borderWidth");
        textStyle.textBorderRadius = textStyleModel.getShallow("borderRadius");
        textStyle.textBoxShadowColor = textStyleModel.getShallow("shadowColor");
        textStyle.textBoxShadowBlur = textStyleModel.getShallow("shadowBlur");
        textStyle.textBoxShadowOffsetX = textStyleModel.getShallow("shadowOffsetX");
        textStyle.textBoxShadowOffsetY = textStyleModel.getShallow("shadowOffsetY");
    }
    textStyle.textShadowColor = textStyleModel.getShallow("textShadowColor") || globalTextStyle.textShadowColor;
    textStyle.textShadowBlur = textStyleModel.getShallow("textShadowBlur") || globalTextStyle.textShadowBlur;
    textStyle.textShadowOffsetX = textStyleModel.getShallow("textShadowOffsetX") || globalTextStyle.textShadowOffsetX;
    textStyle.textShadowOffsetY = textStyleModel.getShallow("textShadowOffsetY") || globalTextStyle.textShadowOffsetY;
}
function $4b57d6b582d579b7$var$getAutoColor(color, opt) {
    return color !== "auto" ? color : opt && opt.autoColor ? opt.autoColor : null;
}
/**
 * Give some default value to the input `textStyle` object, based on the current settings
 * in this `textStyle` object.
 *
 * The Scenario:
 * when text position is `inside` and `textFill` is not specified, we show
 * text border by default for better view. But it should be considered that text position
 * might be changed when hovering or being emphasis, where the `insideRollback` is used to
 * restore the style.
 *
 * Usage (& NOTICE):
 * When a style object (eithor plain object or instance of `zrender/src/graphic/Style`) is
 * about to be modified on its text related properties, `rollbackDefaultTextStyle` should
 * be called before the modification and `applyDefaultTextStyle` should be called after that.
 * (For the case that all of the text related properties is reset, like `setTextStyleCommon`
 * does, `rollbackDefaultTextStyle` is not needed to be called).
 */ function $4b57d6b582d579b7$var$applyDefaultTextStyle(textStyle) {
    var textPosition = textStyle.textPosition;
    var opt = textStyle.insideRollbackOpt;
    var insideRollback;
    if (opt && textStyle.textFill == null) {
        var autoColor = opt.autoColor;
        var isRectText = opt.isRectText;
        var useInsideStyle = opt.useInsideStyle;
        var useInsideStyleCache = useInsideStyle !== false && (useInsideStyle === true || isRectText && textPosition // textPosition can be [10, 30]
         && typeof textPosition === "string" && textPosition.indexOf("inside") >= 0);
        var useAutoColorCache = !useInsideStyleCache && autoColor != null; // All of the props declared in `CACHED_LABEL_STYLE_PROPERTIES` are to be cached.
        if (useInsideStyleCache || useAutoColorCache) insideRollback = {
            textFill: textStyle.textFill,
            textStroke: textStyle.textStroke,
            textStrokeWidth: textStyle.textStrokeWidth
        };
        if (useInsideStyleCache) {
            textStyle.textFill = "#fff"; // Consider text with #fff overflow its container.
            if (textStyle.textStroke == null) {
                textStyle.textStroke = autoColor;
                textStyle.textStrokeWidth == null && (textStyle.textStrokeWidth = 2);
            }
        }
        if (useAutoColorCache) textStyle.textFill = autoColor;
    } // Always set `insideRollback`, so that the previous one can be cleared.
    textStyle.insideRollback = insideRollback;
}
/**
 * Consider the case: in a scatter,
 * label: {
 *     normal: {position: 'inside'},
 *     emphasis: {position: 'top'}
 * }
 * In the normal state, the `textFill` will be set as '#fff' for pretty view (see
 * `applyDefaultTextStyle`), but when switching to emphasis state, the `textFill`
 * should be retured to 'autoColor', but not keep '#fff'.
 */ function $4b57d6b582d579b7$var$rollbackDefaultTextStyle(style) {
    var insideRollback = style.insideRollback;
    if (insideRollback) {
        // Reset all of the props in `CACHED_LABEL_STYLE_PROPERTIES`.
        style.textFill = insideRollback.textFill;
        style.textStroke = insideRollback.textStroke;
        style.textStrokeWidth = insideRollback.textStrokeWidth;
        style.insideRollback = null;
    }
}
function $4b57d6b582d579b7$var$getFont(opt, ecModel) {
    var gTextStyleModel = ecModel && ecModel.getModel("textStyle");
    return $ec279652dd95c27b$export$87c2784dc9fc4ab([
        opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow("fontStyle") || "",
        opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow("fontWeight") || "",
        (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow("fontSize") || 12) + "px",
        opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow("fontFamily") || "sans-serif"
    ].join(" "));
}
function $4b57d6b582d579b7$var$animateOrSetProps(isUpdate, el, props, animatableModel, dataIndex, cb) {
    if (typeof dataIndex === "function") {
        cb = dataIndex;
        dataIndex = null;
    } // Do not check 'animation' property directly here. Consider this case:
    // animation model is an `itemModel`, whose does not have `isAnimationEnabled`
    // but its parent model (`seriesModel`) does.
    var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
    if (animationEnabled) {
        var postfix = isUpdate ? "Update" : "";
        var duration = animatableModel.getShallow("animationDuration" + postfix);
        var animationEasing = animatableModel.getShallow("animationEasing" + postfix);
        var animationDelay = animatableModel.getShallow("animationDelay" + postfix);
        if (typeof animationDelay === "function") animationDelay = animationDelay(dataIndex, animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
        if (typeof duration === "function") duration = duration(dataIndex);
        duration > 0 ? el.animateTo(props, duration, animationDelay || 0, animationEasing, cb, !!cb) : (el.stopAnimation(), el.attr(props), cb && cb());
    } else {
        el.stopAnimation();
        el.attr(props);
        cb && cb();
    }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 *
 * @param {module:zrender/Element} el
 * @param {Object} props
 * @param {module:echarts/model/Model} [animatableModel]
 * @param {number} [dataIndex]
 * @param {Function} [cb]
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */ function $4b57d6b582d579b7$var$updateProps(el, props, animatableModel, dataIndex, cb) {
    $4b57d6b582d579b7$var$animateOrSetProps(true, el, props, animatableModel, dataIndex, cb);
}
/**
 * Init graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 *
 * @param {module:zrender/Element} el
 * @param {Object} props
 * @param {module:echarts/model/Model} [animatableModel]
 * @param {number} [dataIndex]
 * @param {Function} cb
 */ function $4b57d6b582d579b7$var$initProps(el, props, animatableModel, dataIndex, cb) {
    $4b57d6b582d579b7$var$animateOrSetProps(false, el, props, animatableModel, dataIndex, cb);
}
/**
 * Get transform matrix of target (param target),
 * in coordinate of its ancestor (param ancestor)
 *
 * @param {module:zrender/mixin/Transformable} target
 * @param {module:zrender/mixin/Transformable} [ancestor]
 */ function $4b57d6b582d579b7$var$getTransform(target, ancestor) {
    var mat = $6c6dd9610ba660f0$export$f0954fd7d5368655([]);
    while(target && target !== ancestor){
        $6c6dd9610ba660f0$export$6e3a27864ab166fe(mat, target.getLocalTransform(), mat);
        target = target.parent;
    }
    return mat;
}
/**
 * Apply transform to an vertex.
 * @param {Array.<number>} target [x, y]
 * @param {Array.<number>|TypedArray.<number>|Object} transform Can be:
 *      + Transform matrix: like [1, 0, 0, 1, 0, 0]
 *      + {position, rotation, scale}, the same as `zrender/Transformable`.
 * @param {boolean=} invert Whether use invert matrix.
 * @return {Array.<number>} [x, y]
 */ function $4b57d6b582d579b7$var$applyTransform(target, transform, invert) {
    if (transform && !$ec279652dd95c27b$export$1e2f57719e155213(transform)) transform = $af5c198eb02e5120$exports.getLocalTransform(transform);
    if (invert) transform = $6c6dd9610ba660f0$export$6897c284b6f9f4dc([], transform);
    return $9eb63d101f3bcd79$export$9f9dcb98c894b623([], target, transform);
}
/**
 * @param {string} direction 'left' 'right' 'top' 'bottom'
 * @param {Array.<number>} transform Transform matrix: like [1, 0, 0, 1, 0, 0]
 * @param {boolean=} invert Whether use invert matrix.
 * @return {string} Transformed direction. 'left' 'right' 'top' 'bottom'
 */ function $4b57d6b582d579b7$var$transformDirection(direction, transform, invert) {
    // Pick a base, ensure that transform result will not be (0, 0).
    var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
    var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
    var vertex = [
        direction === "left" ? -hBase : direction === "right" ? hBase : 0,
        direction === "top" ? -vBase : direction === "bottom" ? vBase : 0
    ];
    vertex = $4b57d6b582d579b7$var$applyTransform(vertex, transform, invert);
    return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? "right" : "left" : vertex[1] > 0 ? "bottom" : "top";
}
/**
 * Apply group transition animation from g1 to g2.
 * If no animatableModel, no animation.
 */ function $4b57d6b582d579b7$var$groupTransition(g1, g2, animatableModel, cb) {
    if (!g1 || !g2) return;
    function getElMap(g) {
        var elMap = {};
        g.traverse(function(el) {
            if (!el.isGroup && el.anid) elMap[el.anid] = el;
        });
        return elMap;
    }
    function getAnimatableProps(el) {
        var obj = {
            position: $9eb63d101f3bcd79$export$9cd59f9826255e47(el.position),
            rotation: el.rotation
        };
        if (el.shape) obj.shape = $ec279652dd95c27b$export$8b58be045bf06082({}, el.shape);
        return obj;
    }
    var elMap1 = getElMap(g1);
    g2.traverse(function(el) {
        if (!el.isGroup && el.anid) {
            var oldEl = elMap1[el.anid];
            if (oldEl) {
                var newProp = getAnimatableProps(el);
                el.attr(getAnimatableProps(oldEl));
                $4b57d6b582d579b7$var$updateProps(el, newProp, animatableModel, el.dataIndex);
            } // else {
        //     if (el.previousProps) {
        //         graphic.updateProps
        //     }
        // }
        }
    });
}
/**
 * @param {Array.<Array.<number>>} points Like: [[23, 44], [53, 66], ...]
 * @param {Object} rect {x, y, width, height}
 * @return {Array.<Array.<number>>} A new clipped points.
 */ function $4b57d6b582d579b7$var$clipPointsByRect(points, rect) {
    // FIXME: this way migth be incorrect when grpahic clipped by a corner.
    // and when element have border.
    return $ec279652dd95c27b$export$871de8747c9eaa88(points, function(point) {
        var x = point[0];
        x = $4b57d6b582d579b7$var$mathMax(x, rect.x);
        x = $4b57d6b582d579b7$var$mathMin(x, rect.x + rect.width);
        var y = point[1];
        y = $4b57d6b582d579b7$var$mathMax(y, rect.y);
        y = $4b57d6b582d579b7$var$mathMin(y, rect.y + rect.height);
        return [
            x,
            y
        ];
    });
}
/**
 * @param {Object} targetRect {x, y, width, height}
 * @param {Object} rect {x, y, width, height}
 * @return {Object} A new clipped rect. If rect size are negative, return undefined.
 */ function $4b57d6b582d579b7$var$clipRectByRect(targetRect, rect) {
    var x = $4b57d6b582d579b7$var$mathMax(targetRect.x, rect.x);
    var x2 = $4b57d6b582d579b7$var$mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
    var y = $4b57d6b582d579b7$var$mathMax(targetRect.y, rect.y);
    var y2 = $4b57d6b582d579b7$var$mathMin(targetRect.y + targetRect.height, rect.y + rect.height); // If the total rect is cliped, nothing, including the border,
    // should be painted. So return undefined.
    if (x2 >= x && y2 >= y) return {
        x: x,
        y: y,
        width: x2 - x,
        height: y2 - y
    };
}
/**
 * @param {string} iconStr Support 'image://' or 'path://' or direct svg path.
 * @param {Object} [opt] Properties of `module:zrender/Element`, except `style`.
 * @param {Object} [rect] {x, y, width, height}
 * @return {module:zrender/Element} Icon path or image element.
 */ function $4b57d6b582d579b7$var$createIcon(iconStr, opt, rect) {
    opt = $ec279652dd95c27b$export$8b58be045bf06082({
        rectHover: true
    }, opt);
    var style = opt.style = {
        strokeNoScale: true
    };
    rect = rect || {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    };
    if (iconStr) return iconStr.indexOf("image://") === 0 ? (style.image = iconStr.slice(8), $ec279652dd95c27b$export$ebe90cb607ad99e(style, rect), new $8d11db19115b899b$exports(opt)) : $4b57d6b582d579b7$var$makePath(iconStr.replace("path://", ""), opt, rect, "center");
}
/**
 * Return `true` if the given line (line `a`) and the given polygon
 * are intersect.
 * Note that we do not count colinear as intersect here because no
 * requirement for that. We could do that if required in future.
 *
 * @param {number} a1x
 * @param {number} a1y
 * @param {number} a2x
 * @param {number} a2y
 * @param {Array.<Array.<number>>} points Points of the polygon.
 * @return {boolean}
 */ function $4b57d6b582d579b7$var$linePolygonIntersect(a1x, a1y, a2x, a2y, points) {
    for(var i = 0, p2 = points[points.length - 1]; i < points.length; i++){
        var p = points[i];
        if ($4b57d6b582d579b7$var$lineLineIntersect(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) return true;
        p2 = p;
    }
}
/**
 * Return `true` if the given two lines (line `a` and line `b`)
 * are intersect.
 * Note that we do not count colinear as intersect here because no
 * requirement for that. We could do that if required in future.
 *
 * @param {number} a1x
 * @param {number} a1y
 * @param {number} a2x
 * @param {number} a2y
 * @param {number} b1x
 * @param {number} b1y
 * @param {number} b2x
 * @param {number} b2y
 * @return {boolean}
 */ function $4b57d6b582d579b7$var$lineLineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y; // `vec_m` and `vec_n` are parallel iff
    //     exising `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
    var nmCrossProduct = $4b57d6b582d579b7$var$crossProduct2d(nx, ny, mx, my);
    if ($4b57d6b582d579b7$var$nearZero(nmCrossProduct)) return false;
     // `vec_m` and `vec_n` are intersect iff
    //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
    //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
    //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var q = $4b57d6b582d579b7$var$crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
    if (q < 0 || q > 1) return false;
    var p = $4b57d6b582d579b7$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return false;
    return true;
}
/**
 * Cross product of 2-dimension vector.
 */ function $4b57d6b582d579b7$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $4b57d6b582d579b7$var$nearZero(val) {
    return val <= 1e-6 && val >= -0.000001;
} // Register built-in shapes. These shapes might be overwirtten
// by users, although we do not recommend that.
$4b57d6b582d579b7$var$registerShape("circle", $eddb4ac7833251bb$exports);
$4b57d6b582d579b7$var$registerShape("sector", $d7bd8a41e5d15836$exports);
$4b57d6b582d579b7$var$registerShape("ring", $35ca50b8f972e4c4$exports);
$4b57d6b582d579b7$var$registerShape("polygon", $b354b78e9d1919f1$exports);
$4b57d6b582d579b7$var$registerShape("polyline", $d6beacdc66e44020$exports);
$4b57d6b582d579b7$var$registerShape("rect", $9dfde1361bdd05e1$exports);
$4b57d6b582d579b7$var$registerShape("line", $f84975fd9f4e7d13$exports);
$4b57d6b582d579b7$var$registerShape("bezierCurve", $fd40ae4a803aa3fa$exports);
$4b57d6b582d579b7$var$registerShape("arc", $210ee3596a85e224$exports);
$4b57d6b582d579b7$export$1cb9fc6ed5b9836c = $4b57d6b582d579b7$var$Z2_EMPHASIS_LIFT;
$4b57d6b582d579b7$export$5f1d7d4030ae155b = $4b57d6b582d579b7$var$CACHED_LABEL_STYLE_PROPERTIES;
$4b57d6b582d579b7$export$d0d5398c9d612037 = $4b57d6b582d579b7$var$extendShape;
$4b57d6b582d579b7$export$53b54a3137026af0 = $4b57d6b582d579b7$var$extendPath;
$4b57d6b582d579b7$export$2b95b62e3aaf6fdd = $4b57d6b582d579b7$var$registerShape;
$4b57d6b582d579b7$export$51df4b5565a58189 = $4b57d6b582d579b7$var$getShapeClass;
$4b57d6b582d579b7$export$aa9bab72412f5613 = $4b57d6b582d579b7$var$makePath;
$4b57d6b582d579b7$export$7a2bdede98851ac5 = $4b57d6b582d579b7$var$makeImage;
$4b57d6b582d579b7$export$7b1dd269fbc4e903 = $4b57d6b582d579b7$var$mergePath;
$4b57d6b582d579b7$export$566dbf1c62b04fc7 = $4b57d6b582d579b7$var$resizePath;
$4b57d6b582d579b7$export$8b4b620d7f4aad1b = $4b57d6b582d579b7$var$subPixelOptimizeLine;
$4b57d6b582d579b7$export$60e2aa74957d0b9d = $4b57d6b582d579b7$var$subPixelOptimizeRect;
$4b57d6b582d579b7$export$72c4fd4c1b8fcb10 = $4b57d6b582d579b7$var$subPixelOptimize;
$4b57d6b582d579b7$export$2397e568fe8d15a0 = $4b57d6b582d579b7$var$setElementHoverStyle;
$4b57d6b582d579b7$export$28b42df8183f218c = $4b57d6b582d579b7$var$setHoverStyle;
$4b57d6b582d579b7$export$9ba15aea1e048d48 = $4b57d6b582d579b7$var$setAsHighDownDispatcher;
$4b57d6b582d579b7$export$77d1445f699c58b5 = $4b57d6b582d579b7$var$isHighDownDispatcher;
$4b57d6b582d579b7$export$824af40eb714530d = $4b57d6b582d579b7$var$getHighlightDigit;
$4b57d6b582d579b7$export$9a13992917966657 = $4b57d6b582d579b7$var$setLabelStyle;
$4b57d6b582d579b7$export$377292315e79b7ac = $4b57d6b582d579b7$var$modifyLabelStyle;
$4b57d6b582d579b7$export$6605af501964d89a = $4b57d6b582d579b7$var$setTextStyle;
$4b57d6b582d579b7$export$cbe0d99836e1498f = $4b57d6b582d579b7$var$setText;
$4b57d6b582d579b7$export$155316a870a9d61e = $4b57d6b582d579b7$var$getFont;
$4b57d6b582d579b7$export$c8dce3c08436e91e = $4b57d6b582d579b7$var$updateProps;
$4b57d6b582d579b7$export$a121566aadcfe021 = $4b57d6b582d579b7$var$initProps;
$4b57d6b582d579b7$export$fce0c6cfca85ed96 = $4b57d6b582d579b7$var$getTransform;
$4b57d6b582d579b7$export$9f9dcb98c894b623 = $4b57d6b582d579b7$var$applyTransform;
$4b57d6b582d579b7$export$fff94e9792354cfa = $4b57d6b582d579b7$var$transformDirection;
$4b57d6b582d579b7$export$64fcab7860c216ae = $4b57d6b582d579b7$var$groupTransition;
$4b57d6b582d579b7$export$e2f409471bbbc1dc = $4b57d6b582d579b7$var$clipPointsByRect;
$4b57d6b582d579b7$export$d0d3709202b8b2a = $4b57d6b582d579b7$var$clipRectByRect;
$4b57d6b582d579b7$export$274edc73af1ae9c8 = $4b57d6b582d579b7$var$createIcon;
$4b57d6b582d579b7$export$4f47c855a5e9ae9 = $4b57d6b582d579b7$var$linePolygonIntersect;
$4b57d6b582d579b7$export$6c0a70ea1d8d158b = $4b57d6b582d579b7$var$lineLineIntersect;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $16a1179a33351935$var$PATH_COLOR = [
    "textStyle",
    "color"
];
var $16a1179a33351935$var$_default = {
    /**
   * Get color property or get color from option.textStyle.color
   * @param {boolean} [isEmphasis]
   * @return {string}
   */ getTextColor: function(isEmphasis) {
        var ecModel = this.ecModel;
        return this.getShallow("color") || (!isEmphasis && ecModel ? ecModel.get($16a1179a33351935$var$PATH_COLOR) : null);
    },
    /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */ getFont: function() {
        return $4b57d6b582d579b7$export$155316a870a9d61e({
            fontStyle: this.getShallow("fontStyle"),
            fontWeight: this.getShallow("fontWeight"),
            fontSize: this.getShallow("fontSize"),
            fontFamily: this.getShallow("fontFamily")
        }, this.ecModel);
    },
    getTextRect: function(text) {
        return $ebae9c4ebc22906c$export$c381147bfed79d9f(text, this.getFont(), this.getShallow("align"), this.getShallow("verticalAlign") || this.getShallow("baseline"), this.getShallow("padding"), this.getShallow("lineHeight"), this.getShallow("rich"), this.getShallow("truncateText"));
    }
};
$16a1179a33351935$exports = $16a1179a33351935$var$_default;


var $8f359535192aeaf1$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $8f359535192aeaf1$var$getItemStyle = $d701679ba7a46009$exports([
    [
        "fill",
        "color"
    ],
    [
        "stroke",
        "borderColor"
    ],
    [
        "lineWidth",
        "borderWidth"
    ],
    [
        "opacity"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "shadowColor"
    ],
    [
        "textPosition"
    ],
    [
        "textAlign"
    ]
]);
var $8f359535192aeaf1$var$_default = {
    getItemStyle: function(excludes, includes) {
        var style = $8f359535192aeaf1$var$getItemStyle(this, excludes, includes);
        var lineDash = this.getBorderLineDash();
        lineDash && (style.lineDash = lineDash);
        return style;
    },
    getBorderLineDash: function() {
        var lineType = this.get("borderType");
        return lineType === "solid" || lineType == null ? null : lineType === "dashed" ? [
            5,
            5
        ] : [
            1,
            1
        ];
    }
};
$8f359535192aeaf1$exports = $8f359535192aeaf1$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @module echarts/model/Model
 */ var $2b51b4bf776ec22e$var$mixin = $ec279652dd95c27b$export$e36fc9d62a853069;
var $2b51b4bf776ec22e$var$inner = $2b51b4bf776ec22e$var$makeInner();
/**
 * @alias module:echarts/model/Model
 * @constructor
 * @param {Object} [option]
 * @param {module:echarts/model/Model} [parentModel]
 * @param {module:echarts/model/Global} [ecModel]
 */ function $2b51b4bf776ec22e$var$Model(option, parentModel, ecModel) {
    /**
   * @type {module:echarts/model/Model}
   * @readOnly
   */ this.parentModel = parentModel;
    /**
   * @type {module:echarts/model/Global}
   * @readOnly
   */ this.ecModel = ecModel;
    /**
   * @type {Object}
   * @protected
   */ this.option = option; // Simple optimization
// if (this.init) {
//     if (arguments.length <= 4) {
//         this.init(option, parentModel, ecModel, extraOpt);
//     }
//     else {
//         this.init.apply(this, arguments);
//     }
// }
}
$2b51b4bf776ec22e$var$Model.prototype = {
    constructor: $2b51b4bf776ec22e$var$Model,
    /**
   * Model 的初始化函数
   * @param {Object} option
   */ init: null,
    /**
   * 从新的 Option merge
   */ mergeOption: function(option) {
        $ec279652dd95c27b$export$4950aa0f605343fb(this.option, option, true);
    },
    /**
   * @param {string|Array.<string>} path
   * @param {boolean} [ignoreParent=false]
   * @return {*}
   */ get: function(path, ignoreParent) {
        if (path == null) return this.option;
        return $2b51b4bf776ec22e$var$doGet(this.option, this.parsePath(path), !ignoreParent && $2b51b4bf776ec22e$var$getParent(this, path));
    },
    /**
   * @param {string} key
   * @param {boolean} [ignoreParent=false]
   * @return {*}
   */ getShallow: function(key, ignoreParent) {
        var option = this.option;
        var val = option == null ? option : option[key];
        var parentModel = !ignoreParent && $2b51b4bf776ec22e$var$getParent(this, key);
        if (val == null && parentModel) val = parentModel.getShallow(key);
        return val;
    },
    /**
   * @param {string|Array.<string>} [path]
   * @param {module:echarts/model/Model} [parentModel]
   * @return {module:echarts/model/Model}
   */ getModel: function(path, parentModel) {
        var obj = path == null ? this.option : $2b51b4bf776ec22e$var$doGet(this.option, path = this.parsePath(path));
        var thisParentModel;
        parentModel = parentModel || (thisParentModel = $2b51b4bf776ec22e$var$getParent(this, path)) && thisParentModel.getModel(path);
        return new $2b51b4bf776ec22e$var$Model(obj, parentModel, this.ecModel);
    },
    /**
   * If model has option
   */ isEmpty: function() {
        return this.option == null;
    },
    restoreData: function() {},
    // Pending
    clone: function() {
        var Ctor = this.constructor;
        return new Ctor($ec279652dd95c27b$export$9cd59f9826255e47(this.option));
    },
    setReadOnly: function(properties) {},
    // If path is null/undefined, return null/undefined.
    parsePath: function(path) {
        if (typeof path === "string") path = path.split(".");
        return path;
    },
    /**
   * @param {Function} getParentMethod
   *        param {Array.<string>|string} path
   *        return {module:echarts/model/Model}
   */ customizeGetParent: function(getParentMethod) {
        $2b51b4bf776ec22e$var$inner(this).getParent = getParentMethod;
    },
    isAnimationEnabled: function() {
        if (!$27ac1413ecc67076$exports.node) {
            if (this.option.animation != null) return !!this.option.animation;
            else if (this.parentModel) return this.parentModel.isAnimationEnabled();
        }
    }
};
function $2b51b4bf776ec22e$var$doGet(obj, pathArr, parentModel) {
    for(var i = 0; i < pathArr.length; i++){
        // Ignore empty
        if (!pathArr[i]) continue;
         // obj could be number/string/... (like 0)
        obj = obj && typeof obj === "object" ? obj[pathArr[i]] : null;
        if (obj == null) break;
    }
    if (obj == null && parentModel) obj = parentModel.get(pathArr);
    return obj;
} // `path` can be null/undefined
function $2b51b4bf776ec22e$var$getParent(model, path) {
    var getParentMethod = $2b51b4bf776ec22e$var$inner(model).getParent;
    return getParentMethod ? getParentMethod.call(model, path) : model.parentModel;
} // Enable Model.extend.
$2b51b4bf776ec22e$var$enableClassExtend($2b51b4bf776ec22e$var$Model);
$2b51b4bf776ec22e$var$enableClassCheck($2b51b4bf776ec22e$var$Model);
$2b51b4bf776ec22e$var$mixin($2b51b4bf776ec22e$var$Model, $86d235be5020002e$exports);
$2b51b4bf776ec22e$var$mixin($2b51b4bf776ec22e$var$Model, $6459279907957a83$exports);
$2b51b4bf776ec22e$var$mixin($2b51b4bf776ec22e$var$Model, $16a1179a33351935$exports);
$2b51b4bf776ec22e$var$mixin($2b51b4bf776ec22e$var$Model, $8f359535192aeaf1$exports);
var $2b51b4bf776ec22e$var$_default = $2b51b4bf776ec22e$var$Model;
$2b51b4bf776ec22e$exports = $2b51b4bf776ec22e$var$_default;


var $3b9c2389e45dfb7d$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $a39499a9dbffdb7d$export$6d2b3473b0986646;
var $a39499a9dbffdb7d$export$b9faf30b7d655a6f;
var $a39499a9dbffdb7d$export$ce592d345a3ec040;


var $a39499a9dbffdb7d$var$parseClassType = $c125ba1250423743$export$fbe18865d303bf01;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $a39499a9dbffdb7d$var$base = 0;
/**
 * @public
 * @param {string} type
 * @return {string}
 */ function $a39499a9dbffdb7d$var$getUID(type) {
    // Considering the case of crossing js context,
    // use Math.random to make id as unique as possible.
    return [
        type || "",
        $a39499a9dbffdb7d$var$base++,
        Math.random().toFixed(5)
    ].join("_");
}
/**
 * @inner
 */ function $a39499a9dbffdb7d$var$enableSubTypeDefaulter(entity) {
    var subTypeDefaulters = {};
    entity.registerSubTypeDefaulter = function(componentType, defaulter) {
        componentType = $a39499a9dbffdb7d$var$parseClassType(componentType);
        subTypeDefaulters[componentType.main] = defaulter;
    };
    entity.determineSubType = function(componentType, option) {
        var type = option.type;
        if (!type) {
            var componentTypeMain = $a39499a9dbffdb7d$var$parseClassType(componentType).main;
            if (entity.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) type = subTypeDefaulters[componentTypeMain](option);
        }
        return type;
    };
    return entity;
}
/**
 * Topological travel on Activity Network (Activity On Vertices).
 * Dependencies is defined in Model.prototype.dependencies, like ['xAxis', 'yAxis'].
 *
 * If 'xAxis' or 'yAxis' is absent in componentTypeList, just ignore it in topology.
 *
 * If there is circle dependencey, Error will be thrown.
 *
 */ function $a39499a9dbffdb7d$var$enableTopologicalTravel(entity, dependencyGetter) {
    /**
   * @public
   * @param {Array.<string>} targetNameList Target Component type list.
   *                                           Can be ['aa', 'bb', 'aa.xx']
   * @param {Array.<string>} fullNameList By which we can build dependency graph.
   * @param {Function} callback Params: componentType, dependencies.
   * @param {Object} context Scope of callback.
   */ entity.topologicalTravel = function(targetNameList, fullNameList, callback, context) {
        if (!targetNameList.length) return;
        var result = makeDepndencyGraph(fullNameList);
        var graph = result.graph;
        var stack = result.noEntryList;
        var targetNameSet = {};
        $ec279652dd95c27b$export$79b2f7037acddd43(targetNameList, function(name) {
            targetNameSet[name] = true;
        });
        while(stack.length){
            var currComponentType = stack.pop();
            var currVertex = graph[currComponentType];
            var isInTargetNameSet = !!targetNameSet[currComponentType];
            if (isInTargetNameSet) {
                callback.call(context, currComponentType, currVertex.originalDeps.slice());
                delete targetNameSet[currComponentType];
            }
            $ec279652dd95c27b$export$79b2f7037acddd43(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
        }
        $ec279652dd95c27b$export$79b2f7037acddd43(targetNameSet, function() {
            throw new Error("Circle dependency may exists");
        });
        function removeEdge(succComponentType) {
            graph[succComponentType].entryCount--;
            if (graph[succComponentType].entryCount === 0) stack.push(succComponentType);
        } // Consider this case: legend depends on series, and we call
        // chart.setOption({series: [...]}), where only series is in option.
        // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
        // not be called, but only sereis.mergeOption is called. Thus legend
        // have no chance to update its local record about series (like which
        // name of series is available in legend).
        function removeEdgeAndAdd(succComponentType) {
            targetNameSet[succComponentType] = true;
            removeEdge(succComponentType);
        }
    };
    /**
   * DepndencyGraph: {Object}
   * key: conponentType,
   * value: {
   *     successor: [conponentTypes...],
   *     originalDeps: [conponentTypes...],
   *     entryCount: {number}
   * }
   */ function makeDepndencyGraph(fullNameList) {
        var graph = {};
        var noEntryList = [];
        $ec279652dd95c27b$export$79b2f7037acddd43(fullNameList, function(name) {
            var thisItem = createDependencyGraphItem(graph, name);
            var originalDeps = thisItem.originalDeps = dependencyGetter(name);
            var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
            thisItem.entryCount = availableDeps.length;
            if (thisItem.entryCount === 0) noEntryList.push(name);
            $ec279652dd95c27b$export$79b2f7037acddd43(availableDeps, function(dependentName) {
                if ($ec279652dd95c27b$export$305f7d4e9d4624f2(thisItem.predecessor, dependentName) < 0) thisItem.predecessor.push(dependentName);
                var thatItem = createDependencyGraphItem(graph, dependentName);
                if ($ec279652dd95c27b$export$305f7d4e9d4624f2(thatItem.successor, dependentName) < 0) thatItem.successor.push(name);
            });
        });
        return {
            graph: graph,
            noEntryList: noEntryList
        };
    }
    function createDependencyGraphItem(graph, name) {
        if (!graph[name]) graph[name] = {
            predecessor: [],
            successor: []
        };
        return graph[name];
    }
    function getAvailableDependencies(originalDeps, fullNameList) {
        var availableDeps = [];
        $ec279652dd95c27b$export$79b2f7037acddd43(originalDeps, function(dep) {
            $ec279652dd95c27b$export$305f7d4e9d4624f2(fullNameList, dep) >= 0 && availableDeps.push(dep);
        });
        return availableDeps;
    }
}
$a39499a9dbffdb7d$export$6d2b3473b0986646 = $a39499a9dbffdb7d$var$getUID;
$a39499a9dbffdb7d$export$b9faf30b7d655a6f = $a39499a9dbffdb7d$var$enableSubTypeDefaulter;
$a39499a9dbffdb7d$export$ce592d345a3ec040 = $a39499a9dbffdb7d$var$enableTopologicalTravel;



var $3b9c2389e45dfb7d$var$enableClassManagement = $c125ba1250423743$export$241315e45585454d;
var $3b9c2389e45dfb7d$var$parseClassType = $c125ba1250423743$export$fbe18865d303bf01;

var $3b9c2389e45dfb7d$var$makeInner = $d559f43cb9041423$export$64df9f8d92ae083f;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $ab0c9086dd6c5b39$export$a9aa2cc018afbed;
var $ab0c9086dd6c5b39$export$d7fd4338c7b20804;
var $ab0c9086dd6c5b39$export$827f4ee28efc37;
var $ab0c9086dd6c5b39$export$be20d9158c17374c;
var $ab0c9086dd6c5b39$export$ae65a483d943e7a7;
var $ab0c9086dd6c5b39$export$145a8938a85a22b1;
var $ab0c9086dd6c5b39$export$4517a5ca639a7293;
var $ab0c9086dd6c5b39$export$74054bd96b5eeef1;
var $ab0c9086dd6c5b39$export$7ede609e8ebc9650;
var $ab0c9086dd6c5b39$export$1754cb91f16ca028;
var $ab0c9086dd6c5b39$export$4b0d20af19c9875e;
var $ab0c9086dd6c5b39$export$7438999faea9b6cc;


var $2d742dbe7f960d8c$exports = {};

$parcel$export($2d742dbe7f960d8c$exports, "linearMap", () => $2d742dbe7f960d8c$export$d3f68fbaa670562, (v) => $2d742dbe7f960d8c$export$d3f68fbaa670562 = v);
$parcel$export($2d742dbe7f960d8c$exports, "parsePercent", () => $2d742dbe7f960d8c$export$e8514cb5a5e2b40f, (v) => $2d742dbe7f960d8c$export$e8514cb5a5e2b40f = v);
$parcel$export($2d742dbe7f960d8c$exports, "round", () => $2d742dbe7f960d8c$export$2077e0241d6afd3c, (v) => $2d742dbe7f960d8c$export$2077e0241d6afd3c = v);
$parcel$export($2d742dbe7f960d8c$exports, "asc", () => $2d742dbe7f960d8c$export$debe6e778e0a6d32, (v) => $2d742dbe7f960d8c$export$debe6e778e0a6d32 = v);
$parcel$export($2d742dbe7f960d8c$exports, "getPrecision", () => $2d742dbe7f960d8c$export$e0c74b50bbd10f68, (v) => $2d742dbe7f960d8c$export$e0c74b50bbd10f68 = v);
$parcel$export($2d742dbe7f960d8c$exports, "getPrecisionSafe", () => $2d742dbe7f960d8c$export$6d86ba4ca4984d31, (v) => $2d742dbe7f960d8c$export$6d86ba4ca4984d31 = v);
$parcel$export($2d742dbe7f960d8c$exports, "getPixelPrecision", () => $2d742dbe7f960d8c$export$666260d9a2dda8a7, (v) => $2d742dbe7f960d8c$export$666260d9a2dda8a7 = v);
$parcel$export($2d742dbe7f960d8c$exports, "getPercentWithPrecision", () => $2d742dbe7f960d8c$export$70cc11b075afeb90, (v) => $2d742dbe7f960d8c$export$70cc11b075afeb90 = v);
$parcel$export($2d742dbe7f960d8c$exports, "MAX_SAFE_INTEGER", () => $2d742dbe7f960d8c$export$18510406f204a1b9, (v) => $2d742dbe7f960d8c$export$18510406f204a1b9 = v);
$parcel$export($2d742dbe7f960d8c$exports, "remRadian", () => $2d742dbe7f960d8c$export$2ca6dd70a288b1c3, (v) => $2d742dbe7f960d8c$export$2ca6dd70a288b1c3 = v);
$parcel$export($2d742dbe7f960d8c$exports, "isRadianAroundZero", () => $2d742dbe7f960d8c$export$d1df570aea2868f, (v) => $2d742dbe7f960d8c$export$d1df570aea2868f = v);
$parcel$export($2d742dbe7f960d8c$exports, "parseDate", () => $2d742dbe7f960d8c$export$6b862160d295c8e, (v) => $2d742dbe7f960d8c$export$6b862160d295c8e = v);
$parcel$export($2d742dbe7f960d8c$exports, "quantity", () => $2d742dbe7f960d8c$export$82dd68b83a44b253, (v) => $2d742dbe7f960d8c$export$82dd68b83a44b253 = v);
$parcel$export($2d742dbe7f960d8c$exports, "quantityExponent", () => $2d742dbe7f960d8c$export$97256a17b20a0c24, (v) => $2d742dbe7f960d8c$export$97256a17b20a0c24 = v);
$parcel$export($2d742dbe7f960d8c$exports, "nice", () => $2d742dbe7f960d8c$export$7a695fe44258210b, (v) => $2d742dbe7f960d8c$export$7a695fe44258210b = v);
$parcel$export($2d742dbe7f960d8c$exports, "quantile", () => $2d742dbe7f960d8c$export$651fb4afdb6caa4b, (v) => $2d742dbe7f960d8c$export$651fb4afdb6caa4b = v);
$parcel$export($2d742dbe7f960d8c$exports, "reformIntervals", () => $2d742dbe7f960d8c$export$12f7386070bc380a, (v) => $2d742dbe7f960d8c$export$12f7386070bc380a = v);
$parcel$export($2d742dbe7f960d8c$exports, "isNumeric", () => $2d742dbe7f960d8c$export$e90fb89750dba83f, (v) => $2d742dbe7f960d8c$export$e90fb89750dba83f = v);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $2d742dbe7f960d8c$export$d3f68fbaa670562;
var $2d742dbe7f960d8c$export$e8514cb5a5e2b40f;
var $2d742dbe7f960d8c$export$2077e0241d6afd3c;
var $2d742dbe7f960d8c$export$debe6e778e0a6d32;
var $2d742dbe7f960d8c$export$e0c74b50bbd10f68;
var $2d742dbe7f960d8c$export$6d86ba4ca4984d31;
var $2d742dbe7f960d8c$export$666260d9a2dda8a7;
var $2d742dbe7f960d8c$export$70cc11b075afeb90;
var $2d742dbe7f960d8c$export$18510406f204a1b9;
var $2d742dbe7f960d8c$export$2ca6dd70a288b1c3;
var $2d742dbe7f960d8c$export$d1df570aea2868f;
var $2d742dbe7f960d8c$export$6b862160d295c8e;
var $2d742dbe7f960d8c$export$82dd68b83a44b253;
var $2d742dbe7f960d8c$export$97256a17b20a0c24;
var $2d742dbe7f960d8c$export$7a695fe44258210b;
var $2d742dbe7f960d8c$export$651fb4afdb6caa4b;
var $2d742dbe7f960d8c$export$12f7386070bc380a;
var $2d742dbe7f960d8c$export$e90fb89750dba83f;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embeded for some of the code in this file:
* The method "quantile" was copied from "d3.js".
* (See more details in the comment of the method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ var $2d742dbe7f960d8c$var$RADIAN_EPSILON = 1e-4;
function $2d742dbe7f960d8c$var$_trim(str) {
    return str.replace(/^\s+|\s+$/g, "");
}
/**
 * Linear mapping a value from domain to range
 * @memberOf module:echarts/util/number
 * @param  {(number|Array.<number>)} val
 * @param  {Array.<number>} domain Domain extent domain[0] can be bigger than domain[1]
 * @param  {Array.<number>} range  Range extent range[0] can be bigger than range[1]
 * @param  {boolean} clamp
 * @return {(number|Array.<number>}
 */ function $2d742dbe7f960d8c$var$linearMap(val, domain, range, clamp) {
    var subDomain = domain[1] - domain[0];
    var subRange = range[1] - range[0];
    if (subDomain === 0) return subRange === 0 ? range[0] : (range[0] + range[1]) / 2;
     // Avoid accuracy problem in edge, such as
    // 146.39 - 62.83 === 83.55999999999999.
    // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
    // It is a little verbose for efficiency considering this method
    // is a hotspot.
    if (clamp) {
        if (subDomain > 0) {
            if (val <= domain[0]) return range[0];
            else if (val >= domain[1]) return range[1];
        } else {
            if (val >= domain[0]) return range[0];
            else if (val <= domain[1]) return range[1];
        }
    } else {
        if (val === domain[0]) return range[0];
        if (val === domain[1]) return range[1];
    }
    return (val - domain[0]) / subDomain * subRange + range[0];
}
/**
 * Convert a percent string to absolute number.
 * Returns NaN if percent is not a valid string or number
 * @memberOf module:echarts/util/number
 * @param {string|number} percent
 * @param {number} all
 * @return {number}
 */ function $2d742dbe7f960d8c$var$parsePercent(percent, all) {
    switch(percent){
        case "center":
        case "middle":
            percent = "50%";
            break;
        case "left":
        case "top":
            percent = "0%";
            break;
        case "right":
        case "bottom":
            percent = "100%";
            break;
    }
    if (typeof percent === "string") {
        if ($2d742dbe7f960d8c$var$_trim(percent).match(/%$/)) return parseFloat(percent) / 100 * all;
        return parseFloat(percent);
    }
    return percent == null ? NaN : +percent;
}
/**
 * (1) Fix rounding error of float numbers.
 * (2) Support return string to avoid scientific notation like '3.5e-7'.
 *
 * @param {number} x
 * @param {number} [precision]
 * @param {boolean} [returnStr]
 * @return {number|string}
 */ function $2d742dbe7f960d8c$var$round(x, precision, returnStr) {
    if (precision == null) precision = 10;
     // Avoid range error
    precision = Math.min(Math.max(0, precision), 20);
    x = (+x).toFixed(precision);
    return returnStr ? x : +x;
}
/**
 * asc sort arr.
 * The input arr will be modified.
 *
 * @param {Array} arr
 * @return {Array} The input arr.
 */ function $2d742dbe7f960d8c$var$asc(arr) {
    arr.sort(function(a, b) {
        return a - b;
    });
    return arr;
}
/**
 * Get precision
 * @param {number} val
 */ function $2d742dbe7f960d8c$var$getPrecision(val) {
    val = +val;
    if (isNaN(val)) return 0;
     // It is much faster than methods converting number to string as follows
    //      var tmp = val.toString();
    //      return tmp.length - 1 - tmp.indexOf('.');
    // especially when precision is low
    var e = 1;
    var count = 0;
    while(Math.round(val * e) / e !== val){
        e *= 10;
        count++;
    }
    return count;
}
/**
 * @param {string|number} val
 * @return {number}
 */ function $2d742dbe7f960d8c$var$getPrecisionSafe(val) {
    var str = val.toString(); // Consider scientific notation: '3.4e-12' '3.4e+12'
    var eIndex = str.indexOf("e");
    if (eIndex > 0) {
        var precision = +str.slice(eIndex + 1);
        return precision < 0 ? -precision : 0;
    } else {
        var dotIndex = str.indexOf(".");
        return dotIndex < 0 ? 0 : str.length - 1 - dotIndex;
    }
}
/**
 * Minimal dicernible data precisioin according to a single pixel.
 *
 * @param {Array.<number>} dataExtent
 * @param {Array.<number>} pixelExtent
 * @return {number} precision
 */ function $2d742dbe7f960d8c$var$getPixelPrecision(dataExtent, pixelExtent) {
    var log = Math.log;
    var LN10 = Math.LN10;
    var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
    var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10); // toFixed() digits argument must be between 0 and 20.
    var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
    return !isFinite(precision) ? 20 : precision;
}
/**
 * Get a data of given precision, assuring the sum of percentages
 * in valueList is 1.
 * The largest remainer method is used.
 * https://en.wikipedia.org/wiki/Largest_remainder_method
 *
 * @param {Array.<number>} valueList a list of all data
 * @param {number} idx index of the data to be processed in valueList
 * @param {number} precision integer number showing digits of precision
 * @return {number} percent ranging from 0 to 100
 */ function $2d742dbe7f960d8c$var$getPercentWithPrecision(valueList, idx, precision) {
    if (!valueList[idx]) return 0;
    var sum = $ec279652dd95c27b$export$533b26079ad0b4b(valueList, function(acc, val) {
        return acc + (isNaN(val) ? 0 : val);
    }, 0);
    if (sum === 0) return 0;
    var digits = Math.pow(10, precision);
    var votesPerQuota = $ec279652dd95c27b$export$871de8747c9eaa88(valueList, function(val) {
        return (isNaN(val) ? 0 : val) / sum * digits * 100;
    });
    var targetSeats = digits * 100;
    var seats = $ec279652dd95c27b$export$871de8747c9eaa88(votesPerQuota, function(votes) {
        // Assign automatic seats.
        return Math.floor(votes);
    });
    var currentSum = $ec279652dd95c27b$export$533b26079ad0b4b(seats, function(acc, val) {
        return acc + val;
    }, 0);
    var remainder = $ec279652dd95c27b$export$871de8747c9eaa88(votesPerQuota, function(votes, idx) {
        return votes - seats[idx];
    }); // Has remainding votes.
    while(currentSum < targetSeats){
        // Find next largest remainder.
        var max = Number.NEGATIVE_INFINITY;
        var maxId = null;
        for(var i = 0, len = remainder.length; i < len; ++i)if (remainder[i] > max) {
            max = remainder[i];
            maxId = i;
        }
         // Add a vote to max remainder.
        ++seats[maxId];
        remainder[maxId] = 0;
        ++currentSum;
    }
    return seats[idx] / digits;
} // Number.MAX_SAFE_INTEGER, ie do not support.
var $2d742dbe7f960d8c$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * To 0 - 2 * PI, considering negative radian.
 * @param {number} radian
 * @return {number}
 */ function $2d742dbe7f960d8c$var$remRadian(radian) {
    var pi2 = Math.PI * 2;
    return (radian % pi2 + pi2) % pi2;
}
/**
 * @param {type} radian
 * @return {boolean}
 */ function $2d742dbe7f960d8c$var$isRadianAroundZero(val) {
    return val > -$2d742dbe7f960d8c$var$RADIAN_EPSILON && val < $2d742dbe7f960d8c$var$RADIAN_EPSILON;
}
/* eslint-disable */ var $2d742dbe7f960d8c$var$TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d\d)(?::(\d\d)(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
/* eslint-enable */ /**
 * @param {string|Date|number} value These values can be accepted:
 *   + An instance of Date, represent a time in its own time zone.
 *   + Or string in a subset of ISO 8601, only including:
 *     + only year, month, date: '2012-03', '2012-03-01', '2012-03-01 05', '2012-03-01 05:06',
 *     + separated with T or space: '2012-03-01T12:22:33.123', '2012-03-01 12:22:33.123',
 *     + time zone: '2012-03-01T12:22:33Z', '2012-03-01T12:22:33+8000', '2012-03-01T12:22:33-05:00',
 *     all of which will be treated as local time if time zone is not specified
 *     (see <https://momentjs.com/>).
 *   + Or other string format, including (all of which will be treated as loacal time):
 *     '2012', '2012-3-1', '2012/3/1', '2012/03/01',
 *     '2009/6/12 2:00', '2009/6/12 2:05:08', '2009/6/12 2:05:08.123'
 *   + a timestamp, which represent a time in UTC.
 * @return {Date} date
 */ function $2d742dbe7f960d8c$var$parseDate(value) {
    if (value instanceof Date) return value;
    else if (typeof value === "string") {
        // Different browsers parse date in different way, so we parse it manually.
        // Some other issues:
        // new Date('1970-01-01') is UTC,
        // new Date('1970/01/01') and new Date('1970-1-01') is local.
        // See issue #3623
        var match = $2d742dbe7f960d8c$var$TIME_REG.exec(value);
        if (!match) // return Invalid Date.
        return new Date(NaN);
         // Use local time when no timezone offset specifed.
        if (!match[8]) // match[n] can only be string or undefined.
        // But take care of '12' + 1 => '121'.
        return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, +match[7] || 0);
        else {
            var hour = +match[4] || 0;
            if (match[8].toUpperCase() !== "Z") hour -= match[8].slice(0, 3);
            return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, +match[7] || 0));
        }
    } else if (value == null) return new Date(NaN);
    return new Date(Math.round(value));
}
/**
 * Quantity of a number. e.g. 0.1, 1, 10, 100
 *
 * @param  {number} val
 * @return {number}
 */ function $2d742dbe7f960d8c$var$quantity(val) {
    return Math.pow(10, $2d742dbe7f960d8c$var$quantityExponent(val));
}
/**
 * Exponent of the quantity of a number
 * e.g., 1234 equals to 1.234*10^3, so quantityExponent(1234) is 3
 *
 * @param  {number} val non-negative value
 * @return {number}
 */ function $2d742dbe7f960d8c$var$quantityExponent(val) {
    if (val === 0) return 0;
    var exp = Math.floor(Math.log(val) / Math.LN10);
    /**
   * exp is expected to be the rounded-down result of the base-10 log of val.
   * But due to the precision loss with Math.log(val), we need to restore it
   * using 10^exp to make sure we can get val back from exp. #11249
   */ if (val / Math.pow(10, exp) >= 10) exp++;
    return exp;
}
/**
 * find a “nice” number approximately equal to x. Round the number if round = true,
 * take ceiling if round = false. The primary observation is that the “nicest”
 * numbers in decimal are 1, 2, and 5, and all power-of-ten multiples of these numbers.
 *
 * See "Nice Numbers for Graph Labels" of Graphic Gems.
 *
 * @param  {number} val Non-negative value.
 * @param  {boolean} round
 * @return {number}
 */ function $2d742dbe7f960d8c$var$nice(val, round) {
    var exponent = $2d742dbe7f960d8c$var$quantityExponent(val);
    var exp10 = Math.pow(10, exponent);
    var f = val / exp10; // 1 <= f < 10
    var nf;
    if (round) {
        if (f < 1.5) nf = 1;
        else if (f < 2.5) nf = 2;
        else if (f < 4) nf = 3;
        else if (f < 7) nf = 5;
        else nf = 10;
    } else {
        if (f < 1) nf = 1;
        else if (f < 2) nf = 2;
        else if (f < 3) nf = 3;
        else if (f < 5) nf = 5;
        else nf = 10;
    }
    val = nf * exp10; // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
    // 20 is the uppper bound of toFixed.
    return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
}
/**
 * This code was copied from "d3.js"
 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/arrays/quantile.js>.
 * See the license statement at the head of this file.
 * @param {Array.<number>} ascArr
 */ function $2d742dbe7f960d8c$var$quantile(ascArr, p) {
    var H = (ascArr.length - 1) * p + 1;
    var h = Math.floor(H);
    var v = +ascArr[h - 1];
    var e = H - h;
    return e ? v + e * (ascArr[h] - v) : v;
}
/**
 * Order intervals asc, and split them when overlap.
 * expect(numberUtil.reformIntervals([
 *     {interval: [18, 62], close: [1, 1]},
 *     {interval: [-Infinity, -70], close: [0, 0]},
 *     {interval: [-70, -26], close: [1, 1]},
 *     {interval: [-26, 18], close: [1, 1]},
 *     {interval: [62, 150], close: [1, 1]},
 *     {interval: [106, 150], close: [1, 1]},
 *     {interval: [150, Infinity], close: [0, 0]}
 * ])).toEqual([
 *     {interval: [-Infinity, -70], close: [0, 0]},
 *     {interval: [-70, -26], close: [1, 1]},
 *     {interval: [-26, 18], close: [0, 1]},
 *     {interval: [18, 62], close: [0, 1]},
 *     {interval: [62, 150], close: [0, 1]},
 *     {interval: [150, Infinity], close: [0, 0]}
 * ]);
 * @param {Array.<Object>} list, where `close` mean open or close
 *        of the interval, and Infinity can be used.
 * @return {Array.<Object>} The origin list, which has been reformed.
 */ function $2d742dbe7f960d8c$var$reformIntervals(list) {
    list.sort(function(a, b) {
        return littleThan(a, b, 0) ? -1 : 1;
    });
    var curr = -Infinity;
    var currClose = 1;
    for(var i = 0; i < list.length;){
        var interval = list[i].interval;
        var close = list[i].close;
        for(var lg = 0; lg < 2; lg++){
            if (interval[lg] <= curr) {
                interval[lg] = curr;
                close[lg] = !lg ? 1 - currClose : 1;
            }
            curr = interval[lg];
            currClose = close[lg];
        }
        if (interval[0] === interval[1] && close[0] * close[1] !== 1) list.splice(i, 1);
        else i++;
    }
    return list;
    function littleThan(a, b, lg) {
        return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
    }
}
/**
 * parseFloat NaNs numeric-cast false positives (null|true|false|"")
 * ...but misinterprets leading-number strings, particularly hex literals ("0x...")
 * subtraction forces infinities to NaN
 *
 * @param {*} v
 * @return {boolean}
 */ function $2d742dbe7f960d8c$var$isNumeric(v) {
    return v - parseFloat(v) >= 0;
}
$2d742dbe7f960d8c$export$d3f68fbaa670562 = $2d742dbe7f960d8c$var$linearMap;
$2d742dbe7f960d8c$export$e8514cb5a5e2b40f = $2d742dbe7f960d8c$var$parsePercent;
$2d742dbe7f960d8c$export$2077e0241d6afd3c = $2d742dbe7f960d8c$var$round;
$2d742dbe7f960d8c$export$debe6e778e0a6d32 = $2d742dbe7f960d8c$var$asc;
$2d742dbe7f960d8c$export$e0c74b50bbd10f68 = $2d742dbe7f960d8c$var$getPrecision;
$2d742dbe7f960d8c$export$6d86ba4ca4984d31 = $2d742dbe7f960d8c$var$getPrecisionSafe;
$2d742dbe7f960d8c$export$666260d9a2dda8a7 = $2d742dbe7f960d8c$var$getPixelPrecision;
$2d742dbe7f960d8c$export$70cc11b075afeb90 = $2d742dbe7f960d8c$var$getPercentWithPrecision;
$2d742dbe7f960d8c$export$18510406f204a1b9 = $2d742dbe7f960d8c$var$MAX_SAFE_INTEGER;
$2d742dbe7f960d8c$export$2ca6dd70a288b1c3 = $2d742dbe7f960d8c$var$remRadian;
$2d742dbe7f960d8c$export$d1df570aea2868f = $2d742dbe7f960d8c$var$isRadianAroundZero;
$2d742dbe7f960d8c$export$6b862160d295c8e = $2d742dbe7f960d8c$var$parseDate;
$2d742dbe7f960d8c$export$82dd68b83a44b253 = $2d742dbe7f960d8c$var$quantity;
$2d742dbe7f960d8c$export$97256a17b20a0c24 = $2d742dbe7f960d8c$var$quantityExponent;
$2d742dbe7f960d8c$export$7a695fe44258210b = $2d742dbe7f960d8c$var$nice;
$2d742dbe7f960d8c$export$651fb4afdb6caa4b = $2d742dbe7f960d8c$var$quantile;
$2d742dbe7f960d8c$export$12f7386070bc380a = $2d742dbe7f960d8c$var$reformIntervals;
$2d742dbe7f960d8c$export$e90fb89750dba83f = $2d742dbe7f960d8c$var$isNumeric;


var $ab0c9086dd6c5b39$var$parsePercent = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f;
var $a4be9366aeb9fcc8$exports = {};

$parcel$export($a4be9366aeb9fcc8$exports, "addCommas", () => $a4be9366aeb9fcc8$export$b6fe44657ce35c42, (v) => $a4be9366aeb9fcc8$export$b6fe44657ce35c42 = v);
$parcel$export($a4be9366aeb9fcc8$exports, "toCamelCase", () => $a4be9366aeb9fcc8$export$86f54f62aa7a7514, (v) => $a4be9366aeb9fcc8$export$86f54f62aa7a7514 = v);
$parcel$export($a4be9366aeb9fcc8$exports, "normalizeCssArray", () => $a4be9366aeb9fcc8$export$f3a38102c49f4268, (v) => $a4be9366aeb9fcc8$export$f3a38102c49f4268 = v);
$parcel$export($a4be9366aeb9fcc8$exports, "encodeHTML", () => $a4be9366aeb9fcc8$export$f9d6449b9af28dc1, (v) => $a4be9366aeb9fcc8$export$f9d6449b9af28dc1 = v);
$parcel$export($a4be9366aeb9fcc8$exports, "formatTpl", () => $a4be9366aeb9fcc8$export$2028496a35766e41, (v) => $a4be9366aeb9fcc8$export$2028496a35766e41 = v);
$parcel$export($a4be9366aeb9fcc8$exports, "formatTplSimple", () => $a4be9366aeb9fcc8$export$2fa08233ee42f8e1, (v) => $a4be9366aeb9fcc8$export$2fa08233ee42f8e1 = v);
$parcel$export($a4be9366aeb9fcc8$exports, "getTooltipMarker", () => $a4be9366aeb9fcc8$export$1987a3dbdf3c45ca, (v) => $a4be9366aeb9fcc8$export$1987a3dbdf3c45ca = v);
$parcel$export($a4be9366aeb9fcc8$exports, "formatTime", () => $a4be9366aeb9fcc8$export$3203edd9e5edd663, (v) => $a4be9366aeb9fcc8$export$3203edd9e5edd663 = v);
$parcel$export($a4be9366aeb9fcc8$exports, "capitalFirst", () => $a4be9366aeb9fcc8$export$38a1e7552f497c0e, (v) => $a4be9366aeb9fcc8$export$38a1e7552f497c0e = v);
$parcel$export($a4be9366aeb9fcc8$exports, "truncateText", () => $a4be9366aeb9fcc8$export$59a943b34a82e690, (v) => $a4be9366aeb9fcc8$export$59a943b34a82e690 = v);
$parcel$export($a4be9366aeb9fcc8$exports, "getTextBoundingRect", () => $a4be9366aeb9fcc8$export$350786ac99772852, (v) => $a4be9366aeb9fcc8$export$350786ac99772852 = v);
$parcel$export($a4be9366aeb9fcc8$exports, "getTextRect", () => $a4be9366aeb9fcc8$export$372ffda650a6e70d, (v) => $a4be9366aeb9fcc8$export$372ffda650a6e70d = v);
$parcel$export($a4be9366aeb9fcc8$exports, "windowOpen", () => $a4be9366aeb9fcc8$export$13e13f9b96dbe8fa, (v) => $a4be9366aeb9fcc8$export$13e13f9b96dbe8fa = v);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $a4be9366aeb9fcc8$export$b6fe44657ce35c42;
var $a4be9366aeb9fcc8$export$86f54f62aa7a7514;
var $a4be9366aeb9fcc8$export$f3a38102c49f4268;
var $a4be9366aeb9fcc8$export$f9d6449b9af28dc1;
var $a4be9366aeb9fcc8$export$2028496a35766e41;
var $a4be9366aeb9fcc8$export$2fa08233ee42f8e1;
var $a4be9366aeb9fcc8$export$1987a3dbdf3c45ca;
var $a4be9366aeb9fcc8$export$3203edd9e5edd663;
var $a4be9366aeb9fcc8$export$38a1e7552f497c0e;
var $a4be9366aeb9fcc8$export$59a943b34a82e690;
var $a4be9366aeb9fcc8$export$350786ac99772852;
var $a4be9366aeb9fcc8$export$372ffda650a6e70d;
var $a4be9366aeb9fcc8$export$13e13f9b96dbe8fa;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // import Text from 'zrender/src/graphic/Text';
/**
 * add commas after every three numbers
 * @param {string|number} x
 * @return {string}
 */ function $a4be9366aeb9fcc8$var$addCommas(x) {
    if (isNaN(x)) return "-";
    x = (x + "").split(".");
    return x[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, "$1,") + (x.length > 1 ? "." + x[1] : "");
}
/**
 * @param {string} str
 * @param {boolean} [upperCaseFirst=false]
 * @return {string} str
 */ function $a4be9366aeb9fcc8$var$toCamelCase(str, upperCaseFirst) {
    str = (str || "").toLowerCase().replace(/-(.)/g, function(match, group1) {
        return group1.toUpperCase();
    });
    if (upperCaseFirst && str) str = str.charAt(0).toUpperCase() + str.slice(1);
    return str;
}
var $a4be9366aeb9fcc8$var$normalizeCssArray = $ec279652dd95c27b$export$f3a38102c49f4268;
var $a4be9366aeb9fcc8$var$replaceReg = /([&<>"'])/g;
var $a4be9366aeb9fcc8$var$replaceMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
function $a4be9366aeb9fcc8$var$encodeHTML(source) {
    return source == null ? "" : (source + "").replace($a4be9366aeb9fcc8$var$replaceReg, function(str, c) {
        return $a4be9366aeb9fcc8$var$replaceMap[c];
    });
}
var $a4be9366aeb9fcc8$var$TPL_VAR_ALIAS = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g"
];
var $a4be9366aeb9fcc8$var$wrapVar = function(varName, seriesIdx) {
    return "{" + varName + (seriesIdx == null ? "" : seriesIdx) + "}";
};
/**
 * Template formatter
 * @param {string} tpl
 * @param {Array.<Object>|Object} paramsList
 * @param {boolean} [encode=false]
 * @return {string}
 */ function $a4be9366aeb9fcc8$var$formatTpl(tpl, paramsList, encode) {
    if (!$ec279652dd95c27b$export$43bee75e5e14138e(paramsList)) paramsList = [
        paramsList
    ];
    var seriesLen = paramsList.length;
    if (!seriesLen) return "";
    var $vars = paramsList[0].$vars || [];
    for(var i = 0; i < $vars.length; i++){
        var alias = $a4be9366aeb9fcc8$var$TPL_VAR_ALIAS[i];
        tpl = tpl.replace($a4be9366aeb9fcc8$var$wrapVar(alias), $a4be9366aeb9fcc8$var$wrapVar(alias, 0));
    }
    for(var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++)for(var k = 0; k < $vars.length; k++){
        var val = paramsList[seriesIdx][$vars[k]];
        tpl = tpl.replace($a4be9366aeb9fcc8$var$wrapVar($a4be9366aeb9fcc8$var$TPL_VAR_ALIAS[k], seriesIdx), encode ? $a4be9366aeb9fcc8$var$encodeHTML(val) : val);
    }
    return tpl;
}
/**
 * simple Template formatter
 *
 * @param {string} tpl
 * @param {Object} param
 * @param {boolean} [encode=false]
 * @return {string}
 */ function $a4be9366aeb9fcc8$var$formatTplSimple(tpl, param, encode) {
    $ec279652dd95c27b$export$79b2f7037acddd43(param, function(value, key) {
        tpl = tpl.replace("{" + key + "}", encode ? $a4be9366aeb9fcc8$var$encodeHTML(value) : value);
    });
    return tpl;
}
/**
 * @param {Object|string} [opt] If string, means color.
 * @param {string} [opt.color]
 * @param {string} [opt.extraCssText]
 * @param {string} [opt.type='item'] 'item' or 'subItem'
 * @param {string} [opt.renderMode='html'] render mode of tooltip, 'html' or 'richText'
 * @param {string} [opt.markerId='X'] id name for marker. If only one marker is in a rich text, this can be omitted.
 * @return {string}
 */ function $a4be9366aeb9fcc8$var$getTooltipMarker(opt, extraCssText) {
    opt = $ec279652dd95c27b$export$844ec244b1367d54(opt) ? {
        color: opt,
        extraCssText: extraCssText
    } : opt || {};
    var color = opt.color;
    var type = opt.type;
    var extraCssText = opt.extraCssText;
    var renderMode = opt.renderMode || "html";
    var markerId = opt.markerId || "X";
    if (!color) return "";
    if (renderMode === "html") return type === "subItem" ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' + $a4be9366aeb9fcc8$var$encodeHTML(color) + ";" + (extraCssText || "") + '"></span>' : '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + $a4be9366aeb9fcc8$var$encodeHTML(color) + ";" + (extraCssText || "") + '"></span>';
    else // Space for rich element marker
    return {
        renderMode: renderMode,
        content: "{marker" + markerId + "|}  ",
        style: {
            color: color
        }
    };
}
function $a4be9366aeb9fcc8$var$pad(str, len) {
    str += "";
    return "0000".substr(0, len - str.length) + str;
}
/**
 * ISO Date format
 * @param {string} tpl
 * @param {number} value
 * @param {boolean} [isUTC=false] Default in local time.
 *           see `module:echarts/scale/Time`
 *           and `module:echarts/util/number#parseDate`.
 * @inner
 */ function $a4be9366aeb9fcc8$var$formatTime(tpl, value, isUTC) {
    if (tpl === "week" || tpl === "month" || tpl === "quarter" || tpl === "half-year" || tpl === "year") tpl = "MM-dd\nyyyy";
    var date = $2d742dbe7f960d8c$export$6b862160d295c8e(value);
    var utc = isUTC ? "UTC" : "";
    var y = date["get" + utc + "FullYear"]();
    var M = date["get" + utc + "Month"]() + 1;
    var d = date["get" + utc + "Date"]();
    var h = date["get" + utc + "Hours"]();
    var m = date["get" + utc + "Minutes"]();
    var s = date["get" + utc + "Seconds"]();
    var S = date["get" + utc + "Milliseconds"]();
    tpl = tpl.replace("MM", $a4be9366aeb9fcc8$var$pad(M, 2)).replace("M", M).replace("yyyy", y).replace("yy", y % 100).replace("dd", $a4be9366aeb9fcc8$var$pad(d, 2)).replace("d", d).replace("hh", $a4be9366aeb9fcc8$var$pad(h, 2)).replace("h", h).replace("mm", $a4be9366aeb9fcc8$var$pad(m, 2)).replace("m", m).replace("ss", $a4be9366aeb9fcc8$var$pad(s, 2)).replace("s", s).replace("SSS", $a4be9366aeb9fcc8$var$pad(S, 3));
    return tpl;
}
/**
 * Capital first
 * @param {string} str
 * @return {string}
 */ function $a4be9366aeb9fcc8$var$capitalFirst(str) {
    return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}
var $a4be9366aeb9fcc8$var$truncateText = $ebae9c4ebc22906c$export$59a943b34a82e690;
/**
 * @public
 * @param {Object} opt
 * @param {string} opt.text
 * @param {string} opt.font
 * @param {string} [opt.textAlign='left']
 * @param {string} [opt.textVerticalAlign='top']
 * @param {Array.<number>} [opt.textPadding]
 * @param {number} [opt.textLineHeight]
 * @param {Object} [opt.rich]
 * @param {Object} [opt.truncate]
 * @return {Object} {x, y, width, height, lineHeight}
 */ function $a4be9366aeb9fcc8$var$getTextBoundingRect(opt) {
    return $ebae9c4ebc22906c$export$c381147bfed79d9f(opt.text, opt.font, opt.textAlign, opt.textVerticalAlign, opt.textPadding, opt.textLineHeight, opt.rich, opt.truncate);
}
/**
 * @deprecated
 * the `textLineHeight` was added later.
 * For backward compatiblility, put it as the last parameter.
 * But deprecated this interface. Please use `getTextBoundingRect` instead.
 */ function $a4be9366aeb9fcc8$var$getTextRect(text, font, textAlign, textVerticalAlign, textPadding, rich, truncate, textLineHeight) {
    return $ebae9c4ebc22906c$export$c381147bfed79d9f(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate);
}
/**
 * open new tab
 * @param {string} link url
 * @param {string} target blank or self
 */ function $a4be9366aeb9fcc8$var$windowOpen(link, target) {
    if (target === "_blank" || target === "blank") {
        var blank = window.open();
        blank.opener = null;
        blank.location = link;
    } else window.open(link, target);
}
$a4be9366aeb9fcc8$export$b6fe44657ce35c42 = $a4be9366aeb9fcc8$var$addCommas;
$a4be9366aeb9fcc8$export$86f54f62aa7a7514 = $a4be9366aeb9fcc8$var$toCamelCase;
$a4be9366aeb9fcc8$export$f3a38102c49f4268 = $a4be9366aeb9fcc8$var$normalizeCssArray;
$a4be9366aeb9fcc8$export$f9d6449b9af28dc1 = $a4be9366aeb9fcc8$var$encodeHTML;
$a4be9366aeb9fcc8$export$2028496a35766e41 = $a4be9366aeb9fcc8$var$formatTpl;
$a4be9366aeb9fcc8$export$2fa08233ee42f8e1 = $a4be9366aeb9fcc8$var$formatTplSimple;
$a4be9366aeb9fcc8$export$1987a3dbdf3c45ca = $a4be9366aeb9fcc8$var$getTooltipMarker;
$a4be9366aeb9fcc8$export$3203edd9e5edd663 = $a4be9366aeb9fcc8$var$formatTime;
$a4be9366aeb9fcc8$export$38a1e7552f497c0e = $a4be9366aeb9fcc8$var$capitalFirst;
$a4be9366aeb9fcc8$export$59a943b34a82e690 = $a4be9366aeb9fcc8$var$truncateText;
$a4be9366aeb9fcc8$export$350786ac99772852 = $a4be9366aeb9fcc8$var$getTextBoundingRect;
$a4be9366aeb9fcc8$export$372ffda650a6e70d = $a4be9366aeb9fcc8$var$getTextRect;
$a4be9366aeb9fcc8$export$13e13f9b96dbe8fa = $a4be9366aeb9fcc8$var$windowOpen;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Layout helpers for each component positioning
var $ab0c9086dd6c5b39$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
/**
 * @public
 */ var $ab0c9086dd6c5b39$var$LOCATION_PARAMS = [
    "left",
    "right",
    "top",
    "bottom",
    "width",
    "height"
];
/**
 * @public
 */ var $ab0c9086dd6c5b39$var$HV_NAMES = [
    [
        "width",
        "left",
        "right"
    ],
    [
        "height",
        "top",
        "bottom"
    ]
];
function $ab0c9086dd6c5b39$var$boxLayout(orient, group, gap, maxWidth, maxHeight) {
    var x = 0;
    var y = 0;
    if (maxWidth == null) maxWidth = Infinity;
    if (maxHeight == null) maxHeight = Infinity;
    var currentLineMaxSize = 0;
    group.eachChild(function(child, idx) {
        var position = child.position;
        var rect = child.getBoundingRect();
        var nextChild = group.childAt(idx + 1);
        var nextChildRect = nextChild && nextChild.getBoundingRect();
        var nextX;
        var nextY;
        if (orient === "horizontal") {
            var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
            nextX = x + moveX; // Wrap when width exceeds maxWidth or meet a `newline` group
            // FIXME compare before adding gap?
            if (nextX > maxWidth || child.newline) {
                x = 0;
                nextX = moveX;
                y += currentLineMaxSize + gap;
                currentLineMaxSize = rect.height;
            } else // FIXME: consider rect.y is not `0`?
            currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
        } else {
            var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
            nextY = y + moveY; // Wrap when width exceeds maxHeight or meet a `newline` group
            if (nextY > maxHeight || child.newline) {
                x += currentLineMaxSize + gap;
                y = 0;
                nextY = moveY;
                currentLineMaxSize = rect.width;
            } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
        }
        if (child.newline) return;
        position[0] = x;
        position[1] = y;
        orient === "horizontal" ? x = nextX + gap : y = nextY + gap;
    });
}
/**
 * VBox or HBox layouting
 * @param {string} orient
 * @param {module:zrender/container/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */ var $ab0c9086dd6c5b39$var$box = $ab0c9086dd6c5b39$var$boxLayout;
/**
 * VBox layouting
 * @param {module:zrender/container/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */ var $ab0c9086dd6c5b39$var$vbox = $ec279652dd95c27b$export$c3095a23b368d1f2($ab0c9086dd6c5b39$var$boxLayout, "vertical");
/**
 * HBox layouting
 * @param {module:zrender/container/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */ var $ab0c9086dd6c5b39$var$hbox = $ec279652dd95c27b$export$c3095a23b368d1f2($ab0c9086dd6c5b39$var$boxLayout, "horizontal");
/**
 * If x or x2 is not specified or 'center' 'left' 'right',
 * the width would be as long as possible.
 * If y or y2 is not specified or 'middle' 'top' 'bottom',
 * the height would be as long as possible.
 *
 * @param {Object} positionInfo
 * @param {number|string} [positionInfo.x]
 * @param {number|string} [positionInfo.y]
 * @param {number|string} [positionInfo.x2]
 * @param {number|string} [positionInfo.y2]
 * @param {Object} containerRect {width, height}
 * @param {string|number} margin
 * @return {Object} {width, height}
 */ function $ab0c9086dd6c5b39$var$getAvailableSize(positionInfo, containerRect, margin) {
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var x = $ab0c9086dd6c5b39$var$parsePercent(positionInfo.x, containerWidth);
    var y = $ab0c9086dd6c5b39$var$parsePercent(positionInfo.y, containerHeight);
    var x2 = $ab0c9086dd6c5b39$var$parsePercent(positionInfo.x2, containerWidth);
    var y2 = $ab0c9086dd6c5b39$var$parsePercent(positionInfo.y2, containerHeight);
    (isNaN(x) || isNaN(parseFloat(positionInfo.x))) && (x = 0);
    (isNaN(x2) || isNaN(parseFloat(positionInfo.x2))) && (x2 = containerWidth);
    (isNaN(y) || isNaN(parseFloat(positionInfo.y))) && (y = 0);
    (isNaN(y2) || isNaN(parseFloat(positionInfo.y2))) && (y2 = containerHeight);
    margin = $a4be9366aeb9fcc8$export$f3a38102c49f4268(margin || 0);
    return {
        width: Math.max(x2 - x - margin[1] - margin[3], 0),
        height: Math.max(y2 - y - margin[0] - margin[2], 0)
    };
}
/**
 * Parse position info.
 *
 * @param {Object} positionInfo
 * @param {number|string} [positionInfo.left]
 * @param {number|string} [positionInfo.top]
 * @param {number|string} [positionInfo.right]
 * @param {number|string} [positionInfo.bottom]
 * @param {number|string} [positionInfo.width]
 * @param {number|string} [positionInfo.height]
 * @param {number|string} [positionInfo.aspect] Aspect is width / height
 * @param {Object} containerRect
 * @param {string|number} [margin]
 *
 * @return {module:zrender/core/BoundingRect}
 */ function $ab0c9086dd6c5b39$var$getLayoutRect(positionInfo, containerRect, margin) {
    margin = $a4be9366aeb9fcc8$export$f3a38102c49f4268(margin || 0);
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var left = $ab0c9086dd6c5b39$var$parsePercent(positionInfo.left, containerWidth);
    var top = $ab0c9086dd6c5b39$var$parsePercent(positionInfo.top, containerHeight);
    var right = $ab0c9086dd6c5b39$var$parsePercent(positionInfo.right, containerWidth);
    var bottom = $ab0c9086dd6c5b39$var$parsePercent(positionInfo.bottom, containerHeight);
    var width = $ab0c9086dd6c5b39$var$parsePercent(positionInfo.width, containerWidth);
    var height = $ab0c9086dd6c5b39$var$parsePercent(positionInfo.height, containerHeight);
    var verticalMargin = margin[2] + margin[0];
    var horizontalMargin = margin[1] + margin[3];
    var aspect = positionInfo.aspect; // If width is not specified, calculate width from left and right
    if (isNaN(width)) width = containerWidth - right - horizontalMargin - left;
    if (isNaN(height)) height = containerHeight - bottom - verticalMargin - top;
    if (aspect != null) {
        // If width and height are not given
        // 1. Graph should not exceeds the container
        // 2. Aspect must be keeped
        // 3. Graph should take the space as more as possible
        // FIXME
        // Margin is not considered, because there is no case that both
        // using margin and aspect so far.
        if (isNaN(width) && isNaN(height)) {
            if (aspect > containerWidth / containerHeight) width = containerWidth * 0.8;
            else height = containerHeight * 0.8;
        } // Calculate width or height with given aspect
        if (isNaN(width)) width = aspect * height;
        if (isNaN(height)) height = width / aspect;
    } // If left is not specified, calculate left from right and width
    if (isNaN(left)) left = containerWidth - right - width - horizontalMargin;
    if (isNaN(top)) top = containerHeight - bottom - height - verticalMargin;
     // Align left and top
    switch(positionInfo.left || positionInfo.right){
        case "center":
            left = containerWidth / 2 - width / 2 - margin[3];
            break;
        case "right":
            left = containerWidth - width - horizontalMargin;
            break;
    }
    switch(positionInfo.top || positionInfo.bottom){
        case "middle":
        case "center":
            top = containerHeight / 2 - height / 2 - margin[0];
            break;
        case "bottom":
            top = containerHeight - height - verticalMargin;
            break;
    } // If something is wrong and left, top, width, height are calculated as NaN
    left = left || 0;
    top = top || 0;
    if (isNaN(width)) // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
    if (isNaN(height)) // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
    var rect = new $33e4fae744d34798$exports(left + margin[3], top + margin[0], width, height);
    rect.margin = margin;
    return rect;
}
/**
 * Position a zr element in viewport
 *  Group position is specified by either
 *  {left, top}, {right, bottom}
 *  If all properties exists, right and bottom will be igonred.
 *
 * Logic:
 *     1. Scale (against origin point in parent coord)
 *     2. Rotate (against origin point in parent coord)
 *     3. Traslate (with el.position by this method)
 * So this method only fixes the last step 'Traslate', which does not affect
 * scaling and rotating.
 *
 * If be called repeatly with the same input el, the same result will be gotten.
 *
 * @param {module:zrender/Element} el Should have `getBoundingRect` method.
 * @param {Object} positionInfo
 * @param {number|string} [positionInfo.left]
 * @param {number|string} [positionInfo.top]
 * @param {number|string} [positionInfo.right]
 * @param {number|string} [positionInfo.bottom]
 * @param {number|string} [positionInfo.width] Only for opt.boundingModel: 'raw'
 * @param {number|string} [positionInfo.height] Only for opt.boundingModel: 'raw'
 * @param {Object} containerRect
 * @param {string|number} margin
 * @param {Object} [opt]
 * @param {Array.<number>} [opt.hv=[1,1]] Only horizontal or only vertical.
 * @param {Array.<number>} [opt.boundingMode='all']
 *        Specify how to calculate boundingRect when locating.
 *        'all': Position the boundingRect that is transformed and uioned
 *               both itself and its descendants.
 *               This mode simplies confine the elements in the bounding
 *               of their container (e.g., using 'right: 0').
 *        'raw': Position the boundingRect that is not transformed and only itself.
 *               This mode is useful when you want a element can overflow its
 *               container. (Consider a rotated circle needs to be located in a corner.)
 *               In this mode positionInfo.width/height can only be number.
 */ function $ab0c9086dd6c5b39$var$positionElement(el, positionInfo, containerRect, margin, opt) {
    var h = !opt || !opt.hv || opt.hv[0];
    var v = !opt || !opt.hv || opt.hv[1];
    var boundingMode = opt && opt.boundingMode || "all";
    if (!h && !v) return;
    var rect;
    if (boundingMode === "raw") rect = el.type === "group" ? new $33e4fae744d34798$exports(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
    else {
        rect = el.getBoundingRect();
        if (el.needLocalTransform()) {
            var transform = el.getLocalTransform(); // Notice: raw rect may be inner object of el,
            // which should not be modified.
            rect = rect.clone();
            rect.applyTransform(transform);
        }
    } // The real width and height can not be specified but calculated by the given el.
    positionInfo = $ab0c9086dd6c5b39$var$getLayoutRect($ec279652dd95c27b$export$ebe90cb607ad99e({
        width: rect.width,
        height: rect.height
    }, positionInfo), containerRect, margin); // Because 'tranlate' is the last step in transform
    // (see zrender/core/Transformable#getLocalTransform),
    // we can just only modify el.position to get final result.
    var elPos = el.position;
    var dx = h ? positionInfo.x - rect.x : 0;
    var dy = v ? positionInfo.y - rect.y : 0;
    el.attr("position", boundingMode === "raw" ? [
        dx,
        dy
    ] : [
        elPos[0] + dx,
        elPos[1] + dy
    ]);
}
/**
 * @param {Object} option Contains some of the properties in HV_NAMES.
 * @param {number} hvIdx 0: horizontal; 1: vertical.
 */ function $ab0c9086dd6c5b39$var$sizeCalculable(option, hvIdx) {
    return option[$ab0c9086dd6c5b39$var$HV_NAMES[hvIdx][0]] != null || option[$ab0c9086dd6c5b39$var$HV_NAMES[hvIdx][1]] != null && option[$ab0c9086dd6c5b39$var$HV_NAMES[hvIdx][2]] != null;
}
/**
 * Consider Case:
 * When defulat option has {left: 0, width: 100}, and we set {right: 0}
 * through setOption or media query, using normal zrUtil.merge will cause
 * {right: 0} does not take effect.
 *
 * @example
 * ComponentModel.extend({
 *     init: function () {
 *         ...
 *         var inputPositionParams = layout.getLayoutParams(option);
 *         this.mergeOption(inputPositionParams);
 *     },
 *     mergeOption: function (newOption) {
 *         newOption && zrUtil.merge(thisOption, newOption, true);
 *         layout.mergeLayoutParam(thisOption, newOption);
 *     }
 * });
 *
 * @param {Object} targetOption
 * @param {Object} newOption
 * @param {Object|string} [opt]
 * @param {boolean|Array.<boolean>} [opt.ignoreSize=false] Used for the components
 *  that width (or height) should not be calculated by left and right (or top and bottom).
 */ function $ab0c9086dd6c5b39$var$mergeLayoutParam(targetOption, newOption, opt) {
    !$ec279652dd95c27b$export$a6cdc56e425d0d0a(opt) && (opt = {});
    var ignoreSize = opt.ignoreSize;
    !$ec279652dd95c27b$export$43bee75e5e14138e(ignoreSize) && (ignoreSize = [
        ignoreSize,
        ignoreSize
    ]);
    var hResult = merge($ab0c9086dd6c5b39$var$HV_NAMES[0], 0);
    var vResult = merge($ab0c9086dd6c5b39$var$HV_NAMES[1], 1);
    copy($ab0c9086dd6c5b39$var$HV_NAMES[0], targetOption, hResult);
    copy($ab0c9086dd6c5b39$var$HV_NAMES[1], targetOption, vResult);
    function merge(names, hvIdx) {
        var newParams = {};
        var newValueCount = 0;
        var merged = {};
        var mergedValueCount = 0;
        var enoughParamNumber = 2;
        $ab0c9086dd6c5b39$var$each(names, function(name) {
            merged[name] = targetOption[name];
        });
        $ab0c9086dd6c5b39$var$each(names, function(name) {
            // Consider case: newOption.width is null, which is
            // set by user for removing width setting.
            hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
            hasValue(newParams, name) && newValueCount++;
            hasValue(merged, name) && mergedValueCount++;
        });
        if (ignoreSize[hvIdx]) {
            // Only one of left/right is premitted to exist.
            if (hasValue(newOption, names[1])) merged[names[2]] = null;
            else if (hasValue(newOption, names[2])) merged[names[1]] = null;
            return merged;
        } // Case: newOption: {width: ..., right: ...},
        // or targetOption: {right: ...} and newOption: {width: ...},
        // There is no conflict when merged only has params count
        // little than enoughParamNumber.
        if (mergedValueCount === enoughParamNumber || !newValueCount) return merged;
        else if (newValueCount >= enoughParamNumber) return newParams;
        else {
            // Chose another param from targetOption by priority.
            for(var i = 0; i < names.length; i++){
                var name = names[i];
                if (!hasProp(newParams, name) && hasProp(targetOption, name)) {
                    newParams[name] = targetOption[name];
                    break;
                }
            }
            return newParams;
        }
    }
    function hasProp(obj, name) {
        return obj.hasOwnProperty(name);
    }
    function hasValue(obj, name) {
        return obj[name] != null && obj[name] !== "auto";
    }
    function copy(names, target, source) {
        $ab0c9086dd6c5b39$var$each(names, function(name) {
            target[name] = source[name];
        });
    }
}
/**
 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
 * @param {Object} source
 * @return {Object} Result contains those props.
 */ function $ab0c9086dd6c5b39$var$getLayoutParams(source) {
    return $ab0c9086dd6c5b39$var$copyLayoutParams({}, source);
}
/**
 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
 * @param {Object} source
 * @return {Object} Result contains those props.
 */ function $ab0c9086dd6c5b39$var$copyLayoutParams(target, source) {
    source && target && $ab0c9086dd6c5b39$var$each($ab0c9086dd6c5b39$var$LOCATION_PARAMS, function(name) {
        source.hasOwnProperty(name) && (target[name] = source[name]);
    });
    return target;
}
$ab0c9086dd6c5b39$export$a9aa2cc018afbed = $ab0c9086dd6c5b39$var$LOCATION_PARAMS;
$ab0c9086dd6c5b39$export$d7fd4338c7b20804 = $ab0c9086dd6c5b39$var$HV_NAMES;
$ab0c9086dd6c5b39$export$827f4ee28efc37 = $ab0c9086dd6c5b39$var$box;
$ab0c9086dd6c5b39$export$be20d9158c17374c = $ab0c9086dd6c5b39$var$vbox;
$ab0c9086dd6c5b39$export$ae65a483d943e7a7 = $ab0c9086dd6c5b39$var$hbox;
$ab0c9086dd6c5b39$export$145a8938a85a22b1 = $ab0c9086dd6c5b39$var$getAvailableSize;
$ab0c9086dd6c5b39$export$4517a5ca639a7293 = $ab0c9086dd6c5b39$var$getLayoutRect;
$ab0c9086dd6c5b39$export$74054bd96b5eeef1 = $ab0c9086dd6c5b39$var$positionElement;
$ab0c9086dd6c5b39$export$7ede609e8ebc9650 = $ab0c9086dd6c5b39$var$sizeCalculable;
$ab0c9086dd6c5b39$export$1754cb91f16ca028 = $ab0c9086dd6c5b39$var$mergeLayoutParam;
$ab0c9086dd6c5b39$export$4b0d20af19c9875e = $ab0c9086dd6c5b39$var$getLayoutParams;
$ab0c9086dd6c5b39$export$7438999faea9b6cc = $ab0c9086dd6c5b39$var$copyLayoutParams;


var $501b99e5c9bfce9d$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $501b99e5c9bfce9d$var$_default = {
    getBoxLayoutParams: function() {
        return {
            left: this.get("left"),
            top: this.get("top"),
            right: this.get("right"),
            bottom: this.get("bottom"),
            width: this.get("width"),
            height: this.get("height")
        };
    }
};
$501b99e5c9bfce9d$exports = $501b99e5c9bfce9d$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Component model
 *
 * @module echarts/model/Component
 */ var $3b9c2389e45dfb7d$var$inner = $3b9c2389e45dfb7d$var$makeInner();
/**
 * @alias module:echarts/model/Component
 * @constructor
 * @param {Object} option
 * @param {module:echarts/model/Model} parentModel
 * @param {module:echarts/model/Model} ecModel
 */ var $3b9c2389e45dfb7d$var$ComponentModel = $2b51b4bf776ec22e$exports.extend({
    type: "component",
    /**
   * @readOnly
   * @type {string}
   */ id: "",
    /**
   * Because simplified concept is probably better, series.name (or component.name)
   * has been having too many resposibilities:
   * (1) Generating id (which requires name in option should not be modified).
   * (2) As an index to mapping series when merging option or calling API (a name
   * can refer to more then one components, which is convinient is some case).
   * (3) Display.
   * @readOnly
   */ name: "",
    /**
   * @readOnly
   * @type {string}
   */ mainType: "",
    /**
   * @readOnly
   * @type {string}
   */ subType: "",
    /**
   * @readOnly
   * @type {number}
   */ componentIndex: 0,
    /**
   * @type {Object}
   * @protected
   */ defaultOption: null,
    /**
   * @type {module:echarts/model/Global}
   * @readOnly
   */ ecModel: null,
    /**
   * key: componentType
   * value:  Component model list, can not be null.
   * @type {Object.<string, Array.<module:echarts/model/Model>>}
   * @readOnly
   */ dependentModels: [],
    /**
   * @type {string}
   * @readOnly
   */ uid: null,
    /**
   * Support merge layout params.
   * Only support 'box' now (left/right/top/bottom/width/height).
   * @type {string|Object} Object can be {ignoreSize: true}
   * @readOnly
   */ layoutMode: null,
    $constructor: function(option, parentModel, ecModel, extraOpt) {
        $2b51b4bf776ec22e$exports.call(this, option, parentModel, ecModel, extraOpt);
        this.uid = $a39499a9dbffdb7d$export$6d2b3473b0986646("ec_cpt_model");
    },
    init: function(option, parentModel, ecModel, extraOpt) {
        this.mergeDefaultAndTheme(option, ecModel);
    },
    mergeDefaultAndTheme: function(option, ecModel) {
        var layoutMode = this.layoutMode;
        var inputPositionParams = layoutMode ? $ab0c9086dd6c5b39$export$4b0d20af19c9875e(option) : {};
        var themeModel = ecModel.getTheme();
        $ec279652dd95c27b$export$4950aa0f605343fb(option, themeModel.get(this.mainType));
        $ec279652dd95c27b$export$4950aa0f605343fb(option, this.getDefaultOption());
        if (layoutMode) $ab0c9086dd6c5b39$export$1754cb91f16ca028(option, inputPositionParams, layoutMode);
    },
    mergeOption: function(option, extraOpt) {
        $ec279652dd95c27b$export$4950aa0f605343fb(this.option, option, true);
        var layoutMode = this.layoutMode;
        if (layoutMode) $ab0c9086dd6c5b39$export$1754cb91f16ca028(this.option, option, layoutMode);
    },
    // Hooker after init or mergeOption
    optionUpdated: function(newCptOption, isInit) {},
    getDefaultOption: function() {
        var fields = $3b9c2389e45dfb7d$var$inner(this);
        if (!fields.defaultOption) {
            var optList = [];
            var Class = this.constructor;
            while(Class){
                var opt = Class.prototype.defaultOption;
                opt && optList.push(opt);
                Class = Class.superClass;
            }
            var defaultOption = {};
            for(var i = optList.length - 1; i >= 0; i--)defaultOption = $ec279652dd95c27b$export$4950aa0f605343fb(defaultOption, optList[i], true);
            fields.defaultOption = defaultOption;
        }
        return fields.defaultOption;
    },
    getReferringComponents: function(mainType) {
        return this.ecModel.queryComponents({
            mainType: mainType,
            index: this.get(mainType + "Index", true),
            id: this.get(mainType + "Id", true)
        });
    }
}); // Reset ComponentModel.extend, add preConstruct.
// clazzUtil.enableClassExtend(
//     ComponentModel,
//     function (option, parentModel, ecModel, extraOpt) {
//         // Set dependentModels, componentIndex, name, id, mainType, subType.
//         zrUtil.extend(this, extraOpt);
//         this.uid = componentUtil.getUID('componentModel');
//         // this.setReadOnly([
//         //     'type', 'id', 'uid', 'name', 'mainType', 'subType',
//         //     'dependentModels', 'componentIndex'
//         // ]);
//     }
// );
// Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
$3b9c2389e45dfb7d$var$enableClassManagement($3b9c2389e45dfb7d$var$ComponentModel, {
    registerWhenExtend: true
});
$a39499a9dbffdb7d$export$b9faf30b7d655a6f($3b9c2389e45dfb7d$var$ComponentModel); // Add capability of ComponentModel.topologicalTravel.
$a39499a9dbffdb7d$export$ce592d345a3ec040($3b9c2389e45dfb7d$var$ComponentModel, $3b9c2389e45dfb7d$var$getDependencies);
function $3b9c2389e45dfb7d$var$getDependencies(componentType) {
    var deps = [];
    $ec279652dd95c27b$export$79b2f7037acddd43($3b9c2389e45dfb7d$var$ComponentModel.getClassesByMainType(componentType), function(Clazz) {
        deps = deps.concat(Clazz.prototype.dependencies || []);
    }); // Ensure main type.
    deps = $ec279652dd95c27b$export$871de8747c9eaa88(deps, function(type) {
        return $3b9c2389e45dfb7d$var$parseClassType(type).main;
    }); // Hack dataset for convenience.
    if (componentType !== "dataset" && $ec279652dd95c27b$export$305f7d4e9d4624f2(deps, "dataset") <= 0) deps.unshift("dataset");
    return deps;
}
$ec279652dd95c27b$export$e36fc9d62a853069($3b9c2389e45dfb7d$var$ComponentModel, $501b99e5c9bfce9d$exports);
var $3b9c2389e45dfb7d$var$_default = $3b9c2389e45dfb7d$var$ComponentModel;
$3b9c2389e45dfb7d$exports = $3b9c2389e45dfb7d$var$_default;


var $45541fb6e3126ae5$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $45541fb6e3126ae5$var$platform = ""; // Navigator not exists in node
if (typeof navigator !== "undefined") $45541fb6e3126ae5$var$platform = navigator.platform || "";
var $45541fb6e3126ae5$var$_default = {
    // backgroundColor: 'rgba(0,0,0,0)',
    // https://dribbble.com/shots/1065960-Infographic-Pie-chart-visualization
    // color: ['#5793f3', '#d14a61', '#fd9c35', '#675bba', '#fec42c', '#dd4444', '#d4df5a', '#cd4870'],
    // Light colors:
    // color: ['#bcd3bb', '#e88f70', '#edc1a5', '#9dc5c8', '#e1e8c8', '#7b7c68', '#e5b5b5', '#f0b489', '#928ea8', '#bda29a'],
    // color: ['#cc5664', '#9bd6ec', '#ea946e', '#8acaaa', '#f1ec64', '#ee8686', '#a48dc1', '#5da6bc', '#b9dcae'],
    // Dark colors:
    color: [
        "#c23531",
        "#2f4554",
        "#61a0a8",
        "#d48265",
        "#91c7ae",
        "#749f83",
        "#ca8622",
        "#bda29a",
        "#6e7074",
        "#546570",
        "#c4ccd3"
    ],
    gradientColor: [
        "#f6efa6",
        "#d88273",
        "#bf444c"
    ],
    // If xAxis and yAxis declared, grid is created by default.
    // grid: {},
    textStyle: {
        // color: '#000',
        // decoration: 'none',
        // PENDING
        fontFamily: $45541fb6e3126ae5$var$platform.match(/^Win/) ? "Microsoft YaHei" : "sans-serif",
        // fontFamily: 'Arial, Verdana, sans-serif',
        fontSize: 12,
        fontStyle: "normal",
        fontWeight: "normal"
    },
    // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
    // Default is source-over
    blendMode: null,
    animation: "auto",
    animationDuration: 1000,
    animationDurationUpdate: 300,
    animationEasing: "exponentialOut",
    animationEasingUpdate: "cubicOut",
    animationThreshold: 2000,
    // Configuration for progressive/incremental rendering
    progressiveThreshold: 3000,
    progressive: 400,
    // Threshold of if use single hover layer to optimize.
    // It is recommended that `hoverLayerThreshold` is equivalent to or less than
    // `progressiveThreshold`, otherwise hover will cause restart of progressive,
    // which is unexpected.
    // see example <echarts/test/heatmap-large.html>.
    hoverLayerThreshold: 3000,
    // See: module:echarts/scale/Time
    useUTC: false
};
$45541fb6e3126ae5$exports = $45541fb6e3126ae5$var$_default;


var $5de0a04ca2e71297$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5de0a04ca2e71297$var$makeInner = $d559f43cb9041423$export$64df9f8d92ae083f;
var $5de0a04ca2e71297$var$normalizeToArray = $d559f43cb9041423$export$4f07b212a02c8051;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $5de0a04ca2e71297$var$inner = $5de0a04ca2e71297$var$makeInner();
function $5de0a04ca2e71297$var$getNearestColorPalette(colors, requestColorNum) {
    var paletteNum = colors.length; // TODO colors must be in order
    for(var i = 0; i < paletteNum; i++){
        if (colors[i].length > requestColorNum) return colors[i];
    }
    return colors[paletteNum - 1];
}
var $5de0a04ca2e71297$var$_default = {
    clearColorPalette: function() {
        $5de0a04ca2e71297$var$inner(this).colorIdx = 0;
        $5de0a04ca2e71297$var$inner(this).colorNameMap = {};
    },
    /**
   * @param {string} name MUST NOT be null/undefined. Otherwise call this function
   *                 twise with the same parameters will get different result.
   * @param {Object} [scope=this]
   * @param {Object} [requestColorNum]
   * @return {string} color string.
   */ getColorFromPalette: function(name, scope, requestColorNum) {
        scope = scope || this;
        var scopeFields = $5de0a04ca2e71297$var$inner(scope);
        var colorIdx = scopeFields.colorIdx || 0;
        var colorNameMap = scopeFields.colorNameMap = scopeFields.colorNameMap || {}; // Use `hasOwnProperty` to avoid conflict with Object.prototype.
        if (colorNameMap.hasOwnProperty(name)) return colorNameMap[name];
        var defaultColorPalette = $5de0a04ca2e71297$var$normalizeToArray(this.get("color", true));
        var layeredColorPalette = this.get("colorLayer", true);
        var colorPalette = requestColorNum == null || !layeredColorPalette ? defaultColorPalette : $5de0a04ca2e71297$var$getNearestColorPalette(layeredColorPalette, requestColorNum); // In case can't find in layered color palette.
        colorPalette = colorPalette || defaultColorPalette;
        if (!colorPalette || !colorPalette.length) return;
        var color = colorPalette[colorIdx];
        if (name) colorNameMap[name] = color;
        scopeFields.colorIdx = (colorIdx + 1) % colorPalette.length;
        return color;
    }
};
$5de0a04ca2e71297$exports = $5de0a04ca2e71297$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $71e1a98f99449cca$export$328749e9c5b40760;
var $71e1a98f99449cca$export$52a469afa4653e57;
var $71e1a98f99449cca$export$dd2b6e807fb37ba3;
var $71e1a98f99449cca$export$b30cdea50aa00e6;
var $71e1a98f99449cca$export$6d45f5142dbcbf3;
var $71e1a98f99449cca$export$37682b8fdd2e83d;
var $71e1a98f99449cca$export$60b8a57d1f2fed26;
var $71e1a98f99449cca$export$c51adf1a2be01b9c;

var $71e1a98f99449cca$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;

var $71e1a98f99449cca$var$makeInner = $d559f43cb9041423$export$64df9f8d92ae083f;
var $71e1a98f99449cca$var$getDataItemValue = $d559f43cb9041423$export$2c944e12edb48d4b;

var $71e1a98f99449cca$var$createHashMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4;
var $71e1a98f99449cca$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $71e1a98f99449cca$var$map = $ec279652dd95c27b$export$871de8747c9eaa88;
var $71e1a98f99449cca$var$isArray = $ec279652dd95c27b$export$43bee75e5e14138e;
var $71e1a98f99449cca$var$isString = $ec279652dd95c27b$export$844ec244b1367d54;
var $71e1a98f99449cca$var$isObject = $ec279652dd95c27b$export$a6cdc56e425d0d0a;
var $71e1a98f99449cca$var$isTypedArray = $ec279652dd95c27b$export$b119cc7e1840e59c;
var $71e1a98f99449cca$var$isArrayLike = $ec279652dd95c27b$export$1e2f57719e155213;
var $71e1a98f99449cca$var$extend = $ec279652dd95c27b$export$8b58be045bf06082;
var $71e1a98f99449cca$var$assert = $ec279652dd95c27b$export$a7a9523472993e97;
var $058c715583456086$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $058c715583456086$var$createHashMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4;
var $058c715583456086$var$isTypedArray = $ec279652dd95c27b$export$b119cc7e1840e59c;

var $058c715583456086$var$enableClassCheck = $c125ba1250423743$export$e1aac4552ae82081;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Avoid typo.
var $00bf3640e0468773$export$2823037fb9d8f0c6;
var $00bf3640e0468773$export$fcd62ebf51387903;
var $00bf3640e0468773$export$703ae8a2d83f441;
var $00bf3640e0468773$export$6a32b42c754a3cb8;
var $00bf3640e0468773$export$c78f1330778d30d;
var $00bf3640e0468773$export$a918cb016a382d45;
var $00bf3640e0468773$export$7b3f3c6551b4949b;
var $00bf3640e0468773$export$d55da1467cdf7804;
var $00bf3640e0468773$var$SOURCE_FORMAT_ORIGINAL = "original";
var $00bf3640e0468773$var$SOURCE_FORMAT_ARRAY_ROWS = "arrayRows";
var $00bf3640e0468773$var$SOURCE_FORMAT_OBJECT_ROWS = "objectRows";
var $00bf3640e0468773$var$SOURCE_FORMAT_KEYED_COLUMNS = "keyedColumns";
var $00bf3640e0468773$var$SOURCE_FORMAT_UNKNOWN = "unknown"; // ??? CHANGE A NAME
var $00bf3640e0468773$var$SOURCE_FORMAT_TYPED_ARRAY = "typedArray";
var $00bf3640e0468773$var$SERIES_LAYOUT_BY_COLUMN = "column";
var $00bf3640e0468773$var$SERIES_LAYOUT_BY_ROW = "row";
$00bf3640e0468773$export$2823037fb9d8f0c6 = $00bf3640e0468773$var$SOURCE_FORMAT_ORIGINAL;
$00bf3640e0468773$export$fcd62ebf51387903 = $00bf3640e0468773$var$SOURCE_FORMAT_ARRAY_ROWS;
$00bf3640e0468773$export$703ae8a2d83f441 = $00bf3640e0468773$var$SOURCE_FORMAT_OBJECT_ROWS;
$00bf3640e0468773$export$6a32b42c754a3cb8 = $00bf3640e0468773$var$SOURCE_FORMAT_KEYED_COLUMNS;
$00bf3640e0468773$export$c78f1330778d30d = $00bf3640e0468773$var$SOURCE_FORMAT_UNKNOWN;
$00bf3640e0468773$export$a918cb016a382d45 = $00bf3640e0468773$var$SOURCE_FORMAT_TYPED_ARRAY;
$00bf3640e0468773$export$7b3f3c6551b4949b = $00bf3640e0468773$var$SERIES_LAYOUT_BY_COLUMN;
$00bf3640e0468773$export$d55da1467cdf7804 = $00bf3640e0468773$var$SERIES_LAYOUT_BY_ROW;


var $058c715583456086$var$SOURCE_FORMAT_ORIGINAL = $00bf3640e0468773$export$2823037fb9d8f0c6;
var $058c715583456086$var$SERIES_LAYOUT_BY_COLUMN = $00bf3640e0468773$export$7b3f3c6551b4949b;
var $058c715583456086$var$SOURCE_FORMAT_UNKNOWN = $00bf3640e0468773$export$c78f1330778d30d;
var $058c715583456086$var$SOURCE_FORMAT_TYPED_ARRAY = $00bf3640e0468773$export$a918cb016a382d45;
var $058c715583456086$var$SOURCE_FORMAT_KEYED_COLUMNS = $00bf3640e0468773$export$6a32b42c754a3cb8;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * [sourceFormat]
 *
 * + "original":
 * This format is only used in series.data, where
 * itemStyle can be specified in data item.
 *
 * + "arrayRows":
 * [
 *     ['product', 'score', 'amount'],
 *     ['Matcha Latte', 89.3, 95.8],
 *     ['Milk Tea', 92.1, 89.4],
 *     ['Cheese Cocoa', 94.4, 91.2],
 *     ['Walnut Brownie', 85.4, 76.9]
 * ]
 *
 * + "objectRows":
 * [
 *     {product: 'Matcha Latte', score: 89.3, amount: 95.8},
 *     {product: 'Milk Tea', score: 92.1, amount: 89.4},
 *     {product: 'Cheese Cocoa', score: 94.4, amount: 91.2},
 *     {product: 'Walnut Brownie', score: 85.4, amount: 76.9}
 * ]
 *
 * + "keyedColumns":
 * {
 *     'product': ['Matcha Latte', 'Milk Tea', 'Cheese Cocoa', 'Walnut Brownie'],
 *     'count': [823, 235, 1042, 988],
 *     'score': [95.8, 81.4, 91.2, 76.9]
 * }
 *
 * + "typedArray"
 *
 * + "unknown"
 */ /**
 * @constructor
 * @param {Object} fields
 * @param {string} fields.sourceFormat
 * @param {Array|Object} fields.fromDataset
 * @param {Array|Object} [fields.data]
 * @param {string} [seriesLayoutBy='column']
 * @param {Array.<Object|string>} [dimensionsDefine]
 * @param {Objet|HashMap} [encodeDefine]
 * @param {number} [startIndex=0]
 * @param {number} [dimensionsDetectCount]
 */ function $058c715583456086$var$Source(fields) {
    /**
   * @type {boolean}
   */ this.fromDataset = fields.fromDataset;
    /**
   * Not null/undefined.
   * @type {Array|Object}
   */ this.data = fields.data || (fields.sourceFormat === $058c715583456086$var$SOURCE_FORMAT_KEYED_COLUMNS ? {} : []);
    /**
   * See also "detectSourceFormat".
   * Not null/undefined.
   * @type {string}
   */ this.sourceFormat = fields.sourceFormat || $058c715583456086$var$SOURCE_FORMAT_UNKNOWN;
    /**
   * 'row' or 'column'
   * Not null/undefined.
   * @type {string} seriesLayoutBy
   */ this.seriesLayoutBy = fields.seriesLayoutBy || $058c715583456086$var$SERIES_LAYOUT_BY_COLUMN;
    /**
   * dimensions definition in option.
   * can be null/undefined.
   * @type {Array.<Object|string>}
   */ this.dimensionsDefine = fields.dimensionsDefine;
    /**
   * encode definition in option.
   * can be null/undefined.
   * @type {Objet|HashMap}
   */ this.encodeDefine = fields.encodeDefine && $058c715583456086$var$createHashMap(fields.encodeDefine);
    /**
   * Not null/undefined, uint.
   * @type {number}
   */ this.startIndex = fields.startIndex || 0;
    /**
   * Can be null/undefined (when unknown), uint.
   * @type {number}
   */ this.dimensionsDetectCount = fields.dimensionsDetectCount;
}
/**
 * Wrap original series data for some compatibility cases.
 */ $058c715583456086$var$Source.seriesDataToSource = function(data) {
    return new $058c715583456086$var$Source({
        data: data,
        sourceFormat: $058c715583456086$var$isTypedArray(data) ? $058c715583456086$var$SOURCE_FORMAT_TYPED_ARRAY : $058c715583456086$var$SOURCE_FORMAT_ORIGINAL,
        fromDataset: false
    });
};
$058c715583456086$var$enableClassCheck($058c715583456086$var$Source);
var $058c715583456086$var$_default = $058c715583456086$var$Source;
$058c715583456086$exports = $058c715583456086$var$_default;



var $71e1a98f99449cca$var$SOURCE_FORMAT_ORIGINAL = $00bf3640e0468773$export$2823037fb9d8f0c6;
var $71e1a98f99449cca$var$SOURCE_FORMAT_ARRAY_ROWS = $00bf3640e0468773$export$fcd62ebf51387903;
var $71e1a98f99449cca$var$SOURCE_FORMAT_OBJECT_ROWS = $00bf3640e0468773$export$703ae8a2d83f441;
var $71e1a98f99449cca$var$SOURCE_FORMAT_KEYED_COLUMNS = $00bf3640e0468773$export$6a32b42c754a3cb8;
var $71e1a98f99449cca$var$SOURCE_FORMAT_UNKNOWN = $00bf3640e0468773$export$c78f1330778d30d;
var $71e1a98f99449cca$var$SOURCE_FORMAT_TYPED_ARRAY = $00bf3640e0468773$export$a918cb016a382d45;
var $71e1a98f99449cca$var$SERIES_LAYOUT_BY_ROW = $00bf3640e0468773$export$d55da1467cdf7804;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // The result of `guessOrdinal`.
var $71e1a98f99449cca$var$BE_ORDINAL = {
    Must: 1,
    // Encounter string but not '-' and not number-like.
    Might: 2,
    // Encounter string but number-like.
    Not: 3 // Other cases
};
var $71e1a98f99449cca$var$inner = $71e1a98f99449cca$var$makeInner();
/**
 * @see {module:echarts/data/Source}
 * @param {module:echarts/component/dataset/DatasetModel} datasetModel
 * @return {string} sourceFormat
 */ function $71e1a98f99449cca$var$detectSourceFormat(datasetModel) {
    var data = datasetModel.option.source;
    var sourceFormat = $71e1a98f99449cca$var$SOURCE_FORMAT_UNKNOWN;
    if ($71e1a98f99449cca$var$isTypedArray(data)) sourceFormat = $71e1a98f99449cca$var$SOURCE_FORMAT_TYPED_ARRAY;
    else if ($71e1a98f99449cca$var$isArray(data)) {
        // FIXME Whether tolerate null in top level array?
        if (data.length === 0) sourceFormat = $71e1a98f99449cca$var$SOURCE_FORMAT_ARRAY_ROWS;
        for(var i = 0, len = data.length; i < len; i++){
            var item = data[i];
            if (item == null) continue;
            else if ($71e1a98f99449cca$var$isArray(item)) {
                sourceFormat = $71e1a98f99449cca$var$SOURCE_FORMAT_ARRAY_ROWS;
                break;
            } else if ($71e1a98f99449cca$var$isObject(item)) {
                sourceFormat = $71e1a98f99449cca$var$SOURCE_FORMAT_OBJECT_ROWS;
                break;
            }
        }
    } else if ($71e1a98f99449cca$var$isObject(data)) {
        for(var key in data)if (data.hasOwnProperty(key) && $71e1a98f99449cca$var$isArrayLike(data[key])) {
            sourceFormat = $71e1a98f99449cca$var$SOURCE_FORMAT_KEYED_COLUMNS;
            break;
        }
    } else if (data != null) throw new Error("Invalid data");
    $71e1a98f99449cca$var$inner(datasetModel).sourceFormat = sourceFormat;
}
/**
 * [Scenarios]:
 * (1) Provide source data directly:
 *     series: {
 *         encode: {...},
 *         dimensions: [...]
 *         seriesLayoutBy: 'row',
 *         data: [[...]]
 *     }
 * (2) Refer to datasetModel.
 *     series: [{
 *         encode: {...}
 *         // Ignore datasetIndex means `datasetIndex: 0`
 *         // and the dimensions defination in dataset is used
 *     }, {
 *         encode: {...},
 *         seriesLayoutBy: 'column',
 *         datasetIndex: 1
 *     }]
 *
 * Get data from series itself or datset.
 * @return {module:echarts/data/Source} source
 */ function $71e1a98f99449cca$var$getSource(seriesModel) {
    return $71e1a98f99449cca$var$inner(seriesModel).source;
}
/**
 * MUST be called before mergeOption of all series.
 * @param {module:echarts/model/Global} ecModel
 */ function $71e1a98f99449cca$var$resetSourceDefaulter(ecModel) {
    // `datasetMap` is used to make default encode.
    $71e1a98f99449cca$var$inner(ecModel).datasetMap = $71e1a98f99449cca$var$createHashMap();
}
/**
 * [Caution]:
 * MUST be called after series option merged and
 * before "series.getInitailData()" called.
 *
 * [The rule of making default encode]:
 * Category axis (if exists) alway map to the first dimension.
 * Each other axis occupies a subsequent dimension.
 *
 * [Why make default encode]:
 * Simplify the typing of encode in option, avoiding the case like that:
 * series: [{encode: {x: 0, y: 1}}, {encode: {x: 0, y: 2}}, {encode: {x: 0, y: 3}}],
 * where the "y" have to be manually typed as "1, 2, 3, ...".
 *
 * @param {module:echarts/model/Series} seriesModel
 */ function $71e1a98f99449cca$var$prepareSource(seriesModel) {
    var seriesOption = seriesModel.option;
    var data = seriesOption.data;
    var sourceFormat = $71e1a98f99449cca$var$isTypedArray(data) ? $71e1a98f99449cca$var$SOURCE_FORMAT_TYPED_ARRAY : $71e1a98f99449cca$var$SOURCE_FORMAT_ORIGINAL;
    var fromDataset = false;
    var seriesLayoutBy = seriesOption.seriesLayoutBy;
    var sourceHeader = seriesOption.sourceHeader;
    var dimensionsDefine = seriesOption.dimensions;
    var datasetModel = $71e1a98f99449cca$var$getDatasetModel(seriesModel);
    if (datasetModel) {
        var datasetOption = datasetModel.option;
        data = datasetOption.source;
        sourceFormat = $71e1a98f99449cca$var$inner(datasetModel).sourceFormat;
        fromDataset = true; // These settings from series has higher priority.
        seriesLayoutBy = seriesLayoutBy || datasetOption.seriesLayoutBy;
        sourceHeader == null && (sourceHeader = datasetOption.sourceHeader);
        dimensionsDefine = dimensionsDefine || datasetOption.dimensions;
    }
    var completeResult = $71e1a98f99449cca$var$completeBySourceData(data, sourceFormat, seriesLayoutBy, sourceHeader, dimensionsDefine);
    $71e1a98f99449cca$var$inner(seriesModel).source = new $058c715583456086$exports({
        data: data,
        fromDataset: fromDataset,
        seriesLayoutBy: seriesLayoutBy,
        sourceFormat: sourceFormat,
        dimensionsDefine: completeResult.dimensionsDefine,
        startIndex: completeResult.startIndex,
        dimensionsDetectCount: completeResult.dimensionsDetectCount,
        // Note: dataset option does not have `encode`.
        encodeDefine: seriesOption.encode
    });
} // return {startIndex, dimensionsDefine, dimensionsCount}
function $71e1a98f99449cca$var$completeBySourceData(data, sourceFormat, seriesLayoutBy, sourceHeader, dimensionsDefine) {
    if (!data) return {
        dimensionsDefine: $71e1a98f99449cca$var$normalizeDimensionsDefine(dimensionsDefine)
    };
    var dimensionsDetectCount;
    var startIndex;
    if (sourceFormat === $71e1a98f99449cca$var$SOURCE_FORMAT_ARRAY_ROWS) {
        // Rule: Most of the first line are string: it is header.
        // Caution: consider a line with 5 string and 1 number,
        // it still can not be sure it is a head, because the
        // 5 string may be 5 values of category columns.
        if (sourceHeader === "auto" || sourceHeader == null) $71e1a98f99449cca$var$arrayRowsTravelFirst(function(val) {
            // '-' is regarded as null/undefined.
            if (val != null && val !== "-") {
                if ($71e1a98f99449cca$var$isString(val)) startIndex == null && (startIndex = 1);
                else startIndex = 0;
            } // 10 is an experience number, avoid long loop.
        }, seriesLayoutBy, data, 10);
        else startIndex = sourceHeader ? 1 : 0;
        if (!dimensionsDefine && startIndex === 1) {
            dimensionsDefine = [];
            $71e1a98f99449cca$var$arrayRowsTravelFirst(function(val, index) {
                dimensionsDefine[index] = val != null ? val : "";
            }, seriesLayoutBy, data);
        }
        dimensionsDetectCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === $71e1a98f99449cca$var$SERIES_LAYOUT_BY_ROW ? data.length : data[0] ? data[0].length : null;
    } else if (sourceFormat === $71e1a98f99449cca$var$SOURCE_FORMAT_OBJECT_ROWS) {
        if (!dimensionsDefine) dimensionsDefine = $71e1a98f99449cca$var$objectRowsCollectDimensions(data);
    } else if (sourceFormat === $71e1a98f99449cca$var$SOURCE_FORMAT_KEYED_COLUMNS) {
        if (!dimensionsDefine) {
            dimensionsDefine = [];
            $71e1a98f99449cca$var$each(data, function(colArr, key) {
                dimensionsDefine.push(key);
            });
        }
    } else if (sourceFormat === $71e1a98f99449cca$var$SOURCE_FORMAT_ORIGINAL) {
        var value0 = $71e1a98f99449cca$var$getDataItemValue(data[0]);
        dimensionsDetectCount = $71e1a98f99449cca$var$isArray(value0) && value0.length || 1;
    }
    return {
        startIndex: startIndex,
        dimensionsDefine: $71e1a98f99449cca$var$normalizeDimensionsDefine(dimensionsDefine),
        dimensionsDetectCount: dimensionsDetectCount
    };
} // Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefiend or string.
function $71e1a98f99449cca$var$normalizeDimensionsDefine(dimensionsDefine) {
    if (!dimensionsDefine) // The meaning of null/undefined is different from empty array.
    return;
    var nameMap = $71e1a98f99449cca$var$createHashMap();
    return $71e1a98f99449cca$var$map(dimensionsDefine, function(item, index) {
        item = $71e1a98f99449cca$var$extend({}, $71e1a98f99449cca$var$isObject(item) ? item : {
            name: item
        }); // User can set null in dimensions.
        // We dont auto specify name, othewise a given name may
        // cause it be refered unexpectedly.
        if (item.name == null) return item;
         // Also consider number form like 2012.
        item.name += ""; // User may also specify displayName.
        // displayName will always exists except user not
        // specified or dim name is not specified or detected.
        // (A auto generated dim name will not be used as
        // displayName).
        if (item.displayName == null) item.displayName = item.name;
        var exist = nameMap.get(item.name);
        if (!exist) nameMap.set(item.name, {
            count: 1
        });
        else item.name += "-" + exist.count++;
        return item;
    });
}
function $71e1a98f99449cca$var$arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
    maxLoop == null && (maxLoop = Infinity);
    if (seriesLayoutBy === $71e1a98f99449cca$var$SERIES_LAYOUT_BY_ROW) for(var i = 0; i < data.length && i < maxLoop; i++)cb(data[i] ? data[i][0] : null, i);
    else {
        var value0 = data[0] || [];
        for(var i = 0; i < value0.length && i < maxLoop; i++)cb(value0[i], i);
    }
}
function $71e1a98f99449cca$var$objectRowsCollectDimensions(data) {
    var firstIndex = 0;
    var obj;
    while(firstIndex < data.length && !(obj = data[firstIndex++])); // jshint ignore: line
    if (obj) {
        var dimensions = [];
        $71e1a98f99449cca$var$each(obj, function(value, key) {
            dimensions.push(key);
        });
        return dimensions;
    }
}
/**
 * [The strategy of the arrengment of data dimensions for dataset]:
 * "value way": all axes are non-category axes. So series one by one take
 *     several (the number is coordSysDims.length) dimensions from dataset.
 *     The result of data arrengment of data dimensions like:
 *     | ser0_x | ser0_y | ser1_x | ser1_y | ser2_x | ser2_y |
 * "category way": at least one axis is category axis. So the the first data
 *     dimension is always mapped to the first category axis and shared by
 *     all of the series. The other data dimensions are taken by series like
 *     "value way" does.
 *     The result of data arrengment of data dimensions like:
 *     | ser_shared_x | ser0_y | ser1_y | ser2_y |
 *
 * @param {Array.<Object|string>} coordDimensions [{name: <string>, type: <string>, dimsDef: <Array>}, ...]
 * @param {module:model/Series} seriesModel
 * @param {module:data/Source} source
 * @return {Object} encode Never be `null/undefined`.
 */ function $71e1a98f99449cca$var$makeSeriesEncodeForAxisCoordSys(coordDimensions, seriesModel, source) {
    var encode = {};
    var datasetModel = $71e1a98f99449cca$var$getDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel || !coordDimensions) return encode;
    var encodeItemName = [];
    var encodeSeriesName = [];
    var ecModel = seriesModel.ecModel;
    var datasetMap = $71e1a98f99449cca$var$inner(ecModel).datasetMap;
    var key = datasetModel.uid + "_" + source.seriesLayoutBy;
    var baseCategoryDimIndex;
    var categoryWayValueDimStart;
    coordDimensions = coordDimensions.slice();
    $71e1a98f99449cca$var$each(coordDimensions, function(coordDimInfo, coordDimIdx) {
        !$71e1a98f99449cca$var$isObject(coordDimInfo) && (coordDimensions[coordDimIdx] = {
            name: coordDimInfo
        });
        if (coordDimInfo.type === "ordinal" && baseCategoryDimIndex == null) {
            baseCategoryDimIndex = coordDimIdx;
            categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimensions[coordDimIdx]);
        }
        encode[coordDimInfo.name] = [];
    });
    var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
        categoryWayDim: categoryWayValueDimStart,
        valueWayDim: 0
    }); // TODO
    // Auto detect first time axis and do arrangement.
    $71e1a98f99449cca$var$each(coordDimensions, function(coordDimInfo, coordDimIdx) {
        var coordDimName = coordDimInfo.name;
        var count = getDataDimCountOnCoordDim(coordDimInfo); // In value way.
        if (baseCategoryDimIndex == null) {
            var start = datasetRecord.valueWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.valueWayDim += count; // ??? TODO give a better default series name rule?
        // especially when encode x y specified.
        // consider: when mutiple series share one dimension
        // category axis, series name should better use
        // the other dimsion name. On the other hand, use
        // both dimensions name.
        } else if (baseCategoryDimIndex === coordDimIdx) {
            pushDim(encode[coordDimName], 0, count);
            pushDim(encodeItemName, 0, count);
        } else {
            var start = datasetRecord.categoryWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.categoryWayDim += count;
        }
    });
    function pushDim(dimIdxArr, idxFrom, idxCount) {
        for(var i = 0; i < idxCount; i++)dimIdxArr.push(idxFrom + i);
    }
    function getDataDimCountOnCoordDim(coordDimInfo) {
        var dimsDef = coordDimInfo.dimsDef;
        return dimsDef ? dimsDef.length : 1;
    }
    encodeItemName.length && (encode.itemName = encodeItemName);
    encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
    return encode;
}
/**
 * Work for data like [{name: ..., value: ...}, ...].
 *
 * @param {module:model/Series} seriesModel
 * @param {module:data/Source} source
 * @return {Object} encode Never be `null/undefined`.
 */ function $71e1a98f99449cca$var$makeSeriesEncodeForNameBased(seriesModel, source, dimCount) {
    var encode = {};
    var datasetModel = $71e1a98f99449cca$var$getDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel) return encode;
    var sourceFormat = source.sourceFormat;
    var dimensionsDefine = source.dimensionsDefine;
    var potentialNameDimIndex;
    if (sourceFormat === $71e1a98f99449cca$var$SOURCE_FORMAT_OBJECT_ROWS || sourceFormat === $71e1a98f99449cca$var$SOURCE_FORMAT_KEYED_COLUMNS) $71e1a98f99449cca$var$each(dimensionsDefine, function(dim, idx) {
        if (($71e1a98f99449cca$var$isObject(dim) ? dim.name : dim) === "name") potentialNameDimIndex = idx;
    });
     // idxResult: {v, n}.
    var idxResult = function() {
        var idxRes0 = {};
        var idxRes1 = {};
        var guessRecords = []; // 5 is an experience value.
        for(var i = 0, len = Math.min(5, dimCount); i < len; i++){
            var guessResult = $71e1a98f99449cca$var$doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
            guessRecords.push(guessResult);
            var isPureNumber = guessResult === $71e1a98f99449cca$var$BE_ORDINAL.Not; // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
            // and then find a name dim with the priority:
            // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
            if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) idxRes0.v = i;
            if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === $71e1a98f99449cca$var$BE_ORDINAL.Not) idxRes0.n = i;
            if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== $71e1a98f99449cca$var$BE_ORDINAL.Not) return idxRes0;
             // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
            // find the first BE_ORDINAL.Might as the value dim,
            // and then find a name dim with the priority:
            // "other dim" > "the value dim itself".
            // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
            // treated as number.
            if (!isPureNumber) {
                if (guessResult === $71e1a98f99449cca$var$BE_ORDINAL.Might && idxRes1.v == null && i !== potentialNameDimIndex) idxRes1.v = i;
                if (idxRes1.n == null || idxRes1.n === idxRes1.v) idxRes1.n = i;
            }
        }
        function fulfilled(idxResult) {
            return idxResult.v != null && idxResult.n != null;
        }
        return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
    }();
    if (idxResult) {
        encode.value = idxResult.v; // `potentialNameDimIndex` has highest priority.
        var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n; // By default, label use itemName in charts.
        // So we dont set encodeLabel here.
        encode.itemName = [
            nameDimIndex
        ];
        encode.seriesName = [
            nameDimIndex
        ];
    }
    return encode;
}
/**
 * If return null/undefined, indicate that should not use datasetModel.
 */ function $71e1a98f99449cca$var$getDatasetModel(seriesModel) {
    var option = seriesModel.option; // Caution: consider the scenario:
    // A dataset is declared and a series is not expected to use the dataset,
    // and at the beginning `setOption({series: { noData })` (just prepare other
    // option but no data), then `setOption({series: {data: [...]}); In this case,
    // the user should set an empty array to avoid that dataset is used by default.
    var thisData = option.data;
    if (!thisData) return seriesModel.ecModel.getComponent("dataset", option.datasetIndex || 0);
}
/**
 * The rule should not be complex, otherwise user might not
 * be able to known where the data is wrong.
 * The code is ugly, but how to make it neat?
 *
 * @param {module:echars/data/Source} source
 * @param {number} dimIndex
 * @return {BE_ORDINAL} guess result.
 */ function $71e1a98f99449cca$var$guessOrdinal(source, dimIndex) {
    return $71e1a98f99449cca$var$doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
} // dimIndex may be overflow source data.
// return {BE_ORDINAL}
function $71e1a98f99449cca$var$doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
    var result; // Experience value.
    var maxLoop = 5;
    if ($71e1a98f99449cca$var$isTypedArray(data)) return $71e1a98f99449cca$var$BE_ORDINAL.Not;
     // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
    // always exists in source.
    var dimName;
    var dimType;
    if (dimensionsDefine) {
        var dimDefItem = dimensionsDefine[dimIndex];
        if ($71e1a98f99449cca$var$isObject(dimDefItem)) {
            dimName = dimDefItem.name;
            dimType = dimDefItem.type;
        } else if ($71e1a98f99449cca$var$isString(dimDefItem)) dimName = dimDefItem;
    }
    if (dimType != null) return dimType === "ordinal" ? $71e1a98f99449cca$var$BE_ORDINAL.Must : $71e1a98f99449cca$var$BE_ORDINAL.Not;
    if (sourceFormat === $71e1a98f99449cca$var$SOURCE_FORMAT_ARRAY_ROWS) {
        if (seriesLayoutBy === $71e1a98f99449cca$var$SERIES_LAYOUT_BY_ROW) {
            var sample = data[dimIndex];
            for(var i = 0; i < (sample || []).length && i < maxLoop; i++){
                if ((result = detectValue(sample[startIndex + i])) != null) return result;
            }
        } else for(var i = 0; i < data.length && i < maxLoop; i++){
            var row = data[startIndex + i];
            if (row && (result = detectValue(row[dimIndex])) != null) return result;
        }
    } else if (sourceFormat === $71e1a98f99449cca$var$SOURCE_FORMAT_OBJECT_ROWS) {
        if (!dimName) return $71e1a98f99449cca$var$BE_ORDINAL.Not;
        for(var i = 0; i < data.length && i < maxLoop; i++){
            var item = data[i];
            if (item && (result = detectValue(item[dimName])) != null) return result;
        }
    } else if (sourceFormat === $71e1a98f99449cca$var$SOURCE_FORMAT_KEYED_COLUMNS) {
        if (!dimName) return $71e1a98f99449cca$var$BE_ORDINAL.Not;
        var sample = data[dimName];
        if (!sample || $71e1a98f99449cca$var$isTypedArray(sample)) return $71e1a98f99449cca$var$BE_ORDINAL.Not;
        for(var i = 0; i < sample.length && i < maxLoop; i++){
            if ((result = detectValue(sample[i])) != null) return result;
        }
    } else if (sourceFormat === $71e1a98f99449cca$var$SOURCE_FORMAT_ORIGINAL) for(var i = 0; i < data.length && i < maxLoop; i++){
        var item = data[i];
        var val = $71e1a98f99449cca$var$getDataItemValue(item);
        if (!$71e1a98f99449cca$var$isArray(val)) return $71e1a98f99449cca$var$BE_ORDINAL.Not;
        if ((result = detectValue(val[dimIndex])) != null) return result;
    }
    function detectValue(val) {
        var beStr = $71e1a98f99449cca$var$isString(val); // Consider usage convenience, '1', '2' will be treated as "number".
        // `isFinit('')` get `true`.
        if (val != null && isFinite(val) && val !== "") return beStr ? $71e1a98f99449cca$var$BE_ORDINAL.Might : $71e1a98f99449cca$var$BE_ORDINAL.Not;
        else if (beStr && val !== "-") return $71e1a98f99449cca$var$BE_ORDINAL.Must;
    }
    return $71e1a98f99449cca$var$BE_ORDINAL.Not;
}
$71e1a98f99449cca$export$328749e9c5b40760 = $71e1a98f99449cca$var$BE_ORDINAL;
$71e1a98f99449cca$export$52a469afa4653e57 = $71e1a98f99449cca$var$detectSourceFormat;
$71e1a98f99449cca$export$dd2b6e807fb37ba3 = $71e1a98f99449cca$var$getSource;
$71e1a98f99449cca$export$b30cdea50aa00e6 = $71e1a98f99449cca$var$resetSourceDefaulter;
$71e1a98f99449cca$export$6d45f5142dbcbf3 = $71e1a98f99449cca$var$prepareSource;
$71e1a98f99449cca$export$37682b8fdd2e83d = $71e1a98f99449cca$var$makeSeriesEncodeForAxisCoordSys;
$71e1a98f99449cca$export$60b8a57d1f2fed26 = $71e1a98f99449cca$var$makeSeriesEncodeForNameBased;
$71e1a98f99449cca$export$c51adf1a2be01b9c = $71e1a98f99449cca$var$guessOrdinal;


var $6c7ab8052e1c6936$var$resetSourceDefaulter = $71e1a98f99449cca$export$b30cdea50aa00e6;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * ECharts global model
 *
 * @module {echarts/model/Global}
 */ /**
 * Caution: If the mechanism should be changed some day, these cases
 * should be considered:
 *
 * (1) In `merge option` mode, if using the same option to call `setOption`
 * many times, the result should be the same (try our best to ensure that).
 * (2) In `merge option` mode, if a component has no id/name specified, it
 * will be merged by index, and the result sequence of the components is
 * consistent to the original sequence.
 * (3) `reset` feature (in toolbox). Find detailed info in comments about
 * `mergeOption` in module:echarts/model/OptionManager.
 */ var $6c7ab8052e1c6936$var$OPTION_INNER_KEY = "\x00_ec_inner";
/**
 * @alias module:echarts/model/Global
 *
 * @param {Object} option
 * @param {module:echarts/model/Model} parentModel
 * @param {Object} theme
 */ var $6c7ab8052e1c6936$var$GlobalModel = $2b51b4bf776ec22e$exports.extend({
    init: function(option, parentModel, theme, optionManager) {
        theme = theme || {};
        this.option = null; // Mark as not initialized.
        /**
     * @type {module:echarts/model/Model}
     * @private
     */ this._theme = new $2b51b4bf776ec22e$exports(theme);
        /**
     * @type {module:echarts/model/OptionManager}
     */ this._optionManager = optionManager;
    },
    setOption: function(option, optionPreprocessorFuncs) {
        $6c7ab8052e1c6936$var$assert(!($6c7ab8052e1c6936$var$OPTION_INNER_KEY in option), "please use chart.getOption()");
        this._optionManager.setOption(option, optionPreprocessorFuncs);
        this.resetOption(null);
    },
    /**
   * @param {string} type null/undefined: reset all.
   *                      'recreate': force recreate all.
   *                      'timeline': only reset timeline option
   *                      'media': only reset media query option
   * @return {boolean} Whether option changed.
   */ resetOption: function(type) {
        var optionChanged = false;
        var optionManager = this._optionManager;
        if (!type || type === "recreate") {
            var baseOption = optionManager.mountOption(type === "recreate");
            if (!this.option || type === "recreate") $6c7ab8052e1c6936$var$initBase.call(this, baseOption);
            else {
                this.restoreData();
                this.mergeOption(baseOption);
            }
            optionChanged = true;
        }
        if (type === "timeline" || type === "media") this.restoreData();
        if (!type || type === "recreate" || type === "timeline") {
            var timelineOption = optionManager.getTimelineOption(this);
            timelineOption && (this.mergeOption(timelineOption), optionChanged = true);
        }
        if (!type || type === "recreate" || type === "media") {
            var mediaOptions = optionManager.getMediaOption(this, this._api);
            if (mediaOptions.length) $6c7ab8052e1c6936$var$each(mediaOptions, function(mediaOption) {
                this.mergeOption(mediaOption, optionChanged = true);
            }, this);
        }
        return optionChanged;
    },
    /**
   * @protected
   */ mergeOption: function(newOption) {
        var option = this.option;
        var componentsMap = this._componentsMap;
        var newCptTypes = [];
        $6c7ab8052e1c6936$var$resetSourceDefaulter(this); // If no component class, merge directly.
        // For example: color, animaiton options, etc.
        $6c7ab8052e1c6936$var$each(newOption, function(componentOption, mainType) {
            if (componentOption == null) return;
            if (!$3b9c2389e45dfb7d$exports.hasClass(mainType)) // globalSettingTask.dirty();
            option[mainType] = option[mainType] == null ? $6c7ab8052e1c6936$var$clone(componentOption) : $6c7ab8052e1c6936$var$merge(option[mainType], componentOption, true);
            else if (mainType) newCptTypes.push(mainType);
        });
        $3b9c2389e45dfb7d$exports.topologicalTravel(newCptTypes, $3b9c2389e45dfb7d$exports.getAllClassMainTypes(), visitComponent, this);
        function visitComponent(mainType, dependencies) {
            var newCptOptionList = $d559f43cb9041423$export$4f07b212a02c8051(newOption[mainType]);
            var mapResult = $d559f43cb9041423$export$574f818966e4da87(componentsMap.get(mainType), newCptOptionList);
            $d559f43cb9041423$export$6f01005fe2e2ddc6(mapResult); // Set mainType and complete subType.
            $6c7ab8052e1c6936$var$each(mapResult, function(item, index) {
                var opt = item.option;
                if ($6c7ab8052e1c6936$var$isObject(opt)) {
                    item.keyInfo.mainType = mainType;
                    item.keyInfo.subType = $6c7ab8052e1c6936$var$determineSubType(mainType, opt, item.exist);
                }
            });
            var dependentModels = $6c7ab8052e1c6936$var$getComponentsByTypes(componentsMap, dependencies);
            option[mainType] = [];
            componentsMap.set(mainType, []);
            $6c7ab8052e1c6936$var$each(mapResult, function(resultItem, index) {
                var componentModel = resultItem.exist;
                var newCptOption = resultItem.option;
                $6c7ab8052e1c6936$var$assert($6c7ab8052e1c6936$var$isObject(newCptOption) || componentModel, "Empty component definition"); // Consider where is no new option and should be merged using {},
                // see removeEdgeAndAdd in topologicalTravel and
                // ComponentModel.getAllClassMainTypes.
                if (!newCptOption) {
                    componentModel.mergeOption({}, this);
                    componentModel.optionUpdated({}, false);
                } else {
                    var ComponentModelClass = $3b9c2389e45dfb7d$exports.getClass(mainType, resultItem.keyInfo.subType, true);
                    if (componentModel && componentModel.constructor === ComponentModelClass) {
                        componentModel.name = resultItem.keyInfo.name; // componentModel.settingTask && componentModel.settingTask.dirty();
                        componentModel.mergeOption(newCptOption, this);
                        componentModel.optionUpdated(newCptOption, false);
                    } else {
                        // PENDING Global as parent ?
                        var extraOpt = $6c7ab8052e1c6936$var$extend({
                            dependentModels: dependentModels,
                            componentIndex: index
                        }, resultItem.keyInfo);
                        componentModel = new ComponentModelClass(newCptOption, this, this, extraOpt);
                        $6c7ab8052e1c6936$var$extend(componentModel, extraOpt);
                        componentModel.init(newCptOption, this, this, extraOpt); // Call optionUpdated after init.
                        // newCptOption has been used as componentModel.option
                        // and may be merged with theme and default, so pass null
                        // to avoid confusion.
                        componentModel.optionUpdated(null, true);
                    }
                }
                componentsMap.get(mainType)[index] = componentModel;
                option[mainType][index] = componentModel.option;
            }, this); // Backup series for filtering.
            if (mainType === "series") $6c7ab8052e1c6936$var$createSeriesIndices(this, componentsMap.get("series"));
        }
        this._seriesIndicesMap = $6c7ab8052e1c6936$var$createHashMap(this._seriesIndices = this._seriesIndices || []);
    },
    /**
   * Get option for output (cloned option and inner info removed)
   * @public
   * @return {Object}
   */ getOption: function() {
        var option = $6c7ab8052e1c6936$var$clone(this.option);
        $6c7ab8052e1c6936$var$each(option, function(opts, mainType) {
            if ($3b9c2389e45dfb7d$exports.hasClass(mainType)) {
                var opts = $d559f43cb9041423$export$4f07b212a02c8051(opts);
                for(var i = opts.length - 1; i >= 0; i--)// Remove options with inner id.
                if ($d559f43cb9041423$export$66efd7adff61f97d(opts[i])) opts.splice(i, 1);
                option[mainType] = opts;
            }
        });
        delete option[$6c7ab8052e1c6936$var$OPTION_INNER_KEY];
        return option;
    },
    /**
   * @return {module:echarts/model/Model}
   */ getTheme: function() {
        return this._theme;
    },
    /**
   * @param {string} mainType
   * @param {number} [idx=0]
   * @return {module:echarts/model/Component}
   */ getComponent: function(mainType, idx) {
        var list = this._componentsMap.get(mainType);
        if (list) return list[idx || 0];
    },
    /**
   * If none of index and id and name used, return all components with mainType.
   * @param {Object} condition
   * @param {string} condition.mainType
   * @param {string} [condition.subType] If ignore, only query by mainType
   * @param {number|Array.<number>} [condition.index] Either input index or id or name.
   * @param {string|Array.<string>} [condition.id] Either input index or id or name.
   * @param {string|Array.<string>} [condition.name] Either input index or id or name.
   * @return {Array.<module:echarts/model/Component>}
   */ queryComponents: function(condition) {
        var mainType = condition.mainType;
        if (!mainType) return [];
        var index = condition.index;
        var id = condition.id;
        var name = condition.name;
        var cpts = this._componentsMap.get(mainType);
        if (!cpts || !cpts.length) return [];
        var result;
        if (index != null) {
            if (!$6c7ab8052e1c6936$var$isArray(index)) index = [
                index
            ];
            result = $6c7ab8052e1c6936$var$filter($6c7ab8052e1c6936$var$map(index, function(idx) {
                return cpts[idx];
            }), function(val) {
                return !!val;
            });
        } else if (id != null) {
            var isIdArray = $6c7ab8052e1c6936$var$isArray(id);
            result = $6c7ab8052e1c6936$var$filter(cpts, function(cpt) {
                return isIdArray && $6c7ab8052e1c6936$var$indexOf(id, cpt.id) >= 0 || !isIdArray && cpt.id === id;
            });
        } else if (name != null) {
            var isNameArray = $6c7ab8052e1c6936$var$isArray(name);
            result = $6c7ab8052e1c6936$var$filter(cpts, function(cpt) {
                return isNameArray && $6c7ab8052e1c6936$var$indexOf(name, cpt.name) >= 0 || !isNameArray && cpt.name === name;
            });
        } else // Return all components with mainType
        result = cpts.slice();
        return $6c7ab8052e1c6936$var$filterBySubType(result, condition);
    },
    /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * var result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * var result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * var result = findComponents(
   *     {mainType: 'series',
   *     filter: function (model, index) {...}}
   * );
   * // result like [component0, componnet1, ...]
   *
   * @param {Object} condition
   * @param {string} condition.mainType Mandatory.
   * @param {string} [condition.subType] Optional.
   * @param {Object} [condition.query] like {xxxIndex, xxxId, xxxName},
   *        where xxx is mainType.
   *        If query attribute is null/undefined or has no index/id/name,
   *        do not filtering by query conditions, which is convenient for
   *        no-payload situations or when target of action is global.
   * @param {Function} [condition.filter] parameter: component, return boolean.
   * @return {Array.<module:echarts/model/Component>}
   */ findComponents: function(condition) {
        var query = condition.query;
        var mainType = condition.mainType;
        var queryCond = getQueryCond(query);
        var result = queryCond ? this.queryComponents(queryCond) : this._componentsMap.get(mainType);
        return doFilter($6c7ab8052e1c6936$var$filterBySubType(result, condition));
        function getQueryCond(q) {
            var indexAttr = mainType + "Index";
            var idAttr = mainType + "Id";
            var nameAttr = mainType + "Name";
            return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
                mainType: mainType,
                // subType will be filtered finally.
                index: q[indexAttr],
                id: q[idAttr],
                name: q[nameAttr]
            } : null;
        }
        function doFilter(res) {
            return condition.filter ? $6c7ab8052e1c6936$var$filter(res, condition.filter) : res;
        }
    },
    /**
   * @usage
   * eachComponent('legend', function (legendModel, index) {
   *     ...
   * });
   * eachComponent(function (componentType, model, index) {
   *     // componentType does not include subType
   *     // (componentType is 'xxx' but not 'xxx.aa')
   * });
   * eachComponent(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}},
   *     function (model, index) {...}
   * );
   * eachComponent(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}},
   *     function (model, index) {...}
   * );
   *
   * @param {string|Object=} mainType When mainType is object, the definition
   *                                  is the same as the method 'findComponents'.
   * @param {Function} cb
   * @param {*} context
   */ eachComponent: function(mainType, cb, context) {
        var componentsMap = this._componentsMap;
        if (typeof mainType === "function") {
            context = cb;
            cb = mainType;
            componentsMap.each(function(components, componentType) {
                $6c7ab8052e1c6936$var$each(components, function(component, index) {
                    cb.call(context, componentType, component, index);
                });
            });
        } else if ($6c7ab8052e1c6936$var$isString(mainType)) $6c7ab8052e1c6936$var$each(componentsMap.get(mainType), cb, context);
        else if ($6c7ab8052e1c6936$var$isObject(mainType)) {
            var queryResult = this.findComponents(mainType);
            $6c7ab8052e1c6936$var$each(queryResult, cb, context);
        }
    },
    /**
   * @param {string} name
   * @return {Array.<module:echarts/model/Series>}
   */ getSeriesByName: function(name) {
        var series = this._componentsMap.get("series");
        return $6c7ab8052e1c6936$var$filter(series, function(oneSeries) {
            return oneSeries.name === name;
        });
    },
    /**
   * @param {number} seriesIndex
   * @return {module:echarts/model/Series}
   */ getSeriesByIndex: function(seriesIndex) {
        return this._componentsMap.get("series")[seriesIndex];
    },
    /**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   *
   * @param {string} subType
   * @return {Array.<module:echarts/model/Series>}
   */ getSeriesByType: function(subType) {
        var series = this._componentsMap.get("series");
        return $6c7ab8052e1c6936$var$filter(series, function(oneSeries) {
            return oneSeries.subType === subType;
        });
    },
    /**
   * @return {Array.<module:echarts/model/Series>}
   */ getSeries: function() {
        return this._componentsMap.get("series").slice();
    },
    /**
   * @return {number}
   */ getSeriesCount: function() {
        return this._componentsMap.get("series").length;
    },
    /**
   * After filtering, series may be different
   * frome raw series.
   *
   * @param {Function} cb
   * @param {*} context
   */ eachSeries: function(cb, context) {
        $6c7ab8052e1c6936$var$assertSeriesInitialized(this);
        $6c7ab8052e1c6936$var$each(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get("series")[rawSeriesIndex];
            cb.call(context, series, rawSeriesIndex);
        }, this);
    },
    /**
   * Iterate raw series before filtered.
   *
   * @param {Function} cb
   * @param {*} context
   */ eachRawSeries: function(cb, context) {
        $6c7ab8052e1c6936$var$each(this._componentsMap.get("series"), cb, context);
    },
    /**
   * After filtering, series may be different.
   * frome raw series.
   *
   * @param {string} subType.
   * @param {Function} cb
   * @param {*} context
   */ eachSeriesByType: function(subType, cb, context) {
        $6c7ab8052e1c6936$var$assertSeriesInitialized(this);
        $6c7ab8052e1c6936$var$each(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get("series")[rawSeriesIndex];
            if (series.subType === subType) cb.call(context, series, rawSeriesIndex);
        }, this);
    },
    /**
   * Iterate raw series before filtered of given type.
   *
   * @parma {string} subType
   * @param {Function} cb
   * @param {*} context
   */ eachRawSeriesByType: function(subType, cb, context) {
        return $6c7ab8052e1c6936$var$each(this.getSeriesByType(subType), cb, context);
    },
    /**
   * @param {module:echarts/model/Series} seriesModel
   */ isSeriesFiltered: function(seriesModel) {
        $6c7ab8052e1c6936$var$assertSeriesInitialized(this);
        return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
    },
    /**
   * @return {Array.<number>}
   */ getCurrentSeriesIndices: function() {
        return (this._seriesIndices || []).slice();
    },
    /**
   * @param {Function} cb
   * @param {*} context
   */ filterSeries: function(cb, context) {
        $6c7ab8052e1c6936$var$assertSeriesInitialized(this);
        var filteredSeries = $6c7ab8052e1c6936$var$filter(this._componentsMap.get("series"), cb, context);
        $6c7ab8052e1c6936$var$createSeriesIndices(this, filteredSeries);
    },
    restoreData: function(payload) {
        var componentsMap = this._componentsMap;
        $6c7ab8052e1c6936$var$createSeriesIndices(this, componentsMap.get("series"));
        var componentTypes = [];
        componentsMap.each(function(components, componentType) {
            componentTypes.push(componentType);
        });
        $3b9c2389e45dfb7d$exports.topologicalTravel(componentTypes, $3b9c2389e45dfb7d$exports.getAllClassMainTypes(), function(componentType, dependencies) {
            $6c7ab8052e1c6936$var$each(componentsMap.get(componentType), function(component) {
                (componentType !== "series" || !$6c7ab8052e1c6936$var$isNotTargetSeries(component, payload)) && component.restoreData();
            });
        });
    }
});
function $6c7ab8052e1c6936$var$isNotTargetSeries(seriesModel, payload) {
    if (payload) {
        var index = payload.seiresIndex;
        var id = payload.seriesId;
        var name = payload.seriesName;
        return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name != null && seriesModel.name !== name;
    }
}
/**
 * @inner
 */ function $6c7ab8052e1c6936$var$mergeTheme(option, theme) {
    // PENDING
    // NOT use `colorLayer` in theme if option has `color`
    var notMergeColorLayer = option.color && !option.colorLayer;
    $6c7ab8052e1c6936$var$each(theme, function(themeItem, name) {
        if (name === "colorLayer" && notMergeColorLayer) return;
         // 如果有 component model 则把具体的 merge 逻辑交给该 model 处理
        if (!$3b9c2389e45dfb7d$exports.hasClass(name)) {
            if (typeof themeItem === "object") option[name] = !option[name] ? $6c7ab8052e1c6936$var$clone(themeItem) : $6c7ab8052e1c6936$var$merge(option[name], themeItem, false);
            else if (option[name] == null) option[name] = themeItem;
        }
    });
}
function $6c7ab8052e1c6936$var$initBase(baseOption) {
    baseOption; // Using OPTION_INNER_KEY to mark that this option can not be used outside,
    // i.e. `chart.setOption(chart.getModel().option);` is forbiden.
    this.option = {};
    this.option[$6c7ab8052e1c6936$var$OPTION_INNER_KEY] = 1;
    /**
   * Init with series: [], in case of calling findSeries method
   * before series initialized.
   * @type {Object.<string, Array.<module:echarts/model/Model>>}
   * @private
   */ this._componentsMap = $6c7ab8052e1c6936$var$createHashMap({
        series: []
    });
    /**
   * Mapping between filtered series list and raw series list.
   * key: filtered series indices, value: raw series indices.
   * @type {Array.<nubmer>}
   * @private
   */ this._seriesIndices;
    this._seriesIndicesMap;
    $6c7ab8052e1c6936$var$mergeTheme(baseOption, this._theme.option); // TODO Needs clone when merging to the unexisted property
    $6c7ab8052e1c6936$var$merge(baseOption, $45541fb6e3126ae5$exports, false);
    this.mergeOption(baseOption);
}
/**
 * @inner
 * @param {Array.<string>|string} types model types
 * @return {Object} key: {string} type, value: {Array.<Object>} models
 */ function $6c7ab8052e1c6936$var$getComponentsByTypes(componentsMap, types) {
    if (!$6c7ab8052e1c6936$var$isArray(types)) types = types ? [
        types
    ] : [];
    var ret = {};
    $6c7ab8052e1c6936$var$each(types, function(type) {
        ret[type] = (componentsMap.get(type) || []).slice();
    });
    return ret;
}
/**
 * @inner
 */ function $6c7ab8052e1c6936$var$determineSubType(mainType, newCptOption, existComponent) {
    var subType = newCptOption.type ? newCptOption.type : existComponent ? existComponent.subType // Use determineSubType only when there is no existComponent.
     : $3b9c2389e45dfb7d$exports.determineSubType(mainType, newCptOption); // tooltip, markline, markpoint may always has no subType
    return subType;
}
/**
 * @inner
 */ function $6c7ab8052e1c6936$var$createSeriesIndices(ecModel, seriesModels) {
    ecModel._seriesIndicesMap = $6c7ab8052e1c6936$var$createHashMap(ecModel._seriesIndices = $6c7ab8052e1c6936$var$map(seriesModels, function(series) {
        return series.componentIndex;
    }) || []);
}
/**
 * @inner
 */ function $6c7ab8052e1c6936$var$filterBySubType(components, condition) {
    // Using hasOwnProperty for restrict. Consider
    // subType is undefined in user payload.
    return condition.hasOwnProperty("subType") ? $6c7ab8052e1c6936$var$filter(components, function(cpt) {
        return cpt.subType === condition.subType;
    }) : components;
}
/**
 * @inner
 */ function $6c7ab8052e1c6936$var$assertSeriesInitialized(ecModel) {}
$6c7ab8052e1c6936$var$mixin($6c7ab8052e1c6936$var$GlobalModel, $5de0a04ca2e71297$exports);
var $6c7ab8052e1c6936$var$_default = $6c7ab8052e1c6936$var$GlobalModel;
$6c7ab8052e1c6936$exports = $6c7ab8052e1c6936$var$_default;


var $c4d7ef2132c5793c$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $c4d7ef2132c5793c$var$echartsAPIList = [
    "getDom",
    "getZr",
    "getWidth",
    "getHeight",
    "getDevicePixelRatio",
    "dispatchAction",
    "isDisposed",
    "on",
    "off",
    "getDataURL",
    "getConnectedDataURL",
    "getModel",
    "getOption",
    "getViewOfComponentModel",
    "getViewOfSeriesModel"
]; // And `getCoordinateSystems` and `getComponentByElement` will be injected in echarts.js
function $c4d7ef2132c5793c$var$ExtensionAPI(chartInstance) {
    $ec279652dd95c27b$export$79b2f7037acddd43($c4d7ef2132c5793c$var$echartsAPIList, function(name) {
        this[name] = $ec279652dd95c27b$export$2385a24977818dd0(chartInstance[name], chartInstance);
    }, this);
}
var $c4d7ef2132c5793c$var$_default = $c4d7ef2132c5793c$var$ExtensionAPI;
$c4d7ef2132c5793c$exports = $c4d7ef2132c5793c$var$_default;


var $9c36d0fff3b0f387$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $9c36d0fff3b0f387$var$coordinateSystemCreators = {};
function $9c36d0fff3b0f387$var$CoordinateSystemManager() {
    this._coordinateSystems = [];
}
$9c36d0fff3b0f387$var$CoordinateSystemManager.prototype = {
    constructor: $9c36d0fff3b0f387$var$CoordinateSystemManager,
    create: function(ecModel, api) {
        var coordinateSystems = [];
        $ec279652dd95c27b$export$79b2f7037acddd43($9c36d0fff3b0f387$var$coordinateSystemCreators, function(creater, type) {
            var list = creater.create(ecModel, api);
            coordinateSystems = coordinateSystems.concat(list || []);
        });
        this._coordinateSystems = coordinateSystems;
    },
    update: function(ecModel, api) {
        $ec279652dd95c27b$export$79b2f7037acddd43(this._coordinateSystems, function(coordSys) {
            coordSys.update && coordSys.update(ecModel, api);
        });
    },
    getCoordinateSystems: function() {
        return this._coordinateSystems.slice();
    }
};
$9c36d0fff3b0f387$var$CoordinateSystemManager.register = function(type, coordinateSystemCreator) {
    $9c36d0fff3b0f387$var$coordinateSystemCreators[type] = coordinateSystemCreator;
};
$9c36d0fff3b0f387$var$CoordinateSystemManager.get = function(type) {
    return $9c36d0fff3b0f387$var$coordinateSystemCreators[type];
};
var $9c36d0fff3b0f387$var$_default = $9c36d0fff3b0f387$var$CoordinateSystemManager;
$9c36d0fff3b0f387$exports = $9c36d0fff3b0f387$var$_default;


var $440c6b6cac31c6df$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * ECharts option manager
 *
 * @module {echarts/model/OptionManager}
 */ var $440c6b6cac31c6df$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $440c6b6cac31c6df$var$clone = $ec279652dd95c27b$export$9cd59f9826255e47;
var $440c6b6cac31c6df$var$map = $ec279652dd95c27b$export$871de8747c9eaa88;
var $440c6b6cac31c6df$var$merge = $ec279652dd95c27b$export$4950aa0f605343fb;
var $440c6b6cac31c6df$var$QUERY_REG = /^(min|max)?(.+)$/;
/**
 * TERM EXPLANATIONS:
 *
 * [option]:
 *
 *     An object that contains definitions of components. For example:
 *     var option = {
 *         title: {...},
 *         legend: {...},
 *         visualMap: {...},
 *         series: [
 *             {data: [...]},
 *             {data: [...]},
 *             ...
 *         ]
 *     };
 *
 * [rawOption]:
 *
 *     An object input to echarts.setOption. 'rawOption' may be an
 *     'option', or may be an object contains multi-options. For example:
 *     var option = {
 *         baseOption: {
 *             title: {...},
 *             legend: {...},
 *             series: [
 *                 {data: [...]},
 *                 {data: [...]},
 *                 ...
 *             ]
 *         },
 *         timeline: {...},
 *         options: [
 *             {title: {...}, series: {data: [...]}},
 *             {title: {...}, series: {data: [...]}},
 *             ...
 *         ],
 *         media: [
 *             {
 *                 query: {maxWidth: 320},
 *                 option: {series: {x: 20}, visualMap: {show: false}}
 *             },
 *             {
 *                 query: {minWidth: 320, maxWidth: 720},
 *                 option: {series: {x: 500}, visualMap: {show: true}}
 *             },
 *             {
 *                 option: {series: {x: 1200}, visualMap: {show: true}}
 *             }
 *         ]
 *     };
 *
 * @alias module:echarts/model/OptionManager
 * @param {module:echarts/ExtensionAPI} api
 */ function $440c6b6cac31c6df$var$OptionManager(api) {
    /**
   * @private
   * @type {module:echarts/ExtensionAPI}
   */ this._api = api;
    /**
   * @private
   * @type {Array.<number>}
   */ this._timelineOptions = [];
    /**
   * @private
   * @type {Array.<Object>}
   */ this._mediaList = [];
    /**
   * @private
   * @type {Object}
   */ this._mediaDefault;
    /**
   * -1, means default.
   * empty means no media.
   * @private
   * @type {Array.<number>}
   */ this._currentMediaIndices = [];
    /**
   * @private
   * @type {Object}
   */ this._optionBackup;
    /**
   * @private
   * @type {Object}
   */ this._newBaseOption;
} // timeline.notMerge is not supported in ec3. Firstly there is rearly
// case that notMerge is needed. Secondly supporting 'notMerge' requires
// rawOption cloned and backuped when timeline changed, which does no
// good to performance. What's more, that both timeline and setOption
// method supply 'notMerge' brings complex and some problems.
// Consider this case:
// (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
// (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
$440c6b6cac31c6df$var$OptionManager.prototype = {
    constructor: $440c6b6cac31c6df$var$OptionManager,
    /**
   * @public
   * @param {Object} rawOption Raw option.
   * @param {module:echarts/model/Global} ecModel
   * @param {Array.<Function>} optionPreprocessorFuncs
   * @return {Object} Init option
   */ setOption: function(rawOption, optionPreprocessorFuncs) {
        if (rawOption) // That set dat primitive is dangerous if user reuse the data when setOption again.
        $ec279652dd95c27b$export$79b2f7037acddd43($d559f43cb9041423$export$4f07b212a02c8051(rawOption.series), function(series) {
            series && series.data && $ec279652dd95c27b$export$b119cc7e1840e59c(series.data) && $ec279652dd95c27b$export$112e66431016387b(series.data);
        });
         // Caution: some series modify option data, if do not clone,
        // it should ensure that the repeat modify correctly
        // (create a new object when modify itself).
        rawOption = $440c6b6cac31c6df$var$clone(rawOption); // FIXME
        // 如果 timeline options 或者 media 中设置了某个属性，而baseOption中没有设置，则进行警告。
        var oldOptionBackup = this._optionBackup;
        var newParsedOption = $440c6b6cac31c6df$var$parseRawOption.call(this, rawOption, optionPreprocessorFuncs, !oldOptionBackup);
        this._newBaseOption = newParsedOption.baseOption; // For setOption at second time (using merge mode);
        if (oldOptionBackup) {
            // Only baseOption can be merged.
            $440c6b6cac31c6df$var$mergeOption(oldOptionBackup.baseOption, newParsedOption.baseOption); // For simplicity, timeline options and media options do not support merge,
            // that is, if you `setOption` twice and both has timeline options, the latter
            // timeline opitons will not be merged to the formers, but just substitude them.
            if (newParsedOption.timelineOptions.length) oldOptionBackup.timelineOptions = newParsedOption.timelineOptions;
            if (newParsedOption.mediaList.length) oldOptionBackup.mediaList = newParsedOption.mediaList;
            if (newParsedOption.mediaDefault) oldOptionBackup.mediaDefault = newParsedOption.mediaDefault;
        } else this._optionBackup = newParsedOption;
    },
    /**
   * @param {boolean} isRecreate
   * @return {Object}
   */ mountOption: function(isRecreate) {
        var optionBackup = this._optionBackup; // TODO
        // 如果没有reset功能则不clone。
        this._timelineOptions = $440c6b6cac31c6df$var$map(optionBackup.timelineOptions, $440c6b6cac31c6df$var$clone);
        this._mediaList = $440c6b6cac31c6df$var$map(optionBackup.mediaList, $440c6b6cac31c6df$var$clone);
        this._mediaDefault = $440c6b6cac31c6df$var$clone(optionBackup.mediaDefault);
        this._currentMediaIndices = [];
        return $440c6b6cac31c6df$var$clone(isRecreate // this._optionBackup.baseOption, which is created at the first `setOption`
         ? optionBackup.baseOption : this._newBaseOption);
    },
    /**
   * @param {module:echarts/model/Global} ecModel
   * @return {Object}
   */ getTimelineOption: function(ecModel) {
        var option;
        var timelineOptions = this._timelineOptions;
        if (timelineOptions.length) {
            // getTimelineOption can only be called after ecModel inited,
            // so we can get currentIndex from timelineModel.
            var timelineModel = ecModel.getComponent("timeline");
            if (timelineModel) option = $440c6b6cac31c6df$var$clone(timelineOptions[timelineModel.getCurrentIndex()], true);
        }
        return option;
    },
    /**
   * @param {module:echarts/model/Global} ecModel
   * @return {Array.<Object>}
   */ getMediaOption: function(ecModel) {
        var ecWidth = this._api.getWidth();
        var ecHeight = this._api.getHeight();
        var mediaList = this._mediaList;
        var mediaDefault = this._mediaDefault;
        var indices = [];
        var result = []; // No media defined.
        if (!mediaList.length && !mediaDefault) return result;
         // Multi media may be applied, the latter defined media has higher priority.
        for(var i = 0, len = mediaList.length; i < len; i++)if ($440c6b6cac31c6df$var$applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) indices.push(i);
         // FIXME
        // 是否mediaDefault应该强制用户设置，否则可能修改不能回归。
        if (!indices.length && mediaDefault) indices = [
            -1
        ];
        if (indices.length && !$440c6b6cac31c6df$var$indicesEquals(indices, this._currentMediaIndices)) result = $440c6b6cac31c6df$var$map(indices, function(index) {
            return $440c6b6cac31c6df$var$clone(index === -1 ? mediaDefault.option : mediaList[index].option);
        });
         // Otherwise return nothing.
        this._currentMediaIndices = indices;
        return result;
    }
};
function $440c6b6cac31c6df$var$parseRawOption(rawOption, optionPreprocessorFuncs, isNew) {
    var timelineOptions = [];
    var mediaList = [];
    var mediaDefault;
    var baseOption; // Compatible with ec2.
    var timelineOpt = rawOption.timeline;
    if (rawOption.baseOption) baseOption = rawOption.baseOption;
     // For timeline
    if (timelineOpt || rawOption.options) {
        baseOption = baseOption || {};
        timelineOptions = (rawOption.options || []).slice();
    } // For media query
    if (rawOption.media) {
        baseOption = baseOption || {};
        var media = rawOption.media;
        $440c6b6cac31c6df$var$each(media, function(singleMedia) {
            if (singleMedia && singleMedia.option) {
                if (singleMedia.query) mediaList.push(singleMedia);
                else if (!mediaDefault) // Use the first media default.
                mediaDefault = singleMedia;
            }
        });
    } // For normal option
    if (!baseOption) baseOption = rawOption;
     // Set timelineOpt to baseOption in ec3,
    // which is convenient for merge option.
    if (!baseOption.timeline) baseOption.timeline = timelineOpt;
     // Preprocess.
    $440c6b6cac31c6df$var$each([
        baseOption
    ].concat(timelineOptions).concat($ec279652dd95c27b$export$871de8747c9eaa88(mediaList, function(media) {
        return media.option;
    })), function(option) {
        $440c6b6cac31c6df$var$each(optionPreprocessorFuncs, function(preProcess) {
            preProcess(option, isNew);
        });
    });
    return {
        baseOption: baseOption,
        timelineOptions: timelineOptions,
        mediaDefault: mediaDefault,
        mediaList: mediaList
    };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */ function $440c6b6cac31c6df$var$applyMediaQuery(query, ecWidth, ecHeight) {
    var realMap = {
        width: ecWidth,
        height: ecHeight,
        aspectratio: ecWidth / ecHeight // lowser case for convenientce.
    };
    var applicatable = true;
    $ec279652dd95c27b$export$79b2f7037acddd43(query, function(value, attr) {
        var matched = attr.match($440c6b6cac31c6df$var$QUERY_REG);
        if (!matched || !matched[1] || !matched[2]) return;
        var operator = matched[1];
        var realAttr = matched[2].toLowerCase();
        if (!$440c6b6cac31c6df$var$compare(realMap[realAttr], value, operator)) applicatable = false;
    });
    return applicatable;
}
function $440c6b6cac31c6df$var$compare(real, expect, operator) {
    if (operator === "min") return real >= expect;
    else if (operator === "max") return real <= expect;
    else // Equals
    return real === expect;
}
function $440c6b6cac31c6df$var$indicesEquals(indices1, indices2) {
    // indices is always order by asc and has only finite number.
    return indices1.join(",") === indices2.join(",");
}
/**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handle its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performace expensive)
 */ function $440c6b6cac31c6df$var$mergeOption(oldOption, newOption) {
    newOption = newOption || {};
    $440c6b6cac31c6df$var$each(newOption, function(newCptOpt, mainType) {
        if (newCptOpt == null) return;
        var oldCptOpt = oldOption[mainType];
        if (!$3b9c2389e45dfb7d$exports.hasClass(mainType)) oldOption[mainType] = $440c6b6cac31c6df$var$merge(oldCptOpt, newCptOpt, true);
        else {
            newCptOpt = $d559f43cb9041423$export$4f07b212a02c8051(newCptOpt);
            oldCptOpt = $d559f43cb9041423$export$4f07b212a02c8051(oldCptOpt);
            var mapResult = $d559f43cb9041423$export$574f818966e4da87(oldCptOpt, newCptOpt);
            oldOption[mainType] = $440c6b6cac31c6df$var$map(mapResult, function(item) {
                return item.option && item.exist ? $440c6b6cac31c6df$var$merge(item.exist, item.option, true) : item.exist || item.option;
            });
        }
    });
}
var $440c6b6cac31c6df$var$_default = $440c6b6cac31c6df$var$OptionManager;
$440c6b6cac31c6df$exports = $440c6b6cac31c6df$var$_default;


var $1706c18d3b422369$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1706c18d3b422369$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $1706c18d3b422369$var$isArray = $ec279652dd95c27b$export$43bee75e5e14138e;
var $1706c18d3b422369$var$isObject = $ec279652dd95c27b$export$a6cdc56e425d0d0a;
var $d9e191613321bdaa$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $d9e191613321bdaa$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $d9e191613321bdaa$var$isObject = $ec279652dd95c27b$export$a6cdc56e425d0d0a;
var $d9e191613321bdaa$var$POSSIBLE_STYLES = [
    "areaStyle",
    "lineStyle",
    "nodeStyle",
    "linkStyle",
    "chordStyle",
    "label",
    "labelLine"
];
function $d9e191613321bdaa$var$compatEC2ItemStyle(opt) {
    var itemStyleOpt = opt && opt.itemStyle;
    if (!itemStyleOpt) return;
    for(var i = 0, len = $d9e191613321bdaa$var$POSSIBLE_STYLES.length; i < len; i++){
        var styleName = $d9e191613321bdaa$var$POSSIBLE_STYLES[i];
        var normalItemStyleOpt = itemStyleOpt.normal;
        var emphasisItemStyleOpt = itemStyleOpt.emphasis;
        if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].normal) opt[styleName].normal = normalItemStyleOpt[styleName];
            else $ec279652dd95c27b$export$4950aa0f605343fb(opt[styleName].normal, normalItemStyleOpt[styleName]);
            normalItemStyleOpt[styleName] = null;
        }
        if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].emphasis) opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
            else $ec279652dd95c27b$export$4950aa0f605343fb(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
            emphasisItemStyleOpt[styleName] = null;
        }
    }
}
function $d9e191613321bdaa$var$convertNormalEmphasis(opt, optType, useExtend) {
    if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
        var normalOpt = opt[optType].normal;
        var emphasisOpt = opt[optType].emphasis;
        if (normalOpt) {
            // Timeline controlStyle has other properties besides normal and emphasis
            if (useExtend) {
                opt[optType].normal = opt[optType].emphasis = null;
                $ec279652dd95c27b$export$ebe90cb607ad99e(opt[optType], normalOpt);
            } else opt[optType] = normalOpt;
        }
        if (emphasisOpt) {
            opt.emphasis = opt.emphasis || {};
            opt.emphasis[optType] = emphasisOpt;
        }
    }
}
function $d9e191613321bdaa$var$removeEC3NormalStatus(opt) {
    $d9e191613321bdaa$var$convertNormalEmphasis(opt, "itemStyle");
    $d9e191613321bdaa$var$convertNormalEmphasis(opt, "lineStyle");
    $d9e191613321bdaa$var$convertNormalEmphasis(opt, "areaStyle");
    $d9e191613321bdaa$var$convertNormalEmphasis(opt, "label");
    $d9e191613321bdaa$var$convertNormalEmphasis(opt, "labelLine"); // treemap
    $d9e191613321bdaa$var$convertNormalEmphasis(opt, "upperLabel"); // graph
    $d9e191613321bdaa$var$convertNormalEmphasis(opt, "edgeLabel");
}
function $d9e191613321bdaa$var$compatTextStyle(opt, propName) {
    // Check whether is not object (string\null\undefined ...)
    var labelOptSingle = $d9e191613321bdaa$var$isObject(opt) && opt[propName];
    var textStyle = $d9e191613321bdaa$var$isObject(labelOptSingle) && labelOptSingle.textStyle;
    if (textStyle) for(var i = 0, len = $d559f43cb9041423$export$df45610347a602ad.length; i < len; i++){
        var propName = $d559f43cb9041423$export$df45610347a602ad[i];
        if (textStyle.hasOwnProperty(propName)) labelOptSingle[propName] = textStyle[propName];
    }
}
function $d9e191613321bdaa$var$compatEC3CommonStyles(opt) {
    if (opt) {
        $d9e191613321bdaa$var$removeEC3NormalStatus(opt);
        $d9e191613321bdaa$var$compatTextStyle(opt, "label");
        opt.emphasis && $d9e191613321bdaa$var$compatTextStyle(opt.emphasis, "label");
    }
}
function $d9e191613321bdaa$var$processSeries(seriesOpt) {
    if (!$d9e191613321bdaa$var$isObject(seriesOpt)) return;
    $d9e191613321bdaa$var$compatEC2ItemStyle(seriesOpt);
    $d9e191613321bdaa$var$removeEC3NormalStatus(seriesOpt);
    $d9e191613321bdaa$var$compatTextStyle(seriesOpt, "label"); // treemap
    $d9e191613321bdaa$var$compatTextStyle(seriesOpt, "upperLabel"); // graph
    $d9e191613321bdaa$var$compatTextStyle(seriesOpt, "edgeLabel");
    if (seriesOpt.emphasis) {
        $d9e191613321bdaa$var$compatTextStyle(seriesOpt.emphasis, "label"); // treemap
        $d9e191613321bdaa$var$compatTextStyle(seriesOpt.emphasis, "upperLabel"); // graph
        $d9e191613321bdaa$var$compatTextStyle(seriesOpt.emphasis, "edgeLabel");
    }
    var markPoint = seriesOpt.markPoint;
    if (markPoint) {
        $d9e191613321bdaa$var$compatEC2ItemStyle(markPoint);
        $d9e191613321bdaa$var$compatEC3CommonStyles(markPoint);
    }
    var markLine = seriesOpt.markLine;
    if (markLine) {
        $d9e191613321bdaa$var$compatEC2ItemStyle(markLine);
        $d9e191613321bdaa$var$compatEC3CommonStyles(markLine);
    }
    var markArea = seriesOpt.markArea;
    if (markArea) $d9e191613321bdaa$var$compatEC3CommonStyles(markArea);
    var data = seriesOpt.data; // Break with ec3: if `setOption` again, there may be no `type` in option,
    // then the backward compat based on option type will not be performed.
    if (seriesOpt.type === "graph") {
        data = data || seriesOpt.nodes;
        var edgeData = seriesOpt.links || seriesOpt.edges;
        if (edgeData && !$ec279652dd95c27b$export$b119cc7e1840e59c(edgeData)) for(var i = 0; i < edgeData.length; i++)$d9e191613321bdaa$var$compatEC3CommonStyles(edgeData[i]);
        $ec279652dd95c27b$export$79b2f7037acddd43(seriesOpt.categories, function(opt) {
            $d9e191613321bdaa$var$removeEC3NormalStatus(opt);
        });
    }
    if (data && !$ec279652dd95c27b$export$b119cc7e1840e59c(data)) for(var i = 0; i < data.length; i++)$d9e191613321bdaa$var$compatEC3CommonStyles(data[i]);
     // mark point data
    var markPoint = seriesOpt.markPoint;
    if (markPoint && markPoint.data) {
        var mpData = markPoint.data;
        for(var i = 0; i < mpData.length; i++)$d9e191613321bdaa$var$compatEC3CommonStyles(mpData[i]);
    } // mark line data
    var markLine = seriesOpt.markLine;
    if (markLine && markLine.data) {
        var mlData = markLine.data;
        for(var i = 0; i < mlData.length; i++)if ($ec279652dd95c27b$export$43bee75e5e14138e(mlData[i])) {
            $d9e191613321bdaa$var$compatEC3CommonStyles(mlData[i][0]);
            $d9e191613321bdaa$var$compatEC3CommonStyles(mlData[i][1]);
        } else $d9e191613321bdaa$var$compatEC3CommonStyles(mlData[i]);
    } // Series
    if (seriesOpt.type === "gauge") {
        $d9e191613321bdaa$var$compatTextStyle(seriesOpt, "axisLabel");
        $d9e191613321bdaa$var$compatTextStyle(seriesOpt, "title");
        $d9e191613321bdaa$var$compatTextStyle(seriesOpt, "detail");
    } else if (seriesOpt.type === "treemap") {
        $d9e191613321bdaa$var$convertNormalEmphasis(seriesOpt.breadcrumb, "itemStyle");
        $ec279652dd95c27b$export$79b2f7037acddd43(seriesOpt.levels, function(opt) {
            $d9e191613321bdaa$var$removeEC3NormalStatus(opt);
        });
    } else if (seriesOpt.type === "tree") $d9e191613321bdaa$var$removeEC3NormalStatus(seriesOpt.leaves);
     // sunburst starts from ec4, so it does not need to compat levels.
}
function $d9e191613321bdaa$var$toArr(o) {
    return $ec279652dd95c27b$export$43bee75e5e14138e(o) ? o : o ? [
        o
    ] : [];
}
function $d9e191613321bdaa$var$toObj(o) {
    return ($ec279652dd95c27b$export$43bee75e5e14138e(o) ? o[0] : o) || {};
}
function $d9e191613321bdaa$var$_default(option, isTheme) {
    $d9e191613321bdaa$var$each($d9e191613321bdaa$var$toArr(option.series), function(seriesOpt) {
        $d9e191613321bdaa$var$isObject(seriesOpt) && $d9e191613321bdaa$var$processSeries(seriesOpt);
    });
    var axes = [
        "xAxis",
        "yAxis",
        "radiusAxis",
        "angleAxis",
        "singleAxis",
        "parallelAxis",
        "radar"
    ];
    isTheme && axes.push("valueAxis", "categoryAxis", "logAxis", "timeAxis");
    $d9e191613321bdaa$var$each(axes, function(axisName) {
        $d9e191613321bdaa$var$each($d9e191613321bdaa$var$toArr(option[axisName]), function(axisOpt) {
            if (axisOpt) {
                $d9e191613321bdaa$var$compatTextStyle(axisOpt, "axisLabel");
                $d9e191613321bdaa$var$compatTextStyle(axisOpt.axisPointer, "label");
            }
        });
    });
    $d9e191613321bdaa$var$each($d9e191613321bdaa$var$toArr(option.parallel), function(parallelOpt) {
        var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
        $d9e191613321bdaa$var$compatTextStyle(parallelAxisDefault, "axisLabel");
        $d9e191613321bdaa$var$compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, "label");
    });
    $d9e191613321bdaa$var$each($d9e191613321bdaa$var$toArr(option.calendar), function(calendarOpt) {
        $d9e191613321bdaa$var$convertNormalEmphasis(calendarOpt, "itemStyle");
        $d9e191613321bdaa$var$compatTextStyle(calendarOpt, "dayLabel");
        $d9e191613321bdaa$var$compatTextStyle(calendarOpt, "monthLabel");
        $d9e191613321bdaa$var$compatTextStyle(calendarOpt, "yearLabel");
    }); // radar.name.textStyle
    $d9e191613321bdaa$var$each($d9e191613321bdaa$var$toArr(option.radar), function(radarOpt) {
        $d9e191613321bdaa$var$compatTextStyle(radarOpt, "name");
    });
    $d9e191613321bdaa$var$each($d9e191613321bdaa$var$toArr(option.geo), function(geoOpt) {
        if ($d9e191613321bdaa$var$isObject(geoOpt)) {
            $d9e191613321bdaa$var$compatEC3CommonStyles(geoOpt);
            $d9e191613321bdaa$var$each($d9e191613321bdaa$var$toArr(geoOpt.regions), function(regionObj) {
                $d9e191613321bdaa$var$compatEC3CommonStyles(regionObj);
            });
        }
    });
    $d9e191613321bdaa$var$each($d9e191613321bdaa$var$toArr(option.timeline), function(timelineOpt) {
        $d9e191613321bdaa$var$compatEC3CommonStyles(timelineOpt);
        $d9e191613321bdaa$var$convertNormalEmphasis(timelineOpt, "label");
        $d9e191613321bdaa$var$convertNormalEmphasis(timelineOpt, "itemStyle");
        $d9e191613321bdaa$var$convertNormalEmphasis(timelineOpt, "controlStyle", true);
        var data = timelineOpt.data;
        $ec279652dd95c27b$export$43bee75e5e14138e(data) && $ec279652dd95c27b$export$79b2f7037acddd43(data, function(item) {
            if ($ec279652dd95c27b$export$a6cdc56e425d0d0a(item)) {
                $d9e191613321bdaa$var$convertNormalEmphasis(item, "label");
                $d9e191613321bdaa$var$convertNormalEmphasis(item, "itemStyle");
            }
        });
    });
    $d9e191613321bdaa$var$each($d9e191613321bdaa$var$toArr(option.toolbox), function(toolboxOpt) {
        $d9e191613321bdaa$var$convertNormalEmphasis(toolboxOpt, "iconStyle");
        $d9e191613321bdaa$var$each(toolboxOpt.feature, function(featureOpt) {
            $d9e191613321bdaa$var$convertNormalEmphasis(featureOpt, "iconStyle");
        });
    });
    $d9e191613321bdaa$var$compatTextStyle($d9e191613321bdaa$var$toObj(option.axisPointer), "label");
    $d9e191613321bdaa$var$compatTextStyle($d9e191613321bdaa$var$toObj(option.tooltip).axisPointer, "label");
}
$d9e191613321bdaa$exports = $d9e191613321bdaa$var$_default;



var $1706c18d3b422369$var$normalizeToArray = $d559f43cb9041423$export$4f07b212a02c8051;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Compatitable with 2.0
function $1706c18d3b422369$var$get(opt, path) {
    path = path.split(",");
    var obj = opt;
    for(var i = 0; i < path.length; i++){
        obj = obj && obj[path[i]];
        if (obj == null) break;
    }
    return obj;
}
function $1706c18d3b422369$var$set(opt, path, val, overwrite) {
    path = path.split(",");
    var obj = opt;
    var key;
    for(var i = 0; i < path.length - 1; i++){
        key = path[i];
        if (obj[key] == null) obj[key] = {};
        obj = obj[key];
    }
    if (overwrite || obj[path[i]] == null) obj[path[i]] = val;
}
function $1706c18d3b422369$var$compatLayoutProperties(option) {
    $1706c18d3b422369$var$each($1706c18d3b422369$var$LAYOUT_PROPERTIES, function(prop) {
        if (prop[0] in option && !(prop[1] in option)) option[prop[1]] = option[prop[0]];
    });
}
var $1706c18d3b422369$var$LAYOUT_PROPERTIES = [
    [
        "x",
        "left"
    ],
    [
        "y",
        "top"
    ],
    [
        "x2",
        "right"
    ],
    [
        "y2",
        "bottom"
    ]
];
var $1706c18d3b422369$var$COMPATITABLE_COMPONENTS = [
    "grid",
    "geo",
    "parallel",
    "legend",
    "toolbox",
    "title",
    "visualMap",
    "dataZoom",
    "timeline"
];
function $1706c18d3b422369$var$_default(option, isTheme) {
    $d9e191613321bdaa$exports(option, isTheme); // Make sure series array for model initialization.
    option.series = $1706c18d3b422369$var$normalizeToArray(option.series);
    $1706c18d3b422369$var$each(option.series, function(seriesOpt) {
        if (!$1706c18d3b422369$var$isObject(seriesOpt)) return;
        var seriesType = seriesOpt.type;
        if (seriesType === "line") {
            if (seriesOpt.clipOverflow != null) seriesOpt.clip = seriesOpt.clipOverflow;
        } else if (seriesType === "pie" || seriesType === "gauge") {
            if (seriesOpt.clockWise != null) seriesOpt.clockwise = seriesOpt.clockWise;
        } else if (seriesType === "gauge") {
            var pointerColor = $1706c18d3b422369$var$get(seriesOpt, "pointer.color");
            pointerColor != null && $1706c18d3b422369$var$set(seriesOpt, "itemStyle.color", pointerColor);
        }
        $1706c18d3b422369$var$compatLayoutProperties(seriesOpt);
    }); // dataRange has changed to visualMap
    if (option.dataRange) option.visualMap = option.dataRange;
    $1706c18d3b422369$var$each($1706c18d3b422369$var$COMPATITABLE_COMPONENTS, function(componentName) {
        var options = option[componentName];
        if (options) {
            if (!$1706c18d3b422369$var$isArray(options)) options = [
                options
            ];
            $1706c18d3b422369$var$each(options, function(option) {
                $1706c18d3b422369$var$compatLayoutProperties(option);
            });
        }
    });
}
$1706c18d3b422369$exports = $1706c18d3b422369$var$_default;


var $947eaf1df12e0ddf$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $947eaf1df12e0ddf$var$createHashMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4;
var $947eaf1df12e0ddf$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // (1) [Caution]: the logic is correct based on the premises:
//     data processing stage is blocked in stream.
//     See <module:echarts/stream/Scheduler#performDataProcessorTasks>
// (2) Only register once when import repeatly.
//     Should be executed after series filtered and before stack calculation.
function $947eaf1df12e0ddf$var$_default(ecModel) {
    var stackInfoMap = $947eaf1df12e0ddf$var$createHashMap();
    ecModel.eachSeries(function(seriesModel) {
        var stack = seriesModel.get("stack"); // Compatibal: when `stack` is set as '', do not stack.
        if (stack) {
            var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
            var data = seriesModel.getData();
            var stackInfo = {
                // Used for calculate axis extent automatically.
                stackResultDimension: data.getCalculationInfo("stackResultDimension"),
                stackedOverDimension: data.getCalculationInfo("stackedOverDimension"),
                stackedDimension: data.getCalculationInfo("stackedDimension"),
                stackedByDimension: data.getCalculationInfo("stackedByDimension"),
                isStackedByIndex: data.getCalculationInfo("isStackedByIndex"),
                data: data,
                seriesModel: seriesModel
            }; // If stacked on axis that do not support data stack.
            if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) return;
            stackInfoList.length && data.setCalculationInfo("stackedOnSeries", stackInfoList[stackInfoList.length - 1].seriesModel);
            stackInfoList.push(stackInfo);
        }
    });
    stackInfoMap.each($947eaf1df12e0ddf$var$calculateStack);
}
function $947eaf1df12e0ddf$var$calculateStack(stackInfoList) {
    $947eaf1df12e0ddf$var$each(stackInfoList, function(targetStackInfo, idxInStack) {
        var resultVal = [];
        var resultNaN = [
            NaN,
            NaN
        ];
        var dims = [
            targetStackInfo.stackResultDimension,
            targetStackInfo.stackedOverDimension
        ];
        var targetData = targetStackInfo.data;
        var isStackedByIndex = targetStackInfo.isStackedByIndex; // Should not write on raw data, because stack series model list changes
        // depending on legend selection.
        var newData = targetData.map(dims, function(v0, v1, dataIndex) {
            var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex); // Consider `connectNulls` of line area, if value is NaN, stackedOver
            // should also be NaN, to draw a appropriate belt area.
            if (isNaN(sum)) return resultNaN;
            var byValue;
            var stackedDataRawIndex;
            if (isStackedByIndex) stackedDataRawIndex = targetData.getRawIndex(dataIndex);
            else byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
             // If stackOver is NaN, chart view will render point on value start.
            var stackedOver = NaN;
            for(var j = idxInStack - 1; j >= 0; j--){
                var stackInfo = stackInfoList[j]; // Has been optimized by inverted indices on `stackedByDimension`.
                if (!isStackedByIndex) stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
                if (stackedDataRawIndex >= 0) {
                    var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex); // Considering positive stack, negative stack and empty data
                    if (sum >= 0 && val > 0 || // Positive stack
                    sum <= 0 && val < 0 // Negative stack
                    ) {
                        sum += val;
                        stackedOver = val;
                        break;
                    }
                }
            }
            resultVal[0] = sum;
            resultVal[1] = stackedOver;
            return resultVal;
        });
        targetData.hostModel.setData(newData); // Update for consequent calculation
        targetStackInfo.data = newData;
    });
}
$947eaf1df12e0ddf$exports = $947eaf1df12e0ddf$var$_default;



var $70847df98016d69d$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $70847df98016d69d$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;



var $70847df98016d69d$var$formatTime = $a4be9366aeb9fcc8$export$3203edd9e5edd663;
var $70847df98016d69d$var$encodeHTML = $a4be9366aeb9fcc8$export$f9d6449b9af28dc1;
var $70847df98016d69d$var$addCommas = $a4be9366aeb9fcc8$export$b6fe44657ce35c42;
var $70847df98016d69d$var$getTooltipMarker = $a4be9366aeb9fcc8$export$1987a3dbdf3c45ca;



var $47a08a90150906d7$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $05c9939f6206d72a$export$b900d7c4c3952a40;
var $05c9939f6206d72a$export$fb9e716e12537ce0;
var $05c9939f6206d72a$export$cde9373da9aad801;
var $05c9939f6206d72a$export$c8ae9e77e0ddc42a;

var $05c9939f6206d72a$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;

var $05c9939f6206d72a$var$isTypedArray = $ec279652dd95c27b$export$b119cc7e1840e59c;
var $05c9939f6206d72a$var$extend = $ec279652dd95c27b$export$8b58be045bf06082;
var $05c9939f6206d72a$var$assert = $ec279652dd95c27b$export$a7a9523472993e97;
var $05c9939f6206d72a$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $05c9939f6206d72a$var$isObject = $ec279652dd95c27b$export$a6cdc56e425d0d0a;

var $05c9939f6206d72a$var$getDataItemValue = $d559f43cb9041423$export$2c944e12edb48d4b;
var $05c9939f6206d72a$var$isDataItemOption = $d559f43cb9041423$export$3e1a543f33ef6883;

var $05c9939f6206d72a$var$parseDate = $2d742dbe7f960d8c$export$6b862160d295c8e;


var $05c9939f6206d72a$var$SOURCE_FORMAT_TYPED_ARRAY = $00bf3640e0468773$export$a918cb016a382d45;
var $05c9939f6206d72a$var$SOURCE_FORMAT_ARRAY_ROWS = $00bf3640e0468773$export$fcd62ebf51387903;
var $05c9939f6206d72a$var$SOURCE_FORMAT_ORIGINAL = $00bf3640e0468773$export$2823037fb9d8f0c6;
var $05c9939f6206d72a$var$SOURCE_FORMAT_OBJECT_ROWS = $00bf3640e0468773$export$703ae8a2d83f441;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO
// ??? refactor? check the outer usage of data provider.
// merge with defaultDimValueGetter?
/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */ function $05c9939f6206d72a$var$DefaultDataProvider(source, dimSize) {
    if (!$058c715583456086$exports.isInstance(source)) source = $058c715583456086$exports.seriesDataToSource(source);
    this._source = source;
    var data = this._data = source.data;
    var sourceFormat = source.sourceFormat; // Typed array. TODO IE10+?
    if (sourceFormat === $05c9939f6206d72a$var$SOURCE_FORMAT_TYPED_ARRAY) {
        this._offset = 0;
        this._dimSize = dimSize;
        this._data = data;
    }
    var methods = $05c9939f6206d72a$var$providerMethods[sourceFormat === $05c9939f6206d72a$var$SOURCE_FORMAT_ARRAY_ROWS ? sourceFormat + "_" + source.seriesLayoutBy : sourceFormat];
    $05c9939f6206d72a$var$extend(this, methods);
}
var $05c9939f6206d72a$var$providerProto = $05c9939f6206d72a$var$DefaultDataProvider.prototype; // If data is pure without style configuration
$05c9939f6206d72a$var$providerProto.pure = false; // If data is persistent and will not be released after use.
$05c9939f6206d72a$var$providerProto.persistent = true; // ???! FIXME legacy data provider do not has method getSource
$05c9939f6206d72a$var$providerProto.getSource = function() {
    return this._source;
};
var $05c9939f6206d72a$var$providerMethods = {
    "arrayRows_column": {
        pure: true,
        count: function() {
            return Math.max(0, this._data.length - this._source.startIndex);
        },
        getItem: function(idx) {
            return this._data[idx + this._source.startIndex];
        },
        appendData: $05c9939f6206d72a$var$appendDataSimply
    },
    "arrayRows_row": {
        pure: true,
        count: function() {
            var row = this._data[0];
            return row ? Math.max(0, row.length - this._source.startIndex) : 0;
        },
        getItem: function(idx) {
            idx += this._source.startIndex;
            var item = [];
            var data = this._data;
            for(var i = 0; i < data.length; i++){
                var row = data[i];
                item.push(row ? row[idx] : null);
            }
            return item;
        },
        appendData: function() {
            throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
        }
    },
    "objectRows": {
        pure: true,
        count: $05c9939f6206d72a$var$countSimply,
        getItem: $05c9939f6206d72a$var$getItemSimply,
        appendData: $05c9939f6206d72a$var$appendDataSimply
    },
    "keyedColumns": {
        pure: true,
        count: function() {
            var dimName = this._source.dimensionsDefine[0].name;
            var col = this._data[dimName];
            return col ? col.length : 0;
        },
        getItem: function(idx) {
            var item = [];
            var dims = this._source.dimensionsDefine;
            for(var i = 0; i < dims.length; i++){
                var col = this._data[dims[i].name];
                item.push(col ? col[idx] : null);
            }
            return item;
        },
        appendData: function(newData) {
            var data = this._data;
            $05c9939f6206d72a$var$each(newData, function(newCol, key) {
                var oldCol = data[key] || (data[key] = []);
                for(var i = 0; i < (newCol || []).length; i++)oldCol.push(newCol[i]);
            });
        }
    },
    "original": {
        count: $05c9939f6206d72a$var$countSimply,
        getItem: $05c9939f6206d72a$var$getItemSimply,
        appendData: $05c9939f6206d72a$var$appendDataSimply
    },
    "typedArray": {
        persistent: false,
        pure: true,
        count: function() {
            return this._data ? this._data.length / this._dimSize : 0;
        },
        getItem: function(idx, out) {
            idx = idx - this._offset;
            out = out || [];
            var offset = this._dimSize * idx;
            for(var i = 0; i < this._dimSize; i++)out[i] = this._data[offset + i];
            return out;
        },
        appendData: function(newData) {
            this._data = newData;
        },
        // Clean self if data is already used.
        clean: function() {
            // PENDING
            this._offset += this.count();
            this._data = null;
        }
    }
};
function $05c9939f6206d72a$var$countSimply() {
    return this._data.length;
}
function $05c9939f6206d72a$var$getItemSimply(idx) {
    return this._data[idx];
}
function $05c9939f6206d72a$var$appendDataSimply(newData) {
    for(var i = 0; i < newData.length; i++)this._data.push(newData[i]);
}
var $05c9939f6206d72a$var$rawValueGetters = {
    arrayRows: $05c9939f6206d72a$var$getRawValueSimply,
    objectRows: function(dataItem, dataIndex, dimIndex, dimName) {
        return dimIndex != null ? dataItem[dimName] : dataItem;
    },
    keyedColumns: $05c9939f6206d72a$var$getRawValueSimply,
    original: function(dataItem, dataIndex, dimIndex, dimName) {
        // FIXME
        // In some case (markpoint in geo (geo-map.html)), dataItem
        // is {coord: [...]}
        var value = $05c9939f6206d72a$var$getDataItemValue(dataItem);
        return dimIndex == null || !(value instanceof Array) ? value : value[dimIndex];
    },
    typedArray: $05c9939f6206d72a$var$getRawValueSimply
};
function $05c9939f6206d72a$var$getRawValueSimply(dataItem, dataIndex, dimIndex, dimName) {
    return dimIndex != null ? dataItem[dimIndex] : dataItem;
}
var $05c9939f6206d72a$var$defaultDimValueGetters = {
    arrayRows: $05c9939f6206d72a$var$getDimValueSimply,
    objectRows: function(dataItem, dimName, dataIndex, dimIndex) {
        return $05c9939f6206d72a$var$converDataValue(dataItem[dimName], this._dimensionInfos[dimName]);
    },
    keyedColumns: $05c9939f6206d72a$var$getDimValueSimply,
    original: function(dataItem, dimName, dataIndex, dimIndex) {
        // Performance sensitive, do not use modelUtil.getDataItemValue.
        // If dataItem is an plain object with no value field, the var `value`
        // will be assigned with the object, but it will be tread correctly
        // in the `convertDataValue`.
        var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value); // If any dataItem is like { value: 10 }
        if (!this._rawData.pure && $05c9939f6206d72a$var$isDataItemOption(dataItem)) this.hasItemOption = true;
        return $05c9939f6206d72a$var$converDataValue(value instanceof Array ? value[dimIndex] // If value is a single number or something else not array.
         : value, this._dimensionInfos[dimName]);
    },
    typedArray: function(dataItem, dimName, dataIndex, dimIndex) {
        return dataItem[dimIndex];
    }
};
function $05c9939f6206d72a$var$getDimValueSimply(dataItem, dimName, dataIndex, dimIndex) {
    return $05c9939f6206d72a$var$converDataValue(dataItem[dimIndex], this._dimensionInfos[dimName]);
}
/**
 * This helper method convert value in data.
 * @param {string|number|Date} value
 * @param {Object|string} [dimInfo] If string (like 'x'), dimType defaults 'number'.
 *        If "dimInfo.ordinalParseAndSave", ordinal value can be parsed.
 */ function $05c9939f6206d72a$var$converDataValue(value, dimInfo) {
    // Performance sensitive.
    var dimType = dimInfo && dimInfo.type;
    if (dimType === "ordinal") {
        // If given value is a category string
        var ordinalMeta = dimInfo && dimInfo.ordinalMeta;
        return ordinalMeta ? ordinalMeta.parseAndCollect(value) : value;
    }
    if (dimType === "time" // spead up when using timestamp
     && typeof value !== "number" && value != null && value !== "-") value = +$05c9939f6206d72a$var$parseDate(value);
     // dimType defaults 'number'.
    // If dimType is not ordinal and value is null or undefined or NaN or '-',
    // parse to NaN.
    return value == null || value === "" ? NaN // If string (like '-'), using '+' parse to NaN
     : +value;
} // ??? FIXME can these logic be more neat: getRawValue, getRawDataItem,
// Consider persistent.
// Caution: why use raw value to display on label or tooltip?
// A reason is to avoid format. For example time value we do not know
// how to format is expected. More over, if stack is used, calculated
// value may be 0.91000000001, which have brings trouble to display.
// TODO: consider how to treat null/undefined/NaN when display?
/**
 * @param {module:echarts/data/List} data
 * @param {number} dataIndex
 * @param {string|number} [dim] dimName or dimIndex
 * @return {Array.<number>|string|number} can be null/undefined.
 */ function $05c9939f6206d72a$var$retrieveRawValue(data, dataIndex, dim) {
    if (!data) return;
     // Consider data may be not persistent.
    var dataItem = data.getRawDataItem(dataIndex);
    if (dataItem == null) return;
    var sourceFormat = data.getProvider().getSource().sourceFormat;
    var dimName;
    var dimIndex;
    var dimInfo = data.getDimensionInfo(dim);
    if (dimInfo) {
        dimName = dimInfo.name;
        dimIndex = dimInfo.index;
    }
    return $05c9939f6206d72a$var$rawValueGetters[sourceFormat](dataItem, dataIndex, dimIndex, dimName);
}
/**
 * Compatible with some cases (in pie, map) like:
 * data: [{name: 'xx', value: 5, selected: true}, ...]
 * where only sourceFormat is 'original' and 'objectRows' supported.
 *
 * ??? TODO
 * Supported detail options in data item when using 'arrayRows'.
 *
 * @param {module:echarts/data/List} data
 * @param {number} dataIndex
 * @param {string} attr like 'selected'
 */ function $05c9939f6206d72a$var$retrieveRawAttr(data, dataIndex, attr) {
    if (!data) return;
    var sourceFormat = data.getProvider().getSource().sourceFormat;
    if (sourceFormat !== $05c9939f6206d72a$var$SOURCE_FORMAT_ORIGINAL && sourceFormat !== $05c9939f6206d72a$var$SOURCE_FORMAT_OBJECT_ROWS) return;
    var dataItem = data.getRawDataItem(dataIndex);
    if (sourceFormat === $05c9939f6206d72a$var$SOURCE_FORMAT_ORIGINAL && !$05c9939f6206d72a$var$isObject(dataItem)) dataItem = null;
    if (dataItem) return dataItem[attr];
}
$05c9939f6206d72a$export$b900d7c4c3952a40 = $05c9939f6206d72a$var$DefaultDataProvider;
$05c9939f6206d72a$export$fb9e716e12537ce0 = $05c9939f6206d72a$var$defaultDimValueGetters;
$05c9939f6206d72a$export$cde9373da9aad801 = $05c9939f6206d72a$var$retrieveRawValue;
$05c9939f6206d72a$export$c8ae9e77e0ddc42a = $05c9939f6206d72a$var$retrieveRawAttr;


var $47a08a90150906d7$var$retrieveRawValue = $05c9939f6206d72a$export$cde9373da9aad801;

var $47a08a90150906d7$var$getTooltipMarker = $a4be9366aeb9fcc8$export$1987a3dbdf3c45ca;
var $47a08a90150906d7$var$formatTpl = $a4be9366aeb9fcc8$export$2028496a35766e41;

var $47a08a90150906d7$var$getTooltipRenderMode = $d559f43cb9041423$export$cc0a17a5d27b4e17;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $47a08a90150906d7$var$DIMENSION_LABEL_REG = /\{@(.+?)\}/g; // PENDING A little ugly
var $47a08a90150906d7$var$_default = {
    /**
   * Get params for formatter
   * @param {number} dataIndex
   * @param {string} [dataType]
   * @return {Object}
   */ getDataParams: function(dataIndex, dataType) {
        var data = this.getData(dataType);
        var rawValue = this.getRawValue(dataIndex, dataType);
        var rawDataIndex = data.getRawIndex(dataIndex);
        var name = data.getName(dataIndex);
        var itemOpt = data.getRawDataItem(dataIndex);
        var color = data.getItemVisual(dataIndex, "color");
        var borderColor = data.getItemVisual(dataIndex, "borderColor");
        var tooltipModel = this.ecModel.getComponent("tooltip");
        var renderModeOption = tooltipModel && tooltipModel.get("renderMode");
        var renderMode = $47a08a90150906d7$var$getTooltipRenderMode(renderModeOption);
        var mainType = this.mainType;
        var isSeries = mainType === "series";
        var userOutput = data.userOutput;
        return {
            componentType: mainType,
            componentSubType: this.subType,
            componentIndex: this.componentIndex,
            seriesType: isSeries ? this.subType : null,
            seriesIndex: this.seriesIndex,
            seriesId: isSeries ? this.id : null,
            seriesName: isSeries ? this.name : null,
            name: name,
            dataIndex: rawDataIndex,
            data: itemOpt,
            dataType: dataType,
            value: rawValue,
            color: color,
            borderColor: borderColor,
            dimensionNames: userOutput ? userOutput.dimensionNames : null,
            encode: userOutput ? userOutput.encode : null,
            marker: $47a08a90150906d7$var$getTooltipMarker({
                color: color,
                renderMode: renderMode
            }),
            // Param name list for mapping `a`, `b`, `c`, `d`, `e`
            $vars: [
                "seriesName",
                "name",
                "value"
            ]
        };
    },
    /**
   * Format label
   * @param {number} dataIndex
   * @param {string} [status='normal'] 'normal' or 'emphasis'
   * @param {string} [dataType]
   * @param {number} [dimIndex] Only used in some chart that
   *        use formatter in different dimensions, like radar.
   * @param {string} [labelProp='label']
   * @return {string} If not formatter, return null/undefined
   */ getFormattedLabel: function(dataIndex, status, dataType, dimIndex, labelProp) {
        status = status || "normal";
        var data = this.getData(dataType);
        var itemModel = data.getItemModel(dataIndex);
        var params = this.getDataParams(dataIndex, dataType);
        if (dimIndex != null && params.value instanceof Array) params.value = params.value[dimIndex];
        var formatter = itemModel.get(status === "normal" ? [
            labelProp || "label",
            "formatter"
        ] : [
            status,
            labelProp || "label",
            "formatter"
        ]);
        if (typeof formatter === "function") {
            params.status = status;
            params.dimensionIndex = dimIndex;
            return formatter(params);
        } else if (typeof formatter === "string") {
            var str = $47a08a90150906d7$var$formatTpl(formatter, params); // Support 'aaa{@[3]}bbb{@product}ccc'.
            // Do not support '}' in dim name util have to.
            return str.replace($47a08a90150906d7$var$DIMENSION_LABEL_REG, function(origin, dim) {
                var len = dim.length;
                if (dim.charAt(0) === "[" && dim.charAt(len - 1) === "]") dim = +dim.slice(1, len - 1); // Also: '[]' => 0
                return $47a08a90150906d7$var$retrieveRawValue(data, dataIndex, dim);
            });
        }
    },
    /**
   * Get raw value in option
   * @param {number} idx
   * @param {string} [dataType]
   * @return {Array|number|string}
   */ getRawValue: function(idx, dataType) {
        return $47a08a90150906d7$var$retrieveRawValue(this.getData(dataType), idx);
    },
    /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {number} [dataType]
   * @return {string} tooltip string
   */ formatTooltip: function() {}
};
$47a08a90150906d7$exports = $47a08a90150906d7$var$_default;



var $70847df98016d69d$var$getLayoutParams = $ab0c9086dd6c5b39$export$4b0d20af19c9875e;
var $70847df98016d69d$var$mergeLayoutParam = $ab0c9086dd6c5b39$export$1754cb91f16ca028;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // For stream debug (Should be commented out after used!)
// Usage: printTask(this, 'begin');
// Usage: printTask(this, null, {someExtraProp});
// function printTask(task, prefix, extra) {
//     window.ecTaskUID == null && (window.ecTaskUID = 0);
//     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
//     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
//     var props = [];
//     if (task.__pipeline) {
//         var val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
//         props.push({text: 'idx', value: val});
//     } else {
//         var stubCount = 0;
//         task.agentStubMap.each(() => stubCount++);
//         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
//     }
//     props.push({text: 'uid', value: task.uidDebug});
//     if (task.__pipeline) {
//         props.push({text: 'pid', value: task.__pipeline.id});
//         task.agent && props.push(
//             {text: 'stubFor', value: task.agent.uidDebug}
//         );
//     }
//     props.push(
//         {text: 'dirty', value: task._dirty},
//         {text: 'dueIndex', value: task._dueIndex},
//         {text: 'dueEnd', value: task._dueEnd},
//         {text: 'outputDueEnd', value: task._outputDueEnd}
//     );
//     if (extra) {
//         Object.keys(extra).forEach(key => {
//             props.push({text: key, value: extra[key]});
//         });
//     }
//     var args = ['color: blue'];
//     var msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
//         args.push('color: black', 'color: red'),
//         `${item.text}: %c${item.value}`
//     )).join('%c, ');
//     console.log.apply(console, [msg].concat(args));
//     // console.log(this);
// }
var $6d93d3ff4f052552$export$f7292ab7796be73c;

var $6d93d3ff4f052552$var$assert = $ec279652dd95c27b$export$a7a9523472993e97;
var $6d93d3ff4f052552$var$isArray = $ec279652dd95c27b$export$43bee75e5e14138e;

var $6d93d3ff4f052552$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @param {Object} define
 * @return See the return of `createTask`.
 */ function $6d93d3ff4f052552$var$createTask(define) {
    return new $6d93d3ff4f052552$var$Task(define);
}
/**
 * @constructor
 * @param {Object} define
 * @param {Function} define.reset Custom reset
 * @param {Function} [define.plan] Returns 'reset' indicate reset immediately.
 * @param {Function} [define.count] count is used to determin data task.
 * @param {Function} [define.onDirty] count is used to determin data task.
 */ function $6d93d3ff4f052552$var$Task(define) {
    define = define || {};
    this._reset = define.reset;
    this._plan = define.plan;
    this._count = define.count;
    this._onDirty = define.onDirty;
    this._dirty = true; // Context must be specified implicitly, to
    // avoid miss update context when model changed.
    this.context;
}
var $6d93d3ff4f052552$var$taskProto = $6d93d3ff4f052552$var$Task.prototype;
/**
 * @param {Object} performArgs
 * @param {number} [performArgs.step] Specified step.
 * @param {number} [performArgs.skip] Skip customer perform call.
 * @param {number} [performArgs.modBy] Sampling window size.
 * @param {number} [performArgs.modDataCount] Sampling count.
 */ $6d93d3ff4f052552$var$taskProto.perform = function(performArgs) {
    var upTask = this._upstream;
    var skip = performArgs && performArgs.skip; // TODO some refactor.
    // Pull data. Must pull data each time, because context.data
    // may be updated by Series.setData.
    if (this._dirty && upTask) {
        var context = this.context;
        context.data = context.outputData = upTask.context.outputData;
    }
    if (this.__pipeline) this.__pipeline.currentTask = this;
    var planResult;
    if (this._plan && !skip) planResult = this._plan(this.context);
     // Support sharding by mod, which changes the render sequence and makes the rendered graphic
    // elements uniformed distributed when progress, especially when moving or zooming.
    var lastModBy = normalizeModBy(this._modBy);
    var lastModDataCount = this._modDataCount || 0;
    var modBy = normalizeModBy(performArgs && performArgs.modBy);
    var modDataCount = performArgs && performArgs.modDataCount || 0;
    if (lastModBy !== modBy || lastModDataCount !== modDataCount) planResult = "reset";
    function normalizeModBy(val) {
        !(val >= 1) && (val = 1); // jshint ignore:line
        return val;
    }
    var forceFirstProgress;
    if (this._dirty || planResult === "reset") {
        this._dirty = false;
        forceFirstProgress = $6d93d3ff4f052552$var$reset(this, skip);
    }
    this._modBy = modBy;
    this._modDataCount = modDataCount;
    var step = performArgs && performArgs.step;
    if (upTask) this._dueEnd = upTask._outputDueEnd;
    else this._dueEnd = this._count ? this._count(this.context) : Infinity;
     // Note: Stubs, that its host overall task let it has progress, has progress.
    // If no progress, pass index from upstream to downstream each time plan called.
    if (this._progress) {
        var start = this._dueIndex;
        var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
        if (!skip && (forceFirstProgress || start < end)) {
            var progress = this._progress;
            if ($6d93d3ff4f052552$var$isArray(progress)) for(var i = 0; i < progress.length; i++)$6d93d3ff4f052552$var$doProgress(this, progress[i], start, end, modBy, modDataCount);
            else $6d93d3ff4f052552$var$doProgress(this, progress, start, end, modBy, modDataCount);
        }
        this._dueIndex = end; // If no `outputDueEnd`, assume that output data and
        // input data is the same, so use `dueIndex` as `outputDueEnd`.
        var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
        this._outputDueEnd = outputDueEnd;
    } else // (1) Some overall task has no progress.
    // (2) Stubs, that its host overall task do not let it has progress, has no progress.
    // This should always be performed so it can be passed to downstream.
    this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
    return this.unfinished();
};
var $6d93d3ff4f052552$var$iterator = function() {
    var end;
    var current;
    var modBy;
    var modDataCount;
    var winCount;
    var it = {
        reset: function(s, e, sStep, sCount) {
            current = s;
            end = e;
            modBy = sStep;
            modDataCount = sCount;
            winCount = Math.ceil(modDataCount / modBy);
            it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
        }
    };
    return it;
    function sequentialNext() {
        return current < end ? current++ : null;
    }
    function modNext() {
        var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
        var result = current >= end ? null : dataIndex < modDataCount ? dataIndex // If modDataCount is smaller than data.count() (consider `appendData` case),
         : current;
        current++;
        return result;
    }
}();
$6d93d3ff4f052552$var$taskProto.dirty = function() {
    this._dirty = true;
    this._onDirty && this._onDirty(this.context);
};
function $6d93d3ff4f052552$var$doProgress(taskIns, progress, start, end, modBy, modDataCount) {
    $6d93d3ff4f052552$var$iterator.reset(start, end, modBy, modDataCount);
    taskIns._callingProgress = progress;
    taskIns._callingProgress({
        start: start,
        end: end,
        count: end - start,
        next: $6d93d3ff4f052552$var$iterator.next
    }, taskIns.context);
}
function $6d93d3ff4f052552$var$reset(taskIns, skip) {
    taskIns._dueIndex = taskIns._outputDueEnd = taskIns._dueEnd = 0;
    taskIns._settedOutputEnd = null;
    var progress;
    var forceFirstProgress;
    if (!skip && taskIns._reset) {
        progress = taskIns._reset(taskIns.context);
        if (progress && progress.progress) {
            forceFirstProgress = progress.forceFirstProgress;
            progress = progress.progress;
        } // To simplify no progress checking, array must has item.
        if ($6d93d3ff4f052552$var$isArray(progress) && !progress.length) progress = null;
    }
    taskIns._progress = progress;
    taskIns._modBy = taskIns._modDataCount = null;
    var downstream = taskIns._downstream;
    downstream && downstream.dirty();
    return forceFirstProgress;
}
/**
 * @return {boolean}
 */ $6d93d3ff4f052552$var$taskProto.unfinished = function() {
    return this._progress && this._dueIndex < this._dueEnd;
};
/**
 * @param {Object} downTask The downstream task.
 * @return {Object} The downstream task.
 */ $6d93d3ff4f052552$var$taskProto.pipe = function(downTask) {
    // If already downstream, do not dirty downTask.
    if (this._downstream !== downTask || this._dirty) {
        this._downstream = downTask;
        downTask._upstream = this;
        downTask.dirty();
    }
};
$6d93d3ff4f052552$var$taskProto.dispose = function() {
    if (this._disposed) return;
    this._upstream && (this._upstream._downstream = null);
    this._downstream && (this._downstream._upstream = null);
    this._dirty = false;
    this._disposed = true;
};
$6d93d3ff4f052552$var$taskProto.getUpstream = function() {
    return this._upstream;
};
$6d93d3ff4f052552$var$taskProto.getDownstream = function() {
    return this._downstream;
};
$6d93d3ff4f052552$var$taskProto.setOutputEnd = function(end) {
    // This only happend in dataTask, dataZoom, map, currently.
    // where dataZoom do not set end each time, but only set
    // when reset. So we should record the setted end, in case
    // that the stub of dataZoom perform again and earse the
    // setted end by upstream.
    this._outputDueEnd = this._settedOutputEnd = end;
}; ///////////////////////////////////////////////////////////
$6d93d3ff4f052552$export$f7292ab7796be73c = $6d93d3ff4f052552$var$createTask;


var $70847df98016d69d$var$createTask = $6d93d3ff4f052552$export$f7292ab7796be73c;

var $70847df98016d69d$var$prepareSource = $71e1a98f99449cca$export$6d45f5142dbcbf3;
var $70847df98016d69d$var$getSource = $71e1a98f99449cca$export$dd2b6e807fb37ba3;

var $70847df98016d69d$var$retrieveRawValue = $05c9939f6206d72a$export$cde9373da9aad801;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $70847df98016d69d$var$inner = $d559f43cb9041423$export$64df9f8d92ae083f();
var $70847df98016d69d$var$SeriesModel = $3b9c2389e45dfb7d$exports.extend({
    type: "series.__base__",
    /**
   * @readOnly
   */ seriesIndex: 0,
    // coodinateSystem will be injected in the echarts/CoordinateSystem
    coordinateSystem: null,
    /**
   * @type {Object}
   * @protected
   */ defaultOption: null,
    /**
   * legend visual provider to the legend component
   * @type {Object}
   */ // PENDING
    legendVisualProvider: null,
    /**
   * Access path of color for visual
   */ visualColorAccessPath: "itemStyle.color",
    /**
   * Access path of borderColor for visual
   */ visualBorderColorAccessPath: "itemStyle.borderColor",
    /**
   * Support merge layout params.
   * Only support 'box' now (left/right/top/bottom/width/height).
   * @type {string|Object} Object can be {ignoreSize: true}
   * @readOnly
   */ layoutMode: null,
    init: function(option, parentModel, ecModel, extraOpt) {
        /**
     * @type {number}
     * @readOnly
     */ this.seriesIndex = this.componentIndex;
        this.dataTask = $70847df98016d69d$var$createTask({
            count: $70847df98016d69d$var$dataTaskCount,
            reset: $70847df98016d69d$var$dataTaskReset
        });
        this.dataTask.context = {
            model: this
        };
        this.mergeDefaultAndTheme(option, ecModel);
        $70847df98016d69d$var$prepareSource(this);
        var data = this.getInitialData(option, ecModel);
        $70847df98016d69d$var$wrapData(data, this);
        this.dataTask.context.data = data;
        /**
     * @type {module:echarts/data/List|module:echarts/data/Tree|module:echarts/data/Graph}
     * @private
     */ $70847df98016d69d$var$inner(this).dataBeforeProcessed = data; // If we reverse the order (make data firstly, and then make
        // dataBeforeProcessed by cloneShallow), cloneShallow will
        // cause data.graph.data !== data when using
        // module:echarts/data/Graph or module:echarts/data/Tree.
        // See module:echarts/data/helper/linkList
        // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
        // init or merge stage, because the data can be restored. So we do not `restoreData`
        // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
        // Call `seriesModel.getRawData()` instead.
        // this.restoreData();
        $70847df98016d69d$var$autoSeriesName(this);
    },
    /**
   * Util for merge default and theme to option
   * @param  {Object} option
   * @param  {module:echarts/model/Global} ecModel
   */ mergeDefaultAndTheme: function(option, ecModel) {
        var layoutMode = this.layoutMode;
        var inputPositionParams = layoutMode ? $70847df98016d69d$var$getLayoutParams(option) : {}; // Backward compat: using subType on theme.
        // But if name duplicate between series subType
        // (for example: parallel) add component mainType,
        // add suffix 'Series'.
        var themeSubType = this.subType;
        if ($3b9c2389e45dfb7d$exports.hasClass(themeSubType)) themeSubType += "Series";
        $ec279652dd95c27b$export$4950aa0f605343fb(option, ecModel.getTheme().get(this.subType));
        $ec279652dd95c27b$export$4950aa0f605343fb(option, this.getDefaultOption()); // Default label emphasis `show`
        $d559f43cb9041423$export$abdcc6a26372f94b(option, "label", [
            "show"
        ]);
        this.fillDataTextStyle(option.data);
        if (layoutMode) $70847df98016d69d$var$mergeLayoutParam(option, inputPositionParams, layoutMode);
    },
    mergeOption: function(newSeriesOption, ecModel) {
        // this.settingTask.dirty();
        newSeriesOption = $ec279652dd95c27b$export$4950aa0f605343fb(this.option, newSeriesOption, true);
        this.fillDataTextStyle(newSeriesOption.data);
        var layoutMode = this.layoutMode;
        if (layoutMode) $70847df98016d69d$var$mergeLayoutParam(this.option, newSeriesOption, layoutMode);
        $70847df98016d69d$var$prepareSource(this);
        var data = this.getInitialData(newSeriesOption, ecModel);
        $70847df98016d69d$var$wrapData(data, this);
        this.dataTask.dirty();
        this.dataTask.context.data = data;
        $70847df98016d69d$var$inner(this).dataBeforeProcessed = data;
        $70847df98016d69d$var$autoSeriesName(this);
    },
    fillDataTextStyle: function(data) {
        // Default data label emphasis `show`
        // FIXME Tree structure data ?
        // FIXME Performance ?
        if (data && !$ec279652dd95c27b$export$b119cc7e1840e59c(data)) {
            var props = [
                "show"
            ];
            for(var i = 0; i < data.length; i++)if (data[i] && data[i].label) $d559f43cb9041423$export$abdcc6a26372f94b(data[i], "label", props);
        }
    },
    /**
   * Init a data structure from data related option in series
   * Must be overwritten
   */ getInitialData: function() {},
    /**
   * Append data to list
   * @param {Object} params
   * @param {Array|TypedArray} params.data
   */ appendData: function(params) {
        // FIXME ???
        // (1) If data from dataset, forbidden append.
        // (2) support append data of dataset.
        var data = this.getRawData();
        data.appendData(params.data);
    },
    /**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   * @param {string} [dataType]
   * @return {module:echarts/data/List}
   */ getData: function(dataType) {
        var task = $70847df98016d69d$var$getCurrentTask(this);
        if (task) {
            var data = task.context.data;
            return dataType == null ? data : data.getLinkedData(dataType);
        } else // When series is not alive (that may happen when click toolbox
        // restore or setOption with not merge mode), series data may
        // be still need to judge animation or something when graphic
        // elements want to know whether fade out.
        return $70847df98016d69d$var$inner(this).data;
    },
    /**
   * @param {module:echarts/data/List} data
   */ setData: function(data) {
        var task = $70847df98016d69d$var$getCurrentTask(this);
        if (task) {
            var context = task.context; // Consider case: filter, data sample.
            if (context.data !== data && task.modifyOutputEnd) task.setOutputEnd(data.count());
            context.outputData = data; // Caution: setData should update context.data,
            // Because getData may be called multiply in a
            // single stage and expect to get the data just
            // set. (For example, AxisProxy, x y both call
            // getData and setDate sequentially).
            // So the context.data should be fetched from
            // upstream each time when a stage starts to be
            // performed.
            if (task !== this.dataTask) context.data = data;
        }
        $70847df98016d69d$var$inner(this).data = data;
    },
    /**
   * @see {module:echarts/data/helper/sourceHelper#getSource}
   * @return {module:echarts/data/Source} source
   */ getSource: function() {
        return $70847df98016d69d$var$getSource(this);
    },
    /**
   * Get data before processed
   * @return {module:echarts/data/List}
   */ getRawData: function() {
        return $70847df98016d69d$var$inner(this).dataBeforeProcessed;
    },
    /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overrided for some chart.
   * @return {type} description
   */ getBaseAxis: function() {
        var coordSys = this.coordinateSystem;
        return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
    },
    // FIXME
    /**
   * Default tooltip formatter
   *
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {number} [dataType]
   * @param {string} [renderMode='html'] valid values: 'html' and 'richText'.
   *                                     'html' is used for rendering tooltip in extra DOM form, and the result
   *                                     string is used as DOM HTML content.
   *                                     'richText' is used for rendering tooltip in rich text form, for those where
   *                                     DOM operation is not supported.
   * @return {Object} formatted tooltip with `html` and `markers`
   */ formatTooltip: function(dataIndex, multipleSeries, dataType, renderMode) {
        var series = this;
        renderMode = renderMode || "html";
        var newLine = renderMode === "html" ? "<br/>" : "\n";
        var isRichText = renderMode === "richText";
        var markers = {};
        var markerId = 0;
        function formatArrayValue(value) {
            // ??? TODO refactor these logic.
            // check: category-no-encode-has-axis-data in dataset.html
            var vertially = $ec279652dd95c27b$export$533b26079ad0b4b(value, function(vertially, val, idx) {
                var dimItem = data.getDimensionInfo(idx);
                return vertially |= dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
            }, 0);
            var result = [];
            tooltipDims.length ? $ec279652dd95c27b$export$79b2f7037acddd43(tooltipDims, function(dim) {
                setEachItem($70847df98016d69d$var$retrieveRawValue(data, dataIndex, dim), dim);
            }) // By default, all dims is used on tooltip.
             : $ec279652dd95c27b$export$79b2f7037acddd43(value, setEachItem);
            function setEachItem(val, dim) {
                var dimInfo = data.getDimensionInfo(dim); // If `dimInfo.tooltip` is not set, show tooltip.
                if (!dimInfo || dimInfo.otherDims.tooltip === false) return;
                var dimType = dimInfo.type;
                var markName = "sub" + series.seriesIndex + "at" + markerId;
                var dimHead = $70847df98016d69d$var$getTooltipMarker({
                    color: color,
                    type: "subItem",
                    renderMode: renderMode,
                    markerId: markName
                });
                var dimHeadStr = typeof dimHead === "string" ? dimHead : dimHead.content;
                var valStr = (vertially ? dimHeadStr + $70847df98016d69d$var$encodeHTML(dimInfo.displayName || "-") + ": " : "") + // FIXME should not format time for raw data?
                $70847df98016d69d$var$encodeHTML(dimType === "ordinal" ? val + "" : dimType === "time" ? multipleSeries ? "" : $70847df98016d69d$var$formatTime("yyyy/MM/dd hh:mm:ss", val) : $70847df98016d69d$var$addCommas(val));
                valStr && result.push(valStr);
                if (isRichText) {
                    markers[markName] = color;
                    ++markerId;
                }
            }
            var newLine = vertially ? isRichText ? "\n" : "<br/>" : "";
            var content = newLine + result.join(newLine || ", ");
            return {
                renderMode: renderMode,
                content: content,
                style: markers
            };
        }
        function formatSingleValue(val) {
            // return encodeHTML(addCommas(val));
            return {
                renderMode: renderMode,
                content: $70847df98016d69d$var$encodeHTML($70847df98016d69d$var$addCommas(val)),
                style: markers
            };
        }
        var data = this.getData();
        var tooltipDims = data.mapDimension("defaultedTooltip", true);
        var tooltipDimLen = tooltipDims.length;
        var value = this.getRawValue(dataIndex);
        var isValueArr = $ec279652dd95c27b$export$43bee75e5e14138e(value);
        var color = data.getItemVisual(dataIndex, "color");
        if ($ec279652dd95c27b$export$a6cdc56e425d0d0a(color) && color.colorStops) color = (color.colorStops[0] || {}).color;
        color = color || "transparent"; // Complicated rule for pretty tooltip.
        var formattedValue = tooltipDimLen > 1 || isValueArr && !tooltipDimLen ? formatArrayValue(value) : tooltipDimLen ? formatSingleValue($70847df98016d69d$var$retrieveRawValue(data, dataIndex, tooltipDims[0])) : formatSingleValue(isValueArr ? value[0] : value);
        var content = formattedValue.content;
        var markName = series.seriesIndex + "at" + markerId;
        var colorEl = $70847df98016d69d$var$getTooltipMarker({
            color: color,
            type: "item",
            renderMode: renderMode,
            markerId: markName
        });
        markers[markName] = color;
        ++markerId;
        var name = data.getName(dataIndex);
        var seriesName = this.name;
        if (!$d559f43cb9041423$export$beae19a2652b3368(this)) seriesName = "";
        seriesName = seriesName ? $70847df98016d69d$var$encodeHTML(seriesName) + (!multipleSeries ? newLine : ": ") : "";
        var colorStr = typeof colorEl === "string" ? colorEl : colorEl.content;
        var html = !multipleSeries ? seriesName + colorStr + (name ? $70847df98016d69d$var$encodeHTML(name) + ": " + content : content) : colorStr + seriesName + content;
        return {
            html: html,
            markers: markers
        };
    },
    /**
   * @return {boolean}
   */ isAnimationEnabled: function() {
        if ($27ac1413ecc67076$exports.node) return false;
        var animationEnabled = this.getShallow("animation");
        if (animationEnabled) {
            if (this.getData().count() > this.getShallow("animationThreshold")) animationEnabled = false;
        }
        return animationEnabled;
    },
    restoreData: function() {
        this.dataTask.dirty();
    },
    getColorFromPalette: function(name, scope, requestColorNum) {
        var ecModel = this.ecModel; // PENDING
        var color = $5de0a04ca2e71297$exports.getColorFromPalette.call(this, name, scope, requestColorNum);
        if (!color) color = ecModel.getColorFromPalette(name, scope, requestColorNum);
        return color;
    },
    /**
   * Use `data.mapDimension(coordDim, true)` instead.
   * @deprecated
   */ coordDimToDataDim: function(coordDim) {
        return this.getRawData().mapDimension(coordDim, true);
    },
    /**
   * Get progressive rendering count each step
   * @return {number}
   */ getProgressive: function() {
        return this.get("progressive");
    },
    /**
   * Get progressive rendering count each step
   * @return {number}
   */ getProgressiveThreshold: function() {
        return this.get("progressiveThreshold");
    },
    /**
   * Get data indices for show tooltip content. See tooltip.
   * @abstract
   * @param {Array.<string>|string} dim
   * @param {Array.<number>} value
   * @param {module:echarts/coord/single/SingleAxis} baseAxis
   * @return {Object} {dataIndices, nestestValue}.
   */ getAxisTooltipData: null,
    /**
   * See tooltip.
   * @abstract
   * @param {number} dataIndex
   * @return {Array.<number>} Point of tooltip. null/undefined can be returned.
   */ getTooltipPosition: null,
    /**
   * @see {module:echarts/stream/Scheduler}
   */ pipeTask: null,
    /**
   * Convinient for override in extended class.
   * @protected
   * @type {Function}
   */ preventIncremental: null,
    /**
   * @public
   * @readOnly
   * @type {Object}
   */ pipelineContext: null
});
$ec279652dd95c27b$export$e36fc9d62a853069($70847df98016d69d$var$SeriesModel, $47a08a90150906d7$exports);
$ec279652dd95c27b$export$e36fc9d62a853069($70847df98016d69d$var$SeriesModel, $5de0a04ca2e71297$exports);
/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */ function $70847df98016d69d$var$autoSeriesName(seriesModel) {
    // User specified name has higher priority, otherwise it may cause
    // series can not be queried unexpectedly.
    var name = seriesModel.name;
    if (!$d559f43cb9041423$export$beae19a2652b3368(seriesModel)) seriesModel.name = $70847df98016d69d$var$getSeriesAutoName(seriesModel) || name;
}
function $70847df98016d69d$var$getSeriesAutoName(seriesModel) {
    var data = seriesModel.getRawData();
    var dataDims = data.mapDimension("seriesName", true);
    var nameArr = [];
    $ec279652dd95c27b$export$79b2f7037acddd43(dataDims, function(dataDim) {
        var dimInfo = data.getDimensionInfo(dataDim);
        dimInfo.displayName && nameArr.push(dimInfo.displayName);
    });
    return nameArr.join(" ");
}
function $70847df98016d69d$var$dataTaskCount(context) {
    return context.model.getRawData().count();
}
function $70847df98016d69d$var$dataTaskReset(context) {
    var seriesModel = context.model;
    seriesModel.setData(seriesModel.getRawData().cloneShallow());
    return $70847df98016d69d$var$dataTaskProgress;
}
function $70847df98016d69d$var$dataTaskProgress(param, context) {
    // Avoid repead cloneShallow when data just created in reset.
    if (context.outputData && param.end > context.outputData.count()) context.model.getRawData().cloneShallow(context.outputData);
} // TODO refactor
function $70847df98016d69d$var$wrapData(data, seriesModel) {
    $ec279652dd95c27b$export$79b2f7037acddd43(data.CHANGABLE_METHODS, function(methodName) {
        data.wrapMethod(methodName, $ec279652dd95c27b$export$c3095a23b368d1f2($70847df98016d69d$var$onDataSelfChange, seriesModel));
    });
}
function $70847df98016d69d$var$onDataSelfChange(seriesModel) {
    var task = $70847df98016d69d$var$getCurrentTask(seriesModel);
    if (task) // Consider case: filter, selectRange
    task.setOutputEnd(this.count());
}
function $70847df98016d69d$var$getCurrentTask(seriesModel) {
    var scheduler = (seriesModel.ecModel || {}).scheduler;
    var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
    if (pipeline) {
        // When pipline finished, the currrentTask keep the last
        // task (renderTask).
        var task = pipeline.currentTask;
        if (task) {
            var agentStubMap = task.agentStubMap;
            if (agentStubMap) task = agentStubMap.get(seriesModel.uid);
        }
        return task;
    }
}
var $70847df98016d69d$var$_default = $70847df98016d69d$var$SeriesModel;
$70847df98016d69d$exports = $70847df98016d69d$var$_default;


var $9c7fc7c628500365$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $9c7fc7c628500365$var$Component = function() {
    /**
   * @type {module:zrender/container/Group}
   * @readOnly
   */ this.group = new $48aa8d5160ffcc64$exports();
    /**
   * @type {string}
   * @readOnly
   */ this.uid = $a39499a9dbffdb7d$export$6d2b3473b0986646("viewComponent");
};
$9c7fc7c628500365$var$Component.prototype = {
    constructor: $9c7fc7c628500365$var$Component,
    init: function(ecModel, api) {},
    render: function(componentModel, ecModel, api, payload) {},
    dispose: function() {},
    /**
   * @param {string} eventType
   * @param {Object} query
   * @param {module:zrender/Element} targetEl
   * @param {Object} packedEvent
   * @return {boolen} Pass only when return `true`.
   */ filterForExposedEvent: null
};
var $9c7fc7c628500365$var$componentProto = $9c7fc7c628500365$var$Component.prototype;
$9c7fc7c628500365$var$componentProto.updateView = $9c7fc7c628500365$var$componentProto.updateLayout = $9c7fc7c628500365$var$componentProto.updateVisual = function(seriesModel, ecModel, api, payload) {}; // Enable Component.extend.
$c125ba1250423743$export$cd4c3a4dca301c70($9c7fc7c628500365$var$Component); // Enable capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
$c125ba1250423743$export$241315e45585454d($9c7fc7c628500365$var$Component, {
    registerWhenExtend: true
});
var $9c7fc7c628500365$var$_default = $9c7fc7c628500365$var$Component;
$9c7fc7c628500365$exports = $9c7fc7c628500365$var$_default;


var $6448f0aa5ca2bdaa$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $6448f0aa5ca2bdaa$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;






var $6448f0aa5ca2bdaa$var$createTask = $6d93d3ff4f052552$export$f7292ab7796be73c;
var $a77c5f604e87a748$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $a77c5f604e87a748$var$makeInner = $d559f43cb9041423$export$64df9f8d92ae083f;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @return {string} If large mode changed, return string 'reset';
 */ function $a77c5f604e87a748$var$_default() {
    var inner = $a77c5f604e87a748$var$makeInner();
    return function(seriesModel) {
        var fields = inner(seriesModel);
        var pipelineContext = seriesModel.pipelineContext;
        var originalLarge = fields.large;
        var originalProgressive = fields.progressiveRender; // FIXME: if the planner works on a filtered series, `pipelineContext` does not
        // exists. See #11611 . Probably we need to modify this structure, see the comment
        // on `performRawSeries` in `Schedular.js`.
        var large = fields.large = pipelineContext && pipelineContext.large;
        var progressive = fields.progressiveRender = pipelineContext && pipelineContext.progressiveRender;
        return !!(originalLarge ^ large || originalProgressive ^ progressive) && "reset";
    };
}
$a77c5f604e87a748$exports = $a77c5f604e87a748$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $6448f0aa5ca2bdaa$var$inner = $d559f43cb9041423$export$64df9f8d92ae083f();
var $6448f0aa5ca2bdaa$var$renderPlanner = $a77c5f604e87a748$exports();
function $6448f0aa5ca2bdaa$var$Chart() {
    /**
   * @type {module:zrender/container/Group}
   * @readOnly
   */ this.group = new $48aa8d5160ffcc64$exports();
    /**
   * @type {string}
   * @readOnly
   */ this.uid = $a39499a9dbffdb7d$export$6d2b3473b0986646("viewChart");
    this.renderTask = $6448f0aa5ca2bdaa$var$createTask({
        plan: $6448f0aa5ca2bdaa$var$renderTaskPlan,
        reset: $6448f0aa5ca2bdaa$var$renderTaskReset
    });
    this.renderTask.context = {
        view: this
    };
}
$6448f0aa5ca2bdaa$var$Chart.prototype = {
    type: "chart",
    /**
   * Init the chart.
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */ init: function(ecModel, api) {},
    /**
   * Render the chart.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */ render: function(seriesModel, ecModel, api, payload) {},
    /**
   * Highlight series or specified data item.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */ highlight: function(seriesModel, ecModel, api, payload) {
        $6448f0aa5ca2bdaa$var$toggleHighlight(seriesModel.getData(), payload, "emphasis");
    },
    /**
   * Downplay series or specified data item.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */ downplay: function(seriesModel, ecModel, api, payload) {
        $6448f0aa5ca2bdaa$var$toggleHighlight(seriesModel.getData(), payload, "normal");
    },
    /**
   * Remove self.
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */ remove: function(ecModel, api) {
        this.group.removeAll();
    },
    /**
   * Dispose self.
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */ dispose: function() {},
    /**
   * Rendering preparation in progressive mode.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */ incrementalPrepareRender: null,
    /**
   * Render in progressive mode.
   * @param  {Object} params See taskParams in `stream/task.js`
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */ incrementalRender: null,
    /**
   * Update transform directly.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   * @return {Object} {update: true}
   */ updateTransform: null,
    /**
   * The view contains the given point.
   * @interface
   * @param {Array.<number>} point
   * @return {boolean}
   */ // containPoint: function () {}
    /**
   * @param {string} eventType
   * @param {Object} query
   * @param {module:zrender/Element} targetEl
   * @param {Object} packedEvent
   * @return {boolen} Pass only when return `true`.
   */ filterForExposedEvent: null
};
var $6448f0aa5ca2bdaa$var$chartProto = $6448f0aa5ca2bdaa$var$Chart.prototype;
$6448f0aa5ca2bdaa$var$chartProto.updateView = $6448f0aa5ca2bdaa$var$chartProto.updateLayout = $6448f0aa5ca2bdaa$var$chartProto.updateVisual = function(seriesModel, ecModel, api, payload) {
    this.render(seriesModel, ecModel, api, payload);
};
/**
 * Set state of single element
 * @param {module:zrender/Element} el
 * @param {string} state 'normal'|'emphasis'
 * @param {number} highlightDigit
 */ function $6448f0aa5ca2bdaa$var$elSetState(el, state, highlightDigit) {
    if (el) {
        el.trigger(state, highlightDigit);
        if (el.isGroup // Simple optimize.
         && !$4b57d6b582d579b7$export$77d1445f699c58b5(el)) for(var i = 0, len = el.childCount(); i < len; i++)$6448f0aa5ca2bdaa$var$elSetState(el.childAt(i), state, highlightDigit);
    }
}
/**
 * @param {module:echarts/data/List} data
 * @param {Object} payload
 * @param {string} state 'normal'|'emphasis'
 */ function $6448f0aa5ca2bdaa$var$toggleHighlight(data, payload, state) {
    var dataIndex = $d559f43cb9041423$export$42b26cae8b8d10(data, payload);
    var highlightDigit = payload && payload.highlightKey != null ? $4b57d6b582d579b7$export$824af40eb714530d(payload.highlightKey) : null;
    if (dataIndex != null) $6448f0aa5ca2bdaa$var$each($d559f43cb9041423$export$4f07b212a02c8051(dataIndex), function(dataIdx) {
        $6448f0aa5ca2bdaa$var$elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
    });
    else data.eachItemGraphicEl(function(el) {
        $6448f0aa5ca2bdaa$var$elSetState(el, state, highlightDigit);
    });
} // Enable Chart.extend.
$c125ba1250423743$export$cd4c3a4dca301c70($6448f0aa5ca2bdaa$var$Chart, [
    "dispose"
]); // Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
$c125ba1250423743$export$241315e45585454d($6448f0aa5ca2bdaa$var$Chart, {
    registerWhenExtend: true
});
$6448f0aa5ca2bdaa$var$Chart.markUpdateMethod = function(payload, methodName) {
    $6448f0aa5ca2bdaa$var$inner(payload).updateMethod = methodName;
};
function $6448f0aa5ca2bdaa$var$renderTaskPlan(context) {
    return $6448f0aa5ca2bdaa$var$renderPlanner(context.model);
}
function $6448f0aa5ca2bdaa$var$renderTaskReset(context) {
    var seriesModel = context.model;
    var ecModel = context.ecModel;
    var api = context.api;
    var payload = context.payload; // ???! remove updateView updateVisual
    var progressiveRender = seriesModel.pipelineContext.progressiveRender;
    var view = context.view;
    var updateMethod = payload && $6448f0aa5ca2bdaa$var$inner(payload).updateMethod;
    var methodName = progressiveRender ? "incrementalPrepareRender" : updateMethod && view[updateMethod] ? updateMethod // `appendData` is also supported when data amount
     : "render";
    if (methodName !== "render") view[methodName](seriesModel, ecModel, api, payload);
    return $6448f0aa5ca2bdaa$var$progressMethodMap[methodName];
}
var $6448f0aa5ca2bdaa$var$progressMethodMap = {
    incrementalPrepareRender: {
        progress: function(params, context) {
            context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
        }
    },
    render: {
        // Put view.render in `progress` to support appendData. But in this case
        // view.render should not be called in reset, otherwise it will be called
        // twise. Use `forceFirstProgress` to make sure that view.render is called
        // in any cases.
        forceFirstProgress: true,
        progress: function(params, context) {
            context.view.render(context.model, context.ecModel, context.api, context.payload);
        }
    }
};
var $6448f0aa5ca2bdaa$var$_default = $6448f0aa5ca2bdaa$var$Chart;
$6448f0aa5ca2bdaa$exports = $6448f0aa5ca2bdaa$var$_default;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $a181ac84b0d97d16$export$de363e709c412c8a;
var $a181ac84b0d97d16$export$958e3e1a02eac4b6;
var $a181ac84b0d97d16$export$42ffd38884aecdac;
var $a181ac84b0d97d16$var$ORIGIN_METHOD = "\x00__throttleOriginMethod";
var $a181ac84b0d97d16$var$RATE = "\x00__throttleRate";
var $a181ac84b0d97d16$var$THROTTLE_TYPE = "\x00__throttleType";
/**
 * @public
 * @param {(Function)} fn
 * @param {number} [delay=0] Unit: ms.
 * @param {boolean} [debounce=false]
 *        true: If call interval less than `delay`, only the last call works.
 *        false: If call interval less than `delay, call works on fixed rate.
 * @return {(Function)} throttled fn.
 */ function $a181ac84b0d97d16$var$throttle(fn, delay, debounce) {
    var currCall;
    var lastCall = 0;
    var lastExec = 0;
    var timer = null;
    var diff;
    var scope;
    var args;
    var debounceNextCall;
    delay = delay || 0;
    function exec() {
        lastExec = new Date().getTime();
        timer = null;
        fn.apply(scope, args || []);
    }
    var cb = function() {
        currCall = new Date().getTime();
        scope = this;
        args = arguments;
        var thisDelay = debounceNextCall || delay;
        var thisDebounce = debounceNextCall || debounce;
        debounceNextCall = null;
        diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
        clearTimeout(timer); // Here we should make sure that: the `exec` SHOULD NOT be called later
        // than a new call of `cb`, that is, preserving the command order. Consider
        // calculating "scale rate" when roaming as an example. When a call of `cb`
        // happens, either the `exec` is called dierectly, or the call is delayed.
        // But the delayed call should never be later than next call of `cb`. Under
        // this assurance, we can simply update view state each time `dispatchAction`
        // triggered by user roaming, but not need to add extra code to avoid the
        // state being "rolled-back".
        if (thisDebounce) timer = setTimeout(exec, thisDelay);
        else if (diff >= 0) exec();
        else timer = setTimeout(exec, -diff);
        lastCall = currCall;
    };
    /**
   * Clear throttle.
   * @public
   */ cb.clear = function() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };
    /**
   * Enable debounce once.
   */ cb.debounceNextCall = function(debounceDelay) {
        debounceNextCall = debounceDelay;
    };
    return cb;
}
/**
 * Create throttle method or update throttle rate.
 *
 * @example
 * ComponentView.prototype.render = function () {
 *     ...
 *     throttle.createOrUpdate(
 *         this,
 *         '_dispatchAction',
 *         this.model.get('throttle'),
 *         'fixRate'
 *     );
 * };
 * ComponentView.prototype.remove = function () {
 *     throttle.clear(this, '_dispatchAction');
 * };
 * ComponentView.prototype.dispose = function () {
 *     throttle.clear(this, '_dispatchAction');
 * };
 *
 * @public
 * @param {Object} obj
 * @param {string} fnAttr
 * @param {number} [rate]
 * @param {string} [throttleType='fixRate'] 'fixRate' or 'debounce'
 * @return {Function} throttled function.
 */ function $a181ac84b0d97d16$var$createOrUpdate(obj, fnAttr, rate, throttleType) {
    var fn = obj[fnAttr];
    if (!fn) return;
    var originFn = fn[$a181ac84b0d97d16$var$ORIGIN_METHOD] || fn;
    var lastThrottleType = fn[$a181ac84b0d97d16$var$THROTTLE_TYPE];
    var lastRate = fn[$a181ac84b0d97d16$var$RATE];
    if (lastRate !== rate || lastThrottleType !== throttleType) {
        if (rate == null || !throttleType) return obj[fnAttr] = originFn;
        fn = obj[fnAttr] = $a181ac84b0d97d16$var$throttle(originFn, rate, throttleType === "debounce");
        fn[$a181ac84b0d97d16$var$ORIGIN_METHOD] = originFn;
        fn[$a181ac84b0d97d16$var$THROTTLE_TYPE] = throttleType;
        fn[$a181ac84b0d97d16$var$RATE] = rate;
    }
    return fn;
}
/**
 * Clear throttle. Example see throttle.createOrUpdate.
 *
 * @public
 * @param {Object} obj
 * @param {string} fnAttr
 */ function $a181ac84b0d97d16$var$clear(obj, fnAttr) {
    var fn = obj[fnAttr];
    if (fn && fn[$a181ac84b0d97d16$var$ORIGIN_METHOD]) obj[fnAttr] = fn[$a181ac84b0d97d16$var$ORIGIN_METHOD];
}
$a181ac84b0d97d16$export$de363e709c412c8a = $a181ac84b0d97d16$var$throttle;
$a181ac84b0d97d16$export$958e3e1a02eac4b6 = $a181ac84b0d97d16$var$createOrUpdate;
$a181ac84b0d97d16$export$42ffd38884aecdac = $a181ac84b0d97d16$var$clear;


var $f406636b535430a7$var$throttle = $a181ac84b0d97d16$export$de363e709c412c8a;
var $dc90ac0b9dfd0eec$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $dc90ac0b9dfd0eec$var$isFunction = $ec279652dd95c27b$export$f6e2535fb5126e54;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $dc90ac0b9dfd0eec$var$_default = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        var colorAccessPath = (seriesModel.visualColorAccessPath || "itemStyle.color").split("."); // Set in itemStyle
        var color = seriesModel.get(colorAccessPath);
        var colorCallback = $dc90ac0b9dfd0eec$var$isFunction(color) && !(color instanceof $256a1ff3f5381b07$exports) ? color : null; // Default color
        if (!color || colorCallback) color = seriesModel.getColorFromPalette(seriesModel.name, null, ecModel.getSeriesCount());
        data.setVisual("color", color);
        var borderColorAccessPath = (seriesModel.visualBorderColorAccessPath || "itemStyle.borderColor").split(".");
        var borderColor = seriesModel.get(borderColorAccessPath);
        data.setVisual("borderColor", borderColor); // Only visible series has each data be visual encoded
        if (!ecModel.isSeriesFiltered(seriesModel)) {
            if (colorCallback) data.each(function(idx) {
                data.setItemVisual(idx, "color", colorCallback(seriesModel.getDataParams(idx)));
            });
             // itemStyle in each data item
            var dataEach = function(data, idx) {
                var itemModel = data.getItemModel(idx);
                var color = itemModel.get(colorAccessPath, true);
                var borderColor = itemModel.get(borderColorAccessPath, true);
                if (color != null) data.setItemVisual(idx, "color", color);
                if (borderColor != null) data.setItemVisual(idx, "borderColor", borderColor);
            };
            return {
                dataEach: data.hasItemOption ? dataEach : null
            };
        }
    }
};
$dc90ac0b9dfd0eec$exports = $dc90ac0b9dfd0eec$var$_default;


var $1fcc208ab978e042$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $136ae13721f5e257$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Language: (Simplified) Chinese.
 */ var $136ae13721f5e257$var$_default = {
    legend: {
        selector: {
            all: "\u5168\u9009",
            inverse: "\u53CD\u9009"
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: "\u77E9\u5F62\u9009\u62E9",
                polygon: "\u5708\u9009",
                lineX: "\u6A2A\u5411\u9009\u62E9",
                lineY: "\u7EB5\u5411\u9009\u62E9",
                keep: "\u4FDD\u6301\u9009\u62E9",
                clear: "\u6E05\u9664\u9009\u62E9"
            }
        },
        dataView: {
            title: "\u6570\u636E\u89C6\u56FE",
            lang: [
                "\u6570\u636E\u89C6\u56FE",
                "\u5173\u95ED",
                "\u5237\u65B0"
            ]
        },
        dataZoom: {
            title: {
                zoom: "\u533A\u57DF\u7F29\u653E",
                back: "\u533A\u57DF\u7F29\u653E\u8FD8\u539F"
            }
        },
        magicType: {
            title: {
                line: "\u5207\u6362\u4E3A\u6298\u7EBF\u56FE",
                bar: "\u5207\u6362\u4E3A\u67F1\u72B6\u56FE",
                stack: "\u5207\u6362\u4E3A\u5806\u53E0",
                tiled: "\u5207\u6362\u4E3A\u5E73\u94FA"
            }
        },
        restore: {
            title: "\u8FD8\u539F"
        },
        saveAsImage: {
            title: "\u4FDD\u5B58\u4E3A\u56FE\u7247",
            lang: [
                "\u53F3\u952E\u53E6\u5B58\u4E3A\u56FE\u7247"
            ]
        }
    },
    series: {
        typeNames: {
            pie: "\u997C\u56FE",
            bar: "\u67F1\u72B6\u56FE",
            line: "\u6298\u7EBF\u56FE",
            scatter: "\u6563\u70B9\u56FE",
            effectScatter: "\u6D9F\u6F2A\u6563\u70B9\u56FE",
            radar: "\u96F7\u8FBE\u56FE",
            tree: "\u6811\u56FE",
            treemap: "\u77E9\u5F62\u6811\u56FE",
            boxplot: "\u7BB1\u578B\u56FE",
            candlestick: "K\u7EBF\u56FE",
            k: "K\u7EBF\u56FE",
            heatmap: "\u70ED\u529B\u56FE",
            map: "\u5730\u56FE",
            parallel: "\u5E73\u884C\u5750\u6807\u56FE",
            lines: "\u7EBF\u56FE",
            graph: "\u5173\u7CFB\u56FE",
            sankey: "\u6851\u57FA\u56FE",
            funnel: "\u6F0F\u6597\u56FE",
            gauge: "\u4EEA\u8868\u76D8\u56FE",
            pictorialBar: "\u8C61\u5F62\u67F1\u56FE",
            themeRiver: "\u4E3B\u9898\u6CB3\u6D41\u56FE",
            sunburst: "\u65ED\u65E5\u56FE"
        }
    },
    aria: {
        general: {
            withTitle: "\u8FD9\u662F\u4E00\u4E2A\u5173\u4E8E\u201C{title}\u201D\u7684\u56FE\u8868\u3002",
            withoutTitle: "\u8FD9\u662F\u4E00\u4E2A\u56FE\u8868\uFF0C"
        },
        series: {
            single: {
                prefix: "",
                withName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\uFF0C\u8868\u793A{seriesName}\u3002",
                withoutName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\u3002"
            },
            multiple: {
                prefix: "\u5B83\u7531{seriesCount}\u4E2A\u56FE\u8868\u7CFB\u5217\u7EC4\u6210\u3002",
                withName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A\u8868\u793A{seriesName}\u7684{seriesType}\uFF0C",
                withoutName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A{seriesType}\uFF0C",
                separator: {
                    middle: "\uFF1B",
                    end: "\u3002"
                }
            }
        },
        data: {
            allData: "\u5176\u6570\u636E\u662F\u2014\u2014",
            partialData: "\u5176\u4E2D\uFF0C\u524D{displayCnt}\u9879\u662F\u2014\u2014",
            withName: "{name}\u7684\u6570\u636E\u662F{value}",
            withoutName: "{value}",
            separator: {
                middle: "\uFF0C",
                end: ""
            }
        }
    }
};
$136ae13721f5e257$exports = $136ae13721f5e257$var$_default;



var $1fcc208ab978e042$var$retrieveRawValue = $05c9939f6206d72a$export$cde9373da9aad801;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $1fcc208ab978e042$var$_default(dom, ecModel) {
    var ariaModel = ecModel.getModel("aria");
    if (!ariaModel.get("show")) return;
    else if (ariaModel.get("description")) {
        dom.setAttribute("aria-label", ariaModel.get("description"));
        return;
    }
    var seriesCnt = 0;
    ecModel.eachSeries(function(seriesModel, idx) {
        ++seriesCnt;
    }, this);
    var maxDataCnt = ariaModel.get("data.maxCount") || 10;
    var maxSeriesCnt = ariaModel.get("series.maxCount") || 10;
    var displaySeriesCnt = Math.min(seriesCnt, maxSeriesCnt);
    var ariaLabel;
    if (seriesCnt < 1) // No series, no aria label
    return;
    else {
        var title = getTitle();
        if (title) ariaLabel = replace(getConfig("general.withTitle"), {
            title: title
        });
        else ariaLabel = getConfig("general.withoutTitle");
        var seriesLabels = [];
        var prefix = seriesCnt > 1 ? "series.multiple.prefix" : "series.single.prefix";
        ariaLabel += replace(getConfig(prefix), {
            seriesCount: seriesCnt
        });
        ecModel.eachSeries(function(seriesModel, idx) {
            if (idx < displaySeriesCnt) {
                var seriesLabel;
                var seriesName = seriesModel.get("name");
                var seriesTpl = "series." + (seriesCnt > 1 ? "multiple" : "single") + ".";
                seriesLabel = getConfig(seriesName ? seriesTpl + "withName" : seriesTpl + "withoutName");
                seriesLabel = replace(seriesLabel, {
                    seriesId: seriesModel.seriesIndex,
                    seriesName: seriesModel.get("name"),
                    seriesType: getSeriesTypeName(seriesModel.subType)
                });
                var data = seriesModel.getData();
                window.data = data;
                if (data.count() > maxDataCnt) // Show part of data
                seriesLabel += replace(getConfig("data.partialData"), {
                    displayCnt: maxDataCnt
                });
                else seriesLabel += getConfig("data.allData");
                var dataLabels = [];
                for(var i = 0; i < data.count(); i++)if (i < maxDataCnt) {
                    var name = data.getName(i);
                    var value = $1fcc208ab978e042$var$retrieveRawValue(data, i);
                    dataLabels.push(replace(name ? getConfig("data.withName") : getConfig("data.withoutName"), {
                        name: name,
                        value: value
                    }));
                }
                seriesLabel += dataLabels.join(getConfig("data.separator.middle")) + getConfig("data.separator.end");
                seriesLabels.push(seriesLabel);
            }
        });
        ariaLabel += seriesLabels.join(getConfig("series.multiple.separator.middle")) + getConfig("series.multiple.separator.end");
        dom.setAttribute("aria-label", ariaLabel);
    }
    function replace(str, keyValues) {
        if (typeof str !== "string") return str;
        var result = str;
        $ec279652dd95c27b$export$79b2f7037acddd43(keyValues, function(value, key) {
            result = result.replace(new RegExp("\\{\\s*" + key + "\\s*\\}", "g"), value);
        });
        return result;
    }
    function getConfig(path) {
        var userConfig = ariaModel.get(path);
        if (userConfig == null) {
            var pathArr = path.split(".");
            var result = $136ae13721f5e257$exports.aria;
            for(var i = 0; i < pathArr.length; ++i)result = result[pathArr[i]];
            return result;
        } else return userConfig;
    }
    function getTitle() {
        var title = ecModel.getModel("title").option;
        if (title && title.length) title = title[0];
        return title && title.text;
    }
    function getSeriesTypeName(type) {
        return $136ae13721f5e257$exports.series.typeNames[type] || "\u81EA\u5B9A\u4E49\u56FE";
    }
}
$1fcc208ab978e042$exports = $1fcc208ab978e042$var$_default;


var $ceb6a16d7f3e4c83$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $ceb6a16d7f3e4c83$var$PI = Math.PI;
/**
 * @param {module:echarts/ExtensionAPI} api
 * @param {Object} [opts]
 * @param {string} [opts.text]
 * @param {string} [opts.color]
 * @param {string} [opts.textColor]
 * @return {module:zrender/Element}
 */ function $ceb6a16d7f3e4c83$var$_default(api, opts) {
    opts = opts || {};
    $ec279652dd95c27b$export$ebe90cb607ad99e(opts, {
        text: "loading",
        textColor: "#000",
        fontSize: "12px",
        maskColor: "rgba(255, 255, 255, 0.8)",
        showSpinner: true,
        color: "#c23531",
        spinnerRadius: 10,
        lineWidth: 5,
        zlevel: 0
    });
    var group = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
    var mask = new $4b57d6b582d579b7$export$c79fc6492f3af13d({
        style: {
            fill: opts.maskColor
        },
        zlevel: opts.zlevel,
        z: 10000
    });
    group.add(mask);
    var font = opts.fontSize + " sans-serif";
    var labelRect = new $4b57d6b582d579b7$export$c79fc6492f3af13d({
        style: {
            fill: "none",
            text: opts.text,
            font: font,
            textPosition: "right",
            textDistance: 10,
            textFill: opts.textColor
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    group.add(labelRect);
    if (opts.showSpinner) {
        var arc = new $4b57d6b582d579b7$export$6ef80ffb606dd232({
            shape: {
                startAngle: -$ceb6a16d7f3e4c83$var$PI / 2,
                endAngle: -$ceb6a16d7f3e4c83$var$PI / 2 + 0.1,
                r: opts.spinnerRadius
            },
            style: {
                stroke: opts.color,
                lineCap: "round",
                lineWidth: opts.lineWidth
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        arc.animateShape(true).when(1000, {
            endAngle: $ceb6a16d7f3e4c83$var$PI * 3 / 2
        }).start("circularInOut");
        arc.animateShape(true).when(1000, {
            startAngle: $ceb6a16d7f3e4c83$var$PI * 3 / 2
        }).delay(300).start("circularInOut");
        group.add(arc);
    } // Inject resize
    group.resize = function() {
        var textWidth = $ebae9c4ebc22906c$export$3c49c185de0c2bfc(opts.text, font);
        var r = opts.showSpinner ? opts.spinnerRadius : 0; // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
        // textDistance needs to be calculated when both animation and text exist
        var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 // only show the text
         - (opts.showSpinner ? 0 : textWidth / 2);
        var cy = api.getHeight() / 2;
        opts.showSpinner && arc.setShape({
            cx: cx,
            cy: cy
        });
        labelRect.setShape({
            x: cx - r,
            y: cy - r,
            width: r * 2,
            height: r * 2
        });
        mask.setShape({
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        });
    };
    group.resize();
    return group;
}
$ceb6a16d7f3e4c83$exports = $ceb6a16d7f3e4c83$var$_default;


var $578727d567ffa2bc$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $578727d567ffa2bc$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $578727d567ffa2bc$var$map = $ec279652dd95c27b$export$871de8747c9eaa88;
var $578727d567ffa2bc$var$isFunction = $ec279652dd95c27b$export$f6e2535fb5126e54;
var $578727d567ffa2bc$var$createHashMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4;
var $578727d567ffa2bc$var$noop = $ec279652dd95c27b$export$8793edee2d425525;

var $578727d567ffa2bc$var$createTask = $6d93d3ff4f052552$export$f7292ab7796be73c;

var $578727d567ffa2bc$var$getUID = $a39499a9dbffdb7d$export$6d2b3473b0986646;



var $578727d567ffa2bc$var$normalizeToArray = $d559f43cb9041423$export$4f07b212a02c8051;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @module echarts/stream/Scheduler
 */ /**
 * @constructor
 */ function $578727d567ffa2bc$var$Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
    this.ecInstance = ecInstance;
    this.api = api;
    this.unfinished; // Fix current processors in case that in some rear cases that
    // processors might be registered after echarts instance created.
    // Register processors incrementally for a echarts instance is
    // not supported by this stream architecture.
    var dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
    var visualHandlers = this._visualHandlers = visualHandlers.slice();
    this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
    /**
   * @private
   * @type {
   *     [handlerUID: string]: {
   *         seriesTaskMap?: {
   *             [seriesUID: string]: Task
   *         },
   *         overallTask?: Task
   *     }
   * }
   */ this._stageTaskMap = $578727d567ffa2bc$var$createHashMap();
}
var $578727d567ffa2bc$var$proto = $578727d567ffa2bc$var$Scheduler.prototype;
/**
 * @param {module:echarts/model/Global} ecModel
 * @param {Object} payload
 */ $578727d567ffa2bc$var$proto.restoreData = function(ecModel, payload) {
    // TODO: Only restore needed series and components, but not all components.
    // Currently `restoreData` of all of the series and component will be called.
    // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
    // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
    // and some components like coordinate system, axes, dataZoom, visualMap only
    // need their target series refresh.
    // (1) If we are implementing this feature some day, we should consider these cases:
    // if a data processor depends on a component (e.g., dataZoomProcessor depends
    // on the settings of `dataZoom`), it should be re-performed if the component
    // is modified by `setOption`.
    // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
    // it should be re-performed when the result array of `getTargetSeries` changed.
    // We use `dependencies` to cover these issues.
    // (3) How to update target series when coordinate system related components modified.
    // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
    // and this case all of the tasks will be set as dirty.
    ecModel.restoreData(payload); // Theoretically an overall task not only depends on each of its target series, but also
    // depends on all of the series.
    // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
    // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
    // that the overall task is set as dirty and to be performed, otherwise it probably cause
    // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
    // probably cause state chaos (consider `dataZoomProcessor`).
    this._stageTaskMap.each(function(taskRecord) {
        var overallTask = taskRecord.overallTask;
        overallTask && overallTask.dirty();
    });
}; // If seriesModel provided, incremental threshold is check by series data.
$578727d567ffa2bc$var$proto.getPerformArgs = function(task, isBlock) {
    // For overall task
    if (!task.__pipeline) return;
    var pipeline = this._pipelineMap.get(task.__pipeline.id);
    var pCtx = pipeline.context;
    var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
    var step = incremental ? pipeline.step : null;
    var modDataCount = pCtx && pCtx.modDataCount;
    var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
    return {
        step: step,
        modBy: modBy,
        modDataCount: modDataCount
    };
};
$578727d567ffa2bc$var$proto.getPipeline = function(pipelineId) {
    return this._pipelineMap.get(pipelineId);
};
/**
 * Current, progressive rendering starts from visual and layout.
 * Always detect render mode in the same stage, avoiding that incorrect
 * detection caused by data filtering.
 * Caution:
 * `updateStreamModes` use `seriesModel.getData()`.
 */ $578727d567ffa2bc$var$proto.updateStreamModes = function(seriesModel, view) {
    var pipeline = this._pipelineMap.get(seriesModel.uid);
    var data = seriesModel.getData();
    var dataLen = data.count(); // `progressiveRender` means that can render progressively in each
    // animation frame. Note that some types of series do not provide
    // `view.incrementalPrepareRender` but support `chart.appendData`. We
    // use the term `incremental` but not `progressive` to describe the
    // case that `chart.appendData`.
    var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
    var large = seriesModel.get("large") && dataLen >= seriesModel.get("largeThreshold"); // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
    // see `test/candlestick-large3.html`
    var modDataCount = seriesModel.get("progressiveChunkMode") === "mod" ? dataLen : null;
    seriesModel.pipelineContext = pipeline.context = {
        progressiveRender: progressiveRender,
        modDataCount: modDataCount,
        large: large
    };
};
$578727d567ffa2bc$var$proto.restorePipelines = function(ecModel) {
    var scheduler = this;
    var pipelineMap = scheduler._pipelineMap = $578727d567ffa2bc$var$createHashMap();
    ecModel.eachSeries(function(seriesModel) {
        var progressive = seriesModel.getProgressive();
        var pipelineId = seriesModel.uid;
        pipelineMap.set(pipelineId, {
            id: pipelineId,
            head: null,
            tail: null,
            threshold: seriesModel.getProgressiveThreshold(),
            progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
            blockIndex: -1,
            step: Math.round(progressive || 700),
            count: 0
        });
        $578727d567ffa2bc$var$pipe(scheduler, seriesModel, seriesModel.dataTask);
    });
};
$578727d567ffa2bc$var$proto.prepareStageTasks = function() {
    var stageTaskMap = this._stageTaskMap;
    var ecModel = this.ecInstance.getModel();
    var api = this.api;
    $578727d567ffa2bc$var$each(this._allHandlers, function(handler) {
        var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, []);
        handler.reset && $578727d567ffa2bc$var$createSeriesStageTask(this, handler, record, ecModel, api);
        handler.overallReset && $578727d567ffa2bc$var$createOverallStageTask(this, handler, record, ecModel, api);
    }, this);
};
$578727d567ffa2bc$var$proto.prepareView = function(view, model, ecModel, api) {
    var renderTask = view.renderTask;
    var context = renderTask.context;
    context.model = model;
    context.ecModel = ecModel;
    context.api = api;
    renderTask.__block = !view.incrementalPrepareRender;
    $578727d567ffa2bc$var$pipe(this, model, renderTask);
};
$578727d567ffa2bc$var$proto.performDataProcessorTasks = function(ecModel, payload) {
    // If we do not use `block` here, it should be considered when to update modes.
    $578727d567ffa2bc$var$performStageTasks(this, this._dataProcessorHandlers, ecModel, payload, {
        block: true
    });
}; // opt
// opt.visualType: 'visual' or 'layout'
// opt.setDirty
$578727d567ffa2bc$var$proto.performVisualTasks = function(ecModel, payload, opt) {
    $578727d567ffa2bc$var$performStageTasks(this, this._visualHandlers, ecModel, payload, opt);
};
function $578727d567ffa2bc$var$performStageTasks(scheduler, stageHandlers, ecModel, payload, opt) {
    opt = opt || {};
    var unfinished;
    $578727d567ffa2bc$var$each(stageHandlers, function(stageHandler, idx) {
        if (opt.visualType && opt.visualType !== stageHandler.visualType) return;
        var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
        var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
        var overallTask = stageHandlerRecord.overallTask;
        if (overallTask) {
            var overallNeedDirty;
            var agentStubMap = overallTask.agentStubMap;
            agentStubMap.each(function(stub) {
                if (needSetDirty(opt, stub)) {
                    stub.dirty();
                    overallNeedDirty = true;
                }
            });
            overallNeedDirty && overallTask.dirty();
            $578727d567ffa2bc$var$updatePayload(overallTask, payload);
            var performArgs = scheduler.getPerformArgs(overallTask, opt.block); // Execute stubs firstly, which may set the overall task dirty,
            // then execute the overall task. And stub will call seriesModel.setData,
            // which ensures that in the overallTask seriesModel.getData() will not
            // return incorrect data.
            agentStubMap.each(function(stub) {
                stub.perform(performArgs);
            });
            unfinished |= overallTask.perform(performArgs);
        } else if (seriesTaskMap) seriesTaskMap.each(function(task, pipelineId) {
            if (needSetDirty(opt, task)) task.dirty();
            var performArgs = scheduler.getPerformArgs(task, opt.block); // FIXME
            // if intending to decalare `performRawSeries` in handlers, only
            // stream-independent (specifically, data item independent) operations can be
            // performed. Because is a series is filtered, most of the tasks will not
            // be performed. A stream-dependent operation probably cause wrong biz logic.
            // Perhaps we should not provide a separate callback for this case instead
            // of providing the config `performRawSeries`. The stream-dependent operaions
            // and stream-independent operations should better not be mixed.
            performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
            $578727d567ffa2bc$var$updatePayload(task, payload);
            unfinished |= task.perform(performArgs);
        });
    });
    function needSetDirty(opt, task) {
        return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
    }
    scheduler.unfinished |= unfinished;
}
$578727d567ffa2bc$var$proto.performSeriesTasks = function(ecModel) {
    var unfinished;
    ecModel.eachSeries(function(seriesModel) {
        // Progress to the end for dataInit and dataRestore.
        unfinished |= seriesModel.dataTask.perform();
    });
    this.unfinished |= unfinished;
};
$578727d567ffa2bc$var$proto.plan = function() {
    // Travel pipelines, check block.
    this._pipelineMap.each(function(pipeline) {
        var task = pipeline.tail;
        do {
            if (task.__block) {
                pipeline.blockIndex = task.__idxInPipeline;
                break;
            }
            task = task.getUpstream();
        }while (task);
    });
};
var $578727d567ffa2bc$var$updatePayload = $578727d567ffa2bc$var$proto.updatePayload = function(task, payload) {
    payload !== "remain" && (task.context.payload = payload);
};
function $578727d567ffa2bc$var$createSeriesStageTask(scheduler, stageHandler, stageHandlerRecord, ecModel, api) {
    var seriesTaskMap = stageHandlerRecord.seriesTaskMap || (stageHandlerRecord.seriesTaskMap = $578727d567ffa2bc$var$createHashMap());
    var seriesType = stageHandler.seriesType;
    var getTargetSeries = stageHandler.getTargetSeries; // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
    // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
    // it works but it may cause other irrelevant charts blocked.
    if (stageHandler.createOnAllSeries) ecModel.eachRawSeries(create);
    else if (seriesType) ecModel.eachRawSeriesByType(seriesType, create);
    else if (getTargetSeries) getTargetSeries(ecModel, api).each(create);
    function create(seriesModel) {
        var pipelineId = seriesModel.uid; // Init tasks for each seriesModel only once.
        // Reuse original task instance.
        var task = seriesTaskMap.get(pipelineId) || seriesTaskMap.set(pipelineId, $578727d567ffa2bc$var$createTask({
            plan: $578727d567ffa2bc$var$seriesTaskPlan,
            reset: $578727d567ffa2bc$var$seriesTaskReset,
            count: $578727d567ffa2bc$var$seriesTaskCount
        }));
        task.context = {
            model: seriesModel,
            ecModel: ecModel,
            api: api,
            useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
            plan: stageHandler.plan,
            reset: stageHandler.reset,
            scheduler: scheduler
        };
        $578727d567ffa2bc$var$pipe(scheduler, seriesModel, task);
    } // Clear unused series tasks.
    var pipelineMap = scheduler._pipelineMap;
    seriesTaskMap.each(function(task, pipelineId) {
        if (!pipelineMap.get(pipelineId)) {
            task.dispose();
            seriesTaskMap.removeKey(pipelineId);
        }
    });
}
function $578727d567ffa2bc$var$createOverallStageTask(scheduler, stageHandler, stageHandlerRecord, ecModel, api) {
    var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask // For overall task, the function only be called on reset stage.
     || $578727d567ffa2bc$var$createTask({
        reset: $578727d567ffa2bc$var$overallTaskReset
    });
    overallTask.context = {
        ecModel: ecModel,
        api: api,
        overallReset: stageHandler.overallReset,
        scheduler: scheduler
    }; // Reuse orignal stubs.
    var agentStubMap = overallTask.agentStubMap = overallTask.agentStubMap || $578727d567ffa2bc$var$createHashMap();
    var seriesType = stageHandler.seriesType;
    var getTargetSeries = stageHandler.getTargetSeries;
    var overallProgress = true;
    var modifyOutputEnd = stageHandler.modifyOutputEnd; // An overall task with seriesType detected or has `getTargetSeries`, we add
    // stub in each pipelines, it will set the overall task dirty when the pipeline
    // progress. Moreover, to avoid call the overall task each frame (too frequent),
    // we set the pipeline block.
    if (seriesType) ecModel.eachRawSeriesByType(seriesType, createStub);
    else if (getTargetSeries) getTargetSeries(ecModel, api).each(createStub);
    else {
        overallProgress = false;
        $578727d567ffa2bc$var$each(ecModel.getSeries(), createStub);
    }
    function createStub(seriesModel) {
        var pipelineId = seriesModel.uid;
        var stub = agentStubMap.get(pipelineId);
        if (!stub) {
            stub = agentStubMap.set(pipelineId, $578727d567ffa2bc$var$createTask({
                reset: $578727d567ffa2bc$var$stubReset,
                onDirty: $578727d567ffa2bc$var$stubOnDirty
            })); // When the result of `getTargetSeries` changed, the overallTask
            // should be set as dirty and re-performed.
            overallTask.dirty();
        }
        stub.context = {
            model: seriesModel,
            overallProgress: overallProgress,
            modifyOutputEnd: modifyOutputEnd
        };
        stub.agent = overallTask;
        stub.__block = overallProgress;
        $578727d567ffa2bc$var$pipe(scheduler, seriesModel, stub);
    } // Clear unused stubs.
    var pipelineMap = scheduler._pipelineMap;
    agentStubMap.each(function(stub, pipelineId) {
        if (!pipelineMap.get(pipelineId)) {
            stub.dispose(); // When the result of `getTargetSeries` changed, the overallTask
            // should be set as dirty and re-performed.
            overallTask.dirty();
            agentStubMap.removeKey(pipelineId);
        }
    });
}
function $578727d567ffa2bc$var$overallTaskReset(context) {
    context.overallReset(context.ecModel, context.api, context.payload);
}
function $578727d567ffa2bc$var$stubReset(context, upstreamContext) {
    return context.overallProgress && $578727d567ffa2bc$var$stubProgress;
}
function $578727d567ffa2bc$var$stubProgress() {
    this.agent.dirty();
    this.getDownstream().dirty();
}
function $578727d567ffa2bc$var$stubOnDirty() {
    this.agent && this.agent.dirty();
}
function $578727d567ffa2bc$var$seriesTaskPlan(context) {
    return context.plan && context.plan(context.model, context.ecModel, context.api, context.payload);
}
function $578727d567ffa2bc$var$seriesTaskReset(context) {
    if (context.useClearVisual) context.data.clearAllVisual();
    var resetDefines = context.resetDefines = $578727d567ffa2bc$var$normalizeToArray(context.reset(context.model, context.ecModel, context.api, context.payload));
    return resetDefines.length > 1 ? $578727d567ffa2bc$var$map(resetDefines, function(v, idx) {
        return $578727d567ffa2bc$var$makeSeriesTaskProgress(idx);
    }) : $578727d567ffa2bc$var$singleSeriesTaskProgress;
}
var $578727d567ffa2bc$var$singleSeriesTaskProgress = $578727d567ffa2bc$var$makeSeriesTaskProgress(0);
function $578727d567ffa2bc$var$makeSeriesTaskProgress(resetDefineIdx) {
    return function(params, context) {
        var data = context.data;
        var resetDefine = context.resetDefines[resetDefineIdx];
        if (resetDefine && resetDefine.dataEach) for(var i = params.start; i < params.end; i++)resetDefine.dataEach(data, i);
        else if (resetDefine && resetDefine.progress) resetDefine.progress(params, data);
    };
}
function $578727d567ffa2bc$var$seriesTaskCount(context) {
    return context.data.count();
}
function $578727d567ffa2bc$var$pipe(scheduler, seriesModel, task) {
    var pipelineId = seriesModel.uid;
    var pipeline = scheduler._pipelineMap.get(pipelineId);
    !pipeline.head && (pipeline.head = task);
    pipeline.tail && pipeline.tail.pipe(task);
    pipeline.tail = task;
    task.__idxInPipeline = pipeline.count++;
    task.__pipeline = pipeline;
}
$578727d567ffa2bc$var$Scheduler.wrapStageHandler = function(stageHandler, visualType) {
    if ($578727d567ffa2bc$var$isFunction(stageHandler)) stageHandler = {
        overallReset: stageHandler,
        seriesType: $578727d567ffa2bc$var$detectSeriseType(stageHandler)
    };
    stageHandler.uid = $578727d567ffa2bc$var$getUID("stageHandler");
    visualType && (stageHandler.visualType = visualType);
    return stageHandler;
};
/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */ function $578727d567ffa2bc$var$detectSeriseType(legacyFunc) {
    $578727d567ffa2bc$var$seriesType = null;
    try {
        // Assume there is no async when calling `eachSeriesByType`.
        legacyFunc($578727d567ffa2bc$var$ecModelMock, $578727d567ffa2bc$var$apiMock);
    } catch (e) {}
    return $578727d567ffa2bc$var$seriesType;
}
var $578727d567ffa2bc$var$ecModelMock = {};
var $578727d567ffa2bc$var$apiMock = {};
var $578727d567ffa2bc$var$seriesType;
$578727d567ffa2bc$var$mockMethods($578727d567ffa2bc$var$ecModelMock, $6c7ab8052e1c6936$exports);
$578727d567ffa2bc$var$mockMethods($578727d567ffa2bc$var$apiMock, $c4d7ef2132c5793c$exports);
$578727d567ffa2bc$var$ecModelMock.eachSeriesByType = $578727d567ffa2bc$var$ecModelMock.eachRawSeriesByType = function(type) {
    $578727d567ffa2bc$var$seriesType = type;
};
$578727d567ffa2bc$var$ecModelMock.eachComponent = function(cond) {
    if (cond.mainType === "series" && cond.subType) $578727d567ffa2bc$var$seriesType = cond.subType;
};
function $578727d567ffa2bc$var$mockMethods(target, Clz) {
    /* eslint-disable */ for(var name in Clz.prototype)// Do not use hasOwnProperty
    target[name] = $578727d567ffa2bc$var$noop;
/* eslint-enable */ }
var $578727d567ffa2bc$var$_default = $578727d567ffa2bc$var$Scheduler;
$578727d567ffa2bc$exports = $578727d567ffa2bc$var$_default;


var $88cc146d2e63406a$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $88cc146d2e63406a$var$colorAll = [
    "#37A2DA",
    "#32C5E9",
    "#67E0E3",
    "#9FE6B8",
    "#FFDB5C",
    "#ff9f7f",
    "#fb7293",
    "#E062AE",
    "#E690D1",
    "#e7bcf3",
    "#9d96f5",
    "#8378EA",
    "#96BFFF"
];
var $88cc146d2e63406a$var$_default = {
    color: $88cc146d2e63406a$var$colorAll,
    colorLayer: [
        [
            "#37A2DA",
            "#ffd85c",
            "#fd7b5f"
        ],
        [
            "#37A2DA",
            "#67E0E3",
            "#FFDB5C",
            "#ff9f7f",
            "#E062AE",
            "#9d96f5"
        ],
        [
            "#37A2DA",
            "#32C5E9",
            "#9FE6B8",
            "#FFDB5C",
            "#ff9f7f",
            "#fb7293",
            "#e7bcf3",
            "#8378EA",
            "#96BFFF"
        ],
        $88cc146d2e63406a$var$colorAll
    ]
};
$88cc146d2e63406a$exports = $88cc146d2e63406a$var$_default;


var $287a5d0f68383d3f$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $287a5d0f68383d3f$var$contrastColor = "#eee";
var $287a5d0f68383d3f$var$axisCommon = function() {
    return {
        axisLine: {
            lineStyle: {
                color: $287a5d0f68383d3f$var$contrastColor
            }
        },
        axisTick: {
            lineStyle: {
                color: $287a5d0f68383d3f$var$contrastColor
            }
        },
        axisLabel: {
            textStyle: {
                color: $287a5d0f68383d3f$var$contrastColor
            }
        },
        splitLine: {
            lineStyle: {
                type: "dashed",
                color: "#aaa"
            }
        },
        splitArea: {
            areaStyle: {
                color: $287a5d0f68383d3f$var$contrastColor
            }
        }
    };
};
var $287a5d0f68383d3f$var$colorPalette = [
    "#dd6b66",
    "#759aa0",
    "#e69d87",
    "#8dc1a9",
    "#ea7e53",
    "#eedd78",
    "#73a373",
    "#73b9bc",
    "#7289ab",
    "#91ca8c",
    "#f49f42"
];
var $287a5d0f68383d3f$var$theme = {
    color: $287a5d0f68383d3f$var$colorPalette,
    backgroundColor: "#333",
    tooltip: {
        axisPointer: {
            lineStyle: {
                color: $287a5d0f68383d3f$var$contrastColor
            },
            crossStyle: {
                color: $287a5d0f68383d3f$var$contrastColor
            },
            label: {
                color: "#000"
            }
        }
    },
    legend: {
        textStyle: {
            color: $287a5d0f68383d3f$var$contrastColor
        }
    },
    textStyle: {
        color: $287a5d0f68383d3f$var$contrastColor
    },
    title: {
        textStyle: {
            color: $287a5d0f68383d3f$var$contrastColor
        }
    },
    toolbox: {
        iconStyle: {
            normal: {
                borderColor: $287a5d0f68383d3f$var$contrastColor
            }
        }
    },
    dataZoom: {
        textStyle: {
            color: $287a5d0f68383d3f$var$contrastColor
        }
    },
    visualMap: {
        textStyle: {
            color: $287a5d0f68383d3f$var$contrastColor
        }
    },
    timeline: {
        lineStyle: {
            color: $287a5d0f68383d3f$var$contrastColor
        },
        itemStyle: {
            normal: {
                color: $287a5d0f68383d3f$var$colorPalette[1]
            }
        },
        label: {
            normal: {
                textStyle: {
                    color: $287a5d0f68383d3f$var$contrastColor
                }
            }
        },
        controlStyle: {
            normal: {
                color: $287a5d0f68383d3f$var$contrastColor,
                borderColor: $287a5d0f68383d3f$var$contrastColor
            }
        }
    },
    timeAxis: $287a5d0f68383d3f$var$axisCommon(),
    logAxis: $287a5d0f68383d3f$var$axisCommon(),
    valueAxis: $287a5d0f68383d3f$var$axisCommon(),
    categoryAxis: $287a5d0f68383d3f$var$axisCommon(),
    line: {
        symbol: "circle"
    },
    graph: {
        color: $287a5d0f68383d3f$var$colorPalette
    },
    gauge: {
        title: {
            textStyle: {
                color: $287a5d0f68383d3f$var$contrastColor
            }
        }
    },
    candlestick: {
        itemStyle: {
            normal: {
                color: "#FD1050",
                color0: "#0CF49B",
                borderColor: "#FD1050",
                borderColor0: "#0CF49B"
            }
        }
    }
};
$287a5d0f68383d3f$var$theme.categoryAxis.splitLine.show = false;
var $287a5d0f68383d3f$var$_default = $287a5d0f68383d3f$var$theme;
$287a5d0f68383d3f$exports = $287a5d0f68383d3f$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $d0a560c17857bb06$var$detectSourceFormat = $71e1a98f99449cca$export$52a469afa4653e57;

var $d0a560c17857bb06$var$SERIES_LAYOUT_BY_COLUMN = $00bf3640e0468773$export$7b3f3c6551b4949b;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * This module is imported by echarts directly.
 *
 * Notice:
 * Always keep this file exists for backward compatibility.
 * Because before 4.1.0, dataset is an optional component,
 * some users may import this module manually.
 */ $3b9c2389e45dfb7d$exports.extend({
    type: "dataset",
    /**
   * @protected
   */ defaultOption: {
        // 'row', 'column'
        seriesLayoutBy: $d0a560c17857bb06$var$SERIES_LAYOUT_BY_COLUMN,
        // null/'auto': auto detect header, see "module:echarts/data/helper/sourceHelper"
        sourceHeader: null,
        dimensions: null,
        source: null
    },
    optionUpdated: function() {
        $d0a560c17857bb06$var$detectSourceFormat(this);
    }
});
$9c7fc7c628500365$exports.extend({
    type: "dataset"
});


var $cc0f61c9f8527b8d$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $cc0f61c9f8527b8d$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;

var $cc0f61c9f8527b8d$var$createHashMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4;
var $cc0f61c9f8527b8d$var$isString = $ec279652dd95c27b$export$844ec244b1367d54;
var $cc0f61c9f8527b8d$var$isArray = $ec279652dd95c27b$export$43bee75e5e14138e;
var $cc0f61c9f8527b8d$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $cc0f61c9f8527b8d$var$assert = $ec279652dd95c27b$export$a7a9523472993e97;
var $13df5e2156d14c42$export$eacefc55fad2867e;
var $13df5e2156d14c42$export$3e2db4420f14f50f;
var $13df5e2156d14c42$export$1919f5101c220601;





var $a519a6d467310bf2$exports = {};

/**
 * 椭圆形状
 * @module zrender/graphic/shape/Ellipse
 */ var $a519a6d467310bf2$var$_default = $b9701a0f23f767de$exports.extend({
    type: "ellipse",
    shape: {
        cx: 0,
        cy: 0,
        rx: 0,
        ry: 0
    },
    buildPath: function(ctx, shape) {
        var k = 0.5522848;
        var x = shape.cx;
        var y = shape.cy;
        var a = shape.rx;
        var b = shape.ry;
        var ox = a * k; // 水平控制点偏移量
        var oy = b * k; // 垂直控制点偏移量
        // 从椭圆的左端点开始顺时针绘制四条三次贝塞尔曲线
        ctx.moveTo(x - a, y);
        ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
        ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
        ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
        ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
        ctx.closePath();
    }
});
$a519a6d467310bf2$exports = $a519a6d467310bf2$var$_default;










var $13df5e2156d14c42$var$createFromString = $69b77ae5b8565cf7$export$ae5b259626f00aeb;

var $13df5e2156d14c42$var$isString = $ec279652dd95c27b$export$844ec244b1367d54;
var $13df5e2156d14c42$var$extend = $ec279652dd95c27b$export$8b58be045bf06082;
var $13df5e2156d14c42$var$defaults = $ec279652dd95c27b$export$ebe90cb607ad99e;
var $13df5e2156d14c42$var$trim = $ec279652dd95c27b$export$87c2784dc9fc4ab;
var $13df5e2156d14c42$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
// import RadialGradient from '../graphic/RadialGradient';
// import Pattern from '../graphic/Pattern';
// import * as vector from '../core/vector';
// Most of the values can be separated by comma and/or white space.
var $13df5e2156d14c42$var$DILIMITER_REG = /[\s,]+/;
/**
 * For big svg string, this method might be time consuming.
 *
 * @param {string} svg xml string
 * @return {Object} xml root.
 */ function $13df5e2156d14c42$var$parseXML(svg) {
    if ($13df5e2156d14c42$var$isString(svg)) {
        var parser = new DOMParser();
        svg = parser.parseFromString(svg, "text/xml");
    } // Document node. If using $.get, doc node may be input.
    if (svg.nodeType === 9) svg = svg.firstChild;
     // nodeName of <!DOCTYPE svg> is also 'svg'.
    while(svg.nodeName.toLowerCase() !== "svg" || svg.nodeType !== 1)svg = svg.nextSibling;
    return svg;
}
function $13df5e2156d14c42$var$SVGParser() {
    this._defs = {};
    this._root = null;
    this._isDefine = false;
    this._isText = false;
}
$13df5e2156d14c42$var$SVGParser.prototype.parse = function(xml, opt) {
    opt = opt || {};
    var svg = $13df5e2156d14c42$var$parseXML(xml);
    if (!svg) throw new Error("Illegal svg");
    var root = new $48aa8d5160ffcc64$exports();
    this._root = root; // parse view port
    var viewBox = svg.getAttribute("viewBox") || ""; // If width/height not specified, means "100%" of `opt.width/height`.
    // TODO: Other percent value not supported yet.
    var width = parseFloat(svg.getAttribute("width") || opt.width);
    var height = parseFloat(svg.getAttribute("height") || opt.height); // If width/height not specified, set as null for output.
    isNaN(width) && (width = null);
    isNaN(height) && (height = null); // Apply inline style on svg element.
    $13df5e2156d14c42$var$parseAttributes(svg, root, null, true);
    var child = svg.firstChild;
    while(child){
        this._parseNode(child, root);
        child = child.nextSibling;
    }
    var viewBoxRect;
    var viewBoxTransform;
    if (viewBox) {
        var viewBoxArr = $13df5e2156d14c42$var$trim(viewBox).split($13df5e2156d14c42$var$DILIMITER_REG); // Some invalid case like viewBox: 'none'.
        if (viewBoxArr.length >= 4) viewBoxRect = {
            x: parseFloat(viewBoxArr[0] || 0),
            y: parseFloat(viewBoxArr[1] || 0),
            width: parseFloat(viewBoxArr[2]),
            height: parseFloat(viewBoxArr[3])
        };
    }
    if (viewBoxRect && width != null && height != null) {
        viewBoxTransform = $13df5e2156d14c42$var$makeViewBoxTransform(viewBoxRect, width, height);
        if (!opt.ignoreViewBox) {
            // If set transform on the output group, it probably bring trouble when
            // some users only intend to show the clipped content inside the viewBox,
            // but not intend to transform the output group. So we keep the output
            // group no transform. If the user intend to use the viewBox as a
            // camera, just set `opt.ignoreViewBox` as `true` and set transfrom
            // manually according to the viewBox info in the output of this method.
            var elRoot = root;
            root = new $48aa8d5160ffcc64$exports();
            root.add(elRoot);
            elRoot.scale = viewBoxTransform.scale.slice();
            elRoot.position = viewBoxTransform.position.slice();
        }
    } // Some shapes might be overflow the viewport, which should be
    // clipped despite whether the viewBox is used, as the SVG does.
    if (!opt.ignoreRootClip && width != null && height != null) root.setClipPath(new $9dfde1361bdd05e1$exports({
        shape: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    }));
     // Set width/height on group just for output the viewport size.
    return {
        root: root,
        width: width,
        height: height,
        viewBoxRect: viewBoxRect,
        viewBoxTransform: viewBoxTransform
    };
};
$13df5e2156d14c42$var$SVGParser.prototype._parseNode = function(xmlNode, parentGroup) {
    var nodeName = xmlNode.nodeName.toLowerCase(); // TODO
    // support <style>...</style> in svg, where nodeName is 'style',
    // CSS classes is defined globally wherever the style tags are declared.
    if (nodeName === "defs") // define flag
    this._isDefine = true;
    else if (nodeName === "text") this._isText = true;
    var el;
    if (this._isDefine) {
        var parser = $13df5e2156d14c42$var$defineParsers[nodeName];
        if (parser) {
            var def = parser.call(this, xmlNode);
            var id = xmlNode.getAttribute("id");
            if (id) this._defs[id] = def;
        }
    } else {
        var parser = $13df5e2156d14c42$var$nodeParsers[nodeName];
        if (parser) {
            el = parser.call(this, xmlNode, parentGroup);
            parentGroup.add(el);
        }
    }
    var child = xmlNode.firstChild;
    while(child){
        if (child.nodeType === 1) this._parseNode(child, el);
         // Is text
        if (child.nodeType === 3 && this._isText) this._parseText(child, el);
        child = child.nextSibling;
    } // Quit define
    if (nodeName === "defs") this._isDefine = false;
    else if (nodeName === "text") this._isText = false;
};
$13df5e2156d14c42$var$SVGParser.prototype._parseText = function(xmlNode, parentGroup) {
    if (xmlNode.nodeType === 1) {
        var dx = xmlNode.getAttribute("dx") || 0;
        var dy = xmlNode.getAttribute("dy") || 0;
        this._textX += parseFloat(dx);
        this._textY += parseFloat(dy);
    }
    var text = new $2fc81b997a587c68$exports({
        style: {
            text: xmlNode.textContent,
            transformText: true
        },
        position: [
            this._textX || 0,
            this._textY || 0
        ]
    });
    $13df5e2156d14c42$var$inheritStyle(parentGroup, text);
    $13df5e2156d14c42$var$parseAttributes(xmlNode, text, this._defs);
    var fontSize = text.style.fontSize;
    if (fontSize && fontSize < 9) {
        // PENDING
        text.style.fontSize = 9;
        text.scale = text.scale || [
            1,
            1
        ];
        text.scale[0] *= fontSize / 9;
        text.scale[1] *= fontSize / 9;
    }
    var rect = text.getBoundingRect();
    this._textX += rect.width;
    parentGroup.add(text);
    return text;
};
var $13df5e2156d14c42$var$nodeParsers = {
    "g": function(xmlNode, parentGroup) {
        var g = new $48aa8d5160ffcc64$exports();
        $13df5e2156d14c42$var$inheritStyle(parentGroup, g);
        $13df5e2156d14c42$var$parseAttributes(xmlNode, g, this._defs);
        return g;
    },
    "rect": function(xmlNode, parentGroup) {
        var rect = new $9dfde1361bdd05e1$exports();
        $13df5e2156d14c42$var$inheritStyle(parentGroup, rect);
        $13df5e2156d14c42$var$parseAttributes(xmlNode, rect, this._defs);
        rect.setShape({
            x: parseFloat(xmlNode.getAttribute("x") || 0),
            y: parseFloat(xmlNode.getAttribute("y") || 0),
            width: parseFloat(xmlNode.getAttribute("width") || 0),
            height: parseFloat(xmlNode.getAttribute("height") || 0)
        }); // console.log(xmlNode.getAttribute('transform'));
        // console.log(rect.transform);
        return rect;
    },
    "circle": function(xmlNode, parentGroup) {
        var circle = new $eddb4ac7833251bb$exports();
        $13df5e2156d14c42$var$inheritStyle(parentGroup, circle);
        $13df5e2156d14c42$var$parseAttributes(xmlNode, circle, this._defs);
        circle.setShape({
            cx: parseFloat(xmlNode.getAttribute("cx") || 0),
            cy: parseFloat(xmlNode.getAttribute("cy") || 0),
            r: parseFloat(xmlNode.getAttribute("r") || 0)
        });
        return circle;
    },
    "line": function(xmlNode, parentGroup) {
        var line = new $f84975fd9f4e7d13$exports();
        $13df5e2156d14c42$var$inheritStyle(parentGroup, line);
        $13df5e2156d14c42$var$parseAttributes(xmlNode, line, this._defs);
        line.setShape({
            x1: parseFloat(xmlNode.getAttribute("x1") || 0),
            y1: parseFloat(xmlNode.getAttribute("y1") || 0),
            x2: parseFloat(xmlNode.getAttribute("x2") || 0),
            y2: parseFloat(xmlNode.getAttribute("y2") || 0)
        });
        return line;
    },
    "ellipse": function(xmlNode, parentGroup) {
        var ellipse = new $a519a6d467310bf2$exports();
        $13df5e2156d14c42$var$inheritStyle(parentGroup, ellipse);
        $13df5e2156d14c42$var$parseAttributes(xmlNode, ellipse, this._defs);
        ellipse.setShape({
            cx: parseFloat(xmlNode.getAttribute("cx") || 0),
            cy: parseFloat(xmlNode.getAttribute("cy") || 0),
            rx: parseFloat(xmlNode.getAttribute("rx") || 0),
            ry: parseFloat(xmlNode.getAttribute("ry") || 0)
        });
        return ellipse;
    },
    "polygon": function(xmlNode, parentGroup) {
        var points = xmlNode.getAttribute("points");
        if (points) points = $13df5e2156d14c42$var$parsePoints(points);
        var polygon = new $b354b78e9d1919f1$exports({
            shape: {
                points: points || []
            }
        });
        $13df5e2156d14c42$var$inheritStyle(parentGroup, polygon);
        $13df5e2156d14c42$var$parseAttributes(xmlNode, polygon, this._defs);
        return polygon;
    },
    "polyline": function(xmlNode, parentGroup) {
        var path = new $b9701a0f23f767de$exports();
        $13df5e2156d14c42$var$inheritStyle(parentGroup, path);
        $13df5e2156d14c42$var$parseAttributes(xmlNode, path, this._defs);
        var points = xmlNode.getAttribute("points");
        if (points) points = $13df5e2156d14c42$var$parsePoints(points);
        var polyline = new $d6beacdc66e44020$exports({
            shape: {
                points: points || []
            }
        });
        return polyline;
    },
    "image": function(xmlNode, parentGroup) {
        var img = new $8d11db19115b899b$exports();
        $13df5e2156d14c42$var$inheritStyle(parentGroup, img);
        $13df5e2156d14c42$var$parseAttributes(xmlNode, img, this._defs);
        img.setStyle({
            image: xmlNode.getAttribute("xlink:href"),
            x: xmlNode.getAttribute("x"),
            y: xmlNode.getAttribute("y"),
            width: xmlNode.getAttribute("width"),
            height: xmlNode.getAttribute("height")
        });
        return img;
    },
    "text": function(xmlNode, parentGroup) {
        var x = xmlNode.getAttribute("x") || 0;
        var y = xmlNode.getAttribute("y") || 0;
        var dx = xmlNode.getAttribute("dx") || 0;
        var dy = xmlNode.getAttribute("dy") || 0;
        this._textX = parseFloat(x) + parseFloat(dx);
        this._textY = parseFloat(y) + parseFloat(dy);
        var g = new $48aa8d5160ffcc64$exports();
        $13df5e2156d14c42$var$inheritStyle(parentGroup, g);
        $13df5e2156d14c42$var$parseAttributes(xmlNode, g, this._defs);
        return g;
    },
    "tspan": function(xmlNode, parentGroup) {
        var x = xmlNode.getAttribute("x");
        var y = xmlNode.getAttribute("y");
        if (x != null) // new offset x
        this._textX = parseFloat(x);
        if (y != null) // new offset y
        this._textY = parseFloat(y);
        var dx = xmlNode.getAttribute("dx") || 0;
        var dy = xmlNode.getAttribute("dy") || 0;
        var g = new $48aa8d5160ffcc64$exports();
        $13df5e2156d14c42$var$inheritStyle(parentGroup, g);
        $13df5e2156d14c42$var$parseAttributes(xmlNode, g, this._defs);
        this._textX += dx;
        this._textY += dy;
        return g;
    },
    "path": function(xmlNode, parentGroup) {
        // TODO svg fill rule
        // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/fill-rule
        // path.style.globalCompositeOperation = 'xor';
        var d = xmlNode.getAttribute("d") || ""; // Performance sensitive.
        var path = $13df5e2156d14c42$var$createFromString(d);
        $13df5e2156d14c42$var$inheritStyle(parentGroup, path);
        $13df5e2156d14c42$var$parseAttributes(xmlNode, path, this._defs);
        return path;
    }
};
var $13df5e2156d14c42$var$defineParsers = {
    "lineargradient": function(xmlNode) {
        var x1 = parseInt(xmlNode.getAttribute("x1") || 0, 10);
        var y1 = parseInt(xmlNode.getAttribute("y1") || 0, 10);
        var x2 = parseInt(xmlNode.getAttribute("x2") || 10, 10);
        var y2 = parseInt(xmlNode.getAttribute("y2") || 0, 10);
        var gradient = new $2b8958ff0f4c4e26$exports(x1, y1, x2, y2);
        $13df5e2156d14c42$var$_parseGradientColorStops(xmlNode, gradient);
        return gradient;
    },
    "radialgradient": function(xmlNode) {}
};
function $13df5e2156d14c42$var$_parseGradientColorStops(xmlNode, gradient) {
    var stop = xmlNode.firstChild;
    while(stop){
        if (stop.nodeType === 1) {
            var offset = stop.getAttribute("offset");
            if (offset.indexOf("%") > 0) // percentage
            offset = parseInt(offset, 10) / 100;
            else if (offset) // number from 0 to 1
            offset = parseFloat(offset);
            else offset = 0;
            var stopColor = stop.getAttribute("stop-color") || "#000000";
            gradient.addColorStop(offset, stopColor);
        }
        stop = stop.nextSibling;
    }
}
function $13df5e2156d14c42$var$inheritStyle(parent, child) {
    if (parent && parent.__inheritedStyle) {
        if (!child.__inheritedStyle) child.__inheritedStyle = {};
        $13df5e2156d14c42$var$defaults(child.__inheritedStyle, parent.__inheritedStyle);
    }
}
function $13df5e2156d14c42$var$parsePoints(pointsString) {
    var list = $13df5e2156d14c42$var$trim(pointsString).split($13df5e2156d14c42$var$DILIMITER_REG);
    var points = [];
    for(var i = 0; i < list.length; i += 2){
        var x = parseFloat(list[i]);
        var y = parseFloat(list[i + 1]);
        points.push([
            x,
            y
        ]);
    }
    return points;
}
var $13df5e2156d14c42$var$attributesMap = {
    "fill": "fill",
    "stroke": "stroke",
    "stroke-width": "lineWidth",
    "opacity": "opacity",
    "fill-opacity": "fillOpacity",
    "stroke-opacity": "strokeOpacity",
    "stroke-dasharray": "lineDash",
    "stroke-dashoffset": "lineDashOffset",
    "stroke-linecap": "lineCap",
    "stroke-linejoin": "lineJoin",
    "stroke-miterlimit": "miterLimit",
    "font-family": "fontFamily",
    "font-size": "fontSize",
    "font-style": "fontStyle",
    "font-weight": "fontWeight",
    "text-align": "textAlign",
    "alignment-baseline": "textBaseline"
};
function $13df5e2156d14c42$var$parseAttributes(xmlNode, el, defs, onlyInlineStyle) {
    var zrStyle = el.__inheritedStyle || {};
    var isTextEl = el.type === "text"; // TODO Shadow
    if (xmlNode.nodeType === 1) {
        $13df5e2156d14c42$var$parseTransformAttribute(xmlNode, el);
        $13df5e2156d14c42$var$extend(zrStyle, $13df5e2156d14c42$var$parseStyleAttribute(xmlNode));
        if (!onlyInlineStyle) {
            for(var svgAttrName in $13df5e2156d14c42$var$attributesMap)if ($13df5e2156d14c42$var$attributesMap.hasOwnProperty(svgAttrName)) {
                var attrValue = xmlNode.getAttribute(svgAttrName);
                if (attrValue != null) zrStyle[$13df5e2156d14c42$var$attributesMap[svgAttrName]] = attrValue;
            }
        }
    }
    var elFillProp = isTextEl ? "textFill" : "fill";
    var elStrokeProp = isTextEl ? "textStroke" : "stroke";
    el.style = el.style || new $5138c5bbf976c46c$exports();
    var elStyle = el.style;
    zrStyle.fill != null && elStyle.set(elFillProp, $13df5e2156d14c42$var$getPaint(zrStyle.fill, defs));
    zrStyle.stroke != null && elStyle.set(elStrokeProp, $13df5e2156d14c42$var$getPaint(zrStyle.stroke, defs));
    $13df5e2156d14c42$var$each([
        "lineWidth",
        "opacity",
        "fillOpacity",
        "strokeOpacity",
        "miterLimit",
        "fontSize"
    ], function(propName) {
        var elPropName = propName === "lineWidth" && isTextEl ? "textStrokeWidth" : propName;
        zrStyle[propName] != null && elStyle.set(elPropName, parseFloat(zrStyle[propName]));
    });
    if (!zrStyle.textBaseline || zrStyle.textBaseline === "auto") zrStyle.textBaseline = "alphabetic";
    if (zrStyle.textBaseline === "alphabetic") zrStyle.textBaseline = "bottom";
    if (zrStyle.textAlign === "start") zrStyle.textAlign = "left";
    if (zrStyle.textAlign === "end") zrStyle.textAlign = "right";
    $13df5e2156d14c42$var$each([
        "lineDashOffset",
        "lineCap",
        "lineJoin",
        "fontWeight",
        "fontFamily",
        "fontStyle",
        "textAlign",
        "textBaseline"
    ], function(propName) {
        zrStyle[propName] != null && elStyle.set(propName, zrStyle[propName]);
    });
    if (zrStyle.lineDash) el.style.lineDash = $13df5e2156d14c42$var$trim(zrStyle.lineDash).split($13df5e2156d14c42$var$DILIMITER_REG);
    if (elStyle[elStrokeProp] && elStyle[elStrokeProp] !== "none") // enable stroke
    el[elStrokeProp] = true;
    el.__inheritedStyle = zrStyle;
}
var $13df5e2156d14c42$var$urlRegex = /url\(\s*#(.*?)\)/;
function $13df5e2156d14c42$var$getPaint(str, defs) {
    // if (str === 'none') {
    //     return;
    // }
    var urlMatch = defs && str && str.match($13df5e2156d14c42$var$urlRegex);
    if (urlMatch) {
        var url = $13df5e2156d14c42$var$trim(urlMatch[1]);
        var def = defs[url];
        return def;
    }
    return str;
}
var $13df5e2156d14c42$var$transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.e,]*)\)/g;
function $13df5e2156d14c42$var$parseTransformAttribute(xmlNode, node) {
    var transform = xmlNode.getAttribute("transform");
    if (transform) {
        transform = transform.replace(/,/g, " ");
        var m = null;
        var transformOps = [];
        transform.replace($13df5e2156d14c42$var$transformRegex, function(str, type, value) {
            transformOps.push(type, value);
        });
        for(var i = transformOps.length - 1; i > 0; i -= 2){
            var value = transformOps[i];
            var type = transformOps[i - 1];
            m = m || $6c6dd9610ba660f0$export$185802fd694ee1f5();
            switch(type){
                case "translate":
                    value = $13df5e2156d14c42$var$trim(value).split($13df5e2156d14c42$var$DILIMITER_REG);
                    $6c6dd9610ba660f0$export$d73ee8ef04f5226a(m, m, [
                        parseFloat(value[0]),
                        parseFloat(value[1] || 0)
                    ]);
                    break;
                case "scale":
                    value = $13df5e2156d14c42$var$trim(value).split($13df5e2156d14c42$var$DILIMITER_REG);
                    $6c6dd9610ba660f0$export$dcdf75081b88279d(m, m, [
                        parseFloat(value[0]),
                        parseFloat(value[1] || value[0])
                    ]);
                    break;
                case "rotate":
                    value = $13df5e2156d14c42$var$trim(value).split($13df5e2156d14c42$var$DILIMITER_REG);
                    $6c6dd9610ba660f0$export$bb628a54ab399bc9(m, m, parseFloat(value[0]));
                    break;
                case "skew":
                    value = $13df5e2156d14c42$var$trim(value).split($13df5e2156d14c42$var$DILIMITER_REG);
                    console.warn("Skew transform is not supported yet");
                    break;
                case "matrix":
                    var value = $13df5e2156d14c42$var$trim(value).split($13df5e2156d14c42$var$DILIMITER_REG);
                    m[0] = parseFloat(value[0]);
                    m[1] = parseFloat(value[1]);
                    m[2] = parseFloat(value[2]);
                    m[3] = parseFloat(value[3]);
                    m[4] = parseFloat(value[4]);
                    m[5] = parseFloat(value[5]);
                    break;
            }
        }
        node.setLocalTransform(m);
    }
} // Value may contain space.
var $13df5e2156d14c42$var$styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
function $13df5e2156d14c42$var$parseStyleAttribute(xmlNode) {
    var style = xmlNode.getAttribute("style");
    var result = {};
    if (!style) return result;
    var styleList = {};
    $13df5e2156d14c42$var$styleRegex.lastIndex = 0;
    var styleRegResult;
    while((styleRegResult = $13df5e2156d14c42$var$styleRegex.exec(style)) != null)styleList[styleRegResult[1]] = styleRegResult[2];
    for(var svgAttrName in $13df5e2156d14c42$var$attributesMap)if ($13df5e2156d14c42$var$attributesMap.hasOwnProperty(svgAttrName) && styleList[svgAttrName] != null) result[$13df5e2156d14c42$var$attributesMap[svgAttrName]] = styleList[svgAttrName];
    return result;
}
/**
 * @param {Array.<number>} viewBoxRect
 * @param {number} width
 * @param {number} height
 * @return {Object} {scale, position}
 */ function $13df5e2156d14c42$var$makeViewBoxTransform(viewBoxRect, width, height) {
    var scaleX = width / viewBoxRect.width;
    var scaleY = height / viewBoxRect.height;
    var scale = Math.min(scaleX, scaleY); // preserveAspectRatio 'xMidYMid'
    var viewBoxScale = [
        scale,
        scale
    ];
    var viewBoxPosition = [
        -(viewBoxRect.x + viewBoxRect.width / 2) * scale + width / 2,
        -(viewBoxRect.y + viewBoxRect.height / 2) * scale + height / 2
    ];
    return {
        scale: viewBoxScale,
        position: viewBoxPosition
    };
}
/**
 * @param {string|XMLElement} xml
 * @param {Object} [opt]
 * @param {number} [opt.width] Default width if svg width not specified or is a percent value.
 * @param {number} [opt.height] Default height if svg height not specified or is a percent value.
 * @param {boolean} [opt.ignoreViewBox]
 * @param {boolean} [opt.ignoreRootClip]
 * @return {Object} result:
 * {
 *     root: Group, The root of the the result tree of zrender shapes,
 *     width: number, the viewport width of the SVG,
 *     height: number, the viewport height of the SVG,
 *     viewBoxRect: {x, y, width, height}, the declared viewBox rect of the SVG, if exists,
 *     viewBoxTransform: the {scale, position} calculated by viewBox and viewport, is exists.
 * }
 */ function $13df5e2156d14c42$var$parseSVG(xml, opt) {
    var parser = new $13df5e2156d14c42$var$SVGParser();
    return parser.parse(xml, opt);
}
$13df5e2156d14c42$export$eacefc55fad2867e = $13df5e2156d14c42$var$parseXML;
$13df5e2156d14c42$export$3e2db4420f14f50f = $13df5e2156d14c42$var$makeViewBoxTransform;
$13df5e2156d14c42$export$1919f5101c220601 = $13df5e2156d14c42$var$parseSVG;


var $cc0f61c9f8527b8d$var$parseXML = $13df5e2156d14c42$export$eacefc55fad2867e;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $cc0f61c9f8527b8d$var$storage = $cc0f61c9f8527b8d$var$createHashMap(); // For minimize the code size of common echarts package,
// do not put too much logic in this module.
var $cc0f61c9f8527b8d$var$_default = {
    // The format of record: see `echarts.registerMap`.
    // Compatible with previous `echarts.registerMap`.
    registerMap: function(mapName, rawGeoJson, rawSpecialAreas) {
        var records;
        if ($cc0f61c9f8527b8d$var$isArray(rawGeoJson)) records = rawGeoJson;
        else if (rawGeoJson.svg) records = [
            {
                type: "svg",
                source: rawGeoJson.svg,
                specialAreas: rawGeoJson.specialAreas
            }
        ];
        else {
            // Backward compatibility.
            if (rawGeoJson.geoJson && !rawGeoJson.features) {
                rawSpecialAreas = rawGeoJson.specialAreas;
                rawGeoJson = rawGeoJson.geoJson;
            }
            records = [
                {
                    type: "geoJSON",
                    source: rawGeoJson,
                    specialAreas: rawSpecialAreas
                }
            ];
        }
        $cc0f61c9f8527b8d$var$each(records, function(record) {
            var type = record.type;
            type === "geoJson" && (type = record.type = "geoJSON");
            var parse = $cc0f61c9f8527b8d$var$parsers[type];
            parse(record);
        });
        return $cc0f61c9f8527b8d$var$storage.set(mapName, records);
    },
    retrieveMap: function(mapName) {
        return $cc0f61c9f8527b8d$var$storage.get(mapName);
    }
};
var $cc0f61c9f8527b8d$var$parsers = {
    geoJSON: function(record) {
        var source = record.source;
        record.geoJSON = !$cc0f61c9f8527b8d$var$isString(source) ? source : typeof JSON !== "undefined" && JSON.parse ? JSON.parse(source) : new Function("return (" + source + ");")();
    },
    // Only perform parse to XML object here, which might be time
    // consiming for large SVG.
    // Although convert XML to zrender element is also time consiming,
    // if we do it here, the clone of zrender elements has to be
    // required. So we do it once for each geo instance, util real
    // performance issues call for optimizing it.
    svg: function(record) {
        record.svgXML = $cc0f61c9f8527b8d$var$parseXML(record.source);
    }
};
$cc0f61c9f8527b8d$exports = $cc0f61c9f8527b8d$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $f406636b535430a7$var$assert = $ec279652dd95c27b$export$a7a9523472993e97;
var $f406636b535430a7$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $f406636b535430a7$var$isFunction = $ec279652dd95c27b$export$f6e2535fb5126e54;
var $f406636b535430a7$var$isObject = $ec279652dd95c27b$export$a6cdc56e425d0d0a;
var $f406636b535430a7$var$parseClassType = $3b9c2389e45dfb7d$exports.parseClassType;
var $f406636b535430a7$var$version = "4.9.0";
var $f406636b535430a7$var$dependencies = {
    zrender: "4.3.2"
};
var $f406636b535430a7$var$TEST_FRAME_REMAIN_TIME = 1;
var $f406636b535430a7$var$PRIORITY_PROCESSOR_FILTER = 1000;
var $f406636b535430a7$var$PRIORITY_PROCESSOR_SERIES_FILTER = 800;
var $f406636b535430a7$var$PRIORITY_PROCESSOR_DATASTACK = 900;
var $f406636b535430a7$var$PRIORITY_PROCESSOR_STATISTIC = 5000;
var $f406636b535430a7$var$PRIORITY_VISUAL_LAYOUT = 1000;
var $f406636b535430a7$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
var $f406636b535430a7$var$PRIORITY_VISUAL_GLOBAL = 2000;
var $f406636b535430a7$var$PRIORITY_VISUAL_CHART = 3000;
var $f406636b535430a7$var$PRIORITY_VISUAL_POST_CHART_LAYOUT = 3500;
var $f406636b535430a7$var$PRIORITY_VISUAL_COMPONENT = 4000; // FIXME
// necessary?
var $f406636b535430a7$var$PRIORITY_VISUAL_BRUSH = 5000;
var $f406636b535430a7$var$PRIORITY = {
    PROCESSOR: {
        FILTER: $f406636b535430a7$var$PRIORITY_PROCESSOR_FILTER,
        SERIES_FILTER: $f406636b535430a7$var$PRIORITY_PROCESSOR_SERIES_FILTER,
        STATISTIC: $f406636b535430a7$var$PRIORITY_PROCESSOR_STATISTIC
    },
    VISUAL: {
        LAYOUT: $f406636b535430a7$var$PRIORITY_VISUAL_LAYOUT,
        PROGRESSIVE_LAYOUT: $f406636b535430a7$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
        GLOBAL: $f406636b535430a7$var$PRIORITY_VISUAL_GLOBAL,
        CHART: $f406636b535430a7$var$PRIORITY_VISUAL_CHART,
        POST_CHART_LAYOUT: $f406636b535430a7$var$PRIORITY_VISUAL_POST_CHART_LAYOUT,
        COMPONENT: $f406636b535430a7$var$PRIORITY_VISUAL_COMPONENT,
        BRUSH: $f406636b535430a7$var$PRIORITY_VISUAL_BRUSH
    }
}; // Main process have three entries: `setOption`, `dispatchAction` and `resize`,
// where they must not be invoked nestedly, except the only case: invoke
// dispatchAction with updateMethod "none" in main process.
// This flag is used to carry out this rule.
// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
var $f406636b535430a7$var$IN_MAIN_PROCESS = "__flagInMainProcess";
var $f406636b535430a7$var$OPTION_UPDATED = "__optionUpdated";
var $f406636b535430a7$var$ACTION_REG = /^[a-zA-Z0-9_]+$/;
function $f406636b535430a7$var$createRegisterEventWithLowercaseName(method, ignoreDisposed) {
    return function(eventName, handler, context) {
        if (!ignoreDisposed && this._disposed) {
            $f406636b535430a7$var$disposedWarning(this.id);
            return;
        } // Event name is all lowercase
        eventName = eventName && eventName.toLowerCase();
        $b7a44647f5b5bfa5$exports.prototype[method].call(this, eventName, handler, context);
    };
}
/**
 * @module echarts~MessageCenter
 */ function $f406636b535430a7$var$MessageCenter() {
    $b7a44647f5b5bfa5$exports.call(this);
}
$f406636b535430a7$var$MessageCenter.prototype.on = $f406636b535430a7$var$createRegisterEventWithLowercaseName("on", true);
$f406636b535430a7$var$MessageCenter.prototype.off = $f406636b535430a7$var$createRegisterEventWithLowercaseName("off", true);
$f406636b535430a7$var$MessageCenter.prototype.one = $f406636b535430a7$var$createRegisterEventWithLowercaseName("one", true);
$ec279652dd95c27b$export$e36fc9d62a853069($f406636b535430a7$var$MessageCenter, $b7a44647f5b5bfa5$exports);
/**
 * @module echarts~ECharts
 */ function $f406636b535430a7$var$ECharts(dom, theme, opts) {
    opts = opts || {}; // Get theme by name
    if (typeof theme === "string") theme = $f406636b535430a7$var$themeStorage[theme];
    /**
   * @type {string}
   */ this.id;
    /**
   * Group id
   * @type {string}
   */ this.group;
    /**
   * @type {HTMLElement}
   * @private
   */ this._dom = dom;
    var defaultRenderer = "canvas";
    /**
   * @type {module:zrender/ZRender}
   * @private
   */ var zr = this._zr = $ec1efdd8e4428d18$export$2cd8252107eb640b(dom, {
        renderer: opts.renderer || defaultRenderer,
        devicePixelRatio: opts.devicePixelRatio,
        width: opts.width,
        height: opts.height
    });
    /**
   * Expect 60 fps.
   * @type {Function}
   * @private
   */ this._throttledZrFlush = $f406636b535430a7$var$throttle($ec279652dd95c27b$export$2385a24977818dd0(zr.flush, zr), 17);
    var theme = $ec279652dd95c27b$export$9cd59f9826255e47(theme);
    theme && $1706c18d3b422369$exports(theme, true);
    /**
   * @type {Object}
   * @private
   */ this._theme = theme;
    /**
   * @type {Array.<module:echarts/view/Chart>}
   * @private
   */ this._chartsViews = [];
    /**
   * @type {Object.<string, module:echarts/view/Chart>}
   * @private
   */ this._chartsMap = {};
    /**
   * @type {Array.<module:echarts/view/Component>}
   * @private
   */ this._componentsViews = [];
    /**
   * @type {Object.<string, module:echarts/view/Component>}
   * @private
   */ this._componentsMap = {};
    /**
   * @type {module:echarts/CoordinateSystem}
   * @private
   */ this._coordSysMgr = new $9c36d0fff3b0f387$exports();
    /**
   * @type {module:echarts/ExtensionAPI}
   * @private
   */ var api = this._api = $f406636b535430a7$var$createExtensionAPI(this); // Sort on demand
    function prioritySortFunc(a, b) {
        return a.__prio - b.__prio;
    }
    $7f3d4243ceebe2b3$exports($f406636b535430a7$var$visualFuncs, prioritySortFunc);
    $7f3d4243ceebe2b3$exports($f406636b535430a7$var$dataProcessorFuncs, prioritySortFunc);
    /**
   * @type {module:echarts/stream/Scheduler}
   */ this._scheduler = new $578727d567ffa2bc$exports(this, api, $f406636b535430a7$var$dataProcessorFuncs, $f406636b535430a7$var$visualFuncs);
    $b7a44647f5b5bfa5$exports.call(this, this._ecEventProcessor = new $f406636b535430a7$var$EventProcessor());
    /**
   * @type {module:echarts~MessageCenter}
   * @private
   */ this._messageCenter = new $f406636b535430a7$var$MessageCenter(); // Init mouse events
    this._initEvents(); // In case some people write `window.onresize = chart.resize`
    this.resize = $ec279652dd95c27b$export$2385a24977818dd0(this.resize, this); // Can't dispatch action during rendering procedure
    this._pendingActions = [];
    zr.animation.on("frame", this._onframe, this);
    $f406636b535430a7$var$bindRenderedEvent(zr, this); // ECharts instance can be used as value.
    $ec279652dd95c27b$export$112e66431016387b(this);
}
var $f406636b535430a7$var$echartsProto = $f406636b535430a7$var$ECharts.prototype;
$f406636b535430a7$var$echartsProto._onframe = function() {
    if (this._disposed) return;
    var scheduler = this._scheduler; // Lazy update
    if (this[$f406636b535430a7$var$OPTION_UPDATED]) {
        var silent = this[$f406636b535430a7$var$OPTION_UPDATED].silent;
        this[$f406636b535430a7$var$IN_MAIN_PROCESS] = true;
        $f406636b535430a7$var$prepare(this);
        $f406636b535430a7$var$updateMethods.update.call(this);
        this[$f406636b535430a7$var$IN_MAIN_PROCESS] = false;
        this[$f406636b535430a7$var$OPTION_UPDATED] = false;
        $f406636b535430a7$var$flushPendingActions.call(this, silent);
        $f406636b535430a7$var$triggerUpdatedEvent.call(this, silent);
    } else if (scheduler.unfinished) {
        // Stream progress.
        var remainTime = $f406636b535430a7$var$TEST_FRAME_REMAIN_TIME;
        var ecModel = this._model;
        var api = this._api;
        scheduler.unfinished = false;
        do {
            var startTime = +new Date();
            scheduler.performSeriesTasks(ecModel); // Currently dataProcessorFuncs do not check threshold.
            scheduler.performDataProcessorTasks(ecModel);
            $f406636b535430a7$var$updateStreamModes(this, ecModel); // Do not update coordinate system here. Because that coord system update in
            // each frame is not a good user experience. So we follow the rule that
            // the extent of the coordinate system is determin in the first frame (the
            // frame is executed immedietely after task reset.
            // this._coordSysMgr.update(ecModel, api);
            // console.log('--- ec frame visual ---', remainTime);
            scheduler.performVisualTasks(ecModel);
            $f406636b535430a7$var$renderSeries(this, this._model, api, "remain");
            remainTime -= +new Date() - startTime;
        }while (remainTime > 0 && scheduler.unfinished); // Call flush explicitly for trigger finished event.
        if (!scheduler.unfinished) this._zr.flush();
         // Else, zr flushing be ensue within the same frame,
    // because zr flushing is after onframe event.
    }
};
/**
 * @return {HTMLElement}
 */ $f406636b535430a7$var$echartsProto.getDom = function() {
    return this._dom;
};
/**
 * @return {module:zrender~ZRender}
 */ $f406636b535430a7$var$echartsProto.getZr = function() {
    return this._zr;
};
/**
 * Usage:
 * chart.setOption(option, notMerge, lazyUpdate);
 * chart.setOption(option, {
 *     notMerge: ...,
 *     lazyUpdate: ...,
 *     silent: ...
 * });
 *
 * @param {Object} option
 * @param {Object|boolean} [opts] opts or notMerge.
 * @param {boolean} [opts.notMerge=false]
 * @param {boolean} [opts.lazyUpdate=false] Useful when setOption frequently.
 */ $f406636b535430a7$var$echartsProto.setOption = function(option, notMerge, lazyUpdate) {
    if (this._disposed) {
        $f406636b535430a7$var$disposedWarning(this.id);
        return;
    }
    var silent;
    if ($f406636b535430a7$var$isObject(notMerge)) {
        lazyUpdate = notMerge.lazyUpdate;
        silent = notMerge.silent;
        notMerge = notMerge.notMerge;
    }
    this[$f406636b535430a7$var$IN_MAIN_PROCESS] = true;
    if (!this._model || notMerge) {
        var optionManager = new $440c6b6cac31c6df$exports(this._api);
        var theme = this._theme;
        var ecModel = this._model = new $6c7ab8052e1c6936$exports();
        ecModel.scheduler = this._scheduler;
        ecModel.init(null, null, theme, optionManager);
    }
    this._model.setOption(option, $f406636b535430a7$var$optionPreprocessorFuncs);
    if (lazyUpdate) {
        this[$f406636b535430a7$var$OPTION_UPDATED] = {
            silent: silent
        };
        this[$f406636b535430a7$var$IN_MAIN_PROCESS] = false;
    } else {
        $f406636b535430a7$var$prepare(this);
        $f406636b535430a7$var$updateMethods.update.call(this); // Ensure zr refresh sychronously, and then pixel in canvas can be
        // fetched after `setOption`.
        this._zr.flush();
        this[$f406636b535430a7$var$OPTION_UPDATED] = false;
        this[$f406636b535430a7$var$IN_MAIN_PROCESS] = false;
        $f406636b535430a7$var$flushPendingActions.call(this, silent);
        $f406636b535430a7$var$triggerUpdatedEvent.call(this, silent);
    }
};
/**
 * @DEPRECATED
 */ $f406636b535430a7$var$echartsProto.setTheme = function() {
    console.error("ECharts#setTheme() is DEPRECATED in ECharts 3.0");
};
/**
 * @return {module:echarts/model/Global}
 */ $f406636b535430a7$var$echartsProto.getModel = function() {
    return this._model;
};
/**
 * @return {Object}
 */ $f406636b535430a7$var$echartsProto.getOption = function() {
    return this._model && this._model.getOption();
};
/**
 * @return {number}
 */ $f406636b535430a7$var$echartsProto.getWidth = function() {
    return this._zr.getWidth();
};
/**
 * @return {number}
 */ $f406636b535430a7$var$echartsProto.getHeight = function() {
    return this._zr.getHeight();
};
/**
 * @return {number}
 */ $f406636b535430a7$var$echartsProto.getDevicePixelRatio = function() {
    return this._zr.painter.dpr || window.devicePixelRatio || 1;
};
/**
 * Get canvas which has all thing rendered
 * @param {Object} opts
 * @param {string} [opts.backgroundColor]
 * @return {string}
 */ $f406636b535430a7$var$echartsProto.getRenderedCanvas = function(opts) {
    if (!$27ac1413ecc67076$exports.canvasSupported) return;
    opts = opts || {};
    opts.pixelRatio = opts.pixelRatio || 1;
    opts.backgroundColor = opts.backgroundColor || this._model.get("backgroundColor");
    var zr = this._zr; // var list = zr.storage.getDisplayList();
    // Stop animations
    // Never works before in init animation, so remove it.
    // zrUtil.each(list, function (el) {
    //     el.stopAnimation(true);
    // });
    return zr.painter.getRenderedCanvas(opts);
};
/**
 * Get svg data url
 * @return {string}
 */ $f406636b535430a7$var$echartsProto.getSvgDataURL = function() {
    if (!$27ac1413ecc67076$exports.svgSupported) return;
    var zr = this._zr;
    var list = zr.storage.getDisplayList(); // Stop animations
    $ec279652dd95c27b$export$79b2f7037acddd43(list, function(el) {
        el.stopAnimation(true);
    });
    return zr.painter.toDataURL();
};
/**
 * @return {string}
 * @param {Object} opts
 * @param {string} [opts.type='png']
 * @param {string} [opts.pixelRatio=1]
 * @param {string} [opts.backgroundColor]
 * @param {string} [opts.excludeComponents]
 */ $f406636b535430a7$var$echartsProto.getDataURL = function(opts) {
    if (this._disposed) {
        $f406636b535430a7$var$disposedWarning(this.id);
        return;
    }
    opts = opts || {};
    var excludeComponents = opts.excludeComponents;
    var ecModel = this._model;
    var excludesComponentViews = [];
    var self = this;
    $f406636b535430a7$var$each(excludeComponents, function(componentType) {
        ecModel.eachComponent({
            mainType: componentType
        }, function(component) {
            var view = self._componentsMap[component.__viewId];
            if (!view.group.ignore) {
                excludesComponentViews.push(view);
                view.group.ignore = true;
            }
        });
    });
    var url = this._zr.painter.getType() === "svg" ? this.getSvgDataURL() : this.getRenderedCanvas(opts).toDataURL("image/" + (opts && opts.type || "png"));
    $f406636b535430a7$var$each(excludesComponentViews, function(view) {
        view.group.ignore = false;
    });
    return url;
};
/**
 * @return {string}
 * @param {Object} opts
 * @param {string} [opts.type='png']
 * @param {string} [opts.pixelRatio=1]
 * @param {string} [opts.backgroundColor]
 */ $f406636b535430a7$var$echartsProto.getConnectedDataURL = function(opts) {
    if (this._disposed) {
        $f406636b535430a7$var$disposedWarning(this.id);
        return;
    }
    if (!$27ac1413ecc67076$exports.canvasSupported) return;
    var isSvg = opts.type === "svg";
    var groupId = this.group;
    var mathMin = Math.min;
    var mathMax = Math.max;
    var MAX_NUMBER = Infinity;
    if ($f406636b535430a7$var$connectedGroups[groupId]) {
        var left = MAX_NUMBER;
        var top = MAX_NUMBER;
        var right = -MAX_NUMBER;
        var bottom = -MAX_NUMBER;
        var canvasList = [];
        var dpr = opts && opts.pixelRatio || 1;
        $ec279652dd95c27b$export$79b2f7037acddd43($f406636b535430a7$var$instances, function(chart, id) {
            if (chart.group === groupId) {
                var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.getRenderedCanvas($ec279652dd95c27b$export$9cd59f9826255e47(opts));
                var boundingRect = chart.getDom().getBoundingClientRect();
                left = mathMin(boundingRect.left, left);
                top = mathMin(boundingRect.top, top);
                right = mathMax(boundingRect.right, right);
                bottom = mathMax(boundingRect.bottom, bottom);
                canvasList.push({
                    dom: canvas,
                    left: boundingRect.left,
                    top: boundingRect.top
                });
            }
        });
        left *= dpr;
        top *= dpr;
        right *= dpr;
        bottom *= dpr;
        var width = right - left;
        var height = bottom - top;
        var targetCanvas = $ec279652dd95c27b$export$cd3d1f114b139967();
        var zr = $ec1efdd8e4428d18$export$2cd8252107eb640b(targetCanvas, {
            renderer: isSvg ? "svg" : "canvas"
        });
        zr.resize({
            width: width,
            height: height
        });
        if (isSvg) {
            var content = "";
            $f406636b535430a7$var$each(canvasList, function(item) {
                var x = item.left - left;
                var y = item.top - top;
                content += '<g transform="translate(' + x + "," + y + ')">' + item.dom + "</g>";
            });
            zr.painter.getSvgRoot().innerHTML = content;
            if (opts.connectedBackgroundColor) zr.painter.setBackgroundColor(opts.connectedBackgroundColor);
            zr.refreshImmediately();
            return zr.painter.toDataURL();
        } else {
            // Background between the charts
            if (opts.connectedBackgroundColor) zr.add(new $4b57d6b582d579b7$export$c79fc6492f3af13d({
                shape: {
                    x: 0,
                    y: 0,
                    width: width,
                    height: height
                },
                style: {
                    fill: opts.connectedBackgroundColor
                }
            }));
            $f406636b535430a7$var$each(canvasList, function(item) {
                var img = new $4b57d6b582d579b7$export$3e431a229df88919({
                    style: {
                        x: item.left * dpr - left,
                        y: item.top * dpr - top,
                        image: item.dom
                    }
                });
                zr.add(img);
            });
            zr.refreshImmediately();
            return targetCanvas.toDataURL("image/" + (opts && opts.type || "png"));
        }
    } else return this.getDataURL(opts);
};
/**
 * Convert from logical coordinate system to pixel coordinate system.
 * See CoordinateSystem#convertToPixel.
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            geoIndex / geoId, geoName,
 *            bmapIndex / bmapId / bmapName,
 *            xAxisIndex / xAxisId / xAxisName,
 *            yAxisIndex / yAxisId / yAxisName,
 *            gridIndex / gridId / gridName,
 *            ... (can be extended)
 *        }
 * @param {Array|number} value
 * @return {Array|number} result
 */ $f406636b535430a7$var$echartsProto.convertToPixel = $ec279652dd95c27b$export$c3095a23b368d1f2($f406636b535430a7$var$doConvertPixel, "convertToPixel");
/**
 * Convert from pixel coordinate system to logical coordinate system.
 * See CoordinateSystem#convertFromPixel.
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            geoIndex / geoId / geoName,
 *            bmapIndex / bmapId / bmapName,
 *            xAxisIndex / xAxisId / xAxisName,
 *            yAxisIndex / yAxisId / yAxisName
 *            gridIndex / gridId / gridName,
 *            ... (can be extended)
 *        }
 * @param {Array|number} value
 * @return {Array|number} result
 */ $f406636b535430a7$var$echartsProto.convertFromPixel = $ec279652dd95c27b$export$c3095a23b368d1f2($f406636b535430a7$var$doConvertPixel, "convertFromPixel");
function $f406636b535430a7$var$doConvertPixel(methodName, finder, value) {
    if (this._disposed) {
        $f406636b535430a7$var$disposedWarning(this.id);
        return;
    }
    var ecModel = this._model;
    var coordSysList = this._coordSysMgr.getCoordinateSystems();
    var result;
    finder = $d559f43cb9041423$export$95de80076abac814(ecModel, finder);
    for(var i = 0; i < coordSysList.length; i++){
        var coordSys = coordSysList[i];
        if (coordSys[methodName] && (result = coordSys[methodName](ecModel, finder, value)) != null) return result;
    }
}
/**
 * Is the specified coordinate systems or components contain the given pixel point.
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            geoIndex / geoId / geoName,
 *            bmapIndex / bmapId / bmapName,
 *            xAxisIndex / xAxisId / xAxisName,
 *            yAxisIndex / yAxisId / yAxisName,
 *            gridIndex / gridId / gridName,
 *            ... (can be extended)
 *        }
 * @param {Array|number} value
 * @return {boolean} result
 */ $f406636b535430a7$var$echartsProto.containPixel = function(finder, value) {
    if (this._disposed) {
        $f406636b535430a7$var$disposedWarning(this.id);
        return;
    }
    var ecModel = this._model;
    var result;
    finder = $d559f43cb9041423$export$95de80076abac814(ecModel, finder);
    $ec279652dd95c27b$export$79b2f7037acddd43(finder, function(models, key) {
        key.indexOf("Models") >= 0 && $ec279652dd95c27b$export$79b2f7037acddd43(models, function(model) {
            var coordSys = model.coordinateSystem;
            if (coordSys && coordSys.containPoint) result |= !!coordSys.containPoint(value);
            else if (key === "seriesModels") {
                var view = this._chartsMap[model.__viewId];
                if (view && view.containPoint) result |= view.containPoint(value, model);
            }
        }, this);
    }, this);
    return !!result;
};
/**
 * Get visual from series or data.
 * @param {string|Object} finder
 *        If string, e.g., 'series', means {seriesIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            dataIndex / dataIndexInside
 *        }
 *        If dataIndex is not specified, series visual will be fetched,
 *        but not data item visual.
 *        If all of seriesIndex, seriesId, seriesName are not specified,
 *        visual will be fetched from first series.
 * @param {string} visualType 'color', 'symbol', 'symbolSize'
 */ $f406636b535430a7$var$echartsProto.getVisual = function(finder, visualType) {
    var ecModel = this._model;
    finder = $d559f43cb9041423$export$95de80076abac814(ecModel, finder, {
        defaultMainType: "series"
    });
    var seriesModel = finder.seriesModel;
    var data = seriesModel.getData();
    var dataIndexInside = finder.hasOwnProperty("dataIndexInside") ? finder.dataIndexInside : finder.hasOwnProperty("dataIndex") ? data.indexOfRawIndex(finder.dataIndex) : null;
    return dataIndexInside != null ? data.getItemVisual(dataIndexInside, visualType) : data.getVisual(visualType);
};
/**
 * Get view of corresponding component model
 * @param  {module:echarts/model/Component} componentModel
 * @return {module:echarts/view/Component}
 */ $f406636b535430a7$var$echartsProto.getViewOfComponentModel = function(componentModel) {
    return this._componentsMap[componentModel.__viewId];
};
/**
 * Get view of corresponding series model
 * @param  {module:echarts/model/Series} seriesModel
 * @return {module:echarts/view/Chart}
 */ $f406636b535430a7$var$echartsProto.getViewOfSeriesModel = function(seriesModel) {
    return this._chartsMap[seriesModel.__viewId];
};
var $f406636b535430a7$var$updateMethods = {
    prepareAndUpdate: function(payload) {
        $f406636b535430a7$var$prepare(this);
        $f406636b535430a7$var$updateMethods.update.call(this, payload);
    },
    /**
   * @param {Object} payload
   * @private
   */ update: function(payload) {
        // console.profile && console.profile('update');
        var ecModel = this._model;
        var api = this._api;
        var zr = this._zr;
        var coordSysMgr = this._coordSysMgr;
        var scheduler = this._scheduler; // update before setOption
        if (!ecModel) return;
        scheduler.restoreData(ecModel, payload);
        scheduler.performSeriesTasks(ecModel); // TODO
        // Save total ecModel here for undo/redo (after restoring data and before processing data).
        // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
        // Create new coordinate system each update
        // In LineView may save the old coordinate system and use it to get the orignal point
        coordSysMgr.create(ecModel, api);
        scheduler.performDataProcessorTasks(ecModel, payload); // Current stream render is not supported in data process. So we can update
        // stream modes after data processing, where the filtered data is used to
        // deteming whether use progressive rendering.
        $f406636b535430a7$var$updateStreamModes(this, ecModel); // We update stream modes before coordinate system updated, then the modes info
        // can be fetched when coord sys updating (consider the barGrid extent fix). But
        // the drawback is the full coord info can not be fetched. Fortunately this full
        // coord is not requied in stream mode updater currently.
        coordSysMgr.update(ecModel, api);
        $f406636b535430a7$var$clearColorPalette(ecModel);
        scheduler.performVisualTasks(ecModel, payload);
        $f406636b535430a7$var$render(this, ecModel, api, payload); // Set background
        var backgroundColor = ecModel.get("backgroundColor") || "transparent"; // In IE8
        if (!$27ac1413ecc67076$exports.canvasSupported) {
            var colorArr = $b1179c91b052e827$export$98e6a39c04603d36(backgroundColor);
            backgroundColor = $b1179c91b052e827$export$fac44ee5b035f737(colorArr, "rgb");
            if (colorArr[3] === 0) backgroundColor = "transparent";
        } else zr.setBackgroundColor(backgroundColor);
        $f406636b535430a7$var$performPostUpdateFuncs(ecModel, api); // console.profile && console.profileEnd('update');
    },
    /**
   * @param {Object} payload
   * @private
   */ updateTransform: function(payload) {
        var ecModel = this._model;
        var ecIns = this;
        var api = this._api; // update before setOption
        if (!ecModel) return;
         // ChartView.markUpdateMethod(payload, 'updateTransform');
        var componentDirtyList = [];
        ecModel.eachComponent(function(componentType, componentModel) {
            var componentView = ecIns.getViewOfComponentModel(componentModel);
            if (componentView && componentView.__alive) {
                if (componentView.updateTransform) {
                    var result = componentView.updateTransform(componentModel, ecModel, api, payload);
                    result && result.update && componentDirtyList.push(componentView);
                } else componentDirtyList.push(componentView);
            }
        });
        var seriesDirtyMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4();
        ecModel.eachSeries(function(seriesModel) {
            var chartView = ecIns._chartsMap[seriesModel.__viewId];
            if (chartView.updateTransform) {
                var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
                result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
            } else seriesDirtyMap.set(seriesModel.uid, 1);
        });
        $f406636b535430a7$var$clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
        // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
        this._scheduler.performVisualTasks(ecModel, payload, {
            setDirty: true,
            dirtyMap: seriesDirtyMap
        }); // Currently, not call render of components. Geo render cost a lot.
        // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
        $f406636b535430a7$var$renderSeries(ecIns, ecModel, api, payload, seriesDirtyMap);
        $f406636b535430a7$var$performPostUpdateFuncs(ecModel, this._api);
    },
    /**
   * @param {Object} payload
   * @private
   */ updateView: function(payload) {
        var ecModel = this._model; // update before setOption
        if (!ecModel) return;
        $6448f0aa5ca2bdaa$exports.markUpdateMethod(payload, "updateView");
        $f406636b535430a7$var$clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
        this._scheduler.performVisualTasks(ecModel, payload, {
            setDirty: true
        });
        $f406636b535430a7$var$render(this, this._model, this._api, payload);
        $f406636b535430a7$var$performPostUpdateFuncs(ecModel, this._api);
    },
    /**
   * @param {Object} payload
   * @private
   */ updateVisual: function(payload) {
        $f406636b535430a7$var$updateMethods.update.call(this, payload); // var ecModel = this._model;
    // // update before setOption
    // if (!ecModel) {
    //     return;
    // }
    // ChartView.markUpdateMethod(payload, 'updateVisual');
    // clearColorPalette(ecModel);
    // // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
    // this._scheduler.performVisualTasks(ecModel, payload, {visualType: 'visual', setDirty: true});
    // render(this, this._model, this._api, payload);
    // performPostUpdateFuncs(ecModel, this._api);
    },
    /**
   * @param {Object} payload
   * @private
   */ updateLayout: function(payload) {
        $f406636b535430a7$var$updateMethods.update.call(this, payload); // var ecModel = this._model;
    // // update before setOption
    // if (!ecModel) {
    //     return;
    // }
    // ChartView.markUpdateMethod(payload, 'updateLayout');
    // // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
    // // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
    // this._scheduler.performVisualTasks(ecModel, payload, {setDirty: true});
    // render(this, this._model, this._api, payload);
    // performPostUpdateFuncs(ecModel, this._api);
    }
};
function $f406636b535430a7$var$prepare(ecIns) {
    var ecModel = ecIns._model;
    var scheduler = ecIns._scheduler;
    scheduler.restorePipelines(ecModel);
    scheduler.prepareStageTasks();
    $f406636b535430a7$var$prepareView(ecIns, "component", ecModel, scheduler);
    $f406636b535430a7$var$prepareView(ecIns, "chart", ecModel, scheduler);
    scheduler.plan();
}
/**
 * @private
 */ function $f406636b535430a7$var$updateDirectly(ecIns, method, payload, mainType, subType) {
    var ecModel = ecIns._model; // broadcast
    if (!mainType) {
        // FIXME
        // Chart will not be update directly here, except set dirty.
        // But there is no such scenario now.
        $f406636b535430a7$var$each(ecIns._componentsViews.concat(ecIns._chartsViews), callView);
        return;
    }
    var query = {};
    query[mainType + "Id"] = payload[mainType + "Id"];
    query[mainType + "Index"] = payload[mainType + "Index"];
    query[mainType + "Name"] = payload[mainType + "Name"];
    var condition = {
        mainType: mainType,
        query: query
    };
    subType && (condition.subType = subType); // subType may be '' by parseClassType;
    var excludeSeriesId = payload.excludeSeriesId;
    if (excludeSeriesId != null) excludeSeriesId = $ec279652dd95c27b$export$55f8aa7ef875b0a4($d559f43cb9041423$export$4f07b212a02c8051(excludeSeriesId));
     // If dispatchAction before setOption, do nothing.
    ecModel && ecModel.eachComponent(condition, function(model) {
        if (!excludeSeriesId || excludeSeriesId.get(model.id) == null) callView(ecIns[mainType === "series" ? "_chartsMap" : "_componentsMap"][model.__viewId]);
    }, ecIns);
    function callView(view) {
        view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
    }
}
/**
 * Resize the chart
 * @param {Object} opts
 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
 * @param {boolean} [opts.silent=false]
 */ $f406636b535430a7$var$echartsProto.resize = function(opts) {
    if (this._disposed) {
        $f406636b535430a7$var$disposedWarning(this.id);
        return;
    }
    this._zr.resize(opts);
    var ecModel = this._model; // Resize loading effect
    this._loadingFX && this._loadingFX.resize();
    if (!ecModel) return;
    var optionChanged = ecModel.resetOption("media");
    var silent = opts && opts.silent;
    this[$f406636b535430a7$var$IN_MAIN_PROCESS] = true;
    optionChanged && $f406636b535430a7$var$prepare(this);
    $f406636b535430a7$var$updateMethods.update.call(this);
    this[$f406636b535430a7$var$IN_MAIN_PROCESS] = false;
    $f406636b535430a7$var$flushPendingActions.call(this, silent);
    $f406636b535430a7$var$triggerUpdatedEvent.call(this, silent);
};
function $f406636b535430a7$var$updateStreamModes(ecIns, ecModel) {
    var chartsMap = ecIns._chartsMap;
    var scheduler = ecIns._scheduler;
    ecModel.eachSeries(function(seriesModel) {
        scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
    });
}
/**
 * Show loading effect
 * @param  {string} [name='default']
 * @param  {Object} [cfg]
 */ $f406636b535430a7$var$echartsProto.showLoading = function(name, cfg) {
    if (this._disposed) {
        $f406636b535430a7$var$disposedWarning(this.id);
        return;
    }
    if ($f406636b535430a7$var$isObject(name)) {
        cfg = name;
        name = "";
    }
    name = name || "default";
    this.hideLoading();
    if (!$f406636b535430a7$var$loadingEffects[name]) return;
    var el = $f406636b535430a7$var$loadingEffects[name](this._api, cfg);
    var zr = this._zr;
    this._loadingFX = el;
    zr.add(el);
};
/**
 * Hide loading effect
 */ $f406636b535430a7$var$echartsProto.hideLoading = function() {
    if (this._disposed) {
        $f406636b535430a7$var$disposedWarning(this.id);
        return;
    }
    this._loadingFX && this._zr.remove(this._loadingFX);
    this._loadingFX = null;
};
/**
 * @param {Object} eventObj
 * @return {Object}
 */ $f406636b535430a7$var$echartsProto.makeActionFromEvent = function(eventObj) {
    var payload = $ec279652dd95c27b$export$8b58be045bf06082({}, eventObj);
    payload.type = $f406636b535430a7$var$eventActionMap[eventObj.type];
    return payload;
};
/**
 * @pubilc
 * @param {Object} payload
 * @param {string} [payload.type] Action type
 * @param {Object|boolean} [opt] If pass boolean, means opt.silent
 * @param {boolean} [opt.silent=false] Whether trigger events.
 * @param {boolean} [opt.flush=undefined]
 *                  true: Flush immediately, and then pixel in canvas can be fetched
 *                      immediately. Caution: it might affect performance.
 *                  false: Not flush.
 *                  undefined: Auto decide whether perform flush.
 */ $f406636b535430a7$var$echartsProto.dispatchAction = function(payload, opt) {
    if (this._disposed) {
        $f406636b535430a7$var$disposedWarning(this.id);
        return;
    }
    if (!$f406636b535430a7$var$isObject(opt)) opt = {
        silent: !!opt
    };
    if (!$f406636b535430a7$var$actions[payload.type]) return;
     // Avoid dispatch action before setOption. Especially in `connect`.
    if (!this._model) return;
     // May dispatchAction in rendering procedure
    if (this[$f406636b535430a7$var$IN_MAIN_PROCESS]) {
        this._pendingActions.push(payload);
        return;
    }
    $f406636b535430a7$var$doDispatchAction.call(this, payload, opt.silent);
    if (opt.flush) this._zr.flush(true);
    else if (opt.flush !== false && $27ac1413ecc67076$exports.browser.weChat) // In WeChat embeded browser, `requestAnimationFrame` and `setInterval`
    // hang when sliding page (on touch event), which cause that zr does not
    // refresh util user interaction finished, which is not expected.
    // But `dispatchAction` may be called too frequently when pan on touch
    // screen, which impacts performance if do not throttle them.
    this._throttledZrFlush();
    $f406636b535430a7$var$flushPendingActions.call(this, opt.silent);
    $f406636b535430a7$var$triggerUpdatedEvent.call(this, opt.silent);
};
function $f406636b535430a7$var$doDispatchAction(payload, silent) {
    var payloadType = payload.type;
    var escapeConnect = payload.escapeConnect;
    var actionWrap = $f406636b535430a7$var$actions[payloadType];
    var actionInfo = actionWrap.actionInfo;
    var cptType = (actionInfo.update || "update").split(":");
    var updateMethod = cptType.pop();
    cptType = cptType[0] != null && $f406636b535430a7$var$parseClassType(cptType[0]);
    this[$f406636b535430a7$var$IN_MAIN_PROCESS] = true;
    var payloads = [
        payload
    ];
    var batched = false; // Batch action
    if (payload.batch) {
        batched = true;
        payloads = $ec279652dd95c27b$export$871de8747c9eaa88(payload.batch, function(item) {
            item = $ec279652dd95c27b$export$ebe90cb607ad99e($ec279652dd95c27b$export$8b58be045bf06082({}, item), payload);
            item.batch = null;
            return item;
        });
    }
    var eventObjBatch = [];
    var eventObj;
    var isHighDown = payloadType === "highlight" || payloadType === "downplay";
    $f406636b535430a7$var$each(payloads, function(batchItem) {
        // Action can specify the event by return it.
        eventObj = actionWrap.action(batchItem, this._model, this._api); // Emit event outside
        eventObj = eventObj || $ec279652dd95c27b$export$8b58be045bf06082({}, batchItem); // Convert type to eventType
        eventObj.type = actionInfo.event || eventObj.type;
        eventObjBatch.push(eventObj); // light update does not perform data process, layout and visual.
        if (isHighDown) // method, payload, mainType, subType
        $f406636b535430a7$var$updateDirectly(this, updateMethod, batchItem, "series");
        else if (cptType) $f406636b535430a7$var$updateDirectly(this, updateMethod, batchItem, cptType.main, cptType.sub);
    }, this);
    if (updateMethod !== "none" && !isHighDown && !cptType) {
        // Still dirty
        if (this[$f406636b535430a7$var$OPTION_UPDATED]) {
            // FIXME Pass payload ?
            $f406636b535430a7$var$prepare(this);
            $f406636b535430a7$var$updateMethods.update.call(this, payload);
            this[$f406636b535430a7$var$OPTION_UPDATED] = false;
        } else $f406636b535430a7$var$updateMethods[updateMethod].call(this, payload);
    } // Follow the rule of action batch
    if (batched) eventObj = {
        type: actionInfo.event || payloadType,
        escapeConnect: escapeConnect,
        batch: eventObjBatch
    };
    else eventObj = eventObjBatch[0];
    this[$f406636b535430a7$var$IN_MAIN_PROCESS] = false;
    !silent && this._messageCenter.trigger(eventObj.type, eventObj);
}
function $f406636b535430a7$var$flushPendingActions(silent) {
    var pendingActions = this._pendingActions;
    while(pendingActions.length){
        var payload = pendingActions.shift();
        $f406636b535430a7$var$doDispatchAction.call(this, payload, silent);
    }
}
function $f406636b535430a7$var$triggerUpdatedEvent(silent) {
    !silent && this.trigger("updated");
}
/**
 * Event `rendered` is triggered when zr
 * rendered. It is useful for realtime
 * snapshot (reflect animation).
 *
 * Event `finished` is triggered when:
 * (1) zrender rendering finished.
 * (2) initial animation finished.
 * (3) progressive rendering finished.
 * (4) no pending action.
 * (5) no delayed setOption needs to be processed.
 */ function $f406636b535430a7$var$bindRenderedEvent(zr, ecIns) {
    zr.on("rendered", function() {
        ecIns.trigger("rendered"); // The `finished` event should not be triggered repeatly,
        // so it should only be triggered when rendering indeed happend
        // in zrender. (Consider the case that dipatchAction is keep
        // triggering when mouse move).
        if (// and this checking is called on frame, we also check
        // animation finished for robustness.
        zr.animation.isFinished() && !ecIns[$f406636b535430a7$var$OPTION_UPDATED] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) ecIns.trigger("finished");
    });
}
/**
 * @param {Object} params
 * @param {number} params.seriesIndex
 * @param {Array|TypedArray} params.data
 */ $f406636b535430a7$var$echartsProto.appendData = function(params) {
    if (this._disposed) {
        $f406636b535430a7$var$disposedWarning(this.id);
        return;
    }
    var seriesIndex = params.seriesIndex;
    var ecModel = this.getModel();
    var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
    seriesModel.appendData(params); // Note: `appendData` does not support that update extent of coordinate
    // system, util some scenario require that. In the expected usage of
    // `appendData`, the initial extent of coordinate system should better
    // be fixed by axis `min`/`max` setting or initial data, otherwise if
    // the extent changed while `appendData`, the location of the painted
    // graphic elements have to be changed, which make the usage of
    // `appendData` meaningless.
    this._scheduler.unfinished = true;
};
/**
 * Register event
 * @method
 */ $f406636b535430a7$var$echartsProto.on = $f406636b535430a7$var$createRegisterEventWithLowercaseName("on", false);
$f406636b535430a7$var$echartsProto.off = $f406636b535430a7$var$createRegisterEventWithLowercaseName("off", false);
$f406636b535430a7$var$echartsProto.one = $f406636b535430a7$var$createRegisterEventWithLowercaseName("one", false);
/**
 * Prepare view instances of charts and components
 * @param  {module:echarts/model/Global} ecModel
 * @private
 */ function $f406636b535430a7$var$prepareView(ecIns, type, ecModel, scheduler) {
    var isComponent = type === "component";
    var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
    var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
    var zr = ecIns._zr;
    var api = ecIns._api;
    for(var i = 0; i < viewList.length; i++)viewList[i].__alive = false;
    isComponent ? ecModel.eachComponent(function(componentType, model) {
        componentType !== "series" && doPrepare(model);
    }) : ecModel.eachSeries(doPrepare);
    function doPrepare(model) {
        // Consider: id same and type changed.
        var viewId = "_ec_" + model.id + "_" + model.type;
        var view = viewMap[viewId];
        if (!view) {
            var classType = $f406636b535430a7$var$parseClassType(model.type);
            var Clazz = isComponent ? $9c7fc7c628500365$exports.getClass(classType.main, classType.sub) : $6448f0aa5ca2bdaa$exports.getClass(classType.sub);
            view = new Clazz();
            view.init(ecModel, api);
            viewMap[viewId] = view;
            viewList.push(view);
            zr.add(view.group);
        }
        model.__viewId = view.__id = viewId;
        view.__alive = true;
        view.__model = model;
        view.group.__ecComponentInfo = {
            mainType: model.mainType,
            index: model.componentIndex
        };
        !isComponent && scheduler.prepareView(view, model, ecModel, api);
    }
    for(var i = 0; i < viewList.length;){
        var view = viewList[i];
        if (!view.__alive) {
            !isComponent && view.renderTask.dispose();
            zr.remove(view.group);
            view.dispose(ecModel, api);
            viewList.splice(i, 1);
            delete viewMap[view.__id];
            view.__id = view.group.__ecComponentInfo = null;
        } else i++;
    }
} // /**
//  * Encode visual infomation from data after data processing
//  *
//  * @param {module:echarts/model/Global} ecModel
//  * @param {object} layout
//  * @param {boolean} [layoutFilter] `true`: only layout,
//  *                                 `false`: only not layout,
//  *                                 `null`/`undefined`: all.
//  * @param {string} taskBaseTag
//  * @private
//  */
// function startVisualEncoding(ecIns, ecModel, api, payload, layoutFilter) {
//     each(visualFuncs, function (visual, index) {
//         var isLayout = visual.isLayout;
//         if (layoutFilter == null
//             || (layoutFilter === false && !isLayout)
//             || (layoutFilter === true && isLayout)
//         ) {
//             visual.func(ecModel, api, payload);
//         }
//     });
// }
function $f406636b535430a7$var$clearColorPalette(ecModel) {
    ecModel.clearColorPalette();
    ecModel.eachSeries(function(seriesModel) {
        seriesModel.clearColorPalette();
    });
}
function $f406636b535430a7$var$render(ecIns, ecModel, api, payload) {
    $f406636b535430a7$var$renderComponents(ecIns, ecModel, api, payload);
    $f406636b535430a7$var$each(ecIns._chartsViews, function(chart) {
        chart.__alive = false;
    });
    $f406636b535430a7$var$renderSeries(ecIns, ecModel, api, payload); // Remove groups of unrendered charts
    $f406636b535430a7$var$each(ecIns._chartsViews, function(chart) {
        if (!chart.__alive) chart.remove(ecModel, api);
    });
}
function $f406636b535430a7$var$renderComponents(ecIns, ecModel, api, payload, dirtyList) {
    $f406636b535430a7$var$each(dirtyList || ecIns._componentsViews, function(componentView) {
        var componentModel = componentView.__model;
        componentView.render(componentModel, ecModel, api, payload);
        $f406636b535430a7$var$updateZ(componentModel, componentView);
    });
}
/**
 * Render each chart and component
 * @private
 */ function $f406636b535430a7$var$renderSeries(ecIns, ecModel, api, payload, dirtyMap) {
    // Render all charts
    var scheduler = ecIns._scheduler;
    var unfinished;
    ecModel.eachSeries(function(seriesModel) {
        var chartView = ecIns._chartsMap[seriesModel.__viewId];
        chartView.__alive = true;
        var renderTask = chartView.renderTask;
        scheduler.updatePayload(renderTask, payload);
        if (dirtyMap && dirtyMap.get(seriesModel.uid)) renderTask.dirty();
        unfinished |= renderTask.perform(scheduler.getPerformArgs(renderTask));
        chartView.group.silent = !!seriesModel.get("silent");
        $f406636b535430a7$var$updateZ(seriesModel, chartView);
        $f406636b535430a7$var$updateBlend(seriesModel, chartView);
    });
    scheduler.unfinished |= unfinished; // If use hover layer
    $f406636b535430a7$var$updateHoverLayerStatus(ecIns, ecModel); // Add aria
    $1fcc208ab978e042$exports(ecIns._zr.dom, ecModel);
}
function $f406636b535430a7$var$performPostUpdateFuncs(ecModel, api) {
    $f406636b535430a7$var$each($f406636b535430a7$var$postUpdateFuncs, function(func) {
        func(ecModel, api);
    });
}
var $f406636b535430a7$var$MOUSE_EVENT_NAMES = [
    "click",
    "dblclick",
    "mouseover",
    "mouseout",
    "mousemove",
    "mousedown",
    "mouseup",
    "globalout",
    "contextmenu"
];
/**
 * @private
 */ $f406636b535430a7$var$echartsProto._initEvents = function() {
    $f406636b535430a7$var$each($f406636b535430a7$var$MOUSE_EVENT_NAMES, function(eveName) {
        var handler = function(e) {
            var ecModel = this.getModel();
            var el = e.target;
            var params;
            var isGlobalOut = eveName === "globalout"; // no e.target when 'globalout'.
            if (isGlobalOut) params = {};
            else if (el && el.dataIndex != null) {
                var dataModel = el.dataModel || ecModel.getSeriesByIndex(el.seriesIndex);
                params = dataModel && dataModel.getDataParams(el.dataIndex, el.dataType, el) || {};
            } else if (el && el.eventData) params = $ec279652dd95c27b$export$8b58be045bf06082({}, el.eventData);
             // Contract: if params prepared in mouse event,
            // these properties must be specified:
            // {
            //    componentType: string (component main type)
            //    componentIndex: number
            // }
            // Otherwise event query can not work.
            if (params) {
                var componentType = params.componentType;
                var componentIndex = params.componentIndex; // Special handling for historic reason: when trigger by
                // markLine/markPoint/markArea, the componentType is
                // 'markLine'/'markPoint'/'markArea', but we should better
                // enable them to be queried by seriesIndex, since their
                // option is set in each series.
                if (componentType === "markLine" || componentType === "markPoint" || componentType === "markArea") {
                    componentType = "series";
                    componentIndex = params.seriesIndex;
                }
                var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
                var view = model && this[model.mainType === "series" ? "_chartsMap" : "_componentsMap"][model.__viewId];
                params.event = e;
                params.type = eveName;
                this._ecEventProcessor.eventInfo = {
                    targetEl: el,
                    packedEvent: params,
                    model: model,
                    view: view
                };
                this.trigger(eveName, params);
            }
        }; // Consider that some component (like tooltip, brush, ...)
        // register zr event handler, but user event handler might
        // do anything, such as call `setOption` or `dispatchAction`,
        // which probably update any of the content and probably
        // cause problem if it is called previous other inner handlers.
        handler.zrEventfulCallAtLast = true;
        this._zr.on(eveName, handler, this);
    }, this);
    $f406636b535430a7$var$each($f406636b535430a7$var$eventActionMap, function(actionType, eventType) {
        this._messageCenter.on(eventType, function(event) {
            this.trigger(eventType, event);
        }, this);
    }, this);
};
/**
 * @return {boolean}
 */ $f406636b535430a7$var$echartsProto.isDisposed = function() {
    return this._disposed;
};
/**
 * Clear
 */ $f406636b535430a7$var$echartsProto.clear = function() {
    if (this._disposed) {
        $f406636b535430a7$var$disposedWarning(this.id);
        return;
    }
    this.setOption({
        series: []
    }, true);
};
/**
 * Dispose instance
 */ $f406636b535430a7$var$echartsProto.dispose = function() {
    if (this._disposed) {
        $f406636b535430a7$var$disposedWarning(this.id);
        return;
    }
    this._disposed = true;
    $d559f43cb9041423$export$9fec4d97f1922e0b(this.getDom(), $f406636b535430a7$var$DOM_ATTRIBUTE_KEY, "");
    var api = this._api;
    var ecModel = this._model;
    $f406636b535430a7$var$each(this._componentsViews, function(component) {
        component.dispose(ecModel, api);
    });
    $f406636b535430a7$var$each(this._chartsViews, function(chart) {
        chart.dispose(ecModel, api);
    }); // Dispose after all views disposed
    this._zr.dispose();
    delete $f406636b535430a7$var$instances[this.id];
};
$ec279652dd95c27b$export$e36fc9d62a853069($f406636b535430a7$var$ECharts, $b7a44647f5b5bfa5$exports);
function $f406636b535430a7$var$disposedWarning(id) {}
function $f406636b535430a7$var$updateHoverLayerStatus(ecIns, ecModel) {
    var zr = ecIns._zr;
    var storage = zr.storage;
    var elCount = 0;
    storage.traverse(function(el) {
        elCount++;
    });
    if (elCount > ecModel.get("hoverLayerThreshold") && !$27ac1413ecc67076$exports.node) ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.preventUsingHoverLayer) return;
        var chartView = ecIns._chartsMap[seriesModel.__viewId];
        if (chartView.__alive) chartView.group.traverse(function(el) {
            // Don't switch back.
            el.useHoverLayer = true;
        });
    });
}
/**
 * Update chart progressive and blend.
 * @param {module:echarts/model/Series|module:echarts/model/Component} model
 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
 */ function $f406636b535430a7$var$updateBlend(seriesModel, chartView) {
    var blendMode = seriesModel.get("blendMode") || null;
    chartView.group.traverse(function(el) {
        // FIXME marker and other components
        if (!el.isGroup) // Only set if blendMode is changed. In case element is incremental and don't wan't to rerender.
        {
            if (el.style.blend !== blendMode) el.setStyle("blend", blendMode);
        }
        if (el.eachPendingDisplayable) el.eachPendingDisplayable(function(displayable) {
            displayable.setStyle("blend", blendMode);
        });
    });
}
/**
 * @param {module:echarts/model/Series|module:echarts/model/Component} model
 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
 */ function $f406636b535430a7$var$updateZ(model, view) {
    var z = model.get("z");
    var zlevel = model.get("zlevel"); // Set z and zlevel
    view.group.traverse(function(el) {
        if (el.type !== "group") {
            z != null && (el.z = z);
            zlevel != null && (el.zlevel = zlevel);
        }
    });
}
function $f406636b535430a7$var$createExtensionAPI(ecInstance) {
    var coordSysMgr = ecInstance._coordSysMgr;
    return $ec279652dd95c27b$export$8b58be045bf06082(new $c4d7ef2132c5793c$exports(ecInstance), {
        // Inject methods
        getCoordinateSystems: $ec279652dd95c27b$export$2385a24977818dd0(coordSysMgr.getCoordinateSystems, coordSysMgr),
        getComponentByElement: function(el) {
            while(el){
                var modelInfo = el.__ecComponentInfo;
                if (modelInfo != null) return ecInstance._model.getComponent(modelInfo.mainType, modelInfo.index);
                el = el.parent;
            }
        }
    });
}
/**
 * @class
 * Usage of query:
 * `chart.on('click', query, handler);`
 * The `query` can be:
 * + The component type query string, only `mainType` or `mainType.subType`,
 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
 * + The component query object, like:
 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
 * + The data query object, like:
 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
 * + The other query object (cmponent customized query), like:
 *   `{element: 'some'}` (only available in custom series).
 *
 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
 * same as there is no such prop in the `query` object.
 */ function $f406636b535430a7$var$EventProcessor() {
    // These info required: targetEl, packedEvent, model, view
    this.eventInfo;
}
$f406636b535430a7$var$EventProcessor.prototype = {
    constructor: $f406636b535430a7$var$EventProcessor,
    normalizeQuery: function(query) {
        var cptQuery = {};
        var dataQuery = {};
        var otherQuery = {}; // `query` is `mainType` or `mainType.subType` of component.
        if ($ec279652dd95c27b$export$844ec244b1367d54(query)) {
            var condCptType = $f406636b535430a7$var$parseClassType(query); // `.main` and `.sub` may be ''.
            cptQuery.mainType = condCptType.main || null;
            cptQuery.subType = condCptType.sub || null;
        } else {
            // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
            // can not be used in `compomentModel.filterForExposedEvent`.
            var suffixes = [
                "Index",
                "Name",
                "Id"
            ];
            var dataKeys = {
                name: 1,
                dataIndex: 1,
                dataType: 1
            };
            $ec279652dd95c27b$export$79b2f7037acddd43(query, function(val, key) {
                var reserved = false;
                for(var i = 0; i < suffixes.length; i++){
                    var propSuffix = suffixes[i];
                    var suffixPos = key.lastIndexOf(propSuffix);
                    if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
                        var mainType = key.slice(0, suffixPos); // Consider `dataIndex`.
                        if (mainType !== "data") {
                            cptQuery.mainType = mainType;
                            cptQuery[propSuffix.toLowerCase()] = val;
                            reserved = true;
                        }
                    }
                }
                if (dataKeys.hasOwnProperty(key)) {
                    dataQuery[key] = val;
                    reserved = true;
                }
                if (!reserved) otherQuery[key] = val;
            });
        }
        return {
            cptQuery: cptQuery,
            dataQuery: dataQuery,
            otherQuery: otherQuery
        };
    },
    filter: function(eventType, query, args) {
        // They should be assigned before each trigger call.
        var eventInfo = this.eventInfo;
        if (!eventInfo) return true;
        var targetEl = eventInfo.targetEl;
        var packedEvent = eventInfo.packedEvent;
        var model = eventInfo.model;
        var view = eventInfo.view; // For event like 'globalout'.
        if (!model || !view) return true;
        var cptQuery = query.cptQuery;
        var dataQuery = query.dataQuery;
        return check(cptQuery, model, "mainType") && check(cptQuery, model, "subType") && check(cptQuery, model, "index", "componentIndex") && check(cptQuery, model, "name") && check(cptQuery, model, "id") && check(dataQuery, packedEvent, "name") && check(dataQuery, packedEvent, "dataIndex") && check(dataQuery, packedEvent, "dataType") && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
        function check(query, host, prop, propOnHost) {
            return query[prop] == null || host[propOnHost || prop] === query[prop];
        }
    },
    afterTrigger: function() {
        // Make sure the eventInfo wont be used in next trigger.
        this.eventInfo = null;
    }
};
/**
 * @type {Object} key: actionType.
 * @inner
 */ var $f406636b535430a7$var$actions = {};
/**
 * Map eventType to actionType
 * @type {Object}
 */ var $f406636b535430a7$var$eventActionMap = {};
/**
 * Data processor functions of each stage
 * @type {Array.<Object.<string, Function>>}
 * @inner
 */ var $f406636b535430a7$var$dataProcessorFuncs = [];
/**
 * @type {Array.<Function>}
 * @inner
 */ var $f406636b535430a7$var$optionPreprocessorFuncs = [];
/**
 * @type {Array.<Function>}
 * @inner
 */ var $f406636b535430a7$var$postUpdateFuncs = [];
/**
 * Visual encoding functions of each stage
 * @type {Array.<Object.<string, Function>>}
 */ var $f406636b535430a7$var$visualFuncs = [];
/**
 * Theme storage
 * @type {Object.<key, Object>}
 */ var $f406636b535430a7$var$themeStorage = {};
/**
 * Loading effects
 */ var $f406636b535430a7$var$loadingEffects = {};
var $f406636b535430a7$var$instances = {};
var $f406636b535430a7$var$connectedGroups = {};
var $f406636b535430a7$var$idBase = new Date() - 0;
var $f406636b535430a7$var$groupIdBase = new Date() - 0;
var $f406636b535430a7$var$DOM_ATTRIBUTE_KEY = "_echarts_instance_";
function $f406636b535430a7$var$enableConnect(chart) {
    var STATUS_PENDING = 0;
    var STATUS_UPDATING = 1;
    var STATUS_UPDATED = 2;
    var STATUS_KEY = "__connectUpdateStatus";
    function updateConnectedChartsStatus(charts, status) {
        for(var i = 0; i < charts.length; i++){
            var otherChart = charts[i];
            otherChart[STATUS_KEY] = status;
        }
    }
    $f406636b535430a7$var$each($f406636b535430a7$var$eventActionMap, function(actionType, eventType) {
        chart._messageCenter.on(eventType, function(event) {
            if ($f406636b535430a7$var$connectedGroups[chart.group] && chart[STATUS_KEY] !== STATUS_PENDING) {
                if (event && event.escapeConnect) return;
                var action = chart.makeActionFromEvent(event);
                var otherCharts = [];
                $f406636b535430a7$var$each($f406636b535430a7$var$instances, function(otherChart) {
                    if (otherChart !== chart && otherChart.group === chart.group) otherCharts.push(otherChart);
                });
                updateConnectedChartsStatus(otherCharts, STATUS_PENDING);
                $f406636b535430a7$var$each(otherCharts, function(otherChart) {
                    if (otherChart[STATUS_KEY] !== STATUS_UPDATING) otherChart.dispatchAction(action);
                });
                updateConnectedChartsStatus(otherCharts, STATUS_UPDATED);
            }
        });
    });
}
/**
 * @param {HTMLElement} dom
 * @param {Object} [theme]
 * @param {Object} opts
 * @param {number} [opts.devicePixelRatio] Use window.devicePixelRatio by default
 * @param {string} [opts.renderer] Can choose 'canvas' or 'svg' to render the chart.
 * @param {number} [opts.width] Use clientWidth of the input `dom` by default.
 *                              Can be 'auto' (the same as null/undefined)
 * @param {number} [opts.height] Use clientHeight of the input `dom` by default.
 *                               Can be 'auto' (the same as null/undefined)
 */ function $f406636b535430a7$var$init(dom, theme, opts) {
    var existInstance = $f406636b535430a7$var$getInstanceByDom(dom);
    if (existInstance) return existInstance;
    var chart = new $f406636b535430a7$var$ECharts(dom, theme, opts);
    chart.id = "ec_" + $f406636b535430a7$var$idBase++;
    $f406636b535430a7$var$instances[chart.id] = chart;
    $d559f43cb9041423$export$9fec4d97f1922e0b(dom, $f406636b535430a7$var$DOM_ATTRIBUTE_KEY, chart.id);
    $f406636b535430a7$var$enableConnect(chart);
    return chart;
}
/**
 * @return {string|Array.<module:echarts~ECharts>} groupId
 */ function $f406636b535430a7$var$connect(groupId) {
    // Is array of charts
    if ($ec279652dd95c27b$export$43bee75e5e14138e(groupId)) {
        var charts = groupId;
        groupId = null; // If any chart has group
        $f406636b535430a7$var$each(charts, function(chart) {
            if (chart.group != null) groupId = chart.group;
        });
        groupId = groupId || "g_" + $f406636b535430a7$var$groupIdBase++;
        $f406636b535430a7$var$each(charts, function(chart) {
            chart.group = groupId;
        });
    }
    $f406636b535430a7$var$connectedGroups[groupId] = true;
    return groupId;
}
/**
 * @DEPRECATED
 * @return {string} groupId
 */ function $f406636b535430a7$var$disConnect(groupId) {
    $f406636b535430a7$var$connectedGroups[groupId] = false;
}
/**
 * @return {string} groupId
 */ var $f406636b535430a7$var$disconnect = $f406636b535430a7$var$disConnect;
/**
 * Dispose a chart instance
 * @param  {module:echarts~ECharts|HTMLDomElement|string} chart
 */ function $f406636b535430a7$var$dispose(chart) {
    if (typeof chart === "string") chart = $f406636b535430a7$var$instances[chart];
    else if (!(chart instanceof $f406636b535430a7$var$ECharts)) // Try to treat as dom
    chart = $f406636b535430a7$var$getInstanceByDom(chart);
    if (chart instanceof $f406636b535430a7$var$ECharts && !chart.isDisposed()) chart.dispose();
}
/**
 * @param  {HTMLElement} dom
 * @return {echarts~ECharts}
 */ function $f406636b535430a7$var$getInstanceByDom(dom) {
    return $f406636b535430a7$var$instances[$d559f43cb9041423$export$735ee1799fd02602(dom, $f406636b535430a7$var$DOM_ATTRIBUTE_KEY)];
}
/**
 * @param {string} key
 * @return {echarts~ECharts}
 */ function $f406636b535430a7$var$getInstanceById(key) {
    return $f406636b535430a7$var$instances[key];
}
/**
 * Register theme
 */ function $f406636b535430a7$var$registerTheme(name, theme) {
    $f406636b535430a7$var$themeStorage[name] = theme;
}
/**
 * Register option preprocessor
 * @param {Function} preprocessorFunc
 */ function $f406636b535430a7$var$registerPreprocessor(preprocessorFunc) {
    $f406636b535430a7$var$optionPreprocessorFuncs.push(preprocessorFunc);
}
/**
 * @param {number} [priority=1000]
 * @param {Object|Function} processor
 */ function $f406636b535430a7$var$registerProcessor(priority, processor) {
    $f406636b535430a7$var$normalizeRegister($f406636b535430a7$var$dataProcessorFuncs, priority, processor, $f406636b535430a7$var$PRIORITY_PROCESSOR_FILTER);
}
/**
 * Register postUpdater
 * @param {Function} postUpdateFunc
 */ function $f406636b535430a7$var$registerPostUpdate(postUpdateFunc) {
    $f406636b535430a7$var$postUpdateFuncs.push(postUpdateFunc);
}
/**
 * Usage:
 * registerAction('someAction', 'someEvent', function () { ... });
 * registerAction('someAction', function () { ... });
 * registerAction(
 *     {type: 'someAction', event: 'someEvent', update: 'updateView'},
 *     function () { ... }
 * );
 *
 * @param {(string|Object)} actionInfo
 * @param {string} actionInfo.type
 * @param {string} [actionInfo.event]
 * @param {string} [actionInfo.update]
 * @param {string} [eventName]
 * @param {Function} action
 */ function $f406636b535430a7$var$registerAction(actionInfo, eventName, action) {
    if (typeof eventName === "function") {
        action = eventName;
        eventName = "";
    }
    var actionType = $f406636b535430a7$var$isObject(actionInfo) ? actionInfo.type : [
        actionInfo,
        actionInfo = {
            event: eventName
        }
    ][0]; // Event name is all lowercase
    actionInfo.event = (actionInfo.event || actionType).toLowerCase();
    eventName = actionInfo.event; // Validate action type and event name.
    $f406636b535430a7$var$assert($f406636b535430a7$var$ACTION_REG.test(actionType) && $f406636b535430a7$var$ACTION_REG.test(eventName));
    if (!$f406636b535430a7$var$actions[actionType]) $f406636b535430a7$var$actions[actionType] = {
        action: action,
        actionInfo: actionInfo
    };
    $f406636b535430a7$var$eventActionMap[eventName] = actionType;
}
/**
 * @param {string} type
 * @param {*} CoordinateSystem
 */ function $f406636b535430a7$var$registerCoordinateSystem(type, CoordinateSystem) {
    $9c36d0fff3b0f387$exports.register(type, CoordinateSystem);
}
/**
 * Get dimensions of specified coordinate system.
 * @param {string} type
 * @return {Array.<string|Object>}
 */ function $f406636b535430a7$var$getCoordinateSystemDimensions(type) {
    var coordSysCreator = $9c36d0fff3b0f387$exports.get(type);
    if (coordSysCreator) return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
}
/**
 * Layout is a special stage of visual encoding
 * Most visual encoding like color are common for different chart
 * But each chart has it's own layout algorithm
 *
 * @param {number} [priority=1000]
 * @param {Function} layoutTask
 */ function $f406636b535430a7$var$registerLayout(priority, layoutTask) {
    $f406636b535430a7$var$normalizeRegister($f406636b535430a7$var$visualFuncs, priority, layoutTask, $f406636b535430a7$var$PRIORITY_VISUAL_LAYOUT, "layout");
}
/**
 * @param {number} [priority=3000]
 * @param {module:echarts/stream/Task} visualTask
 */ function $f406636b535430a7$var$registerVisual(priority, visualTask) {
    $f406636b535430a7$var$normalizeRegister($f406636b535430a7$var$visualFuncs, priority, visualTask, $f406636b535430a7$var$PRIORITY_VISUAL_CHART, "visual");
}
/**
 * @param {Object|Function} fn: {seriesType, createOnAllSeries, performRawSeries, reset}
 */ function $f406636b535430a7$var$normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
    if ($f406636b535430a7$var$isFunction(priority) || $f406636b535430a7$var$isObject(priority)) {
        fn = priority;
        priority = defaultPriority;
    }
    var stageHandler = $578727d567ffa2bc$exports.wrapStageHandler(fn, visualType);
    stageHandler.__prio = priority;
    stageHandler.__raw = fn;
    targetList.push(stageHandler);
    return stageHandler;
}
/**
 * @param {string} name
 */ function $f406636b535430a7$var$registerLoading(name, loadingFx) {
    $f406636b535430a7$var$loadingEffects[name] = loadingFx;
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */ function $f406636b535430a7$var$extendComponentModel(opts) {
    // var Clazz = ComponentModel;
    // if (superClass) {
    //     var classType = parseClassType(superClass);
    //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
    // }
    return $3b9c2389e45dfb7d$exports.extend(opts);
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */ function $f406636b535430a7$var$extendComponentView(opts) {
    // var Clazz = ComponentView;
    // if (superClass) {
    //     var classType = parseClassType(superClass);
    //     Clazz = ComponentView.getClass(classType.main, classType.sub, true);
    // }
    return $9c7fc7c628500365$exports.extend(opts);
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */ function $f406636b535430a7$var$extendSeriesModel(opts) {
    // var Clazz = SeriesModel;
    // if (superClass) {
    //     superClass = 'series.' + superClass.replace('series.', '');
    //     var classType = parseClassType(superClass);
    //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
    // }
    return $70847df98016d69d$exports.extend(opts);
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */ function $f406636b535430a7$var$extendChartView(opts) {
    // var Clazz = ChartView;
    // if (superClass) {
    //     superClass = superClass.replace('series.', '');
    //     var classType = parseClassType(superClass);
    //     Clazz = ChartView.getClass(classType.main, true);
    // }
    return $6448f0aa5ca2bdaa$exports.extend(opts);
}
/**
 * ZRender need a canvas context to do measureText.
 * But in node environment canvas may be created by node-canvas.
 * So we need to specify how to create a canvas instead of using document.createElement('canvas')
 *
 * Be careful of using it in the browser.
 *
 * @param {Function} creator
 * @example
 *     var Canvas = require('canvas');
 *     var echarts = require('echarts');
 *     echarts.setCanvasCreator(function () {
 *         // Small size is enough.
 *         return new Canvas(32, 32);
 *     });
 */ function $f406636b535430a7$var$setCanvasCreator(creator) {
    $ec279652dd95c27b$export$d35a04b83ea6803e("createCanvas", creator);
}
/**
 * @param {string} mapName
 * @param {Array.<Object>|Object|string} geoJson
 * @param {Object} [specialAreas]
 *
 * @example GeoJSON
 *     $.get('USA.json', function (geoJson) {
 *         echarts.registerMap('USA', geoJson);
 *         // Or
 *         echarts.registerMap('USA', {
 *             geoJson: geoJson,
 *             specialAreas: {}
 *         })
 *     });
 *
 *     $.get('airport.svg', function (svg) {
 *         echarts.registerMap('airport', {
 *             svg: svg
 *         }
 *     });
 *
 *     echarts.registerMap('eu', [
 *         {svg: eu-topographic.svg},
 *         {geoJSON: eu.json}
 *     ])
 */ function $f406636b535430a7$var$registerMap(mapName, geoJson, specialAreas) {
    $cc0f61c9f8527b8d$exports.registerMap(mapName, geoJson, specialAreas);
}
/**
 * @param {string} mapName
 * @return {Object}
 */ function $f406636b535430a7$var$getMap(mapName) {
    // For backward compatibility, only return the first one.
    var records = $cc0f61c9f8527b8d$exports.retrieveMap(mapName);
    return records && records[0] && {
        geoJson: records[0].geoJSON,
        specialAreas: records[0].specialAreas
    };
}
$f406636b535430a7$var$registerVisual($f406636b535430a7$var$PRIORITY_VISUAL_GLOBAL, $dc90ac0b9dfd0eec$exports);
$f406636b535430a7$var$registerPreprocessor($1706c18d3b422369$exports);
$f406636b535430a7$var$registerProcessor($f406636b535430a7$var$PRIORITY_PROCESSOR_DATASTACK, $947eaf1df12e0ddf$exports);
$f406636b535430a7$var$registerLoading("default", $ceb6a16d7f3e4c83$exports); // Default actions
$f406636b535430a7$var$registerAction({
    type: "highlight",
    event: "highlight",
    update: "highlight"
}, $ec279652dd95c27b$export$8793edee2d425525);
$f406636b535430a7$var$registerAction({
    type: "downplay",
    event: "downplay",
    update: "downplay"
}, $ec279652dd95c27b$export$8793edee2d425525); // Default theme
$f406636b535430a7$var$registerTheme("light", $88cc146d2e63406a$exports);
$f406636b535430a7$var$registerTheme("dark", $287a5d0f68383d3f$exports); // For backward compatibility, where the namespace `dataTool` will
// be mounted on `echarts` is the extension `dataTool` is imported.
var $f406636b535430a7$var$dataTool = {};
$f406636b535430a7$exports.version = $f406636b535430a7$var$version;
$f406636b535430a7$exports.dependencies = $f406636b535430a7$var$dependencies;
$f406636b535430a7$exports.PRIORITY = $f406636b535430a7$var$PRIORITY;
$f406636b535430a7$exports.init = $f406636b535430a7$var$init;
$f406636b535430a7$exports.connect = $f406636b535430a7$var$connect;
$f406636b535430a7$exports.disConnect = $f406636b535430a7$var$disConnect;
$f406636b535430a7$exports.disconnect = $f406636b535430a7$var$disconnect;
$f406636b535430a7$exports.dispose = $f406636b535430a7$var$dispose;
$f406636b535430a7$exports.getInstanceByDom = $f406636b535430a7$var$getInstanceByDom;
$f406636b535430a7$exports.getInstanceById = $f406636b535430a7$var$getInstanceById;
$f406636b535430a7$exports.registerTheme = $f406636b535430a7$var$registerTheme;
$f406636b535430a7$exports.registerPreprocessor = $f406636b535430a7$var$registerPreprocessor;
$f406636b535430a7$exports.registerProcessor = $f406636b535430a7$var$registerProcessor;
$f406636b535430a7$exports.registerPostUpdate = $f406636b535430a7$var$registerPostUpdate;
$f406636b535430a7$exports.registerAction = $f406636b535430a7$var$registerAction;
$f406636b535430a7$exports.registerCoordinateSystem = $f406636b535430a7$var$registerCoordinateSystem;
$f406636b535430a7$exports.getCoordinateSystemDimensions = $f406636b535430a7$var$getCoordinateSystemDimensions;
$f406636b535430a7$exports.registerLayout = $f406636b535430a7$var$registerLayout;
$f406636b535430a7$exports.registerVisual = $f406636b535430a7$var$registerVisual;
$f406636b535430a7$exports.registerLoading = $f406636b535430a7$var$registerLoading;
$f406636b535430a7$exports.extendComponentModel = $f406636b535430a7$var$extendComponentModel;
$f406636b535430a7$exports.extendComponentView = $f406636b535430a7$var$extendComponentView;
$f406636b535430a7$exports.extendSeriesModel = $f406636b535430a7$var$extendSeriesModel;
$f406636b535430a7$exports.extendChartView = $f406636b535430a7$var$extendChartView;
$f406636b535430a7$exports.setCanvasCreator = $f406636b535430a7$var$setCanvasCreator;
$f406636b535430a7$exports.registerMap = $f406636b535430a7$var$registerMap;
$f406636b535430a7$exports.getMap = $f406636b535430a7$var$getMap;
$f406636b535430a7$exports.dataTool = $f406636b535430a7$var$dataTool;
var $a5a5f16c8a84146c$exports = {};

$parcel$export($a5a5f16c8a84146c$exports, "zrender", () => $a5a5f16c8a84146c$export$36f18b7b5b28517c, (v) => $a5a5f16c8a84146c$export$36f18b7b5b28517c = v);
$parcel$export($a5a5f16c8a84146c$exports, "matrix", () => $a5a5f16c8a84146c$export$9bdad1ae37d738e0, (v) => $a5a5f16c8a84146c$export$9bdad1ae37d738e0 = v);
$parcel$export($a5a5f16c8a84146c$exports, "vector", () => $a5a5f16c8a84146c$export$6074e20ba5c64bef, (v) => $a5a5f16c8a84146c$export$6074e20ba5c64bef = v);
$parcel$export($a5a5f16c8a84146c$exports, "color", () => $a5a5f16c8a84146c$export$35e9368ef982300f, (v) => $a5a5f16c8a84146c$export$35e9368ef982300f = v);
$parcel$export($a5a5f16c8a84146c$exports, "number", () => $a5a5f16c8a84146c$export$98e628dec113755e, (v) => $a5a5f16c8a84146c$export$98e628dec113755e = v);
$parcel$export($a5a5f16c8a84146c$exports, "format", () => $a5a5f16c8a84146c$export$d9468344d3651243, (v) => $a5a5f16c8a84146c$export$d9468344d3651243 = v);
$parcel$export($a5a5f16c8a84146c$exports, "throttle", () => $a5a5f16c8a84146c$export$de363e709c412c8a, (v) => $a5a5f16c8a84146c$export$de363e709c412c8a = v);
$parcel$export($a5a5f16c8a84146c$exports, "helper", () => $a5a5f16c8a84146c$export$4bbbbc0a0e57a7f, (v) => $a5a5f16c8a84146c$export$4bbbbc0a0e57a7f = v);
$parcel$export($a5a5f16c8a84146c$exports, "parseGeoJSON", () => $a5a5f16c8a84146c$export$d93d4ce94fa6bbcb, (v) => $a5a5f16c8a84146c$export$d93d4ce94fa6bbcb = v);
$parcel$export($a5a5f16c8a84146c$exports, "List", () => $a5a5f16c8a84146c$export$54c2e3dc7acea9f5, (v) => $a5a5f16c8a84146c$export$54c2e3dc7acea9f5 = v);
$parcel$export($a5a5f16c8a84146c$exports, "Model", () => $a5a5f16c8a84146c$export$a1edc412be3e1841, (v) => $a5a5f16c8a84146c$export$a1edc412be3e1841 = v);
$parcel$export($a5a5f16c8a84146c$exports, "Axis", () => $a5a5f16c8a84146c$export$d06866a9fb0606da, (v) => $a5a5f16c8a84146c$export$d06866a9fb0606da = v);
$parcel$export($a5a5f16c8a84146c$exports, "env", () => $a5a5f16c8a84146c$export$a7b6bc01c63cdfc3, (v) => $a5a5f16c8a84146c$export$a7b6bc01c63cdfc3 = v);
$parcel$export($a5a5f16c8a84146c$exports, "parseGeoJson", () => $a5a5f16c8a84146c$export$6d6c4c1a99631459, (v) => $a5a5f16c8a84146c$export$6d6c4c1a99631459 = v);
$parcel$export($a5a5f16c8a84146c$exports, "util", () => $a5a5f16c8a84146c$export$7debb50ef11d5e0b, (v) => $a5a5f16c8a84146c$export$7debb50ef11d5e0b = v);
$parcel$export($a5a5f16c8a84146c$exports, "graphic", () => $a5a5f16c8a84146c$export$c96b99088d96cc6d, (v) => $a5a5f16c8a84146c$export$c96b99088d96cc6d = v);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $a5a5f16c8a84146c$export$36f18b7b5b28517c;
var $a5a5f16c8a84146c$export$9bdad1ae37d738e0;
var $a5a5f16c8a84146c$export$6074e20ba5c64bef;
var $a5a5f16c8a84146c$export$35e9368ef982300f;
var $a5a5f16c8a84146c$export$98e628dec113755e;
var $a5a5f16c8a84146c$export$d9468344d3651243;
var $a5a5f16c8a84146c$export$de363e709c412c8a;
var $a5a5f16c8a84146c$export$4bbbbc0a0e57a7f;
var $a5a5f16c8a84146c$export$d93d4ce94fa6bbcb;
var $a5a5f16c8a84146c$export$54c2e3dc7acea9f5;
var $a5a5f16c8a84146c$export$a1edc412be3e1841;
var $a5a5f16c8a84146c$export$d06866a9fb0606da;
var $a5a5f16c8a84146c$export$a7b6bc01c63cdfc3;
var $a5a5f16c8a84146c$export$6d6c4c1a99631459;
var $a5a5f16c8a84146c$export$7debb50ef11d5e0b;
var $a5a5f16c8a84146c$export$c96b99088d96cc6d;

$a5a5f16c8a84146c$export$36f18b7b5b28517c = $ec1efdd8e4428d18$exports;

$a5a5f16c8a84146c$export$9bdad1ae37d738e0 = $6c6dd9610ba660f0$exports;

$a5a5f16c8a84146c$export$6074e20ba5c64bef = $9eb63d101f3bcd79$exports;


$a5a5f16c8a84146c$export$35e9368ef982300f = $b1179c91b052e827$exports;


$a5a5f16c8a84146c$export$98e628dec113755e = $2d742dbe7f960d8c$exports;

$a5a5f16c8a84146c$export$d9468344d3651243 = $a4be9366aeb9fcc8$exports;

var $a5a5f16c8a84146c$var$throttle = $a181ac84b0d97d16$export$de363e709c412c8a;
$a5a5f16c8a84146c$export$de363e709c412c8a = $a181ac84b0d97d16$export$de363e709c412c8a;
var $f74da13fea6dc6fb$exports = {};

$parcel$export($f74da13fea6dc6fb$exports, "getLayoutRect", () => $f74da13fea6dc6fb$export$4517a5ca639a7293, (v) => $f74da13fea6dc6fb$export$4517a5ca639a7293 = v);
$parcel$export($f74da13fea6dc6fb$exports, "completeDimensions", () => $f74da13fea6dc6fb$export$b31bb4acc0481e9b, (v) => $f74da13fea6dc6fb$export$b31bb4acc0481e9b = v);
$parcel$export($f74da13fea6dc6fb$exports, "createDimensions", () => $f74da13fea6dc6fb$export$8066c1b52b2e9504, (v) => $f74da13fea6dc6fb$export$8066c1b52b2e9504 = v);
$parcel$export($f74da13fea6dc6fb$exports, "createSymbol", () => $f74da13fea6dc6fb$export$af050e04da3a02e8, (v) => $f74da13fea6dc6fb$export$af050e04da3a02e8 = v);
$parcel$export($f74da13fea6dc6fb$exports, "createList", () => $f74da13fea6dc6fb$export$5897d8d7c7a3d871, (v) => $f74da13fea6dc6fb$export$5897d8d7c7a3d871 = v);
$parcel$export($f74da13fea6dc6fb$exports, "dataStack", () => $f74da13fea6dc6fb$export$d6100971d5a3a0a7, (v) => $f74da13fea6dc6fb$export$d6100971d5a3a0a7 = v);
$parcel$export($f74da13fea6dc6fb$exports, "createScale", () => $f74da13fea6dc6fb$export$587d9c3c553380c6, (v) => $f74da13fea6dc6fb$export$587d9c3c553380c6 = v);
$parcel$export($f74da13fea6dc6fb$exports, "mixinAxisModelCommonMethods", () => $f74da13fea6dc6fb$export$4665cbe3470e4d57, (v) => $f74da13fea6dc6fb$export$4665cbe3470e4d57 = v);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $f74da13fea6dc6fb$export$4517a5ca639a7293;
var $f74da13fea6dc6fb$export$b31bb4acc0481e9b;
var $f74da13fea6dc6fb$export$8066c1b52b2e9504;
var $f74da13fea6dc6fb$export$af050e04da3a02e8;
var $f74da13fea6dc6fb$export$5897d8d7c7a3d871;
var $f74da13fea6dc6fb$export$d6100971d5a3a0a7;
var $f74da13fea6dc6fb$export$587d9c3c553380c6;
var $f74da13fea6dc6fb$export$4665cbe3470e4d57;

var $10e48b57e44af7c1$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $f643df856475f69e$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $f643df856475f69e$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;


var $8e5cd4a27af1b00f$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $8e5cd4a27af1b00f$var$defaultKeyGetter(item) {
    return item;
}
/**
 * @param {Array} oldArr
 * @param {Array} newArr
 * @param {Function} oldKeyGetter
 * @param {Function} newKeyGetter
 * @param {Object} [context] Can be visited by this.context in callback.
 */ function $8e5cd4a27af1b00f$var$DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context) {
    this._old = oldArr;
    this._new = newArr;
    this._oldKeyGetter = oldKeyGetter || $8e5cd4a27af1b00f$var$defaultKeyGetter;
    this._newKeyGetter = newKeyGetter || $8e5cd4a27af1b00f$var$defaultKeyGetter;
    this.context = context;
}
$8e5cd4a27af1b00f$var$DataDiffer.prototype = {
    constructor: $8e5cd4a27af1b00f$var$DataDiffer,
    /**
   * Callback function when add a data
   */ add: function(func) {
        this._add = func;
        return this;
    },
    /**
   * Callback function when update a data
   */ update: function(func) {
        this._update = func;
        return this;
    },
    /**
   * Callback function when remove a data
   */ remove: function(func) {
        this._remove = func;
        return this;
    },
    execute: function() {
        var oldArr = this._old;
        var newArr = this._new;
        var oldDataIndexMap = {};
        var newDataIndexMap = {};
        var oldDataKeyArr = [];
        var newDataKeyArr = [];
        var i;
        $8e5cd4a27af1b00f$var$initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, "_oldKeyGetter", this);
        $8e5cd4a27af1b00f$var$initIndexMap(newArr, newDataIndexMap, newDataKeyArr, "_newKeyGetter", this);
        for(i = 0; i < oldArr.length; i++){
            var key = oldDataKeyArr[i];
            var idx = newDataIndexMap[key]; // idx can never be empty array here. see 'set null' logic below.
            if (idx != null) {
                // Consider there is duplicate key (for example, use dataItem.name as key).
                // We should make sure every item in newArr and oldArr can be visited.
                var len = idx.length;
                if (len) {
                    len === 1 && (newDataIndexMap[key] = null);
                    idx = idx.shift();
                } else newDataIndexMap[key] = null;
                this._update && this._update(idx, i);
            } else this._remove && this._remove(i);
        }
        for(var i = 0; i < newDataKeyArr.length; i++){
            var key = newDataKeyArr[i];
            if (newDataIndexMap.hasOwnProperty(key)) {
                var idx = newDataIndexMap[key];
                if (idx == null) continue;
                 // idx can never be empty array here. see 'set null' logic above.
                if (!idx.length) this._add && this._add(idx);
                else for(var j = 0, len = idx.length; j < len; j++)this._add && this._add(idx[j]);
            }
        }
    }
};
function $8e5cd4a27af1b00f$var$initIndexMap(arr, map, keyArr, keyGetterName, dataDiffer) {
    for(var i = 0; i < arr.length; i++){
        // Add prefix to avoid conflict with Object.prototype.
        var key = "_ec_" + dataDiffer[keyGetterName](arr[i], i);
        var existence = map[key];
        if (existence == null) {
            keyArr.push(key);
            map[key] = i;
        } else {
            if (!existence.length) map[key] = existence = [
                existence
            ];
            existence.push(i);
        }
    }
}
var $8e5cd4a27af1b00f$var$_default = $8e5cd4a27af1b00f$var$DataDiffer;
$8e5cd4a27af1b00f$exports = $8e5cd4a27af1b00f$var$_default;




var $f643df856475f69e$var$defaultDimValueGetters = $05c9939f6206d72a$export$fb9e716e12537ce0;
var $f643df856475f69e$var$DefaultDataProvider = $05c9939f6206d72a$export$b900d7c4c3952a40;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ //     // Get last value dim
//     var dimensions = data.dimensions.slice();
//     var valueType;
//     var valueDim;
//     while (dimensions.length && (
//         valueDim = dimensions.pop(),
//         valueType = data.getDimensionInfo(valueDim).type,
//         valueType === 'ordinal' || valueType === 'time'
//     )) {} // jshint ignore:line
//     return valueDim;
// }
var $b5496acb5150a0c1$export$15ee9443ac05a329;
var $b5496acb5150a0c1$export$505a22c3734846f1;
var $b5496acb5150a0c1$export$af1622903e71278e;

var $b5496acb5150a0c1$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $b5496acb5150a0c1$var$createHashMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4;
var $b5496acb5150a0c1$var$assert = $ec279652dd95c27b$export$a7a9523472993e97;

var $b5496acb5150a0c1$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $b5496acb5150a0c1$var$OTHER_DIMENSIONS = $b5496acb5150a0c1$var$createHashMap([
    "tooltip",
    "label",
    "itemName",
    "itemId",
    "seriesName"
]);
function $b5496acb5150a0c1$var$summarizeDimensions(data) {
    var summary = {};
    var encode = summary.encode = {};
    var notExtraCoordDimMap = $b5496acb5150a0c1$var$createHashMap();
    var defaultedLabel = [];
    var defaultedTooltip = []; // See the comment of `List.js#userOutput`.
    var userOutput = summary.userOutput = {
        dimensionNames: data.dimensions.slice(),
        encode: {}
    };
    $b5496acb5150a0c1$var$each(data.dimensions, function(dimName) {
        var dimItem = data.getDimensionInfo(dimName);
        var coordDim = dimItem.coordDim;
        if (coordDim) {
            var coordDimIndex = dimItem.coordDimIndex;
            $b5496acb5150a0c1$var$getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
            if (!dimItem.isExtraCoord) {
                notExtraCoordDimMap.set(coordDim, 1); // Use the last coord dim (and label friendly) as default label,
                // because when dataset is used, it is hard to guess which dimension
                // can be value dimension. If both show x, y on label is not look good,
                // and conventionally y axis is focused more.
                if ($b5496acb5150a0c1$var$mayLabelDimType(dimItem.type)) defaultedLabel[0] = dimName;
                 // User output encode do not contain generated coords.
                // And it only has index. User can use index to retrieve value from the raw item array.
                $b5496acb5150a0c1$var$getOrCreateEncodeArr(userOutput.encode, coordDim)[coordDimIndex] = dimItem.index;
            }
            if (dimItem.defaultTooltip) defaultedTooltip.push(dimName);
        }
        $b5496acb5150a0c1$var$OTHER_DIMENSIONS.each(function(v, otherDim) {
            var encodeArr = $b5496acb5150a0c1$var$getOrCreateEncodeArr(encode, otherDim);
            var dimIndex = dimItem.otherDims[otherDim];
            if (dimIndex != null && dimIndex !== false) encodeArr[dimIndex] = dimItem.name;
        });
    });
    var dataDimsOnCoord = [];
    var encodeFirstDimNotExtra = {};
    notExtraCoordDimMap.each(function(v, coordDim) {
        var dimArr = encode[coordDim]; // ??? FIXME extra coord should not be set in dataDimsOnCoord.
        // But should fix the case that radar axes: simplify the logic
        // of `completeDimension`, remove `extraPrefix`.
        encodeFirstDimNotExtra[coordDim] = dimArr[0]; // Not necessary to remove duplicate, because a data
        // dim canot on more than one coordDim.
        dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
    });
    summary.dataDimsOnCoord = dataDimsOnCoord;
    summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
    var encodeLabel = encode.label; // FIXME `encode.label` is not recommanded, because formatter can not be set
    // in this way. Use label.formatter instead. May be remove this approach someday.
    if (encodeLabel && encodeLabel.length) defaultedLabel = encodeLabel.slice();
    var encodeTooltip = encode.tooltip;
    if (encodeTooltip && encodeTooltip.length) defaultedTooltip = encodeTooltip.slice();
    else if (!defaultedTooltip.length) defaultedTooltip = defaultedLabel.slice();
    encode.defaultedLabel = defaultedLabel;
    encode.defaultedTooltip = defaultedTooltip;
    return summary;
}
function $b5496acb5150a0c1$var$getOrCreateEncodeArr(encode, dim) {
    if (!encode.hasOwnProperty(dim)) encode[dim] = [];
    return encode[dim];
}
function $b5496acb5150a0c1$var$getDimensionTypeByAxis(axisType) {
    return axisType === "category" ? "ordinal" : axisType === "time" ? "time" : "float";
}
function $b5496acb5150a0c1$var$mayLabelDimType(dimType) {
    // In most cases, ordinal and time do not suitable for label.
    // Ordinal info can be displayed on axis. Time is too long.
    return !(dimType === "ordinal" || dimType === "time");
} // function findTheLastDimMayLabel(data) {
$b5496acb5150a0c1$export$15ee9443ac05a329 = $b5496acb5150a0c1$var$OTHER_DIMENSIONS;
$b5496acb5150a0c1$export$505a22c3734846f1 = $b5496acb5150a0c1$var$summarizeDimensions;
$b5496acb5150a0c1$export$af1622903e71278e = $b5496acb5150a0c1$var$getDimensionTypeByAxis;


var $f643df856475f69e$var$summarizeDimensions = $b5496acb5150a0c1$export$505a22c3734846f1;
var $972c5fe9ccf46f49$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @class
 * @param {Object|DataDimensionInfo} [opt] All of the fields will be shallow copied.
 */ function $972c5fe9ccf46f49$var$DataDimensionInfo(opt) {
    if (opt != null) $ec279652dd95c27b$export$8b58be045bf06082(this, opt);
    /**
   * Dimension name.
   * Mandatory.
   * @type {string}
   */ // this.name;
    /**
   * The origin name in dimsDef, see source helper.
   * If displayName given, the tooltip will displayed vertically.
   * Optional.
   * @type {string}
   */ // this.displayName;
    /**
   * Which coordSys dimension this dimension mapped to.
   * A `coordDim` can be a "coordSysDim" that the coordSys required
   * (for example, an item in `coordSysDims` of `model/referHelper#CoordSysInfo`),
   * or an generated "extra coord name" if does not mapped to any "coordSysDim"
   * (That is determined by whether `isExtraCoord` is `true`).
   * Mandatory.
   * @type {string}
   */ // this.coordDim;
    /**
   * The index of this dimension in `series.encode[coordDim]`.
   * Mandatory.
   * @type {number}
   */ // this.coordDimIndex;
    /**
   * Dimension type. The enumerable values are the key of
   * `dataCtors` of `data/List`.
   * Optional.
   * @type {string}
   */ // this.type;
    /**
   * This index of this dimension info in `data/List#_dimensionInfos`.
   * Mandatory after added to `data/List`.
   * @type {number}
   */ // this.index;
    /**
   * The format of `otherDims` is:
   * ```js
   * {
   *     tooltip: number optional,
   *     label: number optional,
   *     itemName: number optional,
   *     seriesName: number optional,
   * }
   * ```
   *
   * A `series.encode` can specified these fields:
   * ```js
   * encode: {
   *     // "3, 1, 5" is the index of data dimension.
   *     tooltip: [3, 1, 5],
   *     label: [0, 3],
   *     ...
   * }
   * ```
   * `otherDims` is the parse result of the `series.encode` above, like:
   * ```js
   * // Suppose the index of this data dimension is `3`.
   * this.otherDims = {
   *     // `3` is at the index `0` of the `encode.tooltip`
   *     tooltip: 0,
   *     // `3` is at the index `1` of the `encode.tooltip`
   *     label: 1
   * };
   * ```
   *
   * This prop should never be `null`/`undefined` after initialized.
   * @type {Object}
   */ this.otherDims = {};
/**
   * Be `true` if this dimension is not mapped to any "coordSysDim" that the
   * "coordSys" required.
   * Mandatory.
   * @type {boolean}
   */ // this.isExtraCoord;
/**
   * @type {module:data/OrdinalMeta}
   */ // this.ordinalMeta;
/**
   * Whether to create inverted indices.
   * @type {boolean}
   */ // this.createInvertedIndices;
}
var $972c5fe9ccf46f49$var$_default = $972c5fe9ccf46f49$var$DataDimensionInfo;
$972c5fe9ccf46f49$exports = $972c5fe9ccf46f49$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Float64Array, Int32Array, Uint32Array, Uint16Array */ /**
 * List for data storage
 * @module echarts/data/List
 */ var $f643df856475f69e$var$isObject = $ec279652dd95c27b$export$a6cdc56e425d0d0a;
var $f643df856475f69e$var$UNDEFINED = "undefined";
var $f643df856475f69e$var$INDEX_NOT_FOUND = -1; // Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird udpate animation.
var $f643df856475f69e$var$ID_PREFIX = "e\x00\x00";
var $f643df856475f69e$var$dataCtors = {
    "float": typeof Float64Array === $f643df856475f69e$var$UNDEFINED ? Array : Float64Array,
    "int": typeof Int32Array === $f643df856475f69e$var$UNDEFINED ? Array : Int32Array,
    // Ordinal data type can be string or int
    "ordinal": Array,
    "number": Array,
    "time": Array
}; // Caution: MUST not use `new CtorUint32Array(arr, 0, len)`, because the Ctor of array is
// different from the Ctor of typed array.
var $f643df856475f69e$var$CtorUint32Array = typeof Uint32Array === $f643df856475f69e$var$UNDEFINED ? Array : Uint32Array;
var $f643df856475f69e$var$CtorInt32Array = typeof Int32Array === $f643df856475f69e$var$UNDEFINED ? Array : Int32Array;
var $f643df856475f69e$var$CtorUint16Array = typeof Uint16Array === $f643df856475f69e$var$UNDEFINED ? Array : Uint16Array;
function $f643df856475f69e$var$getIndicesCtor(list) {
    // The possible max value in this._indicies is always this._rawCount despite of filtering.
    return list._rawCount > 65535 ? $f643df856475f69e$var$CtorUint32Array : $f643df856475f69e$var$CtorUint16Array;
}
function $f643df856475f69e$var$cloneChunk(originalChunk) {
    var Ctor = originalChunk.constructor; // Only shallow clone is enough when Array.
    return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
}
var $f643df856475f69e$var$TRANSFERABLE_PROPERTIES = [
    "hasItemOption",
    "_nameList",
    "_idList",
    "_invertedIndicesMap",
    "_rawData",
    "_chunkSize",
    "_chunkCount",
    "_dimValueGetter",
    "_count",
    "_rawCount",
    "_nameDimIdx",
    "_idDimIdx"
];
var $f643df856475f69e$var$CLONE_PROPERTIES = [
    "_extent",
    "_approximateExtent",
    "_rawExtent"
];
function $f643df856475f69e$var$transferProperties(target, source) {
    $ec279652dd95c27b$export$79b2f7037acddd43($f643df856475f69e$var$TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function(propName) {
        if (source.hasOwnProperty(propName)) target[propName] = source[propName];
    });
    target.__wrappedMethods = source.__wrappedMethods;
    $ec279652dd95c27b$export$79b2f7037acddd43($f643df856475f69e$var$CLONE_PROPERTIES, function(propName) {
        target[propName] = $ec279652dd95c27b$export$9cd59f9826255e47(source[propName]);
    });
    target._calculationInfo = $ec279652dd95c27b$export$8b58be045bf06082(source._calculationInfo);
}
/**
 * @constructor
 * @alias module:echarts/data/List
 *
 * @param {Array.<string|Object|module:data/DataDimensionInfo>} dimensions
 *      For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
 *      Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
 * @param {module:echarts/model/Model} hostModel
 */ var $f643df856475f69e$var$List = function(dimensions, hostModel) {
    dimensions = dimensions || [
        "x",
        "y"
    ];
    var dimensionInfos = {};
    var dimensionNames = [];
    var invertedIndicesMap = {};
    for(var i = 0; i < dimensions.length; i++){
        // Use the original dimensions[i], where other flag props may exists.
        var dimensionInfo = dimensions[i];
        if ($ec279652dd95c27b$export$844ec244b1367d54(dimensionInfo)) dimensionInfo = new $972c5fe9ccf46f49$exports({
            name: dimensionInfo
        });
        else if (!(dimensionInfo instanceof $972c5fe9ccf46f49$exports)) dimensionInfo = new $972c5fe9ccf46f49$exports(dimensionInfo);
        var dimensionName = dimensionInfo.name;
        dimensionInfo.type = dimensionInfo.type || "float";
        if (!dimensionInfo.coordDim) {
            dimensionInfo.coordDim = dimensionName;
            dimensionInfo.coordDimIndex = 0;
        }
        dimensionInfo.otherDims = dimensionInfo.otherDims || {};
        dimensionNames.push(dimensionName);
        dimensionInfos[dimensionName] = dimensionInfo;
        dimensionInfo.index = i;
        if (dimensionInfo.createInvertedIndices) invertedIndicesMap[dimensionName] = [];
    }
    /**
   * @readOnly
   * @type {Array.<string>}
   */ this.dimensions = dimensionNames;
    /**
   * Infomation of each data dimension, like data type.
   * @type {Object}
   */ this._dimensionInfos = dimensionInfos;
    /**
   * @type {module:echarts/model/Model}
   */ this.hostModel = hostModel;
    /**
   * @type {module:echarts/model/Model}
   */ this.dataType;
    /**
   * Indices stores the indices of data subset after filtered.
   * This data subset will be used in chart.
   * @type {Array.<number>}
   * @readOnly
   */ this._indices = null;
    this._count = 0;
    this._rawCount = 0;
    /**
   * Data storage
   * @type {Object.<key, Array.<TypedArray|Array>>}
   * @private
   */ this._storage = {};
    /**
   * @type {Array.<string>}
   */ this._nameList = [];
    /**
   * @type {Array.<string>}
   */ this._idList = [];
    /**
   * Models of data option is stored sparse for optimizing memory cost
   * @type {Array.<module:echarts/model/Model>}
   * @private
   */ this._optionModels = [];
    /**
   * Global visual properties after visual coding
   * @type {Object}
   * @private
   */ this._visual = {};
    /**
   * Globel layout properties.
   * @type {Object}
   * @private
   */ this._layout = {};
    /**
   * Item visual properties after visual coding
   * @type {Array.<Object>}
   * @private
   */ this._itemVisuals = [];
    /**
   * Key: visual type, Value: boolean
   * @type {Object}
   * @readOnly
   */ this.hasItemVisual = {};
    /**
   * Item layout properties after layout
   * @type {Array.<Object>}
   * @private
   */ this._itemLayouts = [];
    /**
   * Graphic elemnents
   * @type {Array.<module:zrender/Element>}
   * @private
   */ this._graphicEls = [];
    /**
   * Max size of each chunk.
   * @type {number}
   * @private
   */ this._chunkSize = 1e5;
    /**
   * @type {number}
   * @private
   */ this._chunkCount = 0;
    /**
   * @type {Array.<Array|Object>}
   * @private
   */ this._rawData;
    /**
   * Raw extent will not be cloned, but only transfered.
   * It will not be calculated util needed.
   * key: dim,
   * value: {end: number, extent: Array.<number>}
   * @type {Object}
   * @private
   */ this._rawExtent = {};
    /**
   * @type {Object}
   * @private
   */ this._extent = {};
    /**
   * key: dim
   * value: extent
   * @type {Object}
   * @private
   */ this._approximateExtent = {};
    /**
   * Cache summary info for fast visit. See "dimensionHelper".
   * @type {Object}
   * @private
   */ this._dimensionsSummary = $f643df856475f69e$var$summarizeDimensions(this);
    /**
   * @type {Object.<Array|TypedArray>}
   * @private
   */ this._invertedIndicesMap = invertedIndicesMap;
    /**
   * @type {Object}
   * @private
   */ this._calculationInfo = {};
    /**
   * User output info of this data.
   * DO NOT use it in other places!
   *
   * When preparing user params for user callbacks, we have
   * to clone these inner data structures to prevent users
   * from modifying them to effect built-in logic. And for
   * performance consideration we make this `userOutput` to
   * avoid clone them too many times.
   *
   * @type {Object}
   * @readOnly
   */ this.userOutput = this._dimensionsSummary.userOutput;
};
var $f643df856475f69e$var$listProto = $f643df856475f69e$var$List.prototype;
$f643df856475f69e$var$listProto.type = "list";
/**
 * If each data item has it's own option
 * @type {boolean}
 */ $f643df856475f69e$var$listProto.hasItemOption = true;
/**
 * The meanings of the input parameter `dim`:
 *
 * + If dim is a number (e.g., `1`), it means the index of the dimension.
 *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
 * + If dim is a number-like string (e.g., `"1"`):
 *     + If there is the same concrete dim name defined in `this.dimensions`, it means that concrete name.
 *     + If not, it will be converted to a number, which means the index of the dimension.
 *        (why? because of the backward compatbility. We have been tolerating number-like string in
 *        dimension setting, although now it seems that it is not a good idea.)
 *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
 *     if no dimension name is defined as `"1"`.
 * + If dim is a not-number-like string, it means the concrete dim name.
 *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
 *   or customized in `dimensions` property of option like `"age"`.
 *
 * Get dimension name
 * @param {string|number} dim See above.
 * @return {string} Concrete dim name.
 */ $f643df856475f69e$var$listProto.getDimension = function(dim) {
    if (typeof dim === "number" // If being a number-like string but not being defined a dimension name.
     || !isNaN(dim) && !this._dimensionInfos.hasOwnProperty(dim)) dim = this.dimensions[dim];
    return dim;
};
/**
 * Get type and calculation info of particular dimension
 * @param {string|number} dim
 *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
 *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
 */ $f643df856475f69e$var$listProto.getDimensionInfo = function(dim) {
    // Do not clone, because there may be categories in dimInfo.
    return this._dimensionInfos[this.getDimension(dim)];
};
/**
 * @return {Array.<string>} concrete dimension name list on coord.
 */ $f643df856475f69e$var$listProto.getDimensionsOnCoord = function() {
    return this._dimensionsSummary.dataDimsOnCoord.slice();
};
/**
 * @param {string} coordDim
 * @param {number} [idx] A coordDim may map to more than one data dim.
 *        If idx is `true`, return a array of all mapped dims.
 *        If idx is not specified, return the first dim not extra.
 * @return {string|Array.<string>} concrete data dim.
 *        If idx is number, and not found, return null/undefined.
 *        If idx is `true`, and not found, return empty array (always return array).
 */ $f643df856475f69e$var$listProto.mapDimension = function(coordDim, idx) {
    var dimensionsSummary = this._dimensionsSummary;
    if (idx == null) return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
    var dims = dimensionsSummary.encode[coordDim];
    return idx === true // always return array if idx is `true`
     ? (dims || []).slice() : dims && dims[idx];
};
/**
 * Initialize from data
 * @param {Array.<Object|number|Array>} data source or data or data provider.
 * @param {Array.<string>} [nameLIst] The name of a datum is used on data diff and
 *        default label/tooltip.
 *        A name can be specified in encode.itemName,
 *        or dataItem.name (only for series option data),
 *        or provided in nameList from outside.
 * @param {Function} [dimValueGetter] (dataItem, dimName, dataIndex, dimIndex) => number
 */ $f643df856475f69e$var$listProto.initData = function(data, nameList, dimValueGetter) {
    var notProvider = $058c715583456086$exports.isInstance(data) || $ec279652dd95c27b$export$1e2f57719e155213(data);
    if (notProvider) data = new $f643df856475f69e$var$DefaultDataProvider(data, this.dimensions.length);
    this._rawData = data; // Clear
    this._storage = {};
    this._indices = null;
    this._nameList = nameList || [];
    this._idList = [];
    this._nameRepeatCount = {};
    if (!dimValueGetter) this.hasItemOption = false;
    /**
   * @readOnly
   */ this.defaultDimValueGetter = $f643df856475f69e$var$defaultDimValueGetters[this._rawData.getSource().sourceFormat]; // Default dim value getter
    this._dimValueGetter = dimValueGetter = dimValueGetter || this.defaultDimValueGetter;
    this._dimValueGetterArrayRows = $f643df856475f69e$var$defaultDimValueGetters.arrayRows; // Reset raw extent.
    this._rawExtent = {};
    this._initDataFromProvider(0, data.count()); // If data has no item option.
    if (data.pure) this.hasItemOption = false;
};
$f643df856475f69e$var$listProto.getProvider = function() {
    return this._rawData;
};
/**
 * Caution: Can be only called on raw data (before `this._indices` created).
 */ $f643df856475f69e$var$listProto.appendData = function(data) {
    var rawData = this._rawData;
    var start = this.count();
    rawData.appendData(data);
    var end = rawData.count();
    if (!rawData.persistent) end += start;
    this._initDataFromProvider(start, end);
};
/**
 * Caution: Can be only called on raw data (before `this._indices` created).
 * This method does not modify `rawData` (`dataProvider`), but only
 * add values to storage.
 *
 * The final count will be increased by `Math.max(values.length, names.length)`.
 *
 * @param {Array.<Array.<*>>} values That is the SourceType: 'arrayRows', like
 *        [
 *            [12, 33, 44],
 *            [NaN, 43, 1],
 *            ['-', 'asdf', 0]
 *        ]
 *        Each item is exaclty cooresponding to a dimension.
 * @param {Array.<string>} [names]
 */ $f643df856475f69e$var$listProto.appendValues = function(values, names) {
    var chunkSize = this._chunkSize;
    var storage = this._storage;
    var dimensions = this.dimensions;
    var dimLen = dimensions.length;
    var rawExtent = this._rawExtent;
    var start = this.count();
    var end = start + Math.max(values.length, names ? names.length : 0);
    var originalChunkCount = this._chunkCount;
    for(var i = 0; i < dimLen; i++){
        var dim = dimensions[i];
        if (!rawExtent[dim]) rawExtent[dim] = $f643df856475f69e$var$getInitialExtent();
        if (!storage[dim]) storage[dim] = [];
        $f643df856475f69e$var$prepareChunks(storage, this._dimensionInfos[dim], chunkSize, originalChunkCount, end);
        this._chunkCount = storage[dim].length;
    }
    var emptyDataItem = new Array(dimLen);
    for(var idx = start; idx < end; idx++){
        var sourceIdx = idx - start;
        var chunkIndex = Math.floor(idx / chunkSize);
        var chunkOffset = idx % chunkSize; // Store the data by dimensions
        for(var k = 0; k < dimLen; k++){
            var dim = dimensions[k];
            var val = this._dimValueGetterArrayRows(values[sourceIdx] || emptyDataItem, dim, sourceIdx, k);
            storage[dim][chunkIndex][chunkOffset] = val;
            var dimRawExtent = rawExtent[dim];
            val < dimRawExtent[0] && (dimRawExtent[0] = val);
            val > dimRawExtent[1] && (dimRawExtent[1] = val);
        }
        if (names) this._nameList[idx] = names[sourceIdx];
    }
    this._rawCount = this._count = end; // Reset data extent
    this._extent = {};
    $f643df856475f69e$var$prepareInvertedIndex(this);
};
$f643df856475f69e$var$listProto._initDataFromProvider = function(start, end) {
    // Optimize.
    if (start >= end) return;
    var chunkSize = this._chunkSize;
    var rawData = this._rawData;
    var storage = this._storage;
    var dimensions = this.dimensions;
    var dimLen = dimensions.length;
    var dimensionInfoMap = this._dimensionInfos;
    var nameList = this._nameList;
    var idList = this._idList;
    var rawExtent = this._rawExtent;
    var nameRepeatCount = this._nameRepeatCount = {};
    var nameDimIdx;
    var originalChunkCount = this._chunkCount;
    for(var i = 0; i < dimLen; i++){
        var dim = dimensions[i];
        if (!rawExtent[dim]) rawExtent[dim] = $f643df856475f69e$var$getInitialExtent();
        var dimInfo = dimensionInfoMap[dim];
        if (dimInfo.otherDims.itemName === 0) nameDimIdx = this._nameDimIdx = i;
        if (dimInfo.otherDims.itemId === 0) this._idDimIdx = i;
        if (!storage[dim]) storage[dim] = [];
        $f643df856475f69e$var$prepareChunks(storage, dimInfo, chunkSize, originalChunkCount, end);
        this._chunkCount = storage[dim].length;
    }
    var dataItem = new Array(dimLen);
    for(var idx = start; idx < end; idx++){
        // NOTICE: Try not to write things into dataItem
        dataItem = rawData.getItem(idx, dataItem); // Each data item is value
        // [1, 2]
        // 2
        // Bar chart, line chart which uses category axis
        // only gives the 'y' value. 'x' value is the indices of category
        // Use a tempValue to normalize the value to be a (x, y) value
        var chunkIndex = Math.floor(idx / chunkSize);
        var chunkOffset = idx % chunkSize; // Store the data by dimensions
        for(var k = 0; k < dimLen; k++){
            var dim = dimensions[k];
            var dimStorage = storage[dim][chunkIndex]; // PENDING NULL is empty or zero
            var val = this._dimValueGetter(dataItem, dim, idx, k);
            dimStorage[chunkOffset] = val;
            var dimRawExtent = rawExtent[dim];
            val < dimRawExtent[0] && (dimRawExtent[0] = val);
            val > dimRawExtent[1] && (dimRawExtent[1] = val);
        } // ??? FIXME not check by pure but sourceFormat?
        // TODO refactor these logic.
        if (!rawData.pure) {
            var name = nameList[idx];
            if (dataItem && name == null) {
                // If dataItem is {name: ...}, it has highest priority.
                // That is appropriate for many common cases.
                if (dataItem.name != null) // There is no other place to persistent dataItem.name,
                // so save it to nameList.
                nameList[idx] = name = dataItem.name;
                else if (nameDimIdx != null) {
                    var nameDim = dimensions[nameDimIdx];
                    var nameDimChunk = storage[nameDim][chunkIndex];
                    if (nameDimChunk) {
                        name = nameDimChunk[chunkOffset];
                        var ordinalMeta = dimensionInfoMap[nameDim].ordinalMeta;
                        if (ordinalMeta && ordinalMeta.categories.length) name = ordinalMeta.categories[name];
                    }
                }
            } // Try using the id in option
            // id or name is used on dynamical data, mapping old and new items.
            var id = dataItem == null ? null : dataItem.id;
            if (id == null && name != null) {
                // Use name as id and add counter to avoid same name
                nameRepeatCount[name] = nameRepeatCount[name] || 0;
                id = name;
                if (nameRepeatCount[name] > 0) id += "__ec__" + nameRepeatCount[name];
                nameRepeatCount[name]++;
            }
            id != null && (idList[idx] = id);
        }
    }
    if (!rawData.persistent && rawData.clean) // Clean unused data if data source is typed array.
    rawData.clean();
    this._rawCount = this._count = end; // Reset data extent
    this._extent = {};
    $f643df856475f69e$var$prepareInvertedIndex(this);
};
function $f643df856475f69e$var$prepareChunks(storage, dimInfo, chunkSize, chunkCount, end) {
    var DataCtor = $f643df856475f69e$var$dataCtors[dimInfo.type];
    var lastChunkIndex = chunkCount - 1;
    var dim = dimInfo.name;
    var resizeChunkArray = storage[dim][lastChunkIndex];
    if (resizeChunkArray && resizeChunkArray.length < chunkSize) {
        var newStore = new DataCtor(Math.min(end - lastChunkIndex * chunkSize, chunkSize)); // The cost of the copy is probably inconsiderable
        // within the initial chunkSize.
        for(var j = 0; j < resizeChunkArray.length; j++)newStore[j] = resizeChunkArray[j];
        storage[dim][lastChunkIndex] = newStore;
    } // Create new chunks.
    for(var k = chunkCount * chunkSize; k < end; k += chunkSize)storage[dim].push(new DataCtor(Math.min(end - k, chunkSize)));
}
function $f643df856475f69e$var$prepareInvertedIndex(list) {
    var invertedIndicesMap = list._invertedIndicesMap;
    $ec279652dd95c27b$export$79b2f7037acddd43(invertedIndicesMap, function(invertedIndices, dim) {
        var dimInfo = list._dimensionInfos[dim]; // Currently, only dimensions that has ordinalMeta can create inverted indices.
        var ordinalMeta = dimInfo.ordinalMeta;
        if (ordinalMeta) {
            invertedIndices = invertedIndicesMap[dim] = new $f643df856475f69e$var$CtorInt32Array(ordinalMeta.categories.length); // The default value of TypedArray is 0. To avoid miss
            // mapping to 0, we should set it as INDEX_NOT_FOUND.
            for(var i = 0; i < invertedIndices.length; i++)invertedIndices[i] = $f643df856475f69e$var$INDEX_NOT_FOUND;
            for(var i = 0; i < list._count; i++)// Only support the case that all values are distinct.
            invertedIndices[list.get(dim, i)] = i;
        }
    });
}
function $f643df856475f69e$var$getRawValueFromStore(list, dimIndex, rawIndex) {
    var val;
    if (dimIndex != null) {
        var chunkSize = list._chunkSize;
        var chunkIndex = Math.floor(rawIndex / chunkSize);
        var chunkOffset = rawIndex % chunkSize;
        var dim = list.dimensions[dimIndex];
        var chunk = list._storage[dim][chunkIndex];
        if (chunk) {
            val = chunk[chunkOffset];
            var ordinalMeta = list._dimensionInfos[dim].ordinalMeta;
            if (ordinalMeta && ordinalMeta.categories.length) val = ordinalMeta.categories[val];
        }
    }
    return val;
}
/**
 * @return {number}
 */ $f643df856475f69e$var$listProto.count = function() {
    return this._count;
};
$f643df856475f69e$var$listProto.getIndices = function() {
    var newIndices;
    var indices = this._indices;
    if (indices) {
        var Ctor = indices.constructor;
        var thisCount = this._count; // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
        if (Ctor === Array) {
            newIndices = new Ctor(thisCount);
            for(var i = 0; i < thisCount; i++)newIndices[i] = indices[i];
        } else newIndices = new Ctor(indices.buffer, 0, thisCount);
    } else {
        var Ctor = $f643df856475f69e$var$getIndicesCtor(this);
        var newIndices = new Ctor(this.count());
        for(var i = 0; i < newIndices.length; i++)newIndices[i] = i;
    }
    return newIndices;
};
/**
 * Get value. Return NaN if idx is out of range.
 * @param {string} dim Dim must be concrete name.
 * @param {number} idx
 * @param {boolean} stack
 * @return {number}
 */ $f643df856475f69e$var$listProto.get = function(dim, idx) {
    if (!(idx >= 0 && idx < this._count)) return NaN;
    var storage = this._storage;
    if (!storage[dim]) // TODO Warn ?
    return NaN;
    idx = this.getRawIndex(idx);
    var chunkIndex = Math.floor(idx / this._chunkSize);
    var chunkOffset = idx % this._chunkSize;
    var chunkStore = storage[dim][chunkIndex];
    var value = chunkStore[chunkOffset]; // FIXME ordinal data type is not stackable
    // if (stack) {
    //     var dimensionInfo = this._dimensionInfos[dim];
    //     if (dimensionInfo && dimensionInfo.stackable) {
    //         var stackedOn = this.stackedOn;
    //         while (stackedOn) {
    //             // Get no stacked data of stacked on
    //             var stackedValue = stackedOn.get(dim, idx);
    //             // Considering positive stack, negative stack and empty data
    //             if ((value >= 0 && stackedValue > 0)  // Positive stack
    //                 || (value <= 0 && stackedValue < 0) // Negative stack
    //             ) {
    //                 value += stackedValue;
    //             }
    //             stackedOn = stackedOn.stackedOn;
    //         }
    //     }
    // }
    return value;
};
/**
 * @param {string} dim concrete dim
 * @param {number} rawIndex
 * @return {number|string}
 */ $f643df856475f69e$var$listProto.getByRawIndex = function(dim, rawIdx) {
    if (!(rawIdx >= 0 && rawIdx < this._rawCount)) return NaN;
    var dimStore = this._storage[dim];
    if (!dimStore) // TODO Warn ?
    return NaN;
    var chunkIndex = Math.floor(rawIdx / this._chunkSize);
    var chunkOffset = rawIdx % this._chunkSize;
    var chunkStore = dimStore[chunkIndex];
    return chunkStore[chunkOffset];
};
/**
 * FIXME Use `get` on chrome maybe slow(in filterSelf and selectRange).
 * Hack a much simpler _getFast
 * @private
 */ $f643df856475f69e$var$listProto._getFast = function(dim, rawIdx) {
    var chunkIndex = Math.floor(rawIdx / this._chunkSize);
    var chunkOffset = rawIdx % this._chunkSize;
    var chunkStore = this._storage[dim][chunkIndex];
    return chunkStore[chunkOffset];
};
/**
 * Get value for multi dimensions.
 * @param {Array.<string>} [dimensions] If ignored, using all dimensions.
 * @param {number} idx
 * @return {number}
 */ $f643df856475f69e$var$listProto.getValues = function(dimensions, idx) {
    var values = [];
    if (!$ec279652dd95c27b$export$43bee75e5e14138e(dimensions)) {
        // stack = idx;
        idx = dimensions;
        dimensions = this.dimensions;
    }
    for(var i = 0, len = dimensions.length; i < len; i++)values.push(this.get(dimensions[i], idx));
    return values;
};
/**
 * If value is NaN. Inlcuding '-'
 * Only check the coord dimensions.
 * @param {string} dim
 * @param {number} idx
 * @return {number}
 */ $f643df856475f69e$var$listProto.hasValue = function(idx) {
    var dataDimsOnCoord = this._dimensionsSummary.dataDimsOnCoord;
    for(var i = 0, len = dataDimsOnCoord.length; i < len; i++){
        // Ordinal type originally can be string or number.
        // But when an ordinal type is used on coord, it can
        // not be string but only number. So we can also use isNaN.
        if (isNaN(this.get(dataDimsOnCoord[i], idx))) return false;
    }
    return true;
};
/**
 * Get extent of data in one dimension
 * @param {string} dim
 * @param {boolean} stack
 */ $f643df856475f69e$var$listProto.getDataExtent = function(dim) {
    // Make sure use concrete dim as cache name.
    dim = this.getDimension(dim);
    var dimData = this._storage[dim];
    var initialExtent = $f643df856475f69e$var$getInitialExtent(); // stack = !!((stack || false) && this.getCalculationInfo(dim));
    if (!dimData) return initialExtent;
     // Make more strict checkings to ensure hitting cache.
    var currEnd = this.count(); // var cacheName = [dim, !!stack].join('_');
    // var cacheName = dim;
    // Consider the most cases when using data zoom, `getDataExtent`
    // happened before filtering. We cache raw extent, which is not
    // necessary to be cleared and recalculated when restore data.
    var useRaw = !this._indices; // && !stack;
    var dimExtent;
    if (useRaw) return this._rawExtent[dim].slice();
    dimExtent = this._extent[dim];
    if (dimExtent) return dimExtent.slice();
    dimExtent = initialExtent;
    var min = dimExtent[0];
    var max = dimExtent[1];
    for(var i = 0; i < currEnd; i++){
        // var value = stack ? this.get(dim, i, true) : this._getFast(dim, this.getRawIndex(i));
        var value = this._getFast(dim, this.getRawIndex(i));
        value < min && (min = value);
        value > max && (max = value);
    }
    dimExtent = [
        min,
        max
    ];
    this._extent[dim] = dimExtent;
    return dimExtent;
};
/**
 * Optimize for the scenario that data is filtered by a given extent.
 * Consider that if data amount is more than hundreds of thousand,
 * extent calculation will cost more than 10ms and the cache will
 * be erased because of the filtering.
 */ $f643df856475f69e$var$listProto.getApproximateExtent = function(dim) {
    dim = this.getDimension(dim);
    return this._approximateExtent[dim] || this.getDataExtent(dim);
};
$f643df856475f69e$var$listProto.setApproximateExtent = function(extent, dim) {
    dim = this.getDimension(dim);
    this._approximateExtent[dim] = extent.slice();
};
/**
 * @param {string} key
 * @return {*}
 */ $f643df856475f69e$var$listProto.getCalculationInfo = function(key) {
    return this._calculationInfo[key];
};
/**
 * @param {string|Object} key or k-v object
 * @param {*} [value]
 */ $f643df856475f69e$var$listProto.setCalculationInfo = function(key, value) {
    $f643df856475f69e$var$isObject(key) ? $ec279652dd95c27b$export$8b58be045bf06082(this._calculationInfo, key) : this._calculationInfo[key] = value;
};
/**
 * Get sum of data in one dimension
 * @param {string} dim
 */ $f643df856475f69e$var$listProto.getSum = function(dim) {
    var dimData = this._storage[dim];
    var sum = 0;
    if (dimData) for(var i = 0, len = this.count(); i < len; i++){
        var value = this.get(dim, i);
        if (!isNaN(value)) sum += value;
    }
    return sum;
};
/**
 * Get median of data in one dimension
 * @param {string} dim
 */ $f643df856475f69e$var$listProto.getMedian = function(dim) {
    var dimDataArray = []; // map all data of one dimension
    this.each(dim, function(val, idx) {
        if (!isNaN(val)) dimDataArray.push(val);
    }); // TODO
    // Use quick select?
    // immutability & sort
    var sortedDimDataArray = [].concat(dimDataArray).sort(function(a, b) {
        return a - b;
    });
    var len = this.count(); // calculate median
    return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
}; // /**
//  * Retreive the index with given value
//  * @param {string} dim Concrete dimension.
//  * @param {number} value
//  * @return {number}
//  */
// Currently incorrect: should return dataIndex but not rawIndex.
// Do not fix it until this method is to be used somewhere.
// FIXME Precision of float value
// listProto.indexOf = function (dim, value) {
//     var storage = this._storage;
//     var dimData = storage[dim];
//     var chunkSize = this._chunkSize;
//     if (dimData) {
//         for (var i = 0, len = this.count(); i < len; i++) {
//             var chunkIndex = Math.floor(i / chunkSize);
//             var chunkOffset = i % chunkSize;
//             if (dimData[chunkIndex][chunkOffset] === value) {
//                 return i;
//             }
//         }
//     }
//     return -1;
// };
/**
 * Only support the dimension which inverted index created.
 * Do not support other cases until required.
 * @param {string} concrete dim
 * @param {number|string} value
 * @return {number} rawIndex
 */ $f643df856475f69e$var$listProto.rawIndexOf = function(dim, value) {
    var invertedIndices = dim && this._invertedIndicesMap[dim];
    var rawIndex = invertedIndices[value];
    if (rawIndex == null || isNaN(rawIndex)) return $f643df856475f69e$var$INDEX_NOT_FOUND;
    return rawIndex;
};
/**
 * Retreive the index with given name
 * @param {number} idx
 * @param {number} name
 * @return {number}
 */ $f643df856475f69e$var$listProto.indexOfName = function(name) {
    for(var i = 0, len = this.count(); i < len; i++){
        if (this.getName(i) === name) return i;
    }
    return -1;
};
/**
 * Retreive the index with given raw data index
 * @param {number} idx
 * @param {number} name
 * @return {number}
 */ $f643df856475f69e$var$listProto.indexOfRawIndex = function(rawIndex) {
    if (rawIndex >= this._rawCount || rawIndex < 0) return -1;
    if (!this._indices) return rawIndex;
     // Indices are ascending
    var indices = this._indices; // If rawIndex === dataIndex
    var rawDataIndex = indices[rawIndex];
    if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) return rawIndex;
    var left = 0;
    var right = this._count - 1;
    while(left <= right){
        var mid = (left + right) / 2 | 0;
        if (indices[mid] < rawIndex) left = mid + 1;
        else if (indices[mid] > rawIndex) right = mid - 1;
        else return mid;
    }
    return -1;
};
/**
 * Retreive the index of nearest value
 * @param {string} dim
 * @param {number} value
 * @param {number} [maxDistance=Infinity]
 * @return {Array.<number>} If and only if multiple indices has
 *        the same value, they are put to the result.
 */ $f643df856475f69e$var$listProto.indicesOfNearest = function(dim, value, maxDistance) {
    var storage = this._storage;
    var dimData = storage[dim];
    var nearestIndices = [];
    if (!dimData) return nearestIndices;
    if (maxDistance == null) maxDistance = Infinity;
    var minDist = Infinity;
    var minDiff = -1;
    var nearestIndicesLen = 0; // Check the test case of `test/ut/spec/data/List.js`.
    for(var i = 0, len = this.count(); i < len; i++){
        var diff = value - this.get(dim, i);
        var dist = Math.abs(diff);
        if (dist <= maxDistance) {
            // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
            // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
            // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
            // So we chose the one that `diff >= 0` in this csae.
            // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
            // should be push to `nearestIndices`.
            if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
                minDist = dist;
                minDiff = diff;
                nearestIndicesLen = 0;
            }
            if (diff === minDiff) nearestIndices[nearestIndicesLen++] = i;
        }
    }
    nearestIndices.length = nearestIndicesLen;
    return nearestIndices;
};
/**
 * Get raw data index
 * @param {number} idx
 * @return {number}
 */ $f643df856475f69e$var$listProto.getRawIndex = $f643df856475f69e$var$getRawIndexWithoutIndices;
function $f643df856475f69e$var$getRawIndexWithoutIndices(idx) {
    return idx;
}
function $f643df856475f69e$var$getRawIndexWithIndices(idx) {
    if (idx < this._count && idx >= 0) return this._indices[idx];
    return -1;
}
/**
 * Get raw data item
 * @param {number} idx
 * @return {number}
 */ $f643df856475f69e$var$listProto.getRawDataItem = function(idx) {
    if (!this._rawData.persistent) {
        var val = [];
        for(var i = 0; i < this.dimensions.length; i++){
            var dim = this.dimensions[i];
            val.push(this.get(dim, idx));
        }
        return val;
    } else return this._rawData.getItem(this.getRawIndex(idx));
};
/**
 * @param {number} idx
 * @param {boolean} [notDefaultIdx=false]
 * @return {string}
 */ $f643df856475f69e$var$listProto.getName = function(idx) {
    var rawIndex = this.getRawIndex(idx);
    return this._nameList[rawIndex] || $f643df856475f69e$var$getRawValueFromStore(this, this._nameDimIdx, rawIndex) || "";
};
/**
 * @param {number} idx
 * @param {boolean} [notDefaultIdx=false]
 * @return {string}
 */ $f643df856475f69e$var$listProto.getId = function(idx) {
    return $f643df856475f69e$var$getId(this, this.getRawIndex(idx));
};
function $f643df856475f69e$var$getId(list, rawIndex) {
    var id = list._idList[rawIndex];
    if (id == null) id = $f643df856475f69e$var$getRawValueFromStore(list, list._idDimIdx, rawIndex);
    if (id == null) // FIXME Check the usage in graph, should not use prefix.
    id = $f643df856475f69e$var$ID_PREFIX + rawIndex;
    return id;
}
function $f643df856475f69e$var$normalizeDimensions(dimensions) {
    if (!$ec279652dd95c27b$export$43bee75e5e14138e(dimensions)) dimensions = [
        dimensions
    ];
    return dimensions;
}
function $f643df856475f69e$var$validateDimensions(list, dims) {
    for(var i = 0; i < dims.length; i++)// stroage may be empty when no data, so use
    // dimensionInfos to check.
    if (!list._dimensionInfos[dims[i]]) console.error("Unkown dimension " + dims[i]);
}
/**
 * Data iteration
 * @param {string|Array.<string>}
 * @param {Function} cb
 * @param {*} [context=this]
 *
 * @example
 *  list.each('x', function (x, idx) {});
 *  list.each(['x', 'y'], function (x, y, idx) {});
 *  list.each(function (idx) {})
 */ $f643df856475f69e$var$listProto.each = function(dims, cb, context, contextCompat) {
    "use strict";
    if (!this._count) return;
    if (typeof dims === "function") {
        contextCompat = context;
        context = cb;
        cb = dims;
        dims = [];
    } // contextCompat just for compat echarts3
    context = context || contextCompat || this;
    dims = $ec279652dd95c27b$export$871de8747c9eaa88($f643df856475f69e$var$normalizeDimensions(dims), this.getDimension, this);
    var dimSize = dims.length;
    for(var i = 0; i < this.count(); i++)// Simple optimization
    switch(dimSize){
        case 0:
            cb.call(context, i);
            break;
        case 1:
            cb.call(context, this.get(dims[0], i), i);
            break;
        case 2:
            cb.call(context, this.get(dims[0], i), this.get(dims[1], i), i);
            break;
        default:
            var k = 0;
            var value = [];
            for(; k < dimSize; k++)value[k] = this.get(dims[k], i);
             // Index
            value[k] = i;
            cb.apply(context, value);
    }
};
/**
 * Data filter
 * @param {string|Array.<string>}
 * @param {Function} cb
 * @param {*} [context=this]
 */ $f643df856475f69e$var$listProto.filterSelf = function(dimensions, cb, context, contextCompat) {
    "use strict";
    if (!this._count) return;
    if (typeof dimensions === "function") {
        contextCompat = context;
        context = cb;
        cb = dimensions;
        dimensions = [];
    } // contextCompat just for compat echarts3
    context = context || contextCompat || this;
    dimensions = $ec279652dd95c27b$export$871de8747c9eaa88($f643df856475f69e$var$normalizeDimensions(dimensions), this.getDimension, this);
    var count = this.count();
    var Ctor = $f643df856475f69e$var$getIndicesCtor(this);
    var newIndices = new Ctor(count);
    var value = [];
    var dimSize = dimensions.length;
    var offset = 0;
    var dim0 = dimensions[0];
    for(var i = 0; i < count; i++){
        var keep;
        var rawIdx = this.getRawIndex(i); // Simple optimization
        if (dimSize === 0) keep = cb.call(context, i);
        else if (dimSize === 1) {
            var val = this._getFast(dim0, rawIdx);
            keep = cb.call(context, val, i);
        } else {
            for(var k = 0; k < dimSize; k++)value[k] = this._getFast(dim0, rawIdx);
            value[k] = i;
            keep = cb.apply(context, value);
        }
        if (keep) newIndices[offset++] = rawIdx;
    } // Set indices after filtered.
    if (offset < count) this._indices = newIndices;
    this._count = offset; // Reset data extent
    this._extent = {};
    this.getRawIndex = this._indices ? $f643df856475f69e$var$getRawIndexWithIndices : $f643df856475f69e$var$getRawIndexWithoutIndices;
    return this;
};
/**
 * Select data in range. (For optimization of filter)
 * (Manually inline code, support 5 million data filtering in data zoom.)
 */ $f643df856475f69e$var$listProto.selectRange = function(range) {
    "use strict";
    if (!this._count) return;
    var dimensions = [];
    for(var dim in range)if (range.hasOwnProperty(dim)) dimensions.push(dim);
    var dimSize = dimensions.length;
    if (!dimSize) return;
    var originalCount = this.count();
    var Ctor = $f643df856475f69e$var$getIndicesCtor(this);
    var newIndices = new Ctor(originalCount);
    var offset = 0;
    var dim0 = dimensions[0];
    var min = range[dim0][0];
    var max = range[dim0][1];
    var quickFinished = false;
    if (!this._indices) {
        // Extreme optimization for common case. About 2x faster in chrome.
        var idx = 0;
        if (dimSize === 1) {
            var dimStorage = this._storage[dimensions[0]];
            for(var k = 0; k < this._chunkCount; k++){
                var chunkStorage = dimStorage[k];
                var len = Math.min(this._count - k * this._chunkSize, this._chunkSize);
                for(var i = 0; i < len; i++){
                    var val = chunkStorage[i]; // NaN will not be filtered. Consider the case, in line chart, empty
                    // value indicates the line should be broken. But for the case like
                    // scatter plot, a data item with empty value will not be rendered,
                    // but the axis extent may be effected if some other dim of the data
                    // item has value. Fortunately it is not a significant negative effect.
                    if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = idx;
                    idx++;
                }
            }
            quickFinished = true;
        } else if (dimSize === 2) {
            var dimStorage = this._storage[dim0];
            var dimStorage2 = this._storage[dimensions[1]];
            var min2 = range[dimensions[1]][0];
            var max2 = range[dimensions[1]][1];
            for(var k = 0; k < this._chunkCount; k++){
                var chunkStorage = dimStorage[k];
                var chunkStorage2 = dimStorage2[k];
                var len = Math.min(this._count - k * this._chunkSize, this._chunkSize);
                for(var i = 0; i < len; i++){
                    var val = chunkStorage[i];
                    var val2 = chunkStorage2[i]; // Do not filter NaN, see comment above.
                    if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) newIndices[offset++] = idx;
                    idx++;
                }
            }
            quickFinished = true;
        }
    }
    if (!quickFinished) {
        if (dimSize === 1) for(var i = 0; i < originalCount; i++){
            var rawIndex = this.getRawIndex(i);
            var val = this._getFast(dim0, rawIndex); // Do not filter NaN, see comment above.
            if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = rawIndex;
        }
        else for(var i = 0; i < originalCount; i++){
            var keep = true;
            var rawIndex = this.getRawIndex(i);
            for(var k = 0; k < dimSize; k++){
                var dimk = dimensions[k];
                var val = this._getFast(dim, rawIndex); // Do not filter NaN, see comment above.
                if (val < range[dimk][0] || val > range[dimk][1]) keep = false;
            }
            if (keep) newIndices[offset++] = this.getRawIndex(i);
        }
    } // Set indices after filtered.
    if (offset < originalCount) this._indices = newIndices;
    this._count = offset; // Reset data extent
    this._extent = {};
    this.getRawIndex = this._indices ? $f643df856475f69e$var$getRawIndexWithIndices : $f643df856475f69e$var$getRawIndexWithoutIndices;
    return this;
};
/**
 * Data mapping to a plain array
 * @param {string|Array.<string>} [dimensions]
 * @param {Function} cb
 * @param {*} [context=this]
 * @return {Array}
 */ $f643df856475f69e$var$listProto.mapArray = function(dimensions, cb, context, contextCompat) {
    "use strict";
    if (typeof dimensions === "function") {
        contextCompat = context;
        context = cb;
        cb = dimensions;
        dimensions = [];
    } // contextCompat just for compat echarts3
    context = context || contextCompat || this;
    var result = [];
    this.each(dimensions, function() {
        result.push(cb && cb.apply(this, arguments));
    }, context);
    return result;
}; // Data in excludeDimensions is copied, otherwise transfered.
function $f643df856475f69e$var$cloneListForMapAndSample(original, excludeDimensions) {
    var allDimensions = original.dimensions;
    var list = new $f643df856475f69e$var$List($ec279652dd95c27b$export$871de8747c9eaa88(allDimensions, original.getDimensionInfo, original), original.hostModel); // FIXME If needs stackedOn, value may already been stacked
    $f643df856475f69e$var$transferProperties(list, original);
    var storage = list._storage = {};
    var originalStorage = original._storage; // Init storage
    for(var i = 0; i < allDimensions.length; i++){
        var dim = allDimensions[i];
        if (originalStorage[dim]) {
            // Notice that we do not reset invertedIndicesMap here, becuase
            // there is no scenario of mapping or sampling ordinal dimension.
            if ($ec279652dd95c27b$export$305f7d4e9d4624f2(excludeDimensions, dim) >= 0) {
                storage[dim] = $f643df856475f69e$var$cloneDimStore(originalStorage[dim]);
                list._rawExtent[dim] = $f643df856475f69e$var$getInitialExtent();
                list._extent[dim] = null;
            } else // Direct reference for other dimensions
            storage[dim] = originalStorage[dim];
        }
    }
    return list;
}
function $f643df856475f69e$var$cloneDimStore(originalDimStore) {
    var newDimStore = new Array(originalDimStore.length);
    for(var j = 0; j < originalDimStore.length; j++)newDimStore[j] = $f643df856475f69e$var$cloneChunk(originalDimStore[j]);
    return newDimStore;
}
function $f643df856475f69e$var$getInitialExtent() {
    return [
        Infinity,
        -Infinity
    ];
}
/**
 * Data mapping to a new List with given dimensions
 * @param {string|Array.<string>} dimensions
 * @param {Function} cb
 * @param {*} [context=this]
 * @return {Array}
 */ $f643df856475f69e$var$listProto.map = function(dimensions, cb, context, contextCompat) {
    "use strict"; // contextCompat just for compat echarts3
    context = context || contextCompat || this;
    dimensions = $ec279652dd95c27b$export$871de8747c9eaa88($f643df856475f69e$var$normalizeDimensions(dimensions), this.getDimension, this);
    var list = $f643df856475f69e$var$cloneListForMapAndSample(this, dimensions); // Following properties are all immutable.
    // So we can reference to the same value
    list._indices = this._indices;
    list.getRawIndex = list._indices ? $f643df856475f69e$var$getRawIndexWithIndices : $f643df856475f69e$var$getRawIndexWithoutIndices;
    var storage = list._storage;
    var tmpRetValue = [];
    var chunkSize = this._chunkSize;
    var dimSize = dimensions.length;
    var dataCount = this.count();
    var values = [];
    var rawExtent = list._rawExtent;
    for(var dataIndex = 0; dataIndex < dataCount; dataIndex++){
        for(var dimIndex = 0; dimIndex < dimSize; dimIndex++)values[dimIndex] = this.get(dimensions[dimIndex], dataIndex);
        values[dimSize] = dataIndex;
        var retValue = cb && cb.apply(context, values);
        if (retValue != null) {
            // a number or string (in oridinal dimension)?
            if (typeof retValue !== "object") {
                tmpRetValue[0] = retValue;
                retValue = tmpRetValue;
            }
            var rawIndex = this.getRawIndex(dataIndex);
            var chunkIndex = Math.floor(rawIndex / chunkSize);
            var chunkOffset = rawIndex % chunkSize;
            for(var i = 0; i < retValue.length; i++){
                var dim = dimensions[i];
                var val = retValue[i];
                var rawExtentOnDim = rawExtent[dim];
                var dimStore = storage[dim];
                if (dimStore) dimStore[chunkIndex][chunkOffset] = val;
                if (val < rawExtentOnDim[0]) rawExtentOnDim[0] = val;
                if (val > rawExtentOnDim[1]) rawExtentOnDim[1] = val;
            }
        }
    }
    return list;
};
/**
 * Large data down sampling on given dimension
 * @param {string} dimension
 * @param {number} rate
 * @param {Function} sampleValue
 * @param {Function} sampleIndex Sample index for name and id
 */ $f643df856475f69e$var$listProto.downSample = function(dimension, rate, sampleValue, sampleIndex) {
    var list = $f643df856475f69e$var$cloneListForMapAndSample(this, [
        dimension
    ]);
    var targetStorage = list._storage;
    var frameValues = [];
    var frameSize = Math.floor(1 / rate);
    var dimStore = targetStorage[dimension];
    var len = this.count();
    var chunkSize = this._chunkSize;
    var rawExtentOnDim = list._rawExtent[dimension];
    var newIndices = new ($f643df856475f69e$var$getIndicesCtor(this))(len);
    var offset = 0;
    for(var i = 0; i < len; i += frameSize){
        // Last frame
        if (frameSize > len - i) {
            frameSize = len - i;
            frameValues.length = frameSize;
        }
        for(var k = 0; k < frameSize; k++){
            var dataIdx = this.getRawIndex(i + k);
            var originalChunkIndex = Math.floor(dataIdx / chunkSize);
            var originalChunkOffset = dataIdx % chunkSize;
            frameValues[k] = dimStore[originalChunkIndex][originalChunkOffset];
        }
        var value = sampleValue(frameValues);
        var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
        var sampleChunkIndex = Math.floor(sampleFrameIdx / chunkSize);
        var sampleChunkOffset = sampleFrameIdx % chunkSize; // Only write value on the filtered data
        dimStore[sampleChunkIndex][sampleChunkOffset] = value;
        if (value < rawExtentOnDim[0]) rawExtentOnDim[0] = value;
        if (value > rawExtentOnDim[1]) rawExtentOnDim[1] = value;
        newIndices[offset++] = sampleFrameIdx;
    }
    list._count = offset;
    list._indices = newIndices;
    list.getRawIndex = $f643df856475f69e$var$getRawIndexWithIndices;
    return list;
};
/**
 * Get model of one data item.
 *
 * @param {number} idx
 */ // FIXME Model proxy ?
$f643df856475f69e$var$listProto.getItemModel = function(idx) {
    var hostModel = this.hostModel;
    return new $2b51b4bf776ec22e$exports(this.getRawDataItem(idx), hostModel, hostModel && hostModel.ecModel);
};
/**
 * Create a data differ
 * @param {module:echarts/data/List} otherList
 * @return {module:echarts/data/DataDiffer}
 */ $f643df856475f69e$var$listProto.diff = function(otherList) {
    var thisList = this;
    return new $8e5cd4a27af1b00f$exports(otherList ? otherList.getIndices() : [], this.getIndices(), function(idx) {
        return $f643df856475f69e$var$getId(otherList, idx);
    }, function(idx) {
        return $f643df856475f69e$var$getId(thisList, idx);
    });
};
/**
 * Get visual property.
 * @param {string} key
 */ $f643df856475f69e$var$listProto.getVisual = function(key) {
    var visual = this._visual;
    return visual && visual[key];
};
/**
 * Set visual property
 * @param {string|Object} key
 * @param {*} [value]
 *
 * @example
 *  setVisual('color', color);
 *  setVisual({
 *      'color': color
 *  });
 */ $f643df856475f69e$var$listProto.setVisual = function(key, val) {
    if ($f643df856475f69e$var$isObject(key)) {
        for(var name in key)if (key.hasOwnProperty(name)) this.setVisual(name, key[name]);
        return;
    }
    this._visual = this._visual || {};
    this._visual[key] = val;
};
/**
 * Set layout property.
 * @param {string|Object} key
 * @param {*} [val]
 */ $f643df856475f69e$var$listProto.setLayout = function(key, val) {
    if ($f643df856475f69e$var$isObject(key)) {
        for(var name in key)if (key.hasOwnProperty(name)) this.setLayout(name, key[name]);
        return;
    }
    this._layout[key] = val;
};
/**
 * Get layout property.
 * @param  {string} key.
 * @return {*}
 */ $f643df856475f69e$var$listProto.getLayout = function(key) {
    return this._layout[key];
};
/**
 * Get layout of single data item
 * @param {number} idx
 */ $f643df856475f69e$var$listProto.getItemLayout = function(idx) {
    return this._itemLayouts[idx];
};
/**
 * Set layout of single data item
 * @param {number} idx
 * @param {Object} layout
 * @param {boolean=} [merge=false]
 */ $f643df856475f69e$var$listProto.setItemLayout = function(idx, layout, merge) {
    this._itemLayouts[idx] = merge ? $ec279652dd95c27b$export$8b58be045bf06082(this._itemLayouts[idx] || {}, layout) : layout;
};
/**
 * Clear all layout of single data item
 */ $f643df856475f69e$var$listProto.clearItemLayouts = function() {
    this._itemLayouts.length = 0;
};
/**
 * Get visual property of single data item
 * @param {number} idx
 * @param {string} key
 * @param {boolean} [ignoreParent=false]
 */ $f643df856475f69e$var$listProto.getItemVisual = function(idx, key, ignoreParent) {
    var itemVisual = this._itemVisuals[idx];
    var val = itemVisual && itemVisual[key];
    if (val == null && !ignoreParent) // Use global visual property
    return this.getVisual(key);
    return val;
};
/**
 * Set visual property of single data item
 *
 * @param {number} idx
 * @param {string|Object} key
 * @param {*} [value]
 *
 * @example
 *  setItemVisual(0, 'color', color);
 *  setItemVisual(0, {
 *      'color': color
 *  });
 */ $f643df856475f69e$var$listProto.setItemVisual = function(idx, key, value) {
    var itemVisual = this._itemVisuals[idx] || {};
    var hasItemVisual = this.hasItemVisual;
    this._itemVisuals[idx] = itemVisual;
    if ($f643df856475f69e$var$isObject(key)) {
        for(var name in key)if (key.hasOwnProperty(name)) {
            itemVisual[name] = key[name];
            hasItemVisual[name] = true;
        }
        return;
    }
    itemVisual[key] = value;
    hasItemVisual[key] = true;
};
/**
 * Clear itemVisuals and list visual.
 */ $f643df856475f69e$var$listProto.clearAllVisual = function() {
    this._visual = {};
    this._itemVisuals = [];
    this.hasItemVisual = {};
};
var $f643df856475f69e$var$setItemDataAndSeriesIndex = function(child) {
    child.seriesIndex = this.seriesIndex;
    child.dataIndex = this.dataIndex;
    child.dataType = this.dataType;
};
/**
 * Set graphic element relative to data. It can be set as null
 * @param {number} idx
 * @param {module:zrender/Element} [el]
 */ $f643df856475f69e$var$listProto.setItemGraphicEl = function(idx, el) {
    var hostModel = this.hostModel;
    if (el) {
        // Add data index and series index for indexing the data by element
        // Useful in tooltip
        el.dataIndex = idx;
        el.dataType = this.dataType;
        el.seriesIndex = hostModel && hostModel.seriesIndex;
        if (el.type === "group") el.traverse($f643df856475f69e$var$setItemDataAndSeriesIndex, el);
    }
    this._graphicEls[idx] = el;
};
/**
 * @param {number} idx
 * @return {module:zrender/Element}
 */ $f643df856475f69e$var$listProto.getItemGraphicEl = function(idx) {
    return this._graphicEls[idx];
};
/**
 * @param {Function} cb
 * @param {*} context
 */ $f643df856475f69e$var$listProto.eachItemGraphicEl = function(cb, context) {
    $ec279652dd95c27b$export$79b2f7037acddd43(this._graphicEls, function(el, idx) {
        if (el) cb && cb.call(context, el, idx);
    });
};
/**
 * Shallow clone a new list except visual and layout properties, and graph elements.
 * New list only change the indices.
 */ $f643df856475f69e$var$listProto.cloneShallow = function(list) {
    if (!list) {
        var dimensionInfoList = $ec279652dd95c27b$export$871de8747c9eaa88(this.dimensions, this.getDimensionInfo, this);
        list = new $f643df856475f69e$var$List(dimensionInfoList, this.hostModel);
    } // FIXME
    list._storage = this._storage;
    $f643df856475f69e$var$transferProperties(list, this); // Clone will not change the data extent and indices
    if (this._indices) {
        var Ctor = this._indices.constructor;
        list._indices = new Ctor(this._indices);
    } else list._indices = null;
    list.getRawIndex = list._indices ? $f643df856475f69e$var$getRawIndexWithIndices : $f643df856475f69e$var$getRawIndexWithoutIndices;
    return list;
};
/**
 * Wrap some method to add more feature
 * @param {string} methodName
 * @param {Function} injectFunction
 */ $f643df856475f69e$var$listProto.wrapMethod = function(methodName, injectFunction) {
    var originalMethod = this[methodName];
    if (typeof originalMethod !== "function") return;
    this.__wrappedMethods = this.__wrappedMethods || [];
    this.__wrappedMethods.push(methodName);
    this[methodName] = function() {
        var res = originalMethod.apply(this, arguments);
        return injectFunction.apply(this, [
            res
        ].concat($ec279652dd95c27b$export$58adb3bec8346d0f(arguments)));
    };
}; // Methods that create a new list based on this list should be listed here.
// Notice that those method should `RETURN` the new list.
$f643df856475f69e$var$listProto.TRANSFERABLE_METHODS = [
    "cloneShallow",
    "downSample",
    "map"
]; // Methods that change indices of this list should be listed here.
$f643df856475f69e$var$listProto.CHANGABLE_METHODS = [
    "filterSelf",
    "selectRange"
];
var $f643df856475f69e$var$_default = $f643df856475f69e$var$List;
$f643df856475f69e$exports = $f643df856475f69e$var$_default;


var $c766697b1ee08f64$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $9f400f3216e0ad55$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9f400f3216e0ad55$var$createHashMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4;
var $9f400f3216e0ad55$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $9f400f3216e0ad55$var$isString = $ec279652dd95c27b$export$844ec244b1367d54;
var $9f400f3216e0ad55$var$defaults = $ec279652dd95c27b$export$ebe90cb607ad99e;
var $9f400f3216e0ad55$var$extend = $ec279652dd95c27b$export$8b58be045bf06082;
var $9f400f3216e0ad55$var$isObject = $ec279652dd95c27b$export$a6cdc56e425d0d0a;
var $9f400f3216e0ad55$var$clone = $ec279652dd95c27b$export$9cd59f9826255e47;

var $9f400f3216e0ad55$var$normalizeToArray = $d559f43cb9041423$export$4f07b212a02c8051;

var $9f400f3216e0ad55$var$guessOrdinal = $71e1a98f99449cca$export$c51adf1a2be01b9c;
var $9f400f3216e0ad55$var$BE_ORDINAL = $71e1a98f99449cca$export$328749e9c5b40760;


var $9f400f3216e0ad55$var$OTHER_DIMENSIONS = $b5496acb5150a0c1$export$15ee9443ac05a329;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @deprecated
 * Use `echarts/data/helper/createDimensions` instead.
 */ /**
 * @see {module:echarts/test/ut/spec/data/completeDimensions}
 *
 * This method builds the relationship between:
 * + "what the coord sys or series requires (see `sysDims`)",
 * + "what the user defines (in `encode` and `dimensions`, see `opt.dimsDef` and `opt.encodeDef`)"
 * + "what the data source provids (see `source`)".
 *
 * Some guess strategy will be adapted if user does not define something.
 * If no 'value' dimension specified, the first no-named dimension will be
 * named as 'value'.
 *
 * @param {Array.<string>} sysDims Necessary dimensions, like ['x', 'y'], which
 *      provides not only dim template, but also default order.
 *      properties: 'name', 'type', 'displayName'.
 *      `name` of each item provides default coord name.
 *      [{dimsDef: [string|Object, ...]}, ...] dimsDef of sysDim item provides default dim name, and
 *                                    provide dims count that the sysDim required.
 *      [{ordinalMeta}] can be specified.
 * @param {module:echarts/data/Source|Array|Object} source or data (for compatibal with pervious)
 * @param {Object} [opt]
 * @param {Array.<Object|string>} [opt.dimsDef] option.series.dimensions User defined dimensions
 *      For example: ['asdf', {name, type}, ...].
 * @param {Object|HashMap} [opt.encodeDef] option.series.encode {x: 2, y: [3, 1], tooltip: [1, 2], label: 3}
 * @param {Function} [opt.encodeDefaulter] Called if no `opt.encodeDef` exists.
 *      If not specified, auto find the next available data dim.
 *      param source {module:data/Source}
 *      param dimCount {number}
 *      return {Object} encode Never be `null/undefined`.
 * @param {string} [opt.generateCoord] Generate coord dim with the given name.
 *      If not specified, extra dim names will be:
 *      'value', 'value0', 'value1', ...
 * @param {number} [opt.generateCoordCount] By default, the generated dim name is `generateCoord`.
 *      If `generateCoordCount` specified, the generated dim names will be:
 *      `generateCoord` + 0, `generateCoord` + 1, ...
 *      can be Infinity, indicate that use all of the remain columns.
 * @param {number} [opt.dimCount] If not specified, guess by the first data item.
 * @return {Array.<module:data/DataDimensionInfo>}
 */ function $9f400f3216e0ad55$var$completeDimensions(sysDims, source, opt) {
    if (!$058c715583456086$exports.isInstance(source)) source = $058c715583456086$exports.seriesDataToSource(source);
    opt = opt || {};
    sysDims = (sysDims || []).slice();
    var dimsDef = (opt.dimsDef || []).slice();
    var dataDimNameMap = $9f400f3216e0ad55$var$createHashMap();
    var coordDimNameMap = $9f400f3216e0ad55$var$createHashMap(); // var valueCandidate;
    var result = [];
    var dimCount = $9f400f3216e0ad55$var$getDimCount(source, sysDims, dimsDef, opt.dimCount); // Apply user defined dims (`name` and `type`) and init result.
    for(var i = 0; i < dimCount; i++){
        var dimDefItem = dimsDef[i] = $9f400f3216e0ad55$var$extend({}, $9f400f3216e0ad55$var$isObject(dimsDef[i]) ? dimsDef[i] : {
            name: dimsDef[i]
        });
        var userDimName = dimDefItem.name;
        var resultItem = result[i] = new $972c5fe9ccf46f49$exports(); // Name will be applied later for avoiding duplication.
        if (userDimName != null && dataDimNameMap.get(userDimName) == null) {
            // Only if `series.dimensions` is defined in option
            // displayName, will be set, and dimension will be diplayed vertically in
            // tooltip by default.
            resultItem.name = resultItem.displayName = userDimName;
            dataDimNameMap.set(userDimName, i);
        }
        dimDefItem.type != null && (resultItem.type = dimDefItem.type);
        dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
    }
    var encodeDef = opt.encodeDef;
    if (!encodeDef && opt.encodeDefaulter) encodeDef = opt.encodeDefaulter(source, dimCount);
    encodeDef = $9f400f3216e0ad55$var$createHashMap(encodeDef); // Set `coordDim` and `coordDimIndex` by `encodeDef` and normalize `encodeDef`.
    encodeDef.each(function(dataDims, coordDim) {
        dataDims = $9f400f3216e0ad55$var$normalizeToArray(dataDims).slice(); // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
        // `{encode: {x: -1, y: 1}}`. Should not filter anything in
        // this case.
        if (dataDims.length === 1 && !$9f400f3216e0ad55$var$isString(dataDims[0]) && dataDims[0] < 0) {
            encodeDef.set(coordDim, false);
            return;
        }
        var validDataDims = encodeDef.set(coordDim, []);
        $9f400f3216e0ad55$var$each(dataDims, function(resultDimIdx, idx) {
            // The input resultDimIdx can be dim name or index.
            $9f400f3216e0ad55$var$isString(resultDimIdx) && (resultDimIdx = dataDimNameMap.get(resultDimIdx));
            if (resultDimIdx != null && resultDimIdx < dimCount) {
                validDataDims[idx] = resultDimIdx;
                applyDim(result[resultDimIdx], coordDim, idx);
            }
        });
    }); // Apply templetes and default order from `sysDims`.
    var availDimIdx = 0;
    $9f400f3216e0ad55$var$each(sysDims, function(sysDimItem, sysDimIndex) {
        var coordDim;
        var sysDimItem;
        var sysDimItemDimsDef;
        var sysDimItemOtherDims;
        if ($9f400f3216e0ad55$var$isString(sysDimItem)) {
            coordDim = sysDimItem;
            sysDimItem = {};
        } else {
            coordDim = sysDimItem.name;
            var ordinalMeta = sysDimItem.ordinalMeta;
            sysDimItem.ordinalMeta = null;
            sysDimItem = $9f400f3216e0ad55$var$clone(sysDimItem);
            sysDimItem.ordinalMeta = ordinalMeta; // `coordDimIndex` should not be set directly.
            sysDimItemDimsDef = sysDimItem.dimsDef;
            sysDimItemOtherDims = sysDimItem.otherDims;
            sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
        }
        var dataDims = encodeDef.get(coordDim); // negative resultDimIdx means no need to mapping.
        if (dataDims === false) return;
        var dataDims = $9f400f3216e0ad55$var$normalizeToArray(dataDims); // dimensions provides default dim sequences.
        if (!dataDims.length) for(var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++){
            while(availDimIdx < result.length && result[availDimIdx].coordDim != null)availDimIdx++;
            availDimIdx < result.length && dataDims.push(availDimIdx++);
        }
         // Apply templates.
        $9f400f3216e0ad55$var$each(dataDims, function(resultDimIdx, coordDimIndex) {
            var resultItem = result[resultDimIdx];
            applyDim($9f400f3216e0ad55$var$defaults(resultItem, sysDimItem), coordDim, coordDimIndex);
            if (resultItem.name == null && sysDimItemDimsDef) {
                var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
                !$9f400f3216e0ad55$var$isObject(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
                    name: sysDimItemDimsDefItem
                });
                resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
                resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
            } // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
            sysDimItemOtherDims && $9f400f3216e0ad55$var$defaults(resultItem.otherDims, sysDimItemOtherDims);
        });
    });
    function applyDim(resultItem, coordDim, coordDimIndex) {
        if ($9f400f3216e0ad55$var$OTHER_DIMENSIONS.get(coordDim) != null) resultItem.otherDims[coordDim] = coordDimIndex;
        else {
            resultItem.coordDim = coordDim;
            resultItem.coordDimIndex = coordDimIndex;
            coordDimNameMap.set(coordDim, true);
        }
    } // Make sure the first extra dim is 'value'.
    var generateCoord = opt.generateCoord;
    var generateCoordCount = opt.generateCoordCount;
    var fromZero = generateCoordCount != null;
    generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
    var extra = generateCoord || "value"; // Set dim `name` and other `coordDim` and other props.
    for(var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++){
        var resultItem = result[resultDimIdx] = result[resultDimIdx] || new $972c5fe9ccf46f49$exports();
        var coordDim = resultItem.coordDim;
        if (coordDim == null) {
            resultItem.coordDim = $9f400f3216e0ad55$var$genName(extra, coordDimNameMap, fromZero);
            resultItem.coordDimIndex = 0;
            if (!generateCoord || generateCoordCount <= 0) resultItem.isExtraCoord = true;
            generateCoordCount--;
        }
        resultItem.name == null && (resultItem.name = $9f400f3216e0ad55$var$genName(resultItem.coordDim, dataDimNameMap));
        if (resultItem.type == null && ($9f400f3216e0ad55$var$guessOrdinal(source, resultDimIdx, resultItem.name) === $9f400f3216e0ad55$var$BE_ORDINAL.Must // Consider the case:
         || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) resultItem.type = "ordinal";
    }
    return result;
} // ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calcualte bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in storage?
function $9f400f3216e0ad55$var$getDimCount(source, sysDims, dimsDef, optDimCount) {
    // Note that the result dimCount should not small than columns count
    // of data, otherwise `dataDimNameMap` checking will be incorrect.
    var dimCount = Math.max(source.dimensionsDetectCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
    $9f400f3216e0ad55$var$each(sysDims, function(sysDimItem) {
        var sysDimItemDimsDef = sysDimItem.dimsDef;
        sysDimItemDimsDef && (dimCount = Math.max(dimCount, sysDimItemDimsDef.length));
    });
    return dimCount;
}
function $9f400f3216e0ad55$var$genName(name, map, fromZero) {
    if (fromZero || map.get(name) != null) {
        var i = 0;
        while(map.get(name + i) != null)i++;
        name += i;
    }
    map.set(name, true);
    return name;
}
var $9f400f3216e0ad55$var$_default = $9f400f3216e0ad55$var$completeDimensions;
$9f400f3216e0ad55$exports = $9f400f3216e0ad55$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Substitute `completeDimensions`.
 * `completeDimensions` is to be deprecated.
 */ /**
 * @param {module:echarts/data/Source|module:echarts/data/List} source or data.
 * @param {Object|Array} [opt]
 * @param {Array.<string|Object>} [opt.coordDimensions=[]]
 * @param {number} [opt.dimensionsCount]
 * @param {string} [opt.generateCoord]
 * @param {string} [opt.generateCoordCount]
 * @param {Array.<string|Object>} [opt.dimensionsDefine=source.dimensionsDefine] Overwrite source define.
 * @param {Object|HashMap} [opt.encodeDefine=source.encodeDefine] Overwrite source define.
 * @param {Function} [opt.encodeDefaulter] Make default encode if user not specified.
 * @return {Array.<Object>} dimensionsInfo
 */ function $c766697b1ee08f64$var$_default(source, opt) {
    opt = opt || {};
    return $9f400f3216e0ad55$exports(opt.coordDimensions || [], source, {
        dimsDef: opt.dimensionsDefine || source.dimensionsDefine,
        encodeDef: opt.encodeDefine || source.encodeDefine,
        dimCount: opt.dimensionsCount,
        encodeDefaulter: opt.encodeDefaulter,
        generateCoord: opt.generateCoord,
        generateCoordCount: opt.generateCoordCount
    });
}
$c766697b1ee08f64$exports = $c766697b1ee08f64$var$_default;



var $10e48b57e44af7c1$var$SOURCE_FORMAT_ORIGINAL = $00bf3640e0468773$export$2823037fb9d8f0c6;

var $10e48b57e44af7c1$var$getDimensionTypeByAxis = $b5496acb5150a0c1$export$af1622903e71278e;

var $10e48b57e44af7c1$var$getDataItemValue = $d559f43cb9041423$export$2c944e12edb48d4b;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $b0b171afa1b3238e$export$f2befeb2f4933656;

var $b0b171afa1b3238e$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;

var $b0b171afa1b3238e$var$createHashMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4;
var $b0b171afa1b3238e$var$retrieve = $ec279652dd95c27b$export$8a4d17b6e8486e66;
var $b0b171afa1b3238e$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Helper for model references.
 * There are many manners to refer axis/coordSys.
 */ // TODO
// merge relevant logic to this file?
// check: "modelHelper" of tooltip and "BrushTargetManager".
/**
 * @class
 * For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // The index of the first category axis in `coordSysDims`.
 *     // `null/undefined` means no category axis exists.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */ function $b0b171afa1b3238e$var$CoordSysInfo(coordSysName) {
    /**
   * @type {string}
   */ this.coordSysName = coordSysName;
    /**
   * @type {Array.<string>}
   */ this.coordSysDims = [];
    /**
   * @type {module:zrender/core/util#HashMap}
   */ this.axisMap = $b0b171afa1b3238e$var$createHashMap();
    /**
   * @type {module:zrender/core/util#HashMap}
   */ this.categoryAxisMap = $b0b171afa1b3238e$var$createHashMap();
    /**
   * @type {number}
   */ this.firstCategoryDimIndex = null;
}
/**
 * @return {module:model/referHelper#CoordSysInfo}
 */ function $b0b171afa1b3238e$var$getCoordSysInfoBySeries(seriesModel) {
    var coordSysName = seriesModel.get("coordinateSystem");
    var result = new $b0b171afa1b3238e$var$CoordSysInfo(coordSysName);
    var fetch = $b0b171afa1b3238e$var$fetchers[coordSysName];
    if (fetch) {
        fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
        return result;
    }
}
var $b0b171afa1b3238e$var$fetchers = {
    cartesian2d: function(seriesModel, result, axisMap, categoryAxisMap) {
        var xAxisModel = seriesModel.getReferringComponents("xAxis")[0];
        var yAxisModel = seriesModel.getReferringComponents("yAxis")[0];
        result.coordSysDims = [
            "x",
            "y"
        ];
        axisMap.set("x", xAxisModel);
        axisMap.set("y", yAxisModel);
        if ($b0b171afa1b3238e$var$isCategory(xAxisModel)) {
            categoryAxisMap.set("x", xAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($b0b171afa1b3238e$var$isCategory(yAxisModel)) {
            categoryAxisMap.set("y", yAxisModel);
            result.firstCategoryDimIndex, result.firstCategoryDimIndex = 1;
        }
    },
    singleAxis: function(seriesModel, result, axisMap, categoryAxisMap) {
        var singleAxisModel = seriesModel.getReferringComponents("singleAxis")[0];
        result.coordSysDims = [
            "single"
        ];
        axisMap.set("single", singleAxisModel);
        if ($b0b171afa1b3238e$var$isCategory(singleAxisModel)) {
            categoryAxisMap.set("single", singleAxisModel);
            result.firstCategoryDimIndex = 0;
        }
    },
    polar: function(seriesModel, result, axisMap, categoryAxisMap) {
        var polarModel = seriesModel.getReferringComponents("polar")[0];
        var radiusAxisModel = polarModel.findAxisModel("radiusAxis");
        var angleAxisModel = polarModel.findAxisModel("angleAxis");
        result.coordSysDims = [
            "radius",
            "angle"
        ];
        axisMap.set("radius", radiusAxisModel);
        axisMap.set("angle", angleAxisModel);
        if ($b0b171afa1b3238e$var$isCategory(radiusAxisModel)) {
            categoryAxisMap.set("radius", radiusAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($b0b171afa1b3238e$var$isCategory(angleAxisModel)) {
            categoryAxisMap.set("angle", angleAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    geo: function(seriesModel, result, axisMap, categoryAxisMap) {
        result.coordSysDims = [
            "lng",
            "lat"
        ];
    },
    parallel: function(seriesModel, result, axisMap, categoryAxisMap) {
        var ecModel = seriesModel.ecModel;
        var parallelModel = ecModel.getComponent("parallel", seriesModel.get("parallelIndex"));
        var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
        $b0b171afa1b3238e$var$each(parallelModel.parallelAxisIndex, function(axisIndex, index) {
            var axisModel = ecModel.getComponent("parallelAxis", axisIndex);
            var axisDim = coordSysDims[index];
            axisMap.set(axisDim, axisModel);
            if ($b0b171afa1b3238e$var$isCategory(axisModel) && result.firstCategoryDimIndex == null) {
                categoryAxisMap.set(axisDim, axisModel);
                result.firstCategoryDimIndex = index;
            }
        });
    }
};
function $b0b171afa1b3238e$var$isCategory(axisModel) {
    return axisModel.get("type") === "category";
}
$b0b171afa1b3238e$export$f2befeb2f4933656 = $b0b171afa1b3238e$var$getCoordSysInfoBySeries;


var $10e48b57e44af7c1$var$getCoordSysInfoBySeries = $b0b171afa1b3238e$export$f2befeb2f4933656;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $1712a5e8fbedbcb3$export$f2165f9e8499b278;
var $1712a5e8fbedbcb3$export$1dedc39359ae35c;
var $1712a5e8fbedbcb3$export$909db2be4938fbdf;

var $1712a5e8fbedbcb3$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $1712a5e8fbedbcb3$var$isString = $ec279652dd95c27b$export$844ec244b1367d54;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Note that it is too complicated to support 3d stack by value
 * (have to create two-dimension inverted index), so in 3d case
 * we just support that stacked by index.
 *
 * @param {module:echarts/model/Series} seriesModel
 * @param {Array.<string|Object>} dimensionInfoList The same as the input of <module:echarts/data/List>.
 *        The input dimensionInfoList will be modified.
 * @param {Object} [opt]
 * @param {boolean} [opt.stackedCoordDimension=''] Specify a coord dimension if needed.
 * @param {boolean} [opt.byIndex=false]
 * @return {Object} calculationInfo
 * {
 *     stackedDimension: string
 *     stackedByDimension: string
 *     isStackedByIndex: boolean
 *     stackedOverDimension: string
 *     stackResultDimension: string
 * }
 */ function $1712a5e8fbedbcb3$var$enableDataStack(seriesModel, dimensionInfoList, opt) {
    opt = opt || {};
    var byIndex = opt.byIndex;
    var stackedCoordDimension = opt.stackedCoordDimension; // Compatibal: when `stack` is set as '', do not stack.
    var mayStack = !!(seriesModel && seriesModel.get("stack"));
    var stackedByDimInfo;
    var stackedDimInfo;
    var stackResultDimension;
    var stackedOverDimension;
    $1712a5e8fbedbcb3$var$each(dimensionInfoList, function(dimensionInfo, index) {
        if ($1712a5e8fbedbcb3$var$isString(dimensionInfo)) dimensionInfoList[index] = dimensionInfo = {
            name: dimensionInfo
        };
        if (mayStack && !dimensionInfo.isExtraCoord) {
            // Find the first ordinal dimension as the stackedByDimInfo.
            if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) stackedByDimInfo = dimensionInfo;
             // Find the first stackable dimension as the stackedDimInfo.
            if (!stackedDimInfo && dimensionInfo.type !== "ordinal" && dimensionInfo.type !== "time" && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) stackedDimInfo = dimensionInfo;
        }
    });
    if (stackedDimInfo && !byIndex && !stackedByDimInfo) // Compatible with previous design, value axis (time axis) only stack by index.
    // It may make sense if the user provides elaborately constructed data.
    byIndex = true;
     // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
    // That put stack logic in List is for using conveniently in echarts extensions, but it
    // might not be a good way.
    if (stackedDimInfo) {
        // Use a weird name that not duplicated with other names.
        stackResultDimension = "__\x00ecstackresult";
        stackedOverDimension = "__\x00ecstackedover"; // Create inverted index to fast query index by value.
        if (stackedByDimInfo) stackedByDimInfo.createInvertedIndices = true;
        var stackedDimCoordDim = stackedDimInfo.coordDim;
        var stackedDimType = stackedDimInfo.type;
        var stackedDimCoordIndex = 0;
        $1712a5e8fbedbcb3$var$each(dimensionInfoList, function(dimensionInfo) {
            if (dimensionInfo.coordDim === stackedDimCoordDim) stackedDimCoordIndex++;
        });
        dimensionInfoList.push({
            name: stackResultDimension,
            coordDim: stackedDimCoordDim,
            coordDimIndex: stackedDimCoordIndex,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true
        });
        stackedDimCoordIndex++;
        dimensionInfoList.push({
            name: stackedOverDimension,
            // This dimension contains stack base (generally, 0), so do not set it as
            // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
            coordDim: stackedOverDimension,
            coordDimIndex: stackedDimCoordIndex,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true
        });
    }
    return {
        stackedDimension: stackedDimInfo && stackedDimInfo.name,
        stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
        isStackedByIndex: byIndex,
        stackedOverDimension: stackedOverDimension,
        stackResultDimension: stackResultDimension
    };
}
/**
 * @param {module:echarts/data/List} data
 * @param {string} stackedDim
 */ function $1712a5e8fbedbcb3$var$isDimensionStacked(data, stackedDim) {
    // Each single series only maps to one pair of axis. So we do not need to
    // check stackByDim, whatever stacked by a dimension or stacked by index.
    return !!stackedDim && stackedDim === data.getCalculationInfo("stackedDimension"); // && (
//     stackedByDim != null
//         ? stackedByDim === data.getCalculationInfo('stackedByDimension')
//         : data.getCalculationInfo('isStackedByIndex')
// );
}
/**
 * @param {module:echarts/data/List} data
 * @param {string} targetDim
 * @param {string} [stackedByDim] If not input this parameter, check whether
 *                                stacked by index.
 * @return {string} dimension
 */ function $1712a5e8fbedbcb3$var$getStackedDimension(data, targetDim) {
    return $1712a5e8fbedbcb3$var$isDimensionStacked(data, targetDim) ? data.getCalculationInfo("stackResultDimension") : targetDim;
}
$1712a5e8fbedbcb3$export$f2165f9e8499b278 = $1712a5e8fbedbcb3$var$enableDataStack;
$1712a5e8fbedbcb3$export$1dedc39359ae35c = $1712a5e8fbedbcb3$var$isDimensionStacked;
$1712a5e8fbedbcb3$export$909db2be4938fbdf = $1712a5e8fbedbcb3$var$getStackedDimension;


var $10e48b57e44af7c1$var$enableDataStack = $1712a5e8fbedbcb3$export$f2165f9e8499b278;

var $10e48b57e44af7c1$var$makeSeriesEncodeForAxisCoordSys = $71e1a98f99449cca$export$37682b8fdd2e83d;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @param {module:echarts/data/Source|Array} source Or raw data.
 * @param {module:echarts/model/Series} seriesModel
 * @param {Object} [opt]
 * @param {string} [opt.generateCoord]
 * @param {boolean} [opt.useEncodeDefaulter]
 */ function $10e48b57e44af7c1$var$createListFromArray(source, seriesModel, opt) {
    opt = opt || {};
    if (!$058c715583456086$exports.isInstance(source)) source = $058c715583456086$exports.seriesDataToSource(source);
    var coordSysName = seriesModel.get("coordinateSystem");
    var registeredCoordSys = $9c36d0fff3b0f387$exports.get(coordSysName);
    var coordSysInfo = $10e48b57e44af7c1$var$getCoordSysInfoBySeries(seriesModel);
    var coordSysDimDefs;
    if (coordSysInfo) coordSysDimDefs = $ec279652dd95c27b$export$871de8747c9eaa88(coordSysInfo.coordSysDims, function(dim) {
        var dimInfo = {
            name: dim
        };
        var axisModel = coordSysInfo.axisMap.get(dim);
        if (axisModel) {
            var axisType = axisModel.get("type");
            dimInfo.type = $10e48b57e44af7c1$var$getDimensionTypeByAxis(axisType); // dimInfo.stackable = isStackable(axisType);
        }
        return dimInfo;
    });
    if (!coordSysDimDefs) // Get dimensions from registered coordinate system
    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || [
        "x",
        "y"
    ];
    var dimInfoList = $c766697b1ee08f64$exports(source, {
        coordDimensions: coordSysDimDefs,
        generateCoord: opt.generateCoord,
        encodeDefaulter: opt.useEncodeDefaulter ? $ec279652dd95c27b$export$c3095a23b368d1f2($10e48b57e44af7c1$var$makeSeriesEncodeForAxisCoordSys, coordSysDimDefs, seriesModel) : null
    });
    var firstCategoryDimIndex;
    var hasNameEncode;
    coordSysInfo && $ec279652dd95c27b$export$79b2f7037acddd43(dimInfoList, function(dimInfo, dimIndex) {
        var coordDim = dimInfo.coordDim;
        var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
        if (categoryAxisModel) {
            if (firstCategoryDimIndex == null) firstCategoryDimIndex = dimIndex;
            dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
        }
        if (dimInfo.otherDims.itemName != null) hasNameEncode = true;
    });
    if (!hasNameEncode && firstCategoryDimIndex != null) dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
    var stackCalculationInfo = $10e48b57e44af7c1$var$enableDataStack(seriesModel, dimInfoList);
    var list = new $f643df856475f69e$exports(dimInfoList, seriesModel);
    list.setCalculationInfo(stackCalculationInfo);
    var dimValueGetter = firstCategoryDimIndex != null && $10e48b57e44af7c1$var$isNeedCompleteOrdinalData(source) ? function(itemOpt, dimName, dataIndex, dimIndex) {
        // Use dataIndex as ordinal value in categoryAxis
        return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
    } : null;
    list.hasItemOption = false;
    list.initData(source, null, dimValueGetter);
    return list;
}
function $10e48b57e44af7c1$var$isNeedCompleteOrdinalData(source) {
    if (source.sourceFormat === $10e48b57e44af7c1$var$SOURCE_FORMAT_ORIGINAL) {
        var sampleItem = $10e48b57e44af7c1$var$firstDataNotNull(source.data || []);
        return sampleItem != null && !$ec279652dd95c27b$export$43bee75e5e14138e($10e48b57e44af7c1$var$getDataItemValue(sampleItem));
    }
}
function $10e48b57e44af7c1$var$firstDataNotNull(data) {
    var i = 0;
    while(i < data.length && data[i] == null)i++;
    return data[i];
}
var $10e48b57e44af7c1$var$_default = $10e48b57e44af7c1$var$createListFromArray;
$10e48b57e44af7c1$exports = $10e48b57e44af7c1$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $13542623aa20eeae$export$9c0ba8df7eb7b328;
var $13542623aa20eeae$export$51f3e70a54405d5a;
var $13542623aa20eeae$export$8941c4cacdc8f5a5;
var $13542623aa20eeae$export$3eac36a69f37d52;
var $13542623aa20eeae$export$742f19a75415b2ae;
var $13542623aa20eeae$export$a5a32f324c1fa457;
var $13542623aa20eeae$export$fef1c7f0af0b48d;
var $13542623aa20eeae$export$6d0bc2429155c088;
var $13542623aa20eeae$export$c2911c025243d6a6;

var $13542623aa20eeae$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;

var $f50a6e2f21e09df9$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bc005cc279c19f7c$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * // Scale class management
 * @module echarts/scale/Scale
 */ /**
 * @param {Object} [setting]
 */ function $bc005cc279c19f7c$var$Scale(setting) {
    this._setting = setting || {};
    /**
   * Extent
   * @type {Array.<number>}
   * @protected
   */ this._extent = [
        Infinity,
        -Infinity
    ];
    /**
   * Step is calculated in adjustExtent
   * @type {Array.<number>}
   * @protected
   */ this._interval = 0;
    this.init && this.init.apply(this, arguments);
}
/**
 * Parse input val to valid inner number.
 * @param {*} val
 * @return {number}
 */ $bc005cc279c19f7c$var$Scale.prototype.parse = function(val) {
    // Notice: This would be a trap here, If the implementation
    // of this method depends on extent, and this method is used
    // before extent set (like in dataZoom), it would be wrong.
    // Nevertheless, parse does not depend on extent generally.
    return val;
};
$bc005cc279c19f7c$var$Scale.prototype.getSetting = function(name) {
    return this._setting[name];
};
$bc005cc279c19f7c$var$Scale.prototype.contain = function(val) {
    var extent = this._extent;
    return val >= extent[0] && val <= extent[1];
};
/**
 * Normalize value to linear [0, 1], return 0.5 if extent span is 0
 * @param {number} val
 * @return {number}
 */ $bc005cc279c19f7c$var$Scale.prototype.normalize = function(val) {
    var extent = this._extent;
    if (extent[1] === extent[0]) return 0.5;
    return (val - extent[0]) / (extent[1] - extent[0]);
};
/**
 * Scale normalized value
 * @param {number} val
 * @return {number}
 */ $bc005cc279c19f7c$var$Scale.prototype.scale = function(val) {
    var extent = this._extent;
    return val * (extent[1] - extent[0]) + extent[0];
};
/**
 * Set extent from data
 * @param {Array.<number>} other
 */ $bc005cc279c19f7c$var$Scale.prototype.unionExtent = function(other) {
    var extent = this._extent;
    other[0] < extent[0] && (extent[0] = other[0]);
    other[1] > extent[1] && (extent[1] = other[1]); // not setExtent because in log axis it may transformed to power
// this.setExtent(extent[0], extent[1]);
};
/**
 * Set extent from data
 * @param {module:echarts/data/List} data
 * @param {string} dim
 */ $bc005cc279c19f7c$var$Scale.prototype.unionExtentFromData = function(data, dim) {
    this.unionExtent(data.getApproximateExtent(dim));
};
/**
 * Get extent
 * @return {Array.<number>}
 */ $bc005cc279c19f7c$var$Scale.prototype.getExtent = function() {
    return this._extent.slice();
};
/**
 * Set extent
 * @param {number} start
 * @param {number} end
 */ $bc005cc279c19f7c$var$Scale.prototype.setExtent = function(start, end) {
    var thisExtent = this._extent;
    if (!isNaN(start)) thisExtent[0] = start;
    if (!isNaN(end)) thisExtent[1] = end;
};
/**
 * When axis extent depends on data and no data exists,
 * axis ticks should not be drawn, which is named 'blank'.
 */ $bc005cc279c19f7c$var$Scale.prototype.isBlank = function() {
    return this._isBlank;
}, /**
 * When axis extent depends on data and no data exists,
 * axis ticks should not be drawn, which is named 'blank'.
 */ $bc005cc279c19f7c$var$Scale.prototype.setBlank = function(isBlank) {
    this._isBlank = isBlank;
};
/**
 * @abstract
 * @param {*} tick
 * @return {string} label of the tick.
 */ $bc005cc279c19f7c$var$Scale.prototype.getLabel = null;
$c125ba1250423743$export$cd4c3a4dca301c70($bc005cc279c19f7c$var$Scale);
$c125ba1250423743$export$241315e45585454d($bc005cc279c19f7c$var$Scale, {
    registerWhenExtend: true
});
var $bc005cc279c19f7c$var$_default = $bc005cc279c19f7c$var$Scale;
$bc005cc279c19f7c$exports = $bc005cc279c19f7c$var$_default;


var $7439ece03b1889e3$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7439ece03b1889e3$var$createHashMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4;
var $7439ece03b1889e3$var$isObject = $ec279652dd95c27b$export$a6cdc56e425d0d0a;
var $7439ece03b1889e3$var$map = $ec279652dd95c27b$export$871de8747c9eaa88;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @constructor
 * @param {Object} [opt]
 * @param {Object} [opt.categories=[]]
 * @param {Object} [opt.needCollect=false]
 * @param {Object} [opt.deduplication=false]
 */ function $7439ece03b1889e3$var$OrdinalMeta(opt) {
    /**
   * @readOnly
   * @type {Array.<string>}
   */ this.categories = opt.categories || [];
    /**
   * @private
   * @type {boolean}
   */ this._needCollect = opt.needCollect;
    /**
   * @private
   * @type {boolean}
   */ this._deduplication = opt.deduplication;
    /**
   * @private
   * @type {boolean}
   */ this._map;
}
/**
 * @param {module:echarts/model/Model} axisModel
 * @return {module:echarts/data/OrdinalMeta}
 */ $7439ece03b1889e3$var$OrdinalMeta.createByAxisModel = function(axisModel) {
    var option = axisModel.option;
    var data = option.data;
    var categories = data && $7439ece03b1889e3$var$map(data, $7439ece03b1889e3$var$getName);
    return new $7439ece03b1889e3$var$OrdinalMeta({
        categories: categories,
        needCollect: !categories,
        // deduplication is default in axis.
        deduplication: option.dedplication !== false
    });
};
var $7439ece03b1889e3$var$proto = $7439ece03b1889e3$var$OrdinalMeta.prototype;
/**
 * @param {string} category
 * @return {number} ordinal
 */ $7439ece03b1889e3$var$proto.getOrdinal = function(category) {
    return $7439ece03b1889e3$var$getOrCreateMap(this).get(category);
};
/**
 * @param {*} category
 * @return {number} The ordinal. If not found, return NaN.
 */ $7439ece03b1889e3$var$proto.parseAndCollect = function(category) {
    var index;
    var needCollect = this._needCollect; // The value of category dim can be the index of the given category set.
    // This feature is only supported when !needCollect, because we should
    // consider a common case: a value is 2017, which is a number but is
    // expected to be tread as a category. This case usually happen in dataset,
    // where it happent to be no need of the index feature.
    if (typeof category !== "string" && !needCollect) return category;
     // Optimize for the scenario:
    // category is ['2012-01-01', '2012-01-02', ...], where the input
    // data has been ensured not duplicate and is large data.
    // Notice, if a dataset dimension provide categroies, usually echarts
    // should remove duplication except user tell echarts dont do that
    // (set axis.deduplication = false), because echarts do not know whether
    // the values in the category dimension has duplication (consider the
    // parallel-aqi example)
    if (needCollect && !this._deduplication) {
        index = this.categories.length;
        this.categories[index] = category;
        return index;
    }
    var map = $7439ece03b1889e3$var$getOrCreateMap(this);
    index = map.get(category);
    if (index == null) {
        if (needCollect) {
            index = this.categories.length;
            this.categories[index] = category;
            map.set(category, index);
        } else index = NaN;
    }
    return index;
}; // Consider big data, do not create map until needed.
function $7439ece03b1889e3$var$getOrCreateMap(ordinalMeta) {
    return ordinalMeta._map || (ordinalMeta._map = $7439ece03b1889e3$var$createHashMap(ordinalMeta.categories));
}
function $7439ece03b1889e3$var$getName(obj) {
    if ($7439ece03b1889e3$var$isObject(obj) && obj.value != null) return obj.value;
    else return obj + "";
}
var $7439ece03b1889e3$var$_default = $7439ece03b1889e3$var$OrdinalMeta;
$7439ece03b1889e3$exports = $7439ece03b1889e3$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Linear continuous scale
 * @module echarts/coord/scale/Ordinal
 *
 * http://en.wikipedia.org/wiki/Level_of_measurement
 */ // FIXME only one data
var $f50a6e2f21e09df9$var$scaleProto = $bc005cc279c19f7c$exports.prototype;
var $f50a6e2f21e09df9$var$OrdinalScale = $bc005cc279c19f7c$exports.extend({
    type: "ordinal",
    /**
   * @param {module:echarts/data/OrdianlMeta|Array.<string>} ordinalMeta
   */ init: function(ordinalMeta, extent) {
        // Caution: Should not use instanceof, consider ec-extensions using
        // import approach to get OrdinalMeta class.
        if (!ordinalMeta || $ec279652dd95c27b$export$43bee75e5e14138e(ordinalMeta)) ordinalMeta = new $7439ece03b1889e3$exports({
            categories: ordinalMeta
        });
        this._ordinalMeta = ordinalMeta;
        this._extent = extent || [
            0,
            ordinalMeta.categories.length - 1
        ];
    },
    parse: function(val) {
        return typeof val === "string" ? this._ordinalMeta.getOrdinal(val) // val might be float.
         : Math.round(val);
    },
    contain: function(rank) {
        rank = this.parse(rank);
        return $f50a6e2f21e09df9$var$scaleProto.contain.call(this, rank) && this._ordinalMeta.categories[rank] != null;
    },
    /**
   * Normalize given rank or name to linear [0, 1]
   * @param {number|string} [val]
   * @return {number}
   */ normalize: function(val) {
        return $f50a6e2f21e09df9$var$scaleProto.normalize.call(this, this.parse(val));
    },
    scale: function(val) {
        return Math.round($f50a6e2f21e09df9$var$scaleProto.scale.call(this, val));
    },
    /**
   * @return {Array}
   */ getTicks: function() {
        var ticks = [];
        var extent = this._extent;
        var rank = extent[0];
        while(rank <= extent[1]){
            ticks.push(rank);
            rank++;
        }
        return ticks;
    },
    /**
   * Get item on rank n
   * @param {number} n
   * @return {string}
   */ getLabel: function(n) {
        if (!this.isBlank()) // Note that if no data, ordinalMeta.categories is an empty array.
        return this._ordinalMeta.categories[n];
    },
    /**
   * @return {number}
   */ count: function() {
        return this._extent[1] - this._extent[0] + 1;
    },
    /**
   * @override
   */ unionExtentFromData: function(data, dim) {
        this.unionExtent(data.getApproximateExtent(dim));
    },
    getOrdinalMeta: function() {
        return this._ordinalMeta;
    },
    niceTicks: $ec279652dd95c27b$export$8793edee2d425525,
    niceExtent: $ec279652dd95c27b$export$8793edee2d425525
});
/**
 * @return {module:echarts/scale/Time}
 */ $f50a6e2f21e09df9$var$OrdinalScale.create = function() {
    return new $f50a6e2f21e09df9$var$OrdinalScale();
};
var $f50a6e2f21e09df9$var$_default = $f50a6e2f21e09df9$var$OrdinalScale;
$f50a6e2f21e09df9$exports = $f50a6e2f21e09df9$var$_default;


var $d31daeaa402f1a9c$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $164662d25c20e709$export$eeea879a611eb991;
var $164662d25c20e709$export$86a060b060d3d31a;
var $164662d25c20e709$export$624b8c8c438031ad;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * For testable.
 */ var $164662d25c20e709$var$roundNumber = $2d742dbe7f960d8c$export$2077e0241d6afd3c;
/**
 * @param {Array.<number>} extent Both extent[0] and extent[1] should be valid number.
 *                                Should be extent[0] < extent[1].
 * @param {number} splitNumber splitNumber should be >= 1.
 * @param {number} [minInterval]
 * @param {number} [maxInterval]
 * @return {Object} {interval, intervalPrecision, niceTickExtent}
 */ function $164662d25c20e709$var$intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval) {
    var result = {};
    var span = extent[1] - extent[0];
    var interval = result.interval = $2d742dbe7f960d8c$export$7a695fe44258210b(span / splitNumber, true);
    if (minInterval != null && interval < minInterval) interval = result.interval = minInterval;
    if (maxInterval != null && interval > maxInterval) interval = result.interval = maxInterval;
     // Tow more digital for tick.
    var precision = result.intervalPrecision = $164662d25c20e709$var$getIntervalPrecision(interval); // Niced extent inside original extent
    var niceTickExtent = result.niceTickExtent = [
        $164662d25c20e709$var$roundNumber(Math.ceil(extent[0] / interval) * interval, precision),
        $164662d25c20e709$var$roundNumber(Math.floor(extent[1] / interval) * interval, precision)
    ];
    $164662d25c20e709$var$fixExtent(niceTickExtent, extent);
    return result;
}
/**
 * @param {number} interval
 * @return {number} interval precision
 */ function $164662d25c20e709$var$getIntervalPrecision(interval) {
    // Tow more digital for tick.
    return $2d742dbe7f960d8c$export$6d86ba4ca4984d31(interval) + 2;
}
function $164662d25c20e709$var$clamp(niceTickExtent, idx, extent) {
    niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
} // In some cases (e.g., splitNumber is 1), niceTickExtent may be out of extent.
function $164662d25c20e709$var$fixExtent(niceTickExtent, extent) {
    !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
    !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
    $164662d25c20e709$var$clamp(niceTickExtent, 0, extent);
    $164662d25c20e709$var$clamp(niceTickExtent, 1, extent);
    if (niceTickExtent[0] > niceTickExtent[1]) niceTickExtent[0] = niceTickExtent[1];
}
$164662d25c20e709$export$eeea879a611eb991 = $164662d25c20e709$var$intervalScaleNiceTicks;
$164662d25c20e709$export$86a060b060d3d31a = $164662d25c20e709$var$getIntervalPrecision;
$164662d25c20e709$export$624b8c8c438031ad = $164662d25c20e709$var$fixExtent;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Interval scale
 * @module echarts/scale/Interval
 */ var $d31daeaa402f1a9c$var$roundNumber = $2d742dbe7f960d8c$export$2077e0241d6afd3c;
/**
 * @alias module:echarts/coord/scale/Interval
 * @constructor
 */ var $d31daeaa402f1a9c$var$IntervalScale = $bc005cc279c19f7c$exports.extend({
    type: "interval",
    _interval: 0,
    _intervalPrecision: 2,
    setExtent: function(start, end) {
        var thisExtent = this._extent; //start,end may be a Number like '25',so...
        if (!isNaN(start)) thisExtent[0] = parseFloat(start);
        if (!isNaN(end)) thisExtent[1] = parseFloat(end);
    },
    unionExtent: function(other) {
        var extent = this._extent;
        other[0] < extent[0] && (extent[0] = other[0]);
        other[1] > extent[1] && (extent[1] = other[1]); // unionExtent may called by it's sub classes
        $d31daeaa402f1a9c$var$IntervalScale.prototype.setExtent.call(this, extent[0], extent[1]);
    },
    /**
   * Get interval
   */ getInterval: function() {
        return this._interval;
    },
    /**
   * Set interval
   */ setInterval: function(interval) {
        this._interval = interval; // Dropped auto calculated niceExtent and use user setted extent
        // We assume user wan't to set both interval, min, max to get a better result
        this._niceExtent = this._extent.slice();
        this._intervalPrecision = $164662d25c20e709$export$86a060b060d3d31a(interval);
    },
    /**
   * @param {boolean} [expandToNicedExtent=false] If expand the ticks to niced extent.
   * @return {Array.<number>}
   */ getTicks: function(expandToNicedExtent) {
        var interval = this._interval;
        var extent = this._extent;
        var niceTickExtent = this._niceExtent;
        var intervalPrecision = this._intervalPrecision;
        var ticks = []; // If interval is 0, return [];
        if (!interval) return ticks;
         // Consider this case: using dataZoom toolbox, zoom and zoom.
        var safeLimit = 10000;
        if (extent[0] < niceTickExtent[0]) {
            if (expandToNicedExtent) ticks.push($d31daeaa402f1a9c$var$roundNumber(niceTickExtent[0] - interval, intervalPrecision));
            else ticks.push(extent[0]);
        }
        var tick = niceTickExtent[0];
        while(tick <= niceTickExtent[1]){
            ticks.push(tick); // Avoid rounding error
            tick = $d31daeaa402f1a9c$var$roundNumber(tick + interval, intervalPrecision);
            if (tick === ticks[ticks.length - 1]) break;
            if (ticks.length > safeLimit) return [];
        } // Consider this case: the last item of ticks is smaller
        // than niceTickExtent[1] and niceTickExtent[1] === extent[1].
        var lastNiceTick = ticks.length ? ticks[ticks.length - 1] : niceTickExtent[1];
        if (extent[1] > lastNiceTick) {
            if (expandToNicedExtent) ticks.push($d31daeaa402f1a9c$var$roundNumber(lastNiceTick + interval, intervalPrecision));
            else ticks.push(extent[1]);
        }
        return ticks;
    },
    /**
   * @param {number} [splitNumber=5]
   * @return {Array.<Array.<number>>}
   */ getMinorTicks: function(splitNumber) {
        var ticks = this.getTicks(true);
        var minorTicks = [];
        var extent = this.getExtent();
        for(var i = 1; i < ticks.length; i++){
            var nextTick = ticks[i];
            var prevTick = ticks[i - 1];
            var count = 0;
            var minorTicksGroup = [];
            var interval = nextTick - prevTick;
            var minorInterval = interval / splitNumber;
            while(count < splitNumber - 1){
                var minorTick = $2d742dbe7f960d8c$export$2077e0241d6afd3c(prevTick + (count + 1) * minorInterval); // For the first and last interval. The count may be less than splitNumber.
                if (minorTick > extent[0] && minorTick < extent[1]) minorTicksGroup.push(minorTick);
                count++;
            }
            minorTicks.push(minorTicksGroup);
        }
        return minorTicks;
    },
    /**
   * @param {number} data
   * @param {Object} [opt]
   * @param {number|string} [opt.precision] If 'auto', use nice presision.
   * @param {boolean} [opt.pad] returns 1.50 but not 1.5 if precision is 2.
   * @return {string}
   */ getLabel: function(data, opt) {
        if (data == null) return "";
        var precision = opt && opt.precision;
        if (precision == null) precision = $2d742dbe7f960d8c$export$6d86ba4ca4984d31(data) || 0;
        else if (precision === "auto") // Should be more precise then tick.
        precision = this._intervalPrecision;
         // (1) If `precision` is set, 12.005 should be display as '12.00500'.
        // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
        data = $d31daeaa402f1a9c$var$roundNumber(data, precision, true);
        return $a4be9366aeb9fcc8$export$b6fe44657ce35c42(data);
    },
    /**
   * Update interval and extent of intervals for nice ticks
   *
   * @param {number} [splitNumber = 5] Desired number of ticks
   * @param {number} [minInterval]
   * @param {number} [maxInterval]
   */ niceTicks: function(splitNumber, minInterval, maxInterval) {
        splitNumber = splitNumber || 5;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        if (!isFinite(span)) return;
         // User may set axis min 0 and data are all negative
        // FIXME If it needs to reverse ?
        if (span < 0) {
            span = -span;
            extent.reverse();
        }
        var result = $164662d25c20e709$export$eeea879a611eb991(extent, splitNumber, minInterval, maxInterval);
        this._intervalPrecision = result.intervalPrecision;
        this._interval = result.interval;
        this._niceExtent = result.niceTickExtent;
    },
    /**
   * Nice extent.
   * @param {Object} opt
   * @param {number} [opt.splitNumber = 5] Given approx tick number
   * @param {boolean} [opt.fixMin=false]
   * @param {boolean} [opt.fixMax=false]
   * @param {boolean} [opt.minInterval]
   * @param {boolean} [opt.maxInterval]
   */ niceExtent: function(opt) {
        var extent = this._extent; // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            if (extent[0] !== 0) {
                // Expand extent
                var expandSize = extent[0]; // In the fowllowing case
                //      Axis has been fixed max 100
                //      Plus data are all 100 and axis extent are [100, 100].
                // Extend to the both side will cause expanded max is larger than fixed max.
                // So only expand to the smaller side.
                if (!opt.fixMax) {
                    extent[1] += expandSize / 2;
                    extent[0] -= expandSize / 2;
                } else extent[0] -= expandSize / 2;
            } else extent[1] = 1;
        }
        var span = extent[1] - extent[0]; // If there are no data and extent are [Infinity, -Infinity]
        if (!isFinite(span)) {
            extent[0] = 0;
            extent[1] = 1;
        }
        this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;
        var interval = this._interval;
        if (!opt.fixMin) extent[0] = $d31daeaa402f1a9c$var$roundNumber(Math.floor(extent[0] / interval) * interval);
        if (!opt.fixMax) extent[1] = $d31daeaa402f1a9c$var$roundNumber(Math.ceil(extent[1] / interval) * interval);
    }
});
/**
 * @return {module:echarts/scale/Time}
 */ $d31daeaa402f1a9c$var$IntervalScale.create = function() {
    return new $d31daeaa402f1a9c$var$IntervalScale();
};
var $d31daeaa402f1a9c$var$_default = $d31daeaa402f1a9c$var$IntervalScale;
$d31daeaa402f1a9c$exports = $d31daeaa402f1a9c$var$_default;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $249e780a835e3f86$export$658df087977b9e84;
var $249e780a835e3f86$export$efbd0c3f5ab0d5e4;
var $249e780a835e3f86$export$20769dafc84e0299;
var $249e780a835e3f86$export$35920bb6556da1c2;
var $249e780a835e3f86$export$b3219800bda33a1f;
var $249e780a835e3f86$export$1fcd87ee6628f095;


var $249e780a835e3f86$var$parsePercent = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f;

var $249e780a835e3f86$var$isDimensionStacked = $1712a5e8fbedbcb3$export$1dedc39359ae35c;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Float32Array */ var $249e780a835e3f86$var$STACK_PREFIX = "__ec_stack_";
var $249e780a835e3f86$var$LARGE_BAR_MIN_WIDTH = 0.5;
var $249e780a835e3f86$var$LargeArr = typeof Float32Array !== "undefined" ? Float32Array : Array;
function $249e780a835e3f86$var$getSeriesStackId(seriesModel) {
    return seriesModel.get("stack") || $249e780a835e3f86$var$STACK_PREFIX + seriesModel.seriesIndex;
}
function $249e780a835e3f86$var$getAxisKey(axis) {
    return axis.dim + axis.index;
}
/**
 * @param {Object} opt
 * @param {module:echarts/coord/Axis} opt.axis Only support category axis currently.
 * @param {number} opt.count Positive interger.
 * @param {number} [opt.barWidth]
 * @param {number} [opt.barMaxWidth]
 * @param {number} [opt.barMinWidth]
 * @param {number} [opt.barGap]
 * @param {number} [opt.barCategoryGap]
 * @return {Object} {width, offset, offsetCenter} If axis.type is not 'category', return undefined.
 */ function $249e780a835e3f86$var$getLayoutOnAxis(opt) {
    var params = [];
    var baseAxis = opt.axis;
    var axisKey = "axis0";
    if (baseAxis.type !== "category") return;
    var bandWidth = baseAxis.getBandWidth();
    for(var i = 0; i < opt.count || 0; i++)params.push($ec279652dd95c27b$export$ebe90cb607ad99e({
        bandWidth: bandWidth,
        axisKey: axisKey,
        stackId: $249e780a835e3f86$var$STACK_PREFIX + i
    }, opt));
    var widthAndOffsets = $249e780a835e3f86$var$doCalBarWidthAndOffset(params);
    var result = [];
    for(var i = 0; i < opt.count; i++){
        var item = widthAndOffsets[axisKey][$249e780a835e3f86$var$STACK_PREFIX + i];
        item.offsetCenter = item.offset + item.width / 2;
        result.push(item);
    }
    return result;
}
function $249e780a835e3f86$var$prepareLayoutBarSeries(seriesType, ecModel) {
    var seriesModels = [];
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        // Check series coordinate, do layout for cartesian2d only
        if ($249e780a835e3f86$var$isOnCartesian(seriesModel) && !$249e780a835e3f86$var$isInLargeMode(seriesModel)) seriesModels.push(seriesModel);
    });
    return seriesModels;
}
/**
 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
 * values.
 * This works for time axes, value axes, and log axes.
 * For a single time axis, return value is in the form like
 * {'x_0': [1000000]}.
 * The value of 1000000 is in milliseconds.
 */ function $249e780a835e3f86$var$getValueAxesMinGaps(barSeries) {
    /**
   * Map from axis.index to values.
   * For a single time axis, axisValues is in the form like
   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
   * Items in axisValues[x], e.g. 1495555200000, are time values of all
   * series.
   */ var axisValues = {};
    $ec279652dd95c27b$export$79b2f7037acddd43(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        if (baseAxis.type !== "time" && baseAxis.type !== "value") return;
        var data = seriesModel.getData();
        var key = baseAxis.dim + "_" + baseAxis.index;
        var dim = data.mapDimension(baseAxis.dim);
        for(var i = 0, cnt = data.count(); i < cnt; ++i){
            var value = data.get(dim, i);
            if (!axisValues[key]) // No previous data for the axis
            axisValues[key] = [
                value
            ];
            else // No value in previous series
            axisValues[key].push(value);
             // Ignore duplicated time values in the same axis
        }
    });
    var axisMinGaps = [];
    for(var key in axisValues)if (axisValues.hasOwnProperty(key)) {
        var valuesInAxis = axisValues[key];
        if (valuesInAxis) {
            // Sort axis values into ascending order to calculate gaps
            valuesInAxis.sort(function(a, b) {
                return a - b;
            });
            var min = null;
            for(var j = 1; j < valuesInAxis.length; ++j){
                var delta = valuesInAxis[j] - valuesInAxis[j - 1];
                if (delta > 0) // Ignore 0 delta because they are of the same axis value
                min = min === null ? delta : Math.min(min, delta);
            } // Set to null if only have one data
            axisMinGaps[key] = min;
        }
    }
    return axisMinGaps;
}
function $249e780a835e3f86$var$makeColumnLayout(barSeries) {
    var axisMinGaps = $249e780a835e3f86$var$getValueAxesMinGaps(barSeries);
    var seriesInfoList = [];
    $ec279652dd95c27b$export$79b2f7037acddd43(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var axisExtent = baseAxis.getExtent();
        var bandWidth;
        if (baseAxis.type === "category") bandWidth = baseAxis.getBandWidth();
        else if (baseAxis.type === "value" || baseAxis.type === "time") {
            var key = baseAxis.dim + "_" + baseAxis.index;
            var minGap = axisMinGaps[key];
            var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
            var scale = baseAxis.scale.getExtent();
            var scaleSpan = Math.abs(scale[1] - scale[0]);
            bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
        } else {
            var data = seriesModel.getData();
            bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
        }
        var barWidth = $249e780a835e3f86$var$parsePercent(seriesModel.get("barWidth"), bandWidth);
        var barMaxWidth = $249e780a835e3f86$var$parsePercent(seriesModel.get("barMaxWidth"), bandWidth);
        var barMinWidth = $249e780a835e3f86$var$parsePercent(// the auto-calculated bar width might be less than 1.
        seriesModel.get("barMinWidth") || 1, bandWidth);
        var barGap = seriesModel.get("barGap");
        var barCategoryGap = seriesModel.get("barCategoryGap");
        seriesInfoList.push({
            bandWidth: bandWidth,
            barWidth: barWidth,
            barMaxWidth: barMaxWidth,
            barMinWidth: barMinWidth,
            barGap: barGap,
            barCategoryGap: barCategoryGap,
            axisKey: $249e780a835e3f86$var$getAxisKey(baseAxis),
            stackId: $249e780a835e3f86$var$getSeriesStackId(seriesModel)
        });
    });
    return $249e780a835e3f86$var$doCalBarWidthAndOffset(seriesInfoList);
}
function $249e780a835e3f86$var$doCalBarWidthAndOffset(seriesInfoList) {
    // Columns info on each category axis. Key is cartesian name
    var columnsMap = {};
    $ec279652dd95c27b$export$79b2f7037acddd43(seriesInfoList, function(seriesInfo, idx) {
        var axisKey = seriesInfo.axisKey;
        var bandWidth = seriesInfo.bandWidth;
        var columnsOnAxis = columnsMap[axisKey] || {
            bandWidth: bandWidth,
            remainedWidth: bandWidth,
            autoWidthCount: 0,
            categoryGap: "20%",
            gap: "30%",
            stacks: {}
        };
        var stacks = columnsOnAxis.stacks;
        columnsMap[axisKey] = columnsOnAxis;
        var stackId = seriesInfo.stackId;
        if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
        stacks[stackId] = stacks[stackId] || {
            width: 0,
            maxWidth: 0
        }; // Caution: In a single coordinate system, these barGrid attributes
        // will be shared by series. Consider that they have default values,
        // only the attributes set on the last series will work.
        // Do not change this fact unless there will be a break change.
        var barWidth = seriesInfo.barWidth;
        if (barWidth && !stacks[stackId].width) {
            // See #6312, do not restrict width.
            stacks[stackId].width = barWidth;
            barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
            columnsOnAxis.remainedWidth -= barWidth;
        }
        var barMaxWidth = seriesInfo.barMaxWidth;
        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
        var barMinWidth = seriesInfo.barMinWidth;
        barMinWidth && (stacks[stackId].minWidth = barMinWidth);
        var barGap = seriesInfo.barGap;
        barGap != null && (columnsOnAxis.gap = barGap);
        var barCategoryGap = seriesInfo.barCategoryGap;
        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
    });
    var result = {};
    $ec279652dd95c27b$export$79b2f7037acddd43(columnsMap, function(columnsOnAxis, coordSysName) {
        result[coordSysName] = {};
        var stacks = columnsOnAxis.stacks;
        var bandWidth = columnsOnAxis.bandWidth;
        var categoryGap = $249e780a835e3f86$var$parsePercent(columnsOnAxis.categoryGap, bandWidth);
        var barGapPercent = $249e780a835e3f86$var$parsePercent(columnsOnAxis.gap, 1);
        var remainedWidth = columnsOnAxis.remainedWidth;
        var autoWidthCount = columnsOnAxis.autoWidthCount;
        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
        $ec279652dd95c27b$export$79b2f7037acddd43(stacks, function(column) {
            var maxWidth = column.maxWidth;
            var minWidth = column.minWidth;
            if (!column.width) {
                var finalWidth = autoWidth;
                if (maxWidth && maxWidth < finalWidth) finalWidth = Math.min(maxWidth, remainedWidth);
                 // `minWidth` has higher priority. `minWidth` decide that wheter the
                // bar is able to be visible. So `minWidth` should not be restricted
                // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
                // the extreme cases for `value` axis, bars are allowed to overlap
                // with each other if `minWidth` specified.
                if (minWidth && minWidth > finalWidth) finalWidth = minWidth;
                if (finalWidth !== autoWidth) {
                    column.width = finalWidth;
                    remainedWidth -= finalWidth + barGapPercent * finalWidth;
                    autoWidthCount--;
                }
            } else {
                // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
                // CSS does. Becuase barWidth can be a percent value, where
                // `barMaxWidth` can be used to restrict the final width.
                var finalWidth = column.width;
                if (maxWidth) finalWidth = Math.min(finalWidth, maxWidth);
                 // `minWidth` has higher priority, as described above
                if (minWidth) finalWidth = Math.max(finalWidth, minWidth);
                column.width = finalWidth;
                remainedWidth -= finalWidth + barGapPercent * finalWidth;
                autoWidthCount--;
            }
        }); // Recalculate width again
        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        var widthSum = 0;
        var lastColumn;
        $ec279652dd95c27b$export$79b2f7037acddd43(stacks, function(column, idx) {
            if (!column.width) column.width = autoWidth;
            lastColumn = column;
            widthSum += column.width * (1 + barGapPercent);
        });
        if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
        var offset = -widthSum / 2;
        $ec279652dd95c27b$export$79b2f7037acddd43(stacks, function(column, stackId) {
            result[coordSysName][stackId] = result[coordSysName][stackId] || {
                bandWidth: bandWidth,
                offset: offset,
                width: column.width
            };
            offset += column.width * (1 + barGapPercent);
        });
    });
    return result;
}
/**
 * @param {Object} barWidthAndOffset The result of makeColumnLayout
 * @param {module:echarts/coord/Axis} axis
 * @param {module:echarts/model/Series} [seriesModel] If not provided, return all.
 * @return {Object} {stackId: {offset, width}} or {offset, width} if seriesModel provided.
 */ function $249e780a835e3f86$var$retrieveColumnLayout(barWidthAndOffset, axis, seriesModel) {
    if (barWidthAndOffset && axis) {
        var result = barWidthAndOffset[$249e780a835e3f86$var$getAxisKey(axis)];
        if (result != null && seriesModel != null) result = result[$249e780a835e3f86$var$getSeriesStackId(seriesModel)];
        return result;
    }
}
/**
 * @param {string} seriesType
 * @param {module:echarts/model/Global} ecModel
 */ function $249e780a835e3f86$var$layout(seriesType, ecModel) {
    var seriesModels = $249e780a835e3f86$var$prepareLayoutBarSeries(seriesType, ecModel);
    var barWidthAndOffset = $249e780a835e3f86$var$makeColumnLayout(seriesModels);
    var lastStackCoords = {};
    var lastStackCoordsOrigin = {};
    $ec279652dd95c27b$export$79b2f7037acddd43(seriesModels, function(seriesModel) {
        var data = seriesModel.getData();
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var stackId = $249e780a835e3f86$var$getSeriesStackId(seriesModel);
        var columnLayoutInfo = barWidthAndOffset[$249e780a835e3f86$var$getAxisKey(baseAxis)][stackId];
        var columnOffset = columnLayoutInfo.offset;
        var columnWidth = columnLayoutInfo.width;
        var valueAxis = cartesian.getOtherAxis(baseAxis);
        var barMinHeight = seriesModel.get("barMinHeight") || 0;
        lastStackCoords[stackId] = lastStackCoords[stackId] || [];
        lastStackCoordsOrigin[stackId] = lastStackCoordsOrigin[stackId] || []; // Fix #4243
        data.setLayout({
            bandWidth: columnLayoutInfo.bandWidth,
            offset: columnOffset,
            size: columnWidth
        });
        var valueDim = data.mapDimension(valueAxis.dim);
        var baseDim = data.mapDimension(baseAxis.dim);
        var stacked = $249e780a835e3f86$var$isDimensionStacked(data, valueDim);
        var isValueAxisH = valueAxis.isHorizontal();
        var valueAxisStart = $249e780a835e3f86$var$getValueAxisStart(baseAxis, valueAxis, stacked);
        for(var idx = 0, len = data.count(); idx < len; idx++){
            var value = data.get(valueDim, idx);
            var baseValue = data.get(baseDim, idx);
            var sign = value >= 0 ? "p" : "n";
            var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
            // stackResultDimension directly.
            if (stacked) {
                // Only ordinal axis can be stacked.
                if (!lastStackCoords[stackId][baseValue]) lastStackCoords[stackId][baseValue] = {
                    p: valueAxisStart,
                    // Positive stack
                    n: valueAxisStart // Negative stack
                };
                 // Should also consider #4243
                baseCoord = lastStackCoords[stackId][baseValue][sign];
            }
            var x;
            var y;
            var width;
            var height;
            if (isValueAxisH) {
                var coord = cartesian.dataToPoint([
                    value,
                    baseValue
                ]);
                x = baseCoord;
                y = coord[1] + columnOffset;
                width = coord[0] - valueAxisStart;
                height = columnWidth;
                if (Math.abs(width) < barMinHeight) width = (width < 0 ? -1 : 1) * barMinHeight;
                 // Ignore stack from NaN value
                if (!isNaN(width)) stacked && (lastStackCoords[stackId][baseValue][sign] += width);
            } else {
                var coord = cartesian.dataToPoint([
                    baseValue,
                    value
                ]);
                x = coord[0] + columnOffset;
                y = baseCoord;
                width = columnWidth;
                height = coord[1] - valueAxisStart;
                if (Math.abs(height) < barMinHeight) // Include zero to has a positive bar
                height = (height <= 0 ? -1 : 1) * barMinHeight;
                 // Ignore stack from NaN value
                if (!isNaN(height)) stacked && (lastStackCoords[stackId][baseValue][sign] += height);
            }
            data.setItemLayout(idx, {
                x: x,
                y: y,
                width: width,
                height: height
            });
        }
    }, this);
} // TODO: Do not support stack in large mode yet.
var $249e780a835e3f86$var$largeLayout = {
    seriesType: "bar",
    plan: $a77c5f604e87a748$exports(),
    reset: function(seriesModel) {
        if (!$249e780a835e3f86$var$isOnCartesian(seriesModel) || !$249e780a835e3f86$var$isInLargeMode(seriesModel)) return;
        var data = seriesModel.getData();
        var cartesian = seriesModel.coordinateSystem;
        var coordLayout = cartesian.grid.getRect();
        var baseAxis = cartesian.getBaseAxis();
        var valueAxis = cartesian.getOtherAxis(baseAxis);
        var valueDim = data.mapDimension(valueAxis.dim);
        var baseDim = data.mapDimension(baseAxis.dim);
        var valueAxisHorizontal = valueAxis.isHorizontal();
        var valueDimIdx = valueAxisHorizontal ? 0 : 1;
        var barWidth = $249e780a835e3f86$var$retrieveColumnLayout($249e780a835e3f86$var$makeColumnLayout([
            seriesModel
        ]), baseAxis, seriesModel).width;
        if (!(barWidth > $249e780a835e3f86$var$LARGE_BAR_MIN_WIDTH)) // jshint ignore:line
        barWidth = $249e780a835e3f86$var$LARGE_BAR_MIN_WIDTH;
        return {
            progress: progress
        };
        function progress(params, data) {
            var count = params.count;
            var largePoints = new $249e780a835e3f86$var$LargeArr(count * 2);
            var largeBackgroundPoints = new $249e780a835e3f86$var$LargeArr(count * 2);
            var largeDataIndices = new $249e780a835e3f86$var$LargeArr(count);
            var dataIndex;
            var coord = [];
            var valuePair = [];
            var pointsOffset = 0;
            var idxOffset = 0;
            while((dataIndex = params.next()) != null){
                valuePair[valueDimIdx] = data.get(valueDim, dataIndex);
                valuePair[1 - valueDimIdx] = data.get(baseDim, dataIndex);
                coord = cartesian.dataToPoint(valuePair, null, coord); // Data index might not be in order, depends on `progressiveChunkMode`.
                largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coordLayout.x + coordLayout.width : coord[0];
                largePoints[pointsOffset++] = coord[0];
                largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coord[1] : coordLayout.y + coordLayout.height;
                largePoints[pointsOffset++] = coord[1];
                largeDataIndices[idxOffset++] = dataIndex;
            }
            data.setLayout({
                largePoints: largePoints,
                largeDataIndices: largeDataIndices,
                largeBackgroundPoints: largeBackgroundPoints,
                barWidth: barWidth,
                valueAxisStart: $249e780a835e3f86$var$getValueAxisStart(baseAxis, valueAxis, false),
                backgroundStart: valueAxisHorizontal ? coordLayout.x : coordLayout.y,
                valueAxisHorizontal: valueAxisHorizontal
            });
        }
    }
};
function $249e780a835e3f86$var$isOnCartesian(seriesModel) {
    return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === "cartesian2d";
}
function $249e780a835e3f86$var$isInLargeMode(seriesModel) {
    return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
} // See cases in `test/bar-start.html` and `#7412`, `#8747`.
function $249e780a835e3f86$var$getValueAxisStart(baseAxis, valueAxis, stacked) {
    return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === "log" ? 1 : 0));
}
$249e780a835e3f86$export$658df087977b9e84 = $249e780a835e3f86$var$getLayoutOnAxis;
$249e780a835e3f86$export$efbd0c3f5ab0d5e4 = $249e780a835e3f86$var$prepareLayoutBarSeries;
$249e780a835e3f86$export$20769dafc84e0299 = $249e780a835e3f86$var$makeColumnLayout;
$249e780a835e3f86$export$35920bb6556da1c2 = $249e780a835e3f86$var$retrieveColumnLayout;
$249e780a835e3f86$export$b3219800bda33a1f = $249e780a835e3f86$var$layout;
$249e780a835e3f86$export$1fcd87ee6628f095 = $249e780a835e3f86$var$largeLayout;


var $13542623aa20eeae$var$prepareLayoutBarSeries = $249e780a835e3f86$export$efbd0c3f5ab0d5e4;
var $13542623aa20eeae$var$makeColumnLayout = $249e780a835e3f86$export$20769dafc84e0299;
var $13542623aa20eeae$var$retrieveColumnLayout = $249e780a835e3f86$export$35920bb6556da1c2;

var $38e09771cae01bb4$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embeded for some of the code in this file:
* The "scaleLevels" was originally copied from "d3.js" with some
* modifications made for this project.
* (See more details in the comment on the definition of "scaleLevels" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ // [About UTC and local time zone]:
// In most cases, `number.parseDate` will treat input data string as local time
// (except time zone is specified in time string). And `format.formateTime` returns
// local time by default. option.useUTC is false by default. This design have
// concidered these common case:
// (1) Time that is persistent in server is in UTC, but it is needed to be diplayed
// in local time by default.
// (2) By default, the input data string (e.g., '2011-01-02') should be displayed
// as its original time, without any time difference.
var $38e09771cae01bb4$var$intervalScaleProto = $d31daeaa402f1a9c$exports.prototype;
var $38e09771cae01bb4$var$mathCeil = Math.ceil;
var $38e09771cae01bb4$var$mathFloor = Math.floor;
var $38e09771cae01bb4$var$ONE_SECOND = 1000;
var $38e09771cae01bb4$var$ONE_MINUTE = $38e09771cae01bb4$var$ONE_SECOND * 60;
var $38e09771cae01bb4$var$ONE_HOUR = $38e09771cae01bb4$var$ONE_MINUTE * 60;
var $38e09771cae01bb4$var$ONE_DAY = $38e09771cae01bb4$var$ONE_HOUR * 24; // FIXME 公用？
var $38e09771cae01bb4$var$bisect = function(a, x, lo, hi) {
    while(lo < hi){
        var mid = lo + hi >>> 1;
        if (a[mid][1] < x) lo = mid + 1;
        else hi = mid;
    }
    return lo;
};
/**
 * @alias module:echarts/coord/scale/Time
 * @constructor
 */ var $38e09771cae01bb4$var$TimeScale = $d31daeaa402f1a9c$exports.extend({
    type: "time",
    /**
   * @override
   */ getLabel: function(val) {
        var stepLvl = this._stepLvl;
        var date = new Date(val);
        return $a4be9366aeb9fcc8$export$3203edd9e5edd663(stepLvl[0], date, this.getSetting("useUTC"));
    },
    /**
   * @override
   */ niceExtent: function(opt) {
        var extent = this._extent; // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            // Expand extent
            extent[0] -= $38e09771cae01bb4$var$ONE_DAY;
            extent[1] += $38e09771cae01bb4$var$ONE_DAY;
        } // If there are no data and extent are [Infinity, -Infinity]
        if (extent[1] === -Infinity && extent[0] === Infinity) {
            var d = new Date();
            extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
            extent[0] = extent[1] - $38e09771cae01bb4$var$ONE_DAY;
        }
        this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;
        var interval = this._interval;
        if (!opt.fixMin) extent[0] = $2d742dbe7f960d8c$export$2077e0241d6afd3c($38e09771cae01bb4$var$mathFloor(extent[0] / interval) * interval);
        if (!opt.fixMax) extent[1] = $2d742dbe7f960d8c$export$2077e0241d6afd3c($38e09771cae01bb4$var$mathCeil(extent[1] / interval) * interval);
    },
    /**
   * @override
   */ niceTicks: function(approxTickNum, minInterval, maxInterval) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        var approxInterval = span / approxTickNum;
        if (minInterval != null && approxInterval < minInterval) approxInterval = minInterval;
        if (maxInterval != null && approxInterval > maxInterval) approxInterval = maxInterval;
        var scaleLevelsLen = $38e09771cae01bb4$var$scaleLevels.length;
        var idx = $38e09771cae01bb4$var$bisect($38e09771cae01bb4$var$scaleLevels, approxInterval, 0, scaleLevelsLen);
        var level = $38e09771cae01bb4$var$scaleLevels[Math.min(idx, scaleLevelsLen - 1)];
        var interval = level[1]; // Same with interval scale if span is much larger than 1 year
        if (level[0] === "year") {
            var yearSpan = span / interval; // From "Nice Numbers for Graph Labels" of Graphic Gems
            // var niceYearSpan = numberUtil.nice(yearSpan, false);
            var yearStep = $2d742dbe7f960d8c$export$7a695fe44258210b(yearSpan / approxTickNum, true);
            interval *= yearStep;
        }
        var timezoneOffset = this.getSetting("useUTC") ? 0 : new Date(+extent[0] || +extent[1]).getTimezoneOffset() * 60000;
        var niceExtent = [
            Math.round($38e09771cae01bb4$var$mathCeil((extent[0] - timezoneOffset) / interval) * interval + timezoneOffset),
            Math.round($38e09771cae01bb4$var$mathFloor((extent[1] - timezoneOffset) / interval) * interval + timezoneOffset)
        ];
        $164662d25c20e709$export$624b8c8c438031ad(niceExtent, extent);
        this._stepLvl = level; // Interval will be used in getTicks
        this._interval = interval;
        this._niceExtent = niceExtent;
    },
    parse: function(val) {
        // val might be float.
        return +$2d742dbe7f960d8c$export$6b862160d295c8e(val);
    }
});
$ec279652dd95c27b$export$79b2f7037acddd43([
    "contain",
    "normalize"
], function(methodName) {
    $38e09771cae01bb4$var$TimeScale.prototype[methodName] = function(val) {
        return $38e09771cae01bb4$var$intervalScaleProto[methodName].call(this, this.parse(val));
    };
});
/**
 * This implementation was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ var $38e09771cae01bb4$var$scaleLevels = [
    [
        "hh:mm:ss",
        $38e09771cae01bb4$var$ONE_SECOND
    ],
    [
        "hh:mm:ss",
        $38e09771cae01bb4$var$ONE_SECOND * 5
    ],
    [
        "hh:mm:ss",
        $38e09771cae01bb4$var$ONE_SECOND * 10
    ],
    [
        "hh:mm:ss",
        $38e09771cae01bb4$var$ONE_SECOND * 15
    ],
    [
        "hh:mm:ss",
        $38e09771cae01bb4$var$ONE_SECOND * 30
    ],
    [
        "hh:mm\nMM-dd",
        $38e09771cae01bb4$var$ONE_MINUTE
    ],
    [
        "hh:mm\nMM-dd",
        $38e09771cae01bb4$var$ONE_MINUTE * 5
    ],
    [
        "hh:mm\nMM-dd",
        $38e09771cae01bb4$var$ONE_MINUTE * 10
    ],
    [
        "hh:mm\nMM-dd",
        $38e09771cae01bb4$var$ONE_MINUTE * 15
    ],
    [
        "hh:mm\nMM-dd",
        $38e09771cae01bb4$var$ONE_MINUTE * 30
    ],
    [
        "hh:mm\nMM-dd",
        $38e09771cae01bb4$var$ONE_HOUR
    ],
    [
        "hh:mm\nMM-dd",
        $38e09771cae01bb4$var$ONE_HOUR * 2
    ],
    [
        "hh:mm\nMM-dd",
        $38e09771cae01bb4$var$ONE_HOUR * 6
    ],
    [
        "hh:mm\nMM-dd",
        $38e09771cae01bb4$var$ONE_HOUR * 12
    ],
    [
        "MM-dd\nyyyy",
        $38e09771cae01bb4$var$ONE_DAY
    ],
    [
        "MM-dd\nyyyy",
        $38e09771cae01bb4$var$ONE_DAY * 2
    ],
    [
        "MM-dd\nyyyy",
        $38e09771cae01bb4$var$ONE_DAY * 3
    ],
    [
        "MM-dd\nyyyy",
        $38e09771cae01bb4$var$ONE_DAY * 4
    ],
    [
        "MM-dd\nyyyy",
        $38e09771cae01bb4$var$ONE_DAY * 5
    ],
    [
        "MM-dd\nyyyy",
        $38e09771cae01bb4$var$ONE_DAY * 6
    ],
    [
        "week",
        $38e09771cae01bb4$var$ONE_DAY * 7
    ],
    [
        "MM-dd\nyyyy",
        $38e09771cae01bb4$var$ONE_DAY * 10
    ],
    [
        "week",
        $38e09771cae01bb4$var$ONE_DAY * 14
    ],
    [
        "week",
        $38e09771cae01bb4$var$ONE_DAY * 21
    ],
    [
        "month",
        $38e09771cae01bb4$var$ONE_DAY * 31
    ],
    [
        "week",
        $38e09771cae01bb4$var$ONE_DAY * 42
    ],
    [
        "month",
        $38e09771cae01bb4$var$ONE_DAY * 62
    ],
    [
        "week",
        $38e09771cae01bb4$var$ONE_DAY * 70
    ],
    [
        "quarter",
        $38e09771cae01bb4$var$ONE_DAY * 95
    ],
    [
        "month",
        $38e09771cae01bb4$var$ONE_DAY * 124
    ],
    [
        "month",
        $38e09771cae01bb4$var$ONE_DAY * 155
    ],
    [
        "half-year",
        $38e09771cae01bb4$var$ONE_DAY * 380 / 2
    ],
    [
        "month",
        $38e09771cae01bb4$var$ONE_DAY * 248
    ],
    [
        "month",
        $38e09771cae01bb4$var$ONE_DAY * 310
    ],
    [
        "year",
        $38e09771cae01bb4$var$ONE_DAY * 380
    ] // 1Y
];
/**
 * @param {module:echarts/model/Model}
 * @return {module:echarts/scale/Time}
 */ $38e09771cae01bb4$var$TimeScale.create = function(model) {
    return new $38e09771cae01bb4$var$TimeScale({
        useUTC: model.ecModel.get("useUTC")
    });
};
var $38e09771cae01bb4$var$_default = $38e09771cae01bb4$var$TimeScale;
$38e09771cae01bb4$exports = $38e09771cae01bb4$var$_default;


var $8c161e42bb81a4d8$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Log scale
 * @module echarts/scale/Log
 */ // Use some method of IntervalScale
var $8c161e42bb81a4d8$var$scaleProto = $bc005cc279c19f7c$exports.prototype;
var $8c161e42bb81a4d8$var$intervalScaleProto = $d31daeaa402f1a9c$exports.prototype;
var $8c161e42bb81a4d8$var$getPrecisionSafe = $2d742dbe7f960d8c$export$6d86ba4ca4984d31;
var $8c161e42bb81a4d8$var$roundingErrorFix = $2d742dbe7f960d8c$export$2077e0241d6afd3c;
var $8c161e42bb81a4d8$var$mathFloor = Math.floor;
var $8c161e42bb81a4d8$var$mathCeil = Math.ceil;
var $8c161e42bb81a4d8$var$mathPow = Math.pow;
var $8c161e42bb81a4d8$var$mathLog = Math.log;
var $8c161e42bb81a4d8$var$LogScale = $bc005cc279c19f7c$exports.extend({
    type: "log",
    base: 10,
    $constructor: function() {
        $bc005cc279c19f7c$exports.apply(this, arguments);
        this._originalScale = new $d31daeaa402f1a9c$exports();
    },
    /**
   * @param {boolean} [expandToNicedExtent=false] If expand the ticks to niced extent.
   * @return {Array.<number>}
   */ getTicks: function(expandToNicedExtent) {
        var originalScale = this._originalScale;
        var extent = this._extent;
        var originalExtent = originalScale.getExtent();
        return $ec279652dd95c27b$export$871de8747c9eaa88($8c161e42bb81a4d8$var$intervalScaleProto.getTicks.call(this, expandToNicedExtent), function(val) {
            var powVal = $2d742dbe7f960d8c$export$2077e0241d6afd3c($8c161e42bb81a4d8$var$mathPow(this.base, val)); // Fix #4158
            powVal = val === extent[0] && originalScale.__fixMin ? $8c161e42bb81a4d8$var$fixRoundingError(powVal, originalExtent[0]) : powVal;
            powVal = val === extent[1] && originalScale.__fixMax ? $8c161e42bb81a4d8$var$fixRoundingError(powVal, originalExtent[1]) : powVal;
            return powVal;
        }, this);
    },
    /**
   * @param {number} splitNumber
   * @return {Array.<Array.<number>>}
   */ getMinorTicks: $8c161e42bb81a4d8$var$intervalScaleProto.getMinorTicks,
    /**
   * @param {number} val
   * @return {string}
   */ getLabel: $8c161e42bb81a4d8$var$intervalScaleProto.getLabel,
    /**
   * @param  {number} val
   * @return {number}
   */ scale: function(val) {
        val = $8c161e42bb81a4d8$var$scaleProto.scale.call(this, val);
        return $8c161e42bb81a4d8$var$mathPow(this.base, val);
    },
    /**
   * @param {number} start
   * @param {number} end
   */ setExtent: function(start, end) {
        var base = this.base;
        start = $8c161e42bb81a4d8$var$mathLog(start) / $8c161e42bb81a4d8$var$mathLog(base);
        end = $8c161e42bb81a4d8$var$mathLog(end) / $8c161e42bb81a4d8$var$mathLog(base);
        $8c161e42bb81a4d8$var$intervalScaleProto.setExtent.call(this, start, end);
    },
    /**
   * @return {number} end
   */ getExtent: function() {
        var base = this.base;
        var extent = $8c161e42bb81a4d8$var$scaleProto.getExtent.call(this);
        extent[0] = $8c161e42bb81a4d8$var$mathPow(base, extent[0]);
        extent[1] = $8c161e42bb81a4d8$var$mathPow(base, extent[1]); // Fix #4158
        var originalScale = this._originalScale;
        var originalExtent = originalScale.getExtent();
        originalScale.__fixMin && (extent[0] = $8c161e42bb81a4d8$var$fixRoundingError(extent[0], originalExtent[0]));
        originalScale.__fixMax && (extent[1] = $8c161e42bb81a4d8$var$fixRoundingError(extent[1], originalExtent[1]));
        return extent;
    },
    /**
   * @param  {Array.<number>} extent
   */ unionExtent: function(extent) {
        this._originalScale.unionExtent(extent);
        var base = this.base;
        extent[0] = $8c161e42bb81a4d8$var$mathLog(extent[0]) / $8c161e42bb81a4d8$var$mathLog(base);
        extent[1] = $8c161e42bb81a4d8$var$mathLog(extent[1]) / $8c161e42bb81a4d8$var$mathLog(base);
        $8c161e42bb81a4d8$var$scaleProto.unionExtent.call(this, extent);
    },
    /**
   * @override
   */ unionExtentFromData: function(data, dim) {
        // TODO
        // filter value that <= 0
        this.unionExtent(data.getApproximateExtent(dim));
    },
    /**
   * Update interval and extent of intervals for nice ticks
   * @param  {number} [approxTickNum = 10] Given approx tick number
   */ niceTicks: function(approxTickNum) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        if (span === Infinity || span <= 0) return;
        var interval = $2d742dbe7f960d8c$export$82dd68b83a44b253(span);
        var err = approxTickNum / span * interval; // Filter ticks to get closer to the desired count.
        if (err <= 0.5) interval *= 10;
         // Interval should be integer
        while(!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0)interval *= 10;
        var niceExtent = [
            $2d742dbe7f960d8c$export$2077e0241d6afd3c($8c161e42bb81a4d8$var$mathCeil(extent[0] / interval) * interval),
            $2d742dbe7f960d8c$export$2077e0241d6afd3c($8c161e42bb81a4d8$var$mathFloor(extent[1] / interval) * interval)
        ];
        this._interval = interval;
        this._niceExtent = niceExtent;
    },
    /**
   * Nice extent.
   * @override
   */ niceExtent: function(opt) {
        $8c161e42bb81a4d8$var$intervalScaleProto.niceExtent.call(this, opt);
        var originalScale = this._originalScale;
        originalScale.__fixMin = opt.fixMin;
        originalScale.__fixMax = opt.fixMax;
    }
});
$ec279652dd95c27b$export$79b2f7037acddd43([
    "contain",
    "normalize"
], function(methodName) {
    $8c161e42bb81a4d8$var$LogScale.prototype[methodName] = function(val) {
        val = $8c161e42bb81a4d8$var$mathLog(val) / $8c161e42bb81a4d8$var$mathLog(this.base);
        return $8c161e42bb81a4d8$var$scaleProto[methodName].call(this, val);
    };
});
$8c161e42bb81a4d8$var$LogScale.create = function() {
    return new $8c161e42bb81a4d8$var$LogScale();
};
function $8c161e42bb81a4d8$var$fixRoundingError(val, originalVal) {
    return $8c161e42bb81a4d8$var$roundingErrorFix(val, $8c161e42bb81a4d8$var$getPrecisionSafe(originalVal));
}
var $8c161e42bb81a4d8$var$_default = $8c161e42bb81a4d8$var$LogScale;
$8c161e42bb81a4d8$exports = $8c161e42bb81a4d8$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Get axis scale extent before niced.
 * Item of returned array can only be number (including Infinity and NaN).
 */ function $13542623aa20eeae$var$getScaleExtent(scale, model) {
    var scaleType = scale.type;
    var min = model.getMin();
    var max = model.getMax();
    var originalExtent = scale.getExtent();
    var axisDataLen;
    var boundaryGap;
    var span;
    if (scaleType === "ordinal") axisDataLen = model.getCategories().length;
    else {
        boundaryGap = model.get("boundaryGap");
        if (!$ec279652dd95c27b$export$43bee75e5e14138e(boundaryGap)) boundaryGap = [
            boundaryGap || 0,
            boundaryGap || 0
        ];
        if (typeof boundaryGap[0] === "boolean") boundaryGap = [
            0,
            0
        ];
        boundaryGap[0] = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(boundaryGap[0], 1);
        boundaryGap[1] = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(boundaryGap[1], 1);
        span = originalExtent[1] - originalExtent[0] || Math.abs(originalExtent[0]);
    } // Notice: When min/max is not set (that is, when there are null/undefined,
    // which is the most common case), these cases should be ensured:
    // (1) For 'ordinal', show all axis.data.
    // (2) For others:
    //      + `boundaryGap` is applied (if min/max set, boundaryGap is
    //      disabled).
    //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
    //      be the result that originalExtent enlarged by boundaryGap.
    // (3) If no data, it should be ensured that `scale.setBlank` is set.
    // FIXME
    // (1) When min/max is 'dataMin' or 'dataMax', should boundaryGap be able to used?
    // (2) When `needCrossZero` and all data is positive/negative, should it be ensured
    // that the results processed by boundaryGap are positive/negative?
    if (min === "dataMin") min = originalExtent[0];
    else if (typeof min === "function") min = min({
        min: originalExtent[0],
        max: originalExtent[1]
    });
    if (max === "dataMax") max = originalExtent[1];
    else if (typeof max === "function") max = max({
        min: originalExtent[0],
        max: originalExtent[1]
    });
    var fixMin = min != null;
    var fixMax = max != null;
    if (min == null) min = scaleType === "ordinal" ? axisDataLen ? 0 : NaN : originalExtent[0] - boundaryGap[0] * span;
    if (max == null) max = scaleType === "ordinal" ? axisDataLen ? axisDataLen - 1 : NaN : originalExtent[1] + boundaryGap[1] * span;
    (min == null || !isFinite(min)) && (min = NaN);
    (max == null || !isFinite(max)) && (max = NaN);
    scale.setBlank($ec279652dd95c27b$export$7d667b9a0c48c975(min) || $ec279652dd95c27b$export$7d667b9a0c48c975(max) || scaleType === "ordinal" && !scale.getOrdinalMeta().categories.length); // Evaluate if axis needs cross zero
    if (model.getNeedCrossZero()) {
        // Axis is over zero and min is not set
        if (min > 0 && max > 0 && !fixMin) min = 0;
         // Axis is under zero and max is not set
        if (min < 0 && max < 0 && !fixMax) max = 0;
    } // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
    // is base axis
    // FIXME
    // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
    // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
    //     Should not depend on series type `bar`?
    // (3) Fix that might overlap when using dataZoom.
    // (4) Consider other chart types using `barGrid`?
    // See #6728, #4862, `test/bar-overflow-time-plot.html`
    var ecModel = model.ecModel;
    if (ecModel && scaleType === "time") {
        var barSeriesModels = $13542623aa20eeae$var$prepareLayoutBarSeries("bar", ecModel);
        var isBaseAxisAndHasBarSeries;
        $ec279652dd95c27b$export$79b2f7037acddd43(barSeriesModels, function(seriesModel) {
            isBaseAxisAndHasBarSeries |= seriesModel.getBaseAxis() === model.axis;
        });
        if (isBaseAxisAndHasBarSeries) {
            // Calculate placement of bars on axis
            var barWidthAndOffset = $13542623aa20eeae$var$makeColumnLayout(barSeriesModels); // Adjust axis min and max to account for overflow
            var adjustedScale = $13542623aa20eeae$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset);
            min = adjustedScale.min;
            max = adjustedScale.max;
        }
    }
    return {
        extent: [
            min,
            max
        ],
        // "fix" means "fixed", the value should not be
        // changed in the subsequent steps.
        fixMin: fixMin,
        fixMax: fixMax
    };
}
function $13542623aa20eeae$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset) {
    // Get Axis Length
    var axisExtent = model.axis.getExtent();
    var axisLength = axisExtent[1] - axisExtent[0]; // Get bars on current base axis and calculate min and max overflow
    var barsOnCurrentAxis = $13542623aa20eeae$var$retrieveColumnLayout(barWidthAndOffset, model.axis);
    if (barsOnCurrentAxis === undefined) return {
        min: min,
        max: max
    };
    var minOverflow = Infinity;
    $ec279652dd95c27b$export$79b2f7037acddd43(barsOnCurrentAxis, function(item) {
        minOverflow = Math.min(item.offset, minOverflow);
    });
    var maxOverflow = -Infinity;
    $ec279652dd95c27b$export$79b2f7037acddd43(barsOnCurrentAxis, function(item) {
        maxOverflow = Math.max(item.offset + item.width, maxOverflow);
    });
    minOverflow = Math.abs(minOverflow);
    maxOverflow = Math.abs(maxOverflow);
    var totalOverFlow = minOverflow + maxOverflow; // Calulate required buffer based on old range and overflow
    var oldRange = max - min;
    var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
    var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
    max += overflowBuffer * (maxOverflow / totalOverFlow);
    min -= overflowBuffer * (minOverflow / totalOverFlow);
    return {
        min: min,
        max: max
    };
}
function $13542623aa20eeae$var$niceScaleExtent(scale, model) {
    var extentInfo = $13542623aa20eeae$var$getScaleExtent(scale, model);
    var extent = extentInfo.extent;
    var splitNumber = model.get("splitNumber");
    if (scale.type === "log") scale.base = model.get("logBase");
    var scaleType = scale.type;
    scale.setExtent(extent[0], extent[1]);
    scale.niceExtent({
        splitNumber: splitNumber,
        fixMin: extentInfo.fixMin,
        fixMax: extentInfo.fixMax,
        minInterval: scaleType === "interval" || scaleType === "time" ? model.get("minInterval") : null,
        maxInterval: scaleType === "interval" || scaleType === "time" ? model.get("maxInterval") : null
    }); // If some one specified the min, max. And the default calculated interval
    // is not good enough. He can specify the interval. It is often appeared
    // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
    // to be 60.
    // FIXME
    var interval = model.get("interval");
    if (interval != null) scale.setInterval && scale.setInterval(interval);
}
/**
 * @param {module:echarts/model/Model} model
 * @param {string} [axisType] Default retrieve from model.type
 * @return {module:echarts/scale/*}
 */ function $13542623aa20eeae$var$createScaleByModel(model, axisType) {
    axisType = axisType || model.get("type");
    if (axisType) switch(axisType){
        // Buildin scale
        case "category":
            return new $f50a6e2f21e09df9$exports(model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(), [
                Infinity,
                -Infinity
            ]);
        case "value":
            return new $d31daeaa402f1a9c$exports();
        // Extended scale, like time and log
        default:
            return ($bc005cc279c19f7c$exports.getClass(axisType) || $d31daeaa402f1a9c$exports).create(model);
    }
}
/**
 * Check if the axis corss 0
 */ function $13542623aa20eeae$var$ifAxisCrossZero(axis) {
    var dataExtent = axis.scale.getExtent();
    var min = dataExtent[0];
    var max = dataExtent[1];
    return !(min > 0 && max > 0 || min < 0 && max < 0);
}
/**
 * @param {module:echarts/coord/Axis} axis
 * @return {Function} Label formatter function.
 *         param: {number} tickValue,
 *         param: {number} idx, the index in all ticks.
 *                         If category axis, this param is not requied.
 *         return: {string} label string.
 */ function $13542623aa20eeae$var$makeLabelFormatter(axis) {
    var labelFormatter = axis.getLabelModel().get("formatter");
    var categoryTickStart = axis.type === "category" ? axis.scale.getExtent()[0] : null;
    if (typeof labelFormatter === "string") {
        labelFormatter = function(tpl) {
            return function(val) {
                // For category axis, get raw value; for numeric axis,
                // get foramtted label like '1,333,444'.
                val = axis.scale.getLabel(val);
                return tpl.replace("{value}", val != null ? val : "");
            };
        }(labelFormatter); // Consider empty array
        return labelFormatter;
    } else if (typeof labelFormatter === "function") return function(tickValue, idx) {
        // The original intention of `idx` is "the index of the tick in all ticks".
        // But the previous implementation of category axis do not consider the
        // `axisLabel.interval`, which cause that, for example, the `interval` is
        // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
        // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
        // the definition here for back compatibility.
        if (categoryTickStart != null) idx = tickValue - categoryTickStart;
        return labelFormatter($13542623aa20eeae$var$getAxisRawValue(axis, tickValue), idx);
    };
    else return function(tick) {
        return axis.scale.getLabel(tick);
    };
}
function $13542623aa20eeae$var$getAxisRawValue(axis, value) {
    // In category axis with data zoom, tick is not the original
    // index of axis.data. So tick should not be exposed to user
    // in category axis.
    return axis.type === "category" ? axis.scale.getLabel(value) : value;
}
/**
 * @param {module:echarts/coord/Axis} axis
 * @return {module:zrender/core/BoundingRect} Be null/undefined if no labels.
 */ function $13542623aa20eeae$var$estimateLabelUnionRect(axis) {
    var axisModel = axis.model;
    var scale = axis.scale;
    if (!axisModel.get("axisLabel.show") || scale.isBlank()) return;
    var isCategory = axis.type === "category";
    var realNumberScaleTicks;
    var tickCount;
    var categoryScaleExtent = scale.getExtent(); // Optimize for large category data, avoid call `getTicks()`.
    if (isCategory) tickCount = scale.count();
    else {
        realNumberScaleTicks = scale.getTicks();
        tickCount = realNumberScaleTicks.length;
    }
    var axisLabelModel = axis.getLabelModel();
    var labelFormatter = $13542623aa20eeae$var$makeLabelFormatter(axis);
    var rect;
    var step = 1; // Simple optimization for large amount of labels
    if (tickCount > 40) step = Math.ceil(tickCount / 40);
    for(var i = 0; i < tickCount; i += step){
        var tickValue = realNumberScaleTicks ? realNumberScaleTicks[i] : categoryScaleExtent[0] + i;
        var label = labelFormatter(tickValue);
        var unrotatedSingleRect = axisLabelModel.getTextRect(label);
        var singleRect = $13542623aa20eeae$var$rotateTextRect(unrotatedSingleRect, axisLabelModel.get("rotate") || 0);
        rect ? rect.union(singleRect) : rect = singleRect;
    }
    return rect;
}
function $13542623aa20eeae$var$rotateTextRect(textRect, rotate) {
    var rotateRadians = rotate * Math.PI / 180;
    var boundingBox = textRect.plain();
    var beforeWidth = boundingBox.width;
    var beforeHeight = boundingBox.height;
    var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
    var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
    var rotatedRect = new $33e4fae744d34798$exports(boundingBox.x, boundingBox.y, afterWidth, afterHeight);
    return rotatedRect;
}
/**
 * @param {module:echarts/src/model/Model} model axisLabelModel or axisTickModel
 * @return {number|String} Can be null|'auto'|number|function
 */ function $13542623aa20eeae$var$getOptionCategoryInterval(model) {
    var interval = model.get("interval");
    return interval == null ? "auto" : interval;
}
/**
 * Set `categoryInterval` as 0 implicitly indicates that
 * show all labels reguardless of overlap.
 * @param {Object} axis axisModel.axis
 * @return {boolean}
 */ function $13542623aa20eeae$var$shouldShowAllLabels(axis) {
    return axis.type === "category" && $13542623aa20eeae$var$getOptionCategoryInterval(axis.getLabelModel()) === 0;
}
$13542623aa20eeae$export$9c0ba8df7eb7b328 = $13542623aa20eeae$var$getScaleExtent;
$13542623aa20eeae$export$51f3e70a54405d5a = $13542623aa20eeae$var$niceScaleExtent;
$13542623aa20eeae$export$8941c4cacdc8f5a5 = $13542623aa20eeae$var$createScaleByModel;
$13542623aa20eeae$export$3eac36a69f37d52 = $13542623aa20eeae$var$ifAxisCrossZero;
$13542623aa20eeae$export$742f19a75415b2ae = $13542623aa20eeae$var$makeLabelFormatter;
$13542623aa20eeae$export$a5a32f324c1fa457 = $13542623aa20eeae$var$getAxisRawValue;
$13542623aa20eeae$export$fef1c7f0af0b48d = $13542623aa20eeae$var$estimateLabelUnionRect;
$13542623aa20eeae$export$6d0bc2429155c088 = $13542623aa20eeae$var$getOptionCategoryInterval;
$13542623aa20eeae$export$c2911c025243d6a6 = $13542623aa20eeae$var$shouldShowAllLabels;


var $ce1d0648e3723c9f$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // import * as axisHelper from './axisHelper';
var $ce1d0648e3723c9f$var$_default = {
    /**
   * @param {boolean} origin
   * @return {number|string} min value or 'dataMin' or null/undefined (means auto) or NaN
   */ getMin: function(origin) {
        var option = this.option;
        var min = !origin && option.rangeStart != null ? option.rangeStart : option.min;
        if (this.axis && min != null && min !== "dataMin" && typeof min !== "function" && !$ec279652dd95c27b$export$7d667b9a0c48c975(min)) min = this.axis.scale.parse(min);
        return min;
    },
    /**
   * @param {boolean} origin
   * @return {number|string} max value or 'dataMax' or null/undefined (means auto) or NaN
   */ getMax: function(origin) {
        var option = this.option;
        var max = !origin && option.rangeEnd != null ? option.rangeEnd : option.max;
        if (this.axis && max != null && max !== "dataMax" && typeof max !== "function" && !$ec279652dd95c27b$export$7d667b9a0c48c975(max)) max = this.axis.scale.parse(max);
        return max;
    },
    /**
   * @return {boolean}
   */ getNeedCrossZero: function() {
        var option = this.option;
        return option.rangeStart != null || option.rangeEnd != null ? false : !option.scale;
    },
    /**
   * Should be implemented by each axis model if necessary.
   * @return {module:echarts/model/Component} coordinate system model
   */ getCoordSysModel: $ec279652dd95c27b$export$8793edee2d425525,
    /**
   * @param {number} rangeStart Can only be finite number or null/undefined or NaN.
   * @param {number} rangeEnd Can only be finite number or null/undefined or NaN.
   */ setRange: function(rangeStart, rangeEnd) {
        this.option.rangeStart = rangeStart;
        this.option.rangeEnd = rangeEnd;
    },
    /**
   * Reset range
   */ resetRange: function() {
        // rangeStart and rangeEnd is readonly.
        this.option.rangeStart = this.option.rangeEnd = null;
    }
};
$ce1d0648e3723c9f$exports = $ce1d0648e3723c9f$var$_default;




var $f74da13fea6dc6fb$var$getLayoutRect = $ab0c9086dd6c5b39$export$4517a5ca639a7293;
$f74da13fea6dc6fb$export$4517a5ca639a7293 = $ab0c9086dd6c5b39$export$4517a5ca639a7293;

var $f74da13fea6dc6fb$var$enableDataStack = $1712a5e8fbedbcb3$export$f2165f9e8499b278;
var $f74da13fea6dc6fb$var$isDimensionStacked = $1712a5e8fbedbcb3$export$1dedc39359ae35c;
var $f74da13fea6dc6fb$var$getStackedDimension = $1712a5e8fbedbcb3$export$909db2be4938fbdf;

$f74da13fea6dc6fb$export$b31bb4acc0481e9b = $9f400f3216e0ad55$exports;

$f74da13fea6dc6fb$export$8066c1b52b2e9504 = $c766697b1ee08f64$exports;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $804dcb9a0b78b5fe$export$af050e04da3a02e8;




var $804dcb9a0b78b5fe$var$calculateTextPosition = $ebae9c4ebc22906c$export$eee3603b512feab7;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Symbol factory
/**
 * Triangle shape
 * @inner
 */ var $804dcb9a0b78b5fe$var$Triangle = $4b57d6b582d579b7$export$d0d5398c9d612037({
    type: "triangle",
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy + height);
        path.lineTo(cx - width, cy + height);
        path.closePath();
    }
});
/**
 * Diamond shape
 * @inner
 */ var $804dcb9a0b78b5fe$var$Diamond = $4b57d6b582d579b7$export$d0d5398c9d612037({
    type: "diamond",
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy);
        path.lineTo(cx, cy + height);
        path.lineTo(cx - width, cy);
        path.closePath();
    }
});
/**
 * Pin shape
 * @inner
 */ var $804dcb9a0b78b5fe$var$Pin = $4b57d6b582d579b7$export$d0d5398c9d612037({
    type: "pin",
    shape: {
        // x, y on the cusp
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var x = shape.x;
        var y = shape.y;
        var w = shape.width / 5 * 3; // Height must be larger than width
        var h = Math.max(w, shape.height);
        var r = w / 2; // Dist on y with tangent point and circle center
        var dy = r * r / (h - r);
        var cy = y - h + r + dy;
        var angle = Math.asin(dy / r); // Dist on x with tangent point and circle center
        var dx = Math.cos(angle) * r;
        var tanX = Math.sin(angle);
        var tanY = Math.cos(angle);
        var cpLen = r * 0.6;
        var cpLen2 = r * 0.7;
        path.moveTo(x - dx, cy + dy);
        path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
        path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
        path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
        path.closePath();
    }
});
/**
 * Arrow shape
 * @inner
 */ var $804dcb9a0b78b5fe$var$Arrow = $4b57d6b582d579b7$export$d0d5398c9d612037({
    type: "arrow",
    shape: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(ctx, shape) {
        var height = shape.height;
        var width = shape.width;
        var x = shape.x;
        var y = shape.y;
        var dx = width / 3 * 2;
        ctx.moveTo(x, y);
        ctx.lineTo(x + dx, y + height);
        ctx.lineTo(x, y + height / 4 * 3);
        ctx.lineTo(x - dx, y + height);
        ctx.lineTo(x, y);
        ctx.closePath();
    }
});
/**
 * Map of path contructors
 * @type {Object.<string, module:zrender/graphic/Path>}
 */ var $804dcb9a0b78b5fe$var$symbolCtors = {
    line: $4b57d6b582d579b7$export$17d680238e50603e,
    rect: $4b57d6b582d579b7$export$c79fc6492f3af13d,
    roundRect: $4b57d6b582d579b7$export$c79fc6492f3af13d,
    square: $4b57d6b582d579b7$export$c79fc6492f3af13d,
    circle: $4b57d6b582d579b7$export$c89a927ffc67e6fa,
    diamond: $804dcb9a0b78b5fe$var$Diamond,
    pin: $804dcb9a0b78b5fe$var$Pin,
    arrow: $804dcb9a0b78b5fe$var$Arrow,
    triangle: $804dcb9a0b78b5fe$var$Triangle
};
var $804dcb9a0b78b5fe$var$symbolShapeMakers = {
    line: function(x, y, w, h, shape) {
        // FIXME
        shape.x1 = x;
        shape.y1 = y + h / 2;
        shape.x2 = x + w;
        shape.y2 = y + h / 2;
    },
    rect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
    },
    roundRect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
        shape.r = Math.min(w, h) / 4;
    },
    square: function(x, y, w, h, shape) {
        var size = Math.min(w, h);
        shape.x = x;
        shape.y = y;
        shape.width = size;
        shape.height = size;
    },
    circle: function(x, y, w, h, shape) {
        // Put circle in the center of square
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.r = Math.min(w, h) / 2;
    },
    diamond: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    pin: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    arrow: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    triangle: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    }
};
var $804dcb9a0b78b5fe$var$symbolBuildProxies = {};
$ec279652dd95c27b$export$79b2f7037acddd43($804dcb9a0b78b5fe$var$symbolCtors, function(Ctor, name) {
    $804dcb9a0b78b5fe$var$symbolBuildProxies[name] = new Ctor();
});
var $804dcb9a0b78b5fe$var$SymbolClz = $4b57d6b582d579b7$export$d0d5398c9d612037({
    type: "symbol",
    shape: {
        symbolType: "",
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    calculateTextPosition: function(out, style, rect) {
        var res = $804dcb9a0b78b5fe$var$calculateTextPosition(out, style, rect);
        var shape = this.shape;
        if (shape && shape.symbolType === "pin" && style.textPosition === "inside") res.y = rect.y + rect.height * 0.4;
        return res;
    },
    buildPath: function(ctx, shape, inBundle) {
        var symbolType = shape.symbolType;
        if (symbolType !== "none") {
            var proxySymbol = $804dcb9a0b78b5fe$var$symbolBuildProxies[symbolType];
            if (!proxySymbol) {
                // Default rect
                symbolType = "rect";
                proxySymbol = $804dcb9a0b78b5fe$var$symbolBuildProxies[symbolType];
            }
            $804dcb9a0b78b5fe$var$symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
            proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
        }
    }
}); // Provide setColor helper method to avoid determine if set the fill or stroke outside
function $804dcb9a0b78b5fe$var$symbolPathSetColor(color, innerColor) {
    if (this.type !== "image") {
        var symbolStyle = this.style;
        var symbolShape = this.shape;
        if (symbolShape && symbolShape.symbolType === "line") symbolStyle.stroke = color;
        else if (this.__isEmptyBrush) {
            symbolStyle.stroke = color;
            symbolStyle.fill = innerColor || "#fff";
        } else {
            // FIXME 判断图形默认是填充还是描边，使用 onlyStroke ?
            symbolStyle.fill && (symbolStyle.fill = color);
            symbolStyle.stroke && (symbolStyle.stroke = color);
        }
        this.dirty(false);
    }
}
/**
 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
 * @param {string} symbolType
 * @param {number} x
 * @param {number} y
 * @param {number} w
 * @param {number} h
 * @param {string} color
 * @param {boolean} [keepAspect=false] whether to keep the ratio of w/h,
 *                            for path and image only.
 */ function $804dcb9a0b78b5fe$var$createSymbol(symbolType, x, y, w, h, color, keepAspect) {
    // TODO Support image object, DynamicImage.
    var isEmpty = symbolType.indexOf("empty") === 0;
    if (isEmpty) symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
    var symbolPath;
    if (symbolType.indexOf("image://") === 0) symbolPath = $4b57d6b582d579b7$export$7a2bdede98851ac5(symbolType.slice(8), new $33e4fae744d34798$exports(x, y, w, h), keepAspect ? "center" : "cover");
    else if (symbolType.indexOf("path://") === 0) symbolPath = $4b57d6b582d579b7$export$aa9bab72412f5613(symbolType.slice(7), {}, new $33e4fae744d34798$exports(x, y, w, h), keepAspect ? "center" : "cover");
    else symbolPath = new $804dcb9a0b78b5fe$var$SymbolClz({
        shape: {
            symbolType: symbolType,
            x: x,
            y: y,
            width: w,
            height: h
        }
    });
    symbolPath.__isEmptyBrush = isEmpty;
    symbolPath.setColor = $804dcb9a0b78b5fe$var$symbolPathSetColor;
    symbolPath.setColor(color);
    return symbolPath;
}
$804dcb9a0b78b5fe$export$af050e04da3a02e8 = $804dcb9a0b78b5fe$var$createSymbol;


$f74da13fea6dc6fb$export$af050e04da3a02e8 = $804dcb9a0b78b5fe$export$af050e04da3a02e8;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // import createGraphFromNodeEdge from './chart/helper/createGraphFromNodeEdge';
/**
 * Create a muti dimension List structure from seriesModel.
 * @param  {module:echarts/model/Model} seriesModel
 * @return {module:echarts/data/List} list
 */ function $f74da13fea6dc6fb$var$createList(seriesModel) {
    return $10e48b57e44af7c1$exports(seriesModel.getSource(), seriesModel);
} // export function createGraph(seriesModel) {
//     var nodes = seriesModel.get('data');
//     var links = seriesModel.get('links');
//     return createGraphFromNodeEdge(nodes, links, seriesModel);
// }
var $f74da13fea6dc6fb$var$dataStack = {
    isDimensionStacked: $f74da13fea6dc6fb$var$isDimensionStacked,
    enableDataStack: $f74da13fea6dc6fb$var$enableDataStack,
    getStackedDimension: $f74da13fea6dc6fb$var$getStackedDimension
};
/**
 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
 * @param {string} symbolDesc
 * @param {number} x
 * @param {number} y
 * @param {number} w
 * @param {number} h
 * @param {string} color
 */ /**
 * Create scale
 * @param {Array.<number>} dataExtent
 * @param {Object|module:echarts/Model} option
 */ function $f74da13fea6dc6fb$var$createScale(dataExtent, option) {
    var axisModel = option;
    if (!$2b51b4bf776ec22e$exports.isInstance(option)) {
        axisModel = new $2b51b4bf776ec22e$exports(option);
        $ec279652dd95c27b$export$e36fc9d62a853069(axisModel, $ce1d0648e3723c9f$exports);
    }
    var scale = $13542623aa20eeae$export$8941c4cacdc8f5a5(axisModel);
    scale.setExtent(dataExtent[0], dataExtent[1]);
    $13542623aa20eeae$export$51f3e70a54405d5a(scale, axisModel);
    return scale;
}
/**
 * Mixin common methods to axis model,
 *
 * Inlcude methods
 * `getFormattedLabels() => Array.<string>`
 * `getCategories() => Array.<string>`
 * `getMin(origin: boolean) => number`
 * `getMax(origin: boolean) => number`
 * `getNeedCrossZero() => boolean`
 * `setRange(start: number, end: number)`
 * `resetRange()`
 */ function $f74da13fea6dc6fb$var$mixinAxisModelCommonMethods(Model) {
    $ec279652dd95c27b$export$e36fc9d62a853069(Model, $ce1d0648e3723c9f$exports);
}
$f74da13fea6dc6fb$export$5897d8d7c7a3d871 = $f74da13fea6dc6fb$var$createList;
$f74da13fea6dc6fb$export$d6100971d5a3a0a7 = $f74da13fea6dc6fb$var$dataStack;
$f74da13fea6dc6fb$export$587d9c3c553380c6 = $f74da13fea6dc6fb$var$createScale;
$f74da13fea6dc6fb$export$4665cbe3470e4d57 = $f74da13fea6dc6fb$var$mixinAxisModelCommonMethods;


$a5a5f16c8a84146c$export$4bbbbc0a0e57a7f = $f74da13fea6dc6fb$exports;
var $e0a8b9e18cb663b3$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $92c6ed3dd2805a32$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $b6130b3a3ace3afb$export$8893e2b90ba10d92;

var $b6130b3a3ace3afb$var$EPSILON = 1e-8;
function $b6130b3a3ace3afb$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $b6130b3a3ace3afb$var$EPSILON;
}
function $b6130b3a3ace3afb$var$contain(points, x, y) {
    var w = 0;
    var p = points[0];
    if (!p) return false;
    for(var i = 1; i < points.length; i++){
        var p2 = points[i];
        w += $94d785909998a63b$exports(p[0], p[1], p2[0], p2[1], x, y);
        p = p2;
    } // Close polygon
    var p0 = points[0];
    if (!$b6130b3a3ace3afb$var$isAroundEqual(p[0], p0[0]) || !$b6130b3a3ace3afb$var$isAroundEqual(p[1], p0[1])) w += $94d785909998a63b$exports(p[0], p[1], p0[0], p0[1], x, y);
    return w !== 0;
}
$b6130b3a3ace3afb$export$8893e2b90ba10d92 = $b6130b3a3ace3afb$var$contain;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @module echarts/coord/geo/Region
 */ /**
 * @param {string|Region} name
 * @param {Array} geometries
 * @param {Array.<number>} cp
 */ function $92c6ed3dd2805a32$var$Region(name, geometries, cp) {
    /**
   * @type {string}
   * @readOnly
   */ this.name = name;
    /**
   * @type {Array.<Array>}
   * @readOnly
   */ this.geometries = geometries;
    if (!cp) {
        var rect = this.getBoundingRect();
        cp = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    } else cp = [
        cp[0],
        cp[1]
    ];
    /**
   * @type {Array.<number>}
   */ this.center = cp;
}
$92c6ed3dd2805a32$var$Region.prototype = {
    constructor: $92c6ed3dd2805a32$var$Region,
    properties: null,
    /**
   * @return {module:zrender/core/BoundingRect}
   */ getBoundingRect: function() {
        var rect = this._rect;
        if (rect) return rect;
        var MAX_NUMBER = Number.MAX_VALUE;
        var min = [
            MAX_NUMBER,
            MAX_NUMBER
        ];
        var max = [
            -MAX_NUMBER,
            -MAX_NUMBER
        ];
        var min2 = [];
        var max2 = [];
        var geometries = this.geometries;
        for(var i = 0; i < geometries.length; i++){
            // Only support polygon
            if (geometries[i].type !== "polygon") continue;
             // Doesn't consider hole
            var exterior = geometries[i].exterior;
            $22231ac051eb7cf7$export$188c3cd07b4129dd(exterior, min2, max2);
            $9eb63d101f3bcd79$export$96ec731ed4dcb222(min, min, min2);
            $9eb63d101f3bcd79$export$8960430cfd85939f(max, max, max2);
        } // No data
        if (i === 0) min[0] = min[1] = max[0] = max[1] = 0;
        return this._rect = new $33e4fae744d34798$exports(min[0], min[1], max[0] - min[0], max[1] - min[1]);
    },
    /**
   * @param {<Array.<number>} coord
   * @return {boolean}
   */ contain: function(coord) {
        var rect = this.getBoundingRect();
        var geometries = this.geometries;
        if (!rect.contain(coord[0], coord[1])) return false;
        loopGeo: for(var i = 0, len = geometries.length; i < len; i++){
            // Only support polygon.
            if (geometries[i].type !== "polygon") continue;
            var exterior = geometries[i].exterior;
            var interiors = geometries[i].interiors;
            if ($b6130b3a3ace3afb$export$8893e2b90ba10d92(exterior, coord[0], coord[1])) {
                // Not in the region if point is in the hole.
                for(var k = 0; k < (interiors ? interiors.length : 0); k++){
                    if ($b6130b3a3ace3afb$export$8893e2b90ba10d92(interiors[k])) continue loopGeo;
                }
                return true;
            }
        }
        return false;
    },
    transformTo: function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var aspect = rect.width / rect.height;
        if (!width) width = aspect * height;
        else if (!height) height = width / aspect;
        var target = new $33e4fae744d34798$exports(x, y, width, height);
        var transform = rect.calculateTransform(target);
        var geometries = this.geometries;
        for(var i = 0; i < geometries.length; i++){
            // Only support polygon.
            if (geometries[i].type !== "polygon") continue;
            var exterior = geometries[i].exterior;
            var interiors = geometries[i].interiors;
            for(var p = 0; p < exterior.length; p++)$9eb63d101f3bcd79$export$9f9dcb98c894b623(exterior[p], exterior[p], transform);
            for(var h = 0; h < (interiors ? interiors.length : 0); h++)for(var p = 0; p < interiors[h].length; p++)$9eb63d101f3bcd79$export$9f9dcb98c894b623(interiors[h][p], interiors[h][p], transform);
        }
        rect = this._rect;
        rect.copy(target); // Update center
        this.center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    },
    cloneShallow: function(name) {
        name == null && (name = this.name);
        var newRegion = new $92c6ed3dd2805a32$var$Region(name, this.geometries, this.center);
        newRegion._rect = this._rect;
        newRegion.transformTo = null; // Simply avoid to be called.
        return newRegion;
    }
};
var $92c6ed3dd2805a32$var$_default = $92c6ed3dd2805a32$var$Region;
$92c6ed3dd2805a32$exports = $92c6ed3dd2805a32$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parse and decode geo json
 * @module echarts/coord/geo/parseGeoJson
 */ function $e0a8b9e18cb663b3$var$decode(json) {
    if (!json.UTF8Encoding) return json;
    var encodeScale = json.UTF8Scale;
    if (encodeScale == null) encodeScale = 1024;
    var features = json.features;
    for(var f = 0; f < features.length; f++){
        var feature = features[f];
        var geometry = feature.geometry;
        var coordinates = geometry.coordinates;
        var encodeOffsets = geometry.encodeOffsets;
        for(var c = 0; c < coordinates.length; c++){
            var coordinate = coordinates[c];
            if (geometry.type === "Polygon") coordinates[c] = $e0a8b9e18cb663b3$var$decodePolygon(coordinate, encodeOffsets[c], encodeScale);
            else if (geometry.type === "MultiPolygon") for(var c2 = 0; c2 < coordinate.length; c2++){
                var polygon = coordinate[c2];
                coordinate[c2] = $e0a8b9e18cb663b3$var$decodePolygon(polygon, encodeOffsets[c][c2], encodeScale);
            }
        }
    } // Has been decoded
    json.UTF8Encoding = false;
    return json;
}
function $e0a8b9e18cb663b3$var$decodePolygon(coordinate, encodeOffsets, encodeScale) {
    var result = [];
    var prevX = encodeOffsets[0];
    var prevY = encodeOffsets[1];
    for(var i = 0; i < coordinate.length; i += 2){
        var x = coordinate.charCodeAt(i) - 64;
        var y = coordinate.charCodeAt(i + 1) - 64; // ZigZag decoding
        x = x >> 1 ^ -(x & 1);
        y = y >> 1 ^ -(y & 1); // Delta deocding
        x += prevX;
        y += prevY;
        prevX = x;
        prevY = y; // Dequantize
        result.push([
            x / encodeScale,
            y / encodeScale
        ]);
    }
    return result;
}
/**
 * @alias module:echarts/coord/geo/parseGeoJson
 * @param {Object} geoJson
 * @param {string} nameProperty
 * @return {module:zrender/container/Group}
 */ function $e0a8b9e18cb663b3$var$_default(geoJson, nameProperty) {
    $e0a8b9e18cb663b3$var$decode(geoJson);
    return $ec279652dd95c27b$export$871de8747c9eaa88($ec279652dd95c27b$export$3dea766d36a8935f(geoJson.features, function(featureObj) {
        // Output of mapshaper may have geometry null
        return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
    }), function(featureObj) {
        var properties = featureObj.properties;
        var geo = featureObj.geometry;
        var coordinates = geo.coordinates;
        var geometries = [];
        if (geo.type === "Polygon") geometries.push({
            type: "polygon",
            // According to the GeoJSON specification.
            // First must be exterior, and the rest are all interior(holes).
            exterior: coordinates[0],
            interiors: coordinates.slice(1)
        });
        if (geo.type === "MultiPolygon") $ec279652dd95c27b$export$79b2f7037acddd43(coordinates, function(item) {
            if (item[0]) geometries.push({
                type: "polygon",
                exterior: item[0],
                interiors: item.slice(1)
            });
        });
        var region = new $92c6ed3dd2805a32$exports(properties[nameProperty || "name"], geometries, properties.cp);
        region.properties = properties;
        return region;
    });
}
$e0a8b9e18cb663b3$exports = $e0a8b9e18cb663b3$var$_default;


$a5a5f16c8a84146c$export$d93d4ce94fa6bbcb = $e0a8b9e18cb663b3$exports;

$a5a5f16c8a84146c$export$54c2e3dc7acea9f5 = $f643df856475f69e$exports;

$a5a5f16c8a84146c$export$a1edc412be3e1841 = $2b51b4bf776ec22e$exports;
var $95e1f94acccc578d$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $95e1f94acccc578d$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $95e1f94acccc578d$var$map = $ec279652dd95c27b$export$871de8747c9eaa88;

var $95e1f94acccc578d$var$linearMap = $2d742dbe7f960d8c$export$d3f68fbaa670562;
var $95e1f94acccc578d$var$getPixelPrecision = $2d742dbe7f960d8c$export$666260d9a2dda8a7;
var $95e1f94acccc578d$var$round = $2d742dbe7f960d8c$export$2077e0241d6afd3c;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $9ae5bb0b7a5c1254$export$10216ebd3e3e485e;
var $9ae5bb0b7a5c1254$export$7cccf6836ae8323c;
var $9ae5bb0b7a5c1254$export$9ea1d3f146a5a65f;



var $9ae5bb0b7a5c1254$var$makeInner = $d559f43cb9041423$export$64df9f8d92ae083f;

var $9ae5bb0b7a5c1254$var$makeLabelFormatter = $13542623aa20eeae$export$742f19a75415b2ae;
var $9ae5bb0b7a5c1254$var$getOptionCategoryInterval = $13542623aa20eeae$export$6d0bc2429155c088;
var $9ae5bb0b7a5c1254$var$shouldShowAllLabels = $13542623aa20eeae$export$c2911c025243d6a6;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $9ae5bb0b7a5c1254$var$inner = $9ae5bb0b7a5c1254$var$makeInner();
/**
 * @param {module:echats/coord/Axis} axis
 * @return {Object} {
 *     labels: [{
 *         formattedLabel: string,
 *         rawLabel: string,
 *         tickValue: number
 *     }, ...],
 *     labelCategoryInterval: number
 * }
 */ function $9ae5bb0b7a5c1254$var$createAxisLabels(axis) {
    // Only ordinal scale support tick interval
    return axis.type === "category" ? $9ae5bb0b7a5c1254$var$makeCategoryLabels(axis) : $9ae5bb0b7a5c1254$var$makeRealNumberLabels(axis);
}
/**
 * @param {module:echats/coord/Axis} axis
 * @param {module:echarts/model/Model} tickModel For example, can be axisTick, splitLine, splitArea.
 * @return {Object} {
 *     ticks: Array.<number>
 *     tickCategoryInterval: number
 * }
 */ function $9ae5bb0b7a5c1254$var$createAxisTicks(axis, tickModel) {
    // Only ordinal scale support tick interval
    return axis.type === "category" ? $9ae5bb0b7a5c1254$var$makeCategoryTicks(axis, tickModel) : {
        ticks: axis.scale.getTicks()
    };
}
function $9ae5bb0b7a5c1254$var$makeCategoryLabels(axis) {
    var labelModel = axis.getLabelModel();
    var result = $9ae5bb0b7a5c1254$var$makeCategoryLabelsActually(axis, labelModel);
    return !labelModel.get("show") || axis.scale.isBlank() ? {
        labels: [],
        labelCategoryInterval: result.labelCategoryInterval
    } : result;
}
function $9ae5bb0b7a5c1254$var$makeCategoryLabelsActually(axis, labelModel) {
    var labelsCache = $9ae5bb0b7a5c1254$var$getListCache(axis, "labels");
    var optionLabelInterval = $9ae5bb0b7a5c1254$var$getOptionCategoryInterval(labelModel);
    var result = $9ae5bb0b7a5c1254$var$listCacheGet(labelsCache, optionLabelInterval);
    if (result) return result;
    var labels;
    var numericLabelInterval;
    if ($ec279652dd95c27b$export$f6e2535fb5126e54(optionLabelInterval)) labels = $9ae5bb0b7a5c1254$var$makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
    else {
        numericLabelInterval = optionLabelInterval === "auto" ? $9ae5bb0b7a5c1254$var$makeAutoCategoryInterval(axis) : optionLabelInterval;
        labels = $9ae5bb0b7a5c1254$var$makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
    } // Cache to avoid calling interval function repeatly.
    return $9ae5bb0b7a5c1254$var$listCacheSet(labelsCache, optionLabelInterval, {
        labels: labels,
        labelCategoryInterval: numericLabelInterval
    });
}
function $9ae5bb0b7a5c1254$var$makeCategoryTicks(axis, tickModel) {
    var ticksCache = $9ae5bb0b7a5c1254$var$getListCache(axis, "ticks");
    var optionTickInterval = $9ae5bb0b7a5c1254$var$getOptionCategoryInterval(tickModel);
    var result = $9ae5bb0b7a5c1254$var$listCacheGet(ticksCache, optionTickInterval);
    if (result) return result;
    var ticks;
    var tickCategoryInterval; // Optimize for the case that large category data and no label displayed,
    // we should not return all ticks.
    if (!tickModel.get("show") || axis.scale.isBlank()) ticks = [];
    if ($ec279652dd95c27b$export$f6e2535fb5126e54(optionTickInterval)) ticks = $9ae5bb0b7a5c1254$var$makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
    else if (optionTickInterval === "auto") {
        var labelsResult = $9ae5bb0b7a5c1254$var$makeCategoryLabelsActually(axis, axis.getLabelModel());
        tickCategoryInterval = labelsResult.labelCategoryInterval;
        ticks = $ec279652dd95c27b$export$871de8747c9eaa88(labelsResult.labels, function(labelItem) {
            return labelItem.tickValue;
        });
    } else {
        tickCategoryInterval = optionTickInterval;
        ticks = $9ae5bb0b7a5c1254$var$makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
    } // Cache to avoid calling interval function repeatly.
    return $9ae5bb0b7a5c1254$var$listCacheSet(ticksCache, optionTickInterval, {
        ticks: ticks,
        tickCategoryInterval: tickCategoryInterval
    });
}
function $9ae5bb0b7a5c1254$var$makeRealNumberLabels(axis) {
    var ticks = axis.scale.getTicks();
    var labelFormatter = $9ae5bb0b7a5c1254$var$makeLabelFormatter(axis);
    return {
        labels: $ec279652dd95c27b$export$871de8747c9eaa88(ticks, function(tickValue, idx) {
            return {
                formattedLabel: labelFormatter(tickValue, idx),
                rawLabel: axis.scale.getLabel(tickValue),
                tickValue: tickValue
            };
        })
    };
} // Large category data calculation is performence sensitive, and ticks and label
// probably be fetched by multiple times. So we cache the result.
// axis is created each time during a ec process, so we do not need to clear cache.
function $9ae5bb0b7a5c1254$var$getListCache(axis, prop) {
    // Because key can be funciton, and cache size always be small, we use array cache.
    return $9ae5bb0b7a5c1254$var$inner(axis)[prop] || ($9ae5bb0b7a5c1254$var$inner(axis)[prop] = []);
}
function $9ae5bb0b7a5c1254$var$listCacheGet(cache, key) {
    for(var i = 0; i < cache.length; i++){
        if (cache[i].key === key) return cache[i].value;
    }
}
function $9ae5bb0b7a5c1254$var$listCacheSet(cache, key, value) {
    cache.push({
        key: key,
        value: value
    });
    return value;
}
function $9ae5bb0b7a5c1254$var$makeAutoCategoryInterval(axis) {
    var result = $9ae5bb0b7a5c1254$var$inner(axis).autoInterval;
    return result != null ? result : $9ae5bb0b7a5c1254$var$inner(axis).autoInterval = axis.calculateCategoryInterval();
}
/**
 * Calculate interval for category axis ticks and labels.
 * To get precise result, at least one of `getRotate` and `isHorizontal`
 * should be implemented in axis.
 */ function $9ae5bb0b7a5c1254$var$calculateCategoryInterval(axis) {
    var params = $9ae5bb0b7a5c1254$var$fetchAutoCategoryIntervalCalculationParams(axis);
    var labelFormatter = $9ae5bb0b7a5c1254$var$makeLabelFormatter(axis);
    var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
    // avoid generating a long array by `getTicks`
    // in large category data case.
    var tickCount = ordinalScale.count();
    if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
    var step = 1; // Simple optimization. Empirical value: tick count should less than 40.
    if (tickCount > 40) step = Math.max(1, Math.floor(tickCount / 40));
    var tickValue = ordinalExtent[0];
    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
    var unitW = Math.abs(unitSpan * Math.cos(rotation));
    var unitH = Math.abs(unitSpan * Math.sin(rotation));
    var maxW = 0;
    var maxH = 0; // Caution: Performance sensitive for large category data.
    // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
    for(; tickValue <= ordinalExtent[1]; tickValue += step){
        var width = 0;
        var height = 0; // Not precise, do not consider align and vertical align
        // and each distance from axis line yet.
        var rect = $ebae9c4ebc22906c$export$c381147bfed79d9f(labelFormatter(tickValue), params.font, "center", "top"); // Magic number
        width = rect.width * 1.3;
        height = rect.height * 1.3; // Min size, void long loop.
        maxW = Math.max(maxW, width, 7);
        maxH = Math.max(maxH, height, 7);
    }
    var dw = maxW / unitW;
    var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.
    isNaN(dw) && (dw = Infinity);
    isNaN(dh) && (dh = Infinity);
    var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
    var cache = $9ae5bb0b7a5c1254$var$inner(axis.model);
    var axisExtent = axis.getExtent();
    var lastAutoInterval = cache.lastAutoInterval;
    var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
    // otherwise the calculated interval might jitter when the zoom
    // window size is close to the interval-changing size.
    // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
    // The jitter will cause that sometimes the displayed labels are
    // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
     && lastAutoInterval > interval // If the axis change is caused by chart resize, the cache should not
     && cache.axisExtend0 === axisExtent[0] && cache.axisExtend1 === axisExtent[1]) interval = lastAutoInterval;
    else {
        cache.lastTickCount = tickCount;
        cache.lastAutoInterval = interval;
        cache.axisExtend0 = axisExtent[0];
        cache.axisExtend1 = axisExtent[1];
    }
    return interval;
}
function $9ae5bb0b7a5c1254$var$fetchAutoCategoryIntervalCalculationParams(axis) {
    var labelModel = axis.getLabelModel();
    return {
        axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
        labelRotate: labelModel.get("rotate") || 0,
        font: labelModel.getFont()
    };
}
function $9ae5bb0b7a5c1254$var$makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
    var labelFormatter = $9ae5bb0b7a5c1254$var$makeLabelFormatter(axis);
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    var labelModel = axis.getLabelModel();
    var result = []; // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...
    var step = Math.max((categoryInterval || 0) + 1, 1);
    var startTick = ordinalExtent[0];
    var tickCount = ordinalScale.count(); // Calculate start tick based on zero if possible to keep label consistent
    // while zooming and moving while interval > 0. Otherwise the selection
    // of displayable ticks and symbols probably keep changing.
    // 3 is empirical value.
    if (startTick !== 0 && step > 1 && tickCount / step > 2) startTick = Math.round(Math.ceil(startTick / step) * step);
     // (1) Only add min max label here but leave overlap checking
    // to render stage, which also ensure the returned list
    // suitable for splitLine and splitArea rendering.
    // (2) Scales except category always contain min max label so
    // do not need to perform this process.
    var showAllLabel = $9ae5bb0b7a5c1254$var$shouldShowAllLabels(axis);
    var includeMinLabel = labelModel.get("showMinLabel") || showAllLabel;
    var includeMaxLabel = labelModel.get("showMaxLabel") || showAllLabel;
    if (includeMinLabel && startTick !== ordinalExtent[0]) addItem(ordinalExtent[0]);
     // Optimize: avoid generating large array by `ordinalScale.getTicks()`.
    var tickValue = startTick;
    for(; tickValue <= ordinalExtent[1]; tickValue += step)addItem(tickValue);
    if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) addItem(ordinalExtent[1]);
    function addItem(tVal) {
        result.push(onlyTick ? tVal : {
            formattedLabel: labelFormatter(tVal),
            rawLabel: ordinalScale.getLabel(tVal),
            tickValue: tVal
        });
    }
    return result;
} // When interval is function, the result `false` means ignore the tick.
// It is time consuming for large category data.
function $9ae5bb0b7a5c1254$var$makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
    var ordinalScale = axis.scale;
    var labelFormatter = $9ae5bb0b7a5c1254$var$makeLabelFormatter(axis);
    var result = [];
    $ec279652dd95c27b$export$79b2f7037acddd43(ordinalScale.getTicks(), function(tickValue) {
        var rawLabel = ordinalScale.getLabel(tickValue);
        if (categoryInterval(tickValue, rawLabel)) result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tickValue),
            rawLabel: rawLabel,
            tickValue: tickValue
        });
    });
    return result;
}
$9ae5bb0b7a5c1254$export$10216ebd3e3e485e = $9ae5bb0b7a5c1254$var$createAxisLabels;
$9ae5bb0b7a5c1254$export$7cccf6836ae8323c = $9ae5bb0b7a5c1254$var$createAxisTicks;
$9ae5bb0b7a5c1254$export$9ea1d3f146a5a65f = $9ae5bb0b7a5c1254$var$calculateCategoryInterval;


var $95e1f94acccc578d$var$createAxisTicks = $9ae5bb0b7a5c1254$export$7cccf6836ae8323c;
var $95e1f94acccc578d$var$createAxisLabels = $9ae5bb0b7a5c1254$export$10216ebd3e3e485e;
var $95e1f94acccc578d$var$calculateCategoryInterval = $9ae5bb0b7a5c1254$export$9ea1d3f146a5a65f;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $95e1f94acccc578d$var$NORMALIZED_EXTENT = [
    0,
    1
];
/**
 * Base class of Axis.
 * @constructor
 */ var $95e1f94acccc578d$var$Axis = function(dim, scale, extent) {
    /**
   * Axis dimension. Such as 'x', 'y', 'z', 'angle', 'radius'.
   * @type {string}
   */ this.dim = dim;
    /**
   * Axis scale
   * @type {module:echarts/coord/scale/*}
   */ this.scale = scale;
    /**
   * @type {Array.<number>}
   * @private
   */ this._extent = extent || [
        0,
        0
    ];
    /**
   * @type {boolean}
   */ this.inverse = false;
    /**
   * Usually true when axis has a ordinal scale
   * @type {boolean}
   */ this.onBand = false;
};
$95e1f94acccc578d$var$Axis.prototype = {
    constructor: $95e1f94acccc578d$var$Axis,
    /**
   * If axis extent contain given coord
   * @param {number} coord
   * @return {boolean}
   */ contain: function(coord) {
        var extent = this._extent;
        var min = Math.min(extent[0], extent[1]);
        var max = Math.max(extent[0], extent[1]);
        return coord >= min && coord <= max;
    },
    /**
   * If axis extent contain given data
   * @param {number} data
   * @return {boolean}
   */ containData: function(data) {
        return this.scale.contain(data);
    },
    /**
   * Get coord extent.
   * @return {Array.<number>}
   */ getExtent: function() {
        return this._extent.slice();
    },
    /**
   * Get precision used for formatting
   * @param {Array.<number>} [dataExtent]
   * @return {number}
   */ getPixelPrecision: function(dataExtent) {
        return $95e1f94acccc578d$var$getPixelPrecision(dataExtent || this.scale.getExtent(), this._extent);
    },
    /**
   * Set coord extent
   * @param {number} start
   * @param {number} end
   */ setExtent: function(start, end) {
        var extent = this._extent;
        extent[0] = start;
        extent[1] = end;
    },
    /**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   * @param {number} data
   * @param  {boolean} clamp
   * @return {number}
   */ dataToCoord: function(data, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        data = scale.normalize(data);
        if (this.onBand && scale.type === "ordinal") {
            extent = extent.slice();
            $95e1f94acccc578d$var$fixExtentWithBands(extent, scale.count());
        }
        return $95e1f94acccc578d$var$linearMap(data, $95e1f94acccc578d$var$NORMALIZED_EXTENT, extent, clamp);
    },
    /**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   * @param {number} coord
   * @param  {boolean} clamp
   * @return {number}
   */ coordToData: function(coord, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        if (this.onBand && scale.type === "ordinal") {
            extent = extent.slice();
            $95e1f94acccc578d$var$fixExtentWithBands(extent, scale.count());
        }
        var t = $95e1f94acccc578d$var$linearMap(coord, extent, $95e1f94acccc578d$var$NORMALIZED_EXTENT, clamp);
        return this.scale.scale(t);
    },
    /**
   * Convert pixel point to data in axis
   * @param {Array.<number>} point
   * @param  {boolean} clamp
   * @return {number} data
   */ pointToData: function(point, clamp) {},
    /**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param {Object} [opt]
   * @param {Model} [opt.tickModel=axis.model.getModel('axisTick')]
   * @param {boolean} [opt.clamp] If `true`, the first and the last
   *        tick must be at the axis end points. Otherwise, clip ticks
   *        that outside the axis extent.
   * @return {Array.<Object>} [{
   *     coord: ...,
   *     tickValue: ...
   * }, ...]
   */ getTicksCoords: function(opt) {
        opt = opt || {};
        var tickModel = opt.tickModel || this.getTickModel();
        var result = $95e1f94acccc578d$var$createAxisTicks(this, tickModel);
        var ticks = result.ticks;
        var ticksCoords = $95e1f94acccc578d$var$map(ticks, function(tickValue) {
            return {
                coord: this.dataToCoord(tickValue),
                tickValue: tickValue
            };
        }, this);
        var alignWithLabel = tickModel.get("alignWithLabel");
        $95e1f94acccc578d$var$fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
        return ticksCoords;
    },
    /**
   * @return {Array.<Array.<Object>>} [{ coord: ..., tickValue: ...}]
   */ getMinorTicksCoords: function() {
        if (this.scale.type === "ordinal") // Category axis doesn't support minor ticks
        return [];
        var minorTickModel = this.model.getModel("minorTick");
        var splitNumber = minorTickModel.get("splitNumber"); // Protection.
        if (!(splitNumber > 0 && splitNumber < 100)) splitNumber = 5;
        var minorTicks = this.scale.getMinorTicks(splitNumber);
        var minorTicksCoords = $95e1f94acccc578d$var$map(minorTicks, function(minorTicksGroup) {
            return $95e1f94acccc578d$var$map(minorTicksGroup, function(minorTick) {
                return {
                    coord: this.dataToCoord(minorTick),
                    tickValue: minorTick
                };
            }, this);
        }, this);
        return minorTicksCoords;
    },
    /**
   * @return {Array.<Object>} [{
   *     formattedLabel: string,
   *     rawLabel: axis.scale.getLabel(tickValue)
   *     tickValue: number
   * }, ...]
   */ getViewLabels: function() {
        return $95e1f94acccc578d$var$createAxisLabels(this).labels;
    },
    /**
   * @return {module:echarts/coord/model/Model}
   */ getLabelModel: function() {
        return this.model.getModel("axisLabel");
    },
    /**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overrided to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   * @return {module:echarts/coord/model/Model}
   */ getTickModel: function() {
        return this.model.getModel("axisTick");
    },
    /**
   * Get width of band
   * @return {number}
   */ getBandWidth: function() {
        var axisExtent = this._extent;
        var dataExtent = this.scale.getExtent();
        var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0); // Fix #2728, avoid NaN when only one data.
        len === 0 && (len = 1);
        var size = Math.abs(axisExtent[1] - axisExtent[0]);
        return Math.abs(size) / len;
    },
    /**
   * @abstract
   * @return {boolean} Is horizontal
   */ isHorizontal: null,
    /**
   * @abstract
   * @return {number} Get axis rotate, by degree.
   */ getRotate: null,
    /**
   * Only be called in category axis.
   * Can be overrided, consider other axes like in 3D.
   * @return {number} Auto interval for cateogry axis tick and label
   */ calculateCategoryInterval: function() {
        return $95e1f94acccc578d$var$calculateCategoryInterval(this);
    }
};
function $95e1f94acccc578d$var$fixExtentWithBands(extent, nTick) {
    var size = extent[1] - extent[0];
    var len = nTick;
    var margin = size / len / 2;
    extent[0] += margin;
    extent[1] -= margin;
} // If axis has labels [1, 2, 3, 4]. Bands on the axis are
// |---1---|---2---|---3---|---4---|.
// So the displayed ticks and splitLine/splitArea should between
// each data item, otherwise cause misleading (e.g., split tow bars
// of a single data item when there are two bar series).
// Also consider if tickCategoryInterval > 0 and onBand, ticks and
// splitLine/spliteArea should layout appropriately corresponding
// to displayed labels. (So we should not use `getBandWidth` in this
// case).
function $95e1f94acccc578d$var$fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
    var ticksLen = ticksCoords.length;
    if (!axis.onBand || alignWithLabel || !ticksLen) return;
    var axisExtent = axis.getExtent();
    var last;
    var diffSize;
    if (ticksLen === 1) {
        ticksCoords[0].coord = axisExtent[0];
        last = ticksCoords[1] = {
            coord: axisExtent[0]
        };
    } else {
        var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
        var shift = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
        $95e1f94acccc578d$var$each(ticksCoords, function(ticksItem) {
            ticksItem.coord -= shift / 2;
        });
        var dataExtent = axis.scale.getExtent();
        diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
        last = {
            coord: ticksCoords[ticksLen - 1].coord + shift * diffSize
        };
        ticksCoords.push(last);
    }
    var inverse = axisExtent[0] > axisExtent[1]; // Handling clamp.
    if (littleThan(ticksCoords[0].coord, axisExtent[0])) clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
    if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) ticksCoords.unshift({
        coord: axisExtent[0]
    });
    if (littleThan(axisExtent[1], last.coord)) clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
    if (clamp && littleThan(last.coord, axisExtent[1])) ticksCoords.push({
        coord: axisExtent[1]
    });
    function littleThan(a, b) {
        // Avoid rounding error cause calculated tick coord different with extent.
        // It may cause an extra unecessary tick added.
        a = $95e1f94acccc578d$var$round(a);
        b = $95e1f94acccc578d$var$round(b);
        return inverse ? a > b : a < b;
    }
}
var $95e1f94acccc578d$var$_default = $95e1f94acccc578d$var$Axis;
$95e1f94acccc578d$exports = $95e1f94acccc578d$var$_default;


$a5a5f16c8a84146c$export$d06866a9fb0606da = $95e1f94acccc578d$exports;

$a5a5f16c8a84146c$export$a7b6bc01c63cdfc3 = $27ac1413ecc67076$exports;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Do not mount those modules on 'src/echarts' for better tree shaking.
 */ var $a5a5f16c8a84146c$var$parseGeoJson = $e0a8b9e18cb663b3$exports;
var $a5a5f16c8a84146c$var$ecUtil = {};
$ec279652dd95c27b$exports.each([
    "map",
    "each",
    "filter",
    "indexOf",
    "inherits",
    "reduce",
    "filter",
    "bind",
    "curry",
    "isArray",
    "isString",
    "isObject",
    "isFunction",
    "extend",
    "defaults",
    "clone",
    "merge"
], function(name) {
    $a5a5f16c8a84146c$var$ecUtil[name] = $ec279652dd95c27b$exports[name];
});
var $a5a5f16c8a84146c$var$graphic = {};
$ec279652dd95c27b$exports.each([
    "extendShape",
    "extendPath",
    "makePath",
    "makeImage",
    "mergePath",
    "resizePath",
    "createIcon",
    "setHoverStyle",
    "setLabelStyle",
    "setTextStyle",
    "setText",
    "getFont",
    "updateProps",
    "initProps",
    "getTransform",
    "clipPointsByRect",
    "clipRectByRect",
    "registerShape",
    "getShapeClass",
    "Group",
    "Image",
    "Text",
    "Circle",
    "Sector",
    "Ring",
    "Polygon",
    "Polyline",
    "Rect",
    "Line",
    "BezierCurve",
    "Arc",
    "IncrementalDisplayable",
    "CompoundPath",
    "LinearGradient",
    "RadialGradient",
    "BoundingRect"
], function(name) {
    $a5a5f16c8a84146c$var$graphic[name] = $4b57d6b582d579b7$exports[name];
});
$a5a5f16c8a84146c$export$6d6c4c1a99631459 = $a5a5f16c8a84146c$var$parseGeoJson;
$a5a5f16c8a84146c$export$7debb50ef11d5e0b = $a5a5f16c8a84146c$var$ecUtil;
$a5a5f16c8a84146c$export$c96b99088d96cc6d = $a5a5f16c8a84146c$var$graphic;


(function() {
    for(var key in $a5a5f16c8a84146c$exports)if ($a5a5f16c8a84146c$exports.hasOwnProperty(key)) $f406636b535430a7$exports[key] = $a5a5f16c8a84146c$exports[key];
})();


(function() {
    for(var key in $f406636b535430a7$exports){
        if ($f406636b535430a7$exports == null || !$f406636b535430a7$exports.hasOwnProperty(key) || key === "default" || key === "__esModule") return;
        $5451110f8ff557ba$exports[key] = $f406636b535430a7$exports[key];
    }
})();

(function() {
    for(var key in $a5a5f16c8a84146c$exports){
        if ($a5a5f16c8a84146c$exports == null || !$a5a5f16c8a84146c$exports.hasOwnProperty(key) || key === "default" || key === "__esModule") return;
        $5451110f8ff557ba$exports[key] = $a5a5f16c8a84146c$exports[key];
    }
})();

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $beab7322e2738f1c$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $beab7322e2738f1c$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $beab7322e2738f1c$var$_default = $70847df98016d69d$exports.extend({
    type: "series.line",
    dependencies: [
        "grid",
        "polar"
    ],
    getInitialData: function(option, ecModel) {
        return $10e48b57e44af7c1$exports(this.getSource(), this, {
            useEncodeDefaulter: true
        });
    },
    defaultOption: {
        zlevel: 0,
        z: 2,
        coordinateSystem: "cartesian2d",
        legendHoverLink: true,
        hoverAnimation: true,
        // stack: null
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // polarIndex: 0,
        // If clip the overflow value
        clip: true,
        // cursor: null,
        label: {
            position: "top"
        },
        // itemStyle: {
        // },
        lineStyle: {
            width: 2,
            type: "solid"
        },
        // areaStyle: {
        // origin of areaStyle. Valid values:
        // `'auto'/null/undefined`: from axisLine to data
        // `'start'`: from min to data
        // `'end'`: from data to max
        // origin: 'auto'
        // },
        // false, 'start', 'end', 'middle'
        step: false,
        // Disabled if step is true
        smooth: false,
        smoothMonotone: null,
        symbol: "emptyCircle",
        symbolSize: 4,
        symbolRotate: null,
        showSymbol: true,
        // `false`: follow the label interval strategy.
        // `true`: show all symbols.
        // `'auto'`: If possible, show all symbols, otherwise
        //           follow the label interval strategy.
        showAllSymbol: "auto",
        // Whether to connect break point.
        connectNulls: false,
        // Sampling for large data. Can be: 'average', 'max', 'min', 'sum'.
        sampling: "none",
        animationEasing: "linear",
        // Disable progressive
        progressive: 0,
        hoverLayerThreshold: Infinity
    }
});
$beab7322e2738f1c$exports = $beab7322e2738f1c$var$_default;


var $92ccbedd9013fd4e$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $92ccbedd9013fd4e$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;


var $92ccbedd9013fd4e$var$fromPoints = $22231ac051eb7cf7$export$188c3cd07b4129dd;
var $e99d13e2181fb062$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $051ad5e1a7c7bd92$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $051ad5e1a7c7bd92$var$createSymbol = $804dcb9a0b78b5fe$export$af050e04da3a02e8;


var $051ad5e1a7c7bd92$var$parsePercent = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $a03b7f2e2ed9bf1c$export$5ff20667590927ed;

var $a03b7f2e2ed9bf1c$var$retrieveRawValue = $05c9939f6206d72a$export$cde9373da9aad801;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @param {module:echarts/data/List} data
 * @param {number} dataIndex
 * @return {string} label string. Not null/undefined
 */ function $a03b7f2e2ed9bf1c$var$getDefaultLabel(data, dataIndex) {
    var labelDims = data.mapDimension("defaultedLabel", true);
    var len = labelDims.length; // Simple optimization (in lots of cases, label dims length is 1)
    if (len === 1) return $a03b7f2e2ed9bf1c$var$retrieveRawValue(data, dataIndex, labelDims[0]);
    else if (len) {
        var vals = [];
        for(var i = 0; i < labelDims.length; i++){
            var val = $a03b7f2e2ed9bf1c$var$retrieveRawValue(data, dataIndex, labelDims[i]);
            vals.push(val);
        }
        return vals.join(" ");
    }
}
$a03b7f2e2ed9bf1c$export$5ff20667590927ed = $a03b7f2e2ed9bf1c$var$getDefaultLabel;


var $051ad5e1a7c7bd92$var$getDefaultLabel = $a03b7f2e2ed9bf1c$export$5ff20667590927ed;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @module echarts/chart/helper/Symbol
 */ /**
 * @constructor
 * @alias {module:echarts/chart/helper/Symbol}
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @extends {module:zrender/graphic/Group}
 */ function $051ad5e1a7c7bd92$var$SymbolClz(data, idx, seriesScope) {
    $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4.call(this);
    this.updateData(data, idx, seriesScope);
}
var $051ad5e1a7c7bd92$var$symbolProto = $051ad5e1a7c7bd92$var$SymbolClz.prototype;
/**
 * @public
 * @static
 * @param {module:echarts/data/List} data
 * @param {number} dataIndex
 * @return {Array.<number>} [width, height]
 */ var $051ad5e1a7c7bd92$var$getSymbolSize = $051ad5e1a7c7bd92$var$SymbolClz.getSymbolSize = function(data, idx) {
    var symbolSize = data.getItemVisual(idx, "symbolSize");
    return symbolSize instanceof Array ? symbolSize.slice() : [
        +symbolSize,
        +symbolSize
    ];
};
function $051ad5e1a7c7bd92$var$getScale(symbolSize) {
    return [
        symbolSize[0] / 2,
        symbolSize[1] / 2
    ];
}
function $051ad5e1a7c7bd92$var$driftSymbol(dx, dy) {
    this.parent.drift(dx, dy);
}
$051ad5e1a7c7bd92$var$symbolProto._createSymbol = function(symbolType, data, idx, symbolSize, keepAspect) {
    // Remove paths created before
    this.removeAll();
    var color = data.getItemVisual(idx, "color"); // var symbolPath = createSymbol(
    //     symbolType, -0.5, -0.5, 1, 1, color
    // );
    // If width/height are set too small (e.g., set to 1) on ios10
    // and macOS Sierra, a circle stroke become a rect, no matter what
    // the scale is set. So we set width/height as 2. See #4150.
    var symbolPath = $051ad5e1a7c7bd92$var$createSymbol(symbolType, -1, -1, 2, 2, color, keepAspect);
    symbolPath.attr({
        z2: 100,
        culling: true,
        scale: $051ad5e1a7c7bd92$var$getScale(symbolSize)
    }); // Rewrite drift method
    symbolPath.drift = $051ad5e1a7c7bd92$var$driftSymbol;
    this._symbolType = symbolType;
    this.add(symbolPath);
};
/**
 * Stop animation
 * @param {boolean} toLastFrame
 */ $051ad5e1a7c7bd92$var$symbolProto.stopSymbolAnimation = function(toLastFrame) {
    this.childAt(0).stopAnimation(toLastFrame);
};
/**
 * FIXME:
 * Caution: This method breaks the encapsulation of this module,
 * but it indeed brings convenience. So do not use the method
 * unless you detailedly know all the implements of `Symbol`,
 * especially animation.
 *
 * Get symbol path element.
 */ $051ad5e1a7c7bd92$var$symbolProto.getSymbolPath = function() {
    return this.childAt(0);
};
/**
 * Get scale(aka, current symbol size).
 * Including the change caused by animation
 */ $051ad5e1a7c7bd92$var$symbolProto.getScale = function() {
    return this.childAt(0).scale;
};
/**
 * Highlight symbol
 */ $051ad5e1a7c7bd92$var$symbolProto.highlight = function() {
    this.childAt(0).trigger("emphasis");
};
/**
 * Downplay symbol
 */ $051ad5e1a7c7bd92$var$symbolProto.downplay = function() {
    this.childAt(0).trigger("normal");
};
/**
 * @param {number} zlevel
 * @param {number} z
 */ $051ad5e1a7c7bd92$var$symbolProto.setZ = function(zlevel, z) {
    var symbolPath = this.childAt(0);
    symbolPath.zlevel = zlevel;
    symbolPath.z = z;
};
$051ad5e1a7c7bd92$var$symbolProto.setDraggable = function(draggable) {
    var symbolPath = this.childAt(0);
    symbolPath.draggable = draggable;
    symbolPath.cursor = draggable ? "move" : symbolPath.cursor;
};
/**
 * Update symbol properties
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @param {Object} [seriesScope]
 * @param {Object} [seriesScope.itemStyle]
 * @param {Object} [seriesScope.hoverItemStyle]
 * @param {Object} [seriesScope.symbolRotate]
 * @param {Object} [seriesScope.symbolOffset]
 * @param {module:echarts/model/Model} [seriesScope.labelModel]
 * @param {module:echarts/model/Model} [seriesScope.hoverLabelModel]
 * @param {boolean} [seriesScope.hoverAnimation]
 * @param {Object} [seriesScope.cursorStyle]
 * @param {module:echarts/model/Model} [seriesScope.itemModel]
 * @param {string} [seriesScope.symbolInnerColor]
 * @param {Object} [seriesScope.fadeIn=false]
 */ $051ad5e1a7c7bd92$var$symbolProto.updateData = function(data, idx, seriesScope) {
    this.silent = false;
    var symbolType = data.getItemVisual(idx, "symbol") || "circle";
    var seriesModel = data.hostModel;
    var symbolSize = $051ad5e1a7c7bd92$var$getSymbolSize(data, idx);
    var isInit = symbolType !== this._symbolType;
    if (isInit) {
        var keepAspect = data.getItemVisual(idx, "symbolKeepAspect");
        this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
    } else {
        var symbolPath = this.childAt(0);
        symbolPath.silent = false;
        $4b57d6b582d579b7$export$c8dce3c08436e91e(symbolPath, {
            scale: $051ad5e1a7c7bd92$var$getScale(symbolSize)
        }, seriesModel, idx);
    }
    this._updateCommon(data, idx, symbolSize, seriesScope);
    if (isInit) {
        var symbolPath = this.childAt(0);
        var fadeIn = seriesScope && seriesScope.fadeIn;
        var target = {
            scale: symbolPath.scale.slice()
        };
        fadeIn && (target.style = {
            opacity: symbolPath.style.opacity
        });
        symbolPath.scale = [
            0,
            0
        ];
        fadeIn && (symbolPath.style.opacity = 0);
        $4b57d6b582d579b7$export$a121566aadcfe021(symbolPath, target, seriesModel, idx);
    }
    this._seriesModel = seriesModel;
}; // Update common properties
var $051ad5e1a7c7bd92$var$normalStyleAccessPath = [
    "itemStyle"
];
var $051ad5e1a7c7bd92$var$emphasisStyleAccessPath = [
    "emphasis",
    "itemStyle"
];
var $051ad5e1a7c7bd92$var$normalLabelAccessPath = [
    "label"
];
var $051ad5e1a7c7bd92$var$emphasisLabelAccessPath = [
    "emphasis",
    "label"
];
/**
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @param {Array.<number>} symbolSize
 * @param {Object} [seriesScope]
 */ $051ad5e1a7c7bd92$var$symbolProto._updateCommon = function(data, idx, symbolSize, seriesScope) {
    var symbolPath = this.childAt(0);
    var seriesModel = data.hostModel;
    var color = data.getItemVisual(idx, "color"); // Reset style
    if (symbolPath.type !== "image") symbolPath.useStyle({
        strokeNoScale: true
    });
    else symbolPath.setStyle({
        opacity: 1,
        shadowBlur: null,
        shadowOffsetX: null,
        shadowOffsetY: null,
        shadowColor: null
    });
    var itemStyle = seriesScope && seriesScope.itemStyle;
    var hoverItemStyle = seriesScope && seriesScope.hoverItemStyle;
    var symbolOffset = seriesScope && seriesScope.symbolOffset;
    var labelModel = seriesScope && seriesScope.labelModel;
    var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel;
    var hoverAnimation = seriesScope && seriesScope.hoverAnimation;
    var cursorStyle = seriesScope && seriesScope.cursorStyle;
    if (!seriesScope || data.hasItemOption) {
        var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx); // Color must be excluded.
        // Because symbol provide setColor individually to set fill and stroke
        itemStyle = itemModel.getModel($051ad5e1a7c7bd92$var$normalStyleAccessPath).getItemStyle([
            "color"
        ]);
        hoverItemStyle = itemModel.getModel($051ad5e1a7c7bd92$var$emphasisStyleAccessPath).getItemStyle();
        symbolOffset = itemModel.getShallow("symbolOffset");
        labelModel = itemModel.getModel($051ad5e1a7c7bd92$var$normalLabelAccessPath);
        hoverLabelModel = itemModel.getModel($051ad5e1a7c7bd92$var$emphasisLabelAccessPath);
        hoverAnimation = itemModel.getShallow("hoverAnimation");
        cursorStyle = itemModel.getShallow("cursor");
    } else hoverItemStyle = $ec279652dd95c27b$export$8b58be045bf06082({}, hoverItemStyle);
    var elStyle = symbolPath.style;
    var symbolRotate = data.getItemVisual(idx, "symbolRotate");
    symbolPath.attr("rotation", (symbolRotate || 0) * Math.PI / 180 || 0);
    if (symbolOffset) symbolPath.attr("position", [
        $051ad5e1a7c7bd92$var$parsePercent(symbolOffset[0], symbolSize[0]),
        $051ad5e1a7c7bd92$var$parsePercent(symbolOffset[1], symbolSize[1])
    ]);
    cursorStyle && symbolPath.attr("cursor", cursorStyle); // PENDING setColor before setStyle!!!
    symbolPath.setColor(color, seriesScope && seriesScope.symbolInnerColor);
    symbolPath.setStyle(itemStyle);
    var opacity = data.getItemVisual(idx, "opacity");
    if (opacity != null) elStyle.opacity = opacity;
    var liftZ = data.getItemVisual(idx, "liftZ");
    var z2Origin = symbolPath.__z2Origin;
    if (liftZ != null) {
        if (z2Origin == null) {
            symbolPath.__z2Origin = symbolPath.z2;
            symbolPath.z2 += liftZ;
        }
    } else if (z2Origin != null) {
        symbolPath.z2 = z2Origin;
        symbolPath.__z2Origin = null;
    }
    var useNameLabel = seriesScope && seriesScope.useNameLabel;
    $4b57d6b582d579b7$export$9a13992917966657(elStyle, hoverItemStyle, labelModel, hoverLabelModel, {
        labelFetcher: seriesModel,
        labelDataIndex: idx,
        defaultText: getLabelDefaultText,
        isRectText: true,
        autoColor: color
    }); // Do not execute util needed.
    function getLabelDefaultText(idx, opt) {
        return useNameLabel ? data.getName(idx) : $051ad5e1a7c7bd92$var$getDefaultLabel(data, idx);
    }
    symbolPath.__symbolOriginalScale = $051ad5e1a7c7bd92$var$getScale(symbolSize);
    symbolPath.hoverStyle = hoverItemStyle;
    symbolPath.highDownOnUpdate = hoverAnimation && seriesModel.isAnimationEnabled() ? $051ad5e1a7c7bd92$var$highDownOnUpdate : null;
    $4b57d6b582d579b7$export$28b42df8183f218c(symbolPath);
};
function $051ad5e1a7c7bd92$var$highDownOnUpdate(fromState, toState) {
    // Do not support this hover animation util some scenario required.
    // Animation can only be supported in hover layer when using `el.incremetal`.
    if (this.incremental || this.useHoverLayer) return;
    if (toState === "emphasis") {
        var scale = this.__symbolOriginalScale;
        var ratio = scale[1] / scale[0];
        var emphasisOpt = {
            scale: [
                Math.max(scale[0] * 1.1, scale[0] + 3),
                Math.max(scale[1] * 1.1, scale[1] + 3 * ratio)
            ]
        }; // FIXME
        // modify it after support stop specified animation.
        // toState === fromState
        //     ? (this.stopAnimation(), this.attr(emphasisOpt))
        this.animateTo(emphasisOpt, 400, "elasticOut");
    } else if (toState === "normal") this.animateTo({
        scale: this.__symbolOriginalScale
    }, 400, "elasticOut");
}
/**
 * @param {Function} cb
 * @param {Object} [opt]
 * @param {Object} [opt.keepLabel=true]
 */ $051ad5e1a7c7bd92$var$symbolProto.fadeOut = function(cb, opt) {
    var symbolPath = this.childAt(0); // Avoid mistaken hover when fading out
    this.silent = symbolPath.silent = true; // Not show text when animating
    !(opt && opt.keepLabel) && (symbolPath.style.text = null);
    $4b57d6b582d579b7$export$c8dce3c08436e91e(symbolPath, {
        style: {
            opacity: 0
        },
        scale: [
            0,
            0
        ]
    }, this._seriesModel, this.dataIndex, cb);
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($051ad5e1a7c7bd92$var$SymbolClz, $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4);
var $051ad5e1a7c7bd92$var$_default = $051ad5e1a7c7bd92$var$SymbolClz;
$051ad5e1a7c7bd92$exports = $051ad5e1a7c7bd92$var$_default;



var $e99d13e2181fb062$var$isObject = $ec279652dd95c27b$export$a6cdc56e425d0d0a;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @module echarts/chart/helper/SymbolDraw
 */ /**
 * @constructor
 * @alias module:echarts/chart/helper/SymbolDraw
 * @param {module:zrender/graphic/Group} [symbolCtor]
 */ function $e99d13e2181fb062$var$SymbolDraw(symbolCtor) {
    this.group = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
    this._symbolCtor = symbolCtor || $051ad5e1a7c7bd92$exports;
}
var $e99d13e2181fb062$var$symbolDrawProto = $e99d13e2181fb062$var$SymbolDraw.prototype;
function $e99d13e2181fb062$var$symbolNeedsDraw(data, point, idx, opt) {
    return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx) // We do not set clipShape on group, because it will cut part of
    ) && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, "symbol") !== "none";
}
/**
 * Update symbols draw by new data
 * @param {module:echarts/data/List} data
 * @param {Object} [opt] Or isIgnore
 * @param {Function} [opt.isIgnore]
 * @param {Object} [opt.clipShape]
 */ $e99d13e2181fb062$var$symbolDrawProto.updateData = function(data, opt) {
    opt = $e99d13e2181fb062$var$normalizeUpdateOpt(opt);
    var group = this.group;
    var seriesModel = data.hostModel;
    var oldData = this._data;
    var SymbolCtor = this._symbolCtor;
    var seriesScope = $e99d13e2181fb062$var$makeSeriesScope(data); // There is no oldLineData only when first rendering or switching from
    // stream mode to normal mode, where previous elements should be removed.
    if (!oldData) group.removeAll();
    data.diff(oldData).add(function(newIdx) {
        var point = data.getItemLayout(newIdx);
        if ($e99d13e2181fb062$var$symbolNeedsDraw(data, point, newIdx, opt)) {
            var symbolEl = new SymbolCtor(data, newIdx, seriesScope);
            symbolEl.attr("position", point);
            data.setItemGraphicEl(newIdx, symbolEl);
            group.add(symbolEl);
        }
    }).update(function(newIdx, oldIdx) {
        var symbolEl = oldData.getItemGraphicEl(oldIdx);
        var point = data.getItemLayout(newIdx);
        if (!$e99d13e2181fb062$var$symbolNeedsDraw(data, point, newIdx, opt)) {
            group.remove(symbolEl);
            return;
        }
        if (!symbolEl) {
            symbolEl = new SymbolCtor(data, newIdx);
            symbolEl.attr("position", point);
        } else {
            symbolEl.updateData(data, newIdx, seriesScope);
            $4b57d6b582d579b7$export$c8dce3c08436e91e(symbolEl, {
                position: point
            }, seriesModel);
        } // Add back
        group.add(symbolEl);
        data.setItemGraphicEl(newIdx, symbolEl);
    }).remove(function(oldIdx) {
        var el = oldData.getItemGraphicEl(oldIdx);
        el && el.fadeOut(function() {
            group.remove(el);
        });
    }).execute();
    this._data = data;
};
$e99d13e2181fb062$var$symbolDrawProto.isPersistent = function() {
    return true;
};
$e99d13e2181fb062$var$symbolDrawProto.updateLayout = function() {
    var data = this._data;
    if (data) // Not use animation
    data.eachItemGraphicEl(function(el, idx) {
        var point = data.getItemLayout(idx);
        el.attr("position", point);
    });
};
$e99d13e2181fb062$var$symbolDrawProto.incrementalPrepareUpdate = function(data) {
    this._seriesScope = $e99d13e2181fb062$var$makeSeriesScope(data);
    this._data = null;
    this.group.removeAll();
};
/**
 * Update symbols draw by new data
 * @param {module:echarts/data/List} data
 * @param {Object} [opt] Or isIgnore
 * @param {Function} [opt.isIgnore]
 * @param {Object} [opt.clipShape]
 */ $e99d13e2181fb062$var$symbolDrawProto.incrementalUpdate = function(taskParams, data, opt) {
    opt = $e99d13e2181fb062$var$normalizeUpdateOpt(opt);
    function updateIncrementalAndHover(el) {
        if (!el.isGroup) el.incremental = el.useHoverLayer = true;
    }
    for(var idx = taskParams.start; idx < taskParams.end; idx++){
        var point = data.getItemLayout(idx);
        if ($e99d13e2181fb062$var$symbolNeedsDraw(data, point, idx, opt)) {
            var el = new this._symbolCtor(data, idx, this._seriesScope);
            el.traverse(updateIncrementalAndHover);
            el.attr("position", point);
            this.group.add(el);
            data.setItemGraphicEl(idx, el);
        }
    }
};
function $e99d13e2181fb062$var$normalizeUpdateOpt(opt) {
    if (opt != null && !$e99d13e2181fb062$var$isObject(opt)) opt = {
        isIgnore: opt
    };
    return opt || {};
}
$e99d13e2181fb062$var$symbolDrawProto.remove = function(enableAnimation) {
    var group = this.group;
    var data = this._data; // Incremental model do not have this._data.
    if (data && enableAnimation) data.eachItemGraphicEl(function(el) {
        el.fadeOut(function() {
            group.remove(el);
        });
    });
    else group.removeAll();
};
function $e99d13e2181fb062$var$makeSeriesScope(data) {
    var seriesModel = data.hostModel;
    return {
        itemStyle: seriesModel.getModel("itemStyle").getItemStyle([
            "color"
        ]),
        hoverItemStyle: seriesModel.getModel("emphasis.itemStyle").getItemStyle(),
        symbolRotate: seriesModel.get("symbolRotate"),
        symbolOffset: seriesModel.get("symbolOffset"),
        hoverAnimation: seriesModel.get("hoverAnimation"),
        labelModel: seriesModel.getModel("label"),
        hoverLabelModel: seriesModel.getModel("emphasis.label"),
        cursorStyle: seriesModel.get("cursor")
    };
}
var $e99d13e2181fb062$var$_default = $e99d13e2181fb062$var$SymbolDraw;
$e99d13e2181fb062$exports = $e99d13e2181fb062$var$_default;



var $3b1969327efa589a$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $c262b1a9157d3e82$export$b488a529581b37e;
var $c262b1a9157d3e82$export$c1601aa630e7b5f8;

var $c262b1a9157d3e82$var$isDimensionStacked = $1712a5e8fbedbcb3$export$1dedc39359ae35c;

var $c262b1a9157d3e82$var$map = $ec279652dd95c27b$export$871de8747c9eaa88;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @param {Object} coordSys
 * @param {module:echarts/data/List} data
 * @param {string} valueOrigin lineSeries.option.areaStyle.origin
 */ function $c262b1a9157d3e82$var$prepareDataCoordInfo(coordSys, data, valueOrigin) {
    var baseAxis = coordSys.getBaseAxis();
    var valueAxis = coordSys.getOtherAxis(baseAxis);
    var valueStart = $c262b1a9157d3e82$var$getValueStart(valueAxis, valueOrigin);
    var baseAxisDim = baseAxis.dim;
    var valueAxisDim = valueAxis.dim;
    var valueDim = data.mapDimension(valueAxisDim);
    var baseDim = data.mapDimension(baseAxisDim);
    var baseDataOffset = valueAxisDim === "x" || valueAxisDim === "radius" ? 1 : 0;
    var dims = $c262b1a9157d3e82$var$map(coordSys.dimensions, function(coordDim) {
        return data.mapDimension(coordDim);
    });
    var stacked;
    var stackResultDim = data.getCalculationInfo("stackResultDimension");
    if (stacked |= $c262b1a9157d3e82$var$isDimensionStacked(data, dims[0])) // jshint ignore:line
    dims[0] = stackResultDim;
    if (stacked |= $c262b1a9157d3e82$var$isDimensionStacked(data, dims[1])) // jshint ignore:line
    dims[1] = stackResultDim;
    return {
        dataDimsForPoint: dims,
        valueStart: valueStart,
        valueAxisDim: valueAxisDim,
        baseAxisDim: baseAxisDim,
        stacked: !!stacked,
        valueDim: valueDim,
        baseDim: baseDim,
        baseDataOffset: baseDataOffset,
        stackedOverDimension: data.getCalculationInfo("stackedOverDimension")
    };
}
function $c262b1a9157d3e82$var$getValueStart(valueAxis, valueOrigin) {
    var valueStart = 0;
    var extent = valueAxis.scale.getExtent();
    if (valueOrigin === "start") valueStart = extent[0];
    else if (valueOrigin === "end") valueStart = extent[1];
    else {
        // Both positive
        if (extent[0] > 0) valueStart = extent[0];
        else if (extent[1] < 0) valueStart = extent[1];
         // If is one positive, and one negative, onZero shall be true
    }
    return valueStart;
}
function $c262b1a9157d3e82$var$getStackedOnPoint(dataCoordInfo, coordSys, data, idx) {
    var value = NaN;
    if (dataCoordInfo.stacked) value = data.get(data.getCalculationInfo("stackedOverDimension"), idx);
    if (isNaN(value)) value = dataCoordInfo.valueStart;
    var baseDataOffset = dataCoordInfo.baseDataOffset;
    var stackedData = [];
    stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
    stackedData[1 - baseDataOffset] = value;
    return coordSys.dataToPoint(stackedData);
}
$c262b1a9157d3e82$export$b488a529581b37e = $c262b1a9157d3e82$var$prepareDataCoordInfo;
$c262b1a9157d3e82$export$c1601aa630e7b5f8 = $c262b1a9157d3e82$var$getStackedOnPoint;


var $3b1969327efa589a$var$prepareDataCoordInfo = $c262b1a9157d3e82$export$b488a529581b37e;
var $3b1969327efa589a$var$getStackedOnPoint = $c262b1a9157d3e82$export$c1601aa630e7b5f8;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // var arrayDiff = require('zrender/src/core/arrayDiff');
// 'zrender/src/core/arrayDiff' has been used before, but it did
// not do well in performance when roam with fixed dataZoom window.
// function convertToIntId(newIdList, oldIdList) {
//     // Generate int id instead of string id.
//     // Compare string maybe slow in score function of arrDiff
//     // Assume id in idList are all unique
//     var idIndicesMap = {};
//     var idx = 0;
//     for (var i = 0; i < newIdList.length; i++) {
//         idIndicesMap[newIdList[i]] = idx;
//         newIdList[i] = idx++;
//     }
//     for (var i = 0; i < oldIdList.length; i++) {
//         var oldId = oldIdList[i];
//         // Same with newIdList
//         if (idIndicesMap[oldId]) {
//             oldIdList[i] = idIndicesMap[oldId];
//         }
//         else {
//             oldIdList[i] = idx++;
//         }
//     }
// }
function $3b1969327efa589a$var$diffData(oldData, newData) {
    var diffResult = [];
    newData.diff(oldData).add(function(idx) {
        diffResult.push({
            cmd: "+",
            idx: idx
        });
    }).update(function(newIdx, oldIdx) {
        diffResult.push({
            cmd: "=",
            idx: oldIdx,
            idx1: newIdx
        });
    }).remove(function(idx) {
        diffResult.push({
            cmd: "-",
            idx: idx
        });
    }).execute();
    return diffResult;
}
function $3b1969327efa589a$var$_default(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
    var diff = $3b1969327efa589a$var$diffData(oldData, newData); // var newIdList = newData.mapArray(newData.getId);
    // var oldIdList = oldData.mapArray(oldData.getId);
    // convertToIntId(newIdList, oldIdList);
    // // FIXME One data ?
    // diff = arrayDiff(oldIdList, newIdList);
    var currPoints = [];
    var nextPoints = []; // Points for stacking base line
    var currStackedPoints = [];
    var nextStackedPoints = [];
    var status = [];
    var sortedIndices = [];
    var rawIndices = [];
    var newDataOldCoordInfo = $3b1969327efa589a$var$prepareDataCoordInfo(oldCoordSys, newData, oldValueOrigin);
    var oldDataNewCoordInfo = $3b1969327efa589a$var$prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);
    for(var i = 0; i < diff.length; i++){
        var diffItem = diff[i];
        var pointAdded = true; // FIXME, animation is not so perfect when dataZoom window moves fast
        // Which is in case remvoing or add more than one data in the tail or head
        switch(diffItem.cmd){
            case "=":
                var currentPt = oldData.getItemLayout(diffItem.idx);
                var nextPt = newData.getItemLayout(diffItem.idx1); // If previous data is NaN, use next point directly
                if (isNaN(currentPt[0]) || isNaN(currentPt[1])) currentPt = nextPt.slice();
                currPoints.push(currentPt);
                nextPoints.push(nextPt);
                currStackedPoints.push(oldStackedOnPoints[diffItem.idx]);
                nextStackedPoints.push(newStackedOnPoints[diffItem.idx1]);
                rawIndices.push(newData.getRawIndex(diffItem.idx1));
                break;
            case "+":
                var idx = diffItem.idx;
                currPoints.push(oldCoordSys.dataToPoint([
                    newData.get(newDataOldCoordInfo.dataDimsForPoint[0], idx),
                    newData.get(newDataOldCoordInfo.dataDimsForPoint[1], idx)
                ]));
                nextPoints.push(newData.getItemLayout(idx).slice());
                currStackedPoints.push($3b1969327efa589a$var$getStackedOnPoint(newDataOldCoordInfo, oldCoordSys, newData, idx));
                nextStackedPoints.push(newStackedOnPoints[idx]);
                rawIndices.push(newData.getRawIndex(idx));
                break;
            case "-":
                var idx = diffItem.idx;
                var rawIndex = oldData.getRawIndex(idx); // Data is replaced. In the case of dynamic data queue
                // FIXME FIXME FIXME
                if (rawIndex !== idx) {
                    currPoints.push(oldData.getItemLayout(idx));
                    nextPoints.push(newCoordSys.dataToPoint([
                        oldData.get(oldDataNewCoordInfo.dataDimsForPoint[0], idx),
                        oldData.get(oldDataNewCoordInfo.dataDimsForPoint[1], idx)
                    ]));
                    currStackedPoints.push(oldStackedOnPoints[idx]);
                    nextStackedPoints.push($3b1969327efa589a$var$getStackedOnPoint(oldDataNewCoordInfo, newCoordSys, oldData, idx));
                    rawIndices.push(rawIndex);
                } else pointAdded = false;
        } // Original indices
        if (pointAdded) {
            status.push(diffItem);
            sortedIndices.push(sortedIndices.length);
        }
    } // Diff result may be crossed if all items are changed
    // Sort by data index
    sortedIndices.sort(function(a, b) {
        return rawIndices[a] - rawIndices[b];
    });
    var sortedCurrPoints = [];
    var sortedNextPoints = [];
    var sortedCurrStackedPoints = [];
    var sortedNextStackedPoints = [];
    var sortedStatus = [];
    for(var i = 0; i < sortedIndices.length; i++){
        var idx = sortedIndices[i];
        sortedCurrPoints[i] = currPoints[idx];
        sortedNextPoints[i] = nextPoints[idx];
        sortedCurrStackedPoints[i] = currStackedPoints[idx];
        sortedNextStackedPoints[i] = nextStackedPoints[idx];
        sortedStatus[i] = status[idx];
    }
    return {
        current: sortedCurrPoints,
        next: sortedNextPoints,
        stackedOnCurrent: sortedCurrStackedPoints,
        stackedOnNext: sortedNextStackedPoints,
        status: sortedStatus
    };
}
$3b1969327efa589a$exports = $3b1969327efa589a$var$_default;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $e116d72876f40a95$export$79f3ee03e63e7073;
var $e116d72876f40a95$export$7d31b617c820d435;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Poly path support NaN point
var $e116d72876f40a95$var$vec2Min = $9eb63d101f3bcd79$export$96ec731ed4dcb222;
var $e116d72876f40a95$var$vec2Max = $9eb63d101f3bcd79$export$8960430cfd85939f;
var $e116d72876f40a95$var$scaleAndAdd = $9eb63d101f3bcd79$export$19cedf1da84ba854;
var $e116d72876f40a95$var$v2Copy = $9eb63d101f3bcd79$export$784d13d8ee351f07; // Temporary variable
var $e116d72876f40a95$var$v = [];
var $e116d72876f40a95$var$cp0 = [];
var $e116d72876f40a95$var$cp1 = [];
function $e116d72876f40a95$var$isPointNull(p) {
    return isNaN(p[0]) || isNaN(p[1]);
}
function $e116d72876f40a95$var$drawSegment(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
    // if (smoothMonotone == null) {
    //     if (isMono(points, 'x')) {
    //         return drawMono(ctx, points, start, segLen, allLen,
    //             dir, smoothMin, smoothMax, smooth, 'x', connectNulls);
    //     }
    //     else if (isMono(points, 'y')) {
    //         return drawMono(ctx, points, start, segLen, allLen,
    //             dir, smoothMin, smoothMax, smooth, 'y', connectNulls);
    //     }
    //     else {
    //         return drawNonMono.apply(this, arguments);
    //     }
    // }
    // else if (smoothMonotone !== 'none' && isMono(points, smoothMonotone)) {
    //     return drawMono.apply(this, arguments);
    // }
    // else {
    //     return drawNonMono.apply(this, arguments);
    // }
    if (smoothMonotone === "none" || !smoothMonotone) return $e116d72876f40a95$var$drawNonMono.apply(this, arguments);
    else return $e116d72876f40a95$var$drawMono.apply(this, arguments);
}
/**
 * Check if points is in monotone.
 *
 * @param {number[][]} points         Array of points which is in [x, y] form
 * @param {string}     smoothMonotone 'x', 'y', or 'none', stating for which
 *                                    dimension that is checking.
 *                                    If is 'none', `drawNonMono` should be
 *                                    called.
 *                                    If is undefined, either being monotone
 *                                    in 'x' or 'y' will call `drawMono`.
 */ // function isMono(points, smoothMonotone) {
//     if (points.length <= 1) {
//         return true;
//     }
//     var dim = smoothMonotone === 'x' ? 0 : 1;
//     var last = points[0][dim];
//     var lastDiff = 0;
//     for (var i = 1; i < points.length; ++i) {
//         var diff = points[i][dim] - last;
//         if (!isNaN(diff) && !isNaN(lastDiff)
//             && diff !== 0 && lastDiff !== 0
//             && ((diff >= 0) !== (lastDiff >= 0))
//         ) {
//             return false;
//         }
//         if (!isNaN(diff) && diff !== 0) {
//             lastDiff = diff;
//             last = points[i][dim];
//         }
//     }
//     return true;
// }
/**
 * Draw smoothed line in monotone, in which only vertical or horizontal bezier
 * control points will be used. This should be used when points are monotone
 * either in x or y dimension.
 */ function $e116d72876f40a95$var$drawMono(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
    var prevIdx = 0;
    var idx = start;
    for(var k = 0; k < segLen; k++){
        var p = points[idx];
        if (idx >= allLen || idx < 0) break;
        if ($e116d72876f40a95$var$isPointNull(p)) {
            if (connectNulls) {
                idx += dir;
                continue;
            }
            break;
        }
        if (idx === start) ctx[dir > 0 ? "moveTo" : "lineTo"](p[0], p[1]);
        else if (smooth > 0) {
            var prevP = points[prevIdx];
            var dim = smoothMonotone === "y" ? 1 : 0; // Length of control point to p, either in x or y, but not both
            var ctrlLen = (p[dim] - prevP[dim]) * smooth;
            $e116d72876f40a95$var$v2Copy($e116d72876f40a95$var$cp0, prevP);
            $e116d72876f40a95$var$cp0[dim] = prevP[dim] + ctrlLen;
            $e116d72876f40a95$var$v2Copy($e116d72876f40a95$var$cp1, p);
            $e116d72876f40a95$var$cp1[dim] = p[dim] - ctrlLen;
            ctx.bezierCurveTo($e116d72876f40a95$var$cp0[0], $e116d72876f40a95$var$cp0[1], $e116d72876f40a95$var$cp1[0], $e116d72876f40a95$var$cp1[1], p[0], p[1]);
        } else ctx.lineTo(p[0], p[1]);
        prevIdx = idx;
        idx += dir;
    }
    return k;
}
/**
 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
 * situations. This should be used when points are non-monotone neither in x or
 * y dimension.
 */ function $e116d72876f40a95$var$drawNonMono(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
    var prevIdx = 0;
    var idx = start;
    for(var k = 0; k < segLen; k++){
        var p = points[idx];
        if (idx >= allLen || idx < 0) break;
        if ($e116d72876f40a95$var$isPointNull(p)) {
            if (connectNulls) {
                idx += dir;
                continue;
            }
            break;
        }
        if (idx === start) {
            ctx[dir > 0 ? "moveTo" : "lineTo"](p[0], p[1]);
            $e116d72876f40a95$var$v2Copy($e116d72876f40a95$var$cp0, p);
        } else if (smooth > 0) {
            var nextIdx = idx + dir;
            var nextP = points[nextIdx];
            if (connectNulls) // Find next point not null
            while(nextP && $e116d72876f40a95$var$isPointNull(points[nextIdx])){
                nextIdx += dir;
                nextP = points[nextIdx];
            }
            var ratioNextSeg = 0.5;
            var prevP = points[prevIdx];
            var nextP = points[nextIdx]; // Last point
            if (!nextP || $e116d72876f40a95$var$isPointNull(nextP)) $e116d72876f40a95$var$v2Copy($e116d72876f40a95$var$cp1, p);
            else {
                // If next data is null in not connect case
                if ($e116d72876f40a95$var$isPointNull(nextP) && !connectNulls) nextP = p;
                $9eb63d101f3bcd79$export$f93b5905241a7cca($e116d72876f40a95$var$v, nextP, prevP);
                var lenPrevSeg;
                var lenNextSeg;
                if (smoothMonotone === "x" || smoothMonotone === "y") {
                    var dim = smoothMonotone === "x" ? 0 : 1;
                    lenPrevSeg = Math.abs(p[dim] - prevP[dim]);
                    lenNextSeg = Math.abs(p[dim] - nextP[dim]);
                } else {
                    lenPrevSeg = $9eb63d101f3bcd79$export$6c4a311cc157c764(p, prevP);
                    lenNextSeg = $9eb63d101f3bcd79$export$6c4a311cc157c764(p, nextP);
                } // Use ratio of seg length
                ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
                $e116d72876f40a95$var$scaleAndAdd($e116d72876f40a95$var$cp1, p, $e116d72876f40a95$var$v, -smooth * (1 - ratioNextSeg));
            } // Smooth constraint
            $e116d72876f40a95$var$vec2Min($e116d72876f40a95$var$cp0, $e116d72876f40a95$var$cp0, smoothMax);
            $e116d72876f40a95$var$vec2Max($e116d72876f40a95$var$cp0, $e116d72876f40a95$var$cp0, smoothMin);
            $e116d72876f40a95$var$vec2Min($e116d72876f40a95$var$cp1, $e116d72876f40a95$var$cp1, smoothMax);
            $e116d72876f40a95$var$vec2Max($e116d72876f40a95$var$cp1, $e116d72876f40a95$var$cp1, smoothMin);
            ctx.bezierCurveTo($e116d72876f40a95$var$cp0[0], $e116d72876f40a95$var$cp0[1], $e116d72876f40a95$var$cp1[0], $e116d72876f40a95$var$cp1[1], p[0], p[1]); // cp0 of next segment
            $e116d72876f40a95$var$scaleAndAdd($e116d72876f40a95$var$cp0, p, $e116d72876f40a95$var$v, smooth * ratioNextSeg);
        } else ctx.lineTo(p[0], p[1]);
        prevIdx = idx;
        idx += dir;
    }
    return k;
}
function $e116d72876f40a95$var$getBoundingBox(points, smoothConstraint) {
    var ptMin = [
        Infinity,
        Infinity
    ];
    var ptMax = [
        -Infinity,
        -Infinity
    ];
    if (smoothConstraint) for(var i = 0; i < points.length; i++){
        var pt = points[i];
        if (pt[0] < ptMin[0]) ptMin[0] = pt[0];
        if (pt[1] < ptMin[1]) ptMin[1] = pt[1];
        if (pt[0] > ptMax[0]) ptMax[0] = pt[0];
        if (pt[1] > ptMax[1]) ptMax[1] = pt[1];
    }
    return {
        min: smoothConstraint ? ptMin : ptMax,
        max: smoothConstraint ? ptMax : ptMin
    };
}
var $e116d72876f40a95$var$Polyline = $b9701a0f23f767de$exports.extend({
    type: "ec-polyline",
    shape: {
        points: [],
        smooth: 0,
        smoothConstraint: true,
        smoothMonotone: null,
        connectNulls: false
    },
    style: {
        fill: null,
        stroke: "#000"
    },
    brush: $a68c476206b129a9$exports($b9701a0f23f767de$exports.prototype.brush),
    buildPath: function(ctx, shape) {
        var points = shape.points;
        var i = 0;
        var len = points.length;
        var result = $e116d72876f40a95$var$getBoundingBox(points, shape.smoothConstraint);
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$e116d72876f40a95$var$isPointNull(points[len - 1])) break;
            }
            for(; i < len; i++){
                if (!$e116d72876f40a95$var$isPointNull(points[i])) break;
            }
        }
        while(i < len)i += $e116d72876f40a95$var$drawSegment(ctx, points, i, len, len, 1, result.min, result.max, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
    }
});
var $e116d72876f40a95$var$Polygon = $b9701a0f23f767de$exports.extend({
    type: "ec-polygon",
    shape: {
        points: [],
        // Offset between stacked base points and points
        stackedOnPoints: [],
        smooth: 0,
        stackedOnSmooth: 0,
        smoothConstraint: true,
        smoothMonotone: null,
        connectNulls: false
    },
    brush: $a68c476206b129a9$exports($b9701a0f23f767de$exports.prototype.brush),
    buildPath: function(ctx, shape) {
        var points = shape.points;
        var stackedOnPoints = shape.stackedOnPoints;
        var i = 0;
        var len = points.length;
        var smoothMonotone = shape.smoothMonotone;
        var bbox = $e116d72876f40a95$var$getBoundingBox(points, shape.smoothConstraint);
        var stackedOnBBox = $e116d72876f40a95$var$getBoundingBox(stackedOnPoints, shape.smoothConstraint);
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$e116d72876f40a95$var$isPointNull(points[len - 1])) break;
            }
            for(; i < len; i++){
                if (!$e116d72876f40a95$var$isPointNull(points[i])) break;
            }
        }
        while(i < len){
            var k = $e116d72876f40a95$var$drawSegment(ctx, points, i, len, len, 1, bbox.min, bbox.max, shape.smooth, smoothMonotone, shape.connectNulls);
            $e116d72876f40a95$var$drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, stackedOnBBox.min, stackedOnBBox.max, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
            i += k + 1;
            ctx.closePath();
        }
    }
});
$e116d72876f40a95$export$79f3ee03e63e7073 = $e116d72876f40a95$var$Polyline;
$e116d72876f40a95$export$7d31b617c820d435 = $e116d72876f40a95$var$Polygon;


var $92ccbedd9013fd4e$var$Polyline = $e116d72876f40a95$export$79f3ee03e63e7073;
var $92ccbedd9013fd4e$var$Polygon = $e116d72876f40a95$export$7d31b617c820d435;


var $92ccbedd9013fd4e$var$prepareDataCoordInfo = $c262b1a9157d3e82$export$b488a529581b37e;
var $92ccbedd9013fd4e$var$getStackedOnPoint = $c262b1a9157d3e82$export$c1601aa630e7b5f8;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $df90403704fddb7c$export$83958787eb658d14;
var $df90403704fddb7c$export$13dc2b2230df3cb5;
var $df90403704fddb7c$export$e0fe5081209d01c9;


var $df90403704fddb7c$var$round = $2d742dbe7f960d8c$export$2077e0241d6afd3c;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $df90403704fddb7c$var$createGridClipPath(cartesian, hasAnimation, seriesModel) {
    var rect = cartesian.getArea();
    var isHorizontal = cartesian.getBaseAxis().isHorizontal();
    var x = rect.x;
    var y = rect.y;
    var width = rect.width;
    var height = rect.height;
    var lineWidth = seriesModel.get("lineStyle.width") || 2; // Expand the clip path a bit to avoid the border is clipped and looks thinner
    x -= lineWidth / 2;
    y -= lineWidth / 2;
    width += lineWidth;
    height += lineWidth; // fix: https://github.com/apache/incubator-echarts/issues/11369
    x = Math.floor(x);
    width = Math.round(width);
    var clipPath = new $4b57d6b582d579b7$export$c79fc6492f3af13d({
        shape: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    });
    if (hasAnimation) {
        clipPath.shape[isHorizontal ? "width" : "height"] = 0;
        $4b57d6b582d579b7$export$a121566aadcfe021(clipPath, {
            shape: {
                width: width,
                height: height
            }
        }, seriesModel);
    }
    return clipPath;
}
function $df90403704fddb7c$var$createPolarClipPath(polar, hasAnimation, seriesModel) {
    var sectorArea = polar.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
    var clipPath = new $4b57d6b582d579b7$export$e98c2c7eb2b14f45({
        shape: {
            cx: $df90403704fddb7c$var$round(polar.cx, 1),
            cy: $df90403704fddb7c$var$round(polar.cy, 1),
            r0: $df90403704fddb7c$var$round(sectorArea.r0, 1),
            r: $df90403704fddb7c$var$round(sectorArea.r, 1),
            startAngle: sectorArea.startAngle,
            endAngle: sectorArea.endAngle,
            clockwise: sectorArea.clockwise
        }
    });
    if (hasAnimation) {
        clipPath.shape.endAngle = sectorArea.startAngle;
        $4b57d6b582d579b7$export$a121566aadcfe021(clipPath, {
            shape: {
                endAngle: sectorArea.endAngle
            }
        }, seriesModel);
    }
    return clipPath;
}
function $df90403704fddb7c$var$createClipPath(coordSys, hasAnimation, seriesModel) {
    if (!coordSys) return null;
    else if (coordSys.type === "polar") return $df90403704fddb7c$var$createPolarClipPath(coordSys, hasAnimation, seriesModel);
    else if (coordSys.type === "cartesian2d") return $df90403704fddb7c$var$createGridClipPath(coordSys, hasAnimation, seriesModel);
    return null;
}
$df90403704fddb7c$export$83958787eb658d14 = $df90403704fddb7c$var$createGridClipPath;
$df90403704fddb7c$export$13dc2b2230df3cb5 = $df90403704fddb7c$var$createPolarClipPath;
$df90403704fddb7c$export$e0fe5081209d01c9 = $df90403704fddb7c$var$createClipPath;


var $92ccbedd9013fd4e$var$createGridClipPath = $df90403704fddb7c$export$83958787eb658d14;
var $92ccbedd9013fd4e$var$createPolarClipPath = $df90403704fddb7c$export$13dc2b2230df3cb5;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME step not support polar
function $92ccbedd9013fd4e$var$isPointsSame(points1, points2) {
    if (points1.length !== points2.length) return;
    for(var i = 0; i < points1.length; i++){
        var p1 = points1[i];
        var p2 = points2[i];
        if (p1[0] !== p2[0] || p1[1] !== p2[1]) return;
    }
    return true;
}
function $92ccbedd9013fd4e$var$getBoundingDiff(points1, points2) {
    var min1 = [];
    var max1 = [];
    var min2 = [];
    var max2 = [];
    $92ccbedd9013fd4e$var$fromPoints(points1, min1, max1);
    $92ccbedd9013fd4e$var$fromPoints(points2, min2, max2); // Get a max value from each corner of two boundings.
    return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
}
function $92ccbedd9013fd4e$var$getSmooth(smooth) {
    return typeof smooth === "number" ? smooth : smooth ? 0.5 : 0;
}
/**
 * @param {module:echarts/coord/cartesian/Cartesian2D|module:echarts/coord/polar/Polar} coordSys
 * @param {module:echarts/data/List} data
 * @param {Object} dataCoordInfo
 * @param {Array.<Array.<number>>} points
 */ function $92ccbedd9013fd4e$var$getStackedOnPoints(coordSys, data, dataCoordInfo) {
    if (!dataCoordInfo.valueDim) return [];
    var points = [];
    for(var idx = 0, len = data.count(); idx < len; idx++)points.push($92ccbedd9013fd4e$var$getStackedOnPoint(dataCoordInfo, coordSys, data, idx));
    return points;
}
function $92ccbedd9013fd4e$var$turnPointsIntoStep(points, coordSys, stepTurnAt) {
    var baseAxis = coordSys.getBaseAxis();
    var baseIndex = baseAxis.dim === "x" || baseAxis.dim === "radius" ? 0 : 1;
    var stepPoints = [];
    for(var i = 0; i < points.length - 1; i++){
        var nextPt = points[i + 1];
        var pt = points[i];
        stepPoints.push(pt);
        var stepPt = [];
        switch(stepTurnAt){
            case "end":
                stepPt[baseIndex] = nextPt[baseIndex];
                stepPt[1 - baseIndex] = pt[1 - baseIndex]; // default is start
                stepPoints.push(stepPt);
                break;
            case "middle":
                // default is start
                var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
                var stepPt2 = [];
                stepPt[baseIndex] = stepPt2[baseIndex] = middle;
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt);
                stepPoints.push(stepPt2);
                break;
            default:
                stepPt[baseIndex] = pt[baseIndex];
                stepPt[1 - baseIndex] = nextPt[1 - baseIndex]; // default is start
                stepPoints.push(stepPt);
        }
    } // Last points
    points[i] && stepPoints.push(points[i]);
    return stepPoints;
}
function $92ccbedd9013fd4e$var$getVisualGradient(data, coordSys) {
    var visualMetaList = data.getVisual("visualMeta");
    if (!visualMetaList || !visualMetaList.length || !data.count()) // When data.count() is 0, gradient range can not be calculated.
    return;
    if (coordSys.type !== "cartesian2d") return;
    var coordDim;
    var visualMeta;
    for(var i = visualMetaList.length - 1; i >= 0; i--){
        var dimIndex = visualMetaList[i].dimension;
        var dimName = data.dimensions[dimIndex];
        var dimInfo = data.getDimensionInfo(dimName);
        coordDim = dimInfo && dimInfo.coordDim; // Can only be x or y
        if (coordDim === "x" || coordDim === "y") {
            visualMeta = visualMetaList[i];
            break;
        }
    }
    if (!visualMeta) return;
     // If the area to be rendered is bigger than area defined by LinearGradient,
    // the canvas spec prescribes that the color of the first stop and the last
    // stop should be used. But if two stops are added at offset 0, in effect
    // browsers use the color of the second stop to render area outside
    // LinearGradient. So we can only infinitesimally extend area defined in
    // LinearGradient to render `outerColors`.
    var axis = coordSys.getAxis(coordDim); // dataToCoor mapping may not be linear, but must be monotonic.
    var colorStops = $ec279652dd95c27b$export$871de8747c9eaa88(visualMeta.stops, function(stop) {
        return {
            coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
            color: stop.color
        };
    });
    var stopLen = colorStops.length;
    var outerColors = visualMeta.outerColors.slice();
    if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
        colorStops.reverse();
        outerColors.reverse();
    }
    var tinyExtent = 10; // Arbitrary value: 10px
    var minCoord = colorStops[0].coord - tinyExtent;
    var maxCoord = colorStops[stopLen - 1].coord + tinyExtent;
    var coordSpan = maxCoord - minCoord;
    if (coordSpan < 1e-3) return "transparent";
    $ec279652dd95c27b$export$79b2f7037acddd43(colorStops, function(stop) {
        stop.offset = (stop.coord - minCoord) / coordSpan;
    });
    colorStops.push({
        offset: stopLen ? colorStops[stopLen - 1].offset : 0.5,
        color: outerColors[1] || "transparent"
    });
    colorStops.unshift({
        // notice colorStops.length have been changed.
        offset: stopLen ? colorStops[0].offset : 0.5,
        color: outerColors[0] || "transparent"
    }); // zrUtil.each(colorStops, function (colorStop) {
    //     // Make sure each offset has rounded px to avoid not sharp edge
    //     colorStop.offset = (Math.round(colorStop.offset * (end - start) + start) - start) / (end - start);
    // });
    var gradient = new $4b57d6b582d579b7$export$39a41c7169757633(0, 0, 0, 0, colorStops, true);
    gradient[coordDim] = minCoord;
    gradient[coordDim + "2"] = maxCoord;
    return gradient;
}
function $92ccbedd9013fd4e$var$getIsIgnoreFunc(seriesModel, data, coordSys) {
    var showAllSymbol = seriesModel.get("showAllSymbol");
    var isAuto = showAllSymbol === "auto";
    if (showAllSymbol && !isAuto) return;
    var categoryAxis = coordSys.getAxesByScale("ordinal")[0];
    if (!categoryAxis) return;
     // Note that category label interval strategy might bring some weird effect
    // in some scenario: users may wonder why some of the symbols are not
    // displayed. So we show all symbols as possible as we can.
    if (isAuto // Simplify the logic, do not determine label overlap here.
     && $92ccbedd9013fd4e$var$canShowAllSymbolForCategory(categoryAxis, data)) return;
     // Otherwise follow the label interval strategy on category axis.
    var categoryDataDim = data.mapDimension(categoryAxis.dim);
    var labelMap = {};
    $ec279652dd95c27b$export$79b2f7037acddd43(categoryAxis.getViewLabels(), function(labelItem) {
        labelMap[labelItem.tickValue] = 1;
    });
    return function(dataIndex) {
        return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
    };
}
function $92ccbedd9013fd4e$var$canShowAllSymbolForCategory(categoryAxis, data) {
    // In mose cases, line is monotonous on category axis, and the label size
    // is close with each other. So we check the symbol size and some of the
    // label size alone with the category axis to estimate whether all symbol
    // can be shown without overlap.
    var axisExtent = categoryAxis.getExtent();
    var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
    isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
    // Sampling some points, max 5.
    var dataLen = data.count();
    var step = Math.max(1, Math.round(dataLen / 5));
    for(var dataIndex = 0; dataIndex < dataLen; dataIndex += step){
        if ($051ad5e1a7c7bd92$exports.getSymbolSize(data, dataIndex // Only for cartesian, where `isHorizontal` exists.
        )[categoryAxis.isHorizontal() ? 1 : 0] // Empirical number
         * 1.5 > availSize) return false;
    }
    return true;
}
function $92ccbedd9013fd4e$var$createLineClipPath(coordSys, hasAnimation, seriesModel) {
    if (coordSys.type === "cartesian2d") {
        var isHorizontal = coordSys.getBaseAxis().isHorizontal();
        var clipPath = $92ccbedd9013fd4e$var$createGridClipPath(coordSys, hasAnimation, seriesModel); // Expand clip shape to avoid clipping when line value exceeds axis
        if (!seriesModel.get("clip", true)) {
            var rectShape = clipPath.shape;
            var expandSize = Math.max(rectShape.width, rectShape.height);
            if (isHorizontal) {
                rectShape.y -= expandSize;
                rectShape.height += expandSize * 2;
            } else {
                rectShape.x -= expandSize;
                rectShape.width += expandSize * 2;
            }
        }
        return clipPath;
    } else return $92ccbedd9013fd4e$var$createPolarClipPath(coordSys, hasAnimation, seriesModel);
}
var $92ccbedd9013fd4e$var$_default = $6448f0aa5ca2bdaa$exports.extend({
    type: "line",
    init: function() {
        var lineGroup = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
        var symbolDraw = new $e99d13e2181fb062$exports();
        this.group.add(symbolDraw.group);
        this._symbolDraw = symbolDraw;
        this._lineGroup = lineGroup;
    },
    render: function(seriesModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var group = this.group;
        var data = seriesModel.getData();
        var lineStyleModel = seriesModel.getModel("lineStyle");
        var areaStyleModel = seriesModel.getModel("areaStyle");
        var points = data.mapArray(data.getItemLayout);
        var isCoordSysPolar = coordSys.type === "polar";
        var prevCoordSys = this._coordSys;
        var symbolDraw = this._symbolDraw;
        var polyline = this._polyline;
        var polygon = this._polygon;
        var lineGroup = this._lineGroup;
        var hasAnimation = seriesModel.get("animation");
        var isAreaChart = !areaStyleModel.isEmpty();
        var valueOrigin = areaStyleModel.get("origin");
        var dataCoordInfo = $92ccbedd9013fd4e$var$prepareDataCoordInfo(coordSys, data, valueOrigin);
        var stackedOnPoints = $92ccbedd9013fd4e$var$getStackedOnPoints(coordSys, data, dataCoordInfo);
        var showSymbol = seriesModel.get("showSymbol");
        var isIgnoreFunc = showSymbol && !isCoordSysPolar && $92ccbedd9013fd4e$var$getIsIgnoreFunc(seriesModel, data, coordSys); // Remove temporary symbols
        var oldData = this._data;
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        }); // Remove previous created symbols if showSymbol changed to false
        if (!showSymbol) symbolDraw.remove();
        group.add(lineGroup); // FIXME step not support polar
        var step = !isCoordSysPolar && seriesModel.get("step");
        var clipShapeForSymbol;
        if (coordSys && coordSys.getArea && seriesModel.get("clip", true)) {
            clipShapeForSymbol = coordSys.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
            // See #7913 and `test/dataZoom-clip.html`.
            if (clipShapeForSymbol.width != null) {
                clipShapeForSymbol.x -= 0.1;
                clipShapeForSymbol.y -= 0.1;
                clipShapeForSymbol.width += 0.2;
                clipShapeForSymbol.height += 0.2;
            } else if (clipShapeForSymbol.r0) {
                clipShapeForSymbol.r0 -= 0.5;
                clipShapeForSymbol.r1 += 0.5;
            }
        }
        this._clipShapeForSymbol = clipShapeForSymbol; // Initialization animation or coordinate system changed
        if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol
            });
            if (step) {
                // TODO If stacked series is not step
                points = $92ccbedd9013fd4e$var$turnPointsIntoStep(points, coordSys, step);
                stackedOnPoints = $92ccbedd9013fd4e$var$turnPointsIntoStep(stackedOnPoints, coordSys, step);
            }
            polyline = this._newPolyline(points, coordSys, hasAnimation);
            if (isAreaChart) polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
            lineGroup.setClipPath($92ccbedd9013fd4e$var$createLineClipPath(coordSys, true, seriesModel));
        } else {
            if (isAreaChart && !polygon) // If areaStyle is added
            polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
            else if (polygon && !isAreaChart) {
                // If areaStyle is removed
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            } // Update clipPath
            lineGroup.setClipPath($92ccbedd9013fd4e$var$createLineClipPath(coordSys, false, seriesModel)); // Always update, or it is wrong in the case turning on legend
            // because points are not changed
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol
            }); // Stop symbol animation and sync with line points
            // FIXME performance?
            data.eachItemGraphicEl(function(el) {
                el.stopAnimation(true);
            }); // In the case data zoom triggerred refreshing frequently
            // Data may not change if line has a category axis. So it should animate nothing
            if (!$92ccbedd9013fd4e$var$isPointsSame(this._stackedOnPoints, stackedOnPoints) || !$92ccbedd9013fd4e$var$isPointsSame(this._points, points)) {
                if (hasAnimation) this._updateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin);
                else {
                    // Not do it in update with animation
                    if (step) {
                        // TODO If stacked series is not step
                        points = $92ccbedd9013fd4e$var$turnPointsIntoStep(points, coordSys, step);
                        stackedOnPoints = $92ccbedd9013fd4e$var$turnPointsIntoStep(stackedOnPoints, coordSys, step);
                    }
                    polyline.setShape({
                        points: points
                    });
                    polygon && polygon.setShape({
                        points: points,
                        stackedOnPoints: stackedOnPoints
                    });
                }
            }
        }
        var visualColor = $92ccbedd9013fd4e$var$getVisualGradient(data, coordSys) || data.getVisual("color");
        polyline.useStyle($ec279652dd95c27b$export$ebe90cb607ad99e(lineStyleModel.getLineStyle(), {
            fill: "none",
            stroke: visualColor,
            lineJoin: "bevel"
        }));
        var smooth = seriesModel.get("smooth");
        smooth = $92ccbedd9013fd4e$var$getSmooth(seriesModel.get("smooth"));
        polyline.setShape({
            smooth: smooth,
            smoothMonotone: seriesModel.get("smoothMonotone"),
            connectNulls: seriesModel.get("connectNulls")
        });
        if (polygon) {
            var stackedOnSeries = data.getCalculationInfo("stackedOnSeries");
            var stackedOnSmooth = 0;
            polygon.useStyle($ec279652dd95c27b$export$ebe90cb607ad99e(areaStyleModel.getAreaStyle(), {
                fill: visualColor,
                opacity: 0.7,
                lineJoin: "bevel"
            }));
            if (stackedOnSeries) stackedOnSmooth = $92ccbedd9013fd4e$var$getSmooth(stackedOnSeries.get("smooth"));
            polygon.setShape({
                smooth: smooth,
                stackedOnSmooth: stackedOnSmooth,
                smoothMonotone: seriesModel.get("smoothMonotone"),
                connectNulls: seriesModel.get("connectNulls")
            });
        }
        this._data = data; // Save the coordinate system for transition animation when data changed
        this._coordSys = coordSys;
        this._stackedOnPoints = stackedOnPoints;
        this._points = points;
        this._step = step;
        this._valueOrigin = valueOrigin;
    },
    dispose: function() {},
    highlight: function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $d559f43cb9041423$export$42b26cae8b8d10(data, payload);
        if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
            var symbol = data.getItemGraphicEl(dataIndex);
            if (!symbol) {
                // Create a temporary symbol if it is not exists
                var pt = data.getItemLayout(dataIndex);
                if (!pt) // Null data
                return;
                 // fix #11360: should't draw symbol outside clipShapeForSymbol
                if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(pt[0], pt[1])) return;
                symbol = new $051ad5e1a7c7bd92$exports(data, dataIndex);
                symbol.position = pt;
                symbol.setZ(seriesModel.get("zlevel"), seriesModel.get("z"));
                symbol.ignore = isNaN(pt[0]) || isNaN(pt[1]);
                symbol.__temp = true;
                data.setItemGraphicEl(dataIndex, symbol); // Stop scale animation
                symbol.stopSymbolAnimation(true);
                this.group.add(symbol);
            }
            symbol.highlight();
        } else // Highlight whole series
        $6448f0aa5ca2bdaa$exports.prototype.highlight.call(this, seriesModel, ecModel, api, payload);
    },
    downplay: function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $d559f43cb9041423$export$42b26cae8b8d10(data, payload);
        if (dataIndex != null && dataIndex >= 0) {
            var symbol = data.getItemGraphicEl(dataIndex);
            if (symbol) {
                if (symbol.__temp) {
                    data.setItemGraphicEl(dataIndex, null);
                    this.group.remove(symbol);
                } else symbol.downplay();
            }
        } else // FIXME
        // can not downplay completely.
        // Downplay whole series
        $6448f0aa5ca2bdaa$exports.prototype.downplay.call(this, seriesModel, ecModel, api, payload);
    },
    /**
   * @param {module:zrender/container/Group} group
   * @param {Array.<Array.<number>>} points
   * @private
   */ _newPolyline: function(points) {
        var polyline = this._polyline; // Remove previous created polyline
        if (polyline) this._lineGroup.remove(polyline);
        polyline = new $92ccbedd9013fd4e$var$Polyline({
            shape: {
                points: points
            },
            silent: true,
            z2: 10
        });
        this._lineGroup.add(polyline);
        this._polyline = polyline;
        return polyline;
    },
    /**
   * @param {module:zrender/container/Group} group
   * @param {Array.<Array.<number>>} stackedOnPoints
   * @param {Array.<Array.<number>>} points
   * @private
   */ _newPolygon: function(points, stackedOnPoints) {
        var polygon = this._polygon; // Remove previous created polygon
        if (polygon) this._lineGroup.remove(polygon);
        polygon = new $92ccbedd9013fd4e$var$Polygon({
            shape: {
                points: points,
                stackedOnPoints: stackedOnPoints
            },
            silent: true
        });
        this._lineGroup.add(polygon);
        this._polygon = polygon;
        return polygon;
    },
    /**
   * @private
   */ // FIXME Two value axis
    _updateAnimation: function(data, stackedOnPoints, coordSys, api, step, valueOrigin) {
        var polyline = this._polyline;
        var polygon = this._polygon;
        var seriesModel = data.hostModel;
        var diff = $3b1969327efa589a$exports(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
        var current = diff.current;
        var stackedOnCurrent = diff.stackedOnCurrent;
        var next = diff.next;
        var stackedOnNext = diff.stackedOnNext;
        if (step) {
            // TODO If stacked series is not step
            current = $92ccbedd9013fd4e$var$turnPointsIntoStep(diff.current, coordSys, step);
            stackedOnCurrent = $92ccbedd9013fd4e$var$turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step);
            next = $92ccbedd9013fd4e$var$turnPointsIntoStep(diff.next, coordSys, step);
            stackedOnNext = $92ccbedd9013fd4e$var$turnPointsIntoStep(diff.stackedOnNext, coordSys, step);
        } // Don't apply animation if diff is large.
        // For better result and avoid memory explosion problems like
        // https://github.com/apache/incubator-echarts/issues/12229
        if ($92ccbedd9013fd4e$var$getBoundingDiff(current, next) > 3000 || polygon && $92ccbedd9013fd4e$var$getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
            polyline.setShape({
                points: next
            });
            if (polygon) polygon.setShape({
                points: next,
                stackedOnPoints: stackedOnNext
            });
            return;
        } // `diff.current` is subset of `current` (which should be ensured by
        // turnPointsIntoStep), so points in `__points` can be updated when
        // points in `current` are update during animation.
        polyline.shape.__points = diff.current;
        polyline.shape.points = current;
        $4b57d6b582d579b7$export$c8dce3c08436e91e(polyline, {
            shape: {
                points: next
            }
        }, seriesModel);
        if (polygon) {
            polygon.setShape({
                points: current,
                stackedOnPoints: stackedOnCurrent
            });
            $4b57d6b582d579b7$export$c8dce3c08436e91e(polygon, {
                shape: {
                    points: next,
                    stackedOnPoints: stackedOnNext
                }
            }, seriesModel);
        }
        var updatedDataInfo = [];
        var diffStatus = diff.status;
        for(var i = 0; i < diffStatus.length; i++){
            var cmd = diffStatus[i].cmd;
            if (cmd === "=") {
                var el = data.getItemGraphicEl(diffStatus[i].idx1);
                if (el) updatedDataInfo.push({
                    el: el,
                    ptIdx: i // Index of points
                });
            }
        }
        if (polyline.animators && polyline.animators.length) polyline.animators[0].during(function() {
            for(var i = 0; i < updatedDataInfo.length; i++){
                var el = updatedDataInfo[i].el;
                el.attr("position", polyline.shape.__points[updatedDataInfo[i].ptIdx]);
            }
        });
    },
    remove: function(ecModel) {
        var group = this.group;
        var oldData = this._data;
        this._lineGroup.removeAll();
        this._symbolDraw.remove(true); // Remove temporary created elements when highlighting
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._data = null;
    }
});
$92ccbedd9013fd4e$exports = $92ccbedd9013fd4e$var$_default;


var $6efa4c3507ca2b4d$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $6efa4c3507ca2b4d$var$isFunction = $ec279652dd95c27b$export$f6e2535fb5126e54;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $6efa4c3507ca2b4d$var$_default(seriesType, defaultSymbolType, legendSymbol) {
    // Encoding visual for all series include which is filtered for legend drawing
    return {
        seriesType: seriesType,
        // For legend.
        performRawSeries: true,
        reset: function(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            var symbolType = seriesModel.get("symbol");
            var symbolSize = seriesModel.get("symbolSize");
            var keepAspect = seriesModel.get("symbolKeepAspect");
            var symbolRotate = seriesModel.get("symbolRotate");
            var hasSymbolTypeCallback = $6efa4c3507ca2b4d$var$isFunction(symbolType);
            var hasSymbolSizeCallback = $6efa4c3507ca2b4d$var$isFunction(symbolSize);
            var hasSymbolRotateCallback = $6efa4c3507ca2b4d$var$isFunction(symbolRotate);
            var hasCallback = hasSymbolTypeCallback || hasSymbolSizeCallback || hasSymbolRotateCallback;
            var seriesSymbol = !hasSymbolTypeCallback && symbolType ? symbolType : defaultSymbolType;
            var seriesSymbolSize = !hasSymbolSizeCallback ? symbolSize : null;
            var seriesSymbolRotate = !hasSymbolRotateCallback ? seriesSymbolRotate : null;
            data.setVisual({
                legendSymbol: legendSymbol || seriesSymbol,
                // If seting callback functions on `symbol` or `symbolSize`, for simplicity and avoiding
                // to bring trouble, we do not pick a reuslt from one of its calling on data item here,
                // but just use the default value. Callback on `symbol` or `symbolSize` is convenient in
                // some cases but generally it is not recommanded.
                symbol: seriesSymbol,
                symbolSize: seriesSymbolSize,
                symbolKeepAspect: keepAspect,
                symbolRotate: symbolRotate
            }); // Only visible series has each data be visual encoded
            if (ecModel.isSeriesFiltered(seriesModel)) return;
            function dataEach(data, idx) {
                if (hasCallback) {
                    var rawValue = seriesModel.getRawValue(idx);
                    var params = seriesModel.getDataParams(idx);
                    hasSymbolTypeCallback && data.setItemVisual(idx, "symbol", symbolType(rawValue, params));
                    hasSymbolSizeCallback && data.setItemVisual(idx, "symbolSize", symbolSize(rawValue, params));
                    hasSymbolRotateCallback && data.setItemVisual(idx, "symbolRotate", symbolRotate(rawValue, params));
                }
                if (data.hasItemOption) {
                    var itemModel = data.getItemModel(idx);
                    var itemSymbolType = itemModel.getShallow("symbol", true);
                    var itemSymbolSize = itemModel.getShallow("symbolSize", true);
                    var itemSymbolRotate = itemModel.getShallow("symbolRotate", true);
                    var itemSymbolKeepAspect = itemModel.getShallow("symbolKeepAspect", true); // If has item symbol
                    if (itemSymbolType != null) data.setItemVisual(idx, "symbol", itemSymbolType);
                    if (itemSymbolSize != null) // PENDING Transform symbolSize ?
                    data.setItemVisual(idx, "symbolSize", itemSymbolSize);
                    if (itemSymbolRotate != null) data.setItemVisual(idx, "symbolRotate", itemSymbolRotate);
                    if (itemSymbolKeepAspect != null) data.setItemVisual(idx, "symbolKeepAspect", itemSymbolKeepAspect);
                }
            }
            return {
                dataEach: data.hasItemOption || hasCallback ? dataEach : null
            };
        }
    };
}
$6efa4c3507ca2b4d$exports = $6efa4c3507ca2b4d$var$_default;


var $c76a359a25b70ceb$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $c76a359a25b70ceb$var$map = $ec279652dd95c27b$export$871de8747c9eaa88;


var $c76a359a25b70ceb$var$isDimensionStacked = $1712a5e8fbedbcb3$export$1dedc39359ae35c;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Float32Array */ function $c76a359a25b70ceb$var$_default(seriesType) {
    return {
        seriesType: seriesType,
        plan: $a77c5f604e87a748$exports(),
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            var coordSys = seriesModel.coordinateSystem;
            var pipelineContext = seriesModel.pipelineContext;
            var isLargeRender = pipelineContext.large;
            if (!coordSys) return;
            var dims = $c76a359a25b70ceb$var$map(coordSys.dimensions, function(dim) {
                return data.mapDimension(dim);
            }).slice(0, 2);
            var dimLen = dims.length;
            var stackResultDim = data.getCalculationInfo("stackResultDimension");
            if ($c76a359a25b70ceb$var$isDimensionStacked(data, dims[0])) dims[0] = stackResultDim;
            if ($c76a359a25b70ceb$var$isDimensionStacked(data, dims[1])) dims[1] = stackResultDim;
            function progress(params, data) {
                var segCount = params.end - params.start;
                var points = isLargeRender && new Float32Array(segCount * dimLen);
                for(var i = params.start, offset = 0, tmpIn = [], tmpOut = []; i < params.end; i++){
                    var point;
                    if (dimLen === 1) {
                        var x = data.get(dims[0], i);
                        point = !isNaN(x) && coordSys.dataToPoint(x, null, tmpOut);
                    } else {
                        var x = tmpIn[0] = data.get(dims[0], i);
                        var y = tmpIn[1] = data.get(dims[1], i); // Also {Array.<number>}, not undefined to avoid if...else... statement
                        point = !isNaN(x) && !isNaN(y) && coordSys.dataToPoint(tmpIn, null, tmpOut);
                    }
                    if (isLargeRender) {
                        points[offset++] = point ? point[0] : NaN;
                        points[offset++] = point ? point[1] : NaN;
                    } else data.setItemLayout(i, point && point.slice() || [
                        NaN,
                        NaN
                    ]);
                }
                isLargeRender && data.setLayout("symbolPoints", points);
            }
            return dimLen && {
                progress: progress
            };
        }
    };
}
$c76a359a25b70ceb$exports = $c76a359a25b70ceb$var$_default;


var $051a1cec4ea723be$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $051a1cec4ea723be$var$samplers = {
    average: function(frame) {
        var sum = 0;
        var count = 0;
        for(var i = 0; i < frame.length; i++)if (!isNaN(frame[i])) {
            sum += frame[i];
            count++;
        }
         // Return NaN if count is 0
        return count === 0 ? NaN : sum / count;
    },
    sum: function(frame) {
        var sum = 0;
        for(var i = 0; i < frame.length; i++)// Ignore NaN
        sum += frame[i] || 0;
        return sum;
    },
    max: function(frame) {
        var max = -Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] > max && (max = frame[i]);
         // NaN will cause illegal axis extent.
        return isFinite(max) ? max : NaN;
    },
    min: function(frame) {
        var min = Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] < min && (min = frame[i]);
         // NaN will cause illegal axis extent.
        return isFinite(min) ? min : NaN;
    },
    // TODO
    // Median
    nearest: function(frame) {
        return frame[0];
    }
};
var $051a1cec4ea723be$var$indexSampler = function(frame, value) {
    return Math.round(frame.length / 2);
};
function $051a1cec4ea723be$var$_default(seriesType) {
    return {
        seriesType: seriesType,
        modifyOutputEnd: true,
        reset: function(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            var sampling = seriesModel.get("sampling");
            var coordSys = seriesModel.coordinateSystem; // Only cartesian2d support down sampling
            if (coordSys.type === "cartesian2d" && sampling) {
                var baseAxis = coordSys.getBaseAxis();
                var valueAxis = coordSys.getOtherAxis(baseAxis);
                var extent = baseAxis.getExtent(); // Coordinste system has been resized
                var size = Math.abs(extent[1] - extent[0]);
                var rate = Math.round(data.count() / size);
                if (rate > 1) {
                    var sampler;
                    if (typeof sampling === "string") sampler = $051a1cec4ea723be$var$samplers[sampling];
                    else if (typeof sampling === "function") sampler = sampling;
                    if (sampler) // Only support sample the first dim mapped from value axis.
                    seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, $051a1cec4ea723be$var$indexSampler));
                }
            }
        }
    };
}
$051a1cec4ea723be$exports = $051a1cec4ea723be$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $8a5f98f965d72329$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $8a5f98f965d72329$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;

var $8a5f98f965d72329$var$isObject = $ec279652dd95c27b$export$a6cdc56e425d0d0a;
var $8a5f98f965d72329$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $8a5f98f965d72329$var$map = $ec279652dd95c27b$export$871de8747c9eaa88;
var $8a5f98f965d72329$var$indexOf = $ec279652dd95c27b$export$305f7d4e9d4624f2;
var $8a5f98f965d72329$var$retrieve = $ec279652dd95c27b$export$8a4d17b6e8486e66;

var $8a5f98f965d72329$var$getLayoutRect = $ab0c9086dd6c5b39$export$4517a5ca639a7293;

var $8a5f98f965d72329$var$createScaleByModel = $13542623aa20eeae$export$8941c4cacdc8f5a5;
var $8a5f98f965d72329$var$ifAxisCrossZero = $13542623aa20eeae$export$3eac36a69f37d52;
var $8a5f98f965d72329$var$niceScaleExtent = $13542623aa20eeae$export$51f3e70a54405d5a;
var $8a5f98f965d72329$var$estimateLabelUnionRect = $13542623aa20eeae$export$fef1c7f0af0b48d;
var $1d0a24c9bfccbdef$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $ad3c84a981ded14c$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Cartesian coordinate system
 * @module  echarts/coord/Cartesian
 *
 */ function $ad3c84a981ded14c$var$dimAxisMapper(dim) {
    return this._axes[dim];
}
/**
 * @alias module:echarts/coord/Cartesian
 * @constructor
 */ var $ad3c84a981ded14c$var$Cartesian = function(name) {
    this._axes = {};
    this._dimList = [];
    /**
   * @type {string}
   */ this.name = name || "";
};
$ad3c84a981ded14c$var$Cartesian.prototype = {
    constructor: $ad3c84a981ded14c$var$Cartesian,
    type: "cartesian",
    /**
   * Get axis
   * @param  {number|string} dim
   * @return {module:echarts/coord/Cartesian~Axis}
   */ getAxis: function(dim) {
        return this._axes[dim];
    },
    /**
   * Get axes list
   * @return {Array.<module:echarts/coord/Cartesian~Axis>}
   */ getAxes: function() {
        return $ec279652dd95c27b$export$871de8747c9eaa88(this._dimList, $ad3c84a981ded14c$var$dimAxisMapper, this);
    },
    /**
   * Get axes list by given scale type
   */ getAxesByScale: function(scaleType) {
        scaleType = scaleType.toLowerCase();
        return $ec279652dd95c27b$export$3dea766d36a8935f(this.getAxes(), function(axis) {
            return axis.scale.type === scaleType;
        });
    },
    /**
   * Add axis
   * @param {module:echarts/coord/Cartesian.Axis}
   */ addAxis: function(axis) {
        var dim = axis.dim;
        this._axes[dim] = axis;
        this._dimList.push(dim);
    },
    /**
   * Convert data to coord in nd space
   * @param {Array.<number>|Object.<string, number>} val
   * @return {Array.<number>|Object.<string, number>}
   */ dataToCoord: function(val) {
        return this._dataCoordConvert(val, "dataToCoord");
    },
    /**
   * Convert coord in nd space to data
   * @param  {Array.<number>|Object.<string, number>} val
   * @return {Array.<number>|Object.<string, number>}
   */ coordToData: function(val) {
        return this._dataCoordConvert(val, "coordToData");
    },
    _dataCoordConvert: function(input, method) {
        var dimList = this._dimList;
        var output = input instanceof Array ? [] : {};
        for(var i = 0; i < dimList.length; i++){
            var dim = dimList[i];
            var axis = this._axes[dim];
            output[dim] = axis[method](input[dim]);
        }
        return output;
    }
};
var $ad3c84a981ded14c$var$_default = $ad3c84a981ded14c$var$Cartesian;
$ad3c84a981ded14c$exports = $ad3c84a981ded14c$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $1d0a24c9bfccbdef$var$Cartesian2D(name) {
    $ad3c84a981ded14c$exports.call(this, name);
}
$1d0a24c9bfccbdef$var$Cartesian2D.prototype = {
    constructor: $1d0a24c9bfccbdef$var$Cartesian2D,
    type: "cartesian2d",
    /**
   * @type {Array.<string>}
   * @readOnly
   */ dimensions: [
        "x",
        "y"
    ],
    /**
   * Base axis will be used on stacking.
   *
   * @return {module:echarts/coord/cartesian/Axis2D}
   */ getBaseAxis: function() {
        return this.getAxesByScale("ordinal")[0] || this.getAxesByScale("time")[0] || this.getAxis("x");
    },
    /**
   * If contain point
   * @param {Array.<number>} point
   * @return {boolean}
   */ containPoint: function(point) {
        var axisX = this.getAxis("x");
        var axisY = this.getAxis("y");
        return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
    },
    /**
   * If contain data
   * @param {Array.<number>} data
   * @return {boolean}
   */ containData: function(data) {
        return this.getAxis("x").containData(data[0]) && this.getAxis("y").containData(data[1]);
    },
    /**
   * @param {Array.<number>} data
   * @param {Array.<number>} out
   * @return {Array.<number>}
   */ dataToPoint: function(data, reserved, out) {
        var xAxis = this.getAxis("x");
        var yAxis = this.getAxis("y");
        out = out || [];
        out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(data[0]));
        out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(data[1]));
        return out;
    },
    /**
   * @param {Array.<number>} data
   * @param {Array.<number>} out
   * @return {Array.<number>}
   */ clampData: function(data, out) {
        var xScale = this.getAxis("x").scale;
        var yScale = this.getAxis("y").scale;
        var xAxisExtent = xScale.getExtent();
        var yAxisExtent = yScale.getExtent();
        var x = xScale.parse(data[0]);
        var y = yScale.parse(data[1]);
        out = out || [];
        out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
        out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
        return out;
    },
    /**
   * @param {Array.<number>} point
   * @param {Array.<number>} out
   * @return {Array.<number>}
   */ pointToData: function(point, out) {
        var xAxis = this.getAxis("x");
        var yAxis = this.getAxis("y");
        out = out || [];
        out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]));
        out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]));
        return out;
    },
    /**
   * Get other axis
   * @param {module:echarts/coord/cartesian/Axis2D} axis
   */ getOtherAxis: function(axis) {
        return this.getAxis(axis.dim === "x" ? "y" : "x");
    },
    /**
   * Get rect area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   * @return {BoundingRect}
   */ getArea: function() {
        var xExtent = this.getAxis("x").getGlobalExtent();
        var yExtent = this.getAxis("y").getGlobalExtent();
        var x = Math.min(xExtent[0], xExtent[1]);
        var y = Math.min(yExtent[0], yExtent[1]);
        var width = Math.max(xExtent[0], xExtent[1]) - x;
        var height = Math.max(yExtent[0], yExtent[1]) - y;
        var rect = new $33e4fae744d34798$exports(x, y, width, height);
        return rect;
    }
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($1d0a24c9bfccbdef$var$Cartesian2D, $ad3c84a981ded14c$exports);
var $1d0a24c9bfccbdef$var$_default = $1d0a24c9bfccbdef$var$Cartesian2D;
$1d0a24c9bfccbdef$exports = $1d0a24c9bfccbdef$var$_default;


var $7fc89aa5912f9d18$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Extend axis 2d
 * @constructor module:echarts/coord/cartesian/Axis2D
 * @extends {module:echarts/coord/cartesian/Axis}
 * @param {string} dim
 * @param {*} scale
 * @param {Array.<number>} coordExtent
 * @param {string} axisType
 * @param {string} position
 */ var $7fc89aa5912f9d18$var$Axis2D = function(dim, scale, coordExtent, axisType, position) {
    $95e1f94acccc578d$exports.call(this, dim, scale, coordExtent);
    /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */ this.type = axisType || "value";
    /**
   * Axis position
   *  - 'top'
   *  - 'bottom'
   *  - 'left'
   *  - 'right'
   */ this.position = position || "bottom";
};
$7fc89aa5912f9d18$var$Axis2D.prototype = {
    constructor: $7fc89aa5912f9d18$var$Axis2D,
    /**
   * Index of axis, can be used as key
   */ index: 0,
    /**
   * Implemented in <module:echarts/coord/cartesian/Grid>.
   * @return {Array.<module:echarts/coord/cartesian/Axis2D>}
   *         If not on zero of other axis, return null/undefined.
   *         If no axes, return an empty array.
   */ getAxesOnZeroOf: null,
    /**
   * Axis model
   * @param {module:echarts/coord/cartesian/AxisModel}
   */ model: null,
    isHorizontal: function() {
        var position = this.position;
        return position === "top" || position === "bottom";
    },
    /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */ getGlobalExtent: function(asc) {
        var ret = this.getExtent();
        ret[0] = this.toGlobalCoord(ret[0]);
        ret[1] = this.toGlobalCoord(ret[1]);
        asc && ret[0] > ret[1] && ret.reverse();
        return ret;
    },
    getOtherAxis: function() {
        this.grid.getOtherAxis();
    },
    /**
   * @override
   */ pointToData: function(point, clamp) {
        return this.coordToData(this.toLocalCoord(point[this.dim === "x" ? 0 : 1]), clamp);
    },
    /**
   * Transform global coord to local coord,
   * i.e. var localCoord = axis.toLocalCoord(80);
   * designate by module:echarts/coord/cartesian/Grid.
   * @type {Function}
   */ toLocalCoord: null,
    /**
   * Transform global coord to local coord,
   * i.e. var globalCoord = axis.toLocalCoord(40);
   * designate by module:echarts/coord/cartesian/Grid.
   * @type {Function}
   */ toGlobalCoord: null
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($7fc89aa5912f9d18$var$Axis2D, $95e1f94acccc578d$exports);
var $7fc89aa5912f9d18$var$_default = $7fc89aa5912f9d18$var$Axis2D;
$7fc89aa5912f9d18$exports = $7fc89aa5912f9d18$var$_default;




var $8a5f98f965d72329$var$getStackedDimension = $1712a5e8fbedbcb3$export$909db2be4938fbdf;
var $215690f4030ac5aa$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $f9a3e0b5cd15ffc8$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $b94fd69108c44724$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $42af304458b85594$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $42af304458b85594$var$defaultOption = {
    show: true,
    zlevel: 0,
    z: 0,
    // Inverse the axis.
    inverse: false,
    // Axis name displayed.
    name: "",
    // 'start' | 'middle' | 'end'
    nameLocation: "end",
    // By degree. By default auto rotate by nameLocation.
    nameRotate: null,
    nameTruncate: {
        maxWidth: null,
        ellipsis: "...",
        placeholder: "."
    },
    // Use global text style by default.
    nameTextStyle: {},
    // The gap between axisName and axisLine.
    nameGap: 15,
    // Default `false` to support tooltip.
    silent: false,
    // Default `false` to avoid legacy user event listener fail.
    triggerEvent: false,
    tooltip: {
        show: false
    },
    axisPointer: {},
    axisLine: {
        show: true,
        onZero: true,
        onZeroAxisIndex: null,
        lineStyle: {
            color: "#333",
            width: 1,
            type: "solid"
        },
        // The arrow at both ends the the axis.
        symbol: [
            "none",
            "none"
        ],
        symbolSize: [
            10,
            15
        ]
    },
    axisTick: {
        show: true,
        // Whether axisTick is inside the grid or outside the grid.
        inside: false,
        // The length of axisTick.
        length: 5,
        lineStyle: {
            width: 1
        }
    },
    axisLabel: {
        show: true,
        // Whether axisLabel is inside the grid or outside the grid.
        inside: false,
        rotate: 0,
        // true | false | null/undefined (auto)
        showMinLabel: null,
        // true | false | null/undefined (auto)
        showMaxLabel: null,
        margin: 8,
        // formatter: null,
        fontSize: 12
    },
    splitLine: {
        show: true,
        lineStyle: {
            color: [
                "#ccc"
            ],
            width: 1,
            type: "solid"
        }
    },
    splitArea: {
        show: false,
        areaStyle: {
            color: [
                "rgba(250,250,250,0.3)",
                "rgba(200,200,200,0.3)"
            ]
        }
    }
};
var $42af304458b85594$var$axisDefault = {};
$42af304458b85594$var$axisDefault.categoryAxis = $ec279652dd95c27b$export$4950aa0f605343fb({
    // The gap at both ends of the axis. For categoryAxis, boolean.
    boundaryGap: true,
    // Set false to faster category collection.
    // Only usefull in the case like: category is
    // ['2012-01-01', '2012-01-02', ...], where the input
    // data has been ensured not duplicate and is large data.
    // null means "auto":
    // if axis.data provided, do not deduplication,
    // else do deduplication.
    deduplication: null,
    // splitArea: {
    // show: false
    // },
    splitLine: {
        show: false
    },
    axisTick: {
        // If tick is align with label when boundaryGap is true
        alignWithLabel: false,
        interval: "auto"
    },
    axisLabel: {
        interval: "auto"
    }
}, $42af304458b85594$var$defaultOption);
$42af304458b85594$var$axisDefault.valueAxis = $ec279652dd95c27b$export$4950aa0f605343fb({
    // The gap at both ends of the axis. For value axis, [GAP, GAP], where
    // `GAP` can be an absolute pixel number (like `35`), or percent (like `'30%'`)
    boundaryGap: [
        0,
        0
    ],
    // TODO
    // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
    // Min value of the axis. can be:
    // + a number
    // + 'dataMin': use the min value in data.
    // + null/undefined: auto decide min value (consider pretty look and boundaryGap).
    // min: null,
    // Max value of the axis. can be:
    // + a number
    // + 'dataMax': use the max value in data.
    // + null/undefined: auto decide max value (consider pretty look and boundaryGap).
    // max: null,
    // Readonly prop, specifies start value of the range when using data zoom.
    // rangeStart: null
    // Readonly prop, specifies end value of the range when using data zoom.
    // rangeEnd: null
    // Optional value can be:
    // + `false`: always include value 0.
    // + `true`: the extent do not consider value 0.
    // scale: false,
    // AxisTick and axisLabel and splitLine are caculated based on splitNumber.
    splitNumber: 5,
    // Interval specifies the span of the ticks is mandatorily.
    // interval: null
    // Specify min interval when auto calculate tick interval.
    // minInterval: null
    // Specify max interval when auto calculate tick interval.
    // maxInterval: null
    minorTick: {
        // Minor tick, not available for cateogry axis.
        show: false,
        // Split number of minor ticks. The value should be in range of (0, 100)
        splitNumber: 5,
        // Lenght of minor tick
        length: 3,
        // Same inside with axisTick
        // Line style
        lineStyle: {}
    },
    minorSplitLine: {
        show: false,
        lineStyle: {
            color: "#eee",
            width: 1
        }
    }
}, $42af304458b85594$var$defaultOption);
$42af304458b85594$var$axisDefault.timeAxis = $ec279652dd95c27b$export$ebe90cb607ad99e({
    scale: true,
    min: "dataMin",
    max: "dataMax"
}, $42af304458b85594$var$axisDefault.valueAxis);
$42af304458b85594$var$axisDefault.logAxis = $ec279652dd95c27b$export$ebe90cb607ad99e({
    scale: true,
    logBase: 10
}, $42af304458b85594$var$axisDefault.valueAxis);
var $42af304458b85594$var$_default = $42af304458b85594$var$axisDefault;
$42af304458b85594$exports = $42af304458b85594$var$_default;




var $b94fd69108c44724$var$getLayoutParams = $ab0c9086dd6c5b39$export$4b0d20af19c9875e;
var $b94fd69108c44724$var$mergeLayoutParam = $ab0c9086dd6c5b39$export$1754cb91f16ca028;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME axisType is fixed ?
var $b94fd69108c44724$var$AXIS_TYPES = [
    "value",
    "category",
    "time",
    "log"
];
/**
 * Generate sub axis model class
 * @param {string} axisName 'x' 'y' 'radius' 'angle' 'parallel'
 * @param {module:echarts/model/Component} BaseAxisModelClass
 * @param {Function} axisTypeDefaulter
 * @param {Object} [extraDefaultOption]
 */ function $b94fd69108c44724$var$_default(axisName, BaseAxisModelClass, axisTypeDefaulter, extraDefaultOption) {
    $ec279652dd95c27b$export$79b2f7037acddd43($b94fd69108c44724$var$AXIS_TYPES, function(axisType) {
        BaseAxisModelClass.extend({
            /**
       * @readOnly
       */ type: axisName + "Axis." + axisType,
            mergeDefaultAndTheme: function(option, ecModel) {
                var layoutMode = this.layoutMode;
                var inputPositionParams = layoutMode ? $b94fd69108c44724$var$getLayoutParams(option) : {};
                var themeModel = ecModel.getTheme();
                $ec279652dd95c27b$export$4950aa0f605343fb(option, themeModel.get(axisType + "Axis"));
                $ec279652dd95c27b$export$4950aa0f605343fb(option, this.getDefaultOption());
                option.type = axisTypeDefaulter(axisName, option);
                if (layoutMode) $b94fd69108c44724$var$mergeLayoutParam(option, inputPositionParams, layoutMode);
            },
            /**
       * @override
       */ optionUpdated: function() {
                var thisOption = this.option;
                if (thisOption.type === "category") this.__ordinalMeta = $7439ece03b1889e3$exports.createByAxisModel(this);
            },
            /**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */ getCategories: function(rawData) {
                var option = this.option; // FIXME
                // warning if called before all of 'getInitailData' finished.
                if (option.type === "category") {
                    if (rawData) return option.data;
                    return this.__ordinalMeta.categories;
                }
            },
            getOrdinalMeta: function() {
                return this.__ordinalMeta;
            },
            defaultOption: $ec279652dd95c27b$export$18aef43295bbe906([
                {},
                $42af304458b85594$exports[axisType + "Axis"],
                extraDefaultOption
            ], true)
        });
    });
    $3b9c2389e45dfb7d$exports.registerSubTypeDefaulter(axisName + "Axis", $ec279652dd95c27b$export$c3095a23b368d1f2(axisTypeDefaulter, axisName));
}
$b94fd69108c44724$exports = $b94fd69108c44724$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $f9a3e0b5cd15ffc8$var$AxisModel = $3b9c2389e45dfb7d$exports.extend({
    type: "cartesian2dAxis",
    /**
   * @type {module:echarts/coord/cartesian/Axis2D}
   */ axis: null,
    /**
   * @override
   */ init: function() {
        $f9a3e0b5cd15ffc8$var$AxisModel.superApply(this, "init", arguments);
        this.resetRange();
    },
    /**
   * @override
   */ mergeOption: function() {
        $f9a3e0b5cd15ffc8$var$AxisModel.superApply(this, "mergeOption", arguments);
        this.resetRange();
    },
    /**
   * @override
   */ restoreData: function() {
        $f9a3e0b5cd15ffc8$var$AxisModel.superApply(this, "restoreData", arguments);
        this.resetRange();
    },
    /**
   * @override
   * @return {module:echarts/model/Component}
   */ getCoordSysModel: function() {
        return this.ecModel.queryComponents({
            mainType: "grid",
            index: this.option.gridIndex,
            id: this.option.gridId
        })[0];
    }
});
function $f9a3e0b5cd15ffc8$var$getAxisType(axisDim, option) {
    // Default axis with data is category axis
    return option.type || (option.data ? "category" : "value");
}
$ec279652dd95c27b$export$4950aa0f605343fb($f9a3e0b5cd15ffc8$var$AxisModel.prototype, $ce1d0648e3723c9f$exports);
var $f9a3e0b5cd15ffc8$var$extraOption = {
    // gridIndex: 0,
    // gridId: '',
    // Offset is for multiple axis on the same position
    offset: 0
};
$b94fd69108c44724$exports("x", $f9a3e0b5cd15ffc8$var$AxisModel, $f9a3e0b5cd15ffc8$var$getAxisType, $f9a3e0b5cd15ffc8$var$extraOption);
$b94fd69108c44724$exports("y", $f9a3e0b5cd15ffc8$var$AxisModel, $f9a3e0b5cd15ffc8$var$getAxisType, $f9a3e0b5cd15ffc8$var$extraOption);
var $f9a3e0b5cd15ffc8$var$_default = $f9a3e0b5cd15ffc8$var$AxisModel;
$f9a3e0b5cd15ffc8$exports = $f9a3e0b5cd15ffc8$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Grid 是在有直角坐标系的时候必须要存在的
// 所以这里也要被 Cartesian2D 依赖
var $215690f4030ac5aa$var$_default = $3b9c2389e45dfb7d$exports.extend({
    type: "grid",
    dependencies: [
        "xAxis",
        "yAxis"
    ],
    layoutMode: "box",
    /**
   * @type {module:echarts/coord/cartesian/Grid}
   */ coordinateSystem: null,
    defaultOption: {
        show: false,
        zlevel: 0,
        z: 0,
        left: "10%",
        top: 60,
        right: "10%",
        bottom: 60,
        // If grid size contain label
        containLabel: false,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        backgroundColor: "rgba(0,0,0,0)",
        borderWidth: 1,
        borderColor: "#ccc"
    }
});
$215690f4030ac5aa$exports = $215690f4030ac5aa$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */ // Depends on GridModel, AxisModel, which performs preprocess.
/**
 * Check if the axis is used in the specified grid
 * @inner
 */ function $8a5f98f965d72329$var$isAxisUsedInTheGrid(axisModel, gridModel, ecModel) {
    return axisModel.getCoordSysModel() === gridModel;
}
function $8a5f98f965d72329$var$Grid(gridModel, ecModel, api) {
    /**
   * @type {Object.<string, module:echarts/coord/cartesian/Cartesian2D>}
   * @private
   */ this._coordsMap = {};
    /**
   * @type {Array.<module:echarts/coord/cartesian/Cartesian>}
   * @private
   */ this._coordsList = [];
    /**
   * @type {Object.<string, Array.<module:echarts/coord/cartesian/Axis2D>>}
   * @private
   */ this._axesMap = {};
    /**
   * @type {Array.<module:echarts/coord/cartesian/Axis2D>}
   * @private
   */ this._axesList = [];
    this._initCartesian(gridModel, ecModel, api);
    this.model = gridModel;
}
var $8a5f98f965d72329$var$gridProto = $8a5f98f965d72329$var$Grid.prototype;
$8a5f98f965d72329$var$gridProto.type = "grid";
$8a5f98f965d72329$var$gridProto.axisPointerEnabled = true;
$8a5f98f965d72329$var$gridProto.getRect = function() {
    return this._rect;
};
$8a5f98f965d72329$var$gridProto.update = function(ecModel, api) {
    var axesMap = this._axesMap;
    this._updateScale(ecModel, this.model);
    $8a5f98f965d72329$var$each(axesMap.x, function(xAxis) {
        $8a5f98f965d72329$var$niceScaleExtent(xAxis.scale, xAxis.model);
    });
    $8a5f98f965d72329$var$each(axesMap.y, function(yAxis) {
        $8a5f98f965d72329$var$niceScaleExtent(yAxis.scale, yAxis.model);
    }); // Key: axisDim_axisIndex, value: boolean, whether onZero target.
    var onZeroRecords = {};
    $8a5f98f965d72329$var$each(axesMap.x, function(xAxis) {
        $8a5f98f965d72329$var$fixAxisOnZero(axesMap, "y", xAxis, onZeroRecords);
    });
    $8a5f98f965d72329$var$each(axesMap.y, function(yAxis) {
        $8a5f98f965d72329$var$fixAxisOnZero(axesMap, "x", yAxis, onZeroRecords);
    }); // Resize again if containLabel is enabled
    // FIXME It may cause getting wrong grid size in data processing stage
    this.resize(this.model, api);
};
function $8a5f98f965d72329$var$fixAxisOnZero(axesMap, otherAxisDim, axis, onZeroRecords) {
    axis.getAxesOnZeroOf = function() {
        // TODO: onZero of multiple axes.
        return otherAxisOnZeroOf ? [
            otherAxisOnZeroOf
        ] : [];
    }; // onZero can not be enabled in these two situations:
    // 1. When any other axis is a category axis.
    // 2. When no axis is cross 0 point.
    var otherAxes = axesMap[otherAxisDim];
    var otherAxisOnZeroOf;
    var axisModel = axis.model;
    var onZero = axisModel.get("axisLine.onZero");
    var onZeroAxisIndex = axisModel.get("axisLine.onZeroAxisIndex");
    if (!onZero) return;
     // If target axis is specified.
    if (onZeroAxisIndex != null) {
        if ($8a5f98f965d72329$var$canOnZeroToAxis(otherAxes[onZeroAxisIndex])) otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
    } else {
        // Find the first available other axis.
        for(var idx in otherAxes)if (otherAxes.hasOwnProperty(idx) && $8a5f98f965d72329$var$canOnZeroToAxis(otherAxes[idx]) // Consider that two Y axes on one value axis,
         && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
            otherAxisOnZeroOf = otherAxes[idx];
            break;
        }
    }
    if (otherAxisOnZeroOf) onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
    function getOnZeroRecordKey(axis) {
        return axis.dim + "_" + axis.index;
    }
}
function $8a5f98f965d72329$var$canOnZeroToAxis(axis) {
    return axis && axis.type !== "category" && axis.type !== "time" && $8a5f98f965d72329$var$ifAxisCrossZero(axis);
}
/**
 * Resize the grid
 * @param {module:echarts/coord/cartesian/GridModel} gridModel
 * @param {module:echarts/ExtensionAPI} api
 */ $8a5f98f965d72329$var$gridProto.resize = function(gridModel, api, ignoreContainLabel) {
    var gridRect = $8a5f98f965d72329$var$getLayoutRect(gridModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
    this._rect = gridRect;
    var axesList = this._axesList;
    adjustAxes(); // Minus label size
    if (!ignoreContainLabel && gridModel.get("containLabel")) {
        $8a5f98f965d72329$var$each(axesList, function(axis) {
            if (!axis.model.get("axisLabel.inside")) {
                var labelUnionRect = $8a5f98f965d72329$var$estimateLabelUnionRect(axis);
                if (labelUnionRect) {
                    var dim = axis.isHorizontal() ? "height" : "width";
                    var margin = axis.model.get("axisLabel.margin");
                    gridRect[dim] -= labelUnionRect[dim] + margin;
                    if (axis.position === "top") gridRect.y += labelUnionRect.height + margin;
                    else if (axis.position === "left") gridRect.x += labelUnionRect.width + margin;
                }
            }
        });
        adjustAxes();
    }
    function adjustAxes() {
        $8a5f98f965d72329$var$each(axesList, function(axis) {
            var isHorizontal = axis.isHorizontal();
            var extent = isHorizontal ? [
                0,
                gridRect.width
            ] : [
                0,
                gridRect.height
            ];
            var idx = axis.inverse ? 1 : 0;
            axis.setExtent(extent[idx], extent[1 - idx]);
            $8a5f98f965d72329$var$updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
        });
    }
};
/**
 * @param {string} axisType
 * @param {number} [axisIndex]
 */ $8a5f98f965d72329$var$gridProto.getAxis = function(axisType, axisIndex) {
    var axesMapOnDim = this._axesMap[axisType];
    if (axesMapOnDim != null) {
        if (axisIndex == null) // Find first axis
        for(var name in axesMapOnDim){
            if (axesMapOnDim.hasOwnProperty(name)) return axesMapOnDim[name];
        }
        return axesMapOnDim[axisIndex];
    }
};
/**
 * @return {Array.<module:echarts/coord/Axis>}
 */ $8a5f98f965d72329$var$gridProto.getAxes = function() {
    return this._axesList.slice();
};
/**
 * Usage:
 *      grid.getCartesian(xAxisIndex, yAxisIndex);
 *      grid.getCartesian(xAxisIndex);
 *      grid.getCartesian(null, yAxisIndex);
 *      grid.getCartesian({xAxisIndex: ..., yAxisIndex: ...});
 *
 * @param {number|Object} [xAxisIndex]
 * @param {number} [yAxisIndex]
 */ $8a5f98f965d72329$var$gridProto.getCartesian = function(xAxisIndex, yAxisIndex) {
    if (xAxisIndex != null && yAxisIndex != null) {
        var key = "x" + xAxisIndex + "y" + yAxisIndex;
        return this._coordsMap[key];
    }
    if ($8a5f98f965d72329$var$isObject(xAxisIndex)) {
        yAxisIndex = xAxisIndex.yAxisIndex;
        xAxisIndex = xAxisIndex.xAxisIndex;
    } // When only xAxisIndex or yAxisIndex given, find its first cartesian.
    for(var i = 0, coordList = this._coordsList; i < coordList.length; i++){
        if (coordList[i].getAxis("x").index === xAxisIndex || coordList[i].getAxis("y").index === yAxisIndex) return coordList[i];
    }
};
$8a5f98f965d72329$var$gridProto.getCartesians = function() {
    return this._coordsList.slice();
};
/**
 * @implements
 * see {module:echarts/CoodinateSystem}
 */ $8a5f98f965d72329$var$gridProto.convertToPixel = function(ecModel, finder, value) {
    var target = this._findConvertTarget(ecModel, finder);
    return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
};
/**
 * @implements
 * see {module:echarts/CoodinateSystem}
 */ $8a5f98f965d72329$var$gridProto.convertFromPixel = function(ecModel, finder, value) {
    var target = this._findConvertTarget(ecModel, finder);
    return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
};
/**
 * @inner
 */ $8a5f98f965d72329$var$gridProto._findConvertTarget = function(ecModel, finder) {
    var seriesModel = finder.seriesModel;
    var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents("xAxis")[0];
    var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents("yAxis")[0];
    var gridModel = finder.gridModel;
    var coordsList = this._coordsList;
    var cartesian;
    var axis;
    if (seriesModel) {
        cartesian = seriesModel.coordinateSystem;
        $8a5f98f965d72329$var$indexOf(coordsList, cartesian) < 0 && (cartesian = null);
    } else if (xAxisModel && yAxisModel) cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
    else if (xAxisModel) axis = this.getAxis("x", xAxisModel.componentIndex);
    else if (yAxisModel) axis = this.getAxis("y", yAxisModel.componentIndex);
    else if (gridModel) {
        var grid = gridModel.coordinateSystem;
        if (grid === this) cartesian = this._coordsList[0];
    }
    return {
        cartesian: cartesian,
        axis: axis
    };
};
/**
 * @implements
 * see {module:echarts/CoodinateSystem}
 */ $8a5f98f965d72329$var$gridProto.containPoint = function(point) {
    var coord = this._coordsList[0];
    if (coord) return coord.containPoint(point);
};
/**
 * Initialize cartesian coordinate systems
 * @private
 */ $8a5f98f965d72329$var$gridProto._initCartesian = function(gridModel, ecModel, api) {
    var axisPositionUsed = {
        left: false,
        right: false,
        top: false,
        bottom: false
    };
    var axesMap = {
        x: {},
        y: {}
    };
    var axesCount = {
        x: 0,
        y: 0
    }; /// Create axis
    ecModel.eachComponent("xAxis", createAxisCreator("x"), this);
    ecModel.eachComponent("yAxis", createAxisCreator("y"), this);
    if (!axesCount.x || !axesCount.y) {
        // Roll back when there no either x or y axis
        this._axesMap = {};
        this._axesList = [];
        return;
    }
    this._axesMap = axesMap; /// Create cartesian2d
    $8a5f98f965d72329$var$each(axesMap.x, function(xAxis, xAxisIndex) {
        $8a5f98f965d72329$var$each(axesMap.y, function(yAxis, yAxisIndex) {
            var key = "x" + xAxisIndex + "y" + yAxisIndex;
            var cartesian = new $1d0a24c9bfccbdef$exports(key);
            cartesian.grid = this;
            cartesian.model = gridModel;
            this._coordsMap[key] = cartesian;
            this._coordsList.push(cartesian);
            cartesian.addAxis(xAxis);
            cartesian.addAxis(yAxis);
        }, this);
    }, this);
    function createAxisCreator(axisType) {
        return function(axisModel, idx) {
            if (!$8a5f98f965d72329$var$isAxisUsedInTheGrid(axisModel, gridModel, ecModel)) return;
            var axisPosition = axisModel.get("position");
            if (axisType === "x") // Fix position
            {
                if (axisPosition !== "top" && axisPosition !== "bottom") // Default bottom of X
                axisPosition = axisPositionUsed.bottom ? "top" : "bottom";
            } else // Fix position
            if (axisPosition !== "left" && axisPosition !== "right") // Default left of Y
            axisPosition = axisPositionUsed.left ? "right" : "left";
            axisPositionUsed[axisPosition] = true;
            var axis = new $7fc89aa5912f9d18$exports(axisType, $8a5f98f965d72329$var$createScaleByModel(axisModel), [
                0,
                0
            ], axisModel.get("type"), axisPosition);
            var isCategory = axis.type === "category";
            axis.onBand = isCategory && axisModel.get("boundaryGap");
            axis.inverse = axisModel.get("inverse"); // Inject axis into axisModel
            axisModel.axis = axis; // Inject axisModel into axis
            axis.model = axisModel; // Inject grid info axis
            axis.grid = this; // Index of axis, can be used as key
            axis.index = idx;
            this._axesList.push(axis);
            axesMap[axisType][idx] = axis;
            axesCount[axisType]++;
        };
    }
};
/**
 * Update cartesian properties from series
 * @param  {module:echarts/model/Option} option
 * @private
 */ $8a5f98f965d72329$var$gridProto._updateScale = function(ecModel, gridModel) {
    // Reset scale
    $8a5f98f965d72329$var$each(this._axesList, function(axis) {
        axis.scale.setExtent(Infinity, -Infinity);
    });
    ecModel.eachSeries(function(seriesModel) {
        if ($8a5f98f965d72329$var$isCartesian2D(seriesModel)) {
            var axesModels = $8a5f98f965d72329$var$findAxesModels(seriesModel, ecModel);
            var xAxisModel = axesModels[0];
            var yAxisModel = axesModels[1];
            if (!$8a5f98f965d72329$var$isAxisUsedInTheGrid(xAxisModel, gridModel, ecModel) || !$8a5f98f965d72329$var$isAxisUsedInTheGrid(yAxisModel, gridModel, ecModel)) return;
            var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
            var data = seriesModel.getData();
            var xAxis = cartesian.getAxis("x");
            var yAxis = cartesian.getAxis("y");
            if (data.type === "list") {
                unionExtent(data, xAxis, seriesModel);
                unionExtent(data, yAxis, seriesModel);
            }
        }
    }, this);
    function unionExtent(data, axis, seriesModel) {
        $8a5f98f965d72329$var$each(data.mapDimension(axis.dim, true), function(dim) {
            axis.scale.unionExtentFromData(// is [0.1, 0.5], the extent of the `stackResultDimension`
            // is [7, 9], the final extent should not include [0.1, 0.5].
            data, $8a5f98f965d72329$var$getStackedDimension(data, dim));
        });
    }
};
/**
 * @param {string} [dim] 'x' or 'y' or 'auto' or null/undefined
 * @return {Object} {baseAxes: [], otherAxes: []}
 */ $8a5f98f965d72329$var$gridProto.getTooltipAxes = function(dim) {
    var baseAxes = [];
    var otherAxes = [];
    $8a5f98f965d72329$var$each(this.getCartesians(), function(cartesian) {
        var baseAxis = dim != null && dim !== "auto" ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
        var otherAxis = cartesian.getOtherAxis(baseAxis);
        $8a5f98f965d72329$var$indexOf(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
        $8a5f98f965d72329$var$indexOf(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
    });
    return {
        baseAxes: baseAxes,
        otherAxes: otherAxes
    };
};
/**
 * @inner
 */ function $8a5f98f965d72329$var$updateAxisTransform(axis, coordBase) {
    var axisExtent = axis.getExtent();
    var axisExtentSum = axisExtent[0] + axisExtent[1]; // Fast transform
    axis.toGlobalCoord = axis.dim === "x" ? function(coord) {
        return coord + coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
    axis.toLocalCoord = axis.dim === "x" ? function(coord) {
        return coord - coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
}
var $8a5f98f965d72329$var$axesTypes = [
    "xAxis",
    "yAxis"
];
/**
 * @inner
 */ function $8a5f98f965d72329$var$findAxesModels(seriesModel, ecModel) {
    return $8a5f98f965d72329$var$map($8a5f98f965d72329$var$axesTypes, function(axisType) {
        var axisModel = seriesModel.getReferringComponents(axisType)[0];
        return axisModel;
    });
}
/**
 * @inner
 */ function $8a5f98f965d72329$var$isCartesian2D(seriesModel) {
    return seriesModel.get("coordinateSystem") === "cartesian2d";
}
$8a5f98f965d72329$var$Grid.create = function(ecModel, api) {
    var grids = [];
    ecModel.eachComponent("grid", function(gridModel, idx) {
        var grid = new $8a5f98f965d72329$var$Grid(gridModel, ecModel, api);
        grid.name = "grid_" + idx; // dataSampling requires axis extent, so resize
        // should be performed in create stage.
        grid.resize(gridModel, api, true);
        gridModel.coordinateSystem = grid;
        grids.push(grid);
    }); // Inject the coordinateSystems into seriesModel
    ecModel.eachSeries(function(seriesModel) {
        if (!$8a5f98f965d72329$var$isCartesian2D(seriesModel)) return;
        var axesModels = $8a5f98f965d72329$var$findAxesModels(seriesModel, ecModel);
        var xAxisModel = axesModels[0];
        var yAxisModel = axesModels[1];
        var gridModel = xAxisModel.getCoordSysModel();
        var grid = gridModel.coordinateSystem;
        seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
    });
    return grids;
}; // For deciding which dimensions to use when creating list data
$8a5f98f965d72329$var$Grid.dimensions = $8a5f98f965d72329$var$Grid.prototype.dimensions = $1d0a24c9bfccbdef$exports.prototype.dimensions;
$9c36d0fff3b0f387$exports.register("cartesian2d", $8a5f98f965d72329$var$Grid);
var $8a5f98f965d72329$var$_default = $8a5f98f965d72329$var$Grid;
$8a5f98f965d72329$exports = $8a5f98f965d72329$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $3ce77a4133d2c8eb$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3ce77a4133d2c8eb$var$retrieve = $ec279652dd95c27b$export$8a4d17b6e8486e66;
var $3ce77a4133d2c8eb$var$defaults = $ec279652dd95c27b$export$ebe90cb607ad99e;
var $3ce77a4133d2c8eb$var$extend = $ec279652dd95c27b$export$8b58be045bf06082;
var $3ce77a4133d2c8eb$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;




var $3ce77a4133d2c8eb$var$isRadianAroundZero = $2d742dbe7f960d8c$export$d1df570aea2868f;
var $3ce77a4133d2c8eb$var$remRadian = $2d742dbe7f960d8c$export$2ca6dd70a288b1c3;

var $3ce77a4133d2c8eb$var$createSymbol = $804dcb9a0b78b5fe$export$af050e04da3a02e8;


var $3ce77a4133d2c8eb$var$v2ApplyTransform = $9eb63d101f3bcd79$export$9f9dcb98c894b623;

var $3ce77a4133d2c8eb$var$shouldShowAllLabels = $13542623aa20eeae$export$c2911c025243d6a6;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $3ce77a4133d2c8eb$var$PI = Math.PI;
/**
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
 * for example: (0, 0) ------------> (0, 50)
 *
 * nameDirection or tickDirection or labelDirection is 1 means tick
 * or label is below the standard axis, whereas is -1 means above
 * the standard axis. labelOffset means offset between label and axis,
 * which is useful when 'onZero', where axisLabel is in the grid and
 * label in outside grid.
 *
 * Tips: like always,
 * positive rotation represents anticlockwise, and negative rotation
 * represents clockwise.
 * The direction of position coordinate is the same as the direction
 * of screen coordinate.
 *
 * Do not need to consider axis 'inverse', which is auto processed by
 * axis extent.
 *
 * @param {module:zrender/container/Group} group
 * @param {Object} axisModel
 * @param {Object} opt Standard axis parameters.
 * @param {Array.<number>} opt.position [x, y]
 * @param {number} opt.rotation by radian
 * @param {number} [opt.nameDirection=1] 1 or -1 Used when nameLocation is 'middle' or 'center'.
 * @param {number} [opt.tickDirection=1] 1 or -1
 * @param {number} [opt.labelDirection=1] 1 or -1
 * @param {number} [opt.labelOffset=0] Usefull when onZero.
 * @param {string} [opt.axisLabelShow] default get from axisModel.
 * @param {string} [opt.axisName] default get from axisModel.
 * @param {number} [opt.axisNameAvailableWidth]
 * @param {number} [opt.labelRotate] by degree, default get from axisModel.
 * @param {number} [opt.strokeContainThreshold] Default label interval when label
 * @param {number} [opt.nameTruncateMaxWidth]
 */ var $3ce77a4133d2c8eb$var$AxisBuilder = function(axisModel, opt) {
    /**
   * @readOnly
   */ this.opt = opt;
    /**
   * @readOnly
   */ this.axisModel = axisModel; // Default value
    $3ce77a4133d2c8eb$var$defaults(opt, {
        labelOffset: 0,
        nameDirection: 1,
        tickDirection: 1,
        labelDirection: 1,
        silent: true
    });
    /**
   * @readOnly
   */ this.group = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4(); // FIXME Not use a seperate text group?
    var dumbGroup = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4({
        position: opt.position.slice(),
        rotation: opt.rotation
    }); // this.group.add(dumbGroup);
    // this._dumbGroup = dumbGroup;
    dumbGroup.updateTransform();
    this._transform = dumbGroup.transform;
    this._dumbGroup = dumbGroup;
};
$3ce77a4133d2c8eb$var$AxisBuilder.prototype = {
    constructor: $3ce77a4133d2c8eb$var$AxisBuilder,
    hasBuilder: function(name) {
        return !!$3ce77a4133d2c8eb$var$builders[name];
    },
    add: function(name) {
        $3ce77a4133d2c8eb$var$builders[name].call(this);
    },
    getGroup: function() {
        return this.group;
    }
};
var $3ce77a4133d2c8eb$var$builders = {
    /**
   * @private
   */ axisLine: function() {
        var opt = this.opt;
        var axisModel = this.axisModel;
        if (!axisModel.get("axisLine.show")) return;
        var extent = this.axisModel.axis.getExtent();
        var matrix = this._transform;
        var pt1 = [
            extent[0],
            0
        ];
        var pt2 = [
            extent[1],
            0
        ];
        if (matrix) {
            $3ce77a4133d2c8eb$var$v2ApplyTransform(pt1, pt1, matrix);
            $3ce77a4133d2c8eb$var$v2ApplyTransform(pt2, pt2, matrix);
        }
        var lineStyle = $3ce77a4133d2c8eb$var$extend({
            lineCap: "round"
        }, axisModel.getModel("axisLine.lineStyle").getLineStyle());
        this.group.add(new $4b57d6b582d579b7$export$17d680238e50603e({
            // Id for animation
            anid: "line",
            subPixelOptimize: true,
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: lineStyle,
            strokeContainThreshold: opt.strokeContainThreshold || 5,
            silent: true,
            z2: 1
        }));
        var arrows = axisModel.get("axisLine.symbol");
        var arrowSize = axisModel.get("axisLine.symbolSize");
        var arrowOffset = axisModel.get("axisLine.symbolOffset") || 0;
        if (typeof arrowOffset === "number") arrowOffset = [
            arrowOffset,
            arrowOffset
        ];
        if (arrows != null) {
            if (typeof arrows === "string") // Use the same arrow for start and end point
            arrows = [
                arrows,
                arrows
            ];
            if (typeof arrowSize === "string" || typeof arrowSize === "number") // Use the same size for width and height
            arrowSize = [
                arrowSize,
                arrowSize
            ];
            var symbolWidth = arrowSize[0];
            var symbolHeight = arrowSize[1];
            $3ce77a4133d2c8eb$var$each([
                {
                    rotate: opt.rotation + Math.PI / 2,
                    offset: arrowOffset[0],
                    r: 0
                },
                {
                    rotate: opt.rotation - Math.PI / 2,
                    offset: arrowOffset[1],
                    r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
                }
            ], function(point, index) {
                if (arrows[index] !== "none" && arrows[index] != null) {
                    var symbol = $3ce77a4133d2c8eb$var$createSymbol(arrows[index], -symbolWidth / 2, -symbolHeight / 2, symbolWidth, symbolHeight, lineStyle.stroke, true); // Calculate arrow position with offset
                    var r = point.r + point.offset;
                    var pos = [
                        pt1[0] + r * Math.cos(opt.rotation),
                        pt1[1] - r * Math.sin(opt.rotation)
                    ];
                    symbol.attr({
                        rotation: point.rotate,
                        position: pos,
                        silent: true,
                        z2: 11
                    });
                    this.group.add(symbol);
                }
            }, this);
        }
    },
    /**
   * @private
   */ axisTickLabel: function() {
        var axisModel = this.axisModel;
        var opt = this.opt;
        var ticksEls = $3ce77a4133d2c8eb$var$buildAxisMajorTicks(this, axisModel, opt);
        var labelEls = $3ce77a4133d2c8eb$var$buildAxisLabel(this, axisModel, opt);
        $3ce77a4133d2c8eb$var$fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
        $3ce77a4133d2c8eb$var$buildAxisMinorTicks(this, axisModel, opt);
    },
    /**
   * @private
   */ axisName: function() {
        var opt = this.opt;
        var axisModel = this.axisModel;
        var name = $3ce77a4133d2c8eb$var$retrieve(opt.axisName, axisModel.get("name"));
        if (!name) return;
        var nameLocation = axisModel.get("nameLocation");
        var nameDirection = opt.nameDirection;
        var textStyleModel = axisModel.getModel("nameTextStyle");
        var gap = axisModel.get("nameGap") || 0;
        var extent = this.axisModel.axis.getExtent();
        var gapSignal = extent[0] > extent[1] ? -1 : 1;
        var pos = [
            nameLocation === "start" ? extent[0] - gapSignal * gap : nameLocation === "end" ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2,
            // Reuse labelOffset.
            $3ce77a4133d2c8eb$var$isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0
        ];
        var labelLayout;
        var nameRotation = axisModel.get("nameRotate");
        if (nameRotation != null) nameRotation = nameRotation * $3ce77a4133d2c8eb$var$PI / 180; // To radian.
        var axisNameAvailableWidth;
        if ($3ce77a4133d2c8eb$var$isNameLocationCenter(nameLocation)) labelLayout = $3ce77a4133d2c8eb$var$innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, nameDirection);
        else {
            labelLayout = $3ce77a4133d2c8eb$var$endTextLayout(opt, nameLocation, nameRotation || 0, extent);
            axisNameAvailableWidth = opt.axisNameAvailableWidth;
            if (axisNameAvailableWidth != null) {
                axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
                !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
            }
        }
        var textFont = textStyleModel.getFont();
        var truncateOpt = axisModel.get("nameTruncate", true) || {};
        var ellipsis = truncateOpt.ellipsis;
        var maxWidth = $3ce77a4133d2c8eb$var$retrieve(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth); // FIXME
        // truncate rich text? (consider performance)
        var truncatedText = ellipsis != null && maxWidth != null ? $a4be9366aeb9fcc8$export$59a943b34a82e690(name, maxWidth, textFont, ellipsis, {
            minChar: 2,
            placeholder: truncateOpt.placeholder
        }) : name;
        var tooltipOpt = axisModel.get("tooltip", true);
        var mainType = axisModel.mainType;
        var formatterParams = {
            componentType: mainType,
            name: name,
            $vars: [
                "name"
            ]
        };
        formatterParams[mainType + "Index"] = axisModel.componentIndex;
        var textEl = new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
            // Id for animation
            anid: "name",
            __fullText: name,
            __truncatedText: truncatedText,
            position: pos,
            rotation: labelLayout.rotation,
            silent: $3ce77a4133d2c8eb$var$isLabelSilent(axisModel),
            z2: 1,
            tooltip: tooltipOpt && tooltipOpt.show ? $3ce77a4133d2c8eb$var$extend({
                content: name,
                formatter: function() {
                    return name;
                },
                formatterParams: formatterParams
            }, tooltipOpt) : null
        });
        $4b57d6b582d579b7$export$6605af501964d89a(textEl.style, textStyleModel, {
            text: truncatedText,
            textFont: textFont,
            textFill: textStyleModel.getTextColor() || axisModel.get("axisLine.lineStyle.color"),
            textAlign: textStyleModel.get("align") || labelLayout.textAlign,
            textVerticalAlign: textStyleModel.get("verticalAlign") || labelLayout.textVerticalAlign
        });
        if (axisModel.get("triggerEvent")) {
            textEl.eventData = $3ce77a4133d2c8eb$var$makeAxisEventDataBase(axisModel);
            textEl.eventData.targetType = "axisName";
            textEl.eventData.name = name;
        } // FIXME
        this._dumbGroup.add(textEl);
        textEl.updateTransform();
        this.group.add(textEl);
        textEl.decomposeTransform();
    }
};
var $3ce77a4133d2c8eb$var$makeAxisEventDataBase = $3ce77a4133d2c8eb$var$AxisBuilder.makeAxisEventDataBase = function(axisModel) {
    var eventData = {
        componentType: axisModel.mainType,
        componentIndex: axisModel.componentIndex
    };
    eventData[axisModel.mainType + "Index"] = axisModel.componentIndex;
    return eventData;
};
/**
 * @public
 * @static
 * @param {Object} opt
 * @param {number} axisRotation in radian
 * @param {number} textRotation in radian
 * @param {number} direction
 * @return {Object} {
 *  rotation, // according to axis
 *  textAlign,
 *  textVerticalAlign
 * }
 */ var $3ce77a4133d2c8eb$var$innerTextLayout = $3ce77a4133d2c8eb$var$AxisBuilder.innerTextLayout = function(axisRotation, textRotation, direction) {
    var rotationDiff = $3ce77a4133d2c8eb$var$remRadian(textRotation - axisRotation);
    var textAlign;
    var textVerticalAlign;
    if ($3ce77a4133d2c8eb$var$isRadianAroundZero(rotationDiff)) {
        // Label is parallel with axis line.
        textVerticalAlign = direction > 0 ? "top" : "bottom";
        textAlign = "center";
    } else if ($3ce77a4133d2c8eb$var$isRadianAroundZero(rotationDiff - $3ce77a4133d2c8eb$var$PI)) {
        // Label is inverse parallel with axis line.
        textVerticalAlign = direction > 0 ? "bottom" : "top";
        textAlign = "center";
    } else {
        textVerticalAlign = "middle";
        if (rotationDiff > 0 && rotationDiff < $3ce77a4133d2c8eb$var$PI) textAlign = direction > 0 ? "right" : "left";
        else textAlign = direction > 0 ? "left" : "right";
    }
    return {
        rotation: rotationDiff,
        textAlign: textAlign,
        textVerticalAlign: textVerticalAlign
    };
};
function $3ce77a4133d2c8eb$var$endTextLayout(opt, textPosition, textRotate, extent) {
    var rotationDiff = $3ce77a4133d2c8eb$var$remRadian(textRotate - opt.rotation);
    var textAlign;
    var textVerticalAlign;
    var inverse = extent[0] > extent[1];
    var onLeft = textPosition === "start" && !inverse || textPosition !== "start" && inverse;
    if ($3ce77a4133d2c8eb$var$isRadianAroundZero(rotationDiff - $3ce77a4133d2c8eb$var$PI / 2)) {
        textVerticalAlign = onLeft ? "bottom" : "top";
        textAlign = "center";
    } else if ($3ce77a4133d2c8eb$var$isRadianAroundZero(rotationDiff - $3ce77a4133d2c8eb$var$PI * 1.5)) {
        textVerticalAlign = onLeft ? "top" : "bottom";
        textAlign = "center";
    } else {
        textVerticalAlign = "middle";
        if (rotationDiff < $3ce77a4133d2c8eb$var$PI * 1.5 && rotationDiff > $3ce77a4133d2c8eb$var$PI / 2) textAlign = onLeft ? "left" : "right";
        else textAlign = onLeft ? "right" : "left";
    }
    return {
        rotation: rotationDiff,
        textAlign: textAlign,
        textVerticalAlign: textVerticalAlign
    };
}
var $3ce77a4133d2c8eb$var$isLabelSilent = $3ce77a4133d2c8eb$var$AxisBuilder.isLabelSilent = function(axisModel) {
    var tooltipOpt = axisModel.get("tooltip");
    return axisModel.get("silent") // Consider mouse cursor, add these restrictions.
     || !(axisModel.get("triggerEvent") || tooltipOpt && tooltipOpt.show);
};
function $3ce77a4133d2c8eb$var$fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
    if ($3ce77a4133d2c8eb$var$shouldShowAllLabels(axisModel.axis)) return;
     // If min or max are user set, we need to check
    // If the tick on min(max) are overlap on their neighbour tick
    // If they are overlapped, we need to hide the min(max) tick label
    var showMinLabel = axisModel.get("axisLabel.showMinLabel");
    var showMaxLabel = axisModel.get("axisLabel.showMaxLabel"); // FIXME
    // Have not consider onBand yet, where tick els is more than label els.
    labelEls = labelEls || [];
    tickEls = tickEls || [];
    var firstLabel = labelEls[0];
    var nextLabel = labelEls[1];
    var lastLabel = labelEls[labelEls.length - 1];
    var prevLabel = labelEls[labelEls.length - 2];
    var firstTick = tickEls[0];
    var nextTick = tickEls[1];
    var lastTick = tickEls[tickEls.length - 1];
    var prevTick = tickEls[tickEls.length - 2];
    if (showMinLabel === false) {
        $3ce77a4133d2c8eb$var$ignoreEl(firstLabel);
        $3ce77a4133d2c8eb$var$ignoreEl(firstTick);
    } else if ($3ce77a4133d2c8eb$var$isTwoLabelOverlapped(firstLabel, nextLabel)) {
        if (showMinLabel) {
            $3ce77a4133d2c8eb$var$ignoreEl(nextLabel);
            $3ce77a4133d2c8eb$var$ignoreEl(nextTick);
        } else {
            $3ce77a4133d2c8eb$var$ignoreEl(firstLabel);
            $3ce77a4133d2c8eb$var$ignoreEl(firstTick);
        }
    }
    if (showMaxLabel === false) {
        $3ce77a4133d2c8eb$var$ignoreEl(lastLabel);
        $3ce77a4133d2c8eb$var$ignoreEl(lastTick);
    } else if ($3ce77a4133d2c8eb$var$isTwoLabelOverlapped(prevLabel, lastLabel)) {
        if (showMaxLabel) {
            $3ce77a4133d2c8eb$var$ignoreEl(prevLabel);
            $3ce77a4133d2c8eb$var$ignoreEl(prevTick);
        } else {
            $3ce77a4133d2c8eb$var$ignoreEl(lastLabel);
            $3ce77a4133d2c8eb$var$ignoreEl(lastTick);
        }
    }
}
function $3ce77a4133d2c8eb$var$ignoreEl(el) {
    el && (el.ignore = true);
}
function $3ce77a4133d2c8eb$var$isTwoLabelOverlapped(current, next, labelLayout) {
    // current and next has the same rotation.
    var firstRect = current && current.getBoundingRect().clone();
    var nextRect = next && next.getBoundingRect().clone();
    if (!firstRect || !nextRect) return;
     // When checking intersect of two rotated labels, we use mRotationBack
    // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.
    var mRotationBack = $6c6dd9610ba660f0$export$f0954fd7d5368655([]);
    $6c6dd9610ba660f0$export$bb628a54ab399bc9(mRotationBack, mRotationBack, -current.rotation);
    firstRect.applyTransform($6c6dd9610ba660f0$export$6e3a27864ab166fe([], mRotationBack, current.getLocalTransform()));
    nextRect.applyTransform($6c6dd9610ba660f0$export$6e3a27864ab166fe([], mRotationBack, next.getLocalTransform()));
    return firstRect.intersect(nextRect);
}
function $3ce77a4133d2c8eb$var$isNameLocationCenter(nameLocation) {
    return nameLocation === "middle" || nameLocation === "center";
}
function $3ce77a4133d2c8eb$var$createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, aniid) {
    var tickEls = [];
    var pt1 = [];
    var pt2 = [];
    for(var i = 0; i < ticksCoords.length; i++){
        var tickCoord = ticksCoords[i].coord;
        pt1[0] = tickCoord;
        pt1[1] = 0;
        pt2[0] = tickCoord;
        pt2[1] = tickEndCoord;
        if (tickTransform) {
            $3ce77a4133d2c8eb$var$v2ApplyTransform(pt1, pt1, tickTransform);
            $3ce77a4133d2c8eb$var$v2ApplyTransform(pt2, pt2, tickTransform);
        } // Tick line, Not use group transform to have better line draw
        var tickEl = new $4b57d6b582d579b7$export$17d680238e50603e({
            // Id for animation
            anid: aniid + "_" + ticksCoords[i].tickValue,
            subPixelOptimize: true,
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: tickLineStyle,
            z2: 2,
            silent: true
        });
        tickEls.push(tickEl);
    }
    return tickEls;
}
function $3ce77a4133d2c8eb$var$buildAxisMajorTicks(axisBuilder, axisModel, opt) {
    var axis = axisModel.axis;
    var tickModel = axisModel.getModel("axisTick");
    if (!tickModel.get("show") || axis.scale.isBlank()) return;
    var lineStyleModel = tickModel.getModel("lineStyle");
    var tickEndCoord = opt.tickDirection * tickModel.get("length");
    var ticksCoords = axis.getTicksCoords();
    var ticksEls = $3ce77a4133d2c8eb$var$createTicks(ticksCoords, axisBuilder._transform, tickEndCoord, $3ce77a4133d2c8eb$var$defaults(lineStyleModel.getLineStyle(), {
        stroke: axisModel.get("axisLine.lineStyle.color")
    }), "ticks");
    for(var i = 0; i < ticksEls.length; i++)axisBuilder.group.add(ticksEls[i]);
    return ticksEls;
}
function $3ce77a4133d2c8eb$var$buildAxisMinorTicks(axisBuilder, axisModel, opt) {
    var axis = axisModel.axis;
    var minorTickModel = axisModel.getModel("minorTick");
    if (!minorTickModel.get("show") || axis.scale.isBlank()) return;
    var minorTicksCoords = axis.getMinorTicksCoords();
    if (!minorTicksCoords.length) return;
    var lineStyleModel = minorTickModel.getModel("lineStyle");
    var tickEndCoord = opt.tickDirection * minorTickModel.get("length");
    var minorTickLineStyle = $3ce77a4133d2c8eb$var$defaults(lineStyleModel.getLineStyle(), $3ce77a4133d2c8eb$var$defaults(axisModel.getModel("axisTick").getLineStyle(), {
        stroke: axisModel.get("axisLine.lineStyle.color")
    }));
    for(var i = 0; i < minorTicksCoords.length; i++){
        var minorTicksEls = $3ce77a4133d2c8eb$var$createTicks(minorTicksCoords[i], axisBuilder._transform, tickEndCoord, minorTickLineStyle, "minorticks_" + i);
        for(var k = 0; k < minorTicksEls.length; k++)axisBuilder.group.add(minorTicksEls[k]);
    }
}
function $3ce77a4133d2c8eb$var$buildAxisLabel(axisBuilder, axisModel, opt) {
    var axis = axisModel.axis;
    var show = $3ce77a4133d2c8eb$var$retrieve(opt.axisLabelShow, axisModel.get("axisLabel.show"));
    if (!show || axis.scale.isBlank()) return;
    var labelModel = axisModel.getModel("axisLabel");
    var labelMargin = labelModel.get("margin");
    var labels = axis.getViewLabels(); // Special label rotate.
    var labelRotation = ($3ce77a4133d2c8eb$var$retrieve(opt.labelRotate, labelModel.get("rotate")) || 0) * $3ce77a4133d2c8eb$var$PI / 180;
    var labelLayout = $3ce77a4133d2c8eb$var$innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
    var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
    var labelEls = [];
    var silent = $3ce77a4133d2c8eb$var$isLabelSilent(axisModel);
    var triggerEvent = axisModel.get("triggerEvent");
    $3ce77a4133d2c8eb$var$each(labels, function(labelItem, index) {
        var tickValue = labelItem.tickValue;
        var formattedLabel = labelItem.formattedLabel;
        var rawLabel = labelItem.rawLabel;
        var itemLabelModel = labelModel;
        if (rawCategoryData && rawCategoryData[tickValue] && rawCategoryData[tickValue].textStyle) itemLabelModel = new $2b51b4bf776ec22e$exports(rawCategoryData[tickValue].textStyle, labelModel, axisModel.ecModel);
        var textColor = itemLabelModel.getTextColor() || axisModel.get("axisLine.lineStyle.color");
        var tickCoord = axis.dataToCoord(tickValue);
        var pos = [
            tickCoord,
            opt.labelOffset + opt.labelDirection * labelMargin
        ];
        var textEl = new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
            // Id for animation
            anid: "label_" + tickValue,
            position: pos,
            rotation: labelLayout.rotation,
            silent: silent,
            z2: 10
        });
        $4b57d6b582d579b7$export$6605af501964d89a(textEl.style, itemLabelModel, {
            text: formattedLabel,
            textAlign: itemLabelModel.getShallow("align", true) || labelLayout.textAlign,
            textVerticalAlign: itemLabelModel.getShallow("verticalAlign", true) || itemLabelModel.getShallow("baseline", true) || labelLayout.textVerticalAlign,
            textFill: typeof textColor === "function" ? textColor(// index of axis.data. So tick should not be exposed to user
            // in category axis.
            // (2) Compatible with previous version, which always use formatted label as
            // input. But in interval scale the formatted label is like '223,445', which
            // maked user repalce ','. So we modify it to return original val but remain
            // it as 'string' to avoid error in replacing.
            axis.type === "category" ? rawLabel : axis.type === "value" ? tickValue + "" : tickValue, index) : textColor
        }); // Pack data for mouse event
        if (triggerEvent) {
            textEl.eventData = $3ce77a4133d2c8eb$var$makeAxisEventDataBase(axisModel);
            textEl.eventData.targetType = "axisLabel";
            textEl.eventData.value = rawLabel;
        } // FIXME
        axisBuilder._dumbGroup.add(textEl);
        textEl.updateTransform();
        labelEls.push(textEl);
        axisBuilder.group.add(textEl);
        textEl.decomposeTransform();
    });
    return labelEls;
}
var $3ce77a4133d2c8eb$var$_default = $3ce77a4133d2c8eb$var$AxisBuilder;
$3ce77a4133d2c8eb$exports = $3ce77a4133d2c8eb$var$_default;


var $0880bad8284a1b39$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $0880bad8284a1b39$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $16df2470cde098b3$export$bb44f104e3c54dae;
var $16df2470cde098b3$export$f5ea32e3629d8043;
var $16df2470cde098b3$export$bd39458db76002ab;
var $16df2470cde098b3$export$3b06fce3f68b734;
var $16df2470cde098b3$export$d01b444bafb1a792;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $16df2470cde098b3$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $16df2470cde098b3$var$curry = $ec279652dd95c27b$export$c3095a23b368d1f2; // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
// allAxesInfo should be updated when setOption performed.
function $16df2470cde098b3$var$collect(ecModel, api) {
    var result = {
        /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */ axesInfo: {},
        seriesInvolved: false,
        /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */ coordSysAxesInfo: {},
        coordSysMap: {}
    };
    $16df2470cde098b3$var$collectAxesInfo(result, ecModel, api); // Check seriesInvolved for performance, in case too many series in some chart.
    result.seriesInvolved && $16df2470cde098b3$var$collectSeriesInfo(result, ecModel);
    return result;
}
function $16df2470cde098b3$var$collectAxesInfo(result, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent("tooltip");
    var globalAxisPointerModel = ecModel.getComponent("axisPointer"); // links can only be set on global.
    var linksOption = globalAxisPointerModel.get("link", true) || [];
    var linkGroups = []; // Collect axes info.
    $16df2470cde098b3$var$each(api.getCoordinateSystems(), function(coordSys) {
        // Some coordinate system do not support axes, like geo.
        if (!coordSys.axisPointerEnabled) return;
        var coordSysKey = $16df2470cde098b3$var$makeKey(coordSys.model);
        var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
        result.coordSysMap[coordSysKey] = coordSys; // Set tooltip (like 'cross') is a convienent way to show axisPointer
        // for user. So we enable seting tooltip on coordSys model.
        var coordSysModel = coordSys.model;
        var baseTooltipModel = coordSysModel.getModel("tooltip", globalTooltipModel);
        $16df2470cde098b3$var$each(coordSys.getAxes(), $16df2470cde098b3$var$curry(saveTooltipAxisInfo, false, null)); // If axis tooltip used, choose tooltip axis for each coordSys.
        // Notice this case: coordSys is `grid` but not `cartesian2D` here.
        if (coordSys.getTooltipAxes && globalTooltipModel // If tooltip.showContent is set as false, tooltip will not
         && baseTooltipModel.get("show")) {
            // Compatible with previous logic. But series.tooltip.trigger: 'axis'
            // or series.data[n].tooltip.trigger: 'axis' are not support any more.
            var triggerAxis = baseTooltipModel.get("trigger") === "axis";
            var cross = baseTooltipModel.get("axisPointer.type") === "cross";
            var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get("axisPointer.axis"));
            if (triggerAxis || cross) $16df2470cde098b3$var$each(tooltipAxes.baseAxes, $16df2470cde098b3$var$curry(saveTooltipAxisInfo, cross ? "cross" : true, triggerAxis));
            if (cross) $16df2470cde098b3$var$each(tooltipAxes.otherAxes, $16df2470cde098b3$var$curry(saveTooltipAxisInfo, "cross", false));
        } // fromTooltip: true | false | 'cross'
        // triggerTooltip: true | false | null
        function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
            var axisPointerModel = axis.model.getModel("axisPointer", globalAxisPointerModel);
            var axisPointerShow = axisPointerModel.get("show");
            if (!axisPointerShow || axisPointerShow === "auto" && !fromTooltip && !$16df2470cde098b3$var$isHandleTrigger(axisPointerModel)) return;
            if (triggerTooltip == null) triggerTooltip = axisPointerModel.get("triggerTooltip");
            axisPointerModel = fromTooltip ? $16df2470cde098b3$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
            var snap = axisPointerModel.get("snap");
            var key = $16df2470cde098b3$var$makeKey(axis.model);
            var involveSeries = triggerTooltip || snap || axis.type === "category"; // If result.axesInfo[key] exist, override it (tooltip has higher priority).
            var axisInfo = result.axesInfo[key] = {
                key: key,
                axis: axis,
                coordSys: coordSys,
                axisPointerModel: axisPointerModel,
                triggerTooltip: triggerTooltip,
                involveSeries: involveSeries,
                snap: snap,
                useHandle: $16df2470cde098b3$var$isHandleTrigger(axisPointerModel),
                seriesModels: []
            };
            axesInfoInCoordSys[key] = axisInfo;
            result.seriesInvolved |= involveSeries;
            var groupIndex = $16df2470cde098b3$var$getLinkGroupIndex(linksOption, axis);
            if (groupIndex != null) {
                var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
                    axesInfo: {}
                });
                linkGroup.axesInfo[key] = axisInfo;
                linkGroup.mapper = linksOption[groupIndex].mapper;
                axisInfo.linkGroup = linkGroup;
            }
        }
    });
}
function $16df2470cde098b3$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
    var tooltipAxisPointerModel = baseTooltipModel.getModel("axisPointer");
    var volatileOption = {};
    $16df2470cde098b3$var$each([
        "type",
        "snap",
        "lineStyle",
        "shadowStyle",
        "label",
        "animation",
        "animationDurationUpdate",
        "animationEasingUpdate",
        "z"
    ], function(field) {
        volatileOption[field] = $ec279652dd95c27b$export$9cd59f9826255e47(tooltipAxisPointerModel.get(field));
    }); // category axis do not auto snap, otherwise some tick that do not
    // has value can not be hovered. value/time/log axis default snap if
    // triggered from tooltip and trigger tooltip.
    volatileOption.snap = axis.type !== "category" && !!triggerTooltip; // Compatibel with previous behavior, tooltip axis do not show label by default.
    // Only these properties can be overrided from tooltip to axisPointer.
    if (tooltipAxisPointerModel.get("type") === "cross") volatileOption.type = "line";
    var labelOption = volatileOption.label || (volatileOption.label = {}); // Follow the convention, do not show label when triggered by tooltip by default.
    labelOption.show == null && (labelOption.show = false);
    if (fromTooltip === "cross") {
        // When 'cross', both axes show labels.
        var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get("label.show");
        labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true; // If triggerTooltip, this is a base axis, which should better not use cross style
        // (cross style is dashed by default)
        if (!triggerTooltip) {
            var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get("crossStyle");
            crossStyle && $ec279652dd95c27b$export$ebe90cb607ad99e(labelOption, crossStyle.textStyle);
        }
    }
    return axis.model.getModel("axisPointer", new $2b51b4bf776ec22e$exports(volatileOption, globalAxisPointerModel, ecModel));
}
function $16df2470cde098b3$var$collectSeriesInfo(result, ecModel) {
    // Prepare data for axis trigger
    ecModel.eachSeries(function(seriesModel) {
        // Notice this case: this coordSys is `cartesian2D` but not `grid`.
        var coordSys = seriesModel.coordinateSystem;
        var seriesTooltipTrigger = seriesModel.get("tooltip.trigger", true);
        var seriesTooltipShow = seriesModel.get("tooltip.show", true);
        if (!coordSys || seriesTooltipTrigger === "none" || seriesTooltipTrigger === false || seriesTooltipTrigger === "item" || seriesTooltipShow === false || seriesModel.get("axisPointer.show", true) === false) return;
        $16df2470cde098b3$var$each(result.coordSysAxesInfo[$16df2470cde098b3$var$makeKey(coordSys.model)], function(axisInfo) {
            var axis = axisInfo.axis;
            if (coordSys.getAxis(axis.dim) === axis) {
                axisInfo.seriesModels.push(seriesModel);
                axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
                axisInfo.seriesDataCount += seriesModel.getData().count();
            }
        });
    }, this);
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */ function $16df2470cde098b3$var$getLinkGroupIndex(linksOption, axis) {
    var axisModel = axis.model;
    var dim = axis.dim;
    for(var i = 0; i < linksOption.length; i++){
        var linkOption = linksOption[i] || {};
        if ($16df2470cde098b3$var$checkPropInLink(linkOption[dim + "AxisId"], axisModel.id) || $16df2470cde098b3$var$checkPropInLink(linkOption[dim + "AxisIndex"], axisModel.componentIndex) || $16df2470cde098b3$var$checkPropInLink(linkOption[dim + "AxisName"], axisModel.name)) return i;
    }
}
function $16df2470cde098b3$var$checkPropInLink(linkPropValue, axisPropValue) {
    return linkPropValue === "all" || $ec279652dd95c27b$export$43bee75e5e14138e(linkPropValue) && $ec279652dd95c27b$export$305f7d4e9d4624f2(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}
function $16df2470cde098b3$var$fixValue(axisModel) {
    var axisInfo = $16df2470cde098b3$var$getAxisInfo(axisModel);
    if (!axisInfo) return;
    var axisPointerModel = axisInfo.axisPointerModel;
    var scale = axisInfo.axis.scale;
    var option = axisPointerModel.option;
    var status = axisPointerModel.get("status");
    var value = axisPointerModel.get("value"); // Parse init value for category and time axis.
    if (value != null) value = scale.parse(value);
    var useHandle = $16df2470cde098b3$var$isHandleTrigger(axisPointerModel); // If `handle` used, `axisPointer` will always be displayed, so value
    // and status should be initialized.
    if (status == null) option.status = useHandle ? "show" : "hide";
    var extent = scale.getExtent().slice();
    extent[0] > extent[1] && extent.reverse();
    if (value == null // If both `handle` and `dataZoom` are used, value may be out of axis extent,
     || value > extent[1]) // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
    if (value < extent[0]) value = extent[0];
    option.value = value;
    if (useHandle) option.status = axisInfo.axis.scale.isBlank() ? "hide" : "show";
}
function $16df2470cde098b3$var$getAxisInfo(axisModel) {
    var coordSysAxesInfo = (axisModel.ecModel.getComponent("axisPointer") || {}).coordSysAxesInfo;
    return coordSysAxesInfo && coordSysAxesInfo.axesInfo[$16df2470cde098b3$var$makeKey(axisModel)];
}
function $16df2470cde098b3$var$getAxisPointerModel(axisModel) {
    var axisInfo = $16df2470cde098b3$var$getAxisInfo(axisModel);
    return axisInfo && axisInfo.axisPointerModel;
}
function $16df2470cde098b3$var$isHandleTrigger(axisPointerModel) {
    return !!axisPointerModel.get("handle.show");
}
/**
 * @param {module:echarts/model/Model} model
 * @return {string} unique key
 */ function $16df2470cde098b3$var$makeKey(model) {
    return model.type + "||" + model.id;
}
$16df2470cde098b3$export$bb44f104e3c54dae = $16df2470cde098b3$var$collect;
$16df2470cde098b3$export$f5ea32e3629d8043 = $16df2470cde098b3$var$fixValue;
$16df2470cde098b3$export$bd39458db76002ab = $16df2470cde098b3$var$getAxisInfo;
$16df2470cde098b3$export$3b06fce3f68b734 = $16df2470cde098b3$var$getAxisPointerModel;
$16df2470cde098b3$export$d01b444bafb1a792 = $16df2470cde098b3$var$makeKey;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Base class of AxisView.
 */ var $0880bad8284a1b39$var$AxisView = $f406636b535430a7$exports.extendComponentView({
    type: "axis",
    /**
   * @private
   */ _axisPointer: null,
    /**
   * @protected
   * @type {string}
   */ axisPointerClass: null,
    /**
   * @override
   */ render: function(axisModel, ecModel, api, payload) {
        // FIXME
        // This process should proformed after coordinate systems updated
        // (axis scale updated), and should be performed each time update.
        // So put it here temporarily, although it is not appropriate to
        // put a model-writing procedure in `view`.
        this.axisPointerClass && $16df2470cde098b3$export$f5ea32e3629d8043(axisModel);
        $0880bad8284a1b39$var$AxisView.superApply(this, "render", arguments);
        $0880bad8284a1b39$var$updateAxisPointer(this, axisModel, ecModel, api, payload, true);
    },
    /**
   * Action handler.
   * @public
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/model/Global} ecModel
   * @param {module:echarts/ExtensionAPI} api
   * @param {Object} payload
   */ updateAxisPointer: function(axisModel, ecModel, api, payload, force) {
        $0880bad8284a1b39$var$updateAxisPointer(this, axisModel, ecModel, api, payload, false);
    },
    /**
   * @override
   */ remove: function(ecModel, api) {
        var axisPointer = this._axisPointer;
        axisPointer && axisPointer.remove(api);
        $0880bad8284a1b39$var$AxisView.superApply(this, "remove", arguments);
    },
    /**
   * @override
   */ dispose: function(ecModel, api) {
        $0880bad8284a1b39$var$disposeAxisPointer(this, api);
        $0880bad8284a1b39$var$AxisView.superApply(this, "dispose", arguments);
    }
});
function $0880bad8284a1b39$var$updateAxisPointer(axisView, axisModel, ecModel, api, payload, forceRender) {
    var Clazz = $0880bad8284a1b39$var$AxisView.getAxisPointerClass(axisView.axisPointerClass);
    if (!Clazz) return;
    var axisPointerModel = $16df2470cde098b3$export$3b06fce3f68b734(axisModel);
    axisPointerModel ? (axisView._axisPointer || (axisView._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : $0880bad8284a1b39$var$disposeAxisPointer(axisView, api);
}
function $0880bad8284a1b39$var$disposeAxisPointer(axisView, ecModel, api) {
    var axisPointer = axisView._axisPointer;
    axisPointer && axisPointer.dispose(ecModel, api);
    axisView._axisPointer = null;
}
var $0880bad8284a1b39$var$axisPointerClazz = [];
$0880bad8284a1b39$var$AxisView.registerAxisPointerClass = function(type, clazz) {
    $0880bad8284a1b39$var$axisPointerClazz[type] = clazz;
};
$0880bad8284a1b39$var$AxisView.getAxisPointerClass = function(type) {
    return type && $0880bad8284a1b39$var$axisPointerClazz[type];
};
var $0880bad8284a1b39$var$_default = $0880bad8284a1b39$var$AxisView;
$0880bad8284a1b39$exports = $0880bad8284a1b39$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $6f26210b03436c56$export$b3219800bda33a1f;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Can only be called after coordinate system creation stage.
 * (Can be called before coordinate system update stage).
 *
 * @param {Object} opt {labelInside}
 * @return {Object} {
 *  position, rotation, labelDirection, labelOffset,
 *  tickDirection, labelRotate, z2
 * }
 */ function $6f26210b03436c56$var$layout(gridModel, axisModel, opt) {
    opt = opt || {};
    var grid = gridModel.coordinateSystem;
    var axis = axisModel.axis;
    var layout = {};
    var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
    var rawAxisPosition = axis.position;
    var axisPosition = otherAxisOnZeroOf ? "onZero" : rawAxisPosition;
    var axisDim = axis.dim;
    var rect = grid.getRect();
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var idx = {
        left: 0,
        right: 1,
        top: 0,
        bottom: 1,
        onZero: 2
    };
    var axisOffset = axisModel.get("offset") || 0;
    var posBound = axisDim === "x" ? [
        rectBound[2] - axisOffset,
        rectBound[3] + axisOffset
    ] : [
        rectBound[0] - axisOffset,
        rectBound[1] + axisOffset
    ];
    if (otherAxisOnZeroOf) {
        var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
        posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
    } // Axis position
    layout.position = [
        axisDim === "y" ? posBound[idx[axisPosition]] : rectBound[0],
        axisDim === "x" ? posBound[idx[axisPosition]] : rectBound[3]
    ]; // Axis rotation
    layout.rotation = Math.PI / 2 * (axisDim === "x" ? 0 : 1); // Tick and label direction, x y is axisDim
    var dirMap = {
        top: -1,
        bottom: 1,
        left: -1,
        right: 1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
    layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
    if (axisModel.get("axisTick.inside")) layout.tickDirection = -layout.tickDirection;
    if ($ec279652dd95c27b$export$8a4d17b6e8486e66(opt.labelInside, axisModel.get("axisLabel.inside"))) layout.labelDirection = -layout.labelDirection;
     // Special label rotation
    var labelRotate = axisModel.get("axisLabel.rotate");
    layout.labelRotate = axisPosition === "top" ? -labelRotate : labelRotate; // Over splitLine and splitArea
    layout.z2 = 1;
    return layout;
}
$6f26210b03436c56$export$b3219800bda33a1f = $6f26210b03436c56$var$layout;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $7667fad32ad54e48$export$c80b7ef1527ec8c9;
var $7667fad32ad54e48$export$48ebf2d6ce8ad076;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $7667fad32ad54e48$var$rectCoordAxisBuildSplitArea(axisView, axisGroup, axisModel, gridModel) {
    var axis = axisModel.axis;
    if (axis.scale.isBlank()) return;
    var splitAreaModel = axisModel.getModel("splitArea");
    var areaStyleModel = splitAreaModel.getModel("areaStyle");
    var areaColors = areaStyleModel.get("color");
    var gridRect = gridModel.coordinateSystem.getRect();
    var ticksCoords = axis.getTicksCoords({
        tickModel: splitAreaModel,
        clamp: true
    });
    if (!ticksCoords.length) return;
     // For Making appropriate splitArea animation, the color and anid
    // should be corresponding to previous one if possible.
    var areaColorsLen = areaColors.length;
    var lastSplitAreaColors = axisView.__splitAreaColors;
    var newSplitAreaColors = $ec279652dd95c27b$export$55f8aa7ef875b0a4();
    var colorIndex = 0;
    if (lastSplitAreaColors) for(var i = 0; i < ticksCoords.length; i++){
        var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
        if (cIndex != null) {
            colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
            break;
        }
    }
    var prev = axis.toGlobalCoord(ticksCoords[0].coord);
    var areaStyle = areaStyleModel.getAreaStyle();
    areaColors = $ec279652dd95c27b$export$43bee75e5e14138e(areaColors) ? areaColors : [
        areaColors
    ];
    for(var i = 1; i < ticksCoords.length; i++){
        var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
        var x;
        var y;
        var width;
        var height;
        if (axis.isHorizontal()) {
            x = prev;
            y = gridRect.y;
            width = tickCoord - x;
            height = gridRect.height;
            prev = x + width;
        } else {
            x = gridRect.x;
            y = prev;
            width = gridRect.width;
            height = tickCoord - y;
            prev = y + height;
        }
        var tickValue = ticksCoords[i - 1].tickValue;
        tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
        axisGroup.add(new $4b57d6b582d579b7$export$c79fc6492f3af13d({
            anid: tickValue != null ? "area_" + tickValue : null,
            shape: {
                x: x,
                y: y,
                width: width,
                height: height
            },
            style: $ec279652dd95c27b$export$ebe90cb607ad99e({
                fill: areaColors[colorIndex]
            }, areaStyle),
            silent: true
        }));
        colorIndex = (colorIndex + 1) % areaColorsLen;
    }
    axisView.__splitAreaColors = newSplitAreaColors;
}
function $7667fad32ad54e48$var$rectCoordAxisHandleRemove(axisView) {
    axisView.__splitAreaColors = null;
}
$7667fad32ad54e48$export$c80b7ef1527ec8c9 = $7667fad32ad54e48$var$rectCoordAxisBuildSplitArea;
$7667fad32ad54e48$export$48ebf2d6ce8ad076 = $7667fad32ad54e48$var$rectCoordAxisHandleRemove;


var $e241777f781d2ac2$var$rectCoordAxisBuildSplitArea = $7667fad32ad54e48$export$c80b7ef1527ec8c9;
var $e241777f781d2ac2$var$rectCoordAxisHandleRemove = $7667fad32ad54e48$export$48ebf2d6ce8ad076;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $e241777f781d2ac2$var$axisBuilderAttrs = [
    "axisLine",
    "axisTickLabel",
    "axisName"
];
var $e241777f781d2ac2$var$selfBuilderAttrs = [
    "splitArea",
    "splitLine",
    "minorSplitLine"
];
var $e241777f781d2ac2$var$CartesianAxisView = $0880bad8284a1b39$exports.extend({
    type: "cartesianAxis",
    axisPointerClass: "CartesianAxisPointer",
    /**
   * @override
   */ render: function(axisModel, ecModel, api, payload) {
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
        this.group.add(this._axisGroup);
        if (!axisModel.get("show")) return;
        var gridModel = axisModel.getCoordSysModel();
        var layout = $6f26210b03436c56$export$b3219800bda33a1f(gridModel, axisModel);
        var axisBuilder = new $3ce77a4133d2c8eb$exports(axisModel, layout);
        $ec279652dd95c27b$export$79b2f7037acddd43($e241777f781d2ac2$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
        this._axisGroup.add(axisBuilder.getGroup());
        $ec279652dd95c27b$export$79b2f7037acddd43($e241777f781d2ac2$var$selfBuilderAttrs, function(name) {
            if (axisModel.get(name + ".show")) this["_" + name](axisModel, gridModel);
        }, this);
        $4b57d6b582d579b7$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
        $e241777f781d2ac2$var$CartesianAxisView.superCall(this, "render", axisModel, ecModel, api, payload);
    },
    remove: function() {
        $e241777f781d2ac2$var$rectCoordAxisHandleRemove(this);
    },
    /**
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/coord/cartesian/GridModel} gridModel
   * @private
   */ _splitLine: function(axisModel, gridModel) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel("splitLine");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var lineColors = lineStyleModel.get("color");
        lineColors = $ec279652dd95c27b$export$43bee75e5e14138e(lineColors) ? lineColors : [
            lineColors
        ];
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel
        });
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < ticksCoords.length; i++){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var colorIndex = lineCount++ % lineColors.length;
            var tickValue = ticksCoords[i].tickValue;
            this._axisGroup.add(new $4b57d6b582d579b7$export$17d680238e50603e({
                anid: tickValue != null ? "line_" + ticksCoords[i].tickValue : null,
                subPixelOptimize: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: $ec279652dd95c27b$export$ebe90cb607ad99e({
                    stroke: lineColors[colorIndex]
                }, lineStyle),
                silent: true
            }));
        }
    },
    /**
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/coord/cartesian/GridModel} gridModel
   * @private
   */ _minorSplitLine: function(axisModel, gridModel) {
        var axis = axisModel.axis;
        var minorSplitLineModel = axisModel.getModel("minorSplitLine");
        var lineStyleModel = minorSplitLineModel.getModel("lineStyle");
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var minorTicksCoords = axis.getMinorTicksCoords();
        if (!minorTicksCoords.length) return;
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++){
            var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            this._axisGroup.add(new $4b57d6b582d579b7$export$17d680238e50603e({
                anid: "minor_line_" + minorTicksCoords[i][k].tickValue,
                subPixelOptimize: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: lineStyle,
                silent: true
            }));
        }
    },
    /**
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/coord/cartesian/GridModel} gridModel
   * @private
   */ _splitArea: function(axisModel, gridModel) {
        $e241777f781d2ac2$var$rectCoordAxisBuildSplitArea(this, this._axisGroup, axisModel, gridModel);
    }
});
$e241777f781d2ac2$var$CartesianAxisView.extend({
    type: "xAxis"
});
$e241777f781d2ac2$var$CartesianAxisView.extend({
    type: "yAxis"
});




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Grid view
$f406636b535430a7$exports.extendComponentView({
    type: "grid",
    render: function(gridModel, ecModel) {
        this.group.removeAll();
        if (gridModel.get("show")) this.group.add(new $4b57d6b582d579b7$export$c79fc6492f3af13d({
            shape: gridModel.coordinateSystem.getRect(),
            style: $ec279652dd95c27b$export$ebe90cb607ad99e({
                fill: gridModel.get("backgroundColor")
            }, gridModel.getItemStyle()),
            silent: true,
            z2: -1
        }));
    }
});
$f406636b535430a7$exports.registerPreprocessor(function(option) {
    // Only create grid when need
    if (option.xAxis && option.yAxis && !option.grid) option.grid = {};
});


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // In case developer forget to include grid component
$f406636b535430a7$exports.registerVisual($6efa4c3507ca2b4d$exports("line", "circle", "line"));
$f406636b535430a7$exports.registerLayout($c76a359a25b70ceb$exports("line")); // Down sample after filter
$f406636b535430a7$exports.registerProcessor($f406636b535430a7$exports.PRIORITY.PROCESSOR.STATISTIC, $051a1cec4ea723be$exports("line"));


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $7f2a79451c5c013b$var$layout = $249e780a835e3f86$export$b3219800bda33a1f;
var $7f2a79451c5c013b$var$largeLayout = $249e780a835e3f86$export$1fcd87ee6628f095;

var $9e7ca0cbc577e716$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $4d229707f7d9b379$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $4d229707f7d9b379$var$_default = $70847df98016d69d$exports.extend({
    type: "series.__base_bar__",
    getInitialData: function(option, ecModel) {
        return $10e48b57e44af7c1$exports(this.getSource(), this, {
            useEncodeDefaulter: true
        });
    },
    getMarkerPosition: function(value) {
        var coordSys = this.coordinateSystem;
        if (coordSys) {
            // PENDING if clamp ?
            var pt = coordSys.dataToPoint(coordSys.clampData(value));
            var data = this.getData();
            var offset = data.getLayout("offset");
            var size = data.getLayout("size");
            var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
            pt[offsetIndex] += offset + size / 2;
            return pt;
        }
        return [
            NaN,
            NaN
        ];
    },
    defaultOption: {
        zlevel: 0,
        // 一级层叠
        z: 2,
        // 二级层叠
        coordinateSystem: "cartesian2d",
        legendHoverLink: true,
        // stack: null
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // 最小高度改为0
        barMinHeight: 0,
        // 最小角度为0，仅对极坐标系下的柱状图有效
        barMinAngle: 0,
        // cursor: null,
        large: false,
        largeThreshold: 400,
        progressive: 3e3,
        progressiveChunkMode: "mod",
        // barMaxWidth: null,
        // In cartesian, the default value is 1. Otherwise null.
        // barMinWidth: null,
        // 默认自适应
        // barWidth: null,
        // 柱间距离，默认为柱形宽度的30%，可设固定值
        // barGap: '30%',
        // 类目间柱形距离，默认为类目间距的20%，可设固定值
        // barCategoryGap: '20%',
        // label: {
        //      show: false
        // },
        itemStyle: {},
        emphasis: {}
    }
});
$4d229707f7d9b379$exports = $4d229707f7d9b379$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $9e7ca0cbc577e716$var$_default = $4d229707f7d9b379$exports.extend({
    type: "series.bar",
    dependencies: [
        "grid",
        "polar"
    ],
    brushSelector: "rect",
    /**
   * @override
   */ getProgressive: function() {
        // Do not support progressive in normal mode.
        return this.get("large") ? this.get("progressive") : false;
    },
    /**
   * @override
   */ getProgressiveThreshold: function() {
        // Do not support progressive in normal mode.
        var progressiveThreshold = this.get("progressiveThreshold");
        var largeThreshold = this.get("largeThreshold");
        if (largeThreshold > progressiveThreshold) progressiveThreshold = largeThreshold;
        return progressiveThreshold;
    },
    defaultOption: {
        // If clipped
        // Only available on cartesian2d
        clip: true,
        // If use caps on two sides of bars
        // Only available on tangential polar bar
        roundCap: false,
        showBackground: false,
        backgroundStyle: {
            color: "rgba(180, 180, 180, 0.2)",
            borderColor: null,
            borderWidth: 0,
            borderType: "solid",
            borderRadius: 0,
            shadowBlur: 0,
            shadowColor: null,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1
        }
    }
});
$9e7ca0cbc577e716$exports = $9e7ca0cbc577e716$var$_default;


var $109bc4040f406ce7$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $109bc4040f406ce7$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $928677db495c9bf1$export$4f65e594f6031297;


var $928677db495c9bf1$var$getDefaultLabel = $a03b7f2e2ed9bf1c$export$5ff20667590927ed;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $928677db495c9bf1$var$setLabel(normalStyle, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside) {
    var labelModel = itemModel.getModel("label");
    var hoverLabelModel = itemModel.getModel("emphasis.label");
    $4b57d6b582d579b7$export$9a13992917966657(normalStyle, hoverStyle, labelModel, hoverLabelModel, {
        labelFetcher: seriesModel,
        labelDataIndex: dataIndex,
        defaultText: $928677db495c9bf1$var$getDefaultLabel(seriesModel.getData(), dataIndex),
        isRectText: true,
        autoColor: color
    });
    $928677db495c9bf1$var$fixPosition(normalStyle);
    $928677db495c9bf1$var$fixPosition(hoverStyle);
}
function $928677db495c9bf1$var$fixPosition(style, labelPositionOutside) {
    if (style.textPosition === "outside") style.textPosition = labelPositionOutside;
}
$928677db495c9bf1$export$4f65e594f6031297 = $928677db495c9bf1$var$setLabel;


var $109bc4040f406ce7$var$setLabel = $928677db495c9bf1$export$4f65e594f6031297;

var $243c68d094c9b685$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $243c68d094c9b685$var$getBarItemStyle = $d701679ba7a46009$exports([
    [
        "fill",
        "color"
    ],
    [
        "stroke",
        "borderColor"
    ],
    [
        "lineWidth",
        "borderWidth"
    ],
    [
        "stroke",
        "barBorderColor"
    ],
    [
        "lineWidth",
        "barBorderWidth"
    ],
    [
        "opacity"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "shadowColor"
    ]
]);
var $243c68d094c9b685$var$_default = {
    getBarItemStyle: function(excludes) {
        var style = $243c68d094c9b685$var$getBarItemStyle(this, excludes);
        if (this.getBorderLineDash) {
            var lineDash = this.getBorderLineDash();
            lineDash && (style.lineDash = lineDash);
        }
        return style;
    }
};
$243c68d094c9b685$exports = $243c68d094c9b685$var$_default;





var $109bc4040f406ce7$var$throttle = $a181ac84b0d97d16$export$de363e709c412c8a;

var $109bc4040f406ce7$var$createClipPath = $df90403704fddb7c$export$e0fe5081209d01c9;
var $b208d3946b6a308a$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $b208d3946b6a308a$var$extendShape = $4b57d6b582d579b7$export$d0d5398c9d612037;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Sausage: similar to sector, but have half circle on both sides
 * @public
 */ var $b208d3946b6a308a$var$_default = $b208d3946b6a308a$var$extendShape({
    type: "sausage",
    shape: {
        cx: 0,
        cy: 0,
        r0: 0,
        r: 0,
        startAngle: 0,
        endAngle: Math.PI * 2,
        clockwise: true
    },
    buildPath: function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r0 = Math.max(shape.r0 || 0, 0);
        var r = Math.max(shape.r, 0);
        var dr = (r - r0) * 0.5;
        var rCenter = r0 + dr;
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitStartX = Math.cos(startAngle);
        var unitStartY = Math.sin(startAngle);
        var unitEndX = Math.cos(endAngle);
        var unitEndY = Math.sin(endAngle);
        var lessThanCircle = clockwise ? endAngle - startAngle < Math.PI * 2 : startAngle - endAngle < Math.PI * 2;
        if (lessThanCircle) {
            ctx.moveTo(unitStartX * r0 + x, unitStartY * r0 + y);
            ctx.arc(unitStartX * rCenter + x, unitStartY * rCenter + y, dr, -Math.PI + startAngle, startAngle, !clockwise);
        }
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
        ctx.moveTo(unitEndX * r + x, unitEndY * r + y);
        ctx.arc(unitEndX * rCenter + x, unitEndY * rCenter + y, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);
        if (r0 !== 0) {
            ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
            ctx.moveTo(unitStartX * r0 + x, unitEndY * r0 + y);
        }
        ctx.closePath();
    }
});
$b208d3946b6a308a$exports = $b208d3946b6a308a$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $109bc4040f406ce7$var$BAR_BORDER_WIDTH_QUERY = [
    "itemStyle",
    "barBorderWidth"
];
var $109bc4040f406ce7$var$_eventPos = [
    0,
    0
]; // FIXME
// Just for compatible with ec2.
$ec279652dd95c27b$export$8b58be045bf06082($2b51b4bf776ec22e$exports.prototype, $243c68d094c9b685$exports);
function $109bc4040f406ce7$var$getClipArea(coord, data) {
    var coordSysClipArea = coord.getArea && coord.getArea();
    if (coord.type === "cartesian2d") {
        var baseAxis = coord.getBaseAxis(); // When boundaryGap is false or using time axis. bar may exceed the grid.
        // We should not clip this part.
        // See test/bar2.html
        if (baseAxis.type !== "category" || !baseAxis.onBand) {
            var expandWidth = data.getLayout("bandWidth");
            if (baseAxis.isHorizontal()) {
                coordSysClipArea.x -= expandWidth;
                coordSysClipArea.width += expandWidth * 2;
            } else {
                coordSysClipArea.y -= expandWidth;
                coordSysClipArea.height += expandWidth * 2;
            }
        }
    }
    return coordSysClipArea;
}
var $109bc4040f406ce7$var$_default = $f406636b535430a7$exports.extendChartView({
    type: "bar",
    render: function(seriesModel, ecModel, api) {
        this._updateDrawMode(seriesModel);
        var coordinateSystemType = seriesModel.get("coordinateSystem");
        if (coordinateSystemType === "cartesian2d" || coordinateSystemType === "polar") this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api);
        return this.group;
    },
    incrementalPrepareRender: function(seriesModel, ecModel, api) {
        this._clear();
        this._updateDrawMode(seriesModel);
    },
    incrementalRender: function(params, seriesModel, ecModel, api) {
        // Do not support progressive in normal mode.
        this._incrementalRenderLarge(params, seriesModel);
    },
    _updateDrawMode: function(seriesModel) {
        var isLargeDraw = seriesModel.pipelineContext.large;
        if (this._isLargeDraw == null || isLargeDraw ^ this._isLargeDraw) {
            this._isLargeDraw = isLargeDraw;
            this._clear();
        }
    },
    _renderNormal: function(seriesModel, ecModel, api) {
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        var coord = seriesModel.coordinateSystem;
        var baseAxis = coord.getBaseAxis();
        var isHorizontalOrRadial;
        if (coord.type === "cartesian2d") isHorizontalOrRadial = baseAxis.isHorizontal();
        else if (coord.type === "polar") isHorizontalOrRadial = baseAxis.dim === "angle";
        var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
        var needsClip = seriesModel.get("clip", true);
        var coordSysClipArea = $109bc4040f406ce7$var$getClipArea(coord, data); // If there is clipPath created in large mode. Remove it.
        group.removeClipPath(); // We don't use clipPath in normal mode because we needs a perfect animation
        // And don't want the label are clipped.
        var roundCap = seriesModel.get("roundCap", true);
        var drawBackground = seriesModel.get("showBackground", true);
        var backgroundModel = seriesModel.getModel("backgroundStyle");
        var barBorderRadius = backgroundModel.get("barBorderRadius") || 0;
        var bgEls = [];
        var oldBgEls = this._backgroundEls || [];
        var createBackground = function(dataIndex) {
            var bgLayout = $109bc4040f406ce7$var$getLayout[coord.type](data, dataIndex);
            var bgEl = $109bc4040f406ce7$var$createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
            bgEl.useStyle(backgroundModel.getBarItemStyle()); // Only cartesian2d support borderRadius.
            if (coord.type === "cartesian2d") bgEl.setShape("r", barBorderRadius);
            bgEls[dataIndex] = bgEl;
            return bgEl;
        };
        data.diff(oldData).add(function(dataIndex) {
            var itemModel = data.getItemModel(dataIndex);
            var layout = $109bc4040f406ce7$var$getLayout[coord.type](data, dataIndex, itemModel);
            if (drawBackground) createBackground(dataIndex);
             // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".
            if (!data.hasValue(dataIndex)) return;
            if (needsClip) {
                // Clip will modify the layout params.
                // And return a boolean to determine if the shape are fully clipped.
                var isClipped = $109bc4040f406ce7$var$clip[coord.type](coordSysClipArea, layout);
                if (isClipped) {
                    group.remove(el);
                    return;
                }
            }
            var el = $109bc4040f406ce7$var$elementCreator[coord.type](dataIndex, layout, isHorizontalOrRadial, animationModel, false, roundCap);
            data.setItemGraphicEl(dataIndex, el);
            group.add(el);
            $109bc4040f406ce7$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === "polar");
        }).update(function(newIndex, oldIndex) {
            var itemModel = data.getItemModel(newIndex);
            var layout = $109bc4040f406ce7$var$getLayout[coord.type](data, newIndex, itemModel);
            if (drawBackground) {
                var bgEl;
                if (oldBgEls.length === 0) bgEl = createBackground(oldIndex);
                else {
                    bgEl = oldBgEls[oldIndex];
                    bgEl.useStyle(backgroundModel.getBarItemStyle()); // Only cartesian2d support borderRadius.
                    if (coord.type === "cartesian2d") bgEl.setShape("r", barBorderRadius);
                    bgEls[newIndex] = bgEl;
                }
                var bgLayout = $109bc4040f406ce7$var$getLayout[coord.type](data, newIndex);
                var shape = $109bc4040f406ce7$var$createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
                $4b57d6b582d579b7$exports.updateProps(bgEl, {
                    shape: shape
                }, animationModel, newIndex);
            }
            var el = oldData.getItemGraphicEl(oldIndex);
            if (!data.hasValue(newIndex)) {
                group.remove(el);
                return;
            }
            if (needsClip) {
                var isClipped = $109bc4040f406ce7$var$clip[coord.type](coordSysClipArea, layout);
                if (isClipped) {
                    group.remove(el);
                    return;
                }
            }
            if (el) $4b57d6b582d579b7$exports.updateProps(el, {
                shape: layout
            }, animationModel, newIndex);
            else el = $109bc4040f406ce7$var$elementCreator[coord.type](newIndex, layout, isHorizontalOrRadial, animationModel, true, roundCap);
            data.setItemGraphicEl(newIndex, el); // Add back
            group.add(el);
            $109bc4040f406ce7$var$updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === "polar");
        }).remove(function(dataIndex) {
            var el = oldData.getItemGraphicEl(dataIndex);
            if (coord.type === "cartesian2d") el && $109bc4040f406ce7$var$removeRect(dataIndex, animationModel, el);
            else el && $109bc4040f406ce7$var$removeSector(dataIndex, animationModel, el);
        }).execute();
        var bgGroup = this._backgroundGroup || (this._backgroundGroup = new $48aa8d5160ffcc64$exports());
        bgGroup.removeAll();
        for(var i = 0; i < bgEls.length; ++i)bgGroup.add(bgEls[i]);
        group.add(bgGroup);
        this._backgroundEls = bgEls;
        this._data = data;
    },
    _renderLarge: function(seriesModel, ecModel, api) {
        this._clear();
        $109bc4040f406ce7$var$createLarge(seriesModel, this.group); // Use clipPath in large mode.
        var clipPath = seriesModel.get("clip", true) ? $109bc4040f406ce7$var$createClipPath(seriesModel.coordinateSystem, false, seriesModel) : null;
        if (clipPath) this.group.setClipPath(clipPath);
        else this.group.removeClipPath();
    },
    _incrementalRenderLarge: function(params, seriesModel) {
        this._removeBackground();
        $109bc4040f406ce7$var$createLarge(seriesModel, this.group, true);
    },
    dispose: $ec279652dd95c27b$export$8793edee2d425525,
    remove: function(ecModel) {
        this._clear(ecModel);
    },
    _clear: function(ecModel) {
        var group = this.group;
        var data = this._data;
        if (ecModel && ecModel.get("animation") && data && !this._isLargeDraw) {
            this._removeBackground();
            this._backgroundEls = [];
            data.eachItemGraphicEl(function(el) {
                if (el.type === "sector") $109bc4040f406ce7$var$removeSector(el.dataIndex, ecModel, el);
                else $109bc4040f406ce7$var$removeRect(el.dataIndex, ecModel, el);
            });
        } else group.removeAll();
        this._data = null;
    },
    _removeBackground: function() {
        this.group.remove(this._backgroundGroup);
        this._backgroundGroup = null;
    }
});
var $109bc4040f406ce7$var$mathMax = Math.max;
var $109bc4040f406ce7$var$mathMin = Math.min;
var $109bc4040f406ce7$var$clip = {
    cartesian2d: function(coordSysBoundingRect, layout) {
        var signWidth = layout.width < 0 ? -1 : 1;
        var signHeight = layout.height < 0 ? -1 : 1; // Needs positive width and height
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        var x = $109bc4040f406ce7$var$mathMax(layout.x, coordSysBoundingRect.x);
        var x2 = $109bc4040f406ce7$var$mathMin(layout.x + layout.width, coordSysBoundingRect.x + coordSysBoundingRect.width);
        var y = $109bc4040f406ce7$var$mathMax(layout.y, coordSysBoundingRect.y);
        var y2 = $109bc4040f406ce7$var$mathMin(layout.y + layout.height, coordSysBoundingRect.y + coordSysBoundingRect.height);
        layout.x = x;
        layout.y = y;
        layout.width = x2 - x;
        layout.height = y2 - y;
        var clipped = layout.width < 0 || layout.height < 0; // Reverse back
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        return clipped;
    },
    polar: function(coordSysClipArea, layout) {
        var signR = layout.r0 <= layout.r ? 1 : -1; // Make sure r is larger than r0
        if (signR < 0) {
            var r = layout.r;
            layout.r = layout.r0;
            layout.r0 = r;
        }
        var r = $109bc4040f406ce7$var$mathMin(layout.r, coordSysClipArea.r);
        var r0 = $109bc4040f406ce7$var$mathMax(layout.r0, coordSysClipArea.r0);
        layout.r = r;
        layout.r0 = r0;
        var clipped = r - r0 < 0; // Reverse back
        if (signR < 0) {
            var r = layout.r;
            layout.r = layout.r0;
            layout.r0 = r;
        }
        return clipped;
    }
};
var $109bc4040f406ce7$var$elementCreator = {
    cartesian2d: function(dataIndex, layout, isHorizontal, animationModel, isUpdate) {
        var rect = new $4b57d6b582d579b7$exports.Rect({
            shape: $ec279652dd95c27b$export$8b58be045bf06082({}, layout),
            z2: 1
        });
        rect.name = "item"; // Animation
        if (animationModel) {
            var rectShape = rect.shape;
            var animateProperty = isHorizontal ? "height" : "width";
            var animateTarget = {};
            rectShape[animateProperty] = 0;
            animateTarget[animateProperty] = layout[animateProperty];
            $4b57d6b582d579b7$exports[isUpdate ? "updateProps" : "initProps"](rect, {
                shape: animateTarget
            }, animationModel, dataIndex);
        }
        return rect;
    },
    polar: function(dataIndex, layout, isRadial, animationModel, isUpdate, roundCap) {
        // Keep the same logic with bar in catesion: use end value to control
        // direction. Notice that if clockwise is true (by default), the sector
        // will always draw clockwisely, no matter whether endAngle is greater
        // or less than startAngle.
        var clockwise = layout.startAngle < layout.endAngle;
        var ShapeClass = !isRadial && roundCap ? $b208d3946b6a308a$exports : $4b57d6b582d579b7$exports.Sector;
        var sector = new ShapeClass({
            shape: $ec279652dd95c27b$export$ebe90cb607ad99e({
                clockwise: clockwise
            }, layout),
            z2: 1
        });
        sector.name = "item"; // Animation
        if (animationModel) {
            var sectorShape = sector.shape;
            var animateProperty = isRadial ? "r" : "endAngle";
            var animateTarget = {};
            sectorShape[animateProperty] = isRadial ? 0 : layout.startAngle;
            animateTarget[animateProperty] = layout[animateProperty];
            $4b57d6b582d579b7$exports[isUpdate ? "updateProps" : "initProps"](sector, {
                shape: animateTarget
            }, animationModel, dataIndex);
        }
        return sector;
    }
};
function $109bc4040f406ce7$var$removeRect(dataIndex, animationModel, el) {
    // Not show text when animating
    el.style.text = null;
    $4b57d6b582d579b7$exports.updateProps(el, {
        shape: {
            width: 0
        }
    }, animationModel, dataIndex, function() {
        el.parent && el.parent.remove(el);
    });
}
function $109bc4040f406ce7$var$removeSector(dataIndex, animationModel, el) {
    // Not show text when animating
    el.style.text = null;
    $4b57d6b582d579b7$exports.updateProps(el, {
        shape: {
            r: el.shape.r0
        }
    }, animationModel, dataIndex, function() {
        el.parent && el.parent.remove(el);
    });
}
var $109bc4040f406ce7$var$getLayout = {
    // itemModel is only used to get borderWidth, which is not needed
    // when calculating bar background layout.
    cartesian2d: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        var fixedLineWidth = itemModel ? $109bc4040f406ce7$var$getLineWidth(itemModel, layout) : 0; // fix layout with lineWidth
        var signX = layout.width > 0 ? 1 : -1;
        var signY = layout.height > 0 ? 1 : -1;
        return {
            x: layout.x + signX * fixedLineWidth / 2,
            y: layout.y + signY * fixedLineWidth / 2,
            width: layout.width - signX * fixedLineWidth,
            height: layout.height - signY * fixedLineWidth
        };
    },
    polar: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        return {
            cx: layout.cx,
            cy: layout.cy,
            r0: layout.r0,
            r: layout.r,
            startAngle: layout.startAngle,
            endAngle: layout.endAngle
        };
    }
};
function $109bc4040f406ce7$var$isZeroOnPolar(layout) {
    return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
}
function $109bc4040f406ce7$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontal, isPolar) {
    var color = data.getItemVisual(dataIndex, "color");
    var opacity = data.getItemVisual(dataIndex, "opacity");
    var stroke = data.getVisual("borderColor");
    var itemStyleModel = itemModel.getModel("itemStyle");
    var hoverStyle = itemModel.getModel("emphasis.itemStyle").getBarItemStyle();
    if (!isPolar) el.setShape("r", itemStyleModel.get("barBorderRadius") || 0);
    el.useStyle($ec279652dd95c27b$export$ebe90cb607ad99e({
        stroke: $109bc4040f406ce7$var$isZeroOnPolar(layout) ? "none" : stroke,
        fill: $109bc4040f406ce7$var$isZeroOnPolar(layout) ? "none" : color,
        opacity: opacity
    }, itemStyleModel.getBarItemStyle()));
    var cursorStyle = itemModel.getShallow("cursor");
    cursorStyle && el.attr("cursor", cursorStyle);
    var labelPositionOutside = isHorizontal ? layout.height > 0 ? "bottom" : "top" : layout.width > 0 ? "left" : "right";
    if (!isPolar) $109bc4040f406ce7$var$setLabel(el.style, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside);
    if ($109bc4040f406ce7$var$isZeroOnPolar(layout)) hoverStyle.fill = hoverStyle.stroke = "none";
    $4b57d6b582d579b7$exports.setHoverStyle(el, hoverStyle);
} // In case width or height are too small.
function $109bc4040f406ce7$var$getLineWidth(itemModel, rawLayout) {
    var lineWidth = itemModel.get($109bc4040f406ce7$var$BAR_BORDER_WIDTH_QUERY) || 0; // width or height may be NaN for empty data
    var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
    var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
    return Math.min(lineWidth, width, height);
}
var $109bc4040f406ce7$var$LargePath = $b9701a0f23f767de$exports.extend({
    type: "largeBar",
    shape: {
        points: []
    },
    buildPath: function(ctx, shape) {
        // Drawing lines is more efficient than drawing
        // a whole line or drawing rects.
        var points = shape.points;
        var startPoint = this.__startPoint;
        var baseDimIdx = this.__baseDimIdx;
        for(var i = 0; i < points.length; i += 2){
            startPoint[baseDimIdx] = points[i + baseDimIdx];
            ctx.moveTo(startPoint[0], startPoint[1]);
            ctx.lineTo(points[i], points[i + 1]);
        }
    }
});
function $109bc4040f406ce7$var$createLarge(seriesModel, group, incremental) {
    // TODO support polar
    var data = seriesModel.getData();
    var startPoint = [];
    var baseDimIdx = data.getLayout("valueAxisHorizontal") ? 1 : 0;
    startPoint[1 - baseDimIdx] = data.getLayout("valueAxisStart");
    var largeDataIndices = data.getLayout("largeDataIndices");
    var barWidth = data.getLayout("barWidth");
    var backgroundModel = seriesModel.getModel("backgroundStyle");
    var drawBackground = seriesModel.get("showBackground", true);
    if (drawBackground) {
        var points = data.getLayout("largeBackgroundPoints");
        var backgroundStartPoint = [];
        backgroundStartPoint[1 - baseDimIdx] = data.getLayout("backgroundStart");
        var bgEl = new $109bc4040f406ce7$var$LargePath({
            shape: {
                points: points
            },
            incremental: !!incremental,
            __startPoint: backgroundStartPoint,
            __baseDimIdx: baseDimIdx,
            __largeDataIndices: largeDataIndices,
            __barWidth: barWidth,
            silent: true,
            z2: 0
        });
        $109bc4040f406ce7$var$setLargeBackgroundStyle(bgEl, backgroundModel, data);
        group.add(bgEl);
    }
    var el = new $109bc4040f406ce7$var$LargePath({
        shape: {
            points: data.getLayout("largePoints")
        },
        incremental: !!incremental,
        __startPoint: startPoint,
        __baseDimIdx: baseDimIdx,
        __largeDataIndices: largeDataIndices,
        __barWidth: barWidth
    });
    group.add(el);
    $109bc4040f406ce7$var$setLargeStyle(el, seriesModel, data); // Enable tooltip and user mouse/touch event handlers.
    el.seriesIndex = seriesModel.seriesIndex;
    if (!seriesModel.get("silent")) {
        el.on("mousedown", $109bc4040f406ce7$var$largePathUpdateDataIndex);
        el.on("mousemove", $109bc4040f406ce7$var$largePathUpdateDataIndex);
    }
} // Use throttle to avoid frequently traverse to find dataIndex.
var $109bc4040f406ce7$var$largePathUpdateDataIndex = $109bc4040f406ce7$var$throttle(function(event) {
    var largePath = this;
    var dataIndex = $109bc4040f406ce7$var$largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
    largePath.dataIndex = dataIndex >= 0 ? dataIndex : null;
}, 30, false);
function $109bc4040f406ce7$var$largePathFindDataIndex(largePath, x, y) {
    var baseDimIdx = largePath.__baseDimIdx;
    var valueDimIdx = 1 - baseDimIdx;
    var points = largePath.shape.points;
    var largeDataIndices = largePath.__largeDataIndices;
    var barWidthHalf = Math.abs(largePath.__barWidth / 2);
    var startValueVal = largePath.__startPoint[valueDimIdx];
    $109bc4040f406ce7$var$_eventPos[0] = x;
    $109bc4040f406ce7$var$_eventPos[1] = y;
    var pointerBaseVal = $109bc4040f406ce7$var$_eventPos[baseDimIdx];
    var pointerValueVal = $109bc4040f406ce7$var$_eventPos[1 - baseDimIdx];
    var baseLowerBound = pointerBaseVal - barWidthHalf;
    var baseUpperBound = pointerBaseVal + barWidthHalf;
    for(var i = 0, len = points.length / 2; i < len; i++){
        var ii = i * 2;
        var barBaseVal = points[ii + baseDimIdx];
        var barValueVal = points[ii + valueDimIdx];
        if (barBaseVal >= baseLowerBound && barBaseVal <= baseUpperBound && (startValueVal <= barValueVal ? pointerValueVal >= startValueVal && pointerValueVal <= barValueVal : pointerValueVal >= barValueVal && pointerValueVal <= startValueVal)) return largeDataIndices[i];
    }
    return -1;
}
function $109bc4040f406ce7$var$setLargeStyle(el, seriesModel, data) {
    var borderColor = data.getVisual("borderColor") || data.getVisual("color");
    var itemStyle = seriesModel.getModel("itemStyle").getItemStyle([
        "color",
        "borderColor"
    ]);
    el.useStyle(itemStyle);
    el.style.fill = null;
    el.style.stroke = borderColor;
    el.style.lineWidth = data.getLayout("barWidth");
}
function $109bc4040f406ce7$var$setLargeBackgroundStyle(el, backgroundModel, data) {
    var borderColor = backgroundModel.get("borderColor") || backgroundModel.get("color");
    var itemStyle = backgroundModel.getItemStyle([
        "color",
        "borderColor"
    ]);
    el.useStyle(itemStyle);
    el.style.fill = null;
    el.style.stroke = borderColor;
    el.style.lineWidth = data.getLayout("barWidth");
}
function $109bc4040f406ce7$var$createBackgroundShape(isHorizontalOrRadial, layout, coord) {
    var coordLayout;
    var isPolar = coord.type === "polar";
    if (isPolar) coordLayout = coord.getArea();
    else coordLayout = coord.grid.getRect();
    if (isPolar) return {
        cx: coordLayout.cx,
        cy: coordLayout.cy,
        r0: isHorizontalOrRadial ? coordLayout.r0 : layout.r0,
        r: isHorizontalOrRadial ? coordLayout.r : layout.r,
        startAngle: isHorizontalOrRadial ? layout.startAngle : 0,
        endAngle: isHorizontalOrRadial ? layout.endAngle : Math.PI * 2
    };
    else return {
        x: isHorizontalOrRadial ? layout.x : coordLayout.x,
        y: isHorizontalOrRadial ? coordLayout.y : layout.y,
        width: isHorizontalOrRadial ? layout.width : coordLayout.width,
        height: isHorizontalOrRadial ? coordLayout.height : layout.height
    };
}
function $109bc4040f406ce7$var$createBackgroundEl(coord, isHorizontalOrRadial, layout) {
    var ElementClz = coord.type === "polar" ? $4b57d6b582d579b7$exports.Sector : $4b57d6b582d579b7$exports.Rect;
    return new ElementClz({
        shape: $109bc4040f406ce7$var$createBackgroundShape(isHorizontalOrRadial, layout, coord),
        silent: true,
        z2: 0
    });
}
$109bc4040f406ce7$exports = $109bc4040f406ce7$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // In case developer forget to include grid component
$f406636b535430a7$exports.registerLayout($f406636b535430a7$exports.PRIORITY.VISUAL.LAYOUT, $ec279652dd95c27b$export$c3095a23b368d1f2($7f2a79451c5c013b$var$layout, "bar")); // Use higher prority to avoid to be blocked by other overall layout, which do not
// only exist in this module, but probably also exist in other modules, like `barPolar`.
$f406636b535430a7$exports.registerLayout($f406636b535430a7$exports.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, $7f2a79451c5c013b$var$largeLayout);
$f406636b535430a7$exports.registerVisual({
    seriesType: "bar",
    reset: function(seriesModel) {
        // Visual coding for legend
        seriesModel.getData().setVisual("legendSymbol", "roundRect");
    }
});


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $43967943ccba0543$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1dd6d8dd116bcd7f$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $1dd6d8dd116bcd7f$var$extend = $ec279652dd95c27b$export$8b58be045bf06082;
var $1dd6d8dd116bcd7f$var$isArray = $ec279652dd95c27b$export$43bee75e5e14138e;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * [Usage]:
 * (1)
 * createListSimply(seriesModel, ['value']);
 * (2)
 * createListSimply(seriesModel, {
 *     coordDimensions: ['value'],
 *     dimensionsCount: 5
 * });
 *
 * @param {module:echarts/model/Series} seriesModel
 * @param {Object|Array.<string|Object>} opt opt or coordDimensions
 *        The options in opt, see `echarts/data/helper/createDimensions`
 * @param {Array.<string>} [nameList]
 * @return {module:echarts/data/List}
 */ function $1dd6d8dd116bcd7f$var$_default(seriesModel, opt, nameList) {
    opt = $1dd6d8dd116bcd7f$var$isArray(opt) && {
        coordDimensions: opt
    } || $1dd6d8dd116bcd7f$var$extend({}, opt);
    var source = seriesModel.getSource();
    var dimensionsInfo = $c766697b1ee08f64$exports(source, opt);
    var list = new $f643df856475f69e$exports(dimensionsInfo, seriesModel);
    list.initData(source, nameList);
    return list;
}
$1dd6d8dd116bcd7f$exports = $1dd6d8dd116bcd7f$var$_default;





var $43967943ccba0543$var$getPercentWithPrecision = $2d742dbe7f960d8c$export$70cc11b075afeb90;
var $8460a2195ba68c18$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Data selectable mixin for chart series.
 * To eanble data select, option of series must have `selectedMode`.
 * And each data item will use `selected` to toggle itself selected status
 */ var $8460a2195ba68c18$var$_default = {
    /**
   * @param {Array.<Object>} targetList [{name, value, selected}, ...]
   *        If targetList is an array, it should like [{name: ..., value: ...}, ...].
   *        If targetList is a "List", it must have coordDim: 'value' dimension and name.
   */ updateSelectedMap: function(targetList) {
        this._targetList = $ec279652dd95c27b$export$43bee75e5e14138e(targetList) ? targetList.slice() : [];
        this._selectTargetMap = $ec279652dd95c27b$export$533b26079ad0b4b(targetList || [], function(targetMap, target) {
            targetMap.set(target.name, target);
            return targetMap;
        }, $ec279652dd95c27b$export$55f8aa7ef875b0a4());
    },
    /**
   * Either name or id should be passed as input here.
   * If both of them are defined, id is used.
   *
   * @param {string|undefined} name name of data
   * @param {number|undefined} id dataIndex of data
   */ // PENGING If selectedMode is null ?
    select: function(name, id) {
        var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
        var selectedMode = this.get("selectedMode");
        if (selectedMode === "single") this._selectTargetMap.each(function(target) {
            target.selected = false;
        });
        target && (target.selected = true);
    },
    /**
   * Either name or id should be passed as input here.
   * If both of them are defined, id is used.
   *
   * @param {string|undefined} name name of data
   * @param {number|undefined} id dataIndex of data
   */ unSelect: function(name, id) {
        var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name); // var selectedMode = this.get('selectedMode');
        // selectedMode !== 'single' && target && (target.selected = false);
        target && (target.selected = false);
    },
    /**
   * Either name or id should be passed as input here.
   * If both of them are defined, id is used.
   *
   * @param {string|undefined} name name of data
   * @param {number|undefined} id dataIndex of data
   */ toggleSelected: function(name, id) {
        var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
        if (target != null) {
            this[target.selected ? "unSelect" : "select"](name, id);
            return target.selected;
        }
    },
    /**
   * Either name or id should be passed as input here.
   * If both of them are defined, id is used.
   *
   * @param {string|undefined} name name of data
   * @param {number|undefined} id dataIndex of data
   */ isSelected: function(name, id) {
        var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
        return target && target.selected;
    }
};
$8460a2195ba68c18$exports = $8460a2195ba68c18$var$_default;



var $43967943ccba0543$var$retrieveRawAttr = $05c9939f6206d72a$export$c8ae9e77e0ddc42a;

var $43967943ccba0543$var$makeSeriesEncodeForNameBased = $71e1a98f99449cca$export$60b8a57d1f2fed26;
var $6b46bfdbd75036d4$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * LegendVisualProvider is an bridge that pick encoded color from data and
 * provide to the legend component.
 * @param {Function} getDataWithEncodedVisual Function to get data after filtered. It stores all the encoding info
 * @param {Function} getRawData Function to get raw data before filtered.
 */ function $6b46bfdbd75036d4$var$LegendVisualProvider(getDataWithEncodedVisual, getRawData) {
    this.getAllNames = function() {
        var rawData = getRawData(); // We find the name from the raw data. In case it's filtered by the legend component.
        // Normally, the name can be found in rawData, but can't be found in filtered data will display as gray.
        return rawData.mapArray(rawData.getName);
    };
    this.containName = function(name) {
        var rawData = getRawData();
        return rawData.indexOfName(name) >= 0;
    };
    this.indexOfName = function(name) {
        // Only get data when necessary.
        // Because LegendVisualProvider constructor may be new in the stage that data is not prepared yet.
        // Invoking Series#getData immediately will throw an error.
        var dataWithEncodedVisual = getDataWithEncodedVisual();
        return dataWithEncodedVisual.indexOfName(name);
    };
    this.getItemVisual = function(dataIndex, key) {
        // Get encoded visual properties from final filtered data.
        var dataWithEncodedVisual = getDataWithEncodedVisual();
        return dataWithEncodedVisual.getItemVisual(dataIndex, key);
    };
}
var $6b46bfdbd75036d4$var$_default = $6b46bfdbd75036d4$var$LegendVisualProvider;
$6b46bfdbd75036d4$exports = $6b46bfdbd75036d4$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $43967943ccba0543$var$PieSeries = $f406636b535430a7$exports.extendSeriesModel({
    type: "series.pie",
    // Overwrite
    init: function(option) {
        $43967943ccba0543$var$PieSeries.superApply(this, "init", arguments); // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new $6b46bfdbd75036d4$exports($ec279652dd95c27b$export$2385a24977818dd0(this.getData, this), $ec279652dd95c27b$export$2385a24977818dd0(this.getRawData, this));
        this.updateSelectedMap(this._createSelectableList());
        this._defaultLabelLine(option);
    },
    // Overwrite
    mergeOption: function(newOption) {
        $43967943ccba0543$var$PieSeries.superCall(this, "mergeOption", newOption);
        this.updateSelectedMap(this._createSelectableList());
    },
    getInitialData: function(option, ecModel) {
        return $1dd6d8dd116bcd7f$exports(this, {
            coordDimensions: [
                "value"
            ],
            encodeDefaulter: $ec279652dd95c27b$export$c3095a23b368d1f2($43967943ccba0543$var$makeSeriesEncodeForNameBased, this)
        });
    },
    _createSelectableList: function() {
        var data = this.getRawData();
        var valueDim = data.mapDimension("value");
        var targetList = [];
        for(var i = 0, len = data.count(); i < len; i++)targetList.push({
            name: data.getName(i),
            value: data.get(valueDim, i),
            selected: $43967943ccba0543$var$retrieveRawAttr(data, i, "selected")
        });
        return targetList;
    },
    // Overwrite
    getDataParams: function(dataIndex) {
        var data = this.getData();
        var params = $43967943ccba0543$var$PieSeries.superCall(this, "getDataParams", dataIndex); // FIXME toFixed?
        var valueList = [];
        data.each(data.mapDimension("value"), function(value) {
            valueList.push(value);
        });
        params.percent = $43967943ccba0543$var$getPercentWithPrecision(valueList, dataIndex, data.hostModel.get("percentPrecision"));
        params.$vars.push("percent");
        return params;
    },
    _defaultLabelLine: function(option) {
        // Extend labelLine emphasis
        $d559f43cb9041423$export$abdcc6a26372f94b(option, "labelLine", [
            "show"
        ]);
        var labelLineNormalOpt = option.labelLine;
        var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`
        labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
        labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
    },
    defaultOption: {
        zlevel: 0,
        z: 2,
        legendHoverLink: true,
        hoverAnimation: true,
        // 默认全局居中
        center: [
            "50%",
            "50%"
        ],
        radius: [
            0,
            "75%"
        ],
        // 默认顺时针
        clockwise: true,
        startAngle: 90,
        // 最小角度改为0
        minAngle: 0,
        // If the angle of a sector less than `minShowLabelAngle`,
        // the label will not be displayed.
        minShowLabelAngle: 0,
        // 选中时扇区偏移量
        selectedOffset: 10,
        // 高亮扇区偏移量
        hoverOffset: 10,
        // If use strategy to avoid label overlapping
        avoidLabelOverlap: true,
        // 选择模式，默认关闭，可选single，multiple
        // selectedMode: false,
        // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
        // roseType: null,
        percentPrecision: 2,
        // If still show when all data zero.
        stillShowZeroSum: true,
        // cursor: null,
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        width: null,
        height: null,
        label: {
            // If rotate around circle
            rotate: false,
            show: true,
            // 'outer', 'inside', 'center'
            position: "outer",
            // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
            alignTo: "none",
            // Closest distance between label and chart edge.
            // Works only position is 'outer' and alignTo is 'edge'.
            margin: "25%",
            // Works only position is 'outer' and alignTo is not 'edge'.
            bleedMargin: 10,
            // Distance between text and label line.
            distanceToLabelLine: 5 // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
        },
        // Enabled when label.normal.position is 'outer'
        labelLine: {
            show: true,
            // 引导线两段中的第一段长度
            length: 15,
            // 引导线两段中的第二段长度
            length2: 15,
            smooth: false,
            lineStyle: {
                // color: 各异,
                width: 1,
                type: "solid"
            }
        },
        itemStyle: {
            borderWidth: 1
        },
        // Animation type. Valid values: expansion, scale
        animationType: "expansion",
        // Animation type when update. Valid values: transition, expansion
        animationTypeUpdate: "transition",
        animationEasing: "cubicOut"
    }
});
$ec279652dd95c27b$export$e36fc9d62a853069($43967943ccba0543$var$PieSeries, $8460a2195ba68c18$exports);
var $43967943ccba0543$var$_default = $43967943ccba0543$var$PieSeries;
$43967943ccba0543$exports = $43967943ccba0543$var$_default;


var $e8616d1f2bea2390$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @param {module:echarts/model/Series} seriesModel
 * @param {boolean} hasAnimation
 * @inner
 */ function $e8616d1f2bea2390$var$updateDataSelected(uid, seriesModel, hasAnimation, api) {
    var data = seriesModel.getData();
    var dataIndex = this.dataIndex;
    var name = data.getName(dataIndex);
    var selectedOffset = seriesModel.get("selectedOffset");
    api.dispatchAction({
        type: "pieToggleSelect",
        from: uid,
        name: name,
        seriesId: seriesModel.id
    });
    data.each(function(idx) {
        $e8616d1f2bea2390$var$toggleItemSelected(data.getItemGraphicEl(idx), data.getItemLayout(idx), seriesModel.isSelected(data.getName(idx)), selectedOffset, hasAnimation);
    });
}
/**
 * @param {module:zrender/graphic/Sector} el
 * @param {Object} layout
 * @param {boolean} isSelected
 * @param {number} selectedOffset
 * @param {boolean} hasAnimation
 * @inner
 */ function $e8616d1f2bea2390$var$toggleItemSelected(el, layout, isSelected, selectedOffset, hasAnimation) {
    var midAngle = (layout.startAngle + layout.endAngle) / 2;
    var dx = Math.cos(midAngle);
    var dy = Math.sin(midAngle);
    var offset = isSelected ? selectedOffset : 0;
    var position = [
        dx * offset,
        dy * offset
    ];
    hasAnimation // animateTo will stop revious animation like update transition
     ? el.animate().when(200, {
        position: position
    }).start("bounceOut") : el.attr("position", position);
}
/**
 * Piece of pie including Sector, Label, LabelLine
 * @constructor
 * @extends {module:zrender/graphic/Group}
 */ function $e8616d1f2bea2390$var$PiePiece(data, idx) {
    $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4.call(this);
    var sector = new $4b57d6b582d579b7$export$e98c2c7eb2b14f45({
        z2: 2
    });
    var polyline = new $4b57d6b582d579b7$export$79f3ee03e63e7073();
    var text = new $4b57d6b582d579b7$export$5f1af8db9871e1d6();
    this.add(sector);
    this.add(polyline);
    this.add(text);
    this.updateData(data, idx, true);
}
var $e8616d1f2bea2390$var$piePieceProto = $e8616d1f2bea2390$var$PiePiece.prototype;
$e8616d1f2bea2390$var$piePieceProto.updateData = function(data, idx, firstCreate) {
    var sector = this.childAt(0);
    var labelLine = this.childAt(1);
    var labelText = this.childAt(2);
    var seriesModel = data.hostModel;
    var itemModel = data.getItemModel(idx);
    var layout = data.getItemLayout(idx);
    var sectorShape = $ec279652dd95c27b$export$8b58be045bf06082({}, layout);
    sectorShape.label = null;
    var animationTypeUpdate = seriesModel.getShallow("animationTypeUpdate");
    if (firstCreate) {
        sector.setShape(sectorShape);
        var animationType = seriesModel.getShallow("animationType");
        if (animationType === "scale") {
            sector.shape.r = layout.r0;
            $4b57d6b582d579b7$export$a121566aadcfe021(sector, {
                shape: {
                    r: layout.r
                }
            }, seriesModel, idx);
        } else {
            sector.shape.endAngle = layout.startAngle;
            $4b57d6b582d579b7$export$c8dce3c08436e91e(sector, {
                shape: {
                    endAngle: layout.endAngle
                }
            }, seriesModel, idx);
        }
    } else if (animationTypeUpdate === "expansion") // Sectors are set to be target shape and an overlaying clipPath is used for animation
    sector.setShape(sectorShape);
    else // Transition animation from the old shape
    $4b57d6b582d579b7$export$c8dce3c08436e91e(sector, {
        shape: sectorShape
    }, seriesModel, idx);
     // Update common style
    var visualColor = data.getItemVisual(idx, "color");
    sector.useStyle($ec279652dd95c27b$export$ebe90cb607ad99e({
        lineJoin: "bevel",
        fill: visualColor
    }, itemModel.getModel("itemStyle").getItemStyle()));
    sector.hoverStyle = itemModel.getModel("emphasis.itemStyle").getItemStyle();
    var cursorStyle = itemModel.getShallow("cursor");
    cursorStyle && sector.attr("cursor", cursorStyle); // Toggle selected
    $e8616d1f2bea2390$var$toggleItemSelected(this, data.getItemLayout(idx), seriesModel.isSelected(data.getName(idx)), seriesModel.get("selectedOffset"), seriesModel.get("animation")); // Label and text animation should be applied only for transition type animation when update
    var withAnimation = !firstCreate && animationTypeUpdate === "transition";
    this._updateLabel(data, idx, withAnimation);
    this.highDownOnUpdate = !seriesModel.get("silent") ? function(fromState, toState) {
        var hasAnimation = seriesModel.isAnimationEnabled() && itemModel.get("hoverAnimation");
        if (toState === "emphasis") {
            labelLine.ignore = labelLine.hoverIgnore;
            labelText.ignore = labelText.hoverIgnore; // Sector may has animation of updating data. Force to move to the last frame
            // Or it may stopped on the wrong shape
            if (hasAnimation) {
                sector.stopAnimation(true);
                sector.animateTo({
                    shape: {
                        r: layout.r + seriesModel.get("hoverOffset")
                    }
                }, 300, "elasticOut");
            }
        } else {
            labelLine.ignore = labelLine.normalIgnore;
            labelText.ignore = labelText.normalIgnore;
            if (hasAnimation) {
                sector.stopAnimation(true);
                sector.animateTo({
                    shape: {
                        r: layout.r
                    }
                }, 300, "elasticOut");
            }
        }
    } : null;
    $4b57d6b582d579b7$export$28b42df8183f218c(this);
};
$e8616d1f2bea2390$var$piePieceProto._updateLabel = function(data, idx, withAnimation) {
    var labelLine = this.childAt(1);
    var labelText = this.childAt(2);
    var seriesModel = data.hostModel;
    var itemModel = data.getItemModel(idx);
    var layout = data.getItemLayout(idx);
    var labelLayout = layout.label;
    var visualColor = data.getItemVisual(idx, "color");
    if (!labelLayout || isNaN(labelLayout.x) || isNaN(labelLayout.y)) {
        labelText.ignore = labelText.normalIgnore = labelText.hoverIgnore = labelLine.ignore = labelLine.normalIgnore = labelLine.hoverIgnore = true;
        return;
    }
    var targetLineShape = {
        points: labelLayout.linePoints || [
            [
                labelLayout.x,
                labelLayout.y
            ],
            [
                labelLayout.x,
                labelLayout.y
            ],
            [
                labelLayout.x,
                labelLayout.y
            ]
        ]
    };
    var targetTextStyle = {
        x: labelLayout.x,
        y: labelLayout.y
    };
    if (withAnimation) {
        $4b57d6b582d579b7$export$c8dce3c08436e91e(labelLine, {
            shape: targetLineShape
        }, seriesModel, idx);
        $4b57d6b582d579b7$export$c8dce3c08436e91e(labelText, {
            style: targetTextStyle
        }, seriesModel, idx);
    } else {
        labelLine.attr({
            shape: targetLineShape
        });
        labelText.attr({
            style: targetTextStyle
        });
    }
    labelText.attr({
        rotation: labelLayout.rotation,
        origin: [
            labelLayout.x,
            labelLayout.y
        ],
        z2: 10
    });
    var labelModel = itemModel.getModel("label");
    var labelHoverModel = itemModel.getModel("emphasis.label");
    var labelLineModel = itemModel.getModel("labelLine");
    var labelLineHoverModel = itemModel.getModel("emphasis.labelLine");
    var visualColor = data.getItemVisual(idx, "color");
    $4b57d6b582d579b7$export$9a13992917966657(labelText.style, labelText.hoverStyle = {}, labelModel, labelHoverModel, {
        labelFetcher: data.hostModel,
        labelDataIndex: idx,
        defaultText: labelLayout.text,
        autoColor: visualColor,
        useInsideStyle: !!labelLayout.inside
    }, {
        textAlign: labelLayout.textAlign,
        textVerticalAlign: labelLayout.verticalAlign,
        opacity: data.getItemVisual(idx, "opacity")
    });
    labelText.ignore = labelText.normalIgnore = !labelModel.get("show");
    labelText.hoverIgnore = !labelHoverModel.get("show");
    labelLine.ignore = labelLine.normalIgnore = !labelLineModel.get("show");
    labelLine.hoverIgnore = !labelLineHoverModel.get("show"); // Default use item visual color
    labelLine.setStyle({
        stroke: visualColor,
        opacity: data.getItemVisual(idx, "opacity")
    });
    labelLine.setStyle(labelLineModel.getModel("lineStyle").getLineStyle());
    labelLine.hoverStyle = labelLineHoverModel.getModel("lineStyle").getLineStyle();
    var smooth = labelLineModel.get("smooth");
    if (smooth && smooth === true) smooth = 0.4;
    labelLine.setShape({
        smooth: smooth
    });
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($e8616d1f2bea2390$var$PiePiece, $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4); // Pie view
var $e8616d1f2bea2390$var$PieView = $6448f0aa5ca2bdaa$exports.extend({
    type: "pie",
    init: function() {
        var sectorGroup = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
        this._sectorGroup = sectorGroup;
    },
    render: function(seriesModel, ecModel, api, payload) {
        if (payload && payload.from === this.uid) return;
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        var hasAnimation = ecModel.get("animation");
        var isFirstRender = !oldData;
        var animationType = seriesModel.get("animationType");
        var animationTypeUpdate = seriesModel.get("animationTypeUpdate");
        var onSectorClick = $ec279652dd95c27b$export$c3095a23b368d1f2($e8616d1f2bea2390$var$updateDataSelected, this.uid, seriesModel, hasAnimation, api);
        var selectedMode = seriesModel.get("selectedMode");
        data.diff(oldData).add(function(idx) {
            var piePiece = new $e8616d1f2bea2390$var$PiePiece(data, idx); // Default expansion animation
            if (isFirstRender && animationType !== "scale") piePiece.eachChild(function(child) {
                child.stopAnimation(true);
            });
            selectedMode && piePiece.on("click", onSectorClick);
            data.setItemGraphicEl(idx, piePiece);
            group.add(piePiece);
        }).update(function(newIdx, oldIdx) {
            var piePiece = oldData.getItemGraphicEl(oldIdx);
            if (!isFirstRender && animationTypeUpdate !== "transition") piePiece.eachChild(function(child) {
                child.stopAnimation(true);
            });
            piePiece.updateData(data, newIdx);
            piePiece.off("click");
            selectedMode && piePiece.on("click", onSectorClick);
            group.add(piePiece);
            data.setItemGraphicEl(newIdx, piePiece);
        }).remove(function(idx) {
            var piePiece = oldData.getItemGraphicEl(idx);
            group.remove(piePiece);
        }).execute();
        if (hasAnimation && data.count() > 0 && (isFirstRender ? animationType !== "scale" : animationTypeUpdate !== "transition")) {
            var shape = data.getItemLayout(0);
            for(var s = 1; isNaN(shape.startAngle) && s < data.count(); ++s)shape = data.getItemLayout(s);
            var r = Math.max(api.getWidth(), api.getHeight()) / 2;
            var removeClipPath = $ec279652dd95c27b$export$2385a24977818dd0(group.removeClipPath, group);
            group.setClipPath(this._createClipPath(shape.cx, shape.cy, r, shape.startAngle, shape.clockwise, removeClipPath, seriesModel, isFirstRender));
        } else // clipPath is used in first-time animation, so remove it when otherwise. See: #8994
        group.removeClipPath();
        this._data = data;
    },
    dispose: function() {},
    _createClipPath: function(cx, cy, r, startAngle, clockwise, cb, seriesModel, isFirstRender) {
        var clipPath = new $4b57d6b582d579b7$export$e98c2c7eb2b14f45({
            shape: {
                cx: cx,
                cy: cy,
                r0: 0,
                r: r,
                startAngle: startAngle,
                endAngle: startAngle,
                clockwise: clockwise
            }
        });
        var initOrUpdate = isFirstRender ? $4b57d6b582d579b7$export$a121566aadcfe021 : $4b57d6b582d579b7$export$c8dce3c08436e91e;
        initOrUpdate(clipPath, {
            shape: {
                endAngle: startAngle + (clockwise ? 1 : -1) * Math.PI * 2
            }
        }, seriesModel, cb);
        return clipPath;
    },
    /**
   * @implement
   */ containPoint: function(point, seriesModel) {
        var data = seriesModel.getData();
        var itemLayout = data.getItemLayout(0);
        if (itemLayout) {
            var dx = point[0] - itemLayout.cx;
            var dy = point[1] - itemLayout.cy;
            var radius = Math.sqrt(dx * dx + dy * dy);
            return radius <= itemLayout.r && radius >= itemLayout.r0;
        }
    }
});
var $e8616d1f2bea2390$var$_default = $e8616d1f2bea2390$var$PieView;
$e8616d1f2bea2390$exports = $e8616d1f2bea2390$var$_default;


var $0bc18fa5df3b90ab$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $0bc18fa5df3b90ab$var$_default(seriesType, actionInfos) {
    $ec279652dd95c27b$export$79b2f7037acddd43(actionInfos, function(actionInfo) {
        actionInfo.update = "updateView";
        /**
     * @payload
     * @property {string} seriesName
     * @property {string} name
     */ $f406636b535430a7$exports.registerAction(actionInfo, function(payload, ecModel) {
            var selected = {};
            ecModel.eachComponent({
                mainType: "series",
                subType: seriesType,
                query: payload
            }, function(seriesModel) {
                if (seriesModel[actionInfo.method]) seriesModel[actionInfo.method](payload.name, payload.dataIndex);
                var data = seriesModel.getData(); // Create selected map
                data.each(function(idx) {
                    var name = data.getName(idx);
                    selected[name] = seriesModel.isSelected(name) || false;
                });
            });
            return {
                name: payload.name,
                selected: selected,
                seriesId: payload.seriesId
            };
        });
    });
}
$0bc18fa5df3b90ab$exports = $0bc18fa5df3b90ab$var$_default;


var $a6ff2ebba94839b3$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $a6ff2ebba94839b3$var$createHashMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Pick color from palette for each data item.
// Applicable for charts that require applying color palette
// in data level (like pie, funnel, chord).
function $a6ff2ebba94839b3$var$_default(seriesType) {
    return {
        getTargetSeries: function(ecModel) {
            // Pie and funnel may use diferrent scope
            var paletteScope = {};
            var seiresModelMap = $a6ff2ebba94839b3$var$createHashMap();
            ecModel.eachSeriesByType(seriesType, function(seriesModel) {
                seriesModel.__paletteScope = paletteScope;
                seiresModelMap.set(seriesModel.uid, seriesModel);
            });
            return seiresModelMap;
        },
        reset: function(seriesModel, ecModel) {
            var dataAll = seriesModel.getRawData();
            var idxMap = {};
            var data = seriesModel.getData();
            data.each(function(idx) {
                var rawIdx = data.getRawIndex(idx);
                idxMap[rawIdx] = idx;
            });
            dataAll.each(function(rawIdx) {
                var filteredIdx = idxMap[rawIdx]; // If series.itemStyle.normal.color is a function. itemVisual may be encoded
                var singleDataColor = filteredIdx != null && data.getItemVisual(filteredIdx, "color", true);
                var singleDataBorderColor = filteredIdx != null && data.getItemVisual(filteredIdx, "borderColor", true);
                var itemModel;
                if (!singleDataColor || !singleDataBorderColor) // FIXME Performance
                itemModel = dataAll.getItemModel(rawIdx);
                if (!singleDataColor) {
                    var color = itemModel.get("itemStyle.color") || seriesModel.getColorFromPalette(dataAll.getName(rawIdx) || rawIdx + "", seriesModel.__paletteScope, dataAll.count()); // Data is not filtered
                    if (filteredIdx != null) data.setItemVisual(filteredIdx, "color", color);
                }
                if (!singleDataBorderColor) {
                    var borderColor = itemModel.get("itemStyle.borderColor"); // Data is not filtered
                    if (filteredIdx != null) data.setItemVisual(filteredIdx, "borderColor", borderColor);
                }
            });
        }
    };
}
$a6ff2ebba94839b3$exports = $a6ff2ebba94839b3$var$_default;


var $0618bd1e2bfe2bb8$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $0618bd1e2bfe2bb8$var$parsePercent = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f;
var $0618bd1e2bfe2bb8$var$linearMap = $2d742dbe7f960d8c$export$d3f68fbaa670562;

var $f48fede92c90f184$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $f48fede92c90f184$var$parsePercent = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME emphasis label position is not same with normal label position
var $f48fede92c90f184$var$RADIAN = Math.PI / 180;
function $f48fede92c90f184$var$adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight, viewLeft, viewTop, farthestX) {
    list.sort(function(a, b) {
        return a.y - b.y;
    });
    function shiftDown(start, end, delta, dir) {
        for(var j = start; j < end; j++){
            if (list[j].y + delta > viewTop + viewHeight) break;
            list[j].y += delta;
            if (j > start && j + 1 < end && list[j + 1].y > list[j].y + list[j].height) {
                shiftUp(j, delta / 2);
                return;
            }
        }
        shiftUp(end - 1, delta / 2);
    }
    function shiftUp(end, delta) {
        for(var j = end; j >= 0; j--){
            if (list[j].y - delta < viewTop) break;
            list[j].y -= delta;
            if (j > 0 && list[j].y > list[j - 1].y + list[j - 1].height) break;
        }
    }
    function changeX(list, isDownList, cx, cy, r, dir) {
        var lastDeltaX = dir > 0 ? isDownList // right-side
         ? Number.MAX_VALUE // down
         : 0 // up
         : isDownList // left-side
         ? Number.MAX_VALUE // down
         : 0; // up
        for(var i = 0, l = list.length; i < l; i++){
            if (list[i].labelAlignTo !== "none") continue;
            var deltaY = Math.abs(list[i].y - cy);
            var length = list[i].len;
            var length2 = list[i].len2;
            var deltaX = deltaY < r + length ? Math.sqrt((r + length + length2) * (r + length + length2) - deltaY * deltaY) : Math.abs(list[i].x - cx);
            if (isDownList && deltaX >= lastDeltaX) // right-down, left-down
            deltaX = lastDeltaX - 10;
            if (!isDownList && deltaX <= lastDeltaX) // right-up, left-up
            deltaX = lastDeltaX + 10;
            list[i].x = cx + deltaX * dir;
            lastDeltaX = deltaX;
        }
    }
    var lastY = 0;
    var delta;
    var len = list.length;
    var upList = [];
    var downList = [];
    for(var i = 0; i < len; i++){
        if (list[i].position === "outer" && list[i].labelAlignTo === "labelLine") {
            var dx = list[i].x - farthestX;
            list[i].linePoints[1][0] += dx;
            list[i].x = farthestX;
        }
        delta = list[i].y - lastY;
        if (delta < 0) shiftDown(i, len, -delta, dir);
        lastY = list[i].y + list[i].height;
    }
    if (viewHeight - lastY < 0) shiftUp(len - 1, lastY - viewHeight);
    for(var i = 0; i < len; i++)if (list[i].y >= cy) downList.push(list[i]);
    else upList.push(list[i]);
    changeX(upList, false, cx, cy, r, dir);
    changeX(downList, true, cx, cy, r, dir);
}
function $f48fede92c90f184$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop) {
    var leftList = [];
    var rightList = [];
    var leftmostX = Number.MAX_VALUE;
    var rightmostX = -Number.MAX_VALUE;
    for(var i = 0; i < labelLayoutList.length; i++){
        if ($f48fede92c90f184$var$isPositionCenter(labelLayoutList[i])) continue;
        if (labelLayoutList[i].x < cx) {
            leftmostX = Math.min(leftmostX, labelLayoutList[i].x);
            leftList.push(labelLayoutList[i]);
        } else {
            rightmostX = Math.max(rightmostX, labelLayoutList[i].x);
            rightList.push(labelLayoutList[i]);
        }
    }
    $f48fede92c90f184$var$adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight, viewLeft, viewTop, rightmostX);
    $f48fede92c90f184$var$adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight, viewLeft, viewTop, leftmostX);
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        if ($f48fede92c90f184$var$isPositionCenter(layout)) continue;
        var linePoints = layout.linePoints;
        if (linePoints) {
            var isAlignToEdge = layout.labelAlignTo === "edge";
            var realTextWidth = layout.textRect.width;
            var targetTextWidth;
            if (isAlignToEdge) {
                if (layout.x < cx) targetTextWidth = linePoints[2][0] - layout.labelDistance - viewLeft - layout.labelMargin;
                else targetTextWidth = viewLeft + viewWidth - layout.labelMargin - linePoints[2][0] - layout.labelDistance;
            } else if (layout.x < cx) targetTextWidth = layout.x - viewLeft - layout.bleedMargin;
            else targetTextWidth = viewLeft + viewWidth - layout.x - layout.bleedMargin;
            if (targetTextWidth < layout.textRect.width) {
                layout.text = $ebae9c4ebc22906c$export$59a943b34a82e690(layout.text, targetTextWidth, layout.font);
                if (layout.labelAlignTo === "edge") realTextWidth = $ebae9c4ebc22906c$export$3c49c185de0c2bfc(layout.text, layout.font);
            }
            var dist = linePoints[1][0] - linePoints[2][0];
            if (isAlignToEdge) {
                if (layout.x < cx) linePoints[2][0] = viewLeft + layout.labelMargin + realTextWidth + layout.labelDistance;
                else linePoints[2][0] = viewLeft + viewWidth - layout.labelMargin - realTextWidth - layout.labelDistance;
            } else {
                if (layout.x < cx) linePoints[2][0] = layout.x + layout.labelDistance;
                else linePoints[2][0] = layout.x - layout.labelDistance;
                linePoints[1][0] = linePoints[2][0] + dist;
            }
            linePoints[1][1] = linePoints[2][1] = layout.y;
        }
    }
}
function $f48fede92c90f184$var$isPositionCenter(layout) {
    // Not change x for center label
    return layout.position === "center";
}
function $f48fede92c90f184$var$_default(seriesModel, r, viewWidth, viewHeight, viewLeft, viewTop) {
    var data = seriesModel.getData();
    var labelLayoutList = [];
    var cx;
    var cy;
    var hasLabelRotate = false;
    var minShowLabelRadian = (seriesModel.get("minShowLabelAngle") || 0) * $f48fede92c90f184$var$RADIAN;
    data.each(function(idx) {
        var layout = data.getItemLayout(idx);
        var itemModel = data.getItemModel(idx);
        var labelModel = itemModel.getModel("label"); // Use position in normal or emphasis
        var labelPosition = labelModel.get("position") || itemModel.get("emphasis.label.position");
        var labelDistance = labelModel.get("distanceToLabelLine");
        var labelAlignTo = labelModel.get("alignTo");
        var labelMargin = $f48fede92c90f184$var$parsePercent(labelModel.get("margin"), viewWidth);
        var bleedMargin = labelModel.get("bleedMargin");
        var font = labelModel.getFont();
        var labelLineModel = itemModel.getModel("labelLine");
        var labelLineLen = labelLineModel.get("length");
        labelLineLen = $f48fede92c90f184$var$parsePercent(labelLineLen, viewWidth);
        var labelLineLen2 = labelLineModel.get("length2");
        labelLineLen2 = $f48fede92c90f184$var$parsePercent(labelLineLen2, viewWidth);
        if (layout.angle < minShowLabelRadian) return;
        var midAngle = (layout.startAngle + layout.endAngle) / 2;
        var dx = Math.cos(midAngle);
        var dy = Math.sin(midAngle);
        var textX;
        var textY;
        var linePoints;
        var textAlign;
        cx = layout.cx;
        cy = layout.cy;
        var text = seriesModel.getFormattedLabel(idx, "normal") || data.getName(idx);
        var textRect = $ebae9c4ebc22906c$export$c381147bfed79d9f(text, font, textAlign, "top");
        var isLabelInside = labelPosition === "inside" || labelPosition === "inner";
        if (labelPosition === "center") {
            textX = layout.cx;
            textY = layout.cy;
            textAlign = "center";
        } else {
            var x1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dx : layout.r * dx) + cx;
            var y1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dy : layout.r * dy) + cy;
            textX = x1 + dx * 3;
            textY = y1 + dy * 3;
            if (!isLabelInside) {
                // For roseType
                var x2 = x1 + dx * (labelLineLen + r - layout.r);
                var y2 = y1 + dy * (labelLineLen + r - layout.r);
                var x3 = x2 + (dx < 0 ? -1 : 1) * labelLineLen2;
                var y3 = y2;
                if (labelAlignTo === "edge") // Adjust textX because text align of edge is opposite
                textX = dx < 0 ? viewLeft + labelMargin : viewLeft + viewWidth - labelMargin;
                else textX = x3 + (dx < 0 ? -labelDistance : labelDistance);
                textY = y3;
                linePoints = [
                    [
                        x1,
                        y1
                    ],
                    [
                        x2,
                        y2
                    ],
                    [
                        x3,
                        y3
                    ]
                ];
            }
            textAlign = isLabelInside ? "center" : labelAlignTo === "edge" ? dx > 0 ? "right" : "left" : dx > 0 ? "left" : "right";
        }
        var labelRotate;
        var rotate = labelModel.get("rotate");
        if (typeof rotate === "number") labelRotate = rotate * (Math.PI / 180);
        else labelRotate = rotate ? dx < 0 ? -midAngle + Math.PI : -midAngle : 0;
        hasLabelRotate = !!labelRotate;
        layout.label = {
            x: textX,
            y: textY,
            position: labelPosition,
            height: textRect.height,
            len: labelLineLen,
            len2: labelLineLen2,
            linePoints: linePoints,
            textAlign: textAlign,
            verticalAlign: "middle",
            rotation: labelRotate,
            inside: isLabelInside,
            labelDistance: labelDistance,
            labelAlignTo: labelAlignTo,
            labelMargin: labelMargin,
            bleedMargin: bleedMargin,
            textRect: textRect,
            text: text,
            font: font
        }; // Not layout the inside label
        if (!isLabelInside) labelLayoutList.push(layout.label);
    });
    if (!hasLabelRotate && seriesModel.get("avoidLabelOverlap")) $f48fede92c90f184$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop);
}
$f48fede92c90f184$exports = $f48fede92c90f184$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $0618bd1e2bfe2bb8$var$PI2 = Math.PI * 2;
var $0618bd1e2bfe2bb8$var$RADIAN = Math.PI / 180;
function $0618bd1e2bfe2bb8$var$getViewRect(seriesModel, api) {
    return $ab0c9086dd6c5b39$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $0618bd1e2bfe2bb8$var$_default(seriesType, ecModel, api, payload) {
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        var data = seriesModel.getData();
        var valueDim = data.mapDimension("value");
        var viewRect = $0618bd1e2bfe2bb8$var$getViewRect(seriesModel, api);
        var center = seriesModel.get("center");
        var radius = seriesModel.get("radius");
        if (!$ec279652dd95c27b$export$43bee75e5e14138e(radius)) radius = [
            0,
            radius
        ];
        if (!$ec279652dd95c27b$export$43bee75e5e14138e(center)) center = [
            center,
            center
        ];
        var width = $0618bd1e2bfe2bb8$var$parsePercent(viewRect.width, api.getWidth());
        var height = $0618bd1e2bfe2bb8$var$parsePercent(viewRect.height, api.getHeight());
        var size = Math.min(width, height);
        var cx = $0618bd1e2bfe2bb8$var$parsePercent(center[0], width) + viewRect.x;
        var cy = $0618bd1e2bfe2bb8$var$parsePercent(center[1], height) + viewRect.y;
        var r0 = $0618bd1e2bfe2bb8$var$parsePercent(radius[0], size / 2);
        var r = $0618bd1e2bfe2bb8$var$parsePercent(radius[1], size / 2);
        var startAngle = -seriesModel.get("startAngle") * $0618bd1e2bfe2bb8$var$RADIAN;
        var minAngle = seriesModel.get("minAngle") * $0618bd1e2bfe2bb8$var$RADIAN;
        var validDataCount = 0;
        data.each(valueDim, function(value) {
            !isNaN(value) && validDataCount++;
        });
        var sum = data.getSum(valueDim); // Sum may be 0
        var unitRadian = Math.PI / (sum || validDataCount) * 2;
        var clockwise = seriesModel.get("clockwise");
        var roseType = seriesModel.get("roseType");
        var stillShowZeroSum = seriesModel.get("stillShowZeroSum"); // [0...max]
        var extent = data.getDataExtent(valueDim);
        extent[0] = 0; // In the case some sector angle is smaller than minAngle
        var restAngle = $0618bd1e2bfe2bb8$var$PI2;
        var valueSumLargerThanMinAngle = 0;
        var currentAngle = startAngle;
        var dir = clockwise ? 1 : -1;
        data.each(valueDim, function(value, idx) {
            var angle;
            if (isNaN(value)) {
                data.setItemLayout(idx, {
                    angle: NaN,
                    startAngle: NaN,
                    endAngle: NaN,
                    clockwise: clockwise,
                    cx: cx,
                    cy: cy,
                    r0: r0,
                    r: roseType ? NaN : r,
                    viewRect: viewRect
                });
                return;
            } // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？
            if (roseType !== "area") angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
            else angle = $0618bd1e2bfe2bb8$var$PI2 / validDataCount;
            if (angle < minAngle) {
                angle = minAngle;
                restAngle -= minAngle;
            } else valueSumLargerThanMinAngle += value;
            var endAngle = currentAngle + dir * angle;
            data.setItemLayout(idx, {
                angle: angle,
                startAngle: currentAngle,
                endAngle: endAngle,
                clockwise: clockwise,
                cx: cx,
                cy: cy,
                r0: r0,
                r: roseType ? $0618bd1e2bfe2bb8$var$linearMap(value, extent, [
                    r0,
                    r
                ]) : r,
                viewRect: viewRect
            });
            currentAngle = endAngle;
        }); // Some sector is constrained by minAngle
        // Rest sectors needs recalculate angle
        if (restAngle < $0618bd1e2bfe2bb8$var$PI2 && validDataCount) {
            // Average the angle if rest angle is not enough after all angles is
            // Constrained by minAngle
            if (restAngle <= 1e-3) {
                var angle = $0618bd1e2bfe2bb8$var$PI2 / validDataCount;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout = data.getItemLayout(idx);
                        layout.angle = angle;
                        layout.startAngle = startAngle + dir * idx * angle;
                        layout.endAngle = startAngle + dir * (idx + 1) * angle;
                    }
                });
            } else {
                unitRadian = restAngle / valueSumLargerThanMinAngle;
                currentAngle = startAngle;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout = data.getItemLayout(idx);
                        var angle = layout.angle === minAngle ? minAngle : value * unitRadian;
                        layout.startAngle = currentAngle;
                        layout.endAngle = currentAngle + dir * angle;
                        currentAngle += dir * angle;
                    }
                });
            }
        }
        $f48fede92c90f184$exports(seriesModel, r, viewRect.width, viewRect.height, viewRect.x, viewRect.y);
    });
}
$0618bd1e2bfe2bb8$exports = $0618bd1e2bfe2bb8$var$_default;


var $334937e6881c9447$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $334937e6881c9447$var$_default(seriesType) {
    return {
        seriesType: seriesType,
        reset: function(seriesModel, ecModel) {
            var legendModels = ecModel.findComponents({
                mainType: "legend"
            });
            if (!legendModels || !legendModels.length) return;
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                var name = data.getName(idx); // If in any legend component the status is not selected.
                for(var i = 0; i < legendModels.length; i++){
                    if (!legendModels[i].isSelected(name)) return false;
                }
                return true;
            });
        }
    };
}
$334937e6881c9447$exports = $334937e6881c9447$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $0bc18fa5df3b90ab$exports("pie", [
    {
        type: "pieToggleSelect",
        event: "pieselectchanged",
        method: "toggleSelected"
    },
    {
        type: "pieSelect",
        event: "pieselected",
        method: "select"
    },
    {
        type: "pieUnSelect",
        event: "pieunselected",
        method: "unSelect"
    }
]);
$f406636b535430a7$exports.registerVisual($a6ff2ebba94839b3$exports("pie"));
$f406636b535430a7$exports.registerLayout($ec279652dd95c27b$export$c3095a23b368d1f2($0618bd1e2bfe2bb8$exports, "pie"));
$f406636b535430a7$exports.registerProcessor($334937e6881c9447$exports("pie"));


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1e4c7a78dc97a054$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $1e4c7a78dc97a054$var$_default = $70847df98016d69d$exports.extend({
    type: "series.scatter",
    dependencies: [
        "grid",
        "polar",
        "geo",
        "singleAxis",
        "calendar"
    ],
    getInitialData: function(option, ecModel) {
        return $10e48b57e44af7c1$exports(this.getSource(), this, {
            useEncodeDefaulter: true
        });
    },
    brushSelector: "point",
    getProgressive: function() {
        var progressive = this.option.progressive;
        if (progressive == null) // PENDING
        return this.option.large ? 5e3 : this.get("progressive");
        return progressive;
    },
    getProgressiveThreshold: function() {
        var progressiveThreshold = this.option.progressiveThreshold;
        if (progressiveThreshold == null) // PENDING
        return this.option.large ? 1e4 : this.get("progressiveThreshold");
        return progressiveThreshold;
    },
    defaultOption: {
        coordinateSystem: "cartesian2d",
        zlevel: 0,
        z: 2,
        legendHoverLink: true,
        hoverAnimation: true,
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // Polar coordinate system
        // polarIndex: 0,
        // Geo coordinate system
        // geoIndex: 0,
        // symbol: null,        // 图形类型
        symbolSize: 10,
        // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
        // symbolRotate: null,  // 图形旋转控制
        large: false,
        // Available when large is true
        largeThreshold: 2000,
        // cursor: null,
        // label: {
        // show: false
        // distance: 5,
        // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
        // position: 默认自适应，水平布局为'top'，垂直布局为'right'，可选为
        //           'inside'|'left'|'right'|'top'|'bottom'
        // 默认使用全局文本样式，详见TEXTSTYLE
        // },
        itemStyle: {
            opacity: 0.8 // color: 各异
        },
        // If clip the overflow graphics
        // Works on cartesian / polar series
        clip: true // progressive: null
    }
});
$1e4c7a78dc97a054$exports = $1e4c7a78dc97a054$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $026f278a9478d862$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $026f278a9478d862$var$createSymbol = $804dcb9a0b78b5fe$export$af050e04da3a02e8;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Float32Array */ // TODO Batch by color
var $026f278a9478d862$var$BOOST_SIZE_THRESHOLD = 4;
var $026f278a9478d862$var$LargeSymbolPath = $4b57d6b582d579b7$export$d0d5398c9d612037({
    shape: {
        points: null
    },
    symbolProxy: null,
    softClipShape: null,
    buildPath: function(path, shape) {
        var points = shape.points;
        var size = shape.size;
        var symbolProxy = this.symbolProxy;
        var symbolProxyShape = symbolProxy.shape;
        var ctx = path.getContext ? path.getContext() : path;
        var canBoost = ctx && size[0] < $026f278a9478d862$var$BOOST_SIZE_THRESHOLD; // Do draw in afterBrush.
        if (canBoost) return;
        for(var i = 0; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (isNaN(x) || isNaN(y)) continue;
            if (this.softClipShape && !this.softClipShape.contain(x, y)) continue;
            symbolProxyShape.x = x - size[0] / 2;
            symbolProxyShape.y = y - size[1] / 2;
            symbolProxyShape.width = size[0];
            symbolProxyShape.height = size[1];
            symbolProxy.buildPath(path, symbolProxyShape, true);
        }
    },
    afterBrush: function(ctx) {
        var shape = this.shape;
        var points = shape.points;
        var size = shape.size;
        var canBoost = size[0] < $026f278a9478d862$var$BOOST_SIZE_THRESHOLD;
        if (!canBoost) return;
        this.setTransform(ctx); // PENDING If style or other canvas status changed?
        for(var i = 0; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (isNaN(x) || isNaN(y)) continue;
            if (this.softClipShape && !this.softClipShape.contain(x, y)) continue;
             // fillRect is faster than building a rect path and draw.
            // And it support light globalCompositeOperation.
            ctx.fillRect(x - size[0] / 2, y - size[1] / 2, size[0], size[1]);
        }
        this.restoreTransform(ctx);
    },
    findDataIndex: function(x, y) {
        // TODO ???
        // Consider transform
        var shape = this.shape;
        var points = shape.points;
        var size = shape.size;
        var w = Math.max(size[0], 4);
        var h = Math.max(size[1], 4); // Not consider transform
        // Treat each element as a rect
        // top down traverse
        for(var idx = points.length / 2 - 1; idx >= 0; idx--){
            var i = idx * 2;
            var x0 = points[i] - w / 2;
            var y0 = points[i + 1] - h / 2;
            if (x >= x0 && y >= y0 && x <= x0 + w && y <= y0 + h) return idx;
        }
        return -1;
    }
});
function $026f278a9478d862$var$LargeSymbolDraw() {
    this.group = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
}
var $026f278a9478d862$var$largeSymbolProto = $026f278a9478d862$var$LargeSymbolDraw.prototype;
$026f278a9478d862$var$largeSymbolProto.isPersistent = function() {
    return !this._incremental;
};
/**
 * Update symbols draw by new data
 * @param {module:echarts/data/List} data
 * @param {Object} opt
 * @param {Object} [opt.clipShape]
 */ $026f278a9478d862$var$largeSymbolProto.updateData = function(data, opt) {
    this.group.removeAll();
    var symbolEl = new $026f278a9478d862$var$LargeSymbolPath({
        rectHover: true,
        cursor: "default"
    });
    symbolEl.setShape({
        points: data.getLayout("symbolPoints")
    });
    this._setCommon(symbolEl, data, false, opt);
    this.group.add(symbolEl);
    this._incremental = null;
};
$026f278a9478d862$var$largeSymbolProto.updateLayout = function(data) {
    if (this._incremental) return;
    var points = data.getLayout("symbolPoints");
    this.group.eachChild(function(child) {
        if (child.startIndex != null) {
            var len = (child.endIndex - child.startIndex) * 2;
            var byteOffset = child.startIndex * 8;
            points = new Float32Array(points.buffer, byteOffset, len);
        }
        child.setShape("points", points);
    });
};
$026f278a9478d862$var$largeSymbolProto.incrementalPrepareUpdate = function(data) {
    this.group.removeAll();
    this._clearIncremental(); // Only use incremental displayables when data amount is larger than 2 million.
    // PENDING Incremental data?
    if (data.count() > 2e6) {
        if (!this._incremental) this._incremental = new $06c8a3923ade9f4d$exports({
            silent: true
        });
        this.group.add(this._incremental);
    } else this._incremental = null;
};
$026f278a9478d862$var$largeSymbolProto.incrementalUpdate = function(taskParams, data, opt) {
    var symbolEl;
    if (this._incremental) {
        symbolEl = new $026f278a9478d862$var$LargeSymbolPath();
        this._incremental.addDisplayable(symbolEl, true);
    } else {
        symbolEl = new $026f278a9478d862$var$LargeSymbolPath({
            rectHover: true,
            cursor: "default",
            startIndex: taskParams.start,
            endIndex: taskParams.end
        });
        symbolEl.incremental = true;
        this.group.add(symbolEl);
    }
    symbolEl.setShape({
        points: data.getLayout("symbolPoints")
    });
    this._setCommon(symbolEl, data, !!this._incremental, opt);
};
$026f278a9478d862$var$largeSymbolProto._setCommon = function(symbolEl, data, isIncremental, opt) {
    var hostModel = data.hostModel;
    opt = opt || {}; // TODO
    // if (data.hasItemVisual.symbolSize) {
    //     // TODO typed array?
    //     symbolEl.setShape('sizes', data.mapArray(
    //         function (idx) {
    //             var size = data.getItemVisual(idx, 'symbolSize');
    //             return (size instanceof Array) ? size : [size, size];
    //         }
    //     ));
    // }
    // else {
    var size = data.getVisual("symbolSize");
    symbolEl.setShape("size", size instanceof Array ? size : [
        size,
        size
    ]); // }
    symbolEl.softClipShape = opt.clipShape || null; // Create symbolProxy to build path for each data
    symbolEl.symbolProxy = $026f278a9478d862$var$createSymbol(data.getVisual("symbol"), 0, 0, 0, 0); // Use symbolProxy setColor method
    symbolEl.setColor = symbolEl.symbolProxy.setColor;
    var extrudeShadow = symbolEl.shape.size[0] < $026f278a9478d862$var$BOOST_SIZE_THRESHOLD;
    symbolEl.useStyle(hostModel.getModel("itemStyle").getItemStyle(extrudeShadow ? [
        "color",
        "shadowBlur",
        "shadowColor"
    ] : [
        "color"
    ]));
    var visualColor = data.getVisual("color");
    if (visualColor) symbolEl.setColor(visualColor);
    if (!isIncremental) {
        // Enable tooltip
        // PENDING May have performance issue when path is extremely large
        symbolEl.seriesIndex = hostModel.seriesIndex;
        symbolEl.on("mousemove", function(e) {
            symbolEl.dataIndex = null;
            var dataIndex = symbolEl.findDataIndex(e.offsetX, e.offsetY);
            if (dataIndex >= 0) // Provide dataIndex for tooltip
            symbolEl.dataIndex = dataIndex + (symbolEl.startIndex || 0);
        });
    }
};
$026f278a9478d862$var$largeSymbolProto.remove = function() {
    this._clearIncremental();
    this._incremental = null;
    this.group.removeAll();
};
$026f278a9478d862$var$largeSymbolProto._clearIncremental = function() {
    var incremental = this._incremental;
    if (incremental) incremental.clearDisplaybles();
};
var $026f278a9478d862$var$_default = $026f278a9478d862$var$LargeSymbolDraw;
$026f278a9478d862$exports = $026f278a9478d862$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.extendChartView({
    type: "scatter",
    render: function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
        symbolDraw.updateData(data, {
            // TODO
            // If this parameter should be a shape or a bounding volume
            // shape will be more general.
            // But bounding volume like bounding rect will be much faster in the contain calculation
            clipShape: this._getClipShape(seriesModel)
        });
        this._finished = true;
    },
    incrementalPrepareRender: function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
        symbolDraw.incrementalPrepareUpdate(data);
        this._finished = false;
    },
    incrementalRender: function(taskParams, seriesModel, ecModel) {
        this._symbolDraw.incrementalUpdate(taskParams, seriesModel.getData(), {
            clipShape: this._getClipShape(seriesModel)
        });
        this._finished = taskParams.end === seriesModel.getData().count();
    },
    updateTransform: function(seriesModel, ecModel, api) {
        var data = seriesModel.getData(); // Must mark group dirty and make sure the incremental layer will be cleared
        // PENDING
        this.group.dirty();
        if (!this._finished || data.count() > 1e4 || !this._symbolDraw.isPersistent()) return {
            update: true
        };
        else {
            var res = $c76a359a25b70ceb$exports().reset(seriesModel);
            if (res.progress) res.progress({
                start: 0,
                end: data.count()
            }, data);
            this._symbolDraw.updateLayout(data);
        }
    },
    _getClipShape: function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
        return seriesModel.get("clip", true) ? clipArea : null;
    },
    _updateSymbolDraw: function(data, seriesModel) {
        var symbolDraw = this._symbolDraw;
        var pipelineContext = seriesModel.pipelineContext;
        var isLargeDraw = pipelineContext.large;
        if (!symbolDraw || isLargeDraw !== this._isLargeDraw) {
            symbolDraw && symbolDraw.remove();
            symbolDraw = this._symbolDraw = isLargeDraw ? new $026f278a9478d862$exports() : new $e99d13e2181fb062$exports();
            this._isLargeDraw = isLargeDraw;
            this.group.removeAll();
        }
        this.group.add(symbolDraw.group);
        return symbolDraw;
    },
    remove: function(ecModel, api) {
        this._symbolDraw && this._symbolDraw.remove(true);
        this._symbolDraw = null;
    },
    dispose: function() {}
});





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // import * as zrUtil from 'zrender/src/core/util';
// In case developer forget to include grid component
$f406636b535430a7$exports.registerVisual($6efa4c3507ca2b4d$exports("scatter", "circle"));
$f406636b535430a7$exports.registerLayout($c76a359a25b70ceb$exports("scatter")); // echarts.registerProcessor(function (ecModel, api) {
 //     ecModel.eachSeriesByType('scatter', function (seriesModel) {
 //         var data = seriesModel.getData();
 //         var coordSys = seriesModel.coordinateSystem;
 //         if (coordSys.type !== 'geo') {
 //             return;
 //         }
 //         var startPt = coordSys.pointToData([0, 0]);
 //         var endPt = coordSys.pointToData([api.getWidth(), api.getHeight()]);
 //         var dims = zrUtil.map(coordSys.dimensions, function (dim) {
 //             return data.mapDimension(dim);
 //         });
 //         var range = {};
 //         range[dims[0]] = [Math.min(startPt[0], endPt[0]), Math.max(startPt[0], endPt[0])];
 //         range[dims[1]] = [Math.min(startPt[1], endPt[1]), Math.max(startPt[1], endPt[1])];
 //         data.selectRange(range);
 //     });
 // });


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $9b64f700f9f8a64f$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bc746b8bf990f8bf$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $bc746b8bf990f8bf$var$IndicatorAxis(dim, scale, radiusExtent) {
    $95e1f94acccc578d$exports.call(this, dim, scale, radiusExtent);
    /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */ this.type = "value";
    this.angle = 0;
    /**
   * Indicator name
   * @type {string}
   */ this.name = "";
    /**
   * @type {module:echarts/model/Model}
   */ this.model;
}
$ec279652dd95c27b$export$69f1b2dcda23c5f8($bc746b8bf990f8bf$var$IndicatorAxis, $95e1f94acccc578d$exports);
var $bc746b8bf990f8bf$var$_default = $bc746b8bf990f8bf$var$IndicatorAxis;
$bc746b8bf990f8bf$exports = $bc746b8bf990f8bf$var$_default;





var $9b64f700f9f8a64f$var$getScaleExtent = $13542623aa20eeae$export$9c0ba8df7eb7b328;
var $9b64f700f9f8a64f$var$niceScaleExtent = $13542623aa20eeae$export$51f3e70a54405d5a;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO clockwise
function $9b64f700f9f8a64f$var$Radar(radarModel, ecModel, api) {
    this._model = radarModel;
    /**
   * Radar dimensions
   * @type {Array.<string>}
   */ this.dimensions = [];
    this._indicatorAxes = $ec279652dd95c27b$export$871de8747c9eaa88(radarModel.getIndicatorModels(), function(indicatorModel, idx) {
        var dim = "indicator_" + idx;
        var indicatorAxis = new $bc746b8bf990f8bf$exports(dim, indicatorModel.get("axisType") === "log" ? new $8c161e42bb81a4d8$exports() : new $d31daeaa402f1a9c$exports());
        indicatorAxis.name = indicatorModel.get("name"); // Inject model and axis
        indicatorAxis.model = indicatorModel;
        indicatorModel.axis = indicatorAxis;
        this.dimensions.push(dim);
        return indicatorAxis;
    }, this);
    this.resize(radarModel, api);
    /**
   * @type {number}
   * @readOnly
   */ this.cx;
    /**
   * @type {number}
   * @readOnly
   */ this.cy;
    /**
   * @type {number}
   * @readOnly
   */ this.r;
    /**
   * @type {number}
   * @readOnly
   */ this.r0;
    /**
   * @type {number}
   * @readOnly
   */ this.startAngle;
}
$9b64f700f9f8a64f$var$Radar.prototype.getIndicatorAxes = function() {
    return this._indicatorAxes;
};
$9b64f700f9f8a64f$var$Radar.prototype.dataToPoint = function(value, indicatorIndex) {
    var indicatorAxis = this._indicatorAxes[indicatorIndex];
    return this.coordToPoint(indicatorAxis.dataToCoord(value), indicatorIndex);
};
$9b64f700f9f8a64f$var$Radar.prototype.coordToPoint = function(coord, indicatorIndex) {
    var indicatorAxis = this._indicatorAxes[indicatorIndex];
    var angle = indicatorAxis.angle;
    var x = this.cx + coord * Math.cos(angle);
    var y = this.cy - coord * Math.sin(angle);
    return [
        x,
        y
    ];
};
$9b64f700f9f8a64f$var$Radar.prototype.pointToData = function(pt) {
    var dx = pt[0] - this.cx;
    var dy = pt[1] - this.cy;
    var radius = Math.sqrt(dx * dx + dy * dy);
    dx /= radius;
    dy /= radius;
    var radian = Math.atan2(-dy, dx); // Find the closest angle
    // FIXME index can calculated directly
    var minRadianDiff = Infinity;
    var closestAxis;
    var closestAxisIdx = -1;
    for(var i = 0; i < this._indicatorAxes.length; i++){
        var indicatorAxis = this._indicatorAxes[i];
        var diff = Math.abs(radian - indicatorAxis.angle);
        if (diff < minRadianDiff) {
            closestAxis = indicatorAxis;
            closestAxisIdx = i;
            minRadianDiff = diff;
        }
    }
    return [
        closestAxisIdx,
        +(closestAxis && closestAxis.coordToData(radius))
    ];
};
$9b64f700f9f8a64f$var$Radar.prototype.resize = function(radarModel, api) {
    var center = radarModel.get("center");
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    var viewSize = Math.min(viewWidth, viewHeight) / 2;
    this.cx = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(center[0], viewWidth);
    this.cy = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(center[1], viewHeight);
    this.startAngle = radarModel.get("startAngle") * Math.PI / 180; // radius may be single value like `20`, `'80%'`, or array like `[10, '80%']`
    var radius = radarModel.get("radius");
    if (typeof radius === "string" || typeof radius === "number") radius = [
        0,
        radius
    ];
    this.r0 = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(radius[0], viewSize);
    this.r = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(radius[1], viewSize);
    $ec279652dd95c27b$export$79b2f7037acddd43(this._indicatorAxes, function(indicatorAxis, idx) {
        indicatorAxis.setExtent(this.r0, this.r);
        var angle = this.startAngle + idx * Math.PI * 2 / this._indicatorAxes.length; // Normalize to [-PI, PI]
        angle = Math.atan2(Math.sin(angle), Math.cos(angle));
        indicatorAxis.angle = angle;
    }, this);
};
$9b64f700f9f8a64f$var$Radar.prototype.update = function(ecModel, api) {
    var indicatorAxes = this._indicatorAxes;
    var radarModel = this._model;
    $ec279652dd95c27b$export$79b2f7037acddd43(indicatorAxes, function(indicatorAxis) {
        indicatorAxis.scale.setExtent(Infinity, -Infinity);
    });
    ecModel.eachSeriesByType("radar", function(radarSeries, idx) {
        if (radarSeries.get("coordinateSystem") !== "radar" || ecModel.getComponent("radar", radarSeries.get("radarIndex")) !== radarModel) return;
        var data = radarSeries.getData();
        $ec279652dd95c27b$export$79b2f7037acddd43(indicatorAxes, function(indicatorAxis) {
            indicatorAxis.scale.unionExtentFromData(data, data.mapDimension(indicatorAxis.dim));
        });
    }, this);
    var splitNumber = radarModel.get("splitNumber");
    function increaseInterval(interval) {
        var exp10 = Math.pow(10, Math.floor(Math.log(interval) / Math.LN10)); // Increase interval
        var f = interval / exp10;
        if (f === 2) f = 5;
        else // f is 2 or 5
        f *= 2;
        return f * exp10;
    } // Force all the axis fixing the maxSplitNumber.
    $ec279652dd95c27b$export$79b2f7037acddd43(indicatorAxes, function(indicatorAxis, idx) {
        var rawExtent = $9b64f700f9f8a64f$var$getScaleExtent(indicatorAxis.scale, indicatorAxis.model).extent;
        $9b64f700f9f8a64f$var$niceScaleExtent(indicatorAxis.scale, indicatorAxis.model);
        var axisModel = indicatorAxis.model;
        var scale = indicatorAxis.scale;
        var fixedMin = axisModel.getMin();
        var fixedMax = axisModel.getMax();
        var interval = scale.getInterval();
        if (fixedMin != null && fixedMax != null) {
            // User set min, max, divide to get new interval
            scale.setExtent(+fixedMin, +fixedMax);
            scale.setInterval((fixedMax - fixedMin) / splitNumber);
        } else if (fixedMin != null) {
            var max; // User set min, expand extent on the other side
            do {
                max = fixedMin + interval * splitNumber;
                scale.setExtent(+fixedMin, max); // Interval must been set after extent
                // FIXME
                scale.setInterval(interval);
                interval = increaseInterval(interval);
            }while (max < rawExtent[1] && isFinite(max) && isFinite(rawExtent[1]));
        } else if (fixedMax != null) {
            var min; // User set min, expand extent on the other side
            do {
                min = fixedMax - interval * splitNumber;
                scale.setExtent(min, +fixedMax);
                scale.setInterval(interval);
                interval = increaseInterval(interval);
            }while (min > rawExtent[0] && isFinite(min) && isFinite(rawExtent[0]));
        } else {
            var nicedSplitNumber = scale.getTicks().length - 1;
            if (nicedSplitNumber > splitNumber) interval = increaseInterval(interval);
             // TODO
            var max = Math.ceil(rawExtent[1] / interval) * interval;
            var min = $2d742dbe7f960d8c$export$2077e0241d6afd3c(max - interval * splitNumber);
            scale.setExtent(min, max);
            scale.setInterval(interval);
        }
    });
};
/**
 * Radar dimensions is based on the data
 * @type {Array}
 */ $9b64f700f9f8a64f$var$Radar.dimensions = [];
$9b64f700f9f8a64f$var$Radar.create = function(ecModel, api) {
    var radarList = [];
    ecModel.eachComponent("radar", function(radarModel) {
        var radar = new $9b64f700f9f8a64f$var$Radar(radarModel, ecModel, api);
        radarList.push(radar);
        radarModel.coordinateSystem = radar;
    });
    ecModel.eachSeriesByType("radar", function(radarSeries) {
        if (radarSeries.get("coordinateSystem") === "radar") // Inject coordinate system
        radarSeries.coordinateSystem = radarList[radarSeries.get("radarIndex") || 0];
    });
    return radarList;
};
$9c36d0fff3b0f387$exports.register("radar", $9b64f700f9f8a64f$var$Radar);
var $9b64f700f9f8a64f$var$_default = $9b64f700f9f8a64f$var$Radar;
$9b64f700f9f8a64f$exports = $9b64f700f9f8a64f$var$_default;


var $ae43fd16a0ec50f3$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $ae43fd16a0ec50f3$var$valueAxisDefault = $42af304458b85594$exports.valueAxis;
function $ae43fd16a0ec50f3$var$defaultsShow(opt, show) {
    return $ec279652dd95c27b$export$ebe90cb607ad99e({
        show: show
    }, opt);
}
var $ae43fd16a0ec50f3$var$RadarModel = $f406636b535430a7$exports.extendComponentModel({
    type: "radar",
    optionUpdated: function() {
        var boundaryGap = this.get("boundaryGap");
        var splitNumber = this.get("splitNumber");
        var scale = this.get("scale");
        var axisLine = this.get("axisLine");
        var axisTick = this.get("axisTick");
        var axisType = this.get("axisType");
        var axisLabel = this.get("axisLabel");
        var nameTextStyle = this.get("name");
        var showName = this.get("name.show");
        var nameFormatter = this.get("name.formatter");
        var nameGap = this.get("nameGap");
        var triggerEvent = this.get("triggerEvent");
        var indicatorModels = $ec279652dd95c27b$export$871de8747c9eaa88(this.get("indicator") || [], function(indicatorOpt) {
            // PENDING
            if (indicatorOpt.max != null && indicatorOpt.max > 0 && !indicatorOpt.min) indicatorOpt.min = 0;
            else if (indicatorOpt.min != null && indicatorOpt.min < 0 && !indicatorOpt.max) indicatorOpt.max = 0;
            var iNameTextStyle = nameTextStyle;
            if (indicatorOpt.color != null) iNameTextStyle = $ec279652dd95c27b$export$ebe90cb607ad99e({
                color: indicatorOpt.color
            }, nameTextStyle);
             // Use same configuration
            indicatorOpt = $ec279652dd95c27b$export$4950aa0f605343fb($ec279652dd95c27b$export$9cd59f9826255e47(indicatorOpt), {
                boundaryGap: boundaryGap,
                splitNumber: splitNumber,
                scale: scale,
                axisLine: axisLine,
                axisTick: axisTick,
                axisType: axisType,
                axisLabel: axisLabel,
                // Compatible with 2 and use text
                name: indicatorOpt.text,
                nameLocation: "end",
                nameGap: nameGap,
                // min: 0,
                nameTextStyle: iNameTextStyle,
                triggerEvent: triggerEvent
            }, false);
            if (!showName) indicatorOpt.name = "";
            if (typeof nameFormatter === "string") {
                var indName = indicatorOpt.name;
                indicatorOpt.name = nameFormatter.replace("{value}", indName != null ? indName : "");
            } else if (typeof nameFormatter === "function") indicatorOpt.name = nameFormatter(indicatorOpt.name, indicatorOpt);
            var model = $ec279652dd95c27b$export$8b58be045bf06082(new $2b51b4bf776ec22e$exports(indicatorOpt, null, this.ecModel), $ce1d0648e3723c9f$exports); // For triggerEvent.
            model.mainType = "radar";
            model.componentIndex = this.componentIndex;
            return model;
        }, this);
        this.getIndicatorModels = function() {
            return indicatorModels;
        };
    },
    defaultOption: {
        zlevel: 0,
        z: 0,
        center: [
            "50%",
            "50%"
        ],
        radius: "75%",
        startAngle: 90,
        name: {
            show: true // formatter: null
        },
        boundaryGap: [
            0,
            0
        ],
        splitNumber: 5,
        nameGap: 15,
        scale: false,
        // Polygon or circle
        shape: "polygon",
        axisLine: $ec279652dd95c27b$export$4950aa0f605343fb({
            lineStyle: {
                color: "#bbb"
            }
        }, $ae43fd16a0ec50f3$var$valueAxisDefault.axisLine),
        axisLabel: $ae43fd16a0ec50f3$var$defaultsShow($ae43fd16a0ec50f3$var$valueAxisDefault.axisLabel, false),
        axisTick: $ae43fd16a0ec50f3$var$defaultsShow($ae43fd16a0ec50f3$var$valueAxisDefault.axisTick, false),
        axisType: "interval",
        splitLine: $ae43fd16a0ec50f3$var$defaultsShow($ae43fd16a0ec50f3$var$valueAxisDefault.splitLine, true),
        splitArea: $ae43fd16a0ec50f3$var$defaultsShow($ae43fd16a0ec50f3$var$valueAxisDefault.splitArea, true),
        // {text, min, max}
        indicator: []
    }
});
var $ae43fd16a0ec50f3$var$_default = $ae43fd16a0ec50f3$var$RadarModel;
$ae43fd16a0ec50f3$exports = $ae43fd16a0ec50f3$var$_default;


var $1cd023934deb0a27$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1cd023934deb0a27$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $1cd023934deb0a27$var$axisBuilderAttrs = [
    "axisLine",
    "axisTickLabel",
    "axisName"
];
var $1cd023934deb0a27$var$_default = $f406636b535430a7$exports.extendComponentView({
    type: "radar",
    render: function(radarModel, ecModel, api) {
        var group = this.group;
        group.removeAll();
        this._buildAxes(radarModel);
        this._buildSplitLineAndArea(radarModel);
    },
    _buildAxes: function(radarModel) {
        var radar = radarModel.coordinateSystem;
        var indicatorAxes = radar.getIndicatorAxes();
        var axisBuilders = $ec279652dd95c27b$export$871de8747c9eaa88(indicatorAxes, function(indicatorAxis) {
            var axisBuilder = new $3ce77a4133d2c8eb$exports(indicatorAxis.model, {
                position: [
                    radar.cx,
                    radar.cy
                ],
                rotation: indicatorAxis.angle,
                labelDirection: -1,
                tickDirection: -1,
                nameDirection: 1
            });
            return axisBuilder;
        });
        $ec279652dd95c27b$export$79b2f7037acddd43(axisBuilders, function(axisBuilder) {
            $ec279652dd95c27b$export$79b2f7037acddd43($1cd023934deb0a27$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
            this.group.add(axisBuilder.getGroup());
        }, this);
    },
    _buildSplitLineAndArea: function(radarModel) {
        var radar = radarModel.coordinateSystem;
        var indicatorAxes = radar.getIndicatorAxes();
        if (!indicatorAxes.length) return;
        var shape = radarModel.get("shape");
        var splitLineModel = radarModel.getModel("splitLine");
        var splitAreaModel = radarModel.getModel("splitArea");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var areaStyleModel = splitAreaModel.getModel("areaStyle");
        var showSplitLine = splitLineModel.get("show");
        var showSplitArea = splitAreaModel.get("show");
        var splitLineColors = lineStyleModel.get("color");
        var splitAreaColors = areaStyleModel.get("color");
        splitLineColors = $ec279652dd95c27b$export$43bee75e5e14138e(splitLineColors) ? splitLineColors : [
            splitLineColors
        ];
        splitAreaColors = $ec279652dd95c27b$export$43bee75e5e14138e(splitAreaColors) ? splitAreaColors : [
            splitAreaColors
        ];
        var splitLines = [];
        var splitAreas = [];
        function getColorIndex(areaOrLine, areaOrLineColorList, idx) {
            var colorIndex = idx % areaOrLineColorList.length;
            areaOrLine[colorIndex] = areaOrLine[colorIndex] || [];
            return colorIndex;
        }
        if (shape === "circle") {
            var ticksRadius = indicatorAxes[0].getTicksCoords();
            var cx = radar.cx;
            var cy = radar.cy;
            for(var i = 0; i < ticksRadius.length; i++){
                if (showSplitLine) {
                    var colorIndex = getColorIndex(splitLines, splitLineColors, i);
                    splitLines[colorIndex].push(new $4b57d6b582d579b7$export$c89a927ffc67e6fa({
                        shape: {
                            cx: cx,
                            cy: cy,
                            r: ticksRadius[i].coord
                        }
                    }));
                }
                if (showSplitArea && i < ticksRadius.length - 1) {
                    var colorIndex = getColorIndex(splitAreas, splitAreaColors, i);
                    splitAreas[colorIndex].push(new $4b57d6b582d579b7$export$a6e3577650b6d6d7({
                        shape: {
                            cx: cx,
                            cy: cy,
                            r0: ticksRadius[i].coord,
                            r: ticksRadius[i + 1].coord
                        }
                    }));
                }
            }
        } else {
            var realSplitNumber;
            var axesTicksPoints = $ec279652dd95c27b$export$871de8747c9eaa88(indicatorAxes, function(indicatorAxis, idx) {
                var ticksCoords = indicatorAxis.getTicksCoords();
                realSplitNumber = realSplitNumber == null ? ticksCoords.length - 1 : Math.min(ticksCoords.length - 1, realSplitNumber);
                return $ec279652dd95c27b$export$871de8747c9eaa88(ticksCoords, function(tickCoord) {
                    return radar.coordToPoint(tickCoord.coord, idx);
                });
            });
            var prevPoints = [];
            for(var i = 0; i <= realSplitNumber; i++){
                var points = [];
                for(var j = 0; j < indicatorAxes.length; j++)points.push(axesTicksPoints[j][i]);
                 // Close
                if (points[0]) points.push(points[0].slice());
                if (showSplitLine) {
                    var colorIndex = getColorIndex(splitLines, splitLineColors, i);
                    splitLines[colorIndex].push(new $4b57d6b582d579b7$export$79f3ee03e63e7073({
                        shape: {
                            points: points
                        }
                    }));
                }
                if (showSplitArea && prevPoints) {
                    var colorIndex = getColorIndex(splitAreas, splitAreaColors, i - 1);
                    splitAreas[colorIndex].push(new $4b57d6b582d579b7$export$7d31b617c820d435({
                        shape: {
                            points: points.concat(prevPoints)
                        }
                    }));
                }
                prevPoints = points.slice().reverse();
            }
        }
        var lineStyle = lineStyleModel.getLineStyle();
        var areaStyle = areaStyleModel.getAreaStyle(); // Add splitArea before splitLine
        $ec279652dd95c27b$export$79b2f7037acddd43(splitAreas, function(splitAreas, idx) {
            this.group.add($4b57d6b582d579b7$export$7b1dd269fbc4e903(splitAreas, {
                style: $ec279652dd95c27b$export$ebe90cb607ad99e({
                    stroke: "none",
                    fill: splitAreaColors[idx % splitAreaColors.length]
                }, areaStyle),
                silent: true
            }));
        }, this);
        $ec279652dd95c27b$export$79b2f7037acddd43(splitLines, function(splitLines, idx) {
            this.group.add($4b57d6b582d579b7$export$7b1dd269fbc4e903(splitLines, {
                style: $ec279652dd95c27b$export$ebe90cb607ad99e({
                    fill: "none",
                    stroke: splitLineColors[idx % splitLineColors.length]
                }, lineStyle),
                silent: true
            }));
        }, this);
    }
});
$1cd023934deb0a27$exports = $1cd023934deb0a27$var$_default;




var $4002f765f3f2642f$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $4002f765f3f2642f$var$encodeHTML = $a4be9366aeb9fcc8$export$f9d6449b9af28dc1;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $4002f765f3f2642f$var$RadarSeries = $70847df98016d69d$exports.extend({
    type: "series.radar",
    dependencies: [
        "radar"
    ],
    // Overwrite
    init: function(option) {
        $4002f765f3f2642f$var$RadarSeries.superApply(this, "init", arguments); // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new $6b46bfdbd75036d4$exports($ec279652dd95c27b$export$2385a24977818dd0(this.getData, this), $ec279652dd95c27b$export$2385a24977818dd0(this.getRawData, this));
    },
    getInitialData: function(option, ecModel) {
        return $1dd6d8dd116bcd7f$exports(this, {
            generateCoord: "indicator_",
            generateCoordCount: Infinity
        });
    },
    formatTooltip: function(dataIndex, multipleSeries, dataType, renderMode) {
        var data = this.getData();
        var coordSys = this.coordinateSystem;
        var indicatorAxes = coordSys.getIndicatorAxes();
        var name = this.getData().getName(dataIndex);
        var newLine = renderMode === "html" ? "<br/>" : "\n";
        return $4002f765f3f2642f$var$encodeHTML(name === "" ? this.name : name) + newLine + $ec279652dd95c27b$export$871de8747c9eaa88(indicatorAxes, function(axis, idx) {
            var val = data.get(data.mapDimension(axis.dim), dataIndex);
            return $4002f765f3f2642f$var$encodeHTML(axis.name + " : " + val);
        }).join(newLine);
    },
    /**
   * @implement
   */ getTooltipPosition: function(dataIndex) {
        if (dataIndex != null) {
            var data = this.getData();
            var coordSys = this.coordinateSystem;
            var values = data.getValues($ec279652dd95c27b$export$871de8747c9eaa88(coordSys.dimensions, function(dim) {
                return data.mapDimension(dim);
            }), dataIndex, true);
            for(var i = 0, len = values.length; i < len; i++)if (!isNaN(values[i])) {
                var indicatorAxes = coordSys.getIndicatorAxes();
                return coordSys.coordToPoint(indicatorAxes[i].dataToCoord(values[i]), i);
            }
        }
    },
    defaultOption: {
        zlevel: 0,
        z: 2,
        coordinateSystem: "radar",
        legendHoverLink: true,
        radarIndex: 0,
        lineStyle: {
            width: 2,
            type: "solid"
        },
        label: {
            position: "top"
        },
        // areaStyle: {
        // },
        // itemStyle: {}
        symbol: "emptyCircle",
        symbolSize: 4 // symbolRotate: null
    }
});
var $4002f765f3f2642f$var$_default = $4002f765f3f2642f$var$RadarSeries;
$4002f765f3f2642f$exports = $4002f765f3f2642f$var$_default;


var $e4a1b78c188c22e3$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $e4a1b78c188c22e3$var$normalizeSymbolSize(symbolSize) {
    if (!$ec279652dd95c27b$export$43bee75e5e14138e(symbolSize)) symbolSize = [
        +symbolSize,
        +symbolSize
    ];
    return symbolSize;
}
var $e4a1b78c188c22e3$var$_default = $f406636b535430a7$exports.extendChartView({
    type: "radar",
    render: function(seriesModel, ecModel, api) {
        var polar = seriesModel.coordinateSystem;
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        function createSymbol(data, idx) {
            var symbolType = data.getItemVisual(idx, "symbol") || "circle";
            var color = data.getItemVisual(idx, "color");
            if (symbolType === "none") return;
            var symbolSize = $e4a1b78c188c22e3$var$normalizeSymbolSize(data.getItemVisual(idx, "symbolSize"));
            var symbolPath = $804dcb9a0b78b5fe$export$af050e04da3a02e8(symbolType, -1, -1, 2, 2, color);
            var symbolRotate = data.getItemVisual(idx, "symbolRotate") || 0;
            symbolPath.attr({
                style: {
                    strokeNoScale: true
                },
                z2: 100,
                scale: [
                    symbolSize[0] / 2,
                    symbolSize[1] / 2
                ],
                rotation: symbolRotate * Math.PI / 180 || 0
            });
            return symbolPath;
        }
        function updateSymbols(oldPoints, newPoints, symbolGroup, data, idx, isInit) {
            // Simply rerender all
            symbolGroup.removeAll();
            for(var i = 0; i < newPoints.length - 1; i++){
                var symbolPath = createSymbol(data, idx);
                if (symbolPath) {
                    symbolPath.__dimIdx = i;
                    if (oldPoints[i]) {
                        symbolPath.attr("position", oldPoints[i]);
                        $4b57d6b582d579b7$exports[isInit ? "initProps" : "updateProps"](symbolPath, {
                            position: newPoints[i]
                        }, seriesModel, idx);
                    } else symbolPath.attr("position", newPoints[i]);
                    symbolGroup.add(symbolPath);
                }
            }
        }
        function getInitialPoints(points) {
            return $ec279652dd95c27b$export$871de8747c9eaa88(points, function(pt) {
                return [
                    polar.cx,
                    polar.cy
                ];
            });
        }
        data.diff(oldData).add(function(idx) {
            var points = data.getItemLayout(idx);
            if (!points) return;
            var polygon = new $4b57d6b582d579b7$exports.Polygon();
            var polyline = new $4b57d6b582d579b7$exports.Polyline();
            var target = {
                shape: {
                    points: points
                }
            };
            polygon.shape.points = getInitialPoints(points);
            polyline.shape.points = getInitialPoints(points);
            $4b57d6b582d579b7$exports.initProps(polygon, target, seriesModel, idx);
            $4b57d6b582d579b7$exports.initProps(polyline, target, seriesModel, idx);
            var itemGroup = new $4b57d6b582d579b7$exports.Group();
            var symbolGroup = new $4b57d6b582d579b7$exports.Group();
            itemGroup.add(polyline);
            itemGroup.add(polygon);
            itemGroup.add(symbolGroup);
            updateSymbols(polyline.shape.points, points, symbolGroup, data, idx, true);
            data.setItemGraphicEl(idx, itemGroup);
        }).update(function(newIdx, oldIdx) {
            var itemGroup = oldData.getItemGraphicEl(oldIdx);
            var polyline = itemGroup.childAt(0);
            var polygon = itemGroup.childAt(1);
            var symbolGroup = itemGroup.childAt(2);
            var target = {
                shape: {
                    points: data.getItemLayout(newIdx)
                }
            };
            if (!target.shape.points) return;
            updateSymbols(polyline.shape.points, target.shape.points, symbolGroup, data, newIdx, false);
            $4b57d6b582d579b7$exports.updateProps(polyline, target, seriesModel);
            $4b57d6b582d579b7$exports.updateProps(polygon, target, seriesModel);
            data.setItemGraphicEl(newIdx, itemGroup);
        }).remove(function(idx) {
            group.remove(oldData.getItemGraphicEl(idx));
        }).execute();
        data.eachItemGraphicEl(function(itemGroup, idx) {
            var itemModel = data.getItemModel(idx);
            var polyline = itemGroup.childAt(0);
            var polygon = itemGroup.childAt(1);
            var symbolGroup = itemGroup.childAt(2);
            var color = data.getItemVisual(idx, "color");
            group.add(itemGroup);
            polyline.useStyle($ec279652dd95c27b$export$ebe90cb607ad99e(itemModel.getModel("lineStyle").getLineStyle(), {
                fill: "none",
                stroke: color
            }));
            polyline.hoverStyle = itemModel.getModel("emphasis.lineStyle").getLineStyle();
            var areaStyleModel = itemModel.getModel("areaStyle");
            var hoverAreaStyleModel = itemModel.getModel("emphasis.areaStyle");
            var polygonIgnore = areaStyleModel.isEmpty() && areaStyleModel.parentModel.isEmpty();
            var hoverPolygonIgnore = hoverAreaStyleModel.isEmpty() && hoverAreaStyleModel.parentModel.isEmpty();
            hoverPolygonIgnore = hoverPolygonIgnore && polygonIgnore;
            polygon.ignore = polygonIgnore;
            polygon.useStyle($ec279652dd95c27b$export$ebe90cb607ad99e(areaStyleModel.getAreaStyle(), {
                fill: color,
                opacity: 0.7
            }));
            polygon.hoverStyle = hoverAreaStyleModel.getAreaStyle();
            var itemStyle = itemModel.getModel("itemStyle").getItemStyle([
                "color"
            ]);
            var itemHoverStyle = itemModel.getModel("emphasis.itemStyle").getItemStyle();
            var labelModel = itemModel.getModel("label");
            var labelHoverModel = itemModel.getModel("emphasis.label");
            symbolGroup.eachChild(function(symbolPath) {
                symbolPath.setStyle(itemStyle);
                symbolPath.hoverStyle = $ec279652dd95c27b$export$9cd59f9826255e47(itemHoverStyle);
                var defaultText = data.get(data.dimensions[symbolPath.__dimIdx], idx);
                (defaultText == null || isNaN(defaultText)) && (defaultText = "");
                $4b57d6b582d579b7$exports.setLabelStyle(symbolPath.style, symbolPath.hoverStyle, labelModel, labelHoverModel, {
                    labelFetcher: data.hostModel,
                    labelDataIndex: idx,
                    labelDimIndex: symbolPath.__dimIdx,
                    defaultText: defaultText,
                    autoColor: color,
                    isRectText: true
                });
            });
            itemGroup.highDownOnUpdate = function(fromState, toState) {
                polygon.attr("ignore", toState === "emphasis" ? hoverPolygonIgnore : polygonIgnore);
            };
            $4b57d6b582d579b7$exports.setHoverStyle(itemGroup);
        });
        this._data = data;
    },
    remove: function() {
        this.group.removeAll();
        this._data = null;
    },
    dispose: function() {}
});
$e4a1b78c188c22e3$exports = $e4a1b78c188c22e3$var$_default;




var $850c8f8f5c93732a$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $850c8f8f5c93732a$var$_default(ecModel) {
    ecModel.eachSeriesByType("radar", function(seriesModel) {
        var data = seriesModel.getData();
        var points = [];
        var coordSys = seriesModel.coordinateSystem;
        if (!coordSys) return;
        var axes = coordSys.getIndicatorAxes();
        $ec279652dd95c27b$export$79b2f7037acddd43(axes, function(axis, axisIndex) {
            data.each(data.mapDimension(axes[axisIndex].dim), function(val, dataIndex) {
                points[dataIndex] = points[dataIndex] || [];
                var point = coordSys.dataToPoint(val, axisIndex);
                points[dataIndex][axisIndex] = $850c8f8f5c93732a$var$isValidPoint(point) ? point : $850c8f8f5c93732a$var$getValueMissingPoint(coordSys);
            });
        }); // Close polygon
        data.each(function(idx) {
            // TODO
            // Is it appropriate to connect to the next data when some data is missing?
            // Or, should trade it like `connectNull` in line chart?
            var firstPoint = $ec279652dd95c27b$export$71aa6c912b956294(points[idx], function(point) {
                return $850c8f8f5c93732a$var$isValidPoint(point);
            }) || $850c8f8f5c93732a$var$getValueMissingPoint(coordSys); // Copy the first actual point to the end of the array
            points[idx].push(firstPoint.slice());
            data.setItemLayout(idx, points[idx]);
        });
    });
}
function $850c8f8f5c93732a$var$isValidPoint(point) {
    return !isNaN(point[0]) && !isNaN(point[1]);
}
function $850c8f8f5c93732a$var$getValueMissingPoint(coordSys) {
    // It is error-prone to input [NaN, NaN] into polygon, polygon.
    // (probably cause problem when refreshing or animating)
    return [
        coordSys.cx,
        coordSys.cy
    ];
}
$850c8f8f5c93732a$exports = $850c8f8f5c93732a$var$_default;



var $241a86ffba391cd3$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Backward compat for radar chart in 2
function $241a86ffba391cd3$var$_default(option) {
    var polarOptArr = option.polar;
    if (polarOptArr) {
        if (!$ec279652dd95c27b$export$43bee75e5e14138e(polarOptArr)) polarOptArr = [
            polarOptArr
        ];
        var polarNotRadar = [];
        $ec279652dd95c27b$export$79b2f7037acddd43(polarOptArr, function(polarOpt, idx) {
            if (polarOpt.indicator) {
                if (polarOpt.type && !polarOpt.shape) polarOpt.shape = polarOpt.type;
                option.radar = option.radar || [];
                if (!$ec279652dd95c27b$export$43bee75e5e14138e(option.radar)) option.radar = [
                    option.radar
                ];
                option.radar.push(polarOpt);
            } else polarNotRadar.push(polarOpt);
        });
        option.polar = polarNotRadar;
    }
    $ec279652dd95c27b$export$79b2f7037acddd43(option.series, function(seriesOpt) {
        if (seriesOpt && seriesOpt.type === "radar" && seriesOpt.polarIndex) seriesOpt.radarIndex = seriesOpt.polarIndex;
    });
}
$241a86ffba391cd3$exports = $241a86ffba391cd3$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Must use radar component
$f406636b535430a7$exports.registerVisual($a6ff2ebba94839b3$exports("radar"));
$f406636b535430a7$exports.registerVisual($6efa4c3507ca2b4d$exports("radar", "circle"));
$f406636b535430a7$exports.registerLayout($850c8f8f5c93732a$exports);
$f406636b535430a7$exports.registerProcessor($334937e6881c9447$exports("radar"));
$f406636b535430a7$exports.registerPreprocessor($241a86ffba391cd3$exports);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fd409843f0c7089b$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $fd409843f0c7089b$var$encodeHTML = $a4be9366aeb9fcc8$export$f9d6449b9af28dc1;
var $fd409843f0c7089b$var$addCommas = $a4be9366aeb9fcc8$export$b6fe44657ce35c42;


var $fd409843f0c7089b$var$retrieveRawAttr = $05c9939f6206d72a$export$c8ae9e77e0ddc42a;
var $2fbe62bcc4893be5$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2fbe62bcc4893be5$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;

var $2fbe62bcc4893be5$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $2fbe62bcc4893be5$var$createHashMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4;

var $3d8c13a2d49694ad$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3d8c13a2d49694ad$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;


var $3d8c13a2d49694ad$var$makeInner = $d559f43cb9041423$export$64df9f8d92ae083f;
var $016820f6419efd4a$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 南海诸岛
var $016820f6419efd4a$var$geoCoord = [
    126,
    25
];
var $016820f6419efd4a$var$points = [
    [
        [
            0,
            3.5
        ],
        [
            7,
            11.2
        ],
        [
            15,
            11.9
        ],
        [
            30,
            7
        ],
        [
            42,
            0.7
        ],
        [
            52,
            0.7
        ],
        [
            56,
            7.7
        ],
        [
            59,
            0.7
        ],
        [
            64,
            0.7
        ],
        [
            64,
            0
        ],
        [
            5,
            0
        ],
        [
            0,
            3.5
        ]
    ],
    [
        [
            13,
            16.1
        ],
        [
            19,
            14.7
        ],
        [
            16,
            21.7
        ],
        [
            11,
            23.1
        ],
        [
            13,
            16.1
        ]
    ],
    [
        [
            12,
            32.2
        ],
        [
            14,
            38.5
        ],
        [
            15,
            38.5
        ],
        [
            13,
            32.2
        ],
        [
            12,
            32.2
        ]
    ],
    [
        [
            16,
            47.6
        ],
        [
            12,
            53.2
        ],
        [
            13,
            53.2
        ],
        [
            18,
            47.6
        ],
        [
            16,
            47.6
        ]
    ],
    [
        [
            6,
            64.4
        ],
        [
            8,
            70
        ],
        [
            9,
            70
        ],
        [
            8,
            64.4
        ],
        [
            6,
            64.4
        ]
    ],
    [
        [
            23,
            82.6
        ],
        [
            29,
            79.8
        ],
        [
            30,
            79.8
        ],
        [
            25,
            82.6
        ],
        [
            23,
            82.6
        ]
    ],
    [
        [
            37,
            70.7
        ],
        [
            43,
            62.3
        ],
        [
            44,
            62.3
        ],
        [
            39,
            70.7
        ],
        [
            37,
            70.7
        ]
    ],
    [
        [
            48,
            51.1
        ],
        [
            51,
            45.5
        ],
        [
            53,
            45.5
        ],
        [
            50,
            51.1
        ],
        [
            48,
            51.1
        ]
    ],
    [
        [
            51,
            35
        ],
        [
            51,
            28.7
        ],
        [
            53,
            28.7
        ],
        [
            53,
            35
        ],
        [
            51,
            35
        ]
    ],
    [
        [
            52,
            22.4
        ],
        [
            55,
            17.5
        ],
        [
            56,
            17.5
        ],
        [
            53,
            22.4
        ],
        [
            52,
            22.4
        ]
    ],
    [
        [
            58,
            12.6
        ],
        [
            62,
            7
        ],
        [
            63,
            7
        ],
        [
            60,
            12.6
        ],
        [
            58,
            12.6
        ]
    ],
    [
        [
            0,
            3.5
        ],
        [
            0,
            93.1
        ],
        [
            64,
            93.1
        ],
        [
            64,
            0
        ],
        [
            63,
            0
        ],
        [
            63,
            92.4
        ],
        [
            1,
            92.4
        ],
        [
            1,
            3.5
        ],
        [
            0,
            3.5
        ]
    ]
];
for(var $016820f6419efd4a$var$i = 0; $016820f6419efd4a$var$i < $016820f6419efd4a$var$points.length; $016820f6419efd4a$var$i++)for(var $016820f6419efd4a$var$k = 0; $016820f6419efd4a$var$k < $016820f6419efd4a$var$points[$016820f6419efd4a$var$i].length; $016820f6419efd4a$var$k++){
    $016820f6419efd4a$var$points[$016820f6419efd4a$var$i][$016820f6419efd4a$var$k][0] /= 10.5;
    $016820f6419efd4a$var$points[$016820f6419efd4a$var$i][$016820f6419efd4a$var$k][1] /= -14;
    $016820f6419efd4a$var$points[$016820f6419efd4a$var$i][$016820f6419efd4a$var$k][0] += $016820f6419efd4a$var$geoCoord[0];
    $016820f6419efd4a$var$points[$016820f6419efd4a$var$i][$016820f6419efd4a$var$k][1] += $016820f6419efd4a$var$geoCoord[1];
}
function $016820f6419efd4a$var$_default(mapType, regions) {
    if (mapType === "china") regions.push(new $92c6ed3dd2805a32$exports("\u5357\u6D77\u8BF8\u5C9B", $ec279652dd95c27b$export$871de8747c9eaa88($016820f6419efd4a$var$points, function(exterior) {
        return {
            type: "polygon",
            exterior: exterior
        };
    }), $016820f6419efd4a$var$geoCoord));
}
$016820f6419efd4a$exports = $016820f6419efd4a$var$_default;


var $51fec9407e9ac940$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $51fec9407e9ac940$var$coordsOffsetMap = {
    "\u5357\u6D77\u8BF8\u5C9B": [
        32,
        80
    ],
    // 全国
    "\u5E7F\u4E1C": [
        0,
        -10
    ],
    "\u9999\u6E2F": [
        10,
        5
    ],
    "\u6FB3\u95E8": [
        -10,
        10
    ],
    //'北京': [-10, 0],
    "\u5929\u6D25": [
        5,
        5
    ]
};
function $51fec9407e9ac940$var$_default(mapType, region) {
    if (mapType === "china") {
        var coordFix = $51fec9407e9ac940$var$coordsOffsetMap[region.name];
        if (coordFix) {
            var cp = region.center;
            cp[0] += coordFix[0] / 10.5;
            cp[1] += -coordFix[1] / 14;
        }
    }
}
$51fec9407e9ac940$exports = $51fec9407e9ac940$var$_default;


var $192578ce466a73c9$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $192578ce466a73c9$var$geoCoordMap = {
    "Russia": [
        100,
        60
    ],
    "United States": [
        -99,
        38
    ],
    "United States of America": [
        -99,
        38
    ]
};
function $192578ce466a73c9$var$_default(mapType, region) {
    if (mapType === "world") {
        var geoCoord = $192578ce466a73c9$var$geoCoordMap[region.name];
        if (geoCoord) {
            var cp = region.center;
            cp[0] = geoCoord[0];
            cp[1] = geoCoord[1];
        }
    }
}
$192578ce466a73c9$exports = $192578ce466a73c9$var$_default;


var $393e7f27fe8f9e0f$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 钓鱼岛
// var Region = require('../Region');
// var zrUtil = require('zrender/src/core/util');
// var geoCoord = [126, 25];
var $393e7f27fe8f9e0f$var$points = [
    [
        [
            123.45165252685547,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.73527164402261
        ]
    ]
];
function $393e7f27fe8f9e0f$var$_default(mapType, region) {
    if (mapType === "china" && region.name === "\u53F0\u6E7E") region.geometries.push({
        type: "polygon",
        exterior: $393e7f27fe8f9e0f$var$points[0]
    });
}
$393e7f27fe8f9e0f$exports = $393e7f27fe8f9e0f$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Built-in GEO fixer.
var $3d8c13a2d49694ad$var$inner = $3d8c13a2d49694ad$var$makeInner();
var $3d8c13a2d49694ad$var$_default = {
    /**
   * @param {string} mapName
   * @param {Object} mapRecord {specialAreas, geoJSON}
   * @param {string} nameProperty
   * @return {Object} {regions, boundingRect}
   */ load: function(mapName, mapRecord, nameProperty) {
        var parsed = $3d8c13a2d49694ad$var$inner(mapRecord).parsed;
        if (parsed) return parsed;
        var specialAreas = mapRecord.specialAreas || {};
        var geoJSON = mapRecord.geoJSON;
        var regions; // https://jsperf.com/try-catch-performance-overhead
        try {
            regions = geoJSON ? $e0a8b9e18cb663b3$exports(geoJSON, nameProperty) : [];
        } catch (e) {
            throw new Error("Invalid geoJson format\n" + e.message);
        }
        $016820f6419efd4a$exports(mapName, regions);
        $3d8c13a2d49694ad$var$each(regions, function(region) {
            var regionName = region.name;
            $51fec9407e9ac940$exports(mapName, region);
            $192578ce466a73c9$exports(mapName, region);
            $393e7f27fe8f9e0f$exports(mapName, region); // Some area like Alaska in USA map needs to be tansformed
            // to look better
            var specialArea = specialAreas[regionName];
            if (specialArea) region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
        });
        return $3d8c13a2d49694ad$var$inner(mapRecord).parsed = {
            regions: regions,
            boundingRect: $3d8c13a2d49694ad$var$getBoundingRect(regions)
        };
    }
};
function $3d8c13a2d49694ad$var$getBoundingRect(regions) {
    var rect;
    for(var i = 0; i < regions.length; i++){
        var regionRect = regions[i].getBoundingRect();
        rect = rect || regionRect.clone();
        rect.union(regionRect);
    }
    return rect;
}
$3d8c13a2d49694ad$exports = $3d8c13a2d49694ad$var$_default;


var $d1d67a155c27d5b9$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $d1d67a155c27d5b9$var$parseSVG = $13df5e2156d14c42$export$1919f5101c220601;
var $d1d67a155c27d5b9$var$makeViewBoxTransform = $13df5e2156d14c42$export$3e2db4420f14f50f;



var $d1d67a155c27d5b9$var$assert = $ec279652dd95c27b$export$a7a9523472993e97;
var $d1d67a155c27d5b9$var$createHashMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4;


var $d1d67a155c27d5b9$var$makeInner = $d559f43cb9041423$export$64df9f8d92ae083f;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $d1d67a155c27d5b9$var$inner = $d1d67a155c27d5b9$var$makeInner();
var $d1d67a155c27d5b9$var$_default = {
    /**
   * @param {string} mapName
   * @param {Object} mapRecord {specialAreas, geoJSON}
   * @return {Object} {root, boundingRect}
   */ load: function(mapName, mapRecord) {
        var originRoot = $d1d67a155c27d5b9$var$inner(mapRecord).originRoot;
        if (originRoot) return {
            root: originRoot,
            boundingRect: $d1d67a155c27d5b9$var$inner(mapRecord).boundingRect
        };
        var graphic = $d1d67a155c27d5b9$var$buildGraphic(mapRecord);
        $d1d67a155c27d5b9$var$inner(mapRecord).originRoot = graphic.root;
        $d1d67a155c27d5b9$var$inner(mapRecord).boundingRect = graphic.boundingRect;
        return graphic;
    },
    makeGraphic: function(mapName, mapRecord, hostKey) {
        // For performance consideration (in large SVG), graphic only maked
        // when necessary and reuse them according to hostKey.
        var field = $d1d67a155c27d5b9$var$inner(mapRecord);
        var rootMap = field.rootMap || (field.rootMap = $d1d67a155c27d5b9$var$createHashMap());
        var root = rootMap.get(hostKey);
        if (root) return root;
        var originRoot = field.originRoot;
        var boundingRect = field.boundingRect; // For performance, if originRoot is not used by a view,
        // assign it to a view, but not reproduce graphic elements.
        if (!field.originRootHostKey) {
            field.originRootHostKey = hostKey;
            root = originRoot;
        } else root = $d1d67a155c27d5b9$var$buildGraphic(mapRecord, boundingRect).root;
        return rootMap.set(hostKey, root);
    },
    removeGraphic: function(mapName, mapRecord, hostKey) {
        var field = $d1d67a155c27d5b9$var$inner(mapRecord);
        var rootMap = field.rootMap;
        rootMap && rootMap.removeKey(hostKey);
        if (hostKey === field.originRootHostKey) field.originRootHostKey = null;
    }
};
function $d1d67a155c27d5b9$var$buildGraphic(mapRecord, boundingRect) {
    var svgXML = mapRecord.svgXML;
    var result;
    var root;
    try {
        result = svgXML && $d1d67a155c27d5b9$var$parseSVG(svgXML, {
            ignoreViewBox: true,
            ignoreRootClip: true
        }) || {};
        root = result.root;
        $d1d67a155c27d5b9$var$assert(root != null);
    } catch (e) {
        throw new Error("Invalid svg format\n" + e.message);
    }
    var svgWidth = result.width;
    var svgHeight = result.height;
    var viewBoxRect = result.viewBoxRect;
    if (!boundingRect) {
        boundingRect = svgWidth == null || svgHeight == null ? // bounding rect as the width / height
        root.getBoundingRect() : new $33e4fae744d34798$exports(0, 0, 0, 0);
        if (svgWidth != null) boundingRect.width = svgWidth;
        if (svgHeight != null) boundingRect.height = svgHeight;
    }
    if (viewBoxRect) {
        var viewBoxTransform = $d1d67a155c27d5b9$var$makeViewBoxTransform(viewBoxRect, boundingRect.width, boundingRect.height);
        var elRoot = root;
        root = new $48aa8d5160ffcc64$exports();
        root.add(elRoot);
        elRoot.scale = viewBoxTransform.scale;
        elRoot.position = viewBoxTransform.position;
    }
    root.setClipPath(new $9dfde1361bdd05e1$exports({
        shape: boundingRect.plain()
    }));
    return {
        root: root,
        boundingRect: boundingRect
    };
}
$d1d67a155c27d5b9$exports = $d1d67a155c27d5b9$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $2fbe62bcc4893be5$var$loaders = {
    geoJSON: $3d8c13a2d49694ad$exports,
    svg: $d1d67a155c27d5b9$exports
};
var $2fbe62bcc4893be5$var$_default = {
    /**
   * @param {string} mapName
   * @param {Object} nameMap
   * @param {string} nameProperty
   * @return {Object} source {regions, regionsMap, nameCoordMap, boundingRect}
   */ load: function(mapName, nameMap, nameProperty) {
        var regions = [];
        var regionsMap = $2fbe62bcc4893be5$var$createHashMap();
        var nameCoordMap = $2fbe62bcc4893be5$var$createHashMap();
        var boundingRect;
        var mapRecords = $2fbe62bcc4893be5$var$retrieveMap(mapName);
        $2fbe62bcc4893be5$var$each(mapRecords, function(record) {
            var singleSource = $2fbe62bcc4893be5$var$loaders[record.type].load(mapName, record, nameProperty);
            $2fbe62bcc4893be5$var$each(singleSource.regions, function(region) {
                var regionName = region.name; // Try use the alias in geoNameMap
                if (nameMap && nameMap.hasOwnProperty(regionName)) region = region.cloneShallow(regionName = nameMap[regionName]);
                regions.push(region);
                regionsMap.set(regionName, region);
                nameCoordMap.set(regionName, region.center);
            });
            var rect = singleSource.boundingRect;
            if (rect) boundingRect ? boundingRect.union(rect) : boundingRect = rect.clone();
        });
        return {
            regions: regions,
            regionsMap: regionsMap,
            nameCoordMap: nameCoordMap,
            // FIXME Always return new ?
            boundingRect: boundingRect || new $33e4fae744d34798$exports(0, 0, 0, 0)
        };
    },
    /**
   * @param {string} mapName
   * @param {string} hostKey For cache.
   * @return {Array.<module:zrender/Element>} Roots.
   */ makeGraphic: $2fbe62bcc4893be5$var$makeInvoker("makeGraphic"),
    /**
   * @param {string} mapName
   * @param {string} hostKey For cache.
   */ removeGraphic: $2fbe62bcc4893be5$var$makeInvoker("removeGraphic")
};
function $2fbe62bcc4893be5$var$makeInvoker(methodName) {
    return function(mapName, hostKey) {
        var mapRecords = $2fbe62bcc4893be5$var$retrieveMap(mapName);
        var results = [];
        $2fbe62bcc4893be5$var$each(mapRecords, function(record) {
            var method = $2fbe62bcc4893be5$var$loaders[record.type][methodName];
            method && results.push(method(mapName, record, hostKey));
        });
        return results;
    };
}
function $2fbe62bcc4893be5$var$mapNotExistsError(mapName) {}
function $2fbe62bcc4893be5$var$retrieveMap(mapName) {
    var mapRecords = $cc0f61c9f8527b8d$exports.retrieveMap(mapName) || [];
    return mapRecords;
}
$2fbe62bcc4893be5$exports = $2fbe62bcc4893be5$var$_default;



var $fd409843f0c7089b$var$makeSeriesEncodeForNameBased = $71e1a98f99449cca$export$60b8a57d1f2fed26;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $fd409843f0c7089b$var$MapSeries = $70847df98016d69d$exports.extend({
    type: "series.map",
    dependencies: [
        "geo"
    ],
    layoutMode: "box",
    /**
   * Only first map series of same mapType will drawMap
   * @type {boolean}
   */ needsDrawMap: false,
    /**
   * Group of all map series with same mapType
   * @type {boolean}
   */ seriesGroup: [],
    getInitialData: function(option) {
        var data = $1dd6d8dd116bcd7f$exports(this, {
            coordDimensions: [
                "value"
            ],
            encodeDefaulter: $ec279652dd95c27b$export$c3095a23b368d1f2($fd409843f0c7089b$var$makeSeriesEncodeForNameBased, this)
        });
        var valueDim = data.mapDimension("value");
        var dataNameMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4();
        var selectTargetList = [];
        var toAppendNames = [];
        for(var i = 0, len = data.count(); i < len; i++){
            var name = data.getName(i);
            dataNameMap.set(name, true);
            selectTargetList.push({
                name: name,
                value: data.get(valueDim, i),
                selected: $fd409843f0c7089b$var$retrieveRawAttr(data, i, "selected")
            });
        }
        var geoSource = $2fbe62bcc4893be5$exports.load(this.getMapType(), this.option.nameMap, this.option.nameProperty);
        $ec279652dd95c27b$export$79b2f7037acddd43(geoSource.regions, function(region) {
            var name = region.name;
            if (!dataNameMap.get(name)) {
                selectTargetList.push({
                    name: name
                });
                toAppendNames.push(name);
            }
        });
        this.updateSelectedMap(selectTargetList); // Complete data with missing regions. The consequent processes (like visual
        // map and render) can not be performed without a "full data". For example,
        // find `dataIndex` by name.
        data.appendValues([], toAppendNames);
        return data;
    },
    /**
   * If no host geo model, return null, which means using a
   * inner exclusive geo model.
   */ getHostGeoModel: function() {
        var geoIndex = this.option.geoIndex;
        return geoIndex != null ? this.dependentModels.geo[geoIndex] : null;
    },
    getMapType: function() {
        return (this.getHostGeoModel() || this).option.map;
    },
    // _fillOption: function (option, mapName) {
    // Shallow clone
    // option = zrUtil.extend({}, option);
    // option.data = geoCreator.getFilledRegions(option.data, mapName, option.nameMap);
    // return option;
    // },
    getRawValue: function(dataIndex) {
        // Use value stored in data instead because it is calculated from multiple series
        // FIXME Provide all value of multiple series ?
        var data = this.getData();
        return data.get(data.mapDimension("value"), dataIndex);
    },
    /**
   * Get model of region
   * @param  {string} name
   * @return {module:echarts/model/Model}
   */ getRegionModel: function(regionName) {
        var data = this.getData();
        return data.getItemModel(data.indexOfName(regionName));
    },
    /**
   * Map tooltip formatter
   *
   * @param {number} dataIndex
   */ formatTooltip: function(dataIndex, multipleSeries, dataType, renderMode) {
        // FIXME orignalData and data is a bit confusing
        var data = this.getData();
        var formattedValue = $fd409843f0c7089b$var$addCommas(this.getRawValue(dataIndex));
        var name = data.getName(dataIndex);
        var seriesGroup = this.seriesGroup;
        var seriesNames = [];
        for(var i = 0; i < seriesGroup.length; i++){
            var otherIndex = seriesGroup[i].originalData.indexOfName(name);
            var valueDim = data.mapDimension("value");
            if (!isNaN(seriesGroup[i].originalData.get(valueDim, otherIndex))) seriesNames.push($fd409843f0c7089b$var$encodeHTML(seriesGroup[i].name));
        }
        var newLine = renderMode === "html" ? "<br/>" : "\n";
        return seriesNames.join(", ") + newLine + $fd409843f0c7089b$var$encodeHTML(name + " : " + formattedValue);
    },
    /**
   * @implement
   */ getTooltipPosition: function(dataIndex) {
        if (dataIndex != null) {
            var name = this.getData().getName(dataIndex);
            var geo = this.coordinateSystem;
            var region = geo.getRegion(name);
            return region && geo.dataToPoint(region.center);
        }
    },
    setZoom: function(zoom) {
        this.option.zoom = zoom;
    },
    setCenter: function(center) {
        this.option.center = center;
    },
    defaultOption: {
        // 一级层叠
        zlevel: 0,
        // 二级层叠
        z: 2,
        coordinateSystem: "geo",
        // map should be explicitly specified since ec3.
        map: "",
        // If `geoIndex` is not specified, a exclusive geo will be
        // created. Otherwise use the specified geo component, and
        // `map` and `mapType` are ignored.
        // geoIndex: 0,
        // 'center' | 'left' | 'right' | 'x%' | {number}
        left: "center",
        // 'center' | 'top' | 'bottom' | 'x%' | {number}
        top: "center",
        // right
        // bottom
        // width:
        // height
        // Aspect is width / height. Inited to be geoJson bbox aspect
        // This parameter is used for scale this aspect
        aspectScale: 0.75,
        ///// Layout with center and size
        // If you wan't to put map in a fixed size box with right aspect ratio
        // This two properties may more conveninet
        // layoutCenter: [50%, 50%]
        // layoutSize: 100
        // 数值合并方式，默认加和，可选为：
        // 'sum' | 'average' | 'max' | 'min'
        // mapValueCalculation: 'sum',
        // 地图数值计算结果小数精度
        // mapValuePrecision: 0,
        // 显示图例颜色标识（系列标识的小圆点），图例开启时有效
        showLegendSymbol: true,
        // 选择模式，默认关闭，可选single，multiple
        // selectedMode: false,
        dataRangeHoverLink: true,
        // 是否开启缩放及漫游模式
        // roam: false,
        // Define left-top, right-bottom coords to control view
        // For example, [ [180, 90], [-180, -90] ],
        // higher priority than center and zoom
        boundingCoords: null,
        // Default on center of map
        center: null,
        zoom: 1,
        scaleLimit: null,
        label: {
            show: false,
            color: "#000"
        },
        // scaleLimit: null,
        itemStyle: {
            borderWidth: 0.5,
            borderColor: "#444",
            areaColor: "#eee"
        },
        emphasis: {
            label: {
                show: true,
                color: "rgb(100,0,0)"
            },
            itemStyle: {
                areaColor: "rgba(255,215,0,0.8)"
            }
        },
        nameProperty: "name"
    }
});
$ec279652dd95c27b$export$e36fc9d62a853069($fd409843f0c7089b$var$MapSeries, $8460a2195ba68c18$exports);
var $fd409843f0c7089b$var$_default = $fd409843f0c7089b$var$MapSeries;
$fd409843f0c7089b$exports = $fd409843f0c7089b$var$_default;


var $f4c50d258f00706b$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $3f31ab2d08c97478$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $f812ed7651a5f0b7$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $3e7ee0b67ffa0477$export$b7df5d561049483a;
var $3e7ee0b67ffa0477$export$23d3fad09dc44362;
var $3e7ee0b67ffa0477$export$5623cba512bc9470;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $3e7ee0b67ffa0477$var$ATTR = "\x00_ec_interaction_mutex";
function $3e7ee0b67ffa0477$var$take(zr, resourceKey, userKey) {
    var store = $3e7ee0b67ffa0477$var$getStore(zr);
    store[resourceKey] = userKey;
}
function $3e7ee0b67ffa0477$var$release(zr, resourceKey, userKey) {
    var store = $3e7ee0b67ffa0477$var$getStore(zr);
    var uKey = store[resourceKey];
    if (uKey === userKey) store[resourceKey] = null;
}
function $3e7ee0b67ffa0477$var$isTaken(zr, resourceKey) {
    return !!$3e7ee0b67ffa0477$var$getStore(zr)[resourceKey];
}
function $3e7ee0b67ffa0477$var$getStore(zr) {
    return zr[$3e7ee0b67ffa0477$var$ATTR] || (zr[$3e7ee0b67ffa0477$var$ATTR] = {});
}
/**
 * payload: {
 *     type: 'takeGlobalCursor',
 *     key: 'dataZoomSelect', or 'brush', or ...,
 *         If no userKey, release global cursor.
 * }
 */ $f406636b535430a7$exports.registerAction({
    type: "takeGlobalCursor",
    event: "globalCursorTaken",
    update: "update"
}, function() {});
$3e7ee0b67ffa0477$export$b7df5d561049483a = $3e7ee0b67ffa0477$var$take;
$3e7ee0b67ffa0477$export$23d3fad09dc44362 = $3e7ee0b67ffa0477$var$release;
$3e7ee0b67ffa0477$export$5623cba512bc9470 = $3e7ee0b67ffa0477$var$isTaken;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @alias module:echarts/component/helper/RoamController
 * @constructor
 * @mixin {module:zrender/mixin/Eventful}
 *
 * @param {module:zrender/zrender~ZRender} zr
 */ function $f812ed7651a5f0b7$var$RoamController(zr) {
    /**
   * @type {Function}
   */ this.pointerChecker;
    /**
   * @type {module:zrender}
   */ this._zr = zr;
    /**
   * @type {Object}
   */ this._opt = {}; // Avoid two roamController bind the same handler
    var bind = $ec279652dd95c27b$export$2385a24977818dd0;
    var mousedownHandler = bind($f812ed7651a5f0b7$var$mousedown, this);
    var mousemoveHandler = bind($f812ed7651a5f0b7$var$mousemove, this);
    var mouseupHandler = bind($f812ed7651a5f0b7$var$mouseup, this);
    var mousewheelHandler = bind($f812ed7651a5f0b7$var$mousewheel, this);
    var pinchHandler = bind($f812ed7651a5f0b7$var$pinch, this);
    $b7a44647f5b5bfa5$exports.call(this);
    /**
   * @param {Function} pointerChecker
   *                   input: x, y
   *                   output: boolean
   */ this.setPointerChecker = function(pointerChecker) {
        this.pointerChecker = pointerChecker;
    };
    /**
   * Notice: only enable needed types. For example, if 'zoom'
   * is not needed, 'zoom' should not be enabled, otherwise
   * default mousewheel behaviour (scroll page) will be disabled.
   *
   * @param  {boolean|string} [controlType=true] Specify the control type,
   *                          which can be null/undefined or true/false
   *                          or 'pan/move' or 'zoom'/'scale'
   * @param {Object} [opt]
   * @param {Object} [opt.zoomOnMouseWheel=true] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
   * @param {Object} [opt.moveOnMouseMove=true] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
   * @param {Object} [opt.moveOnMouseWheel=false] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
   * @param {Object} [opt.preventDefaultMouseMove=true] When pan.
   */ this.enable = function(controlType, opt) {
        // Disable previous first
        this.disable();
        this._opt = $ec279652dd95c27b$export$ebe90cb607ad99e($ec279652dd95c27b$export$9cd59f9826255e47(opt) || {}, {
            zoomOnMouseWheel: true,
            moveOnMouseMove: true,
            // By default, wheel do not trigger move.
            moveOnMouseWheel: false,
            preventDefaultMouseMove: true
        });
        if (controlType == null) controlType = true;
        if (controlType === true || controlType === "move" || controlType === "pan") {
            zr.on("mousedown", mousedownHandler);
            zr.on("mousemove", mousemoveHandler);
            zr.on("mouseup", mouseupHandler);
        }
        if (controlType === true || controlType === "scale" || controlType === "zoom") {
            zr.on("mousewheel", mousewheelHandler);
            zr.on("pinch", pinchHandler);
        }
    };
    this.disable = function() {
        zr.off("mousedown", mousedownHandler);
        zr.off("mousemove", mousemoveHandler);
        zr.off("mouseup", mouseupHandler);
        zr.off("mousewheel", mousewheelHandler);
        zr.off("pinch", pinchHandler);
    };
    this.dispose = this.disable;
    this.isDragging = function() {
        return this._dragging;
    };
    this.isPinching = function() {
        return this._pinching;
    };
}
$ec279652dd95c27b$export$e36fc9d62a853069($f812ed7651a5f0b7$var$RoamController, $b7a44647f5b5bfa5$exports);
function $f812ed7651a5f0b7$var$mousedown(e) {
    if ($adca58e5ac25631a$export$b7ae4cded3e71bd2(e) || e.target && e.target.draggable) return;
    var x = e.offsetX;
    var y = e.offsetY; // Only check on mosedown, but not mousemove.
    // Mouse can be out of target when mouse moving.
    if (this.pointerChecker && this.pointerChecker(e, x, y)) {
        this._x = x;
        this._y = y;
        this._dragging = true;
    }
}
function $f812ed7651a5f0b7$var$mousemove(e) {
    if (!this._dragging || !$f812ed7651a5f0b7$var$isAvailableBehavior("moveOnMouseMove", e, this._opt) || e.gestureEvent === "pinch" || $3e7ee0b67ffa0477$export$5623cba512bc9470(this._zr, "globalPan")) return;
    var x = e.offsetX;
    var y = e.offsetY;
    var oldX = this._x;
    var oldY = this._y;
    var dx = x - oldX;
    var dy = y - oldY;
    this._x = x;
    this._y = y;
    this._opt.preventDefaultMouseMove && $adca58e5ac25631a$export$fa6813432f753b0d(e.event);
    $f812ed7651a5f0b7$var$trigger(this, "pan", "moveOnMouseMove", e, {
        dx: dx,
        dy: dy,
        oldX: oldX,
        oldY: oldY,
        newX: x,
        newY: y
    });
}
function $f812ed7651a5f0b7$var$mouseup(e) {
    if (!$adca58e5ac25631a$export$b7ae4cded3e71bd2(e)) this._dragging = false;
}
function $f812ed7651a5f0b7$var$mousewheel(e) {
    var shouldZoom = $f812ed7651a5f0b7$var$isAvailableBehavior("zoomOnMouseWheel", e, this._opt);
    var shouldMove = $f812ed7651a5f0b7$var$isAvailableBehavior("moveOnMouseWheel", e, this._opt);
    var wheelDelta = e.wheelDelta;
    var absWheelDeltaDelta = Math.abs(wheelDelta);
    var originX = e.offsetX;
    var originY = e.offsetY; // wheelDelta maybe -0 in chrome mac.
    if (wheelDelta === 0 || !shouldZoom && !shouldMove) return;
     // If both `shouldZoom` and `shouldMove` is true, trigger
    // their event both, and the final behavior is determined
    // by event listener themselves.
    if (shouldZoom) {
        // Convenience:
        // Mac and VM Windows on Mac: scroll up: zoom out.
        // Windows: scroll up: zoom in.
        // FIXME: Should do more test in different environment.
        // wheelDelta is too complicated in difference nvironment
        // (https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel),
        // although it has been normallized by zrender.
        // wheelDelta of mouse wheel is bigger than touch pad.
        var factor = absWheelDeltaDelta > 3 ? 1.4 : absWheelDeltaDelta > 1 ? 1.2 : 1.1;
        var scale = wheelDelta > 0 ? factor : 1 / factor;
        $f812ed7651a5f0b7$var$checkPointerAndTrigger(this, "zoom", "zoomOnMouseWheel", e, {
            scale: scale,
            originX: originX,
            originY: originY
        });
    }
    if (shouldMove) {
        // FIXME: Should do more test in different environment.
        var absDelta = Math.abs(wheelDelta); // wheelDelta of mouse wheel is bigger than touch pad.
        var scrollDelta = (wheelDelta > 0 ? 1 : -1) * (absDelta > 3 ? 0.4 : absDelta > 1 ? 0.15 : 0.05);
        $f812ed7651a5f0b7$var$checkPointerAndTrigger(this, "scrollMove", "moveOnMouseWheel", e, {
            scrollDelta: scrollDelta,
            originX: originX,
            originY: originY
        });
    }
}
function $f812ed7651a5f0b7$var$pinch(e) {
    if ($3e7ee0b67ffa0477$export$5623cba512bc9470(this._zr, "globalPan")) return;
    var scale = e.pinchScale > 1 ? 1.1 : 1 / 1.1;
    $f812ed7651a5f0b7$var$checkPointerAndTrigger(this, "zoom", null, e, {
        scale: scale,
        originX: e.pinchX,
        originY: e.pinchY
    });
}
function $f812ed7651a5f0b7$var$checkPointerAndTrigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
    if (controller.pointerChecker && controller.pointerChecker(e, contollerEvent.originX, contollerEvent.originY)) {
        // When mouse is out of roamController rect,
        // default befavoius should not be be disabled, otherwise
        // page sliding is disabled, contrary to expectation.
        $adca58e5ac25631a$export$fa6813432f753b0d(e.event);
        $f812ed7651a5f0b7$var$trigger(controller, eventName, behaviorToCheck, e, contollerEvent);
    }
}
function $f812ed7651a5f0b7$var$trigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
    // Also provide behavior checker for event listener, for some case that
    // multiple components share one listener.
    contollerEvent.isAvailableBehavior = $ec279652dd95c27b$export$2385a24977818dd0($f812ed7651a5f0b7$var$isAvailableBehavior, null, behaviorToCheck, e);
    controller.trigger(eventName, contollerEvent);
} // settings: {
//     zoomOnMouseWheel
//     moveOnMouseMove
//     moveOnMouseWheel
// }
// The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
function $f812ed7651a5f0b7$var$isAvailableBehavior(behaviorToCheck, e, settings) {
    var setting = settings[behaviorToCheck];
    return !behaviorToCheck || setting && (!$ec279652dd95c27b$export$844ec244b1367d54(setting) || e.event[setting + "Key"]);
}
var $f812ed7651a5f0b7$var$_default = $f812ed7651a5f0b7$var$RoamController;
$f812ed7651a5f0b7$exports = $f812ed7651a5f0b7$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * For geo and graph.
 *
 * @param {Object} controllerHost
 * @param {module:zrender/Element} controllerHost.target
 */ var $b7c2af586a53b694$export$1e6abcd98caba733;
var $b7c2af586a53b694$export$29b3c66d30a4866;
function $b7c2af586a53b694$var$updateViewOnPan(controllerHost, dx, dy) {
    var target = controllerHost.target;
    var pos = target.position;
    pos[0] += dx;
    pos[1] += dy;
    target.dirty();
}
/**
 * For geo and graph.
 *
 * @param {Object} controllerHost
 * @param {module:zrender/Element} controllerHost.target
 * @param {number} controllerHost.zoom
 * @param {number} controllerHost.zoomLimit like: {min: 1, max: 2}
 */ function $b7c2af586a53b694$var$updateViewOnZoom(controllerHost, zoomDelta, zoomX, zoomY) {
    var target = controllerHost.target;
    var zoomLimit = controllerHost.zoomLimit;
    var pos = target.position;
    var scale = target.scale;
    var newZoom = controllerHost.zoom = controllerHost.zoom || 1;
    newZoom *= zoomDelta;
    if (zoomLimit) {
        var zoomMin = zoomLimit.min || 0;
        var zoomMax = zoomLimit.max || Infinity;
        newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
    }
    var zoomScale = newZoom / controllerHost.zoom;
    controllerHost.zoom = newZoom; // Keep the mouse center when scaling
    pos[0] -= (zoomX - pos[0]) * (zoomScale - 1);
    pos[1] -= (zoomY - pos[1]) * (zoomScale - 1);
    scale[0] *= zoomScale;
    scale[1] *= zoomScale;
    target.dirty();
}
$b7c2af586a53b694$export$1e6abcd98caba733 = $b7c2af586a53b694$var$updateViewOnPan;
$b7c2af586a53b694$export$29b3c66d30a4866 = $b7c2af586a53b694$var$updateViewOnZoom;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $42222c91ddd2a800$export$8a33eacb690eac07;
var $42222c91ddd2a800$var$IRRELEVANT_EXCLUDES = {
    "axisPointer": 1,
    "tooltip": 1,
    "brush": 1
};
/**
 * Avoid that: mouse click on a elements that is over geo or graph,
 * but roam is triggered.
 */ function $42222c91ddd2a800$var$onIrrelevantElement(e, api, targetCoordSysModel) {
    var model = api.getComponentByElement(e.topTarget); // If model is axisModel, it works only if it is injected with coordinateSystem.
    var coordSys = model && model.coordinateSystem;
    return model && model !== targetCoordSysModel && !$42222c91ddd2a800$var$IRRELEVANT_EXCLUDES[model.mainType] && coordSys && coordSys.model !== targetCoordSysModel;
}
$42222c91ddd2a800$export$8a33eacb690eac07 = $42222c91ddd2a800$var$onIrrelevantElement;


var $3f31ab2d08c97478$var$onIrrelevantElement = $42222c91ddd2a800$export$8a33eacb690eac07;



var $3f31ab2d08c97478$var$getUID = $a39499a9dbffdb7d$export$6d2b3473b0986646;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $3f31ab2d08c97478$var$getFixedItemStyle(model) {
    var itemStyle = model.getItemStyle();
    var areaColor = model.get("areaColor"); // If user want the color not to be changed when hover,
    // they should both set areaColor and color to be null.
    if (areaColor != null) itemStyle.fill = areaColor;
    return itemStyle;
}
function $3f31ab2d08c97478$var$updateMapSelectHandler(mapDraw, mapOrGeoModel, regionsGroup, api, fromView) {
    regionsGroup.off("click");
    regionsGroup.off("mousedown");
    if (mapOrGeoModel.get("selectedMode")) {
        regionsGroup.on("mousedown", function() {
            mapDraw._mouseDownFlag = true;
        });
        regionsGroup.on("click", function(e) {
            if (!mapDraw._mouseDownFlag) return;
            mapDraw._mouseDownFlag = false;
            var el = e.target;
            while(!el.__regions)el = el.parent;
            if (!el) return;
            var action = {
                type: (mapOrGeoModel.mainType === "geo" ? "geo" : "map") + "ToggleSelect",
                batch: $ec279652dd95c27b$export$871de8747c9eaa88(el.__regions, function(region) {
                    return {
                        name: region.name,
                        from: fromView.uid
                    };
                })
            };
            action[mapOrGeoModel.mainType + "Id"] = mapOrGeoModel.id;
            api.dispatchAction(action);
            $3f31ab2d08c97478$var$updateMapSelected(mapOrGeoModel, regionsGroup);
        });
    }
}
function $3f31ab2d08c97478$var$updateMapSelected(mapOrGeoModel, regionsGroup) {
    // FIXME
    regionsGroup.eachChild(function(otherRegionEl) {
        $ec279652dd95c27b$export$79b2f7037acddd43(otherRegionEl.__regions, function(region) {
            otherRegionEl.trigger(mapOrGeoModel.isSelected(region.name) ? "emphasis" : "normal");
        });
    });
}
/**
 * @alias module:echarts/component/helper/MapDraw
 * @param {module:echarts/ExtensionAPI} api
 * @param {boolean} updateGroup
 */ function $3f31ab2d08c97478$var$MapDraw(api, updateGroup) {
    var group = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
    /**
   * @type {string}
   * @private
   */ this.uid = $3f31ab2d08c97478$var$getUID("ec_map_draw");
    /**
   * @type {module:echarts/component/helper/RoamController}
   * @private
   */ this._controller = new $f812ed7651a5f0b7$exports(api.getZr());
    /**
   * @type {Object} {target, zoom, zoomLimit}
   * @private
   */ this._controllerHost = {
        target: updateGroup ? group : null
    };
    /**
   * @type {module:zrender/container/Group}
   * @readOnly
   */ this.group = group;
    /**
   * @type {boolean}
   * @private
   */ this._updateGroup = updateGroup;
    /**
   * This flag is used to make sure that only one among
   * `pan`, `zoom`, `click` can occurs, otherwise 'selected'
   * action may be triggered when `pan`, which is unexpected.
   * @type {booelan}
   */ this._mouseDownFlag;
    /**
   * @type {string}
   */ this._mapName;
    /**
   * @type {boolean}
   */ this._initialized;
    /**
   * @type {module:zrender/container/Group}
   */ group.add(this._regionsGroup = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4());
    /**
   * @type {module:zrender/container/Group}
   */ group.add(this._backgroundGroup = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4());
}
$3f31ab2d08c97478$var$MapDraw.prototype = {
    constructor: $3f31ab2d08c97478$var$MapDraw,
    draw: function(mapOrGeoModel, ecModel, api, fromView, payload) {
        var isGeo = mapOrGeoModel.mainType === "geo"; // Map series has data. GEO model that controlled by map series
        // will be assigned with map data. Other GEO model has no data.
        var data = mapOrGeoModel.getData && mapOrGeoModel.getData();
        isGeo && ecModel.eachComponent({
            mainType: "series",
            subType: "map"
        }, function(mapSeries) {
            if (!data && mapSeries.getHostGeoModel() === mapOrGeoModel) data = mapSeries.getData();
        });
        var geo = mapOrGeoModel.coordinateSystem;
        this._updateBackground(geo);
        var regionsGroup = this._regionsGroup;
        var group = this.group;
        var transformInfo = geo.getTransformInfo(); // No animation when first draw or in action
        var isFirstDraw = !regionsGroup.childAt(0) || payload;
        var targetScale;
        if (isFirstDraw) {
            group.transform = transformInfo.roamTransform;
            group.decomposeTransform();
            group.dirty();
        } else {
            var target = new $af5c198eb02e5120$exports();
            target.transform = transformInfo.roamTransform;
            target.decomposeTransform();
            var props = {
                scale: target.scale,
                position: target.position
            };
            targetScale = target.scale;
            $4b57d6b582d579b7$export$c8dce3c08436e91e(group, props, mapOrGeoModel);
        }
        var scale = transformInfo.rawScale;
        var position = transformInfo.rawPosition;
        regionsGroup.removeAll();
        var itemStyleAccessPath = [
            "itemStyle"
        ];
        var hoverItemStyleAccessPath = [
            "emphasis",
            "itemStyle"
        ];
        var labelAccessPath = [
            "label"
        ];
        var hoverLabelAccessPath = [
            "emphasis",
            "label"
        ];
        var nameMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4();
        $ec279652dd95c27b$export$79b2f7037acddd43(geo.regions, function(region) {
            // Consider in GeoJson properties.name may be duplicated, for example,
            // there is multiple region named "United Kindom" or "France" (so many
            // colonies). And it is not appropriate to merge them in geo, which
            // will make them share the same label and bring trouble in label
            // location calculation.
            var regionGroup = nameMap.get(region.name) || nameMap.set(region.name, new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4());
            var compoundPath = new $4b57d6b582d579b7$export$eabfbb332713dc05({
                segmentIgnoreThreshold: 1,
                shape: {
                    paths: []
                }
            });
            regionGroup.add(compoundPath);
            var regionModel = mapOrGeoModel.getRegionModel(region.name) || mapOrGeoModel;
            var itemStyleModel = regionModel.getModel(itemStyleAccessPath);
            var hoverItemStyleModel = regionModel.getModel(hoverItemStyleAccessPath);
            var itemStyle = $3f31ab2d08c97478$var$getFixedItemStyle(itemStyleModel);
            var hoverItemStyle = $3f31ab2d08c97478$var$getFixedItemStyle(hoverItemStyleModel);
            var labelModel = regionModel.getModel(labelAccessPath);
            var hoverLabelModel = regionModel.getModel(hoverLabelAccessPath);
            var dataIdx; // Use the itemStyle in data if has data
            if (data) {
                dataIdx = data.indexOfName(region.name); // Only visual color of each item will be used. It can be encoded by dataRange
                // But visual color of series is used in symbol drawing
                //
                // Visual color for each series is for the symbol draw
                var visualColor = data.getItemVisual(dataIdx, "color", true);
                if (visualColor) itemStyle.fill = visualColor;
            }
            var transformPoint = function(point) {
                return [
                    point[0] * scale[0] + position[0],
                    point[1] * scale[1] + position[1]
                ];
            };
            $ec279652dd95c27b$export$79b2f7037acddd43(region.geometries, function(geometry) {
                if (geometry.type !== "polygon") return;
                var points = [];
                for(var i = 0; i < geometry.exterior.length; ++i)points.push(transformPoint(geometry.exterior[i]));
                compoundPath.shape.paths.push(new $4b57d6b582d579b7$export$7d31b617c820d435({
                    segmentIgnoreThreshold: 1,
                    shape: {
                        points: points
                    }
                }));
                for(var i = 0; i < (geometry.interiors ? geometry.interiors.length : 0); ++i){
                    var interior = geometry.interiors[i];
                    var points = [];
                    for(var j = 0; j < interior.length; ++j)points.push(transformPoint(interior[j]));
                    compoundPath.shape.paths.push(new $4b57d6b582d579b7$export$7d31b617c820d435({
                        segmentIgnoreThreshold: 1,
                        shape: {
                            points: points
                        }
                    }));
                }
            });
            compoundPath.setStyle(itemStyle);
            compoundPath.style.strokeNoScale = true;
            compoundPath.culling = true; // Label
            var showLabel = labelModel.get("show");
            var hoverShowLabel = hoverLabelModel.get("show");
            var isDataNaN = data && isNaN(data.get(data.mapDimension("value"), dataIdx));
            var itemLayout = data && data.getItemLayout(dataIdx); // In the following cases label will be drawn
            // 1. In map series and data value is NaN
            // 2. In geo component
            // 4. Region has no series legendSymbol, which will be add a showLabel flag in mapSymbolLayout
            if (isGeo || isDataNaN && (showLabel || hoverShowLabel) || itemLayout && itemLayout.showLabel) {
                var query = !isGeo ? dataIdx : region.name;
                var labelFetcher; // Consider dataIdx not found.
                if (!data || dataIdx >= 0) labelFetcher = mapOrGeoModel;
                var textEl = new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
                    position: transformPoint(region.center.slice()),
                    // FIXME
                    // label rotation is not support yet in geo or regions of series-map
                    // that has no data. The rotation will be effected by this `scale`.
                    // So needed to change to RectText?
                    scale: [
                        1 / group.scale[0],
                        1 / group.scale[1]
                    ],
                    z2: 10,
                    silent: true
                });
                $4b57d6b582d579b7$export$9a13992917966657(textEl.style, textEl.hoverStyle = {}, labelModel, hoverLabelModel, {
                    labelFetcher: labelFetcher,
                    labelDataIndex: query,
                    defaultText: region.name,
                    useInsideStyle: false
                }, {
                    textAlign: "center",
                    textVerticalAlign: "middle"
                });
                if (!isFirstDraw) {
                    // Text animation
                    var textScale = [
                        1 / targetScale[0],
                        1 / targetScale[1]
                    ];
                    $4b57d6b582d579b7$export$c8dce3c08436e91e(textEl, {
                        scale: textScale
                    }, mapOrGeoModel);
                }
                regionGroup.add(textEl);
            } // setItemGraphicEl, setHoverStyle after all polygons and labels
            // are added to the rigionGroup
            if (data) data.setItemGraphicEl(dataIdx, regionGroup);
            else {
                var regionModel = mapOrGeoModel.getRegionModel(region.name); // Package custom mouse event for geo component
                compoundPath.eventData = {
                    componentType: "geo",
                    componentIndex: mapOrGeoModel.componentIndex,
                    geoIndex: mapOrGeoModel.componentIndex,
                    name: region.name,
                    region: regionModel && regionModel.option || {}
                };
            }
            var groupRegions = regionGroup.__regions || (regionGroup.__regions = []);
            groupRegions.push(region);
            regionGroup.highDownSilentOnTouch = !!mapOrGeoModel.get("selectedMode");
            $4b57d6b582d579b7$export$28b42df8183f218c(regionGroup, hoverItemStyle);
            regionsGroup.add(regionGroup);
        });
        this._updateController(mapOrGeoModel, ecModel, api);
        $3f31ab2d08c97478$var$updateMapSelectHandler(this, mapOrGeoModel, regionsGroup, api, fromView);
        $3f31ab2d08c97478$var$updateMapSelected(mapOrGeoModel, regionsGroup);
    },
    remove: function() {
        this._regionsGroup.removeAll();
        this._backgroundGroup.removeAll();
        this._controller.dispose();
        this._mapName && $2fbe62bcc4893be5$exports.removeGraphic(this._mapName, this.uid);
        this._mapName = null;
        this._controllerHost = {};
    },
    _updateBackground: function(geo) {
        var mapName = geo.map;
        if (this._mapName !== mapName) $ec279652dd95c27b$export$79b2f7037acddd43($2fbe62bcc4893be5$exports.makeGraphic(mapName, this.uid), function(root) {
            this._backgroundGroup.add(root);
        }, this);
        this._mapName = mapName;
    },
    _updateController: function(mapOrGeoModel, ecModel, api) {
        var geo = mapOrGeoModel.coordinateSystem;
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        controllerHost.zoomLimit = mapOrGeoModel.get("scaleLimit");
        controllerHost.zoom = geo.getZoom(); // roamType is will be set default true if it is null
        controller.enable(mapOrGeoModel.get("roam") || false);
        var mainType = mapOrGeoModel.mainType;
        function makeActionBase() {
            var action = {
                type: "geoRoam",
                componentType: mainType
            };
            action[mainType + "Id"] = mapOrGeoModel.id;
            return action;
        }
        controller.off("pan").on("pan", function(e) {
            this._mouseDownFlag = false;
            $b7c2af586a53b694$export$1e6abcd98caba733(controllerHost, e.dx, e.dy);
            api.dispatchAction($ec279652dd95c27b$export$8b58be045bf06082(makeActionBase(), {
                dx: e.dx,
                dy: e.dy
            }));
        }, this);
        controller.off("zoom").on("zoom", function(e) {
            this._mouseDownFlag = false;
            $b7c2af586a53b694$export$29b3c66d30a4866(controllerHost, e.scale, e.originX, e.originY);
            api.dispatchAction($ec279652dd95c27b$export$8b58be045bf06082(makeActionBase(), {
                zoom: e.scale,
                originX: e.originX,
                originY: e.originY
            }));
            if (this._updateGroup) {
                var scale = this.group.scale;
                this._regionsGroup.traverse(function(el) {
                    if (el.type === "text") el.attr("scale", [
                        1 / scale[0],
                        1 / scale[1]
                    ]);
                });
            }
        }, this);
        controller.setPointerChecker(function(e, x, y) {
            return geo.getViewRectAfterRoam().contain(x, y) && !$3f31ab2d08c97478$var$onIrrelevantElement(e, api, mapOrGeoModel);
        });
    }
};
var $3f31ab2d08c97478$var$_default = $3f31ab2d08c97478$var$MapDraw;
$3f31ab2d08c97478$exports = $3f31ab2d08c97478$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $f4c50d258f00706b$var$HIGH_DOWN_PROP = "__seriesMapHighDown";
var $f4c50d258f00706b$var$RECORD_VERSION_PROP = "__seriesMapCallKey";
var $f4c50d258f00706b$var$_default = $f406636b535430a7$exports.extendChartView({
    type: "map",
    render: function(mapModel, ecModel, api, payload) {
        // Not render if it is an toggleSelect action from self
        if (payload && payload.type === "mapToggleSelect" && payload.from === this.uid) return;
        var group = this.group;
        group.removeAll();
        if (mapModel.getHostGeoModel()) return;
         // Not update map if it is an roam action from self
        if (!(payload && payload.type === "geoRoam" && payload.componentType === "series" && payload.seriesId === mapModel.id)) {
            if (mapModel.needsDrawMap) {
                var mapDraw = this._mapDraw || new $3f31ab2d08c97478$exports(api, true);
                group.add(mapDraw.group);
                mapDraw.draw(mapModel, ecModel, api, this, payload);
                this._mapDraw = mapDraw;
            } else {
                // Remove drawed map
                this._mapDraw && this._mapDraw.remove();
                this._mapDraw = null;
            }
        } else {
            var mapDraw = this._mapDraw;
            mapDraw && group.add(mapDraw.group);
        }
        mapModel.get("showLegendSymbol") && ecModel.getComponent("legend") && this._renderSymbols(mapModel, ecModel, api);
    },
    remove: function() {
        this._mapDraw && this._mapDraw.remove();
        this._mapDraw = null;
        this.group.removeAll();
    },
    dispose: function() {
        this._mapDraw && this._mapDraw.remove();
        this._mapDraw = null;
    },
    _renderSymbols: function(mapModel, ecModel, api) {
        var originalData = mapModel.originalData;
        var group = this.group;
        originalData.each(originalData.mapDimension("value"), function(value, originalDataIndex) {
            if (isNaN(value)) return;
            var layout = originalData.getItemLayout(originalDataIndex);
            if (!layout || !layout.point) // Not exists in map
            return;
            var point = layout.point;
            var offset = layout.offset;
            var circle = new $4b57d6b582d579b7$export$c89a927ffc67e6fa({
                style: {
                    // Because the special of map draw.
                    // Which needs statistic of multiple series and draw on one map.
                    // And each series also need a symbol with legend color
                    //
                    // Layout and visual are put one the different data
                    fill: mapModel.getData().getVisual("color")
                },
                shape: {
                    cx: point[0] + offset * 9,
                    cy: point[1],
                    r: 3
                },
                silent: true,
                // Do not overlap the first series, on which labels are displayed.
                z2: 8 + (!offset ? $4b57d6b582d579b7$export$1cb9fc6ed5b9836c + 1 : 0)
            }); // Only the series that has the first value on the same region is in charge of rendering the label.
            // But consider the case:
            // series: [
            //     {id: 'X', type: 'map', map: 'm', {data: [{name: 'A', value: 11}, {name: 'B', {value: 22}]},
            //     {id: 'Y', type: 'map', map: 'm', {data: [{name: 'A', value: 21}, {name: 'C', {value: 33}]}
            // ]
            // The offset `0` of item `A` is at series `X`, but of item `C` is at series `Y`.
            // For backward compatibility, we follow the rule that render label `A` by the
            // settings on series `X` but render label `C` by the settings on series `Y`.
            if (!offset) {
                var fullData = mapModel.mainSeries.getData();
                var name = originalData.getName(originalDataIndex);
                var fullIndex = fullData.indexOfName(name);
                var itemModel = originalData.getItemModel(originalDataIndex);
                var labelModel = itemModel.getModel("label");
                var hoverLabelModel = itemModel.getModel("emphasis.label");
                var regionGroup = fullData.getItemGraphicEl(fullIndex); // `getFormattedLabel` needs to use `getData` inside. Here
                // `mapModel.getData()` is shallow cloned from `mainSeries.getData()`.
                // FIXME
                // If this is not the `mainSeries`, the item model (like label formatter)
                // set on original data item will never get. But it has been working
                // like that from the begining, and this scenario is rarely encountered.
                // So it won't be fixed until have to.
                var normalText = $ec279652dd95c27b$export$995e01f2f5c9d030(mapModel.getFormattedLabel(fullIndex, "normal"), name);
                var emphasisText = $ec279652dd95c27b$export$995e01f2f5c9d030(mapModel.getFormattedLabel(fullIndex, "emphasis"), normalText);
                var highDownRecord = regionGroup[$f4c50d258f00706b$var$HIGH_DOWN_PROP];
                var recordVersion = Math.random(); // Prevent from register listeners duplicatedly when roaming.
                if (!highDownRecord) {
                    highDownRecord = regionGroup[$f4c50d258f00706b$var$HIGH_DOWN_PROP] = {};
                    var onEmphasis = $ec279652dd95c27b$export$c3095a23b368d1f2($f4c50d258f00706b$var$onRegionHighDown, true);
                    var onNormal = $ec279652dd95c27b$export$c3095a23b368d1f2($f4c50d258f00706b$var$onRegionHighDown, false);
                    regionGroup.on("mouseover", onEmphasis).on("mouseout", onNormal).on("emphasis", onEmphasis).on("normal", onNormal);
                } // Prevent removed regions effect current grapics.
                regionGroup[$f4c50d258f00706b$var$RECORD_VERSION_PROP] = recordVersion;
                $ec279652dd95c27b$export$8b58be045bf06082(highDownRecord, {
                    recordVersion: recordVersion,
                    circle: circle,
                    labelModel: labelModel,
                    hoverLabelModel: hoverLabelModel,
                    emphasisText: emphasisText,
                    normalText: normalText
                }); // FIXME
                // Consider set option when emphasis.
                $f4c50d258f00706b$var$enterRegionHighDown(highDownRecord, false);
            }
            group.add(circle);
        });
    }
});
function $f4c50d258f00706b$var$onRegionHighDown(toHighOrDown) {
    var highDownRecord = this[$f4c50d258f00706b$var$HIGH_DOWN_PROP];
    if (highDownRecord && highDownRecord.recordVersion === this[$f4c50d258f00706b$var$RECORD_VERSION_PROP]) $f4c50d258f00706b$var$enterRegionHighDown(highDownRecord, toHighOrDown);
}
function $f4c50d258f00706b$var$enterRegionHighDown(highDownRecord, toHighOrDown) {
    var circle = highDownRecord.circle;
    var labelModel = highDownRecord.labelModel;
    var hoverLabelModel = highDownRecord.hoverLabelModel;
    var emphasisText = highDownRecord.emphasisText;
    var normalText = highDownRecord.normalText;
    if (toHighOrDown) {
        circle.style.extendFrom($4b57d6b582d579b7$export$6605af501964d89a({}, hoverLabelModel, {
            text: hoverLabelModel.get("show") ? emphasisText : null
        }, {
            isRectText: true,
            useInsideStyle: false
        }, true)); // Make label upper than others if overlaps.
        circle.__mapOriginalZ2 = circle.z2;
        circle.z2 += $4b57d6b582d579b7$export$1cb9fc6ed5b9836c;
    } else {
        $4b57d6b582d579b7$export$6605af501964d89a(circle.style, labelModel, {
            text: labelModel.get("show") ? normalText : null,
            textPosition: labelModel.getShallow("position") || "bottom"
        }, {
            isRectText: true,
            useInsideStyle: false
        }); // Trigger normalize style like padding.
        circle.dirty(false);
        if (circle.__mapOriginalZ2 != null) {
            circle.z2 = circle.__mapOriginalZ2;
            circle.__mapOriginalZ2 = null;
        }
    }
}
$f4c50d258f00706b$exports = $f4c50d258f00706b$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @param {module:echarts/coord/View} view
 * @param {Object} payload
 * @param {Object} [zoomLimit]
 */ var $80b2a59d4ab83148$export$797ecc50d262ebd8;
function $80b2a59d4ab83148$var$updateCenterAndZoom(view, payload, zoomLimit) {
    var previousZoom = view.getZoom();
    var center = view.getCenter();
    var zoom = payload.zoom;
    var point = view.dataToPoint(center);
    if (payload.dx != null && payload.dy != null) {
        point[0] -= payload.dx;
        point[1] -= payload.dy;
        var center = view.pointToData(point);
        view.setCenter(center);
    }
    if (zoom != null) {
        if (zoomLimit) {
            var zoomMin = zoomLimit.min || 0;
            var zoomMax = zoomLimit.max || Infinity;
            zoom = Math.max(Math.min(previousZoom * zoom, zoomMax), zoomMin) / previousZoom;
        } // Zoom on given point(originX, originY)
        view.scale[0] *= zoom;
        view.scale[1] *= zoom;
        var position = view.position;
        var fixX = (payload.originX - position[0]) * (zoom - 1);
        var fixY = (payload.originY - position[1]) * (zoom - 1);
        position[0] -= fixX;
        position[1] -= fixY;
        view.updateTransform(); // Get the new center
        var center = view.pointToData(point);
        view.setCenter(center);
        view.setZoom(zoom * previousZoom);
    }
    return {
        center: view.getCenter(),
        zoom: view.getZoom()
    };
}
$80b2a59d4ab83148$export$797ecc50d262ebd8 = $80b2a59d4ab83148$var$updateCenterAndZoom;


var $6739fd44fe573762$var$updateCenterAndZoom = $80b2a59d4ab83148$export$797ecc50d262ebd8;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @payload
 * @property {string} [componentType=series]
 * @property {number} [dx]
 * @property {number} [dy]
 * @property {number} [zoom]
 * @property {number} [originX]
 * @property {number} [originY]
 */ $f406636b535430a7$exports.registerAction({
    type: "geoRoam",
    event: "geoRoam",
    update: "updateTransform"
}, function(payload, ecModel) {
    var componentType = payload.componentType || "series";
    ecModel.eachComponent({
        mainType: componentType,
        query: payload
    }, function(componentModel) {
        var geo = componentModel.coordinateSystem;
        if (geo.type !== "geo") return;
        var res = $6739fd44fe573762$var$updateCenterAndZoom(geo, payload, componentModel.get("scaleLimit"));
        componentModel.setCenter && componentModel.setCenter(res.center);
        componentModel.setZoom && componentModel.setZoom(res.zoom); // All map series with same `map` use the same geo coordinate system
        // So the center and zoom must be in sync. Include the series not selected by legend
        if (componentType === "series") $ec279652dd95c27b$export$79b2f7037acddd43(componentModel.seriesGroup, function(seriesModel) {
            seriesModel.setCenter(res.center);
            seriesModel.setZoom(res.zoom);
        });
    });
});


var $19a6292b10a68530$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $19a6292b10a68530$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;


var $7ffcba078a1daa17$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $28347f1c81a620dc$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Simple view coordinate system
 * Mapping given x, y to transformd view x, y
 */ var $28347f1c81a620dc$var$v2ApplyTransform = $9eb63d101f3bcd79$export$9f9dcb98c894b623; // Dummy transform node
function $28347f1c81a620dc$var$TransformDummy() {
    $af5c198eb02e5120$exports.call(this);
}
$ec279652dd95c27b$export$e36fc9d62a853069($28347f1c81a620dc$var$TransformDummy, $af5c198eb02e5120$exports);
function $28347f1c81a620dc$var$View(name) {
    /**
   * @type {string}
   */ this.name = name;
    /**
   * @type {Object}
   */ this.zoomLimit;
    $af5c198eb02e5120$exports.call(this);
    this._roamTransformable = new $28347f1c81a620dc$var$TransformDummy();
    this._rawTransformable = new $28347f1c81a620dc$var$TransformDummy();
    this._center;
    this._zoom;
}
$28347f1c81a620dc$var$View.prototype = {
    constructor: $28347f1c81a620dc$var$View,
    type: "view",
    /**
   * @param {Array.<string>}
   * @readOnly
   */ dimensions: [
        "x",
        "y"
    ],
    /**
   * Set bounding rect
   * @param {number} x
   * @param {number} y
   * @param {number} width
   * @param {number} height
   */ // PENDING to getRect
    setBoundingRect: function(x, y, width, height) {
        this._rect = new $33e4fae744d34798$exports(x, y, width, height);
        return this._rect;
    },
    /**
   * @return {module:zrender/core/BoundingRect}
   */ // PENDING to getRect
    getBoundingRect: function() {
        return this._rect;
    },
    /**
   * @param {number} x
   * @param {number} y
   * @param {number} width
   * @param {number} height
   */ setViewRect: function(x, y, width, height) {
        this.transformTo(x, y, width, height);
        this._viewRect = new $33e4fae744d34798$exports(x, y, width, height);
    },
    /**
   * Transformed to particular position and size
   * @param {number} x
   * @param {number} y
   * @param {number} width
   * @param {number} height
   */ transformTo: function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var rawTransform = this._rawTransformable;
        rawTransform.transform = rect.calculateTransform(new $33e4fae744d34798$exports(x, y, width, height));
        rawTransform.decomposeTransform();
        this._updateTransform();
    },
    /**
   * Set center of view
   * @param {Array.<number>} [centerCoord]
   */ setCenter: function(centerCoord) {
        if (!centerCoord) return;
        this._center = centerCoord;
        this._updateCenterAndZoom();
    },
    /**
   * @param {number} zoom
   */ setZoom: function(zoom) {
        zoom = zoom || 1;
        var zoomLimit = this.zoomLimit;
        if (zoomLimit) {
            if (zoomLimit.max != null) zoom = Math.min(zoomLimit.max, zoom);
            if (zoomLimit.min != null) zoom = Math.max(zoomLimit.min, zoom);
        }
        this._zoom = zoom;
        this._updateCenterAndZoom();
    },
    /**
   * Get default center without roam
   */ getDefaultCenter: function() {
        // Rect before any transform
        var rawRect = this.getBoundingRect();
        var cx = rawRect.x + rawRect.width / 2;
        var cy = rawRect.y + rawRect.height / 2;
        return [
            cx,
            cy
        ];
    },
    getCenter: function() {
        return this._center || this.getDefaultCenter();
    },
    getZoom: function() {
        return this._zoom || 1;
    },
    /**
   * @return {Array.<number}
   */ getRoamTransform: function() {
        return this._roamTransformable.getLocalTransform();
    },
    /**
   * Remove roam
   */ _updateCenterAndZoom: function() {
        // Must update after view transform updated
        var rawTransformMatrix = this._rawTransformable.getLocalTransform();
        var roamTransform = this._roamTransformable;
        var defaultCenter = this.getDefaultCenter();
        var center = this.getCenter();
        var zoom = this.getZoom();
        center = $9eb63d101f3bcd79$export$9f9dcb98c894b623([], center, rawTransformMatrix);
        defaultCenter = $9eb63d101f3bcd79$export$9f9dcb98c894b623([], defaultCenter, rawTransformMatrix);
        roamTransform.origin = center;
        roamTransform.position = [
            defaultCenter[0] - center[0],
            defaultCenter[1] - center[1]
        ];
        roamTransform.scale = [
            zoom,
            zoom
        ];
        this._updateTransform();
    },
    /**
   * Update transform from roam and mapLocation
   * @private
   */ _updateTransform: function() {
        var roamTransformable = this._roamTransformable;
        var rawTransformable = this._rawTransformable;
        rawTransformable.parent = roamTransformable;
        roamTransformable.updateTransform();
        rawTransformable.updateTransform();
        $6c6dd9610ba660f0$export$784d13d8ee351f07(this.transform || (this.transform = []), rawTransformable.transform || $6c6dd9610ba660f0$export$185802fd694ee1f5());
        this._rawTransform = rawTransformable.getLocalTransform();
        this.invTransform = this.invTransform || [];
        $6c6dd9610ba660f0$export$6897c284b6f9f4dc(this.invTransform, this.transform);
        this.decomposeTransform();
    },
    getTransformInfo: function() {
        var roamTransform = this._roamTransformable.transform;
        var rawTransformable = this._rawTransformable;
        return {
            roamTransform: roamTransform ? $ec279652dd95c27b$export$58adb3bec8346d0f(roamTransform) : $6c6dd9610ba660f0$export$185802fd694ee1f5(),
            rawScale: $ec279652dd95c27b$export$58adb3bec8346d0f(rawTransformable.scale),
            rawPosition: $ec279652dd95c27b$export$58adb3bec8346d0f(rawTransformable.position)
        };
    },
    /**
   * @return {module:zrender/core/BoundingRect}
   */ getViewRect: function() {
        return this._viewRect;
    },
    /**
   * Get view rect after roam transform
   * @return {module:zrender/core/BoundingRect}
   */ getViewRectAfterRoam: function() {
        var rect = this.getBoundingRect().clone();
        rect.applyTransform(this.transform);
        return rect;
    },
    /**
   * Convert a single (lon, lat) data item to (x, y) point.
   * @param {Array.<number>} data
   * @param {boolean} noRoam
   * @param {Array.<number>} [out]
   * @return {Array.<number>}
   */ dataToPoint: function(data, noRoam, out) {
        var transform = noRoam ? this._rawTransform : this.transform;
        out = out || [];
        return transform ? $28347f1c81a620dc$var$v2ApplyTransform(out, data, transform) : $9eb63d101f3bcd79$export$784d13d8ee351f07(out, data);
    },
    /**
   * Convert a (x, y) point to (lon, lat) data
   * @param {Array.<number>} point
   * @return {Array.<number>}
   */ pointToData: function(point) {
        var invTransform = this.invTransform;
        return invTransform ? $28347f1c81a620dc$var$v2ApplyTransform([], point, invTransform) : [
            point[0],
            point[1]
        ];
    },
    /**
   * @implements
   * see {module:echarts/CoodinateSystem}
   */ convertToPixel: $ec279652dd95c27b$export$c3095a23b368d1f2($28347f1c81a620dc$var$doConvert, "dataToPoint"),
    /**
   * @implements
   * see {module:echarts/CoodinateSystem}
   */ convertFromPixel: $ec279652dd95c27b$export$c3095a23b368d1f2($28347f1c81a620dc$var$doConvert, "pointToData"),
    /**
   * @implements
   * see {module:echarts/CoodinateSystem}
   */ containPoint: function(point) {
        return this.getViewRectAfterRoam().contain(point[0], point[1]);
    }
};
$ec279652dd95c27b$export$e36fc9d62a853069($28347f1c81a620dc$var$View, $af5c198eb02e5120$exports);
function $28347f1c81a620dc$var$doConvert(methodName, ecModel, finder, value) {
    var seriesModel = finder.seriesModel;
    var coordSys = seriesModel ? seriesModel.coordinateSystem : null; // e.g., graph.
    return coordSys === this ? coordSys[methodName](value) : null;
}
var $28347f1c81a620dc$var$_default = $28347f1c81a620dc$var$View;
$28347f1c81a620dc$exports = $28347f1c81a620dc$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * [Geo description]
 * For backward compatibility, the orginal interface:
 * `name, map, geoJson, specialAreas, nameMap` is kept.
 *
 * @param {string|Object} name
 * @param {string} map Map type
 *        Specify the positioned areas by left, top, width, height
 * @param {Object.<string, string>} [nameMap]
 *        Specify name alias
 * @param {boolean} [invertLongitute=true]
 */ function $7ffcba078a1daa17$var$Geo(name, map, nameMap, invertLongitute) {
    $28347f1c81a620dc$exports.call(this, name);
    /**
   * Map type
   * @type {string}
   */ this.map = map;
    var source = $2fbe62bcc4893be5$exports.load(map, nameMap);
    this._nameCoordMap = source.nameCoordMap;
    this._regionsMap = source.regionsMap;
    this._invertLongitute = invertLongitute == null ? true : invertLongitute;
    /**
   * @readOnly
   */ this.regions = source.regions;
    /**
   * @type {module:zrender/src/core/BoundingRect}
   */ this._rect = source.boundingRect;
}
$7ffcba078a1daa17$var$Geo.prototype = {
    constructor: $7ffcba078a1daa17$var$Geo,
    type: "geo",
    /**
   * @param {Array.<string>}
   * @readOnly
   */ dimensions: [
        "lng",
        "lat"
    ],
    /**
   * If contain given lng,lat coord
   * @param {Array.<number>}
   * @readOnly
   */ containCoord: function(coord) {
        var regions = this.regions;
        for(var i = 0; i < regions.length; i++){
            if (regions[i].contain(coord)) return true;
        }
        return false;
    },
    /**
   * @override
   */ transformTo: function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var invertLongitute = this._invertLongitute;
        rect = rect.clone();
        if (invertLongitute) // Longitute is inverted
        rect.y = -rect.y - rect.height;
        var rawTransformable = this._rawTransformable;
        rawTransformable.transform = rect.calculateTransform(new $33e4fae744d34798$exports(x, y, width, height));
        rawTransformable.decomposeTransform();
        if (invertLongitute) {
            var scale = rawTransformable.scale;
            scale[1] = -scale[1];
        }
        rawTransformable.updateTransform();
        this._updateTransform();
    },
    /**
   * @param {string} name
   * @return {module:echarts/coord/geo/Region}
   */ getRegion: function(name) {
        return this._regionsMap.get(name);
    },
    getRegionByCoord: function(coord) {
        var regions = this.regions;
        for(var i = 0; i < regions.length; i++){
            if (regions[i].contain(coord)) return regions[i];
        }
    },
    /**
   * Add geoCoord for indexing by name
   * @param {string} name
   * @param {Array.<number>} geoCoord
   */ addGeoCoord: function(name, geoCoord) {
        this._nameCoordMap.set(name, geoCoord);
    },
    /**
   * Get geoCoord by name
   * @param {string} name
   * @return {Array.<number>}
   */ getGeoCoord: function(name) {
        return this._nameCoordMap.get(name);
    },
    /**
   * @override
   */ getBoundingRect: function() {
        return this._rect;
    },
    /**
   * @param {string|Array.<number>} data
   * @param {boolean} noRoam
   * @param {Array.<number>} [out]
   * @return {Array.<number>}
   */ dataToPoint: function(data, noRoam, out) {
        if (typeof data === "string") // Map area name to geoCoord
        data = this.getGeoCoord(data);
        if (data) return $28347f1c81a620dc$exports.prototype.dataToPoint.call(this, data, noRoam, out);
    },
    /**
   * @override
   */ convertToPixel: $ec279652dd95c27b$export$c3095a23b368d1f2($7ffcba078a1daa17$var$doConvert, "dataToPoint"),
    /**
   * @override
   */ convertFromPixel: $ec279652dd95c27b$export$c3095a23b368d1f2($7ffcba078a1daa17$var$doConvert, "pointToData")
};
$ec279652dd95c27b$export$e36fc9d62a853069($7ffcba078a1daa17$var$Geo, $28347f1c81a620dc$exports);
function $7ffcba078a1daa17$var$doConvert(methodName, ecModel, finder, value) {
    var geoModel = finder.geoModel;
    var seriesModel = finder.seriesModel;
    var coordSys = geoModel ? geoModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem // For map.
     || (seriesModel.getReferringComponents("geo")[0] || {}).coordinateSystem : null;
    return coordSys === this ? coordSys[methodName](value) : null;
}
var $7ffcba078a1daa17$var$_default = $7ffcba078a1daa17$var$Geo;
$7ffcba078a1daa17$exports = $7ffcba078a1daa17$var$_default;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Resize method bound to the geo
 * @param {module:echarts/coord/geo/GeoModel|module:echarts/chart/map/MapModel} geoModel
 * @param {module:echarts/ExtensionAPI} api
 */ function $19a6292b10a68530$var$resizeGeo(geoModel, api) {
    var boundingCoords = geoModel.get("boundingCoords");
    if (boundingCoords != null) {
        var leftTop = boundingCoords[0];
        var rightBottom = boundingCoords[1];
        if (isNaN(leftTop[0]) || isNaN(leftTop[1]) || isNaN(rightBottom[0]) || isNaN(rightBottom[1])) ;
        else this.setBoundingRect(leftTop[0], leftTop[1], rightBottom[0] - leftTop[0], rightBottom[1] - leftTop[1]);
    }
    var rect = this.getBoundingRect();
    var boxLayoutOption;
    var center = geoModel.get("layoutCenter");
    var size = geoModel.get("layoutSize");
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    var aspect = rect.width / rect.height * this.aspectScale;
    var useCenterAndSize = false;
    if (center && size) {
        center = [
            $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(center[0], viewWidth),
            $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(center[1], viewHeight)
        ];
        size = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(size, Math.min(viewWidth, viewHeight));
        if (!isNaN(center[0]) && !isNaN(center[1]) && !isNaN(size)) useCenterAndSize = true;
    }
    var viewRect;
    if (useCenterAndSize) {
        var viewRect = {};
        if (aspect > 1) {
            // Width is same with size
            viewRect.width = size;
            viewRect.height = size / aspect;
        } else {
            viewRect.height = size;
            viewRect.width = size * aspect;
        }
        viewRect.y = center[1] - viewRect.height / 2;
        viewRect.x = center[0] - viewRect.width / 2;
    } else {
        // Use left/top/width/height
        boxLayoutOption = geoModel.getBoxLayoutParams(); // 0.75 rate
        boxLayoutOption.aspect = aspect;
        viewRect = $ab0c9086dd6c5b39$export$4517a5ca639a7293(boxLayoutOption, {
            width: viewWidth,
            height: viewHeight
        });
    }
    this.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
    this.setCenter(geoModel.get("center"));
    this.setZoom(geoModel.get("zoom"));
}
/**
 * @param {module:echarts/coord/Geo} geo
 * @param {module:echarts/model/Model} model
 * @inner
 */ function $19a6292b10a68530$var$setGeoCoords(geo, model) {
    $ec279652dd95c27b$export$79b2f7037acddd43(model.get("geoCoord"), function(geoCoord, name) {
        geo.addGeoCoord(name, geoCoord);
    });
}
var $19a6292b10a68530$var$geoCreator = {
    // For deciding which dimensions to use when creating list data
    dimensions: $7ffcba078a1daa17$exports.prototype.dimensions,
    create: function(ecModel, api) {
        var geoList = []; // FIXME Create each time may be slow
        ecModel.eachComponent("geo", function(geoModel, idx) {
            var name = geoModel.get("map");
            var aspectScale = geoModel.get("aspectScale");
            var invertLongitute = true;
            var mapRecords = $cc0f61c9f8527b8d$exports.retrieveMap(name);
            if (mapRecords && mapRecords[0] && mapRecords[0].type === "svg") {
                aspectScale == null && (aspectScale = 1);
                invertLongitute = false;
            } else aspectScale == null && (aspectScale = 0.75);
            var geo = new $7ffcba078a1daa17$exports(name + idx, name, geoModel.get("nameMap"), invertLongitute);
            geo.aspectScale = aspectScale;
            geo.zoomLimit = geoModel.get("scaleLimit");
            geoList.push(geo);
            $19a6292b10a68530$var$setGeoCoords(geo, geoModel);
            geoModel.coordinateSystem = geo;
            geo.model = geoModel; // Inject resize method
            geo.resize = $19a6292b10a68530$var$resizeGeo;
            geo.resize(geoModel, api);
        });
        ecModel.eachSeries(function(seriesModel) {
            var coordSys = seriesModel.get("coordinateSystem");
            if (coordSys === "geo") {
                var geoIndex = seriesModel.get("geoIndex") || 0;
                seriesModel.coordinateSystem = geoList[geoIndex];
            }
        }); // If has map series
        var mapModelGroupBySeries = {};
        ecModel.eachSeriesByType("map", function(seriesModel) {
            if (!seriesModel.getHostGeoModel()) {
                var mapType = seriesModel.getMapType();
                mapModelGroupBySeries[mapType] = mapModelGroupBySeries[mapType] || [];
                mapModelGroupBySeries[mapType].push(seriesModel);
            }
        });
        $ec279652dd95c27b$export$79b2f7037acddd43(mapModelGroupBySeries, function(mapSeries, mapType) {
            var nameMapList = $ec279652dd95c27b$export$871de8747c9eaa88(mapSeries, function(singleMapSeries) {
                return singleMapSeries.get("nameMap");
            });
            var geo = new $7ffcba078a1daa17$exports(mapType, mapType, $ec279652dd95c27b$export$18aef43295bbe906(nameMapList));
            geo.zoomLimit = $ec279652dd95c27b$export$8a4d17b6e8486e66.apply(null, $ec279652dd95c27b$export$871de8747c9eaa88(mapSeries, function(singleMapSeries) {
                return singleMapSeries.get("scaleLimit");
            }));
            geoList.push(geo); // Inject resize method
            geo.resize = $19a6292b10a68530$var$resizeGeo;
            geo.aspectScale = mapSeries[0].get("aspectScale");
            geo.resize(mapSeries[0], api);
            $ec279652dd95c27b$export$79b2f7037acddd43(mapSeries, function(singleMapSeries) {
                singleMapSeries.coordinateSystem = geo;
                $19a6292b10a68530$var$setGeoCoords(geo, singleMapSeries);
            });
        });
        return geoList;
    },
    /**
   * Fill given regions array
   * @param  {Array.<Object>} originRegionArr
   * @param  {string} mapName
   * @param  {Object} [nameMap]
   * @return {Array}
   */ getFilledRegions: function(originRegionArr, mapName, nameMap) {
        // Not use the original
        var regionsArr = (originRegionArr || []).slice();
        var dataNameMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4();
        for(var i = 0; i < regionsArr.length; i++)dataNameMap.set(regionsArr[i].name, regionsArr[i]);
        var source = $2fbe62bcc4893be5$exports.load(mapName, nameMap);
        $ec279652dd95c27b$export$79b2f7037acddd43(source.regions, function(region) {
            var name = region.name;
            !dataNameMap.get(name) && regionsArr.push({
                name: name
            });
        });
        return regionsArr;
    }
};
$f406636b535430a7$exports.registerCoordinateSystem("geo", $19a6292b10a68530$var$geoCreator);
var $19a6292b10a68530$var$_default = $19a6292b10a68530$var$geoCreator;
$19a6292b10a68530$exports = $19a6292b10a68530$var$_default;


var $343e19b4f53dabd8$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $343e19b4f53dabd8$var$_default(ecModel) {
    var processedMapType = {};
    ecModel.eachSeriesByType("map", function(mapSeries) {
        var mapType = mapSeries.getMapType();
        if (mapSeries.getHostGeoModel() || processedMapType[mapType]) return;
        var mapSymbolOffsets = {};
        $ec279652dd95c27b$export$79b2f7037acddd43(mapSeries.seriesGroup, function(subMapSeries) {
            var geo = subMapSeries.coordinateSystem;
            var data = subMapSeries.originalData;
            if (subMapSeries.get("showLegendSymbol") && ecModel.getComponent("legend")) data.each(data.mapDimension("value"), function(value, idx) {
                var name = data.getName(idx);
                var region = geo.getRegion(name); // If input series.data is [11, 22, '-'/null/undefined, 44],
                // it will be filled with NaN: [11, 22, NaN, 44] and NaN will
                // not be drawn. So here must validate if value is NaN.
                if (!region || isNaN(value)) return;
                var offset = mapSymbolOffsets[name] || 0;
                var point = geo.dataToPoint(region.center);
                mapSymbolOffsets[name] = offset + 1;
                data.setItemLayout(idx, {
                    point: point,
                    offset: offset
                });
            });
        }); // Show label of those region not has legendSymbol(which is offset 0)
        var data = mapSeries.getData();
        data.each(function(idx) {
            var name = data.getName(idx);
            var layout = data.getItemLayout(idx) || {};
            layout.showLabel = !mapSymbolOffsets[name];
            data.setItemLayout(idx, layout);
        });
        processedMapType[mapType] = true;
    });
}
$343e19b4f53dabd8$exports = $343e19b4f53dabd8$var$_default;


var $4e47571de94013fd$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $4e47571de94013fd$var$_default(ecModel) {
    ecModel.eachSeriesByType("map", function(seriesModel) {
        var colorList = seriesModel.get("color");
        var itemStyleModel = seriesModel.getModel("itemStyle");
        var areaColor = itemStyleModel.get("areaColor");
        var color = itemStyleModel.get("color") || colorList[seriesModel.seriesIndex % colorList.length];
        seriesModel.getData().setVisual({
            "areaColor": areaColor,
            "color": color
        });
    });
}
$4e47571de94013fd$exports = $4e47571de94013fd$var$_default;


var $7347b769b8b57432$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME 公用？
/**
 * @param {Array.<module:echarts/data/List>} datas
 * @param {string} statisticType 'average' 'sum'
 * @inner
 */ function $7347b769b8b57432$var$dataStatistics(datas, statisticType) {
    var dataNameMap = {};
    $ec279652dd95c27b$export$79b2f7037acddd43(datas, function(data) {
        data.each(data.mapDimension("value"), function(value, idx) {
            // Add prefix to avoid conflict with Object.prototype.
            var mapKey = "ec-" + data.getName(idx);
            dataNameMap[mapKey] = dataNameMap[mapKey] || [];
            if (!isNaN(value)) dataNameMap[mapKey].push(value);
        });
    });
    return datas[0].map(datas[0].mapDimension("value"), function(value, idx) {
        var mapKey = "ec-" + datas[0].getName(idx);
        var sum = 0;
        var min = Infinity;
        var max = -Infinity;
        var len = dataNameMap[mapKey].length;
        for(var i = 0; i < len; i++){
            min = Math.min(min, dataNameMap[mapKey][i]);
            max = Math.max(max, dataNameMap[mapKey][i]);
            sum += dataNameMap[mapKey][i];
        }
        var result;
        if (statisticType === "min") result = min;
        else if (statisticType === "max") result = max;
        else if (statisticType === "average") result = sum / len;
        else result = sum;
        return len === 0 ? NaN : result;
    });
}
function $7347b769b8b57432$var$_default(ecModel) {
    var seriesGroups = {};
    ecModel.eachSeriesByType("map", function(seriesModel) {
        var hostGeoModel = seriesModel.getHostGeoModel();
        var key = hostGeoModel ? "o" + hostGeoModel.id : "i" + seriesModel.getMapType();
        (seriesGroups[key] = seriesGroups[key] || []).push(seriesModel);
    });
    $ec279652dd95c27b$export$79b2f7037acddd43(seriesGroups, function(seriesList, key) {
        var data = $7347b769b8b57432$var$dataStatistics($ec279652dd95c27b$export$871de8747c9eaa88(seriesList, function(seriesModel) {
            return seriesModel.getData();
        }), seriesList[0].get("mapValueCalculation"));
        for(var i = 0; i < seriesList.length; i++)seriesList[i].originalData = seriesList[i].getData();
         // FIXME Put where?
        for(var i = 0; i < seriesList.length; i++){
            seriesList[i].seriesGroup = seriesList;
            seriesList[i].needsDrawMap = i === 0 && !seriesList[i].getHostGeoModel();
            seriesList[i].setData(data.cloneShallow());
            seriesList[i].mainSeries = seriesList[0];
        }
    });
}
$7347b769b8b57432$exports = $7347b769b8b57432$var$_default;


var $0115e26f25e99510$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $0115e26f25e99510$var$_default(option) {
    // Save geoCoord
    var mapSeries = [];
    $ec279652dd95c27b$export$79b2f7037acddd43(option.series, function(seriesOpt) {
        if (seriesOpt && seriesOpt.type === "map") {
            mapSeries.push(seriesOpt);
            seriesOpt.map = seriesOpt.map || seriesOpt.mapType; // Put x, y, width, height, x2, y2 in the top level
            $ec279652dd95c27b$export$ebe90cb607ad99e(seriesOpt, seriesOpt.mapLocation);
        }
    });
}
$0115e26f25e99510$exports = $0115e26f25e99510$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerLayout($343e19b4f53dabd8$exports);
$f406636b535430a7$exports.registerVisual($4e47571de94013fd$exports);
$f406636b535430a7$exports.registerProcessor($f406636b535430a7$exports.PRIORITY.PROCESSOR.STATISTIC, $7347b769b8b57432$exports);
$f406636b535430a7$exports.registerPreprocessor($0115e26f25e99510$exports);
$0bc18fa5df3b90ab$exports("map", [
    {
        type: "mapToggleSelect",
        event: "mapselectchanged",
        method: "toggleSelected"
    },
    {
        type: "mapSelect",
        event: "mapselected",
        method: "select"
    },
    {
        type: "mapUnSelect",
        event: "mapunselected",
        method: "unSelect"
    }
]);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eaf5ad59e8442cf7$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $b7a0421515afdfda$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $e71b48bcfe9ccb76$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Link lists and struct (graph or tree)
 */ var $e71b48bcfe9ccb76$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $e71b48bcfe9ccb76$var$DATAS = "\x00__link_datas";
var $e71b48bcfe9ccb76$var$MAIN_DATA = "\x00__link_mainData"; // Caution:
// In most case, either list or its shallow clones (see list.cloneShallow)
// is active in echarts process. So considering heap memory consumption,
// we do not clone tree or graph, but share them among list and its shallow clones.
// But in some rare case, we have to keep old list (like do animation in chart). So
// please take care that both the old list and the new list share the same tree/graph.
/**
 * @param {Object} opt
 * @param {module:echarts/data/List} opt.mainData
 * @param {Object} [opt.struct] For example, instance of Graph or Tree.
 * @param {string} [opt.structAttr] designation: list[structAttr] = struct;
 * @param {Object} [opt.datas] {dataType: data},
 *                 like: {node: nodeList, edge: edgeList}.
 *                 Should contain mainData.
 * @param {Object} [opt.datasAttr] {dataType: attr},
 *                 designation: struct[datasAttr[dataType]] = list;
 */ function $e71b48bcfe9ccb76$var$linkList(opt) {
    var mainData = opt.mainData;
    var datas = opt.datas;
    if (!datas) {
        datas = {
            main: mainData
        };
        opt.datasAttr = {
            main: "data"
        };
    }
    opt.datas = opt.mainData = null;
    $e71b48bcfe9ccb76$var$linkAll(mainData, datas, opt); // Porxy data original methods.
    $e71b48bcfe9ccb76$var$each(datas, function(data) {
        $e71b48bcfe9ccb76$var$each(mainData.TRANSFERABLE_METHODS, function(methodName) {
            data.wrapMethod(methodName, $ec279652dd95c27b$export$c3095a23b368d1f2($e71b48bcfe9ccb76$var$transferInjection, opt));
        });
    }); // Beyond transfer, additional features should be added to `cloneShallow`.
    mainData.wrapMethod("cloneShallow", $ec279652dd95c27b$export$c3095a23b368d1f2($e71b48bcfe9ccb76$var$cloneShallowInjection, opt)); // Only mainData trigger change, because struct.update may trigger
    // another changable methods, which may bring about dead lock.
    $e71b48bcfe9ccb76$var$each(mainData.CHANGABLE_METHODS, function(methodName) {
        mainData.wrapMethod(methodName, $ec279652dd95c27b$export$c3095a23b368d1f2($e71b48bcfe9ccb76$var$changeInjection, opt));
    }); // Make sure datas contains mainData.
    $ec279652dd95c27b$export$a7a9523472993e97(datas[mainData.dataType] === mainData);
}
function $e71b48bcfe9ccb76$var$transferInjection(opt, res) {
    if ($e71b48bcfe9ccb76$var$isMainData(this)) {
        // Transfer datas to new main data.
        var datas = $ec279652dd95c27b$export$8b58be045bf06082({}, this[$e71b48bcfe9ccb76$var$DATAS]);
        datas[this.dataType] = res;
        $e71b48bcfe9ccb76$var$linkAll(res, datas, opt);
    } else // Modify the reference in main data to point newData.
    $e71b48bcfe9ccb76$var$linkSingle(res, this.dataType, this[$e71b48bcfe9ccb76$var$MAIN_DATA], opt);
    return res;
}
function $e71b48bcfe9ccb76$var$changeInjection(opt, res) {
    opt.struct && opt.struct.update(this);
    return res;
}
function $e71b48bcfe9ccb76$var$cloneShallowInjection(opt, res) {
    // cloneShallow, which brings about some fragilities, may be inappropriate
    // to be exposed as an API. So for implementation simplicity we can make
    // the restriction that cloneShallow of not-mainData should not be invoked
    // outside, but only be invoked here.
    $e71b48bcfe9ccb76$var$each(res[$e71b48bcfe9ccb76$var$DATAS], function(data, dataType) {
        data !== res && $e71b48bcfe9ccb76$var$linkSingle(data.cloneShallow(), dataType, res, opt);
    });
    return res;
}
/**
 * Supplement method to List.
 *
 * @public
 * @param {string} [dataType] If not specified, return mainData.
 * @return {module:echarts/data/List}
 */ function $e71b48bcfe9ccb76$var$getLinkedData(dataType) {
    var mainData = this[$e71b48bcfe9ccb76$var$MAIN_DATA];
    return dataType == null || mainData == null ? mainData : mainData[$e71b48bcfe9ccb76$var$DATAS][dataType];
}
function $e71b48bcfe9ccb76$var$isMainData(data) {
    return data[$e71b48bcfe9ccb76$var$MAIN_DATA] === data;
}
function $e71b48bcfe9ccb76$var$linkAll(mainData, datas, opt) {
    mainData[$e71b48bcfe9ccb76$var$DATAS] = {};
    $e71b48bcfe9ccb76$var$each(datas, function(data, dataType) {
        $e71b48bcfe9ccb76$var$linkSingle(data, dataType, mainData, opt);
    });
}
function $e71b48bcfe9ccb76$var$linkSingle(data, dataType, mainData, opt) {
    mainData[$e71b48bcfe9ccb76$var$DATAS][dataType] = data;
    data[$e71b48bcfe9ccb76$var$MAIN_DATA] = mainData;
    data.dataType = dataType;
    if (opt.struct) {
        data[opt.structAttr] = opt.struct;
        opt.struct[opt.datasAttr[dataType]] = data;
    } // Supplement method.
    data.getLinkedData = $e71b48bcfe9ccb76$var$getLinkedData;
}
var $e71b48bcfe9ccb76$var$_default = $e71b48bcfe9ccb76$var$linkList;
$e71b48bcfe9ccb76$exports = $e71b48bcfe9ccb76$var$_default;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Tree data structure
 *
 * @module echarts/data/Tree
 */ /**
 * @constructor module:echarts/data/Tree~TreeNode
 * @param {string} name
 * @param {module:echarts/data/Tree} hostTree
 */ var $b7a0421515afdfda$var$TreeNode = function(name, hostTree) {
    /**
   * @type {string}
   */ this.name = name || "";
    /**
   * Depth of node
   *
   * @type {number}
   * @readOnly
   */ this.depth = 0;
    /**
   * Height of the subtree rooted at this node.
   * @type {number}
   * @readOnly
   */ this.height = 0;
    /**
   * @type {module:echarts/data/Tree~TreeNode}
   * @readOnly
   */ this.parentNode = null;
    /**
   * Reference to list item.
   * Do not persistent dataIndex outside,
   * besause it may be changed by list.
   * If dataIndex -1,
   * this node is logical deleted (filtered) in list.
   *
   * @type {Object}
   * @readOnly
   */ this.dataIndex = -1;
    /**
   * @type {Array.<module:echarts/data/Tree~TreeNode>}
   * @readOnly
   */ this.children = [];
    /**
   * @type {Array.<module:echarts/data/Tree~TreeNode>}
   * @pubilc
   */ this.viewChildren = [];
    /**
   * @type {moduel:echarts/data/Tree}
   * @readOnly
   */ this.hostTree = hostTree;
};
$b7a0421515afdfda$var$TreeNode.prototype = {
    constructor: $b7a0421515afdfda$var$TreeNode,
    /**
   * The node is removed.
   * @return {boolean} is removed.
   */ isRemoved: function() {
        return this.dataIndex < 0;
    },
    /**
   * Travel this subtree (include this node).
   * Usage:
   *    node.eachNode(function () { ... }); // preorder
   *    node.eachNode('preorder', function () { ... }); // preorder
   *    node.eachNode('postorder', function () { ... }); // postorder
   *    node.eachNode(
   *        {order: 'postorder', attr: 'viewChildren'},
   *        function () { ... }
   *    ); // postorder
   *
   * @param {(Object|string)} options If string, means order.
   * @param {string=} options.order 'preorder' or 'postorder'
   * @param {string=} options.attr 'children' or 'viewChildren'
   * @param {Function} cb If in preorder and return false,
   *                      its subtree will not be visited.
   * @param {Object} [context]
   */ eachNode: function(options, cb, context) {
        if (typeof options === "function") {
            context = cb;
            cb = options;
            options = null;
        }
        options = options || {};
        if ($ec279652dd95c27b$export$844ec244b1367d54(options)) options = {
            order: options
        };
        var order = options.order || "preorder";
        var children = this[options.attr || "children"];
        var suppressVisitSub;
        order === "preorder" && (suppressVisitSub = cb.call(context, this));
        for(var i = 0; !suppressVisitSub && i < children.length; i++)children[i].eachNode(options, cb, context);
        order === "postorder" && cb.call(context, this);
    },
    /**
   * Update depth and height of this subtree.
   *
   * @param  {number} depth
   */ updateDepthAndHeight: function(depth) {
        var height = 0;
        this.depth = depth;
        for(var i = 0; i < this.children.length; i++){
            var child = this.children[i];
            child.updateDepthAndHeight(depth + 1);
            if (child.height > height) height = child.height;
        }
        this.height = height + 1;
    },
    /**
   * @param  {string} id
   * @return {module:echarts/data/Tree~TreeNode}
   */ getNodeById: function(id) {
        if (this.getId() === id) return this;
        for(var i = 0, children = this.children, len = children.length; i < len; i++){
            var res = children[i].getNodeById(id);
            if (res) return res;
        }
    },
    /**
   * @param {module:echarts/data/Tree~TreeNode} node
   * @return {boolean}
   */ contains: function(node) {
        if (node === this) return true;
        for(var i = 0, children = this.children, len = children.length; i < len; i++){
            var res = children[i].contains(node);
            if (res) return res;
        }
    },
    /**
   * @param {boolean} includeSelf Default false.
   * @return {Array.<module:echarts/data/Tree~TreeNode>} order: [root, child, grandchild, ...]
   */ getAncestors: function(includeSelf) {
        var ancestors = [];
        var node = includeSelf ? this : this.parentNode;
        while(node){
            ancestors.push(node);
            node = node.parentNode;
        }
        ancestors.reverse();
        return ancestors;
    },
    /**
   * @param {string|Array=} [dimension='value'] Default 'value'. can be 0, 1, 2, 3
   * @return {number} Value.
   */ getValue: function(dimension) {
        var data = this.hostTree.data;
        return data.get(data.getDimension(dimension || "value"), this.dataIndex);
    },
    /**
   * @param {Object} layout
   * @param {boolean=} [merge=false]
   */ setLayout: function(layout, merge) {
        this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, layout, merge);
    },
    /**
   * @return {Object} layout
   */ getLayout: function() {
        return this.hostTree.data.getItemLayout(this.dataIndex);
    },
    /**
   * @param {string} [path]
   * @return {module:echarts/model/Model}
   */ getModel: function(path) {
        if (this.dataIndex < 0) return;
        var hostTree = this.hostTree;
        var itemModel = hostTree.data.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    },
    /**
   * @example
   *  setItemVisual('color', color);
   *  setItemVisual({
   *      'color': color
   *  });
   */ setVisual: function(key, value) {
        this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, key, value);
    },
    /**
   * Get item visual
   */ getVisual: function(key, ignoreParent) {
        return this.hostTree.data.getItemVisual(this.dataIndex, key, ignoreParent);
    },
    /**
   * @public
   * @return {number}
   */ getRawIndex: function() {
        return this.hostTree.data.getRawIndex(this.dataIndex);
    },
    /**
   * @public
   * @return {string}
   */ getId: function() {
        return this.hostTree.data.getId(this.dataIndex);
    },
    /**
   * if this is an ancestor of another node
   *
   * @public
   * @param {TreeNode} node another node
   * @return {boolean} if is ancestor
   */ isAncestorOf: function(node) {
        var parent = node.parentNode;
        while(parent){
            if (parent === this) return true;
            parent = parent.parentNode;
        }
        return false;
    },
    /**
   * if this is an descendant of another node
   *
   * @public
   * @param {TreeNode} node another node
   * @return {boolean} if is descendant
   */ isDescendantOf: function(node) {
        return node !== this && node.isAncestorOf(this);
    }
};
/**
 * @constructor
 * @alias module:echarts/data/Tree
 * @param {module:echarts/model/Model} hostModel
 */ function $b7a0421515afdfda$var$Tree(hostModel) {
    /**
   * @type {module:echarts/data/Tree~TreeNode}
   * @readOnly
   */ this.root;
    /**
   * @type {module:echarts/data/List}
   * @readOnly
   */ this.data;
    /**
   * Index of each item is the same as the raw index of coresponding list item.
   * @private
   * @type {Array.<module:echarts/data/Tree~TreeNode}
   */ this._nodes = [];
    /**
   * @private
   * @readOnly
   * @type {module:echarts/model/Model}
   */ this.hostModel = hostModel;
}
$b7a0421515afdfda$var$Tree.prototype = {
    constructor: $b7a0421515afdfda$var$Tree,
    type: "tree",
    /**
   * Travel this subtree (include this node).
   * Usage:
   *    node.eachNode(function () { ... }); // preorder
   *    node.eachNode('preorder', function () { ... }); // preorder
   *    node.eachNode('postorder', function () { ... }); // postorder
   *    node.eachNode(
   *        {order: 'postorder', attr: 'viewChildren'},
   *        function () { ... }
   *    ); // postorder
   *
   * @param {(Object|string)} options If string, means order.
   * @param {string=} options.order 'preorder' or 'postorder'
   * @param {string=} options.attr 'children' or 'viewChildren'
   * @param {Function} cb
   * @param {Object}   [context]
   */ eachNode: function(options, cb, context) {
        this.root.eachNode(options, cb, context);
    },
    /**
   * @param {number} dataIndex
   * @return {module:echarts/data/Tree~TreeNode}
   */ getNodeByDataIndex: function(dataIndex) {
        var rawIndex = this.data.getRawIndex(dataIndex);
        return this._nodes[rawIndex];
    },
    /**
   * @param {string} name
   * @return {module:echarts/data/Tree~TreeNode}
   */ getNodeByName: function(name) {
        return this.root.getNodeByName(name);
    },
    /**
   * Update item available by list,
   * when list has been performed options like 'filterSelf' or 'map'.
   */ update: function() {
        var data = this.data;
        var nodes = this._nodes;
        for(var i = 0, len = nodes.length; i < len; i++)nodes[i].dataIndex = -1;
        for(var i = 0, len = data.count(); i < len; i++)nodes[data.getRawIndex(i)].dataIndex = i;
    },
    /**
   * Clear all layouts
   */ clearLayouts: function() {
        this.data.clearItemLayouts();
    }
};
/**
 * data node format:
 * {
 *     name: ...
 *     value: ...
 *     children: [
 *         {
 *             name: ...
 *             value: ...
 *             children: ...
 *         },
 *         ...
 *     ]
 * }
 *
 * @static
 * @param {Object} dataRoot Root node.
 * @param {module:echarts/model/Model} hostModel
 * @return module:echarts/data/Tree
 */ $b7a0421515afdfda$var$Tree.createTree = function(dataRoot, hostModel, beforeLink) {
    var tree = new $b7a0421515afdfda$var$Tree(hostModel);
    var listData = [];
    var dimMax = 1;
    buildHierarchy(dataRoot);
    function buildHierarchy(dataNode, parentNode) {
        var value = dataNode.value;
        dimMax = Math.max(dimMax, $ec279652dd95c27b$export$43bee75e5e14138e(value) ? value.length : 1);
        listData.push(dataNode);
        var node = new $b7a0421515afdfda$var$TreeNode(dataNode.name, tree);
        parentNode ? $b7a0421515afdfda$var$addChild(node, parentNode) : tree.root = node;
        tree._nodes.push(node);
        var children = dataNode.children;
        if (children) for(var i = 0; i < children.length; i++)buildHierarchy(children[i], node);
    }
    tree.root.updateDepthAndHeight(0);
    var dimensionsInfo = $c766697b1ee08f64$exports(listData, {
        coordDimensions: [
            "value"
        ],
        dimensionsCount: dimMax
    });
    var list = new $f643df856475f69e$exports(dimensionsInfo, hostModel);
    list.initData(listData);
    beforeLink && beforeLink(list);
    $e71b48bcfe9ccb76$exports({
        mainData: list,
        struct: tree,
        structAttr: "tree"
    });
    tree.update();
    return tree;
};
/**
 * It is needed to consider the mess of 'list', 'hostModel' when creating a TreeNote,
 * so this function is not ready and not necessary to be public.
 *
 * @param {(module:echarts/data/Tree~TreeNode|Object)} child
 */ function $b7a0421515afdfda$var$addChild(child, node) {
    var children = node.children;
    if (child.parentNode === node) return;
    children.push(child);
    child.parentNode = node;
}
var $b7a0421515afdfda$var$_default = $b7a0421515afdfda$var$Tree;
$b7a0421515afdfda$exports = $b7a0421515afdfda$var$_default;



var $eaf5ad59e8442cf7$var$encodeHTML = $a4be9366aeb9fcc8$export$f9d6449b9af28dc1;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $eaf5ad59e8442cf7$var$_default = $70847df98016d69d$exports.extend({
    type: "series.tree",
    layoutInfo: null,
    // can support the position parameters 'left', 'top','right','bottom', 'width',
    // 'height' in the setOption() with 'merge' mode normal.
    layoutMode: "box",
    /**
   * Init a tree data structure from data in option series
   * @param  {Object} option  the object used to config echarts view
   * @return {module:echarts/data/List} storage initial data
   */ getInitialData: function(option) {
        //create an virtual root
        var root = {
            name: option.name,
            children: option.data
        };
        var leaves = option.leaves || {};
        var leavesModel = new $2b51b4bf776ec22e$exports(leaves, this, this.ecModel);
        var tree = $b7a0421515afdfda$exports.createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod("getItemModel", function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                if (!node.children.length || !node.isExpand) model.parentModel = leavesModel;
                return model;
            });
        }
        var treeDepth = 0;
        tree.eachNode("preorder", function(node) {
            if (node.depth > treeDepth) treeDepth = node.depth;
        });
        var expandAndCollapse = option.expandAndCollapse;
        var expandTreeDepth = expandAndCollapse && option.initialTreeDepth >= 0 ? option.initialTreeDepth : treeDepth;
        tree.root.eachNode("preorder", function(node) {
            var item = node.hostTree.data.getRawDataItem(node.dataIndex); // Add item.collapsed != null, because users can collapse node original in the series.data.
            node.isExpand = item && item.collapsed != null ? !item.collapsed : node.depth <= expandTreeDepth;
        });
        return tree.data;
    },
    /**
   * Make the configuration 'orient' backward compatibly, with 'horizontal = LR', 'vertical = TB'.
   * @returns {string} orient
   */ getOrient: function() {
        var orient = this.get("orient");
        if (orient === "horizontal") orient = "LR";
        else if (orient === "vertical") orient = "TB";
        return orient;
    },
    setZoom: function(zoom) {
        this.option.zoom = zoom;
    },
    setCenter: function(center) {
        this.option.center = center;
    },
    /**
   * @override
   * @param {number} dataIndex
   */ formatTooltip: function(dataIndex) {
        var tree = this.getData().tree;
        var realRoot = tree.root.children[0];
        var node = tree.getNodeByDataIndex(dataIndex);
        var value = node.getValue();
        var name = node.name;
        while(node && node !== realRoot){
            name = node.parentNode.name + "." + name;
            node = node.parentNode;
        }
        return $eaf5ad59e8442cf7$var$encodeHTML(name + (isNaN(value) || value == null ? "" : " : " + value));
    },
    defaultOption: {
        zlevel: 0,
        z: 2,
        coordinateSystem: "view",
        // the position of the whole view
        left: "12%",
        top: "12%",
        right: "12%",
        bottom: "12%",
        // the layout of the tree, two value can be selected, 'orthogonal' or 'radial'
        layout: "orthogonal",
        // value can be 'polyline'
        edgeShape: "curve",
        edgeForkPosition: "50%",
        // true | false | 'move' | 'scale', see module:component/helper/RoamController.
        roam: false,
        // Symbol size scale ratio in roam
        nodeScaleRatio: 0.4,
        // Default on center of graph
        center: null,
        zoom: 1,
        // The orient of orthoginal layout, can be setted to 'LR', 'TB', 'RL', 'BT'.
        // and the backward compatibility configuration 'horizontal = LR', 'vertical = TB'.
        orient: "LR",
        symbol: "emptyCircle",
        symbolSize: 7,
        expandAndCollapse: true,
        initialTreeDepth: 2,
        lineStyle: {
            color: "#ccc",
            width: 1.5,
            curveness: 0.5
        },
        itemStyle: {
            color: "lightsteelblue",
            borderColor: "#c23531",
            borderWidth: 1.5
        },
        label: {
            show: true,
            color: "#555"
        },
        leaves: {
            label: {
                show: true
            }
        },
        animationEasing: "linear",
        animationDuration: 700,
        animationDurationUpdate: 1000
    }
});
$eaf5ad59e8442cf7$exports = $eaf5ad59e8442cf7$var$_default;


var $e6ba25e0016601ab$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $dd684fac5d09ffb4$export$2cd8252107eb640b;
var $dd684fac5d09ffb4$export$f7eff93d75358a2c;
var $dd684fac5d09ffb4$export$39e6f19b1ce889be;
var $dd684fac5d09ffb4$export$3bf720ece7bc7b2e;
var $dd684fac5d09ffb4$export$60198ec123d36099;
var $dd684fac5d09ffb4$export$c02eeb5f98d59b89;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embeded for some of the code in this file:
* The tree layoutHelper implementation was originally copied from
* "d3.js"(https://github.com/d3/d3-hierarchy) with
* some modifications made for this project.
* (see more details in the comment of the specific method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the licence of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ /**
 * @file The layout algorithm of node-link tree diagrams. Here we using Reingold-Tilford algorithm to drawing
 *       the tree.
 */ /**
 * Initialize all computational message for following algorithm.
 *
 * @param  {module:echarts/data/Tree~TreeNode} root   The virtual root of the tree.
 */ function $dd684fac5d09ffb4$var$init(root) {
    root.hierNode = {
        defaultAncestor: null,
        ancestor: root,
        prelim: 0,
        modifier: 0,
        change: 0,
        shift: 0,
        i: 0,
        thread: null
    };
    var nodes = [
        root
    ];
    var node;
    var children;
    while(node = nodes.pop()){
        // jshint ignore:line
        children = node.children;
        if (node.isExpand && children.length) {
            var n = children.length;
            for(var i = n - 1; i >= 0; i--){
                var child = children[i];
                child.hierNode = {
                    defaultAncestor: null,
                    ancestor: child,
                    prelim: 0,
                    modifier: 0,
                    change: 0,
                    shift: 0,
                    i: i,
                    thread: null
                };
                nodes.push(child);
            }
        }
    }
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * Computes a preliminary x coordinate for node. Before that, this function is
 * applied recursively to the children of node, as well as the function
 * apportion(). After spacing out the children by calling executeShifts(), the
 * node is placed to the midpoint of its outermost children.
 *
 * @param  {module:echarts/data/Tree~TreeNode} node
 * @param {Function} separation
 */ function $dd684fac5d09ffb4$var$firstWalk(node, separation) {
    var children = node.isExpand ? node.children : [];
    var siblings = node.parentNode.children;
    var subtreeW = node.hierNode.i ? siblings[node.hierNode.i - 1] : null;
    if (children.length) {
        $dd684fac5d09ffb4$var$executeShifts(node);
        var midPoint = (children[0].hierNode.prelim + children[children.length - 1].hierNode.prelim) / 2;
        if (subtreeW) {
            node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
            node.hierNode.modifier = node.hierNode.prelim - midPoint;
        } else node.hierNode.prelim = midPoint;
    } else if (subtreeW) node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
    node.parentNode.hierNode.defaultAncestor = $dd684fac5d09ffb4$var$apportion(node, subtreeW, node.parentNode.hierNode.defaultAncestor || siblings[0], separation);
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * Computes all real x-coordinates by summing up the modifiers recursively.
 *
 * @param  {module:echarts/data/Tree~TreeNode} node
 */ function $dd684fac5d09ffb4$var$secondWalk(node) {
    var nodeX = node.hierNode.prelim + node.parentNode.hierNode.modifier;
    node.setLayout({
        x: nodeX
    }, true);
    node.hierNode.modifier += node.parentNode.hierNode.modifier;
}
function $dd684fac5d09ffb4$var$separation(cb) {
    return arguments.length ? cb : $dd684fac5d09ffb4$var$defaultSeparation;
}
/**
 * Transform the common coordinate to radial coordinate.
 *
 * @param  {number} x
 * @param  {number} y
 * @return {Object}
 */ function $dd684fac5d09ffb4$var$radialCoordinate(x, y) {
    var radialCoor = {};
    x -= Math.PI / 2;
    radialCoor.x = y * Math.cos(x);
    radialCoor.y = y * Math.sin(x);
    return radialCoor;
}
/**
 * Get the layout position of the whole view.
 *
 * @param {module:echarts/model/Series} seriesModel  the model object of sankey series
 * @param {module:echarts/ExtensionAPI} api  provide the API list that the developer can call
 * @return {module:zrender/core/BoundingRect}  size of rect to draw the sankey view
 */ function $dd684fac5d09ffb4$var$getViewRect(seriesModel, api) {
    return $ab0c9086dd6c5b39$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
/**
 * All other shifts, applied to the smaller subtrees between w- and w+, are
 * performed by this function.
 *
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * @param  {module:echarts/data/Tree~TreeNode} node
 */ function $dd684fac5d09ffb4$var$executeShifts(node) {
    var children = node.children;
    var n = children.length;
    var shift = 0;
    var change = 0;
    while(--n >= 0){
        var child = children[n];
        child.hierNode.prelim += shift;
        child.hierNode.modifier += shift;
        change += child.hierNode.change;
        shift += child.hierNode.shift + change;
    }
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * The core of the algorithm. Here, a new subtree is combined with the
 * previous subtrees. Threads are used to traverse the inside and outside
 * contours of the left and right subtree up to the highest common level.
 * Whenever two nodes of the inside contours conflict, we compute the left
 * one of the greatest uncommon ancestors using the function nextAncestor()
 * and call moveSubtree() to shift the subtree and prepare the shifts of
 * smaller subtrees. Finally, we add a new thread (if necessary).
 *
 * @param  {module:echarts/data/Tree~TreeNode} subtreeV
 * @param  {module:echarts/data/Tree~TreeNode} subtreeW
 * @param  {module:echarts/data/Tree~TreeNode} ancestor
 * @param  {Function} separation
 * @return {module:echarts/data/Tree~TreeNode}
 */ function $dd684fac5d09ffb4$var$apportion(subtreeV, subtreeW, ancestor, separation) {
    if (subtreeW) {
        var nodeOutRight = subtreeV;
        var nodeInRight = subtreeV;
        var nodeOutLeft = nodeInRight.parentNode.children[0];
        var nodeInLeft = subtreeW;
        var sumOutRight = nodeOutRight.hierNode.modifier;
        var sumInRight = nodeInRight.hierNode.modifier;
        var sumOutLeft = nodeOutLeft.hierNode.modifier;
        var sumInLeft = nodeInLeft.hierNode.modifier;
        while(nodeInLeft = $dd684fac5d09ffb4$var$nextRight(nodeInLeft), nodeInRight = $dd684fac5d09ffb4$var$nextLeft(nodeInRight), nodeInLeft && nodeInRight){
            nodeOutRight = $dd684fac5d09ffb4$var$nextRight(nodeOutRight);
            nodeOutLeft = $dd684fac5d09ffb4$var$nextLeft(nodeOutLeft);
            nodeOutRight.hierNode.ancestor = subtreeV;
            var shift = nodeInLeft.hierNode.prelim + sumInLeft - nodeInRight.hierNode.prelim - sumInRight + separation(nodeInLeft, nodeInRight);
            if (shift > 0) {
                $dd684fac5d09ffb4$var$moveSubtree($dd684fac5d09ffb4$var$nextAncestor(nodeInLeft, subtreeV, ancestor), subtreeV, shift);
                sumInRight += shift;
                sumOutRight += shift;
            }
            sumInLeft += nodeInLeft.hierNode.modifier;
            sumInRight += nodeInRight.hierNode.modifier;
            sumOutRight += nodeOutRight.hierNode.modifier;
            sumOutLeft += nodeOutLeft.hierNode.modifier;
        }
        if (nodeInLeft && !$dd684fac5d09ffb4$var$nextRight(nodeOutRight)) {
            nodeOutRight.hierNode.thread = nodeInLeft;
            nodeOutRight.hierNode.modifier += sumInLeft - sumOutRight;
        }
        if (nodeInRight && !$dd684fac5d09ffb4$var$nextLeft(nodeOutLeft)) {
            nodeOutLeft.hierNode.thread = nodeInRight;
            nodeOutLeft.hierNode.modifier += sumInRight - sumOutLeft;
            ancestor = subtreeV;
        }
    }
    return ancestor;
}
/**
 * This function is used to traverse the right contour of a subtree.
 * It returns the rightmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 *
 * @param  {module:echarts/data/Tree~TreeNode} node
 * @return {module:echarts/data/Tree~TreeNode}
 */ function $dd684fac5d09ffb4$var$nextRight(node) {
    var children = node.children;
    return children.length && node.isExpand ? children[children.length - 1] : node.hierNode.thread;
}
/**
 * This function is used to traverse the left contour of a subtree (or a subforest).
 * It returns the leftmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 *
 * @param  {module:echarts/data/Tree~TreeNode} node
 * @return {module:echarts/data/Tree~TreeNode}
 */ function $dd684fac5d09ffb4$var$nextLeft(node) {
    var children = node.children;
    return children.length && node.isExpand ? children[0] : node.hierNode.thread;
}
/**
 * If nodeInLeft’s ancestor is a sibling of node, returns nodeInLeft’s ancestor.
 * Otherwise, returns the specified ancestor.
 *
 * @param  {module:echarts/data/Tree~TreeNode} nodeInLeft
 * @param  {module:echarts/data/Tree~TreeNode} node
 * @param  {module:echarts/data/Tree~TreeNode} ancestor
 * @return {module:echarts/data/Tree~TreeNode}
 */ function $dd684fac5d09ffb4$var$nextAncestor(nodeInLeft, node, ancestor) {
    return nodeInLeft.hierNode.ancestor.parentNode === node.parentNode ? nodeInLeft.hierNode.ancestor : ancestor;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * Shifts the current subtree rooted at wr.
 * This is done by increasing prelim(w+) and modifier(w+) by shift.
 *
 * @param  {module:echarts/data/Tree~TreeNode} wl
 * @param  {module:echarts/data/Tree~TreeNode} wr
 * @param  {number} shift [description]
 */ function $dd684fac5d09ffb4$var$moveSubtree(wl, wr, shift) {
    var change = shift / (wr.hierNode.i - wl.hierNode.i);
    wr.hierNode.change -= change;
    wr.hierNode.shift += shift;
    wr.hierNode.modifier += shift;
    wr.hierNode.prelim += shift;
    wl.hierNode.change += change;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ function $dd684fac5d09ffb4$var$defaultSeparation(node1, node2) {
    return node1.parentNode === node2.parentNode ? 1 : 2;
}
$dd684fac5d09ffb4$export$2cd8252107eb640b = $dd684fac5d09ffb4$var$init;
$dd684fac5d09ffb4$export$f7eff93d75358a2c = $dd684fac5d09ffb4$var$firstWalk;
$dd684fac5d09ffb4$export$39e6f19b1ce889be = $dd684fac5d09ffb4$var$secondWalk;
$dd684fac5d09ffb4$export$3bf720ece7bc7b2e = $dd684fac5d09ffb4$var$separation;
$dd684fac5d09ffb4$export$60198ec123d36099 = $dd684fac5d09ffb4$var$radialCoordinate;
$dd684fac5d09ffb4$export$c02eeb5f98d59b89 = $dd684fac5d09ffb4$var$getViewRect;


var $e6ba25e0016601ab$var$radialCoordinate = $dd684fac5d09ffb4$export$60198ec123d36099;






var $e6ba25e0016601ab$var$onIrrelevantElement = $42222c91ddd2a800$export$8a33eacb690eac07;

var $e6ba25e0016601ab$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;

var $e6ba25e0016601ab$var$parsePercent = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $e6ba25e0016601ab$var$TreeShape = $4b57d6b582d579b7$export$d0d5398c9d612037({
    shape: {
        parentPoint: [],
        childPoints: [],
        orient: "",
        forkPosition: ""
    },
    style: {
        stroke: "#000",
        fill: null
    },
    buildPath: function(ctx, shape) {
        var childPoints = shape.childPoints;
        var childLen = childPoints.length;
        var parentPoint = shape.parentPoint;
        var firstChildPos = childPoints[0];
        var lastChildPos = childPoints[childLen - 1];
        if (childLen === 1) {
            ctx.moveTo(parentPoint[0], parentPoint[1]);
            ctx.lineTo(firstChildPos[0], firstChildPos[1]);
            return;
        }
        var orient = shape.orient;
        var forkDim = orient === "TB" || orient === "BT" ? 0 : 1;
        var otherDim = 1 - forkDim;
        var forkPosition = $e6ba25e0016601ab$var$parsePercent(shape.forkPosition, 1);
        var tmpPoint = [];
        tmpPoint[forkDim] = parentPoint[forkDim];
        tmpPoint[otherDim] = parentPoint[otherDim] + (lastChildPos[otherDim] - parentPoint[otherDim]) * forkPosition;
        ctx.moveTo(parentPoint[0], parentPoint[1]);
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        ctx.moveTo(firstChildPos[0], firstChildPos[1]);
        tmpPoint[forkDim] = firstChildPos[forkDim];
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        tmpPoint[forkDim] = lastChildPos[forkDim];
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        ctx.lineTo(lastChildPos[0], lastChildPos[1]);
        for(var i = 1; i < childLen - 1; i++){
            var point = childPoints[i];
            ctx.moveTo(point[0], point[1]);
            tmpPoint[forkDim] = point[forkDim];
            ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        }
    }
});
var $e6ba25e0016601ab$var$_default = $f406636b535430a7$exports.extendChartView({
    type: "tree",
    /**
   * Init the chart
   * @override
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */ init: function(ecModel, api) {
        /**
     * @private
     * @type {module:echarts/data/Tree}
     */ this._oldTree;
        /**
     * @private
     * @type {module:zrender/container/Group}
     */ this._mainGroup = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
        /**
     * @private
     * @type {module:echarts/componet/helper/RoamController}
     */ this._controller = new $f812ed7651a5f0b7$exports(api.getZr());
        this._controllerHost = {
            target: this.group
        };
        this.group.add(this._mainGroup);
    },
    render: function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var layoutInfo = seriesModel.layoutInfo;
        var group = this._mainGroup;
        var layout = seriesModel.get("layout");
        if (layout === "radial") group.attr("position", [
            layoutInfo.x + layoutInfo.width / 2,
            layoutInfo.y + layoutInfo.height / 2
        ]);
        else group.attr("position", [
            layoutInfo.x,
            layoutInfo.y
        ]);
        this._updateViewCoordSys(seriesModel, layoutInfo, layout);
        this._updateController(seriesModel, ecModel, api);
        var oldData = this._data;
        var seriesScope = {
            expandAndCollapse: seriesModel.get("expandAndCollapse"),
            layout: layout,
            edgeShape: seriesModel.get("edgeShape"),
            edgeForkPosition: seriesModel.get("edgeForkPosition"),
            orient: seriesModel.getOrient(),
            curvature: seriesModel.get("lineStyle.curveness"),
            symbolRotate: seriesModel.get("symbolRotate"),
            symbolOffset: seriesModel.get("symbolOffset"),
            hoverAnimation: seriesModel.get("hoverAnimation"),
            useNameLabel: true,
            fadeIn: true
        };
        data.diff(oldData).add(function(newIdx) {
            if ($e6ba25e0016601ab$var$symbolNeedsDraw(data, newIdx)) // Create node and edge
            $e6ba25e0016601ab$var$updateNode(data, newIdx, null, group, seriesModel, seriesScope);
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            if (!$e6ba25e0016601ab$var$symbolNeedsDraw(data, newIdx)) {
                symbolEl && $e6ba25e0016601ab$var$removeNode(oldData, oldIdx, symbolEl, group, seriesModel, seriesScope);
                return;
            } // Update node and edge
            $e6ba25e0016601ab$var$updateNode(data, newIdx, symbolEl, group, seriesModel, seriesScope);
        }).remove(function(oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx); // When remove a collapsed node of subtree, since the collapsed
            // node haven't been initialized with a symbol element,
            // you can't found it's symbol element through index.
            // so if we want to remove the symbol element we should insure
            // that the symbol element is not null.
            if (symbolEl) $e6ba25e0016601ab$var$removeNode(oldData, oldIdx, symbolEl, group, seriesModel, seriesScope);
        }).execute();
        this._nodeScaleRatio = seriesModel.get("nodeScaleRatio");
        this._updateNodeAndLinkScale(seriesModel);
        if (seriesScope.expandAndCollapse === true) data.eachItemGraphicEl(function(el, dataIndex) {
            el.off("click").on("click", function() {
                api.dispatchAction({
                    type: "treeExpandAndCollapse",
                    seriesId: seriesModel.id,
                    dataIndex: dataIndex
                });
            });
        });
        this._data = data;
    },
    _updateViewCoordSys: function(seriesModel) {
        var data = seriesModel.getData();
        var points = [];
        data.each(function(idx) {
            var layout = data.getItemLayout(idx);
            if (layout && !isNaN(layout.x) && !isNaN(layout.y)) points.push([
                +layout.x,
                +layout.y
            ]);
        });
        var min = [];
        var max = [];
        $22231ac051eb7cf7$export$188c3cd07b4129dd(points, min, max); // If don't Store min max when collapse the root node after roam,
        // the root node will disappear.
        var oldMin = this._min;
        var oldMax = this._max; // If width or height is 0
        if (max[0] - min[0] === 0) {
            min[0] = oldMin ? oldMin[0] : min[0] - 1;
            max[0] = oldMax ? oldMax[0] : max[0] + 1;
        }
        if (max[1] - min[1] === 0) {
            min[1] = oldMin ? oldMin[1] : min[1] - 1;
            max[1] = oldMax ? oldMax[1] : max[1] + 1;
        }
        var viewCoordSys = seriesModel.coordinateSystem = new $28347f1c81a620dc$exports();
        viewCoordSys.zoomLimit = seriesModel.get("scaleLimit");
        viewCoordSys.setBoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
        viewCoordSys.setCenter(seriesModel.get("center"));
        viewCoordSys.setZoom(seriesModel.get("zoom")); // Here we use viewCoordSys just for computing the 'position' and 'scale' of the group
        this.group.attr({
            position: viewCoordSys.position,
            scale: viewCoordSys.scale
        });
        this._viewCoordSys = viewCoordSys;
        this._min = min;
        this._max = max;
    },
    _updateController: function(seriesModel, ecModel, api) {
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        var group = this.group;
        controller.setPointerChecker(function(e, x, y) {
            var rect = group.getBoundingRect();
            rect.applyTransform(group.transform);
            return rect.contain(x, y) && !$e6ba25e0016601ab$var$onIrrelevantElement(e, api, seriesModel);
        });
        controller.enable(seriesModel.get("roam"));
        controllerHost.zoomLimit = seriesModel.get("scaleLimit");
        controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
        controller.off("pan").off("zoom").on("pan", function(e) {
            $b7c2af586a53b694$export$1e6abcd98caba733(controllerHost, e.dx, e.dy);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: "treeRoam",
                dx: e.dx,
                dy: e.dy
            });
        }, this).on("zoom", function(e) {
            $b7c2af586a53b694$export$29b3c66d30a4866(controllerHost, e.scale, e.originX, e.originY);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: "treeRoam",
                zoom: e.scale,
                originX: e.originX,
                originY: e.originY
            });
            this._updateNodeAndLinkScale(seriesModel);
        }, this);
    },
    _updateNodeAndLinkScale: function(seriesModel) {
        var data = seriesModel.getData();
        var nodeScale = this._getNodeGlobalScale(seriesModel);
        var invScale = [
            nodeScale,
            nodeScale
        ];
        data.eachItemGraphicEl(function(el, idx) {
            el.attr("scale", invScale);
        });
    },
    _getNodeGlobalScale: function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys.type !== "view") return 1;
        var nodeScaleRatio = this._nodeScaleRatio;
        var groupScale = coordSys.scale;
        var groupZoom = groupScale && groupScale[0] || 1; // Scale node when zoom changes
        var roamZoom = coordSys.getZoom();
        var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
        return nodeScale / groupZoom;
    },
    dispose: function() {
        this._controller && this._controller.dispose();
        this._controllerHost = {};
    },
    remove: function() {
        this._mainGroup.removeAll();
        this._data = null;
    }
});
function $e6ba25e0016601ab$var$symbolNeedsDraw(data, dataIndex) {
    var layout = data.getItemLayout(dataIndex);
    return layout && !isNaN(layout.x) && !isNaN(layout.y) && data.getItemVisual(dataIndex, "symbol") !== "none";
}
function $e6ba25e0016601ab$var$getTreeNodeStyle(node, itemModel, seriesScope) {
    seriesScope.itemModel = itemModel;
    seriesScope.itemStyle = itemModel.getModel("itemStyle").getItemStyle();
    seriesScope.hoverItemStyle = itemModel.getModel("emphasis.itemStyle").getItemStyle();
    seriesScope.lineStyle = itemModel.getModel("lineStyle").getLineStyle();
    seriesScope.labelModel = itemModel.getModel("label");
    seriesScope.hoverLabelModel = itemModel.getModel("emphasis.label");
    if (node.isExpand === false && node.children.length !== 0) seriesScope.symbolInnerColor = seriesScope.itemStyle.fill;
    else seriesScope.symbolInnerColor = "#fff";
    return seriesScope;
}
function $e6ba25e0016601ab$var$updateNode(data, dataIndex, symbolEl, group, seriesModel, seriesScope) {
    var isInit = !symbolEl;
    var node = data.tree.getNodeByDataIndex(dataIndex);
    var itemModel = node.getModel();
    var seriesScope = $e6ba25e0016601ab$var$getTreeNodeStyle(node, itemModel, seriesScope);
    var virtualRoot = data.tree.root;
    var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
    var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
    var sourceLayout = source.getLayout();
    var sourceOldLayout = sourceSymbolEl ? {
        x: sourceSymbolEl.position[0],
        y: sourceSymbolEl.position[1],
        rawX: sourceSymbolEl.__radialOldRawX,
        rawY: sourceSymbolEl.__radialOldRawY
    } : sourceLayout;
    var targetLayout = node.getLayout();
    if (isInit) {
        symbolEl = new $051ad5e1a7c7bd92$exports(data, dataIndex, seriesScope);
        symbolEl.attr("position", [
            sourceOldLayout.x,
            sourceOldLayout.y
        ]);
    } else symbolEl.updateData(data, dataIndex, seriesScope);
    symbolEl.__radialOldRawX = symbolEl.__radialRawX;
    symbolEl.__radialOldRawY = symbolEl.__radialRawY;
    symbolEl.__radialRawX = targetLayout.rawX;
    symbolEl.__radialRawY = targetLayout.rawY;
    group.add(symbolEl);
    data.setItemGraphicEl(dataIndex, symbolEl);
    $4b57d6b582d579b7$export$c8dce3c08436e91e(symbolEl, {
        position: [
            targetLayout.x,
            targetLayout.y
        ]
    }, seriesModel);
    var symbolPath = symbolEl.getSymbolPath();
    if (seriesScope.layout === "radial") {
        var realRoot = virtualRoot.children[0];
        var rootLayout = realRoot.getLayout();
        var length = realRoot.children.length;
        var rad;
        var isLeft;
        if (targetLayout.x === rootLayout.x && node.isExpand === true) {
            var center = {};
            center.x = (realRoot.children[0].getLayout().x + realRoot.children[length - 1].getLayout().x) / 2;
            center.y = (realRoot.children[0].getLayout().y + realRoot.children[length - 1].getLayout().y) / 2;
            rad = Math.atan2(center.y - rootLayout.y, center.x - rootLayout.x);
            if (rad < 0) rad = Math.PI * 2 + rad;
            isLeft = center.x < rootLayout.x;
            if (isLeft) rad = rad - Math.PI;
        } else {
            rad = Math.atan2(targetLayout.y - rootLayout.y, targetLayout.x - rootLayout.x);
            if (rad < 0) rad = Math.PI * 2 + rad;
            if (node.children.length === 0 || node.children.length !== 0 && node.isExpand === false) {
                isLeft = targetLayout.x < rootLayout.x;
                if (isLeft) rad = rad - Math.PI;
            } else {
                isLeft = targetLayout.x > rootLayout.x;
                if (!isLeft) rad = rad - Math.PI;
            }
        }
        var textPosition = isLeft ? "left" : "right";
        var rotate = seriesScope.labelModel.get("rotate");
        var labelRotateRadian = rotate * (Math.PI / 180);
        symbolPath.setStyle({
            textPosition: seriesScope.labelModel.get("position") || textPosition,
            textRotation: rotate == null ? -rad : labelRotateRadian,
            textOrigin: "center",
            verticalAlign: "middle"
        });
    }
    $e6ba25e0016601ab$var$drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group, seriesScope);
}
function $e6ba25e0016601ab$var$drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group, seriesScope) {
    var edgeShape = seriesScope.edgeShape;
    var edge = symbolEl.__edge;
    if (edgeShape === "curve") {
        if (node.parentNode && node.parentNode !== virtualRoot) {
            if (!edge) edge = symbolEl.__edge = new $4b57d6b582d579b7$export$a57c23a30525a34b({
                shape: $e6ba25e0016601ab$var$getEdgeShape(seriesScope, sourceOldLayout, sourceOldLayout),
                style: $ec279652dd95c27b$export$ebe90cb607ad99e({
                    opacity: 0,
                    strokeNoScale: true
                }, seriesScope.lineStyle)
            });
            $4b57d6b582d579b7$export$c8dce3c08436e91e(edge, {
                shape: $e6ba25e0016601ab$var$getEdgeShape(seriesScope, sourceLayout, targetLayout),
                style: $ec279652dd95c27b$export$ebe90cb607ad99e({
                    opacity: 1
                }, seriesScope.lineStyle)
            }, seriesModel);
        }
    } else if (edgeShape === "polyline") {
        if (seriesScope.layout === "orthogonal") {
            if (node !== virtualRoot && node.children && node.children.length !== 0 && node.isExpand === true) {
                var children = node.children;
                var childPoints = [];
                for(var i = 0; i < children.length; i++){
                    var childLayout = children[i].getLayout();
                    childPoints.push([
                        childLayout.x,
                        childLayout.y
                    ]);
                }
                if (!edge) edge = symbolEl.__edge = new $e6ba25e0016601ab$var$TreeShape({
                    shape: {
                        parentPoint: [
                            targetLayout.x,
                            targetLayout.y
                        ],
                        childPoints: [
                            [
                                targetLayout.x,
                                targetLayout.y
                            ]
                        ],
                        orient: seriesScope.orient,
                        forkPosition: seriesScope.edgeForkPosition
                    },
                    style: $ec279652dd95c27b$export$ebe90cb607ad99e({
                        opacity: 0,
                        strokeNoScale: true
                    }, seriesScope.lineStyle)
                });
                $4b57d6b582d579b7$export$c8dce3c08436e91e(edge, {
                    shape: {
                        parentPoint: [
                            targetLayout.x,
                            targetLayout.y
                        ],
                        childPoints: childPoints
                    },
                    style: $ec279652dd95c27b$export$ebe90cb607ad99e({
                        opacity: 1
                    }, seriesScope.lineStyle)
                }, seriesModel);
            }
        }
    }
    group.add(edge);
}
function $e6ba25e0016601ab$var$removeNode(data, dataIndex, symbolEl, group, seriesModel, seriesScope) {
    var node = data.tree.getNodeByDataIndex(dataIndex);
    var virtualRoot = data.tree.root;
    var itemModel = node.getModel();
    var seriesScope = $e6ba25e0016601ab$var$getTreeNodeStyle(node, itemModel, seriesScope);
    var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
    var edgeShape = seriesScope.edgeShape;
    var sourceLayout;
    while(sourceLayout = source.getLayout(), sourceLayout == null)source = source.parentNode === virtualRoot ? source : source.parentNode || source;
    $4b57d6b582d579b7$export$c8dce3c08436e91e(symbolEl, {
        position: [
            sourceLayout.x + 1,
            sourceLayout.y + 1
        ]
    }, seriesModel, function() {
        group.remove(symbolEl);
        data.setItemGraphicEl(dataIndex, null);
    });
    symbolEl.fadeOut(null, {
        keepLabel: true
    });
    var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
    var sourceEdge = sourceSymbolEl.__edge; // 1. when expand the sub tree, delete the children node should delete the edge of
    // the source at the same time. because the polyline edge shape is only owned by the source.
    // 2.when the node is the only children of the source, delete the node should delete the edge of
    // the source at the same time. the same reason as above.
    var edge = symbolEl.__edge || (source.isExpand === false || source.children.length === 1 ? sourceEdge : undefined);
    var edgeShape = seriesScope.edgeShape;
    if (edge) {
        if (edgeShape === "curve") $4b57d6b582d579b7$export$c8dce3c08436e91e(edge, {
            shape: $e6ba25e0016601ab$var$getEdgeShape(seriesScope, sourceLayout, sourceLayout),
            style: {
                opacity: 0
            }
        }, seriesModel, function() {
            group.remove(edge);
        });
        else if (edgeShape === "polyline" && seriesScope.layout === "orthogonal") $4b57d6b582d579b7$export$c8dce3c08436e91e(edge, {
            shape: {
                parentPoint: [
                    sourceLayout.x,
                    sourceLayout.y
                ],
                childPoints: [
                    [
                        sourceLayout.x,
                        sourceLayout.y
                    ]
                ]
            },
            style: {
                opacity: 0
            }
        }, seriesModel, function() {
            group.remove(edge);
        });
    }
}
function $e6ba25e0016601ab$var$getEdgeShape(seriesScope, sourceLayout, targetLayout) {
    var cpx1;
    var cpy1;
    var cpx2;
    var cpy2;
    var orient = seriesScope.orient;
    var x1;
    var x2;
    var y1;
    var y2;
    if (seriesScope.layout === "radial") {
        x1 = sourceLayout.rawX;
        y1 = sourceLayout.rawY;
        x2 = targetLayout.rawX;
        y2 = targetLayout.rawY;
        var radialCoor1 = $e6ba25e0016601ab$var$radialCoordinate(x1, y1);
        var radialCoor2 = $e6ba25e0016601ab$var$radialCoordinate(x1, y1 + (y2 - y1) * seriesScope.curvature);
        var radialCoor3 = $e6ba25e0016601ab$var$radialCoordinate(x2, y2 + (y1 - y2) * seriesScope.curvature);
        var radialCoor4 = $e6ba25e0016601ab$var$radialCoordinate(x2, y2);
        return {
            x1: radialCoor1.x,
            y1: radialCoor1.y,
            x2: radialCoor4.x,
            y2: radialCoor4.y,
            cpx1: radialCoor2.x,
            cpy1: radialCoor2.y,
            cpx2: radialCoor3.x,
            cpy2: radialCoor3.y
        };
    } else {
        x1 = sourceLayout.x;
        y1 = sourceLayout.y;
        x2 = targetLayout.x;
        y2 = targetLayout.y;
        if (orient === "LR" || orient === "RL") {
            cpx1 = x1 + (x2 - x1) * seriesScope.curvature;
            cpy1 = y1;
            cpx2 = x2 + (x1 - x2) * seriesScope.curvature;
            cpy2 = y2;
        }
        if (orient === "TB" || orient === "BT") {
            cpx1 = x1;
            cpy1 = y1 + (y2 - y1) * seriesScope.curvature;
            cpx2 = x2;
            cpy2 = y2 + (y1 - y2) * seriesScope.curvature;
        }
    }
    return {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        cpx1: cpx1,
        cpy1: cpy1,
        cpx2: cpx2,
        cpy2: cpy2
    };
}
$e6ba25e0016601ab$exports = $e6ba25e0016601ab$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $3b3b0009dd4ba00d$var$updateCenterAndZoom = $80b2a59d4ab83148$export$797ecc50d262ebd8;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerAction({
    type: "treeExpandAndCollapse",
    event: "treeExpandAndCollapse",
    update: "update"
}, function(payload, ecModel) {
    ecModel.eachComponent({
        mainType: "series",
        subType: "tree",
        query: payload
    }, function(seriesModel) {
        var dataIndex = payload.dataIndex;
        var tree = seriesModel.getData().tree;
        var node = tree.getNodeByDataIndex(dataIndex);
        node.isExpand = !node.isExpand;
    });
});
$f406636b535430a7$exports.registerAction({
    type: "treeRoam",
    event: "treeRoam",
    // Here we set 'none' instead of 'update', because roam action
    // just need to update the transform matrix without having to recalculate
    // the layout. So don't need to go through the whole update process, such
    // as 'dataPrcocess', 'coordSystemUpdate', 'layout' and so on.
    update: "none"
}, function(payload, ecModel) {
    ecModel.eachComponent({
        mainType: "series",
        subType: "tree",
        query: payload
    }, function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var res = $3b3b0009dd4ba00d$var$updateCenterAndZoom(coordSys, payload);
        seriesModel.setCenter && seriesModel.setCenter(res.center);
        seriesModel.setZoom && seriesModel.setZoom(res.zoom);
    });
});



var $1e581ab60db7848c$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Traverse the tree from bottom to top and do something
 * @param  {module:echarts/data/Tree~TreeNode} root  The real root of the tree
 * @param  {Function} callback
 */ var $ab610a72c43807dd$export$bd961f70bc91ffb4;
var $ab610a72c43807dd$export$32a66ec2b39acdac;
function $ab610a72c43807dd$var$eachAfter(root, callback, separation) {
    var nodes = [
        root
    ];
    var next = [];
    var node;
    while(node = nodes.pop()){
        // jshint ignore:line
        next.push(node);
        if (node.isExpand) {
            var children = node.children;
            if (children.length) for(var i = 0; i < children.length; i++)nodes.push(children[i]);
        }
    }
    while(node = next.pop())// jshint ignore:line
    callback(node, separation);
}
/**
 * Traverse the tree from top to bottom and do something
 * @param  {module:echarts/data/Tree~TreeNode} root  The real root of the tree
 * @param  {Function} callback
 */ function $ab610a72c43807dd$var$eachBefore(root, callback) {
    var nodes = [
        root
    ];
    var node;
    while(node = nodes.pop()){
        // jshint ignore:line
        callback(node);
        if (node.isExpand) {
            var children = node.children;
            if (children.length) for(var i = children.length - 1; i >= 0; i--)nodes.push(children[i]);
        }
    }
}
$ab610a72c43807dd$export$bd961f70bc91ffb4 = $ab610a72c43807dd$var$eachAfter;
$ab610a72c43807dd$export$32a66ec2b39acdac = $ab610a72c43807dd$var$eachBefore;


var $1e581ab60db7848c$var$eachAfter = $ab610a72c43807dd$export$bd961f70bc91ffb4;
var $1e581ab60db7848c$var$eachBefore = $ab610a72c43807dd$export$32a66ec2b39acdac;

var $1e581ab60db7848c$var$init = $dd684fac5d09ffb4$export$2cd8252107eb640b;
var $1e581ab60db7848c$var$firstWalk = $dd684fac5d09ffb4$export$f7eff93d75358a2c;
var $1e581ab60db7848c$var$secondWalk = $dd684fac5d09ffb4$export$39e6f19b1ce889be;
var $1e581ab60db7848c$var$sep = $dd684fac5d09ffb4$export$3bf720ece7bc7b2e;
var $1e581ab60db7848c$var$radialCoordinate = $dd684fac5d09ffb4$export$60198ec123d36099;
var $1e581ab60db7848c$var$getViewRect = $dd684fac5d09ffb4$export$c02eeb5f98d59b89;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $1e581ab60db7848c$var$_default(ecModel, api) {
    ecModel.eachSeriesByType("tree", function(seriesModel) {
        $1e581ab60db7848c$var$commonLayout(seriesModel, api);
    });
}
function $1e581ab60db7848c$var$commonLayout(seriesModel, api) {
    var layoutInfo = $1e581ab60db7848c$var$getViewRect(seriesModel, api);
    seriesModel.layoutInfo = layoutInfo;
    var layout = seriesModel.get("layout");
    var width = 0;
    var height = 0;
    var separation = null;
    if (layout === "radial") {
        width = 2 * Math.PI;
        height = Math.min(layoutInfo.height, layoutInfo.width) / 2;
        separation = $1e581ab60db7848c$var$sep(function(node1, node2) {
            return (node1.parentNode === node2.parentNode ? 1 : 2) / node1.depth;
        });
    } else {
        width = layoutInfo.width;
        height = layoutInfo.height;
        separation = $1e581ab60db7848c$var$sep();
    }
    var virtualRoot = seriesModel.getData().tree.root;
    var realRoot = virtualRoot.children[0];
    if (realRoot) {
        $1e581ab60db7848c$var$init(virtualRoot);
        $1e581ab60db7848c$var$eachAfter(realRoot, $1e581ab60db7848c$var$firstWalk, separation);
        virtualRoot.hierNode.modifier = -realRoot.hierNode.prelim;
        $1e581ab60db7848c$var$eachBefore(realRoot, $1e581ab60db7848c$var$secondWalk);
        var left = realRoot;
        var right = realRoot;
        var bottom = realRoot;
        $1e581ab60db7848c$var$eachBefore(realRoot, function(node) {
            var x = node.getLayout().x;
            if (x < left.getLayout().x) left = node;
            if (x > right.getLayout().x) right = node;
            if (node.depth > bottom.depth) bottom = node;
        });
        var delta = left === right ? 1 : separation(left, right) / 2;
        var tx = delta - left.getLayout().x;
        var kx = 0;
        var ky = 0;
        var coorX = 0;
        var coorY = 0;
        if (layout === "radial") {
            kx = width / (right.getLayout().x + delta + tx); // here we use (node.depth - 1), bucause the real root's depth is 1
            ky = height / (bottom.depth - 1 || 1);
            $1e581ab60db7848c$var$eachBefore(realRoot, function(node) {
                coorX = (node.getLayout().x + tx) * kx;
                coorY = (node.depth - 1) * ky;
                var finalCoor = $1e581ab60db7848c$var$radialCoordinate(coorX, coorY);
                node.setLayout({
                    x: finalCoor.x,
                    y: finalCoor.y,
                    rawX: coorX,
                    rawY: coorY
                }, true);
            });
        } else {
            var orient = seriesModel.getOrient();
            if (orient === "RL" || orient === "LR") {
                ky = height / (right.getLayout().x + delta + tx);
                kx = width / (bottom.depth - 1 || 1);
                $1e581ab60db7848c$var$eachBefore(realRoot, function(node) {
                    coorY = (node.getLayout().x + tx) * ky;
                    coorX = orient === "LR" ? (node.depth - 1) * kx : width - (node.depth - 1) * kx;
                    node.setLayout({
                        x: coorX,
                        y: coorY
                    }, true);
                });
            } else if (orient === "TB" || orient === "BT") {
                kx = width / (right.getLayout().x + delta + tx);
                ky = height / (bottom.depth - 1 || 1);
                $1e581ab60db7848c$var$eachBefore(realRoot, function(node) {
                    coorX = (node.getLayout().x + tx) * kx;
                    coorY = orient === "TB" ? (node.depth - 1) * ky : height - (node.depth - 1) * ky;
                    node.setLayout({
                        x: coorX,
                        y: coorY
                    }, true);
                });
            }
        }
    }
}
$1e581ab60db7848c$exports = $1e581ab60db7848c$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerVisual($6efa4c3507ca2b4d$exports("tree", "circle"));
$f406636b535430a7$exports.registerLayout($1e581ab60db7848c$exports);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2f1268eeb1ae6997$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $2f1268eeb1ae6997$var$encodeHTML = $a4be9366aeb9fcc8$export$f9d6449b9af28dc1;
var $2f1268eeb1ae6997$var$addCommas = $a4be9366aeb9fcc8$export$b6fe44657ce35c42;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $9dcc91b21f0b70b6$export$c5445fa59c15dec4;
var $9dcc91b21f0b70b6$export$6be31fe4499506f9;
var $9dcc91b21f0b70b6$export$df59de26c77b5bea;
var $9dcc91b21f0b70b6$export$c5baa480d6ceb0a3;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $9dcc91b21f0b70b6$var$retrieveTargetInfo(payload, validPayloadTypes, seriesModel) {
    if (payload && $ec279652dd95c27b$export$305f7d4e9d4624f2(validPayloadTypes, payload.type) >= 0) {
        var root = seriesModel.getData().tree.root;
        var targetNode = payload.targetNode;
        if (typeof targetNode === "string") targetNode = root.getNodeById(targetNode);
        if (targetNode && root.contains(targetNode)) return {
            node: targetNode
        };
        var targetNodeId = payload.targetNodeId;
        if (targetNodeId != null && (targetNode = root.getNodeById(targetNodeId))) return {
            node: targetNode
        };
    }
} // Not includes the given node at the last item.
function $9dcc91b21f0b70b6$var$getPathToRoot(node) {
    var path = [];
    while(node){
        node = node.parentNode;
        node && path.push(node);
    }
    return path.reverse();
}
function $9dcc91b21f0b70b6$var$aboveViewRoot(viewRoot, node) {
    var viewPath = $9dcc91b21f0b70b6$var$getPathToRoot(viewRoot);
    return $ec279652dd95c27b$export$305f7d4e9d4624f2(viewPath, node) >= 0;
} // From root to the input node (the input node will be included).
function $9dcc91b21f0b70b6$var$wrapTreePathInfo(node, seriesModel) {
    var treePathInfo = [];
    while(node){
        var nodeDataIndex = node.dataIndex;
        treePathInfo.push({
            name: node.name,
            dataIndex: nodeDataIndex,
            value: seriesModel.getRawValue(nodeDataIndex)
        });
        node = node.parentNode;
    }
    treePathInfo.reverse();
    return treePathInfo;
}
$9dcc91b21f0b70b6$export$c5445fa59c15dec4 = $9dcc91b21f0b70b6$var$retrieveTargetInfo;
$9dcc91b21f0b70b6$export$6be31fe4499506f9 = $9dcc91b21f0b70b6$var$getPathToRoot;
$9dcc91b21f0b70b6$export$df59de26c77b5bea = $9dcc91b21f0b70b6$var$aboveViewRoot;
$9dcc91b21f0b70b6$export$c5baa480d6ceb0a3 = $9dcc91b21f0b70b6$var$wrapTreePathInfo;


var $2f1268eeb1ae6997$var$wrapTreePathInfo = $9dcc91b21f0b70b6$export$c5baa480d6ceb0a3;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $2f1268eeb1ae6997$var$_default = $70847df98016d69d$exports.extend({
    type: "series.treemap",
    layoutMode: "box",
    dependencies: [
        "grid",
        "polar"
    ],
    preventUsingHoverLayer: true,
    /**
   * @type {module:echarts/data/Tree~Node}
   */ _viewRoot: null,
    defaultOption: {
        // Disable progressive rendering
        progressive: 0,
        // center: ['50%', '50%'],          // not supported in ec3.
        // size: ['80%', '80%'],            // deprecated, compatible with ec2.
        left: "center",
        top: "middle",
        right: null,
        bottom: null,
        width: "80%",
        height: "80%",
        sort: true,
        // Can be null or false or true
        // (order by desc default, asc not supported yet (strange effect))
        clipWindow: "origin",
        // Size of clipped window when zooming. 'origin' or 'fullscreen'
        squareRatio: 0.5 * (1 + Math.sqrt(5)),
        // golden ratio
        leafDepth: null,
        // Nodes on depth from root are regarded as leaves.
        // Count from zero (zero represents only view root).
        drillDownIcon: "\u25B6",
        // Use html character temporarily because it is complicated
        // to align specialized icon. ▷▶❒❐▼✚
        zoomToNodeRatio: 0.1024,
        // Be effective when using zoomToNode. Specify the proportion of the
        // target node area in the view area.
        roam: true,
        // true, false, 'scale' or 'zoom', 'move'.
        nodeClick: "zoomToNode",
        // Leaf node click behaviour: 'zoomToNode', 'link', false.
        // If leafDepth is set and clicking a node which has children but
        // be on left depth, the behaviour would be changing root. Otherwise
        // use behavious defined above.
        animation: true,
        animationDurationUpdate: 900,
        animationEasing: "quinticInOut",
        breadcrumb: {
            show: true,
            height: 22,
            left: "center",
            top: "bottom",
            // right
            // bottom
            emptyItemWidth: 25,
            // Width of empty node.
            itemStyle: {
                color: "rgba(0,0,0,0.7)",
                //'#5793f3',
                borderColor: "rgba(255,255,255,0.7)",
                borderWidth: 1,
                shadowColor: "rgba(150,150,150,1)",
                shadowBlur: 3,
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                textStyle: {
                    color: "#fff"
                }
            },
            emphasis: {
                textStyle: {}
            }
        },
        label: {
            show: true,
            // Do not use textDistance, for ellipsis rect just the same as treemap node rect.
            distance: 0,
            padding: 5,
            position: "inside",
            // Can be [5, '5%'] or position stirng like 'insideTopLeft', ...
            // formatter: null,
            color: "#fff",
            ellipsis: true // align
        },
        upperLabel: {
            // Label when node is parent.
            show: false,
            position: [
                0,
                "50%"
            ],
            height: 20,
            // formatter: null,
            color: "#fff",
            ellipsis: true,
            // align: null,
            verticalAlign: "middle"
        },
        itemStyle: {
            color: null,
            // Can be 'none' if not necessary.
            colorAlpha: null,
            // Can be 'none' if not necessary.
            colorSaturation: null,
            // Can be 'none' if not necessary.
            borderWidth: 0,
            gapWidth: 0,
            borderColor: "#fff",
            borderColorSaturation: null // If specified, borderColor will be ineffective, and the
        },
        emphasis: {
            upperLabel: {
                show: true,
                position: [
                    0,
                    "50%"
                ],
                color: "#fff",
                ellipsis: true,
                verticalAlign: "middle"
            }
        },
        visualDimension: 0,
        // Can be 0, 1, 2, 3.
        visualMin: null,
        visualMax: null,
        color: [],
        // + treemapSeries.color should not be modified. Please only modified
        // level[n].color (if necessary).
        // + Specify color list of each level. level[0].color would be global
        // color list if not specified. (see method `setDefault`).
        // + But set as a empty array to forbid fetch color from global palette
        // when using nodeModel.get('color'), otherwise nodes on deep level
        // will always has color palette set and are not able to inherit color
        // from parent node.
        // + TreemapSeries.color can not be set as 'none', otherwise effect
        // legend color fetching (see seriesColor.js).
        colorAlpha: null,
        // Array. Specify color alpha range of each level, like [0.2, 0.8]
        colorSaturation: null,
        // Array. Specify color saturation of each level, like [0.2, 0.5]
        colorMappingBy: "index",
        // 'value' or 'index' or 'id'.
        visibleMin: 10,
        // If area less than this threshold (unit: pixel^2), node will not
        // be rendered. Only works when sort is 'asc' or 'desc'.
        childrenVisibleMin: null,
        // If area of a node less than this threshold (unit: pixel^2),
        // grandchildren will not show.
        // Why grandchildren? If not grandchildren but children,
        // some siblings show children and some not,
        // the appearance may be mess and not consistent,
        levels: [] // Each item: {
    },
    /**
   * @override
   */ getInitialData: function(option, ecModel) {
        // Create a virtual root.
        var root = {
            name: option.name,
            children: option.data
        };
        $2f1268eeb1ae6997$var$completeTreeValue(root);
        var levels = option.levels || []; // Used in "visual priority" in `treemapVisual.js`.
        // This way is a little tricky, must satisfy the precondition:
        //   1. There is no `treeNode.getModel('itemStyle.xxx')` used.
        //   2. The `Model.prototype.getModel()` will not use any clone-like way.
        var designatedVisualItemStyle = this.designatedVisualItemStyle = {};
        var designatedVisualModel = new $2b51b4bf776ec22e$exports({
            itemStyle: designatedVisualItemStyle
        }, this, ecModel);
        levels = option.levels = $2f1268eeb1ae6997$var$setDefault(levels, ecModel);
        var levelModels = $ec279652dd95c27b$export$871de8747c9eaa88(levels || [], function(levelDefine) {
            return new $2b51b4bf776ec22e$exports(levelDefine, designatedVisualModel, ecModel);
        }, this); // Make sure always a new tree is created when setOption,
        // in TreemapView, we check whether oldTree === newTree
        // to choose mappings approach among old shapes and new shapes.
        var tree = $b7a0421515afdfda$exports.createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod("getItemModel", function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                var levelModel = levelModels[node.depth]; // If no levelModel, we also need `designatedVisualModel`.
                model.parentModel = levelModel || designatedVisualModel;
                return model;
            });
        }
        return tree.data;
    },
    optionUpdated: function() {
        this.resetViewRoot();
    },
    /**
   * @override
   * @param {number} dataIndex
   * @param {boolean} [mutipleSeries=false]
   */ formatTooltip: function(dataIndex) {
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var formattedValue = $ec279652dd95c27b$export$43bee75e5e14138e(value) ? $2f1268eeb1ae6997$var$addCommas(value[0]) : $2f1268eeb1ae6997$var$addCommas(value);
        var name = data.getName(dataIndex);
        return $2f1268eeb1ae6997$var$encodeHTML(name + ": " + formattedValue);
    },
    /**
   * Add tree path to tooltip param
   *
   * @override
   * @param {number} dataIndex
   * @return {Object}
   */ getDataParams: function(dataIndex) {
        var params = $70847df98016d69d$exports.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treePathInfo = $2f1268eeb1ae6997$var$wrapTreePathInfo(node, this);
        return params;
    },
    /**
   * @public
   * @param {Object} layoutInfo {
   *                                x: containerGroup x
   *                                y: containerGroup y
   *                                width: containerGroup width
   *                                height: containerGroup height
   *                            }
   */ setLayoutInfo: function(layoutInfo) {
        /**
     * @readOnly
     * @type {Object}
     */ this.layoutInfo = this.layoutInfo || {};
        $ec279652dd95c27b$export$8b58be045bf06082(this.layoutInfo, layoutInfo);
    },
    /**
   * @param  {string} id
   * @return {number} index
   */ mapIdToIndex: function(id) {
        // A feature is implemented:
        // index is monotone increasing with the sequence of
        // input id at the first time.
        // This feature can make sure that each data item and its
        // mapped color have the same index between data list and
        // color list at the beginning, which is useful for user
        // to adjust data-color mapping.
        /**
     * @private
     * @type {Object}
     */ var idIndexMap = this._idIndexMap;
        if (!idIndexMap) {
            idIndexMap = this._idIndexMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4();
            /**
       * @private
       * @type {number}
       */ this._idIndexMapCount = 0;
        }
        var index = idIndexMap.get(id);
        if (index == null) idIndexMap.set(id, index = this._idIndexMapCount++);
        return index;
    },
    getViewRoot: function() {
        return this._viewRoot;
    },
    /**
   * @param {module:echarts/data/Tree~Node} [viewRoot]
   */ resetViewRoot: function(viewRoot) {
        viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
        var root = this.getRawData().tree.root;
        if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) this._viewRoot = root;
    }
});
/**
 * @param {Object} dataNode
 */ function $2f1268eeb1ae6997$var$completeTreeValue(dataNode) {
    // Postorder travel tree.
    // If value of none-leaf node is not set,
    // calculate it by suming up the value of all children.
    var sum = 0;
    $ec279652dd95c27b$export$79b2f7037acddd43(dataNode.children, function(child) {
        $2f1268eeb1ae6997$var$completeTreeValue(child);
        var childValue = child.value;
        $ec279652dd95c27b$export$43bee75e5e14138e(childValue) && (childValue = childValue[0]);
        sum += childValue;
    });
    var thisValue = dataNode.value;
    if ($ec279652dd95c27b$export$43bee75e5e14138e(thisValue)) thisValue = thisValue[0];
    if (thisValue == null || isNaN(thisValue)) thisValue = sum;
     // Value should not less than 0.
    if (thisValue < 0) thisValue = 0;
    $ec279652dd95c27b$export$43bee75e5e14138e(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}
/**
 * set default to level configuration
 */ function $2f1268eeb1ae6997$var$setDefault(levels, ecModel) {
    var globalColorList = ecModel.get("color");
    if (!globalColorList) return;
    levels = levels || [];
    var hasColorDefine;
    $ec279652dd95c27b$export$79b2f7037acddd43(levels, function(levelDefine) {
        var model = new $2b51b4bf776ec22e$exports(levelDefine);
        var modelColor = model.get("color");
        if (model.get("itemStyle.color") || modelColor && modelColor !== "none") hasColorDefine = true;
    });
    if (!hasColorDefine) {
        var level0 = levels[0] || (levels[0] = {});
        level0.color = globalColorList.slice();
    }
    return levels;
}
$2f1268eeb1ae6997$exports = $2f1268eeb1ae6997$var$_default;


var $3d28756fafc75b63$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $ea990397bda1e908$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $ea990397bda1e908$var$wrapTreePathInfo = $9dcc91b21f0b70b6$export$c5baa480d6ceb0a3;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $ea990397bda1e908$var$TEXT_PADDING = 8;
var $ea990397bda1e908$var$ITEM_GAP = 8;
var $ea990397bda1e908$var$ARRAY_LENGTH = 5;
function $ea990397bda1e908$var$Breadcrumb(containerGroup) {
    /**
   * @private
   * @type {module:zrender/container/Group}
   */ this.group = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
    containerGroup.add(this.group);
}
$ea990397bda1e908$var$Breadcrumb.prototype = {
    constructor: $ea990397bda1e908$var$Breadcrumb,
    render: function(seriesModel, api, targetNode, onSelect) {
        var model = seriesModel.getModel("breadcrumb");
        var thisGroup = this.group;
        thisGroup.removeAll();
        if (!model.get("show") || !targetNode) return;
        var normalStyleModel = model.getModel("itemStyle"); // var emphasisStyleModel = model.getModel('emphasis.itemStyle');
        var textStyleModel = normalStyleModel.getModel("textStyle");
        var layoutParam = {
            pos: {
                left: model.get("left"),
                right: model.get("right"),
                top: model.get("top"),
                bottom: model.get("bottom")
            },
            box: {
                width: api.getWidth(),
                height: api.getHeight()
            },
            emptyItemWidth: model.get("emptyItemWidth"),
            totalWidth: 0,
            renderList: []
        };
        this._prepare(targetNode, layoutParam, textStyleModel);
        this._renderContent(seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect);
        $ab0c9086dd6c5b39$export$74054bd96b5eeef1(thisGroup, layoutParam.pos, layoutParam.box);
    },
    /**
   * Prepare render list and total width
   * @private
   */ _prepare: function(targetNode, layoutParam, textStyleModel) {
        for(var node = targetNode; node; node = node.parentNode){
            var text = node.getModel().get("name");
            var textRect = textStyleModel.getTextRect(text);
            var itemWidth = Math.max(textRect.width + $ea990397bda1e908$var$TEXT_PADDING * 2, layoutParam.emptyItemWidth);
            layoutParam.totalWidth += itemWidth + $ea990397bda1e908$var$ITEM_GAP;
            layoutParam.renderList.push({
                node: node,
                text: text,
                width: itemWidth
            });
        }
    },
    /**
   * @private
   */ _renderContent: function(seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect) {
        // Start rendering.
        var lastX = 0;
        var emptyItemWidth = layoutParam.emptyItemWidth;
        var height = seriesModel.get("breadcrumb.height");
        var availableSize = $ab0c9086dd6c5b39$export$145a8938a85a22b1(layoutParam.pos, layoutParam.box);
        var totalWidth = layoutParam.totalWidth;
        var renderList = layoutParam.renderList;
        for(var i = renderList.length - 1; i >= 0; i--){
            var item = renderList[i];
            var itemNode = item.node;
            var itemWidth = item.width;
            var text = item.text; // Hdie text and shorten width if necessary.
            if (totalWidth > availableSize.width) {
                totalWidth -= itemWidth - emptyItemWidth;
                itemWidth = emptyItemWidth;
                text = null;
            }
            var el = new $4b57d6b582d579b7$export$7d31b617c820d435({
                shape: {
                    points: $ea990397bda1e908$var$makeItemPoints(lastX, 0, itemWidth, height, i === renderList.length - 1, i === 0)
                },
                style: $ec279652dd95c27b$export$ebe90cb607ad99e(normalStyleModel.getItemStyle(), {
                    lineJoin: "bevel",
                    text: text,
                    textFill: textStyleModel.getTextColor(),
                    textFont: textStyleModel.getFont()
                }),
                z: 10,
                onclick: $ec279652dd95c27b$export$c3095a23b368d1f2(onSelect, itemNode)
            });
            this.group.add(el);
            $ea990397bda1e908$var$packEventData(el, seriesModel, itemNode);
            lastX += itemWidth + $ea990397bda1e908$var$ITEM_GAP;
        }
    },
    /**
   * @override
   */ remove: function() {
        this.group.removeAll();
    }
};
function $ea990397bda1e908$var$makeItemPoints(x, y, itemWidth, itemHeight, head, tail) {
    var points = [
        [
            head ? x : x - $ea990397bda1e908$var$ARRAY_LENGTH,
            y
        ],
        [
            x + itemWidth,
            y
        ],
        [
            x + itemWidth,
            y + itemHeight
        ],
        [
            head ? x : x - $ea990397bda1e908$var$ARRAY_LENGTH,
            y + itemHeight
        ]
    ];
    !tail && points.splice(2, 0, [
        x + itemWidth + $ea990397bda1e908$var$ARRAY_LENGTH,
        y + itemHeight / 2
    ]);
    !head && points.push([
        x,
        y + itemHeight / 2
    ]);
    return points;
} // Package custom mouse event.
function $ea990397bda1e908$var$packEventData(el, seriesModel, itemNode) {
    el.eventData = {
        componentType: "series",
        componentSubType: "treemap",
        componentIndex: seriesModel.componentIndex,
        seriesIndex: seriesModel.componentIndex,
        seriesName: seriesModel.name,
        seriesType: "treemap",
        selfType: "breadcrumb",
        // Distinguish with click event on treemap node.
        nodeData: {
            dataIndex: itemNode && itemNode.dataIndex,
            name: itemNode && itemNode.name
        },
        treePathInfo: itemNode && $ea990397bda1e908$var$wrapTreePathInfo(itemNode, seriesModel)
    };
}
var $ea990397bda1e908$var$_default = $ea990397bda1e908$var$Breadcrumb;
$ea990397bda1e908$exports = $ea990397bda1e908$var$_default;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $1cef8d7c4a2910d9$export$944643101ee10c7;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @param {number} [time=500] Time in ms
 * @param {string} [easing='linear']
 * @param {number} [delay=0]
 * @param {Function} [callback]
 *
 * @example
 *  // Animate position
 *  animation
 *      .createWrap()
 *      .add(el1, {position: [10, 10]})
 *      .add(el2, {shape: {width: 500}, style: {fill: 'red'}}, 400)
 *      .done(function () { // done })
 *      .start('cubicOut');
 */ function $1cef8d7c4a2910d9$var$createWrap() {
    var storage = [];
    var elExistsMap = {};
    var doneCallback;
    return {
        /**
     * Caution: a el can only be added once, otherwise 'done'
     * might not be called. This method checks this (by el.id),
     * suppresses adding and returns false when existing el found.
     *
     * @param {modele:zrender/Element} el
     * @param {Object} target
     * @param {number} [time=500]
     * @param {number} [delay=0]
     * @param {string} [easing='linear']
     * @return {boolean} Whether adding succeeded.
     *
     * @example
     *     add(el, target, time, delay, easing);
     *     add(el, target, time, easing);
     *     add(el, target, time);
     *     add(el, target);
     */ add: function(el, target, time, delay, easing) {
            if ($ec279652dd95c27b$export$844ec244b1367d54(delay)) {
                easing = delay;
                delay = 0;
            }
            if (elExistsMap[el.id]) return false;
            elExistsMap[el.id] = 1;
            storage.push({
                el: el,
                target: target,
                time: time,
                delay: delay,
                easing: easing
            });
            return true;
        },
        /**
     * Only execute when animation finished. Will not execute when any
     * of 'stop' or 'stopAnimation' called.
     *
     * @param {Function} callback
     */ done: function(callback) {
            doneCallback = callback;
            return this;
        },
        /**
     * Will stop exist animation firstly.
     */ start: function() {
            var count = storage.length;
            for(var i = 0, len = storage.length; i < len; i++){
                var item = storage[i];
                item.el.animateTo(item.target, item.time, item.delay, item.easing, done);
            }
            return this;
            function done() {
                count--;
                if (!count) {
                    storage.length = 0;
                    elExistsMap = {};
                    doneCallback && doneCallback();
                }
            }
        }
    };
}
$1cef8d7c4a2910d9$export$944643101ee10c7 = $1cef8d7c4a2910d9$var$createWrap;




var $3d28756fafc75b63$var$windowOpen = $a4be9366aeb9fcc8$export$13e13f9b96dbe8fa;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $3d28756fafc75b63$var$bind = $ec279652dd95c27b$export$2385a24977818dd0;
var $3d28756fafc75b63$var$Group = $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4;
var $3d28756fafc75b63$var$Rect = $4b57d6b582d579b7$export$c79fc6492f3af13d;
var $3d28756fafc75b63$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $3d28756fafc75b63$var$DRAG_THRESHOLD = 3;
var $3d28756fafc75b63$var$PATH_LABEL_NOAMAL = [
    "label"
];
var $3d28756fafc75b63$var$PATH_LABEL_EMPHASIS = [
    "emphasis",
    "label"
];
var $3d28756fafc75b63$var$PATH_UPPERLABEL_NORMAL = [
    "upperLabel"
];
var $3d28756fafc75b63$var$PATH_UPPERLABEL_EMPHASIS = [
    "emphasis",
    "upperLabel"
];
var $3d28756fafc75b63$var$Z_BASE = 10; // Should bigger than every z.
var $3d28756fafc75b63$var$Z_BG = 1;
var $3d28756fafc75b63$var$Z_CONTENT = 2;
var $3d28756fafc75b63$var$getItemStyleEmphasis = $d701679ba7a46009$exports([
    [
        "fill",
        "color"
    ],
    // so use `stroke` to indicate the stroke of the rect.
    [
        "stroke",
        "strokeColor"
    ],
    [
        "lineWidth",
        "strokeWidth"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "shadowColor"
    ]
]);
var $3d28756fafc75b63$var$getItemStyleNormal = function(model) {
    // Normal style props should include emphasis style props.
    var itemStyle = $3d28756fafc75b63$var$getItemStyleEmphasis(model); // Clear styles set by emphasis.
    itemStyle.stroke = itemStyle.fill = itemStyle.lineWidth = null;
    return itemStyle;
};
var $3d28756fafc75b63$var$_default = $f406636b535430a7$exports.extendChartView({
    type: "treemap",
    /**
   * @override
   */ init: function(o, api) {
        /**
     * @private
     * @type {module:zrender/container/Group}
     */ this._containerGroup;
        /**
     * @private
     * @type {Object.<string, Array.<module:zrender/container/Group>>}
     */ this._storage = $3d28756fafc75b63$var$createStorage();
        /**
     * @private
     * @type {module:echarts/data/Tree}
     */ this._oldTree;
        /**
     * @private
     * @type {module:echarts/chart/treemap/Breadcrumb}
     */ this._breadcrumb;
        /**
     * @private
     * @type {module:echarts/component/helper/RoamController}
     */ this._controller;
        /**
     * 'ready', 'animating'
     * @private
     */ this._state = "ready";
    },
    /**
   * @override
   */ render: function(seriesModel, ecModel, api, payload) {
        var models = ecModel.findComponents({
            mainType: "series",
            subType: "treemap",
            query: payload
        });
        if ($ec279652dd95c27b$export$305f7d4e9d4624f2(models, seriesModel) < 0) return;
        this.seriesModel = seriesModel;
        this.api = api;
        this.ecModel = ecModel;
        var types = [
            "treemapZoomToNode",
            "treemapRootToNode"
        ];
        var targetInfo = $9dcc91b21f0b70b6$export$c5445fa59c15dec4(payload, types, seriesModel);
        var payloadType = payload && payload.type;
        var layoutInfo = seriesModel.layoutInfo;
        var isInit = !this._oldTree;
        var thisStorage = this._storage; // Mark new root when action is treemapRootToNode.
        var reRoot = payloadType === "treemapRootToNode" && targetInfo && thisStorage ? {
            rootNodeGroup: thisStorage.nodeGroup[targetInfo.node.getRawIndex()],
            direction: payload.direction
        } : null;
        var containerGroup = this._giveContainerGroup(layoutInfo);
        var renderResult = this._doRender(containerGroup, seriesModel, reRoot);
        !isInit && (!payloadType || payloadType === "treemapZoomToNode" || payloadType === "treemapRootToNode") ? this._doAnimation(containerGroup, renderResult, seriesModel, reRoot) : renderResult.renderFinally();
        this._resetController(api);
        this._renderBreadcrumb(seriesModel, api, targetInfo);
    },
    /**
   * @private
   */ _giveContainerGroup: function(layoutInfo) {
        var containerGroup = this._containerGroup;
        if (!containerGroup) {
            // FIXME
            // 加一层containerGroup是为了clip，但是现在clip功能并没有实现。
            containerGroup = this._containerGroup = new $3d28756fafc75b63$var$Group();
            this._initEvents(containerGroup);
            this.group.add(containerGroup);
        }
        containerGroup.attr("position", [
            layoutInfo.x,
            layoutInfo.y
        ]);
        return containerGroup;
    },
    /**
   * @private
   */ _doRender: function(containerGroup, seriesModel, reRoot) {
        var thisTree = seriesModel.getData().tree;
        var oldTree = this._oldTree; // Clear last shape records.
        var lastsForAnimation = $3d28756fafc75b63$var$createStorage();
        var thisStorage = $3d28756fafc75b63$var$createStorage();
        var oldStorage = this._storage;
        var willInvisibleEls = [];
        var doRenderNode = $ec279652dd95c27b$export$c3095a23b368d1f2($3d28756fafc75b63$var$renderNode, seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls); // Notice: when thisTree and oldTree are the same tree (see list.cloneShallow),
        // the oldTree is actually losted, so we can not find all of the old graphic
        // elements from tree. So we use this stragegy: make element storage, move
        // from old storage to new storage, clear old storage.
        dualTravel(thisTree.root ? [
            thisTree.root
        ] : [], oldTree && oldTree.root ? [
            oldTree.root
        ] : [], containerGroup, thisTree === oldTree || !oldTree, 0); // Process all removing.
        var willDeleteEls = clearStorage(oldStorage);
        this._oldTree = thisTree;
        this._storage = thisStorage;
        return {
            lastsForAnimation: lastsForAnimation,
            willDeleteEls: willDeleteEls,
            renderFinally: renderFinally
        };
        function dualTravel(thisViewChildren, oldViewChildren, parentGroup, sameTree, depth) {
            // When 'render' is triggered by action,
            // 'this' and 'old' may be the same tree,
            // we use rawIndex in that case.
            if (sameTree) {
                oldViewChildren = thisViewChildren;
                $3d28756fafc75b63$var$each(thisViewChildren, function(child, index) {
                    !child.isRemoved() && processNode(index, index);
                });
            } else new $8e5cd4a27af1b00f$exports(oldViewChildren, thisViewChildren, getKey, getKey).add(processNode).update(processNode).remove($ec279652dd95c27b$export$c3095a23b368d1f2(processNode, null)).execute();
            function getKey(node) {
                // Identify by name or raw index.
                return node.getId();
            }
            function processNode(newIndex, oldIndex) {
                var thisNode = newIndex != null ? thisViewChildren[newIndex] : null;
                var oldNode = oldIndex != null ? oldViewChildren[oldIndex] : null;
                var group = doRenderNode(thisNode, oldNode, parentGroup, depth);
                group && dualTravel(thisNode && thisNode.viewChildren || [], oldNode && oldNode.viewChildren || [], group, sameTree, depth + 1);
            }
        }
        function clearStorage(storage) {
            var willDeleteEls = $3d28756fafc75b63$var$createStorage();
            storage && $3d28756fafc75b63$var$each(storage, function(store, storageName) {
                var delEls = willDeleteEls[storageName];
                $3d28756fafc75b63$var$each(store, function(el) {
                    el && (delEls.push(el), el.__tmWillDelete = 1);
                });
            });
            return willDeleteEls;
        }
        function renderFinally() {
            $3d28756fafc75b63$var$each(willDeleteEls, function(els) {
                $3d28756fafc75b63$var$each(els, function(el) {
                    el.parent && el.parent.remove(el);
                });
            });
            $3d28756fafc75b63$var$each(willInvisibleEls, function(el) {
                el.invisible = true; // Setting invisible is for optimizing, so no need to set dirty,
                // just mark as invisible.
                el.dirty();
            });
        }
    },
    /**
   * @private
   */ _doAnimation: function(containerGroup, renderResult, seriesModel, reRoot) {
        if (!seriesModel.get("animation")) return;
        var duration = seriesModel.get("animationDurationUpdate");
        var easing = seriesModel.get("animationEasing");
        var animationWrap = $1cef8d7c4a2910d9$export$944643101ee10c7(); // Make delete animations.
        $3d28756fafc75b63$var$each(renderResult.willDeleteEls, function(store, storageName) {
            $3d28756fafc75b63$var$each(store, function(el, rawIndex) {
                if (el.invisible) return;
                var parent = el.parent; // Always has parent, and parent is nodeGroup.
                var target;
                if (reRoot && reRoot.direction === "drillDown") target = parent === reRoot.rootNodeGroup // This is the content element of view root.
                 ? {
                    shape: {
                        x: 0,
                        y: 0,
                        width: parent.__tmNodeWidth,
                        height: parent.__tmNodeHeight
                    },
                    style: {
                        opacity: 0
                    } // Others.
                } : {
                    style: {
                        opacity: 0
                    }
                };
                else {
                    var targetX = 0;
                    var targetY = 0;
                    if (!parent.__tmWillDelete) {
                        // Let node animate to right-bottom corner, cooperating with fadeout,
                        // which is appropriate for user understanding.
                        // Divided by 2 for reRoot rolling up effect.
                        targetX = parent.__tmNodeWidth / 2;
                        targetY = parent.__tmNodeHeight / 2;
                    }
                    target = storageName === "nodeGroup" ? {
                        position: [
                            targetX,
                            targetY
                        ],
                        style: {
                            opacity: 0
                        }
                    } : {
                        shape: {
                            x: targetX,
                            y: targetY,
                            width: 0,
                            height: 0
                        },
                        style: {
                            opacity: 0
                        }
                    };
                }
                target && animationWrap.add(el, target, duration, easing);
            });
        }); // Make other animations
        $3d28756fafc75b63$var$each(this._storage, function(store, storageName) {
            $3d28756fafc75b63$var$each(store, function(el, rawIndex) {
                var last = renderResult.lastsForAnimation[storageName][rawIndex];
                var target = {};
                if (!last) return;
                if (storageName === "nodeGroup") {
                    if (last.old) {
                        target.position = el.position.slice();
                        el.attr("position", last.old);
                    }
                } else {
                    if (last.old) {
                        target.shape = $ec279652dd95c27b$export$8b58be045bf06082({}, el.shape);
                        el.setShape(last.old);
                    }
                    if (last.fadein) {
                        el.setStyle("opacity", 0);
                        target.style = {
                            opacity: 1
                        };
                    } else if (el.style.opacity !== 1) target.style = {
                        opacity: 1
                    };
                }
                animationWrap.add(el, target, duration, easing);
            });
        }, this);
        this._state = "animating";
        animationWrap.done($3d28756fafc75b63$var$bind(function() {
            this._state = "ready";
            renderResult.renderFinally();
        }, this)).start();
    },
    /**
   * @private
   */ _resetController: function(api) {
        var controller = this._controller; // Init controller.
        if (!controller) {
            controller = this._controller = new $f812ed7651a5f0b7$exports(api.getZr());
            controller.enable(this.seriesModel.get("roam"));
            controller.on("pan", $3d28756fafc75b63$var$bind(this._onPan, this));
            controller.on("zoom", $3d28756fafc75b63$var$bind(this._onZoom, this));
        }
        var rect = new $33e4fae744d34798$exports(0, 0, api.getWidth(), api.getHeight());
        controller.setPointerChecker(function(e, x, y) {
            return rect.contain(x, y);
        });
    },
    /**
   * @private
   */ _clearController: function() {
        var controller = this._controller;
        if (controller) {
            controller.dispose();
            controller = null;
        }
    },
    /**
   * @private
   */ _onPan: function(e) {
        if (this._state !== "animating" && (Math.abs(e.dx) > $3d28756fafc75b63$var$DRAG_THRESHOLD || Math.abs(e.dy) > $3d28756fafc75b63$var$DRAG_THRESHOLD)) {
            // These param must not be cached.
            var root = this.seriesModel.getData().tree.root;
            if (!root) return;
            var rootLayout = root.getLayout();
            if (!rootLayout) return;
            this.api.dispatchAction({
                type: "treemapMove",
                from: this.uid,
                seriesId: this.seriesModel.id,
                rootRect: {
                    x: rootLayout.x + e.dx,
                    y: rootLayout.y + e.dy,
                    width: rootLayout.width,
                    height: rootLayout.height
                }
            });
        }
    },
    /**
   * @private
   */ _onZoom: function(e) {
        var mouseX = e.originX;
        var mouseY = e.originY;
        if (this._state !== "animating") {
            // These param must not be cached.
            var root = this.seriesModel.getData().tree.root;
            if (!root) return;
            var rootLayout = root.getLayout();
            if (!rootLayout) return;
            var rect = new $33e4fae744d34798$exports(rootLayout.x, rootLayout.y, rootLayout.width, rootLayout.height);
            var layoutInfo = this.seriesModel.layoutInfo; // Transform mouse coord from global to containerGroup.
            mouseX -= layoutInfo.x;
            mouseY -= layoutInfo.y; // Scale root bounding rect.
            var m = $6c6dd9610ba660f0$export$185802fd694ee1f5();
            $6c6dd9610ba660f0$export$d73ee8ef04f5226a(m, m, [
                -mouseX,
                -mouseY
            ]);
            $6c6dd9610ba660f0$export$dcdf75081b88279d(m, m, [
                e.scale,
                e.scale
            ]);
            $6c6dd9610ba660f0$export$d73ee8ef04f5226a(m, m, [
                mouseX,
                mouseY
            ]);
            rect.applyTransform(m);
            this.api.dispatchAction({
                type: "treemapRender",
                from: this.uid,
                seriesId: this.seriesModel.id,
                rootRect: {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                }
            });
        }
    },
    /**
   * @private
   */ _initEvents: function(containerGroup) {
        containerGroup.on("click", function(e) {
            if (this._state !== "ready") return;
            var nodeClick = this.seriesModel.get("nodeClick", true);
            if (!nodeClick) return;
            var targetInfo = this.findTarget(e.offsetX, e.offsetY);
            if (!targetInfo) return;
            var node = targetInfo.node;
            if (node.getLayout().isLeafRoot) this._rootToNode(targetInfo);
            else {
                if (nodeClick === "zoomToNode") this._zoomToNode(targetInfo);
                else if (nodeClick === "link") {
                    var itemModel = node.hostTree.data.getItemModel(node.dataIndex);
                    var link = itemModel.get("link", true);
                    var linkTarget = itemModel.get("target", true) || "blank";
                    link && $3d28756fafc75b63$var$windowOpen(link, linkTarget);
                }
            }
        }, this);
    },
    /**
   * @private
   */ _renderBreadcrumb: function(seriesModel, api, targetInfo) {
        if (!targetInfo) {
            targetInfo = seriesModel.get("leafDepth", true) != null ? {
                node: seriesModel.getViewRoot() // FIXME
            } : this.findTarget(api.getWidth() / 2, api.getHeight() / 2);
            if (!targetInfo) targetInfo = {
                node: seriesModel.getData().tree.root
            };
        }
        (this._breadcrumb || (this._breadcrumb = new $ea990397bda1e908$exports(this.group))).render(seriesModel, api, targetInfo.node, $3d28756fafc75b63$var$bind(onSelect, this));
        function onSelect(node) {
            if (this._state !== "animating") $9dcc91b21f0b70b6$export$df59de26c77b5bea(seriesModel.getViewRoot(), node) ? this._rootToNode({
                node: node
            }) : this._zoomToNode({
                node: node
            });
        }
    },
    /**
   * @override
   */ remove: function() {
        this._clearController();
        this._containerGroup && this._containerGroup.removeAll();
        this._storage = $3d28756fafc75b63$var$createStorage();
        this._state = "ready";
        this._breadcrumb && this._breadcrumb.remove();
    },
    dispose: function() {
        this._clearController();
    },
    /**
   * @private
   */ _zoomToNode: function(targetInfo) {
        this.api.dispatchAction({
            type: "treemapZoomToNode",
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: targetInfo.node
        });
    },
    /**
   * @private
   */ _rootToNode: function(targetInfo) {
        this.api.dispatchAction({
            type: "treemapRootToNode",
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: targetInfo.node
        });
    },
    /**
   * @public
   * @param {number} x Global coord x.
   * @param {number} y Global coord y.
   * @return {Object} info If not found, return undefined;
   * @return {number} info.node Target node.
   * @return {number} info.offsetX x refer to target node.
   * @return {number} info.offsetY y refer to target node.
   */ findTarget: function(x, y) {
        var targetInfo;
        var viewRoot = this.seriesModel.getViewRoot();
        viewRoot.eachNode({
            attr: "viewChildren",
            order: "preorder"
        }, function(node) {
            var bgEl = this._storage.background[node.getRawIndex()]; // If invisible, there might be no element.
            if (bgEl) {
                var point = bgEl.transformCoordToLocal(x, y);
                var shape = bgEl.shape; // For performance consideration, dont use 'getBoundingRect'.
                if (shape.x <= point[0] && point[0] <= shape.x + shape.width && shape.y <= point[1] && point[1] <= shape.y + shape.height) targetInfo = {
                    node: node,
                    offsetX: point[0],
                    offsetY: point[1]
                };
                else return false; // Suppress visit subtree.
            }
        }, this);
        return targetInfo;
    }
});
/**
 * @inner
 */ function $3d28756fafc75b63$var$createStorage() {
    return {
        nodeGroup: [],
        background: [],
        content: []
    };
}
/**
 * @inner
 * @return Return undefined means do not travel further.
 */ function $3d28756fafc75b63$var$renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth) {
    // Whether under viewRoot.
    if (!thisNode) // Deleting nodes will be performed finally. This method just find
    // element from old storage, or create new element, set them to new
    // storage, and set styles.
    return;
     // -------------------------------------------------------------------
    // Start of closure variables available in "Procedures in renderNode".
    var thisLayout = thisNode.getLayout();
    var data = seriesModel.getData(); // Only for enabling highlight/downplay. Clear firstly.
    // Because some node will not be rendered.
    data.setItemGraphicEl(thisNode.dataIndex, null);
    if (!thisLayout || !thisLayout.isInView) return;
    var thisWidth = thisLayout.width;
    var thisHeight = thisLayout.height;
    var borderWidth = thisLayout.borderWidth;
    var thisInvisible = thisLayout.invisible;
    var thisRawIndex = thisNode.getRawIndex();
    var oldRawIndex = oldNode && oldNode.getRawIndex();
    var thisViewChildren = thisNode.viewChildren;
    var upperHeight = thisLayout.upperHeight;
    var isParent = thisViewChildren && thisViewChildren.length;
    var itemStyleNormalModel = thisNode.getModel("itemStyle");
    var itemStyleEmphasisModel = thisNode.getModel("emphasis.itemStyle"); // End of closure ariables available in "Procedures in renderNode".
    // -----------------------------------------------------------------
    // Node group
    var group = giveGraphic("nodeGroup", $3d28756fafc75b63$var$Group);
    if (!group) return;
    parentGroup.add(group); // x,y are not set when el is above view root.
    group.attr("position", [
        thisLayout.x || 0,
        thisLayout.y || 0
    ]);
    group.__tmNodeWidth = thisWidth;
    group.__tmNodeHeight = thisHeight;
    if (thisLayout.isAboveViewRoot) return group;
    var nodeModel = thisNode.getModel(); // Background
    var bg = giveGraphic("background", $3d28756fafc75b63$var$Rect, depth, $3d28756fafc75b63$var$Z_BG);
    bg && renderBackground(group, bg, isParent && thisLayout.upperLabelHeight); // No children, render content.
    if (isParent) {
        // Because of the implementation about "traverse" in graphic hover style, we
        // can not set hover listener on the "group" of non-leaf node. Otherwise the
        // hover event from the descendents will be listenered.
        if ($4b57d6b582d579b7$export$77d1445f699c58b5(group)) $4b57d6b582d579b7$export$9ba15aea1e048d48(group, false);
        if (bg) {
            $4b57d6b582d579b7$export$9ba15aea1e048d48(bg, true); // Only for enabling highlight/downplay.
            data.setItemGraphicEl(thisNode.dataIndex, bg);
        }
    } else {
        var content = giveGraphic("content", $3d28756fafc75b63$var$Rect, depth, $3d28756fafc75b63$var$Z_CONTENT);
        content && renderContent(group, content);
        if (bg && $4b57d6b582d579b7$export$77d1445f699c58b5(bg)) $4b57d6b582d579b7$export$9ba15aea1e048d48(bg, false);
        $4b57d6b582d579b7$export$9ba15aea1e048d48(group, true); // Only for enabling highlight/downplay.
        data.setItemGraphicEl(thisNode.dataIndex, group);
    }
    return group; // ----------------------------
    // | Procedures in renderNode |
    // ----------------------------
    function renderBackground(group, bg, useUpperLabel) {
        // For tooltip.
        bg.dataIndex = thisNode.dataIndex;
        bg.seriesIndex = seriesModel.seriesIndex;
        bg.setShape({
            x: 0,
            y: 0,
            width: thisWidth,
            height: thisHeight
        });
        if (thisInvisible) // If invisible, do not set visual, otherwise the element will
        // change immediately before animation. We think it is OK to
        // remain its origin color when moving out of the view window.
        processInvisible(bg);
        else {
            bg.invisible = false;
            var visualBorderColor = thisNode.getVisual("borderColor", true);
            var emphasisBorderColor = itemStyleEmphasisModel.get("borderColor");
            var normalStyle = $3d28756fafc75b63$var$getItemStyleNormal(itemStyleNormalModel);
            normalStyle.fill = visualBorderColor;
            var emphasisStyle = $3d28756fafc75b63$var$getItemStyleEmphasis(itemStyleEmphasisModel);
            emphasisStyle.fill = emphasisBorderColor;
            if (useUpperLabel) {
                var upperLabelWidth = thisWidth - 2 * borderWidth;
                prepareText(normalStyle, emphasisStyle, visualBorderColor, upperLabelWidth, upperHeight, {
                    x: borderWidth,
                    y: 0,
                    width: upperLabelWidth,
                    height: upperHeight
                });
            } else normalStyle.text = emphasisStyle.text = null;
            bg.setStyle(normalStyle);
            $4b57d6b582d579b7$export$2397e568fe8d15a0(bg, emphasisStyle);
        }
        group.add(bg);
    }
    function renderContent(group, content) {
        // For tooltip.
        content.dataIndex = thisNode.dataIndex;
        content.seriesIndex = seriesModel.seriesIndex;
        var contentWidth = Math.max(thisWidth - 2 * borderWidth, 0);
        var contentHeight = Math.max(thisHeight - 2 * borderWidth, 0);
        content.culling = true;
        content.setShape({
            x: borderWidth,
            y: borderWidth,
            width: contentWidth,
            height: contentHeight
        });
        if (thisInvisible) // If invisible, do not set visual, otherwise the element will
        // change immediately before animation. We think it is OK to
        // remain its origin color when moving out of the view window.
        processInvisible(content);
        else {
            content.invisible = false;
            var visualColor = thisNode.getVisual("color", true);
            var normalStyle = $3d28756fafc75b63$var$getItemStyleNormal(itemStyleNormalModel);
            normalStyle.fill = visualColor;
            var emphasisStyle = $3d28756fafc75b63$var$getItemStyleEmphasis(itemStyleEmphasisModel);
            prepareText(normalStyle, emphasisStyle, visualColor, contentWidth, contentHeight);
            content.setStyle(normalStyle);
            $4b57d6b582d579b7$export$2397e568fe8d15a0(content, emphasisStyle);
        }
        group.add(content);
    }
    function processInvisible(element) {
        // Delay invisible setting utill animation finished,
        // avoid element vanish suddenly before animation.
        !element.invisible && willInvisibleEls.push(element);
    }
    function prepareText(normalStyle, emphasisStyle, visualColor, width, height, upperLabelRect) {
        var defaultText = nodeModel.get("name");
        var normalLabelModel = nodeModel.getModel(upperLabelRect ? $3d28756fafc75b63$var$PATH_UPPERLABEL_NORMAL : $3d28756fafc75b63$var$PATH_LABEL_NOAMAL);
        var emphasisLabelModel = nodeModel.getModel(upperLabelRect ? $3d28756fafc75b63$var$PATH_UPPERLABEL_EMPHASIS : $3d28756fafc75b63$var$PATH_LABEL_EMPHASIS);
        var isShow = normalLabelModel.getShallow("show");
        $4b57d6b582d579b7$export$9a13992917966657(normalStyle, emphasisStyle, normalLabelModel, emphasisLabelModel, {
            defaultText: isShow ? defaultText : null,
            autoColor: visualColor,
            isRectText: true,
            labelFetcher: seriesModel,
            labelDataIndex: thisNode.dataIndex,
            labelProp: upperLabelRect ? "upperLabel" : "label"
        });
        addDrillDownIcon(normalStyle, upperLabelRect, thisLayout);
        addDrillDownIcon(emphasisStyle, upperLabelRect, thisLayout);
        upperLabelRect && (normalStyle.textRect = $ec279652dd95c27b$export$9cd59f9826255e47(upperLabelRect));
        normalStyle.truncate = isShow && normalLabelModel.get("ellipsis") ? {
            outerWidth: width,
            outerHeight: height,
            minChar: 2
        } : null;
    }
    function addDrillDownIcon(style, upperLabelRect, thisLayout) {
        var text = style.text;
        if (!upperLabelRect && thisLayout.isLeafRoot && text != null) {
            var iconChar = seriesModel.get("drillDownIcon", true);
            style.text = iconChar ? iconChar + " " + text : text;
        }
    }
    function giveGraphic(storageName, Ctor, depth, z) {
        var element = oldRawIndex != null && oldStorage[storageName][oldRawIndex];
        var lasts = lastsForAnimation[storageName];
        if (element) {
            // Remove from oldStorage
            oldStorage[storageName][oldRawIndex] = null;
            prepareAnimationWhenHasOld(lasts, element, storageName);
        } else if (!thisInvisible) {
            element = new Ctor({
                z: $3d28756fafc75b63$var$calculateZ(depth, z)
            });
            element.__tmDepth = depth;
            element.__tmStorageName = storageName;
            prepareAnimationWhenNoOld(lasts, element, storageName);
        } // Set to thisStorage
        return thisStorage[storageName][thisRawIndex] = element;
    }
    function prepareAnimationWhenHasOld(lasts, element, storageName) {
        var lastCfg = lasts[thisRawIndex] = {};
        lastCfg.old = storageName === "nodeGroup" ? element.position.slice() : $ec279652dd95c27b$export$8b58be045bf06082({}, element.shape);
    } // If a element is new, we need to find the animation start point carefully,
    // otherwise it will looks strange when 'zoomToNode'.
    function prepareAnimationWhenNoOld(lasts, element, storageName) {
        var lastCfg = lasts[thisRawIndex] = {};
        var parentNode = thisNode.parentNode;
        if (parentNode && (!reRoot || reRoot.direction === "drillDown")) {
            var parentOldX = 0;
            var parentOldY = 0; // New nodes appear from right-bottom corner in 'zoomToNode' animation.
            // For convenience, get old bounding rect from background.
            var parentOldBg = lastsForAnimation.background[parentNode.getRawIndex()];
            if (!reRoot && parentOldBg && parentOldBg.old) {
                parentOldX = parentOldBg.old.width;
                parentOldY = parentOldBg.old.height;
            } // When no parent old shape found, its parent is new too,
            // so we can just use {x:0, y:0}.
            lastCfg.old = storageName === "nodeGroup" ? [
                0,
                parentOldY
            ] : {
                x: parentOldX,
                y: parentOldY,
                width: 0,
                height: 0
            };
        } // Fade in, user can be aware that these nodes are new.
        lastCfg.fadein = storageName !== "nodeGroup";
    }
} // We can not set all backgroud with the same z, Because the behaviour of
// drill down and roll up differ background creation sequence from tree
// hierarchy sequence, which cause that lowser background element overlap
// upper ones. So we calculate z based on depth.
// Moreover, we try to shrink down z interval to [0, 1] to avoid that
// treemap with large z overlaps other components.
function $3d28756fafc75b63$var$calculateZ(depth, zInLevel) {
    var zb = depth * $3d28756fafc75b63$var$Z_BASE + zInLevel;
    return (zb - 1) / zb;
}
$3d28756fafc75b63$exports = $3d28756fafc75b63$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @file Treemap action
 */ var $d9fbcd3205ee8967$var$noop = function() {};
var $d9fbcd3205ee8967$var$actionTypes = [
    "treemapZoomToNode",
    "treemapRender",
    "treemapMove"
];
for(var $d9fbcd3205ee8967$var$i = 0; $d9fbcd3205ee8967$var$i < $d9fbcd3205ee8967$var$actionTypes.length; $d9fbcd3205ee8967$var$i++)$f406636b535430a7$exports.registerAction({
    type: $d9fbcd3205ee8967$var$actionTypes[$d9fbcd3205ee8967$var$i],
    update: "updateView"
}, $d9fbcd3205ee8967$var$noop);
$f406636b535430a7$exports.registerAction({
    type: "treemapRootToNode",
    update: "updateView"
}, function(payload, ecModel) {
    ecModel.eachComponent({
        mainType: "series",
        subType: "treemap",
        query: payload
    }, handleRootToNode);
    function handleRootToNode(model, index) {
        var types = [
            "treemapZoomToNode",
            "treemapRootToNode"
        ];
        var targetInfo = $9dcc91b21f0b70b6$export$c5445fa59c15dec4(payload, types, model);
        if (targetInfo) {
            var originViewRoot = model.getViewRoot();
            if (originViewRoot) payload.direction = $9dcc91b21f0b70b6$export$df59de26c77b5bea(originViewRoot, targetInfo.node) ? "rollUp" : "drillDown";
            model.resetViewRoot(targetInfo.node);
        }
    }
});


var $22530f2601951680$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $72cc7afb3a2d7026$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $72cc7afb3a2d7026$var$linearMap = $2d742dbe7f960d8c$export$d3f68fbaa670562;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $72cc7afb3a2d7026$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $72cc7afb3a2d7026$var$isObject = $ec279652dd95c27b$export$a6cdc56e425d0d0a;
var $72cc7afb3a2d7026$var$CATEGORY_DEFAULT_VISUAL_INDEX = -1;
/**
 * @param {Object} option
 * @param {string} [option.type] See visualHandlers.
 * @param {string} [option.mappingMethod] 'linear' or 'piecewise' or 'category' or 'fixed'
 * @param {Array.<number>=} [option.dataExtent] [minExtent, maxExtent],
 *                                              required when mappingMethod is 'linear'
 * @param {Array.<Object>=} [option.pieceList] [
 *                                             {value: someValue},
 *                                             {interval: [min1, max1], visual: {...}},
 *                                             {interval: [min2, max2]}
 *                                             ],
 *                                            required when mappingMethod is 'piecewise'.
 *                                            Visual for only each piece can be specified.
 * @param {Array.<string|Object>=} [option.categories] ['cate1', 'cate2']
 *                                            required when mappingMethod is 'category'.
 *                                            If no option.categories, categories is set
 *                                            as [0, 1, 2, ...].
 * @param {boolean} [option.loop=false] Whether loop mapping when mappingMethod is 'category'.
 * @param {(Array|Object|*)} [option.visual]  Visual data.
 *                                            when mappingMethod is 'category',
 *                                            visual data can be array or object
 *                                            (like: {cate1: '#222', none: '#fff'})
 *                                            or primary types (which represents
 *                                            default category visual), otherwise visual
 *                                            can be array or primary (which will be
 *                                            normalized to array).
 *
 */ var $72cc7afb3a2d7026$var$VisualMapping = function(option) {
    var mappingMethod = option.mappingMethod;
    var visualType = option.type;
    /**
   * @readOnly
   * @type {Object}
   */ var thisOption = this.option = $ec279652dd95c27b$export$9cd59f9826255e47(option);
    /**
   * @readOnly
   * @type {string}
   */ this.type = visualType;
    /**
   * @readOnly
   * @type {string}
   */ this.mappingMethod = mappingMethod;
    /**
   * @private
   * @type {Function}
   */ this._normalizeData = $72cc7afb3a2d7026$var$normalizers[mappingMethod];
    var visualHandler = $72cc7afb3a2d7026$var$visualHandlers[visualType];
    /**
   * @public
   * @type {Function}
   */ this.applyVisual = visualHandler.applyVisual;
    /**
   * @public
   * @type {Function}
   */ this.getColorMapper = visualHandler.getColorMapper;
    /**
   * @private
   * @type {Function}
   */ this._doMap = visualHandler._doMap[mappingMethod];
    if (mappingMethod === "piecewise") {
        $72cc7afb3a2d7026$var$normalizeVisualRange(thisOption);
        $72cc7afb3a2d7026$var$preprocessForPiecewise(thisOption);
    } else if (mappingMethod === "category") thisOption.categories ? $72cc7afb3a2d7026$var$preprocessForSpecifiedCategory(thisOption) // categories is ordinal when thisOption.categories not specified,
     : $72cc7afb3a2d7026$var$normalizeVisualRange(thisOption, true);
    else {
        // mappingMethod === 'linear' or 'fixed'
        $ec279652dd95c27b$export$a7a9523472993e97(mappingMethod !== "linear" || thisOption.dataExtent);
        $72cc7afb3a2d7026$var$normalizeVisualRange(thisOption);
    }
};
$72cc7afb3a2d7026$var$VisualMapping.prototype = {
    constructor: $72cc7afb3a2d7026$var$VisualMapping,
    mapValueToVisual: function(value) {
        var normalized = this._normalizeData(value);
        return this._doMap(normalized, value);
    },
    getNormalizer: function() {
        return $ec279652dd95c27b$export$2385a24977818dd0(this._normalizeData, this);
    }
};
var $72cc7afb3a2d7026$var$visualHandlers = $72cc7afb3a2d7026$var$VisualMapping.visualHandlers = {
    color: {
        applyVisual: $72cc7afb3a2d7026$var$makeApplyVisual("color"),
        /**
     * Create a mapper function
     * @return {Function}
     */ getColorMapper: function() {
            var thisOption = this.option;
            return $ec279652dd95c27b$export$2385a24977818dd0(thisOption.mappingMethod === "category" ? function(value, isNormalized) {
                !isNormalized && (value = this._normalizeData(value));
                return $72cc7afb3a2d7026$var$doMapCategory.call(this, value);
            } : function(value, isNormalized, out) {
                // If output rgb array
                // which will be much faster and useful in pixel manipulation
                var returnRGBArray = !!out;
                !isNormalized && (value = this._normalizeData(value));
                out = $b1179c91b052e827$export$66cb3c0e9efc61c8(value, thisOption.parsedVisual, out);
                return returnRGBArray ? out : $b1179c91b052e827$export$fac44ee5b035f737(out, "rgba");
            }, this);
        },
        _doMap: {
            linear: function(normalized) {
                return $b1179c91b052e827$export$fac44ee5b035f737($b1179c91b052e827$export$66cb3c0e9efc61c8(normalized, this.option.parsedVisual), "rgba");
            },
            category: $72cc7afb3a2d7026$var$doMapCategory,
            piecewise: function(normalized, value) {
                var result = $72cc7afb3a2d7026$var$getSpecifiedVisual.call(this, value);
                if (result == null) result = $b1179c91b052e827$export$fac44ee5b035f737($b1179c91b052e827$export$66cb3c0e9efc61c8(normalized, this.option.parsedVisual), "rgba");
                return result;
            },
            fixed: $72cc7afb3a2d7026$var$doMapFixed
        }
    },
    colorHue: $72cc7afb3a2d7026$var$makePartialColorVisualHandler(function(color, value) {
        return $b1179c91b052e827$export$d898ae866e27bf18(color, value);
    }),
    colorSaturation: $72cc7afb3a2d7026$var$makePartialColorVisualHandler(function(color, value) {
        return $b1179c91b052e827$export$d898ae866e27bf18(color, null, value);
    }),
    colorLightness: $72cc7afb3a2d7026$var$makePartialColorVisualHandler(function(color, value) {
        return $b1179c91b052e827$export$d898ae866e27bf18(color, null, null, value);
    }),
    colorAlpha: $72cc7afb3a2d7026$var$makePartialColorVisualHandler(function(color, value) {
        return $b1179c91b052e827$export$ab4754bf42583a26(color, value);
    }),
    opacity: {
        applyVisual: $72cc7afb3a2d7026$var$makeApplyVisual("opacity"),
        _doMap: $72cc7afb3a2d7026$var$makeDoMap([
            0,
            1
        ])
    },
    liftZ: {
        applyVisual: $72cc7afb3a2d7026$var$makeApplyVisual("liftZ"),
        _doMap: {
            linear: $72cc7afb3a2d7026$var$doMapFixed,
            category: $72cc7afb3a2d7026$var$doMapFixed,
            piecewise: $72cc7afb3a2d7026$var$doMapFixed,
            fixed: $72cc7afb3a2d7026$var$doMapFixed
        }
    },
    symbol: {
        applyVisual: function(value, getter, setter) {
            var symbolCfg = this.mapValueToVisual(value);
            if ($ec279652dd95c27b$export$844ec244b1367d54(symbolCfg)) setter("symbol", symbolCfg);
            else if ($72cc7afb3a2d7026$var$isObject(symbolCfg)) {
                for(var name in symbolCfg)if (symbolCfg.hasOwnProperty(name)) setter(name, symbolCfg[name]);
            }
        },
        _doMap: {
            linear: $72cc7afb3a2d7026$var$doMapToArray,
            category: $72cc7afb3a2d7026$var$doMapCategory,
            piecewise: function(normalized, value) {
                var result = $72cc7afb3a2d7026$var$getSpecifiedVisual.call(this, value);
                if (result == null) result = $72cc7afb3a2d7026$var$doMapToArray.call(this, normalized);
                return result;
            },
            fixed: $72cc7afb3a2d7026$var$doMapFixed
        }
    },
    symbolSize: {
        applyVisual: $72cc7afb3a2d7026$var$makeApplyVisual("symbolSize"),
        _doMap: $72cc7afb3a2d7026$var$makeDoMap([
            0,
            1
        ])
    }
};
function $72cc7afb3a2d7026$var$preprocessForPiecewise(thisOption) {
    var pieceList = thisOption.pieceList;
    thisOption.hasSpecialVisual = false;
    $ec279652dd95c27b$export$79b2f7037acddd43(pieceList, function(piece, index) {
        piece.originIndex = index; // piece.visual is "result visual value" but not
        // a visual range, so it does not need to be normalized.
        if (piece.visual != null) thisOption.hasSpecialVisual = true;
    });
}
function $72cc7afb3a2d7026$var$preprocessForSpecifiedCategory(thisOption) {
    // Hash categories.
    var categories = thisOption.categories;
    var visual = thisOption.visual;
    var categoryMap = thisOption.categoryMap = {};
    $72cc7afb3a2d7026$var$each(categories, function(cate, index) {
        categoryMap[cate] = index;
    }); // Process visual map input.
    if (!$ec279652dd95c27b$export$43bee75e5e14138e(visual)) {
        var visualArr = [];
        if ($ec279652dd95c27b$export$a6cdc56e425d0d0a(visual)) $72cc7afb3a2d7026$var$each(visual, function(v, cate) {
            var index = categoryMap[cate];
            visualArr[index != null ? index : $72cc7afb3a2d7026$var$CATEGORY_DEFAULT_VISUAL_INDEX] = v;
        });
        else // Is primary type, represents default visual.
        visualArr[$72cc7afb3a2d7026$var$CATEGORY_DEFAULT_VISUAL_INDEX] = visual;
        visual = $72cc7afb3a2d7026$var$setVisualToOption(thisOption, visualArr);
    } // Remove categories that has no visual,
    // then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.
    for(var i = categories.length - 1; i >= 0; i--)if (visual[i] == null) {
        delete categoryMap[categories[i]];
        categories.pop();
    }
}
function $72cc7afb3a2d7026$var$normalizeVisualRange(thisOption, isCategory) {
    var visual = thisOption.visual;
    var visualArr = [];
    if ($ec279652dd95c27b$export$a6cdc56e425d0d0a(visual)) $72cc7afb3a2d7026$var$each(visual, function(v) {
        visualArr.push(v);
    });
    else if (visual != null) visualArr.push(visual);
    var doNotNeedPair = {
        color: 1,
        symbol: 1
    };
    if (!isCategory && visualArr.length === 1 && !doNotNeedPair.hasOwnProperty(thisOption.type)) // Do not care visualArr.length === 0, which is illegal.
    visualArr[1] = visualArr[0];
    $72cc7afb3a2d7026$var$setVisualToOption(thisOption, visualArr);
}
function $72cc7afb3a2d7026$var$makePartialColorVisualHandler(applyValue) {
    return {
        applyVisual: function(value, getter, setter) {
            value = this.mapValueToVisual(value); // Must not be array value
            setter("color", applyValue(getter("color"), value));
        },
        _doMap: $72cc7afb3a2d7026$var$makeDoMap([
            0,
            1
        ])
    };
}
function $72cc7afb3a2d7026$var$doMapToArray(normalized) {
    var visual = this.option.visual;
    return visual[Math.round($72cc7afb3a2d7026$var$linearMap(normalized, [
        0,
        1
    ], [
        0,
        visual.length - 1
    ], true))] || {};
}
function $72cc7afb3a2d7026$var$makeApplyVisual(visualType) {
    return function(value, getter, setter) {
        setter(visualType, this.mapValueToVisual(value));
    };
}
function $72cc7afb3a2d7026$var$doMapCategory(normalized) {
    var visual = this.option.visual;
    return visual[this.option.loop && normalized !== $72cc7afb3a2d7026$var$CATEGORY_DEFAULT_VISUAL_INDEX ? normalized % visual.length : normalized];
}
function $72cc7afb3a2d7026$var$doMapFixed() {
    return this.option.visual[0];
}
function $72cc7afb3a2d7026$var$makeDoMap(sourceExtent) {
    return {
        linear: function(normalized) {
            return $72cc7afb3a2d7026$var$linearMap(normalized, sourceExtent, this.option.visual, true);
        },
        category: $72cc7afb3a2d7026$var$doMapCategory,
        piecewise: function(normalized, value) {
            var result = $72cc7afb3a2d7026$var$getSpecifiedVisual.call(this, value);
            if (result == null) result = $72cc7afb3a2d7026$var$linearMap(normalized, sourceExtent, this.option.visual, true);
            return result;
        },
        fixed: $72cc7afb3a2d7026$var$doMapFixed
    };
}
function $72cc7afb3a2d7026$var$getSpecifiedVisual(value) {
    var thisOption = this.option;
    var pieceList = thisOption.pieceList;
    if (thisOption.hasSpecialVisual) {
        var pieceIndex = $72cc7afb3a2d7026$var$VisualMapping.findPieceIndex(value, pieceList);
        var piece = pieceList[pieceIndex];
        if (piece && piece.visual) return piece.visual[this.type];
    }
}
function $72cc7afb3a2d7026$var$setVisualToOption(thisOption, visualArr) {
    thisOption.visual = visualArr;
    if (thisOption.type === "color") thisOption.parsedVisual = $ec279652dd95c27b$export$871de8747c9eaa88(visualArr, function(item) {
        return $b1179c91b052e827$export$98e6a39c04603d36(item);
    });
    return visualArr;
}
/**
 * Normalizers by mapping methods.
 */ var $72cc7afb3a2d7026$var$normalizers = {
    linear: function(value) {
        return $72cc7afb3a2d7026$var$linearMap(value, this.option.dataExtent, [
            0,
            1
        ], true);
    },
    piecewise: function(value) {
        var pieceList = this.option.pieceList;
        var pieceIndex = $72cc7afb3a2d7026$var$VisualMapping.findPieceIndex(value, pieceList, true);
        if (pieceIndex != null) return $72cc7afb3a2d7026$var$linearMap(pieceIndex, [
            0,
            pieceList.length - 1
        ], [
            0,
            1
        ], true);
    },
    category: function(value) {
        var index = this.option.categories ? this.option.categoryMap[value] : value; // ordinal
        return index == null ? $72cc7afb3a2d7026$var$CATEGORY_DEFAULT_VISUAL_INDEX : index;
    },
    fixed: $ec279652dd95c27b$export$8793edee2d425525
};
/**
 * List available visual types.
 *
 * @public
 * @return {Array.<string>}
 */ $72cc7afb3a2d7026$var$VisualMapping.listVisualTypes = function() {
    var visualTypes = [];
    $ec279652dd95c27b$export$79b2f7037acddd43($72cc7afb3a2d7026$var$visualHandlers, function(handler, key) {
        visualTypes.push(key);
    });
    return visualTypes;
};
/**
 * @public
 */ $72cc7afb3a2d7026$var$VisualMapping.addVisualHandler = function(name, handler) {
    $72cc7afb3a2d7026$var$visualHandlers[name] = handler;
};
/**
 * @public
 */ $72cc7afb3a2d7026$var$VisualMapping.isValidType = function(visualType) {
    return $72cc7afb3a2d7026$var$visualHandlers.hasOwnProperty(visualType);
};
/**
 * Convinent method.
 * Visual can be Object or Array or primary type.
 *
 * @public
 */ $72cc7afb3a2d7026$var$VisualMapping.eachVisual = function(visual, callback, context) {
    if ($ec279652dd95c27b$export$a6cdc56e425d0d0a(visual)) $ec279652dd95c27b$export$79b2f7037acddd43(visual, callback, context);
    else callback.call(context, visual);
};
$72cc7afb3a2d7026$var$VisualMapping.mapVisual = function(visual, callback, context) {
    var isPrimary;
    var newVisual = $ec279652dd95c27b$export$43bee75e5e14138e(visual) ? [] : $ec279652dd95c27b$export$a6cdc56e425d0d0a(visual) ? {} : (isPrimary = true, null);
    $72cc7afb3a2d7026$var$VisualMapping.eachVisual(visual, function(v, key) {
        var newVal = callback.call(context, v, key);
        isPrimary ? newVisual = newVal : newVisual[key] = newVal;
    });
    return newVisual;
};
/**
 * @public
 * @param {Object} obj
 * @return {Object} new object containers visual values.
 *                 If no visuals, return null.
 */ $72cc7afb3a2d7026$var$VisualMapping.retrieveVisuals = function(obj) {
    var ret = {};
    var hasVisual;
    obj && $72cc7afb3a2d7026$var$each($72cc7afb3a2d7026$var$visualHandlers, function(h, visualType) {
        if (obj.hasOwnProperty(visualType)) {
            ret[visualType] = obj[visualType];
            hasVisual = true;
        }
    });
    return hasVisual ? ret : null;
};
/**
 * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
 *
 * @public
 * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
 *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
 * @return {Array.<string>} Sorted visual types.
 */ $72cc7afb3a2d7026$var$VisualMapping.prepareVisualTypes = function(visualTypes) {
    if ($72cc7afb3a2d7026$var$isObject(visualTypes)) {
        var types = [];
        $72cc7afb3a2d7026$var$each(visualTypes, function(item, type) {
            types.push(type);
        });
        visualTypes = types;
    } else if ($ec279652dd95c27b$export$43bee75e5e14138e(visualTypes)) visualTypes = visualTypes.slice();
    else return [];
    visualTypes.sort(function(type1, type2) {
        // color should be front of colorSaturation, colorAlpha, ...
        // symbol and symbolSize do not matter.
        return type2 === "color" && type1 !== "color" && type1.indexOf("color") === 0 ? 1 : -1;
    });
    return visualTypes;
};
/**
 * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
 * Other visuals are only depends on themself.
 *
 * @public
 * @param {string} visualType1
 * @param {string} visualType2
 * @return {boolean}
 */ $72cc7afb3a2d7026$var$VisualMapping.dependsOn = function(visualType1, visualType2) {
    return visualType2 === "color" ? !!(visualType1 && visualType1.indexOf(visualType2) === 0) : visualType1 === visualType2;
};
/**
 * @param {number} value
 * @param {Array.<Object>} pieceList [{value: ..., interval: [min, max]}, ...]
 *                         Always from small to big.
 * @param {boolean} [findClosestWhenOutside=false]
 * @return {number} index
 */ $72cc7afb3a2d7026$var$VisualMapping.findPieceIndex = function(value, pieceList, findClosestWhenOutside) {
    var possibleI;
    var abs = Infinity; // value has the higher priority.
    for(var i = 0, len = pieceList.length; i < len; i++){
        var pieceValue = pieceList[i].value;
        if (pieceValue != null) {
            if (pieceValue === value // FIXME
             || typeof pieceValue === "string" && pieceValue === value + "") return i;
            findClosestWhenOutside && updatePossible(pieceValue, i);
        }
    }
    for(var i = 0, len = pieceList.length; i < len; i++){
        var piece = pieceList[i];
        var interval = piece.interval;
        var close = piece.close;
        if (interval) {
            if (interval[0] === -Infinity) {
                if ($72cc7afb3a2d7026$var$littleThan(close[1], value, interval[1])) return i;
            } else if (interval[1] === Infinity) {
                if ($72cc7afb3a2d7026$var$littleThan(close[0], interval[0], value)) return i;
            } else if ($72cc7afb3a2d7026$var$littleThan(close[0], interval[0], value) && $72cc7afb3a2d7026$var$littleThan(close[1], value, interval[1])) return i;
            findClosestWhenOutside && updatePossible(interval[0], i);
            findClosestWhenOutside && updatePossible(interval[1], i);
        }
    }
    if (findClosestWhenOutside) return value === Infinity ? pieceList.length - 1 : value === -Infinity ? 0 : possibleI;
    function updatePossible(val, index) {
        var newAbs = Math.abs(val - value);
        if (newAbs < abs) {
            abs = newAbs;
            possibleI = index;
        }
    }
};
function $72cc7afb3a2d7026$var$littleThan(close, a, b) {
    return close ? a <= b : a < b;
}
var $72cc7afb3a2d7026$var$_default = $72cc7afb3a2d7026$var$VisualMapping;
$72cc7afb3a2d7026$exports = $72cc7afb3a2d7026$var$_default;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $22530f2601951680$var$isArray = $ec279652dd95c27b$export$43bee75e5e14138e;
var $22530f2601951680$var$ITEM_STYLE_NORMAL = "itemStyle";
var $22530f2601951680$var$_default = {
    seriesType: "treemap",
    reset: function(seriesModel, ecModel, api, payload) {
        var tree = seriesModel.getData().tree;
        var root = tree.root;
        if (root.isRemoved()) return;
        $22530f2601951680$var$travelTree(root, {}, seriesModel.getViewRoot().getAncestors(), seriesModel);
    }
};
function $22530f2601951680$var$travelTree(node, designatedVisual, viewRootAncestors, seriesModel) {
    var nodeModel = node.getModel();
    var nodeLayout = node.getLayout(); // Optimize
    if (!nodeLayout || nodeLayout.invisible || !nodeLayout.isInView) return;
    var nodeItemStyleModel = node.getModel($22530f2601951680$var$ITEM_STYLE_NORMAL);
    var visuals = $22530f2601951680$var$buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel); // calculate border color
    var borderColor = nodeItemStyleModel.get("borderColor");
    var borderColorSaturation = nodeItemStyleModel.get("borderColorSaturation");
    var thisNodeColor;
    if (borderColorSaturation != null) {
        // For performance, do not always execute 'calculateColor'.
        thisNodeColor = $22530f2601951680$var$calculateColor(visuals, node);
        borderColor = $22530f2601951680$var$calculateBorderColor(borderColorSaturation, thisNodeColor);
    }
    node.setVisual("borderColor", borderColor);
    var viewChildren = node.viewChildren;
    if (!viewChildren || !viewChildren.length) {
        thisNodeColor = $22530f2601951680$var$calculateColor(visuals, node); // Apply visual to this node.
        node.setVisual("color", thisNodeColor);
    } else {
        var mapping = $22530f2601951680$var$buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren); // Designate visual to children.
        $ec279652dd95c27b$export$79b2f7037acddd43(viewChildren, function(child, index) {
            // If higher than viewRoot, only ancestors of viewRoot is needed to visit.
            if (child.depth >= viewRootAncestors.length || child === viewRootAncestors[child.depth]) {
                var childVisual = $22530f2601951680$var$mapVisual(nodeModel, visuals, child, index, mapping, seriesModel);
                $22530f2601951680$var$travelTree(child, childVisual, viewRootAncestors, seriesModel);
            }
        });
    }
}
function $22530f2601951680$var$buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel) {
    var visuals = $ec279652dd95c27b$export$8b58be045bf06082({}, designatedVisual);
    var designatedVisualItemStyle = seriesModel.designatedVisualItemStyle;
    $ec279652dd95c27b$export$79b2f7037acddd43([
        "color",
        "colorAlpha",
        "colorSaturation"
    ], function(visualName) {
        // Priority: thisNode > thisLevel > parentNodeDesignated > seriesModel
        designatedVisualItemStyle[visualName] = designatedVisual[visualName];
        var val = nodeItemStyleModel.get(visualName);
        designatedVisualItemStyle[visualName] = null;
        val != null && (visuals[visualName] = val);
    });
    return visuals;
}
function $22530f2601951680$var$calculateColor(visuals) {
    var color = $22530f2601951680$var$getValueVisualDefine(visuals, "color");
    if (color) {
        var colorAlpha = $22530f2601951680$var$getValueVisualDefine(visuals, "colorAlpha");
        var colorSaturation = $22530f2601951680$var$getValueVisualDefine(visuals, "colorSaturation");
        if (colorSaturation) color = $b1179c91b052e827$export$d898ae866e27bf18(color, null, null, colorSaturation);
        if (colorAlpha) color = $b1179c91b052e827$export$ab4754bf42583a26(color, colorAlpha);
        return color;
    }
}
function $22530f2601951680$var$calculateBorderColor(borderColorSaturation, thisNodeColor) {
    return thisNodeColor != null ? $b1179c91b052e827$export$d898ae866e27bf18(thisNodeColor, null, null, borderColorSaturation) : null;
}
function $22530f2601951680$var$getValueVisualDefine(visuals, name) {
    var value = visuals[name];
    if (value != null && value !== "none") return value;
}
function $22530f2601951680$var$buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren) {
    if (!viewChildren || !viewChildren.length) return;
    var rangeVisual = $22530f2601951680$var$getRangeVisual(nodeModel, "color") || visuals.color != null && visuals.color !== "none" && ($22530f2601951680$var$getRangeVisual(nodeModel, "colorAlpha") || $22530f2601951680$var$getRangeVisual(nodeModel, "colorSaturation"));
    if (!rangeVisual) return;
    var visualMin = nodeModel.get("visualMin");
    var visualMax = nodeModel.get("visualMax");
    var dataExtent = nodeLayout.dataExtent.slice();
    visualMin != null && visualMin < dataExtent[0] && (dataExtent[0] = visualMin);
    visualMax != null && visualMax > dataExtent[1] && (dataExtent[1] = visualMax);
    var colorMappingBy = nodeModel.get("colorMappingBy");
    var opt = {
        type: rangeVisual.name,
        dataExtent: dataExtent,
        visual: rangeVisual.range
    };
    if (opt.type === "color" && (colorMappingBy === "index" || colorMappingBy === "id")) {
        opt.mappingMethod = "category";
        opt.loop = true; // categories is ordinal, so do not set opt.categories.
    } else opt.mappingMethod = "linear";
    var mapping = new $72cc7afb3a2d7026$exports(opt);
    mapping.__drColorMappingBy = colorMappingBy;
    return mapping;
} // Notice: If we dont have the attribute 'colorRange', but only use
// attribute 'color' to represent both concepts of 'colorRange' and 'color',
// (It means 'colorRange' when 'color' is Array, means 'color' when not array),
// this problem will be encountered:
// If a level-1 node dont have children, and its siblings has children,
// and colorRange is set on level-1, then the node can not be colored.
// So we separate 'colorRange' and 'color' to different attributes.
function $22530f2601951680$var$getRangeVisual(nodeModel, name) {
    // 'colorRange', 'colorARange', 'colorSRange'.
    // If not exsits on this node, fetch from levels and series.
    var range = nodeModel.get(name);
    return $22530f2601951680$var$isArray(range) && range.length ? {
        name: name,
        range: range
    } : null;
}
function $22530f2601951680$var$mapVisual(nodeModel, visuals, child, index, mapping, seriesModel) {
    var childVisuals = $ec279652dd95c27b$export$8b58be045bf06082({}, visuals);
    if (mapping) {
        var mappingType = mapping.type;
        var colorMappingBy = mappingType === "color" && mapping.__drColorMappingBy;
        var value = colorMappingBy === "index" ? index : colorMappingBy === "id" ? seriesModel.mapIdToIndex(child.getId()) : child.getValue(nodeModel.get("visualDimension"));
        childVisuals[mappingType] = mapping.mapValueToVisual(value);
    }
    return childVisuals;
}
$22530f2601951680$exports = $22530f2601951680$var$_default;


var $3f95d408d24a51e0$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $3f95d408d24a51e0$var$parsePercent = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f;
var $3f95d408d24a51e0$var$MAX_SAFE_INTEGER = $2d742dbe7f960d8c$export$18510406f204a1b9;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embeded for some of the code in this file:
* The treemap layout implementation was originally copied from
* "d3.js" with some modifications made for this project.
* (See more details in the comment of the method "squarify" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ var $3f95d408d24a51e0$var$mathMax = Math.max;
var $3f95d408d24a51e0$var$mathMin = Math.min;
var $3f95d408d24a51e0$var$retrieveValue = $ec279652dd95c27b$export$8a4d17b6e8486e66;
var $3f95d408d24a51e0$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $3f95d408d24a51e0$var$PATH_BORDER_WIDTH = [
    "itemStyle",
    "borderWidth"
];
var $3f95d408d24a51e0$var$PATH_GAP_WIDTH = [
    "itemStyle",
    "gapWidth"
];
var $3f95d408d24a51e0$var$PATH_UPPER_LABEL_SHOW = [
    "upperLabel",
    "show"
];
var $3f95d408d24a51e0$var$PATH_UPPER_LABEL_HEIGHT = [
    "upperLabel",
    "height"
];
/**
 * @public
 */ var $3f95d408d24a51e0$var$_default = {
    seriesType: "treemap",
    reset: function(seriesModel, ecModel, api, payload) {
        // Layout result in each node:
        // {x, y, width, height, area, borderWidth}
        var ecWidth = api.getWidth();
        var ecHeight = api.getHeight();
        var seriesOption = seriesModel.option;
        var layoutInfo = $ab0c9086dd6c5b39$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
            width: api.getWidth(),
            height: api.getHeight()
        });
        var size = seriesOption.size || []; // Compatible with ec2.
        var containerWidth = $3f95d408d24a51e0$var$parsePercent($3f95d408d24a51e0$var$retrieveValue(layoutInfo.width, size[0]), ecWidth);
        var containerHeight = $3f95d408d24a51e0$var$parsePercent($3f95d408d24a51e0$var$retrieveValue(layoutInfo.height, size[1]), ecHeight); // Fetch payload info.
        var payloadType = payload && payload.type;
        var types = [
            "treemapZoomToNode",
            "treemapRootToNode"
        ];
        var targetInfo = $9dcc91b21f0b70b6$export$c5445fa59c15dec4(payload, types, seriesModel);
        var rootRect = payloadType === "treemapRender" || payloadType === "treemapMove" ? payload.rootRect : null;
        var viewRoot = seriesModel.getViewRoot();
        var viewAbovePath = $9dcc91b21f0b70b6$export$6be31fe4499506f9(viewRoot);
        if (payloadType !== "treemapMove") {
            var rootSize = payloadType === "treemapZoomToNode" ? $3f95d408d24a51e0$var$estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) : rootRect ? [
                rootRect.width,
                rootRect.height
            ] : [
                containerWidth,
                containerHeight
            ];
            var sort = seriesOption.sort;
            if (sort && sort !== "asc" && sort !== "desc") sort = "desc";
            var options = {
                squareRatio: seriesOption.squareRatio,
                sort: sort,
                leafDepth: seriesOption.leafDepth
            }; // layout should be cleared because using updateView but not update.
            viewRoot.hostTree.clearLayouts(); // TODO
            // optimize: if out of view clip, do not layout.
            // But take care that if do not render node out of view clip,
            // how to calculate start po
            var viewRootLayout = {
                x: 0,
                y: 0,
                width: rootSize[0],
                height: rootSize[1],
                area: rootSize[0] * rootSize[1]
            };
            viewRoot.setLayout(viewRootLayout);
            $3f95d408d24a51e0$var$squarify(viewRoot, options, false, 0); // Supplement layout.
            var viewRootLayout = viewRoot.getLayout();
            $3f95d408d24a51e0$var$each(viewAbovePath, function(node, index) {
                var childValue = (viewAbovePath[index + 1] || viewRoot).getValue();
                node.setLayout($ec279652dd95c27b$export$8b58be045bf06082({
                    dataExtent: [
                        childValue,
                        childValue
                    ],
                    borderWidth: 0,
                    upperHeight: 0
                }, viewRootLayout));
            });
        }
        var treeRoot = seriesModel.getData().tree.root;
        treeRoot.setLayout($3f95d408d24a51e0$var$calculateRootPosition(layoutInfo, rootRect, targetInfo), true);
        seriesModel.setLayoutInfo(layoutInfo); // FIXME
        // 现在没有clip功能，暂时取ec高宽。
        $3f95d408d24a51e0$var$prunning(treeRoot, new $33e4fae744d34798$exports(-layoutInfo.x, -layoutInfo.y, ecWidth, ecHeight), viewAbovePath, viewRoot, 0);
    }
};
/**
 * Layout treemap with squarify algorithm.
 * The original presentation of this algorithm
 * was made by Mark Bruls, Kees Huizing, and Jarke J. van Wijk
 * <https://graphics.ethz.ch/teaching/scivis_common/Literature/squarifiedTreeMaps.pdf>.
 * The implementation of this algorithm was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/layout/treemap.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * @protected
 * @param {module:echarts/data/Tree~TreeNode} node
 * @param {Object} options
 * @param {string} options.sort 'asc' or 'desc'
 * @param {number} options.squareRatio
 * @param {boolean} hideChildren
 * @param {number} depth
 */ function $3f95d408d24a51e0$var$squarify(node, options, hideChildren, depth) {
    var width;
    var height;
    if (node.isRemoved()) return;
    var thisLayout = node.getLayout();
    width = thisLayout.width;
    height = thisLayout.height; // Considering border and gap
    var nodeModel = node.getModel();
    var borderWidth = nodeModel.get($3f95d408d24a51e0$var$PATH_BORDER_WIDTH);
    var halfGapWidth = nodeModel.get($3f95d408d24a51e0$var$PATH_GAP_WIDTH) / 2;
    var upperLabelHeight = $3f95d408d24a51e0$var$getUpperLabelHeight(nodeModel);
    var upperHeight = Math.max(borderWidth, upperLabelHeight);
    var layoutOffset = borderWidth - halfGapWidth;
    var layoutOffsetUpper = upperHeight - halfGapWidth;
    var nodeModel = node.getModel();
    node.setLayout({
        borderWidth: borderWidth,
        upperHeight: upperHeight,
        upperLabelHeight: upperLabelHeight
    }, true);
    width = $3f95d408d24a51e0$var$mathMax(width - 2 * layoutOffset, 0);
    height = $3f95d408d24a51e0$var$mathMax(height - layoutOffset - layoutOffsetUpper, 0);
    var totalArea = width * height;
    var viewChildren = $3f95d408d24a51e0$var$initChildren(node, nodeModel, totalArea, options, hideChildren, depth);
    if (!viewChildren.length) return;
    var rect = {
        x: layoutOffset,
        y: layoutOffsetUpper,
        width: width,
        height: height
    };
    var rowFixedLength = $3f95d408d24a51e0$var$mathMin(width, height);
    var best = Infinity; // the best row score so far
    var row = [];
    row.area = 0;
    for(var i = 0, len = viewChildren.length; i < len;){
        var child = viewChildren[i];
        row.push(child);
        row.area += child.getLayout().area;
        var score = $3f95d408d24a51e0$var$worst(row, rowFixedLength, options.squareRatio); // continue with this orientation
        if (score <= best) {
            i++;
            best = score;
        } else {
            row.area -= row.pop().getLayout().area;
            $3f95d408d24a51e0$var$position(row, rowFixedLength, rect, halfGapWidth, false);
            rowFixedLength = $3f95d408d24a51e0$var$mathMin(rect.width, rect.height);
            row.length = row.area = 0;
            best = Infinity;
        }
    }
    if (row.length) $3f95d408d24a51e0$var$position(row, rowFixedLength, rect, halfGapWidth, true);
    if (!hideChildren) {
        var childrenVisibleMin = nodeModel.get("childrenVisibleMin");
        if (childrenVisibleMin != null && totalArea < childrenVisibleMin) hideChildren = true;
    }
    for(var i = 0, len = viewChildren.length; i < len; i++)$3f95d408d24a51e0$var$squarify(viewChildren[i], options, hideChildren, depth + 1);
}
/**
 * Set area to each child, and calculate data extent for visual coding.
 */ function $3f95d408d24a51e0$var$initChildren(node, nodeModel, totalArea, options, hideChildren, depth) {
    var viewChildren = node.children || [];
    var orderBy = options.sort;
    orderBy !== "asc" && orderBy !== "desc" && (orderBy = null);
    var overLeafDepth = options.leafDepth != null && options.leafDepth <= depth; // leafDepth has higher priority.
    if (hideChildren && !overLeafDepth) return node.viewChildren = [];
     // Sort children, order by desc.
    viewChildren = $ec279652dd95c27b$export$3dea766d36a8935f(viewChildren, function(child) {
        return !child.isRemoved();
    });
    $3f95d408d24a51e0$var$sort(viewChildren, orderBy);
    var info = $3f95d408d24a51e0$var$statistic(nodeModel, viewChildren, orderBy);
    if (info.sum === 0) return node.viewChildren = [];
    info.sum = $3f95d408d24a51e0$var$filterByThreshold(nodeModel, totalArea, info.sum, orderBy, viewChildren);
    if (info.sum === 0) return node.viewChildren = [];
     // Set area to each child.
    for(var i = 0, len = viewChildren.length; i < len; i++){
        var area = viewChildren[i].getValue() / info.sum * totalArea; // Do not use setLayout({...}, true), because it is needed to clear last layout.
        viewChildren[i].setLayout({
            area: area
        });
    }
    if (overLeafDepth) {
        viewChildren.length && node.setLayout({
            isLeafRoot: true
        }, true);
        viewChildren.length = 0;
    }
    node.viewChildren = viewChildren;
    node.setLayout({
        dataExtent: info.dataExtent
    }, true);
    return viewChildren;
}
/**
 * Consider 'visibleMin'. Modify viewChildren and get new sum.
 */ function $3f95d408d24a51e0$var$filterByThreshold(nodeModel, totalArea, sum, orderBy, orderedChildren) {
    // visibleMin is not supported yet when no option.sort.
    if (!orderBy) return sum;
    var visibleMin = nodeModel.get("visibleMin");
    var len = orderedChildren.length;
    var deletePoint = len; // Always travel from little value to big value.
    for(var i = len - 1; i >= 0; i--){
        var value = orderedChildren[orderBy === "asc" ? len - i - 1 : i].getValue();
        if (value / sum * totalArea < visibleMin) {
            deletePoint = i;
            sum -= value;
        }
    }
    orderBy === "asc" ? orderedChildren.splice(0, len - deletePoint) : orderedChildren.splice(deletePoint, len - deletePoint);
    return sum;
}
/**
 * Sort
 */ function $3f95d408d24a51e0$var$sort(viewChildren, orderBy) {
    if (orderBy) viewChildren.sort(function(a, b) {
        var diff = orderBy === "asc" ? a.getValue() - b.getValue() : b.getValue() - a.getValue();
        return diff === 0 ? orderBy === "asc" ? a.dataIndex - b.dataIndex : b.dataIndex - a.dataIndex : diff;
    });
    return viewChildren;
}
/**
 * Statistic
 */ function $3f95d408d24a51e0$var$statistic(nodeModel, children, orderBy) {
    // Calculate sum.
    var sum = 0;
    for(var i = 0, len = children.length; i < len; i++)sum += children[i].getValue();
     // Statistic data extent for latter visual coding.
    // Notice: data extent should be calculate based on raw children
    // but not filtered view children, otherwise visual mapping will not
    // be stable when zoom (where children is filtered by visibleMin).
    var dimension = nodeModel.get("visualDimension");
    var dataExtent; // The same as area dimension.
    if (!children || !children.length) dataExtent = [
        NaN,
        NaN
    ];
    else if (dimension === "value" && orderBy) {
        dataExtent = [
            children[children.length - 1].getValue(),
            children[0].getValue()
        ];
        orderBy === "asc" && dataExtent.reverse();
    } else {
        var dataExtent = [
            Infinity,
            -Infinity
        ];
        $3f95d408d24a51e0$var$each(children, function(child) {
            var value = child.getValue(dimension);
            value < dataExtent[0] && (dataExtent[0] = value);
            value > dataExtent[1] && (dataExtent[1] = value);
        });
    }
    return {
        sum: sum,
        dataExtent: dataExtent
    };
}
/**
 * Computes the score for the specified row,
 * as the worst aspect ratio.
 */ function $3f95d408d24a51e0$var$worst(row, rowFixedLength, ratio) {
    var areaMax = 0;
    var areaMin = Infinity;
    for(var i = 0, area, len = row.length; i < len; i++){
        area = row[i].getLayout().area;
        if (area) {
            area < areaMin && (areaMin = area);
            area > areaMax && (areaMax = area);
        }
    }
    var squareArea = row.area * row.area;
    var f = rowFixedLength * rowFixedLength * ratio;
    return squareArea ? $3f95d408d24a51e0$var$mathMax(f * areaMax / squareArea, squareArea / (f * areaMin)) : Infinity;
}
/**
 * Positions the specified row of nodes. Modifies `rect`.
 */ function $3f95d408d24a51e0$var$position(row, rowFixedLength, rect, halfGapWidth, flush) {
    // When rowFixedLength === rect.width,
    // it is horizontal subdivision,
    // rowFixedLength is the width of the subdivision,
    // rowOtherLength is the height of the subdivision,
    // and nodes will be positioned from left to right.
    // wh[idx0WhenH] means: when horizontal,
    //      wh[idx0WhenH] => wh[0] => 'width'.
    //      xy[idx1WhenH] => xy[1] => 'y'.
    var idx0WhenH = rowFixedLength === rect.width ? 0 : 1;
    var idx1WhenH = 1 - idx0WhenH;
    var xy = [
        "x",
        "y"
    ];
    var wh = [
        "width",
        "height"
    ];
    var last = rect[xy[idx0WhenH]];
    var rowOtherLength = rowFixedLength ? row.area / rowFixedLength : 0;
    if (flush || rowOtherLength > rect[wh[idx1WhenH]]) rowOtherLength = rect[wh[idx1WhenH]]; // over+underflow
    for(var i = 0, rowLen = row.length; i < rowLen; i++){
        var node = row[i];
        var nodeLayout = {};
        var step = rowOtherLength ? node.getLayout().area / rowOtherLength : 0;
        var wh1 = nodeLayout[wh[idx1WhenH]] = $3f95d408d24a51e0$var$mathMax(rowOtherLength - 2 * halfGapWidth, 0); // We use Math.max/min to avoid negative width/height when considering gap width.
        var remain = rect[xy[idx0WhenH]] + rect[wh[idx0WhenH]] - last;
        var modWH = i === rowLen - 1 || remain < step ? remain : step;
        var wh0 = nodeLayout[wh[idx0WhenH]] = $3f95d408d24a51e0$var$mathMax(modWH - 2 * halfGapWidth, 0);
        nodeLayout[xy[idx1WhenH]] = rect[xy[idx1WhenH]] + $3f95d408d24a51e0$var$mathMin(halfGapWidth, wh1 / 2);
        nodeLayout[xy[idx0WhenH]] = last + $3f95d408d24a51e0$var$mathMin(halfGapWidth, wh0 / 2);
        last += modWH;
        node.setLayout(nodeLayout, true);
    }
    rect[xy[idx1WhenH]] += rowOtherLength;
    rect[wh[idx1WhenH]] -= rowOtherLength;
} // Return [containerWidth, containerHeight] as default.
function $3f95d408d24a51e0$var$estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) {
    // If targetInfo.node exists, we zoom to the node,
    // so estimate whold width and heigth by target node.
    var currNode = (targetInfo || {}).node;
    var defaultSize = [
        containerWidth,
        containerHeight
    ];
    if (!currNode || currNode === viewRoot) return defaultSize;
    var parent;
    var viewArea = containerWidth * containerHeight;
    var area = viewArea * seriesModel.option.zoomToNodeRatio;
    while(parent = currNode.parentNode){
        // jshint ignore:line
        var sum = 0;
        var siblings = parent.children;
        for(var i = 0, len = siblings.length; i < len; i++)sum += siblings[i].getValue();
        var currNodeValue = currNode.getValue();
        if (currNodeValue === 0) return defaultSize;
        area *= sum / currNodeValue; // Considering border, suppose aspect ratio is 1.
        var parentModel = parent.getModel();
        var borderWidth = parentModel.get($3f95d408d24a51e0$var$PATH_BORDER_WIDTH);
        var upperHeight = Math.max(borderWidth, $3f95d408d24a51e0$var$getUpperLabelHeight(parentModel, borderWidth));
        area += 4 * borderWidth * borderWidth + (3 * borderWidth + upperHeight) * Math.pow(area, 0.5);
        area > $3f95d408d24a51e0$var$MAX_SAFE_INTEGER && (area = $3f95d408d24a51e0$var$MAX_SAFE_INTEGER);
        currNode = parent;
    }
    area < viewArea && (area = viewArea);
    var scale = Math.pow(area / viewArea, 0.5);
    return [
        containerWidth * scale,
        containerHeight * scale
    ];
} // Root postion base on coord of containerGroup
function $3f95d408d24a51e0$var$calculateRootPosition(layoutInfo, rootRect, targetInfo) {
    if (rootRect) return {
        x: rootRect.x,
        y: rootRect.y
    };
    var defaultPosition = {
        x: 0,
        y: 0
    };
    if (!targetInfo) return defaultPosition;
     // If targetInfo is fetched by 'retrieveTargetInfo',
    // old tree and new tree are the same tree,
    // so the node still exists and we can visit it.
    var targetNode = targetInfo.node;
    var layout = targetNode.getLayout();
    if (!layout) return defaultPosition;
     // Transform coord from local to container.
    var targetCenter = [
        layout.width / 2,
        layout.height / 2
    ];
    var node = targetNode;
    while(node){
        var nodeLayout = node.getLayout();
        targetCenter[0] += nodeLayout.x;
        targetCenter[1] += nodeLayout.y;
        node = node.parentNode;
    }
    return {
        x: layoutInfo.width / 2 - targetCenter[0],
        y: layoutInfo.height / 2 - targetCenter[1]
    };
} // Mark nodes visible for prunning when visual coding and rendering.
// Prunning depends on layout and root position, so we have to do it after layout.
function $3f95d408d24a51e0$var$prunning(node, clipRect, viewAbovePath, viewRoot, depth) {
    var nodeLayout = node.getLayout();
    var nodeInViewAbovePath = viewAbovePath[depth];
    var isAboveViewRoot = nodeInViewAbovePath && nodeInViewAbovePath === node;
    if (nodeInViewAbovePath && !isAboveViewRoot || depth === viewAbovePath.length && node !== viewRoot) return;
    node.setLayout({
        // isInView means: viewRoot sub tree + viewAbovePath
        isInView: true,
        // invisible only means: outside view clip so that the node can not
        // see but still layout for animation preparation but not render.
        invisible: !isAboveViewRoot && !clipRect.intersect(nodeLayout),
        isAboveViewRoot: isAboveViewRoot
    }, true); // Transform to child coordinate.
    var childClipRect = new $33e4fae744d34798$exports(clipRect.x - nodeLayout.x, clipRect.y - nodeLayout.y, clipRect.width, clipRect.height);
    $3f95d408d24a51e0$var$each(node.viewChildren || [], function(child) {
        $3f95d408d24a51e0$var$prunning(child, childClipRect, viewAbovePath, viewRoot, depth + 1);
    });
}
function $3f95d408d24a51e0$var$getUpperLabelHeight(model) {
    return model.get($3f95d408d24a51e0$var$PATH_UPPER_LABEL_SHOW) ? model.get($3f95d408d24a51e0$var$PATH_UPPER_LABEL_HEIGHT) : 0;
}
$3f95d408d24a51e0$exports = $3f95d408d24a51e0$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerVisual($22530f2601951680$exports);
$f406636b535430a7$exports.registerLayout($3f95d408d24a51e0$exports);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9797037c9f9a4007$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $9797037c9f9a4007$var$defaultEmphasis = $d559f43cb9041423$export$abdcc6a26372f94b;


var $9797037c9f9a4007$var$encodeHTML = $a4be9366aeb9fcc8$export$f9d6449b9af28dc1;
var $0e1e8e36c7c1833e$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $4bcacd140b4b0300$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4bcacd140b4b0300$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;


var $4bcacd140b4b0300$var$enableClassCheck = $c125ba1250423743$export$e1aac4552ae82081;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // id may be function name of Object, add a prefix to avoid this problem.
function $4bcacd140b4b0300$var$generateNodeKey(id) {
    return "_EC_" + id;
}
/**
 * @alias module:echarts/data/Graph
 * @constructor
 * @param {boolean} directed
 */ var $4bcacd140b4b0300$var$Graph = function(directed) {
    /**
   * 是否是有向图
   * @type {boolean}
   * @private
   */ this._directed = directed || false;
    /**
   * @type {Array.<module:echarts/data/Graph.Node>}
   * @readOnly
   */ this.nodes = [];
    /**
   * @type {Array.<module:echarts/data/Graph.Edge>}
   * @readOnly
   */ this.edges = [];
    /**
   * @type {Object.<string, module:echarts/data/Graph.Node>}
   * @private
   */ this._nodesMap = {};
    /**
   * @type {Object.<string, module:echarts/data/Graph.Edge>}
   * @private
   */ this._edgesMap = {};
    /**
   * @type {module:echarts/data/List}
   * @readOnly
   */ this.data;
    /**
   * @type {module:echarts/data/List}
   * @readOnly
   */ this.edgeData;
};
var $4bcacd140b4b0300$var$graphProto = $4bcacd140b4b0300$var$Graph.prototype;
/**
 * @type {string}
 */ $4bcacd140b4b0300$var$graphProto.type = "graph";
/**
 * If is directed graph
 * @return {boolean}
 */ $4bcacd140b4b0300$var$graphProto.isDirected = function() {
    return this._directed;
};
/**
 * Add a new node
 * @param {string} id
 * @param {number} [dataIndex]
 */ $4bcacd140b4b0300$var$graphProto.addNode = function(id, dataIndex) {
    id = id == null ? "" + dataIndex : "" + id;
    var nodesMap = this._nodesMap;
    if (nodesMap[$4bcacd140b4b0300$var$generateNodeKey(id)]) return;
    var node = new $4bcacd140b4b0300$var$Node(id, dataIndex);
    node.hostGraph = this;
    this.nodes.push(node);
    nodesMap[$4bcacd140b4b0300$var$generateNodeKey(id)] = node;
    return node;
};
/**
 * Get node by data index
 * @param  {number} dataIndex
 * @return {module:echarts/data/Graph~Node}
 */ $4bcacd140b4b0300$var$graphProto.getNodeByIndex = function(dataIndex) {
    var rawIdx = this.data.getRawIndex(dataIndex);
    return this.nodes[rawIdx];
};
/**
 * Get node by id
 * @param  {string} id
 * @return {module:echarts/data/Graph.Node}
 */ $4bcacd140b4b0300$var$graphProto.getNodeById = function(id) {
    return this._nodesMap[$4bcacd140b4b0300$var$generateNodeKey(id)];
};
/**
 * Add a new edge
 * @param {number|string|module:echarts/data/Graph.Node} n1
 * @param {number|string|module:echarts/data/Graph.Node} n2
 * @param {number} [dataIndex=-1]
 * @return {module:echarts/data/Graph.Edge}
 */ $4bcacd140b4b0300$var$graphProto.addEdge = function(n1, n2, dataIndex) {
    var nodesMap = this._nodesMap;
    var edgesMap = this._edgesMap; // PNEDING
    if (typeof n1 === "number") n1 = this.nodes[n1];
    if (typeof n2 === "number") n2 = this.nodes[n2];
    if (!$4bcacd140b4b0300$var$Node.isInstance(n1)) n1 = nodesMap[$4bcacd140b4b0300$var$generateNodeKey(n1)];
    if (!$4bcacd140b4b0300$var$Node.isInstance(n2)) n2 = nodesMap[$4bcacd140b4b0300$var$generateNodeKey(n2)];
    if (!n1 || !n2) return;
    var key = n1.id + "-" + n2.id;
    var edge = new $4bcacd140b4b0300$var$Edge(n1, n2, dataIndex);
    edge.hostGraph = this;
    if (this._directed) {
        n1.outEdges.push(edge);
        n2.inEdges.push(edge);
    }
    n1.edges.push(edge);
    if (n1 !== n2) n2.edges.push(edge);
    this.edges.push(edge);
    edgesMap[key] = edge;
    return edge;
};
/**
 * Get edge by data index
 * @param  {number} dataIndex
 * @return {module:echarts/data/Graph~Node}
 */ $4bcacd140b4b0300$var$graphProto.getEdgeByIndex = function(dataIndex) {
    var rawIdx = this.edgeData.getRawIndex(dataIndex);
    return this.edges[rawIdx];
};
/**
 * Get edge by two linked nodes
 * @param  {module:echarts/data/Graph.Node|string} n1
 * @param  {module:echarts/data/Graph.Node|string} n2
 * @return {module:echarts/data/Graph.Edge}
 */ $4bcacd140b4b0300$var$graphProto.getEdge = function(n1, n2) {
    if ($4bcacd140b4b0300$var$Node.isInstance(n1)) n1 = n1.id;
    if ($4bcacd140b4b0300$var$Node.isInstance(n2)) n2 = n2.id;
    var edgesMap = this._edgesMap;
    if (this._directed) return edgesMap[n1 + "-" + n2];
    else return edgesMap[n1 + "-" + n2] || edgesMap[n2 + "-" + n1];
};
/**
 * Iterate all nodes
 * @param  {Function} cb
 * @param  {*} [context]
 */ $4bcacd140b4b0300$var$graphProto.eachNode = function(cb, context) {
    var nodes = this.nodes;
    var len = nodes.length;
    for(var i = 0; i < len; i++)if (nodes[i].dataIndex >= 0) cb.call(context, nodes[i], i);
};
/**
 * Iterate all edges
 * @param  {Function} cb
 * @param  {*} [context]
 */ $4bcacd140b4b0300$var$graphProto.eachEdge = function(cb, context) {
    var edges = this.edges;
    var len = edges.length;
    for(var i = 0; i < len; i++)if (edges[i].dataIndex >= 0 && edges[i].node1.dataIndex >= 0 && edges[i].node2.dataIndex >= 0) cb.call(context, edges[i], i);
};
/**
 * Breadth first traverse
 * @param {Function} cb
 * @param {module:echarts/data/Graph.Node} startNode
 * @param {string} [direction='none'] 'none'|'in'|'out'
 * @param {*} [context]
 */ $4bcacd140b4b0300$var$graphProto.breadthFirstTraverse = function(cb, startNode, direction, context) {
    if (!$4bcacd140b4b0300$var$Node.isInstance(startNode)) startNode = this._nodesMap[$4bcacd140b4b0300$var$generateNodeKey(startNode)];
    if (!startNode) return;
    var edgeType = direction === "out" ? "outEdges" : direction === "in" ? "inEdges" : "edges";
    for(var i = 0; i < this.nodes.length; i++)this.nodes[i].__visited = false;
    if (cb.call(context, startNode, null)) return;
    var queue = [
        startNode
    ];
    while(queue.length){
        var currentNode = queue.shift();
        var edges = currentNode[edgeType];
        for(var i = 0; i < edges.length; i++){
            var e = edges[i];
            var otherNode = e.node1 === currentNode ? e.node2 : e.node1;
            if (!otherNode.__visited) {
                if (cb.call(context, otherNode, currentNode)) // Stop traversing
                return;
                queue.push(otherNode);
                otherNode.__visited = true;
            }
        }
    }
}; // TODO
// graphProto.depthFirstTraverse = function (
//     cb, startNode, direction, context
// ) {
// };
// Filter update
$4bcacd140b4b0300$var$graphProto.update = function() {
    var data = this.data;
    var edgeData = this.edgeData;
    var nodes = this.nodes;
    var edges = this.edges;
    for(var i = 0, len = nodes.length; i < len; i++)nodes[i].dataIndex = -1;
    for(var i = 0, len = data.count(); i < len; i++)nodes[data.getRawIndex(i)].dataIndex = i;
    edgeData.filterSelf(function(idx) {
        var edge = edges[edgeData.getRawIndex(idx)];
        return edge.node1.dataIndex >= 0 && edge.node2.dataIndex >= 0;
    }); // Update edge
    for(var i = 0, len = edges.length; i < len; i++)edges[i].dataIndex = -1;
    for(var i = 0, len = edgeData.count(); i < len; i++)edges[edgeData.getRawIndex(i)].dataIndex = i;
};
/**
 * @return {module:echarts/data/Graph}
 */ $4bcacd140b4b0300$var$graphProto.clone = function() {
    var graph = new $4bcacd140b4b0300$var$Graph(this._directed);
    var nodes = this.nodes;
    var edges = this.edges;
    for(var i = 0; i < nodes.length; i++)graph.addNode(nodes[i].id, nodes[i].dataIndex);
    for(var i = 0; i < edges.length; i++){
        var e = edges[i];
        graph.addEdge(e.node1.id, e.node2.id, e.dataIndex);
    }
    return graph;
};
/**
 * @alias module:echarts/data/Graph.Node
 */ function $4bcacd140b4b0300$var$Node(id, dataIndex) {
    /**
  * @type {string}
  */ this.id = id == null ? "" : id;
    /**
  * @type {Array.<module:echarts/data/Graph.Edge>}
  */ this.inEdges = [];
    /**
  * @type {Array.<module:echarts/data/Graph.Edge>}
  */ this.outEdges = [];
    /**
  * @type {Array.<module:echarts/data/Graph.Edge>}
  */ this.edges = [];
    /**
   * @type {module:echarts/data/Graph}
   */ this.hostGraph;
    /**
   * @type {number}
   */ this.dataIndex = dataIndex == null ? -1 : dataIndex;
}
$4bcacd140b4b0300$var$Node.prototype = {
    constructor: $4bcacd140b4b0300$var$Node,
    /**
   * @return {number}
   */ degree: function() {
        return this.edges.length;
    },
    /**
   * @return {number}
   */ inDegree: function() {
        return this.inEdges.length;
    },
    /**
  * @return {number}
  */ outDegree: function() {
        return this.outEdges.length;
    },
    /**
   * @param {string} [path]
   * @return {module:echarts/model/Model}
   */ getModel: function(path) {
        if (this.dataIndex < 0) return;
        var graph = this.hostGraph;
        var itemModel = graph.data.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    }
};
/**
 * 图边
 * @alias module:echarts/data/Graph.Edge
 * @param {module:echarts/data/Graph.Node} n1
 * @param {module:echarts/data/Graph.Node} n2
 * @param {number} [dataIndex=-1]
 */ function $4bcacd140b4b0300$var$Edge(n1, n2, dataIndex) {
    /**
   * 节点1，如果是有向图则为源节点
   * @type {module:echarts/data/Graph.Node}
   */ this.node1 = n1;
    /**
   * 节点2，如果是有向图则为目标节点
   * @type {module:echarts/data/Graph.Node}
   */ this.node2 = n2;
    this.dataIndex = dataIndex == null ? -1 : dataIndex;
}
/**
 * @param {string} [path]
 * @return {module:echarts/model/Model}
 */ $4bcacd140b4b0300$var$Edge.prototype.getModel = function(path) {
    if (this.dataIndex < 0) return;
    var graph = this.hostGraph;
    var itemModel = graph.edgeData.getItemModel(this.dataIndex);
    return itemModel.getModel(path);
};
var $4bcacd140b4b0300$var$createGraphDataProxyMixin = function(hostName, dataName) {
    return {
        /**
     * @param {string=} [dimension='value'] Default 'value'. can be 'a', 'b', 'c', 'd', 'e'.
     * @return {number}
     */ getValue: function(dimension) {
            var data = this[hostName][dataName];
            return data.get(data.getDimension(dimension || "value"), this.dataIndex);
        },
        /**
     * @param {Object|string} key
     * @param {*} [value]
     */ setVisual: function(key, value) {
            this.dataIndex >= 0 && this[hostName][dataName].setItemVisual(this.dataIndex, key, value);
        },
        /**
     * @param {string} key
     * @return {boolean}
     */ getVisual: function(key, ignoreParent) {
            return this[hostName][dataName].getItemVisual(this.dataIndex, key, ignoreParent);
        },
        /**
     * @param {Object} layout
     * @return {boolean} [merge=false]
     */ setLayout: function(layout, merge) {
            this.dataIndex >= 0 && this[hostName][dataName].setItemLayout(this.dataIndex, layout, merge);
        },
        /**
     * @return {Object}
     */ getLayout: function() {
            return this[hostName][dataName].getItemLayout(this.dataIndex);
        },
        /**
     * @return {module:zrender/Element}
     */ getGraphicEl: function() {
            return this[hostName][dataName].getItemGraphicEl(this.dataIndex);
        },
        /**
     * @return {number}
     */ getRawIndex: function() {
            return this[hostName][dataName].getRawIndex(this.dataIndex);
        }
    };
};
$ec279652dd95c27b$export$e36fc9d62a853069($4bcacd140b4b0300$var$Node, $4bcacd140b4b0300$var$createGraphDataProxyMixin("hostGraph", "data"));
$ec279652dd95c27b$export$e36fc9d62a853069($4bcacd140b4b0300$var$Edge, $4bcacd140b4b0300$var$createGraphDataProxyMixin("hostGraph", "edgeData"));
$4bcacd140b4b0300$var$Graph.Node = $4bcacd140b4b0300$var$Node;
$4bcacd140b4b0300$var$Graph.Edge = $4bcacd140b4b0300$var$Edge;
$4bcacd140b4b0300$var$enableClassCheck($4bcacd140b4b0300$var$Node);
$4bcacd140b4b0300$var$enableClassCheck($4bcacd140b4b0300$var$Edge);
var $4bcacd140b4b0300$var$_default = $4bcacd140b4b0300$var$Graph;
$4bcacd140b4b0300$exports = $4bcacd140b4b0300$var$_default;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $0e1e8e36c7c1833e$var$_default(nodes, edges, seriesModel, directed, beforeLink) {
    // ??? TODO
    // support dataset?
    var graph = new $4bcacd140b4b0300$exports(directed);
    for(var i = 0; i < nodes.length; i++)graph.addNode($ec279652dd95c27b$export$8a4d17b6e8486e66(nodes[i].id, nodes[i].name, i), i);
    var linkNameList = [];
    var validEdges = [];
    var linkCount = 0;
    for(var i = 0; i < edges.length; i++){
        var link = edges[i];
        var source = link.source;
        var target = link.target; // addEdge may fail when source or target not exists
        if (graph.addEdge(source, target, linkCount)) {
            validEdges.push(link);
            linkNameList.push($ec279652dd95c27b$export$8a4d17b6e8486e66(link.id, source + " > " + target));
            linkCount++;
        }
    }
    var coordSys = seriesModel.get("coordinateSystem");
    var nodeData;
    if (coordSys === "cartesian2d" || coordSys === "polar") nodeData = $10e48b57e44af7c1$exports(nodes, seriesModel);
    else {
        var coordSysCtor = $9c36d0fff3b0f387$exports.get(coordSys);
        var coordDimensions = coordSysCtor && coordSysCtor.type !== "view" ? coordSysCtor.dimensions || [] : []; // FIXME: Some geo do not need `value` dimenson, whereas `calendar` needs
        // `value` dimension, but graph need `value` dimension. It's better to
        // uniform this behavior.
        if ($ec279652dd95c27b$export$305f7d4e9d4624f2(coordDimensions, "value") < 0) coordDimensions.concat([
            "value"
        ]);
        var dimensionNames = $c766697b1ee08f64$exports(nodes, {
            coordDimensions: coordDimensions
        });
        nodeData = new $f643df856475f69e$exports(dimensionNames, seriesModel);
        nodeData.initData(nodes);
    }
    var edgeData = new $f643df856475f69e$exports([
        "value"
    ], seriesModel);
    edgeData.initData(validEdges, linkNameList);
    beforeLink && beforeLink(nodeData, edgeData);
    $e71b48bcfe9ccb76$exports({
        mainData: nodeData,
        struct: graph,
        structAttr: "graph",
        datas: {
            node: nodeData,
            edge: edgeData
        },
        datasAttr: {
            node: "data",
            edge: "edgeData"
        }
    }); // Update dataIndex of nodes and edges because invalid edge may be removed
    graph.update();
    return graph;
}
$0e1e8e36c7c1833e$exports = $0e1e8e36c7c1833e$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $51497e7e6c6924a6$export$4f05389c1f2934b8;
var $51497e7e6c6924a6$export$c47b549eed9a7311;
var $51497e7e6c6924a6$export$7e88123f7f1f62da;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $51497e7e6c6924a6$var$KEY_DELIMITER = "-->";
/**
 * params handler
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {*}
 */ var $51497e7e6c6924a6$var$getAutoCurvenessParams = function(seriesModel) {
    return seriesModel.get("autoCurveness") || null;
};
/**
 * Generate a list of edge curvatures, 20 is the default
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @param {number} appendLength
 * @return  20 => [0, -0.2, 0.2, -0.4, 0.4, -0.6, 0.6, -0.8, 0.8, -1, 1, -1.2, 1.2, -1.4, 1.4, -1.6, 1.6, -1.8, 1.8, -2]
 */ var $51497e7e6c6924a6$var$createCurveness = function(seriesModel, appendLength) {
    var autoCurvenessParmas = $51497e7e6c6924a6$var$getAutoCurvenessParams(seriesModel);
    var length = 20;
    var curvenessList = []; // handler the function set
    if (typeof autoCurvenessParmas === "number") length = autoCurvenessParmas;
    else if ($ec279652dd95c27b$export$43bee75e5e14138e(autoCurvenessParmas)) {
        seriesModel.__curvenessList = autoCurvenessParmas;
        return;
    } // append length
    if (appendLength > length) length = appendLength;
     // make sure the length is even
    var len = length % 2 ? length + 2 : length + 3;
    curvenessList = [];
    for(var i = 0; i < len; i++)curvenessList.push((i % 2 ? i + 1 : i) / 10 * (i % 2 ? -1 : 1));
    seriesModel.__curvenessList = curvenessList;
};
/**
 * Create different cache key data in the positive and negative directions, in order to set the curvature later
 * @param {number|string|module:echarts/data/Graph.Node} n1
 * @param {number|string|module:echarts/data/Graph.Node} n2
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {string} key
 */ var $51497e7e6c6924a6$var$getKeyOfEdges = function(n1, n2, seriesModel) {
    var source = [
        n1.id,
        n1.dataIndex
    ].join(".");
    var target = [
        n2.id,
        n2.dataIndex
    ].join(".");
    return [
        seriesModel.uid,
        source,
        target
    ].join($51497e7e6c6924a6$var$KEY_DELIMITER);
};
/**
 * get opposite key
 * @param {string} key
 * @returns {string}
 */ var $51497e7e6c6924a6$var$getOppositeKey = function(key) {
    var keys = key.split($51497e7e6c6924a6$var$KEY_DELIMITER);
    return [
        keys[0],
        keys[2],
        keys[1]
    ].join($51497e7e6c6924a6$var$KEY_DELIMITER);
};
/**
 * get edgeMap with key
 * @param edge
 * @param {module:echarts/model/SeriesModel} seriesModel
 */ var $51497e7e6c6924a6$var$getEdgeFromMap = function(edge, seriesModel) {
    var key = $51497e7e6c6924a6$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel);
    return seriesModel.__edgeMap[key];
};
/**
 * calculate all cases total length
 * @param edge
 * @param seriesModel
 * @returns {number}
 */ var $51497e7e6c6924a6$var$getTotalLengthBetweenNodes = function(edge, seriesModel) {
    var len = $51497e7e6c6924a6$var$getEdgeMapLengthWithKey($51497e7e6c6924a6$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel), seriesModel);
    var lenV = $51497e7e6c6924a6$var$getEdgeMapLengthWithKey($51497e7e6c6924a6$var$getKeyOfEdges(edge.node2, edge.node1, seriesModel), seriesModel);
    return len + lenV;
};
/**
 *
 * @param key
 */ var $51497e7e6c6924a6$var$getEdgeMapLengthWithKey = function(key, seriesModel) {
    var edgeMap = seriesModel.__edgeMap;
    return edgeMap[key] ? edgeMap[key].length : 0;
};
/**
 * Count the number of edges between the same two points, used to obtain the curvature table and the parity of the edge
 * @see /graph/GraphSeries.js@getInitialData
 * @param {module:echarts/model/SeriesModel} seriesModel
 */ function $51497e7e6c6924a6$var$initCurvenessList(seriesModel) {
    if (!$51497e7e6c6924a6$var$getAutoCurvenessParams(seriesModel)) return;
    seriesModel.__curvenessList = [];
    seriesModel.__edgeMap = {}; // calc the array of curveness List
    $51497e7e6c6924a6$var$createCurveness(seriesModel);
}
/**
 * set edgeMap with key
 * @param {number|string|module:echarts/data/Graph.Node} n1
 * @param {number|string|module:echarts/data/Graph.Node} n2
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @param {number} index
 */ function $51497e7e6c6924a6$var$createEdgeMapForCurveness(n1, n2, seriesModel, index) {
    if (!$51497e7e6c6924a6$var$getAutoCurvenessParams(seriesModel)) return;
    var key = $51497e7e6c6924a6$var$getKeyOfEdges(n1, n2, seriesModel);
    var edgeMap = seriesModel.__edgeMap;
    var oppositeEdges = edgeMap[$51497e7e6c6924a6$var$getOppositeKey(key)]; // set direction
    if (edgeMap[key] && !oppositeEdges) edgeMap[key].isForward = true;
    else if (oppositeEdges && edgeMap[key]) {
        oppositeEdges.isForward = true;
        edgeMap[key].isForward = false;
    }
    edgeMap[key] = edgeMap[key] || [];
    edgeMap[key].push(index);
}
/**
 * get curvature for edge
 * @param edge
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @param index
 */ function $51497e7e6c6924a6$var$getCurvenessForEdge(edge, seriesModel, index, needReverse) {
    var autoCurvenessParams = $51497e7e6c6924a6$var$getAutoCurvenessParams(seriesModel);
    var isArrayParam = $ec279652dd95c27b$export$43bee75e5e14138e(autoCurvenessParams);
    if (!autoCurvenessParams) return null;
    var edgeArray = $51497e7e6c6924a6$var$getEdgeFromMap(edge, seriesModel);
    if (!edgeArray) return null;
    var edgeIndex = -1;
    for(var i = 0; i < edgeArray.length; i++)if (edgeArray[i] === index) {
        edgeIndex = i;
        break;
    }
     // if totalLen is Longer createCurveness
    var totalLen = $51497e7e6c6924a6$var$getTotalLengthBetweenNodes(edge, seriesModel);
    $51497e7e6c6924a6$var$createCurveness(seriesModel, totalLen);
    edge.lineStyle = edge.lineStyle || {}; // if is opposite edge, must set curvenss to opposite number
    var curKey = $51497e7e6c6924a6$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel);
    var curvenessList = seriesModel.__curvenessList; // if pass array no need parity
    var parityCorrection = isArrayParam ? 0 : totalLen % 2 ? 0 : 1;
    if (!edgeArray.isForward) {
        // the opposite edge show outside
        var oppositeKey = $51497e7e6c6924a6$var$getOppositeKey(curKey);
        var len = $51497e7e6c6924a6$var$getEdgeMapLengthWithKey(oppositeKey, seriesModel);
        var resValue = curvenessList[edgeIndex + len + parityCorrection]; // isNeedReverse, simple, force type need reverse the curveness in the junction of the forword and the opposite
        if (needReverse) {
            // set as array may make the parity handle with the len of opposite
            if (isArrayParam) {
                if (autoCurvenessParams && autoCurvenessParams[0] === 0) return (len + parityCorrection) % 2 ? resValue : -resValue;
                else return ((len % 2 ? 0 : 1) + parityCorrection) % 2 ? resValue : -resValue;
            } else return (len + parityCorrection) % 2 ? resValue : -resValue;
        } else return curvenessList[edgeIndex + len + parityCorrection];
    } else return curvenessList[parityCorrection + edgeIndex];
}
$51497e7e6c6924a6$export$4f05389c1f2934b8 = $51497e7e6c6924a6$var$initCurvenessList;
$51497e7e6c6924a6$export$c47b549eed9a7311 = $51497e7e6c6924a6$var$createEdgeMapForCurveness;
$51497e7e6c6924a6$export$7e88123f7f1f62da = $51497e7e6c6924a6$var$getCurvenessForEdge;


var $9797037c9f9a4007$var$initCurvenessList = $51497e7e6c6924a6$export$4f05389c1f2934b8;
var $9797037c9f9a4007$var$createEdgeMapForCurveness = $51497e7e6c6924a6$export$c47b549eed9a7311;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $9797037c9f9a4007$var$GraphSeries = $f406636b535430a7$exports.extendSeriesModel({
    type: "series.graph",
    init: function(option) {
        $9797037c9f9a4007$var$GraphSeries.superApply(this, "init", arguments);
        var self = this;
        function getCategoriesData() {
            return self._categoriesData;
        } // Provide data for legend select
        this.legendVisualProvider = new $6b46bfdbd75036d4$exports(getCategoriesData, getCategoriesData);
        this.fillDataTextStyle(option.edges || option.links);
        this._updateCategoriesData();
    },
    mergeOption: function(option) {
        $9797037c9f9a4007$var$GraphSeries.superApply(this, "mergeOption", arguments);
        this.fillDataTextStyle(option.edges || option.links);
        this._updateCategoriesData();
    },
    mergeDefaultAndTheme: function(option) {
        $9797037c9f9a4007$var$GraphSeries.superApply(this, "mergeDefaultAndTheme", arguments);
        $9797037c9f9a4007$var$defaultEmphasis(option, [
            "edgeLabel"
        ], [
            "show"
        ]);
    },
    getInitialData: function(option, ecModel) {
        var edges = option.edges || option.links || [];
        var nodes = option.data || option.nodes || [];
        var self = this;
        if (nodes && edges) {
            // auto curveness
            $9797037c9f9a4007$var$initCurvenessList(this);
            var graph = $0e1e8e36c7c1833e$exports(nodes, edges, this, true, beforeLink);
            $ec279652dd95c27b$export$79b2f7037acddd43(graph.edges, function(edge) {
                $9797037c9f9a4007$var$createEdgeMapForCurveness(edge.node1, edge.node2, this, edge.dataIndex);
            }, this);
            return graph.data;
        }
        function beforeLink(nodeData, edgeData) {
            // Overwrite nodeData.getItemModel to
            nodeData.wrapMethod("getItemModel", function(model) {
                var categoriesModels = self._categoriesModels;
                var categoryIdx = model.getShallow("category");
                var categoryModel = categoriesModels[categoryIdx];
                if (categoryModel) {
                    categoryModel.parentModel = model.parentModel;
                    model.parentModel = categoryModel;
                }
                return model;
            });
            var edgeLabelModel = self.getModel("edgeLabel"); // For option `edgeLabel` can be found by label.xxx.xxx on item mode.
            var fakeSeriesModel = new $2b51b4bf776ec22e$exports({
                label: edgeLabelModel.option
            }, edgeLabelModel.parentModel, ecModel);
            var emphasisEdgeLabelModel = self.getModel("emphasis.edgeLabel");
            var emphasisFakeSeriesModel = new $2b51b4bf776ec22e$exports({
                emphasis: {
                    label: emphasisEdgeLabelModel.option
                }
            }, emphasisEdgeLabelModel.parentModel, ecModel);
            edgeData.wrapMethod("getItemModel", function(model) {
                model.customizeGetParent(edgeGetParent);
                return model;
            });
            function edgeGetParent(path) {
                path = this.parsePath(path);
                return path && path[0] === "label" ? fakeSeriesModel : path && path[0] === "emphasis" && path[1] === "label" ? emphasisFakeSeriesModel : this.parentModel;
            }
        }
    },
    /**
   * @return {module:echarts/data/Graph}
   */ getGraph: function() {
        return this.getData().graph;
    },
    /**
   * @return {module:echarts/data/List}
   */ getEdgeData: function() {
        return this.getGraph().edgeData;
    },
    /**
   * @return {module:echarts/data/List}
   */ getCategoriesData: function() {
        return this._categoriesData;
    },
    /**
   * @override
   */ formatTooltip: function(dataIndex, multipleSeries, dataType) {
        if (dataType === "edge") {
            var nodeData = this.getData();
            var params = this.getDataParams(dataIndex, dataType);
            var edge = nodeData.graph.getEdgeByIndex(dataIndex);
            var sourceName = nodeData.getName(edge.node1.dataIndex);
            var targetName = nodeData.getName(edge.node2.dataIndex);
            var html = [];
            sourceName != null && html.push(sourceName);
            targetName != null && html.push(targetName);
            html = $9797037c9f9a4007$var$encodeHTML(html.join(" > "));
            if (params.value) html += " : " + $9797037c9f9a4007$var$encodeHTML(params.value);
            return html;
        } else // dataType === 'node' or empty
        return $9797037c9f9a4007$var$GraphSeries.superApply(this, "formatTooltip", arguments);
    },
    _updateCategoriesData: function() {
        var categories = $ec279652dd95c27b$export$871de8747c9eaa88(this.option.categories || [], function(category) {
            // Data must has value
            return category.value != null ? category : $ec279652dd95c27b$export$8b58be045bf06082({
                value: 0
            }, category);
        });
        var categoriesData = new $f643df856475f69e$exports([
            "value"
        ], this);
        categoriesData.initData(categories);
        this._categoriesData = categoriesData;
        this._categoriesModels = categoriesData.mapArray(function(idx) {
            return categoriesData.getItemModel(idx, true);
        });
    },
    setZoom: function(zoom) {
        this.option.zoom = zoom;
    },
    setCenter: function(center) {
        this.option.center = center;
    },
    isAnimationEnabled: function() {
        return $9797037c9f9a4007$var$GraphSeries.superCall(this, "isAnimationEnabled") // Not enable animation when do force layout
         && !(this.get("layout") === "force" && this.get("force.layoutAnimation"));
    },
    defaultOption: {
        zlevel: 0,
        z: 2,
        coordinateSystem: "view",
        // Default option for all coordinate systems
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // polarIndex: 0,
        // geoIndex: 0,
        legendHoverLink: true,
        hoverAnimation: true,
        layout: null,
        focusNodeAdjacency: false,
        // Configuration of circular layout
        circular: {
            rotateLabel: false
        },
        // Configuration of force directed layout
        force: {
            initLayout: null,
            // Node repulsion. Can be an array to represent range.
            repulsion: [
                0,
                50
            ],
            gravity: 0.1,
            // Initial friction
            friction: 0.6,
            // Edge length. Can be an array to represent range.
            edgeLength: 30,
            layoutAnimation: true
        },
        left: "center",
        top: "center",
        // right: null,
        // bottom: null,
        // width: '80%',
        // height: '80%',
        symbol: "circle",
        symbolSize: 10,
        edgeSymbol: [
            "none",
            "none"
        ],
        edgeSymbolSize: 10,
        edgeLabel: {
            position: "middle",
            distance: 5
        },
        draggable: false,
        roam: false,
        // Default on center of graph
        center: null,
        zoom: 1,
        // Symbol size scale ratio in roam
        nodeScaleRatio: 0.6,
        // cursor: null,
        // categories: [],
        // data: []
        // Or
        // nodes: []
        //
        // links: []
        // Or
        // edges: []
        label: {
            show: false,
            formatter: "{b}"
        },
        itemStyle: {},
        lineStyle: {
            color: "#aaa",
            width: 1,
            opacity: 0.5
        },
        emphasis: {
            label: {
                show: true
            }
        }
    }
});
var $9797037c9f9a4007$var$_default = $9797037c9f9a4007$var$GraphSeries;
$9797037c9f9a4007$exports = $9797037c9f9a4007$var$_default;


var $ff6bf07147eecdc1$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $d4dffdc6cfcd68dc$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $6dd196751040d665$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $94682ebc3a9cf1a5$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Line path for bezier and straight line draw
 */ var $94682ebc3a9cf1a5$var$straightLineProto = $4b57d6b582d579b7$export$17d680238e50603e.prototype;
var $94682ebc3a9cf1a5$var$bezierCurveProto = $4b57d6b582d579b7$export$a57c23a30525a34b.prototype;
function $94682ebc3a9cf1a5$var$isLine(shape) {
    return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
}
var $94682ebc3a9cf1a5$var$_default = $4b57d6b582d579b7$export$d0d5398c9d612037({
    type: "ec-line",
    style: {
        stroke: "#000",
        fill: null
    },
    shape: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0,
        percent: 1,
        cpx1: null,
        cpy1: null
    },
    buildPath: function(ctx, shape) {
        this[$94682ebc3a9cf1a5$var$isLine(shape) ? "_buildPathLine" : "_buildPathCurve"](ctx, shape);
    },
    _buildPathLine: $94682ebc3a9cf1a5$var$straightLineProto.buildPath,
    _buildPathCurve: $94682ebc3a9cf1a5$var$bezierCurveProto.buildPath,
    pointAt: function(t) {
        return this[$94682ebc3a9cf1a5$var$isLine(this.shape) ? "_pointAtLine" : "_pointAtCurve"](t);
    },
    _pointAtLine: $94682ebc3a9cf1a5$var$straightLineProto.pointAt,
    _pointAtCurve: $94682ebc3a9cf1a5$var$bezierCurveProto.pointAt,
    tangentAt: function(t) {
        var shape = this.shape;
        var p = $94682ebc3a9cf1a5$var$isLine(shape) ? [
            shape.x2 - shape.x1,
            shape.y2 - shape.y1
        ] : this._tangentAtCurve(t);
        return $9eb63d101f3bcd79$export$a3295358bff77e(p, p);
    },
    _tangentAtCurve: $94682ebc3a9cf1a5$var$bezierCurveProto.tangentAt
});
$94682ebc3a9cf1a5$exports = $94682ebc3a9cf1a5$var$_default;




var $6dd196751040d665$var$round = $2d742dbe7f960d8c$export$2077e0241d6afd3c;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @module echarts/chart/helper/Line
 */ var $6dd196751040d665$var$SYMBOL_CATEGORIES = [
    "fromSymbol",
    "toSymbol"
];
function $6dd196751040d665$var$makeSymbolTypeKey(symbolCategory) {
    return "_" + symbolCategory + "Type";
}
/**
 * @inner
 */ function $6dd196751040d665$var$createSymbol(name, lineData, idx) {
    var symbolType = lineData.getItemVisual(idx, name);
    if (!symbolType || symbolType === "none") return;
    var color = lineData.getItemVisual(idx, "color");
    var symbolSize = lineData.getItemVisual(idx, name + "Size");
    var symbolRotate = lineData.getItemVisual(idx, name + "Rotate");
    if (!$ec279652dd95c27b$export$43bee75e5e14138e(symbolSize)) symbolSize = [
        symbolSize,
        symbolSize
    ];
    var symbolPath = $804dcb9a0b78b5fe$export$af050e04da3a02e8(symbolType, -symbolSize[0] / 2, -symbolSize[1] / 2, symbolSize[0], symbolSize[1], color); // rotate by default if symbolRotate is not specified or NaN
    symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
    symbolPath.name = name;
    return symbolPath;
}
function $6dd196751040d665$var$createLine(points) {
    var line = new $94682ebc3a9cf1a5$exports({
        name: "line",
        subPixelOptimize: true
    });
    $6dd196751040d665$var$setLinePoints(line.shape, points);
    return line;
}
function $6dd196751040d665$var$setLinePoints(targetShape, points) {
    targetShape.x1 = points[0][0];
    targetShape.y1 = points[0][1];
    targetShape.x2 = points[1][0];
    targetShape.y2 = points[1][1];
    targetShape.percent = 1;
    var cp1 = points[2];
    if (cp1) {
        targetShape.cpx1 = cp1[0];
        targetShape.cpy1 = cp1[1];
    } else {
        targetShape.cpx1 = NaN;
        targetShape.cpy1 = NaN;
    }
}
function $6dd196751040d665$var$updateSymbolAndLabelBeforeLineUpdate() {
    var lineGroup = this;
    var symbolFrom = lineGroup.childOfName("fromSymbol");
    var symbolTo = lineGroup.childOfName("toSymbol");
    var label = lineGroup.childOfName("label"); // Quick reject
    if (!symbolFrom && !symbolTo && label.ignore) return;
    var invScale = 1;
    var parentNode = this.parent;
    while(parentNode){
        if (parentNode.scale) invScale /= parentNode.scale[0];
        parentNode = parentNode.parent;
    }
    var line = lineGroup.childOfName("line"); // If line not changed
    // FIXME Parent scale changed
    if (!this.__dirty && !line.__dirty) return;
    var percent = line.shape.percent;
    var fromPos = line.pointAt(0);
    var toPos = line.pointAt(percent);
    var d = $9eb63d101f3bcd79$export$f93b5905241a7cca([], toPos, fromPos);
    $9eb63d101f3bcd79$export$a3295358bff77e(d, d);
    if (symbolFrom) {
        symbolFrom.attr("position", fromPos); // Fix #12388
        // when symbol is set to be 'arrow' in markLine,
        // symbolRotate value will be ignored, and compulsively use tangent angle.
        // rotate by default if symbol rotation is not specified
        var specifiedRotation = symbolFrom.__specifiedRotation;
        if (specifiedRotation == null) {
            var tangent = line.tangentAt(0);
            symbolFrom.attr("rotation", Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
        } else symbolFrom.attr("rotation", specifiedRotation);
        symbolFrom.attr("scale", [
            invScale * percent,
            invScale * percent
        ]);
    }
    if (symbolTo) {
        symbolTo.attr("position", toPos); // Fix #12388
        // when symbol is set to be 'arrow' in markLine,
        // symbolRotate value will be ignored, and compulsively use tangent angle.
        // rotate by default if symbol rotation is not specified
        var specifiedRotation = symbolTo.__specifiedRotation;
        if (specifiedRotation == null) {
            var tangent = line.tangentAt(1);
            symbolTo.attr("rotation", -Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
        } else symbolTo.attr("rotation", specifiedRotation);
        symbolTo.attr("scale", [
            invScale * percent,
            invScale * percent
        ]);
    }
    if (!label.ignore) {
        label.attr("position", toPos);
        var textPosition;
        var textAlign;
        var textVerticalAlign;
        var textOrigin;
        var distance = label.__labelDistance;
        var distanceX = distance[0] * invScale;
        var distanceY = distance[1] * invScale;
        var halfPercent = percent / 2;
        var tangent = line.tangentAt(halfPercent);
        var n = [
            tangent[1],
            -tangent[0]
        ];
        var cp = line.pointAt(halfPercent);
        if (n[1] > 0) {
            n[0] = -n[0];
            n[1] = -n[1];
        }
        var dir = tangent[0] < 0 ? -1 : 1;
        if (label.__position !== "start" && label.__position !== "end") {
            var rotation = -Math.atan2(tangent[1], tangent[0]);
            if (toPos[0] < fromPos[0]) rotation = Math.PI + rotation;
            label.attr("rotation", rotation);
        }
        var dy;
        switch(label.__position){
            case "insideStartTop":
            case "insideMiddleTop":
            case "insideEndTop":
            case "middle":
                dy = -distanceY;
                textVerticalAlign = "bottom";
                break;
            case "insideStartBottom":
            case "insideMiddleBottom":
            case "insideEndBottom":
                dy = distanceY;
                textVerticalAlign = "top";
                break;
            default:
                dy = 0;
                textVerticalAlign = "middle";
        }
        switch(label.__position){
            case "end":
                textPosition = [
                    d[0] * distanceX + toPos[0],
                    d[1] * distanceY + toPos[1]
                ];
                textAlign = d[0] > 0.8 ? "left" : d[0] < -0.8 ? "right" : "center";
                textVerticalAlign = d[1] > 0.8 ? "top" : d[1] < -0.8 ? "bottom" : "middle";
                break;
            case "start":
                textPosition = [
                    -d[0] * distanceX + fromPos[0],
                    -d[1] * distanceY + fromPos[1]
                ];
                textAlign = d[0] > 0.8 ? "right" : d[0] < -0.8 ? "left" : "center";
                textVerticalAlign = d[1] > 0.8 ? "bottom" : d[1] < -0.8 ? "top" : "middle";
                break;
            case "insideStartTop":
            case "insideStart":
            case "insideStartBottom":
                textPosition = [
                    distanceX * dir + fromPos[0],
                    fromPos[1] + dy
                ];
                textAlign = tangent[0] < 0 ? "right" : "left";
                textOrigin = [
                    -distanceX * dir,
                    -dy
                ];
                break;
            case "insideMiddleTop":
            case "insideMiddle":
            case "insideMiddleBottom":
            case "middle":
                textPosition = [
                    cp[0],
                    cp[1] + dy
                ];
                textAlign = "center";
                textOrigin = [
                    0,
                    -dy
                ];
                break;
            case "insideEndTop":
            case "insideEnd":
            case "insideEndBottom":
                textPosition = [
                    -distanceX * dir + toPos[0],
                    toPos[1] + dy
                ];
                textAlign = tangent[0] >= 0 ? "right" : "left";
                textOrigin = [
                    distanceX * dir,
                    -dy
                ];
                break;
        }
        label.attr({
            style: {
                // Use the user specified text align and baseline first
                textVerticalAlign: label.__verticalAlign || textVerticalAlign,
                textAlign: label.__textAlign || textAlign
            },
            position: textPosition,
            scale: [
                invScale,
                invScale
            ],
            origin: textOrigin
        });
    }
}
/**
 * @constructor
 * @extends {module:zrender/graphic/Group}
 * @alias {module:echarts/chart/helper/Line}
 */ function $6dd196751040d665$var$Line(lineData, idx, seriesScope) {
    $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4.call(this);
    this._createLine(lineData, idx, seriesScope);
}
var $6dd196751040d665$var$lineProto = $6dd196751040d665$var$Line.prototype; // Update symbol position and rotation
$6dd196751040d665$var$lineProto.beforeUpdate = $6dd196751040d665$var$updateSymbolAndLabelBeforeLineUpdate;
$6dd196751040d665$var$lineProto._createLine = function(lineData, idx, seriesScope) {
    var seriesModel = lineData.hostModel;
    var linePoints = lineData.getItemLayout(idx);
    var line = $6dd196751040d665$var$createLine(linePoints);
    line.shape.percent = 0;
    $4b57d6b582d579b7$export$a121566aadcfe021(line, {
        shape: {
            percent: 1
        }
    }, seriesModel, idx);
    this.add(line);
    var label = new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
        name: "label",
        // FIXME
        // Temporary solution for `focusNodeAdjacency`.
        // line label do not use the opacity of lineStyle.
        lineLabelOriginalOpacity: 1
    });
    this.add(label);
    $ec279652dd95c27b$export$79b2f7037acddd43($6dd196751040d665$var$SYMBOL_CATEGORIES, function(symbolCategory) {
        var symbol = $6dd196751040d665$var$createSymbol(symbolCategory, lineData, idx); // symbols must added after line to make sure
        // it will be updated after line#update.
        // Or symbol position and rotation update in line#beforeUpdate will be one frame slow
        this.add(symbol);
        this[$6dd196751040d665$var$makeSymbolTypeKey(symbolCategory)] = lineData.getItemVisual(idx, symbolCategory);
    }, this);
    this._updateCommonStl(lineData, idx, seriesScope);
};
$6dd196751040d665$var$lineProto.updateData = function(lineData, idx, seriesScope) {
    var seriesModel = lineData.hostModel;
    var line = this.childOfName("line");
    var linePoints = lineData.getItemLayout(idx);
    var target = {
        shape: {}
    };
    $6dd196751040d665$var$setLinePoints(target.shape, linePoints);
    $4b57d6b582d579b7$export$c8dce3c08436e91e(line, target, seriesModel, idx);
    $ec279652dd95c27b$export$79b2f7037acddd43($6dd196751040d665$var$SYMBOL_CATEGORIES, function(symbolCategory) {
        var symbolType = lineData.getItemVisual(idx, symbolCategory);
        var key = $6dd196751040d665$var$makeSymbolTypeKey(symbolCategory); // Symbol changed
        if (this[key] !== symbolType) {
            this.remove(this.childOfName(symbolCategory));
            var symbol = $6dd196751040d665$var$createSymbol(symbolCategory, lineData, idx);
            this.add(symbol);
        }
        this[key] = symbolType;
    }, this);
    this._updateCommonStl(lineData, idx, seriesScope);
};
$6dd196751040d665$var$lineProto._updateCommonStl = function(lineData, idx, seriesScope) {
    var seriesModel = lineData.hostModel;
    var line = this.childOfName("line");
    var lineStyle = seriesScope && seriesScope.lineStyle;
    var hoverLineStyle = seriesScope && seriesScope.hoverLineStyle;
    var labelModel = seriesScope && seriesScope.labelModel;
    var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel; // Optimization for large dataset
    if (!seriesScope || lineData.hasItemOption) {
        var itemModel = lineData.getItemModel(idx);
        lineStyle = itemModel.getModel("lineStyle").getLineStyle();
        hoverLineStyle = itemModel.getModel("emphasis.lineStyle").getLineStyle();
        labelModel = itemModel.getModel("label");
        hoverLabelModel = itemModel.getModel("emphasis.label");
    }
    var visualColor = lineData.getItemVisual(idx, "color");
    var visualOpacity = $ec279652dd95c27b$export$2e94551289abb95b(lineData.getItemVisual(idx, "opacity"), lineStyle.opacity, 1);
    line.useStyle($ec279652dd95c27b$export$ebe90cb607ad99e({
        strokeNoScale: true,
        fill: "none",
        stroke: visualColor,
        opacity: visualOpacity
    }, lineStyle));
    line.hoverStyle = hoverLineStyle; // Update symbol
    $ec279652dd95c27b$export$79b2f7037acddd43($6dd196751040d665$var$SYMBOL_CATEGORIES, function(symbolCategory) {
        var symbol = this.childOfName(symbolCategory);
        if (symbol) {
            symbol.setColor(visualColor);
            symbol.setStyle({
                opacity: visualOpacity
            });
        }
    }, this);
    var showLabel = labelModel.getShallow("show");
    var hoverShowLabel = hoverLabelModel.getShallow("show");
    var label = this.childOfName("label");
    var defaultLabelColor;
    var baseText; // FIXME: the logic below probably should be merged to `graphic.setLabelStyle`.
    if (showLabel || hoverShowLabel) {
        defaultLabelColor = visualColor || "#000";
        baseText = seriesModel.getFormattedLabel(idx, "normal", lineData.dataType);
        if (baseText == null) {
            var rawVal = seriesModel.getRawValue(idx);
            baseText = rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? $6dd196751040d665$var$round(rawVal) : rawVal;
        }
    }
    var normalText = showLabel ? baseText : null;
    var emphasisText = hoverShowLabel ? $ec279652dd95c27b$export$995e01f2f5c9d030(seriesModel.getFormattedLabel(idx, "emphasis", lineData.dataType), baseText) : null;
    var labelStyle = label.style; // Always set `textStyle` even if `normalStyle.text` is null, because default
    // values have to be set on `normalStyle`.
    if (normalText != null || emphasisText != null) {
        $4b57d6b582d579b7$export$6605af501964d89a(label.style, labelModel, {
            text: normalText
        }, {
            autoColor: defaultLabelColor
        });
        label.__textAlign = labelStyle.textAlign;
        label.__verticalAlign = labelStyle.textVerticalAlign; // 'start', 'middle', 'end'
        label.__position = labelModel.get("position") || "middle";
        var distance = labelModel.get("distance");
        if (!$ec279652dd95c27b$export$43bee75e5e14138e(distance)) distance = [
            distance,
            distance
        ];
        label.__labelDistance = distance;
    }
    if (emphasisText != null) // Only these properties supported in this emphasis style here.
    label.hoverStyle = {
        text: emphasisText,
        textFill: hoverLabelModel.getTextColor(true),
        // For merging hover style to normal style, do not use
        // `hoverLabelModel.getFont()` here.
        fontStyle: hoverLabelModel.getShallow("fontStyle"),
        fontWeight: hoverLabelModel.getShallow("fontWeight"),
        fontSize: hoverLabelModel.getShallow("fontSize"),
        fontFamily: hoverLabelModel.getShallow("fontFamily")
    };
    else label.hoverStyle = {
        text: null
    };
    label.ignore = !showLabel && !hoverShowLabel;
    $4b57d6b582d579b7$export$28b42df8183f218c(this);
};
$6dd196751040d665$var$lineProto.highlight = function() {
    this.trigger("emphasis");
};
$6dd196751040d665$var$lineProto.downplay = function() {
    this.trigger("normal");
};
$6dd196751040d665$var$lineProto.updateLayout = function(lineData, idx) {
    this.setLinePoints(lineData.getItemLayout(idx));
};
$6dd196751040d665$var$lineProto.setLinePoints = function(points) {
    var linePath = this.childOfName("line");
    $6dd196751040d665$var$setLinePoints(linePath.shape, points);
    linePath.dirty();
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($6dd196751040d665$var$Line, $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4);
var $6dd196751040d665$var$_default = $6dd196751040d665$var$Line;
$6dd196751040d665$exports = $6dd196751040d665$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @module echarts/chart/helper/LineDraw
 */ // import IncrementalDisplayable from 'zrender/src/graphic/IncrementalDisplayable';
/**
 * @alias module:echarts/component/marker/LineDraw
 * @constructor
 */ function $d4dffdc6cfcd68dc$var$LineDraw(ctor) {
    this._ctor = ctor || $6dd196751040d665$exports;
    this.group = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
}
var $d4dffdc6cfcd68dc$var$lineDrawProto = $d4dffdc6cfcd68dc$var$LineDraw.prototype;
$d4dffdc6cfcd68dc$var$lineDrawProto.isPersistent = function() {
    return true;
};
/**
 * @param {module:echarts/data/List} lineData
 */ $d4dffdc6cfcd68dc$var$lineDrawProto.updateData = function(lineData) {
    var lineDraw = this;
    var group = lineDraw.group;
    var oldLineData = lineDraw._lineData;
    lineDraw._lineData = lineData; // There is no oldLineData only when first rendering or switching from
    // stream mode to normal mode, where previous elements should be removed.
    if (!oldLineData) group.removeAll();
    var seriesScope = $d4dffdc6cfcd68dc$var$makeSeriesScope(lineData);
    lineData.diff(oldLineData).add(function(idx) {
        $d4dffdc6cfcd68dc$var$doAdd(lineDraw, lineData, idx, seriesScope);
    }).update(function(newIdx, oldIdx) {
        $d4dffdc6cfcd68dc$var$doUpdate(lineDraw, oldLineData, lineData, oldIdx, newIdx, seriesScope);
    }).remove(function(idx) {
        group.remove(oldLineData.getItemGraphicEl(idx));
    }).execute();
};
function $d4dffdc6cfcd68dc$var$doAdd(lineDraw, lineData, idx, seriesScope) {
    var itemLayout = lineData.getItemLayout(idx);
    if (!$d4dffdc6cfcd68dc$var$lineNeedsDraw(itemLayout)) return;
    var el = new lineDraw._ctor(lineData, idx, seriesScope);
    lineData.setItemGraphicEl(idx, el);
    lineDraw.group.add(el);
}
function $d4dffdc6cfcd68dc$var$doUpdate(lineDraw, oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
    var itemEl = oldLineData.getItemGraphicEl(oldIdx);
    if (!$d4dffdc6cfcd68dc$var$lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
        lineDraw.group.remove(itemEl);
        return;
    }
    if (!itemEl) itemEl = new lineDraw._ctor(newLineData, newIdx, seriesScope);
    else itemEl.updateData(newLineData, newIdx, seriesScope);
    newLineData.setItemGraphicEl(newIdx, itemEl);
    lineDraw.group.add(itemEl);
}
$d4dffdc6cfcd68dc$var$lineDrawProto.updateLayout = function() {
    var lineData = this._lineData; // Do not support update layout in incremental mode.
    if (!lineData) return;
    lineData.eachItemGraphicEl(function(el, idx) {
        el.updateLayout(lineData, idx);
    }, this);
};
$d4dffdc6cfcd68dc$var$lineDrawProto.incrementalPrepareUpdate = function(lineData) {
    this._seriesScope = $d4dffdc6cfcd68dc$var$makeSeriesScope(lineData);
    this._lineData = null;
    this.group.removeAll();
};
function $d4dffdc6cfcd68dc$var$isEffectObject(el) {
    return el.animators && el.animators.length > 0;
}
$d4dffdc6cfcd68dc$var$lineDrawProto.incrementalUpdate = function(taskParams, lineData) {
    function updateIncrementalAndHover(el) {
        if (!el.isGroup && !$d4dffdc6cfcd68dc$var$isEffectObject(el)) el.incremental = el.useHoverLayer = true;
    }
    for(var idx = taskParams.start; idx < taskParams.end; idx++){
        var itemLayout = lineData.getItemLayout(idx);
        if ($d4dffdc6cfcd68dc$var$lineNeedsDraw(itemLayout)) {
            var el = new this._ctor(lineData, idx, this._seriesScope);
            el.traverse(updateIncrementalAndHover);
            this.group.add(el);
            lineData.setItemGraphicEl(idx, el);
        }
    }
};
function $d4dffdc6cfcd68dc$var$makeSeriesScope(lineData) {
    var hostModel = lineData.hostModel;
    return {
        lineStyle: hostModel.getModel("lineStyle").getLineStyle(),
        hoverLineStyle: hostModel.getModel("emphasis.lineStyle").getLineStyle(),
        labelModel: hostModel.getModel("label"),
        hoverLabelModel: hostModel.getModel("emphasis.label")
    };
}
$d4dffdc6cfcd68dc$var$lineDrawProto.remove = function() {
    this._clearIncremental();
    this._incremental = null;
    this.group.removeAll();
};
$d4dffdc6cfcd68dc$var$lineDrawProto._clearIncremental = function() {
    var incremental = this._incremental;
    if (incremental) incremental.clearDisplaybles();
};
function $d4dffdc6cfcd68dc$var$isPointNaN(pt) {
    return isNaN(pt[0]) || isNaN(pt[1]);
}
function $d4dffdc6cfcd68dc$var$lineNeedsDraw(pts) {
    return !$d4dffdc6cfcd68dc$var$isPointNaN(pts[0]) && !$d4dffdc6cfcd68dc$var$isPointNaN(pts[1]);
}
var $d4dffdc6cfcd68dc$var$_default = $d4dffdc6cfcd68dc$var$LineDraw;
$d4dffdc6cfcd68dc$exports = $d4dffdc6cfcd68dc$var$_default;





var $ff6bf07147eecdc1$var$onIrrelevantElement = $42222c91ddd2a800$export$8a33eacb690eac07;

var $805e352dc678a651$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $c83209d77195bb6d$export$e2aa0fb9ed198ba7;
var $c83209d77195bb6d$export$8d4a06d3facd414b;
function $c83209d77195bb6d$var$getNodeGlobalScale(seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys.type !== "view") return 1;
    var nodeScaleRatio = seriesModel.option.nodeScaleRatio;
    var groupScale = coordSys.scale;
    var groupZoom = groupScale && groupScale[0] || 1; // Scale node when zoom changes
    var roamZoom = coordSys.getZoom();
    var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
    return nodeScale / groupZoom;
}
function $c83209d77195bb6d$var$getSymbolSize(node) {
    var symbolSize = node.getVisual("symbolSize");
    if (symbolSize instanceof Array) symbolSize = (symbolSize[0] + symbolSize[1]) / 2;
    return +symbolSize;
}
$c83209d77195bb6d$export$e2aa0fb9ed198ba7 = $c83209d77195bb6d$var$getNodeGlobalScale;
$c83209d77195bb6d$export$8d4a06d3facd414b = $c83209d77195bb6d$var$getSymbolSize;


var $805e352dc678a651$var$getSymbolSize = $c83209d77195bb6d$export$8d4a06d3facd414b;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $805e352dc678a651$var$v1 = [];
var $805e352dc678a651$var$v2 = [];
var $805e352dc678a651$var$v3 = [];
var $805e352dc678a651$var$quadraticAt = $ab3ad2315df1d857$export$af17094a950f5073;
var $805e352dc678a651$var$v2DistSquare = $9eb63d101f3bcd79$export$c68db45a034c13b0;
var $805e352dc678a651$var$mathAbs = Math.abs;
function $805e352dc678a651$var$intersectCurveCircle(curvePoints, center, radius) {
    var p0 = curvePoints[0];
    var p1 = curvePoints[1];
    var p2 = curvePoints[2];
    var d = Infinity;
    var t;
    var radiusSquare = radius * radius;
    var interval = 0.1;
    for(var _t = 0.1; _t <= 0.9; _t += 0.1){
        $805e352dc678a651$var$v1[0] = $805e352dc678a651$var$quadraticAt(p0[0], p1[0], p2[0], _t);
        $805e352dc678a651$var$v1[1] = $805e352dc678a651$var$quadraticAt(p0[1], p1[1], p2[1], _t);
        var diff = $805e352dc678a651$var$mathAbs($805e352dc678a651$var$v2DistSquare($805e352dc678a651$var$v1, center) - radiusSquare);
        if (diff < d) {
            d = diff;
            t = _t;
        }
    } // Assume the segment is monotone，Find root through Bisection method
    // At most 32 iteration
    for(var i = 0; i < 32; i++){
        // var prev = t - interval;
        var next = t + interval; // v1[0] = quadraticAt(p0[0], p1[0], p2[0], prev);
        // v1[1] = quadraticAt(p0[1], p1[1], p2[1], prev);
        $805e352dc678a651$var$v2[0] = $805e352dc678a651$var$quadraticAt(p0[0], p1[0], p2[0], t);
        $805e352dc678a651$var$v2[1] = $805e352dc678a651$var$quadraticAt(p0[1], p1[1], p2[1], t);
        $805e352dc678a651$var$v3[0] = $805e352dc678a651$var$quadraticAt(p0[0], p1[0], p2[0], next);
        $805e352dc678a651$var$v3[1] = $805e352dc678a651$var$quadraticAt(p0[1], p1[1], p2[1], next);
        var diff = $805e352dc678a651$var$v2DistSquare($805e352dc678a651$var$v2, center) - radiusSquare;
        if ($805e352dc678a651$var$mathAbs(diff) < 1e-2) break;
         // var prevDiff = v2DistSquare(v1, center) - radiusSquare;
        var nextDiff = $805e352dc678a651$var$v2DistSquare($805e352dc678a651$var$v3, center) - radiusSquare;
        interval /= 2;
        if (diff < 0) {
            if (nextDiff >= 0) t = t + interval;
            else t = t - interval;
        } else if (nextDiff >= 0) t = t - interval;
        else t = t + interval;
    }
    return t;
} // Adjust edge to avoid
function $805e352dc678a651$var$_default(graph, scale) {
    var tmp0 = [];
    var quadraticSubdivide = $ab3ad2315df1d857$export$117c659e21a7a060;
    var pts = [
        [],
        [],
        []
    ];
    var pts2 = [
        [],
        []
    ];
    var v = [];
    scale /= 2;
    graph.eachEdge(function(edge, idx) {
        var linePoints = edge.getLayout();
        var fromSymbol = edge.getVisual("fromSymbol");
        var toSymbol = edge.getVisual("toSymbol");
        if (!linePoints.__original) {
            linePoints.__original = [
                $9eb63d101f3bcd79$export$9cd59f9826255e47(linePoints[0]),
                $9eb63d101f3bcd79$export$9cd59f9826255e47(linePoints[1])
            ];
            if (linePoints[2]) linePoints.__original.push($9eb63d101f3bcd79$export$9cd59f9826255e47(linePoints[2]));
        }
        var originalPoints = linePoints.__original; // Quadratic curve
        if (linePoints[2] != null) {
            $9eb63d101f3bcd79$export$784d13d8ee351f07(pts[0], originalPoints[0]);
            $9eb63d101f3bcd79$export$784d13d8ee351f07(pts[1], originalPoints[2]);
            $9eb63d101f3bcd79$export$784d13d8ee351f07(pts[2], originalPoints[1]);
            if (fromSymbol && fromSymbol !== "none") {
                var symbolSize = $805e352dc678a651$var$getSymbolSize(edge.node1);
                var t = $805e352dc678a651$var$intersectCurveCircle(pts, originalPoints[0], symbolSize * scale); // Subdivide and get the second
                quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
                pts[0][0] = tmp0[3];
                pts[1][0] = tmp0[4];
                quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
                pts[0][1] = tmp0[3];
                pts[1][1] = tmp0[4];
            }
            if (toSymbol && toSymbol !== "none") {
                var symbolSize = $805e352dc678a651$var$getSymbolSize(edge.node2);
                var t = $805e352dc678a651$var$intersectCurveCircle(pts, originalPoints[1], symbolSize * scale); // Subdivide and get the first
                quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
                pts[1][0] = tmp0[1];
                pts[2][0] = tmp0[2];
                quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
                pts[1][1] = tmp0[1];
                pts[2][1] = tmp0[2];
            } // Copy back to layout
            $9eb63d101f3bcd79$export$784d13d8ee351f07(linePoints[0], pts[0]);
            $9eb63d101f3bcd79$export$784d13d8ee351f07(linePoints[1], pts[2]);
            $9eb63d101f3bcd79$export$784d13d8ee351f07(linePoints[2], pts[1]);
        } else {
            $9eb63d101f3bcd79$export$784d13d8ee351f07(pts2[0], originalPoints[0]);
            $9eb63d101f3bcd79$export$784d13d8ee351f07(pts2[1], originalPoints[1]);
            $9eb63d101f3bcd79$export$f93b5905241a7cca(v, pts2[1], pts2[0]);
            $9eb63d101f3bcd79$export$a3295358bff77e(v, v);
            if (fromSymbol && fromSymbol !== "none") {
                var symbolSize = $805e352dc678a651$var$getSymbolSize(edge.node1);
                $9eb63d101f3bcd79$export$19cedf1da84ba854(pts2[0], pts2[0], v, symbolSize * scale);
            }
            if (toSymbol && toSymbol !== "none") {
                var symbolSize = $805e352dc678a651$var$getSymbolSize(edge.node2);
                $9eb63d101f3bcd79$export$19cedf1da84ba854(pts2[1], pts2[1], v, -symbolSize * scale);
            }
            $9eb63d101f3bcd79$export$784d13d8ee351f07(linePoints[0], pts2[0]);
            $9eb63d101f3bcd79$export$784d13d8ee351f07(linePoints[1], pts2[1]);
        }
    });
}
$805e352dc678a651$exports = $805e352dc678a651$var$_default;



var $ff6bf07147eecdc1$var$getNodeGlobalScale = $c83209d77195bb6d$export$e2aa0fb9ed198ba7;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $ff6bf07147eecdc1$var$FOCUS_ADJACENCY = "__focusNodeAdjacency";
var $ff6bf07147eecdc1$var$UNFOCUS_ADJACENCY = "__unfocusNodeAdjacency";
var $ff6bf07147eecdc1$var$nodeOpacityPath = [
    "itemStyle",
    "opacity"
];
var $ff6bf07147eecdc1$var$lineOpacityPath = [
    "lineStyle",
    "opacity"
];
function $ff6bf07147eecdc1$var$getItemOpacity(item, opacityPath) {
    var opacity = item.getVisual("opacity");
    return opacity != null ? opacity : item.getModel().get(opacityPath);
}
function $ff6bf07147eecdc1$var$fadeOutItem(item, opacityPath, opacityRatio) {
    var el = item.getGraphicEl();
    var opacity = $ff6bf07147eecdc1$var$getItemOpacity(item, opacityPath);
    if (opacityRatio != null) {
        opacity == null && (opacity = 1);
        opacity *= opacityRatio;
    }
    el.downplay && el.downplay();
    el.traverse(function(child) {
        if (!child.isGroup) {
            var opct = child.lineLabelOriginalOpacity;
            if (opct == null || opacityRatio != null) opct = opacity;
            child.setStyle("opacity", opct);
        }
    });
}
function $ff6bf07147eecdc1$var$fadeInItem(item, opacityPath) {
    var opacity = $ff6bf07147eecdc1$var$getItemOpacity(item, opacityPath);
    var el = item.getGraphicEl(); // Should go back to normal opacity first, consider hoverLayer,
    // where current state is copied to elMirror, and support
    // emphasis opacity here.
    el.traverse(function(child) {
        !child.isGroup && child.setStyle("opacity", opacity);
    });
    el.highlight && el.highlight();
}
var $ff6bf07147eecdc1$var$_default = $f406636b535430a7$exports.extendChartView({
    type: "graph",
    init: function(ecModel, api) {
        var symbolDraw = new $e99d13e2181fb062$exports();
        var lineDraw = new $d4dffdc6cfcd68dc$exports();
        var group = this.group;
        this._controller = new $f812ed7651a5f0b7$exports(api.getZr());
        this._controllerHost = {
            target: group
        };
        group.add(symbolDraw.group);
        group.add(lineDraw.group);
        this._symbolDraw = symbolDraw;
        this._lineDraw = lineDraw;
        this._firstRender = true;
    },
    render: function(seriesModel, ecModel, api) {
        var graphView = this;
        var coordSys = seriesModel.coordinateSystem;
        this._model = seriesModel;
        var symbolDraw = this._symbolDraw;
        var lineDraw = this._lineDraw;
        var group = this.group;
        if (coordSys.type === "view") {
            var groupNewProp = {
                position: coordSys.position,
                scale: coordSys.scale
            };
            if (this._firstRender) group.attr(groupNewProp);
            else $4b57d6b582d579b7$export$c8dce3c08436e91e(group, groupNewProp, seriesModel);
        } // Fix edge contact point with node
        $805e352dc678a651$exports(seriesModel.getGraph(), $ff6bf07147eecdc1$var$getNodeGlobalScale(seriesModel));
        var data = seriesModel.getData();
        symbolDraw.updateData(data);
        var edgeData = seriesModel.getEdgeData();
        lineDraw.updateData(edgeData);
        this._updateNodeAndLinkScale();
        this._updateController(seriesModel, ecModel, api);
        clearTimeout(this._layoutTimeout);
        var forceLayout = seriesModel.forceLayout;
        var layoutAnimation = seriesModel.get("force.layoutAnimation");
        if (forceLayout) this._startForceLayoutIteration(forceLayout, layoutAnimation);
        data.eachItemGraphicEl(function(el, idx) {
            var itemModel = data.getItemModel(idx); // Update draggable
            el.off("drag").off("dragend");
            var draggable = itemModel.get("draggable");
            if (draggable) el.on("drag", function() {
                if (forceLayout) {
                    forceLayout.warmUp();
                    !this._layouting && this._startForceLayoutIteration(forceLayout, layoutAnimation);
                    forceLayout.setFixed(idx); // Write position back to layout
                    data.setItemLayout(idx, el.position);
                }
            }, this).on("dragend", function() {
                if (forceLayout) forceLayout.setUnfixed(idx);
            }, this);
            el.setDraggable(draggable && forceLayout);
            el[$ff6bf07147eecdc1$var$FOCUS_ADJACENCY] && el.off("mouseover", el[$ff6bf07147eecdc1$var$FOCUS_ADJACENCY]);
            el[$ff6bf07147eecdc1$var$UNFOCUS_ADJACENCY] && el.off("mouseout", el[$ff6bf07147eecdc1$var$UNFOCUS_ADJACENCY]);
            if (itemModel.get("focusNodeAdjacency")) {
                el.on("mouseover", el[$ff6bf07147eecdc1$var$FOCUS_ADJACENCY] = function() {
                    graphView._clearTimer();
                    api.dispatchAction({
                        type: "focusNodeAdjacency",
                        seriesId: seriesModel.id,
                        dataIndex: el.dataIndex
                    });
                });
                el.on("mouseout", el[$ff6bf07147eecdc1$var$UNFOCUS_ADJACENCY] = function() {
                    graphView._dispatchUnfocus(api);
                });
            }
        }, this);
        data.graph.eachEdge(function(edge) {
            var el = edge.getGraphicEl();
            el[$ff6bf07147eecdc1$var$FOCUS_ADJACENCY] && el.off("mouseover", el[$ff6bf07147eecdc1$var$FOCUS_ADJACENCY]);
            el[$ff6bf07147eecdc1$var$UNFOCUS_ADJACENCY] && el.off("mouseout", el[$ff6bf07147eecdc1$var$UNFOCUS_ADJACENCY]);
            if (edge.getModel().get("focusNodeAdjacency")) {
                el.on("mouseover", el[$ff6bf07147eecdc1$var$FOCUS_ADJACENCY] = function() {
                    graphView._clearTimer();
                    api.dispatchAction({
                        type: "focusNodeAdjacency",
                        seriesId: seriesModel.id,
                        edgeDataIndex: edge.dataIndex
                    });
                });
                el.on("mouseout", el[$ff6bf07147eecdc1$var$UNFOCUS_ADJACENCY] = function() {
                    graphView._dispatchUnfocus(api);
                });
            }
        });
        var circularRotateLabel = seriesModel.get("layout") === "circular" && seriesModel.get("circular.rotateLabel");
        var cx = data.getLayout("cx");
        var cy = data.getLayout("cy");
        data.eachItemGraphicEl(function(el, idx) {
            var itemModel = data.getItemModel(idx);
            var labelRotate = itemModel.get("label.rotate") || 0;
            var symbolPath = el.getSymbolPath();
            if (circularRotateLabel) {
                var pos = data.getItemLayout(idx);
                var rad = Math.atan2(pos[1] - cy, pos[0] - cx);
                if (rad < 0) rad = Math.PI * 2 + rad;
                var isLeft = pos[0] < cx;
                if (isLeft) rad = rad - Math.PI;
                var textPosition = isLeft ? "left" : "right";
                $4b57d6b582d579b7$export$377292315e79b7ac(symbolPath, {
                    textRotation: -rad,
                    textPosition: textPosition,
                    textOrigin: "center"
                }, {
                    textPosition: textPosition
                });
            } else $4b57d6b582d579b7$export$377292315e79b7ac(symbolPath, {
                textRotation: labelRotate *= Math.PI / 180
            });
        });
        this._firstRender = false;
    },
    dispose: function() {
        this._controller && this._controller.dispose();
        this._controllerHost = {};
        this._clearTimer();
    },
    _dispatchUnfocus: function(api, opt) {
        var self = this;
        this._clearTimer();
        this._unfocusDelayTimer = setTimeout(function() {
            self._unfocusDelayTimer = null;
            api.dispatchAction({
                type: "unfocusNodeAdjacency",
                seriesId: self._model.id
            });
        }, 500);
    },
    _clearTimer: function() {
        if (this._unfocusDelayTimer) {
            clearTimeout(this._unfocusDelayTimer);
            this._unfocusDelayTimer = null;
        }
    },
    focusNodeAdjacency: function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var graph = data.graph;
        var dataIndex = payload.dataIndex;
        var edgeDataIndex = payload.edgeDataIndex;
        var node = graph.getNodeByIndex(dataIndex);
        var edge = graph.getEdgeByIndex(edgeDataIndex);
        if (!node && !edge) return;
        graph.eachNode(function(node) {
            $ff6bf07147eecdc1$var$fadeOutItem(node, $ff6bf07147eecdc1$var$nodeOpacityPath, 0.1);
        });
        graph.eachEdge(function(edge) {
            $ff6bf07147eecdc1$var$fadeOutItem(edge, $ff6bf07147eecdc1$var$lineOpacityPath, 0.1);
        });
        if (node) {
            $ff6bf07147eecdc1$var$fadeInItem(node, $ff6bf07147eecdc1$var$nodeOpacityPath);
            $ec279652dd95c27b$export$79b2f7037acddd43(node.edges, function(adjacentEdge) {
                if (adjacentEdge.dataIndex < 0) return;
                $ff6bf07147eecdc1$var$fadeInItem(adjacentEdge, $ff6bf07147eecdc1$var$lineOpacityPath);
                $ff6bf07147eecdc1$var$fadeInItem(adjacentEdge.node1, $ff6bf07147eecdc1$var$nodeOpacityPath);
                $ff6bf07147eecdc1$var$fadeInItem(adjacentEdge.node2, $ff6bf07147eecdc1$var$nodeOpacityPath);
            });
        }
        if (edge) {
            $ff6bf07147eecdc1$var$fadeInItem(edge, $ff6bf07147eecdc1$var$lineOpacityPath);
            $ff6bf07147eecdc1$var$fadeInItem(edge.node1, $ff6bf07147eecdc1$var$nodeOpacityPath);
            $ff6bf07147eecdc1$var$fadeInItem(edge.node2, $ff6bf07147eecdc1$var$nodeOpacityPath);
        }
    },
    unfocusNodeAdjacency: function(seriesModel, ecModel, api, payload) {
        var graph = seriesModel.getData().graph;
        graph.eachNode(function(node) {
            $ff6bf07147eecdc1$var$fadeOutItem(node, $ff6bf07147eecdc1$var$nodeOpacityPath);
        });
        graph.eachEdge(function(edge) {
            $ff6bf07147eecdc1$var$fadeOutItem(edge, $ff6bf07147eecdc1$var$lineOpacityPath);
        });
    },
    _startForceLayoutIteration: function(forceLayout, layoutAnimation) {
        var self = this;
        (function step() {
            forceLayout.step(function(stopped) {
                self.updateLayout(self._model);
                (self._layouting = !stopped) && (layoutAnimation ? self._layoutTimeout = setTimeout(step, 16) : step());
            });
        })();
    },
    _updateController: function(seriesModel, ecModel, api) {
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        var group = this.group;
        controller.setPointerChecker(function(e, x, y) {
            var rect = group.getBoundingRect();
            rect.applyTransform(group.transform);
            return rect.contain(x, y) && !$ff6bf07147eecdc1$var$onIrrelevantElement(e, api, seriesModel);
        });
        if (seriesModel.coordinateSystem.type !== "view") {
            controller.disable();
            return;
        }
        controller.enable(seriesModel.get("roam"));
        controllerHost.zoomLimit = seriesModel.get("scaleLimit");
        controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
        controller.off("pan").off("zoom").on("pan", function(e) {
            $b7c2af586a53b694$export$1e6abcd98caba733(controllerHost, e.dx, e.dy);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: "graphRoam",
                dx: e.dx,
                dy: e.dy
            });
        }).on("zoom", function(e) {
            $b7c2af586a53b694$export$29b3c66d30a4866(controllerHost, e.scale, e.originX, e.originY);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: "graphRoam",
                zoom: e.scale,
                originX: e.originX,
                originY: e.originY
            });
            this._updateNodeAndLinkScale();
            $805e352dc678a651$exports(seriesModel.getGraph(), $ff6bf07147eecdc1$var$getNodeGlobalScale(seriesModel));
            this._lineDraw.updateLayout();
        }, this);
    },
    _updateNodeAndLinkScale: function() {
        var seriesModel = this._model;
        var data = seriesModel.getData();
        var nodeScale = $ff6bf07147eecdc1$var$getNodeGlobalScale(seriesModel);
        var invScale = [
            nodeScale,
            nodeScale
        ];
        data.eachItemGraphicEl(function(el, idx) {
            el.attr("scale", invScale);
        });
    },
    updateLayout: function(seriesModel) {
        $805e352dc678a651$exports(seriesModel.getGraph(), $ff6bf07147eecdc1$var$getNodeGlobalScale(seriesModel));
        this._symbolDraw.updateLayout();
        this._lineDraw.updateLayout();
    },
    remove: function(ecModel, api) {
        this._symbolDraw && this._symbolDraw.remove();
        this._lineDraw && this._lineDraw.remove();
    }
});
$ff6bf07147eecdc1$exports = $ff6bf07147eecdc1$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $a167347b8934a606$var$updateCenterAndZoom = $80b2a59d4ab83148$export$797ecc50d262ebd8;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @payload
 * @property {number} [seriesIndex]
 * @property {string} [seriesId]
 * @property {string} [seriesName]
 * @property {number} [dataIndex]
 */ $f406636b535430a7$exports.registerAction({
    type: "focusNodeAdjacency",
    event: "focusNodeAdjacency",
    update: "series:focusNodeAdjacency"
}, function() {});
/**
 * @payload
 * @property {number} [seriesIndex]
 * @property {string} [seriesId]
 * @property {string} [seriesName]
 */ $f406636b535430a7$exports.registerAction({
    type: "unfocusNodeAdjacency",
    event: "unfocusNodeAdjacency",
    update: "series:unfocusNodeAdjacency"
}, function() {});


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $a167347b8934a606$var$actionInfo = {
    type: "graphRoam",
    event: "graphRoam",
    update: "none"
};
/**
 * @payload
 * @property {string} name Series name
 * @property {number} [dx]
 * @property {number} [dy]
 * @property {number} [zoom]
 * @property {number} [originX]
 * @property {number} [originY]
 */ $f406636b535430a7$exports.registerAction($a167347b8934a606$var$actionInfo, function(payload, ecModel) {
    ecModel.eachComponent({
        mainType: "series",
        query: payload
    }, function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var res = $a167347b8934a606$var$updateCenterAndZoom(coordSys, payload);
        seriesModel.setCenter && seriesModel.setCenter(res.center);
        seriesModel.setZoom && seriesModel.setZoom(res.zoom);
    });
});


var $314826883cb9e925$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $314826883cb9e925$var$_default(ecModel) {
    var legendModels = ecModel.findComponents({
        mainType: "legend"
    });
    if (!legendModels || !legendModels.length) return;
    ecModel.eachSeriesByType("graph", function(graphSeries) {
        var categoriesData = graphSeries.getCategoriesData();
        var graph = graphSeries.getGraph();
        var data = graph.data;
        var categoryNames = categoriesData.mapArray(categoriesData.getName);
        data.filterSelf(function(idx) {
            var model = data.getItemModel(idx);
            var category = model.getShallow("category");
            if (category != null) {
                if (typeof category === "number") category = categoryNames[category];
                 // If in any legend component the status is not selected.
                for(var i = 0; i < legendModels.length; i++){
                    if (!legendModels[i].isSelected(category)) return false;
                }
            }
            return true;
        });
    }, this);
}
$314826883cb9e925$exports = $314826883cb9e925$var$_default;



var $45d79776579e2365$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $45d79776579e2365$var$_default(ecModel) {
    var paletteScope = {};
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        var categoriesData = seriesModel.getCategoriesData();
        var data = seriesModel.getData();
        var categoryNameIdxMap = {};
        categoriesData.each(function(idx) {
            var name = categoriesData.getName(idx); // Add prefix to avoid conflict with Object.prototype.
            categoryNameIdxMap["ec-" + name] = idx;
            var itemModel = categoriesData.getItemModel(idx);
            var color = itemModel.get("itemStyle.color") || seriesModel.getColorFromPalette(name, paletteScope);
            categoriesData.setItemVisual(idx, "color", color);
            var itemStyleList = [
                "opacity",
                "symbol",
                "symbolSize",
                "symbolKeepAspect"
            ];
            for(var i = 0; i < itemStyleList.length; i++){
                var itemStyle = itemModel.getShallow(itemStyleList[i], true);
                if (itemStyle != null) categoriesData.setItemVisual(idx, itemStyleList[i], itemStyle);
            }
        }); // Assign category color to visual
        if (categoriesData.count()) data.each(function(idx) {
            var model = data.getItemModel(idx);
            var category = model.getShallow("category");
            if (category != null) {
                if (typeof category === "string") category = categoryNameIdxMap["ec-" + category];
                var itemStyleList = [
                    "color",
                    "opacity",
                    "symbol",
                    "symbolSize",
                    "symbolKeepAspect"
                ];
                for(var i = 0; i < itemStyleList.length; i++)if (data.getItemVisual(idx, itemStyleList[i], true) == null) data.setItemVisual(idx, itemStyleList[i], categoriesData.getItemVisual(category, itemStyleList[i]));
            }
        });
    });
}
$45d79776579e2365$exports = $45d79776579e2365$var$_default;


var $42b1773e7f17f688$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $42b1773e7f17f688$var$normalize(a) {
    if (!(a instanceof Array)) a = [
        a,
        a
    ];
    return a;
}
function $42b1773e7f17f688$var$_default(ecModel) {
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        var graph = seriesModel.getGraph();
        var edgeData = seriesModel.getEdgeData();
        var symbolType = $42b1773e7f17f688$var$normalize(seriesModel.get("edgeSymbol"));
        var symbolSize = $42b1773e7f17f688$var$normalize(seriesModel.get("edgeSymbolSize"));
        var colorQuery = "lineStyle.color".split(".");
        var opacityQuery = "lineStyle.opacity".split(".");
        edgeData.setVisual("fromSymbol", symbolType && symbolType[0]);
        edgeData.setVisual("toSymbol", symbolType && symbolType[1]);
        edgeData.setVisual("fromSymbolSize", symbolSize && symbolSize[0]);
        edgeData.setVisual("toSymbolSize", symbolSize && symbolSize[1]);
        edgeData.setVisual("color", seriesModel.get(colorQuery));
        edgeData.setVisual("opacity", seriesModel.get(opacityQuery));
        edgeData.each(function(idx) {
            var itemModel = edgeData.getItemModel(idx);
            var edge = graph.getEdgeByIndex(idx);
            var symbolType = $42b1773e7f17f688$var$normalize(itemModel.getShallow("symbol", true));
            var symbolSize = $42b1773e7f17f688$var$normalize(itemModel.getShallow("symbolSize", true)); // Edge visual must after node visual
            var color = itemModel.get(colorQuery);
            var opacity = itemModel.get(opacityQuery);
            switch(color){
                case "source":
                    color = edge.node1.getVisual("color");
                    break;
                case "target":
                    color = edge.node2.getVisual("color");
                    break;
            }
            symbolType[0] && edge.setVisual("fromSymbol", symbolType[0]);
            symbolType[1] && edge.setVisual("toSymbol", symbolType[1]);
            symbolSize[0] && edge.setVisual("fromSymbolSize", symbolSize[0]);
            symbolSize[1] && edge.setVisual("toSymbolSize", symbolSize[1]);
            edge.setVisual("color", color);
            edge.setVisual("opacity", opacity);
        });
    });
}
$42b1773e7f17f688$exports = $42b1773e7f17f688$var$_default;


var $81c07c300bc0ceeb$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $81c07c300bc0ceeb$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $6df4c433c059e62c$export$6d7efb25f4dcb4db;
var $6df4c433c059e62c$export$a25b52345bee32aa;



var $6df4c433c059e62c$var$getCurvenessForEdge = $51497e7e6c6924a6$export$7e88123f7f1f62da;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $6df4c433c059e62c$var$simpleLayout(seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys && coordSys.type !== "view") return;
    var graph = seriesModel.getGraph();
    graph.eachNode(function(node) {
        var model = node.getModel();
        node.setLayout([
            +model.get("x"),
            +model.get("y")
        ]);
    });
    $6df4c433c059e62c$var$simpleLayoutEdge(graph, seriesModel);
}
function $6df4c433c059e62c$var$simpleLayoutEdge(graph, seriesModel) {
    graph.eachEdge(function(edge, index) {
        var curveness = $ec279652dd95c27b$export$2e94551289abb95b(edge.getModel().get("lineStyle.curveness"), -$6df4c433c059e62c$var$getCurvenessForEdge(edge, seriesModel, index, true), 0);
        var p1 = $9eb63d101f3bcd79$export$9cd59f9826255e47(edge.node1.getLayout());
        var p2 = $9eb63d101f3bcd79$export$9cd59f9826255e47(edge.node2.getLayout());
        var points = [
            p1,
            p2
        ];
        if (+curveness) points.push([
            (p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * curveness,
            (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * curveness
        ]);
        edge.setLayout(points);
    });
}
$6df4c433c059e62c$export$6d7efb25f4dcb4db = $6df4c433c059e62c$var$simpleLayout;
$6df4c433c059e62c$export$a25b52345bee32aa = $6df4c433c059e62c$var$simpleLayoutEdge;


var $81c07c300bc0ceeb$var$simpleLayout = $6df4c433c059e62c$export$6d7efb25f4dcb4db;
var $81c07c300bc0ceeb$var$simpleLayoutEdge = $6df4c433c059e62c$export$a25b52345bee32aa;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $81c07c300bc0ceeb$var$_default(ecModel, api) {
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        var layout = seriesModel.get("layout");
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.type !== "view") {
            var data = seriesModel.getData();
            var dimensions = [];
            $81c07c300bc0ceeb$var$each(coordSys.dimensions, function(coordDim) {
                dimensions = dimensions.concat(data.mapDimension(coordDim, true));
            });
            for(var dataIndex = 0; dataIndex < data.count(); dataIndex++){
                var value = [];
                var hasValue = false;
                for(var i = 0; i < dimensions.length; i++){
                    var val = data.get(dimensions[i], dataIndex);
                    if (!isNaN(val)) hasValue = true;
                    value.push(val);
                }
                if (hasValue) data.setItemLayout(dataIndex, coordSys.dataToPoint(value));
                else // Also {Array.<number>}, not undefined to avoid if...else... statement
                data.setItemLayout(dataIndex, [
                    NaN,
                    NaN
                ]);
            }
            $81c07c300bc0ceeb$var$simpleLayoutEdge(data.graph, seriesModel);
        } else if (!layout || layout === "none") $81c07c300bc0ceeb$var$simpleLayout(seriesModel);
    });
}
$81c07c300bc0ceeb$exports = $81c07c300bc0ceeb$var$_default;


var $85bb1b1f26e52263$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $48a1a4a5b37bcec7$export$cbfed6ae5cab3dae;


var $48a1a4a5b37bcec7$var$getSymbolSize = $c83209d77195bb6d$export$8d4a06d3facd414b;
var $48a1a4a5b37bcec7$var$getNodeGlobalScale = $c83209d77195bb6d$export$e2aa0fb9ed198ba7;


var $48a1a4a5b37bcec7$var$getCurvenessForEdge = $51497e7e6c6924a6$export$7e88123f7f1f62da;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $48a1a4a5b37bcec7$var$PI = Math.PI;
var $48a1a4a5b37bcec7$var$_symbolRadiansHalf = [];
/**
 * `basedOn` can be:
 * 'value':
 *     This layout is not accurate and have same bad case. For example,
 *     if the min value is very smaller than the max value, the nodes
 *     with the min value probably overlap even though there is enough
 *     space to layout them. So we only use this approach in the as the
 *     init layout of the force layout.
 *     FIXME
 *     Probably we do not need this method any more but use
 *     `basedOn: 'symbolSize'` in force layout if
 *     delay its init operations to GraphView.
 * 'symbolSize':
 *     This approach work only if all of the symbol size calculated.
 *     That is, the progressive rendering is not applied to graph.
 *     FIXME
 *     If progressive rendering is applied to graph some day,
 *     probably we have to use `basedOn: 'value'`.
 *
 * @param {module:echarts/src/model/Series} seriesModel
 * @param {string} basedOn 'value' or 'symbolSize'
 */ function $48a1a4a5b37bcec7$var$circularLayout(seriesModel, basedOn) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys && coordSys.type !== "view") return;
    var rect = coordSys.getBoundingRect();
    var nodeData = seriesModel.getData();
    var graph = nodeData.graph;
    var cx = rect.width / 2 + rect.x;
    var cy = rect.height / 2 + rect.y;
    var r = Math.min(rect.width, rect.height) / 2;
    var count = nodeData.count();
    nodeData.setLayout({
        cx: cx,
        cy: cy
    });
    if (!count) return;
    $48a1a4a5b37bcec7$var$_layoutNodesBasedOn[basedOn](seriesModel, coordSys, graph, nodeData, r, cx, cy, count);
    graph.eachEdge(function(edge, index) {
        var curveness = $ec279652dd95c27b$export$2e94551289abb95b(edge.getModel().get("lineStyle.curveness"), $48a1a4a5b37bcec7$var$getCurvenessForEdge(edge, seriesModel, index), 0);
        var p1 = $9eb63d101f3bcd79$export$9cd59f9826255e47(edge.node1.getLayout());
        var p2 = $9eb63d101f3bcd79$export$9cd59f9826255e47(edge.node2.getLayout());
        var cp1;
        var x12 = (p1[0] + p2[0]) / 2;
        var y12 = (p1[1] + p2[1]) / 2;
        if (+curveness) {
            curveness *= 3;
            cp1 = [
                cx * curveness + x12 * (1 - curveness),
                cy * curveness + y12 * (1 - curveness)
            ];
        }
        edge.setLayout([
            p1,
            p2,
            cp1
        ]);
    });
}
var $48a1a4a5b37bcec7$var$_layoutNodesBasedOn = {
    value: function(seriesModel, coordSys, graph, nodeData, r, cx, cy, count) {
        var angle = 0;
        var sum = nodeData.getSum("value");
        var unitAngle = Math.PI * 2 / (sum || count);
        graph.eachNode(function(node) {
            var value = node.getValue("value");
            var radianHalf = unitAngle * (sum ? value : 1) / 2;
            angle += radianHalf;
            node.setLayout([
                r * Math.cos(angle) + cx,
                r * Math.sin(angle) + cy
            ]);
            angle += radianHalf;
        });
    },
    symbolSize: function(seriesModel, coordSys, graph, nodeData, r, cx, cy, count) {
        var sumRadian = 0;
        $48a1a4a5b37bcec7$var$_symbolRadiansHalf.length = count;
        var nodeScale = $48a1a4a5b37bcec7$var$getNodeGlobalScale(seriesModel);
        graph.eachNode(function(node) {
            var symbolSize = $48a1a4a5b37bcec7$var$getSymbolSize(node); // Normally this case will not happen, but we still add
            // some the defensive code (2px is an arbitrary value).
            isNaN(symbolSize) && (symbolSize = 2);
            symbolSize < 0 && (symbolSize = 0);
            symbolSize *= nodeScale;
            var symbolRadianHalf = Math.asin(symbolSize / 2 / r); // when `symbolSize / 2` is bigger than `r`.
            isNaN(symbolRadianHalf) && (symbolRadianHalf = $48a1a4a5b37bcec7$var$PI / 2);
            $48a1a4a5b37bcec7$var$_symbolRadiansHalf[node.dataIndex] = symbolRadianHalf;
            sumRadian += symbolRadianHalf * 2;
        });
        var halfRemainRadian = (2 * $48a1a4a5b37bcec7$var$PI - sumRadian) / count / 2;
        var angle = 0;
        graph.eachNode(function(node) {
            var radianHalf = halfRemainRadian + $48a1a4a5b37bcec7$var$_symbolRadiansHalf[node.dataIndex];
            angle += radianHalf;
            node.setLayout([
                r * Math.cos(angle) + cx,
                r * Math.sin(angle) + cy
            ]);
            angle += radianHalf;
        });
    }
};
$48a1a4a5b37bcec7$export$cbfed6ae5cab3dae = $48a1a4a5b37bcec7$var$circularLayout;


var $85bb1b1f26e52263$var$circularLayout = $48a1a4a5b37bcec7$export$cbfed6ae5cab3dae;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $85bb1b1f26e52263$var$_default(ecModel) {
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        if (seriesModel.get("layout") === "circular") $85bb1b1f26e52263$var$circularLayout(seriesModel, "symbolSize");
    });
}
$85bb1b1f26e52263$exports = $85bb1b1f26e52263$var$_default;


var $18eef3b14aa472c6$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $8a2c914c5f2a6747$export$100e93b4853dcbde;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embeded for some of the code in this file:
* Some formulas were originally copied from "d3.js" with some
* modifications made for this project.
* (See more details in the comment of the method "step" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ var $8a2c914c5f2a6747$var$scaleAndAdd = $9eb63d101f3bcd79$export$19cedf1da84ba854; // function adjacentNode(n, e) {
//     return e.n1 === n ? e.n2 : e.n1;
// }
function $8a2c914c5f2a6747$var$forceLayout(nodes, edges, opts) {
    var rect = opts.rect;
    var width = rect.width;
    var height = rect.height;
    var center = [
        rect.x + width / 2,
        rect.y + height / 2
    ]; // var scale = opts.scale || 1;
    var gravity = opts.gravity == null ? 0.1 : opts.gravity; // for (var i = 0; i < edges.length; i++) {
    //     var e = edges[i];
    //     var n1 = e.n1;
    //     var n2 = e.n2;
    //     n1.edges = n1.edges || [];
    //     n2.edges = n2.edges || [];
    //     n1.edges.push(e);
    //     n2.edges.push(e);
    // }
    // Init position
    for(var i = 0; i < nodes.length; i++){
        var n = nodes[i];
        if (!n.p) n.p = $9eb63d101f3bcd79$export$185802fd694ee1f5(width * (Math.random() - 0.5) + center[0], height * (Math.random() - 0.5) + center[1]);
        n.pp = $9eb63d101f3bcd79$export$9cd59f9826255e47(n.p);
        n.edges = null;
    } // Formula in 'Graph Drawing by Force-directed Placement'
    // var k = scale * Math.sqrt(width * height / nodes.length);
    // var k2 = k * k;
    var initialFriction = opts.friction == null ? 0.6 : opts.friction;
    var friction = initialFriction;
    return {
        warmUp: function() {
            friction = initialFriction * 0.8;
        },
        setFixed: function(idx) {
            nodes[idx].fixed = true;
        },
        setUnfixed: function(idx) {
            nodes[idx].fixed = false;
        },
        /**
     * Some formulas were originally copied from "d3.js"
     * https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/layout/force.js
     * with some modifications made for this project.
     * See the license statement at the head of this file.
     */ step: function(cb) {
            var v12 = [];
            var nLen = nodes.length;
            for(var i = 0; i < edges.length; i++){
                var e = edges[i];
                if (e.ignoreForceLayout) continue;
                var n1 = e.n1;
                var n2 = e.n2;
                $9eb63d101f3bcd79$export$f93b5905241a7cca(v12, n2.p, n1.p);
                var d = $9eb63d101f3bcd79$export$fc1400facf92c78(v12) - e.d;
                var w = n2.w / (n1.w + n2.w);
                if (isNaN(w)) w = 0;
                $9eb63d101f3bcd79$export$a3295358bff77e(v12, v12);
                !n1.fixed && $8a2c914c5f2a6747$var$scaleAndAdd(n1.p, n1.p, v12, w * d * friction);
                !n2.fixed && $8a2c914c5f2a6747$var$scaleAndAdd(n2.p, n2.p, v12, -(1 - w) * d * friction);
            } // Gravity
            for(var i = 0; i < nLen; i++){
                var n = nodes[i];
                if (!n.fixed) {
                    $9eb63d101f3bcd79$export$f93b5905241a7cca(v12, center, n.p); // var d = vec2.len(v12);
                    // vec2.scale(v12, v12, 1 / d);
                    // var gravityFactor = gravity;
                    $8a2c914c5f2a6747$var$scaleAndAdd(n.p, n.p, v12, gravity * friction);
                }
            } // Repulsive
            // PENDING
            for(var i = 0; i < nLen; i++){
                var n1 = nodes[i];
                for(var j = i + 1; j < nLen; j++){
                    var n2 = nodes[j];
                    $9eb63d101f3bcd79$export$f93b5905241a7cca(v12, n2.p, n1.p);
                    var d = $9eb63d101f3bcd79$export$fc1400facf92c78(v12);
                    if (d === 0) {
                        // Random repulse
                        $9eb63d101f3bcd79$export$adaa4cf7ef1b65be(v12, Math.random() - 0.5, Math.random() - 0.5);
                        d = 1;
                    }
                    var repFact = (n1.rep + n2.rep) / d / d;
                    !n1.fixed && $8a2c914c5f2a6747$var$scaleAndAdd(n1.pp, n1.pp, v12, repFact);
                    !n2.fixed && $8a2c914c5f2a6747$var$scaleAndAdd(n2.pp, n2.pp, v12, -repFact);
                }
            }
            var v = [];
            for(var i = 0; i < nLen; i++){
                var n = nodes[i];
                if (!n.fixed) {
                    $9eb63d101f3bcd79$export$f93b5905241a7cca(v, n.p, n.pp);
                    $8a2c914c5f2a6747$var$scaleAndAdd(n.p, n.p, v, friction);
                    $9eb63d101f3bcd79$export$784d13d8ee351f07(n.pp, n.p);
                }
            }
            friction = friction * 0.992;
            cb && cb(nodes, edges, friction < 0.01);
        }
    };
}
$8a2c914c5f2a6747$export$100e93b4853dcbde = $8a2c914c5f2a6747$var$forceLayout;


var $18eef3b14aa472c6$var$forceLayout = $8a2c914c5f2a6747$export$100e93b4853dcbde;

var $18eef3b14aa472c6$var$simpleLayout = $6df4c433c059e62c$export$6d7efb25f4dcb4db;

var $18eef3b14aa472c6$var$circularLayout = $48a1a4a5b37bcec7$export$cbfed6ae5cab3dae;

var $18eef3b14aa472c6$var$linearMap = $2d742dbe7f960d8c$export$d3f68fbaa670562;



var $18eef3b14aa472c6$var$getCurvenessForEdge = $51497e7e6c6924a6$export$7e88123f7f1f62da;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $18eef3b14aa472c6$var$_default(ecModel) {
    ecModel.eachSeriesByType("graph", function(graphSeries) {
        var coordSys = graphSeries.coordinateSystem;
        if (coordSys && coordSys.type !== "view") return;
        if (graphSeries.get("layout") === "force") {
            var preservedPoints = graphSeries.preservedPoints || {};
            var graph = graphSeries.getGraph();
            var nodeData = graph.data;
            var edgeData = graph.edgeData;
            var forceModel = graphSeries.getModel("force");
            var initLayout = forceModel.get("initLayout");
            if (graphSeries.preservedPoints) nodeData.each(function(idx) {
                var id = nodeData.getId(idx);
                nodeData.setItemLayout(idx, preservedPoints[id] || [
                    NaN,
                    NaN
                ]);
            });
            else if (!initLayout || initLayout === "none") $18eef3b14aa472c6$var$simpleLayout(graphSeries);
            else if (initLayout === "circular") $18eef3b14aa472c6$var$circularLayout(graphSeries, "value");
            var nodeDataExtent = nodeData.getDataExtent("value");
            var edgeDataExtent = edgeData.getDataExtent("value"); // var edgeDataExtent = edgeData.getDataExtent('value');
            var repulsion = forceModel.get("repulsion");
            var edgeLength = forceModel.get("edgeLength");
            if (!$ec279652dd95c27b$export$43bee75e5e14138e(repulsion)) repulsion = [
                repulsion,
                repulsion
            ];
            if (!$ec279652dd95c27b$export$43bee75e5e14138e(edgeLength)) edgeLength = [
                edgeLength,
                edgeLength
            ];
             // Larger value has smaller length
            edgeLength = [
                edgeLength[1],
                edgeLength[0]
            ];
            var nodes = nodeData.mapArray("value", function(value, idx) {
                var point = nodeData.getItemLayout(idx);
                var rep = $18eef3b14aa472c6$var$linearMap(value, nodeDataExtent, repulsion);
                if (isNaN(rep)) rep = (repulsion[0] + repulsion[1]) / 2;
                return {
                    w: rep,
                    rep: rep,
                    fixed: nodeData.getItemModel(idx).get("fixed"),
                    p: !point || isNaN(point[0]) || isNaN(point[1]) ? null : point
                };
            });
            var edges = edgeData.mapArray("value", function(value, idx) {
                var edge = graph.getEdgeByIndex(idx);
                var d = $18eef3b14aa472c6$var$linearMap(value, edgeDataExtent, edgeLength);
                if (isNaN(d)) d = (edgeLength[0] + edgeLength[1]) / 2;
                var edgeModel = edge.getModel();
                var curveness = $ec279652dd95c27b$export$2e94551289abb95b(edgeModel.get("lineStyle.curveness"), -$18eef3b14aa472c6$var$getCurvenessForEdge(edge, graphSeries, idx, true), 0);
                return {
                    n1: nodes[edge.node1.dataIndex],
                    n2: nodes[edge.node2.dataIndex],
                    d: d,
                    curveness: curveness,
                    ignoreForceLayout: edgeModel.get("ignoreForceLayout")
                };
            });
            var coordSys = graphSeries.coordinateSystem;
            var rect = coordSys.getBoundingRect();
            var forceInstance = $18eef3b14aa472c6$var$forceLayout(nodes, edges, {
                rect: rect,
                gravity: forceModel.get("gravity"),
                friction: forceModel.get("friction")
            });
            var oldStep = forceInstance.step;
            forceInstance.step = function(cb) {
                for(var i = 0, l = nodes.length; i < l; i++)if (nodes[i].fixed) // Write back to layout instance
                $9eb63d101f3bcd79$export$784d13d8ee351f07(nodes[i].p, graph.getNodeByIndex(i).getLayout());
                oldStep(function(nodes, edges, stopped) {
                    for(var i = 0, l = nodes.length; i < l; i++){
                        if (!nodes[i].fixed) graph.getNodeByIndex(i).setLayout(nodes[i].p);
                        preservedPoints[nodeData.getId(i)] = nodes[i].p;
                    }
                    for(var i = 0, l = edges.length; i < l; i++){
                        var e = edges[i];
                        var edge = graph.getEdgeByIndex(i);
                        var p1 = e.n1.p;
                        var p2 = e.n2.p;
                        var points = edge.getLayout();
                        points = points ? points.slice() : [];
                        points[0] = points[0] || [];
                        points[1] = points[1] || [];
                        $9eb63d101f3bcd79$export$784d13d8ee351f07(points[0], p1);
                        $9eb63d101f3bcd79$export$784d13d8ee351f07(points[1], p2);
                        if (+e.curveness) points[2] = [
                            (p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * e.curveness,
                            (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * e.curveness
                        ];
                        edge.setLayout(points);
                    } // Update layout
                    cb && cb(stopped);
                });
            };
            graphSeries.forceLayout = forceInstance;
            graphSeries.preservedPoints = preservedPoints; // Step to get the layout
            forceInstance.step();
        } else // Remove prev injected forceLayout instance
        graphSeries.forceLayout = null;
    });
}
$18eef3b14aa472c6$exports = $18eef3b14aa472c6$var$_default;


var $fae893be0a390fbc$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $fae893be0a390fbc$var$getLayoutRect = $ab0c9086dd6c5b39$export$4517a5ca639a7293;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME Where to create the simple view coordinate system
function $fae893be0a390fbc$var$getViewRect(seriesModel, api, aspect) {
    var option = seriesModel.getBoxLayoutParams();
    option.aspect = aspect;
    return $fae893be0a390fbc$var$getLayoutRect(option, {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $fae893be0a390fbc$var$_default(ecModel, api) {
    var viewList = [];
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        var coordSysType = seriesModel.get("coordinateSystem");
        if (!coordSysType || coordSysType === "view") {
            var data = seriesModel.getData();
            var positions = data.mapArray(function(idx) {
                var itemModel = data.getItemModel(idx);
                return [
                    +itemModel.get("x"),
                    +itemModel.get("y")
                ];
            });
            var min = [];
            var max = [];
            $22231ac051eb7cf7$export$188c3cd07b4129dd(positions, min, max); // If width or height is 0
            if (max[0] - min[0] === 0) {
                max[0] += 1;
                min[0] -= 1;
            }
            if (max[1] - min[1] === 0) {
                max[1] += 1;
                min[1] -= 1;
            }
            var aspect = (max[0] - min[0]) / (max[1] - min[1]); // FIXME If get view rect after data processed?
            var viewRect = $fae893be0a390fbc$var$getViewRect(seriesModel, api, aspect); // Position may be NaN, use view rect instead
            if (isNaN(aspect)) {
                min = [
                    viewRect.x,
                    viewRect.y
                ];
                max = [
                    viewRect.x + viewRect.width,
                    viewRect.y + viewRect.height
                ];
            }
            var bbWidth = max[0] - min[0];
            var bbHeight = max[1] - min[1];
            var viewWidth = viewRect.width;
            var viewHeight = viewRect.height;
            var viewCoordSys = seriesModel.coordinateSystem = new $28347f1c81a620dc$exports();
            viewCoordSys.zoomLimit = seriesModel.get("scaleLimit");
            viewCoordSys.setBoundingRect(min[0], min[1], bbWidth, bbHeight);
            viewCoordSys.setViewRect(viewRect.x, viewRect.y, viewWidth, viewHeight); // Update roam info
            viewCoordSys.setCenter(seriesModel.get("center"));
            viewCoordSys.setZoom(seriesModel.get("zoom"));
            viewList.push(viewCoordSys);
        }
    });
    return viewList;
}
$fae893be0a390fbc$exports = $fae893be0a390fbc$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerProcessor($314826883cb9e925$exports);
$f406636b535430a7$exports.registerVisual($6efa4c3507ca2b4d$exports("graph", "circle", null));
$f406636b535430a7$exports.registerVisual($45d79776579e2365$exports);
$f406636b535430a7$exports.registerVisual($42b1773e7f17f688$exports);
$f406636b535430a7$exports.registerLayout($81c07c300bc0ceeb$exports);
$f406636b535430a7$exports.registerLayout($f406636b535430a7$exports.PRIORITY.VISUAL.POST_CHART_LAYOUT, $85bb1b1f26e52263$exports);
$f406636b535430a7$exports.registerLayout($18eef3b14aa472c6$exports); // Graph view coordinate system
$f406636b535430a7$exports.registerCoordinateSystem("graphView", {
    create: $fae893be0a390fbc$exports
});


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $e31d09ecc64a9f49$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $e31d09ecc64a9f49$var$GaugeSeries = $70847df98016d69d$exports.extend({
    type: "series.gauge",
    getInitialData: function(option, ecModel) {
        return $1dd6d8dd116bcd7f$exports(this, [
            "value"
        ]);
    },
    defaultOption: {
        zlevel: 0,
        z: 2,
        // 默认全局居中
        center: [
            "50%",
            "50%"
        ],
        legendHoverLink: true,
        radius: "75%",
        startAngle: 225,
        endAngle: -45,
        clockwise: true,
        // 最小值
        min: 0,
        // 最大值
        max: 100,
        // 分割段数，默认为10
        splitNumber: 10,
        // 坐标轴线
        axisLine: {
            // 默认显示，属性show控制显示与否
            show: true,
            lineStyle: {
                // 属性lineStyle控制线条样式
                color: [
                    [
                        0.2,
                        "#91c7ae"
                    ],
                    [
                        0.8,
                        "#63869e"
                    ],
                    [
                        1,
                        "#c23531"
                    ]
                ],
                width: 30
            }
        },
        // 分隔线
        splitLine: {
            // 默认显示，属性show控制显示与否
            show: true,
            // 属性length控制线长
            length: 30,
            // 属性lineStyle（详见lineStyle）控制线条样式
            lineStyle: {
                color: "#eee",
                width: 2,
                type: "solid"
            }
        },
        // 坐标轴小标记
        axisTick: {
            // 属性show控制显示与否，默认不显示
            show: true,
            // 每份split细分多少段
            splitNumber: 5,
            // 属性length控制线长
            length: 8,
            // 属性lineStyle控制线条样式
            lineStyle: {
                color: "#eee",
                width: 1,
                type: "solid"
            }
        },
        axisLabel: {
            show: true,
            distance: 5,
            // formatter: null,
            color: "auto"
        },
        pointer: {
            show: true,
            length: "80%",
            width: 8
        },
        itemStyle: {
            color: "auto"
        },
        title: {
            show: true,
            // x, y，单位px
            offsetCenter: [
                0,
                "-40%"
            ],
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: "#333",
            fontSize: 15
        },
        detail: {
            show: true,
            backgroundColor: "rgba(0,0,0,0)",
            borderWidth: 0,
            borderColor: "#ccc",
            width: 100,
            height: null,
            // self-adaption
            padding: [
                5,
                10
            ],
            // x, y，单位px
            offsetCenter: [
                0,
                "40%"
            ],
            // formatter: null,
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: "auto",
            fontSize: 30
        }
    }
});
var $e31d09ecc64a9f49$var$_default = $e31d09ecc64a9f49$var$GaugeSeries;
$e31d09ecc64a9f49$exports = $e31d09ecc64a9f49$var$_default;


var $6c03d6f24bba4b96$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $9649bb0d25b2f2d0$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $9649bb0d25b2f2d0$var$_default = $b9701a0f23f767de$exports.extend({
    type: "echartsGaugePointer",
    shape: {
        angle: 0,
        width: 10,
        r: 10,
        x: 0,
        y: 0
    },
    buildPath: function(ctx, shape) {
        var mathCos = Math.cos;
        var mathSin = Math.sin;
        var r = shape.r;
        var width = shape.width;
        var angle = shape.angle;
        var x = shape.x - mathCos(angle) * width * (width >= r / 3 ? 1 : 2);
        var y = shape.y - mathSin(angle) * width * (width >= r / 3 ? 1 : 2);
        angle = shape.angle - Math.PI / 2;
        ctx.moveTo(x, y);
        ctx.lineTo(shape.x + mathCos(angle) * width, shape.y + mathSin(angle) * width);
        ctx.lineTo(shape.x + mathCos(shape.angle) * r, shape.y + mathSin(shape.angle) * r);
        ctx.lineTo(shape.x - mathCos(angle) * width, shape.y - mathSin(angle) * width);
        ctx.lineTo(x, y);
        return;
    }
});
$9649bb0d25b2f2d0$exports = $9649bb0d25b2f2d0$var$_default;





var $6c03d6f24bba4b96$var$parsePercent = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f;
var $6c03d6f24bba4b96$var$round = $2d742dbe7f960d8c$export$2077e0241d6afd3c;
var $6c03d6f24bba4b96$var$linearMap = $2d742dbe7f960d8c$export$d3f68fbaa670562;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $6c03d6f24bba4b96$var$parsePosition(seriesModel, api) {
    var center = seriesModel.get("center");
    var width = api.getWidth();
    var height = api.getHeight();
    var size = Math.min(width, height);
    var cx = $6c03d6f24bba4b96$var$parsePercent(center[0], api.getWidth());
    var cy = $6c03d6f24bba4b96$var$parsePercent(center[1], api.getHeight());
    var r = $6c03d6f24bba4b96$var$parsePercent(seriesModel.get("radius"), size / 2);
    return {
        cx: cx,
        cy: cy,
        r: r
    };
}
function $6c03d6f24bba4b96$var$formatLabel(label, labelFormatter) {
    if (labelFormatter) {
        if (typeof labelFormatter === "string") label = labelFormatter.replace("{value}", label != null ? label : "");
        else if (typeof labelFormatter === "function") label = labelFormatter(label);
    }
    return label;
}
var $6c03d6f24bba4b96$var$PI2 = Math.PI * 2;
var $6c03d6f24bba4b96$var$GaugeView = $6448f0aa5ca2bdaa$exports.extend({
    type: "gauge",
    render: function(seriesModel, ecModel, api) {
        this.group.removeAll();
        var colorList = seriesModel.get("axisLine.lineStyle.color");
        var posInfo = $6c03d6f24bba4b96$var$parsePosition(seriesModel, api);
        this._renderMain(seriesModel, ecModel, api, colorList, posInfo);
    },
    dispose: function() {},
    _renderMain: function(seriesModel, ecModel, api, colorList, posInfo) {
        var group = this.group;
        var axisLineModel = seriesModel.getModel("axisLine");
        var lineStyleModel = axisLineModel.getModel("lineStyle");
        var clockwise = seriesModel.get("clockwise");
        var startAngle = -seriesModel.get("startAngle") / 180 * Math.PI;
        var endAngle = -seriesModel.get("endAngle") / 180 * Math.PI;
        var angleRangeSpan = (endAngle - startAngle) % $6c03d6f24bba4b96$var$PI2;
        var prevEndAngle = startAngle;
        var axisLineWidth = lineStyleModel.get("width");
        var showAxis = axisLineModel.get("show");
        for(var i = 0; showAxis && i < colorList.length; i++){
            // Clamp
            var percent = Math.min(Math.max(colorList[i][0], 0), 1);
            var endAngle = startAngle + angleRangeSpan * percent;
            var sector = new $4b57d6b582d579b7$export$e98c2c7eb2b14f45({
                shape: {
                    startAngle: prevEndAngle,
                    endAngle: endAngle,
                    cx: posInfo.cx,
                    cy: posInfo.cy,
                    clockwise: clockwise,
                    r0: posInfo.r - axisLineWidth,
                    r: posInfo.r
                },
                silent: true
            });
            sector.setStyle({
                fill: colorList[i][1]
            });
            sector.setStyle(lineStyleModel.getLineStyle(// so the properties for stroking are useless
            [
                "color",
                "borderWidth",
                "borderColor"
            ]));
            group.add(sector);
            prevEndAngle = endAngle;
        }
        var getColor = function(percent) {
            // Less than 0
            if (percent <= 0) return colorList[0][1];
            for(var i = 0; i < colorList.length; i++){
                if (colorList[i][0] >= percent && (i === 0 ? 0 : colorList[i - 1][0]) < percent) return colorList[i][1];
            } // More than 1
            return colorList[i - 1][1];
        };
        if (!clockwise) {
            var tmp = startAngle;
            startAngle = endAngle;
            endAngle = tmp;
        }
        this._renderTicks(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise);
        this._renderPointer(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise);
        this._renderTitle(seriesModel, ecModel, api, getColor, posInfo);
        this._renderDetail(seriesModel, ecModel, api, getColor, posInfo);
    },
    _renderTicks: function(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise) {
        var group = this.group;
        var cx = posInfo.cx;
        var cy = posInfo.cy;
        var r = posInfo.r;
        var minVal = +seriesModel.get("min");
        var maxVal = +seriesModel.get("max");
        var splitLineModel = seriesModel.getModel("splitLine");
        var tickModel = seriesModel.getModel("axisTick");
        var labelModel = seriesModel.getModel("axisLabel");
        var splitNumber = seriesModel.get("splitNumber");
        var subSplitNumber = tickModel.get("splitNumber");
        var splitLineLen = $6c03d6f24bba4b96$var$parsePercent(splitLineModel.get("length"), r);
        var tickLen = $6c03d6f24bba4b96$var$parsePercent(tickModel.get("length"), r);
        var angle = startAngle;
        var step = (endAngle - startAngle) / splitNumber;
        var subStep = step / subSplitNumber;
        var splitLineStyle = splitLineModel.getModel("lineStyle").getLineStyle();
        var tickLineStyle = tickModel.getModel("lineStyle").getLineStyle();
        for(var i = 0; i <= splitNumber; i++){
            var unitX = Math.cos(angle);
            var unitY = Math.sin(angle); // Split line
            if (splitLineModel.get("show")) {
                var splitLine = new $4b57d6b582d579b7$export$17d680238e50603e({
                    shape: {
                        x1: unitX * r + cx,
                        y1: unitY * r + cy,
                        x2: unitX * (r - splitLineLen) + cx,
                        y2: unitY * (r - splitLineLen) + cy
                    },
                    style: splitLineStyle,
                    silent: true
                });
                if (splitLineStyle.stroke === "auto") splitLine.setStyle({
                    stroke: getColor(i / splitNumber)
                });
                group.add(splitLine);
            } // Label
            if (labelModel.get("show")) {
                var label = $6c03d6f24bba4b96$var$formatLabel($6c03d6f24bba4b96$var$round(i / splitNumber * (maxVal - minVal) + minVal), labelModel.get("formatter"));
                var distance = labelModel.get("distance");
                var autoColor = getColor(i / splitNumber);
                group.add(new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
                    style: $4b57d6b582d579b7$export$6605af501964d89a({}, labelModel, {
                        text: label,
                        x: unitX * (r - splitLineLen - distance) + cx,
                        y: unitY * (r - splitLineLen - distance) + cy,
                        textVerticalAlign: unitY < -0.4 ? "top" : unitY > 0.4 ? "bottom" : "middle",
                        textAlign: unitX < -0.4 ? "left" : unitX > 0.4 ? "right" : "center"
                    }, {
                        autoColor: autoColor
                    }),
                    silent: true
                }));
            } // Axis tick
            if (tickModel.get("show") && i !== splitNumber) {
                for(var j = 0; j <= subSplitNumber; j++){
                    var unitX = Math.cos(angle);
                    var unitY = Math.sin(angle);
                    var tickLine = new $4b57d6b582d579b7$export$17d680238e50603e({
                        shape: {
                            x1: unitX * r + cx,
                            y1: unitY * r + cy,
                            x2: unitX * (r - tickLen) + cx,
                            y2: unitY * (r - tickLen) + cy
                        },
                        silent: true,
                        style: tickLineStyle
                    });
                    if (tickLineStyle.stroke === "auto") tickLine.setStyle({
                        stroke: getColor((i + j / subSplitNumber) / splitNumber)
                    });
                    group.add(tickLine);
                    angle += subStep;
                }
                angle -= subStep;
            } else angle += step;
        }
    },
    _renderPointer: function(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise) {
        var group = this.group;
        var oldData = this._data;
        if (!seriesModel.get("pointer.show")) {
            // Remove old element
            oldData && oldData.eachItemGraphicEl(function(el) {
                group.remove(el);
            });
            return;
        }
        var valueExtent = [
            +seriesModel.get("min"),
            +seriesModel.get("max")
        ];
        var angleExtent = [
            startAngle,
            endAngle
        ];
        var data = seriesModel.getData();
        var valueDim = data.mapDimension("value");
        data.diff(oldData).add(function(idx) {
            var pointer = new $9649bb0d25b2f2d0$exports({
                shape: {
                    angle: startAngle
                }
            });
            $4b57d6b582d579b7$export$a121566aadcfe021(pointer, {
                shape: {
                    angle: $6c03d6f24bba4b96$var$linearMap(data.get(valueDim, idx), valueExtent, angleExtent, true)
                }
            }, seriesModel);
            group.add(pointer);
            data.setItemGraphicEl(idx, pointer);
        }).update(function(newIdx, oldIdx) {
            var pointer = oldData.getItemGraphicEl(oldIdx);
            $4b57d6b582d579b7$export$c8dce3c08436e91e(pointer, {
                shape: {
                    angle: $6c03d6f24bba4b96$var$linearMap(data.get(valueDim, newIdx), valueExtent, angleExtent, true)
                }
            }, seriesModel);
            group.add(pointer);
            data.setItemGraphicEl(newIdx, pointer);
        }).remove(function(idx) {
            var pointer = oldData.getItemGraphicEl(idx);
            group.remove(pointer);
        }).execute();
        data.eachItemGraphicEl(function(pointer, idx) {
            var itemModel = data.getItemModel(idx);
            var pointerModel = itemModel.getModel("pointer");
            pointer.setShape({
                x: posInfo.cx,
                y: posInfo.cy,
                width: $6c03d6f24bba4b96$var$parsePercent(pointerModel.get("width"), posInfo.r),
                r: $6c03d6f24bba4b96$var$parsePercent(pointerModel.get("length"), posInfo.r)
            });
            pointer.useStyle(itemModel.getModel("itemStyle").getItemStyle());
            if (pointer.style.fill === "auto") pointer.setStyle("fill", getColor($6c03d6f24bba4b96$var$linearMap(data.get(valueDim, idx), valueExtent, [
                0,
                1
            ], true)));
            $4b57d6b582d579b7$export$28b42df8183f218c(pointer, itemModel.getModel("emphasis.itemStyle").getItemStyle());
        });
        this._data = data;
    },
    _renderTitle: function(seriesModel, ecModel, api, getColor, posInfo) {
        var data = seriesModel.getData();
        var valueDim = data.mapDimension("value");
        var titleModel = seriesModel.getModel("title");
        if (titleModel.get("show")) {
            var offsetCenter = titleModel.get("offsetCenter");
            var x = posInfo.cx + $6c03d6f24bba4b96$var$parsePercent(offsetCenter[0], posInfo.r);
            var y = posInfo.cy + $6c03d6f24bba4b96$var$parsePercent(offsetCenter[1], posInfo.r);
            var minVal = +seriesModel.get("min");
            var maxVal = +seriesModel.get("max");
            var value = seriesModel.getData().get(valueDim, 0);
            var autoColor = getColor($6c03d6f24bba4b96$var$linearMap(value, [
                minVal,
                maxVal
            ], [
                0,
                1
            ], true));
            this.group.add(new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
                silent: true,
                style: $4b57d6b582d579b7$export$6605af501964d89a({}, titleModel, {
                    x: x,
                    y: y,
                    // FIXME First data name ?
                    text: data.getName(0),
                    textAlign: "center",
                    textVerticalAlign: "middle"
                }, {
                    autoColor: autoColor,
                    forceRich: true
                })
            }));
        }
    },
    _renderDetail: function(seriesModel, ecModel, api, getColor, posInfo) {
        var detailModel = seriesModel.getModel("detail");
        var minVal = +seriesModel.get("min");
        var maxVal = +seriesModel.get("max");
        if (detailModel.get("show")) {
            var offsetCenter = detailModel.get("offsetCenter");
            var x = posInfo.cx + $6c03d6f24bba4b96$var$parsePercent(offsetCenter[0], posInfo.r);
            var y = posInfo.cy + $6c03d6f24bba4b96$var$parsePercent(offsetCenter[1], posInfo.r);
            var width = $6c03d6f24bba4b96$var$parsePercent(detailModel.get("width"), posInfo.r);
            var height = $6c03d6f24bba4b96$var$parsePercent(detailModel.get("height"), posInfo.r);
            var data = seriesModel.getData();
            var value = data.get(data.mapDimension("value"), 0);
            var autoColor = getColor($6c03d6f24bba4b96$var$linearMap(value, [
                minVal,
                maxVal
            ], [
                0,
                1
            ], true));
            this.group.add(new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
                silent: true,
                style: $4b57d6b582d579b7$export$6605af501964d89a({}, detailModel, {
                    x: x,
                    y: y,
                    text: $6c03d6f24bba4b96$var$formatLabel(value, detailModel.get("formatter")),
                    textWidth: isNaN(width) ? null : width,
                    textHeight: isNaN(height) ? null : height,
                    textAlign: "center",
                    textVerticalAlign: "middle"
                }, {
                    autoColor: autoColor,
                    forceRich: true
                })
            }));
        }
    }
});
var $6c03d6f24bba4b96$var$_default = $6c03d6f24bba4b96$var$GaugeView;
$6c03d6f24bba4b96$exports = $6c03d6f24bba4b96$var$_default;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $185ae95e27b55db2$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $185ae95e27b55db2$var$defaultEmphasis = $d559f43cb9041423$export$abdcc6a26372f94b;

var $185ae95e27b55db2$var$makeSeriesEncodeForNameBased = $71e1a98f99449cca$export$60b8a57d1f2fed26;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $185ae95e27b55db2$var$FunnelSeries = $f406636b535430a7$exports.extendSeriesModel({
    type: "series.funnel",
    init: function(option) {
        $185ae95e27b55db2$var$FunnelSeries.superApply(this, "init", arguments); // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new $6b46bfdbd75036d4$exports($ec279652dd95c27b$export$2385a24977818dd0(this.getData, this), $ec279652dd95c27b$export$2385a24977818dd0(this.getRawData, this)); // Extend labelLine emphasis
        this._defaultLabelLine(option);
    },
    getInitialData: function(option, ecModel) {
        return $1dd6d8dd116bcd7f$exports(this, {
            coordDimensions: [
                "value"
            ],
            encodeDefaulter: $ec279652dd95c27b$export$c3095a23b368d1f2($185ae95e27b55db2$var$makeSeriesEncodeForNameBased, this)
        });
    },
    _defaultLabelLine: function(option) {
        // Extend labelLine emphasis
        $185ae95e27b55db2$var$defaultEmphasis(option, "labelLine", [
            "show"
        ]);
        var labelLineNormalOpt = option.labelLine;
        var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`
        labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
        labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
    },
    // Overwrite
    getDataParams: function(dataIndex) {
        var data = this.getData();
        var params = $185ae95e27b55db2$var$FunnelSeries.superCall(this, "getDataParams", dataIndex);
        var valueDim = data.mapDimension("value");
        var sum = data.getSum(valueDim); // Percent is 0 if sum is 0
        params.percent = !sum ? 0 : +(data.get(valueDim, dataIndex) / sum * 100).toFixed(2);
        params.$vars.push("percent");
        return params;
    },
    defaultOption: {
        zlevel: 0,
        // 一级层叠
        z: 2,
        // 二级层叠
        legendHoverLink: true,
        left: 80,
        top: 60,
        right: 80,
        bottom: 60,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        // 默认取数据最小最大值
        // min: 0,
        // max: 100,
        minSize: "0%",
        maxSize: "100%",
        sort: "descending",
        // 'ascending', 'descending'
        orient: "vertical",
        gap: 0,
        funnelAlign: "center",
        label: {
            show: true,
            position: "outer" // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
        },
        labelLine: {
            show: true,
            length: 20,
            lineStyle: {
                // color: 各异,
                width: 1,
                type: "solid"
            }
        },
        itemStyle: {
            // color: 各异,
            borderColor: "#fff",
            borderWidth: 1
        },
        emphasis: {
            label: {
                show: true
            }
        }
    }
});
var $185ae95e27b55db2$var$_default = $185ae95e27b55db2$var$FunnelSeries;
$185ae95e27b55db2$exports = $185ae95e27b55db2$var$_default;


var $0afa2062d8f99826$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Piece of pie including Sector, Label, LabelLine
 * @constructor
 * @extends {module:zrender/graphic/Group}
 */ function $0afa2062d8f99826$var$FunnelPiece(data, idx) {
    $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4.call(this);
    var polygon = new $4b57d6b582d579b7$export$7d31b617c820d435();
    var labelLine = new $4b57d6b582d579b7$export$79f3ee03e63e7073();
    var text = new $4b57d6b582d579b7$export$5f1af8db9871e1d6();
    this.add(polygon);
    this.add(labelLine);
    this.add(text);
    this.highDownOnUpdate = function(fromState, toState) {
        if (toState === "emphasis") {
            labelLine.ignore = labelLine.hoverIgnore;
            text.ignore = text.hoverIgnore;
        } else {
            labelLine.ignore = labelLine.normalIgnore;
            text.ignore = text.normalIgnore;
        }
    };
    this.updateData(data, idx, true);
}
var $0afa2062d8f99826$var$funnelPieceProto = $0afa2062d8f99826$var$FunnelPiece.prototype;
var $0afa2062d8f99826$var$opacityAccessPath = [
    "itemStyle",
    "opacity"
];
$0afa2062d8f99826$var$funnelPieceProto.updateData = function(data, idx, firstCreate) {
    var polygon = this.childAt(0);
    var seriesModel = data.hostModel;
    var itemModel = data.getItemModel(idx);
    var layout = data.getItemLayout(idx);
    var opacity = data.getItemModel(idx).get($0afa2062d8f99826$var$opacityAccessPath);
    opacity = opacity == null ? 1 : opacity; // Reset style
    polygon.useStyle({});
    if (firstCreate) {
        polygon.setShape({
            points: layout.points
        });
        polygon.setStyle({
            opacity: 0
        });
        $4b57d6b582d579b7$export$a121566aadcfe021(polygon, {
            style: {
                opacity: opacity
            }
        }, seriesModel, idx);
    } else $4b57d6b582d579b7$export$c8dce3c08436e91e(polygon, {
        style: {
            opacity: opacity
        },
        shape: {
            points: layout.points
        }
    }, seriesModel, idx);
     // Update common style
    var itemStyleModel = itemModel.getModel("itemStyle");
    var visualColor = data.getItemVisual(idx, "color");
    polygon.setStyle($ec279652dd95c27b$export$ebe90cb607ad99e({
        lineJoin: "round",
        fill: visualColor
    }, itemStyleModel.getItemStyle([
        "opacity"
    ])));
    polygon.hoverStyle = itemStyleModel.getModel("emphasis").getItemStyle();
    this._updateLabel(data, idx);
    $4b57d6b582d579b7$export$28b42df8183f218c(this);
};
$0afa2062d8f99826$var$funnelPieceProto._updateLabel = function(data, idx) {
    var labelLine = this.childAt(1);
    var labelText = this.childAt(2);
    var seriesModel = data.hostModel;
    var itemModel = data.getItemModel(idx);
    var layout = data.getItemLayout(idx);
    var labelLayout = layout.label;
    var visualColor = data.getItemVisual(idx, "color");
    $4b57d6b582d579b7$export$c8dce3c08436e91e(labelLine, {
        shape: {
            points: labelLayout.linePoints || labelLayout.linePoints
        }
    }, seriesModel, idx);
    $4b57d6b582d579b7$export$c8dce3c08436e91e(labelText, {
        style: {
            x: labelLayout.x,
            y: labelLayout.y
        }
    }, seriesModel, idx);
    labelText.attr({
        rotation: labelLayout.rotation,
        origin: [
            labelLayout.x,
            labelLayout.y
        ],
        z2: 10
    });
    var labelModel = itemModel.getModel("label");
    var labelHoverModel = itemModel.getModel("emphasis.label");
    var labelLineModel = itemModel.getModel("labelLine");
    var labelLineHoverModel = itemModel.getModel("emphasis.labelLine");
    var visualColor = data.getItemVisual(idx, "color");
    $4b57d6b582d579b7$export$9a13992917966657(labelText.style, labelText.hoverStyle = {}, labelModel, labelHoverModel, {
        labelFetcher: data.hostModel,
        labelDataIndex: idx,
        defaultText: data.getName(idx),
        autoColor: visualColor,
        useInsideStyle: !!labelLayout.inside
    }, {
        textAlign: labelLayout.textAlign,
        textVerticalAlign: labelLayout.verticalAlign
    });
    labelText.ignore = labelText.normalIgnore = !labelModel.get("show");
    labelText.hoverIgnore = !labelHoverModel.get("show");
    labelLine.ignore = labelLine.normalIgnore = !labelLineModel.get("show");
    labelLine.hoverIgnore = !labelLineHoverModel.get("show"); // Default use item visual color
    labelLine.setStyle({
        stroke: visualColor
    });
    labelLine.setStyle(labelLineModel.getModel("lineStyle").getLineStyle());
    labelLine.hoverStyle = labelLineHoverModel.getModel("lineStyle").getLineStyle();
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($0afa2062d8f99826$var$FunnelPiece, $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4);
var $0afa2062d8f99826$var$FunnelView = $6448f0aa5ca2bdaa$exports.extend({
    type: "funnel",
    render: function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        data.diff(oldData).add(function(idx) {
            var funnelPiece = new $0afa2062d8f99826$var$FunnelPiece(data, idx);
            data.setItemGraphicEl(idx, funnelPiece);
            group.add(funnelPiece);
        }).update(function(newIdx, oldIdx) {
            var piePiece = oldData.getItemGraphicEl(oldIdx);
            piePiece.updateData(data, newIdx);
            group.add(piePiece);
            data.setItemGraphicEl(newIdx, piePiece);
        }).remove(function(idx) {
            var piePiece = oldData.getItemGraphicEl(idx);
            group.remove(piePiece);
        }).execute();
        this._data = data;
    },
    remove: function() {
        this.group.removeAll();
        this._data = null;
    },
    dispose: function() {}
});
var $0afa2062d8f99826$var$_default = $0afa2062d8f99826$var$FunnelView;
$0afa2062d8f99826$exports = $0afa2062d8f99826$var$_default;



var $d600476baa2efc24$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $d600476baa2efc24$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;


var $d600476baa2efc24$var$parsePercent = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f;
var $d600476baa2efc24$var$linearMap = $2d742dbe7f960d8c$export$d3f68fbaa670562;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $d600476baa2efc24$var$getViewRect(seriesModel, api) {
    return $ab0c9086dd6c5b39$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $d600476baa2efc24$var$getSortedIndices(data, sort) {
    var valueDim = data.mapDimension("value");
    var valueArr = data.mapArray(valueDim, function(val) {
        return val;
    });
    var indices = [];
    var isAscending = sort === "ascending";
    for(var i = 0, len = data.count(); i < len; i++)indices[i] = i;
     // Add custom sortable function & none sortable opetion by "options.sort"
    if (typeof sort === "function") indices.sort(sort);
    else if (sort !== "none") indices.sort(function(a, b) {
        return isAscending ? valueArr[a] - valueArr[b] : valueArr[b] - valueArr[a];
    });
    return indices;
}
function $d600476baa2efc24$var$labelLayout(data) {
    data.each(function(idx) {
        var itemModel = data.getItemModel(idx);
        var labelModel = itemModel.getModel("label");
        var labelPosition = labelModel.get("position");
        var orient = itemModel.get("orient");
        var labelLineModel = itemModel.getModel("labelLine");
        var layout = data.getItemLayout(idx);
        var points = layout.points;
        var isLabelInside = labelPosition === "inner" || labelPosition === "inside" || labelPosition === "center" || labelPosition === "insideLeft" || labelPosition === "insideRight";
        var textAlign;
        var textX;
        var textY;
        var linePoints;
        if (isLabelInside) {
            if (labelPosition === "insideLeft") {
                textX = (points[0][0] + points[3][0]) / 2 + 5;
                textY = (points[0][1] + points[3][1]) / 2;
                textAlign = "left";
            } else if (labelPosition === "insideRight") {
                textX = (points[1][0] + points[2][0]) / 2 - 5;
                textY = (points[1][1] + points[2][1]) / 2;
                textAlign = "right";
            } else {
                textX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4;
                textY = (points[0][1] + points[1][1] + points[2][1] + points[3][1]) / 4;
                textAlign = "center";
            }
            linePoints = [
                [
                    textX,
                    textY
                ],
                [
                    textX,
                    textY
                ]
            ];
        } else {
            var x1;
            var y1;
            var x2;
            var y2;
            var labelLineLen = labelLineModel.get("length");
            if (labelPosition === "left") {
                // Left side
                x1 = (points[3][0] + points[0][0]) / 2;
                y1 = (points[3][1] + points[0][1]) / 2;
                x2 = x1 - labelLineLen;
                textX = x2 - 5;
                textAlign = "right";
            } else if (labelPosition === "right") {
                // Right side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                x2 = x1 + labelLineLen;
                textX = x2 + 5;
                textAlign = "left";
            } else if (labelPosition === "top") {
                // Top side
                x1 = (points[3][0] + points[0][0]) / 2;
                y1 = (points[3][1] + points[0][1]) / 2;
                y2 = y1 - labelLineLen;
                textY = y2 - 5;
                textAlign = "center";
            } else if (labelPosition === "bottom") {
                // Bottom side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                y2 = y1 + labelLineLen;
                textY = y2 + 5;
                textAlign = "center";
            } else if (labelPosition === "rightTop") {
                // RightTop side
                x1 = orient === "horizontal" ? points[3][0] : points[1][0];
                y1 = orient === "horizontal" ? points[3][1] : points[1][1];
                if (orient === "horizontal") {
                    y2 = y1 - labelLineLen;
                    textY = y2 - 5;
                    textAlign = "center";
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = "top";
                }
            } else if (labelPosition === "rightBottom") {
                // RightBottom side
                x1 = points[2][0];
                y1 = points[2][1];
                if (orient === "horizontal") {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = "center";
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = "bottom";
                }
            } else if (labelPosition === "leftTop") {
                // LeftTop side
                x1 = points[0][0];
                y1 = orient === "horizontal" ? points[0][1] : points[1][1];
                if (orient === "horizontal") {
                    y2 = y1 - labelLineLen;
                    textY = y2 - 5;
                    textAlign = "center";
                } else {
                    x2 = x1 - labelLineLen;
                    textX = x2 - 5;
                    textAlign = "right";
                }
            } else if (labelPosition === "leftBottom") {
                // LeftBottom side
                x1 = orient === "horizontal" ? points[1][0] : points[3][0];
                y1 = orient === "horizontal" ? points[1][1] : points[2][1];
                if (orient === "horizontal") {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = "center";
                } else {
                    x2 = x1 - labelLineLen;
                    textX = x2 - 5;
                    textAlign = "right";
                }
            } else {
                // Right side or Bottom side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                if (orient === "horizontal") {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = "center";
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = "left";
                }
            }
            if (orient === "horizontal") {
                x2 = x1;
                textX = x2;
            } else {
                y2 = y1;
                textY = y2;
            }
            linePoints = [
                [
                    x1,
                    y1
                ],
                [
                    x2,
                    y2
                ]
            ];
        }
        layout.label = {
            linePoints: linePoints,
            x: textX,
            y: textY,
            verticalAlign: "middle",
            textAlign: textAlign,
            inside: isLabelInside
        };
    });
}
function $d600476baa2efc24$var$_default(ecModel, api, payload) {
    ecModel.eachSeriesByType("funnel", function(seriesModel) {
        var data = seriesModel.getData();
        var valueDim = data.mapDimension("value");
        var sort = seriesModel.get("sort");
        var viewRect = $d600476baa2efc24$var$getViewRect(seriesModel, api);
        var indices = $d600476baa2efc24$var$getSortedIndices(data, sort);
        var orient = seriesModel.get("orient");
        var viewWidth = viewRect.width;
        var viewHeight = viewRect.height;
        var x = viewRect.x;
        var y = viewRect.y;
        var sizeExtent = orient === "horizontal" ? [
            $d600476baa2efc24$var$parsePercent(seriesModel.get("minSize"), viewHeight),
            $d600476baa2efc24$var$parsePercent(seriesModel.get("maxSize"), viewHeight)
        ] : [
            $d600476baa2efc24$var$parsePercent(seriesModel.get("minSize"), viewWidth),
            $d600476baa2efc24$var$parsePercent(seriesModel.get("maxSize"), viewWidth)
        ];
        var dataExtent = data.getDataExtent(valueDim);
        var min = seriesModel.get("min");
        var max = seriesModel.get("max");
        if (min == null) min = Math.min(dataExtent[0], 0);
        if (max == null) max = dataExtent[1];
        var funnelAlign = seriesModel.get("funnelAlign");
        var gap = seriesModel.get("gap");
        var viewSize = orient === "horizontal" ? viewWidth : viewHeight;
        var itemSize = (viewSize - gap * (data.count() - 1)) / data.count();
        var getLinePoints = function(idx, offset) {
            // End point index is data.count() and we assign it 0
            if (orient === "horizontal") {
                var val = data.get(valueDim, idx) || 0;
                var itemHeight = $d600476baa2efc24$var$linearMap(val, [
                    min,
                    max
                ], sizeExtent, true);
                var y0;
                switch(funnelAlign){
                    case "top":
                        y0 = y;
                        break;
                    case "center":
                        y0 = y + (viewHeight - itemHeight) / 2;
                        break;
                    case "bottom":
                        y0 = y + (viewHeight - itemHeight);
                        break;
                }
                return [
                    [
                        offset,
                        y0
                    ],
                    [
                        offset,
                        y0 + itemHeight
                    ]
                ];
            }
            var val = data.get(valueDim, idx) || 0;
            var itemWidth = $d600476baa2efc24$var$linearMap(val, [
                min,
                max
            ], sizeExtent, true);
            var x0;
            switch(funnelAlign){
                case "left":
                    x0 = x;
                    break;
                case "center":
                    x0 = x + (viewWidth - itemWidth) / 2;
                    break;
                case "right":
                    x0 = x + viewWidth - itemWidth;
                    break;
            }
            return [
                [
                    x0,
                    offset
                ],
                [
                    x0 + itemWidth,
                    offset
                ]
            ];
        };
        if (sort === "ascending") {
            // From bottom to top
            itemSize = -itemSize;
            gap = -gap;
            if (orient === "horizontal") x += viewWidth;
            else y += viewHeight;
            indices = indices.reverse();
        }
        for(var i = 0; i < indices.length; i++){
            var idx = indices[i];
            var nextIdx = indices[i + 1];
            var itemModel = data.getItemModel(idx);
            if (orient === "horizontal") {
                var width = itemModel.get("itemStyle.width");
                if (width == null) width = itemSize;
                else {
                    width = $d600476baa2efc24$var$parsePercent(width, viewWidth);
                    if (sort === "ascending") width = -width;
                }
                var start = getLinePoints(idx, x);
                var end = getLinePoints(nextIdx, x + width);
                x += width + gap;
                data.setItemLayout(idx, {
                    points: start.concat(end.slice().reverse())
                });
            } else {
                var height = itemModel.get("itemStyle.height");
                if (height == null) height = itemSize;
                else {
                    height = $d600476baa2efc24$var$parsePercent(height, viewHeight);
                    if (sort === "ascending") height = -height;
                }
                var start = orient === "horizontal" ? getLinePoints(idx, x) : getLinePoints(idx, y);
                var end = orient === "horizontal" ? getLinePoints(nextIdx, x + width) : getLinePoints(nextIdx, y + height);
                y += height + gap;
                data.setItemLayout(idx, {
                    points: start.concat(end.slice().reverse())
                });
            }
        }
        $d600476baa2efc24$var$labelLayout(data);
    });
}
$d600476baa2efc24$exports = $d600476baa2efc24$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerVisual($a6ff2ebba94839b3$exports("funnel"));
$f406636b535430a7$exports.registerLayout($d600476baa2efc24$exports);
$f406636b535430a7$exports.registerProcessor($334937e6881c9447$exports("funnel"));


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $acf51de22f2685e8$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $acf51de22f2685e8$var$_default(option) {
    $acf51de22f2685e8$var$createParallelIfNeeded(option);
    $acf51de22f2685e8$var$mergeAxisOptionFromParallel(option);
}
/**
 * Create a parallel coordinate if not exists.
 * @inner
 */ function $acf51de22f2685e8$var$createParallelIfNeeded(option) {
    if (option.parallel) return;
    var hasParallelSeries = false;
    $ec279652dd95c27b$export$79b2f7037acddd43(option.series, function(seriesOpt) {
        if (seriesOpt && seriesOpt.type === "parallel") hasParallelSeries = true;
    });
    if (hasParallelSeries) option.parallel = [
        {}
    ];
}
/**
 * Merge aixs definition from parallel option (if exists) to axis option.
 * @inner
 */ function $acf51de22f2685e8$var$mergeAxisOptionFromParallel(option) {
    var axes = $d559f43cb9041423$export$4f07b212a02c8051(option.parallelAxis);
    $ec279652dd95c27b$export$79b2f7037acddd43(axes, function(axisOption) {
        if (!$ec279652dd95c27b$export$a6cdc56e425d0d0a(axisOption)) return;
        var parallelIndex = axisOption.parallelIndex || 0;
        var parallelOption = $d559f43cb9041423$export$4f07b212a02c8051(option.parallel)[parallelIndex];
        if (parallelOption && parallelOption.parallelAxisDefault) $ec279652dd95c27b$export$4950aa0f605343fb(axisOption, parallelOption.parallelAxisDefault, false);
    });
}
$acf51de22f2685e8$exports = $acf51de22f2685e8$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $8f90b1743422ad78$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $5cf9c9d9bb4e2db1$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @constructor module:echarts/coord/parallel/ParallelAxis
 * @extends {module:echarts/coord/Axis}
 * @param {string} dim
 * @param {*} scale
 * @param {Array.<number>} coordExtent
 * @param {string} axisType
 */ var $5cf9c9d9bb4e2db1$var$ParallelAxis = function(dim, scale, coordExtent, axisType, axisIndex) {
    $95e1f94acccc578d$exports.call(this, dim, scale, coordExtent);
    /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */ this.type = axisType || "value";
    /**
   * @type {number}
   * @readOnly
   */ this.axisIndex = axisIndex;
};
$5cf9c9d9bb4e2db1$var$ParallelAxis.prototype = {
    constructor: $5cf9c9d9bb4e2db1$var$ParallelAxis,
    /**
   * Axis model
   * @param {module:echarts/coord/parallel/AxisModel}
   */ model: null,
    /**
   * @override
   */ isHorizontal: function() {
        return this.coordinateSystem.getModel().get("layout") !== "horizontal";
    }
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($5cf9c9d9bb4e2db1$var$ParallelAxis, $95e1f94acccc578d$exports);
var $5cf9c9d9bb4e2db1$var$_default = $5cf9c9d9bb4e2db1$var$ParallelAxis;
$5cf9c9d9bb4e2db1$exports = $5cf9c9d9bb4e2db1$var$_default;




var $1d1b44fc5f576d07$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Calculate slider move result.
 * Usage:
 * (1) If both handle0 and handle1 are needed to be moved, set minSpan the same as
 * maxSpan and the same as `Math.abs(handleEnd[1] - handleEnds[0])`.
 * (2) If handle0 is forbidden to cross handle1, set minSpan as `0`.
 *
 * @param {number} delta Move length.
 * @param {Array.<number>} handleEnds handleEnds[0] can be bigger then handleEnds[1].
 *              handleEnds will be modified in this method.
 * @param {Array.<number>} extent handleEnds is restricted by extent.
 *              extent[0] should less or equals than extent[1].
 * @param {number|string} handleIndex Can be 'all', means that both move the two handleEnds.
 * @param {number} [minSpan] The range of dataZoom can not be smaller than that.
 *              If not set, handle0 and cross handle1. If set as a non-negative
 *              number (including `0`), handles will push each other when reaching
 *              the minSpan.
 * @param {number} [maxSpan] The range of dataZoom can not be larger than that.
 * @return {Array.<number>} The input handleEnds.
 */ function $1d1b44fc5f576d07$var$_default(delta, handleEnds, extent, handleIndex, minSpan, maxSpan) {
    delta = delta || 0;
    var extentSpan = extent[1] - extent[0]; // Notice maxSpan and minSpan can be null/undefined.
    if (minSpan != null) minSpan = $1d1b44fc5f576d07$var$restrict(minSpan, [
        0,
        extentSpan
    ]);
    if (maxSpan != null) maxSpan = Math.max(maxSpan, minSpan != null ? minSpan : 0);
    if (handleIndex === "all") {
        var handleSpan = Math.abs(handleEnds[1] - handleEnds[0]);
        handleSpan = $1d1b44fc5f576d07$var$restrict(handleSpan, [
            0,
            extentSpan
        ]);
        minSpan = maxSpan = $1d1b44fc5f576d07$var$restrict(handleSpan, [
            minSpan,
            maxSpan
        ]);
        handleIndex = 0;
    }
    handleEnds[0] = $1d1b44fc5f576d07$var$restrict(handleEnds[0], extent);
    handleEnds[1] = $1d1b44fc5f576d07$var$restrict(handleEnds[1], extent);
    var originalDistSign = $1d1b44fc5f576d07$var$getSpanSign(handleEnds, handleIndex);
    handleEnds[handleIndex] += delta; // Restrict in extent.
    var extentMinSpan = minSpan || 0;
    var realExtent = extent.slice();
    originalDistSign.sign < 0 ? realExtent[0] += extentMinSpan : realExtent[1] -= extentMinSpan;
    handleEnds[handleIndex] = $1d1b44fc5f576d07$var$restrict(handleEnds[handleIndex], realExtent); // Expand span.
    var currDistSign = $1d1b44fc5f576d07$var$getSpanSign(handleEnds, handleIndex);
    if (minSpan != null && (currDistSign.sign !== originalDistSign.sign || currDistSign.span < minSpan)) // If minSpan exists, 'cross' is forbidden.
    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + originalDistSign.sign * minSpan;
     // Shrink span.
    var currDistSign = $1d1b44fc5f576d07$var$getSpanSign(handleEnds, handleIndex);
    if (maxSpan != null && currDistSign.span > maxSpan) handleEnds[1 - handleIndex] = handleEnds[handleIndex] + currDistSign.sign * maxSpan;
    return handleEnds;
}
function $1d1b44fc5f576d07$var$getSpanSign(handleEnds, handleIndex) {
    var dist = handleEnds[handleIndex] - handleEnds[1 - handleIndex]; // If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
    // is at left of handleEnds[1] for non-cross case.
    return {
        span: Math.abs(dist),
        sign: dist > 0 ? -1 : dist < 0 ? 1 : handleIndex ? -1 : 1
    };
}
function $1d1b44fc5f576d07$var$restrict(value, extend) {
    return Math.min(extend[1] != null ? extend[1] : Infinity, Math.max(extend[0] != null ? extend[0] : -Infinity, value));
}
$1d1b44fc5f576d07$exports = $1d1b44fc5f576d07$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parallel Coordinates
 * <https://en.wikipedia.org/wiki/Parallel_coordinates>
 */ var $8f90b1743422ad78$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $8f90b1743422ad78$var$mathMin = Math.min;
var $8f90b1743422ad78$var$mathMax = Math.max;
var $8f90b1743422ad78$var$mathFloor = Math.floor;
var $8f90b1743422ad78$var$mathCeil = Math.ceil;
var $8f90b1743422ad78$var$round = $2d742dbe7f960d8c$export$2077e0241d6afd3c;
var $8f90b1743422ad78$var$PI = Math.PI;
function $8f90b1743422ad78$var$Parallel(parallelModel, ecModel, api) {
    /**
   * key: dimension
   * @type {Object.<string, module:echarts/coord/parallel/Axis>}
   * @private
   */ this._axesMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4();
    /**
   * key: dimension
   * value: {position: [], rotation, }
   * @type {Object.<string, Object>}
   * @private
   */ this._axesLayout = {};
    /**
   * Always follow axis order.
   * @type {Array.<string>}
   * @readOnly
   */ this.dimensions = parallelModel.dimensions;
    /**
   * @type {module:zrender/core/BoundingRect}
   */ this._rect;
    /**
   * @type {module:echarts/coord/parallel/ParallelModel}
   */ this._model = parallelModel;
    this._init(parallelModel, ecModel, api);
}
$8f90b1743422ad78$var$Parallel.prototype = {
    type: "parallel",
    constructor: $8f90b1743422ad78$var$Parallel,
    /**
   * Initialize cartesian coordinate systems
   * @private
   */ _init: function(parallelModel, ecModel, api) {
        var dimensions = parallelModel.dimensions;
        var parallelAxisIndex = parallelModel.parallelAxisIndex;
        $8f90b1743422ad78$var$each(dimensions, function(dim, idx) {
            var axisIndex = parallelAxisIndex[idx];
            var axisModel = ecModel.getComponent("parallelAxis", axisIndex);
            var axis = this._axesMap.set(dim, new $5cf9c9d9bb4e2db1$exports(dim, $13542623aa20eeae$export$8941c4cacdc8f5a5(axisModel), [
                0,
                0
            ], axisModel.get("type"), axisIndex));
            var isCategory = axis.type === "category";
            axis.onBand = isCategory && axisModel.get("boundaryGap");
            axis.inverse = axisModel.get("inverse"); // Injection
            axisModel.axis = axis;
            axis.model = axisModel;
            axis.coordinateSystem = axisModel.coordinateSystem = this;
        }, this);
    },
    /**
   * Update axis scale after data processed
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */ update: function(ecModel, api) {
        this._updateAxesFromSeries(this._model, ecModel);
    },
    /**
   * @override
   */ containPoint: function(point) {
        var layoutInfo = this._makeLayoutInfo();
        var axisBase = layoutInfo.axisBase;
        var layoutBase = layoutInfo.layoutBase;
        var pixelDimIndex = layoutInfo.pixelDimIndex;
        var pAxis = point[1 - pixelDimIndex];
        var pLayout = point[pixelDimIndex];
        return pAxis >= axisBase && pAxis <= axisBase + layoutInfo.axisLength && pLayout >= layoutBase && pLayout <= layoutBase + layoutInfo.layoutLength;
    },
    getModel: function() {
        return this._model;
    },
    /**
   * Update properties from series
   * @private
   */ _updateAxesFromSeries: function(parallelModel, ecModel) {
        ecModel.eachSeries(function(seriesModel) {
            if (!parallelModel.contains(seriesModel, ecModel)) return;
            var data = seriesModel.getData();
            $8f90b1743422ad78$var$each(this.dimensions, function(dim) {
                var axis = this._axesMap.get(dim);
                axis.scale.unionExtentFromData(data, data.mapDimension(dim));
                $13542623aa20eeae$export$51f3e70a54405d5a(axis.scale, axis.model);
            }, this);
        }, this);
    },
    /**
   * Resize the parallel coordinate system.
   * @param {module:echarts/coord/parallel/ParallelModel} parallelModel
   * @param {module:echarts/ExtensionAPI} api
   */ resize: function(parallelModel, api) {
        this._rect = $ab0c9086dd6c5b39$export$4517a5ca639a7293(parallelModel.getBoxLayoutParams(), {
            width: api.getWidth(),
            height: api.getHeight()
        });
        this._layoutAxes();
    },
    /**
   * @return {module:zrender/core/BoundingRect}
   */ getRect: function() {
        return this._rect;
    },
    /**
   * @private
   */ _makeLayoutInfo: function() {
        var parallelModel = this._model;
        var rect = this._rect;
        var xy = [
            "x",
            "y"
        ];
        var wh = [
            "width",
            "height"
        ];
        var layout = parallelModel.get("layout");
        var pixelDimIndex = layout === "horizontal" ? 0 : 1;
        var layoutLength = rect[wh[pixelDimIndex]];
        var layoutExtent = [
            0,
            layoutLength
        ];
        var axisCount = this.dimensions.length;
        var axisExpandWidth = $8f90b1743422ad78$var$restrict(parallelModel.get("axisExpandWidth"), layoutExtent);
        var axisExpandCount = $8f90b1743422ad78$var$restrict(parallelModel.get("axisExpandCount") || 0, [
            0,
            axisCount
        ]);
        var axisExpandable = parallelModel.get("axisExpandable") && axisCount > 3 && axisCount > axisExpandCount && axisExpandCount > 1 && axisExpandWidth > 0 && layoutLength > 0; // `axisExpandWindow` is According to the coordinates of [0, axisExpandLength],
        // for sake of consider the case that axisCollapseWidth is 0 (when screen is narrow),
        // where collapsed axes should be overlapped.
        var axisExpandWindow = parallelModel.get("axisExpandWindow");
        var winSize;
        if (!axisExpandWindow) {
            winSize = $8f90b1743422ad78$var$restrict(axisExpandWidth * (axisExpandCount - 1), layoutExtent);
            var axisExpandCenter = parallelModel.get("axisExpandCenter") || $8f90b1743422ad78$var$mathFloor(axisCount / 2);
            axisExpandWindow = [
                axisExpandWidth * axisExpandCenter - winSize / 2
            ];
            axisExpandWindow[1] = axisExpandWindow[0] + winSize;
        } else {
            winSize = $8f90b1743422ad78$var$restrict(axisExpandWindow[1] - axisExpandWindow[0], layoutExtent);
            axisExpandWindow[1] = axisExpandWindow[0] + winSize;
        }
        var axisCollapseWidth = (layoutLength - winSize) / (axisCount - axisExpandCount); // Avoid axisCollapseWidth is too small.
        axisCollapseWidth < 3 && (axisCollapseWidth = 0); // Find the first and last indices > ewin[0] and < ewin[1].
        var winInnerIndices = [
            $8f90b1743422ad78$var$mathFloor($8f90b1743422ad78$var$round(axisExpandWindow[0] / axisExpandWidth, 1)) + 1,
            $8f90b1743422ad78$var$mathCeil($8f90b1743422ad78$var$round(axisExpandWindow[1] / axisExpandWidth, 1)) - 1
        ]; // Pos in ec coordinates.
        var axisExpandWindow0Pos = axisCollapseWidth / axisExpandWidth * axisExpandWindow[0];
        return {
            layout: layout,
            pixelDimIndex: pixelDimIndex,
            layoutBase: rect[xy[pixelDimIndex]],
            layoutLength: layoutLength,
            axisBase: rect[xy[1 - pixelDimIndex]],
            axisLength: rect[wh[1 - pixelDimIndex]],
            axisExpandable: axisExpandable,
            axisExpandWidth: axisExpandWidth,
            axisCollapseWidth: axisCollapseWidth,
            axisExpandWindow: axisExpandWindow,
            axisCount: axisCount,
            winInnerIndices: winInnerIndices,
            axisExpandWindow0Pos: axisExpandWindow0Pos
        };
    },
    /**
   * @private
   */ _layoutAxes: function() {
        var rect = this._rect;
        var axes = this._axesMap;
        var dimensions = this.dimensions;
        var layoutInfo = this._makeLayoutInfo();
        var layout = layoutInfo.layout;
        axes.each(function(axis) {
            var axisExtent = [
                0,
                layoutInfo.axisLength
            ];
            var idx = axis.inverse ? 1 : 0;
            axis.setExtent(axisExtent[idx], axisExtent[1 - idx]);
        });
        $8f90b1743422ad78$var$each(dimensions, function(dim, idx) {
            var posInfo = (layoutInfo.axisExpandable ? $8f90b1743422ad78$var$layoutAxisWithExpand : $8f90b1743422ad78$var$layoutAxisWithoutExpand)(idx, layoutInfo);
            var positionTable = {
                horizontal: {
                    x: posInfo.position,
                    y: layoutInfo.axisLength
                },
                vertical: {
                    x: 0,
                    y: posInfo.position
                }
            };
            var rotationTable = {
                horizontal: $8f90b1743422ad78$var$PI / 2,
                vertical: 0
            };
            var position = [
                positionTable[layout].x + rect.x,
                positionTable[layout].y + rect.y
            ];
            var rotation = rotationTable[layout];
            var transform = $6c6dd9610ba660f0$export$185802fd694ee1f5();
            $6c6dd9610ba660f0$export$bb628a54ab399bc9(transform, transform, rotation);
            $6c6dd9610ba660f0$export$d73ee8ef04f5226a(transform, transform, position); // TODO
            // tick等排布信息。
            // TODO
            // 根据axis order 更新 dimensions顺序。
            this._axesLayout[dim] = {
                position: position,
                rotation: rotation,
                transform: transform,
                axisNameAvailableWidth: posInfo.axisNameAvailableWidth,
                axisLabelShow: posInfo.axisLabelShow,
                nameTruncateMaxWidth: posInfo.nameTruncateMaxWidth,
                tickDirection: 1,
                labelDirection: 1
            };
        }, this);
    },
    /**
   * Get axis by dim.
   * @param {string} dim
   * @return {module:echarts/coord/parallel/ParallelAxis} [description]
   */ getAxis: function(dim) {
        return this._axesMap.get(dim);
    },
    /**
   * Convert a dim value of a single item of series data to Point.
   * @param {*} value
   * @param {string} dim
   * @return {Array}
   */ dataToPoint: function(value, dim) {
        return this.axisCoordToPoint(this._axesMap.get(dim).dataToCoord(value), dim);
    },
    /**
   * Travel data for one time, get activeState of each data item.
   * @param {module:echarts/data/List} data
   * @param {Functio} cb param: {string} activeState 'active' or 'inactive' or 'normal'
   *                            {number} dataIndex
   * @param {number} [start=0] the start dataIndex that travel from.
   * @param {number} [end=data.count()] the next dataIndex of the last dataIndex will be travel.
   */ eachActiveState: function(data, callback, start, end) {
        start == null && (start = 0);
        end == null && (end = data.count());
        var axesMap = this._axesMap;
        var dimensions = this.dimensions;
        var dataDimensions = [];
        var axisModels = [];
        $ec279652dd95c27b$export$79b2f7037acddd43(dimensions, function(axisDim) {
            dataDimensions.push(data.mapDimension(axisDim));
            axisModels.push(axesMap.get(axisDim).model);
        });
        var hasActiveSet = this.hasAxisBrushed();
        for(var dataIndex = start; dataIndex < end; dataIndex++){
            var activeState;
            if (!hasActiveSet) activeState = "normal";
            else {
                activeState = "active";
                var values = data.getValues(dataDimensions, dataIndex);
                for(var j = 0, lenj = dimensions.length; j < lenj; j++){
                    var state = axisModels[j].getActiveState(values[j]);
                    if (state === "inactive") {
                        activeState = "inactive";
                        break;
                    }
                }
            }
            callback(activeState, dataIndex);
        }
    },
    /**
   * Whether has any activeSet.
   * @return {boolean}
   */ hasAxisBrushed: function() {
        var dimensions = this.dimensions;
        var axesMap = this._axesMap;
        var hasActiveSet = false;
        for(var j = 0, lenj = dimensions.length; j < lenj; j++)if (axesMap.get(dimensions[j]).model.getActiveState() !== "normal") hasActiveSet = true;
        return hasActiveSet;
    },
    /**
   * Convert coords of each axis to Point.
   *  Return point. For example: [10, 20]
   * @param {Array.<number>} coords
   * @param {string} dim
   * @return {Array.<number>}
   */ axisCoordToPoint: function(coord, dim) {
        var axisLayout = this._axesLayout[dim];
        return $4b57d6b582d579b7$export$9f9dcb98c894b623([
            coord,
            0
        ], axisLayout.transform);
    },
    /**
   * Get axis layout.
   */ getAxisLayout: function(dim) {
        return $ec279652dd95c27b$export$9cd59f9826255e47(this._axesLayout[dim]);
    },
    /**
   * @param {Array.<number>} point
   * @return {Object} {axisExpandWindow, delta, behavior: 'jump' | 'slide' | 'none'}.
   */ getSlidedAxisExpandWindow: function(point) {
        var layoutInfo = this._makeLayoutInfo();
        var pixelDimIndex = layoutInfo.pixelDimIndex;
        var axisExpandWindow = layoutInfo.axisExpandWindow.slice();
        var winSize = axisExpandWindow[1] - axisExpandWindow[0];
        var extent = [
            0,
            layoutInfo.axisExpandWidth * (layoutInfo.axisCount - 1)
        ]; // Out of the area of coordinate system.
        if (!this.containPoint(point)) return {
            behavior: "none",
            axisExpandWindow: axisExpandWindow
        };
         // Conver the point from global to expand coordinates.
        var pointCoord = point[pixelDimIndex] - layoutInfo.layoutBase - layoutInfo.axisExpandWindow0Pos; // For dragging operation convenience, the window should not be
        // slided when mouse is the center area of the window.
        var delta;
        var behavior = "slide";
        var axisCollapseWidth = layoutInfo.axisCollapseWidth;
        var triggerArea = this._model.get("axisExpandSlideTriggerArea"); // But consider touch device, jump is necessary.
        var useJump = triggerArea[0] != null;
        if (axisCollapseWidth) {
            if (useJump && axisCollapseWidth && pointCoord < winSize * triggerArea[0]) {
                behavior = "jump";
                delta = pointCoord - winSize * triggerArea[2];
            } else if (useJump && axisCollapseWidth && pointCoord > winSize * (1 - triggerArea[0])) {
                behavior = "jump";
                delta = pointCoord - winSize * (1 - triggerArea[2]);
            } else (delta = pointCoord - winSize * triggerArea[1]) >= 0 && (delta = pointCoord - winSize * (1 - triggerArea[1])) <= 0 && (delta = 0);
            delta *= layoutInfo.axisExpandWidth / axisCollapseWidth;
            delta ? $1d1b44fc5f576d07$exports(delta, axisExpandWindow, extent, "all") // Avoid nonsense triger on mousemove.
             : behavior = "none";
        } else {
            var winSize = axisExpandWindow[1] - axisExpandWindow[0];
            var pos = extent[1] * pointCoord / winSize;
            axisExpandWindow = [
                $8f90b1743422ad78$var$mathMax(0, pos - winSize / 2)
            ];
            axisExpandWindow[1] = $8f90b1743422ad78$var$mathMin(extent[1], axisExpandWindow[0] + winSize);
            axisExpandWindow[0] = axisExpandWindow[1] - winSize;
        }
        return {
            axisExpandWindow: axisExpandWindow,
            behavior: behavior
        };
    }
};
function $8f90b1743422ad78$var$restrict(len, extent) {
    return $8f90b1743422ad78$var$mathMin($8f90b1743422ad78$var$mathMax(len, extent[0]), extent[1]);
}
function $8f90b1743422ad78$var$layoutAxisWithoutExpand(axisIndex, layoutInfo) {
    var step = layoutInfo.layoutLength / (layoutInfo.axisCount - 1);
    return {
        position: step * axisIndex,
        axisNameAvailableWidth: step,
        axisLabelShow: true
    };
}
function $8f90b1743422ad78$var$layoutAxisWithExpand(axisIndex, layoutInfo) {
    var layoutLength = layoutInfo.layoutLength;
    var axisExpandWidth = layoutInfo.axisExpandWidth;
    var axisCount = layoutInfo.axisCount;
    var axisCollapseWidth = layoutInfo.axisCollapseWidth;
    var winInnerIndices = layoutInfo.winInnerIndices;
    var position;
    var axisNameAvailableWidth = axisCollapseWidth;
    var axisLabelShow = false;
    var nameTruncateMaxWidth;
    if (axisIndex < winInnerIndices[0]) {
        position = axisIndex * axisCollapseWidth;
        nameTruncateMaxWidth = axisCollapseWidth;
    } else if (axisIndex <= winInnerIndices[1]) {
        position = layoutInfo.axisExpandWindow0Pos + axisIndex * axisExpandWidth - layoutInfo.axisExpandWindow[0];
        axisNameAvailableWidth = axisExpandWidth;
        axisLabelShow = true;
    } else {
        position = layoutLength - (axisCount - 1 - axisIndex) * axisCollapseWidth;
        nameTruncateMaxWidth = axisCollapseWidth;
    }
    return {
        position: position,
        axisNameAvailableWidth: axisNameAvailableWidth,
        axisLabelShow: axisLabelShow,
        nameTruncateMaxWidth: nameTruncateMaxWidth
    };
}
var $8f90b1743422ad78$var$_default = $8f90b1743422ad78$var$Parallel;
$8f90b1743422ad78$exports = $8f90b1743422ad78$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parallel coordinate system creater.
 */ function $92f856b7a5a65b23$var$create(ecModel, api) {
    var coordSysList = [];
    ecModel.eachComponent("parallel", function(parallelModel, idx) {
        var coordSys = new $8f90b1743422ad78$exports(parallelModel, ecModel, api);
        coordSys.name = "parallel_" + idx;
        coordSys.resize(parallelModel, api);
        parallelModel.coordinateSystem = coordSys;
        coordSys.model = parallelModel;
        coordSysList.push(coordSys);
    }); // Inject the coordinateSystems into seriesModel
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.get("coordinateSystem") === "parallel") {
            var parallelModel = ecModel.queryComponents({
                mainType: "parallel",
                index: seriesModel.get("parallelIndex"),
                id: seriesModel.get("parallelId")
            })[0];
            seriesModel.coordinateSystem = parallelModel.coordinateSystem;
        }
    });
    return coordSysList;
}
$9c36d0fff3b0f387$exports.register("parallel", {
    create: $92f856b7a5a65b23$var$create
});


var $f269f1dcc243ea93$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $c0924d36bf3b3fcb$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $c0924d36bf3b3fcb$var$AxisModel = $3b9c2389e45dfb7d$exports.extend({
    type: "baseParallelAxis",
    /**
   * @type {module:echarts/coord/parallel/Axis}
   */ axis: null,
    /**
   * @type {Array.<Array.<number>}
   * @readOnly
   */ activeIntervals: [],
    /**
   * @return {Object}
   */ getAreaSelectStyle: function() {
        return $d701679ba7a46009$exports([
            [
                "fill",
                "color"
            ],
            [
                "lineWidth",
                "borderWidth"
            ],
            [
                "stroke",
                "borderColor"
            ],
            [
                "width",
                "width"
            ],
            [
                "opacity",
                "opacity"
            ]
        ])(this.getModel("areaSelectStyle"));
    },
    /**
   * The code of this feature is put on AxisModel but not ParallelAxis,
   * because axisModel can be alive after echarts updating but instance of
   * ParallelAxis having been disposed. this._activeInterval should be kept
   * when action dispatched (i.e. legend click).
   *
   * @param {Array.<Array<number>>} intervals interval.length === 0
   *                                          means set all active.
   * @public
   */ setActiveIntervals: function(intervals) {
        var activeIntervals = this.activeIntervals = $ec279652dd95c27b$export$9cd59f9826255e47(intervals); // Normalize
        if (activeIntervals) for(var i = activeIntervals.length - 1; i >= 0; i--)$2d742dbe7f960d8c$export$debe6e778e0a6d32(activeIntervals[i]);
    },
    /**
   * @param {number|string} [value] When attempting to detect 'no activeIntervals set',
   *                         value can not be input.
   * @return {string} 'normal': no activeIntervals set,
   *                  'active',
   *                  'inactive'.
   * @public
   */ getActiveState: function(value) {
        var activeIntervals = this.activeIntervals;
        if (!activeIntervals.length) return "normal";
        if (value == null || isNaN(value)) return "inactive";
         // Simple optimization
        if (activeIntervals.length === 1) {
            var interval = activeIntervals[0];
            if (interval[0] <= value && value <= interval[1]) return "active";
        } else for(var i = 0, len = activeIntervals.length; i < len; i++){
            if (activeIntervals[i][0] <= value && value <= activeIntervals[i][1]) return "active";
        }
        return "inactive";
    }
});
var $c0924d36bf3b3fcb$var$defaultOption = {
    type: "value",
    /**
   * @type {Array.<number>}
   */ dim: null,
    // 0, 1, 2, ...
    // parallelIndex: null,
    areaSelectStyle: {
        width: 20,
        borderWidth: 1,
        borderColor: "rgba(160,197,232)",
        color: "rgba(160,197,232)",
        opacity: 0.3
    },
    realtime: true,
    // Whether realtime update view when select.
    z: 10
};
$ec279652dd95c27b$export$4950aa0f605343fb($c0924d36bf3b3fcb$var$AxisModel.prototype, $ce1d0648e3723c9f$exports);
function $c0924d36bf3b3fcb$var$getAxisType(axisName, option) {
    return option.type || (option.data ? "category" : "value");
}
$b94fd69108c44724$exports("parallel", $c0924d36bf3b3fcb$var$AxisModel, $c0924d36bf3b3fcb$var$getAxisType, $c0924d36bf3b3fcb$var$defaultOption);
var $c0924d36bf3b3fcb$var$_default = $c0924d36bf3b3fcb$var$AxisModel;
$c0924d36bf3b3fcb$exports = $c0924d36bf3b3fcb$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $f269f1dcc243ea93$var$_default = $3b9c2389e45dfb7d$exports.extend({
    type: "parallel",
    dependencies: [
        "parallelAxis"
    ],
    /**
   * @type {module:echarts/coord/parallel/Parallel}
   */ coordinateSystem: null,
    /**
   * Each item like: 'dim0', 'dim1', 'dim2', ...
   * @type {Array.<string>}
   * @readOnly
   */ dimensions: null,
    /**
   * Coresponding to dimensions.
   * @type {Array.<number>}
   * @readOnly
   */ parallelAxisIndex: null,
    layoutMode: "box",
    defaultOption: {
        zlevel: 0,
        z: 0,
        left: 80,
        top: 60,
        right: 80,
        bottom: 60,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        layout: "horizontal",
        // 'horizontal' or 'vertical'
        // FIXME
        // naming?
        axisExpandable: false,
        axisExpandCenter: null,
        axisExpandCount: 0,
        axisExpandWidth: 50,
        // FIXME '10%' ?
        axisExpandRate: 17,
        axisExpandDebounce: 50,
        // [out, in, jumpTarget]. In percentage. If use [null, 0.05], null means full.
        // Do not doc to user until necessary.
        axisExpandSlideTriggerArea: [
            -0.15,
            0.05,
            0.4
        ],
        axisExpandTriggerOn: "click",
        // 'mousemove' or 'click'
        parallelAxisDefault: null
    },
    /**
   * @override
   */ init: function() {
        $3b9c2389e45dfb7d$exports.prototype.init.apply(this, arguments);
        this.mergeOption({});
    },
    /**
   * @override
   */ mergeOption: function(newOption) {
        var thisOption = this.option;
        newOption && $ec279652dd95c27b$export$4950aa0f605343fb(thisOption, newOption, true);
        this._initDimensions();
    },
    /**
   * Whether series or axis is in this coordinate system.
   * @param {module:echarts/model/Series|module:echarts/coord/parallel/AxisModel} model
   * @param {module:echarts/model/Global} ecModel
   */ contains: function(model, ecModel) {
        var parallelIndex = model.get("parallelIndex");
        return parallelIndex != null && ecModel.getComponent("parallel", parallelIndex) === this;
    },
    setAxisExpand: function(opt) {
        $ec279652dd95c27b$export$79b2f7037acddd43([
            "axisExpandable",
            "axisExpandCenter",
            "axisExpandCount",
            "axisExpandWidth",
            "axisExpandWindow"
        ], function(name) {
            if (opt.hasOwnProperty(name)) this.option[name] = opt[name];
        }, this);
    },
    /**
   * @private
   */ _initDimensions: function() {
        var dimensions = this.dimensions = [];
        var parallelAxisIndex = this.parallelAxisIndex = [];
        var axisModels = $ec279652dd95c27b$export$3dea766d36a8935f(this.dependentModels.parallelAxis, function(axisModel) {
            // Can not use this.contains here, because
            // initialization has not been completed yet.
            return (axisModel.get("parallelIndex") || 0) === this.componentIndex;
        }, this);
        $ec279652dd95c27b$export$79b2f7037acddd43(axisModels, function(axisModel) {
            dimensions.push("dim" + axisModel.get("dim"));
            parallelAxisIndex.push(axisModel.componentIndex);
        });
    }
});
$f269f1dcc243ea93$exports = $f269f1dcc243ea93$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @payload
 * @property {string} parallelAxisId
 * @property {Array.<Array.<number>>} intervals
 */ var $efc21b4973c87a6a$var$actionInfo = {
    type: "axisAreaSelect",
    event: "axisAreaSelected" // update: 'updateVisual'
};
$f406636b535430a7$exports.registerAction($efc21b4973c87a6a$var$actionInfo, function(payload, ecModel) {
    ecModel.eachComponent({
        mainType: "parallelAxis",
        query: payload
    }, function(parallelAxisModel) {
        parallelAxisModel.axis.model.setActiveIntervals(payload.intervals);
    });
});
/**
 * @payload
 */ $f406636b535430a7$exports.registerAction("parallelAxisExpand", function(payload, ecModel) {
    ecModel.eachComponent({
        mainType: "parallel",
        query: payload
    }, function(parallelModel) {
        parallelModel.setAxisExpand(payload);
    });
});


var $40f9599448f8fe0a$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $32947641224f901a$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $32947641224f901a$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $32947641224f901a$var$curry = $ec279652dd95c27b$export$c3095a23b368d1f2;
var $32947641224f901a$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $32947641224f901a$var$map = $ec279652dd95c27b$export$871de8747c9eaa88;
var $32947641224f901a$var$mathMin = Math.min;
var $32947641224f901a$var$mathMax = Math.max;
var $32947641224f901a$var$mathPow = Math.pow;
var $32947641224f901a$var$COVER_Z = 10000;
var $32947641224f901a$var$UNSELECT_THRESHOLD = 6;
var $32947641224f901a$var$MIN_RESIZE_LINE_WIDTH = 6;
var $32947641224f901a$var$MUTEX_RESOURCE_KEY = "globalPan";
var $32947641224f901a$var$DIRECTION_MAP = {
    w: [
        0,
        0
    ],
    e: [
        0,
        1
    ],
    n: [
        1,
        0
    ],
    s: [
        1,
        1
    ]
};
var $32947641224f901a$var$CURSOR_MAP = {
    w: "ew",
    e: "ew",
    n: "ns",
    s: "ns",
    ne: "nesw",
    sw: "nesw",
    nw: "nwse",
    se: "nwse"
};
var $32947641224f901a$var$DEFAULT_BRUSH_OPT = {
    brushStyle: {
        lineWidth: 2,
        stroke: "rgba(0,0,0,0.3)",
        fill: "rgba(0,0,0,0.1)"
    },
    transformable: true,
    brushMode: "single",
    removeOnClick: false
};
var $32947641224f901a$var$baseUID = 0;
/**
 * @alias module:echarts/component/helper/BrushController
 * @constructor
 * @mixin {module:zrender/mixin/Eventful}
 * @event module:echarts/component/helper/BrushController#brush
 *        params:
 *            areas: Array.<Array>, coord relates to container group,
 *                                    If no container specified, to global.
 *            opt {
 *                isEnd: boolean,
 *                removeOnClick: boolean
 *            }
 *
 * @param {module:zrender/zrender~ZRender} zr
 */ function $32947641224f901a$var$BrushController(zr) {
    $b7a44647f5b5bfa5$exports.call(this);
    /**
   * @type {module:zrender/zrender~ZRender}
   * @private
   */ this._zr = zr;
    /**
   * @type {module:zrender/container/Group}
   * @readOnly
   */ this.group = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
    /**
   * Only for drawing (after enabledBrush).
   *     'line', 'rect', 'polygon' or false
   *     If passing false/null/undefined, disable brush.
   *     If passing 'auto', determined by panel.defaultBrushType
   * @private
   * @type {string}
   */ this._brushType;
    /**
   * Only for drawing (after enabledBrush).
   *
   * @private
   * @type {Object}
   */ this._brushOption;
    /**
   * @private
   * @type {Object}
   */ this._panels;
    /**
   * @private
   * @type {Array.<nubmer>}
   */ this._track = [];
    /**
   * @private
   * @type {boolean}
   */ this._dragging;
    /**
   * @private
   * @type {Array}
   */ this._covers = [];
    /**
   * @private
   * @type {moudule:zrender/container/Group}
   */ this._creatingCover;
    /**
   * `true` means global panel
   * @private
   * @type {module:zrender/container/Group|boolean}
   */ this._creatingPanel;
    /**
   * @private
   * @type {boolean}
   */ this._enableGlobalPan;
    /**
   * @private
   * @type {boolean}
   */ /**
   * @private
   * @type {string}
   */ this._uid = "brushController_" + $32947641224f901a$var$baseUID++;
    /**
   * @private
   * @type {Object}
   */ this._handlers = {};
    $32947641224f901a$var$each($32947641224f901a$var$pointerHandlers, function(handler, eventName) {
        this._handlers[eventName] = $ec279652dd95c27b$export$2385a24977818dd0(handler, this);
    }, this);
}
$32947641224f901a$var$BrushController.prototype = {
    constructor: $32947641224f901a$var$BrushController,
    /**
   * If set to null/undefined/false, select disabled.
   * @param {Object} brushOption
   * @param {string|boolean} brushOption.brushType 'line', 'rect', 'polygon' or false
   *                          If passing false/null/undefined, disable brush.
   *                          If passing 'auto', determined by panel.defaultBrushType.
   *                              ('auto' can not be used in global panel)
   * @param {number} [brushOption.brushMode='single'] 'single' or 'multiple'
   * @param {boolean} [brushOption.transformable=true]
   * @param {boolean} [brushOption.removeOnClick=false]
   * @param {Object} [brushOption.brushStyle]
   * @param {number} [brushOption.brushStyle.width]
   * @param {number} [brushOption.brushStyle.lineWidth]
   * @param {string} [brushOption.brushStyle.stroke]
   * @param {string} [brushOption.brushStyle.fill]
   * @param {number} [brushOption.z]
   */ enableBrush: function(brushOption) {
        this._brushType && $32947641224f901a$var$doDisableBrush(this);
        brushOption.brushType && $32947641224f901a$var$doEnableBrush(this, brushOption);
        return this;
    },
    /**
   * @param {Array.<Object>} panelOpts If not pass, it is global brush.
   *        Each items: {
   *            panelId, // mandatory.
   *            clipPath, // mandatory. function.
   *            isTargetByCursor, // mandatory. function.
   *            defaultBrushType, // optional, only used when brushType is 'auto'.
   *            getLinearBrushOtherExtent, // optional. function.
   *        }
   */ setPanels: function(panelOpts) {
        if (panelOpts && panelOpts.length) {
            var panels = this._panels = {};
            $ec279652dd95c27b$export$79b2f7037acddd43(panelOpts, function(panelOpts) {
                panels[panelOpts.panelId] = $ec279652dd95c27b$export$9cd59f9826255e47(panelOpts);
            });
        } else this._panels = null;
        return this;
    },
    /**
   * @param {Object} [opt]
   * @return {boolean} [opt.enableGlobalPan=false]
   */ mount: function(opt) {
        opt = opt || {};
        this._enableGlobalPan = opt.enableGlobalPan;
        var thisGroup = this.group;
        this._zr.add(thisGroup);
        thisGroup.attr({
            position: opt.position || [
                0,
                0
            ],
            rotation: opt.rotation || 0,
            scale: opt.scale || [
                1,
                1
            ]
        });
        this._transform = thisGroup.getLocalTransform();
        return this;
    },
    eachCover: function(cb, context) {
        $32947641224f901a$var$each(this._covers, cb, context);
    },
    /**
   * Update covers.
   * @param {Array.<Object>} brushOptionList Like:
   *        [
   *            {id: 'xx', brushType: 'line', range: [23, 44], brushStyle, transformable},
   *            {id: 'yy', brushType: 'rect', range: [[23, 44], [23, 54]]},
   *            ...
   *        ]
   *        `brushType` is required in each cover info. (can not be 'auto')
   *        `id` is not mandatory.
   *        `brushStyle`, `transformable` is not mandatory, use DEFAULT_BRUSH_OPT by default.
   *        If brushOptionList is null/undefined, all covers removed.
   */ updateCovers: function(brushOptionList) {
        brushOptionList = $ec279652dd95c27b$export$871de8747c9eaa88(brushOptionList, function(brushOption) {
            return $ec279652dd95c27b$export$4950aa0f605343fb($ec279652dd95c27b$export$9cd59f9826255e47($32947641224f901a$var$DEFAULT_BRUSH_OPT), brushOption, true);
        });
        var tmpIdPrefix = "\x00-brush-index-";
        var oldCovers = this._covers;
        var newCovers = this._covers = [];
        var controller = this;
        var creatingCover = this._creatingCover;
        new $8e5cd4a27af1b00f$exports(oldCovers, brushOptionList, oldGetKey, getKey).add(addOrUpdate).update(addOrUpdate).remove(remove).execute();
        return this;
        function getKey(brushOption, index) {
            return (brushOption.id != null ? brushOption.id : tmpIdPrefix + index) + "-" + brushOption.brushType;
        }
        function oldGetKey(cover, index) {
            return getKey(cover.__brushOption, index);
        }
        function addOrUpdate(newIndex, oldIndex) {
            var newBrushOption = brushOptionList[newIndex]; // Consider setOption in event listener of brushSelect,
            // where updating cover when creating should be forbiden.
            if (oldIndex != null && oldCovers[oldIndex] === creatingCover) newCovers[newIndex] = oldCovers[oldIndex];
            else {
                var cover = newCovers[newIndex] = oldIndex != null ? (oldCovers[oldIndex].__brushOption = newBrushOption, oldCovers[oldIndex]) : $32947641224f901a$var$endCreating(controller, $32947641224f901a$var$createCover(controller, newBrushOption));
                $32947641224f901a$var$updateCoverAfterCreation(controller, cover);
            }
        }
        function remove(oldIndex) {
            if (oldCovers[oldIndex] !== creatingCover) controller.group.remove(oldCovers[oldIndex]);
        }
    },
    unmount: function() {
        this.enableBrush(false); // container may 'removeAll' outside.
        $32947641224f901a$var$clearCovers(this);
        this._zr.remove(this.group);
        return this;
    },
    dispose: function() {
        this.unmount();
        this.off();
    }
};
$ec279652dd95c27b$export$e36fc9d62a853069($32947641224f901a$var$BrushController, $b7a44647f5b5bfa5$exports);
function $32947641224f901a$var$doEnableBrush(controller, brushOption) {
    var zr = controller._zr; // Consider roam, which takes globalPan too.
    if (!controller._enableGlobalPan) $3e7ee0b67ffa0477$export$b7df5d561049483a(zr, $32947641224f901a$var$MUTEX_RESOURCE_KEY, controller._uid);
    $32947641224f901a$var$mountHandlers(zr, controller._handlers);
    controller._brushType = brushOption.brushType;
    controller._brushOption = $ec279652dd95c27b$export$4950aa0f605343fb($ec279652dd95c27b$export$9cd59f9826255e47($32947641224f901a$var$DEFAULT_BRUSH_OPT), brushOption, true);
}
function $32947641224f901a$var$doDisableBrush(controller) {
    var zr = controller._zr;
    $3e7ee0b67ffa0477$export$23d3fad09dc44362(zr, $32947641224f901a$var$MUTEX_RESOURCE_KEY, controller._uid);
    $32947641224f901a$var$unmountHandlers(zr, controller._handlers);
    controller._brushType = controller._brushOption = null;
}
function $32947641224f901a$var$mountHandlers(zr, handlers) {
    $32947641224f901a$var$each(handlers, function(handler, eventName) {
        zr.on(eventName, handler);
    });
}
function $32947641224f901a$var$unmountHandlers(zr, handlers) {
    $32947641224f901a$var$each(handlers, function(handler, eventName) {
        zr.off(eventName, handler);
    });
}
function $32947641224f901a$var$createCover(controller, brushOption) {
    var cover = $32947641224f901a$var$coverRenderers[brushOption.brushType].createCover(controller, brushOption);
    cover.__brushOption = brushOption;
    $32947641224f901a$var$updateZ(cover, brushOption);
    controller.group.add(cover);
    return cover;
}
function $32947641224f901a$var$endCreating(controller, creatingCover) {
    var coverRenderer = $32947641224f901a$var$getCoverRenderer(creatingCover);
    if (coverRenderer.endCreating) {
        coverRenderer.endCreating(controller, creatingCover);
        $32947641224f901a$var$updateZ(creatingCover, creatingCover.__brushOption);
    }
    return creatingCover;
}
function $32947641224f901a$var$updateCoverShape(controller, cover) {
    var brushOption = cover.__brushOption;
    $32947641224f901a$var$getCoverRenderer(cover).updateCoverShape(controller, cover, brushOption.range, brushOption);
}
function $32947641224f901a$var$updateZ(cover, brushOption) {
    var z = brushOption.z;
    z == null && (z = $32947641224f901a$var$COVER_Z);
    cover.traverse(function(el) {
        el.z = z;
        el.z2 = z; // Consider in given container.
    });
}
function $32947641224f901a$var$updateCoverAfterCreation(controller, cover) {
    $32947641224f901a$var$getCoverRenderer(cover).updateCommon(controller, cover);
    $32947641224f901a$var$updateCoverShape(controller, cover);
}
function $32947641224f901a$var$getCoverRenderer(cover) {
    return $32947641224f901a$var$coverRenderers[cover.__brushOption.brushType];
} // return target panel or `true` (means global panel)
function $32947641224f901a$var$getPanelByPoint(controller, e, localCursorPoint) {
    var panels = controller._panels;
    if (!panels) return true; // Global panel
    var panel;
    var transform = controller._transform;
    $32947641224f901a$var$each(panels, function(pn) {
        pn.isTargetByCursor(e, localCursorPoint, transform) && (panel = pn);
    });
    return panel;
} // Return a panel or true
function $32947641224f901a$var$getPanelByCover(controller, cover) {
    var panels = controller._panels;
    if (!panels) return true; // Global panel
    var panelId = cover.__brushOption.panelId; // User may give cover without coord sys info,
    // which is then treated as global panel.
    return panelId != null ? panels[panelId] : true;
}
function $32947641224f901a$var$clearCovers(controller) {
    var covers = controller._covers;
    var originalLength = covers.length;
    $32947641224f901a$var$each(covers, function(cover) {
        controller.group.remove(cover);
    }, controller);
    covers.length = 0;
    return !!originalLength;
}
function $32947641224f901a$var$trigger(controller, opt) {
    var areas = $32947641224f901a$var$map(controller._covers, function(cover) {
        var brushOption = cover.__brushOption;
        var range = $ec279652dd95c27b$export$9cd59f9826255e47(brushOption.range);
        return {
            brushType: brushOption.brushType,
            panelId: brushOption.panelId,
            range: range
        };
    });
    controller.trigger("brush", areas, {
        isEnd: !!opt.isEnd,
        removeOnClick: !!opt.removeOnClick
    });
}
function $32947641224f901a$var$shouldShowCover(controller) {
    var track = controller._track;
    if (!track.length) return false;
    var p2 = track[track.length - 1];
    var p1 = track[0];
    var dx = p2[0] - p1[0];
    var dy = p2[1] - p1[1];
    var dist = $32947641224f901a$var$mathPow(dx * dx + dy * dy, 0.5);
    return dist > $32947641224f901a$var$UNSELECT_THRESHOLD;
}
function $32947641224f901a$var$getTrackEnds(track) {
    var tail = track.length - 1;
    tail < 0 && (tail = 0);
    return [
        track[0],
        track[tail]
    ];
}
function $32947641224f901a$var$createBaseRectCover(doDrift, controller, brushOption, edgeNames) {
    var cover = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
    cover.add(new $4b57d6b582d579b7$export$c79fc6492f3af13d({
        name: "main",
        style: $32947641224f901a$var$makeStyle(brushOption),
        silent: true,
        draggable: true,
        cursor: "move",
        drift: $32947641224f901a$var$curry(doDrift, controller, cover, "nswe"),
        ondragend: $32947641224f901a$var$curry($32947641224f901a$var$trigger, controller, {
            isEnd: true
        })
    }));
    $32947641224f901a$var$each(edgeNames, function(name) {
        cover.add(new $4b57d6b582d579b7$export$c79fc6492f3af13d({
            name: name,
            style: {
                opacity: 0
            },
            draggable: true,
            silent: true,
            invisible: true,
            drift: $32947641224f901a$var$curry(doDrift, controller, cover, name),
            ondragend: $32947641224f901a$var$curry($32947641224f901a$var$trigger, controller, {
                isEnd: true
            })
        }));
    });
    return cover;
}
function $32947641224f901a$var$updateBaseRect(controller, cover, localRange, brushOption) {
    var lineWidth = brushOption.brushStyle.lineWidth || 0;
    var handleSize = $32947641224f901a$var$mathMax(lineWidth, $32947641224f901a$var$MIN_RESIZE_LINE_WIDTH);
    var x = localRange[0][0];
    var y = localRange[1][0];
    var xa = x - lineWidth / 2;
    var ya = y - lineWidth / 2;
    var x2 = localRange[0][1];
    var y2 = localRange[1][1];
    var x2a = x2 - handleSize + lineWidth / 2;
    var y2a = y2 - handleSize + lineWidth / 2;
    var width = x2 - x;
    var height = y2 - y;
    var widtha = width + lineWidth;
    var heighta = height + lineWidth;
    $32947641224f901a$var$updateRectShape(controller, cover, "main", x, y, width, height);
    if (brushOption.transformable) {
        $32947641224f901a$var$updateRectShape(controller, cover, "w", xa, ya, handleSize, heighta);
        $32947641224f901a$var$updateRectShape(controller, cover, "e", x2a, ya, handleSize, heighta);
        $32947641224f901a$var$updateRectShape(controller, cover, "n", xa, ya, widtha, handleSize);
        $32947641224f901a$var$updateRectShape(controller, cover, "s", xa, y2a, widtha, handleSize);
        $32947641224f901a$var$updateRectShape(controller, cover, "nw", xa, ya, handleSize, handleSize);
        $32947641224f901a$var$updateRectShape(controller, cover, "ne", x2a, ya, handleSize, handleSize);
        $32947641224f901a$var$updateRectShape(controller, cover, "sw", xa, y2a, handleSize, handleSize);
        $32947641224f901a$var$updateRectShape(controller, cover, "se", x2a, y2a, handleSize, handleSize);
    }
}
function $32947641224f901a$var$updateCommon(controller, cover) {
    var brushOption = cover.__brushOption;
    var transformable = brushOption.transformable;
    var mainEl = cover.childAt(0);
    mainEl.useStyle($32947641224f901a$var$makeStyle(brushOption));
    mainEl.attr({
        silent: !transformable,
        cursor: transformable ? "move" : "default"
    });
    $32947641224f901a$var$each([
        "w",
        "e",
        "n",
        "s",
        "se",
        "sw",
        "ne",
        "nw"
    ], function(name) {
        var el = cover.childOfName(name);
        var globalDir = $32947641224f901a$var$getGlobalDirection(controller, name);
        el && el.attr({
            silent: !transformable,
            invisible: !transformable,
            cursor: transformable ? $32947641224f901a$var$CURSOR_MAP[globalDir] + "-resize" : null
        });
    });
}
function $32947641224f901a$var$updateRectShape(controller, cover, name, x, y, w, h) {
    var el = cover.childOfName(name);
    el && el.setShape($32947641224f901a$var$pointsToRect($32947641224f901a$var$clipByPanel(controller, cover, [
        [
            x,
            y
        ],
        [
            x + w,
            y + h
        ]
    ])));
}
function $32947641224f901a$var$makeStyle(brushOption) {
    return $ec279652dd95c27b$export$ebe90cb607ad99e({
        strokeNoScale: true
    }, brushOption.brushStyle);
}
function $32947641224f901a$var$formatRectRange(x, y, x2, y2) {
    var min = [
        $32947641224f901a$var$mathMin(x, x2),
        $32947641224f901a$var$mathMin(y, y2)
    ];
    var max = [
        $32947641224f901a$var$mathMax(x, x2),
        $32947641224f901a$var$mathMax(y, y2)
    ];
    return [
        [
            min[0],
            max[0]
        ],
        [
            min[1],
            max[1]
        ] // y range
    ];
}
function $32947641224f901a$var$getTransform(controller) {
    return $4b57d6b582d579b7$export$fce0c6cfca85ed96(controller.group);
}
function $32947641224f901a$var$getGlobalDirection(controller, localDirection) {
    if (localDirection.length > 1) {
        localDirection = localDirection.split("");
        var globalDir = [
            $32947641224f901a$var$getGlobalDirection(controller, localDirection[0]),
            $32947641224f901a$var$getGlobalDirection(controller, localDirection[1])
        ];
        (globalDir[0] === "e" || globalDir[0] === "w") && globalDir.reverse();
        return globalDir.join("");
    } else {
        var map = {
            w: "left",
            e: "right",
            n: "top",
            s: "bottom"
        };
        var inverseMap = {
            left: "w",
            right: "e",
            top: "n",
            bottom: "s"
        };
        var globalDir = $4b57d6b582d579b7$export$fff94e9792354cfa(map[localDirection], $32947641224f901a$var$getTransform(controller));
        return inverseMap[globalDir];
    }
}
function $32947641224f901a$var$driftRect(toRectRange, fromRectRange, controller, cover, name, dx, dy, e) {
    var brushOption = cover.__brushOption;
    var rectRange = toRectRange(brushOption.range);
    var localDelta = $32947641224f901a$var$toLocalDelta(controller, dx, dy);
    $32947641224f901a$var$each(name.split(""), function(namePart) {
        var ind = $32947641224f901a$var$DIRECTION_MAP[namePart];
        rectRange[ind[0]][ind[1]] += localDelta[ind[0]];
    });
    brushOption.range = fromRectRange($32947641224f901a$var$formatRectRange(rectRange[0][0], rectRange[1][0], rectRange[0][1], rectRange[1][1]));
    $32947641224f901a$var$updateCoverAfterCreation(controller, cover);
    $32947641224f901a$var$trigger(controller, {
        isEnd: false
    });
}
function $32947641224f901a$var$driftPolygon(controller, cover, dx, dy, e) {
    var range = cover.__brushOption.range;
    var localDelta = $32947641224f901a$var$toLocalDelta(controller, dx, dy);
    $32947641224f901a$var$each(range, function(point) {
        point[0] += localDelta[0];
        point[1] += localDelta[1];
    });
    $32947641224f901a$var$updateCoverAfterCreation(controller, cover);
    $32947641224f901a$var$trigger(controller, {
        isEnd: false
    });
}
function $32947641224f901a$var$toLocalDelta(controller, dx, dy) {
    var thisGroup = controller.group;
    var localD = thisGroup.transformCoordToLocal(dx, dy);
    var localZero = thisGroup.transformCoordToLocal(0, 0);
    return [
        localD[0] - localZero[0],
        localD[1] - localZero[1]
    ];
}
function $32947641224f901a$var$clipByPanel(controller, cover, data) {
    var panel = $32947641224f901a$var$getPanelByCover(controller, cover);
    return panel && panel !== true ? panel.clipPath(data, controller._transform) : $ec279652dd95c27b$export$9cd59f9826255e47(data);
}
function $32947641224f901a$var$pointsToRect(points) {
    var xmin = $32947641224f901a$var$mathMin(points[0][0], points[1][0]);
    var ymin = $32947641224f901a$var$mathMin(points[0][1], points[1][1]);
    var xmax = $32947641224f901a$var$mathMax(points[0][0], points[1][0]);
    var ymax = $32947641224f901a$var$mathMax(points[0][1], points[1][1]);
    return {
        x: xmin,
        y: ymin,
        width: xmax - xmin,
        height: ymax - ymin
    };
}
function $32947641224f901a$var$resetCursor(controller, e, localCursorPoint) {
    if (!controller._brushType // resetCursor should be always called when mouse is in zr area,
     || $32947641224f901a$var$isOutsideZrArea(controller, e)) return;
    var zr = controller._zr;
    var covers = controller._covers;
    var currPanel = $32947641224f901a$var$getPanelByPoint(controller, e, localCursorPoint); // Check whether in covers.
    if (!controller._dragging) for(var i = 0; i < covers.length; i++){
        var brushOption = covers[i].__brushOption;
        if (currPanel && (currPanel === true || brushOption.panelId === currPanel.panelId) && $32947641224f901a$var$coverRenderers[brushOption.brushType].contain(covers[i], localCursorPoint[0], localCursorPoint[1])) // Use cursor style set on cover.
        return;
    }
    currPanel && zr.setCursorStyle("crosshair");
}
function $32947641224f901a$var$preventDefault(e) {
    var rawE = e.event;
    rawE.preventDefault && rawE.preventDefault();
}
function $32947641224f901a$var$mainShapeContain(cover, x, y) {
    return cover.childOfName("main").contain(x, y);
}
function $32947641224f901a$var$updateCoverByMouse(controller, e, localCursorPoint, isEnd) {
    var creatingCover = controller._creatingCover;
    var panel = controller._creatingPanel;
    var thisBrushOption = controller._brushOption;
    var eventParams;
    controller._track.push(localCursorPoint.slice());
    if ($32947641224f901a$var$shouldShowCover(controller) || creatingCover) {
        if (panel && !creatingCover) {
            thisBrushOption.brushMode === "single" && $32947641224f901a$var$clearCovers(controller);
            var brushOption = $ec279652dd95c27b$export$9cd59f9826255e47(thisBrushOption);
            brushOption.brushType = $32947641224f901a$var$determineBrushType(brushOption.brushType, panel);
            brushOption.panelId = panel === true ? null : panel.panelId;
            creatingCover = controller._creatingCover = $32947641224f901a$var$createCover(controller, brushOption);
            controller._covers.push(creatingCover);
        }
        if (creatingCover) {
            var coverRenderer = $32947641224f901a$var$coverRenderers[$32947641224f901a$var$determineBrushType(controller._brushType, panel)];
            var coverBrushOption = creatingCover.__brushOption;
            coverBrushOption.range = coverRenderer.getCreatingRange($32947641224f901a$var$clipByPanel(controller, creatingCover, controller._track));
            if (isEnd) {
                $32947641224f901a$var$endCreating(controller, creatingCover);
                coverRenderer.updateCommon(controller, creatingCover);
            }
            $32947641224f901a$var$updateCoverShape(controller, creatingCover);
            eventParams = {
                isEnd: isEnd
            };
        }
    } else if (isEnd && thisBrushOption.brushMode === "single" && thisBrushOption.removeOnClick) // Help user to remove covers easily, only by a tiny drag, in 'single' mode.
    // But a single click do not clear covers, because user may have casual
    // clicks (for example, click on other component and do not expect covers
    // disappear).
    // Only some cover removed, trigger action, but not every click trigger action.
    {
        if ($32947641224f901a$var$getPanelByPoint(controller, e, localCursorPoint) && $32947641224f901a$var$clearCovers(controller)) eventParams = {
            isEnd: isEnd,
            removeOnClick: true
        };
    }
    return eventParams;
}
function $32947641224f901a$var$determineBrushType(brushType, panel) {
    if (brushType === "auto") return panel.defaultBrushType;
    return brushType;
}
var $32947641224f901a$var$pointerHandlers = {
    mousedown: function(e) {
        if (this._dragging) // In case some browser do not support globalOut,
        // and release mose out side the browser.
        $32947641224f901a$var$handleDragEnd(this, e);
        else if (!e.target || !e.target.draggable) {
            $32947641224f901a$var$preventDefault(e);
            var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
            this._creatingCover = null;
            var panel = this._creatingPanel = $32947641224f901a$var$getPanelByPoint(this, e, localCursorPoint);
            if (panel) {
                this._dragging = true;
                this._track = [
                    localCursorPoint.slice()
                ];
            }
        }
    },
    mousemove: function(e) {
        var x = e.offsetX;
        var y = e.offsetY;
        var localCursorPoint = this.group.transformCoordToLocal(x, y);
        $32947641224f901a$var$resetCursor(this, e, localCursorPoint);
        if (this._dragging) {
            $32947641224f901a$var$preventDefault(e);
            var eventParams = $32947641224f901a$var$updateCoverByMouse(this, e, localCursorPoint, false);
            eventParams && $32947641224f901a$var$trigger(this, eventParams);
        }
    },
    mouseup: function(e) {
        $32947641224f901a$var$handleDragEnd(this, e);
    }
};
function $32947641224f901a$var$handleDragEnd(controller, e) {
    if (controller._dragging) {
        $32947641224f901a$var$preventDefault(e);
        var x = e.offsetX;
        var y = e.offsetY;
        var localCursorPoint = controller.group.transformCoordToLocal(x, y);
        var eventParams = $32947641224f901a$var$updateCoverByMouse(controller, e, localCursorPoint, true);
        controller._dragging = false;
        controller._track = [];
        controller._creatingCover = null; // trigger event shoule be at final, after procedure will be nested.
        eventParams && $32947641224f901a$var$trigger(controller, eventParams);
    }
}
function $32947641224f901a$var$isOutsideZrArea(controller, x, y) {
    var zr = controller._zr;
    return x < 0 || x > zr.getWidth() || y < 0 || y > zr.getHeight();
}
/**
 * key: brushType
 * @type {Object}
 */ var $32947641224f901a$var$coverRenderers = {
    lineX: $32947641224f901a$var$getLineRenderer(0),
    lineY: $32947641224f901a$var$getLineRenderer(1),
    rect: {
        createCover: function(controller, brushOption) {
            return $32947641224f901a$var$createBaseRectCover($32947641224f901a$var$curry($32947641224f901a$var$driftRect, function(range) {
                return range;
            }, function(range) {
                return range;
            }), controller, brushOption, [
                "w",
                "e",
                "n",
                "s",
                "se",
                "sw",
                "ne",
                "nw"
            ]);
        },
        getCreatingRange: function(localTrack) {
            var ends = $32947641224f901a$var$getTrackEnds(localTrack);
            return $32947641224f901a$var$formatRectRange(ends[1][0], ends[1][1], ends[0][0], ends[0][1]);
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            $32947641224f901a$var$updateBaseRect(controller, cover, localRange, brushOption);
        },
        updateCommon: $32947641224f901a$var$updateCommon,
        contain: $32947641224f901a$var$mainShapeContain
    },
    polygon: {
        createCover: function(controller, brushOption) {
            var cover = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4(); // Do not use graphic.Polygon because graphic.Polyline do not close the
            // border of the shape when drawing, which is a better experience for user.
            cover.add(new $4b57d6b582d579b7$export$79f3ee03e63e7073({
                name: "main",
                style: $32947641224f901a$var$makeStyle(brushOption),
                silent: true
            }));
            return cover;
        },
        getCreatingRange: function(localTrack) {
            return localTrack;
        },
        endCreating: function(controller, cover) {
            cover.remove(cover.childAt(0)); // Use graphic.Polygon close the shape.
            cover.add(new $4b57d6b582d579b7$export$7d31b617c820d435({
                name: "main",
                draggable: true,
                drift: $32947641224f901a$var$curry($32947641224f901a$var$driftPolygon, controller, cover),
                ondragend: $32947641224f901a$var$curry($32947641224f901a$var$trigger, controller, {
                    isEnd: true
                })
            }));
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            cover.childAt(0).setShape({
                points: $32947641224f901a$var$clipByPanel(controller, cover, localRange)
            });
        },
        updateCommon: $32947641224f901a$var$updateCommon,
        contain: $32947641224f901a$var$mainShapeContain
    }
};
function $32947641224f901a$var$getLineRenderer(xyIndex) {
    return {
        createCover: function(controller, brushOption) {
            return $32947641224f901a$var$createBaseRectCover($32947641224f901a$var$curry($32947641224f901a$var$driftRect, function(range) {
                var rectRange = [
                    range,
                    [
                        0,
                        100
                    ]
                ];
                xyIndex && rectRange.reverse();
                return rectRange;
            }, function(rectRange) {
                return rectRange[xyIndex];
            }), controller, brushOption, [
                [
                    "w",
                    "e"
                ],
                [
                    "n",
                    "s"
                ]
            ][xyIndex]);
        },
        getCreatingRange: function(localTrack) {
            var ends = $32947641224f901a$var$getTrackEnds(localTrack);
            var min = $32947641224f901a$var$mathMin(ends[0][xyIndex], ends[1][xyIndex]);
            var max = $32947641224f901a$var$mathMax(ends[0][xyIndex], ends[1][xyIndex]);
            return [
                min,
                max
            ];
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            var otherExtent; // If brushWidth not specified, fit the panel.
            var panel = $32947641224f901a$var$getPanelByCover(controller, cover);
            if (panel !== true && panel.getLinearBrushOtherExtent) otherExtent = panel.getLinearBrushOtherExtent(xyIndex, controller._transform);
            else {
                var zr = controller._zr;
                otherExtent = [
                    0,
                    [
                        zr.getWidth(),
                        zr.getHeight()
                    ][1 - xyIndex]
                ];
            }
            var rectRange = [
                localRange,
                otherExtent
            ];
            xyIndex && rectRange.reverse();
            $32947641224f901a$var$updateBaseRect(controller, cover, rectRange, brushOption);
        },
        updateCommon: $32947641224f901a$var$updateCommon,
        contain: $32947641224f901a$var$mainShapeContain
    };
}
var $32947641224f901a$var$_default = $32947641224f901a$var$BrushController;
$32947641224f901a$exports = $32947641224f901a$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $bc32eea3d1412e03$export$fee17964a62a87a7;
var $bc32eea3d1412e03$export$7280070e90fad7a0;
var $bc32eea3d1412e03$export$e63e66b3b18aa99f;


var $bc32eea3d1412e03$var$onIrrelevantElement = $42222c91ddd2a800$export$8a33eacb690eac07;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $bc32eea3d1412e03$var$makeRectPanelClipPath(rect) {
    rect = $bc32eea3d1412e03$var$normalizeRect(rect);
    return function(localPoints, transform) {
        return $4b57d6b582d579b7$export$e2f409471bbbc1dc(localPoints, rect);
    };
}
function $bc32eea3d1412e03$var$makeLinearBrushOtherExtent(rect, specifiedXYIndex) {
    rect = $bc32eea3d1412e03$var$normalizeRect(rect);
    return function(xyIndex) {
        var idx = specifiedXYIndex != null ? specifiedXYIndex : xyIndex;
        var brushWidth = idx ? rect.width : rect.height;
        var base = idx ? rect.x : rect.y;
        return [
            base,
            base + (brushWidth || 0)
        ];
    };
}
function $bc32eea3d1412e03$var$makeRectIsTargetByCursor(rect, api, targetModel) {
    rect = $bc32eea3d1412e03$var$normalizeRect(rect);
    return function(e, localCursorPoint, transform) {
        return rect.contain(localCursorPoint[0], localCursorPoint[1]) && !$bc32eea3d1412e03$var$onIrrelevantElement(e, api, targetModel);
    };
} // Consider width/height is negative.
function $bc32eea3d1412e03$var$normalizeRect(rect) {
    return $33e4fae744d34798$exports.create(rect);
}
$bc32eea3d1412e03$export$fee17964a62a87a7 = $bc32eea3d1412e03$var$makeRectPanelClipPath;
$bc32eea3d1412e03$export$7280070e90fad7a0 = $bc32eea3d1412e03$var$makeLinearBrushOtherExtent;
$bc32eea3d1412e03$export$e63e66b3b18aa99f = $bc32eea3d1412e03$var$makeRectIsTargetByCursor;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $40f9599448f8fe0a$var$elementList = [
    "axisLine",
    "axisTickLabel",
    "axisName"
];
var $40f9599448f8fe0a$var$AxisView = $f406636b535430a7$exports.extendComponentView({
    type: "parallelAxis",
    /**
   * @override
   */ init: function(ecModel, api) {
        $40f9599448f8fe0a$var$AxisView.superApply(this, "init", arguments);
        /**
     * @type {module:echarts/component/helper/BrushController}
     */ (this._brushController = new $32947641224f901a$exports(api.getZr())).on("brush", $ec279652dd95c27b$export$2385a24977818dd0(this._onBrush, this));
    },
    /**
   * @override
   */ render: function(axisModel, ecModel, api, payload) {
        if ($40f9599448f8fe0a$var$fromAxisAreaSelect(axisModel, ecModel, payload)) return;
        this.axisModel = axisModel;
        this.api = api;
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
        this.group.add(this._axisGroup);
        if (!axisModel.get("show")) return;
        var coordSysModel = $40f9599448f8fe0a$var$getCoordSysModel(axisModel, ecModel);
        var coordSys = coordSysModel.coordinateSystem;
        var areaSelectStyle = axisModel.getAreaSelectStyle();
        var areaWidth = areaSelectStyle.width;
        var dim = axisModel.axis.dim;
        var axisLayout = coordSys.getAxisLayout(dim);
        var builderOpt = $ec279652dd95c27b$export$8b58be045bf06082({
            strokeContainThreshold: areaWidth
        }, axisLayout);
        var axisBuilder = new $3ce77a4133d2c8eb$exports(axisModel, builderOpt);
        $ec279652dd95c27b$export$79b2f7037acddd43($40f9599448f8fe0a$var$elementList, axisBuilder.add, axisBuilder);
        this._axisGroup.add(axisBuilder.getGroup());
        this._refreshBrushController(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api);
        var animationModel = payload && payload.animation === false ? null : axisModel;
        $4b57d6b582d579b7$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, animationModel);
    },
    // /**
    //  * @override
    //  */
    // updateVisual: function (axisModel, ecModel, api, payload) {
    //     this._brushController && this._brushController
    //         .updateCovers(getCoverInfoList(axisModel));
    // },
    _refreshBrushController: function(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api) {
        // After filtering, axis may change, select area needs to be update.
        var extent = axisModel.axis.getExtent();
        var extentLen = extent[1] - extent[0];
        var extra = Math.min(30, Math.abs(extentLen) * 0.1); // Arbitrary value.
        // width/height might be negative, which will be
        // normalized in BoundingRect.
        var rect = $4b57d6b582d579b7$export$2cf684e818bac055.create({
            x: extent[0],
            y: -areaWidth / 2,
            width: extentLen,
            height: areaWidth
        });
        rect.x -= extra;
        rect.width += 2 * extra;
        this._brushController.mount({
            enableGlobalPan: true,
            rotation: builderOpt.rotation,
            position: builderOpt.position
        }).setPanels([
            {
                panelId: "pl",
                clipPath: $bc32eea3d1412e03$export$fee17964a62a87a7(rect),
                isTargetByCursor: $bc32eea3d1412e03$export$e63e66b3b18aa99f(rect, api, coordSysModel),
                getLinearBrushOtherExtent: $bc32eea3d1412e03$export$7280070e90fad7a0(rect, 0)
            }
        ]).enableBrush({
            brushType: "lineX",
            brushStyle: areaSelectStyle,
            removeOnClick: true
        }).updateCovers($40f9599448f8fe0a$var$getCoverInfoList(axisModel));
    },
    _onBrush: function(coverInfoList, opt) {
        // Do not cache these object, because the mey be changed.
        var axisModel = this.axisModel;
        var axis = axisModel.axis;
        var intervals = $ec279652dd95c27b$export$871de8747c9eaa88(coverInfoList, function(coverInfo) {
            return [
                axis.coordToData(coverInfo.range[0], true),
                axis.coordToData(coverInfo.range[1], true)
            ];
        }); // If realtime is true, action is not dispatched on drag end, because
        // the drag end emits the same params with the last drag move event,
        // and may have some delay when using touch pad.
        if (!axisModel.option.realtime === opt.isEnd || opt.removeOnClick) // jshint ignore:line
        this.api.dispatchAction({
            type: "axisAreaSelect",
            parallelAxisId: axisModel.id,
            intervals: intervals
        });
    },
    /**
   * @override
   */ dispose: function() {
        this._brushController.dispose();
    }
});
function $40f9599448f8fe0a$var$fromAxisAreaSelect(axisModel, ecModel, payload) {
    return payload && payload.type === "axisAreaSelect" && ecModel.findComponents({
        mainType: "parallelAxis",
        query: payload
    })[0] === axisModel;
}
function $40f9599448f8fe0a$var$getCoverInfoList(axisModel) {
    var axis = axisModel.axis;
    return $ec279652dd95c27b$export$871de8747c9eaa88(axisModel.activeIntervals, function(interval) {
        return {
            brushType: "lineX",
            panelId: "pl",
            range: [
                axis.dataToCoord(interval[0], true),
                axis.dataToCoord(interval[1], true)
            ]
        };
    });
}
function $40f9599448f8fe0a$var$getCoordSysModel(axisModel, ecModel) {
    return ecModel.getComponent("parallel", axisModel.get("parallelIndex"));
}
var $40f9599448f8fe0a$var$_default = $40f9599448f8fe0a$var$AxisView;
$40f9599448f8fe0a$exports = $40f9599448f8fe0a$var$_default;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $3ee25a7bc2ec01e4$var$CLICK_THRESHOLD = 5; // > 4
// Parallel view
$f406636b535430a7$exports.extendComponentView({
    type: "parallel",
    render: function(parallelModel, ecModel, api) {
        this._model = parallelModel;
        this._api = api;
        if (!this._handlers) {
            this._handlers = {};
            $ec279652dd95c27b$export$79b2f7037acddd43($3ee25a7bc2ec01e4$var$handlers, function(handler, eventName) {
                api.getZr().on(eventName, this._handlers[eventName] = $ec279652dd95c27b$export$2385a24977818dd0(handler, this));
            }, this);
        }
        $a181ac84b0d97d16$export$958e3e1a02eac4b6(this, "_throttledDispatchExpand", parallelModel.get("axisExpandRate"), "fixRate");
    },
    dispose: function(ecModel, api) {
        $ec279652dd95c27b$export$79b2f7037acddd43(this._handlers, function(handler, eventName) {
            api.getZr().off(eventName, handler);
        });
        this._handlers = null;
    },
    /**
   * @param {Object} [opt] If null, cancle the last action triggering for debounce.
   */ _throttledDispatchExpand: function(opt) {
        this._dispatchExpand(opt);
    },
    _dispatchExpand: function(opt) {
        opt && this._api.dispatchAction($ec279652dd95c27b$export$8b58be045bf06082({
            type: "parallelAxisExpand"
        }, opt));
    }
});
var $3ee25a7bc2ec01e4$var$handlers = {
    mousedown: function(e) {
        if ($3ee25a7bc2ec01e4$var$checkTrigger(this, "click")) this._mouseDownPoint = [
            e.offsetX,
            e.offsetY
        ];
    },
    mouseup: function(e) {
        var mouseDownPoint = this._mouseDownPoint;
        if ($3ee25a7bc2ec01e4$var$checkTrigger(this, "click") && mouseDownPoint) {
            var point = [
                e.offsetX,
                e.offsetY
            ];
            var dist = Math.pow(mouseDownPoint[0] - point[0], 2) + Math.pow(mouseDownPoint[1] - point[1], 2);
            if (dist > $3ee25a7bc2ec01e4$var$CLICK_THRESHOLD) return;
            var result = this._model.coordinateSystem.getSlidedAxisExpandWindow([
                e.offsetX,
                e.offsetY
            ]);
            result.behavior !== "none" && this._dispatchExpand({
                axisExpandWindow: result.axisExpandWindow
            });
        }
        this._mouseDownPoint = null;
    },
    mousemove: function(e) {
        // Should do nothing when brushing.
        if (this._mouseDownPoint || !$3ee25a7bc2ec01e4$var$checkTrigger(this, "mousemove")) return;
        var model = this._model;
        var result = model.coordinateSystem.getSlidedAxisExpandWindow([
            e.offsetX,
            e.offsetY
        ]);
        var behavior = result.behavior;
        behavior === "jump" && this._throttledDispatchExpand.debounceNextCall(model.get("axisExpandDebounce"));
        this._throttledDispatchExpand(behavior === "none" ? null // Cancle the last trigger, in case that mouse slide out of the area quickly.
         : {
            axisExpandWindow: result.axisExpandWindow,
            // Jumping uses animation, and sliding suppresses animation.
            animation: behavior === "jump" ? null : false
        });
    }
};
function $3ee25a7bc2ec01e4$var$checkTrigger(view, triggerOn) {
    var model = view._model;
    return model.get("axisExpandable") && model.get("axisExpandTriggerOn") === triggerOn;
}
$f406636b535430a7$exports.registerPreprocessor($acf51de22f2685e8$exports);


var $e0450751b846a80c$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $e0450751b846a80c$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $e0450751b846a80c$var$createHashMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $e0450751b846a80c$var$_default = $70847df98016d69d$exports.extend({
    type: "series.parallel",
    dependencies: [
        "parallel"
    ],
    visualColorAccessPath: "lineStyle.color",
    getInitialData: function(option, ecModel) {
        var source = this.getSource();
        $e0450751b846a80c$var$setEncodeAndDimensions(source, this);
        return $10e48b57e44af7c1$exports(source, this);
    },
    /**
   * User can get data raw indices on 'axisAreaSelected' event received.
   *
   * @public
   * @param {string} activeState 'active' or 'inactive' or 'normal'
   * @return {Array.<number>} Raw indices
   */ getRawIndicesByActiveState: function(activeState) {
        var coordSys = this.coordinateSystem;
        var data = this.getData();
        var indices = [];
        coordSys.eachActiveState(data, function(theActiveState, dataIndex) {
            if (activeState === theActiveState) indices.push(data.getRawIndex(dataIndex));
        });
        return indices;
    },
    defaultOption: {
        zlevel: 0,
        // 一级层叠
        z: 2,
        // 二级层叠
        coordinateSystem: "parallel",
        parallelIndex: 0,
        label: {
            show: false
        },
        inactiveOpacity: 0.05,
        activeOpacity: 1,
        lineStyle: {
            width: 1,
            opacity: 0.45,
            type: "solid"
        },
        emphasis: {
            label: {
                show: false
            }
        },
        progressive: 500,
        smooth: false,
        // true | false | number
        animationEasing: "linear"
    }
});
function $e0450751b846a80c$var$setEncodeAndDimensions(source, seriesModel) {
    // The mapping of parallelAxis dimension to data dimension can
    // be specified in parallelAxis.option.dim. For example, if
    // parallelAxis.option.dim is 'dim3', it mapping to the third
    // dimension of data. But `data.encode` has higher priority.
    // Moreover, parallelModel.dimension should not be regarded as data
    // dimensions. Consider dimensions = ['dim4', 'dim2', 'dim6'];
    if (source.encodeDefine) return;
    var parallelModel = seriesModel.ecModel.getComponent("parallel", seriesModel.get("parallelIndex"));
    if (!parallelModel) return;
    var encodeDefine = source.encodeDefine = $e0450751b846a80c$var$createHashMap();
    $e0450751b846a80c$var$each(parallelModel.dimensions, function(axisDim) {
        var dataDimIndex = $e0450751b846a80c$var$convertDimNameToNumber(axisDim);
        encodeDefine.set(axisDim, dataDimIndex);
    });
}
function $e0450751b846a80c$var$convertDimNameToNumber(dimName) {
    return +dimName.replace("dim", "");
}
$e0450751b846a80c$exports = $e0450751b846a80c$var$_default;


var $21a051e8ba12e6e9$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $21a051e8ba12e6e9$var$DEFAULT_SMOOTH = 0.3;
var $21a051e8ba12e6e9$var$ParallelView = $6448f0aa5ca2bdaa$exports.extend({
    type: "parallel",
    init: function() {
        /**
     * @type {module:zrender/container/Group}
     * @private
     */ this._dataGroup = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
        this.group.add(this._dataGroup);
        /**
     * @type {module:echarts/data/List}
     */ this._data;
        /**
     * @type {boolean}
     */ this._initialized;
    },
    /**
   * @override
   */ render: function(seriesModel, ecModel, api, payload) {
        var dataGroup = this._dataGroup;
        var data = seriesModel.getData();
        var oldData = this._data;
        var coordSys = seriesModel.coordinateSystem;
        var dimensions = coordSys.dimensions;
        var seriesScope = $21a051e8ba12e6e9$var$makeSeriesScope(seriesModel);
        data.diff(oldData).add(add).update(update).remove(remove).execute();
        function add(newDataIndex) {
            var line = $21a051e8ba12e6e9$var$addEl(data, dataGroup, newDataIndex, dimensions, coordSys);
            $21a051e8ba12e6e9$var$updateElCommon(line, data, newDataIndex, seriesScope);
        }
        function update(newDataIndex, oldDataIndex) {
            var line = oldData.getItemGraphicEl(oldDataIndex);
            var points = $21a051e8ba12e6e9$var$createLinePoints(data, newDataIndex, dimensions, coordSys);
            data.setItemGraphicEl(newDataIndex, line);
            var animationModel = payload && payload.animation === false ? null : seriesModel;
            $4b57d6b582d579b7$export$c8dce3c08436e91e(line, {
                shape: {
                    points: points
                }
            }, animationModel, newDataIndex);
            $21a051e8ba12e6e9$var$updateElCommon(line, data, newDataIndex, seriesScope);
        }
        function remove(oldDataIndex) {
            var line = oldData.getItemGraphicEl(oldDataIndex);
            dataGroup.remove(line);
        } // First create
        if (!this._initialized) {
            this._initialized = true;
            var clipPath = $21a051e8ba12e6e9$var$createGridClipShape(coordSys, seriesModel, function() {
                // Callback will be invoked immediately if there is no animation
                setTimeout(function() {
                    dataGroup.removeClipPath();
                });
            });
            dataGroup.setClipPath(clipPath);
        }
        this._data = data;
    },
    incrementalPrepareRender: function(seriesModel, ecModel, api) {
        this._initialized = true;
        this._data = null;
        this._dataGroup.removeAll();
    },
    incrementalRender: function(taskParams, seriesModel, ecModel) {
        var data = seriesModel.getData();
        var coordSys = seriesModel.coordinateSystem;
        var dimensions = coordSys.dimensions;
        var seriesScope = $21a051e8ba12e6e9$var$makeSeriesScope(seriesModel);
        for(var dataIndex = taskParams.start; dataIndex < taskParams.end; dataIndex++){
            var line = $21a051e8ba12e6e9$var$addEl(data, this._dataGroup, dataIndex, dimensions, coordSys);
            line.incremental = true;
            $21a051e8ba12e6e9$var$updateElCommon(line, data, dataIndex, seriesScope);
        }
    },
    dispose: function() {},
    // _renderForProgressive: function (seriesModel) {
    //     var dataGroup = this._dataGroup;
    //     var data = seriesModel.getData();
    //     var oldData = this._data;
    //     var coordSys = seriesModel.coordinateSystem;
    //     var dimensions = coordSys.dimensions;
    //     var option = seriesModel.option;
    //     var progressive = option.progressive;
    //     var smooth = option.smooth ? SMOOTH : null;
    //     // In progressive animation is disabled, so use simple data diff,
    //     // which effects performance less.
    //     // (Typically performance for data with length 7000+ like:
    //     // simpleDiff: 60ms, addEl: 184ms,
    //     // in RMBP 2.4GHz intel i7, OSX 10.9 chrome 50.0.2661.102 (64-bit))
    //     if (simpleDiff(oldData, data, dimensions)) {
    //         dataGroup.removeAll();
    //         data.each(function (dataIndex) {
    //             addEl(data, dataGroup, dataIndex, dimensions, coordSys);
    //         });
    //     }
    //     updateElCommon(data, progressive, smooth);
    //     // Consider switch between progressive and not.
    //     data.__plProgressive = true;
    //     this._data = data;
    // },
    /**
   * @override
   */ remove: function() {
        this._dataGroup && this._dataGroup.removeAll();
        this._data = null;
    }
});
function $21a051e8ba12e6e9$var$createGridClipShape(coordSys, seriesModel, cb) {
    var parallelModel = coordSys.model;
    var rect = coordSys.getRect();
    var rectEl = new $4b57d6b582d579b7$export$c79fc6492f3af13d({
        shape: {
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        }
    });
    var dim = parallelModel.get("layout") === "horizontal" ? "width" : "height";
    rectEl.setShape(dim, 0);
    $4b57d6b582d579b7$export$a121566aadcfe021(rectEl, {
        shape: {
            width: rect.width,
            height: rect.height
        }
    }, seriesModel, cb);
    return rectEl;
}
function $21a051e8ba12e6e9$var$createLinePoints(data, dataIndex, dimensions, coordSys) {
    var points = [];
    for(var i = 0; i < dimensions.length; i++){
        var dimName = dimensions[i];
        var value = data.get(data.mapDimension(dimName), dataIndex);
        if (!$21a051e8ba12e6e9$var$isEmptyValue(value, coordSys.getAxis(dimName).type)) points.push(coordSys.dataToPoint(value, dimName));
    }
    return points;
}
function $21a051e8ba12e6e9$var$addEl(data, dataGroup, dataIndex, dimensions, coordSys) {
    var points = $21a051e8ba12e6e9$var$createLinePoints(data, dataIndex, dimensions, coordSys);
    var line = new $4b57d6b582d579b7$export$79f3ee03e63e7073({
        shape: {
            points: points
        },
        silent: true,
        z2: 10
    });
    dataGroup.add(line);
    data.setItemGraphicEl(dataIndex, line);
    return line;
}
function $21a051e8ba12e6e9$var$makeSeriesScope(seriesModel) {
    var smooth = seriesModel.get("smooth", true);
    smooth === true && (smooth = $21a051e8ba12e6e9$var$DEFAULT_SMOOTH);
    return {
        lineStyle: seriesModel.getModel("lineStyle").getLineStyle(),
        smooth: smooth != null ? smooth : $21a051e8ba12e6e9$var$DEFAULT_SMOOTH
    };
}
function $21a051e8ba12e6e9$var$updateElCommon(el, data, dataIndex, seriesScope) {
    var lineStyle = seriesScope.lineStyle;
    if (data.hasItemOption) {
        var lineStyleModel = data.getItemModel(dataIndex).getModel("lineStyle");
        lineStyle = lineStyleModel.getLineStyle();
    }
    el.useStyle(lineStyle);
    var elStyle = el.style;
    elStyle.fill = null; // lineStyle.color have been set to itemVisual in module:echarts/visual/seriesColor.
    elStyle.stroke = data.getItemVisual(dataIndex, "color"); // lineStyle.opacity have been set to itemVisual in parallelVisual.
    elStyle.opacity = data.getItemVisual(dataIndex, "opacity");
    seriesScope.smooth && (el.shape.smooth = seriesScope.smooth);
} // function simpleDiff(oldData, newData, dimensions) {
//     var oldLen;
//     if (!oldData
//         || !oldData.__plProgressive
//         || (oldLen = oldData.count()) !== newData.count()
//     ) {
//         return true;
//     }
//     var dimLen = dimensions.length;
//     for (var i = 0; i < oldLen; i++) {
//         for (var j = 0; j < dimLen; j++) {
//             if (oldData.get(dimensions[j], i) !== newData.get(dimensions[j], i)) {
//                 return true;
//             }
//         }
//     }
//     return false;
// }
// FIXME
// 公用方法?
function $21a051e8ba12e6e9$var$isEmptyValue(val, axisType) {
    return axisType === "category" ? val == null : val == null || isNaN(val); // axisType === 'value'
}
var $21a051e8ba12e6e9$var$_default = $21a051e8ba12e6e9$var$ParallelView;
$21a051e8ba12e6e9$exports = $21a051e8ba12e6e9$var$_default;


var $00f0e63c6b7ab090$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $00f0e63c6b7ab090$var$opacityAccessPath = [
    "lineStyle",
    "normal",
    "opacity"
];
var $00f0e63c6b7ab090$var$_default = {
    seriesType: "parallel",
    reset: function(seriesModel, ecModel, api) {
        var itemStyleModel = seriesModel.getModel("itemStyle");
        var lineStyleModel = seriesModel.getModel("lineStyle");
        var globalColors = ecModel.get("color");
        var color = lineStyleModel.get("color") || itemStyleModel.get("color") || globalColors[seriesModel.seriesIndex % globalColors.length];
        var inactiveOpacity = seriesModel.get("inactiveOpacity");
        var activeOpacity = seriesModel.get("activeOpacity");
        var lineStyle = seriesModel.getModel("lineStyle").getLineStyle();
        var coordSys = seriesModel.coordinateSystem;
        var data = seriesModel.getData();
        var opacityMap = {
            normal: lineStyle.opacity,
            active: activeOpacity,
            inactive: inactiveOpacity
        };
        data.setVisual("color", color);
        function progress(params, data) {
            coordSys.eachActiveState(data, function(activeState, dataIndex) {
                var opacity = opacityMap[activeState];
                if (activeState === "normal" && data.hasItemOption) {
                    var itemOpacity = data.getItemModel(dataIndex).get($00f0e63c6b7ab090$var$opacityAccessPath, true);
                    itemOpacity != null && (opacity = itemOpacity);
                }
                data.setItemVisual(dataIndex, "opacity", opacity);
            }, params.start, params.end);
        }
        return {
            progress: progress
        };
    }
};
$00f0e63c6b7ab090$exports = $00f0e63c6b7ab090$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerVisual($00f0e63c6b7ab090$exports);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bf4039c2f001a1e1$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $bf4039c2f001a1e1$var$encodeHTML = $a4be9366aeb9fcc8$export$f9d6449b9af28dc1;


var $bf4039c2f001a1e1$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $bf4039c2f001a1e1$var$SankeySeries = $70847df98016d69d$exports.extend({
    type: "series.sankey",
    layoutInfo: null,
    levelModels: null,
    /**
   * Init a graph data structure from data in option series
   *
   * @param  {Object} option  the object used to config echarts view
   * @return {module:echarts/data/List} storage initial data
   */ getInitialData: function(option, ecModel) {
        var links = option.edges || option.links;
        var nodes = option.data || option.nodes;
        var levels = option.levels;
        var levelModels = this.levelModels = {};
        for(var i = 0; i < levels.length; i++)if (levels[i].depth != null && levels[i].depth >= 0) levelModels[levels[i].depth] = new $2b51b4bf776ec22e$exports(levels[i], this, ecModel);
        if (nodes && links) {
            var graph = $0e1e8e36c7c1833e$exports(nodes, links, this, true, beforeLink);
            return graph.data;
        }
        function beforeLink(nodeData, edgeData) {
            nodeData.wrapMethod("getItemModel", function(model, idx) {
                model.customizeGetParent(function(path) {
                    var parentModel = this.parentModel;
                    var nodeDepth = parentModel.getData().getItemLayout(idx).depth;
                    var levelModel = parentModel.levelModels[nodeDepth];
                    return levelModel || this.parentModel;
                });
                return model;
            });
            edgeData.wrapMethod("getItemModel", function(model, idx) {
                model.customizeGetParent(function(path) {
                    var parentModel = this.parentModel;
                    var edge = parentModel.getGraph().getEdgeByIndex(idx);
                    var depth = edge.node1.getLayout().depth;
                    var levelModel = parentModel.levelModels[depth];
                    return levelModel || this.parentModel;
                });
                return model;
            });
        }
    },
    setNodePosition: function(dataIndex, localPosition) {
        var dataItem = this.option.data[dataIndex];
        dataItem.localX = localPosition[0];
        dataItem.localY = localPosition[1];
    },
    /**
   * Return the graphic data structure
   *
   * @return {module:echarts/data/Graph} graphic data structure
   */ getGraph: function() {
        return this.getData().graph;
    },
    /**
   * Get edge data of graphic data structure
   *
   * @return {module:echarts/data/List} data structure of list
   */ getEdgeData: function() {
        return this.getGraph().edgeData;
    },
    /**
   * @override
   */ formatTooltip: function(dataIndex, multipleSeries, dataType) {
        // dataType === 'node' or empty do not show tooltip by default
        if (dataType === "edge") {
            var params = this.getDataParams(dataIndex, dataType);
            var rawDataOpt = params.data;
            var html = rawDataOpt.source + " -- " + rawDataOpt.target;
            if (params.value) html += " : " + params.value;
            return $bf4039c2f001a1e1$var$encodeHTML(html);
        } else if (dataType === "node") {
            var node = this.getGraph().getNodeByIndex(dataIndex);
            var value = node.getLayout().value;
            var name = this.getDataParams(dataIndex, dataType).data.name;
            if (value) var html = name + " : " + value;
            return $bf4039c2f001a1e1$var$encodeHTML(html);
        }
        return $bf4039c2f001a1e1$var$SankeySeries.superCall(this, "formatTooltip", dataIndex, multipleSeries);
    },
    optionUpdated: function() {
        var option = this.option;
        if (option.focusNodeAdjacency === true) option.focusNodeAdjacency = "allEdges";
    },
    // Override Series.getDataParams()
    getDataParams: function(dataIndex, dataType) {
        var params = $bf4039c2f001a1e1$var$SankeySeries.superCall(this, "getDataParams", dataIndex, dataType);
        if (params.value == null && dataType === "node") {
            var node = this.getGraph().getNodeByIndex(dataIndex);
            var nodeValue = node.getLayout().value;
            params.value = nodeValue;
        }
        return params;
    },
    defaultOption: {
        zlevel: 0,
        z: 2,
        coordinateSystem: "view",
        layout: null,
        // The position of the whole view
        left: "5%",
        top: "5%",
        right: "20%",
        bottom: "5%",
        // Value can be 'vertical'
        orient: "horizontal",
        // The dx of the node
        nodeWidth: 20,
        // The vertical distance between two nodes
        nodeGap: 8,
        // Control if the node can move or not
        draggable: true,
        // Value can be 'inEdges', 'outEdges', 'allEdges', true (the same as 'allEdges').
        focusNodeAdjacency: false,
        // The number of iterations to change the position of the node
        layoutIterations: 32,
        label: {
            show: true,
            position: "right",
            color: "#000",
            fontSize: 12
        },
        levels: [],
        // Value can be 'left' or 'right'
        nodeAlign: "justify",
        itemStyle: {
            borderWidth: 1,
            borderColor: "#333"
        },
        lineStyle: {
            color: "#314656",
            opacity: 0.2,
            curveness: 0.5
        },
        emphasis: {
            label: {
                show: true
            },
            lineStyle: {
                opacity: 0.5
            }
        },
        animationEasing: "linear",
        animationDuration: 1000
    }
});
var $bf4039c2f001a1e1$var$_default = $bf4039c2f001a1e1$var$SankeySeries;
$bf4039c2f001a1e1$exports = $bf4039c2f001a1e1$var$_default;


var $32b97e8b7dc51caa$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $32b97e8b7dc51caa$var$nodeOpacityPath = [
    "itemStyle",
    "opacity"
];
var $32b97e8b7dc51caa$var$hoverNodeOpacityPath = [
    "emphasis",
    "itemStyle",
    "opacity"
];
var $32b97e8b7dc51caa$var$lineOpacityPath = [
    "lineStyle",
    "opacity"
];
var $32b97e8b7dc51caa$var$hoverLineOpacityPath = [
    "emphasis",
    "lineStyle",
    "opacity"
];
function $32b97e8b7dc51caa$var$getItemOpacity(item, opacityPath) {
    return item.getVisual("opacity") || item.getModel().get(opacityPath);
}
function $32b97e8b7dc51caa$var$fadeOutItem(item, opacityPath, opacityRatio) {
    var el = item.getGraphicEl();
    var opacity = $32b97e8b7dc51caa$var$getItemOpacity(item, opacityPath);
    if (opacityRatio != null) {
        opacity == null && (opacity = 1);
        opacity *= opacityRatio;
    }
    el.downplay && el.downplay();
    el.traverse(function(child) {
        if (child.type !== "group") child.setStyle("opacity", opacity);
    });
}
function $32b97e8b7dc51caa$var$fadeInItem(item, opacityPath) {
    var opacity = $32b97e8b7dc51caa$var$getItemOpacity(item, opacityPath);
    var el = item.getGraphicEl();
    el.traverse(function(child) {
        if (child.type !== "group") child.setStyle("opacity", opacity);
    }); // Support emphasis here.
    el.highlight && el.highlight();
}
var $32b97e8b7dc51caa$var$SankeyShape = $4b57d6b582d579b7$export$d0d5398c9d612037({
    shape: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0,
        cpx1: 0,
        cpy1: 0,
        cpx2: 0,
        cpy2: 0,
        extent: 0,
        orient: ""
    },
    buildPath: function(ctx, shape) {
        var extent = shape.extent;
        ctx.moveTo(shape.x1, shape.y1);
        ctx.bezierCurveTo(shape.cpx1, shape.cpy1, shape.cpx2, shape.cpy2, shape.x2, shape.y2);
        if (shape.orient === "vertical") {
            ctx.lineTo(shape.x2 + extent, shape.y2);
            ctx.bezierCurveTo(shape.cpx2 + extent, shape.cpy2, shape.cpx1 + extent, shape.cpy1, shape.x1 + extent, shape.y1);
        } else {
            ctx.lineTo(shape.x2, shape.y2 + extent);
            ctx.bezierCurveTo(shape.cpx2, shape.cpy2 + extent, shape.cpx1, shape.cpy1 + extent, shape.x1, shape.y1 + extent);
        }
        ctx.closePath();
    },
    highlight: function() {
        this.trigger("emphasis");
    },
    downplay: function() {
        this.trigger("normal");
    }
});
var $32b97e8b7dc51caa$var$_default = $f406636b535430a7$exports.extendChartView({
    type: "sankey",
    /**
   * @private
   * @type {module:echarts/chart/sankey/SankeySeries}
   */ _model: null,
    /**
   * @private
   * @type {boolean}
   */ _focusAdjacencyDisabled: false,
    render: function(seriesModel, ecModel, api) {
        var sankeyView = this;
        var graph = seriesModel.getGraph();
        var group = this.group;
        var layoutInfo = seriesModel.layoutInfo; // view width
        var width = layoutInfo.width; // view height
        var height = layoutInfo.height;
        var nodeData = seriesModel.getData();
        var edgeData = seriesModel.getData("edge");
        var orient = seriesModel.get("orient");
        this._model = seriesModel;
        group.removeAll();
        group.attr("position", [
            layoutInfo.x,
            layoutInfo.y
        ]); // generate a bezire Curve for each edge
        graph.eachEdge(function(edge) {
            var curve = new $32b97e8b7dc51caa$var$SankeyShape();
            curve.dataIndex = edge.dataIndex;
            curve.seriesIndex = seriesModel.seriesIndex;
            curve.dataType = "edge";
            var lineStyleModel = edge.getModel("lineStyle");
            var curvature = lineStyleModel.get("curveness");
            var n1Layout = edge.node1.getLayout();
            var node1Model = edge.node1.getModel();
            var dragX1 = node1Model.get("localX");
            var dragY1 = node1Model.get("localY");
            var n2Layout = edge.node2.getLayout();
            var node2Model = edge.node2.getModel();
            var dragX2 = node2Model.get("localX");
            var dragY2 = node2Model.get("localY");
            var edgeLayout = edge.getLayout();
            var x1;
            var y1;
            var x2;
            var y2;
            var cpx1;
            var cpy1;
            var cpx2;
            var cpy2;
            curve.shape.extent = Math.max(1, edgeLayout.dy);
            curve.shape.orient = orient;
            if (orient === "vertical") {
                x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + edgeLayout.sy;
                y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + n1Layout.dy;
                x2 = (dragX2 != null ? dragX2 * width : n2Layout.x) + edgeLayout.ty;
                y2 = dragY2 != null ? dragY2 * height : n2Layout.y;
                cpx1 = x1;
                cpy1 = y1 * (1 - curvature) + y2 * curvature;
                cpx2 = x2;
                cpy2 = y1 * curvature + y2 * (1 - curvature);
            } else {
                x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + n1Layout.dx;
                y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + edgeLayout.sy;
                x2 = dragX2 != null ? dragX2 * width : n2Layout.x;
                y2 = (dragY2 != null ? dragY2 * height : n2Layout.y) + edgeLayout.ty;
                cpx1 = x1 * (1 - curvature) + x2 * curvature;
                cpy1 = y1;
                cpx2 = x1 * curvature + x2 * (1 - curvature);
                cpy2 = y2;
            }
            curve.setShape({
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                cpx1: cpx1,
                cpy1: cpy1,
                cpx2: cpx2,
                cpy2: cpy2
            });
            curve.setStyle(lineStyleModel.getItemStyle()); // Special color, use source node color or target node color
            switch(curve.style.fill){
                case "source":
                    curve.style.fill = edge.node1.getVisual("color");
                    break;
                case "target":
                    curve.style.fill = edge.node2.getVisual("color");
                    break;
            }
            $4b57d6b582d579b7$export$28b42df8183f218c(curve, edge.getModel("emphasis.lineStyle").getItemStyle());
            group.add(curve);
            edgeData.setItemGraphicEl(edge.dataIndex, curve);
        }); // Generate a rect for each node
        graph.eachNode(function(node) {
            var layout = node.getLayout();
            var itemModel = node.getModel();
            var dragX = itemModel.get("localX");
            var dragY = itemModel.get("localY");
            var labelModel = itemModel.getModel("label");
            var labelHoverModel = itemModel.getModel("emphasis.label");
            var rect = new $4b57d6b582d579b7$export$c79fc6492f3af13d({
                shape: {
                    x: dragX != null ? dragX * width : layout.x,
                    y: dragY != null ? dragY * height : layout.y,
                    width: layout.dx,
                    height: layout.dy
                },
                style: itemModel.getModel("itemStyle").getItemStyle()
            });
            var hoverStyle = node.getModel("emphasis.itemStyle").getItemStyle();
            $4b57d6b582d579b7$export$9a13992917966657(rect.style, hoverStyle, labelModel, labelHoverModel, {
                labelFetcher: seriesModel,
                labelDataIndex: node.dataIndex,
                defaultText: node.id,
                isRectText: true
            });
            rect.setStyle("fill", node.getVisual("color"));
            $4b57d6b582d579b7$export$28b42df8183f218c(rect, hoverStyle);
            group.add(rect);
            nodeData.setItemGraphicEl(node.dataIndex, rect);
            rect.dataType = "node";
        });
        nodeData.eachItemGraphicEl(function(el, dataIndex) {
            var itemModel = nodeData.getItemModel(dataIndex);
            if (itemModel.get("draggable")) {
                el.drift = function(dx, dy) {
                    sankeyView._focusAdjacencyDisabled = true;
                    this.shape.x += dx;
                    this.shape.y += dy;
                    this.dirty();
                    api.dispatchAction({
                        type: "dragNode",
                        seriesId: seriesModel.id,
                        dataIndex: nodeData.getRawIndex(dataIndex),
                        localX: this.shape.x / width,
                        localY: this.shape.y / height
                    });
                };
                el.ondragend = function() {
                    sankeyView._focusAdjacencyDisabled = false;
                };
                el.draggable = true;
                el.cursor = "move";
            }
            el.highlight = function() {
                this.trigger("emphasis");
            };
            el.downplay = function() {
                this.trigger("normal");
            };
            el.focusNodeAdjHandler && el.off("mouseover", el.focusNodeAdjHandler);
            el.unfocusNodeAdjHandler && el.off("mouseout", el.unfocusNodeAdjHandler);
            if (itemModel.get("focusNodeAdjacency")) {
                el.on("mouseover", el.focusNodeAdjHandler = function() {
                    if (!sankeyView._focusAdjacencyDisabled) {
                        sankeyView._clearTimer();
                        api.dispatchAction({
                            type: "focusNodeAdjacency",
                            seriesId: seriesModel.id,
                            dataIndex: el.dataIndex
                        });
                    }
                });
                el.on("mouseout", el.unfocusNodeAdjHandler = function() {
                    if (!sankeyView._focusAdjacencyDisabled) sankeyView._dispatchUnfocus(api);
                });
            }
        });
        edgeData.eachItemGraphicEl(function(el, dataIndex) {
            var edgeModel = edgeData.getItemModel(dataIndex);
            el.focusNodeAdjHandler && el.off("mouseover", el.focusNodeAdjHandler);
            el.unfocusNodeAdjHandler && el.off("mouseout", el.unfocusNodeAdjHandler);
            if (edgeModel.get("focusNodeAdjacency")) {
                el.on("mouseover", el.focusNodeAdjHandler = function() {
                    if (!sankeyView._focusAdjacencyDisabled) {
                        sankeyView._clearTimer();
                        api.dispatchAction({
                            type: "focusNodeAdjacency",
                            seriesId: seriesModel.id,
                            edgeDataIndex: el.dataIndex
                        });
                    }
                });
                el.on("mouseout", el.unfocusNodeAdjHandler = function() {
                    if (!sankeyView._focusAdjacencyDisabled) sankeyView._dispatchUnfocus(api);
                });
            }
        });
        if (!this._data && seriesModel.get("animation")) group.setClipPath($32b97e8b7dc51caa$var$createGridClipShape(group.getBoundingRect(), seriesModel, function() {
            group.removeClipPath();
        }));
        this._data = seriesModel.getData();
    },
    dispose: function() {
        this._clearTimer();
    },
    _dispatchUnfocus: function(api) {
        var self = this;
        this._clearTimer();
        this._unfocusDelayTimer = setTimeout(function() {
            self._unfocusDelayTimer = null;
            api.dispatchAction({
                type: "unfocusNodeAdjacency",
                seriesId: self._model.id
            });
        }, 500);
    },
    _clearTimer: function() {
        if (this._unfocusDelayTimer) {
            clearTimeout(this._unfocusDelayTimer);
            this._unfocusDelayTimer = null;
        }
    },
    focusNodeAdjacency: function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var graph = data.graph;
        var dataIndex = payload.dataIndex;
        var itemModel = data.getItemModel(dataIndex);
        var edgeDataIndex = payload.edgeDataIndex;
        if (dataIndex == null && edgeDataIndex == null) return;
        var node = graph.getNodeByIndex(dataIndex);
        var edge = graph.getEdgeByIndex(edgeDataIndex);
        graph.eachNode(function(node) {
            $32b97e8b7dc51caa$var$fadeOutItem(node, $32b97e8b7dc51caa$var$nodeOpacityPath, 0.1);
        });
        graph.eachEdge(function(edge) {
            $32b97e8b7dc51caa$var$fadeOutItem(edge, $32b97e8b7dc51caa$var$lineOpacityPath, 0.1);
        });
        if (node) {
            $32b97e8b7dc51caa$var$fadeInItem(node, $32b97e8b7dc51caa$var$hoverNodeOpacityPath);
            var focusNodeAdj = itemModel.get("focusNodeAdjacency");
            if (focusNodeAdj === "outEdges") $ec279652dd95c27b$export$79b2f7037acddd43(node.outEdges, function(edge) {
                if (edge.dataIndex < 0) return;
                $32b97e8b7dc51caa$var$fadeInItem(edge, $32b97e8b7dc51caa$var$hoverLineOpacityPath);
                $32b97e8b7dc51caa$var$fadeInItem(edge.node2, $32b97e8b7dc51caa$var$hoverNodeOpacityPath);
            });
            else if (focusNodeAdj === "inEdges") $ec279652dd95c27b$export$79b2f7037acddd43(node.inEdges, function(edge) {
                if (edge.dataIndex < 0) return;
                $32b97e8b7dc51caa$var$fadeInItem(edge, $32b97e8b7dc51caa$var$hoverLineOpacityPath);
                $32b97e8b7dc51caa$var$fadeInItem(edge.node1, $32b97e8b7dc51caa$var$hoverNodeOpacityPath);
            });
            else if (focusNodeAdj === "allEdges") $ec279652dd95c27b$export$79b2f7037acddd43(node.edges, function(edge) {
                if (edge.dataIndex < 0) return;
                $32b97e8b7dc51caa$var$fadeInItem(edge, $32b97e8b7dc51caa$var$hoverLineOpacityPath);
                edge.node1 !== node && $32b97e8b7dc51caa$var$fadeInItem(edge.node1, $32b97e8b7dc51caa$var$hoverNodeOpacityPath);
                edge.node2 !== node && $32b97e8b7dc51caa$var$fadeInItem(edge.node2, $32b97e8b7dc51caa$var$hoverNodeOpacityPath);
            });
        }
        if (edge) {
            $32b97e8b7dc51caa$var$fadeInItem(edge, $32b97e8b7dc51caa$var$hoverLineOpacityPath);
            $32b97e8b7dc51caa$var$fadeInItem(edge.node1, $32b97e8b7dc51caa$var$hoverNodeOpacityPath);
            $32b97e8b7dc51caa$var$fadeInItem(edge.node2, $32b97e8b7dc51caa$var$hoverNodeOpacityPath);
        }
    },
    unfocusNodeAdjacency: function(seriesModel, ecModel, api, payload) {
        var graph = seriesModel.getGraph();
        graph.eachNode(function(node) {
            $32b97e8b7dc51caa$var$fadeOutItem(node, $32b97e8b7dc51caa$var$nodeOpacityPath);
        });
        graph.eachEdge(function(edge) {
            $32b97e8b7dc51caa$var$fadeOutItem(edge, $32b97e8b7dc51caa$var$lineOpacityPath);
        });
    }
}); // Add animation to the view
function $32b97e8b7dc51caa$var$createGridClipShape(rect, seriesModel, cb) {
    var rectEl = new $4b57d6b582d579b7$export$c79fc6492f3af13d({
        shape: {
            x: rect.x - 10,
            y: rect.y - 10,
            width: 0,
            height: rect.height + 20
        }
    });
    $4b57d6b582d579b7$export$a121566aadcfe021(rectEl, {
        shape: {
            width: rect.width + 20
        }
    }, seriesModel, cb);
    return rectEl;
}
$32b97e8b7dc51caa$exports = $32b97e8b7dc51caa$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerAction({
    type: "dragNode",
    event: "dragnode",
    // here can only use 'update' now, other value is not support in echarts.
    update: "update"
}, function(payload, ecModel) {
    ecModel.eachComponent({
        mainType: "series",
        subType: "sankey",
        query: payload
    }, function(seriesModel) {
        seriesModel.setNodePosition(payload.dataIndex, [
            payload.localX,
            payload.localY
        ]);
    });
});


var $2d32aa0b2cc7dd45$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $2d32aa0b2cc7dd45$var$groupData = $d559f43cb9041423$export$7ab5bda43e13168f;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $2d32aa0b2cc7dd45$var$_default(ecModel, api, payload) {
    ecModel.eachSeriesByType("sankey", function(seriesModel) {
        var nodeWidth = seriesModel.get("nodeWidth");
        var nodeGap = seriesModel.get("nodeGap");
        var layoutInfo = $2d32aa0b2cc7dd45$var$getViewRect(seriesModel, api);
        seriesModel.layoutInfo = layoutInfo;
        var width = layoutInfo.width;
        var height = layoutInfo.height;
        var graph = seriesModel.getGraph();
        var nodes = graph.nodes;
        var edges = graph.edges;
        $2d32aa0b2cc7dd45$var$computeNodeValues(nodes);
        var filteredNodes = $ec279652dd95c27b$export$3dea766d36a8935f(nodes, function(node) {
            return node.getLayout().value === 0;
        });
        var iterations = filteredNodes.length !== 0 ? 0 : seriesModel.get("layoutIterations");
        var orient = seriesModel.get("orient");
        var nodeAlign = seriesModel.get("nodeAlign");
        $2d32aa0b2cc7dd45$var$layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign);
    });
}
/**
 * Get the layout position of the whole view
 *
 * @param {module:echarts/model/Series} seriesModel  the model object of sankey series
 * @param {module:echarts/ExtensionAPI} api  provide the API list that the developer can call
 * @return {module:zrender/core/BoundingRect}  size of rect to draw the sankey view
 */ function $2d32aa0b2cc7dd45$var$getViewRect(seriesModel, api) {
    return $ab0c9086dd6c5b39$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $2d32aa0b2cc7dd45$var$layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign) {
    $2d32aa0b2cc7dd45$var$computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign);
    $2d32aa0b2cc7dd45$var$computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient);
    $2d32aa0b2cc7dd45$var$computeEdgeDepths(nodes, orient);
}
/**
 * Compute the value of each node by summing the associated edge's value
 *
 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
 */ function $2d32aa0b2cc7dd45$var$computeNodeValues(nodes) {
    $ec279652dd95c27b$export$79b2f7037acddd43(nodes, function(node) {
        var value1 = $2d32aa0b2cc7dd45$var$sum(node.outEdges, $2d32aa0b2cc7dd45$var$getEdgeValue);
        var value2 = $2d32aa0b2cc7dd45$var$sum(node.inEdges, $2d32aa0b2cc7dd45$var$getEdgeValue);
        var nodeRawValue = node.getValue() || 0;
        var value = Math.max(value1, value2, nodeRawValue);
        node.setLayout({
            value: value
        }, true);
    });
}
/**
 * Compute the x-position for each node.
 *
 * Here we use Kahn algorithm to detect cycle when we traverse
 * the node to computer the initial x position.
 *
 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
 * @param  {number} nodeWidth  the dx of the node
 * @param  {number} width  the whole width of the area to draw the view
 */ function $2d32aa0b2cc7dd45$var$computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign) {
    // Used to mark whether the edge is deleted. if it is deleted,
    // the value is 0, otherwise it is 1.
    var remainEdges = []; // Storage each node's indegree.
    var indegreeArr = []; //Used to storage the node with indegree is equal to 0.
    var zeroIndegrees = [];
    var nextTargetNode = [];
    var x = 0;
    var kx = 0;
    for(var i = 0; i < edges.length; i++)remainEdges[i] = 1;
    for(i = 0; i < nodes.length; i++){
        indegreeArr[i] = nodes[i].inEdges.length;
        if (indegreeArr[i] === 0) zeroIndegrees.push(nodes[i]);
    }
    var maxNodeDepth = -1; // Traversing nodes using topological sorting to calculate the
    // horizontal(if orient === 'horizontal') or vertical(if orient === 'vertical')
    // position of the nodes.
    while(zeroIndegrees.length){
        for(var idx = 0; idx < zeroIndegrees.length; idx++){
            var node = zeroIndegrees[idx];
            var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
            var isItemDepth = item.depth != null && item.depth >= 0;
            if (isItemDepth && item.depth > maxNodeDepth) maxNodeDepth = item.depth;
            node.setLayout({
                depth: isItemDepth ? item.depth : x
            }, true);
            orient === "vertical" ? node.setLayout({
                dy: nodeWidth
            }, true) : node.setLayout({
                dx: nodeWidth
            }, true);
            for(var edgeIdx = 0; edgeIdx < node.outEdges.length; edgeIdx++){
                var edge = node.outEdges[edgeIdx];
                var indexEdge = edges.indexOf(edge);
                remainEdges[indexEdge] = 0;
                var targetNode = edge.node2;
                var nodeIndex = nodes.indexOf(targetNode);
                if (--indegreeArr[nodeIndex] === 0 && nextTargetNode.indexOf(targetNode) < 0) nextTargetNode.push(targetNode);
            }
        }
        ++x;
        zeroIndegrees = nextTargetNode;
        nextTargetNode = [];
    }
    for(i = 0; i < remainEdges.length; i++){
        if (remainEdges[i] === 1) throw new Error("Sankey is a DAG, the original data has cycle!");
    }
    var maxDepth = maxNodeDepth > x - 1 ? maxNodeDepth : x - 1;
    if (nodeAlign && nodeAlign !== "left") $2d32aa0b2cc7dd45$var$adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth);
    var kx = orient === "vertical" ? (height - nodeWidth) / maxDepth : (width - nodeWidth) / maxDepth;
    $2d32aa0b2cc7dd45$var$scaleNodeBreadths(nodes, kx, orient);
}
function $2d32aa0b2cc7dd45$var$isNodeDepth(node) {
    var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
    return item.depth != null && item.depth >= 0;
}
function $2d32aa0b2cc7dd45$var$adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth) {
    if (nodeAlign === "right") {
        var nextSourceNode = [];
        var remainNodes = nodes;
        var nodeHeight = 0;
        while(remainNodes.length){
            for(var i = 0; i < remainNodes.length; i++){
                var node = remainNodes[i];
                node.setLayout({
                    skNodeHeight: nodeHeight
                }, true);
                for(var j = 0; j < node.inEdges.length; j++){
                    var edge = node.inEdges[j];
                    if (nextSourceNode.indexOf(edge.node1) < 0) nextSourceNode.push(edge.node1);
                }
            }
            remainNodes = nextSourceNode;
            nextSourceNode = [];
            ++nodeHeight;
        }
        $ec279652dd95c27b$export$79b2f7037acddd43(nodes, function(node) {
            if (!$2d32aa0b2cc7dd45$var$isNodeDepth(node)) node.setLayout({
                depth: Math.max(0, maxDepth - node.getLayout().skNodeHeight)
            }, true);
        });
    } else if (nodeAlign === "justify") $2d32aa0b2cc7dd45$var$moveSinksRight(nodes, maxDepth);
}
/**
 * All the node without outEgdes are assigned maximum x-position and
 *     be aligned in the last column.
 *
 * @param {module:echarts/data/Graph~Node} nodes.  node of sankey view.
 * @param {number} maxDepth.  use to assign to node without outEdges as x-position.
 */ function $2d32aa0b2cc7dd45$var$moveSinksRight(nodes, maxDepth) {
    $ec279652dd95c27b$export$79b2f7037acddd43(nodes, function(node) {
        if (!$2d32aa0b2cc7dd45$var$isNodeDepth(node) && !node.outEdges.length) node.setLayout({
            depth: maxDepth
        }, true);
    });
}
/**
 * Scale node x-position to the width
 *
 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
 * @param {number} kx   multiple used to scale nodes
 */ function $2d32aa0b2cc7dd45$var$scaleNodeBreadths(nodes, kx, orient) {
    $ec279652dd95c27b$export$79b2f7037acddd43(nodes, function(node) {
        var nodeDepth = node.getLayout().depth * kx;
        orient === "vertical" ? node.setLayout({
            y: nodeDepth
        }, true) : node.setLayout({
            x: nodeDepth
        }, true);
    });
}
/**
 * Using Gauss-Seidel iterations method to compute the node depth(y-position)
 *
 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
 * @param {module:echarts/data/Graph~Edge} edges  edge of sankey view
 * @param {number} height  the whole height of the area to draw the view
 * @param {number} nodeGap  the vertical distance between two nodes
 *     in the same column.
 * @param {number} iterations  the number of iterations for the algorithm
 */ function $2d32aa0b2cc7dd45$var$computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient) {
    var nodesByBreadth = $2d32aa0b2cc7dd45$var$prepareNodesByBreadth(nodes, orient);
    $2d32aa0b2cc7dd45$var$initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient);
    $2d32aa0b2cc7dd45$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
    for(var alpha = 1; iterations > 0; iterations--){
        // 0.99 is a experience parameter, ensure that each iterations of
        // changes as small as possible.
        alpha *= 0.99;
        $2d32aa0b2cc7dd45$var$relaxRightToLeft(nodesByBreadth, alpha, orient);
        $2d32aa0b2cc7dd45$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
        $2d32aa0b2cc7dd45$var$relaxLeftToRight(nodesByBreadth, alpha, orient);
        $2d32aa0b2cc7dd45$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
    }
}
function $2d32aa0b2cc7dd45$var$prepareNodesByBreadth(nodes, orient) {
    var nodesByBreadth = [];
    var keyAttr = orient === "vertical" ? "y" : "x";
    var groupResult = $2d32aa0b2cc7dd45$var$groupData(nodes, function(node) {
        return node.getLayout()[keyAttr];
    });
    groupResult.keys.sort(function(a, b) {
        return a - b;
    });
    $ec279652dd95c27b$export$79b2f7037acddd43(groupResult.keys, function(key) {
        nodesByBreadth.push(groupResult.buckets.get(key));
    });
    return nodesByBreadth;
}
/**
 * Compute the original y-position for each node
 *
 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
 *     group by the array of all sankey nodes based on the nodes x-position.
 * @param {module:echarts/data/Graph~Edge} edges  edge of sankey view
 * @param {number} height  the whole height of the area to draw the view
 * @param {number} nodeGap  the vertical distance between two nodes
 */ function $2d32aa0b2cc7dd45$var$initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient) {
    var minKy = Infinity;
    $ec279652dd95c27b$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        var n = nodes.length;
        var sum = 0;
        $ec279652dd95c27b$export$79b2f7037acddd43(nodes, function(node) {
            sum += node.getLayout().value;
        });
        var ky = orient === "vertical" ? (width - (n - 1) * nodeGap) / sum : (height - (n - 1) * nodeGap) / sum;
        if (ky < minKy) minKy = ky;
    });
    $ec279652dd95c27b$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        $ec279652dd95c27b$export$79b2f7037acddd43(nodes, function(node, i) {
            var nodeDy = node.getLayout().value * minKy;
            if (orient === "vertical") {
                node.setLayout({
                    x: i
                }, true);
                node.setLayout({
                    dx: nodeDy
                }, true);
            } else {
                node.setLayout({
                    y: i
                }, true);
                node.setLayout({
                    dy: nodeDy
                }, true);
            }
        });
    });
    $ec279652dd95c27b$export$79b2f7037acddd43(edges, function(edge) {
        var edgeDy = +edge.getValue() * minKy;
        edge.setLayout({
            dy: edgeDy
        }, true);
    });
}
/**
 * Resolve the collision of initialized depth (y-position)
 *
 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
 *     group by the array of all sankey nodes based on the nodes x-position.
 * @param {number} nodeGap  the vertical distance between two nodes
 * @param {number} height  the whole height of the area to draw the view
 */ function $2d32aa0b2cc7dd45$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient) {
    var keyAttr = orient === "vertical" ? "x" : "y";
    $ec279652dd95c27b$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        nodes.sort(function(a, b) {
            return a.getLayout()[keyAttr] - b.getLayout()[keyAttr];
        });
        var nodeX;
        var node;
        var dy;
        var y0 = 0;
        var n = nodes.length;
        var nodeDyAttr = orient === "vertical" ? "dx" : "dy";
        for(var i = 0; i < n; i++){
            node = nodes[i];
            dy = y0 - node.getLayout()[keyAttr];
            if (dy > 0) {
                nodeX = node.getLayout()[keyAttr] + dy;
                orient === "vertical" ? node.setLayout({
                    x: nodeX
                }, true) : node.setLayout({
                    y: nodeX
                }, true);
            }
            y0 = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap;
        }
        var viewWidth = orient === "vertical" ? width : height; // If the bottommost node goes outside the bounds, push it back up
        dy = y0 - nodeGap - viewWidth;
        if (dy > 0) {
            nodeX = node.getLayout()[keyAttr] - dy;
            orient === "vertical" ? node.setLayout({
                x: nodeX
            }, true) : node.setLayout({
                y: nodeX
            }, true);
            y0 = nodeX;
            for(i = n - 2; i >= 0; --i){
                node = nodes[i];
                dy = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap - y0;
                if (dy > 0) {
                    nodeX = node.getLayout()[keyAttr] - dy;
                    orient === "vertical" ? node.setLayout({
                        x: nodeX
                    }, true) : node.setLayout({
                        y: nodeX
                    }, true);
                }
                y0 = node.getLayout()[keyAttr];
            }
        }
    });
}
/**
 * Change the y-position of the nodes, except most the right side nodes
 *
 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
 *     group by the array of all sankey nodes based on the node x-position.
 * @param {number} alpha  parameter used to adjust the nodes y-position
 */ function $2d32aa0b2cc7dd45$var$relaxRightToLeft(nodesByBreadth, alpha, orient) {
    $ec279652dd95c27b$export$79b2f7037acddd43(nodesByBreadth.slice().reverse(), function(nodes) {
        $ec279652dd95c27b$export$79b2f7037acddd43(nodes, function(node) {
            if (node.outEdges.length) {
                var y = $2d32aa0b2cc7dd45$var$sum(node.outEdges, $2d32aa0b2cc7dd45$var$weightedTarget, orient) / $2d32aa0b2cc7dd45$var$sum(node.outEdges, $2d32aa0b2cc7dd45$var$getEdgeValue, orient);
                if (isNaN(y)) {
                    var len = node.outEdges.length;
                    y = len ? $2d32aa0b2cc7dd45$var$sum(node.outEdges, $2d32aa0b2cc7dd45$var$centerTarget, orient) / len : 0;
                }
                if (orient === "vertical") {
                    var nodeX = node.getLayout().x + (y - $2d32aa0b2cc7dd45$var$center(node, orient)) * alpha;
                    node.setLayout({
                        x: nodeX
                    }, true);
                } else {
                    var nodeY = node.getLayout().y + (y - $2d32aa0b2cc7dd45$var$center(node, orient)) * alpha;
                    node.setLayout({
                        y: nodeY
                    }, true);
                }
            }
        });
    });
}
function $2d32aa0b2cc7dd45$var$weightedTarget(edge, orient) {
    return $2d32aa0b2cc7dd45$var$center(edge.node2, orient) * edge.getValue();
}
function $2d32aa0b2cc7dd45$var$centerTarget(edge, orient) {
    return $2d32aa0b2cc7dd45$var$center(edge.node2, orient);
}
function $2d32aa0b2cc7dd45$var$weightedSource(edge, orient) {
    return $2d32aa0b2cc7dd45$var$center(edge.node1, orient) * edge.getValue();
}
function $2d32aa0b2cc7dd45$var$centerSource(edge, orient) {
    return $2d32aa0b2cc7dd45$var$center(edge.node1, orient);
}
function $2d32aa0b2cc7dd45$var$center(node, orient) {
    return orient === "vertical" ? node.getLayout().x + node.getLayout().dx / 2 : node.getLayout().y + node.getLayout().dy / 2;
}
function $2d32aa0b2cc7dd45$var$getEdgeValue(edge) {
    return edge.getValue();
}
function $2d32aa0b2cc7dd45$var$sum(array, cb, orient) {
    var sum = 0;
    var len = array.length;
    var i = -1;
    while(++i < len){
        var value = +cb.call(array, array[i], orient);
        if (!isNaN(value)) sum += value;
    }
    return sum;
}
/**
 * Change the y-position of the nodes, except most the left side nodes
 *
 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
 *     group by the array of all sankey nodes based on the node x-position.
 * @param {number} alpha  parameter used to adjust the nodes y-position
 */ function $2d32aa0b2cc7dd45$var$relaxLeftToRight(nodesByBreadth, alpha, orient) {
    $ec279652dd95c27b$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        $ec279652dd95c27b$export$79b2f7037acddd43(nodes, function(node) {
            if (node.inEdges.length) {
                var y = $2d32aa0b2cc7dd45$var$sum(node.inEdges, $2d32aa0b2cc7dd45$var$weightedSource, orient) / $2d32aa0b2cc7dd45$var$sum(node.inEdges, $2d32aa0b2cc7dd45$var$getEdgeValue, orient);
                if (isNaN(y)) {
                    var len = node.inEdges.length;
                    y = len ? $2d32aa0b2cc7dd45$var$sum(node.inEdges, $2d32aa0b2cc7dd45$var$centerSource, orient) / len : 0;
                }
                if (orient === "vertical") {
                    var nodeX = node.getLayout().x + (y - $2d32aa0b2cc7dd45$var$center(node, orient)) * alpha;
                    node.setLayout({
                        x: nodeX
                    }, true);
                } else {
                    var nodeY = node.getLayout().y + (y - $2d32aa0b2cc7dd45$var$center(node, orient)) * alpha;
                    node.setLayout({
                        y: nodeY
                    }, true);
                }
            }
        });
    });
}
/**
 * Compute the depth(y-position) of each edge
 *
 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
 */ function $2d32aa0b2cc7dd45$var$computeEdgeDepths(nodes, orient) {
    var keyAttr = orient === "vertical" ? "x" : "y";
    $ec279652dd95c27b$export$79b2f7037acddd43(nodes, function(node) {
        node.outEdges.sort(function(a, b) {
            return a.node2.getLayout()[keyAttr] - b.node2.getLayout()[keyAttr];
        });
        node.inEdges.sort(function(a, b) {
            return a.node1.getLayout()[keyAttr] - b.node1.getLayout()[keyAttr];
        });
    });
    $ec279652dd95c27b$export$79b2f7037acddd43(nodes, function(node) {
        var sy = 0;
        var ty = 0;
        $ec279652dd95c27b$export$79b2f7037acddd43(node.outEdges, function(edge) {
            edge.setLayout({
                sy: sy
            }, true);
            sy += edge.getLayout().dy;
        });
        $ec279652dd95c27b$export$79b2f7037acddd43(node.inEdges, function(edge) {
            edge.setLayout({
                ty: ty
            }, true);
            ty += edge.getLayout().dy;
        });
    });
}
$2d32aa0b2cc7dd45$exports = $2d32aa0b2cc7dd45$var$_default;


var $c9c2c94bd2da7951$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $c9c2c94bd2da7951$var$_default(ecModel, payload) {
    ecModel.eachSeriesByType("sankey", function(seriesModel) {
        var graph = seriesModel.getGraph();
        var nodes = graph.nodes;
        if (nodes.length) {
            var minValue = Infinity;
            var maxValue = -Infinity;
            $ec279652dd95c27b$export$79b2f7037acddd43(nodes, function(node) {
                var nodeValue = node.getLayout().value;
                if (nodeValue < minValue) minValue = nodeValue;
                if (nodeValue > maxValue) maxValue = nodeValue;
            });
            $ec279652dd95c27b$export$79b2f7037acddd43(nodes, function(node) {
                var mapping = new $72cc7afb3a2d7026$exports({
                    type: "color",
                    mappingMethod: "linear",
                    dataExtent: [
                        minValue,
                        maxValue
                    ],
                    visual: seriesModel.get("color")
                });
                var mapValueToColor = mapping.mapValueToVisual(node.getLayout().value);
                var customColor = node.getModel().get("itemStyle.color");
                customColor != null ? node.setVisual("color", customColor) : node.setVisual("color", mapValueToColor);
            });
        }
    });
}
$c9c2c94bd2da7951$exports = $c9c2c94bd2da7951$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerLayout($2d32aa0b2cc7dd45$exports);
$f406636b535430a7$exports.registerVisual($c9c2c94bd2da7951$exports);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $329ad190f8dbc9eb$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $639fac15dc0e2de5$export$b1c37a7214e49089;



var $639fac15dc0e2de5$var$getDimensionTypeByAxis = $b5496acb5150a0c1$export$af1622903e71278e;

var $639fac15dc0e2de5$var$makeSeriesEncodeForAxisCoordSys = $71e1a98f99449cca$export$37682b8fdd2e83d;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $639fac15dc0e2de5$var$seriesModelMixin = {
    /**
   * @private
   * @type {string}
   */ _baseAxisDim: null,
    /**
   * @override
   */ getInitialData: function(option, ecModel) {
        // When both types of xAxis and yAxis are 'value', layout is
        // needed to be specified by user. Otherwise, layout can be
        // judged by which axis is category.
        var ordinalMeta;
        var xAxisModel = ecModel.getComponent("xAxis", this.get("xAxisIndex"));
        var yAxisModel = ecModel.getComponent("yAxis", this.get("yAxisIndex"));
        var xAxisType = xAxisModel.get("type");
        var yAxisType = yAxisModel.get("type");
        var addOrdinal; // FIXME
        // Consider time axis.
        if (xAxisType === "category") {
            option.layout = "horizontal";
            ordinalMeta = xAxisModel.getOrdinalMeta();
            addOrdinal = true;
        } else if (yAxisType === "category") {
            option.layout = "vertical";
            ordinalMeta = yAxisModel.getOrdinalMeta();
            addOrdinal = true;
        } else option.layout = option.layout || "horizontal";
        var coordDims = [
            "x",
            "y"
        ];
        var baseAxisDimIndex = option.layout === "horizontal" ? 0 : 1;
        var baseAxisDim = this._baseAxisDim = coordDims[baseAxisDimIndex];
        var otherAxisDim = coordDims[1 - baseAxisDimIndex];
        var axisModels = [
            xAxisModel,
            yAxisModel
        ];
        var baseAxisType = axisModels[baseAxisDimIndex].get("type");
        var otherAxisType = axisModels[1 - baseAxisDimIndex].get("type");
        var data = option.data; // ??? FIXME make a stage to perform data transfrom.
        // MUST create a new data, consider setOption({}) again.
        if (data && addOrdinal) {
            var newOptionData = [];
            $ec279652dd95c27b$export$79b2f7037acddd43(data, function(item, index) {
                var newItem;
                if (item.value && $ec279652dd95c27b$export$43bee75e5e14138e(item.value)) {
                    newItem = item.value.slice();
                    item.value.unshift(index);
                } else if ($ec279652dd95c27b$export$43bee75e5e14138e(item)) {
                    newItem = item.slice();
                    item.unshift(index);
                } else newItem = item;
                newOptionData.push(newItem);
            });
            option.data = newOptionData;
        }
        var defaultValueDimensions = this.defaultValueDimensions;
        var coordDimensions = [
            {
                name: baseAxisDim,
                type: $639fac15dc0e2de5$var$getDimensionTypeByAxis(baseAxisType),
                ordinalMeta: ordinalMeta,
                otherDims: {
                    tooltip: false,
                    itemName: 0
                },
                dimsDef: [
                    "base"
                ]
            },
            {
                name: otherAxisDim,
                type: $639fac15dc0e2de5$var$getDimensionTypeByAxis(otherAxisType),
                dimsDef: defaultValueDimensions.slice()
            }
        ];
        return $1dd6d8dd116bcd7f$exports(this, {
            coordDimensions: coordDimensions,
            dimensionsCount: defaultValueDimensions.length + 1,
            encodeDefaulter: $ec279652dd95c27b$export$c3095a23b368d1f2($639fac15dc0e2de5$var$makeSeriesEncodeForAxisCoordSys, coordDimensions, this)
        });
    },
    /**
   * If horizontal, base axis is x, otherwise y.
   * @override
   */ getBaseAxis: function() {
        var dim = this._baseAxisDim;
        return this.ecModel.getComponent(dim + "Axis", this.get(dim + "AxisIndex")).axis;
    }
};
$639fac15dc0e2de5$export$b1c37a7214e49089 = $639fac15dc0e2de5$var$seriesModelMixin;


var $329ad190f8dbc9eb$var$seriesModelMixin = $639fac15dc0e2de5$export$b1c37a7214e49089;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $329ad190f8dbc9eb$var$BoxplotSeries = $70847df98016d69d$exports.extend({
    type: "series.boxplot",
    dependencies: [
        "xAxis",
        "yAxis",
        "grid"
    ],
    // TODO
    // box width represents group size, so dimension should have 'size'.
    /**
   * @see <https://en.wikipedia.org/wiki/Box_plot>
   * The meanings of 'min' and 'max' depend on user,
   * and echarts do not need to know it.
   * @readOnly
   */ defaultValueDimensions: [
        {
            name: "min",
            defaultTooltip: true
        },
        {
            name: "Q1",
            defaultTooltip: true
        },
        {
            name: "median",
            defaultTooltip: true
        },
        {
            name: "Q3",
            defaultTooltip: true
        },
        {
            name: "max",
            defaultTooltip: true
        }
    ],
    /**
   * @type {Array.<string>}
   * @readOnly
   */ dimensions: null,
    /**
   * @override
   */ defaultOption: {
        zlevel: 0,
        // 一级层叠
        z: 2,
        // 二级层叠
        coordinateSystem: "cartesian2d",
        legendHoverLink: true,
        hoverAnimation: true,
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        layout: null,
        // 'horizontal' or 'vertical'
        boxWidth: [
            7,
            50
        ],
        // [min, max] can be percent of band width.
        itemStyle: {
            color: "#fff",
            borderWidth: 1
        },
        emphasis: {
            itemStyle: {
                borderWidth: 2,
                shadowBlur: 5,
                shadowOffsetX: 2,
                shadowOffsetY: 2,
                shadowColor: "rgba(0,0,0,0.4)"
            }
        },
        animationEasing: "elasticOut",
        animationDuration: 800
    }
});
$ec279652dd95c27b$export$e36fc9d62a853069($329ad190f8dbc9eb$var$BoxplotSeries, $329ad190f8dbc9eb$var$seriesModelMixin, true);
var $329ad190f8dbc9eb$var$_default = $329ad190f8dbc9eb$var$BoxplotSeries;
$329ad190f8dbc9eb$exports = $329ad190f8dbc9eb$var$_default;


var $9278cc45b09f0983$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Update common properties
var $9278cc45b09f0983$var$NORMAL_ITEM_STYLE_PATH = [
    "itemStyle"
];
var $9278cc45b09f0983$var$EMPHASIS_ITEM_STYLE_PATH = [
    "emphasis",
    "itemStyle"
];
var $9278cc45b09f0983$var$BoxplotView = $6448f0aa5ca2bdaa$exports.extend({
    type: "boxplot",
    render: function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var group = this.group;
        var oldData = this._data; // There is no old data only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!this._data) group.removeAll();
        var constDim = seriesModel.get("layout") === "horizontal" ? 1 : 0;
        data.diff(oldData).add(function(newIdx) {
            if (data.hasValue(newIdx)) {
                var itemLayout = data.getItemLayout(newIdx);
                var symbolEl = $9278cc45b09f0983$var$createNormalBox(itemLayout, data, newIdx, constDim, true);
                data.setItemGraphicEl(newIdx, symbolEl);
                group.add(symbolEl);
            }
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx); // Empty data
            if (!data.hasValue(newIdx)) {
                group.remove(symbolEl);
                return;
            }
            var itemLayout = data.getItemLayout(newIdx);
            if (!symbolEl) symbolEl = $9278cc45b09f0983$var$createNormalBox(itemLayout, data, newIdx, constDim);
            else $9278cc45b09f0983$var$updateNormalBoxData(itemLayout, symbolEl, data, newIdx);
            group.add(symbolEl);
            data.setItemGraphicEl(newIdx, symbolEl);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && group.remove(el);
        }).execute();
        this._data = data;
    },
    remove: function(ecModel) {
        var group = this.group;
        var data = this._data;
        this._data = null;
        data && data.eachItemGraphicEl(function(el) {
            el && group.remove(el);
        });
    },
    dispose: $ec279652dd95c27b$export$8793edee2d425525
});
var $9278cc45b09f0983$var$BoxPath = $b9701a0f23f767de$exports.extend({
    type: "boxplotBoxPath",
    shape: {},
    buildPath: function(ctx, shape) {
        var ends = shape.points;
        var i = 0;
        ctx.moveTo(ends[i][0], ends[i][1]);
        i++;
        for(; i < 4; i++)ctx.lineTo(ends[i][0], ends[i][1]);
        ctx.closePath();
        for(; i < ends.length; i++){
            ctx.moveTo(ends[i][0], ends[i][1]);
            i++;
            ctx.lineTo(ends[i][0], ends[i][1]);
        }
    }
});
function $9278cc45b09f0983$var$createNormalBox(itemLayout, data, dataIndex, constDim, isInit) {
    var ends = itemLayout.ends;
    var el = new $9278cc45b09f0983$var$BoxPath({
        shape: {
            points: isInit ? $9278cc45b09f0983$var$transInit(ends, constDim, itemLayout) : ends
        }
    });
    $9278cc45b09f0983$var$updateNormalBoxData(itemLayout, el, data, dataIndex, isInit);
    return el;
}
function $9278cc45b09f0983$var$updateNormalBoxData(itemLayout, el, data, dataIndex, isInit) {
    var seriesModel = data.hostModel;
    var updateMethod = $4b57d6b582d579b7$exports[isInit ? "initProps" : "updateProps"];
    updateMethod(el, {
        shape: {
            points: itemLayout.ends
        }
    }, seriesModel, dataIndex);
    var itemModel = data.getItemModel(dataIndex);
    var normalItemStyleModel = itemModel.getModel($9278cc45b09f0983$var$NORMAL_ITEM_STYLE_PATH);
    var borderColor = data.getItemVisual(dataIndex, "color"); // Exclude borderColor.
    var itemStyle = normalItemStyleModel.getItemStyle([
        "borderColor"
    ]);
    itemStyle.stroke = borderColor;
    itemStyle.strokeNoScale = true;
    el.useStyle(itemStyle);
    el.z2 = 100;
    var hoverStyle = itemModel.getModel($9278cc45b09f0983$var$EMPHASIS_ITEM_STYLE_PATH).getItemStyle();
    $4b57d6b582d579b7$exports.setHoverStyle(el, hoverStyle);
}
function $9278cc45b09f0983$var$transInit(points, dim, itemLayout) {
    return $ec279652dd95c27b$export$871de8747c9eaa88(points, function(point) {
        point = point.slice();
        point[dim] = itemLayout.initBaseline;
        return point;
    });
}
var $9278cc45b09f0983$var$_default = $9278cc45b09f0983$var$BoxplotView;
$9278cc45b09f0983$exports = $9278cc45b09f0983$var$_default;


var $88e78288bdd83e7d$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $88e78288bdd83e7d$var$borderColorQuery = [
    "itemStyle",
    "borderColor"
];
function $88e78288bdd83e7d$var$_default(ecModel, api) {
    var globalColors = ecModel.get("color");
    ecModel.eachRawSeriesByType("boxplot", function(seriesModel) {
        var defaulColor = globalColors[seriesModel.seriesIndex % globalColors.length];
        var data = seriesModel.getData();
        data.setVisual({
            legendSymbol: "roundRect",
            // Use name 'color' but not 'borderColor' for legend usage and
            // visual coding from other component like dataRange.
            color: seriesModel.get($88e78288bdd83e7d$var$borderColorQuery) || defaulColor
        }); // Only visible series has each data be visual encoded
        if (!ecModel.isSeriesFiltered(seriesModel)) data.each(function(idx) {
            var itemModel = data.getItemModel(idx);
            data.setItemVisual(idx, {
                color: itemModel.get($88e78288bdd83e7d$var$borderColorQuery, true)
            });
        });
    });
}
$88e78288bdd83e7d$exports = $88e78288bdd83e7d$var$_default;


var $ac40aeb969e2937f$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $ac40aeb969e2937f$var$parsePercent = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $ac40aeb969e2937f$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
function $ac40aeb969e2937f$var$_default(ecModel) {
    var groupResult = $ac40aeb969e2937f$var$groupSeriesByAxis(ecModel);
    $ac40aeb969e2937f$var$each(groupResult, function(groupItem) {
        var seriesModels = groupItem.seriesModels;
        if (!seriesModels.length) return;
        $ac40aeb969e2937f$var$calculateBase(groupItem);
        $ac40aeb969e2937f$var$each(seriesModels, function(seriesModel, idx) {
            $ac40aeb969e2937f$var$layoutSingleSeries(seriesModel, groupItem.boxOffsetList[idx], groupItem.boxWidthList[idx]);
        });
    });
}
/**
 * Group series by axis.
 */ function $ac40aeb969e2937f$var$groupSeriesByAxis(ecModel) {
    var result = [];
    var axisList = [];
    ecModel.eachSeriesByType("boxplot", function(seriesModel) {
        var baseAxis = seriesModel.getBaseAxis();
        var idx = $ec279652dd95c27b$export$305f7d4e9d4624f2(axisList, baseAxis);
        if (idx < 0) {
            idx = axisList.length;
            axisList[idx] = baseAxis;
            result[idx] = {
                axis: baseAxis,
                seriesModels: []
            };
        }
        result[idx].seriesModels.push(seriesModel);
    });
    return result;
}
/**
 * Calculate offset and box width for each series.
 */ function $ac40aeb969e2937f$var$calculateBase(groupItem) {
    var extent;
    var baseAxis = groupItem.axis;
    var seriesModels = groupItem.seriesModels;
    var seriesCount = seriesModels.length;
    var boxWidthList = groupItem.boxWidthList = [];
    var boxOffsetList = groupItem.boxOffsetList = [];
    var boundList = [];
    var bandWidth;
    if (baseAxis.type === "category") bandWidth = baseAxis.getBandWidth();
    else {
        var maxDataCount = 0;
        $ac40aeb969e2937f$var$each(seriesModels, function(seriesModel) {
            maxDataCount = Math.max(maxDataCount, seriesModel.getData().count());
        });
        extent = baseAxis.getExtent(), extent[1], extent[0];
    }
    $ac40aeb969e2937f$var$each(seriesModels, function(seriesModel) {
        var boxWidthBound = seriesModel.get("boxWidth");
        if (!$ec279652dd95c27b$export$43bee75e5e14138e(boxWidthBound)) boxWidthBound = [
            boxWidthBound,
            boxWidthBound
        ];
        boundList.push([
            $ac40aeb969e2937f$var$parsePercent(boxWidthBound[0], bandWidth) || 0,
            $ac40aeb969e2937f$var$parsePercent(boxWidthBound[1], bandWidth) || 0
        ]);
    });
    var availableWidth = bandWidth * 0.8 - 2;
    var boxGap = availableWidth / seriesCount * 0.3;
    var boxWidth = (availableWidth - boxGap * (seriesCount - 1)) / seriesCount;
    var base = boxWidth / 2 - availableWidth / 2;
    $ac40aeb969e2937f$var$each(seriesModels, function(seriesModel, idx) {
        boxOffsetList.push(base);
        base += boxGap + boxWidth;
        boxWidthList.push(Math.min(Math.max(boxWidth, boundList[idx][0]), boundList[idx][1]));
    });
}
/**
 * Calculate points location for each series.
 */ function $ac40aeb969e2937f$var$layoutSingleSeries(seriesModel, offset, boxWidth) {
    var coordSys = seriesModel.coordinateSystem;
    var data = seriesModel.getData();
    var halfWidth = boxWidth / 2;
    var cDimIdx = seriesModel.get("layout") === "horizontal" ? 0 : 1;
    var vDimIdx = 1 - cDimIdx;
    var coordDims = [
        "x",
        "y"
    ];
    var cDim = data.mapDimension(coordDims[cDimIdx]);
    var vDims = data.mapDimension(coordDims[vDimIdx], true);
    if (cDim == null || vDims.length < 5) return;
    for(var dataIndex = 0; dataIndex < data.count(); dataIndex++){
        var axisDimVal = data.get(cDim, dataIndex);
        var median = getPoint(axisDimVal, vDims[2], dataIndex);
        var end1 = getPoint(axisDimVal, vDims[0], dataIndex);
        var end2 = getPoint(axisDimVal, vDims[1], dataIndex);
        var end4 = getPoint(axisDimVal, vDims[3], dataIndex);
        var end5 = getPoint(axisDimVal, vDims[4], dataIndex);
        var ends = [];
        addBodyEnd(ends, end2, 0);
        addBodyEnd(ends, end4, 1);
        ends.push(end1, end2, end5, end4);
        layEndLine(ends, end1);
        layEndLine(ends, end5);
        layEndLine(ends, median);
        data.setItemLayout(dataIndex, {
            initBaseline: median[vDimIdx],
            ends: ends
        });
    }
    function getPoint(axisDimVal, dimIdx, dataIndex) {
        var val = data.get(dimIdx, dataIndex);
        var p = [];
        p[cDimIdx] = axisDimVal;
        p[vDimIdx] = val;
        var point;
        if (isNaN(axisDimVal) || isNaN(val)) point = [
            NaN,
            NaN
        ];
        else {
            point = coordSys.dataToPoint(p);
            point[cDimIdx] += offset;
        }
        return point;
    }
    function addBodyEnd(ends, point, start) {
        var point1 = point.slice();
        var point2 = point.slice();
        point1[cDimIdx] += halfWidth;
        point2[cDimIdx] -= halfWidth;
        start ? ends.push(point1, point2) : ends.push(point2, point1);
    }
    function layEndLine(ends, endCenter) {
        var from = endCenter.slice();
        var to = endCenter.slice();
        from[cDimIdx] -= halfWidth;
        to[cDimIdx] += halfWidth;
        ends.push(from, to);
    }
}
$ac40aeb969e2937f$exports = $ac40aeb969e2937f$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerVisual($88e78288bdd83e7d$exports);
$f406636b535430a7$exports.registerLayout($ac40aeb969e2937f$exports);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $0d3ec32109c15e79$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $0d3ec32109c15e79$var$seriesModelMixin = $639fac15dc0e2de5$export$b1c37a7214e49089;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $0d3ec32109c15e79$var$CandlestickSeries = $70847df98016d69d$exports.extend({
    type: "series.candlestick",
    dependencies: [
        "xAxis",
        "yAxis",
        "grid"
    ],
    /**
   * @readOnly
   */ defaultValueDimensions: [
        {
            name: "open",
            defaultTooltip: true
        },
        {
            name: "close",
            defaultTooltip: true
        },
        {
            name: "lowest",
            defaultTooltip: true
        },
        {
            name: "highest",
            defaultTooltip: true
        }
    ],
    /**
   * @type {Array.<string>}
   * @readOnly
   */ dimensions: null,
    /**
   * @override
   */ defaultOption: {
        zlevel: 0,
        z: 2,
        coordinateSystem: "cartesian2d",
        legendHoverLink: true,
        hoverAnimation: true,
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        layout: null,
        // 'horizontal' or 'vertical'
        clip: true,
        itemStyle: {
            color: "#c23531",
            // 阳线 positive
            color0: "#314656",
            // 阴线 negative     '#c23531', '#314656'
            borderWidth: 1,
            // FIXME
            // ec2中使用的是lineStyle.color 和 lineStyle.color0
            borderColor: "#c23531",
            borderColor0: "#314656"
        },
        emphasis: {
            itemStyle: {
                borderWidth: 2
            }
        },
        barMaxWidth: null,
        barMinWidth: null,
        barWidth: null,
        large: true,
        largeThreshold: 600,
        progressive: 3e3,
        progressiveThreshold: 1e4,
        progressiveChunkMode: "mod",
        animationUpdate: false,
        animationEasing: "linear",
        animationDuration: 300
    },
    /**
   * Get dimension for shadow in dataZoom
   * @return {string} dimension name
   */ getShadowDim: function() {
        return "open";
    },
    brushSelector: function(dataIndex, data, selectors) {
        var itemLayout = data.getItemLayout(dataIndex);
        return itemLayout && selectors.rect(itemLayout.brushRect);
    }
});
$ec279652dd95c27b$export$e36fc9d62a853069($0d3ec32109c15e79$var$CandlestickSeries, $0d3ec32109c15e79$var$seriesModelMixin, true);
var $0d3ec32109c15e79$var$_default = $0d3ec32109c15e79$var$CandlestickSeries;
$0d3ec32109c15e79$exports = $0d3ec32109c15e79$var$_default;


var $dcbfb167c2b81071$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $dcbfb167c2b81071$var$createClipPath = $df90403704fddb7c$export$e0fe5081209d01c9;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $dcbfb167c2b81071$var$NORMAL_ITEM_STYLE_PATH = [
    "itemStyle"
];
var $dcbfb167c2b81071$var$EMPHASIS_ITEM_STYLE_PATH = [
    "emphasis",
    "itemStyle"
];
var $dcbfb167c2b81071$var$SKIP_PROPS = [
    "color",
    "color0",
    "borderColor",
    "borderColor0"
];
var $dcbfb167c2b81071$var$CandlestickView = $6448f0aa5ca2bdaa$exports.extend({
    type: "candlestick",
    render: function(seriesModel, ecModel, api) {
        // If there is clipPath created in large mode. Remove it.
        this.group.removeClipPath();
        this._updateDrawMode(seriesModel);
        this._isLargeDraw ? this._renderLarge(seriesModel) : this._renderNormal(seriesModel);
    },
    incrementalPrepareRender: function(seriesModel, ecModel, api) {
        this._clear();
        this._updateDrawMode(seriesModel);
    },
    incrementalRender: function(params, seriesModel, ecModel, api) {
        this._isLargeDraw ? this._incrementalRenderLarge(params, seriesModel) : this._incrementalRenderNormal(params, seriesModel);
    },
    _updateDrawMode: function(seriesModel) {
        var isLargeDraw = seriesModel.pipelineContext.large;
        if (this._isLargeDraw == null || isLargeDraw ^ this._isLargeDraw) {
            this._isLargeDraw = isLargeDraw;
            this._clear();
        }
    },
    _renderNormal: function(seriesModel) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        var isSimpleBox = data.getLayout("isSimpleBox");
        var needsClip = seriesModel.get("clip", true);
        var coord = seriesModel.coordinateSystem;
        var clipArea = coord.getArea && coord.getArea(); // There is no old data only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!this._data) group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            if (data.hasValue(newIdx)) {
                var el;
                var itemLayout = data.getItemLayout(newIdx);
                if (needsClip && $dcbfb167c2b81071$var$isNormalBoxClipped(clipArea, itemLayout)) return;
                el = $dcbfb167c2b81071$var$createNormalBox(itemLayout, newIdx, true);
                $4b57d6b582d579b7$export$a121566aadcfe021(el, {
                    shape: {
                        points: itemLayout.ends
                    }
                }, seriesModel, newIdx);
                $dcbfb167c2b81071$var$setBoxCommon(el, data, newIdx, isSimpleBox);
                group.add(el);
                data.setItemGraphicEl(newIdx, el);
            }
        }).update(function(newIdx, oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx); // Empty data
            if (!data.hasValue(newIdx)) {
                group.remove(el);
                return;
            }
            var itemLayout = data.getItemLayout(newIdx);
            if (needsClip && $dcbfb167c2b81071$var$isNormalBoxClipped(clipArea, itemLayout)) {
                group.remove(el);
                return;
            }
            if (!el) el = $dcbfb167c2b81071$var$createNormalBox(itemLayout, newIdx);
            else $4b57d6b582d579b7$export$c8dce3c08436e91e(el, {
                shape: {
                    points: itemLayout.ends
                }
            }, seriesModel, newIdx);
            $dcbfb167c2b81071$var$setBoxCommon(el, data, newIdx, isSimpleBox);
            group.add(el);
            data.setItemGraphicEl(newIdx, el);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && group.remove(el);
        }).execute();
        this._data = data;
    },
    _renderLarge: function(seriesModel) {
        this._clear();
        $dcbfb167c2b81071$var$createLarge(seriesModel, this.group);
        var clipPath = seriesModel.get("clip", true) ? $dcbfb167c2b81071$var$createClipPath(seriesModel.coordinateSystem, false, seriesModel) : null;
        if (clipPath) this.group.setClipPath(clipPath);
        else this.group.removeClipPath();
    },
    _incrementalRenderNormal: function(params, seriesModel) {
        var data = seriesModel.getData();
        var isSimpleBox = data.getLayout("isSimpleBox");
        var dataIndex;
        while((dataIndex = params.next()) != null){
            var el;
            var itemLayout = data.getItemLayout(dataIndex);
            el = $dcbfb167c2b81071$var$createNormalBox(itemLayout, dataIndex);
            $dcbfb167c2b81071$var$setBoxCommon(el, data, dataIndex, isSimpleBox);
            el.incremental = true;
            this.group.add(el);
        }
    },
    _incrementalRenderLarge: function(params, seriesModel) {
        $dcbfb167c2b81071$var$createLarge(seriesModel, this.group, true);
    },
    remove: function(ecModel) {
        this._clear();
    },
    _clear: function() {
        this.group.removeAll();
        this._data = null;
    },
    dispose: $ec279652dd95c27b$export$8793edee2d425525
});
var $dcbfb167c2b81071$var$NormalBoxPath = $b9701a0f23f767de$exports.extend({
    type: "normalCandlestickBox",
    shape: {},
    buildPath: function(ctx, shape) {
        var ends = shape.points;
        if (this.__simpleBox) {
            ctx.moveTo(ends[4][0], ends[4][1]);
            ctx.lineTo(ends[6][0], ends[6][1]);
        } else {
            ctx.moveTo(ends[0][0], ends[0][1]);
            ctx.lineTo(ends[1][0], ends[1][1]);
            ctx.lineTo(ends[2][0], ends[2][1]);
            ctx.lineTo(ends[3][0], ends[3][1]);
            ctx.closePath();
            ctx.moveTo(ends[4][0], ends[4][1]);
            ctx.lineTo(ends[5][0], ends[5][1]);
            ctx.moveTo(ends[6][0], ends[6][1]);
            ctx.lineTo(ends[7][0], ends[7][1]);
        }
    }
});
function $dcbfb167c2b81071$var$createNormalBox(itemLayout, dataIndex, isInit) {
    var ends = itemLayout.ends;
    return new $dcbfb167c2b81071$var$NormalBoxPath({
        shape: {
            points: isInit ? $dcbfb167c2b81071$var$transInit(ends, itemLayout) : ends
        },
        z2: 100
    });
}
function $dcbfb167c2b81071$var$isNormalBoxClipped(clipArea, itemLayout) {
    var clipped = true;
    for(var i = 0; i < itemLayout.ends.length; i++)// If any point are in the region.
    if (clipArea.contain(itemLayout.ends[i][0], itemLayout.ends[i][1])) {
        clipped = false;
        break;
    }
    return clipped;
}
function $dcbfb167c2b81071$var$setBoxCommon(el, data, dataIndex, isSimpleBox) {
    var itemModel = data.getItemModel(dataIndex);
    var normalItemStyleModel = itemModel.getModel($dcbfb167c2b81071$var$NORMAL_ITEM_STYLE_PATH);
    var color = data.getItemVisual(dataIndex, "color");
    var borderColor = data.getItemVisual(dataIndex, "borderColor") || color; // Color must be excluded.
    // Because symbol provide setColor individually to set fill and stroke
    var itemStyle = normalItemStyleModel.getItemStyle($dcbfb167c2b81071$var$SKIP_PROPS);
    el.useStyle(itemStyle);
    el.style.strokeNoScale = true;
    el.style.fill = color;
    el.style.stroke = borderColor;
    el.__simpleBox = isSimpleBox;
    var hoverStyle = itemModel.getModel($dcbfb167c2b81071$var$EMPHASIS_ITEM_STYLE_PATH).getItemStyle();
    $4b57d6b582d579b7$export$28b42df8183f218c(el, hoverStyle);
}
function $dcbfb167c2b81071$var$transInit(points, itemLayout) {
    return $ec279652dd95c27b$export$871de8747c9eaa88(points, function(point) {
        point = point.slice();
        point[1] = itemLayout.initBaseline;
        return point;
    });
}
var $dcbfb167c2b81071$var$LargeBoxPath = $b9701a0f23f767de$exports.extend({
    type: "largeCandlestickBox",
    shape: {},
    buildPath: function(ctx, shape) {
        // Drawing lines is more efficient than drawing
        // a whole line or drawing rects.
        var points = shape.points;
        for(var i = 0; i < points.length;)if (this.__sign === points[i++]) {
            var x = points[i++];
            ctx.moveTo(x, points[i++]);
            ctx.lineTo(x, points[i++]);
        } else i += 3;
    }
});
function $dcbfb167c2b81071$var$createLarge(seriesModel, group, incremental) {
    var data = seriesModel.getData();
    var largePoints = data.getLayout("largePoints");
    var elP = new $dcbfb167c2b81071$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: 1
    });
    group.add(elP);
    var elN = new $dcbfb167c2b81071$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: -1
    });
    group.add(elN);
    $dcbfb167c2b81071$var$setLargeStyle(1, elP, seriesModel, data);
    $dcbfb167c2b81071$var$setLargeStyle(-1, elN, seriesModel, data);
    if (incremental) {
        elP.incremental = true;
        elN.incremental = true;
    }
}
function $dcbfb167c2b81071$var$setLargeStyle(sign, el, seriesModel, data) {
    var suffix = sign > 0 ? "P" : "N";
    var borderColor = data.getVisual("borderColor" + suffix) || data.getVisual("color" + suffix); // Color must be excluded.
    // Because symbol provide setColor individually to set fill and stroke
    var itemStyle = seriesModel.getModel($dcbfb167c2b81071$var$NORMAL_ITEM_STYLE_PATH).getItemStyle($dcbfb167c2b81071$var$SKIP_PROPS);
    el.useStyle(itemStyle);
    el.style.fill = null;
    el.style.stroke = borderColor; // No different
// el.style.lineWidth = .5;
}
var $dcbfb167c2b81071$var$_default = $dcbfb167c2b81071$var$CandlestickView;
$dcbfb167c2b81071$exports = $dcbfb167c2b81071$var$_default;


var $379c3c9176a27bb5$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $379c3c9176a27bb5$var$_default(option) {
    if (!option || !$ec279652dd95c27b$export$43bee75e5e14138e(option.series)) return;
     // Translate 'k' to 'candlestick'.
    $ec279652dd95c27b$export$79b2f7037acddd43(option.series, function(seriesItem) {
        if ($ec279652dd95c27b$export$a6cdc56e425d0d0a(seriesItem) && seriesItem.type === "k") seriesItem.type = "candlestick";
    });
}
$379c3c9176a27bb5$exports = $379c3c9176a27bb5$var$_default;


var $06ea117e2d13ba60$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $06ea117e2d13ba60$var$positiveBorderColorQuery = [
    "itemStyle",
    "borderColor"
];
var $06ea117e2d13ba60$var$negativeBorderColorQuery = [
    "itemStyle",
    "borderColor0"
];
var $06ea117e2d13ba60$var$positiveColorQuery = [
    "itemStyle",
    "color"
];
var $06ea117e2d13ba60$var$negativeColorQuery = [
    "itemStyle",
    "color0"
];
var $06ea117e2d13ba60$var$_default = {
    seriesType: "candlestick",
    plan: $a77c5f604e87a748$exports(),
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        data.setVisual({
            legendSymbol: "roundRect",
            colorP: getColor(1, seriesModel),
            colorN: getColor(-1, seriesModel),
            borderColorP: getBorderColor(1, seriesModel),
            borderColorN: getBorderColor(-1, seriesModel)
        }); // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var isLargeRender = seriesModel.pipelineContext.large;
        return !isLargeRender && {
            progress: progress
        };
        function progress(params, data) {
            var dataIndex;
            while((dataIndex = params.next()) != null){
                var itemModel = data.getItemModel(dataIndex);
                var sign = data.getItemLayout(dataIndex).sign;
                data.setItemVisual(dataIndex, {
                    color: getColor(sign, itemModel),
                    borderColor: getBorderColor(sign, itemModel)
                });
            }
        }
        function getColor(sign, model) {
            return model.get(sign > 0 ? $06ea117e2d13ba60$var$positiveColorQuery : $06ea117e2d13ba60$var$negativeColorQuery);
        }
        function getBorderColor(sign, model) {
            return model.get(sign > 0 ? $06ea117e2d13ba60$var$positiveBorderColorQuery : $06ea117e2d13ba60$var$negativeBorderColorQuery);
        }
    }
};
$06ea117e2d13ba60$exports = $06ea117e2d13ba60$var$_default;


var $7887b3834f69325a$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7887b3834f69325a$var$subPixelOptimize = $4b57d6b582d579b7$export$72c4fd4c1b8fcb10;


var $7887b3834f69325a$var$parsePercent = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f;

var $7887b3834f69325a$var$retrieve2 = $ec279652dd95c27b$export$995e01f2f5c9d030;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Float32Array */ var $7887b3834f69325a$var$LargeArr = typeof Float32Array !== "undefined" ? Float32Array : Array;
var $7887b3834f69325a$var$_default = {
    seriesType: "candlestick",
    plan: $a77c5f604e87a748$exports(),
    reset: function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var data = seriesModel.getData();
        var candleWidth = $7887b3834f69325a$var$calculateCandleWidth(seriesModel, data);
        var cDimIdx = 0;
        var vDimIdx = 1;
        var coordDims = [
            "x",
            "y"
        ];
        var cDim = data.mapDimension(coordDims[cDimIdx]);
        var vDims = data.mapDimension(coordDims[vDimIdx], true);
        var openDim = vDims[0];
        var closeDim = vDims[1];
        var lowestDim = vDims[2];
        var highestDim = vDims[3];
        data.setLayout({
            candleWidth: candleWidth,
            // The value is experimented visually.
            isSimpleBox: candleWidth <= 1.3
        });
        if (cDim == null || vDims.length < 4) return;
        return {
            progress: seriesModel.pipelineContext.large ? largeProgress : normalProgress
        };
        function normalProgress(params, data) {
            var dataIndex;
            while((dataIndex = params.next()) != null){
                var axisDimVal = data.get(cDim, dataIndex);
                var openVal = data.get(openDim, dataIndex);
                var closeVal = data.get(closeDim, dataIndex);
                var lowestVal = data.get(lowestDim, dataIndex);
                var highestVal = data.get(highestDim, dataIndex);
                var ocLow = Math.min(openVal, closeVal);
                var ocHigh = Math.max(openVal, closeVal);
                var ocLowPoint = getPoint(ocLow, axisDimVal);
                var ocHighPoint = getPoint(ocHigh, axisDimVal);
                var lowestPoint = getPoint(lowestVal, axisDimVal);
                var highestPoint = getPoint(highestVal, axisDimVal);
                var ends = [];
                addBodyEnd(ends, ocHighPoint, 0);
                addBodyEnd(ends, ocLowPoint, 1);
                ends.push(subPixelOptimizePoint(highestPoint), subPixelOptimizePoint(ocHighPoint), subPixelOptimizePoint(lowestPoint), subPixelOptimizePoint(ocLowPoint));
                data.setItemLayout(dataIndex, {
                    sign: $7887b3834f69325a$var$getSign(data, dataIndex, openVal, closeVal, closeDim),
                    initBaseline: openVal > closeVal ? ocHighPoint[vDimIdx] : ocLowPoint[vDimIdx],
                    // open point.
                    ends: ends,
                    brushRect: makeBrushRect(lowestVal, highestVal, axisDimVal)
                });
            }
            function getPoint(val, axisDimVal) {
                var p = [];
                p[cDimIdx] = axisDimVal;
                p[vDimIdx] = val;
                return isNaN(axisDimVal) || isNaN(val) ? [
                    NaN,
                    NaN
                ] : coordSys.dataToPoint(p);
            }
            function addBodyEnd(ends, point, start) {
                var point1 = point.slice();
                var point2 = point.slice();
                point1[cDimIdx] = $7887b3834f69325a$var$subPixelOptimize(point1[cDimIdx] + candleWidth / 2, 1, false);
                point2[cDimIdx] = $7887b3834f69325a$var$subPixelOptimize(point2[cDimIdx] - candleWidth / 2, 1, true);
                start ? ends.push(point1, point2) : ends.push(point2, point1);
            }
            function makeBrushRect(lowestVal, highestVal, axisDimVal) {
                var pmin = getPoint(lowestVal, axisDimVal);
                var pmax = getPoint(highestVal, axisDimVal);
                pmin[cDimIdx] -= candleWidth / 2;
                pmax[cDimIdx] -= candleWidth / 2;
                return {
                    x: pmin[0],
                    y: pmin[1],
                    width: vDimIdx ? candleWidth : pmax[0] - pmin[0],
                    height: vDimIdx ? pmax[1] - pmin[1] : candleWidth
                };
            }
            function subPixelOptimizePoint(point) {
                point[cDimIdx] = $7887b3834f69325a$var$subPixelOptimize(point[cDimIdx], 1);
                return point;
            }
        }
        function largeProgress(params, data) {
            // Structure: [sign, x, yhigh, ylow, sign, x, yhigh, ylow, ...]
            var points = new $7887b3834f69325a$var$LargeArr(params.count * 4);
            var offset = 0;
            var point;
            var tmpIn = [];
            var tmpOut = [];
            var dataIndex;
            while((dataIndex = params.next()) != null){
                var axisDimVal = data.get(cDim, dataIndex);
                var openVal = data.get(openDim, dataIndex);
                var closeVal = data.get(closeDim, dataIndex);
                var lowestVal = data.get(lowestDim, dataIndex);
                var highestVal = data.get(highestDim, dataIndex);
                if (isNaN(axisDimVal) || isNaN(lowestVal) || isNaN(highestVal)) {
                    points[offset++] = NaN;
                    offset += 3;
                    continue;
                }
                points[offset++] = $7887b3834f69325a$var$getSign(data, dataIndex, openVal, closeVal, closeDim);
                tmpIn[cDimIdx] = axisDimVal;
                tmpIn[vDimIdx] = lowestVal;
                point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                points[offset++] = point ? point[0] : NaN;
                points[offset++] = point ? point[1] : NaN;
                tmpIn[vDimIdx] = highestVal;
                point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                points[offset++] = point ? point[1] : NaN;
            }
            data.setLayout("largePoints", points);
        }
    }
};
function $7887b3834f69325a$var$getSign(data, dataIndex, openVal, closeVal, closeDim) {
    var sign;
    if (openVal > closeVal) sign = -1;
    else if (openVal < closeVal) sign = 1;
    else sign = dataIndex > 0 // If close === open, compare with close of last record
     ? data.get(closeDim, dataIndex - 1) <= closeVal ? 1 : -1 : 1;
    return sign;
}
function $7887b3834f69325a$var$calculateCandleWidth(seriesModel, data) {
    var baseAxis = seriesModel.getBaseAxis();
    var extent;
    var bandWidth = baseAxis.type === "category" ? baseAxis.getBandWidth() : (extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / data.count());
    var barMaxWidth = $7887b3834f69325a$var$parsePercent($7887b3834f69325a$var$retrieve2(seriesModel.get("barMaxWidth"), bandWidth), bandWidth);
    var barMinWidth = $7887b3834f69325a$var$parsePercent($7887b3834f69325a$var$retrieve2(seriesModel.get("barMinWidth"), 1), bandWidth);
    var barWidth = seriesModel.get("barWidth");
    return barWidth != null ? $7887b3834f69325a$var$parsePercent(barWidth, bandWidth) // Put max outer to ensure bar visible in spite of overlap.
     : Math.max(Math.min(bandWidth / 2, barMaxWidth), barMinWidth);
}
$7887b3834f69325a$exports = $7887b3834f69325a$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerPreprocessor($379c3c9176a27bb5$exports);
$f406636b535430a7$exports.registerVisual($06ea117e2d13ba60$exports);
$f406636b535430a7$exports.registerLayout($7887b3834f69325a$exports);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $b69e79cb234e2441$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $b69e79cb234e2441$var$_default = $70847df98016d69d$exports.extend({
    type: "series.effectScatter",
    dependencies: [
        "grid",
        "polar"
    ],
    getInitialData: function(option, ecModel) {
        return $10e48b57e44af7c1$exports(this.getSource(), this, {
            useEncodeDefaulter: true
        });
    },
    brushSelector: "point",
    defaultOption: {
        coordinateSystem: "cartesian2d",
        zlevel: 0,
        z: 2,
        legendHoverLink: true,
        effectType: "ripple",
        progressive: 0,
        // When to show the effect, option: 'render'|'emphasis'
        showEffectOn: "render",
        // Ripple effect config
        rippleEffect: {
            period: 4,
            // Scale of ripple
            scale: 2.5,
            // Brush type can be fill or stroke
            brushType: "fill"
        },
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // Polar coordinate system
        // polarIndex: 0,
        // Geo coordinate system
        // geoIndex: 0,
        // symbol: null,        // 图形类型
        symbolSize: 10 // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
    }
});
$b69e79cb234e2441$exports = $b69e79cb234e2441$var$_default;


var $acd079fa5165bf94$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $b305ae720916924a$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $b305ae720916924a$var$createSymbol = $804dcb9a0b78b5fe$export$af050e04da3a02e8;

var $b305ae720916924a$var$Group = $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4;

var $b305ae720916924a$var$parsePercent = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Symbol with ripple effect
 * @module echarts/chart/helper/EffectSymbol
 */ var $b305ae720916924a$var$EFFECT_RIPPLE_NUMBER = 3;
function $b305ae720916924a$var$normalizeSymbolSize(symbolSize) {
    if (!$ec279652dd95c27b$export$43bee75e5e14138e(symbolSize)) symbolSize = [
        +symbolSize,
        +symbolSize
    ];
    return symbolSize;
}
function $b305ae720916924a$var$updateRipplePath(rippleGroup, effectCfg) {
    var color = effectCfg.rippleEffectColor || effectCfg.color;
    rippleGroup.eachChild(function(ripplePath) {
        ripplePath.attr({
            z: effectCfg.z,
            zlevel: effectCfg.zlevel,
            style: {
                stroke: effectCfg.brushType === "stroke" ? color : null,
                fill: effectCfg.brushType === "fill" ? color : null
            }
        });
    });
}
/**
 * @constructor
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @extends {module:zrender/graphic/Group}
 */ function $b305ae720916924a$var$EffectSymbol(data, idx) {
    $b305ae720916924a$var$Group.call(this);
    var symbol = new $051ad5e1a7c7bd92$exports(data, idx);
    var rippleGroup = new $b305ae720916924a$var$Group();
    this.add(symbol);
    this.add(rippleGroup);
    rippleGroup.beforeUpdate = function() {
        this.attr(symbol.getScale());
    };
    this.updateData(data, idx);
}
var $b305ae720916924a$var$effectSymbolProto = $b305ae720916924a$var$EffectSymbol.prototype;
$b305ae720916924a$var$effectSymbolProto.stopEffectAnimation = function() {
    this.childAt(1).removeAll();
};
$b305ae720916924a$var$effectSymbolProto.startEffectAnimation = function(effectCfg) {
    var symbolType = effectCfg.symbolType;
    var color = effectCfg.color;
    var rippleGroup = this.childAt(1);
    for(var i = 0; i < $b305ae720916924a$var$EFFECT_RIPPLE_NUMBER; i++){
        // If width/height are set too small (e.g., set to 1) on ios10
        // and macOS Sierra, a circle stroke become a rect, no matter what
        // the scale is set. So we set width/height as 2. See #4136.
        var ripplePath = $b305ae720916924a$var$createSymbol(symbolType, -1, -1, 2, 2, color);
        ripplePath.attr({
            style: {
                strokeNoScale: true
            },
            z2: 99,
            silent: true,
            scale: [
                0.5,
                0.5
            ]
        });
        var delay = -i / $b305ae720916924a$var$EFFECT_RIPPLE_NUMBER * effectCfg.period + effectCfg.effectOffset; // TODO Configurable effectCfg.period
        ripplePath.animate("", true).when(effectCfg.period, {
            scale: [
                effectCfg.rippleScale / 2,
                effectCfg.rippleScale / 2
            ]
        }).delay(delay).start();
        ripplePath.animateStyle(true).when(effectCfg.period, {
            opacity: 0
        }).delay(delay).start();
        rippleGroup.add(ripplePath);
    }
    $b305ae720916924a$var$updateRipplePath(rippleGroup, effectCfg);
};
/**
 * Update effect symbol
 */ $b305ae720916924a$var$effectSymbolProto.updateEffectAnimation = function(effectCfg) {
    var oldEffectCfg = this._effectCfg;
    var rippleGroup = this.childAt(1); // Must reinitialize effect if following configuration changed
    var DIFFICULT_PROPS = [
        "symbolType",
        "period",
        "rippleScale"
    ];
    for(var i = 0; i < DIFFICULT_PROPS.length; i++){
        var propName = DIFFICULT_PROPS[i];
        if (oldEffectCfg[propName] !== effectCfg[propName]) {
            this.stopEffectAnimation();
            this.startEffectAnimation(effectCfg);
            return;
        }
    }
    $b305ae720916924a$var$updateRipplePath(rippleGroup, effectCfg);
};
/**
 * Highlight symbol
 */ $b305ae720916924a$var$effectSymbolProto.highlight = function() {
    this.trigger("emphasis");
};
/**
 * Downplay symbol
 */ $b305ae720916924a$var$effectSymbolProto.downplay = function() {
    this.trigger("normal");
};
/**
 * Update symbol properties
 * @param  {module:echarts/data/List} data
 * @param  {number} idx
 */ $b305ae720916924a$var$effectSymbolProto.updateData = function(data, idx) {
    var seriesModel = data.hostModel;
    this.childAt(0).updateData(data, idx);
    var rippleGroup = this.childAt(1);
    var itemModel = data.getItemModel(idx);
    var symbolType = data.getItemVisual(idx, "symbol");
    var symbolSize = $b305ae720916924a$var$normalizeSymbolSize(data.getItemVisual(idx, "symbolSize"));
    var color = data.getItemVisual(idx, "color");
    rippleGroup.attr("scale", symbolSize);
    rippleGroup.traverse(function(ripplePath) {
        ripplePath.attr({
            fill: color
        });
    });
    var symbolOffset = itemModel.getShallow("symbolOffset");
    if (symbolOffset) {
        var pos = rippleGroup.position;
        pos[0] = $b305ae720916924a$var$parsePercent(symbolOffset[0], symbolSize[0]);
        pos[1] = $b305ae720916924a$var$parsePercent(symbolOffset[1], symbolSize[1]);
    }
    var symbolRotate = data.getItemVisual(idx, "symbolRotate");
    rippleGroup.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
    var effectCfg = {};
    effectCfg.showEffectOn = seriesModel.get("showEffectOn");
    effectCfg.rippleScale = itemModel.get("rippleEffect.scale");
    effectCfg.brushType = itemModel.get("rippleEffect.brushType");
    effectCfg.period = itemModel.get("rippleEffect.period") * 1000;
    effectCfg.effectOffset = idx / data.count();
    effectCfg.z = itemModel.getShallow("z") || 0;
    effectCfg.zlevel = itemModel.getShallow("zlevel") || 0;
    effectCfg.symbolType = symbolType;
    effectCfg.color = color;
    effectCfg.rippleEffectColor = itemModel.get("rippleEffect.color");
    this.off("mouseover").off("mouseout").off("emphasis").off("normal");
    if (effectCfg.showEffectOn === "render") {
        this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
        this._effectCfg = effectCfg;
    } else {
        // Not keep old effect config
        this._effectCfg = null;
        this.stopEffectAnimation();
        var symbol = this.childAt(0);
        var onEmphasis = function() {
            symbol.highlight();
            if (effectCfg.showEffectOn !== "render") this.startEffectAnimation(effectCfg);
        };
        var onNormal = function() {
            symbol.downplay();
            if (effectCfg.showEffectOn !== "render") this.stopEffectAnimation();
        };
        this.on("mouseover", onEmphasis, this).on("mouseout", onNormal, this).on("emphasis", onEmphasis, this).on("normal", onNormal, this);
    }
    this._effectCfg = effectCfg;
};
$b305ae720916924a$var$effectSymbolProto.fadeOut = function(cb) {
    this.off("mouseover").off("mouseout").off("emphasis").off("normal");
    cb && cb();
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($b305ae720916924a$var$EffectSymbol, $b305ae720916924a$var$Group);
var $b305ae720916924a$var$_default = $b305ae720916924a$var$EffectSymbol;
$b305ae720916924a$exports = $b305ae720916924a$var$_default;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $acd079fa5165bf94$var$_default = $f406636b535430a7$exports.extendChartView({
    type: "effectScatter",
    init: function() {
        this._symbolDraw = new $e99d13e2181fb062$exports($b305ae720916924a$exports);
    },
    render: function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var effectSymbolDraw = this._symbolDraw;
        effectSymbolDraw.updateData(data);
        this.group.add(effectSymbolDraw.group);
    },
    updateTransform: function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        this.group.dirty();
        var res = $c76a359a25b70ceb$exports().reset(seriesModel);
        if (res.progress) res.progress({
            start: 0,
            end: data.count()
        }, data);
        this._symbolDraw.updateLayout(data);
    },
    _updateGroupTransform: function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.getRoamTransform) {
            this.group.transform = $6c6dd9610ba660f0$export$9cd59f9826255e47(coordSys.getRoamTransform());
            this.group.decomposeTransform();
        }
    },
    remove: function(ecModel, api) {
        this._symbolDraw && this._symbolDraw.remove(api);
    },
    dispose: function() {}
});
$acd079fa5165bf94$exports = $acd079fa5165bf94$var$_default;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerVisual($6efa4c3507ca2b4d$exports("effectScatter", "circle"));
$f406636b535430a7$exports.registerLayout($c76a359a25b70ceb$exports("effectScatter"));


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ea397e7c75bae32a$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ea397e7c75bae32a$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;



var $ea397e7c75bae32a$var$concatArray = $ec279652dd95c27b$export$4fd8af2c48c43416;
var $ea397e7c75bae32a$var$mergeAll = $ec279652dd95c27b$export$18aef43295bbe906;
var $ea397e7c75bae32a$var$map = $ec279652dd95c27b$export$871de8747c9eaa88;

var $ea397e7c75bae32a$var$encodeHTML = $a4be9366aeb9fcc8$export$f9d6449b9af28dc1;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Uint32Array, Float64Array, Float32Array */ var $ea397e7c75bae32a$var$Uint32Arr = typeof Uint32Array === "undefined" ? Array : Uint32Array;
var $ea397e7c75bae32a$var$Float64Arr = typeof Float64Array === "undefined" ? Array : Float64Array;
function $ea397e7c75bae32a$var$compatEc2(seriesOpt) {
    var data = seriesOpt.data;
    if (data && data[0] && data[0][0] && data[0][0].coord) seriesOpt.data = $ea397e7c75bae32a$var$map(data, function(itemOpt) {
        var coords = [
            itemOpt[0].coord,
            itemOpt[1].coord
        ];
        var target = {
            coords: coords
        };
        if (itemOpt[0].name) target.fromName = itemOpt[0].name;
        if (itemOpt[1].name) target.toName = itemOpt[1].name;
        return $ea397e7c75bae32a$var$mergeAll([
            target,
            itemOpt[0],
            itemOpt[1]
        ]);
    });
}
var $ea397e7c75bae32a$var$LinesSeries = $70847df98016d69d$exports.extend({
    type: "series.lines",
    dependencies: [
        "grid",
        "polar"
    ],
    visualColorAccessPath: "lineStyle.color",
    init: function(option) {
        // The input data may be null/undefined.
        option.data = option.data || []; // Not using preprocessor because mergeOption may not have series.type
        $ea397e7c75bae32a$var$compatEc2(option);
        var result = this._processFlatCoordsArray(option.data);
        this._flatCoords = result.flatCoords;
        this._flatCoordsOffset = result.flatCoordsOffset;
        if (result.flatCoords) option.data = new Float32Array(result.count);
        $ea397e7c75bae32a$var$LinesSeries.superApply(this, "init", arguments);
    },
    mergeOption: function(option) {
        $ea397e7c75bae32a$var$compatEc2(option);
        if (option.data) {
            // Only update when have option data to merge.
            var result = this._processFlatCoordsArray(option.data);
            this._flatCoords = result.flatCoords;
            this._flatCoordsOffset = result.flatCoordsOffset;
            if (result.flatCoords) option.data = new Float32Array(result.count);
        }
        $ea397e7c75bae32a$var$LinesSeries.superApply(this, "mergeOption", arguments);
    },
    appendData: function(params) {
        var result = this._processFlatCoordsArray(params.data);
        if (result.flatCoords) {
            if (!this._flatCoords) {
                this._flatCoords = result.flatCoords;
                this._flatCoordsOffset = result.flatCoordsOffset;
            } else {
                this._flatCoords = $ea397e7c75bae32a$var$concatArray(this._flatCoords, result.flatCoords);
                this._flatCoordsOffset = $ea397e7c75bae32a$var$concatArray(this._flatCoordsOffset, result.flatCoordsOffset);
            }
            params.data = new Float32Array(result.count);
        }
        this.getRawData().appendData(params.data);
    },
    _getCoordsFromItemModel: function(idx) {
        var itemModel = this.getData().getItemModel(idx);
        var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.getShallow("coords");
        return coords;
    },
    getLineCoordsCount: function(idx) {
        if (this._flatCoordsOffset) return this._flatCoordsOffset[idx * 2 + 1];
        else return this._getCoordsFromItemModel(idx).length;
    },
    getLineCoords: function(idx, out) {
        if (this._flatCoordsOffset) {
            var offset = this._flatCoordsOffset[idx * 2];
            var len = this._flatCoordsOffset[idx * 2 + 1];
            for(var i = 0; i < len; i++){
                out[i] = out[i] || [];
                out[i][0] = this._flatCoords[offset + i * 2];
                out[i][1] = this._flatCoords[offset + i * 2 + 1];
            }
            return len;
        } else {
            var coords = this._getCoordsFromItemModel(idx);
            for(var i = 0; i < coords.length; i++){
                out[i] = out[i] || [];
                out[i][0] = coords[i][0];
                out[i][1] = coords[i][1];
            }
            return coords.length;
        }
    },
    _processFlatCoordsArray: function(data) {
        var startOffset = 0;
        if (this._flatCoords) startOffset = this._flatCoords.length;
         // Stored as a typed array. In format
        // Points Count(2) | x | y | x | y | Points Count(3) | x |  y | x | y | x | y |
        if (typeof data[0] === "number") {
            var len = data.length; // Store offset and len of each segment
            var coordsOffsetAndLenStorage = new $ea397e7c75bae32a$var$Uint32Arr(len);
            var coordsStorage = new $ea397e7c75bae32a$var$Float64Arr(len);
            var coordsCursor = 0;
            var offsetCursor = 0;
            var dataCount = 0;
            for(var i = 0; i < len;){
                dataCount++;
                var count = data[i++]; // Offset
                coordsOffsetAndLenStorage[offsetCursor++] = coordsCursor + startOffset; // Len
                coordsOffsetAndLenStorage[offsetCursor++] = count;
                for(var k = 0; k < count; k++){
                    var x = data[i++];
                    var y = data[i++];
                    coordsStorage[coordsCursor++] = x;
                    coordsStorage[coordsCursor++] = y;
                }
            }
            return {
                flatCoordsOffset: new Uint32Array(coordsOffsetAndLenStorage.buffer, 0, offsetCursor),
                flatCoords: coordsStorage,
                count: dataCount
            };
        }
        return {
            flatCoordsOffset: null,
            flatCoords: null,
            count: data.length
        };
    },
    getInitialData: function(option, ecModel) {
        var lineData = new $f643df856475f69e$exports([
            "value"
        ], this);
        lineData.hasItemOption = false;
        lineData.initData(option.data, [], function(dataItem, dimName, dataIndex, dimIndex) {
            // dataItem is simply coords
            if (dataItem instanceof Array) return NaN;
            else {
                lineData.hasItemOption = true;
                var value = dataItem.value;
                if (value != null) return value instanceof Array ? value[dimIndex] : value;
            }
        });
        return lineData;
    },
    formatTooltip: function(dataIndex) {
        var data = this.getData();
        var itemModel = data.getItemModel(dataIndex);
        var name = itemModel.get("name");
        if (name) return name;
        var fromName = itemModel.get("fromName");
        var toName = itemModel.get("toName");
        var html = [];
        fromName != null && html.push(fromName);
        toName != null && html.push(toName);
        return $ea397e7c75bae32a$var$encodeHTML(html.join(" > "));
    },
    preventIncremental: function() {
        return !!this.get("effect.show");
    },
    getProgressive: function() {
        var progressive = this.option.progressive;
        if (progressive == null) return this.option.large ? 1e4 : this.get("progressive");
        return progressive;
    },
    getProgressiveThreshold: function() {
        var progressiveThreshold = this.option.progressiveThreshold;
        if (progressiveThreshold == null) return this.option.large ? 2e4 : this.get("progressiveThreshold");
        return progressiveThreshold;
    },
    defaultOption: {
        coordinateSystem: "geo",
        zlevel: 0,
        z: 2,
        legendHoverLink: true,
        hoverAnimation: true,
        // Cartesian coordinate system
        xAxisIndex: 0,
        yAxisIndex: 0,
        symbol: [
            "none",
            "none"
        ],
        symbolSize: [
            10,
            10
        ],
        // Geo coordinate system
        geoIndex: 0,
        effect: {
            show: false,
            period: 4,
            // Animation delay. support callback
            // delay: 0,
            // If move with constant speed px/sec
            // period will be ignored if this property is > 0,
            constantSpeed: 0,
            symbol: "circle",
            symbolSize: 3,
            loop: true,
            // Length of trail, 0 - 1
            trailLength: 0.2 // Same with lineStyle.color
        },
        large: false,
        // Available when large is true
        largeThreshold: 2000,
        // If lines are polyline
        // polyline not support curveness, label, animation
        polyline: false,
        // If clip the overflow.
        // Available when coordinateSystem is cartesian or polar.
        clip: true,
        label: {
            show: false,
            position: "end" // distance: 5,
        },
        lineStyle: {
            opacity: 0.5
        }
    }
});
var $ea397e7c75bae32a$var$_default = $ea397e7c75bae32a$var$LinesSeries;
$ea397e7c75bae32a$exports = $ea397e7c75bae32a$var$_default;


var $05ca32e13df06090$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $05ca32e13df06090$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;


var $93721fb902e8b0d1$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $93721fb902e8b0d1$var$createSymbol = $804dcb9a0b78b5fe$export$af050e04da3a02e8;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Provide effect for line
 * @module echarts/chart/helper/EffectLine
 */ /**
 * @constructor
 * @extends {module:zrender/graphic/Group}
 * @alias {module:echarts/chart/helper/Line}
 */ function $93721fb902e8b0d1$var$EffectLine(lineData, idx, seriesScope) {
    $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4.call(this);
    this.add(this.createLine(lineData, idx, seriesScope));
    this._updateEffectSymbol(lineData, idx);
}
var $93721fb902e8b0d1$var$effectLineProto = $93721fb902e8b0d1$var$EffectLine.prototype;
$93721fb902e8b0d1$var$effectLineProto.createLine = function(lineData, idx, seriesScope) {
    return new $6dd196751040d665$exports(lineData, idx, seriesScope);
};
$93721fb902e8b0d1$var$effectLineProto._updateEffectSymbol = function(lineData, idx) {
    var itemModel = lineData.getItemModel(idx);
    var effectModel = itemModel.getModel("effect");
    var size = effectModel.get("symbolSize");
    var symbolType = effectModel.get("symbol");
    if (!$ec279652dd95c27b$export$43bee75e5e14138e(size)) size = [
        size,
        size
    ];
    var color = effectModel.get("color") || lineData.getItemVisual(idx, "color");
    var symbol = this.childAt(1);
    if (this._symbolType !== symbolType) {
        // Remove previous
        this.remove(symbol);
        symbol = $93721fb902e8b0d1$var$createSymbol(symbolType, -0.5, -0.5, 1, 1, color);
        symbol.z2 = 100;
        symbol.culling = true;
        this.add(symbol);
    } // Symbol may be removed if loop is false
    if (!symbol) return;
     // Shadow color is same with color in default
    symbol.setStyle("shadowColor", color);
    symbol.setStyle(effectModel.getItemStyle([
        "color"
    ]));
    symbol.attr("scale", size);
    symbol.setColor(color);
    symbol.attr("scale", size);
    this._symbolType = symbolType;
    this._symbolScale = size;
    this._updateEffectAnimation(lineData, effectModel, idx);
};
$93721fb902e8b0d1$var$effectLineProto._updateEffectAnimation = function(lineData, effectModel, idx) {
    var symbol = this.childAt(1);
    if (!symbol) return;
    var self = this;
    var points = lineData.getItemLayout(idx);
    var period = effectModel.get("period") * 1000;
    var loop = effectModel.get("loop");
    var constantSpeed = effectModel.get("constantSpeed");
    var delayExpr = $ec279652dd95c27b$export$8a4d17b6e8486e66(effectModel.get("delay"), function(idx) {
        return idx / lineData.count() * period / 3;
    });
    var isDelayFunc = typeof delayExpr === "function"; // Ignore when updating
    symbol.ignore = true;
    this.updateAnimationPoints(symbol, points);
    if (constantSpeed > 0) period = this.getLineLength(symbol) / constantSpeed * 1000;
    if (period !== this._period || loop !== this._loop) {
        symbol.stopAnimation();
        var delay = delayExpr;
        if (isDelayFunc) delay = delayExpr(idx);
        if (symbol.__t > 0) delay = -period * symbol.__t;
        symbol.__t = 0;
        var animator = symbol.animate("", loop).when(period, {
            __t: 1
        }).delay(delay).during(function() {
            self.updateSymbolPosition(symbol);
        });
        if (!loop) animator.done(function() {
            self.remove(symbol);
        });
        animator.start();
    }
    this._period = period;
    this._loop = loop;
};
$93721fb902e8b0d1$var$effectLineProto.getLineLength = function(symbol) {
    // Not so accurate
    return $9eb63d101f3bcd79$export$6c4a311cc157c764(symbol.__p1, symbol.__cp1) + $9eb63d101f3bcd79$export$6c4a311cc157c764(symbol.__cp1, symbol.__p2);
};
$93721fb902e8b0d1$var$effectLineProto.updateAnimationPoints = function(symbol, points) {
    symbol.__p1 = points[0];
    symbol.__p2 = points[1];
    symbol.__cp1 = points[2] || [
        (points[0][0] + points[1][0]) / 2,
        (points[0][1] + points[1][1]) / 2
    ];
};
$93721fb902e8b0d1$var$effectLineProto.updateData = function(lineData, idx, seriesScope) {
    this.childAt(0).updateData(lineData, idx, seriesScope);
    this._updateEffectSymbol(lineData, idx);
};
$93721fb902e8b0d1$var$effectLineProto.updateSymbolPosition = function(symbol) {
    var p1 = symbol.__p1;
    var p2 = symbol.__p2;
    var cp1 = symbol.__cp1;
    var t = symbol.__t;
    var pos = symbol.position;
    var lastPos = [
        pos[0],
        pos[1]
    ];
    var quadraticAt = $ab3ad2315df1d857$export$af17094a950f5073;
    var quadraticDerivativeAt = $ab3ad2315df1d857$export$7e161e77e6fff8cb;
    pos[0] = quadraticAt(p1[0], cp1[0], p2[0], t);
    pos[1] = quadraticAt(p1[1], cp1[1], p2[1], t); // Tangent
    var tx = quadraticDerivativeAt(p1[0], cp1[0], p2[0], t);
    var ty = quadraticDerivativeAt(p1[1], cp1[1], p2[1], t);
    symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2; // enable continuity trail for 'line', 'rect', 'roundRect' symbolType
    if (this._symbolType === "line" || this._symbolType === "rect" || this._symbolType === "roundRect") {
        if (symbol.__lastT !== undefined && symbol.__lastT < symbol.__t) {
            var scaleY = $9eb63d101f3bcd79$export$6c4a311cc157c764(lastPos, pos) * 1.05;
            symbol.attr("scale", [
                symbol.scale[0],
                scaleY
            ]); // make sure the last segment render within endPoint
            if (t === 1) {
                pos[0] = lastPos[0] + (pos[0] - lastPos[0]) / 2;
                pos[1] = lastPos[1] + (pos[1] - lastPos[1]) / 2;
            }
        } else if (symbol.__lastT === 1) {
            // After first loop, symbol.__t does NOT start with 0, so connect p1 to pos directly.
            var scaleY = 2 * $9eb63d101f3bcd79$export$6c4a311cc157c764(p1, pos);
            symbol.attr("scale", [
                symbol.scale[0],
                scaleY
            ]);
        } else symbol.attr("scale", this._symbolScale);
    }
    symbol.__lastT = symbol.__t;
    symbol.ignore = false;
};
$93721fb902e8b0d1$var$effectLineProto.updateLayout = function(lineData, idx) {
    this.childAt(0).updateLayout(lineData, idx);
    var effectModel = lineData.getItemModel(idx).getModel("effect");
    this._updateEffectAnimation(lineData, effectModel, idx);
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($93721fb902e8b0d1$var$EffectLine, $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4);
var $93721fb902e8b0d1$var$_default = $93721fb902e8b0d1$var$EffectLine;
$93721fb902e8b0d1$exports = $93721fb902e8b0d1$var$_default;



var $6d33a9a32b5bce4f$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @module echarts/chart/helper/Line
 */ /**
 * @constructor
 * @extends {module:zrender/graphic/Group}
 * @alias {module:echarts/chart/helper/Polyline}
 */ function $6d33a9a32b5bce4f$var$Polyline(lineData, idx, seriesScope) {
    $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4.call(this);
    this._createPolyline(lineData, idx, seriesScope);
}
var $6d33a9a32b5bce4f$var$polylineProto = $6d33a9a32b5bce4f$var$Polyline.prototype;
$6d33a9a32b5bce4f$var$polylineProto._createPolyline = function(lineData, idx, seriesScope) {
    // var seriesModel = lineData.hostModel;
    var points = lineData.getItemLayout(idx);
    var line = new $4b57d6b582d579b7$export$79f3ee03e63e7073({
        shape: {
            points: points
        }
    });
    this.add(line);
    this._updateCommonStl(lineData, idx, seriesScope);
};
$6d33a9a32b5bce4f$var$polylineProto.updateData = function(lineData, idx, seriesScope) {
    var seriesModel = lineData.hostModel;
    var line = this.childAt(0);
    var target = {
        shape: {
            points: lineData.getItemLayout(idx)
        }
    };
    $4b57d6b582d579b7$export$c8dce3c08436e91e(line, target, seriesModel, idx);
    this._updateCommonStl(lineData, idx, seriesScope);
};
$6d33a9a32b5bce4f$var$polylineProto._updateCommonStl = function(lineData, idx, seriesScope) {
    var line = this.childAt(0);
    var itemModel = lineData.getItemModel(idx);
    var visualColor = lineData.getItemVisual(idx, "color");
    var lineStyle = seriesScope && seriesScope.lineStyle;
    var hoverLineStyle = seriesScope && seriesScope.hoverLineStyle;
    if (!seriesScope || lineData.hasItemOption) {
        lineStyle = itemModel.getModel("lineStyle").getLineStyle();
        hoverLineStyle = itemModel.getModel("emphasis.lineStyle").getLineStyle();
    }
    line.useStyle($ec279652dd95c27b$export$ebe90cb607ad99e({
        strokeNoScale: true,
        fill: "none",
        stroke: visualColor
    }, lineStyle));
    line.hoverStyle = hoverLineStyle;
    $4b57d6b582d579b7$export$28b42df8183f218c(this);
};
$6d33a9a32b5bce4f$var$polylineProto.updateLayout = function(lineData, idx) {
    var polyline = this.childAt(0);
    polyline.setShape("points", lineData.getItemLayout(idx));
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($6d33a9a32b5bce4f$var$Polyline, $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4);
var $6d33a9a32b5bce4f$var$_default = $6d33a9a32b5bce4f$var$Polyline;
$6d33a9a32b5bce4f$exports = $6d33a9a32b5bce4f$var$_default;


var $3e0b73a2c55a4148$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Provide effect for line
 * @module echarts/chart/helper/EffectLine
 */ /**
 * @constructor
 * @extends {module:echarts/chart/helper/EffectLine}
 * @alias {module:echarts/chart/helper/Polyline}
 */ function $3e0b73a2c55a4148$var$EffectPolyline(lineData, idx, seriesScope) {
    $93721fb902e8b0d1$exports.call(this, lineData, idx, seriesScope);
    this._lastFrame = 0;
    this._lastFramePercent = 0;
}
var $3e0b73a2c55a4148$var$effectPolylineProto = $3e0b73a2c55a4148$var$EffectPolyline.prototype; // Overwrite
$3e0b73a2c55a4148$var$effectPolylineProto.createLine = function(lineData, idx, seriesScope) {
    return new $6d33a9a32b5bce4f$exports(lineData, idx, seriesScope);
}; // Overwrite
$3e0b73a2c55a4148$var$effectPolylineProto.updateAnimationPoints = function(symbol, points) {
    this._points = points;
    var accLenArr = [
        0
    ];
    var len = 0;
    for(var i = 1; i < points.length; i++){
        var p1 = points[i - 1];
        var p2 = points[i];
        len += $9eb63d101f3bcd79$export$6c4a311cc157c764(p1, p2);
        accLenArr.push(len);
    }
    if (len === 0) return;
    for(var i = 0; i < accLenArr.length; i++)accLenArr[i] /= len;
    this._offsets = accLenArr;
    this._length = len;
}; // Overwrite
$3e0b73a2c55a4148$var$effectPolylineProto.getLineLength = function(symbol) {
    return this._length;
}; // Overwrite
$3e0b73a2c55a4148$var$effectPolylineProto.updateSymbolPosition = function(symbol) {
    var t = symbol.__t;
    var points = this._points;
    var offsets = this._offsets;
    var len = points.length;
    if (!offsets) // Has length 0
    return;
    var lastFrame = this._lastFrame;
    var frame;
    if (t < this._lastFramePercent) {
        // Start from the next frame
        // PENDING start from lastFrame ?
        var start = Math.min(lastFrame + 1, len - 1);
        for(frame = start; frame >= 0; frame--){
            if (offsets[frame] <= t) break;
        } // PENDING really need to do this ?
        frame = Math.min(frame, len - 2);
    } else {
        for(var frame = lastFrame; frame < len; frame++){
            if (offsets[frame] > t) break;
        }
        frame = Math.min(frame - 1, len - 2);
    }
    $9eb63d101f3bcd79$export$3a89f8d6f6bf6c9f(symbol.position, points[frame], points[frame + 1], (t - offsets[frame]) / (offsets[frame + 1] - offsets[frame]));
    var tx = points[frame + 1][0] - points[frame][0];
    var ty = points[frame + 1][1] - points[frame][1];
    symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
    this._lastFrame = frame;
    this._lastFramePercent = t;
    symbol.ignore = false;
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($3e0b73a2c55a4148$var$EffectPolyline, $93721fb902e8b0d1$exports);
var $3e0b73a2c55a4148$var$_default = $3e0b73a2c55a4148$var$EffectPolyline;
$3e0b73a2c55a4148$exports = $3e0b73a2c55a4148$var$_default;


var $f59ad1bd4f9b8a15$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Batch by color
var $f59ad1bd4f9b8a15$var$LargeLineShape = $4b57d6b582d579b7$export$d0d5398c9d612037({
    shape: {
        polyline: false,
        curveness: 0,
        segs: []
    },
    buildPath: function(path, shape) {
        var segs = shape.segs;
        var curveness = shape.curveness;
        if (shape.polyline) for(var i = 0; i < segs.length;){
            var count = segs[i++];
            if (count > 0) {
                path.moveTo(segs[i++], segs[i++]);
                for(var k = 1; k < count; k++)path.lineTo(segs[i++], segs[i++]);
            }
        }
        else for(var i = 0; i < segs.length;){
            var x0 = segs[i++];
            var y0 = segs[i++];
            var x1 = segs[i++];
            var y1 = segs[i++];
            path.moveTo(x0, y0);
            if (curveness > 0) {
                var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
                var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
                path.quadraticCurveTo(x2, y2, x1, y1);
            } else path.lineTo(x1, y1);
        }
    },
    findDataIndex: function(x, y) {
        var shape = this.shape;
        var segs = shape.segs;
        var curveness = shape.curveness;
        if (shape.polyline) {
            var dataIndex = 0;
            for(var i = 0; i < segs.length;){
                var count = segs[i++];
                if (count > 0) {
                    var x0 = segs[i++];
                    var y0 = segs[i++];
                    for(var k = 1; k < count; k++){
                        var x1 = segs[i++];
                        var y1 = segs[i++];
                        if ($d76a7bd0bb84dce0$export$8d36b1b5d19157c5(x0, y0, x1, y1)) return dataIndex;
                    }
                }
                dataIndex++;
            }
        } else {
            var dataIndex = 0;
            for(var i = 0; i < segs.length;){
                var x0 = segs[i++];
                var y0 = segs[i++];
                var x1 = segs[i++];
                var y1 = segs[i++];
                if (curveness > 0) {
                    var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
                    var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
                    if ($f75c89e8641a5e0c$export$8d36b1b5d19157c5(x0, y0, x2, y2, x1, y1)) return dataIndex;
                } else {
                    if ($d76a7bd0bb84dce0$export$8d36b1b5d19157c5(x0, y0, x1, y1)) return dataIndex;
                }
                dataIndex++;
            }
        }
        return -1;
    }
});
function $f59ad1bd4f9b8a15$var$LargeLineDraw() {
    this.group = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
}
var $f59ad1bd4f9b8a15$var$largeLineProto = $f59ad1bd4f9b8a15$var$LargeLineDraw.prototype;
$f59ad1bd4f9b8a15$var$largeLineProto.isPersistent = function() {
    return !this._incremental;
};
/**
 * Update symbols draw by new data
 * @param {module:echarts/data/List} data
 */ $f59ad1bd4f9b8a15$var$largeLineProto.updateData = function(data) {
    this.group.removeAll();
    var lineEl = new $f59ad1bd4f9b8a15$var$LargeLineShape({
        rectHover: true,
        cursor: "default"
    });
    lineEl.setShape({
        segs: data.getLayout("linesPoints")
    });
    this._setCommon(lineEl, data); // Add back
    this.group.add(lineEl);
    this._incremental = null;
};
/**
 * @override
 */ $f59ad1bd4f9b8a15$var$largeLineProto.incrementalPrepareUpdate = function(data) {
    this.group.removeAll();
    this._clearIncremental();
    if (data.count() > 5e5) {
        if (!this._incremental) this._incremental = new $06c8a3923ade9f4d$exports({
            silent: true
        });
        this.group.add(this._incremental);
    } else this._incremental = null;
};
/**
 * @override
 */ $f59ad1bd4f9b8a15$var$largeLineProto.incrementalUpdate = function(taskParams, data) {
    var lineEl = new $f59ad1bd4f9b8a15$var$LargeLineShape();
    lineEl.setShape({
        segs: data.getLayout("linesPoints")
    });
    this._setCommon(lineEl, data, !!this._incremental);
    if (!this._incremental) {
        lineEl.rectHover = true;
        lineEl.cursor = "default";
        lineEl.__startIndex = taskParams.start;
        this.group.add(lineEl);
    } else this._incremental.addDisplayable(lineEl, true);
};
/**
 * @override
 */ $f59ad1bd4f9b8a15$var$largeLineProto.remove = function() {
    this._clearIncremental();
    this._incremental = null;
    this.group.removeAll();
};
$f59ad1bd4f9b8a15$var$largeLineProto._setCommon = function(lineEl, data, isIncremental) {
    var hostModel = data.hostModel;
    lineEl.setShape({
        polyline: hostModel.get("polyline"),
        curveness: hostModel.get("lineStyle.curveness")
    });
    lineEl.useStyle(hostModel.getModel("lineStyle").getLineStyle());
    lineEl.style.strokeNoScale = true;
    var visualColor = data.getVisual("color");
    if (visualColor) lineEl.setStyle("stroke", visualColor);
    lineEl.setStyle("fill");
    if (!isIncremental) {
        // Enable tooltip
        // PENDING May have performance issue when path is extremely large
        lineEl.seriesIndex = hostModel.seriesIndex;
        lineEl.on("mousemove", function(e) {
            lineEl.dataIndex = null;
            var dataIndex = lineEl.findDataIndex(e.offsetX, e.offsetY);
            if (dataIndex > 0) // Provide dataIndex for tooltip
            lineEl.dataIndex = dataIndex + lineEl.__startIndex;
        });
    }
};
$f59ad1bd4f9b8a15$var$largeLineProto._clearIncremental = function() {
    var incremental = this._incremental;
    if (incremental) incremental.clearDisplaybles();
};
var $f59ad1bd4f9b8a15$var$_default = $f59ad1bd4f9b8a15$var$LargeLineDraw;
$f59ad1bd4f9b8a15$exports = $f59ad1bd4f9b8a15$var$_default;


var $48fa7323b1da59b1$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Float32Array */ var $48fa7323b1da59b1$var$_default = {
    seriesType: "lines",
    plan: $a77c5f604e87a748$exports(),
    reset: function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var isPolyline = seriesModel.get("polyline");
        var isLarge = seriesModel.pipelineContext.large;
        function progress(params, lineData) {
            var lineCoords = [];
            if (isLarge) {
                var points;
                var segCount = params.end - params.start;
                if (isPolyline) {
                    var totalCoordsCount = 0;
                    for(var i = params.start; i < params.end; i++)totalCoordsCount += seriesModel.getLineCoordsCount(i);
                    points = new Float32Array(segCount + totalCoordsCount * 2);
                } else points = new Float32Array(segCount * 4);
                var offset = 0;
                var pt = [];
                for(var i = params.start; i < params.end; i++){
                    var len = seriesModel.getLineCoords(i, lineCoords);
                    if (isPolyline) points[offset++] = len;
                    for(var k = 0; k < len; k++){
                        pt = coordSys.dataToPoint(lineCoords[k], false, pt);
                        points[offset++] = pt[0];
                        points[offset++] = pt[1];
                    }
                }
                lineData.setLayout("linesPoints", points);
            } else for(var i = params.start; i < params.end; i++){
                var itemModel = lineData.getItemModel(i);
                var len = seriesModel.getLineCoords(i, lineCoords);
                var pts = [];
                if (isPolyline) for(var j = 0; j < len; j++)pts.push(coordSys.dataToPoint(lineCoords[j]));
                else {
                    pts[0] = coordSys.dataToPoint(lineCoords[0]);
                    pts[1] = coordSys.dataToPoint(lineCoords[1]);
                    var curveness = itemModel.get("lineStyle.curveness");
                    if (+curveness) pts[2] = [
                        (pts[0][0] + pts[1][0]) / 2 - (pts[0][1] - pts[1][1]) * curveness,
                        (pts[0][1] + pts[1][1]) / 2 - (pts[1][0] - pts[0][0]) * curveness
                    ];
                }
                lineData.setItemLayout(i, pts);
            }
        }
        return {
            progress: progress
        };
    }
};
$48fa7323b1da59b1$exports = $48fa7323b1da59b1$var$_default;



var $05ca32e13df06090$var$createClipPath = $df90403704fddb7c$export$e0fe5081209d01c9;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $05ca32e13df06090$var$_default = $f406636b535430a7$exports.extendChartView({
    type: "lines",
    init: function() {},
    render: function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var lineDraw = this._updateLineDraw(data, seriesModel);
        var zlevel = seriesModel.get("zlevel");
        var trailLength = seriesModel.get("effect.trailLength");
        var zr = api.getZr(); // Avoid the drag cause ghost shadow
        // FIXME Better way ?
        // SVG doesn't support
        var isSvg = zr.painter.getType() === "svg";
        if (!isSvg) zr.painter.getLayer(zlevel).clear(true);
         // Config layer with motion blur
        if (this._lastZlevel != null && !isSvg) zr.configLayer(this._lastZlevel, {
            motionBlur: false
        });
        if (this._showEffect(seriesModel) && trailLength) {
            if (!isSvg) zr.configLayer(zlevel, {
                motionBlur: true,
                lastFrameAlpha: Math.max(Math.min(trailLength / 10 + 0.9, 1), 0)
            });
        }
        lineDraw.updateData(data);
        var clipPath = seriesModel.get("clip", true) && $05ca32e13df06090$var$createClipPath(seriesModel.coordinateSystem, false, seriesModel);
        if (clipPath) this.group.setClipPath(clipPath);
        else this.group.removeClipPath();
        this._lastZlevel = zlevel;
        this._finished = true;
    },
    incrementalPrepareRender: function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var lineDraw = this._updateLineDraw(data, seriesModel);
        lineDraw.incrementalPrepareUpdate(data);
        this._clearLayer(api);
        this._finished = false;
    },
    incrementalRender: function(taskParams, seriesModel, ecModel) {
        this._lineDraw.incrementalUpdate(taskParams, seriesModel.getData());
        this._finished = taskParams.end === seriesModel.getData().count();
    },
    updateTransform: function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var pipelineContext = seriesModel.pipelineContext;
        if (!this._finished || pipelineContext.large || pipelineContext.progressiveRender) // TODO Don't have to do update in large mode. Only do it when there are millions of data.
        return {
            update: true
        };
        else {
            // TODO Use same logic with ScatterView.
            // Manually update layout
            var res = $48fa7323b1da59b1$exports.reset(seriesModel);
            if (res.progress) res.progress({
                start: 0,
                end: data.count()
            }, data);
            this._lineDraw.updateLayout();
            this._clearLayer(api);
        }
    },
    _updateLineDraw: function(data, seriesModel) {
        var lineDraw = this._lineDraw;
        var hasEffect = this._showEffect(seriesModel);
        var isPolyline = !!seriesModel.get("polyline");
        var pipelineContext = seriesModel.pipelineContext;
        var isLargeDraw = pipelineContext.large;
        if (!lineDraw || hasEffect !== this._hasEffet || isPolyline !== this._isPolyline || isLargeDraw !== this._isLargeDraw) {
            if (lineDraw) lineDraw.remove();
            lineDraw = this._lineDraw = isLargeDraw ? new $f59ad1bd4f9b8a15$exports() : new $d4dffdc6cfcd68dc$exports(isPolyline ? hasEffect ? $3e0b73a2c55a4148$exports : $6d33a9a32b5bce4f$exports : hasEffect ? $93721fb902e8b0d1$exports : $6dd196751040d665$exports);
            this._hasEffet = hasEffect;
            this._isPolyline = isPolyline;
            this._isLargeDraw = isLargeDraw;
            this.group.removeAll();
        }
        this.group.add(lineDraw.group);
        return lineDraw;
    },
    _showEffect: function(seriesModel) {
        return !!seriesModel.get("effect.show");
    },
    _clearLayer: function(api) {
        // Not use motion when dragging or zooming
        var zr = api.getZr();
        var isSvg = zr.painter.getType() === "svg";
        if (!isSvg && this._lastZlevel != null) zr.painter.getLayer(this._lastZlevel).clear(true);
    },
    remove: function(ecModel, api) {
        this._lineDraw && this._lineDraw.remove();
        this._lineDraw = null; // Clear motion when lineDraw is removed
        this._clearLayer(api);
    },
    dispose: function() {}
});
$05ca32e13df06090$exports = $05ca32e13df06090$var$_default;



var $38fabb14b3765ecd$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $38fabb14b3765ecd$var$normalize(a) {
    if (!(a instanceof Array)) a = [
        a,
        a
    ];
    return a;
}
var $38fabb14b3765ecd$var$opacityQuery = "lineStyle.opacity".split(".");
var $38fabb14b3765ecd$var$_default = {
    seriesType: "lines",
    reset: function(seriesModel, ecModel, api) {
        var symbolType = $38fabb14b3765ecd$var$normalize(seriesModel.get("symbol"));
        var symbolSize = $38fabb14b3765ecd$var$normalize(seriesModel.get("symbolSize"));
        var data = seriesModel.getData();
        data.setVisual("fromSymbol", symbolType && symbolType[0]);
        data.setVisual("toSymbol", symbolType && symbolType[1]);
        data.setVisual("fromSymbolSize", symbolSize && symbolSize[0]);
        data.setVisual("toSymbolSize", symbolSize && symbolSize[1]);
        data.setVisual("opacity", seriesModel.get($38fabb14b3765ecd$var$opacityQuery));
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            var symbolType = $38fabb14b3765ecd$var$normalize(itemModel.getShallow("symbol", true));
            var symbolSize = $38fabb14b3765ecd$var$normalize(itemModel.getShallow("symbolSize", true));
            var opacity = itemModel.get($38fabb14b3765ecd$var$opacityQuery);
            symbolType[0] && data.setItemVisual(idx, "fromSymbol", symbolType[0]);
            symbolType[1] && data.setItemVisual(idx, "toSymbol", symbolType[1]);
            symbolSize[0] && data.setItemVisual(idx, "fromSymbolSize", symbolSize[0]);
            symbolSize[1] && data.setItemVisual(idx, "toSymbolSize", symbolSize[1]);
            data.setItemVisual(idx, "opacity", opacity);
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};
$38fabb14b3765ecd$exports = $38fabb14b3765ecd$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerLayout($48fa7323b1da59b1$exports);
$f406636b535430a7$exports.registerVisual($38fabb14b3765ecd$exports);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $5e553113796cd7e9$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $5e553113796cd7e9$var$_default = $70847df98016d69d$exports.extend({
    type: "series.heatmap",
    getInitialData: function(option, ecModel) {
        return $10e48b57e44af7c1$exports(this.getSource(), this, {
            generateCoord: "value"
        });
    },
    preventIncremental: function() {
        var coordSysCreator = $9c36d0fff3b0f387$exports.get(this.get("coordinateSystem"));
        if (coordSysCreator && coordSysCreator.dimensions) return coordSysCreator.dimensions[0] === "lng" && coordSysCreator.dimensions[1] === "lat";
    },
    defaultOption: {
        // Cartesian2D or geo
        coordinateSystem: "cartesian2d",
        zlevel: 0,
        z: 2,
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // Geo coordinate system
        geoIndex: 0,
        blurSize: 30,
        pointSize: 20,
        maxOpacity: 1,
        minOpacity: 0
    }
});
$5e553113796cd7e9$exports = $5e553113796cd7e9$var$_default;


var $8482ad5005f26a3f$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $8482ad5005f26a3f$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;


var $5205feb0c1cd8e9c$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Uint8ClampedArray */ var $5205feb0c1cd8e9c$var$GRADIENT_LEVELS = 256;
/**
 * Heatmap Chart
 *
 * @class
 */ function $5205feb0c1cd8e9c$var$Heatmap() {
    var canvas = $ec279652dd95c27b$export$cd3d1f114b139967();
    this.canvas = canvas;
    this.blurSize = 30;
    this.pointSize = 20;
    this.maxOpacity = 1;
    this.minOpacity = 0;
    this._gradientPixels = {};
}
$5205feb0c1cd8e9c$var$Heatmap.prototype = {
    /**
   * Renders Heatmap and returns the rendered canvas
   * @param {Array} data array of data, each has x, y, value
   * @param {number} width canvas width
   * @param {number} height canvas height
   */ update: function(data, width, height, normalize, colorFunc, isInRange) {
        var brush = this._getBrush();
        var gradientInRange = this._getGradient(data, colorFunc, "inRange");
        var gradientOutOfRange = this._getGradient(data, colorFunc, "outOfRange");
        var r = this.pointSize + this.blurSize;
        var canvas = this.canvas;
        var ctx = canvas.getContext("2d");
        var len = data.length;
        canvas.width = width;
        canvas.height = height;
        for(var i = 0; i < len; ++i){
            var p = data[i];
            var x = p[0];
            var y = p[1];
            var value = p[2]; // calculate alpha using value
            var alpha = normalize(value); // draw with the circle brush with alpha
            ctx.globalAlpha = alpha;
            ctx.drawImage(brush, x - r, y - r);
        }
        if (!canvas.width || !canvas.height) // Avoid "Uncaught DOMException: Failed to execute 'getImageData' on
        // 'CanvasRenderingContext2D': The source height is 0."
        return canvas;
         // colorize the canvas using alpha value and set with gradient
        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var pixels = imageData.data;
        var offset = 0;
        var pixelLen = pixels.length;
        var minOpacity = this.minOpacity;
        var maxOpacity = this.maxOpacity;
        var diffOpacity = maxOpacity - minOpacity;
        while(offset < pixelLen){
            var alpha = pixels[offset + 3] / 256;
            var gradientOffset = Math.floor(alpha * ($5205feb0c1cd8e9c$var$GRADIENT_LEVELS - 1)) * 4; // Simple optimize to ignore the empty data
            if (alpha > 0) {
                var gradient = isInRange(alpha) ? gradientInRange : gradientOutOfRange; // Any alpha > 0 will be mapped to [minOpacity, maxOpacity]
                alpha > 0 && (alpha = alpha * diffOpacity + minOpacity);
                pixels[offset++] = gradient[gradientOffset];
                pixels[offset++] = gradient[gradientOffset + 1];
                pixels[offset++] = gradient[gradientOffset + 2];
                pixels[offset++] = gradient[gradientOffset + 3] * alpha * 256;
            } else offset += 4;
        }
        ctx.putImageData(imageData, 0, 0);
        return canvas;
    },
    /**
   * get canvas of a black circle brush used for canvas to draw later
   * @private
   * @returns {Object} circle brush canvas
   */ _getBrush: function() {
        var brushCanvas = this._brushCanvas || (this._brushCanvas = $ec279652dd95c27b$export$cd3d1f114b139967()); // set brush size
        var r = this.pointSize + this.blurSize;
        var d = r * 2;
        brushCanvas.width = d;
        brushCanvas.height = d;
        var ctx = brushCanvas.getContext("2d");
        ctx.clearRect(0, 0, d, d); // in order to render shadow without the distinct circle,
        // draw the distinct circle in an invisible place,
        // and use shadowOffset to draw shadow in the center of the canvas
        ctx.shadowOffsetX = d;
        ctx.shadowBlur = this.blurSize; // draw the shadow in black, and use alpha and shadow blur to generate
        // color in color map
        ctx.shadowColor = "#000"; // draw circle in the left to the canvas
        ctx.beginPath();
        ctx.arc(-r, r, this.pointSize, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        return brushCanvas;
    },
    /**
   * get gradient color map
   * @private
   */ _getGradient: function(data, colorFunc, state) {
        var gradientPixels = this._gradientPixels;
        var pixelsSingleState = gradientPixels[state] || (gradientPixels[state] = new Uint8ClampedArray(1024));
        var color = [
            0,
            0,
            0,
            0
        ];
        var off = 0;
        for(var i = 0; i < 256; i++){
            colorFunc[state](i / 255, true, color);
            pixelsSingleState[off++] = color[0];
            pixelsSingleState[off++] = color[1];
            pixelsSingleState[off++] = color[2];
            pixelsSingleState[off++] = color[3];
        }
        return pixelsSingleState;
    }
};
var $5205feb0c1cd8e9c$var$_default = $5205feb0c1cd8e9c$var$Heatmap;
$5205feb0c1cd8e9c$exports = $5205feb0c1cd8e9c$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $8482ad5005f26a3f$var$getIsInPiecewiseRange(dataExtent, pieceList, selected) {
    var dataSpan = dataExtent[1] - dataExtent[0];
    pieceList = $ec279652dd95c27b$export$871de8747c9eaa88(pieceList, function(piece) {
        return {
            interval: [
                (piece.interval[0] - dataExtent[0]) / dataSpan,
                (piece.interval[1] - dataExtent[0]) / dataSpan
            ]
        };
    });
    var len = pieceList.length;
    var lastIndex = 0;
    return function(val) {
        // Try to find in the location of the last found
        for(var i = lastIndex; i < len; i++){
            var interval = pieceList[i].interval;
            if (interval[0] <= val && val <= interval[1]) {
                lastIndex = i;
                break;
            }
        }
        if (i === len) // Not found, back interation
        for(var i = lastIndex - 1; i >= 0; i--){
            var interval = pieceList[i].interval;
            if (interval[0] <= val && val <= interval[1]) {
                lastIndex = i;
                break;
            }
        }
        return i >= 0 && i < len && selected[i];
    };
}
function $8482ad5005f26a3f$var$getIsInContinuousRange(dataExtent, range) {
    var dataSpan = dataExtent[1] - dataExtent[0];
    range = [
        (range[0] - dataExtent[0]) / dataSpan,
        (range[1] - dataExtent[0]) / dataSpan
    ];
    return function(val) {
        return val >= range[0] && val <= range[1];
    };
}
function $8482ad5005f26a3f$var$isGeoCoordSys(coordSys) {
    var dimensions = coordSys.dimensions; // Not use coorSys.type === 'geo' because coordSys maybe extended
    return dimensions[0] === "lng" && dimensions[1] === "lat";
}
var $8482ad5005f26a3f$var$_default = $f406636b535430a7$exports.extendChartView({
    type: "heatmap",
    render: function(seriesModel, ecModel, api) {
        var visualMapOfThisSeries;
        ecModel.eachComponent("visualMap", function(visualMap) {
            visualMap.eachTargetSeries(function(targetSeries) {
                if (targetSeries === seriesModel) visualMapOfThisSeries = visualMap;
            });
        });
        this.group.removeAll();
        this._incrementalDisplayable = null;
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys.type === "cartesian2d" || coordSys.type === "calendar") this._renderOnCartesianAndCalendar(seriesModel, api, 0, seriesModel.getData().count());
        else if ($8482ad5005f26a3f$var$isGeoCoordSys(coordSys)) this._renderOnGeo(coordSys, seriesModel, visualMapOfThisSeries, api);
    },
    incrementalPrepareRender: function(seriesModel, ecModel, api) {
        this.group.removeAll();
    },
    incrementalRender: function(params, seriesModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys) this._renderOnCartesianAndCalendar(seriesModel, api, params.start, params.end, true);
    },
    _renderOnCartesianAndCalendar: function(seriesModel, api, start, end, incremental) {
        var coordSys = seriesModel.coordinateSystem;
        var width;
        var height;
        if (coordSys.type === "cartesian2d") {
            var xAxis = coordSys.getAxis("x");
            var yAxis = coordSys.getAxis("y");
            width = xAxis.getBandWidth();
            height = yAxis.getBandWidth();
        }
        var group = this.group;
        var data = seriesModel.getData();
        var itemStyleQuery = "itemStyle";
        var hoverItemStyleQuery = "emphasis.itemStyle";
        var labelQuery = "label";
        var hoverLabelQuery = "emphasis.label";
        var style = seriesModel.getModel(itemStyleQuery).getItemStyle([
            "color"
        ]);
        var hoverStl = seriesModel.getModel(hoverItemStyleQuery).getItemStyle();
        var labelModel = seriesModel.getModel(labelQuery);
        var hoverLabelModel = seriesModel.getModel(hoverLabelQuery);
        var coordSysType = coordSys.type;
        var dataDims = coordSysType === "cartesian2d" ? [
            data.mapDimension("x"),
            data.mapDimension("y"),
            data.mapDimension("value")
        ] : [
            data.mapDimension("time"),
            data.mapDimension("value")
        ];
        for(var idx = start; idx < end; idx++){
            var rect;
            if (coordSysType === "cartesian2d") {
                // Ignore empty data
                if (isNaN(data.get(dataDims[2], idx))) continue;
                var point = coordSys.dataToPoint([
                    data.get(dataDims[0], idx),
                    data.get(dataDims[1], idx)
                ]);
                rect = new $4b57d6b582d579b7$export$c79fc6492f3af13d({
                    shape: {
                        x: Math.floor(Math.round(point[0]) - width / 2),
                        y: Math.floor(Math.round(point[1]) - height / 2),
                        width: Math.ceil(width),
                        height: Math.ceil(height)
                    },
                    style: {
                        fill: data.getItemVisual(idx, "color"),
                        opacity: data.getItemVisual(idx, "opacity")
                    }
                });
            } else {
                // Ignore empty data
                if (isNaN(data.get(dataDims[1], idx))) continue;
                rect = new $4b57d6b582d579b7$export$c79fc6492f3af13d({
                    z2: 1,
                    shape: coordSys.dataToRect([
                        data.get(dataDims[0], idx)
                    ]).contentShape,
                    style: {
                        fill: data.getItemVisual(idx, "color"),
                        opacity: data.getItemVisual(idx, "opacity")
                    }
                });
            }
            var itemModel = data.getItemModel(idx); // Optimization for large datset
            if (data.hasItemOption) {
                style = itemModel.getModel(itemStyleQuery).getItemStyle([
                    "color"
                ]);
                hoverStl = itemModel.getModel(hoverItemStyleQuery).getItemStyle();
                labelModel = itemModel.getModel(labelQuery);
                hoverLabelModel = itemModel.getModel(hoverLabelQuery);
            }
            var rawValue = seriesModel.getRawValue(idx);
            var defaultText = "-";
            if (rawValue && rawValue[2] != null) defaultText = rawValue[2];
            $4b57d6b582d579b7$export$9a13992917966657(style, hoverStl, labelModel, hoverLabelModel, {
                labelFetcher: seriesModel,
                labelDataIndex: idx,
                defaultText: defaultText,
                isRectText: true
            });
            rect.setStyle(style);
            $4b57d6b582d579b7$export$28b42df8183f218c(rect, data.hasItemOption ? hoverStl : $ec279652dd95c27b$export$8b58be045bf06082({}, hoverStl));
            rect.incremental = incremental; // PENDING
            if (incremental) // Rect must use hover layer if it's incremental.
            rect.useHoverLayer = true;
            group.add(rect);
            data.setItemGraphicEl(idx, rect);
        }
    },
    _renderOnGeo: function(geo, seriesModel, visualMapModel, api) {
        var inRangeVisuals = visualMapModel.targetVisuals.inRange;
        var outOfRangeVisuals = visualMapModel.targetVisuals.outOfRange; // if (!visualMapping) {
        //     throw new Error('Data range must have color visuals');
        // }
        var data = seriesModel.getData();
        var hmLayer = this._hmLayer || this._hmLayer || new $5205feb0c1cd8e9c$exports();
        hmLayer.blurSize = seriesModel.get("blurSize");
        hmLayer.pointSize = seriesModel.get("pointSize");
        hmLayer.minOpacity = seriesModel.get("minOpacity");
        hmLayer.maxOpacity = seriesModel.get("maxOpacity");
        var rect = geo.getViewRect().clone();
        var roamTransform = geo.getRoamTransform();
        rect.applyTransform(roamTransform); // Clamp on viewport
        var x = Math.max(rect.x, 0);
        var y = Math.max(rect.y, 0);
        var x2 = Math.min(rect.width + rect.x, api.getWidth());
        var y2 = Math.min(rect.height + rect.y, api.getHeight());
        var width = x2 - x;
        var height = y2 - y;
        var dims = [
            data.mapDimension("lng"),
            data.mapDimension("lat"),
            data.mapDimension("value")
        ];
        var points = data.mapArray(dims, function(lng, lat, value) {
            var pt = geo.dataToPoint([
                lng,
                lat
            ]);
            pt[0] -= x;
            pt[1] -= y;
            pt.push(value);
            return pt;
        });
        var dataExtent = visualMapModel.getExtent();
        var isInRange = visualMapModel.type === "visualMap.continuous" ? $8482ad5005f26a3f$var$getIsInContinuousRange(dataExtent, visualMapModel.option.range) : $8482ad5005f26a3f$var$getIsInPiecewiseRange(dataExtent, visualMapModel.getPieceList(), visualMapModel.option.selected);
        hmLayer.update(points, width, height, inRangeVisuals.color.getNormalizer(), {
            inRange: inRangeVisuals.color.getColorMapper(),
            outOfRange: outOfRangeVisuals.color.getColorMapper()
        }, isInRange);
        var img = new $4b57d6b582d579b7$export$3e431a229df88919({
            style: {
                width: width,
                height: height,
                x: x,
                y: y,
                image: hmLayer.canvas
            },
            silent: true
        });
        this.group.add(img);
    },
    dispose: function() {}
});
$8482ad5005f26a3f$exports = $8482ad5005f26a3f$var$_default;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $8bee1578e13824c5$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $8bee1578e13824c5$var$PictorialBarSeries = $4d229707f7d9b379$exports.extend({
    type: "series.pictorialBar",
    dependencies: [
        "grid"
    ],
    defaultOption: {
        symbol: "circle",
        // Customized bar shape
        symbolSize: null,
        // Can be ['100%', '100%'], null means auto.
        symbolRotate: null,
        symbolPosition: null,
        // 'start' or 'end' or 'center', null means auto.
        symbolOffset: null,
        symbolMargin: null,
        // start margin and end margin. Can be a number or a percent string.
        // Auto margin by default.
        symbolRepeat: false,
        // false/null/undefined, means no repeat.
        // Can be true, means auto calculate repeat times and cut by data.
        // Can be a number, specifies repeat times, and do not cut by data.
        // Can be 'fixed', means auto calculate repeat times but do not cut by data.
        symbolRepeatDirection: "end",
        // 'end' means from 'start' to 'end'.
        symbolClip: false,
        symbolBoundingData: null,
        // Can be 60 or -40 or [-40, 60]
        symbolPatternSize: 400,
        // 400 * 400 px
        barGap: "-100%",
        // In most case, overlap is needed.
        // z can be set in data item, which is z2 actually.
        // Disable progressive
        progressive: 0,
        hoverAnimation: false // Open only when needed.
    },
    getInitialData: function(option) {
        // Disable stack.
        option.stack = null;
        return $8bee1578e13824c5$var$PictorialBarSeries.superApply(this, "getInitialData", arguments);
    }
});
var $8bee1578e13824c5$var$_default = $8bee1578e13824c5$var$PictorialBarSeries;
$8bee1578e13824c5$exports = $8bee1578e13824c5$var$_default;


var $776888f3e44e6872$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $776888f3e44e6872$var$createSymbol = $804dcb9a0b78b5fe$export$af050e04da3a02e8;

var $776888f3e44e6872$var$parsePercent = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f;
var $776888f3e44e6872$var$isNumeric = $2d742dbe7f960d8c$export$e90fb89750dba83f;

var $776888f3e44e6872$var$setLabel = $928677db495c9bf1$export$4f65e594f6031297;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $776888f3e44e6872$var$BAR_BORDER_WIDTH_QUERY = [
    "itemStyle",
    "borderWidth"
]; // index: +isHorizontal
var $776888f3e44e6872$var$LAYOUT_ATTRS = [
    {
        xy: "x",
        wh: "width",
        index: 0,
        posDesc: [
            "left",
            "right"
        ]
    },
    {
        xy: "y",
        wh: "height",
        index: 1,
        posDesc: [
            "top",
            "bottom"
        ]
    }
];
var $776888f3e44e6872$var$pathForLineWidth = new $4b57d6b582d579b7$exports.Circle();
var $776888f3e44e6872$var$BarView = $f406636b535430a7$exports.extendChartView({
    type: "pictorialBar",
    render: function(seriesModel, ecModel, api) {
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = !!baseAxis.isHorizontal();
        var coordSysRect = cartesian.grid.getRect();
        var opt = {
            ecSize: {
                width: api.getWidth(),
                height: api.getHeight()
            },
            seriesModel: seriesModel,
            coordSys: cartesian,
            coordSysExtent: [
                [
                    coordSysRect.x,
                    coordSysRect.x + coordSysRect.width
                ],
                [
                    coordSysRect.y,
                    coordSysRect.y + coordSysRect.height
                ]
            ],
            isHorizontal: isHorizontal,
            valueDim: $776888f3e44e6872$var$LAYOUT_ATTRS[+isHorizontal],
            categoryDim: $776888f3e44e6872$var$LAYOUT_ATTRS[1 - isHorizontal]
        };
        data.diff(oldData).add(function(dataIndex) {
            if (!data.hasValue(dataIndex)) return;
            var itemModel = $776888f3e44e6872$var$getItemModel(data, dataIndex);
            var symbolMeta = $776888f3e44e6872$var$getSymbolMeta(data, dataIndex, itemModel, opt);
            var bar = $776888f3e44e6872$var$createBar(data, opt, symbolMeta);
            data.setItemGraphicEl(dataIndex, bar);
            group.add(bar);
            $776888f3e44e6872$var$updateCommon(bar, opt, symbolMeta);
        }).update(function(newIndex, oldIndex) {
            var bar = oldData.getItemGraphicEl(oldIndex);
            if (!data.hasValue(newIndex)) {
                group.remove(bar);
                return;
            }
            var itemModel = $776888f3e44e6872$var$getItemModel(data, newIndex);
            var symbolMeta = $776888f3e44e6872$var$getSymbolMeta(data, newIndex, itemModel, opt);
            var pictorialShapeStr = $776888f3e44e6872$var$getShapeStr(data, symbolMeta);
            if (bar && pictorialShapeStr !== bar.__pictorialShapeStr) {
                group.remove(bar);
                data.setItemGraphicEl(newIndex, null);
                bar = null;
            }
            if (bar) $776888f3e44e6872$var$updateBar(bar, opt, symbolMeta);
            else bar = $776888f3e44e6872$var$createBar(data, opt, symbolMeta, true);
            data.setItemGraphicEl(newIndex, bar);
            bar.__pictorialSymbolMeta = symbolMeta; // Add back
            group.add(bar);
            $776888f3e44e6872$var$updateCommon(bar, opt, symbolMeta);
        }).remove(function(dataIndex) {
            var bar = oldData.getItemGraphicEl(dataIndex);
            bar && $776888f3e44e6872$var$removeBar(oldData, dataIndex, bar.__pictorialSymbolMeta.animationModel, bar);
        }).execute();
        this._data = data;
        return this.group;
    },
    dispose: $ec279652dd95c27b$export$8793edee2d425525,
    remove: function(ecModel, api) {
        var group = this.group;
        var data = this._data;
        if (ecModel.get("animation")) {
            if (data) data.eachItemGraphicEl(function(bar) {
                $776888f3e44e6872$var$removeBar(data, bar.dataIndex, ecModel, bar);
            });
        } else group.removeAll();
    }
}); // Set or calculate default value about symbol, and calculate layout info.
function $776888f3e44e6872$var$getSymbolMeta(data, dataIndex, itemModel, opt) {
    var layout = data.getItemLayout(dataIndex);
    var symbolRepeat = itemModel.get("symbolRepeat");
    var symbolClip = itemModel.get("symbolClip");
    var symbolPosition = itemModel.get("symbolPosition") || "start";
    var symbolRotate = itemModel.get("symbolRotate");
    var rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
    var symbolPatternSize = itemModel.get("symbolPatternSize") || 2;
    var isAnimationEnabled = itemModel.isAnimationEnabled();
    var symbolMeta = {
        dataIndex: dataIndex,
        layout: layout,
        itemModel: itemModel,
        symbolType: data.getItemVisual(dataIndex, "symbol") || "circle",
        color: data.getItemVisual(dataIndex, "color"),
        symbolClip: symbolClip,
        symbolRepeat: symbolRepeat,
        symbolRepeatDirection: itemModel.get("symbolRepeatDirection"),
        symbolPatternSize: symbolPatternSize,
        rotation: rotation,
        animationModel: isAnimationEnabled ? itemModel : null,
        hoverAnimation: isAnimationEnabled && itemModel.get("hoverAnimation"),
        z2: itemModel.getShallow("z", true) || 0
    };
    $776888f3e44e6872$var$prepareBarLength(itemModel, symbolRepeat, layout, opt, symbolMeta);
    $776888f3e44e6872$var$prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, symbolMeta.boundingLength, symbolMeta.pxSign, symbolPatternSize, opt, symbolMeta);
    $776888f3e44e6872$var$prepareLineWidth(itemModel, symbolMeta.symbolScale, rotation, opt, symbolMeta);
    var symbolSize = symbolMeta.symbolSize;
    var symbolOffset = itemModel.get("symbolOffset");
    if ($ec279652dd95c27b$export$43bee75e5e14138e(symbolOffset)) symbolOffset = [
        $776888f3e44e6872$var$parsePercent(symbolOffset[0], symbolSize[0]),
        $776888f3e44e6872$var$parsePercent(symbolOffset[1], symbolSize[1])
    ];
    $776888f3e44e6872$var$prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, symbolMeta.valueLineWidth, symbolMeta.boundingLength, symbolMeta.repeatCutLength, opt, symbolMeta);
    return symbolMeta;
} // bar length can be negative.
function $776888f3e44e6872$var$prepareBarLength(itemModel, symbolRepeat, layout, opt, output) {
    var valueDim = opt.valueDim;
    var symbolBoundingData = itemModel.get("symbolBoundingData");
    var valueAxis = opt.coordSys.getOtherAxis(opt.coordSys.getBaseAxis());
    var zeroPx = valueAxis.toGlobalCoord(valueAxis.dataToCoord(0));
    var pxSignIdx = 1 - +(layout[valueDim.wh] <= 0);
    var boundingLength;
    if ($ec279652dd95c27b$export$43bee75e5e14138e(symbolBoundingData)) {
        var symbolBoundingExtent = [
            $776888f3e44e6872$var$convertToCoordOnAxis(valueAxis, symbolBoundingData[0]) - zeroPx,
            $776888f3e44e6872$var$convertToCoordOnAxis(valueAxis, symbolBoundingData[1]) - zeroPx
        ];
        symbolBoundingExtent[1] < symbolBoundingExtent[0] && symbolBoundingExtent.reverse();
        boundingLength = symbolBoundingExtent[pxSignIdx];
    } else if (symbolBoundingData != null) boundingLength = $776888f3e44e6872$var$convertToCoordOnAxis(valueAxis, symbolBoundingData) - zeroPx;
    else if (symbolRepeat) boundingLength = opt.coordSysExtent[valueDim.index][pxSignIdx] - zeroPx;
    else boundingLength = layout[valueDim.wh];
    output.boundingLength = boundingLength;
    if (symbolRepeat) output.repeatCutLength = layout[valueDim.wh];
    output.pxSign = boundingLength > 0 ? 1 : boundingLength < 0 ? -1 : 0;
}
function $776888f3e44e6872$var$convertToCoordOnAxis(axis, value) {
    return axis.toGlobalCoord(axis.dataToCoord(axis.scale.parse(value)));
} // Support ['100%', '100%']
function $776888f3e44e6872$var$prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, boundingLength, pxSign, symbolPatternSize, opt, output) {
    var valueDim = opt.valueDim;
    var categoryDim = opt.categoryDim;
    var categorySize = Math.abs(layout[categoryDim.wh]);
    var symbolSize = data.getItemVisual(dataIndex, "symbolSize");
    if ($ec279652dd95c27b$export$43bee75e5e14138e(symbolSize)) symbolSize = symbolSize.slice();
    else {
        if (symbolSize == null) symbolSize = "100%";
        symbolSize = [
            symbolSize,
            symbolSize
        ];
    } // Note: percentage symbolSize (like '100%') do not consider lineWidth, because it is
    // to complicated to calculate real percent value if considering scaled lineWidth.
    // So the actual size will bigger than layout size if lineWidth is bigger than zero,
    // which can be tolerated in pictorial chart.
    symbolSize[categoryDim.index] = $776888f3e44e6872$var$parsePercent(symbolSize[categoryDim.index], categorySize);
    symbolSize[valueDim.index] = $776888f3e44e6872$var$parsePercent(symbolSize[valueDim.index], symbolRepeat ? categorySize : Math.abs(boundingLength));
    output.symbolSize = symbolSize; // If x or y is less than zero, show reversed shape.
    var symbolScale = output.symbolScale = [
        symbolSize[0] / symbolPatternSize,
        symbolSize[1] / symbolPatternSize
    ]; // Follow convention, 'right' and 'top' is the normal scale.
    symbolScale[valueDim.index] *= (opt.isHorizontal ? -1 : 1) * pxSign;
}
function $776888f3e44e6872$var$prepareLineWidth(itemModel, symbolScale, rotation, opt, output) {
    // In symbols are drawn with scale, so do not need to care about the case that width
    // or height are too small. But symbol use strokeNoScale, where acture lineWidth should
    // be calculated.
    var valueLineWidth = itemModel.get($776888f3e44e6872$var$BAR_BORDER_WIDTH_QUERY) || 0;
    if (valueLineWidth) {
        $776888f3e44e6872$var$pathForLineWidth.attr({
            scale: symbolScale.slice(),
            rotation: rotation
        });
        $776888f3e44e6872$var$pathForLineWidth.updateTransform();
        valueLineWidth /= $776888f3e44e6872$var$pathForLineWidth.getLineScale();
        valueLineWidth *= symbolScale[opt.valueDim.index];
    }
    output.valueLineWidth = valueLineWidth;
}
function $776888f3e44e6872$var$prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, valueLineWidth, boundingLength, repeatCutLength, opt, output) {
    var categoryDim = opt.categoryDim;
    var valueDim = opt.valueDim;
    var pxSign = output.pxSign;
    var unitLength = Math.max(symbolSize[valueDim.index] + valueLineWidth, 0);
    var pathLen = unitLength; // Note: rotation will not effect the layout of symbols, because user may
    // want symbols to rotate on its center, which should not be translated
    // when rotating.
    if (symbolRepeat) {
        var absBoundingLength = Math.abs(boundingLength);
        var symbolMargin = $ec279652dd95c27b$export$8a4d17b6e8486e66(itemModel.get("symbolMargin"), "15%") + "";
        var hasEndGap = false;
        if (symbolMargin.lastIndexOf("!") === symbolMargin.length - 1) {
            hasEndGap = true;
            symbolMargin = symbolMargin.slice(0, symbolMargin.length - 1);
        }
        symbolMargin = $776888f3e44e6872$var$parsePercent(symbolMargin, symbolSize[valueDim.index]);
        var uLenWithMargin = Math.max(unitLength + symbolMargin * 2, 0); // When symbol margin is less than 0, margin at both ends will be subtracted
        // to ensure that all of the symbols will not be overflow the given area.
        var endFix = hasEndGap ? 0 : symbolMargin * 2; // Both final repeatTimes and final symbolMargin area calculated based on
        // boundingLength.
        var repeatSpecified = $776888f3e44e6872$var$isNumeric(symbolRepeat);
        var repeatTimes = repeatSpecified ? symbolRepeat : $776888f3e44e6872$var$toIntTimes((absBoundingLength + endFix) / uLenWithMargin); // Adjust calculate margin, to ensure each symbol is displayed
        // entirely in the given layout area.
        var mDiff = absBoundingLength - repeatTimes * unitLength;
        symbolMargin = mDiff / 2 / (hasEndGap ? repeatTimes : repeatTimes - 1);
        uLenWithMargin = unitLength + symbolMargin * 2;
        endFix = hasEndGap ? 0 : symbolMargin * 2; // Update repeatTimes when not all symbol will be shown.
        if (!repeatSpecified && symbolRepeat !== "fixed") repeatTimes = repeatCutLength ? $776888f3e44e6872$var$toIntTimes((Math.abs(repeatCutLength) + endFix) / uLenWithMargin) : 0;
        pathLen = repeatTimes * uLenWithMargin - endFix;
        output.repeatTimes = repeatTimes;
        output.symbolMargin = symbolMargin;
    }
    var sizeFix = pxSign * (pathLen / 2);
    var pathPosition = output.pathPosition = [];
    pathPosition[categoryDim.index] = layout[categoryDim.wh] / 2;
    pathPosition[valueDim.index] = symbolPosition === "start" ? sizeFix : symbolPosition === "end" ? boundingLength - sizeFix : boundingLength / 2; // 'center'
    if (symbolOffset) {
        pathPosition[0] += symbolOffset[0];
        pathPosition[1] += symbolOffset[1];
    }
    var bundlePosition = output.bundlePosition = [];
    bundlePosition[categoryDim.index] = layout[categoryDim.xy];
    bundlePosition[valueDim.index] = layout[valueDim.xy];
    var barRectShape = output.barRectShape = $ec279652dd95c27b$export$8b58be045bf06082({}, layout);
    barRectShape[valueDim.wh] = pxSign * Math.max(Math.abs(layout[valueDim.wh]), Math.abs(pathPosition[valueDim.index] + sizeFix));
    barRectShape[categoryDim.wh] = layout[categoryDim.wh];
    var clipShape = output.clipShape = {}; // Consider that symbol may be overflow layout rect.
    clipShape[categoryDim.xy] = -layout[categoryDim.xy];
    clipShape[categoryDim.wh] = opt.ecSize[categoryDim.wh];
    clipShape[valueDim.xy] = 0;
    clipShape[valueDim.wh] = layout[valueDim.wh];
}
function $776888f3e44e6872$var$createPath(symbolMeta) {
    var symbolPatternSize = symbolMeta.symbolPatternSize;
    var path = $776888f3e44e6872$var$createSymbol(symbolMeta.symbolType, -symbolPatternSize / 2, -symbolPatternSize / 2, symbolPatternSize, symbolPatternSize, symbolMeta.color);
    path.attr({
        culling: true
    });
    path.type !== "image" && path.setStyle({
        strokeNoScale: true
    });
    return path;
}
function $776888f3e44e6872$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta, isUpdate) {
    var bundle = bar.__pictorialBundle;
    var symbolSize = symbolMeta.symbolSize;
    var valueLineWidth = symbolMeta.valueLineWidth;
    var pathPosition = symbolMeta.pathPosition;
    var valueDim = opt.valueDim;
    var repeatTimes = symbolMeta.repeatTimes || 0;
    var index = 0;
    var unit = symbolSize[opt.valueDim.index] + valueLineWidth + symbolMeta.symbolMargin * 2;
    $776888f3e44e6872$var$eachPath(bar, function(path) {
        path.__pictorialAnimationIndex = index;
        path.__pictorialRepeatTimes = repeatTimes;
        if (index < repeatTimes) $776888f3e44e6872$var$updateAttr(path, null, makeTarget(index), symbolMeta, isUpdate);
        else $776888f3e44e6872$var$updateAttr(path, null, {
            scale: [
                0,
                0
            ]
        }, symbolMeta, isUpdate, function() {
            bundle.remove(path);
        });
        $776888f3e44e6872$var$updateHoverAnimation(path, symbolMeta);
        index++;
    });
    for(; index < repeatTimes; index++){
        var path = $776888f3e44e6872$var$createPath(symbolMeta);
        path.__pictorialAnimationIndex = index;
        path.__pictorialRepeatTimes = repeatTimes;
        bundle.add(path);
        var target = makeTarget(index);
        $776888f3e44e6872$var$updateAttr(path, {
            position: target.position,
            scale: [
                0,
                0
            ]
        }, {
            scale: target.scale,
            rotation: target.rotation
        }, symbolMeta, isUpdate); // FIXME
        // If all emphasis/normal through action.
        path.on("mouseover", onMouseOver).on("mouseout", onMouseOut);
        $776888f3e44e6872$var$updateHoverAnimation(path, symbolMeta);
    }
    function makeTarget(index) {
        var position = pathPosition.slice(); // (start && pxSign > 0) || (end && pxSign < 0): i = repeatTimes - index
        // Otherwise: i = index;
        var pxSign = symbolMeta.pxSign;
        var i = index;
        if (symbolMeta.symbolRepeatDirection === "start" ? pxSign > 0 : pxSign < 0) i = repeatTimes - 1 - index;
        position[valueDim.index] = unit * (i - repeatTimes / 2 + 0.5) + pathPosition[valueDim.index];
        return {
            position: position,
            scale: symbolMeta.symbolScale.slice(),
            rotation: symbolMeta.rotation
        };
    }
    function onMouseOver() {
        $776888f3e44e6872$var$eachPath(bar, function(path) {
            path.trigger("emphasis");
        });
    }
    function onMouseOut() {
        $776888f3e44e6872$var$eachPath(bar, function(path) {
            path.trigger("normal");
        });
    }
}
function $776888f3e44e6872$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta, isUpdate) {
    var bundle = bar.__pictorialBundle;
    var mainPath = bar.__pictorialMainPath;
    if (!mainPath) {
        mainPath = bar.__pictorialMainPath = $776888f3e44e6872$var$createPath(symbolMeta);
        bundle.add(mainPath);
        $776888f3e44e6872$var$updateAttr(mainPath, {
            position: symbolMeta.pathPosition.slice(),
            scale: [
                0,
                0
            ],
            rotation: symbolMeta.rotation
        }, {
            scale: symbolMeta.symbolScale.slice()
        }, symbolMeta, isUpdate);
        mainPath.on("mouseover", onMouseOver).on("mouseout", onMouseOut);
    } else $776888f3e44e6872$var$updateAttr(mainPath, null, {
        position: symbolMeta.pathPosition.slice(),
        scale: symbolMeta.symbolScale.slice(),
        rotation: symbolMeta.rotation
    }, symbolMeta, isUpdate);
    $776888f3e44e6872$var$updateHoverAnimation(mainPath, symbolMeta);
    function onMouseOver() {
        this.trigger("emphasis");
    }
    function onMouseOut() {
        this.trigger("normal");
    }
} // bar rect is used for label.
function $776888f3e44e6872$var$createOrUpdateBarRect(bar, symbolMeta, isUpdate) {
    var rectShape = $ec279652dd95c27b$export$8b58be045bf06082({}, symbolMeta.barRectShape);
    var barRect = bar.__pictorialBarRect;
    if (!barRect) {
        barRect = bar.__pictorialBarRect = new $4b57d6b582d579b7$exports.Rect({
            z2: 2,
            shape: rectShape,
            silent: true,
            style: {
                stroke: "transparent",
                fill: "transparent",
                lineWidth: 0
            }
        });
        bar.add(barRect);
    } else $776888f3e44e6872$var$updateAttr(barRect, null, {
        shape: rectShape
    }, symbolMeta, isUpdate);
}
function $776888f3e44e6872$var$createOrUpdateClip(bar, opt, symbolMeta, isUpdate) {
    // If not clip, symbol will be remove and rebuilt.
    if (symbolMeta.symbolClip) {
        var clipPath = bar.__pictorialClipPath;
        var clipShape = $ec279652dd95c27b$export$8b58be045bf06082({}, symbolMeta.clipShape);
        var valueDim = opt.valueDim;
        var animationModel = symbolMeta.animationModel;
        var dataIndex = symbolMeta.dataIndex;
        if (clipPath) $4b57d6b582d579b7$exports.updateProps(clipPath, {
            shape: clipShape
        }, animationModel, dataIndex);
        else {
            clipShape[valueDim.wh] = 0;
            clipPath = new $4b57d6b582d579b7$exports.Rect({
                shape: clipShape
            });
            bar.__pictorialBundle.setClipPath(clipPath);
            bar.__pictorialClipPath = clipPath;
            var target = {};
            target[valueDim.wh] = symbolMeta.clipShape[valueDim.wh];
            $4b57d6b582d579b7$exports[isUpdate ? "updateProps" : "initProps"](clipPath, {
                shape: target
            }, animationModel, dataIndex);
        }
    }
}
function $776888f3e44e6872$var$getItemModel(data, dataIndex) {
    var itemModel = data.getItemModel(dataIndex);
    itemModel.getAnimationDelayParams = $776888f3e44e6872$var$getAnimationDelayParams;
    itemModel.isAnimationEnabled = $776888f3e44e6872$var$isAnimationEnabled;
    return itemModel;
}
function $776888f3e44e6872$var$getAnimationDelayParams(path) {
    // The order is the same as the z-order, see `symbolRepeatDiretion`.
    return {
        index: path.__pictorialAnimationIndex,
        count: path.__pictorialRepeatTimes
    };
}
function $776888f3e44e6872$var$isAnimationEnabled() {
    // `animation` prop can be set on itemModel in pictorial bar chart.
    return this.parentModel.isAnimationEnabled() && !!this.getShallow("animation");
}
function $776888f3e44e6872$var$updateHoverAnimation(path, symbolMeta) {
    path.off("emphasis").off("normal");
    var scale = symbolMeta.symbolScale.slice();
    symbolMeta.hoverAnimation && path.on("emphasis", function() {
        this.animateTo({
            scale: [
                scale[0] * 1.1,
                scale[1] * 1.1
            ]
        }, 400, "elasticOut");
    }).on("normal", function() {
        this.animateTo({
            scale: scale.slice()
        }, 400, "elasticOut");
    });
}
function $776888f3e44e6872$var$createBar(data, opt, symbolMeta, isUpdate) {
    // bar is the main element for each data.
    var bar = new $4b57d6b582d579b7$exports.Group(); // bundle is used for location and clip.
    var bundle = new $4b57d6b582d579b7$exports.Group();
    bar.add(bundle);
    bar.__pictorialBundle = bundle;
    bundle.attr("position", symbolMeta.bundlePosition.slice());
    if (symbolMeta.symbolRepeat) $776888f3e44e6872$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta);
    else $776888f3e44e6872$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta);
    $776888f3e44e6872$var$createOrUpdateBarRect(bar, symbolMeta, isUpdate);
    $776888f3e44e6872$var$createOrUpdateClip(bar, opt, symbolMeta, isUpdate);
    bar.__pictorialShapeStr = $776888f3e44e6872$var$getShapeStr(data, symbolMeta);
    bar.__pictorialSymbolMeta = symbolMeta;
    return bar;
}
function $776888f3e44e6872$var$updateBar(bar, opt, symbolMeta) {
    var animationModel = symbolMeta.animationModel;
    var dataIndex = symbolMeta.dataIndex;
    var bundle = bar.__pictorialBundle;
    $4b57d6b582d579b7$exports.updateProps(bundle, {
        position: symbolMeta.bundlePosition.slice()
    }, animationModel, dataIndex);
    if (symbolMeta.symbolRepeat) $776888f3e44e6872$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta, true);
    else $776888f3e44e6872$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta, true);
    $776888f3e44e6872$var$createOrUpdateBarRect(bar, symbolMeta, true);
    $776888f3e44e6872$var$createOrUpdateClip(bar, opt, symbolMeta, true);
}
function $776888f3e44e6872$var$removeBar(data, dataIndex, animationModel, bar) {
    // Not show text when animating
    var labelRect = bar.__pictorialBarRect;
    labelRect && (labelRect.style.text = null);
    var pathes = [];
    $776888f3e44e6872$var$eachPath(bar, function(path) {
        pathes.push(path);
    });
    bar.__pictorialMainPath && pathes.push(bar.__pictorialMainPath); // I do not find proper remove animation for clip yet.
    bar.__pictorialClipPath && (animationModel = null);
    $ec279652dd95c27b$export$79b2f7037acddd43(pathes, function(path) {
        $4b57d6b582d579b7$exports.updateProps(path, {
            scale: [
                0,
                0
            ]
        }, animationModel, dataIndex, function() {
            bar.parent && bar.parent.remove(bar);
        });
    });
    data.setItemGraphicEl(dataIndex, null);
}
function $776888f3e44e6872$var$getShapeStr(data, symbolMeta) {
    return [
        data.getItemVisual(symbolMeta.dataIndex, "symbol") || "none",
        !!symbolMeta.symbolRepeat,
        !!symbolMeta.symbolClip
    ].join(":");
}
function $776888f3e44e6872$var$eachPath(bar, cb, context) {
    // Do not use Group#eachChild, because it do not support remove.
    $ec279652dd95c27b$export$79b2f7037acddd43(bar.__pictorialBundle.children(), function(el) {
        el !== bar.__pictorialBarRect && cb.call(context, el);
    });
}
function $776888f3e44e6872$var$updateAttr(el, immediateAttrs, animationAttrs, symbolMeta, isUpdate, cb) {
    immediateAttrs && el.attr(immediateAttrs); // when symbolCip used, only clip path has init animation, otherwise it would be weird effect.
    if (symbolMeta.symbolClip && !isUpdate) animationAttrs && el.attr(animationAttrs);
    else animationAttrs && $4b57d6b582d579b7$exports[isUpdate ? "updateProps" : "initProps"](el, animationAttrs, symbolMeta.animationModel, symbolMeta.dataIndex, cb);
}
function $776888f3e44e6872$var$updateCommon(bar, opt, symbolMeta) {
    var color = symbolMeta.color;
    var dataIndex = symbolMeta.dataIndex;
    var itemModel = symbolMeta.itemModel; // Color must be excluded.
    // Because symbol provide setColor individually to set fill and stroke
    var normalStyle = itemModel.getModel("itemStyle").getItemStyle([
        "color"
    ]);
    var hoverStyle = itemModel.getModel("emphasis.itemStyle").getItemStyle();
    var cursorStyle = itemModel.getShallow("cursor");
    $776888f3e44e6872$var$eachPath(bar, function(path) {
        // PENDING setColor should be before setStyle!!!
        path.setColor(color);
        path.setStyle($ec279652dd95c27b$export$ebe90cb607ad99e({
            fill: color,
            opacity: symbolMeta.opacity
        }, normalStyle));
        $4b57d6b582d579b7$exports.setHoverStyle(path, hoverStyle);
        cursorStyle && (path.cursor = cursorStyle);
        path.z2 = symbolMeta.z2;
    });
    var barRectHoverStyle = {};
    var barPositionOutside = opt.valueDim.posDesc[+(symbolMeta.boundingLength > 0)];
    var barRect = bar.__pictorialBarRect;
    $776888f3e44e6872$var$setLabel(barRect.style, barRectHoverStyle, itemModel, color, opt.seriesModel, dataIndex, barPositionOutside);
    $4b57d6b582d579b7$exports.setHoverStyle(barRect, barRectHoverStyle);
}
function $776888f3e44e6872$var$toIntTimes(times) {
    var roundedTimes = Math.round(times); // Escapse accurate error
    return Math.abs(times - roundedTimes) < 1e-4 ? roundedTimes : Math.ceil(times);
}
var $776888f3e44e6872$var$_default = $776888f3e44e6872$var$BarView;
$776888f3e44e6872$exports = $776888f3e44e6872$var$_default;



var $aadb6b93de4f6105$var$layout = $249e780a835e3f86$export$b3219800bda33a1f;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // In case developer forget to include grid component
$f406636b535430a7$exports.registerLayout($ec279652dd95c27b$export$c3095a23b368d1f2($aadb6b93de4f6105$var$layout, "pictorialBar"));
$f406636b535430a7$exports.registerVisual($6efa4c3507ca2b4d$exports("pictorialBar", "roundRect"));


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $155aeaceae47210e$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $b3d280146d16cde6$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @constructor  module:echarts/coord/single/SingleAxis
 * @extends {module:echarts/coord/Axis}
 * @param {string} dim
 * @param {*} scale
 * @param {Array.<number>} coordExtent
 * @param {string} axisType
 * @param {string} position
 */ var $b3d280146d16cde6$var$SingleAxis = function(dim, scale, coordExtent, axisType, position) {
    $95e1f94acccc578d$exports.call(this, dim, scale, coordExtent);
    /**
   * Axis type
   * - 'category'
   * - 'value'
   * - 'time'
   * - 'log'
   * @type {string}
   */ this.type = axisType || "value";
    /**
   * Axis position
   *  - 'top'
   *  - 'bottom'
   *  - 'left'
   *  - 'right'
   *  @type {string}
   */ this.position = position || "bottom";
    /**
   * Axis orient
   *  - 'horizontal'
   *  - 'vertical'
   * @type {[type]}
   */ this.orient = null;
};
$b3d280146d16cde6$var$SingleAxis.prototype = {
    constructor: $b3d280146d16cde6$var$SingleAxis,
    /**
   * Axis model
   * @type {module:echarts/coord/single/AxisModel}
   */ model: null,
    /**
   * Judge the orient of the axis.
   * @return {boolean}
   */ isHorizontal: function() {
        var position = this.position;
        return position === "top" || position === "bottom";
    },
    /**
   * @override
   */ pointToData: function(point, clamp) {
        return this.coordinateSystem.pointToData(point, clamp)[0];
    },
    /**
   * Convert the local coord(processed by dataToCoord())
   * to global coord(concrete pixel coord).
   * designated by module:echarts/coord/single/Single.
   * @type {Function}
   */ toGlobalCoord: null,
    /**
   * Convert the global coord to local coord.
   * designated by module:echarts/coord/single/Single.
   * @type {Function}
   */ toLocalCoord: null
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($b3d280146d16cde6$var$SingleAxis, $95e1f94acccc578d$exports);
var $b3d280146d16cde6$var$_default = $b3d280146d16cde6$var$SingleAxis;
$b3d280146d16cde6$exports = $b3d280146d16cde6$var$_default;




var $155aeaceae47210e$var$getLayoutRect = $ab0c9086dd6c5b39$export$4517a5ca639a7293;

var $155aeaceae47210e$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Single coordinates system.
 */ /**
 * Create a single coordinates system.
 *
 * @param {module:echarts/coord/single/AxisModel} axisModel
 * @param {module:echarts/model/Global} ecModel
 * @param {module:echarts/ExtensionAPI} api
 */ function $155aeaceae47210e$var$Single(axisModel, ecModel, api) {
    /**
   * @type {string}
   * @readOnly
   */ this.dimension = "single";
    /**
   * Add it just for draw tooltip.
   *
   * @type {Array.<string>}
   * @readOnly
   */ this.dimensions = [
        "single"
    ];
    /**
   * @private
   * @type {module:echarts/coord/single/SingleAxis}.
   */ this._axis = null;
    /**
   * @private
   * @type {module:zrender/core/BoundingRect}
   */ this._rect;
    this._init(axisModel, ecModel, api);
    /**
   * @type {module:echarts/coord/single/AxisModel}
   */ this.model = axisModel;
}
$155aeaceae47210e$var$Single.prototype = {
    type: "singleAxis",
    axisPointerEnabled: true,
    constructor: $155aeaceae47210e$var$Single,
    /**
   * Initialize single coordinate system.
   *
   * @param  {module:echarts/coord/single/AxisModel} axisModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @private
   */ _init: function(axisModel, ecModel, api) {
        var dim = this.dimension;
        var axis = new $b3d280146d16cde6$exports(dim, $13542623aa20eeae$export$8941c4cacdc8f5a5(axisModel), [
            0,
            0
        ], axisModel.get("type"), axisModel.get("position"));
        var isCategory = axis.type === "category";
        axis.onBand = isCategory && axisModel.get("boundaryGap");
        axis.inverse = axisModel.get("inverse");
        axis.orient = axisModel.get("orient");
        axisModel.axis = axis;
        axis.model = axisModel;
        axis.coordinateSystem = this;
        this._axis = axis;
    },
    /**
   * Update axis scale after data processed
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */ update: function(ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.coordinateSystem === this) {
                var data = seriesModel.getData();
                $155aeaceae47210e$var$each(data.mapDimension(this.dimension, true), function(dim) {
                    this._axis.scale.unionExtentFromData(data, dim);
                }, this);
                $13542623aa20eeae$export$51f3e70a54405d5a(this._axis.scale, this._axis.model);
            }
        }, this);
    },
    /**
   * Resize the single coordinate system.
   *
   * @param  {module:echarts/coord/single/AxisModel} axisModel
   * @param  {module:echarts/ExtensionAPI} api
   */ resize: function(axisModel, api) {
        this._rect = $155aeaceae47210e$var$getLayoutRect({
            left: axisModel.get("left"),
            top: axisModel.get("top"),
            right: axisModel.get("right"),
            bottom: axisModel.get("bottom"),
            width: axisModel.get("width"),
            height: axisModel.get("height")
        }, {
            width: api.getWidth(),
            height: api.getHeight()
        });
        this._adjustAxis();
    },
    /**
   * @return {module:zrender/core/BoundingRect}
   */ getRect: function() {
        return this._rect;
    },
    /**
   * @private
   */ _adjustAxis: function() {
        var rect = this._rect;
        var axis = this._axis;
        var isHorizontal = axis.isHorizontal();
        var extent = isHorizontal ? [
            0,
            rect.width
        ] : [
            0,
            rect.height
        ];
        var idx = axis.reverse ? 1 : 0;
        axis.setExtent(extent[idx], extent[1 - idx]);
        this._updateAxisTransform(axis, isHorizontal ? rect.x : rect.y);
    },
    /**
   * @param  {module:echarts/coord/single/SingleAxis} axis
   * @param  {number} coordBase
   */ _updateAxisTransform: function(axis, coordBase) {
        var axisExtent = axis.getExtent();
        var extentSum = axisExtent[0] + axisExtent[1];
        var isHorizontal = axis.isHorizontal();
        axis.toGlobalCoord = isHorizontal ? function(coord) {
            return coord + coordBase;
        } : function(coord) {
            return extentSum - coord + coordBase;
        };
        axis.toLocalCoord = isHorizontal ? function(coord) {
            return coord - coordBase;
        } : function(coord) {
            return extentSum - coord + coordBase;
        };
    },
    /**
   * Get axis.
   *
   * @return {module:echarts/coord/single/SingleAxis}
   */ getAxis: function() {
        return this._axis;
    },
    /**
   * Get axis, add it just for draw tooltip.
   *
   * @return {[type]} [description]
   */ getBaseAxis: function() {
        return this._axis;
    },
    /**
   * @return {Array.<module:echarts/coord/Axis>}
   */ getAxes: function() {
        return [
            this._axis
        ];
    },
    /**
   * @return {Object} {baseAxes: [], otherAxes: []}
   */ getTooltipAxes: function() {
        return {
            baseAxes: [
                this.getAxis()
            ]
        };
    },
    /**
   * If contain point.
   *
   * @param  {Array.<number>} point
   * @return {boolean}
   */ containPoint: function(point) {
        var rect = this.getRect();
        var axis = this.getAxis();
        var orient = axis.orient;
        if (orient === "horizontal") return axis.contain(axis.toLocalCoord(point[0])) && point[1] >= rect.y && point[1] <= rect.y + rect.height;
        else return axis.contain(axis.toLocalCoord(point[1])) && point[0] >= rect.y && point[0] <= rect.y + rect.height;
    },
    /**
   * @param {Array.<number>} point
   * @return {Array.<number>}
   */ pointToData: function(point) {
        var axis = this.getAxis();
        return [
            axis.coordToData(axis.toLocalCoord(point[axis.orient === "horizontal" ? 0 : 1]))
        ];
    },
    /**
   * Convert the series data to concrete point.
   *
   * @param  {number|Array.<number>} val
   * @return {Array.<number>}
   */ dataToPoint: function(val) {
        var axis = this.getAxis();
        var rect = this.getRect();
        var pt = [];
        var idx = axis.orient === "horizontal" ? 0 : 1;
        if (val instanceof Array) val = val[0];
        pt[idx] = axis.toGlobalCoord(axis.dataToCoord(+val));
        pt[1 - idx] = idx === 0 ? rect.y + rect.height / 2 : rect.x + rect.width / 2;
        return pt;
    }
};
var $155aeaceae47210e$var$_default = $155aeaceae47210e$var$Single;
$155aeaceae47210e$exports = $155aeaceae47210e$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Single coordinate system creator.
 */ /**
 * Create single coordinate system and inject it into seriesModel.
 *
 * @param {module:echarts/model/Global} ecModel
 * @param {module:echarts/ExtensionAPI} api
 * @return {Array.<module:echarts/coord/single/Single>}
 */ function $ce4ba6f03ae4afda$var$create(ecModel, api) {
    var singles = [];
    ecModel.eachComponent("singleAxis", function(axisModel, idx) {
        var single = new $155aeaceae47210e$exports(axisModel, ecModel, api);
        single.name = "single_" + idx;
        single.resize(axisModel, api);
        axisModel.coordinateSystem = single;
        singles.push(single);
    });
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.get("coordinateSystem") === "singleAxis") {
            var singleAxisModel = ecModel.queryComponents({
                mainType: "singleAxis",
                index: seriesModel.get("singleAxisIndex"),
                id: seriesModel.get("singleAxisId")
            })[0];
            seriesModel.coordinateSystem = singleAxisModel && singleAxisModel.coordinateSystem;
        }
    });
    return singles;
}
$9c36d0fff3b0f387$exports.register("single", {
    create: $ce4ba6f03ae4afda$var$create,
    dimensions: $155aeaceae47210e$exports.prototype.dimensions
});


var $bc4522a2fa734293$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $faeb8b4722a93173$export$b3219800bda33a1f;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @param {Object} opt {labelInside}
 * @return {Object} {
 *  position, rotation, labelDirection, labelOffset,
 *  tickDirection, labelRotate, z2
 * }
 */ function $faeb8b4722a93173$var$layout(axisModel, opt) {
    opt = opt || {};
    var single = axisModel.coordinateSystem;
    var axis = axisModel.axis;
    var layout = {};
    var axisPosition = axis.position;
    var orient = axis.orient;
    var rect = single.getRect();
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var positionMap = {
        horizontal: {
            top: rectBound[2],
            bottom: rectBound[3]
        },
        vertical: {
            left: rectBound[0],
            right: rectBound[1]
        }
    };
    layout.position = [
        orient === "vertical" ? positionMap.vertical[axisPosition] : rectBound[0],
        orient === "horizontal" ? positionMap.horizontal[axisPosition] : rectBound[3]
    ];
    var r = {
        horizontal: 0,
        vertical: 1
    };
    layout.rotation = Math.PI / 2 * r[orient];
    var directionMap = {
        top: -1,
        bottom: 1,
        right: 1,
        left: -1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = directionMap[axisPosition];
    if (axisModel.get("axisTick.inside")) layout.tickDirection = -layout.tickDirection;
    if ($ec279652dd95c27b$export$8a4d17b6e8486e66(opt.labelInside, axisModel.get("axisLabel.inside"))) layout.labelDirection = -layout.labelDirection;
    var labelRotation = opt.rotate;
    labelRotation == null && (labelRotation = axisModel.get("axisLabel.rotate"));
    layout.labelRotation = axisPosition === "top" ? -labelRotation : labelRotation;
    layout.z2 = 1;
    return layout;
}
$faeb8b4722a93173$export$b3219800bda33a1f = $faeb8b4722a93173$var$layout;




var $bc4522a2fa734293$var$rectCoordAxisBuildSplitArea = $7667fad32ad54e48$export$c80b7ef1527ec8c9;
var $bc4522a2fa734293$var$rectCoordAxisHandleRemove = $7667fad32ad54e48$export$48ebf2d6ce8ad076;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $bc4522a2fa734293$var$axisBuilderAttrs = [
    "axisLine",
    "axisTickLabel",
    "axisName"
];
var $bc4522a2fa734293$var$selfBuilderAttrs = [
    "splitArea",
    "splitLine"
];
var $bc4522a2fa734293$var$SingleAxisView = $0880bad8284a1b39$exports.extend({
    type: "singleAxis",
    axisPointerClass: "SingleAxisPointer",
    render: function(axisModel, ecModel, api, payload) {
        var group = this.group;
        group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
        var layout = $faeb8b4722a93173$export$b3219800bda33a1f(axisModel);
        var axisBuilder = new $3ce77a4133d2c8eb$exports(axisModel, layout);
        $ec279652dd95c27b$export$79b2f7037acddd43($bc4522a2fa734293$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
        group.add(this._axisGroup);
        group.add(axisBuilder.getGroup());
        $ec279652dd95c27b$export$79b2f7037acddd43($bc4522a2fa734293$var$selfBuilderAttrs, function(name) {
            if (axisModel.get(name + ".show")) this["_" + name](axisModel);
        }, this);
        $4b57d6b582d579b7$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
        $bc4522a2fa734293$var$SingleAxisView.superCall(this, "render", axisModel, ecModel, api, payload);
    },
    remove: function() {
        $bc4522a2fa734293$var$rectCoordAxisHandleRemove(this);
    },
    _splitLine: function(axisModel) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel("splitLine");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var lineWidth = lineStyleModel.get("width");
        var lineColors = lineStyleModel.get("color");
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var gridRect = axisModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var splitLines = [];
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel
        });
        var p1 = [];
        var p2 = [];
        for(var i = 0; i < ticksCoords.length; ++i){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(new $4b57d6b582d579b7$export$17d680238e50603e({
                subPixelOptimize: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: {
                    lineWidth: lineWidth
                },
                silent: true
            }));
        }
        for(var i = 0; i < splitLines.length; ++i)this.group.add($4b57d6b582d579b7$export$7b1dd269fbc4e903(splitLines[i], {
            style: {
                stroke: lineColors[i % lineColors.length],
                lineDash: lineStyleModel.getLineDash(lineWidth),
                lineWidth: lineWidth
            },
            silent: true
        }));
    },
    _splitArea: function(axisModel) {
        $bc4522a2fa734293$var$rectCoordAxisBuildSplitArea(this, this._axisGroup, axisModel, axisModel);
    }
});
var $bc4522a2fa734293$var$_default = $bc4522a2fa734293$var$SingleAxisView;
$bc4522a2fa734293$exports = $bc4522a2fa734293$var$_default;


var $5f5e7020486264f4$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $5f5e7020486264f4$var$AxisModel = $3b9c2389e45dfb7d$exports.extend({
    type: "singleAxis",
    layoutMode: "box",
    /**
   * @type {module:echarts/coord/single/SingleAxis}
   */ axis: null,
    /**
   * @type {module:echarts/coord/single/Single}
   */ coordinateSystem: null,
    /**
   * @override
   */ getCoordSysModel: function() {
        return this;
    }
});
var $5f5e7020486264f4$var$defaultOption = {
    left: "5%",
    top: "5%",
    right: "5%",
    bottom: "5%",
    type: "value",
    position: "bottom",
    orient: "horizontal",
    axisLine: {
        show: true,
        lineStyle: {
            width: 1,
            type: "solid"
        }
    },
    // Single coordinate system and single axis is the,
    // which is used as the parent tooltip model.
    // same model, so we set default tooltip show as true.
    tooltip: {
        show: true
    },
    axisTick: {
        show: true,
        length: 6,
        lineStyle: {
            width: 1
        }
    },
    axisLabel: {
        show: true,
        interval: "auto"
    },
    splitLine: {
        show: true,
        lineStyle: {
            type: "dashed",
            opacity: 0.2
        }
    }
};
function $5f5e7020486264f4$var$getAxisType(axisName, option) {
    return option.type || (option.data ? "category" : "value");
}
$ec279652dd95c27b$export$4950aa0f605343fb($5f5e7020486264f4$var$AxisModel.prototype, $ce1d0648e3723c9f$exports);
$b94fd69108c44724$exports("single", $5f5e7020486264f4$var$AxisModel, $5f5e7020486264f4$var$getAxisType, $5f5e7020486264f4$var$defaultOption);
var $5f5e7020486264f4$var$_default = $5f5e7020486264f4$var$AxisModel;
$5f5e7020486264f4$exports = $5f5e7020486264f4$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $6cb5d26145fab208$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $6cb5d26145fab208$var$makeInner = $d559f43cb9041423$export$64df9f8d92ae083f;

var $764073131e463cfe$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @param {Object} finder contains {seriesIndex, dataIndex, dataIndexInside}
 * @param {module:echarts/model/Global} ecModel
 * @return {Object} {point: [x, y], el: ...} point Will not be null.
 */ function $764073131e463cfe$var$_default(finder, ecModel) {
    var point = [];
    var seriesIndex = finder.seriesIndex;
    var seriesModel;
    if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) return {
        point: []
    };
    var data = seriesModel.getData();
    var dataIndex = $d559f43cb9041423$export$42b26cae8b8d10(data, finder);
    if (dataIndex == null || dataIndex < 0 || $ec279652dd95c27b$export$43bee75e5e14138e(dataIndex)) return {
        point: []
    };
    var el = data.getItemGraphicEl(dataIndex);
    var coordSys = seriesModel.coordinateSystem;
    if (seriesModel.getTooltipPosition) point = seriesModel.getTooltipPosition(dataIndex) || [];
    else if (coordSys && coordSys.dataToPoint) point = coordSys.dataToPoint(data.getValues($ec279652dd95c27b$export$871de8747c9eaa88(coordSys.dimensions, function(dim) {
        return data.mapDimension(dim);
    }), dataIndex, true)) || [];
    else if (el) {
        // Use graphic bounding rect
        var rect = el.getBoundingRect().clone();
        rect.applyTransform(el.transform);
        point = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    }
    return {
        point: point,
        el: el
    };
}
$764073131e463cfe$exports = $764073131e463cfe$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $6cb5d26145fab208$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $6cb5d26145fab208$var$curry = $ec279652dd95c27b$export$c3095a23b368d1f2;
var $6cb5d26145fab208$var$inner = $6cb5d26145fab208$var$makeInner();
/**
 * Basic logic: check all axis, if they do not demand show/highlight,
 * then hide/downplay them.
 *
 * @param {Object} coordSysAxesInfo
 * @param {Object} payload
 * @param {string} [payload.currTrigger] 'click' | 'mousemove' | 'leave'
 * @param {Array.<number>} [payload.x] x and y, which are mandatory, specify a point to
 *              trigger axisPointer and tooltip.
 * @param {Array.<number>} [payload.y] x and y, which are mandatory, specify a point to
 *              trigger axisPointer and tooltip.
 * @param {Object} [payload.seriesIndex] finder, optional, restrict target axes.
 * @param {Object} [payload.dataIndex] finder, restrict target axes.
 * @param {Object} [payload.axesInfo] finder, restrict target axes.
 *        [{
 *          axisDim: 'x'|'y'|'angle'|...,
 *          axisIndex: ...,
 *          value: ...
 *        }, ...]
 * @param {Function} [payload.dispatchAction]
 * @param {Object} [payload.tooltipOption]
 * @param {Object|Array.<number>|Function} [payload.position] Tooltip position,
 *        which can be specified in dispatchAction
 * @param {module:echarts/model/Global} ecModel
 * @param {module:echarts/ExtensionAPI} api
 * @return {Object} content of event obj for echarts.connect.
 */ function $6cb5d26145fab208$var$_default(payload, ecModel, api) {
    var currTrigger = payload.currTrigger;
    var point = [
        payload.x,
        payload.y
    ];
    var finder = payload;
    var dispatchAction = payload.dispatchAction || $ec279652dd95c27b$export$2385a24977818dd0(api.dispatchAction, api);
    var coordSysAxesInfo = ecModel.getComponent("axisPointer").coordSysAxesInfo; // Pending
    // See #6121. But we are not able to reproduce it yet.
    if (!coordSysAxesInfo) return;
    if ($6cb5d26145fab208$var$illegalPoint(point)) // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = $764073131e463cfe$exports({
        seriesIndex: finder.seriesIndex,
        // Do not use dataIndexInside from other ec instance.
        // FIXME: auto detect it?
        dataIndex: finder.dataIndex
    }, ecModel).point;
    var isIllegalPoint = $6cb5d26145fab208$var$illegalPoint(point); // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
    // Notice: In this case, it is difficult to get the `point` (which is necessary to show
    // tooltip, so if point is not given, we just use the point found by sample seriesIndex
    // and dataIndex.
    var inputAxesInfo = finder.axesInfo;
    var axesInfo = coordSysAxesInfo.axesInfo;
    var shouldHide = currTrigger === "leave" || $6cb5d26145fab208$var$illegalPoint(point);
    var outputFinder = {};
    var showValueMap = {};
    var dataByCoordSys = {
        list: [],
        map: {}
    };
    var updaters = {
        showPointer: $6cb5d26145fab208$var$curry($6cb5d26145fab208$var$showPointer, showValueMap),
        showTooltip: $6cb5d26145fab208$var$curry($6cb5d26145fab208$var$showTooltip, dataByCoordSys)
    }; // Process for triggered axes.
    $6cb5d26145fab208$var$each(coordSysAxesInfo.coordSysMap, function(coordSys, coordSysKey) {
        // If a point given, it must be contained by the coordinate system.
        var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
        $6cb5d26145fab208$var$each(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function(axisInfo, key) {
            var axis = axisInfo.axis;
            var inputAxisInfo = $6cb5d26145fab208$var$findInputAxisInfo(inputAxesInfo, axisInfo); // If no inputAxesInfo, no axis is restricted.
            if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
                var val = inputAxisInfo && inputAxisInfo.value;
                if (val == null && !isIllegalPoint) val = axis.pointToData(point);
                val != null && $6cb5d26145fab208$var$processOnAxis(axisInfo, val, updaters, false, outputFinder);
            }
        });
    }); // Process for linked axes.
    var linkTriggers = {};
    $6cb5d26145fab208$var$each(axesInfo, function(tarAxisInfo, tarKey) {
        var linkGroup = tarAxisInfo.linkGroup; // If axis has been triggered in the previous stage, it should not be triggered by link.
        if (linkGroup && !showValueMap[tarKey]) $6cb5d26145fab208$var$each(linkGroup.axesInfo, function(srcAxisInfo, srcKey) {
            var srcValItem = showValueMap[srcKey]; // If srcValItem exist, source axis is triggered, so link to target axis.
            if (srcAxisInfo !== tarAxisInfo && srcValItem) {
                var val = srcValItem.value;
                linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, $6cb5d26145fab208$var$makeMapperParam(srcAxisInfo), $6cb5d26145fab208$var$makeMapperParam(tarAxisInfo))));
                linkTriggers[tarAxisInfo.key] = val;
            }
        });
    });
    $6cb5d26145fab208$var$each(linkTriggers, function(val, tarKey) {
        $6cb5d26145fab208$var$processOnAxis(axesInfo[tarKey], val, updaters, true, outputFinder);
    });
    $6cb5d26145fab208$var$updateModelActually(showValueMap, axesInfo, outputFinder);
    $6cb5d26145fab208$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
    $6cb5d26145fab208$var$dispatchHighDownActually(axesInfo, dispatchAction, api);
    return outputFinder;
}
function $6cb5d26145fab208$var$processOnAxis(axisInfo, newValue, updaters, dontSnap, outputFinder) {
    var axis = axisInfo.axis;
    if (axis.scale.isBlank() || !axis.containData(newValue)) return;
    if (!axisInfo.involveSeries) {
        updaters.showPointer(axisInfo, newValue);
        return;
    } // Heavy calculation. So put it after axis.containData checking.
    var payloadInfo = $6cb5d26145fab208$var$buildPayloadsBySeries(newValue, axisInfo);
    var payloadBatch = payloadInfo.payloadBatch;
    var snapToValue = payloadInfo.snapToValue; // Fill content of event obj for echarts.connect.
    // By default use the first involved series data as a sample to connect.
    if (payloadBatch[0] && outputFinder.seriesIndex == null) $ec279652dd95c27b$export$8b58be045bf06082(outputFinder, payloadBatch[0]);
     // If no linkSource input, this process is for collecting link
    // target, where snap should not be accepted.
    if (!dontSnap && axisInfo.snap) {
        if (axis.containData(snapToValue) && snapToValue != null) newValue = snapToValue;
    }
    updaters.showPointer(axisInfo, newValue, payloadBatch, outputFinder); // Tooltip should always be snapToValue, otherwise there will be
    // incorrect "axis value ~ series value" mapping displayed in tooltip.
    updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}
function $6cb5d26145fab208$var$buildPayloadsBySeries(value, axisInfo) {
    var axis = axisInfo.axis;
    var dim = axis.dim;
    var snapToValue = value;
    var payloadBatch = [];
    var minDist = Number.MAX_VALUE;
    var minDiff = -1;
    $6cb5d26145fab208$var$each(axisInfo.seriesModels, function(series, idx) {
        var dataDim = series.getData().mapDimension(dim, true);
        var seriesNestestValue;
        var dataIndices;
        if (series.getAxisTooltipData) {
            var result = series.getAxisTooltipData(dataDim, value, axis);
            dataIndices = result.dataIndices;
            seriesNestestValue = result.nestestValue;
        } else {
            dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // when data length is not same.
            // false,
            axis.type === "category" ? 0.5 : null);
            if (!dataIndices.length) return;
            seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
        }
        if (seriesNestestValue == null || !isFinite(seriesNestestValue)) return;
        var diff = value - seriesNestestValue;
        var dist = Math.abs(diff); // Consider category case
        if (dist <= minDist) {
            if (dist < minDist || diff >= 0 && minDiff < 0) {
                minDist = dist;
                minDiff = diff;
                snapToValue = seriesNestestValue;
                payloadBatch.length = 0;
            }
            $6cb5d26145fab208$var$each(dataIndices, function(dataIndex) {
                payloadBatch.push({
                    seriesIndex: series.seriesIndex,
                    dataIndexInside: dataIndex,
                    dataIndex: series.getData().getRawIndex(dataIndex)
                });
            });
        }
    });
    return {
        payloadBatch: payloadBatch,
        snapToValue: snapToValue
    };
}
function $6cb5d26145fab208$var$showPointer(showValueMap, axisInfo, value, payloadBatch) {
    showValueMap[axisInfo.key] = {
        value: value,
        payloadBatch: payloadBatch
    };
}
function $6cb5d26145fab208$var$showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
    var payloadBatch = payloadInfo.payloadBatch;
    var axis = axisInfo.axis;
    var axisModel = axis.model;
    var axisPointerModel = axisInfo.axisPointerModel; // If no data, do not create anything in dataByCoordSys,
    // whose length will be used to judge whether dispatch action.
    if (!axisInfo.triggerTooltip || !payloadBatch.length) return;
    var coordSysModel = axisInfo.coordSys.model;
    var coordSysKey = $16df2470cde098b3$export$d01b444bafb1a792(coordSysModel);
    var coordSysItem = dataByCoordSys.map[coordSysKey];
    if (!coordSysItem) {
        coordSysItem = dataByCoordSys.map[coordSysKey] = {
            coordSysId: coordSysModel.id,
            coordSysIndex: coordSysModel.componentIndex,
            coordSysType: coordSysModel.type,
            coordSysMainType: coordSysModel.mainType,
            dataByAxis: []
        };
        dataByCoordSys.list.push(coordSysItem);
    }
    coordSysItem.dataByAxis.push({
        axisDim: axis.dim,
        axisIndex: axisModel.componentIndex,
        axisType: axisModel.type,
        axisId: axisModel.id,
        value: value,
        // Caustion: viewHelper.getValueLabel is actually on "view stage", which
        // depends that all models have been updated. So it should not be performed
        // here. Considering axisPointerModel used here is volatile, which is hard
        // to be retrieve in TooltipView, we prepare parameters here.
        valueLabelOpt: {
            precision: axisPointerModel.get("label.precision"),
            formatter: axisPointerModel.get("label.formatter")
        },
        seriesDataIndices: payloadBatch.slice()
    });
}
function $6cb5d26145fab208$var$updateModelActually(showValueMap, axesInfo, outputFinder) {
    var outputAxesInfo = outputFinder.axesInfo = []; // Basic logic: If no 'show' required, 'hide' this axisPointer.
    $6cb5d26145fab208$var$each(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        var valItem = showValueMap[key];
        if (valItem) {
            !axisInfo.useHandle && (option.status = "show");
            option.value = valItem.value; // For label formatter param and highlight.
            option.seriesDataIndices = (valItem.payloadBatch || []).slice();
        } else // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = "hide");
         // If status is 'hide', should be no info in payload.
        option.status === "show" && outputAxesInfo.push({
            axisDim: axisInfo.axis.dim,
            axisIndex: axisInfo.axis.model.componentIndex,
            value: option.value
        });
    });
}
function $6cb5d26145fab208$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
    // Basic logic: If no showTip required, hideTip will be dispatched.
    if ($6cb5d26145fab208$var$illegalPoint(point) || !dataByCoordSys.list.length) {
        dispatchAction({
            type: "hideTip"
        });
        return;
    } // In most case only one axis (or event one series is used). It is
    // convinient to fetch payload.seriesIndex and payload.dataIndex
    // dirtectly. So put the first seriesIndex and dataIndex of the first
    // axis on the payload.
    var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
    dispatchAction({
        type: "showTip",
        escapeConnect: true,
        x: point[0],
        y: point[1],
        tooltipOption: payload.tooltipOption,
        position: payload.position,
        dataIndexInside: sampleItem.dataIndexInside,
        dataIndex: sampleItem.dataIndex,
        seriesIndex: sampleItem.seriesIndex,
        dataByCoordSys: dataByCoordSys.list
    });
}
function $6cb5d26145fab208$var$dispatchHighDownActually(axesInfo, dispatchAction, api) {
    // FIXME
    // highlight status modification shoule be a stage of main process?
    // (Consider confilct (e.g., legend and axisPointer) and setOption)
    var zr = api.getZr();
    var highDownKey = "axisPointerLastHighlights";
    var lastHighlights = $6cb5d26145fab208$var$inner(zr)[highDownKey] || {};
    var newHighlights = $6cb5d26145fab208$var$inner(zr)[highDownKey] = {}; // Update highlight/downplay status according to axisPointer model.
    // Build hash map and remove duplicate incidentally.
    $6cb5d26145fab208$var$each(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        option.status === "show" && $6cb5d26145fab208$var$each(option.seriesDataIndices, function(batchItem) {
            var key = batchItem.seriesIndex + " | " + batchItem.dataIndex;
            newHighlights[key] = batchItem;
        });
    }); // Diff.
    var toHighlight = [];
    var toDownplay = [];
    $ec279652dd95c27b$export$79b2f7037acddd43(lastHighlights, function(batchItem, key) {
        !newHighlights[key] && toDownplay.push(batchItem);
    });
    $ec279652dd95c27b$export$79b2f7037acddd43(newHighlights, function(batchItem, key) {
        !lastHighlights[key] && toHighlight.push(batchItem);
    });
    toDownplay.length && api.dispatchAction({
        type: "downplay",
        escapeConnect: true,
        batch: toDownplay
    });
    toHighlight.length && api.dispatchAction({
        type: "highlight",
        escapeConnect: true,
        batch: toHighlight
    });
}
function $6cb5d26145fab208$var$findInputAxisInfo(inputAxesInfo, axisInfo) {
    for(var i = 0; i < (inputAxesInfo || []).length; i++){
        var inputAxisInfo = inputAxesInfo[i];
        if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) return inputAxisInfo;
    }
}
function $6cb5d26145fab208$var$makeMapperParam(axisInfo) {
    var axisModel = axisInfo.axis.model;
    var item = {};
    var dim = item.axisDim = axisInfo.axis.dim;
    item.axisIndex = item[dim + "AxisIndex"] = axisModel.componentIndex;
    item.axisName = item[dim + "AxisName"] = axisModel.name;
    item.axisId = item[dim + "AxisId"] = axisModel.id;
    return item;
}
function $6cb5d26145fab208$var$illegalPoint(point) {
    return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}
$6cb5d26145fab208$exports = $6cb5d26145fab208$var$_default;


var $b70f377d360d99f0$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $b70f377d360d99f0$var$AxisPointerModel = $f406636b535430a7$exports.extendComponentModel({
    type: "axisPointer",
    coordSysAxesInfo: null,
    defaultOption: {
        // 'auto' means that show when triggered by tooltip or handle.
        show: "auto",
        // 'click' | 'mousemove' | 'none'
        triggerOn: null,
        // set default in AxisPonterView.js
        zlevel: 0,
        z: 50,
        type: "line",
        // 'line' 'shadow' 'cross' 'none'.
        // axispointer triggered by tootip determine snap automatically,
        // see `modelHelper`.
        snap: false,
        triggerTooltip: true,
        value: null,
        status: null,
        // Init value depends on whether handle is used.
        // [group0, group1, ...]
        // Each group can be: {
        //      mapper: function () {},
        //      singleTooltip: 'multiple',  // 'multiple' or 'single'
        //      xAxisId: ...,
        //      yAxisName: ...,
        //      angleAxisIndex: ...
        // }
        // mapper: can be ignored.
        //      input: {axisInfo, value}
        //      output: {axisInfo, value}
        link: [],
        // Do not set 'auto' here, otherwise global animation: false
        // will not effect at this axispointer.
        animation: null,
        animationDurationUpdate: 200,
        lineStyle: {
            color: "#aaa",
            width: 1,
            type: "solid"
        },
        shadowStyle: {
            color: "rgba(150,150,150,0.3)"
        },
        label: {
            show: true,
            formatter: null,
            // string | Function
            precision: "auto",
            // Or a number like 0, 1, 2 ...
            margin: 3,
            color: "#fff",
            padding: [
                5,
                7,
                5,
                7
            ],
            backgroundColor: "auto",
            // default: axis line color
            borderColor: null,
            borderWidth: 0,
            shadowBlur: 3,
            shadowColor: "#aaa" // Considering applicability, common style should
        },
        handle: {
            show: false,
            /* eslint-disable */ icon: "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z",
            // jshint ignore:line
            /* eslint-enable */ size: 45,
            // handle margin is from symbol center to axis, which is stable when circular move.
            margin: 50,
            // color: '#1b8bbd'
            // color: '#2f4554'
            color: "#333",
            shadowBlur: 3,
            shadowColor: "#aaa",
            shadowOffsetX: 0,
            shadowOffsetY: 2,
            // For mobile performance
            throttle: 40
        }
    }
});
var $b70f377d360d99f0$var$_default = $b70f377d360d99f0$var$AxisPointerModel;
$b70f377d360d99f0$exports = $b70f377d360d99f0$var$_default;


var $1ec1f1e8448dfb20$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $5e44907374287613$export$6503ec6e8aabbaf;
var $5e44907374287613$export$d07f55d4c15c0440;



var $5e44907374287613$var$makeInner = $d559f43cb9041423$export$64df9f8d92ae083f;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $5e44907374287613$var$inner = $5e44907374287613$var$makeInner();
var $5e44907374287613$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
/**
 * @param {string} key
 * @param {module:echarts/ExtensionAPI} api
 * @param {Function} handler
 *      param: {string} currTrigger
 *      param: {Array.<number>} point
 */ function $5e44907374287613$var$register(key, api, handler) {
    if ($27ac1413ecc67076$exports.node) return;
    var zr = api.getZr();
    $5e44907374287613$var$inner(zr).records || ($5e44907374287613$var$inner(zr).records = {});
    $5e44907374287613$var$initGlobalListeners(zr, api);
    var record = $5e44907374287613$var$inner(zr).records[key] || ($5e44907374287613$var$inner(zr).records[key] = {});
    record.handler = handler;
}
function $5e44907374287613$var$initGlobalListeners(zr, api) {
    if ($5e44907374287613$var$inner(zr).initialized) return;
    $5e44907374287613$var$inner(zr).initialized = true;
    useHandler("click", $ec279652dd95c27b$export$c3095a23b368d1f2($5e44907374287613$var$doEnter, "click"));
    useHandler("mousemove", $ec279652dd95c27b$export$c3095a23b368d1f2($5e44907374287613$var$doEnter, "mousemove")); // useHandler('mouseout', onLeave);
    useHandler("globalout", $5e44907374287613$var$onLeave);
    function useHandler(eventType, cb) {
        zr.on(eventType, function(e) {
            var dis = $5e44907374287613$var$makeDispatchAction(api);
            $5e44907374287613$var$each($5e44907374287613$var$inner(zr).records, function(record) {
                record && cb(record, e, dis.dispatchAction);
            });
            $5e44907374287613$var$dispatchTooltipFinally(dis.pendings, api);
        });
    }
}
function $5e44907374287613$var$dispatchTooltipFinally(pendings, api) {
    var showLen = pendings.showTip.length;
    var hideLen = pendings.hideTip.length;
    var actuallyPayload;
    if (showLen) actuallyPayload = pendings.showTip[showLen - 1];
    else if (hideLen) actuallyPayload = pendings.hideTip[hideLen - 1];
    if (actuallyPayload) {
        actuallyPayload.dispatchAction = null;
        api.dispatchAction(actuallyPayload);
    }
}
function $5e44907374287613$var$onLeave(record, e, dispatchAction) {
    record.handler("leave", null, dispatchAction);
}
function $5e44907374287613$var$doEnter(currTrigger, record, e, dispatchAction) {
    record.handler(currTrigger, e, dispatchAction);
}
function $5e44907374287613$var$makeDispatchAction(api) {
    var pendings = {
        showTip: [],
        hideTip: []
    }; // FIXME
    // better approach?
    // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
    // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
    // So we have to add "final stage" to merge those dispatched actions.
    var dispatchAction = function(payload) {
        var pendingList = pendings[payload.type];
        if (pendingList) pendingList.push(payload);
        else {
            payload.dispatchAction = dispatchAction;
            api.dispatchAction(payload);
        }
    };
    return {
        dispatchAction: dispatchAction,
        pendings: pendings
    };
}
/**
 * @param {string} key
 * @param {module:echarts/ExtensionAPI} api
 */ function $5e44907374287613$var$unregister(key, api) {
    if ($27ac1413ecc67076$exports.node) return;
    var zr = api.getZr();
    var record = ($5e44907374287613$var$inner(zr).records || {})[key];
    if (record) $5e44907374287613$var$inner(zr).records[key] = null;
}
$5e44907374287613$export$6503ec6e8aabbaf = $5e44907374287613$var$register;
$5e44907374287613$export$d07f55d4c15c0440 = $5e44907374287613$var$unregister;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $1ec1f1e8448dfb20$var$AxisPointerView = $f406636b535430a7$exports.extendComponentView({
    type: "axisPointer",
    render: function(globalAxisPointerModel, ecModel, api) {
        var globalTooltipModel = ecModel.getComponent("tooltip");
        var triggerOn = globalAxisPointerModel.get("triggerOn") || globalTooltipModel && globalTooltipModel.get("triggerOn") || "mousemove|click"; // Register global listener in AxisPointerView to enable
        // AxisPointerView to be independent to Tooltip.
        $5e44907374287613$export$6503ec6e8aabbaf("axisPointer", api, function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== "none" && (currTrigger === "leave" || triggerOn.indexOf(currTrigger) >= 0)) dispatchAction({
                type: "updateAxisPointer",
                currTrigger: currTrigger,
                x: e && e.offsetX,
                y: e && e.offsetY
            });
        });
    },
    /**
   * @override
   */ remove: function(ecModel, api) {
        $5e44907374287613$export$d07f55d4c15c0440(api.getZr(), "axisPointer");
        $1ec1f1e8448dfb20$var$AxisPointerView.superApply(this._model, "remove", arguments);
    },
    /**
   * @override
   */ dispose: function(ecModel, api) {
        $5e44907374287613$export$d07f55d4c15c0440("axisPointer", api);
        $1ec1f1e8448dfb20$var$AxisPointerView.superApply(this._model, "dispose", arguments);
    }
});
var $1ec1f1e8448dfb20$var$_default = $1ec1f1e8448dfb20$var$AxisPointerView;
$1ec1f1e8448dfb20$exports = $1ec1f1e8448dfb20$var$_default;


var $1fe792ff13c9db02$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $90232af8e64a7c89$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $90232af8e64a7c89$var$makeInner = $d559f43cb9041423$export$64df9f8d92ae083f;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $90232af8e64a7c89$var$inner = $90232af8e64a7c89$var$makeInner();
var $90232af8e64a7c89$var$clone = $ec279652dd95c27b$export$9cd59f9826255e47;
var $90232af8e64a7c89$var$bind = $ec279652dd95c27b$export$2385a24977818dd0;
/**
 * Base axis pointer class in 2D.
 * Implemenents {module:echarts/component/axis/IAxisPointer}.
 */ function $90232af8e64a7c89$var$BaseAxisPointer() {}
$90232af8e64a7c89$var$BaseAxisPointer.prototype = {
    /**
   * @private
   */ _group: null,
    /**
   * @private
   */ _lastGraphicKey: null,
    /**
   * @private
   */ _handle: null,
    /**
   * @private
   */ _dragging: false,
    /**
   * @private
   */ _lastValue: null,
    /**
   * @private
   */ _lastStatus: null,
    /**
   * @private
   */ _payloadInfo: null,
    /**
   * In px, arbitrary value. Do not set too small,
   * no animation is ok for most cases.
   * @protected
   */ animationThreshold: 15,
    /**
   * @implement
   */ render: function(axisModel, axisPointerModel, api, forceRender) {
        var value = axisPointerModel.get("value");
        var status = axisPointerModel.get("status"); // Bind them to `this`, not in closure, otherwise they will not
        // be replaced when user calling setOption in not merge mode.
        this._axisModel = axisModel;
        this._axisPointerModel = axisPointerModel;
        this._api = api; // Optimize: `render` will be called repeatly during mouse move.
        // So it is power consuming if performing `render` each time,
        // especially on mobile device.
        if (!forceRender && this._lastValue === value && this._lastStatus === status) return;
        this._lastValue = value;
        this._lastStatus = status;
        var group = this._group;
        var handle = this._handle;
        if (!status || status === "hide") {
            // Do not clear here, for animation better.
            group && group.hide();
            handle && handle.hide();
            return;
        }
        group && group.show();
        handle && handle.show(); // Otherwise status is 'show'
        var elOption = {};
        this.makeElOption(elOption, value, axisModel, axisPointerModel, api); // Enable change axis pointer type.
        var graphicKey = elOption.graphicKey;
        if (graphicKey !== this._lastGraphicKey) this.clear(api);
        this._lastGraphicKey = graphicKey;
        var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
        if (!group) {
            group = this._group = new $4b57d6b582d579b7$exports.Group();
            this.createPointerEl(group, elOption, axisModel, axisPointerModel);
            this.createLabelEl(group, elOption, axisModel, axisPointerModel);
            api.getZr().add(group);
        } else {
            var doUpdateProps = $ec279652dd95c27b$export$c3095a23b368d1f2($90232af8e64a7c89$var$updateProps, axisPointerModel, moveAnimation);
            this.updatePointerEl(group, elOption, doUpdateProps, axisPointerModel);
            this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
        }
        $90232af8e64a7c89$var$updateMandatoryProps(group, axisPointerModel, true);
        this._renderHandle(value);
    },
    /**
   * @implement
   */ remove: function(api) {
        this.clear(api);
    },
    /**
   * @implement
   */ dispose: function(api) {
        this.clear(api);
    },
    /**
   * @protected
   */ determineAnimation: function(axisModel, axisPointerModel) {
        var animation = axisPointerModel.get("animation");
        var axis = axisModel.axis;
        var isCategoryAxis = axis.type === "category";
        var useSnap = axisPointerModel.get("snap"); // Value axis without snap always do not snap.
        if (!useSnap && !isCategoryAxis) return false;
        if (animation === "auto" || animation == null) {
            var animationThreshold = this.animationThreshold;
            if (isCategoryAxis && axis.getBandWidth() > animationThreshold) return true;
             // It is important to auto animation when snap used. Consider if there is
            // a dataZoom, animation will be disabled when too many points exist, while
            // it will be enabled for better visual effect when little points exist.
            if (useSnap) {
                var seriesDataCount = $16df2470cde098b3$export$bd39458db76002ab(axisModel).seriesDataCount;
                var axisExtent = axis.getExtent(); // Approximate band width
                return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
            }
            return false;
        }
        return animation === true;
    },
    /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */ makeElOption: function(elOption, value, axisModel, axisPointerModel, api) {},
    /**
   * @protected
   */ createPointerEl: function(group, elOption, axisModel, axisPointerModel) {
        var pointerOption = elOption.pointer;
        if (pointerOption) {
            var pointerEl = $90232af8e64a7c89$var$inner(group).pointerEl = new $4b57d6b582d579b7$exports[pointerOption.type]($90232af8e64a7c89$var$clone(elOption.pointer));
            group.add(pointerEl);
        }
    },
    /**
   * @protected
   */ createLabelEl: function(group, elOption, axisModel, axisPointerModel) {
        if (elOption.label) {
            var labelEl = $90232af8e64a7c89$var$inner(group).labelEl = new $4b57d6b582d579b7$exports.Rect($90232af8e64a7c89$var$clone(elOption.label));
            group.add(labelEl);
            $90232af8e64a7c89$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    },
    /**
   * @protected
   */ updatePointerEl: function(group, elOption, updateProps) {
        var pointerEl = $90232af8e64a7c89$var$inner(group).pointerEl;
        if (pointerEl && elOption.pointer) {
            pointerEl.setStyle(elOption.pointer.style);
            updateProps(pointerEl, {
                shape: elOption.pointer.shape
            });
        }
    },
    /**
   * @protected
   */ updateLabelEl: function(group, elOption, updateProps, axisPointerModel) {
        var labelEl = $90232af8e64a7c89$var$inner(group).labelEl;
        if (labelEl) {
            labelEl.setStyle(elOption.label.style);
            updateProps(labelEl, {
                // Consider text length change in vertical axis, animation should
                // be used on shape, otherwise the effect will be weird.
                shape: elOption.label.shape,
                position: elOption.label.position
            });
            $90232af8e64a7c89$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    },
    /**
   * @private
   */ _renderHandle: function(value) {
        if (this._dragging || !this.updateHandleTransform) return;
        var axisPointerModel = this._axisPointerModel;
        var zr = this._api.getZr();
        var handle = this._handle;
        var handleModel = axisPointerModel.getModel("handle");
        var status = axisPointerModel.get("status");
        if (!handleModel.get("show") || !status || status === "hide") {
            handle && zr.remove(handle);
            this._handle = null;
            return;
        }
        var isInit;
        if (!this._handle) {
            isInit = true;
            handle = this._handle = $4b57d6b582d579b7$exports.createIcon(handleModel.get("icon"), {
                cursor: "move",
                draggable: true,
                onmousemove: function(e) {
                    // Fot mobile devicem, prevent screen slider on the button.
                    $adca58e5ac25631a$export$fa6813432f753b0d(e.event);
                },
                onmousedown: $90232af8e64a7c89$var$bind(this._onHandleDragMove, this, 0, 0),
                drift: $90232af8e64a7c89$var$bind(this._onHandleDragMove, this),
                ondragend: $90232af8e64a7c89$var$bind(this._onHandleDragEnd, this)
            });
            zr.add(handle);
        }
        $90232af8e64a7c89$var$updateMandatoryProps(handle, axisPointerModel, false); // update style
        var includeStyles = [
            "color",
            "borderColor",
            "borderWidth",
            "opacity",
            "shadowColor",
            "shadowBlur",
            "shadowOffsetX",
            "shadowOffsetY"
        ];
        handle.setStyle(handleModel.getItemStyle(null, includeStyles)); // update position
        var handleSize = handleModel.get("size");
        if (!$ec279652dd95c27b$export$43bee75e5e14138e(handleSize)) handleSize = [
            handleSize,
            handleSize
        ];
        handle.attr("scale", [
            handleSize[0] / 2,
            handleSize[1] / 2
        ]);
        $a181ac84b0d97d16$export$958e3e1a02eac4b6(this, "_doDispatchAxisPointer", handleModel.get("throttle") || 0, "fixRate");
        this._moveHandleToValue(value, isInit);
    },
    /**
   * @private
   */ _moveHandleToValue: function(value, isInit) {
        $90232af8e64a7c89$var$updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, $90232af8e64a7c89$var$getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
    },
    /**
   * @private
   */ _onHandleDragMove: function(dx, dy) {
        var handle = this._handle;
        if (!handle) return;
        this._dragging = true; // Persistent for throttle.
        var trans = this.updateHandleTransform($90232af8e64a7c89$var$getHandleTransProps(handle), [
            dx,
            dy
        ], this._axisModel, this._axisPointerModel);
        this._payloadInfo = trans;
        handle.stopAnimation();
        handle.attr($90232af8e64a7c89$var$getHandleTransProps(trans));
        $90232af8e64a7c89$var$inner(handle).lastProp = null;
        this._doDispatchAxisPointer();
    },
    /**
   * Throttled method.
   * @private
   */ _doDispatchAxisPointer: function() {
        var handle = this._handle;
        if (!handle) return;
        var payloadInfo = this._payloadInfo;
        var axisModel = this._axisModel;
        this._api.dispatchAction({
            type: "updateAxisPointer",
            x: payloadInfo.cursorPoint[0],
            y: payloadInfo.cursorPoint[1],
            tooltipOption: payloadInfo.tooltipOption,
            axesInfo: [
                {
                    axisDim: axisModel.axis.dim,
                    axisIndex: axisModel.componentIndex
                }
            ]
        });
    },
    /**
   * @private
   */ _onHandleDragEnd: function(moveAnimation) {
        this._dragging = false;
        var handle = this._handle;
        if (!handle) return;
        var value = this._axisPointerModel.get("value"); // Consider snap or categroy axis, handle may be not consistent with
        // axisPointer. So move handle to align the exact value position when
        // drag ended.
        this._moveHandleToValue(value); // For the effect: tooltip will be shown when finger holding on handle
        // button, and will be hidden after finger left handle button.
        this._api.dispatchAction({
            type: "hideTip"
        });
    },
    /**
   * Should be implemenented by sub-class if support `handle`.
   * @protected
   * @param {number} value
   * @param {module:echarts/model/Model} axisModel
   * @param {module:echarts/model/Model} axisPointerModel
   * @return {Object} {position: [x, y], rotation: 0}
   */ getHandleTransform: null,
    /**
   * * Should be implemenented by sub-class if support `handle`.
   * @protected
   * @param {Object} transform {position, rotation}
   * @param {Array.<number>} delta [dx, dy]
   * @param {module:echarts/model/Model} axisModel
   * @param {module:echarts/model/Model} axisPointerModel
   * @return {Object} {position: [x, y], rotation: 0, cursorPoint: [x, y]}
   */ updateHandleTransform: null,
    /**
   * @private
   */ clear: function(api) {
        this._lastValue = null;
        this._lastStatus = null;
        var zr = api.getZr();
        var group = this._group;
        var handle = this._handle;
        if (zr && group) {
            this._lastGraphicKey = null;
            group && zr.remove(group);
            handle && zr.remove(handle);
            this._group = null;
            this._handle = null;
            this._payloadInfo = null;
        }
    },
    /**
   * @protected
   */ doClear: function() {},
    /**
   * @protected
   * @param {Array.<number>} xy
   * @param {Array.<number>} wh
   * @param {number} [xDimIndex=0] or 1
   */ buildLabel: function(xy, wh, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x: xy[xDimIndex],
            y: xy[1 - xDimIndex],
            width: wh[xDimIndex],
            height: wh[1 - xDimIndex]
        };
    }
};
$90232af8e64a7c89$var$BaseAxisPointer.prototype.constructor = $90232af8e64a7c89$var$BaseAxisPointer;
function $90232af8e64a7c89$var$updateProps(animationModel, moveAnimation, el, props) {
    // Animation optimize.
    if (!$90232af8e64a7c89$var$propsEqual($90232af8e64a7c89$var$inner(el).lastProp, props)) {
        $90232af8e64a7c89$var$inner(el).lastProp = props;
        moveAnimation ? $4b57d6b582d579b7$exports.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
    }
}
function $90232af8e64a7c89$var$propsEqual(lastProps, newProps) {
    if ($ec279652dd95c27b$export$a6cdc56e425d0d0a(lastProps) && $ec279652dd95c27b$export$a6cdc56e425d0d0a(newProps)) {
        var equals = true;
        $ec279652dd95c27b$export$79b2f7037acddd43(newProps, function(item, key) {
            equals = equals && $90232af8e64a7c89$var$propsEqual(lastProps[key], item);
        });
        return !!equals;
    } else return lastProps === newProps;
}
function $90232af8e64a7c89$var$updateLabelShowHide(labelEl, axisPointerModel) {
    labelEl[axisPointerModel.get("label.show") ? "show" : "hide"]();
}
function $90232af8e64a7c89$var$getHandleTransProps(trans) {
    return {
        position: trans.position.slice(),
        rotation: trans.rotation || 0
    };
}
function $90232af8e64a7c89$var$updateMandatoryProps(group, axisPointerModel, silent) {
    var z = axisPointerModel.get("z");
    var zlevel = axisPointerModel.get("zlevel");
    group && group.traverse(function(el) {
        if (el.type !== "group") {
            z != null && (el.z = z);
            zlevel != null && (el.zlevel = zlevel);
            el.silent = silent;
        }
    });
}
$c125ba1250423743$export$cd4c3a4dca301c70($90232af8e64a7c89$var$BaseAxisPointer);
var $90232af8e64a7c89$var$_default = $90232af8e64a7c89$var$BaseAxisPointer;
$90232af8e64a7c89$exports = $90232af8e64a7c89$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $9a2d7ccde43eb492$export$b7fe459c7cc50060;
var $9a2d7ccde43eb492$export$8206a9937c45910f;
var $9a2d7ccde43eb492$export$7cffee0f9aed39d0;
var $9a2d7ccde43eb492$export$4bb66440324c3a3d;
var $9a2d7ccde43eb492$export$fd3eb3812211a173;
var $9a2d7ccde43eb492$export$885fa0ad5a826207;
var $9a2d7ccde43eb492$export$a8b35248bcc02756;
var $9a2d7ccde43eb492$export$b0cf82e7ebc0d7d0;







/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @param {module:echarts/model/Model} axisPointerModel
 */ function $9a2d7ccde43eb492$var$buildElStyle(axisPointerModel) {
    var axisPointerType = axisPointerModel.get("type");
    var styleModel = axisPointerModel.getModel(axisPointerType + "Style");
    var style;
    if (axisPointerType === "line") {
        style = styleModel.getLineStyle();
        style.fill = null;
    } else if (axisPointerType === "shadow") {
        style = styleModel.getAreaStyle();
        style.stroke = null;
    }
    return style;
}
/**
 * @param {Function} labelPos {align, verticalAlign, position}
 */ function $9a2d7ccde43eb492$var$buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos) {
    var value = axisPointerModel.get("value");
    var text = $9a2d7ccde43eb492$var$getValueLabel(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get("seriesDataIndices"), {
        precision: axisPointerModel.get("label.precision"),
        formatter: axisPointerModel.get("label.formatter")
    });
    var labelModel = axisPointerModel.getModel("label");
    var paddings = $a4be9366aeb9fcc8$export$f3a38102c49f4268(labelModel.get("padding") || 0);
    var font = labelModel.getFont();
    var textRect = $ebae9c4ebc22906c$export$c381147bfed79d9f(text, font);
    var position = labelPos.position;
    var width = textRect.width + paddings[1] + paddings[3];
    var height = textRect.height + paddings[0] + paddings[2]; // Adjust by align.
    var align = labelPos.align;
    align === "right" && (position[0] -= width);
    align === "center" && (position[0] -= width / 2);
    var verticalAlign = labelPos.verticalAlign;
    verticalAlign === "bottom" && (position[1] -= height);
    verticalAlign === "middle" && (position[1] -= height / 2); // Not overflow ec container
    $9a2d7ccde43eb492$var$confineInContainer(position, width, height, api);
    var bgColor = labelModel.get("backgroundColor");
    if (!bgColor || bgColor === "auto") bgColor = axisModel.get("axisLine.lineStyle.color");
    elOption.label = {
        shape: {
            x: 0,
            y: 0,
            width: width,
            height: height,
            r: labelModel.get("borderRadius")
        },
        position: position.slice(),
        // TODO: rich
        style: {
            text: text,
            textFont: font,
            textFill: labelModel.getTextColor(),
            textPosition: "inside",
            textPadding: paddings,
            fill: bgColor,
            stroke: labelModel.get("borderColor") || "transparent",
            lineWidth: labelModel.get("borderWidth") || 0,
            shadowBlur: labelModel.get("shadowBlur"),
            shadowColor: labelModel.get("shadowColor"),
            shadowOffsetX: labelModel.get("shadowOffsetX"),
            shadowOffsetY: labelModel.get("shadowOffsetY")
        },
        // Lable should be over axisPointer.
        z2: 10
    };
} // Do not overflow ec container
function $9a2d7ccde43eb492$var$confineInContainer(position, width, height, api) {
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    position[0] = Math.min(position[0] + width, viewWidth) - width;
    position[1] = Math.min(position[1] + height, viewHeight) - height;
    position[0] = Math.max(position[0], 0);
    position[1] = Math.max(position[1], 0);
}
/**
 * @param {number} value
 * @param {module:echarts/coord/Axis} axis
 * @param {module:echarts/model/Global} ecModel
 * @param {Object} opt
 * @param {Array.<Object>} seriesDataIndices
 * @param {number|string} opt.precision 'auto' or a number
 * @param {string|Function} opt.formatter label formatter
 */ function $9a2d7ccde43eb492$var$getValueLabel(value, axis, ecModel, seriesDataIndices, opt) {
    value = axis.scale.parse(value);
    var text = axis.scale.getLabel(// helps to debounce when when moving label.
    value, {
        precision: opt.precision
    });
    var formatter = opt.formatter;
    if (formatter) {
        var params = {
            value: $13542623aa20eeae$export$a5a32f324c1fa457(axis, value),
            axisDimension: axis.dim,
            axisIndex: axis.index,
            seriesData: []
        };
        $ec279652dd95c27b$export$79b2f7037acddd43(seriesDataIndices, function(idxItem) {
            var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
            var dataIndex = idxItem.dataIndexInside;
            var dataParams = series && series.getDataParams(dataIndex);
            dataParams && params.seriesData.push(dataParams);
        });
        if ($ec279652dd95c27b$export$844ec244b1367d54(formatter)) text = formatter.replace("{value}", text);
        else if ($ec279652dd95c27b$export$f6e2535fb5126e54(formatter)) text = formatter(params);
    }
    return text;
}
/**
 * @param {module:echarts/coord/Axis} axis
 * @param {number} value
 * @param {Object} layoutInfo {
 *  rotation, position, labelOffset, labelDirection, labelMargin
 * }
 */ function $9a2d7ccde43eb492$var$getTransformedPosition(axis, value, layoutInfo) {
    var transform = $6c6dd9610ba660f0$export$185802fd694ee1f5();
    $6c6dd9610ba660f0$export$bb628a54ab399bc9(transform, transform, layoutInfo.rotation);
    $6c6dd9610ba660f0$export$d73ee8ef04f5226a(transform, transform, layoutInfo.position);
    return $4b57d6b582d579b7$export$9f9dcb98c894b623([
        axis.dataToCoord(value),
        (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)
    ], transform);
}
function $9a2d7ccde43eb492$var$buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
    var textLayout = $3ce77a4133d2c8eb$exports.innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
    layoutInfo.labelMargin = axisPointerModel.get("label.margin");
    $9a2d7ccde43eb492$var$buildLabelElOption(elOption, axisModel, axisPointerModel, api, {
        position: $9a2d7ccde43eb492$var$getTransformedPosition(axisModel.axis, value, layoutInfo),
        align: textLayout.textAlign,
        verticalAlign: textLayout.textVerticalAlign
    });
}
/**
 * @param {Array.<number>} p1
 * @param {Array.<number>} p2
 * @param {number} [xDimIndex=0] or 1
 */ function $9a2d7ccde43eb492$var$makeLineShape(p1, p2, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x1: p1[xDimIndex],
        y1: p1[1 - xDimIndex],
        x2: p2[xDimIndex],
        y2: p2[1 - xDimIndex]
    };
}
/**
 * @param {Array.<number>} xy
 * @param {Array.<number>} wh
 * @param {number} [xDimIndex=0] or 1
 */ function $9a2d7ccde43eb492$var$makeRectShape(xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x: xy[xDimIndex],
        y: xy[1 - xDimIndex],
        width: wh[xDimIndex],
        height: wh[1 - xDimIndex]
    };
}
function $9a2d7ccde43eb492$var$makeSectorShape(cx, cy, r0, r, startAngle, endAngle) {
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r,
        startAngle: startAngle,
        endAngle: endAngle,
        clockwise: true
    };
}
$9a2d7ccde43eb492$export$b7fe459c7cc50060 = $9a2d7ccde43eb492$var$buildElStyle;
$9a2d7ccde43eb492$export$8206a9937c45910f = $9a2d7ccde43eb492$var$buildLabelElOption;
$9a2d7ccde43eb492$export$7cffee0f9aed39d0 = $9a2d7ccde43eb492$var$getValueLabel;
$9a2d7ccde43eb492$export$4bb66440324c3a3d = $9a2d7ccde43eb492$var$getTransformedPosition;
$9a2d7ccde43eb492$export$fd3eb3812211a173 = $9a2d7ccde43eb492$var$buildCartesianSingleLabelElOption;
$9a2d7ccde43eb492$export$885fa0ad5a826207 = $9a2d7ccde43eb492$var$makeLineShape;
$9a2d7ccde43eb492$export$a8b35248bcc02756 = $9a2d7ccde43eb492$var$makeRectShape;
$9a2d7ccde43eb492$export$b0cf82e7ebc0d7d0 = $9a2d7ccde43eb492$var$makeSectorShape;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $1fe792ff13c9db02$var$CartesianAxisPointer = $90232af8e64a7c89$exports.extend({
    /**
   * @override
   */ makeElOption: function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisPointerType = axisPointerModel.get("type");
        var otherExtent = $1fe792ff13c9db02$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
        if (axisPointerType && axisPointerType !== "none") {
            var elStyle = $9a2d7ccde43eb492$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $1fe792ff13c9db02$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $6f26210b03436c56$export$b3219800bda33a1f(grid.model, axisModel);
        $9a2d7ccde43eb492$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    },
    /**
   * @override
   */ getHandleTransform: function(value, axisModel, axisPointerModel) {
        var layoutInfo = $6f26210b03436c56$export$b3219800bda33a1f(axisModel.axis.grid.model, axisModel, {
            labelInside: false
        });
        layoutInfo.labelMargin = axisPointerModel.get("handle.margin");
        return {
            position: $9a2d7ccde43eb492$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo),
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    },
    /**
   * @override
   */ updateHandleTransform: function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisExtent = axis.getGlobalExtent(true);
        var otherExtent = $1fe792ff13c9db02$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var dimIndex = axis.dim === "x" ? 0 : 1;
        var currPosition = transform.position;
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex]; // Make tooltip do not overlap axisPointer and in the middle of the grid.
        var tooltipOptions = [
            {
                verticalAlign: "middle"
            },
            {
                align: "center"
            }
        ];
        return {
            position: currPosition,
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: tooltipOptions[dimIndex]
        };
    }
});
function $1fe792ff13c9db02$var$getCartesian(grid, axis) {
    var opt = {};
    opt[axis.dim + "AxisIndex"] = axis.index;
    return grid.getCartesian(opt);
}
var $1fe792ff13c9db02$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, otherExtent) {
        var targetShape = $9a2d7ccde43eb492$export$885fa0ad5a826207([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $1fe792ff13c9db02$var$getAxisDimIndex(axis));
        return {
            type: "Line",
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, otherExtent) {
        var bandWidth = Math.max(1, axis.getBandWidth());
        var span = otherExtent[1] - otherExtent[0];
        return {
            type: "Rect",
            shape: $9a2d7ccde43eb492$export$a8b35248bcc02756([
                pixelValue - bandWidth / 2,
                otherExtent[0]
            ], [
                bandWidth,
                span
            ], $1fe792ff13c9db02$var$getAxisDimIndex(axis))
        };
    }
};
function $1fe792ff13c9db02$var$getAxisDimIndex(axis) {
    return axis.dim === "x" ? 0 : 1;
}
$0880bad8284a1b39$exports.registerAxisPointerClass("CartesianAxisPointer", $1fe792ff13c9db02$var$CartesianAxisPointer);
var $1fe792ff13c9db02$var$_default = $1fe792ff13c9db02$var$CartesianAxisPointer;
$1fe792ff13c9db02$exports = $1fe792ff13c9db02$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // CartesianAxisPointer is not supposed to be required here. But consider
// echarts.simple.js and online build tooltip, which only require gridSimple,
// CartesianAxisPointer should be able to required somewhere.
$f406636b535430a7$exports.registerPreprocessor(function(option) {
    // Always has a global axisPointerModel for default setting.
    if (option) {
        (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
        var link = option.axisPointer.link; // Normalize to array to avoid object mergin. But if link
        // is not set, remain null/undefined, otherwise it will
        // override existent link setting.
        if (link && !$ec279652dd95c27b$export$43bee75e5e14138e(link)) option.axisPointer.link = [
            link
        ];
    }
}); // This process should proformed after coordinate systems created
// and series data processed. So put it on statistic processing stage.
$f406636b535430a7$exports.registerProcessor($f406636b535430a7$exports.PRIORITY.PROCESSOR.STATISTIC, function(ecModel, api) {
    // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
    // allAxesInfo should be updated when setOption performed.
    ecModel.getComponent("axisPointer").coordSysAxesInfo = $16df2470cde098b3$export$bb44f104e3c54dae(ecModel, api);
}); // Broadcast to all views.
$f406636b535430a7$exports.registerAction({
    type: "updateAxisPointer",
    event: "updateAxisPointer",
    update: ":updateAxisPointer"
}, $6cb5d26145fab208$exports);


var $6af55903f7e6d9d7$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $6af55903f7e6d9d7$var$XY = [
    "x",
    "y"
];
var $6af55903f7e6d9d7$var$WH = [
    "width",
    "height"
];
var $6af55903f7e6d9d7$var$SingleAxisPointer = $90232af8e64a7c89$exports.extend({
    /**
   * @override
   */ makeElOption: function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var coordSys = axis.coordinateSystem;
        var otherExtent = $6af55903f7e6d9d7$var$getGlobalExtent(coordSys, 1 - $6af55903f7e6d9d7$var$getPointDimIndex(axis));
        var pixelValue = coordSys.dataToPoint(value)[0];
        var axisPointerType = axisPointerModel.get("type");
        if (axisPointerType && axisPointerType !== "none") {
            var elStyle = $9a2d7ccde43eb492$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $6af55903f7e6d9d7$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $faeb8b4722a93173$export$b3219800bda33a1f(axisModel);
        $9a2d7ccde43eb492$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    },
    /**
   * @override
   */ getHandleTransform: function(value, axisModel, axisPointerModel) {
        var layoutInfo = $faeb8b4722a93173$export$b3219800bda33a1f(axisModel, {
            labelInside: false
        });
        layoutInfo.labelMargin = axisPointerModel.get("handle.margin");
        return {
            position: $9a2d7ccde43eb492$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo),
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    },
    /**
   * @override
   */ updateHandleTransform: function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var coordSys = axis.coordinateSystem;
        var dimIndex = $6af55903f7e6d9d7$var$getPointDimIndex(axis);
        var axisExtent = $6af55903f7e6d9d7$var$getGlobalExtent(coordSys, dimIndex);
        var currPosition = transform.position;
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
        var otherExtent = $6af55903f7e6d9d7$var$getGlobalExtent(coordSys, 1 - dimIndex);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex];
        return {
            position: currPosition,
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: {
                verticalAlign: "middle"
            }
        };
    }
});
var $6af55903f7e6d9d7$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, otherExtent) {
        var targetShape = $9a2d7ccde43eb492$export$885fa0ad5a826207([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $6af55903f7e6d9d7$var$getPointDimIndex(axis));
        return {
            type: "Line",
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, otherExtent) {
        var bandWidth = axis.getBandWidth();
        var span = otherExtent[1] - otherExtent[0];
        return {
            type: "Rect",
            shape: $9a2d7ccde43eb492$export$a8b35248bcc02756([
                pixelValue - bandWidth / 2,
                otherExtent[0]
            ], [
                bandWidth,
                span
            ], $6af55903f7e6d9d7$var$getPointDimIndex(axis))
        };
    }
};
function $6af55903f7e6d9d7$var$getPointDimIndex(axis) {
    return axis.isHorizontal() ? 0 : 1;
}
function $6af55903f7e6d9d7$var$getGlobalExtent(coordSys, dimIndex) {
    var rect = coordSys.getRect();
    return [
        rect[$6af55903f7e6d9d7$var$XY[dimIndex]],
        rect[$6af55903f7e6d9d7$var$XY[dimIndex]] + rect[$6af55903f7e6d9d7$var$WH[dimIndex]]
    ];
}
$0880bad8284a1b39$exports.registerAxisPointerClass("SingleAxisPointer", $6af55903f7e6d9d7$var$SingleAxisPointer);
var $6af55903f7e6d9d7$var$_default = $6af55903f7e6d9d7$var$SingleAxisPointer;
$6af55903f7e6d9d7$exports = $6af55903f7e6d9d7$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.extendComponentView({
    type: "single"
});


var $01897f1925538cce$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $01897f1925538cce$var$getDimensionTypeByAxis = $b5496acb5150a0c1$export$af1622903e71278e;



var $01897f1925538cce$var$groupData = $d559f43cb9041423$export$7ab5bda43e13168f;

var $01897f1925538cce$var$encodeHTML = $a4be9366aeb9fcc8$export$f9d6449b9af28dc1;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $01897f1925538cce$var$DATA_NAME_INDEX = 2;
var $01897f1925538cce$var$ThemeRiverSeries = $70847df98016d69d$exports.extend({
    type: "series.themeRiver",
    dependencies: [
        "singleAxis"
    ],
    /**
   * @readOnly
   * @type {module:zrender/core/util#HashMap}
   */ nameMap: null,
    /**
   * @override
   */ init: function(option) {
        // eslint-disable-next-line
        $01897f1925538cce$var$ThemeRiverSeries.superApply(this, "init", arguments); // Put this function here is for the sake of consistency of code style.
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new $6b46bfdbd75036d4$exports($ec279652dd95c27b$export$2385a24977818dd0(this.getData, this), $ec279652dd95c27b$export$2385a24977818dd0(this.getRawData, this));
    },
    /**
   * If there is no value of a certain point in the time for some event,set it value to 0.
   *
   * @param {Array} data  initial data in the option
   * @return {Array}
   */ fixData: function(data) {
        var rawDataLength = data.length;
        /**
     * Make sure every layer data get the same keys.
     * The value index tells which layer has visited.
     * {
     *  2014/01/01: -1
     * }
     */ var timeValueKeys = {}; // grouped data by name
        var groupResult = $01897f1925538cce$var$groupData(data, function(item) {
            if (!timeValueKeys.hasOwnProperty(item[0])) timeValueKeys[item[0]] = -1;
            return item[2];
        });
        var layData = [];
        groupResult.buckets.each(function(items, key) {
            layData.push({
                name: key,
                dataList: items
            });
        });
        var layerNum = layData.length;
        for(var k = 0; k < layerNum; ++k){
            var name = layData[k].name;
            for(var j = 0; j < layData[k].dataList.length; ++j){
                var timeValue = layData[k].dataList[j][0];
                timeValueKeys[timeValue] = k;
            }
            for(var timeValue in timeValueKeys)if (timeValueKeys.hasOwnProperty(timeValue) && timeValueKeys[timeValue] !== k) {
                timeValueKeys[timeValue] = k;
                data[rawDataLength] = [];
                data[rawDataLength][0] = timeValue;
                data[rawDataLength][1] = 0;
                data[rawDataLength][2] = name;
                rawDataLength++;
            }
        }
        return data;
    },
    /**
   * @override
   * @param  {Object} option  the initial option that user gived
   * @param  {module:echarts/model/Model} ecModel  the model object for themeRiver option
   * @return {module:echarts/data/List}
   */ getInitialData: function(option, ecModel) {
        var singleAxisModel = ecModel.queryComponents({
            mainType: "singleAxis",
            index: this.get("singleAxisIndex"),
            id: this.get("singleAxisId")
        })[0];
        var axisType = singleAxisModel.get("type"); // filter the data item with the value of label is undefined
        var filterData = $ec279652dd95c27b$export$3dea766d36a8935f(option.data, function(dataItem) {
            return dataItem[2] !== undefined;
        }); // ??? TODO design a stage to transfer data for themeRiver and lines?
        var data = this.fixData(filterData || []);
        var nameList = [];
        var nameMap = this.nameMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4();
        var count = 0;
        for(var i = 0; i < data.length; ++i){
            nameList.push(data[i][$01897f1925538cce$var$DATA_NAME_INDEX]);
            if (!nameMap.get(data[i][$01897f1925538cce$var$DATA_NAME_INDEX])) {
                nameMap.set(data[i][$01897f1925538cce$var$DATA_NAME_INDEX], count);
                count++;
            }
        }
        var dimensionsInfo = $c766697b1ee08f64$exports(data, {
            coordDimensions: [
                "single"
            ],
            dimensionsDefine: [
                {
                    name: "time",
                    type: $01897f1925538cce$var$getDimensionTypeByAxis(axisType)
                },
                {
                    name: "value",
                    type: "float"
                },
                {
                    name: "name",
                    type: "ordinal"
                }
            ],
            encodeDefine: {
                single: 0,
                value: 1,
                itemName: 2
            }
        });
        var list = new $f643df856475f69e$exports(dimensionsInfo, this);
        list.initData(data);
        return list;
    },
    /**
   * The raw data is divided into multiple layers and each layer
   *     has same name.
   *
   * @return {Array.<Array.<number>>}
   */ getLayerSeries: function() {
        var data = this.getData();
        var lenCount = data.count();
        var indexArr = [];
        for(var i = 0; i < lenCount; ++i)indexArr[i] = i;
        var timeDim = data.mapDimension("single"); // data group by name
        var groupResult = $01897f1925538cce$var$groupData(indexArr, function(index) {
            return data.get("name", index);
        });
        var layerSeries = [];
        groupResult.buckets.each(function(items, key) {
            items.sort(function(index1, index2) {
                return data.get(timeDim, index1) - data.get(timeDim, index2);
            });
            layerSeries.push({
                name: key,
                indices: items
            });
        });
        return layerSeries;
    },
    /**
   * Get data indices for show tooltip content
    * @param {Array.<string>|string} dim  single coordinate dimension
   * @param {number} value axis value
   * @param {module:echarts/coord/single/SingleAxis} baseAxis  single Axis used
   *     the themeRiver.
   * @return {Object} {dataIndices, nestestValue}
   */ getAxisTooltipData: function(dim, value, baseAxis) {
        if (!$ec279652dd95c27b$export$43bee75e5e14138e(dim)) dim = dim ? [
            dim
        ] : [];
        var data = this.getData();
        var layerSeries = this.getLayerSeries();
        var indices = [];
        var layerNum = layerSeries.length;
        var nestestValue;
        for(var i = 0; i < layerNum; ++i){
            var minDist = Number.MAX_VALUE;
            var nearestIdx = -1;
            var pointNum = layerSeries[i].indices.length;
            for(var j = 0; j < pointNum; ++j){
                var theValue = data.get(dim[0], layerSeries[i].indices[j]);
                var dist = Math.abs(theValue - value);
                if (dist <= minDist) {
                    nestestValue = theValue;
                    minDist = dist;
                    nearestIdx = layerSeries[i].indices[j];
                }
            }
            indices.push(nearestIdx);
        }
        return {
            dataIndices: indices,
            nestestValue: nestestValue
        };
    },
    /**
   * @override
   * @param {number} dataIndex  index of data
   */ formatTooltip: function(dataIndex) {
        var data = this.getData();
        var htmlName = data.getName(dataIndex);
        var htmlValue = data.get(data.mapDimension("value"), dataIndex);
        if (isNaN(htmlValue) || htmlValue == null) htmlValue = "-";
        return $01897f1925538cce$var$encodeHTML(htmlName + " : " + htmlValue);
    },
    defaultOption: {
        zlevel: 0,
        z: 2,
        coordinateSystem: "singleAxis",
        // gap in axis's orthogonal orientation
        boundaryGap: [
            "10%",
            "10%"
        ],
        // legendHoverLink: true,
        singleAxisIndex: 0,
        animationEasing: "linear",
        label: {
            margin: 4,
            show: true,
            position: "left",
            color: "#000",
            fontSize: 11
        },
        emphasis: {
            label: {
                show: true
            }
        }
    }
});
var $01897f1925538cce$var$_default = $01897f1925538cce$var$ThemeRiverSeries;
$01897f1925538cce$exports = $01897f1925538cce$var$_default;


var $2b5ff9c2be18c926$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $2b5ff9c2be18c926$var$Polygon = $e116d72876f40a95$export$7d31b617c820d435;


var $2b5ff9c2be18c926$var$bind = $ec279652dd95c27b$export$2385a24977818dd0;
var $2b5ff9c2be18c926$var$extend = $ec279652dd95c27b$export$8b58be045bf06082;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $2b5ff9c2be18c926$var$_default = $f406636b535430a7$exports.extendChartView({
    type: "themeRiver",
    init: function() {
        this._layers = [];
    },
    render: function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var group = this.group;
        var layerSeries = seriesModel.getLayerSeries();
        var layoutInfo = data.getLayout("layoutInfo");
        var rect = layoutInfo.rect;
        var boundaryGap = layoutInfo.boundaryGap;
        group.attr("position", [
            0,
            rect.y + boundaryGap[0]
        ]);
        function keyGetter(item) {
            return item.name;
        }
        var dataDiffer = new $8e5cd4a27af1b00f$exports(this._layersSeries || [], layerSeries, keyGetter, keyGetter);
        var newLayersGroups = {};
        dataDiffer.add($2b5ff9c2be18c926$var$bind(process, this, "add")).update($2b5ff9c2be18c926$var$bind(process, this, "update")).remove($2b5ff9c2be18c926$var$bind(process, this, "remove")).execute();
        function process(status, idx, oldIdx) {
            var oldLayersGroups = this._layers;
            if (status === "remove") {
                group.remove(oldLayersGroups[idx]);
                return;
            }
            var points0 = [];
            var points1 = [];
            var color;
            var indices = layerSeries[idx].indices;
            for(var j = 0; j < indices.length; j++){
                var layout = data.getItemLayout(indices[j]);
                var x = layout.x;
                var y0 = layout.y0;
                var y = layout.y;
                points0.push([
                    x,
                    y0
                ]);
                points1.push([
                    x,
                    y0 + y
                ]);
                color = data.getItemVisual(indices[j], "color");
            }
            var polygon;
            var text;
            var textLayout = data.getItemLayout(indices[0]);
            var itemModel = data.getItemModel(indices[j - 1]);
            var labelModel = itemModel.getModel("label");
            var margin = labelModel.get("margin");
            if (status === "add") {
                var layerGroup = newLayersGroups[idx] = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
                polygon = new $2b5ff9c2be18c926$var$Polygon({
                    shape: {
                        points: points0,
                        stackedOnPoints: points1,
                        smooth: 0.4,
                        stackedOnSmooth: 0.4,
                        smoothConstraint: false
                    },
                    z2: 0
                });
                text = new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
                    style: {
                        x: textLayout.x - margin,
                        y: textLayout.y0 + textLayout.y / 2
                    }
                });
                layerGroup.add(polygon);
                layerGroup.add(text);
                group.add(layerGroup);
                polygon.setClipPath($2b5ff9c2be18c926$var$createGridClipShape(polygon.getBoundingRect(), seriesModel, function() {
                    polygon.removeClipPath();
                }));
            } else {
                var layerGroup = oldLayersGroups[oldIdx];
                polygon = layerGroup.childAt(0);
                text = layerGroup.childAt(1);
                group.add(layerGroup);
                newLayersGroups[idx] = layerGroup;
                $4b57d6b582d579b7$export$c8dce3c08436e91e(polygon, {
                    shape: {
                        points: points0,
                        stackedOnPoints: points1
                    }
                }, seriesModel);
                $4b57d6b582d579b7$export$c8dce3c08436e91e(text, {
                    style: {
                        x: textLayout.x - margin,
                        y: textLayout.y0 + textLayout.y / 2
                    }
                }, seriesModel);
            }
            var hoverItemStyleModel = itemModel.getModel("emphasis.itemStyle");
            var itemStyleModel = itemModel.getModel("itemStyle");
            $4b57d6b582d579b7$export$6605af501964d89a(text.style, labelModel, {
                text: labelModel.get("show") ? seriesModel.getFormattedLabel(indices[j - 1], "normal") || data.getName(indices[j - 1]) : null,
                textVerticalAlign: "middle"
            });
            polygon.setStyle($2b5ff9c2be18c926$var$extend({
                fill: color
            }, itemStyleModel.getItemStyle([
                "color"
            ])));
            $4b57d6b582d579b7$export$28b42df8183f218c(polygon, hoverItemStyleModel.getItemStyle());
        }
        this._layersSeries = layerSeries;
        this._layers = newLayersGroups;
    },
    dispose: function() {}
}); // add animation to the view
function $2b5ff9c2be18c926$var$createGridClipShape(rect, seriesModel, cb) {
    var rectEl = new $4b57d6b582d579b7$export$c79fc6492f3af13d({
        shape: {
            x: rect.x - 10,
            y: rect.y - 10,
            width: 0,
            height: rect.height + 20
        }
    });
    $4b57d6b582d579b7$export$a121566aadcfe021(rectEl, {
        shape: {
            width: rect.width + 20,
            height: rect.height + 20
        }
    }, seriesModel, cb);
    return rectEl;
}
$2b5ff9c2be18c926$exports = $2b5ff9c2be18c926$var$_default;


var $b5f53a0b35e3272f$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $b5f53a0b35e3272f$var$_default(ecModel, api) {
    ecModel.eachSeriesByType("themeRiver", function(seriesModel) {
        var data = seriesModel.getData();
        var single = seriesModel.coordinateSystem;
        var layoutInfo = {}; // use the axis boundingRect for view
        var rect = single.getRect();
        layoutInfo.rect = rect;
        var boundaryGap = seriesModel.get("boundaryGap");
        var axis = single.getAxis();
        layoutInfo.boundaryGap = boundaryGap;
        if (axis.orient === "horizontal") {
            boundaryGap[0] = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(boundaryGap[0], rect.height);
            boundaryGap[1] = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(boundaryGap[1], rect.height);
            var height = rect.height - boundaryGap[0] - boundaryGap[1];
            $b5f53a0b35e3272f$var$themeRiverLayout(data, seriesModel, height);
        } else {
            boundaryGap[0] = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(boundaryGap[0], rect.width);
            boundaryGap[1] = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(boundaryGap[1], rect.width);
            var width = rect.width - boundaryGap[0] - boundaryGap[1];
            $b5f53a0b35e3272f$var$themeRiverLayout(data, seriesModel, width);
        }
        data.setLayout("layoutInfo", layoutInfo);
    });
}
/**
 * The layout information about themeriver
 *
 * @param {module:echarts/data/List} data  data in the series
 * @param {module:echarts/model/Series} seriesModel  the model object of themeRiver series
 * @param {number} height  value used to compute every series height
 */ function $b5f53a0b35e3272f$var$themeRiverLayout(data, seriesModel, height) {
    if (!data.count()) return;
    var coordSys = seriesModel.coordinateSystem; // the data in each layer are organized into a series.
    var layerSeries = seriesModel.getLayerSeries(); // the points in each layer.
    var timeDim = data.mapDimension("single");
    var valueDim = data.mapDimension("value");
    var layerPoints = $ec279652dd95c27b$export$871de8747c9eaa88(layerSeries, function(singleLayer) {
        return $ec279652dd95c27b$export$871de8747c9eaa88(singleLayer.indices, function(idx) {
            var pt = coordSys.dataToPoint(data.get(timeDim, idx));
            pt[1] = data.get(valueDim, idx);
            return pt;
        });
    });
    var base = $b5f53a0b35e3272f$var$computeBaseline(layerPoints);
    var baseLine = base.y0;
    var ky = height / base.max; // set layout information for each item.
    var n = layerSeries.length;
    var m = layerSeries[0].indices.length;
    var baseY0;
    for(var j = 0; j < m; ++j){
        baseY0 = baseLine[j] * ky;
        data.setItemLayout(layerSeries[0].indices[j], {
            layerIndex: 0,
            x: layerPoints[0][j][0],
            y0: baseY0,
            y: layerPoints[0][j][1] * ky
        });
        for(var i = 1; i < n; ++i){
            baseY0 += layerPoints[i - 1][j][1] * ky;
            data.setItemLayout(layerSeries[i].indices[j], {
                layerIndex: i,
                x: layerPoints[i][j][0],
                y0: baseY0,
                y: layerPoints[i][j][1] * ky
            });
        }
    }
}
/**
 * Compute the baseLine of the rawdata
 * Inspired by Lee Byron's paper Stacked Graphs - Geometry & Aesthetics
 *
 * @param  {Array.<Array>} data  the points in each layer
 * @return {Object}
 */ function $b5f53a0b35e3272f$var$computeBaseline(data) {
    var layerNum = data.length;
    var pointNum = data[0].length;
    var sums = [];
    var y0 = [];
    var max = 0;
    var temp;
    var base = {};
    for(var i = 0; i < pointNum; ++i){
        for(var j = 0, temp = 0; j < layerNum; ++j)temp += data[j][i][1];
        if (temp > max) max = temp;
        sums.push(temp);
    }
    for(var k = 0; k < pointNum; ++k)y0[k] = (max - sums[k]) / 2;
    max = 0;
    for(var l = 0; l < pointNum; ++l){
        var sum = sums[l] + y0[l];
        if (sum > max) max = sum;
    }
    base.y0 = y0;
    base.max = max;
    return base;
}
$b5f53a0b35e3272f$exports = $b5f53a0b35e3272f$var$_default;


var $52be635279ac3658$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $52be635279ac3658$var$createHashMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $52be635279ac3658$var$_default(ecModel) {
    ecModel.eachSeriesByType("themeRiver", function(seriesModel) {
        var data = seriesModel.getData();
        var rawData = seriesModel.getRawData();
        var colorList = seriesModel.get("color");
        var idxMap = $52be635279ac3658$var$createHashMap();
        data.each(function(idx) {
            idxMap.set(data.getRawIndex(idx), idx);
        });
        rawData.each(function(rawIndex) {
            var name = rawData.getName(rawIndex);
            var color = colorList[(seriesModel.nameMap.get(name) - 1) % colorList.length];
            rawData.setItemVisual(rawIndex, "color", color);
            var idx = idxMap.get(rawIndex);
            if (idx != null) data.setItemVisual(idx, "color", color);
        });
    });
}
$52be635279ac3658$exports = $52be635279ac3658$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerLayout($b5f53a0b35e3272f$exports);
$f406636b535430a7$exports.registerVisual($52be635279ac3658$exports);
$f406636b535430a7$exports.registerProcessor($334937e6881c9447$exports("themeRiver"));


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $d08a4c589a21453f$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $d08a4c589a21453f$var$wrapTreePathInfo = $9dcc91b21f0b70b6$export$c5baa480d6ceb0a3;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $d08a4c589a21453f$var$_default = $70847df98016d69d$exports.extend({
    type: "series.sunburst",
    /**
   * @type {module:echarts/data/Tree~Node}
   */ _viewRoot: null,
    getInitialData: function(option, ecModel) {
        // Create a virtual root.
        var root = {
            name: option.name,
            children: option.data
        };
        $d08a4c589a21453f$var$completeTreeValue(root);
        var levelModels = $ec279652dd95c27b$export$871de8747c9eaa88(option.levels || [], function(levelDefine) {
            return new $2b51b4bf776ec22e$exports(levelDefine, this, ecModel);
        }, this); // Make sure always a new tree is created when setOption,
        // in TreemapView, we check whether oldTree === newTree
        // to choose mappings approach among old shapes and new shapes.
        var tree = $b7a0421515afdfda$exports.createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod("getItemModel", function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                var levelModel = levelModels[node.depth];
                levelModel && (model.parentModel = levelModel);
                return model;
            });
        }
        return tree.data;
    },
    optionUpdated: function() {
        this.resetViewRoot();
    },
    /*
   * @override
   */ getDataParams: function(dataIndex) {
        var params = $70847df98016d69d$exports.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treePathInfo = $d08a4c589a21453f$var$wrapTreePathInfo(node, this);
        return params;
    },
    defaultOption: {
        zlevel: 0,
        z: 2,
        // 默认全局居中
        center: [
            "50%",
            "50%"
        ],
        radius: [
            0,
            "75%"
        ],
        // 默认顺时针
        clockwise: true,
        startAngle: 90,
        // 最小角度改为0
        minAngle: 0,
        percentPrecision: 2,
        // If still show when all data zero.
        stillShowZeroSum: true,
        // Policy of highlighting pieces when hover on one
        // Valid values: 'none' (for not downplay others), 'descendant',
        // 'ancestor', 'self'
        highlightPolicy: "descendant",
        // 'rootToNode', 'link', or false
        nodeClick: "rootToNode",
        renderLabelForZeroData: false,
        label: {
            // could be: 'radial', 'tangential', or 'none'
            rotate: "radial",
            show: true,
            opacity: 1,
            // 'left' is for inner side of inside, and 'right' is for outter
            // side for inside
            align: "center",
            position: "inside",
            distance: 5,
            silent: true
        },
        itemStyle: {
            borderWidth: 1,
            borderColor: "white",
            borderType: "solid",
            shadowBlur: 0,
            shadowColor: "rgba(0, 0, 0, 0.2)",
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1
        },
        highlight: {
            itemStyle: {
                opacity: 1
            }
        },
        downplay: {
            itemStyle: {
                opacity: 0.5
            },
            label: {
                opacity: 0.6
            }
        },
        // Animation type canbe expansion, scale
        animationType: "expansion",
        animationDuration: 1000,
        animationDurationUpdate: 500,
        animationEasing: "cubicOut",
        data: [],
        levels: [],
        /**
     * Sort order.
     *
     * Valid values: 'desc', 'asc', null, or callback function.
     * 'desc' and 'asc' for descend and ascendant order;
     * null for not sorting;
     * example of callback function:
     * function(nodeA, nodeB) {
     *     return nodeA.getValue() - nodeB.getValue();
     * }
     */ sort: "desc"
    },
    getViewRoot: function() {
        return this._viewRoot;
    },
    /**
   * @param {module:echarts/data/Tree~Node} [viewRoot]
   */ resetViewRoot: function(viewRoot) {
        viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
        var root = this.getRawData().tree.root;
        if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) this._viewRoot = root;
    }
});
/**
 * @param {Object} dataNode
 */ function $d08a4c589a21453f$var$completeTreeValue(dataNode) {
    // Postorder travel tree.
    // If value of none-leaf node is not set,
    // calculate it by suming up the value of all children.
    var sum = 0;
    $ec279652dd95c27b$export$79b2f7037acddd43(dataNode.children, function(child) {
        $d08a4c589a21453f$var$completeTreeValue(child);
        var childValue = child.value;
        $ec279652dd95c27b$export$43bee75e5e14138e(childValue) && (childValue = childValue[0]);
        sum += childValue;
    });
    var thisValue = dataNode.value;
    if ($ec279652dd95c27b$export$43bee75e5e14138e(thisValue)) thisValue = thisValue[0];
    if (thisValue == null || isNaN(thisValue)) thisValue = sum;
     // Value should not less than 0.
    if (thisValue < 0) thisValue = 0;
    $ec279652dd95c27b$export$43bee75e5e14138e(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}
$d08a4c589a21453f$exports = $d08a4c589a21453f$var$_default;


var $7f0dbc2b3f9fa2ce$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $ae813137e8c5f65e$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $ae813137e8c5f65e$var$NodeHighlightPolicy = {
    NONE: "none",
    // not downplay others
    DESCENDANT: "descendant",
    ANCESTOR: "ancestor",
    SELF: "self"
};
var $ae813137e8c5f65e$var$DEFAULT_SECTOR_Z = 2;
var $ae813137e8c5f65e$var$DEFAULT_TEXT_Z = 4;
/**
 * Sunburstce of Sunburst including Sector, Label, LabelLine
 * @constructor
 * @extends {module:zrender/graphic/Group}
 */ function $ae813137e8c5f65e$var$SunburstPiece(node, seriesModel, ecModel) {
    $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4.call(this);
    var sector = new $4b57d6b582d579b7$export$e98c2c7eb2b14f45({
        z2: $ae813137e8c5f65e$var$DEFAULT_SECTOR_Z
    });
    sector.seriesIndex = seriesModel.seriesIndex;
    var text = new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
        z2: $ae813137e8c5f65e$var$DEFAULT_TEXT_Z,
        silent: node.getModel("label").get("silent")
    });
    this.add(sector);
    this.add(text);
    this.updateData(true, node, "normal", seriesModel, ecModel); // Hover to change label and labelLine
    function onEmphasis() {
        text.ignore = text.hoverIgnore;
    }
    function onNormal() {
        text.ignore = text.normalIgnore;
    }
    this.on("emphasis", onEmphasis).on("normal", onNormal).on("mouseover", onEmphasis).on("mouseout", onNormal);
}
var $ae813137e8c5f65e$var$SunburstPieceProto = $ae813137e8c5f65e$var$SunburstPiece.prototype;
$ae813137e8c5f65e$var$SunburstPieceProto.updateData = function(firstCreate, node, state, seriesModel, ecModel) {
    this.node = node;
    node.piece = this;
    seriesModel = seriesModel || this._seriesModel;
    ecModel = ecModel || this._ecModel;
    var sector = this.childAt(0);
    sector.dataIndex = node.dataIndex;
    var itemModel = node.getModel();
    var layout = node.getLayout(); // if (!layout) {
    //     console.log(node.getLayout());
    // }
    var sectorShape = $ec279652dd95c27b$export$8b58be045bf06082({}, layout);
    sectorShape.label = null;
    var visualColor = $ae813137e8c5f65e$var$getNodeColor(node, seriesModel, ecModel);
    $ae813137e8c5f65e$var$fillDefaultColor(node, seriesModel, visualColor);
    var normalStyle = itemModel.getModel("itemStyle").getItemStyle();
    var style;
    if (state === "normal") style = normalStyle;
    else {
        var stateStyle = itemModel.getModel(state + ".itemStyle").getItemStyle();
        style = $ec279652dd95c27b$export$4950aa0f605343fb(stateStyle, normalStyle);
    }
    style = $ec279652dd95c27b$export$ebe90cb607ad99e({
        lineJoin: "bevel",
        fill: style.fill || visualColor
    }, style);
    if (firstCreate) {
        sector.setShape(sectorShape);
        sector.shape.r = layout.r0;
        $4b57d6b582d579b7$export$c8dce3c08436e91e(sector, {
            shape: {
                r: layout.r
            }
        }, seriesModel, node.dataIndex);
        sector.useStyle(style);
    } else if (typeof style.fill === "object" && style.fill.type || typeof sector.style.fill === "object" && sector.style.fill.type) {
        // Disable animation for gradient since no interpolation method
        // is supported for gradient
        $4b57d6b582d579b7$export$c8dce3c08436e91e(sector, {
            shape: sectorShape
        }, seriesModel);
        sector.useStyle(style);
    } else $4b57d6b582d579b7$export$c8dce3c08436e91e(sector, {
        shape: sectorShape,
        style: style
    }, seriesModel);
    this._updateLabel(seriesModel, visualColor, state);
    var cursorStyle = itemModel.getShallow("cursor");
    cursorStyle && sector.attr("cursor", cursorStyle);
    if (firstCreate) {
        var highlightPolicy = seriesModel.getShallow("highlightPolicy");
        this._initEvents(sector, node, seriesModel, highlightPolicy);
    }
    this._seriesModel = seriesModel || this._seriesModel;
    this._ecModel = ecModel || this._ecModel;
    $4b57d6b582d579b7$export$28b42df8183f218c(this);
};
$ae813137e8c5f65e$var$SunburstPieceProto.onEmphasis = function(highlightPolicy) {
    var that = this;
    this.node.hostTree.root.eachNode(function(n) {
        if (n.piece) {
            if (that.node === n) n.piece.updateData(false, n, "emphasis");
            else if ($ae813137e8c5f65e$var$isNodeHighlighted(n, that.node, highlightPolicy)) n.piece.childAt(0).trigger("highlight");
            else if (highlightPolicy !== $ae813137e8c5f65e$var$NodeHighlightPolicy.NONE) n.piece.childAt(0).trigger("downplay");
        }
    });
};
$ae813137e8c5f65e$var$SunburstPieceProto.onNormal = function() {
    this.node.hostTree.root.eachNode(function(n) {
        if (n.piece) n.piece.updateData(false, n, "normal");
    });
};
$ae813137e8c5f65e$var$SunburstPieceProto.onHighlight = function() {
    this.updateData(false, this.node, "highlight");
};
$ae813137e8c5f65e$var$SunburstPieceProto.onDownplay = function() {
    this.updateData(false, this.node, "downplay");
};
$ae813137e8c5f65e$var$SunburstPieceProto._updateLabel = function(seriesModel, visualColor, state) {
    var itemModel = this.node.getModel();
    var normalModel = itemModel.getModel("label");
    var labelModel = state === "normal" || state === "emphasis" ? normalModel : itemModel.getModel(state + ".label");
    var labelHoverModel = itemModel.getModel("emphasis.label");
    var labelFormatter = labelModel.get("formatter"); // Use normal formatter if no state formatter is defined
    var labelState = labelFormatter ? state : "normal";
    var text = $ec279652dd95c27b$export$8a4d17b6e8486e66(seriesModel.getFormattedLabel(this.node.dataIndex, labelState, null, null, "label"), this.node.name);
    if (getLabelAttr("show") === false) text = "";
    var layout = this.node.getLayout();
    var labelMinAngle = labelModel.get("minAngle");
    if (labelMinAngle == null) labelMinAngle = normalModel.get("minAngle");
    labelMinAngle = labelMinAngle / 180 * Math.PI;
    var angle = layout.endAngle - layout.startAngle;
    if (labelMinAngle != null && Math.abs(angle) < labelMinAngle) // Not displaying text when angle is too small
    text = "";
    var label = this.childAt(1);
    $4b57d6b582d579b7$export$9a13992917966657(label.style, label.hoverStyle || {}, normalModel, labelHoverModel, {
        defaultText: labelModel.getShallow("show") ? text : null,
        autoColor: visualColor,
        useInsideStyle: true
    });
    var midAngle = (layout.startAngle + layout.endAngle) / 2;
    var dx = Math.cos(midAngle);
    var dy = Math.sin(midAngle);
    var r;
    var labelPosition = getLabelAttr("position");
    var labelPadding = getLabelAttr("distance") || 0;
    var textAlign = getLabelAttr("align");
    if (labelPosition === "outside") {
        r = layout.r + labelPadding;
        textAlign = midAngle > Math.PI / 2 ? "right" : "left";
    } else {
        if (!textAlign || textAlign === "center") {
            r = (layout.r + layout.r0) / 2;
            textAlign = "center";
        } else if (textAlign === "left") {
            r = layout.r0 + labelPadding;
            if (midAngle > Math.PI / 2) textAlign = "right";
        } else if (textAlign === "right") {
            r = layout.r - labelPadding;
            if (midAngle > Math.PI / 2) textAlign = "left";
        }
    }
    label.attr("style", {
        text: text,
        textAlign: textAlign,
        textVerticalAlign: getLabelAttr("verticalAlign") || "middle",
        opacity: getLabelAttr("opacity")
    });
    var textX = r * dx + layout.cx;
    var textY = r * dy + layout.cy;
    label.attr("position", [
        textX,
        textY
    ]);
    var rotateType = getLabelAttr("rotate");
    var rotate = 0;
    if (rotateType === "radial") {
        rotate = -midAngle;
        if (rotate < -Math.PI / 2) rotate += Math.PI;
    } else if (rotateType === "tangential") {
        rotate = Math.PI / 2 - midAngle;
        if (rotate > Math.PI / 2) rotate -= Math.PI;
        else if (rotate < -Math.PI / 2) rotate += Math.PI;
    } else if (typeof rotateType === "number") rotate = rotateType * Math.PI / 180;
    label.attr("rotation", rotate);
    function getLabelAttr(name) {
        var stateAttr = labelModel.get(name);
        if (stateAttr == null) return normalModel.get(name);
        else return stateAttr;
    }
};
$ae813137e8c5f65e$var$SunburstPieceProto._initEvents = function(sector, node, seriesModel, highlightPolicy) {
    sector.off("mouseover").off("mouseout").off("emphasis").off("normal");
    var that = this;
    var onEmphasis = function() {
        that.onEmphasis(highlightPolicy);
    };
    var onNormal = function() {
        that.onNormal();
    };
    var onDownplay = function() {
        that.onDownplay();
    };
    var onHighlight = function() {
        that.onHighlight();
    };
    if (seriesModel.isAnimationEnabled()) sector.on("mouseover", onEmphasis).on("mouseout", onNormal).on("emphasis", onEmphasis).on("normal", onNormal).on("downplay", onDownplay).on("highlight", onHighlight);
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($ae813137e8c5f65e$var$SunburstPiece, $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4);
var $ae813137e8c5f65e$var$_default = $ae813137e8c5f65e$var$SunburstPiece;
/**
 * Get node color
 *
 * @param {TreeNode} node the node to get color
 * @param {module:echarts/model/Series} seriesModel series
 * @param {module:echarts/model/Global} ecModel echarts defaults
 */ function $ae813137e8c5f65e$var$getNodeColor(node, seriesModel, ecModel) {
    // Color from visualMap
    var visualColor = node.getVisual("color");
    var visualMetaList = node.getVisual("visualMeta");
    if (!visualMetaList || visualMetaList.length === 0) // Use first-generation color if has no visualMap
    visualColor = null;
     // Self color or level color
    var color = node.getModel("itemStyle").get("color");
    if (color) return color;
    else if (visualColor) // Color mapping
    return visualColor;
    else if (node.depth === 0) // Virtual root node
    return ecModel.option.color[0];
    else {
        // First-generation color
        var length = ecModel.option.color.length;
        color = ecModel.option.color[$ae813137e8c5f65e$var$getRootId(node) % length];
    }
    return color;
}
/**
 * Get index of root in sorted order
 *
 * @param {TreeNode} node current node
 * @return {number} index in root
 */ function $ae813137e8c5f65e$var$getRootId(node) {
    var ancestor = node;
    while(ancestor.depth > 1)ancestor = ancestor.parentNode;
    var virtualRoot = node.getAncestors()[0];
    return $ec279652dd95c27b$export$305f7d4e9d4624f2(virtualRoot.children, ancestor);
}
function $ae813137e8c5f65e$var$isNodeHighlighted(node, activeNode, policy) {
    if (policy === $ae813137e8c5f65e$var$NodeHighlightPolicy.NONE) return false;
    else if (policy === $ae813137e8c5f65e$var$NodeHighlightPolicy.SELF) return node === activeNode;
    else if (policy === $ae813137e8c5f65e$var$NodeHighlightPolicy.ANCESTOR) return node === activeNode || node.isAncestorOf(activeNode);
    else return node === activeNode || node.isDescendantOf(activeNode);
} // Fix tooltip callback function params.color incorrect when pick a default color
function $ae813137e8c5f65e$var$fillDefaultColor(node, seriesModel, color) {
    var data = seriesModel.getData();
    data.setItemVisual(node.dataIndex, "color", color);
}
$ae813137e8c5f65e$exports = $ae813137e8c5f65e$var$_default;




var $7f0dbc2b3f9fa2ce$var$windowOpen = $a4be9366aeb9fcc8$export$13e13f9b96dbe8fa;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $7f0dbc2b3f9fa2ce$var$ROOT_TO_NODE_ACTION = "sunburstRootToNode";
var $7f0dbc2b3f9fa2ce$var$SunburstView = $6448f0aa5ca2bdaa$exports.extend({
    type: "sunburst",
    init: function() {},
    render: function(seriesModel, ecModel, api, payload) {
        var that = this;
        this.seriesModel = seriesModel;
        this.api = api;
        this.ecModel = ecModel;
        var data = seriesModel.getData();
        var virtualRoot = data.tree.root;
        var newRoot = seriesModel.getViewRoot();
        var group = this.group;
        var renderLabelForZeroData = seriesModel.get("renderLabelForZeroData");
        var newChildren = [];
        newRoot.eachNode(function(node) {
            newChildren.push(node);
        });
        var oldChildren = this._oldChildren || [];
        dualTravel(newChildren, oldChildren);
        renderRollUp(virtualRoot, newRoot);
        if (payload && payload.highlight && payload.highlight.piece) {
            var highlightPolicy = seriesModel.getShallow("highlightPolicy");
            payload.highlight.piece.onEmphasis(highlightPolicy);
        } else if (payload && payload.unhighlight) {
            var piece = this.virtualPiece;
            if (!piece && virtualRoot.children.length) piece = virtualRoot.children[0].piece;
            if (piece) piece.onNormal();
        }
        this._initEvents();
        this._oldChildren = newChildren;
        function dualTravel(newChildren, oldChildren) {
            if (newChildren.length === 0 && oldChildren.length === 0) return;
            new $8e5cd4a27af1b00f$exports(oldChildren, newChildren, getKey, getKey).add(processNode).update(processNode).remove($ec279652dd95c27b$export$c3095a23b368d1f2(processNode, null)).execute();
            function getKey(node) {
                return node.getId();
            }
            function processNode(newId, oldId) {
                var newNode = newId == null ? null : newChildren[newId];
                var oldNode = oldId == null ? null : oldChildren[oldId];
                doRenderNode(newNode, oldNode);
            }
        }
        function doRenderNode(newNode, oldNode) {
            if (!renderLabelForZeroData && newNode && !newNode.getValue()) // Not render data with value 0
            newNode = null;
            if (newNode !== virtualRoot && oldNode !== virtualRoot) {
                if (oldNode && oldNode.piece) {
                    if (newNode) {
                        // Update
                        oldNode.piece.updateData(false, newNode, "normal", seriesModel, ecModel); // For tooltip
                        data.setItemGraphicEl(newNode.dataIndex, oldNode.piece);
                    } else // Remove
                    removeNode(oldNode);
                } else if (newNode) {
                    // Add
                    var piece = new $ae813137e8c5f65e$exports(newNode, seriesModel, ecModel);
                    group.add(piece); // For tooltip
                    data.setItemGraphicEl(newNode.dataIndex, piece);
                }
            }
        }
        function removeNode(node) {
            if (!node) return;
            if (node.piece) {
                group.remove(node.piece);
                node.piece = null;
            }
        }
        function renderRollUp(virtualRoot, viewRoot) {
            if (viewRoot.depth > 0) {
                // Render
                if (that.virtualPiece) // Update
                that.virtualPiece.updateData(false, virtualRoot, "normal", seriesModel, ecModel);
                else {
                    // Add
                    that.virtualPiece = new $ae813137e8c5f65e$exports(virtualRoot, seriesModel, ecModel);
                    group.add(that.virtualPiece);
                }
                if (viewRoot.piece._onclickEvent) viewRoot.piece.off("click", viewRoot.piece._onclickEvent);
                var event = function(e) {
                    that._rootToNode(viewRoot.parentNode);
                };
                viewRoot.piece._onclickEvent = event;
                that.virtualPiece.on("click", event);
            } else if (that.virtualPiece) {
                // Remove
                group.remove(that.virtualPiece);
                that.virtualPiece = null;
            }
        }
    },
    dispose: function() {},
    /**
   * @private
   */ _initEvents: function() {
        var that = this;
        var event = function(e) {
            var targetFound = false;
            var viewRoot = that.seriesModel.getViewRoot();
            viewRoot.eachNode(function(node) {
                if (!targetFound && node.piece && node.piece.childAt(0) === e.target) {
                    var nodeClick = node.getModel().get("nodeClick");
                    if (nodeClick === "rootToNode") that._rootToNode(node);
                    else if (nodeClick === "link") {
                        var itemModel = node.getModel();
                        var link = itemModel.get("link");
                        if (link) {
                            var linkTarget = itemModel.get("target", true) || "_blank";
                            $7f0dbc2b3f9fa2ce$var$windowOpen(link, linkTarget);
                        }
                    }
                    targetFound = true;
                }
            });
        };
        if (this.group._onclickEvent) this.group.off("click", this.group._onclickEvent);
        this.group.on("click", event);
        this.group._onclickEvent = event;
    },
    /**
   * @private
   */ _rootToNode: function(node) {
        if (node !== this.seriesModel.getViewRoot()) this.api.dispatchAction({
            type: $7f0dbc2b3f9fa2ce$var$ROOT_TO_NODE_ACTION,
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: node
        });
    },
    /**
   * @implement
   */ containPoint: function(point, seriesModel) {
        var treeRoot = seriesModel.getData();
        var itemLayout = treeRoot.getItemLayout(0);
        if (itemLayout) {
            var dx = point[0] - itemLayout.cx;
            var dy = point[1] - itemLayout.cy;
            var radius = Math.sqrt(dx * dx + dy * dy);
            return radius <= itemLayout.r && radius >= itemLayout.r0;
        }
    }
});
var $7f0dbc2b3f9fa2ce$var$_default = $7f0dbc2b3f9fa2ce$var$SunburstView;
$7f0dbc2b3f9fa2ce$exports = $7f0dbc2b3f9fa2ce$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @file Sunburst action
 */ var $62eef51a31b69e93$var$ROOT_TO_NODE_ACTION = "sunburstRootToNode";
$f406636b535430a7$exports.registerAction({
    type: $62eef51a31b69e93$var$ROOT_TO_NODE_ACTION,
    update: "updateView"
}, function(payload, ecModel) {
    ecModel.eachComponent({
        mainType: "series",
        subType: "sunburst",
        query: payload
    }, handleRootToNode);
    function handleRootToNode(model, index) {
        var targetInfo = $9dcc91b21f0b70b6$export$c5445fa59c15dec4(payload, [
            $62eef51a31b69e93$var$ROOT_TO_NODE_ACTION
        ], model);
        if (targetInfo) {
            var originViewRoot = model.getViewRoot();
            if (originViewRoot) payload.direction = $9dcc91b21f0b70b6$export$df59de26c77b5bea(originViewRoot, targetInfo.node) ? "rollUp" : "drillDown";
            model.resetViewRoot(targetInfo.node);
        }
    }
});
var $62eef51a31b69e93$var$HIGHLIGHT_ACTION = "sunburstHighlight";
$f406636b535430a7$exports.registerAction({
    type: $62eef51a31b69e93$var$HIGHLIGHT_ACTION,
    update: "updateView"
}, function(payload, ecModel) {
    ecModel.eachComponent({
        mainType: "series",
        subType: "sunburst",
        query: payload
    }, handleHighlight);
    function handleHighlight(model, index) {
        var targetInfo = $9dcc91b21f0b70b6$export$c5445fa59c15dec4(payload, [
            $62eef51a31b69e93$var$HIGHLIGHT_ACTION
        ], model);
        if (targetInfo) payload.highlight = targetInfo.node;
    }
});
var $62eef51a31b69e93$var$UNHIGHLIGHT_ACTION = "sunburstUnhighlight";
$f406636b535430a7$exports.registerAction({
    type: $62eef51a31b69e93$var$UNHIGHLIGHT_ACTION,
    update: "updateView"
}, function(payload, ecModel) {
    ecModel.eachComponent({
        mainType: "series",
        subType: "sunburst",
        query: payload
    }, handleUnhighlight);
    function handleUnhighlight(model, index) {
        payload.unhighlight = true;
    }
});



var $9e52e843c98715cf$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9e52e843c98715cf$var$parsePercent = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // var PI2 = Math.PI * 2;
var $9e52e843c98715cf$var$RADIAN = Math.PI / 180;
function $9e52e843c98715cf$var$_default(seriesType, ecModel, api, payload) {
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        var center = seriesModel.get("center");
        var radius = seriesModel.get("radius");
        if (!$ec279652dd95c27b$export$43bee75e5e14138e(radius)) radius = [
            0,
            radius
        ];
        if (!$ec279652dd95c27b$export$43bee75e5e14138e(center)) center = [
            center,
            center
        ];
        var width = api.getWidth();
        var height = api.getHeight();
        var size = Math.min(width, height);
        var cx = $9e52e843c98715cf$var$parsePercent(center[0], width);
        var cy = $9e52e843c98715cf$var$parsePercent(center[1], height);
        var r0 = $9e52e843c98715cf$var$parsePercent(radius[0], size / 2);
        var r = $9e52e843c98715cf$var$parsePercent(radius[1], size / 2);
        var startAngle = -seriesModel.get("startAngle") * $9e52e843c98715cf$var$RADIAN;
        var minAngle = seriesModel.get("minAngle") * $9e52e843c98715cf$var$RADIAN;
        var virtualRoot = seriesModel.getData().tree.root;
        var treeRoot = seriesModel.getViewRoot();
        var rootDepth = treeRoot.depth;
        var sort = seriesModel.get("sort");
        if (sort != null) $9e52e843c98715cf$var$initChildren(treeRoot, sort);
        var validDataCount = 0;
        $ec279652dd95c27b$export$79b2f7037acddd43(treeRoot.children, function(child) {
            !isNaN(child.getValue()) && validDataCount++;
        });
        var sum = treeRoot.getValue(); // Sum may be 0
        var unitRadian = Math.PI / (sum || validDataCount) * 2;
        var renderRollupNode = treeRoot.depth > 0;
        var levels = treeRoot.height - (renderRollupNode ? -1 : 1);
        var rPerLevel = (r - r0) / (levels || 1);
        var clockwise = seriesModel.get("clockwise");
        var stillShowZeroSum = seriesModel.get("stillShowZeroSum"); // In the case some sector angle is smaller than minAngle
        // var restAngle = PI2;
        // var valueSumLargerThanMinAngle = 0;
        var dir = clockwise ? 1 : -1;
        /**
     * Render a tree
     * @return increased angle
     */ var renderNode = function(node, startAngle) {
            if (!node) return;
            var endAngle = startAngle; // Render self
            if (node !== virtualRoot) {
                // Tree node is virtual, so it doesn't need to be drawn
                var value = node.getValue();
                var angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
                if (angle < minAngle) angle = minAngle; // restAngle -= minAngle;
                 // else {
                //     valueSumLargerThanMinAngle += value;
                // }
                endAngle = startAngle + dir * angle;
                var depth = node.depth - rootDepth - (renderRollupNode ? -1 : 1);
                var rStart = r0 + rPerLevel * depth;
                var rEnd = r0 + rPerLevel * (depth + 1);
                var itemModel = node.getModel();
                if (itemModel.get("r0") != null) rStart = $9e52e843c98715cf$var$parsePercent(itemModel.get("r0"), size / 2);
                if (itemModel.get("r") != null) rEnd = $9e52e843c98715cf$var$parsePercent(itemModel.get("r"), size / 2);
                node.setLayout({
                    angle: angle,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    clockwise: clockwise,
                    cx: cx,
                    cy: cy,
                    r0: rStart,
                    r: rEnd
                });
            } // Render children
            if (node.children && node.children.length) {
                // currentAngle = startAngle;
                var siblingAngle = 0;
                $ec279652dd95c27b$export$79b2f7037acddd43(node.children, function(node) {
                    siblingAngle += renderNode(node, startAngle + siblingAngle);
                });
            }
            return endAngle - startAngle;
        }; // Virtual root node for roll up
        if (renderRollupNode) {
            var rStart = r0;
            var rEnd = r0 + rPerLevel;
            var angle = Math.PI * 2;
            virtualRoot.setLayout({
                angle: angle,
                startAngle: startAngle,
                endAngle: startAngle + angle,
                clockwise: clockwise,
                cx: cx,
                cy: cy,
                r0: rStart,
                r: rEnd
            });
        }
        renderNode(treeRoot, startAngle);
    });
}
/**
 * Init node children by order and update visual
 *
 * @param {TreeNode} node  root node
 * @param {boolean}  isAsc if is in ascendant order
 */ function $9e52e843c98715cf$var$initChildren(node, isAsc) {
    var children = node.children || [];
    node.children = $9e52e843c98715cf$var$sort(children, isAsc); // Init children recursively
    if (children.length) $ec279652dd95c27b$export$79b2f7037acddd43(node.children, function(child) {
        $9e52e843c98715cf$var$initChildren(child, isAsc);
    });
}
/**
 * Sort children nodes
 *
 * @param {TreeNode[]}               children children of node to be sorted
 * @param {string | function | null} sort sort method
 *                                   See SunburstSeries.js for details.
 */ function $9e52e843c98715cf$var$sort(children, sortOrder) {
    if (typeof sortOrder === "function") return children.sort(sortOrder);
    else {
        var isAsc = sortOrder === "asc";
        return children.sort(function(a, b) {
            var diff = (a.getValue() - b.getValue()) * (isAsc ? 1 : -1);
            return diff === 0 ? (a.dataIndex - b.dataIndex) * (isAsc ? -1 : 1) : diff;
        });
    }
}
$9e52e843c98715cf$exports = $9e52e843c98715cf$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerVisual($ec279652dd95c27b$export$c3095a23b368d1f2($a6ff2ebba94839b3$exports, "sunburst"));
$f406636b535430a7$exports.registerLayout($ec279652dd95c27b$export$c3095a23b368d1f2($9e52e843c98715cf$exports, "sunburst"));
$f406636b535430a7$exports.registerProcessor($ec279652dd95c27b$export$c3095a23b368d1f2($334937e6881c9447$exports, "sunburst"));


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $f3cd3fb02a960b00$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;



var $f3cd3fb02a960b00$var$getDefaultLabel = $a03b7f2e2ed9bf1c$export$5ff20667590927ed;


var $f3cd3fb02a960b00$var$getLayoutOnAxis = $249e780a835e3f86$export$658df087977b9e84;





var $f3cd3fb02a960b00$var$createClipPath = $df90403704fddb7c$export$e0fe5081209d01c9;
var $5d6b2803ee740ea8$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $5d6b2803ee740ea8$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    dataItem = dataItem || [
        0,
        0
    ];
    return $ec279652dd95c27b$export$871de8747c9eaa88([
        "x",
        "y"
    ], function(dim, dimIdx) {
        var axis = this.getAxis(dim);
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        return axis.type === "category" ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
    }, this);
}
function $5d6b2803ee740ea8$var$_default(coordSys) {
    var rect = coordSys.grid.getRect();
    return {
        coordSys: {
            // The name exposed to user is always 'cartesian2d' but not 'grid'.
            type: "cartesian2d",
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        api: {
            coord: function(data) {
                // do not provide "out" param
                return coordSys.dataToPoint(data);
            },
            size: $ec279652dd95c27b$export$2385a24977818dd0($5d6b2803ee740ea8$var$dataToCoordSize, coordSys)
        }
    };
}
$5d6b2803ee740ea8$exports = $5d6b2803ee740ea8$var$_default;


var $81b439798bd8341f$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $81b439798bd8341f$var$dataToCoordSize(dataSize, dataItem) {
    dataItem = dataItem || [
        0,
        0
    ];
    return $ec279652dd95c27b$export$871de8747c9eaa88([
        0,
        1
    ], function(dimIdx) {
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        var p1 = [];
        var p2 = [];
        p1[dimIdx] = val - halfSize;
        p2[dimIdx] = val + halfSize;
        p1[1 - dimIdx] = p2[1 - dimIdx] = dataItem[1 - dimIdx];
        return Math.abs(this.dataToPoint(p1)[dimIdx] - this.dataToPoint(p2)[dimIdx]);
    }, this);
}
function $81b439798bd8341f$var$_default(coordSys) {
    var rect = coordSys.getBoundingRect();
    return {
        coordSys: {
            type: "geo",
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
            zoom: coordSys.getZoom()
        },
        api: {
            coord: function(data) {
                // do not provide "out" and noRoam param,
                // Compatible with this usage:
                // echarts.util.map(item.points, api.coord)
                return coordSys.dataToPoint(data);
            },
            size: $ec279652dd95c27b$export$2385a24977818dd0($81b439798bd8341f$var$dataToCoordSize, coordSys)
        }
    };
}
$81b439798bd8341f$exports = $81b439798bd8341f$var$_default;


var $1ce77792aab4fbd3$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $1ce77792aab4fbd3$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    var axis = this.getAxis();
    var val = dataItem instanceof Array ? dataItem[0] : dataItem;
    var halfSize = (dataSize instanceof Array ? dataSize[0] : dataSize) / 2;
    return axis.type === "category" ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
}
function $1ce77792aab4fbd3$var$_default(coordSys) {
    var rect = coordSys.getRect();
    return {
        coordSys: {
            type: "singleAxis",
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        api: {
            coord: function(val) {
                // do not provide "out" param
                return coordSys.dataToPoint(val);
            },
            size: $ec279652dd95c27b$export$2385a24977818dd0($1ce77792aab4fbd3$var$dataToCoordSize, coordSys)
        }
    };
}
$1ce77792aab4fbd3$exports = $1ce77792aab4fbd3$var$_default;


var $b7455afc44bd6312$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $b7455afc44bd6312$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    return $ec279652dd95c27b$export$871de8747c9eaa88([
        "Radius",
        "Angle"
    ], function(dim, dimIdx) {
        var axis = this["get" + dim + "Axis"]();
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        var method = "dataTo" + dim;
        var result = axis.type === "category" ? axis.getBandWidth() : Math.abs(axis[method](val - halfSize) - axis[method](val + halfSize));
        if (dim === "Angle") result = result * Math.PI / 180;
        return result;
    }, this);
}
function $b7455afc44bd6312$var$_default(coordSys) {
    var radiusAxis = coordSys.getRadiusAxis();
    var angleAxis = coordSys.getAngleAxis();
    var radius = radiusAxis.getExtent();
    radius[0] > radius[1] && radius.reverse();
    return {
        coordSys: {
            type: "polar",
            cx: coordSys.cx,
            cy: coordSys.cy,
            r: radius[1],
            r0: radius[0]
        },
        api: {
            coord: $ec279652dd95c27b$export$2385a24977818dd0(function(data) {
                var radius = radiusAxis.dataToRadius(data[0]);
                var angle = angleAxis.dataToAngle(data[1]);
                var coord = coordSys.coordToPoint([
                    radius,
                    angle
                ]);
                coord.push(radius, angle * Math.PI / 180);
                return coord;
            }),
            size: $ec279652dd95c27b$export$2385a24977818dd0($b7455afc44bd6312$var$dataToCoordSize, coordSys)
        }
    };
}
$b7455afc44bd6312$exports = $b7455afc44bd6312$var$_default;


var $e773092738b1d977$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $e773092738b1d977$var$_default(coordSys) {
    var rect = coordSys.getRect();
    var rangeInfo = coordSys.getRangeInfo();
    return {
        coordSys: {
            type: "calendar",
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
            cellWidth: coordSys.getCellWidth(),
            cellHeight: coordSys.getCellHeight(),
            rangeInfo: {
                start: rangeInfo.start,
                end: rangeInfo.end,
                weeks: rangeInfo.weeks,
                dayCount: rangeInfo.allDay
            }
        },
        api: {
            coord: function(data, clamp) {
                return coordSys.dataToPoint(data, clamp);
            }
        }
    };
}
$e773092738b1d977$exports = $e773092738b1d977$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $f3cd3fb02a960b00$var$CACHED_LABEL_STYLE_PROPERTIES = $4b57d6b582d579b7$export$5f1d7d4030ae155b;
var $f3cd3fb02a960b00$var$ITEM_STYLE_NORMAL_PATH = [
    "itemStyle"
];
var $f3cd3fb02a960b00$var$ITEM_STYLE_EMPHASIS_PATH = [
    "emphasis",
    "itemStyle"
];
var $f3cd3fb02a960b00$var$LABEL_NORMAL = [
    "label"
];
var $f3cd3fb02a960b00$var$LABEL_EMPHASIS = [
    "emphasis",
    "label"
]; // Use prefix to avoid index to be the same as el.name,
// which will cause weird udpate animation.
var $f3cd3fb02a960b00$var$GROUP_DIFF_PREFIX = "e\x00\x00";
/**
 * To reduce total package size of each coordinate systems, the modules `prepareCustom`
 * of each coordinate systems are not required by each coordinate systems directly, but
 * required by the module `custom`.
 *
 * prepareInfoForCustomSeries {Function}: optional
 *     @return {Object} {coordSys: {...}, api: {
 *         coord: function (data, clamp) {}, // return point in global.
 *         size: function (dataSize, dataItem) {} // return size of each axis in coordSys.
 *     }}
 */ var $f3cd3fb02a960b00$var$prepareCustoms = {
    cartesian2d: $5d6b2803ee740ea8$exports,
    geo: $81b439798bd8341f$exports,
    singleAxis: $1ce77792aab4fbd3$exports,
    polar: $b7455afc44bd6312$exports,
    calendar: $e773092738b1d977$exports
}; // ------
// Model
// ------
$70847df98016d69d$exports.extend({
    type: "series.custom",
    dependencies: [
        "grid",
        "polar",
        "geo",
        "singleAxis",
        "calendar"
    ],
    defaultOption: {
        coordinateSystem: "cartesian2d",
        // Can be set as 'none'
        zlevel: 0,
        z: 2,
        legendHoverLink: true,
        useTransform: true,
        // Custom series will not clip by default.
        // Some case will use custom series to draw label
        // For example https://echarts.apache.org/examples/en/editor.html?c=custom-gantt-flight
        // Only works on polar and cartesian2d coordinate system.
        clip: false // Cartesian coordinate system
    },
    /**
   * @override
   */ getInitialData: function(option, ecModel) {
        return $10e48b57e44af7c1$exports(this.getSource(), this);
    },
    /**
   * @override
   */ getDataParams: function(dataIndex, dataType, el) {
        var params = $70847df98016d69d$exports.prototype.getDataParams.apply(this, arguments);
        el && (params.info = el.info);
        return params;
    }
}); // -----
// View
// -----
$6448f0aa5ca2bdaa$exports.extend({
    type: "custom",
    /**
   * @private
   * @type {module:echarts/data/List}
   */ _data: null,
    /**
   * @override
   */ render: function(customSeries, ecModel, api, payload) {
        var oldData = this._data;
        var data = customSeries.getData();
        var group = this.group;
        var renderItem = $f3cd3fb02a960b00$var$makeRenderItem(customSeries, data, ecModel, api); // By default, merge mode is applied. In most cases, custom series is
        // used in the scenario that data amount is not large but graphic elements
        // is complicated, where merge mode is probably necessary for optimization.
        // For example, reuse graphic elements and only update the transform when
        // roam or data zoom according to `actionType`.
        data.diff(oldData).add(function(newIdx) {
            $f3cd3fb02a960b00$var$createOrUpdate(null, newIdx, renderItem(newIdx, payload), customSeries, group, data);
        }).update(function(newIdx, oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            $f3cd3fb02a960b00$var$createOrUpdate(el, newIdx, renderItem(newIdx, payload), customSeries, group, data);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && group.remove(el);
        }).execute(); // Do clipping
        var clipPath = customSeries.get("clip", true) ? $f3cd3fb02a960b00$var$createClipPath(customSeries.coordinateSystem, false, customSeries) : null;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
        this._data = data;
    },
    incrementalPrepareRender: function(customSeries, ecModel, api) {
        this.group.removeAll();
        this._data = null;
    },
    incrementalRender: function(params, customSeries, ecModel, api, payload) {
        var data = customSeries.getData();
        var renderItem = $f3cd3fb02a960b00$var$makeRenderItem(customSeries, data, ecModel, api);
        function setIncrementalAndHoverLayer(el) {
            if (!el.isGroup) {
                el.incremental = true;
                el.useHoverLayer = true;
            }
        }
        for(var idx = params.start; idx < params.end; idx++){
            var el = $f3cd3fb02a960b00$var$createOrUpdate(null, idx, renderItem(idx, payload), customSeries, this.group, data);
            el.traverse(setIncrementalAndHoverLayer);
        }
    },
    /**
   * @override
   */ dispose: $ec279652dd95c27b$export$8793edee2d425525,
    /**
   * @override
   */ filterForExposedEvent: function(eventType, query, targetEl, packedEvent) {
        var elementName = query.element;
        if (elementName == null || targetEl.name === elementName) return true;
         // Enable to give a name on a group made by `renderItem`, and listen
        // events that triggerd by its descendents.
        while((targetEl = targetEl.parent) && targetEl !== this.group){
            if (targetEl.name === elementName) return true;
        }
        return false;
    }
});
function $f3cd3fb02a960b00$var$createEl(elOption) {
    var graphicType = elOption.type;
    var el; // Those graphic elements are not shapes. They should not be
    // overwritten by users, so do them first.
    if (graphicType === "path") {
        var shape = elOption.shape; // Using pathRect brings convenience to users sacle svg path.
        var pathRect = shape.width != null && shape.height != null ? {
            x: shape.x || 0,
            y: shape.y || 0,
            width: shape.width,
            height: shape.height
        } : null;
        var pathData = $f3cd3fb02a960b00$var$getPathData(shape); // Path is also used for icon, so layout 'center' by default.
        el = $4b57d6b582d579b7$export$aa9bab72412f5613(pathData, null, pathRect, shape.layout || "center");
        el.__customPathData = pathData;
    } else if (graphicType === "image") {
        el = new $4b57d6b582d579b7$export$3e431a229df88919({});
        el.__customImagePath = elOption.style.image;
    } else if (graphicType === "text") {
        el = new $4b57d6b582d579b7$export$5f1af8db9871e1d6({});
        el.__customText = elOption.style.text;
    } else if (graphicType === "group") el = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
    else if (graphicType === "compoundPath") throw new Error('"compoundPath" is not supported yet.');
    else {
        var Clz = $4b57d6b582d579b7$export$51df4b5565a58189(graphicType);
        el = new Clz();
    }
    el.__customGraphicType = graphicType;
    el.name = elOption.name;
    return el;
}
function $f3cd3fb02a960b00$var$updateEl(el, dataIndex, elOption, animatableModel, data, isInit, isRoot) {
    var transitionProps = {};
    var elOptionStyle = elOption.style || {};
    elOption.shape && (transitionProps.shape = $ec279652dd95c27b$export$9cd59f9826255e47(elOption.shape));
    elOption.position && (transitionProps.position = elOption.position.slice());
    elOption.scale && (transitionProps.scale = elOption.scale.slice());
    elOption.origin && (transitionProps.origin = elOption.origin.slice());
    elOption.rotation && (transitionProps.rotation = elOption.rotation);
    if (el.type === "image" && elOption.style) {
        var targetStyle = transitionProps.style = {};
        $ec279652dd95c27b$export$79b2f7037acddd43([
            "x",
            "y",
            "width",
            "height"
        ], function(prop) {
            $f3cd3fb02a960b00$var$prepareStyleTransition(prop, targetStyle, elOptionStyle, el.style, isInit);
        });
    }
    if (el.type === "text" && elOption.style) {
        var targetStyle = transitionProps.style = {};
        $ec279652dd95c27b$export$79b2f7037acddd43([
            "x",
            "y"
        ], function(prop) {
            $f3cd3fb02a960b00$var$prepareStyleTransition(prop, targetStyle, elOptionStyle, el.style, isInit);
        }); // Compatible with previous: both support
        // textFill and fill, textStroke and stroke in 'text' element.
        !elOptionStyle.hasOwnProperty("textFill") && elOptionStyle.fill && (elOptionStyle.textFill = elOptionStyle.fill);
        !elOptionStyle.hasOwnProperty("textStroke") && elOptionStyle.stroke && (elOptionStyle.textStroke = elOptionStyle.stroke);
    }
    if (el.type !== "group") {
        el.useStyle(elOptionStyle); // Init animation.
        if (isInit) {
            el.style.opacity = 0;
            var targetOpacity = elOptionStyle.opacity;
            targetOpacity == null && (targetOpacity = 1);
            $4b57d6b582d579b7$export$a121566aadcfe021(el, {
                style: {
                    opacity: targetOpacity
                }
            }, animatableModel, dataIndex);
        }
    }
    if (isInit) el.attr(transitionProps);
    else $4b57d6b582d579b7$export$c8dce3c08436e91e(el, transitionProps, animatableModel, dataIndex);
     // Merge by default.
    // z2 must not be null/undefined, otherwise sort error may occur.
    elOption.hasOwnProperty("z2") && el.attr("z2", elOption.z2 || 0);
    elOption.hasOwnProperty("silent") && el.attr("silent", elOption.silent);
    elOption.hasOwnProperty("invisible") && el.attr("invisible", elOption.invisible);
    elOption.hasOwnProperty("ignore") && el.attr("ignore", elOption.ignore); // `elOption.info` enables user to mount some info on
    // elements and use them in event handlers.
    // Update them only when user specified, otherwise, remain.
    elOption.hasOwnProperty("info") && el.attr("info", elOption.info); // If `elOption.styleEmphasis` is `false`, remove hover style. The
    // logic is ensured by `graphicUtil.setElementHoverStyle`.
    var styleEmphasis = elOption.styleEmphasis; // hoverStyle should always be set here, because if the hover style
    // may already be changed, where the inner cache should be reset.
    $4b57d6b582d579b7$export$2397e568fe8d15a0(el, styleEmphasis);
    if (isRoot) $4b57d6b582d579b7$export$9ba15aea1e048d48(el, styleEmphasis !== false);
}
function $f3cd3fb02a960b00$var$prepareStyleTransition(prop, targetStyle, elOptionStyle, oldElStyle, isInit) {
    if (elOptionStyle[prop] != null && !isInit) {
        targetStyle[prop] = elOptionStyle[prop];
        elOptionStyle[prop] = oldElStyle[prop];
    }
}
function $f3cd3fb02a960b00$var$makeRenderItem(customSeries, data, ecModel, api) {
    var renderItem = customSeries.get("renderItem");
    var coordSys = customSeries.coordinateSystem;
    var prepareResult = {};
    if (coordSys) prepareResult = coordSys.prepareCustoms ? coordSys.prepareCustoms() : $f3cd3fb02a960b00$var$prepareCustoms[coordSys.type](coordSys);
    var userAPI = $ec279652dd95c27b$export$ebe90cb607ad99e({
        getWidth: api.getWidth,
        getHeight: api.getHeight,
        getZr: api.getZr,
        getDevicePixelRatio: api.getDevicePixelRatio,
        value: value,
        style: style,
        styleEmphasis: styleEmphasis,
        visual: visual,
        barLayout: barLayout,
        currentSeriesIndices: currentSeriesIndices,
        font: font
    }, prepareResult.api || {});
    var userParams = {
        // The life cycle of context: current round of rendering.
        // The global life cycle is probably not necessary, because
        // user can store global status by themselves.
        context: {},
        seriesId: customSeries.id,
        seriesName: customSeries.name,
        seriesIndex: customSeries.seriesIndex,
        coordSys: prepareResult.coordSys,
        dataInsideLength: data.count(),
        encode: $f3cd3fb02a960b00$var$wrapEncodeDef(customSeries.getData())
    }; // Do not support call `api` asynchronously without dataIndexInside input.
    var currDataIndexInside;
    var currDirty = true;
    var currItemModel;
    var currLabelNormalModel;
    var currLabelEmphasisModel;
    var currVisualColor;
    return function(dataIndexInside, payload) {
        currDataIndexInside = dataIndexInside;
        currDirty = true;
        return renderItem && renderItem($ec279652dd95c27b$export$ebe90cb607ad99e({
            dataIndexInside: dataIndexInside,
            dataIndex: data.getRawIndex(dataIndexInside),
            // Can be used for optimization when zoom or roam.
            actionType: payload ? payload.type : null
        }, userParams), userAPI);
    }; // Do not update cache until api called.
    function updateCache(dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        if (currDirty) {
            currItemModel = data.getItemModel(dataIndexInside);
            currLabelNormalModel = currItemModel.getModel($f3cd3fb02a960b00$var$LABEL_NORMAL);
            currLabelEmphasisModel = currItemModel.getModel($f3cd3fb02a960b00$var$LABEL_EMPHASIS);
            currVisualColor = data.getItemVisual(dataIndexInside, "color");
            currDirty = false;
        }
    }
    /**
   * @public
   * @param {number|string} dim
   * @param {number} [dataIndexInside=currDataIndexInside]
   * @return {number|string} value
   */ function value(dim, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        return data.get(data.getDimension(dim || 0), dataIndexInside);
    }
    /**
   * By default, `visual` is applied to style (to support visualMap).
   * `visual.color` is applied at `fill`. If user want apply visual.color on `stroke`,
   * it can be implemented as:
   * `api.style({stroke: api.visual('color'), fill: null})`;
   * @public
   * @param {Object} [extra]
   * @param {number} [dataIndexInside=currDataIndexInside]
   */ function style(extra, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        updateCache(dataIndexInside);
        var itemStyle = currItemModel.getModel($f3cd3fb02a960b00$var$ITEM_STYLE_NORMAL_PATH).getItemStyle();
        currVisualColor != null && (itemStyle.fill = currVisualColor);
        var opacity = data.getItemVisual(dataIndexInside, "opacity");
        opacity != null && (itemStyle.opacity = opacity);
        var labelModel = extra ? $f3cd3fb02a960b00$var$applyExtraBefore(extra, currLabelNormalModel) : currLabelNormalModel;
        $4b57d6b582d579b7$export$6605af501964d89a(itemStyle, labelModel, null, {
            autoColor: currVisualColor,
            isRectText: true
        });
        itemStyle.text = labelModel.getShallow("show") ? $ec279652dd95c27b$export$995e01f2f5c9d030(customSeries.getFormattedLabel(dataIndexInside, "normal"), $f3cd3fb02a960b00$var$getDefaultLabel(data, dataIndexInside)) : null;
        extra && $f3cd3fb02a960b00$var$applyExtraAfter(itemStyle, extra);
        return itemStyle;
    }
    /**
   * @public
   * @param {Object} [extra]
   * @param {number} [dataIndexInside=currDataIndexInside]
   */ function styleEmphasis(extra, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        updateCache(dataIndexInside);
        var itemStyle = currItemModel.getModel($f3cd3fb02a960b00$var$ITEM_STYLE_EMPHASIS_PATH).getItemStyle();
        var labelModel = extra ? $f3cd3fb02a960b00$var$applyExtraBefore(extra, currLabelEmphasisModel) : currLabelEmphasisModel;
        $4b57d6b582d579b7$export$6605af501964d89a(itemStyle, labelModel, null, {
            isRectText: true
        }, true);
        itemStyle.text = labelModel.getShallow("show") ? $ec279652dd95c27b$export$2e94551289abb95b(customSeries.getFormattedLabel(dataIndexInside, "emphasis"), customSeries.getFormattedLabel(dataIndexInside, "normal"), $f3cd3fb02a960b00$var$getDefaultLabel(data, dataIndexInside)) : null;
        extra && $f3cd3fb02a960b00$var$applyExtraAfter(itemStyle, extra);
        return itemStyle;
    }
    /**
   * @public
   * @param {string} visualType
   * @param {number} [dataIndexInside=currDataIndexInside]
   */ function visual(visualType, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        return data.getItemVisual(dataIndexInside, visualType);
    }
    /**
   * @public
   * @param {number} opt.count Positive interger.
   * @param {number} [opt.barWidth]
   * @param {number} [opt.barMaxWidth]
   * @param {number} [opt.barMinWidth]
   * @param {number} [opt.barGap]
   * @param {number} [opt.barCategoryGap]
   * @return {Object} {width, offset, offsetCenter} is not support, return undefined.
   */ function barLayout(opt) {
        if (coordSys.getBaseAxis) {
            var baseAxis = coordSys.getBaseAxis();
            return $f3cd3fb02a960b00$var$getLayoutOnAxis($ec279652dd95c27b$export$ebe90cb607ad99e({
                axis: baseAxis
            }, opt), api);
        }
    }
    /**
   * @public
   * @return {Array.<number>}
   */ function currentSeriesIndices() {
        return ecModel.getCurrentSeriesIndices();
    }
    /**
   * @public
   * @param {Object} opt
   * @param {string} [opt.fontStyle]
   * @param {number} [opt.fontWeight]
   * @param {number} [opt.fontSize]
   * @param {string} [opt.fontFamily]
   * @return {string} font string
   */ function font(opt) {
        return $4b57d6b582d579b7$export$155316a870a9d61e(opt, ecModel);
    }
}
function $f3cd3fb02a960b00$var$wrapEncodeDef(data) {
    var encodeDef = {};
    $ec279652dd95c27b$export$79b2f7037acddd43(data.dimensions, function(dimName, dataDimIndex) {
        var dimInfo = data.getDimensionInfo(dimName);
        if (!dimInfo.isExtraCoord) {
            var coordDim = dimInfo.coordDim;
            var dataDims = encodeDef[coordDim] = encodeDef[coordDim] || [];
            dataDims[dimInfo.coordDimIndex] = dataDimIndex;
        }
    });
    return encodeDef;
}
function $f3cd3fb02a960b00$var$createOrUpdate(el, dataIndex, elOption, animatableModel, group, data) {
    el = $f3cd3fb02a960b00$var$doCreateOrUpdate(el, dataIndex, elOption, animatableModel, group, data, true);
    el && data.setItemGraphicEl(dataIndex, el);
    return el;
}
function $f3cd3fb02a960b00$var$doCreateOrUpdate(el, dataIndex, elOption, animatableModel, group, data, isRoot) {
    // [Rule]
    // By default, follow merge mode.
    //     (It probably brings benifit for performance in some cases of large data, where
    //     user program can be optimized to that only updated props needed to be re-calculated,
    //     or according to `actionType` some calculation can be skipped.)
    // If `renderItem` returns `null`/`undefined`/`false`, remove the previous el if existing.
    //     (It seems that violate the "merge" principle, but most of users probably intuitively
    //     regard "return;" as "show nothing element whatever", so make a exception to meet the
    //     most cases.)
    var simplyRemove = !elOption; // `null`/`undefined`/`false`
    elOption = elOption || {};
    var elOptionType = elOption.type;
    var elOptionShape = elOption.shape;
    var elOptionStyle = elOption.style;
    if (el && (simplyRemove // || elOption.$merge === false
     || elOptionType != null && elOptionType !== el.__customGraphicType || elOptionType === "path" && $f3cd3fb02a960b00$var$hasOwnPathData(elOptionShape) && $f3cd3fb02a960b00$var$getPathData(elOptionShape) !== el.__customPathData || elOptionType === "image" && $f3cd3fb02a960b00$var$hasOwn(elOptionStyle, "image") && elOptionStyle.image !== el.__customImagePath // FIXME test and remove this restriction?
     || elOptionType === "text" && $f3cd3fb02a960b00$var$hasOwn(elOptionShape, "text") && elOptionStyle.text !== el.__customText)) {
        group.remove(el);
        el = null;
    } // `elOption.type` is undefined when `renderItem` returns nothing.
    if (simplyRemove) return;
    var isInit = !el;
    !el && (el = $f3cd3fb02a960b00$var$createEl(elOption));
    $f3cd3fb02a960b00$var$updateEl(el, dataIndex, elOption, animatableModel, data, isInit, isRoot);
    if (elOptionType === "group") $f3cd3fb02a960b00$var$mergeChildren(el, dataIndex, elOption, animatableModel, data);
     // Always add whatever already added to ensure sequence.
    group.add(el);
    return el;
} // Usage:
// (1) By default, `elOption.$mergeChildren` is `'byIndex'`, which indicates that
//     the existing children will not be removed, and enables the feature that
//     update some of the props of some of the children simply by construct
//     the returned children of `renderItem` like:
//     `var children = group.children = []; children[3] = {opacity: 0.5};`
// (2) If `elOption.$mergeChildren` is `'byName'`, add/update/remove children
//     by child.name. But that might be lower performance.
// (3) If `elOption.$mergeChildren` is `false`, the existing children will be
//     replaced totally.
// (4) If `!elOption.children`, following the "merge" principle, nothing will happen.
//
// For implementation simpleness, do not provide a direct way to remove sinlge
// child (otherwise the total indicies of the children array have to be modified).
// User can remove a single child by set its `ignore` as `true` or replace
// it by another element, where its `$merge` can be set as `true` if necessary.
function $f3cd3fb02a960b00$var$mergeChildren(el, dataIndex, elOption, animatableModel, data) {
    var newChildren = elOption.children;
    var newLen = newChildren ? newChildren.length : 0;
    var mergeChildren = elOption.$mergeChildren; // `diffChildrenByName` has been deprecated.
    var byName = mergeChildren === "byName" || elOption.diffChildrenByName;
    var notMerge = mergeChildren === false; // For better performance on roam update, only enter if necessary.
    if (!newLen && !byName && !notMerge) return;
    if (byName) {
        $f3cd3fb02a960b00$var$diffGroupChildren({
            oldChildren: el.children() || [],
            newChildren: newChildren || [],
            dataIndex: dataIndex,
            animatableModel: animatableModel,
            group: el,
            data: data
        });
        return;
    }
    notMerge && el.removeAll(); // Mapping children of a group simply by index, which
    // might be better performance.
    var index = 0;
    for(; index < newLen; index++)newChildren[index] && $f3cd3fb02a960b00$var$doCreateOrUpdate(el.childAt(index), dataIndex, newChildren[index], animatableModel, el, data);
}
function $f3cd3fb02a960b00$var$diffGroupChildren(context) {
    new $8e5cd4a27af1b00f$exports(context.oldChildren, context.newChildren, $f3cd3fb02a960b00$var$getKey, $f3cd3fb02a960b00$var$getKey, context).add($f3cd3fb02a960b00$var$processAddUpdate).update($f3cd3fb02a960b00$var$processAddUpdate).remove($f3cd3fb02a960b00$var$processRemove).execute();
}
function $f3cd3fb02a960b00$var$getKey(item, idx) {
    var name = item && item.name;
    return name != null ? name : $f3cd3fb02a960b00$var$GROUP_DIFF_PREFIX + idx;
}
function $f3cd3fb02a960b00$var$processAddUpdate(newIndex, oldIndex) {
    var context = this.context;
    var childOption = newIndex != null ? context.newChildren[newIndex] : null;
    var child = oldIndex != null ? context.oldChildren[oldIndex] : null;
    $f3cd3fb02a960b00$var$doCreateOrUpdate(child, context.dataIndex, childOption, context.animatableModel, context.group, context.data);
} // `graphic#applyDefaultTextStyle` will cache
// textFill, textStroke, textStrokeWidth.
// We have to do this trick.
function $f3cd3fb02a960b00$var$applyExtraBefore(extra, model) {
    var dummyModel = new $2b51b4bf776ec22e$exports({}, model);
    $ec279652dd95c27b$export$79b2f7037acddd43($f3cd3fb02a960b00$var$CACHED_LABEL_STYLE_PROPERTIES, function(stylePropName, modelPropName) {
        if (extra.hasOwnProperty(stylePropName)) dummyModel.option[modelPropName] = extra[stylePropName];
    });
    return dummyModel;
}
function $f3cd3fb02a960b00$var$applyExtraAfter(itemStyle, extra) {
    for(var key in extra)if (extra.hasOwnProperty(key) || !$f3cd3fb02a960b00$var$CACHED_LABEL_STYLE_PROPERTIES.hasOwnProperty(key)) itemStyle[key] = extra[key];
}
function $f3cd3fb02a960b00$var$processRemove(oldIndex) {
    var context = this.context;
    var child = context.oldChildren[oldIndex];
    child && context.group.remove(child);
}
function $f3cd3fb02a960b00$var$getPathData(shape) {
    // "d" follows the SVG convention.
    return shape && (shape.pathData || shape.d);
}
function $f3cd3fb02a960b00$var$hasOwnPathData(shape) {
    return shape && (shape.hasOwnProperty("pathData") || shape.hasOwnProperty("d"));
}
function $f3cd3fb02a960b00$var$hasOwn(host, prop) {
    return host && host.hasOwnProperty(prop);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $090080dae14fbf55$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $090080dae14fbf55$var$parsePercent = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f;

var $090080dae14fbf55$var$isDimensionStacked = $1712a5e8fbedbcb3$export$1dedc39359ae35c;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $090080dae14fbf55$var$getSeriesStackId(seriesModel) {
    return seriesModel.get("stack") || "__ec_stack_" + seriesModel.seriesIndex;
}
function $090080dae14fbf55$var$getAxisKey(polar, axis) {
    return axis.dim + polar.model.componentIndex;
}
/**
 * @param {string} seriesType
 * @param {module:echarts/model/Global} ecModel
 * @param {module:echarts/ExtensionAPI} api
 */ function $090080dae14fbf55$var$barLayoutPolar(seriesType, ecModel, api) {
    var lastStackCoords = {};
    var barWidthAndOffset = $090080dae14fbf55$var$calRadialBar($ec279652dd95c27b$export$3dea766d36a8935f(ecModel.getSeriesByType(seriesType), function(seriesModel) {
        return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === "polar";
    }));
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        // Check series coordinate, do layout for polar only
        if (seriesModel.coordinateSystem.type !== "polar") return;
        var data = seriesModel.getData();
        var polar = seriesModel.coordinateSystem;
        var baseAxis = polar.getBaseAxis();
        var axisKey = $090080dae14fbf55$var$getAxisKey(polar, baseAxis);
        var stackId = $090080dae14fbf55$var$getSeriesStackId(seriesModel);
        var columnLayoutInfo = barWidthAndOffset[axisKey][stackId];
        var columnOffset = columnLayoutInfo.offset;
        var columnWidth = columnLayoutInfo.width;
        var valueAxis = polar.getOtherAxis(baseAxis);
        var cx = seriesModel.coordinateSystem.cx;
        var cy = seriesModel.coordinateSystem.cy;
        var barMinHeight = seriesModel.get("barMinHeight") || 0;
        var barMinAngle = seriesModel.get("barMinAngle") || 0;
        lastStackCoords[stackId] = lastStackCoords[stackId] || [];
        var valueDim = data.mapDimension(valueAxis.dim);
        var baseDim = data.mapDimension(baseAxis.dim);
        var stacked = $090080dae14fbf55$var$isDimensionStacked(data, valueDim);
        var clampLayout = baseAxis.dim !== "radius" || !seriesModel.get("roundCap", true);
        var valueAxisStart = valueAxis.dim === "radius" ? valueAxis.dataToRadius(0) : valueAxis.dataToAngle(0);
        for(var idx = 0, len = data.count(); idx < len; idx++){
            var value = data.get(valueDim, idx);
            var baseValue = data.get(baseDim, idx);
            var sign = value >= 0 ? "p" : "n";
            var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
            // stackResultDimension directly.
            // Only ordinal axis can be stacked.
            if (stacked) {
                if (!lastStackCoords[stackId][baseValue]) lastStackCoords[stackId][baseValue] = {
                    p: valueAxisStart,
                    // Positive stack
                    n: valueAxisStart // Negative stack
                };
                 // Should also consider #4243
                baseCoord = lastStackCoords[stackId][baseValue][sign];
            }
            var r0;
            var r;
            var startAngle;
            var endAngle; // radial sector
            if (valueAxis.dim === "radius") {
                var radiusSpan = valueAxis.dataToRadius(value) - valueAxisStart;
                var angle = baseAxis.dataToAngle(baseValue);
                if (Math.abs(radiusSpan) < barMinHeight) radiusSpan = (radiusSpan < 0 ? -1 : 1) * barMinHeight;
                r0 = baseCoord;
                r = baseCoord + radiusSpan;
                startAngle = angle - columnOffset;
                endAngle = startAngle - columnWidth;
                stacked && (lastStackCoords[stackId][baseValue][sign] = r);
            } else {
                var angleSpan = valueAxis.dataToAngle(value, clampLayout) - valueAxisStart;
                var radius = baseAxis.dataToRadius(baseValue);
                if (Math.abs(angleSpan) < barMinAngle) angleSpan = (angleSpan < 0 ? -1 : 1) * barMinAngle;
                r0 = radius + columnOffset;
                r = r0 + columnWidth;
                startAngle = baseCoord;
                endAngle = baseCoord + angleSpan; // if the previous stack is at the end of the ring,
                // add a round to differentiate it from origin
                // var extent = angleAxis.getExtent();
                // var stackCoord = angle;
                // if (stackCoord === extent[0] && value > 0) {
                //     stackCoord = extent[1];
                // }
                // else if (stackCoord === extent[1] && value < 0) {
                //     stackCoord = extent[0];
                // }
                stacked && (lastStackCoords[stackId][baseValue][sign] = endAngle);
            }
            data.setItemLayout(idx, {
                cx: cx,
                cy: cy,
                r0: r0,
                r: r,
                // Consider that positive angle is anti-clockwise,
                // while positive radian of sector is clockwise
                startAngle: -startAngle * Math.PI / 180,
                endAngle: -endAngle * Math.PI / 180
            });
        }
    }, this);
}
/**
 * Calculate bar width and offset for radial bar charts
 */ function $090080dae14fbf55$var$calRadialBar(barSeries, api) {
    // Columns info on each category axis. Key is polar name
    var columnsMap = {};
    $ec279652dd95c27b$export$79b2f7037acddd43(barSeries, function(seriesModel, idx) {
        var data = seriesModel.getData();
        var polar = seriesModel.coordinateSystem;
        var baseAxis = polar.getBaseAxis();
        var axisKey = $090080dae14fbf55$var$getAxisKey(polar, baseAxis);
        var axisExtent = baseAxis.getExtent();
        var bandWidth = baseAxis.type === "category" ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
        var columnsOnAxis = columnsMap[axisKey] || {
            bandWidth: bandWidth,
            remainedWidth: bandWidth,
            autoWidthCount: 0,
            categoryGap: "20%",
            gap: "30%",
            stacks: {}
        };
        var stacks = columnsOnAxis.stacks;
        columnsMap[axisKey] = columnsOnAxis;
        var stackId = $090080dae14fbf55$var$getSeriesStackId(seriesModel);
        if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
        stacks[stackId] = stacks[stackId] || {
            width: 0,
            maxWidth: 0
        };
        var barWidth = $090080dae14fbf55$var$parsePercent(seriesModel.get("barWidth"), bandWidth);
        var barMaxWidth = $090080dae14fbf55$var$parsePercent(seriesModel.get("barMaxWidth"), bandWidth);
        var barGap = seriesModel.get("barGap");
        var barCategoryGap = seriesModel.get("barCategoryGap");
        if (barWidth && !stacks[stackId].width) {
            barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
            stacks[stackId].width = barWidth;
            columnsOnAxis.remainedWidth -= barWidth;
        }
        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
        barGap != null && (columnsOnAxis.gap = barGap);
        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
    });
    var result = {};
    $ec279652dd95c27b$export$79b2f7037acddd43(columnsMap, function(columnsOnAxis, coordSysName) {
        result[coordSysName] = {};
        var stacks = columnsOnAxis.stacks;
        var bandWidth = columnsOnAxis.bandWidth;
        var categoryGap = $090080dae14fbf55$var$parsePercent(columnsOnAxis.categoryGap, bandWidth);
        var barGapPercent = $090080dae14fbf55$var$parsePercent(columnsOnAxis.gap, 1);
        var remainedWidth = columnsOnAxis.remainedWidth;
        var autoWidthCount = columnsOnAxis.autoWidthCount;
        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
        $ec279652dd95c27b$export$79b2f7037acddd43(stacks, function(column, stack) {
            var maxWidth = column.maxWidth;
            if (maxWidth && maxWidth < autoWidth) {
                maxWidth = Math.min(maxWidth, remainedWidth);
                if (column.width) maxWidth = Math.min(maxWidth, column.width);
                remainedWidth -= maxWidth;
                column.width = maxWidth;
                autoWidthCount--;
            }
        }); // Recalculate width again
        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        var widthSum = 0;
        var lastColumn;
        $ec279652dd95c27b$export$79b2f7037acddd43(stacks, function(column, idx) {
            if (!column.width) column.width = autoWidth;
            lastColumn = column;
            widthSum += column.width * (1 + barGapPercent);
        });
        if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
        var offset = -widthSum / 2;
        $ec279652dd95c27b$export$79b2f7037acddd43(stacks, function(column, stackId) {
            result[coordSysName][stackId] = result[coordSysName][stackId] || {
                offset: offset,
                width: column.width
            };
            offset += column.width * (1 + barGapPercent);
        });
    });
    return result;
}
var $090080dae14fbf55$var$_default = $090080dae14fbf55$var$barLayoutPolar;
$090080dae14fbf55$exports = $090080dae14fbf55$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $004e8ff36cb365b3$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;

var $b37852f04e5c514a$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $7086e6b36c60f43a$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $7086e6b36c60f43a$var$RadiusAxis(scale, radiusExtent) {
    $95e1f94acccc578d$exports.call(this, "radius", scale, radiusExtent);
    /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */ this.type = "category";
}
$7086e6b36c60f43a$var$RadiusAxis.prototype = {
    constructor: $7086e6b36c60f43a$var$RadiusAxis,
    /**
   * @override
   */ pointToData: function(point, clamp) {
        return this.polar.pointToData(point, clamp)[this.dim === "radius" ? 0 : 1];
    },
    dataToRadius: $95e1f94acccc578d$exports.prototype.dataToCoord,
    radiusToData: $95e1f94acccc578d$exports.prototype.coordToData
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($7086e6b36c60f43a$var$RadiusAxis, $95e1f94acccc578d$exports);
var $7086e6b36c60f43a$var$_default = $7086e6b36c60f43a$var$RadiusAxis;
$7086e6b36c60f43a$exports = $7086e6b36c60f43a$var$_default;


var $2aa56e64a85dfa82$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $2aa56e64a85dfa82$var$makeInner = $d559f43cb9041423$export$64df9f8d92ae083f;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $2aa56e64a85dfa82$var$inner = $2aa56e64a85dfa82$var$makeInner();
function $2aa56e64a85dfa82$var$AngleAxis(scale, angleExtent) {
    angleExtent = angleExtent || [
        0,
        360
    ];
    $95e1f94acccc578d$exports.call(this, "angle", scale, angleExtent);
    /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */ this.type = "category";
}
$2aa56e64a85dfa82$var$AngleAxis.prototype = {
    constructor: $2aa56e64a85dfa82$var$AngleAxis,
    /**
   * @override
   */ pointToData: function(point, clamp) {
        return this.polar.pointToData(point, clamp)[this.dim === "radius" ? 0 : 1];
    },
    dataToAngle: $95e1f94acccc578d$exports.prototype.dataToCoord,
    angleToData: $95e1f94acccc578d$exports.prototype.coordToData,
    /**
   * Only be called in category axis.
   * Angle axis uses text height to decide interval
   *
   * @override
   * @return {number} Auto interval for cateogry axis tick and label
   */ calculateCategoryInterval: function() {
        var axis = this;
        var labelModel = axis.getLabelModel();
        var ordinalScale = axis.scale;
        var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
        // avoid generating a long array by `getTicks`
        // in large category data case.
        var tickCount = ordinalScale.count();
        if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
        var tickValue = ordinalExtent[0];
        var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
        var unitH = Math.abs(unitSpan); // Not precise, just use height as text width
        // and each distance from axis line yet.
        var rect = $ebae9c4ebc22906c$export$c381147bfed79d9f(tickValue, labelModel.getFont(), "center", "top");
        var maxH = Math.max(rect.height, 7);
        var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.
        isNaN(dh) && (dh = Infinity);
        var interval = Math.max(0, Math.floor(dh));
        var cache = $2aa56e64a85dfa82$var$inner(axis.model);
        var lastAutoInterval = cache.lastAutoInterval;
        var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
        // otherwise the calculated interval might jitter when the zoom
        // window size is close to the interval-changing size.
        if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
         && lastAutoInterval > interval) interval = lastAutoInterval;
        else {
            cache.lastTickCount = tickCount;
            cache.lastAutoInterval = interval;
        }
        return interval;
    }
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($2aa56e64a85dfa82$var$AngleAxis, $95e1f94acccc578d$exports);
var $2aa56e64a85dfa82$var$_default = $2aa56e64a85dfa82$var$AngleAxis;
$2aa56e64a85dfa82$exports = $2aa56e64a85dfa82$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @module echarts/coord/polar/Polar
 */ /**
 * @alias {module:echarts/coord/polar/Polar}
 * @constructor
 * @param {string} name
 */ var $b37852f04e5c514a$var$Polar = function(name) {
    /**
   * @type {string}
   */ this.name = name || "";
    /**
   * x of polar center
   * @type {number}
   */ this.cx = 0;
    /**
   * y of polar center
   * @type {number}
   */ this.cy = 0;
    /**
   * @type {module:echarts/coord/polar/RadiusAxis}
   * @private
   */ this._radiusAxis = new $7086e6b36c60f43a$exports();
    /**
   * @type {module:echarts/coord/polar/AngleAxis}
   * @private
   */ this._angleAxis = new $2aa56e64a85dfa82$exports();
    this._radiusAxis.polar = this._angleAxis.polar = this;
};
$b37852f04e5c514a$var$Polar.prototype = {
    type: "polar",
    axisPointerEnabled: true,
    constructor: $b37852f04e5c514a$var$Polar,
    /**
   * @param {Array.<string>}
   * @readOnly
   */ dimensions: [
        "radius",
        "angle"
    ],
    /**
   * @type {module:echarts/coord/PolarModel}
   */ model: null,
    /**
   * If contain coord
   * @param {Array.<number>} point
   * @return {boolean}
   */ containPoint: function(point) {
        var coord = this.pointToCoord(point);
        return this._radiusAxis.contain(coord[0]) && this._angleAxis.contain(coord[1]);
    },
    /**
   * If contain data
   * @param {Array.<number>} data
   * @return {boolean}
   */ containData: function(data) {
        return this._radiusAxis.containData(data[0]) && this._angleAxis.containData(data[1]);
    },
    /**
   * @param {string} dim
   * @return {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
   */ getAxis: function(dim) {
        return this["_" + dim + "Axis"];
    },
    /**
   * @return {Array.<module:echarts/coord/Axis>}
   */ getAxes: function() {
        return [
            this._radiusAxis,
            this._angleAxis
        ];
    },
    /**
   * Get axes by type of scale
   * @param {string} scaleType
   * @return {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
   */ getAxesByScale: function(scaleType) {
        var axes = [];
        var angleAxis = this._angleAxis;
        var radiusAxis = this._radiusAxis;
        angleAxis.scale.type === scaleType && axes.push(angleAxis);
        radiusAxis.scale.type === scaleType && axes.push(radiusAxis);
        return axes;
    },
    /**
   * @return {module:echarts/coord/polar/AngleAxis}
   */ getAngleAxis: function() {
        return this._angleAxis;
    },
    /**
   * @return {module:echarts/coord/polar/RadiusAxis}
   */ getRadiusAxis: function() {
        return this._radiusAxis;
    },
    /**
   * @param {module:echarts/coord/polar/Axis}
   * @return {module:echarts/coord/polar/Axis}
   */ getOtherAxis: function(axis) {
        var angleAxis = this._angleAxis;
        return axis === angleAxis ? this._radiusAxis : angleAxis;
    },
    /**
   * Base axis will be used on stacking.
   *
   * @return {module:echarts/coord/polar/Axis}
   */ getBaseAxis: function() {
        return this.getAxesByScale("ordinal")[0] || this.getAxesByScale("time")[0] || this.getAngleAxis();
    },
    /**
   * @param {string} [dim] 'radius' or 'angle' or 'auto' or null/undefined
   * @return {Object} {baseAxes: [], otherAxes: []}
   */ getTooltipAxes: function(dim) {
        var baseAxis = dim != null && dim !== "auto" ? this.getAxis(dim) : this.getBaseAxis();
        return {
            baseAxes: [
                baseAxis
            ],
            otherAxes: [
                this.getOtherAxis(baseAxis)
            ]
        };
    },
    /**
   * Convert a single data item to (x, y) point.
   * Parameter data is an array which the first element is radius and the second is angle
   * @param {Array.<number>} data
   * @param {boolean} [clamp=false]
   * @return {Array.<number>}
   */ dataToPoint: function(data, clamp) {
        return this.coordToPoint([
            this._radiusAxis.dataToRadius(data[0], clamp),
            this._angleAxis.dataToAngle(data[1], clamp)
        ]);
    },
    /**
   * Convert a (x, y) point to data
   * @param {Array.<number>} point
   * @param {boolean} [clamp=false]
   * @return {Array.<number>}
   */ pointToData: function(point, clamp) {
        var coord = this.pointToCoord(point);
        return [
            this._radiusAxis.radiusToData(coord[0], clamp),
            this._angleAxis.angleToData(coord[1], clamp)
        ];
    },
    /**
   * Convert a (x, y) point to (radius, angle) coord
   * @param {Array.<number>} point
   * @return {Array.<number>}
   */ pointToCoord: function(point) {
        var dx = point[0] - this.cx;
        var dy = point[1] - this.cy;
        var angleAxis = this.getAngleAxis();
        var extent = angleAxis.getExtent();
        var minAngle = Math.min(extent[0], extent[1]);
        var maxAngle = Math.max(extent[0], extent[1]); // Fix fixed extent in polarCreator
        // FIXME
        angleAxis.inverse ? minAngle = maxAngle - 360 : maxAngle = minAngle + 360;
        var radius = Math.sqrt(dx * dx + dy * dy);
        dx /= radius;
        dy /= radius;
        var radian = Math.atan2(-dy, dx) / Math.PI * 180; // move to angleExtent
        var dir = radian < minAngle ? 1 : -1;
        while(radian < minAngle || radian > maxAngle)radian += dir * 360;
        return [
            radius,
            radian
        ];
    },
    /**
   * Convert a (radius, angle) coord to (x, y) point
   * @param {Array.<number>} coord
   * @return {Array.<number>}
   */ coordToPoint: function(coord) {
        var radius = coord[0];
        var radian = coord[1] / 180 * Math.PI;
        var x = Math.cos(radian) * radius + this.cx; // Inverse the y
        var y = -Math.sin(radian) * radius + this.cy;
        return [
            x,
            y
        ];
    },
    /**
   * Get ring area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   * @return {Ring}
   */ getArea: function() {
        var angleAxis = this.getAngleAxis();
        var radiusAxis = this.getRadiusAxis();
        var radiusExtent = radiusAxis.getExtent().slice();
        radiusExtent[0] > radiusExtent[1] && radiusExtent.reverse();
        var angleExtent = angleAxis.getExtent();
        var RADIAN = Math.PI / 180;
        return {
            cx: this.cx,
            cy: this.cy,
            r0: radiusExtent[0],
            r: radiusExtent[1],
            startAngle: -angleExtent[0] * RADIAN,
            endAngle: -angleExtent[1] * RADIAN,
            clockwise: angleAxis.inverse,
            contain: function(x, y) {
                // It's a ring shape.
                // Start angle and end angle don't matter
                var dx = x - this.cx;
                var dy = y - this.cy;
                var d2 = dx * dx + dy * dy;
                var r = this.r;
                var r0 = this.r0;
                return d2 <= r * r && d2 >= r0 * r0;
            }
        };
    }
};
var $b37852f04e5c514a$var$_default = $b37852f04e5c514a$var$Polar;
$b37852f04e5c514a$exports = $b37852f04e5c514a$var$_default;



var $004e8ff36cb365b3$var$parsePercent = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f;

var $004e8ff36cb365b3$var$createScaleByModel = $13542623aa20eeae$export$8941c4cacdc8f5a5;
var $004e8ff36cb365b3$var$niceScaleExtent = $13542623aa20eeae$export$51f3e70a54405d5a;


var $004e8ff36cb365b3$var$getStackedDimension = $1712a5e8fbedbcb3$export$909db2be4938fbdf;
var $7e4b40b95c6b575c$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $acefa9271268c43e$var$PolarAxisModel = $3b9c2389e45dfb7d$exports.extend({
    type: "polarAxis",
    /**
   * @type {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
   */ axis: null,
    /**
   * @override
   */ getCoordSysModel: function() {
        return this.ecModel.queryComponents({
            mainType: "polar",
            index: this.option.polarIndex,
            id: this.option.polarId
        })[0];
    }
});
$ec279652dd95c27b$export$4950aa0f605343fb($acefa9271268c43e$var$PolarAxisModel.prototype, $ce1d0648e3723c9f$exports);
var $acefa9271268c43e$var$polarAxisDefaultExtendedOption = {
    angle: {
        // polarIndex: 0,
        // polarId: '',
        startAngle: 90,
        clockwise: true,
        splitNumber: 12,
        axisLabel: {
            rotate: false
        }
    },
    radius: {
        // polarIndex: 0,
        // polarId: '',
        splitNumber: 5
    }
};
function $acefa9271268c43e$var$getAxisType(axisDim, option) {
    // Default axis with data is category axis
    return option.type || (option.data ? "category" : "value");
}
$b94fd69108c44724$exports("angle", $acefa9271268c43e$var$PolarAxisModel, $acefa9271268c43e$var$getAxisType, $acefa9271268c43e$var$polarAxisDefaultExtendedOption.angle);
$b94fd69108c44724$exports("radius", $acefa9271268c43e$var$PolarAxisModel, $acefa9271268c43e$var$getAxisType, $acefa9271268c43e$var$polarAxisDefaultExtendedOption.radius);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $7e4b40b95c6b575c$var$_default = $f406636b535430a7$exports.extendComponentModel({
    type: "polar",
    dependencies: [
        "polarAxis",
        "angleAxis"
    ],
    /**
   * @type {module:echarts/coord/polar/Polar}
   */ coordinateSystem: null,
    /**
   * @param {string} axisType
   * @return {module:echarts/coord/polar/AxisModel}
   */ findAxisModel: function(axisType) {
        var foundAxisModel;
        var ecModel = this.ecModel;
        ecModel.eachComponent(axisType, function(axisModel) {
            if (axisModel.getCoordSysModel() === this) foundAxisModel = axisModel;
        }, this);
        return foundAxisModel;
    },
    defaultOption: {
        zlevel: 0,
        z: 0,
        center: [
            "50%",
            "50%"
        ],
        radius: "80%"
    }
});
$7e4b40b95c6b575c$exports = $7e4b40b95c6b575c$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Axis scale
/**
 * Resize method bound to the polar
 * @param {module:echarts/coord/polar/PolarModel} polarModel
 * @param {module:echarts/ExtensionAPI} api
 */ function $004e8ff36cb365b3$var$resizePolar(polar, polarModel, api) {
    var center = polarModel.get("center");
    var width = api.getWidth();
    var height = api.getHeight();
    polar.cx = $004e8ff36cb365b3$var$parsePercent(center[0], width);
    polar.cy = $004e8ff36cb365b3$var$parsePercent(center[1], height);
    var radiusAxis = polar.getRadiusAxis();
    var size = Math.min(width, height) / 2;
    var radius = polarModel.get("radius");
    if (radius == null) radius = [
        0,
        "100%"
    ];
    else if (!$ec279652dd95c27b$export$43bee75e5e14138e(radius)) // r0 = 0
    radius = [
        0,
        radius
    ];
    radius = [
        $004e8ff36cb365b3$var$parsePercent(radius[0], size),
        $004e8ff36cb365b3$var$parsePercent(radius[1], size)
    ];
    radiusAxis.inverse ? radiusAxis.setExtent(radius[1], radius[0]) : radiusAxis.setExtent(radius[0], radius[1]);
}
/**
 * Update polar
 */ function $004e8ff36cb365b3$var$updatePolarScale(ecModel, api) {
    var polar = this;
    var angleAxis = polar.getAngleAxis();
    var radiusAxis = polar.getRadiusAxis(); // Reset scale
    angleAxis.scale.setExtent(Infinity, -Infinity);
    radiusAxis.scale.setExtent(Infinity, -Infinity);
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.coordinateSystem === polar) {
            var data = seriesModel.getData();
            $ec279652dd95c27b$export$79b2f7037acddd43(data.mapDimension("radius", true), function(dim) {
                radiusAxis.scale.unionExtentFromData(data, $004e8ff36cb365b3$var$getStackedDimension(data, dim));
            });
            $ec279652dd95c27b$export$79b2f7037acddd43(data.mapDimension("angle", true), function(dim) {
                angleAxis.scale.unionExtentFromData(data, $004e8ff36cb365b3$var$getStackedDimension(data, dim));
            });
        }
    });
    $004e8ff36cb365b3$var$niceScaleExtent(angleAxis.scale, angleAxis.model);
    $004e8ff36cb365b3$var$niceScaleExtent(radiusAxis.scale, radiusAxis.model); // Fix extent of category angle axis
    if (angleAxis.type === "category" && !angleAxis.onBand) {
        var extent = angleAxis.getExtent();
        var diff = 360 / angleAxis.scale.count();
        angleAxis.inverse ? extent[1] += diff : extent[1] -= diff;
        angleAxis.setExtent(extent[0], extent[1]);
    }
}
/**
 * Set common axis properties
 * @param {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
 * @param {module:echarts/coord/polar/AxisModel}
 * @inner
 */ function $004e8ff36cb365b3$var$setAxis(axis, axisModel) {
    axis.type = axisModel.get("type");
    axis.scale = $004e8ff36cb365b3$var$createScaleByModel(axisModel);
    axis.onBand = axisModel.get("boundaryGap") && axis.type === "category";
    axis.inverse = axisModel.get("inverse");
    if (axisModel.mainType === "angleAxis") {
        axis.inverse ^= axisModel.get("clockwise");
        var startAngle = axisModel.get("startAngle");
        axis.setExtent(startAngle, startAngle + (axis.inverse ? -360 : 360));
    } // Inject axis instance
    axisModel.axis = axis;
    axis.model = axisModel;
}
var $004e8ff36cb365b3$var$polarCreator = {
    dimensions: $b37852f04e5c514a$exports.prototype.dimensions,
    create: function(ecModel, api) {
        var polarList = [];
        ecModel.eachComponent("polar", function(polarModel, idx) {
            var polar = new $b37852f04e5c514a$exports(idx); // Inject resize and update method
            polar.update = $004e8ff36cb365b3$var$updatePolarScale;
            var radiusAxis = polar.getRadiusAxis();
            var angleAxis = polar.getAngleAxis();
            var radiusAxisModel = polarModel.findAxisModel("radiusAxis");
            var angleAxisModel = polarModel.findAxisModel("angleAxis");
            $004e8ff36cb365b3$var$setAxis(radiusAxis, radiusAxisModel);
            $004e8ff36cb365b3$var$setAxis(angleAxis, angleAxisModel);
            $004e8ff36cb365b3$var$resizePolar(polar, polarModel, api);
            polarList.push(polar);
            polarModel.coordinateSystem = polar;
            polar.model = polarModel;
        }); // Inject coordinateSystem to series
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.get("coordinateSystem") === "polar") {
                var polarModel = ecModel.queryComponents({
                    mainType: "polar",
                    index: seriesModel.get("polarIndex"),
                    id: seriesModel.get("polarId")
                })[0];
                seriesModel.coordinateSystem = polarModel.coordinateSystem;
            }
        });
        return polarList;
    }
};
$9c36d0fff3b0f387$exports.register("polar", $004e8ff36cb365b3$var$polarCreator);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $f7db135a52c5a410$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $f7db135a52c5a410$var$elementList = [
    "axisLine",
    "axisLabel",
    "axisTick",
    "minorTick",
    "splitLine",
    "minorSplitLine",
    "splitArea"
];
function $f7db135a52c5a410$var$getAxisLineShape(polar, rExtent, angle) {
    rExtent[1] > rExtent[0] && (rExtent = rExtent.slice().reverse());
    var start = polar.coordToPoint([
        rExtent[0],
        angle
    ]);
    var end = polar.coordToPoint([
        rExtent[1],
        angle
    ]);
    return {
        x1: start[0],
        y1: start[1],
        x2: end[0],
        y2: end[1]
    };
}
function $f7db135a52c5a410$var$getRadiusIdx(polar) {
    var radiusAxis = polar.getRadiusAxis();
    return radiusAxis.inverse ? 0 : 1;
} // Remove the last tick which will overlap the first tick
function $f7db135a52c5a410$var$fixAngleOverlap(list) {
    var firstItem = list[0];
    var lastItem = list[list.length - 1];
    if (firstItem && lastItem && Math.abs(Math.abs(firstItem.coord - lastItem.coord) - 360) < 1e-4) list.pop();
}
var $f7db135a52c5a410$var$_default = $0880bad8284a1b39$exports.extend({
    type: "angleAxis",
    axisPointerClass: "PolarAxisPointer",
    render: function(angleAxisModel, ecModel) {
        this.group.removeAll();
        if (!angleAxisModel.get("show")) return;
        var angleAxis = angleAxisModel.axis;
        var polar = angleAxis.polar;
        var radiusExtent = polar.getRadiusAxis().getExtent();
        var ticksAngles = angleAxis.getTicksCoords();
        var minorTickAngles = angleAxis.getMinorTicksCoords();
        var labels = $ec279652dd95c27b$export$871de8747c9eaa88(angleAxis.getViewLabels(), function(labelItem) {
            var labelItem = $ec279652dd95c27b$export$9cd59f9826255e47(labelItem);
            labelItem.coord = angleAxis.dataToCoord(labelItem.tickValue);
            return labelItem;
        });
        $f7db135a52c5a410$var$fixAngleOverlap(labels);
        $f7db135a52c5a410$var$fixAngleOverlap(ticksAngles);
        $ec279652dd95c27b$export$79b2f7037acddd43($f7db135a52c5a410$var$elementList, function(name) {
            if (angleAxisModel.get(name + ".show") && (!angleAxis.scale.isBlank() || name === "axisLine")) this["_" + name](angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels);
        }, this);
    },
    /**
   * @private
   */ _axisLine: function(angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var lineStyleModel = angleAxisModel.getModel("axisLine.lineStyle"); // extent id of the axis radius (r0 and r)
        var rId = $f7db135a52c5a410$var$getRadiusIdx(polar);
        var r0Id = rId ? 0 : 1;
        var shape;
        if (radiusExtent[r0Id] === 0) shape = new $4b57d6b582d579b7$export$c89a927ffc67e6fa({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: radiusExtent[rId]
            },
            style: lineStyleModel.getLineStyle(),
            z2: 1,
            silent: true
        });
        else shape = new $4b57d6b582d579b7$export$a6e3577650b6d6d7({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: radiusExtent[rId],
                r0: radiusExtent[r0Id]
            },
            style: lineStyleModel.getLineStyle(),
            z2: 1,
            silent: true
        });
        shape.style.fill = null;
        this.group.add(shape);
    },
    /**
   * @private
   */ _axisTick: function(angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var tickModel = angleAxisModel.getModel("axisTick");
        var tickLen = (tickModel.get("inside") ? -1 : 1) * tickModel.get("length");
        var radius = radiusExtent[$f7db135a52c5a410$var$getRadiusIdx(polar)];
        var lines = $ec279652dd95c27b$export$871de8747c9eaa88(ticksAngles, function(tickAngleItem) {
            return new $4b57d6b582d579b7$export$17d680238e50603e({
                shape: $f7db135a52c5a410$var$getAxisLineShape(polar, [
                    radius,
                    radius + tickLen
                ], tickAngleItem.coord)
            });
        });
        this.group.add($4b57d6b582d579b7$export$7b1dd269fbc4e903(lines, {
            style: $ec279652dd95c27b$export$ebe90cb607ad99e(tickModel.getModel("lineStyle").getLineStyle(), {
                stroke: angleAxisModel.get("axisLine.lineStyle.color")
            })
        }));
    },
    /**
   * @private
   */ _minorTick: function(angleAxisModel, polar, tickAngles, minorTickAngles, radiusExtent) {
        if (!minorTickAngles.length) return;
        var tickModel = angleAxisModel.getModel("axisTick");
        var minorTickModel = angleAxisModel.getModel("minorTick");
        var tickLen = (tickModel.get("inside") ? -1 : 1) * minorTickModel.get("length");
        var radius = radiusExtent[$f7db135a52c5a410$var$getRadiusIdx(polar)];
        var lines = [];
        for(var i = 0; i < minorTickAngles.length; i++)for(var k = 0; k < minorTickAngles[i].length; k++)lines.push(new $4b57d6b582d579b7$export$17d680238e50603e({
            shape: $f7db135a52c5a410$var$getAxisLineShape(polar, [
                radius,
                radius + tickLen
            ], minorTickAngles[i][k].coord)
        }));
        this.group.add($4b57d6b582d579b7$export$7b1dd269fbc4e903(lines, {
            style: $ec279652dd95c27b$export$ebe90cb607ad99e(minorTickModel.getModel("lineStyle").getLineStyle(), $ec279652dd95c27b$export$ebe90cb607ad99e(tickModel.getLineStyle(), {
                stroke: angleAxisModel.get("axisLine.lineStyle.color")
            }))
        }));
    },
    /**
   * @private
   */ _axisLabel: function(angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels) {
        var rawCategoryData = angleAxisModel.getCategories(true);
        var commonLabelModel = angleAxisModel.getModel("axisLabel");
        var labelMargin = commonLabelModel.get("margin");
        var triggerEvent = angleAxisModel.get("triggerEvent"); // Use length of ticksAngles because it may remove the last tick to avoid overlapping
        $ec279652dd95c27b$export$79b2f7037acddd43(labels, function(labelItem, idx) {
            var labelModel = commonLabelModel;
            var tickValue = labelItem.tickValue;
            var r = radiusExtent[$f7db135a52c5a410$var$getRadiusIdx(polar)];
            var p = polar.coordToPoint([
                r + labelMargin,
                labelItem.coord
            ]);
            var cx = polar.cx;
            var cy = polar.cy;
            var labelTextAlign = Math.abs(p[0] - cx) / r < 0.3 ? "center" : p[0] > cx ? "left" : "right";
            var labelTextVerticalAlign = Math.abs(p[1] - cy) / r < 0.3 ? "middle" : p[1] > cy ? "top" : "bottom";
            if (rawCategoryData && rawCategoryData[tickValue] && rawCategoryData[tickValue].textStyle) labelModel = new $2b51b4bf776ec22e$exports(rawCategoryData[tickValue].textStyle, commonLabelModel, commonLabelModel.ecModel);
            var textEl = new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
                silent: $3ce77a4133d2c8eb$exports.isLabelSilent(angleAxisModel)
            });
            this.group.add(textEl);
            $4b57d6b582d579b7$export$6605af501964d89a(textEl.style, labelModel, {
                x: p[0],
                y: p[1],
                textFill: labelModel.getTextColor() || angleAxisModel.get("axisLine.lineStyle.color"),
                text: labelItem.formattedLabel,
                textAlign: labelTextAlign,
                textVerticalAlign: labelTextVerticalAlign
            }); // Pack data for mouse event
            if (triggerEvent) {
                textEl.eventData = $3ce77a4133d2c8eb$exports.makeAxisEventDataBase(angleAxisModel);
                textEl.eventData.targetType = "axisLabel";
                textEl.eventData.value = labelItem.rawLabel;
            }
        }, this);
    },
    /**
   * @private
   */ _splitLine: function(angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var splitLineModel = angleAxisModel.getModel("splitLine");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var lineColors = lineStyleModel.get("color");
        var lineCount = 0;
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var splitLines = [];
        for(var i = 0; i < ticksAngles.length; i++){
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(new $4b57d6b582d579b7$export$17d680238e50603e({
                shape: $f7db135a52c5a410$var$getAxisLineShape(polar, radiusExtent, ticksAngles[i].coord)
            }));
        } // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitLines.length; i++)this.group.add($4b57d6b582d579b7$export$7b1dd269fbc4e903(splitLines[i], {
            style: $ec279652dd95c27b$export$ebe90cb607ad99e({
                stroke: lineColors[i % lineColors.length]
            }, lineStyleModel.getLineStyle()),
            silent: true,
            z: angleAxisModel.get("z")
        }));
    },
    /**
   * @private
   */ _minorSplitLine: function(angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        if (!minorTickAngles.length) return;
        var minorSplitLineModel = angleAxisModel.getModel("minorSplitLine");
        var lineStyleModel = minorSplitLineModel.getModel("lineStyle");
        var lines = [];
        for(var i = 0; i < minorTickAngles.length; i++)for(var k = 0; k < minorTickAngles[i].length; k++)lines.push(new $4b57d6b582d579b7$export$17d680238e50603e({
            shape: $f7db135a52c5a410$var$getAxisLineShape(polar, radiusExtent, minorTickAngles[i][k].coord)
        }));
        this.group.add($4b57d6b582d579b7$export$7b1dd269fbc4e903(lines, {
            style: lineStyleModel.getLineStyle(),
            silent: true,
            z: angleAxisModel.get("z")
        }));
    },
    /**
   * @private
   */ _splitArea: function(angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        if (!ticksAngles.length) return;
        var splitAreaModel = angleAxisModel.getModel("splitArea");
        var areaStyleModel = splitAreaModel.getModel("areaStyle");
        var areaColors = areaStyleModel.get("color");
        var lineCount = 0;
        areaColors = areaColors instanceof Array ? areaColors : [
            areaColors
        ];
        var splitAreas = [];
        var RADIAN = Math.PI / 180;
        var prevAngle = -ticksAngles[0].coord * RADIAN;
        var r0 = Math.min(radiusExtent[0], radiusExtent[1]);
        var r1 = Math.max(radiusExtent[0], radiusExtent[1]);
        var clockwise = angleAxisModel.get("clockwise");
        for(var i = 1; i < ticksAngles.length; i++){
            var colorIndex = lineCount++ % areaColors.length;
            splitAreas[colorIndex] = splitAreas[colorIndex] || [];
            splitAreas[colorIndex].push(new $4b57d6b582d579b7$export$e98c2c7eb2b14f45({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    r0: r0,
                    r: r1,
                    startAngle: prevAngle,
                    endAngle: -ticksAngles[i].coord * RADIAN,
                    clockwise: clockwise
                },
                silent: true
            }));
            prevAngle = -ticksAngles[i].coord * RADIAN;
        } // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitAreas.length; i++)this.group.add($4b57d6b582d579b7$export$7b1dd269fbc4e903(splitAreas[i], {
            style: $ec279652dd95c27b$export$ebe90cb607ad99e({
                fill: areaColors[i % areaColors.length]
            }, areaStyleModel.getAreaStyle()),
            silent: true
        }));
    }
});
$f7db135a52c5a410$exports = $f7db135a52c5a410$var$_default;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $6930dfa50952df7d$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $6930dfa50952df7d$var$axisBuilderAttrs = [
    "axisLine",
    "axisTickLabel",
    "axisName"
];
var $6930dfa50952df7d$var$selfBuilderAttrs = [
    "splitLine",
    "splitArea",
    "minorSplitLine"
];
var $6930dfa50952df7d$var$_default = $0880bad8284a1b39$exports.extend({
    type: "radiusAxis",
    axisPointerClass: "PolarAxisPointer",
    render: function(radiusAxisModel, ecModel) {
        this.group.removeAll();
        if (!radiusAxisModel.get("show")) return;
        var radiusAxis = radiusAxisModel.axis;
        var polar = radiusAxis.polar;
        var angleAxis = polar.getAngleAxis();
        var ticksCoords = radiusAxis.getTicksCoords();
        var minorTicksCoords = radiusAxis.getMinorTicksCoords();
        var axisAngle = angleAxis.getExtent()[0];
        var radiusExtent = radiusAxis.getExtent();
        var layout = $6930dfa50952df7d$var$layoutAxis(polar, radiusAxisModel, axisAngle);
        var axisBuilder = new $3ce77a4133d2c8eb$exports(radiusAxisModel, layout);
        $ec279652dd95c27b$export$79b2f7037acddd43($6930dfa50952df7d$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
        this.group.add(axisBuilder.getGroup());
        $ec279652dd95c27b$export$79b2f7037acddd43($6930dfa50952df7d$var$selfBuilderAttrs, function(name) {
            if (radiusAxisModel.get(name + ".show") && !radiusAxis.scale.isBlank()) this["_" + name](radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords);
        }, this);
    },
    /**
   * @private
   */ _splitLine: function(radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
        var splitLineModel = radiusAxisModel.getModel("splitLine");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var lineColors = lineStyleModel.get("color");
        var lineCount = 0;
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var splitLines = [];
        for(var i = 0; i < ticksCoords.length; i++){
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(new $4b57d6b582d579b7$export$c89a927ffc67e6fa({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    r: ticksCoords[i].coord
                }
            }));
        } // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitLines.length; i++)this.group.add($4b57d6b582d579b7$export$7b1dd269fbc4e903(splitLines[i], {
            style: $ec279652dd95c27b$export$ebe90cb607ad99e({
                stroke: lineColors[i % lineColors.length],
                fill: null
            }, lineStyleModel.getLineStyle()),
            silent: true
        }));
    },
    /**
   * @private
   */ _minorSplitLine: function(radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords) {
        if (!minorTicksCoords.length) return;
        var minorSplitLineModel = radiusAxisModel.getModel("minorSplitLine");
        var lineStyleModel = minorSplitLineModel.getModel("lineStyle");
        var lines = [];
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++)lines.push(new $4b57d6b582d579b7$export$c89a927ffc67e6fa({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: minorTicksCoords[i][k].coord
            }
        }));
        this.group.add($4b57d6b582d579b7$export$7b1dd269fbc4e903(lines, {
            style: $ec279652dd95c27b$export$ebe90cb607ad99e({
                fill: null
            }, lineStyleModel.getLineStyle()),
            silent: true
        }));
    },
    /**
   * @private
   */ _splitArea: function(radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
        if (!ticksCoords.length) return;
        var splitAreaModel = radiusAxisModel.getModel("splitArea");
        var areaStyleModel = splitAreaModel.getModel("areaStyle");
        var areaColors = areaStyleModel.get("color");
        var lineCount = 0;
        areaColors = areaColors instanceof Array ? areaColors : [
            areaColors
        ];
        var splitAreas = [];
        var prevRadius = ticksCoords[0].coord;
        for(var i = 1; i < ticksCoords.length; i++){
            var colorIndex = lineCount++ % areaColors.length;
            splitAreas[colorIndex] = splitAreas[colorIndex] || [];
            splitAreas[colorIndex].push(new $4b57d6b582d579b7$export$e98c2c7eb2b14f45({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    r0: prevRadius,
                    r: ticksCoords[i].coord,
                    startAngle: 0,
                    endAngle: Math.PI * 2
                },
                silent: true
            }));
            prevRadius = ticksCoords[i].coord;
        } // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitAreas.length; i++)this.group.add($4b57d6b582d579b7$export$7b1dd269fbc4e903(splitAreas[i], {
            style: $ec279652dd95c27b$export$ebe90cb607ad99e({
                fill: areaColors[i % areaColors.length]
            }, areaStyleModel.getAreaStyle()),
            silent: true
        }));
    }
});
/**
 * @inner
 */ function $6930dfa50952df7d$var$layoutAxis(polar, radiusAxisModel, axisAngle) {
    return {
        position: [
            polar.cx,
            polar.cy
        ],
        rotation: axisAngle / 180 * Math.PI,
        labelDirection: -1,
        tickDirection: -1,
        nameDirection: 1,
        labelRotate: radiusAxisModel.getModel("axisLabel").get("rotate"),
        // Over splitLine and splitArea
        z2: 1
    };
}
$6930dfa50952df7d$exports = $6930dfa50952df7d$var$_default;





var $ccacfa3557ff0315$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $ccacfa3557ff0315$var$PolarAxisPointer = $90232af8e64a7c89$exports.extend({
    /**
   * @override
   */ makeElOption: function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        if (axis.dim === "angle") this.animationThreshold = Math.PI / 18;
        var polar = axis.polar;
        var otherAxis = polar.getOtherAxis(axis);
        var otherExtent = otherAxis.getExtent();
        var coordValue;
        coordValue = axis["dataTo" + $a4be9366aeb9fcc8$export$38a1e7552f497c0e(axis.dim)](value);
        var axisPointerType = axisPointerModel.get("type");
        if (axisPointerType && axisPointerType !== "none") {
            var elStyle = $9a2d7ccde43eb492$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $ccacfa3557ff0315$var$pointerShapeBuilder[axisPointerType](axis, polar, coordValue, otherExtent, elStyle);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var labelMargin = axisPointerModel.get("label.margin");
        var labelPos = $ccacfa3557ff0315$var$getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin);
        $9a2d7ccde43eb492$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos);
    } // Do not support handle, utill any user requires it.
});
function $ccacfa3557ff0315$var$getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin) {
    var axis = axisModel.axis;
    var coord = axis.dataToCoord(value);
    var axisAngle = polar.getAngleAxis().getExtent()[0];
    axisAngle = axisAngle / 180 * Math.PI;
    var radiusExtent = polar.getRadiusAxis().getExtent();
    var position;
    var align;
    var verticalAlign;
    if (axis.dim === "radius") {
        var transform = $6c6dd9610ba660f0$export$185802fd694ee1f5();
        $6c6dd9610ba660f0$export$bb628a54ab399bc9(transform, transform, axisAngle);
        $6c6dd9610ba660f0$export$d73ee8ef04f5226a(transform, transform, [
            polar.cx,
            polar.cy
        ]);
        position = $4b57d6b582d579b7$export$9f9dcb98c894b623([
            coord,
            -labelMargin
        ], transform);
        var labelRotation = axisModel.getModel("axisLabel").get("rotate") || 0;
        var labelLayout = $3ce77a4133d2c8eb$exports.innerTextLayout(axisAngle, labelRotation * Math.PI / 180, -1);
        align = labelLayout.textAlign;
        verticalAlign = labelLayout.textVerticalAlign;
    } else {
        // angle axis
        var r = radiusExtent[1];
        position = polar.coordToPoint([
            r + labelMargin,
            coord
        ]);
        var cx = polar.cx;
        var cy = polar.cy;
        align = Math.abs(position[0] - cx) / r < 0.3 ? "center" : position[0] > cx ? "left" : "right";
        verticalAlign = Math.abs(position[1] - cy) / r < 0.3 ? "middle" : position[1] > cy ? "top" : "bottom";
    }
    return {
        position: position,
        align: align,
        verticalAlign: verticalAlign
    };
}
var $ccacfa3557ff0315$var$pointerShapeBuilder = {
    line: function(axis, polar, coordValue, otherExtent, elStyle) {
        return axis.dim === "angle" ? {
            type: "Line",
            shape: $9a2d7ccde43eb492$export$885fa0ad5a826207(polar.coordToPoint([
                otherExtent[0],
                coordValue
            ]), polar.coordToPoint([
                otherExtent[1],
                coordValue
            ]))
        } : {
            type: "Circle",
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: coordValue
            }
        };
    },
    shadow: function(axis, polar, coordValue, otherExtent, elStyle) {
        var bandWidth = Math.max(1, axis.getBandWidth());
        var radian = Math.PI / 180;
        return axis.dim === "angle" ? {
            type: "Sector",
            shape: $9a2d7ccde43eb492$export$b0cf82e7ebc0d7d0(polar.cx, polar.cy, otherExtent[0], otherExtent[1], (-coordValue - bandWidth / 2) * radian, (-coordValue + bandWidth / 2) * radian)
        } : {
            type: "Sector",
            shape: $9a2d7ccde43eb492$export$b0cf82e7ebc0d7d0(polar.cx, polar.cy, coordValue - bandWidth / 2, coordValue + bandWidth / 2, 0, Math.PI * 2)
        };
    }
};
$0880bad8284a1b39$exports.registerAxisPointerClass("PolarAxisPointer", $ccacfa3557ff0315$var$PolarAxisPointer);
var $ccacfa3557ff0315$var$_default = $ccacfa3557ff0315$var$PolarAxisPointer;
$ccacfa3557ff0315$exports = $ccacfa3557ff0315$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // For reducing size of echarts.min, barLayoutPolar is required by polar.
$f406636b535430a7$exports.registerLayout($ec279652dd95c27b$export$c3095a23b368d1f2($090080dae14fbf55$exports, "bar")); // Polar view
$f406636b535430a7$exports.extendComponentView({
    type: "polar"
});


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $0c663ceb645e87fb$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $0c663ceb645e87fb$var$GeoModel = $3b9c2389e45dfb7d$exports.extend({
    type: "geo",
    /**
   * @type {module:echarts/coord/geo/Geo}
   */ coordinateSystem: null,
    layoutMode: "box",
    init: function(option) {
        $3b9c2389e45dfb7d$exports.prototype.init.apply(this, arguments); // Default label emphasis `show`
        $d559f43cb9041423$export$abdcc6a26372f94b(option, "label", [
            "show"
        ]);
    },
    optionUpdated: function() {
        var option = this.option;
        var self = this;
        option.regions = $19a6292b10a68530$exports.getFilledRegions(option.regions, option.map, option.nameMap);
        this._optionModelMap = $ec279652dd95c27b$export$533b26079ad0b4b(option.regions || [], function(optionModelMap, regionOpt) {
            if (regionOpt.name) optionModelMap.set(regionOpt.name, new $2b51b4bf776ec22e$exports(regionOpt, self));
            return optionModelMap;
        }, $ec279652dd95c27b$export$55f8aa7ef875b0a4());
        this.updateSelectedMap(option.regions);
    },
    defaultOption: {
        zlevel: 0,
        z: 0,
        show: true,
        left: "center",
        top: "center",
        // width:,
        // height:,
        // right
        // bottom
        // Aspect is width / height. Inited to be geoJson bbox aspect
        // This parameter is used for scale this aspect
        // If svg used, aspectScale is 1 by default.
        // aspectScale: 0.75,
        aspectScale: null,
        ///// Layout with center and size
        // If you wan't to put map in a fixed size box with right aspect ratio
        // This two properties may more conveninet
        // layoutCenter: [50%, 50%]
        // layoutSize: 100
        silent: false,
        // Map type
        map: "",
        // Define left-top, right-bottom coords to control view
        // For example, [ [180, 90], [-180, -90] ]
        boundingCoords: null,
        // Default on center of map
        center: null,
        zoom: 1,
        scaleLimit: null,
        // selectedMode: false
        label: {
            show: false,
            color: "#000"
        },
        itemStyle: {
            // color: 各异,
            borderWidth: 0.5,
            borderColor: "#444",
            color: "#eee"
        },
        emphasis: {
            label: {
                show: true,
                color: "rgb(100,0,0)"
            },
            itemStyle: {
                color: "rgba(255,215,0,0.8)"
            }
        },
        regions: []
    },
    /**
   * Get model of region
   * @param  {string} name
   * @return {module:echarts/model/Model}
   */ getRegionModel: function(name) {
        return this._optionModelMap.get(name) || new $2b51b4bf776ec22e$exports(null, this, this.ecModel);
    },
    /**
   * Format label
   * @param {string} name Region name
   * @param {string} [status='normal'] 'normal' or 'emphasis'
   * @return {string}
   */ getFormattedLabel: function(name, status) {
        status = status || "normal";
        var regionModel = this.getRegionModel(name);
        var formatter = regionModel.get((status === "normal" ? "" : status + ".") + "label.formatter");
        var params = {
            name: name
        };
        if (typeof formatter === "function") {
            params.status = status;
            return formatter(params);
        } else if (typeof formatter === "string") return formatter.replace("{a}", name != null ? name : "");
    },
    setZoom: function(zoom) {
        this.option.zoom = zoom;
    },
    setCenter: function(center) {
        this.option.center = center;
    }
});
$ec279652dd95c27b$export$e36fc9d62a853069($0c663ceb645e87fb$var$GeoModel, $8460a2195ba68c18$exports);
var $0c663ceb645e87fb$var$_default = $0c663ceb645e87fb$var$GeoModel;
$0c663ceb645e87fb$exports = $0c663ceb645e87fb$var$_default;



var $aac5af8813874369$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $aac5af8813874369$var$_default = $f406636b535430a7$exports.extendComponentView({
    type: "geo",
    init: function(ecModel, api) {
        var mapDraw = new $3f31ab2d08c97478$exports(api, true);
        this._mapDraw = mapDraw;
        this.group.add(mapDraw.group);
    },
    render: function(geoModel, ecModel, api, payload) {
        // Not render if it is an toggleSelect action from self
        if (payload && payload.type === "geoToggleSelect" && payload.from === this.uid) return;
        var mapDraw = this._mapDraw;
        if (geoModel.get("show")) mapDraw.draw(geoModel, ecModel, api, this, payload);
        else this._mapDraw.group.removeAll();
        this.group.silent = geoModel.get("silent");
    },
    dispose: function() {
        this._mapDraw && this._mapDraw.remove();
    }
});
$aac5af8813874369$exports = $aac5af8813874369$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $cf841d3f107f16f3$var$makeAction(method, actionInfo) {
    actionInfo.update = "updateView";
    $f406636b535430a7$exports.registerAction(actionInfo, function(payload, ecModel) {
        var selected = {};
        ecModel.eachComponent({
            mainType: "geo",
            query: payload
        }, function(geoModel) {
            geoModel[method](payload.name);
            var geo = geoModel.coordinateSystem;
            $ec279652dd95c27b$export$79b2f7037acddd43(geo.regions, function(region) {
                selected[region.name] = geoModel.isSelected(region.name) || false;
            });
        });
        return {
            selected: selected,
            name: payload.name
        };
    });
}
$cf841d3f107f16f3$var$makeAction("toggleSelected", {
    type: "geoToggleSelect",
    event: "geoselectchanged"
});
$cf841d3f107f16f3$var$makeAction("select", {
    type: "geoSelect",
    event: "geoselected"
});
$cf841d3f107f16f3$var$makeAction("unSelect", {
    type: "geoUnSelect",
    event: "geounselected"
});




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $708a15d6d0757b33$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // (24*60*60*1000)
var $708a15d6d0757b33$var$PROXIMATE_ONE_DAY = 86400000;
/**
 * Calendar
 *
 * @constructor
 *
 * @param {Object} calendarModel calendarModel
 * @param {Object} ecModel       ecModel
 * @param {Object} api           api
 */ function $708a15d6d0757b33$var$Calendar(calendarModel, ecModel, api) {
    this._model = calendarModel;
}
$708a15d6d0757b33$var$Calendar.prototype = {
    constructor: $708a15d6d0757b33$var$Calendar,
    type: "calendar",
    dimensions: [
        "time",
        "value"
    ],
    // Required in createListFromData
    getDimensionsInfo: function() {
        return [
            {
                name: "time",
                type: "time"
            },
            "value"
        ];
    },
    getRangeInfo: function() {
        return this._rangeInfo;
    },
    getModel: function() {
        return this._model;
    },
    getRect: function() {
        return this._rect;
    },
    getCellWidth: function() {
        return this._sw;
    },
    getCellHeight: function() {
        return this._sh;
    },
    getOrient: function() {
        return this._orient;
    },
    /**
   * getFirstDayOfWeek
   *
   * @example
   *     0 : start at Sunday
   *     1 : start at Monday
   *
   * @return {number}
   */ getFirstDayOfWeek: function() {
        return this._firstDayOfWeek;
    },
    /**
   * get date info
   *
   * @param  {string|number} date date
   * @return {Object}
   * {
   *      y: string, local full year, eg., '1940',
   *      m: string, local month, from '01' ot '12',
   *      d: string, local date, from '01' to '31' (if exists),
   *      day: It is not date.getDay(). It is the location of the cell in a week, from 0 to 6,
   *      time: timestamp,
   *      formatedDate: string, yyyy-MM-dd,
   *      date: original date object.
   * }
   */ getDateInfo: function(date) {
        date = $2d742dbe7f960d8c$export$6b862160d295c8e(date);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var d = date.getDate();
        d = d < 10 ? "0" + d : d;
        var day = date.getDay();
        day = Math.abs((day + 7 - this.getFirstDayOfWeek()) % 7);
        return {
            y: y,
            m: m,
            d: d,
            day: day,
            time: date.getTime(),
            formatedDate: y + "-" + m + "-" + d,
            date: date
        };
    },
    getNextNDay: function(date, n) {
        n = n || 0;
        if (n === 0) return this.getDateInfo(date);
        date = new Date(this.getDateInfo(date).time);
        date.setDate(date.getDate() + n);
        return this.getDateInfo(date);
    },
    update: function(ecModel, api) {
        this._firstDayOfWeek = +this._model.getModel("dayLabel").get("firstDay");
        this._orient = this._model.get("orient");
        this._lineWidth = this._model.getModel("itemStyle").getItemStyle().lineWidth || 0;
        this._rangeInfo = this._getRangeInfo(this._initRangeOption());
        var weeks = this._rangeInfo.weeks || 1;
        var whNames = [
            "width",
            "height"
        ];
        var cellSize = this._model.get("cellSize").slice();
        var layoutParams = this._model.getBoxLayoutParams();
        var cellNumbers = this._orient === "horizontal" ? [
            weeks,
            7
        ] : [
            7,
            weeks
        ];
        $ec279652dd95c27b$export$79b2f7037acddd43([
            0,
            1
        ], function(idx) {
            if (cellSizeSpecified(cellSize, idx)) layoutParams[whNames[idx]] = cellSize[idx] * cellNumbers[idx];
        });
        var whGlobal = {
            width: api.getWidth(),
            height: api.getHeight()
        };
        var calendarRect = this._rect = $ab0c9086dd6c5b39$export$4517a5ca639a7293(layoutParams, whGlobal);
        $ec279652dd95c27b$export$79b2f7037acddd43([
            0,
            1
        ], function(idx) {
            if (!cellSizeSpecified(cellSize, idx)) cellSize[idx] = calendarRect[whNames[idx]] / cellNumbers[idx];
        });
        function cellSizeSpecified(cellSize, idx) {
            return cellSize[idx] != null && cellSize[idx] !== "auto";
        }
        this._sw = cellSize[0];
        this._sh = cellSize[1];
    },
    /**
   * Convert a time data(time, value) item to (x, y) point.
   *
   * @override
   * @param  {Array|number} data data
   * @param  {boolean} [clamp=true] out of range
   * @return {Array} point
   */ dataToPoint: function(data, clamp) {
        $ec279652dd95c27b$export$43bee75e5e14138e(data) && (data = data[0]);
        clamp == null && (clamp = true);
        var dayInfo = this.getDateInfo(data);
        var range = this._rangeInfo;
        var date = dayInfo.formatedDate; // if not in range return [NaN, NaN]
        if (clamp && !(dayInfo.time >= range.start.time && dayInfo.time < range.end.time + $708a15d6d0757b33$var$PROXIMATE_ONE_DAY)) return [
            NaN,
            NaN
        ];
        var week = dayInfo.day;
        var nthWeek = this._getRangeInfo([
            range.start.time,
            date
        ]).nthWeek;
        if (this._orient === "vertical") return [
            this._rect.x + week * this._sw + this._sw / 2,
            this._rect.y + nthWeek * this._sh + this._sh / 2
        ];
        return [
            this._rect.x + nthWeek * this._sw + this._sw / 2,
            this._rect.y + week * this._sh + this._sh / 2
        ];
    },
    /**
   * Convert a (x, y) point to time data
   *
   * @override
   * @param  {string} point point
   * @return {string}       data
   */ pointToData: function(point) {
        var date = this.pointToDate(point);
        return date && date.time;
    },
    /**
   * Convert a time date item to (x, y) four point.
   *
   * @param  {Array} data  date[0] is date
   * @param  {boolean} [clamp=true]  out of range
   * @return {Object}       point
   */ dataToRect: function(data, clamp) {
        var point = this.dataToPoint(data, clamp);
        return {
            contentShape: {
                x: point[0] - (this._sw - this._lineWidth) / 2,
                y: point[1] - (this._sh - this._lineWidth) / 2,
                width: this._sw - this._lineWidth,
                height: this._sh - this._lineWidth
            },
            center: point,
            tl: [
                point[0] - this._sw / 2,
                point[1] - this._sh / 2
            ],
            tr: [
                point[0] + this._sw / 2,
                point[1] - this._sh / 2
            ],
            br: [
                point[0] + this._sw / 2,
                point[1] + this._sh / 2
            ],
            bl: [
                point[0] - this._sw / 2,
                point[1] + this._sh / 2
            ]
        };
    },
    /**
   * Convert a (x, y) point to time date
   *
   * @param  {Array} point point
   * @return {Object}       date
   */ pointToDate: function(point) {
        var nthX = Math.floor((point[0] - this._rect.x) / this._sw) + 1;
        var nthY = Math.floor((point[1] - this._rect.y) / this._sh) + 1;
        var range = this._rangeInfo.range;
        if (this._orient === "vertical") return this._getDateByWeeksAndDay(nthY, nthX - 1, range);
        return this._getDateByWeeksAndDay(nthX, nthY - 1, range);
    },
    /**
   * @inheritDoc
   */ convertToPixel: $ec279652dd95c27b$export$c3095a23b368d1f2($708a15d6d0757b33$var$doConvert, "dataToPoint"),
    /**
   * @inheritDoc
   */ convertFromPixel: $ec279652dd95c27b$export$c3095a23b368d1f2($708a15d6d0757b33$var$doConvert, "pointToData"),
    /**
   * initRange
   *
   * @private
   * @return {Array} [start, end]
   */ _initRangeOption: function() {
        var range = this._model.get("range");
        var rg = range;
        if ($ec279652dd95c27b$export$43bee75e5e14138e(rg) && rg.length === 1) rg = rg[0];
        if (/^\d{4}$/.test(rg)) range = [
            rg + "-01-01",
            rg + "-12-31"
        ];
        if (/^\d{4}[\/|-]\d{1,2}$/.test(rg)) {
            var start = this.getDateInfo(rg);
            var firstDay = start.date;
            firstDay.setMonth(firstDay.getMonth() + 1);
            var end = this.getNextNDay(firstDay, -1);
            range = [
                start.formatedDate,
                end.formatedDate
            ];
        }
        if (/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(rg)) range = [
            rg,
            rg
        ];
        var tmp = this._getRangeInfo(range);
        if (tmp.start.time > tmp.end.time) range.reverse();
        return range;
    },
    /**
   * range info
   *
   * @private
   * @param  {Array} range range ['2017-01-01', '2017-07-08']
   *  If range[0] > range[1], they will not be reversed.
   * @return {Object}       obj
   */ _getRangeInfo: function(range) {
        range = [
            this.getDateInfo(range[0]),
            this.getDateInfo(range[1])
        ];
        var reversed;
        if (range[0].time > range[1].time) {
            reversed = true;
            range.reverse();
        }
        var allDay = Math.floor(range[1].time / $708a15d6d0757b33$var$PROXIMATE_ONE_DAY) - Math.floor(range[0].time / $708a15d6d0757b33$var$PROXIMATE_ONE_DAY) + 1; // Consider case1 (#11677 #10430):
        // Set the system timezone as "UK", set the range to `['2016-07-01', '2016-12-31']`
        // Consider case2:
        // Firstly set system timezone as "Time Zone: America/Toronto",
        // ```
        // var first = new Date(1478412000000 - 3600 * 1000 * 2.5);
        // var second = new Date(1478412000000);
        // var allDays = Math.floor(second / ONE_DAY) - Math.floor(first / ONE_DAY) + 1;
        // ```
        // will get wrong result because of DST. So we should fix it.
        var date = new Date(range[0].time);
        var startDateNum = date.getDate();
        var endDateNum = range[1].date.getDate();
        date.setDate(startDateNum + allDay - 1); // The bias can not over a month, so just compare date.
        var dateNum = date.getDate();
        if (dateNum !== endDateNum) {
            var sign = date.getTime() - range[1].time > 0 ? 1 : -1;
            while((dateNum = date.getDate()) !== endDateNum && (date.getTime() - range[1].time) * sign > 0){
                allDay -= sign;
                date.setDate(dateNum - sign);
            }
        }
        var weeks = Math.floor((allDay + range[0].day + 6) / 7);
        var nthWeek = reversed ? -weeks + 1 : weeks - 1;
        reversed && range.reverse();
        return {
            range: [
                range[0].formatedDate,
                range[1].formatedDate
            ],
            start: range[0],
            end: range[1],
            allDay: allDay,
            weeks: weeks,
            // From 0.
            nthWeek: nthWeek,
            fweek: range[0].day,
            lweek: range[1].day
        };
    },
    /**
   * get date by nthWeeks and week day in range
   *
   * @private
   * @param  {number} nthWeek the week
   * @param  {number} day   the week day
   * @param  {Array} range [d1, d2]
   * @return {Object}
   */ _getDateByWeeksAndDay: function(nthWeek, day, range) {
        var rangeInfo = this._getRangeInfo(range);
        if (nthWeek > rangeInfo.weeks || nthWeek === 0 && day < rangeInfo.fweek || nthWeek === rangeInfo.weeks && day > rangeInfo.lweek) return false;
        var nthDay = (nthWeek - 1) * 7 - rangeInfo.fweek + day;
        var date = new Date(rangeInfo.start.time);
        date.setDate(rangeInfo.start.d + nthDay);
        return this.getDateInfo(date);
    }
};
$708a15d6d0757b33$var$Calendar.dimensions = $708a15d6d0757b33$var$Calendar.prototype.dimensions;
$708a15d6d0757b33$var$Calendar.getDimensionsInfo = $708a15d6d0757b33$var$Calendar.prototype.getDimensionsInfo;
$708a15d6d0757b33$var$Calendar.create = function(ecModel, api) {
    var calendarList = [];
    ecModel.eachComponent("calendar", function(calendarModel) {
        var calendar = new $708a15d6d0757b33$var$Calendar(calendarModel, ecModel, api);
        calendarList.push(calendar);
        calendarModel.coordinateSystem = calendar;
    });
    ecModel.eachSeries(function(calendarSeries) {
        if (calendarSeries.get("coordinateSystem") === "calendar") // Inject coordinate system
        calendarSeries.coordinateSystem = calendarList[calendarSeries.get("calendarIndex") || 0];
    });
    return calendarList;
};
function $708a15d6d0757b33$var$doConvert(methodName, ecModel, finder, value) {
    var calendarModel = finder.calendarModel;
    var seriesModel = finder.seriesModel;
    var coordSys = calendarModel ? calendarModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
    return coordSys === this ? coordSys[methodName](value) : null;
}
$9c36d0fff3b0f387$exports.register("calendar", $708a15d6d0757b33$var$Calendar);
var $708a15d6d0757b33$var$_default = $708a15d6d0757b33$var$Calendar;
$708a15d6d0757b33$exports = $708a15d6d0757b33$var$_default;


var $def7d7523f2e6514$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $def7d7523f2e6514$var$getLayoutParams = $ab0c9086dd6c5b39$export$4b0d20af19c9875e;
var $def7d7523f2e6514$var$sizeCalculable = $ab0c9086dd6c5b39$export$7ede609e8ebc9650;
var $def7d7523f2e6514$var$mergeLayoutParam = $ab0c9086dd6c5b39$export$1754cb91f16ca028;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $def7d7523f2e6514$var$CalendarModel = $3b9c2389e45dfb7d$exports.extend({
    type: "calendar",
    /**
   * @type {module:echarts/coord/calendar/Calendar}
   */ coordinateSystem: null,
    defaultOption: {
        zlevel: 0,
        z: 2,
        left: 80,
        top: 60,
        cellSize: 20,
        // horizontal vertical
        orient: "horizontal",
        // month separate line style
        splitLine: {
            show: true,
            lineStyle: {
                color: "#000",
                width: 1,
                type: "solid"
            }
        },
        // rect style  temporarily unused emphasis
        itemStyle: {
            color: "#fff",
            borderWidth: 1,
            borderColor: "#ccc"
        },
        // week text style
        dayLabel: {
            show: true,
            // a week first day
            firstDay: 0,
            // start end
            position: "start",
            margin: "50%",
            // 50% of cellSize
            nameMap: "en",
            color: "#000"
        },
        // month text style
        monthLabel: {
            show: true,
            // start end
            position: "start",
            margin: 5,
            // center or left
            align: "center",
            // cn en []
            nameMap: "en",
            formatter: null,
            color: "#000"
        },
        // year text style
        yearLabel: {
            show: true,
            // top bottom left right
            position: null,
            margin: 30,
            formatter: null,
            color: "#ccc",
            fontFamily: "sans-serif",
            fontWeight: "bolder",
            fontSize: 20
        }
    },
    /**
   * @override
   */ init: function(option, parentModel, ecModel, extraOpt) {
        var inputPositionParams = $def7d7523f2e6514$var$getLayoutParams(option);
        $def7d7523f2e6514$var$CalendarModel.superApply(this, "init", arguments);
        $def7d7523f2e6514$var$mergeAndNormalizeLayoutParams(option, inputPositionParams);
    },
    /**
   * @override
   */ mergeOption: function(option, extraOpt) {
        $def7d7523f2e6514$var$CalendarModel.superApply(this, "mergeOption", arguments);
        $def7d7523f2e6514$var$mergeAndNormalizeLayoutParams(this.option, option);
    }
});
function $def7d7523f2e6514$var$mergeAndNormalizeLayoutParams(target, raw) {
    // Normalize cellSize
    var cellSize = target.cellSize;
    if (!$ec279652dd95c27b$export$43bee75e5e14138e(cellSize)) cellSize = target.cellSize = [
        cellSize,
        cellSize
    ];
    else if (cellSize.length === 1) cellSize[1] = cellSize[0];
    var ignoreSize = $ec279652dd95c27b$export$871de8747c9eaa88([
        0,
        1
    ], function(hvIdx) {
        // If user have set `width` or both `left` and `right`, cellSize
        // will be automatically set to 'auto', otherwise the default
        // setting of cellSize will make `width` setting not work.
        if ($def7d7523f2e6514$var$sizeCalculable(raw, hvIdx)) cellSize[hvIdx] = "auto";
        return cellSize[hvIdx] != null && cellSize[hvIdx] !== "auto";
    });
    $def7d7523f2e6514$var$mergeLayoutParam(target, raw, {
        type: "box",
        ignoreSize: ignoreSize
    });
}
var $def7d7523f2e6514$var$_default = $def7d7523f2e6514$var$CalendarModel;
$def7d7523f2e6514$exports = $def7d7523f2e6514$var$_default;


var $9ad6c62d8a200c11$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $9ad6c62d8a200c11$var$MONTH_TEXT = {
    EN: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    CN: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $9ad6c62d8a200c11$var$WEEK_TEXT = {
    EN: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    CN: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ]
};
var $9ad6c62d8a200c11$var$_default = $f406636b535430a7$exports.extendComponentView({
    type: "calendar",
    /**
   * top/left line points
   *  @private
   */ _tlpoints: null,
    /**
   * bottom/right line points
   *  @private
   */ _blpoints: null,
    /**
   * first day of month
   *  @private
   */ _firstDayOfMonth: null,
    /**
   * first day point of month
   *  @private
   */ _firstDayPoints: null,
    render: function(calendarModel, ecModel, api) {
        var group = this.group;
        group.removeAll();
        var coordSys = calendarModel.coordinateSystem; // range info
        var rangeData = coordSys.getRangeInfo();
        var orient = coordSys.getOrient();
        this._renderDayRect(calendarModel, rangeData, group); // _renderLines must be called prior to following function
        this._renderLines(calendarModel, rangeData, orient, group);
        this._renderYearText(calendarModel, rangeData, orient, group);
        this._renderMonthText(calendarModel, orient, group);
        this._renderWeekText(calendarModel, rangeData, orient, group);
    },
    // render day rect
    _renderDayRect: function(calendarModel, rangeData, group) {
        var coordSys = calendarModel.coordinateSystem;
        var itemRectStyleModel = calendarModel.getModel("itemStyle").getItemStyle();
        var sw = coordSys.getCellWidth();
        var sh = coordSys.getCellHeight();
        for(var i = rangeData.start.time; i <= rangeData.end.time; i = coordSys.getNextNDay(i, 1).time){
            var point = coordSys.dataToRect([
                i
            ], false).tl; // every rect
            var rect = new $4b57d6b582d579b7$export$c79fc6492f3af13d({
                shape: {
                    x: point[0],
                    y: point[1],
                    width: sw,
                    height: sh
                },
                cursor: "default",
                style: itemRectStyleModel
            });
            group.add(rect);
        }
    },
    // render separate line
    _renderLines: function(calendarModel, rangeData, orient, group) {
        var self = this;
        var coordSys = calendarModel.coordinateSystem;
        var lineStyleModel = calendarModel.getModel("splitLine.lineStyle").getLineStyle();
        var show = calendarModel.get("splitLine.show");
        var lineWidth = lineStyleModel.lineWidth;
        this._tlpoints = [];
        this._blpoints = [];
        this._firstDayOfMonth = [];
        this._firstDayPoints = [];
        var firstDay = rangeData.start;
        for(var i = 0; firstDay.time <= rangeData.end.time; i++){
            addPoints(firstDay.formatedDate);
            if (i === 0) firstDay = coordSys.getDateInfo(rangeData.start.y + "-" + rangeData.start.m);
            var date = firstDay.date;
            date.setMonth(date.getMonth() + 1);
            firstDay = coordSys.getDateInfo(date);
        }
        addPoints(coordSys.getNextNDay(rangeData.end.time, 1).formatedDate);
        function addPoints(date) {
            self._firstDayOfMonth.push(coordSys.getDateInfo(date));
            self._firstDayPoints.push(coordSys.dataToRect([
                date
            ], false).tl);
            var points = self._getLinePointsOfOneWeek(calendarModel, date, orient);
            self._tlpoints.push(points[0]);
            self._blpoints.push(points[points.length - 1]);
            show && self._drawSplitline(points, lineStyleModel, group);
        } // render top/left line
        show && this._drawSplitline(self._getEdgesPoints(self._tlpoints, lineWidth, orient), lineStyleModel, group); // render bottom/right line
        show && this._drawSplitline(self._getEdgesPoints(self._blpoints, lineWidth, orient), lineStyleModel, group);
    },
    // get points at both ends
    _getEdgesPoints: function(points, lineWidth, orient) {
        var rs = [
            points[0].slice(),
            points[points.length - 1].slice()
        ];
        var idx = orient === "horizontal" ? 0 : 1; // both ends of the line are extend half lineWidth
        rs[0][idx] = rs[0][idx] - lineWidth / 2;
        rs[1][idx] = rs[1][idx] + lineWidth / 2;
        return rs;
    },
    // render split line
    _drawSplitline: function(points, lineStyleModel, group) {
        var poyline = new $4b57d6b582d579b7$export$79f3ee03e63e7073({
            z2: 20,
            shape: {
                points: points
            },
            style: lineStyleModel
        });
        group.add(poyline);
    },
    // render month line of one week points
    _getLinePointsOfOneWeek: function(calendarModel, date, orient) {
        var coordSys = calendarModel.coordinateSystem;
        date = coordSys.getDateInfo(date);
        var points = [];
        for(var i = 0; i < 7; i++){
            var tmpD = coordSys.getNextNDay(date.time, i);
            var point = coordSys.dataToRect([
                tmpD.time
            ], false);
            points[2 * tmpD.day] = point.tl;
            points[2 * tmpD.day + 1] = point[orient === "horizontal" ? "bl" : "tr"];
        }
        return points;
    },
    _formatterLabel: function(formatter, params) {
        if (typeof formatter === "string" && formatter) return $a4be9366aeb9fcc8$export$2fa08233ee42f8e1(formatter, params);
        if (typeof formatter === "function") return formatter(params);
        return params.nameMap;
    },
    _yearTextPositionControl: function(textEl, point, orient, position, margin) {
        point = point.slice();
        var aligns = [
            "center",
            "bottom"
        ];
        if (position === "bottom") {
            point[1] += margin;
            aligns = [
                "center",
                "top"
            ];
        } else if (position === "left") point[0] -= margin;
        else if (position === "right") {
            point[0] += margin;
            aligns = [
                "center",
                "top"
            ];
        } else // top
        point[1] -= margin;
        var rotate = 0;
        if (position === "left" || position === "right") rotate = Math.PI / 2;
        return {
            rotation: rotate,
            position: point,
            style: {
                textAlign: aligns[0],
                textVerticalAlign: aligns[1]
            }
        };
    },
    // render year
    _renderYearText: function(calendarModel, rangeData, orient, group) {
        var yearLabel = calendarModel.getModel("yearLabel");
        if (!yearLabel.get("show")) return;
        var margin = yearLabel.get("margin");
        var pos = yearLabel.get("position");
        if (!pos) pos = orient !== "horizontal" ? "top" : "left";
        var points = [
            this._tlpoints[this._tlpoints.length - 1],
            this._blpoints[0]
        ];
        var xc = (points[0][0] + points[1][0]) / 2;
        var yc = (points[0][1] + points[1][1]) / 2;
        var idx = orient === "horizontal" ? 0 : 1;
        var posPoints = {
            top: [
                xc,
                points[idx][1]
            ],
            bottom: [
                xc,
                points[1 - idx][1]
            ],
            left: [
                points[1 - idx][0],
                yc
            ],
            right: [
                points[idx][0],
                yc
            ]
        };
        var name = rangeData.start.y;
        if (+rangeData.end.y > +rangeData.start.y) name = name + "-" + rangeData.end.y;
        var formatter = yearLabel.get("formatter");
        var params = {
            start: rangeData.start.y,
            end: rangeData.end.y,
            nameMap: name
        };
        var content = this._formatterLabel(formatter, params);
        var yearText = new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
            z2: 30
        });
        $4b57d6b582d579b7$export$6605af501964d89a(yearText.style, yearLabel, {
            text: content
        }), yearText.attr(this._yearTextPositionControl(yearText, posPoints[pos], orient, pos, margin));
        group.add(yearText);
    },
    _monthTextPositionControl: function(point, isCenter, orient, position, margin) {
        var align = "left";
        var vAlign = "top";
        var x = point[0];
        var y = point[1];
        if (orient === "horizontal") {
            y = y + margin;
            if (isCenter) align = "center";
            if (position === "start") vAlign = "bottom";
        } else {
            x = x + margin;
            if (isCenter) vAlign = "middle";
            if (position === "start") align = "right";
        }
        return {
            x: x,
            y: y,
            textAlign: align,
            textVerticalAlign: vAlign
        };
    },
    // render month and year text
    _renderMonthText: function(calendarModel, orient, group) {
        var monthLabel = calendarModel.getModel("monthLabel");
        if (!monthLabel.get("show")) return;
        var nameMap = monthLabel.get("nameMap");
        var margin = monthLabel.get("margin");
        var pos = monthLabel.get("position");
        var align = monthLabel.get("align");
        var termPoints = [
            this._tlpoints,
            this._blpoints
        ];
        if ($ec279652dd95c27b$export$844ec244b1367d54(nameMap)) nameMap = $9ad6c62d8a200c11$var$MONTH_TEXT[nameMap.toUpperCase()] || [];
        var idx = pos === "start" ? 0 : 1;
        var axis = orient === "horizontal" ? 0 : 1;
        margin = pos === "start" ? -margin : margin;
        var isCenter = align === "center";
        for(var i = 0; i < termPoints[idx].length - 1; i++){
            var tmp = termPoints[idx][i].slice();
            var firstDay = this._firstDayOfMonth[i];
            if (isCenter) {
                var firstDayPoints = this._firstDayPoints[i];
                tmp[axis] = (firstDayPoints[axis] + termPoints[0][i + 1][axis]) / 2;
            }
            var formatter = monthLabel.get("formatter");
            var name = nameMap[+firstDay.m - 1];
            var params = {
                yyyy: firstDay.y,
                yy: (firstDay.y + "").slice(2),
                MM: firstDay.m,
                M: +firstDay.m,
                nameMap: name
            };
            var content = this._formatterLabel(formatter, params);
            var monthText = new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
                z2: 30
            });
            $ec279652dd95c27b$export$8b58be045bf06082($4b57d6b582d579b7$export$6605af501964d89a(monthText.style, monthLabel, {
                text: content
            }), this._monthTextPositionControl(tmp, isCenter, orient, pos, margin));
            group.add(monthText);
        }
    },
    _weekTextPositionControl: function(point, orient, position, margin, cellSize) {
        var align = "center";
        var vAlign = "middle";
        var x = point[0];
        var y = point[1];
        var isStart = position === "start";
        if (orient === "horizontal") {
            x = x + margin + (isStart ? 1 : -1) * cellSize[0] / 2;
            align = isStart ? "right" : "left";
        } else {
            y = y + margin + (isStart ? 1 : -1) * cellSize[1] / 2;
            vAlign = isStart ? "bottom" : "top";
        }
        return {
            x: x,
            y: y,
            textAlign: align,
            textVerticalAlign: vAlign
        };
    },
    // render weeks
    _renderWeekText: function(calendarModel, rangeData, orient, group) {
        var dayLabel = calendarModel.getModel("dayLabel");
        if (!dayLabel.get("show")) return;
        var coordSys = calendarModel.coordinateSystem;
        var pos = dayLabel.get("position");
        var nameMap = dayLabel.get("nameMap");
        var margin = dayLabel.get("margin");
        var firstDayOfWeek = coordSys.getFirstDayOfWeek();
        if ($ec279652dd95c27b$export$844ec244b1367d54(nameMap)) nameMap = $9ad6c62d8a200c11$var$WEEK_TEXT[nameMap.toUpperCase()] || [];
        var start = coordSys.getNextNDay(rangeData.end.time, 7 - rangeData.lweek).time;
        var cellSize = [
            coordSys.getCellWidth(),
            coordSys.getCellHeight()
        ];
        margin = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(margin, cellSize[orient === "horizontal" ? 0 : 1]);
        if (pos === "start") {
            start = coordSys.getNextNDay(rangeData.start.time, -(7 + rangeData.fweek)).time;
            margin = -margin;
        }
        for(var i = 0; i < 7; i++){
            var tmpD = coordSys.getNextNDay(start, i);
            var point = coordSys.dataToRect([
                tmpD.time
            ], false).center;
            var day = i;
            day = Math.abs((i + firstDayOfWeek) % 7);
            var weekText = new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
                z2: 30
            });
            $ec279652dd95c27b$export$8b58be045bf06082($4b57d6b582d579b7$export$6605af501964d89a(weekText.style, dayLabel, {
                text: nameMap[day]
            }), this._weekTextPositionControl(point, orient, pos, margin, cellSize));
            group.add(weekText);
        }
    }
});
$9ad6c62d8a200c11$exports = $9ad6c62d8a200c11$var$_default;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $838361220d284f63$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;






var $838361220d284f63$var$parsePercent = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $838361220d284f63$var$_nonShapeGraphicElements = {
    // Reserved but not supported in graphic component.
    path: null,
    compoundPath: null,
    // Supported in graphic component.
    group: $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4,
    image: $4b57d6b582d579b7$export$3e431a229df88919,
    text: $4b57d6b582d579b7$export$5f1af8db9871e1d6
}; // -------------
// Preprocessor
// -------------
$f406636b535430a7$exports.registerPreprocessor(function(option) {
    var graphicOption = option.graphic; // Convert
    // {graphic: [{left: 10, type: 'circle'}, ...]}
    // or
    // {graphic: {left: 10, type: 'circle'}}
    // to
    // {graphic: [{elements: [{left: 10, type: 'circle'}, ...]}]}
    if ($ec279652dd95c27b$export$43bee75e5e14138e(graphicOption)) {
        if (!graphicOption[0] || !graphicOption[0].elements) option.graphic = [
            {
                elements: graphicOption
            }
        ];
        else // Only one graphic instance can be instantiated. (We dont
        // want that too many views are created in echarts._viewMap)
        option.graphic = [
            option.graphic[0]
        ];
    } else if (graphicOption && !graphicOption.elements) option.graphic = [
        {
            elements: [
                graphicOption
            ]
        }
    ];
}); // ------
// Model
// ------
var $838361220d284f63$var$GraphicModel = $f406636b535430a7$exports.extendComponentModel({
    type: "graphic",
    defaultOption: {
        // Extra properties for each elements:
        //
        // left/right/top/bottom: (like 12, '22%', 'center', default undefined)
        //      If left/rigth is set, shape.x/shape.cx/position will not be used.
        //      If top/bottom is set, shape.y/shape.cy/position will not be used.
        //      This mechanism is useful when you want to position a group/element
        //      against the right side or the center of this container.
        //
        // width/height: (can only be pixel value, default 0)
        //      Only be used to specify contianer(group) size, if needed. And
        //      can not be percentage value (like '33%'). See the reason in the
        //      layout algorithm below.
        //
        // bounding: (enum: 'all' (default) | 'raw')
        //      Specify how to calculate boundingRect when locating.
        //      'all': Get uioned and transformed boundingRect
        //          from both itself and its descendants.
        //          This mode simplies confining a group of elements in the bounding
        //          of their ancester container (e.g., using 'right: 0').
        //      'raw': Only use the boundingRect of itself and before transformed.
        //          This mode is similar to css behavior, which is useful when you
        //          want an element to be able to overflow its container. (Consider
        //          a rotated circle needs to be located in a corner.)
        // info: custom info. enables user to mount some info on elements and use them
        //      in event handlers. Update them only when user specified, otherwise, remain.
        // Note: elements is always behind its ancestors in this elements array.
        elements: [],
        parentId: null
    },
    /**
   * Save el options for the sake of the performance (only update modified graphics).
   * The order is the same as those in option. (ancesters -> descendants)
   *
   * @private
   * @type {Array.<Object>}
   */ _elOptionsToUpdate: null,
    /**
   * @override
   */ mergeOption: function(option) {
        // Prevent default merge to elements
        var elements = this.option.elements;
        this.option.elements = null;
        $838361220d284f63$var$GraphicModel.superApply(this, "mergeOption", arguments);
        this.option.elements = elements;
    },
    /**
   * @override
   */ optionUpdated: function(newOption, isInit) {
        var thisOption = this.option;
        var newList = (isInit ? thisOption : newOption).elements;
        var existList = thisOption.elements = isInit ? [] : thisOption.elements;
        var flattenedList = [];
        this._flatten(newList, flattenedList);
        var mappingResult = $d559f43cb9041423$export$574f818966e4da87(existList, flattenedList);
        $d559f43cb9041423$export$6f01005fe2e2ddc6(mappingResult); // Clear elOptionsToUpdate
        var elOptionsToUpdate = this._elOptionsToUpdate = [];
        $ec279652dd95c27b$export$79b2f7037acddd43(mappingResult, function(resultItem, index) {
            var newElOption = resultItem.option;
            if (!newElOption) return;
            elOptionsToUpdate.push(newElOption);
            $838361220d284f63$var$setKeyInfoToNewElOption(resultItem, newElOption);
            $838361220d284f63$var$mergeNewElOptionToExist(existList, index, newElOption);
            $838361220d284f63$var$setLayoutInfoToExist(existList[index], newElOption);
        }, this); // Clean
        for(var i = existList.length - 1; i >= 0; i--)if (existList[i] == null) existList.splice(i, 1);
        else // $action should be volatile, otherwise option gotten from
        // `getOption` will contain unexpected $action.
        delete existList[i].$action;
    },
    /**
   * Convert
   * [{
   *  type: 'group',
   *  id: 'xx',
   *  children: [{type: 'circle'}, {type: 'polygon'}]
   * }]
   * to
   * [
   *  {type: 'group', id: 'xx'},
   *  {type: 'circle', parentId: 'xx'},
   *  {type: 'polygon', parentId: 'xx'}
   * ]
   *
   * @private
   * @param {Array.<Object>} optionList option list
   * @param {Array.<Object>} result result of flatten
   * @param {Object} parentOption parent option
   */ _flatten: function(optionList, result, parentOption) {
        $ec279652dd95c27b$export$79b2f7037acddd43(optionList, function(option) {
            if (!option) return;
            if (parentOption) option.parentOption = parentOption;
            result.push(option);
            var children = option.children;
            if (option.type === "group" && children) this._flatten(children, result, option);
             // Deleting for JSON output, and for not affecting group creation.
            delete option.children;
        }, this);
    },
    // FIXME
    // Pass to view using payload? setOption has a payload?
    useElOptionsToUpdate: function() {
        var els = this._elOptionsToUpdate; // Clear to avoid render duplicately when zooming.
        this._elOptionsToUpdate = null;
        return els;
    }
}); // -----
// View
// -----
$f406636b535430a7$exports.extendComponentView({
    type: "graphic",
    /**
   * @override
   */ init: function(ecModel, api) {
        /**
     * @private
     * @type {module:zrender/core/util.HashMap}
     */ this._elMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4();
        /**
     * @private
     * @type {module:echarts/graphic/GraphicModel}
     */ this._lastGraphicModel;
    },
    /**
   * @override
   */ render: function(graphicModel, ecModel, api) {
        // Having leveraged between use cases and algorithm complexity, a very
        // simple layout mechanism is used:
        // The size(width/height) can be determined by itself or its parent (not
        // implemented yet), but can not by its children. (Top-down travel)
        // The location(x/y) can be determined by the bounding rect of itself
        // (can including its descendants or not) and the size of its parent.
        // (Bottom-up travel)
        // When `chart.clear()` or `chart.setOption({...}, true)` with the same id,
        // view will be reused.
        if (graphicModel !== this._lastGraphicModel) this._clear();
        this._lastGraphicModel = graphicModel;
        this._updateElements(graphicModel);
        this._relocate(graphicModel, api);
    },
    /**
   * Update graphic elements.
   *
   * @private
   * @param {Object} graphicModel graphic model
   */ _updateElements: function(graphicModel) {
        var elOptionsToUpdate = graphicModel.useElOptionsToUpdate();
        if (!elOptionsToUpdate) return;
        var elMap = this._elMap;
        var rootGroup = this.group; // Top-down tranverse to assign graphic settings to each elements.
        $ec279652dd95c27b$export$79b2f7037acddd43(elOptionsToUpdate, function(elOption) {
            var $action = elOption.$action;
            var id = elOption.id;
            var existEl = elMap.get(id);
            var parentId = elOption.parentId;
            var targetElParent = parentId != null ? elMap.get(parentId) : rootGroup;
            var elOptionStyle = elOption.style;
            if (elOption.type === "text" && elOptionStyle) {
                // In top/bottom mode, textVerticalAlign should not be used, which cause
                // inaccurately locating.
                if (elOption.hv && elOption.hv[1]) elOptionStyle.textVerticalAlign = elOptionStyle.textBaseline = null;
                 // Compatible with previous setting: both support fill and textFill,
                // stroke and textStroke.
                !elOptionStyle.hasOwnProperty("textFill") && elOptionStyle.fill && (elOptionStyle.textFill = elOptionStyle.fill);
                !elOptionStyle.hasOwnProperty("textStroke") && elOptionStyle.stroke && (elOptionStyle.textStroke = elOptionStyle.stroke);
            } // Remove unnecessary props to avoid potential problems.
            var elOptionCleaned = $838361220d284f63$var$getCleanedElOption(elOption); // For simple, do not support parent change, otherwise reorder is needed.
            if (!$action || $action === "merge") existEl ? existEl.attr(elOptionCleaned) : $838361220d284f63$var$createEl(id, targetElParent, elOptionCleaned, elMap);
            else if ($action === "replace") {
                $838361220d284f63$var$removeEl(existEl, elMap);
                $838361220d284f63$var$createEl(id, targetElParent, elOptionCleaned, elMap);
            } else if ($action === "remove") $838361220d284f63$var$removeEl(existEl, elMap);
            var el = elMap.get(id);
            if (el) {
                el.__ecGraphicWidthOption = elOption.width;
                el.__ecGraphicHeightOption = elOption.height;
                $838361220d284f63$var$setEventData(el, graphicModel, elOption);
            }
        });
    },
    /**
   * Locate graphic elements.
   *
   * @private
   * @param {Object} graphicModel graphic model
   * @param {module:echarts/ExtensionAPI} api extension API
   */ _relocate: function(graphicModel, api) {
        var elOptions = graphicModel.option.elements;
        var rootGroup = this.group;
        var elMap = this._elMap;
        var apiWidth = api.getWidth();
        var apiHeight = api.getHeight(); // Top-down to calculate percentage width/height of group
        for(var i = 0; i < elOptions.length; i++){
            var elOption = elOptions[i];
            var el = elMap.get(elOption.id);
            if (!el || !el.isGroup) continue;
            var parentEl = el.parent;
            var isParentRoot = parentEl === rootGroup; // Like 'position:absolut' in css, default 0.
            el.__ecGraphicWidth = $838361220d284f63$var$parsePercent(el.__ecGraphicWidthOption, isParentRoot ? apiWidth : parentEl.__ecGraphicWidth) || 0;
            el.__ecGraphicHeight = $838361220d284f63$var$parsePercent(el.__ecGraphicHeightOption, isParentRoot ? apiHeight : parentEl.__ecGraphicHeight) || 0;
        } // Bottom-up tranvese all elements (consider ec resize) to locate elements.
        for(var i = elOptions.length - 1; i >= 0; i--){
            var elOption = elOptions[i];
            var el = elMap.get(elOption.id);
            if (!el) continue;
            var parentEl = el.parent;
            var containerInfo = parentEl === rootGroup ? {
                width: apiWidth,
                height: apiHeight
            } : {
                width: parentEl.__ecGraphicWidth,
                height: parentEl.__ecGraphicHeight
            }; // PENDING
            // Currently, when `bounding: 'all'`, the union bounding rect of the group
            // does not include the rect of [0, 0, group.width, group.height], which
            // is probably weird for users. Should we make a break change for it?
            $ab0c9086dd6c5b39$export$74054bd96b5eeef1(el, elOption, containerInfo, null, {
                hv: elOption.hv,
                boundingMode: elOption.bounding
            });
        }
    },
    /**
   * Clear all elements.
   *
   * @private
   */ _clear: function() {
        var elMap = this._elMap;
        elMap.each(function(el) {
            $838361220d284f63$var$removeEl(el, elMap);
        });
        this._elMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4();
    },
    /**
   * @override
   */ dispose: function() {
        this._clear();
    }
});
function $838361220d284f63$var$createEl(id, targetElParent, elOption, elMap) {
    var graphicType = elOption.type;
    var Clz = $838361220d284f63$var$_nonShapeGraphicElements.hasOwnProperty(graphicType) // Those graphic elements are not shapes. They should not be
     ? $838361220d284f63$var$_nonShapeGraphicElements[graphicType] : $4b57d6b582d579b7$export$51df4b5565a58189(graphicType);
    var el = new Clz(elOption);
    targetElParent.add(el);
    elMap.set(id, el);
    el.__ecGraphicId = id;
}
function $838361220d284f63$var$removeEl(existEl, elMap) {
    var existElParent = existEl && existEl.parent;
    if (existElParent) {
        existEl.type === "group" && existEl.traverse(function(el) {
            $838361220d284f63$var$removeEl(el, elMap);
        });
        elMap.removeKey(existEl.__ecGraphicId);
        existElParent.remove(existEl);
    }
} // Remove unnecessary props to avoid potential problems.
function $838361220d284f63$var$getCleanedElOption(elOption) {
    elOption = $ec279652dd95c27b$export$8b58be045bf06082({}, elOption);
    $ec279652dd95c27b$export$79b2f7037acddd43([
        "id",
        "parentId",
        "$action",
        "hv",
        "bounding"
    ].concat($ab0c9086dd6c5b39$export$a9aa2cc018afbed), function(name) {
        delete elOption[name];
    });
    return elOption;
}
function $838361220d284f63$var$isSetLoc(obj, props) {
    var isSet;
    $ec279652dd95c27b$export$79b2f7037acddd43(props, function(prop) {
        obj[prop] != null && obj[prop] !== "auto" && (isSet = true);
    });
    return isSet;
}
function $838361220d284f63$var$setKeyInfoToNewElOption(resultItem, newElOption) {
    var existElOption = resultItem.exist; // Set id and type after id assigned.
    newElOption.id = resultItem.keyInfo.id;
    !newElOption.type && existElOption && (newElOption.type = existElOption.type); // Set parent id if not specified
    if (newElOption.parentId == null) {
        var newElParentOption = newElOption.parentOption;
        if (newElParentOption) newElOption.parentId = newElParentOption.id;
        else if (existElOption) newElOption.parentId = existElOption.parentId;
    } // Clear
    newElOption.parentOption = null;
}
function $838361220d284f63$var$mergeNewElOptionToExist(existList, index, newElOption) {
    // Update existing options, for `getOption` feature.
    var newElOptCopy = $ec279652dd95c27b$export$8b58be045bf06082({}, newElOption);
    var existElOption = existList[index];
    var $action = newElOption.$action || "merge";
    if ($action === "merge") {
        if (existElOption) {
            // We can ensure that newElOptCopy and existElOption are not
            // the same object, so `merge` will not change newElOptCopy.
            $ec279652dd95c27b$export$4950aa0f605343fb(existElOption, newElOptCopy, true); // Rigid body, use ignoreSize.
            $ab0c9086dd6c5b39$export$1754cb91f16ca028(existElOption, newElOptCopy, {
                ignoreSize: true
            }); // Will be used in render.
            $ab0c9086dd6c5b39$export$7438999faea9b6cc(newElOption, existElOption);
        } else existList[index] = newElOptCopy;
    } else if ($action === "replace") existList[index] = newElOptCopy;
    else if ($action === "remove") // null will be cleaned later.
    existElOption && (existList[index] = null);
}
function $838361220d284f63$var$setLayoutInfoToExist(existItem, newElOption) {
    if (!existItem) return;
    existItem.hv = newElOption.hv = [
        $838361220d284f63$var$isSetLoc(newElOption, [
            "left",
            "right"
        ]),
        $838361220d284f63$var$isSetLoc(newElOption, [
            "top",
            "bottom"
        ])
    ]; // Give default group size. Otherwise layout error may occur.
    if (existItem.type === "group") {
        existItem.width == null && (existItem.width = newElOption.width = 0);
        existItem.height == null && (existItem.height = newElOption.height = 0);
    }
}
function $838361220d284f63$var$setEventData(el, graphicModel, elOption) {
    var eventData = el.eventData; // Simple optimize for large amount of elements that no need event.
    if (!el.silent && !el.ignore && !eventData) eventData = el.eventData = {
        componentType: "graphic",
        componentIndex: graphicModel.componentIndex,
        name: el.name
    };
     // `elOption.info` enables user to mount some info on
    // elements and use them in event handlers.
    if (eventData) eventData.info = el.info;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $9619318ea32611b1$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $d50e8440ce792ca2$export$6503ec6e8aabbaf;
var $d50e8440ce792ca2$export$3988ae62b71be9a3;
var $d50e8440ce792ca2$var$features = {};
function $d50e8440ce792ca2$var$register(name, ctor) {
    $d50e8440ce792ca2$var$features[name] = ctor;
}
function $d50e8440ce792ca2$var$get(name) {
    return $d50e8440ce792ca2$var$features[name];
}
$d50e8440ce792ca2$export$6503ec6e8aabbaf = $d50e8440ce792ca2$var$register;
$d50e8440ce792ca2$export$3988ae62b71be9a3 = $d50e8440ce792ca2$var$get;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $9619318ea32611b1$var$ToolboxModel = $f406636b535430a7$exports.extendComponentModel({
    type: "toolbox",
    layoutMode: {
        type: "box",
        ignoreSize: true
    },
    optionUpdated: function() {
        $9619318ea32611b1$var$ToolboxModel.superApply(this, "optionUpdated", arguments);
        $ec279652dd95c27b$export$79b2f7037acddd43(this.option.feature, function(featureOpt, featureName) {
            var Feature = $d50e8440ce792ca2$export$3988ae62b71be9a3(featureName);
            Feature && $ec279652dd95c27b$export$4950aa0f605343fb(featureOpt, Feature.defaultOption);
        });
    },
    defaultOption: {
        show: true,
        z: 6,
        zlevel: 0,
        orient: "horizontal",
        left: "right",
        top: "top",
        // right
        // bottom
        backgroundColor: "transparent",
        borderColor: "#ccc",
        borderRadius: 0,
        borderWidth: 0,
        padding: 5,
        itemSize: 15,
        itemGap: 8,
        showTitle: true,
        iconStyle: {
            borderColor: "#666",
            color: "none"
        },
        emphasis: {
            iconStyle: {
                borderColor: "#3E98C5"
            }
        },
        // textStyle: {},
        // feature
        tooltip: {
            show: false
        }
    }
});
var $9619318ea32611b1$var$_default = $9619318ea32611b1$var$ToolboxModel;
$9619318ea32611b1$exports = $9619318ea32611b1$var$_default;


var $dacae16e48b4514e$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $2e73e18200bfef56$export$b3219800bda33a1f;
var $2e73e18200bfef56$export$fae23936eedfad4f;

var $2e73e18200bfef56$var$getLayoutRect = $ab0c9086dd6c5b39$export$4517a5ca639a7293;
var $2e73e18200bfef56$var$layoutBox = $ab0c9086dd6c5b39$export$827f4ee28efc37;
var $2e73e18200bfef56$var$positionElement = $ab0c9086dd6c5b39$export$74054bd96b5eeef1;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Layout list like component.
 * It will box layout each items in group of component and then position the whole group in the viewport
 * @param {module:zrender/group/Group} group
 * @param {module:echarts/model/Component} componentModel
 * @param {module:echarts/ExtensionAPI}
 */ function $2e73e18200bfef56$var$layout(group, componentModel, api) {
    var boxLayoutParams = componentModel.getBoxLayoutParams();
    var padding = componentModel.get("padding");
    var viewportSize = {
        width: api.getWidth(),
        height: api.getHeight()
    };
    var rect = $2e73e18200bfef56$var$getLayoutRect(boxLayoutParams, viewportSize, padding);
    $2e73e18200bfef56$var$layoutBox(componentModel.get("orient"), group, componentModel.get("itemGap"), rect.width, rect.height);
    $2e73e18200bfef56$var$positionElement(group, boxLayoutParams, viewportSize, padding);
}
function $2e73e18200bfef56$var$makeBackground(rect, componentModel) {
    var padding = $a4be9366aeb9fcc8$export$f3a38102c49f4268(componentModel.get("padding"));
    var style = componentModel.getItemStyle([
        "color",
        "opacity"
    ]);
    style.fill = componentModel.get("backgroundColor");
    var rect = new $4b57d6b582d579b7$export$c79fc6492f3af13d({
        shape: {
            x: rect.x - padding[3],
            y: rect.y - padding[0],
            width: rect.width + padding[1] + padding[3],
            height: rect.height + padding[0] + padding[2],
            r: componentModel.get("borderRadius")
        },
        style: style,
        silent: true,
        z2: -1
    }); // FIXME
    // `subPixelOptimizeRect` may bring some gap between edge of viewpart
    // and background rect when setting like `left: 0`, `top: 0`.
    // graphic.subPixelOptimizeRect(rect);
    return rect;
}
$2e73e18200bfef56$export$b3219800bda33a1f = $2e73e18200bfef56$var$layout;
$2e73e18200bfef56$export$fae23936eedfad4f = $2e73e18200bfef56$var$makeBackground;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $dacae16e48b4514e$var$_default = $f406636b535430a7$exports.extendComponentView({
    type: "toolbox",
    render: function(toolboxModel, ecModel, api, payload) {
        var group = this.group;
        group.removeAll();
        if (!toolboxModel.get("show")) return;
        var itemSize = +toolboxModel.get("itemSize");
        var featureOpts = toolboxModel.get("feature") || {};
        var features = this._features || (this._features = {});
        var featureNames = [];
        $ec279652dd95c27b$export$79b2f7037acddd43(featureOpts, function(opt, name) {
            featureNames.push(name);
        });
        new $8e5cd4a27af1b00f$exports(this._featureNames || [], featureNames).add(processFeature).update(processFeature).remove($ec279652dd95c27b$export$c3095a23b368d1f2(processFeature, null)).execute(); // Keep for diff.
        this._featureNames = featureNames;
        function processFeature(newIndex, oldIndex) {
            var featureName = featureNames[newIndex];
            var oldName = featureNames[oldIndex];
            var featureOpt = featureOpts[featureName];
            var featureModel = new $2b51b4bf776ec22e$exports(featureOpt, toolboxModel, toolboxModel.ecModel);
            var feature; // FIX#11236, merge feature title from MagicType newOption. TODO: consider seriesIndex ?
            if (payload && payload.newTitle != null && payload.featureName === featureName) featureOpt.title = payload.newTitle;
            if (featureName && !oldName) {
                // Create
                if ($dacae16e48b4514e$var$isUserFeatureName(featureName)) feature = {
                    model: featureModel,
                    onclick: featureModel.option.onclick,
                    featureName: featureName
                };
                else {
                    var Feature = $d50e8440ce792ca2$export$3988ae62b71be9a3(featureName);
                    if (!Feature) return;
                    feature = new Feature(featureModel, ecModel, api);
                }
                features[featureName] = feature;
            } else {
                feature = features[oldName]; // If feature does not exsit.
                if (!feature) return;
                feature.model = featureModel;
                feature.ecModel = ecModel;
                feature.api = api;
            }
            if (!featureName && oldName) {
                feature.dispose && feature.dispose(ecModel, api);
                return;
            }
            if (!featureModel.get("show") || feature.unusable) {
                feature.remove && feature.remove(ecModel, api);
                return;
            }
            createIconPaths(featureModel, feature, featureName);
            featureModel.setIconStatus = function(iconName, status) {
                var option = this.option;
                var iconPaths = this.iconPaths;
                option.iconStatus = option.iconStatus || {};
                option.iconStatus[iconName] = status; // FIXME
                iconPaths[iconName] && iconPaths[iconName].trigger(status);
            };
            if (feature.render) feature.render(featureModel, ecModel, api, payload);
        }
        function createIconPaths(featureModel, feature, featureName) {
            var iconStyleModel = featureModel.getModel("iconStyle");
            var iconStyleEmphasisModel = featureModel.getModel("emphasis.iconStyle"); // If one feature has mutiple icon. they are orginaized as
            // {
            //     icon: {
            //         foo: '',
            //         bar: ''
            //     },
            //     title: {
            //         foo: '',
            //         bar: ''
            //     }
            // }
            var icons = feature.getIcons ? feature.getIcons() : featureModel.get("icon");
            var titles = featureModel.get("title") || {};
            if (typeof icons === "string") {
                var icon = icons;
                var title = titles;
                icons = {};
                titles = {};
                icons[featureName] = icon;
                titles[featureName] = title;
            }
            var iconPaths = featureModel.iconPaths = {};
            $ec279652dd95c27b$export$79b2f7037acddd43(icons, function(iconStr, iconName) {
                var path = $4b57d6b582d579b7$export$274edc73af1ae9c8(iconStr, {}, {
                    x: -itemSize / 2,
                    y: -itemSize / 2,
                    width: itemSize,
                    height: itemSize
                });
                path.setStyle(iconStyleModel.getItemStyle());
                path.hoverStyle = iconStyleEmphasisModel.getItemStyle(); // Text position calculation
                path.setStyle({
                    text: titles[iconName],
                    textAlign: iconStyleEmphasisModel.get("textAlign"),
                    textBorderRadius: iconStyleEmphasisModel.get("textBorderRadius"),
                    textPadding: iconStyleEmphasisModel.get("textPadding"),
                    textFill: null
                });
                var tooltipModel = toolboxModel.getModel("tooltip");
                if (tooltipModel && tooltipModel.get("show")) path.attr("tooltip", $ec279652dd95c27b$export$8b58be045bf06082({
                    content: titles[iconName],
                    formatter: tooltipModel.get("formatter", true) || function() {
                        return titles[iconName];
                    },
                    formatterParams: {
                        componentType: "toolbox",
                        name: iconName,
                        title: titles[iconName],
                        $vars: [
                            "name",
                            "title"
                        ]
                    },
                    position: tooltipModel.get("position", true) || "bottom"
                }, tooltipModel.option));
                $4b57d6b582d579b7$export$28b42df8183f218c(path);
                if (toolboxModel.get("showTitle")) {
                    path.__title = titles[iconName];
                    path.on("mouseover", function() {
                        // Should not reuse above hoverStyle, which might be modified.
                        var hoverStyle = iconStyleEmphasisModel.getItemStyle();
                        var defaultTextPosition = toolboxModel.get("orient") === "vertical" ? toolboxModel.get("right") == null ? "right" : "left" : toolboxModel.get("bottom") == null ? "bottom" : "top";
                        path.setStyle({
                            textFill: iconStyleEmphasisModel.get("textFill") || hoverStyle.fill || hoverStyle.stroke || "#000",
                            textBackgroundColor: iconStyleEmphasisModel.get("textBackgroundColor"),
                            textPosition: iconStyleEmphasisModel.get("textPosition") || defaultTextPosition
                        });
                    }).on("mouseout", function() {
                        path.setStyle({
                            textFill: null,
                            textBackgroundColor: null
                        });
                    });
                }
                path.trigger(featureModel.get("iconStatus." + iconName) || "normal");
                group.add(path);
                path.on("click", $ec279652dd95c27b$export$2385a24977818dd0(feature.onclick, feature, ecModel, api, iconName));
                iconPaths[iconName] = path;
            });
        }
        $2e73e18200bfef56$export$b3219800bda33a1f(group, toolboxModel, api); // Render background after group is layout
        // FIXME
        group.add($2e73e18200bfef56$export$fae23936eedfad4f(group.getBoundingRect(), toolboxModel)); // Adjust icon title positions to avoid them out of screen
        group.eachChild(function(icon) {
            var titleText = icon.__title;
            var hoverStyle = icon.hoverStyle; // May be background element
            if (hoverStyle && titleText) {
                var rect = $ebae9c4ebc22906c$export$c381147bfed79d9f(titleText, $ebae9c4ebc22906c$export$624ea4f0c38e70fc(hoverStyle));
                var offsetX = icon.position[0] + group.position[0];
                var offsetY = icon.position[1] + group.position[1] + itemSize;
                var needPutOnTop = false;
                if (offsetY + rect.height > api.getHeight()) {
                    hoverStyle.textPosition = "top";
                    needPutOnTop = true;
                }
                var topOffset = needPutOnTop ? -5 - rect.height : itemSize + 8;
                if (offsetX + rect.width / 2 > api.getWidth()) {
                    hoverStyle.textPosition = [
                        "100%",
                        topOffset
                    ];
                    hoverStyle.textAlign = "right";
                } else if (offsetX - rect.width / 2 < 0) {
                    hoverStyle.textPosition = [
                        0,
                        topOffset
                    ];
                    hoverStyle.textAlign = "left";
                }
            }
        });
    },
    updateView: function(toolboxModel, ecModel, api, payload) {
        $ec279652dd95c27b$export$79b2f7037acddd43(this._features, function(feature) {
            feature.updateView && feature.updateView(feature.model, ecModel, api, payload);
        });
    },
    // updateLayout: function (toolboxModel, ecModel, api, payload) {
    //     zrUtil.each(this._features, function (feature) {
    //         feature.updateLayout && feature.updateLayout(feature.model, ecModel, api, payload);
    //     });
    // },
    remove: function(ecModel, api) {
        $ec279652dd95c27b$export$79b2f7037acddd43(this._features, function(feature) {
            feature.remove && feature.remove(ecModel, api);
        });
        this.group.removeAll();
    },
    dispose: function(ecModel, api) {
        $ec279652dd95c27b$export$79b2f7037acddd43(this._features, function(feature) {
            feature.dispose && feature.dispose(ecModel, api);
        });
    }
});
function $dacae16e48b4514e$var$isUserFeatureName(featureName) {
    return featureName.indexOf("my") === 0;
}
$dacae16e48b4514e$exports = $dacae16e48b4514e$var$_default;


var $155811bbfdd6a8d0$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Uint8Array */ var $155811bbfdd6a8d0$var$saveAsImageLang = $136ae13721f5e257$exports.toolbox.saveAsImage;
function $155811bbfdd6a8d0$var$SaveAsImage(model) {
    this.model = model;
}
$155811bbfdd6a8d0$var$SaveAsImage.defaultOption = {
    show: true,
    icon: "M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0",
    title: $155811bbfdd6a8d0$var$saveAsImageLang.title,
    type: "png",
    // Default use option.backgroundColor
    // backgroundColor: '#fff',
    connectedBackgroundColor: "#fff",
    name: "",
    excludeComponents: [
        "toolbox"
    ],
    pixelRatio: 1,
    lang: $155811bbfdd6a8d0$var$saveAsImageLang.lang.slice()
};
$155811bbfdd6a8d0$var$SaveAsImage.prototype.unusable = !$27ac1413ecc67076$exports.canvasSupported;
var $155811bbfdd6a8d0$var$proto = $155811bbfdd6a8d0$var$SaveAsImage.prototype;
$155811bbfdd6a8d0$var$proto.onclick = function(ecModel, api) {
    var model = this.model;
    var title = model.get("name") || ecModel.get("title.0.text") || "echarts";
    var isSvg = api.getZr().painter.getType() === "svg";
    var type = isSvg ? "svg" : model.get("type", true) || "png";
    var url = api.getConnectedDataURL({
        type: type,
        backgroundColor: model.get("backgroundColor", true) || ecModel.get("backgroundColor") || "#fff",
        connectedBackgroundColor: model.get("connectedBackgroundColor"),
        excludeComponents: model.get("excludeComponents"),
        pixelRatio: model.get("pixelRatio")
    }); // Chrome and Firefox
    if (typeof MouseEvent === "function" && !$27ac1413ecc67076$exports.browser.ie && !$27ac1413ecc67076$exports.browser.edge) {
        var $a = document.createElement("a");
        $a.download = title + "." + type;
        $a.target = "_blank";
        $a.href = url;
        var evt = new MouseEvent("click", {
            // some micro front-end framework， window maybe is a Proxy
            view: document.defaultView,
            bubbles: true,
            cancelable: false
        });
        $a.dispatchEvent(evt);
    } else if (window.navigator.msSaveOrOpenBlob) {
        var bstr = atob(url.split(",")[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);
        while(n--)u8arr[n] = bstr.charCodeAt(n);
        var blob = new Blob([
            u8arr
        ]);
        window.navigator.msSaveOrOpenBlob(blob, title + "." + type);
    } else {
        var lang = model.get("lang");
        var html = '<body style="margin:0;"><img src="' + url + '" style="max-width:100%;" title="' + (lang && lang[0] || "") + '" />' + "</body>";
        var tab = window.open();
        tab.document.write(html);
    }
};
$d50e8440ce792ca2$export$6503ec6e8aabbaf("saveAsImage", $155811bbfdd6a8d0$var$SaveAsImage);
var $155811bbfdd6a8d0$var$_default = $155811bbfdd6a8d0$var$SaveAsImage;
$155811bbfdd6a8d0$exports = $155811bbfdd6a8d0$var$_default;


var $0cf5826521c95460$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $0cf5826521c95460$var$magicTypeLang = $136ae13721f5e257$exports.toolbox.magicType;
var $0cf5826521c95460$var$INNER_STACK_KEYWORD = "__ec_magicType_stack__";
function $0cf5826521c95460$var$MagicType(model) {
    this.model = model;
}
$0cf5826521c95460$var$MagicType.defaultOption = {
    show: true,
    type: [],
    // Icon group
    icon: {
        /* eslint-disable */ line: "M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4",
        bar: "M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7",
        stack: "M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z" // jshint ignore:line
    },
    // `line`, `bar`, `stack`, `tiled`
    title: $ec279652dd95c27b$export$9cd59f9826255e47($0cf5826521c95460$var$magicTypeLang.title),
    option: {},
    seriesIndex: {}
};
var $0cf5826521c95460$var$proto = $0cf5826521c95460$var$MagicType.prototype;
$0cf5826521c95460$var$proto.getIcons = function() {
    var model = this.model;
    var availableIcons = model.get("icon");
    var icons = {};
    $ec279652dd95c27b$export$79b2f7037acddd43(model.get("type"), function(type) {
        if (availableIcons[type]) icons[type] = availableIcons[type];
    });
    return icons;
};
var $0cf5826521c95460$var$seriesOptGenreator = {
    "line": function(seriesType, seriesId, seriesModel, model) {
        if (seriesType === "bar") return $ec279652dd95c27b$export$4950aa0f605343fb({
            id: seriesId,
            type: "line",
            // Preserve data related option
            data: seriesModel.get("data"),
            stack: seriesModel.get("stack"),
            markPoint: seriesModel.get("markPoint"),
            markLine: seriesModel.get("markLine")
        }, model.get("option.line") || {}, true);
    },
    "bar": function(seriesType, seriesId, seriesModel, model) {
        if (seriesType === "line") return $ec279652dd95c27b$export$4950aa0f605343fb({
            id: seriesId,
            type: "bar",
            // Preserve data related option
            data: seriesModel.get("data"),
            stack: seriesModel.get("stack"),
            markPoint: seriesModel.get("markPoint"),
            markLine: seriesModel.get("markLine")
        }, model.get("option.bar") || {}, true);
    },
    "stack": function(seriesType, seriesId, seriesModel, model) {
        var isStack = seriesModel.get("stack") === $0cf5826521c95460$var$INNER_STACK_KEYWORD;
        if (seriesType === "line" || seriesType === "bar") {
            model.setIconStatus("stack", isStack ? "normal" : "emphasis");
            return $ec279652dd95c27b$export$4950aa0f605343fb({
                id: seriesId,
                stack: isStack ? "" : $0cf5826521c95460$var$INNER_STACK_KEYWORD
            }, model.get("option.stack") || {}, true);
        }
    }
};
var $0cf5826521c95460$var$radioTypes = [
    [
        "line",
        "bar"
    ],
    [
        "stack"
    ]
];
$0cf5826521c95460$var$proto.onclick = function(ecModel, api, type) {
    var model = this.model;
    var seriesIndex = model.get("seriesIndex." + type); // Not supported magicType
    if (!$0cf5826521c95460$var$seriesOptGenreator[type]) return;
    var newOption = {
        series: []
    };
    var generateNewSeriesTypes = function(seriesModel) {
        var seriesType = seriesModel.subType;
        var seriesId = seriesModel.id;
        var newSeriesOpt = $0cf5826521c95460$var$seriesOptGenreator[type](seriesType, seriesId, seriesModel, model);
        if (newSeriesOpt) {
            // PENDING If merge original option?
            $ec279652dd95c27b$export$ebe90cb607ad99e(newSeriesOpt, seriesModel.option);
            newOption.series.push(newSeriesOpt);
        } // Modify boundaryGap
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.type === "cartesian2d" && (type === "line" || type === "bar")) {
            var categoryAxis = coordSys.getAxesByScale("ordinal")[0];
            if (categoryAxis) {
                var axisDim = categoryAxis.dim;
                var axisType = axisDim + "Axis";
                var axisModel = ecModel.queryComponents({
                    mainType: axisType,
                    index: seriesModel.get(name + "Index"),
                    id: seriesModel.get(name + "Id")
                })[0];
                var axisIndex = axisModel.componentIndex;
                newOption[axisType] = newOption[axisType] || [];
                for(var i = 0; i <= axisIndex; i++)newOption[axisType][axisIndex] = newOption[axisType][axisIndex] || {};
                newOption[axisType][axisIndex].boundaryGap = type === "bar";
            }
        }
    };
    $ec279652dd95c27b$export$79b2f7037acddd43($0cf5826521c95460$var$radioTypes, function(radio) {
        if ($ec279652dd95c27b$export$305f7d4e9d4624f2(radio, type) >= 0) $ec279652dd95c27b$export$79b2f7037acddd43(radio, function(item) {
            model.setIconStatus(item, "normal");
        });
    });
    model.setIconStatus(type, "emphasis");
    ecModel.eachComponent({
        mainType: "series",
        query: seriesIndex == null ? null : {
            seriesIndex: seriesIndex
        }
    }, generateNewSeriesTypes);
    var newTitle; // Change title of stack
    if (type === "stack") {
        var isStack = newOption.series && newOption.series[0] && newOption.series[0].stack === $0cf5826521c95460$var$INNER_STACK_KEYWORD;
        newTitle = isStack ? $ec279652dd95c27b$export$4950aa0f605343fb({
            stack: $0cf5826521c95460$var$magicTypeLang.title.tiled
        }, $0cf5826521c95460$var$magicTypeLang.title) : $ec279652dd95c27b$export$9cd59f9826255e47($0cf5826521c95460$var$magicTypeLang.title);
    }
    api.dispatchAction({
        type: "changeMagicType",
        currentType: type,
        newOption: newOption,
        newTitle: newTitle,
        featureName: "magicType"
    });
};
$f406636b535430a7$exports.registerAction({
    type: "changeMagicType",
    event: "magicTypeChanged",
    update: "prepareAndUpdate"
}, function(payload, ecModel) {
    ecModel.mergeOption(payload.newOption);
});
$d50e8440ce792ca2$export$6503ec6e8aabbaf("magicType", $0cf5826521c95460$var$MagicType);
var $0cf5826521c95460$var$_default = $0cf5826521c95460$var$MagicType;
$0cf5826521c95460$exports = $0cf5826521c95460$var$_default;


var $e459ec7d71842ceb$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $e459ec7d71842ceb$var$dataViewLang = $136ae13721f5e257$exports.toolbox.dataView;
var $e459ec7d71842ceb$var$BLOCK_SPLITER = new Array(60).join("-");
var $e459ec7d71842ceb$var$ITEM_SPLITER = "	";
/**
 * Group series into two types
 *  1. on category axis, like line, bar
 *  2. others, like scatter, pie
 * @param {module:echarts/model/Global} ecModel
 * @return {Object}
 * @inner
 */ function $e459ec7d71842ceb$var$groupSeries(ecModel) {
    var seriesGroupByCategoryAxis = {};
    var otherSeries = [];
    var meta = [];
    ecModel.eachRawSeries(function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && (coordSys.type === "cartesian2d" || coordSys.type === "polar")) {
            var baseAxis = coordSys.getBaseAxis();
            if (baseAxis.type === "category") {
                var key = baseAxis.dim + "_" + baseAxis.index;
                if (!seriesGroupByCategoryAxis[key]) {
                    seriesGroupByCategoryAxis[key] = {
                        categoryAxis: baseAxis,
                        valueAxis: coordSys.getOtherAxis(baseAxis),
                        series: []
                    };
                    meta.push({
                        axisDim: baseAxis.dim,
                        axisIndex: baseAxis.index
                    });
                }
                seriesGroupByCategoryAxis[key].series.push(seriesModel);
            } else otherSeries.push(seriesModel);
        } else otherSeries.push(seriesModel);
    });
    return {
        seriesGroupByCategoryAxis: seriesGroupByCategoryAxis,
        other: otherSeries,
        meta: meta
    };
}
/**
 * Assemble content of series on cateogory axis
 * @param {Array.<module:echarts/model/Series>} series
 * @return {string}
 * @inner
 */ function $e459ec7d71842ceb$var$assembleSeriesWithCategoryAxis(series) {
    var tables = [];
    $ec279652dd95c27b$export$79b2f7037acddd43(series, function(group, key) {
        var categoryAxis = group.categoryAxis;
        var valueAxis = group.valueAxis;
        var valueAxisDim = valueAxis.dim;
        var headers = [
            " "
        ].concat($ec279652dd95c27b$export$871de8747c9eaa88(group.series, function(series) {
            return series.name;
        }));
        var columns = [
            categoryAxis.model.getCategories()
        ];
        $ec279652dd95c27b$export$79b2f7037acddd43(group.series, function(series) {
            var rawData = series.getRawData();
            columns.push(series.getRawData().mapArray(rawData.mapDimension(valueAxisDim), function(val) {
                return val;
            }));
        }); // Assemble table content
        var lines = [
            headers.join($e459ec7d71842ceb$var$ITEM_SPLITER)
        ];
        for(var i = 0; i < columns[0].length; i++){
            var items = [];
            for(var j = 0; j < columns.length; j++)items.push(columns[j][i]);
            lines.push(items.join($e459ec7d71842ceb$var$ITEM_SPLITER));
        }
        tables.push(lines.join("\n"));
    });
    return tables.join("\n\n" + $e459ec7d71842ceb$var$BLOCK_SPLITER + "\n\n");
}
/**
 * Assemble content of other series
 * @param {Array.<module:echarts/model/Series>} series
 * @return {string}
 * @inner
 */ function $e459ec7d71842ceb$var$assembleOtherSeries(series) {
    return $ec279652dd95c27b$export$871de8747c9eaa88(series, function(series) {
        var data = series.getRawData();
        var lines = [
            series.name
        ];
        var vals = [];
        data.each(data.dimensions, function() {
            var argLen = arguments.length;
            var dataIndex = arguments[argLen - 1];
            var name = data.getName(dataIndex);
            for(var i = 0; i < argLen - 1; i++)vals[i] = arguments[i];
            lines.push((name ? name + $e459ec7d71842ceb$var$ITEM_SPLITER : "") + vals.join($e459ec7d71842ceb$var$ITEM_SPLITER));
        });
        return lines.join("\n");
    }).join("\n\n" + $e459ec7d71842ceb$var$BLOCK_SPLITER + "\n\n");
}
/**
 * @param {module:echarts/model/Global}
 * @return {Object}
 * @inner
 */ function $e459ec7d71842ceb$var$getContentFromModel(ecModel) {
    var result = $e459ec7d71842ceb$var$groupSeries(ecModel);
    return {
        value: $ec279652dd95c27b$export$3dea766d36a8935f([
            $e459ec7d71842ceb$var$assembleSeriesWithCategoryAxis(result.seriesGroupByCategoryAxis),
            $e459ec7d71842ceb$var$assembleOtherSeries(result.other)
        ], function(str) {
            return str.replace(/[\n\t\s]/g, "");
        }).join("\n\n" + $e459ec7d71842ceb$var$BLOCK_SPLITER + "\n\n"),
        meta: result.meta
    };
}
function $e459ec7d71842ceb$var$trim(str) {
    return str.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
/**
 * If a block is tsv format
 */ function $e459ec7d71842ceb$var$isTSVFormat(block) {
    // Simple method to find out if a block is tsv format
    var firstLine = block.slice(0, block.indexOf("\n"));
    if (firstLine.indexOf($e459ec7d71842ceb$var$ITEM_SPLITER) >= 0) return true;
}
var $e459ec7d71842ceb$var$itemSplitRegex = new RegExp("[" + $e459ec7d71842ceb$var$ITEM_SPLITER + "]+", "g");
/**
 * @param {string} tsv
 * @return {Object}
 */ function $e459ec7d71842ceb$var$parseTSVContents(tsv) {
    var tsvLines = tsv.split(/\n+/g);
    var headers = $e459ec7d71842ceb$var$trim(tsvLines.shift()).split($e459ec7d71842ceb$var$itemSplitRegex);
    var categories = [];
    var series = $ec279652dd95c27b$export$871de8747c9eaa88(headers, function(header) {
        return {
            name: header,
            data: []
        };
    });
    for(var i = 0; i < tsvLines.length; i++){
        var items = $e459ec7d71842ceb$var$trim(tsvLines[i]).split($e459ec7d71842ceb$var$itemSplitRegex);
        categories.push(items.shift());
        for(var j = 0; j < items.length; j++)series[j] && (series[j].data[i] = items[j]);
    }
    return {
        series: series,
        categories: categories
    };
}
/**
 * @param {string} str
 * @return {Array.<Object>}
 * @inner
 */ function $e459ec7d71842ceb$var$parseListContents(str) {
    var lines = str.split(/\n+/g);
    var seriesName = $e459ec7d71842ceb$var$trim(lines.shift());
    var data = [];
    for(var i = 0; i < lines.length; i++){
        // if line is empty, ignore it.
        // there is a case that a user forgot to delete `\n`.
        var line = $e459ec7d71842ceb$var$trim(lines[i]);
        if (!line) continue;
        var items = line.split($e459ec7d71842ceb$var$itemSplitRegex);
        var name = "";
        var value;
        var hasName = false;
        if (isNaN(items[0])) {
            // First item is name
            hasName = true;
            name = items[0];
            items = items.slice(1);
            data[i] = {
                name: name,
                value: []
            };
            value = data[i].value;
        } else value = data[i] = [];
        for(var j = 0; j < items.length; j++)value.push(+items[j]);
        if (value.length === 1) hasName ? data[i].value = value[0] : data[i] = value[0];
    }
    return {
        name: seriesName,
        data: data
    };
}
/**
 * @param {string} str
 * @param {Array.<Object>} blockMetaList
 * @return {Object}
 * @inner
 */ function $e459ec7d71842ceb$var$parseContents(str, blockMetaList) {
    var blocks = str.split(new RegExp("\n*" + $e459ec7d71842ceb$var$BLOCK_SPLITER + "\n*", "g"));
    var newOption = {
        series: []
    };
    $ec279652dd95c27b$export$79b2f7037acddd43(blocks, function(block, idx) {
        if ($e459ec7d71842ceb$var$isTSVFormat(block)) {
            var result = $e459ec7d71842ceb$var$parseTSVContents(block);
            var blockMeta = blockMetaList[idx];
            var axisKey = blockMeta.axisDim + "Axis";
            if (blockMeta) {
                newOption[axisKey] = newOption[axisKey] || [];
                newOption[axisKey][blockMeta.axisIndex] = {
                    data: result.categories
                };
                newOption.series = newOption.series.concat(result.series);
            }
        } else {
            var result = $e459ec7d71842ceb$var$parseListContents(block);
            newOption.series.push(result);
        }
    });
    return newOption;
}
/**
 * @alias {module:echarts/component/toolbox/feature/DataView}
 * @constructor
 * @param {module:echarts/model/Model} model
 */ function $e459ec7d71842ceb$var$DataView(model) {
    this._dom = null;
    this.model = model;
}
$e459ec7d71842ceb$var$DataView.defaultOption = {
    show: true,
    readOnly: false,
    optionToContent: null,
    contentToOption: null,
    icon: "M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28",
    title: $ec279652dd95c27b$export$9cd59f9826255e47($e459ec7d71842ceb$var$dataViewLang.title),
    lang: $ec279652dd95c27b$export$9cd59f9826255e47($e459ec7d71842ceb$var$dataViewLang.lang),
    backgroundColor: "#fff",
    textColor: "#000",
    textareaColor: "#fff",
    textareaBorderColor: "#333",
    buttonColor: "#c23531",
    buttonTextColor: "#fff"
};
$e459ec7d71842ceb$var$DataView.prototype.onclick = function(ecModel, api) {
    var container = api.getDom();
    var model = this.model;
    if (this._dom) container.removeChild(this._dom);
    var root = document.createElement("div");
    root.style.cssText = "position:absolute;left:5px;top:5px;bottom:5px;right:5px;";
    root.style.backgroundColor = model.get("backgroundColor") || "#fff"; // Create elements
    var header = document.createElement("h4");
    var lang = model.get("lang") || [];
    header.innerHTML = lang[0] || model.get("title");
    header.style.cssText = "margin: 10px 20px;";
    header.style.color = model.get("textColor");
    var viewMain = document.createElement("div");
    var textarea = document.createElement("textarea");
    viewMain.style.cssText = "display:block;width:100%;overflow:auto;";
    var optionToContent = model.get("optionToContent");
    var contentToOption = model.get("contentToOption");
    var result = $e459ec7d71842ceb$var$getContentFromModel(ecModel);
    if (typeof optionToContent === "function") {
        var htmlOrDom = optionToContent(api.getOption());
        if (typeof htmlOrDom === "string") viewMain.innerHTML = htmlOrDom;
        else if ($ec279652dd95c27b$export$9f57505b7bd8dae(htmlOrDom)) viewMain.appendChild(htmlOrDom);
    } else {
        // Use default textarea
        viewMain.appendChild(textarea);
        textarea.readOnly = model.get("readOnly");
        textarea.style.cssText = "width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;";
        textarea.style.color = model.get("textColor");
        textarea.style.borderColor = model.get("textareaBorderColor");
        textarea.style.backgroundColor = model.get("textareaColor");
        textarea.value = result.value;
    }
    var blockMetaList = result.meta;
    var buttonContainer = document.createElement("div");
    buttonContainer.style.cssText = "position:absolute;bottom:0;left:0;right:0;";
    var buttonStyle = "float:right;margin-right:20px;border:none;cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px";
    var closeButton = document.createElement("div");
    var refreshButton = document.createElement("div");
    buttonStyle += ";background-color:" + model.get("buttonColor");
    buttonStyle += ";color:" + model.get("buttonTextColor");
    var self = this;
    function close() {
        container.removeChild(root);
        self._dom = null;
    }
    $adca58e5ac25631a$export$3f65cefe8380dbea(closeButton, "click", close);
    $adca58e5ac25631a$export$3f65cefe8380dbea(refreshButton, "click", function() {
        var newOption;
        try {
            if (typeof contentToOption === "function") newOption = contentToOption(viewMain, api.getOption());
            else newOption = $e459ec7d71842ceb$var$parseContents(textarea.value, blockMetaList);
        } catch (e) {
            close();
            throw new Error("Data view format error " + e);
        }
        if (newOption) api.dispatchAction({
            type: "changeDataView",
            newOption: newOption
        });
        close();
    });
    closeButton.innerHTML = lang[1];
    refreshButton.innerHTML = lang[2];
    refreshButton.style.cssText = buttonStyle;
    closeButton.style.cssText = buttonStyle;
    !model.get("readOnly") && buttonContainer.appendChild(refreshButton);
    buttonContainer.appendChild(closeButton);
    root.appendChild(header);
    root.appendChild(viewMain);
    root.appendChild(buttonContainer);
    viewMain.style.height = container.clientHeight - 80 + "px";
    container.appendChild(root);
    this._dom = root;
};
$e459ec7d71842ceb$var$DataView.prototype.remove = function(ecModel, api) {
    this._dom && api.getDom().removeChild(this._dom);
};
$e459ec7d71842ceb$var$DataView.prototype.dispose = function(ecModel, api) {
    this.remove(ecModel, api);
};
/**
 * @inner
 */ function $e459ec7d71842ceb$var$tryMergeDataOption(newData, originalData) {
    return $ec279652dd95c27b$export$871de8747c9eaa88(newData, function(newVal, idx) {
        var original = originalData && originalData[idx];
        if ($ec279652dd95c27b$export$a6cdc56e425d0d0a(original) && !$ec279652dd95c27b$export$43bee75e5e14138e(original)) {
            var newValIsObject = $ec279652dd95c27b$export$a6cdc56e425d0d0a(newVal) && !$ec279652dd95c27b$export$43bee75e5e14138e(newVal);
            if (!newValIsObject) newVal = {
                value: newVal
            };
             // original data has name but new data has no name
            var shouldDeleteName = original.name != null && newVal.name == null; // Original data has option
            newVal = $ec279652dd95c27b$export$ebe90cb607ad99e(newVal, original);
            shouldDeleteName && delete newVal.name;
            return newVal;
        } else return newVal;
    });
}
$d50e8440ce792ca2$export$6503ec6e8aabbaf("dataView", $e459ec7d71842ceb$var$DataView);
$f406636b535430a7$exports.registerAction({
    type: "changeDataView",
    event: "dataViewChanged",
    update: "prepareAndUpdate"
}, function(payload, ecModel) {
    var newSeriesOptList = [];
    $ec279652dd95c27b$export$79b2f7037acddd43(payload.newOption.series, function(seriesOpt) {
        var seriesModel = ecModel.getSeriesByName(seriesOpt.name)[0];
        if (!seriesModel) // New created series
        // Geuss the series type
        newSeriesOptList.push($ec279652dd95c27b$export$8b58be045bf06082({
            // Default is scatter
            type: "scatter"
        }, seriesOpt));
        else {
            var originalData = seriesModel.get("data");
            newSeriesOptList.push({
                name: seriesOpt.name,
                data: $e459ec7d71842ceb$var$tryMergeDataOption(seriesOpt.data, originalData)
            });
        }
    });
    ecModel.mergeOption($ec279652dd95c27b$export$ebe90cb607ad99e({
        series: newSeriesOptList
    }, payload.newOption));
});
var $e459ec7d71842ceb$var$_default = $e459ec7d71842ceb$var$DataView;
$e459ec7d71842ceb$exports = $e459ec7d71842ceb$var$_default;


var $643b599947e36d1f$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $0f8d0342fd643dbc$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $0f8d0342fd643dbc$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $0f8d0342fd643dbc$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $0f8d0342fd643dbc$var$indexOf = $ec279652dd95c27b$export$305f7d4e9d4624f2;
var $0f8d0342fd643dbc$var$curry = $ec279652dd95c27b$export$c3095a23b368d1f2;
var $0f8d0342fd643dbc$var$COORD_CONVERTS = [
    "dataToPoint",
    "pointToData"
]; // FIXME
// how to genarialize to more coordinate systems.
var $0f8d0342fd643dbc$var$INCLUDE_FINDER_MAIN_TYPES = [
    "grid",
    "xAxis",
    "yAxis",
    "geo",
    "graph",
    "polar",
    "radiusAxis",
    "angleAxis",
    "bmap"
];
/**
 * [option in constructor]:
 * {
 *     Index/Id/Name of geo, xAxis, yAxis, grid: See util/model#parseFinder.
 * }
 *
 *
 * [targetInfo]:
 *
 * There can be multiple axes in a single targetInfo. Consider the case
 * of `grid` component, a targetInfo represents a grid which contains one or more
 * cartesian and one or more axes. And consider the case of parallel system,
 * which has multiple axes in a coordinate system.
 * Can be {
 *     panelId: ...,
 *     coordSys: <a representitive cartesian in grid (first cartesian by default)>,
 *     coordSyses: all cartesians.
 *     gridModel: <grid component>
 *     xAxes: correspond to coordSyses on index
 *     yAxes: correspond to coordSyses on index
 * }
 * or {
 *     panelId: ...,
 *     coordSys: <geo coord sys>
 *     coordSyses: [<geo coord sys>]
 *     geoModel: <geo component>
 * }
 *
 *
 * [panelOpt]:
 *
 * Make from targetInfo. Input to BrushController.
 * {
 *     panelId: ...,
 *     rect: ...
 * }
 *
 *
 * [area]:
 *
 * Generated by BrushController or user input.
 * {
 *     panelId: Used to locate coordInfo directly. If user inpput, no panelId.
 *     brushType: determine how to convert to/from coord('rect' or 'polygon' or 'lineX/Y').
 *     Index/Id/Name of geo, xAxis, yAxis, grid: See util/model#parseFinder.
 *     range: pixel range.
 *     coordRange: representitive coord range (the first one of coordRanges).
 *     coordRanges: <Array> coord ranges, used in multiple cartesian in one grid.
 * }
 */ /**
 * @param {Object} option contains Index/Id/Name of xAxis/yAxis/geo/grid
 *        Each can be {number|Array.<number>}. like: {xAxisIndex: [3, 4]}
 * @param {module:echarts/model/Global} ecModel
 * @param {Object} [opt]
 * @param {Array.<string>} [opt.include] include coordinate system types.
 */ function $0f8d0342fd643dbc$var$BrushTargetManager(option, ecModel, opt) {
    /**
   * @private
   * @type {Array.<Object>}
   */ var targetInfoList = this._targetInfoList = [];
    var info = {};
    var foundCpts = $0f8d0342fd643dbc$var$parseFinder(ecModel, option);
    $0f8d0342fd643dbc$var$each($0f8d0342fd643dbc$var$targetInfoBuilders, function(builder, type) {
        if (!opt || !opt.include || $0f8d0342fd643dbc$var$indexOf(opt.include, type) >= 0) builder(foundCpts, targetInfoList, info);
    });
}
var $0f8d0342fd643dbc$var$proto = $0f8d0342fd643dbc$var$BrushTargetManager.prototype;
$0f8d0342fd643dbc$var$proto.setOutputRanges = function(areas, ecModel) {
    this.matchOutputRanges(areas, ecModel, function(area, coordRange, coordSys) {
        (area.coordRanges || (area.coordRanges = [])).push(coordRange); // area.coordRange is the first of area.coordRanges
        if (!area.coordRange) {
            area.coordRange = coordRange; // In 'category' axis, coord to pixel is not reversible, so we can not
            // rebuild range by coordRange accrately, which may bring trouble when
            // brushing only one item. So we use __rangeOffset to rebuilding range
            // by coordRange. And this it only used in brush component so it is no
            // need to be adapted to coordRanges.
            var result = $0f8d0342fd643dbc$var$coordConvert[area.brushType](0, coordSys, coordRange);
            area.__rangeOffset = {
                offset: $0f8d0342fd643dbc$var$diffProcessor[area.brushType](result.values, area.range, [
                    1,
                    1
                ]),
                xyMinMax: result.xyMinMax
            };
        }
    });
};
$0f8d0342fd643dbc$var$proto.matchOutputRanges = function(areas, ecModel, cb) {
    $0f8d0342fd643dbc$var$each(areas, function(area) {
        var targetInfo = this.findTargetInfo(area, ecModel);
        if (targetInfo && targetInfo !== true) $ec279652dd95c27b$export$79b2f7037acddd43(targetInfo.coordSyses, function(coordSys) {
            var result = $0f8d0342fd643dbc$var$coordConvert[area.brushType](1, coordSys, area.range);
            cb(area, result.values, coordSys, ecModel);
        });
    }, this);
};
$0f8d0342fd643dbc$var$proto.setInputRanges = function(areas, ecModel) {
    $0f8d0342fd643dbc$var$each(areas, function(area) {
        var targetInfo = this.findTargetInfo(area, ecModel);
        area.range = area.range || []; // convert coordRange to global range and set panelId.
        if (targetInfo && targetInfo !== true) {
            area.panelId = targetInfo.panelId; // (1) area.range shoule always be calculate from coordRange but does
            // not keep its original value, for the sake of the dataZoom scenario,
            // where area.coordRange remains unchanged but area.range may be changed.
            // (2) Only support converting one coordRange to pixel range in brush
            // component. So do not consider `coordRanges`.
            // (3) About __rangeOffset, see comment above.
            var result = $0f8d0342fd643dbc$var$coordConvert[area.brushType](0, targetInfo.coordSys, area.coordRange);
            var rangeOffset = area.__rangeOffset;
            area.range = rangeOffset ? $0f8d0342fd643dbc$var$diffProcessor[area.brushType](result.values, rangeOffset.offset, $0f8d0342fd643dbc$var$getScales(result.xyMinMax, rangeOffset.xyMinMax)) : result.values;
        }
    }, this);
};
$0f8d0342fd643dbc$var$proto.makePanelOpts = function(api, getDefaultBrushType) {
    return $ec279652dd95c27b$export$871de8747c9eaa88(this._targetInfoList, function(targetInfo) {
        var rect = targetInfo.getPanelRect();
        return {
            panelId: targetInfo.panelId,
            defaultBrushType: getDefaultBrushType && getDefaultBrushType(targetInfo),
            clipPath: $bc32eea3d1412e03$export$fee17964a62a87a7(rect),
            isTargetByCursor: $bc32eea3d1412e03$export$e63e66b3b18aa99f(rect, api, targetInfo.coordSysModel),
            getLinearBrushOtherExtent: $bc32eea3d1412e03$export$7280070e90fad7a0(rect)
        };
    });
};
$0f8d0342fd643dbc$var$proto.controlSeries = function(area, seriesModel, ecModel) {
    // Check whether area is bound in coord, and series do not belong to that coord.
    // If do not do this check, some brush (like lineX) will controll all axes.
    var targetInfo = this.findTargetInfo(area, ecModel);
    return targetInfo === true || targetInfo && $0f8d0342fd643dbc$var$indexOf(targetInfo.coordSyses, seriesModel.coordinateSystem) >= 0;
};
/**
 * If return Object, a coord found.
 * If reutrn true, global found.
 * Otherwise nothing found.
 *
 * @param {Object} area
 * @param {Array} targetInfoList
 * @return {Object|boolean}
 */ $0f8d0342fd643dbc$var$proto.findTargetInfo = function(area, ecModel) {
    var targetInfoList = this._targetInfoList;
    var foundCpts = $0f8d0342fd643dbc$var$parseFinder(ecModel, area);
    for(var i = 0; i < targetInfoList.length; i++){
        var targetInfo = targetInfoList[i];
        var areaPanelId = area.panelId;
        if (areaPanelId) {
            if (targetInfo.panelId === areaPanelId) return targetInfo;
        } else for(var i = 0; i < $0f8d0342fd643dbc$var$targetInfoMatchers.length; i++){
            if ($0f8d0342fd643dbc$var$targetInfoMatchers[i](foundCpts, targetInfo)) return targetInfo;
        }
    }
    return true;
};
function $0f8d0342fd643dbc$var$formatMinMax(minMax) {
    minMax[0] > minMax[1] && minMax.reverse();
    return minMax;
}
function $0f8d0342fd643dbc$var$parseFinder(ecModel, option) {
    return $d559f43cb9041423$export$95de80076abac814(ecModel, option, {
        includeMainTypes: $0f8d0342fd643dbc$var$INCLUDE_FINDER_MAIN_TYPES
    });
}
var $0f8d0342fd643dbc$var$targetInfoBuilders = {
    grid: function(foundCpts, targetInfoList) {
        var xAxisModels = foundCpts.xAxisModels;
        var yAxisModels = foundCpts.yAxisModels;
        var gridModels = foundCpts.gridModels; // Remove duplicated.
        var gridModelMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4();
        var xAxesHas = {};
        var yAxesHas = {};
        if (!xAxisModels && !yAxisModels && !gridModels) return;
        $0f8d0342fd643dbc$var$each(xAxisModels, function(axisModel) {
            var gridModel = axisModel.axis.grid.model;
            gridModelMap.set(gridModel.id, gridModel);
            xAxesHas[gridModel.id] = true;
        });
        $0f8d0342fd643dbc$var$each(yAxisModels, function(axisModel) {
            var gridModel = axisModel.axis.grid.model;
            gridModelMap.set(gridModel.id, gridModel);
            yAxesHas[gridModel.id] = true;
        });
        $0f8d0342fd643dbc$var$each(gridModels, function(gridModel) {
            gridModelMap.set(gridModel.id, gridModel);
            xAxesHas[gridModel.id] = true;
            yAxesHas[gridModel.id] = true;
        });
        gridModelMap.each(function(gridModel) {
            var grid = gridModel.coordinateSystem;
            var cartesians = [];
            $0f8d0342fd643dbc$var$each(grid.getCartesians(), function(cartesian, index) {
                if ($0f8d0342fd643dbc$var$indexOf(xAxisModels, cartesian.getAxis("x").model) >= 0 || $0f8d0342fd643dbc$var$indexOf(yAxisModels, cartesian.getAxis("y").model) >= 0) cartesians.push(cartesian);
            });
            targetInfoList.push({
                panelId: "grid--" + gridModel.id,
                gridModel: gridModel,
                coordSysModel: gridModel,
                // Use the first one as the representitive coordSys.
                coordSys: cartesians[0],
                coordSyses: cartesians,
                getPanelRect: $0f8d0342fd643dbc$var$panelRectBuilder.grid,
                xAxisDeclared: xAxesHas[gridModel.id],
                yAxisDeclared: yAxesHas[gridModel.id]
            });
        });
    },
    geo: function(foundCpts, targetInfoList) {
        $0f8d0342fd643dbc$var$each(foundCpts.geoModels, function(geoModel) {
            var coordSys = geoModel.coordinateSystem;
            targetInfoList.push({
                panelId: "geo--" + geoModel.id,
                geoModel: geoModel,
                coordSysModel: geoModel,
                coordSys: coordSys,
                coordSyses: [
                    coordSys
                ],
                getPanelRect: $0f8d0342fd643dbc$var$panelRectBuilder.geo
            });
        });
    }
};
var $0f8d0342fd643dbc$var$targetInfoMatchers = [
    function(foundCpts, targetInfo) {
        var xAxisModel = foundCpts.xAxisModel;
        var yAxisModel = foundCpts.yAxisModel;
        var gridModel = foundCpts.gridModel;
        !gridModel && xAxisModel && (gridModel = xAxisModel.axis.grid.model);
        !gridModel && yAxisModel && (gridModel = yAxisModel.axis.grid.model);
        return gridModel && gridModel === targetInfo.gridModel;
    },
    function(foundCpts, targetInfo) {
        var geoModel = foundCpts.geoModel;
        return geoModel && geoModel === targetInfo.geoModel;
    }
];
var $0f8d0342fd643dbc$var$panelRectBuilder = {
    grid: function() {
        // grid is not Transformable.
        return this.coordSys.grid.getRect().clone();
    },
    geo: function() {
        var coordSys = this.coordSys;
        var rect = coordSys.getBoundingRect().clone(); // geo roam and zoom transform
        rect.applyTransform($4b57d6b582d579b7$export$fce0c6cfca85ed96(coordSys));
        return rect;
    }
};
var $0f8d0342fd643dbc$var$coordConvert = {
    lineX: $0f8d0342fd643dbc$var$curry($0f8d0342fd643dbc$var$axisConvert, 0),
    lineY: $0f8d0342fd643dbc$var$curry($0f8d0342fd643dbc$var$axisConvert, 1),
    rect: function(to, coordSys, rangeOrCoordRange) {
        var xminymin = coordSys[$0f8d0342fd643dbc$var$COORD_CONVERTS[to]]([
            rangeOrCoordRange[0][0],
            rangeOrCoordRange[1][0]
        ]);
        var xmaxymax = coordSys[$0f8d0342fd643dbc$var$COORD_CONVERTS[to]]([
            rangeOrCoordRange[0][1],
            rangeOrCoordRange[1][1]
        ]);
        var values = [
            $0f8d0342fd643dbc$var$formatMinMax([
                xminymin[0],
                xmaxymax[0]
            ]),
            $0f8d0342fd643dbc$var$formatMinMax([
                xminymin[1],
                xmaxymax[1]
            ])
        ];
        return {
            values: values,
            xyMinMax: values
        };
    },
    polygon: function(to, coordSys, rangeOrCoordRange) {
        var xyMinMax = [
            [
                Infinity,
                -Infinity
            ],
            [
                Infinity,
                -Infinity
            ]
        ];
        var values = $ec279652dd95c27b$export$871de8747c9eaa88(rangeOrCoordRange, function(item) {
            var p = coordSys[$0f8d0342fd643dbc$var$COORD_CONVERTS[to]](item);
            xyMinMax[0][0] = Math.min(xyMinMax[0][0], p[0]);
            xyMinMax[1][0] = Math.min(xyMinMax[1][0], p[1]);
            xyMinMax[0][1] = Math.max(xyMinMax[0][1], p[0]);
            xyMinMax[1][1] = Math.max(xyMinMax[1][1], p[1]);
            return p;
        });
        return {
            values: values,
            xyMinMax: xyMinMax
        };
    }
};
function $0f8d0342fd643dbc$var$axisConvert(axisNameIndex, to, coordSys, rangeOrCoordRange) {
    var axis = coordSys.getAxis([
        "x",
        "y"
    ][axisNameIndex]);
    var values = $0f8d0342fd643dbc$var$formatMinMax($ec279652dd95c27b$export$871de8747c9eaa88([
        0,
        1
    ], function(i) {
        return to ? axis.coordToData(axis.toLocalCoord(rangeOrCoordRange[i])) : axis.toGlobalCoord(axis.dataToCoord(rangeOrCoordRange[i]));
    }));
    var xyMinMax = [];
    xyMinMax[axisNameIndex] = values;
    xyMinMax[1 - axisNameIndex] = [
        NaN,
        NaN
    ];
    return {
        values: values,
        xyMinMax: xyMinMax
    };
}
var $0f8d0342fd643dbc$var$diffProcessor = {
    lineX: $0f8d0342fd643dbc$var$curry($0f8d0342fd643dbc$var$axisDiffProcessor, 0),
    lineY: $0f8d0342fd643dbc$var$curry($0f8d0342fd643dbc$var$axisDiffProcessor, 1),
    rect: function(values, refer, scales) {
        return [
            [
                values[0][0] - scales[0] * refer[0][0],
                values[0][1] - scales[0] * refer[0][1]
            ],
            [
                values[1][0] - scales[1] * refer[1][0],
                values[1][1] - scales[1] * refer[1][1]
            ]
        ];
    },
    polygon: function(values, refer, scales) {
        return $ec279652dd95c27b$export$871de8747c9eaa88(values, function(item, idx) {
            return [
                item[0] - scales[0] * refer[idx][0],
                item[1] - scales[1] * refer[idx][1]
            ];
        });
    }
};
function $0f8d0342fd643dbc$var$axisDiffProcessor(axisNameIndex, values, refer, scales) {
    return [
        values[0] - scales[axisNameIndex] * refer[0],
        values[1] - scales[axisNameIndex] * refer[1]
    ];
} // We have to process scale caused by dataZoom manually,
// although it might be not accurate.
function $0f8d0342fd643dbc$var$getScales(xyMinMaxCurr, xyMinMaxOrigin) {
    var sizeCurr = $0f8d0342fd643dbc$var$getSize(xyMinMaxCurr);
    var sizeOrigin = $0f8d0342fd643dbc$var$getSize(xyMinMaxOrigin);
    var scales = [
        sizeCurr[0] / sizeOrigin[0],
        sizeCurr[1] / sizeOrigin[1]
    ];
    isNaN(scales[0]) && (scales[0] = 1);
    isNaN(scales[1]) && (scales[1] = 1);
    return scales;
}
function $0f8d0342fd643dbc$var$getSize(xyMinMax) {
    return xyMinMax ? [
        xyMinMax[0][1] - xyMinMax[0][0],
        xyMinMax[1][1] - xyMinMax[1][0]
    ] : [
        NaN,
        NaN
    ];
}
var $0f8d0342fd643dbc$var$_default = $0f8d0342fd643dbc$var$BrushTargetManager;
$0f8d0342fd643dbc$exports = $0f8d0342fd643dbc$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $607093a8ca9b646d$export$4cbf152802aa238;
var $607093a8ca9b646d$export$3e41007ebfff0e64;
var $607093a8ca9b646d$export$42ffd38884aecdac;
var $607093a8ca9b646d$export$85b9a36db797e02b;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $607093a8ca9b646d$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $607093a8ca9b646d$var$ATTR = "\x00_ec_hist_store";
/**
 * @param {module:echarts/model/Global} ecModel
 * @param {Object} newSnapshot {dataZoomId, batch: [payloadInfo, ...]}
 */ function $607093a8ca9b646d$var$push(ecModel, newSnapshot) {
    var store = $607093a8ca9b646d$var$giveStore(ecModel); // If previous dataZoom can not be found,
    // complete an range with current range.
    $607093a8ca9b646d$var$each(newSnapshot, function(batchItem, dataZoomId) {
        var i = store.length - 1;
        for(; i >= 0; i--){
            var snapshot = store[i];
            if (snapshot[dataZoomId]) break;
        }
        if (i < 0) {
            // No origin range set, create one by current range.
            var dataZoomModel = ecModel.queryComponents({
                mainType: "dataZoom",
                subType: "select",
                id: dataZoomId
            })[0];
            if (dataZoomModel) {
                var percentRange = dataZoomModel.getPercentRange();
                store[0][dataZoomId] = {
                    dataZoomId: dataZoomId,
                    start: percentRange[0],
                    end: percentRange[1]
                };
            }
        }
    });
    store.push(newSnapshot);
}
/**
 * @param {module:echarts/model/Global} ecModel
 * @return {Object} snapshot
 */ function $607093a8ca9b646d$var$pop(ecModel) {
    var store = $607093a8ca9b646d$var$giveStore(ecModel);
    var head = store[store.length - 1];
    store.length > 1 && store.pop(); // Find top for all dataZoom.
    var snapshot = {};
    $607093a8ca9b646d$var$each(head, function(batchItem, dataZoomId) {
        for(var i = store.length - 1; i >= 0; i--){
            var batchItem = store[i][dataZoomId];
            if (batchItem) {
                snapshot[dataZoomId] = batchItem;
                break;
            }
        }
    });
    return snapshot;
}
/**
 * @param {module:echarts/model/Global} ecModel
 */ function $607093a8ca9b646d$var$clear(ecModel) {
    ecModel[$607093a8ca9b646d$var$ATTR] = null;
}
/**
 * @param {module:echarts/model/Global} ecModel
 * @return {number} records. always >= 1.
 */ function $607093a8ca9b646d$var$count(ecModel) {
    return $607093a8ca9b646d$var$giveStore(ecModel).length;
}
/**
 * [{key: dataZoomId, value: {dataZoomId, range}}, ...]
 * History length of each dataZoom may be different.
 * this._history[0] is used to store origin range.
 * @type {Array.<Object>}
 */ function $607093a8ca9b646d$var$giveStore(ecModel) {
    var store = ecModel[$607093a8ca9b646d$var$ATTR];
    if (!store) store = ecModel[$607093a8ca9b646d$var$ATTR] = [
        {}
    ];
    return store;
}
$607093a8ca9b646d$export$4cbf152802aa238 = $607093a8ca9b646d$var$push;
$607093a8ca9b646d$export$3e41007ebfff0e64 = $607093a8ca9b646d$var$pop;
$607093a8ca9b646d$export$42ffd38884aecdac = $607093a8ca9b646d$var$clear;
$607093a8ca9b646d$export$85b9a36db797e02b = $607093a8ca9b646d$var$count;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $3b9c2389e45dfb7d$exports.registerSubTypeDefaulter("dataZoom", function() {
    // Default 'slider' when no type specified.
    return "slider";
});


var $49e2222a92c1e4ca$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $49e2222a92c1e4ca$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $13a67f461dae48b9$export$2d449d4adc0d2cfc;
var $13a67f461dae48b9$export$6941a56d4f5b9d41;
var $13a67f461dae48b9$export$5f8200ec3576e138;
var $13a67f461dae48b9$export$88f56b430ae5fcfa;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $13a67f461dae48b9$var$AXIS_DIMS = [
    "x",
    "y",
    "z",
    "radius",
    "angle",
    "single"
]; // Supported coords.
var $13a67f461dae48b9$var$COORDS = [
    "cartesian2d",
    "polar",
    "singleAxis"
];
/**
 * @param {string} coordType
 * @return {boolean}
 */ function $13a67f461dae48b9$var$isCoordSupported(coordType) {
    return $ec279652dd95c27b$export$305f7d4e9d4624f2($13a67f461dae48b9$var$COORDS, coordType) >= 0;
}
/**
 * Create "each" method to iterate names.
 *
 * @pubilc
 * @param  {Array.<string>} names
 * @param  {Array.<string>=} attrs
 * @return {Function}
 */ function $13a67f461dae48b9$var$createNameEach(names, attrs) {
    names = names.slice();
    var capitalNames = $ec279652dd95c27b$export$871de8747c9eaa88(names, $a4be9366aeb9fcc8$export$38a1e7552f497c0e);
    attrs = (attrs || []).slice();
    var capitalAttrs = $ec279652dd95c27b$export$871de8747c9eaa88(attrs, $a4be9366aeb9fcc8$export$38a1e7552f497c0e);
    return function(callback, context) {
        $ec279652dd95c27b$export$79b2f7037acddd43(names, function(name, index) {
            var nameObj = {
                name: name,
                capital: capitalNames[index]
            };
            for(var j = 0; j < attrs.length; j++)nameObj[attrs[j]] = name + capitalAttrs[j];
            callback.call(context, nameObj);
        });
    };
}
/**
 * Iterate each dimension name.
 *
 * @public
 * @param {Function} callback The parameter is like:
 *                            {
 *                                name: 'angle',
 *                                capital: 'Angle',
 *                                axis: 'angleAxis',
 *                                axisIndex: 'angleAixs',
 *                                index: 'angleIndex'
 *                            }
 * @param {Object} context
 */ var $13a67f461dae48b9$var$eachAxisDim = $13a67f461dae48b9$var$createNameEach($13a67f461dae48b9$var$AXIS_DIMS, [
    "axisIndex",
    "axis",
    "index",
    "id"
]);
/**
 * If tow dataZoomModels has the same axis controlled, we say that they are 'linked'.
 * dataZoomModels and 'links' make up one or more graphics.
 * This function finds the graphic where the source dataZoomModel is in.
 *
 * @public
 * @param {Function} forEachNode Node iterator.
 * @param {Function} forEachEdgeType edgeType iterator
 * @param {Function} edgeIdGetter Giving node and edgeType, return an array of edge id.
 * @return {Function} Input: sourceNode, Output: Like {nodes: [], dims: {}}
 */ function $13a67f461dae48b9$var$createLinkedNodesFinder(forEachNode, forEachEdgeType, edgeIdGetter) {
    return function(sourceNode) {
        var result = {
            nodes: [],
            records: {} // key: edgeType.name, value: Object (key: edge id, value: boolean).
        };
        forEachEdgeType(function(edgeType) {
            result.records[edgeType.name] = {};
        });
        if (!sourceNode) return result;
        absorb(sourceNode, result);
        var existsLink;
        do {
            existsLink = false;
            forEachNode(processSingleNode);
        }while (existsLink);
        function processSingleNode(node) {
            if (!isNodeAbsorded(node, result) && isLinked(node, result)) {
                absorb(node, result);
                existsLink = true;
            }
        }
        return result;
    };
    function isNodeAbsorded(node, result) {
        return $ec279652dd95c27b$export$305f7d4e9d4624f2(result.nodes, node) >= 0;
    }
    function isLinked(node, result) {
        var hasLink = false;
        forEachEdgeType(function(edgeType) {
            $ec279652dd95c27b$export$79b2f7037acddd43(edgeIdGetter(node, edgeType) || [], function(edgeId) {
                result.records[edgeType.name][edgeId] && (hasLink = true);
            });
        });
        return hasLink;
    }
    function absorb(node, result) {
        result.nodes.push(node);
        forEachEdgeType(function(edgeType) {
            $ec279652dd95c27b$export$79b2f7037acddd43(edgeIdGetter(node, edgeType) || [], function(edgeId) {
                result.records[edgeType.name][edgeId] = true;
            });
        });
    }
}
$13a67f461dae48b9$export$2d449d4adc0d2cfc = $13a67f461dae48b9$var$isCoordSupported;
$13a67f461dae48b9$export$6941a56d4f5b9d41 = $13a67f461dae48b9$var$createNameEach;
$13a67f461dae48b9$export$5f8200ec3576e138 = $13a67f461dae48b9$var$eachAxisDim;
$13a67f461dae48b9$export$88f56b430ae5fcfa = $13a67f461dae48b9$var$createLinkedNodesFinder;


var $6545cb10ff7ad120$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $6545cb10ff7ad120$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $6545cb10ff7ad120$var$asc = $2d742dbe7f960d8c$export$debe6e778e0a6d32;
/**
 * Operate single axis.
 * One axis can only operated by one axis operator.
 * Different dataZoomModels may be defined to operate the same axis.
 * (i.e. 'inside' data zoom and 'slider' data zoom components)
 * So dataZoomModels share one axisProxy in that case.
 *
 * @class
 */ var $6545cb10ff7ad120$var$AxisProxy = function(dimName, axisIndex, dataZoomModel, ecModel) {
    /**
   * @private
   * @type {string}
   */ this._dimName = dimName;
    /**
   * @private
   */ this._axisIndex = axisIndex;
    /**
   * @private
   * @type {Array.<number>}
   */ this._valueWindow;
    /**
   * @private
   * @type {Array.<number>}
   */ this._percentWindow;
    /**
   * @private
   * @type {Array.<number>}
   */ this._dataExtent;
    /**
   * {minSpan, maxSpan, minValueSpan, maxValueSpan}
   * @private
   * @type {Object}
   */ this._minMaxSpan;
    /**
   * @readOnly
   * @type {module: echarts/model/Global}
   */ this.ecModel = ecModel;
    /**
   * @private
   * @type {module: echarts/component/dataZoom/DataZoomModel}
   */ this._dataZoomModel = dataZoomModel; // /**
//  * @readOnly
//  * @private
//  */
// this.hasSeriesStacked;
};
$6545cb10ff7ad120$var$AxisProxy.prototype = {
    constructor: $6545cb10ff7ad120$var$AxisProxy,
    /**
   * Whether the axisProxy is hosted by dataZoomModel.
   *
   * @public
   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
   * @return {boolean}
   */ hostedBy: function(dataZoomModel) {
        return this._dataZoomModel === dataZoomModel;
    },
    /**
   * @return {Array.<number>} Value can only be NaN or finite value.
   */ getDataValueWindow: function() {
        return this._valueWindow.slice();
    },
    /**
   * @return {Array.<number>}
   */ getDataPercentWindow: function() {
        return this._percentWindow.slice();
    },
    /**
   * @public
   * @param {number} axisIndex
   * @return {Array} seriesModels
   */ getTargetSeriesModels: function() {
        var seriesModels = [];
        var ecModel = this.ecModel;
        ecModel.eachSeries(function(seriesModel) {
            if ($13a67f461dae48b9$export$2d449d4adc0d2cfc(seriesModel.get("coordinateSystem"))) {
                var dimName = this._dimName;
                var axisModel = ecModel.queryComponents({
                    mainType: dimName + "Axis",
                    index: seriesModel.get(dimName + "AxisIndex"),
                    id: seriesModel.get(dimName + "AxisId")
                })[0];
                if (this._axisIndex === (axisModel && axisModel.componentIndex)) seriesModels.push(seriesModel);
            }
        }, this);
        return seriesModels;
    },
    getAxisModel: function() {
        return this.ecModel.getComponent(this._dimName + "Axis", this._axisIndex);
    },
    getOtherAxisModel: function() {
        var axisDim = this._dimName;
        var ecModel = this.ecModel;
        var axisModel = this.getAxisModel();
        var isCartesian = axisDim === "x" || axisDim === "y";
        var otherAxisDim;
        var coordSysIndexName;
        if (isCartesian) {
            coordSysIndexName = "gridIndex";
            otherAxisDim = axisDim === "x" ? "y" : "x";
        } else {
            coordSysIndexName = "polarIndex";
            otherAxisDim = axisDim === "angle" ? "radius" : "angle";
        }
        var foundOtherAxisModel;
        ecModel.eachComponent(otherAxisDim + "Axis", function(otherAxisModel) {
            if ((otherAxisModel.get(coordSysIndexName) || 0) === (axisModel.get(coordSysIndexName) || 0)) foundOtherAxisModel = otherAxisModel;
        });
        return foundOtherAxisModel;
    },
    getMinMaxSpan: function() {
        return $ec279652dd95c27b$export$9cd59f9826255e47(this._minMaxSpan);
    },
    /**
   * Only calculate by given range and this._dataExtent, do not change anything.
   *
   * @param {Object} opt
   * @param {number} [opt.start]
   * @param {number} [opt.end]
   * @param {number} [opt.startValue]
   * @param {number} [opt.endValue]
   */ calculateDataWindow: function(opt) {
        var dataExtent = this._dataExtent;
        var axisModel = this.getAxisModel();
        var scale = axisModel.axis.scale;
        var rangePropMode = this._dataZoomModel.getRangePropMode();
        var percentExtent = [
            0,
            100
        ];
        var percentWindow = [];
        var valueWindow = [];
        var hasPropModeValue;
        $6545cb10ff7ad120$var$each([
            "start",
            "end"
        ], function(prop, idx) {
            var boundPercent = opt[prop];
            var boundValue = opt[prop + "Value"]; // Notice: dataZoom is based either on `percentProp` ('start', 'end') or
            // on `valueProp` ('startValue', 'endValue'). (They are based on the data extent
            // but not min/max of axis, which will be calculated by data window then).
            // The former one is suitable for cases that a dataZoom component controls multiple
            // axes with different unit or extent, and the latter one is suitable for accurate
            // zoom by pixel (e.g., in dataZoomSelect).
            // we use `getRangePropMode()` to mark which prop is used. `rangePropMode` is updated
            // only when setOption or dispatchAction, otherwise it remains its original value.
            // (Why not only record `percentProp` and always map to `valueProp`? Because
            // the map `valueProp` -> `percentProp` -> `valueProp` probably not the original
            // `valueProp`. consider two axes constrolled by one dataZoom. They have different
            // data extent. All of values that are overflow the `dataExtent` will be calculated
            // to percent '100%').
            if (rangePropMode[idx] === "percent") {
                boundPercent == null && (boundPercent = percentExtent[idx]); // Use scale.parse to math round for category or time axis.
                boundValue = scale.parse($2d742dbe7f960d8c$export$d3f68fbaa670562(boundPercent, percentExtent, dataExtent));
            } else {
                hasPropModeValue = true;
                boundValue = boundValue == null ? dataExtent[idx] : scale.parse(boundValue); // Calculating `percent` from `value` may be not accurate, because
                // This calculation can not be inversed, because all of values that
                // are overflow the `dataExtent` will be calculated to percent '100%'
                boundPercent = $2d742dbe7f960d8c$export$d3f68fbaa670562(boundValue, dataExtent, percentExtent);
            } // valueWindow[idx] = round(boundValue);
            // percentWindow[idx] = round(boundPercent);
            valueWindow[idx] = boundValue;
            percentWindow[idx] = boundPercent;
        });
        $6545cb10ff7ad120$var$asc(valueWindow);
        $6545cb10ff7ad120$var$asc(percentWindow); // The windows from user calling of `dispatchAction` might be out of the extent,
        // or do not obey the `min/maxSpan`, `min/maxValueSpan`. But we dont restrict window
        // by `zoomLock` here, because we see `zoomLock` just as a interaction constraint,
        // where API is able to initialize/modify the window size even though `zoomLock`
        // specified.
        var spans = this._minMaxSpan;
        hasPropModeValue ? restrictSet(valueWindow, percentWindow, dataExtent, percentExtent, false) : restrictSet(percentWindow, valueWindow, percentExtent, dataExtent, true);
        function restrictSet(fromWindow, toWindow, fromExtent, toExtent, toValue) {
            var suffix = toValue ? "Span" : "ValueSpan";
            $1d1b44fc5f576d07$exports(0, fromWindow, fromExtent, "all", spans["min" + suffix], spans["max" + suffix]);
            for(var i = 0; i < 2; i++){
                toWindow[i] = $2d742dbe7f960d8c$export$d3f68fbaa670562(fromWindow[i], fromExtent, toExtent, true);
                toValue && (toWindow[i] = scale.parse(toWindow[i]));
            }
        }
        return {
            valueWindow: valueWindow,
            percentWindow: percentWindow
        };
    },
    /**
   * Notice: reset should not be called before series.restoreData() called,
   * so it is recommanded to be called in "process stage" but not "model init
   * stage".
   *
   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
   */ reset: function(dataZoomModel) {
        if (dataZoomModel !== this._dataZoomModel) return;
        var targetSeries = this.getTargetSeriesModels(); // Culculate data window and data extent, and record them.
        this._dataExtent = $6545cb10ff7ad120$var$calculateDataExtent(this, this._dimName, targetSeries); // this.hasSeriesStacked = false;
        // each(targetSeries, function (series) {
        // var data = series.getData();
        // var dataDim = data.mapDimension(this._dimName);
        // var stackedDimension = data.getCalculationInfo('stackedDimension');
        // if (stackedDimension && stackedDimension === dataDim) {
        // this.hasSeriesStacked = true;
        // }
        // }, this);
        // `calculateDataWindow` uses min/maxSpan.
        $6545cb10ff7ad120$var$setMinMaxSpan(this);
        var dataWindow = this.calculateDataWindow(dataZoomModel.settledOption);
        this._valueWindow = dataWindow.valueWindow;
        this._percentWindow = dataWindow.percentWindow; // Update axis setting then.
        $6545cb10ff7ad120$var$setAxisModel(this);
    },
    /**
   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
   */ restore: function(dataZoomModel) {
        if (dataZoomModel !== this._dataZoomModel) return;
        this._valueWindow = this._percentWindow = null;
        $6545cb10ff7ad120$var$setAxisModel(this, true);
    },
    /**
   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
   */ filterData: function(dataZoomModel, api) {
        if (dataZoomModel !== this._dataZoomModel) return;
        var axisDim = this._dimName;
        var seriesModels = this.getTargetSeriesModels();
        var filterMode = dataZoomModel.get("filterMode");
        var valueWindow = this._valueWindow;
        if (filterMode === "none") return;
         // FIXME
        // Toolbox may has dataZoom injected. And if there are stacked bar chart
        // with NaN data, NaN will be filtered and stack will be wrong.
        // So we need to force the mode to be set empty.
        // In fect, it is not a big deal that do not support filterMode-'filter'
        // when using toolbox#dataZoom, utill tooltip#dataZoom support "single axis
        // selection" some day, which might need "adapt to data extent on the
        // otherAxis", which is disabled by filterMode-'empty'.
        // But currently, stack has been fixed to based on value but not index,
        // so this is not an issue any more.
        // var otherAxisModel = this.getOtherAxisModel();
        // if (dataZoomModel.get('$fromToolbox')
        //     && otherAxisModel
        //     && otherAxisModel.hasSeriesStacked
        // ) {
        //     filterMode = 'empty';
        // }
        // TODO
        // filterMode 'weakFilter' and 'empty' is not optimized for huge data yet.
        $6545cb10ff7ad120$var$each(seriesModels, function(seriesModel) {
            var seriesData = seriesModel.getData();
            var dataDims = seriesData.mapDimension(axisDim, true);
            if (!dataDims.length) return;
            if (filterMode === "weakFilter") seriesData.filterSelf(function(dataIndex) {
                var leftOut;
                var rightOut;
                var hasValue;
                for(var i = 0; i < dataDims.length; i++){
                    var value = seriesData.get(dataDims[i], dataIndex);
                    var thisHasValue = !isNaN(value);
                    var thisLeftOut = value < valueWindow[0];
                    var thisRightOut = value > valueWindow[1];
                    if (thisHasValue && !thisLeftOut && !thisRightOut) return true;
                    thisHasValue && (hasValue = true);
                    thisLeftOut && (leftOut = true);
                    thisRightOut && (rightOut = true);
                } // If both left out and right out, do not filter.
                return hasValue && leftOut && rightOut;
            });
            else $6545cb10ff7ad120$var$each(dataDims, function(dim) {
                if (filterMode === "empty") seriesModel.setData(seriesData = seriesData.map(dim, function(value) {
                    return !isInWindow(value) ? NaN : value;
                }));
                else {
                    var range = {};
                    range[dim] = valueWindow; // console.time('select');
                    seriesData.selectRange(range); // console.timeEnd('select');
                }
            });
            $6545cb10ff7ad120$var$each(dataDims, function(dim) {
                seriesData.setApproximateExtent(valueWindow, dim);
            });
        });
        function isInWindow(value) {
            return value >= valueWindow[0] && value <= valueWindow[1];
        }
    }
};
function $6545cb10ff7ad120$var$calculateDataExtent(axisProxy, axisDim, seriesModels) {
    var dataExtent = [
        Infinity,
        -Infinity
    ];
    $6545cb10ff7ad120$var$each(seriesModels, function(seriesModel) {
        var seriesData = seriesModel.getData();
        if (seriesData) $6545cb10ff7ad120$var$each(seriesData.mapDimension(axisDim, true), function(dim) {
            var seriesExtent = seriesData.getApproximateExtent(dim);
            seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
            seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
        });
    });
    if (dataExtent[1] < dataExtent[0]) dataExtent = [
        NaN,
        NaN
    ];
     // It is important to get "consistent" extent when more then one axes is
    // controlled by a `dataZoom`, otherwise those axes will not be synchronized
    // when zooming. But it is difficult to know what is "consistent", considering
    // axes have different type or even different meanings (For example, two
    // time axes are used to compare data of the same date in different years).
    // So basically dataZoom just obtains extent by series.data (in category axis
    // extent can be obtained from axis.data).
    // Nevertheless, user can set min/max/scale on axes to make extent of axes
    // consistent.
    $6545cb10ff7ad120$var$fixExtentByAxis(axisProxy, dataExtent);
    return dataExtent;
}
function $6545cb10ff7ad120$var$fixExtentByAxis(axisProxy, dataExtent) {
    var axisModel = axisProxy.getAxisModel();
    var min = axisModel.getMin(true); // For category axis, if min/max/scale are not set, extent is determined
    // by axis.data by default.
    var isCategoryAxis = axisModel.get("type") === "category";
    var axisDataLen = isCategoryAxis && axisModel.getCategories().length;
    if (min != null && min !== "dataMin" && typeof min !== "function") dataExtent[0] = min;
    else if (isCategoryAxis) dataExtent[0] = axisDataLen > 0 ? 0 : NaN;
    var max = axisModel.getMax(true);
    if (max != null && max !== "dataMax" && typeof max !== "function") dataExtent[1] = max;
    else if (isCategoryAxis) dataExtent[1] = axisDataLen > 0 ? axisDataLen - 1 : NaN;
    if (!axisModel.get("scale", true)) {
        dataExtent[0] > 0 && (dataExtent[0] = 0);
        dataExtent[1] < 0 && (dataExtent[1] = 0);
    } // For value axis, if min/max/scale are not set, we just use the extent obtained
    // by series data, which may be a little different from the extent calculated by
    // `axisHelper.getScaleExtent`. But the different just affects the experience a
    // little when zooming. So it will not be fixed until some users require it strongly.
    return dataExtent;
}
function $6545cb10ff7ad120$var$setAxisModel(axisProxy, isRestore) {
    var axisModel = axisProxy.getAxisModel();
    var percentWindow = axisProxy._percentWindow;
    var valueWindow = axisProxy._valueWindow;
    if (!percentWindow) return;
     // [0, 500]: arbitrary value, guess axis extent.
    var precision = $2d742dbe7f960d8c$export$666260d9a2dda8a7(valueWindow, [
        0,
        500
    ]);
    precision = Math.min(precision, 20); // isRestore or isFull
    var useOrigin = isRestore || percentWindow[0] === 0 && percentWindow[1] === 100;
    axisModel.setRange(useOrigin ? null : +valueWindow[0].toFixed(precision), useOrigin ? null : +valueWindow[1].toFixed(precision));
}
function $6545cb10ff7ad120$var$setMinMaxSpan(axisProxy) {
    var minMaxSpan = axisProxy._minMaxSpan = {};
    var dataZoomModel = axisProxy._dataZoomModel;
    var dataExtent = axisProxy._dataExtent;
    $6545cb10ff7ad120$var$each([
        "min",
        "max"
    ], function(minMax) {
        var percentSpan = dataZoomModel.get(minMax + "Span");
        var valueSpan = dataZoomModel.get(minMax + "ValueSpan");
        valueSpan != null && (valueSpan = axisProxy.getAxisModel().axis.scale.parse(valueSpan)); // minValueSpan and maxValueSpan has higher priority than minSpan and maxSpan
        if (valueSpan != null) percentSpan = $2d742dbe7f960d8c$export$d3f68fbaa670562(dataExtent[0] + valueSpan, dataExtent, [
            0,
            100
        ], true);
        else if (percentSpan != null) valueSpan = $2d742dbe7f960d8c$export$d3f68fbaa670562(percentSpan, [
            0,
            100
        ], dataExtent, true) - dataExtent[0];
        minMaxSpan[minMax + "Span"] = percentSpan;
        minMaxSpan[minMax + "ValueSpan"] = valueSpan;
    });
}
var $6545cb10ff7ad120$var$_default = $6545cb10ff7ad120$var$AxisProxy;
$6545cb10ff7ad120$exports = $6545cb10ff7ad120$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $49e2222a92c1e4ca$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $49e2222a92c1e4ca$var$eachAxisDim = $13a67f461dae48b9$export$5f8200ec3576e138;
var $49e2222a92c1e4ca$var$DataZoomModel = $f406636b535430a7$exports.extendComponentModel({
    type: "dataZoom",
    dependencies: [
        "xAxis",
        "yAxis",
        "zAxis",
        "radiusAxis",
        "angleAxis",
        "singleAxis",
        "series"
    ],
    /**
   * @protected
   */ defaultOption: {
        zlevel: 0,
        z: 4,
        // Higher than normal component (z: 2).
        orient: null,
        // Default auto by axisIndex. Possible value: 'horizontal', 'vertical'.
        xAxisIndex: null,
        // Default the first horizontal category axis.
        yAxisIndex: null,
        // Default the first vertical category axis.
        filterMode: "filter",
        // Possible values: 'filter' or 'empty' or 'weakFilter'.
        // 'filter': data items which are out of window will be removed. This option is
        //          applicable when filtering outliers. For each data item, it will be
        //          filtered if one of the relevant dimensions is out of the window.
        // 'weakFilter': data items which are out of window will be removed. This option
        //          is applicable when filtering outliers. For each data item, it will be
        //          filtered only if all  of the relevant dimensions are out of the same
        //          side of the window.
        // 'empty': data items which are out of window will be set to empty.
        //          This option is applicable when user should not neglect
        //          that there are some data items out of window.
        // 'none': Do not filter.
        // Taking line chart as an example, line will be broken in
        // the filtered points when filterModel is set to 'empty', but
        // be connected when set to 'filter'.
        throttle: null,
        // Dispatch action by the fixed rate, avoid frequency.
        // default 100. Do not throttle when use null/undefined.
        // If animation === true and animationDurationUpdate > 0,
        // default value is 100, otherwise 20.
        start: 0,
        // Start percent. 0 ~ 100
        end: 100,
        // End percent. 0 ~ 100
        startValue: null,
        // Start value. If startValue specified, start is ignored.
        endValue: null,
        // End value. If endValue specified, end is ignored.
        minSpan: null,
        // 0 ~ 100
        maxSpan: null,
        // 0 ~ 100
        minValueSpan: null,
        // The range of dataZoom can not be smaller than that.
        maxValueSpan: null,
        // The range of dataZoom can not be larger than that.
        rangeMode: null // Array, can be 'value' or 'percent'.
    },
    /**
   * @override
   */ init: function(option, parentModel, ecModel) {
        /**
     * key like x_0, y_1
     * @private
     * @type {Object}
     */ this._dataIntervalByAxis = {};
        /**
     * @private
     */ this._dataInfo = {};
        /**
     * key like x_0, y_1
     * @private
     */ this._axisProxies = {};
        /**
     * @readOnly
     */ this.textStyleModel;
        /**
     * @private
     */ this._autoThrottle = true;
        /**
     * It is `[rangeModeForMin, rangeModeForMax]`.
     * The optional values for `rangeMode`:
     * + `'value'` mode: the axis extent will always be determined by
     *     `dataZoom.startValue` and `dataZoom.endValue`, despite
     *     how data like and how `axis.min` and `axis.max` are.
     * + `'percent'` mode: `100` represents 100% of the `[dMin, dMax]`,
     *     where `dMin` is `axis.min` if `axis.min` specified, otherwise `data.extent[0]`,
     *     and `dMax` is `axis.max` if `axis.max` specified, otherwise `data.extent[1]`.
     *     Axis extent will be determined by the result of the percent of `[dMin, dMax]`.
     *
     * For example, when users are using dynamic data (update data periodically via `setOption`),
     * if in `'value`' mode, the window will be kept in a fixed value range despite how
     * data are appended, while if in `'percent'` mode, whe window range will be changed alone with
     * the appended data (suppose `axis.min` and `axis.max` are not specified).
     *
     * @private
     */ this._rangePropMode = [
            "percent",
            "percent"
        ];
        var inputRawOption = $49e2222a92c1e4ca$var$retrieveRawOption(option);
        /**
     * Suppose a "main process" start at the point that model prepared (that is,
     * model initialized or merged or method called in `action`).
     * We should keep the `main process` idempotent, that is, given a set of values
     * on `option`, we get the same result.
     *
     * But sometimes, values on `option` will be updated for providing users
     * a "final calculated value" (`dataZoomProcessor` will do that). Those value
     * should not be the base/input of the `main process`.
     *
     * So in that case we should save and keep the input of the `main process`
     * separately, called `settledOption`.
     *
     * For example, consider the case:
     * (Step_1) brush zoom the grid by `toolbox.dataZoom`,
     *     where the original input `option.startValue`, `option.endValue` are earsed by
     *     calculated value.
     * (Step)2) click the legend to hide and show a series,
     *     where the new range is calculated by the earsed `startValue` and `endValue`,
     *     which brings incorrect result.
     *
     * @readOnly
     */ this.settledOption = inputRawOption;
        this.mergeDefaultAndTheme(option, ecModel);
        this.doInit(inputRawOption);
    },
    /**
   * @override
   */ mergeOption: function(newOption) {
        var inputRawOption = $49e2222a92c1e4ca$var$retrieveRawOption(newOption); //FIX #2591
        $ec279652dd95c27b$export$4950aa0f605343fb(this.option, newOption, true);
        $ec279652dd95c27b$export$4950aa0f605343fb(this.settledOption, inputRawOption, true);
        this.doInit(inputRawOption);
    },
    /**
   * @protected
   */ doInit: function(inputRawOption) {
        var thisOption = this.option; // Disable realtime view update if canvas is not supported.
        if (!$27ac1413ecc67076$exports.canvasSupported) thisOption.realtime = false;
        this._setDefaultThrottle(inputRawOption);
        $49e2222a92c1e4ca$var$updateRangeUse(this, inputRawOption);
        var settledOption = this.settledOption;
        $49e2222a92c1e4ca$var$each([
            [
                "start",
                "startValue"
            ],
            [
                "end",
                "endValue"
            ]
        ], function(names, index) {
            // start/end has higher priority over startValue/endValue if they
            // both set, but we should make chart.setOption({endValue: 1000})
            // effective, rather than chart.setOption({endValue: 1000, end: null}).
            if (this._rangePropMode[index] === "value") thisOption[names[0]] = settledOption[names[0]] = null;
             // Otherwise do nothing and use the merge result.
        }, this);
        this.textStyleModel = this.getModel("textStyle");
        this._resetTarget();
        this._giveAxisProxies();
    },
    /**
   * @private
   */ _giveAxisProxies: function() {
        var axisProxies = this._axisProxies;
        this.eachTargetAxis(function(dimNames, axisIndex, dataZoomModel, ecModel) {
            var axisModel = this.dependentModels[dimNames.axis][axisIndex]; // If exists, share axisProxy with other dataZoomModels.
            var axisProxy = axisModel.__dzAxisProxy || (axisModel.__dzAxisProxy = new $6545cb10ff7ad120$exports(dimNames.name, axisIndex, this, ecModel)); // FIXME
            // dispose __dzAxisProxy
            axisProxies[dimNames.name + "_" + axisIndex] = axisProxy;
        }, this);
    },
    /**
   * @private
   */ _resetTarget: function() {
        var thisOption = this.option;
        var autoMode = this._judgeAutoMode();
        $49e2222a92c1e4ca$var$eachAxisDim(function(dimNames) {
            var axisIndexName = dimNames.axisIndex;
            thisOption[axisIndexName] = $d559f43cb9041423$export$4f07b212a02c8051(thisOption[axisIndexName]);
        }, this);
        if (autoMode === "axisIndex") this._autoSetAxisIndex();
        else if (autoMode === "orient") this._autoSetOrient();
    },
    /**
   * @private
   */ _judgeAutoMode: function() {
        // Auto set only works for setOption at the first time.
        // The following is user's reponsibility. So using merged
        // option is OK.
        var thisOption = this.option;
        var hasIndexSpecified = false;
        $49e2222a92c1e4ca$var$eachAxisDim(function(dimNames) {
            // When user set axisIndex as a empty array, we think that user specify axisIndex
            // but do not want use auto mode. Because empty array may be encountered when
            // some error occured.
            if (thisOption[dimNames.axisIndex] != null) hasIndexSpecified = true;
        }, this);
        var orient = thisOption.orient;
        if (orient == null && hasIndexSpecified) return "orient";
        else if (!hasIndexSpecified) {
            if (orient == null) thisOption.orient = "horizontal";
            return "axisIndex";
        }
    },
    /**
   * @private
   */ _autoSetAxisIndex: function() {
        var autoAxisIndex = true;
        var orient = this.get("orient", true);
        var thisOption = this.option;
        var dependentModels = this.dependentModels;
        if (autoAxisIndex) {
            // Find axis that parallel to dataZoom as default.
            var dimName = orient === "vertical" ? "y" : "x";
            if (dependentModels[dimName + "Axis"].length) {
                thisOption[dimName + "AxisIndex"] = [
                    0
                ];
                autoAxisIndex = false;
            } else $49e2222a92c1e4ca$var$each(dependentModels.singleAxis, function(singleAxisModel) {
                if (autoAxisIndex && singleAxisModel.get("orient", true) === orient) {
                    thisOption.singleAxisIndex = [
                        singleAxisModel.componentIndex
                    ];
                    autoAxisIndex = false;
                }
            });
        }
        if (autoAxisIndex) // Find the first category axis as default. (consider polar)
        $49e2222a92c1e4ca$var$eachAxisDim(function(dimNames) {
            if (!autoAxisIndex) return;
            var axisIndices = [];
            var axisModels = this.dependentModels[dimNames.axis];
            if (axisModels.length && !axisIndices.length) {
                for(var i = 0, len = axisModels.length; i < len; i++)if (axisModels[i].get("type") === "category") axisIndices.push(i);
            }
            thisOption[dimNames.axisIndex] = axisIndices;
            if (axisIndices.length) autoAxisIndex = false;
        }, this);
        if (autoAxisIndex) // FIXME
        // 这里是兼容ec2的写法（没指定xAxisIndex和yAxisIndex时把scatter和双数值轴折柱纳入dataZoom控制），
        // 但是实际是否需要Grid.js#getScaleByOption来判断（考虑time，log等axis type）？
        // If both dataZoom.xAxisIndex and dataZoom.yAxisIndex is not specified,
        // dataZoom component auto adopts series that reference to
        // both xAxis and yAxis which type is 'value'.
        this.ecModel.eachSeries(function(seriesModel) {
            if (this._isSeriesHasAllAxesTypeOf(seriesModel, "value")) $49e2222a92c1e4ca$var$eachAxisDim(function(dimNames) {
                var axisIndices = thisOption[dimNames.axisIndex];
                var axisIndex = seriesModel.get(dimNames.axisIndex);
                var axisId = seriesModel.get(dimNames.axisId);
                var axisModel = seriesModel.ecModel.queryComponents({
                    mainType: dimNames.axis,
                    index: axisIndex,
                    id: axisId
                })[0];
                axisIndex = axisModel.componentIndex;
                if ($ec279652dd95c27b$export$305f7d4e9d4624f2(axisIndices, axisIndex) < 0) axisIndices.push(axisIndex);
            });
        }, this);
    },
    /**
   * @private
   */ _autoSetOrient: function() {
        var dim; // Find the first axis
        this.eachTargetAxis(function(dimNames) {
            !dim && (dim = dimNames.name);
        }, this);
        this.option.orient = dim === "y" ? "vertical" : "horizontal";
    },
    /**
   * @private
   */ _isSeriesHasAllAxesTypeOf: function(seriesModel, axisType) {
        // FIXME
        // 需要series的xAxisIndex和yAxisIndex都首先自动设置上。
        // 例如series.type === scatter时。
        var is = true;
        $49e2222a92c1e4ca$var$eachAxisDim(function(dimNames) {
            var seriesAxisIndex = seriesModel.get(dimNames.axisIndex);
            var axisModel = this.dependentModels[dimNames.axis][seriesAxisIndex];
            if (!axisModel || axisModel.get("type") !== axisType) is = false;
        }, this);
        return is;
    },
    /**
   * @private
   */ _setDefaultThrottle: function(inputRawOption) {
        // When first time user set throttle, auto throttle ends.
        if (inputRawOption.hasOwnProperty("throttle")) this._autoThrottle = false;
        if (this._autoThrottle) {
            var globalOption = this.ecModel.option;
            this.option.throttle = globalOption.animation && globalOption.animationDurationUpdate > 0 ? 100 : 20;
        }
    },
    /**
   * @public
   */ getFirstTargetAxisModel: function() {
        var firstAxisModel;
        $49e2222a92c1e4ca$var$eachAxisDim(function(dimNames) {
            if (firstAxisModel == null) {
                var indices = this.get(dimNames.axisIndex);
                if (indices.length) firstAxisModel = this.dependentModels[dimNames.axis][indices[0]];
            }
        }, this);
        return firstAxisModel;
    },
    /**
   * @public
   * @param {Function} callback param: axisModel, dimNames, axisIndex, dataZoomModel, ecModel
   */ eachTargetAxis: function(callback, context) {
        var ecModel = this.ecModel;
        $49e2222a92c1e4ca$var$eachAxisDim(function(dimNames) {
            $49e2222a92c1e4ca$var$each(this.get(dimNames.axisIndex), function(axisIndex) {
                callback.call(context, dimNames, axisIndex, this, ecModel);
            }, this);
        }, this);
    },
    /**
   * @param {string} dimName
   * @param {number} axisIndex
   * @return {module:echarts/component/dataZoom/AxisProxy} If not found, return null/undefined.
   */ getAxisProxy: function(dimName, axisIndex) {
        return this._axisProxies[dimName + "_" + axisIndex];
    },
    /**
   * @param {string} dimName
   * @param {number} axisIndex
   * @return {module:echarts/model/Model} If not found, return null/undefined.
   */ getAxisModel: function(dimName, axisIndex) {
        var axisProxy = this.getAxisProxy(dimName, axisIndex);
        return axisProxy && axisProxy.getAxisModel();
    },
    /**
   * If not specified, set to undefined.
   *
   * @public
   * @param {Object} opt
   * @param {number} [opt.start]
   * @param {number} [opt.end]
   * @param {number} [opt.startValue]
   * @param {number} [opt.endValue]
   */ setRawRange: function(opt) {
        var thisOption = this.option;
        var settledOption = this.settledOption;
        $49e2222a92c1e4ca$var$each([
            [
                "start",
                "startValue"
            ],
            [
                "end",
                "endValue"
            ]
        ], function(names) {
            // Consider the pair <start, startValue>:
            // If one has value and the other one is `null/undefined`, we both set them
            // to `settledOption`. This strategy enables the feature to clear the original
            // value in `settledOption` to `null/undefined`.
            // But if both of them are `null/undefined`, we do not set them to `settledOption`
            // and keep `settledOption` with the original value. This strategy enables users to
            // only set <end or endValue> but not set <start or startValue> when calling
            // `dispatchAction`.
            // The pair <end, endValue> is treated in the same way.
            if (opt[names[0]] != null || opt[names[1]] != null) {
                thisOption[names[0]] = settledOption[names[0]] = opt[names[0]];
                thisOption[names[1]] = settledOption[names[1]] = opt[names[1]];
            }
        }, this);
        $49e2222a92c1e4ca$var$updateRangeUse(this, opt);
    },
    /**
   * @public
   * @param {Object} opt
   * @param {number} [opt.start]
   * @param {number} [opt.end]
   * @param {number} [opt.startValue]
   * @param {number} [opt.endValue]
   */ setCalculatedRange: function(opt) {
        var option = this.option;
        $49e2222a92c1e4ca$var$each([
            "start",
            "startValue",
            "end",
            "endValue"
        ], function(name) {
            option[name] = opt[name];
        });
    },
    /**
   * @public
   * @return {Array.<number>} [startPercent, endPercent]
   */ getPercentRange: function() {
        var axisProxy = this.findRepresentativeAxisProxy();
        if (axisProxy) return axisProxy.getDataPercentWindow();
    },
    /**
   * @public
   * For example, chart.getModel().getComponent('dataZoom').getValueRange('y', 0);
   *
   * @param {string} [axisDimName]
   * @param {number} [axisIndex]
   * @return {Array.<number>} [startValue, endValue] value can only be '-' or finite number.
   */ getValueRange: function(axisDimName, axisIndex) {
        if (axisDimName == null && axisIndex == null) {
            var axisProxy = this.findRepresentativeAxisProxy();
            if (axisProxy) return axisProxy.getDataValueWindow();
        } else return this.getAxisProxy(axisDimName, axisIndex).getDataValueWindow();
    },
    /**
   * @public
   * @param {module:echarts/model/Model} [axisModel] If axisModel given, find axisProxy
   *      corresponding to the axisModel
   * @return {module:echarts/component/dataZoom/AxisProxy}
   */ findRepresentativeAxisProxy: function(axisModel) {
        if (axisModel) return axisModel.__dzAxisProxy;
         // Find the first hosted axisProxy
        var axisProxies = this._axisProxies;
        for(var key in axisProxies){
            if (axisProxies.hasOwnProperty(key) && axisProxies[key].hostedBy(this)) return axisProxies[key];
        } // If no hosted axis find not hosted axisProxy.
        // Consider this case: dataZoomModel1 and dataZoomModel2 control the same axis,
        // and the option.start or option.end settings are different. The percentRange
        // should follow axisProxy.
        // (We encounter this problem in toolbox data zoom.)
        for(var key in axisProxies){
            if (axisProxies.hasOwnProperty(key) && !axisProxies[key].hostedBy(this)) return axisProxies[key];
        }
    },
    /**
   * @return {Array.<string>}
   */ getRangePropMode: function() {
        return this._rangePropMode.slice();
    }
});
/**
 * Retrieve the those raw params from option, which will be cached separately.
 * becasue they will be overwritten by normalized/calculated values in the main
 * process.
 */ function $49e2222a92c1e4ca$var$retrieveRawOption(option) {
    var ret = {};
    $49e2222a92c1e4ca$var$each([
        "start",
        "end",
        "startValue",
        "endValue",
        "throttle"
    ], function(name) {
        option.hasOwnProperty(name) && (ret[name] = option[name]);
    });
    return ret;
}
function $49e2222a92c1e4ca$var$updateRangeUse(dataZoomModel, inputRawOption) {
    var rangePropMode = dataZoomModel._rangePropMode;
    var rangeModeInOption = dataZoomModel.get("rangeMode");
    $49e2222a92c1e4ca$var$each([
        [
            "start",
            "startValue"
        ],
        [
            "end",
            "endValue"
        ]
    ], function(names, index) {
        var percentSpecified = inputRawOption[names[0]] != null;
        var valueSpecified = inputRawOption[names[1]] != null;
        if (percentSpecified && !valueSpecified) rangePropMode[index] = "percent";
        else if (!percentSpecified && valueSpecified) rangePropMode[index] = "value";
        else if (rangeModeInOption) rangePropMode[index] = rangeModeInOption[index];
        else if (percentSpecified) // percentSpecified && valueSpecified
        rangePropMode[index] = "percent";
         // else remain its original setting.
    });
}
var $49e2222a92c1e4ca$var$_default = $49e2222a92c1e4ca$var$DataZoomModel;
$49e2222a92c1e4ca$exports = $49e2222a92c1e4ca$var$_default;


var $13c3ce64e9689141$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $13c3ce64e9689141$var$_default = $9c7fc7c628500365$exports.extend({
    type: "dataZoom",
    render: function(dataZoomModel, ecModel, api, payload) {
        this.dataZoomModel = dataZoomModel;
        this.ecModel = ecModel;
        this.api = api;
    },
    /**
   * Find the first target coordinate system.
   *
   * @protected
   * @return {Object} {
   *                   grid: [
   *                       {model: coord0, axisModels: [axis1, axis3], coordIndex: 1},
   *                       {model: coord1, axisModels: [axis0, axis2], coordIndex: 0},
   *                       ...
   *                   ],  // cartesians must not be null/undefined.
   *                   polar: [
   *                       {model: coord0, axisModels: [axis4], coordIndex: 0},
   *                       ...
   *                   ],  // polars must not be null/undefined.
   *                   singleAxis: [
   *                       {model: coord0, axisModels: [], coordIndex: 0}
   *                   ]
   */ getTargetCoordInfo: function() {
        var dataZoomModel = this.dataZoomModel;
        var ecModel = this.ecModel;
        var coordSysLists = {};
        dataZoomModel.eachTargetAxis(function(dimNames, axisIndex) {
            var axisModel = ecModel.getComponent(dimNames.axis, axisIndex);
            if (axisModel) {
                var coordModel = axisModel.getCoordSysModel();
                coordModel && save(coordModel, axisModel, coordSysLists[coordModel.mainType] || (coordSysLists[coordModel.mainType] = []), coordModel.componentIndex);
            }
        }, this);
        function save(coordModel, axisModel, store, coordIndex) {
            var item;
            for(var i = 0; i < store.length; i++)if (store[i].model === coordModel) {
                item = store[i];
                break;
            }
            if (!item) store.push(item = {
                model: coordModel,
                axisModels: [],
                coordIndex: coordIndex
            });
            item.axisModels.push(axisModel);
        }
        return coordSysLists;
    }
});
$13c3ce64e9689141$exports = $13c3ce64e9689141$var$_default;


var $28329841b176c03d$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $28329841b176c03d$var$_default = $49e2222a92c1e4ca$exports.extend({
    type: "dataZoom.select"
});
$28329841b176c03d$exports = $28329841b176c03d$var$_default;


var $d611527809af642e$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $d611527809af642e$var$_default = $13c3ce64e9689141$exports.extend({
    type: "dataZoom.select"
});
$d611527809af642e$exports = $d611527809af642e$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $5aebff164c80e105$var$createHashMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4;
var $5aebff164c80e105$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerProcessor({
    // `dataZoomProcessor` will only be performed in needed series. Consider if
    // there is a line series and a pie series, it is better not to update the
    // line series if only pie series is needed to be updated.
    getTargetSeries: function(ecModel) {
        var seriesModelMap = $5aebff164c80e105$var$createHashMap();
        ecModel.eachComponent("dataZoom", function(dataZoomModel) {
            dataZoomModel.eachTargetAxis(function(dimNames, axisIndex, dataZoomModel) {
                var axisProxy = dataZoomModel.getAxisProxy(dimNames.name, axisIndex);
                $5aebff164c80e105$var$each(axisProxy.getTargetSeriesModels(), function(seriesModel) {
                    seriesModelMap.set(seriesModel.uid, seriesModel);
                });
            });
        });
        return seriesModelMap;
    },
    modifyOutputEnd: true,
    // Consider appendData, where filter should be performed. Because data process is
    // in block mode currently, it is not need to worry about that the overallProgress
    // execute every frame.
    overallReset: function(ecModel, api) {
        ecModel.eachComponent("dataZoom", function(dataZoomModel) {
            // We calculate window and reset axis here but not in model
            // init stage and not after action dispatch handler, because
            // reset should be called after seriesData.restoreData.
            dataZoomModel.eachTargetAxis(function(dimNames, axisIndex, dataZoomModel) {
                dataZoomModel.getAxisProxy(dimNames.name, axisIndex).reset(dataZoomModel, api);
            }); // Caution: data zoom filtering is order sensitive when using
            // percent range and no min/max/scale set on axis.
            // For example, we have dataZoom definition:
            // [
            //      {xAxisIndex: 0, start: 30, end: 70},
            //      {yAxisIndex: 0, start: 20, end: 80}
            // ]
            // In this case, [20, 80] of y-dataZoom should be based on data
            // that have filtered by x-dataZoom using range of [30, 70],
            // but should not be based on full raw data. Thus sliding
            // x-dataZoom will change both ranges of xAxis and yAxis,
            // while sliding y-dataZoom will only change the range of yAxis.
            // So we should filter x-axis after reset x-axis immediately,
            // and then reset y-axis and filter y-axis.
            dataZoomModel.eachTargetAxis(function(dimNames, axisIndex, dataZoomModel) {
                dataZoomModel.getAxisProxy(dimNames.name, axisIndex).filterData(dataZoomModel, api);
            });
        });
        ecModel.eachComponent("dataZoom", function(dataZoomModel) {
            // Fullfill all of the range props so that user
            // is able to get them from chart.getOption().
            var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
            var percentRange = axisProxy.getDataPercentWindow();
            var valueRange = axisProxy.getDataValueWindow();
            dataZoomModel.setCalculatedRange({
                start: percentRange[0],
                end: percentRange[1],
                startValue: valueRange[0],
                endValue: valueRange[1]
            });
        });
    }
});


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerAction("dataZoom", function(payload, ecModel) {
    var linkedNodesFinder = $13a67f461dae48b9$export$88f56b430ae5fcfa($ec279652dd95c27b$export$2385a24977818dd0(ecModel.eachComponent, ecModel, "dataZoom"), $13a67f461dae48b9$export$5f8200ec3576e138, function(model, dimNames) {
        return model.get(dimNames.axisIndex);
    });
    var effectedModels = [];
    ecModel.eachComponent({
        mainType: "dataZoom",
        query: payload
    }, function(model, index) {
        effectedModels.push.apply(effectedModels, linkedNodesFinder(model).nodes);
    });
    $ec279652dd95c27b$export$79b2f7037acddd43(effectedModels, function(dataZoomModel, index) {
        dataZoomModel.setRawRange({
            start: payload.start,
            end: payload.end,
            startValue: payload.startValue,
            endValue: payload.endValue
        });
    });
});




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Use dataZoomSelect
var $643b599947e36d1f$var$dataZoomLang = $136ae13721f5e257$exports.toolbox.dataZoom;
var $643b599947e36d1f$var$each = $ec279652dd95c27b$export$79b2f7037acddd43; // Spectial component id start with \0ec\0, see echarts/model/Global.js~hasInnerId
var $643b599947e36d1f$var$DATA_ZOOM_ID_BASE = "\x00_ec_\x00toolbox-dataZoom_";
function $643b599947e36d1f$var$DataZoom(model, ecModel, api) {
    /**
   * @private
   * @type {module:echarts/component/helper/BrushController}
   */ (this._brushController = new $32947641224f901a$exports(api.getZr())).on("brush", $ec279652dd95c27b$export$2385a24977818dd0(this._onBrush, this)).mount();
    /**
   * @private
   * @type {boolean}
   */ this._isZoomActive;
}
$643b599947e36d1f$var$DataZoom.defaultOption = {
    show: true,
    filterMode: "filter",
    // Icon group
    icon: {
        zoom: "M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1",
        back: "M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26"
    },
    // `zoom`, `back`
    title: $ec279652dd95c27b$export$9cd59f9826255e47($643b599947e36d1f$var$dataZoomLang.title),
    brushStyle: {
        borderWidth: 0,
        color: "rgba(0,0,0,0.2)"
    }
};
var $643b599947e36d1f$var$proto = $643b599947e36d1f$var$DataZoom.prototype;
$643b599947e36d1f$var$proto.render = function(featureModel, ecModel, api, payload) {
    this.model = featureModel;
    this.ecModel = ecModel;
    this.api = api;
    $643b599947e36d1f$var$updateZoomBtnStatus(featureModel, ecModel, this, payload, api);
    $643b599947e36d1f$var$updateBackBtnStatus(featureModel, ecModel);
};
$643b599947e36d1f$var$proto.onclick = function(ecModel, api, type) {
    $643b599947e36d1f$var$handlers[type].call(this);
};
$643b599947e36d1f$var$proto.remove = function(ecModel, api) {
    this._brushController.unmount();
};
$643b599947e36d1f$var$proto.dispose = function(ecModel, api) {
    this._brushController.dispose();
};
/**
 * @private
 */ var $643b599947e36d1f$var$handlers = {
    zoom: function() {
        var nextActive = !this._isZoomActive;
        this.api.dispatchAction({
            type: "takeGlobalCursor",
            key: "dataZoomSelect",
            dataZoomSelectActive: nextActive
        });
    },
    back: function() {
        this._dispatchZoomAction($607093a8ca9b646d$export$3e41007ebfff0e64(this.ecModel));
    }
};
/**
 * @private
 */ $643b599947e36d1f$var$proto._onBrush = function(areas, opt) {
    if (!opt.isEnd || !areas.length) return;
    var snapshot = {};
    var ecModel = this.ecModel;
    this._brushController.updateCovers([]); // remove cover
    var brushTargetManager = new $0f8d0342fd643dbc$exports($643b599947e36d1f$var$retrieveAxisSetting(this.model.option), ecModel, {
        include: [
            "grid"
        ]
    });
    brushTargetManager.matchOutputRanges(areas, ecModel, function(area, coordRange, coordSys) {
        if (coordSys.type !== "cartesian2d") return;
        var brushType = area.brushType;
        if (brushType === "rect") {
            setBatch("x", coordSys, coordRange[0]);
            setBatch("y", coordSys, coordRange[1]);
        } else setBatch({
            lineX: "x",
            lineY: "y"
        }[brushType], coordSys, coordRange);
    });
    $607093a8ca9b646d$export$4cbf152802aa238(ecModel, snapshot);
    this._dispatchZoomAction(snapshot);
    function setBatch(dimName, coordSys, minMax) {
        var axis = coordSys.getAxis(dimName);
        var axisModel = axis.model;
        var dataZoomModel = findDataZoom(dimName, axisModel, ecModel); // Restrict range.
        var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy(axisModel).getMinMaxSpan();
        if (minMaxSpan.minValueSpan != null || minMaxSpan.maxValueSpan != null) minMax = $1d1b44fc5f576d07$exports(0, minMax.slice(), axis.scale.getExtent(), 0, minMaxSpan.minValueSpan, minMaxSpan.maxValueSpan);
        dataZoomModel && (snapshot[dataZoomModel.id] = {
            dataZoomId: dataZoomModel.id,
            startValue: minMax[0],
            endValue: minMax[1]
        });
    }
    function findDataZoom(dimName, axisModel, ecModel) {
        var found;
        ecModel.eachComponent({
            mainType: "dataZoom",
            subType: "select"
        }, function(dzModel) {
            var has = dzModel.getAxisModel(dimName, axisModel.componentIndex);
            has && (found = dzModel);
        });
        return found;
    }
};
/**
 * @private
 */ $643b599947e36d1f$var$proto._dispatchZoomAction = function(snapshot) {
    var batch = []; // Convert from hash map to array.
    $643b599947e36d1f$var$each(snapshot, function(batchItem, dataZoomId) {
        batch.push($ec279652dd95c27b$export$9cd59f9826255e47(batchItem));
    });
    batch.length && this.api.dispatchAction({
        type: "dataZoom",
        from: this.uid,
        batch: batch
    });
};
function $643b599947e36d1f$var$retrieveAxisSetting(option) {
    var setting = {}; // Compatible with previous setting: null => all axis, false => no axis.
    $ec279652dd95c27b$export$79b2f7037acddd43([
        "xAxisIndex",
        "yAxisIndex"
    ], function(name) {
        setting[name] = option[name];
        setting[name] == null && (setting[name] = "all");
        (setting[name] === false || setting[name] === "none") && (setting[name] = []);
    });
    return setting;
}
function $643b599947e36d1f$var$updateBackBtnStatus(featureModel, ecModel) {
    featureModel.setIconStatus("back", $607093a8ca9b646d$export$85b9a36db797e02b(ecModel) > 1 ? "emphasis" : "normal");
}
function $643b599947e36d1f$var$updateZoomBtnStatus(featureModel, ecModel, view, payload, api) {
    var zoomActive = view._isZoomActive;
    if (payload && payload.type === "takeGlobalCursor") zoomActive = payload.key === "dataZoomSelect" ? payload.dataZoomSelectActive : false;
    view._isZoomActive = zoomActive;
    featureModel.setIconStatus("zoom", zoomActive ? "emphasis" : "normal");
    var brushTargetManager = new $0f8d0342fd643dbc$exports($643b599947e36d1f$var$retrieveAxisSetting(featureModel.option), ecModel, {
        include: [
            "grid"
        ]
    });
    view._brushController.setPanels(brushTargetManager.makePanelOpts(api, function(targetInfo) {
        return targetInfo.xAxisDeclared && !targetInfo.yAxisDeclared ? "lineX" : !targetInfo.xAxisDeclared && targetInfo.yAxisDeclared ? "lineY" : "rect";
    })).enableBrush(zoomActive ? {
        brushType: "auto",
        brushStyle: featureModel.getModel("brushStyle").getItemStyle()
    } : false);
}
$d50e8440ce792ca2$export$6503ec6e8aabbaf("dataZoom", $643b599947e36d1f$var$DataZoom); // Create special dataZoom option for select
// FIXME consider the case of merge option, where axes options are not exists.
$f406636b535430a7$exports.registerPreprocessor(function(option) {
    if (!option) return;
    var dataZoomOpts = option.dataZoom || (option.dataZoom = []);
    if (!$ec279652dd95c27b$export$43bee75e5e14138e(dataZoomOpts)) option.dataZoom = dataZoomOpts = [
        dataZoomOpts
    ];
    var toolboxOpt = option.toolbox;
    if (toolboxOpt) {
        // Assume there is only one toolbox
        if ($ec279652dd95c27b$export$43bee75e5e14138e(toolboxOpt)) toolboxOpt = toolboxOpt[0];
        if (toolboxOpt && toolboxOpt.feature) {
            var dataZoomOpt = toolboxOpt.feature.dataZoom; // FIXME: If add dataZoom when setOption in merge mode,
            // no axis info to be added. See `test/dataZoom-extreme.html`
            addForAxis("xAxis", dataZoomOpt);
            addForAxis("yAxis", dataZoomOpt);
        }
    }
    function addForAxis(axisName, dataZoomOpt) {
        if (!dataZoomOpt) return;
         // Try not to modify model, because it is not merged yet.
        var axisIndicesName = axisName + "Index";
        var givenAxisIndices = dataZoomOpt[axisIndicesName];
        if (givenAxisIndices != null && givenAxisIndices !== "all" && !$ec279652dd95c27b$export$43bee75e5e14138e(givenAxisIndices)) givenAxisIndices = givenAxisIndices === false || givenAxisIndices === "none" ? [] : [
            givenAxisIndices
        ];
        forEachComponent(axisName, function(axisOpt, axisIndex) {
            if (givenAxisIndices != null && givenAxisIndices !== "all" && $ec279652dd95c27b$export$305f7d4e9d4624f2(givenAxisIndices, axisIndex) === -1) return;
            var newOpt = {
                type: "select",
                $fromToolbox: true,
                // Default to be filter
                filterMode: dataZoomOpt.filterMode || "filter",
                // Id for merge mapping.
                id: $643b599947e36d1f$var$DATA_ZOOM_ID_BASE + axisName + axisIndex
            }; // FIXME
            // Only support one axis now.
            newOpt[axisIndicesName] = axisIndex;
            dataZoomOpts.push(newOpt);
        });
    }
    function forEachComponent(mainType, cb) {
        var opts = option[mainType];
        if (!$ec279652dd95c27b$export$43bee75e5e14138e(opts)) opts = opts ? [
            opts
        ] : [];
        $643b599947e36d1f$var$each(opts, cb);
    }
});
var $643b599947e36d1f$var$_default = $643b599947e36d1f$var$DataZoom;
$643b599947e36d1f$exports = $643b599947e36d1f$var$_default;


var $7944666d79bbe1de$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $7944666d79bbe1de$var$restoreLang = $136ae13721f5e257$exports.toolbox.restore;
function $7944666d79bbe1de$var$Restore(model) {
    this.model = model;
}
$7944666d79bbe1de$var$Restore.defaultOption = {
    show: true,
    /* eslint-disable */ icon: "M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5",
    /* eslint-enable */ title: $7944666d79bbe1de$var$restoreLang.title
};
var $7944666d79bbe1de$var$proto = $7944666d79bbe1de$var$Restore.prototype;
$7944666d79bbe1de$var$proto.onclick = function(ecModel, api, type) {
    $607093a8ca9b646d$export$42ffd38884aecdac(ecModel);
    api.dispatchAction({
        type: "restore",
        from: this.uid
    });
};
$d50e8440ce792ca2$export$6503ec6e8aabbaf("restore", $7944666d79bbe1de$var$Restore);
$f406636b535430a7$exports.registerAction({
    type: "restore",
    event: "restore",
    update: "prepareAndUpdate"
}, function(payload, ecModel) {
    ecModel.resetOption("recreate");
});
var $7944666d79bbe1de$var$_default = $7944666d79bbe1de$var$Restore;
$7944666d79bbe1de$exports = $7944666d79bbe1de$var$_default;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $8a2d0e38de8a76ea$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $8a2d0e38de8a76ea$var$_default = $f406636b535430a7$exports.extendComponentModel({
    type: "tooltip",
    dependencies: [
        "axisPointer"
    ],
    defaultOption: {
        zlevel: 0,
        z: 60,
        show: true,
        // tooltip主体内容
        showContent: true,
        // 'trigger' only works on coordinate system.
        // 'item' | 'axis' | 'none'
        trigger: "item",
        // 'click' | 'mousemove' | 'none'
        triggerOn: "mousemove|click",
        alwaysShowContent: false,
        displayMode: "single",
        // 'single' | 'multipleByCoordSys'
        renderMode: "auto",
        // 'auto' | 'html' | 'richText'
        // 'auto': use html by default, and use non-html if `document` is not defined
        // 'html': use html for tooltip
        // 'richText': use canvas, svg, and etc. for tooltip
        // 位置 {Array} | {Function}
        // position: null
        // Consider triggered from axisPointer handle, verticalAlign should be 'middle'
        // align: null,
        // verticalAlign: null,
        // 是否约束 content 在 viewRect 中。默认 false 是为了兼容以前版本。
        confine: false,
        // 内容格式器：{string}（Template） ¦ {Function}
        // formatter: null
        showDelay: 0,
        // 隐藏延迟，单位ms
        hideDelay: 100,
        // 动画变换时间，单位s
        transitionDuration: 0.4,
        enterable: false,
        // 提示背景颜色，默认为透明度为0.7的黑色
        backgroundColor: "rgba(50,50,50,0.7)",
        // 提示边框颜色
        borderColor: "#333",
        // 提示边框圆角，单位px，默认为4
        borderRadius: 4,
        // 提示边框线宽，单位px，默认为0（无边框）
        borderWidth: 0,
        // 提示内边距，单位px，默认各方向内边距为5，
        // 接受数组分别设定上右下左边距，同css
        padding: 5,
        // Extra css text
        extraCssText: "",
        // 坐标轴指示器，坐标轴触发有效
        axisPointer: {
            // 默认为直线
            // 可选为：'line' | 'shadow' | 'cross'
            type: "line",
            // type 为 line 的时候有效，指定 tooltip line 所在的轴，可选
            // 可选 'x' | 'y' | 'angle' | 'radius' | 'auto'
            // 默认 'auto'，会选择类型为 category 的轴，对于双数值轴，笛卡尔坐标系会默认选择 x 轴
            // 极坐标系会默认选择 angle 轴
            axis: "auto",
            animation: "auto",
            animationDurationUpdate: 200,
            animationEasingUpdate: "exponentialOut",
            crossStyle: {
                color: "#999",
                width: 1,
                type: "dashed",
                // TODO formatter
                textStyle: {} // lineStyle and shadowStyle should not be specified here,
            }
        },
        textStyle: {
            color: "#fff",
            fontSize: 14
        }
    }
});
$8a2d0e38de8a76ea$exports = $8a2d0e38de8a76ea$var$_default;


var $86c35e57e4ce9190$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $af2f90d0022157bb$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $af2f90d0022157bb$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $af2f90d0022157bb$var$toCamelCase = $a4be9366aeb9fcc8$export$86f54f62aa7a7514;
var $af2f90d0022157bb$var$vendors = [
    "",
    "-webkit-",
    "-moz-",
    "-o-"
];
var $af2f90d0022157bb$var$gCssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;";
/**
 * @param {number} duration
 * @return {string}
 * @inner
 */ function $af2f90d0022157bb$var$assembleTransition(duration) {
    var transitionCurve = "cubic-bezier(0.23, 1, 0.32, 1)";
    var transitionText = "left " + duration + "s " + transitionCurve + "," + "top " + duration + "s " + transitionCurve;
    return $ec279652dd95c27b$export$871de8747c9eaa88($af2f90d0022157bb$var$vendors, function(vendorPrefix) {
        return vendorPrefix + "transition:" + transitionText;
    }).join(";");
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */ function $af2f90d0022157bb$var$assembleFont(textStyleModel) {
    var cssText = [];
    var fontSize = textStyleModel.get("fontSize");
    var color = textStyleModel.getTextColor();
    color && cssText.push("color:" + color);
    cssText.push("font:" + textStyleModel.getFont());
    var lineHeight = textStyleModel.get("lineHeight");
    if (lineHeight == null) lineHeight = Math.round(fontSize * 3 / 2);
    fontSize && cssText.push("line-height:" + lineHeight + "px");
    var shadowColor = textStyleModel.get("textShadowColor");
    var shadowBlur = textStyleModel.get("textShadowBlur") || 0;
    var shadowOffsetX = textStyleModel.get("textShadowOffsetX") || 0;
    var shadowOffsetY = textStyleModel.get("textShadowOffsetY") || 0;
    shadowBlur && cssText.push("text-shadow:" + shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor);
    $af2f90d0022157bb$var$each([
        "decoration",
        "align"
    ], function(name) {
        var val = textStyleModel.get(name);
        val && cssText.push("text-" + name + ":" + val);
    });
    return cssText.join(";");
}
/**
 * @param {Object} tooltipModel
 * @return {string}
 * @inner
 */ function $af2f90d0022157bb$var$assembleCssText(tooltipModel) {
    var cssText = [];
    var transitionDuration = tooltipModel.get("transitionDuration");
    var backgroundColor = tooltipModel.get("backgroundColor");
    var textStyleModel = tooltipModel.getModel("textStyle");
    var padding = tooltipModel.get("padding"); // Animation transition. Do not animate when transitionDuration is 0.
    transitionDuration && cssText.push($af2f90d0022157bb$var$assembleTransition(transitionDuration));
    if (backgroundColor) {
        if ($27ac1413ecc67076$exports.canvasSupported) cssText.push("background-Color:" + backgroundColor);
        else {
            // for ie
            cssText.push("background-Color:#" + $b1179c91b052e827$export$7ea66e3774a60b67(backgroundColor));
            cssText.push("filter:alpha(opacity=70)");
        }
    } // Border style
    $af2f90d0022157bb$var$each([
        "width",
        "color",
        "radius"
    ], function(name) {
        var borderName = "border-" + name;
        var camelCase = $af2f90d0022157bb$var$toCamelCase(borderName);
        var val = tooltipModel.get(camelCase);
        val != null && cssText.push(borderName + ":" + val + (name === "color" ? "" : "px"));
    }); // Text style
    cssText.push($af2f90d0022157bb$var$assembleFont(textStyleModel)); // Padding
    if (padding != null) cssText.push("padding:" + $a4be9366aeb9fcc8$export$f3a38102c49f4268(padding).join("px ") + "px");
    return cssText.join(";") + ";";
} // If not able to make, do not modify the input `out`.
function $af2f90d0022157bb$var$makeStyleCoord(out, zr, appendToBody, zrX, zrY) {
    var zrPainter = zr && zr.painter;
    if (appendToBody) {
        var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
        if (zrViewportRoot) // Some APPs might use scale on body, so we support CSS transform here.
        $41f9987155a2665f$export$8c5c02e118307e20(out, zrViewportRoot, document.body, zrX, zrY);
    } else {
        out[0] = zrX;
        out[1] = zrY; // xy should be based on canvas root. But tooltipContent is
        // the sibling of canvas root. So padding of ec container
        // should be considered here.
        var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
        if (viewportRootOffset) {
            out[0] += viewportRootOffset.offsetLeft;
            out[1] += viewportRootOffset.offsetTop;
        }
    }
    out[2] = out[0] / zr.getWidth(); // The ratio of left to width
    out[3] = out[1] / zr.getHeight(); // The ratio of top to height
}
/**
 * @alias module:echarts/component/tooltip/TooltipContent
 * @param {HTMLElement} container
 * @param {ExtensionAPI} api
 * @param {Object} [opt]
 * @param {boolean} [opt.appendToBody]
 *        `false`: the DOM element will be inside the container. Default value.
 *        `true`: the DOM element will be appended to HTML body, which avoid
 *                some overflow clip but intrude outside of the container.
 * @constructor
 */ function $af2f90d0022157bb$var$TooltipContent(container, api, opt) {
    if ($27ac1413ecc67076$exports.wxa) return null;
    var el = document.createElement("div");
    el.domBelongToZr = true;
    this.el = el;
    var zr = this._zr = api.getZr();
    var appendToBody = this._appendToBody = opt && opt.appendToBody;
    this._styleCoord = [
        0,
        0,
        0,
        0
    ]; // [left, top, left/width, top/height]
    $af2f90d0022157bb$var$makeStyleCoord(this._styleCoord, zr, appendToBody, api.getWidth() / 2, api.getHeight() / 2);
    if (appendToBody) document.body.appendChild(el);
    else container.appendChild(el);
    this._container = container;
    this._show = false;
    /**
   * @private
   */ this._hideTimeout; // FIXME
    // Is it needed to trigger zr event manually if
    // the browser do not support `pointer-events: none`.
    var self = this;
    el.onmouseenter = function() {
        // clear the timeout in hideLater and keep showing tooltip
        if (self._enterable) {
            clearTimeout(self._hideTimeout);
            self._show = true;
        }
        self._inContent = true;
    };
    el.onmousemove = function(e) {
        e = e || window.event;
        if (!self._enterable) {
            // `pointer-events: none` is set to tooltip content div
            // if `enterable` is set as `false`, and `el.onmousemove`
            // can not be triggered. But in browser that do not
            // support `pointer-events`, we need to do this:
            // Try trigger zrender event to avoid mouse
            // in and out shape too frequently
            var handler = zr.handler;
            var zrViewportRoot = zr.painter.getViewportRoot();
            $adca58e5ac25631a$export$40fadb093aebad71(zrViewportRoot, e, true);
            handler.dispatch("mousemove", e);
        }
    };
    el.onmouseleave = function() {
        if (self._enterable) {
            if (self._show) self.hideLater(self._hideDelay);
        }
        self._inContent = false;
    };
}
$af2f90d0022157bb$var$TooltipContent.prototype = {
    constructor: $af2f90d0022157bb$var$TooltipContent,
    /**
   * @private
   * @type {boolean}
   */ _enterable: true,
    /**
   * Update when tooltip is rendered
   */ update: function(tooltipModel) {
        // FIXME
        // Move this logic to ec main?
        var container = this._container;
        var stl = container.currentStyle || document.defaultView.getComputedStyle(container);
        var domStyle = container.style;
        if (domStyle.position !== "absolute" && stl.position !== "absolute") domStyle.position = "relative";
        var alwaysShowContent = tooltipModel.get("alwaysShowContent");
        alwaysShowContent && this._moveTooltipIfResized(); // Hide the tooltip
    // PENDING
    // this.hide();
    },
    /**
   * when `alwaysShowContent` is true,
   * we should move the tooltip after chart resized
   */ _moveTooltipIfResized: function() {
        var ratioX = this._styleCoord[2]; // The ratio of left to width
        var ratioY = this._styleCoord[3]; // The ratio of top to height
        var realX = ratioX * this._zr.getWidth();
        var realY = ratioY * this._zr.getHeight();
        this.moveTo(realX, realY);
    },
    show: function(tooltipModel) {
        clearTimeout(this._hideTimeout);
        var el = this.el;
        var styleCoord = this._styleCoord;
        el.style.cssText = $af2f90d0022157bb$var$gCssText + $af2f90d0022157bb$var$assembleCssText(tooltipModel) // Because of the reason described in:
         + ";left:" + styleCoord[0] + "px;top:" + styleCoord[1] + "px;" + (tooltipModel.get("extraCssText") || "");
        el.style.display = el.innerHTML ? "block" : "none"; // If mouse occasionally move over the tooltip, a mouseout event will be
        // triggered by canvas, and cause some unexpectable result like dragging
        // stop, "unfocusAdjacency". Here `pointer-events: none` is used to solve
        // it. Although it is not supported by IE8~IE10, fortunately it is a rare
        // scenario.
        el.style.pointerEvents = this._enterable ? "auto" : "none";
        this._show = true;
    },
    setContent: function(content) {
        this.el.innerHTML = content == null ? "" : content;
    },
    setEnterable: function(enterable) {
        this._enterable = enterable;
    },
    getSize: function() {
        var el = this.el;
        return [
            el.clientWidth,
            el.clientHeight
        ];
    },
    moveTo: function(zrX, zrY) {
        var styleCoord = this._styleCoord;
        $af2f90d0022157bb$var$makeStyleCoord(styleCoord, this._zr, this._appendToBody, zrX, zrY);
        var style = this.el.style;
        style.left = styleCoord[0] + "px";
        style.top = styleCoord[1] + "px";
    },
    hide: function() {
        this.el.style.display = "none";
        this._show = false;
    },
    hideLater: function(time) {
        if (this._show && !(this._inContent && this._enterable)) {
            if (time) {
                this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout($ec279652dd95c27b$export$2385a24977818dd0(this.hide, this), time);
            } else this.hide();
        }
    },
    isShow: function() {
        return this._show;
    },
    dispose: function() {
        this.el.parentNode.removeChild(this.el);
    },
    getOuterSize: function() {
        var width = this.el.clientWidth;
        var height = this.el.clientHeight; // Consider browser compatibility.
        // IE8 does not support getComputedStyle.
        if (document.defaultView && document.defaultView.getComputedStyle) {
            var stl = document.defaultView.getComputedStyle(this.el);
            if (stl) {
                width += parseInt(stl.borderLeftWidth, 10) + parseInt(stl.borderRightWidth, 10);
                height += parseInt(stl.borderTopWidth, 10) + parseInt(stl.borderBottomWidth, 10);
            }
        }
        return {
            width: width,
            height: height
        };
    }
};
var $af2f90d0022157bb$var$_default = $af2f90d0022157bb$var$TooltipContent;
$af2f90d0022157bb$exports = $af2f90d0022157bb$var$_default;


var $e5c126d5360a689f$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // import Group from 'zrender/src/container/Group';
function $e5c126d5360a689f$var$makeStyleCoord(out, zr, zrX, zrY) {
    out[0] = zrX;
    out[1] = zrY;
    out[2] = out[0] / zr.getWidth(); // The ratio of left to width
    out[3] = out[1] / zr.getHeight(); // The ratio of top to height
}
/**
 * @alias module:echarts/component/tooltip/TooltipRichContent
 * @constructor
 */ function $e5c126d5360a689f$var$TooltipRichContent(api) {
    var zr = this._zr = api.getZr();
    this._styleCoord = [
        0,
        0,
        0,
        0
    ]; // [left, top, left/width, top/height]
    $e5c126d5360a689f$var$makeStyleCoord(this._styleCoord, zr, api.getWidth() / 2, api.getHeight() / 2);
    this._show = false;
    /**
   * @private
   */ this._hideTimeout;
}
$e5c126d5360a689f$var$TooltipRichContent.prototype = {
    constructor: $e5c126d5360a689f$var$TooltipRichContent,
    /**
   * @private
   * @type {boolean}
   */ _enterable: true,
    /**
   * Update when tooltip is rendered
   */ update: function(tooltipModel) {
        var alwaysShowContent = tooltipModel.get("alwaysShowContent");
        alwaysShowContent && this._moveTooltipIfResized();
    },
    /**
   * when `alwaysShowContent` is true,
   * we should move the tooltip after chart resized
   */ _moveTooltipIfResized: function() {
        var ratioX = this._styleCoord[2]; // The ratio of left to width
        var ratioY = this._styleCoord[3]; // The ratio of top to height
        var realX = ratioX * this._zr.getWidth();
        var realY = ratioY * this._zr.getHeight();
        this.moveTo(realX, realY);
    },
    show: function(tooltipModel) {
        if (this._hideTimeout) clearTimeout(this._hideTimeout);
        this.el.attr("show", true);
        this._show = true;
    },
    /**
   * Set tooltip content
   *
   * @param {string} content rich text string of content
   * @param {Object} markerRich rich text style
   * @param {Object} tooltipModel tooltip model
   */ setContent: function(content, markerRich, tooltipModel) {
        if (this.el) this._zr.remove(this.el);
        var markers = {};
        var text = content;
        var prefix = "{marker";
        var suffix = "|}";
        var startId = text.indexOf(prefix);
        while(startId >= 0){
            var endId = text.indexOf(suffix);
            var name = text.substr(startId + prefix.length, endId - startId - prefix.length);
            if (name.indexOf("sub") > -1) markers["marker" + name] = {
                textWidth: 4,
                textHeight: 4,
                textBorderRadius: 2,
                textBackgroundColor: markerRich[name],
                // TODO: textOffset is not implemented for rich text
                textOffset: [
                    3,
                    0
                ]
            };
            else markers["marker" + name] = {
                textWidth: 10,
                textHeight: 10,
                textBorderRadius: 5,
                textBackgroundColor: markerRich[name]
            };
            text = text.substr(endId + 1);
            startId = text.indexOf("{marker");
        }
        var textStyleModel = tooltipModel.getModel("textStyle");
        var fontSize = textStyleModel.get("fontSize");
        var lineHeight = tooltipModel.get("textLineHeight");
        if (lineHeight == null) lineHeight = Math.round(fontSize * 3 / 2);
        this.el = new $2fc81b997a587c68$exports({
            style: $4b57d6b582d579b7$export$6605af501964d89a({}, textStyleModel, {
                rich: markers,
                text: content,
                textBackgroundColor: tooltipModel.get("backgroundColor"),
                textBorderRadius: tooltipModel.get("borderRadius"),
                textFill: tooltipModel.get("textStyle.color"),
                textPadding: tooltipModel.get("padding"),
                textLineHeight: lineHeight
            }),
            z: tooltipModel.get("z")
        });
        this._zr.add(this.el);
        var self = this;
        this.el.on("mouseover", function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        });
        this.el.on("mouseout", function() {
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
            self._inContent = false;
        });
    },
    setEnterable: function(enterable) {
        this._enterable = enterable;
    },
    getSize: function() {
        var bounding = this.el.getBoundingRect();
        return [
            bounding.width,
            bounding.height
        ];
    },
    moveTo: function(x, y) {
        if (this.el) {
            var styleCoord = this._styleCoord;
            $e5c126d5360a689f$var$makeStyleCoord(styleCoord, this._zr, x, y);
            this.el.attr("position", [
                styleCoord[0],
                styleCoord[1]
            ]);
        }
    },
    hide: function() {
        if (this.el) this.el.hide();
        this._show = false;
    },
    hideLater: function(time) {
        if (this._show && !(this._inContent && this._enterable)) {
            if (time) {
                this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout($ec279652dd95c27b$export$2385a24977818dd0(this.hide, this), time);
            } else this.hide();
        }
    },
    isShow: function() {
        return this._show;
    },
    dispose: function() {
        clearTimeout(this._hideTimeout);
        if (this.el) this._zr.remove(this.el);
    },
    getOuterSize: function() {
        var size = this.getSize();
        return {
            width: size[0],
            height: size[1]
        };
    }
};
var $e5c126d5360a689f$var$_default = $e5c126d5360a689f$var$TooltipRichContent;
$e5c126d5360a689f$exports = $e5c126d5360a689f$var$_default;












var $86c35e57e4ce9190$var$getTooltipRenderMode = $d559f43cb9041423$export$cc0a17a5d27b4e17;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $86c35e57e4ce9190$var$bind = $ec279652dd95c27b$export$2385a24977818dd0;
var $86c35e57e4ce9190$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $86c35e57e4ce9190$var$parsePercent = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f;
var $86c35e57e4ce9190$var$proxyRect = new $4b57d6b582d579b7$export$c79fc6492f3af13d({
    shape: {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    }
});
var $86c35e57e4ce9190$var$_default = $f406636b535430a7$exports.extendComponentView({
    type: "tooltip",
    init: function(ecModel, api) {
        if ($27ac1413ecc67076$exports.node) return;
        var tooltipModel = ecModel.getComponent("tooltip");
        var renderMode = tooltipModel.get("renderMode");
        this._renderMode = $86c35e57e4ce9190$var$getTooltipRenderMode(renderMode);
        var tooltipContent;
        if (this._renderMode === "html") {
            tooltipContent = new $af2f90d0022157bb$exports(api.getDom(), api, {
                appendToBody: tooltipModel.get("appendToBody", true)
            });
            this._newLine = "<br/>";
        } else {
            tooltipContent = new $e5c126d5360a689f$exports(api);
            this._newLine = "\n";
        }
        this._tooltipContent = tooltipContent;
    },
    render: function(tooltipModel, ecModel, api) {
        if ($27ac1413ecc67076$exports.node) return;
         // Reset
        this.group.removeAll();
        /**
     * @private
     * @type {module:echarts/component/tooltip/TooltipModel}
     */ this._tooltipModel = tooltipModel;
        /**
     * @private
     * @type {module:echarts/model/Global}
     */ this._ecModel = ecModel;
        /**
     * @private
     * @type {module:echarts/ExtensionAPI}
     */ this._api = api;
        /**
     * Should be cleaned when render.
     * @private
     * @type {Array.<Array.<Object>>}
     */ this._lastDataByCoordSys = null;
        /**
     * @private
     * @type {boolean}
     */ this._alwaysShowContent = tooltipModel.get("alwaysShowContent");
        var tooltipContent = this._tooltipContent;
        tooltipContent.update(tooltipModel);
        tooltipContent.setEnterable(tooltipModel.get("enterable"));
        this._initGlobalListener();
        this._keepShow();
    },
    _initGlobalListener: function() {
        var tooltipModel = this._tooltipModel;
        var triggerOn = tooltipModel.get("triggerOn");
        $5e44907374287613$export$6503ec6e8aabbaf("itemTooltip", this._api, $86c35e57e4ce9190$var$bind(function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== "none") {
                if (triggerOn.indexOf(currTrigger) >= 0) this._tryShow(e, dispatchAction);
                else if (currTrigger === "leave") this._hide(dispatchAction);
            }
        }, this));
    },
    _keepShow: function() {
        var tooltipModel = this._tooltipModel;
        var ecModel = this._ecModel;
        var api = this._api; // Try to keep the tooltip show when refreshing
        if (this._lastX != null && this._lastY != null // When user is willing to control tooltip totally using API,
         && tooltipModel.get("triggerOn") !== "none") {
            var self = this;
            clearTimeout(this._refreshUpdateTimeout);
            this._refreshUpdateTimeout = setTimeout(function() {
                // Show tip next tick after other charts are rendered
                // In case highlight action has wrong result
                // FIXME
                !api.isDisposed() && self.manuallyShowTip(tooltipModel, ecModel, api, {
                    x: self._lastX,
                    y: self._lastY
                });
            });
        }
    },
    /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */ manuallyShowTip: function(tooltipModel, ecModel, api, payload) {
        if (payload.from === this.uid || $27ac1413ecc67076$exports.node) return;
        var dispatchAction = $86c35e57e4ce9190$var$makeDispatchAction(payload, api); // Reset ticket
        this._ticket = ""; // When triggered from axisPointer.
        var dataByCoordSys = payload.dataByCoordSys;
        if (payload.tooltip && payload.x != null && payload.y != null) {
            var el = $86c35e57e4ce9190$var$proxyRect;
            el.position = [
                payload.x,
                payload.y
            ];
            el.update();
            el.tooltip = payload.tooltip; // Manually show tooltip while view is not using zrender elements.
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                target: el
            }, dispatchAction);
        } else if (dataByCoordSys) this._tryShow({
            offsetX: payload.x,
            offsetY: payload.y,
            position: payload.position,
            dataByCoordSys: payload.dataByCoordSys,
            tooltipOption: payload.tooltipOption
        }, dispatchAction);
        else if (payload.seriesIndex != null) {
            if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) return;
            var pointInfo = $764073131e463cfe$exports(payload, ecModel);
            var cx = pointInfo.point[0];
            var cy = pointInfo.point[1];
            if (cx != null && cy != null) this._tryShow({
                offsetX: cx,
                offsetY: cy,
                position: payload.position,
                target: pointInfo.el
            }, dispatchAction);
        } else if (payload.x != null && payload.y != null) {
            // FIXME
            // should wrap dispatchAction like `axisPointer/globalListener` ?
            api.dispatchAction({
                type: "updateAxisPointer",
                x: payload.x,
                y: payload.y
            });
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                position: payload.position,
                target: api.getZr().findHover(payload.x, payload.y).target
            }, dispatchAction);
        }
    },
    manuallyHideTip: function(tooltipModel, ecModel, api, payload) {
        var tooltipContent = this._tooltipContent;
        if (!this._alwaysShowContent && this._tooltipModel) tooltipContent.hideLater(this._tooltipModel.get("hideDelay"));
        this._lastX = this._lastY = null;
        if (payload.from !== this.uid) this._hide($86c35e57e4ce9190$var$makeDispatchAction(payload, api));
    },
    // Be compatible with previous design, that is, when tooltip.type is 'axis' and
    // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
    // and tooltip.
    _manuallyAxisShowTip: function(tooltipModel, ecModel, api, payload) {
        var seriesIndex = payload.seriesIndex;
        var dataIndex = payload.dataIndex;
        var coordSysAxesInfo = ecModel.getComponent("axisPointer").coordSysAxesInfo;
        if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) return;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        if (!seriesModel) return;
        var data = seriesModel.getData();
        var tooltipModel = $86c35e57e4ce9190$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            seriesModel,
            (seriesModel.coordinateSystem || {}).model,
            tooltipModel
        ]);
        if (tooltipModel.get("trigger") !== "axis") return;
        api.dispatchAction({
            type: "updateAxisPointer",
            seriesIndex: seriesIndex,
            dataIndex: dataIndex,
            position: payload.position
        });
        return true;
    },
    _tryShow: function(e, dispatchAction) {
        var el = e.target;
        var tooltipModel = this._tooltipModel;
        if (!tooltipModel) return;
         // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
        this._lastX = e.offsetX;
        this._lastY = e.offsetY;
        var dataByCoordSys = e.dataByCoordSys;
        if (dataByCoordSys && dataByCoordSys.length) this._showAxisTooltip(dataByCoordSys, e);
        else if (el && el.dataIndex != null) {
            this._lastDataByCoordSys = null;
            this._showSeriesItemTooltip(e, el, dispatchAction);
        } else if (el && el.tooltip) {
            this._lastDataByCoordSys = null;
            this._showComponentItemTooltip(e, el, dispatchAction);
        } else {
            this._lastDataByCoordSys = null;
            this._hide(dispatchAction);
        }
    },
    _showOrMove: function(tooltipModel, cb) {
        // showDelay is used in this case: tooltip.enterable is set
        // as true. User intent to move mouse into tooltip and click
        // something. `showDelay` makes it easier to enter the content
        // but tooltip do not move immediately.
        var delay = tooltipModel.get("showDelay");
        cb = $ec279652dd95c27b$export$2385a24977818dd0(cb, this);
        clearTimeout(this._showTimout);
        delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
    },
    _showAxisTooltip: function(dataByCoordSys, e) {
        var ecModel = this._ecModel;
        var globalTooltipModel = this._tooltipModel;
        var point = [
            e.offsetX,
            e.offsetY
        ];
        var singleDefaultHTML = [];
        var singleParamsList = [];
        var singleTooltipModel = $86c35e57e4ce9190$var$buildTooltipModel([
            e.tooltipOption,
            globalTooltipModel
        ]);
        var renderMode = this._renderMode;
        var newLine = this._newLine;
        var markers = {};
        $86c35e57e4ce9190$var$each(dataByCoordSys, function(itemCoordSys) {
            // var coordParamList = [];
            // var coordDefaultHTML = [];
            // var coordTooltipModel = buildTooltipModel([
            //     e.tooltipOption,
            //     itemCoordSys.tooltipOption,
            //     ecModel.getComponent(itemCoordSys.coordSysMainType, itemCoordSys.coordSysIndex),
            //     globalTooltipModel
            // ]);
            // var displayMode = coordTooltipModel.get('displayMode');
            // var paramsList = displayMode === 'single' ? singleParamsList : [];
            $86c35e57e4ce9190$var$each(itemCoordSys.dataByAxis, function(item) {
                var axisModel = ecModel.getComponent(item.axisDim + "Axis", item.axisIndex);
                var axisValue = item.value;
                var seriesDefaultHTML = [];
                if (!axisModel || axisValue == null) return;
                var valueLabel = $9a2d7ccde43eb492$export$7cffee0f9aed39d0(axisValue, axisModel.axis, ecModel, item.seriesDataIndices, item.valueLabelOpt);
                $ec279652dd95c27b$export$79b2f7037acddd43(item.seriesDataIndices, function(idxItem) {
                    var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
                    var dataIndex = idxItem.dataIndexInside;
                    var dataParams = series && series.getDataParams(dataIndex);
                    dataParams.axisDim = item.axisDim;
                    dataParams.axisIndex = item.axisIndex;
                    dataParams.axisType = item.axisType;
                    dataParams.axisId = item.axisId;
                    dataParams.axisValue = $13542623aa20eeae$export$a5a32f324c1fa457(axisModel.axis, axisValue);
                    dataParams.axisValueLabel = valueLabel;
                    if (dataParams) {
                        singleParamsList.push(dataParams);
                        var seriesTooltip = series.formatTooltip(dataIndex, true, null, renderMode);
                        var html;
                        if ($ec279652dd95c27b$export$a6cdc56e425d0d0a(seriesTooltip)) {
                            html = seriesTooltip.html;
                            var newMarkers = seriesTooltip.markers;
                            $ec279652dd95c27b$export$4950aa0f605343fb(markers, newMarkers);
                        } else html = seriesTooltip;
                        seriesDefaultHTML.push(html);
                    }
                }); // Default tooltip content
                // FIXME
                // (1) should be the first data which has name?
                // (2) themeRiver, firstDataIndex is array, and first line is unnecessary.
                var firstLine = valueLabel;
                if (renderMode !== "html") singleDefaultHTML.push(seriesDefaultHTML.join(newLine));
                else singleDefaultHTML.push((firstLine ? $a4be9366aeb9fcc8$export$f9d6449b9af28dc1(firstLine) + newLine : "") + seriesDefaultHTML.join(newLine));
            });
        }, this); // In most case, the second axis is shown upper than the first one.
        singleDefaultHTML.reverse();
        singleDefaultHTML = singleDefaultHTML.join(this._newLine + this._newLine);
        var positionExpr = e.position;
        this._showOrMove(singleTooltipModel, function() {
            if (this._updateContentNotChangedOnAxis(dataByCoordSys)) this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, singleParamsList);
            else this._showTooltipContent(singleTooltipModel, singleDefaultHTML, singleParamsList, Math.random(), point[0], point[1], positionExpr, undefined, markers);
        }); // Do not trigger events here, because this branch only be entered
    // from dispatchAction.
    },
    _showSeriesItemTooltip: function(e, el, dispatchAction) {
        var ecModel = this._ecModel; // Use dataModel in element if possible
        // Used when mouseover on a element like markPoint or edge
        // In which case, the data is not main data in series.
        var seriesIndex = el.seriesIndex;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex); // For example, graph link.
        var dataModel = el.dataModel || seriesModel;
        var dataIndex = el.dataIndex;
        var dataType = el.dataType;
        var data = dataModel.getData(dataType);
        var tooltipModel = $86c35e57e4ce9190$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            dataModel,
            seriesModel && (seriesModel.coordinateSystem || {}).model,
            this._tooltipModel
        ]);
        var tooltipTrigger = tooltipModel.get("trigger");
        if (tooltipTrigger != null && tooltipTrigger !== "item") return;
        var params = dataModel.getDataParams(dataIndex, dataType);
        var seriesTooltip = dataModel.formatTooltip(dataIndex, false, dataType, this._renderMode);
        var defaultHtml;
        var markers;
        if ($ec279652dd95c27b$export$a6cdc56e425d0d0a(seriesTooltip)) {
            defaultHtml = seriesTooltip.html;
            markers = seriesTooltip.markers;
        } else {
            defaultHtml = seriesTooltip;
            markers = null;
        }
        var asyncTicket = "item_" + dataModel.name + "_" + dataIndex;
        this._showOrMove(tooltipModel, function() {
            this._showTooltipContent(tooltipModel, defaultHtml, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markers);
        }); // FIXME
        // duplicated showtip if manuallyShowTip is called from dispatchAction.
        dispatchAction({
            type: "showTip",
            dataIndexInside: dataIndex,
            dataIndex: data.getRawIndex(dataIndex),
            seriesIndex: seriesIndex,
            from: this.uid
        });
    },
    _showComponentItemTooltip: function(e, el, dispatchAction) {
        var tooltipOpt = el.tooltip;
        if (typeof tooltipOpt === "string") {
            var content = tooltipOpt;
            tooltipOpt = {
                content: content,
                // Fixed formatter
                formatter: content
            };
        }
        var subTooltipModel = new $2b51b4bf776ec22e$exports(tooltipOpt, this._tooltipModel, this._ecModel);
        var defaultHtml = subTooltipModel.get("content");
        var asyncTicket = Math.random(); // Do not check whether `trigger` is 'none' here, because `trigger`
        // only works on coordinate system. In fact, we have not found case
        // that requires setting `trigger` nothing on component yet.
        this._showOrMove(subTooltipModel, function() {
            this._showTooltipContent(subTooltipModel, defaultHtml, subTooltipModel.get("formatterParams") || {}, asyncTicket, e.offsetX, e.offsetY, e.position, el);
        }); // If not dispatch showTip, tip may be hide triggered by axis.
        dispatchAction({
            type: "showTip",
            from: this.uid
        });
    },
    _showTooltipContent: function(tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markers) {
        // Reset ticket
        this._ticket = "";
        if (!tooltipModel.get("showContent") || !tooltipModel.get("show")) return;
        var tooltipContent = this._tooltipContent;
        var formatter = tooltipModel.get("formatter");
        positionExpr = positionExpr || tooltipModel.get("position");
        var html = defaultHtml;
        if (formatter && typeof formatter === "string") html = $a4be9366aeb9fcc8$export$2028496a35766e41(formatter, params, true);
        else if (typeof formatter === "function") {
            var callback = $86c35e57e4ce9190$var$bind(function(cbTicket, html) {
                if (cbTicket === this._ticket) {
                    tooltipContent.setContent(html, markers, tooltipModel);
                    this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
                }
            }, this);
            this._ticket = asyncTicket;
            html = formatter(params, asyncTicket, callback);
        }
        tooltipContent.setContent(html, markers, tooltipModel);
        tooltipContent.show(tooltipModel);
        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
    },
    /**
   * @param  {string|Function|Array.<number>|Object} positionExpr
   * @param  {number} x Mouse x
   * @param  {number} y Mouse y
   * @param  {boolean} confine Whether confine tooltip content in view rect.
   * @param  {Object|<Array.<Object>} params
   * @param  {module:zrender/Element} el target element
   * @param  {module:echarts/ExtensionAPI} api
   * @return {Array.<number>}
   */ _updatePosition: function(tooltipModel, positionExpr, x, y, content, params, el) {
        var viewWidth = this._api.getWidth();
        var viewHeight = this._api.getHeight();
        positionExpr = positionExpr || tooltipModel.get("position");
        var contentSize = content.getSize();
        var align = tooltipModel.get("align");
        var vAlign = tooltipModel.get("verticalAlign");
        var rect = el && el.getBoundingRect().clone();
        el && rect.applyTransform(el.transform);
        if (typeof positionExpr === "function") // Callback of position can be an array or a string specify the position
        positionExpr = positionExpr([
            x,
            y
        ], params, content.el, rect, {
            viewSize: [
                viewWidth,
                viewHeight
            ],
            contentSize: contentSize.slice()
        });
        if ($ec279652dd95c27b$export$43bee75e5e14138e(positionExpr)) {
            x = $86c35e57e4ce9190$var$parsePercent(positionExpr[0], viewWidth);
            y = $86c35e57e4ce9190$var$parsePercent(positionExpr[1], viewHeight);
        } else if ($ec279652dd95c27b$export$a6cdc56e425d0d0a(positionExpr)) {
            positionExpr.width = contentSize[0];
            positionExpr.height = contentSize[1];
            var layoutRect = $ab0c9086dd6c5b39$export$4517a5ca639a7293(positionExpr, {
                width: viewWidth,
                height: viewHeight
            });
            x = layoutRect.x;
            y = layoutRect.y;
            align = null; // When positionExpr is left/top/right/bottom,
            // align and verticalAlign will not work.
            vAlign = null;
        } else if (typeof positionExpr === "string" && el) {
            var pos = $86c35e57e4ce9190$var$calcTooltipPosition(positionExpr, rect, contentSize);
            x = pos[0];
            y = pos[1];
        } else {
            var pos = $86c35e57e4ce9190$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
            x = pos[0];
            y = pos[1];
        }
        align && (x -= $86c35e57e4ce9190$var$isCenterAlign(align) ? contentSize[0] / 2 : align === "right" ? contentSize[0] : 0);
        vAlign && (y -= $86c35e57e4ce9190$var$isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === "bottom" ? contentSize[1] : 0);
        if (tooltipModel.get("confine")) {
            var pos = $86c35e57e4ce9190$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight);
            x = pos[0];
            y = pos[1];
        }
        content.moveTo(x, y);
    },
    // FIXME
    // Should we remove this but leave this to user?
    _updateContentNotChangedOnAxis: function(dataByCoordSys) {
        var lastCoordSys = this._lastDataByCoordSys;
        var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
        contentNotChanged && $86c35e57e4ce9190$var$each(lastCoordSys, function(lastItemCoordSys, indexCoordSys) {
            var lastDataByAxis = lastItemCoordSys.dataByAxis || {};
            var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
            var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
            contentNotChanged &= lastDataByAxis.length === thisDataByAxis.length;
            contentNotChanged && $86c35e57e4ce9190$var$each(lastDataByAxis, function(lastItem, indexAxis) {
                var thisItem = thisDataByAxis[indexAxis] || {};
                var lastIndices = lastItem.seriesDataIndices || [];
                var newIndices = thisItem.seriesDataIndices || [];
                contentNotChanged &= lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
                contentNotChanged && $86c35e57e4ce9190$var$each(lastIndices, function(lastIdxItem, j) {
                    var newIdxItem = newIndices[j];
                    contentNotChanged &= lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
                });
            });
        });
        this._lastDataByCoordSys = dataByCoordSys;
        return !!contentNotChanged;
    },
    _hide: function(dispatchAction) {
        // Do not directly hideLater here, because this behavior may be prevented
        // in dispatchAction when showTip is dispatched.
        // FIXME
        // duplicated hideTip if manuallyHideTip is called from dispatchAction.
        this._lastDataByCoordSys = null;
        dispatchAction({
            type: "hideTip",
            from: this.uid
        });
    },
    dispose: function(ecModel, api) {
        if ($27ac1413ecc67076$exports.node) return;
        this._tooltipContent.dispose();
        $5e44907374287613$export$d07f55d4c15c0440("itemTooltip", api);
    }
});
/**
 * @param {Array.<Object|module:echarts/model/Model>} modelCascade
 * From top to bottom. (the last one should be globalTooltipModel);
 */ function $86c35e57e4ce9190$var$buildTooltipModel(modelCascade) {
    var resultModel = modelCascade.pop();
    while(modelCascade.length){
        var tooltipOpt = modelCascade.pop();
        if (tooltipOpt) {
            if ($2b51b4bf776ec22e$exports.isInstance(tooltipOpt)) tooltipOpt = tooltipOpt.get("tooltip", true);
             // In each data item tooltip can be simply write:
            // {
            //  value: 10,
            //  tooltip: 'Something you need to know'
            // }
            if (typeof tooltipOpt === "string") tooltipOpt = {
                formatter: tooltipOpt
            };
            resultModel = new $2b51b4bf776ec22e$exports(tooltipOpt, resultModel, resultModel.ecModel);
        }
    }
    return resultModel;
}
function $86c35e57e4ce9190$var$makeDispatchAction(payload, api) {
    return payload.dispatchAction || $ec279652dd95c27b$export$2385a24977818dd0(api.dispatchAction, api);
}
function $86c35e57e4ce9190$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
    var size = content.getOuterSize();
    var width = size.width;
    var height = size.height;
    if (gapH != null) {
        if (x + width + gapH > viewWidth) x -= width + gapH;
        else x += gapH;
    }
    if (gapV != null) {
        if (y + height + gapV > viewHeight) y -= height + gapV;
        else y += gapV;
    }
    return [
        x,
        y
    ];
}
function $86c35e57e4ce9190$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
    var size = content.getOuterSize();
    var width = size.width;
    var height = size.height;
    x = Math.min(x + width, viewWidth) - width;
    y = Math.min(y + height, viewHeight) - height;
    x = Math.max(x, 0);
    y = Math.max(y, 0);
    return [
        x,
        y
    ];
}
function $86c35e57e4ce9190$var$calcTooltipPosition(position, rect, contentSize) {
    var domWidth = contentSize[0];
    var domHeight = contentSize[1];
    var gap = 5;
    var x = 0;
    var y = 0;
    var rectWidth = rect.width;
    var rectHeight = rect.height;
    switch(position){
        case "inside":
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case "top":
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y - domHeight - gap;
            break;
        case "bottom":
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight + gap;
            break;
        case "left":
            x = rect.x - domWidth - gap;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case "right":
            x = rect.x + rectWidth + gap;
            y = rect.y + rectHeight / 2 - domHeight / 2;
    }
    return [
        x,
        y
    ];
}
function $86c35e57e4ce9190$var$isCenterAlign(align) {
    return align === "center" || align === "middle";
}
$86c35e57e4ce9190$exports = $86c35e57e4ce9190$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME Better way to pack data in graphic element
/**
 * @action
 * @property {string} type
 * @property {number} seriesIndex
 * @property {number} dataIndex
 * @property {number} [x]
 * @property {number} [y]
 */ $f406636b535430a7$exports.registerAction({
    type: "showTip",
    event: "showTip",
    update: "tooltip:manuallyShowTip"
}, function() {});
$f406636b535430a7$exports.registerAction({
    type: "hideTip",
    event: "hideTip",
    update: "tooltip:manuallyHideTip"
}, function() {});



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3680d94a27c921ca$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $3680d94a27c921ca$var$DEFAULT_TOOLBOX_BTNS = [
    "rect",
    "polygon",
    "keep",
    "clear"
];
function $3680d94a27c921ca$var$_default(option, isNew) {
    var brushComponents = option && option.brush;
    if (!$ec279652dd95c27b$export$43bee75e5e14138e(brushComponents)) brushComponents = brushComponents ? [
        brushComponents
    ] : [];
    if (!brushComponents.length) return;
    var brushComponentSpecifiedBtns = [];
    $ec279652dd95c27b$export$79b2f7037acddd43(brushComponents, function(brushOpt) {
        var tbs = brushOpt.hasOwnProperty("toolbox") ? brushOpt.toolbox : [];
        if (tbs instanceof Array) brushComponentSpecifiedBtns = brushComponentSpecifiedBtns.concat(tbs);
    });
    var toolbox = option && option.toolbox;
    if ($ec279652dd95c27b$export$43bee75e5e14138e(toolbox)) toolbox = toolbox[0];
    if (!toolbox) {
        toolbox = {
            feature: {}
        };
        option.toolbox = [
            toolbox
        ];
    }
    var toolboxFeature = toolbox.feature || (toolbox.feature = {});
    var toolboxBrush = toolboxFeature.brush || (toolboxFeature.brush = {});
    var brushTypes = toolboxBrush.type || (toolboxBrush.type = []);
    brushTypes.push.apply(brushTypes, brushComponentSpecifiedBtns);
    $3680d94a27c921ca$var$removeDuplicate(brushTypes);
    if (isNew && !brushTypes.length) brushTypes.push.apply(brushTypes, $3680d94a27c921ca$var$DEFAULT_TOOLBOX_BTNS);
}
function $3680d94a27c921ca$var$removeDuplicate(arr) {
    var map = {};
    $ec279652dd95c27b$export$79b2f7037acddd43(arr, function(val) {
        map[val] = 1;
    });
    arr.length = 0;
    $ec279652dd95c27b$export$79b2f7037acddd43(map, function(flag, val) {
        arr.push(val);
    });
}
$3680d94a27c921ca$exports = $3680d94a27c921ca$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $efcd5a709be2082a$export$ead1205d8c0d8375;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $5d9ee77508af1280$export$89974527642f24a0;
var $5d9ee77508af1280$export$797d20c0a6de578f;
var $5d9ee77508af1280$export$bb1ef43951d58629;
var $5d9ee77508af1280$export$fc0ef8703cccf128;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @file Visual solution, for consistent option specification.
 */ var $5d9ee77508af1280$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
function $5d9ee77508af1280$var$hasKeys(obj) {
    if (obj) for(var name in obj){
        if (obj.hasOwnProperty(name)) return true;
    }
}
/**
 * @param {Object} option
 * @param {Array.<string>} stateList
 * @param {Function} [supplementVisualOption]
 * @return {Object} visualMappings <state, <visualType, module:echarts/visual/VisualMapping>>
 */ function $5d9ee77508af1280$var$createVisualMappings(option, stateList, supplementVisualOption) {
    var visualMappings = {};
    $5d9ee77508af1280$var$each(stateList, function(state) {
        var mappings = visualMappings[state] = createMappings();
        $5d9ee77508af1280$var$each(option[state], function(visualData, visualType) {
            if (!$72cc7afb3a2d7026$exports.isValidType(visualType)) return;
            var mappingOption = {
                type: visualType,
                visual: visualData
            };
            supplementVisualOption && supplementVisualOption(mappingOption, state);
            mappings[visualType] = new $72cc7afb3a2d7026$exports(mappingOption); // Prepare a alpha for opacity, for some case that opacity
            // is not supported, such as rendering using gradient color.
            if (visualType === "opacity") {
                mappingOption = $ec279652dd95c27b$export$9cd59f9826255e47(mappingOption);
                mappingOption.type = "colorAlpha";
                mappings.__hidden.__alphaForOpacity = new $72cc7afb3a2d7026$exports(mappingOption);
            }
        });
    });
    return visualMappings;
    function createMappings() {
        var Creater = function() {}; // Make sure hidden fields will not be visited by
        // object iteration (with hasOwnProperty checking).
        Creater.prototype.__hidden = Creater.prototype;
        var obj = new Creater();
        return obj;
    }
}
/**
 * @param {Object} thisOption
 * @param {Object} newOption
 * @param {Array.<string>} keys
 */ function $5d9ee77508af1280$var$replaceVisualOption(thisOption, newOption, keys) {
    // Visual attributes merge is not supported, otherwise it
    // brings overcomplicated merge logic. See #2853. So if
    // newOption has anyone of these keys, all of these keys
    // will be reset. Otherwise, all keys remain.
    var has;
    $ec279652dd95c27b$export$79b2f7037acddd43(keys, function(key) {
        if (newOption.hasOwnProperty(key) && $5d9ee77508af1280$var$hasKeys(newOption[key])) has = true;
    });
    has && $ec279652dd95c27b$export$79b2f7037acddd43(keys, function(key) {
        if (newOption.hasOwnProperty(key) && $5d9ee77508af1280$var$hasKeys(newOption[key])) thisOption[key] = $ec279652dd95c27b$export$9cd59f9826255e47(newOption[key]);
        else delete thisOption[key];
    });
}
/**
 * @param {Array.<string>} stateList
 * @param {Object} visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
 * @param {module:echarts/data/List} list
 * @param {Function} getValueState param: valueOrIndex, return: state.
 * @param {object} [scope] Scope for getValueState
 * @param {string} [dimension] Concrete dimension, if used.
 */ // ???! handle brush?
function $5d9ee77508af1280$var$applyVisual(stateList, visualMappings, data, getValueState, scope, dimension) {
    var visualTypesMap = {};
    $ec279652dd95c27b$export$79b2f7037acddd43(stateList, function(state) {
        var visualTypes = $72cc7afb3a2d7026$exports.prepareVisualTypes(visualMappings[state]);
        visualTypesMap[state] = visualTypes;
    });
    var dataIndex;
    function getVisual(key) {
        return data.getItemVisual(dataIndex, key);
    }
    function setVisual(key, value) {
        data.setItemVisual(dataIndex, key, value);
    }
    if (dimension == null) data.each(eachItem);
    else data.each([
        dimension
    ], eachItem);
    function eachItem(valueOrIndex, index) {
        dataIndex = dimension == null ? valueOrIndex : index;
        var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance
        if (rawDataItem && rawDataItem.visualMap === false) return;
        var valueState = getValueState.call(scope, valueOrIndex);
        var mappings = visualMappings[valueState];
        var visualTypes = visualTypesMap[valueState];
        for(var i = 0, len = visualTypes.length; i < len; i++){
            var type = visualTypes[i];
            mappings[type] && mappings[type].applyVisual(valueOrIndex, getVisual, setVisual);
        }
    }
}
/**
 * @param {module:echarts/data/List} data
 * @param {Array.<string>} stateList
 * @param {Object} visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
 * @param {Function} getValueState param: valueOrIndex, return: state.
 * @param {number} [dim] dimension or dimension index.
 */ function $5d9ee77508af1280$var$incrementalApplyVisual(stateList, visualMappings, getValueState, dim) {
    var visualTypesMap = {};
    $ec279652dd95c27b$export$79b2f7037acddd43(stateList, function(state) {
        var visualTypes = $72cc7afb3a2d7026$exports.prepareVisualTypes(visualMappings[state]);
        visualTypesMap[state] = visualTypes;
    });
    function progress(params, data) {
        if (dim != null) dim = data.getDimension(dim);
        function getVisual(key) {
            return data.getItemVisual(dataIndex, key);
        }
        function setVisual(key, value) {
            data.setItemVisual(dataIndex, key, value);
        }
        var dataIndex;
        while((dataIndex = params.next()) != null){
            var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance
            if (rawDataItem && rawDataItem.visualMap === false) continue;
            var value = dim != null ? data.get(dim, dataIndex, true) : dataIndex;
            var valueState = getValueState(value);
            var mappings = visualMappings[valueState];
            var visualTypes = visualTypesMap[valueState];
            for(var i = 0, len = visualTypes.length; i < len; i++){
                var type = visualTypes[i];
                mappings[type] && mappings[type].applyVisual(value, getVisual, setVisual);
            }
        }
    }
    return {
        progress: progress
    };
}
$5d9ee77508af1280$export$89974527642f24a0 = $5d9ee77508af1280$var$createVisualMappings;
$5d9ee77508af1280$export$797d20c0a6de578f = $5d9ee77508af1280$var$replaceVisualOption;
$5d9ee77508af1280$export$bb1ef43951d58629 = $5d9ee77508af1280$var$applyVisual;
$5d9ee77508af1280$export$fc0ef8703cccf128 = $5d9ee77508af1280$var$incrementalApplyVisual;


var $585061c56b3f8c81$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $585061c56b3f8c81$var$linePolygonIntersect = $4b57d6b582d579b7$export$4f47c855a5e9ae9;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Key of the first level is brushType: `line`, `rect`, `polygon`.
// Key of the second level is chart element type: `point`, `rect`.
// See moudule:echarts/component/helper/BrushController
// function param:
//      {Object} itemLayout fetch from data.getItemLayout(dataIndex)
//      {Object} selectors {point: selector, rect: selector, ...}
//      {Object} area {range: [[], [], ..], boudingRect}
// function return:
//      {boolean} Whether in the given brush.
var $585061c56b3f8c81$var$selector = {
    lineX: $585061c56b3f8c81$var$getLineSelectors(0),
    lineY: $585061c56b3f8c81$var$getLineSelectors(1),
    rect: {
        point: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]);
        },
        rect: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.intersect(itemLayout);
        }
    },
    polygon: {
        point: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]) && $b6130b3a3ace3afb$export$8893e2b90ba10d92(area.range, itemLayout[0], itemLayout[1]);
        },
        rect: function(itemLayout, selectors, area) {
            var points = area.range;
            if (!itemLayout || points.length <= 1) return false;
            var x = itemLayout.x;
            var y = itemLayout.y;
            var width = itemLayout.width;
            var height = itemLayout.height;
            var p = points[0];
            if ($b6130b3a3ace3afb$export$8893e2b90ba10d92(points, x, y) || $b6130b3a3ace3afb$export$8893e2b90ba10d92(points, x + width, y) || $b6130b3a3ace3afb$export$8893e2b90ba10d92(points, x, y + height) || $b6130b3a3ace3afb$export$8893e2b90ba10d92(points, x + width, y + height) || $33e4fae744d34798$exports.create(itemLayout).contain(p[0], p[1]) || $585061c56b3f8c81$var$linePolygonIntersect(x, y, x + width, y, points) || $585061c56b3f8c81$var$linePolygonIntersect(x, y, x, y + height, points) || $585061c56b3f8c81$var$linePolygonIntersect(x + width, y, x + width, y + height, points) || $585061c56b3f8c81$var$linePolygonIntersect(x, y + height, x + width, y + height, points)) return true;
        }
    }
};
function $585061c56b3f8c81$var$getLineSelectors(xyIndex) {
    var xy = [
        "x",
        "y"
    ];
    var wh = [
        "width",
        "height"
    ];
    return {
        point: function(itemLayout, selectors, area) {
            if (itemLayout) {
                var range = area.range;
                var p = itemLayout[xyIndex];
                return $585061c56b3f8c81$var$inLineRange(p, range);
            }
        },
        rect: function(itemLayout, selectors, area) {
            if (itemLayout) {
                var range = area.range;
                var layoutRange = [
                    itemLayout[xy[xyIndex]],
                    itemLayout[xy[xyIndex]] + itemLayout[wh[xyIndex]]
                ];
                layoutRange[1] < layoutRange[0] && layoutRange.reverse();
                return $585061c56b3f8c81$var$inLineRange(layoutRange[0], range) || $585061c56b3f8c81$var$inLineRange(layoutRange[1], range) || $585061c56b3f8c81$var$inLineRange(range[0], layoutRange) || $585061c56b3f8c81$var$inLineRange(range[1], layoutRange);
            }
        }
    };
}
function $585061c56b3f8c81$var$inLineRange(p, range) {
    return range[0] <= p && p <= range[1];
}
var $585061c56b3f8c81$var$_default = $585061c56b3f8c81$var$selector;
$585061c56b3f8c81$exports = $585061c56b3f8c81$var$_default;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $efcd5a709be2082a$var$STATE_LIST = [
    "inBrush",
    "outOfBrush"
];
var $efcd5a709be2082a$var$DISPATCH_METHOD = "__ecBrushSelect";
var $efcd5a709be2082a$var$DISPATCH_FLAG = "__ecInBrushSelectEvent";
var $efcd5a709be2082a$var$PRIORITY_BRUSH = $f406636b535430a7$exports.PRIORITY.VISUAL.BRUSH;
/**
 * Layout for visual, the priority higher than other layout, and before brush visual.
 */ $f406636b535430a7$exports.registerLayout($efcd5a709be2082a$var$PRIORITY_BRUSH, function(ecModel, api, payload) {
    ecModel.eachComponent({
        mainType: "brush"
    }, function(brushModel) {
        payload && payload.type === "takeGlobalCursor" && brushModel.setBrushOption(payload.key === "brush" ? payload.brushOption : {
            brushType: false
        });
    });
    $efcd5a709be2082a$var$layoutCovers(ecModel);
});
function $efcd5a709be2082a$var$layoutCovers(ecModel) {
    ecModel.eachComponent({
        mainType: "brush"
    }, function(brushModel) {
        var brushTargetManager = brushModel.brushTargetManager = new $0f8d0342fd643dbc$exports(brushModel.option, ecModel);
        brushTargetManager.setInputRanges(brushModel.areas, ecModel);
    });
}
/**
 * Register the visual encoding if this modules required.
 */ $f406636b535430a7$exports.registerVisual($efcd5a709be2082a$var$PRIORITY_BRUSH, function(ecModel, api, payload) {
    var brushSelected = [];
    var throttleType;
    var throttleDelay;
    ecModel.eachComponent({
        mainType: "brush"
    }, function(brushModel, brushIndex) {
        var thisBrushSelected = {
            brushId: brushModel.id,
            brushIndex: brushIndex,
            brushName: brushModel.name,
            areas: $ec279652dd95c27b$export$9cd59f9826255e47(brushModel.areas),
            selected: []
        }; // Every brush component exists in event params, convenient
        // for user to find by index.
        brushSelected.push(thisBrushSelected);
        var brushOption = brushModel.option;
        var brushLink = brushOption.brushLink;
        var linkedSeriesMap = [];
        var selectedDataIndexForLink = [];
        var rangeInfoBySeries = [];
        var hasBrushExists = 0;
        if (!brushIndex) {
            // Only the first throttle setting works.
            throttleType = brushOption.throttleType;
            throttleDelay = brushOption.throttleDelay;
        } // Add boundingRect and selectors to range.
        var areas = $ec279652dd95c27b$export$871de8747c9eaa88(brushModel.areas, function(area) {
            return $efcd5a709be2082a$var$bindSelector($ec279652dd95c27b$export$ebe90cb607ad99e({
                boundingRect: $efcd5a709be2082a$var$boundingRectBuilders[area.brushType](area)
            }, area));
        });
        var visualMappings = $5d9ee77508af1280$export$89974527642f24a0(brushModel.option, $efcd5a709be2082a$var$STATE_LIST, function(mappingOption) {
            mappingOption.mappingMethod = "fixed";
        });
        $ec279652dd95c27b$export$43bee75e5e14138e(brushLink) && $ec279652dd95c27b$export$79b2f7037acddd43(brushLink, function(seriesIndex) {
            linkedSeriesMap[seriesIndex] = 1;
        });
        function linkOthers(seriesIndex) {
            return brushLink === "all" || linkedSeriesMap[seriesIndex];
        } // If no supported brush or no brush on the series,
        // all visuals should be in original state.
        function brushed(rangeInfoList) {
            return !!rangeInfoList.length;
        }
        /**
     * Logic for each series: (If the logic has to be modified one day, do it carefully!)
     *
     * ( brushed ┬ && ┬hasBrushExist ┬ && linkOthers  ) => StepA: ┬record, ┬ StepB: ┬visualByRecord.
     *   !brushed┘    ├hasBrushExist ┤                            └nothing,┘        ├visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( !brushed  && ┬hasBrushExist ┬ && linkOthers  ) => StepA:  nothing,  StepB: ┬visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( brushed ┬ &&                     !linkOthers ) => StepA:  nothing,  StepB: ┬visualByCheck.
     *   !brushed┘                                                                  └nothing.
     * ( !brushed  &&                     !linkOthers ) => StepA:  nothing,  StepB:  nothing.
     */ // Step A
        ecModel.eachSeries(function(seriesModel, seriesIndex) {
            var rangeInfoList = rangeInfoBySeries[seriesIndex] = [];
            seriesModel.subType === "parallel" ? stepAParallel(seriesModel, seriesIndex, rangeInfoList) : stepAOthers(seriesModel, seriesIndex, rangeInfoList);
        });
        function stepAParallel(seriesModel, seriesIndex) {
            var coordSys = seriesModel.coordinateSystem;
            hasBrushExists |= coordSys.hasAxisBrushed();
            linkOthers(seriesIndex) && coordSys.eachActiveState(seriesModel.getData(), function(activeState, dataIndex) {
                activeState === "active" && (selectedDataIndexForLink[dataIndex] = 1);
            });
        }
        function stepAOthers(seriesModel, seriesIndex, rangeInfoList) {
            var selectorsByBrushType = $efcd5a709be2082a$var$getSelectorsByBrushType(seriesModel);
            if (!selectorsByBrushType || $efcd5a709be2082a$var$brushModelNotControll(brushModel, seriesIndex)) return;
            $ec279652dd95c27b$export$79b2f7037acddd43(areas, function(area) {
                selectorsByBrushType[area.brushType] && brushModel.brushTargetManager.controlSeries(area, seriesModel, ecModel) && rangeInfoList.push(area);
                hasBrushExists |= brushed(rangeInfoList);
            });
            if (linkOthers(seriesIndex) && brushed(rangeInfoList)) {
                var data = seriesModel.getData();
                data.each(function(dataIndex) {
                    if ($efcd5a709be2082a$var$checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex)) selectedDataIndexForLink[dataIndex] = 1;
                });
            }
        } // Step B
        ecModel.eachSeries(function(seriesModel, seriesIndex) {
            var seriesBrushSelected = {
                seriesId: seriesModel.id,
                seriesIndex: seriesIndex,
                seriesName: seriesModel.name,
                dataIndex: []
            }; // Every series exists in event params, convenient
            // for user to find series by seriesIndex.
            thisBrushSelected.selected.push(seriesBrushSelected);
            var selectorsByBrushType = $efcd5a709be2082a$var$getSelectorsByBrushType(seriesModel);
            var rangeInfoList = rangeInfoBySeries[seriesIndex];
            var data = seriesModel.getData();
            var getValueState = linkOthers(seriesIndex) ? function(dataIndex) {
                return selectedDataIndexForLink[dataIndex] ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), "inBrush") : "outOfBrush";
            } : function(dataIndex) {
                return $efcd5a709be2082a$var$checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex) ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), "inBrush") : "outOfBrush";
            }; // If no supported brush or no brush, all visuals are in original state.
            (linkOthers(seriesIndex) ? hasBrushExists : brushed(rangeInfoList)) && $5d9ee77508af1280$export$bb1ef43951d58629($efcd5a709be2082a$var$STATE_LIST, visualMappings, data, getValueState);
        });
    });
    $efcd5a709be2082a$var$dispatchAction(api, throttleType, throttleDelay, brushSelected, payload);
});
function $efcd5a709be2082a$var$dispatchAction(api, throttleType, throttleDelay, brushSelected, payload) {
    // This event will not be triggered when `setOpion`, otherwise dead lock may
    // triggered when do `setOption` in event listener, which we do not find
    // satisfactory way to solve yet. Some considered resolutions:
    // (a) Diff with prevoius selected data ant only trigger event when changed.
    // But store previous data and diff precisely (i.e., not only by dataIndex, but
    // also detect value changes in selected data) might bring complexity or fragility.
    // (b) Use spectial param like `silent` to suppress event triggering.
    // But such kind of volatile param may be weird in `setOption`.
    if (!payload) return;
    var zr = api.getZr();
    if (zr[$efcd5a709be2082a$var$DISPATCH_FLAG]) return;
    if (!zr[$efcd5a709be2082a$var$DISPATCH_METHOD]) zr[$efcd5a709be2082a$var$DISPATCH_METHOD] = $efcd5a709be2082a$var$doDispatch;
    var fn = $a181ac84b0d97d16$export$958e3e1a02eac4b6(zr, $efcd5a709be2082a$var$DISPATCH_METHOD, throttleDelay, throttleType);
    fn(api, brushSelected);
}
function $efcd5a709be2082a$var$doDispatch(api, brushSelected) {
    if (!api.isDisposed()) {
        var zr = api.getZr();
        zr[$efcd5a709be2082a$var$DISPATCH_FLAG] = true;
        api.dispatchAction({
            type: "brushSelect",
            batch: brushSelected
        });
        zr[$efcd5a709be2082a$var$DISPATCH_FLAG] = false;
    }
}
function $efcd5a709be2082a$var$checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex) {
    for(var i = 0, len = rangeInfoList.length; i < len; i++){
        var area = rangeInfoList[i];
        if (selectorsByBrushType[area.brushType](dataIndex, data, area.selectors, area)) return true;
    }
}
function $efcd5a709be2082a$var$getSelectorsByBrushType(seriesModel) {
    var brushSelector = seriesModel.brushSelector;
    if ($ec279652dd95c27b$export$844ec244b1367d54(brushSelector)) {
        var sels = [];
        $ec279652dd95c27b$export$79b2f7037acddd43($585061c56b3f8c81$exports, function(selectorsByElementType, brushType) {
            sels[brushType] = function(dataIndex, data, selectors, area) {
                var itemLayout = data.getItemLayout(dataIndex);
                return selectorsByElementType[brushSelector](itemLayout, selectors, area);
            };
        });
        return sels;
    } else if ($ec279652dd95c27b$export$f6e2535fb5126e54(brushSelector)) {
        var bSelector = {};
        $ec279652dd95c27b$export$79b2f7037acddd43($585061c56b3f8c81$exports, function(sel, brushType) {
            bSelector[brushType] = brushSelector;
        });
        return bSelector;
    }
    return brushSelector;
}
function $efcd5a709be2082a$var$brushModelNotControll(brushModel, seriesIndex) {
    var seriesIndices = brushModel.option.seriesIndex;
    return seriesIndices != null && seriesIndices !== "all" && ($ec279652dd95c27b$export$43bee75e5e14138e(seriesIndices) ? $ec279652dd95c27b$export$305f7d4e9d4624f2(seriesIndices, seriesIndex) < 0 : seriesIndex !== seriesIndices);
}
function $efcd5a709be2082a$var$bindSelector(area) {
    var selectors = area.selectors = {};
    $ec279652dd95c27b$export$79b2f7037acddd43($585061c56b3f8c81$exports[area.brushType], function(selFn, elType) {
        // Do not use function binding or curry for performance.
        selectors[elType] = function(itemLayout) {
            return selFn(itemLayout, selectors, area);
        };
    });
    return area;
}
var $efcd5a709be2082a$var$boundingRectBuilders = {
    lineX: $ec279652dd95c27b$export$8793edee2d425525,
    lineY: $ec279652dd95c27b$export$8793edee2d425525,
    rect: function(area) {
        return $efcd5a709be2082a$var$getBoundingRectFromMinMax(area.range);
    },
    polygon: function(area) {
        var minMax;
        var range = area.range;
        for(var i = 0, len = range.length; i < len; i++){
            minMax = minMax || [
                [
                    Infinity,
                    -Infinity
                ],
                [
                    Infinity,
                    -Infinity
                ]
            ];
            var rg = range[i];
            rg[0] < minMax[0][0] && (minMax[0][0] = rg[0]);
            rg[0] > minMax[0][1] && (minMax[0][1] = rg[0]);
            rg[1] < minMax[1][0] && (minMax[1][0] = rg[1]);
            rg[1] > minMax[1][1] && (minMax[1][1] = rg[1]);
        }
        return minMax && $efcd5a709be2082a$var$getBoundingRectFromMinMax(minMax);
    }
};
function $efcd5a709be2082a$var$getBoundingRectFromMinMax(minMax) {
    return new $33e4fae744d34798$exports(minMax[0][0], minMax[1][0], minMax[0][1] - minMax[0][0], minMax[1][1] - minMax[1][0]);
}
$efcd5a709be2082a$export$ead1205d8c0d8375 = $efcd5a709be2082a$var$layoutCovers;


var $2dabc261f99d7e68$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2dabc261f99d7e68$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $2dabc261f99d7e68$var$DEFAULT_OUT_OF_BRUSH_COLOR = [
    "#ddd"
];
var $2dabc261f99d7e68$var$BrushModel = $f406636b535430a7$exports.extendComponentModel({
    type: "brush",
    dependencies: [
        "geo",
        "grid",
        "xAxis",
        "yAxis",
        "parallel",
        "series"
    ],
    /**
   * @protected
   */ defaultOption: {
        // inBrush: null,
        // outOfBrush: null,
        toolbox: null,
        // Default value see preprocessor.
        brushLink: null,
        // Series indices array, broadcast using dataIndex.
        // or 'all', which means all series. 'none' or null means no series.
        seriesIndex: "all",
        // seriesIndex array, specify series controlled by this brush component.
        geoIndex: null,
        //
        xAxisIndex: null,
        yAxisIndex: null,
        brushType: "rect",
        // Default brushType, see BrushController.
        brushMode: "single",
        // Default brushMode, 'single' or 'multiple'
        transformable: true,
        // Default transformable.
        brushStyle: {
            // Default brushStyle
            borderWidth: 1,
            color: "rgba(120,140,180,0.3)",
            borderColor: "rgba(120,140,180,0.8)"
        },
        throttleType: "fixRate",
        // Throttle in brushSelected event. 'fixRate' or 'debounce'.
        // If null, no throttle. Valid only in the first brush component
        throttleDelay: 0,
        // Unit: ms, 0 means every event will be triggered.
        // FIXME
        // 试验效果
        removeOnClick: true,
        z: 10000
    },
    /**
   * @readOnly
   * @type {Array.<Object>}
   */ areas: [],
    /**
   * Current activated brush type.
   * If null, brush is inactived.
   * see module:echarts/component/helper/BrushController
   * @readOnly
   * @type {string}
   */ brushType: null,
    /**
   * Current brush opt.
   * see module:echarts/component/helper/BrushController
   * @readOnly
   * @type {Object}
   */ brushOption: {},
    /**
   * @readOnly
   * @type {Array.<Object>}
   */ coordInfoList: [],
    optionUpdated: function(newOption, isInit) {
        var thisOption = this.option;
        !isInit && $5d9ee77508af1280$export$797d20c0a6de578f(thisOption, newOption, [
            "inBrush",
            "outOfBrush"
        ]);
        var inBrush = thisOption.inBrush = thisOption.inBrush || {}; // Always give default visual, consider setOption at the second time.
        thisOption.outOfBrush = thisOption.outOfBrush || {
            color: $2dabc261f99d7e68$var$DEFAULT_OUT_OF_BRUSH_COLOR
        };
        if (!inBrush.hasOwnProperty("liftZ")) // Bigger than the highlight z lift, otherwise it will
        // be effected by the highlight z when brush.
        inBrush.liftZ = 5;
    },
    /**
   * If ranges is null/undefined, range state remain.
   *
   * @param {Array.<Object>} [ranges]
   */ setAreas: function(areas) {
        // If ranges is null/undefined, range state remain.
        // This helps user to dispatchAction({type: 'brush'}) with no areas
        // set but just want to get the current brush select info from a `brush` event.
        if (!areas) return;
        this.areas = $ec279652dd95c27b$export$871de8747c9eaa88(areas, function(area) {
            return $2dabc261f99d7e68$var$generateBrushOption(this.option, area);
        }, this);
    },
    /**
   * see module:echarts/component/helper/BrushController
   * @param {Object} brushOption
   */ setBrushOption: function(brushOption) {
        this.brushOption = $2dabc261f99d7e68$var$generateBrushOption(this.option, brushOption);
        this.brushType = this.brushOption.brushType;
    }
});
function $2dabc261f99d7e68$var$generateBrushOption(option, brushOption) {
    return $ec279652dd95c27b$export$4950aa0f605343fb({
        brushType: option.brushType,
        brushMode: option.brushMode,
        transformable: option.transformable,
        brushStyle: new $2b51b4bf776ec22e$exports(option.brushStyle).getItemStyle(),
        removeOnClick: option.removeOnClick,
        z: option.z
    }, brushOption, true);
}
var $2dabc261f99d7e68$var$_default = $2dabc261f99d7e68$var$BrushModel;
$2dabc261f99d7e68$exports = $2dabc261f99d7e68$var$_default;


var $e915f6400b6176f1$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $e915f6400b6176f1$var$layoutCovers = $efcd5a709be2082a$export$ead1205d8c0d8375;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $e915f6400b6176f1$var$_default = $f406636b535430a7$exports.extendComponentView({
    type: "brush",
    init: function(ecModel, api) {
        /**
     * @readOnly
     * @type {module:echarts/model/Global}
     */ this.ecModel = ecModel;
        /**
     * @readOnly
     * @type {module:echarts/ExtensionAPI}
     */ this.api = api;
        /**
     * @readOnly
     * @type {module:echarts/component/brush/BrushModel}
     */ this.model;
        /**
     * @private
     * @type {module:echarts/component/helper/BrushController}
     */ (this._brushController = new $32947641224f901a$exports(api.getZr())).on("brush", $ec279652dd95c27b$export$2385a24977818dd0(this._onBrush, this)).mount();
    },
    /**
   * @override
   */ render: function(brushModel) {
        this.model = brushModel;
        return $e915f6400b6176f1$var$updateController.apply(this, arguments);
    },
    /**
   * @override
   */ updateTransform: function(brushModel, ecModel) {
        // PENDING: `updateTransform` is a little tricky, whose layout need
        // to be calculate mandatorily and other stages will not be performed.
        // Take care the correctness of the logic. See #11754 .
        $e915f6400b6176f1$var$layoutCovers(ecModel);
        return $e915f6400b6176f1$var$updateController.apply(this, arguments);
    },
    /**
   * @override
   */ updateView: $e915f6400b6176f1$var$updateController,
    // /**
    //  * @override
    //  */
    // updateLayout: updateController,
    // /**
    //  * @override
    //  */
    // updateVisual: updateController,
    /**
   * @override
   */ dispose: function() {
        this._brushController.dispose();
    },
    /**
   * @private
   */ _onBrush: function(areas, opt) {
        var modelId = this.model.id;
        this.model.brushTargetManager.setOutputRanges(areas, this.ecModel); // Action is not dispatched on drag end, because the drag end
        // emits the same params with the last drag move event, and
        // may have some delay when using touch pad, which makes
        // animation not smooth (when using debounce).
        (!opt.isEnd || opt.removeOnClick) && this.api.dispatchAction({
            type: "brush",
            brushId: modelId,
            areas: $ec279652dd95c27b$export$9cd59f9826255e47(areas),
            $from: modelId
        });
        opt.isEnd && this.api.dispatchAction({
            type: "brushEnd",
            brushId: modelId,
            areas: $ec279652dd95c27b$export$9cd59f9826255e47(areas),
            $from: modelId
        });
    }
});
function $e915f6400b6176f1$var$updateController(brushModel, ecModel, api, payload) {
    // Do not update controller when drawing.
    (!payload || payload.$from !== brushModel.id) && this._brushController.setPanels(brushModel.brushTargetManager.makePanelOpts(api)).enableBrush(brushModel.brushOption).updateCovers(brushModel.areas.slice());
}
$e915f6400b6176f1$exports = $e915f6400b6176f1$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * payload: {
 *      brushIndex: number, or,
 *      brushId: string, or,
 *      brushName: string,
 *      globalRanges: Array
 * }
 */ $f406636b535430a7$exports.registerAction({
    type: "brush",
    event: "brush"
}, function(payload, ecModel) {
    ecModel.eachComponent({
        mainType: "brush",
        query: payload
    }, function(brushModel) {
        brushModel.setAreas(payload.areas);
    });
});
/**
 * payload: {
 *      brushComponents: [
 *          {
 *              brushId,
 *              brushIndex,
 *              brushName,
 *              series: [
 *                  {
 *                      seriesId,
 *                      seriesIndex,
 *                      seriesName,
 *                      rawIndices: [21, 34, ...]
 *                  },
 *                  ...
 *              ]
 *          },
 *          ...
 *      ]
 * }
 */ $f406636b535430a7$exports.registerAction({
    type: "brushSelect",
    event: "brushSelected",
    update: "none"
}, function() {});
$f406636b535430a7$exports.registerAction({
    type: "brushEnd",
    event: "brushEnd",
    update: "none"
}, function() {});


var $7c0339f829efdc47$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $7c0339f829efdc47$var$brushLang = $136ae13721f5e257$exports.toolbox.brush;
function $7c0339f829efdc47$var$Brush(model, ecModel, api) {
    this.model = model;
    this.ecModel = ecModel;
    this.api = api;
    /**
   * @private
   * @type {string}
   */ this._brushType;
    /**
   * @private
   * @type {string}
   */ this._brushMode;
}
$7c0339f829efdc47$var$Brush.defaultOption = {
    show: true,
    type: [
        "rect",
        "polygon",
        "lineX",
        "lineY",
        "keep",
        "clear"
    ],
    icon: {
        /* eslint-disable */ rect: "M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13",
        // jshint ignore:line
        polygon: "M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2",
        // jshint ignore:line
        lineX: "M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4",
        // jshint ignore:line
        lineY: "M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4",
        // jshint ignore:line
        keep: "M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z",
        // jshint ignore:line
        clear: "M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2" // jshint ignore:line
    },
    // `rect`, `polygon`, `lineX`, `lineY`, `keep`, `clear`
    title: $ec279652dd95c27b$export$9cd59f9826255e47($7c0339f829efdc47$var$brushLang.title)
};
var $7c0339f829efdc47$var$proto = $7c0339f829efdc47$var$Brush.prototype; // proto.updateLayout = function (featureModel, ecModel, api) {
/* eslint-disable */ $7c0339f829efdc47$var$proto.render = /* eslint-enable */ $7c0339f829efdc47$var$proto.updateView = function(featureModel, ecModel, api) {
    var brushType;
    var brushMode;
    var isBrushed;
    ecModel.eachComponent({
        mainType: "brush"
    }, function(brushModel) {
        brushType = brushModel.brushType;
        brushMode = brushModel.brushOption.brushMode || "single";
        isBrushed |= brushModel.areas.length;
    });
    this._brushType = brushType;
    this._brushMode = brushMode;
    $ec279652dd95c27b$export$79b2f7037acddd43(featureModel.get("type", true), function(type) {
        featureModel.setIconStatus(type, (type === "keep" ? brushMode === "multiple" : type === "clear" ? isBrushed : type === brushType) ? "emphasis" : "normal");
    });
};
$7c0339f829efdc47$var$proto.getIcons = function() {
    var model = this.model;
    var availableIcons = model.get("icon", true);
    var icons = {};
    $ec279652dd95c27b$export$79b2f7037acddd43(model.get("type", true), function(type) {
        if (availableIcons[type]) icons[type] = availableIcons[type];
    });
    return icons;
};
$7c0339f829efdc47$var$proto.onclick = function(ecModel, api, type) {
    var brushType = this._brushType;
    var brushMode = this._brushMode;
    if (type === "clear") {
        // Trigger parallel action firstly
        api.dispatchAction({
            type: "axisAreaSelect",
            intervals: []
        });
        api.dispatchAction({
            type: "brush",
            command: "clear",
            // Clear all areas of all brush components.
            areas: []
        });
    } else api.dispatchAction({
        type: "takeGlobalCursor",
        key: "brush",
        brushOption: {
            brushType: type === "keep" ? brushType : brushType === type ? false : type,
            brushMode: type === "keep" ? brushMode === "multiple" ? "single" : "multiple" : brushMode
        }
    });
};
$d50e8440ce792ca2$export$6503ec6e8aabbaf("brush", $7c0339f829efdc47$var$Brush);
var $7c0339f829efdc47$var$_default = $7c0339f829efdc47$var$Brush;
$7c0339f829efdc47$exports = $7c0339f829efdc47$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Brush component entry
 */ $f406636b535430a7$exports.registerPreprocessor($3680d94a27c921ca$exports);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $2424c162dba9e41f$var$getLayoutRect = $ab0c9086dd6c5b39$export$4517a5ca639a7293;

var $2424c162dba9e41f$var$windowOpen = $a4be9366aeb9fcc8$export$13e13f9b96dbe8fa;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Model
$f406636b535430a7$exports.extendComponentModel({
    type: "title",
    layoutMode: {
        type: "box",
        ignoreSize: true
    },
    defaultOption: {
        // 一级层叠
        zlevel: 0,
        // 二级层叠
        z: 6,
        show: true,
        text: "",
        // 超链接跳转
        // link: null,
        // 仅支持self | blank
        target: "blank",
        subtext: "",
        // 超链接跳转
        // sublink: null,
        // 仅支持self | blank
        subtarget: "blank",
        // 'center' ¦ 'left' ¦ 'right'
        // ¦ {number}（x坐标，单位px）
        left: 0,
        // 'top' ¦ 'bottom' ¦ 'center'
        // ¦ {number}（y坐标，单位px）
        top: 0,
        // 水平对齐
        // 'auto' | 'left' | 'right' | 'center'
        // 默认根据 left 的位置判断是左对齐还是右对齐
        // textAlign: null
        //
        // 垂直对齐
        // 'auto' | 'top' | 'bottom' | 'middle'
        // 默认根据 top 位置判断是上对齐还是下对齐
        // textVerticalAlign: null
        // textBaseline: null // The same as textVerticalAlign.
        backgroundColor: "rgba(0,0,0,0)",
        // 标题边框颜色
        borderColor: "#ccc",
        // 标题边框线宽，单位px，默认为0（无边框）
        borderWidth: 0,
        // 标题内边距，单位px，默认各方向内边距为5，
        // 接受数组分别设定上右下左边距，同css
        padding: 5,
        // 主副标题纵向间隔，单位px，默认为10，
        itemGap: 10,
        textStyle: {
            fontSize: 18,
            fontWeight: "bolder",
            color: "#333"
        },
        subtextStyle: {
            color: "#aaa"
        }
    }
}); // View
$f406636b535430a7$exports.extendComponentView({
    type: "title",
    render: function(titleModel, ecModel, api) {
        this.group.removeAll();
        if (!titleModel.get("show")) return;
        var group = this.group;
        var textStyleModel = titleModel.getModel("textStyle");
        var subtextStyleModel = titleModel.getModel("subtextStyle");
        var textAlign = titleModel.get("textAlign");
        var textVerticalAlign = $ec279652dd95c27b$export$995e01f2f5c9d030(titleModel.get("textBaseline"), titleModel.get("textVerticalAlign"));
        var textEl = new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
            style: $4b57d6b582d579b7$export$6605af501964d89a({}, textStyleModel, {
                text: titleModel.get("text"),
                textFill: textStyleModel.getTextColor()
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var textRect = textEl.getBoundingRect();
        var subText = titleModel.get("subtext");
        var subTextEl = new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
            style: $4b57d6b582d579b7$export$6605af501964d89a({}, subtextStyleModel, {
                text: subText,
                textFill: subtextStyleModel.getTextColor(),
                y: textRect.height + titleModel.get("itemGap"),
                textVerticalAlign: "top"
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var link = titleModel.get("link");
        var sublink = titleModel.get("sublink");
        var triggerEvent = titleModel.get("triggerEvent", true);
        textEl.silent = !link && !triggerEvent;
        subTextEl.silent = !sublink && !triggerEvent;
        if (link) textEl.on("click", function() {
            $2424c162dba9e41f$var$windowOpen(link, "_" + titleModel.get("target"));
        });
        if (sublink) subTextEl.on("click", function() {
            $2424c162dba9e41f$var$windowOpen(sublink, "_" + titleModel.get("subtarget"));
        });
        textEl.eventData = subTextEl.eventData = triggerEvent ? {
            componentType: "title",
            componentIndex: titleModel.componentIndex
        } : null;
        group.add(textEl);
        subText && group.add(subTextEl); // If no subText, but add subTextEl, there will be an empty line.
        var groupRect = group.getBoundingRect();
        var layoutOption = titleModel.getBoxLayoutParams();
        layoutOption.width = groupRect.width;
        layoutOption.height = groupRect.height;
        var layoutRect = $2424c162dba9e41f$var$getLayoutRect(layoutOption, {
            width: api.getWidth(),
            height: api.getHeight()
        }, titleModel.get("padding")); // Adjust text align based on position
        if (!textAlign) {
            // Align left if title is on the left. center and right is same
            textAlign = titleModel.get("left") || titleModel.get("right");
            if (textAlign === "middle") textAlign = "center";
             // Adjust layout by text align
            if (textAlign === "right") layoutRect.x += layoutRect.width;
            else if (textAlign === "center") layoutRect.x += layoutRect.width / 2;
        }
        if (!textVerticalAlign) {
            textVerticalAlign = titleModel.get("top") || titleModel.get("bottom");
            if (textVerticalAlign === "center") textVerticalAlign = "middle";
            if (textVerticalAlign === "bottom") layoutRect.y += layoutRect.height;
            else if (textVerticalAlign === "middle") layoutRect.y += layoutRect.height / 2;
            textVerticalAlign = textVerticalAlign || "top";
        }
        group.attr("position", [
            layoutRect.x,
            layoutRect.y
        ]);
        var alignStyle = {
            textAlign: textAlign,
            textVerticalAlign: textVerticalAlign
        };
        textEl.setStyle(alignStyle);
        subTextEl.setStyle(alignStyle); // Render background
        // Get groupRect again because textAlign has been changed
        groupRect = group.getBoundingRect();
        var padding = layoutRect.margin;
        var style = titleModel.getItemStyle([
            "color",
            "opacity"
        ]);
        style.fill = titleModel.get("backgroundColor");
        var rect = new $4b57d6b582d579b7$export$c79fc6492f3af13d({
            shape: {
                x: groupRect.x - padding[3],
                y: groupRect.y - padding[0],
                width: groupRect.width + padding[1] + padding[3],
                height: groupRect.height + padding[0] + padding[2],
                r: titleModel.get("borderRadius")
            },
            style: style,
            subPixelOptimize: true,
            silent: true
        });
        group.add(rect);
    }
});


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4fcf7a1f81ac6a27$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $4fcf7a1f81ac6a27$var$_default(option) {
    var timelineOpt = option && option.timeline;
    if (!$ec279652dd95c27b$export$43bee75e5e14138e(timelineOpt)) timelineOpt = timelineOpt ? [
        timelineOpt
    ] : [];
    $ec279652dd95c27b$export$79b2f7037acddd43(timelineOpt, function(opt) {
        if (!opt) return;
        $4fcf7a1f81ac6a27$var$compatibleEC2(opt);
    });
}
function $4fcf7a1f81ac6a27$var$compatibleEC2(opt) {
    var type = opt.type;
    var ec2Types = {
        "number": "value",
        "time": "time"
    }; // Compatible with ec2
    if (ec2Types[type]) {
        opt.axisType = ec2Types[type];
        delete opt.type;
    }
    $4fcf7a1f81ac6a27$var$transferItem(opt);
    if ($4fcf7a1f81ac6a27$var$has(opt, "controlPosition")) {
        var controlStyle = opt.controlStyle || (opt.controlStyle = {});
        if (!$4fcf7a1f81ac6a27$var$has(controlStyle, "position")) controlStyle.position = opt.controlPosition;
        if (controlStyle.position === "none" && !$4fcf7a1f81ac6a27$var$has(controlStyle, "show")) {
            controlStyle.show = false;
            delete controlStyle.position;
        }
        delete opt.controlPosition;
    }
    $ec279652dd95c27b$export$79b2f7037acddd43(opt.data || [], function(dataItem) {
        if ($ec279652dd95c27b$export$a6cdc56e425d0d0a(dataItem) && !$ec279652dd95c27b$export$43bee75e5e14138e(dataItem)) {
            if (!$4fcf7a1f81ac6a27$var$has(dataItem, "value") && $4fcf7a1f81ac6a27$var$has(dataItem, "name")) // In ec2, using name as value.
            dataItem.value = dataItem.name;
            $4fcf7a1f81ac6a27$var$transferItem(dataItem);
        }
    });
}
function $4fcf7a1f81ac6a27$var$transferItem(opt) {
    var itemStyle = opt.itemStyle || (opt.itemStyle = {});
    var itemStyleEmphasis = itemStyle.emphasis || (itemStyle.emphasis = {}); // Transfer label out
    var label = opt.label || opt.label || {};
    var labelNormal = label.normal || (label.normal = {});
    var excludeLabelAttr = {
        normal: 1,
        emphasis: 1
    };
    $ec279652dd95c27b$export$79b2f7037acddd43(label, function(value, name) {
        if (!excludeLabelAttr[name] && !$4fcf7a1f81ac6a27$var$has(labelNormal, name)) labelNormal[name] = value;
    });
    if (itemStyleEmphasis.label && !$4fcf7a1f81ac6a27$var$has(label, "emphasis")) {
        label.emphasis = itemStyleEmphasis.label;
        delete itemStyleEmphasis.label;
    }
}
function $4fcf7a1f81ac6a27$var$has(obj, attr) {
    return obj.hasOwnProperty(attr);
}
$4fcf7a1f81ac6a27$exports = $4fcf7a1f81ac6a27$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $3b9c2389e45dfb7d$exports.registerSubTypeDefaulter("timeline", function() {
    // Only slider now.
    return "slider";
});


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerAction({
    type: "timelineChange",
    event: "timelineChanged",
    update: "prepareAndUpdate"
}, function(payload, ecModel) {
    var timelineModel = ecModel.getComponent("timeline");
    if (timelineModel && payload.currentIndex != null) {
        timelineModel.setCurrentIndex(payload.currentIndex);
        if (!timelineModel.get("loop", true) && timelineModel.isIndexMax()) timelineModel.setPlayState(false);
    } // Set normalized currentIndex to payload.
    ecModel.resetOption("timeline");
    return $ec279652dd95c27b$export$ebe90cb607ad99e({
        currentIndex: timelineModel.option.currentIndex
    }, payload);
});
$f406636b535430a7$exports.registerAction({
    type: "timelinePlayChange",
    event: "timelinePlayChanged",
    update: "update"
}, function(payload, ecModel) {
    var timelineModel = ecModel.getComponent("timeline");
    if (timelineModel && payload.playState != null) timelineModel.setPlayState(payload.playState);
});


var $62857e66514cb42a$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fdfe4777a6393623$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $fdfe4777a6393623$var$TimelineModel = $3b9c2389e45dfb7d$exports.extend({
    type: "timeline",
    layoutMode: "box",
    /**
   * @protected
   */ defaultOption: {
        zlevel: 0,
        // 一级层叠
        z: 4,
        // 二级层叠
        show: true,
        axisType: "time",
        // 模式是时间类型，支持 value, category
        realtime: true,
        left: "20%",
        top: null,
        right: "20%",
        bottom: 0,
        width: null,
        height: 40,
        padding: 5,
        controlPosition: "left",
        // 'left' 'right' 'top' 'bottom' 'none'
        autoPlay: false,
        rewind: false,
        // 反向播放
        loop: true,
        playInterval: 2000,
        // 播放时间间隔，单位ms
        currentIndex: 0,
        itemStyle: {},
        label: {
            color: "#000"
        },
        data: []
    },
    /**
   * @override
   */ init: function(option, parentModel, ecModel) {
        /**
     * @private
     * @type {module:echarts/data/List}
     */ this._data;
        /**
     * @private
     * @type {Array.<string>}
     */ this._names;
        this.mergeDefaultAndTheme(option, ecModel);
        this._initData();
    },
    /**
   * @override
   */ mergeOption: function(option) {
        $fdfe4777a6393623$var$TimelineModel.superApply(this, "mergeOption", arguments);
        this._initData();
    },
    /**
   * @param {number} [currentIndex]
   */ setCurrentIndex: function(currentIndex) {
        if (currentIndex == null) currentIndex = this.option.currentIndex;
        var count = this._data.count();
        if (this.option.loop) currentIndex = (currentIndex % count + count) % count;
        else {
            currentIndex >= count && (currentIndex = count - 1);
            currentIndex < 0 && (currentIndex = 0);
        }
        this.option.currentIndex = currentIndex;
    },
    /**
   * @return {number} currentIndex
   */ getCurrentIndex: function() {
        return this.option.currentIndex;
    },
    /**
   * @return {boolean}
   */ isIndexMax: function() {
        return this.getCurrentIndex() >= this._data.count() - 1;
    },
    /**
   * @param {boolean} state true: play, false: stop
   */ setPlayState: function(state) {
        this.option.autoPlay = !!state;
    },
    /**
   * @return {boolean} true: play, false: stop
   */ getPlayState: function() {
        return !!this.option.autoPlay;
    },
    /**
   * @private
   */ _initData: function() {
        var thisOption = this.option;
        var dataArr = thisOption.data || [];
        var axisType = thisOption.axisType;
        var names = this._names = [];
        if (axisType === "category") {
            var idxArr = [];
            $ec279652dd95c27b$export$79b2f7037acddd43(dataArr, function(item, index) {
                var value = $d559f43cb9041423$export$2c944e12edb48d4b(item);
                var newItem;
                if ($ec279652dd95c27b$export$a6cdc56e425d0d0a(item)) {
                    newItem = $ec279652dd95c27b$export$9cd59f9826255e47(item);
                    newItem.value = index;
                } else newItem = index;
                idxArr.push(newItem);
                if (!$ec279652dd95c27b$export$844ec244b1367d54(value) && (value == null || isNaN(value))) value = "";
                names.push(value + "");
            });
            dataArr = idxArr;
        }
        var dimType = {
            category: "ordinal",
            time: "time"
        }[axisType] || "number";
        var data = this._data = new $f643df856475f69e$exports([
            {
                name: "value",
                type: dimType
            }
        ], this);
        data.initData(dataArr, names);
    },
    getData: function() {
        return this._data;
    },
    /**
   * @public
   * @return {Array.<string>} categoreis
   */ getCategories: function() {
        if (this.get("axisType") === "category") return this._names.slice();
    }
});
var $fdfe4777a6393623$var$_default = $fdfe4777a6393623$var$TimelineModel;
$fdfe4777a6393623$exports = $fdfe4777a6393623$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $62857e66514cb42a$var$SliderTimelineModel = $fdfe4777a6393623$exports.extend({
    type: "timeline.slider",
    /**
   * @protected
   */ defaultOption: {
        backgroundColor: "rgba(0,0,0,0)",
        // 时间轴背景颜色
        borderColor: "#ccc",
        // 时间轴边框颜色
        borderWidth: 0,
        // 时间轴边框线宽，单位px，默认为0（无边框）
        orient: "horizontal",
        // 'vertical'
        inverse: false,
        tooltip: {
            // boolean or Object
            trigger: "item" // data item may also have tootip attr.
        },
        symbol: "emptyCircle",
        symbolSize: 10,
        lineStyle: {
            show: true,
            width: 2,
            color: "#304654"
        },
        label: {
            // 文本标签
            position: "auto",
            // auto left right top bottom
            // When using number, label position is not
            // restricted by viewRect.
            // positive: right/bottom, negative: left/top
            show: true,
            interval: "auto",
            rotate: 0,
            // formatter: null,
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: "#304654"
        },
        itemStyle: {
            color: "#304654",
            borderWidth: 1
        },
        checkpointStyle: {
            symbol: "circle",
            symbolSize: 13,
            color: "#c23531",
            borderWidth: 5,
            borderColor: "rgba(194,53,49, 0.5)",
            animation: true,
            animationDuration: 300,
            animationEasing: "quinticInOut"
        },
        controlStyle: {
            show: true,
            showPlayBtn: true,
            showPrevBtn: true,
            showNextBtn: true,
            itemSize: 22,
            itemGap: 12,
            position: "left",
            // 'left' 'right' 'top' 'bottom'
            playIcon: "path://M31.6,53C17.5,53,6,41.5,6,27.4S17.5,1.8,31.6,1.8C45.7,1.8,57.2,13.3,57.2,27.4S45.7,53,31.6,53z M31.6,3.3 C18.4,3.3,7.5,14.1,7.5,27.4c0,13.3,10.8,24.1,24.1,24.1C44.9,51.5,55.7,40.7,55.7,27.4C55.7,14.1,44.9,3.3,31.6,3.3z M24.9,21.3 c0-2.2,1.6-3.1,3.5-2l10.5,6.1c1.899,1.1,1.899,2.9,0,4l-10.5,6.1c-1.9,1.1-3.5,0.2-3.5-2V21.3z",
            // jshint ignore:line
            stopIcon: "path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z",
            // jshint ignore:line
            nextIcon: "path://M18.6,50.8l22.5-22.5c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7L18.7,4.4c-0.1-0.1-0.2-0.3-0.2-0.5 c0-0.4,0.3-0.8,0.8-0.8c0.2,0,0.5,0.1,0.6,0.3l23.5,23.5l0,0c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7l-0.1,0.1L19.7,52 c-0.1,0.1-0.3,0.2-0.5,0.2c-0.4,0-0.8-0.3-0.8-0.8C18.4,51.2,18.5,51,18.6,50.8z",
            // jshint ignore:line
            prevIcon: "path://M43,52.8L20.4,30.3c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.3,0.1-0.5,0.3-0.7L42.9,6.4c0.1-0.1,0.2-0.3,0.2-0.5 c0-0.4-0.3-0.8-0.8-0.8c-0.2,0-0.5,0.1-0.6,0.3L18.3,28.8l0,0c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7l0.1,0.1L41.9,54 c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0,0.8-0.3,0.8-0.8C43.2,53.2,43.1,53,43,52.8z",
            // jshint ignore:line
            color: "#304654",
            borderColor: "#304654",
            borderWidth: 1
        },
        emphasis: {
            label: {
                show: true,
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                color: "#c23531"
            },
            itemStyle: {
                color: "#c23531"
            },
            controlStyle: {
                color: "#c23531",
                borderColor: "#c23531",
                borderWidth: 2
            }
        },
        data: []
    }
});
$ec279652dd95c27b$export$e36fc9d62a853069($62857e66514cb42a$var$SliderTimelineModel, $47a08a90150906d7$exports);
var $62857e66514cb42a$var$_default = $62857e66514cb42a$var$SliderTimelineModel;
$62857e66514cb42a$exports = $62857e66514cb42a$var$_default;


var $909b8eb4a85e59ae$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $b998f4d844d0b56f$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $b998f4d844d0b56f$var$_default = $9c7fc7c628500365$exports.extend({
    type: "timeline"
});
$b998f4d844d0b56f$exports = $b998f4d844d0b56f$var$_default;


var $07d1c902e2c564c5$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Extend axis 2d
 * @constructor module:echarts/coord/cartesian/Axis2D
 * @extends {module:echarts/coord/cartesian/Axis}
 * @param {string} dim
 * @param {*} scale
 * @param {Array.<number>} coordExtent
 * @param {string} axisType
 * @param {string} position
 */ var $07d1c902e2c564c5$var$TimelineAxis = function(dim, scale, coordExtent, axisType) {
    $95e1f94acccc578d$exports.call(this, dim, scale, coordExtent);
    /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */ this.type = axisType || "value";
    /**
   * Axis model
   * @param {module:echarts/component/TimelineModel}
   */ this.model = null;
};
$07d1c902e2c564c5$var$TimelineAxis.prototype = {
    constructor: $07d1c902e2c564c5$var$TimelineAxis,
    /**
   * @override
   */ getLabelModel: function() {
        return this.model.getModel("label");
    },
    /**
   * @override
   */ isHorizontal: function() {
        return this.model.get("orient") === "horizontal";
    }
};
$ec279652dd95c27b$export$69f1b2dcda23c5f8($07d1c902e2c564c5$var$TimelineAxis, $95e1f94acccc578d$exports);
var $07d1c902e2c564c5$var$_default = $07d1c902e2c564c5$var$TimelineAxis;
$07d1c902e2c564c5$exports = $07d1c902e2c564c5$var$_default;



var $909b8eb4a85e59ae$var$createSymbol = $804dcb9a0b78b5fe$export$af050e04da3a02e8;



var $909b8eb4a85e59ae$var$encodeHTML = $a4be9366aeb9fcc8$export$f9d6449b9af28dc1;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $909b8eb4a85e59ae$var$bind = $ec279652dd95c27b$export$2385a24977818dd0;
var $909b8eb4a85e59ae$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $909b8eb4a85e59ae$var$PI = Math.PI;
var $909b8eb4a85e59ae$var$_default = $b998f4d844d0b56f$exports.extend({
    type: "timeline.slider",
    init: function(ecModel, api) {
        this.api = api;
        /**
     * @private
     * @type {module:echarts/component/timeline/TimelineAxis}
     */ this._axis;
        /**
     * @private
     * @type {module:zrender/core/BoundingRect}
     */ this._viewRect;
        /**
     * @type {number}
     */ this._timer;
        /**
     * @type {module:zrender/Element}
     */ this._currentPointer;
        /**
     * @type {module:zrender/container/Group}
     */ this._mainGroup;
        /**
     * @type {module:zrender/container/Group}
     */ this._labelGroup;
    },
    /**
   * @override
   */ render: function(timelineModel, ecModel, api, payload) {
        this.model = timelineModel;
        this.api = api;
        this.ecModel = ecModel;
        this.group.removeAll();
        if (timelineModel.get("show", true)) {
            var layoutInfo = this._layout(timelineModel, api);
            var mainGroup = this._createGroup("mainGroup");
            var labelGroup = this._createGroup("labelGroup");
            /**
       * @private
       * @type {module:echarts/component/timeline/TimelineAxis}
       */ var axis = this._axis = this._createAxis(layoutInfo, timelineModel);
            timelineModel.formatTooltip = function(dataIndex) {
                return $909b8eb4a85e59ae$var$encodeHTML(axis.scale.getLabel(dataIndex));
            };
            $909b8eb4a85e59ae$var$each([
                "AxisLine",
                "AxisTick",
                "Control",
                "CurrentPointer"
            ], function(name) {
                this["_render" + name](layoutInfo, mainGroup, axis, timelineModel);
            }, this);
            this._renderAxisLabel(layoutInfo, labelGroup, axis, timelineModel);
            this._position(layoutInfo, timelineModel);
        }
        this._doPlayStop();
    },
    /**
   * @override
   */ remove: function() {
        this._clearTimer();
        this.group.removeAll();
    },
    /**
   * @override
   */ dispose: function() {
        this._clearTimer();
    },
    _layout: function(timelineModel, api) {
        var labelPosOpt = timelineModel.get("label.position");
        var orient = timelineModel.get("orient");
        var viewRect = $909b8eb4a85e59ae$var$getViewRect(timelineModel, api); // Auto label offset.
        if (labelPosOpt == null || labelPosOpt === "auto") labelPosOpt = orient === "horizontal" ? viewRect.y + viewRect.height / 2 < api.getHeight() / 2 ? "-" : "+" : viewRect.x + viewRect.width / 2 < api.getWidth() / 2 ? "+" : "-";
        else if (isNaN(labelPosOpt)) labelPosOpt = ({
            horizontal: {
                top: "-",
                bottom: "+"
            },
            vertical: {
                left: "-",
                right: "+"
            }
        })[orient][labelPosOpt];
        var labelAlignMap = {
            horizontal: "center",
            vertical: labelPosOpt >= 0 || labelPosOpt === "+" ? "left" : "right"
        };
        var labelBaselineMap = {
            horizontal: labelPosOpt >= 0 || labelPosOpt === "+" ? "top" : "bottom",
            vertical: "middle"
        };
        var rotationMap = {
            horizontal: 0,
            vertical: $909b8eb4a85e59ae$var$PI / 2
        }; // Position
        var mainLength = orient === "vertical" ? viewRect.height : viewRect.width;
        var controlModel = timelineModel.getModel("controlStyle");
        var showControl = controlModel.get("show", true);
        var controlSize = showControl ? controlModel.get("itemSize") : 0;
        var controlGap = showControl ? controlModel.get("itemGap") : 0;
        var sizePlusGap = controlSize + controlGap; // Special label rotate.
        var labelRotation = timelineModel.get("label.rotate") || 0;
        labelRotation = labelRotation * $909b8eb4a85e59ae$var$PI / 180; // To radian.
        var playPosition;
        var prevBtnPosition;
        var nextBtnPosition;
        var axisExtent;
        var controlPosition = controlModel.get("position", true);
        var showPlayBtn = showControl && controlModel.get("showPlayBtn", true);
        var showPrevBtn = showControl && controlModel.get("showPrevBtn", true);
        var showNextBtn = showControl && controlModel.get("showNextBtn", true);
        var xLeft = 0;
        var xRight = mainLength; // position[0] means left, position[1] means middle.
        if (controlPosition === "left" || controlPosition === "bottom") {
            showPlayBtn && (playPosition = [
                0,
                0
            ], xLeft += sizePlusGap);
            showPrevBtn && (prevBtnPosition = [
                xLeft,
                0
            ], xLeft += sizePlusGap);
            showNextBtn && (nextBtnPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
        } else {
            // 'top' 'right'
            showPlayBtn && (playPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
            showPrevBtn && (prevBtnPosition = [
                0,
                0
            ], xLeft += sizePlusGap);
            showNextBtn && (nextBtnPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
        }
        axisExtent = [
            xLeft,
            xRight
        ];
        if (timelineModel.get("inverse")) axisExtent.reverse();
        return {
            viewRect: viewRect,
            mainLength: mainLength,
            orient: orient,
            rotation: rotationMap[orient],
            labelRotation: labelRotation,
            labelPosOpt: labelPosOpt,
            labelAlign: timelineModel.get("label.align") || labelAlignMap[orient],
            labelBaseline: timelineModel.get("label.verticalAlign") || timelineModel.get("label.baseline") || labelBaselineMap[orient],
            // Based on mainGroup.
            playPosition: playPosition,
            prevBtnPosition: prevBtnPosition,
            nextBtnPosition: nextBtnPosition,
            axisExtent: axisExtent,
            controlSize: controlSize,
            controlGap: controlGap
        };
    },
    _position: function(layoutInfo, timelineModel) {
        // Position is be called finally, because bounding rect is needed for
        // adapt content to fill viewRect (auto adapt offset).
        // Timeline may be not all in the viewRect when 'offset' is specified
        // as a number, because it is more appropriate that label aligns at
        // 'offset' but not the other edge defined by viewRect.
        var mainGroup = this._mainGroup;
        var labelGroup = this._labelGroup;
        var viewRect = layoutInfo.viewRect;
        if (layoutInfo.orient === "vertical") {
            // transform to horizontal, inverse rotate by left-top point.
            var m = $6c6dd9610ba660f0$export$185802fd694ee1f5();
            var rotateOriginX = viewRect.x;
            var rotateOriginY = viewRect.y + viewRect.height;
            $6c6dd9610ba660f0$export$d73ee8ef04f5226a(m, m, [
                -rotateOriginX,
                -rotateOriginY
            ]);
            $6c6dd9610ba660f0$export$bb628a54ab399bc9(m, m, -$909b8eb4a85e59ae$var$PI / 2);
            $6c6dd9610ba660f0$export$d73ee8ef04f5226a(m, m, [
                rotateOriginX,
                rotateOriginY
            ]);
            viewRect = viewRect.clone();
            viewRect.applyTransform(m);
        }
        var viewBound = getBound(viewRect);
        var mainBound = getBound(mainGroup.getBoundingRect());
        var labelBound = getBound(labelGroup.getBoundingRect());
        var mainPosition = mainGroup.position;
        var labelsPosition = labelGroup.position;
        labelsPosition[0] = mainPosition[0] = viewBound[0][0];
        var labelPosOpt = layoutInfo.labelPosOpt;
        if (isNaN(labelPosOpt)) {
            // '+' or '-'
            var mainBoundIdx = labelPosOpt === "+" ? 0 : 1;
            toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
            toBound(labelsPosition, labelBound, viewBound, 1, 1 - mainBoundIdx);
        } else {
            var mainBoundIdx = labelPosOpt >= 0 ? 0 : 1;
            toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
            labelsPosition[1] = mainPosition[1] + labelPosOpt;
        }
        mainGroup.attr("position", mainPosition);
        labelGroup.attr("position", labelsPosition);
        mainGroup.rotation = labelGroup.rotation = layoutInfo.rotation;
        setOrigin(mainGroup);
        setOrigin(labelGroup);
        function setOrigin(targetGroup) {
            var pos = targetGroup.position;
            targetGroup.origin = [
                viewBound[0][0] - pos[0],
                viewBound[1][0] - pos[1]
            ];
        }
        function getBound(rect) {
            // [[xmin, xmax], [ymin, ymax]]
            return [
                [
                    rect.x,
                    rect.x + rect.width
                ],
                [
                    rect.y,
                    rect.y + rect.height
                ]
            ];
        }
        function toBound(fromPos, from, to, dimIdx, boundIdx) {
            fromPos[dimIdx] += to[dimIdx][boundIdx] - from[dimIdx][boundIdx];
        }
    },
    _createAxis: function(layoutInfo, timelineModel) {
        var data = timelineModel.getData();
        var axisType = timelineModel.get("axisType");
        var scale = $13542623aa20eeae$export$8941c4cacdc8f5a5(timelineModel, axisType); // Customize scale. The `tickValue` is `dataIndex`.
        scale.getTicks = function() {
            return data.mapArray([
                "value"
            ], function(value) {
                return value;
            });
        };
        var dataExtent = data.getDataExtent("value");
        scale.setExtent(dataExtent[0], dataExtent[1]);
        scale.niceTicks();
        var axis = new $07d1c902e2c564c5$exports("value", scale, layoutInfo.axisExtent, axisType);
        axis.model = timelineModel;
        return axis;
    },
    _createGroup: function(name) {
        var newGroup = this["_" + name] = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
        this.group.add(newGroup);
        return newGroup;
    },
    _renderAxisLine: function(layoutInfo, group, axis, timelineModel) {
        var axisExtent = axis.getExtent();
        if (!timelineModel.get("lineStyle.show")) return;
        group.add(new $4b57d6b582d579b7$export$17d680238e50603e({
            shape: {
                x1: axisExtent[0],
                y1: 0,
                x2: axisExtent[1],
                y2: 0
            },
            style: $ec279652dd95c27b$export$8b58be045bf06082({
                lineCap: "round"
            }, timelineModel.getModel("lineStyle").getLineStyle()),
            silent: true,
            z2: 1
        }));
    },
    /**
   * @private
   */ _renderAxisTick: function(layoutInfo, group, axis, timelineModel) {
        var data = timelineModel.getData(); // Show all ticks, despite ignoring strategy.
        var ticks = axis.scale.getTicks(); // The value is dataIndex, see the costomized scale.
        $909b8eb4a85e59ae$var$each(ticks, function(value) {
            var tickCoord = axis.dataToCoord(value);
            var itemModel = data.getItemModel(value);
            var itemStyleModel = itemModel.getModel("itemStyle");
            var hoverStyleModel = itemModel.getModel("emphasis.itemStyle");
            var symbolOpt = {
                position: [
                    tickCoord,
                    0
                ],
                onclick: $909b8eb4a85e59ae$var$bind(this._changeTimeline, this, value)
            };
            var el = $909b8eb4a85e59ae$var$giveSymbol(itemModel, itemStyleModel, group, symbolOpt);
            $4b57d6b582d579b7$export$28b42df8183f218c(el, hoverStyleModel.getItemStyle());
            if (itemModel.get("tooltip")) {
                el.dataIndex = value;
                el.dataModel = timelineModel;
            } else el.dataIndex = el.dataModel = null;
        }, this);
    },
    /**
   * @private
   */ _renderAxisLabel: function(layoutInfo, group, axis, timelineModel) {
        var labelModel = axis.getLabelModel();
        if (!labelModel.get("show")) return;
        var data = timelineModel.getData();
        var labels = axis.getViewLabels();
        $909b8eb4a85e59ae$var$each(labels, function(labelItem) {
            // The tickValue is dataIndex, see the costomized scale.
            var dataIndex = labelItem.tickValue;
            var itemModel = data.getItemModel(dataIndex);
            var normalLabelModel = itemModel.getModel("label");
            var hoverLabelModel = itemModel.getModel("emphasis.label");
            var tickCoord = axis.dataToCoord(labelItem.tickValue);
            var textEl = new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
                position: [
                    tickCoord,
                    0
                ],
                rotation: layoutInfo.labelRotation - layoutInfo.rotation,
                onclick: $909b8eb4a85e59ae$var$bind(this._changeTimeline, this, dataIndex),
                silent: false
            });
            $4b57d6b582d579b7$export$6605af501964d89a(textEl.style, normalLabelModel, {
                text: labelItem.formattedLabel,
                textAlign: layoutInfo.labelAlign,
                textVerticalAlign: layoutInfo.labelBaseline
            });
            group.add(textEl);
            $4b57d6b582d579b7$export$28b42df8183f218c(textEl, $4b57d6b582d579b7$export$6605af501964d89a({}, hoverLabelModel));
        }, this);
    },
    /**
   * @private
   */ _renderControl: function(layoutInfo, group, axis, timelineModel) {
        var controlSize = layoutInfo.controlSize;
        var rotation = layoutInfo.rotation;
        var itemStyle = timelineModel.getModel("controlStyle").getItemStyle();
        var hoverStyle = timelineModel.getModel("emphasis.controlStyle").getItemStyle();
        var rect = [
            0,
            -controlSize / 2,
            controlSize,
            controlSize
        ];
        var playState = timelineModel.getPlayState();
        var inverse = timelineModel.get("inverse", true);
        makeBtn(layoutInfo.nextBtnPosition, "controlStyle.nextIcon", $909b8eb4a85e59ae$var$bind(this._changeTimeline, this, inverse ? "-" : "+"));
        makeBtn(layoutInfo.prevBtnPosition, "controlStyle.prevIcon", $909b8eb4a85e59ae$var$bind(this._changeTimeline, this, inverse ? "+" : "-"));
        makeBtn(layoutInfo.playPosition, "controlStyle." + (playState ? "stopIcon" : "playIcon"), $909b8eb4a85e59ae$var$bind(this._handlePlayClick, this, !playState), true);
        function makeBtn(position, iconPath, onclick, willRotate) {
            if (!position) return;
            var opt = {
                position: position,
                origin: [
                    controlSize / 2,
                    0
                ],
                rotation: willRotate ? -rotation : 0,
                rectHover: true,
                style: itemStyle,
                onclick: onclick
            };
            var btn = $909b8eb4a85e59ae$var$makeIcon(timelineModel, iconPath, rect, opt);
            group.add(btn);
            $4b57d6b582d579b7$export$28b42df8183f218c(btn, hoverStyle);
        }
    },
    _renderCurrentPointer: function(layoutInfo, group, axis, timelineModel) {
        var data = timelineModel.getData();
        var currentIndex = timelineModel.getCurrentIndex();
        var pointerModel = data.getItemModel(currentIndex).getModel("checkpointStyle");
        var me = this;
        var callback = {
            onCreate: function(pointer) {
                pointer.draggable = true;
                pointer.drift = $909b8eb4a85e59ae$var$bind(me._handlePointerDrag, me);
                pointer.ondragend = $909b8eb4a85e59ae$var$bind(me._handlePointerDragend, me);
                $909b8eb4a85e59ae$var$pointerMoveTo(pointer, currentIndex, axis, timelineModel, true);
            },
            onUpdate: function(pointer) {
                $909b8eb4a85e59ae$var$pointerMoveTo(pointer, currentIndex, axis, timelineModel);
            }
        }; // Reuse when exists, for animation and drag.
        this._currentPointer = $909b8eb4a85e59ae$var$giveSymbol(pointerModel, pointerModel, this._mainGroup, {}, this._currentPointer, callback);
    },
    _handlePlayClick: function(nextState) {
        this._clearTimer();
        this.api.dispatchAction({
            type: "timelinePlayChange",
            playState: nextState,
            from: this.uid
        });
    },
    _handlePointerDrag: function(dx, dy, e) {
        this._clearTimer();
        this._pointerChangeTimeline([
            e.offsetX,
            e.offsetY
        ]);
    },
    _handlePointerDragend: function(e) {
        this._pointerChangeTimeline([
            e.offsetX,
            e.offsetY
        ], true);
    },
    _pointerChangeTimeline: function(mousePos, trigger) {
        var toCoord = this._toAxisCoord(mousePos)[0];
        var axis = this._axis;
        var axisExtent = $2d742dbe7f960d8c$export$debe6e778e0a6d32(axis.getExtent().slice());
        toCoord > axisExtent[1] && (toCoord = axisExtent[1]);
        toCoord < axisExtent[0] && (toCoord = axisExtent[0]);
        this._currentPointer.position[0] = toCoord;
        this._currentPointer.dirty();
        var targetDataIndex = this._findNearestTick(toCoord);
        var timelineModel = this.model;
        if (trigger || targetDataIndex !== timelineModel.getCurrentIndex() && timelineModel.get("realtime")) this._changeTimeline(targetDataIndex);
    },
    _doPlayStop: function() {
        this._clearTimer();
        if (this.model.getPlayState()) this._timer = setTimeout($909b8eb4a85e59ae$var$bind(handleFrame, this), this.model.get("playInterval"));
        function handleFrame() {
            // Do not cache
            var timelineModel = this.model;
            this._changeTimeline(timelineModel.getCurrentIndex() + (timelineModel.get("rewind", true) ? -1 : 1));
        }
    },
    _toAxisCoord: function(vertex) {
        var trans = this._mainGroup.getLocalTransform();
        return $4b57d6b582d579b7$export$9f9dcb98c894b623(vertex, trans, true);
    },
    _findNearestTick: function(axisCoord) {
        var data = this.model.getData();
        var dist = Infinity;
        var targetDataIndex;
        var axis = this._axis;
        data.each([
            "value"
        ], function(value, dataIndex) {
            var coord = axis.dataToCoord(value);
            var d = Math.abs(coord - axisCoord);
            if (d < dist) {
                dist = d;
                targetDataIndex = dataIndex;
            }
        });
        return targetDataIndex;
    },
    _clearTimer: function() {
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
    },
    _changeTimeline: function(nextIndex) {
        var currentIndex = this.model.getCurrentIndex();
        if (nextIndex === "+") nextIndex = currentIndex + 1;
        else if (nextIndex === "-") nextIndex = currentIndex - 1;
        this.api.dispatchAction({
            type: "timelineChange",
            currentIndex: nextIndex,
            from: this.uid
        });
    }
});
function $909b8eb4a85e59ae$var$getViewRect(model, api) {
    return $ab0c9086dd6c5b39$export$4517a5ca639a7293(model.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    }, model.get("padding"));
}
function $909b8eb4a85e59ae$var$makeIcon(timelineModel, objPath, rect, opts) {
    var style = opts.style;
    var icon = $4b57d6b582d579b7$export$274edc73af1ae9c8(timelineModel.get(objPath), opts || {}, new $33e4fae744d34798$exports(rect[0], rect[1], rect[2], rect[3])); // TODO createIcon won't use style in opt.
    if (style) icon.setStyle(style);
    return icon;
}
/**
 * Create symbol or update symbol
 * opt: basic position and event handlers
 */ function $909b8eb4a85e59ae$var$giveSymbol(hostModel, itemStyleModel, group, opt, symbol, callback) {
    var color = itemStyleModel.get("color");
    if (!symbol) {
        var symbolType = hostModel.get("symbol");
        symbol = $909b8eb4a85e59ae$var$createSymbol(symbolType, -1, -1, 2, 2, color);
        symbol.setStyle("strokeNoScale", true);
        group.add(symbol);
        callback && callback.onCreate(symbol);
    } else {
        symbol.setColor(color);
        group.add(symbol); // Group may be new, also need to add.
        callback && callback.onUpdate(symbol);
    } // Style
    var itemStyle = itemStyleModel.getItemStyle([
        "color",
        "symbol",
        "symbolSize"
    ]);
    symbol.setStyle(itemStyle); // Transform and events.
    opt = $ec279652dd95c27b$export$4950aa0f605343fb({
        rectHover: true,
        z2: 100
    }, opt, true);
    var symbolSize = hostModel.get("symbolSize");
    symbolSize = symbolSize instanceof Array ? symbolSize.slice() : [
        +symbolSize,
        +symbolSize
    ];
    symbolSize[0] /= 2;
    symbolSize[1] /= 2;
    opt.scale = symbolSize;
    var symbolOffset = hostModel.get("symbolOffset");
    if (symbolOffset) {
        var pos = opt.position = opt.position || [
            0,
            0
        ];
        pos[0] += $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(symbolOffset[0], symbolSize[0]);
        pos[1] += $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(symbolOffset[1], symbolSize[1]);
    }
    var symbolRotate = hostModel.get("symbolRotate");
    opt.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
    symbol.attr(opt); // FIXME
    // (1) When symbol.style.strokeNoScale is true and updateTransform is not performed,
    // getBoundingRect will return wrong result.
    // (This is supposed to be resolved in zrender, but it is a little difficult to
    // leverage performance and auto updateTransform)
    // (2) All of ancesters of symbol do not scale, so we can just updateTransform symbol.
    symbol.updateTransform();
    return symbol;
}
function $909b8eb4a85e59ae$var$pointerMoveTo(pointer, dataIndex, axis, timelineModel, noAnimation) {
    if (pointer.dragging) return;
    var pointerModel = timelineModel.getModel("checkpointStyle");
    var toCoord = axis.dataToCoord(timelineModel.getData().get([
        "value"
    ], dataIndex));
    if (noAnimation || !pointerModel.get("animation", true)) pointer.attr({
        position: [
            toCoord,
            0
        ]
    });
    else {
        pointer.stopAnimation(true);
        pointer.animateTo({
            position: [
                toCoord,
                0
            ]
        }, pointerModel.get("animationDuration", true), pointerModel.get("animationEasing", true));
    }
}
$909b8eb4a85e59ae$exports = $909b8eb4a85e59ae$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * DataZoom component entry
 */ $f406636b535430a7$exports.registerPreprocessor($4fcf7a1f81ac6a27$exports);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4836436a927303dd$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $540fef5090737dc7$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $540fef5090737dc7$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $540fef5090737dc7$var$addCommas = $a4be9366aeb9fcc8$export$b6fe44657ce35c42;
var $540fef5090737dc7$var$encodeHTML = $a4be9366aeb9fcc8$export$f9d6449b9af28dc1;
function $540fef5090737dc7$var$fillLabel(opt) {
    $d559f43cb9041423$export$abdcc6a26372f94b(opt, "label", [
        "show"
    ]);
}
var $540fef5090737dc7$var$MarkerModel = $f406636b535430a7$exports.extendComponentModel({
    type: "marker",
    dependencies: [
        "series",
        "grid",
        "polar",
        "geo"
    ],
    /**
   * @overrite
   */ init: function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        this._mergeOption(option, ecModel, false, true);
    },
    /**
   * @return {boolean}
   */ isAnimationEnabled: function() {
        if ($27ac1413ecc67076$exports.node) return false;
        var hostSeries = this.__hostSeries;
        return this.getShallow("animation") && hostSeries && hostSeries.isAnimationEnabled();
    },
    /**
   * @overrite
   */ mergeOption: function(newOpt, ecModel) {
        this._mergeOption(newOpt, ecModel, false, false);
    },
    _mergeOption: function(newOpt, ecModel, createdBySelf, isInit) {
        var MarkerModel = this.constructor;
        var modelPropName = this.mainType + "Model";
        if (!createdBySelf) ecModel.eachSeries(function(seriesModel) {
            var markerOpt = seriesModel.get(this.mainType, true);
            var markerModel = seriesModel[modelPropName];
            if (!markerOpt || !markerOpt.data) {
                seriesModel[modelPropName] = null;
                return;
            }
            if (!markerModel) {
                if (isInit) // Default label emphasis `position` and `show`
                $540fef5090737dc7$var$fillLabel(markerOpt);
                $ec279652dd95c27b$export$79b2f7037acddd43(markerOpt.data, function(item) {
                    // FIXME Overwrite fillLabel method ?
                    if (item instanceof Array) {
                        $540fef5090737dc7$var$fillLabel(item[0]);
                        $540fef5090737dc7$var$fillLabel(item[1]);
                    } else $540fef5090737dc7$var$fillLabel(item);
                });
                markerModel = new MarkerModel(markerOpt, this, ecModel);
                $ec279652dd95c27b$export$8b58be045bf06082(markerModel, {
                    mainType: this.mainType,
                    // Use the same series index and name
                    seriesIndex: seriesModel.seriesIndex,
                    name: seriesModel.name,
                    createdBySelf: true
                });
                markerModel.__hostSeries = seriesModel;
            } else markerModel._mergeOption(markerOpt, ecModel, true);
            seriesModel[modelPropName] = markerModel;
        }, this);
    },
    formatTooltip: function(dataIndex, multipleSeries, dataType, renderMode) {
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var formattedValue = $ec279652dd95c27b$export$43bee75e5e14138e(value) ? $ec279652dd95c27b$export$871de8747c9eaa88(value, $540fef5090737dc7$var$addCommas).join(", ") : $540fef5090737dc7$var$addCommas(value);
        var name = data.getName(dataIndex);
        var html = $540fef5090737dc7$var$encodeHTML(this.name);
        var newLine = renderMode === "html" ? "<br/>" : "\n";
        if (value != null || name) html += newLine;
        if (name) {
            html += $540fef5090737dc7$var$encodeHTML(name);
            if (value != null) html += " : ";
        }
        if (value != null) html += $540fef5090737dc7$var$encodeHTML(formattedValue);
        return html;
    },
    getData: function() {
        return this._data;
    },
    setData: function(data) {
        this._data = data;
    }
});
$ec279652dd95c27b$export$e36fc9d62a853069($540fef5090737dc7$var$MarkerModel, $47a08a90150906d7$exports);
var $540fef5090737dc7$var$_default = $540fef5090737dc7$var$MarkerModel;
$540fef5090737dc7$exports = $540fef5090737dc7$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $4836436a927303dd$var$_default = $540fef5090737dc7$exports.extend({
    type: "markPoint",
    defaultOption: {
        zlevel: 0,
        z: 5,
        symbol: "pin",
        symbolSize: 50,
        //symbolRotate: 0,
        //symbolOffset: [0, 0]
        tooltip: {
            trigger: "item"
        },
        label: {
            show: true,
            position: "inside"
        },
        itemStyle: {
            borderWidth: 2
        },
        emphasis: {
            label: {
                show: true
            }
        }
    }
});
$4836436a927303dd$exports = $4836436a927303dd$var$_default;


var $373691ec0b5357a8$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $44f2f8e18f62e3d5$export$3eebd2d54b98c04f;
var $44f2f8e18f62e3d5$export$bd39458db76002ab;
var $44f2f8e18f62e3d5$export$179695f4a9040f73;
var $44f2f8e18f62e3d5$export$426eee13be6be7f;
var $44f2f8e18f62e3d5$export$18ddefb55c03640b;



var $44f2f8e18f62e3d5$var$isDimensionStacked = $1712a5e8fbedbcb3$export$1dedc39359ae35c;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $44f2f8e18f62e3d5$var$indexOf = $ec279652dd95c27b$export$305f7d4e9d4624f2;
function $44f2f8e18f62e3d5$var$hasXOrY(item) {
    return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
}
function $44f2f8e18f62e3d5$var$hasXAndY(item) {
    return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
} // Make it simple, do not visit all stacked value to count precision.
// function getPrecision(data, valueAxisDim, dataIndex) {
//     var precision = -1;
//     var stackedDim = data.mapDimension(valueAxisDim);
//     do {
//         precision = Math.max(
//             numberUtil.getPrecision(data.get(stackedDim, dataIndex)),
//             precision
//         );
//         var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
//         if (stackedOnSeries) {
//             var byValue = data.get(data.getCalculationInfo('stackedByDimension'), dataIndex);
//             data = stackedOnSeries.getData();
//             dataIndex = data.indexOf(data.getCalculationInfo('stackedByDimension'), byValue);
//             stackedDim = data.getCalculationInfo('stackedDimension');
//         }
//         else {
//             data = null;
//         }
//     } while (data);
//     return precision;
// }
function $44f2f8e18f62e3d5$var$markerTypeCalculatorWithExtent(mlType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
    var coordArr = [];
    var stacked = $44f2f8e18f62e3d5$var$isDimensionStacked(data, targetDataDim);
    var calcDataDim = stacked ? data.getCalculationInfo("stackResultDimension") : targetDataDim;
    var value = $44f2f8e18f62e3d5$var$numCalculate(data, calcDataDim, mlType);
    var dataIndex = data.indicesOfNearest(calcDataDim, value)[0];
    coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
    coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
    var coordArrValue = data.get(targetDataDim, dataIndex); // Make it simple, do not visit all stacked value to count precision.
    var precision = $2d742dbe7f960d8c$export$e0c74b50bbd10f68(data.get(targetDataDim, dataIndex));
    precision = Math.min(precision, 20);
    if (precision >= 0) coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
    return [
        coordArr,
        coordArrValue
    ];
}
var $44f2f8e18f62e3d5$var$curry = $ec279652dd95c27b$export$c3095a23b368d1f2; // TODO Specified percent
var $44f2f8e18f62e3d5$var$markerTypeCalculator = {
    /**
   * @method
   * @param {module:echarts/data/List} data
   * @param {string} baseAxisDim
   * @param {string} valueAxisDim
   */ min: $44f2f8e18f62e3d5$var$curry($44f2f8e18f62e3d5$var$markerTypeCalculatorWithExtent, "min"),
    /**
   * @method
   * @param {module:echarts/data/List} data
   * @param {string} baseAxisDim
   * @param {string} valueAxisDim
   */ max: $44f2f8e18f62e3d5$var$curry($44f2f8e18f62e3d5$var$markerTypeCalculatorWithExtent, "max"),
    /**
   * @method
   * @param {module:echarts/data/List} data
   * @param {string} baseAxisDim
   * @param {string} valueAxisDim
   */ average: $44f2f8e18f62e3d5$var$curry($44f2f8e18f62e3d5$var$markerTypeCalculatorWithExtent, "average")
};
/**
 * Transform markPoint data item to format used in List by do the following
 * 1. Calculate statistic like `max`, `min`, `average`
 * 2. Convert `item.xAxis`, `item.yAxis` to `item.coord` array
 * @param  {module:echarts/model/Series} seriesModel
 * @param  {module:echarts/coord/*} [coordSys]
 * @param  {Object} item
 * @return {Object}
 */ function $44f2f8e18f62e3d5$var$dataTransform(seriesModel, item) {
    var data = seriesModel.getData();
    var coordSys = seriesModel.coordinateSystem; // 1. If not specify the position with pixel directly
    // 2. If `coord` is not a data array. Which uses `xAxis`,
    // `yAxis` to specify the coord on each dimension
    // parseFloat first because item.x and item.y can be percent string like '20%'
    if (item && !$44f2f8e18f62e3d5$var$hasXAndY(item) && !$ec279652dd95c27b$export$43bee75e5e14138e(item.coord) && coordSys) {
        var dims = coordSys.dimensions;
        var axisInfo = $44f2f8e18f62e3d5$var$getAxisInfo(item, data, coordSys, seriesModel); // Clone the option
        // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value
        item = $ec279652dd95c27b$export$9cd59f9826255e47(item);
        if (item.type && $44f2f8e18f62e3d5$var$markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
            var otherCoordIndex = $44f2f8e18f62e3d5$var$indexOf(dims, axisInfo.baseAxis.dim);
            var targetCoordIndex = $44f2f8e18f62e3d5$var$indexOf(dims, axisInfo.valueAxis.dim);
            var coordInfo = $44f2f8e18f62e3d5$var$markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
            item.coord = coordInfo[0]; // Force to use the value of calculated value.
            // let item use the value without stack.
            item.value = coordInfo[1];
        } else {
            // FIXME Only has one of xAxis and yAxis.
            var coord = [
                item.xAxis != null ? item.xAxis : item.radiusAxis,
                item.yAxis != null ? item.yAxis : item.angleAxis
            ]; // Each coord support max, min, average
            for(var i = 0; i < 2; i++)if ($44f2f8e18f62e3d5$var$markerTypeCalculator[coord[i]]) coord[i] = $44f2f8e18f62e3d5$var$numCalculate(data, data.mapDimension(dims[i]), coord[i]);
            item.coord = coord;
        }
    }
    return item;
}
function $44f2f8e18f62e3d5$var$getAxisInfo(item, data, coordSys, seriesModel) {
    var ret = {};
    if (item.valueIndex != null || item.valueDim != null) {
        ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
        ret.valueAxis = coordSys.getAxis($44f2f8e18f62e3d5$var$dataDimToCoordDim(seriesModel, ret.valueDataDim));
        ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
    } else {
        ret.baseAxis = seriesModel.getBaseAxis();
        ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
        ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
    }
    return ret;
}
function $44f2f8e18f62e3d5$var$dataDimToCoordDim(seriesModel, dataDim) {
    var data = seriesModel.getData();
    var dimensions = data.dimensions;
    dataDim = data.getDimension(dataDim);
    for(var i = 0; i < dimensions.length; i++){
        var dimItem = data.getDimensionInfo(dimensions[i]);
        if (dimItem.name === dataDim) return dimItem.coordDim;
    }
}
/**
 * Filter data which is out of coordinateSystem range
 * [dataFilter description]
 * @param  {module:echarts/coord/*} [coordSys]
 * @param  {Object} item
 * @return {boolean}
 */ function $44f2f8e18f62e3d5$var$dataFilter(coordSys, item) {
    // Alwalys return true if there is no coordSys
    return coordSys && coordSys.containData && item.coord && !$44f2f8e18f62e3d5$var$hasXOrY(item) ? coordSys.containData(item.coord) : true;
}
function $44f2f8e18f62e3d5$var$dimValueGetter(item, dimName, dataIndex, dimIndex) {
    // x, y, radius, angle
    if (dimIndex < 2) return item.coord && item.coord[dimIndex];
    return item.value;
}
function $44f2f8e18f62e3d5$var$numCalculate(data, valueDataDim, type) {
    if (type === "average") {
        var sum = 0;
        var count = 0;
        data.each(valueDataDim, function(val, idx) {
            if (!isNaN(val)) {
                sum += val;
                count++;
            }
        });
        return sum / count;
    } else if (type === "median") return data.getMedian(valueDataDim);
    else // max & min
    return data.getDataExtent(valueDataDim, true)[type === "max" ? 1 : 0];
}
$44f2f8e18f62e3d5$export$3eebd2d54b98c04f = $44f2f8e18f62e3d5$var$dataTransform;
$44f2f8e18f62e3d5$export$bd39458db76002ab = $44f2f8e18f62e3d5$var$getAxisInfo;
$44f2f8e18f62e3d5$export$179695f4a9040f73 = $44f2f8e18f62e3d5$var$dataFilter;
$44f2f8e18f62e3d5$export$426eee13be6be7f = $44f2f8e18f62e3d5$var$dimValueGetter;
$44f2f8e18f62e3d5$export$18ddefb55c03640b = $44f2f8e18f62e3d5$var$numCalculate;


var $1a1595edab742f54$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $1a1595edab742f54$var$_default = $f406636b535430a7$exports.extendComponentView({
    type: "marker",
    init: function() {
        /**
     * Markline grouped by series
     * @private
     * @type {module:zrender/core/util.HashMap}
     */ this.markerGroupMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4();
    },
    render: function(markerModel, ecModel, api) {
        var markerGroupMap = this.markerGroupMap;
        markerGroupMap.each(function(item) {
            item.__keep = false;
        });
        var markerModelKey = this.type + "Model";
        ecModel.eachSeries(function(seriesModel) {
            var markerModel = seriesModel[markerModelKey];
            markerModel && this.renderSeries(seriesModel, markerModel, ecModel, api);
        }, this);
        markerGroupMap.each(function(item) {
            !item.__keep && this.group.remove(item.group);
        }, this);
    },
    renderSeries: function() {}
});
$1a1595edab742f54$exports = $1a1595edab742f54$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $373691ec0b5357a8$var$updateMarkerLayout(mpData, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    mpData.each(function(idx) {
        var itemModel = mpData.getItemModel(idx);
        var point;
        var xPx = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(itemModel.get("x"), api.getWidth());
        var yPx = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(itemModel.get("y"), api.getHeight());
        if (!isNaN(xPx) && !isNaN(yPx)) point = [
            xPx,
            yPx
        ];
        else if (seriesModel.getMarkerPosition) // Use the getMarkerPoisition
        point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
        else if (coordSys) {
            var x = mpData.get(coordSys.dimensions[0], idx);
            var y = mpData.get(coordSys.dimensions[1], idx);
            point = coordSys.dataToPoint([
                x,
                y
            ]);
        } // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
        mpData.setItemLayout(idx, point);
    });
}
var $373691ec0b5357a8$var$_default = $1a1595edab742f54$exports.extend({
    type: "markPoint",
    // updateLayout: function (markPointModel, ecModel, api) {
    //     ecModel.eachSeries(function (seriesModel) {
    //         var mpModel = seriesModel.markPointModel;
    //         if (mpModel) {
    //             updateMarkerLayout(mpModel.getData(), seriesModel, api);
    //             this.markerGroupMap.get(seriesModel.id).updateLayout(mpModel);
    //         }
    //     }, this);
    // },
    updateTransform: function(markPointModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var mpModel = seriesModel.markPointModel;
            if (mpModel) {
                $373691ec0b5357a8$var$updateMarkerLayout(mpModel.getData(), seriesModel, api);
                this.markerGroupMap.get(seriesModel.id).updateLayout(mpModel);
            }
        }, this);
    },
    renderSeries: function(seriesModel, mpModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var symbolDrawMap = this.markerGroupMap;
        var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new $e99d13e2181fb062$exports());
        var mpData = $373691ec0b5357a8$var$createList(coordSys, seriesModel, mpModel); // FIXME
        mpModel.setData(mpData);
        $373691ec0b5357a8$var$updateMarkerLayout(mpModel.getData(), seriesModel, api);
        mpData.each(function(idx) {
            var itemModel = mpData.getItemModel(idx);
            var symbol = itemModel.getShallow("symbol");
            var symbolSize = itemModel.getShallow("symbolSize");
            var symbolRotate = itemModel.getShallow("symbolRotate");
            var isFnSymbol = $ec279652dd95c27b$export$f6e2535fb5126e54(symbol);
            var isFnSymbolSize = $ec279652dd95c27b$export$f6e2535fb5126e54(symbolSize);
            var isFnSymbolRotate = $ec279652dd95c27b$export$f6e2535fb5126e54(symbolRotate);
            if (isFnSymbol || isFnSymbolSize || isFnSymbolRotate) {
                var rawIdx = mpModel.getRawValue(idx);
                var dataParams = mpModel.getDataParams(idx);
                if (isFnSymbol) symbol = symbol(rawIdx, dataParams);
                if (isFnSymbolSize) // FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
                symbolSize = symbolSize(rawIdx, dataParams);
                if (isFnSymbolRotate) symbolRotate = symbolRotate(rawIdx, dataParams);
            }
            mpData.setItemVisual(idx, {
                symbol: symbol,
                symbolSize: symbolSize,
                symbolRotate: symbolRotate,
                color: itemModel.get("itemStyle.color") || seriesData.getVisual("color")
            });
        }); // TODO Text are wrong
        symbolDraw.updateData(mpData);
        this.group.add(symbolDraw.group); // Set host model for tooltip
        // FIXME
        mpData.eachItemGraphicEl(function(el) {
            el.traverse(function(child) {
                child.dataModel = mpModel;
            });
        });
        symbolDraw.__keep = true;
        symbolDraw.group.silent = mpModel.get("silent") || seriesModel.get("silent");
    }
});
/**
 * @inner
 * @param {module:echarts/coord/*} [coordSys]
 * @param {module:echarts/model/Series} seriesModel
 * @param {module:echarts/model/Model} mpModel
 */ function $373691ec0b5357a8$var$createList(coordSys, seriesModel, mpModel) {
    var coordDimsInfos;
    if (coordSys) coordDimsInfos = $ec279652dd95c27b$export$871de8747c9eaa88(coordSys && coordSys.dimensions, function(coordDim) {
        var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
        return $ec279652dd95c27b$export$ebe90cb607ad99e({
            name: coordDim
        }, info);
    });
    else coordDimsInfos = [
        {
            name: "value",
            type: "float"
        }
    ];
    var mpData = new $f643df856475f69e$exports(coordDimsInfos, mpModel);
    var dataOpt = $ec279652dd95c27b$export$871de8747c9eaa88(mpModel.get("data"), $ec279652dd95c27b$export$c3095a23b368d1f2($44f2f8e18f62e3d5$export$3eebd2d54b98c04f, seriesModel));
    if (coordSys) dataOpt = $ec279652dd95c27b$export$3dea766d36a8935f(dataOpt, $ec279652dd95c27b$export$c3095a23b368d1f2($44f2f8e18f62e3d5$export$179695f4a9040f73, coordSys));
    mpData.initData(dataOpt, null, coordSys ? $44f2f8e18f62e3d5$export$426eee13be6be7f : function(item) {
        return item.value;
    });
    return mpData;
}
$373691ec0b5357a8$exports = $373691ec0b5357a8$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // HINT Markpoint can't be used too much
$f406636b535430a7$exports.registerPreprocessor(function(opt) {
    // Make sure markPoint component is enabled
    opt.markPoint = opt.markPoint || {};
});


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $e63386d87a8c10cc$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $e63386d87a8c10cc$var$_default = $540fef5090737dc7$exports.extend({
    type: "markLine",
    defaultOption: {
        zlevel: 0,
        z: 5,
        symbol: [
            "circle",
            "arrow"
        ],
        symbolSize: [
            8,
            16
        ],
        //symbolRotate: 0,
        precision: 2,
        tooltip: {
            trigger: "item"
        },
        label: {
            show: true,
            position: "end",
            distance: 5
        },
        lineStyle: {
            type: "dashed"
        },
        emphasis: {
            label: {
                show: true
            },
            lineStyle: {
                width: 3
            }
        },
        animationEasing: "linear"
    }
});
$e63386d87a8c10cc$exports = $e63386d87a8c10cc$var$_default;


var $c128c74cf1614e07$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $c128c74cf1614e07$var$getStackedDimension = $1712a5e8fbedbcb3$export$909db2be4938fbdf;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $c128c74cf1614e07$var$markLineTransform = function(seriesModel, coordSys, mlModel, item) {
    var data = seriesModel.getData(); // Special type markLine like 'min', 'max', 'average', 'median'
    var mlType = item.type;
    if (!$ec279652dd95c27b$export$43bee75e5e14138e(item) && (mlType === "min" || mlType === "max" || mlType === "average" || mlType === "median" // In case
     || item.xAxis != null || item.yAxis != null)) {
        var valueAxis;
        var value;
        if (item.yAxis != null || item.xAxis != null) {
            valueAxis = coordSys.getAxis(item.yAxis != null ? "y" : "x");
            value = $ec279652dd95c27b$export$8a4d17b6e8486e66(item.yAxis, item.xAxis);
        } else {
            var axisInfo = $44f2f8e18f62e3d5$export$bd39458db76002ab(item, data, coordSys, seriesModel);
            valueAxis = axisInfo.valueAxis;
            var valueDataDim = $c128c74cf1614e07$var$getStackedDimension(data, axisInfo.valueDataDim);
            value = $44f2f8e18f62e3d5$export$18ddefb55c03640b(data, valueDataDim, mlType);
        }
        var valueIndex = valueAxis.dim === "x" ? 0 : 1;
        var baseIndex = 1 - valueIndex;
        var mlFrom = $ec279652dd95c27b$export$9cd59f9826255e47(item);
        var mlTo = {};
        mlFrom.type = null;
        mlFrom.coord = [];
        mlTo.coord = [];
        mlFrom.coord[baseIndex] = -Infinity;
        mlTo.coord[baseIndex] = Infinity;
        var precision = mlModel.get("precision");
        if (precision >= 0 && typeof value === "number") value = +value.toFixed(Math.min(precision, 20));
        mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
        item = [
            mlFrom,
            mlTo,
            {
                // Extra option for tooltip and label
                type: mlType,
                valueIndex: item.valueIndex,
                // Force to use the value of calculated value.
                value: value
            }
        ];
    }
    item = [
        $44f2f8e18f62e3d5$export$3eebd2d54b98c04f(seriesModel, item[0]),
        $44f2f8e18f62e3d5$export$3eebd2d54b98c04f(seriesModel, item[1]),
        $ec279652dd95c27b$export$8b58be045bf06082({}, item[2])
    ]; // Avoid line data type is extended by from(to) data type
    item[2].type = item[2].type || ""; // Merge from option and to option into line option
    $ec279652dd95c27b$export$4950aa0f605343fb(item[2], item[0]);
    $ec279652dd95c27b$export$4950aa0f605343fb(item[2], item[1]);
    return item;
};
function $c128c74cf1614e07$var$isInifinity(val) {
    return !isNaN(val) && !isFinite(val);
} // If a markLine has one dim
function $c128c74cf1614e07$var$ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
    var otherDimIndex = 1 - dimIndex;
    var dimName = coordSys.dimensions[dimIndex];
    return $c128c74cf1614e07$var$isInifinity(fromCoord[otherDimIndex]) && $c128c74cf1614e07$var$isInifinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
}
function $c128c74cf1614e07$var$markLineFilter(coordSys, item) {
    if (coordSys.type === "cartesian2d") {
        var fromCoord = item[0].coord;
        var toCoord = item[1].coord; // In case
        // {
        //  markLine: {
        //    data: [{ yAxis: 2 }]
        //  }
        // }
        if (fromCoord && toCoord && ($c128c74cf1614e07$var$ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || $c128c74cf1614e07$var$ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
    }
    return $44f2f8e18f62e3d5$export$179695f4a9040f73(coordSys, item[0]) && $44f2f8e18f62e3d5$export$179695f4a9040f73(coordSys, item[1]);
}
function $c128c74cf1614e07$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var itemModel = data.getItemModel(idx);
    var point;
    var xPx = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(itemModel.get("x"), api.getWidth());
    var yPx = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(itemModel.get("y"), api.getHeight());
    if (!isNaN(xPx) && !isNaN(yPx)) point = [
        xPx,
        yPx
    ];
    else {
        // Chart like bar may have there own marker positioning logic
        if (seriesModel.getMarkerPosition) // Use the getMarkerPoisition
        point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
        else {
            var dims = coordSys.dimensions;
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            point = coordSys.dataToPoint([
                x,
                y
            ]);
        } // Expand line to the edge of grid if value on one axis is Inifnity
        // In case
        //  markLine: {
        //    data: [{
        //      yAxis: 2
        //      // or
        //      type: 'average'
        //    }]
        //  }
        if (coordSys.type === "cartesian2d") {
            var xAxis = coordSys.getAxis("x");
            var yAxis = coordSys.getAxis("y");
            var dims = coordSys.dimensions;
            if ($c128c74cf1614e07$var$isInifinity(data.get(dims[0], idx))) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
            else if ($c128c74cf1614e07$var$isInifinity(data.get(dims[1], idx))) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
        } // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
    }
    data.setItemLayout(idx, point);
}
var $c128c74cf1614e07$var$_default = $1a1595edab742f54$exports.extend({
    type: "markLine",
    // updateLayout: function (markLineModel, ecModel, api) {
    //     ecModel.eachSeries(function (seriesModel) {
    //         var mlModel = seriesModel.markLineModel;
    //         if (mlModel) {
    //             var mlData = mlModel.getData();
    //             var fromData = mlModel.__from;
    //             var toData = mlModel.__to;
    //             // Update visual and layout of from symbol and to symbol
    //             fromData.each(function (idx) {
    //                 updateSingleMarkerEndLayout(fromData, idx, true, seriesModel, api);
    //                 updateSingleMarkerEndLayout(toData, idx, false, seriesModel, api);
    //             });
    //             // Update layout of line
    //             mlData.each(function (idx) {
    //                 mlData.setItemLayout(idx, [
    //                     fromData.getItemLayout(idx),
    //                     toData.getItemLayout(idx)
    //                 ]);
    //             });
    //             this.markerGroupMap.get(seriesModel.id).updateLayout();
    //         }
    //     }, this);
    // },
    updateTransform: function(markLineModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var mlModel = seriesModel.markLineModel;
            if (mlModel) {
                var mlData = mlModel.getData();
                var fromData = mlModel.__from;
                var toData = mlModel.__to; // Update visual and layout of from symbol and to symbol
                fromData.each(function(idx) {
                    $c128c74cf1614e07$var$updateSingleMarkerEndLayout(fromData, idx, true, seriesModel, api);
                    $c128c74cf1614e07$var$updateSingleMarkerEndLayout(toData, idx, false, seriesModel, api);
                }); // Update layout of line
                mlData.each(function(idx) {
                    mlData.setItemLayout(idx, [
                        fromData.getItemLayout(idx),
                        toData.getItemLayout(idx)
                    ]);
                });
                this.markerGroupMap.get(seriesModel.id).updateLayout();
            }
        }, this);
    },
    renderSeries: function(seriesModel, mlModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var lineDrawMap = this.markerGroupMap;
        var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new $d4dffdc6cfcd68dc$exports());
        this.group.add(lineDraw.group);
        var mlData = $c128c74cf1614e07$var$createList(coordSys, seriesModel, mlModel);
        var fromData = mlData.from;
        var toData = mlData.to;
        var lineData = mlData.line;
        mlModel.__from = fromData;
        mlModel.__to = toData; // Line data for tooltip and formatter
        mlModel.setData(lineData);
        var symbolType = mlModel.get("symbol");
        var symbolSize = mlModel.get("symbolSize");
        if (!$ec279652dd95c27b$export$43bee75e5e14138e(symbolType)) symbolType = [
            symbolType,
            symbolType
        ];
        if (typeof symbolSize === "number") symbolSize = [
            symbolSize,
            symbolSize
        ];
         // Update visual and layout of from symbol and to symbol
        mlData.from.each(function(idx) {
            updateDataVisualAndLayout(fromData, idx, true);
            updateDataVisualAndLayout(toData, idx, false);
        }); // Update visual and layout of line
        lineData.each(function(idx) {
            var lineColor = lineData.getItemModel(idx).get("lineStyle.color");
            lineData.setItemVisual(idx, {
                color: lineColor || fromData.getItemVisual(idx, "color")
            });
            lineData.setItemLayout(idx, [
                fromData.getItemLayout(idx),
                toData.getItemLayout(idx)
            ]);
            lineData.setItemVisual(idx, {
                "fromSymbolRotate": fromData.getItemVisual(idx, "symbolRotate"),
                "fromSymbolSize": fromData.getItemVisual(idx, "symbolSize"),
                "fromSymbol": fromData.getItemVisual(idx, "symbol"),
                "toSymbolRotate": toData.getItemVisual(idx, "symbolRotate"),
                "toSymbolSize": toData.getItemVisual(idx, "symbolSize"),
                "toSymbol": toData.getItemVisual(idx, "symbol")
            });
        });
        lineDraw.updateData(lineData); // Set host model for tooltip
        // FIXME
        mlData.line.eachItemGraphicEl(function(el, idx) {
            el.traverse(function(child) {
                child.dataModel = mlModel;
            });
        });
        function updateDataVisualAndLayout(data, idx, isFrom) {
            var itemModel = data.getItemModel(idx);
            $c128c74cf1614e07$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
            data.setItemVisual(idx, {
                symbolRotate: itemModel.get("symbolRotate"),
                symbolSize: itemModel.get("symbolSize") || symbolSize[isFrom ? 0 : 1],
                symbol: itemModel.get("symbol", true) || symbolType[isFrom ? 0 : 1],
                color: itemModel.get("itemStyle.color") || seriesData.getVisual("color")
            });
        }
        lineDraw.__keep = true;
        lineDraw.group.silent = mlModel.get("silent") || seriesModel.get("silent");
    }
});
/**
 * @inner
 * @param {module:echarts/coord/*} coordSys
 * @param {module:echarts/model/Series} seriesModel
 * @param {module:echarts/model/Model} mpModel
 */ function $c128c74cf1614e07$var$createList(coordSys, seriesModel, mlModel) {
    var coordDimsInfos;
    if (coordSys) coordDimsInfos = $ec279652dd95c27b$export$871de8747c9eaa88(coordSys && coordSys.dimensions, function(coordDim) {
        var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
        return $ec279652dd95c27b$export$ebe90cb607ad99e({
            name: coordDim
        }, info);
    });
    else coordDimsInfos = [
        {
            name: "value",
            type: "float"
        }
    ];
    var fromData = new $f643df856475f69e$exports(coordDimsInfos, mlModel);
    var toData = new $f643df856475f69e$exports(coordDimsInfos, mlModel); // No dimensions
    var lineData = new $f643df856475f69e$exports([], mlModel);
    var optData = $ec279652dd95c27b$export$871de8747c9eaa88(mlModel.get("data"), $ec279652dd95c27b$export$c3095a23b368d1f2($c128c74cf1614e07$var$markLineTransform, seriesModel, coordSys, mlModel));
    if (coordSys) optData = $ec279652dd95c27b$export$3dea766d36a8935f(optData, $ec279652dd95c27b$export$c3095a23b368d1f2($c128c74cf1614e07$var$markLineFilter, coordSys));
    var dimValueGetter = coordSys ? $44f2f8e18f62e3d5$export$426eee13be6be7f : function(item) {
        return item.value;
    };
    fromData.initData($ec279652dd95c27b$export$871de8747c9eaa88(optData, function(item) {
        return item[0];
    }), null, dimValueGetter);
    toData.initData($ec279652dd95c27b$export$871de8747c9eaa88(optData, function(item) {
        return item[1];
    }), null, dimValueGetter);
    lineData.initData($ec279652dd95c27b$export$871de8747c9eaa88(optData, function(item) {
        return item[2];
    }));
    lineData.hasItemOption = true;
    return {
        from: fromData,
        to: toData,
        line: lineData
    };
}
$c128c74cf1614e07$exports = $c128c74cf1614e07$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerPreprocessor(function(opt) {
    // Make sure markLine component is enabled
    opt.markLine = opt.markLine || {};
});


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $c5fee7ec3896acd6$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $c5fee7ec3896acd6$var$_default = $540fef5090737dc7$exports.extend({
    type: "markArea",
    defaultOption: {
        zlevel: 0,
        // PENDING
        z: 1,
        tooltip: {
            trigger: "item"
        },
        // markArea should fixed on the coordinate system
        animation: false,
        label: {
            show: true,
            position: "top"
        },
        itemStyle: {
            // color and borderColor default to use color from series
            // color: 'auto'
            // borderColor: 'auto'
            borderWidth: 0
        },
        emphasis: {
            label: {
                show: true,
                position: "top"
            }
        }
    }
});
$c5fee7ec3896acd6$exports = $c5fee7ec3896acd6$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Better on polar
var $26876ac396d8fd7c$var$markAreaTransform = function(seriesModel, coordSys, maModel, item) {
    var lt = $44f2f8e18f62e3d5$export$3eebd2d54b98c04f(seriesModel, item[0]);
    var rb = $44f2f8e18f62e3d5$export$3eebd2d54b98c04f(seriesModel, item[1]);
    var retrieve = $ec279652dd95c27b$export$8a4d17b6e8486e66; // FIXME make sure lt is less than rb
    var ltCoord = lt.coord;
    var rbCoord = rb.coord;
    ltCoord[0] = retrieve(ltCoord[0], -Infinity);
    ltCoord[1] = retrieve(ltCoord[1], -Infinity);
    rbCoord[0] = retrieve(rbCoord[0], Infinity);
    rbCoord[1] = retrieve(rbCoord[1], Infinity); // Merge option into one
    var result = $ec279652dd95c27b$export$18aef43295bbe906([
        {},
        lt,
        rb
    ]);
    result.coord = [
        lt.coord,
        rb.coord
    ];
    result.x0 = lt.x;
    result.y0 = lt.y;
    result.x1 = rb.x;
    result.y1 = rb.y;
    return result;
};
function $26876ac396d8fd7c$var$isInifinity(val) {
    return !isNaN(val) && !isFinite(val);
} // If a markArea has one dim
function $26876ac396d8fd7c$var$ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
    var otherDimIndex = 1 - dimIndex;
    return $26876ac396d8fd7c$var$isInifinity(fromCoord[otherDimIndex]) && $26876ac396d8fd7c$var$isInifinity(toCoord[otherDimIndex]);
}
function $26876ac396d8fd7c$var$markAreaFilter(coordSys, item) {
    var fromCoord = item.coord[0];
    var toCoord = item.coord[1];
    if (coordSys.type === "cartesian2d") {
        // In case
        // {
        //  markArea: {
        //    data: [{ yAxis: 2 }]
        //  }
        // }
        if (fromCoord && toCoord && ($26876ac396d8fd7c$var$ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || $26876ac396d8fd7c$var$ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
    }
    return $44f2f8e18f62e3d5$export$179695f4a9040f73(coordSys, {
        coord: fromCoord,
        x: item.x0,
        y: item.y0
    }) || $44f2f8e18f62e3d5$export$179695f4a9040f73(coordSys, {
        coord: toCoord,
        x: item.x1,
        y: item.y1
    });
} // dims can be ['x0', 'y0'], ['x1', 'y1'], ['x0', 'y1'], ['x1', 'y0']
function $26876ac396d8fd7c$var$getSingleMarkerEndPoint(data, idx, dims, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var itemModel = data.getItemModel(idx);
    var point;
    var xPx = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(itemModel.get(dims[0]), api.getWidth());
    var yPx = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(itemModel.get(dims[1]), api.getHeight());
    if (!isNaN(xPx) && !isNaN(yPx)) point = [
        xPx,
        yPx
    ];
    else {
        // Chart like bar may have there own marker positioning logic
        if (seriesModel.getMarkerPosition) // Use the getMarkerPoisition
        point = seriesModel.getMarkerPosition(data.getValues(dims, idx));
        else {
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            var pt = [
                x,
                y
            ];
            coordSys.clampData && coordSys.clampData(pt, pt);
            point = coordSys.dataToPoint(pt, true);
        }
        if (coordSys.type === "cartesian2d") {
            var xAxis = coordSys.getAxis("x");
            var yAxis = coordSys.getAxis("y");
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            if ($26876ac396d8fd7c$var$isInifinity(x)) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[dims[0] === "x0" ? 0 : 1]);
            else if ($26876ac396d8fd7c$var$isInifinity(y)) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[dims[1] === "y0" ? 0 : 1]);
        } // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
    }
    return point;
}
var $26876ac396d8fd7c$var$dimPermutations = [
    [
        "x0",
        "y0"
    ],
    [
        "x1",
        "y0"
    ],
    [
        "x1",
        "y1"
    ],
    [
        "x0",
        "y1"
    ]
];
$1a1595edab742f54$exports.extend({
    type: "markArea",
    // updateLayout: function (markAreaModel, ecModel, api) {
    //     ecModel.eachSeries(function (seriesModel) {
    //         var maModel = seriesModel.markAreaModel;
    //         if (maModel) {
    //             var areaData = maModel.getData();
    //             areaData.each(function (idx) {
    //                 var points = zrUtil.map(dimPermutations, function (dim) {
    //                     return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
    //                 });
    //                 // Layout
    //                 areaData.setItemLayout(idx, points);
    //                 var el = areaData.getItemGraphicEl(idx);
    //                 el.setShape('points', points);
    //             });
    //         }
    //     }, this);
    // },
    updateTransform: function(markAreaModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var maModel = seriesModel.markAreaModel;
            if (maModel) {
                var areaData = maModel.getData();
                areaData.each(function(idx) {
                    var points = $ec279652dd95c27b$export$871de8747c9eaa88($26876ac396d8fd7c$var$dimPermutations, function(dim) {
                        return $26876ac396d8fd7c$var$getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
                    }); // Layout
                    areaData.setItemLayout(idx, points);
                    var el = areaData.getItemGraphicEl(idx);
                    el.setShape("points", points);
                });
            }
        }, this);
    },
    renderSeries: function(seriesModel, maModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var areaGroupMap = this.markerGroupMap;
        var polygonGroup = areaGroupMap.get(seriesId) || areaGroupMap.set(seriesId, {
            group: new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4()
        });
        this.group.add(polygonGroup.group);
        polygonGroup.__keep = true;
        var areaData = $26876ac396d8fd7c$var$createList(coordSys, seriesModel, maModel); // Line data for tooltip and formatter
        maModel.setData(areaData); // Update visual and layout of line
        areaData.each(function(idx) {
            // Layout
            var points = $ec279652dd95c27b$export$871de8747c9eaa88($26876ac396d8fd7c$var$dimPermutations, function(dim) {
                return $26876ac396d8fd7c$var$getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
            }); // If none of the area is inside coordSys, allClipped is set to be true
            // in layout so that label will not be displayed. See #12591
            var allClipped = true;
            $ec279652dd95c27b$export$79b2f7037acddd43($26876ac396d8fd7c$var$dimPermutations, function(dim) {
                if (!allClipped) return;
                var xValue = areaData.get(dim[0], idx);
                var yValue = areaData.get(dim[1], idx); // If is infinity, the axis should be considered not clipped
                if (($26876ac396d8fd7c$var$isInifinity(xValue) || coordSys.getAxis("x").containData(xValue)) && ($26876ac396d8fd7c$var$isInifinity(yValue) || coordSys.getAxis("y").containData(yValue))) allClipped = false;
            });
            areaData.setItemLayout(idx, {
                points: points,
                allClipped: allClipped
            }); // Visual
            areaData.setItemVisual(idx, {
                color: seriesData.getVisual("color")
            });
        });
        areaData.diff(polygonGroup.__data).add(function(idx) {
            var layout = areaData.getItemLayout(idx);
            if (!layout.allClipped) {
                var polygon = new $4b57d6b582d579b7$export$7d31b617c820d435({
                    shape: {
                        points: layout.points
                    }
                });
                areaData.setItemGraphicEl(idx, polygon);
                polygonGroup.group.add(polygon);
            }
        }).update(function(newIdx, oldIdx) {
            var polygon = polygonGroup.__data.getItemGraphicEl(oldIdx);
            var layout = areaData.getItemLayout(newIdx);
            if (!layout.allClipped) {
                if (polygon) $4b57d6b582d579b7$export$c8dce3c08436e91e(polygon, {
                    shape: {
                        points: layout.points
                    }
                }, maModel, newIdx);
                else polygon = new $4b57d6b582d579b7$export$7d31b617c820d435({
                    shape: {
                        points: layout.points
                    }
                });
                areaData.setItemGraphicEl(newIdx, polygon);
                polygonGroup.group.add(polygon);
            } else if (polygon) polygonGroup.group.remove(polygon);
        }).remove(function(idx) {
            var polygon = polygonGroup.__data.getItemGraphicEl(idx);
            polygonGroup.group.remove(polygon);
        }).execute();
        areaData.eachItemGraphicEl(function(polygon, idx) {
            var itemModel = areaData.getItemModel(idx);
            var labelModel = itemModel.getModel("label");
            var labelHoverModel = itemModel.getModel("emphasis.label");
            var color = areaData.getItemVisual(idx, "color");
            polygon.useStyle($ec279652dd95c27b$export$ebe90cb607ad99e(itemModel.getModel("itemStyle").getItemStyle(), {
                fill: $b1179c91b052e827$export$ab4754bf42583a26(color, 0.4),
                stroke: color
            }));
            polygon.hoverStyle = itemModel.getModel("emphasis.itemStyle").getItemStyle();
            $4b57d6b582d579b7$export$9a13992917966657(polygon.style, polygon.hoverStyle, labelModel, labelHoverModel, {
                labelFetcher: maModel,
                labelDataIndex: idx,
                defaultText: areaData.getName(idx) || "",
                isRectText: true,
                autoColor: color
            });
            $4b57d6b582d579b7$export$28b42df8183f218c(polygon, {});
            polygon.dataModel = maModel;
        });
        polygonGroup.__data = areaData;
        polygonGroup.group.silent = maModel.get("silent") || seriesModel.get("silent");
    }
});
/**
 * @inner
 * @param {module:echarts/coord/*} coordSys
 * @param {module:echarts/model/Series} seriesModel
 * @param {module:echarts/model/Model} mpModel
 */ function $26876ac396d8fd7c$var$createList(coordSys, seriesModel, maModel) {
    var coordDimsInfos;
    var areaData;
    var dims = [
        "x0",
        "y0",
        "x1",
        "y1"
    ];
    if (coordSys) {
        coordDimsInfos = $ec279652dd95c27b$export$871de8747c9eaa88(coordSys && coordSys.dimensions, function(coordDim) {
            var data = seriesModel.getData();
            var info = data.getDimensionInfo(data.mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
            return $ec279652dd95c27b$export$ebe90cb607ad99e({
                name: coordDim
            }, info);
        });
        areaData = new $f643df856475f69e$exports($ec279652dd95c27b$export$871de8747c9eaa88(dims, function(dim, idx) {
            return {
                name: dim,
                type: coordDimsInfos[idx % 2].type
            };
        }), maModel);
    } else {
        coordDimsInfos = [
            {
                name: "value",
                type: "float"
            }
        ];
        areaData = new $f643df856475f69e$exports(coordDimsInfos, maModel);
    }
    var optData = $ec279652dd95c27b$export$871de8747c9eaa88(maModel.get("data"), $ec279652dd95c27b$export$c3095a23b368d1f2($26876ac396d8fd7c$var$markAreaTransform, seriesModel, coordSys, maModel));
    if (coordSys) optData = $ec279652dd95c27b$export$3dea766d36a8935f(optData, $ec279652dd95c27b$export$c3095a23b368d1f2($26876ac396d8fd7c$var$markAreaFilter, coordSys));
    var dimValueGetter = coordSys ? function(item, dimName, dataIndex, dimIndex) {
        return item.coord[Math.floor(dimIndex / 2)][dimIndex % 2];
    } : function(item) {
        return item.value;
    };
    areaData.initData(optData, null, dimValueGetter);
    areaData.hasItemOption = true;
    return areaData;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $f406636b535430a7$exports.registerPreprocessor(function(opt) {
    // Make sure markArea component is enabled
    opt.markArea = opt.markArea || {};
});


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $a36382d14056343e$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $a36382d14056343e$var$isNameSpecified = $d559f43cb9041423$export$beae19a2652b3368;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $a36382d14056343e$var$langSelector = $136ae13721f5e257$exports.legend.selector;
var $a36382d14056343e$var$defaultSelectorOption = {
    all: {
        type: "all",
        title: $ec279652dd95c27b$export$9cd59f9826255e47($a36382d14056343e$var$langSelector.all)
    },
    inverse: {
        type: "inverse",
        title: $ec279652dd95c27b$export$9cd59f9826255e47($a36382d14056343e$var$langSelector.inverse)
    }
};
var $a36382d14056343e$var$LegendModel = $f406636b535430a7$exports.extendComponentModel({
    type: "legend.plain",
    dependencies: [
        "series"
    ],
    layoutMode: {
        type: "box",
        // legend.width/height are maxWidth/maxHeight actually,
        // whereas realy width/height is calculated by its content.
        // (Setting {left: 10, right: 10} does not make sense).
        // So consider the case:
        // `setOption({legend: {left: 10});`
        // then `setOption({legend: {right: 10});`
        // The previous `left` should be cleared by setting `ignoreSize`.
        ignoreSize: true
    },
    init: function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        option.selected = option.selected || {};
        this._updateSelector(option);
    },
    mergeOption: function(option) {
        $a36382d14056343e$var$LegendModel.superCall(this, "mergeOption", option);
        this._updateSelector(option);
    },
    _updateSelector: function(option) {
        var selector = option.selector;
        if (selector === true) selector = option.selector = [
            "all",
            "inverse"
        ];
        if ($ec279652dd95c27b$export$43bee75e5e14138e(selector)) $ec279652dd95c27b$export$79b2f7037acddd43(selector, function(item, index) {
            $ec279652dd95c27b$export$844ec244b1367d54(item) && (item = {
                type: item
            });
            selector[index] = $ec279652dd95c27b$export$4950aa0f605343fb(item, $a36382d14056343e$var$defaultSelectorOption[item.type]);
        });
    },
    optionUpdated: function() {
        this._updateData(this.ecModel);
        var legendData = this._data; // If selectedMode is single, try to select one
        if (legendData[0] && this.get("selectedMode") === "single") {
            var hasSelected = false; // If has any selected in option.selected
            for(var i = 0; i < legendData.length; i++){
                var name = legendData[i].get("name");
                if (this.isSelected(name)) {
                    // Force to unselect others
                    this.select(name);
                    hasSelected = true;
                    break;
                }
            } // Try select the first if selectedMode is single
            !hasSelected && this.select(legendData[0].get("name"));
        }
    },
    _updateData: function(ecModel) {
        var potentialData = [];
        var availableNames = [];
        ecModel.eachRawSeries(function(seriesModel) {
            var seriesName = seriesModel.name;
            availableNames.push(seriesName);
            var isPotential;
            if (seriesModel.legendVisualProvider) {
                var provider = seriesModel.legendVisualProvider;
                var names = provider.getAllNames();
                if (!ecModel.isSeriesFiltered(seriesModel)) availableNames = availableNames.concat(names);
                if (names.length) potentialData = potentialData.concat(names);
                else isPotential = true;
            } else isPotential = true;
            if (isPotential && $a36382d14056343e$var$isNameSpecified(seriesModel)) potentialData.push(seriesModel.name);
        });
        /**
     * @type {Array.<string>}
     * @private
     */ this._availableNames = availableNames; // If legend.data not specified in option, use availableNames as data,
        // which is convinient for user preparing option.
        var rawData = this.get("data") || potentialData;
        var legendData = $ec279652dd95c27b$export$871de8747c9eaa88(rawData, function(dataItem) {
            // Can be string or number
            if (typeof dataItem === "string" || typeof dataItem === "number") dataItem = {
                name: dataItem
            };
            return new $2b51b4bf776ec22e$exports(dataItem, this, this.ecModel);
        }, this);
        /**
     * @type {Array.<module:echarts/model/Model>}
     * @private
     */ this._data = legendData;
    },
    /**
   * @return {Array.<module:echarts/model/Model>}
   */ getData: function() {
        return this._data;
    },
    /**
   * @param {string} name
   */ select: function(name) {
        var selected = this.option.selected;
        var selectedMode = this.get("selectedMode");
        if (selectedMode === "single") {
            var data = this._data;
            $ec279652dd95c27b$export$79b2f7037acddd43(data, function(dataItem) {
                selected[dataItem.get("name")] = false;
            });
        }
        selected[name] = true;
    },
    /**
   * @param {string} name
   */ unSelect: function(name) {
        if (this.get("selectedMode") !== "single") this.option.selected[name] = false;
    },
    /**
   * @param {string} name
   */ toggleSelected: function(name) {
        var selected = this.option.selected; // Default is true
        if (!selected.hasOwnProperty(name)) selected[name] = true;
        this[selected[name] ? "unSelect" : "select"](name);
    },
    allSelect: function() {
        var data = this._data;
        var selected = this.option.selected;
        $ec279652dd95c27b$export$79b2f7037acddd43(data, function(dataItem) {
            selected[dataItem.get("name", true)] = true;
        });
    },
    inverseSelect: function() {
        var data = this._data;
        var selected = this.option.selected;
        $ec279652dd95c27b$export$79b2f7037acddd43(data, function(dataItem) {
            var name = dataItem.get("name", true); // Initially, default value is true
            if (!selected.hasOwnProperty(name)) selected[name] = true;
            selected[name] = !selected[name];
        });
    },
    /**
   * @param {string} name
   */ isSelected: function(name) {
        var selected = this.option.selected;
        return !(selected.hasOwnProperty(name) && !selected[name]) && $ec279652dd95c27b$export$305f7d4e9d4624f2(this._availableNames, name) >= 0;
    },
    getOrient: function() {
        return this.get("orient") === "vertical" ? {
            index: 1,
            name: "vertical"
        } : {
            index: 0,
            name: "horizontal"
        };
    },
    defaultOption: {
        // 一级层叠
        zlevel: 0,
        // 二级层叠
        z: 4,
        show: true,
        // 布局方式，默认为水平布局，可选为：
        // 'horizontal' | 'vertical'
        orient: "horizontal",
        left: "center",
        // right: 'center',
        top: 0,
        // bottom: null,
        // 水平对齐
        // 'auto' | 'left' | 'right'
        // 默认为 'auto', 根据 x 的位置判断是左对齐还是右对齐
        align: "auto",
        backgroundColor: "rgba(0,0,0,0)",
        // 图例边框颜色
        borderColor: "#ccc",
        borderRadius: 0,
        // 图例边框线宽，单位px，默认为0（无边框）
        borderWidth: 0,
        // 图例内边距，单位px，默认各方向内边距为5，
        // 接受数组分别设定上右下左边距，同css
        padding: 5,
        // 各个item之间的间隔，单位px，默认为10，
        // 横向布局时为水平间隔，纵向布局时为纵向间隔
        itemGap: 10,
        // the width of legend symbol
        itemWidth: 25,
        // the height of legend symbol
        itemHeight: 14,
        // the color of unselected legend symbol
        inactiveColor: "#ccc",
        // the borderColor of unselected legend symbol
        inactiveBorderColor: "#ccc",
        itemStyle: {
            // the default borderWidth of legend symbol
            borderWidth: 0
        },
        textStyle: {
            // 图例文字颜色
            color: "#333"
        },
        // formatter: '',
        // 选择模式，默认开启图例开关
        selectedMode: true,
        // 配置默认选中状态，可配合LEGEND.SELECTED事件做动态数据载入
        // selected: null,
        // 图例内容（详见legend.data，数组中每一项代表一个item
        // data: [],
        // Usage:
        // selector: [{type: 'all or inverse', title: xxx}]
        // or
        // selector: true
        // or
        // selector: ['all', 'inverse']
        selector: false,
        selectorLabel: {
            show: true,
            borderRadius: 10,
            padding: [
                3,
                5,
                3,
                5
            ],
            fontSize: 12,
            fontFamily: " sans-serif",
            color: "#666",
            borderWidth: 1,
            borderColor: "#666"
        },
        emphasis: {
            selectorLabel: {
                show: true,
                color: "#eee",
                backgroundColor: "#666"
            }
        },
        // Value can be 'start' or 'end'
        selectorPosition: "auto",
        selectorItemGap: 7,
        selectorButtonGap: 10,
        // Tooltip 相关配置
        tooltip: {
            show: false
        }
    }
});
var $a36382d14056343e$var$_default = $a36382d14056343e$var$LegendModel;
$a36382d14056343e$exports = $a36382d14056343e$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $73fea93e6ca2bf4c$var$legendSelectActionHandler(methodName, payload, ecModel) {
    var selectedMap = {};
    var isToggleSelect = methodName === "toggleSelected";
    var isSelected; // Update all legend components
    ecModel.eachComponent("legend", function(legendModel) {
        if (isToggleSelect && isSelected != null) // Force other legend has same selected status
        // Or the first is toggled to true and other are toggled to false
        // In the case one legend has some item unSelected in option. And if other legend
        // doesn't has the item, they will assume it is selected.
        legendModel[isSelected ? "select" : "unSelect"](payload.name);
        else if (methodName === "allSelect" || methodName === "inverseSelect") legendModel[methodName]();
        else {
            legendModel[methodName](payload.name);
            isSelected = legendModel.isSelected(payload.name);
        }
        var legendData = legendModel.getData();
        $ec279652dd95c27b$export$79b2f7037acddd43(legendData, function(model) {
            var name = model.get("name"); // Wrap element
            if (name === "\n" || name === "") return;
            var isItemSelected = legendModel.isSelected(name);
            if (selectedMap.hasOwnProperty(name)) // Unselected if any legend is unselected
            selectedMap[name] = selectedMap[name] && isItemSelected;
            else selectedMap[name] = isItemSelected;
        });
    }); // Return the event explicitly
    return methodName === "allSelect" || methodName === "inverseSelect" ? {
        selected: selectedMap
    } : {
        name: payload.name,
        selected: selectedMap
    };
}
/**
 * @event legendToggleSelect
 * @type {Object}
 * @property {string} type 'legendToggleSelect'
 * @property {string} [from]
 * @property {string} name Series name or data item name
 */ $f406636b535430a7$exports.registerAction("legendToggleSelect", "legendselectchanged", $ec279652dd95c27b$export$c3095a23b368d1f2($73fea93e6ca2bf4c$var$legendSelectActionHandler, "toggleSelected"));
$f406636b535430a7$exports.registerAction("legendAllSelect", "legendselectall", $ec279652dd95c27b$export$c3095a23b368d1f2($73fea93e6ca2bf4c$var$legendSelectActionHandler, "allSelect"));
$f406636b535430a7$exports.registerAction("legendInverseSelect", "legendinverseselect", $ec279652dd95c27b$export$c3095a23b368d1f2($73fea93e6ca2bf4c$var$legendSelectActionHandler, "inverseSelect"));
/**
 * @event legendSelect
 * @type {Object}
 * @property {string} type 'legendSelect'
 * @property {string} name Series name or data item name
 */ $f406636b535430a7$exports.registerAction("legendSelect", "legendselected", $ec279652dd95c27b$export$c3095a23b368d1f2($73fea93e6ca2bf4c$var$legendSelectActionHandler, "select"));
/**
 * @event legendUnSelect
 * @type {Object}
 * @property {string} type 'legendUnSelect'
 * @property {string} name Series name or data item name
 */ $f406636b535430a7$exports.registerAction("legendUnSelect", "legendunselected", $ec279652dd95c27b$export$c3095a23b368d1f2($73fea93e6ca2bf4c$var$legendSelectActionHandler, "unSelect"));


var $4eae30b803afde39$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4eae30b803afde39$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;



var $4eae30b803afde39$var$createSymbol = $804dcb9a0b78b5fe$export$af050e04da3a02e8;


var $4eae30b803afde39$var$makeBackground = $2e73e18200bfef56$export$fae23936eedfad4f;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $4eae30b803afde39$var$curry = $ec279652dd95c27b$export$c3095a23b368d1f2;
var $4eae30b803afde39$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $4eae30b803afde39$var$Group = $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4;
var $4eae30b803afde39$var$_default = $f406636b535430a7$exports.extendComponentView({
    type: "legend.plain",
    newlineDisabled: false,
    /**
   * @override
   */ init: function() {
        /**
     * @private
     * @type {module:zrender/container/Group}
     */ this.group.add(this._contentGroup = new $4eae30b803afde39$var$Group());
        /**
     * @private
     * @type {module:zrender/Element}
     */ this._backgroundEl;
        /**
     * @private
     * @type {module:zrender/container/Group}
     */ this.group.add(this._selectorGroup = new $4eae30b803afde39$var$Group());
        /**
     * If first rendering, `contentGroup.position` is [0, 0], which
     * does not make sense and may cause unexepcted animation if adopted.
     * @private
     * @type {boolean}
     */ this._isFirstRender = true;
    },
    /**
   * @protected
   */ getContentGroup: function() {
        return this._contentGroup;
    },
    /**
   * @protected
   */ getSelectorGroup: function() {
        return this._selectorGroup;
    },
    /**
   * @override
   */ render: function(legendModel, ecModel, api) {
        var isFirstRender = this._isFirstRender;
        this._isFirstRender = false;
        this.resetInner();
        if (!legendModel.get("show", true)) return;
        var itemAlign = legendModel.get("align");
        var orient = legendModel.get("orient");
        if (!itemAlign || itemAlign === "auto") itemAlign = legendModel.get("left") === "right" && orient === "vertical" ? "right" : "left";
        var selector = legendModel.get("selector", true);
        var selectorPosition = legendModel.get("selectorPosition", true);
        if (selector && (!selectorPosition || selectorPosition === "auto")) selectorPosition = orient === "horizontal" ? "end" : "start";
        this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition); // Perform layout.
        var positionInfo = legendModel.getBoxLayoutParams();
        var viewportSize = {
            width: api.getWidth(),
            height: api.getHeight()
        };
        var padding = legendModel.get("padding");
        var maxSize = $ab0c9086dd6c5b39$export$4517a5ca639a7293(positionInfo, viewportSize, padding);
        var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition); // Place mainGroup, based on the calculated `mainRect`.
        var layoutRect = $ab0c9086dd6c5b39$export$4517a5ca639a7293($ec279652dd95c27b$export$ebe90cb607ad99e({
            width: mainRect.width,
            height: mainRect.height
        }, positionInfo), viewportSize, padding);
        this.group.attr("position", [
            layoutRect.x - mainRect.x,
            layoutRect.y - mainRect.y
        ]); // Render background after group is layout.
        this.group.add(this._backgroundEl = $4eae30b803afde39$var$makeBackground(mainRect, legendModel));
    },
    /**
   * @protected
   */ resetInner: function() {
        this.getContentGroup().removeAll();
        this._backgroundEl && this.group.remove(this._backgroundEl);
        this.getSelectorGroup().removeAll();
    },
    /**
   * @protected
   */ renderInner: function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var legendDrawnMap = $ec279652dd95c27b$export$55f8aa7ef875b0a4();
        var selectMode = legendModel.get("selectedMode");
        var excludeSeriesId = [];
        ecModel.eachRawSeries(function(seriesModel) {
            !seriesModel.get("legendHoverLink") && excludeSeriesId.push(seriesModel.id);
        });
        $4eae30b803afde39$var$each(legendModel.getData(), function(itemModel, dataIndex) {
            var name = itemModel.get("name"); // Use empty string or \n as a newline string
            if (!this.newlineDisabled && (name === "" || name === "\n")) {
                contentGroup.add(new $4eae30b803afde39$var$Group({
                    newline: true
                }));
                return;
            } // Representitive series.
            var seriesModel = ecModel.getSeriesByName(name)[0];
            if (legendDrawnMap.get(name)) // Have been drawed
            return;
             // Legend to control series.
            if (seriesModel) {
                var data = seriesModel.getData();
                var color = data.getVisual("color");
                var borderColor = data.getVisual("borderColor"); // If color is a callback function
                if (typeof color === "function") // Use the first data
                color = color(seriesModel.getDataParams(0));
                 // If borderColor is a callback function
                if (typeof borderColor === "function") // Use the first data
                borderColor = borderColor(seriesModel.getDataParams(0));
                 // Using rect symbol defaultly
                var legendSymbolType = data.getVisual("legendSymbol") || "roundRect";
                var symbolType = data.getVisual("symbol");
                var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, borderColor, selectMode);
                itemGroup.on("click", $4eae30b803afde39$var$curry($4eae30b803afde39$var$dispatchSelectAction, name, null, api, excludeSeriesId)).on("mouseover", $4eae30b803afde39$var$curry($4eae30b803afde39$var$dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on("mouseout", $4eae30b803afde39$var$curry($4eae30b803afde39$var$dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
                legendDrawnMap.set(name, true);
            } else // Legend to control data. In pie and funnel.
            ecModel.eachRawSeries(function(seriesModel) {
                // In case multiple series has same data name
                if (legendDrawnMap.get(name)) return;
                if (seriesModel.legendVisualProvider) {
                    var provider = seriesModel.legendVisualProvider;
                    if (!provider.containName(name)) return;
                    var idx = provider.indexOfName(name);
                    var color = provider.getItemVisual(idx, "color");
                    var borderColor = provider.getItemVisual(idx, "borderColor");
                    var legendSymbolType = "roundRect";
                    var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, null, itemAlign, color, borderColor, selectMode); // FIXME: consider different series has items with the same name.
                    itemGroup.on("click", $4eae30b803afde39$var$curry($4eae30b803afde39$var$dispatchSelectAction, null, name, api, excludeSeriesId)) // Should not specify the series name, consider legend controls
                    // more than one pie series.
                    .on("mouseover", $4eae30b803afde39$var$curry($4eae30b803afde39$var$dispatchHighlightAction, null, name, api, excludeSeriesId)).on("mouseout", $4eae30b803afde39$var$curry($4eae30b803afde39$var$dispatchDownplayAction, null, name, api, excludeSeriesId));
                    legendDrawnMap.set(name, true);
                }
            }, this);
        }, this);
        if (selector) this._createSelector(selector, legendModel, api, orient, selectorPosition);
    },
    _createSelector: function(selector, legendModel, api, orient, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        $4eae30b803afde39$var$each(selector, function(selectorItem) {
            createSelectorButton(selectorItem);
        });
        function createSelectorButton(selectorItem) {
            var type = selectorItem.type;
            var labelText = new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
                style: {
                    x: 0,
                    y: 0,
                    align: "center",
                    verticalAlign: "middle"
                },
                onclick: function() {
                    api.dispatchAction({
                        type: type === "all" ? "legendAllSelect" : "legendInverseSelect"
                    });
                }
            });
            selectorGroup.add(labelText);
            var labelModel = legendModel.getModel("selectorLabel");
            var emphasisLabelModel = legendModel.getModel("emphasis.selectorLabel");
            $4b57d6b582d579b7$export$9a13992917966657(labelText.style, labelText.hoverStyle = {}, labelModel, emphasisLabelModel, {
                defaultText: selectorItem.title,
                isRectText: false
            });
            $4b57d6b582d579b7$export$28b42df8183f218c(labelText);
        }
    },
    _createItem: function(name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, borderColor, selectMode) {
        var itemWidth = legendModel.get("itemWidth");
        var itemHeight = legendModel.get("itemHeight");
        var inactiveColor = legendModel.get("inactiveColor");
        var inactiveBorderColor = legendModel.get("inactiveBorderColor");
        var symbolKeepAspect = legendModel.get("symbolKeepAspect");
        var legendModelItemStyle = legendModel.getModel("itemStyle");
        var isSelected = legendModel.isSelected(name);
        var itemGroup = new $4eae30b803afde39$var$Group();
        var textStyleModel = itemModel.getModel("textStyle");
        var itemIcon = itemModel.get("icon");
        var tooltipModel = itemModel.getModel("tooltip");
        var legendGlobalTooltipModel = tooltipModel.parentModel; // Use user given icon first
        legendSymbolType = itemIcon || legendSymbolType;
        var legendSymbol = $4eae30b803afde39$var$createSymbol(legendSymbolType, 0, 0, itemWidth, itemHeight, isSelected ? color : inactiveColor, symbolKeepAspect == null ? true : symbolKeepAspect);
        itemGroup.add($4eae30b803afde39$var$setSymbolStyle(legendSymbol, legendSymbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected)); // Compose symbols
        // PENDING
        if (!itemIcon && symbolType // At least show one symbol, can't be all none
         && (symbolType !== legendSymbolType || symbolType === "none")) {
            var size = itemHeight * 0.8;
            if (symbolType === "none") symbolType = "circle";
            var legendSymbolCenter = $4eae30b803afde39$var$createSymbol(symbolType, (itemWidth - size) / 2, (itemHeight - size) / 2, size, size, isSelected ? color : inactiveColor, symbolKeepAspect == null ? true : symbolKeepAspect); // Put symbol in the center
            itemGroup.add($4eae30b803afde39$var$setSymbolStyle(legendSymbolCenter, symbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected));
        }
        var textX = itemAlign === "left" ? itemWidth + 5 : -5;
        var textAlign = itemAlign;
        var formatter = legendModel.get("formatter");
        var content = name;
        if (typeof formatter === "string" && formatter) content = formatter.replace("{name}", name != null ? name : "");
        else if (typeof formatter === "function") content = formatter(name);
        itemGroup.add(new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
            style: $4b57d6b582d579b7$export$6605af501964d89a({}, textStyleModel, {
                text: content,
                x: textX,
                y: itemHeight / 2,
                textFill: isSelected ? textStyleModel.getTextColor() : inactiveColor,
                textAlign: textAlign,
                textVerticalAlign: "middle"
            })
        })); // Add a invisible rect to increase the area of mouse hover
        var hitRect = new $4b57d6b582d579b7$export$c79fc6492f3af13d({
            shape: itemGroup.getBoundingRect(),
            invisible: true,
            tooltip: tooltipModel.get("show") ? $ec279652dd95c27b$export$8b58be045bf06082({
                content: name,
                // Defaul formatter
                formatter: legendGlobalTooltipModel.get("formatter", true) || function() {
                    return name;
                },
                formatterParams: {
                    componentType: "legend",
                    legendIndex: legendModel.componentIndex,
                    name: name,
                    $vars: [
                        "name"
                    ]
                }
            }, tooltipModel.option) : null
        });
        itemGroup.add(hitRect);
        itemGroup.eachChild(function(child) {
            child.silent = true;
        });
        hitRect.silent = !selectMode;
        this.getContentGroup().add(itemGroup);
        $4b57d6b582d579b7$export$28b42df8183f218c(itemGroup);
        itemGroup.__legendDataIndex = dataIndex;
        return itemGroup;
    },
    /**
   * @protected
   */ layoutInner: function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var selectorGroup = this.getSelectorGroup(); // Place items in contentGroup.
        $ab0c9086dd6c5b39$export$827f4ee28efc37(legendModel.get("orient"), contentGroup, legendModel.get("itemGap"), maxSize.width, maxSize.height);
        var contentRect = contentGroup.getBoundingRect();
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        if (selector) {
            // Place buttons in selectorGroup
            $ab0c9086dd6c5b39$export$827f4ee28efc37("horizontal", selectorGroup, legendModel.get("selectorItemGap", true));
            var selectorRect = selectorGroup.getBoundingRect();
            var selectorPos = [
                -selectorRect.x,
                -selectorRect.y
            ];
            var selectorButtonGap = legendModel.get("selectorButtonGap", true);
            var orientIdx = legendModel.getOrient().index;
            var wh = orientIdx === 0 ? "width" : "height";
            var hw = orientIdx === 0 ? "height" : "width";
            var yx = orientIdx === 0 ? "y" : "x";
            if (selectorPosition === "end") selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
            else contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
             //Always align selector to content as 'middle'
            selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
            selectorGroup.attr("position", selectorPos);
            contentGroup.attr("position", contentPos);
            var mainRect = {
                x: 0,
                y: 0
            };
            mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
            mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
            return mainRect;
        } else {
            contentGroup.attr("position", contentPos);
            return this.group.getBoundingRect();
        }
    },
    /**
   * @protected
   */ remove: function() {
        this.getContentGroup().removeAll();
        this._isFirstRender = true;
    }
});
function $4eae30b803afde39$var$setSymbolStyle(symbol, symbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected) {
    var itemStyle;
    if (symbolType !== "line" && symbolType.indexOf("empty") < 0) {
        itemStyle = legendModelItemStyle.getItemStyle();
        symbol.style.stroke = borderColor;
        if (!isSelected) itemStyle.stroke = inactiveBorderColor;
    } else itemStyle = legendModelItemStyle.getItemStyle([
        "borderWidth",
        "borderColor"
    ]);
    return symbol.setStyle(itemStyle);
}
function $4eae30b803afde39$var$dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
    // downplay before unselect
    $4eae30b803afde39$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
    api.dispatchAction({
        type: "legendToggleSelect",
        name: seriesName != null ? seriesName : dataName
    }); // highlight after select
    $4eae30b803afde39$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
}
function $4eae30b803afde39$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
    // If element hover will move to a hoverLayer.
    var el = api.getZr().storage.getDisplayList()[0];
    if (!(el && el.useHoverLayer)) api.dispatchAction({
        type: "highlight",
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
function $4eae30b803afde39$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
    // If element hover will move to a hoverLayer.
    var el = api.getZr().storage.getDisplayList()[0];
    if (!(el && el.useHoverLayer)) api.dispatchAction({
        type: "downplay",
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
$4eae30b803afde39$exports = $4eae30b803afde39$var$_default;


var $9e62e3f417f76c10$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $9e62e3f417f76c10$var$_default(ecModel) {
    var legendModels = ecModel.findComponents({
        mainType: "legend"
    });
    if (legendModels && legendModels.length) ecModel.filterSeries(function(series) {
        // If in any legend component the status is not selected.
        // Because in legend series is assumed selected when it is not in the legend data.
        for(var i = 0; i < legendModels.length; i++){
            if (!legendModels[i].isSelected(series.name)) return false;
        }
        return true;
    });
}
$9e62e3f417f76c10$exports = $9e62e3f417f76c10$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Do not contain scrollable legend, for sake of file size.
// Series Filter
$f406636b535430a7$exports.registerProcessor($f406636b535430a7$exports.PRIORITY.PROCESSOR.SERIES_FILTER, $9e62e3f417f76c10$exports);
$3b9c2389e45dfb7d$exports.registerSubTypeDefaulter("legend", function() {
    // Default 'plain' when no type specified.
    return "plain";
});


var $20528b696b585d49$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $20528b696b585d49$var$mergeLayoutParam = $ab0c9086dd6c5b39$export$1754cb91f16ca028;
var $20528b696b585d49$var$getLayoutParams = $ab0c9086dd6c5b39$export$4b0d20af19c9875e;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $20528b696b585d49$var$ScrollableLegendModel = $a36382d14056343e$exports.extend({
    type: "legend.scroll",
    /**
   * @param {number} scrollDataIndex
   */ setScrollDataIndex: function(scrollDataIndex) {
        this.option.scrollDataIndex = scrollDataIndex;
    },
    defaultOption: {
        scrollDataIndex: 0,
        pageButtonItemGap: 5,
        pageButtonGap: null,
        pageButtonPosition: "end",
        // 'start' or 'end'
        pageFormatter: "{current}/{total}",
        // If null/undefined, do not show page.
        pageIcons: {
            horizontal: [
                "M0,0L12,-10L12,10z",
                "M0,0L-12,-10L-12,10z"
            ],
            vertical: [
                "M0,0L20,0L10,-20z",
                "M0,0L20,0L10,20z"
            ]
        },
        pageIconColor: "#2f4554",
        pageIconInactiveColor: "#aaa",
        pageIconSize: 15,
        // Can be [10, 3], which represents [width, height]
        pageTextStyle: {
            color: "#333"
        },
        animationDurationUpdate: 800
    },
    /**
   * @override
   */ init: function(option, parentModel, ecModel, extraOpt) {
        var inputPositionParams = $20528b696b585d49$var$getLayoutParams(option);
        $20528b696b585d49$var$ScrollableLegendModel.superCall(this, "init", option, parentModel, ecModel, extraOpt);
        $20528b696b585d49$var$mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
    },
    /**
   * @override
   */ mergeOption: function(option, extraOpt) {
        $20528b696b585d49$var$ScrollableLegendModel.superCall(this, "mergeOption", option, extraOpt);
        $20528b696b585d49$var$mergeAndNormalizeLayoutParams(this, this.option, option);
    }
}); // Do not `ignoreSize` to enable setting {left: 10, right: 10}.
function $20528b696b585d49$var$mergeAndNormalizeLayoutParams(legendModel, target, raw) {
    var orient = legendModel.getOrient();
    var ignoreSize = [
        1,
        1
    ];
    ignoreSize[orient.index] = 0;
    $20528b696b585d49$var$mergeLayoutParam(target, raw, {
        type: "box",
        ignoreSize: ignoreSize
    });
}
var $20528b696b585d49$var$_default = $20528b696b585d49$var$ScrollableLegendModel;
$20528b696b585d49$exports = $20528b696b585d49$var$_default;


var $4fef91490aef69c4$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Separate legend and scrollable legend to reduce package size.
 */ var $4fef91490aef69c4$var$Group = $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4;
var $4fef91490aef69c4$var$WH = [
    "width",
    "height"
];
var $4fef91490aef69c4$var$XY = [
    "x",
    "y"
];
var $4fef91490aef69c4$var$ScrollableLegendView = $4eae30b803afde39$exports.extend({
    type: "legend.scroll",
    newlineDisabled: true,
    init: function() {
        $4fef91490aef69c4$var$ScrollableLegendView.superCall(this, "init");
        /**
     * @private
     * @type {number} For `scroll`.
     */ this._currentIndex = 0;
        /**
     * @private
     * @type {module:zrender/container/Group}
     */ this.group.add(this._containerGroup = new $4fef91490aef69c4$var$Group());
        this._containerGroup.add(this.getContentGroup());
        /**
     * @private
     * @type {module:zrender/container/Group}
     */ this.group.add(this._controllerGroup = new $4fef91490aef69c4$var$Group());
        /**
     *
     * @private
     */ this._showController;
    },
    /**
   * @override
   */ resetInner: function() {
        $4fef91490aef69c4$var$ScrollableLegendView.superCall(this, "resetInner");
        this._controllerGroup.removeAll();
        this._containerGroup.removeClipPath();
        this._containerGroup.__rectSize = null;
    },
    /**
   * @override
   */ renderInner: function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var me = this; // Render content items.
        $4fef91490aef69c4$var$ScrollableLegendView.superCall(this, "renderInner", itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        var controllerGroup = this._controllerGroup; // FIXME: support be 'auto' adapt to size number text length,
        // e.g., '3/12345' should not overlap with the control arrow button.
        var pageIconSize = legendModel.get("pageIconSize", true);
        if (!$ec279652dd95c27b$export$43bee75e5e14138e(pageIconSize)) pageIconSize = [
            pageIconSize,
            pageIconSize
        ];
        createPageButton("pagePrev", 0);
        var pageTextStyleModel = legendModel.getModel("pageTextStyle");
        controllerGroup.add(new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
            name: "pageText",
            style: {
                textFill: pageTextStyleModel.getTextColor(),
                font: pageTextStyleModel.getFont(),
                textVerticalAlign: "middle",
                textAlign: "center"
            },
            silent: true
        }));
        createPageButton("pageNext", 1);
        function createPageButton(name, iconIdx) {
            var pageDataIndexName = name + "DataIndex";
            var icon = $4b57d6b582d579b7$export$274edc73af1ae9c8(legendModel.get("pageIcons", true)[legendModel.getOrient().name][iconIdx], {
                // Buttons will be created in each render, so we do not need
                // to worry about avoiding using legendModel kept in scope.
                onclick: $ec279652dd95c27b$export$2385a24977818dd0(me._pageGo, me, pageDataIndexName, legendModel, api)
            }, {
                x: -pageIconSize[0] / 2,
                y: -pageIconSize[1] / 2,
                width: pageIconSize[0],
                height: pageIconSize[1]
            });
            icon.name = name;
            controllerGroup.add(icon);
        }
    },
    /**
   * @override
   */ layoutInner: function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        var orientIdx = legendModel.getOrient().index;
        var wh = $4fef91490aef69c4$var$WH[orientIdx];
        var xy = $4fef91490aef69c4$var$XY[orientIdx];
        var hw = $4fef91490aef69c4$var$WH[1 - orientIdx];
        var yx = $4fef91490aef69c4$var$XY[1 - orientIdx];
        selector && $ab0c9086dd6c5b39$export$827f4ee28efc37("horizontal", selectorGroup, legendModel.get("selectorItemGap", true));
        var selectorButtonGap = legendModel.get("selectorButtonGap", true);
        var selectorRect = selectorGroup.getBoundingRect();
        var selectorPos = [
            -selectorRect.x,
            -selectorRect.y
        ];
        var processMaxSize = $ec279652dd95c27b$export$9cd59f9826255e47(maxSize);
        selector && (processMaxSize[wh] = maxSize[wh] - selectorRect[wh] - selectorButtonGap);
        var mainRect = this._layoutContentAndController(legendModel, isFirstRender, processMaxSize, orientIdx, wh, hw, yx);
        if (selector) {
            if (selectorPosition === "end") selectorPos[orientIdx] += mainRect[wh] + selectorButtonGap;
            else {
                var offset = selectorRect[wh] + selectorButtonGap;
                selectorPos[orientIdx] -= offset;
                mainRect[xy] -= offset;
            }
            mainRect[wh] += selectorRect[wh] + selectorButtonGap;
            selectorPos[1 - orientIdx] += mainRect[yx] + mainRect[hw] / 2 - selectorRect[hw] / 2;
            mainRect[hw] = Math.max(mainRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(mainRect[yx], selectorRect[yx] + selectorPos[1 - orientIdx]);
            selectorGroup.attr("position", selectorPos);
        }
        return mainRect;
    },
    _layoutContentAndController: function(legendModel, isFirstRender, maxSize, orientIdx, wh, hw, yx) {
        var contentGroup = this.getContentGroup();
        var containerGroup = this._containerGroup;
        var controllerGroup = this._controllerGroup; // Place items in contentGroup.
        $ab0c9086dd6c5b39$export$827f4ee28efc37(legendModel.get("orient"), contentGroup, legendModel.get("itemGap"), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
        $ab0c9086dd6c5b39$export$827f4ee28efc37("horizontal", controllerGroup, legendModel.get("pageButtonItemGap", true));
        var contentRect = contentGroup.getBoundingRect();
        var controllerRect = controllerGroup.getBoundingRect();
        var showController = this._showController = contentRect[wh] > maxSize[wh];
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ]; // Remain contentPos when scroll animation perfroming.
        // If first rendering, `contentGroup.position` is [0, 0], which
        // does not make sense and may cause unexepcted animation if adopted.
        if (!isFirstRender) contentPos[orientIdx] = contentGroup.position[orientIdx];
         // Layout container group based on 0.
        var containerPos = [
            0,
            0
        ];
        var controllerPos = [
            -controllerRect.x,
            -controllerRect.y
        ];
        var pageButtonGap = $ec279652dd95c27b$export$995e01f2f5c9d030(legendModel.get("pageButtonGap", true), legendModel.get("itemGap", true)); // Place containerGroup and controllerGroup and contentGroup.
        if (showController) {
            var pageButtonPosition = legendModel.get("pageButtonPosition", true); // controller is on the right / bottom.
            if (pageButtonPosition === "end") controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
            else containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
        } // Always align controller to content as 'middle'.
        controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
        contentGroup.attr("position", contentPos);
        containerGroup.attr("position", containerPos);
        controllerGroup.attr("position", controllerPos); // Calculate `mainRect` and set `clipPath`.
        // mainRect should not be calculated by `this.group.getBoundingRect()`
        // for sake of the overflow.
        var mainRect = {
            x: 0,
            y: 0
        }; // Consider content may be overflow (should be clipped).
        mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
        mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]); // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.
        mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
        containerGroup.__rectSize = maxSize[wh];
        if (showController) {
            var clipShape = {
                x: 0,
                y: 0
            };
            clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
            clipShape[hw] = mainRect[hw];
            containerGroup.setClipPath(new $4b57d6b582d579b7$export$c79fc6492f3af13d({
                shape: clipShape
            })); // Consider content may be larger than container, container rect
            // can not be obtained from `containerGroup.getBoundingRect()`.
            containerGroup.__rectSize = clipShape[wh];
        } else // Do not remove or ignore controller. Keep them set as placeholders.
        controllerGroup.eachChild(function(child) {
            child.attr({
                invisible: true,
                silent: true
            });
        });
         // Content translate animation.
        var pageInfo = this._getPageInfo(legendModel);
        pageInfo.pageIndex != null && $4b57d6b582d579b7$export$c8dce3c08436e91e(contentGroup, {
            position: pageInfo.contentPosition
        }, // updated immediately without animation, otherwise causes weird effect.
        showController ? legendModel : false);
        this._updatePageInfoView(legendModel, pageInfo);
        return mainRect;
    },
    _pageGo: function(to, legendModel, api) {
        var scrollDataIndex = this._getPageInfo(legendModel)[to];
        scrollDataIndex != null && api.dispatchAction({
            type: "legendScroll",
            scrollDataIndex: scrollDataIndex,
            legendId: legendModel.id
        });
    },
    _updatePageInfoView: function(legendModel, pageInfo) {
        var controllerGroup = this._controllerGroup;
        $ec279652dd95c27b$export$79b2f7037acddd43([
            "pagePrev",
            "pageNext"
        ], function(name) {
            var canJump = pageInfo[name + "DataIndex"] != null;
            var icon = controllerGroup.childOfName(name);
            if (icon) {
                icon.setStyle("fill", canJump ? legendModel.get("pageIconColor", true) : legendModel.get("pageIconInactiveColor", true));
                icon.cursor = canJump ? "pointer" : "default";
            }
        });
        var pageText = controllerGroup.childOfName("pageText");
        var pageFormatter = legendModel.get("pageFormatter");
        var pageIndex = pageInfo.pageIndex;
        var current = pageIndex != null ? pageIndex + 1 : 0;
        var total = pageInfo.pageCount;
        pageText && pageFormatter && pageText.setStyle("text", $ec279652dd95c27b$export$844ec244b1367d54(pageFormatter) ? pageFormatter.replace("{current}", current).replace("{total}", total) : pageFormatter({
            current: current,
            total: total
        }));
    },
    /**
   * @param {module:echarts/model/Model} legendModel
   * @return {Object} {
   *  contentPosition: Array.<number>, null when data item not found.
   *  pageIndex: number, null when data item not found.
   *  pageCount: number, always be a number, can be 0.
   *  pagePrevDataIndex: number, null when no previous page.
   *  pageNextDataIndex: number, null when no next page.
   * }
   */ _getPageInfo: function(legendModel) {
        var scrollDataIndex = legendModel.get("scrollDataIndex", true);
        var contentGroup = this.getContentGroup();
        var containerRectSize = this._containerGroup.__rectSize;
        var orientIdx = legendModel.getOrient().index;
        var wh = $4fef91490aef69c4$var$WH[orientIdx];
        var xy = $4fef91490aef69c4$var$XY[orientIdx];
        var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);
        var children = contentGroup.children();
        var targetItem = children[targetItemIndex];
        var itemCount = children.length;
        var pCount = !itemCount ? 0 : 1;
        var result = {
            contentPosition: contentGroup.position.slice(),
            pageCount: pCount,
            pageIndex: pCount - 1,
            pagePrevDataIndex: null,
            pageNextDataIndex: null
        };
        if (!targetItem) return result;
        var targetItemInfo = getItemInfo(targetItem);
        result.contentPosition[orientIdx] = -targetItemInfo.s; // Strategy:
        // (1) Always align based on the left/top most item.
        // (2) It is user-friendly that the last item shown in the
        // current window is shown at the begining of next window.
        // Otherwise if half of the last item is cut by the window,
        // it will have no chance to display entirely.
        // (3) Consider that item size probably be different, we
        // have calculate pageIndex by size rather than item index,
        // and we can not get page index directly by division.
        // (4) The window is to narrow to contain more than
        // one item, we should make sure that the page can be fliped.
        for(var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i){
            currItemInfo = getItemInfo(children[i]);
            if (!currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || // If the current item does not intersect with the window, the new page
            // can be started at the current item or the last item.
            currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
                if (winEndItemInfo.i > winStartItemInfo.i) winStartItemInfo = winEndItemInfo;
                else // e.g., when page size is smaller than item size.
                winStartItemInfo = currItemInfo;
                if (winStartItemInfo) {
                    if (result.pageNextDataIndex == null) result.pageNextDataIndex = winStartItemInfo.i;
                    ++result.pageCount;
                }
            }
            winEndItemInfo = currItemInfo;
        }
        for(var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i){
            currItemInfo = getItemInfo(children[i]);
            if (// from the current item, a page can be settled.
            (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && // e.g., when page size is smaller than item size.
            winStartItemInfo.i < winEndItemInfo.i) {
                winEndItemInfo = winStartItemInfo;
                if (result.pagePrevDataIndex == null) result.pagePrevDataIndex = winStartItemInfo.i;
                ++result.pageCount;
                ++result.pageIndex;
            }
            winStartItemInfo = currItemInfo;
        }
        return result;
        function getItemInfo(el) {
            if (el) {
                var itemRect = el.getBoundingRect();
                var start = itemRect[xy] + el.position[orientIdx];
                return {
                    s: start,
                    e: start + itemRect[wh],
                    i: el.__legendDataIndex
                };
            }
        }
        function intersect(itemInfo, winStart) {
            return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
        }
    },
    _findTargetItemIndex: function(targetDataIndex) {
        if (!this._showController) return 0;
        var index;
        var contentGroup = this.getContentGroup();
        var defaultIndex;
        contentGroup.eachChild(function(child, idx) {
            var legendDataIdx = child.__legendDataIndex; // FIXME
            // If the given targetDataIndex (from model) is illegal,
            // we use defaultIndex. But the index on the legend model and
            // action payload is still illegal. That case will not be
            // changed until some scenario requires.
            if (defaultIndex == null && legendDataIdx != null) defaultIndex = idx;
            if (legendDataIdx === targetDataIndex) index = idx;
        });
        return index != null ? index : defaultIndex;
    }
});
var $4fef91490aef69c4$var$_default = $4fef91490aef69c4$var$ScrollableLegendView;
$4fef91490aef69c4$exports = $4fef91490aef69c4$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @event legendScroll
 * @type {Object}
 * @property {string} type 'legendScroll'
 * @property {string} scrollDataIndex
 */ $f406636b535430a7$exports.registerAction("legendScroll", "legendscroll", function(payload, ecModel) {
    var scrollDataIndex = payload.scrollDataIndex;
    scrollDataIndex != null && ecModel.eachComponent({
        mainType: "legend",
        subType: "scroll",
        query: payload
    }, function(legendModel) {
        legendModel.setScrollDataIndex(scrollDataIndex);
    });
});





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $091b35673bb5394e$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $091b35673bb5394e$var$SliderZoomModel = $49e2222a92c1e4ca$exports.extend({
    type: "dataZoom.slider",
    layoutMode: "box",
    /**
   * @protected
   */ defaultOption: {
        show: true,
        // ph => placeholder. Using placehoder here because
        // deault value can only be drived in view stage.
        right: "ph",
        // Default align to grid rect.
        top: "ph",
        // Default align to grid rect.
        width: "ph",
        // Default align to grid rect.
        height: "ph",
        // Default align to grid rect.
        left: null,
        // Default align to grid rect.
        bottom: null,
        // Default align to grid rect.
        backgroundColor: "rgba(47,69,84,0)",
        // Background of slider zoom component.
        // dataBackgroundColor: '#ddd',         // Background coor of data shadow and border of box,
        // highest priority, remain for compatibility of
        // previous version, but not recommended any more.
        dataBackground: {
            lineStyle: {
                color: "#2f4554",
                width: 0.5,
                opacity: 0.3
            },
            areaStyle: {
                color: "rgba(47,69,84,0.3)",
                opacity: 0.3
            }
        },
        borderColor: "#ddd",
        // border color of the box. For compatibility,
        // if dataBackgroundColor is set, borderColor
        // is ignored.
        fillerColor: "rgba(167,183,204,0.4)",
        // Color of selected area.
        // handleColor: 'rgba(89,170,216,0.95)',     // Color of handle.
        // handleIcon: 'path://M4.9,17.8c0-1.4,4.5-10.5,5.5-12.4c0-0.1,0.6-1.1,0.9-1.1c0.4,0,0.9,1,0.9,1.1c1.1,2.2,5.4,11,5.4,12.4v17.8c0,1.5-0.6,2.1-1.3,2.1H6.1c-0.7,0-1.3-0.6-1.3-2.1V17.8z',
        /* eslint-disable */ handleIcon: "M8.2,13.6V3.9H6.3v9.7H3.1v14.9h3.3v9.7h1.8v-9.7h3.3V13.6H8.2z M9.7,24.4H4.8v-1.4h4.9V24.4z M9.7,19.1H4.8v-1.4h4.9V19.1z",
        /* eslint-enable */ // Percent of the slider height
        handleSize: "100%",
        handleStyle: {
            color: "#a7b7cc"
        },
        labelPrecision: null,
        labelFormatter: null,
        showDetail: true,
        showDataShadow: "auto",
        // Default auto decision.
        realtime: true,
        zoomLock: false,
        // Whether disable zoom.
        textStyle: {
            color: "#333"
        }
    }
});
var $091b35673bb5394e$var$_default = $091b35673bb5394e$var$SliderZoomModel;
$091b35673bb5394e$exports = $091b35673bb5394e$var$_default;


var $9965fdbe3c6f53f9$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $9965fdbe3c6f53f9$var$Rect = $4b57d6b582d579b7$export$c79fc6492f3af13d;
var $9965fdbe3c6f53f9$var$linearMap = $2d742dbe7f960d8c$export$d3f68fbaa670562;
var $9965fdbe3c6f53f9$var$asc = $2d742dbe7f960d8c$export$debe6e778e0a6d32;
var $9965fdbe3c6f53f9$var$bind = $ec279652dd95c27b$export$2385a24977818dd0;
var $9965fdbe3c6f53f9$var$each = $ec279652dd95c27b$export$79b2f7037acddd43; // Constants
var $9965fdbe3c6f53f9$var$DEFAULT_LOCATION_EDGE_GAP = 7;
var $9965fdbe3c6f53f9$var$DEFAULT_FRAME_BORDER_WIDTH = 1;
var $9965fdbe3c6f53f9$var$DEFAULT_FILLER_SIZE = 30;
var $9965fdbe3c6f53f9$var$HORIZONTAL = "horizontal";
var $9965fdbe3c6f53f9$var$VERTICAL = "vertical";
var $9965fdbe3c6f53f9$var$LABEL_GAP = 5;
var $9965fdbe3c6f53f9$var$SHOW_DATA_SHADOW_SERIES_TYPE = [
    "line",
    "bar",
    "candlestick",
    "scatter"
];
var $9965fdbe3c6f53f9$var$SliderZoomView = $13c3ce64e9689141$exports.extend({
    type: "dataZoom.slider",
    init: function(ecModel, api) {
        /**
     * @private
     * @type {Object}
     */ this._displayables = {};
        /**
     * @private
     * @type {string}
     */ this._orient;
        /**
     * [0, 100]
     * @private
     */ this._range;
        /**
     * [coord of the first handle, coord of the second handle]
     * @private
     */ this._handleEnds;
        /**
     * [length, thick]
     * @private
     * @type {Array.<number>}
     */ this._size;
        /**
     * @private
     * @type {number}
     */ this._handleWidth;
        /**
     * @private
     * @type {number}
     */ this._handleHeight;
        /**
     * @private
     */ this._location;
        /**
     * @private
     */ this._dragging;
        /**
     * @private
     */ this._dataShadowInfo;
        this.api = api;
    },
    /**
   * @override
   */ render: function(dataZoomModel, ecModel, api, payload) {
        $9965fdbe3c6f53f9$var$SliderZoomView.superApply(this, "render", arguments);
        $a181ac84b0d97d16$export$958e3e1a02eac4b6(this, "_dispatchZoomAction", this.dataZoomModel.get("throttle"), "fixRate");
        this._orient = dataZoomModel.get("orient");
        if (this.dataZoomModel.get("show") === false) {
            this.group.removeAll();
            return;
        } // Notice: this._resetInterval() should not be executed when payload.type
        // is 'dataZoom', origin this._range should be maintained, otherwise 'pan'
        // or 'zoom' info will be missed because of 'throttle' of this.dispatchAction,
        if (!payload || payload.type !== "dataZoom" || payload.from !== this.uid) this._buildView();
        this._updateView();
    },
    /**
   * @override
   */ remove: function() {
        $9965fdbe3c6f53f9$var$SliderZoomView.superApply(this, "remove", arguments);
        $a181ac84b0d97d16$export$42ffd38884aecdac(this, "_dispatchZoomAction");
    },
    /**
   * @override
   */ dispose: function() {
        $9965fdbe3c6f53f9$var$SliderZoomView.superApply(this, "dispose", arguments);
        $a181ac84b0d97d16$export$42ffd38884aecdac(this, "_dispatchZoomAction");
    },
    _buildView: function() {
        var thisGroup = this.group;
        thisGroup.removeAll();
        this._resetLocation();
        this._resetInterval();
        var barGroup = this._displayables.barGroup = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
        this._renderBackground();
        this._renderHandle();
        this._renderDataShadow();
        thisGroup.add(barGroup);
        this._positionGroup();
    },
    /**
   * @private
   */ _resetLocation: function() {
        var dataZoomModel = this.dataZoomModel;
        var api = this.api; // If some of x/y/width/height are not specified,
        // auto-adapt according to target grid.
        var coordRect = this._findCoordRect();
        var ecSize = {
            width: api.getWidth(),
            height: api.getHeight()
        }; // Default align by coordinate system rect.
        var positionInfo = this._orient === $9965fdbe3c6f53f9$var$HORIZONTAL ? {
            // Why using 'right', because right should be used in vertical,
            // and it is better to be consistent for dealing with position param merge.
            right: ecSize.width - coordRect.x - coordRect.width,
            top: ecSize.height - $9965fdbe3c6f53f9$var$DEFAULT_FILLER_SIZE - $9965fdbe3c6f53f9$var$DEFAULT_LOCATION_EDGE_GAP,
            width: coordRect.width,
            height: $9965fdbe3c6f53f9$var$DEFAULT_FILLER_SIZE
        } : {
            // vertical
            right: $9965fdbe3c6f53f9$var$DEFAULT_LOCATION_EDGE_GAP,
            top: coordRect.y,
            width: $9965fdbe3c6f53f9$var$DEFAULT_FILLER_SIZE,
            height: coordRect.height
        }; // Do not write back to option and replace value 'ph', because
        // the 'ph' value should be recalculated when resize.
        var layoutParams = $ab0c9086dd6c5b39$export$4b0d20af19c9875e(dataZoomModel.option); // Replace the placeholder value.
        $ec279652dd95c27b$export$79b2f7037acddd43([
            "right",
            "top",
            "width",
            "height"
        ], function(name) {
            if (layoutParams[name] === "ph") layoutParams[name] = positionInfo[name];
        });
        var layoutRect = $ab0c9086dd6c5b39$export$4517a5ca639a7293(layoutParams, ecSize, dataZoomModel.padding);
        this._location = {
            x: layoutRect.x,
            y: layoutRect.y
        };
        this._size = [
            layoutRect.width,
            layoutRect.height
        ];
        this._orient === $9965fdbe3c6f53f9$var$VERTICAL && this._size.reverse();
    },
    /**
   * @private
   */ _positionGroup: function() {
        var thisGroup = this.group;
        var location = this._location;
        var orient = this._orient; // Just use the first axis to determine mapping.
        var targetAxisModel = this.dataZoomModel.getFirstTargetAxisModel();
        var inverse = targetAxisModel && targetAxisModel.get("inverse");
        var barGroup = this._displayables.barGroup;
        var otherAxisInverse = (this._dataShadowInfo || {}).otherAxisInverse; // Transform barGroup.
        barGroup.attr(orient === $9965fdbe3c6f53f9$var$HORIZONTAL && !inverse ? {
            scale: otherAxisInverse ? [
                1,
                1
            ] : [
                1,
                -1
            ]
        } : orient === $9965fdbe3c6f53f9$var$HORIZONTAL && inverse ? {
            scale: otherAxisInverse ? [
                -1,
                1
            ] : [
                -1,
                -1
            ]
        } : orient === $9965fdbe3c6f53f9$var$VERTICAL && !inverse ? {
            scale: otherAxisInverse ? [
                1,
                -1
            ] : [
                1,
                1
            ],
            rotation: Math.PI / 2 // Dont use Math.PI, considering shadow direction.
        } : {
            scale: otherAxisInverse ? [
                -1,
                -1
            ] : [
                -1,
                1
            ],
            rotation: Math.PI / 2
        }); // Position barGroup
        var rect = thisGroup.getBoundingRect([
            barGroup
        ]);
        thisGroup.attr("position", [
            location.x - rect.x,
            location.y - rect.y
        ]);
    },
    /**
   * @private
   */ _getViewExtent: function() {
        return [
            0,
            this._size[0]
        ];
    },
    _renderBackground: function() {
        var dataZoomModel = this.dataZoomModel;
        var size = this._size;
        var barGroup = this._displayables.barGroup;
        barGroup.add(new $9965fdbe3c6f53f9$var$Rect({
            silent: true,
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1]
            },
            style: {
                fill: dataZoomModel.get("backgroundColor")
            },
            z2: -40
        })); // Click panel, over shadow, below handles.
        barGroup.add(new $9965fdbe3c6f53f9$var$Rect({
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1]
            },
            style: {
                fill: "transparent"
            },
            z2: 0,
            onclick: $ec279652dd95c27b$export$2385a24977818dd0(this._onClickPanelClick, this)
        }));
    },
    _renderDataShadow: function() {
        var info = this._dataShadowInfo = this._prepareDataShadowInfo();
        if (!info) return;
        var size = this._size;
        var seriesModel = info.series;
        var data = seriesModel.getRawData();
        var otherDim = seriesModel.getShadowDim ? seriesModel.getShadowDim() // @see candlestick
         : info.otherDim;
        if (otherDim == null) return;
        var otherDataExtent = data.getDataExtent(otherDim); // Nice extent.
        var otherOffset = (otherDataExtent[1] - otherDataExtent[0]) * 0.3;
        otherDataExtent = [
            otherDataExtent[0] - otherOffset,
            otherDataExtent[1] + otherOffset
        ];
        var otherShadowExtent = [
            0,
            size[1]
        ];
        var thisShadowExtent = [
            0,
            size[0]
        ];
        var areaPoints = [
            [
                size[0],
                0
            ],
            [
                0,
                0
            ]
        ];
        var linePoints = [];
        var step = thisShadowExtent[1] / (data.count() - 1);
        var thisCoord = 0; // Optimize for large data shadow
        var stride = Math.round(data.count() / size[0]);
        var lastIsEmpty;
        data.each([
            otherDim
        ], function(value, index) {
            if (stride > 0 && index % stride) {
                thisCoord += step;
                return;
            } // FIXME
            // Should consider axis.min/axis.max when drawing dataShadow.
            // FIXME
            // 应该使用统一的空判断？还是在list里进行空判断？
            var isEmpty = value == null || isNaN(value) || value === ""; // See #4235.
            var otherCoord = isEmpty ? 0 : $9965fdbe3c6f53f9$var$linearMap(value, otherDataExtent, otherShadowExtent, true); // Attempt to draw data shadow precisely when there are empty value.
            if (isEmpty && !lastIsEmpty && index) {
                areaPoints.push([
                    areaPoints[areaPoints.length - 1][0],
                    0
                ]);
                linePoints.push([
                    linePoints[linePoints.length - 1][0],
                    0
                ]);
            } else if (!isEmpty && lastIsEmpty) {
                areaPoints.push([
                    thisCoord,
                    0
                ]);
                linePoints.push([
                    thisCoord,
                    0
                ]);
            }
            areaPoints.push([
                thisCoord,
                otherCoord
            ]);
            linePoints.push([
                thisCoord,
                otherCoord
            ]);
            thisCoord += step;
            lastIsEmpty = isEmpty;
        });
        var dataZoomModel = this.dataZoomModel; // var dataBackgroundModel = dataZoomModel.getModel('dataBackground');
        this._displayables.barGroup.add(new $4b57d6b582d579b7$export$7d31b617c820d435({
            shape: {
                points: areaPoints
            },
            style: $ec279652dd95c27b$export$ebe90cb607ad99e({
                fill: dataZoomModel.get("dataBackgroundColor")
            }, dataZoomModel.getModel("dataBackground.areaStyle").getAreaStyle()),
            silent: true,
            z2: -20
        }));
        this._displayables.barGroup.add(new $4b57d6b582d579b7$export$79f3ee03e63e7073({
            shape: {
                points: linePoints
            },
            style: dataZoomModel.getModel("dataBackground.lineStyle").getLineStyle(),
            silent: true,
            z2: -19
        }));
    },
    _prepareDataShadowInfo: function() {
        var dataZoomModel = this.dataZoomModel;
        var showDataShadow = dataZoomModel.get("showDataShadow");
        if (showDataShadow === false) return;
         // Find a representative series.
        var result;
        var ecModel = this.ecModel;
        dataZoomModel.eachTargetAxis(function(dimNames, axisIndex) {
            var seriesModels = dataZoomModel.getAxisProxy(dimNames.name, axisIndex).getTargetSeriesModels();
            $ec279652dd95c27b$export$79b2f7037acddd43(seriesModels, function(seriesModel) {
                if (result) return;
                if (showDataShadow !== true && $ec279652dd95c27b$export$305f7d4e9d4624f2($9965fdbe3c6f53f9$var$SHOW_DATA_SHADOW_SERIES_TYPE, seriesModel.get("type")) < 0) return;
                var thisAxis = ecModel.getComponent(dimNames.axis, axisIndex).axis;
                var otherDim = $9965fdbe3c6f53f9$var$getOtherDim(dimNames.name);
                var otherAxisInverse;
                var coordSys = seriesModel.coordinateSystem;
                if (otherDim != null && coordSys.getOtherAxis) otherAxisInverse = coordSys.getOtherAxis(thisAxis).inverse;
                otherDim = seriesModel.getData().mapDimension(otherDim);
                result = {
                    thisAxis: thisAxis,
                    series: seriesModel,
                    thisDim: dimNames.name,
                    otherDim: otherDim,
                    otherAxisInverse: otherAxisInverse
                };
            }, this);
        }, this);
        return result;
    },
    _renderHandle: function() {
        var displaybles = this._displayables;
        var handles = displaybles.handles = [];
        var handleLabels = displaybles.handleLabels = [];
        var barGroup = this._displayables.barGroup;
        var size = this._size;
        var dataZoomModel = this.dataZoomModel;
        barGroup.add(displaybles.filler = new $9965fdbe3c6f53f9$var$Rect({
            draggable: true,
            cursor: $9965fdbe3c6f53f9$var$getCursor(this._orient),
            drift: $9965fdbe3c6f53f9$var$bind(this._onDragMove, this, "all"),
            ondragstart: $9965fdbe3c6f53f9$var$bind(this._showDataInfo, this, true),
            ondragend: $9965fdbe3c6f53f9$var$bind(this._onDragEnd, this),
            onmouseover: $9965fdbe3c6f53f9$var$bind(this._showDataInfo, this, true),
            onmouseout: $9965fdbe3c6f53f9$var$bind(this._showDataInfo, this, false),
            style: {
                fill: dataZoomModel.get("fillerColor"),
                textPosition: "inside"
            }
        })); // Frame border.
        barGroup.add(new $9965fdbe3c6f53f9$var$Rect({
            silent: true,
            subPixelOptimize: true,
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1]
            },
            style: {
                stroke: dataZoomModel.get("dataBackgroundColor") || dataZoomModel.get("borderColor"),
                lineWidth: $9965fdbe3c6f53f9$var$DEFAULT_FRAME_BORDER_WIDTH,
                fill: "rgba(0,0,0,0)"
            }
        }));
        $9965fdbe3c6f53f9$var$each([
            0,
            1
        ], function(handleIndex) {
            var path = $4b57d6b582d579b7$export$274edc73af1ae9c8(dataZoomModel.get("handleIcon"), {
                cursor: $9965fdbe3c6f53f9$var$getCursor(this._orient),
                draggable: true,
                drift: $9965fdbe3c6f53f9$var$bind(this._onDragMove, this, handleIndex),
                ondragend: $9965fdbe3c6f53f9$var$bind(this._onDragEnd, this),
                onmouseover: $9965fdbe3c6f53f9$var$bind(this._showDataInfo, this, true),
                onmouseout: $9965fdbe3c6f53f9$var$bind(this._showDataInfo, this, false)
            }, {
                x: -1,
                y: 0,
                width: 2,
                height: 2
            });
            var bRect = path.getBoundingRect();
            this._handleHeight = $2d742dbe7f960d8c$export$e8514cb5a5e2b40f(dataZoomModel.get("handleSize"), this._size[1]);
            this._handleWidth = bRect.width / bRect.height * this._handleHeight;
            path.setStyle(dataZoomModel.getModel("handleStyle").getItemStyle());
            var handleColor = dataZoomModel.get("handleColor"); // Compatitable with previous version
            if (handleColor != null) path.style.fill = handleColor;
            barGroup.add(handles[handleIndex] = path);
            var textStyleModel = dataZoomModel.textStyleModel;
            this.group.add(handleLabels[handleIndex] = new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
                silent: true,
                invisible: true,
                style: {
                    x: 0,
                    y: 0,
                    text: "",
                    textVerticalAlign: "middle",
                    textAlign: "center",
                    textFill: textStyleModel.getTextColor(),
                    textFont: textStyleModel.getFont()
                },
                z2: 10
            }));
        }, this);
    },
    /**
   * @private
   */ _resetInterval: function() {
        var range = this._range = this.dataZoomModel.getPercentRange();
        var viewExtent = this._getViewExtent();
        this._handleEnds = [
            $9965fdbe3c6f53f9$var$linearMap(range[0], [
                0,
                100
            ], viewExtent, true),
            $9965fdbe3c6f53f9$var$linearMap(range[1], [
                0,
                100
            ], viewExtent, true)
        ];
    },
    /**
   * @private
   * @param {(number|string)} handleIndex 0 or 1 or 'all'
   * @param {number} delta
   * @return {boolean} changed
   */ _updateInterval: function(handleIndex, delta) {
        var dataZoomModel = this.dataZoomModel;
        var handleEnds = this._handleEnds;
        var viewExtend = this._getViewExtent();
        var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
        var percentExtent = [
            0,
            100
        ];
        $1d1b44fc5f576d07$exports(delta, handleEnds, viewExtend, dataZoomModel.get("zoomLock") ? "all" : handleIndex, minMaxSpan.minSpan != null ? $9965fdbe3c6f53f9$var$linearMap(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? $9965fdbe3c6f53f9$var$linearMap(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
        var lastRange = this._range;
        var range = this._range = $9965fdbe3c6f53f9$var$asc([
            $9965fdbe3c6f53f9$var$linearMap(handleEnds[0], viewExtend, percentExtent, true),
            $9965fdbe3c6f53f9$var$linearMap(handleEnds[1], viewExtend, percentExtent, true)
        ]);
        return !lastRange || lastRange[0] !== range[0] || lastRange[1] !== range[1];
    },
    /**
   * @private
   */ _updateView: function(nonRealtime) {
        var displaybles = this._displayables;
        var handleEnds = this._handleEnds;
        var handleInterval = $9965fdbe3c6f53f9$var$asc(handleEnds.slice());
        var size = this._size;
        $9965fdbe3c6f53f9$var$each([
            0,
            1
        ], function(handleIndex) {
            // Handles
            var handle = displaybles.handles[handleIndex];
            var handleHeight = this._handleHeight;
            handle.attr({
                scale: [
                    handleHeight / 2,
                    handleHeight / 2
                ],
                position: [
                    handleEnds[handleIndex],
                    size[1] / 2 - handleHeight / 2
                ]
            });
        }, this); // Filler
        displaybles.filler.setShape({
            x: handleInterval[0],
            y: 0,
            width: handleInterval[1] - handleInterval[0],
            height: size[1]
        });
        this._updateDataInfo(nonRealtime);
    },
    /**
   * @private
   */ _updateDataInfo: function(nonRealtime) {
        var dataZoomModel = this.dataZoomModel;
        var displaybles = this._displayables;
        var handleLabels = displaybles.handleLabels;
        var orient = this._orient;
        var labelTexts = [
            "",
            ""
        ]; // FIXME
        // date型，支持formatter，autoformatter（ec2 date.getAutoFormatter）
        if (dataZoomModel.get("showDetail")) {
            var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
            if (axisProxy) {
                var axis = axisProxy.getAxisModel().axis;
                var range = this._range;
                var dataInterval = nonRealtime // See #4434, data and axis are not processed and reset yet in non-realtime mode.
                 ? axisProxy.calculateDataWindow({
                    start: range[0],
                    end: range[1]
                }).valueWindow : axisProxy.getDataValueWindow();
                labelTexts = [
                    this._formatLabel(dataInterval[0], axis),
                    this._formatLabel(dataInterval[1], axis)
                ];
            }
        }
        var orderedHandleEnds = $9965fdbe3c6f53f9$var$asc(this._handleEnds.slice());
        setLabel.call(this, 0);
        setLabel.call(this, 1);
        function setLabel(handleIndex) {
            // Label
            // Text should not transform by barGroup.
            // Ignore handlers transform
            var barTransform = $4b57d6b582d579b7$export$fce0c6cfca85ed96(displaybles.handles[handleIndex].parent, this.group);
            var direction = $4b57d6b582d579b7$export$fff94e9792354cfa(handleIndex === 0 ? "right" : "left", barTransform);
            var offset = this._handleWidth / 2 + $9965fdbe3c6f53f9$var$LABEL_GAP;
            var textPoint = $4b57d6b582d579b7$export$9f9dcb98c894b623([
                orderedHandleEnds[handleIndex] + (handleIndex === 0 ? -offset : offset),
                this._size[1] / 2
            ], barTransform);
            handleLabels[handleIndex].setStyle({
                x: textPoint[0],
                y: textPoint[1],
                textVerticalAlign: orient === $9965fdbe3c6f53f9$var$HORIZONTAL ? "middle" : direction,
                textAlign: orient === $9965fdbe3c6f53f9$var$HORIZONTAL ? direction : "center",
                text: labelTexts[handleIndex]
            });
        }
    },
    /**
   * @private
   */ _formatLabel: function(value, axis) {
        var dataZoomModel = this.dataZoomModel;
        var labelFormatter = dataZoomModel.get("labelFormatter");
        var labelPrecision = dataZoomModel.get("labelPrecision");
        if (labelPrecision == null || labelPrecision === "auto") labelPrecision = axis.getPixelPrecision();
        var valueStr = value == null || isNaN(value) ? "" // FIXME Glue code
         : axis.type === "category" || axis.type === "time" ? axis.scale.getLabel(Math.round(value)) // param of toFixed should less then 20.
         : value.toFixed(Math.min(labelPrecision, 20));
        return $ec279652dd95c27b$export$f6e2535fb5126e54(labelFormatter) ? labelFormatter(value, valueStr) : $ec279652dd95c27b$export$844ec244b1367d54(labelFormatter) ? labelFormatter.replace("{value}", valueStr) : valueStr;
    },
    /**
   * @private
   * @param {boolean} showOrHide true: show, false: hide
   */ _showDataInfo: function(showOrHide) {
        // Always show when drgging.
        showOrHide = this._dragging || showOrHide;
        var handleLabels = this._displayables.handleLabels;
        handleLabels[0].attr("invisible", !showOrHide);
        handleLabels[1].attr("invisible", !showOrHide);
    },
    _onDragMove: function(handleIndex, dx, dy, event) {
        this._dragging = true; // For mobile device, prevent screen slider on the button.
        $adca58e5ac25631a$export$fa6813432f753b0d(event.event); // Transform dx, dy to bar coordination.
        var barTransform = this._displayables.barGroup.getLocalTransform();
        var vertex = $4b57d6b582d579b7$export$9f9dcb98c894b623([
            dx,
            dy
        ], barTransform, true);
        var changed = this._updateInterval(handleIndex, vertex[0]);
        var realtime = this.dataZoomModel.get("realtime");
        this._updateView(!realtime); // Avoid dispatch dataZoom repeatly but range not changed,
        // which cause bad visual effect when progressive enabled.
        changed && realtime && this._dispatchZoomAction();
    },
    _onDragEnd: function() {
        this._dragging = false;
        this._showDataInfo(false); // While in realtime mode and stream mode, dispatch action when
        // drag end will cause the whole view rerender, which is unnecessary.
        var realtime = this.dataZoomModel.get("realtime");
        !realtime && this._dispatchZoomAction();
    },
    _onClickPanelClick: function(e) {
        var size = this._size;
        var localPoint = this._displayables.barGroup.transformCoordToLocal(e.offsetX, e.offsetY);
        if (localPoint[0] < 0 || localPoint[0] > size[0] || localPoint[1] < 0 || localPoint[1] > size[1]) return;
        var handleEnds = this._handleEnds;
        var center = (handleEnds[0] + handleEnds[1]) / 2;
        var changed = this._updateInterval("all", localPoint[0] - center);
        this._updateView();
        changed && this._dispatchZoomAction();
    },
    /**
   * This action will be throttled.
   * @private
   */ _dispatchZoomAction: function() {
        var range = this._range;
        this.api.dispatchAction({
            type: "dataZoom",
            from: this.uid,
            dataZoomId: this.dataZoomModel.id,
            start: range[0],
            end: range[1]
        });
    },
    /**
   * @private
   */ _findCoordRect: function() {
        // Find the grid coresponding to the first axis referred by dataZoom.
        var rect;
        $9965fdbe3c6f53f9$var$each(this.getTargetCoordInfo(), function(coordInfoList) {
            if (!rect && coordInfoList.length) {
                var coordSys = coordInfoList[0].model.coordinateSystem;
                rect = coordSys.getRect && coordSys.getRect();
            }
        });
        if (!rect) {
            var width = this.api.getWidth();
            var height = this.api.getHeight();
            rect = {
                x: width * 0.2,
                y: height * 0.2,
                width: width * 0.6,
                height: height * 0.6
            };
        }
        return rect;
    }
});
function $9965fdbe3c6f53f9$var$getOtherDim(thisDim) {
    // FIXME
    // 这个逻辑和getOtherAxis里一致，但是写在这里是否不好
    var map = {
        x: "y",
        y: "x",
        radius: "angle",
        angle: "radius"
    };
    return map[thisDim];
}
function $9965fdbe3c6f53f9$var$getCursor(orient) {
    return orient === "vertical" ? "ns-resize" : "ew-resize";
}
var $9965fdbe3c6f53f9$var$_default = $9965fdbe3c6f53f9$var$SliderZoomView;
$9965fdbe3c6f53f9$exports = $9965fdbe3c6f53f9$var$_default;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $a5d92c576c355d03$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $a5d92c576c355d03$var$_default = $49e2222a92c1e4ca$exports.extend({
    type: "dataZoom.inside",
    /**
   * @protected
   */ defaultOption: {
        disabled: false,
        // Whether disable this inside zoom.
        zoomLock: false,
        // Whether disable zoom but only pan.
        zoomOnMouseWheel: true,
        // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
        moveOnMouseMove: true,
        // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
        moveOnMouseWheel: false,
        // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
        preventDefaultMouseMove: true
    }
});
$a5d92c576c355d03$exports = $a5d92c576c355d03$var$_default;


var $d8ec0d82035d7e8a$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $ecc3c1e744093fae$export$6503ec6e8aabbaf;
var $ecc3c1e744093fae$export$d07f55d4c15c0440;
var $ecc3c1e744093fae$export$f1606efd6618121b;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Only create one roam controller for each coordinate system.
// one roam controller might be refered by two inside data zoom
// components (for example, one for x and one for y). When user
// pan or zoom, only dispatch one action for those data zoom
// components.
var $ecc3c1e744093fae$var$ATTR = "\x00_ec_dataZoom_roams";
/**
 * @public
 * @param {module:echarts/ExtensionAPI} api
 * @param {Object} dataZoomInfo
 * @param {string} dataZoomInfo.coordId
 * @param {Function} dataZoomInfo.containsPoint
 * @param {Array.<string>} dataZoomInfo.allCoordIds
 * @param {string} dataZoomInfo.dataZoomId
 * @param {Object} dataZoomInfo.getRange
 * @param {Function} dataZoomInfo.getRange.pan
 * @param {Function} dataZoomInfo.getRange.zoom
 * @param {Function} dataZoomInfo.getRange.scrollMove
 * @param {boolean} dataZoomInfo.dataZoomModel
 */ function $ecc3c1e744093fae$var$register(api, dataZoomInfo) {
    var store = $ecc3c1e744093fae$var$giveStore(api);
    var theDataZoomId = dataZoomInfo.dataZoomId;
    var theCoordId = dataZoomInfo.coordId; // Do clean when a dataZoom changes its target coordnate system.
    // Avoid memory leak, dispose all not-used-registered.
    $ec279652dd95c27b$export$79b2f7037acddd43(store, function(record, coordId) {
        var dataZoomInfos = record.dataZoomInfos;
        if (dataZoomInfos[theDataZoomId] && $ec279652dd95c27b$export$305f7d4e9d4624f2(dataZoomInfo.allCoordIds, theCoordId) < 0) {
            delete dataZoomInfos[theDataZoomId];
            record.count--;
        }
    });
    $ecc3c1e744093fae$var$cleanStore(store);
    var record = store[theCoordId]; // Create if needed.
    if (!record) {
        record = store[theCoordId] = {
            coordId: theCoordId,
            dataZoomInfos: {},
            count: 0
        };
        record.controller = $ecc3c1e744093fae$var$createController(api, record);
        record.dispatchAction = $ec279652dd95c27b$export$c3095a23b368d1f2($ecc3c1e744093fae$var$dispatchAction, api);
    } // Update reference of dataZoom.
    !record.dataZoomInfos[theDataZoomId] && record.count++;
    record.dataZoomInfos[theDataZoomId] = dataZoomInfo;
    var controllerParams = $ecc3c1e744093fae$var$mergeControllerParams(record.dataZoomInfos);
    record.controller.enable(controllerParams.controlType, controllerParams.opt); // Consider resize, area should be always updated.
    record.controller.setPointerChecker(dataZoomInfo.containsPoint); // Update throttle.
    $a181ac84b0d97d16$export$958e3e1a02eac4b6(record, "dispatchAction", dataZoomInfo.dataZoomModel.get("throttle", true), "fixRate");
}
/**
 * @public
 * @param {module:echarts/ExtensionAPI} api
 * @param {string} dataZoomId
 */ function $ecc3c1e744093fae$var$unregister(api, dataZoomId) {
    var store = $ecc3c1e744093fae$var$giveStore(api);
    $ec279652dd95c27b$export$79b2f7037acddd43(store, function(record) {
        record.controller.dispose();
        var dataZoomInfos = record.dataZoomInfos;
        if (dataZoomInfos[dataZoomId]) {
            delete dataZoomInfos[dataZoomId];
            record.count--;
        }
    });
    $ecc3c1e744093fae$var$cleanStore(store);
}
/**
 * @public
 */ function $ecc3c1e744093fae$var$generateCoordId(coordModel) {
    return coordModel.type + "\x00_" + coordModel.id;
}
/**
 * Key: coordId, value: {dataZoomInfos: [], count, controller}
 * @type {Array.<Object>}
 */ function $ecc3c1e744093fae$var$giveStore(api) {
    // Mount store on zrender instance, so that we do not
    // need to worry about dispose.
    var zr = api.getZr();
    return zr[$ecc3c1e744093fae$var$ATTR] || (zr[$ecc3c1e744093fae$var$ATTR] = {});
}
function $ecc3c1e744093fae$var$createController(api, newRecord) {
    var controller = new $f812ed7651a5f0b7$exports(api.getZr());
    $ec279652dd95c27b$export$79b2f7037acddd43([
        "pan",
        "zoom",
        "scrollMove"
    ], function(eventName) {
        controller.on(eventName, function(event) {
            var batch = [];
            $ec279652dd95c27b$export$79b2f7037acddd43(newRecord.dataZoomInfos, function(info) {
                // Check whether the behaviors (zoomOnMouseWheel, moveOnMouseMove,
                // moveOnMouseWheel, ...) enabled.
                if (!event.isAvailableBehavior(info.dataZoomModel.option)) return;
                var method = (info.getRange || {})[eventName];
                var range = method && method(newRecord.controller, event);
                !info.dataZoomModel.get("disabled", true) && range && batch.push({
                    dataZoomId: info.dataZoomId,
                    start: range[0],
                    end: range[1]
                });
            });
            batch.length && newRecord.dispatchAction(batch);
        });
    });
    return controller;
}
function $ecc3c1e744093fae$var$cleanStore(store) {
    $ec279652dd95c27b$export$79b2f7037acddd43(store, function(record, coordId) {
        if (!record.count) {
            record.controller.dispose();
            delete store[coordId];
        }
    });
}
/**
 * This action will be throttled.
 */ function $ecc3c1e744093fae$var$dispatchAction(api, batch) {
    api.dispatchAction({
        type: "dataZoom",
        batch: batch
    });
}
/**
 * Merge roamController settings when multiple dataZooms share one roamController.
 */ function $ecc3c1e744093fae$var$mergeControllerParams(dataZoomInfos) {
    var controlType; // DO NOT use reserved word (true, false, undefined) as key literally. Even if encapsulated
    // as string, it is probably revert to reserved word by compress tool. See #7411.
    var prefix = "type_";
    var typePriority = {
        "type_true": 2,
        "type_move": 1,
        "type_false": 0,
        "type_undefined": -1
    };
    var preventDefaultMouseMove = true;
    $ec279652dd95c27b$export$79b2f7037acddd43(dataZoomInfos, function(dataZoomInfo) {
        var dataZoomModel = dataZoomInfo.dataZoomModel;
        var oneType = dataZoomModel.get("disabled", true) ? false : dataZoomModel.get("zoomLock", true) ? "move" : true;
        if (typePriority[prefix + oneType] > typePriority[prefix + controlType]) controlType = oneType;
         // Prevent default move event by default. If one false, do not prevent. Otherwise
        // users may be confused why it does not work when multiple insideZooms exist.
        preventDefaultMouseMove &= dataZoomModel.get("preventDefaultMouseMove", true);
    });
    return {
        controlType: controlType,
        opt: {
            // RoamController will enable all of these functionalities,
            // and the final behavior is determined by its event listener
            // provided by each inside zoom.
            zoomOnMouseWheel: true,
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
            preventDefaultMouseMove: !!preventDefaultMouseMove
        }
    };
}
$ecc3c1e744093fae$export$6503ec6e8aabbaf = $ecc3c1e744093fae$var$register;
$ecc3c1e744093fae$export$d07f55d4c15c0440 = $ecc3c1e744093fae$var$unregister;
$ecc3c1e744093fae$export$f1606efd6618121b = $ecc3c1e744093fae$var$generateCoordId;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $d8ec0d82035d7e8a$var$bind = $ec279652dd95c27b$export$2385a24977818dd0;
var $d8ec0d82035d7e8a$var$InsideZoomView = $13c3ce64e9689141$exports.extend({
    type: "dataZoom.inside",
    /**
   * @override
   */ init: function(ecModel, api) {
        /**
     * 'throttle' is used in this.dispatchAction, so we save range
     * to avoid missing some 'pan' info.
     * @private
     * @type {Array.<number>}
     */ this._range;
    },
    /**
   * @override
   */ render: function(dataZoomModel, ecModel, api, payload) {
        $d8ec0d82035d7e8a$var$InsideZoomView.superApply(this, "render", arguments); // Hence the `throttle` util ensures to preserve command order,
        // here simply updating range all the time will not cause missing
        // any of the the roam change.
        this._range = dataZoomModel.getPercentRange(); // Reset controllers.
        $ec279652dd95c27b$export$79b2f7037acddd43(this.getTargetCoordInfo(), function(coordInfoList, coordSysName) {
            var allCoordIds = $ec279652dd95c27b$export$871de8747c9eaa88(coordInfoList, function(coordInfo) {
                return $ecc3c1e744093fae$export$f1606efd6618121b(coordInfo.model);
            });
            $ec279652dd95c27b$export$79b2f7037acddd43(coordInfoList, function(coordInfo) {
                var coordModel = coordInfo.model;
                var getRange = {};
                $ec279652dd95c27b$export$79b2f7037acddd43([
                    "pan",
                    "zoom",
                    "scrollMove"
                ], function(eventName) {
                    getRange[eventName] = $d8ec0d82035d7e8a$var$bind($d8ec0d82035d7e8a$var$roamHandlers[eventName], this, coordInfo, coordSysName);
                }, this);
                $ecc3c1e744093fae$export$6503ec6e8aabbaf(api, {
                    coordId: $ecc3c1e744093fae$export$f1606efd6618121b(coordModel),
                    allCoordIds: allCoordIds,
                    containsPoint: function(e, x, y) {
                        return coordModel.coordinateSystem.containPoint([
                            x,
                            y
                        ]);
                    },
                    dataZoomId: dataZoomModel.id,
                    dataZoomModel: dataZoomModel,
                    getRange: getRange
                });
            }, this);
        }, this);
    },
    /**
   * @override
   */ dispose: function() {
        $ecc3c1e744093fae$export$d07f55d4c15c0440(this.api, this.dataZoomModel.id);
        $d8ec0d82035d7e8a$var$InsideZoomView.superApply(this, "dispose", arguments);
        this._range = null;
    }
});
var $d8ec0d82035d7e8a$var$roamHandlers = {
    /**
   * @this {module:echarts/component/dataZoom/InsideZoomView}
   */ zoom: function(coordInfo, coordSysName, controller, e) {
        var lastRange = this._range;
        var range = lastRange.slice(); // Calculate transform by the first axis.
        var axisModel = coordInfo.axisModels[0];
        if (!axisModel) return;
        var directionInfo = $d8ec0d82035d7e8a$var$getDirectionInfo[coordSysName](null, [
            e.originX,
            e.originY
        ], axisModel, controller, coordInfo);
        var percentPoint = (directionInfo.signal > 0 ? directionInfo.pixelStart + directionInfo.pixelLength - directionInfo.pixel : directionInfo.pixel - directionInfo.pixelStart) / directionInfo.pixelLength * (range[1] - range[0]) + range[0];
        var scale = Math.max(1 / e.scale, 0);
        range[0] = (range[0] - percentPoint) * scale + percentPoint;
        range[1] = (range[1] - percentPoint) * scale + percentPoint; // Restrict range.
        var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
        $1d1b44fc5f576d07$exports(0, range, [
            0,
            100
        ], 0, minMaxSpan.minSpan, minMaxSpan.maxSpan);
        this._range = range;
        if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) return range;
    },
    /**
   * @this {module:echarts/component/dataZoom/InsideZoomView}
   */ pan: $d8ec0d82035d7e8a$var$makeMover(function(range, axisModel, coordInfo, coordSysName, controller, e) {
        var directionInfo = $d8ec0d82035d7e8a$var$getDirectionInfo[coordSysName]([
            e.oldX,
            e.oldY
        ], [
            e.newX,
            e.newY
        ], axisModel, controller, coordInfo);
        return directionInfo.signal * (range[1] - range[0]) * directionInfo.pixel / directionInfo.pixelLength;
    }),
    /**
   * @this {module:echarts/component/dataZoom/InsideZoomView}
   */ scrollMove: $d8ec0d82035d7e8a$var$makeMover(function(range, axisModel, coordInfo, coordSysName, controller, e) {
        var directionInfo = $d8ec0d82035d7e8a$var$getDirectionInfo[coordSysName]([
            0,
            0
        ], [
            e.scrollDelta,
            e.scrollDelta
        ], axisModel, controller, coordInfo);
        return directionInfo.signal * (range[1] - range[0]) * e.scrollDelta;
    })
};
function $d8ec0d82035d7e8a$var$makeMover(getPercentDelta) {
    return function(coordInfo, coordSysName, controller, e) {
        var lastRange = this._range;
        var range = lastRange.slice(); // Calculate transform by the first axis.
        var axisModel = coordInfo.axisModels[0];
        if (!axisModel) return;
        var percentDelta = getPercentDelta(range, axisModel, coordInfo, coordSysName, controller, e);
        $1d1b44fc5f576d07$exports(percentDelta, range, [
            0,
            100
        ], "all");
        this._range = range;
        if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) return range;
    };
}
var $d8ec0d82035d7e8a$var$getDirectionInfo = {
    grid: function(oldPoint, newPoint, axisModel, controller, coordInfo) {
        var axis = axisModel.axis;
        var ret = {};
        var rect = coordInfo.model.coordinateSystem.getRect();
        oldPoint = oldPoint || [
            0,
            0
        ];
        if (axis.dim === "x") {
            ret.pixel = newPoint[0] - oldPoint[0];
            ret.pixelLength = rect.width;
            ret.pixelStart = rect.x;
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // axis.dim === 'y'
            ret.pixel = newPoint[1] - oldPoint[1];
            ret.pixelLength = rect.height;
            ret.pixelStart = rect.y;
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    },
    polar: function(oldPoint, newPoint, axisModel, controller, coordInfo) {
        var axis = axisModel.axis;
        var ret = {};
        var polar = coordInfo.model.coordinateSystem;
        var radiusExtent = polar.getRadiusAxis().getExtent();
        var angleExtent = polar.getAngleAxis().getExtent();
        oldPoint = oldPoint ? polar.pointToCoord(oldPoint) : [
            0,
            0
        ];
        newPoint = polar.pointToCoord(newPoint);
        if (axisModel.mainType === "radiusAxis") {
            ret.pixel = newPoint[0] - oldPoint[0]; // ret.pixelLength = Math.abs(radiusExtent[1] - radiusExtent[0]);
            // ret.pixelStart = Math.min(radiusExtent[0], radiusExtent[1]);
            ret.pixelLength = radiusExtent[1] - radiusExtent[0];
            ret.pixelStart = radiusExtent[0];
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // 'angleAxis'
            ret.pixel = newPoint[1] - oldPoint[1]; // ret.pixelLength = Math.abs(angleExtent[1] - angleExtent[0]);
            // ret.pixelStart = Math.min(angleExtent[0], angleExtent[1]);
            ret.pixelLength = angleExtent[1] - angleExtent[0];
            ret.pixelStart = angleExtent[0];
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    },
    singleAxis: function(oldPoint, newPoint, axisModel, controller, coordInfo) {
        var axis = axisModel.axis;
        var rect = coordInfo.model.coordinateSystem.getRect();
        var ret = {};
        oldPoint = oldPoint || [
            0,
            0
        ];
        if (axis.orient === "horizontal") {
            ret.pixel = newPoint[0] - oldPoint[0];
            ret.pixelLength = rect.width;
            ret.pixelStart = rect.x;
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // 'vertical'
            ret.pixel = newPoint[1] - oldPoint[1];
            ret.pixelLength = rect.height;
            ret.pixelStart = rect.y;
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    }
};
var $d8ec0d82035d7e8a$var$_default = $d8ec0d82035d7e8a$var$InsideZoomView;
$d8ec0d82035d7e8a$exports = $d8ec0d82035d7e8a$var$_default;










/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $0a0c8397cd877127$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $0a0c8397cd877127$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
function $0a0c8397cd877127$var$_default(option) {
    var visualMap = option && option.visualMap;
    if (!$ec279652dd95c27b$export$43bee75e5e14138e(visualMap)) visualMap = visualMap ? [
        visualMap
    ] : [];
    $0a0c8397cd877127$var$each(visualMap, function(opt) {
        if (!opt) return;
         // rename splitList to pieces
        if ($0a0c8397cd877127$var$has(opt, "splitList") && !$0a0c8397cd877127$var$has(opt, "pieces")) {
            opt.pieces = opt.splitList;
            delete opt.splitList;
        }
        var pieces = opt.pieces;
        if (pieces && $ec279652dd95c27b$export$43bee75e5e14138e(pieces)) $0a0c8397cd877127$var$each(pieces, function(piece) {
            if ($ec279652dd95c27b$export$a6cdc56e425d0d0a(piece)) {
                if ($0a0c8397cd877127$var$has(piece, "start") && !$0a0c8397cd877127$var$has(piece, "min")) piece.min = piece.start;
                if ($0a0c8397cd877127$var$has(piece, "end") && !$0a0c8397cd877127$var$has(piece, "max")) piece.max = piece.end;
            }
        });
    });
}
function $0a0c8397cd877127$var$has(obj, name) {
    return obj && obj.hasOwnProperty && obj.hasOwnProperty(name);
}
$0a0c8397cd877127$exports = $0a0c8397cd877127$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ $3b9c2389e45dfb7d$exports.registerSubTypeDefaulter("visualMap", function(option) {
    // Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
    return !option.categories && (!(option.pieces ? option.pieces.length > 0 : option.splitNumber > 0) || option.calculable) ? "continuous" : "piecewise";
});


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $857c67b284991d33$var$VISUAL_PRIORITY = $f406636b535430a7$exports.PRIORITY.VISUAL.COMPONENT;
$f406636b535430a7$exports.registerVisual($857c67b284991d33$var$VISUAL_PRIORITY, {
    createOnAllSeries: true,
    reset: function(seriesModel, ecModel) {
        var resetDefines = [];
        ecModel.eachComponent("visualMap", function(visualMapModel) {
            var pipelineContext = seriesModel.pipelineContext;
            if (!visualMapModel.isTargetSeries(seriesModel) || pipelineContext && pipelineContext.large) return;
            resetDefines.push($5d9ee77508af1280$export$fc0ef8703cccf128(visualMapModel.stateList, visualMapModel.targetVisuals, $ec279652dd95c27b$export$2385a24977818dd0(visualMapModel.getValueState, visualMapModel), visualMapModel.getDataDimension(seriesModel.getData())));
        });
        return resetDefines;
    }
}); // Only support color.
$f406636b535430a7$exports.registerVisual($857c67b284991d33$var$VISUAL_PRIORITY, {
    createOnAllSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        var visualMetaList = [];
        ecModel.eachComponent("visualMap", function(visualMapModel) {
            if (visualMapModel.isTargetSeries(seriesModel)) {
                var visualMeta = visualMapModel.getVisualMeta($ec279652dd95c27b$export$2385a24977818dd0($857c67b284991d33$var$getColorVisual, null, seriesModel, visualMapModel)) || {
                    stops: [],
                    outerColors: []
                };
                var concreteDim = visualMapModel.getDataDimension(data);
                var dimInfo = data.getDimensionInfo(concreteDim);
                if (dimInfo != null) {
                    // visualMeta.dimension should be dimension index, but not concrete dimension.
                    visualMeta.dimension = dimInfo.index;
                    visualMetaList.push(visualMeta);
                }
            }
        }); // console.log(JSON.stringify(visualMetaList.map(a => a.stops)));
        seriesModel.getData().setVisual("visualMeta", visualMetaList);
    }
}); // FIXME
// performance and export for heatmap?
// value can be Infinity or -Infinity
function $857c67b284991d33$var$getColorVisual(seriesModel, visualMapModel, value, valueState) {
    var mappings = visualMapModel.targetVisuals[valueState];
    var visualTypes = $72cc7afb3a2d7026$exports.prepareVisualTypes(mappings);
    var resultVisual = {
        color: seriesModel.getData().getVisual("color") // default color.
    };
    for(var i = 0, len = visualTypes.length; i < len; i++){
        var type = visualTypes[i];
        var mapping = mappings[type === "opacity" ? "__alphaForOpacity" : type];
        mapping && mapping.applyVisual(value, getVisual, setVisual);
    }
    return resultVisual.color;
    function getVisual(key) {
        return resultVisual[key];
    }
    function setVisual(key, value) {
        resultVisual[key] = value;
    }
}


var $ce3619c97c2a2576$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $e0a90a30cc6b290f$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $71f23b5f15c222ae$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @file Visual mapping.
 */ var $71f23b5f15c222ae$var$visualDefault = {
    /**
   * @public
   */ get: function(visualType, key, isCategory) {
        var value = $ec279652dd95c27b$export$9cd59f9826255e47(($71f23b5f15c222ae$var$defaultOption[visualType] || {})[key]);
        return isCategory ? $ec279652dd95c27b$export$43bee75e5e14138e(value) ? value[value.length - 1] : value : value;
    }
};
var $71f23b5f15c222ae$var$defaultOption = {
    color: {
        active: [
            "#006edd",
            "#e0ffff"
        ],
        inactive: [
            "rgba(0,0,0,0)"
        ]
    },
    colorHue: {
        active: [
            0,
            360
        ],
        inactive: [
            0,
            0
        ]
    },
    colorSaturation: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    colorLightness: {
        active: [
            0.9,
            0.5
        ],
        inactive: [
            0,
            0
        ]
    },
    colorAlpha: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    opacity: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    symbol: {
        active: [
            "circle",
            "roundRect",
            "diamond"
        ],
        inactive: [
            "none"
        ]
    },
    symbolSize: {
        active: [
            10,
            50
        ],
        inactive: [
            0,
            0
        ]
    }
};
var $71f23b5f15c222ae$var$_default = $71f23b5f15c222ae$var$visualDefault;
$71f23b5f15c222ae$exports = $71f23b5f15c222ae$var$_default;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $e0a90a30cc6b290f$var$mapVisual = $72cc7afb3a2d7026$exports.mapVisual;
var $e0a90a30cc6b290f$var$eachVisual = $72cc7afb3a2d7026$exports.eachVisual;
var $e0a90a30cc6b290f$var$isArray = $ec279652dd95c27b$export$43bee75e5e14138e;
var $e0a90a30cc6b290f$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $e0a90a30cc6b290f$var$asc = $2d742dbe7f960d8c$export$debe6e778e0a6d32;
var $e0a90a30cc6b290f$var$linearMap = $2d742dbe7f960d8c$export$d3f68fbaa670562;
var $e0a90a30cc6b290f$var$noop = $ec279652dd95c27b$export$8793edee2d425525;
var $e0a90a30cc6b290f$var$VisualMapModel = $f406636b535430a7$exports.extendComponentModel({
    type: "visualMap",
    dependencies: [
        "series"
    ],
    /**
   * @readOnly
   * @type {Array.<string>}
   */ stateList: [
        "inRange",
        "outOfRange"
    ],
    /**
   * @readOnly
   * @type {Array.<string>}
   */ replacableOptionKeys: [
        "inRange",
        "outOfRange",
        "target",
        "controller",
        "color"
    ],
    /**
   * [lowerBound, upperBound]
   *
   * @readOnly
   * @type {Array.<number>}
   */ dataBound: [
        -Infinity,
        Infinity
    ],
    /**
   * @readOnly
   * @type {string|Object}
   */ layoutMode: {
        type: "box",
        ignoreSize: true
    },
    /**
   * @protected
   */ defaultOption: {
        show: true,
        zlevel: 0,
        z: 4,
        seriesIndex: "all",
        // 'all' or null/undefined: all series.
        // A number or an array of number: the specified series.
        // set min: 0, max: 200, only for campatible with ec2.
        // In fact min max should not have default value.
        min: 0,
        // min value, must specified if pieces is not specified.
        max: 200,
        // max value, must specified if pieces is not specified.
        dimension: null,
        inRange: null,
        // 'color', 'colorHue', 'colorSaturation', 'colorLightness', 'colorAlpha',
        // 'symbol', 'symbolSize'
        outOfRange: null,
        // 'color', 'colorHue', 'colorSaturation',
        // 'colorLightness', 'colorAlpha',
        // 'symbol', 'symbolSize'
        left: 0,
        // 'center' ¦ 'left' ¦ 'right' ¦ {number} (px)
        right: null,
        // The same as left.
        top: null,
        // 'top' ¦ 'bottom' ¦ 'center' ¦ {number} (px)
        bottom: 0,
        // The same as top.
        itemWidth: null,
        itemHeight: null,
        inverse: false,
        orient: "vertical",
        // 'horizontal' ¦ 'vertical'
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: "#ccc",
        // 值域边框颜色
        contentColor: "#5793f3",
        inactiveColor: "#aaa",
        borderWidth: 0,
        // 值域边框线宽，单位px，默认为0（无边框）
        padding: 5,
        // 值域内边距，单位px，默认各方向内边距为5，
        // 接受数组分别设定上右下左边距，同css
        textGap: 10,
        //
        precision: 0,
        // 小数精度，默认为0，无小数点
        color: null,
        //颜色（deprecated，兼容ec2，顺序同pieces，不同于inRange/outOfRange）
        formatter: null,
        text: null,
        // 文本，如['高', '低']，兼容ec2，text[0]对应高值，text[1]对应低值
        textStyle: {
            color: "#333" // 值域文字颜色
        }
    },
    /**
   * @protected
   */ init: function(option, parentModel, ecModel) {
        /**
     * @private
     * @type {Array.<number>}
     */ this._dataExtent;
        /**
     * @readOnly
     */ this.targetVisuals = {};
        /**
     * @readOnly
     */ this.controllerVisuals = {};
        /**
     * @readOnly
     */ this.textStyleModel;
        /**
     * [width, height]
     * @readOnly
     * @type {Array.<number>}
     */ this.itemSize;
        this.mergeDefaultAndTheme(option, ecModel);
    },
    /**
   * @protected
   */ optionUpdated: function(newOption, isInit) {
        var thisOption = this.option; // FIXME
        // necessary?
        // Disable realtime view update if canvas is not supported.
        if (!$27ac1413ecc67076$exports.canvasSupported) thisOption.realtime = false;
        !isInit && $5d9ee77508af1280$export$797d20c0a6de578f(thisOption, newOption, this.replacableOptionKeys);
        this.textStyleModel = this.getModel("textStyle");
        this.resetItemSize();
        this.completeVisualOption();
    },
    /**
   * @protected
   */ resetVisual: function(supplementVisualOption) {
        var stateList = this.stateList;
        supplementVisualOption = $ec279652dd95c27b$export$2385a24977818dd0(supplementVisualOption, this);
        this.controllerVisuals = $5d9ee77508af1280$export$89974527642f24a0(this.option.controller, stateList, supplementVisualOption);
        this.targetVisuals = $5d9ee77508af1280$export$89974527642f24a0(this.option.target, stateList, supplementVisualOption);
    },
    /**
   * @protected
   * @return {Array.<number>} An array of series indices.
   */ getTargetSeriesIndices: function() {
        var optionSeriesIndex = this.option.seriesIndex;
        var seriesIndices = [];
        if (optionSeriesIndex == null || optionSeriesIndex === "all") this.ecModel.eachSeries(function(seriesModel, index) {
            seriesIndices.push(index);
        });
        else seriesIndices = $d559f43cb9041423$export$4f07b212a02c8051(optionSeriesIndex);
        return seriesIndices;
    },
    /**
   * @public
   */ eachTargetSeries: function(callback, context) {
        $ec279652dd95c27b$export$79b2f7037acddd43(this.getTargetSeriesIndices(), function(seriesIndex) {
            callback.call(context, this.ecModel.getSeriesByIndex(seriesIndex));
        }, this);
    },
    /**
   * @pubilc
   */ isTargetSeries: function(seriesModel) {
        var is = false;
        this.eachTargetSeries(function(model) {
            model === seriesModel && (is = true);
        });
        return is;
    },
    /**
   * @example
   * this.formatValueText(someVal); // format single numeric value to text.
   * this.formatValueText(someVal, true); // format single category value to text.
   * this.formatValueText([min, max]); // format numeric min-max to text.
   * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
   * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
   *
   * @param {number|Array.<number>} value Real value, or this.dataBound[0 or 1].
   * @param {boolean} [isCategory=false] Only available when value is number.
   * @param {Array.<string>} edgeSymbols Open-close symbol when value is interval.
   * @return {string}
   * @protected
   */ formatValueText: function(value, isCategory, edgeSymbols) {
        var option = this.option;
        var precision = option.precision;
        var dataBound = this.dataBound;
        var formatter = option.formatter;
        var isMinMax;
        var textValue;
        edgeSymbols = edgeSymbols || [
            "<",
            ">"
        ];
        if ($ec279652dd95c27b$export$43bee75e5e14138e(value)) {
            value = value.slice();
            isMinMax = true;
        }
        textValue = isCategory ? value : isMinMax ? [
            toFixed(value[0]),
            toFixed(value[1])
        ] : toFixed(value);
        if ($ec279652dd95c27b$export$844ec244b1367d54(formatter)) return formatter.replace("{value}", isMinMax ? textValue[0] : textValue).replace("{value2}", isMinMax ? textValue[1] : textValue);
        else if ($ec279652dd95c27b$export$f6e2535fb5126e54(formatter)) return isMinMax ? formatter(value[0], value[1]) : formatter(value);
        if (isMinMax) {
            if (value[0] === dataBound[0]) return edgeSymbols[0] + " " + textValue[1];
            else if (value[1] === dataBound[1]) return edgeSymbols[1] + " " + textValue[0];
            else return textValue[0] + " - " + textValue[1];
        } else // Format single value (includes category case).
        return textValue;
        function toFixed(val) {
            return val === dataBound[0] ? "min" : val === dataBound[1] ? "max" : (+val).toFixed(Math.min(precision, 20));
        }
    },
    /**
   * @protected
   */ resetExtent: function() {
        var thisOption = this.option; // Can not calculate data extent by data here.
        // Because series and data may be modified in processing stage.
        // So we do not support the feature "auto min/max".
        var extent = $e0a90a30cc6b290f$var$asc([
            thisOption.min,
            thisOption.max
        ]);
        this._dataExtent = extent;
    },
    /**
   * @public
   * @param {module:echarts/data/List} list
   * @return {string} Concrete dimention. If return null/undefined,
   *                  no dimension used.
   */ getDataDimension: function(list) {
        var optDim = this.option.dimension;
        var listDimensions = list.dimensions;
        if (optDim == null && !listDimensions.length) return;
        if (optDim != null) return list.getDimension(optDim);
        var dimNames = list.dimensions;
        for(var i = dimNames.length - 1; i >= 0; i--){
            var dimName = dimNames[i];
            var dimInfo = list.getDimensionInfo(dimName);
            if (!dimInfo.isCalculationCoord) return dimName;
        }
    },
    /**
   * @public
   * @override
   */ getExtent: function() {
        return this._dataExtent.slice();
    },
    /**
   * @protected
   */ completeVisualOption: function() {
        var ecModel = this.ecModel;
        var thisOption = this.option;
        var base = {
            inRange: thisOption.inRange,
            outOfRange: thisOption.outOfRange
        };
        var target = thisOption.target || (thisOption.target = {});
        var controller = thisOption.controller || (thisOption.controller = {});
        $ec279652dd95c27b$export$4950aa0f605343fb(target, base); // Do not override
        $ec279652dd95c27b$export$4950aa0f605343fb(controller, base); // Do not override
        var isCategory = this.isCategory();
        completeSingle.call(this, target);
        completeSingle.call(this, controller);
        completeInactive.call(this, target, "inRange", "outOfRange"); // completeInactive.call(this, target, 'outOfRange', 'inRange');
        completeController.call(this, controller);
        function completeSingle(base) {
            // Compatible with ec2 dataRange.color.
            // The mapping order of dataRange.color is: [high value, ..., low value]
            // whereas inRange.color and outOfRange.color is [low value, ..., high value]
            // Notice: ec2 has no inverse.
            if ($e0a90a30cc6b290f$var$isArray(thisOption.color) // If there has been inRange: {symbol: ...}, adding color is a mistake.
             && !base.inRange) base.inRange = {
                color: thisOption.color.slice().reverse()
            };
             // Compatible with previous logic, always give a defautl color, otherwise
            // simple config with no inRange and outOfRange will not work.
            // Originally we use visualMap.color as the default color, but setOption at
            // the second time the default color will be erased. So we change to use
            // constant DEFAULT_COLOR.
            // If user do not want the default color, set inRange: {color: null}.
            base.inRange = base.inRange || {
                color: ecModel.get("gradientColor")
            }; // If using shortcut like: {inRange: 'symbol'}, complete default value.
            $e0a90a30cc6b290f$var$each(this.stateList, function(state) {
                var visualType = base[state];
                if ($ec279652dd95c27b$export$844ec244b1367d54(visualType)) {
                    var defa = $71f23b5f15c222ae$exports.get(visualType, "active", isCategory);
                    if (defa) {
                        base[state] = {};
                        base[state][visualType] = defa;
                    } else // Mark as not specified.
                    delete base[state];
                }
            }, this);
        }
        function completeInactive(base, stateExist, stateAbsent) {
            var optExist = base[stateExist];
            var optAbsent = base[stateAbsent];
            if (optExist && !optAbsent) {
                optAbsent = base[stateAbsent] = {};
                $e0a90a30cc6b290f$var$each(optExist, function(visualData, visualType) {
                    if (!$72cc7afb3a2d7026$exports.isValidType(visualType)) return;
                    var defa = $71f23b5f15c222ae$exports.get(visualType, "inactive", isCategory);
                    if (defa != null) {
                        optAbsent[visualType] = defa; // Compatibable with ec2:
                        // Only inactive color to rgba(0,0,0,0) can not
                        // make label transparent, so use opacity also.
                        if (visualType === "color" && !optAbsent.hasOwnProperty("opacity") && !optAbsent.hasOwnProperty("colorAlpha")) optAbsent.opacity = [
                            0,
                            0
                        ];
                    }
                });
            }
        }
        function completeController(controller) {
            var symbolExists = (controller.inRange || {}).symbol || (controller.outOfRange || {}).symbol;
            var symbolSizeExists = (controller.inRange || {}).symbolSize || (controller.outOfRange || {}).symbolSize;
            var inactiveColor = this.get("inactiveColor");
            $e0a90a30cc6b290f$var$each(this.stateList, function(state) {
                var itemSize = this.itemSize;
                var visuals = controller[state]; // Set inactive color for controller if no other color
                // attr (like colorAlpha) specified.
                if (!visuals) visuals = controller[state] = {
                    color: isCategory ? inactiveColor : [
                        inactiveColor
                    ]
                };
                 // Consistent symbol and symbolSize if not specified.
                if (visuals.symbol == null) visuals.symbol = symbolExists && $ec279652dd95c27b$export$9cd59f9826255e47(symbolExists) || (isCategory ? "roundRect" : [
                    "roundRect"
                ]);
                if (visuals.symbolSize == null) visuals.symbolSize = symbolSizeExists && $ec279652dd95c27b$export$9cd59f9826255e47(symbolSizeExists) || (isCategory ? itemSize[0] : [
                    itemSize[0],
                    itemSize[0]
                ]);
                 // Filter square and none.
                visuals.symbol = $e0a90a30cc6b290f$var$mapVisual(visuals.symbol, function(symbol) {
                    return symbol === "none" || symbol === "square" ? "roundRect" : symbol;
                }); // Normalize symbolSize
                var symbolSize = visuals.symbolSize;
                if (symbolSize != null) {
                    var max = -Infinity; // symbolSize can be object when categories defined.
                    $e0a90a30cc6b290f$var$eachVisual(symbolSize, function(value) {
                        value > max && (max = value);
                    });
                    visuals.symbolSize = $e0a90a30cc6b290f$var$mapVisual(symbolSize, function(value) {
                        return $e0a90a30cc6b290f$var$linearMap(value, [
                            0,
                            max
                        ], [
                            0,
                            itemSize[0]
                        ], true);
                    });
                }
            }, this);
        }
    },
    /**
   * @protected
   */ resetItemSize: function() {
        this.itemSize = [
            parseFloat(this.get("itemWidth")),
            parseFloat(this.get("itemHeight"))
        ];
    },
    /**
   * @public
   */ isCategory: function() {
        return !!this.option.categories;
    },
    /**
   * @public
   * @abstract
   */ setSelected: $e0a90a30cc6b290f$var$noop,
    /**
   * @public
   * @abstract
   * @param {*|module:echarts/data/List} valueOrData
   * @param {number} dataIndex
   * @return {string} state See this.stateList
   */ getValueState: $e0a90a30cc6b290f$var$noop,
    /**
   * FIXME
   * Do not publish to thirt-part-dev temporarily
   * util the interface is stable. (Should it return
   * a function but not visual meta?)
   *
   * @pubilc
   * @abstract
   * @param {Function} getColorVisual
   *        params: value, valueState
   *        return: color
   * @return {Object} visualMeta
   *        should includes {stops, outerColors}
   *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
   */ getVisualMeta: $e0a90a30cc6b290f$var$noop
});
var $e0a90a30cc6b290f$var$_default = $e0a90a30cc6b290f$var$VisualMapModel;
$e0a90a30cc6b290f$exports = $e0a90a30cc6b290f$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Constant
var $ce3619c97c2a2576$var$DEFAULT_BAR_BOUND = [
    20,
    140
];
var $ce3619c97c2a2576$var$ContinuousModel = $e0a90a30cc6b290f$exports.extend({
    type: "visualMap.continuous",
    /**
   * @protected
   */ defaultOption: {
        align: "auto",
        // 'auto', 'left', 'right', 'top', 'bottom'
        calculable: false,
        // This prop effect default component type determine,
        // See echarts/component/visualMap/typeDefaulter.
        range: null,
        // selected range. In default case `range` is [min, max]
        // and can auto change along with modification of min max,
        // util use specifid a range.
        realtime: true,
        // Whether realtime update.
        itemHeight: null,
        // The length of the range control edge.
        itemWidth: null,
        // The length of the other side.
        hoverLink: true,
        // Enable hover highlight.
        hoverLinkDataSize: null,
        // The size of hovered data.
        hoverLinkOnHandle: null // Whether trigger hoverLink when hover handle.
    },
    /**
   * @override
   */ optionUpdated: function(newOption, isInit) {
        $ce3619c97c2a2576$var$ContinuousModel.superApply(this, "optionUpdated", arguments);
        this.resetExtent();
        this.resetVisual(function(mappingOption) {
            mappingOption.mappingMethod = "linear";
            mappingOption.dataExtent = this.getExtent();
        });
        this._resetRange();
    },
    /**
   * @protected
   * @override
   */ resetItemSize: function() {
        $ce3619c97c2a2576$var$ContinuousModel.superApply(this, "resetItemSize", arguments);
        var itemSize = this.itemSize;
        this._orient === "horizontal" && itemSize.reverse();
        (itemSize[0] == null || isNaN(itemSize[0])) && (itemSize[0] = $ce3619c97c2a2576$var$DEFAULT_BAR_BOUND[0]);
        (itemSize[1] == null || isNaN(itemSize[1])) && (itemSize[1] = $ce3619c97c2a2576$var$DEFAULT_BAR_BOUND[1]);
    },
    /**
   * @private
   */ _resetRange: function() {
        var dataExtent = this.getExtent();
        var range = this.option.range;
        if (!range || range.auto) {
            // `range` should always be array (so we dont use other
            // value like 'auto') for user-friend. (consider getOption).
            dataExtent.auto = 1;
            this.option.range = dataExtent;
        } else if ($ec279652dd95c27b$export$43bee75e5e14138e(range)) {
            if (range[0] > range[1]) range.reverse();
            range[0] = Math.max(range[0], dataExtent[0]);
            range[1] = Math.min(range[1], dataExtent[1]);
        }
    },
    /**
   * @protected
   * @override
   */ completeVisualOption: function() {
        $e0a90a30cc6b290f$exports.prototype.completeVisualOption.apply(this, arguments);
        $ec279652dd95c27b$export$79b2f7037acddd43(this.stateList, function(state) {
            var symbolSize = this.option.controller[state].symbolSize;
            if (symbolSize && symbolSize[0] !== symbolSize[1]) symbolSize[0] = 0; // For good looking.
        }, this);
    },
    /**
   * @override
   */ setSelected: function(selected) {
        this.option.range = selected.slice();
        this._resetRange();
    },
    /**
   * @public
   */ getSelected: function() {
        var dataExtent = this.getExtent();
        var dataInterval = $2d742dbe7f960d8c$export$debe6e778e0a6d32((this.get("range") || []).slice()); // Clamp
        dataInterval[0] > dataExtent[1] && (dataInterval[0] = dataExtent[1]);
        dataInterval[1] > dataExtent[1] && (dataInterval[1] = dataExtent[1]);
        dataInterval[0] < dataExtent[0] && (dataInterval[0] = dataExtent[0]);
        dataInterval[1] < dataExtent[0] && (dataInterval[1] = dataExtent[0]);
        return dataInterval;
    },
    /**
   * @override
   */ getValueState: function(value) {
        var range = this.option.range;
        var dataExtent = this.getExtent(); // When range[0] === dataExtent[0], any value larger than dataExtent[0] maps to 'inRange'.
        // range[1] is processed likewise.
        return (range[0] <= dataExtent[0] || range[0] <= value) && (range[1] >= dataExtent[1] || value <= range[1]) ? "inRange" : "outOfRange";
    },
    /**
   * @params {Array.<number>} range target value: range[0] <= value && value <= range[1]
   * @return {Array.<Object>} [{seriesId, dataIndices: <Array.<number>>}, ...]
   */ findTargetDataIndices: function(range) {
        var result = [];
        this.eachTargetSeries(function(seriesModel) {
            var dataIndices = [];
            var data = seriesModel.getData();
            data.each(this.getDataDimension(data), function(value, dataIndex) {
                range[0] <= value && value <= range[1] && dataIndices.push(dataIndex);
            }, this);
            result.push({
                seriesId: seriesModel.id,
                dataIndex: dataIndices
            });
        }, this);
        return result;
    },
    /**
   * @implement
   */ getVisualMeta: function(getColorVisual) {
        var oVals = $ce3619c97c2a2576$var$getColorStopValues(this, "outOfRange", this.getExtent());
        var iVals = $ce3619c97c2a2576$var$getColorStopValues(this, "inRange", this.option.range.slice());
        var stops = [];
        function setStop(value, valueState) {
            stops.push({
                value: value,
                color: getColorVisual(value, valueState)
            });
        } // Format to: outOfRange -- inRange -- outOfRange.
        var iIdx = 0;
        var oIdx = 0;
        var iLen = iVals.length;
        var oLen = oVals.length;
        for(; oIdx < oLen && (!iVals.length || oVals[oIdx] <= iVals[0]); oIdx++)// If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
        if (oVals[oIdx] < iVals[iIdx]) setStop(oVals[oIdx], "outOfRange");
        for(var first = 1; iIdx < iLen; iIdx++, first = 0){
            // If range is full, value beyond min, max will be clamped.
            // make a singularity
            first && stops.length && setStop(iVals[iIdx], "outOfRange");
            setStop(iVals[iIdx], "inRange");
        }
        for(var first = 1; oIdx < oLen; oIdx++)if (!iVals.length || iVals[iVals.length - 1] < oVals[oIdx]) {
            // make a singularity
            if (first) {
                stops.length && setStop(stops[stops.length - 1].value, "outOfRange");
                first = 0;
            }
            setStop(oVals[oIdx], "outOfRange");
        }
        var stopsLen = stops.length;
        return {
            stops: stops,
            outerColors: [
                stopsLen ? stops[0].color : "transparent",
                stopsLen ? stops[stopsLen - 1].color : "transparent"
            ]
        };
    }
});
function $ce3619c97c2a2576$var$getColorStopValues(visualMapModel, valueState, dataExtent) {
    if (dataExtent[0] === dataExtent[1]) return dataExtent.slice();
     // When using colorHue mapping, it is not linear color any more.
    // Moreover, canvas gradient seems not to be accurate linear.
    // FIXME
    // Should be arbitrary value 100? or based on pixel size?
    var count = 200;
    var step = (dataExtent[1] - dataExtent[0]) / count;
    var value = dataExtent[0];
    var stopValues = [];
    for(var i = 0; i <= count && value < dataExtent[1]; i++){
        stopValues.push(value);
        value += step;
    }
    stopValues.push(dataExtent[1]);
    return stopValues;
}
var $ce3619c97c2a2576$var$_default = $ce3619c97c2a2576$var$ContinuousModel;
$ce3619c97c2a2576$exports = $ce3619c97c2a2576$var$_default;


var $9da1193b89b3ffbb$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $823894306aa67fc9$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $823894306aa67fc9$var$_default = $f406636b535430a7$exports.extendComponentView({
    type: "visualMap",
    /**
   * @readOnly
   * @type {Object}
   */ autoPositionValues: {
        left: 1,
        right: 1,
        top: 1,
        bottom: 1
    },
    init: function(ecModel, api) {
        /**
     * @readOnly
     * @type {module:echarts/model/Global}
     */ this.ecModel = ecModel;
        /**
     * @readOnly
     * @type {module:echarts/ExtensionAPI}
     */ this.api = api;
        /**
     * @readOnly
     * @type {module:echarts/component/visualMap/visualMapModel}
     */ this.visualMapModel;
    },
    /**
   * @protected
   */ render: function(visualMapModel, ecModel, api, payload) {
        this.visualMapModel = visualMapModel;
        if (visualMapModel.get("show") === false) {
            this.group.removeAll();
            return;
        }
        this.doRender.apply(this, arguments);
    },
    /**
   * @protected
   */ renderBackground: function(group) {
        var visualMapModel = this.visualMapModel;
        var padding = $a4be9366aeb9fcc8$export$f3a38102c49f4268(visualMapModel.get("padding") || 0);
        var rect = group.getBoundingRect();
        group.add(new $4b57d6b582d579b7$export$c79fc6492f3af13d({
            z2: -1,
            // Lay background rect on the lowest layer.
            silent: true,
            shape: {
                x: rect.x - padding[3],
                y: rect.y - padding[0],
                width: rect.width + padding[3] + padding[1],
                height: rect.height + padding[0] + padding[2]
            },
            style: {
                fill: visualMapModel.get("backgroundColor"),
                stroke: visualMapModel.get("borderColor"),
                lineWidth: visualMapModel.get("borderWidth")
            }
        }));
    },
    /**
   * @protected
   * @param {number} targetValue can be Infinity or -Infinity
   * @param {string=} visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
   * @param {Object} [opts]
   * @param {string=} [opts.forceState] Specify state, instead of using getValueState method.
   * @param {string=} [opts.convertOpacityToAlpha=false] For color gradient in controller widget.
   * @return {*} Visual value.
   */ getControllerVisual: function(targetValue, visualCluster, opts) {
        opts = opts || {};
        var forceState = opts.forceState;
        var visualMapModel = this.visualMapModel;
        var visualObj = {}; // Default values.
        if (visualCluster === "symbol") visualObj.symbol = visualMapModel.get("itemSymbol");
        if (visualCluster === "color") {
            var defaultColor = visualMapModel.get("contentColor");
            visualObj.color = defaultColor;
        }
        function getter(key) {
            return visualObj[key];
        }
        function setter(key, value) {
            visualObj[key] = value;
        }
        var mappings = visualMapModel.controllerVisuals[forceState || visualMapModel.getValueState(targetValue)];
        var visualTypes = $72cc7afb3a2d7026$exports.prepareVisualTypes(mappings);
        $ec279652dd95c27b$export$79b2f7037acddd43(visualTypes, function(type) {
            var visualMapping = mappings[type];
            if (opts.convertOpacityToAlpha && type === "opacity") {
                type = "colorAlpha";
                visualMapping = mappings.__alphaForOpacity;
            }
            if ($72cc7afb3a2d7026$exports.dependsOn(type, visualCluster)) visualMapping && visualMapping.applyVisual(targetValue, getter, setter);
        });
        return visualObj[visualCluster];
    },
    /**
   * @protected
   */ positionGroup: function(group) {
        var model = this.visualMapModel;
        var api = this.api;
        $ab0c9086dd6c5b39$export$74054bd96b5eeef1(group, model.getBoxLayoutParams(), {
            width: api.getWidth(),
            height: api.getHeight()
        });
    },
    /**
   * @protected
   * @abstract
   */ doRender: $ec279652dd95c27b$export$8793edee2d425525
});
$823894306aa67fc9$exports = $823894306aa67fc9$var$_default;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $5223da44caf2fe65$export$dca53c4702e35c6;
var $5223da44caf2fe65$export$5381a9dc5427ba18;


var $5223da44caf2fe65$var$getLayoutRect = $ab0c9086dd6c5b39$export$4517a5ca639a7293;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @param {module:echarts/component/visualMap/VisualMapModel} visualMapModel\
 * @param {module:echarts/ExtensionAPI} api
 * @param {Array.<number>} itemSize always [short, long]
 * @return {string} 'left' or 'right' or 'top' or 'bottom'
 */ function $5223da44caf2fe65$var$getItemAlign(visualMapModel, api, itemSize) {
    var modelOption = visualMapModel.option;
    var itemAlign = modelOption.align;
    if (itemAlign != null && itemAlign !== "auto") return itemAlign;
     // Auto decision align.
    var ecSize = {
        width: api.getWidth(),
        height: api.getHeight()
    };
    var realIndex = modelOption.orient === "horizontal" ? 1 : 0;
    var paramsSet = [
        [
            "left",
            "right",
            "width"
        ],
        [
            "top",
            "bottom",
            "height"
        ]
    ];
    var reals = paramsSet[realIndex];
    var fakeValue = [
        0,
        null,
        10
    ];
    var layoutInput = {};
    for(var i = 0; i < 3; i++){
        layoutInput[paramsSet[1 - realIndex][i]] = fakeValue[i];
        layoutInput[reals[i]] = i === 2 ? itemSize[0] : modelOption[reals[i]];
    }
    var rParam = [
        [
            "x",
            "width",
            3
        ],
        [
            "y",
            "height",
            0
        ]
    ][realIndex];
    var rect = $5223da44caf2fe65$var$getLayoutRect(layoutInput, ecSize, modelOption.padding);
    return reals[(rect.margin[rParam[2]] || 0) + rect[rParam[0]] + rect[rParam[1]] * 0.5 < ecSize[rParam[1]] * 0.5 ? 0 : 1];
}
/**
 * Prepare dataIndex for outside usage, where dataIndex means rawIndex, and
 * dataIndexInside means filtered index.
 */ function $5223da44caf2fe65$var$makeHighDownBatch(batch, visualMapModel) {
    $ec279652dd95c27b$export$79b2f7037acddd43(batch || [], function(batchItem) {
        if (batchItem.dataIndex != null) {
            batchItem.dataIndexInside = batchItem.dataIndex;
            batchItem.dataIndex = null;
        }
        batchItem.highlightKey = "visualMap" + (visualMapModel ? visualMapModel.componentIndex : "");
    });
    return batch;
}
$5223da44caf2fe65$export$dca53c4702e35c6 = $5223da44caf2fe65$var$getItemAlign;
$5223da44caf2fe65$export$5381a9dc5427ba18 = $5223da44caf2fe65$var$makeHighDownBatch;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $9da1193b89b3ffbb$var$linearMap = $2d742dbe7f960d8c$export$d3f68fbaa670562;
var $9da1193b89b3ffbb$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
var $9da1193b89b3ffbb$var$mathMin = Math.min;
var $9da1193b89b3ffbb$var$mathMax = Math.max; // Arbitrary value
var $9da1193b89b3ffbb$var$HOVER_LINK_SIZE = 12;
var $9da1193b89b3ffbb$var$HOVER_LINK_OUT = 6; // Notice:
// Any "interval" should be by the order of [low, high].
// "handle0" (handleIndex === 0) maps to
// low data value: this._dataInterval[0] and has low coord.
// "handle1" (handleIndex === 1) maps to
// high data value: this._dataInterval[1] and has high coord.
// The logic of transform is implemented in this._createBarGroup.
var $9da1193b89b3ffbb$var$ContinuousView = $823894306aa67fc9$exports.extend({
    type: "visualMap.continuous",
    /**
   * @override
   */ init: function() {
        $9da1193b89b3ffbb$var$ContinuousView.superApply(this, "init", arguments);
        /**
     * @private
     */ this._shapes = {};
        /**
     * @private
     */ this._dataInterval = [];
        /**
     * @private
     */ this._handleEnds = [];
        /**
     * @private
     */ this._orient;
        /**
     * @private
     */ this._useHandle;
        /**
     * @private
     */ this._hoverLinkDataIndices = [];
        /**
     * @private
     */ this._dragging;
        /**
     * @private
     */ this._hovering;
    },
    /**
   * @protected
   * @override
   */ doRender: function(visualMapModel, ecModel, api, payload) {
        if (!payload || payload.type !== "selectDataRange" || payload.from !== this.uid) this._buildView();
    },
    /**
   * @private
   */ _buildView: function() {
        this.group.removeAll();
        var visualMapModel = this.visualMapModel;
        var thisGroup = this.group;
        this._orient = visualMapModel.get("orient");
        this._useHandle = visualMapModel.get("calculable");
        this._resetInterval();
        this._renderBar(thisGroup);
        var dataRangeText = visualMapModel.get("text");
        this._renderEndsText(thisGroup, dataRangeText, 0);
        this._renderEndsText(thisGroup, dataRangeText, 1); // Do this for background size calculation.
        this._updateView(true); // After updating view, inner shapes is built completely,
        // and then background can be rendered.
        this.renderBackground(thisGroup); // Real update view
        this._updateView();
        this._enableHoverLinkToSeries();
        this._enableHoverLinkFromSeries();
        this.positionGroup(thisGroup);
    },
    /**
   * @private
   */ _renderEndsText: function(group, dataRangeText, endsIndex) {
        if (!dataRangeText) return;
         // Compatible with ec2, text[0] map to high value, text[1] map low value.
        var text = dataRangeText[1 - endsIndex];
        text = text != null ? text + "" : "";
        var visualMapModel = this.visualMapModel;
        var textGap = visualMapModel.get("textGap");
        var itemSize = visualMapModel.itemSize;
        var barGroup = this._shapes.barGroup;
        var position = this._applyTransform([
            itemSize[0] / 2,
            endsIndex === 0 ? -textGap : itemSize[1] + textGap
        ], barGroup);
        var align = this._applyTransform(endsIndex === 0 ? "bottom" : "top", barGroup);
        var orient = this._orient;
        var textStyleModel = this.visualMapModel.textStyleModel;
        this.group.add(new $4b57d6b582d579b7$exports.Text({
            style: {
                x: position[0],
                y: position[1],
                textVerticalAlign: orient === "horizontal" ? "middle" : align,
                textAlign: orient === "horizontal" ? align : "center",
                text: text,
                textFont: textStyleModel.getFont(),
                textFill: textStyleModel.getTextColor()
            }
        }));
    },
    /**
   * @private
   */ _renderBar: function(targetGroup) {
        var visualMapModel = this.visualMapModel;
        var shapes = this._shapes;
        var itemSize = visualMapModel.itemSize;
        var orient = this._orient;
        var useHandle = this._useHandle;
        var itemAlign = $5223da44caf2fe65$export$dca53c4702e35c6(visualMapModel, this.api, itemSize);
        var barGroup = shapes.barGroup = this._createBarGroup(itemAlign); // Bar
        barGroup.add(shapes.outOfRange = $9da1193b89b3ffbb$var$createPolygon());
        barGroup.add(shapes.inRange = $9da1193b89b3ffbb$var$createPolygon(null, useHandle ? $9da1193b89b3ffbb$var$getCursor(this._orient) : null, $ec279652dd95c27b$export$2385a24977818dd0(this._dragHandle, this, "all", false), $ec279652dd95c27b$export$2385a24977818dd0(this._dragHandle, this, "all", true)));
        var textRect = visualMapModel.textStyleModel.getTextRect("\u56FD");
        var textSize = $9da1193b89b3ffbb$var$mathMax(textRect.width, textRect.height); // Handle
        if (useHandle) {
            shapes.handleThumbs = [];
            shapes.handleLabels = [];
            shapes.handleLabelPoints = [];
            this._createHandle(barGroup, 0, itemSize, textSize, orient, itemAlign);
            this._createHandle(barGroup, 1, itemSize, textSize, orient, itemAlign);
        }
        this._createIndicator(barGroup, itemSize, textSize, orient);
        targetGroup.add(barGroup);
    },
    /**
   * @private
   */ _createHandle: function(barGroup, handleIndex, itemSize, textSize, orient) {
        var onDrift = $ec279652dd95c27b$export$2385a24977818dd0(this._dragHandle, this, handleIndex, false);
        var onDragEnd = $ec279652dd95c27b$export$2385a24977818dd0(this._dragHandle, this, handleIndex, true);
        var handleThumb = $9da1193b89b3ffbb$var$createPolygon($9da1193b89b3ffbb$var$createHandlePoints(handleIndex, textSize), $9da1193b89b3ffbb$var$getCursor(this._orient), onDrift, onDragEnd);
        handleThumb.position[0] = itemSize[0];
        barGroup.add(handleThumb); // Text is always horizontal layout but should not be effected by
        // transform (orient/inverse). So label is built separately but not
        // use zrender/graphic/helper/RectText, and is located based on view
        // group (according to handleLabelPoint) but not barGroup.
        var textStyleModel = this.visualMapModel.textStyleModel;
        var handleLabel = new $4b57d6b582d579b7$exports.Text({
            draggable: true,
            drift: onDrift,
            onmousemove: function(e) {
                // Fot mobile devicem, prevent screen slider on the button.
                $adca58e5ac25631a$export$fa6813432f753b0d(e.event);
            },
            ondragend: onDragEnd,
            style: {
                x: 0,
                y: 0,
                text: "",
                textFont: textStyleModel.getFont(),
                textFill: textStyleModel.getTextColor()
            }
        });
        this.group.add(handleLabel);
        var handleLabelPoint = [
            orient === "horizontal" ? textSize / 2 : textSize * 1.5,
            orient === "horizontal" ? handleIndex === 0 ? -(textSize * 1.5) : textSize * 1.5 : handleIndex === 0 ? -textSize / 2 : textSize / 2
        ];
        var shapes = this._shapes;
        shapes.handleThumbs[handleIndex] = handleThumb;
        shapes.handleLabelPoints[handleIndex] = handleLabelPoint;
        shapes.handleLabels[handleIndex] = handleLabel;
    },
    /**
   * @private
   */ _createIndicator: function(barGroup, itemSize, textSize, orient) {
        var indicator = $9da1193b89b3ffbb$var$createPolygon([
            [
                0,
                0
            ]
        ], "move");
        indicator.position[0] = itemSize[0];
        indicator.attr({
            invisible: true,
            silent: true
        });
        barGroup.add(indicator);
        var textStyleModel = this.visualMapModel.textStyleModel;
        var indicatorLabel = new $4b57d6b582d579b7$exports.Text({
            silent: true,
            invisible: true,
            style: {
                x: 0,
                y: 0,
                text: "",
                textFont: textStyleModel.getFont(),
                textFill: textStyleModel.getTextColor()
            }
        });
        this.group.add(indicatorLabel);
        var indicatorLabelPoint = [
            orient === "horizontal" ? textSize / 2 : $9da1193b89b3ffbb$var$HOVER_LINK_OUT + 3,
            0
        ];
        var shapes = this._shapes;
        shapes.indicator = indicator;
        shapes.indicatorLabel = indicatorLabel;
        shapes.indicatorLabelPoint = indicatorLabelPoint;
    },
    /**
   * @private
   */ _dragHandle: function(handleIndex, isEnd, dx, dy) {
        if (!this._useHandle) return;
        this._dragging = !isEnd;
        if (!isEnd) {
            // Transform dx, dy to bar coordination.
            var vertex = this._applyTransform([
                dx,
                dy
            ], this._shapes.barGroup, true);
            this._updateInterval(handleIndex, vertex[1]); // Considering realtime, update view should be executed
            // before dispatch action.
            this._updateView();
        } // dragEnd do not dispatch action when realtime.
        if (isEnd === !this.visualMapModel.get("realtime")) // jshint ignore:line
        this.api.dispatchAction({
            type: "selectDataRange",
            from: this.uid,
            visualMapId: this.visualMapModel.id,
            selected: this._dataInterval.slice()
        });
        if (isEnd) !this._hovering && this._clearHoverLinkToSeries();
        else if ($9da1193b89b3ffbb$var$useHoverLinkOnHandle(this.visualMapModel)) this._doHoverLinkToSeries(this._handleEnds[handleIndex], false);
    },
    /**
   * @private
   */ _resetInterval: function() {
        var visualMapModel = this.visualMapModel;
        var dataInterval = this._dataInterval = visualMapModel.getSelected();
        var dataExtent = visualMapModel.getExtent();
        var sizeExtent = [
            0,
            visualMapModel.itemSize[1]
        ];
        this._handleEnds = [
            $9da1193b89b3ffbb$var$linearMap(dataInterval[0], dataExtent, sizeExtent, true),
            $9da1193b89b3ffbb$var$linearMap(dataInterval[1], dataExtent, sizeExtent, true)
        ];
    },
    /**
   * @private
   * @param {(number|string)} handleIndex 0 or 1 or 'all'
   * @param {number} dx
   * @param {number} dy
   */ _updateInterval: function(handleIndex, delta) {
        delta = delta || 0;
        var visualMapModel = this.visualMapModel;
        var handleEnds = this._handleEnds;
        var sizeExtent = [
            0,
            visualMapModel.itemSize[1]
        ];
        $1d1b44fc5f576d07$exports(delta, handleEnds, sizeExtent, handleIndex, 0);
        var dataExtent = visualMapModel.getExtent(); // Update data interval.
        this._dataInterval = [
            $9da1193b89b3ffbb$var$linearMap(handleEnds[0], sizeExtent, dataExtent, true),
            $9da1193b89b3ffbb$var$linearMap(handleEnds[1], sizeExtent, dataExtent, true)
        ];
    },
    /**
   * @private
   */ _updateView: function(forSketch) {
        var visualMapModel = this.visualMapModel;
        var dataExtent = visualMapModel.getExtent();
        var shapes = this._shapes;
        var outOfRangeHandleEnds = [
            0,
            visualMapModel.itemSize[1]
        ];
        var inRangeHandleEnds = forSketch ? outOfRangeHandleEnds : this._handleEnds;
        var visualInRange = this._createBarVisual(this._dataInterval, dataExtent, inRangeHandleEnds, "inRange");
        var visualOutOfRange = this._createBarVisual(dataExtent, dataExtent, outOfRangeHandleEnds, "outOfRange");
        shapes.inRange.setStyle({
            fill: visualInRange.barColor,
            opacity: visualInRange.opacity
        }).setShape("points", visualInRange.barPoints);
        shapes.outOfRange.setStyle({
            fill: visualOutOfRange.barColor,
            opacity: visualOutOfRange.opacity
        }).setShape("points", visualOutOfRange.barPoints);
        this._updateHandle(inRangeHandleEnds, visualInRange);
    },
    /**
   * @private
   */ _createBarVisual: function(dataInterval, dataExtent, handleEnds, forceState) {
        var opts = {
            forceState: forceState,
            convertOpacityToAlpha: true
        };
        var colorStops = this._makeColorGradient(dataInterval, opts);
        var symbolSizes = [
            this.getControllerVisual(dataInterval[0], "symbolSize", opts),
            this.getControllerVisual(dataInterval[1], "symbolSize", opts)
        ];
        var barPoints = this._createBarPoints(handleEnds, symbolSizes);
        return {
            barColor: new $2b8958ff0f4c4e26$exports(0, 0, 0, 1, colorStops),
            barPoints: barPoints,
            handlesColor: [
                colorStops[0].color,
                colorStops[colorStops.length - 1].color
            ]
        };
    },
    /**
   * @private
   */ _makeColorGradient: function(dataInterval, opts) {
        // Considering colorHue, which is not linear, so we have to sample
        // to calculate gradient color stops, but not only caculate head
        // and tail.
        var sampleNumber = 100; // Arbitrary value.
        var colorStops = [];
        var step = (dataInterval[1] - dataInterval[0]) / sampleNumber;
        colorStops.push({
            color: this.getControllerVisual(dataInterval[0], "color", opts),
            offset: 0
        });
        for(var i = 1; i < sampleNumber; i++){
            var currValue = dataInterval[0] + step * i;
            if (currValue > dataInterval[1]) break;
            colorStops.push({
                color: this.getControllerVisual(currValue, "color", opts),
                offset: i / sampleNumber
            });
        }
        colorStops.push({
            color: this.getControllerVisual(dataInterval[1], "color", opts),
            offset: 1
        });
        return colorStops;
    },
    /**
   * @private
   */ _createBarPoints: function(handleEnds, symbolSizes) {
        var itemSize = this.visualMapModel.itemSize;
        return [
            [
                itemSize[0] - symbolSizes[0],
                handleEnds[0]
            ],
            [
                itemSize[0],
                handleEnds[0]
            ],
            [
                itemSize[0],
                handleEnds[1]
            ],
            [
                itemSize[0] - symbolSizes[1],
                handleEnds[1]
            ]
        ];
    },
    /**
   * @private
   */ _createBarGroup: function(itemAlign) {
        var orient = this._orient;
        var inverse = this.visualMapModel.get("inverse");
        return new $4b57d6b582d579b7$exports.Group(orient === "horizontal" && !inverse ? {
            scale: itemAlign === "bottom" ? [
                1,
                1
            ] : [
                -1,
                1
            ],
            rotation: Math.PI / 2
        } : orient === "horizontal" && inverse ? {
            scale: itemAlign === "bottom" ? [
                -1,
                1
            ] : [
                1,
                1
            ],
            rotation: -Math.PI / 2
        } : orient === "vertical" && !inverse ? {
            scale: itemAlign === "left" ? [
                1,
                -1
            ] : [
                -1,
                -1
            ]
        } : {
            scale: itemAlign === "left" ? [
                1,
                1
            ] : [
                -1,
                1
            ]
        });
    },
    /**
   * @private
   */ _updateHandle: function(handleEnds, visualInRange) {
        if (!this._useHandle) return;
        var shapes = this._shapes;
        var visualMapModel = this.visualMapModel;
        var handleThumbs = shapes.handleThumbs;
        var handleLabels = shapes.handleLabels;
        $9da1193b89b3ffbb$var$each([
            0,
            1
        ], function(handleIndex) {
            var handleThumb = handleThumbs[handleIndex];
            handleThumb.setStyle("fill", visualInRange.handlesColor[handleIndex]);
            handleThumb.position[1] = handleEnds[handleIndex]; // Update handle label position.
            var textPoint = $4b57d6b582d579b7$exports.applyTransform(shapes.handleLabelPoints[handleIndex], $4b57d6b582d579b7$exports.getTransform(handleThumb, this.group));
            handleLabels[handleIndex].setStyle({
                x: textPoint[0],
                y: textPoint[1],
                text: visualMapModel.formatValueText(this._dataInterval[handleIndex]),
                textVerticalAlign: "middle",
                textAlign: this._applyTransform(this._orient === "horizontal" ? handleIndex === 0 ? "bottom" : "top" : "left", shapes.barGroup)
            });
        }, this);
    },
    /**
   * @private
   * @param {number} cursorValue
   * @param {number} textValue
   * @param {string} [rangeSymbol]
   * @param {number} [halfHoverLinkSize]
   */ _showIndicator: function(cursorValue, textValue, rangeSymbol, halfHoverLinkSize) {
        var visualMapModel = this.visualMapModel;
        var dataExtent = visualMapModel.getExtent();
        var itemSize = visualMapModel.itemSize;
        var sizeExtent = [
            0,
            itemSize[1]
        ];
        var pos = $9da1193b89b3ffbb$var$linearMap(cursorValue, dataExtent, sizeExtent, true);
        var shapes = this._shapes;
        var indicator = shapes.indicator;
        if (!indicator) return;
        indicator.position[1] = pos;
        indicator.attr("invisible", false);
        indicator.setShape("points", $9da1193b89b3ffbb$var$createIndicatorPoints(!!rangeSymbol, halfHoverLinkSize, pos, itemSize[1]));
        var opts = {
            convertOpacityToAlpha: true
        };
        var color = this.getControllerVisual(cursorValue, "color", opts);
        indicator.setStyle("fill", color); // Update handle label position.
        var textPoint = $4b57d6b582d579b7$exports.applyTransform(shapes.indicatorLabelPoint, $4b57d6b582d579b7$exports.getTransform(indicator, this.group));
        var indicatorLabel = shapes.indicatorLabel;
        indicatorLabel.attr("invisible", false);
        var align = this._applyTransform("left", shapes.barGroup);
        var orient = this._orient;
        indicatorLabel.setStyle({
            text: (rangeSymbol ? rangeSymbol : "") + visualMapModel.formatValueText(textValue),
            textVerticalAlign: orient === "horizontal" ? align : "middle",
            textAlign: orient === "horizontal" ? "center" : align,
            x: textPoint[0],
            y: textPoint[1]
        });
    },
    /**
   * @private
   */ _enableHoverLinkToSeries: function() {
        var self = this;
        this._shapes.barGroup.on("mousemove", function(e) {
            self._hovering = true;
            if (!self._dragging) {
                var itemSize = self.visualMapModel.itemSize;
                var pos = self._applyTransform([
                    e.offsetX,
                    e.offsetY
                ], self._shapes.barGroup, true, true); // For hover link show when hover handle, which might be
                // below or upper than sizeExtent.
                pos[1] = $9da1193b89b3ffbb$var$mathMin($9da1193b89b3ffbb$var$mathMax(0, pos[1]), itemSize[1]);
                self._doHoverLinkToSeries(pos[1], 0 <= pos[0] && pos[0] <= itemSize[0]);
            }
        }).on("mouseout", function() {
            // When mouse is out of handle, hoverLink still need
            // to be displayed when realtime is set as false.
            self._hovering = false;
            !self._dragging && self._clearHoverLinkToSeries();
        });
    },
    /**
   * @private
   */ _enableHoverLinkFromSeries: function() {
        var zr = this.api.getZr();
        if (this.visualMapModel.option.hoverLink) {
            zr.on("mouseover", this._hoverLinkFromSeriesMouseOver, this);
            zr.on("mouseout", this._hideIndicator, this);
        } else this._clearHoverLinkFromSeries();
    },
    /**
   * @private
   */ _doHoverLinkToSeries: function(cursorPos, hoverOnBar) {
        var visualMapModel = this.visualMapModel;
        var itemSize = visualMapModel.itemSize;
        if (!visualMapModel.option.hoverLink) return;
        var sizeExtent = [
            0,
            itemSize[1]
        ];
        var dataExtent = visualMapModel.getExtent(); // For hover link show when hover handle, which might be below or upper than sizeExtent.
        cursorPos = $9da1193b89b3ffbb$var$mathMin($9da1193b89b3ffbb$var$mathMax(sizeExtent[0], cursorPos), sizeExtent[1]);
        var halfHoverLinkSize = $9da1193b89b3ffbb$var$getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent);
        var hoverRange = [
            cursorPos - halfHoverLinkSize,
            cursorPos + halfHoverLinkSize
        ];
        var cursorValue = $9da1193b89b3ffbb$var$linearMap(cursorPos, sizeExtent, dataExtent, true);
        var valueRange = [
            $9da1193b89b3ffbb$var$linearMap(hoverRange[0], sizeExtent, dataExtent, true),
            $9da1193b89b3ffbb$var$linearMap(hoverRange[1], sizeExtent, dataExtent, true)
        ]; // Consider data range is out of visualMap range, see test/visualMap-continuous.html,
        // where china and india has very large population.
        hoverRange[0] < sizeExtent[0] && (valueRange[0] = -Infinity);
        hoverRange[1] > sizeExtent[1] && (valueRange[1] = Infinity); // Do not show indicator when mouse is over handle,
        // otherwise labels overlap, especially when dragging.
        if (hoverOnBar) {
            if (valueRange[0] === -Infinity) this._showIndicator(cursorValue, valueRange[1], "< ", halfHoverLinkSize);
            else if (valueRange[1] === Infinity) this._showIndicator(cursorValue, valueRange[0], "> ", halfHoverLinkSize);
            else this._showIndicator(cursorValue, cursorValue, "\u2248 ", halfHoverLinkSize);
        } // When realtime is set as false, handles, which are in barGroup,
        // also trigger hoverLink, which help user to realize where they
        // focus on when dragging. (see test/heatmap-large.html)
        // When realtime is set as true, highlight will not show when hover
        // handle, because the label on handle, which displays a exact value
        // but not range, might mislead users.
        var oldBatch = this._hoverLinkDataIndices;
        var newBatch = [];
        if (hoverOnBar || $9da1193b89b3ffbb$var$useHoverLinkOnHandle(visualMapModel)) newBatch = this._hoverLinkDataIndices = visualMapModel.findTargetDataIndices(valueRange);
        var resultBatches = $d559f43cb9041423$export$6d12cabb0c9bf8e3(oldBatch, newBatch);
        this._dispatchHighDown("downplay", $5223da44caf2fe65$export$5381a9dc5427ba18(resultBatches[0], visualMapModel));
        this._dispatchHighDown("highlight", $5223da44caf2fe65$export$5381a9dc5427ba18(resultBatches[1], visualMapModel));
    },
    /**
   * @private
   */ _hoverLinkFromSeriesMouseOver: function(e) {
        var el = e.target;
        var visualMapModel = this.visualMapModel;
        if (!el || el.dataIndex == null) return;
        var dataModel = this.ecModel.getSeriesByIndex(el.seriesIndex);
        if (!visualMapModel.isTargetSeries(dataModel)) return;
        var data = dataModel.getData(el.dataType);
        var value = data.get(visualMapModel.getDataDimension(data), el.dataIndex, true);
        if (!isNaN(value)) this._showIndicator(value, value);
    },
    /**
   * @private
   */ _hideIndicator: function() {
        var shapes = this._shapes;
        shapes.indicator && shapes.indicator.attr("invisible", true);
        shapes.indicatorLabel && shapes.indicatorLabel.attr("invisible", true);
    },
    /**
   * @private
   */ _clearHoverLinkToSeries: function() {
        this._hideIndicator();
        var indices = this._hoverLinkDataIndices;
        this._dispatchHighDown("downplay", $5223da44caf2fe65$export$5381a9dc5427ba18(indices, this.visualMapModel));
        indices.length = 0;
    },
    /**
   * @private
   */ _clearHoverLinkFromSeries: function() {
        this._hideIndicator();
        var zr = this.api.getZr();
        zr.off("mouseover", this._hoverLinkFromSeriesMouseOver);
        zr.off("mouseout", this._hideIndicator);
    },
    /**
   * @private
   */ _applyTransform: function(vertex, element, inverse, global) {
        var transform = $4b57d6b582d579b7$exports.getTransform(element, global ? null : this.group);
        return $4b57d6b582d579b7$exports[$ec279652dd95c27b$export$43bee75e5e14138e(vertex) ? "applyTransform" : "transformDirection"](vertex, transform, inverse);
    },
    /**
   * @private
   */ _dispatchHighDown: function(type, batch) {
        batch && batch.length && this.api.dispatchAction({
            type: type,
            batch: batch
        });
    },
    /**
   * @override
   */ dispose: function() {
        this._clearHoverLinkFromSeries();
        this._clearHoverLinkToSeries();
    },
    /**
   * @override
   */ remove: function() {
        this._clearHoverLinkFromSeries();
        this._clearHoverLinkToSeries();
    }
});
function $9da1193b89b3ffbb$var$createPolygon(points, cursor, onDrift, onDragEnd) {
    return new $4b57d6b582d579b7$exports.Polygon({
        shape: {
            points: points
        },
        draggable: !!onDrift,
        cursor: cursor,
        drift: onDrift,
        onmousemove: function(e) {
            // Fot mobile devicem, prevent screen slider on the button.
            $adca58e5ac25631a$export$fa6813432f753b0d(e.event);
        },
        ondragend: onDragEnd
    });
}
function $9da1193b89b3ffbb$var$createHandlePoints(handleIndex, textSize) {
    return handleIndex === 0 ? [
        [
            0,
            0
        ],
        [
            textSize,
            0
        ],
        [
            textSize,
            -textSize
        ]
    ] : [
        [
            0,
            0
        ],
        [
            textSize,
            0
        ],
        [
            textSize,
            textSize
        ]
    ];
}
function $9da1193b89b3ffbb$var$createIndicatorPoints(isRange, halfHoverLinkSize, pos, extentMax) {
    return isRange ? [
        [
            0,
            -$9da1193b89b3ffbb$var$mathMin(halfHoverLinkSize, $9da1193b89b3ffbb$var$mathMax(pos, 0))
        ],
        [
            $9da1193b89b3ffbb$var$HOVER_LINK_OUT,
            0
        ],
        [
            0,
            $9da1193b89b3ffbb$var$mathMin(halfHoverLinkSize, $9da1193b89b3ffbb$var$mathMax(extentMax - pos, 0))
        ]
    ] : [
        [
            0,
            0
        ],
        [
            5,
            -5
        ],
        [
            5,
            5
        ]
    ];
}
function $9da1193b89b3ffbb$var$getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent) {
    var halfHoverLinkSize = $9da1193b89b3ffbb$var$HOVER_LINK_SIZE / 2;
    var hoverLinkDataSize = visualMapModel.get("hoverLinkDataSize");
    if (hoverLinkDataSize) halfHoverLinkSize = $9da1193b89b3ffbb$var$linearMap(hoverLinkDataSize, dataExtent, sizeExtent, true) / 2;
    return halfHoverLinkSize;
}
function $9da1193b89b3ffbb$var$useHoverLinkOnHandle(visualMapModel) {
    var hoverLinkOnHandle = visualMapModel.get("hoverLinkOnHandle");
    return !!(hoverLinkOnHandle == null ? visualMapModel.get("realtime") : hoverLinkOnHandle);
}
function $9da1193b89b3ffbb$var$getCursor(orient) {
    return orient === "vertical" ? "ns-resize" : "ew-resize";
}
var $9da1193b89b3ffbb$var$_default = $9da1193b89b3ffbb$var$ContinuousView;
$9da1193b89b3ffbb$exports = $9da1193b89b3ffbb$var$_default;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $04474502adb779b3$var$actionInfo = {
    type: "selectDataRange",
    event: "dataRangeSelected",
    // FIXME use updateView appears wrong
    update: "update"
};
$f406636b535430a7$exports.registerAction($04474502adb779b3$var$actionInfo, function(payload, ecModel) {
    ecModel.eachComponent({
        mainType: "visualMap",
        query: payload
    }, function(model) {
        model.setSelected(payload.selected);
    });
});


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * DataZoom component entry
 */ $f406636b535430a7$exports.registerPreprocessor($0a0c8397cd877127$exports);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $0aadb5c2f3cd9f13$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $0aadb5c2f3cd9f13$var$__DEV__ = $f06357f91478219a$export$a866f231438cc228;





var $0aadb5c2f3cd9f13$var$reformIntervals = $2d742dbe7f960d8c$export$12f7386070bc380a;
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $0aadb5c2f3cd9f13$var$PiecewiseModel = $e0a90a30cc6b290f$exports.extend({
    type: "visualMap.piecewise",
    /**
   * Order Rule:
   *
   * option.categories / option.pieces / option.text / option.selected:
   *     If !option.inverse,
   *     Order when vertical: ['top', ..., 'bottom'].
   *     Order when horizontal: ['left', ..., 'right'].
   *     If option.inverse, the meaning of
   *     the order should be reversed.
   *
   * this._pieceList:
   *     The order is always [low, ..., high].
   *
   * Mapping from location to low-high:
   *     If !option.inverse
   *     When vertical, top is high.
   *     When horizontal, right is high.
   *     If option.inverse, reverse.
   */ /**
   * @protected
   */ defaultOption: {
        selected: null,
        // Object. If not specified, means selected.
        // When pieces and splitNumber: {'0': true, '5': true}
        // When categories: {'cate1': false, 'cate3': true}
        // When selected === false, means all unselected.
        minOpen: false,
        // Whether include values that smaller than `min`.
        maxOpen: false,
        // Whether include values that bigger than `max`.
        align: "auto",
        // 'auto', 'left', 'right'
        itemWidth: 20,
        // When put the controller vertically, it is the length of
        // horizontal side of each item. Otherwise, vertical side.
        itemHeight: 14,
        // When put the controller vertically, it is the length of
        // vertical side of each item. Otherwise, horizontal side.
        itemSymbol: "roundRect",
        pieceList: null,
        // Each item is Object, with some of those attrs:
        // {min, max, lt, gt, lte, gte, value,
        // color, colorSaturation, colorAlpha, opacity,
        // symbol, symbolSize}, which customize the range or visual
        // coding of the certain piece. Besides, see "Order Rule".
        categories: null,
        // category names, like: ['some1', 'some2', 'some3'].
        // Attr min/max are ignored when categories set. See "Order Rule"
        splitNumber: 5,
        // If set to 5, auto split five pieces equally.
        // If set to 0 and component type not set, component type will be
        // determined as "continuous". (It is less reasonable but for ec2
        // compatibility, see echarts/component/visualMap/typeDefaulter)
        selectedMode: "multiple",
        // Can be 'multiple' or 'single'.
        itemGap: 10,
        // The gap between two items, in px.
        hoverLink: true,
        // Enable hover highlight.
        showLabel: null // By default, when text is used, label will hide (the logic
    },
    /**
   * @override
   */ optionUpdated: function(newOption, isInit) {
        $0aadb5c2f3cd9f13$var$PiecewiseModel.superApply(this, "optionUpdated", arguments);
        /**
     * The order is always [low, ..., high].
     * [{text: string, interval: Array.<number>}, ...]
     * @private
     * @type {Array.<Object>}
     */ this._pieceList = [];
        this.resetExtent();
        /**
     * 'pieces', 'categories', 'splitNumber'
     * @type {string}
     */ var mode = this._mode = this._determineMode();
        $0aadb5c2f3cd9f13$var$resetMethods[this._mode].call(this);
        this._resetSelected(newOption, isInit);
        var categories = this.option.categories;
        this.resetVisual(function(mappingOption, state) {
            if (mode === "categories") {
                mappingOption.mappingMethod = "category";
                mappingOption.categories = $ec279652dd95c27b$export$9cd59f9826255e47(categories);
            } else {
                mappingOption.dataExtent = this.getExtent();
                mappingOption.mappingMethod = "piecewise";
                mappingOption.pieceList = $ec279652dd95c27b$export$871de8747c9eaa88(this._pieceList, function(piece) {
                    var piece = $ec279652dd95c27b$export$9cd59f9826255e47(piece);
                    if (state !== "inRange") // FIXME
                    // outOfRange do not support special visual in pieces.
                    piece.visual = null;
                    return piece;
                });
            }
        });
    },
    /**
   * @protected
   * @override
   */ completeVisualOption: function() {
        // Consider this case:
        // visualMap: {
        //      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
        // }
        // where no inRange/outOfRange set but only pieces. So we should make
        // default inRange/outOfRange for this case, otherwise visuals that only
        // appear in `pieces` will not be taken into account in visual encoding.
        var option = this.option;
        var visualTypesInPieces = {};
        var visualTypes = $72cc7afb3a2d7026$exports.listVisualTypes();
        var isCategory = this.isCategory();
        $ec279652dd95c27b$export$79b2f7037acddd43(option.pieces, function(piece) {
            $ec279652dd95c27b$export$79b2f7037acddd43(visualTypes, function(visualType) {
                if (piece.hasOwnProperty(visualType)) visualTypesInPieces[visualType] = 1;
            });
        });
        $ec279652dd95c27b$export$79b2f7037acddd43(visualTypesInPieces, function(v, visualType) {
            var exists = 0;
            $ec279652dd95c27b$export$79b2f7037acddd43(this.stateList, function(state) {
                exists |= has(option, state, visualType) || has(option.target, state, visualType);
            }, this);
            !exists && $ec279652dd95c27b$export$79b2f7037acddd43(this.stateList, function(state) {
                (option[state] || (option[state] = {}))[visualType] = $71f23b5f15c222ae$exports.get(visualType, state === "inRange" ? "active" : "inactive", isCategory);
            });
        }, this);
        function has(obj, state, visualType) {
            return obj && obj[state] && ($ec279652dd95c27b$export$a6cdc56e425d0d0a(obj[state]) ? obj[state].hasOwnProperty(visualType) : obj[state] === visualType // e.g., inRange: 'symbol'
            );
        }
        $e0a90a30cc6b290f$exports.prototype.completeVisualOption.apply(this, arguments);
    },
    _resetSelected: function(newOption, isInit) {
        var thisOption = this.option;
        var pieceList = this._pieceList; // Selected do not merge but all override.
        var selected = (isInit ? thisOption : newOption).selected || {};
        thisOption.selected = selected; // Consider 'not specified' means true.
        $ec279652dd95c27b$export$79b2f7037acddd43(pieceList, function(piece, index) {
            var key = this.getSelectedMapKey(piece);
            if (!selected.hasOwnProperty(key)) selected[key] = true;
        }, this);
        if (thisOption.selectedMode === "single") {
            // Ensure there is only one selected.
            var hasSel = false;
            $ec279652dd95c27b$export$79b2f7037acddd43(pieceList, function(piece, index) {
                var key = this.getSelectedMapKey(piece);
                if (selected[key]) hasSel ? selected[key] = false : hasSel = true;
            }, this);
        } // thisOption.selectedMode === 'multiple', default: all selected.
    },
    /**
   * @public
   */ getSelectedMapKey: function(piece) {
        return this._mode === "categories" ? piece.value + "" : piece.index + "";
    },
    /**
   * @public
   */ getPieceList: function() {
        return this._pieceList;
    },
    /**
   * @private
   * @return {string}
   */ _determineMode: function() {
        var option = this.option;
        return option.pieces && option.pieces.length > 0 ? "pieces" : this.option.categories ? "categories" : "splitNumber";
    },
    /**
   * @public
   * @override
   */ setSelected: function(selected) {
        this.option.selected = $ec279652dd95c27b$export$9cd59f9826255e47(selected);
    },
    /**
   * @public
   * @override
   */ getValueState: function(value) {
        var index = $72cc7afb3a2d7026$exports.findPieceIndex(value, this._pieceList);
        return index != null ? this.option.selected[this.getSelectedMapKey(this._pieceList[index])] ? "inRange" : "outOfRange" : "outOfRange";
    },
    /**
   * @public
   * @params {number} pieceIndex piece index in visualMapModel.getPieceList()
   * @return {Array.<Object>} [{seriesId, dataIndex: <Array.<number>>}, ...]
   */ findTargetDataIndices: function(pieceIndex) {
        var result = [];
        this.eachTargetSeries(function(seriesModel) {
            var dataIndices = [];
            var data = seriesModel.getData();
            data.each(this.getDataDimension(data), function(value, dataIndex) {
                // Should always base on model pieceList, because it is order sensitive.
                var pIdx = $72cc7afb3a2d7026$exports.findPieceIndex(value, this._pieceList);
                pIdx === pieceIndex && dataIndices.push(dataIndex);
            }, this);
            result.push({
                seriesId: seriesModel.id,
                dataIndex: dataIndices
            });
        }, this);
        return result;
    },
    /**
   * @private
   * @param {Object} piece piece.value or piece.interval is required.
   * @return {number} Can be Infinity or -Infinity
   */ getRepresentValue: function(piece) {
        var representValue;
        if (this.isCategory()) representValue = piece.value;
        else if (piece.value != null) representValue = piece.value;
        else {
            var pieceInterval = piece.interval || [];
            representValue = pieceInterval[0] === -Infinity && pieceInterval[1] === Infinity ? 0 : (pieceInterval[0] + pieceInterval[1]) / 2;
        }
        return representValue;
    },
    getVisualMeta: function(getColorVisual) {
        // Do not support category. (category axis is ordinal, numerical)
        if (this.isCategory()) return;
        var stops = [];
        var outerColors = [];
        var visualMapModel = this;
        function setStop(interval, valueState) {
            var representValue = visualMapModel.getRepresentValue({
                interval: interval
            });
            if (!valueState) valueState = visualMapModel.getValueState(representValue);
            var color = getColorVisual(representValue, valueState);
            if (interval[0] === -Infinity) outerColors[0] = color;
            else if (interval[1] === Infinity) outerColors[1] = color;
            else stops.push({
                value: interval[0],
                color: color
            }, {
                value: interval[1],
                color: color
            });
        } // Suplement
        var pieceList = this._pieceList.slice();
        if (!pieceList.length) pieceList.push({
            interval: [
                -Infinity,
                Infinity
            ]
        });
        else {
            var edge = pieceList[0].interval[0];
            edge !== -Infinity && pieceList.unshift({
                interval: [
                    -Infinity,
                    edge
                ]
            });
            edge = pieceList[pieceList.length - 1].interval[1];
            edge !== Infinity && pieceList.push({
                interval: [
                    edge,
                    Infinity
                ]
            });
        }
        var curr = -Infinity;
        $ec279652dd95c27b$export$79b2f7037acddd43(pieceList, function(piece) {
            var interval = piece.interval;
            if (interval) {
                // Fulfill gap.
                interval[0] > curr && setStop([
                    curr,
                    interval[0]
                ], "outOfRange");
                setStop(interval.slice());
                curr = interval[1];
            }
        }, this);
        return {
            stops: stops,
            outerColors: outerColors
        };
    }
});
/**
 * Key is this._mode
 * @type {Object}
 * @this {module:echarts/component/viusalMap/PiecewiseMode}
 */ var $0aadb5c2f3cd9f13$var$resetMethods = {
    splitNumber: function() {
        var thisOption = this.option;
        var pieceList = this._pieceList;
        var precision = Math.min(thisOption.precision, 20);
        var dataExtent = this.getExtent();
        var splitNumber = thisOption.splitNumber;
        splitNumber = Math.max(parseInt(splitNumber, 10), 1);
        thisOption.splitNumber = splitNumber;
        var splitStep = (dataExtent[1] - dataExtent[0]) / splitNumber; // Precision auto-adaption
        while(+splitStep.toFixed(precision) !== splitStep && precision < 5)precision++;
        thisOption.precision = precision;
        splitStep = +splitStep.toFixed(precision);
        if (thisOption.minOpen) pieceList.push({
            interval: [
                -Infinity,
                dataExtent[0]
            ],
            close: [
                0,
                0
            ]
        });
        for(var index = 0, curr = dataExtent[0]; index < splitNumber; curr += splitStep, index++){
            var max = index === splitNumber - 1 ? dataExtent[1] : curr + splitStep;
            pieceList.push({
                interval: [
                    curr,
                    max
                ],
                close: [
                    1,
                    1
                ]
            });
        }
        if (thisOption.maxOpen) pieceList.push({
            interval: [
                dataExtent[1],
                Infinity
            ],
            close: [
                0,
                0
            ]
        });
        $0aadb5c2f3cd9f13$var$reformIntervals(pieceList);
        $ec279652dd95c27b$export$79b2f7037acddd43(pieceList, function(piece, index) {
            piece.index = index;
            piece.text = this.formatValueText(piece.interval);
        }, this);
    },
    categories: function() {
        var thisOption = this.option;
        $ec279652dd95c27b$export$79b2f7037acddd43(thisOption.categories, function(cate) {
            // FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
            // 是否改一致。
            this._pieceList.push({
                text: this.formatValueText(cate, true),
                value: cate
            });
        }, this); // See "Order Rule".
        $0aadb5c2f3cd9f13$var$normalizeReverse(thisOption, this._pieceList);
    },
    pieces: function() {
        var thisOption = this.option;
        var pieceList = this._pieceList;
        $ec279652dd95c27b$export$79b2f7037acddd43(thisOption.pieces, function(pieceListItem, index) {
            if (!$ec279652dd95c27b$export$a6cdc56e425d0d0a(pieceListItem)) pieceListItem = {
                value: pieceListItem
            };
            var item = {
                text: "",
                index: index
            };
            if (pieceListItem.label != null) item.text = pieceListItem.label;
            if (pieceListItem.hasOwnProperty("value")) {
                var value = item.value = pieceListItem.value;
                item.interval = [
                    value,
                    value
                ];
                item.close = [
                    1,
                    1
                ];
            } else {
                // `min` `max` is legacy option.
                // `lt` `gt` `lte` `gte` is recommanded.
                var interval = item.interval = [];
                var close = item.close = [
                    0,
                    0
                ];
                var closeList = [
                    1,
                    0,
                    1
                ];
                var infinityList = [
                    -Infinity,
                    Infinity
                ];
                var useMinMax = [];
                for(var lg = 0; lg < 2; lg++){
                    var names = [
                        [
                            "gte",
                            "gt",
                            "min"
                        ],
                        [
                            "lte",
                            "lt",
                            "max"
                        ]
                    ][lg];
                    for(var i = 0; i < 3 && interval[lg] == null; i++){
                        interval[lg] = pieceListItem[names[i]];
                        close[lg] = closeList[i];
                        useMinMax[lg] = i === 2;
                    }
                    interval[lg] == null && (interval[lg] = infinityList[lg]);
                }
                useMinMax[0] && interval[1] === Infinity && (close[0] = 0);
                useMinMax[1] && interval[0] === -Infinity && (close[1] = 0);
                if (interval[0] === interval[1] && close[0] && close[1]) // Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
                // we use value to lift the priority when min === max
                item.value = interval[0];
            }
            item.visual = $72cc7afb3a2d7026$exports.retrieveVisuals(pieceListItem);
            pieceList.push(item);
        }, this); // See "Order Rule".
        $0aadb5c2f3cd9f13$var$normalizeReverse(thisOption, pieceList); // Only pieces
        $0aadb5c2f3cd9f13$var$reformIntervals(pieceList);
        $ec279652dd95c27b$export$79b2f7037acddd43(pieceList, function(piece) {
            var close = piece.close;
            var edgeSymbols = [
                [
                    "<",
                    "\u2264"
                ][close[1]],
                [
                    ">",
                    "\u2265"
                ][close[0]]
            ];
            piece.text = piece.text || this.formatValueText(piece.value != null ? piece.value : piece.interval, false, edgeSymbols);
        }, this);
    }
};
function $0aadb5c2f3cd9f13$var$normalizeReverse(thisOption, pieceList) {
    var inverse = thisOption.inverse;
    if (thisOption.orient === "vertical" ? !inverse : inverse) pieceList.reverse();
}
var $0aadb5c2f3cd9f13$var$_default = $0aadb5c2f3cd9f13$var$PiecewiseModel;
$0aadb5c2f3cd9f13$exports = $0aadb5c2f3cd9f13$var$_default;


var $de76474da67893d8$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $de76474da67893d8$var$createSymbol = $804dcb9a0b78b5fe$export$af050e04da3a02e8;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $de76474da67893d8$var$PiecewiseVisualMapView = $823894306aa67fc9$exports.extend({
    type: "visualMap.piecewise",
    /**
   * @protected
   * @override
   */ doRender: function() {
        var thisGroup = this.group;
        thisGroup.removeAll();
        var visualMapModel = this.visualMapModel;
        var textGap = visualMapModel.get("textGap");
        var textStyleModel = visualMapModel.textStyleModel;
        var textFont = textStyleModel.getFont();
        var textFill = textStyleModel.getTextColor();
        var itemAlign = this._getItemAlign();
        var itemSize = visualMapModel.itemSize;
        var viewData = this._getViewData();
        var endsText = viewData.endsText;
        var showLabel = $ec279652dd95c27b$export$8a4d17b6e8486e66(visualMapModel.get("showLabel", true), !endsText);
        endsText && this._renderEndsText(thisGroup, endsText[0], itemSize, showLabel, itemAlign);
        $ec279652dd95c27b$export$79b2f7037acddd43(viewData.viewPieceList, renderItem, this);
        endsText && this._renderEndsText(thisGroup, endsText[1], itemSize, showLabel, itemAlign);
        $ab0c9086dd6c5b39$export$827f4ee28efc37(visualMapModel.get("orient"), thisGroup, visualMapModel.get("itemGap"));
        this.renderBackground(thisGroup);
        this.positionGroup(thisGroup);
        function renderItem(item) {
            var piece = item.piece;
            var itemGroup = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
            itemGroup.onclick = $ec279652dd95c27b$export$2385a24977818dd0(this._onItemClick, this, piece);
            this._enableHoverLink(itemGroup, item.indexInModelPieceList);
            var representValue = visualMapModel.getRepresentValue(piece);
            this._createItemSymbol(itemGroup, representValue, [
                0,
                0,
                itemSize[0],
                itemSize[1]
            ]);
            if (showLabel) {
                var visualState = this.visualMapModel.getValueState(representValue);
                itemGroup.add(new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
                    style: {
                        x: itemAlign === "right" ? -textGap : itemSize[0] + textGap,
                        y: itemSize[1] / 2,
                        text: piece.text,
                        textVerticalAlign: "middle",
                        textAlign: itemAlign,
                        textFont: textFont,
                        textFill: textFill,
                        opacity: visualState === "outOfRange" ? 0.5 : 1
                    }
                }));
            }
            thisGroup.add(itemGroup);
        }
    },
    /**
   * @private
   */ _enableHoverLink: function(itemGroup, pieceIndex) {
        itemGroup.on("mouseover", $ec279652dd95c27b$export$2385a24977818dd0(onHoverLink, this, "highlight")).on("mouseout", $ec279652dd95c27b$export$2385a24977818dd0(onHoverLink, this, "downplay"));
        function onHoverLink(method) {
            var visualMapModel = this.visualMapModel;
            visualMapModel.option.hoverLink && this.api.dispatchAction({
                type: method,
                batch: $5223da44caf2fe65$export$5381a9dc5427ba18(visualMapModel.findTargetDataIndices(pieceIndex), visualMapModel)
            });
        }
    },
    /**
   * @private
   */ _getItemAlign: function() {
        var visualMapModel = this.visualMapModel;
        var modelOption = visualMapModel.option;
        if (modelOption.orient === "vertical") return $5223da44caf2fe65$export$dca53c4702e35c6(visualMapModel, this.api, visualMapModel.itemSize);
        else {
            // horizontal, most case left unless specifying right.
            var align = modelOption.align;
            if (!align || align === "auto") align = "left";
            return align;
        }
    },
    /**
   * @private
   */ _renderEndsText: function(group, text, itemSize, showLabel, itemAlign) {
        if (!text) return;
        var itemGroup = new $4b57d6b582d579b7$export$eb2fcfdbd7ba97d4();
        var textStyleModel = this.visualMapModel.textStyleModel;
        itemGroup.add(new $4b57d6b582d579b7$export$5f1af8db9871e1d6({
            style: {
                x: showLabel ? itemAlign === "right" ? itemSize[0] : 0 : itemSize[0] / 2,
                y: itemSize[1] / 2,
                textVerticalAlign: "middle",
                textAlign: showLabel ? itemAlign : "center",
                text: text,
                textFont: textStyleModel.getFont(),
                textFill: textStyleModel.getTextColor()
            }
        }));
        group.add(itemGroup);
    },
    /**
   * @private
   * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
   */ _getViewData: function() {
        var visualMapModel = this.visualMapModel;
        var viewPieceList = $ec279652dd95c27b$export$871de8747c9eaa88(visualMapModel.getPieceList(), function(piece, index) {
            return {
                piece: piece,
                indexInModelPieceList: index
            };
        });
        var endsText = visualMapModel.get("text"); // Consider orient and inverse.
        var orient = visualMapModel.get("orient");
        var inverse = visualMapModel.get("inverse"); // Order of model pieceList is always [low, ..., high]
        if (orient === "horizontal" ? inverse : !inverse) viewPieceList.reverse();
        else if (endsText) endsText = endsText.slice().reverse();
        return {
            viewPieceList: viewPieceList,
            endsText: endsText
        };
    },
    /**
   * @private
   */ _createItemSymbol: function(group, representValue, shapeParam) {
        group.add($de76474da67893d8$var$createSymbol(this.getControllerVisual(representValue, "symbol"), shapeParam[0], shapeParam[1], shapeParam[2], shapeParam[3], this.getControllerVisual(representValue, "color")));
    },
    /**
   * @private
   */ _onItemClick: function(piece) {
        var visualMapModel = this.visualMapModel;
        var option = visualMapModel.option;
        var selected = $ec279652dd95c27b$export$9cd59f9826255e47(option.selected);
        var newKey = visualMapModel.getSelectedMapKey(piece);
        if (option.selectedMode === "single") {
            selected[newKey] = true;
            $ec279652dd95c27b$export$79b2f7037acddd43(selected, function(o, key) {
                selected[key] = key === newKey;
            });
        } else selected[newKey] = !selected[newKey];
        this.api.dispatchAction({
            type: "selectDataRange",
            from: this.uid,
            visualMapId: this.visualMapModel.id,
            selected: selected
        });
    }
});
var $de76474da67893d8$var$_default = $de76474da67893d8$var$PiecewiseVisualMapView;
$de76474da67893d8$exports = $de76474da67893d8$var$_default;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * DataZoom component entry
 */ $f406636b535430a7$exports.registerPreprocessor($0a0c8397cd877127$exports);








var $a4fb891c706c1187$var$applyTransform = $9eb63d101f3bcd79$export$9f9dcb98c894b623;











var $e20cbd3597409037$export$2a111da947c407d2;
var $e20cbd3597409037$export$270e7ba5936d3c48;
var $e20cbd3597409037$export$df5ad88089fbec49;

var $e20cbd3597409037$var$urn = "urn:schemas-microsoft-com:vml";
var $e20cbd3597409037$var$win = typeof window === "undefined" ? null : window;
var $e20cbd3597409037$var$vmlInited = false;
var $e20cbd3597409037$var$doc = $e20cbd3597409037$var$win && $e20cbd3597409037$var$win.document;
function $e20cbd3597409037$var$createNode(tagName) {
    return $e20cbd3597409037$var$doCreateNode(tagName);
} // Avoid assign to an exported variable, for transforming to cjs.
var $e20cbd3597409037$var$doCreateNode;
if ($e20cbd3597409037$var$doc && !$27ac1413ecc67076$exports.canvasSupported) try {
    !$e20cbd3597409037$var$doc.namespaces.zrvml && $e20cbd3597409037$var$doc.namespaces.add("zrvml", $e20cbd3597409037$var$urn);
    $e20cbd3597409037$var$doCreateNode = function(tagName) {
        return $e20cbd3597409037$var$doc.createElement("<zrvml:" + tagName + ' class="zrvml">');
    };
} catch (e) {
    $e20cbd3597409037$var$doCreateNode = function(tagName) {
        return $e20cbd3597409037$var$doc.createElement("<" + tagName + ' xmlns="' + $e20cbd3597409037$var$urn + '" class="zrvml">');
    };
}
 // From raphael
function $e20cbd3597409037$var$initVML() {
    if ($e20cbd3597409037$var$vmlInited || !$e20cbd3597409037$var$doc) return;
    $e20cbd3597409037$var$vmlInited = true;
    var styleSheets = $e20cbd3597409037$var$doc.styleSheets;
    if (styleSheets.length < 31) $e20cbd3597409037$var$doc.createStyleSheet().addRule(".zrvml", "behavior:url(#default#VML)");
    else // http://msdn.microsoft.com/en-us/library/ms531194%28VS.85%29.aspx
    styleSheets[0].addRule(".zrvml", "behavior:url(#default#VML)");
}
$e20cbd3597409037$export$2a111da947c407d2 = $e20cbd3597409037$var$doc;
$e20cbd3597409037$export$270e7ba5936d3c48 = $e20cbd3597409037$var$createNode;
$e20cbd3597409037$export$df5ad88089fbec49 = $e20cbd3597409037$var$initVML;


// http://www.w3.org/TR/NOTE-VML
// TODO Use proxy like svg instead of overwrite brush methods
var $a4fb891c706c1187$var$CMD = $4c785e18473c2aa4$exports.CMD;
var $a4fb891c706c1187$var$round = Math.round;
var $a4fb891c706c1187$var$sqrt = Math.sqrt;
var $a4fb891c706c1187$var$abs = Math.abs;
var $a4fb891c706c1187$var$cos = Math.cos;
var $a4fb891c706c1187$var$sin = Math.sin;
var $a4fb891c706c1187$var$mathMax = Math.max;
if (!$27ac1413ecc67076$exports.canvasSupported) {
    var $a4fb891c706c1187$var$comma = ",";
    var $a4fb891c706c1187$var$imageTransformPrefix = "progid:DXImageTransform.Microsoft";
    var $a4fb891c706c1187$var$Z = 21600;
    var $a4fb891c706c1187$var$Z2 = $a4fb891c706c1187$var$Z / 2;
    var $a4fb891c706c1187$var$ZLEVEL_BASE = 100000;
    var $a4fb891c706c1187$var$Z_BASE = 1000;
    var $a4fb891c706c1187$var$initRootElStyle = function(el) {
        el.style.cssText = "position:absolute;left:0;top:0;width:1px;height:1px;";
        el.coordsize = $a4fb891c706c1187$var$Z + "," + $a4fb891c706c1187$var$Z;
        el.coordorigin = "0,0";
    };
    var $a4fb891c706c1187$var$encodeHtmlAttribute = function(s) {
        return String(s).replace(/&/g, "&amp;").replace(/"/g, "&quot;");
    };
    var $a4fb891c706c1187$var$rgb2Str = function(r, g, b) {
        return "rgb(" + [
            r,
            g,
            b
        ].join(",") + ")";
    };
    var $a4fb891c706c1187$var$append = function(parent, child) {
        if (child && parent && child.parentNode !== parent) parent.appendChild(child);
    };
    var $a4fb891c706c1187$var$remove = function(parent, child) {
        if (child && parent && child.parentNode === parent) parent.removeChild(child);
    };
    var $a4fb891c706c1187$var$getZIndex = function(zlevel, z, z2) {
        // z 的取值范围为 [0, 1000]
        return (parseFloat(zlevel) || 0) * $a4fb891c706c1187$var$ZLEVEL_BASE + (parseFloat(z) || 0) * $a4fb891c706c1187$var$Z_BASE + z2;
    };
    var $a4fb891c706c1187$var$parsePercent = $5b0ace94e7e58ea5$export$e8514cb5a5e2b40f;
    /***************************************************
   * PATH
   **************************************************/ var $a4fb891c706c1187$var$setColorAndOpacity = function(el, color, opacity) {
        var colorArr = $b1179c91b052e827$export$98e6a39c04603d36(color);
        opacity = +opacity;
        if (isNaN(opacity)) opacity = 1;
        if (colorArr) {
            el.color = $a4fb891c706c1187$var$rgb2Str(colorArr[0], colorArr[1], colorArr[2]);
            el.opacity = opacity * colorArr[3];
        }
    };
    var $a4fb891c706c1187$var$getColorAndAlpha = function(color) {
        var colorArr = $b1179c91b052e827$export$98e6a39c04603d36(color);
        return [
            $a4fb891c706c1187$var$rgb2Str(colorArr[0], colorArr[1], colorArr[2]),
            colorArr[3]
        ];
    };
    var $a4fb891c706c1187$var$updateFillNode = function(el, style, zrEl) {
        // TODO pattern
        var fill = style.fill;
        if (fill != null) {
            // Modified from excanvas
            if (fill instanceof $256a1ff3f5381b07$exports) {
                var gradientType;
                var angle = 0;
                var focus = [
                    0,
                    0
                ]; // additional offset
                var shift = 0; // scale factor for offset
                var expansion = 1;
                var rect = zrEl.getBoundingRect();
                var rectWidth = rect.width;
                var rectHeight = rect.height;
                if (fill.type === "linear") {
                    gradientType = "gradient";
                    var transform = zrEl.transform;
                    var p0 = [
                        fill.x * rectWidth,
                        fill.y * rectHeight
                    ];
                    var p1 = [
                        fill.x2 * rectWidth,
                        fill.y2 * rectHeight
                    ];
                    if (transform) {
                        $a4fb891c706c1187$var$applyTransform(p0, p0, transform);
                        $a4fb891c706c1187$var$applyTransform(p1, p1, transform);
                    }
                    var dx = p1[0] - p0[0];
                    var dy = p1[1] - p0[1];
                    angle = Math.atan2(dx, dy) * 180 / Math.PI; // The angle should be a non-negative number.
                    if (angle < 0) angle += 360;
                     // Very small angles produce an unexpected result because they are
                    // converted to a scientific notation string.
                    if (angle < 1e-6) angle = 0;
                } else {
                    gradientType = "gradientradial";
                    var p0 = [
                        fill.x * rectWidth,
                        fill.y * rectHeight
                    ];
                    var transform = zrEl.transform;
                    var scale = zrEl.scale;
                    var width = rectWidth;
                    var height = rectHeight;
                    focus = [
                        (p0[0] - rect.x) / width,
                        (p0[1] - rect.y) / height
                    ];
                    if (transform) $a4fb891c706c1187$var$applyTransform(p0, p0, transform);
                    width /= scale[0] * $a4fb891c706c1187$var$Z;
                    height /= scale[1] * $a4fb891c706c1187$var$Z;
                    var dimension = $a4fb891c706c1187$var$mathMax(width, height);
                    shift = 0 / dimension;
                    expansion = 2 * fill.r / dimension - shift;
                } // We need to sort the color stops in ascending order by offset,
                // otherwise IE won't interpret it correctly.
                var stops = fill.colorStops.slice();
                stops.sort(function(cs1, cs2) {
                    return cs1.offset - cs2.offset;
                });
                var length = stops.length; // Color and alpha list of first and last stop
                var colorAndAlphaList = [];
                var colors = [];
                for(var i = 0; i < length; i++){
                    var stop = stops[i];
                    var colorAndAlpha = $a4fb891c706c1187$var$getColorAndAlpha(stop.color);
                    colors.push(stop.offset * expansion + shift + " " + colorAndAlpha[0]);
                    if (i === 0 || i === length - 1) colorAndAlphaList.push(colorAndAlpha);
                }
                if (length >= 2) {
                    var color1 = colorAndAlphaList[0][0];
                    var color2 = colorAndAlphaList[1][0];
                    var opacity1 = colorAndAlphaList[0][1] * style.opacity;
                    var opacity2 = colorAndAlphaList[1][1] * style.opacity;
                    el.type = gradientType;
                    el.method = "none";
                    el.focus = "100%";
                    el.angle = angle;
                    el.color = color1;
                    el.color2 = color2;
                    el.colors = colors.join(","); // When colors attribute is used, the meanings of opacity and o:opacity2
                    // are reversed.
                    el.opacity = opacity2; // FIXME g_o_:opacity ?
                    el.opacity2 = opacity1;
                }
                if (gradientType === "radial") el.focusposition = focus.join(",");
            } else // FIXME Change from Gradient fill to color fill
            $a4fb891c706c1187$var$setColorAndOpacity(el, fill, style.opacity);
        }
    };
    var $a4fb891c706c1187$var$updateStrokeNode = function(el, style) {
        // if (style.lineJoin != null) {
        //     el.joinstyle = style.lineJoin;
        // }
        // if (style.miterLimit != null) {
        //     el.miterlimit = style.miterLimit * Z;
        // }
        // if (style.lineCap != null) {
        //     el.endcap = style.lineCap;
        // }
        if (style.lineDash) el.dashstyle = style.lineDash.join(" ");
        if (style.stroke != null && !(style.stroke instanceof $256a1ff3f5381b07$exports)) $a4fb891c706c1187$var$setColorAndOpacity(el, style.stroke, style.opacity);
    };
    var $a4fb891c706c1187$var$updateFillAndStroke = function(vmlEl, type, style, zrEl) {
        var isFill = type === "fill";
        var el = vmlEl.getElementsByTagName(type)[0]; // Stroke must have lineWidth
        if (style[type] != null && style[type] !== "none" && (isFill || !isFill && style.lineWidth)) {
            vmlEl[isFill ? "filled" : "stroked"] = "true"; // FIXME Remove before updating, or set `colors` will throw error
            if (style[type] instanceof $256a1ff3f5381b07$exports) $a4fb891c706c1187$var$remove(vmlEl, el);
            if (!el) el = $e20cbd3597409037$export$270e7ba5936d3c48(type);
            isFill ? $a4fb891c706c1187$var$updateFillNode(el, style, zrEl) : $a4fb891c706c1187$var$updateStrokeNode(el, style);
            $a4fb891c706c1187$var$append(vmlEl, el);
        } else {
            vmlEl[isFill ? "filled" : "stroked"] = "false";
            $a4fb891c706c1187$var$remove(vmlEl, el);
        }
    };
    var $a4fb891c706c1187$var$points = [
        [],
        [],
        []
    ];
    var $a4fb891c706c1187$var$pathDataToString = function(path, m) {
        var M = $a4fb891c706c1187$var$CMD.M;
        var C = $a4fb891c706c1187$var$CMD.C;
        var L = $a4fb891c706c1187$var$CMD.L;
        var A = $a4fb891c706c1187$var$CMD.A;
        var Q = $a4fb891c706c1187$var$CMD.Q;
        var str = [];
        var nPoint;
        var cmdStr;
        var cmd;
        var i;
        var xi;
        var yi;
        var data = path.data;
        var dataLength = path.len();
        for(i = 0; i < dataLength;){
            cmd = data[i++];
            cmdStr = "";
            nPoint = 0;
            switch(cmd){
                case M:
                    cmdStr = " m ";
                    nPoint = 1;
                    xi = data[i++];
                    yi = data[i++];
                    $a4fb891c706c1187$var$points[0][0] = xi;
                    $a4fb891c706c1187$var$points[0][1] = yi;
                    break;
                case L:
                    cmdStr = " l ";
                    nPoint = 1;
                    xi = data[i++];
                    yi = data[i++];
                    $a4fb891c706c1187$var$points[0][0] = xi;
                    $a4fb891c706c1187$var$points[0][1] = yi;
                    break;
                case Q:
                case C:
                    cmdStr = " c ";
                    nPoint = 3;
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var x3;
                    var y3;
                    if (cmd === Q) {
                        // Convert quadratic to cubic using degree elevation
                        x3 = x2;
                        y3 = y2;
                        x2 = (x2 + 2 * x1) / 3;
                        y2 = (y2 + 2 * y1) / 3;
                        x1 = (xi + 2 * x1) / 3;
                        y1 = (yi + 2 * y1) / 3;
                    } else {
                        x3 = data[i++];
                        y3 = data[i++];
                    }
                    $a4fb891c706c1187$var$points[0][0] = x1;
                    $a4fb891c706c1187$var$points[0][1] = y1;
                    $a4fb891c706c1187$var$points[1][0] = x2;
                    $a4fb891c706c1187$var$points[1][1] = y2;
                    $a4fb891c706c1187$var$points[2][0] = x3;
                    $a4fb891c706c1187$var$points[2][1] = y3;
                    xi = x3;
                    yi = y3;
                    break;
                case A:
                    var x = 0;
                    var y = 0;
                    var sx = 1;
                    var sy = 1;
                    var angle = 0;
                    if (m) {
                        // Extract SRT from matrix
                        x = m[4];
                        y = m[5];
                        sx = $a4fb891c706c1187$var$sqrt(m[0] * m[0] + m[1] * m[1]);
                        sy = $a4fb891c706c1187$var$sqrt(m[2] * m[2] + m[3] * m[3]);
                        angle = Math.atan2(-m[1] / sy, m[0] / sx);
                    }
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++] + angle;
                    var endAngle = data[i++] + startAngle + angle; // FIXME
                    // var psi = data[i++];
                    i++;
                    var clockwise = data[i++];
                    var x0 = cx + $a4fb891c706c1187$var$cos(startAngle) * rx;
                    var y0 = cy + $a4fb891c706c1187$var$sin(startAngle) * ry;
                    var x1 = cx + $a4fb891c706c1187$var$cos(endAngle) * rx;
                    var y1 = cy + $a4fb891c706c1187$var$sin(endAngle) * ry;
                    var type = clockwise ? " wa " : " at ";
                    if (Math.abs(x0 - x1) < 1e-4) {
                        // IE won't render arches drawn counter clockwise if x0 == x1.
                        if (Math.abs(endAngle - startAngle) > 1e-2) // Offset x0 by 1/80 of a pixel. Use something
                        // that can be represented in binary
                        {
                            if (clockwise) x0 += 270 / $a4fb891c706c1187$var$Z;
                        } else {
                            // Avoid case draw full circle
                            if (Math.abs(y0 - cy) < 1e-4) {
                                if (clockwise && x0 < cx || !clockwise && x0 > cx) y1 -= 270 / $a4fb891c706c1187$var$Z;
                                else y1 += 270 / $a4fb891c706c1187$var$Z;
                            } else if (clockwise && y0 < cy || !clockwise && y0 > cy) x1 += 270 / $a4fb891c706c1187$var$Z;
                            else x1 -= 270 / $a4fb891c706c1187$var$Z;
                        }
                    }
                    str.push(type, $a4fb891c706c1187$var$round(((cx - rx) * sx + x) * $a4fb891c706c1187$var$Z - $a4fb891c706c1187$var$Z2), $a4fb891c706c1187$var$comma, $a4fb891c706c1187$var$round(((cy - ry) * sy + y) * $a4fb891c706c1187$var$Z - $a4fb891c706c1187$var$Z2), $a4fb891c706c1187$var$comma, $a4fb891c706c1187$var$round(((cx + rx) * sx + x) * $a4fb891c706c1187$var$Z - $a4fb891c706c1187$var$Z2), $a4fb891c706c1187$var$comma, $a4fb891c706c1187$var$round(((cy + ry) * sy + y) * $a4fb891c706c1187$var$Z - $a4fb891c706c1187$var$Z2), $a4fb891c706c1187$var$comma, $a4fb891c706c1187$var$round((x0 * sx + x) * $a4fb891c706c1187$var$Z - $a4fb891c706c1187$var$Z2), $a4fb891c706c1187$var$comma, $a4fb891c706c1187$var$round((y0 * sy + y) * $a4fb891c706c1187$var$Z - $a4fb891c706c1187$var$Z2), $a4fb891c706c1187$var$comma, $a4fb891c706c1187$var$round((x1 * sx + x) * $a4fb891c706c1187$var$Z - $a4fb891c706c1187$var$Z2), $a4fb891c706c1187$var$comma, $a4fb891c706c1187$var$round((y1 * sy + y) * $a4fb891c706c1187$var$Z - $a4fb891c706c1187$var$Z2));
                    xi = x1;
                    yi = y1;
                    break;
                case $a4fb891c706c1187$var$CMD.R:
                    var p0 = $a4fb891c706c1187$var$points[0];
                    var p1 = $a4fb891c706c1187$var$points[1]; // x0, y0
                    p0[0] = data[i++];
                    p0[1] = data[i++]; // x1, y1
                    p1[0] = p0[0] + data[i++];
                    p1[1] = p0[1] + data[i++];
                    if (m) {
                        $a4fb891c706c1187$var$applyTransform(p0, p0, m);
                        $a4fb891c706c1187$var$applyTransform(p1, p1, m);
                    }
                    p0[0] = $a4fb891c706c1187$var$round(p0[0] * $a4fb891c706c1187$var$Z - $a4fb891c706c1187$var$Z2);
                    p1[0] = $a4fb891c706c1187$var$round(p1[0] * $a4fb891c706c1187$var$Z - $a4fb891c706c1187$var$Z2);
                    p0[1] = $a4fb891c706c1187$var$round(p0[1] * $a4fb891c706c1187$var$Z - $a4fb891c706c1187$var$Z2);
                    p1[1] = $a4fb891c706c1187$var$round(p1[1] * $a4fb891c706c1187$var$Z - $a4fb891c706c1187$var$Z2);
                    str.push(" m ", p0[0], $a4fb891c706c1187$var$comma, p0[1], " l ", p1[0], $a4fb891c706c1187$var$comma, p0[1], " l ", p1[0], $a4fb891c706c1187$var$comma, p1[1], " l ", p0[0], $a4fb891c706c1187$var$comma, p1[1]);
                    break;
                case $a4fb891c706c1187$var$CMD.Z:
                    // FIXME Update xi, yi
                    str.push(" x ");
            }
            if (nPoint > 0) {
                str.push(cmdStr);
                for(var k = 0; k < nPoint; k++){
                    var p = $a4fb891c706c1187$var$points[k];
                    m && $a4fb891c706c1187$var$applyTransform(p, p, m); // 不 round 会非常慢
                    str.push($a4fb891c706c1187$var$round(p[0] * $a4fb891c706c1187$var$Z - $a4fb891c706c1187$var$Z2), $a4fb891c706c1187$var$comma, $a4fb891c706c1187$var$round(p[1] * $a4fb891c706c1187$var$Z - $a4fb891c706c1187$var$Z2), k < nPoint - 1 ? $a4fb891c706c1187$var$comma : "");
                }
            }
        }
        return str.join("");
    }; // Rewrite the original path method
    $b9701a0f23f767de$exports.prototype.brushVML = function(vmlRoot) {
        var style = this.style;
        var vmlEl = this._vmlEl;
        if (!vmlEl) {
            vmlEl = $e20cbd3597409037$export$270e7ba5936d3c48("shape");
            $a4fb891c706c1187$var$initRootElStyle(vmlEl);
            this._vmlEl = vmlEl;
        }
        $a4fb891c706c1187$var$updateFillAndStroke(vmlEl, "fill", style, this);
        $a4fb891c706c1187$var$updateFillAndStroke(vmlEl, "stroke", style, this);
        var m = this.transform;
        var needTransform = m != null;
        var strokeEl = vmlEl.getElementsByTagName("stroke")[0];
        if (strokeEl) {
            var lineWidth = style.lineWidth; // Get the line scale.
            // Determinant of this.m_ means how much the area is enlarged by the
            // transformation. So its square root can be used as a scale factor
            // for width.
            if (needTransform && !style.strokeNoScale) {
                var det = m[0] * m[3] - m[1] * m[2];
                lineWidth *= $a4fb891c706c1187$var$sqrt($a4fb891c706c1187$var$abs(det));
            }
            strokeEl.weight = lineWidth + "px";
        }
        var path = this.path || (this.path = new $4c785e18473c2aa4$exports());
        if (this.__dirtyPath) {
            path.beginPath();
            path.subPixelOptimize = false;
            this.buildPath(path, this.shape);
            path.toStatic();
            this.__dirtyPath = false;
        }
        vmlEl.path = $a4fb891c706c1187$var$pathDataToString(path, this.transform);
        vmlEl.style.zIndex = $a4fb891c706c1187$var$getZIndex(this.zlevel, this.z, this.z2); // Append to root
        $a4fb891c706c1187$var$append(vmlRoot, vmlEl); // Text
        if (style.text != null) this.drawRectText(vmlRoot, this.getBoundingRect());
        else this.removeRectText(vmlRoot);
    };
    $b9701a0f23f767de$exports.prototype.onRemove = function(vmlRoot) {
        $a4fb891c706c1187$var$remove(vmlRoot, this._vmlEl);
        this.removeRectText(vmlRoot);
    };
    $b9701a0f23f767de$exports.prototype.onAdd = function(vmlRoot) {
        $a4fb891c706c1187$var$append(vmlRoot, this._vmlEl);
        this.appendRectText(vmlRoot);
    };
    /***************************************************
   * IMAGE
   **************************************************/ var $a4fb891c706c1187$var$isImage = function(img) {
        // FIXME img instanceof Image 如果 img 是一个字符串的时候，IE8 下会报错
        return typeof img === "object" && img.tagName && img.tagName.toUpperCase() === "IMG"; // return img instanceof Image;
    }; // Rewrite the original path method
    $8d11db19115b899b$exports.prototype.brushVML = function(vmlRoot) {
        var style = this.style;
        var image = style.image; // Image original width, height
        var ow;
        var oh;
        if ($a4fb891c706c1187$var$isImage(image)) {
            var src = image.src;
            if (src === this._imageSrc) {
                ow = this._imageWidth;
                oh = this._imageHeight;
            } else {
                var imageRuntimeStyle = image.runtimeStyle;
                var oldRuntimeWidth = imageRuntimeStyle.width;
                var oldRuntimeHeight = imageRuntimeStyle.height;
                imageRuntimeStyle.width = "auto";
                imageRuntimeStyle.height = "auto"; // get the original size
                ow = image.width;
                oh = image.height; // and remove overides
                imageRuntimeStyle.width = oldRuntimeWidth;
                imageRuntimeStyle.height = oldRuntimeHeight; // Caching image original width, height and src
                this._imageSrc = src;
                this._imageWidth = ow;
                this._imageHeight = oh;
            }
            image = src;
        } else if (image === this._imageSrc) {
            ow = this._imageWidth;
            oh = this._imageHeight;
        }
        if (!image) return;
        var x = style.x || 0;
        var y = style.y || 0;
        var dw = style.width;
        var dh = style.height;
        var sw = style.sWidth;
        var sh = style.sHeight;
        var sx = style.sx || 0;
        var sy = style.sy || 0;
        var hasCrop = sw && sh;
        var vmlEl = this._vmlEl;
        if (!vmlEl) {
            // FIXME 使用 group 在 left, top 都不是 0 的时候就无法显示了。
            // vmlEl = vmlCore.createNode('group');
            vmlEl = $e20cbd3597409037$export$2a111da947c407d2.createElement("div");
            $a4fb891c706c1187$var$initRootElStyle(vmlEl);
            this._vmlEl = vmlEl;
        }
        var vmlElStyle = vmlEl.style;
        var hasRotation = false;
        var m;
        var scaleX = 1;
        var scaleY = 1;
        if (this.transform) {
            m = this.transform;
            scaleX = $a4fb891c706c1187$var$sqrt(m[0] * m[0] + m[1] * m[1]);
            scaleY = $a4fb891c706c1187$var$sqrt(m[2] * m[2] + m[3] * m[3]);
            hasRotation = m[1] || m[2];
        }
        if (hasRotation) {
            // If filters are necessary (rotation exists), create them
            // filters are bog-slow, so only create them if abbsolutely necessary
            // The following check doesn't account for skews (which don't exist
            // in the canvas spec (yet) anyway.
            // From excanvas
            var p0 = [
                x,
                y
            ];
            var p1 = [
                x + dw,
                y
            ];
            var p2 = [
                x,
                y + dh
            ];
            var p3 = [
                x + dw,
                y + dh
            ];
            $a4fb891c706c1187$var$applyTransform(p0, p0, m);
            $a4fb891c706c1187$var$applyTransform(p1, p1, m);
            $a4fb891c706c1187$var$applyTransform(p2, p2, m);
            $a4fb891c706c1187$var$applyTransform(p3, p3, m);
            var maxX = $a4fb891c706c1187$var$mathMax(p0[0], p1[0], p2[0], p3[0]);
            var maxY = $a4fb891c706c1187$var$mathMax(p0[1], p1[1], p2[1], p3[1]);
            var transformFilter = [];
            transformFilter.push("M11=", m[0] / scaleX, $a4fb891c706c1187$var$comma, "M12=", m[2] / scaleY, $a4fb891c706c1187$var$comma, "M21=", m[1] / scaleX, $a4fb891c706c1187$var$comma, "M22=", m[3] / scaleY, $a4fb891c706c1187$var$comma, "Dx=", $a4fb891c706c1187$var$round(x * scaleX + m[4]), $a4fb891c706c1187$var$comma, "Dy=", $a4fb891c706c1187$var$round(y * scaleY + m[5]));
            vmlElStyle.padding = "0 " + $a4fb891c706c1187$var$round(maxX) + "px " + $a4fb891c706c1187$var$round(maxY) + "px 0"; // FIXME DXImageTransform 在 IE11 的兼容模式下不起作用
            vmlElStyle.filter = $a4fb891c706c1187$var$imageTransformPrefix + ".Matrix(" + transformFilter.join("") + ", SizingMethod=clip)";
        } else {
            if (m) {
                x = x * scaleX + m[4];
                y = y * scaleY + m[5];
            }
            vmlElStyle.filter = "";
            vmlElStyle.left = $a4fb891c706c1187$var$round(x) + "px";
            vmlElStyle.top = $a4fb891c706c1187$var$round(y) + "px";
        }
        var imageEl = this._imageEl;
        var cropEl = this._cropEl;
        if (!imageEl) {
            imageEl = $e20cbd3597409037$export$2a111da947c407d2.createElement("div");
            this._imageEl = imageEl;
        }
        var imageELStyle = imageEl.style;
        if (hasCrop) {
            // Needs know image original width and height
            if (!(ow && oh)) {
                var tmpImage = new Image();
                var self = this;
                tmpImage.onload = function() {
                    tmpImage.onload = null;
                    ow = tmpImage.width;
                    oh = tmpImage.height; // Adjust image width and height to fit the ratio destinationSize / sourceSize
                    imageELStyle.width = $a4fb891c706c1187$var$round(scaleX * ow * dw / sw) + "px";
                    imageELStyle.height = $a4fb891c706c1187$var$round(scaleY * oh * dh / sh) + "px"; // Caching image original width, height and src
                    self._imageWidth = ow;
                    self._imageHeight = oh;
                    self._imageSrc = image;
                };
                tmpImage.src = image;
            } else {
                imageELStyle.width = $a4fb891c706c1187$var$round(scaleX * ow * dw / sw) + "px";
                imageELStyle.height = $a4fb891c706c1187$var$round(scaleY * oh * dh / sh) + "px";
            }
            if (!cropEl) {
                cropEl = $e20cbd3597409037$export$2a111da947c407d2.createElement("div");
                cropEl.style.overflow = "hidden";
                this._cropEl = cropEl;
            }
            var cropElStyle = cropEl.style;
            cropElStyle.width = $a4fb891c706c1187$var$round((dw + sx * dw / sw) * scaleX);
            cropElStyle.height = $a4fb891c706c1187$var$round((dh + sy * dh / sh) * scaleY);
            cropElStyle.filter = $a4fb891c706c1187$var$imageTransformPrefix + ".Matrix(Dx=" + -sx * dw / sw * scaleX + ",Dy=" + -sy * dh / sh * scaleY + ")";
            if (!cropEl.parentNode) vmlEl.appendChild(cropEl);
            if (imageEl.parentNode !== cropEl) cropEl.appendChild(imageEl);
        } else {
            imageELStyle.width = $a4fb891c706c1187$var$round(scaleX * dw) + "px";
            imageELStyle.height = $a4fb891c706c1187$var$round(scaleY * dh) + "px";
            vmlEl.appendChild(imageEl);
            if (cropEl && cropEl.parentNode) {
                vmlEl.removeChild(cropEl);
                this._cropEl = null;
            }
        }
        var filterStr = "";
        var alpha = style.opacity;
        if (alpha < 1) filterStr += ".Alpha(opacity=" + $a4fb891c706c1187$var$round(alpha * 100) + ") ";
        filterStr += $a4fb891c706c1187$var$imageTransformPrefix + ".AlphaImageLoader(src=" + image + ", SizingMethod=scale)";
        imageELStyle.filter = filterStr;
        vmlEl.style.zIndex = $a4fb891c706c1187$var$getZIndex(this.zlevel, this.z, this.z2); // Append to root
        $a4fb891c706c1187$var$append(vmlRoot, vmlEl); // Text
        if (style.text != null) this.drawRectText(vmlRoot, this.getBoundingRect());
    };
    $8d11db19115b899b$exports.prototype.onRemove = function(vmlRoot) {
        $a4fb891c706c1187$var$remove(vmlRoot, this._vmlEl);
        this._vmlEl = null;
        this._cropEl = null;
        this._imageEl = null;
        this.removeRectText(vmlRoot);
    };
    $8d11db19115b899b$exports.prototype.onAdd = function(vmlRoot) {
        $a4fb891c706c1187$var$append(vmlRoot, this._vmlEl);
        this.appendRectText(vmlRoot);
    };
    /***************************************************
   * TEXT
   **************************************************/ var $a4fb891c706c1187$var$DEFAULT_STYLE_NORMAL = "normal";
    var $a4fb891c706c1187$var$fontStyleCache = {};
    var $a4fb891c706c1187$var$fontStyleCacheCount = 0;
    var $a4fb891c706c1187$var$MAX_FONT_CACHE_SIZE = 100;
    var $a4fb891c706c1187$var$fontEl = document.createElement("div");
    var $a4fb891c706c1187$var$getFontStyle = function(fontString) {
        var fontStyle = $a4fb891c706c1187$var$fontStyleCache[fontString];
        if (!fontStyle) {
            // Clear cache
            if ($a4fb891c706c1187$var$fontStyleCacheCount > $a4fb891c706c1187$var$MAX_FONT_CACHE_SIZE) {
                $a4fb891c706c1187$var$fontStyleCacheCount = 0;
                $a4fb891c706c1187$var$fontStyleCache = {};
            }
            var style = $a4fb891c706c1187$var$fontEl.style;
            var fontFamily;
            try {
                style.font = fontString;
                fontFamily = style.fontFamily.split(",")[0];
            } catch (e) {}
            fontStyle = {
                style: style.fontStyle || $a4fb891c706c1187$var$DEFAULT_STYLE_NORMAL,
                variant: style.fontVariant || $a4fb891c706c1187$var$DEFAULT_STYLE_NORMAL,
                weight: style.fontWeight || $a4fb891c706c1187$var$DEFAULT_STYLE_NORMAL,
                size: parseFloat(style.fontSize || 12) | 0,
                family: fontFamily || "Microsoft YaHei"
            };
            $a4fb891c706c1187$var$fontStyleCache[fontString] = fontStyle;
            $a4fb891c706c1187$var$fontStyleCacheCount++;
        }
        return fontStyle;
    };
    var $a4fb891c706c1187$var$textMeasureEl; // Overwrite measure text method
    $ebae9c4ebc22906c$export$d35a04b83ea6803e("measureText", function(text, textFont) {
        var doc = $e20cbd3597409037$export$2a111da947c407d2;
        if (!$a4fb891c706c1187$var$textMeasureEl) {
            $a4fb891c706c1187$var$textMeasureEl = doc.createElement("div");
            $a4fb891c706c1187$var$textMeasureEl.style.cssText = "position:absolute;top:-20000px;left:0;padding:0;margin:0;border:none;white-space:pre;";
            $e20cbd3597409037$export$2a111da947c407d2.body.appendChild($a4fb891c706c1187$var$textMeasureEl);
        }
        try {
            $a4fb891c706c1187$var$textMeasureEl.style.font = textFont;
        } catch (ex) {}
        $a4fb891c706c1187$var$textMeasureEl.innerHTML = ""; // Don't use innerHTML or innerText because they allow markup/whitespace.
        $a4fb891c706c1187$var$textMeasureEl.appendChild(doc.createTextNode(text));
        return {
            width: $a4fb891c706c1187$var$textMeasureEl.offsetWidth
        };
    });
    var $a4fb891c706c1187$var$tmpRect = new $33e4fae744d34798$exports();
    var $a4fb891c706c1187$var$drawRectText = function(vmlRoot, rect, textRect, fromTextEl) {
        var style = this.style; // Optimize, avoid normalize every time.
        this.__dirty && $5b0ace94e7e58ea5$export$176336068cc5371f(style, true);
        var text = style.text; // Convert to string
        text != null && (text += "");
        if (!text) return;
         // Convert rich text to plain text. Rich text is not supported in
        // IE8-, but tags in rich text template will be removed.
        if (style.rich) {
            var contentBlock = $ebae9c4ebc22906c$export$15ec9472ff2d721(text, style);
            text = [];
            for(var i = 0; i < contentBlock.lines.length; i++){
                var tokens = contentBlock.lines[i].tokens;
                var textLine = [];
                for(var j = 0; j < tokens.length; j++)textLine.push(tokens[j].text);
                text.push(textLine.join(""));
            }
            text = text.join("\n");
        }
        var x;
        var y;
        var align = style.textAlign;
        var verticalAlign = style.textVerticalAlign;
        var fontStyle = $a4fb891c706c1187$var$getFontStyle(style.font); // FIXME encodeHtmlAttribute ?
        var font = fontStyle.style + " " + fontStyle.variant + " " + fontStyle.weight + " " + fontStyle.size + 'px "' + fontStyle.family + '"';
        textRect = textRect || $ebae9c4ebc22906c$export$c381147bfed79d9f(text, font, align, verticalAlign, style.textPadding, style.textLineHeight); // Transform rect to view space
        var m = this.transform; // Ignore transform for text in other element
        if (m && !fromTextEl) {
            $a4fb891c706c1187$var$tmpRect.copy(rect);
            $a4fb891c706c1187$var$tmpRect.applyTransform(m);
            rect = $a4fb891c706c1187$var$tmpRect;
        }
        if (!fromTextEl) {
            var textPosition = style.textPosition; // Text position represented by coord
            if (textPosition instanceof Array) {
                x = rect.x + $a4fb891c706c1187$var$parsePercent(textPosition[0], rect.width);
                y = rect.y + $a4fb891c706c1187$var$parsePercent(textPosition[1], rect.height);
                align = align || "left";
            } else {
                var res = this.calculateTextPosition ? this.calculateTextPosition({}, style, rect) : $ebae9c4ebc22906c$export$eee3603b512feab7({}, style, rect);
                x = res.x;
                y = res.y; // Default align and baseline when has textPosition
                align = align || res.textAlign;
                verticalAlign = verticalAlign || res.textVerticalAlign;
            }
        } else {
            x = rect.x;
            y = rect.y;
        }
        x = $ebae9c4ebc22906c$export$eb5a525ef00ef9a4(x, textRect.width, align);
        y = $ebae9c4ebc22906c$export$bf7d6802d2badd9(y, textRect.height, verticalAlign); // Force baseline 'middle'
        y += textRect.height / 2; // var fontSize = fontStyle.size;
        // 1.75 is an arbitrary number, as there is no info about the text baseline
        // switch (baseline) {
        // case 'hanging':
        // case 'top':
        //     y += fontSize / 1.75;
        //     break;
        //     case 'middle':
        //         break;
        //     default:
        //     // case null:
        //     // case 'alphabetic':
        //     // case 'ideographic':
        //     // case 'bottom':
        //         y -= fontSize / 2.25;
        //         break;
        // }
        // switch (align) {
        //     case 'left':
        //         break;
        //     case 'center':
        //         x -= textRect.width / 2;
        //         break;
        //     case 'right':
        //         x -= textRect.width;
        //         break;
        // case 'end':
        // align = elementStyle.direction == 'ltr' ? 'right' : 'left';
        // break;
        // case 'start':
        // align = elementStyle.direction == 'rtl' ? 'right' : 'left';
        // break;
        // default:
        //     align = 'left';
        // }
        var createNode = $e20cbd3597409037$export$270e7ba5936d3c48;
        var textVmlEl = this._textVmlEl;
        var pathEl;
        var textPathEl;
        var skewEl;
        if (!textVmlEl) {
            textVmlEl = createNode("line");
            pathEl = createNode("path");
            textPathEl = createNode("textpath");
            skewEl = createNode("skew"); // FIXME Why here is not cammel case
            // Align 'center' seems wrong
            textPathEl.style["v-text-align"] = "left";
            $a4fb891c706c1187$var$initRootElStyle(textVmlEl);
            pathEl.textpathok = true;
            textPathEl.on = true;
            textVmlEl.from = "0 0";
            textVmlEl.to = "1000 0.05";
            $a4fb891c706c1187$var$append(textVmlEl, skewEl);
            $a4fb891c706c1187$var$append(textVmlEl, pathEl);
            $a4fb891c706c1187$var$append(textVmlEl, textPathEl);
            this._textVmlEl = textVmlEl;
        } else {
            // 这里是在前面 appendChild 保证顺序的前提下
            skewEl = textVmlEl.firstChild;
            pathEl = skewEl.nextSibling;
            textPathEl = pathEl.nextSibling;
        }
        var coords = [
            x,
            y
        ];
        var textVmlElStyle = textVmlEl.style; // Ignore transform for text in other element
        if (m && fromTextEl) {
            $a4fb891c706c1187$var$applyTransform(coords, coords, m);
            skewEl.on = true;
            skewEl.matrix = m[0].toFixed(3) + $a4fb891c706c1187$var$comma + m[2].toFixed(3) + $a4fb891c706c1187$var$comma + m[1].toFixed(3) + $a4fb891c706c1187$var$comma + m[3].toFixed(3) + ",0,0"; // Text position
            skewEl.offset = ($a4fb891c706c1187$var$round(coords[0]) || 0) + "," + ($a4fb891c706c1187$var$round(coords[1]) || 0); // Left top point as origin
            skewEl.origin = "0 0";
            textVmlElStyle.left = "0px";
            textVmlElStyle.top = "0px";
        } else {
            skewEl.on = false;
            textVmlElStyle.left = $a4fb891c706c1187$var$round(x) + "px";
            textVmlElStyle.top = $a4fb891c706c1187$var$round(y) + "px";
        }
        textPathEl.string = $a4fb891c706c1187$var$encodeHtmlAttribute(text); // TODO
        try {
            textPathEl.style.font = font;
        } catch (e) {}
        $a4fb891c706c1187$var$updateFillAndStroke(textVmlEl, "fill", {
            fill: style.textFill,
            opacity: style.opacity
        }, this);
        $a4fb891c706c1187$var$updateFillAndStroke(textVmlEl, "stroke", {
            stroke: style.textStroke,
            opacity: style.opacity,
            lineDash: style.lineDash || null // style.lineDash can be `false`.
        }, this);
        textVmlEl.style.zIndex = $a4fb891c706c1187$var$getZIndex(this.zlevel, this.z, this.z2); // Attached to root
        $a4fb891c706c1187$var$append(vmlRoot, textVmlEl);
    };
    var $a4fb891c706c1187$var$removeRectText = function(vmlRoot) {
        $a4fb891c706c1187$var$remove(vmlRoot, this._textVmlEl);
        this._textVmlEl = null;
    };
    var $a4fb891c706c1187$var$appendRectText = function(vmlRoot) {
        $a4fb891c706c1187$var$append(vmlRoot, this._textVmlEl);
    };
    var $a4fb891c706c1187$var$list = [
        $b82ede1bca894b3a$exports,
        $f95b0c44904a541d$exports,
        $8d11db19115b899b$exports,
        $b9701a0f23f767de$exports,
        $2fc81b997a587c68$exports
    ]; // In case Displayable has been mixed in RectText
    for(var $a4fb891c706c1187$var$i = 0; $a4fb891c706c1187$var$i < $a4fb891c706c1187$var$list.length; $a4fb891c706c1187$var$i++){
        var $a4fb891c706c1187$var$proto = $a4fb891c706c1187$var$list[$a4fb891c706c1187$var$i].prototype;
        $a4fb891c706c1187$var$proto.drawRectText = $a4fb891c706c1187$var$drawRectText;
        $a4fb891c706c1187$var$proto.removeRectText = $a4fb891c706c1187$var$removeRectText;
        $a4fb891c706c1187$var$proto.appendRectText = $a4fb891c706c1187$var$appendRectText;
    }
    $2fc81b997a587c68$exports.prototype.brushVML = function(vmlRoot) {
        var style = this.style;
        if (style.text != null) this.drawRectText(vmlRoot, {
            x: style.x || 0,
            y: style.y || 0,
            width: 0,
            height: 0
        }, this.getBoundingRect(), true);
        else this.removeRectText(vmlRoot);
    };
    $2fc81b997a587c68$exports.prototype.onRemove = function(vmlRoot) {
        this.removeRectText(vmlRoot);
    };
    $2fc81b997a587c68$exports.prototype.onAdd = function(vmlRoot) {
        this.appendRectText(vmlRoot);
    };
}



var $bdf89aaf51bc8c9b$var$registerPainter = $ec1efdd8e4428d18$export$a3e793ccb11823a5;
var $212b3e0f1e056ed9$exports = {};



var $212b3e0f1e056ed9$var$each = $ec279652dd95c27b$export$79b2f7037acddd43;
/**
 * VML Painter.
 *
 * @module zrender/vml/Painter
 */ function $212b3e0f1e056ed9$var$parseInt10(val) {
    return parseInt(val, 10);
}
/**
 * @alias module:zrender/vml/Painter
 */ function $212b3e0f1e056ed9$var$VMLPainter(root, storage) {
    $e20cbd3597409037$export$df5ad88089fbec49();
    this.root = root;
    this.storage = storage;
    var vmlViewport = document.createElement("div");
    var vmlRoot = document.createElement("div");
    vmlViewport.style.cssText = "display:inline-block;overflow:hidden;position:relative;width:300px;height:150px;";
    vmlRoot.style.cssText = "position:absolute;left:0;top:0;";
    root.appendChild(vmlViewport);
    this._vmlRoot = vmlRoot;
    this._vmlViewport = vmlViewport;
    this.resize(); // Modify storage
    var oldDelFromStorage = storage.delFromStorage;
    var oldAddToStorage = storage.addToStorage;
    storage.delFromStorage = function(el) {
        oldDelFromStorage.call(storage, el);
        if (el) el.onRemove && el.onRemove(vmlRoot);
    };
    storage.addToStorage = function(el) {
        // Displayable already has a vml node
        el.onAdd && el.onAdd(vmlRoot);
        oldAddToStorage.call(storage, el);
    };
    this._firstPaint = true;
}
$212b3e0f1e056ed9$var$VMLPainter.prototype = {
    constructor: $212b3e0f1e056ed9$var$VMLPainter,
    getType: function() {
        return "vml";
    },
    /**
   * @return {HTMLDivElement}
   */ getViewportRoot: function() {
        return this._vmlViewport;
    },
    getViewportRootOffset: function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    },
    /**
   * 刷新
   */ refresh: function() {
        var list = this.storage.getDisplayList(true, true);
        this._paintList(list);
    },
    _paintList: function(list) {
        var vmlRoot = this._vmlRoot;
        for(var i = 0; i < list.length; i++){
            var el = list[i];
            if (el.invisible || el.ignore) {
                if (!el.__alreadyNotVisible) el.onRemove(vmlRoot);
                 // Set as already invisible
                el.__alreadyNotVisible = true;
            } else {
                if (el.__alreadyNotVisible) el.onAdd(vmlRoot);
                el.__alreadyNotVisible = false;
                if (el.__dirty) {
                    el.beforeBrush && el.beforeBrush();
                    (el.brushVML || el.brush).call(el, vmlRoot);
                    el.afterBrush && el.afterBrush();
                }
            }
            el.__dirty = false;
        }
        if (this._firstPaint) {
            // Detached from document at first time
            // to avoid page refreshing too many times
            // FIXME 如果每次都先 removeChild 可能会导致一些填充和描边的效果改变
            this._vmlViewport.appendChild(vmlRoot);
            this._firstPaint = false;
        }
    },
    resize: function(width, height) {
        var width = width == null ? this._getWidth() : width;
        var height = height == null ? this._getHeight() : height;
        if (this._width !== width || this._height !== height) {
            this._width = width;
            this._height = height;
            var vmlViewportStyle = this._vmlViewport.style;
            vmlViewportStyle.width = width + "px";
            vmlViewportStyle.height = height + "px";
        }
    },
    dispose: function() {
        this.root.innerHTML = "";
        this._vmlRoot = this._vmlViewport = this.storage = null;
    },
    getWidth: function() {
        return this._width;
    },
    getHeight: function() {
        return this._height;
    },
    clear: function() {
        if (this._vmlViewport) this.root.removeChild(this._vmlViewport);
    },
    _getWidth: function() {
        var root = this.root;
        var stl = root.currentStyle;
        return (root.clientWidth || $212b3e0f1e056ed9$var$parseInt10(stl.width)) - $212b3e0f1e056ed9$var$parseInt10(stl.paddingLeft) - $212b3e0f1e056ed9$var$parseInt10(stl.paddingRight) | 0;
    },
    _getHeight: function() {
        var root = this.root;
        var stl = root.currentStyle;
        return (root.clientHeight || $212b3e0f1e056ed9$var$parseInt10(stl.height)) - $212b3e0f1e056ed9$var$parseInt10(stl.paddingTop) - $212b3e0f1e056ed9$var$parseInt10(stl.paddingBottom) | 0;
    }
}; // Not supported methods
function $212b3e0f1e056ed9$var$createMethodNotSupport(method) {
    return function() {
        $5067a17fa0db893f$exports('In IE8.0 VML mode painter not support method "' + method + '"');
    };
} // Unsupported methods
$212b3e0f1e056ed9$var$each([
    "getLayer",
    "insertLayer",
    "eachLayer",
    "eachBuiltinLayer",
    "eachOtherLayer",
    "getLayers",
    "modLayer",
    "delLayer",
    "clearLayer",
    "toDataURL",
    "pathToImage"
], function(name) {
    $212b3e0f1e056ed9$var$VMLPainter.prototype[name] = $212b3e0f1e056ed9$var$createMethodNotSupport(name);
});
var $212b3e0f1e056ed9$var$_default = $212b3e0f1e056ed9$var$VMLPainter;
$212b3e0f1e056ed9$exports = $212b3e0f1e056ed9$var$_default;


$bdf89aaf51bc8c9b$var$registerPainter("vml", $212b3e0f1e056ed9$exports);


var $1a93e11b8812f478$export$bb654e07daaf8c3a;
var $1a93e11b8812f478$export$5c452ff88e35e47d;
var $1a93e11b8812f478$export$6f093cfa640b7166;
var $6abf2e7ae82144f4$export$c8a8987d4410bf2d;
var $6abf2e7ae82144f4$var$svgURI = "http://www.w3.org/2000/svg";
function $6abf2e7ae82144f4$var$createElement(name) {
    return document.createElementNS($6abf2e7ae82144f4$var$svgURI, name);
}
$6abf2e7ae82144f4$export$c8a8987d4410bf2d = $6abf2e7ae82144f4$var$createElement;


var $1a93e11b8812f478$var$createElement = $6abf2e7ae82144f4$export$c8a8987d4410bf2d;






// TODO
// 1. shadow
// 2. Image: sx, sy, sw, sh
var $1a93e11b8812f478$var$CMD = $4c785e18473c2aa4$exports.CMD;
var $1a93e11b8812f478$var$arrayJoin = Array.prototype.join;
var $1a93e11b8812f478$var$NONE = "none";
var $1a93e11b8812f478$var$mathRound = Math.round;
var $1a93e11b8812f478$var$mathSin = Math.sin;
var $1a93e11b8812f478$var$mathCos = Math.cos;
var $1a93e11b8812f478$var$PI = Math.PI;
var $1a93e11b8812f478$var$PI2 = Math.PI * 2;
var $1a93e11b8812f478$var$degree = 180 / $1a93e11b8812f478$var$PI;
var $1a93e11b8812f478$var$EPSILON = 1e-4;
function $1a93e11b8812f478$var$round4(val) {
    return $1a93e11b8812f478$var$mathRound(val * 1e4) / 1e4;
}
function $1a93e11b8812f478$var$isAroundZero(val) {
    return val < $1a93e11b8812f478$var$EPSILON && val > -$1a93e11b8812f478$var$EPSILON;
}
function $1a93e11b8812f478$var$pathHasFill(style, isText) {
    var fill = isText ? style.textFill : style.fill;
    return fill != null && fill !== $1a93e11b8812f478$var$NONE;
}
function $1a93e11b8812f478$var$pathHasStroke(style, isText) {
    var stroke = isText ? style.textStroke : style.stroke;
    return stroke != null && stroke !== $1a93e11b8812f478$var$NONE;
}
function $1a93e11b8812f478$var$setTransform(svgEl, m) {
    if (m) $1a93e11b8812f478$var$attr(svgEl, "transform", "matrix(" + $1a93e11b8812f478$var$arrayJoin.call(m, ",") + ")");
}
function $1a93e11b8812f478$var$attr(el, key, val) {
    if (!val || val.type !== "linear" && val.type !== "radial") // Don't set attribute for gradient, since it need new dom nodes
    el.setAttribute(key, val);
}
function $1a93e11b8812f478$var$attrXLink(el, key, val) {
    el.setAttributeNS("http://www.w3.org/1999/xlink", key, val);
}
function $1a93e11b8812f478$var$bindStyle(svgEl, style, isText, el) {
    if ($1a93e11b8812f478$var$pathHasFill(style, isText)) {
        var fill = isText ? style.textFill : style.fill;
        fill = fill === "transparent" ? $1a93e11b8812f478$var$NONE : fill;
        $1a93e11b8812f478$var$attr(svgEl, "fill", fill);
        $1a93e11b8812f478$var$attr(svgEl, "fill-opacity", style.fillOpacity != null ? style.fillOpacity * style.opacity : style.opacity);
    } else $1a93e11b8812f478$var$attr(svgEl, "fill", $1a93e11b8812f478$var$NONE);
    if ($1a93e11b8812f478$var$pathHasStroke(style, isText)) {
        var stroke = isText ? style.textStroke : style.stroke;
        stroke = stroke === "transparent" ? $1a93e11b8812f478$var$NONE : stroke;
        $1a93e11b8812f478$var$attr(svgEl, "stroke", stroke);
        var strokeWidth = isText ? style.textStrokeWidth : style.lineWidth;
        var strokeScale = !isText && style.strokeNoScale ? el.getLineScale() : 1;
        $1a93e11b8812f478$var$attr(svgEl, "stroke-width", strokeWidth / strokeScale); // stroke then fill for text; fill then stroke for others
        $1a93e11b8812f478$var$attr(svgEl, "paint-order", isText ? "stroke" : "fill");
        $1a93e11b8812f478$var$attr(svgEl, "stroke-opacity", style.strokeOpacity != null ? style.strokeOpacity : style.opacity);
        var lineDash = style.lineDash;
        if (lineDash) {
            $1a93e11b8812f478$var$attr(svgEl, "stroke-dasharray", style.lineDash.join(","));
            $1a93e11b8812f478$var$attr(svgEl, "stroke-dashoffset", $1a93e11b8812f478$var$mathRound(style.lineDashOffset || 0));
        } else $1a93e11b8812f478$var$attr(svgEl, "stroke-dasharray", "");
         // PENDING
        style.lineCap && $1a93e11b8812f478$var$attr(svgEl, "stroke-linecap", style.lineCap);
        style.lineJoin && $1a93e11b8812f478$var$attr(svgEl, "stroke-linejoin", style.lineJoin);
        style.miterLimit && $1a93e11b8812f478$var$attr(svgEl, "stroke-miterlimit", style.miterLimit);
    } else $1a93e11b8812f478$var$attr(svgEl, "stroke", $1a93e11b8812f478$var$NONE);
}
/***************************************************
 * PATH
 **************************************************/ function $1a93e11b8812f478$var$pathDataToString(path) {
    var str = [];
    var data = path.data;
    var dataLength = path.len();
    for(var i = 0; i < dataLength;){
        var cmd = data[i++];
        var cmdStr = "";
        var nData = 0;
        switch(cmd){
            case $1a93e11b8812f478$var$CMD.M:
                cmdStr = "M";
                nData = 2;
                break;
            case $1a93e11b8812f478$var$CMD.L:
                cmdStr = "L";
                nData = 2;
                break;
            case $1a93e11b8812f478$var$CMD.Q:
                cmdStr = "Q";
                nData = 4;
                break;
            case $1a93e11b8812f478$var$CMD.C:
                cmdStr = "C";
                nData = 6;
                break;
            case $1a93e11b8812f478$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                var psi = data[i++];
                var clockwise = data[i++];
                var dThetaPositive = Math.abs(dTheta);
                var isCircle = $1a93e11b8812f478$var$isAroundZero(dThetaPositive - $1a93e11b8812f478$var$PI2) || (clockwise ? dTheta >= $1a93e11b8812f478$var$PI2 : -dTheta >= $1a93e11b8812f478$var$PI2); // Mapping to 0~2PI
                var unifiedTheta = dTheta > 0 ? dTheta % $1a93e11b8812f478$var$PI2 : dTheta % $1a93e11b8812f478$var$PI2 + $1a93e11b8812f478$var$PI2;
                var large = false;
                if (isCircle) large = true;
                else if ($1a93e11b8812f478$var$isAroundZero(dThetaPositive)) large = false;
                else large = unifiedTheta >= $1a93e11b8812f478$var$PI === !!clockwise;
                var x0 = $1a93e11b8812f478$var$round4(cx + rx * $1a93e11b8812f478$var$mathCos(theta));
                var y0 = $1a93e11b8812f478$var$round4(cy + ry * $1a93e11b8812f478$var$mathSin(theta)); // It will not draw if start point and end point are exactly the same
                // We need to shift the end point with a small value
                // FIXME A better way to draw circle ?
                if (isCircle) {
                    if (clockwise) dTheta = $1a93e11b8812f478$var$PI2 - 1e-4;
                    else dTheta = -$1a93e11b8812f478$var$PI2 + 1e-4;
                    large = true;
                    if (i === 9) // Move to (x0, y0) only when CMD.A comes at the
                    // first position of a shape.
                    // For instance, when drawing a ring, CMD.A comes
                    // after CMD.M, so it's unnecessary to move to
                    // (x0, y0).
                    str.push("M", x0, y0);
                }
                var x = $1a93e11b8812f478$var$round4(cx + rx * $1a93e11b8812f478$var$mathCos(theta + dTheta));
                var y = $1a93e11b8812f478$var$round4(cy + ry * $1a93e11b8812f478$var$mathSin(theta + dTheta)); // FIXME Ellipse
                str.push("A", $1a93e11b8812f478$var$round4(rx), $1a93e11b8812f478$var$round4(ry), $1a93e11b8812f478$var$mathRound(psi * $1a93e11b8812f478$var$degree), +large, +clockwise, x, y);
                break;
            case $1a93e11b8812f478$var$CMD.Z:
                cmdStr = "Z";
                break;
            case $1a93e11b8812f478$var$CMD.R:
                var x = $1a93e11b8812f478$var$round4(data[i++]);
                var y = $1a93e11b8812f478$var$round4(data[i++]);
                var w = $1a93e11b8812f478$var$round4(data[i++]);
                var h = $1a93e11b8812f478$var$round4(data[i++]);
                str.push("M", x, y, "L", x + w, y, "L", x + w, y + h, "L", x, y + h, "L", x, y);
                break;
        }
        cmdStr && str.push(cmdStr);
        for(var j = 0; j < nData; j++)// PENDING With scale
        str.push($1a93e11b8812f478$var$round4(data[i++]));
    }
    return str.join(" ");
}
var $1a93e11b8812f478$var$svgPath = {};
$1a93e11b8812f478$var$svgPath.brush = function(el) {
    var style = el.style;
    var svgEl = el.__svgEl;
    if (!svgEl) {
        svgEl = $1a93e11b8812f478$var$createElement("path");
        el.__svgEl = svgEl;
    }
    if (!el.path) el.createPathProxy();
    var path = el.path;
    if (el.__dirtyPath) {
        path.beginPath();
        path.subPixelOptimize = false;
        el.buildPath(path, el.shape);
        el.__dirtyPath = false;
        var pathStr = $1a93e11b8812f478$var$pathDataToString(path);
        if (pathStr.indexOf("NaN") < 0) // Ignore illegal path, which may happen such in out-of-range
        // data in Calendar series.
        $1a93e11b8812f478$var$attr(svgEl, "d", pathStr);
    }
    $1a93e11b8812f478$var$bindStyle(svgEl, style, false, el);
    $1a93e11b8812f478$var$setTransform(svgEl, el.transform);
    if (style.text != null) $1a93e11b8812f478$var$svgTextDrawRectText(el, el.getBoundingRect());
    else $1a93e11b8812f478$var$removeOldTextNode(el);
};
/***************************************************
 * IMAGE
 **************************************************/ var $1a93e11b8812f478$var$svgImage = {};
$1a93e11b8812f478$var$svgImage.brush = function(el) {
    var style = el.style;
    var image = style.image;
    if (image instanceof HTMLImageElement) {
        var src = image.src;
        image = src;
    }
    if (!image) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var dw = style.width;
    var dh = style.height;
    var svgEl = el.__svgEl;
    if (!svgEl) {
        svgEl = $1a93e11b8812f478$var$createElement("image");
        el.__svgEl = svgEl;
    }
    if (image !== el.__imageSrc) {
        $1a93e11b8812f478$var$attrXLink(svgEl, "href", image); // Caching image src
        el.__imageSrc = image;
    }
    $1a93e11b8812f478$var$attr(svgEl, "width", dw);
    $1a93e11b8812f478$var$attr(svgEl, "height", dh);
    $1a93e11b8812f478$var$attr(svgEl, "x", x);
    $1a93e11b8812f478$var$attr(svgEl, "y", y);
    $1a93e11b8812f478$var$setTransform(svgEl, el.transform);
    if (style.text != null) $1a93e11b8812f478$var$svgTextDrawRectText(el, el.getBoundingRect());
    else $1a93e11b8812f478$var$removeOldTextNode(el);
};
/***************************************************
 * TEXT
 **************************************************/ var $1a93e11b8812f478$var$svgText = {};
var $1a93e11b8812f478$var$_tmpTextHostRect = new $33e4fae744d34798$exports();
var $1a93e11b8812f478$var$_tmpTextBoxPos = {};
var $1a93e11b8812f478$var$_tmpTextTransform = [];
var $1a93e11b8812f478$var$TEXT_ALIGN_TO_ANCHRO = {
    left: "start",
    right: "end",
    center: "middle",
    middle: "middle"
};
/**
 * @param {module:zrender/Element} el
 * @param {Object|boolean} [hostRect] {x, y, width, height}
 *        If set false, rect text is not used.
 */ var $1a93e11b8812f478$var$svgTextDrawRectText = function(el, hostRect) {
    var style = el.style;
    var elTransform = el.transform;
    var needTransformTextByHostEl = el instanceof $2fc81b997a587c68$exports || style.transformText;
    el.__dirty && $5b0ace94e7e58ea5$export$176336068cc5371f(style, true);
    var text = style.text; // Convert to string
    text != null && (text += "");
    if (!$5b0ace94e7e58ea5$export$15f386d282805840(text, style)) return;
     // render empty text for svg if no text but need draw text.
    text == null && (text = ""); // Follow the setting in the canvas renderer, if not transform the
    // text, transform the hostRect, by which the text is located.
    if (!needTransformTextByHostEl && elTransform) {
        $1a93e11b8812f478$var$_tmpTextHostRect.copy(hostRect);
        $1a93e11b8812f478$var$_tmpTextHostRect.applyTransform(elTransform);
        hostRect = $1a93e11b8812f478$var$_tmpTextHostRect;
    }
    var textSvgEl = el.__textSvgEl;
    if (!textSvgEl) {
        textSvgEl = $1a93e11b8812f478$var$createElement("text");
        el.__textSvgEl = textSvgEl;
    } // style.font has been normalized by `normalizeTextStyle`.
    var textSvgElStyle = textSvgEl.style;
    var font = style.font || $ebae9c4ebc22906c$export$7d7a232b6d2cc80c;
    var computedFont = textSvgEl.__computedFont;
    if (font !== textSvgEl.__styleFont) {
        textSvgElStyle.font = textSvgEl.__styleFont = font; // The computedFont might not be the orginal font if it is illegal font.
        computedFont = textSvgEl.__computedFont = textSvgElStyle.font;
    }
    var textPadding = style.textPadding;
    var textLineHeight = style.textLineHeight;
    var contentBlock = el.__textCotentBlock;
    if (!contentBlock || el.__dirtyText) contentBlock = el.__textCotentBlock = $ebae9c4ebc22906c$export$5772575e34ef80f9(text, computedFont, textPadding, textLineHeight, style.truncate);
    var outerHeight = contentBlock.outerHeight;
    var lineHeight = contentBlock.lineHeight;
    $5b0ace94e7e58ea5$export$13cc41b670c23b93($1a93e11b8812f478$var$_tmpTextBoxPos, el, style, hostRect);
    var baseX = $1a93e11b8812f478$var$_tmpTextBoxPos.baseX;
    var baseY = $1a93e11b8812f478$var$_tmpTextBoxPos.baseY;
    var textAlign = $1a93e11b8812f478$var$_tmpTextBoxPos.textAlign || "left";
    var textVerticalAlign = $1a93e11b8812f478$var$_tmpTextBoxPos.textVerticalAlign;
    $1a93e11b8812f478$var$setTextTransform(textSvgEl, needTransformTextByHostEl, elTransform, style, hostRect, baseX, baseY);
    var boxY = $ebae9c4ebc22906c$export$bf7d6802d2badd9(baseY, outerHeight, textVerticalAlign);
    var textX = baseX;
    var textY = boxY; // TODO needDrawBg
    if (textPadding) {
        textX = $1a93e11b8812f478$var$getTextXForPadding(baseX, textAlign, textPadding);
        textY += textPadding[0];
    } // `textBaseline` is set as 'middle'.
    textY += lineHeight / 2;
    $1a93e11b8812f478$var$bindStyle(textSvgEl, style, true, el); // FIXME
    // Add a <style> to reset all of the text font as inherit?
    // otherwise the outer <style> may set the unexpected style.
    // Font may affect position of each tspan elements
    var canCacheByTextString = contentBlock.canCacheByTextString;
    var tspanList = el.__tspanList || (el.__tspanList = []);
    var tspanOriginLen = tspanList.length; // Optimize for most cases, just compare text string to determine change.
    if (canCacheByTextString && el.__canCacheByTextString && el.__text === text) {
        if (el.__dirtyText && tspanOriginLen) for(var idx = 0; idx < tspanOriginLen; ++idx)$1a93e11b8812f478$var$updateTextLocation(tspanList[idx], textAlign, textX, textY + idx * lineHeight);
    } else {
        el.__text = text;
        el.__canCacheByTextString = canCacheByTextString;
        var textLines = contentBlock.lines;
        var nTextLines = textLines.length;
        var idx = 0;
        for(; idx < nTextLines; idx++){
            // Using cached tspan elements
            var tspan = tspanList[idx];
            var singleLineText = textLines[idx];
            if (!tspan) {
                tspan = tspanList[idx] = $1a93e11b8812f478$var$createElement("tspan");
                textSvgEl.appendChild(tspan);
                tspan.appendChild(document.createTextNode(singleLineText));
            } else if (tspan.__zrText !== singleLineText) {
                tspan.innerHTML = "";
                tspan.appendChild(document.createTextNode(singleLineText));
            }
            $1a93e11b8812f478$var$updateTextLocation(tspan, textAlign, textX, textY + idx * lineHeight);
        } // Remove unused tspan elements
        if (tspanOriginLen > nTextLines) {
            for(; idx < tspanOriginLen; idx++)textSvgEl.removeChild(tspanList[idx]);
            tspanList.length = nTextLines;
        }
    }
};
function $1a93e11b8812f478$var$setTextTransform(textSvgEl, needTransformTextByHostEl, elTransform, style, hostRect, baseX, baseY) {
    $6c6dd9610ba660f0$export$f0954fd7d5368655($1a93e11b8812f478$var$_tmpTextTransform);
    if (needTransformTextByHostEl && elTransform) $6c6dd9610ba660f0$export$784d13d8ee351f07($1a93e11b8812f478$var$_tmpTextTransform, elTransform);
     // textRotation only apply in RectText.
    var textRotation = style.textRotation;
    if (hostRect && textRotation) {
        var origin = style.textOrigin;
        if (origin === "center") {
            baseX = hostRect.width / 2 + hostRect.x;
            baseY = hostRect.height / 2 + hostRect.y;
        } else if (origin) {
            baseX = origin[0] + hostRect.x;
            baseY = origin[1] + hostRect.y;
        }
        $1a93e11b8812f478$var$_tmpTextTransform[4] -= baseX;
        $1a93e11b8812f478$var$_tmpTextTransform[5] -= baseY; // Positive: anticlockwise
        $6c6dd9610ba660f0$export$bb628a54ab399bc9($1a93e11b8812f478$var$_tmpTextTransform, $1a93e11b8812f478$var$_tmpTextTransform, textRotation);
        $1a93e11b8812f478$var$_tmpTextTransform[4] += baseX;
        $1a93e11b8812f478$var$_tmpTextTransform[5] += baseY;
    } // See the definition in `Style.js#textOrigin`, the default
    // origin is from the result of `getBoxPosition`.
    $1a93e11b8812f478$var$setTransform(textSvgEl, $1a93e11b8812f478$var$_tmpTextTransform);
} // FIXME merge the same code with `helper/text.js#getTextXForPadding`;
function $1a93e11b8812f478$var$getTextXForPadding(x, textAlign, textPadding) {
    return textAlign === "right" ? x - textPadding[1] : textAlign === "center" ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
function $1a93e11b8812f478$var$updateTextLocation(tspan, textAlign, x, y) {
    // Consider different font display differently in vertial align, we always
    // set vertialAlign as 'middle', and use 'y' to locate text vertically.
    $1a93e11b8812f478$var$attr(tspan, "dominant-baseline", "middle");
    $1a93e11b8812f478$var$attr(tspan, "text-anchor", $1a93e11b8812f478$var$TEXT_ALIGN_TO_ANCHRO[textAlign]);
    $1a93e11b8812f478$var$attr(tspan, "x", x);
    $1a93e11b8812f478$var$attr(tspan, "y", y);
}
function $1a93e11b8812f478$var$removeOldTextNode(el) {
    if (el && el.__textSvgEl) {
        // textSvgEl may has no parentNode if el has been removed temporary.
        if (el.__textSvgEl.parentNode) el.__textSvgEl.parentNode.removeChild(el.__textSvgEl);
        el.__textSvgEl = null;
        el.__tspanList = [];
        el.__text = null;
    }
}
$1a93e11b8812f478$var$svgText.drawRectText = $1a93e11b8812f478$var$svgTextDrawRectText;
$1a93e11b8812f478$var$svgText.brush = function(el) {
    var style = el.style;
    if (style.text != null) $1a93e11b8812f478$var$svgTextDrawRectText(el, false);
    else $1a93e11b8812f478$var$removeOldTextNode(el);
};
$1a93e11b8812f478$export$bb654e07daaf8c3a = $1a93e11b8812f478$var$svgPath;
$1a93e11b8812f478$export$5c452ff88e35e47d = $1a93e11b8812f478$var$svgImage;
$1a93e11b8812f478$export$6f093cfa640b7166 = $1a93e11b8812f478$var$svgText;



var $27f7290e41b7f08f$var$registerPainter = $ec1efdd8e4428d18$export$a3e793ccb11823a5;
var $7f039beb86fc00b6$exports = {};

var $7f039beb86fc00b6$var$createElement = $6abf2e7ae82144f4$export$c8a8987d4410bf2d;





var $730fd9803b5e2607$exports = {};
// Myers' Diff Algorithm
// Modified from https://github.com/kpdecker/jsdiff/blob/master/src/diff/base.js
function $730fd9803b5e2607$var$Diff() {}
$730fd9803b5e2607$var$Diff.prototype = {
    diff: function(oldArr, newArr, equals) {
        if (!equals) equals = function(a, b) {
            return a === b;
        };
        this.equals = equals;
        var self = this;
        oldArr = oldArr.slice();
        newArr = newArr.slice(); // Allow subclasses to massage the input prior to running
        var newLen = newArr.length;
        var oldLen = oldArr.length;
        var editLength = 1;
        var maxEditLength = newLen + oldLen;
        var bestPath = [
            {
                newPos: -1,
                components: []
            }
        ]; // Seed editLength = 0, i.e. the content starts with the same values
        var oldPos = this.extractCommon(bestPath[0], newArr, oldArr, 0);
        if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
            var indices = [];
            for(var i = 0; i < newArr.length; i++)indices.push(i);
             // Identity per the equality and tokenizer
            return [
                {
                    indices: indices,
                    count: newArr.length
                }
            ];
        } // Main worker method. checks all permutations of a given edit length for acceptance.
        function execEditLength() {
            for(var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2){
                var basePath;
                var addPath = bestPath[diagonalPath - 1];
                var removePath = bestPath[diagonalPath + 1];
                var oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;
                if (addPath) // No one else is going to attempt to use this value, clear it
                bestPath[diagonalPath - 1] = undefined;
                var canAdd = addPath && addPath.newPos + 1 < newLen;
                var canRemove = removePath && 0 <= oldPos && oldPos < oldLen;
                if (!canAdd && !canRemove) {
                    // If this path is a terminal then prune
                    bestPath[diagonalPath] = undefined;
                    continue;
                } // Select the diagonal that we want to branch from. We select the prior
                // path whose position in the new string is the farthest from the origin
                // and does not pass the bounds of the diff graph
                if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
                    basePath = $730fd9803b5e2607$var$clonePath(removePath);
                    self.pushComponent(basePath.components, undefined, true);
                } else {
                    basePath = addPath; // No need to clone, we've pulled it from the list
                    basePath.newPos++;
                    self.pushComponent(basePath.components, true, undefined);
                }
                oldPos = self.extractCommon(basePath, newArr, oldArr, diagonalPath); // If we have hit the end of both strings, then we are done
                if (basePath.newPos + 1 >= newLen && oldPos + 1 >= oldLen) return $730fd9803b5e2607$var$buildValues(self, basePath.components, newArr, oldArr);
                else // Otherwise track this path as a potential candidate and continue.
                bestPath[diagonalPath] = basePath;
            }
            editLength++;
        }
        while(editLength <= maxEditLength){
            var ret = execEditLength();
            if (ret) return ret;
        }
    },
    pushComponent: function(components, added, removed) {
        var last = components[components.length - 1];
        if (last && last.added === added && last.removed === removed) // We need to clone here as the component clone operation is just
        // as shallow array clone
        components[components.length - 1] = {
            count: last.count + 1,
            added: added,
            removed: removed
        };
        else components.push({
            count: 1,
            added: added,
            removed: removed
        });
    },
    extractCommon: function(basePath, newArr, oldArr, diagonalPath) {
        var newLen = newArr.length;
        var oldLen = oldArr.length;
        var newPos = basePath.newPos;
        var oldPos = newPos - diagonalPath;
        var commonCount = 0;
        while(newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(newArr[newPos + 1], oldArr[oldPos + 1])){
            newPos++;
            oldPos++;
            commonCount++;
        }
        if (commonCount) basePath.components.push({
            count: commonCount
        });
        basePath.newPos = newPos;
        return oldPos;
    },
    tokenize: function(value) {
        return value.slice();
    },
    join: function(value) {
        return value.slice();
    }
};
function $730fd9803b5e2607$var$buildValues(diff, components, newArr, oldArr) {
    var componentPos = 0;
    var componentLen = components.length;
    var newPos = 0;
    var oldPos = 0;
    for(; componentPos < componentLen; componentPos++){
        var component = components[componentPos];
        if (!component.removed) {
            var indices = [];
            for(var i = newPos; i < newPos + component.count; i++)indices.push(i);
            component.indices = indices;
            newPos += component.count; // Common case
            if (!component.added) oldPos += component.count;
        } else {
            var indices = [];
            for(var i = oldPos; i < oldPos + component.count; i++)indices.push(i);
            component.indices = indices;
            oldPos += component.count;
        }
    }
    return components;
}
function $730fd9803b5e2607$var$clonePath(path) {
    return {
        newPos: path.newPos,
        components: path.components.slice(0)
    };
}
var $730fd9803b5e2607$var$arrayDiff = new $730fd9803b5e2607$var$Diff();
function $730fd9803b5e2607$var$_default(oldArr, newArr, callback) {
    return $730fd9803b5e2607$var$arrayDiff.diff(oldArr, newArr, callback);
}
$730fd9803b5e2607$exports = $730fd9803b5e2607$var$_default;


var $062d7ae82084d0fc$exports = {};
var $ba1ede4f50d63d53$exports = {};

var $ba1ede4f50d63d53$var$createElement = $6abf2e7ae82144f4$export$c8a8987d4410bf2d;





var $ba1ede4f50d63d53$var$svgPath = $1a93e11b8812f478$export$bb654e07daaf8c3a;
var $ba1ede4f50d63d53$var$svgImage = $1a93e11b8812f478$export$5c452ff88e35e47d;
var $ba1ede4f50d63d53$var$svgText = $1a93e11b8812f478$export$6f093cfa640b7166;
/**
 * @file Manages elements that can be defined in <defs> in SVG,
 *       e.g., gradients, clip path, etc.
 * @author Zhang Wenli
 */ var $ba1ede4f50d63d53$var$MARK_UNUSED = "0";
var $ba1ede4f50d63d53$var$MARK_USED = "1";
/**
 * Manages elements that can be defined in <defs> in SVG,
 * e.g., gradients, clip path, etc.
 *
 * @class
 * @param {number}          zrId      zrender instance id
 * @param {SVGElement}      svgRoot   root of SVG document
 * @param {string|string[]} tagNames  possible tag names
 * @param {string}          markLabel label name to make if the element
 *                                    is used
 */ function $ba1ede4f50d63d53$var$Definable(zrId, svgRoot, tagNames, markLabel, domName) {
    this._zrId = zrId;
    this._svgRoot = svgRoot;
    this._tagNames = typeof tagNames === "string" ? [
        tagNames
    ] : tagNames;
    this._markLabel = markLabel;
    this._domName = domName || "_dom";
    this.nextId = 0;
}
$ba1ede4f50d63d53$var$Definable.prototype.createElement = $ba1ede4f50d63d53$var$createElement;
/**
 * Get the <defs> tag for svgRoot; optionally creates one if not exists.
 *
 * @param {boolean} isForceCreating if need to create when not exists
 * @return {SVGDefsElement} SVG <defs> element, null if it doesn't
 * exist and isForceCreating is false
 */ $ba1ede4f50d63d53$var$Definable.prototype.getDefs = function(isForceCreating) {
    var svgRoot = this._svgRoot;
    var defs = this._svgRoot.getElementsByTagName("defs");
    if (defs.length === 0) {
        // Not exist
        if (isForceCreating) {
            defs = svgRoot.insertBefore(this.createElement("defs"), svgRoot.firstChild // Insert in the front of svg
            );
            if (!defs.contains) // IE doesn't support contains method
            defs.contains = function(el) {
                var children = defs.children;
                if (!children) return false;
                for(var i = children.length - 1; i >= 0; --i){
                    if (children[i] === el) return true;
                }
                return false;
            };
            return defs;
        } else return null;
    } else return defs[0];
};
/**
 * Update DOM element if necessary.
 *
 * @param {Object|string} element style element. e.g., for gradient,
 *                                it may be '#ccc' or {type: 'linear', ...}
 * @param {Function|undefined} onUpdate update callback
 */ $ba1ede4f50d63d53$var$Definable.prototype.update = function(element, onUpdate) {
    if (!element) return;
    var defs = this.getDefs(false);
    if (element[this._domName] && defs.contains(element[this._domName])) // Update DOM
    {
        if (typeof onUpdate === "function") onUpdate(element);
    } else {
        // No previous dom, create new
        var dom = this.add(element);
        if (dom) element[this._domName] = dom;
    }
};
/**
 * Add gradient dom to defs
 *
 * @param {SVGElement} dom DOM to be added to <defs>
 */ $ba1ede4f50d63d53$var$Definable.prototype.addDom = function(dom) {
    var defs = this.getDefs(true);
    defs.appendChild(dom);
};
/**
 * Remove DOM of a given element.
 *
 * @param {SVGElement} element element to remove dom
 */ $ba1ede4f50d63d53$var$Definable.prototype.removeDom = function(element) {
    var defs = this.getDefs(false);
    if (defs && element[this._domName]) {
        defs.removeChild(element[this._domName]);
        element[this._domName] = null;
    }
};
/**
 * Get DOMs of this element.
 *
 * @return {HTMLDomElement} doms of this defineable elements in <defs>
 */ $ba1ede4f50d63d53$var$Definable.prototype.getDoms = function() {
    var defs = this.getDefs(false);
    if (!defs) // No dom when defs is not defined
    return [];
    var doms = [];
    $ec279652dd95c27b$export$79b2f7037acddd43(this._tagNames, function(tagName) {
        var tags = defs.getElementsByTagName(tagName); // Note that tags is HTMLCollection, which is array-like
        // rather than real array.
        // So `doms.concat(tags)` add tags as one object.
        doms = doms.concat([].slice.call(tags));
    });
    return doms;
};
/**
 * Mark DOMs to be unused before painting, and clear unused ones at the end
 * of the painting.
 */ $ba1ede4f50d63d53$var$Definable.prototype.markAllUnused = function() {
    var doms = this.getDoms();
    var that = this;
    $ec279652dd95c27b$export$79b2f7037acddd43(doms, function(dom) {
        dom[that._markLabel] = $ba1ede4f50d63d53$var$MARK_UNUSED;
    });
};
/**
 * Mark a single DOM to be used.
 *
 * @param {SVGElement} dom DOM to mark
 */ $ba1ede4f50d63d53$var$Definable.prototype.markUsed = function(dom) {
    if (dom) dom[this._markLabel] = $ba1ede4f50d63d53$var$MARK_USED;
};
/**
 * Remove unused DOMs defined in <defs>
 */ $ba1ede4f50d63d53$var$Definable.prototype.removeUnused = function() {
    var defs = this.getDefs(false);
    if (!defs) // Nothing to remove
    return;
    var doms = this.getDoms();
    var that = this;
    $ec279652dd95c27b$export$79b2f7037acddd43(doms, function(dom) {
        if (dom[that._markLabel] !== $ba1ede4f50d63d53$var$MARK_USED) // Remove gradient
        defs.removeChild(dom);
    });
};
/**
 * Get SVG proxy.
 *
 * @param {Displayable} displayable displayable element
 * @return {Path|Image|Text} svg proxy of given element
 */ $ba1ede4f50d63d53$var$Definable.prototype.getSvgProxy = function(displayable) {
    if (displayable instanceof $b9701a0f23f767de$exports) return $ba1ede4f50d63d53$var$svgPath;
    else if (displayable instanceof $8d11db19115b899b$exports) return $ba1ede4f50d63d53$var$svgImage;
    else if (displayable instanceof $2fc81b997a587c68$exports) return $ba1ede4f50d63d53$var$svgText;
    else return $ba1ede4f50d63d53$var$svgPath;
};
/**
 * Get text SVG element.
 *
 * @param {Displayable} displayable displayable element
 * @return {SVGElement} SVG element of text
 */ $ba1ede4f50d63d53$var$Definable.prototype.getTextSvgElement = function(displayable) {
    return displayable.__textSvgEl;
};
/**
 * Get SVG element.
 *
 * @param {Displayable} displayable displayable element
 * @return {SVGElement} SVG element
 */ $ba1ede4f50d63d53$var$Definable.prototype.getSvgElement = function(displayable) {
    return displayable.__svgEl;
};
var $ba1ede4f50d63d53$var$_default = $ba1ede4f50d63d53$var$Definable;
$ba1ede4f50d63d53$exports = $ba1ede4f50d63d53$var$_default;





/**
 * @file Manages SVG gradient elements.
 * @author Zhang Wenli
 */ /**
 * Manages SVG gradient elements.
 *
 * @class
 * @extends Definable
 * @param   {number}     zrId    zrender instance id
 * @param   {SVGElement} svgRoot root of SVG document
 */ function $062d7ae82084d0fc$var$GradientManager(zrId, svgRoot) {
    $ba1ede4f50d63d53$exports.call(this, zrId, svgRoot, [
        "linearGradient",
        "radialGradient"
    ], "__gradient_in_use__");
}
$ec279652dd95c27b$export$69f1b2dcda23c5f8($062d7ae82084d0fc$var$GradientManager, $ba1ede4f50d63d53$exports);
/**
 * Create new gradient DOM for fill or stroke if not exist,
 * but will not update gradient if exists.
 *
 * @param {SvgElement}  svgElement   SVG element to paint
 * @param {Displayable} displayable  zrender displayable element
 */ $062d7ae82084d0fc$var$GradientManager.prototype.addWithoutUpdate = function(svgElement, displayable) {
    if (displayable && displayable.style) {
        var that = this;
        $ec279652dd95c27b$export$79b2f7037acddd43([
            "fill",
            "stroke"
        ], function(fillOrStroke) {
            if (displayable.style[fillOrStroke] && (displayable.style[fillOrStroke].type === "linear" || displayable.style[fillOrStroke].type === "radial")) {
                var gradient = displayable.style[fillOrStroke];
                var defs = that.getDefs(true); // Create dom in <defs> if not exists
                var dom;
                if (gradient._dom) {
                    // Gradient exists
                    dom = gradient._dom;
                    if (!defs.contains(gradient._dom)) // _dom is no longer in defs, recreate
                    that.addDom(dom);
                } else // New dom
                dom = that.add(gradient);
                that.markUsed(displayable);
                var id = dom.getAttribute("id");
                svgElement.setAttribute(fillOrStroke, "url(#" + id + ")");
            }
        });
    }
};
/**
 * Add a new gradient tag in <defs>
 *
 * @param   {Gradient} gradient zr gradient instance
 * @return {SVGLinearGradientElement | SVGRadialGradientElement}
 *                            created DOM
 */ $062d7ae82084d0fc$var$GradientManager.prototype.add = function(gradient) {
    var dom;
    if (gradient.type === "linear") dom = this.createElement("linearGradient");
    else if (gradient.type === "radial") dom = this.createElement("radialGradient");
    else {
        $5067a17fa0db893f$exports("Illegal gradient type.");
        return null;
    } // Set dom id with gradient id, since each gradient instance
    // will have no more than one dom element.
    // id may exists before for those dirty elements, in which case
    // id should remain the same, and other attributes should be
    // updated.
    gradient.id = gradient.id || this.nextId++;
    dom.setAttribute("id", "zr" + this._zrId + "-gradient-" + gradient.id);
    this.updateDom(gradient, dom);
    this.addDom(dom);
    return dom;
};
/**
 * Update gradient.
 *
 * @param {Gradient} gradient zr gradient instance
 */ $062d7ae82084d0fc$var$GradientManager.prototype.update = function(gradient) {
    var that = this;
    $ba1ede4f50d63d53$exports.prototype.update.call(this, gradient, function() {
        var type = gradient.type;
        var tagName = gradient._dom.tagName;
        if (type === "linear" && tagName === "linearGradient" || type === "radial" && tagName === "radialGradient") // Gradient type is not changed, update gradient
        that.updateDom(gradient, gradient._dom);
        else {
            // Remove and re-create if type is changed
            that.removeDom(gradient);
            that.add(gradient);
        }
    });
};
/**
 * Update gradient dom
 *
 * @param {Gradient} gradient zr gradient instance
 * @param {SVGLinearGradientElement | SVGRadialGradientElement} dom
 *                            DOM to update
 */ $062d7ae82084d0fc$var$GradientManager.prototype.updateDom = function(gradient, dom) {
    if (gradient.type === "linear") {
        dom.setAttribute("x1", gradient.x);
        dom.setAttribute("y1", gradient.y);
        dom.setAttribute("x2", gradient.x2);
        dom.setAttribute("y2", gradient.y2);
    } else if (gradient.type === "radial") {
        dom.setAttribute("cx", gradient.x);
        dom.setAttribute("cy", gradient.y);
        dom.setAttribute("r", gradient.r);
    } else {
        $5067a17fa0db893f$exports("Illegal gradient type.");
        return;
    }
    if (gradient.global) // x1, x2, y1, y2 in range of 0 to canvas width or height
    dom.setAttribute("gradientUnits", "userSpaceOnUse");
    else // x1, x2, y1, y2 in range of 0 to 1
    dom.setAttribute("gradientUnits", "objectBoundingBox");
     // Remove color stops if exists
    dom.innerHTML = ""; // Add color stops
    var colors = gradient.colorStops;
    for(var i = 0, len = colors.length; i < len; ++i){
        var stop = this.createElement("stop");
        stop.setAttribute("offset", colors[i].offset * 100 + "%");
        var color = colors[i].color;
        if (color.indexOf("rgba") > -1) {
            // Fix Safari bug that stop-color not recognizing alpha #9014
            var opacity = $b1179c91b052e827$export$98e6a39c04603d36(color)[3];
            var hex = $b1179c91b052e827$export$7ea66e3774a60b67(color); // stop-color cannot be color, since:
            // The opacity value used for the gradient calculation is the
            // *product* of the value of stop-opacity and the opacity of the
            // value of stop-color.
            // See https://www.w3.org/TR/SVG2/pservers.html#StopOpacityProperty
            stop.setAttribute("stop-color", "#" + hex);
            stop.setAttribute("stop-opacity", opacity);
        } else stop.setAttribute("stop-color", colors[i].color);
        dom.appendChild(stop);
    } // Store dom element in gradient, to avoid creating multiple
    // dom instances for the same gradient element
    gradient._dom = dom;
};
/**
 * Mark a single gradient to be used
 *
 * @param {Displayable} displayable displayable element
 */ $062d7ae82084d0fc$var$GradientManager.prototype.markUsed = function(displayable) {
    if (displayable.style) {
        var gradient = displayable.style.fill;
        if (gradient && gradient._dom) $ba1ede4f50d63d53$exports.prototype.markUsed.call(this, gradient._dom);
        gradient = displayable.style.stroke;
        if (gradient && gradient._dom) $ba1ede4f50d63d53$exports.prototype.markUsed.call(this, gradient._dom);
    }
};
var $062d7ae82084d0fc$var$_default = $062d7ae82084d0fc$var$GradientManager;
$062d7ae82084d0fc$exports = $062d7ae82084d0fc$var$_default;


var $c065933b4d98e2e5$exports = {};



/**
 * @file Manages SVG clipPath elements.
 * @author Zhang Wenli
 */ /**
 * Manages SVG clipPath elements.
 *
 * @class
 * @extends Definable
 * @param   {number}     zrId    zrender instance id
 * @param   {SVGElement} svgRoot root of SVG document
 */ function $c065933b4d98e2e5$var$ClippathManager(zrId, svgRoot) {
    $ba1ede4f50d63d53$exports.call(this, zrId, svgRoot, "clipPath", "__clippath_in_use__");
}
$ec279652dd95c27b$export$69f1b2dcda23c5f8($c065933b4d98e2e5$var$ClippathManager, $ba1ede4f50d63d53$exports);
/**
 * Update clipPath.
 *
 * @param {Displayable} displayable displayable element
 */ $c065933b4d98e2e5$var$ClippathManager.prototype.update = function(displayable) {
    var svgEl = this.getSvgElement(displayable);
    if (svgEl) this.updateDom(svgEl, displayable.__clipPaths, false);
    var textEl = this.getTextSvgElement(displayable);
    if (textEl) // Make another clipPath for text, since it's transform
    // matrix is not the same with svgElement
    this.updateDom(textEl, displayable.__clipPaths, true);
    this.markUsed(displayable);
};
/**
 * Create an SVGElement of displayable and create a <clipPath> of its
 * clipPath
 *
 * @param {Displayable} parentEl  parent element
 * @param {ClipPath[]}  clipPaths clipPaths of parent element
 * @param {boolean}     isText    if parent element is Text
 */ $c065933b4d98e2e5$var$ClippathManager.prototype.updateDom = function(parentEl, clipPaths, isText) {
    if (clipPaths && clipPaths.length > 0) {
        // Has clipPath, create <clipPath> with the first clipPath
        var defs = this.getDefs(true);
        var clipPath = clipPaths[0];
        var clipPathEl;
        var id;
        var dom = isText ? "_textDom" : "_dom";
        if (clipPath[dom]) {
            // Use a dom that is already in <defs>
            id = clipPath[dom].getAttribute("id");
            clipPathEl = clipPath[dom]; // Use a dom that is already in <defs>
            if (!defs.contains(clipPathEl)) // This happens when set old clipPath that has
            // been previously removed
            defs.appendChild(clipPathEl);
        } else {
            // New <clipPath>
            id = "zr" + this._zrId + "-clip-" + this.nextId;
            ++this.nextId;
            clipPathEl = this.createElement("clipPath");
            clipPathEl.setAttribute("id", id);
            defs.appendChild(clipPathEl);
            clipPath[dom] = clipPathEl;
        } // Build path and add to <clipPath>
        var svgProxy = this.getSvgProxy(clipPath);
        if (clipPath.transform && clipPath.parent.invTransform && !isText) {
            /**
       * If a clipPath has a parent with transform, the transform
       * of parent should not be considered when setting transform
       * of clipPath. So we need to transform back from parent's
       * transform, which is done by multiplying parent's inverse
       * transform.
       */ // Store old transform
            var transform = Array.prototype.slice.call(clipPath.transform); // Transform back from parent, and brush path
            $6c6dd9610ba660f0$export$6e3a27864ab166fe(clipPath.transform, clipPath.parent.invTransform, clipPath.transform);
            svgProxy.brush(clipPath); // Set back transform of clipPath
            clipPath.transform = transform;
        } else svgProxy.brush(clipPath);
        var pathEl = this.getSvgElement(clipPath);
        clipPathEl.innerHTML = "";
        /**
     * Use `cloneNode()` here to appendChild to multiple parents,
     * which may happend when Text and other shapes are using the same
     * clipPath. Since Text will create an extra clipPath DOM due to
     * different transform rules.
     */ clipPathEl.appendChild(pathEl.cloneNode());
        parentEl.setAttribute("clip-path", "url(#" + id + ")");
        if (clipPaths.length > 1) // Make the other clipPaths recursively
        this.updateDom(clipPathEl, clipPaths.slice(1), isText);
    } else // No clipPath
    if (parentEl) parentEl.setAttribute("clip-path", "none");
};
/**
 * Mark a single clipPath to be used
 *
 * @param {Displayable} displayable displayable element
 */ $c065933b4d98e2e5$var$ClippathManager.prototype.markUsed = function(displayable) {
    var that = this; // displayable.__clipPaths can only be `null`/`undefined` or an non-empty array.
    if (displayable.__clipPaths) $ec279652dd95c27b$export$79b2f7037acddd43(displayable.__clipPaths, function(clipPath) {
        if (clipPath._dom) $ba1ede4f50d63d53$exports.prototype.markUsed.call(that, clipPath._dom);
        if (clipPath._textDom) $ba1ede4f50d63d53$exports.prototype.markUsed.call(that, clipPath._textDom);
    });
};
var $c065933b4d98e2e5$var$_default = $c065933b4d98e2e5$var$ClippathManager;
$c065933b4d98e2e5$exports = $c065933b4d98e2e5$var$_default;


var $27cb5ddec84d78e5$exports = {};


/**
 * @file Manages SVG shadow elements.
 * @author Zhang Wenli
 */ /**
 * Manages SVG shadow elements.
 *
 * @class
 * @extends Definable
 * @param   {number}     zrId    zrender instance id
 * @param   {SVGElement} svgRoot root of SVG document
 */ function $27cb5ddec84d78e5$var$ShadowManager(zrId, svgRoot) {
    $ba1ede4f50d63d53$exports.call(this, zrId, svgRoot, [
        "filter"
    ], "__filter_in_use__", "_shadowDom");
}
$ec279652dd95c27b$export$69f1b2dcda23c5f8($27cb5ddec84d78e5$var$ShadowManager, $ba1ede4f50d63d53$exports);
/**
 * Create new shadow DOM for fill or stroke if not exist,
 * but will not update shadow if exists.
 *
 * @param {SvgElement}  svgElement   SVG element to paint
 * @param {Displayable} displayable  zrender displayable element
 */ $27cb5ddec84d78e5$var$ShadowManager.prototype.addWithoutUpdate = function(svgElement, displayable) {
    if (displayable && $27cb5ddec84d78e5$var$hasShadow(displayable.style)) {
        // Create dom in <defs> if not exists
        var dom;
        if (displayable._shadowDom) {
            // Gradient exists
            dom = displayable._shadowDom;
            var defs = this.getDefs(true);
            if (!defs.contains(displayable._shadowDom)) // _shadowDom is no longer in defs, recreate
            this.addDom(dom);
        } else // New dom
        dom = this.add(displayable);
        this.markUsed(displayable);
        var id = dom.getAttribute("id");
        svgElement.style.filter = "url(#" + id + ")";
    }
};
/**
 * Add a new shadow tag in <defs>
 *
 * @param {Displayable} displayable  zrender displayable element
 * @return {SVGFilterElement} created DOM
 */ $27cb5ddec84d78e5$var$ShadowManager.prototype.add = function(displayable) {
    var dom = this.createElement("filter"); // Set dom id with shadow id, since each shadow instance
    // will have no more than one dom element.
    // id may exists before for those dirty elements, in which case
    // id should remain the same, and other attributes should be
    // updated.
    displayable._shadowDomId = displayable._shadowDomId || this.nextId++;
    dom.setAttribute("id", "zr" + this._zrId + "-shadow-" + displayable._shadowDomId);
    this.updateDom(displayable, dom);
    this.addDom(dom);
    return dom;
};
/**
 * Update shadow.
 *
 * @param {Displayable} displayable  zrender displayable element
 */ $27cb5ddec84d78e5$var$ShadowManager.prototype.update = function(svgElement, displayable) {
    var style = displayable.style;
    if ($27cb5ddec84d78e5$var$hasShadow(style)) {
        var that = this;
        $ba1ede4f50d63d53$exports.prototype.update.call(this, displayable, function() {
            that.updateDom(displayable, displayable._shadowDom);
        });
    } else // Remove shadow
    this.remove(svgElement, displayable);
};
/**
 * Remove DOM and clear parent filter
 */ $27cb5ddec84d78e5$var$ShadowManager.prototype.remove = function(svgElement, displayable) {
    if (displayable._shadowDomId != null) {
        this.removeDom(svgElement);
        svgElement.style.filter = "";
    }
};
/**
 * Update shadow dom
 *
 * @param {Displayable} displayable  zrender displayable element
 * @param {SVGFilterElement} dom DOM to update
 */ $27cb5ddec84d78e5$var$ShadowManager.prototype.updateDom = function(displayable, dom) {
    var domChild = dom.getElementsByTagName("feDropShadow");
    if (domChild.length === 0) domChild = this.createElement("feDropShadow");
    else domChild = domChild[0];
    var style = displayable.style;
    var scaleX = displayable.scale ? displayable.scale[0] || 1 : 1;
    var scaleY = displayable.scale ? displayable.scale[1] || 1 : 1; // TODO: textBoxShadowBlur is not supported yet
    var offsetX;
    var offsetY;
    var blur;
    var color;
    if (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY) {
        offsetX = style.shadowOffsetX || 0;
        offsetY = style.shadowOffsetY || 0;
        blur = style.shadowBlur;
        color = style.shadowColor;
    } else if (style.textShadowBlur) {
        offsetX = style.textShadowOffsetX || 0;
        offsetY = style.textShadowOffsetY || 0;
        blur = style.textShadowBlur;
        color = style.textShadowColor;
    } else {
        // Remove shadow
        this.removeDom(dom, style);
        return;
    }
    domChild.setAttribute("dx", offsetX / scaleX);
    domChild.setAttribute("dy", offsetY / scaleY);
    domChild.setAttribute("flood-color", color); // Divide by two here so that it looks the same as in canvas
    // See: https://html.spec.whatwg.org/multipage/canvas.html#dom-context-2d-shadowblur
    var stdDx = blur / 2 / scaleX;
    var stdDy = blur / 2 / scaleY;
    var stdDeviation = stdDx + " " + stdDy;
    domChild.setAttribute("stdDeviation", stdDeviation); // Fix filter clipping problem
    dom.setAttribute("x", "-100%");
    dom.setAttribute("y", "-100%");
    dom.setAttribute("width", Math.ceil(blur / 2 * 200) + "%");
    dom.setAttribute("height", Math.ceil(blur / 2 * 200) + "%");
    dom.appendChild(domChild); // Store dom element in shadow, to avoid creating multiple
    // dom instances for the same shadow element
    displayable._shadowDom = dom;
};
/**
 * Mark a single shadow to be used
 *
 * @param {Displayable} displayable displayable element
 */ $27cb5ddec84d78e5$var$ShadowManager.prototype.markUsed = function(displayable) {
    if (displayable._shadowDom) $ba1ede4f50d63d53$exports.prototype.markUsed.call(this, displayable._shadowDom);
};
function $27cb5ddec84d78e5$var$hasShadow(style) {
    // TODO: textBoxShadowBlur is not supported yet
    return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY || style.textShadowBlur || style.textShadowOffsetX || style.textShadowOffsetY);
}
var $27cb5ddec84d78e5$var$_default = $27cb5ddec84d78e5$var$ShadowManager;
$27cb5ddec84d78e5$exports = $27cb5ddec84d78e5$var$_default;



var $7f039beb86fc00b6$var$svgPath = $1a93e11b8812f478$export$bb654e07daaf8c3a;
var $7f039beb86fc00b6$var$svgImage = $1a93e11b8812f478$export$5c452ff88e35e47d;
var $7f039beb86fc00b6$var$svgText = $1a93e11b8812f478$export$6f093cfa640b7166;
/**
 * SVG Painter
 * @module zrender/svg/Painter
 */ function $7f039beb86fc00b6$var$parseInt10(val) {
    return parseInt(val, 10);
}
function $7f039beb86fc00b6$var$getSvgProxy(el) {
    if (el instanceof $b9701a0f23f767de$exports) return $7f039beb86fc00b6$var$svgPath;
    else if (el instanceof $8d11db19115b899b$exports) return $7f039beb86fc00b6$var$svgImage;
    else if (el instanceof $2fc81b997a587c68$exports) return $7f039beb86fc00b6$var$svgText;
    else return $7f039beb86fc00b6$var$svgPath;
}
function $7f039beb86fc00b6$var$checkParentAvailable(parent, child) {
    return child && parent && child.parentNode !== parent;
}
function $7f039beb86fc00b6$var$insertAfter(parent, child, prevSibling) {
    if ($7f039beb86fc00b6$var$checkParentAvailable(parent, child) && prevSibling) {
        var nextSibling = prevSibling.nextSibling;
        nextSibling ? parent.insertBefore(child, nextSibling) : parent.appendChild(child);
    }
}
function $7f039beb86fc00b6$var$prepend(parent, child) {
    if ($7f039beb86fc00b6$var$checkParentAvailable(parent, child)) {
        var firstChild = parent.firstChild;
        firstChild ? parent.insertBefore(child, firstChild) : parent.appendChild(child);
    }
} // function append(parent, child) {
//     if (checkParentAvailable(parent, child)) {
//         parent.appendChild(child);
//     }
// }
function $7f039beb86fc00b6$var$remove(parent, child) {
    if (child && parent && child.parentNode === parent) parent.removeChild(child);
}
function $7f039beb86fc00b6$var$getTextSvgElement(displayable) {
    return displayable.__textSvgEl;
}
function $7f039beb86fc00b6$var$getSvgElement(displayable) {
    return displayable.__svgEl;
}
/**
 * @alias module:zrender/svg/Painter
 * @constructor
 * @param {HTMLElement} root 绘图容器
 * @param {module:zrender/Storage} storage
 * @param {Object} opts
 */ var $7f039beb86fc00b6$var$SVGPainter = function(root, storage, opts, zrId) {
    this.root = root;
    this.storage = storage;
    this._opts = opts = $ec279652dd95c27b$export$8b58be045bf06082({}, opts || {});
    var svgDom = $7f039beb86fc00b6$var$createElement("svg");
    svgDom.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    svgDom.setAttribute("version", "1.1");
    svgDom.setAttribute("baseProfile", "full");
    svgDom.style.cssText = "user-select:none;position:absolute;left:0;top:0;";
    var bgRoot = $7f039beb86fc00b6$var$createElement("g");
    svgDom.appendChild(bgRoot);
    var svgRoot = $7f039beb86fc00b6$var$createElement("g");
    svgDom.appendChild(svgRoot);
    this.gradientManager = new $062d7ae82084d0fc$exports(zrId, svgRoot);
    this.clipPathManager = new $c065933b4d98e2e5$exports(zrId, svgRoot);
    this.shadowManager = new $27cb5ddec84d78e5$exports(zrId, svgRoot);
    var viewport = document.createElement("div");
    viewport.style.cssText = "overflow:hidden;position:relative";
    this._svgDom = svgDom;
    this._svgRoot = svgRoot;
    this._backgroundRoot = bgRoot;
    this._viewport = viewport;
    root.appendChild(viewport);
    viewport.appendChild(svgDom);
    this.resize(opts.width, opts.height);
    this._visibleList = [];
};
$7f039beb86fc00b6$var$SVGPainter.prototype = {
    constructor: $7f039beb86fc00b6$var$SVGPainter,
    getType: function() {
        return "svg";
    },
    getViewportRoot: function() {
        return this._viewport;
    },
    getSvgDom: function() {
        return this._svgDom;
    },
    getSvgRoot: function() {
        return this._svgRoot;
    },
    getViewportRootOffset: function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    },
    refresh: function() {
        var list = this.storage.getDisplayList(true);
        this._paintList(list);
    },
    setBackgroundColor: function(backgroundColor) {
        // TODO gradient
        // Insert a bg rect instead of setting background to viewport.
        // Otherwise, the exported SVG don't have background.
        if (this._backgroundRoot && this._backgroundNode) this._backgroundRoot.removeChild(this._backgroundNode);
        var bgNode = $7f039beb86fc00b6$var$createElement("rect");
        bgNode.setAttribute("width", this.getWidth());
        bgNode.setAttribute("height", this.getHeight());
        bgNode.setAttribute("x", 0);
        bgNode.setAttribute("y", 0);
        bgNode.setAttribute("id", 0);
        bgNode.style.fill = backgroundColor;
        this._backgroundRoot.appendChild(bgNode);
        this._backgroundNode = bgNode;
    },
    _paintList: function(list) {
        this.gradientManager.markAllUnused();
        this.clipPathManager.markAllUnused();
        this.shadowManager.markAllUnused();
        var svgRoot = this._svgRoot;
        var visibleList = this._visibleList;
        var listLen = list.length;
        var newVisibleList = [];
        var i;
        for(i = 0; i < listLen; i++){
            var displayable = list[i];
            var svgProxy = $7f039beb86fc00b6$var$getSvgProxy(displayable);
            var svgElement = $7f039beb86fc00b6$var$getSvgElement(displayable) || $7f039beb86fc00b6$var$getTextSvgElement(displayable);
            if (!displayable.invisible) {
                if (displayable.__dirty) {
                    svgProxy && svgProxy.brush(displayable); // Update clipPath
                    this.clipPathManager.update(displayable); // Update gradient and shadow
                    if (displayable.style) {
                        this.gradientManager.update(displayable.style.fill);
                        this.gradientManager.update(displayable.style.stroke);
                        this.shadowManager.update(svgElement, displayable);
                    }
                    displayable.__dirty = false;
                }
                newVisibleList.push(displayable);
            }
        }
        var diff = $730fd9803b5e2607$exports(visibleList, newVisibleList);
        var prevSvgElement; // First do remove, in case element moved to the head and do remove
        // after add
        for(i = 0; i < diff.length; i++){
            var item = diff[i];
            if (item.removed) for(var k = 0; k < item.count; k++){
                var displayable = visibleList[item.indices[k]];
                var svgElement = $7f039beb86fc00b6$var$getSvgElement(displayable);
                var textSvgElement = $7f039beb86fc00b6$var$getTextSvgElement(displayable);
                $7f039beb86fc00b6$var$remove(svgRoot, svgElement);
                $7f039beb86fc00b6$var$remove(svgRoot, textSvgElement);
            }
        }
        for(i = 0; i < diff.length; i++){
            var item = diff[i];
            if (item.added) for(var k = 0; k < item.count; k++){
                var displayable = newVisibleList[item.indices[k]];
                var svgElement = $7f039beb86fc00b6$var$getSvgElement(displayable);
                var textSvgElement = $7f039beb86fc00b6$var$getTextSvgElement(displayable);
                prevSvgElement ? $7f039beb86fc00b6$var$insertAfter(svgRoot, svgElement, prevSvgElement) : $7f039beb86fc00b6$var$prepend(svgRoot, svgElement);
                if (svgElement) $7f039beb86fc00b6$var$insertAfter(svgRoot, textSvgElement, svgElement);
                else if (prevSvgElement) $7f039beb86fc00b6$var$insertAfter(svgRoot, textSvgElement, prevSvgElement);
                else $7f039beb86fc00b6$var$prepend(svgRoot, textSvgElement);
                 // Insert text
                $7f039beb86fc00b6$var$insertAfter(svgRoot, textSvgElement, svgElement);
                prevSvgElement = textSvgElement || svgElement || prevSvgElement; // zrender.Text only create textSvgElement.
                this.gradientManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
                this.shadowManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
                this.clipPathManager.markUsed(displayable);
            }
            else if (!item.removed) for(var k = 0; k < item.count; k++){
                var displayable = newVisibleList[item.indices[k]];
                var svgElement = $7f039beb86fc00b6$var$getSvgElement(displayable);
                var textSvgElement = $7f039beb86fc00b6$var$getTextSvgElement(displayable);
                var svgElement = $7f039beb86fc00b6$var$getSvgElement(displayable);
                var textSvgElement = $7f039beb86fc00b6$var$getTextSvgElement(displayable);
                this.gradientManager.markUsed(displayable);
                this.gradientManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
                this.shadowManager.markUsed(displayable);
                this.shadowManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
                this.clipPathManager.markUsed(displayable);
                if (textSvgElement) // Insert text.
                $7f039beb86fc00b6$var$insertAfter(svgRoot, textSvgElement, svgElement);
                prevSvgElement = svgElement || textSvgElement || prevSvgElement;
            }
        }
        this.gradientManager.removeUnused();
        this.clipPathManager.removeUnused();
        this.shadowManager.removeUnused();
        this._visibleList = newVisibleList;
    },
    _getDefs: function(isForceCreating) {
        var svgRoot = this._svgDom;
        var defs = svgRoot.getElementsByTagName("defs");
        if (defs.length === 0) {
            // Not exist
            if (isForceCreating) {
                var defs = svgRoot.insertBefore($7f039beb86fc00b6$var$createElement("defs"), svgRoot.firstChild // Insert in the front of svg
                );
                if (!defs.contains) // IE doesn't support contains method
                defs.contains = function(el) {
                    var children = defs.children;
                    if (!children) return false;
                    for(var i = children.length - 1; i >= 0; --i){
                        if (children[i] === el) return true;
                    }
                    return false;
                };
                return defs;
            } else return null;
        } else return defs[0];
    },
    resize: function(width, height) {
        var viewport = this._viewport; // FIXME Why ?
        viewport.style.display = "none"; // Save input w/h
        var opts = this._opts;
        width != null && (opts.width = width);
        height != null && (opts.height = height);
        width = this._getSize(0);
        height = this._getSize(1);
        viewport.style.display = "";
        if (this._width !== width || this._height !== height) {
            this._width = width;
            this._height = height;
            var viewportStyle = viewport.style;
            viewportStyle.width = width + "px";
            viewportStyle.height = height + "px";
            var svgRoot = this._svgDom; // Set width by 'svgRoot.width = width' is invalid
            svgRoot.setAttribute("width", width);
            svgRoot.setAttribute("height", height);
        }
        if (this._backgroundNode) {
            this._backgroundNode.setAttribute("width", width);
            this._backgroundNode.setAttribute("height", height);
        }
    },
    /**
   * 获取绘图区域宽度
   */ getWidth: function() {
        return this._width;
    },
    /**
   * 获取绘图区域高度
   */ getHeight: function() {
        return this._height;
    },
    _getSize: function(whIdx) {
        var opts = this._opts;
        var wh = [
            "width",
            "height"
        ][whIdx];
        var cwh = [
            "clientWidth",
            "clientHeight"
        ][whIdx];
        var plt = [
            "paddingLeft",
            "paddingTop"
        ][whIdx];
        var prb = [
            "paddingRight",
            "paddingBottom"
        ][whIdx];
        if (opts[wh] != null && opts[wh] !== "auto") return parseFloat(opts[wh]);
        var root = this.root; // IE8 does not support getComputedStyle, but it use VML.
        var stl = document.defaultView.getComputedStyle(root);
        return (root[cwh] || $7f039beb86fc00b6$var$parseInt10(stl[wh]) || $7f039beb86fc00b6$var$parseInt10(root.style[wh])) - ($7f039beb86fc00b6$var$parseInt10(stl[plt]) || 0) - ($7f039beb86fc00b6$var$parseInt10(stl[prb]) || 0) | 0;
    },
    dispose: function() {
        this.root.innerHTML = "";
        this._svgRoot = this._backgroundRoot = this._svgDom = this._backgroundNode = this._viewport = this.storage = null;
    },
    clear: function() {
        if (this._viewport) this.root.removeChild(this._viewport);
    },
    toDataURL: function() {
        this.refresh();
        var html = encodeURIComponent(this._svgDom.outerHTML.replace(/></g, ">\n\r<"));
        return "data:image/svg+xml;charset=UTF-8," + html;
    }
}; // Not supported methods
function $7f039beb86fc00b6$var$createMethodNotSupport(method) {
    return function() {
        $5067a17fa0db893f$exports('In SVG mode painter not support method "' + method + '"');
    };
} // Unsuppoted methods
$ec279652dd95c27b$export$79b2f7037acddd43([
    "getLayer",
    "insertLayer",
    "eachLayer",
    "eachBuiltinLayer",
    "eachOtherLayer",
    "getLayers",
    "modLayer",
    "delLayer",
    "clearLayer",
    "pathToImage"
], function(name) {
    $7f039beb86fc00b6$var$SVGPainter.prototype[name] = $7f039beb86fc00b6$var$createMethodNotSupport(name);
});
var $7f039beb86fc00b6$var$_default = $7f039beb86fc00b6$var$SVGPainter;
$7f039beb86fc00b6$exports = $7f039beb86fc00b6$var$_default;


$27f7290e41b7f08f$var$registerPainter("svg", $7f039beb86fc00b6$exports);




var $91aec0fe3a4b98f2$var$_echarts2 = $91aec0fe3a4b98f2$var$_interopRequireDefault($5451110f8ff557ba$exports);
var $b020df8179666ac8$exports = {};
"use strict";
Object.defineProperty($b020df8179666ac8$exports, "__esModule", {
    value: true
});
$b020df8179666ac8$exports["default"] = undefined;
var $b020df8179666ac8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $b020df8179666ac8$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $tZqWC = parcelRequire("tZqWC");
var $b020df8179666ac8$var$_react2 = $b020df8179666ac8$var$_interopRequireDefault($tZqWC);

var $4L3zM = parcelRequire("4L3zM");
var $b020df8179666ac8$var$_propTypes2 = $b020df8179666ac8$var$_interopRequireDefault($4L3zM);
var $dea2b9fa8ff3f04c$exports = {};
"use strict";
var $dea2b9fa8ff3f04c$var$isArray = Array.isArray;
var $dea2b9fa8ff3f04c$var$keyList = Object.keys;
var $dea2b9fa8ff3f04c$var$hasProp = Object.prototype.hasOwnProperty;
$dea2b9fa8ff3f04c$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        var arrA = $dea2b9fa8ff3f04c$var$isArray(a), arrB = $dea2b9fa8ff3f04c$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $dea2b9fa8ff3f04c$var$keyList(a);
        length = keys.length;
        if (length !== $dea2b9fa8ff3f04c$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$dea2b9fa8ff3f04c$var$hasProp.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
};


var $b020df8179666ac8$var$_fastDeepEqual2 = $b020df8179666ac8$var$_interopRequireDefault($dea2b9fa8ff3f04c$exports);
var $787299f11414d4bc$exports = {};
"use strict";
Object.defineProperty($787299f11414d4bc$exports, "__esModule", {
    value: true
});
$787299f11414d4bc$exports.ver = $787299f11414d4bc$exports.clear = $787299f11414d4bc$exports.bind = void 0;
var $5455e1871d3919a1$exports = {};
"use strict";
Object.defineProperty($5455e1871d3919a1$exports, "__esModule", {
    value: true
});
$5455e1871d3919a1$exports.removeSensor = $5455e1871d3919a1$exports.getSensor = void 0;

var $5455e1871d3919a1$var$_id = $5455e1871d3919a1$var$_interopRequireDefault((parcelRequire("lJJrC")));
var $9805b9fbf97131b3$exports = {};
"use strict";
Object.defineProperty($9805b9fbf97131b3$exports, "__esModule", {
    value: true
});
$9805b9fbf97131b3$exports.createSensor = void 0;
var $0e2927c09788b369$exports = {};
"use strict";
Object.defineProperty($0e2927c09788b369$exports, "__esModule", {
    value: true
});
$0e2927c09788b369$exports.createSensor = void 0;

var $0e2927c09788b369$var$_debounce = $0e2927c09788b369$var$_interopRequireDefault((parcelRequire("b0nUT")));
var $c87d7fac23d139d4$exports = {};
"use strict";
Object.defineProperty($c87d7fac23d139d4$exports, "__esModule", {
    value: true
});
$c87d7fac23d139d4$exports.SensorTabIndex = $c87d7fac23d139d4$exports.SensorClassName = $c87d7fac23d139d4$exports.SizeSensorId = void 0;
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $c87d7fac23d139d4$var$SizeSensorId = "size-sensor-id";
$c87d7fac23d139d4$exports.SizeSensorId = $c87d7fac23d139d4$var$SizeSensorId;
var $c87d7fac23d139d4$var$SensorClassName = "size-sensor-object";
$c87d7fac23d139d4$exports.SensorClassName = $c87d7fac23d139d4$var$SensorClassName;
var $c87d7fac23d139d4$var$SensorTabIndex = "-1";
$c87d7fac23d139d4$exports.SensorTabIndex = $c87d7fac23d139d4$var$SensorTabIndex;


function $0e2927c09788b369$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $0e2927c09788b369$var$createSensor = function createSensor(element) {
    var sensor = undefined; // callback
    var listeners = [];
    /**
   * create object DOM of sensor
   * @returns {HTMLObjectElement}
   */ var newSensor = function newSensor() {
        // adjust style
        if (getComputedStyle(element).position === "static") element.style.position = "relative";
        var obj = document.createElement("object");
        obj.onload = function() {
            obj.contentDocument.defaultView.addEventListener("resize", resizeListener); // 直接触发一次 resize
            resizeListener();
        };
        obj.style.display = "block";
        obj.style.position = "absolute";
        obj.style.top = "0";
        obj.style.left = "0";
        obj.style.height = "100%";
        obj.style.width = "100%";
        obj.style.overflow = "hidden";
        obj.style.pointerEvents = "none";
        obj.style.zIndex = "-1";
        obj.style.opacity = "0";
        obj.setAttribute("class", $c87d7fac23d139d4$exports.SensorClassName);
        obj.setAttribute("tabindex", $c87d7fac23d139d4$exports.SensorTabIndex);
        obj.type = "text/html"; // append into dom
        element.appendChild(obj); // for ie, should set data attribute delay, or will be white screen
        obj.data = "about:blank";
        return obj;
    };
    /**
   * trigger listeners
   */ var resizeListener = (0, $0e2927c09788b369$var$_debounce["default"])(function() {
        // trigger all listener
        listeners.forEach(function(listener) {
            listener(element);
        });
    });
    /**
   * listen with one callback function
   * @param cb
   */ var bind = function bind(cb) {
        // if not exist sensor, then create one
        if (!sensor) sensor = newSensor();
        if (listeners.indexOf(cb) === -1) listeners.push(cb);
    };
    /**
   * destroy all
   */ var destroy = function destroy() {
        if (sensor && sensor.parentNode) {
            if (sensor.contentDocument) // remote event
            sensor.contentDocument.defaultView.removeEventListener("resize", resizeListener);
             // remove dom
            sensor.parentNode.removeChild(sensor); // initial variable
            sensor = undefined;
            listeners = [];
        }
    };
    /**
   * cancel listener bind
   * @param cb
   */ var unbind = function unbind(cb) {
        var idx = listeners.indexOf(cb);
        if (idx !== -1) listeners.splice(idx, 1);
         // no listener, and sensor is exist
        // then destroy the sensor
        if (listeners.length === 0 && sensor) destroy();
    };
    return {
        element: element,
        bind: bind,
        destroy: destroy,
        unbind: unbind
    };
};
$0e2927c09788b369$exports.createSensor = $0e2927c09788b369$var$createSensor;


var $8b2f77537f316d23$exports = {};
"use strict";
Object.defineProperty($8b2f77537f316d23$exports, "__esModule", {
    value: true
});
$8b2f77537f316d23$exports.createSensor = void 0;

var $8b2f77537f316d23$var$_debounce = $8b2f77537f316d23$var$_interopRequireDefault((parcelRequire("b0nUT")));
function $8b2f77537f316d23$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * Created by hustcc on 18/7/5.
 * Contract: i@hust.cc
 */ var $8b2f77537f316d23$var$createSensor = function createSensor(element) {
    var sensor = undefined; // callback
    var listeners = [];
    /**
   * trigger listeners
   */ var resizeListener = (0, $8b2f77537f316d23$var$_debounce["default"])(function() {
        // trigger all
        listeners.forEach(function(listener) {
            listener(element);
        });
    });
    /**
   * create ResizeObserver sensor
   * @returns
   */ var newSensor = function newSensor() {
        var s = new ResizeObserver(resizeListener); // listen element
        s.observe(element); // trigger once
        resizeListener();
        return s;
    };
    /**
   * listen with callback
   * @param cb
   */ var bind = function bind(cb) {
        if (!sensor) sensor = newSensor();
        if (listeners.indexOf(cb) === -1) listeners.push(cb);
    };
    /**
   * destroy
   */ var destroy = function destroy() {
        sensor.disconnect();
        listeners = [];
        sensor = undefined;
    };
    /**
   * cancel bind
   * @param cb
   */ var unbind = function unbind(cb) {
        var idx = listeners.indexOf(cb);
        if (idx !== -1) listeners.splice(idx, 1);
         // no listener, and sensor is exist
        // then destroy the sensor
        if (listeners.length === 0 && sensor) destroy();
    };
    return {
        element: element,
        bind: bind,
        destroy: destroy,
        unbind: unbind
    };
};
$8b2f77537f316d23$exports.createSensor = $8b2f77537f316d23$var$createSensor;


/**
 * Created by hustcc on 18/7/5.
 * Contract: i@hust.cc
 */ /**
 * sensor strategies
 */ // export const createSensor = createObjectSensor;
var $9805b9fbf97131b3$var$createSensor = typeof ResizeObserver !== "undefined" ? $8b2f77537f316d23$exports.createSensor : $0e2927c09788b369$exports.createSensor;
$9805b9fbf97131b3$exports.createSensor = $9805b9fbf97131b3$var$createSensor;



function $5455e1871d3919a1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ /**
 * all the sensor objects.
 * sensor pool
 */ var $5455e1871d3919a1$var$Sensors = {};
/**
 * get one sensor
 * @param element
 * @returns {*}
 */ var $5455e1871d3919a1$var$getSensor = function getSensor(element) {
    var sensorId = element.getAttribute($c87d7fac23d139d4$exports.SizeSensorId); // 1. if the sensor exists, then use it
    if (sensorId && $5455e1871d3919a1$var$Sensors[sensorId]) return $5455e1871d3919a1$var$Sensors[sensorId];
     // 2. not exist, then create one
    var newId = (0, $5455e1871d3919a1$var$_id["default"])();
    element.setAttribute($c87d7fac23d139d4$exports.SizeSensorId, newId);
    var sensor = (0, $9805b9fbf97131b3$exports.createSensor)(element); // add sensor into pool
    $5455e1871d3919a1$var$Sensors[newId] = sensor;
    return sensor;
};
/**
 * 移除 sensor
 * @param sensor
 */ $5455e1871d3919a1$exports.getSensor = $5455e1871d3919a1$var$getSensor;
var $5455e1871d3919a1$var$removeSensor = function removeSensor(sensor) {
    var sensorId = sensor.element.getAttribute($c87d7fac23d139d4$exports.SizeSensorId); // remove attribute
    sensor.element.removeAttribute($c87d7fac23d139d4$exports.SizeSensorId); // remove event, dom of the sensor used
    sensor.destroy(); // exist, then remove from pool
    if (sensorId && $5455e1871d3919a1$var$Sensors[sensorId]) delete $5455e1871d3919a1$var$Sensors[sensorId];
};
$5455e1871d3919a1$exports.removeSensor = $5455e1871d3919a1$var$removeSensor;


/**
 * Created by hustcc on 18/6/9.[高考时间]
 * Contract: i@hust.cc
 */ /**
 * bind an element with resize callback function
 * @param {*} element
 * @param {*} cb
 */ var $787299f11414d4bc$var$bind = function bind(element, cb) {
    var sensor = (0, $5455e1871d3919a1$exports.getSensor)(element); // listen with callback
    sensor.bind(cb); // return unbind function
    return function() {
        sensor.unbind(cb);
    };
};
/**
 * clear all the listener and sensor of an element
 * @param element
 */ $787299f11414d4bc$exports.bind = $787299f11414d4bc$var$bind;
var $787299f11414d4bc$var$clear = function clear(element) {
    var sensor = (0, $5455e1871d3919a1$exports.getSensor)(element);
    (0, $5455e1871d3919a1$exports.removeSensor)(sensor);
};
$787299f11414d4bc$exports.clear = $787299f11414d4bc$var$clear;
var $787299f11414d4bc$var$ver = "1.0.1";
$787299f11414d4bc$exports.ver = $787299f11414d4bc$var$ver;


var $2e65300da8f19add$exports = {};
"use strict";
Object.defineProperty($2e65300da8f19add$exports, "__esModule", {
    value: true
});
/* eslint-disable import/prefer-default-export */ var $2e65300da8f19add$var$pick = $2e65300da8f19add$exports.pick = function pick(obj, keys) {
    var r = {};
    keys.forEach(function(key) {
        r[key] = obj[key];
    });
    return r;
};


function $b020df8179666ac8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b020df8179666ac8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b020df8179666ac8$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b020df8179666ac8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $b020df8179666ac8$var$EchartsReactCore = function(_Component) {
    $b020df8179666ac8$var$_inherits(EchartsReactCore, _Component);
    function EchartsReactCore(props) {
        $b020df8179666ac8$var$_classCallCheck(this, EchartsReactCore);
        var _this = $b020df8179666ac8$var$_possibleConstructorReturn(this, (EchartsReactCore.__proto__ || Object.getPrototypeOf(EchartsReactCore)).call(this, props));
        _this.getEchartsInstance = function() {
            return _this.echartsLib.getInstanceByDom(_this.echartsElement) || _this.echartsLib.init(_this.echartsElement, _this.props.theme, _this.props.opts);
        };
        _this.dispose = function() {
            if (_this.echartsElement) {
                try {
                    (0, $787299f11414d4bc$exports.clear)(_this.echartsElement);
                } catch (e) {
                    console.warn(e);
                }
                // dispose echarts instance
                _this.echartsLib.dispose(_this.echartsElement);
            }
        };
        _this.rerender = function() {
            var _this$props = _this.props, onEvents = _this$props.onEvents, onChartReady = _this$props.onChartReady;
            var echartObj = _this.renderEchartDom();
            _this.bindEvents(echartObj, onEvents || {});
            // on chart ready
            if (typeof onChartReady === "function") _this.props.onChartReady(echartObj);
            // on resize
            if (_this.echartsElement) (0, $787299f11414d4bc$exports.bind)(_this.echartsElement, function() {
                try {
                    echartObj.resize();
                } catch (e) {
                    console.warn(e);
                }
            });
        };
        _this.bindEvents = function(instance, events) {
            var _bindEvent = function _bindEvent(eventName, func) {
                // ignore the event config which not satisfy
                if (typeof eventName === "string" && typeof func === "function") // binding event
                // instance.off(eventName); // 已经 dispose 在重建，所以无需 off 操作
                instance.on(eventName, function(param) {
                    func(param, instance);
                });
            };
            // loop and bind
            for(var eventName in events)if (Object.prototype.hasOwnProperty.call(events, eventName)) _bindEvent(eventName, events[eventName]);
        };
        _this.renderEchartDom = function() {
            // init the echart object
            var echartObj = _this.getEchartsInstance();
            // set the echart option
            echartObj.setOption(_this.props.option, _this.props.notMerge || false, _this.props.lazyUpdate || false);
            // set loading mask
            if (_this.props.showLoading) echartObj.showLoading(_this.props.loadingOption || null);
            else echartObj.hideLoading();
            return echartObj;
        };
        _this.echartsLib = props.echarts; // the echarts object.
        _this.echartsElement = null; // echarts div element
        return _this;
    }
    // first add
    $b020df8179666ac8$var$_createClass(EchartsReactCore, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.rerender();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                // 判断是否需要 setOption，由开发者自己来确定。默认为 true
                if (typeof this.props.shouldSetOption === "function" && !this.props.shouldSetOption(prevProps, this.props)) return;
                // 以下属性修改的时候，需要 dispose 之后再新建
                // 1. 切换 theme 的时候
                // 2. 修改 opts 的时候
                // 3. 修改 onEvents 的时候，这样可以取消所有之前绑定的事件 issue #151
                if (!(0, $b020df8179666ac8$var$_fastDeepEqual2["default"])(prevProps.theme, this.props.theme) || !(0, $b020df8179666ac8$var$_fastDeepEqual2["default"])(prevProps.opts, this.props.opts) || !(0, $b020df8179666ac8$var$_fastDeepEqual2["default"])(prevProps.onEvents, this.props.onEvents)) {
                    this.dispose();
                    this.rerender(); // 重建
                    return;
                }
                // 当这些属性保持不变的时候，不 setOption
                var pickKeys = [
                    "option",
                    "notMerge",
                    "lazyUpdate",
                    "showLoading",
                    "loadingOption"
                ];
                if ((0, $b020df8179666ac8$var$_fastDeepEqual2["default"])((0, $2e65300da8f19add$exports.pick)(this.props, pickKeys), (0, $2e65300da8f19add$exports.pick)(prevProps, pickKeys))) return;
                var echartObj = this.renderEchartDom();
                // 样式修改的时候，可能会导致大小变化，所以触发一下 resize
                if (!(0, $b020df8179666ac8$var$_fastDeepEqual2["default"])(prevProps.style, this.props.style) || !(0, $b020df8179666ac8$var$_fastDeepEqual2["default"])(prevProps.className, this.props.className)) try {
                    echartObj.resize();
                } catch (e) {
                    console.warn(e);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.dispose();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _props = this.props, style = _props.style, className = _props.className;
                var newStyle = $b020df8179666ac8$var$_extends({
                    height: 300
                }, style);
                // for render
                return $b020df8179666ac8$var$_react2["default"].createElement("div", {
                    ref: function ref(e) {
                        _this2.echartsElement = e;
                    },
                    style: newStyle,
                    className: "echarts-for-react " + className
                });
            }
        }
    ]);
    return EchartsReactCore;
}($tZqWC.Component);
$b020df8179666ac8$exports["default"] = $b020df8179666ac8$var$EchartsReactCore;
$b020df8179666ac8$var$EchartsReactCore.propTypes = {
    option: $b020df8179666ac8$var$_propTypes2["default"].object.isRequired,
    echarts: $b020df8179666ac8$var$_propTypes2["default"].object,
    notMerge: $b020df8179666ac8$var$_propTypes2["default"].bool,
    lazyUpdate: $b020df8179666ac8$var$_propTypes2["default"].bool,
    style: $b020df8179666ac8$var$_propTypes2["default"].object,
    className: $b020df8179666ac8$var$_propTypes2["default"].string,
    theme: $b020df8179666ac8$var$_propTypes2["default"].oneOfType([
        $b020df8179666ac8$var$_propTypes2["default"].string,
        $b020df8179666ac8$var$_propTypes2["default"].object
    ]),
    onChartReady: $b020df8179666ac8$var$_propTypes2["default"].func,
    showLoading: $b020df8179666ac8$var$_propTypes2["default"].bool,
    loadingOption: $b020df8179666ac8$var$_propTypes2["default"].object,
    onEvents: $b020df8179666ac8$var$_propTypes2["default"].object,
    opts: $b020df8179666ac8$var$_propTypes2["default"].shape({
        devicePixelRatio: $b020df8179666ac8$var$_propTypes2["default"].number,
        renderer: $b020df8179666ac8$var$_propTypes2["default"].oneOf([
            "canvas",
            "svg"
        ]),
        width: $b020df8179666ac8$var$_propTypes2["default"].oneOfType([
            $b020df8179666ac8$var$_propTypes2["default"].number,
            $b020df8179666ac8$var$_propTypes2["default"].oneOf([
                null,
                undefined,
                "auto"
            ])
        ]),
        height: $b020df8179666ac8$var$_propTypes2["default"].oneOfType([
            $b020df8179666ac8$var$_propTypes2["default"].number,
            $b020df8179666ac8$var$_propTypes2["default"].oneOf([
                null,
                undefined,
                "auto"
            ])
        ])
    }),
    shouldSetOption: $b020df8179666ac8$var$_propTypes2["default"].func
};
$b020df8179666ac8$var$EchartsReactCore.defaultProps = {
    echarts: {},
    notMerge: false,
    lazyUpdate: false,
    style: {},
    className: "",
    theme: null,
    onChartReady: function onChartReady() {},
    showLoading: false,
    loadingOption: null,
    onEvents: {},
    opts: {},
    shouldSetOption: function shouldSetOption() {
        return true;
    }
};


var $91aec0fe3a4b98f2$var$_core2 = $91aec0fe3a4b98f2$var$_interopRequireDefault($b020df8179666ac8$exports);
function $91aec0fe3a4b98f2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $91aec0fe3a4b98f2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $91aec0fe3a4b98f2$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $91aec0fe3a4b98f2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// export the Component the echarts Object.
var $91aec0fe3a4b98f2$var$EchartsReact = function(_EchartsReactCore) {
    $91aec0fe3a4b98f2$var$_inherits(EchartsReact, _EchartsReactCore);
    function EchartsReact(props) {
        $91aec0fe3a4b98f2$var$_classCallCheck(this, EchartsReact);
        var _this = $91aec0fe3a4b98f2$var$_possibleConstructorReturn(this, (EchartsReact.__proto__ || Object.getPrototypeOf(EchartsReact)).call(this, props));
        _this.echartsLib = $91aec0fe3a4b98f2$var$_echarts2["default"];
        return _this;
    }
    return EchartsReact;
}($91aec0fe3a4b98f2$var$_core2["default"]);
$91aec0fe3a4b98f2$exports["default"] = $91aec0fe3a4b98f2$var$EchartsReact;



const $278d03a6c99b0e98$export$a47039c72d6669b0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;


function $61ce6ebd375cea76$var$NodeChart(props) {
    // Destructure
    const { options: options, style: style, onEvents: onEvents, chartRef: chartRef } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $278d03a6c99b0e98$export$a47039c72d6669b0), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($91aec0fe3a4b98f2$exports))), {
            ref: chartRef,
            style: style,
            option: options,
            onEvents: onEvents,
            notMerge: true,
            lazyUpdate: true
        })
    });
}
// Default Props
$61ce6ebd375cea76$var$NodeChart.defaultProps = {
    chartRef: {},
    options: {},
    style: {},
    onEvents: {}
};
// Proptypes Validation
$61ce6ebd375cea76$var$NodeChart.propTypes = {
    chartRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object),
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object),
    style: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object),
    onEvents: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
};
var $61ce6ebd375cea76$export$2e2bcd8739ae039 = $61ce6ebd375cea76$var$NodeChart;


var $a218f196e5f67e75$export$2e2bcd8739ae039 = (0, $61ce6ebd375cea76$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $dccfc3fa5541d693$export$473cf89ff8915e5f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
	position: relative;
	height: 100%;
	width: 100%;
`;


function $f70b79b6de73f405$var$HorizontalBarChart(props) {
    const { data: data, options: options } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dccfc3fa5541d693$export$473cf89ff8915e5f), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $70bae84a94585e38$exports.HorizontalBar), {
            options: options,
            data: data
        })
    });
}
// Default Props
$f70b79b6de73f405$var$HorizontalBarChart.defaultProps = {
    data: {},
    options: {}
};
// Proptypes Validation
$f70b79b6de73f405$var$HorizontalBarChart.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $f70b79b6de73f405$export$2e2bcd8739ae039 = $f70b79b6de73f405$var$HorizontalBarChart;


var $17a3afb6e0e3a44f$export$2e2bcd8739ae039 = (0, $f70b79b6de73f405$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $a37399d110c5e175$export$ac319665d120df29 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 5px;
`;
const $a37399d110c5e175$export$56d3f3c43edacc7b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
  width: 28px;
  border: 1px solid ${({ theme: theme })=>theme.colors.darkGray};
  color: ${({ theme: theme })=>theme.colors.darkGray};
  border-radius: 5px;
  font-size: 15px;

  ${({ theme: theme, isActive: isActive })=>isActive && `color: ${theme.colors.yellowGreen};`}
  ${({ theme: theme, isActive: isActive })=>isActive && `border: 1px solid ${theme.colors.yellowGreen};`}
  ${({ isActive: isActive })=>isActive && "font-weight: 700;"}
`;


function $7765cf63393968ba$var$NumberedChart(props) {
    // Destructure
    const { numOfBlocks: numOfBlocks, activeNumber: activeNumber } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a37399d110c5e175$export$ac319665d120df29), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a37399d110c5e175$export$56d3f3c43edacc7b), {
                isActive: activeNumber === 0,
                children: "0"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a37399d110c5e175$export$56d3f3c43edacc7b), {
                isActive: activeNumber === 1,
                children: "1"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a37399d110c5e175$export$56d3f3c43edacc7b), {
                isActive: activeNumber === 2,
                children: "2"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a37399d110c5e175$export$56d3f3c43edacc7b), {
                isActive: activeNumber === 3,
                children: "3"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a37399d110c5e175$export$56d3f3c43edacc7b), {
                isActive: activeNumber === 4,
                children: "4"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a37399d110c5e175$export$56d3f3c43edacc7b), {
                isActive: activeNumber > 4,
                children: "+"
            })
        ]
    });
}
// Default Props
$7765cf63393968ba$var$NumberedChart.defaultProps = {
    activeNumber: 0,
    numOfBlocks: 3
};
// Proptypes Validation
$7765cf63393968ba$var$NumberedChart.propTypes = {
    activeNumber: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    numOfBlocks: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
};
var $7765cf63393968ba$export$2e2bcd8739ae039 = $7765cf63393968ba$var$NumberedChart;


var $7a1b412fc5fb14d1$export$2e2bcd8739ae039 = (0, $7765cf63393968ba$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $ad7b6c38afb49dfc$export$858bfd02c3f2fba5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $51b32cf9efbde13e$export$2b77a92f1a5ad772))`
  padding: 0;
  color: ${({ theme: theme })=>theme.colors.darkGray};

  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  margin: 0 auto;

  & .modal-content {
    padding: 0;
    background-color: ${({ theme: theme })=>theme.colors.white};
    border: 1px solid ${({ theme: theme })=>`${theme.colors.gray}80`};
    border-radius: 10px;
  }
`;


function $77d58b2f532fb38c$var$Modal(props) {
    // Destructure
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ad7b6c38afb49dfc$export$858bfd02c3f2fba5), {
        ...rest,
        children: children
    });
}
// Default Props
$77d58b2f532fb38c$var$Modal.defaultProps = {
    children: ""
};
// Proptypes Validation
$77d58b2f532fb38c$var$Modal.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $77d58b2f532fb38c$export$2e2bcd8739ae039 = $77d58b2f532fb38c$var$Modal;


var $0cb604e8ac00d438$export$2e2bcd8739ae039 = (0, $77d58b2f532fb38c$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $605c81e7e5c62281$export$e833dfe35f2086ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $51b32cf9efbde13e$export$cb540d8b0ef7906c))`
  padding: 10px 25px;
  max-height: 60vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  & * {
    text-align: center;
  }
`;


function $1e2098883e348366$var$ModalBody(props) {
    // Destructure
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $605c81e7e5c62281$export$e833dfe35f2086ee), {
        ...rest,
        children: children
    });
}
// Default Props
$1e2098883e348366$var$ModalBody.defaultProps = {
    children: ""
};
// Proptypes Validation
$1e2098883e348366$var$ModalBody.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $1e2098883e348366$export$2e2bcd8739ae039 = $1e2098883e348366$var$ModalBody;


var $5a83d1c72fcd9217$export$2e2bcd8739ae039 = (0, $1e2098883e348366$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $e4c5b774e0c4b7b6$export$47042699470e17dd = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $51b32cf9efbde13e$export$519437715052e656))`
  padding: 25px;
  border-top: 1px solid ${({ theme: theme })=>theme.colors.lightGray};

  display: flex;
  flex-direction: column;
  align-items: center;

  & * {
    text-align: center;
  }
`;


function $79f0f322df77dafe$var$ModalFooter(props) {
    // Destructure
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e4c5b774e0c4b7b6$export$47042699470e17dd), {
        ...rest,
        children: children
    });
}
// Default Props
$79f0f322df77dafe$var$ModalFooter.defaultProps = {
    children: ""
};
// Proptypes Validation
$79f0f322df77dafe$var$ModalFooter.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $79f0f322df77dafe$export$2e2bcd8739ae039 = $79f0f322df77dafe$var$ModalFooter;


var $b07759276f5d7f2d$export$2e2bcd8739ae039 = (0, $79f0f322df77dafe$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $8d60fac67d76c212$export$6033693e6adc1906 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  border: none;
  padding: 25px;
  border-bottom: 1px solid ${({ theme: theme })=>theme.colors.lightGray};
`;
const $8d60fac67d76c212$export$6bbe9e2fb05afc62 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 18px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  & * {
    text-align: center;
  }
`;
const $8d60fac67d76c212$export$799d5582e2c9544c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  transition: 0.4s;
  cursor: pointer;
  position: absolute;
  right: 25px;
  top: 25px;

  & svg {
    fill: ${({ theme: theme })=>theme.colors.gray};
  }
  & svg * path {
    fill: ${({ theme: theme })=>theme.colors.gray};
  }
  &:hover {
    transform: scale(1.2);
  }
`;



function $a3e720aafa7043e8$var$ModalHeader(props) {
    // Destructure
    const { children: children, close: close, toggle: toggle, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8d60fac67d76c212$export$6033693e6adc1906), {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8d60fac67d76c212$export$6bbe9e2fb05afc62), {
                children: children
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8d60fac67d76c212$export$799d5582e2c9544c), {
                onClick: toggle,
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f8b21e6e39ef8af9$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
// Default Props
$a3e720aafa7043e8$var$ModalHeader.defaultProps = {
    children: "",
    close: "",
    toggle: ()=>{}
};
// Proptypes Validation
$a3e720aafa7043e8$var$ModalHeader.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    close: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $a3e720aafa7043e8$export$2e2bcd8739ae039 = $a3e720aafa7043e8$var$ModalHeader;


var $6e660ada3ebfb268$export$2e2bcd8739ae039 = (0, $a3e720aafa7043e8$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $7eb18ad25584009a$export$abd0141a73cbad48 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  transition: all 0.5s ease-in-out;
`;
const $7eb18ad25584009a$export$3b0d6d7590275603 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 6px;
  background: ${({ theme: theme })=>theme.colors.darkGray};
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    background: ${({ theme: theme })=>theme.colors.blue};
    animation: box-1 1500ms cubic-bezier(0.65, 0.81, 0.73, 0.4) infinite;
  }

  &:after {
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    background: ${({ theme: theme })=>theme.colors.blue};
    animation: box-2 1500ms cubic-bezier(0.16, 0.84, 0.44, 1) infinite;
    animation-delay: 9000ms;
  }

  @keyframes box-1 {
    0% {
      left: -35%;
      right: 100%;
    }
    60%,
    100% {
      left: 100%;
      right: -90%;
    }
  }
  @keyframes box-2 {
    0% {
      left: -200%;
      right: 100%;
    }
    60%,
    100% {
      left: 107%;
      right: -8%;
    }
  }
`;


function $5b2507d91b5598e9$var$LoaderLine(props) {
    // Destructure
    const { show: show } = props;
    return show && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7eb18ad25584009a$export$abd0141a73cbad48), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7eb18ad25584009a$export$3b0d6d7590275603), {})
    });
}
// Default Props
$5b2507d91b5598e9$var$LoaderLine.defaultProps = {
    show: false
};
// Proptypes Validation
$5b2507d91b5598e9$var$LoaderLine.propTypes = {
    show: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $5b2507d91b5598e9$export$2e2bcd8739ae039 = $5b2507d91b5598e9$var$LoaderLine;


var $715f0d2ea48e4c84$export$2e2bcd8739ae039 = (0, $5b2507d91b5598e9$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $0c5f83a232eda52f$export$d720433ce0720d73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $0c5f83a232eda52f$export$3b0d6d7590275603 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div.attrs((props)=>({
        // Props
        width: props.width || "80px",
        height: props.height || "80px",
        thickness: props.thickness || "8px"
    }))`

  display: inline-block;
  position: relative;
  height: ${(props)=>props.height};
  width: ${(props)=>props.width};
  margin: 15px;

  & div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    border: ${(props)=>props.thickness} solid ${({ theme: theme })=>theme.colors.blue};
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${({ theme: theme })=>theme.colors.blue} transparent transparent transparent;
  }
  & div:nth-child(1) {
    animation-delay: -0.45s;
  }
  & div:nth-child(2) {
    animation-delay: -0.3s;
  }
  & div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;


function $55844bc5a65b0bca$var$LoaderCircle(props) {
    // Destructure
    const { height: height, width: width, thickness: thickness } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0c5f83a232eda52f$export$d720433ce0720d73), {
        height: height,
        width: width,
        thickness: thickness,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0c5f83a232eda52f$export$3b0d6d7590275603), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {})
            ]
        })
    });
}
// Default Props
$55844bc5a65b0bca$var$LoaderCircle.defaultProps = {
    height: "",
    width: "",
    thickness: ""
};
// Proptypes Validation
$55844bc5a65b0bca$var$LoaderCircle.propTypes = {
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    thickness: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $55844bc5a65b0bca$export$2e2bcd8739ae039 = $55844bc5a65b0bca$var$LoaderCircle;


var $a6fa6c8d0625529f$export$2e2bcd8739ae039 = (0, $55844bc5a65b0bca$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $a6e603242055fdb5$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;


function $ac7f5e87e63c8d1f$var$LoaderWrapper(props) {
    const { children: children } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a6e603242055fdb5$export$e6dfd72ab29f8598), {
        children: [
            " ",
            children
        ]
    });
}
// Default Props
$ac7f5e87e63c8d1f$var$LoaderWrapper.defaultProps = {
    children: ""
};
// Proptypes Validation
$ac7f5e87e63c8d1f$var$LoaderWrapper.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $ac7f5e87e63c8d1f$export$2e2bcd8739ae039 = $ac7f5e87e63c8d1f$var$LoaderWrapper;


var $0167b1f2e06350fb$export$2e2bcd8739ae039 = (0, $ac7f5e87e63c8d1f$export$2e2bcd8739ae039);





const $66db7561c1b80723$export$eb14d77622ea348d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;

  display: flex;
  justify-content: center;
  align-items: center;
`;
const $66db7561c1b80723$export$5a30a9425f4ff973 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 18px;
  padding: 15px 35px;

  border-radius: 5px;
  background-color: white;
  border: ${({ theme: theme })=>`solid 1px ${theme.colors.lightGray}`};
`;


function $7708429b3625dac4$var$LoadingPage() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $66db7561c1b80723$export$eb14d77622ea348d), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $66db7561c1b80723$export$5a30a9425f4ff973), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6fa6c8d0625529f$export$2e2bcd8739ae039), {})
        })
    });
}
var $7708429b3625dac4$export$2e2bcd8739ae039 = $7708429b3625dac4$var$LoadingPage;


var $120944b12d5f4a62$export$2e2bcd8739ae039 = (0, $7708429b3625dac4$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

const $14d469e3b50c8c0d$export$b685374fb421789a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;

  display: flex;
  justify-content: center;
  align-items: center;
`;
const $14d469e3b50c8c0d$export$195f5480bcc8c49d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 500px;
  border-radius: 10px;
  background-color: ${({ theme: theme })=>theme.colors.white};
  border: ${({ theme: theme })=>`solid 1px ${theme.colors.gray}`};
`;
const $14d469e3b50c8c0d$export$7a4750f19a624026 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 10px 30px;
  border-bottom: ${({ theme: theme })=>`solid 1px ${theme.colors.gray}`};
`;
const $14d469e3b50c8c0d$export$ee377b57e77bfb9b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 50px 30px;
`;
const $14d469e3b50c8c0d$export$288b095a729ca5f8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  text-align: center;
  font-size: 15px;

  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $14d469e3b50c8c0d$export$e98d2e18340017d2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  text-align: center;
  font-size: 22px;

  color: ${({ theme: theme })=>theme.colors.darkGray};
`;


function $bbed925ea79855e0$var$NoAccess() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14d469e3b50c8c0d$export$b685374fb421789a), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $14d469e3b50c8c0d$export$195f5480bcc8c49d), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14d469e3b50c8c0d$export$7a4750f19a624026), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14d469e3b50c8c0d$export$e98d2e18340017d2), {
                        children: "Authorization Needed"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14d469e3b50c8c0d$export$ee377b57e77bfb9b), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $14d469e3b50c8c0d$export$288b095a729ca5f8), {
                        children: [
                            "You currently do not have access to this feature. Please contact",
                            " ",
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("a", {
                                href: "sales@ospree.io",
                                children: "(sales@ospree.io)"
                            }),
                            " for more information."
                        ]
                    })
                })
            ]
        })
    });
}
var $bbed925ea79855e0$export$2e2bcd8739ae039 = $bbed925ea79855e0$var$NoAccess;


var $bb6cb7de1cdd9d3b$export$2e2bcd8739ae039 = (0, $bbed925ea79855e0$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $5795c30de138bdef$export$6ce170286acaa8d3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  height: fit-content;
  padding: 20px 0 0 0;

  display: flex;
  justify-content: center;
`;


function $ba9b69b62334fc5f$var$PageWrapper(props) {
    // Destructure
    const { children: children } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5795c30de138bdef$export$6ce170286acaa8d3), {
        children: children
    });
}
// Default Props
$ba9b69b62334fc5f$var$PageWrapper.defaultProps = {
    children: ""
};
// Proptypes Validation
$ba9b69b62334fc5f$var$PageWrapper.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $ba9b69b62334fc5f$export$2e2bcd8739ae039 = $ba9b69b62334fc5f$var$PageWrapper;


var $14870abc08ac0dc0$export$2e2bcd8739ae039 = (0, $ba9b69b62334fc5f$export$2e2bcd8739ae039);


/* eslint-disable max-len */ /* eslint-disable react/prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

// Auth

var $f3d855b3ff65dabd$exports = {};

$f3d855b3ff65dabd$exports = (parcelRequire("aBwLi"));


// export const BASE_URL = 'https://api.ospree.io'
// export const BASE_URL = 'https://sandbox.ospree.io'
// export const DEMO_URL = 'https://flowapi-dev-new.ospree.io'
// TODO Switch back to original url
const $78597906e6a0205e$export$ca6dda5263526f75 = "https://api.ospree.io";
const $78597906e6a0205e$export$7ee62d82c1b5ddae = "https://api.ospree.io";
const $78597906e6a0205e$export$6c611141e7030bb8 = "https://api.ospree.io";
const $78597906e6a0205e$export$a675fe6880411505 = "http://localhost:8000";
const $78597906e6a0205e$export$1deab063ed687beb = "http://localhost:8000";
const $78597906e6a0205e$export$91dfeeea81b01f2f = "http://localhost:8000";
const $78597906e6a0205e$export$2a267d68982d9895 = "http://localhost:8000";
const $78597906e6a0205e$export$1736ebf7cf11dd7a = "http://localhost:8000";
const $78597906e6a0205e$export$36dac04bc644e0bf = {
    GET_ADDRESS_VERIFICATION: "/api/ui/analytics/verification",
    POST_ADDRESS_VERIFICATION: "/api/ui/analytics/verification"
};


const $e29db2de9829c254$var$accessToken = JSON.parse(localStorage.getItem("userCredentials"))?.access_token;
const $e29db2de9829c254$export$456995facc43eda = (baseURL)=>(0, (/*@__PURE__*/$parcel$interopDefault($f3d855b3ff65dabd$exports))).create({
        baseURL: baseURL,
        headers: {
            Authorization: `Bearer ${$e29db2de9829c254$var$accessToken}`
        }
    });
const $e29db2de9829c254$export$38b0b8222efbc769 = $e29db2de9829c254$export$456995facc43eda((0, $78597906e6a0205e$export$ca6dda5263526f75));
// Logging out user if token expires
$e29db2de9829c254$export$38b0b8222efbc769.interceptors.response.use((response)=>response, (error)=>{
    if (error?.response?.status === 401 || error?.response?.status === 403) {
        localStorage.setItem("userCredentials", "{}");
        window.location.reload();
    }
    return Promise.reject(error);
});
const $e29db2de9829c254$export$170e87424a0d64a3 = (0, (/*@__PURE__*/$parcel$interopDefault($f3d855b3ff65dabd$exports))).create({
    baseURL: (0, $78597906e6a0205e$export$ca6dda5263526f75)
});



// export const authAxiosLocalServer = createAxiosInstance(USER_SERVICE_URL)
const $8d805eff8308ac63$var$handler = (0, $e29db2de9829c254$export$170e87424a0d64a3);
const $8d805eff8308ac63$export$430f6593c0173bc3 = async ({ cipher_text: cipher_text })=>{
    const response = await $8d805eff8308ac63$var$handler.get(`${(0, $78597906e6a0205e$export$36dac04bc644e0bf).GET_ADDRESS_VERIFICATION}/${cipher_text}`);
    const { data: data } = response.data;
    return data;
};
const $8d805eff8308ac63$export$e0d05bbd7c45e832 = async ({ signature: signature, cipher_text: cipher_text, pubkey: pubkey = null })=>{
    const response = await $8d805eff8308ac63$var$handler.post(`${(0, $78597906e6a0205e$export$36dac04bc644e0bf).POST_ADDRESS_VERIFICATION}/${cipher_text}`, {
        signature: signature,
        pubkey: pubkey
    });
    const { data: data } = response.data;
    return data;
};


var $9a07e0c7f683589b$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getAddressVerification, data: getAddressVerificationData, error: getAddressVerificationError, isLoading: isGetAddressVerificationLoading, isSuccess: isGetAddressVerificationSuccess, isError: isGetAddressVerificationError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8d805eff8308ac63$export$430f6593c0173bc3));
    return {
        getAddressVerification: getAddressVerification,
        getAddressVerificationData: getAddressVerificationData,
        getAddressVerificationError: getAddressVerificationError,
        isGetAddressVerificationLoading: isGetAddressVerificationLoading,
        isGetAddressVerificationSuccess: isGetAddressVerificationSuccess,
        isGetAddressVerificationError: isGetAddressVerificationError
    };
};




var $6e46db22cfb8b835$export$2e2bcd8739ae039 = ()=>{
    const { mutate: postAddressVerification, data: postAddressVerificationData, error: postAddressVerificationError, isLoading: isPostAddressVerificationLoading, isSuccess: isPostAddressVerificationSuccess, isError: isPostAddressVerificationError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8d805eff8308ac63$export$e0d05bbd7c45e832));
    return {
        postAddressVerification: postAddressVerification,
        postAddressVerificationData: postAddressVerificationData,
        postAddressVerificationError: postAddressVerificationError,
        isPostAddressVerificationLoading: isPostAddressVerificationLoading,
        isPostAddressVerificationSuccess: isPostAddressVerificationSuccess,
        isPostAddressVerificationError: isPostAddressVerificationError
    };
};






parcelRequire("tZqWC");
/* eslint-disable react/prop-types */ /* eslint-disable react/destructuring-assignment */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $49013d5f2a966e04$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || "25",
        height: props?.size || "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M0.859428 9.59853L0.859453 9.59843C2.46161 3.16918 8.97341 -0.743507 15.4015 0.859207L15.4015 0.859213C21.8312 2.46194 25.744 8.97413 24.1411 15.403C22.5382 21.8314 16.0261 25.7435 9.5959 24.1407C3.16893 22.538 -0.743847 16.0266 0.859428 9.59853Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M18.0122 10.7194C18.2607 9.05608 16.9941 8.16194 15.2623 7.56546L15.8241 5.31235L14.4521 4.97055L13.9051 7.16429C13.5449 7.07445 13.1746 6.98968 12.8066 6.9057L13.3574 4.69751L11.9866 4.35571L11.4244 6.60805C11.1259 6.54008 10.8329 6.47289 10.5485 6.40219L10.5501 6.39516L8.65844 5.92289L8.29356 7.38773C8.29356 7.38773 9.31125 7.62093 9.28976 7.63538C9.8453 7.77406 9.94609 8.14163 9.9289 8.43304L9.28898 10.9998C9.32727 11.0096 9.37688 11.0236 9.43158 11.0455L9.28703 11.0096L8.38966 14.6053C8.32169 14.774 8.1494 15.0271 7.76108 14.9311C7.77475 14.951 6.76409 14.6822 6.76409 14.6822L6.08315 16.2525L7.86851 16.6974C8.20058 16.7807 8.52601 16.8678 8.84596 16.9498L8.27832 19.2291L9.6484 19.5709L10.211 17.3162C10.5848 17.4178 10.9482 17.5115 11.3037 17.5998L10.7434 19.8439L12.1151 20.1857L12.6827 17.9111C15.0217 18.3537 16.7808 18.1752 17.5204 16.0603C18.1169 14.3572 17.4911 13.3748 16.2605 12.7338C17.1567 12.5264 17.8317 11.9369 18.0118 10.7194H18.0122ZM14.8779 15.1135C14.4536 16.8166 11.5861 15.8963 10.6559 15.665L11.4091 12.6459C12.3389 12.8779 15.3201 13.3373 14.8783 15.1135H14.8779ZM15.3018 10.6947C14.915 12.244 12.528 11.4568 11.7533 11.2639L12.4362 8.52561C13.2109 8.71858 15.7049 9.07874 15.3018 10.6947V10.6947Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $10b6063c29a39aa7$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M24.5 12.5001C24.5 19.127 19.1275 24.5 12.5001 24.5C5.8729 24.5 0.5 19.127 0.5 12.5001C0.5 5.8726 5.87289 0.5 12.5001 0.5C19.1276 0.5 24.5 5.87249 24.5 12.5001Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M11.7697 15.9533L12.5816 12.8961L14.5038 12.1938L14.982 10.3971L14.9656 10.3525L13.0735 11.0438L14.4368 5.9104H10.5704L8.78753 12.6096L7.29895 13.1534L6.80708 15.0057L8.29453 14.4623L7.24375 18.4105H17.5337L18.1934 15.9533H11.7697Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $693a897af321fbd0$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || "25",
        height: props?.size || "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M24.5 12.5001C24.5 19.127 19.1275 24.5 12.5001 24.5C5.8729 24.5 0.5 19.127 0.5 12.5001C0.5 5.8726 5.87289 0.5 12.5001 0.5C19.1276 0.5 24.5 5.87249 24.5 12.5001Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("g", {
                opacity: "0.6",
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                    d: "M12.5116 10.4548L7.95 12.6468L12.5116 15.4943L17.0714 12.6468L12.5116 10.4548Z",
                    fill: "#00CACD"
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("g", {
                opacity: "0.45",
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                    d: "M7.95 12.6467L12.5116 15.4942V4.6499L7.95 12.6467Z",
                    fill: "#00CACD"
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("g", {
                opacity: "0.8",
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                    d: "M12.5116 4.6499V15.4942L17.0714 12.6467L12.5116 4.6499Z",
                    fill: "#00CACD"
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("g", {
                opacity: "0.45",
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                    d: "M7.95 13.5601L12.5116 20.3501V16.4075L7.95 13.5601Z",
                    fill: "#00CACD"
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("g", {
                opacity: "0.8",
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                    d: "M12.5116 16.4075V20.3501L17.075 13.5601L12.5116 16.4075Z",
                    fill: "#00CACD"
                })
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $f324264db230fc4b$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M332.838 167.716C320.274 139.226 291.404 133.135 256.061 139.036L244.703 95L217.926 101.916L229.094 145.825C222.051 147.602 214.817 149.124 207.647 151.155L196.48 107.5L169.703 114.416L181.061 158.452C175.287 160.102 127 172.475 127 172.475L134.36 201.155C134.36 201.155 154.03 195.635 153.84 196.079C164.754 193.223 169.893 198.68 172.305 203.82L203.523 324.505C203.904 327.995 203.269 333.959 195.782 335.99C196.226 336.244 176.302 341.003 176.302 341.003L179.221 374.442C179.221 374.442 227.063 362.195 233.345 360.609L244.83 405.152L271.607 398.236L260.122 353.376C267.482 351.662 274.652 349.886 281.632 348.046L293.053 392.652L319.83 385.736L308.345 341.256C349.589 331.231 378.713 305.216 372.749 265.431C368.942 241.447 342.736 221.777 320.972 219.556C334.36 207.69 341.15 190.368 332.838 167.716ZM319.957 272.728C325.287 312.132 270.528 316.954 252.444 321.713L236.708 262.766C254.855 258.008 310.947 238.02 319.957 272.728ZM286.962 192.462C292.609 227.487 245.782 231.548 230.68 235.419L216.34 181.929C231.505 178.185 275.477 160.038 286.962 192.462Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $246469410de6a91b$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M343.773 191.36C340.552 157.88 311.648 146.66 275.122 143.46V97H246.857V142.22C239.436 142.22 231.835 142.36 224.294 142.52V97H196.029L196.009 143.42C189.888 143.54 183.867 143.66 178.006 143.66V143.52L139.02 143.5V173.7C139.02 173.7 159.903 173.3 159.543 173.68C171.005 173.68 174.726 180.32 175.806 186.06V238.98C176.606 238.98 177.626 239.02 178.786 239.18H175.806L175.786 313.32C175.286 316.92 173.165 322.66 165.164 322.68C165.524 323 144.621 322.68 144.621 322.68L139 356.44H175.806C182.647 356.44 189.388 356.56 195.989 356.6L196.009 403.58H224.254V357.1C231.995 357.26 239.496 357.32 246.837 357.32L246.817 403.58H275.082V356.7C322.609 353.98 355.915 342 360.035 297.36C363.376 261.42 346.473 245.36 319.489 238.88C335.911 230.56 346.173 215.86 343.773 191.36ZM304.206 291.8C304.206 326.9 244.097 322.92 224.914 322.92V260.66C244.097 260.7 304.206 255.2 304.206 291.8ZM291.044 203.98C291.044 235.92 240.876 232.18 224.914 232.2V175.76C240.896 175.76 291.064 170.68 291.044 203.98Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M175.848 237.74H180.048V240.84H175.848V237.74Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $5f1c58de93ea5b96$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M148.74 306.866C150.551 305.056 153.04 304 155.68 304H395.082C399.457 304 401.644 309.28 398.552 312.372L351.26 359.664C349.449 361.475 346.96 362.531 344.32 362.531H104.918C100.543 362.531 98.3558 357.251 101.448 354.158L148.74 306.866Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M148.74 140.866C150.626 139.056 153.115 138 155.68 138H395.082C399.457 138 401.644 143.28 398.552 146.372L351.26 193.664C349.449 195.475 346.96 196.531 344.32 196.531H104.918C100.543 196.531 98.3558 191.251 101.448 188.158L148.74 140.866Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M351.26 223.866C349.449 222.056 346.96 221 344.32 221H104.918C100.543 221 98.3558 226.28 101.448 229.372L148.74 276.664C150.551 278.475 153.04 279.531 155.68 279.531H395.082C399.457 279.531 401.644 274.251 398.552 271.158L351.26 223.866Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $0ddebe1ec41e0909$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M332.838 167.716C320.274 139.226 291.404 133.135 256.061 139.036L244.703 95L217.926 101.916L229.094 145.825C222.051 147.602 214.817 149.124 207.647 151.155L196.48 107.5L169.703 114.416L181.061 158.452C175.287 160.102 127 172.475 127 172.475L134.36 201.155C134.36 201.155 154.03 195.635 153.84 196.079C164.754 193.223 169.893 198.68 172.305 203.82L203.523 324.505C203.904 327.995 203.269 333.959 195.782 335.99C196.226 336.244 176.302 341.003 176.302 341.003L179.221 374.442C179.221 374.442 227.063 362.195 233.345 360.609L244.83 405.152L271.607 398.236L260.122 353.376C267.482 351.662 274.652 349.886 281.632 348.046L293.053 392.652L319.83 385.736L308.345 341.256C349.589 331.231 378.713 305.216 372.749 265.431C368.942 241.447 342.736 221.777 320.972 219.556C334.36 207.69 341.15 190.368 332.838 167.716ZM319.957 272.728C325.287 312.132 270.528 316.954 252.444 321.713L236.708 262.766C254.855 258.008 310.947 238.02 319.957 272.728ZM286.962 192.462C292.609 227.487 245.782 231.548 230.68 235.419L216.34 181.929C231.505 178.185 275.477 160.038 286.962 192.462Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $5288db72d8c52b99$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M115 160.484V345.488L235.084 388.569V202.063L365 154.18L247.092 112L115 160.484Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M244.914 207.392V308.562L364.998 351.643V162.96L244.914 207.392Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $96050c0d7fe3900b$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M250 148C283.137 148 310 131.658 310 111.5C310 91.3416 283.137 75 250 75C216.863 75 190 91.3416 190 111.5C190 131.658 216.863 148 250 148Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M250 425C283.137 425 310 408.435 310 388C310 367.565 283.137 351 250 351C216.863 351 190 367.565 190 388C190 408.435 216.863 425 250 425Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M165.954 199.227C182.609 169.04 182.501 136.346 165.713 126.203C148.924 116.06 121.812 132.308 105.157 162.495C88.5018 192.681 88.6099 225.375 105.399 235.519C122.187 245.662 149.299 229.414 165.954 199.227Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M394.827 337.503C411.482 307.316 411.383 274.628 394.606 264.491C377.829 254.355 350.726 270.609 334.071 300.795C317.416 330.982 317.515 363.67 334.292 373.807C351.069 383.943 378.172 367.69 394.827 337.503Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M165.72 373.799C182.509 363.656 182.617 330.962 165.962 300.775C149.307 270.588 122.195 254.34 105.406 264.483C88.6177 274.627 88.5096 307.321 105.165 337.507C121.82 367.694 148.932 383.942 165.72 373.799Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M394.622 235.527C411.399 225.39 411.498 192.702 394.843 162.515C378.187 132.328 351.085 116.075 334.308 126.211C317.53 136.348 317.431 169.036 334.087 199.223C350.742 229.409 377.845 245.663 394.622 235.527Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $81d76cb7e7c41ae8$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M356.055 126H399.414L309.18 215.344C276.502 247.682 223.521 247.682 190.82 215.344L100.551 126H143.945L212.5 193.869C222.488 203.714 235.949 209.232 249.974 209.232C263.998 209.232 277.459 203.714 287.447 193.869L356.055 126Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M143.389 374.438H100L190.82 284.543C223.498 252.205 276.479 252.205 309.18 284.543L400 374.438H356.641L287.5 306.018C277.512 296.173 264.051 290.655 250.026 290.655C236.002 290.655 222.541 296.173 212.553 306.018L143.389 374.438Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable react/destructuring-assignment */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $0fb15270830db67a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || "25",
        height: props?.size || "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M148.74 306.866C150.551 305.056 153.04 304 155.68 304H395.082C399.457 304 401.644 309.28 398.552 312.372L351.26 359.664C349.449 361.475 346.96 362.531 344.32 362.531H104.918C100.543 362.531 98.3558 357.251 101.448 354.158L148.74 306.866Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M148.74 140.866C150.626 139.056 153.115 138 155.68 138H395.082C399.457 138 401.644 143.28 398.552 146.372L351.26 193.664C349.449 195.475 346.96 196.531 344.32 196.531H104.918C100.543 196.531 98.3558 191.251 101.448 188.158L148.74 140.866Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M351.26 223.866C349.449 222.056 346.96 221 344.32 221H104.918C100.543 221 98.3558 226.28 101.448 229.372L148.74 276.664C150.551 278.475 153.04 279.531 155.68 279.531H395.082C399.457 279.531 401.644 274.251 398.552 271.158L351.26 223.866Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $7d0256990b04896e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M357.658 156.217L321.535 174.621L147.102 263.468C146.512 258.97 146.215 254.437 146.213 249.9C146.237 231.797 150.99 214.014 160.002 198.312C169.013 182.611 181.97 169.536 197.589 160.383C213.208 151.23 230.948 146.317 249.05 146.129C267.152 145.941 284.99 150.486 300.795 159.314L321.471 148.779L324.556 147.205C305.615 133.458 283.242 125.215 259.91 123.388C236.578 121.56 213.194 126.22 192.344 136.851C171.495 147.482 153.99 163.671 141.766 183.628C129.541 203.586 123.073 226.534 123.075 249.938C123.075 253.171 123.198 256.39 123.443 259.597C123.787 264.139 122.78 268.68 120.548 272.651C118.317 276.621 114.961 279.843 110.903 281.911L100 287.47V313.401L132.099 297.04L142.494 291.735L152.737 286.518L336.626 192.822L357.29 182.3L400 160.532V134.614L357.658 156.217Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M400 186.476L163.183 307.054L142.52 317.602L100 339.268V365.173L142.228 343.66L178.351 325.255L352.962 236.281C353.552 240.809 353.849 245.371 353.85 249.938C353.839 268.062 349.087 285.869 340.067 301.589C331.047 317.31 318.072 330.397 302.43 339.553C286.789 348.709 269.024 353.615 250.901 353.783C232.777 353.951 214.925 349.376 199.116 340.512L197.846 341.185L175.432 352.608C194.368 366.356 216.736 374.601 240.065 376.433C263.393 378.264 286.775 373.611 307.624 362.987C328.474 352.363 345.981 336.182 358.211 316.232C370.441 296.282 376.917 273.339 376.925 249.938C376.925 246.676 376.798 243.414 376.557 240.19C376.214 235.65 377.22 231.11 379.449 227.14C381.678 223.17 385.03 219.948 389.084 217.877L400 212.318V186.476Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $764d9e0e87ef607d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M283.569 406.189C261.22 406.189 244.908 400.806 234.633 390.04C225.113 380.926 219.589 368.415 219.268 355.241C219.152 351.239 220.08 347.275 221.959 343.74C223.713 340.685 226.245 338.15 229.299 336.395C232.848 334.624 236.759 333.703 240.725 333.703C244.691 333.703 248.603 334.624 252.152 336.395C255.2 338.143 257.721 340.681 259.45 343.74C261.384 347.258 262.346 351.228 262.238 355.241C262.437 360.034 261.062 364.76 258.323 368.698C256.04 371.913 252.776 374.301 249.022 375.505C252.694 380.179 257.889 383.418 263.702 384.657C270.207 386.546 276.943 387.517 283.716 387.543C292.684 387.621 301.467 384.995 308.919 380.007C316.65 374.545 322.416 366.738 325.361 357.742C329.095 347.035 330.917 335.755 330.744 324.417C331.045 312.597 329.051 300.831 324.871 289.77C321.728 280.924 315.761 273.357 307.891 268.238C300.576 263.609 292.084 261.18 283.427 261.241C275.884 261.88 268.611 264.349 262.238 268.435L246.525 276.313V268.435L317.139 173.706H219.268V272.007C218.991 279.101 220.868 286.112 224.651 292.12C226.481 294.737 228.957 296.838 231.837 298.218C234.718 299.598 237.906 300.211 241.093 299.997C246.981 299.878 252.676 297.871 257.338 294.272C262.623 290.399 267.222 285.669 270.943 280.276C271.278 279.331 271.896 278.511 272.713 277.929C273.368 277.362 274.205 277.05 275.072 277.048C276.772 277.203 278.381 277.887 279.672 279.004C281.308 280.832 282.198 283.207 282.167 285.659C281.978 287.307 281.684 288.942 281.286 290.553C277.81 298.968 271.982 306.203 264.5 311.393C257.552 316.094 249.345 318.587 240.955 318.545C219.765 318.545 205.086 314.369 196.916 306.017C192.717 301.401 189.481 295.994 187.397 290.112C185.313 284.23 184.423 277.991 184.78 271.761V173.706H135V155.441H185.012V113.797L173.562 102.339V93H206.788L219.268 99.4604V155.441L348.554 155.048L361.426 167.967L282.15 247.628C286.939 245.702 291.983 244.482 297.123 244.007C307.296 244.452 317.222 247.286 326.098 252.278C336.376 257.163 345.038 264.893 351.057 274.551C356.45 282.727 360.267 291.839 362.312 301.417C363.994 308.972 364.896 316.68 365.004 324.419C365.056 339.19 361.708 353.773 355.217 367.041C349.062 379.889 338.702 390.248 325.854 396.404C312.703 402.884 298.23 406.233 283.569 406.189Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $14554b83f65116d4$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M318.758 286.665C318.758 250.208 296.883 237.708 253.133 232.5C221.883 228.333 215.633 220 215.633 205.415C215.633 190.83 226.051 181.458 246.883 181.458C265.633 181.458 276.051 187.708 281.258 203.333C282.301 206.458 285.426 208.54 288.551 208.54H305.216C309.383 208.54 312.508 205.415 312.508 201.25V200.208C308.341 177.29 289.591 159.583 265.633 157.5V132.5C265.633 128.333 262.508 125.208 257.301 124.165H241.676C237.508 124.165 234.383 127.29 233.341 132.5V156.458C202.091 160.625 182.301 181.458 182.301 207.5C182.301 241.875 203.133 255.415 246.883 260.625C276.051 265.833 285.426 272.083 285.426 288.75C285.426 305.418 270.841 316.875 251.051 316.875C223.966 316.875 214.591 305.415 211.466 289.79C210.426 285.625 207.301 283.54 204.176 283.54H186.466C182.301 283.54 179.176 286.665 179.176 290.833V291.875C183.341 317.915 200.008 336.665 234.383 341.875V366.875C234.383 371.04 237.508 374.165 242.716 375.208H258.341C262.508 375.208 265.633 372.083 266.676 366.875V341.875C297.926 336.665 318.758 314.79 318.758 286.665Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M196.884 396.04C115.634 366.875 73.9661 276.25 104.176 196.04C119.801 152.29 154.176 118.957 196.884 103.332C201.051 101.25 203.134 98.125 203.134 92.915V78.3325C203.134 74.165 201.051 71.04 196.884 70C195.841 70 193.759 70 192.716 71.04C93.7586 102.29 39.5911 207.5 70.8411 306.457C89.5911 364.79 134.384 409.582 192.716 428.332C196.884 430.415 201.051 428.332 202.091 424.165C203.134 423.125 203.134 422.082 203.134 420V405.415C203.134 402.29 200.009 398.125 196.884 396.04ZM307.301 71.04C303.134 68.9575 298.966 71.04 297.926 75.2075C296.884 76.25 296.884 77.29 296.884 79.375V93.9575C296.884 98.125 300.009 102.29 303.134 104.375C384.384 133.54 426.051 224.165 395.841 304.375C380.216 348.125 345.841 381.457 303.134 397.082C298.966 399.165 296.884 402.29 296.884 407.5V422.082C296.884 426.25 298.966 429.375 303.134 430.415C304.176 430.415 306.259 430.415 307.301 429.375C406.259 398.125 460.426 292.915 429.176 193.957C410.426 134.582 364.591 89.79 307.301 71.04Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $08e688c4253948d5$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M161.832 385.956L201.018 318.097L240.204 250.478L279.15 182.619L285.602 171.867L288.469 182.619L300.416 227.301L287.035 250.478L247.85 318.097L208.903 385.956H255.735L294.92 318.097L315.23 282.973L324.788 318.097L342.947 385.956H385L366.841 318.097L348.681 250.478L343.903 233.035L373.053 182.619H330.522L329.088 177.602L314.274 122.168L312.363 115H271.504L270.549 116.434L232.319 182.619L193.133 250.478L154.186 318.097L115 385.956H161.832Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $d97a97257806af92$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M325.333 137.764L273.169 215.178C269.562 220.45 276.498 226.831 281.493 222.392L332.825 177.719C334.212 176.609 336.154 177.442 336.154 179.384V318.951C336.154 320.893 333.657 321.726 332.547 320.339L177.164 134.434C172.17 128.33 164.956 125 156.909 125H151.36C136.931 125 125 136.931 125 151.637V348.085C125 362.791 136.931 374.723 151.637 374.723C160.794 374.723 169.395 370.006 174.39 361.959L226.554 284.545C230.161 279.273 223.224 272.891 218.23 277.331L166.898 321.726C165.511 322.836 163.568 322.003 163.568 320.061V180.771C163.568 178.829 166.065 177.997 167.175 179.384L322.558 365.289C327.553 371.393 335.044 374.723 342.814 374.723H348.363C363.069 374.723 375 362.791 375 348.085V151.637C375 136.931 363.069 125 348.363 125C338.929 125 330.327 129.717 325.333 137.764Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $6958b70b6fa7ab9a$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M154.051 172.385V234.77H137.026H120L120.276 250.491L120.551 266.212L137.301 266.486L154.051 266.759V328.621V390.483L201.801 390.733C272.669 391.103 276.491 390.85 297.505 384.38C341.393 370.868 369.101 337.801 378.209 288.07C381.348 270.932 381.368 234.642 378.247 217.624C372.973 188.864 362.876 167.441 346.31 149.864C325.494 127.777 297.367 115.155 259.84 111.06C254.358 110.461 229.212 110 202.09 110H154.051V172.385ZM266.551 164.845C277.163 167.717 291.145 174.593 298.527 180.57C310.986 190.659 320.575 206.365 325.222 224.289C327.315 232.364 327.544 235.396 327.486 254.234C327.429 272.426 327.139 276.211 325.29 282.88C317.629 310.508 300.874 327.776 274.051 335.688C267.231 337.701 263.854 337.94 236.801 338.328L207.051 338.757V302.734V266.711H236.051H265.051V250.741V234.77H236.051H207.051V198.228V161.687L232.801 162.184C255.079 162.614 259.63 162.972 266.551 164.845Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $e4b2dc73b6b2f3ce$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M326.562 198.469C321.094 195.344 314.062 195.344 307.812 198.469L264.062 224.25L234.375 240.656L191.406 266.438C185.937 269.563 178.906 269.563 172.656 266.438L139.062 246.125C133.594 243 129.687 236.75 129.687 229.719V190.656C129.687 184.406 132.812 178.156 139.062 174.25L172.656 154.719C178.125 151.594 185.156 151.594 191.406 154.719L225 175.031C230.469 178.156 234.375 184.406 234.375 191.438V217.219L264.062 200.031V173.469C264.062 167.219 260.937 160.969 254.687 157.062L192.187 120.344C186.719 117.219 179.687 117.219 173.437 120.344L109.375 157.844C103.125 160.969 100 167.219 100 173.469V246.906C100 253.156 103.125 259.406 109.375 263.313L172.656 300.031C178.125 303.156 185.156 303.156 191.406 300.031L234.375 275.031L264.062 257.844L307.031 232.844C312.5 229.719 319.531 229.719 325.781 232.844L359.375 252.375C364.844 255.5 368.75 261.75 368.75 268.781V307.844C368.75 314.094 365.625 320.344 359.375 324.25L326.562 343.781C321.094 346.906 314.062 346.906 307.812 343.781L274.219 324.25C268.75 321.125 264.844 314.875 264.844 307.844V282.844L235.156 300.031V325.813C235.156 332.063 238.281 338.313 244.531 342.219L307.812 378.937C313.281 382.062 320.312 382.062 326.562 378.937L389.844 342.219C395.312 339.094 399.219 332.844 399.219 325.813V251.594C399.219 245.344 396.094 239.094 389.844 235.188L326.562 198.469Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $c25f9c757c4815db$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M196.767 148.364L249.267 233.08H250.858L303.358 148.364H332.392L268.358 250.182L332.392 352H303.358L250.858 268.875H249.267L196.767 352H167.733L233.358 250.182L167.733 148.364H196.767Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M433 250L493 215.359V284.641L433 250Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $7d14ce0847df1b02$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "25",
        fill: "none",
        viewBox: "0 0 500 500",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fill: "#00CACD",
                stroke: "#00CACD",
                strokeWidth: "3",
                d: "M370.582 198.346l.016.015.017.014a8.407 8.407 0 012.793 7.578 37.391 37.391 0 01-3.829 5.627l-.012.014-.011.014c-6.007 7.668-38.756 47.575-70.028 85.594a80942.578 80942.578 0 01-59.677 72.467l-.998 1.21-.255.31-.065.078-.016.02-.004.005c-.001.001-.001.001 1.156.956l-1.157-.955-.02.025-.019.024v.001h-.001l-.003.005-.014.017-.054.072-.21.274a111.597 111.597 0 01-3.192 3.966c-.92 1.087-1.862 2.144-2.655 2.919-.4.391-.728.677-.974.855-.056.04-.1.07-.135.092h-.367c-.625-.081-1.387-.704-2.199-2.181-.778-1.416-1.334-3.128-1.752-4.424l-.008-.026-.01-.026c-6.264-17.245-24.208-60.199-43.481-106.336l-5.325-12.75c-21.16-50.675-42.778-102.689-51.593-127.18v-2.831l.106-.274.009-.025.009-.026a7.671 7.671 0 011.725-2.823l.652-.515a4.27 4.27 0 011.627-.624l.029.002c.089.006.221.019.403.04.362.042.87.111 1.522.207 1.303.193 3.139.488 5.445.874 4.612.772 11.075 1.904 18.857 3.292 15.561 2.777 36.377 6.579 58.146 10.589 38.958 7.175 80.964 15.013 101.37 18.821l6.143 1.146a14.205 14.205 0 014.017 2.265l.039.031.04.029.751.525c6.902 6.13 14.593 13.514 22.112 20.803 1.267 1.227 2.529 2.453 3.781 3.669 6.195 6.014 12.156 11.803 17.299 16.551zm-101.333 14.553l-4.409 3.657 5.635-1.026 80.597-14.673 2.961-.539-2.213-2.04-29.798-27.455-.964-.888-1.01.837-50.799 42.127zm-19.722-.438l.965.79.953-.804 54.047-45.58 2.426-2.046-3.121-.576-141.507-26.098-1.223 2.635 87.46 71.679zm8.604 16.141l-1.119.18-.132 1.126-12.824 108.873-.592 5.033 3.236-3.899 102.339-123.3 2.552-3.075-3.945.636-89.515 14.426zM152.11 145.63l-2.359 1.712 78.707 192.265 2.878-.394 13.316-114.176.093-.798-.612-.519-92.023-78.09z"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20",
                d: "M490 250c0 132.548-107.452 240-240 240S10 382.548 10 250 117.452 10 250 10s240 107.452 240 240z"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $83bf7d60990a7dc4$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "25",
        fill: "none",
        viewBox: "0 0 500 500",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20",
                d: "M490 250c0 132.548-107.452 240-240 240S10 382.548 10 250 117.452 10 250 10s240 107.452 240 240z"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fill: "#00CACD",
                stroke: "#00CACD",
                strokeWidth: "9",
                d: "M238.82 110.818l.004-.002c2.898-1.479 6.801-2.316 10.899-2.316 4.097 0 8 .837 10.899 2.316l.005.003 75.064 38.184c3.445 1.758 4.668 3.962 4.871 5.63l.053.428v190.885c-.056 1.721-1.205 4.144-4.925 6.051l-.006.003-75.057 38.181-.005.003c-2.899 1.479-6.802 2.316-10.899 2.316-4.098 0-8.001-.837-10.899-2.316l-.006-.003-75.068-38.186-.002-.001c-3.511-1.785-4.659-4.186-4.747-6.076v0-97.022l5.819 3.743.128.082.232.149.248.12.123.059 74.872 38.275c.744.389 1.523.697 2.325.935l5.781 1.716v-90.242l-5.781 1.716c-.78.231-1.548.578-1.918.745a5.927 5.927 0 01-.144.065l-.122.053-.119.061-74.893 38.286c-.063.03-.177.087-.294.151l-.007.004c-.025.014-.067.037-.121.069l-6.129 2.956v-92.351l5.819 3.743.128.082.232.149.248.12.125.06 74.981 38.246.004.002c2.789 1.42 6.304 1.971 9.462 1.971 3.158 0 6.673-.551 9.462-1.971l.004-.002 74.98-38.245c.062-.03.177-.088.296-.153l.007-.004a4.887 4.887 0 001.035-.76h.001l.042-.041 4.093-3.948-4.783-3.076-.128-.082-.231-.149-.248-.119-.125-.061-74.938-38.245-.005-.002c-2.789-1.42-6.304-1.971-9.462-1.971-3.158 0-6.673.551-9.462 1.971l-.004.002-74.98 38.245c-.062.03-.178.087-.296.153l-.007.003c-.025.014-.067.037-.121.069l-6.09 2.937c.21-1.596 1.323-3.639 4.713-5.367l75.067-38.227zm98.852 149.969v-7.349l-6.546 3.341-70.547 36.005h0c-2.9 1.481-6.793 2.317-10.883 2.317-4.086 0-7.991-.835-10.918-2.318l-.006-.003-70.367-35.919-6.546-3.341v94.673l2.463 1.25 70.363 35.71.003.002c4.007 2.051 9.237 4.706 14.67 4.812l.044.001h.299c4.988 0 9.676-2.219 13.325-3.947l.993-.468.073-.034.072-.037 71.059-36.375 2.449-1.254V260.787zM135.614 346.35h2.693c.312 5.416 1.239 9.67 2.956 13.107l.009.018.009.018c1.926 3.77 4.77 6.416 8.975 9.224l.089.068.112.087.118.08c.78.526 1.664 1.06 2.531 1.583l.637.386.007.003.006.004 1.365.823.026.016.026.015.246.144-1.293 2.096-.904-.526-.772-.471-.009-.005-.009-.006c-1.382-.833-2.424-1.468-3.325-2.083l-.036-.025-.036-.024c-5.219-3.419-8.411-6.734-10.415-10.831-1.686-3.445-2.685-7.756-3.006-13.701zm121.638-140.901l-5.781-1.716v90.242l5.781-1.716c.78-.231 1.548-.578 1.917-.745l.145-.065.122-.053.119-.061 74.894-38.286a7.05 7.05 0 00.293-.151l.007-.004c.119-.066.576-.317 1.035-.76h.001l.042-.041 4.093-3.948-4.783-3.076-.128-.082-.231-.149-.248-.119-.124-.06-74.894-38.286-.046-.024-.047-.022-.056-.028c-.41-.197-1.202-.58-2.111-.85zm80.42-37.658v-7.326l-6.534 3.312-67.391 34.153-7.92 4.014 7.92 4.014 67.391 34.154 6.534 3.311v-75.632zm-169.236-4.014l-6.535-3.312v82.958l6.535-3.311 67.39-34.154 7.921-4.014-7.921-4.014-67.39-34.153zm179.114-35.802l.009.005.009.006c1.382.833 2.424 1.468 3.325 2.083l.036.025.036.024c5.219 3.419 8.411 6.734 10.415 10.831 1.686 3.445 2.685 7.756 3.006 13.701h-2.693c-.312-5.416-1.239-9.67-2.956-13.107l-.009-.018-.009-.018c-1.926-3.77-4.77-6.416-8.975-9.224l-.088-.068-.113-.087-.118-.08c-.78-.526-1.664-1.06-2.532-1.584l-.636-.385-.007-.003-.006-.004-1.365-.823-.026-.016-.026-.015-.246-.144 1.293-2.096.904.526.772.471z"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $9d3e353b41855c12$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "25",
        fill: "none",
        viewBox: "0 0 500 500",
        ...props,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20",
                d: "M490 250c0 132.548-107.452 240-240 240S10 382.548 10 250 117.452 10 250 10s240 107.452 240 240Z"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fill: "#00CACD",
                d: "M172.7 317.1q-22.35 0-36.6-10.5c-9.4-7.1-14.1-17.3-14.1-30.4 0-2.8.3-6.1.9-10.1 1.6-9 3.9-19.8 6.9-32.5 8.5-34.4 30.5-51.6 65.9-51.6 9.6 0 18.3 1.6 25.9 4.9 7.6 3.1 13.6 7.9 18 14.3q6.6 9.45 6.6 22.5 0 3.9-.9 9.9c-1.9 11.1-4.1 22-6.8 32.5-4.4 17.1-11.9 30-22.7 38.5-10.7 8.4-25.1 12.5-43.1 12.5m2.7-27c7 0 12.9-2.1 17.8-6.2 5-4.1 8.6-10.4 10.7-19 2.9-11.8 5.1-22 6.6-30.8.5-2.6.8-5.3.8-8.1 0-11.4-5.9-17.1-17.8-17.1-7 0-13 2.1-18 6.2-4.9 4.1-8.4 10.4-10.5 19-2.3 8.4-4.5 18.6-6.8 30.8-.5 2.5-.8 5.1-.8 7.9-.1 11.6 6 17.3 18 17.3M254.899 315.3c-1.4 0-2.4-.4-3.2-1.3-.6-1-.8-2.1-.6-3.4l25.9-122c.2-1.4.9-2.5 2.1-3.4 1.1-.9 2.3-1.3 3.6-1.3h49.9c13.9 0 25 2.9 33.4 8.6 8.5 5.8 12.8 14.1 12.8 25 0 3.1-.4 6.4-1.1 9.8-3.1 14.4-9.4 25-19 31.9-9.4 6.9-22.3 10.3-38.7 10.3h-25.3l-8.6 41.1c-.3 1.4-.9 2.5-2.1 3.4-1.1.9-2.3 1.3-3.6 1.3zm66.4-71.7c5.3 0 9.8-1.4 13.7-4.3 4-2.9 6.6-7 7.9-12.4.4-2.1.6-4 .6-5.6 0-3.6-1.1-6.4-3.2-8.3-2.1-2-5.8-3-10.9-3h-22.5l-7.1 33.6z"
            })
        ]
    });
}




const $df4784c9100a83b7$export$c25425c0b9a3de13 = {
    bitcoin: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $49013d5f2a966e04$export$2e2bcd8739ae039), {}),
    ethereum: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $693a897af321fbd0$export$2e2bcd8739ae039), {}),
    litecoin: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $10b6063c29a39aa7$export$2e2bcd8739ae039), {}),
    "bitcoin-cash": /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f324264db230fc4b$export$2e2bcd8739ae039), {}),
    "bitcoin-sv": /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $246469410de6a91b$export$2e2bcd8739ae039), {}),
    cardano: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5f1c58de93ea5b96$export$2e2bcd8739ae039), {}),
    dash: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0ddebe1ec41e0909$export$2e2bcd8739ae039), {}),
    neo: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5288db72d8c52b99$export$2e2bcd8739ae039), {}),
    polkadot: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $96050c0d7fe3900b$export$2e2bcd8739ae039), {}),
    ripple: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $81d76cb7e7c41ae8$export$2e2bcd8739ae039), {}),
    solana: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0fb15270830db67a$export$2e2bcd8739ae039), {}),
    stellar: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7d0256990b04896e$export$2e2bcd8739ae039), {}),
    tezos: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $764d9e0e87ef607d$export$2e2bcd8739ae039), {}),
    usdc: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14554b83f65116d4$export$2e2bcd8739ae039), {}),
    algorand: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $08e688c4253948d5$export$2e2bcd8739ae039), {}),
    near: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d97a97257806af92$export$2e2bcd8739ae039), {}),
    doge: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6958b70b6fa7ab9a$export$2e2bcd8739ae039), {}),
    polygon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e4b2dc73b6b2f3ce$export$2e2bcd8739ae039), {}),
    xdc: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c25f9c757c4815db$export$2e2bcd8739ae039), {}),
    tron: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7d14ce0847df1b02$export$2e2bcd8739ae039), {}),
    fantom: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83bf7d60990a7dc4$export$2e2bcd8739ae039), {}),
    optimism: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d3e353b41855c12$export$2e2bcd8739ae039), {})
};
const $df4784c9100a83b7$export$73b53978386f314 = {
    BTC: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $49013d5f2a966e04$export$2e2bcd8739ae039), {}),
    ETH: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $693a897af321fbd0$export$2e2bcd8739ae039), {}),
    LTC: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $10b6063c29a39aa7$export$2e2bcd8739ae039), {}),
    BCH: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f324264db230fc4b$export$2e2bcd8739ae039), {}),
    BSV: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $246469410de6a91b$export$2e2bcd8739ae039), {}),
    ADA: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5f1c58de93ea5b96$export$2e2bcd8739ae039), {}),
    DASH: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0ddebe1ec41e0909$export$2e2bcd8739ae039), {}),
    NEO: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5288db72d8c52b99$export$2e2bcd8739ae039), {}),
    DOT: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $96050c0d7fe3900b$export$2e2bcd8739ae039), {}),
    XRP: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $81d76cb7e7c41ae8$export$2e2bcd8739ae039), {}),
    SOL: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0fb15270830db67a$export$2e2bcd8739ae039), {}),
    XLM: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7d0256990b04896e$export$2e2bcd8739ae039), {}),
    XTZ: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $764d9e0e87ef607d$export$2e2bcd8739ae039), {}),
    USDC: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14554b83f65116d4$export$2e2bcd8739ae039), {}),
    ALGO: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $08e688c4253948d5$export$2e2bcd8739ae039), {}),
    NEAR: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d97a97257806af92$export$2e2bcd8739ae039), {}),
    DOGE: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6958b70b6fa7ab9a$export$2e2bcd8739ae039), {}),
    MATIC: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e4b2dc73b6b2f3ce$export$2e2bcd8739ae039), {}),
    XDC: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c25f9c757c4815db$export$2e2bcd8739ae039), {}),
    TRX: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7d14ce0847df1b02$export$2e2bcd8739ae039), {}),
    FTM: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83bf7d60990a7dc4$export$2e2bcd8739ae039), {}),
    OP: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d3e353b41855c12$export$2e2bcd8739ae039), {})
};


// import React from 'react'
// import { BitcoinProvider, SolanaProvider, EthereumProvider } from 'views/layouts'
const $88198d6209a430d3$export$cf7a8da258ee7050 = {
    bitcoin: "bitcoin",
    solana: "solana",
    ethereum: "ethereum"
};


/* eslint-disable max-len */ /* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");


function $7fcf240e9d29a15e$var$BitcoinProvider(props) {
    const { messageToSign: messageToSign, setSignature: setSignature, address: address, isLoading: isLoading } = props;
    const { walletProvider: walletProvider } = (0, $02b65957f7a9bfcc$export$7efbc9b78cd6e553)("bip122") // Namespace for Bitcoin
    ;
    // Functions
    // const isPubkeyValid = async (signature) => {
    //   const pubkey = await walletProvider.getPublicKey({ address })
    //   const isTaproot = address.startsWith('bc1p')
    //   let sigBytes
    //   try {
    //     // Try base64 first
    //     sigBytes = Uint8Array.from(atob(signature), (c) => c.charCodeAt(0))
    //   } catch (e1) {
    //     try {
    //       // Try hex fallback
    //       const hex = signature.toLowerCase().replace(/^0x/, '').trim()
    //       if (/^[0-9a-f]{128}$/i.test(hex)) {
    //         sigBytes = Uint8Array.from(hex.match(/.{1,2}/g).map((b) => parseInt(b, 16)))
    //       } else {
    //         console.error('Invalid signature: not base64 or hex')
    //         setErrMsg(
    //           'Invalid Taproot signature or public key.\n\n' +
    //             'This wallet may not support proper Taproot signing. Try another address type.'
    //         )
    //         return false
    //       }
    //     } catch (e2) {
    //       console.error('Invalid signature: not base64 or hex', { e1, e2 })
    //       setErrMsg(
    //         'Invalid Taproot signature or public key.\n\n' +
    //           'This wallet may not support proper Taproot signing. Try another address type.'
    //       )
    //       return false
    //     }
    //   }
    //   if (isTaproot) {
    //     const isSchnorr = sigBytes.length === 64 && sigBytes[0] !== 0x30 // 0x30 = DER
    //     const isXOnly = pubkey.length === 64 // 32 bytes hex = 64 chars
    //     if (!isSchnorr || !isXOnly) {
    //       setErrMsg(
    //         'Invalid Taproot signature or public key.\n\n' +
    //           'This wallet may not support proper Taproot signing. Try another address type.'
    //       )
    //       return false
    //     }
    //   }
    //   return true
    // }
    const handleSignBtc = async ()=>{
        try {
            // Bitcoin's signMessage expects an object with address and message
            const signature = await walletProvider.signMessage({
                address: address,
                message: messageToSign
            });
            // const validPubkey = await isPubkeyValid()
            // if (!validPubkey) {
            //   return
            // }
            if (setSignature) setSignature(signature);
        // You would typically update your UI with this signature
        } catch (error) {
            console.error("Error signing BTC message:", error);
        }
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
        fullWidth: true,
        type: "button",
        onClick: handleSignBtc,
        disabled: isLoading,
        children: isLoading ? "Loading..." : "Sign BTC Message"
    });
}
// Default Props
$7fcf240e9d29a15e$var$BitcoinProvider.defaultProps = {};
// Proptypes Validation
$7fcf240e9d29a15e$var$BitcoinProvider.propTypes = {};
var $7fcf240e9d29a15e$export$2e2bcd8739ae039 = $7fcf240e9d29a15e$var$BitcoinProvider;


var $d255aa67f4358f2f$export$2e2bcd8739ae039 = (0, $7fcf240e9d29a15e$export$2e2bcd8739ae039);


/* eslint-disable max-len */ /* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");
/**
 *  All errors in ethers include properties to ensure they are both
 *  human-readable (i.e. ``.message``) and machine-readable (i.e. ``.code``).
 *
 *  The [[isError]] function can be used to check the error ``code`` and
 *  provide a type guard for the properties present on that error interface.
 *
 *  @_section: api/utils/errors:Errors  [about-errors]
 */ /* Do NOT modify this file; see /src.ts/_admin/update-version.ts */ /**
 *  The current version of Ethers.
 */ const $e1e04df31d902110$export$83d89fbfd8236492 = "6.14.3";


/**
 *  Property helper functions.
 *
 *  @_subsection api/utils:Properties  [about-properties]
 */ function $5c7e3a359d4744c6$var$checkType(value, type, name) {
    const types = type.split("|").map((t)=>t.trim());
    for(let i = 0; i < types.length; i++)switch(type){
        case "any":
            return;
        case "bigint":
        case "boolean":
        case "number":
        case "string":
            if (typeof value === type) return;
    }
    const error = new Error(`invalid value for type ${type}`);
    error.code = "INVALID_ARGUMENT";
    error.argument = `value.${name}`;
    error.value = value;
    throw error;
}
async function $5c7e3a359d4744c6$export$d503dd157d963b60(value) {
    const keys = Object.keys(value);
    const results = await Promise.all(keys.map((k)=>Promise.resolve(value[k])));
    return results.reduce((accum, v, index)=>{
        accum[keys[index]] = v;
        return accum;
    }, {});
}
function $5c7e3a359d4744c6$export$b61bda4fbca264f2(target, values, types) {
    for(let key in values){
        let value = values[key];
        const type = types ? types[key] : null;
        if (type) $5c7e3a359d4744c6$var$checkType(value, type, key);
        Object.defineProperty(target, key, {
            enumerable: true,
            value: value,
            writable: false
        });
    }
}


function $def55b050f09c63c$var$stringify(value, seen) {
    if (value == null) return "null";
    if (seen == null) seen = new Set();
    if (typeof value === "object") {
        if (seen.has(value)) return "[Circular]";
        seen.add(value);
    }
    if (Array.isArray(value)) return "[ " + value.map((v)=>$def55b050f09c63c$var$stringify(v, seen)).join(", ") + " ]";
    if (value instanceof Uint8Array) {
        const HEX = "0123456789abcdef";
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            result += HEX[value[i] >> 4];
            result += HEX[value[i] & 0xf];
        }
        return result;
    }
    if (typeof value === "object" && typeof value.toJSON === "function") return $def55b050f09c63c$var$stringify(value.toJSON(), seen);
    switch(typeof value){
        case "boolean":
        case "number":
        case "symbol":
            return value.toString();
        case "bigint":
            return BigInt(value).toString();
        case "string":
            return JSON.stringify(value);
        case "object":
            {
                const keys = Object.keys(value);
                keys.sort();
                return "{ " + keys.map((k)=>`${$def55b050f09c63c$var$stringify(k, seen)}: ${$def55b050f09c63c$var$stringify(value[k], seen)}`).join(", ") + " }";
            }
    }
    return `[ COULD NOT SERIALIZE ]`;
}
function $def55b050f09c63c$export$e6127cc7fe7395c3(error, code) {
    return error && error.code === code;
}
function $def55b050f09c63c$export$748c4fa78f31ff35(error) {
    return $def55b050f09c63c$export$e6127cc7fe7395c3(error, "CALL_EXCEPTION");
}
function $def55b050f09c63c$export$5a4bb2b1c89bdce7(message, code, info) {
    let shortMessage = message;
    {
        const details = [];
        if (info) {
            if ("message" in info || "code" in info || "name" in info) throw new Error(`value will overwrite populated values: ${$def55b050f09c63c$var$stringify(info)}`);
            for(const key in info){
                if (key === "shortMessage") continue;
                const value = info[key];
                //                try {
                details.push(key + "=" + $def55b050f09c63c$var$stringify(value));
            //                } catch (error: any) {
            //                console.log("MMM", error.message);
            //                    details.push(key + "=[could not serialize object]");
            //                }
            }
        }
        details.push(`code=${code}`);
        details.push(`version=${(0, $e1e04df31d902110$export$83d89fbfd8236492)}`);
        if (details.length) message += " (" + details.join(", ") + ")";
    }
    let error;
    switch(code){
        case "INVALID_ARGUMENT":
            error = new TypeError(message);
            break;
        case "NUMERIC_FAULT":
        case "BUFFER_OVERRUN":
            error = new RangeError(message);
            break;
        default:
            error = new Error(message);
    }
    (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(error, {
        code: code
    });
    if (info) Object.assign(error, info);
    if (error.shortMessage == null) (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(error, {
        shortMessage: shortMessage
    });
    return error;
}
function $def55b050f09c63c$export$a7a9523472993e97(check, message, code, info) {
    if (!check) throw $def55b050f09c63c$export$5a4bb2b1c89bdce7(message, code, info);
}
function $def55b050f09c63c$export$c3d31707e5030f5e(check, message, name, value) {
    $def55b050f09c63c$export$a7a9523472993e97(check, message, "INVALID_ARGUMENT", {
        argument: name,
        value: value
    });
}
function $def55b050f09c63c$export$d228410a8a77e4fa(count, expectedCount, message) {
    if (message == null) message = "";
    if (message) message = ": " + message;
    $def55b050f09c63c$export$a7a9523472993e97(count >= expectedCount, "missing argument" + message, "MISSING_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
    $def55b050f09c63c$export$a7a9523472993e97(count <= expectedCount, "too many arguments" + message, "UNEXPECTED_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
}
const $def55b050f09c63c$var$_normalizeForms = [
    "NFD",
    "NFC",
    "NFKD",
    "NFKC"
].reduce((accum, form)=>{
    try {
        // General test for normalize
        /* c8 ignore start */ if ("test".normalize(form) !== "test") throw new Error("bad");
        /* c8 ignore stop */ if (form === "NFD") {
            const check = String.fromCharCode(0xe9).normalize("NFD");
            const expected = String.fromCharCode(0x65, 0x0301);
            /* c8 ignore start */ if (check !== expected) throw new Error("broken");
        /* c8 ignore stop */ }
        accum.push(form);
    } catch (error) {}
    return accum;
}, []);
function $def55b050f09c63c$export$d993e67fefdfecda(form) {
    $def55b050f09c63c$export$a7a9523472993e97($def55b050f09c63c$var$_normalizeForms.indexOf(form) >= 0, "platform missing String.prototype.normalize", "UNSUPPORTED_OPERATION", {
        operation: "String.prototype.normalize",
        info: {
            form: form
        }
    });
}
function $def55b050f09c63c$export$ac1a938d48ec8c7b(givenGuard, guard, className) {
    if (className == null) className = "";
    if (givenGuard !== guard) {
        let method = className, operation = "new";
        if (className) {
            method += ".";
            operation += " " + className;
        }
        $def55b050f09c63c$export$a7a9523472993e97(false, `private constructor; use ${method}from* methods`, "UNSUPPORTED_OPERATION", {
            operation: operation
        });
    }
}


/**
 *  One of the most common ways to interact with the blockchain is
 *  by a node running a JSON-RPC interface which can be connected to,
 *  based on the transport, using:
 *
 *  - HTTP or HTTPS - [[JsonRpcProvider]]
 *  - WebSocket - [[WebSocketProvider]]
 *  - IPC - [[IpcSocketProvider]]
 *
 * @_section: api/providers/jsonrpc:JSON-RPC Provider  [about-jsonrpcProvider]
 */ // @TODO:
// - Add the batching API
// https://playground.open-rpc.org/?schemaUrl=https://raw.githubusercontent.com/ethereum/eth1.0-apis/assembled-spec/openrpc.json&uiSchema%5BappBar%5D%5Bui:splitView%5D=true&uiSchema%5BappBar%5D%5Bui:input%5D=false&uiSchema%5BappBar%5D%5Bui:examplesDropdown%5D=false
/**
 *  When sending values to or receiving values from a [[Contract]], the
 *  data is generally encoded using the [ABI standard](link-solc-abi).
 *
 *  The AbiCoder provides a utility to encode values to ABI data and
 *  decode values from ABI data.
 *
 *  Most of the time, developers should favour the [[Contract]] class,
 *  which further abstracts a lot of the finer details of ABI data.
 *
 *  @_section api/abi/abi-coder:ABI Encoding
 */ // See: https://github.com/ethereum/wiki/wiki/Ethereum-Contract-ABI
/**
 *  Some data helpers.
 *
 *
 *  @_subsection api/utils:Data Helpers  [about-data]
 */ 
function $8de17c58ebd53b07$var$_getBytes(value, name, copy) {
    if (value instanceof Uint8Array) {
        if (copy) return new Uint8Array(value);
        return value;
    }
    if (typeof value === "string" && value.match(/^0x(?:[0-9a-f][0-9a-f])*$/i)) {
        const result = new Uint8Array((value.length - 2) / 2);
        let offset = 2;
        for(let i = 0; i < result.length; i++){
            result[i] = parseInt(value.substring(offset, offset + 2), 16);
            offset += 2;
        }
        return result;
    }
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "invalid BytesLike value", name || "value", value);
}
function $8de17c58ebd53b07$export$a3521add2594f3c8(value, name) {
    return $8de17c58ebd53b07$var$_getBytes(value, name, false);
}
function $8de17c58ebd53b07$export$37110e7fee0af4ad(value, name) {
    return $8de17c58ebd53b07$var$_getBytes(value, name, true);
}
function $8de17c58ebd53b07$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (typeof length === "number" && value.length !== 2 + 2 * length) return false;
    if (length === true && value.length % 2 !== 0) return false;
    return true;
}
function $8de17c58ebd53b07$export$9a14abb1a440cd5e(value) {
    return $8de17c58ebd53b07$export$b02a40aff8e4ad18(value, true) || value instanceof Uint8Array;
}
const $8de17c58ebd53b07$var$HexCharacters = "0123456789abcdef";
function $8de17c58ebd53b07$export$2b0d6b5fbe698c70(data) {
    const bytes = $8de17c58ebd53b07$export$a3521add2594f3c8(data);
    let result = "0x";
    for(let i = 0; i < bytes.length; i++){
        const v = bytes[i];
        result += $8de17c58ebd53b07$var$HexCharacters[(v & 0xf0) >> 4] + $8de17c58ebd53b07$var$HexCharacters[v & 0x0f];
    }
    return result;
}
function $8de17c58ebd53b07$export$ee1b3e54f0441b22(datas) {
    return "0x" + datas.map((d)=>$8de17c58ebd53b07$export$2b0d6b5fbe698c70(d).substring(2)).join("");
}
function $8de17c58ebd53b07$export$2321cd91b99770ff(data) {
    if ($8de17c58ebd53b07$export$b02a40aff8e4ad18(data, true)) return (data.length - 2) / 2;
    return $8de17c58ebd53b07$export$a3521add2594f3c8(data).length;
}
function $8de17c58ebd53b07$export$f6d845ffb449edc9(data, start, end) {
    const bytes = $8de17c58ebd53b07$export$a3521add2594f3c8(data);
    if (end != null && end > bytes.length) (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: bytes.length,
        offset: end
    });
    return $8de17c58ebd53b07$export$2b0d6b5fbe698c70(bytes.slice(start == null ? 0 : start, end == null ? bytes.length : end));
}
function $8de17c58ebd53b07$export$9c854001a22ebaa2(data) {
    let bytes = $8de17c58ebd53b07$export$2b0d6b5fbe698c70(data).substring(2);
    while(bytes.startsWith("00"))bytes = bytes.substring(2);
    return "0x" + bytes;
}
function $8de17c58ebd53b07$var$zeroPad(data, length, left) {
    const bytes = $8de17c58ebd53b07$export$a3521add2594f3c8(data);
    (0, $def55b050f09c63c$export$a7a9523472993e97)(length >= bytes.length, "padding exceeds data length", "BUFFER_OVERRUN", {
        buffer: new Uint8Array(bytes),
        length: length,
        offset: length + 1
    });
    const result = new Uint8Array(length);
    result.fill(0);
    if (left) result.set(bytes, length - bytes.length);
    else result.set(bytes, 0);
    return $8de17c58ebd53b07$export$2b0d6b5fbe698c70(result);
}
function $8de17c58ebd53b07$export$4473860254365feb(data, length) {
    return $8de17c58ebd53b07$var$zeroPad(data, length, true);
}
function $8de17c58ebd53b07$export$1dc7fbe1b8738fe7(data, length) {
    return $8de17c58ebd53b07$var$zeroPad(data, length, false);
}


/**
 *  Some mathematic operations.
 *
 *  @_subsection: api/utils:Math Helpers  [about-maths]
 */ 

const $7df480338fc2bc47$var$BN_0 = BigInt(0);
const $7df480338fc2bc47$var$BN_1 = BigInt(1);
//const BN_Max256 = (BN_1 << BigInt(256)) - BN_1;
// IEEE 754 support 53-bits of mantissa
const $7df480338fc2bc47$var$maxValue = 0x1fffffffffffff;
function $7df480338fc2bc47$export$92182edcfa20e5bc(_value, _width) {
    const value = $7df480338fc2bc47$export$8677d6ca9282a154(_value, "value");
    const width = BigInt($7df480338fc2bc47$export$b14f2714108df84(_width, "width"));
    (0, $def55b050f09c63c$export$a7a9523472993e97)(value >> width === $7df480338fc2bc47$var$BN_0, "overflow", "NUMERIC_FAULT", {
        operation: "fromTwos",
        fault: "overflow",
        value: _value
    });
    // Top bit set; treat as a negative value
    if (value >> width - $7df480338fc2bc47$var$BN_1) {
        const mask = ($7df480338fc2bc47$var$BN_1 << width) - $7df480338fc2bc47$var$BN_1;
        return -((~value & mask) + $7df480338fc2bc47$var$BN_1);
    }
    return value;
}
function $7df480338fc2bc47$export$7101cd4e6275351c(_value, _width) {
    let value = $7df480338fc2bc47$export$61fe455e2b1e28a4(_value, "value");
    const width = BigInt($7df480338fc2bc47$export$b14f2714108df84(_width, "width"));
    const limit = $7df480338fc2bc47$var$BN_1 << width - $7df480338fc2bc47$var$BN_1;
    if (value < $7df480338fc2bc47$var$BN_0) {
        value = -value;
        (0, $def55b050f09c63c$export$a7a9523472993e97)(value <= limit, "too low", "NUMERIC_FAULT", {
            operation: "toTwos",
            fault: "overflow",
            value: _value
        });
        const mask = ($7df480338fc2bc47$var$BN_1 << width) - $7df480338fc2bc47$var$BN_1;
        return (~value & mask) + $7df480338fc2bc47$var$BN_1;
    } else (0, $def55b050f09c63c$export$a7a9523472993e97)(value < limit, "too high", "NUMERIC_FAULT", {
        operation: "toTwos",
        fault: "overflow",
        value: _value
    });
    return value;
}
function $7df480338fc2bc47$export$d99f0801a68bbcf1(_value, _bits) {
    const value = $7df480338fc2bc47$export$8677d6ca9282a154(_value, "value");
    const bits = BigInt($7df480338fc2bc47$export$b14f2714108df84(_bits, "bits"));
    return value & ($7df480338fc2bc47$var$BN_1 << bits) - $7df480338fc2bc47$var$BN_1;
}
function $7df480338fc2bc47$export$61fe455e2b1e28a4(value, name) {
    switch(typeof value){
        case "bigint":
            return value;
        case "number":
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(value >= -$7df480338fc2bc47$var$maxValue && value <= $7df480338fc2bc47$var$maxValue, "overflow", name || "value", value);
            return BigInt(value);
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                if (value[0] === "-" && value[1] !== "-") return -BigInt(value.substring(1));
                return BigInt(value);
            } catch (e) {
                (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, `invalid BigNumberish string: ${e.message}`, name || "value", value);
            }
    }
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "invalid BigNumberish value", name || "value", value);
}
function $7df480338fc2bc47$export$8677d6ca9282a154(value, name) {
    const result = $7df480338fc2bc47$export$61fe455e2b1e28a4(value, name);
    (0, $def55b050f09c63c$export$a7a9523472993e97)(result >= $7df480338fc2bc47$var$BN_0, "unsigned value cannot be negative", "NUMERIC_FAULT", {
        fault: "overflow",
        operation: "getUint",
        value: value
    });
    return result;
}
const $7df480338fc2bc47$var$Nibbles = "0123456789abcdef";
function $7df480338fc2bc47$export$c221a145703ab783(value) {
    if (value instanceof Uint8Array) {
        let result = "0x0";
        for (const v of value){
            result += $7df480338fc2bc47$var$Nibbles[v >> 4];
            result += $7df480338fc2bc47$var$Nibbles[v & 0x0f];
        }
        return BigInt(result);
    }
    return $7df480338fc2bc47$export$61fe455e2b1e28a4(value);
}
function $7df480338fc2bc47$export$b14f2714108df84(value, name) {
    switch(typeof value){
        case "bigint":
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(value >= -$7df480338fc2bc47$var$maxValue && value <= $7df480338fc2bc47$var$maxValue, "overflow", name || "value", value);
            return Number(value);
        case "number":
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(value >= -$7df480338fc2bc47$var$maxValue && value <= $7df480338fc2bc47$var$maxValue, "overflow", name || "value", value);
            return value;
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                return $7df480338fc2bc47$export$b14f2714108df84(BigInt(value), name);
            } catch (e) {
                (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, `invalid numeric string: ${e.message}`, name || "value", value);
            }
    }
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "invalid numeric value", name || "value", value);
}
function $7df480338fc2bc47$export$a0a81dc3380ce7d3(value) {
    return $7df480338fc2bc47$export$b14f2714108df84($7df480338fc2bc47$export$c221a145703ab783(value));
}
function $7df480338fc2bc47$export$c6ebe05badb16181(_value, _width) {
    const value = $7df480338fc2bc47$export$8677d6ca9282a154(_value, "value");
    let result = value.toString(16);
    if (_width == null) // Ensure the value is of even length
    {
        if (result.length % 2) result = "0" + result;
    } else {
        const width = $7df480338fc2bc47$export$b14f2714108df84(_width, "width");
        (0, $def55b050f09c63c$export$a7a9523472993e97)(width * 2 >= result.length, `value exceeds width (${width} bytes)`, "NUMERIC_FAULT", {
            operation: "toBeHex",
            fault: "overflow",
            value: _value
        });
        // Pad the value to the required width
        while(result.length < width * 2)result = "0" + result;
    }
    return "0x" + result;
}
function $7df480338fc2bc47$export$b627fcfb5ea68cb0(_value) {
    const value = $7df480338fc2bc47$export$8677d6ca9282a154(_value, "value");
    if (value === $7df480338fc2bc47$var$BN_0) return new Uint8Array([]);
    let hex = value.toString(16);
    if (hex.length % 2) hex = "0" + hex;
    const result = new Uint8Array(hex.length / 2);
    for(let i = 0; i < result.length; i++){
        const offset = i * 2;
        result[i] = parseInt(hex.substring(offset, offset + 2), 16);
    }
    return result;
}
function $7df480338fc2bc47$export$d9c067986dbc68dd(value) {
    let result = (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)((0, $8de17c58ebd53b07$export$9a14abb1a440cd5e)(value) ? value : $7df480338fc2bc47$export$b627fcfb5ea68cb0(value)).substring(2);
    while(result.startsWith("0"))result = result.substring(1);
    if (result === "") result = "0";
    return "0x" + result;
}


const $7373ab4bcc395b24$export$b4b1d1fba463e69c = 32;
const $7373ab4bcc395b24$var$Padding = new Uint8Array($7373ab4bcc395b24$export$b4b1d1fba463e69c);
// Properties used to immediate pass through to the underlying object
// - `then` is used to detect if an object is a Promise for await
const $7373ab4bcc395b24$var$passProperties = [
    "then"
];
const $7373ab4bcc395b24$var$_guard = {};
const $7373ab4bcc395b24$var$resultNames = new WeakMap();
function $7373ab4bcc395b24$var$getNames(result) {
    return $7373ab4bcc395b24$var$resultNames.get(result);
}
function $7373ab4bcc395b24$var$setNames(result, names) {
    $7373ab4bcc395b24$var$resultNames.set(result, names);
}
function $7373ab4bcc395b24$var$throwError(name, error) {
    const wrapped = new Error(`deferred error during ABI decoding triggered accessing ${name}`);
    wrapped.error = error;
    throw wrapped;
}
function $7373ab4bcc395b24$var$toObject(names, items, deep) {
    if (names.indexOf(null) >= 0) return items.map((item, index)=>{
        if (item instanceof $7373ab4bcc395b24$export$8fdcabde73f49165) return $7373ab4bcc395b24$var$toObject($7373ab4bcc395b24$var$getNames(item), item, deep);
        return item;
    });
    return names.reduce((accum, name, index)=>{
        let item = items.getValue(name);
        if (!(name in accum)) {
            if (deep && item instanceof $7373ab4bcc395b24$export$8fdcabde73f49165) item = $7373ab4bcc395b24$var$toObject($7373ab4bcc395b24$var$getNames(item), item, deep);
            accum[name] = item;
        }
        return accum;
    }, {});
}
class $7373ab4bcc395b24$export$8fdcabde73f49165 extends Array {
    // No longer used; but cannot be removed as it will remove the
    // #private field from the .d.ts which may break backwards
    // compatibility
    #names;
    /**
     *  @private
     */ constructor(...args){
        // To properly sub-class Array so the other built-in
        // functions work, the constructor has to behave fairly
        // well. So, in the event we are created via fromItems()
        // we build the read-only Result object we want, but on
        // any other input, we use the default constructor
        // constructor(guard: any, items: Array<any>, keys?: Array<null | string>);
        const guard = args[0];
        let items = args[1];
        let names = (args[2] || []).slice();
        let wrap = true;
        if (guard !== $7373ab4bcc395b24$var$_guard) {
            items = args;
            names = [];
            wrap = false;
        }
        // Can't just pass in ...items since an array of length 1
        // is a special case in the super.
        super(items.length);
        items.forEach((item, index)=>{
            this[index] = item;
        });
        // Find all unique keys
        const nameCounts = names.reduce((accum, name)=>{
            if (typeof name === "string") accum.set(name, (accum.get(name) || 0) + 1);
            return accum;
        }, new Map());
        // Remove any key thats not unique
        $7373ab4bcc395b24$var$setNames(this, Object.freeze(items.map((item, index)=>{
            const name = names[index];
            if (name != null && nameCounts.get(name) === 1) return name;
            return null;
        })));
        // Dummy operations to prevent TypeScript from complaining
        this.#names = [];
        if (this.#names == null) this.#names;
        if (!wrap) return;
        // A wrapped Result is immutable
        Object.freeze(this);
        // Proxy indices and names so we can trap deferred errors
        const proxy = new Proxy(this, {
            get: (target, prop, receiver)=>{
                if (typeof prop === "string") {
                    // Index accessor
                    if (prop.match(/^[0-9]+$/)) {
                        const index = (0, $7df480338fc2bc47$export$b14f2714108df84)(prop, "%index");
                        if (index < 0 || index >= this.length) throw new RangeError("out of result range");
                        const item = target[index];
                        if (item instanceof Error) $7373ab4bcc395b24$var$throwError(`index ${index}`, item);
                        return item;
                    }
                    // Pass important checks (like `then` for Promise) through
                    if ($7373ab4bcc395b24$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                    const value = target[prop];
                    if (value instanceof Function) // Make sure functions work with private variables
                    // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#no_private_property_forwarding
                    return function(...args) {
                        return value.apply(this === receiver ? target : this, args);
                    };
                    else if (!(prop in target)) // Possible name accessor
                    return target.getValue.apply(this === receiver ? target : this, [
                        prop
                    ]);
                }
                return Reflect.get(target, prop, receiver);
            }
        });
        $7373ab4bcc395b24$var$setNames(proxy, $7373ab4bcc395b24$var$getNames(this));
        return proxy;
    }
    /**
     *  Returns the Result as a normal Array. If %%deep%%, any children
     *  which are Result objects are also converted to a normal Array.
     *
     *  This will throw if there are any outstanding deferred
     *  errors.
     */ toArray(deep) {
        const result = [];
        this.forEach((item, index)=>{
            if (item instanceof Error) $7373ab4bcc395b24$var$throwError(`index ${index}`, item);
            if (deep && item instanceof $7373ab4bcc395b24$export$8fdcabde73f49165) item = item.toArray(deep);
            result.push(item);
        });
        return result;
    }
    /**
     *  Returns the Result as an Object with each name-value pair. If
     *  %%deep%%, any children which are Result objects are also
     *  converted to an Object.
     *
     *  This will throw if any value is unnamed, or if there are
     *  any outstanding deferred errors.
     */ toObject(deep) {
        const names = $7373ab4bcc395b24$var$getNames(this);
        return names.reduce((accum, name, index)=>{
            (0, $def55b050f09c63c$export$a7a9523472993e97)(name != null, `value at index ${index} unnamed`, "UNSUPPORTED_OPERATION", {
                operation: "toObject()"
            });
            return $7373ab4bcc395b24$var$toObject(names, this, deep);
        }, {});
    }
    /**
     *  @_ignore
     */ slice(start, end) {
        if (start == null) start = 0;
        if (start < 0) {
            start += this.length;
            if (start < 0) start = 0;
        }
        if (end == null) end = this.length;
        if (end < 0) {
            end += this.length;
            if (end < 0) end = 0;
        }
        if (end > this.length) end = this.length;
        const _names = $7373ab4bcc395b24$var$getNames(this);
        const result = [], names = [];
        for(let i = start; i < end; i++){
            result.push(this[i]);
            names.push(_names[i]);
        }
        return new $7373ab4bcc395b24$export$8fdcabde73f49165($7373ab4bcc395b24$var$_guard, result, names);
    }
    /**
     *  @_ignore
     */ filter(callback, thisArg) {
        const _names = $7373ab4bcc395b24$var$getNames(this);
        const result = [], names = [];
        for(let i = 0; i < this.length; i++){
            const item = this[i];
            if (item instanceof Error) $7373ab4bcc395b24$var$throwError(`index ${i}`, item);
            if (callback.call(thisArg, item, i, this)) {
                result.push(item);
                names.push(_names[i]);
            }
        }
        return new $7373ab4bcc395b24$export$8fdcabde73f49165($7373ab4bcc395b24$var$_guard, result, names);
    }
    /**
     *  @_ignore
     */ map(callback, thisArg) {
        const result = [];
        for(let i = 0; i < this.length; i++){
            const item = this[i];
            if (item instanceof Error) $7373ab4bcc395b24$var$throwError(`index ${i}`, item);
            result.push(callback.call(thisArg, item, i, this));
        }
        return result;
    }
    /**
     *  Returns the value for %%name%%.
     *
     *  Since it is possible to have a key whose name conflicts with
     *  a method on a [[Result]] or its superclass Array, or any
     *  JavaScript keyword, this ensures all named values are still
     *  accessible by name.
     */ getValue(name) {
        const index = $7373ab4bcc395b24$var$getNames(this).indexOf(name);
        if (index === -1) return undefined;
        const value = this[index];
        if (value instanceof Error) $7373ab4bcc395b24$var$throwError(`property ${JSON.stringify(name)}`, value.error);
        return value;
    }
    /**
     *  Creates a new [[Result]] for %%items%% with each entry
     *  also accessible by its corresponding name in %%keys%%.
     */ static fromItems(items, keys) {
        return new $7373ab4bcc395b24$export$8fdcabde73f49165($7373ab4bcc395b24$var$_guard, items, keys);
    }
}
function $7373ab4bcc395b24$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
function $7373ab4bcc395b24$var$getValue(value) {
    let bytes = (0, $7df480338fc2bc47$export$b627fcfb5ea68cb0)(value);
    (0, $def55b050f09c63c$export$a7a9523472993e97)(bytes.length <= $7373ab4bcc395b24$export$b4b1d1fba463e69c, "value out-of-bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: $7373ab4bcc395b24$export$b4b1d1fba463e69c,
        offset: bytes.length
    });
    if (bytes.length !== $7373ab4bcc395b24$export$b4b1d1fba463e69c) bytes = (0, $8de17c58ebd53b07$export$37110e7fee0af4ad)((0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)([
        $7373ab4bcc395b24$var$Padding.slice(bytes.length % $7373ab4bcc395b24$export$b4b1d1fba463e69c),
        bytes
    ]));
    return bytes;
}
class $7373ab4bcc395b24$export$2c0c39526f8bad46 {
    // The coder name:
    //   - address, uint256, tuple, array, etc.
    name;
    // The fully expanded type, including composite types:
    //   - address, uint256, tuple(address,bytes), uint256[3][4][],  etc.
    type;
    // The localName bound in the signature, in this example it is "baz":
    //   - tuple(address foo, uint bar) baz
    localName;
    // Whether this type is dynamic:
    //  - Dynamic: bytes, string, address[], tuple(boolean[]), etc.
    //  - Not Dynamic: address, uint256, boolean[3], tuple(address, uint8)
    dynamic;
    constructor(name, type, localName, dynamic){
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            name: name,
            type: type,
            localName: localName,
            dynamic: dynamic
        }, {
            name: "string",
            type: "string",
            localName: "string",
            dynamic: "boolean"
        });
    }
    _throwError(message, value) {
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, message, this.localName, value);
    }
}
class $7373ab4bcc395b24$export$d7a960146e1a269e {
    // An array of WordSize lengthed objects to concatenation
    #data;
    #dataLength;
    constructor(){
        this.#data = [];
        this.#dataLength = 0;
    }
    get data() {
        return (0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)(this.#data);
    }
    get length() {
        return this.#dataLength;
    }
    #writeData(data) {
        this.#data.push(data);
        this.#dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this.#writeData((0, $8de17c58ebd53b07$export$37110e7fee0af4ad)(writer.data));
    }
    // Arrayish item; pad on the right to *nearest* WordSize
    writeBytes(value) {
        let bytes = (0, $8de17c58ebd53b07$export$37110e7fee0af4ad)(value);
        const paddingOffset = bytes.length % $7373ab4bcc395b24$export$b4b1d1fba463e69c;
        if (paddingOffset) bytes = (0, $8de17c58ebd53b07$export$37110e7fee0af4ad)((0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)([
            bytes,
            $7373ab4bcc395b24$var$Padding.slice(paddingOffset)
        ]));
        return this.#writeData(bytes);
    }
    // Numeric item; pad on the left *to* WordSize
    writeValue(value) {
        return this.#writeData($7373ab4bcc395b24$var$getValue(value));
    }
    // Inserts a numeric place-holder, returning a callback that can
    // be used to asjust the value later
    writeUpdatableValue() {
        const offset = this.#data.length;
        this.#data.push($7373ab4bcc395b24$var$Padding);
        this.#dataLength += $7373ab4bcc395b24$export$b4b1d1fba463e69c;
        return (value)=>{
            this.#data[offset] = $7373ab4bcc395b24$var$getValue(value);
        };
    }
}
class $7373ab4bcc395b24$export$2f7a2f0e90c07dc4 {
    // Allows incomplete unpadded data to be read; otherwise an error
    // is raised if attempting to overrun the buffer. This is required
    // to deal with an old Solidity bug, in which event data for
    // external (not public thoguh) was tightly packed.
    allowLoose;
    #data;
    #offset;
    #bytesRead;
    #parent;
    #maxInflation;
    constructor(data, allowLoose, maxInflation){
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            allowLoose: !!allowLoose
        });
        this.#data = (0, $8de17c58ebd53b07$export$37110e7fee0af4ad)(data);
        this.#bytesRead = 0;
        this.#parent = null;
        this.#maxInflation = maxInflation != null ? maxInflation : 1024;
        this.#offset = 0;
    }
    get data() {
        return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(this.#data);
    }
    get dataLength() {
        return this.#data.length;
    }
    get consumed() {
        return this.#offset;
    }
    get bytes() {
        return new Uint8Array(this.#data);
    }
    #incrementBytesRead(count) {
        if (this.#parent) return this.#parent.#incrementBytesRead(count);
        this.#bytesRead += count;
        // Check for excessive inflation (see: #4537)
        (0, $def55b050f09c63c$export$a7a9523472993e97)(this.#maxInflation < 1 || this.#bytesRead <= this.#maxInflation * this.dataLength, `compressed ABI data exceeds inflation ratio of ${this.#maxInflation} ( see: https:/\/github.com/ethers-io/ethers.js/issues/4537 )`, "BUFFER_OVERRUN", {
            buffer: (0, $8de17c58ebd53b07$export$37110e7fee0af4ad)(this.#data),
            offset: this.#offset,
            length: count,
            info: {
                bytesRead: this.#bytesRead,
                dataLength: this.dataLength
            }
        });
    }
    #peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / $7373ab4bcc395b24$export$b4b1d1fba463e69c) * $7373ab4bcc395b24$export$b4b1d1fba463e69c;
        if (this.#offset + alignedLength > this.#data.length) {
            if (this.allowLoose && loose && this.#offset + length <= this.#data.length) alignedLength = length;
            else (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "data out-of-bounds", "BUFFER_OVERRUN", {
                buffer: (0, $8de17c58ebd53b07$export$37110e7fee0af4ad)(this.#data),
                length: this.#data.length,
                offset: this.#offset + alignedLength
            });
        }
        return this.#data.slice(this.#offset, this.#offset + alignedLength);
    }
    // Create a sub-reader with the same underlying data, but offset
    subReader(offset) {
        const reader = new $7373ab4bcc395b24$export$2f7a2f0e90c07dc4(this.#data.slice(this.#offset + offset), this.allowLoose, this.#maxInflation);
        reader.#parent = this;
        return reader;
    }
    // Read bytes
    readBytes(length, loose) {
        let bytes = this.#peekBytes(0, length, !!loose);
        this.#incrementBytesRead(length);
        this.#offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    // Read a numeric values
    readValue() {
        return (0, $7df480338fc2bc47$export$c221a145703ab783)(this.readBytes($7373ab4bcc395b24$export$b4b1d1fba463e69c));
    }
    readIndex() {
        return (0, $7df480338fc2bc47$export$a0a81dc3380ce7d3)(this.readBytes($7373ab4bcc395b24$export$b4b1d1fba463e69c));
    }
}


/**
 *  A fundamental building block of Ethereum is the underlying
 *  cryptographic primitives.
 *
 *  @_section: api/crypto:Cryptographic Functions   [about-crypto]
 */ /**
 *  An **HMAC** enables verification that a given key was used
 *  to authenticate a payload.
 *
 *  See: [[link-wiki-hmac]]
 *
 *  @_subsection: api/crypto:HMAC  [about-hmac]
 */ /* Browser Crypto Shims */ function $f23a064ad7e0f12c$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
function $f23a064ad7e0f12c$export$87b259aa03e3d267(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
function $f23a064ad7e0f12c$export$b3317979f9250576(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
function $f23a064ad7e0f12c$export$d6af199866bfb566(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $f23a064ad7e0f12c$export$98e628dec113755e(hash.outputLen);
    $f23a064ad7e0f12c$export$98e628dec113755e(hash.blockLen);
}
function $f23a064ad7e0f12c$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $f23a064ad7e0f12c$export$c789db2c85949867(out, instance) {
    $f23a064ad7e0f12c$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $f23a064ad7e0f12c$var$assert = {
    number: $f23a064ad7e0f12c$export$98e628dec113755e,
    bool: $f23a064ad7e0f12c$export$87b259aa03e3d267,
    bytes: $f23a064ad7e0f12c$export$b3317979f9250576,
    hash: $f23a064ad7e0f12c$export$d6af199866bfb566,
    exists: $f23a064ad7e0f12c$export$f7e9f41ea797a17,
    output: $f23a064ad7e0f12c$export$c789db2c85949867
};
var $f23a064ad7e0f12c$export$2e2bcd8739ae039 = $f23a064ad7e0f12c$var$assert;


/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated, we can just drop the import.
const $6de26ac214f8077c$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;


const $c77b2cd8495ae394$var$u8a = (a)=>a instanceof Uint8Array;
const $c77b2cd8495ae394$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $c77b2cd8495ae394$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $c77b2cd8495ae394$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $c77b2cd8495ae394$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $c77b2cd8495ae394$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!$c77b2cd8495ae394$export$a0f88e38d4cf9577) throw new Error("Non little-endian hardware is not supported");
const $c77b2cd8495ae394$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $c77b2cd8495ae394$export$58b867e287a802c8(bytes) {
    if (!$c77b2cd8495ae394$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $c77b2cd8495ae394$var$hexes[bytes[i]];
    return hex;
}
function $c77b2cd8495ae394$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
const $c77b2cd8495ae394$export$bdd553fddd433dcb = async ()=>{};
async function $c77b2cd8495ae394$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $c77b2cd8495ae394$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $c77b2cd8495ae394$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $c77b2cd8495ae394$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $c77b2cd8495ae394$export$3df70a15530b5e81(data);
    if (!$c77b2cd8495ae394$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
function $c77b2cd8495ae394$export$287dd7971339c972(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$c77b2cd8495ae394$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
class $c77b2cd8495ae394$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
const $c77b2cd8495ae394$var$toStr = {}.toString;
function $c77b2cd8495ae394$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && $c77b2cd8495ae394$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $c77b2cd8495ae394$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($c77b2cd8495ae394$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $c77b2cd8495ae394$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($c77b2cd8495ae394$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $c77b2cd8495ae394$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($c77b2cd8495ae394$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $c77b2cd8495ae394$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $6de26ac214f8077c$export$7effb53edfc7fa2d) && typeof (0, $6de26ac214f8077c$export$7effb53edfc7fa2d).getRandomValues === "function") return (0, $6de26ac214f8077c$export$7effb53edfc7fa2d).getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}


class $59843fb339d6159b$export$7b9cf41ebec74f45 extends (0, $c77b2cd8495ae394$export$ab85ecd77ce6a5cd) {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $f23a064ad7e0f12c$export$d6af199866bfb566)(hash);
        const key = (0, $c77b2cd8495ae394$export$30a71edf0753ed6b)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $f23a064ad7e0f12c$export$f7e9f41ea797a17)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $f23a064ad7e0f12c$export$f7e9f41ea797a17)(this);
        (0, $f23a064ad7e0f12c$export$b3317979f9250576)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
const $59843fb339d6159b$export$355af40f8ab02f34 = (hash, key, message)=>new $59843fb339d6159b$export$7b9cf41ebec74f45(hash, key).update(message).digest();
$59843fb339d6159b$export$355af40f8ab02f34.create = (hash, key)=>new $59843fb339d6159b$export$7b9cf41ebec74f45(hash, key);





// Common prologue and epilogue for sync/async functions
function $2de97c5df551c9fb$var$pbkdf2Init(hash, _password, _salt, _opts) {
    (0, $f23a064ad7e0f12c$export$d6af199866bfb566)(hash);
    const opts = (0, $c77b2cd8495ae394$export$6fcee72895eceb1e)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c: c, dkLen: dkLen, asyncTick: asyncTick } = opts;
    (0, $f23a064ad7e0f12c$export$98e628dec113755e)(c);
    (0, $f23a064ad7e0f12c$export$98e628dec113755e)(dkLen);
    (0, $f23a064ad7e0f12c$export$98e628dec113755e)(asyncTick);
    if (c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
    const password = (0, $c77b2cd8495ae394$export$30a71edf0753ed6b)(_password);
    const salt = (0, $c77b2cd8495ae394$export$30a71edf0753ed6b)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = (0, $59843fb339d6159b$export$355af40f8ab02f34).create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $2de97c5df551c9fb$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
function $2de97c5df551c9fb$export$448fa22aedc9dbca(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $2de97c5df551c9fb$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $c77b2cd8495ae394$export$d7febe7b891e79f0)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $2de97c5df551c9fb$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
async function $2de97c5df551c9fb$export$fda056adff0996c3(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, asyncTick: asyncTick, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $2de97c5df551c9fb$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $c77b2cd8495ae394$export$d7febe7b891e79f0)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, $c77b2cd8495ae394$export$57207d71b8c929c8)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return $2de97c5df551c9fb$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}




// Polyfill for Safari 14
function $29514d38274e65c0$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
class $29514d38274e65c0$export$ebbe38f24b9a0856 extends (0, $c77b2cd8495ae394$export$ab85ecd77ce6a5cd) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $c77b2cd8495ae394$export$d7febe7b891e79f0)(this.buffer);
    }
    update(data) {
        (0, $f23a064ad7e0f12c$export$f7e9f41ea797a17)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $c77b2cd8495ae394$export$30a71edf0753ed6b)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $c77b2cd8495ae394$export$d7febe7b891e79f0)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $f23a064ad7e0f12c$export$f7e9f41ea797a17)(this);
        (0, $f23a064ad7e0f12c$export$c789db2c85949867)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $29514d38274e65c0$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $c77b2cd8495ae394$export$d7febe7b891e79f0)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}



// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $4448b1ab7a1143c9$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $4448b1ab7a1143c9$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $4448b1ab7a1143c9$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $4448b1ab7a1143c9$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $4448b1ab7a1143c9$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $4448b1ab7a1143c9$var$SHA256 extends (0, $29514d38274e65c0$export$ebbe38f24b9a0856) {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $4448b1ab7a1143c9$var$IV[0] | 0;
        this.B = $4448b1ab7a1143c9$var$IV[1] | 0;
        this.C = $4448b1ab7a1143c9$var$IV[2] | 0;
        this.D = $4448b1ab7a1143c9$var$IV[3] | 0;
        this.E = $4448b1ab7a1143c9$var$IV[4] | 0;
        this.F = $4448b1ab7a1143c9$var$IV[5] | 0;
        this.G = $4448b1ab7a1143c9$var$IV[6] | 0;
        this.H = $4448b1ab7a1143c9$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$4448b1ab7a1143c9$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $4448b1ab7a1143c9$var$SHA256_W[i - 15];
            const W2 = $4448b1ab7a1143c9$var$SHA256_W[i - 2];
            const s0 = (0, $c77b2cd8495ae394$export$466993d7d0d272aa)(W15, 7) ^ (0, $c77b2cd8495ae394$export$466993d7d0d272aa)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $c77b2cd8495ae394$export$466993d7d0d272aa)(W2, 17) ^ (0, $c77b2cd8495ae394$export$466993d7d0d272aa)(W2, 19) ^ W2 >>> 10;
            $4448b1ab7a1143c9$var$SHA256_W[i] = s1 + $4448b1ab7a1143c9$var$SHA256_W[i - 7] + s0 + $4448b1ab7a1143c9$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $c77b2cd8495ae394$export$466993d7d0d272aa)(E, 6) ^ (0, $c77b2cd8495ae394$export$466993d7d0d272aa)(E, 11) ^ (0, $c77b2cd8495ae394$export$466993d7d0d272aa)(E, 25);
            const T1 = H + sigma1 + $4448b1ab7a1143c9$var$Chi(E, F, G) + $4448b1ab7a1143c9$var$SHA256_K[i] + $4448b1ab7a1143c9$var$SHA256_W[i] | 0;
            const sigma0 = (0, $c77b2cd8495ae394$export$466993d7d0d272aa)(A, 2) ^ (0, $c77b2cd8495ae394$export$466993d7d0d272aa)(A, 13) ^ (0, $c77b2cd8495ae394$export$466993d7d0d272aa)(A, 22);
            const T2 = sigma0 + $4448b1ab7a1143c9$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $4448b1ab7a1143c9$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $4448b1ab7a1143c9$var$SHA224 extends $4448b1ab7a1143c9$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
const $4448b1ab7a1143c9$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $c77b2cd8495ae394$export$f081816339df1972)(()=>new $4448b1ab7a1143c9$var$SHA256());
const $4448b1ab7a1143c9$export$97b70509d4e397ea = /* @__PURE__ */ (0, $c77b2cd8495ae394$export$f081816339df1972)(()=>new $4448b1ab7a1143c9$var$SHA224());



const $5a3be053f5ad3014$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $5a3be053f5ad3014$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $5a3be053f5ad3014$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $5a3be053f5ad3014$var$U32_MASK64),
        l: Number(n >> $5a3be053f5ad3014$var$_32n & $5a3be053f5ad3014$var$U32_MASK64)
    };
    return {
        h: Number(n >> $5a3be053f5ad3014$var$_32n & $5a3be053f5ad3014$var$U32_MASK64) | 0,
        l: Number(n & $5a3be053f5ad3014$var$U32_MASK64) | 0
    };
}
function $5a3be053f5ad3014$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $5a3be053f5ad3014$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $5a3be053f5ad3014$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $5a3be053f5ad3014$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $5a3be053f5ad3014$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $5a3be053f5ad3014$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $5a3be053f5ad3014$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $5a3be053f5ad3014$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $5a3be053f5ad3014$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $5a3be053f5ad3014$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $5a3be053f5ad3014$export$a088d44bd387d2a3 = (_h, l)=>l;
const $5a3be053f5ad3014$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $5a3be053f5ad3014$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $5a3be053f5ad3014$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $5a3be053f5ad3014$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $5a3be053f5ad3014$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $5a3be053f5ad3014$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $5a3be053f5ad3014$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $5a3be053f5ad3014$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $5a3be053f5ad3014$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $5a3be053f5ad3014$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $5a3be053f5ad3014$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $5a3be053f5ad3014$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $5a3be053f5ad3014$var$u64 = {
    fromBig: $5a3be053f5ad3014$export$9625d4333cb56c3f,
    split: $5a3be053f5ad3014$export$65980d18b75784e2,
    toBig: $5a3be053f5ad3014$export$30f78adcaaa2eb7,
    shrSH: $5a3be053f5ad3014$export$75aa78dc5bd52853,
    shrSL: $5a3be053f5ad3014$export$a0225ff0aee14e25,
    rotrSH: $5a3be053f5ad3014$export$97f812dfd830ca87,
    rotrSL: $5a3be053f5ad3014$export$60987e30e2c9d9d,
    rotrBH: $5a3be053f5ad3014$export$af9c7fbac44dcb76,
    rotrBL: $5a3be053f5ad3014$export$f619171d6d5ac414,
    rotr32H: $5a3be053f5ad3014$export$a088d44bd387d2a3,
    rotr32L: $5a3be053f5ad3014$export$8415aae4d1f69577,
    rotlSH: $5a3be053f5ad3014$export$4b80a2917447870e,
    rotlSL: $5a3be053f5ad3014$export$20652918a7b63b3,
    rotlBH: $5a3be053f5ad3014$export$a52f14bf902f9977,
    rotlBL: $5a3be053f5ad3014$export$5d12cc1da441323f,
    add: $5a3be053f5ad3014$export$e16d8520af44a096,
    add3L: $5a3be053f5ad3014$export$c0c22b91f08911f,
    add3H: $5a3be053f5ad3014$export$ef7b26044977a8ec,
    add4L: $5a3be053f5ad3014$export$2f4e199c560f545d,
    add4H: $5a3be053f5ad3014$export$e909220d675a7741,
    add5H: $5a3be053f5ad3014$export$b45ee8d78c965098,
    add5L: $5a3be053f5ad3014$export$d732b061fe9c9ae4
};
var $5a3be053f5ad3014$export$2e2bcd8739ae039 = $5a3be053f5ad3014$var$u64;



// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$3119eced6fa51e2a$var$SHA512_Kh, $3119eced6fa51e2a$var$SHA512_Kl] = /* @__PURE__ */ (()=>(0, $5a3be053f5ad3014$export$2e2bcd8739ae039).split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $3119eced6fa51e2a$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $3119eced6fa51e2a$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $3119eced6fa51e2a$export$d655fdb8a1cad5df extends (0, $29514d38274e65c0$export$ebbe38f24b9a0856) {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $3119eced6fa51e2a$var$SHA512_W_H[i] = view.getUint32(offset);
            $3119eced6fa51e2a$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $3119eced6fa51e2a$var$SHA512_W_H[i - 15] | 0;
            const W15l = $3119eced6fa51e2a$var$SHA512_W_L[i - 15] | 0;
            const s0h = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrSH(W15h, W15l, 1) ^ (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrSH(W15h, W15l, 8) ^ (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).shrSH(W15h, W15l, 7);
            const s0l = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrSL(W15h, W15l, 1) ^ (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrSL(W15h, W15l, 8) ^ (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $3119eced6fa51e2a$var$SHA512_W_H[i - 2] | 0;
            const W2l = $3119eced6fa51e2a$var$SHA512_W_L[i - 2] | 0;
            const s1h = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrSH(W2h, W2l, 19) ^ (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrBH(W2h, W2l, 61) ^ (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).shrSH(W2h, W2l, 6);
            const s1l = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrSL(W2h, W2l, 19) ^ (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrBL(W2h, W2l, 61) ^ (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).add4L(s0l, s1l, $3119eced6fa51e2a$var$SHA512_W_L[i - 7], $3119eced6fa51e2a$var$SHA512_W_L[i - 16]);
            const SUMh = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).add4H(SUMl, s0h, s1h, $3119eced6fa51e2a$var$SHA512_W_H[i - 7], $3119eced6fa51e2a$var$SHA512_W_H[i - 16]);
            $3119eced6fa51e2a$var$SHA512_W_H[i] = SUMh | 0;
            $3119eced6fa51e2a$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrSH(Eh, El, 14) ^ (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrSH(Eh, El, 18) ^ (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrBH(Eh, El, 41);
            const sigma1l = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrSL(Eh, El, 14) ^ (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrSL(Eh, El, 18) ^ (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).add5L(Hl, sigma1l, CHIl, $3119eced6fa51e2a$var$SHA512_Kl[i], $3119eced6fa51e2a$var$SHA512_W_L[i]);
            const T1h = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).add5H(T1ll, Hh, sigma1h, CHIh, $3119eced6fa51e2a$var$SHA512_Kh[i], $3119eced6fa51e2a$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrSH(Ah, Al, 28) ^ (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrBH(Ah, Al, 34) ^ (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrBH(Ah, Al, 39);
            const sigma0l = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrSL(Ah, Al, 28) ^ (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrBL(Ah, Al, 34) ^ (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).add3L(T1l, sigma0l, MAJl);
            Ah = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = (0, $5a3be053f5ad3014$export$2e2bcd8739ae039).add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $3119eced6fa51e2a$var$SHA512_W_H.fill(0);
        $3119eced6fa51e2a$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
class $3119eced6fa51e2a$var$SHA512_224 extends $3119eced6fa51e2a$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $3119eced6fa51e2a$var$SHA512_256 extends $3119eced6fa51e2a$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $3119eced6fa51e2a$var$SHA384 extends $3119eced6fa51e2a$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
const $3119eced6fa51e2a$export$a888d2532e6dc7bb = /* @__PURE__ */ (0, $c77b2cd8495ae394$export$f081816339df1972)(()=>new $3119eced6fa51e2a$export$d655fdb8a1cad5df());
const $3119eced6fa51e2a$export$a090a04f72f0a320 = /* @__PURE__ */ (0, $c77b2cd8495ae394$export$f081816339df1972)(()=>new $3119eced6fa51e2a$var$SHA512_224());
const $3119eced6fa51e2a$export$c78786b6da86db2a = /* @__PURE__ */ (0, $c77b2cd8495ae394$export$f081816339df1972)(()=>new $3119eced6fa51e2a$var$SHA512_256());
const $3119eced6fa51e2a$export$612d47d55dedde45 = /* @__PURE__ */ (0, $c77b2cd8495ae394$export$f081816339df1972)(()=>new $3119eced6fa51e2a$var$SHA384());



function $804dae2913482ac7$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $804dae2913482ac7$var$anyGlobal = $804dae2913482ac7$var$getGlobal();
const $804dae2913482ac7$var$crypto = $804dae2913482ac7$var$anyGlobal.crypto || $804dae2913482ac7$var$anyGlobal.msCrypto;
function $804dae2913482ac7$export$2fb37efbf6ae0c0e(algo) {
    switch(algo){
        case "sha256":
            return (0, $4448b1ab7a1143c9$export$bced8d2aada2d1c9).create();
        case "sha512":
            return (0, $3119eced6fa51e2a$export$a888d2532e6dc7bb).create();
    }
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "invalid hashing algorithm name", "algorithm", algo);
}
function $804dae2913482ac7$export$da39cf97e1eb7c91(_algo, key) {
    const algo = {
        sha256: $4448b1ab7a1143c9$export$bced8d2aada2d1c9,
        sha512: $3119eced6fa51e2a$export$a888d2532e6dc7bb
    }[_algo];
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(algo != null, "invalid hmac algorithm", "algorithm", _algo);
    return (0, $59843fb339d6159b$export$355af40f8ab02f34).create(algo, key);
}
function $804dae2913482ac7$export$b80c7ba289c8fa56(password, salt, iterations, keylen, _algo) {
    const algo = {
        sha256: $4448b1ab7a1143c9$export$bced8d2aada2d1c9,
        sha512: $3119eced6fa51e2a$export$a888d2532e6dc7bb
    }[_algo];
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(algo != null, "invalid pbkdf2 algorithm", "algorithm", _algo);
    return (0, $2de97c5df551c9fb$export$448fa22aedc9dbca)(algo, password, salt, {
        c: iterations,
        dkLen: keylen
    });
}
function $804dae2913482ac7$export$5f828d93ff035aa8(length) {
    (0, $def55b050f09c63c$export$a7a9523472993e97)($804dae2913482ac7$var$crypto != null, "platform does not support secure random numbers", "UNSUPPORTED_OPERATION", {
        operation: "randomBytes"
    });
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(Number.isInteger(length) && length > 0 && length <= 1024, "invalid length", "length", length);
    const result = new Uint8Array(length);
    $804dae2913482ac7$var$crypto.getRandomValues(result);
    return result;
}



let $a3afbc50b11f4cd5$var$locked = false;
const $a3afbc50b11f4cd5$var$_computeHmac = function(algorithm, key, data) {
    return (0, $804dae2913482ac7$export$da39cf97e1eb7c91)(algorithm, key).update(data).digest();
};
let $a3afbc50b11f4cd5$var$__computeHmac = $a3afbc50b11f4cd5$var$_computeHmac;
function $a3afbc50b11f4cd5$export$967075d2f3b8e7ff(algorithm, _key, _data) {
    const key = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(_key, "key");
    const data = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(_data, "data");
    return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)($a3afbc50b11f4cd5$var$__computeHmac(algorithm, key, data));
}
$a3afbc50b11f4cd5$export$967075d2f3b8e7ff._ = $a3afbc50b11f4cd5$var$_computeHmac;
$a3afbc50b11f4cd5$export$967075d2f3b8e7ff.lock = function() {
    $a3afbc50b11f4cd5$var$locked = true;
};
$a3afbc50b11f4cd5$export$967075d2f3b8e7ff.register = function(func) {
    if ($a3afbc50b11f4cd5$var$locked) throw new Error("computeHmac is locked");
    $a3afbc50b11f4cd5$var$__computeHmac = func;
};
Object.freeze($a3afbc50b11f4cd5$export$967075d2f3b8e7ff);


/**
 *  Cryptographic hashing functions
 *
 *  @_subsection: api/crypto:Hash Functions [about-crypto-hashing]
 */ 


// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$30bf9982558a3ccb$var$SHA3_PI, $30bf9982558a3ccb$var$SHA3_ROTL, $30bf9982558a3ccb$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $30bf9982558a3ccb$var$_0n = /* @__PURE__ */ BigInt(0);
const $30bf9982558a3ccb$var$_1n = /* @__PURE__ */ BigInt(1);
const $30bf9982558a3ccb$var$_2n = /* @__PURE__ */ BigInt(2);
const $30bf9982558a3ccb$var$_7n = /* @__PURE__ */ BigInt(7);
const $30bf9982558a3ccb$var$_256n = /* @__PURE__ */ BigInt(256);
const $30bf9982558a3ccb$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $30bf9982558a3ccb$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $30bf9982558a3ccb$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $30bf9982558a3ccb$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $30bf9982558a3ccb$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $30bf9982558a3ccb$var$_1n ^ (R >> $30bf9982558a3ccb$var$_7n) * $30bf9982558a3ccb$var$_0x71n) % $30bf9982558a3ccb$var$_256n;
        if (R & $30bf9982558a3ccb$var$_2n) t ^= $30bf9982558a3ccb$var$_1n << ($30bf9982558a3ccb$var$_1n << /* @__PURE__ */ BigInt(j)) - $30bf9982558a3ccb$var$_1n;
    }
    $30bf9982558a3ccb$var$_SHA3_IOTA.push(t);
}
const [$30bf9982558a3ccb$var$SHA3_IOTA_H, $30bf9982558a3ccb$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $5a3be053f5ad3014$export$65980d18b75784e2)($30bf9982558a3ccb$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $30bf9982558a3ccb$var$rotlH = (h, l, s)=>s > 32 ? (0, $5a3be053f5ad3014$export$a52f14bf902f9977)(h, l, s) : (0, $5a3be053f5ad3014$export$4b80a2917447870e)(h, l, s);
const $30bf9982558a3ccb$var$rotlL = (h, l, s)=>s > 32 ? (0, $5a3be053f5ad3014$export$5d12cc1da441323f)(h, l, s) : (0, $5a3be053f5ad3014$export$20652918a7b63b3)(h, l, s);
function $30bf9982558a3ccb$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $30bf9982558a3ccb$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $30bf9982558a3ccb$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $30bf9982558a3ccb$var$SHA3_ROTL[t];
            const Th = $30bf9982558a3ccb$var$rotlH(curH, curL, shift);
            const Tl = $30bf9982558a3ccb$var$rotlL(curH, curL, shift);
            const PI = $30bf9982558a3ccb$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $30bf9982558a3ccb$var$SHA3_IOTA_H[round];
        s[1] ^= $30bf9982558a3ccb$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
class $30bf9982558a3ccb$export$f7374b8b4498bc2e extends (0, $c77b2cd8495ae394$export$ab85ecd77ce6a5cd) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $f23a064ad7e0f12c$export$98e628dec113755e)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $c77b2cd8495ae394$export$8bacf4ad828c7fe7)(this.state);
    }
    keccak() {
        $30bf9982558a3ccb$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $f23a064ad7e0f12c$export$f7e9f41ea797a17)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $c77b2cd8495ae394$export$30a71edf0753ed6b)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $f23a064ad7e0f12c$export$f7e9f41ea797a17)(this, false);
        (0, $f23a064ad7e0f12c$export$b3317979f9250576)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $f23a064ad7e0f12c$export$98e628dec113755e)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $f23a064ad7e0f12c$export$c789db2c85949867)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $30bf9982558a3ccb$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $30bf9982558a3ccb$var$gen = (suffix, blockLen, outputLen)=>(0, $c77b2cd8495ae394$export$f081816339df1972)(()=>new $30bf9982558a3ccb$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $30bf9982558a3ccb$export$fe6c2b96a79338e9 = /* @__PURE__ */ $30bf9982558a3ccb$var$gen(0x06, 144, 28);
const $30bf9982558a3ccb$export$76e19b6966813b14 = /* @__PURE__ */ $30bf9982558a3ccb$var$gen(0x06, 136, 32);
const $30bf9982558a3ccb$export$a58509fa80f30d15 = /* @__PURE__ */ $30bf9982558a3ccb$var$gen(0x06, 104, 48);
const $30bf9982558a3ccb$export$20ed324dbdf09b7c = /* @__PURE__ */ $30bf9982558a3ccb$var$gen(0x06, 72, 64);
const $30bf9982558a3ccb$export$2f7fb3c6fac246bc = /* @__PURE__ */ $30bf9982558a3ccb$var$gen(0x01, 144, 28);
const $30bf9982558a3ccb$export$860ddaa9ca84a66d = /* @__PURE__ */ $30bf9982558a3ccb$var$gen(0x01, 136, 32);
const $30bf9982558a3ccb$export$46fcdeb4c5686552 = /* @__PURE__ */ $30bf9982558a3ccb$var$gen(0x01, 104, 48);
const $30bf9982558a3ccb$export$aec1ddaf6c1ba495 = /* @__PURE__ */ $30bf9982558a3ccb$var$gen(0x01, 72, 64);
const $30bf9982558a3ccb$var$genShake = (suffix, blockLen, outputLen)=>(0, $c77b2cd8495ae394$export$e18964dbd6e083c1)((opts = {})=>new $30bf9982558a3ccb$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $30bf9982558a3ccb$export$f43dc3bb86efbba2 = /* @__PURE__ */ $30bf9982558a3ccb$var$genShake(0x1f, 168, 16);
const $30bf9982558a3ccb$export$c240d011f1520440 = /* @__PURE__ */ $30bf9982558a3ccb$var$genShake(0x1f, 136, 32);



let $1c3ba5429a8a9032$var$locked = false;
const $1c3ba5429a8a9032$var$_keccak256 = function(data) {
    return (0, $30bf9982558a3ccb$export$860ddaa9ca84a66d)(data);
};
let $1c3ba5429a8a9032$var$__keccak256 = $1c3ba5429a8a9032$var$_keccak256;
function $1c3ba5429a8a9032$export$f8151fce47ad1c35(_data) {
    const data = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(_data, "data");
    return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)($1c3ba5429a8a9032$var$__keccak256(data));
}
$1c3ba5429a8a9032$export$f8151fce47ad1c35._ = $1c3ba5429a8a9032$var$_keccak256;
$1c3ba5429a8a9032$export$f8151fce47ad1c35.lock = function() {
    $1c3ba5429a8a9032$var$locked = true;
};
$1c3ba5429a8a9032$export$f8151fce47ad1c35.register = function(func) {
    if ($1c3ba5429a8a9032$var$locked) throw new TypeError("keccak256 is locked");
    $1c3ba5429a8a9032$var$__keccak256 = func;
};
Object.freeze($1c3ba5429a8a9032$export$f8151fce47ad1c35);




// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
const $5761bdcd8147f3b4$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $5761bdcd8147f3b4$var$Id = /* @__PURE__ */ Uint8Array.from({
    length: 16
}, (_, i)=>i);
const $5761bdcd8147f3b4$var$Pi = /* @__PURE__ */ $5761bdcd8147f3b4$var$Id.map((i)=>(9 * i + 5) % 16);
let $5761bdcd8147f3b4$var$idxL = [
    $5761bdcd8147f3b4$var$Id
];
let $5761bdcd8147f3b4$var$idxR = [
    $5761bdcd8147f3b4$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $5761bdcd8147f3b4$var$idxL,
    $5761bdcd8147f3b4$var$idxR
])j.push(j[i].map((k)=>$5761bdcd8147f3b4$var$Rho[k]));
const $5761bdcd8147f3b4$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $5761bdcd8147f3b4$var$shiftsL = /* @__PURE__ */ $5761bdcd8147f3b4$var$idxL.map((idx, i)=>idx.map((j)=>$5761bdcd8147f3b4$var$shifts[i][j]));
const $5761bdcd8147f3b4$var$shiftsR = /* @__PURE__ */ $5761bdcd8147f3b4$var$idxR.map((idx, i)=>idx.map((j)=>$5761bdcd8147f3b4$var$shifts[i][j]));
const $5761bdcd8147f3b4$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $5761bdcd8147f3b4$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// The rotate left (circular left shift) operation for uint32
const $5761bdcd8147f3b4$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift;
// It's called f() in spec.
function $5761bdcd8147f3b4$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $5761bdcd8147f3b4$var$BUF = /* @__PURE__ */ new Uint32Array(16);
class $5761bdcd8147f3b4$export$7b0ccd21718381c9 extends (0, $29514d38274e65c0$export$ebbe38f24b9a0856) {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$5761bdcd8147f3b4$var$BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $5761bdcd8147f3b4$var$Kl[group], hbr = $5761bdcd8147f3b4$var$Kr[group]; // prettier-ignore
            const rl = $5761bdcd8147f3b4$var$idxL[group], rr = $5761bdcd8147f3b4$var$idxR[group]; // prettier-ignore
            const sl = $5761bdcd8147f3b4$var$shiftsL[group], sr = $5761bdcd8147f3b4$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = $5761bdcd8147f3b4$var$rotl(al + $5761bdcd8147f3b4$var$f(group, bl, cl, dl) + $5761bdcd8147f3b4$var$BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = $5761bdcd8147f3b4$var$rotl(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = $5761bdcd8147f3b4$var$rotl(ar + $5761bdcd8147f3b4$var$f(rGroup, br, cr, dr) + $5761bdcd8147f3b4$var$BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = $5761bdcd8147f3b4$var$rotl(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $5761bdcd8147f3b4$var$BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
const $5761bdcd8147f3b4$export$d1cea0ee4e3f0d3e = /* @__PURE__ */ (0, $c77b2cd8495ae394$export$f081816339df1972)(()=>new $5761bdcd8147f3b4$export$7b0ccd21718381c9());



let $98dde69ab041e37f$var$locked = false;
const $98dde69ab041e37f$var$_ripemd160 = function(data) {
    return (0, $5761bdcd8147f3b4$export$d1cea0ee4e3f0d3e)(data);
};
let $98dde69ab041e37f$var$__ripemd160 = $98dde69ab041e37f$var$_ripemd160;
function $98dde69ab041e37f$export$d1cea0ee4e3f0d3e(_data) {
    const data = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(_data, "data");
    return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)($98dde69ab041e37f$var$__ripemd160(data));
}
$98dde69ab041e37f$export$d1cea0ee4e3f0d3e._ = $98dde69ab041e37f$var$_ripemd160;
$98dde69ab041e37f$export$d1cea0ee4e3f0d3e.lock = function() {
    $98dde69ab041e37f$var$locked = true;
};
$98dde69ab041e37f$export$d1cea0ee4e3f0d3e.register = function(func) {
    if ($98dde69ab041e37f$var$locked) throw new TypeError("ripemd160 is locked");
    $98dde69ab041e37f$var$__ripemd160 = func;
};
Object.freeze($98dde69ab041e37f$export$d1cea0ee4e3f0d3e);


/**
 *  A **Password-Based Key-Derivation Function** is designed to create
 *  a sequence of bytes suitible as a **key** from a human-rememberable
 *  password.
 *
 *  @_subsection: api/crypto:Passwords  [about-pbkdf]
 */ 

let $87fe8f72ee20d952$var$locked = false;
const $87fe8f72ee20d952$var$_pbkdf2 = function(password, salt, iterations, keylen, algo) {
    return (0, $804dae2913482ac7$export$b80c7ba289c8fa56)(password, salt, iterations, keylen, algo);
};
let $87fe8f72ee20d952$var$__pbkdf2 = $87fe8f72ee20d952$var$_pbkdf2;
function $87fe8f72ee20d952$export$448fa22aedc9dbca(_password, _salt, iterations, keylen, algo) {
    const password = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(_password, "password");
    const salt = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)($87fe8f72ee20d952$var$__pbkdf2(password, salt, iterations, keylen, algo));
}
$87fe8f72ee20d952$export$448fa22aedc9dbca._ = $87fe8f72ee20d952$var$_pbkdf2;
$87fe8f72ee20d952$export$448fa22aedc9dbca.lock = function() {
    $87fe8f72ee20d952$var$locked = true;
};
$87fe8f72ee20d952$export$448fa22aedc9dbca.register = function(func) {
    if ($87fe8f72ee20d952$var$locked) throw new Error("pbkdf2 is locked");
    $87fe8f72ee20d952$var$__pbkdf2 = func;
};
Object.freeze($87fe8f72ee20d952$export$448fa22aedc9dbca);


/**
 *  A **Cryptographically Secure Random Value** is one that has been
 *  generated with additional care take to prevent side-channels
 *  from allowing others to detect it and prevent others from through
 *  coincidence generate the same values.
 *
 *  @_subsection: api/crypto:Random Values  [about-crypto-random]
 */ 
let $9bd9726dc6ac768c$var$locked = false;
const $9bd9726dc6ac768c$var$_randomBytes = function(length) {
    return new Uint8Array((0, $804dae2913482ac7$export$5f828d93ff035aa8)(length));
};
let $9bd9726dc6ac768c$var$__randomBytes = $9bd9726dc6ac768c$var$_randomBytes;
function $9bd9726dc6ac768c$export$5f828d93ff035aa8(length) {
    return $9bd9726dc6ac768c$var$__randomBytes(length);
}
$9bd9726dc6ac768c$export$5f828d93ff035aa8._ = $9bd9726dc6ac768c$var$_randomBytes;
$9bd9726dc6ac768c$export$5f828d93ff035aa8.lock = function() {
    $9bd9726dc6ac768c$var$locked = true;
};
$9bd9726dc6ac768c$export$5f828d93ff035aa8.register = function(func) {
    if ($9bd9726dc6ac768c$var$locked) throw new Error("randomBytes is locked");
    $9bd9726dc6ac768c$var$__randomBytes = func;
};
Object.freeze($9bd9726dc6ac768c$export$5f828d93ff035aa8);






// RFC 7914 Scrypt KDF
// Left rotate for uint32
const $bb01ac17186bd343$var$rotl = (a, b)=>a << b | a >>> 32 - b;
// The main Scrypt loop: uses Salsa extensively.
// Six versions of the function were tried, this is the fastest one.
// prettier-ignore
function $bb01ac17186bd343$var$XorAndSalsa(prev, pi, input, ii, out, oi) {
    // Based on https://cr.yp.to/salsa20.html
    // Xor blocks
    let y00 = prev[pi++] ^ input[ii++], y01 = prev[pi++] ^ input[ii++];
    let y02 = prev[pi++] ^ input[ii++], y03 = prev[pi++] ^ input[ii++];
    let y04 = prev[pi++] ^ input[ii++], y05 = prev[pi++] ^ input[ii++];
    let y06 = prev[pi++] ^ input[ii++], y07 = prev[pi++] ^ input[ii++];
    let y08 = prev[pi++] ^ input[ii++], y09 = prev[pi++] ^ input[ii++];
    let y10 = prev[pi++] ^ input[ii++], y11 = prev[pi++] ^ input[ii++];
    let y12 = prev[pi++] ^ input[ii++], y13 = prev[pi++] ^ input[ii++];
    let y14 = prev[pi++] ^ input[ii++], y15 = prev[pi++] ^ input[ii++];
    // Save state to temporary variables (salsa)
    let x00 = y00, x01 = y01, x02 = y02, x03 = y03, x04 = y04, x05 = y05, x06 = y06, x07 = y07, x08 = y08, x09 = y09, x10 = y10, x11 = y11, x12 = y12, x13 = y13, x14 = y14, x15 = y15;
    // Main loop (salsa)
    for(let i = 0; i < 8; i += 2){
        x04 ^= $bb01ac17186bd343$var$rotl(x00 + x12 | 0, 7);
        x08 ^= $bb01ac17186bd343$var$rotl(x04 + x00 | 0, 9);
        x12 ^= $bb01ac17186bd343$var$rotl(x08 + x04 | 0, 13);
        x00 ^= $bb01ac17186bd343$var$rotl(x12 + x08 | 0, 18);
        x09 ^= $bb01ac17186bd343$var$rotl(x05 + x01 | 0, 7);
        x13 ^= $bb01ac17186bd343$var$rotl(x09 + x05 | 0, 9);
        x01 ^= $bb01ac17186bd343$var$rotl(x13 + x09 | 0, 13);
        x05 ^= $bb01ac17186bd343$var$rotl(x01 + x13 | 0, 18);
        x14 ^= $bb01ac17186bd343$var$rotl(x10 + x06 | 0, 7);
        x02 ^= $bb01ac17186bd343$var$rotl(x14 + x10 | 0, 9);
        x06 ^= $bb01ac17186bd343$var$rotl(x02 + x14 | 0, 13);
        x10 ^= $bb01ac17186bd343$var$rotl(x06 + x02 | 0, 18);
        x03 ^= $bb01ac17186bd343$var$rotl(x15 + x11 | 0, 7);
        x07 ^= $bb01ac17186bd343$var$rotl(x03 + x15 | 0, 9);
        x11 ^= $bb01ac17186bd343$var$rotl(x07 + x03 | 0, 13);
        x15 ^= $bb01ac17186bd343$var$rotl(x11 + x07 | 0, 18);
        x01 ^= $bb01ac17186bd343$var$rotl(x00 + x03 | 0, 7);
        x02 ^= $bb01ac17186bd343$var$rotl(x01 + x00 | 0, 9);
        x03 ^= $bb01ac17186bd343$var$rotl(x02 + x01 | 0, 13);
        x00 ^= $bb01ac17186bd343$var$rotl(x03 + x02 | 0, 18);
        x06 ^= $bb01ac17186bd343$var$rotl(x05 + x04 | 0, 7);
        x07 ^= $bb01ac17186bd343$var$rotl(x06 + x05 | 0, 9);
        x04 ^= $bb01ac17186bd343$var$rotl(x07 + x06 | 0, 13);
        x05 ^= $bb01ac17186bd343$var$rotl(x04 + x07 | 0, 18);
        x11 ^= $bb01ac17186bd343$var$rotl(x10 + x09 | 0, 7);
        x08 ^= $bb01ac17186bd343$var$rotl(x11 + x10 | 0, 9);
        x09 ^= $bb01ac17186bd343$var$rotl(x08 + x11 | 0, 13);
        x10 ^= $bb01ac17186bd343$var$rotl(x09 + x08 | 0, 18);
        x12 ^= $bb01ac17186bd343$var$rotl(x15 + x14 | 0, 7);
        x13 ^= $bb01ac17186bd343$var$rotl(x12 + x15 | 0, 9);
        x14 ^= $bb01ac17186bd343$var$rotl(x13 + x12 | 0, 13);
        x15 ^= $bb01ac17186bd343$var$rotl(x14 + x13 | 0, 18);
    }
    // Write output (salsa)
    out[oi++] = y00 + x00 | 0;
    out[oi++] = y01 + x01 | 0;
    out[oi++] = y02 + x02 | 0;
    out[oi++] = y03 + x03 | 0;
    out[oi++] = y04 + x04 | 0;
    out[oi++] = y05 + x05 | 0;
    out[oi++] = y06 + x06 | 0;
    out[oi++] = y07 + x07 | 0;
    out[oi++] = y08 + x08 | 0;
    out[oi++] = y09 + x09 | 0;
    out[oi++] = y10 + x10 | 0;
    out[oi++] = y11 + x11 | 0;
    out[oi++] = y12 + x12 | 0;
    out[oi++] = y13 + x13 | 0;
    out[oi++] = y14 + x14 | 0;
    out[oi++] = y15 + x15 | 0;
}
function $bb01ac17186bd343$var$BlockMix(input, ii, out, oi, r) {
    // The block B is r 128-byte chunks (which is equivalent of 2r 64-byte chunks)
    let head = oi + 0;
    let tail = oi + 16 * r;
    for(let i = 0; i < 16; i++)out[tail + i] = input[ii + (2 * r - 1) * 16 + i]; // X ← B[2r−1]
    for(let i = 0; i < r; i++, head += 16, ii += 16){
        // We write odd & even Yi at same time. Even: 0bXXXXX0 Odd:  0bXXXXX1
        $bb01ac17186bd343$var$XorAndSalsa(out, tail, input, ii, out, head); // head[i] = Salsa(blockIn[2*i] ^ tail[i-1])
        if (i > 0) tail += 16; // First iteration overwrites tmp value in tail
        $bb01ac17186bd343$var$XorAndSalsa(out, head, input, ii += 16, out, tail); // tail[i] = Salsa(blockIn[2*i+1] ^ head[i])
    }
}
// Common prologue and epilogue for sync/async functions
function $bb01ac17186bd343$var$scryptInit(password, salt, _opts) {
    // Maxmem - 1GB+1KB by default
    const opts = (0, $c77b2cd8495ae394$export$6fcee72895eceb1e)({
        dkLen: 32,
        asyncTick: 10,
        maxmem: 1024 ** 3 + 1024
    }, _opts);
    const { N: N, r: r, p: p, dkLen: dkLen, asyncTick: asyncTick, maxmem: maxmem, onProgress: onProgress } = opts;
    (0, $f23a064ad7e0f12c$export$98e628dec113755e)(N);
    (0, $f23a064ad7e0f12c$export$98e628dec113755e)(r);
    (0, $f23a064ad7e0f12c$export$98e628dec113755e)(p);
    (0, $f23a064ad7e0f12c$export$98e628dec113755e)(dkLen);
    (0, $f23a064ad7e0f12c$export$98e628dec113755e)(asyncTick);
    (0, $f23a064ad7e0f12c$export$98e628dec113755e)(maxmem);
    if (onProgress !== undefined && typeof onProgress !== "function") throw new Error("progressCb should be function");
    const blockSize = 128 * r;
    const blockSize32 = blockSize / 4;
    if (N <= 1 || (N & N - 1) !== 0 || N >= 2 ** (blockSize / 8) || N > 2 ** 32) // NOTE: we limit N to be less than 2**32 because of 32 bit variant of Integrify function
    // There is no JS engines that allows alocate more than 4GB per single Uint8Array for now, but can change in future.
    throw new Error("Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32");
    if (p < 0 || p > (2 ** 32 - 1) * 32 / blockSize) throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
    if (dkLen < 0 || dkLen > (2 ** 32 - 1) * 32) throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
    const memUsed = blockSize * (N + p);
    if (memUsed > maxmem) throw new Error(`Scrypt: parameters too large, ${memUsed} (128 * r * (N + p)) > ${maxmem} (maxmem)`);
    // [B0...Bp−1] ← PBKDF2HMAC-SHA256(Passphrase, Salt, 1, blockSize*ParallelizationFactor)
    // Since it has only one iteration there is no reason to use async variant
    const B = (0, $2de97c5df551c9fb$export$448fa22aedc9dbca)((0, $4448b1ab7a1143c9$export$bced8d2aada2d1c9), password, salt, {
        c: 1,
        dkLen: blockSize * p
    });
    const B32 = (0, $c77b2cd8495ae394$export$8bacf4ad828c7fe7)(B);
    // Re-used between parallel iterations. Array(iterations) of B
    const V = (0, $c77b2cd8495ae394$export$8bacf4ad828c7fe7)(new Uint8Array(blockSize * N));
    const tmp = (0, $c77b2cd8495ae394$export$8bacf4ad828c7fe7)(new Uint8Array(blockSize));
    let blockMixCb = ()=>{};
    if (onProgress) {
        const totalBlockMix = 2 * N * p;
        // Invoke callback if progress changes from 10.01 to 10.02
        // Allows to draw smooth progress bar on up to 8K screen
        const callbackPer = Math.max(Math.floor(totalBlockMix / 10000), 1);
        let blockMixCnt = 0;
        blockMixCb = ()=>{
            blockMixCnt++;
            if (onProgress && (!(blockMixCnt % callbackPer) || blockMixCnt === totalBlockMix)) onProgress(blockMixCnt / totalBlockMix);
        };
    }
    return {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        blockSize32: blockSize32,
        V: V,
        B32: B32,
        B: B,
        tmp: tmp,
        blockMixCb: blockMixCb,
        asyncTick: asyncTick
    };
}
function $bb01ac17186bd343$var$scryptOutput(password, dkLen, B, V, tmp) {
    const res = (0, $2de97c5df551c9fb$export$448fa22aedc9dbca)((0, $4448b1ab7a1143c9$export$bced8d2aada2d1c9), password, B, {
        c: 1,
        dkLen: dkLen
    });
    B.fill(0);
    V.fill(0);
    tmp.fill(0);
    return res;
}
function $bb01ac17186bd343$export$7cf7c2f1ec457bf3(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb } = $bb01ac17186bd343$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        for(let i = 0, pos = 0; i < N - 1; i++){
            $bb01ac17186bd343$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        }
        $bb01ac17186bd343$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        for(let i = 0; i < N; i++){
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $bb01ac17186bd343$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        }
    }
    return $bb01ac17186bd343$var$scryptOutput(password, dkLen, B, V, tmp);
}
async function $bb01ac17186bd343$export$aaeeb1df7f0390e8(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb, asyncTick: asyncTick } = $bb01ac17186bd343$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        let pos = 0;
        await (0, $c77b2cd8495ae394$export$57207d71b8c929c8)(N - 1, asyncTick, ()=>{
            $bb01ac17186bd343$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        });
        $bb01ac17186bd343$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        await (0, $c77b2cd8495ae394$export$57207d71b8c929c8)(N, asyncTick, ()=>{
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $bb01ac17186bd343$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        });
    }
    return $bb01ac17186bd343$var$scryptOutput(password, dkLen, B, V, tmp);
}



let $5d0fc3d6c21ac1f0$var$lockedSync = false, $5d0fc3d6c21ac1f0$var$lockedAsync = false;
const $5d0fc3d6c21ac1f0$var$_scryptAsync = async function(passwd, salt, N, r, p, dkLen, onProgress) {
    return await (0, $bb01ac17186bd343$export$aaeeb1df7f0390e8)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        onProgress: onProgress
    });
};
const $5d0fc3d6c21ac1f0$var$_scryptSync = function(passwd, salt, N, r, p, dkLen) {
    return (0, $bb01ac17186bd343$export$7cf7c2f1ec457bf3)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen
    });
};
let $5d0fc3d6c21ac1f0$var$__scryptAsync = $5d0fc3d6c21ac1f0$var$_scryptAsync;
let $5d0fc3d6c21ac1f0$var$__scryptSync = $5d0fc3d6c21ac1f0$var$_scryptSync;
async function $5d0fc3d6c21ac1f0$export$7cf7c2f1ec457bf3(_passwd, _salt, N, r, p, dkLen, progress) {
    const passwd = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(_passwd, "passwd");
    const salt = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(await $5d0fc3d6c21ac1f0$var$__scryptAsync(passwd, salt, N, r, p, dkLen, progress));
}
$5d0fc3d6c21ac1f0$export$7cf7c2f1ec457bf3._ = $5d0fc3d6c21ac1f0$var$_scryptAsync;
$5d0fc3d6c21ac1f0$export$7cf7c2f1ec457bf3.lock = function() {
    $5d0fc3d6c21ac1f0$var$lockedAsync = true;
};
$5d0fc3d6c21ac1f0$export$7cf7c2f1ec457bf3.register = function(func) {
    if ($5d0fc3d6c21ac1f0$var$lockedAsync) throw new Error("scrypt is locked");
    $5d0fc3d6c21ac1f0$var$__scryptAsync = func;
};
Object.freeze($5d0fc3d6c21ac1f0$export$7cf7c2f1ec457bf3);
function $5d0fc3d6c21ac1f0$export$86c79e0734c26a76(_passwd, _salt, N, r, p, dkLen) {
    const passwd = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(_passwd, "passwd");
    const salt = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)($5d0fc3d6c21ac1f0$var$__scryptSync(passwd, salt, N, r, p, dkLen));
}
$5d0fc3d6c21ac1f0$export$86c79e0734c26a76._ = $5d0fc3d6c21ac1f0$var$_scryptSync;
$5d0fc3d6c21ac1f0$export$86c79e0734c26a76.lock = function() {
    $5d0fc3d6c21ac1f0$var$lockedSync = true;
};
$5d0fc3d6c21ac1f0$export$86c79e0734c26a76.register = function(func) {
    if ($5d0fc3d6c21ac1f0$var$lockedSync) throw new Error("scryptSync is locked");
    $5d0fc3d6c21ac1f0$var$__scryptSync = func;
};
Object.freeze($5d0fc3d6c21ac1f0$export$86c79e0734c26a76);




const $13e69841bbcc3689$var$_sha256 = function(data) {
    return (0, $804dae2913482ac7$export$2fb37efbf6ae0c0e)("sha256").update(data).digest();
};
const $13e69841bbcc3689$var$_sha512 = function(data) {
    return (0, $804dae2913482ac7$export$2fb37efbf6ae0c0e)("sha512").update(data).digest();
};
let $13e69841bbcc3689$var$__sha256 = $13e69841bbcc3689$var$_sha256;
let $13e69841bbcc3689$var$__sha512 = $13e69841bbcc3689$var$_sha512;
let $13e69841bbcc3689$var$locked256 = false, $13e69841bbcc3689$var$locked512 = false;
function $13e69841bbcc3689$export$bced8d2aada2d1c9(_data) {
    const data = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(_data, "data");
    return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)($13e69841bbcc3689$var$__sha256(data));
}
$13e69841bbcc3689$export$bced8d2aada2d1c9._ = $13e69841bbcc3689$var$_sha256;
$13e69841bbcc3689$export$bced8d2aada2d1c9.lock = function() {
    $13e69841bbcc3689$var$locked256 = true;
};
$13e69841bbcc3689$export$bced8d2aada2d1c9.register = function(func) {
    if ($13e69841bbcc3689$var$locked256) throw new Error("sha256 is locked");
    $13e69841bbcc3689$var$__sha256 = func;
};
Object.freeze($13e69841bbcc3689$export$bced8d2aada2d1c9);
function $13e69841bbcc3689$export$a888d2532e6dc7bb(_data) {
    const data = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(_data, "data");
    return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)($13e69841bbcc3689$var$__sha512(data));
}
$13e69841bbcc3689$export$a888d2532e6dc7bb._ = $13e69841bbcc3689$var$_sha512;
$13e69841bbcc3689$export$a888d2532e6dc7bb.lock = function() {
    $13e69841bbcc3689$var$locked512 = true;
};
$13e69841bbcc3689$export$a888d2532e6dc7bb.register = function(func) {
    if ($13e69841bbcc3689$var$locked512) throw new Error("sha512 is locked");
    $13e69841bbcc3689$var$__sha512 = func;
};
Object.freeze($13e69841bbcc3689$export$bced8d2aada2d1c9);


/**
 *  Add details about signing here.
 *
 *  @_subsection: api/crypto:Signing  [about-signing]
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 


var $fPpMu = parcelRequire("fPpMu");
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Short Weierstrass curve. The formula is: y² = x³ + ax + b

var $fPpMu = parcelRequire("fPpMu");

var $39n9f = parcelRequire("39n9f");

var $ywMPS = parcelRequire("ywMPS");
function $9eb78bd044e663b5$var$validatePointOpts(curve) {
    const opts = (0, $ywMPS.validateBasic)(curve);
    $39n9f.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $9eb78bd044e663b5$var$b2n, hexToBytes: $9eb78bd044e663b5$var$h2b } = $39n9f;
const $9eb78bd044e663b5$export$56ac33195d7076db = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = $9eb78bd044e663b5$export$56ac33195d7076db;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $9eb78bd044e663b5$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = $9eb78bd044e663b5$export$56ac33195d7076db;
        const data = typeof hex === "string" ? $9eb78bd044e663b5$var$h2b(hex) : hex;
        if (!(data instanceof Uint8Array)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = $9eb78bd044e663b5$export$56ac33195d7076db._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = $9eb78bd044e663b5$export$56ac33195d7076db._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $9eb78bd044e663b5$var$_0n = BigInt(0), $9eb78bd044e663b5$var$_1n = BigInt(1), $9eb78bd044e663b5$var$_2n = BigInt(2), $9eb78bd044e663b5$var$_3n = BigInt(3), $9eb78bd044e663b5$var$_4n = BigInt(4);
function $9eb78bd044e663b5$export$fa783af82e4fe0fc(opts) {
    const CURVE = $9eb78bd044e663b5$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $39n9f.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && $9eb78bd044e663b5$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if (key instanceof Uint8Array) key = $39n9f.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $39n9f.bytesToNumberBE((0, $39n9f.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $fPpMu.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $39n9f.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $9eb78bd044e663b5$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $9eb78bd044e663b5$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === $9eb78bd044e663b5$var$_0n) return I;
            assertGE(n); // Will throw on 0
            if (n === $9eb78bd044e663b5$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $9eb78bd044e663b5$var$_0n || k2 > $9eb78bd044e663b5$var$_0n){
                if (k1 & $9eb78bd044e663b5$var$_1n) k1p = k1p.add(d);
                if (k2 & $9eb78bd044e663b5$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $9eb78bd044e663b5$var$_1n;
                k2 >>= $9eb78bd044e663b5$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo: endo } = CURVE;
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $9eb78bd044e663b5$var$_0n || a === $9eb78bd044e663b5$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $9eb78bd044e663b5$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $9eb78bd044e663b5$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return $39n9f.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $ywMPS.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
function $9eb78bd044e663b5$var$validateOpts(curve) {
    const opts = (0, $ywMPS.validateBasic)(curve);
    $39n9f.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $9eb78bd044e663b5$export$350b8ea6f1c27fae(curveDef) {
    const CURVE = $9eb78bd044e663b5$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $9eb78bd044e663b5$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $fPpMu.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $fPpMu.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $9eb78bd044e663b5$export$fa783af82e4fe0fc({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $39n9f.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $39n9f.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & $9eb78bd044e663b5$var$_1n) === $9eb78bd044e663b5$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$39n9f.bytesToHex($39n9f.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $9eb78bd044e663b5$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$39n9f.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $39n9f.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $9eb78bd044e663b5$export$56ac33195d7076db.toSig((0, $39n9f.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $39n9f.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $39n9f.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return $9eb78bd044e663b5$export$56ac33195d7076db.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $39n9f.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $fPpMu.getMinHashLength(CURVE.n);
            return $fPpMu.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = item instanceof Uint8Array;
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $39n9f.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $39n9f.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!($9eb78bd044e663b5$var$_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return $39n9f.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $39n9f.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $39n9f.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $39n9f.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $39n9f.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $9eb78bd044e663b5$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $9eb78bd044e663b5$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $9eb78bd044e663b5$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $39n9f.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $39n9f.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $39n9f.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || sg instanceof Uint8Array) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $9eb78bd044e663b5$export$56ac33195d7076db.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
function $9eb78bd044e663b5$export$8324ae9483e33241(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $9eb78bd044e663b5$var$_0n;
    for(let o = q - $9eb78bd044e663b5$var$_1n; o % $9eb78bd044e663b5$var$_2n === $9eb78bd044e663b5$var$_0n; o /= $9eb78bd044e663b5$var$_2n)l += $9eb78bd044e663b5$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $9eb78bd044e663b5$var$_2n << c1 - $9eb78bd044e663b5$var$_1n - $9eb78bd044e663b5$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $9eb78bd044e663b5$var$_2n;
    const c2 = (q - $9eb78bd044e663b5$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $9eb78bd044e663b5$var$_1n) / $9eb78bd044e663b5$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $9eb78bd044e663b5$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $9eb78bd044e663b5$var$_1n) / $9eb78bd044e663b5$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $9eb78bd044e663b5$var$_1n; i--){
            let tv5 = i - $9eb78bd044e663b5$var$_2n; // 18.    tv5 = i - 2
            tv5 = $9eb78bd044e663b5$var$_2n << tv5 - $9eb78bd044e663b5$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $9eb78bd044e663b5$var$_4n === $9eb78bd044e663b5$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $9eb78bd044e663b5$var$_3n) / $9eb78bd044e663b5$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
function $9eb78bd044e663b5$export$cc7fea9756a17416(Fp, opts) {
    $fPpMu.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $9eb78bd044e663b5$export$8324ae9483e33241(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}



var $39n9f = parcelRequire("39n9f");

var $fPpMu = parcelRequire("fPpMu");

var $39n9f = parcelRequire("39n9f");
function $3dabf7d8a972d5c3$var$validateDST(dst) {
    if (dst instanceof Uint8Array) return dst;
    if (typeof dst === "string") return (0, $39n9f.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $3dabf7d8a972d5c3$var$os2ip = (0, $39n9f.bytesToNumberBE);
// Integer to Octet Stream (numberToBytesBE)
function $3dabf7d8a972d5c3$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $3dabf7d8a972d5c3$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $3dabf7d8a972d5c3$var$isBytes(item) {
    if (!(item instanceof Uint8Array)) throw new Error("Uint8Array expected");
}
function $3dabf7d8a972d5c3$var$isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
function $3dabf7d8a972d5c3$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    $3dabf7d8a972d5c3$var$isBytes(msg);
    $3dabf7d8a972d5c3$var$isBytes(DST);
    $3dabf7d8a972d5c3$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $39n9f.concatBytes)((0, $39n9f.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $39n9f.concatBytes)(DST, $3dabf7d8a972d5c3$var$i2osp(DST.length, 1));
    const Z_pad = $3dabf7d8a972d5c3$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $3dabf7d8a972d5c3$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $39n9f.concatBytes)(Z_pad, msg, l_i_b_str, $3dabf7d8a972d5c3$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $39n9f.concatBytes)(b_0, $3dabf7d8a972d5c3$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $3dabf7d8a972d5c3$var$strxor(b_0, b[i - 1]),
            $3dabf7d8a972d5c3$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $39n9f.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $39n9f.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $3dabf7d8a972d5c3$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    $3dabf7d8a972d5c3$var$isBytes(msg);
    $3dabf7d8a972d5c3$var$isBytes(DST);
    $3dabf7d8a972d5c3$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $39n9f.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($3dabf7d8a972d5c3$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($3dabf7d8a972d5c3$var$i2osp(DST.length, 1)).digest();
}
function $3dabf7d8a972d5c3$export$97cdd5ee18de8172(msg, count, options) {
    (0, $39n9f.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    $3dabf7d8a972d5c3$var$isBytes(msg);
    $3dabf7d8a972d5c3$var$isNum(count);
    const DST = $3dabf7d8a972d5c3$var$validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $3dabf7d8a972d5c3$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $3dabf7d8a972d5c3$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $fPpMu.mod)($3dabf7d8a972d5c3$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $3dabf7d8a972d5c3$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
function $3dabf7d8a972d5c3$export$14b114effbc08b6b(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $3dabf7d8a972d5c3$export$97cdd5ee18de8172(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $3dabf7d8a972d5c3$export$97cdd5ee18de8172(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}


/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 


function $37cd51f61f1247bd$export$adaba664e531641c(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $59843fb339d6159b$export$355af40f8ab02f34)(hash, key, (0, $c77b2cd8495ae394$export$287dd7971339c972)(...msgs)),
        randomBytes: $c77b2cd8495ae394$export$5f828d93ff035aa8
    };
}
function $37cd51f61f1247bd$export$3f2f6721dd02558a(curveDef, defHash) {
    const create = (hash)=>(0, $9eb78bd044e663b5$export$350b8ea6f1c27fae)({
            ...curveDef,
            ...$37cd51f61f1247bd$export$adaba664e531641c(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}


const $cbcde7d8856a7b55$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $cbcde7d8856a7b55$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $cbcde7d8856a7b55$var$_1n = BigInt(1);
const $cbcde7d8856a7b55$var$_2n = BigInt(2);
const $cbcde7d8856a7b55$var$divNearest = (a, b)=>(a + b / $cbcde7d8856a7b55$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $cbcde7d8856a7b55$var$sqrtMod(y) {
    const P = $cbcde7d8856a7b55$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $fPpMu.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $fPpMu.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $fPpMu.pow2)(b9, $cbcde7d8856a7b55$var$_2n, P) * b2 % P;
    const b22 = (0, $fPpMu.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $fPpMu.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $fPpMu.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $fPpMu.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $fPpMu.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $fPpMu.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $fPpMu.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $fPpMu.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $fPpMu.pow2)(t2, $cbcde7d8856a7b55$var$_2n, P);
    if (!$cbcde7d8856a7b55$var$Fp.eql($cbcde7d8856a7b55$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $cbcde7d8856a7b55$var$Fp = (0, $fPpMu.Field)($cbcde7d8856a7b55$var$secp256k1P, undefined, undefined, {
    sqrt: $cbcde7d8856a7b55$var$sqrtMod
});
const $cbcde7d8856a7b55$export$529e6123e9353a90 = (0, $37cd51f61f1247bd$export$3f2f6721dd02558a)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $cbcde7d8856a7b55$var$Fp,
    n: $cbcde7d8856a7b55$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $cbcde7d8856a7b55$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$cbcde7d8856a7b55$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $cbcde7d8856a7b55$var$divNearest(b2 * k, n);
            const c2 = $cbcde7d8856a7b55$var$divNearest(-b1 * k, n);
            let k1 = (0, $fPpMu.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $fPpMu.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, (0, $4448b1ab7a1143c9$export$bced8d2aada2d1c9));
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $cbcde7d8856a7b55$var$_0n = BigInt(0);
const $cbcde7d8856a7b55$var$fe = (x)=>typeof x === "bigint" && $cbcde7d8856a7b55$var$_0n < x && x < $cbcde7d8856a7b55$var$secp256k1P;
const $cbcde7d8856a7b55$var$ge = (x)=>typeof x === "bigint" && $cbcde7d8856a7b55$var$_0n < x && x < $cbcde7d8856a7b55$var$secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $cbcde7d8856a7b55$var$TAGGED_HASH_PREFIXES = {};
function $cbcde7d8856a7b55$var$taggedHash(tag, ...messages) {
    let tagP = $cbcde7d8856a7b55$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $4448b1ab7a1143c9$export$bced8d2aada2d1c9)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $39n9f.concatBytes)(tagH, tagH);
        $cbcde7d8856a7b55$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $4448b1ab7a1143c9$export$bced8d2aada2d1c9)((0, $39n9f.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $cbcde7d8856a7b55$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $cbcde7d8856a7b55$var$numTo32b = (n)=>(0, $39n9f.numberToBytesBE)(n, 32);
const $cbcde7d8856a7b55$var$modP = (x)=>(0, $fPpMu.mod)(x, $cbcde7d8856a7b55$var$secp256k1P);
const $cbcde7d8856a7b55$var$modN = (x)=>(0, $fPpMu.mod)(x, $cbcde7d8856a7b55$var$secp256k1N);
const $cbcde7d8856a7b55$var$Point = $cbcde7d8856a7b55$export$529e6123e9353a90.ProjectivePoint;
const $cbcde7d8856a7b55$var$GmulAdd = (Q, a, b)=>$cbcde7d8856a7b55$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $cbcde7d8856a7b55$var$schnorrGetExtPubKey(priv) {
    let d_ = $cbcde7d8856a7b55$export$529e6123e9353a90.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $cbcde7d8856a7b55$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $cbcde7d8856a7b55$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $cbcde7d8856a7b55$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $cbcde7d8856a7b55$var$lift_x(x) {
    if (!$cbcde7d8856a7b55$var$fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = $cbcde7d8856a7b55$var$modP(x * x);
    const c = $cbcde7d8856a7b55$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $cbcde7d8856a7b55$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $cbcde7d8856a7b55$var$_2n !== $cbcde7d8856a7b55$var$_0n) y = $cbcde7d8856a7b55$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $cbcde7d8856a7b55$var$Point(x, y, $cbcde7d8856a7b55$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $cbcde7d8856a7b55$var$challenge(...args) {
    return $cbcde7d8856a7b55$var$modN((0, $39n9f.bytesToNumberBE)($cbcde7d8856a7b55$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $cbcde7d8856a7b55$var$schnorrGetPublicKey(privateKey) {
    return $cbcde7d8856a7b55$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $cbcde7d8856a7b55$var$schnorrSign(message, privateKey, auxRand = (0, $c77b2cd8495ae394$export$5f828d93ff035aa8)(32)) {
    const m = (0, $39n9f.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $cbcde7d8856a7b55$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $39n9f.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $cbcde7d8856a7b55$var$numTo32b(d ^ (0, $39n9f.bytesToNumberBE)($cbcde7d8856a7b55$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $cbcde7d8856a7b55$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $cbcde7d8856a7b55$var$modN((0, $39n9f.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $cbcde7d8856a7b55$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $cbcde7d8856a7b55$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $cbcde7d8856a7b55$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($cbcde7d8856a7b55$var$numTo32b($cbcde7d8856a7b55$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$cbcde7d8856a7b55$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $cbcde7d8856a7b55$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $39n9f.ensureBytes)("signature", signature, 64);
    const m = (0, $39n9f.ensureBytes)("message", message);
    const pub = (0, $39n9f.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $cbcde7d8856a7b55$var$lift_x((0, $39n9f.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, $39n9f.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$cbcde7d8856a7b55$var$fe(r)) return false;
        const s = (0, $39n9f.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$cbcde7d8856a7b55$var$ge(s)) return false;
        const e = $cbcde7d8856a7b55$var$challenge($cbcde7d8856a7b55$var$numTo32b(r), $cbcde7d8856a7b55$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $cbcde7d8856a7b55$var$GmulAdd(P, s, $cbcde7d8856a7b55$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
const $cbcde7d8856a7b55$export$1f2401df071be9f = /* @__PURE__ */ (()=>({
        getPublicKey: $cbcde7d8856a7b55$var$schnorrGetPublicKey,
        sign: $cbcde7d8856a7b55$var$schnorrSign,
        verify: $cbcde7d8856a7b55$var$schnorrVerify,
        utils: {
            randomPrivateKey: $cbcde7d8856a7b55$export$529e6123e9353a90.utils.randomPrivateKey,
            lift_x: $cbcde7d8856a7b55$var$lift_x,
            pointToBytes: $cbcde7d8856a7b55$var$pointToBytes,
            numberToBytesBE: $39n9f.numberToBytesBE,
            bytesToNumberBE: $39n9f.bytesToNumberBE,
            taggedHash: $cbcde7d8856a7b55$var$taggedHash,
            mod: $fPpMu.mod
        }
    }))();
const $cbcde7d8856a7b55$var$isoMap = /* @__PURE__ */ (()=>(0, $3dabf7d8a972d5c3$export$9393380cf1075f28)($cbcde7d8856a7b55$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $cbcde7d8856a7b55$var$mapSWU = /* @__PURE__ */ (()=>(0, $9eb78bd044e663b5$export$cc7fea9756a17416)($cbcde7d8856a7b55$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $cbcde7d8856a7b55$var$Fp.create(BigInt("-11"))
    }))();
const $cbcde7d8856a7b55$var$htf = /* @__PURE__ */ (()=>(0, $3dabf7d8a972d5c3$export$14b114effbc08b6b)($cbcde7d8856a7b55$export$529e6123e9353a90.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $cbcde7d8856a7b55$var$mapSWU($cbcde7d8856a7b55$var$Fp.create(scalars[0]));
        return $cbcde7d8856a7b55$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $cbcde7d8856a7b55$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $4448b1ab7a1143c9$export$bced8d2aada2d1c9)
    }))();
const $cbcde7d8856a7b55$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$cbcde7d8856a7b55$var$htf.hashToCurve)();
const $cbcde7d8856a7b55$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$cbcde7d8856a7b55$var$htf.encodeToCurve)();



/**
 *  A constant for the zero hash.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000000000000000000000000000"``)
 */ const $a9fb74ca961b72e4$export$89c2533b29c23a61 = "0x0000000000000000000000000000000000000000000000000000000000000000";



// Constants
const $37038a1f415943f5$var$BN_0 = BigInt(0);
const $37038a1f415943f5$var$BN_1 = BigInt(1);
const $37038a1f415943f5$var$BN_2 = BigInt(2);
const $37038a1f415943f5$var$BN_27 = BigInt(27);
const $37038a1f415943f5$var$BN_28 = BigInt(28);
const $37038a1f415943f5$var$BN_35 = BigInt(35);
const $37038a1f415943f5$var$_guard = {};
function $37038a1f415943f5$var$toUint256(value) {
    return (0, $8de17c58ebd53b07$export$4473860254365feb)((0, $7df480338fc2bc47$export$b627fcfb5ea68cb0)(value), 32);
}
class $37038a1f415943f5$export$848620f5f2f26e86 {
    #r;
    #s;
    #v;
    #networkV;
    /**
     *  The ``r`` value for a signature.
     *
     *  This represents the ``x`` coordinate of a "reference" or
     *  challenge point, from which the ``y`` can be computed.
     */ get r() {
        return this.#r;
    }
    set r(value) {
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)((0, $8de17c58ebd53b07$export$2321cd91b99770ff)(value) === 32, "invalid r", "value", value);
        this.#r = (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(value);
    }
    /**
     *  The ``s`` value for a signature.
     */ get s() {
        return this.#s;
    }
    set s(_value) {
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)((0, $8de17c58ebd53b07$export$2321cd91b99770ff)(_value) === 32, "invalid s", "value", _value);
        const value = (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(_value);
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(parseInt(value.substring(0, 3)) < 8, "non-canonical s", "value", value);
        this.#s = value;
    }
    /**
     *  The ``v`` value for a signature.
     *
     *  Since a given ``x`` value for ``r`` has two possible values for
     *  its correspondin ``y``, the ``v`` indicates which of the two ``y``
     *  values to use.
     *
     *  It is normalized to the values ``27`` or ``28`` for legacy
     *  purposes.
     */ get v() {
        return this.#v;
    }
    set v(value) {
        const v = (0, $7df480338fc2bc47$export$b14f2714108df84)(value, "value");
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(v === 27 || v === 28, "invalid v", "v", value);
        this.#v = v;
    }
    /**
     *  The EIP-155 ``v`` for legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get networkV() {
        return this.#networkV;
    }
    /**
     *  The chain ID for EIP-155 legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get legacyChainId() {
        const v = this.networkV;
        if (v == null) return null;
        return $37038a1f415943f5$export$848620f5f2f26e86.getChainId(v);
    }
    /**
     *  The ``yParity`` for the signature.
     *
     *  See ``v`` for more details on how this value is used.
     */ get yParity() {
        return this.v === 27 ? 0 : 1;
    }
    /**
     *  The [[link-eip-2098]] compact representation of the ``yParity``
     *  and ``s`` compacted into a single ``bytes32``.
     */ get yParityAndS() {
        // The EIP-2098 compact representation
        const yParityAndS = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(this.s);
        if (this.yParity) yParityAndS[0] |= 0x80;
        return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(yParityAndS);
    }
    /**
     *  The [[link-eip-2098]] compact representation.
     */ get compactSerialized() {
        return (0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)([
            this.r,
            this.yParityAndS
        ]);
    }
    /**
     *  The serialized representation.
     */ get serialized() {
        return (0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)([
            this.r,
            this.s,
            this.yParity ? "0x1c" : "0x1b"
        ]);
    }
    /**
     *  @private
     */ constructor(guard, r, s, v){
        (0, $def55b050f09c63c$export$ac1a938d48ec8c7b)(guard, $37038a1f415943f5$var$_guard, "Signature");
        this.#r = r;
        this.#s = s;
        this.#v = v;
        this.#networkV = null;
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return `Signature { r: "${this.r}", s: "${this.s}", yParity: ${this.yParity}, networkV: ${this.networkV} }`;
    }
    /**
     *  Returns a new identical [[Signature]].
     */ clone() {
        const clone = new $37038a1f415943f5$export$848620f5f2f26e86($37038a1f415943f5$var$_guard, this.r, this.s, this.v);
        if (this.networkV) clone.#networkV = this.networkV;
        return clone;
    }
    /**
     *  Returns a representation that is compatible with ``JSON.stringify``.
     */ toJSON() {
        const networkV = this.networkV;
        return {
            _type: "signature",
            networkV: networkV != null ? networkV.toString() : null,
            r: this.r,
            s: this.s,
            v: this.v
        };
    }
    /**
     *  Compute the chain ID from the ``v`` in a legacy EIP-155 transactions.
     *
     *  @example:
     *    Signature.getChainId(45)
     *    //_result:
     *
     *    Signature.getChainId(46)
     *    //_result:
     */ static getChainId(v) {
        const bv = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(v, "v");
        // The v is not an EIP-155 v, so it is the unspecified chain ID
        if (bv == $37038a1f415943f5$var$BN_27 || bv == $37038a1f415943f5$var$BN_28) return $37038a1f415943f5$var$BN_0;
        // Bad value for an EIP-155 v
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(bv >= $37038a1f415943f5$var$BN_35, "invalid EIP-155 v", "v", v);
        return (bv - $37038a1f415943f5$var$BN_35) / $37038a1f415943f5$var$BN_2;
    }
    /**
     *  Compute the ``v`` for a chain ID for a legacy EIP-155 transactions.
     *
     *  Legacy transactions which use [[link-eip-155]] hijack the ``v``
     *  property to include the chain ID.
     *
     *  @example:
     *    Signature.getChainIdV(5, 27)
     *    //_result:
     *
     *    Signature.getChainIdV(5, 28)
     *    //_result:
     *
     */ static getChainIdV(chainId, v) {
        return (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(chainId) * $37038a1f415943f5$var$BN_2 + BigInt(35 + v - 27);
    }
    /**
     *  Compute the normalized legacy transaction ``v`` from a ``yParirty``,
     *  a legacy transaction ``v`` or a legacy [[link-eip-155]] transaction.
     *
     *  @example:
     *    // The values 0 and 1 imply v is actually yParity
     *    Signature.getNormalizedV(0)
     *    //_result:
     *
     *    // Legacy non-EIP-1559 transaction (i.e. 27 or 28)
     *    Signature.getNormalizedV(27)
     *    //_result:
     *
     *    // Legacy EIP-155 transaction (i.e. >= 35)
     *    Signature.getNormalizedV(46)
     *    //_result:
     *
     *    // Invalid values throw
     *    Signature.getNormalizedV(5)
     *    //_error:
     */ static getNormalizedV(v) {
        const bv = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(v);
        if (bv === $37038a1f415943f5$var$BN_0 || bv === $37038a1f415943f5$var$BN_27) return 27;
        if (bv === $37038a1f415943f5$var$BN_1 || bv === $37038a1f415943f5$var$BN_28) return 28;
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(bv >= $37038a1f415943f5$var$BN_35, "invalid v", "v", v);
        // Otherwise, EIP-155 v means odd is 27 and even is 28
        return bv & $37038a1f415943f5$var$BN_1 ? 27 : 28;
    }
    /**
     *  Creates a new [[Signature]].
     *
     *  If no %%sig%% is provided, a new [[Signature]] is created
     *  with default values.
     *
     *  If %%sig%% is a string, it is parsed.
     */ static from(sig) {
        function assertError(check, message) {
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(check, message, "signature", sig);
        }
        if (sig == null) return new $37038a1f415943f5$export$848620f5f2f26e86($37038a1f415943f5$var$_guard, (0, $a9fb74ca961b72e4$export$89c2533b29c23a61), (0, $a9fb74ca961b72e4$export$89c2533b29c23a61), 27);
        if (typeof sig === "string") {
            const bytes = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(sig, "signature");
            if (bytes.length === 64) {
                const r = (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                const v = s[0] & 0x80 ? 28 : 27;
                s[0] &= 0x7f;
                return new $37038a1f415943f5$export$848620f5f2f26e86($37038a1f415943f5$var$_guard, r, (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(s), v);
            }
            if (bytes.length === 65) {
                const r = (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                assertError((s[0] & 0x80) === 0, "non-canonical s");
                const v = $37038a1f415943f5$export$848620f5f2f26e86.getNormalizedV(bytes[64]);
                return new $37038a1f415943f5$export$848620f5f2f26e86($37038a1f415943f5$var$_guard, r, (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(s), v);
            }
            assertError(false, "invalid raw signature length");
        }
        if (sig instanceof $37038a1f415943f5$export$848620f5f2f26e86) return sig.clone();
        // Get r
        const _r = sig.r;
        assertError(_r != null, "missing r");
        const r = $37038a1f415943f5$var$toUint256(_r);
        // Get s; by any means necessary (we check consistency below)
        const s = function(s, yParityAndS) {
            if (s != null) return $37038a1f415943f5$var$toUint256(s);
            if (yParityAndS != null) {
                assertError((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(yParityAndS, 32), "invalid yParityAndS");
                const bytes = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(yParityAndS);
                bytes[0] &= 0x7f;
                return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(bytes);
            }
            assertError(false, "missing s");
        }(sig.s, sig.yParityAndS);
        assertError(((0, $8de17c58ebd53b07$export$a3521add2594f3c8)(s)[0] & 0x80) == 0, "non-canonical s");
        // Get v; by any means necessary (we check consistency below)
        const { networkV: networkV, v: v } = function(_v, yParityAndS, yParity) {
            if (_v != null) {
                const v = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(_v);
                return {
                    networkV: v >= $37038a1f415943f5$var$BN_35 ? v : undefined,
                    v: $37038a1f415943f5$export$848620f5f2f26e86.getNormalizedV(v)
                };
            }
            if (yParityAndS != null) {
                assertError((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(yParityAndS, 32), "invalid yParityAndS");
                return {
                    v: (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(yParityAndS)[0] & 0x80 ? 28 : 27
                };
            }
            if (yParity != null) {
                switch((0, $7df480338fc2bc47$export$b14f2714108df84)(yParity, "sig.yParity")){
                    case 0:
                        return {
                            v: 27
                        };
                    case 1:
                        return {
                            v: 28
                        };
                }
                assertError(false, "invalid yParity");
            }
            assertError(false, "missing v");
        }(sig.v, sig.yParityAndS, sig.yParity);
        const result = new $37038a1f415943f5$export$848620f5f2f26e86($37038a1f415943f5$var$_guard, r, s, v);
        if (networkV) result.#networkV = networkV;
        // If multiple of v, yParity, yParityAndS we given, check they match
        assertError(sig.yParity == null || (0, $7df480338fc2bc47$export$b14f2714108df84)(sig.yParity, "sig.yParity") === result.yParity, "yParity mismatch");
        assertError(sig.yParityAndS == null || sig.yParityAndS === result.yParityAndS, "yParityAndS mismatch");
        return result;
    }
}


class $2c64e14017a66a72$export$21643ca94aed3e83 {
    #privateKey;
    /**
     *  Creates a new **SigningKey** for %%privateKey%%.
     */ constructor(privateKey){
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)((0, $8de17c58ebd53b07$export$2321cd91b99770ff)(privateKey) === 32, "invalid private key", "privateKey", "[REDACTED]");
        this.#privateKey = (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(privateKey);
    }
    /**
     *  The private key.
     */ get privateKey() {
        return this.#privateKey;
    }
    /**
     *  The uncompressed public key.
     *
     * This will always begin with the prefix ``0x04`` and be 132
     * characters long (the ``0x`` prefix and 130 hexadecimal nibbles).
     */ get publicKey() {
        return $2c64e14017a66a72$export$21643ca94aed3e83.computePublicKey(this.#privateKey);
    }
    /**
     *  The compressed public key.
     *
     *  This will always begin with either the prefix ``0x02`` or ``0x03``
     *  and be 68 characters long (the ``0x`` prefix and 33 hexadecimal
     *  nibbles)
     */ get compressedPublicKey() {
        return $2c64e14017a66a72$export$21643ca94aed3e83.computePublicKey(this.#privateKey, true);
    }
    /**
     *  Return the signature of the signed %%digest%%.
     */ sign(digest) {
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)((0, $8de17c58ebd53b07$export$2321cd91b99770ff)(digest) === 32, "invalid digest length", "digest", digest);
        const sig = (0, $cbcde7d8856a7b55$export$529e6123e9353a90).sign((0, $8de17c58ebd53b07$export$37110e7fee0af4ad)(digest), (0, $8de17c58ebd53b07$export$37110e7fee0af4ad)(this.#privateKey), {
            lowS: true
        });
        return (0, $37038a1f415943f5$export$848620f5f2f26e86).from({
            r: (0, $7df480338fc2bc47$export$c6ebe05badb16181)(sig.r, 32),
            s: (0, $7df480338fc2bc47$export$c6ebe05badb16181)(sig.s, 32),
            v: sig.recovery ? 0x1c : 0x1b
        });
    }
    /**
     *  Returns the [[link-wiki-ecdh]] shared secret between this
     *  private key and the %%other%% key.
     *
     *  The %%other%% key may be any type of key, a raw public key,
     *  a compressed/uncompressed pubic key or aprivate key.
     *
     *  Best practice is usually to use a cryptographic hash on the
     *  returned value before using it as a symetric secret.
     *
     *  @example:
     *    sign1 = new SigningKey(id("some-secret-1"))
     *    sign2 = new SigningKey(id("some-secret-2"))
     *
     *    // Notice that privA.computeSharedSecret(pubB)...
     *    sign1.computeSharedSecret(sign2.publicKey)
     *    //_result:
     *
     *    // ...is equal to privB.computeSharedSecret(pubA).
     *    sign2.computeSharedSecret(sign1.publicKey)
     *    //_result:
     */ computeSharedSecret(other) {
        const pubKey = $2c64e14017a66a72$export$21643ca94aed3e83.computePublicKey(other);
        return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)((0, $cbcde7d8856a7b55$export$529e6123e9353a90).getSharedSecret((0, $8de17c58ebd53b07$export$37110e7fee0af4ad)(this.#privateKey), (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(pubKey), false));
    }
    /**
     *  Compute the public key for %%key%%, optionally %%compressed%%.
     *
     *  The %%key%% may be any type of key, a raw public key, a
     *  compressed/uncompressed public key or private key.
     *
     *  @example:
     *    sign = new SigningKey(id("some-secret"));
     *
     *    // Compute the uncompressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey)
     *    //_result:
     *
     *    // Compute the compressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey, true)
     *    //_result:
     *
     *    // Compute the uncompressed public key
     *    SigningKey.computePublicKey(sign.publicKey, false);
     *    //_result:
     *
     *    // Compute the Compressed a public key
     *    SigningKey.computePublicKey(sign.publicKey, true);
     *    //_result:
     */ static computePublicKey(key, compressed) {
        let bytes = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(key, "key");
        // private key
        if (bytes.length === 32) {
            const pubKey = (0, $cbcde7d8856a7b55$export$529e6123e9353a90).getPublicKey(bytes, !!compressed);
            return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(pubKey);
        }
        // raw public key; use uncompressed key with 0x04 prefix
        if (bytes.length === 64) {
            const pub = new Uint8Array(65);
            pub[0] = 0x04;
            pub.set(bytes, 1);
            bytes = pub;
        }
        const point = (0, $cbcde7d8856a7b55$export$529e6123e9353a90).ProjectivePoint.fromHex(bytes);
        return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(point.toRawBytes(compressed));
    }
    /**
     *  Returns the public key for the private key which produced the
     *  %%signature%% for the given %%digest%%.
     *
     *  @example:
     *    key = new SigningKey(id("some-secret"))
     *    digest = id("hello world")
     *    sig = key.sign(digest)
     *
     *    // Notice the signer public key...
     *    key.publicKey
     *    //_result:
     *
     *    // ...is equal to the recovered public key
     *    SigningKey.recoverPublicKey(digest, sig)
     *    //_result:
     *
     */ static recoverPublicKey(digest, signature) {
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)((0, $8de17c58ebd53b07$export$2321cd91b99770ff)(digest) === 32, "invalid digest length", "digest", digest);
        const sig = (0, $37038a1f415943f5$export$848620f5f2f26e86).from(signature);
        let secpSig = (0, $cbcde7d8856a7b55$export$529e6123e9353a90).Signature.fromCompact((0, $8de17c58ebd53b07$export$37110e7fee0af4ad)((0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)([
            sig.r,
            sig.s
        ])));
        secpSig = secpSig.addRecoveryBit(sig.yParity);
        const pubKey = secpSig.recoverPublicKey((0, $8de17c58ebd53b07$export$37110e7fee0af4ad)(digest));
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(pubKey != null, "invalid signature for digest", "signature", signature);
        return "0x" + pubKey.toHex(false);
    }
    /**
     *  Returns the point resulting from adding the ellipic curve points
     *  %%p0%% and %%p1%%.
     *
     *  This is not a common function most developers should require, but
     *  can be useful for certain privacy-specific techniques.
     *
     *  For example, it is used by [[HDNodeWallet]] to compute child
     *  addresses from parent public keys and chain codes.
     */ static addPoints(p0, p1, compressed) {
        const pub0 = (0, $cbcde7d8856a7b55$export$529e6123e9353a90).ProjectivePoint.fromHex($2c64e14017a66a72$export$21643ca94aed3e83.computePublicKey(p0).substring(2));
        const pub1 = (0, $cbcde7d8856a7b55$export$529e6123e9353a90).ProjectivePoint.fromHex($2c64e14017a66a72$export$21643ca94aed3e83.computePublicKey(p1).substring(2));
        return "0x" + pub0.add(pub1).toHex(!!compressed);
    }
}



/**
 *  Once called, prevents any future change to the underlying cryptographic
 *  primitives using the ``.register`` feature for hooks.
 */ function $43f1fc4fe6591fc9$export$6a9f04c98a658ecb() {
    (0, $a3afbc50b11f4cd5$export$967075d2f3b8e7ff).lock();
    (0, $1c3ba5429a8a9032$export$f8151fce47ad1c35).lock();
    (0, $87fe8f72ee20d952$export$448fa22aedc9dbca).lock();
    (0, $9bd9726dc6ac768c$export$5f828d93ff035aa8).lock();
    (0, $98dde69ab041e37f$export$d1cea0ee4e3f0d3e).lock();
    (0, $5d0fc3d6c21ac1f0$export$7cf7c2f1ec457bf3).lock();
    (0, $5d0fc3d6c21ac1f0$export$86c79e0734c26a76).lock();
    (0, $13e69841bbcc3689$export$bced8d2aada2d1c9).lock();
    (0, $13e69841bbcc3689$export$a888d2532e6dc7bb).lock();
    (0, $9bd9726dc6ac768c$export$5f828d93ff035aa8).lock();
}



const $61268443a2d16d36$var$BN_0 = BigInt(0);
const $61268443a2d16d36$var$BN_36 = BigInt(36);
function $61268443a2d16d36$var$getChecksumAddress(address) {
    //    if (!isHexString(address, 20)) {
    //        logger.throwArgumentError("invalid address", "address", address);
    //    }
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)((0, $1c3ba5429a8a9032$export$f8151fce47ad1c35)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $61268443a2d16d36$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$61268443a2d16d36$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$61268443a2d16d36$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
// i.e. Math.floor(Math.log10(Number.MAX_SAFE_INTEGER));
const $61268443a2d16d36$var$safeDigits = 15;
function $61268443a2d16d36$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $61268443a2d16d36$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $61268443a2d16d36$var$safeDigits){
        let block = expanded.substring(0, $61268443a2d16d36$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
const $61268443a2d16d36$var$Base36 = function() {
    const result = {};
    for(let i = 0; i < 36; i++){
        const key = "0123456789abcdefghijklmnopqrstuvwxyz"[i];
        result[key] = BigInt(i);
    }
    return result;
}();
function $61268443a2d16d36$var$fromBase36(value) {
    value = value.toLowerCase();
    let result = $61268443a2d16d36$var$BN_0;
    for(let i = 0; i < value.length; i++)result = result * $61268443a2d16d36$var$BN_36 + $61268443a2d16d36$var$Base36[value[i]];
    return result;
}
function $61268443a2d16d36$export$88411125f012957a(address) {
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(typeof address === "string", "invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (!address.startsWith("0x")) address = "0x" + address;
        const result = $61268443a2d16d36$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(!address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || result === address, "bad address checksum", "address", address);
        return result;
    }
    // Maybe ICAP? (we only support direct mode)
    if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(address.substring(2, 4) === $61268443a2d16d36$var$ibanChecksum(address), "bad icap checksum", "address", address);
        let result = $61268443a2d16d36$var$fromBase36(address.substring(4)).toString(16);
        while(result.length < 40)result = "0" + result;
        return $61268443a2d16d36$var$getChecksumAddress("0x" + result);
    }
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "invalid address", "address", address);
}
function $61268443a2d16d36$export$962c4ddada9f668f(address) {
    //let base36 = _base16To36(getAddress(address).substring(2)).toUpperCase();
    let base36 = BigInt($61268443a2d16d36$export$88411125f012957a(address)).toString(36).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $61268443a2d16d36$var$ibanChecksum("XE00" + base36) + base36;
}



/**
 *  A Typed object allows a value to have its type explicitly
 *  specified.
 *
 *  For example, in Solidity, the value ``45`` could represent a
 *  ``uint8`` or a ``uint256``. The value ``0x1234`` could represent
 *  a ``bytes2`` or ``bytes``.
 *
 *  Since JavaScript has no meaningful way to explicitly inform any
 *  APIs which what the type is, this allows transparent interoperation
 *  with Soldity.
 *
 *  @_subsection: api/abi:Typed Values
 */ 
const $ba580f5d16310ab2$var$_gaurd = {};
function $ba580f5d16310ab2$var$n(value, width) {
    let signed = false;
    if (width < 0) {
        signed = true;
        width *= -1;
    }
    // @TODO: Check range is valid for value
    return new $ba580f5d16310ab2$export$af51273277efe223($ba580f5d16310ab2$var$_gaurd, `${signed ? "" : "u"}int${width}`, value, {
        signed: signed,
        width: width
    });
}
function $ba580f5d16310ab2$var$b(value, size) {
    // @TODO: Check range is valid for value
    return new $ba580f5d16310ab2$export$af51273277efe223($ba580f5d16310ab2$var$_gaurd, `bytes${size ? size : ""}`, value, {
        size: size
    });
}
const $ba580f5d16310ab2$var$_typedSymbol = Symbol.for("_ethers_typed");
class $ba580f5d16310ab2$export$af51273277efe223 {
    /**
     *  The type, as a Solidity-compatible type.
     */ type;
    /**
     *  The actual value.
     */ value;
    #options;
    /**
     *  @_ignore:
     */ _typedSymbol;
    /**
     *  @_ignore:
     */ constructor(gaurd, type, value, options){
        if (options == null) options = null;
        (0, $def55b050f09c63c$export$ac1a938d48ec8c7b)($ba580f5d16310ab2$var$_gaurd, gaurd, "Typed");
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            _typedSymbol: $ba580f5d16310ab2$var$_typedSymbol,
            type: type,
            value: value
        });
        this.#options = options;
        // Check the value is valid
        this.format();
    }
    /**
     *  Format the type as a Human-Readable type.
     */ format() {
        if (this.type === "array") throw new Error("");
        else if (this.type === "dynamicArray") throw new Error("");
        else if (this.type === "tuple") return `tuple(${this.value.map((v)=>v.format()).join(",")})`;
        return this.type;
    }
    /**
     *  The default value returned by this type.
     */ defaultValue() {
        return 0;
    }
    /**
     *  The minimum value for numeric types.
     */ minValue() {
        return 0;
    }
    /**
     *  The maximum value for numeric types.
     */ maxValue() {
        return 0;
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
     */ isBigInt() {
        return !!this.type.match(/^u?int[0-9]+$/);
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
     */ isData() {
        return this.type.startsWith("bytes");
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
     */ isString() {
        return this.type === "string";
    }
    /**
     *  Returns the tuple name, if this is a tuple. Throws otherwise.
     */ get tupleName() {
        if (this.type !== "tuple") throw TypeError("not a tuple");
        return this.#options;
    }
    // Returns the length of this type as an array
    // - `null` indicates the length is unforced, it could be dynamic
    // - `-1` indicates the length is dynamic
    // - any other value indicates it is a static array and is its length
    /**
     *  Returns the length of the array type or ``-1`` if it is dynamic.
     *
     *  Throws if the type is not an array.
     */ get arrayLength() {
        if (this.type !== "array") throw TypeError("not an array");
        if (this.#options === true) return -1;
        if (this.#options === false) return this.value.length;
        return null;
    }
    /**
     *  Returns a new **Typed** of %%type%% with the %%value%%.
     */ static from(type, value) {
        return new $ba580f5d16310ab2$export$af51273277efe223($ba580f5d16310ab2$var$_gaurd, type, value);
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */ static uint8(v) {
        return $ba580f5d16310ab2$var$n(v, 8);
    }
    /**
     *  Return a new ``uint16`` type for %%v%%.
     */ static uint16(v) {
        return $ba580f5d16310ab2$var$n(v, 16);
    }
    /**
     *  Return a new ``uint24`` type for %%v%%.
     */ static uint24(v) {
        return $ba580f5d16310ab2$var$n(v, 24);
    }
    /**
     *  Return a new ``uint32`` type for %%v%%.
     */ static uint32(v) {
        return $ba580f5d16310ab2$var$n(v, 32);
    }
    /**
     *  Return a new ``uint40`` type for %%v%%.
     */ static uint40(v) {
        return $ba580f5d16310ab2$var$n(v, 40);
    }
    /**
     *  Return a new ``uint48`` type for %%v%%.
     */ static uint48(v) {
        return $ba580f5d16310ab2$var$n(v, 48);
    }
    /**
     *  Return a new ``uint56`` type for %%v%%.
     */ static uint56(v) {
        return $ba580f5d16310ab2$var$n(v, 56);
    }
    /**
     *  Return a new ``uint64`` type for %%v%%.
     */ static uint64(v) {
        return $ba580f5d16310ab2$var$n(v, 64);
    }
    /**
     *  Return a new ``uint72`` type for %%v%%.
     */ static uint72(v) {
        return $ba580f5d16310ab2$var$n(v, 72);
    }
    /**
     *  Return a new ``uint80`` type for %%v%%.
     */ static uint80(v) {
        return $ba580f5d16310ab2$var$n(v, 80);
    }
    /**
     *  Return a new ``uint88`` type for %%v%%.
     */ static uint88(v) {
        return $ba580f5d16310ab2$var$n(v, 88);
    }
    /**
     *  Return a new ``uint96`` type for %%v%%.
     */ static uint96(v) {
        return $ba580f5d16310ab2$var$n(v, 96);
    }
    /**
     *  Return a new ``uint104`` type for %%v%%.
     */ static uint104(v) {
        return $ba580f5d16310ab2$var$n(v, 104);
    }
    /**
     *  Return a new ``uint112`` type for %%v%%.
     */ static uint112(v) {
        return $ba580f5d16310ab2$var$n(v, 112);
    }
    /**
     *  Return a new ``uint120`` type for %%v%%.
     */ static uint120(v) {
        return $ba580f5d16310ab2$var$n(v, 120);
    }
    /**
     *  Return a new ``uint128`` type for %%v%%.
     */ static uint128(v) {
        return $ba580f5d16310ab2$var$n(v, 128);
    }
    /**
     *  Return a new ``uint136`` type for %%v%%.
     */ static uint136(v) {
        return $ba580f5d16310ab2$var$n(v, 136);
    }
    /**
     *  Return a new ``uint144`` type for %%v%%.
     */ static uint144(v) {
        return $ba580f5d16310ab2$var$n(v, 144);
    }
    /**
     *  Return a new ``uint152`` type for %%v%%.
     */ static uint152(v) {
        return $ba580f5d16310ab2$var$n(v, 152);
    }
    /**
     *  Return a new ``uint160`` type for %%v%%.
     */ static uint160(v) {
        return $ba580f5d16310ab2$var$n(v, 160);
    }
    /**
     *  Return a new ``uint168`` type for %%v%%.
     */ static uint168(v) {
        return $ba580f5d16310ab2$var$n(v, 168);
    }
    /**
     *  Return a new ``uint176`` type for %%v%%.
     */ static uint176(v) {
        return $ba580f5d16310ab2$var$n(v, 176);
    }
    /**
     *  Return a new ``uint184`` type for %%v%%.
     */ static uint184(v) {
        return $ba580f5d16310ab2$var$n(v, 184);
    }
    /**
     *  Return a new ``uint192`` type for %%v%%.
     */ static uint192(v) {
        return $ba580f5d16310ab2$var$n(v, 192);
    }
    /**
     *  Return a new ``uint200`` type for %%v%%.
     */ static uint200(v) {
        return $ba580f5d16310ab2$var$n(v, 200);
    }
    /**
     *  Return a new ``uint208`` type for %%v%%.
     */ static uint208(v) {
        return $ba580f5d16310ab2$var$n(v, 208);
    }
    /**
     *  Return a new ``uint216`` type for %%v%%.
     */ static uint216(v) {
        return $ba580f5d16310ab2$var$n(v, 216);
    }
    /**
     *  Return a new ``uint224`` type for %%v%%.
     */ static uint224(v) {
        return $ba580f5d16310ab2$var$n(v, 224);
    }
    /**
     *  Return a new ``uint232`` type for %%v%%.
     */ static uint232(v) {
        return $ba580f5d16310ab2$var$n(v, 232);
    }
    /**
     *  Return a new ``uint240`` type for %%v%%.
     */ static uint240(v) {
        return $ba580f5d16310ab2$var$n(v, 240);
    }
    /**
     *  Return a new ``uint248`` type for %%v%%.
     */ static uint248(v) {
        return $ba580f5d16310ab2$var$n(v, 248);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */ static uint256(v) {
        return $ba580f5d16310ab2$var$n(v, 256);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */ static uint(v) {
        return $ba580f5d16310ab2$var$n(v, 256);
    }
    /**
     *  Return a new ``int8`` type for %%v%%.
     */ static int8(v) {
        return $ba580f5d16310ab2$var$n(v, -8);
    }
    /**
     *  Return a new ``int16`` type for %%v%%.
     */ static int16(v) {
        return $ba580f5d16310ab2$var$n(v, -16);
    }
    /**
     *  Return a new ``int24`` type for %%v%%.
     */ static int24(v) {
        return $ba580f5d16310ab2$var$n(v, -24);
    }
    /**
     *  Return a new ``int32`` type for %%v%%.
     */ static int32(v) {
        return $ba580f5d16310ab2$var$n(v, -32);
    }
    /**
     *  Return a new ``int40`` type for %%v%%.
     */ static int40(v) {
        return $ba580f5d16310ab2$var$n(v, -40);
    }
    /**
     *  Return a new ``int48`` type for %%v%%.
     */ static int48(v) {
        return $ba580f5d16310ab2$var$n(v, -48);
    }
    /**
     *  Return a new ``int56`` type for %%v%%.
     */ static int56(v) {
        return $ba580f5d16310ab2$var$n(v, -56);
    }
    /**
     *  Return a new ``int64`` type for %%v%%.
     */ static int64(v) {
        return $ba580f5d16310ab2$var$n(v, -64);
    }
    /**
     *  Return a new ``int72`` type for %%v%%.
     */ static int72(v) {
        return $ba580f5d16310ab2$var$n(v, -72);
    }
    /**
     *  Return a new ``int80`` type for %%v%%.
     */ static int80(v) {
        return $ba580f5d16310ab2$var$n(v, -80);
    }
    /**
     *  Return a new ``int88`` type for %%v%%.
     */ static int88(v) {
        return $ba580f5d16310ab2$var$n(v, -88);
    }
    /**
     *  Return a new ``int96`` type for %%v%%.
     */ static int96(v) {
        return $ba580f5d16310ab2$var$n(v, -96);
    }
    /**
     *  Return a new ``int104`` type for %%v%%.
     */ static int104(v) {
        return $ba580f5d16310ab2$var$n(v, -104);
    }
    /**
     *  Return a new ``int112`` type for %%v%%.
     */ static int112(v) {
        return $ba580f5d16310ab2$var$n(v, -112);
    }
    /**
     *  Return a new ``int120`` type for %%v%%.
     */ static int120(v) {
        return $ba580f5d16310ab2$var$n(v, -120);
    }
    /**
     *  Return a new ``int128`` type for %%v%%.
     */ static int128(v) {
        return $ba580f5d16310ab2$var$n(v, -128);
    }
    /**
     *  Return a new ``int136`` type for %%v%%.
     */ static int136(v) {
        return $ba580f5d16310ab2$var$n(v, -136);
    }
    /**
     *  Return a new ``int144`` type for %%v%%.
     */ static int144(v) {
        return $ba580f5d16310ab2$var$n(v, -144);
    }
    /**
     *  Return a new ``int52`` type for %%v%%.
     */ static int152(v) {
        return $ba580f5d16310ab2$var$n(v, -152);
    }
    /**
     *  Return a new ``int160`` type for %%v%%.
     */ static int160(v) {
        return $ba580f5d16310ab2$var$n(v, -160);
    }
    /**
     *  Return a new ``int168`` type for %%v%%.
     */ static int168(v) {
        return $ba580f5d16310ab2$var$n(v, -168);
    }
    /**
     *  Return a new ``int176`` type for %%v%%.
     */ static int176(v) {
        return $ba580f5d16310ab2$var$n(v, -176);
    }
    /**
     *  Return a new ``int184`` type for %%v%%.
     */ static int184(v) {
        return $ba580f5d16310ab2$var$n(v, -184);
    }
    /**
     *  Return a new ``int92`` type for %%v%%.
     */ static int192(v) {
        return $ba580f5d16310ab2$var$n(v, -192);
    }
    /**
     *  Return a new ``int200`` type for %%v%%.
     */ static int200(v) {
        return $ba580f5d16310ab2$var$n(v, -200);
    }
    /**
     *  Return a new ``int208`` type for %%v%%.
     */ static int208(v) {
        return $ba580f5d16310ab2$var$n(v, -208);
    }
    /**
     *  Return a new ``int216`` type for %%v%%.
     */ static int216(v) {
        return $ba580f5d16310ab2$var$n(v, -216);
    }
    /**
     *  Return a new ``int224`` type for %%v%%.
     */ static int224(v) {
        return $ba580f5d16310ab2$var$n(v, -224);
    }
    /**
     *  Return a new ``int232`` type for %%v%%.
     */ static int232(v) {
        return $ba580f5d16310ab2$var$n(v, -232);
    }
    /**
     *  Return a new ``int240`` type for %%v%%.
     */ static int240(v) {
        return $ba580f5d16310ab2$var$n(v, -240);
    }
    /**
     *  Return a new ``int248`` type for %%v%%.
     */ static int248(v) {
        return $ba580f5d16310ab2$var$n(v, -248);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */ static int256(v) {
        return $ba580f5d16310ab2$var$n(v, -256);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */ static int(v) {
        return $ba580f5d16310ab2$var$n(v, -256);
    }
    /**
     *  Return a new ``bytes1`` type for %%v%%.
     */ static bytes1(v) {
        return $ba580f5d16310ab2$var$b(v, 1);
    }
    /**
     *  Return a new ``bytes2`` type for %%v%%.
     */ static bytes2(v) {
        return $ba580f5d16310ab2$var$b(v, 2);
    }
    /**
     *  Return a new ``bytes3`` type for %%v%%.
     */ static bytes3(v) {
        return $ba580f5d16310ab2$var$b(v, 3);
    }
    /**
     *  Return a new ``bytes4`` type for %%v%%.
     */ static bytes4(v) {
        return $ba580f5d16310ab2$var$b(v, 4);
    }
    /**
     *  Return a new ``bytes5`` type for %%v%%.
     */ static bytes5(v) {
        return $ba580f5d16310ab2$var$b(v, 5);
    }
    /**
     *  Return a new ``bytes6`` type for %%v%%.
     */ static bytes6(v) {
        return $ba580f5d16310ab2$var$b(v, 6);
    }
    /**
     *  Return a new ``bytes7`` type for %%v%%.
     */ static bytes7(v) {
        return $ba580f5d16310ab2$var$b(v, 7);
    }
    /**
     *  Return a new ``bytes8`` type for %%v%%.
     */ static bytes8(v) {
        return $ba580f5d16310ab2$var$b(v, 8);
    }
    /**
     *  Return a new ``bytes9`` type for %%v%%.
     */ static bytes9(v) {
        return $ba580f5d16310ab2$var$b(v, 9);
    }
    /**
     *  Return a new ``bytes10`` type for %%v%%.
     */ static bytes10(v) {
        return $ba580f5d16310ab2$var$b(v, 10);
    }
    /**
     *  Return a new ``bytes11`` type for %%v%%.
     */ static bytes11(v) {
        return $ba580f5d16310ab2$var$b(v, 11);
    }
    /**
     *  Return a new ``bytes12`` type for %%v%%.
     */ static bytes12(v) {
        return $ba580f5d16310ab2$var$b(v, 12);
    }
    /**
     *  Return a new ``bytes13`` type for %%v%%.
     */ static bytes13(v) {
        return $ba580f5d16310ab2$var$b(v, 13);
    }
    /**
     *  Return a new ``bytes14`` type for %%v%%.
     */ static bytes14(v) {
        return $ba580f5d16310ab2$var$b(v, 14);
    }
    /**
     *  Return a new ``bytes15`` type for %%v%%.
     */ static bytes15(v) {
        return $ba580f5d16310ab2$var$b(v, 15);
    }
    /**
     *  Return a new ``bytes16`` type for %%v%%.
     */ static bytes16(v) {
        return $ba580f5d16310ab2$var$b(v, 16);
    }
    /**
     *  Return a new ``bytes17`` type for %%v%%.
     */ static bytes17(v) {
        return $ba580f5d16310ab2$var$b(v, 17);
    }
    /**
     *  Return a new ``bytes18`` type for %%v%%.
     */ static bytes18(v) {
        return $ba580f5d16310ab2$var$b(v, 18);
    }
    /**
     *  Return a new ``bytes19`` type for %%v%%.
     */ static bytes19(v) {
        return $ba580f5d16310ab2$var$b(v, 19);
    }
    /**
     *  Return a new ``bytes20`` type for %%v%%.
     */ static bytes20(v) {
        return $ba580f5d16310ab2$var$b(v, 20);
    }
    /**
     *  Return a new ``bytes21`` type for %%v%%.
     */ static bytes21(v) {
        return $ba580f5d16310ab2$var$b(v, 21);
    }
    /**
     *  Return a new ``bytes22`` type for %%v%%.
     */ static bytes22(v) {
        return $ba580f5d16310ab2$var$b(v, 22);
    }
    /**
     *  Return a new ``bytes23`` type for %%v%%.
     */ static bytes23(v) {
        return $ba580f5d16310ab2$var$b(v, 23);
    }
    /**
     *  Return a new ``bytes24`` type for %%v%%.
     */ static bytes24(v) {
        return $ba580f5d16310ab2$var$b(v, 24);
    }
    /**
     *  Return a new ``bytes25`` type for %%v%%.
     */ static bytes25(v) {
        return $ba580f5d16310ab2$var$b(v, 25);
    }
    /**
     *  Return a new ``bytes26`` type for %%v%%.
     */ static bytes26(v) {
        return $ba580f5d16310ab2$var$b(v, 26);
    }
    /**
     *  Return a new ``bytes27`` type for %%v%%.
     */ static bytes27(v) {
        return $ba580f5d16310ab2$var$b(v, 27);
    }
    /**
     *  Return a new ``bytes28`` type for %%v%%.
     */ static bytes28(v) {
        return $ba580f5d16310ab2$var$b(v, 28);
    }
    /**
     *  Return a new ``bytes29`` type for %%v%%.
     */ static bytes29(v) {
        return $ba580f5d16310ab2$var$b(v, 29);
    }
    /**
     *  Return a new ``bytes30`` type for %%v%%.
     */ static bytes30(v) {
        return $ba580f5d16310ab2$var$b(v, 30);
    }
    /**
     *  Return a new ``bytes31`` type for %%v%%.
     */ static bytes31(v) {
        return $ba580f5d16310ab2$var$b(v, 31);
    }
    /**
     *  Return a new ``bytes32`` type for %%v%%.
     */ static bytes32(v) {
        return $ba580f5d16310ab2$var$b(v, 32);
    }
    /**
     *  Return a new ``address`` type for %%v%%.
     */ static address(v) {
        return new $ba580f5d16310ab2$export$af51273277efe223($ba580f5d16310ab2$var$_gaurd, "address", v);
    }
    /**
     *  Return a new ``bool`` type for %%v%%.
     */ static bool(v) {
        return new $ba580f5d16310ab2$export$af51273277efe223($ba580f5d16310ab2$var$_gaurd, "bool", !!v);
    }
    /**
     *  Return a new ``bytes`` type for %%v%%.
     */ static bytes(v) {
        return new $ba580f5d16310ab2$export$af51273277efe223($ba580f5d16310ab2$var$_gaurd, "bytes", v);
    }
    /**
     *  Return a new ``string`` type for %%v%%.
     */ static string(v) {
        return new $ba580f5d16310ab2$export$af51273277efe223($ba580f5d16310ab2$var$_gaurd, "string", v);
    }
    /**
     *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
     */ static array(v, dynamic) {
        throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
     */ static tuple(v, name) {
        throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */ static overrides(v) {
        return new $ba580f5d16310ab2$export$af51273277efe223($ba580f5d16310ab2$var$_gaurd, "overrides", Object.assign({}, v));
    }
    /**
     *  Returns true only if %%value%% is a [[Typed]] instance.
     */ static isTyped(value) {
        return value && typeof value === "object" && "_typedSymbol" in value && value._typedSymbol === $ba580f5d16310ab2$var$_typedSymbol;
    }
    /**
     *  If the value is a [[Typed]] instance, validates the underlying value
     *  and returns it, otherwise returns value directly.
     *
     *  This is useful for functions that with to accept either a [[Typed]]
     *  object or values.
     */ static dereference(value, type) {
        if ($ba580f5d16310ab2$export$af51273277efe223.isTyped(value)) {
            if (value.type !== type) throw new Error(`invalid type: expecetd ${type}, got ${value.type}`);
            return value.value;
        }
        return value;
    }
}



class $61c0fcd6226ace25$export$59dbbded7775bfe7 extends (0, $7373ab4bcc395b24$export$2c0c39526f8bad46) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, _value) {
        let value = (0, $ba580f5d16310ab2$export$af51273277efe223).dereference(_value, "string");
        try {
            value = (0, $61268443a2d16d36$export$88411125f012957a)(value);
        } catch (error) {
            return this._throwError(error.message, _value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $61268443a2d16d36$export$88411125f012957a)((0, $7df480338fc2bc47$export$c6ebe05badb16181)(reader.readValue(), 20));
    }
}






class $a51b7e8543ec7e7f$export$87c41d1139a03fa2 extends (0, $7373ab4bcc395b24$export$2c0c39526f8bad46) {
    coder;
    constructor(coder){
        super(coder.name, coder.type, "_", coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}


function $78ce9144b7f86a2b$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = [];
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            (0, $def55b050f09c63c$export$a7a9523472993e97)(name, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", {
                argument: "values",
                info: {
                    coder: coder
                },
                value: values
            });
            (0, $def55b050f09c63c$export$a7a9523472993e97)(!unique[name], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", {
                argument: "values",
                info: {
                    coder: coder
                },
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "invalid tuple value", "tuple", values);
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(coders.length === arrayValues.length, "types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $7373ab4bcc395b24$export$d7a960146e1a269e)();
    let dynamicWriter = new (0, $7373ab4bcc395b24$export$d7a960146e1a269e)();
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $78ce9144b7f86a2b$export$417857010dc9287f(reader, coders) {
    let values = [];
    let keys = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readIndex();
            let offsetReader = baseReader.subReader(offset);
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if ((0, $def55b050f09c63c$export$e6127cc7fe7395c3)(error, "BUFFER_OVERRUN")) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if ((0, $def55b050f09c63c$export$e6127cc7fe7395c3)(error, "BUFFER_OVERRUN")) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value == undefined) throw new Error("investigate");
        values.push(value);
        keys.push(coder.localName || null);
    });
    return (0, $7373ab4bcc395b24$export$8fdcabde73f49165).fromItems(values, keys);
}
class $78ce9144b7f86a2b$export$88bc419d2df11f54 extends (0, $7373ab4bcc395b24$export$2c0c39526f8bad46) {
    coder;
    length;
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            coder: coder,
            length: length
        });
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, _value) {
        const value = (0, $ba580f5d16310ab2$export$af51273277efe223).dereference(_value, "array");
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        (0, $def55b050f09c63c$export$d228410a8a77e4fa)(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $78ce9144b7f86a2b$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readIndex();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            (0, $def55b050f09c63c$export$a7a9523472993e97)(count * (0, $7373ab4bcc395b24$export$b4b1d1fba463e69c) <= reader.dataLength, "insufficient data length", "BUFFER_OVERRUN", {
                buffer: reader.bytes,
                offset: count * (0, $7373ab4bcc395b24$export$b4b1d1fba463e69c),
                length: reader.dataLength
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $a51b7e8543ec7e7f$export$87c41d1139a03fa2)(this.coder));
        return $78ce9144b7f86a2b$export$417857010dc9287f(reader, coders);
    }
}




class $348a6c77ccf75df7$export$fe9118d6c093150c extends (0, $7373ab4bcc395b24$export$2c0c39526f8bad46) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, _value) {
        const value = (0, $ba580f5d16310ab2$export$af51273277efe223).dereference(_value, "bool");
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return !!reader.readValue();
    }
}




class $002c032202f7ab15$export$db9eadd8df12ad2e extends (0, $7373ab4bcc395b24$export$2c0c39526f8bad46) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $8de17c58ebd53b07$export$37110e7fee0af4ad)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readIndex(), true);
    }
}
class $002c032202f7ab15$export$e5823e9574df18d2 extends $002c032202f7ab15$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(super.decode(reader));
    }
}





class $1ead665379dbc49b$export$7dec9db68e6bcf5a extends (0, $7373ab4bcc395b24$export$2c0c39526f8bad46) {
    size;
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            size: size
        }, {
            size: "number"
        });
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, _value) {
        let data = (0, $8de17c58ebd53b07$export$37110e7fee0af4ad)((0, $ba580f5d16310ab2$export$af51273277efe223).dereference(_value, this.type));
        if (data.length !== this.size) this._throwError("incorrect data length", _value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(reader.readBytes(this.size));
    }
}



const $815745996e1c5a9d$var$Empty = new Uint8Array([]);
class $815745996e1c5a9d$export$70982cadf2d6b4ec extends (0, $7373ab4bcc395b24$export$2c0c39526f8bad46) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes($815745996e1c5a9d$var$Empty);
    }
    decode(reader) {
        reader.readBytes(0);
        return null;
    }
}





const $046571f6e2601e59$var$BN_0 = BigInt(0);
const $046571f6e2601e59$var$BN_1 = BigInt(1);
const $046571f6e2601e59$var$BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
class $046571f6e2601e59$export$b934dc8cfe13938c extends (0, $7373ab4bcc395b24$export$2c0c39526f8bad46) {
    size;
    signed;
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            size: size,
            signed: signed
        }, {
            size: "number",
            signed: "boolean"
        });
    }
    defaultValue() {
        return 0;
    }
    encode(writer, _value) {
        let value = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)((0, $ba580f5d16310ab2$export$af51273277efe223).dereference(_value, this.type));
        // Check bounds are safe for encoding
        let maxUintValue = (0, $7df480338fc2bc47$export$d99f0801a68bbcf1)($046571f6e2601e59$var$BN_MAX_UINT256, (0, $7373ab4bcc395b24$export$b4b1d1fba463e69c) * 8);
        if (this.signed) {
            let bounds = (0, $7df480338fc2bc47$export$d99f0801a68bbcf1)(maxUintValue, this.size * 8 - 1);
            if (value > bounds || value < -(bounds + $046571f6e2601e59$var$BN_1)) this._throwError("value out-of-bounds", _value);
            value = (0, $7df480338fc2bc47$export$7101cd4e6275351c)(value, 8 * (0, $7373ab4bcc395b24$export$b4b1d1fba463e69c));
        } else if (value < $046571f6e2601e59$var$BN_0 || value > (0, $7df480338fc2bc47$export$d99f0801a68bbcf1)(maxUintValue, this.size * 8)) this._throwError("value out-of-bounds", _value);
        return writer.writeValue(value);
    }
    decode(reader) {
        let value = (0, $7df480338fc2bc47$export$d99f0801a68bbcf1)(reader.readValue(), this.size * 8);
        if (this.signed) value = (0, $7df480338fc2bc47$export$92182edcfa20e5bc)(value, this.size * 8);
        return value;
    }
}


/**
 *  Using strings in Ethereum (or any security-basd system) requires
 *  additional care. These utilities attempt to mitigate some of the
 *  safety issues as well as provide the ability to recover and analyse
 *  strings.
 *
 *  @_subsection api/utils:Strings and UTF-8  [about-strings]
 */ 

function $cdede1645bd34985$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, `invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $cdede1645bd34985$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === "BAD_PREFIX" || reason === "UNEXPECTED_CONTINUE") {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === "OVERRUN") return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $cdede1645bd34985$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === "OVERLONG") {
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(typeof badCodepoint === "number", "invalid bad code point for replacement", "badCodepoint", badCodepoint);
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $cdede1645bd34985$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $cdede1645bd34985$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $cdede1645bd34985$var$errorFunc,
    ignore: $cdede1645bd34985$var$ignoreFunc,
    replace: $cdede1645bd34985$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $cdede1645bd34985$var$getUtf8CodePoints(_bytes, onError) {
    if (onError == null) onError = $cdede1645bd34985$export$c6e2180c5bb5bc05.error;
    const bytes = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(_bytes, "bytes");
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError("UNEXPECTED_CONTINUE", i - 1, bytes, result);
            else i += onError("BAD_PREFIX", i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError("OVERRUN", i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError("MISSING_CONTINUE", i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError("OUT_OF_RANGE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError("UTF16_SURROGATE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError("OVERLONG", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $cdede1645bd34985$export$8feeb310b4b4752f(str, form) {
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(typeof str === "string", "invalid string value", "str", str);
    if (form != null) {
        (0, $def55b050f09c63c$export$d993e67fefdfecda)(form);
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(i < str.length && (c2 & 0xfc00) === 0xdc00, "invalid surrogate pair", "str", str);
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return new Uint8Array(result);
}
//export 
function $cdede1645bd34985$var$_toUtf8String(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $cdede1645bd34985$export$7643a1dc2c38d5eb(bytes, onError) {
    return $cdede1645bd34985$var$_toUtf8String($cdede1645bd34985$var$getUtf8CodePoints(bytes, onError));
}
function $cdede1645bd34985$export$ae470a36a31b28c2(str, form) {
    return $cdede1645bd34985$var$getUtf8CodePoints($cdede1645bd34985$export$8feeb310b4b4752f(str, form));
}




class $abab1fc021aefd6b$export$2d1b854518731426 extends (0, $002c032202f7ab15$export$db9eadd8df12ad2e) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, _value) {
        return super.encode(writer, (0, $cdede1645bd34985$export$8feeb310b4b4752f)((0, $ba580f5d16310ab2$export$af51273277efe223).dereference(_value, "string")));
    }
    decode(reader) {
        return (0, $cdede1645bd34985$export$7643a1dc2c38d5eb)(super.decode(reader));
    }
}






class $a959b027e3547ef3$export$e9fceba8f110fea6 extends (0, $7373ab4bcc395b24$export$2c0c39526f8bad46) {
    coders;
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            coders: Object.freeze(coders.slice())
        });
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, _value) {
        const value = (0, $ba580f5d16310ab2$export$af51273277efe223).dereference(_value, "tuple");
        return (0, $78ce9144b7f86a2b$export$2a703dbb0cb35339)(writer, this.coders, value);
    }
    decode(reader) {
        return (0, $78ce9144b7f86a2b$export$417857010dc9287f)(reader, this.coders);
    }
}


/**
 *  A fragment is a single item from an ABI, which may represent any of:
 *
 *  - [Functions](FunctionFragment)
 *  - [Events](EventFragment)
 *  - [Constructors](ConstructorFragment)
 *  - Custom [Errors](ErrorFragment)
 *  - [Fallback or Receive](FallbackFragment) functions
 *
 *  @_subsection api/abi/abi-coder:Fragments  [about-fragments]
 */ 


function $4af82668f5a6ec7b$export$d560c7e4a29451c2(value) {
    return (0, $1c3ba5429a8a9032$export$f8151fce47ad1c35)((0, $cdede1645bd34985$export$8feeb310b4b4752f)(value));
}


// [ "a", "b" ] => { "a": 1, "b": 1 }
function $33b91ae696ec7843$var$setify(items) {
    const result = new Set();
    items.forEach((k)=>result.add(k));
    return Object.freeze(result);
}
const $33b91ae696ec7843$var$_kwVisibDeploy = "external public payable override";
const $33b91ae696ec7843$var$KwVisibDeploy = $33b91ae696ec7843$var$setify($33b91ae696ec7843$var$_kwVisibDeploy.split(" "));
// Visibility Keywords
const $33b91ae696ec7843$var$_kwVisib = "constant external internal payable private public pure view override";
const $33b91ae696ec7843$var$KwVisib = $33b91ae696ec7843$var$setify($33b91ae696ec7843$var$_kwVisib.split(" "));
const $33b91ae696ec7843$var$_kwTypes = "constructor error event fallback function receive struct";
const $33b91ae696ec7843$var$KwTypes = $33b91ae696ec7843$var$setify($33b91ae696ec7843$var$_kwTypes.split(" "));
const $33b91ae696ec7843$var$_kwModifiers = "calldata memory storage payable indexed";
const $33b91ae696ec7843$var$KwModifiers = $33b91ae696ec7843$var$setify($33b91ae696ec7843$var$_kwModifiers.split(" "));
const $33b91ae696ec7843$var$_kwOther = "tuple returns";
// All Keywords
const $33b91ae696ec7843$var$_keywords = [
    $33b91ae696ec7843$var$_kwTypes,
    $33b91ae696ec7843$var$_kwModifiers,
    $33b91ae696ec7843$var$_kwOther,
    $33b91ae696ec7843$var$_kwVisib
].join(" ");
const $33b91ae696ec7843$var$Keywords = $33b91ae696ec7843$var$setify($33b91ae696ec7843$var$_keywords.split(" "));
// Single character tokens
const $33b91ae696ec7843$var$SimpleTokens = {
    "(": "OPEN_PAREN",
    ")": "CLOSE_PAREN",
    "[": "OPEN_BRACKET",
    "]": "CLOSE_BRACKET",
    ",": "COMMA",
    "@": "AT"
};
// Parser regexes to consume the next token
const $33b91ae696ec7843$var$regexWhitespacePrefix = new RegExp("^(\\s*)");
const $33b91ae696ec7843$var$regexNumberPrefix = new RegExp("^([0-9]+)");
const $33b91ae696ec7843$var$regexIdPrefix = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)");
// Parser regexs to check validity
const $33b91ae696ec7843$var$regexId = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$");
const $33b91ae696ec7843$var$regexType = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$");
class $33b91ae696ec7843$var$TokenString {
    #offset;
    #tokens;
    get offset() {
        return this.#offset;
    }
    get length() {
        return this.#tokens.length - this.#offset;
    }
    constructor(tokens){
        this.#offset = 0;
        this.#tokens = tokens.slice();
    }
    clone() {
        return new $33b91ae696ec7843$var$TokenString(this.#tokens);
    }
    reset() {
        this.#offset = 0;
    }
    #subTokenString(from = 0, to = 0) {
        return new $33b91ae696ec7843$var$TokenString(this.#tokens.slice(from, to).map((t)=>{
            return Object.freeze(Object.assign({}, t, {
                match: t.match - from,
                linkBack: t.linkBack - from,
                linkNext: t.linkNext - from
            }));
        }));
    }
    // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
    popKeyword(allowed) {
        const top = this.peek();
        if (top.type !== "KEYWORD" || !allowed.has(top.text)) throw new Error(`expected keyword ${top.text}`);
        return this.pop().text;
    }
    // Pops and returns the value of the next token if it is `type`; throws if out of tokens
    popType(type) {
        if (this.peek().type !== type) {
            const top = this.peek();
            throw new Error(`expected ${type}; got ${top.type} ${JSON.stringify(top.text)}`);
        }
        return this.pop().text;
    }
    // Pops and returns a "(" TOKENS ")"
    popParen() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = this.#subTokenString(this.#offset + 1, top.match + 1);
        this.#offset = top.match + 1;
        return result;
    }
    // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
    popParams() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = [];
        while(this.#offset < top.match - 1){
            const link = this.peek().linkNext;
            result.push(this.#subTokenString(this.#offset + 1, link));
            this.#offset = link;
        }
        this.#offset = top.match + 1;
        return result;
    }
    // Returns the top Token, throwing if out of tokens
    peek() {
        if (this.#offset >= this.#tokens.length) throw new Error("out-of-bounds");
        return this.#tokens[this.#offset];
    }
    // Returns the next value, if it is a keyword in `allowed`
    peekKeyword(allowed) {
        const top = this.peekType("KEYWORD");
        return top != null && allowed.has(top) ? top : null;
    }
    // Returns the value of the next token if it is `type`
    peekType(type) {
        if (this.length === 0) return null;
        const top = this.peek();
        return top.type === type ? top.text : null;
    }
    // Returns the next token; throws if out of tokens
    pop() {
        const result = this.peek();
        this.#offset++;
        return result;
    }
    toString() {
        const tokens = [];
        for(let i = this.#offset; i < this.#tokens.length; i++){
            const token = this.#tokens[i];
            tokens.push(`${token.type}:${token.text}`);
        }
        return `<TokenString ${tokens.join(" ")}>`;
    }
}
function $33b91ae696ec7843$var$lex(text) {
    const tokens = [];
    const throwError = (message)=>{
        const token = offset < text.length ? JSON.stringify(text[offset]) : "$EOI";
        throw new Error(`invalid token ${token} at ${offset}: ${message}`);
    };
    let brackets = [];
    let commas = [];
    let offset = 0;
    while(offset < text.length){
        // Strip off any leading whitespace
        let cur = text.substring(offset);
        let match = cur.match($33b91ae696ec7843$var$regexWhitespacePrefix);
        if (match) {
            offset += match[1].length;
            cur = text.substring(offset);
        }
        const token = {
            depth: brackets.length,
            linkBack: -1,
            linkNext: -1,
            match: -1,
            type: "",
            text: "",
            offset: offset,
            value: -1
        };
        tokens.push(token);
        let type = $33b91ae696ec7843$var$SimpleTokens[cur[0]] || "";
        if (type) {
            token.type = type;
            token.text = cur[0];
            offset++;
            if (type === "OPEN_PAREN") {
                brackets.push(tokens.length - 1);
                commas.push(tokens.length - 1);
            } else if (type == "CLOSE_PAREN") {
                if (brackets.length === 0) throwError("no matching open bracket");
                token.match = brackets.pop();
                tokens[token.match].match = tokens.length - 1;
                token.depth--;
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
            } else if (type === "COMMA") {
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
                commas.push(tokens.length - 1);
            } else if (type === "OPEN_BRACKET") token.type = "BRACKET";
            else if (type === "CLOSE_BRACKET") {
                // Remove the CLOSE_BRACKET
                let suffix = tokens.pop().text;
                if (tokens.length > 0 && tokens[tokens.length - 1].type === "NUMBER") {
                    const value = tokens.pop().text;
                    suffix = value + suffix;
                    tokens[tokens.length - 1].value = (0, $7df480338fc2bc47$export$b14f2714108df84)(value);
                }
                if (tokens.length === 0 || tokens[tokens.length - 1].type !== "BRACKET") throw new Error("missing opening bracket");
                tokens[tokens.length - 1].text += suffix;
            }
            continue;
        }
        match = cur.match($33b91ae696ec7843$var$regexIdPrefix);
        if (match) {
            token.text = match[1];
            offset += token.text.length;
            if ($33b91ae696ec7843$var$Keywords.has(token.text)) {
                token.type = "KEYWORD";
                continue;
            }
            if (token.text.match($33b91ae696ec7843$var$regexType)) {
                token.type = "TYPE";
                continue;
            }
            token.type = "ID";
            continue;
        }
        match = cur.match($33b91ae696ec7843$var$regexNumberPrefix);
        if (match) {
            token.text = match[1];
            token.type = "NUMBER";
            offset += token.text.length;
            continue;
        }
        throw new Error(`unexpected token ${JSON.stringify(cur[0])} at position ${offset}`);
    }
    return new $33b91ae696ec7843$var$TokenString(tokens.map((t)=>Object.freeze(t)));
}
// Check only one of `allowed` is in `set`
function $33b91ae696ec7843$var$allowSingle(set, allowed) {
    let included = [];
    for(const key in allowed.keys())if (set.has(key)) included.push(key);
    if (included.length > 1) throw new Error(`conflicting types: ${included.join(", ")}`);
}
// Functions to process a Solidity Signature TokenString from left-to-right for...
// ...the name with an optional type, returning the name
function $33b91ae696ec7843$var$consumeName(type, tokens) {
    if (tokens.peekKeyword($33b91ae696ec7843$var$KwTypes)) {
        const keyword = tokens.pop().text;
        if (keyword !== type) throw new Error(`expected ${type}, got ${keyword}`);
    }
    return tokens.popType("ID");
}
// ...all keywords matching allowed, returning the keywords
function $33b91ae696ec7843$var$consumeKeywords(tokens, allowed) {
    const keywords = new Set();
    while(true){
        const keyword = tokens.peekType("KEYWORD");
        if (keyword == null || allowed && !allowed.has(keyword)) break;
        tokens.pop();
        if (keywords.has(keyword)) throw new Error(`duplicate keywords: ${JSON.stringify(keyword)}`);
        keywords.add(keyword);
    }
    return Object.freeze(keywords);
}
// ...all visibility keywords, returning the coalesced mutability
function $33b91ae696ec7843$var$consumeMutability(tokens) {
    let modifiers = $33b91ae696ec7843$var$consumeKeywords(tokens, $33b91ae696ec7843$var$KwVisib);
    // Detect conflicting modifiers
    $33b91ae696ec7843$var$allowSingle(modifiers, $33b91ae696ec7843$var$setify("constant payable nonpayable".split(" ")));
    $33b91ae696ec7843$var$allowSingle(modifiers, $33b91ae696ec7843$var$setify("pure view payable nonpayable".split(" ")));
    // Process mutability states
    if (modifiers.has("view")) return "view";
    if (modifiers.has("pure")) return "pure";
    if (modifiers.has("payable")) return "payable";
    if (modifiers.has("nonpayable")) return "nonpayable";
    // Process legacy `constant` last
    if (modifiers.has("constant")) return "view";
    return "nonpayable";
}
// ...a parameter list, returning the ParamType list
function $33b91ae696ec7843$var$consumeParams(tokens, allowIndexed) {
    return tokens.popParams().map((t)=>$33b91ae696ec7843$export$426dc07f493a4c47.from(t, allowIndexed));
}
// ...a gas limit, returning a BigNumber or null if none
function $33b91ae696ec7843$var$consumeGas(tokens) {
    if (tokens.peekType("AT")) {
        tokens.pop();
        if (tokens.peekType("NUMBER")) return (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(tokens.pop().text);
        throw new Error("invalid gas");
    }
    return null;
}
function $33b91ae696ec7843$var$consumeEoi(tokens) {
    if (tokens.length) throw new Error(`unexpected tokens at offset ${tokens.offset}: ${tokens.toString()}`);
}
const $33b91ae696ec7843$var$regexArrayType = new RegExp(/^(.*)\[([0-9]*)\]$/);
function $33b91ae696ec7843$var$verifyBasicType(type) {
    const match = type.match($33b91ae696ec7843$var$regexType);
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(match, "invalid type", "type", type);
    if (type === "uint") return "uint256";
    if (type === "int") return "int256";
    if (match[2]) {
        // bytesXX
        const length = parseInt(match[2]);
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(length !== 0 && length <= 32, "invalid bytes length", "type", type);
    } else if (match[3]) {
        // intXX or uintXX
        const size = parseInt(match[3]);
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(size !== 0 && size <= 256 && size % 8 === 0, "invalid numeric width", "type", type);
    }
    return type;
}
// Make the Fragment constructors effectively private
const $33b91ae696ec7843$var$_guard = {};
const $33b91ae696ec7843$var$internal = Symbol.for("_ethers_internal");
const $33b91ae696ec7843$var$ParamTypeInternal = "_ParamTypeInternal";
const $33b91ae696ec7843$var$ErrorFragmentInternal = "_ErrorInternal";
const $33b91ae696ec7843$var$EventFragmentInternal = "_EventInternal";
const $33b91ae696ec7843$var$ConstructorFragmentInternal = "_ConstructorInternal";
const $33b91ae696ec7843$var$FallbackFragmentInternal = "_FallbackInternal";
const $33b91ae696ec7843$var$FunctionFragmentInternal = "_FunctionInternal";
const $33b91ae696ec7843$var$StructFragmentInternal = "_StructInternal";
class $33b91ae696ec7843$export$426dc07f493a4c47 {
    /**
     *  The local name of the parameter (or ``""`` if unbound)
     */ name;
    /**
     *  The fully qualified type (e.g. ``"address"``, ``"tuple(address)"``,
     *  ``"uint256[3][]"``)
     */ type;
    /**
     *  The base type (e.g. ``"address"``, ``"tuple"``, ``"array"``)
     */ baseType;
    /**
     *  True if the parameters is indexed.
     *
     *  For non-indexable types this is ``null``.
     */ indexed;
    /**
     *  The components for the tuple.
     *
     *  For non-tuple types this is ``null``.
     */ components;
    /**
     *  The array length, or ``-1`` for dynamic-lengthed arrays.
     *
     *  For non-array types this is ``null``.
     */ arrayLength;
    /**
     *  The type of each child in the array.
     *
     *  For non-array types this is ``null``.
     */ arrayChildren;
    /**
     *  @private
     */ constructor(guard, name, type, baseType, indexed, components, arrayLength, arrayChildren){
        (0, $def55b050f09c63c$export$ac1a938d48ec8c7b)(guard, $33b91ae696ec7843$var$_guard, "ParamType");
        Object.defineProperty(this, $33b91ae696ec7843$var$internal, {
            value: $33b91ae696ec7843$var$ParamTypeInternal
        });
        if (components) components = Object.freeze(components.slice());
        if (baseType === "array") {
            if (arrayLength == null || arrayChildren == null) throw new Error("");
        } else if (arrayLength != null || arrayChildren != null) throw new Error("");
        if (baseType === "tuple") {
            if (components == null) throw new Error("");
        } else if (components != null) throw new Error("");
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            name: name,
            type: type,
            baseType: baseType,
            indexed: indexed,
            components: components,
            arrayLength: arrayLength,
            arrayChildren: arrayChildren
        });
    }
    /**
     *  Return a string representation of this type.
     *
     *  For example,
     *
     *  ``sighash" => "(uint256,address)"``
     *
     *  ``"minimal" => "tuple(uint256,address) indexed"``
     *
     *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") {
            const name = this.name || "";
            if (this.isArray()) {
                const result = JSON.parse(this.arrayChildren.format("json"));
                result.name = name;
                result.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
                return JSON.stringify(result);
            }
            const result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: name
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.isTuple()) result.components = this.components.map((c)=>JSON.parse(c.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.isArray()) {
            result += this.arrayChildren.format(format);
            result += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
        } else if (this.isTuple()) result += "(" + this.components.map((comp)=>comp.format(format)).join(format === "full" ? ", " : ",") + ")";
        else result += this.type;
        if (format !== "sighash") {
            if (this.indexed === true) result += " indexed";
            if (format === "full" && this.name) result += " " + this.name;
        }
        return result;
    }
    /**
     *  Returns true if %%this%% is an Array type.
     *
     *  This provides a type gaurd ensuring that [[arrayChildren]]
     *  and [[arrayLength]] are non-null.
     */ isArray() {
        return this.baseType === "array";
    }
    /**
     *  Returns true if %%this%% is a Tuple type.
     *
     *  This provides a type gaurd ensuring that [[components]]
     *  is non-null.
     */ isTuple() {
        return this.baseType === "tuple";
    }
    /**
     *  Returns true if %%this%% is an Indexable type.
     *
     *  This provides a type gaurd ensuring that [[indexed]]
     *  is non-null.
     */ isIndexable() {
        return this.indexed != null;
    }
    /**
     *  Walks the **ParamType** with %%value%%, calling %%process%%
     *  on each type, destructing the %%value%% recursively.
     */ walk(value, process) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v)=>_this.arrayChildren.walk(v, process));
        }
        if (this.isTuple()) {
            if (!Array.isArray(value)) throw new Error("invalid tuple value");
            if (value.length !== this.components.length) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v, i)=>_this.components[i].walk(v, process));
        }
        return process(this.type, value);
    }
    #walkAsync(promises, value, process, setValue) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const childType = this.arrayChildren;
            const result = value.slice();
            result.forEach((value, index)=>{
                childType.#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        if (this.isTuple()) {
            const components = this.components;
            // Convert the object into an array
            let result;
            if (Array.isArray(value)) result = value.slice();
            else {
                if (value == null || typeof value !== "object") throw new Error("invalid tuple value");
                result = components.map((param)=>{
                    if (!param.name) throw new Error("cannot use object value with unnamed components");
                    if (!(param.name in value)) throw new Error(`missing value for component ${param.name}`);
                    return value[param.name];
                });
            }
            if (result.length !== this.components.length) throw new Error("array is wrong length");
            result.forEach((value, index)=>{
                components[index].#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        const result = process(this.type, value);
        if (result.then) promises.push(async function() {
            setValue(await result);
        }());
        else setValue(result);
    }
    /**
     *  Walks the **ParamType** with %%value%%, asynchronously calling
     *  %%process%% on each type, destructing the %%value%% recursively.
     *
     *  This can be used to resolve ENS names by walking and resolving each
     *  ``"address"`` type.
     */ async walkAsync(value, process) {
        const promises = [];
        const result = [
            value
        ];
        this.#walkAsync(promises, value, process, (value)=>{
            result[0] = value;
        });
        if (promises.length) await Promise.all(promises);
        return result[0];
    }
    /**
     *  Creates a new **ParamType** for %%obj%%.
     *
     *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
     *  otherwise the ``indexed`` keyword will throw an error.
     */ static from(obj, allowIndexed) {
        if ($33b91ae696ec7843$export$426dc07f493a4c47.isParamType(obj)) return obj;
        if (typeof obj === "string") try {
            return $33b91ae696ec7843$export$426dc07f493a4c47.from($33b91ae696ec7843$var$lex(obj), allowIndexed);
        } catch (error) {
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "invalid param type", "obj", obj);
        }
        else if (obj instanceof $33b91ae696ec7843$var$TokenString) {
            let type = "", baseType = "";
            let comps = null;
            if ($33b91ae696ec7843$var$consumeKeywords(obj, $33b91ae696ec7843$var$setify([
                "tuple"
            ])).has("tuple") || obj.peekType("OPEN_PAREN")) {
                // Tuple
                baseType = "tuple";
                comps = obj.popParams().map((t)=>$33b91ae696ec7843$export$426dc07f493a4c47.from(t));
                type = `tuple(${comps.map((c)=>c.format()).join(",")})`;
            } else {
                // Normal
                type = $33b91ae696ec7843$var$verifyBasicType(obj.popType("TYPE"));
                baseType = type;
            }
            // Check for Array
            let arrayChildren = null;
            let arrayLength = null;
            while(obj.length && obj.peekType("BRACKET")){
                const bracket = obj.pop(); //arrays[i];
                arrayChildren = new $33b91ae696ec7843$export$426dc07f493a4c47($33b91ae696ec7843$var$_guard, "", type, baseType, null, comps, arrayLength, arrayChildren);
                arrayLength = bracket.value;
                type += bracket.text;
                baseType = "array";
                comps = null;
            }
            let indexed = null;
            const keywords = $33b91ae696ec7843$var$consumeKeywords(obj, $33b91ae696ec7843$var$KwModifiers);
            if (keywords.has("indexed")) {
                if (!allowIndexed) throw new Error("");
                indexed = true;
            }
            const name = obj.peekType("ID") ? obj.pop().text : "";
            if (obj.length) throw new Error("leftover tokens");
            return new $33b91ae696ec7843$export$426dc07f493a4c47($33b91ae696ec7843$var$_guard, name, type, baseType, indexed, comps, arrayLength, arrayChildren);
        }
        const name = obj.name;
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(!name || typeof name === "string" && name.match($33b91ae696ec7843$var$regexId), "invalid name", "obj.name", name);
        let indexed = obj.indexed;
        if (indexed != null) {
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(allowIndexed, "parameter cannot be indexed", "obj.indexed", obj.indexed);
            indexed = !!indexed;
        }
        let type = obj.type;
        let arrayMatch = type.match($33b91ae696ec7843$var$regexArrayType);
        if (arrayMatch) {
            const arrayLength = parseInt(arrayMatch[2] || "-1");
            const arrayChildren = $33b91ae696ec7843$export$426dc07f493a4c47.from({
                type: arrayMatch[1],
                components: obj.components
            });
            return new $33b91ae696ec7843$export$426dc07f493a4c47($33b91ae696ec7843$var$_guard, name || "", type, "array", indexed, null, arrayLength, arrayChildren);
        }
        if (type === "tuple" || type.startsWith("tuple(" /* fix: ) */ ) || type.startsWith("(" /* fix: ) */ )) {
            const comps = obj.components != null ? obj.components.map((c)=>$33b91ae696ec7843$export$426dc07f493a4c47.from(c)) : null;
            const tuple = new $33b91ae696ec7843$export$426dc07f493a4c47($33b91ae696ec7843$var$_guard, name || "", type, "tuple", indexed, comps, null, null);
            // @TODO: use lexer to validate and normalize type
            return tuple;
        }
        type = $33b91ae696ec7843$var$verifyBasicType(obj.type);
        return new $33b91ae696ec7843$export$426dc07f493a4c47($33b91ae696ec7843$var$_guard, name || "", type, type, indexed, null, null, null);
    }
    /**
     *  Returns true if %%value%% is a **ParamType**.
     */ static isParamType(value) {
        return value && value[$33b91ae696ec7843$var$internal] === $33b91ae696ec7843$var$ParamTypeInternal;
    }
}
class $33b91ae696ec7843$export$ffb0004e005737fa {
    /**
     *  The type of the fragment.
     */ type;
    /**
     *  The inputs for the fragment.
     */ inputs;
    /**
     *  @private
     */ constructor(guard, type, inputs){
        (0, $def55b050f09c63c$export$ac1a938d48ec8c7b)(guard, $33b91ae696ec7843$var$_guard, "Fragment");
        inputs = Object.freeze(inputs.slice());
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            type: type,
            inputs: inputs
        });
    }
    /**
     *  Creates a new **Fragment** for %%obj%%, wich can be any supported
     *  ABI frgament type.
     */ static from(obj) {
        if (typeof obj === "string") {
            // Try parsing JSON...
            try {
                $33b91ae696ec7843$export$ffb0004e005737fa.from(JSON.parse(obj));
            } catch (e) {}
            // ...otherwise, use the human-readable lexer
            return $33b91ae696ec7843$export$ffb0004e005737fa.from($33b91ae696ec7843$var$lex(obj));
        }
        if (obj instanceof $33b91ae696ec7843$var$TokenString) {
            // Human-readable ABI (already lexed)
            const type = obj.peekKeyword($33b91ae696ec7843$var$KwTypes);
            switch(type){
                case "constructor":
                    return $33b91ae696ec7843$export$3ac5c9504f801ea4.from(obj);
                case "error":
                    return $33b91ae696ec7843$export$2c42c6d543aa9b59.from(obj);
                case "event":
                    return $33b91ae696ec7843$export$958548f08bac2833.from(obj);
                case "fallback":
                case "receive":
                    return $33b91ae696ec7843$export$71b1ea64c89c20fc.from(obj);
                case "function":
                    return $33b91ae696ec7843$export$8d576c928b93668f.from(obj);
                case "struct":
                    return $33b91ae696ec7843$export$9f91ba10bb234ec7.from(obj);
            }
        } else if (typeof obj === "object") {
            // JSON ABI
            switch(obj.type){
                case "constructor":
                    return $33b91ae696ec7843$export$3ac5c9504f801ea4.from(obj);
                case "error":
                    return $33b91ae696ec7843$export$2c42c6d543aa9b59.from(obj);
                case "event":
                    return $33b91ae696ec7843$export$958548f08bac2833.from(obj);
                case "fallback":
                case "receive":
                    return $33b91ae696ec7843$export$71b1ea64c89c20fc.from(obj);
                case "function":
                    return $33b91ae696ec7843$export$8d576c928b93668f.from(obj);
                case "struct":
                    return $33b91ae696ec7843$export$9f91ba10bb234ec7.from(obj);
            }
            (0, $def55b050f09c63c$export$a7a9523472993e97)(false, `unsupported type: ${obj.type}`, "UNSUPPORTED_OPERATION", {
                operation: "Fragment.from"
            });
        }
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "unsupported frgament object", "obj", obj);
    }
    /**
     *  Returns true if %%value%% is a [[ConstructorFragment]].
     */ static isConstructor(value) {
        return $33b91ae696ec7843$export$3ac5c9504f801ea4.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[ErrorFragment]].
     */ static isError(value) {
        return $33b91ae696ec7843$export$2c42c6d543aa9b59.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[EventFragment]].
     */ static isEvent(value) {
        return $33b91ae696ec7843$export$958548f08bac2833.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[FunctionFragment]].
     */ static isFunction(value) {
        return $33b91ae696ec7843$export$8d576c928b93668f.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[StructFragment]].
     */ static isStruct(value) {
        return $33b91ae696ec7843$export$9f91ba10bb234ec7.isFragment(value);
    }
}
class $33b91ae696ec7843$export$85c6fc53d6299173 extends $33b91ae696ec7843$export$ffb0004e005737fa {
    /**
     *  The name of the fragment.
     */ name;
    /**
     *  @private
     */ constructor(guard, type, name, inputs){
        super(guard, type, inputs);
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(typeof name === "string" && name.match($33b91ae696ec7843$var$regexId), "invalid identifier", "name", name);
        inputs = Object.freeze(inputs.slice());
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
}
function $33b91ae696ec7843$var$joinParams(format, params) {
    return "(" + params.map((p)=>p.format(format)).join(format === "full" ? ", " : ",") + ")";
}
class $33b91ae696ec7843$export$2c42c6d543aa9b59 extends $33b91ae696ec7843$export$85c6fc53d6299173 {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "error", name, inputs);
        Object.defineProperty(this, $33b91ae696ec7843$var$internal, {
            value: $33b91ae696ec7843$var$ErrorFragmentInternal
        });
    }
    /**
     *  The Custom Error selector.
     */ get selector() {
        return (0, $4af82668f5a6ec7b$export$d560c7e4a29451c2)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this fragment as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("error");
        result.push(this.name + $33b91ae696ec7843$var$joinParams(format, this.inputs));
        return result.join(" ");
    }
    /**
     *  Returns a new **ErrorFragment** for %%obj%%.
     */ static from(obj) {
        if ($33b91ae696ec7843$export$2c42c6d543aa9b59.isFragment(obj)) return obj;
        if (typeof obj === "string") return $33b91ae696ec7843$export$2c42c6d543aa9b59.from($33b91ae696ec7843$var$lex(obj));
        else if (obj instanceof $33b91ae696ec7843$var$TokenString) {
            const name = $33b91ae696ec7843$var$consumeName("error", obj);
            const inputs = $33b91ae696ec7843$var$consumeParams(obj);
            $33b91ae696ec7843$var$consumeEoi(obj);
            return new $33b91ae696ec7843$export$2c42c6d543aa9b59($33b91ae696ec7843$var$_guard, name, inputs);
        }
        return new $33b91ae696ec7843$export$2c42c6d543aa9b59($33b91ae696ec7843$var$_guard, obj.name, obj.inputs ? obj.inputs.map($33b91ae696ec7843$export$426dc07f493a4c47.from) : []);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **ErrorFragment**.
     */ static isFragment(value) {
        return value && value[$33b91ae696ec7843$var$internal] === $33b91ae696ec7843$var$ErrorFragmentInternal;
    }
}
class $33b91ae696ec7843$export$958548f08bac2833 extends $33b91ae696ec7843$export$85c6fc53d6299173 {
    /**
     *  Whether this event is anonymous.
     */ anonymous;
    /**
     *  @private
     */ constructor(guard, name, inputs, anonymous){
        super(guard, "event", name, inputs);
        Object.defineProperty(this, $33b91ae696ec7843$var$internal, {
            value: $33b91ae696ec7843$var$EventFragmentInternal
        });
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            anonymous: anonymous
        });
    }
    /**
     *  The Event topic hash.
     */ get topicHash() {
        return (0, $4af82668f5a6ec7b$export$d560c7e4a29451c2)(this.format("sighash"));
    }
    /**
     *  Returns a string representation of this event as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("event");
        result.push(this.name + $33b91ae696ec7843$var$joinParams(format, this.inputs));
        if (format !== "sighash" && this.anonymous) result.push("anonymous");
        return result.join(" ");
    }
    /**
     *  Return the topic hash for an event with %%name%% and %%params%%.
     */ static getTopicHash(name, params) {
        params = (params || []).map((p)=>$33b91ae696ec7843$export$426dc07f493a4c47.from(p));
        const fragment = new $33b91ae696ec7843$export$958548f08bac2833($33b91ae696ec7843$var$_guard, name, params, false);
        return fragment.topicHash;
    }
    /**
     *  Returns a new **EventFragment** for %%obj%%.
     */ static from(obj) {
        if ($33b91ae696ec7843$export$958548f08bac2833.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $33b91ae696ec7843$export$958548f08bac2833.from($33b91ae696ec7843$var$lex(obj));
        } catch (error) {
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "invalid event fragment", "obj", obj);
        }
        else if (obj instanceof $33b91ae696ec7843$var$TokenString) {
            const name = $33b91ae696ec7843$var$consumeName("event", obj);
            const inputs = $33b91ae696ec7843$var$consumeParams(obj, true);
            const anonymous = !!$33b91ae696ec7843$var$consumeKeywords(obj, $33b91ae696ec7843$var$setify([
                "anonymous"
            ])).has("anonymous");
            $33b91ae696ec7843$var$consumeEoi(obj);
            return new $33b91ae696ec7843$export$958548f08bac2833($33b91ae696ec7843$var$_guard, name, inputs, anonymous);
        }
        return new $33b91ae696ec7843$export$958548f08bac2833($33b91ae696ec7843$var$_guard, obj.name, obj.inputs ? obj.inputs.map((p)=>$33b91ae696ec7843$export$426dc07f493a4c47.from(p, true)) : [], !!obj.anonymous);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **EventFragment**.
     */ static isFragment(value) {
        return value && value[$33b91ae696ec7843$var$internal] === $33b91ae696ec7843$var$EventFragmentInternal;
    }
}
class $33b91ae696ec7843$export$3ac5c9504f801ea4 extends $33b91ae696ec7843$export$ffb0004e005737fa {
    /**
     *  Whether the constructor can receive an endowment.
     */ payable;
    /**
     *  The recommended gas limit for deployment or ``null``.
     */ gas;
    /**
     *  @private
     */ constructor(guard, type, inputs, payable, gas){
        super(guard, type, inputs);
        Object.defineProperty(this, $33b91ae696ec7843$var$internal, {
            value: $33b91ae696ec7843$var$ConstructorFragmentInternal
        });
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            payable: payable,
            gas: gas
        });
    }
    /**
     *  Returns a string representation of this constructor as %%format%%.
     */ format(format) {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(format != null && format !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", {
            operation: "format(sighash)"
        });
        if (format === "json") return JSON.stringify({
            type: "constructor",
            stateMutability: this.payable ? "payable" : "undefined",
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [
            `constructor${$33b91ae696ec7843$var$joinParams(format, this.inputs)}`
        ];
        if (this.payable) result.push("payable");
        if (this.gas != null) result.push(`@${this.gas.toString()}`);
        return result.join(" ");
    }
    /**
     *  Returns a new **ConstructorFragment** for %%obj%%.
     */ static from(obj) {
        if ($33b91ae696ec7843$export$3ac5c9504f801ea4.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $33b91ae696ec7843$export$3ac5c9504f801ea4.from($33b91ae696ec7843$var$lex(obj));
        } catch (error) {
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "invalid constuctor fragment", "obj", obj);
        }
        else if (obj instanceof $33b91ae696ec7843$var$TokenString) {
            $33b91ae696ec7843$var$consumeKeywords(obj, $33b91ae696ec7843$var$setify([
                "constructor"
            ]));
            const inputs = $33b91ae696ec7843$var$consumeParams(obj);
            const payable = !!$33b91ae696ec7843$var$consumeKeywords(obj, $33b91ae696ec7843$var$KwVisibDeploy).has("payable");
            const gas = $33b91ae696ec7843$var$consumeGas(obj);
            $33b91ae696ec7843$var$consumeEoi(obj);
            return new $33b91ae696ec7843$export$3ac5c9504f801ea4($33b91ae696ec7843$var$_guard, "constructor", inputs, payable, gas);
        }
        return new $33b91ae696ec7843$export$3ac5c9504f801ea4($33b91ae696ec7843$var$_guard, "constructor", obj.inputs ? obj.inputs.map($33b91ae696ec7843$export$426dc07f493a4c47.from) : [], !!obj.payable, obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **ConstructorFragment**.
     */ static isFragment(value) {
        return value && value[$33b91ae696ec7843$var$internal] === $33b91ae696ec7843$var$ConstructorFragmentInternal;
    }
}
class $33b91ae696ec7843$export$71b1ea64c89c20fc extends $33b91ae696ec7843$export$ffb0004e005737fa {
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    constructor(guard, inputs, payable){
        super(guard, "fallback", inputs);
        Object.defineProperty(this, $33b91ae696ec7843$var$internal, {
            value: $33b91ae696ec7843$var$FallbackFragmentInternal
        });
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            payable: payable
        });
    }
    /**
     *  Returns a string representation of this fallback as %%format%%.
     */ format(format) {
        const type = this.inputs.length === 0 ? "receive" : "fallback";
        if (format === "json") {
            const stateMutability = this.payable ? "payable" : "nonpayable";
            return JSON.stringify({
                type: type,
                stateMutability: stateMutability
            });
        }
        return `${type}()${this.payable ? " payable" : ""}`;
    }
    /**
     *  Returns a new **FallbackFragment** for %%obj%%.
     */ static from(obj) {
        if ($33b91ae696ec7843$export$71b1ea64c89c20fc.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $33b91ae696ec7843$export$71b1ea64c89c20fc.from($33b91ae696ec7843$var$lex(obj));
        } catch (error) {
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "invalid fallback fragment", "obj", obj);
        }
        else if (obj instanceof $33b91ae696ec7843$var$TokenString) {
            const errorObj = obj.toString();
            const topIsValid = obj.peekKeyword($33b91ae696ec7843$var$setify([
                "fallback",
                "receive"
            ]));
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(topIsValid, "type must be fallback or receive", "obj", errorObj);
            const type = obj.popKeyword($33b91ae696ec7843$var$setify([
                "fallback",
                "receive"
            ]));
            // receive()
            if (type === "receive") {
                const inputs = $33b91ae696ec7843$var$consumeParams(obj);
                (0, $def55b050f09c63c$export$c3d31707e5030f5e)(inputs.length === 0, `receive cannot have arguments`, "obj.inputs", inputs);
                $33b91ae696ec7843$var$consumeKeywords(obj, $33b91ae696ec7843$var$setify([
                    "payable"
                ]));
                $33b91ae696ec7843$var$consumeEoi(obj);
                return new $33b91ae696ec7843$export$71b1ea64c89c20fc($33b91ae696ec7843$var$_guard, [], true);
            }
            // fallback() [payable]
            // fallback(bytes) [payable] returns (bytes)
            let inputs = $33b91ae696ec7843$var$consumeParams(obj);
            if (inputs.length) (0, $def55b050f09c63c$export$c3d31707e5030f5e)(inputs.length === 1 && inputs[0].type === "bytes", "invalid fallback inputs", "obj.inputs", inputs.map((i)=>i.format("minimal")).join(", "));
            else inputs = [
                $33b91ae696ec7843$export$426dc07f493a4c47.from("bytes")
            ];
            const mutability = $33b91ae696ec7843$var$consumeMutability(obj);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(mutability === "nonpayable" || mutability === "payable", "fallback cannot be constants", "obj.stateMutability", mutability);
            if ($33b91ae696ec7843$var$consumeKeywords(obj, $33b91ae696ec7843$var$setify([
                "returns"
            ])).has("returns")) {
                const outputs = $33b91ae696ec7843$var$consumeParams(obj);
                (0, $def55b050f09c63c$export$c3d31707e5030f5e)(outputs.length === 1 && outputs[0].type === "bytes", "invalid fallback outputs", "obj.outputs", outputs.map((i)=>i.format("minimal")).join(", "));
            }
            $33b91ae696ec7843$var$consumeEoi(obj);
            return new $33b91ae696ec7843$export$71b1ea64c89c20fc($33b91ae696ec7843$var$_guard, inputs, mutability === "payable");
        }
        if (obj.type === "receive") return new $33b91ae696ec7843$export$71b1ea64c89c20fc($33b91ae696ec7843$var$_guard, [], true);
        if (obj.type === "fallback") {
            const inputs = [
                $33b91ae696ec7843$export$426dc07f493a4c47.from("bytes")
            ];
            const payable = obj.stateMutability === "payable";
            return new $33b91ae696ec7843$export$71b1ea64c89c20fc($33b91ae696ec7843$var$_guard, inputs, payable);
        }
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "invalid fallback description", "obj", obj);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FallbackFragment**.
     */ static isFragment(value) {
        return value && value[$33b91ae696ec7843$var$internal] === $33b91ae696ec7843$var$FallbackFragmentInternal;
    }
}
class $33b91ae696ec7843$export$8d576c928b93668f extends $33b91ae696ec7843$export$85c6fc53d6299173 {
    /**
     *  If the function is constant (e.g. ``pure`` or ``view`` functions).
     */ constant;
    /**
     *  The returned types for the result of calling this function.
     */ outputs;
    /**
     *  The state mutability (e.g. ``payable``, ``nonpayable``, ``view``
     *  or ``pure``)
     */ stateMutability;
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    /**
     *  The recommended gas limit to send when calling this function.
     */ gas;
    /**
     *  @private
     */ constructor(guard, name, stateMutability, inputs, outputs, gas){
        super(guard, "function", name, inputs);
        Object.defineProperty(this, $33b91ae696ec7843$var$internal, {
            value: $33b91ae696ec7843$var$FunctionFragmentInternal
        });
        outputs = Object.freeze(outputs.slice());
        const constant = stateMutability === "view" || stateMutability === "pure";
        const payable = stateMutability === "payable";
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            constant: constant,
            gas: gas,
            outputs: outputs,
            payable: payable,
            stateMutability: stateMutability
        });
    }
    /**
     *  The Function selector.
     */ get selector() {
        return (0, $4af82668f5a6ec7b$export$d560c7e4a29451c2)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this function as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format))),
            outputs: this.outputs.map((o)=>JSON.parse(o.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("function");
        result.push(this.name + $33b91ae696ec7843$var$joinParams(format, this.inputs));
        if (format !== "sighash") {
            if (this.stateMutability !== "nonpayable") result.push(this.stateMutability);
            if (this.outputs && this.outputs.length) {
                result.push("returns");
                result.push($33b91ae696ec7843$var$joinParams(format, this.outputs));
            }
            if (this.gas != null) result.push(`@${this.gas.toString()}`);
        }
        return result.join(" ");
    }
    /**
     *  Return the selector for a function with %%name%% and %%params%%.
     */ static getSelector(name, params) {
        params = (params || []).map((p)=>$33b91ae696ec7843$export$426dc07f493a4c47.from(p));
        const fragment = new $33b91ae696ec7843$export$8d576c928b93668f($33b91ae696ec7843$var$_guard, name, "view", params, [], null);
        return fragment.selector;
    }
    /**
     *  Returns a new **FunctionFragment** for %%obj%%.
     */ static from(obj) {
        if ($33b91ae696ec7843$export$8d576c928b93668f.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $33b91ae696ec7843$export$8d576c928b93668f.from($33b91ae696ec7843$var$lex(obj));
        } catch (error) {
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "invalid function fragment", "obj", obj);
        }
        else if (obj instanceof $33b91ae696ec7843$var$TokenString) {
            const name = $33b91ae696ec7843$var$consumeName("function", obj);
            const inputs = $33b91ae696ec7843$var$consumeParams(obj);
            const mutability = $33b91ae696ec7843$var$consumeMutability(obj);
            let outputs = [];
            if ($33b91ae696ec7843$var$consumeKeywords(obj, $33b91ae696ec7843$var$setify([
                "returns"
            ])).has("returns")) outputs = $33b91ae696ec7843$var$consumeParams(obj);
            const gas = $33b91ae696ec7843$var$consumeGas(obj);
            $33b91ae696ec7843$var$consumeEoi(obj);
            return new $33b91ae696ec7843$export$8d576c928b93668f($33b91ae696ec7843$var$_guard, name, mutability, inputs, outputs, gas);
        }
        let stateMutability = obj.stateMutability;
        // Use legacy Solidity ABI logic if stateMutability is missing
        if (stateMutability == null) {
            stateMutability = "payable";
            if (typeof obj.constant === "boolean") {
                stateMutability = "view";
                if (!obj.constant) {
                    stateMutability = "payable";
                    if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
                }
            } else if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
        }
        // @TODO: verifyState for stateMutability (e.g. throw if
        //        payable: false but stateMutability is "nonpayable")
        return new $33b91ae696ec7843$export$8d576c928b93668f($33b91ae696ec7843$var$_guard, obj.name, stateMutability, obj.inputs ? obj.inputs.map($33b91ae696ec7843$export$426dc07f493a4c47.from) : [], obj.outputs ? obj.outputs.map($33b91ae696ec7843$export$426dc07f493a4c47.from) : [], obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FunctionFragment**.
     */ static isFragment(value) {
        return value && value[$33b91ae696ec7843$var$internal] === $33b91ae696ec7843$var$FunctionFragmentInternal;
    }
}
class $33b91ae696ec7843$export$9f91ba10bb234ec7 extends $33b91ae696ec7843$export$85c6fc53d6299173 {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "struct", name, inputs);
        Object.defineProperty(this, $33b91ae696ec7843$var$internal, {
            value: $33b91ae696ec7843$var$StructFragmentInternal
        });
    }
    /**
     *  Returns a string representation of this struct as %%format%%.
     */ format() {
        throw new Error("@TODO");
    }
    /**
     *  Returns a new **StructFragment** for %%obj%%.
     */ static from(obj) {
        if (typeof obj === "string") try {
            return $33b91ae696ec7843$export$9f91ba10bb234ec7.from($33b91ae696ec7843$var$lex(obj));
        } catch (error) {
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "invalid struct fragment", "obj", obj);
        }
        else if (obj instanceof $33b91ae696ec7843$var$TokenString) {
            const name = $33b91ae696ec7843$var$consumeName("struct", obj);
            const inputs = $33b91ae696ec7843$var$consumeParams(obj);
            $33b91ae696ec7843$var$consumeEoi(obj);
            return new $33b91ae696ec7843$export$9f91ba10bb234ec7($33b91ae696ec7843$var$_guard, name, inputs);
        }
        return new $33b91ae696ec7843$export$9f91ba10bb234ec7($33b91ae696ec7843$var$_guard, obj.name, obj.inputs ? obj.inputs.map($33b91ae696ec7843$export$426dc07f493a4c47.from) : []);
    }
    // @TODO: fix this return type
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **StructFragment**.
     */ static isFragment(value) {
        return value && value[$33b91ae696ec7843$var$internal] === $33b91ae696ec7843$var$StructFragmentInternal;
    }
}



// https://docs.soliditylang.org/en/v0.8.17/control-structures.html
const $a3f016f760f1d6cc$var$PanicReasons = new Map();
$a3f016f760f1d6cc$var$PanicReasons.set(0x00, "GENERIC_PANIC");
$a3f016f760f1d6cc$var$PanicReasons.set(0x01, "ASSERT_FALSE");
$a3f016f760f1d6cc$var$PanicReasons.set(0x11, "OVERFLOW");
$a3f016f760f1d6cc$var$PanicReasons.set(0x12, "DIVIDE_BY_ZERO");
$a3f016f760f1d6cc$var$PanicReasons.set(0x21, "ENUM_RANGE_ERROR");
$a3f016f760f1d6cc$var$PanicReasons.set(0x22, "BAD_STORAGE_DATA");
$a3f016f760f1d6cc$var$PanicReasons.set(0x31, "STACK_UNDERFLOW");
$a3f016f760f1d6cc$var$PanicReasons.set(0x32, "ARRAY_RANGE_ERROR");
$a3f016f760f1d6cc$var$PanicReasons.set(0x41, "OUT_OF_MEMORY");
$a3f016f760f1d6cc$var$PanicReasons.set(0x51, "UNINITIALIZED_FUNCTION_CALL");
const $a3f016f760f1d6cc$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $a3f016f760f1d6cc$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
let $a3f016f760f1d6cc$var$defaultCoder = null;
let $a3f016f760f1d6cc$var$defaultMaxInflation = 1024;
function $a3f016f760f1d6cc$var$getBuiltinCallException(action, tx, data, abiCoder) {
    let message = "missing revert data";
    let reason = null;
    const invocation = null;
    let revert = null;
    if (data) {
        message = "execution reverted";
        const bytes = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(data);
        data = (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(data);
        if (bytes.length === 0) {
            message += " (no data present; likely require(false) occurred";
            reason = "require(false)";
        } else if (bytes.length % 32 !== 4) message += " (could not decode reason; invalid data length)";
        else if ((0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) === "0x08c379a0") // Error(string)
        try {
            reason = abiCoder.decode([
                "string"
            ], bytes.slice(4))[0];
            revert = {
                signature: "Error(string)",
                name: "Error",
                args: [
                    reason
                ]
            };
            message += `: ${JSON.stringify(reason)}`;
        } catch (error) {
            message += " (could not decode reason; invalid string data)";
        }
        else if ((0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) === "0x4e487b71") // Panic(uint256)
        try {
            const code = Number(abiCoder.decode([
                "uint256"
            ], bytes.slice(4))[0]);
            revert = {
                signature: "Panic(uint256)",
                name: "Panic",
                args: [
                    code
                ]
            };
            reason = `Panic due to ${$a3f016f760f1d6cc$var$PanicReasons.get(code) || "UNKNOWN"}(${code})`;
            message += `: ${reason}`;
        } catch (error) {
            message += " (could not decode panic code)";
        }
        else message += " (unknown custom error)";
    }
    const transaction = {
        to: tx.to ? (0, $61268443a2d16d36$export$88411125f012957a)(tx.to) : null,
        data: tx.data || "0x"
    };
    if (tx.from) transaction.from = (0, $61268443a2d16d36$export$88411125f012957a)(tx.from);
    return (0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)(message, "CALL_EXCEPTION", {
        action: action,
        data: data,
        reason: reason,
        transaction: transaction,
        invocation: invocation,
        revert: revert
    });
}
class $a3f016f760f1d6cc$export$fe041e1a83d3efc6 {
    #getCoder(param) {
        if (param.isArray()) return new (0, $78ce9144b7f86a2b$export$88bc419d2df11f54)(this.#getCoder(param.arrayChildren), param.arrayLength, param.name);
        if (param.isTuple()) return new (0, $a959b027e3547ef3$export$e9fceba8f110fea6)(param.components.map((c)=>this.#getCoder(c)), param.name);
        switch(param.baseType){
            case "address":
                return new (0, $61c0fcd6226ace25$export$59dbbded7775bfe7)(param.name);
            case "bool":
                return new (0, $348a6c77ccf75df7$export$fe9118d6c093150c)(param.name);
            case "string":
                return new (0, $abab1fc021aefd6b$export$2d1b854518731426)(param.name);
            case "bytes":
                return new (0, $002c032202f7ab15$export$e5823e9574df18d2)(param.name);
            case "":
                return new (0, $815745996e1c5a9d$export$70982cadf2d6b4ec)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($a3f016f760f1d6cc$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(size !== 0 && size <= 256 && size % 8 === 0, "invalid " + match[1] + " bit length", "param", param);
            return new (0, $046571f6e2601e59$export$b934dc8cfe13938c)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($a3f016f760f1d6cc$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(size !== 0 && size <= 32, "invalid bytes length", "param", param);
            return new (0, $1ead665379dbc49b$export$7dec9db68e6bcf5a)(size, param.name);
        }
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "invalid type", "type", param.type);
    }
    /**
     *  Get the default values for the given %%types%%.
     *
     *  For example, a ``uint`` is by default ``0`` and ``bool``
     *  is by default ``false``.
     */ getDefaultValue(types) {
        const coders = types.map((type)=>this.#getCoder((0, $33b91ae696ec7843$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $a959b027e3547ef3$export$e9fceba8f110fea6)(coders, "_");
        return coder.defaultValue();
    }
    /**
     *  Encode the %%values%% as the %%types%% into ABI data.
     *
     *  @returns DataHexstring
     */ encode(types, values) {
        (0, $def55b050f09c63c$export$d228410a8a77e4fa)(values.length, types.length, "types/values length mismatch");
        const coders = types.map((type)=>this.#getCoder((0, $33b91ae696ec7843$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $a959b027e3547ef3$export$e9fceba8f110fea6)(coders, "_");
        const writer = new (0, $7373ab4bcc395b24$export$d7a960146e1a269e)();
        coder.encode(writer, values);
        return writer.data;
    }
    /**
     *  Decode the ABI %%data%% as the %%types%% into values.
     *
     *  If %%loose%% decoding is enabled, then strict padding is
     *  not enforced. Some older versions of Solidity incorrectly
     *  padded event data emitted from ``external`` functions.
     */ decode(types, data, loose) {
        const coders = types.map((type)=>this.#getCoder((0, $33b91ae696ec7843$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $a959b027e3547ef3$export$e9fceba8f110fea6)(coders, "_");
        return coder.decode(new (0, $7373ab4bcc395b24$export$2f7a2f0e90c07dc4)(data, loose, $a3f016f760f1d6cc$var$defaultMaxInflation));
    }
    static _setDefaultMaxInflation(value) {
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(typeof value === "number" && Number.isInteger(value), "invalid defaultMaxInflation factor", "value", value);
        $a3f016f760f1d6cc$var$defaultMaxInflation = value;
    }
    /**
     *  Returns the shared singleton instance of a default [[AbiCoder]].
     *
     *  On the first call, the instance is created internally.
     */ static defaultAbiCoder() {
        if ($a3f016f760f1d6cc$var$defaultCoder == null) $a3f016f760f1d6cc$var$defaultCoder = new $a3f016f760f1d6cc$export$fe041e1a83d3efc6();
        return $a3f016f760f1d6cc$var$defaultCoder;
    }
    /**
     *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
     *  result %%data%% for the [[CallExceptionAction]] %%action%% against
     *  the Transaction %%tx%%.
     */ static getBuiltinCallException(action, tx, data) {
        return $a3f016f760f1d6cc$var$getBuiltinCallException(action, tx, data, $a3f016f760f1d6cc$export$fe041e1a83d3efc6.defaultAbiCoder());
    }
}




function $d6021cd5b8a26773$export$6a88e03bca5eb759(value) {
    return value && typeof value.getAddress === "function";
}
function $d6021cd5b8a26773$export$977e255126d763d6(value) {
    try {
        (0, $61268443a2d16d36$export$88411125f012957a)(value);
        return true;
    } catch (error) {}
    return false;
}
async function $d6021cd5b8a26773$var$checkAddress(target, promise) {
    const result = await promise;
    if (result == null || result === "0x0000000000000000000000000000000000000000") {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(typeof target !== "string", "unconfigured name", "UNCONFIGURED_NAME", {
            value: target
        });
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "invalid AddressLike value; did not resolve to a value address", "target", target);
    }
    return (0, $61268443a2d16d36$export$88411125f012957a)(result);
}
function $d6021cd5b8a26773$export$687eed6b344123c9(target, resolver) {
    if (typeof target === "string") {
        if (target.match(/^0x[0-9a-f]{40}$/i)) return (0, $61268443a2d16d36$export$88411125f012957a)(target);
        (0, $def55b050f09c63c$export$a7a9523472993e97)(resolver != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", {
            operation: "resolveName"
        });
        return $d6021cd5b8a26773$var$checkAddress(target, resolver.resolveName(target));
    } else if ($d6021cd5b8a26773$export$6a88e03bca5eb759(target)) return $d6021cd5b8a26773$var$checkAddress(target, target.getAddress());
    else if (target && typeof target.then === "function") return $d6021cd5b8a26773$var$checkAddress(target, target);
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "unsupported addressable value", "target", target);
}


//import { TypedDataDomain, TypedDataField } from "@ethersproject/providerabstract-signer";




function $38f7b118ce5fa9c9$export$e67e2732ba9803f9(key) {
    let pubkey;
    if (typeof key === "string") pubkey = (0, $2c64e14017a66a72$export$21643ca94aed3e83).computePublicKey(key, false);
    else pubkey = key.publicKey;
    return (0, $61268443a2d16d36$export$88411125f012957a)((0, $1c3ba5429a8a9032$export$f8151fce47ad1c35)("0x" + pubkey.substring(4)).substring(26));
}
function $38f7b118ce5fa9c9$export$23cc18f96d8510e2(digest, signature) {
    return $38f7b118ce5fa9c9$export$e67e2732ba9803f9((0, $2c64e14017a66a72$export$21643ca94aed3e83).recoverPublicKey(digest, signature));
}




const $838681bef518592f$var$padding = new Uint8Array(32);
$838681bef518592f$var$padding.fill(0);
const $838681bef518592f$var$BN__1 = BigInt(-1);
const $838681bef518592f$var$BN_0 = BigInt(0);
const $838681bef518592f$var$BN_1 = BigInt(1);
const $838681bef518592f$var$BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $838681bef518592f$var$hexPadRight(value) {
    const bytes = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)([
        bytes,
        $838681bef518592f$var$padding.slice(padOffset)
    ]);
    return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(bytes);
}
const $838681bef518592f$var$hexTrue = (0, $7df480338fc2bc47$export$c6ebe05badb16181)($838681bef518592f$var$BN_1, 32);
const $838681bef518592f$var$hexFalse = (0, $7df480338fc2bc47$export$c6ebe05badb16181)($838681bef518592f$var$BN_0, 32);
const $838681bef518592f$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $838681bef518592f$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $838681bef518592f$var$checkString(key) {
    return function(value) {
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(typeof value === "string", `invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $838681bef518592f$var$domainChecks = {
    name: $838681bef518592f$var$checkString("name"),
    version: $838681bef518592f$var$checkString("version"),
    chainId: function(_value) {
        const value = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(_value, "domain.chainId");
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(value >= 0, "invalid chain ID", "domain.chainId", _value);
        if (Number.isSafeInteger(value)) return Number(value);
        return (0, $7df480338fc2bc47$export$d9c067986dbc68dd)(value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $61268443a2d16d36$export$88411125f012957a)(value).toLowerCase();
        } catch (error) {}
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, `invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        const bytes = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(value, "domain.salt");
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(bytes.length === 32, `invalid domain value "salt"`, "domain.salt", value);
        return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(bytes);
    }
};
function $838681bef518592f$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d+)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2]);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(width % 8 === 0 && width !== 0 && width <= 256 && match[2] === String(width), "invalid numeric width", "type", type);
            const boundsUpper = (0, $7df480338fc2bc47$export$d99f0801a68bbcf1)($838681bef518592f$var$BN_MAX_UINT256, signed ? width - 1 : width);
            const boundsLower = signed ? (boundsUpper + $838681bef518592f$var$BN_1) * $838681bef518592f$var$BN__1 : $838681bef518592f$var$BN_0;
            return function(_value) {
                const value = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(_value, "value");
                (0, $def55b050f09c63c$export$c3d31707e5030f5e)(value >= boundsLower && value <= boundsUpper, `value out-of-bounds for ${type}`, "value", value);
                return (0, $7df480338fc2bc47$export$c6ebe05badb16181)(signed ? (0, $7df480338fc2bc47$export$7101cd4e6275351c)(value, 256) : value, 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(width !== 0 && width <= 32 && match[1] === String(width), "invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(value);
                (0, $def55b050f09c63c$export$c3d31707e5030f5e)(bytes.length === width, `invalid length for ${type}`, "value", value);
                return $838681bef518592f$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $8de17c58ebd53b07$export$4473860254365feb)((0, $61268443a2d16d36$export$88411125f012957a)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $838681bef518592f$var$hexFalse : $838681bef518592f$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $1c3ba5429a8a9032$export$f8151fce47ad1c35)(value);
            };
        case "string":
            return function(value) {
                return (0, $4af82668f5a6ec7b$export$d560c7e4a29451c2)(value);
            };
    }
    return null;
}
function $838681bef518592f$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
// foo[][3] => { base: "foo", index: "[][3]", array: {
//     base: "foo", prefix: "foo[]", count: 3 } }
function $838681bef518592f$var$splitArray(type) {
    const match = type.match(/^([^\x5b]*)((\x5b\d*\x5d)*)(\x5b(\d*)\x5d)$/);
    if (match) return {
        base: match[1],
        index: match[2] + match[4],
        array: {
            base: match[1],
            prefix: match[1] + match[2],
            count: match[5] ? parseInt(match[5]) : -1
        }
    };
    return {
        base: type
    };
}
class $838681bef518592f$export$458ab927ae635c3 {
    /**
     *  The primary type for the structured [[types]].
     *
     *  This is derived automatically from the [[types]], since no
     *  recursion is possible, once the DAG for the types is consturcted
     *  internally, the primary type must be the only remaining type with
     *  no parent nodes.
     */ primaryType;
    #types;
    /**
     *  The types.
     */ get types() {
        return JSON.parse(this.#types);
    }
    #fullTypes;
    #encoderCache;
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     *
     *  This performs all necessary checking that types are valid and
     *  do not violate the [[link-eip-712]] structural constraints as
     *  well as computes the [[primaryType]].
     */ constructor(_types){
        this.#fullTypes = new Map();
        this.#encoderCache = new Map();
        // Link struct types to their direct child structs
        const links = new Map();
        // Link structs to structs which contain them as a child
        const parents = new Map();
        // Link all subtypes within a given struct
        const subtypes = new Map();
        const types = {};
        Object.keys(_types).forEach((type)=>{
            types[type] = _types[type].map(({ name: name, type: type })=>{
                // Normalize the base type (unless name conflict)
                let { base: base, index: index } = $838681bef518592f$var$splitArray(type);
                if (base === "int" && !_types["int"]) base = "int256";
                if (base === "uint" && !_types["uint"]) base = "uint256";
                return {
                    name: name,
                    type: base + (index || "")
                };
            });
            links.set(type, new Set());
            parents.set(type, []);
            subtypes.set(type, new Set());
        });
        this.#types = JSON.stringify(types);
        for(const name in types){
            const uniqueNames = new Set();
            for (const field of types[name]){
                // Check each field has a unique name
                (0, $def55b050f09c63c$export$c3d31707e5030f5e)(!uniqueNames.has(field.name), `duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", _types);
                uniqueNames.add(field.name);
                // Get the base type (drop any array specifiers)
                const baseType = $838681bef518592f$var$splitArray(field.type).base;
                (0, $def55b050f09c63c$export$c3d31707e5030f5e)(baseType !== name, `circular type reference to ${JSON.stringify(baseType)}`, "types", _types);
                // Is this a base encoding type?
                const encoder = $838681bef518592f$var$getBaseEncoder(baseType);
                if (encoder) continue;
                (0, $def55b050f09c63c$export$c3d31707e5030f5e)(parents.has(baseType), `unknown type ${JSON.stringify(baseType)}`, "types", _types);
                // Add linkage
                parents.get(baseType).push(name);
                links.get(name).add(baseType);
            }
        }
        // Deduce the primary type
        const primaryTypes = Array.from(parents.keys()).filter((n)=>parents.get(n).length === 0);
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(primaryTypes.length !== 0, "missing primary type", "types", _types);
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(primaryTypes.length === 1, `ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", _types);
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            primaryType: primaryTypes[0]
        });
        // Check for circular type references
        function checkCircular(type, found) {
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(!found.has(type), `circular type reference to ${JSON.stringify(type)}`, "types", _types);
            found.add(type);
            for (const child of links.get(type)){
                if (!parents.has(child)) continue;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                for (const subtype of found)subtypes.get(subtype).add(child);
            }
            found.delete(type);
        }
        checkCircular(this.primaryType, new Set());
        // Compute each fully describe type
        for (const [name, set] of subtypes){
            const st = Array.from(set);
            st.sort();
            this.#fullTypes.set(name, $838681bef518592f$var$encodeType(name, types[name]) + st.map((t)=>$838681bef518592f$var$encodeType(t, types[t])).join(""));
        }
    }
    /**
     *  Returnthe encoder for the specific %%type%%.
     */ getEncoder(type) {
        let encoder = this.#encoderCache.get(type);
        if (!encoder) {
            encoder = this.#getEncoder(type);
            this.#encoderCache.set(type, encoder);
        }
        return encoder;
    }
    #getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $838681bef518592f$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const array = $838681bef518592f$var$splitArray(type).array;
        if (array) {
            const subtype = array.prefix;
            const subEncoder = this.getEncoder(subtype);
            return (value)=>{
                (0, $def55b050f09c63c$export$c3d31707e5030f5e)(array.count === -1 || array.count === value.length, `array length mismatch; expected length ${array.count}`, "value", value);
                let result = value.map(subEncoder);
                if (this.#fullTypes.has(subtype)) result = result.map((0, $1c3ba5429a8a9032$export$f8151fce47ad1c35));
                return (0, $1c3ba5429a8a9032$export$f8151fce47ad1c35)((0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $4af82668f5a6ec7b$export$d560c7e4a29451c2)(this.#fullTypes.get(type));
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this.#fullTypes.has(type)) return (0, $1c3ba5429a8a9032$export$f8151fce47ad1c35)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)(values);
            };
        }
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, `unknown type: ${type}`, "type", type);
    }
    /**
     *  Return the full type for %%name%%.
     */ encodeType(name) {
        const result = this.#fullTypes.get(name);
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(result, `unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    /**
     *  Return the encoded %%value%% for the %%type%%.
     */ encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    /**
     *  Returns the hash of %%value%% for the type of %%name%%.
     */ hashStruct(name, value) {
        return (0, $1c3ba5429a8a9032$export$f8151fce47ad1c35)(this.encodeData(name, value));
    }
    /**
     *  Return the fulled encoded %%value%% for the [[types]].
     */ encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    /**
     *  Return the hash of the fully encoded %%value%% for the [[types]].
     */ hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    /**
     *  @_ignore:
     */ _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $838681bef518592f$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const array = $838681bef518592f$var$splitArray(type).array;
        if (array) {
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(array.count === -1 || array.count === value.length, `array length mismatch; expected length ${array.count}`, "value", value);
            return value.map((v)=>this._visit(array.prefix, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, `unknown type: ${type}`, "type", type);
    }
    /**
     *  Call %%calback%% for each value in %%value%%, passing the type and
     *  component within %%value%%.
     *
     *  This is useful for replacing addresses or other transformation that
     *  may be desired on each component, based on its type.
     */ visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     */ static from(types) {
        return new $838681bef518592f$export$458ab927ae635c3(types);
    }
    /**
     *  Return the primary type for %%types%%.
     */ static getPrimaryType(types) {
        return $838681bef518592f$export$458ab927ae635c3.from(types).primaryType;
    }
    /**
     *  Return the hashed struct for %%value%% using %%types%% and %%name%%.
     */ static hashStruct(name, types, value) {
        return $838681bef518592f$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    /**
     *  Return the domain hash for %%domain%%.
     */ static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            if (domain[name] == null) continue;
            const type = $838681bef518592f$var$domainFieldTypes[name];
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(type, `invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $838681bef518592f$var$domainFieldNames.indexOf(a.name) - $838681bef518592f$var$domainFieldNames.indexOf(b.name);
        });
        return $838681bef518592f$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    /**
     *  Return the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */ static encode(domain, types, value) {
        return (0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)([
            "0x1901",
            $838681bef518592f$export$458ab927ae635c3.hashDomain(domain),
            $838681bef518592f$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    /**
     *  Return the hash of the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */ static hash(domain, types, value) {
        return (0, $1c3ba5429a8a9032$export$f8151fce47ad1c35)($838681bef518592f$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    /**
     * Resolves to the value from resolving all addresses in %%value%% for
     * %%types%% and the %%domain%%.
     */ static async resolveNames(domain, types, value, resolveName) {
        // Make a copy to isolate it from the object passed in
        domain = Object.assign({}, domain);
        // Allow passing null to ignore value
        for(const key in domain)if (domain[key] == null) delete domain[key];
        // Look up all ENS names
        const ensCache = {};
        // Do we need to look up the domain's verifyingContract?
        if (domain.verifyingContract && !(0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
        // We are going to use the encoder to visit all the base values
        const encoder = $838681bef518592f$export$458ab927ae635c3.from(types);
        // Get a list of all the addresses
        encoder.visit(value, (type, value)=>{
            if (type === "address" && !(0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(value, 20)) ensCache[value] = "0x";
            return value;
        });
        // Lookup each name
        for(const name in ensCache)ensCache[name] = await resolveName(name);
        // Replace the domain verifyingContract if needed
        if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
        // Replace all ENS names with their address
        value = encoder.visit(value, (type, value)=>{
            if (type === "address" && ensCache[value]) return ensCache[value];
            return value;
        });
        return {
            domain: domain,
            value: value
        };
    }
    /**
     *  Returns the JSON-encoded payload expected by nodes which implement
     *  the JSON-RPC [[link-eip-712]] method.
     */ static getPayload(domain, types, value) {
        // Validate the domain fields
        $838681bef518592f$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $838681bef518592f$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $838681bef518592f$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $838681bef518592f$var$domainFieldTypes[name]
            });
        });
        const encoder = $838681bef518592f$export$458ab927ae635c3.from(types);
        // Get the normalized types
        types = encoder.types;
        const typesWithDomain = Object.assign({}, types);
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(typesWithDomain.EIP712Domain == null, "types must not contain EIP712Domain type", "types.EIP712Domain", types);
        typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)((0, $8de17c58ebd53b07$export$a3521add2594f3c8)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(typeof value === "string", "invalid string", "value", value);
                        return value;
                }
                (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "unsupported type", "type", type);
            })
        };
    }
}
function $838681bef518592f$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $38f7b118ce5fa9c9$export$23cc18f96d8510e2)($838681bef518592f$export$458ab927ae635c3.hash(domain, types, value), signature);
}




function $63484022a9ae8dfc$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $61268443a2d16d36$export$88411125f012957a)(addr),
        storageKeys: storageKeys.map((storageKey, index)=>{
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(storageKey, 32), "invalid slot", `storageKeys[${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $63484022a9ae8dfc$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(set.length === 2, "invalid slot set", `value[${index}]`, set);
            return $63484022a9ae8dfc$var$accessSetify(set[0], set[1]);
        }
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(set != null && typeof set === "object", "invalid address-slot set", "value", value);
        return $63484022a9ae8dfc$var$accessSetify(set.address, set.storageKeys);
    });
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(value != null && typeof value === "object", "invalid access list", "value", value);
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $63484022a9ae8dfc$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}




function $50e5ec83adfbb986$export$792a4c467f6fbc9f(auth) {
    return {
        address: (0, $61268443a2d16d36$export$88411125f012957a)(auth.address),
        nonce: (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(auth.nonce != null ? auth.nonce : 0),
        chainId: (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(auth.chainId != null ? auth.chainId : 0),
        signature: (0, $37038a1f415943f5$export$848620f5f2f26e86).from(auth.signature)
    };
}


/**
 *  Fetching content from the web is environment-specific, so Ethers
 *  provides an abstraction that each environment can implement to provide
 *  this service.
 *
 *  On [Node.js](link-node), the ``http`` and ``https`` libs are used to
 *  create a request object, register event listeners and process data
 *  and populate the [[FetchResponse]].
 *
 *  In a browser, the [DOM fetch](link-js-fetch) is used, and the resulting
 *  ``Promise`` is waited on to retrieve the payload.
 *
 *  The [[FetchRequest]] is responsible for handling many common situations,
 *  such as redirects, server throttling, authentication, etc.
 *
 *  It also handles common gateways, such as IPFS and data URIs.
 *
 *  @_section api/utils/fetching:Fetching Web Content  [about-fetch]
 */ // utils/base64-browser

function $a5d665d73c4bb2be$export$94fdf11bafc8de6b(textData) {
    textData = atob(textData);
    const data = new Uint8Array(textData.length);
    for(let i = 0; i < textData.length; i++)data[i] = textData.charCodeAt(i);
    return (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(data);
}
function $a5d665d73c4bb2be$export$8fb536984ec8b4d7(_data) {
    const data = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(_data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}







function $be1c1b348b4c33cc$export$d3950daf7bce5bf5(options) {
    async function getUrl(req, _signal) {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(_signal == null || !_signal.cancelled, "request cancelled before sending", "CANCELLED");
        const protocol = req.url.split(":")[0].toLowerCase();
        (0, $def55b050f09c63c$export$a7a9523472993e97)(protocol === "http" || protocol === "https", `unsupported protocol ${protocol}`, "UNSUPPORTED_OPERATION", {
            info: {
                protocol: protocol
            },
            operation: "request"
        });
        (0, $def55b050f09c63c$export$a7a9523472993e97)(protocol === "https" || !req.credentials || req.allowInsecureAuthentication, "insecure authorized connections unsupported", "UNSUPPORTED_OPERATION", {
            operation: "request"
        });
        let error = null;
        const controller = new AbortController();
        const timer = setTimeout(()=>{
            error = (0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("request timeout", "TIMEOUT");
            controller.abort();
        }, req.timeout);
        if (_signal) _signal.addListener(()=>{
            error = (0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("request cancelled", "CANCELLED");
            controller.abort();
        });
        const init = Object.assign({}, options, {
            method: req.method,
            headers: new Headers(Array.from(req)),
            body: req.body || undefined,
            signal: controller.signal
        });
        let resp;
        try {
            resp = await fetch(req.url, init);
        } catch (_error) {
            clearTimeout(timer);
            if (error) throw error;
            throw _error;
        }
        clearTimeout(timer);
        const headers = {};
        resp.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        const respBody = await resp.arrayBuffer();
        const body = respBody == null ? null : new Uint8Array(respBody);
        return {
            statusCode: resp.status,
            statusMessage: resp.statusText,
            headers: headers,
            body: body
        };
    }
    return getUrl;
}
// @TODO: remove in v7; provided for backwards compat
const $be1c1b348b4c33cc$var$defaultGetUrl = $be1c1b348b4c33cc$export$d3950daf7bce5bf5({});
async function $be1c1b348b4c33cc$export$94df0e59ebebf4a7(req, _signal) {
    return $be1c1b348b4c33cc$var$defaultGetUrl(req, _signal);
}


const $639ac0facbde31d2$var$MAX_ATTEMPTS = 12;
const $639ac0facbde31d2$var$SLOT_INTERVAL = 250;
// The global FetchGetUrlFunc implementation.
let $639ac0facbde31d2$var$defaultGetUrlFunc = (0, $be1c1b348b4c33cc$export$d3950daf7bce5bf5)();
const $639ac0facbde31d2$var$reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
const $639ac0facbde31d2$var$reIpfs = new RegExp("^ipfs://(ipfs/)?(.*)$", "i");
// If locked, new Gateways cannot be added
let $639ac0facbde31d2$var$locked = false;
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URLs
async function $639ac0facbde31d2$var$dataGatewayFunc(url, signal) {
    try {
        const match = url.match($639ac0facbde31d2$var$reData);
        if (!match) throw new Error("invalid data");
        return new $639ac0facbde31d2$export$3ae09bba5b6b906e(200, "OK", {
            "content-type": match[1] || "text/plain"
        }, match[2] ? (0, $a5d665d73c4bb2be$export$94fdf11bafc8de6b)(match[3]) : $639ac0facbde31d2$var$unpercent(match[3]));
    } catch (error) {
        return new $639ac0facbde31d2$export$3ae09bba5b6b906e(599, "BAD REQUEST (invalid data: URI)", {}, null, new $639ac0facbde31d2$export$319b96fe59834522(url));
    }
}
/**
 *  Returns a [[FetchGatewayFunc]] for fetching content from a standard
 *  IPFS gateway hosted at %%baseUrl%%.
 */ function $639ac0facbde31d2$var$getIpfsGatewayFunc(baseUrl) {
    async function gatewayIpfs(url, signal) {
        try {
            const match = url.match($639ac0facbde31d2$var$reIpfs);
            if (!match) throw new Error("invalid link");
            return new $639ac0facbde31d2$export$319b96fe59834522(`${baseUrl}${match[2]}`);
        } catch (error) {
            return new $639ac0facbde31d2$export$3ae09bba5b6b906e(599, "BAD REQUEST (invalid IPFS URI)", {}, null, new $639ac0facbde31d2$export$319b96fe59834522(url));
        }
    }
    return gatewayIpfs;
}
const $639ac0facbde31d2$var$Gateways = {
    "data": $639ac0facbde31d2$var$dataGatewayFunc,
    "ipfs": $639ac0facbde31d2$var$getIpfsGatewayFunc("https://gateway.ipfs.io/ipfs/")
};
const $639ac0facbde31d2$var$fetchSignals = new WeakMap();
class $639ac0facbde31d2$export$ef5e7a6febaa4c8b {
    #listeners;
    #cancelled;
    constructor(request){
        this.#listeners = [];
        this.#cancelled = false;
        $639ac0facbde31d2$var$fetchSignals.set(request, ()=>{
            if (this.#cancelled) return;
            this.#cancelled = true;
            for (const listener of this.#listeners)setTimeout(()=>{
                listener();
            }, 0);
            this.#listeners = [];
        });
    }
    addListener(listener) {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(!this.#cancelled, "singal already cancelled", "UNSUPPORTED_OPERATION", {
            operation: "fetchCancelSignal.addCancelListener"
        });
        this.#listeners.push(listener);
    }
    get cancelled() {
        return this.#cancelled;
    }
    checkSignal() {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(!this.cancelled, "cancelled", "CANCELLED", {});
    }
}
// Check the signal, throwing if it is cancelled
function $639ac0facbde31d2$var$checkSignal(signal) {
    if (signal == null) throw new Error("missing signal; should not happen");
    signal.checkSignal();
    return signal;
}
class $639ac0facbde31d2$export$319b96fe59834522 {
    #allowInsecure;
    #gzip;
    #headers;
    #method;
    #timeout;
    #url;
    #body;
    #bodyType;
    #creds;
    // Hooks
    #preflight;
    #process;
    #retry;
    #signal;
    #throttle;
    #getUrlFunc;
    /**
     *  The fetch URL to request.
     */ get url() {
        return this.#url;
    }
    set url(url) {
        this.#url = String(url);
    }
    /**
     *  The fetch body, if any, to send as the request body. //(default: null)//
     *
     *  When setting a body, the intrinsic ``Content-Type`` is automatically
     *  set and will be used if **not overridden** by setting a custom
     *  header.
     *
     *  If %%body%% is null, the body is cleared (along with the
     *  intrinsic ``Content-Type``).
     *
     *  If %%body%% is a string, the intrinsic ``Content-Type`` is set to
     *  ``text/plain``.
     *
     *  If %%body%% is a Uint8Array, the intrinsic ``Content-Type`` is set to
     *  ``application/octet-stream``.
     *
     *  If %%body%% is any other object, the intrinsic ``Content-Type`` is
     *  set to ``application/json``.
     */ get body() {
        if (this.#body == null) return null;
        return new Uint8Array(this.#body);
    }
    set body(body) {
        if (body == null) {
            this.#body = undefined;
            this.#bodyType = undefined;
        } else if (typeof body === "string") {
            this.#body = (0, $cdede1645bd34985$export$8feeb310b4b4752f)(body);
            this.#bodyType = "text/plain";
        } else if (body instanceof Uint8Array) {
            this.#body = body;
            this.#bodyType = "application/octet-stream";
        } else if (typeof body === "object") {
            this.#body = (0, $cdede1645bd34985$export$8feeb310b4b4752f)(JSON.stringify(body));
            this.#bodyType = "application/json";
        } else throw new Error("invalid body");
    }
    /**
     *  Returns true if the request has a body.
     */ hasBody() {
        return this.#body != null;
    }
    /**
     *  The HTTP method to use when requesting the URI. If no method
     *  has been explicitly set, then ``GET`` is used if the body is
     *  null and ``POST`` otherwise.
     */ get method() {
        if (this.#method) return this.#method;
        if (this.hasBody()) return "POST";
        return "GET";
    }
    set method(method) {
        if (method == null) method = "";
        this.#method = String(method).toUpperCase();
    }
    /**
     *  The headers that will be used when requesting the URI. All
     *  keys are lower-case.
     *
     *  This object is a copy, so any changes will **NOT** be reflected
     *  in the ``FetchRequest``.
     *
     *  To set a header entry, use the ``setHeader`` method.
     */ get headers() {
        const headers = Object.assign({}, this.#headers);
        if (this.#creds) headers["authorization"] = `Basic ${(0, $a5d665d73c4bb2be$export$8fb536984ec8b4d7)((0, $cdede1645bd34985$export$8feeb310b4b4752f)(this.#creds))}`;
        if (this.allowGzip) headers["accept-encoding"] = "gzip";
        if (headers["content-type"] == null && this.#bodyType) headers["content-type"] = this.#bodyType;
        if (this.body) headers["content-length"] = String(this.body.length);
        return headers;
    }
    /**
     *  Get the header for %%key%%, ignoring case.
     */ getHeader(key) {
        return this.headers[key.toLowerCase()];
    }
    /**
     *  Set the header for %%key%% to %%value%%. All values are coerced
     *  to a string.
     */ setHeader(key, value) {
        this.#headers[String(key).toLowerCase()] = String(value);
    }
    /**
     *  Clear all headers, resetting all intrinsic headers.
     */ clearHeaders() {
        this.#headers = {};
    }
    [Symbol.iterator]() {
        const headers = this.headers;
        const keys = Object.keys(headers);
        let index = 0;
        return {
            next: ()=>{
                if (index < keys.length) {
                    const key = keys[index++];
                    return {
                        value: [
                            key,
                            headers[key]
                        ],
                        done: false
                    };
                }
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The value that will be sent for the ``Authorization`` header.
     *
     *  To set the credentials, use the ``setCredentials`` method.
     */ get credentials() {
        return this.#creds || null;
    }
    /**
     *  Sets an ``Authorization`` for %%username%% with %%password%%.
     */ setCredentials(username, password) {
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(!username.match(/:/), "invalid basic authentication username", "username", "[REDACTED]");
        this.#creds = `${username}:${password}`;
    }
    /**
     *  Enable and request gzip-encoded responses. The response will
     *  automatically be decompressed. //(default: true)//
     */ get allowGzip() {
        return this.#gzip;
    }
    set allowGzip(value) {
        this.#gzip = !!value;
    }
    /**
     *  Allow ``Authentication`` credentials to be sent over insecure
     *  channels. //(default: false)//
     */ get allowInsecureAuthentication() {
        return !!this.#allowInsecure;
    }
    set allowInsecureAuthentication(value) {
        this.#allowInsecure = !!value;
    }
    /**
     *  The timeout (in milliseconds) to wait for a complete response.
     *  //(default: 5 minutes)//
     */ get timeout() {
        return this.#timeout;
    }
    set timeout(timeout) {
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(timeout >= 0, "timeout must be non-zero", "timeout", timeout);
        this.#timeout = timeout;
    }
    /**
     *  This function is called prior to each request, for example
     *  during a redirection or retry in case of server throttling.
     *
     *  This offers an opportunity to populate headers or update
     *  content before sending a request.
     */ get preflightFunc() {
        return this.#preflight || null;
    }
    set preflightFunc(preflight) {
        this.#preflight = preflight;
    }
    /**
     *  This function is called after each response, offering an
     *  opportunity to provide client-level throttling or updating
     *  response data.
     *
     *  Any error thrown in this causes the ``send()`` to throw.
     *
     *  To schedule a retry attempt (assuming the maximum retry limit
     *  has not been reached), use [[response.throwThrottleError]].
     */ get processFunc() {
        return this.#process || null;
    }
    set processFunc(process) {
        this.#process = process;
    }
    /**
     *  This function is called on each retry attempt.
     */ get retryFunc() {
        return this.#retry || null;
    }
    set retryFunc(retry) {
        this.#retry = retry;
    }
    /**
     *  This function is called to fetch content from HTTP and
     *  HTTPS URLs and is platform specific (e.g. nodejs vs
     *  browsers).
     *
     *  This is by default the currently registered global getUrl
     *  function, which can be changed using [[registerGetUrl]].
     *  If this has been set, setting is to ``null`` will cause
     *  this FetchRequest (and any future clones) to revert back to
     *  using the currently registered global getUrl function.
     *
     *  Setting this is generally not necessary, but may be useful
     *  for developers that wish to intercept requests or to
     *  configurege a proxy or other agent.
     */ get getUrlFunc() {
        return this.#getUrlFunc || $639ac0facbde31d2$var$defaultGetUrlFunc;
    }
    set getUrlFunc(value) {
        this.#getUrlFunc = value;
    }
    /**
     *  Create a new FetchRequest instance with default values.
     *
     *  Once created, each property may be set before issuing a
     *  ``.send()`` to make the request.
     */ constructor(url){
        this.#url = String(url);
        this.#allowInsecure = false;
        this.#gzip = true;
        this.#headers = {};
        this.#method = "";
        this.#timeout = 300000;
        this.#throttle = {
            slotInterval: $639ac0facbde31d2$var$SLOT_INTERVAL,
            maxAttempts: $639ac0facbde31d2$var$MAX_ATTEMPTS
        };
        this.#getUrlFunc = null;
    }
    toString() {
        return `<FetchRequest method=${JSON.stringify(this.method)} url=${JSON.stringify(this.url)} headers=${JSON.stringify(this.headers)} body=${this.#body ? (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(this.#body) : "null"}>`;
    }
    /**
     *  Update the throttle parameters used to determine maximum
     *  attempts and exponential-backoff properties.
     */ setThrottleParams(params) {
        if (params.slotInterval != null) this.#throttle.slotInterval = params.slotInterval;
        if (params.maxAttempts != null) this.#throttle.maxAttempts = params.maxAttempts;
    }
    async #send(attempt, expires, delay, _request, _response) {
        if (attempt >= this.#throttle.maxAttempts) return _response.makeServerError("exceeded maximum retry limit");
        (0, $def55b050f09c63c$export$a7a9523472993e97)($639ac0facbde31d2$var$getTime() <= expires, "timeout", "TIMEOUT", {
            operation: "request.send",
            reason: "timeout",
            request: _request
        });
        if (delay > 0) await $639ac0facbde31d2$var$wait(delay);
        let req = this.clone();
        const scheme = (req.url.split(":")[0] || "").toLowerCase();
        // Process any Gateways
        if (scheme in $639ac0facbde31d2$var$Gateways) {
            const result = await $639ac0facbde31d2$var$Gateways[scheme](req.url, $639ac0facbde31d2$var$checkSignal(_request.#signal));
            if (result instanceof $639ac0facbde31d2$export$3ae09bba5b6b906e) {
                let response = result;
                if (this.processFunc) {
                    $639ac0facbde31d2$var$checkSignal(_request.#signal);
                    try {
                        response = await this.processFunc(req, response);
                    } catch (error) {
                        // Something went wrong during processing; throw a 5xx server error
                        if (error.throttle == null || typeof error.stall !== "number") response.makeServerError("error in post-processing function", error).assertOk();
                    // Ignore throttling
                    }
                }
                return response;
            }
            req = result;
        }
        // We have a preflight function; update the request
        if (this.preflightFunc) req = await this.preflightFunc(req);
        const resp = await this.getUrlFunc(req, $639ac0facbde31d2$var$checkSignal(_request.#signal));
        let response = new $639ac0facbde31d2$export$3ae09bba5b6b906e(resp.statusCode, resp.statusMessage, resp.headers, resp.body, _request);
        if (response.statusCode === 301 || response.statusCode === 302) {
            // Redirect
            try {
                const location = response.headers.location || "";
                return req.redirect(location).#send(attempt + 1, expires, 0, _request, response);
            } catch (error) {}
            // Things won't get any better on another attempt; abort
            return response;
        } else if (response.statusCode === 429) // Throttle
        {
            if (this.retryFunc == null || await this.retryFunc(req, response, attempt)) {
                const retryAfter = response.headers["retry-after"];
                let delay = this.#throttle.slotInterval * Math.trunc(Math.random() * Math.pow(2, attempt));
                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) delay = parseInt(retryAfter);
                return req.clone().#send(attempt + 1, expires, delay, _request, response);
            }
        }
        if (this.processFunc) {
            $639ac0facbde31d2$var$checkSignal(_request.#signal);
            try {
                response = await this.processFunc(req, response);
            } catch (error) {
                // Something went wrong during processing; throw a 5xx server error
                if (error.throttle == null || typeof error.stall !== "number") response.makeServerError("error in post-processing function", error).assertOk();
                // Throttle
                let delay = this.#throttle.slotInterval * Math.trunc(Math.random() * Math.pow(2, attempt));
                if (error.stall >= 0) delay = error.stall;
                return req.clone().#send(attempt + 1, expires, delay, _request, response);
            }
        }
        return response;
    }
    /**
     *  Resolves to the response by sending the request.
     */ send() {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(this.#signal == null, "request already sent", "UNSUPPORTED_OPERATION", {
            operation: "fetchRequest.send"
        });
        this.#signal = new $639ac0facbde31d2$export$ef5e7a6febaa4c8b(this);
        return this.#send(0, $639ac0facbde31d2$var$getTime() + this.timeout, 0, this, new $639ac0facbde31d2$export$3ae09bba5b6b906e(0, "", {}, null, this));
    }
    /**
     *  Cancels the inflight response, causing a ``CANCELLED``
     *  error to be rejected from the [[send]].
     */ cancel() {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(this.#signal != null, "request has not been sent", "UNSUPPORTED_OPERATION", {
            operation: "fetchRequest.cancel"
        });
        const signal = $639ac0facbde31d2$var$fetchSignals.get(this);
        if (!signal) throw new Error("missing signal; should not happen");
        signal();
    }
    /**
     *  Returns a new [[FetchRequest]] that represents the redirection
     *  to %%location%%.
     */ redirect(location) {
        // Redirection; for now we only support absolute locations
        const current = this.url.split(":")[0].toLowerCase();
        const target = location.split(":")[0].toLowerCase();
        // Don't allow redirecting:
        // - non-GET requests
        // - downgrading the security (e.g. https => http)
        // - to non-HTTP (or non-HTTPS) protocols [this could be relaxed?]
        (0, $def55b050f09c63c$export$a7a9523472993e97)(this.method === "GET" && (current !== "https" || target !== "http") && location.match(/^https?:/), `unsupported redirect`, "UNSUPPORTED_OPERATION", {
            operation: `redirect(${this.method} ${JSON.stringify(this.url)} => ${JSON.stringify(location)})`
        });
        // Create a copy of this request, with a new URL
        const req = new $639ac0facbde31d2$export$319b96fe59834522(location);
        req.method = "GET";
        req.allowGzip = this.allowGzip;
        req.timeout = this.timeout;
        req.#headers = Object.assign({}, this.#headers);
        if (this.#body) req.#body = new Uint8Array(this.#body);
        req.#bodyType = this.#bodyType;
        // Do not forward credentials unless on the same domain; only absolute
        //req.allowInsecure = false;
        // paths are currently supported; may want a way to specify to forward?
        //setStore(req.#props, "creds", getStore(this.#pros, "creds"));
        return req;
    }
    /**
     *  Create a new copy of this request.
     */ clone() {
        const clone = new $639ac0facbde31d2$export$319b96fe59834522(this.url);
        // Preserve "default method" (i.e. null)
        clone.#method = this.#method;
        // Preserve "default body" with type, copying the Uint8Array is present
        if (this.#body) clone.#body = this.#body;
        clone.#bodyType = this.#bodyType;
        // Preserve "default headers"
        clone.#headers = Object.assign({}, this.#headers);
        // Credentials is readonly, so we copy internally
        clone.#creds = this.#creds;
        if (this.allowGzip) clone.allowGzip = true;
        clone.timeout = this.timeout;
        if (this.allowInsecureAuthentication) clone.allowInsecureAuthentication = true;
        clone.#preflight = this.#preflight;
        clone.#process = this.#process;
        clone.#retry = this.#retry;
        clone.#throttle = Object.assign({}, this.#throttle);
        clone.#getUrlFunc = this.#getUrlFunc;
        return clone;
    }
    /**
     *  Locks all static configuration for gateways and FetchGetUrlFunc
     *  registration.
     */ static lockConfig() {
        $639ac0facbde31d2$var$locked = true;
    }
    /**
     *  Get the current Gateway function for %%scheme%%.
     */ static getGateway(scheme) {
        return $639ac0facbde31d2$var$Gateways[scheme.toLowerCase()] || null;
    }
    /**
     *  Use the %%func%% when fetching URIs using %%scheme%%.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */ static registerGateway(scheme, func) {
        scheme = scheme.toLowerCase();
        if (scheme === "http" || scheme === "https") throw new Error(`cannot intercept ${scheme}; use registerGetUrl`);
        if ($639ac0facbde31d2$var$locked) throw new Error("gateways locked");
        $639ac0facbde31d2$var$Gateways[scheme] = func;
    }
    /**
     *  Use %%getUrl%% when fetching URIs over HTTP and HTTPS requests.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */ static registerGetUrl(getUrl) {
        if ($639ac0facbde31d2$var$locked) throw new Error("gateways locked");
        $639ac0facbde31d2$var$defaultGetUrlFunc = getUrl;
    }
    /**
     *  Creates a getUrl function that fetches content from HTTP and
     *  HTTPS URLs.
     *
     *  The available %%options%% are dependent on the platform
     *  implementation of the default getUrl function.
     *
     *  This is not generally something that is needed, but is useful
     *  when trying to customize simple behaviour when fetching HTTP
     *  content.
     */ static createGetUrlFunc(options) {
        return (0, $be1c1b348b4c33cc$export$d3950daf7bce5bf5)(options);
    }
    /**
     *  Creates a function that can "fetch" data URIs.
     *
     *  Note that this is automatically done internally to support
     *  data URIs, so it is not necessary to register it.
     *
     *  This is not generally something that is needed, but may
     *  be useful in a wrapper to perfom custom data URI functionality.
     */ static createDataGateway() {
        return $639ac0facbde31d2$var$dataGatewayFunc;
    }
    /**
     *  Creates a function that will fetch IPFS (unvalidated) from
     *  a custom gateway baseUrl.
     *
     *  The default IPFS gateway used internally is
     *  ``"https:/\/gateway.ipfs.io/ipfs/"``.
     */ static createIpfsGatewayFunc(baseUrl) {
        return $639ac0facbde31d2$var$getIpfsGatewayFunc(baseUrl);
    }
}
class $639ac0facbde31d2$export$3ae09bba5b6b906e {
    #statusCode;
    #statusMessage;
    #headers;
    #body;
    #request;
    #error;
    toString() {
        return `<FetchResponse status=${this.statusCode} body=${this.#body ? (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(this.#body) : "null"}>`;
    }
    /**
     *  The response status code.
     */ get statusCode() {
        return this.#statusCode;
    }
    /**
     *  The response status message.
     */ get statusMessage() {
        return this.#statusMessage;
    }
    /**
     *  The response headers. All keys are lower-case.
     */ get headers() {
        return Object.assign({}, this.#headers);
    }
    /**
     *  The response body, or ``null`` if there was no body.
     */ get body() {
        return this.#body == null ? null : new Uint8Array(this.#body);
    }
    /**
     *  The response body as a UTF-8 encoded string, or the empty
     *  string (i.e. ``""``) if there was no body.
     *
     *  An error is thrown if the body is invalid UTF-8 data.
     */ get bodyText() {
        try {
            return this.#body == null ? "" : (0, $cdede1645bd34985$export$7643a1dc2c38d5eb)(this.#body);
        } catch (error) {
            (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "response body is not valid UTF-8 data", "UNSUPPORTED_OPERATION", {
                operation: "bodyText",
                info: {
                    response: this
                }
            });
        }
    }
    /**
     *  The response body, decoded as JSON.
     *
     *  An error is thrown if the body is invalid JSON-encoded data
     *  or if there was no body.
     */ get bodyJson() {
        try {
            return JSON.parse(this.bodyText);
        } catch (error) {
            (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "response body is not valid JSON", "UNSUPPORTED_OPERATION", {
                operation: "bodyJson",
                info: {
                    response: this
                }
            });
        }
    }
    [Symbol.iterator]() {
        const headers = this.headers;
        const keys = Object.keys(headers);
        let index = 0;
        return {
            next: ()=>{
                if (index < keys.length) {
                    const key = keys[index++];
                    return {
                        value: [
                            key,
                            headers[key]
                        ],
                        done: false
                    };
                }
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    constructor(statusCode, statusMessage, headers, body, request){
        this.#statusCode = statusCode;
        this.#statusMessage = statusMessage;
        this.#headers = Object.keys(headers).reduce((accum, k)=>{
            accum[k.toLowerCase()] = String(headers[k]);
            return accum;
        }, {});
        this.#body = body == null ? null : new Uint8Array(body);
        this.#request = request || null;
        this.#error = {
            message: ""
        };
    }
    /**
     *  Return a Response with matching headers and body, but with
     *  an error status code (i.e. 599) and %%message%% with an
     *  optional %%error%%.
     */ makeServerError(message, error) {
        let statusMessage;
        if (!message) {
            message = `${this.statusCode} ${this.statusMessage}`;
            statusMessage = `CLIENT ESCALATED SERVER ERROR (${message})`;
        } else statusMessage = `CLIENT ESCALATED SERVER ERROR (${this.statusCode} ${this.statusMessage}; ${message})`;
        const response = new $639ac0facbde31d2$export$3ae09bba5b6b906e(599, statusMessage, this.headers, this.body, this.#request || undefined);
        response.#error = {
            message: message,
            error: error
        };
        return response;
    }
    /**
     *  If called within a [request.processFunc](FetchRequest-processFunc)
     *  call, causes the request to retry as if throttled for %%stall%%
     *  milliseconds.
     */ throwThrottleError(message, stall) {
        if (stall == null) stall = -1;
        else (0, $def55b050f09c63c$export$c3d31707e5030f5e)(Number.isInteger(stall) && stall >= 0, "invalid stall timeout", "stall", stall);
        const error = new Error(message || "throttling requests");
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(error, {
            stall: stall,
            throttle: true
        });
        throw error;
    }
    /**
     *  Get the header value for %%key%%, ignoring case.
     */ getHeader(key) {
        return this.headers[key.toLowerCase()];
    }
    /**
     *  Returns true if the response has a body.
     */ hasBody() {
        return this.#body != null;
    }
    /**
     *  The request made for this response.
     */ get request() {
        return this.#request;
    }
    /**
     *  Returns true if this response was a success statusCode.
     */ ok() {
        return this.#error.message === "" && this.statusCode >= 200 && this.statusCode < 300;
    }
    /**
     *  Throws a ``SERVER_ERROR`` if this response is not ok.
     */ assertOk() {
        if (this.ok()) return;
        let { message: message, error: error } = this.#error;
        if (message === "") message = `server response ${this.statusCode} ${this.statusMessage}`;
        let requestUrl = null;
        if (this.request) requestUrl = this.request.url;
        let responseBody = null;
        try {
            if (this.#body) responseBody = (0, $cdede1645bd34985$export$7643a1dc2c38d5eb)(this.#body);
        } catch (e) {}
        (0, $def55b050f09c63c$export$a7a9523472993e97)(false, message, "SERVER_ERROR", {
            request: this.request || "unknown request",
            response: this,
            error: error,
            info: {
                requestUrl: requestUrl,
                responseBody: responseBody,
                responseStatus: `${this.statusCode} ${this.statusMessage}`
            }
        });
    }
}
function $639ac0facbde31d2$var$getTime() {
    return new Date().getTime();
}
function $639ac0facbde31d2$var$unpercent(value) {
    return (0, $cdede1645bd34985$export$8feeb310b4b4752f)(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code)=>{
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function $639ac0facbde31d2$var$wait(delay) {
    return new Promise((resolve)=>setTimeout(resolve, delay));
}


/**
 *  The available providers should suffice for most developers purposes,
 *  but the [[AbstractProvider]] class has many features which enable
 *  sub-classing it for specific purposes.
 *
 *  @_section: api/providers/abstract-provider: Subclassing Provider  [abstract-provider]
 */ // @TODO
// Event coalescence
//   When we register an event with an async value (e.g. address is a Signer
//   or ENS name), we need to add it immeidately for the Event API, but also
//   need time to resolve the address. Upon resolving the address, we need to
//   migrate the listener to the static event. We also need to maintain a map
//   of Signer/ENS name to address so we can sync respond to listenerCount.

/**
 *  A constant for the zero address.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000"``)
 */ const $b4909c6a5ae371e9$export$b7cbe423ba83da17 = "0x0000000000000000000000000000000000000000";


/**
 *  The Interface class is a low-level class that accepts an
 *  ABI and provides all the necessary functionality to encode
 *  and decode paramaters to and results from methods, events
 *  and errors.
 *
 *  It also provides several convenience methods to automatically
 *  search and find matching transactions and events to parse them.
 *
 *  @_subsection api/abi:Interfaces  [interfaces]
 */ 






class $3444a7590bebc852$export$c2ab6499be98b3c5 {
    /**
     *  The matching fragment for the ``topic0``.
     */ fragment;
    /**
     *  The name of the Event.
     */ name;
    /**
     *  The full Event signature.
     */ signature;
    /**
     *  The topic hash for the Event.
     */ topic;
    /**
     *  The arguments passed into the Event with ``emit``.
     */ args;
    /**
     *  @_ignore:
     */ constructor(fragment, topic, args){
        const name = fragment.name, signature = fragment.format();
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            fragment: fragment,
            name: name,
            signature: signature,
            topic: topic,
            args: args
        });
    }
}
class $3444a7590bebc852$export$7a3223b0fadb690b {
    /**
     *  The matching fragment from the transaction ``data``.
     */ fragment;
    /**
     *  The name of the Function from the transaction ``data``.
     */ name;
    /**
     *  The arguments passed to the Function from the transaction ``data``.
     */ args;
    /**
     *  The full Function signature from the transaction ``data``.
     */ signature;
    /**
     *  The selector for the Function from the transaction ``data``.
     */ selector;
    /**
     *  The ``value`` (in wei) from the transaction.
     */ value;
    /**
     *  @_ignore:
     */ constructor(fragment, selector, args, value){
        const name = fragment.name, signature = fragment.format();
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            fragment: fragment,
            name: name,
            args: args,
            signature: signature,
            selector: selector,
            value: value
        });
    }
}
class $3444a7590bebc852$export$cfba08fc0e40e2ab {
    /**
     *  The matching fragment.
     */ fragment;
    /**
     *  The name of the Error.
     */ name;
    /**
     *  The arguments passed to the Error with ``revert``.
     */ args;
    /**
     *  The full Error signature.
     */ signature;
    /**
     *  The selector for the Error.
     */ selector;
    /**
     *  @_ignore:
     */ constructor(fragment, selector, args){
        const name = fragment.name, signature = fragment.format();
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            fragment: fragment,
            name: name,
            args: args,
            signature: signature,
            selector: selector
        });
    }
}
class $3444a7590bebc852$export$8ef99100a3c56f8c {
    /**
     *  The ``keccak256`` of the value logged.
     */ hash;
    /**
     *  @_ignore:
     */ _isIndexed;
    /**
     *  Returns ``true`` if %%value%% is an **Indexed**.
     *
     *  This provides a Type Guard for property access.
     */ static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
    /**
     *  @_ignore:
     */ constructor(hash){
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            hash: hash,
            _isIndexed: true
        });
    }
}
// https://docs.soliditylang.org/en/v0.8.13/control-structures.html?highlight=panic#panic-via-assert-and-error-via-require
const $3444a7590bebc852$var$PanicReasons = {
    "0": "generic panic",
    "1": "assert(false)",
    "17": "arithmetic overflow",
    "18": "division or modulo by zero",
    "33": "enum overflow",
    "34": "invalid encoded storage byte array accessed",
    "49": "out-of-bounds array access; popping on an empty array",
    "50": "out-of-bounds access of an array or bytesN",
    "65": "out of memory",
    "81": "uninitialized function"
};
const $3444a7590bebc852$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: (message)=>{
            return `reverted with reason string ${JSON.stringify(message)}`;
        }
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ],
        reason: (code)=>{
            let reason = "unknown panic code";
            if (code >= 0 && code <= 0xff && $3444a7590bebc852$var$PanicReasons[code.toString()]) reason = $3444a7590bebc852$var$PanicReasons[code.toString()];
            return `reverted with panic code 0x${code.toString(16)} (${reason})`;
        }
    }
};
class $3444a7590bebc852$export$48cefb51a4e315b2 {
    /**
     *  All the Contract ABI members (i.e. methods, events, errors, etc).
     */ fragments;
    /**
     *  The Contract constructor.
     */ deploy;
    /**
     *  The Fallback method, if any.
     */ fallback;
    /**
     *  If receiving ether is supported.
     */ receive;
    #errors;
    #events;
    #functions;
    //    #structs: Map<string, StructFragment>;
    #abiCoder;
    /**
     *  Create a new Interface for the %%fragments%%.
     */ constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        this.#functions = new Map();
        this.#errors = new Map();
        this.#events = new Map();
        //        this.#structs = new Map();
        const frags = [];
        for (const a of abi)try {
            frags.push((0, $33b91ae696ec7843$export$ffb0004e005737fa).from(a));
        } catch (error) {
            console.log(`[Warning] Invalid Fragment ${JSON.stringify(a)}:`, error.message);
        }
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            fragments: Object.freeze(frags)
        });
        let fallback = null;
        let receive = false;
        this.#abiCoder = this.getAbiCoder();
        // Add all fragments by their signature
        this.fragments.forEach((fragment, index)=>{
            let bucket;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        console.log("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
                        deploy: fragment
                    });
                    return;
                case "fallback":
                    if (fragment.inputs.length === 0) receive = true;
                    else {
                        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(!fallback || fragment.payable !== fallback.payable, "conflicting fallback fragments", `fragments[${index}]`, fragment);
                        fallback = fragment;
                        receive = fallback.payable;
                    }
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.#functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.#events;
                    break;
                case "error":
                    bucket = this.#errors;
                    break;
                default:
                    return;
            }
            // Two identical entries; ignore it
            const signature = fragment.format();
            if (bucket.has(signature)) return;
            bucket.set(signature, fragment);
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            deploy: (0, $33b91ae696ec7843$export$3ac5c9504f801ea4).from("constructor()")
        });
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            fallback: fallback,
            receive: receive
        });
    }
    /**
     *  Returns the entire Human-Readable ABI, as an array of
     *  signatures, optionally as %%minimal%% strings, which
     *  removes parameter names and unneceesary spaces.
     */ format(minimal) {
        const format = minimal ? "minimal" : "full";
        const abi = this.fragments.map((f)=>f.format(format));
        return abi;
    }
    /**
     *  Return the JSON-encoded ABI. This is the format Solidiy
     *  returns.
     */ formatJson() {
        const abi = this.fragments.map((f)=>f.format("json"));
        // We need to re-bundle the JSON fragments a bit
        return JSON.stringify(abi.map((j)=>JSON.parse(j)));
    }
    /**
     *  The ABI coder that will be used to encode and decode binary
     *  data.
     */ getAbiCoder() {
        return (0, $a3f016f760f1d6cc$export$fe041e1a83d3efc6).defaultAbiCoder();
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    #getFunction(key, values, forceUnique) {
        // Selector
        if ((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(key)) {
            const selector = key.toLowerCase();
            for (const fragment of this.#functions.values()){
                if (selector === fragment.selector) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#functions)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (values) {
                const lastValue = values.length > 0 ? values[values.length - 1] : null;
                let valueLength = values.length;
                let allowOptions = true;
                if ((0, $ba580f5d16310ab2$export$af51273277efe223).isTyped(lastValue) && lastValue.type === "overrides") {
                    allowOptions = false;
                    valueLength--;
                }
                // Remove all matches that don't have a compatible length. The args
                // may contain an overrides, so the match may have n or n - 1 parameters
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs.length;
                    if (inputs !== valueLength && (!allowOptions || inputs !== valueLength - 1)) matching.splice(i, 1);
                }
                // Remove all matches that don't match the Typed signature
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs;
                    for(let j = 0; j < values.length; j++){
                        // Not a typed value
                        if (!(0, $ba580f5d16310ab2$export$af51273277efe223).isTyped(values[j])) continue;
                        // We are past the inputs
                        if (j >= inputs.length) {
                            if (values[j].type === "overrides") continue;
                            matching.splice(i, 1);
                            break;
                        }
                        // Make sure the value type matches the input type
                        if (values[j].type !== inputs[j].baseType) {
                            matching.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            // We found a single matching signature with an overrides, but the
            // last value is something that cannot possibly be an options
            if (matching.length === 1 && values && values.length !== matching[0].inputs.length) {
                const lastArg = values[values.length - 1];
                if (lastArg == null || Array.isArray(lastArg) || typeof lastArg !== "object") matching.splice(0, 1);
            }
            if (matching.length === 0) return null;
            if (matching.length > 1 && forceUnique) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, `ambiguous function description (i.e. matches ${matchStr})`, "key", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        const result = this.#functions.get((0, $33b91ae696ec7843$export$8d576c928b93668f).from(key).format());
        if (result) return result;
        return null;
    }
    /**
     *  Get the function name for %%key%%, which may be a function selector,
     *  function name or function signature that belongs to the ABI.
     */ getFunctionName(key) {
        const fragment = this.#getFunction(key, null, false);
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(fragment, "no matching function", "key", key);
        return fragment.name;
    }
    /**
     *  Returns true if %%key%% (a function selector, function name or
     *  function signature) is present in the ABI.
     *
     *  In the case of a function name, the name may be ambiguous, so
     *  accessing the [[FunctionFragment]] may require refinement.
     */ hasFunction(key) {
        return !!this.#getFunction(key, null, false);
    }
    /**
     *  Get the [[FunctionFragment]] for %%key%%, which may be a function
     *  selector, function name or function signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple functions match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single function in
     *  the ABI, this will throw.
     */ getFunction(key, values) {
        return this.#getFunction(key, values || null, true);
    }
    /**
     *  Iterate over all functions, calling %%callback%%, sorted by their name.
     */ forEachFunction(callback) {
        const names = Array.from(this.#functions.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#functions.get(name), i);
        }
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    #getEvent(key, values, forceUnique) {
        // EventTopic
        if ((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(key)) {
            const eventTopic = key.toLowerCase();
            for (const fragment of this.#events.values()){
                if (eventTopic === fragment.topicHash) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#events)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (values) {
                // Remove all matches that don't have a compatible length.
                for(let i = matching.length - 1; i >= 0; i--)if (matching[i].inputs.length < values.length) matching.splice(i, 1);
                // Remove all matches that don't match the Typed signature
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs;
                    for(let j = 0; j < values.length; j++){
                        // Not a typed value
                        if (!(0, $ba580f5d16310ab2$export$af51273277efe223).isTyped(values[j])) continue;
                        // Make sure the value type matches the input type
                        if (values[j].type !== inputs[j].baseType) {
                            matching.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            if (matching.length === 0) return null;
            if (matching.length > 1 && forceUnique) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, `ambiguous event description (i.e. matches ${matchStr})`, "key", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        const result = this.#events.get((0, $33b91ae696ec7843$export$958548f08bac2833).from(key).format());
        if (result) return result;
        return null;
    }
    /**
     *  Get the event name for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     */ getEventName(key) {
        const fragment = this.#getEvent(key, null, false);
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(fragment, "no matching event", "key", key);
        return fragment.name;
    }
    /**
     *  Returns true if %%key%% (an event topic hash, event name or
     *  event signature) is present in the ABI.
     *
     *  In the case of an event name, the name may be ambiguous, so
     *  accessing the [[EventFragment]] may require refinement.
     */ hasEvent(key) {
        return !!this.#getEvent(key, null, false);
    }
    /**
     *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple events match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single event in
     *  the ABI, this will throw.
     */ getEvent(key, values) {
        return this.#getEvent(key, values || null, true);
    }
    /**
     *  Iterate over all events, calling %%callback%%, sorted by their name.
     */ forEachEvent(callback) {
        const names = Array.from(this.#events.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#events.get(name), i);
        }
    }
    /**
     *  Get the [[ErrorFragment]] for %%key%%, which may be an error
     *  selector, error name or error signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple errors match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single error in
     *  the ABI, this will throw.
     */ getError(key, values) {
        if ((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(key)) {
            const selector = key.toLowerCase();
            if ($3444a7590bebc852$var$BuiltinErrors[selector]) return (0, $33b91ae696ec7843$export$2c42c6d543aa9b59).from($3444a7590bebc852$var$BuiltinErrors[selector].signature);
            for (const fragment of this.#errors.values()){
                if (selector === fragment.selector) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#errors)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (matching.length === 0) {
                if (key === "Error") return (0, $33b91ae696ec7843$export$2c42c6d543aa9b59).from("error Error(string)");
                if (key === "Panic") return (0, $33b91ae696ec7843$export$2c42c6d543aa9b59).from("error Panic(uint256)");
                return null;
            } else if (matching.length > 1) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, `ambiguous error description (i.e. ${matchStr})`, "name", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        key = (0, $33b91ae696ec7843$export$2c42c6d543aa9b59).from(key).format();
        if (key === "Error(string)") return (0, $33b91ae696ec7843$export$2c42c6d543aa9b59).from("error Error(string)");
        if (key === "Panic(uint256)") return (0, $33b91ae696ec7843$export$2c42c6d543aa9b59).from("error Panic(uint256)");
        const result = this.#errors.get(key);
        if (result) return result;
        return null;
    }
    /**
     *  Iterate over all errors, calling %%callback%%, sorted by their name.
     */ forEachError(callback) {
        const names = Array.from(this.#errors.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#errors.get(name), i);
        }
    }
    // Get the 4-byte selector used by Solidity to identify a function
    /*
getSelector(fragment: ErrorFragment | FunctionFragment): string {
    if (typeof(fragment) === "string") {
        const matches: Array<Fragment> = [ ];

        try { matches.push(this.getFunction(fragment)); } catch (error) { }
        try { matches.push(this.getError(<string>fragment)); } catch (_) { }

        if (matches.length === 0) {
            logger.throwArgumentError("unknown fragment", "key", fragment);
        } else if (matches.length > 1) {
            logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
        }

        fragment = matches[0];
    }

    return dataSlice(id(fragment.format()), 0, 4);
}
    */ // Get the 32-byte topic hash used by Solidity to identify an event
    /*
    getEventTopic(fragment: EventFragment): string {
        //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
        return id(fragment.format());
    }
    */ _decodeParams(params, data) {
        return this.#abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this.#abiCoder.encode(params, values);
    }
    /**
     *  Encodes a ``tx.data`` object for deploying the Contract with
     *  the %%values%% as the constructor arguments.
     */ encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified error (see [[getError]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */ decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getError(fragment);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(f, "unknown error", "fragment", fragment);
            fragment = f;
        }
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)((0, $8de17c58ebd53b07$export$f6d845ffb449edc9)(data, 0, 4) === fragment.selector, `data signature does not match error ${fragment.name}.`, "data", data);
        return this._decodeParams(fragment.inputs, (0, $8de17c58ebd53b07$export$f6d845ffb449edc9)(data, 4));
    }
    /**
     *  Encodes the transaction revert data for a call result that
     *  reverted from the the Contract with the sepcified %%error%%
     *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */ encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getError(fragment);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(f, "unknown error", "fragment", fragment);
            fragment = f;
        }
        return (0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)([
            fragment.selector,
            this._encodeParams(fragment.inputs, values || [])
        ]);
    }
    /**
     *  Decodes the %%data%% from a transaction ``tx.data`` for
     *  the function specified (see [[getFunction]] for valid values
     *  for %%fragment%%).
     *
     *  Most developers should prefer the [[parseTransaction]] method
     *  instead, which will automatically detect the fragment.
     */ decodeFunctionData(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)((0, $8de17c58ebd53b07$export$f6d845ffb449edc9)(data, 0, 4) === fragment.selector, `data signature does not match function ${fragment.name}.`, "data", data);
        return this._decodeParams(fragment.inputs, (0, $8de17c58ebd53b07$export$f6d845ffb449edc9)(data, 4));
    }
    /**
     *  Encodes the ``tx.data`` for a transaction that calls the function
     *  specified (see [[getFunction]] for valid values for %%fragment%%) with
     *  the %%values%%.
     */ encodeFunctionData(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        return (0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)([
            fragment.selector,
            this._encodeParams(fragment.inputs, values || [])
        ]);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */ decodeFunctionResult(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        let message = "invalid length for result data";
        const bytes = (0, $8de17c58ebd53b07$export$37110e7fee0af4ad)(data);
        if (bytes.length % 32 === 0) try {
            return this.#abiCoder.decode(fragment.outputs, bytes);
        } catch (error) {
            message = "could not decode result data";
        }
        // Call returned data with no error, but the data is junk
        (0, $def55b050f09c63c$export$a7a9523472993e97)(false, message, "BAD_DATA", {
            value: (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(bytes),
            info: {
                method: fragment.name,
                signature: fragment.format()
            }
        });
    }
    makeError(_data, tx) {
        const data = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(_data, "data");
        const error = (0, $a3f016f760f1d6cc$export$fe041e1a83d3efc6).getBuiltinCallException("call", tx, data);
        // Not a built-in error; try finding a custom error
        const customPrefix = "execution reverted (unknown custom error)";
        if (error.message.startsWith(customPrefix)) {
            const selector = (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(data.slice(0, 4));
            const ef = this.getError(selector);
            if (ef) try {
                const args = this.#abiCoder.decode(ef.inputs, data.slice(4));
                error.revert = {
                    name: ef.name,
                    signature: ef.format(),
                    args: args
                };
                error.reason = error.revert.signature;
                error.message = `execution reverted: ${error.reason}`;
            } catch (e) {
                error.message = `execution reverted (coult not decode custom error)`;
            }
        }
        // Add the invocation, if available
        const parsed = this.parseTransaction(tx);
        if (parsed) error.invocation = {
            method: parsed.name,
            signature: parsed.signature,
            args: parsed.args
        };
        return error;
    }
    /**
     *  Encodes the result data (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values
     *  for %%fragment%%) with %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */ encodeFunctionResult(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(this.#abiCoder.encode(fragment.outputs, values || []));
    }
    /*
        spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
            const promises: Array<Promise<>> = [ ];
            const process = function(type: ParamType, value: any): any {
                if (type.baseType === "array") {
                    return descend(type.child
                }
                if (type. === "address") {
                }
            };
    
            const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
                if (inputs.length !== values.length) { throw new Error("length mismatch"); }
                
            };
    
            const result: Array<any> = [ ];
            values.forEach((value, index) => {
                if (value == null) {
                    topics.push(null);
                } else if (param.baseType === "array" || param.baseType === "tuple") {
                    logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
                } else if (Array.isArray(value)) {
                    topics.push(value.map((value) => encodeTopic(param, value)));
                } else {
                    topics.push(encodeTopic(param, value));
                }
            });
        }
    */ // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        (0, $def55b050f09c63c$export$a7a9523472993e97)(values.length <= fragment.inputs.length, `too many arguments for ${fragment.format()}`, "UNEXPECTED_ARGUMENT", {
            count: values.length,
            expectedCount: fragment.inputs.length
        });
        const topics = [];
        if (!fragment.anonymous) topics.push(fragment.topicHash);
        // @TODO: Use the coders for this; to properly support tuples, etc.
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $4af82668f5a6ec7b$export$d560c7e4a29451c2)(value);
            else if (param.type === "bytes") return (0, $1c3ba5429a8a9032$export$f8151fce47ad1c35)((0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            else if (param.type.match(/^u?int/)) value = (0, $7df480338fc2bc47$export$c6ebe05badb16181)(value); // @TODO: Should this toTwos??
            else if (param.type.match(/^bytes/)) value = (0, $8de17c58ebd53b07$export$1dc7fbe1b8738fe7)(value, 32);
            else if (param.type === "address") // Check addresses are valid
            this.#abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $8de17c58ebd53b07$export$4473860254365feb)((0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(value), 32);
        };
        values.forEach((value, index)=>{
            const param = fragment.inputs[index];
            if (!param.indexed) {
                (0, $def55b050f09c63c$export$c3d31707e5030f5e)(value == null, "cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!fragment.anonymous) topics.push(fragment.topicHash);
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(values.length === fragment.inputs.length, "event arguments/values mismatch", "values", values);
        fragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $4af82668f5a6ec7b$export$d560c7e4a29451c2)(value));
                else if (param.type === "bytes") topics.push((0, $1c3ba5429a8a9032$export$f8151fce47ad1c35)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this.#abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this.#abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(fragment, data, topics) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        if (topics != null && !fragment.anonymous) {
            const eventTopic = fragment.topicHash;
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(topics[0], 32) && topics[0].toLowerCase() === eventTopic, "fragment/topic mismatch", "topics[0]", topics[0]);
            topics = topics.slice(1);
        }
        const indexed = [];
        const nonIndexed = [];
        const dynamic = [];
        fragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $33b91ae696ec7843$export$426dc07f493a4c47).from({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        const resultIndexed = topics != null ? this.#abiCoder.decode(indexed, (0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)(topics)) : null;
        const resultNonIndexed = this.#abiCoder.decode(nonIndexed, data, true);
        //const result: (Array<any> & { [ key: string ]: any }) = [ ];
        const values = [];
        const keys = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        fragment.inputs.forEach((param, index)=>{
            let value = null;
            if (param.indexed) {
                if (resultIndexed == null) value = new $3444a7590bebc852$export$8ef99100a3c56f8c(null);
                else if (dynamic[index]) value = new $3444a7590bebc852$export$8ef99100a3c56f8c(resultIndexed[indexedIndex++]);
                else try {
                    value = resultIndexed[indexedIndex++];
                } catch (error) {
                    value = error;
                }
            } else try {
                value = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                value = error;
            }
            values.push(value);
            keys.push(param.name || null);
        });
        return (0, $7373ab4bcc395b24$export$8fdcabde73f49165).fromItems(values, keys);
    }
    /**
     *  Parses a transaction, finding the matching function and extracts
     *  the parameter values along with other useful function details.
     *
     *  If the matching function cannot be found, return null.
     */ parseTransaction(tx) {
        const data = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(tx.data, "tx.data");
        const value = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(tx.value != null ? tx.value : 0, "tx.value");
        const fragment = this.getFunction((0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(data.slice(0, 4)));
        if (!fragment) return null;
        const args = this.#abiCoder.decode(fragment.inputs, data.slice(4));
        return new $3444a7590bebc852$export$7a3223b0fadb690b(fragment, fragment.selector, args, value);
    }
    parseCallResult(data) {
        throw new Error("@TODO");
    }
    /**
     *  Parses a receipt log, finding the matching event and extracts
     *  the parameter values along with other useful event details.
     *
     *  If the matching event cannot be found, returns null.
     */ parseLog(log) {
        const fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $3444a7590bebc852$export$c2ab6499be98b3c5(fragment, fragment.topicHash, this.decodeEventLog(fragment, log.data, log.topics));
    }
    /**
     *  Parses a revert data, finding the matching error and extracts
     *  the parameter values along with other useful error details.
     *
     *  If the matching error cannot be found, returns null.
     */ parseError(data) {
        const hexData = (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(data);
        const fragment = this.getError((0, $8de17c58ebd53b07$export$f6d845ffb449edc9)(hexData, 0, 4));
        if (!fragment) return null;
        const args = this.#abiCoder.decode(fragment.inputs, (0, $8de17c58ebd53b07$export$f6d845ffb449edc9)(hexData, 4));
        return new $3444a7590bebc852$export$cfba08fc0e40e2ab(fragment, fragment.selector, args);
    }
    /**
     *  Creates a new [[Interface]] from the ABI %%value%%.
     *
     *  The %%value%% may be provided as an existing [[Interface]] object,
     *  a JSON-encoded ABI or any Human-Readable ABI format.
     */ static from(value) {
        // Already an Interface, which is immutable
        if (value instanceof $3444a7590bebc852$export$48cefb51a4e315b2) return value;
        // JSON
        if (typeof value === "string") return new $3444a7590bebc852$export$48cefb51a4e315b2(JSON.parse(value));
        // An Interface; possibly from another v6 instance
        if (typeof value.formatJson === "function") return new $3444a7590bebc852$export$48cefb51a4e315b2(value.formatJson());
        // A legacy Interface; from an older version
        if (typeof value.format === "function") return new $3444a7590bebc852$export$48cefb51a4e315b2(value.format("json"));
        // Array of fragments
        return new $3444a7590bebc852$export$48cefb51a4e315b2(value);
    }
}



//import { resolveAddress } from "@ethersproject/address";


const $daa40c4afcf2fddc$var$BN_0 = BigInt(0);
// -----------------------
function $daa40c4afcf2fddc$var$getValue(value) {
    if (value == null) return null;
    return value;
}
function $daa40c4afcf2fddc$var$toJson(value) {
    if (value == null) return null;
    return value.toString();
}
class $daa40c4afcf2fddc$export$116c49c1e2a96a78 {
    /**
     *  The gas price for legacy networks.
     */ gasPrice;
    /**
     *  The maximum fee to pay per gas.
     *
     *  The base fee per gas is defined by the network and based on
     *  congestion, increasing the cost during times of heavy load
     *  and lowering when less busy.
     *
     *  The actual fee per gas will be the base fee for the block
     *  and the priority fee, up to the max fee per gas.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */ maxFeePerGas;
    /**
     *  The additional amout to pay per gas to encourage a validator
     *  to include the transaction.
     *
     *  The purpose of this is to compensate the validator for the
     *  adjusted risk for including a given transaction.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */ maxPriorityFeePerGas;
    /**
     *  Creates a new FeeData for %%gasPrice%%, %%maxFeePerGas%% and
     *  %%maxPriorityFeePerGas%%.
     */ constructor(gasPrice, maxFeePerGas, maxPriorityFeePerGas){
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            gasPrice: $daa40c4afcf2fddc$var$getValue(gasPrice),
            maxFeePerGas: $daa40c4afcf2fddc$var$getValue(maxFeePerGas),
            maxPriorityFeePerGas: $daa40c4afcf2fddc$var$getValue(maxPriorityFeePerGas)
        });
    }
    /**
     *  Returns a JSON-friendly value.
     */ toJSON() {
        const { gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas } = this;
        return {
            _type: "FeeData",
            gasPrice: $daa40c4afcf2fddc$var$toJson(gasPrice),
            maxFeePerGas: $daa40c4afcf2fddc$var$toJson(maxFeePerGas),
            maxPriorityFeePerGas: $daa40c4afcf2fddc$var$toJson(maxPriorityFeePerGas)
        };
    }
}
function $daa40c4afcf2fddc$export$607b34cdac162b7f(req) {
    const result = {};
    // These could be addresses, ENS names or Addressables
    if (req.to) result.to = req.to;
    if (req.from) result.from = req.from;
    if (req.data) result.data = (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(req.data);
    const bigIntKeys = "chainId,gasLimit,gasPrice,maxFeePerBlobGas,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
    for (const key of bigIntKeys){
        if (!(key in req) || req[key] == null) continue;
        result[key] = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(req[key], `request.${key}`);
    }
    const numberKeys = "type,nonce".split(/,/);
    for (const key of numberKeys){
        if (!(key in req) || req[key] == null) continue;
        result[key] = (0, $7df480338fc2bc47$export$b14f2714108df84)(req[key], `request.${key}`);
    }
    if (req.accessList) result.accessList = (0, $63484022a9ae8dfc$export$6c8662b1600dce2)(req.accessList);
    if (req.authorizationList) result.authorizationList = req.authorizationList.slice();
    if ("blockTag" in req) result.blockTag = req.blockTag;
    if ("enableCcipRead" in req) result.enableCcipRead = !!req.enableCcipRead;
    if ("customData" in req) result.customData = req.customData;
    if ("blobVersionedHashes" in req && req.blobVersionedHashes) result.blobVersionedHashes = req.blobVersionedHashes.slice();
    if ("kzg" in req) result.kzg = req.kzg;
    if ("blobs" in req && req.blobs) result.blobs = req.blobs.map((b)=>{
        if ((0, $8de17c58ebd53b07$export$9a14abb1a440cd5e)(b)) return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(b);
        return Object.assign({}, b);
    });
    return result;
}
class $daa40c4afcf2fddc$export$d96a8827a60d6b69 {
    /**
     *  The provider connected to the block used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The block number, sometimes called the block height. This is a
     *  sequential number that is one higher than the parent block.
     */ number;
    /**
     *  The block hash.
     *
     *  This hash includes all properties, so can be safely used to identify
     *  an exact set of block properties.
     */ hash;
    /**
     *  The timestamp for this block, which is the number of seconds since
     *  epoch that this block was included.
     */ timestamp;
    /**
     *  The block hash of the parent block.
     */ parentHash;
    /**
     *  The hash tree root of the parent beacon block for the given
     *  execution block. See [[link-eip-4788]].
     */ parentBeaconBlockRoot;
    /**
     *  The nonce.
     *
     *  On legacy networks, this is the random number inserted which
     *  permitted the difficulty target to be reached.
     */ nonce;
    /**
     *  The difficulty target.
     *
     *  On legacy networks, this is the proof-of-work target required
     *  for a block to meet the protocol rules to be included.
     *
     *  On modern networks, this is a random number arrived at using
     *  randao.  @TODO: Find links?
     */ difficulty;
    /**
     *  The total gas limit for this block.
     */ gasLimit;
    /**
     *  The total gas used in this block.
     */ gasUsed;
    /**
     *  The root hash for the global state after applying changes
     *  in this block.
     */ stateRoot;
    /**
     *  The hash of the transaction receipts trie.
     */ receiptsRoot;
    /**
     *  The total amount of blob gas consumed by the transactions
     *  within the block. See [[link-eip-4844]].
     */ blobGasUsed;
    /**
     *  The running total of blob gas consumed in excess of the
     *  target, prior to the block. See [[link-eip-4844]].
     */ excessBlobGas;
    /**
     *  The miner coinbase address, wihch receives any subsidies for
     *  including this block.
     */ miner;
    /**
     *  The latest RANDAO mix of the post beacon state of
     *  the previous block.
     */ prevRandao;
    /**
     *  Any extra data the validator wished to include.
     */ extraData;
    /**
     *  The base fee per gas that all transactions in this block were
     *  charged.
     *
     *  This adjusts after each block, depending on how congested the network
     *  is.
     */ baseFeePerGas;
    #transactions;
    /**
     *  Create a new **Block** object.
     *
     *  This should generally not be necessary as the unless implementing a
     *  low-level library.
     */ constructor(block, provider){
        this.#transactions = block.transactions.map((tx)=>{
            if (typeof tx !== "string") return new $daa40c4afcf2fddc$export$70966cdb3bfc0785(tx, provider);
            return tx;
        });
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            provider: provider,
            hash: $daa40c4afcf2fddc$var$getValue(block.hash),
            number: block.number,
            timestamp: block.timestamp,
            parentHash: block.parentHash,
            parentBeaconBlockRoot: block.parentBeaconBlockRoot,
            nonce: block.nonce,
            difficulty: block.difficulty,
            gasLimit: block.gasLimit,
            gasUsed: block.gasUsed,
            blobGasUsed: block.blobGasUsed,
            excessBlobGas: block.excessBlobGas,
            miner: block.miner,
            prevRandao: $daa40c4afcf2fddc$var$getValue(block.prevRandao),
            extraData: block.extraData,
            baseFeePerGas: $daa40c4afcf2fddc$var$getValue(block.baseFeePerGas),
            stateRoot: block.stateRoot,
            receiptsRoot: block.receiptsRoot
        });
    }
    /**
     *  Returns the list of transaction hashes, in the order
     *  they were executed within the block.
     */ get transactions() {
        return this.#transactions.map((tx)=>{
            if (typeof tx === "string") return tx;
            return tx.hash;
        });
    }
    /**
     *  Returns the complete transactions, in the order they
     *  were executed within the block.
     *
     *  This is only available for blocks which prefetched
     *  transactions, by passing ``true`` to %%prefetchTxs%%
     *  into [[Provider-getBlock]].
     */ get prefetchedTransactions() {
        const txs = this.#transactions.slice();
        // Doesn't matter...
        if (txs.length === 0) return [];
        // Make sure we prefetched the transactions
        (0, $def55b050f09c63c$export$a7a9523472993e97)(typeof txs[0] === "object", "transactions were not prefetched with block request", "UNSUPPORTED_OPERATION", {
            operation: "transactionResponses()"
        });
        return txs;
    }
    /**
     *  Returns a JSON-friendly value.
     */ toJSON() {
        const { baseFeePerGas: baseFeePerGas, difficulty: difficulty, extraData: extraData, gasLimit: gasLimit, gasUsed: gasUsed, hash: hash, miner: miner, prevRandao: prevRandao, nonce: nonce, number: number, parentHash: parentHash, parentBeaconBlockRoot: parentBeaconBlockRoot, stateRoot: stateRoot, receiptsRoot: receiptsRoot, timestamp: timestamp, transactions: transactions } = this;
        return {
            _type: "Block",
            baseFeePerGas: $daa40c4afcf2fddc$var$toJson(baseFeePerGas),
            difficulty: $daa40c4afcf2fddc$var$toJson(difficulty),
            extraData: extraData,
            gasLimit: $daa40c4afcf2fddc$var$toJson(gasLimit),
            gasUsed: $daa40c4afcf2fddc$var$toJson(gasUsed),
            blobGasUsed: $daa40c4afcf2fddc$var$toJson(this.blobGasUsed),
            excessBlobGas: $daa40c4afcf2fddc$var$toJson(this.excessBlobGas),
            hash: hash,
            miner: miner,
            prevRandao: prevRandao,
            nonce: nonce,
            number: number,
            parentHash: parentHash,
            timestamp: timestamp,
            parentBeaconBlockRoot: parentBeaconBlockRoot,
            stateRoot: stateRoot,
            receiptsRoot: receiptsRoot,
            transactions: transactions
        };
    }
    [Symbol.iterator]() {
        let index = 0;
        const txs = this.transactions;
        return {
            next: ()=>{
                if (index < this.length) return {
                    value: txs[index++],
                    done: false
                };
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The number of transactions in this block.
     */ get length() {
        return this.#transactions.length;
    }
    /**
     *  The [[link-js-date]] this block was included at.
     */ get date() {
        if (this.timestamp == null) return null;
        return new Date(this.timestamp * 1000);
    }
    /**
     *  Get the transaction at %%indexe%% within this block.
     */ async getTransaction(indexOrHash) {
        // Find the internal value by its index or hash
        let tx = undefined;
        if (typeof indexOrHash === "number") tx = this.#transactions[indexOrHash];
        else {
            const hash = indexOrHash.toLowerCase();
            for (const v of this.#transactions)if (typeof v === "string") {
                if (v !== hash) continue;
                tx = v;
                break;
            } else {
                if (v.hash !== hash) continue;
                tx = v;
                break;
            }
        }
        if (tx == null) throw new Error("no such tx");
        if (typeof tx === "string") return await this.provider.getTransaction(tx);
        else return tx;
    }
    /**
     *  If a **Block** was fetched with a request to include the transactions
     *  this will allow synchronous access to those transactions.
     *
     *  If the transactions were not prefetched, this will throw.
     */ getPrefetchedTransaction(indexOrHash) {
        const txs = this.prefetchedTransactions;
        if (typeof indexOrHash === "number") return txs[indexOrHash];
        indexOrHash = indexOrHash.toLowerCase();
        for (const tx of txs){
            if (tx.hash === indexOrHash) return tx;
        }
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "no matching transaction", "indexOrHash", indexOrHash);
    }
    /**
     *  Returns true if this block been mined. This provides a type guard
     *  for all properties on a [[MinedBlock]].
     */ isMined() {
        return !!this.hash;
    }
    /**
     *  Returns true if this block is an [[link-eip-2930]] block.
     */ isLondon() {
        return !!this.baseFeePerGas;
    }
    /**
     *  @_ignore:
     */ orphanedEvent() {
        if (!this.isMined()) throw new Error("");
        return $daa40c4afcf2fddc$var$createOrphanedBlockFilter(this);
    }
}
class $daa40c4afcf2fddc$export$ce30dbb46644d06c {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The transaction hash of the transaction this log occurred in. Use the
     *  [[Log-getTransaction]] to get the [[TransactionResponse]].
     */ transactionHash;
    /**
     *  The block hash of the block this log occurred in. Use the
     *  [[Log-getBlock]] to get the [[Block]].
     */ blockHash;
    /**
     *  The block number of the block this log occurred in. It is preferred
     *  to use the [[Block-hash]] when fetching the related [[Block]],
     *  since in the case of an orphaned block, the block at that height may
     *  have changed.
     */ blockNumber;
    /**
     *  If the **Log** represents a block that was removed due to an orphaned
     *  block, this will be true.
     *
     *  This can only happen within an orphan event listener.
     */ removed;
    /**
     *  The address of the contract that emitted this log.
     */ address;
    /**
     *  The data included in this log when it was emitted.
     */ data;
    /**
     *  The indexed topics included in this log when it was emitted.
     *
     *  All topics are included in the bloom filters, so they can be
     *  efficiently filtered using the [[Provider-getLogs]] method.
     */ topics;
    /**
     *  The index within the block this log occurred at. This is generally
     *  not useful to developers, but can be used with the various roots
     *  to proof inclusion within a block.
     */ index;
    /**
     *  The index within the transaction of this log.
     */ transactionIndex;
    /**
     *  @_ignore:
     */ constructor(log, provider){
        this.provider = provider;
        const topics = Object.freeze(log.topics.slice());
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            transactionHash: log.transactionHash,
            blockHash: log.blockHash,
            blockNumber: log.blockNumber,
            removed: log.removed,
            address: log.address,
            data: log.data,
            topics: topics,
            index: log.index,
            transactionIndex: log.transactionIndex
        });
    }
    /**
     *  Returns a JSON-compatible object.
     */ toJSON() {
        const { address: address, blockHash: blockHash, blockNumber: blockNumber, data: data, index: index, removed: removed, topics: topics, transactionHash: transactionHash, transactionIndex: transactionIndex } = this;
        return {
            _type: "log",
            address: address,
            blockHash: blockHash,
            blockNumber: blockNumber,
            data: data,
            index: index,
            removed: removed,
            topics: topics,
            transactionHash: transactionHash,
            transactionIndex: transactionIndex
        };
    }
    /**
     *  Returns the block that this log occurred in.
     */ async getBlock() {
        const block = await this.provider.getBlock(this.blockHash);
        (0, $def55b050f09c63c$export$a7a9523472993e97)(!!block, "failed to find transaction", "UNKNOWN_ERROR", {});
        return block;
    }
    /**
     *  Returns the transaction that this log occurred in.
     */ async getTransaction() {
        const tx = await this.provider.getTransaction(this.transactionHash);
        (0, $def55b050f09c63c$export$a7a9523472993e97)(!!tx, "failed to find transaction", "UNKNOWN_ERROR", {});
        return tx;
    }
    /**
     *  Returns the transaction receipt fot the transaction that this
     *  log occurred in.
     */ async getTransactionReceipt() {
        const receipt = await this.provider.getTransactionReceipt(this.transactionHash);
        (0, $def55b050f09c63c$export$a7a9523472993e97)(!!receipt, "failed to find transaction receipt", "UNKNOWN_ERROR", {});
        return receipt;
    }
    /**
     *  @_ignore:
     */ removedEvent() {
        return $daa40c4afcf2fddc$var$createRemovedLogFilter(this);
    }
}
class $daa40c4afcf2fddc$export$375ffd5683aa5c1c {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The address the transaction was sent to.
     */ to;
    /**
     *  The sender of the transaction.
     */ from;
    /**
     *  The address of the contract if the transaction was directly
     *  responsible for deploying one.
     *
     *  This is non-null **only** if the ``to`` is empty and the ``data``
     *  was successfully executed as initcode.
     */ contractAddress;
    /**
     *  The transaction hash.
     */ hash;
    /**
     *  The index of this transaction within the block transactions.
     */ index;
    /**
     *  The block hash of the [[Block]] this transaction was included in.
     */ blockHash;
    /**
     *  The block number of the [[Block]] this transaction was included in.
     */ blockNumber;
    /**
     *  The bloom filter bytes that represent all logs that occurred within
     *  this transaction. This is generally not useful for most developers,
     *  but can be used to validate the included logs.
     */ logsBloom;
    /**
     *  The actual amount of gas used by this transaction.
     *
     *  When creating a transaction, the amount of gas that will be used can
     *  only be approximated, but the sender must pay the gas fee for the
     *  entire gas limit. After the transaction, the difference is refunded.
     */ gasUsed;
    /**
     *  The gas used for BLObs. See [[link-eip-4844]].
     */ blobGasUsed;
    /**
     *  The amount of gas used by all transactions within the block for this
     *  and all transactions with a lower ``index``.
     *
     *  This is generally not useful for developers but can be used to
     *  validate certain aspects of execution.
     */ cumulativeGasUsed;
    /**
     *  The actual gas price used during execution.
     *
     *  Due to the complexity of [[link-eip-1559]] this value can only
     *  be caluclated after the transaction has been mined, snce the base
     *  fee is protocol-enforced.
     */ gasPrice;
    /**
     *  The price paid per BLOB in gas. See [[link-eip-4844]].
     */ blobGasPrice;
    /**
     *  The [[link-eip-2718]] transaction type.
     */ type;
    //readonly byzantium!: boolean;
    /**
     *  The status of this transaction, indicating success (i.e. ``1``) or
     *  a revert (i.e. ``0``).
     *
     *  This is available in post-byzantium blocks, but some backends may
     *  backfill this value.
     */ status;
    /**
     *  The root hash of this transaction.
     *
     *  This is no present and was only included in pre-byzantium blocks, but
     *  could be used to validate certain parts of the receipt.
     */ root;
    #logs;
    /**
     *  @_ignore:
     */ constructor(tx, provider){
        this.#logs = Object.freeze(tx.logs.map((log)=>{
            return new $daa40c4afcf2fddc$export$ce30dbb46644d06c(log, provider);
        }));
        let gasPrice = $daa40c4afcf2fddc$var$BN_0;
        if (tx.effectiveGasPrice != null) gasPrice = tx.effectiveGasPrice;
        else if (tx.gasPrice != null) gasPrice = tx.gasPrice;
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            provider: provider,
            to: tx.to,
            from: tx.from,
            contractAddress: tx.contractAddress,
            hash: tx.hash,
            index: tx.index,
            blockHash: tx.blockHash,
            blockNumber: tx.blockNumber,
            logsBloom: tx.logsBloom,
            gasUsed: tx.gasUsed,
            cumulativeGasUsed: tx.cumulativeGasUsed,
            blobGasUsed: tx.blobGasUsed,
            gasPrice: gasPrice,
            blobGasPrice: tx.blobGasPrice,
            type: tx.type,
            //byzantium: tx.byzantium,
            status: tx.status,
            root: tx.root
        });
    }
    /**
     *  The logs for this transaction.
     */ get logs() {
        return this.#logs;
    }
    /**
     *  Returns a JSON-compatible representation.
     */ toJSON() {
        const { to: to, from: from, contractAddress: contractAddress, hash: hash, index: index, blockHash: blockHash, blockNumber: blockNumber, logsBloom: logsBloom, logs: logs, status: status, root: root } = this;
        return {
            _type: "TransactionReceipt",
            blockHash: blockHash,
            blockNumber: blockNumber,
            contractAddress: //byzantium, 
            contractAddress,
            cumulativeGasUsed: $daa40c4afcf2fddc$var$toJson(this.cumulativeGasUsed),
            from: from,
            gasPrice: $daa40c4afcf2fddc$var$toJson(this.gasPrice),
            blobGasUsed: $daa40c4afcf2fddc$var$toJson(this.blobGasUsed),
            blobGasPrice: $daa40c4afcf2fddc$var$toJson(this.blobGasPrice),
            gasUsed: $daa40c4afcf2fddc$var$toJson(this.gasUsed),
            hash: hash,
            index: index,
            logs: logs,
            logsBloom: logsBloom,
            root: root,
            status: status,
            to: to
        };
    }
    /**
     *  @_ignore:
     */ get length() {
        return this.logs.length;
    }
    [Symbol.iterator]() {
        let index = 0;
        return {
            next: ()=>{
                if (index < this.length) return {
                    value: this.logs[index++],
                    done: false
                };
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The total fee for this transaction, in wei.
     */ get fee() {
        return this.gasUsed * this.gasPrice;
    }
    /**
     *  Resolves to the block this transaction occurred in.
     */ async getBlock() {
        const block = await this.provider.getBlock(this.blockHash);
        if (block == null) throw new Error("TODO");
        return block;
    }
    /**
     *  Resolves to the transaction this transaction occurred in.
     */ async getTransaction() {
        const tx = await this.provider.getTransaction(this.hash);
        if (tx == null) throw new Error("TODO");
        return tx;
    }
    /**
     *  Resolves to the return value of the execution of this transaction.
     *
     *  Support for this feature is limited, as it requires an archive node
     *  with the ``debug_`` or ``trace_`` API enabled.
     */ async getResult() {
        return await this.provider.getTransactionResult(this.hash);
    }
    /**
     *  Resolves to the number of confirmations this transaction has.
     */ async confirmations() {
        return await this.provider.getBlockNumber() - this.blockNumber + 1;
    }
    /**
     *  @_ignore:
     */ removedEvent() {
        return $daa40c4afcf2fddc$var$createRemovedTransactionFilter(this);
    }
    /**
     *  @_ignore:
     */ reorderedEvent(other) {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(!other || other.isMined(), "unmined 'other' transction cannot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "reorderedEvent(other)"
        });
        return $daa40c4afcf2fddc$var$createReorderedTransactionFilter(this, other);
    }
}
class $daa40c4afcf2fddc$export$70966cdb3bfc0785 {
    /**
     *  The provider this is connected to, which will influence how its
     *  methods will resolve its async inspection methods.
     */ provider;
    /**
     *  The block number of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */ blockNumber;
    /**
     *  The blockHash of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */ blockHash;
    /**
     *  The index within the block that this transaction resides at.
     */ index;
    /**
     *  The transaction hash.
     */ hash;
    /**
     *  The [[link-eip-2718]] transaction envelope type. This is
     *  ``0`` for legacy transactions types.
     */ type;
    /**
     *  The receiver of this transaction.
     *
     *  If ``null``, then the transaction is an initcode transaction.
     *  This means the result of executing the [[data]] will be deployed
     *  as a new contract on chain (assuming it does not revert) and the
     *  address may be computed using [[getCreateAddress]].
     */ to;
    /**
     *  The sender of this transaction. It is implicitly computed
     *  from the transaction pre-image hash (as the digest) and the
     *  [[signature]] using ecrecover.
     */ from;
    /**
     *  The nonce, which is used to prevent replay attacks and offer
     *  a method to ensure transactions from a given sender are explicitly
     *  ordered.
     *
     *  When sending a transaction, this must be equal to the number of
     *  transactions ever sent by [[from]].
     */ nonce;
    /**
     *  The maximum units of gas this transaction can consume. If execution
     *  exceeds this, the entries transaction is reverted and the sender
     *  is charged for the full amount, despite not state changes being made.
     */ gasLimit;
    /**
     *  The gas price can have various values, depending on the network.
     *
     *  In modern networks, for transactions that are included this is
     *  the //effective gas price// (the fee per gas that was actually
     *  charged), while for transactions that have not been included yet
     *  is the [[maxFeePerGas]].
     *
     *  For legacy transactions, or transactions on legacy networks, this
     *  is the fee that will be charged per unit of gas the transaction
     *  consumes.
     */ gasPrice;
    /**
     *  The maximum priority fee (per unit of gas) to allow a
     *  validator to charge the sender. This is inclusive of the
     *  [[maxFeeFeePerGas]].
     */ maxPriorityFeePerGas;
    /**
     *  The maximum fee (per unit of gas) to allow this transaction
     *  to charge the sender.
     */ maxFeePerGas;
    /**
     *  The [[link-eip-4844]] max fee per BLOb gas.
     */ maxFeePerBlobGas;
    /**
     *  The data.
     */ data;
    /**
     *  The value, in wei. Use [[formatEther]] to format this value
     *  as ether.
     */ value;
    /**
     *  The chain ID.
     */ chainId;
    /**
     *  The signature.
     */ signature;
    /**
     *  The [[link-eip-2930]] access list for transaction types that
     *  support it, otherwise ``null``.
     */ accessList;
    /**
     *  The [[link-eip-4844]] BLOb versioned hashes.
     */ blobVersionedHashes;
    /**
     *  The [[link-eip-7702]] authorizations (if any).
     */ authorizationList;
    #startBlock;
    /**
     *  @_ignore:
     */ constructor(tx, provider){
        this.provider = provider;
        this.blockNumber = tx.blockNumber != null ? tx.blockNumber : null;
        this.blockHash = tx.blockHash != null ? tx.blockHash : null;
        this.hash = tx.hash;
        this.index = tx.index;
        this.type = tx.type;
        this.from = tx.from;
        this.to = tx.to || null;
        this.gasLimit = tx.gasLimit;
        this.nonce = tx.nonce;
        this.data = tx.data;
        this.value = tx.value;
        this.gasPrice = tx.gasPrice;
        this.maxPriorityFeePerGas = tx.maxPriorityFeePerGas != null ? tx.maxPriorityFeePerGas : null;
        this.maxFeePerGas = tx.maxFeePerGas != null ? tx.maxFeePerGas : null;
        this.maxFeePerBlobGas = tx.maxFeePerBlobGas != null ? tx.maxFeePerBlobGas : null;
        this.chainId = tx.chainId;
        this.signature = tx.signature;
        this.accessList = tx.accessList != null ? tx.accessList : null;
        this.blobVersionedHashes = tx.blobVersionedHashes != null ? tx.blobVersionedHashes : null;
        this.authorizationList = tx.authorizationList != null ? tx.authorizationList : null;
        this.#startBlock = -1;
    }
    /**
     *  Returns a JSON-compatible representation of this transaction.
     */ toJSON() {
        const { blockNumber: blockNumber, blockHash: blockHash, index: index, hash: hash, type: type, to: to, from: from, nonce: nonce, data: data, signature: signature, accessList: accessList, blobVersionedHashes: blobVersionedHashes } = this;
        return {
            _type: "TransactionResponse",
            accessList: accessList,
            blockNumber: blockNumber,
            blockHash: blockHash,
            blobVersionedHashes: blobVersionedHashes,
            chainId: $daa40c4afcf2fddc$var$toJson(this.chainId),
            data: data,
            from: from,
            gasLimit: $daa40c4afcf2fddc$var$toJson(this.gasLimit),
            gasPrice: $daa40c4afcf2fddc$var$toJson(this.gasPrice),
            hash: hash,
            maxFeePerGas: $daa40c4afcf2fddc$var$toJson(this.maxFeePerGas),
            maxPriorityFeePerGas: $daa40c4afcf2fddc$var$toJson(this.maxPriorityFeePerGas),
            maxFeePerBlobGas: $daa40c4afcf2fddc$var$toJson(this.maxFeePerBlobGas),
            nonce: nonce,
            signature: signature,
            to: to,
            index: index,
            type: type,
            value: $daa40c4afcf2fddc$var$toJson(this.value)
        };
    }
    /**
     *  Resolves to the Block that this transaction was included in.
     *
     *  This will return null if the transaction has not been included yet.
     */ async getBlock() {
        let blockNumber = this.blockNumber;
        if (blockNumber == null) {
            const tx = await this.getTransaction();
            if (tx) blockNumber = tx.blockNumber;
        }
        if (blockNumber == null) return null;
        const block = this.provider.getBlock(blockNumber);
        if (block == null) throw new Error("TODO");
        return block;
    }
    /**
     *  Resolves to this transaction being re-requested from the
     *  provider. This can be used if you have an unmined transaction
     *  and wish to get an up-to-date populated instance.
     */ async getTransaction() {
        return this.provider.getTransaction(this.hash);
    }
    /**
     *  Resolve to the number of confirmations this transaction has.
     */ async confirmations() {
        if (this.blockNumber == null) {
            const { tx: tx, blockNumber: blockNumber } = await (0, $5c7e3a359d4744c6$export$d503dd157d963b60)({
                tx: this.getTransaction(),
                blockNumber: this.provider.getBlockNumber()
            });
            // Not mined yet...
            if (tx == null || tx.blockNumber == null) return 0;
            return blockNumber - tx.blockNumber + 1;
        }
        const blockNumber = await this.provider.getBlockNumber();
        return blockNumber - this.blockNumber + 1;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */ async wait(_confirms, _timeout) {
        const confirms = _confirms == null ? 1 : _confirms;
        const timeout = _timeout == null ? 0 : _timeout;
        let startBlock = this.#startBlock;
        let nextScan = -1;
        let stopScanning = startBlock === -1 ? true : false;
        const checkReplacement = async ()=>{
            // Get the current transaction count for this sender
            if (stopScanning) return null;
            const { blockNumber: blockNumber, nonce: nonce } = await (0, $5c7e3a359d4744c6$export$d503dd157d963b60)({
                blockNumber: this.provider.getBlockNumber(),
                nonce: this.provider.getTransactionCount(this.from)
            });
            // No transaction or our nonce has not been mined yet; but we
            // can start scanning later when we do start
            if (nonce < this.nonce) {
                startBlock = blockNumber;
                return;
            }
            // We were mined; no replacement
            if (stopScanning) return null;
            const mined = await this.getTransaction();
            if (mined && mined.blockNumber != null) return;
            // We were replaced; start scanning for that transaction
            // Starting to scan; look back a few extra blocks for safety
            if (nextScan === -1) {
                nextScan = startBlock - 3;
                if (nextScan < this.#startBlock) nextScan = this.#startBlock;
            }
            while(nextScan <= blockNumber){
                // Get the next block to scan
                if (stopScanning) return null;
                const block = await this.provider.getBlock(nextScan, true);
                // This should not happen; but we'll try again shortly
                if (block == null) return;
                // We were mined; no replacement
                for (const hash of block){
                    if (hash === this.hash) return;
                }
                // Search for the transaction that replaced us
                for(let i = 0; i < block.length; i++){
                    const tx = await block.getTransaction(i);
                    if (tx.from === this.from && tx.nonce === this.nonce) {
                        // Get the receipt
                        if (stopScanning) return null;
                        const receipt = await this.provider.getTransactionReceipt(tx.hash);
                        // This should not happen; but we'll try again shortly
                        if (receipt == null) return;
                        // We will retry this on the next block (this case could be optimized)
                        if (blockNumber - receipt.blockNumber + 1 < confirms) return;
                        // The reason we were replaced
                        let reason = "replaced";
                        if (tx.data === this.data && tx.to === this.to && tx.value === this.value) reason = "repriced";
                        else if (tx.data === "0x" && tx.from === tx.to && tx.value === $daa40c4afcf2fddc$var$BN_0) reason = "cancelled";
                        (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "transaction was replaced", "TRANSACTION_REPLACED", {
                            cancelled: reason === "replaced" || reason === "cancelled",
                            reason: reason,
                            replacement: tx.replaceableTransaction(startBlock),
                            hash: tx.hash,
                            receipt: receipt
                        });
                    }
                }
                nextScan++;
            }
            return;
        };
        const checkReceipt = (receipt)=>{
            if (receipt == null || receipt.status !== 0) return receipt;
            (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "transaction execution reverted", "CALL_EXCEPTION", {
                action: "sendTransaction",
                data: null,
                reason: null,
                invocation: null,
                revert: null,
                transaction: {
                    to: receipt.to,
                    from: receipt.from,
                    data: "" // @TODO: in v7, split out sendTransaction properties
                },
                receipt: receipt
            });
        };
        const receipt = await this.provider.getTransactionReceipt(this.hash);
        if (confirms === 0) return checkReceipt(receipt);
        if (receipt) {
            if (confirms === 1 || await receipt.confirmations() >= confirms) return checkReceipt(receipt);
        } else {
            // Check for a replacement; throws if a replacement was found
            await checkReplacement();
            // Allow null only when the confirms is 0
            if (confirms === 0) return null;
        }
        const waiter = new Promise((resolve, reject)=>{
            // List of things to cancel when we have a result (one way or the other)
            const cancellers = [];
            const cancel = ()=>{
                cancellers.forEach((c)=>c());
            };
            // On cancel, stop scanning for replacements
            cancellers.push(()=>{
                stopScanning = true;
            });
            // Set up any timeout requested
            if (timeout > 0) {
                const timer = setTimeout(()=>{
                    cancel();
                    reject((0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("wait for transaction timeout", "TIMEOUT"));
                }, timeout);
                cancellers.push(()=>{
                    clearTimeout(timer);
                });
            }
            const txListener = async (receipt)=>{
                // Done; return it!
                if (await receipt.confirmations() >= confirms) {
                    cancel();
                    try {
                        resolve(checkReceipt(receipt));
                    } catch (error) {
                        reject(error);
                    }
                }
            };
            cancellers.push(()=>{
                this.provider.off(this.hash, txListener);
            });
            this.provider.on(this.hash, txListener);
            // We support replacement detection; start checking
            if (startBlock >= 0) {
                const replaceListener = async ()=>{
                    try {
                        // Check for a replacement; this throws only if one is found
                        await checkReplacement();
                    } catch (error) {
                        // We were replaced (with enough confirms); re-throw the error
                        if ((0, $def55b050f09c63c$export$e6127cc7fe7395c3)(error, "TRANSACTION_REPLACED")) {
                            cancel();
                            reject(error);
                            return;
                        }
                    }
                    // Rescheudle a check on the next block
                    if (!stopScanning) this.provider.once("block", replaceListener);
                };
                cancellers.push(()=>{
                    this.provider.off("block", replaceListener);
                });
                this.provider.once("block", replaceListener);
            }
        });
        return await waiter;
    }
    /**
     *  Returns ``true`` if this transaction has been included.
     *
     *  This is effective only as of the time the TransactionResponse
     *  was instantiated. To get up-to-date information, use
     *  [[getTransaction]].
     *
     *  This provides a Type Guard that this transaction will have
     *  non-null property values for properties that are null for
     *  unmined transactions.
     */ isMined() {
        return this.blockHash != null;
    }
    /**
     *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
     *  transaction.
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isLegacy() {
        return this.type === 0;
    }
    /**
     *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
     *  transaction. See [[link-eip-2070]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isBerlin() {
        return this.type === 1;
    }
    /**
     *  Returns true if the transaction is a London (i.e. ``type == 2``)
     *  transaction. See [[link-eip-1559]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isLondon() {
        return this.type === 2;
    }
    /**
     *  Returns true if hte transaction is a Cancun (i.e. ``type == 3``)
     *  transaction. See [[link-eip-4844]].
     */ isCancun() {
        return this.type === 3;
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that evict this transaction.
     */ removedEvent() {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        return $daa40c4afcf2fddc$var$createRemovedTransactionFilter(this);
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that re-order this event against %%other%%.
     */ reorderedEvent(other) {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        (0, $def55b050f09c63c$export$a7a9523472993e97)(!other || other.isMined(), "unmined 'other' transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        return $daa40c4afcf2fddc$var$createReorderedTransactionFilter(this, other);
    }
    /**
     *  Returns a new TransactionResponse instance which has the ability to
     *  detect (and throw an error) if the transaction is replaced, which
     *  will begin scanning at %%startBlock%%.
     *
     *  This should generally not be used by developers and is intended
     *  primarily for internal use. Setting an incorrect %%startBlock%% can
     *  have devastating performance consequences if used incorrectly.
     */ replaceableTransaction(startBlock) {
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(Number.isInteger(startBlock) && startBlock >= 0, "invalid startBlock", "startBlock", startBlock);
        const tx = new $daa40c4afcf2fddc$export$70966cdb3bfc0785(this, this.provider);
        tx.#startBlock = startBlock;
        return tx;
    }
}
function $daa40c4afcf2fddc$var$createOrphanedBlockFilter(block) {
    return {
        orphan: "drop-block",
        hash: block.hash,
        number: block.number
    };
}
function $daa40c4afcf2fddc$var$createReorderedTransactionFilter(tx, other) {
    return {
        orphan: "reorder-transaction",
        tx: tx,
        other: other
    };
}
function $daa40c4afcf2fddc$var$createRemovedTransactionFilter(tx) {
    return {
        orphan: "drop-transaction",
        tx: tx
    };
}
function $daa40c4afcf2fddc$var$createRemovedLogFilter(log) {
    return {
        orphan: "drop-log",
        log: {
            transactionHash: log.transactionHash,
            blockHash: log.blockHash,
            blockNumber: log.blockNumber,
            address: log.address,
            data: log.data,
            topics: Object.freeze(log.topics.slice()),
            index: log.index
        }
    };
}



// import from provider.ts instead of index.ts to prevent circular dep
// from EtherscanProvider

/**
 *  Events allow for applications to use the observer pattern, which
 *  allows subscribing and publishing events, outside the normal
 *  execution paths.
 *
 *  @_section api/utils/events:Events  [about-events]
 */ 
class $6a5512eaca61d3ca$export$9cec82196983b278 {
    /**
     *  The event filter.
     */ filter;
    /**
     *  The **EventEmitterable**.
     */ emitter;
    #listener;
    /**
     *  Create a new **EventPayload** for %%emitter%% with
     *  the %%listener%% and for %%filter%%.
     */ constructor(emitter, listener, filter){
        this.#listener = listener;
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            emitter: emitter,
            filter: filter
        });
    }
    /**
     *  Unregister the triggered listener for future events.
     */ async removeListener() {
        if (this.#listener == null) return;
        await this.emitter.off(this.filter, this.#listener);
    }
}


class $45b2f7a685545ecd$export$f8203d08df5cd081 extends (0, $daa40c4afcf2fddc$export$ce30dbb46644d06c) {
    /**
     *  The Contract Interface.
     */ interface;
    /**
     *  The matching event.
     */ fragment;
    /**
     *  The parsed arguments passed to the event by ``emit``.
     */ args;
    /**
     * @_ignore:
     */ constructor(log, iface, fragment){
        super(log, log.provider);
        const args = iface.decodeEventLog(fragment, log.data, log.topics);
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            args: args,
            fragment: fragment,
            interface: iface
        });
    }
    /**
     *  The name of the event.
     */ get eventName() {
        return this.fragment.name;
    }
    /**
     *  The signature of the event.
     */ get eventSignature() {
        return this.fragment.format();
    }
}
class $45b2f7a685545ecd$export$53f6e6acc02bf489 extends (0, $daa40c4afcf2fddc$export$ce30dbb46644d06c) {
    /**
     *  The error encounted when trying to decode the log.
     */ error;
    /**
     * @_ignore:
     */ constructor(log, error){
        super(log, log.provider);
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            error: error
        });
    }
}
class $45b2f7a685545ecd$export$86bdc83e93503686 extends (0, $daa40c4afcf2fddc$export$375ffd5683aa5c1c) {
    #iface;
    /**
     *  @_ignore:
     */ constructor(iface, provider, tx){
        super(tx, provider);
        this.#iface = iface;
    }
    /**
     *  The parsed logs for any [[Log]] which has a matching event in the
     *  Contract ABI.
     */ get logs() {
        return super.logs.map((log)=>{
            const fragment = log.topics.length ? this.#iface.getEvent(log.topics[0]) : null;
            if (fragment) try {
                return new $45b2f7a685545ecd$export$f8203d08df5cd081(log, this.#iface, fragment);
            } catch (error) {
                return new $45b2f7a685545ecd$export$53f6e6acc02bf489(log, error);
            }
            return log;
        });
    }
}
class $45b2f7a685545ecd$export$853f7e2df34220ff extends (0, $daa40c4afcf2fddc$export$70966cdb3bfc0785) {
    #iface;
    /**
     *  @_ignore:
     */ constructor(iface, provider, tx){
        super(tx, provider);
        this.#iface = iface;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */ async wait(confirms, timeout) {
        const receipt = await super.wait(confirms, timeout);
        if (receipt == null) return null;
        return new $45b2f7a685545ecd$export$86bdc83e93503686(this.#iface, this.provider, receipt);
    }
}
class $45b2f7a685545ecd$export$54be5ec94ad26a69 extends (0, $6a5512eaca61d3ca$export$9cec82196983b278) {
    /**
     *  The log with no matching events.
     */ log;
    /**
     *  @_event:
     */ constructor(contract, listener, filter, log){
        super(contract, listener, filter);
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            log: log
        });
    }
    /**
     *  Resolves to the block the event occured in.
     */ async getBlock() {
        return await this.log.getBlock();
    }
    /**
     *  Resolves to the transaction the event occured in.
     */ async getTransaction() {
        return await this.log.getTransaction();
    }
    /**
     *  Resolves to the transaction receipt the event occured in.
     */ async getTransactionReceipt() {
        return await this.log.getTransactionReceipt();
    }
}
class $45b2f7a685545ecd$export$35f9272dc1c07dee extends $45b2f7a685545ecd$export$54be5ec94ad26a69 {
    /**
     *  @_ignore:
     */ constructor(contract, listener, filter, fragment, _log){
        super(contract, listener, filter, new $45b2f7a685545ecd$export$f8203d08df5cd081(_log, contract.interface, fragment));
        const args = contract.interface.decodeEventLog(fragment, this.log.data, this.log.topics);
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            args: args,
            fragment: fragment
        });
    }
    /**
     *  The event name.
     */ get eventName() {
        return this.fragment.name;
    }
    /**
     *  The event signature.
     */ get eventSignature() {
        return this.fragment.format();
    }
}


const $220158e9e9aec1ec$var$BN_0 = BigInt(0);
function $220158e9e9aec1ec$var$canCall(value) {
    return value && typeof value.call === "function";
}
function $220158e9e9aec1ec$var$canEstimate(value) {
    return value && typeof value.estimateGas === "function";
}
function $220158e9e9aec1ec$var$canResolve(value) {
    return value && typeof value.resolveName === "function";
}
function $220158e9e9aec1ec$var$canSend(value) {
    return value && typeof value.sendTransaction === "function";
}
function $220158e9e9aec1ec$var$getResolver(value) {
    if (value != null) {
        if ($220158e9e9aec1ec$var$canResolve(value)) return value;
        if (value.provider) return value.provider;
    }
    return undefined;
}
class $220158e9e9aec1ec$var$PreparedTopicFilter {
    #filter;
    fragment;
    constructor(contract, fragment, args){
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            fragment: fragment
        });
        if (fragment.inputs.length < args.length) throw new Error("too many arguments");
        // Recursively descend into args and resolve any addresses
        const runner = $220158e9e9aec1ec$var$getRunner(contract.runner, "resolveName");
        const resolver = $220158e9e9aec1ec$var$canResolve(runner) ? runner : null;
        this.#filter = async function() {
            const resolvedArgs = await Promise.all(fragment.inputs.map((param, index)=>{
                const arg = args[index];
                if (arg == null) return null;
                return param.walkAsync(args[index], (type, value)=>{
                    if (type === "address") {
                        if (Array.isArray(value)) return Promise.all(value.map((v)=>(0, $d6021cd5b8a26773$export$687eed6b344123c9)(v, resolver)));
                        return (0, $d6021cd5b8a26773$export$687eed6b344123c9)(value, resolver);
                    }
                    return value;
                });
            }));
            return contract.interface.encodeFilterTopics(fragment, resolvedArgs);
        }();
    }
    getTopicFilter() {
        return this.#filter;
    }
}
// A = Arguments passed in as a tuple
// R = The result type of the call (i.e. if only one return type,
//     the qualified type, otherwise Result)
// D = The type the default call will return (i.e. R for view/pure,
//     TransactionResponse otherwise)
//export interface ContractMethod<A extends Array<any> = Array<any>, R = any, D extends R | ContractTransactionResponse = ContractTransactionResponse> {
function $220158e9e9aec1ec$var$getRunner(value, feature) {
    if (value == null) return null;
    if (typeof value[feature] === "function") return value;
    if (value.provider && typeof value.provider[feature] === "function") return value.provider;
    return null;
}
function $220158e9e9aec1ec$var$getProvider(value) {
    if (value == null) return null;
    return value.provider || null;
}
async function $220158e9e9aec1ec$export$fc358dcec4fec380(arg, allowed) {
    // Make sure the overrides passed in are a valid overrides object
    const _overrides = (0, $ba580f5d16310ab2$export$af51273277efe223).dereference(arg, "overrides");
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(typeof _overrides === "object", "invalid overrides parameter", "overrides", arg);
    // Create a shallow copy (we'll deep-ify anything needed during normalizing)
    const overrides = (0, $daa40c4afcf2fddc$export$607b34cdac162b7f)(_overrides);
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(overrides.to == null || (allowed || []).indexOf("to") >= 0, "cannot override to", "overrides.to", overrides.to);
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(overrides.data == null || (allowed || []).indexOf("data") >= 0, "cannot override data", "overrides.data", overrides.data);
    // Resolve any from
    if (overrides.from) overrides.from = overrides.from;
    return overrides;
}
async function $220158e9e9aec1ec$export$32e61c94d45e7108(_runner, inputs, args) {
    // Recursively descend into args and resolve any addresses
    const runner = $220158e9e9aec1ec$var$getRunner(_runner, "resolveName");
    const resolver = $220158e9e9aec1ec$var$canResolve(runner) ? runner : null;
    return await Promise.all(inputs.map((param, index)=>{
        return param.walkAsync(args[index], (type, value)=>{
            value = (0, $ba580f5d16310ab2$export$af51273277efe223).dereference(value, type);
            if (type === "address") return (0, $d6021cd5b8a26773$export$687eed6b344123c9)(value, resolver);
            return value;
        });
    }));
}
function $220158e9e9aec1ec$var$buildWrappedFallback(contract) {
    const populateTransaction = async function(overrides) {
        // If an overrides was passed in, copy it and normalize the values
        const tx = await $220158e9e9aec1ec$export$fc358dcec4fec380(overrides, [
            "data"
        ]);
        tx.to = await contract.getAddress();
        if (tx.from) tx.from = await (0, $d6021cd5b8a26773$export$687eed6b344123c9)(tx.from, $220158e9e9aec1ec$var$getResolver(contract.runner));
        const iface = contract.interface;
        const noValue = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(tx.value || $220158e9e9aec1ec$var$BN_0, "overrides.value") === $220158e9e9aec1ec$var$BN_0;
        const noData = (tx.data || "0x") === "0x";
        if (iface.fallback && !iface.fallback.payable && iface.receive && !noData && !noValue) (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "cannot send data to receive or send value to non-payable fallback", "overrides", overrides);
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
        // Only allow payable contracts to set non-zero value
        const payable = iface.receive || iface.fallback && iface.fallback.payable;
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(payable || noValue, "cannot send value to non-payable fallback", "overrides.value", tx.value);
        // Only allow fallback contracts to set non-empty data
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
        return tx;
    };
    const staticCall = async function(overrides) {
        const runner = $220158e9e9aec1ec$var$getRunner(contract.runner, "call");
        (0, $def55b050f09c63c$export$a7a9523472993e97)($220158e9e9aec1ec$var$canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
            operation: "call"
        });
        const tx = await populateTransaction(overrides);
        try {
            return await runner.call(tx);
        } catch (error) {
            if ((0, $def55b050f09c63c$export$748c4fa78f31ff35)(error) && error.data) throw contract.interface.makeError(error.data, tx);
            throw error;
        }
    };
    const send = async function(overrides) {
        const runner = contract.runner;
        (0, $def55b050f09c63c$export$a7a9523472993e97)($220158e9e9aec1ec$var$canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
            operation: "sendTransaction"
        });
        const tx = await runner.sendTransaction(await populateTransaction(overrides));
        const provider = $220158e9e9aec1ec$var$getProvider(contract.runner);
        // @TODO: the provider can be null; make a custom dummy provider that will throw a
        // meaningful error
        return new (0, $45b2f7a685545ecd$export$853f7e2df34220ff)(contract.interface, provider, tx);
    };
    const estimateGas = async function(overrides) {
        const runner = $220158e9e9aec1ec$var$getRunner(contract.runner, "estimateGas");
        (0, $def55b050f09c63c$export$a7a9523472993e97)($220158e9e9aec1ec$var$canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
            operation: "estimateGas"
        });
        return await runner.estimateGas(await populateTransaction(overrides));
    };
    const method = async (overrides)=>{
        return await send(overrides);
    };
    (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(method, {
        _contract: contract,
        estimateGas: estimateGas,
        populateTransaction: populateTransaction,
        send: send,
        staticCall: staticCall
    });
    return method;
}
function $220158e9e9aec1ec$var$buildWrappedMethod(contract, key) {
    const getFragment = function(...args) {
        const fragment = contract.interface.getFunction(key, args);
        (0, $def55b050f09c63c$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
                key: key,
                args: args
            }
        });
        return fragment;
    };
    const populateTransaction = async function(...args) {
        const fragment = getFragment(...args);
        // If an overrides was passed in, copy it and normalize the values
        let overrides = {};
        if (fragment.inputs.length + 1 === args.length) {
            overrides = await $220158e9e9aec1ec$export$fc358dcec4fec380(args.pop());
            if (overrides.from) overrides.from = await (0, $d6021cd5b8a26773$export$687eed6b344123c9)(overrides.from, $220158e9e9aec1ec$var$getResolver(contract.runner));
        }
        if (fragment.inputs.length !== args.length) throw new Error("internal error: fragment inputs doesn't match arguments; should not happen");
        const resolvedArgs = await $220158e9e9aec1ec$export$32e61c94d45e7108(contract.runner, fragment.inputs, args);
        return Object.assign({}, overrides, await (0, $5c7e3a359d4744c6$export$d503dd157d963b60)({
            to: contract.getAddress(),
            data: contract.interface.encodeFunctionData(fragment, resolvedArgs)
        }));
    };
    const staticCall = async function(...args) {
        const result = await staticCallResult(...args);
        if (result.length === 1) return result[0];
        return result;
    };
    const send = async function(...args) {
        const runner = contract.runner;
        (0, $def55b050f09c63c$export$a7a9523472993e97)($220158e9e9aec1ec$var$canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
            operation: "sendTransaction"
        });
        const tx = await runner.sendTransaction(await populateTransaction(...args));
        const provider = $220158e9e9aec1ec$var$getProvider(contract.runner);
        // @TODO: the provider can be null; make a custom dummy provider that will throw a
        // meaningful error
        return new (0, $45b2f7a685545ecd$export$853f7e2df34220ff)(contract.interface, provider, tx);
    };
    const estimateGas = async function(...args) {
        const runner = $220158e9e9aec1ec$var$getRunner(contract.runner, "estimateGas");
        (0, $def55b050f09c63c$export$a7a9523472993e97)($220158e9e9aec1ec$var$canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
            operation: "estimateGas"
        });
        return await runner.estimateGas(await populateTransaction(...args));
    };
    const staticCallResult = async function(...args) {
        const runner = $220158e9e9aec1ec$var$getRunner(contract.runner, "call");
        (0, $def55b050f09c63c$export$a7a9523472993e97)($220158e9e9aec1ec$var$canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
            operation: "call"
        });
        const tx = await populateTransaction(...args);
        let result = "0x";
        try {
            result = await runner.call(tx);
        } catch (error) {
            if ((0, $def55b050f09c63c$export$748c4fa78f31ff35)(error) && error.data) throw contract.interface.makeError(error.data, tx);
            throw error;
        }
        const fragment = getFragment(...args);
        return contract.interface.decodeFunctionResult(fragment, result);
    };
    const method = async (...args)=>{
        const fragment = getFragment(...args);
        if (fragment.constant) return await staticCall(...args);
        return await send(...args);
    };
    (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(method, {
        name: contract.interface.getFunctionName(key),
        _contract: contract,
        _key: key,
        getFragment: getFragment,
        estimateGas: estimateGas,
        populateTransaction: populateTransaction,
        send: send,
        staticCall: staticCall,
        staticCallResult: staticCallResult
    });
    // Only works on non-ambiguous keys (refined fragment is always non-ambiguous)
    Object.defineProperty(method, "fragment", {
        configurable: false,
        enumerable: true,
        get: ()=>{
            const fragment = contract.interface.getFunction(key);
            (0, $def55b050f09c63c$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
                operation: "fragment",
                info: {
                    key: key
                }
            });
            return fragment;
        }
    });
    return method;
}
function $220158e9e9aec1ec$var$buildWrappedEvent(contract, key) {
    const getFragment = function(...args) {
        const fragment = contract.interface.getEvent(key, args);
        (0, $def55b050f09c63c$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
                key: key,
                args: args
            }
        });
        return fragment;
    };
    const method = function(...args) {
        return new $220158e9e9aec1ec$var$PreparedTopicFilter(contract, getFragment(...args), args);
    };
    (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(method, {
        name: contract.interface.getEventName(key),
        _contract: contract,
        _key: key,
        getFragment: getFragment
    });
    // Only works on non-ambiguous keys (refined fragment is always non-ambiguous)
    Object.defineProperty(method, "fragment", {
        configurable: false,
        enumerable: true,
        get: ()=>{
            const fragment = contract.interface.getEvent(key);
            (0, $def55b050f09c63c$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
                operation: "fragment",
                info: {
                    key: key
                }
            });
            return fragment;
        }
    });
    return method;
}
// The combination of TypeScrype, Private Fields and Proxies makes
// the world go boom; so we hide variables with some trickery keeping
// a symbol attached to each BaseContract which its sub-class (even
// via a Proxy) can reach and use to look up its internal values.
const $220158e9e9aec1ec$var$internal = Symbol.for("_ethersInternal_contract");
const $220158e9e9aec1ec$var$internalValues = new WeakMap();
function $220158e9e9aec1ec$var$setInternal(contract, values) {
    $220158e9e9aec1ec$var$internalValues.set(contract[$220158e9e9aec1ec$var$internal], values);
}
function $220158e9e9aec1ec$var$getInternal(contract) {
    return $220158e9e9aec1ec$var$internalValues.get(contract[$220158e9e9aec1ec$var$internal]);
}
function $220158e9e9aec1ec$var$isDeferred(value) {
    return value && typeof value === "object" && "getTopicFilter" in value && typeof value.getTopicFilter === "function" && value.fragment;
}
async function $220158e9e9aec1ec$var$getSubInfo(contract, event) {
    let topics;
    let fragment = null;
    // Convert named events to topicHash and get the fragment for
    // events which need deconstructing.
    if (Array.isArray(event)) {
        const topicHashify = function(name) {
            if ((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(name, 32)) return name;
            const fragment = contract.interface.getEvent(name);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(fragment, "unknown fragment", "name", name);
            return fragment.topicHash;
        };
        // Array of Topics and Names; e.g. `[ "0x1234...89ab", "Transfer(address)" ]`
        topics = event.map((e)=>{
            if (e == null) return null;
            if (Array.isArray(e)) return e.map(topicHashify);
            return topicHashify(e);
        });
    } else if (event === "*") topics = [
        null
    ];
    else if (typeof event === "string") {
        if ((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(event, 32)) // Topic Hash
        topics = [
            event
        ];
        else {
            // Name or Signature; e.g. `"Transfer", `"Transfer(address)"`
            fragment = contract.interface.getEvent(event);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(fragment, "unknown fragment", "event", event);
            topics = [
                fragment.topicHash
            ];
        }
    } else if ($220158e9e9aec1ec$var$isDeferred(event)) // Deferred Topic Filter; e.g. `contract.filter.Transfer(from)`
    topics = await event.getTopicFilter();
    else if ("fragment" in event) {
        // ContractEvent; e.g. `contract.filter.Transfer`
        fragment = event.fragment;
        topics = [
            fragment.topicHash
        ];
    } else (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "unknown event name", "event", event);
    // Normalize topics and sort TopicSets
    topics = topics.map((t)=>{
        if (t == null) return null;
        if (Array.isArray(t)) {
            const items = Array.from(new Set(t.map((t)=>t.toLowerCase())).values());
            if (items.length === 1) return items[0];
            items.sort();
            return items;
        }
        return t.toLowerCase();
    });
    const tag = topics.map((t)=>{
        if (t == null) return "null";
        if (Array.isArray(t)) return t.join("|");
        return t;
    }).join("&");
    return {
        fragment: fragment,
        tag: tag,
        topics: topics
    };
}
async function $220158e9e9aec1ec$var$hasSub(contract, event) {
    const { subs: subs } = $220158e9e9aec1ec$var$getInternal(contract);
    return subs.get((await $220158e9e9aec1ec$var$getSubInfo(contract, event)).tag) || null;
}
async function $220158e9e9aec1ec$var$getSub(contract, operation, event) {
    // Make sure our runner can actually subscribe to events
    const provider = $220158e9e9aec1ec$var$getProvider(contract.runner);
    (0, $def55b050f09c63c$export$a7a9523472993e97)(provider, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", {
        operation: operation
    });
    const { fragment: fragment, tag: tag, topics: topics } = await $220158e9e9aec1ec$var$getSubInfo(contract, event);
    const { addr: addr, subs: subs } = $220158e9e9aec1ec$var$getInternal(contract);
    let sub = subs.get(tag);
    if (!sub) {
        const address = addr ? addr : contract;
        const filter = {
            address: address,
            topics: topics
        };
        const listener = (log)=>{
            let foundFragment = fragment;
            if (foundFragment == null) try {
                foundFragment = contract.interface.getEvent(log.topics[0]);
            } catch (error) {}
            // If fragment is null, we do not deconstruct the args to emit
            if (foundFragment) {
                const _foundFragment = foundFragment;
                const args = fragment ? contract.interface.decodeEventLog(fragment, log.data, log.topics) : [];
                $220158e9e9aec1ec$var$emit(contract, event, args, (listener)=>{
                    return new (0, $45b2f7a685545ecd$export$35f9272dc1c07dee)(contract, listener, event, _foundFragment, log);
                });
            } else $220158e9e9aec1ec$var$emit(contract, event, [], (listener)=>{
                return new (0, $45b2f7a685545ecd$export$54be5ec94ad26a69)(contract, listener, event, log);
            });
        };
        let starting = [];
        const start = ()=>{
            if (starting.length) return;
            starting.push(provider.on(filter, listener));
        };
        const stop = async ()=>{
            if (starting.length == 0) return;
            let started = starting;
            starting = [];
            await Promise.all(started);
            provider.off(filter, listener);
        };
        sub = {
            tag: tag,
            listeners: [],
            start: start,
            stop: stop
        };
        subs.set(tag, sub);
    }
    return sub;
}
// We use this to ensure one emit resolves before firing the next to
// ensure correct ordering (note this cannot throw and just adds the
// notice to the event queu using setTimeout).
let $220158e9e9aec1ec$var$lastEmit = Promise.resolve();
async function $220158e9e9aec1ec$var$_emit(contract, event, args, payloadFunc) {
    await $220158e9e9aec1ec$var$lastEmit;
    const sub = await $220158e9e9aec1ec$var$hasSub(contract, event);
    if (!sub) return false;
    const count = sub.listeners.length;
    sub.listeners = sub.listeners.filter(({ listener: listener, once: once })=>{
        const passArgs = Array.from(args);
        if (payloadFunc) passArgs.push(payloadFunc(once ? null : listener));
        try {
            listener.call(contract, ...passArgs);
        } catch (error) {}
        return !once;
    });
    if (sub.listeners.length === 0) {
        sub.stop();
        $220158e9e9aec1ec$var$getInternal(contract).subs.delete(sub.tag);
    }
    return count > 0;
}
async function $220158e9e9aec1ec$var$emit(contract, event, args, payloadFunc) {
    try {
        await $220158e9e9aec1ec$var$lastEmit;
    } catch (error) {}
    const resultPromise = $220158e9e9aec1ec$var$_emit(contract, event, args, payloadFunc);
    $220158e9e9aec1ec$var$lastEmit = resultPromise;
    return await resultPromise;
}
const $220158e9e9aec1ec$var$passProperties = [
    "then"
];
class $220158e9e9aec1ec$export$304faa4fc17528db {
    /**
     *  The target to connect to.
     *
     *  This can be an address, ENS name or any [[Addressable]], such as
     *  another contract. To get the resovled address, use the ``getAddress``
     *  method.
     */ target;
    /**
     *  The contract Interface.
     */ interface;
    /**
     *  The connected runner. This is generally a [[Provider]] or a
     *  [[Signer]], which dictates what operations are supported.
     *
     *  For example, a **Contract** connected to a [[Provider]] may
     *  only execute read-only operations.
     */ runner;
    /**
     *  All the Events available on this contract.
     */ filters;
    /**
     *  @_ignore:
     */ [$220158e9e9aec1ec$var$internal];
    /**
     *  The fallback or receive function if any.
     */ fallback;
    /**
     *  Creates a new contract connected to %%target%% with the %%abi%% and
     *  optionally connected to a %%runner%% to perform operations on behalf
     *  of.
     */ constructor(target, abi, runner, _deployTx){
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(typeof target === "string" || (0, $d6021cd5b8a26773$export$6a88e03bca5eb759)(target), "invalid value for Contract target", "target", target);
        if (runner == null) runner = null;
        const iface = (0, $3444a7590bebc852$export$48cefb51a4e315b2).from(abi);
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            target: target,
            runner: runner,
            interface: iface
        });
        Object.defineProperty(this, $220158e9e9aec1ec$var$internal, {
            value: {}
        });
        let addrPromise;
        let addr = null;
        let deployTx = null;
        if (_deployTx) {
            const provider = $220158e9e9aec1ec$var$getProvider(runner);
            // @TODO: the provider can be null; make a custom dummy provider that will throw a
            // meaningful error
            deployTx = new (0, $45b2f7a685545ecd$export$853f7e2df34220ff)(this.interface, provider, _deployTx);
        }
        let subs = new Map();
        // Resolve the target as the address
        if (typeof target === "string") {
            if ((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(target)) {
                addr = target;
                addrPromise = Promise.resolve(target);
            } else {
                const resolver = $220158e9e9aec1ec$var$getRunner(runner, "resolveName");
                if (!$220158e9e9aec1ec$var$canResolve(resolver)) throw (0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
                    operation: "resolveName"
                });
                addrPromise = resolver.resolveName(target).then((addr)=>{
                    if (addr == null) throw (0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("an ENS name used for a contract target must be correctly configured", "UNCONFIGURED_NAME", {
                        value: target
                    });
                    $220158e9e9aec1ec$var$getInternal(this).addr = addr;
                    return addr;
                });
            }
        } else addrPromise = target.getAddress().then((addr)=>{
            if (addr == null) throw new Error("TODO");
            $220158e9e9aec1ec$var$getInternal(this).addr = addr;
            return addr;
        });
        // Set our private values
        $220158e9e9aec1ec$var$setInternal(this, {
            addrPromise: addrPromise,
            addr: addr,
            deployTx: deployTx,
            subs: subs
        });
        // Add the event filters
        const filters = new Proxy({}, {
            get: (target, prop, receiver)=>{
                // Pass important checks (like `then` for Promise) through
                if (typeof prop === "symbol" || $220158e9e9aec1ec$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                try {
                    return this.getEvent(prop);
                } catch (error) {
                    if (!(0, $def55b050f09c63c$export$e6127cc7fe7395c3)(error, "INVALID_ARGUMENT") || error.argument !== "key") throw error;
                }
                return undefined;
            },
            has: (target, prop)=>{
                // Pass important checks (like `then` for Promise) through
                if ($220158e9e9aec1ec$var$passProperties.indexOf(prop) >= 0) return Reflect.has(target, prop);
                return Reflect.has(target, prop) || this.interface.hasEvent(String(prop));
            }
        });
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            filters: filters
        });
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            fallback: iface.receive || iface.fallback ? $220158e9e9aec1ec$var$buildWrappedFallback(this) : null
        });
        // Return a Proxy that will respond to functions
        return new Proxy(this, {
            get: (target, prop, receiver)=>{
                if (typeof prop === "symbol" || prop in target || $220158e9e9aec1ec$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                // Undefined properties should return undefined
                try {
                    return target.getFunction(prop);
                } catch (error) {
                    if (!(0, $def55b050f09c63c$export$e6127cc7fe7395c3)(error, "INVALID_ARGUMENT") || error.argument !== "key") throw error;
                }
                return undefined;
            },
            has: (target, prop)=>{
                if (typeof prop === "symbol" || prop in target || $220158e9e9aec1ec$var$passProperties.indexOf(prop) >= 0) return Reflect.has(target, prop);
                return target.interface.hasFunction(prop);
            }
        });
    }
    /**
     *  Return a new Contract instance with the same target and ABI, but
     *  a different %%runner%%.
     */ connect(runner) {
        return new $220158e9e9aec1ec$export$304faa4fc17528db(this.target, this.interface, runner);
    }
    /**
     *  Return a new Contract instance with the same ABI and runner, but
     *  a different %%target%%.
     */ attach(target) {
        return new $220158e9e9aec1ec$export$304faa4fc17528db(target, this.interface, this.runner);
    }
    /**
     *  Return the resolved address of this Contract.
     */ async getAddress() {
        return await $220158e9e9aec1ec$var$getInternal(this).addrPromise;
    }
    /**
     *  Return the deployed bytecode or null if no bytecode is found.
     */ async getDeployedCode() {
        const provider = $220158e9e9aec1ec$var$getProvider(this.runner);
        (0, $def55b050f09c63c$export$a7a9523472993e97)(provider, "runner does not support .provider", "UNSUPPORTED_OPERATION", {
            operation: "getDeployedCode"
        });
        const code = await provider.getCode(await this.getAddress());
        if (code === "0x") return null;
        return code;
    }
    /**
     *  Resolve to this Contract once the bytecode has been deployed, or
     *  resolve immediately if already deployed.
     */ async waitForDeployment() {
        // We have the deployement transaction; just use that (throws if deployement fails)
        const deployTx = this.deploymentTransaction();
        if (deployTx) {
            await deployTx.wait();
            return this;
        }
        // Check for code
        const code = await this.getDeployedCode();
        if (code != null) return this;
        // Make sure we can subscribe to a provider event
        const provider = $220158e9e9aec1ec$var$getProvider(this.runner);
        (0, $def55b050f09c63c$export$a7a9523472993e97)(provider != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", {
            operation: "waitForDeployment"
        });
        return new Promise((resolve, reject)=>{
            const checkCode = async ()=>{
                try {
                    const code = await this.getDeployedCode();
                    if (code != null) return resolve(this);
                    provider.once("block", checkCode);
                } catch (error) {
                    reject(error);
                }
            };
            checkCode();
        });
    }
    /**
     *  Return the transaction used to deploy this contract.
     *
     *  This is only available if this instance was returned from a
     *  [[ContractFactory]].
     */ deploymentTransaction() {
        return $220158e9e9aec1ec$var$getInternal(this).deployTx;
    }
    /**
     *  Return the function for a given name. This is useful when a contract
     *  method name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */ getFunction(key) {
        if (typeof key !== "string") key = key.format();
        const func = $220158e9e9aec1ec$var$buildWrappedMethod(this, key);
        return func;
    }
    /**
     *  Return the event for a given name. This is useful when a contract
     *  event name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */ getEvent(key) {
        if (typeof key !== "string") key = key.format();
        return $220158e9e9aec1ec$var$buildWrappedEvent(this, key);
    }
    /**
     *  @_ignore:
     */ async queryTransaction(hash) {
        throw new Error("@TODO");
    }
    /*
    // @TODO: this is a non-backwards compatible change, but will be added
    //        in v7 and in a potential SmartContract class in an upcoming
    //        v6 release
    async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
        const provider = getProvider(this.runner);
        assert(provider, "contract runner does not have a provider",
            "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });

        const receipt = await provider.getTransactionReceipt(hash);
        if (receipt == null) { return null; }

        return new ContractTransactionReceipt(this.interface, provider, receipt);
    }
    */ /**
     *  Provide historic access to event data for %%event%% in the range
     *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
     *  inclusive.
     */ async queryFilter(event, fromBlock, toBlock) {
        if (fromBlock == null) fromBlock = 0;
        if (toBlock == null) toBlock = "latest";
        const { addr: addr, addrPromise: addrPromise } = $220158e9e9aec1ec$var$getInternal(this);
        const address = addr ? addr : await addrPromise;
        const { fragment: fragment, topics: topics } = await $220158e9e9aec1ec$var$getSubInfo(this, event);
        const filter = {
            address: address,
            topics: topics,
            fromBlock: fromBlock,
            toBlock: toBlock
        };
        const provider = $220158e9e9aec1ec$var$getProvider(this.runner);
        (0, $def55b050f09c63c$export$a7a9523472993e97)(provider, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", {
            operation: "queryFilter"
        });
        return (await provider.getLogs(filter)).map((log)=>{
            let foundFragment = fragment;
            if (foundFragment == null) try {
                foundFragment = this.interface.getEvent(log.topics[0]);
            } catch (error) {}
            if (foundFragment) try {
                return new (0, $45b2f7a685545ecd$export$f8203d08df5cd081)(log, this.interface, foundFragment);
            } catch (error) {
                return new (0, $45b2f7a685545ecd$export$53f6e6acc02bf489)(log, error);
            }
            return new (0, $daa40c4afcf2fddc$export$ce30dbb46644d06c)(log, provider);
        });
    }
    /**
     *  Add an event %%listener%% for the %%event%%.
     */ async on(event, listener) {
        const sub = await $220158e9e9aec1ec$var$getSub(this, "on", event);
        sub.listeners.push({
            listener: listener,
            once: false
        });
        sub.start();
        return this;
    }
    /**
     *  Add an event %%listener%% for the %%event%%, but remove the listener
     *  after it is fired once.
     */ async once(event, listener) {
        const sub = await $220158e9e9aec1ec$var$getSub(this, "once", event);
        sub.listeners.push({
            listener: listener,
            once: true
        });
        sub.start();
        return this;
    }
    /**
     *  Emit an %%event%% calling all listeners with %%args%%.
     *
     *  Resolves to ``true`` if any listeners were called.
     */ async emit(event, ...args) {
        return await $220158e9e9aec1ec$var$emit(this, event, args, null);
    }
    /**
     *  Resolves to the number of listeners of %%event%% or the total number
     *  of listeners if unspecified.
     */ async listenerCount(event) {
        if (event) {
            const sub = await $220158e9e9aec1ec$var$hasSub(this, event);
            if (!sub) return 0;
            return sub.listeners.length;
        }
        const { subs: subs } = $220158e9e9aec1ec$var$getInternal(this);
        let total = 0;
        for (const { listeners: listeners } of subs.values())total += listeners.length;
        return total;
    }
    /**
     *  Resolves to the listeners subscribed to %%event%% or all listeners
     *  if unspecified.
     */ async listeners(event) {
        if (event) {
            const sub = await $220158e9e9aec1ec$var$hasSub(this, event);
            if (!sub) return [];
            return sub.listeners.map(({ listener: listener })=>listener);
        }
        const { subs: subs } = $220158e9e9aec1ec$var$getInternal(this);
        let result = [];
        for (const { listeners: listeners } of subs.values())result = result.concat(listeners.map(({ listener: listener })=>listener));
        return result;
    }
    /**
     *  Remove the %%listener%% from the listeners for %%event%% or remove
     *  all listeners if unspecified.
     */ async off(event, listener) {
        const sub = await $220158e9e9aec1ec$var$hasSub(this, event);
        if (!sub) return this;
        if (listener) {
            const index = sub.listeners.map(({ listener: listener })=>listener).indexOf(listener);
            if (index >= 0) sub.listeners.splice(index, 1);
        }
        if (listener == null || sub.listeners.length === 0) {
            sub.stop();
            $220158e9e9aec1ec$var$getInternal(this).subs.delete(sub.tag);
        }
        return this;
    }
    /**
     *  Remove all the listeners for %%event%% or remove all listeners if
     *  unspecified.
     */ async removeAllListeners(event) {
        if (event) {
            const sub = await $220158e9e9aec1ec$var$hasSub(this, event);
            if (!sub) return this;
            sub.stop();
            $220158e9e9aec1ec$var$getInternal(this).subs.delete(sub.tag);
        } else {
            const { subs: subs } = $220158e9e9aec1ec$var$getInternal(this);
            for (const { tag: tag, stop: stop } of subs.values()){
                stop();
                subs.delete(tag);
            }
        }
        return this;
    }
    /**
     *  Alias for [on].
     */ async addListener(event, listener) {
        return await this.on(event, listener);
    }
    /**
     *  Alias for [off].
     */ async removeListener(event, listener) {
        return await this.off(event, listener);
    }
    /**
     *  Create a new Class for the %%abi%%.
     */ static buildClass(abi) {
        class CustomContract extends $220158e9e9aec1ec$export$304faa4fc17528db {
            constructor(address, runner = null){
                super(address, abi, runner);
            }
        }
        return CustomContract;
    }
    /**
     *  Create a new BaseContract with a specified Interface.
     */ static from(target, abi, runner) {
        if (runner == null) runner = null;
        const contract = new this(target, abi, runner);
        return contract;
    }
}
function $220158e9e9aec1ec$var$_ContractBase() {
    return $220158e9e9aec1ec$export$304faa4fc17528db;
}
class $220158e9e9aec1ec$export$8517d80acf00e19a extends $220158e9e9aec1ec$var$_ContractBase() {
}




// created 2023-09-25T01:01:55.148Z
// compressed base64-encoded blob for include-ens data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: 0565ed049b9cf1614bb9e11ba7d8ac6a6fb96c893253d890f7e2b2884b9ded32
var $6ed0d31e8caec1a4$var$COMPRESSED$1 = "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";
const $6ed0d31e8caec1a4$var$FENCED = new Map([
    [
        8217,
        "apostrophe"
    ],
    [
        8260,
        "fraction slash"
    ],
    [
        12539,
        "middle dot"
    ]
]);
const $6ed0d31e8caec1a4$var$NSM_MAX = 4;
function $6ed0d31e8caec1a4$var$decode_arithmetic(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = 2 ** N;
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
// returns an iterator which returns the next symbol
function $6ed0d31e8caec1a4$var$read_payload(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function $6ed0d31e8caec1a4$var$read_compressed_payload(s) {
    return $6ed0d31e8caec1a4$var$read_payload($6ed0d31e8caec1a4$var$decode_arithmetic($6ed0d31e8caec1a4$var$unsafe_atob(s)));
}
// unsafe in the sense:
// expected well-formed Base64 w/o padding 
// 20220922: added for https://github.com/adraffy/ens-normalize.js/issues/4
function $6ed0d31e8caec1a4$var$unsafe_atob(s) {
    let lookup = [];
    [
        ..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
    ].forEach((c, i)=>lookup[c.charCodeAt(0)] = i);
    let n = s.length;
    let ret = new Uint8Array(6 * n >> 3);
    for(let i = 0, pos = 0, width = 0, carry = 0; i < n; i++){
        carry = carry << 6 | lookup[s.charCodeAt(i)];
        width += 6;
        if (width >= 8) ret[pos++] = carry >> (width -= 8);
    }
    return ret;
}
// eg. [0,1,2,3...] => [0,-1,1,-2,...]
function $6ed0d31e8caec1a4$var$signed(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $6ed0d31e8caec1a4$var$read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += $6ed0d31e8caec1a4$var$signed(next());
    return v;
}
// [123][5] => [0 3] [1 1] [0 0]
function $6ed0d31e8caec1a4$var$read_sorted(next, prev = 0) {
    let ret = [];
    while(true){
        let x = next();
        let n = next();
        if (!n) break;
        prev += x;
        for(let i = 0; i < n; i++)ret.push(prev + i);
        prev += n + 1;
    }
    return ret;
}
function $6ed0d31e8caec1a4$var$read_sorted_arrays(next) {
    return $6ed0d31e8caec1a4$var$read_array_while(()=>{
        let v = $6ed0d31e8caec1a4$var$read_sorted(next);
        if (v.length) return v;
    });
}
// returns map of x => ys
function $6ed0d31e8caec1a4$var$read_mapped(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push($6ed0d31e8caec1a4$var$read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push($6ed0d31e8caec1a4$var$read_replacement_table(w, next));
    }
    return ret.flat();
}
// read until next is falsy
// return array of read values
function $6ed0d31e8caec1a4$var$read_array_while(next) {
    let v = [];
    while(true){
        let x = next(v.length);
        if (!x) break;
        v.push(x);
    }
    return v;
}
// read w columns of length n
// return as n rows of length w
function $6ed0d31e8caec1a4$var$read_transposed(n, w, next) {
    let m = Array(n).fill().map(()=>[]);
    for(let i = 0; i < w; i++)$6ed0d31e8caec1a4$var$read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
// returns [[x, ys], [x+dx, ys+dy], [x+2*dx, ys+2*dy], ...]
// where dx/dy = steps, n = run size, w = length of y
function $6ed0d31e8caec1a4$var$read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = $6ed0d31e8caec1a4$var$read_array_while(next);
    let m = $6ed0d31e8caec1a4$var$read_transposed(vN.length, 1 + w, next);
    return m.flatMap((v, i)=>{
        let [x, ...ys] = v;
        return Array(vN[i]).fill().map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    });
}
// return [[x, ys...], ...]
// where w = length of y
function $6ed0d31e8caec1a4$var$read_replacement_table(w, next) {
    let n = 1 + next();
    let m = $6ed0d31e8caec1a4$var$read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
function $6ed0d31e8caec1a4$var$read_trie(next) {
    let ret = [];
    let sorted = $6ed0d31e8caec1a4$var$read_sorted(next);
    expand(decode([]), []);
    return ret; // not sorted
    function decode(Q) {
        let S = next(); // state: valid, save, check
        let B = $6ed0d31e8caec1a4$var$read_array_while(()=>{
            let cps = $6ed0d31e8caec1a4$var$read_sorted(next).map((i)=>sorted[i]);
            if (cps.length) return decode(cps);
        });
        return {
            S: S,
            B: B,
            Q: Q
        };
    }
    function expand({ S: S, B: B }, cps, saved) {
        if (S & 4 && saved === cps[cps.length - 1]) return;
        if (S & 2) saved = cps[cps.length - 1];
        if (S & 1) ret.push(cps);
        for (let br of B)for (let cp of br.Q)expand(br, [
            ...cps,
            cp
        ], saved);
    }
}
function $6ed0d31e8caec1a4$var$hex_cp(cp) {
    return cp.toString(16).toUpperCase().padStart(2, "0");
}
function $6ed0d31e8caec1a4$var$quote_cp(cp) {
    return `{${$6ed0d31e8caec1a4$var$hex_cp(cp)}}`; // raffy convention: like "\u{X}" w/o the "\u"
}
/*
export function explode_cp(s) {
	return [...s].map(c => c.codePointAt(0));
}
*/ function $6ed0d31e8caec1a4$var$explode_cp(s) {
    let cps = [];
    for(let pos = 0, len = s.length; pos < len;){
        let cp = s.codePointAt(pos);
        pos += cp < 0x10000 ? 1 : 2;
        cps.push(cp);
    }
    return cps;
}
function $6ed0d31e8caec1a4$var$str_from_cps(cps) {
    const chunk = 4096;
    let len = cps.length;
    if (len < chunk) return String.fromCodePoint(...cps);
    let buf = [];
    for(let i = 0; i < len;)buf.push(String.fromCodePoint(...cps.slice(i, i += chunk)));
    return buf.join("");
}
function $6ed0d31e8caec1a4$var$compare_arrays(a, b) {
    let n = a.length;
    let c = n - b.length;
    for(let i = 0; c == 0 && i < n; i++)c = a[i] - b[i];
    return c;
}
// created 2023-09-25T01:01:55.148Z
// compressed base64-encoded blob for include-nf data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: a974b6f8541fc29d919bc85118af0a44015851fab5343f8679cb31be2bdb209e
var $6ed0d31e8caec1a4$var$COMPRESSED = "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";
// https://unicode.org/reports/tr15/
// for reference implementation
// see: /derive/nf.js
// algorithmic hangul
// https://www.unicode.org/versions/Unicode15.0.0/ch03.pdf (page 144)
const $6ed0d31e8caec1a4$var$S0 = 0xAC00;
const $6ed0d31e8caec1a4$var$L0 = 0x1100;
const $6ed0d31e8caec1a4$var$V0 = 0x1161;
const $6ed0d31e8caec1a4$var$T0 = 0x11A7;
const $6ed0d31e8caec1a4$var$L_COUNT = 19;
const $6ed0d31e8caec1a4$var$V_COUNT = 21;
const $6ed0d31e8caec1a4$var$T_COUNT = 28;
const $6ed0d31e8caec1a4$var$N_COUNT = $6ed0d31e8caec1a4$var$V_COUNT * $6ed0d31e8caec1a4$var$T_COUNT;
const $6ed0d31e8caec1a4$var$S_COUNT = $6ed0d31e8caec1a4$var$L_COUNT * $6ed0d31e8caec1a4$var$N_COUNT;
const $6ed0d31e8caec1a4$var$S1 = $6ed0d31e8caec1a4$var$S0 + $6ed0d31e8caec1a4$var$S_COUNT;
const $6ed0d31e8caec1a4$var$L1 = $6ed0d31e8caec1a4$var$L0 + $6ed0d31e8caec1a4$var$L_COUNT;
const $6ed0d31e8caec1a4$var$V1 = $6ed0d31e8caec1a4$var$V0 + $6ed0d31e8caec1a4$var$V_COUNT;
const $6ed0d31e8caec1a4$var$T1 = $6ed0d31e8caec1a4$var$T0 + $6ed0d31e8caec1a4$var$T_COUNT;
function $6ed0d31e8caec1a4$var$unpack_cc(packed) {
    return packed >> 24 & 0xFF;
}
function $6ed0d31e8caec1a4$var$unpack_cp(packed) {
    return packed & 0xFFFFFF;
}
let $6ed0d31e8caec1a4$var$SHIFTED_RANK, $6ed0d31e8caec1a4$var$EXCLUSIONS, $6ed0d31e8caec1a4$var$DECOMP, $6ed0d31e8caec1a4$var$RECOMP;
function $6ed0d31e8caec1a4$var$init$1() {
    //console.time('nf');
    let r = $6ed0d31e8caec1a4$var$read_compressed_payload($6ed0d31e8caec1a4$var$COMPRESSED);
    $6ed0d31e8caec1a4$var$SHIFTED_RANK = new Map($6ed0d31e8caec1a4$var$read_sorted_arrays(r).flatMap((v, i)=>v.map((x)=>[
                x,
                i + 1 << 24
            ]))); // pre-shifted
    $6ed0d31e8caec1a4$var$EXCLUSIONS = new Set($6ed0d31e8caec1a4$var$read_sorted(r));
    $6ed0d31e8caec1a4$var$DECOMP = new Map();
    $6ed0d31e8caec1a4$var$RECOMP = new Map();
    for (let [cp, cps] of $6ed0d31e8caec1a4$var$read_mapped(r)){
        if (!$6ed0d31e8caec1a4$var$EXCLUSIONS.has(cp) && cps.length == 2) {
            let [a, b] = cps;
            let bucket = $6ed0d31e8caec1a4$var$RECOMP.get(a);
            if (!bucket) {
                bucket = new Map();
                $6ed0d31e8caec1a4$var$RECOMP.set(a, bucket);
            }
            bucket.set(b, cp);
        }
        $6ed0d31e8caec1a4$var$DECOMP.set(cp, cps.reverse()); // stored reversed
    }
//console.timeEnd('nf');
// 20230905: 11ms
}
function $6ed0d31e8caec1a4$var$is_hangul(cp) {
    return cp >= $6ed0d31e8caec1a4$var$S0 && cp < $6ed0d31e8caec1a4$var$S1;
}
function $6ed0d31e8caec1a4$var$compose_pair(a, b) {
    if (a >= $6ed0d31e8caec1a4$var$L0 && a < $6ed0d31e8caec1a4$var$L1 && b >= $6ed0d31e8caec1a4$var$V0 && b < $6ed0d31e8caec1a4$var$V1) return $6ed0d31e8caec1a4$var$S0 + (a - $6ed0d31e8caec1a4$var$L0) * $6ed0d31e8caec1a4$var$N_COUNT + (b - $6ed0d31e8caec1a4$var$V0) * $6ed0d31e8caec1a4$var$T_COUNT;
    else if ($6ed0d31e8caec1a4$var$is_hangul(a) && b > $6ed0d31e8caec1a4$var$T0 && b < $6ed0d31e8caec1a4$var$T1 && (a - $6ed0d31e8caec1a4$var$S0) % $6ed0d31e8caec1a4$var$T_COUNT == 0) return a + (b - $6ed0d31e8caec1a4$var$T0);
    else {
        let recomp = $6ed0d31e8caec1a4$var$RECOMP.get(a);
        if (recomp) {
            recomp = recomp.get(b);
            if (recomp) return recomp;
        }
        return -1;
    }
}
function $6ed0d31e8caec1a4$var$decomposed(cps) {
    if (!$6ed0d31e8caec1a4$var$SHIFTED_RANK) $6ed0d31e8caec1a4$var$init$1();
    let ret = [];
    let buf = [];
    let check_order = false;
    function add(cp) {
        let cc = $6ed0d31e8caec1a4$var$SHIFTED_RANK.get(cp);
        if (cc) {
            check_order = true;
            cp |= cc;
        }
        ret.push(cp);
    }
    for (let cp of cps)while(true){
        if (cp < 0x80) ret.push(cp);
        else if ($6ed0d31e8caec1a4$var$is_hangul(cp)) {
            let s_index = cp - $6ed0d31e8caec1a4$var$S0;
            let l_index = s_index / $6ed0d31e8caec1a4$var$N_COUNT | 0;
            let v_index = s_index % $6ed0d31e8caec1a4$var$N_COUNT / $6ed0d31e8caec1a4$var$T_COUNT | 0;
            let t_index = s_index % $6ed0d31e8caec1a4$var$T_COUNT;
            add($6ed0d31e8caec1a4$var$L0 + l_index);
            add($6ed0d31e8caec1a4$var$V0 + v_index);
            if (t_index > 0) add($6ed0d31e8caec1a4$var$T0 + t_index);
        } else {
            let mapped = $6ed0d31e8caec1a4$var$DECOMP.get(cp);
            if (mapped) buf.push(...mapped);
            else add(cp);
        }
        if (!buf.length) break;
        cp = buf.pop();
    }
    if (check_order && ret.length > 1) {
        let prev_cc = $6ed0d31e8caec1a4$var$unpack_cc(ret[0]);
        for(let i = 1; i < ret.length; i++){
            let cc = $6ed0d31e8caec1a4$var$unpack_cc(ret[i]);
            if (cc == 0 || prev_cc <= cc) {
                prev_cc = cc;
                continue;
            }
            let j = i - 1;
            while(true){
                let tmp = ret[j + 1];
                ret[j + 1] = ret[j];
                ret[j] = tmp;
                if (!j) break;
                prev_cc = $6ed0d31e8caec1a4$var$unpack_cc(ret[--j]);
                if (prev_cc <= cc) break;
            }
            prev_cc = $6ed0d31e8caec1a4$var$unpack_cc(ret[i]);
        }
    }
    return ret;
}
function $6ed0d31e8caec1a4$var$composed_from_decomposed(v) {
    let ret = [];
    let stack = [];
    let prev_cp = -1;
    let prev_cc = 0;
    for (let packed of v){
        let cc = $6ed0d31e8caec1a4$var$unpack_cc(packed);
        let cp = $6ed0d31e8caec1a4$var$unpack_cp(packed);
        if (prev_cp == -1) {
            if (cc == 0) prev_cp = cp;
            else ret.push(cp);
        } else if (prev_cc > 0 && prev_cc >= cc) {
            if (cc == 0) {
                ret.push(prev_cp, ...stack);
                stack.length = 0;
                prev_cp = cp;
            } else stack.push(cp);
            prev_cc = cc;
        } else {
            let composed = $6ed0d31e8caec1a4$var$compose_pair(prev_cp, cp);
            if (composed >= 0) prev_cp = composed;
            else if (prev_cc == 0 && cc == 0) {
                ret.push(prev_cp);
                prev_cp = cp;
            } else {
                stack.push(cp);
                prev_cc = cc;
            }
        }
    }
    if (prev_cp >= 0) ret.push(prev_cp, ...stack);
    return ret;
}
// note: cps can be iterable
function $6ed0d31e8caec1a4$export$9d0d896b286a3dba(cps) {
    return $6ed0d31e8caec1a4$var$decomposed(cps).map($6ed0d31e8caec1a4$var$unpack_cp);
}
function $6ed0d31e8caec1a4$export$f42252642e08449(cps) {
    return $6ed0d31e8caec1a4$var$composed_from_decomposed($6ed0d31e8caec1a4$var$decomposed(cps));
}
const $6ed0d31e8caec1a4$var$HYPHEN = 0x2D;
const $6ed0d31e8caec1a4$var$STOP = 0x2E;
const $6ed0d31e8caec1a4$var$STOP_CH = ".";
const $6ed0d31e8caec1a4$var$FE0F = 0xFE0F;
const $6ed0d31e8caec1a4$var$UNIQUE_PH = 1;
// 20230913: replace [...v] with Array_from(v) to avoid large spreads
const $6ed0d31e8caec1a4$var$Array_from = (x)=>Array.from(x); // Array.from.bind(Array);
function $6ed0d31e8caec1a4$var$group_has_cp(g, cp) {
    // 20230913: keep primary and secondary distinct instead of creating valid union
    return g.P.has(cp) || g.Q.has(cp);
}
class $6ed0d31e8caec1a4$var$Emoji extends Array {
    get is_emoji() {
        return true;
    }
}
let $6ed0d31e8caec1a4$var$MAPPED, $6ed0d31e8caec1a4$var$IGNORED, $6ed0d31e8caec1a4$var$CM, $6ed0d31e8caec1a4$var$NSM, $6ed0d31e8caec1a4$var$ESCAPE, $6ed0d31e8caec1a4$var$NFC_CHECK, $6ed0d31e8caec1a4$var$GROUPS, $6ed0d31e8caec1a4$var$WHOLE_VALID, $6ed0d31e8caec1a4$var$WHOLE_MAP, $6ed0d31e8caec1a4$var$VALID, $6ed0d31e8caec1a4$var$EMOJI_LIST, $6ed0d31e8caec1a4$var$EMOJI_ROOT;
function $6ed0d31e8caec1a4$var$init() {
    if ($6ed0d31e8caec1a4$var$MAPPED) return;
    let r = $6ed0d31e8caec1a4$var$read_compressed_payload($6ed0d31e8caec1a4$var$COMPRESSED$1);
    const read_sorted_array = ()=>$6ed0d31e8caec1a4$var$read_sorted(r);
    const read_sorted_set = ()=>new Set(read_sorted_array());
    const set_add_many = (set, v)=>v.forEach((x)=>set.add(x));
    $6ed0d31e8caec1a4$var$MAPPED = new Map($6ed0d31e8caec1a4$var$read_mapped(r));
    $6ed0d31e8caec1a4$var$IGNORED = read_sorted_set(); // ignored characters are not valid, so just read raw codepoints
    /*
	// direct include from payload is smaller than the decompression code
	const FENCED = new Map(read_array_while(() => {
		let cp = r();
		if (cp) return [cp, read_str(r())];
	}));
	*/ // 20230217: we still need all CM for proper error formatting
    // but norm only needs NSM subset that are potentially-valid
    $6ed0d31e8caec1a4$var$CM = read_sorted_array();
    $6ed0d31e8caec1a4$var$NSM = new Set(read_sorted_array().map((i)=>$6ed0d31e8caec1a4$var$CM[i]));
    $6ed0d31e8caec1a4$var$CM = new Set($6ed0d31e8caec1a4$var$CM);
    $6ed0d31e8caec1a4$var$ESCAPE = read_sorted_set(); // characters that should not be printed
    $6ed0d31e8caec1a4$var$NFC_CHECK = read_sorted_set(); // only needed to illustrate ens_tokenize() transformations
    let chunks = $6ed0d31e8caec1a4$var$read_sorted_arrays(r);
    let unrestricted = r();
    //const read_chunked = () => new Set(read_sorted_array().flatMap(i => chunks[i]).concat(read_sorted_array()));
    const read_chunked = ()=>{
        // 20230921: build set in parts, 2x faster
        let set = new Set();
        read_sorted_array().forEach((i)=>set_add_many(set, chunks[i]));
        set_add_many(set, read_sorted_array());
        return set;
    };
    $6ed0d31e8caec1a4$var$GROUPS = $6ed0d31e8caec1a4$var$read_array_while((i)=>{
        // minifier property mangling seems unsafe
        // so these are manually renamed to single chars
        let N = $6ed0d31e8caec1a4$var$read_array_while(r).map((x)=>x + 0x60);
        if (N.length) {
            let R = i >= unrestricted; // unrestricted then restricted
            N[0] -= 32; // capitalize
            N = $6ed0d31e8caec1a4$var$str_from_cps(N);
            if (R) N = `Restricted[${N}]`;
            let P = read_chunked(); // primary
            let Q = read_chunked(); // secondary
            let M = !r(); // not-whitelisted, check for NSM
            // *** this code currently isn't needed ***
            /*
			let V = [...P, ...Q].sort((a, b) => a-b); // derive: sorted valid
			let M = r()-1; // number of combining mark
			if (M < 0) { // whitelisted
				M = new Map(read_array_while(() => {
					let i = r();
					if (i) return [V[i-1], read_array_while(() => {
						let v = read_array_while(r);
						if (v.length) return v.map(x => x-1);
					})];
				}));
			}*/ return {
                N: N,
                P: P,
                Q: Q,
                M: M,
                R: R
            };
        }
    });
    // decode compressed wholes
    $6ed0d31e8caec1a4$var$WHOLE_VALID = read_sorted_set();
    $6ed0d31e8caec1a4$var$WHOLE_MAP = new Map();
    let wholes = read_sorted_array().concat($6ed0d31e8caec1a4$var$Array_from($6ed0d31e8caec1a4$var$WHOLE_VALID)).sort((a, b)=>a - b); // must be sorted
    wholes.forEach((cp, i)=>{
        let d = r();
        let w = wholes[i] = d ? wholes[i - d] : {
            V: [],
            M: new Map()
        };
        w.V.push(cp); // add to member set
        if (!$6ed0d31e8caec1a4$var$WHOLE_VALID.has(cp)) $6ed0d31e8caec1a4$var$WHOLE_MAP.set(cp, w); // register with whole map
    });
    // compute confusable-extent complements
    // usage: WHOLE_MAP.get(cp).M.get(cp) = complement set
    for (let { V: V, M: M } of new Set($6ed0d31e8caec1a4$var$WHOLE_MAP.values())){
        // connect all groups that have each whole character
        let recs = [];
        for (let cp of V){
            let gs = $6ed0d31e8caec1a4$var$GROUPS.filter((g)=>$6ed0d31e8caec1a4$var$group_has_cp(g, cp));
            let rec = recs.find(({ G: G })=>gs.some((g)=>G.has(g)));
            if (!rec) {
                rec = {
                    G: new Set(),
                    V: []
                };
                recs.push(rec);
            }
            rec.V.push(cp);
            set_add_many(rec.G, gs);
        }
        // per character cache groups which are not a member of the extent
        let union = recs.flatMap((x)=>$6ed0d31e8caec1a4$var$Array_from(x.G)); // all of the groups used by this whole
        for (let { G: G, V: V } of recs){
            let complement = new Set(union.filter((g)=>!G.has(g))); // groups not covered by the extent
            for (let cp of V)M.set(cp, complement); // this is the same reference
        }
    }
    // compute valid set
    // 20230924: VALID was union but can be re-used
    $6ed0d31e8caec1a4$var$VALID = new Set(); // exists in 1+ groups
    let multi = new Set(); // exists in 2+ groups
    const add_to_union = (cp)=>$6ed0d31e8caec1a4$var$VALID.has(cp) ? multi.add(cp) : $6ed0d31e8caec1a4$var$VALID.add(cp);
    for (let g of $6ed0d31e8caec1a4$var$GROUPS){
        for (let cp of g.P)add_to_union(cp);
        for (let cp of g.Q)add_to_union(cp);
    }
    // dual purpose WHOLE_MAP: return placeholder if unique non-confusable
    for (let cp of $6ed0d31e8caec1a4$var$VALID)if (!$6ed0d31e8caec1a4$var$WHOLE_MAP.has(cp) && !multi.has(cp)) $6ed0d31e8caec1a4$var$WHOLE_MAP.set(cp, $6ed0d31e8caec1a4$var$UNIQUE_PH);
    // add all decomposed parts
    // see derive: "Valid is Closed (via Brute-force)"
    set_add_many($6ed0d31e8caec1a4$var$VALID, $6ed0d31e8caec1a4$export$9d0d896b286a3dba($6ed0d31e8caec1a4$var$VALID));
    // decode emoji
    // 20230719: emoji are now fully-expanded to avoid quirk logic 
    $6ed0d31e8caec1a4$var$EMOJI_LIST = $6ed0d31e8caec1a4$var$read_trie(r).map((v)=>$6ed0d31e8caec1a4$var$Emoji.from(v)).sort($6ed0d31e8caec1a4$var$compare_arrays);
    $6ed0d31e8caec1a4$var$EMOJI_ROOT = new Map(); // this has approx 7K nodes (2+ per emoji)
    for (let cps of $6ed0d31e8caec1a4$var$EMOJI_LIST){
        // 20230719: change to *slightly* stricter algorithm which disallows 
        // insertion of misplaced FE0F in emoji sequences (matching ENSIP-15)
        // example: beautified [A B] (eg. flag emoji) 
        //  before: allow: [A FE0F B], error: [A FE0F FE0F B] 
        //   after: error: both
        // note: this code now matches ENSNormalize.{cs,java} logic
        let prev = [
            $6ed0d31e8caec1a4$var$EMOJI_ROOT
        ];
        for (let cp of cps){
            let next = prev.map((node)=>{
                let child = node.get(cp);
                if (!child) {
                    // should this be object? 
                    // (most have 1-2 items, few have many)
                    // 20230719: no, v8 default map is 4?
                    child = new Map();
                    node.set(cp, child);
                }
                return child;
            });
            if (cp === $6ed0d31e8caec1a4$var$FE0F) prev.push(...next); // less than 20 elements
            else prev = next;
        }
        for (let x of prev)x.V = cps;
    }
}
// if escaped: {HEX}
//       else: "x" {HEX}
function $6ed0d31e8caec1a4$var$quoted_cp(cp) {
    return ($6ed0d31e8caec1a4$export$4b1c9c18c687e5e9(cp) ? "" : `${$6ed0d31e8caec1a4$var$bidi_qq($6ed0d31e8caec1a4$export$6ec6f9a7f89f00db([
        cp
    ]))} `) + $6ed0d31e8caec1a4$var$quote_cp(cp);
}
// 20230211: some messages can be mixed-directional and result in spillover
// use 200E after a quoted string to force the remainder of a string from 
// acquring the direction of the quote
// https://www.w3.org/International/questions/qa-bidi-unicode-controls#exceptions
function $6ed0d31e8caec1a4$var$bidi_qq(s) {
    return `"${s}"\u200E`; // strong LTR
}
function $6ed0d31e8caec1a4$var$check_label_extension(cps) {
    if (cps.length >= 4 && cps[2] == $6ed0d31e8caec1a4$var$HYPHEN && cps[3] == $6ed0d31e8caec1a4$var$HYPHEN) throw new Error(`invalid label extension: "${$6ed0d31e8caec1a4$var$str_from_cps(cps.slice(0, 4))}"`); // this can only be ascii so cant be bidi
}
function $6ed0d31e8caec1a4$var$check_leading_underscore(cps) {
    const UNDERSCORE = 0x5F;
    for(let i = cps.lastIndexOf(UNDERSCORE); i > 0;){
        if (cps[--i] !== UNDERSCORE) throw new Error("underscore allowed only at start");
    }
}
// check that a fenced cp is not leading, trailing, or touching another fenced cp
function $6ed0d31e8caec1a4$var$check_fenced(cps) {
    let cp = cps[0];
    let prev = $6ed0d31e8caec1a4$var$FENCED.get(cp);
    if (prev) throw $6ed0d31e8caec1a4$var$error_placement(`leading ${prev}`);
    let n = cps.length;
    let last = -1; // prevents trailing from throwing
    for(let i = 1; i < n; i++){
        cp = cps[i];
        let match = $6ed0d31e8caec1a4$var$FENCED.get(cp);
        if (match) {
            // since cps[0] isn't fenced, cps[1] cannot throw
            if (last == i) throw $6ed0d31e8caec1a4$var$error_placement(`${prev} + ${match}`);
            last = i + 1;
            prev = match;
        }
    }
    if (last == n) throw $6ed0d31e8caec1a4$var$error_placement(`trailing ${prev}`);
}
// create a safe to print string 
// invisibles are escaped
// leading cm uses placeholder
// if cps exceed max, middle truncate with ellipsis
// quoter(cp) => string, eg. 3000 => "{3000}"
// note: in html, you'd call this function then replace [<>&] with entities
function $6ed0d31e8caec1a4$export$6ec6f9a7f89f00db(cps, max = Infinity, quoter = $6ed0d31e8caec1a4$var$quote_cp) {
    //if (Number.isInteger(cps)) cps = [cps];
    //if (!Array.isArray(cps)) throw new TypeError(`expected codepoints`);
    let buf = [];
    if ($6ed0d31e8caec1a4$export$e29a9e4d2573411c(cps[0])) buf.push("\u25CC");
    if (cps.length > max) {
        max >>= 1;
        cps = [
            ...cps.slice(0, max),
            0x2026,
            ...cps.slice(-max)
        ];
    }
    let prev = 0;
    let n = cps.length;
    for(let i = 0; i < n; i++){
        let cp = cps[i];
        if ($6ed0d31e8caec1a4$export$4b1c9c18c687e5e9(cp)) {
            buf.push($6ed0d31e8caec1a4$var$str_from_cps(cps.slice(prev, i)));
            buf.push(quoter(cp));
            prev = i + 1;
        }
    }
    buf.push($6ed0d31e8caec1a4$var$str_from_cps(cps.slice(prev, n)));
    return buf.join("");
}
// note: set(s) cannot be exposed because they can be modified
// note: Object.freeze() doesn't work
function $6ed0d31e8caec1a4$export$e29a9e4d2573411c(cp) {
    $6ed0d31e8caec1a4$var$init();
    return $6ed0d31e8caec1a4$var$CM.has(cp);
}
function $6ed0d31e8caec1a4$export$4b1c9c18c687e5e9(cp) {
    $6ed0d31e8caec1a4$var$init();
    return $6ed0d31e8caec1a4$var$ESCAPE.has(cp);
}
// return all supported emoji as fully-qualified emoji 
// ordered by length then lexicographic 
function $6ed0d31e8caec1a4$export$95d5ea4de7964366() {
    $6ed0d31e8caec1a4$var$init();
    return $6ed0d31e8caec1a4$var$EMOJI_LIST.map((x)=>x.slice()); // emoji are exposed so copy
}
function $6ed0d31e8caec1a4$export$f4e6b2721065fb3d(frag, decompose) {
    $6ed0d31e8caec1a4$var$init();
    let nf = decompose ? $6ed0d31e8caec1a4$export$9d0d896b286a3dba : $6ed0d31e8caec1a4$export$f42252642e08449;
    return frag.split($6ed0d31e8caec1a4$var$STOP_CH).map((label)=>$6ed0d31e8caec1a4$var$str_from_cps($6ed0d31e8caec1a4$var$tokens_from_str($6ed0d31e8caec1a4$var$explode_cp(label), nf, $6ed0d31e8caec1a4$var$filter_fe0f).flat())).join($6ed0d31e8caec1a4$var$STOP_CH);
}
function $6ed0d31e8caec1a4$export$499f715881831a51(name) {
    return $6ed0d31e8caec1a4$var$flatten($6ed0d31e8caec1a4$var$split(name, $6ed0d31e8caec1a4$export$f42252642e08449, $6ed0d31e8caec1a4$var$filter_fe0f));
}
function $6ed0d31e8caec1a4$export$d2ee080f6ab2341d(name) {
    let labels = $6ed0d31e8caec1a4$var$split(name, $6ed0d31e8caec1a4$export$f42252642e08449, (x)=>x); // emoji not exposed
    for (let { type: type, output: output, error: error } of labels){
        if (error) break; // flatten will throw
        // replace leading/trailing hyphen
        // 20230121: consider beautifing all or leading/trailing hyphen to unicode variant
        // not exactly the same in every font, but very similar: "-" vs "‐"
        /*
		const UNICODE_HYPHEN = 0x2010;
		// maybe this should replace all for visual consistancy?
		// `node tools/reg-count.js regex ^-\{2,\}` => 592
		//for (let i = 0; i < output.length; i++) if (output[i] == 0x2D) output[i] = 0x2010;
		if (output[0] == HYPHEN) output[0] = UNICODE_HYPHEN;
		let end = output.length-1;
		if (output[end] == HYPHEN) output[end] = UNICODE_HYPHEN;
		*/ // 20230123: WHATWG URL uses "CheckHyphens" false
        // https://url.spec.whatwg.org/#idna
        // update ethereum symbol
        // ξ => Ξ if not greek
        if (type !== "Greek") $6ed0d31e8caec1a4$var$array_replace(output, 0x3BE, 0x39E);
    // 20221213: fixes bidi subdomain issue, but breaks invariant (200E is disallowed)
    // could be fixed with special case for: 2D (.) + 200E (LTR)
    // https://discuss.ens.domains/t/bidi-label-ordering-spoof/15824
    //output.splice(0, 0, 0x200E);
    }
    return $6ed0d31e8caec1a4$var$flatten(labels);
}
function $6ed0d31e8caec1a4$var$array_replace(v, a, b) {
    let prev = 0;
    while(true){
        let next = v.indexOf(a, prev);
        if (next < 0) break;
        v[next] = b;
        prev = next + 1;
    }
}
function $6ed0d31e8caec1a4$export$d2ba335951b08421(name, preserve_emoji) {
    return $6ed0d31e8caec1a4$var$split(name, $6ed0d31e8caec1a4$export$f42252642e08449, preserve_emoji ? (x)=>x.slice() : $6ed0d31e8caec1a4$var$filter_fe0f); // emoji are exposed so copy
}
function $6ed0d31e8caec1a4$var$split(name, nf, ef) {
    if (!name) return []; // 20230719: empty name allowance
    $6ed0d31e8caec1a4$var$init();
    let offset = 0;
    // https://unicode.org/reports/tr46/#Validity_Criteria
    // 4.) "The label must not contain a U+002E ( . ) FULL STOP."
    return name.split($6ed0d31e8caec1a4$var$STOP_CH).map((label)=>{
        let input = $6ed0d31e8caec1a4$var$explode_cp(label);
        let info = {
            input: input,
            offset: offset
        };
        offset += input.length + 1; // + stop
        try {
            // 1.) "The label must be in Unicode Normalization Form NFC"
            let tokens = info.tokens = $6ed0d31e8caec1a4$var$tokens_from_str(input, nf, ef);
            let token_count = tokens.length;
            let type;
            if (!token_count) //norm = [];
            //type = 'None'; // use this instead of next match, "ASCII"
            // 20230120: change to strict
            // https://discuss.ens.domains/t/ens-name-normalization-2nd/14564/59
            throw new Error(`empty label`);
            let norm = info.output = tokens.flat();
            $6ed0d31e8caec1a4$var$check_leading_underscore(norm);
            let emoji = info.emoji = token_count > 1 || tokens[0].is_emoji; // same as: tokens.some(x => x.is_emoji);
            if (!emoji && norm.every((cp)=>cp < 0x80)) {
                // 20230123: matches matches WHATWG, see note 3.3
                $6ed0d31e8caec1a4$var$check_label_extension(norm); // only needed for ascii
                // cant have fenced
                // cant have cm
                // cant have wholes
                // see derive: "Fastpath ASCII"
                type = "ASCII";
            } else {
                let chars = tokens.flatMap((x)=>x.is_emoji ? [] : x); // all of the nfc tokens concat together
                if (!chars.length) type = "Emoji";
                else {
                    // 5.) "The label must not begin with a combining mark, that is: General_Category=Mark."
                    if ($6ed0d31e8caec1a4$var$CM.has(norm[0])) throw $6ed0d31e8caec1a4$var$error_placement("leading combining mark");
                    for(let i = 1; i < token_count; i++){
                        let cps = tokens[i];
                        if (!cps.is_emoji && $6ed0d31e8caec1a4$var$CM.has(cps[0])) // bidi_qq() not needed since emoji is LTR and cps is a CM
                        throw $6ed0d31e8caec1a4$var$error_placement(`emoji + combining mark: "${$6ed0d31e8caec1a4$var$str_from_cps(tokens[i - 1])} + ${$6ed0d31e8caec1a4$export$6ec6f9a7f89f00db([
                            cps[0]
                        ])}"`);
                    }
                    $6ed0d31e8caec1a4$var$check_fenced(norm);
                    let unique = $6ed0d31e8caec1a4$var$Array_from(new Set(chars));
                    let [g] = $6ed0d31e8caec1a4$var$determine_group(unique); // take the first match
                    // see derive: "Matching Groups have Same CM Style"
                    // alternative: could form a hybrid type: Latin/Japanese/...	
                    $6ed0d31e8caec1a4$var$check_group(g, chars); // need text in order
                    $6ed0d31e8caec1a4$var$check_whole(g, unique); // only need unique text (order would be required for multiple-char confusables)
                    type = g.N;
                // 20230121: consider exposing restricted flag
                // it's simpler to just check for 'Restricted'
                // or even better: type.endsWith(']')
                //if (g.R) info.restricted = true;
                }
            }
            info.type = type;
        } catch (err) {
            info.error = err; // use full error object
        }
        return info;
    });
}
function $6ed0d31e8caec1a4$var$check_whole(group, unique) {
    let maker;
    let shared = [];
    for (let cp of unique){
        let whole = $6ed0d31e8caec1a4$var$WHOLE_MAP.get(cp);
        if (whole === $6ed0d31e8caec1a4$var$UNIQUE_PH) return; // unique, non-confusable
        if (whole) {
            let set = whole.M.get(cp); // groups which have a character that look-like this character
            maker = maker ? maker.filter((g)=>set.has(g)) : $6ed0d31e8caec1a4$var$Array_from(set);
            if (!maker.length) return; // confusable intersection is empty
        } else shared.push(cp);
    }
    if (maker) // we have 1+ confusable
    // check if any of the remaining groups
    // contain the shared characters too
    for (let g of maker){
        if (shared.every((cp)=>$6ed0d31e8caec1a4$var$group_has_cp(g, cp))) throw new Error(`whole-script confusable: ${group.N}/${g.N}`);
    }
}
// assumption: unique.size > 0
// returns list of matching groups
function $6ed0d31e8caec1a4$var$determine_group(unique) {
    let groups = $6ed0d31e8caec1a4$var$GROUPS;
    for (let cp of unique){
        // note: we need to dodge CM that are whitelisted
        // but that code isn't currently necessary
        let gs = groups.filter((g)=>$6ed0d31e8caec1a4$var$group_has_cp(g, cp));
        if (!gs.length) {
            if (!$6ed0d31e8caec1a4$var$GROUPS.some((g)=>$6ed0d31e8caec1a4$var$group_has_cp(g, cp))) // the character was composed of valid parts
            // but it's NFC form is invalid
            // 20230716: change to more exact statement, see: ENSNormalize.{cs,java}
            // note: this doesn't have to be a composition
            // 20230720: change to full check
            throw $6ed0d31e8caec1a4$var$error_disallowed(cp); // this should be rare
            else // there is no group that contains all these characters
            // throw using the highest priority group that matched
            // https://www.unicode.org/reports/tr39/#mixed_script_confusables
            throw $6ed0d31e8caec1a4$var$error_group_member(groups[0], cp);
        }
        groups = gs;
        if (gs.length == 1) break; // there is only one group left
    }
    // there are at least 1 group(s) with all of these characters
    return groups;
}
// throw on first error
function $6ed0d31e8caec1a4$var$flatten(split) {
    return split.map(({ input: input, error: error, output: output })=>{
        if (error) {
            // don't print label again if just a single label
            let msg = error.message;
            // bidi_qq() only necessary if msg is digits
            throw new Error(split.length == 1 ? msg : `Invalid label ${$6ed0d31e8caec1a4$var$bidi_qq($6ed0d31e8caec1a4$export$6ec6f9a7f89f00db(input, 63))}: ${msg}`);
        }
        return $6ed0d31e8caec1a4$var$str_from_cps(output);
    }).join($6ed0d31e8caec1a4$var$STOP_CH);
}
function $6ed0d31e8caec1a4$var$error_disallowed(cp) {
    // TODO: add cp to error?
    return new Error(`disallowed character: ${$6ed0d31e8caec1a4$var$quoted_cp(cp)}`);
}
function $6ed0d31e8caec1a4$var$error_group_member(g, cp) {
    let quoted = $6ed0d31e8caec1a4$var$quoted_cp(cp);
    let gg = $6ed0d31e8caec1a4$var$GROUPS.find((g)=>g.P.has(cp)); // only check primary
    if (gg) quoted = `${gg.N} ${quoted}`;
    return new Error(`illegal mixture: ${g.N} + ${quoted}`);
}
function $6ed0d31e8caec1a4$var$error_placement(where) {
    return new Error(`illegal placement: ${where}`);
}
// assumption: cps.length > 0
// assumption: cps[0] isn't a CM
// assumption: the previous character isn't an emoji
function $6ed0d31e8caec1a4$var$check_group(g, cps) {
    for (let cp of cps){
        if (!$6ed0d31e8caec1a4$var$group_has_cp(g, cp)) // for whitelisted scripts, this will throw illegal mixture on invalid cm, eg. "e{300}{300}"
        // at the moment, it's unnecessary to introduce an extra error type
        // until there exists a whitelisted multi-character
        //   eg. if (M < 0 && is_combining_mark(cp)) { ... }
        // there are 3 cases:
        //   1. illegal cm for wrong group => mixture error
        //   2. illegal cm for same group => cm error
        //       requires set of whitelist cm per group: 
        //        eg. new Set([...g.P, ...g.Q].flatMap(nfc).filter(cp => CM.has(cp)))
        //   3. wrong group => mixture error
        throw $6ed0d31e8caec1a4$var$error_group_member(g, cp);
    }
    //if (M >= 0) { // we have a known fixed cm count
    if (g.M) {
        let decomposed = $6ed0d31e8caec1a4$export$9d0d896b286a3dba(cps);
        for(let i = 1, e = decomposed.length; i < e; i++)// 20230210: bugfix: using cps instead of decomposed h/t Carbon225
        /*
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: ${g.N} ${bidi_qq(str_from_cps(decomposed.slice(i-1, j)))} (${j-i}/${M})`);
				}
				i = j;
			}
			*/ // 20230217: switch to NSM counting
        // https://www.unicode.org/reports/tr39/#Optional_Detection
        if ($6ed0d31e8caec1a4$var$NSM.has(decomposed[i])) {
            let j = i + 1;
            for(let cp; j < e && $6ed0d31e8caec1a4$var$NSM.has(cp = decomposed[j]); j++)// a. Forbid sequences of the same nonspacing mark.
            for(let k = i; k < j; k++){
                if (decomposed[k] == cp) throw new Error(`duplicate non-spacing marks: ${$6ed0d31e8caec1a4$var$quoted_cp(cp)}`);
            }
            // parse to end so we have full nsm count
            // b. Forbid sequences of more than 4 nonspacing marks (gc=Mn or gc=Me).
            if (j - i > $6ed0d31e8caec1a4$var$NSM_MAX) // note: this slice starts with a base char or spacing-mark cm
            throw new Error(`excessive non-spacing marks: ${$6ed0d31e8caec1a4$var$bidi_qq($6ed0d31e8caec1a4$export$6ec6f9a7f89f00db(decomposed.slice(i - 1, j)))} (${j - i}/${$6ed0d31e8caec1a4$var$NSM_MAX})`);
            i = j;
        }
    }
// *** this code currently isn't needed ***
/*
	let cm_whitelist = M instanceof Map;
	for (let i = 0, e = cps.length; i < e; ) {
		let cp = cps[i++];
		let seqs = cm_whitelist && M.get(cp);
		if (seqs) { 
			// list of codepoints that can follow
			// if this exists, this will always be 1+
			let j = i;
			while (j < e && CM.has(cps[j])) j++;
			let cms = cps.slice(i, j);
			let match = seqs.find(seq => !compare_arrays(seq, cms));
			if (!match) throw new Error(`disallowed combining mark sequence: "${safe_str_from_cps([cp, ...cms])}"`);
			i = j;
		} else if (!V.has(cp)) {
			// https://www.unicode.org/reports/tr39/#mixed_script_confusables
			let quoted = quoted_cp(cp);
			for (let cp of cps) {
				let u = UNIQUE.get(cp);
				if (u && u !== g) {
					// if both scripts are restricted this error is confusing
					// because we don't differentiate RestrictedA from RestrictedB 
					if (!u.R) quoted = `${quoted} is ${u.N}`;
					break;
				}
			}
			throw new Error(`disallowed ${g.N} character: ${quoted}`);
			//throw new Error(`disallowed character: ${quoted} (expected ${g.N})`);
			//throw new Error(`${g.N} does not allow: ${quoted}`);
		}
	}
	if (!cm_whitelist) {
		let decomposed = nfd(cps);
		for (let i = 1, e = decomposed.length; i < e; i++) { // we know it can't be cm leading
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: "${str_from_cps(decomposed.slice(i-1, j))}" (${j-i}/${M})`);
				}
				i = j;
			}
		}
	}
	*/ }
// given a list of codepoints
// returns a list of lists, where emoji are a fully-qualified (as Array subclass)
// eg. explode_cp("abc💩d") => [[61, 62, 63], Emoji[1F4A9, FE0F], [64]]
// 20230818: rename for 'process' name collision h/t Javarome
// https://github.com/adraffy/ens-normalize.js/issues/23
function $6ed0d31e8caec1a4$var$tokens_from_str(input, nf, ef) {
    let ret = [];
    let chars = [];
    input = input.slice().reverse(); // flip so we can pop
    while(input.length){
        let emoji = $6ed0d31e8caec1a4$var$consume_emoji_reversed(input);
        if (emoji) {
            if (chars.length) {
                ret.push(nf(chars));
                chars = [];
            }
            ret.push(ef(emoji));
        } else {
            let cp = input.pop();
            if ($6ed0d31e8caec1a4$var$VALID.has(cp)) chars.push(cp);
            else {
                let cps = $6ed0d31e8caec1a4$var$MAPPED.get(cp);
                if (cps) chars.push(...cps); // less than 10 elements
                else if (!$6ed0d31e8caec1a4$var$IGNORED.has(cp)) // 20230912: unicode 15.1 changed the order of processing such that
                // disallowed parts are only rejected after NFC
                // https://unicode.org/reports/tr46/#Validity_Criteria
                // this doesn't impact normalization as of today
                // technically, this error can be removed as the group logic will apply similar logic
                // however the error type might be less clear
                throw $6ed0d31e8caec1a4$var$error_disallowed(cp);
            }
        }
    }
    if (chars.length) ret.push(nf(chars));
    return ret;
}
function $6ed0d31e8caec1a4$var$filter_fe0f(cps) {
    return cps.filter((cp)=>cp != $6ed0d31e8caec1a4$var$FE0F);
}
// given array of codepoints
// returns the longest valid emoji sequence (or undefined if no match)
// *MUTATES* the supplied array
// disallows interleaved ignored characters
// fills (optional) eaten array with matched codepoints
function $6ed0d31e8caec1a4$var$consume_emoji_reversed(cps, eaten) {
    let node = $6ed0d31e8caec1a4$var$EMOJI_ROOT;
    let emoji;
    let pos = cps.length;
    while(pos){
        node = node.get(cps[--pos]);
        if (!node) break;
        let { V: V } = node;
        if (V) {
            emoji = V;
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // (optional) copy input, used for ens_tokenize()
            cps.length = pos; // truncate
        }
    }
    return emoji;
}
// ************************************************************
// tokenizer 
const $6ed0d31e8caec1a4$var$TY_VALID = "valid";
const $6ed0d31e8caec1a4$var$TY_MAPPED = "mapped";
const $6ed0d31e8caec1a4$var$TY_IGNORED = "ignored";
const $6ed0d31e8caec1a4$var$TY_DISALLOWED = "disallowed";
const $6ed0d31e8caec1a4$var$TY_EMOJI = "emoji";
const $6ed0d31e8caec1a4$var$TY_NFC = "nfc";
const $6ed0d31e8caec1a4$var$TY_STOP = "stop";
function $6ed0d31e8caec1a4$export$bac129d8210aa825(name, { nf: nf = true } = {}) {
    $6ed0d31e8caec1a4$var$init();
    let input = $6ed0d31e8caec1a4$var$explode_cp(name).reverse();
    let eaten = [];
    let tokens = [];
    while(input.length){
        let emoji = $6ed0d31e8caec1a4$var$consume_emoji_reversed(input, eaten);
        if (emoji) {
            tokens.push({
                type: $6ed0d31e8caec1a4$var$TY_EMOJI,
                emoji: emoji.slice(),
                input: eaten,
                cps: $6ed0d31e8caec1a4$var$filter_fe0f(emoji)
            });
            eaten = []; // reset buffer
        } else {
            let cp = input.pop();
            if (cp == $6ed0d31e8caec1a4$var$STOP) tokens.push({
                type: $6ed0d31e8caec1a4$var$TY_STOP,
                cp: cp
            });
            else if ($6ed0d31e8caec1a4$var$VALID.has(cp)) tokens.push({
                type: $6ed0d31e8caec1a4$var$TY_VALID,
                cps: [
                    cp
                ]
            });
            else if ($6ed0d31e8caec1a4$var$IGNORED.has(cp)) tokens.push({
                type: $6ed0d31e8caec1a4$var$TY_IGNORED,
                cp: cp
            });
            else {
                let cps = $6ed0d31e8caec1a4$var$MAPPED.get(cp);
                if (cps) tokens.push({
                    type: $6ed0d31e8caec1a4$var$TY_MAPPED,
                    cp: cp,
                    cps: cps.slice()
                });
                else tokens.push({
                    type: $6ed0d31e8caec1a4$var$TY_DISALLOWED,
                    cp: cp
                });
            }
        }
    }
    if (nf) for(let i = 0, start = -1; i < tokens.length; i++){
        let token = tokens[i];
        if ($6ed0d31e8caec1a4$var$is_valid_or_mapped(token.type)) {
            if ($6ed0d31e8caec1a4$var$requires_check(token.cps)) {
                let end = i + 1;
                for(let pos = end; pos < tokens.length; pos++){
                    let { type: type, cps: cps } = tokens[pos];
                    if ($6ed0d31e8caec1a4$var$is_valid_or_mapped(type)) {
                        if (!$6ed0d31e8caec1a4$var$requires_check(cps)) break;
                        end = pos + 1;
                    } else if (type !== $6ed0d31e8caec1a4$var$TY_IGNORED) break;
                }
                if (start < 0) start = i;
                let slice = tokens.slice(start, end);
                let cps0 = slice.flatMap((x)=>$6ed0d31e8caec1a4$var$is_valid_or_mapped(x.type) ? x.cps : []); // strip junk tokens
                let cps = $6ed0d31e8caec1a4$export$f42252642e08449(cps0);
                if ($6ed0d31e8caec1a4$var$compare_arrays(cps, cps0)) {
                    tokens.splice(start, end - start, {
                        type: $6ed0d31e8caec1a4$var$TY_NFC,
                        input: cps0,
                        cps: cps,
                        tokens0: $6ed0d31e8caec1a4$var$collapse_valid_tokens(slice),
                        tokens: $6ed0d31e8caec1a4$export$bac129d8210aa825($6ed0d31e8caec1a4$var$str_from_cps(cps), {
                            nf: false
                        })
                    });
                    i = start;
                } else i = end - 1; // skip to end of slice
                start = -1; // reset
            } else start = i; // remember last
        } else if (token.type !== $6ed0d31e8caec1a4$var$TY_IGNORED) start = -1; // reset
    }
    return $6ed0d31e8caec1a4$var$collapse_valid_tokens(tokens);
}
function $6ed0d31e8caec1a4$var$is_valid_or_mapped(type) {
    return type == $6ed0d31e8caec1a4$var$TY_VALID || type == $6ed0d31e8caec1a4$var$TY_MAPPED;
}
function $6ed0d31e8caec1a4$var$requires_check(cps) {
    return cps.some((cp)=>$6ed0d31e8caec1a4$var$NFC_CHECK.has(cp));
}
function $6ed0d31e8caec1a4$var$collapse_valid_tokens(tokens) {
    for(let i = 0; i < tokens.length; i++)if (tokens[i].type == $6ed0d31e8caec1a4$var$TY_VALID) {
        let j = i + 1;
        while(j < tokens.length && tokens[j].type == $6ed0d31e8caec1a4$var$TY_VALID)j++;
        tokens.splice(i, j - i, {
            type: $6ed0d31e8caec1a4$var$TY_VALID,
            cps: tokens.slice(i, j).flatMap((x)=>x.cps)
        });
    }
    return tokens;
}


const $1b6f5b1a3d63639b$var$Zeros = new Uint8Array(32);
$1b6f5b1a3d63639b$var$Zeros.fill(0);
function $1b6f5b1a3d63639b$var$checkComponent(comp) {
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(comp.length !== 0, "invalid ENS name; empty component", "comp", comp);
    return comp;
}
function $1b6f5b1a3d63639b$var$ensNameSplit(name) {
    const bytes = (0, $cdede1645bd34985$export$8feeb310b4b4752f)($1b6f5b1a3d63639b$export$5f232fd2f1a1e8ac(name));
    const comps = [];
    if (name.length === 0) return comps;
    let last = 0;
    for(let i = 0; i < bytes.length; i++){
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push($1b6f5b1a3d63639b$var$checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(last < bytes.length, "invalid ENS name; empty component", "name", name);
    comps.push($1b6f5b1a3d63639b$var$checkComponent(bytes.slice(last)));
    return comps;
}
function $1b6f5b1a3d63639b$export$5f232fd2f1a1e8ac(name) {
    try {
        if (name.length === 0) throw new Error("empty label");
        return (0, $6ed0d31e8caec1a4$export$499f715881831a51)(name);
    } catch (error) {
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, `invalid ENS name (${error.message})`, "name", name);
    }
}
function $1b6f5b1a3d63639b$export$cce2300886e7ace6(name) {
    try {
        return $1b6f5b1a3d63639b$var$ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function $1b6f5b1a3d63639b$export$91d651ee363e1209(name) {
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(typeof name === "string", "invalid ENS name; not a string", "name", name);
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(name.length, `invalid ENS name (empty label)`, "name", name);
    let result = $1b6f5b1a3d63639b$var$Zeros;
    const comps = $1b6f5b1a3d63639b$var$ensNameSplit(name);
    while(comps.length)result = (0, $1c3ba5429a8a9032$export$f8151fce47ad1c35)((0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)([
        result,
        (0, $1c3ba5429a8a9032$export$f8151fce47ad1c35)(comps.pop())
    ]));
    return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(result);
}
function $1b6f5b1a3d63639b$export$6c0a8cdae51cb512(name, _maxLength) {
    const length = _maxLength != null ? _maxLength : 63;
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(length <= 255, "DNS encoded label cannot exceed 255", "length", length);
    return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)((0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)($1b6f5b1a3d63639b$var$ensNameSplit(name).map((comp)=>{
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(comp.length <= length, `label ${JSON.stringify(name)} exceeds ${length} bytes`, "name", name);
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}





//See: https://github.com/ethereum/wiki/wiki/RLP


function $fc3df5208336947e$var$hexlifyByte(value) {
    let result = value.toString(16);
    while(result.length < 2)result = "0" + result;
    return "0x" + result;
}
function $fc3df5208336947e$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $fc3df5208336947e$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $fc3df5208336947e$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        (0, $def55b050f09c63c$export$a7a9523472993e97)(childOffset <= offset + 1 + length, "child data too short", "BUFFER_OVERRUN", {
            buffer: data,
            length: length,
            offset: offset
        });
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $fc3df5208336947e$var$_decode(data, offset) {
    (0, $def55b050f09c63c$export$a7a9523472993e97)(data.length !== 0, "data too short", "BUFFER_OVERRUN", {
        buffer: data,
        length: 0,
        offset: 1
    });
    const checkOffset = (offset)=>{
        (0, $def55b050f09c63c$export$a7a9523472993e97)(offset <= data.length, "data short segment too short", "BUFFER_OVERRUN", {
            buffer: data,
            length: data.length,
            offset: offset
        });
    };
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        checkOffset(offset + 1 + lengthLength);
        const length = $fc3df5208336947e$var$unarrayifyInteger(data, offset + 1, lengthLength);
        checkOffset(offset + 1 + lengthLength + length);
        return $fc3df5208336947e$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        checkOffset(offset + 1 + length);
        return $fc3df5208336947e$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        checkOffset(offset + 1 + lengthLength);
        const length = $fc3df5208336947e$var$unarrayifyInteger(data, offset + 1, lengthLength);
        checkOffset(offset + 1 + lengthLength + length);
        const result = (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        checkOffset(offset + 1 + length);
        const result = (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: $fc3df5208336947e$var$hexlifyByte(data[offset])
    };
}
function $fc3df5208336947e$export$7dc021e13b2aa20d(_data) {
    const data = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(_data, "data");
    const decoded = $fc3df5208336947e$var$_decode(data, 0);
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(decoded.consumed === data.length, "unexpected junk after rlp payload", "data", _data);
    return decoded.result;
}

//See: https://github.com/ethereum/wiki/wiki/RLP

function $0f38deed45b4ff1d$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $0f38deed45b4ff1d$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($0f38deed45b4ff1d$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $0f38deed45b4ff1d$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    const data = Array.prototype.slice.call((0, $8de17c58ebd53b07$export$a3521add2594f3c8)(object, "object"));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $0f38deed45b4ff1d$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
const $0f38deed45b4ff1d$var$nibbles = "0123456789abcdef";
function $0f38deed45b4ff1d$export$aea7770274d28b7(object) {
    let result = "0x";
    for (const v of $0f38deed45b4ff1d$var$_encode(object)){
        result += $0f38deed45b4ff1d$var$nibbles[v >> 4];
        result += $0f38deed45b4ff1d$var$nibbles[v & 0xf];
    }
    return result;
}





const $80204f35584328d0$var$BN_0 = BigInt(0);
const $80204f35584328d0$var$BN_2 = BigInt(2);
const $80204f35584328d0$var$BN_27 = BigInt(27);
const $80204f35584328d0$var$BN_28 = BigInt(28);
const $80204f35584328d0$var$BN_35 = BigInt(35);
const $80204f35584328d0$var$BN_MAX_UINT = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $80204f35584328d0$var$BLOB_SIZE = 131072;
function $80204f35584328d0$var$getKzgLibrary(kzg) {
    const blobToKzgCommitment = (blob)=>{
        if ("computeBlobProof" in kzg) {
            // micro-ecc-signer; check for computeBlobProof since this API
            // expects a string while the kzg-wasm below expects a Unit8Array
            if ("blobToKzgCommitment" in kzg && typeof kzg.blobToKzgCommitment === "function") return (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(kzg.blobToKzgCommitment((0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(blob)));
        } else if ("blobToKzgCommitment" in kzg && typeof kzg.blobToKzgCommitment === "function") // kzg-wasm <0.5.0; blobToKzgCommitment(Uint8Array) => Uint8Array
        return (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(kzg.blobToKzgCommitment(blob));
        // kzg-wasm >= 0.5.0; blobToKZGCommitment(string) => string
        if ("blobToKZGCommitment" in kzg && typeof kzg.blobToKZGCommitment === "function") return (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(kzg.blobToKZGCommitment((0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(blob)));
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "unsupported KZG library", "kzg", kzg);
    };
    const computeBlobKzgProof = (blob, commitment)=>{
        // micro-ecc-signer
        if ("computeBlobProof" in kzg && typeof kzg.computeBlobProof === "function") return (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(kzg.computeBlobProof((0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(blob), (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(commitment)));
        // kzg-wasm <0.5.0; computeBlobKzgProof(Uint8Array, Uint8Array) => Uint8Array
        if ("computeBlobKzgProof" in kzg && typeof kzg.computeBlobKzgProof === "function") return kzg.computeBlobKzgProof(blob, commitment);
        // kzg-wasm >= 0.5.0; computeBlobKZGProof(string, string) => string
        if ("computeBlobKZGProof" in kzg && typeof kzg.computeBlobKZGProof === "function") return (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(kzg.computeBlobKZGProof((0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(blob), (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(commitment)));
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "unsupported KZG library", "kzg", kzg);
    };
    return {
        blobToKzgCommitment: blobToKzgCommitment,
        computeBlobKzgProof: computeBlobKzgProof
    };
}
function $80204f35584328d0$var$getVersionedHash(version, hash) {
    let versioned = version.toString(16);
    while(versioned.length < 2)versioned = "0" + versioned;
    versioned += (0, $13e69841bbcc3689$export$bced8d2aada2d1c9)(hash).substring(4);
    return "0x" + versioned;
}
function $80204f35584328d0$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $61268443a2d16d36$export$88411125f012957a)(value);
}
function $80204f35584328d0$var$handleAccessList(value, param) {
    try {
        return (0, $63484022a9ae8dfc$export$6c8662b1600dce2)(value);
    } catch (error) {
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, error.message, param, value);
    }
}
function $80204f35584328d0$var$handleAuthorizationList(value, param) {
    try {
        if (!Array.isArray(value)) throw new Error("authorizationList: invalid array");
        const result = [];
        for(let i = 0; i < value.length; i++){
            const auth = value[i];
            if (!Array.isArray(auth)) throw new Error(`authorization[${i}]: invalid array`);
            if (auth.length !== 6) throw new Error(`authorization[${i}]: wrong length`);
            if (!auth[1]) throw new Error(`authorization[${i}]: null address`);
            result.push({
                address: $80204f35584328d0$var$handleAddress(auth[1]),
                nonce: $80204f35584328d0$var$handleUint(auth[2], "nonce"),
                chainId: $80204f35584328d0$var$handleUint(auth[0], "chainId"),
                signature: (0, $37038a1f415943f5$export$848620f5f2f26e86).from({
                    yParity: $80204f35584328d0$var$handleNumber(auth[3], "yParity"),
                    r: (0, $8de17c58ebd53b07$export$4473860254365feb)(auth[4], 32),
                    s: (0, $8de17c58ebd53b07$export$4473860254365feb)(auth[5], 32)
                })
            });
        }
        return result;
    } catch (error) {
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, error.message, param, value);
    }
}
function $80204f35584328d0$var$handleNumber(_value, param) {
    if (_value === "0x") return 0;
    return (0, $7df480338fc2bc47$export$b14f2714108df84)(_value, param);
}
function $80204f35584328d0$var$handleUint(_value, param) {
    if (_value === "0x") return $80204f35584328d0$var$BN_0;
    const value = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(_value, param);
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(value <= $80204f35584328d0$var$BN_MAX_UINT, "value exceeds uint size", param, value);
    return value;
}
function $80204f35584328d0$var$formatNumber(_value, name) {
    const value = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(_value, "value");
    const result = (0, $7df480338fc2bc47$export$b627fcfb5ea68cb0)(value);
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(result.length <= 32, `value too large`, `tx.${name}`, value);
    return result;
}
function $80204f35584328d0$var$formatAccessList(value) {
    return (0, $63484022a9ae8dfc$export$6c8662b1600dce2)(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $80204f35584328d0$var$formatAuthorizationList(value) {
    return value.map((a)=>{
        return [
            $80204f35584328d0$var$formatNumber(a.chainId, "chainId"),
            a.address,
            $80204f35584328d0$var$formatNumber(a.nonce, "nonce"),
            $80204f35584328d0$var$formatNumber(a.signature.yParity, "yParity"),
            a.signature.r,
            a.signature.s
        ];
    });
}
function $80204f35584328d0$var$formatHashes(value, param) {
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(Array.isArray(value), `invalid ${param}`, "value", value);
    for(let i = 0; i < value.length; i++)(0, $def55b050f09c63c$export$c3d31707e5030f5e)((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(value[i], 32), "invalid ${ param } hash", `value[${i}]`, value[i]);
    return value;
}
function $80204f35584328d0$var$_parseLegacy(data) {
    const fields = (0, $fc3df5208336947e$export$7dc021e13b2aa20d)(data);
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 9 || fields.length === 6), "invalid field count for legacy transaction", "data", data);
    const tx = {
        type: 0,
        nonce: $80204f35584328d0$var$handleNumber(fields[0], "nonce"),
        gasPrice: $80204f35584328d0$var$handleUint(fields[1], "gasPrice"),
        gasLimit: $80204f35584328d0$var$handleUint(fields[2], "gasLimit"),
        to: $80204f35584328d0$var$handleAddress(fields[3]),
        value: $80204f35584328d0$var$handleUint(fields[4], "value"),
        data: (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(fields[5]),
        chainId: $80204f35584328d0$var$BN_0
    };
    // Legacy unsigned transaction
    if (fields.length === 6) return tx;
    const v = $80204f35584328d0$var$handleUint(fields[6], "v");
    const r = $80204f35584328d0$var$handleUint(fields[7], "r");
    const s = $80204f35584328d0$var$handleUint(fields[8], "s");
    if (r === $80204f35584328d0$var$BN_0 && s === $80204f35584328d0$var$BN_0) // EIP-155 unsigned transaction
    tx.chainId = v;
    else {
        // Compute the EIP-155 chain ID (or 0 for legacy)
        let chainId = (v - $80204f35584328d0$var$BN_35) / $80204f35584328d0$var$BN_2;
        if (chainId < $80204f35584328d0$var$BN_0) chainId = $80204f35584328d0$var$BN_0;
        tx.chainId = chainId;
        // Signed Legacy Transaction
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(chainId !== $80204f35584328d0$var$BN_0 || v === $80204f35584328d0$var$BN_27 || v === $80204f35584328d0$var$BN_28, "non-canonical legacy v", "v", fields[6]);
        tx.signature = (0, $37038a1f415943f5$export$848620f5f2f26e86).from({
            r: (0, $8de17c58ebd53b07$export$4473860254365feb)(fields[7], 32),
            s: (0, $8de17c58ebd53b07$export$4473860254365feb)(fields[8], 32),
            v: v
        });
    //tx.hash = keccak256(data);
    }
    return tx;
}
function $80204f35584328d0$var$_serializeLegacy(tx, sig) {
    const fields = [
        $80204f35584328d0$var$formatNumber(tx.nonce, "nonce"),
        $80204f35584328d0$var$formatNumber(tx.gasPrice || 0, "gasPrice"),
        $80204f35584328d0$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $80204f35584328d0$var$formatNumber(tx.value, "value"),
        tx.data
    ];
    let chainId = $80204f35584328d0$var$BN_0;
    if (tx.chainId != $80204f35584328d0$var$BN_0) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(tx.chainId, "tx.chainId");
        // We have a chainId in the tx and an EIP-155 v in the signature,
        // make sure they agree with each other
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(!sig || sig.networkV == null || sig.legacyChainId === chainId, "tx.chainId/sig.v mismatch", "sig", sig);
    } else if (tx.signature) {
        // No explicit chainId, but EIP-155 have a derived implicit chainId
        const legacy = tx.signature.legacyChainId;
        if (legacy != null) chainId = legacy;
    }
    // Requesting an unsigned transaction
    if (!sig) {
        // We have an EIP-155 transaction (chainId was specified and non-zero)
        if (chainId !== $80204f35584328d0$var$BN_0) {
            fields.push((0, $7df480338fc2bc47$export$b627fcfb5ea68cb0)(chainId));
            fields.push("0x");
            fields.push("0x");
        }
        return (0, $0f38deed45b4ff1d$export$aea7770274d28b7)(fields);
    }
    // @TODO: We should probably check that tx.signature, chainId, and sig
    //        match but that logic could break existing code, so schedule
    //        this for the next major bump.
    // Compute the EIP-155 v
    let v = BigInt(27 + sig.yParity);
    if (chainId !== $80204f35584328d0$var$BN_0) v = (0, $37038a1f415943f5$export$848620f5f2f26e86).getChainIdV(chainId, sig.v);
    else if (BigInt(sig.v) !== v) (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "tx.chainId/sig.v mismatch", "sig", sig);
    // Add the signature
    fields.push((0, $7df480338fc2bc47$export$b627fcfb5ea68cb0)(v));
    fields.push((0, $7df480338fc2bc47$export$b627fcfb5ea68cb0)(sig.r));
    fields.push((0, $7df480338fc2bc47$export$b627fcfb5ea68cb0)(sig.s));
    return (0, $0f38deed45b4ff1d$export$aea7770274d28b7)(fields);
}
function $80204f35584328d0$var$_parseEipSignature(tx, fields) {
    let yParity;
    try {
        yParity = $80204f35584328d0$var$handleNumber(fields[0], "yParity");
        if (yParity !== 0 && yParity !== 1) throw new Error("bad yParity");
    } catch (error) {
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "invalid yParity", "yParity", fields[0]);
    }
    const r = (0, $8de17c58ebd53b07$export$4473860254365feb)(fields[1], 32);
    const s = (0, $8de17c58ebd53b07$export$4473860254365feb)(fields[2], 32);
    const signature = (0, $37038a1f415943f5$export$848620f5f2f26e86).from({
        r: r,
        s: s,
        yParity: yParity
    });
    tx.signature = signature;
}
function $80204f35584328d0$var$_parseEip1559(data) {
    const fields = (0, $fc3df5208336947e$export$7dc021e13b2aa20d)((0, $8de17c58ebd53b07$export$a3521add2594f3c8)(data).slice(1));
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 9 || fields.length === 12), "invalid field count for transaction type: 2", "data", (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(data));
    const tx = {
        type: 2,
        chainId: $80204f35584328d0$var$handleUint(fields[0], "chainId"),
        nonce: $80204f35584328d0$var$handleNumber(fields[1], "nonce"),
        maxPriorityFeePerGas: $80204f35584328d0$var$handleUint(fields[2], "maxPriorityFeePerGas"),
        maxFeePerGas: $80204f35584328d0$var$handleUint(fields[3], "maxFeePerGas"),
        gasPrice: null,
        gasLimit: $80204f35584328d0$var$handleUint(fields[4], "gasLimit"),
        to: $80204f35584328d0$var$handleAddress(fields[5]),
        value: $80204f35584328d0$var$handleUint(fields[6], "value"),
        data: (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(fields[7]),
        accessList: $80204f35584328d0$var$handleAccessList(fields[8], "accessList")
    };
    // Unsigned EIP-1559 Transaction
    if (fields.length === 9) return tx;
    //tx.hash = keccak256(data);
    $80204f35584328d0$var$_parseEipSignature(tx, fields.slice(9));
    return tx;
}
function $80204f35584328d0$var$_serializeEip1559(tx, sig) {
    const fields = [
        $80204f35584328d0$var$formatNumber(tx.chainId, "chainId"),
        $80204f35584328d0$var$formatNumber(tx.nonce, "nonce"),
        $80204f35584328d0$var$formatNumber(tx.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $80204f35584328d0$var$formatNumber(tx.maxFeePerGas || 0, "maxFeePerGas"),
        $80204f35584328d0$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $80204f35584328d0$var$formatNumber(tx.value, "value"),
        tx.data,
        $80204f35584328d0$var$formatAccessList(tx.accessList || [])
    ];
    if (sig) {
        fields.push($80204f35584328d0$var$formatNumber(sig.yParity, "yParity"));
        fields.push((0, $7df480338fc2bc47$export$b627fcfb5ea68cb0)(sig.r));
        fields.push((0, $7df480338fc2bc47$export$b627fcfb5ea68cb0)(sig.s));
    }
    return (0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)([
        "0x02",
        (0, $0f38deed45b4ff1d$export$aea7770274d28b7)(fields)
    ]);
}
function $80204f35584328d0$var$_parseEip2930(data) {
    const fields = (0, $fc3df5208336947e$export$7dc021e13b2aa20d)((0, $8de17c58ebd53b07$export$a3521add2594f3c8)(data).slice(1));
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 8 || fields.length === 11), "invalid field count for transaction type: 1", "data", (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(data));
    const tx = {
        type: 1,
        chainId: $80204f35584328d0$var$handleUint(fields[0], "chainId"),
        nonce: $80204f35584328d0$var$handleNumber(fields[1], "nonce"),
        gasPrice: $80204f35584328d0$var$handleUint(fields[2], "gasPrice"),
        gasLimit: $80204f35584328d0$var$handleUint(fields[3], "gasLimit"),
        to: $80204f35584328d0$var$handleAddress(fields[4]),
        value: $80204f35584328d0$var$handleUint(fields[5], "value"),
        data: (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(fields[6]),
        accessList: $80204f35584328d0$var$handleAccessList(fields[7], "accessList")
    };
    // Unsigned EIP-2930 Transaction
    if (fields.length === 8) return tx;
    //tx.hash = keccak256(data);
    $80204f35584328d0$var$_parseEipSignature(tx, fields.slice(8));
    return tx;
}
function $80204f35584328d0$var$_serializeEip2930(tx, sig) {
    const fields = [
        $80204f35584328d0$var$formatNumber(tx.chainId, "chainId"),
        $80204f35584328d0$var$formatNumber(tx.nonce, "nonce"),
        $80204f35584328d0$var$formatNumber(tx.gasPrice || 0, "gasPrice"),
        $80204f35584328d0$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $80204f35584328d0$var$formatNumber(tx.value, "value"),
        tx.data,
        $80204f35584328d0$var$formatAccessList(tx.accessList || [])
    ];
    if (sig) {
        fields.push($80204f35584328d0$var$formatNumber(sig.yParity, "recoveryParam"));
        fields.push((0, $7df480338fc2bc47$export$b627fcfb5ea68cb0)(sig.r));
        fields.push((0, $7df480338fc2bc47$export$b627fcfb5ea68cb0)(sig.s));
    }
    return (0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)([
        "0x01",
        (0, $0f38deed45b4ff1d$export$aea7770274d28b7)(fields)
    ]);
}
function $80204f35584328d0$var$_parseEip4844(data) {
    let fields = (0, $fc3df5208336947e$export$7dc021e13b2aa20d)((0, $8de17c58ebd53b07$export$a3521add2594f3c8)(data).slice(1));
    let typeName = "3";
    let blobs = null;
    // Parse the network format
    if (fields.length === 4 && Array.isArray(fields[0])) {
        typeName = "3 (network format)";
        const fBlobs = fields[1], fCommits = fields[2], fProofs = fields[3];
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(Array.isArray(fBlobs), "invalid network format: blobs not an array", "fields[1]", fBlobs);
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(Array.isArray(fCommits), "invalid network format: commitments not an array", "fields[2]", fCommits);
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(Array.isArray(fProofs), "invalid network format: proofs not an array", "fields[3]", fProofs);
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(fBlobs.length === fCommits.length, "invalid network format: blobs/commitments length mismatch", "fields", fields);
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(fBlobs.length === fProofs.length, "invalid network format: blobs/proofs length mismatch", "fields", fields);
        blobs = [];
        for(let i = 0; i < fields[1].length; i++)blobs.push({
            data: fBlobs[i],
            commitment: fCommits[i],
            proof: fProofs[i]
        });
        fields = fields[0];
    }
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 11 || fields.length === 14), `invalid field count for transaction type: ${typeName}`, "data", (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(data));
    const tx = {
        type: 3,
        chainId: $80204f35584328d0$var$handleUint(fields[0], "chainId"),
        nonce: $80204f35584328d0$var$handleNumber(fields[1], "nonce"),
        maxPriorityFeePerGas: $80204f35584328d0$var$handleUint(fields[2], "maxPriorityFeePerGas"),
        maxFeePerGas: $80204f35584328d0$var$handleUint(fields[3], "maxFeePerGas"),
        gasPrice: null,
        gasLimit: $80204f35584328d0$var$handleUint(fields[4], "gasLimit"),
        to: $80204f35584328d0$var$handleAddress(fields[5]),
        value: $80204f35584328d0$var$handleUint(fields[6], "value"),
        data: (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(fields[7]),
        accessList: $80204f35584328d0$var$handleAccessList(fields[8], "accessList"),
        maxFeePerBlobGas: $80204f35584328d0$var$handleUint(fields[9], "maxFeePerBlobGas"),
        blobVersionedHashes: fields[10]
    };
    if (blobs) tx.blobs = blobs;
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(tx.to != null, `invalid address for transaction type: ${typeName}`, "data", data);
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(Array.isArray(tx.blobVersionedHashes), "invalid blobVersionedHashes: must be an array", "data", data);
    for(let i = 0; i < tx.blobVersionedHashes.length; i++)(0, $def55b050f09c63c$export$c3d31707e5030f5e)((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(tx.blobVersionedHashes[i], 32), `invalid blobVersionedHash at index ${i}: must be length 32`, "data", data);
    // Unsigned EIP-4844 Transaction
    if (fields.length === 11) return tx;
    // @TODO: Do we need to do this? This is only called internally
    // and used to verify hashes; it might save time to not do this
    //tx.hash = keccak256(concat([ "0x03", encodeRlp(fields) ]));
    $80204f35584328d0$var$_parseEipSignature(tx, fields.slice(11));
    return tx;
}
function $80204f35584328d0$var$_serializeEip4844(tx, sig, blobs) {
    const fields = [
        $80204f35584328d0$var$formatNumber(tx.chainId, "chainId"),
        $80204f35584328d0$var$formatNumber(tx.nonce, "nonce"),
        $80204f35584328d0$var$formatNumber(tx.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $80204f35584328d0$var$formatNumber(tx.maxFeePerGas || 0, "maxFeePerGas"),
        $80204f35584328d0$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || (0, $b4909c6a5ae371e9$export$b7cbe423ba83da17),
        $80204f35584328d0$var$formatNumber(tx.value, "value"),
        tx.data,
        $80204f35584328d0$var$formatAccessList(tx.accessList || []),
        $80204f35584328d0$var$formatNumber(tx.maxFeePerBlobGas || 0, "maxFeePerBlobGas"),
        $80204f35584328d0$var$formatHashes(tx.blobVersionedHashes || [], "blobVersionedHashes")
    ];
    if (sig) {
        fields.push($80204f35584328d0$var$formatNumber(sig.yParity, "yParity"));
        fields.push((0, $7df480338fc2bc47$export$b627fcfb5ea68cb0)(sig.r));
        fields.push((0, $7df480338fc2bc47$export$b627fcfb5ea68cb0)(sig.s));
        // We have blobs; return the network wrapped format
        if (blobs) return (0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)([
            "0x03",
            (0, $0f38deed45b4ff1d$export$aea7770274d28b7)([
                fields,
                blobs.map((b)=>b.data),
                blobs.map((b)=>b.commitment),
                blobs.map((b)=>b.proof)
            ])
        ]);
    }
    return (0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)([
        "0x03",
        (0, $0f38deed45b4ff1d$export$aea7770274d28b7)(fields)
    ]);
}
function $80204f35584328d0$var$_parseEip7702(data) {
    const fields = (0, $fc3df5208336947e$export$7dc021e13b2aa20d)((0, $8de17c58ebd53b07$export$a3521add2594f3c8)(data).slice(1));
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 10 || fields.length === 13), "invalid field count for transaction type: 4", "data", (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(data));
    const tx = {
        type: 4,
        chainId: $80204f35584328d0$var$handleUint(fields[0], "chainId"),
        nonce: $80204f35584328d0$var$handleNumber(fields[1], "nonce"),
        maxPriorityFeePerGas: $80204f35584328d0$var$handleUint(fields[2], "maxPriorityFeePerGas"),
        maxFeePerGas: $80204f35584328d0$var$handleUint(fields[3], "maxFeePerGas"),
        gasPrice: null,
        gasLimit: $80204f35584328d0$var$handleUint(fields[4], "gasLimit"),
        to: $80204f35584328d0$var$handleAddress(fields[5]),
        value: $80204f35584328d0$var$handleUint(fields[6], "value"),
        data: (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(fields[7]),
        accessList: $80204f35584328d0$var$handleAccessList(fields[8], "accessList"),
        authorizationList: $80204f35584328d0$var$handleAuthorizationList(fields[9], "authorizationList")
    };
    // Unsigned EIP-7702 Transaction
    if (fields.length === 10) return tx;
    $80204f35584328d0$var$_parseEipSignature(tx, fields.slice(10));
    return tx;
}
function $80204f35584328d0$var$_serializeEip7702(tx, sig) {
    const fields = [
        $80204f35584328d0$var$formatNumber(tx.chainId, "chainId"),
        $80204f35584328d0$var$formatNumber(tx.nonce, "nonce"),
        $80204f35584328d0$var$formatNumber(tx.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $80204f35584328d0$var$formatNumber(tx.maxFeePerGas || 0, "maxFeePerGas"),
        $80204f35584328d0$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $80204f35584328d0$var$formatNumber(tx.value, "value"),
        tx.data,
        $80204f35584328d0$var$formatAccessList(tx.accessList || []),
        $80204f35584328d0$var$formatAuthorizationList(tx.authorizationList || [])
    ];
    if (sig) {
        fields.push($80204f35584328d0$var$formatNumber(sig.yParity, "yParity"));
        fields.push((0, $7df480338fc2bc47$export$b627fcfb5ea68cb0)(sig.r));
        fields.push((0, $7df480338fc2bc47$export$b627fcfb5ea68cb0)(sig.s));
    }
    return (0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)([
        "0x04",
        (0, $0f38deed45b4ff1d$export$aea7770274d28b7)(fields)
    ]);
}
class $80204f35584328d0$export$febc5573c75cefb0 {
    #type;
    #to;
    #data;
    #nonce;
    #gasLimit;
    #gasPrice;
    #maxPriorityFeePerGas;
    #maxFeePerGas;
    #value;
    #chainId;
    #sig;
    #accessList;
    #maxFeePerBlobGas;
    #blobVersionedHashes;
    #kzg;
    #blobs;
    #auths;
    /**
     *  The transaction type.
     *
     *  If null, the type will be automatically inferred based on
     *  explicit properties.
     */ get type() {
        return this.#type;
    }
    set type(value) {
        switch(value){
            case null:
                this.#type = null;
                break;
            case 0:
            case "legacy":
                this.#type = 0;
                break;
            case 1:
            case "berlin":
            case "eip-2930":
                this.#type = 1;
                break;
            case 2:
            case "london":
            case "eip-1559":
                this.#type = 2;
                break;
            case 3:
            case "cancun":
            case "eip-4844":
                this.#type = 3;
                break;
            case 4:
            case "pectra":
            case "eip-7702":
                this.#type = 4;
                break;
            default:
                (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "unsupported transaction type", "type", value);
        }
    }
    /**
     *  The name of the transaction type.
     */ get typeName() {
        switch(this.type){
            case 0:
                return "legacy";
            case 1:
                return "eip-2930";
            case 2:
                return "eip-1559";
            case 3:
                return "eip-4844";
            case 4:
                return "eip-7702";
        }
        return null;
    }
    /**
     *  The ``to`` address for the transaction or ``null`` if the
     *  transaction is an ``init`` transaction.
     */ get to() {
        const value = this.#to;
        if (value == null && this.type === 3) return 0, $b4909c6a5ae371e9$export$b7cbe423ba83da17;
        return value;
    }
    set to(value) {
        this.#to = value == null ? null : (0, $61268443a2d16d36$export$88411125f012957a)(value);
    }
    /**
     *  The transaction nonce.
     */ get nonce() {
        return this.#nonce;
    }
    set nonce(value) {
        this.#nonce = (0, $7df480338fc2bc47$export$b14f2714108df84)(value, "value");
    }
    /**
     *  The gas limit.
     */ get gasLimit() {
        return this.#gasLimit;
    }
    set gasLimit(value) {
        this.#gasLimit = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(value);
    }
    /**
     *  The gas price.
     *
     *  On legacy networks this defines the fee that will be paid. On
     *  EIP-1559 networks, this should be ``null``.
     */ get gasPrice() {
        const value = this.#gasPrice;
        if (value == null && (this.type === 0 || this.type === 1)) return $80204f35584328d0$var$BN_0;
        return value;
    }
    set gasPrice(value) {
        this.#gasPrice = value == null ? null : (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(value, "gasPrice");
    }
    /**
     *  The maximum priority fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */ get maxPriorityFeePerGas() {
        const value = this.#maxPriorityFeePerGas;
        if (value == null) {
            if (this.type === 2 || this.type === 3) return $80204f35584328d0$var$BN_0;
            return null;
        }
        return value;
    }
    set maxPriorityFeePerGas(value) {
        this.#maxPriorityFeePerGas = value == null ? null : (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(value, "maxPriorityFeePerGas");
    }
    /**
     *  The maximum total fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */ get maxFeePerGas() {
        const value = this.#maxFeePerGas;
        if (value == null) {
            if (this.type === 2 || this.type === 3) return $80204f35584328d0$var$BN_0;
            return null;
        }
        return value;
    }
    set maxFeePerGas(value) {
        this.#maxFeePerGas = value == null ? null : (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(value, "maxFeePerGas");
    }
    /**
     *  The transaction data. For ``init`` transactions this is the
     *  deployment code.
     */ get data() {
        return this.#data;
    }
    set data(value) {
        this.#data = (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(value);
    }
    /**
     *  The amount of ether (in wei) to send in this transactions.
     */ get value() {
        return this.#value;
    }
    set value(value) {
        this.#value = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(value, "value");
    }
    /**
     *  The chain ID this transaction is valid on.
     */ get chainId() {
        return this.#chainId;
    }
    set chainId(value) {
        this.#chainId = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(value);
    }
    /**
     *  If signed, the signature for this transaction.
     */ get signature() {
        return this.#sig || null;
    }
    set signature(value) {
        this.#sig = value == null ? null : (0, $37038a1f415943f5$export$848620f5f2f26e86).from(value);
    }
    /**
     *  The access list.
     *
     *  An access list permits discounted (but pre-paid) access to
     *  bytecode and state variable access within contract execution.
     */ get accessList() {
        const value = this.#accessList || null;
        if (value == null) {
            if (this.type === 1 || this.type === 2 || this.type === 3) // @TODO: in v7, this should assign the value or become
            // a live object itself, otherwise mutation is inconsistent
            return [];
            return null;
        }
        return value;
    }
    set accessList(value) {
        this.#accessList = value == null ? null : (0, $63484022a9ae8dfc$export$6c8662b1600dce2)(value);
    }
    get authorizationList() {
        const value = this.#auths || null;
        if (value == null) {
            if (this.type === 4) // @TODO: in v7, this should become a live object itself,
            // otherwise mutation is inconsistent
            return [];
        }
        return value;
    }
    set authorizationList(auths) {
        this.#auths = auths == null ? null : auths.map((a)=>(0, $50e5ec83adfbb986$export$792a4c467f6fbc9f)(a));
    }
    /**
     *  The max fee per blob gas for Cancun transactions.
     */ get maxFeePerBlobGas() {
        const value = this.#maxFeePerBlobGas;
        if (value == null && this.type === 3) return $80204f35584328d0$var$BN_0;
        return value;
    }
    set maxFeePerBlobGas(value) {
        this.#maxFeePerBlobGas = value == null ? null : (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(value, "maxFeePerBlobGas");
    }
    /**
     *  The BLOb versioned hashes for Cancun transactions.
     */ get blobVersionedHashes() {
        // @TODO: Mutation is inconsistent; if unset, the returned value
        // cannot mutate the object, if set it can
        let value = this.#blobVersionedHashes;
        if (value == null && this.type === 3) return [];
        return value;
    }
    set blobVersionedHashes(value) {
        if (value != null) {
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(Array.isArray(value), "blobVersionedHashes must be an Array", "value", value);
            value = value.slice();
            for(let i = 0; i < value.length; i++)(0, $def55b050f09c63c$export$c3d31707e5030f5e)((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(value[i], 32), "invalid blobVersionedHash", `value[${i}]`, value[i]);
        }
        this.#blobVersionedHashes = value;
    }
    /**
     *  The BLObs for the Transaction, if any.
     *
     *  If ``blobs`` is non-``null``, then the [[seriailized]]
     *  will return the network formatted sidecar, otherwise it
     *  will return the standard [[link-eip-2718]] payload. The
     *  [[unsignedSerialized]] is unaffected regardless.
     *
     *  When setting ``blobs``, either fully valid [[Blob]] objects
     *  may be specified (i.e. correctly padded, with correct
     *  committments and proofs) or a raw [[BytesLike]] may
     *  be provided.
     *
     *  If raw [[BytesLike]] are provided, the [[kzg]] property **must**
     *  be already set. The blob will be correctly padded and the
     *  [[KzgLibrary]] will be used to compute the committment and
     *  proof for the blob.
     *
     *  A BLOb is a sequence of field elements, each of which must
     *  be within the BLS field modulo, so some additional processing
     *  may be required to encode arbitrary data to ensure each 32 byte
     *  field is within the valid range.
     *
     *  Setting this automatically populates [[blobVersionedHashes]],
     *  overwriting any existing values. Setting this to ``null``
     *  does **not** remove the [[blobVersionedHashes]], leaving them
     *  present.
     */ get blobs() {
        if (this.#blobs == null) return null;
        return this.#blobs.map((b)=>Object.assign({}, b));
    }
    set blobs(_blobs) {
        if (_blobs == null) {
            this.#blobs = null;
            return;
        }
        const blobs = [];
        const versionedHashes = [];
        for(let i = 0; i < _blobs.length; i++){
            const blob = _blobs[i];
            if ((0, $8de17c58ebd53b07$export$9a14abb1a440cd5e)(blob)) {
                (0, $def55b050f09c63c$export$a7a9523472993e97)(this.#kzg, "adding a raw blob requires a KZG library", "UNSUPPORTED_OPERATION", {
                    operation: "set blobs()"
                });
                let data = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(blob);
                (0, $def55b050f09c63c$export$c3d31707e5030f5e)(data.length <= $80204f35584328d0$var$BLOB_SIZE, "blob is too large", `blobs[${i}]`, blob);
                // Pad blob if necessary
                if (data.length !== $80204f35584328d0$var$BLOB_SIZE) {
                    const padded = new Uint8Array($80204f35584328d0$var$BLOB_SIZE);
                    padded.set(data);
                    data = padded;
                }
                const commit = this.#kzg.blobToKzgCommitment(data);
                const proof = (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(this.#kzg.computeBlobKzgProof(data, commit));
                blobs.push({
                    data: (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(data),
                    commitment: (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(commit),
                    proof: proof
                });
                versionedHashes.push($80204f35584328d0$var$getVersionedHash(1, commit));
            } else {
                const commit = (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(blob.commitment);
                blobs.push({
                    data: (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(blob.data),
                    commitment: commit,
                    proof: (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(blob.proof)
                });
                versionedHashes.push($80204f35584328d0$var$getVersionedHash(1, commit));
            }
        }
        this.#blobs = blobs;
        this.#blobVersionedHashes = versionedHashes;
    }
    get kzg() {
        return this.#kzg;
    }
    set kzg(kzg) {
        if (kzg == null) this.#kzg = null;
        else this.#kzg = $80204f35584328d0$var$getKzgLibrary(kzg);
    }
    /**
     *  Creates a new Transaction with default values.
     */ constructor(){
        this.#type = null;
        this.#to = null;
        this.#nonce = 0;
        this.#gasLimit = $80204f35584328d0$var$BN_0;
        this.#gasPrice = null;
        this.#maxPriorityFeePerGas = null;
        this.#maxFeePerGas = null;
        this.#data = "0x";
        this.#value = $80204f35584328d0$var$BN_0;
        this.#chainId = $80204f35584328d0$var$BN_0;
        this.#sig = null;
        this.#accessList = null;
        this.#maxFeePerBlobGas = null;
        this.#blobVersionedHashes = null;
        this.#kzg = null;
        this.#blobs = null;
        this.#auths = null;
    }
    /**
     *  The transaction hash, if signed. Otherwise, ``null``.
     */ get hash() {
        if (this.signature == null) return null;
        return (0, $1c3ba5429a8a9032$export$f8151fce47ad1c35)(this.#getSerialized(true, false));
    }
    /**
     *  The pre-image hash of this transaction.
     *
     *  This is the digest that a [[Signer]] must sign to authorize
     *  this transaction.
     */ get unsignedHash() {
        return (0, $1c3ba5429a8a9032$export$f8151fce47ad1c35)(this.unsignedSerialized);
    }
    /**
     *  The sending address, if signed. Otherwise, ``null``.
     */ get from() {
        if (this.signature == null) return null;
        return (0, $38f7b118ce5fa9c9$export$23cc18f96d8510e2)(this.unsignedHash, this.signature);
    }
    /**
     *  The public key of the sender, if signed. Otherwise, ``null``.
     */ get fromPublicKey() {
        if (this.signature == null) return null;
        return (0, $2c64e14017a66a72$export$21643ca94aed3e83).recoverPublicKey(this.unsignedHash, this.signature);
    }
    /**
     *  Returns true if signed.
     *
     *  This provides a Type Guard that properties requiring a signed
     *  transaction are non-null.
     */ isSigned() {
        return this.signature != null;
    }
    #getSerialized(signed, sidecar) {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(!signed || this.signature != null, "cannot serialize unsigned transaction; maybe you meant .unsignedSerialized", "UNSUPPORTED_OPERATION", {
            operation: ".serialized"
        });
        const sig = signed ? this.signature : null;
        switch(this.inferType()){
            case 0:
                return $80204f35584328d0$var$_serializeLegacy(this, sig);
            case 1:
                return $80204f35584328d0$var$_serializeEip2930(this, sig);
            case 2:
                return $80204f35584328d0$var$_serializeEip1559(this, sig);
            case 3:
                return $80204f35584328d0$var$_serializeEip4844(this, sig, sidecar ? this.blobs : null);
            case 4:
                return $80204f35584328d0$var$_serializeEip7702(this, sig);
        }
        (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
            operation: ".serialized"
        });
    }
    /**
     *  The serialized transaction.
     *
     *  This throws if the transaction is unsigned. For the pre-image,
     *  use [[unsignedSerialized]].
     */ get serialized() {
        return this.#getSerialized(true, true);
    }
    /**
     *  The transaction pre-image.
     *
     *  The hash of this is the digest which needs to be signed to
     *  authorize this transaction.
     */ get unsignedSerialized() {
        return this.#getSerialized(false, false);
    }
    /**
     *  Return the most "likely" type; currently the highest
     *  supported transaction type.
     */ inferType() {
        const types = this.inferTypes();
        // Prefer London (EIP-1559) over Cancun (BLOb)
        if (types.indexOf(2) >= 0) return 2;
        // Return the highest inferred type
        return types.pop();
    }
    /**
     *  Validates the explicit properties and returns a list of compatible
     *  transaction types.
     */ inferTypes() {
        // Checks that there are no conflicting properties set
        const hasGasPrice = this.gasPrice != null;
        const hasFee = this.maxFeePerGas != null || this.maxPriorityFeePerGas != null;
        const hasAccessList = this.accessList != null;
        const hasBlob = this.#maxFeePerBlobGas != null || this.#blobVersionedHashes;
        //if (hasGasPrice && hasFee) {
        //    throw new Error("transaction cannot have gasPrice and maxFeePerGas");
        //}
        if (this.maxFeePerGas != null && this.maxPriorityFeePerGas != null) (0, $def55b050f09c63c$export$a7a9523472993e97)(this.maxFeePerGas >= this.maxPriorityFeePerGas, "priorityFee cannot be more than maxFee", "BAD_DATA", {
            value: this
        });
        //if (this.type === 2 && hasGasPrice) {
        //    throw new Error("eip-1559 transaction cannot have gasPrice");
        //}
        (0, $def55b050f09c63c$export$a7a9523472993e97)(!hasFee || this.type !== 0 && this.type !== 1, "transaction type cannot have maxFeePerGas or maxPriorityFeePerGas", "BAD_DATA", {
            value: this
        });
        (0, $def55b050f09c63c$export$a7a9523472993e97)(this.type !== 0 || !hasAccessList, "legacy transaction cannot have accessList", "BAD_DATA", {
            value: this
        });
        const types = [];
        // Explicit type
        if (this.type != null) types.push(this.type);
        else {
            if (this.authorizationList && this.authorizationList.length) types.push(4);
            else if (hasFee) types.push(2);
            else if (hasGasPrice) {
                types.push(1);
                if (!hasAccessList) types.push(0);
            } else if (hasAccessList) {
                types.push(1);
                types.push(2);
            } else if (hasBlob && this.to) types.push(3);
            else {
                types.push(0);
                types.push(1);
                types.push(2);
                types.push(3);
            }
        }
        types.sort();
        return types;
    }
    /**
     *  Returns true if this transaction is a legacy transaction (i.e.
     *  ``type === 0``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isLegacy() {
        return this.type === 0;
    }
    /**
     *  Returns true if this transaction is berlin hardform transaction (i.e.
     *  ``type === 1``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isBerlin() {
        return this.type === 1;
    }
    /**
     *  Returns true if this transaction is london hardform transaction (i.e.
     *  ``type === 2``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isLondon() {
        return this.type === 2;
    }
    /**
     *  Returns true if this transaction is an [[link-eip-4844]] BLOB
     *  transaction.
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isCancun() {
        return this.type === 3;
    }
    /**
     *  Create a copy of this transaciton.
     */ clone() {
        return $80204f35584328d0$export$febc5573c75cefb0.from(this);
    }
    /**
     *  Return a JSON-friendly object.
     */ toJSON() {
        const s = (v)=>{
            if (v == null) return null;
            return v.toString();
        };
        return {
            type: this.type,
            to: this.to,
            //            from: this.from,
            data: this.data,
            nonce: this.nonce,
            gasLimit: s(this.gasLimit),
            gasPrice: s(this.gasPrice),
            maxPriorityFeePerGas: s(this.maxPriorityFeePerGas),
            maxFeePerGas: s(this.maxFeePerGas),
            value: s(this.value),
            chainId: s(this.chainId),
            sig: this.signature ? this.signature.toJSON() : null,
            accessList: this.accessList
        };
    }
    /**
     *  Create a **Transaction** from a serialized transaction or a
     *  Transaction-like object.
     */ static from(tx) {
        if (tx == null) return new $80204f35584328d0$export$febc5573c75cefb0();
        if (typeof tx === "string") {
            const payload = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(tx);
            if (payload[0] >= 0x7f) return $80204f35584328d0$export$febc5573c75cefb0.from($80204f35584328d0$var$_parseLegacy(payload));
            switch(payload[0]){
                case 1:
                    return $80204f35584328d0$export$febc5573c75cefb0.from($80204f35584328d0$var$_parseEip2930(payload));
                case 2:
                    return $80204f35584328d0$export$febc5573c75cefb0.from($80204f35584328d0$var$_parseEip1559(payload));
                case 3:
                    return $80204f35584328d0$export$febc5573c75cefb0.from($80204f35584328d0$var$_parseEip4844(payload));
                case 4:
                    return $80204f35584328d0$export$febc5573c75cefb0.from($80204f35584328d0$var$_parseEip7702(payload));
            }
            (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
                operation: "from"
            });
        }
        const result = new $80204f35584328d0$export$febc5573c75cefb0();
        if (tx.type != null) result.type = tx.type;
        if (tx.to != null) result.to = tx.to;
        if (tx.nonce != null) result.nonce = tx.nonce;
        if (tx.gasLimit != null) result.gasLimit = tx.gasLimit;
        if (tx.gasPrice != null) result.gasPrice = tx.gasPrice;
        if (tx.maxPriorityFeePerGas != null) result.maxPriorityFeePerGas = tx.maxPriorityFeePerGas;
        if (tx.maxFeePerGas != null) result.maxFeePerGas = tx.maxFeePerGas;
        if (tx.maxFeePerBlobGas != null) result.maxFeePerBlobGas = tx.maxFeePerBlobGas;
        if (tx.data != null) result.data = tx.data;
        if (tx.value != null) result.value = tx.value;
        if (tx.chainId != null) result.chainId = tx.chainId;
        if (tx.signature != null) result.signature = (0, $37038a1f415943f5$export$848620f5f2f26e86).from(tx.signature);
        if (tx.accessList != null) result.accessList = tx.accessList;
        if (tx.authorizationList != null) result.authorizationList = tx.authorizationList;
        // This will get overwritten by blobs, if present
        if (tx.blobVersionedHashes != null) result.blobVersionedHashes = tx.blobVersionedHashes;
        // Make sure we assign the kzg before assigning blobs, which
        // require the library in the event raw blob data is provided.
        if (tx.kzg != null) result.kzg = tx.kzg;
        if (tx.blobs != null) result.blobs = tx.blobs;
        if (tx.hash != null) {
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(result.isSigned(), "unsigned transaction cannot define '.hash'", "tx", tx);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(result.hash === tx.hash, "hash mismatch", "tx", tx);
        }
        if (tx.from != null) {
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(result.isSigned(), "unsigned transaction cannot define '.from'", "tx", tx);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(result.from.toLowerCase() === (tx.from || "").toLowerCase(), "from mismatch", "tx", tx);
        }
        return result;
    }
}



/**
 *  ENS is a service which allows easy-to-remember names to map to
 *  network addresses.
 *
 *  @_section: api/providers/ens-resolver:ENS Resolver  [about-ens-rsolver]
 */ 



/**
 *  The [Base58 Encoding](link-base58) scheme allows a **numeric** value
 *  to be encoded as a compact string using a radix of 58 using only
 *  alpha-numeric characters. Confusingly similar characters are omitted
 *  (i.e. ``"l0O"``).
 *
 *  Note that Base58 encodes a **numeric** value, not arbitrary bytes,
 *  since any zero-bytes on the left would get removed. To mitigate this
 *  issue most schemes that use Base58 choose specific high-order values
 *  to ensure non-zero prefixes.
 *
 *  @_subsection: api/utils:Base58 Encoding [about-base58]
 */ 


const $60e672e41142e130$var$Alphabet = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
let $60e672e41142e130$var$Lookup = null;
function $60e672e41142e130$var$getAlpha(letter) {
    if ($60e672e41142e130$var$Lookup == null) {
        $60e672e41142e130$var$Lookup = {};
        for(let i = 0; i < $60e672e41142e130$var$Alphabet.length; i++)$60e672e41142e130$var$Lookup[$60e672e41142e130$var$Alphabet[i]] = BigInt(i);
    }
    const result = $60e672e41142e130$var$Lookup[letter];
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(result != null, `invalid base58 value`, "letter", letter);
    return result;
}
const $60e672e41142e130$var$BN_0 = BigInt(0);
const $60e672e41142e130$var$BN_58 = BigInt(58);
function $60e672e41142e130$export$743e6bddc3282b13(_value) {
    const bytes = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(_value);
    let value = (0, $7df480338fc2bc47$export$c221a145703ab783)(bytes);
    let result = "";
    while(value){
        result = $60e672e41142e130$var$Alphabet[Number(value % $60e672e41142e130$var$BN_58)] + result;
        value /= $60e672e41142e130$var$BN_58;
    }
    // Account for leading padding zeros
    for(let i = 0; i < bytes.length; i++){
        if (bytes[i]) break;
        result = $60e672e41142e130$var$Alphabet[0] + result;
    }
    return result;
}
function $60e672e41142e130$export$63d430871b22e3d9(value) {
    let result = $60e672e41142e130$var$BN_0;
    for(let i = 0; i < value.length; i++){
        result *= $60e672e41142e130$var$BN_58;
        result += $60e672e41142e130$var$getAlpha(value[i]);
    }
    return result;
}


// @TODO: This should use the fetch-data:ipfs gateway
// Trim off the ipfs:// prefix and return the default gateway URL
function $5cf4446c68da03db$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "unsupported IPFS format", "link", link);
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
class $5cf4446c68da03db$export$1e6016d1bbd92d2c {
    /**
     *  The name.
     */ name;
    /**
     *  Creates a new **MulticoinProviderPluing** for %%name%%.
     */ constructor(name){
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
    connect(proivder) {
        return this;
    }
    /**
     *  Returns ``true`` if %%coinType%% is supported by this plugin.
     */ supportsCoinType(coinType) {
        return false;
    }
    /**
     *  Resolves to the encoded %%address%% for %%coinType%%.
     */ async encodeAddress(coinType, address) {
        throw new Error("unsupported coin");
    }
    /**
     *  Resolves to the decoded %%data%% for %%coinType%%.
     */ async decodeAddress(coinType, data) {
        throw new Error("unsupported coin");
    }
}
const $5cf4446c68da03db$var$BasicMulticoinPluginId = "org.ethers.plugins.provider.BasicMulticoin";
class $5cf4446c68da03db$export$dcf63b2028a708b5 extends $5cf4446c68da03db$export$1e6016d1bbd92d2c {
    /**
     *  Creates a new **BasicMulticoinProviderPlugin**.
     */ constructor(){
        super($5cf4446c68da03db$var$BasicMulticoinPluginId);
    }
}
const $5cf4446c68da03db$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
const $5cf4446c68da03db$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $5cf4446c68da03db$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
class $5cf4446c68da03db$export$d04afd034a0a53ae {
    /**
     *  The connected provider.
     */ provider;
    /**
     *  The address of the resolver.
     */ address;
    /**
     *  The name this resolver was resolved against.
     */ name;
    // For EIP-2544 names, the ancestor that provided the resolver
    #supports2544;
    #resolver;
    constructor(provider, address, name){
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            provider: provider,
            address: address,
            name: name
        });
        this.#supports2544 = null;
        this.#resolver = new (0, $220158e9e9aec1ec$export$8517d80acf00e19a)(address, [
            "function supportsInterface(bytes4) view returns (bool)",
            "function resolve(bytes, bytes) view returns (bytes)",
            "function addr(bytes32) view returns (address)",
            "function addr(bytes32, uint) view returns (bytes)",
            "function text(bytes32, string) view returns (string)",
            "function contenthash(bytes32) view returns (bytes)"
        ], provider);
    }
    /**
     *  Resolves to true if the resolver supports wildcard resolution.
     */ async supportsWildcard() {
        if (this.#supports2544 == null) this.#supports2544 = (async ()=>{
            try {
                return await this.#resolver.supportsInterface("0x9061b923");
            } catch (error) {
                // Wildcard resolvers must understand supportsInterface
                // and return true.
                if ((0, $def55b050f09c63c$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) return false;
                // Let future attempts try again...
                this.#supports2544 = null;
                throw error;
            }
        })();
        return await this.#supports2544;
    }
    async #fetch(funcName, params) {
        params = (params || []).slice();
        const iface = this.#resolver.interface;
        // The first parameters is always the nodehash
        params.unshift((0, $1b6f5b1a3d63639b$export$91d651ee363e1209)(this.name));
        let fragment = null;
        if (await this.supportsWildcard()) {
            fragment = iface.getFunction(funcName);
            (0, $def55b050f09c63c$export$a7a9523472993e97)(fragment, "missing fragment", "UNKNOWN_ERROR", {
                info: {
                    funcName: funcName
                }
            });
            params = [
                (0, $1b6f5b1a3d63639b$export$6c0a8cdae51cb512)(this.name, 255),
                iface.encodeFunctionData(fragment, params)
            ];
            funcName = "resolve(bytes,bytes)";
        }
        params.push({
            enableCcipRead: true
        });
        try {
            const result = await this.#resolver[funcName](...params);
            if (fragment) return iface.decodeFunctionResult(fragment, result)[0];
            return result;
        } catch (error) {
            if (!(0, $def55b050f09c63c$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) throw error;
        }
        return null;
    }
    /**
     *  Resolves to the address for %%coinType%% or null if the
     *  provided %%coinType%% has not been configured.
     */ async getAddress(coinType) {
        if (coinType == null) coinType = 60;
        if (coinType === 60) try {
            const result = await this.#fetch("addr(bytes32)");
            // No address
            if (result == null || result === (0, $b4909c6a5ae371e9$export$b7cbe423ba83da17)) return null;
            return result;
        } catch (error) {
            if ((0, $def55b050f09c63c$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) return null;
            throw error;
        }
        // Try decoding its EVM canonical chain as an EVM chain address first
        if (coinType >= 0 && coinType < 0x80000000) {
            let ethCoinType = coinType + 0x80000000;
            const data = await this.#fetch("addr(bytes32,uint)", [
                ethCoinType
            ]);
            if ((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(data, 20)) return (0, $61268443a2d16d36$export$88411125f012957a)(data);
        }
        let coinPlugin = null;
        for (const plugin of this.provider.plugins){
            if (!(plugin instanceof $5cf4446c68da03db$export$1e6016d1bbd92d2c)) continue;
            if (plugin.supportsCoinType(coinType)) {
                coinPlugin = plugin;
                break;
            }
        }
        if (coinPlugin == null) return null;
        // keccak256("addr(bytes32,uint256")
        const data = await this.#fetch("addr(bytes32,uint)", [
            coinType
        ]);
        // No address
        if (data == null || data === "0x") return null;
        // Compute the address
        const address = await coinPlugin.decodeAddress(coinType, data);
        if (address != null) return address;
        (0, $def55b050f09c63c$export$a7a9523472993e97)(false, `invalid coin data`, "UNSUPPORTED_OPERATION", {
            operation: `getAddress(${coinType})`,
            info: {
                coinType: coinType,
                data: data
            }
        });
    }
    /**
     *  Resolves to the EIP-634 text record for %%key%%, or ``null``
     *  if unconfigured.
     */ async getText(key) {
        const data = await this.#fetch("text(bytes32,string)", [
            key
        ]);
        if (data == null || data === "0x") return null;
        return data;
    }
    /**
     *  Rsolves to the content-hash or ``null`` if unconfigured.
     */ async getContentHash() {
        // keccak256("contenthash()")
        const data = await this.#fetch("contenthash(bytes32)");
        // No contenthash
        if (data == null || data === "0x") return null;
        // IPFS (CID: 1, Type: 70=DAG-PB, 72=libp2p-key)
        const ipfs = data.match(/^0x(e3010170|e5010172)(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
        if (ipfs) {
            const scheme = ipfs[1] === "e3010170" ? "ipfs" : "ipns";
            const length = parseInt(ipfs[4], 16);
            if (ipfs[5].length === length * 2) return `${scheme}:/\/${(0, $60e672e41142e130$export$743e6bddc3282b13)("0x" + ipfs[2])}`;
        }
        // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
        const swarm = data.match(/^0xe40101fa011b20([0-9a-f]*)$/);
        if (swarm && swarm[1].length === 64) return `bzz:/\/${swarm[1]}`;
        (0, $def55b050f09c63c$export$a7a9523472993e97)(false, `invalid or unsupported content hash data`, "UNSUPPORTED_OPERATION", {
            operation: "getContentHash()",
            info: {
                data: data
            }
        });
    }
    /**
     *  Resolves to the avatar url or ``null`` if the avatar is either
     *  unconfigured or incorrectly configured (e.g. references an NFT
     *  not owned by the address).
     *
     *  If diagnosing issues with configurations, the [[_getAvatar]]
     *  method may be useful.
     */ async getAvatar() {
        const avatar = await this._getAvatar();
        return avatar.url;
    }
    /**
     *  When resolving an avatar, there are many steps involved, such
     *  fetching metadata and possibly validating ownership of an
     *  NFT.
     *
     *  This method can be used to examine each step and the value it
     *  was working from.
     */ async _getAvatar() {
        const linkage = [
            {
                type: "name",
                value: this.name
            }
        ];
        try {
            // test data for ricmoo.eth
            //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
            const avatar = await this.getText("avatar");
            if (avatar == null) {
                linkage.push({
                    type: "!avatar",
                    value: ""
                });
                return {
                    url: null,
                    linkage: linkage
                };
            }
            linkage.push({
                type: "avatar",
                value: avatar
            });
            for(let i = 0; i < $5cf4446c68da03db$var$matchers.length; i++){
                const match = avatar.match($5cf4446c68da03db$var$matchers[i]);
                if (match == null) continue;
                const scheme = match[1].toLowerCase();
                switch(scheme){
                    case "https":
                    case "data":
                        linkage.push({
                            type: "url",
                            value: avatar
                        });
                        return {
                            linkage: linkage,
                            url: avatar
                        };
                    case "ipfs":
                        {
                            const url = $5cf4446c68da03db$var$getIpfsLink(avatar);
                            linkage.push({
                                type: "ipfs",
                                value: avatar
                            });
                            linkage.push({
                                type: "url",
                                value: url
                            });
                            return {
                                linkage: linkage,
                                url: url
                            };
                        }
                    case "erc721":
                    case "erc1155":
                        {
                            // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                            const selector = scheme === "erc721" ? "tokenURI(uint256)" : "uri(uint256)";
                            linkage.push({
                                type: scheme,
                                value: avatar
                            });
                            // The owner of this name
                            const owner = await this.getAddress();
                            if (owner == null) {
                                linkage.push({
                                    type: "!owner",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            const comps = (match[2] || "").split("/");
                            if (comps.length !== 2) {
                                linkage.push({
                                    type: `!${scheme}caip`,
                                    value: match[2] || ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            const tokenId = comps[1];
                            const contract = new (0, $220158e9e9aec1ec$export$8517d80acf00e19a)(comps[0], [
                                // ERC-721
                                "function tokenURI(uint) view returns (string)",
                                "function ownerOf(uint) view returns (address)",
                                // ERC-1155
                                "function uri(uint) view returns (string)",
                                "function balanceOf(address, uint256) view returns (uint)"
                            ], this.provider);
                            // Check that this account owns the token
                            if (scheme === "erc721") {
                                const tokenOwner = await contract.ownerOf(tokenId);
                                if (owner !== tokenOwner) {
                                    linkage.push({
                                        type: "!owner",
                                        value: tokenOwner
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "owner",
                                    value: tokenOwner
                                });
                            } else if (scheme === "erc1155") {
                                const balance = await contract.balanceOf(owner, tokenId);
                                if (!balance) {
                                    linkage.push({
                                        type: "!balance",
                                        value: "0"
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "balance",
                                    value: balance.toString()
                                });
                            }
                            // Call the token contract for the metadata URL
                            let metadataUrl = await contract[selector](tokenId);
                            if (metadataUrl == null || metadataUrl === "0x") {
                                linkage.push({
                                    type: "!metadata-url",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            linkage.push({
                                type: "metadata-url-base",
                                value: metadataUrl
                            });
                            // ERC-1155 allows a generic {id} in the URL
                            if (scheme === "erc1155") {
                                metadataUrl = metadataUrl.replace("{id}", (0, $7df480338fc2bc47$export$c6ebe05badb16181)(tokenId, 32).substring(2));
                                linkage.push({
                                    type: "metadata-url-expanded",
                                    value: metadataUrl
                                });
                            }
                            // Transform IPFS metadata links
                            if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $5cf4446c68da03db$var$getIpfsLink(metadataUrl);
                            linkage.push({
                                type: "metadata-url",
                                value: metadataUrl
                            });
                            // Get the token metadata
                            let metadata = {};
                            const response = await new (0, $639ac0facbde31d2$export$319b96fe59834522)(metadataUrl).send();
                            response.assertOk();
                            try {
                                metadata = response.bodyJson;
                            } catch (error) {
                                try {
                                    linkage.push({
                                        type: "!metadata",
                                        value: response.bodyText
                                    });
                                } catch (error) {
                                    const bytes = response.body;
                                    if (bytes) linkage.push({
                                        type: "!metadata",
                                        value: (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(bytes)
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            if (!metadata) {
                                linkage.push({
                                    type: "!metadata",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            linkage.push({
                                type: "metadata",
                                value: JSON.stringify(metadata)
                            });
                            // Pull the image URL out
                            let imageUrl = metadata.image;
                            if (typeof imageUrl !== "string") {
                                linkage.push({
                                    type: "!imageUrl",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                            else {
                                // Transform IPFS link to gateway
                                const ipfs = imageUrl.match($5cf4446c68da03db$var$matcherIpfs);
                                if (ipfs == null) {
                                    linkage.push({
                                        type: "!imageUrl-ipfs",
                                        value: imageUrl
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "imageUrl-ipfs",
                                    value: imageUrl
                                });
                                imageUrl = $5cf4446c68da03db$var$getIpfsLink(imageUrl);
                            }
                            linkage.push({
                                type: "url",
                                value: imageUrl
                            });
                            return {
                                linkage: linkage,
                                url: imageUrl
                            };
                        }
                }
            }
        } catch (error) {}
        return {
            linkage: linkage,
            url: null
        };
    }
    static async getEnsAddress(provider) {
        const network = await provider.getNetwork();
        const ensPlugin = network.getPlugin("org.ethers.plugins.network.Ens");
        // No ENS...
        (0, $def55b050f09c63c$export$a7a9523472993e97)(ensPlugin, "network does not support ENS", "UNSUPPORTED_OPERATION", {
            operation: "getEnsAddress",
            info: {
                network: network
            }
        });
        return ensPlugin.address;
    }
    static async #getResolver(provider, name) {
        const ensAddr = await $5cf4446c68da03db$export$d04afd034a0a53ae.getEnsAddress(provider);
        try {
            const contract = new (0, $220158e9e9aec1ec$export$8517d80acf00e19a)(ensAddr, [
                "function resolver(bytes32) view returns (address)"
            ], provider);
            const addr = await contract.resolver((0, $1b6f5b1a3d63639b$export$91d651ee363e1209)(name), {
                enableCcipRead: true
            });
            if (addr === (0, $b4909c6a5ae371e9$export$b7cbe423ba83da17)) return null;
            return addr;
        } catch (error) {
            // ENS registry cannot throw errors on resolver(bytes32),
            // so probably a link error
            throw error;
        }
        return null;
    }
    /**
     *  Resolve to the ENS resolver for %%name%% using %%provider%% or
     *  ``null`` if unconfigured.
     */ static async fromName(provider, name) {
        let currentName = name;
        while(true){
            if (currentName === "" || currentName === ".") return null;
            // Optimization since the eth node cannot change and does
            // not have a wildcard resolver
            if (name !== "eth" && currentName === "eth") return null;
            // Check the current node for a resolver
            const addr = await $5cf4446c68da03db$export$d04afd034a0a53ae.#getResolver(provider, currentName);
            // Found a resolver!
            if (addr != null) {
                const resolver = new $5cf4446c68da03db$export$d04afd034a0a53ae(provider, addr, name);
                // Legacy resolver found, using EIP-2544 so it isn't safe to use
                if (currentName !== name && !await resolver.supportsWildcard()) return null;
                return resolver;
            }
            // Get the parent node
            currentName = currentName.split(".").slice(1).join(".");
        }
    }
}


/**
 *  @_ignore
 */ 


function $e2614ba255120e66$export$769b627a7e45189e(tx) {
    const from = (0, $61268443a2d16d36$export$88411125f012957a)(tx.from);
    const nonce = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(tx.nonce, "tx.nonce");
    let nonceHex = nonce.toString(16);
    if (nonceHex === "0") nonceHex = "0x";
    else if (nonceHex.length % 2) nonceHex = "0x0" + nonceHex;
    else nonceHex = "0x" + nonceHex;
    return (0, $61268443a2d16d36$export$88411125f012957a)((0, $8de17c58ebd53b07$export$f6d845ffb449edc9)((0, $1c3ba5429a8a9032$export$f8151fce47ad1c35)((0, $0f38deed45b4ff1d$export$aea7770274d28b7)([
        from,
        nonceHex
    ])), 12));
}
function $e2614ba255120e66$export$e0b22d96621f73a2(_from, _salt, _initCodeHash) {
    const from = (0, $61268443a2d16d36$export$88411125f012957a)(_from);
    const salt = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(_salt, "salt");
    const initCodeHash = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(_initCodeHash, "initCodeHash");
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(salt.length === 32, "salt must be 32 bytes", "salt", _salt);
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(initCodeHash.length === 32, "initCodeHash must be 32 bytes", "initCodeHash", _initCodeHash);
    return (0, $61268443a2d16d36$export$88411125f012957a)((0, $8de17c58ebd53b07$export$f6d845ffb449edc9)((0, $1c3ba5429a8a9032$export$f8151fce47ad1c35)((0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)([
        "0xff",
        from,
        salt,
        initCodeHash
    ])), 12));
}





const $7e15b80ca03879f6$var$BN_0 = BigInt(0);
function $7e15b80ca03879f6$export$4b08254e38b74fcd(format, nullValue) {
    return function(value) {
        if (value == null) return nullValue;
        return format(value);
    };
}
function $7e15b80ca03879f6$export$e57ff0f701c44363(format, allowNull) {
    return (array)=>{
        if (allowNull && array == null) return null;
        if (!Array.isArray(array)) throw new Error("not an array");
        return array.map((i)=>format(i));
    };
}
function $7e15b80ca03879f6$export$be5493f9613cbbe(format, altNames) {
    return (value)=>{
        const result = {};
        for(const key in format){
            let srcKey = key;
            if (altNames && key in altNames && !(srcKey in value)) {
                for (const altKey of altNames[key])if (altKey in value) {
                    srcKey = altKey;
                    break;
                }
            }
            try {
                const nv = format[key](value[srcKey]);
                if (nv !== undefined) result[key] = nv;
            } catch (error) {
                const message = error instanceof Error ? error.message : "not-an-error";
                (0, $def55b050f09c63c$export$a7a9523472993e97)(false, `invalid value for value.${key} (${message})`, "BAD_DATA", {
                    value: value
                });
            }
        }
        return result;
    };
}
function $7e15b80ca03879f6$export$7a3be81718959bda(value) {
    switch(value){
        case true:
        case "true":
            return true;
        case false:
        case "false":
            return false;
    }
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, `invalid boolean; ${JSON.stringify(value)}`, "value", value);
}
function $7e15b80ca03879f6$export$1f26277db27165ba(value) {
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(value, true), "invalid data", "value", value);
    return value;
}
function $7e15b80ca03879f6$export$bb5bc852e1c64b88(value) {
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(value, 32), "invalid hash", "value", value);
    return value;
}
function $7e15b80ca03879f6$export$aff4fda55e7ac0d6(value) {
    if (!(0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(value)) throw new Error("invalid uint256");
    return (0, $8de17c58ebd53b07$export$4473860254365feb)(value, 32);
}
const $7e15b80ca03879f6$var$_formatLog = $7e15b80ca03879f6$export$be5493f9613cbbe({
    address: (0, $61268443a2d16d36$export$88411125f012957a),
    blockHash: $7e15b80ca03879f6$export$bb5bc852e1c64b88,
    blockNumber: (0, $7df480338fc2bc47$export$b14f2714108df84),
    data: $7e15b80ca03879f6$export$1f26277db27165ba,
    index: (0, $7df480338fc2bc47$export$b14f2714108df84),
    removed: $7e15b80ca03879f6$export$4b08254e38b74fcd($7e15b80ca03879f6$export$7a3be81718959bda, false),
    topics: $7e15b80ca03879f6$export$e57ff0f701c44363($7e15b80ca03879f6$export$bb5bc852e1c64b88),
    transactionHash: $7e15b80ca03879f6$export$bb5bc852e1c64b88,
    transactionIndex: (0, $7df480338fc2bc47$export$b14f2714108df84)
}, {
    index: [
        "logIndex"
    ]
});
function $7e15b80ca03879f6$export$fccdbdc2b9d7893(value) {
    return $7e15b80ca03879f6$var$_formatLog(value);
}
const $7e15b80ca03879f6$var$_formatBlock = $7e15b80ca03879f6$export$be5493f9613cbbe({
    hash: $7e15b80ca03879f6$export$4b08254e38b74fcd($7e15b80ca03879f6$export$bb5bc852e1c64b88),
    parentHash: $7e15b80ca03879f6$export$bb5bc852e1c64b88,
    parentBeaconBlockRoot: $7e15b80ca03879f6$export$4b08254e38b74fcd($7e15b80ca03879f6$export$bb5bc852e1c64b88, null),
    number: (0, $7df480338fc2bc47$export$b14f2714108df84),
    timestamp: (0, $7df480338fc2bc47$export$b14f2714108df84),
    nonce: $7e15b80ca03879f6$export$4b08254e38b74fcd($7e15b80ca03879f6$export$1f26277db27165ba),
    difficulty: (0, $7df480338fc2bc47$export$61fe455e2b1e28a4),
    gasLimit: (0, $7df480338fc2bc47$export$61fe455e2b1e28a4),
    gasUsed: (0, $7df480338fc2bc47$export$61fe455e2b1e28a4),
    stateRoot: $7e15b80ca03879f6$export$4b08254e38b74fcd($7e15b80ca03879f6$export$bb5bc852e1c64b88, null),
    receiptsRoot: $7e15b80ca03879f6$export$4b08254e38b74fcd($7e15b80ca03879f6$export$bb5bc852e1c64b88, null),
    blobGasUsed: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $7df480338fc2bc47$export$61fe455e2b1e28a4), null),
    excessBlobGas: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $7df480338fc2bc47$export$61fe455e2b1e28a4), null),
    miner: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $61268443a2d16d36$export$88411125f012957a)),
    prevRandao: $7e15b80ca03879f6$export$4b08254e38b74fcd($7e15b80ca03879f6$export$bb5bc852e1c64b88, null),
    extraData: $7e15b80ca03879f6$export$1f26277db27165ba,
    baseFeePerGas: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $7df480338fc2bc47$export$61fe455e2b1e28a4))
}, {
    prevRandao: [
        "mixHash"
    ]
});
function $7e15b80ca03879f6$export$ba1152bc4017d62a(value) {
    const result = $7e15b80ca03879f6$var$_formatBlock(value);
    result.transactions = value.transactions.map((tx)=>{
        if (typeof tx === "string") return tx;
        return $7e15b80ca03879f6$export$fe50e42b325965d(tx);
    });
    return result;
}
const $7e15b80ca03879f6$var$_formatReceiptLog = $7e15b80ca03879f6$export$be5493f9613cbbe({
    transactionIndex: (0, $7df480338fc2bc47$export$b14f2714108df84),
    blockNumber: (0, $7df480338fc2bc47$export$b14f2714108df84),
    transactionHash: $7e15b80ca03879f6$export$bb5bc852e1c64b88,
    address: (0, $61268443a2d16d36$export$88411125f012957a),
    topics: $7e15b80ca03879f6$export$e57ff0f701c44363($7e15b80ca03879f6$export$bb5bc852e1c64b88),
    data: $7e15b80ca03879f6$export$1f26277db27165ba,
    index: (0, $7df480338fc2bc47$export$b14f2714108df84),
    blockHash: $7e15b80ca03879f6$export$bb5bc852e1c64b88
}, {
    index: [
        "logIndex"
    ]
});
function $7e15b80ca03879f6$export$5ec2fc59e0e92b87(value) {
    return $7e15b80ca03879f6$var$_formatReceiptLog(value);
}
const $7e15b80ca03879f6$var$_formatTransactionReceipt = $7e15b80ca03879f6$export$be5493f9613cbbe({
    to: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $61268443a2d16d36$export$88411125f012957a), null),
    from: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $61268443a2d16d36$export$88411125f012957a), null),
    contractAddress: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $61268443a2d16d36$export$88411125f012957a), null),
    // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
    index: (0, $7df480338fc2bc47$export$b14f2714108df84),
    root: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)),
    gasUsed: (0, $7df480338fc2bc47$export$61fe455e2b1e28a4),
    blobGasUsed: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $7df480338fc2bc47$export$61fe455e2b1e28a4), null),
    logsBloom: $7e15b80ca03879f6$export$4b08254e38b74fcd($7e15b80ca03879f6$export$1f26277db27165ba),
    blockHash: $7e15b80ca03879f6$export$bb5bc852e1c64b88,
    hash: $7e15b80ca03879f6$export$bb5bc852e1c64b88,
    logs: $7e15b80ca03879f6$export$e57ff0f701c44363($7e15b80ca03879f6$export$5ec2fc59e0e92b87),
    blockNumber: (0, $7df480338fc2bc47$export$b14f2714108df84),
    //confirmations: allowNull(getNumber, null),
    cumulativeGasUsed: (0, $7df480338fc2bc47$export$61fe455e2b1e28a4),
    effectiveGasPrice: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $7df480338fc2bc47$export$61fe455e2b1e28a4)),
    blobGasPrice: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $7df480338fc2bc47$export$61fe455e2b1e28a4), null),
    status: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $7df480338fc2bc47$export$b14f2714108df84)),
    type: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $7df480338fc2bc47$export$b14f2714108df84), 0)
}, {
    effectiveGasPrice: [
        "gasPrice"
    ],
    hash: [
        "transactionHash"
    ],
    index: [
        "transactionIndex"
    ]
});
function $7e15b80ca03879f6$export$30da670e49d6fc31(value) {
    return $7e15b80ca03879f6$var$_formatTransactionReceipt(value);
}
function $7e15b80ca03879f6$export$fe50e42b325965d(value) {
    // Some clients (TestRPC) do strange things like return 0x0 for the
    // 0 address; correct this to be a real address
    if (value.to && (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(value.to) === $7e15b80ca03879f6$var$BN_0) value.to = "0x0000000000000000000000000000000000000000";
    const result = $7e15b80ca03879f6$export$be5493f9613cbbe({
        hash: $7e15b80ca03879f6$export$bb5bc852e1c64b88,
        // Some nodes do not return this, usually test nodes (like Ganache)
        index: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $7df480338fc2bc47$export$b14f2714108df84), undefined),
        type: (value)=>{
            if (value === "0x" || value == null) return 0;
            return (0, $7df480338fc2bc47$export$b14f2714108df84)(value);
        },
        accessList: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $63484022a9ae8dfc$export$6c8662b1600dce2), null),
        blobVersionedHashes: $7e15b80ca03879f6$export$4b08254e38b74fcd($7e15b80ca03879f6$export$e57ff0f701c44363($7e15b80ca03879f6$export$bb5bc852e1c64b88, true), null),
        authorizationList: $7e15b80ca03879f6$export$4b08254e38b74fcd($7e15b80ca03879f6$export$e57ff0f701c44363((v)=>{
            let sig;
            if (v.signature) sig = v.signature;
            else {
                let yParity = v.yParity;
                if (yParity === "0x1b") yParity = 0;
                else if (yParity === "0x1c") yParity = 1;
                sig = Object.assign({}, v, {
                    yParity: yParity
                });
            }
            return {
                address: (0, $61268443a2d16d36$export$88411125f012957a)(v.address),
                chainId: (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(v.chainId),
                nonce: (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(v.nonce),
                signature: (0, $37038a1f415943f5$export$848620f5f2f26e86).from(sig)
            };
        }, false), null),
        blockHash: $7e15b80ca03879f6$export$4b08254e38b74fcd($7e15b80ca03879f6$export$bb5bc852e1c64b88, null),
        blockNumber: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $7df480338fc2bc47$export$b14f2714108df84), null),
        transactionIndex: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $7df480338fc2bc47$export$b14f2714108df84), null),
        from: (0, $61268443a2d16d36$export$88411125f012957a),
        // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas) must be set
        gasPrice: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $7df480338fc2bc47$export$61fe455e2b1e28a4)),
        maxPriorityFeePerGas: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $7df480338fc2bc47$export$61fe455e2b1e28a4)),
        maxFeePerGas: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $7df480338fc2bc47$export$61fe455e2b1e28a4)),
        maxFeePerBlobGas: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $7df480338fc2bc47$export$61fe455e2b1e28a4), null),
        gasLimit: (0, $7df480338fc2bc47$export$61fe455e2b1e28a4),
        to: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $61268443a2d16d36$export$88411125f012957a), null),
        value: (0, $7df480338fc2bc47$export$61fe455e2b1e28a4),
        nonce: (0, $7df480338fc2bc47$export$b14f2714108df84),
        data: $7e15b80ca03879f6$export$1f26277db27165ba,
        creates: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $61268443a2d16d36$export$88411125f012957a), null),
        chainId: $7e15b80ca03879f6$export$4b08254e38b74fcd((0, $7df480338fc2bc47$export$61fe455e2b1e28a4), null)
    }, {
        data: [
            "input"
        ],
        gasLimit: [
            "gas"
        ],
        index: [
            "transactionIndex"
        ]
    })(value);
    // If to and creates are empty, populate the creates from the value
    if (result.to == null && result.creates == null) result.creates = (0, $e2614ba255120e66$export$769b627a7e45189e)(result);
    // @TODO: Check fee data
    // Add an access list to supported transaction types
    if ((value.type === 1 || value.type === 2) && value.accessList == null) result.accessList = [];
    // Compute the signature
    if (value.signature) result.signature = (0, $37038a1f415943f5$export$848620f5f2f26e86).from(value.signature);
    else result.signature = (0, $37038a1f415943f5$export$848620f5f2f26e86).from(value);
    // Some backends omit ChainId on legacy transactions, but we can compute it
    if (result.chainId == null) {
        const chainId = result.signature.legacyChainId;
        if (chainId != null) result.chainId = chainId;
    }
    // @TODO: check chainID
    /*
    if (value.chainId != null) {
        let chainId = value.chainId;

        if (isHexString(chainId)) {
            chainId = BigNumber.from(chainId).toNumber();
        }

        result.chainId = chainId;

    } else {
        let chainId = value.networkId;

        // geth-etc returns chainId
        if (chainId == null && result.v == null) {
            chainId = value.chainId;
        }

        if (isHexString(chainId)) {
            chainId = BigNumber.from(chainId).toNumber();
        }

        if (typeof(chainId) !== "number" && result.v != null) {
            chainId = (result.v - 35) / 2;
            if (chainId < 0) { chainId = 0; }
            chainId = parseInt(chainId);
        }

        if (typeof(chainId) !== "number") { chainId = 0; }

        result.chainId = chainId;
    }
    */ // 0x0000... should actually be null
    if (result.blockHash && (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(result.blockHash) === $7e15b80ca03879f6$var$BN_0) result.blockHash = null;
    return result;
}


/**
 *  A **Network** encapsulates the various properties required to
 *  interact with a specific chain.
 *
 *  @_subsection: api/providers:Networks  [networks]
 */ 



const $3f851804a4cd7871$var$EnsAddress = "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e";
class $3f851804a4cd7871$export$10ae60faeb7e2196 {
    /**
     *  The name of the plugin.
     *
     *  It is recommended to use reverse-domain-notation, which permits
     *  unique names with a known authority as well as hierarchal entries.
     */ name;
    /**
     *  Creates a new **NetworkPlugin**.
     */ constructor(name){
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
    /**
     *  Creates a copy of this plugin.
     */ clone() {
        return new $3f851804a4cd7871$export$10ae60faeb7e2196(this.name);
    }
}
class $3f851804a4cd7871$export$f2b0810a2dd50377 extends $3f851804a4cd7871$export$10ae60faeb7e2196 {
    /**
     *  The block number to treat these values as valid from.
     *
     *  This allows a hardfork to have updated values included as well as
     *  mulutiple hardforks to be supported.
     */ effectiveBlock;
    /**
     *  The transactions base fee.
     */ txBase;
    /**
     *  The fee for creating a new account.
     */ txCreate;
    /**
     *  The fee per zero-byte in the data.
     */ txDataZero;
    /**
     *  The fee per non-zero-byte in the data.
     */ txDataNonzero;
    /**
     *  The fee per storage key in the [[link-eip-2930]] access list.
     */ txAccessListStorageKey;
    /**
     *  The fee per address in the [[link-eip-2930]] access list.
     */ txAccessListAddress;
    /**
     *  Creates a new GasCostPlugin from %%effectiveBlock%% until the
     *  latest block or another GasCostPlugin supercedes that block number,
     *  with the associated %%costs%%.
     */ constructor(effectiveBlock, costs){
        if (effectiveBlock == null) effectiveBlock = 0;
        super(`org.ethers.network.plugins.GasCost#${effectiveBlock || 0}`);
        const props = {
            effectiveBlock: effectiveBlock
        };
        function set(name, nullish) {
            let value = (costs || {})[name];
            if (value == null) value = nullish;
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(typeof value === "number", `invalud value for ${name}`, "costs", costs);
            props[name] = value;
        }
        set("txBase", 21000);
        set("txCreate", 32000);
        set("txDataZero", 4);
        set("txDataNonzero", 16);
        set("txAccessListStorageKey", 1900);
        set("txAccessListAddress", 2400);
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, props);
    }
    clone() {
        return new $3f851804a4cd7871$export$f2b0810a2dd50377(this.effectiveBlock, this);
    }
}
class $3f851804a4cd7871$export$9be0b2c573890879 extends $3f851804a4cd7871$export$10ae60faeb7e2196 {
    /**
     *  The ENS Registrty Contract address.
     */ address;
    /**
     *  The chain ID that the ENS contract lives on.
     */ targetNetwork;
    /**
     *  Creates a new **EnsPlugin** connected to %%address%% on the
     *  %%targetNetwork%%. The default ENS address and mainnet is used
     *  if unspecified.
     */ constructor(address, targetNetwork){
        super("org.ethers.plugins.network.Ens");
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            address: address || $3f851804a4cd7871$var$EnsAddress,
            targetNetwork: targetNetwork == null ? 1 : targetNetwork
        });
    }
    clone() {
        return new $3f851804a4cd7871$export$9be0b2c573890879(this.address, this.targetNetwork);
    }
}
class $3f851804a4cd7871$export$dd49482b7e9ea2da extends $3f851804a4cd7871$export$10ae60faeb7e2196 {
    #feeDataFunc;
    /**
     *  The fee data function provided to the constructor.
     */ get feeDataFunc() {
        return this.#feeDataFunc;
    }
    /**
     *  Creates a new **FeeDataNetworkPlugin**.
     */ constructor(feeDataFunc){
        super("org.ethers.plugins.network.FeeData");
        this.#feeDataFunc = feeDataFunc;
    }
    /**
     *  Resolves to the fee data.
     */ async getFeeData(provider) {
        return await this.#feeDataFunc(provider);
    }
    clone() {
        return new $3f851804a4cd7871$export$dd49482b7e9ea2da(this.#feeDataFunc);
    }
}
class $3f851804a4cd7871$export$3bee30f9880d72e8 extends $3f851804a4cd7871$export$10ae60faeb7e2196 {
    #url;
    #processFunc;
    /**
     *  The URL to initialize the FetchRequest with in %%processFunc%%.
     */ get url() {
        return this.#url;
    }
    /**
     *  The callback to use when computing the FeeData.
     */ get processFunc() {
        return this.#processFunc;
    }
    /**
     *  Creates a new **FetchUrlFeeDataNetworkPlugin** which will
     *  be used when computing the fee data for the network.
     */ constructor(url, processFunc){
        super("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
        this.#url = url;
        this.#processFunc = processFunc;
    }
    // We are immutable, so we can serve as our own clone
    clone() {
        return this;
    }
} /*
export class CustomBlockNetworkPlugin extends NetworkPlugin {
    readonly #blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>;
    readonly #blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>;

    constructor(blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>, blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>) {
        super("org.ethers.network-plugins.custom-block");
        this.#blockFunc = blockFunc;
        this.#blockWithTxsFunc = blockWithTxsFunc;
    }

    async getBlock(provider: Provider, block: BlockParams<string>): Promise<Block<string>> {
        return await this.#blockFunc(provider, block);
    }

    async getBlockions(provider: Provider, block: BlockParams<TransactionResponseParams>): Promise<Block<TransactionResponse>> {
        return await this.#blockWithTxsFunc(provider, block);
    }

    clone(): CustomBlockNetworkPlugin {
        return new CustomBlockNetworkPlugin(this.#blockFunc, this.#blockWithTxsFunc);
    }
}
*/ 


/* * * *
// Networks which operation against an L2 can use this plugin to
// specify how to access L1, for the purpose of resolving ENS,
// for example.
export class LayerOneConnectionPlugin extends NetworkPlugin {
    readonly provider!: Provider;
// @TODO: Rename to ChainAccess and allow for connecting to any chain
    constructor(provider: Provider) {
        super("org.ethers.plugins.layer-one-connection");
        defineProperties<LayerOneConnectionPlugin>(this, { provider });
    }

    clone(): LayerOneConnectionPlugin {
        return new LayerOneConnectionPlugin(this.provider);
    }
}
*/ const $1546470158336c71$var$Networks = new Map();
class $1546470158336c71$export$95be4ae94445245a {
    #name;
    #chainId;
    #plugins;
    /**
     *  Creates a new **Network** for %%name%% and %%chainId%%.
     */ constructor(name, chainId){
        this.#name = name;
        this.#chainId = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(chainId);
        this.#plugins = new Map();
    }
    /**
     *  Returns a JSON-compatible representation of a Network.
     */ toJSON() {
        return {
            name: this.name,
            chainId: String(this.chainId)
        };
    }
    /**
     *  The network common name.
     *
     *  This is the canonical name, as networks migh have multiple
     *  names.
     */ get name() {
        return this.#name;
    }
    set name(value) {
        this.#name = value;
    }
    /**
     *  The network chain ID.
     */ get chainId() {
        return this.#chainId;
    }
    set chainId(value) {
        this.#chainId = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(value, "chainId");
    }
    /**
     *  Returns true if %%other%% matches this network. Any chain ID
     *  must match, and if no chain ID is present, the name must match.
     *
     *  This method does not currently check for additional properties,
     *  such as ENS address or plug-in compatibility.
     */ matches(other) {
        if (other == null) return false;
        if (typeof other === "string") {
            try {
                return this.chainId === (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(other);
            } catch (error) {}
            return this.name === other;
        }
        if (typeof other === "number" || typeof other === "bigint") {
            try {
                return this.chainId === (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(other);
            } catch (error) {}
            return false;
        }
        if (typeof other === "object") {
            if (other.chainId != null) {
                try {
                    return this.chainId === (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(other.chainId);
                } catch (error) {}
                return false;
            }
            if (other.name != null) return this.name === other.name;
            return false;
        }
        return false;
    }
    /**
     *  Returns the list of plugins currently attached to this Network.
     */ get plugins() {
        return Array.from(this.#plugins.values());
    }
    /**
     *  Attach a new %%plugin%% to this Network. The network name
     *  must be unique, excluding any fragment.
     */ attachPlugin(plugin) {
        if (this.#plugins.get(plugin.name)) throw new Error(`cannot replace existing plugin: ${plugin.name} `);
        this.#plugins.set(plugin.name, plugin.clone());
        return this;
    }
    /**
     *  Return the plugin, if any, matching %%name%% exactly. Plugins
     *  with fragments will not be returned unless %%name%% includes
     *  a fragment.
     */ getPlugin(name) {
        return this.#plugins.get(name) || null;
    }
    /**
     *  Gets a list of all plugins that match %%name%%, with otr without
     *  a fragment.
     */ getPlugins(basename) {
        return this.plugins.filter((p)=>p.name.split("#")[0] === basename);
    }
    /**
     *  Create a copy of this Network.
     */ clone() {
        const clone = new $1546470158336c71$export$95be4ae94445245a(this.name, this.chainId);
        this.plugins.forEach((plugin)=>{
            clone.attachPlugin(plugin.clone());
        });
        return clone;
    }
    /**
     *  Compute the intrinsic gas required for a transaction.
     *
     *  A GasCostPlugin can be attached to override the default
     *  values.
     */ computeIntrinsicGas(tx) {
        const costs = this.getPlugin("org.ethers.plugins.network.GasCost") || new (0, $3f851804a4cd7871$export$f2b0810a2dd50377)();
        let gas = costs.txBase;
        if (tx.to == null) gas += costs.txCreate;
        if (tx.data) {
            for(let i = 2; i < tx.data.length; i += 2)if (tx.data.substring(i, i + 2) === "00") gas += costs.txDataZero;
            else gas += costs.txDataNonzero;
        }
        if (tx.accessList) {
            const accessList = (0, $63484022a9ae8dfc$export$6c8662b1600dce2)(tx.accessList);
            for(const addr in accessList)gas += costs.txAccessListAddress + costs.txAccessListStorageKey * accessList[addr].storageKeys.length;
        }
        return gas;
    }
    /**
     *  Returns a new Network for the %%network%% name or chainId.
     */ static from(network) {
        $1546470158336c71$var$injectCommonNetworks();
        // Default network
        if (network == null) return $1546470158336c71$export$95be4ae94445245a.from("mainnet");
        // Canonical name or chain ID
        if (typeof network === "number") network = BigInt(network);
        if (typeof network === "string" || typeof network === "bigint") {
            const networkFunc = $1546470158336c71$var$Networks.get(network);
            if (networkFunc) return networkFunc();
            if (typeof network === "bigint") return new $1546470158336c71$export$95be4ae94445245a("unknown", network);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "unknown network", "network", network);
        }
        // Clonable with network-like abilities
        if (typeof network.clone === "function") {
            const clone = network.clone();
            //if (typeof(network.name) !== "string" || typeof(network.chainId) !== "number") {
            //}
            return clone;
        }
        // Networkish
        if (typeof network === "object") {
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(typeof network.name === "string" && typeof network.chainId === "number", "invalid network object name or chainId", "network", network);
            const custom = new $1546470158336c71$export$95be4ae94445245a(network.name, network.chainId);
            if (network.ensAddress || network.ensNetwork != null) custom.attachPlugin(new (0, $3f851804a4cd7871$export$9be0b2c573890879)(network.ensAddress, network.ensNetwork));
            //if ((<any>network).layerOneConnection) {
            //    custom.attachPlugin(new LayerOneConnectionPlugin((<any>network).layerOneConnection));
            //}
            return custom;
        }
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "invalid network", "network", network);
    }
    /**
     *  Register %%nameOrChainId%% with a function which returns
     *  an instance of a Network representing that chain.
     */ static register(nameOrChainId, networkFunc) {
        if (typeof nameOrChainId === "number") nameOrChainId = BigInt(nameOrChainId);
        const existing = $1546470158336c71$var$Networks.get(nameOrChainId);
        if (existing) (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, `conflicting network for ${JSON.stringify(existing.name)}`, "nameOrChainId", nameOrChainId);
        $1546470158336c71$var$Networks.set(nameOrChainId, networkFunc);
    }
}
// We don't want to bring in formatUnits because it is backed by
// FixedNumber and we want to keep Networks tiny. The values
// included by the Gas Stations are also IEEE 754 with lots of
// rounding issues and exceed the strict checks formatUnits has.
function $1546470158336c71$var$parseUnits(_value, decimals) {
    const value = String(_value);
    if (!value.match(/^[0-9.]+$/)) throw new Error(`invalid gwei value: ${_value}`);
    // Break into [ whole, fraction ]
    const comps = value.split(".");
    if (comps.length === 1) comps.push("");
    // More than 1 decimal point or too many fractional positions
    if (comps.length !== 2) throw new Error(`invalid gwei value: ${_value}`);
    // Pad the fraction to 9 decimalplaces
    while(comps[1].length < decimals)comps[1] += "0";
    // Too many decimals and some non-zero ending, take the ceiling
    if (comps[1].length > 9) {
        let frac = BigInt(comps[1].substring(0, 9));
        if (!comps[1].substring(9).match(/^0+$/)) frac++;
        comps[1] = frac.toString();
    }
    return BigInt(comps[0] + comps[1]);
}
// Used by Polygon to use a gas station for fee data
function $1546470158336c71$var$getGasStationPlugin(url) {
    return new (0, $3f851804a4cd7871$export$3bee30f9880d72e8)(url, async (fetchFeeData, provider, request)=>{
        // Prevent Cloudflare from blocking our request in node.js
        request.setHeader("User-Agent", "ethers");
        let response;
        try {
            const [_response, _feeData] = await Promise.all([
                request.send(),
                fetchFeeData()
            ]);
            response = _response;
            const payload = response.bodyJson.standard;
            const feeData = {
                gasPrice: _feeData.gasPrice,
                maxFeePerGas: $1546470158336c71$var$parseUnits(payload.maxFee, 9),
                maxPriorityFeePerGas: $1546470158336c71$var$parseUnits(payload.maxPriorityFee, 9)
            };
            return feeData;
        } catch (error) {
            (0, $def55b050f09c63c$export$a7a9523472993e97)(false, `error encountered with polygon gas station (${JSON.stringify(request.url)})`, "SERVER_ERROR", {
                request: request,
                response: response,
                error: error
            });
        }
    });
}
// See: https://chainlist.org
let $1546470158336c71$var$injected = false;
function $1546470158336c71$var$injectCommonNetworks() {
    if ($1546470158336c71$var$injected) return;
    $1546470158336c71$var$injected = true;
    /// Register popular Ethereum networks
    function registerEth(name, chainId, options) {
        const func = function() {
            const network = new $1546470158336c71$export$95be4ae94445245a(name, chainId);
            // We use 0 to disable ENS
            if (options.ensNetwork != null) network.attachPlugin(new (0, $3f851804a4cd7871$export$9be0b2c573890879)(null, options.ensNetwork));
            network.attachPlugin(new (0, $3f851804a4cd7871$export$f2b0810a2dd50377)());
            (options.plugins || []).forEach((plugin)=>{
                network.attachPlugin(plugin);
            });
            return network;
        };
        // Register the network by name and chain ID
        $1546470158336c71$export$95be4ae94445245a.register(name, func);
        $1546470158336c71$export$95be4ae94445245a.register(chainId, func);
        if (options.altNames) options.altNames.forEach((name)=>{
            $1546470158336c71$export$95be4ae94445245a.register(name, func);
        });
    }
    registerEth("mainnet", 1, {
        ensNetwork: 1,
        altNames: [
            "homestead"
        ]
    });
    registerEth("ropsten", 3, {
        ensNetwork: 3
    });
    registerEth("rinkeby", 4, {
        ensNetwork: 4
    });
    registerEth("goerli", 5, {
        ensNetwork: 5
    });
    registerEth("kovan", 42, {
        ensNetwork: 42
    });
    registerEth("sepolia", 11155111, {
        ensNetwork: 11155111
    });
    registerEth("holesky", 17000, {
        ensNetwork: 17000
    });
    registerEth("classic", 61, {});
    registerEth("classicKotti", 6, {});
    registerEth("arbitrum", 42161, {
        ensNetwork: 1
    });
    registerEth("arbitrum-goerli", 421613, {});
    registerEth("arbitrum-sepolia", 421614, {});
    registerEth("base", 8453, {
        ensNetwork: 1
    });
    registerEth("base-goerli", 84531, {});
    registerEth("base-sepolia", 84532, {});
    registerEth("bnb", 56, {
        ensNetwork: 1
    });
    registerEth("bnbt", 97, {});
    registerEth("linea", 59144, {
        ensNetwork: 1
    });
    registerEth("linea-goerli", 59140, {});
    registerEth("linea-sepolia", 59141, {});
    registerEth("matic", 137, {
        ensNetwork: 1,
        plugins: [
            $1546470158336c71$var$getGasStationPlugin("https://gasstation.polygon.technology/v2")
        ]
    });
    registerEth("matic-amoy", 80002, {});
    registerEth("matic-mumbai", 80001, {
        altNames: [
            "maticMumbai",
            "maticmum"
        ],
        plugins: [
            $1546470158336c71$var$getGasStationPlugin("https://gasstation-testnet.polygon.technology/v2")
        ]
    });
    registerEth("optimism", 10, {
        ensNetwork: 1,
        plugins: []
    });
    registerEth("optimism-goerli", 420, {});
    registerEth("optimism-sepolia", 11155420, {});
    registerEth("xdai", 100, {
        ensNetwork: 1
    });
}




function $02aebfef9941c580$var$copy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
function $02aebfef9941c580$export$c1d4f1f6d1988b77(provider, event) {
    if (event === "block") return new $02aebfef9941c580$export$aaf796a16ac1a157(provider);
    if ((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(event, 32)) return new $02aebfef9941c580$export$4fe8a9740765f97e(provider, event);
    (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "unsupported polling event", "UNSUPPORTED_OPERATION", {
        operation: "getPollingSubscriber",
        info: {
            event: event
        }
    });
}
class $02aebfef9941c580$export$aaf796a16ac1a157 {
    #provider;
    #poller;
    #interval;
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    #blockNumber;
    /**
     *  Create a new **PollingBlockSubscriber** attached to %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#poller = null;
        this.#interval = 4000;
        this.#blockNumber = -2;
    }
    /**
     *  The polling interval.
     */ get pollingInterval() {
        return this.#interval;
    }
    set pollingInterval(value) {
        this.#interval = value;
    }
    async #poll() {
        try {
            const blockNumber = await this.#provider.getBlockNumber();
            // Bootstrap poll to setup our initial block number
            if (this.#blockNumber === -2) {
                this.#blockNumber = blockNumber;
                return;
            }
            // @TODO: Put a cap on the maximum number of events per loop?
            if (blockNumber !== this.#blockNumber) {
                for(let b = this.#blockNumber + 1; b <= blockNumber; b++){
                    // We have been stopped
                    if (this.#poller == null) return;
                    await this.#provider.emit("block", b);
                }
                this.#blockNumber = blockNumber;
            }
        } catch (error) {
        // @TODO: Minor bump, add an "error" event to let subscribers
        //        know things went awry.
        //console.log(error);
        }
        // We have been stopped
        if (this.#poller == null) return;
        this.#poller = this.#provider._setTimeout(this.#poll.bind(this), this.#interval);
    }
    start() {
        if (this.#poller) return;
        this.#poller = this.#provider._setTimeout(this.#poll.bind(this), this.#interval);
        this.#poll();
    }
    stop() {
        if (!this.#poller) return;
        this.#provider._clearTimeout(this.#poller);
        this.#poller = null;
    }
    pause(dropWhilePaused) {
        this.stop();
        if (dropWhilePaused) this.#blockNumber = -2;
    }
    resume() {
        this.start();
    }
}
class $02aebfef9941c580$export$e8024646c9bd1a27 {
    #provider;
    #poll;
    #running;
    /**
     *  Create a new **OnBlockSubscriber** attached to %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#running = false;
        this.#poll = (blockNumber)=>{
            this._poll(blockNumber, this.#provider);
        };
    }
    /**
     *  Called on every new block.
     */ async _poll(blockNumber, provider) {
        throw new Error("sub-classes must override this");
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        this.#poll(-2);
        this.#provider.on("block", this.#poll);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#provider.off("block", this.#poll);
    }
    pause(dropWhilePaused) {
        this.stop();
    }
    resume() {
        this.start();
    }
}
class $02aebfef9941c580$export$63862f83f14090ef extends $02aebfef9941c580$export$e8024646c9bd1a27 {
    #tag;
    #lastBlock;
    constructor(provider, tag){
        super(provider);
        this.#tag = tag;
        this.#lastBlock = -2;
    }
    pause(dropWhilePaused) {
        if (dropWhilePaused) this.#lastBlock = -2;
        super.pause(dropWhilePaused);
    }
    async _poll(blockNumber, provider) {
        const block = await provider.getBlock(this.#tag);
        if (block == null) return;
        if (this.#lastBlock === -2) this.#lastBlock = block.number;
        else if (block.number > this.#lastBlock) {
            provider.emit(this.#tag, block.number);
            this.#lastBlock = block.number;
        }
    }
}
class $02aebfef9941c580$export$e4ed5c6414dc4e9e extends $02aebfef9941c580$export$e8024646c9bd1a27 {
    #filter;
    constructor(provider, filter){
        super(provider);
        this.#filter = $02aebfef9941c580$var$copy(filter);
    }
    async _poll(blockNumber, provider) {
        throw new Error("@TODO");
    }
}
class $02aebfef9941c580$export$4fe8a9740765f97e extends $02aebfef9941c580$export$e8024646c9bd1a27 {
    #hash;
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%hash%%.
     */ constructor(provider, hash){
        super(provider);
        this.#hash = hash;
    }
    async _poll(blockNumber, provider) {
        const tx = await provider.getTransactionReceipt(this.#hash);
        if (tx) provider.emit(this.#hash, tx);
    }
}
class $02aebfef9941c580$export$bdb759dc2fe68c72 {
    #provider;
    #filter;
    #poller;
    #running;
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    #blockNumber;
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%filter%%.
     */ constructor(provider, filter){
        this.#provider = provider;
        this.#filter = $02aebfef9941c580$var$copy(filter);
        this.#poller = this.#poll.bind(this);
        this.#running = false;
        this.#blockNumber = -2;
    }
    async #poll(blockNumber) {
        // The initial block hasn't been determined yet
        if (this.#blockNumber === -2) return;
        const filter = $02aebfef9941c580$var$copy(this.#filter);
        filter.fromBlock = this.#blockNumber + 1;
        filter.toBlock = blockNumber;
        const logs = await this.#provider.getLogs(filter);
        // No logs could just mean the node has not indexed them yet,
        // so we keep a sliding window of 60 blocks to keep scanning
        if (logs.length === 0) {
            if (this.#blockNumber < blockNumber - 60) this.#blockNumber = blockNumber - 60;
            return;
        }
        for (const log of logs){
            this.#provider.emit(this.#filter, log);
            // Only advance the block number when logs were found to
            // account for networks (like BNB and Polygon) which may
            // sacrifice event consistency for block event speed
            this.#blockNumber = log.blockNumber;
        }
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        if (this.#blockNumber === -2) this.#provider.getBlockNumber().then((blockNumber)=>{
            this.#blockNumber = blockNumber;
        });
        this.#provider.on("block", this.#poller);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#provider.off("block", this.#poller);
    }
    pause(dropWhilePaused) {
        this.stop();
        if (dropWhilePaused) this.#blockNumber = -2;
    }
    resume() {
        this.start();
    }
}


// Constants
const $b1c9b35e5c4247ce$var$BN_2 = BigInt(2);
const $b1c9b35e5c4247ce$var$MAX_CCIP_REDIRECTS = 10;
function $b1c9b35e5c4247ce$var$isPromise(value) {
    return value && typeof value.then === "function";
}
function $b1c9b35e5c4247ce$var$getTag(prefix, value) {
    return prefix + ":" + JSON.stringify(value, (k, v)=>{
        if (v == null) return "null";
        if (typeof v === "bigint") return `bigint:${v.toString()}`;
        if (typeof v === "string") return v.toLowerCase();
        // Sort object keys
        if (typeof v === "object" && !Array.isArray(v)) {
            const keys = Object.keys(v);
            keys.sort();
            return keys.reduce((accum, key)=>{
                accum[key] = v[key];
                return accum;
            }, {});
        }
        return v;
    });
}
class $b1c9b35e5c4247ce$export$f255b979f86248fa {
    /**
     *  The name fof the event.
     */ name;
    /**
     *  Create a new UnmanagedSubscriber with %%name%%.
     */ constructor(name){
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
    start() {}
    stop() {}
    pause(dropWhilePaused) {}
    resume() {}
}
function $b1c9b35e5c4247ce$var$copy(value) {
    return JSON.parse(JSON.stringify(value));
}
function $b1c9b35e5c4247ce$var$concisify(items) {
    items = Array.from(new Set(items).values());
    items.sort();
    return items;
}
async function $b1c9b35e5c4247ce$var$getSubscription(_event, provider) {
    if (_event == null) throw new Error("invalid event");
    // Normalize topic array info an EventFilter
    if (Array.isArray(_event)) _event = {
        topics: _event
    };
    if (typeof _event === "string") switch(_event){
        case "block":
        case "debug":
        case "error":
        case "finalized":
        case "network":
        case "pending":
        case "safe":
            return {
                type: _event,
                tag: _event
            };
    }
    if ((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(_event, 32)) {
        const hash = _event.toLowerCase();
        return {
            type: "transaction",
            tag: $b1c9b35e5c4247ce$var$getTag("tx", {
                hash: hash
            }),
            hash: hash
        };
    }
    if (_event.orphan) {
        const event = _event;
        // @TODO: Should lowercase and whatnot things here instead of copy...
        return {
            type: "orphan",
            tag: $b1c9b35e5c4247ce$var$getTag("orphan", event),
            filter: $b1c9b35e5c4247ce$var$copy(event)
        };
    }
    if (_event.address || _event.topics) {
        const event = _event;
        const filter = {
            topics: (event.topics || []).map((t)=>{
                if (t == null) return null;
                if (Array.isArray(t)) return $b1c9b35e5c4247ce$var$concisify(t.map((t)=>t.toLowerCase()));
                return t.toLowerCase();
            })
        };
        if (event.address) {
            const addresses = [];
            const promises = [];
            const addAddress = (addr)=>{
                if ((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(addr)) addresses.push(addr);
                else promises.push((async ()=>{
                    addresses.push(await (0, $d6021cd5b8a26773$export$687eed6b344123c9)(addr, provider));
                })());
            };
            if (Array.isArray(event.address)) event.address.forEach(addAddress);
            else addAddress(event.address);
            if (promises.length) await Promise.all(promises);
            filter.address = $b1c9b35e5c4247ce$var$concisify(addresses.map((a)=>a.toLowerCase()));
        }
        return {
            filter: filter,
            tag: $b1c9b35e5c4247ce$var$getTag("event", filter),
            type: "event"
        };
    }
    (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "unknown ProviderEvent", "event", _event);
}
function $b1c9b35e5c4247ce$var$getTime() {
    return new Date().getTime();
}
const $b1c9b35e5c4247ce$var$defaultOptions = {
    cacheTimeout: 250,
    pollingInterval: 4000
};
class $b1c9b35e5c4247ce$export$ae9650e85fb229fe {
    #subs;
    #plugins;
    // null=unpaused, true=paused+dropWhilePaused, false=paused
    #pausedState;
    #destroyed;
    #networkPromise;
    #anyNetwork;
    #performCache;
    // The most recent block number if running an event or -1 if no "block" event
    #lastBlockNumber;
    #nextTimer;
    #timers;
    #disableCcipRead;
    #options;
    /**
     *  Create a new **AbstractProvider** connected to %%network%%, or
     *  use the various network detection capabilities to discover the
     *  [[Network]] if necessary.
     */ constructor(_network, options){
        this.#options = Object.assign({}, $b1c9b35e5c4247ce$var$defaultOptions, options || {});
        if (_network === "any") {
            this.#anyNetwork = true;
            this.#networkPromise = null;
        } else if (_network) {
            const network = (0, $1546470158336c71$export$95be4ae94445245a).from(_network);
            this.#anyNetwork = false;
            this.#networkPromise = Promise.resolve(network);
            setTimeout(()=>{
                this.emit("network", network, null);
            }, 0);
        } else {
            this.#anyNetwork = false;
            this.#networkPromise = null;
        }
        this.#lastBlockNumber = -1;
        this.#performCache = new Map();
        this.#subs = new Map();
        this.#plugins = new Map();
        this.#pausedState = null;
        this.#destroyed = false;
        this.#nextTimer = 1;
        this.#timers = new Map();
        this.#disableCcipRead = false;
    }
    get pollingInterval() {
        return this.#options.pollingInterval;
    }
    /**
     *  Returns ``this``, to allow an **AbstractProvider** to implement
     *  the [[ContractRunner]] interface.
     */ get provider() {
        return this;
    }
    /**
     *  Returns all the registered plug-ins.
     */ get plugins() {
        return Array.from(this.#plugins.values());
    }
    /**
     *  Attach a new plug-in.
     */ attachPlugin(plugin) {
        if (this.#plugins.get(plugin.name)) throw new Error(`cannot replace existing plugin: ${plugin.name} `);
        this.#plugins.set(plugin.name, plugin.connect(this));
        return this;
    }
    /**
     *  Get a plugin by name.
     */ getPlugin(name) {
        return this.#plugins.get(name) || null;
    }
    /**
     *  Prevent any CCIP-read operation, regardless of whether requested
     *  in a [[call]] using ``enableCcipRead``.
     */ get disableCcipRead() {
        return this.#disableCcipRead;
    }
    set disableCcipRead(value) {
        this.#disableCcipRead = !!value;
    }
    // Shares multiple identical requests made during the same 250ms
    async #perform(req) {
        const timeout = this.#options.cacheTimeout;
        // Caching disabled
        if (timeout < 0) return await this._perform(req);
        // Create a tag
        const tag = $b1c9b35e5c4247ce$var$getTag(req.method, req);
        let perform = this.#performCache.get(tag);
        if (!perform) {
            perform = this._perform(req);
            this.#performCache.set(tag, perform);
            setTimeout(()=>{
                if (this.#performCache.get(tag) === perform) this.#performCache.delete(tag);
            }, timeout);
        }
        return await perform;
    }
    /**
     *  Resolves to the data for executing the CCIP-read operations.
     */ async ccipReadFetch(tx, calldata, urls) {
        if (this.disableCcipRead || urls.length === 0 || tx.to == null) return null;
        const sender = tx.to.toLowerCase();
        const data = calldata.toLowerCase();
        const errorMessages = [];
        for(let i = 0; i < urls.length; i++){
            const url = urls[i];
            // URL expansion
            const href = url.replace("{sender}", sender).replace("{data}", data);
            // If no {data} is present, use POST; otherwise GET
            //const json: string | null = (url.indexOf("{data}") >= 0) ? null: JSON.stringify({ data, sender });
            //const result = await fetchJson({ url: href, errorPassThrough: true }, json, (value, response) => {
            //    value.status = response.statusCode;
            //    return value;
            //});
            const request = new (0, $639ac0facbde31d2$export$319b96fe59834522)(href);
            if (url.indexOf("{data}") === -1) request.body = {
                data: data,
                sender: sender
            };
            this.emit("debug", {
                action: "sendCcipReadFetchRequest",
                request: request,
                index: i,
                urls: urls
            });
            let errorMessage = "unknown error";
            // Fetch the resource...
            let resp;
            try {
                resp = await request.send();
            } catch (error) {
                // ...low-level fetch error (missing host, bad SSL, etc.),
                // so try next URL
                errorMessages.push(error.message);
                this.emit("debug", {
                    action: "receiveCcipReadFetchError",
                    request: request,
                    result: {
                        error: error
                    }
                });
                continue;
            }
            try {
                const result = resp.bodyJson;
                if (result.data) {
                    this.emit("debug", {
                        action: "receiveCcipReadFetchResult",
                        request: request,
                        result: result
                    });
                    return result.data;
                }
                if (result.message) errorMessage = result.message;
                this.emit("debug", {
                    action: "receiveCcipReadFetchError",
                    request: request,
                    result: result
                });
            } catch (error) {}
            // 4xx indicates the result is not present; stop
            (0, $def55b050f09c63c$export$a7a9523472993e97)(resp.statusCode < 400 || resp.statusCode >= 500, `response not found during CCIP fetch: ${errorMessage}`, "OFFCHAIN_FAULT", {
                reason: "404_MISSING_RESOURCE",
                transaction: tx,
                info: {
                    url: url,
                    errorMessage: errorMessage
                }
            });
            // 5xx indicates server issue; try the next url
            errorMessages.push(errorMessage);
        }
        (0, $def55b050f09c63c$export$a7a9523472993e97)(false, `error encountered during CCIP fetch: ${errorMessages.map((m)=>JSON.stringify(m)).join(", ")}`, "OFFCHAIN_FAULT", {
            reason: "500_SERVER_ERROR",
            transaction: tx,
            info: {
                urls: urls,
                errorMessages: errorMessages
            }
        });
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a block before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Block]].
     */ _wrapBlock(value, network) {
        return new (0, $daa40c4afcf2fddc$export$d96a8827a60d6b69)((0, $7e15b80ca03879f6$export$ba1152bc4017d62a)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a log before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Log]].
     */ _wrapLog(value, network) {
        return new (0, $daa40c4afcf2fddc$export$ce30dbb46644d06c)((0, $7e15b80ca03879f6$export$fccdbdc2b9d7893)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  receipt before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionReceipt]].
     */ _wrapTransactionReceipt(value, network) {
        return new (0, $daa40c4afcf2fddc$export$375ffd5683aa5c1c)((0, $7e15b80ca03879f6$export$30da670e49d6fc31)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  response before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionResponse]].
     */ _wrapTransactionResponse(tx, network) {
        return new (0, $daa40c4afcf2fddc$export$70966cdb3bfc0785)((0, $7e15b80ca03879f6$export$fe50e42b325965d)(tx), this);
    }
    /**
     *  Resolves to the Network, forcing a network detection using whatever
     *  technique the sub-class requires.
     *
     *  Sub-classes **must** override this.
     */ _detectNetwork() {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "sub-classes must implement this", "UNSUPPORTED_OPERATION", {
            operation: "_detectNetwork"
        });
    }
    /**
     *  Sub-classes should use this to perform all built-in operations. All
     *  methods sanitizes and normalizes the values passed into this.
     *
     *  Sub-classes **must** override this.
     */ async _perform(req) {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(false, `unsupported method: ${req.method}`, "UNSUPPORTED_OPERATION", {
            operation: req.method,
            info: req
        });
    }
    // State
    async getBlockNumber() {
        const blockNumber = (0, $7df480338fc2bc47$export$b14f2714108df84)(await this.#perform({
            method: "getBlockNumber"
        }), "%response");
        if (this.#lastBlockNumber >= 0) this.#lastBlockNumber = blockNumber;
        return blockNumber;
    }
    /**
     *  Returns or resolves to the address for %%address%%, resolving ENS
     *  names and [[Addressable]] objects and returning if already an
     *  address.
     */ _getAddress(address) {
        return (0, $d6021cd5b8a26773$export$687eed6b344123c9)(address, this);
    }
    /**
     *  Returns or resolves to a valid block tag for %%blockTag%%, resolving
     *  negative values and returning if already a valid block tag.
     */ _getBlockTag(blockTag) {
        if (blockTag == null) return "latest";
        switch(blockTag){
            case "earliest":
                return "0x0";
            case "finalized":
            case "latest":
            case "pending":
            case "safe":
                return blockTag;
        }
        if ((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(blockTag)) {
            if ((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(blockTag, 32)) return blockTag;
            return (0, $7df480338fc2bc47$export$d9c067986dbc68dd)(blockTag);
        }
        if (typeof blockTag === "bigint") blockTag = (0, $7df480338fc2bc47$export$b14f2714108df84)(blockTag, "blockTag");
        if (typeof blockTag === "number") {
            if (blockTag >= 0) return (0, $7df480338fc2bc47$export$d9c067986dbc68dd)(blockTag);
            if (this.#lastBlockNumber >= 0) return (0, $7df480338fc2bc47$export$d9c067986dbc68dd)(this.#lastBlockNumber + blockTag);
            return this.getBlockNumber().then((b)=>(0, $7df480338fc2bc47$export$d9c067986dbc68dd)(b + blockTag));
        }
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "invalid blockTag", "blockTag", blockTag);
    }
    /**
     *  Returns or resolves to a filter for %%filter%%, resolving any ENS
     *  names or [[Addressable]] object and returning if already a valid
     *  filter.
     */ _getFilter(filter) {
        // Create a canonical representation of the topics
        const topics = (filter.topics || []).map((t)=>{
            if (t == null) return null;
            if (Array.isArray(t)) return $b1c9b35e5c4247ce$var$concisify(t.map((t)=>t.toLowerCase()));
            return t.toLowerCase();
        });
        const blockHash = "blockHash" in filter ? filter.blockHash : undefined;
        const resolve = (_address, fromBlock, toBlock)=>{
            let address = undefined;
            switch(_address.length){
                case 0:
                    break;
                case 1:
                    address = _address[0];
                    break;
                default:
                    _address.sort();
                    address = _address;
            }
            if (blockHash) {
                if (fromBlock != null || toBlock != null) throw new Error("invalid filter");
            }
            const filter = {};
            if (address) filter.address = address;
            if (topics.length) filter.topics = topics;
            if (fromBlock) filter.fromBlock = fromBlock;
            if (toBlock) filter.toBlock = toBlock;
            if (blockHash) filter.blockHash = blockHash;
            return filter;
        };
        // Addresses could be async (ENS names or Addressables)
        let address = [];
        if (filter.address) {
            if (Array.isArray(filter.address)) for (const addr of filter.address)address.push(this._getAddress(addr));
            else address.push(this._getAddress(filter.address));
        }
        let fromBlock = undefined;
        if ("fromBlock" in filter) fromBlock = this._getBlockTag(filter.fromBlock);
        let toBlock = undefined;
        if ("toBlock" in filter) toBlock = this._getBlockTag(filter.toBlock);
        if (address.filter((a)=>typeof a !== "string").length || fromBlock != null && typeof fromBlock !== "string" || toBlock != null && typeof toBlock !== "string") return Promise.all([
            Promise.all(address),
            fromBlock,
            toBlock
        ]).then((result)=>{
            return resolve(result[0], result[1], result[2]);
        });
        return resolve(address, fromBlock, toBlock);
    }
    /**
     *  Returns or resolves to a transaction for %%request%%, resolving
     *  any ENS names or [[Addressable]] and returning if already a valid
     *  transaction.
     */ _getTransactionRequest(_request) {
        const request = (0, $daa40c4afcf2fddc$export$607b34cdac162b7f)(_request);
        const promises = [];
        [
            "to",
            "from"
        ].forEach((key)=>{
            if (request[key] == null) return;
            const addr = (0, $d6021cd5b8a26773$export$687eed6b344123c9)(request[key], this);
            if ($b1c9b35e5c4247ce$var$isPromise(addr)) promises.push(async function() {
                request[key] = await addr;
            }());
            else request[key] = addr;
        });
        if (request.blockTag != null) {
            const blockTag = this._getBlockTag(request.blockTag);
            if ($b1c9b35e5c4247ce$var$isPromise(blockTag)) promises.push(async function() {
                request.blockTag = await blockTag;
            }());
            else request.blockTag = blockTag;
        }
        if (promises.length) return async function() {
            await Promise.all(promises);
            return request;
        }();
        return request;
    }
    async getNetwork() {
        // No explicit network was set and this is our first time
        if (this.#networkPromise == null) {
            // Detect the current network (shared with all calls)
            const detectNetwork = (async ()=>{
                try {
                    const network = await this._detectNetwork();
                    this.emit("network", network, null);
                    return network;
                } catch (error) {
                    if (this.#networkPromise === detectNetwork) this.#networkPromise = null;
                    throw error;
                }
            })();
            this.#networkPromise = detectNetwork;
            return (await detectNetwork).clone();
        }
        const networkPromise = this.#networkPromise;
        const [expected, actual] = await Promise.all([
            networkPromise,
            this._detectNetwork() // The actual connected network
        ]);
        if (expected.chainId !== actual.chainId) {
            if (this.#anyNetwork) {
                // The "any" network can change, so notify listeners
                this.emit("network", actual, expected);
                // Update the network if something else hasn't already changed it
                if (this.#networkPromise === networkPromise) this.#networkPromise = Promise.resolve(actual);
            } else // Otherwise, we do not allow changes to the underlying network
            (0, $def55b050f09c63c$export$a7a9523472993e97)(false, `network changed: ${expected.chainId} => ${actual.chainId} `, "NETWORK_ERROR", {
                event: "changed"
            });
        }
        return expected.clone();
    }
    async getFeeData() {
        const network = await this.getNetwork();
        const getFeeDataFunc = async ()=>{
            const { _block: _block, gasPrice: gasPrice, priorityFee: priorityFee } = await (0, $5c7e3a359d4744c6$export$d503dd157d963b60)({
                _block: this.#getBlock("latest", false),
                gasPrice: (async ()=>{
                    try {
                        const value = await this.#perform({
                            method: "getGasPrice"
                        });
                        return (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(value, "%response");
                    } catch (error) {}
                    return null;
                })(),
                priorityFee: (async ()=>{
                    try {
                        const value = await this.#perform({
                            method: "getPriorityFee"
                        });
                        return (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(value, "%response");
                    } catch (error) {}
                    return null;
                })()
            });
            let maxFeePerGas = null;
            let maxPriorityFeePerGas = null;
            // These are the recommended EIP-1559 heuristics for fee data
            const block = this._wrapBlock(_block, network);
            if (block && block.baseFeePerGas) {
                maxPriorityFeePerGas = priorityFee != null ? priorityFee : BigInt("1000000000");
                maxFeePerGas = block.baseFeePerGas * $b1c9b35e5c4247ce$var$BN_2 + maxPriorityFeePerGas;
            }
            return new (0, $daa40c4afcf2fddc$export$116c49c1e2a96a78)(gasPrice, maxFeePerGas, maxPriorityFeePerGas);
        };
        // Check for a FeeDataNetWorkPlugin
        const plugin = network.getPlugin("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
        if (plugin) {
            const req = new (0, $639ac0facbde31d2$export$319b96fe59834522)(plugin.url);
            const feeData = await plugin.processFunc(getFeeDataFunc, this, req);
            return new (0, $daa40c4afcf2fddc$export$116c49c1e2a96a78)(feeData.gasPrice, feeData.maxFeePerGas, feeData.maxPriorityFeePerGas);
        }
        return await getFeeDataFunc();
    }
    async estimateGas(_tx) {
        let tx = this._getTransactionRequest(_tx);
        if ($b1c9b35e5c4247ce$var$isPromise(tx)) tx = await tx;
        return (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(await this.#perform({
            method: "estimateGas",
            transaction: tx
        }), "%response");
    }
    async #call(tx, blockTag, attempt) {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(attempt < $b1c9b35e5c4247ce$var$MAX_CCIP_REDIRECTS, "CCIP read exceeded maximum redirections", "OFFCHAIN_FAULT", {
            reason: "TOO_MANY_REDIRECTS",
            transaction: Object.assign({}, tx, {
                blockTag: blockTag,
                enableCcipRead: true
            })
        });
        // This came in as a PerformActionTransaction, so to/from are safe; we can cast
        const transaction = (0, $daa40c4afcf2fddc$export$607b34cdac162b7f)(tx);
        try {
            return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(await this._perform({
                method: "call",
                transaction: transaction,
                blockTag: blockTag
            }));
        } catch (error) {
            // CCIP Read OffchainLookup
            if (!this.disableCcipRead && (0, $def55b050f09c63c$export$748c4fa78f31ff35)(error) && error.data && attempt >= 0 && blockTag === "latest" && transaction.to != null && (0, $8de17c58ebd53b07$export$f6d845ffb449edc9)(error.data, 0, 4) === "0x556f1830") {
                const data = error.data;
                const txSender = await (0, $d6021cd5b8a26773$export$687eed6b344123c9)(transaction.to, this);
                // Parse the CCIP Read Arguments
                let ccipArgs;
                try {
                    ccipArgs = $b1c9b35e5c4247ce$var$parseOffchainLookup((0, $8de17c58ebd53b07$export$f6d845ffb449edc9)(error.data, 4));
                } catch (error) {
                    (0, $def55b050f09c63c$export$a7a9523472993e97)(false, error.message, "OFFCHAIN_FAULT", {
                        reason: "BAD_DATA",
                        transaction: transaction,
                        info: {
                            data: data
                        }
                    });
                }
                // Check the sender of the OffchainLookup matches the transaction
                (0, $def55b050f09c63c$export$a7a9523472993e97)(ccipArgs.sender.toLowerCase() === txSender.toLowerCase(), "CCIP Read sender mismatch", "CALL_EXCEPTION", {
                    action: "call",
                    data: data,
                    reason: "OffchainLookup",
                    transaction: transaction,
                    invocation: null,
                    revert: {
                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                        name: "OffchainLookup",
                        args: ccipArgs.errorArgs
                    }
                });
                const ccipResult = await this.ccipReadFetch(transaction, ccipArgs.calldata, ccipArgs.urls);
                (0, $def55b050f09c63c$export$a7a9523472993e97)(ccipResult != null, "CCIP Read failed to fetch data", "OFFCHAIN_FAULT", {
                    reason: "FETCH_FAILED",
                    transaction: transaction,
                    info: {
                        data: error.data,
                        errorArgs: ccipArgs.errorArgs
                    }
                });
                const tx = {
                    to: txSender,
                    data: (0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)([
                        ccipArgs.selector,
                        $b1c9b35e5c4247ce$var$encodeBytes([
                            ccipResult,
                            ccipArgs.extraData
                        ])
                    ])
                };
                this.emit("debug", {
                    action: "sendCcipReadCall",
                    transaction: tx
                });
                try {
                    const result = await this.#call(tx, blockTag, attempt + 1);
                    this.emit("debug", {
                        action: "receiveCcipReadCallResult",
                        transaction: Object.assign({}, tx),
                        result: result
                    });
                    return result;
                } catch (error) {
                    this.emit("debug", {
                        action: "receiveCcipReadCallError",
                        transaction: Object.assign({}, tx),
                        error: error
                    });
                    throw error;
                }
            }
            throw error;
        }
    }
    async #checkNetwork(promise) {
        const { value: value } = await (0, $5c7e3a359d4744c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            value: promise
        });
        return value;
    }
    async call(_tx) {
        const { tx: tx, blockTag: blockTag } = await (0, $5c7e3a359d4744c6$export$d503dd157d963b60)({
            tx: this._getTransactionRequest(_tx),
            blockTag: this._getBlockTag(_tx.blockTag)
        });
        return await this.#checkNetwork(this.#call(tx, blockTag, _tx.enableCcipRead ? 0 : -1));
    }
    // Account
    async #getAccountValue(request, _address, _blockTag) {
        let address = this._getAddress(_address);
        let blockTag = this._getBlockTag(_blockTag);
        if (typeof address !== "string" || typeof blockTag !== "string") [address, blockTag] = await Promise.all([
            address,
            blockTag
        ]);
        return await this.#checkNetwork(this.#perform(Object.assign(request, {
            address: address,
            blockTag: blockTag
        })));
    }
    async getBalance(address, blockTag) {
        return (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(await this.#getAccountValue({
            method: "getBalance"
        }, address, blockTag), "%response");
    }
    async getTransactionCount(address, blockTag) {
        return (0, $7df480338fc2bc47$export$b14f2714108df84)(await this.#getAccountValue({
            method: "getTransactionCount"
        }, address, blockTag), "%response");
    }
    async getCode(address, blockTag) {
        return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(await this.#getAccountValue({
            method: "getCode"
        }, address, blockTag));
    }
    async getStorage(address, _position, blockTag) {
        const position = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(_position, "position");
        return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(await this.#getAccountValue({
            method: "getStorage",
            position: position
        }, address, blockTag));
    }
    // Write
    async broadcastTransaction(signedTx) {
        const { blockNumber: blockNumber, hash: hash, network: network } = await (0, $5c7e3a359d4744c6$export$d503dd157d963b60)({
            blockNumber: this.getBlockNumber(),
            hash: this._perform({
                method: "broadcastTransaction",
                signedTransaction: signedTx
            }),
            network: this.getNetwork()
        });
        const tx = (0, $80204f35584328d0$export$febc5573c75cefb0).from(signedTx);
        if (tx.hash !== hash) throw new Error("@TODO: the returned hash did not match");
        return this._wrapTransactionResponse(tx, network).replaceableTransaction(blockNumber);
    }
    async #getBlock(block, includeTransactions) {
        // @TODO: Add CustomBlockPlugin check
        if ((0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(block, 32)) return await this.#perform({
            method: "getBlock",
            blockHash: block,
            includeTransactions: includeTransactions
        });
        let blockTag = this._getBlockTag(block);
        if (typeof blockTag !== "string") blockTag = await blockTag;
        return await this.#perform({
            method: "getBlock",
            blockTag: blockTag,
            includeTransactions: includeTransactions
        });
    }
    // Queries
    async getBlock(block, prefetchTxs) {
        const { network: network, params: params } = await (0, $5c7e3a359d4744c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#getBlock(block, !!prefetchTxs)
        });
        if (params == null) return null;
        return this._wrapBlock(params, network);
    }
    async getTransaction(hash) {
        const { network: network, params: params } = await (0, $5c7e3a359d4744c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getTransaction",
                hash: hash
            })
        });
        if (params == null) return null;
        return this._wrapTransactionResponse(params, network);
    }
    async getTransactionReceipt(hash) {
        const { network: network, params: params } = await (0, $5c7e3a359d4744c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getTransactionReceipt",
                hash: hash
            })
        });
        if (params == null) return null;
        // Some backends did not backfill the effectiveGasPrice into old transactions
        // in the receipt, so we look it up manually and inject it.
        if (params.gasPrice == null && params.effectiveGasPrice == null) {
            const tx = await this.#perform({
                method: "getTransaction",
                hash: hash
            });
            if (tx == null) throw new Error("report this; could not find tx or effectiveGasPrice");
            params.effectiveGasPrice = tx.gasPrice;
        }
        return this._wrapTransactionReceipt(params, network);
    }
    async getTransactionResult(hash) {
        const { result: result } = await (0, $5c7e3a359d4744c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            result: this.#perform({
                method: "getTransactionResult",
                hash: hash
            })
        });
        if (result == null) return null;
        return (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(result);
    }
    // Bloom-filter Queries
    async getLogs(_filter) {
        let filter = this._getFilter(_filter);
        if ($b1c9b35e5c4247ce$var$isPromise(filter)) filter = await filter;
        const { network: network, params: params } = await (0, $5c7e3a359d4744c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getLogs",
                filter: filter
            })
        });
        return params.map((p)=>this._wrapLog(p, network));
    }
    // ENS
    _getProvider(chainId) {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "provider cannot connect to target network", "UNSUPPORTED_OPERATION", {
            operation: "_getProvider()"
        });
    }
    async getResolver(name) {
        return await (0, $5cf4446c68da03db$export$d04afd034a0a53ae).fromName(this, name);
    }
    async getAvatar(name) {
        const resolver = await this.getResolver(name);
        if (resolver) return await resolver.getAvatar();
        return null;
    }
    async resolveName(name) {
        const resolver = await this.getResolver(name);
        if (resolver) return await resolver.getAddress();
        return null;
    }
    async lookupAddress(address) {
        address = (0, $61268443a2d16d36$export$88411125f012957a)(address);
        const node = (0, $1b6f5b1a3d63639b$export$91d651ee363e1209)(address.substring(2).toLowerCase() + ".addr.reverse");
        try {
            const ensAddr = await (0, $5cf4446c68da03db$export$d04afd034a0a53ae).getEnsAddress(this);
            const ensContract = new (0, $220158e9e9aec1ec$export$8517d80acf00e19a)(ensAddr, [
                "function resolver(bytes32) view returns (address)"
            ], this);
            const resolver = await ensContract.resolver(node);
            if (resolver == null || resolver === (0, $b4909c6a5ae371e9$export$b7cbe423ba83da17)) return null;
            const resolverContract = new (0, $220158e9e9aec1ec$export$8517d80acf00e19a)(resolver, [
                "function name(bytes32) view returns (string)"
            ], this);
            const name = await resolverContract.name(node);
            // Failed forward resolution
            const check = await this.resolveName(name);
            if (check !== address) return null;
            return name;
        } catch (error) {
            // No data was returned from the resolver
            if ((0, $def55b050f09c63c$export$e6127cc7fe7395c3)(error, "BAD_DATA") && error.value === "0x") return null;
            // Something reerted
            if ((0, $def55b050f09c63c$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) return null;
            throw error;
        }
        return null;
    }
    async waitForTransaction(hash, _confirms, timeout) {
        const confirms = _confirms != null ? _confirms : 1;
        if (confirms === 0) return this.getTransactionReceipt(hash);
        return new Promise(async (resolve, reject)=>{
            let timer = null;
            const listener = async (blockNumber)=>{
                try {
                    const receipt = await this.getTransactionReceipt(hash);
                    if (receipt != null) {
                        if (blockNumber - receipt.blockNumber + 1 >= confirms) {
                            resolve(receipt);
                            //this.off("block", listener);
                            if (timer) {
                                clearTimeout(timer);
                                timer = null;
                            }
                            return;
                        }
                    }
                } catch (error) {
                    console.log("EEE", error);
                }
                this.once("block", listener);
            };
            if (timeout != null) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                this.off("block", listener);
                reject((0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("timeout", "TIMEOUT", {
                    reason: "timeout"
                }));
            }, timeout);
            listener(await this.getBlockNumber());
        });
    }
    async waitForBlock(blockTag) {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "not implemented yet", "NOT_IMPLEMENTED", {
            operation: "waitForBlock"
        });
    }
    /**
     *  Clear a timer created using the [[_setTimeout]] method.
     */ _clearTimeout(timerId) {
        const timer = this.#timers.get(timerId);
        if (!timer) return;
        if (timer.timer) clearTimeout(timer.timer);
        this.#timers.delete(timerId);
    }
    /**
     *  Create a timer that will execute %%func%% after at least %%timeout%%
     *  (in ms). If %%timeout%% is unspecified, then %%func%% will execute
     *  in the next event loop.
     *
     *  [Pausing](AbstractProvider-paused) the provider will pause any
     *  associated timers.
     */ _setTimeout(_func, timeout) {
        if (timeout == null) timeout = 0;
        const timerId = this.#nextTimer++;
        const func = ()=>{
            this.#timers.delete(timerId);
            _func();
        };
        if (this.paused) this.#timers.set(timerId, {
            timer: null,
            func: func,
            time: timeout
        });
        else {
            const timer = setTimeout(func, timeout);
            this.#timers.set(timerId, {
                timer: timer,
                func: func,
                time: $b1c9b35e5c4247ce$var$getTime()
            });
        }
        return timerId;
    }
    /**
     *  Perform %%func%% on each subscriber.
     */ _forEachSubscriber(func) {
        for (const sub of this.#subs.values())func(sub.subscriber);
    }
    /**
     *  Sub-classes may override this to customize subscription
     *  implementations.
     */ _getSubscriber(sub) {
        switch(sub.type){
            case "debug":
            case "error":
            case "network":
                return new $b1c9b35e5c4247ce$export$f255b979f86248fa(sub.type);
            case "block":
                {
                    const subscriber = new (0, $02aebfef9941c580$export$aaf796a16ac1a157)(this);
                    subscriber.pollingInterval = this.pollingInterval;
                    return subscriber;
                }
            case "safe":
            case "finalized":
                return new (0, $02aebfef9941c580$export$63862f83f14090ef)(this, sub.type);
            case "event":
                return new (0, $02aebfef9941c580$export$bdb759dc2fe68c72)(this, sub.filter);
            case "transaction":
                return new (0, $02aebfef9941c580$export$4fe8a9740765f97e)(this, sub.hash);
            case "orphan":
                return new (0, $02aebfef9941c580$export$e4ed5c6414dc4e9e)(this, sub.filter);
        }
        throw new Error(`unsupported event: ${sub.type}`);
    }
    /**
     *  If a [[Subscriber]] fails and needs to replace itself, this
     *  method may be used.
     *
     *  For example, this is used for providers when using the
     *  ``eth_getFilterChanges`` method, which can return null if state
     *  filters are not supported by the backend, allowing the Subscriber
     *  to swap in a [[PollingEventSubscriber]].
     */ _recoverSubscriber(oldSub, newSub) {
        for (const sub of this.#subs.values())if (sub.subscriber === oldSub) {
            if (sub.started) sub.subscriber.stop();
            sub.subscriber = newSub;
            if (sub.started) newSub.start();
            if (this.#pausedState != null) newSub.pause(this.#pausedState);
            break;
        }
    }
    async #hasSub(event, emitArgs) {
        let sub = await $b1c9b35e5c4247ce$var$getSubscription(event, this);
        // This is a log that is removing an existing log; we actually want
        // to emit an orphan event for the removed log
        if (sub.type === "event" && emitArgs && emitArgs.length > 0 && emitArgs[0].removed === true) sub = await $b1c9b35e5c4247ce$var$getSubscription({
            orphan: "drop-log",
            log: emitArgs[0]
        }, this);
        return this.#subs.get(sub.tag) || null;
    }
    async #getSub(event) {
        const subscription = await $b1c9b35e5c4247ce$var$getSubscription(event, this);
        // Prevent tampering with our tag in any subclass' _getSubscriber
        const tag = subscription.tag;
        let sub = this.#subs.get(tag);
        if (!sub) {
            const subscriber = this._getSubscriber(subscription);
            const addressableMap = new WeakMap();
            const nameMap = new Map();
            sub = {
                subscriber: subscriber,
                tag: tag,
                addressableMap: addressableMap,
                nameMap: nameMap,
                started: false,
                listeners: []
            };
            this.#subs.set(tag, sub);
        }
        return sub;
    }
    async on(event, listener) {
        const sub = await this.#getSub(event);
        sub.listeners.push({
            listener: listener,
            once: false
        });
        if (!sub.started) {
            sub.subscriber.start();
            sub.started = true;
            if (this.#pausedState != null) sub.subscriber.pause(this.#pausedState);
        }
        return this;
    }
    async once(event, listener) {
        const sub = await this.#getSub(event);
        sub.listeners.push({
            listener: listener,
            once: true
        });
        if (!sub.started) {
            sub.subscriber.start();
            sub.started = true;
            if (this.#pausedState != null) sub.subscriber.pause(this.#pausedState);
        }
        return this;
    }
    async emit(event, ...args) {
        const sub = await this.#hasSub(event, args);
        // If there is not subscription or if a recent emit removed
        // the last of them (which also deleted the sub) do nothing
        if (!sub || sub.listeners.length === 0) return false;
        const count = sub.listeners.length;
        sub.listeners = sub.listeners.filter(({ listener: listener, once: once })=>{
            const payload = new (0, $6a5512eaca61d3ca$export$9cec82196983b278)(this, once ? null : listener, event);
            try {
                listener.call(this, ...args, payload);
            } catch (error) {}
            return !once;
        });
        if (sub.listeners.length === 0) {
            if (sub.started) sub.subscriber.stop();
            this.#subs.delete(sub.tag);
        }
        return count > 0;
    }
    async listenerCount(event) {
        if (event) {
            const sub = await this.#hasSub(event);
            if (!sub) return 0;
            return sub.listeners.length;
        }
        let total = 0;
        for (const { listeners: listeners } of this.#subs.values())total += listeners.length;
        return total;
    }
    async listeners(event) {
        if (event) {
            const sub = await this.#hasSub(event);
            if (!sub) return [];
            return sub.listeners.map(({ listener: listener })=>listener);
        }
        let result = [];
        for (const { listeners: listeners } of this.#subs.values())result = result.concat(listeners.map(({ listener: listener })=>listener));
        return result;
    }
    async off(event, listener) {
        const sub = await this.#hasSub(event);
        if (!sub) return this;
        if (listener) {
            const index = sub.listeners.map(({ listener: listener })=>listener).indexOf(listener);
            if (index >= 0) sub.listeners.splice(index, 1);
        }
        if (!listener || sub.listeners.length === 0) {
            if (sub.started) sub.subscriber.stop();
            this.#subs.delete(sub.tag);
        }
        return this;
    }
    async removeAllListeners(event) {
        if (event) {
            const { tag: tag, started: started, subscriber: subscriber } = await this.#getSub(event);
            if (started) subscriber.stop();
            this.#subs.delete(tag);
        } else for (const [tag, { started: started, subscriber: subscriber }] of this.#subs){
            if (started) subscriber.stop();
            this.#subs.delete(tag);
        }
        return this;
    }
    // Alias for "on"
    async addListener(event, listener) {
        return await this.on(event, listener);
    }
    // Alias for "off"
    async removeListener(event, listener) {
        return this.off(event, listener);
    }
    /**
     *  If this provider has been destroyed using the [[destroy]] method.
     *
     *  Once destroyed, all resources are reclaimed, internal event loops
     *  and timers are cleaned up and no further requests may be sent to
     *  the provider.
     */ get destroyed() {
        return this.#destroyed;
    }
    /**
     *  Sub-classes may use this to shutdown any sockets or release their
     *  resources and reject any pending requests.
     *
     *  Sub-classes **must** call ``super.destroy()``.
     */ destroy() {
        // Stop all listeners
        this.removeAllListeners();
        // Shut down all tiemrs
        for (const timerId of this.#timers.keys())this._clearTimeout(timerId);
        this.#destroyed = true;
    }
    /**
     *  Whether the provider is currently paused.
     *
     *  A paused provider will not emit any events, and generally should
     *  not make any requests to the network, but that is up to sub-classes
     *  to manage.
     *
     *  Setting ``paused = true`` is identical to calling ``.pause(false)``,
     *  which will buffer any events that occur while paused until the
     *  provider is unpaused.
     */ get paused() {
        return this.#pausedState != null;
    }
    set paused(pause) {
        if (!!pause === this.paused) return;
        if (this.paused) this.resume();
        else this.pause(false);
    }
    /**
     *  Pause the provider. If %%dropWhilePaused%%, any events that occur
     *  while paused are dropped, otherwise all events will be emitted once
     *  the provider is unpaused.
     */ pause(dropWhilePaused) {
        this.#lastBlockNumber = -1;
        if (this.#pausedState != null) {
            if (this.#pausedState == !!dropWhilePaused) return;
            (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "cannot change pause type; resume first", "UNSUPPORTED_OPERATION", {
                operation: "pause"
            });
        }
        this._forEachSubscriber((s)=>s.pause(dropWhilePaused));
        this.#pausedState = !!dropWhilePaused;
        for (const timer of this.#timers.values()){
            // Clear the timer
            if (timer.timer) clearTimeout(timer.timer);
            // Remaining time needed for when we become unpaused
            timer.time = $b1c9b35e5c4247ce$var$getTime() - timer.time;
        }
    }
    /**
     *  Resume the provider.
     */ resume() {
        if (this.#pausedState == null) return;
        this._forEachSubscriber((s)=>s.resume());
        this.#pausedState = null;
        for (const timer of this.#timers.values()){
            // Remaining time when we were paused
            let timeout = timer.time;
            if (timeout < 0) timeout = 0;
            // Start time (in cause paused, so we con compute remaininf time)
            timer.time = $b1c9b35e5c4247ce$var$getTime();
            // Start the timer
            setTimeout(timer.func, timeout);
        }
    }
}
function $b1c9b35e5c4247ce$var$_parseString(result, start) {
    try {
        const bytes = $b1c9b35e5c4247ce$var$_parseBytes(result, start);
        if (bytes) return (0, $cdede1645bd34985$export$7643a1dc2c38d5eb)(bytes);
    } catch (error) {}
    return null;
}
function $b1c9b35e5c4247ce$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    try {
        const offset = (0, $7df480338fc2bc47$export$b14f2714108df84)((0, $8de17c58ebd53b07$export$f6d845ffb449edc9)(result, start, start + 32));
        const length = (0, $7df480338fc2bc47$export$b14f2714108df84)((0, $8de17c58ebd53b07$export$f6d845ffb449edc9)(result, offset, offset + 32));
        return (0, $8de17c58ebd53b07$export$f6d845ffb449edc9)(result, offset + 32, offset + 32 + length);
    } catch (error) {}
    return null;
}
function $b1c9b35e5c4247ce$var$numPad(value) {
    const result = (0, $7df480338fc2bc47$export$b627fcfb5ea68cb0)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $b1c9b35e5c4247ce$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
const $b1c9b35e5c4247ce$var$empty = new Uint8Array([]);
// ABI Encodes a series of (bytes, bytes, ...)
function $b1c9b35e5c4247ce$var$encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for(let i = 0; i < datas.length; i++){
        result.push($b1c9b35e5c4247ce$var$empty);
        byteCount += 32;
    }
    for(let i = 0; i < datas.length; i++){
        const data = (0, $8de17c58ebd53b07$export$a3521add2594f3c8)(datas[i]);
        // Update the bytes offset
        result[i] = $b1c9b35e5c4247ce$var$numPad(byteCount);
        // The length and padded value of data
        result.push($b1c9b35e5c4247ce$var$numPad(data.length));
        result.push($b1c9b35e5c4247ce$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $8de17c58ebd53b07$export$ee1b3e54f0441b22)(result);
}
const $b1c9b35e5c4247ce$var$zeros = "0x0000000000000000000000000000000000000000000000000000000000000000";
function $b1c9b35e5c4247ce$var$parseOffchainLookup(data) {
    const result = {
        sender: "",
        urls: [],
        calldata: "",
        selector: "",
        extraData: "",
        errorArgs: []
    };
    (0, $def55b050f09c63c$export$a7a9523472993e97)((0, $8de17c58ebd53b07$export$2321cd91b99770ff)(data) >= 160, "insufficient OffchainLookup data", "OFFCHAIN_FAULT", {
        reason: "insufficient OffchainLookup data"
    });
    const sender = (0, $8de17c58ebd53b07$export$f6d845ffb449edc9)(data, 0, 32);
    (0, $def55b050f09c63c$export$a7a9523472993e97)((0, $8de17c58ebd53b07$export$f6d845ffb449edc9)(sender, 0, 12) === (0, $8de17c58ebd53b07$export$f6d845ffb449edc9)($b1c9b35e5c4247ce$var$zeros, 0, 12), "corrupt OffchainLookup sender", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup sender"
    });
    result.sender = (0, $8de17c58ebd53b07$export$f6d845ffb449edc9)(sender, 12);
    // Read the URLs from the response
    try {
        const urls = [];
        const urlsOffset = (0, $7df480338fc2bc47$export$b14f2714108df84)((0, $8de17c58ebd53b07$export$f6d845ffb449edc9)(data, 32, 64));
        const urlsLength = (0, $7df480338fc2bc47$export$b14f2714108df84)((0, $8de17c58ebd53b07$export$f6d845ffb449edc9)(data, urlsOffset, urlsOffset + 32));
        const urlsData = (0, $8de17c58ebd53b07$export$f6d845ffb449edc9)(data, urlsOffset + 32);
        for(let u = 0; u < urlsLength; u++){
            const url = $b1c9b35e5c4247ce$var$_parseString(urlsData, u * 32);
            if (url == null) throw new Error("abort");
            urls.push(url);
        }
        result.urls = urls;
    } catch (error) {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "corrupt OffchainLookup urls", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup urls"
        });
    }
    // Get the CCIP calldata to forward
    try {
        const calldata = $b1c9b35e5c4247ce$var$_parseBytes(data, 64);
        if (calldata == null) throw new Error("abort");
        result.calldata = calldata;
    } catch (error) {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "corrupt OffchainLookup calldata", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup calldata"
        });
    }
    // Get the callbackSelector (bytes4)
    (0, $def55b050f09c63c$export$a7a9523472993e97)((0, $8de17c58ebd53b07$export$f6d845ffb449edc9)(data, 100, 128) === (0, $8de17c58ebd53b07$export$f6d845ffb449edc9)($b1c9b35e5c4247ce$var$zeros, 0, 28), "corrupt OffchainLookup callbaackSelector", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup callbaackSelector"
    });
    result.selector = (0, $8de17c58ebd53b07$export$f6d845ffb449edc9)(data, 96, 100);
    // Get the extra data to send back to the contract as context
    try {
        const extraData = $b1c9b35e5c4247ce$var$_parseBytes(data, 128);
        if (extraData == null) throw new Error("abort");
        result.extraData = extraData;
    } catch (error) {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "corrupt OffchainLookup extraData", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup extraData"
        });
    }
    result.errorArgs = "sender,urls,calldata,selector,extraData".split(/,/).map((k)=>result[k]);
    return result;
}


/**
 *  Generally the [[Wallet]] and [[JsonRpcSigner]] and their sub-classes
 *  are sufficent for most developers, but this is provided to
 *  fascilitate more complex Signers.
 *
 *  @_section: api/providers/abstract-signer: Subclassing Signer [abstract-signer]
 */ 



function $7aa589f0fee01c00$var$checkProvider(signer, operation) {
    if (signer.provider) return signer.provider;
    (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "missing provider", "UNSUPPORTED_OPERATION", {
        operation: operation
    });
}
async function $7aa589f0fee01c00$var$populate(signer, tx) {
    let pop = (0, $daa40c4afcf2fddc$export$607b34cdac162b7f)(tx);
    if (pop.to != null) pop.to = (0, $d6021cd5b8a26773$export$687eed6b344123c9)(pop.to, signer);
    if (pop.from != null) {
        const from = pop.from;
        pop.from = Promise.all([
            signer.getAddress(),
            (0, $d6021cd5b8a26773$export$687eed6b344123c9)(from, signer)
        ]).then(([address, from])=>{
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(address.toLowerCase() === from.toLowerCase(), "transaction from mismatch", "tx.from", from);
            return address;
        });
    } else pop.from = signer.getAddress();
    return await (0, $5c7e3a359d4744c6$export$d503dd157d963b60)(pop);
}
class $7aa589f0fee01c00$export$6c02143914c373f1 {
    /**
     *  The provider this signer is connected to.
     */ provider;
    /**
     *  Creates a new Signer connected to %%provider%%.
     */ constructor(provider){
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            provider: provider || null
        });
    }
    async getNonce(blockTag) {
        return $7aa589f0fee01c00$var$checkProvider(this, "getTransactionCount").getTransactionCount(await this.getAddress(), blockTag);
    }
    async populateCall(tx) {
        const pop = await $7aa589f0fee01c00$var$populate(this, tx);
        return pop;
    }
    async populateTransaction(tx) {
        const provider = $7aa589f0fee01c00$var$checkProvider(this, "populateTransaction");
        const pop = await $7aa589f0fee01c00$var$populate(this, tx);
        if (pop.nonce == null) pop.nonce = await this.getNonce("pending");
        if (pop.gasLimit == null) pop.gasLimit = await this.estimateGas(pop);
        // Populate the chain ID
        const network = await this.provider.getNetwork();
        if (pop.chainId != null) {
            const chainId = (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(pop.chainId);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(chainId === network.chainId, "transaction chainId mismatch", "tx.chainId", tx.chainId);
        } else pop.chainId = network.chainId;
        // Do not allow mixing pre-eip-1559 and eip-1559 properties
        const hasEip1559 = pop.maxFeePerGas != null || pop.maxPriorityFeePerGas != null;
        if (pop.gasPrice != null && (pop.type === 2 || hasEip1559)) (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "eip-1559 transaction do not support gasPrice", "tx", tx);
        else if ((pop.type === 0 || pop.type === 1) && hasEip1559) (0, $def55b050f09c63c$export$c3d31707e5030f5e)(false, "pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "tx", tx);
        if ((pop.type === 2 || pop.type == null) && pop.maxFeePerGas != null && pop.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
        pop.type = 2;
        else if (pop.type === 0 || pop.type === 1) {
            // Explicit Legacy or EIP-2930 transaction
            // We need to get fee data to determine things
            const feeData = await provider.getFeeData();
            (0, $def55b050f09c63c$export$a7a9523472993e97)(feeData.gasPrice != null, "network does not support gasPrice", "UNSUPPORTED_OPERATION", {
                operation: "getGasPrice"
            });
            // Populate missing gasPrice
            if (pop.gasPrice == null) pop.gasPrice = feeData.gasPrice;
        } else {
            // We need to get fee data to determine things
            const feeData = await provider.getFeeData();
            if (pop.type == null) {
                // We need to auto-detect the intended type of this transaction...
                if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                    // The network supports EIP-1559!
                    // Upgrade transaction from null to eip-1559
                    if (pop.authorizationList && pop.authorizationList.length) pop.type = 4;
                    else pop.type = 2;
                    if (pop.gasPrice != null) {
                        // Using legacy gasPrice property on an eip-1559 network,
                        // so use gasPrice as both fee properties
                        const gasPrice = pop.gasPrice;
                        delete pop.gasPrice;
                        pop.maxFeePerGas = gasPrice;
                        pop.maxPriorityFeePerGas = gasPrice;
                    } else {
                        // Populate missing fee data
                        if (pop.maxFeePerGas == null) pop.maxFeePerGas = feeData.maxFeePerGas;
                        if (pop.maxPriorityFeePerGas == null) pop.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                    }
                } else if (feeData.gasPrice != null) {
                    // Network doesn't support EIP-1559...
                    // ...but they are trying to use EIP-1559 properties
                    (0, $def55b050f09c63c$export$a7a9523472993e97)(!hasEip1559, "network does not support EIP-1559", "UNSUPPORTED_OPERATION", {
                        operation: "populateTransaction"
                    });
                    // Populate missing fee data
                    if (pop.gasPrice == null) pop.gasPrice = feeData.gasPrice;
                    // Explicitly set untyped transaction to legacy
                    // @TODO: Maybe this shold allow type 1?
                    pop.type = 0;
                } else // getFeeData has failed us.
                (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "failed to get consistent fee data", "UNSUPPORTED_OPERATION", {
                    operation: "signer.getFeeData"
                });
            } else if (pop.type === 2 || pop.type === 3 || pop.type === 4) {
                // Explicitly using EIP-1559 or EIP-4844
                // Populate missing fee data
                if (pop.maxFeePerGas == null) pop.maxFeePerGas = feeData.maxFeePerGas;
                if (pop.maxPriorityFeePerGas == null) pop.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
            }
        }
        //@TOOD: Don't await all over the place; save them up for
        // the end for better batching
        return await (0, $5c7e3a359d4744c6$export$d503dd157d963b60)(pop);
    }
    async populateAuthorization(_auth) {
        const auth = Object.assign({}, _auth);
        // Add a chain ID if not explicitly set to 0
        if (auth.chainId == null) auth.chainId = (await $7aa589f0fee01c00$var$checkProvider(this, "getNetwork").getNetwork()).chainId;
        // @TODO: Take chain ID into account when populating noce?
        if (auth.nonce == null) auth.nonce = await this.getNonce();
        return auth;
    }
    async estimateGas(tx) {
        return $7aa589f0fee01c00$var$checkProvider(this, "estimateGas").estimateGas(await this.populateCall(tx));
    }
    async call(tx) {
        return $7aa589f0fee01c00$var$checkProvider(this, "call").call(await this.populateCall(tx));
    }
    async resolveName(name) {
        const provider = $7aa589f0fee01c00$var$checkProvider(this, "resolveName");
        return await provider.resolveName(name);
    }
    async sendTransaction(tx) {
        const provider = $7aa589f0fee01c00$var$checkProvider(this, "sendTransaction");
        const pop = await this.populateTransaction(tx);
        delete pop.from;
        const txObj = (0, $80204f35584328d0$export$febc5573c75cefb0).from(pop);
        return await provider.broadcastTransaction(await this.signTransaction(txObj));
    }
    // @TODO: in v7 move this to be abstract
    authorize(authorization) {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "authorization not implemented for this signer", "UNSUPPORTED_OPERATION", {
            operation: "authorize"
        });
    }
}
class $7aa589f0fee01c00$export$7dbc56d9b9612bad extends $7aa589f0fee01c00$export$6c02143914c373f1 {
    /**
     *  The signer address.
     */ address;
    /**
     *  Creates a new **VoidSigner** with %%address%% attached to
     *  %%provider%%.
     */ constructor(address, provider){
        super(provider);
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            address: address
        });
    }
    async getAddress() {
        return this.address;
    }
    connect(provider) {
        return new $7aa589f0fee01c00$export$7dbc56d9b9612bad(this.address, provider);
    }
    #throwUnsupported(suffix, operation) {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(false, `VoidSigner cannot sign ${suffix}`, "UNSUPPORTED_OPERATION", {
            operation: operation
        });
    }
    async signTransaction(tx) {
        this.#throwUnsupported("transactions", "signTransaction");
    }
    async signMessage(message) {
        this.#throwUnsupported("messages", "signMessage");
    }
    async signTypedData(domain, types, value) {
        this.#throwUnsupported("typed-data", "signTypedData");
    }
}





function $f65cab7df08db94e$var$copy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
class $f65cab7df08db94e$export$a51133e713c99bbe {
    #provider;
    #filterIdPromise;
    #poller;
    #running;
    #network;
    #hault;
    /**
     *  Creates a new **FilterIdSubscriber** which will used [[_subscribe]]
     *  and [[_emitResults]] to setup the subscription and provide the event
     *  to the %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#filterIdPromise = null;
        this.#poller = this.#poll.bind(this);
        this.#running = false;
        this.#network = null;
        this.#hault = false;
    }
    /**
     *  Sub-classes **must** override this to begin the subscription.
     */ _subscribe(provider) {
        throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle the events.
     */ _emitResults(provider, result) {
        throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle recovery on errors.
     */ _recover(provider) {
        throw new Error("subclasses must override this");
    }
    async #poll(blockNumber) {
        try {
            // Subscribe if necessary
            if (this.#filterIdPromise == null) this.#filterIdPromise = this._subscribe(this.#provider);
            // Get the Filter ID
            let filterId = null;
            try {
                filterId = await this.#filterIdPromise;
            } catch (error) {
                if (!(0, $def55b050f09c63c$export$e6127cc7fe7395c3)(error, "UNSUPPORTED_OPERATION") || error.operation !== "eth_newFilter") throw error;
            }
            // The backend does not support Filter ID; downgrade to
            // polling
            if (filterId == null) {
                this.#filterIdPromise = null;
                this.#provider._recoverSubscriber(this, this._recover(this.#provider));
                return;
            }
            const network = await this.#provider.getNetwork();
            if (!this.#network) this.#network = network;
            if (this.#network.chainId !== network.chainId) throw new Error("chaid changed");
            if (this.#hault) return;
            const result = await this.#provider.send("eth_getFilterChanges", [
                filterId
            ]);
            await this._emitResults(this.#provider, result);
        } catch (error) {
            console.log("@TODO", error);
        }
        this.#provider.once("block", this.#poller);
    }
    #teardown() {
        const filterIdPromise = this.#filterIdPromise;
        if (filterIdPromise) {
            this.#filterIdPromise = null;
            filterIdPromise.then((filterId)=>{
                if (this.#provider.destroyed) return;
                this.#provider.send("eth_uninstallFilter", [
                    filterId
                ]);
            });
        }
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        this.#poll(-2);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#hault = true;
        this.#teardown();
        this.#provider.off("block", this.#poller);
    }
    pause(dropWhilePaused) {
        if (dropWhilePaused) this.#teardown();
        this.#provider.off("block", this.#poller);
    }
    resume() {
        this.start();
    }
}
class $f65cab7df08db94e$export$60f65cdabb3c5771 extends $f65cab7df08db94e$export$a51133e713c99bbe {
    #event;
    /**
     *  Creates a new **FilterIdEventSubscriber** attached to %%provider%%
     *  listening for %%filter%%.
     */ constructor(provider, filter){
        super(provider);
        this.#event = $f65cab7df08db94e$var$copy(filter);
    }
    _recover(provider) {
        return new (0, $02aebfef9941c580$export$bdb759dc2fe68c72)(provider, this.#event);
    }
    async _subscribe(provider) {
        const filterId = await provider.send("eth_newFilter", [
            this.#event
        ]);
        return filterId;
    }
    async _emitResults(provider, results) {
        for (const result of results)provider.emit(this.#event, provider._wrapLog(result, provider._network));
    }
}
class $f65cab7df08db94e$export$285511066b2a5499 extends $f65cab7df08db94e$export$a51133e713c99bbe {
    async _subscribe(provider) {
        return await provider.send("eth_newPendingTransactionFilter", []);
    }
    async _emitResults(provider, results) {
        for (const result of results)provider.emit("pending", result);
    }
}



const $96fdd0b482b0a22c$var$Primitive = "bigint,boolean,function,number,string,symbol".split(/,/g);
//const Methods = "getAddress,then".split(/,/g);
function $96fdd0b482b0a22c$var$deepCopy(value) {
    if (value == null || $96fdd0b482b0a22c$var$Primitive.indexOf(typeof value) >= 0) return value;
    // Keep any Addressable
    if (typeof value.getAddress === "function") return value;
    if (Array.isArray(value)) return value.map($96fdd0b482b0a22c$var$deepCopy);
    if (typeof value === "object") return Object.keys(value).reduce((accum, key)=>{
        accum[key] = value[key];
        return accum;
    }, {});
    throw new Error(`should not happen: ${value} (${typeof value})`);
}
function $96fdd0b482b0a22c$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $96fdd0b482b0a22c$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
function $96fdd0b482b0a22c$var$isPollable(value) {
    return value && typeof value.pollingInterval === "number";
}
const $96fdd0b482b0a22c$var$defaultOptions = {
    polling: false,
    staticNetwork: null,
    batchStallTime: 10,
    batchMaxSize: 1048576,
    batchMaxCount: 100,
    cacheTimeout: 250,
    pollingInterval: 4000
};
class $96fdd0b482b0a22c$export$5f7b5fca3508545a extends (0, $7aa589f0fee01c00$export$6c02143914c373f1) {
    address;
    constructor(provider, address){
        super(provider);
        address = (0, $61268443a2d16d36$export$88411125f012957a)(address);
        (0, $5c7e3a359d4744c6$export$b61bda4fbca264f2)(this, {
            address: address
        });
    }
    connect(provider) {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(false, "cannot reconnect JsonRpcSigner", "UNSUPPORTED_OPERATION", {
            operation: "signer.connect"
        });
    }
    async getAddress() {
        return this.address;
    }
    // JSON-RPC will automatially fill in nonce, etc. so we just check from
    async populateTransaction(tx) {
        return await this.populateCall(tx);
    }
    // Returns just the hash of the transaction after sent, which is what
    // the bare JSON-RPC API does;
    async sendUncheckedTransaction(_tx) {
        const tx = $96fdd0b482b0a22c$var$deepCopy(_tx);
        const promises = [];
        // Make sure the from matches the sender
        if (tx.from) {
            const _from = tx.from;
            promises.push((async ()=>{
                const from = await (0, $d6021cd5b8a26773$export$687eed6b344123c9)(_from, this.provider);
                (0, $def55b050f09c63c$export$c3d31707e5030f5e)(from != null && from.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", _tx);
                tx.from = from;
            })());
        } else tx.from = this.address;
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (tx.gasLimit == null) promises.push((async ()=>{
            tx.gasLimit = await this.provider.estimateGas({
                ...tx,
                from: this.address
            });
        })());
        // The address may be an ENS name or Addressable
        if (tx.to != null) {
            const _to = tx.to;
            promises.push((async ()=>{
                tx.to = await (0, $d6021cd5b8a26773$export$687eed6b344123c9)(_to, this.provider);
            })());
        }
        // Wait until all of our properties are filled in
        if (promises.length) await Promise.all(promises);
        const hexTx = this.provider.getRpcTransaction(tx);
        return this.provider.send("eth_sendTransaction", [
            hexTx
        ]);
    }
    async sendTransaction(tx) {
        // This cannot be mined any earlier than any recent block
        const blockNumber = await this.provider.getBlockNumber();
        // Send the transaction
        const hash = await this.sendUncheckedTransaction(tx);
        // Unfortunately, JSON-RPC only provides and opaque transaction hash
        // for a response, and we need the actual transaction, so we poll
        // for it; it should show up very quickly
        return await new Promise((resolve, reject)=>{
            const timeouts = [
                1000,
                100
            ];
            let invalids = 0;
            const checkTx = async ()=>{
                try {
                    // Try getting the transaction
                    const tx = await this.provider.getTransaction(hash);
                    if (tx != null) {
                        resolve(tx.replaceableTransaction(blockNumber));
                        return;
                    }
                } catch (error) {
                    // If we were cancelled: stop polling.
                    // If the data is bad: the node returns bad transactions
                    // If the network changed: calling again will also fail
                    // If unsupported: likely destroyed
                    if ((0, $def55b050f09c63c$export$e6127cc7fe7395c3)(error, "CANCELLED") || (0, $def55b050f09c63c$export$e6127cc7fe7395c3)(error, "BAD_DATA") || (0, $def55b050f09c63c$export$e6127cc7fe7395c3)(error, "NETWORK_ERROR") || (0, $def55b050f09c63c$export$e6127cc7fe7395c3)(error, "UNSUPPORTED_OPERATION")) {
                        if (error.info == null) error.info = {};
                        error.info.sendTransactionHash = hash;
                        reject(error);
                        return;
                    }
                    // Stop-gap for misbehaving backends; see #4513
                    if ((0, $def55b050f09c63c$export$e6127cc7fe7395c3)(error, "INVALID_ARGUMENT")) {
                        invalids++;
                        if (error.info == null) error.info = {};
                        error.info.sendTransactionHash = hash;
                        if (invalids > 10) {
                            reject(error);
                            return;
                        }
                    }
                    // Notify anyone that cares; but we will try again, since
                    // it is likely an intermittent service error
                    this.provider.emit("error", (0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("failed to fetch transation after sending (will try again)", "UNKNOWN_ERROR", {
                        error: error
                    }));
                }
                // Wait another 4 seconds
                this.provider._setTimeout(()=>{
                    checkTx();
                }, timeouts.pop() || 4000);
            };
            checkTx();
        });
    }
    async signTransaction(_tx) {
        const tx = $96fdd0b482b0a22c$var$deepCopy(_tx);
        // Make sure the from matches the sender
        if (tx.from) {
            const from = await (0, $d6021cd5b8a26773$export$687eed6b344123c9)(tx.from, this.provider);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(from != null && from.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", _tx);
            tx.from = from;
        } else tx.from = this.address;
        const hexTx = this.provider.getRpcTransaction(tx);
        return await this.provider.send("eth_signTransaction", [
            hexTx
        ]);
    }
    async signMessage(_message) {
        const message = typeof _message === "string" ? (0, $cdede1645bd34985$export$8feeb310b4b4752f)(_message) : _message;
        return await this.provider.send("personal_sign", [
            (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(message),
            this.address.toLowerCase()
        ]);
    }
    async signTypedData(domain, types, _value) {
        const value = $96fdd0b482b0a22c$var$deepCopy(_value);
        // Populate any ENS names (in-place)
        const populated = await (0, $838681bef518592f$export$458ab927ae635c3).resolveNames(domain, types, value, async (value)=>{
            const address = await (0, $d6021cd5b8a26773$export$687eed6b344123c9)(value);
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(address != null, "TypedData does not support null address", "value", value);
            return address;
        });
        return await this.provider.send("eth_signTypedData_v4", [
            this.address.toLowerCase(),
            JSON.stringify((0, $838681bef518592f$export$458ab927ae635c3).getPayload(populated.domain, types, populated.value))
        ]);
    }
    async unlock(password) {
        return this.provider.send("personal_unlockAccount", [
            this.address.toLowerCase(),
            password,
            null
        ]);
    }
    // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
    async _legacySignMessage(_message) {
        const message = typeof _message === "string" ? (0, $cdede1645bd34985$export$8feeb310b4b4752f)(_message) : _message;
        return await this.provider.send("eth_sign", [
            this.address.toLowerCase(),
            (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(message)
        ]);
    }
}
class $96fdd0b482b0a22c$export$5afe35a44ca7ff9a extends (0, $b1c9b35e5c4247ce$export$ae9650e85fb229fe) {
    #options;
    // The next ID to use for the JSON-RPC ID field
    #nextId;
    // Payloads are queued and triggered in batches using the drainTimer
    #payloads;
    #drainTimer;
    #notReady;
    #network;
    #pendingDetectNetwork;
    #scheduleDrain() {
        if (this.#drainTimer) return;
        // If we aren't using batching, no harm in sending it immediately
        const stallTime = this._getOption("batchMaxCount") === 1 ? 0 : this._getOption("batchStallTime");
        this.#drainTimer = setTimeout(()=>{
            this.#drainTimer = null;
            const payloads = this.#payloads;
            this.#payloads = [];
            while(payloads.length){
                // Create payload batches that satisfy our batch constraints
                const batch = [
                    payloads.shift()
                ];
                while(payloads.length){
                    if (batch.length === this.#options.batchMaxCount) break;
                    batch.push(payloads.shift());
                    const bytes = JSON.stringify(batch.map((p)=>p.payload));
                    if (bytes.length > this.#options.batchMaxSize) {
                        payloads.unshift(batch.pop());
                        break;
                    }
                }
                // Process the result to each payload
                (async ()=>{
                    const payload = batch.length === 1 ? batch[0].payload : batch.map((p)=>p.payload);
                    this.emit("debug", {
                        action: "sendRpcPayload",
                        payload: payload
                    });
                    try {
                        const result = await this._send(payload);
                        this.emit("debug", {
                            action: "receiveRpcResult",
                            result: result
                        });
                        // Process results in batch order
                        for (const { resolve: resolve, reject: reject, payload: payload } of batch){
                            if (this.destroyed) {
                                reject((0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
                                    operation: payload.method
                                }));
                                continue;
                            }
                            // Find the matching result
                            const resp = result.filter((r)=>r.id === payload.id)[0];
                            // No result; the node failed us in unexpected ways
                            if (resp == null) {
                                const error = (0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("missing response for request", "BAD_DATA", {
                                    value: result,
                                    info: {
                                        payload: payload
                                    }
                                });
                                this.emit("error", error);
                                reject(error);
                                continue;
                            }
                            // The response is an error
                            if ("error" in resp) {
                                reject(this.getRpcError(payload, resp));
                                continue;
                            }
                            // All good; send the result
                            resolve(resp.result);
                        }
                    } catch (error) {
                        this.emit("debug", {
                            action: "receiveRpcError",
                            error: error
                        });
                        for (const { reject: reject } of batch)// @TODO: augment the error with the payload
                        reject(error);
                    }
                })();
            }
        }, stallTime);
    }
    constructor(network, options){
        super(network, options);
        this.#nextId = 1;
        this.#options = Object.assign({}, $96fdd0b482b0a22c$var$defaultOptions, options || {});
        this.#payloads = [];
        this.#drainTimer = null;
        this.#network = null;
        this.#pendingDetectNetwork = null;
        {
            let resolve = null;
            const promise = new Promise((_resolve)=>{
                resolve = _resolve;
            });
            this.#notReady = {
                promise: promise,
                resolve: resolve
            };
        }
        const staticNetwork = this._getOption("staticNetwork");
        if (typeof staticNetwork === "boolean") {
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(!staticNetwork || network !== "any", "staticNetwork cannot be used on special network 'any'", "options", options);
            if (staticNetwork && network != null) this.#network = (0, $1546470158336c71$export$95be4ae94445245a).from(network);
        } else if (staticNetwork) {
            // Make sure any static network is compatbile with the provided netwrok
            (0, $def55b050f09c63c$export$c3d31707e5030f5e)(network == null || staticNetwork.matches(network), "staticNetwork MUST match network object", "options", options);
            this.#network = staticNetwork;
        }
    }
    /**
     *  Returns the value associated with the option %%key%%.
     *
     *  Sub-classes can use this to inquire about configuration options.
     */ _getOption(key) {
        return this.#options[key];
    }
    /**
     *  Gets the [[Network]] this provider has committed to. On each call, the network
     *  is detected, and if it has changed, the call will reject.
     */ get _network() {
        (0, $def55b050f09c63c$export$a7a9523472993e97)(this.#network, "network is not available yet", "NETWORK_ERROR");
        return this.#network;
    }
    /**
     *  Resolves to the non-normalized value by performing %%req%%.
     *
     *  Sub-classes may override this to modify behavior of actions,
     *  and should generally call ``super._perform`` as a fallback.
     */ async _perform(req) {
        // Legacy networks do not like the type field being passed along (which
        // is fair), so we delete type if it is 0 and a non-EIP-1559 network
        if (req.method === "call" || req.method === "estimateGas") {
            let tx = req.transaction;
            if (tx && tx.type != null && (0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(tx.type)) // If there are no EIP-1559 or newer properties, it might be pre-EIP-1559
            {
                if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                    const feeData = await this.getFeeData();
                    if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) // Network doesn't know about EIP-1559 (and hence type)
                    req = Object.assign({}, req, {
                        transaction: Object.assign({}, tx, {
                            type: undefined
                        })
                    });
                }
            }
        }
        const request = this.getRpcRequest(req);
        if (request != null) return await this.send(request.method, request.args);
        return super._perform(req);
    }
    /**
     *  Sub-classes may override this; it detects the *actual* network that
     *  we are **currently** connected to.
     *
     *  Keep in mind that [[send]] may only be used once [[ready]], otherwise the
     *  _send primitive must be used instead.
     */ async _detectNetwork() {
        const network = this._getOption("staticNetwork");
        if (network) {
            if (network === true) {
                if (this.#network) return this.#network;
            } else return network;
        }
        if (this.#pendingDetectNetwork) return await this.#pendingDetectNetwork;
        // If we are ready, use ``send``, which enabled requests to be batched
        if (this.ready) {
            this.#pendingDetectNetwork = (async ()=>{
                try {
                    const result = (0, $1546470158336c71$export$95be4ae94445245a).from((0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(await this.send("eth_chainId", [])));
                    this.#pendingDetectNetwork = null;
                    return result;
                } catch (error) {
                    this.#pendingDetectNetwork = null;
                    throw error;
                }
            })();
            return await this.#pendingDetectNetwork;
        }
        // We are not ready yet; use the primitive _send
        this.#pendingDetectNetwork = (async ()=>{
            const payload = {
                id: this.#nextId++,
                method: "eth_chainId",
                params: [],
                jsonrpc: "2.0"
            };
            this.emit("debug", {
                action: "sendRpcPayload",
                payload: payload
            });
            let result;
            try {
                result = (await this._send(payload))[0];
                this.#pendingDetectNetwork = null;
            } catch (error) {
                this.#pendingDetectNetwork = null;
                this.emit("debug", {
                    action: "receiveRpcError",
                    error: error
                });
                throw error;
            }
            this.emit("debug", {
                action: "receiveRpcResult",
                result: result
            });
            if ("result" in result) return (0, $1546470158336c71$export$95be4ae94445245a).from((0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(result.result));
            throw this.getRpcError(payload, result);
        })();
        return await this.#pendingDetectNetwork;
    }
    /**
     *  Sub-classes **MUST** call this. Until [[_start]] has been called, no calls
     *  will be passed to [[_send]] from [[send]]. If it is overridden, then
     *  ``super._start()`` **MUST** be called.
     *
     *  Calling it multiple times is safe and has no effect.
     */ _start() {
        if (this.#notReady == null || this.#notReady.resolve == null) return;
        this.#notReady.resolve();
        this.#notReady = null;
        (async ()=>{
            // Bootstrap the network
            while(this.#network == null && !this.destroyed)try {
                this.#network = await this._detectNetwork();
            } catch (error) {
                if (this.destroyed) break;
                console.log("JsonRpcProvider failed to detect network and cannot start up; retry in 1s (perhaps the URL is wrong or the node is not started)");
                this.emit("error", (0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("failed to bootstrap network detection", "NETWORK_ERROR", {
                    event: "initial-network-discovery",
                    info: {
                        error: error
                    }
                }));
                await $96fdd0b482b0a22c$var$stall(1000);
            }
            // Start dispatching requests
            this.#scheduleDrain();
        })();
    }
    /**
     *  Resolves once the [[_start]] has been called. This can be used in
     *  sub-classes to defer sending data until the connection has been
     *  established.
     */ async _waitUntilReady() {
        if (this.#notReady == null) return;
        return await this.#notReady.promise;
    }
    /**
     *  Return a Subscriber that will manage the %%sub%%.
     *
     *  Sub-classes may override this to modify the behavior of
     *  subscription management.
     */ _getSubscriber(sub) {
        // Pending Filters aren't availble via polling
        if (sub.type === "pending") return new (0, $f65cab7df08db94e$export$285511066b2a5499)(this);
        if (sub.type === "event") {
            if (this._getOption("polling")) return new (0, $02aebfef9941c580$export$bdb759dc2fe68c72)(this, sub.filter);
            return new (0, $f65cab7df08db94e$export$60f65cdabb3c5771)(this, sub.filter);
        }
        // Orphaned Logs are handled automatically, by the filter, since
        // logs with removed are emitted by it
        if (sub.type === "orphan" && sub.filter.orphan === "drop-log") return new (0, $b1c9b35e5c4247ce$export$f255b979f86248fa)("orphan");
        return super._getSubscriber(sub);
    }
    /**
     *  Returns true only if the [[_start]] has been called.
     */ get ready() {
        return this.#notReady == null;
    }
    /**
     *  Returns %%tx%% as a normalized JSON-RPC transaction request,
     *  which has all values hexlified and any numeric values converted
     *  to Quantity values.
     */ getRpcTransaction(tx) {
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        [
            "chainId",
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            let dstKey = key;
            if (key === "gasLimit") dstKey = "gas";
            result[dstKey] = (0, $7df480338fc2bc47$export$d9c067986dbc68dd)((0, $7df480338fc2bc47$export$61fe455e2b1e28a4)(tx[key], `tx.${key}`));
        });
        // Make sure addresses and data are lowercase
        [
            "from",
            "to",
            "data"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            result[key] = (0, $8de17c58ebd53b07$export$2b0d6b5fbe698c70)(tx[key]);
        });
        // Normalize the access list object
        if (tx.accessList) result["accessList"] = (0, $63484022a9ae8dfc$export$6c8662b1600dce2)(tx.accessList);
        if (tx.blobVersionedHashes) // @TODO: Remove this <any> case once EIP-4844 added to prepared tx
        result["blobVersionedHashes"] = tx.blobVersionedHashes.map((h)=>h.toLowerCase());
        if (tx.authorizationList) result["authorizationList"] = tx.authorizationList.map((_a)=>{
            const a = (0, $50e5ec83adfbb986$export$792a4c467f6fbc9f)(_a);
            return {
                address: a.address,
                nonce: (0, $7df480338fc2bc47$export$d9c067986dbc68dd)(a.nonce),
                chainId: (0, $7df480338fc2bc47$export$d9c067986dbc68dd)(a.chainId),
                yParity: (0, $7df480338fc2bc47$export$d9c067986dbc68dd)(a.signature.yParity),
                r: (0, $7df480338fc2bc47$export$d9c067986dbc68dd)(a.signature.r),
                s: (0, $7df480338fc2bc47$export$d9c067986dbc68dd)(a.signature.s)
            };
        });
        // @TODO: blobs should probably also be copied over, optionally
        // accounting for the kzg property to backfill blobVersionedHashes
        // using the commitment. Or should that be left as an exercise to
        // the caller?
        return result;
    }
    /**
     *  Returns the request method and arguments required to perform
     *  %%req%%.
     */ getRpcRequest(req) {
        switch(req.method){
            case "chainId":
                return {
                    method: "eth_chainId",
                    args: []
                };
            case "getBlockNumber":
                return {
                    method: "eth_blockNumber",
                    args: []
                };
            case "getGasPrice":
                return {
                    method: "eth_gasPrice",
                    args: []
                };
            case "getPriorityFee":
                return {
                    method: "eth_maxPriorityFeePerGas",
                    args: []
                };
            case "getBalance":
                return {
                    method: "eth_getBalance",
                    args: [
                        $96fdd0b482b0a22c$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getTransactionCount":
                return {
                    method: "eth_getTransactionCount",
                    args: [
                        $96fdd0b482b0a22c$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getCode":
                return {
                    method: "eth_getCode",
                    args: [
                        $96fdd0b482b0a22c$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getStorage":
                return {
                    method: "eth_getStorageAt",
                    args: [
                        $96fdd0b482b0a22c$var$getLowerCase(req.address),
                        "0x" + req.position.toString(16),
                        req.blockTag
                    ]
                };
            case "broadcastTransaction":
                return {
                    method: "eth_sendRawTransaction",
                    args: [
                        req.signedTransaction
                    ]
                };
            case "getBlock":
                if ("blockTag" in req) return {
                    method: "eth_getBlockByNumber",
                    args: [
                        req.blockTag,
                        !!req.includeTransactions
                    ]
                };
                else if ("blockHash" in req) return {
                    method: "eth_getBlockByHash",
                    args: [
                        req.blockHash,
                        !!req.includeTransactions
                    ]
                };
                break;
            case "getTransaction":
                return {
                    method: "eth_getTransactionByHash",
                    args: [
                        req.hash
                    ]
                };
            case "getTransactionReceipt":
                return {
                    method: "eth_getTransactionReceipt",
                    args: [
                        req.hash
                    ]
                };
            case "call":
                return {
                    method: "eth_call",
                    args: [
                        this.getRpcTransaction(req.transaction),
                        req.blockTag
                    ]
                };
            case "estimateGas":
                return {
                    method: "eth_estimateGas",
                    args: [
                        this.getRpcTransaction(req.transaction)
                    ]
                };
            case "getLogs":
                if (req.filter && req.filter.address != null) {
                    if (Array.isArray(req.filter.address)) req.filter.address = req.filter.address.map($96fdd0b482b0a22c$var$getLowerCase);
                    else req.filter.address = $96fdd0b482b0a22c$var$getLowerCase(req.filter.address);
                }
                return {
                    method: "eth_getLogs",
                    args: [
                        req.filter
                    ]
                };
        }
        return null;
    }
    /**
     *  Returns an ethers-style Error for the given JSON-RPC error
     *  %%payload%%, coalescing the various strings and error shapes
     *  that different nodes return, coercing them into a machine-readable
     *  standardized error.
     */ getRpcError(payload, _error) {
        const { method: method } = payload;
        const { error: error } = _error;
        if (method === "eth_estimateGas" && error.message) {
            const msg = error.message;
            if (!msg.match(/revert/i) && msg.match(/insufficient funds/i)) return (0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("insufficient funds", "INSUFFICIENT_FUNDS", {
                transaction: payload.params[0],
                info: {
                    payload: payload,
                    error: error
                }
            });
            else if (msg.match(/nonce/i) && msg.match(/too low/i)) return (0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("nonce has already been used", "NONCE_EXPIRED", {
                transaction: payload.params[0],
                info: {
                    payload: payload,
                    error: error
                }
            });
        }
        if (method === "eth_call" || method === "eth_estimateGas") {
            const result = $96fdd0b482b0a22c$var$spelunkData(error);
            const e = (0, $a3f016f760f1d6cc$export$fe041e1a83d3efc6).getBuiltinCallException(method === "eth_call" ? "call" : "estimateGas", payload.params[0], result ? result.data : null);
            e.info = {
                error: error,
                payload: payload
            };
            return e;
        }
        // Only estimateGas and call can return arbitrary contract-defined text, so now we
        // we can process text safely.
        const message = JSON.stringify($96fdd0b482b0a22c$var$spelunkMessage(error));
        if (typeof error.message === "string" && error.message.match(/user denied|ethers-user-denied/i)) {
            const actionMap = {
                eth_sign: "signMessage",
                personal_sign: "signMessage",
                eth_signTypedData_v4: "signTypedData",
                eth_signTransaction: "signTransaction",
                eth_sendTransaction: "sendTransaction",
                eth_requestAccounts: "requestAccess",
                wallet_requestAccounts: "requestAccess"
            };
            return (0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)(`user rejected action`, "ACTION_REJECTED", {
                action: actionMap[method] || "unknown",
                reason: "rejected",
                info: {
                    payload: payload,
                    error: error
                }
            });
        }
        if (method === "eth_sendRawTransaction" || method === "eth_sendTransaction") {
            const transaction = payload.params[0];
            if (message.match(/insufficient funds|base fee exceeds gas limit/i)) return (0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            if (message.match(/nonce/i) && message.match(/too low/i)) return (0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("nonce has already been used", "NONCE_EXPIRED", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            // "replacement transaction underpriced"
            if (message.match(/replacement transaction/i) && message.match(/underpriced/i)) return (0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("replacement fee too low", "REPLACEMENT_UNDERPRICED", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            if (message.match(/only replay-protected/i)) return (0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("legacy pre-eip-155 transactions not supported", "UNSUPPORTED_OPERATION", {
                operation: method,
                info: {
                    transaction: transaction,
                    info: {
                        error: error
                    }
                }
            });
        }
        let unsupported = !!message.match(/the method .* does not exist/i);
        if (!unsupported) {
            if (error && error.details && error.details.startsWith("Unauthorized method:")) unsupported = true;
        }
        if (unsupported) return (0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("unsupported operation", "UNSUPPORTED_OPERATION", {
            operation: payload.method,
            info: {
                error: error,
                payload: payload
            }
        });
        return (0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("could not coalesce error", "UNKNOWN_ERROR", {
            error: error,
            payload: payload
        });
    }
    /**
     *  Requests the %%method%% with %%params%% via the JSON-RPC protocol
     *  over the underlying channel. This can be used to call methods
     *  on the backend that do not have a high-level API within the Provider
     *  API.
     *
     *  This method queues requests according to the batch constraints
     *  in the options, assigns the request a unique ID.
     *
     *  **Do NOT override** this method in sub-classes; instead
     *  override [[_send]] or force the options values in the
     *  call to the constructor to modify this method's behavior.
     */ send(method, params) {
        // @TODO: cache chainId?? purge on switch_networks
        // We have been destroyed; no operations are supported anymore
        if (this.destroyed) return Promise.reject((0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
            operation: method
        }));
        const id = this.#nextId++;
        const promise = new Promise((resolve, reject)=>{
            this.#payloads.push({
                resolve: resolve,
                reject: reject,
                payload: {
                    method: method,
                    params: params,
                    id: id,
                    jsonrpc: "2.0"
                }
            });
        });
        // If there is not a pending drainTimer, set one
        this.#scheduleDrain();
        return promise;
    }
    /**
     *  Resolves to the [[Signer]] account for  %%address%% managed by
     *  the client.
     *
     *  If the %%address%% is a number, it is used as an index in the
     *  the accounts from [[listAccounts]].
     *
     *  This can only be used on clients which manage accounts (such as
     *  Geth with imported account or MetaMask).
     *
     *  Throws if the account doesn't exist.
     */ async getSigner(address) {
        if (address == null) address = 0;
        const accountsPromise = this.send("eth_accounts", []);
        // Account index
        if (typeof address === "number") {
            const accounts = await accountsPromise;
            if (address >= accounts.length) throw new Error("no such account");
            return new $96fdd0b482b0a22c$export$5f7b5fca3508545a(this, accounts[address]);
        }
        const { accounts: accounts } = await (0, $5c7e3a359d4744c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            accounts: accountsPromise
        });
        // Account address
        address = (0, $61268443a2d16d36$export$88411125f012957a)(address);
        for (const account of accounts){
            if ((0, $61268443a2d16d36$export$88411125f012957a)(account) === address) return new $96fdd0b482b0a22c$export$5f7b5fca3508545a(this, address);
        }
        throw new Error("invalid account");
    }
    async listAccounts() {
        const accounts = await this.send("eth_accounts", []);
        return accounts.map((a)=>new $96fdd0b482b0a22c$export$5f7b5fca3508545a(this, a));
    }
    destroy() {
        // Stop processing requests
        if (this.#drainTimer) {
            clearTimeout(this.#drainTimer);
            this.#drainTimer = null;
        }
        // Cancel all pending requests
        for (const { payload: payload, reject: reject } of this.#payloads)reject((0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
            operation: payload.method
        }));
        this.#payloads = [];
        // Parent clean-up
        super.destroy();
    }
}
class $96fdd0b482b0a22c$export$e16ffa1aa36d1432 extends $96fdd0b482b0a22c$export$5afe35a44ca7ff9a {
    #pollingInterval;
    constructor(network, options){
        super(network, options);
        let pollingInterval = this._getOption("pollingInterval");
        if (pollingInterval == null) pollingInterval = $96fdd0b482b0a22c$var$defaultOptions.pollingInterval;
        this.#pollingInterval = pollingInterval;
    }
    _getSubscriber(sub) {
        const subscriber = super._getSubscriber(sub);
        if ($96fdd0b482b0a22c$var$isPollable(subscriber)) subscriber.pollingInterval = this.#pollingInterval;
        return subscriber;
    }
    /**
     *  The polling interval (default: 4000 ms)
     */ get pollingInterval() {
        return this.#pollingInterval;
    }
    set pollingInterval(value) {
        if (!Number.isInteger(value) || value < 0) throw new Error("invalid interval");
        this.#pollingInterval = value;
        this._forEachSubscriber((sub)=>{
            if ($96fdd0b482b0a22c$var$isPollable(sub)) sub.pollingInterval = this.#pollingInterval;
        });
    }
}
class $96fdd0b482b0a22c$export$da28308012bf6748 extends $96fdd0b482b0a22c$export$e16ffa1aa36d1432 {
    #connect;
    constructor(url, network, options){
        if (url == null) url = "http://localhost:8545";
        super(network, options);
        if (typeof url === "string") this.#connect = new (0, $639ac0facbde31d2$export$319b96fe59834522)(url);
        else this.#connect = url.clone();
    }
    _getConnection() {
        return this.#connect.clone();
    }
    async send(method, params) {
        // All requests are over HTTP, so we can just start handling requests
        // We do this here rather than the constructor so that we don't send any
        // requests to the network (i.e. eth_chainId) until we absolutely have to.
        await this._start();
        return await super.send(method, params);
    }
    async _send(payload) {
        // Configure a POST connection for the requested method
        const request = this._getConnection();
        request.body = JSON.stringify(payload);
        request.setHeader("content-type", "application/json");
        const response = await request.send();
        response.assertOk();
        let resp = response.bodyJson;
        if (!Array.isArray(resp)) resp = [
            resp
        ];
        return resp;
    }
}
function $96fdd0b482b0a22c$var$spelunkData(value) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match(/revert/i) && (0, $8de17c58ebd53b07$export$b02a40aff8e4ad18)(value.data)) return {
        message: value.message,
        data: value.data
    };
    // Spelunk further...
    if (typeof value === "object") {
        for(const key in value){
            const result = $96fdd0b482b0a22c$var$spelunkData(value[key]);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $96fdd0b482b0a22c$var$spelunkData(JSON.parse(value));
    } catch (error) {}
    return null;
}
function $96fdd0b482b0a22c$var$_spelunkMessage(value, result) {
    if (value == null) return;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string") result.push(value.message);
    // Spelunk further...
    if (typeof value === "object") for(const key in value)$96fdd0b482b0a22c$var$_spelunkMessage(value[key], result);
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $96fdd0b482b0a22c$var$_spelunkMessage(JSON.parse(value), result);
    } catch (error) {}
}
function $96fdd0b482b0a22c$var$spelunkMessage(value) {
    const result = [];
    $96fdd0b482b0a22c$var$_spelunkMessage(value, result);
    return result;
}


class $d2a3fc8f78820a34$export$8d50d0931f78dec8 extends (0, $96fdd0b482b0a22c$export$e16ffa1aa36d1432) {
    #request;
    #providerInfo;
    /**
     *  Connect to the %%ethereum%% provider, optionally forcing the
     *  %%network%%.
     */ constructor(ethereum, network, _options){
        // Copy the options
        const options = Object.assign({}, _options != null ? _options : {}, {
            batchMaxCount: 1
        });
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(ethereum && ethereum.request, "invalid EIP-1193 provider", "ethereum", ethereum);
        super(network, options);
        this.#providerInfo = null;
        if (_options && _options.providerInfo) this.#providerInfo = _options.providerInfo;
        this.#request = async (method, params)=>{
            const payload = {
                method: method,
                params: params
            };
            this.emit("debug", {
                action: "sendEip1193Request",
                payload: payload
            });
            try {
                const result = await ethereum.request(payload);
                this.emit("debug", {
                    action: "receiveEip1193Result",
                    result: result
                });
                return result;
            } catch (e) {
                const error = new Error(e.message);
                error.code = e.code;
                error.data = e.data;
                error.payload = payload;
                this.emit("debug", {
                    action: "receiveEip1193Error",
                    error: error
                });
                throw error;
            }
        };
    }
    get providerInfo() {
        return this.#providerInfo;
    }
    async send(method, params) {
        await this._start();
        return await super.send(method, params);
    }
    async _send(payload) {
        (0, $def55b050f09c63c$export$c3d31707e5030f5e)(!Array.isArray(payload), "EIP-1193 does not support batch request", "payload", payload);
        try {
            const result = await this.#request(payload.method, payload.params || []);
            return [
                {
                    id: payload.id,
                    result: result
                }
            ];
        } catch (e) {
            return [
                {
                    id: payload.id,
                    error: {
                        code: e.code,
                        data: e.data,
                        message: e.message
                    }
                }
            ];
        }
    }
    getRpcError(payload, error) {
        error = JSON.parse(JSON.stringify(error));
        // EIP-1193 gives us some machine-readable error codes, so rewrite
        // them into Ethers standard errors.
        switch(error.error.code || -1){
            case 4001:
                error.error.message = `ethers-user-denied: ${error.error.message}`;
                break;
            case 4200:
                error.error.message = `ethers-unsupported: ${error.error.message}`;
                break;
        }
        return super.getRpcError(payload, error);
    }
    /**
     *  Resolves to ``true`` if the provider manages the %%address%%.
     */ async hasSigner(address) {
        if (address == null) address = 0;
        const accounts = await this.send("eth_accounts", []);
        if (typeof address === "number") return accounts.length > address;
        address = address.toLowerCase();
        return accounts.filter((a)=>a.toLowerCase() === address).length !== 0;
    }
    async getSigner(address) {
        if (address == null) address = 0;
        if (!await this.hasSigner(address)) try {
            await this.#request("eth_requestAccounts", []);
        } catch (error) {
            const payload = error.payload;
            throw this.getRpcError(payload, {
                id: payload.id,
                error: error
            });
        }
        return await super.getSigner(address);
    }
    /**
     *  Discover and connect to a Provider in the Browser using the
     *  [[link-eip-6963]] discovery mechanism. If no providers are
     *  present, ``null`` is resolved.
     */ static async discover(options) {
        if (options == null) options = {};
        if (options.provider) return new $d2a3fc8f78820a34$export$8d50d0931f78dec8(options.provider);
        const context = options.window ? options.window : typeof window !== "undefined" ? window : null;
        if (context == null) return null;
        const anyProvider = options.anyProvider;
        if (anyProvider && context.ethereum) return new $d2a3fc8f78820a34$export$8d50d0931f78dec8(context.ethereum);
        if (!("addEventListener" in context && "dispatchEvent" in context && "removeEventListener" in context)) return null;
        const timeout = options.timeout ? options.timeout : 300;
        if (timeout === 0) return null;
        return await new Promise((resolve, reject)=>{
            let found = [];
            const addProvider = (event)=>{
                found.push(event.detail);
                if (anyProvider) finalize();
            };
            const finalize = ()=>{
                clearTimeout(timer);
                if (found.length) {
                    // If filtering is provided:
                    if (options && options.filter) {
                        // Call filter, with a copies of found provider infos
                        const filtered = options.filter(found.map((i)=>Object.assign({}, i.info)));
                        if (filtered == null) // No provider selected
                        resolve(null);
                        else if (filtered instanceof $d2a3fc8f78820a34$export$8d50d0931f78dec8) // Custom provider created
                        resolve(filtered);
                        else {
                            // Find the matching provider
                            let match = null;
                            if (filtered.uuid) {
                                const matches = found.filter((f)=>filtered.uuid === f.info.uuid);
                                // @TODO: What should happen if multiple values
                                //        for the same UUID?
                                match = matches[0];
                            }
                            if (match) {
                                const { provider: provider, info: info } = match;
                                resolve(new $d2a3fc8f78820a34$export$8d50d0931f78dec8(provider, undefined, {
                                    providerInfo: info
                                }));
                            } else reject((0, $def55b050f09c63c$export$5a4bb2b1c89bdce7)("filter returned unknown info", "UNSUPPORTED_OPERATION", {
                                value: filtered
                            }));
                        }
                    } else {
                        // Pick the first found provider
                        const { provider: provider, info: info } = found[0];
                        resolve(new $d2a3fc8f78820a34$export$8d50d0931f78dec8(provider, undefined, {
                            providerInfo: info
                        }));
                    }
                } else // Nothing found
                resolve(null);
                context.removeEventListener("eip6963:announceProvider", addProvider);
            };
            const timer = setTimeout(()=>{
                finalize();
            }, timeout);
            context.addEventListener("eip6963:announceProvider", addProvider);
            context.dispatchEvent(new Event("eip6963:requestProvider"));
        });
    }
}




function $b43e66ea34ca86d3$var$EthereumProvider(props) {
    const { messageToSign: messageToSign, setSignature: setSignature, address: address, isLoading: isLoading } = props;
    const { walletProvider: walletProvider } = (0, $02b65957f7a9bfcc$export$7efbc9b78cd6e553)("eip155") // Namespace for EVM chains
    ;
    const handleSignEth = async ()=>{
        try {
            // Create an Ethers.js provider and signer from the AppKit walletProvider
            const provider = new (0, $d2a3fc8f78820a34$export$8d50d0931f78dec8)(walletProvider);
            const signer = new (0, $96fdd0b482b0a22c$export$5f7b5fca3508545a)(provider, address);
            const signature = await signer.signMessage(messageToSign);
            if (setSignature) setSignature(signature);
        } catch (error) {
            console.error("Error signing ETH message:", error);
        }
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
        fullWidth: true,
        type: "button",
        onClick: handleSignEth,
        disabled: isLoading,
        children: isLoading ? "Loading..." : "Sign ETH Message"
    });
}
// Default Props
$b43e66ea34ca86d3$var$EthereumProvider.defaultProps = {
    addressVerificationDetails: {}
};
// Proptypes Validation
$b43e66ea34ca86d3$var$EthereumProvider.propTypes = {
    addressVerificationDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $b43e66ea34ca86d3$export$2e2bcd8739ae039 = $b43e66ea34ca86d3$var$EthereumProvider;


var $f39a9a15348a9194$export$2e2bcd8739ae039 = (0, $b43e66ea34ca86d3$export$2e2bcd8739ae039);


/* eslint-disable max-len */ /* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $4zT52 = parcelRequire("4zT52");


function $14f649f67649f31f$var$SolanaProvider(props) {
    const { messageToSign: messageToSign, setSignature: setSignature, isLoading: isLoading } = props;
    const { walletProvider: walletProvider } = (0, $02b65957f7a9bfcc$export$7efbc9b78cd6e553)("solana") // Namespace for Solana
    ;
    const handleSignSol = async ()=>{
        try {
            // Solana's signMessage typically expects a Uint8Array
            const msg = String.raw`${messageToSign}`;
            const encodedMessage = new TextEncoder().encode(msg);
            const signature = await walletProvider.signMessage(encodedMessage);
            if (setSignature) setSignature((0, $4zT52.default).encode(signature));
        // console.log('SOL Signature (Hex):', Buffer.from(signature).toString('hex'))
        } catch (error) {
            console.error("Error signing SOL message:", error);
        }
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
        fullWidth: true,
        type: "button",
        onClick: handleSignSol,
        disabled: isLoading,
        children: isLoading ? "Loading..." : "Sign SOL Message"
    });
}
// Default Props
$14f649f67649f31f$var$SolanaProvider.defaultProps = {
    addressVerificationDetails: {}
};
// Proptypes Validation
$14f649f67649f31f$var$SolanaProvider.propTypes = {
    addressVerificationDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $14f649f67649f31f$export$2e2bcd8739ae039 = $14f649f67649f31f$var$SolanaProvider;


var $2d987d10cfdbdd35$export$2e2bcd8739ae039 = (0, $14f649f67649f31f$export$2e2bcd8739ae039);


/* eslint-disable no-confusing-arrow */ 
const $7fb1d8cb38abb0e0$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  max-width: 600px;
  width: 100%;
  margin-top: 20px;
  padding: 20px;
  gap: 20px;
  border-radius: 20px;
  background-color: ${({ theme: theme })=>`${theme.colors.white}`};
  border: 1px solid ${({ theme: theme })=>`${theme.colors.lightGray}`};
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.15);
`;
const $7fb1d8cb38abb0e0$export$3209f4408be71616 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: ${({ correctWallet: correctWallet })=>correctWallet ? "flex-start" : "center"};
  justify-content: ${({ correctWallet: correctWallet })=>correctWallet ? "flex-start" : "center"};
  padding: ${({ correctWallet: correctWallet })=>correctWallet ? "20px" : "120px 20px"};

  width: 100%;
  border-radius: 10px;
  border: 1px solid ${({ theme: theme })=>`${theme.colors.gray}60`};
`;
const $7fb1d8cb38abb0e0$export$2168ec08bb06a678 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  flex-direction: ${({ connected: connected })=>connected ? "column-reverse" : "column"};
  justify-content: ${({ connected: connected })=>connected ? "flex-start" : "center"};
  gap: ${({ connected: connected })=>connected ? "10px" : "20px"};

  position: relative;

  width: 100%;
`;
const $7fb1d8cb38abb0e0$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;

  width: 100%;
  @media (max-width: 600px) {
    flex-direction: column-reverse;
  }
`;
const $7fb1d8cb38abb0e0$export$f827d3c5a9c3f644 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 5px;
  /* background-color: ${({ theme: theme })=>theme.colors.lightGray}; */
  border: ${({ theme: theme })=>`1px solid ${theme.colors.gray}60`};
  ${({ connected: connected })=>connected ? `padding: 8px 15px;
      border-radius: 12px;
      cursor:pointer;` : `padding: 15px;
      border-radius: 20px;`}
  &:hover {
    ${({ connected: connected, theme: theme })=>connected && `background-color: ${theme.colors.blue}30; border: 1px solid ${theme.colors.blue};`}
  }
  transition: 0.5s;
`;
const $7fb1d8cb38abb0e0$export$7d3ec07ebe7469e5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14px;

  color: ${({ theme: theme })=>theme.colors.darkGray};

  transition: 0.5s;
  overflow: hidden;

  ${({ connected: connected })=>connected ? "width: auto; padding: 5px 10px;  position: relative;" : "width: 0; padding: 0; position: absolute;"}
`;
const $7fb1d8cb38abb0e0$export$d43ffeaaec0b2a58 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  transition: 0.5s;
`;
const $7fb1d8cb38abb0e0$export$9d2b4227a95687cc = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
const $7fb1d8cb38abb0e0$export$616d763e306cba45 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;
  padding: 15px;
  border-radius: 10px;
  background-color: ${({ theme: theme })=>theme.colors.lightGray};
  border: ${({ theme: theme })=>`1px solid ${theme.colors.gray}60`};
  margin: 20px 0;
`;
const $7fb1d8cb38abb0e0$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme, color: color })=>color ? theme.colors[color] : theme.colors.darkGray};
  font-size: 14px;
  text-align: center;
  margin: 0;

  transition: 0.5s;
`;
const $7fb1d8cb38abb0e0$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme, color: color })=>color ? theme.colors[color] : theme.colors.darkGray};
  font-size: 24px;
  font-weight: 700;
  text-align: center;

  margin: 0;

  transition: 0.5s;
`;



var $4L3zM = parcelRequire("4L3zM");
function $577d072af04529e4$var$AddressVerification(props) {
    const { addressVerificationDetails: addressVerificationDetails, cipherText: cipherText, setSuccessMsg: setSuccessMsg, setErrMsg: setErrMsg } = props;
    // Local State
    const [page, setPage] = (0, $tZqWC.useState)(1);
    const [message, setMessage] = (0, $tZqWC.useState)("");
    const [signature, setSignature] = (0, $tZqWC.useState)();
    const [pubkey, setPubkey] = (0, $tZqWC.useState)();
    // Hooks
    const { postAddressVerification: postAddressVerification, postAddressVerificationData: postAddressVerificationData, postAddressVerificationError: postAddressVerificationError, isPostAddressVerificationLoading: isPostAddressVerificationLoading } = (0, $6e46db22cfb8b835$export$2e2bcd8739ae039)();
    const { open: open } = (0, $02b65957f7a9bfcc$export$6c4cc75441b14b9)();
    const { address: address } = (0, $2b5a8e9ff96f5bfb$export$bc49ae41288a26c3)();
    const { disconnect: disconnect } = (0, $2b5a8e9ff96f5bfb$export$83bebf2fe7fead4e)();
    // Only allowing bitcoin accounts for pubkeys
    const { allAccounts: allAccounts } = (0, $2b5a8e9ff96f5bfb$export$bc49ae41288a26c3)({
        chainNamespace: "bip122"
    });
    // Variables
    const notConnected = !address;
    const connected = !!address;
    const correctWallet = address && addressVerificationDetails?.address?.toLowerCase() === address?.toLowerCase();
    const incorrectWallet = address && addressVerificationDetails?.address?.toLowerCase() !== address?.toLowerCase();
    // Functions
    const handleVerification = async ()=>{
        if (!signature) return setSignature();
        if (signature) postAddressVerification({
            signature: signature,
            cipher_text: cipherText,
            pubkey: pubkey || null
        });
    };
    const handleDisconnect = async ()=>{
        await disconnect();
    };
    const generateMessage = ()=>{
        const msg = $577d072af04529e4$var$generateMessageSolana(addressVerificationDetails?.name_business, addressVerificationDetails?.chain, addressVerificationDetails?.address, addressVerificationDetails?.nonce, addressVerificationDetails?.created);
        // `Ospree.io wants you to sign with your ${addressVerificationDetails?.chain} account: ${address}\n\nNonce: ${addressVerificationDetails?.nonce}\nIssued at: ${addressVerificationDetails?.created}`
        setMessage(msg);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (address && page !== 2) setPage(2);
        if (!address && page !== 1) setPage(1);
        if (address) generateMessage();
        if (!address) setMessage("");
    }, [
        address
    ]);
    (0, $tZqWC.useEffect)(()=>{
        handleVerification();
    }, [
        signature
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (postAddressVerificationData && !postAddressVerificationError) setSuccessMsg("Successfully validated ownership");
    }, [
        postAddressVerificationData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (postAddressVerificationError) setErrMsg("Ownership validation unsuccessful, invalid signature.");
    }, [
        postAddressVerificationError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        allAccounts.forEach((acc)=>{
            if (acc?.address?.toLowerCase() === address?.toLowerCase()) setPubkey(acc.publicKey);
        });
    }, [
        allAccounts
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7fb1d8cb38abb0e0$export$e6dfd72ab29f8598), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ef69c736ae57a14f$export$2e2bcd8739ae039), {
                pageNumber: page,
                setPageNumber: setPage,
                headers: [
                    {
                        label: "Connect your wallet"
                    },
                    {
                        label: "Verify ownership"
                    }
                ],
                style: {
                    marginTop: "10px"
                }
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7fb1d8cb38abb0e0$export$3209f4408be71616), {
                correctWallet: correctWallet,
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7fb1d8cb38abb0e0$export$2168ec08bb06a678), {
                    connected: connected,
                    children: [
                        addressVerificationDetails?.symbol && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7fb1d8cb38abb0e0$export$f827d3c5a9c3f644), {
                            connected: connected,
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7fb1d8cb38abb0e0$export$d43ffeaaec0b2a58), {
                                    connected: connected,
                                    children: /*#__PURE__*/ (0, $tZqWC.cloneElement)((0, $df4784c9100a83b7$export$73b53978386f314)[addressVerificationDetails?.symbol], {
                                        size: connected ? 30 : 70
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7fb1d8cb38abb0e0$export$7d3ec07ebe7469e5), {
                                    connected: connected,
                                    onClick: ()=>open({
                                            view: "Networks"
                                        }),
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6f961941b47e982$export$2e2bcd8739ae039), {
                                        text: address,
                                        sliceLength: 5
                                    })
                                })
                            ]
                        }),
                        correctWallet && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7fb1d8cb38abb0e0$export$616d763e306cba45), {
                            correctWallet: correctWallet,
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7fb1d8cb38abb0e0$export$5f1af8db9871e1d6), {
                                style: {
                                    textAlign: "start",
                                    whiteSpace: "pre-line",
                                    wordBreak: "break-all"
                                },
                                children: message && message
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7fb1d8cb38abb0e0$export$9d2b4227a95687cc), {
                            correctWallet: correctWallet,
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7fb1d8cb38abb0e0$export$f99233281efd08a0), {
                                    color: incorrectWallet ? "red" : "",
                                    correctWallet: correctWallet,
                                    children: [
                                        notConnected && "Connect wallet",
                                        correctWallet && "Verify ownership",
                                        incorrectWallet && "Incorrect wallet connected"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7fb1d8cb38abb0e0$export$5f1af8db9871e1d6), {
                                    children: [
                                        notConnected && `Connect your ${addressVerificationDetails?.chain || ""} wallet`,
                                        correctWallet && "Please sign the message below to verify ownership:",
                                        incorrectWallet && `Please connect the correct ${addressVerificationDetails?.chain || ""} wallet`
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7fb1d8cb38abb0e0$export$d53c836cccbb0d90), {
                children: [
                    notConnected && !isPostAddressVerificationLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        type: "button",
                        onClick: ()=>open({
                                view: "Connect"
                            }),
                        children: "Connect Wallet"
                    }),
                    address && !isPostAddressVerificationLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        type: "button",
                        onClick: handleDisconnect,
                        variant: "outlined",
                        children: "Disconnect Wallet"
                    }),
                    correctWallet && addressVerificationDetails?.chain === (0, $88198d6209a430d3$export$cf7a8da258ee7050).bitcoin && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d255aa67f4358f2f$export$2e2bcd8739ae039), {
                        messageToSign: message,
                        setSignature: setSignature,
                        address: address,
                        isLoading: isPostAddressVerificationLoading,
                        setErrMsg: setErrMsg
                    }),
                    correctWallet && addressVerificationDetails?.chain === (0, $88198d6209a430d3$export$cf7a8da258ee7050).ethereum && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f39a9a15348a9194$export$2e2bcd8739ae039), {
                        messageToSign: message,
                        setSignature: setSignature,
                        address: address,
                        isLoading: isPostAddressVerificationLoading
                    }),
                    correctWallet && addressVerificationDetails?.chain === (0, $88198d6209a430d3$export$cf7a8da258ee7050).solana && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2d987d10cfdbdd35$export$2e2bcd8739ae039), {
                        messageToSign: message,
                        setSignature: setSignature,
                        isLoading: isPostAddressVerificationLoading
                    })
                ]
            })
        ]
    });
}
function $577d072af04529e4$var$generateMessageSolana(business_name, chain, address, nonce, created) {
    return `${business_name || "Ospree.io"} wants you to sign with your ${chain} account: ${address}\n` + "\n" + `Nonce: ${nonce}\n` + `Issued at: ${created}`;
}
// Default Props
$577d072af04529e4$var$AddressVerification.defaultProps = {
    addressVerificationDetails: {}
};
// Proptypes Validation
$577d072af04529e4$var$AddressVerification.propTypes = {
    addressVerificationDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $577d072af04529e4$export$2e2bcd8739ae039 = $577d072af04529e4$var$AddressVerification;


var $777e667c1c9452b1$export$2e2bcd8739ae039 = (0, $577d072af04529e4$export$2e2bcd8739ae039);







/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $946d439180b5f98a$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "70",
        height: "18",
        viewBox: "0 0 70 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 6.41901C0 2.8721 2.96803 0 6.62969 0C10.289 0 13.2617 2.8721 13.2617 6.41901C13.2617 9.9648 10.2936 12.838 6.62969 12.838C2.96803 12.838 0 9.9648 0 6.41901ZM3.28143 7.77085C3.41508 8.07758 3.59022 8.362 3.80222 8.61742C4.46588 9.41827 5.48441 9.93134 6.62969 9.93134C8.6368 9.93134 10.2591 8.35531 10.2591 6.41901C10.2591 4.48271 8.6368 2.90668 6.62969 2.90668C4.63179 2.90668 3.0026 4.47713 3.0026 6.41901C3.0026 6.89751 3.10169 7.3537 3.28143 7.77085Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M18.859 4.87644C19.5411 5.18763 20.1195 5.49659 20.5919 5.80221C21.0389 6.0922 21.3915 6.37774 21.645 6.65882C21.9353 6.98897 22.1497 7.37489 22.281 7.80989C22.387 8.15566 22.44 8.53266 22.44 8.93754C22.44 10.0797 22.0091 11.0278 21.1611 11.7472C20.3177 12.461 19.2185 12.8269 17.905 12.8269C17.1422 12.8269 16.4048 12.6841 15.7043 12.3919C15.0084 12.1008 14.377 11.7182 13.8216 11.136L15.3909 8.69215L15.5453 8.81708C15.9878 9.17735 16.3933 9.43388 16.7643 9.5878C17.1307 9.74284 17.5271 9.83988 17.9442 9.86777C18.352 9.88003 18.67 9.8053 18.889 9.64581C19.0134 9.55434 19.101 9.44727 19.1517 9.32123C19.1862 9.23423 19.2024 9.13942 19.2024 9.03458C19.2024 8.78919 19.0848 8.56612 18.8475 8.34304C18.594 8.10881 18.0916 7.82327 17.3542 7.49201C16.9625 7.32693 16.6007 7.15516 16.2735 6.97893C15.8679 6.76032 15.5131 6.5339 15.2112 6.30078C15.1144 6.22605 15.0222 6.15132 14.937 6.07547C14.8517 6.00074 14.7733 5.9249 14.6996 5.84794C14.3263 5.46425 14.0705 5.02479 13.9369 4.53737C13.8608 4.26187 13.8216 3.97075 13.8216 3.66625C13.8216 3.29595 13.87 2.94795 13.9645 2.62337C14.1489 1.99207 14.513 1.44999 15.0545 1.00496C15.3149 0.79192 15.6006 0.612344 15.9117 0.466229C16.2735 0.295576 16.6698 0.172884 17.0962 0.0959227C17.4464 0.032346 17.8174 0 18.2115 0C19.207 0 20.3038 0.27996 21.4676 0.839881L21.6081 0.907919L20.1863 3.66068C19.7278 3.37514 19.3383 3.16991 19.0249 3.04387C18.723 2.92341 18.4396 2.86095 18.1815 2.86095C17.8497 2.86095 17.5847 2.9301 17.3957 3.0606C17.2206 3.18106 17.1376 3.34614 17.1376 3.56922C17.1376 3.72871 17.2552 3.90606 17.4902 4.10014C17.7621 4.31764 18.2161 4.57975 18.859 4.87644Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M29.9384 0C28.5858 0 27.3299 0.393729 26.2791 1.06742V0.405998H23.2834V18H26.2791V11.7695C27.3299 12.4432 28.5858 12.838 29.9384 12.838C33.6001 12.838 36.5681 9.9648 36.5681 6.41901C36.5681 2.8721 33.6001 0 29.9384 0ZM29.9384 9.93134C27.9313 9.93134 26.309 8.35531 26.309 6.41901C26.309 6.24167 26.3229 6.06767 26.3482 5.89813C26.3759 5.71632 26.4197 5.54009 26.475 5.36944C26.6547 4.81063 26.975 4.31206 27.3967 3.91275C27.6272 3.69414 27.8875 3.50564 28.1687 3.35283C28.4475 3.20114 28.7517 3.08403 29.0697 3.00818C29.3485 2.94126 29.6389 2.90668 29.9384 2.90668C31.9432 2.90668 33.5655 4.48271 33.5655 6.41901C33.5655 6.89416 33.4664 7.34812 33.2913 7.76193C33.2452 7.869 33.1945 7.97385 33.1369 8.07535C33.054 8.22258 32.9618 8.36423 32.8604 8.49808C32.2013 9.36696 31.139 9.93134 29.9384 9.93134Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M37.4069 6.40786C37.4069 2.86095 40.375 0 44.0366 0C44.4214 0 44.7994 0.0345768 45.1588 0.0914612L44.38 2.91783C44.2624 2.90668 44.1495 2.9011 44.032 2.9011C42.0249 2.9011 40.4026 4.46598 40.4026 6.40786V12.838H37.4069V6.40786Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M53.5721 9.02342C52.9292 9.5878 52.0789 9.93134 51.141 9.93134C49.6731 9.93134 48.4057 9.08588 47.8388 7.869H56.9088C57.5886 10.7132 60.2225 12.838 63.368 12.838C65.0802 12.838 66.6379 12.2101 67.8108 11.1817L65.7991 9.02342C65.1562 9.5878 64.3059 9.93134 63.368 9.93134C62.7297 9.93134 62.1283 9.77073 61.6052 9.48965C60.9277 9.12492 60.3861 8.55608 60.0658 7.869H69.8295C69.9401 7.40166 70 6.91536 70 6.41901C70 2.8721 67.032 0 63.368 0C60.6189 0 58.2592 1.61953 57.2545 3.92837C56.2498 1.61953 53.8924 0 51.141 0C47.4793 0 44.5113 2.8721 44.5113 6.41901C44.5113 9.95923 47.4793 12.838 51.141 12.838C52.8531 12.838 54.4109 12.2101 55.5838 11.1817L53.5721 9.02342ZM51.141 2.9011C52.6112 2.9011 53.8786 3.74656 54.4455 4.96233H47.8319C48.4103 3.74656 49.6731 2.9011 51.141 2.9011ZM66.6725 4.96233C66.1056 3.74656 64.8382 2.9011 63.368 2.9011C61.9001 2.9011 60.6373 3.74656 60.0589 4.96233H66.6725Z",
                fill: "white"
            })
        ]
    });
}





const $0a195a5213d307b7$export$3209f4408be71616 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-height: 100vh;
  background: ${({ theme: theme })=>theme.colors.blue};
  background: ${({ theme: theme })=>`linear-gradient(25deg, ${theme.colors.lightGray} 65%, ${theme.colors.blue} 130%)`};
`;
const $0a195a5213d307b7$export$e682cc3b1dd75921 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $0a195a5213d307b7$export$43a792a870d28db2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px;
`;
const $0a195a5213d307b7$export$c2954573b14fb846 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 20px;
`;
const $0a195a5213d307b7$export$879c290e457db5eb = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 0px;
  margin-top: 50px;

  & svg {
    width: 100px;
    height: 50px;
    & path {
      fill: ${({ theme: theme })=>theme.colors.darkGray};
    }
  }
`;
const $0a195a5213d307b7$export$bd984c2e806fe80e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  margin: 0 0 5px 0;
`;
const $0a195a5213d307b7$export$8cc88129864aced2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.darkGray};
  margin: 0;
`;
const $0a195a5213d307b7$export$fa9c19edbcff9892 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 100vh;
`;
const $0a195a5213d307b7$export$fbd505524e0a1da = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  align-self: center;

  //TODO: Style Variable
  color: ${({ theme: theme })=>theme.colors.white};
`;
const $0a195a5213d307b7$export$fdd773f48aebb8ab = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: block;
  margin: 20px 0px 0px 0px;
  width: 100%;

  font-weight: 400;
  font-size: 12px;
  text-decoration: underline;
  text-align: center;

  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $0a195a5213d307b7$export$af661ccd4dd193f2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 40px;
  border-radius: 15px;
  background: ${({ theme: theme })=>`${theme.colors.green}30`};
  border: 2px solid ${({ theme: theme })=>`${theme.colors.green}`};
`;
const $0a195a5213d307b7$export$c49782daadc7e415 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 40px;
  border-radius: 15px;
  background: ${({ theme: theme })=>`${theme.colors.red}30`};
  border: 2px solid ${({ theme: theme })=>`${theme.colors.red}`};
`;


function $e943b775b7b35382$var$AddressVerification() {
    // Local State
    const [addressVerificationDetails, setAddressVerificationDetails] = (0, $tZqWC.useState)();
    const [successMsg, setSuccessMsg] = (0, $tZqWC.useState)();
    const [errMsg, setErrMsg] = (0, $tZqWC.useState)();
    // Hooks
    const { cipher_text: cipher_text } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    const { getAddressVerification: getAddressVerification, getAddressVerificationData: getAddressVerificationData, getAddressVerificationError: getAddressVerificationError, isGetAddressVerificationLoading: isGetAddressVerificationLoading } = (0, $9a07e0c7f683589b$export$2e2bcd8739ae039)();
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        getAddressVerification({
            cipher_text: cipher_text
        });
    }, []);
    (0, $tZqWC.useEffect)(()=>{
        if (getAddressVerificationData) setAddressVerificationDetails(getAddressVerificationData);
    }, [
        getAddressVerificationData
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0a195a5213d307b7$export$3209f4408be71616), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0a195a5213d307b7$export$e682cc3b1dd75921), {
            children: [
                isGetAddressVerificationLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0a195a5213d307b7$export$43a792a870d28db2), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6fa6c8d0625529f$export$2e2bcd8739ae039), {})
                }),
                successMsg && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0a195a5213d307b7$export$c2954573b14fb846), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0a195a5213d307b7$export$af661ccd4dd193f2), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0a195a5213d307b7$export$bd984c2e806fe80e), {
                                    children: "Successfully validated wallet!"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0a195a5213d307b7$export$8cc88129864aced2), {
                                    children: "Successfully validated the ownership of the wallet. You may now close this window."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0a195a5213d307b7$export$879c290e457db5eb), {
                            target: "_blank",
                            href: "https://www.ospree.io/",
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0a195a5213d307b7$export$8cc88129864aced2), {
                                    children: "Powered by:"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $946d439180b5f98a$export$2e2bcd8739ae039), {})
                            ]
                        })
                    ]
                }),
                errMsg && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0a195a5213d307b7$export$c2954573b14fb846), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0a195a5213d307b7$export$c49782daadc7e415), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0a195a5213d307b7$export$bd984c2e806fe80e), {
                                    children: "Invalid signature"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0a195a5213d307b7$export$8cc88129864aced2), {
                                    children: errMsg
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0a195a5213d307b7$export$879c290e457db5eb), {
                            target: "_blank",
                            href: "https://www.ospree.io/",
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0a195a5213d307b7$export$8cc88129864aced2), {
                                    children: "Powered by:"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $946d439180b5f98a$export$2e2bcd8739ae039), {})
                            ]
                        })
                    ]
                }),
                !isGetAddressVerificationLoading && addressVerificationDetails && !successMsg && !errMsg && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0a195a5213d307b7$export$c2954573b14fb846), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0a195a5213d307b7$export$bd984c2e806fe80e), {
                            children: "Wallet Ownership Verification"
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0a195a5213d307b7$export$8cc88129864aced2), {
                            children: "To comply with FATF Travel Rule Requirements, we need to verify that you own the destination wallet."
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $777e667c1c9452b1$export$2e2bcd8739ae039), {
                            addressVerificationDetails: addressVerificationDetails,
                            cipherText: cipher_text,
                            setSuccessMsg: setSuccessMsg,
                            setErrMsg: setErrMsg
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0a195a5213d307b7$export$879c290e457db5eb), {
                            target: "_blank",
                            href: "https://www.ospree.io/",
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0a195a5213d307b7$export$8cc88129864aced2), {
                                    children: "Powered by:"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $946d439180b5f98a$export$2e2bcd8739ae039), {})
                            ]
                        })
                    ]
                }),
                !isGetAddressVerificationLoading && getAddressVerificationError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0a195a5213d307b7$export$c2954573b14fb846), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0a195a5213d307b7$export$8cc88129864aced2), {
                        children: "Link has expired or is invalid"
                    })
                })
            ]
        })
    });
}
// Default Props
$e943b775b7b35382$var$AddressVerification.defaultProps = {};
// Proptypes Validation
$e943b775b7b35382$var$AddressVerification.propTypes = {};
var $e943b775b7b35382$export$2e2bcd8739ae039 = $e943b775b7b35382$var$AddressVerification;


var $0cbdd1b634e62616$export$2e2bcd8739ae039 = (0, $e943b775b7b35382$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $2625e1de6b16ee3f$exports = {};
$2625e1de6b16ee3f$exports = new URL("ospreeBlackLarge.bd870433.png", import.meta.url).toString();



const $7286a4f30ed6f8f7$export$c59ec66ce0f5a28f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme: theme })=>theme.colors.lightGray};
`;
const $7286a4f30ed6f8f7$export$47b6a1ddefa0a04 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.blue};
  font-size: 24px;
  font-weight: 600;
`;
const $7286a4f30ed6f8f7$export$f6e751b25abbfdbb = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.darkGray};
`;
const $7286a4f30ed6f8f7$export$73cc7b3e8ae70e11 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
`;
const $7286a4f30ed6f8f7$export$14da99dbf3cc1278 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 35px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;

  border: 1px solid ${({ theme: theme })=>theme.colors.lightGray};
  border-radius: 10px;
  background-color: ${({ theme: theme })=>theme.colors.white};
`;



function $721e18df88e49b9c$var$NotFound() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7286a4f30ed6f8f7$export$c59ec66ce0f5a28f), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7286a4f30ed6f8f7$export$14da99dbf3cc1278), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d), {
                    to: "/",
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7286a4f30ed6f8f7$export$73cc7b3e8ae70e11), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $65f0d7ff3fd922b2$export$2e2bcd8739ae039), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($2625e1de6b16ee3f$exports))),
                            width: 100
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7286a4f30ed6f8f7$export$f6e751b25abbfdbb), {
                    children: "Error 404: The destination you are trying to access does not exist."
                })
            ]
        })
    });
}
// Default Props
$721e18df88e49b9c$var$NotFound.defaultProps = {};
// Proptypes Validation
$721e18df88e49b9c$var$NotFound.propTypes = {};
var $721e18df88e49b9c$export$2e2bcd8739ae039 = $721e18df88e49b9c$var$NotFound;


var $d549f3728d941dad$export$2e2bcd8739ae039 = (0, $721e18df88e49b9c$export$2e2bcd8739ae039);




var $5dc37f8d3265b047$export$2e2bcd8739ae039 = [
    // AddressVerification
    {
        isRouteAdmin: false,
        isRoutePublic: true,
        isRouteProtected: false,
        exact: true,
        routing: {
            component: (0, $0cbdd1b634e62616$export$2e2bcd8739ae039),
            path: "/address/verification/:cipher_text"
        }
    },
    {
        isRouteAdmin: false,
        isRoutePublic: false,
        isRouteProtected: false,
        exact: false,
        routing: {
            component: (0, $d549f3728d941dad$export$2e2bcd8739ae039)
        }
    }
];



parcelRequire("tZqWC");
function $f3c4337929d008f6$var$Global() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8bbd0dc1ab5297af$exports.Fragment), {});
}
var $f3c4337929d008f6$export$2e2bcd8739ae039 = $f3c4337929d008f6$var$Global;


var $d3ab8a2f01720862$export$2e2bcd8739ae039 = (0, $f3c4337929d008f6$export$2e2bcd8739ae039);


function $8754910489049feb$var$Routing() {
    /**
   * Conditionally selects route/component to render based on authentication or authorization
   * @param  {} isRouteProtected
   * @param  {} routeRoleAccess
   * @param  {} component
   */ const renderRouteComponent = ({ component: component })=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(component),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d3ab8a2f01720862$export$2e2bcd8739ae039), {})
            ]
        });
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12b33660068e86aa$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a0d5c3f2fe524011$export$b5d5cf8927ab7262), {
            children: (0, $5dc37f8d3265b047$export$2e2bcd8739ae039).map(({ isRoutePublic: isRoutePublic, isRouteProtected: isRouteProtected, isRouteAdmin: isRouteAdmin, exact: exact, roleAccess: roleAccess, routing: { path: path, component: component } })=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a0d5c3f2fe524011$export$e7b0ac011bb776c6), {
                    exact: exact,
                    path: path,
                    render: ()=>renderRouteComponent({
                            isRoutePublic: isRoutePublic,
                            isRouteProtected: isRouteProtected,
                            isRouteAdmin: isRouteAdmin,
                            roleAccess: roleAccess,
                            component: component,
                            path: path
                        })
                }, (0, $5d7f1dba4fbacab8$export$2e2bcd8739ae039)()))
        })
    });
}
var $8754910489049feb$export$2e2bcd8739ae039 = $8754910489049feb$var$Routing;


/* eslint-disable max-len */ 
const $7c436507295fbb9c$var$GlobalStyle = (0, $a778141486c79bc3$export$f0f03736edb61697)`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-weight: 400;
    font-family: 'OpenSans', sans-serif;
    -webkit-font-smoothing: antialiased;
  }

  a {
    color: inherit;
    text-decoration: none;
    font-weight: inherit;
    
    &:hover, &:focus{
      text-decoration: none;
      color: inherit;
    }
  }

  ul {
    list-style: none;
    padding: 0px;
    margin: 0px;
  }

  button {
    &:focus {
      outline: none;
    }
  }

  button, input, optgroup, select, textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: '';
    box-shadow: none;

    &::-ms-expand {
      display: none;
    }

    &:focus {
      outline: none;
    }
  }

  label {
    margin-bottom: 5px;
  }
  
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-button {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: #787878;
    border: 0px none #ffffff;
    border-radius: 100px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #8f8f8f;
  }
  ::-webkit-scrollbar-thumb:active {
    background: #787878;
  }
  ::-webkit-scrollbar-track {
    background: #e3e3e3;
    border: 0px none #ffffff;
    border-radius: 100px;
  }
  ::-webkit-scrollbar-track:hover {
    background: #e3e3e3;
  }
  ::-webkit-scrollbar-track:active {
    background: #e3e3e3;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }

  w3m-legal-footer  {
    display: none !important;
  }

  div.w3m-router-container {
    display: none !important;
  }
`;
var $7c436507295fbb9c$export$2e2bcd8739ae039 = $7c436507295fbb9c$var$GlobalStyle;


function $f23f4452d96899d0$var$App() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ea5d2799a316b2c2$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6829791a091ca67a$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d7ddad68135e136$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $114cb5fd5cac8cce$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8f386341ec2e7333$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8754910489049feb$export$2e2bcd8739ae039), {})
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7c436507295fbb9c$export$2e2bcd8739ae039), {})
        ]
    });
}
var $f23f4452d96899d0$export$2e2bcd8739ae039 = $f23f4452d96899d0$var$App;





(0, (/*@__PURE__*/$parcel$interopDefault($f419cfc3d92fe631$exports))).render(/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f23f4452d96899d0$export$2e2bcd8739ae039), {}), document.getElementById("root"));


//# sourceMappingURL=index.7fccc161.js.map
